/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(209);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(793);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1936);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1488);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1522);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(139);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1524);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContentWrapper = function (_Component) {
	    _inherits(ContentWrapper, _Component);
	
	    function ContentWrapper() {
	        _classCallCheck(this, ContentWrapper);
	
	        return _possibleConstructorReturn(this, (ContentWrapper.__proto__ || Object.getPrototypeOf(ContentWrapper)).apply(this, arguments));
	    }
	
	    _createClass(ContentWrapper, [{
	        key: "render",
	        value: function render() {
	
	            var childElement = this.props.children;
	
	            // unwrapped pages
	            if (this.props.unwrap) {
	                childElement = _react2.default.createElement(
	                    "div",
	                    { className: "unwrap" },
	                    this.props.children
	                );
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: "content-wrapper" },
	                childElement
	            );
	        }
	    }]);
	
	    return ContentWrapper;
	}(_react.Component);
	
	var _default = ContentWrapper;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(ContentWrapper, "ContentWrapper", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/ContentWrapper.jsx");
	
	    __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/ContentWrapper.jsx");
	}();

	;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var company = 'wecom';
	var generateBase = function generateBase() {
	  var url = window.location.host;
	  var base = url.substring(0, url.indexOf('-'));
	  return base;
	};
	var generateRootUrl = function generateRootUrl() {
	  var base = generateBase();
	  if (!base) return 'https://' + company + '-scm.truckxi.com/api/';
	  if (base === 'local') return 'http://localhost:8001/';
	  return 'https://' + base + '-scm.truckxi.com/api/';
	};
	var ROOT_URL = generateRootUrl();
	// let ROOT_URL = 'https://admin.apoodr.com/api/';
	// let ROOT_URL = 'http://localhost:8001/';
	// falcon: https://scm.realtoreasier.com/
	// let ROOT_URL = 'https://scm.gvyummyus.com/api/';
	// let ROOT_URL = 'https://erp.chinatown-supermarket.com/api/';
	// let ROOT_URL = 'https://hfstage-erp.truckxi.com/api/';
	var VERSION_NUM = '20018';
	
	var companyCode = localStorage.getItem('companyCode');
	var ROOT_API_URL = '';
	if (companyCode === 'PS') {
	  ROOT_API_URL = 'https://premiumstella-scm.truckxi.com/api/';
	} else if (companyCode === 'LAC') {
	  // isCalco
	  ROOT_API_URL = 'https://calco-scm.truckxi.com/api/';
	} else if (companyCode === 'CW') {
	  ROOT_API_URL = 'https://chunwei-scm.truckxi.com/api/';
	} else if (companyCode === 'CT') {
	  // isEcity
	  ROOT_API_URL = 'https://ct-scm.truckxi.com/api/';
	} else if (companyCode === 'MM') {
	  // isMyuMyu
	  ROOT_API_URL = 'https://myumyu-scm.truckxi.com/api/';
	} else if (companyCode === 'JML') {
	  // isJML
	  ROOT_API_URL = 'https://jml-scm.truckxi.com/api/';
	} else if (companyCode === 'HMM') {
	  // isHMM
	  ROOT_API_URL = 'https://hmm-scm.truckxi.com/api/';
	} else if (companyCode === 'DHC') {
	  // isDHC
	  ROOT_API_URL = 'https://dhc-scm.truckxi.com/api/';
	} else if (companyCode === 'AFG') {
	  // isAFG
	  ROOT_API_URL = 'https://afg-scm.truckxi.com/api/';
	} else if (companyCode === 'RVR') {
	  // isRivera
	  ROOT_API_URL = 'https://rivera-scm.truckxi.com/api/';
	} else if (companyCode === 'YB') {
	  // isYibao
	  ROOT_API_URL = 'https://yipao-scm.truckxi.com/api/';
	} else if (companyCode === 'LK') {
	  // isLucky
	  ROOT_API_URL = 'https://lucky-scm.truckxi.com/api/';
	} else if (companyCode === 'WE') {
	  // isWecom
	  ROOT_API_URL = 'https://wecom-scm.truckxi.com/api/';
	} else if (companyCode === 'KH') {
	  // isKouhigh
	  ROOT_API_URL = 'https://afg-scm.truckxi.com/api/';
	} else if (companyCode === 'FV') {
	  // isFung
	  ROOT_API_URL = 'https://fung-scm.truckxi.com/api/';
	} else if (companyCode === 'CO') {
	  // isCO
	  ROOT_API_URL = 'https://co-scm.truckxi.com/api/';
	} else if (companyCode === 'MMD') {
	  // isMMD
	  ROOT_API_URL = 'https://mmdavis-scm.truckxi.com/api/';
	} else if (companyCode === 'SY') {
	  // isSY
	  ROOT_API_URL = 'https://admin.apoodr.com/api/';
	} else if (companyCode === 'GV') {
	  // isGV
	  ROOT_API_URL = 'https://gvyummy-scm.truckxi.com/api/';
	} else if (companyCode === 'FN') {
	  // isFN
	  ROOT_API_URL = 'https://falcon-scm.truckxi.com/api/';
	} else if (companyCode === 'PTS') {
	  // isPTS
	  ROOT_API_URL = 'https://phantoscope-scm.truckxi.com/api/';
	} else if (companyCode === 'AFM') {
	  // isAFM
	  ROOT_API_URL = 'https://afm-scm.truckxi.com/api/';
	} else if (companyCode === 'AN') {
	  // isAN
	  ROOT_API_URL = 'https://asian-scm.truckxi.com/api/';
	} else if (companyCode === 'ABC') {
	  // isABC
	  ROOT_API_URL = 'https://abc-scm.truckxi.com/api/';
	} else if (companyCode === 'TN') {
	  // isTN
	  ROOT_API_URL = 'https://tn-scm.truckxi.com/api/';
	} else if (companyCode === 'PD') {
	  // isPD
	  ROOT_API_URL = 'https://uspride-scm.truckxi.com/api/';
	} else if (companyCode === 'FC') {
	  // isFC
	  ROOT_API_URL = 'https://fit-scm.truckxi.com/api/';
	} else if (companyCode === 'JTB') {
	  // isJTB
	  ROOT_API_URL = 'https://jtb-scm.truckxi.com/api/';
	} else if (companyCode === 'IN') {
	  // isIN
	  ROOT_API_URL = 'https://inutra-scm.truckxi.com/api/';
	} else if (companyCode === 'CNT') {
	  // isCNT
	  ROOT_API_URL = 'https://erp.chinatown-supermarket.com/api/';
	} else if (companyCode === 'WIZ') {
	  // isWIZ
	  ROOT_API_URL = 'https://wiz-scm.truckxi.com/api/';
	} else if (companyCode === 'DSQ') {
	  // isDSQ
	  ROOT_API_URL = 'https://dsq-scm.truckxi.com/api/';
	} else if (companyCode === 'FJ') {
	  // isFJ
	  ROOT_API_URL = 'https://fj-scm.truckxi.com/api/';
	} else if (companyCode === 'HF') {
	  // isHF
	  ROOT_API_URL = 'https://hfstage-erp.truckxi.com/api/';
	} else if (companyCode === 'NBT') {
	  // isNBT
	  ROOT_API_URL = 'https://nbtstage-scm.truckxi.com/api/';
	} else if (companyCode === 'LO') {
	  // isLO
	  ROOT_API_URL = 'https://lonni-scm.truckxi.com/api/';
	} else if (companyCode === 'EG') {
	  // isEG
	  ROOT_API_URL = 'https://elegant-scm.truckxi.com/api/';
	} else if (companyCode === 'CS') {
	  // isCS
	  ROOT_API_URL = 'https://coastsequoia-scm.truckxi.com/api/';
	} else if (companyCode === 'MAG') {
	  // isMAG
	  ROOT_API_URL = 'https://magna-scm.truckxi.com/api/';
	} else if (companyCode === 'TQ') {
	  // isTQ
	  ROOT_API_URL = 'https://topquality-scm.truckxi.com/api/';
	} else if (companyCode === 'FACEX') {
	  ROOT_API_URL = 'https://facex-scm.truckxi.com/api/';
	} else if (companyCode === 'OCM') {
	  // isOCM
	  ROOT_API_URL = 'https://ocm-scm.truckxi.com/api/';
	} else if (companyCode === 'ATL') {
	  // isATL
	  ROOT_API_URL = 'https://alton-scm.truckxi.com/api/';
	} else if (companyCode === 'FBD') {
	  // isFBD
	  ROOT_API_URL = 'https://fbd-scm.truckxi.com/api/';
	} else if (companyCode === 'ABCFF') {
	  // isABCFF
	  ROOT_API_URL = 'https://abcff-scm.truckxi.com/api/';
	} else if (companyCode === 'SW') {
	  // isSW
	  ROOT_API_URL = 'https://snapwise-scm.truckxi.com/api/';
	} else if (companyCode === 'EZ') {
	  // isEZ
	  ROOT_API_URL = 'https://ezone-scm.truckxi.com/api/';
	} else if (companyCode === 'YI') {
	  // isYI
	  ROOT_API_URL = 'https://ying-scm.truckxi.com/api/';
	} else if (companyCode === 'RS') {
	  // isRS
	  ROOT_API_URL = 'https://redstone-scm.truckxi.com/api/';
	} else if (companyCode === 'ASAP') {
	  // isASAP
	  ROOT_API_URL = 'https://asap-scm.truckxi.com/api/';
	} else if (companyCode === 'VIT') {
	  // isVIT
	  ROOT_API_URL = 'https://vitcell-scm.truckxi.com/api/';
	} else if (companyCode === 'KDW') {
	  // isKDW
	  ROOT_API_URL = 'https://kdw-scm.truckxi.com/api/';
	} else if (companyCode === 'NO') {
	  // isNO
	  ROOT_API_URL = 'https://no-scm.truckxi.com/api/';
	} else if (companyCode === 'WUFS') {
	  // isWUFS
	  ROOT_API_URL = 'https://wufs-scm.truckxi.com/api/';
	} else if (companyCode === 'KM') {
	  // isKM
	  ROOT_API_URL = 'https://kingmax-scm.truckxi.com/api/';
	} else if (companyCode === 'GS') {
	  // isGS
	  ROOT_API_URL = 'https://grantstone-scm.truckxi.com/api/';
	} else {
	  ROOT_API_URL = ROOT_URL;
	}
	
	console.log('ROOT_API_URL', ROOT_API_URL);
	var companyCodeTitle = companyCode ? companyCode + ' Truckxi-SCM' : 'Truckxi-SCM';
	if (ROOT_URL === 'https://scm.gvyummyus.com/api/') {
	  companyCodeTitle = companyCode + ' SCM';
	}
	
	var checkCompany = function checkCompany() {
	  var companies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var companyCode = arguments[1];
	
	  return companies.indexOf(company) >= 0;
	};
	
	var isRivera = exports.isRivera = checkCompany(['rivera', 'riverastage', 'rvrstage']);
	var isSY = exports.isSY = checkCompany(['sunny', 'apoodr']);
	var isFV = exports.isFV = checkCompany(['fung']);
	var isLO = exports.isLO = checkCompany(['lonni']);
	var isElegant = exports.isElegant = checkCompany(['elegant']);
	var isSnapwise = exports.isSnapwise = checkCompany(['snapwise']);
	var isWUFS = exports.isWUFS = checkCompany(['wufs']);
	var isEcity = exports.isEcity = checkCompany(['ct']);
	var isLucky88 = exports.isLucky88 = checkCompany(['lucky88']);
	var isUSPride = exports.isUSPride = checkCompany(['uspride']);
	var isCNT = exports.isCNT = checkCompany(['cnt']);
	var isCalco = exports.isCalco = checkCompany(['calco']);
	var isJML = exports.isJML = checkCompany(['jml']);
	
	//export const isTN = checkCompany(['tn', 'tnstage']);
	//export const isFBD = checkCompany(['fbd']);
	/*
	  These ROOT URLS were found on the url.jsx page.
	  In case they're important later, I'll be leaving them here for safekeeping
	
	  let ROOT_URL = "http://54.175.18.0/";
	  let ROOT_URL = "http://oauth2.truckxi.com/";
	  let ROOT_URL = "http://34.201.89.104/api/";
	  let ROOT_URL = 'https://stage-scm.truckxi.com/api/'';
	  let ROOT_URL = 'http://54.175.18.0/'';
	  let ROOT_URL = 'http://192.168.0.13:8001/'';
	*/
	
	exports.VERSION_NUM = VERSION_NUM;
	exports.ROOT_URL = ROOT_URL;
	exports.ROOT_API_URL = ROOT_API_URL;
	exports.companyCodeTitle = companyCodeTitle;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isRivera, 'isRivera', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/root_url.jsx');
	
	  __REACT_HOT_LOADER__.register(isSY, 'isSY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/root_url.jsx');
	
	  __REACT_HOT_LOADER__.register(isFV, 'isFV', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/root_url.jsx');
	
	  __REACT_HOT_LOADER__.register(isLO, 'isLO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/root_url.jsx');
	
	  __REACT_HOT_LOADER__.register(isElegant, 'isElegant', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/root_url.jsx');
	
	  __REACT_HOT_LOADER__.register(isSnapwise, 'isSnapwise', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/root_url.jsx');
	
	  __REACT_HOT_LOADER__.register(isWUFS, 'isWUFS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/root_url.jsx');
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/root_url.jsx');
	
	  __REACT_HOT_LOADER__.register(isLucky88, 'isLucky88', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/root_url.jsx');
	
	  __REACT_HOT_LOADER__.register(isUSPride, 'isUSPride', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/root_url.jsx');
	
	  __REACT_HOT_LOADER__.register(isCNT, 'isCNT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/root_url.jsx');
	
	  __REACT_HOT_LOADER__.register(isCalco, 'isCalco', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/root_url.jsx');
	
	  __REACT_HOT_LOADER__.register(isJML, 'isJML', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/root_url.jsx');
	
	  __REACT_HOT_LOADER__.register(company, 'company', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/root_url.jsx');
	
	  __REACT_HOT_LOADER__.register(generateBase, 'generateBase', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/root_url.jsx');
	
	  __REACT_HOT_LOADER__.register(generateRootUrl, 'generateRootUrl', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/root_url.jsx');
	
	  __REACT_HOT_LOADER__.register(ROOT_URL, 'ROOT_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/root_url.jsx');
	
	  __REACT_HOT_LOADER__.register(VERSION_NUM, 'VERSION_NUM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/root_url.jsx');
	
	  __REACT_HOT_LOADER__.register(companyCode, 'companyCode', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/root_url.jsx');
	
	  __REACT_HOT_LOADER__.register(ROOT_API_URL, 'ROOT_API_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/root_url.jsx');
	
	  __REACT_HOT_LOADER__.register(companyCodeTitle, 'companyCodeTitle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/root_url.jsx');
	
	  __REACT_HOT_LOADER__.register(checkCompany, 'checkCompany', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/root_url.jsx');
	}();

	;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Spinner icon
	
	var Spinner = function Spinner() {
	    return _react2.default.createElement(
	        "div",
	        { className: "ball-pulse" },
	        _react2.default.createElement("div", null),
	        _react2.default.createElement("div", null),
	        _react2.default.createElement("div", null)
	    );
	};
	
	var _default = Spinner;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(Spinner, "Spinner", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Widgets/spinner.jsx");
	
	    __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Widgets/spinner.jsx");
	}();

	;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// GLOBAL CONSTANTS
	// -----------------------------------
	
	var APP_COLORS = exports.APP_COLORS = {
	  'primary': '#0C88E3',
	  'success': '#4CAF50',
	  'info': '#23b7e5',
	  'warning': '#ff902b',
	  'danger': '#f05050',
	  'inverse': '#131e26',
	  'green': '#37bc9b',
	  'pink': '#f532e5',
	  'purple': '#7266ba',
	  'dark': '#3a3f51',
	  'yellow': '#fad732',
	  'gray-darker': '#232735',
	  'gray-dark': '#3a3f51',
	  'gray': '#dde6e9',
	  'gray-light': '#e4eaec',
	  'gray-lighter': '#edf1f2',
	  'blue': '#56A0D3',
	  'body-color': '#656565',
	  'sub-category-nav': '#0D3B69',
	  'category-nav': 'black',
	  'active-category-background-nav': '#FFECB3'
	};
	
	var APP_MEDIAQUERY = exports.APP_MEDIAQUERY = {
	  'desktopLG': 1200,
	  'desktop': 992,
	  'tablet': 768,
	  'mobile': 480
	};
	
	var UI_HEIGHT = exports.UI_HEIGHT = {
	  'leftBar': 235,
	  'rightBar': 300,
	  'binDetail': 210,
	  'noButton': 295,
	  'oneLineButton': 330,
	  'twoLineButton': 380,
	  'fourLineButton': 460,
	  'fiveLineButton': 500,
	  'inventoriesPage': 325,
	  'customersPage': 255,
	  'vendorsPage': 255,
	  'editSalesInvPage': 320,
	  'heightLess490': 490,
	  'inventoryDetailPage': 700,
	  'presidentDashboard': 180
	};
	
	var BACKGROUND_COLOR = exports.BACKGROUND_COLOR = {
	  'red': '#C96059',
	  'blue': '#309DBA',
	  tintedPink: '#FFAFAF',
	  tintedYellow: '#FFF9C4',
	  tintedBlue: '#90CAF9',
	  tintedRed: '#F44336',
	  'yellow': '#E7AE5A',
	  'gray': '#e8e8e8',
	  'lightGray': '#A9A9A9',
	  'OutofStock': '#7C0000',
	  'InStock': '#237193',
	  nonFixed: 'rgba(231, 174, 90, 0.4)',
	  fixed: 'rgba(88, 88, 88, 0.4)'
	};
	
	var DEFAULT_ERROR = exports.DEFAULT_ERROR = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(APP_COLORS, 'APP_COLORS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/constants.js');
	
	  __REACT_HOT_LOADER__.register(APP_MEDIAQUERY, 'APP_MEDIAQUERY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/constants.js');
	
	  __REACT_HOT_LOADER__.register(UI_HEIGHT, 'UI_HEIGHT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/constants.js');
	
	  __REACT_HOT_LOADER__.register(BACKGROUND_COLOR, 'BACKGROUND_COLOR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/constants.js');
	
	  __REACT_HOT_LOADER__.register(DEFAULT_ERROR, 'DEFAULT_ERROR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/constants.js');
	}();

	;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1041);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(804);

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// User action types
	var REQUEST_USERS = exports.REQUEST_USERS = 'REQUEST_USERS';
	var FETCH_USERS_SUCCESS = exports.FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
	var FETCH_USERS_FAILURE = exports.FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';
	var CREATE_USER = exports.CREATE_USER = 'CREATE_USER';
	var SELECT_USER = exports.SELECT_USER = 'SELECT_USER';
	
	// Post action types
	var REQUEST_POSTS = exports.REQUEST_POSTS = 'REQUEST_POSTS';
	var FETCH_POSTS_SUCCESS = exports.FETCH_POSTS_SUCCESS = 'FETCH_POSTS_SUCCESS';
	var FETCH_POSTS_FAILURE = exports.FETCH_POSTS_FAILURE = 'FETCH_POSTS_FAILURE';
	var REQUEST_COMMENTS = exports.REQUEST_COMMENTS = 'REQUEST_COMMENTS';
	var FETCH_COMMENTS_SUCCESS = exports.FETCH_COMMENTS_SUCCESS = 'FETCH_COMMENTS_SUCCESS';
	var FETCH_COMMENTS_FAILURE = exports.FETCH_COMMENTS_FAILURE = 'FETCH_COMMENTS_FAILURE';
	var SELECT_POST = exports.SELECT_POST = 'SELECT_POST';
	
	// Product action types
	var PRODUCTFORM_ACTIVE_CUSTOMER = exports.PRODUCTFORM_ACTIVE_CUSTOMER = 'PRODUCTFORM_ACTIVE_CUSTOMER';
	var DELETE_CATEGORY2_PRODUCT = exports.DELETE_CATEGORY2_PRODUCT = 'DELETE_CATEGORY2_PRODUCT';
	var DELETE_CATEGORY2_PRODUCT_SUCCESS = exports.DELETE_CATEGORY2_PRODUCT_SUCCESS = 'DELETE_CATEGORY2_PRODUCT_SUCCESS';
	var DELETE_CATEGORY2_PRODUCT_FAILURE = exports.DELETE_CATEGORY2_PRODUCT_FAILURE = 'DELETE_CATEGORY2_PRODUCT_FAILURE';
	var REQUEST_PRODUCTS = exports.REQUEST_PRODUCTS = 'REQUEST_PRODUCTS';
	var FETCH_PRODUCTS_SUCCESS = exports.FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
	var FETCH_PRODUCTS_FAILURE = exports.FETCH_PRODUCTS_FAILURE = 'FETCH_PRODUCTS_FAILURE';
	var FETCH_CATEGORY2_PRODUCTS_SUCCESS = exports.FETCH_CATEGORY2_PRODUCTS_SUCCESS = 'FETCH_CATEGORY2_PRODUCTS_SUCCESS';
	var FETCH_PRODUCTS_BY_CATEGORY2_FAILURE = exports.FETCH_PRODUCTS_BY_CATEGORY2_FAILURE = 'FETCH_PRODUCTS_BY_CATEGORY2_FAILURE';
	var REQUEST_CATEGORY2_PRODUCTS = exports.REQUEST_CATEGORY2_PRODUCTS = 'REQUEST_CATEGORY2_PRODUCTS';
	var REQUEST_PRODUCT_BY_NUM = exports.REQUEST_PRODUCT_BY_NUM = 'REQUEST_PRODUCT_BY_NUM';
	var FETCH_PRODUCT_BY_NUM_SUCCESS = exports.FETCH_PRODUCT_BY_NUM_SUCCESS = 'FETCH_PRODUCT_BY_NUM_SUCCESS';
	var FETCH_PRODUCT_BY_NUM_FAILURE = exports.FETCH_PRODUCT_BY_NUM_FAILURE = 'FETCH_PRODUCT_BY_NUM_FAILURE';
	var REQUEST_NEXT_PRODUCT = exports.REQUEST_NEXT_PRODUCT = 'REQUEST_NEXT_PRODUCT';
	var FETCH_NEXT_PRODUCT_SUCCESS = exports.FETCH_NEXT_PRODUCT_SUCCESS = 'FETCH_NEXT_PRODUCT_SUCCESS';
	var FETCH_NEXT_PRODUCT_FAILURE = exports.FETCH_NEXT_PRODUCT_FAILURE = 'FETCH_NEXT_PRODUCT_FAILURE';
	var REQUEST_PREVIOUS_PRODUCT = exports.REQUEST_PREVIOUS_PRODUCT = 'REQUEST_PREVIOUS_PRODUCT';
	var FETCH_PREVIOUS_PRODUCT_SUCCESS = exports.FETCH_PREVIOUS_PRODUCT_SUCCESS = 'FETCH_PREVIOUS_PRODUCT_SUCCESS';
	var FETCH_PREVIOUS_PRODUCT_FAILURE = exports.FETCH_PREVIOUS_PRODUCT_FAILURE = 'FETCH_PREVIOUS_PRODUCT_FAILURE';
	var REQUEST_PRODUCTS_BY_VENDOR = exports.REQUEST_PRODUCTS_BY_VENDOR = 'REQUEST_PRODUCTS_BY_VENDOR';
	var FETCH_PRODUCTS_BY_VENDOR_SUCCESS = exports.FETCH_PRODUCTS_BY_VENDOR_SUCCESS = 'FETCH_PRODUCTS_BY_VENDOR_SUCCESS';
	var FETCH_PRODUCTS_BY_VENDOR_FAILURE = exports.FETCH_PRODUCTS_BY_VENDOR_FAILURE = 'FETCH_PRODUCTS_BY_VENDOR_FAILURE';
	var FETCH_VENDOR_BATCHES = exports.FETCH_VENDOR_BATCHES = 'FETCH_VENDOR_BATCHES';
	var FETCH_VENDOR_BATCHES_SUCCESS = exports.FETCH_VENDOR_BATCHES_SUCCESS = 'FETCH_VENDOR_BATCHES_SUCCESS';
	var FETCH_VENDOR_BATCHES_FAILURE = exports.FETCH_VENDOR_BATCHES_FAILURE = 'FETCH_VENDOR_BATCHES_FAILURE';
	var FETCH_RELATED_PRODUCTS = exports.FETCH_RELATED_PRODUCTS = 'FETCH_RELATED_PRODUCTS';
	var FETCH_RELATED_PRODUCTS_SUCCESS = exports.FETCH_RELATED_PRODUCTS_SUCCESS = 'FETCH_RELATED_PRODUCTS_SUCCESS';
	var FETCH_RELATED_PRODUCTS_FAILURE = exports.FETCH_RELATED_PRODUCTS_FAILURE = 'FETCH_RELATED_PRODUCTS_FAILURE';
	var SELECT_PRODUCT = exports.SELECT_PRODUCT = 'SELECT_PRODUCT';
	var RESET_CURRENT_PRODUCT = exports.RESET_CURRENT_PRODUCT = 'RESET_CURRENT_PRODUCT';
	var CLEAR_CURRENT_PRODUCT = exports.CLEAR_CURRENT_PRODUCT = 'CLEAR_CURRENT_PRODUCT';
	var SET_GROUP_CATEGORY = exports.SET_GROUP_CATEGORY = 'SET_GROUP_CATEGORY';
	var REQUEST_CREATING_PRODUCT = exports.REQUEST_CREATING_PRODUCT = 'REQUEST_CREATING_PRODUCT';
	var CREATE_PRODUCT_SUCCESS = exports.CREATE_PRODUCT_SUCCESS = 'CREATE_PRODUCT_SUCCESS';
	var CREATE_PRODUCT_FAILURE = exports.CREATE_PRODUCT_FAILURE = 'CREATE_PRODUCT_FAILURE';
	var REQUEST_EDITING_PRODUCT = exports.REQUEST_EDITING_PRODUCT = 'REQUEST_EDITING_PRODUCT';
	var EDIT_PRODUCT_SUCCESS = exports.EDIT_PRODUCT_SUCCESS = 'EDIT_PRODUCT_SUCCESS';
	var EDIT_PRODUCT_FAILURE = exports.EDIT_PRODUCT_FAILURE = 'EDIT_PRODUCT_FAILURE';
	var REQUEST_EDITING_MULTI_PRODUCT = exports.REQUEST_EDITING_MULTI_PRODUCT = 'REQUEST_EDITING_MULTI_PRODUCT';
	var EDIT_MULTI_PRODUCT_SUCCESS = exports.EDIT_MULTI_PRODUCT_SUCCESS = 'EDIT_MULTI_PRODUCT_SUCCESS';
	var EDIT_MULTI_PRODUCT_FAILURE = exports.EDIT_MULTI_PRODUCT_FAILURE = 'EDIT_MULTI_PRODUCT_FAILURE';
	var REQUEST_PRODUCT_DETAIL = exports.REQUEST_PRODUCT_DETAIL = 'REQUEST_PRODUCT_DETAIL';
	var FETCH_PRODUCT_DETAIL_SUCCESS = exports.FETCH_PRODUCT_DETAIL_SUCCESS = 'FETCH_PRODUCT_DETAIL_SUCCESS';
	var FETCH_PRODUCT_DETAIL_FAILURE = exports.FETCH_PRODUCT_DETAIL_FAILURE = 'FETCH_PRODUCT_DETAIL_FAILURE';
	var REQUEST_DISPLAY_CATEGORIES = exports.REQUEST_DISPLAY_CATEGORIES = 'REQUEST_DISPLAY_CATEGORIES';
	var FETCH_DISPLAY_CATEGORIES_SUCCESS = exports.FETCH_DISPLAY_CATEGORIES_SUCCESS = 'FETCH_DISPLAY_CATEGORIES_SUCCESS';
	var FETCH_DISPLAY_CATEGORIES_FAILURE = exports.FETCH_DISPLAY_CATEGORIES_FAILURE = 'FETCH_DISPLAY_CATEGORIES_FAILURE';
	var REQUEST_EDIT_DISPLAY_CATEGORIES = exports.REQUEST_EDIT_DISPLAY_CATEGORIES = 'REQUEST_EDIT_DISPLAY_CATEGORIES';
	var EDIT_DISPLAY_CATEGORIES_SUCCESS = exports.EDIT_DISPLAY_CATEGORIES_SUCCESS = 'EDIT_DISPLAY_CATEGORIES_SUCCESS';
	var EDIT_DISPLAY_CATEGORIES_FAILURE = exports.EDIT_DISPLAY_CATEGORIES_FAILURE = 'EDIT_DISPLAY_CATEGORIES_FAILURE';
	var REQUEST_PRODUCT_INFO = exports.REQUEST_PRODUCT_INFO = 'REQUEST_PRODUCT_INFO';
	var FETCH_PRODUCT_INFO_SUCCESS = exports.FETCH_PRODUCT_INFO_SUCCESS = 'FETCH_PRODUCT_INFO_SUCCESS';
	var FETCH_PRODUCT_INFO_FAILURE = exports.FETCH_PRODUCT_INFO_FAILURE = 'FETCH_PRODUCT_INFO_FAILURE';
	var ATTACH_PRODUCT_IMAGE = exports.ATTACH_PRODUCT_IMAGE = 'ATTACH_PRODUCT_IMAGE';
	var ATTACH_PRODUCT_IMAGE_SUCCESS = exports.ATTACH_PRODUCT_IMAGE_SUCCESS = 'ATTACH_PRODUCT_IMAGE_SUCCESS';
	var ATTACH_PRODUCT_IMAGE_FAILURE = exports.ATTACH_PRODUCT_IMAGE_FAILURE = 'ATTACH_PRODUCT_IMAGE_FAILURE';
	var CLEAR_ATTACHED_PRODUCT_IMAGE = exports.CLEAR_ATTACHED_PRODUCT_IMAGE = 'CLEAR_ATTACHED_PRODUCT_IMAGE';
	var FETCH_SUGGESTED_PROD_NUM = exports.FETCH_SUGGESTED_PROD_NUM = 'FETCH_SUGGESTED_PROD_NUM';
	var FETCH_SUGGESTED_PROD_NUM_SUCCESS = exports.FETCH_SUGGESTED_PROD_NUM_SUCCESS = 'FETCH_SUGGESTED_PROD_NUM_SUCCESS';
	var FETCH_SUGGESTED_PROD_NUM_FAILURE = exports.FETCH_SUGGESTED_PROD_NUM_FAILURE = 'FETCH_SUGGESTED_PROD_NUM_FAILURE';
	var FETCH_SUGGEST_DIGIT = exports.FETCH_SUGGEST_DIGIT = 'FETCH_SUGGEST_DIGIT';
	var FETCH_SUGGEST_DIGIT_SUCCESS = exports.FETCH_SUGGEST_DIGIT_SUCCESS = 'FETCH_SUGGEST_DIGIT_SUCCESS';
	var FETCH_SUGGEST_DIGIT_FAILURE = exports.FETCH_SUGGEST_DIGIT_FAILURE = 'FETCH_SUGGEST_DIGIT_FAILURE';
	var CLEAR_SUGGEST_DIGIT = exports.CLEAR_SUGGEST_DIGIT = 'CLEAR_SUGGEST_DIGIT';
	var FETCH_PACKAGE_TYPES = exports.FETCH_PACKAGE_TYPES = 'FETCH_PACKAGE_TYPES';
	var FETCH_PACKAGE_TYPES_SUCCESS = exports.FETCH_PACKAGE_TYPES_SUCCESS = 'FETCH_PACKAGE_TYPES_SUCCESS';
	var FETCH_PACKAGE_TYPES_FAILURE = exports.FETCH_PACKAGE_TYPES_FAILURE = 'FETCH_PACKAGE_TYPES_FAILURE';
	var EDIT_PACKAGE_TYPE = exports.EDIT_PACKAGE_TYPE = 'EDIT_PACKAGE_TYPE';
	var EDIT_PACKAGE_TYPE_SUCCESS = exports.EDIT_PACKAGE_TYPE_SUCCESS = 'EDIT_PACKAGE_TYPE_SUCCESS';
	var EDIT_PACKAGE_TYPE_FAILURE = exports.EDIT_PACKAGE_TYPE_FAILURE = 'EDIT_PACKAGE_TYPE_FAILURE';
	var CLEAR_PACKAGE_TYPE_EDITED = exports.CLEAR_PACKAGE_TYPE_EDITED = 'CLEAR_PACKAGE_TYPE_EDITED';
	var REQUEST_DELETE_PACKAGE_TYPE = exports.REQUEST_DELETE_PACKAGE_TYPE = 'REQUEST_DELETE_PACKAGE_TYPE';
	var DELETE_PACKAGE_TYPE_SUCCESS = exports.DELETE_PACKAGE_TYPE_SUCCESS = 'DELETE_PACKAGE_TYPE_SUCCESS';
	var DELETE_PACKAGE_TYPE_FAILURE = exports.DELETE_PACKAGE_TYPE_FAILURE = 'DELETE_PACKAGE_TYPE_FAILURE';
	var FETCH_MEASUREMENT_UNIT = exports.FETCH_MEASUREMENT_UNIT = 'FETCH_MEASUREMENT_UNIT';
	var FETCH_MEASUREMENT_UNIT_SUCCESS = exports.FETCH_MEASUREMENT_UNIT_SUCCESS = 'FETCH_MEASUREMENT_UNIT_SUCCESS';
	var FETCH_MEASUREMENT_UNIT_FAILURE = exports.FETCH_MEASUREMENT_UNIT_FAILURE = 'FETCH_MEASUREMENT_UNIT_FAILURE';
	var EDIT_MEASUREMENT_UNIT = exports.EDIT_MEASUREMENT_UNIT = 'EDIT_MEASUREMENT_UNIT';
	var EDIT_MEASUREMENT_UNIT_SUCCESS = exports.EDIT_MEASUREMENT_UNIT_SUCCESS = 'EDIT_MEASUREMENT_UNIT_SUCCESS';
	var EDIT_MEASUREMENT_UNIT_FAILURE = exports.EDIT_MEASUREMENT_UNIT_FAILURE = 'EDIT_MEASUREMENT_UNIT_FAILURE';
	var CLEAR_MEASUREMENT_UNIT_EDITED = exports.CLEAR_MEASUREMENT_UNIT_EDITED = 'CLEAR_MEASUREMENT_UNIT_EDITED';
	var REQUEST_DELETE_MEASUREMENT_UNIT = exports.REQUEST_DELETE_MEASUREMENT_UNIT = 'REQUEST_DELETE_MEASUREMENT_UNIT';
	var DELETE_MEASUREMENT_UNIT_SUCCESS = exports.DELETE_MEASUREMENT_UNIT_SUCCESS = 'DELETE_MEASUREMENT_UNIT_SUCCESS';
	var DELETE_MEASUREMENT_UNIT_FAILURE = exports.DELETE_MEASUREMENT_UNIT_FAILURE = 'DELETE_MEASUREMENT_UNIT_FAILURE';
	var FETCH_CONVERTABLE_PRODUCTS = exports.FETCH_CONVERTABLE_PRODUCTS = 'FETCH_CONVERTABLE_PRODUCTS';
	var FETCH_CONVERTABLE_PRODUCTS_SUCCESS = exports.FETCH_CONVERTABLE_PRODUCTS_SUCCESS = 'FETCH_CONVERTABLE_PRODUCTS_SUCCESS';
	var FETCH_CONVERTABLE_PRODUCTS_FAILURE = exports.FETCH_CONVERTABLE_PRODUCTS_FAILURE = 'FETCH_CONVERTABLE_PRODUCTS_FAILURE';
	var SET_CURRENT_PRODUCT = exports.SET_CURRENT_PRODUCT = 'SET_CURRENT_PRODUCT';
	var REQUEST_GROUPS = exports.REQUEST_GROUPS = 'REQUEST_GROUPS';
	var FETCH_GROUPS_SUCCESS = exports.FETCH_GROUPS_SUCCESS = 'FETCH_GROUPS_SUCCESS';
	var FETCH_GROUPS_FAILURE = exports.FETCH_GROUPS_FAILURE = 'FETCH_GROUPS_FAILURE';
	var SELECT_GROUP = exports.SELECT_GROUP = 'SELECT_GROUP';
	var RESET_CURRENT_GROUP = exports.RESET_CURRENT_GROUP = 'RESET_CURRENT_GROUP';
	var REQUEST_CREATING_GROUP = exports.REQUEST_CREATING_GROUP = 'REQUEST_CREATING_GROUP';
	var CREATE_GROUP_SUCCESS = exports.CREATE_GROUP_SUCCESS = 'CREATE_GROUP_SUCCESS';
	var CREATE_GROUP_FAILURE = exports.CREATE_GROUP_FAILURE = 'CREATE_GROUP_FAILURE';
	var REQUEST_EDITING_GROUP = exports.REQUEST_EDITING_GROUP = 'REQUEST_EDITING_GROUP';
	var EDIT_GROUP_SUCCESS = exports.EDIT_GROUP_SUCCESS = 'EDIT_GROUP_SUCCESS';
	var EDIT_GROUP_FAILURE = exports.EDIT_GROUP_FAILURE = 'EDIT_GROUP_FAILURE';
	var REQUEST_EDITING_MULTI_GROUPS = exports.REQUEST_EDITING_MULTI_GROUPS = 'REQUEST_EDITING_MULTI_GROUPS';
	var EDIT_MULTI_GROUPS_SUCCESS = exports.EDIT_MULTI_GROUPS_SUCCESS = 'EDIT_MULTI_GROUPS_SUCCESS';
	var EDIT_MULTI_GROUPS_FAILURE = exports.EDIT_MULTI_GROUPS_FAILURE = 'EDIT_MULTI_GROUPS_FAILURE';
	var REQUEST_GROUP_DETAIL = exports.REQUEST_GROUP_DETAIL = 'REQUEST_GROUP_DETAIL';
	var FETCH_GROUP_DETAIL_SUCCESS = exports.FETCH_GROUP_DETAIL_SUCCESS = 'FETCH_GROUP_DETAIL_SUCCESS';
	var FETCH_GROUP_DETAIL_FAILURE = exports.FETCH_GROUP_DETAIL_FAILURE = 'FETCH_GROUP_DETAIL_FAILURE';
	var REQUEST_CATEGORIES = exports.REQUEST_CATEGORIES = 'REQUEST_CATEGORIES';
	var FETCH_CATEGORIES_SUCCESS = exports.FETCH_CATEGORIES_SUCCESS = 'FETCH_CATEGORIES_SUCCESS';
	var FETCH_CATEGORIES_FAILURE = exports.FETCH_CATEGORIES_FAILURE = 'FETCH_CATEGORIES_FAILURE';
	var REQUEST_GROUP_CATEGORIES = exports.REQUEST_GROUP_CATEGORIES = 'REQUEST_GROUP_CATEGORIES';
	var FETCH_GROUP_CATEGORIES_SUCCESS = exports.FETCH_GROUP_CATEGORIES_SUCCESS = 'FETCH_GROUP_CATEGORIES_SUCCESS';
	var FETCH_GROUP_CATEGORIES_FAILURE = exports.FETCH_GROUP_CATEGORIES_FAILURE = 'FETCH_GROUP_CATEGORIES_FAILURE';
	var SELECT_CATEGORY = exports.SELECT_CATEGORY = 'SELECT_CATEGORY';
	var RESET_CURRENT_CATEGORY = exports.RESET_CURRENT_CATEGORY = 'RESET_CURRENT_CATEGORY';
	var REQUEST_CREATING_CATEGORY = exports.REQUEST_CREATING_CATEGORY = 'REQUEST_CREATING_CATEGORY';
	var CREATE_CATEGORY_SUCCESS = exports.CREATE_CATEGORY_SUCCESS = 'CREATE_CATEGORY_SUCCESS';
	var CREATE_CATEGORY_FAILURE = exports.CREATE_CATEGORY_FAILURE = 'CREATE_CATEGORY_FAILURE';
	var EDIT_MULTI_TAXES = exports.EDIT_MULTI_TAXES = 'EDIT_MULTI_TAXES';
	var EDIT_MULTI_TAXES_SUCCESS = exports.EDIT_MULTI_TAXES_SUCCESS = 'EDIT_MULTI_TAXES_SUCCESS';
	var EDIT_MULTI_TAXES_FAILURE = exports.EDIT_MULTI_TAXES_FAILURE = 'EDIT_MULTI_TAXES_FAILURE';
	var DELETE_TAX = exports.DELETE_TAX = 'DELETE_TAX';
	var DELETE_TAX_SUCCESS = exports.DELETE_TAX_SUCCESS = 'DELETE_TAX_SUCCESS';
	var DELETE_TAX_FAILURE = exports.DELETE_TAX_FAILURE = 'DELETE_TAX_FAILURE';
	var REQUEST_EDITING_CATEGORY = exports.REQUEST_EDITING_CATEGORY = 'REQUEST_EDITING_CATEGORY';
	var EDIT_CATEGORY_SUCCESS = exports.EDIT_CATEGORY_SUCCESS = 'EDIT_CATEGORY_SUCCESS';
	var EDIT_CATEGORY_FAILURE = exports.EDIT_CATEGORY_FAILURE = 'EDIT_CATEGORY_FAILURE';
	var REQUEST_EDITING_MULTI_CATEGORIES = exports.REQUEST_EDITING_MULTI_CATEGORIES = 'REQUEST_EDITING_MULTI_CATEGORIES';
	var EDIT_MULTI_CATEGORIES_SUCCESS = exports.EDIT_MULTI_CATEGORIES_SUCCESS = 'EDIT_MULTI_CATEGORIES_SUCCESS';
	var EDIT_MULTI_CATEGORIES_FAILURE = exports.EDIT_MULTI_CATEGORIES_FAILURE = 'EDIT_MULTI_CATEGORIES_FAILURE';
	var REQUEST_CATEGORIES_2 = exports.REQUEST_CATEGORIES_2 = 'REQUEST_CATEGORIES_2';
	var FETCH_CATEGORIES_2_SUCCESS = exports.FETCH_CATEGORIES_2_SUCCESS = 'FETCH_CATEGORIES_2_SUCCESS';
	var FETCH_CATEGORIES_2_FAILURE = exports.FETCH_CATEGORIES_2_FAILURE = 'FETCH_CATEGORIES_2_FAILURE';
	var REQUEST_EDITING_MULTI_CATEGORIES_2 = exports.REQUEST_EDITING_MULTI_CATEGORIES_2 = 'REQUEST_EDITING_MULTI_CATEGORIES_2';
	var EDIT_MULTI_CATEGORIES_2_SUCCESS = exports.EDIT_MULTI_CATEGORIES_2_SUCCESS = 'EDIT_MULTI_CATEGORIES_2_SUCCESS';
	var EDIT_MULTI_CATEGORIES_2_FAILURE = exports.EDIT_MULTI_CATEGORIES_2_FAILURE = 'EDIT_MULTI_CATEGORIES_2_FAILURE';
	var REQUEST_DELETE_CATEGORY_2 = exports.REQUEST_DELETE_CATEGORY_2 = 'REQUEST_DELETE_CATEGORY_2';
	var DELETE_CATEGORY_2_SUCCESS = exports.DELETE_CATEGORY_2_SUCCESS = 'DELETE_CATEGORY_2_SUCCESS';
	var DELETE_CATEGORY_2_FAILURE = exports.DELETE_CATEGORY_2_FAILURE = 'DELETE_CATEGORY_2_FAILURE';
	var CLEAR_CATEGORY_2_STATUS = exports.CLEAR_CATEGORY_2_STATUS = 'CLEAR_CATEGORY_2_STATUS';
	var SET_ROWS_FILTERS = exports.SET_ROWS_FILTERS = 'SET_ROWS_FILTERS';
	//B2B start
	var REQUEST_CATEGORIES_2_B2B = exports.REQUEST_CATEGORIES_2_B2B = 'REQUEST_CATEGORIES_2_B2B';
	var FETCH_CATEGORIES_2_SUCCESS_B2B = exports.FETCH_CATEGORIES_2_SUCCESS_B2B = 'FETCH_CATEGORIES_2_SUCCESS_B2B';
	var FETCH_CATEGORIES_2_FAILURE_B2B = exports.FETCH_CATEGORIES_2_FAILURE_B2B = 'FETCH_CATEGORIES_2_FAILURE_B2B';
	var REQUEST_EDITING_MULTI_CATEGORIES_2_B2B = exports.REQUEST_EDITING_MULTI_CATEGORIES_2_B2B = 'REQUEST_EDITING_MULTI_CATEGORIES_2_B2B';
	var EDIT_MULTI_CATEGORIES_2_SUCCESS_B2B = exports.EDIT_MULTI_CATEGORIES_2_SUCCESS_B2B = 'EDIT_MULTI_CATEGORIES_2_SUCCESS_B2B';
	var EDIT_MULTI_CATEGORIES_2_FAILURE_B2B = exports.EDIT_MULTI_CATEGORIES_2_FAILURE_B2B = 'EDIT_MULTI_CATEGORIES_2_FAILURE_B2B';
	var REQUEST_DELETE_CATEGORY_2_B2B = exports.REQUEST_DELETE_CATEGORY_2_B2B = 'REQUEST_DELETE_CATEGORY_2_B2B';
	var DELETE_CATEGORY_2_SUCCESS_B2B = exports.DELETE_CATEGORY_2_SUCCESS_B2B = 'DELETE_CATEGORY_2_SUCCESS_B2B';
	var DELETE_CATEGORY_2_FAILURE_B2B = exports.DELETE_CATEGORY_2_FAILURE_B2B = 'DELETE_CATEGORY_2_FAILURE_B2B';
	var CLEAR_CATEGORY_2_STATUS_B2B = exports.CLEAR_CATEGORY_2_STATUS_B2B = 'CLEAR_CATEGORY_2_STATUS_B2B';
	var SELECT_CATEGORY_B2B = exports.SELECT_CATEGORY_B2B = "SELECT_CATEGORY_B2B";
	var RESET_CURRENT_CATEGORY_B2B = exports.RESET_CURRENT_CATEGORY_B2B = "RESET_CURRENT_CATEGORY_B2B";
	var REQUEST_CATEGORY2_PRODUCTS_B2B = exports.REQUEST_CATEGORY2_PRODUCTS_B2B = "REQUEST_CATEGORY2_PRODUCTS_B2B";
	var FETCH_CATEGORY2_PRODUCTS_SUCCESS_B2B = exports.FETCH_CATEGORY2_PRODUCTS_SUCCESS_B2B = "FETCH_CATEGORY2_PRODUCTS_SUCCESS_B2B";
	var FETCH_CATEGORY2_PRODUCTS_FAILURE_B2B = exports.FETCH_CATEGORY2_PRODUCTS_FAILURE_B2B = "FETCH_CATEGORY2_PRODUCTS_FAILURE_B2B";
	//B2B end
	var REQUEST_ACTION_LOG = exports.REQUEST_ACTION_LOG = 'REQUEST_ACTION_LOG';
	var FETCH_ACTION_LOG_SUCCESS = exports.FETCH_ACTION_LOG_SUCCESS = 'FETCH_ACTION_LOG_SUCCESS';
	var FETCH_ACTION_LOG_FAILURE = exports.FETCH_ACTION_LOG_FAILURE = 'FETCH_ACTION_LOG_FAILURE';
	var REQUEST_CONTINUE_OR_DISCONTINUE_PRODUCT = exports.REQUEST_CONTINUE_OR_DISCONTINUE_PRODUCT = 'REQUEST_CONTINUE_PRODUCT';
	var DELETE_PRODUCT = exports.DELETE_PRODUCT = "DELETE_PRODUCT";
	var DELETE_PRODUCT_SUCCESS = exports.DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
	var DELETE_PRODUCT_FAILURE = exports.DELETE_PRODUCT_FAILURE = "DELETE_PRODUCT_FAILURE";
	var CONTINUE_OR_DISCONTINUE_PRODUCT_SUCCESS = exports.CONTINUE_OR_DISCONTINUE_PRODUCT_SUCCESS = 'CONTINUE_PRODUCT_SUCCESS';
	var CONTINUE_OR_DISCONTINUE_PRODUCT_FAILURE = exports.CONTINUE_OR_DISCONTINUE_PRODUCT_FAILURE = 'CONTINUE_PRODUCT_FAILURE';
	var SAVE_MOBILE_DESCRIPTION_BOX_TEXT_SUCCESS = exports.SAVE_MOBILE_DESCRIPTION_BOX_TEXT_SUCCESS = 'SAVE_MOBILE_DESCRIPTION_BOX_TEXT_SUCCESS';
	var SAVE_MOBILE_DESCRIPTION_BOX_TEXT_FAILURE = exports.SAVE_MOBILE_DESCRIPTION_BOX_TEXT_FAILURE = 'SAVE_MOBILE_DESCRIPTION_BOX_TEXT_FAILURE';
	var REQUEST_SAVE_MOBILE_DESCRIPTION_BOX_TEXT = exports.REQUEST_SAVE_MOBILE_DESCRIPTION_BOX_TEXT = 'REQUEST_SAVE_MOBILE_DESCRIPTION_BOX_TEXT';
	var RESET_CATEGORY2_ID = exports.RESET_CATEGORY2_ID = 'RESET_CATEGORY2_ID';
	
	var RESET_GROUP_AND_CATEGORY = exports.RESET_GROUP_AND_CATEGORY = 'RESET_GROUP_AND_CATEGORY';
	var RESET_CATEGORY = exports.RESET_CATEGORY = 'RESET_CATEGORY';
	var REQUEST_TYPES = exports.REQUEST_TYPES = 'REQUEST_TYPES';
	var FETCH_TYPES_SUCCESS = exports.FETCH_TYPES_SUCCESS = 'FETCH_TYPES_SUCCESS';
	var FETCH_TYPES_FAILURE = exports.FETCH_TYPES_FAILURE = 'FETCH_TYPES_FAILURE';
	var REQUEST_PRICELEVELS = exports.REQUEST_PRICELEVELS = 'REQUEST_PRICELEVELS';
	var FETCH_PRICELEVELS_SUCCESS = exports.FETCH_PRICELEVELS_SUCCESS = 'FETCH_PRICELEVELS_SUCCESS';
	var FETCH_PRICELEVELS_FAILURE = exports.FETCH_PRICELEVELS_FAILURE = 'FETCH_PRICELEVELS_FAILURE';
	var REQUEST_EDITING_MULTI_PRICELEVELS = exports.REQUEST_EDITING_MULTI_PRICELEVELS = 'REQUEST_EDITING_MULTI_PRICELEVELS';
	var EDIT_MULTI_PRICELEVELS_SUCCESS = exports.EDIT_MULTI_PRICELEVELS_SUCCESS = 'EDIT_MULTI_PRICELEVELS_SUCCESS';
	var EDIT_MULTI_PRICELEVELS_FAILURE = exports.EDIT_MULTI_PRICELEVELS_FAILURE = 'EDIT_MULTI_PRICELEVELS_FAILURE';
	var REQUEST_SIMPLIFIED_PRODUCTS = exports.REQUEST_SIMPLIFIED_PRODUCTS = 'REQUEST_SIMPLIFIED_PRODUCTS';
	var FETCH_SIMPLIFIED_PRODUCTS_SUCCESS = exports.FETCH_SIMPLIFIED_PRODUCTS_SUCCESS = 'FETCH_SIMPLIFIED_PRODUCTS_SUCCESS';
	var FETCH_SIMPLIFIED_PRODUCTS_FAILURE = exports.FETCH_SIMPLIFIED_PRODUCTS_FAILURE = 'FETCH_SIMPLIFIED_PRODUCTS_FAILURE';
	var REQUEST_DELETE_CATEGORY = exports.REQUEST_DELETE_CATEGORY = 'REQUEST_DELETE_CATEGORY';
	var DELETE_CATEGORY_SUCCESS = exports.DELETE_CATEGORY_SUCCESS = 'DELETE_CATEGORY_SUCCESS';
	var DELETE_CATEGORY_FAILURE = exports.DELETE_CATEGORY_FAILURE = 'DELETE_CATEGORY_FAILURE';
	var REQUEST_DELETE_GROUP = exports.REQUEST_DELETE_GROUP = 'REQUEST_DELETE_GROUP';
	var DELETE_GROUP_SUCCESS = exports.DELETE_GROUP_SUCCESS = 'DELETE_GROUP_SUCCESS';
	var DELETE_PRODUCT_GROUP_SUCCESS = exports.DELETE_PRODUCT_GROUP_SUCCESS = 'DELETE_PRODUCT_GROUP_SUCCESS';
	var DELETE_GROUP_FAILURE = exports.DELETE_GROUP_FAILURE = 'DELETE_GROUP_FAILURE';
	var CLEAR_CATEGORY_STATUS = exports.CLEAR_CATEGORY_STATUS = 'CLEAR_CATEGORY_STATUS';
	var CLEAR_GROUP_STATUS = exports.CLEAR_GROUP_STATUS = 'CLEAR_GROUP_STATUS';
	var REINITIALZIE_PRODUCT_FORM = exports.REINITIALZIE_PRODUCT_FORM = 'REINITIALZIE_PRODUCT_FORM';
	var REQUEST_SMALL_PRODUCT_INFO = exports.REQUEST_SMALL_PRODUCT_INFO = 'REQUEST_SMALL_PRODUCT_INFO';
	var FETCH_SMALL_PRODUCT_INFO_SUCCESS = exports.FETCH_SMALL_PRODUCT_INFO_SUCCESS = 'FETCH_SMALL_PRODUCT_INFO_SUCCESS';
	var FETCH_SMALL_PRODUCT_INFO_FAILURE = exports.FETCH_SMALL_PRODUCT_INFO_FAILURE = 'FETCH_SMALL_PRODUCT_INFO_FAILURE';
	var CLEAR_SMALL_PRODUCT = exports.CLEAR_SMALL_PRODUCT = 'CLEAR_SMALL_PRODUCT';
	var REQUEST_CRV_VALUES = exports.REQUEST_CRV_VALUES = 'REQUEST_CRV_VALUES';
	var FETCH_CRV_VALUES_SUCCESS = exports.FETCH_CRV_VALUES_SUCCESS = 'FETCH_CRV_VALUES_SUCCESS';
	var FETCH_CRV_VALUES_FAILURE = exports.FETCH_CRV_VALUES_FAILURE = 'FETCH_CRV_VALUES_FAILURE';
	
	var REQUEST_DEFAULT_BUYERS = exports.REQUEST_DEFAULT_BUYERS = 'REQUEST_DEFAULT_BUYERS';
	var REQUEST_DEFAULT_BUYERS_SUCCESS = exports.REQUEST_DEFAULT_BUYERS_SUCCESS = 'REQUEST_DEFAULT_BUYERS_SUCCESS';
	var REQUEST_DEFAULT_BUYERS_FAILURE = exports.REQUEST_DEFAULT_BUYERS_FAILURE = 'REQUEST_DEFAULT_BUYERS_FAILURE';
	
	var REQUEST_UPDATE_PRODUCT = exports.REQUEST_UPDATE_PRODUCT = 'REQUEST_UPDATE_PRODUCT';
	var UPDATE_PRODUCT_SUCCEESS = exports.UPDATE_PRODUCT_SUCCEESS = 'UPDATE_PRODUCT_SUCCEESS';
	var UPDATE_PRODUCT_FAILURE = exports.UPDATE_PRODUCT_FAILURE = 'UPDATE_PRODUCT_FAILURE';
	
	// Customer action types
	var REQUEST_CUSTOMERS = exports.REQUEST_CUSTOMERS = 'REQUEST_CUSTOMERS';
	var FETCH_CUSTOMERS_SUCCESS = exports.FETCH_CUSTOMERS_SUCCESS = 'FETCH_CUSTOMERS_SUCCESS';
	var FETCH_CUSTOMERS_FAILURE = exports.FETCH_CUSTOMERS_FAILURE = 'FETCH_CUSTOMERS_FAILURE';
	var REQUEST_CUSTOMERS_PAGINATE = exports.REQUEST_CUSTOMERS_PAGINATE = 'REQUEST_CUSTOMERS_PAGINATE';
	var FETCH_CUSTOMERS_PAGINATE_SUCCESS = exports.FETCH_CUSTOMERS_PAGINATE_SUCCESS = 'FETCH_CUSTOMERS_PAGINATE_SUCCESS';
	var FETCH_CUSTOMERS_PAGINATE_FAILURE = exports.FETCH_CUSTOMERS_PAGINATE_FAILURE = 'FETCH_CUSTOMERS_PAGINATE_FAILURE';
	var SELECT_CUSTOMER = exports.SELECT_CUSTOMER = 'SELECT_CUSTOMER';
	var RESET_CURRENT_CUSTOMER = exports.RESET_CURRENT_CUSTOMER = 'RESET_CURRENT_CUSTOMER';
	var REQUEST_CREATING_CUSTOMER = exports.REQUEST_CREATING_CUSTOMER = 'REQUEST_CREATING_CUSTOMER';
	var CREATE_CUSTOMER_SUCCESS = exports.CREATE_CUSTOMER_SUCCESS = 'CREATE_CUSTOMER_SUCCESS';
	var CREATE_CUSTOMER_FAILURE = exports.CREATE_CUSTOMER_FAILURE = 'CREATE_CUSTOMER_FAILURE';
	var REQUEST_EDITING_CUSTOMER = exports.REQUEST_EDITING_CUSTOMER = 'REQUEST_EDITING_CUSTOMER';
	var EDIT_CUSTOMER_SUCCESS = exports.EDIT_CUSTOMER_SUCCESS = 'EDIT_CUSTOMER_SUCCESS';
	var EDIT_CUSTOMER_FAILURE = exports.EDIT_CUSTOMER_FAILURE = 'EDIT_CUSTOMER_FAILURE';
	var REQUEST_CUSTOMER_DETAIL = exports.REQUEST_CUSTOMER_DETAIL = 'REQUEST_CUSTOMER_DETAIL';
	var FETCH_CUSTOMER_DETAIL_SUCCESS = exports.FETCH_CUSTOMER_DETAIL_SUCCESS = 'FETCH_CUSTOMER_DETAIL_SUCCESS';
	var FETCH_CUSTOMER_DETAIL_FAILURE = exports.FETCH_CUSTOMER_DETAIL_FAILURE = 'FETCH_CUSTOMER_DETAIL_FAILURE';
	var REQUEST_CUSTOMER_CREDIT_BY_DATE = exports.REQUEST_CUSTOMER_CREDIT_BY_DATE = 'REQUEST_CUSTOMER_CREDIT_BY_DATE';
	var FETCH_CUSTOMER_CREDIT_BY_DATE_SUCCESS = exports.FETCH_CUSTOMER_CREDIT_BY_DATE_SUCCESS = 'FETCH_CUSTOMER_CREDIT_BY_DATE_SUCCESS';
	var FETCH_CUSTOMER_CREDIT_BY_DATE_FAILURE = exports.FETCH_CUSTOMER_CREDIT_BY_DATE_FAILURE = 'FETCH_CUSTOMER_CREDIT_BY_DATE_FAILURE';
	var REQUEST_CUSTOMERS_STATUS = exports.REQUEST_CUSTOMERS_STATUS = 'REQUEST_CUSTOMERS_STATUS';
	var FETCH_CUSTOMERS_STATUS_SUCCESS = exports.FETCH_CUSTOMERS_STATUS_SUCCESS = 'FETCH_CUSTOMERS_STATUS_SUCCESS';
	var FETCH_CUSTOMERS_STATUS_FAILURE = exports.FETCH_CUSTOMERS_STATUS_FAILURE = 'FETCH_CUSTOMERS_STATUS_FAILURE';
	
	// Payment term action types
	var REQUEST_PAYMENTTERMS = exports.REQUEST_PAYMENTTERMS = 'REQUEST_PAYMENTTERMS';
	var FETCH_PAYMENTTERMS_SUCCESS = exports.FETCH_PAYMENTTERMS_SUCCESS = 'FETCH_PAYMENTTERMS_SUCCESS';
	var FETCH_PAYMENTTERMS_FAILURE = exports.FETCH_PAYMENTTERMS_FAILURE = 'FETCH_PAYMENTTERMS_FAILURE';
	var SELECT_PAYMENTTERM = exports.SELECT_PAYMENTTERM = 'SELECT_PAYMENTTERM';
	var RESET_CURRENT_PAYMENTTERM = exports.RESET_CURRENT_PAYMENTTERM = 'RESET_CURRENT_PAYMENTTERM';
	var RESET_CREATE_PAYMENT_TERM = exports.RESET_CREATE_PAYMENT_TERM = 'RESET_CREATE_PAYMENT_TERM';
	var RESET_EDIT_PAYMENT_TERM = exports.RESET_EDIT_PAYMENT_TERM = 'RESET_EDIT_PAYMENT_TERM';
	var REQUEST_CREATING_PAYMENT_TERM = exports.REQUEST_CREATING_PAYMENT_TERM = 'REQUEST_CREATING_PAYMENT_TERM';
	var CREATE_PAYMENT_TERM_SUCCESS = exports.CREATE_PAYMENT_TERM_SUCCESS = 'CREATE_PAYMENT_TERM_SUCCESS';
	var CREATE_PAYMENT_TERM_FAILURE = exports.CREATE_PAYMENT_TERM_FAILURE = 'CREATE_PAYMENT_TERM_FAILURE';
	var REQUEST_EDITING_PAYMENT_TERM = exports.REQUEST_EDITING_PAYMENT_TERM = 'REQUEST_EDITING_PAYMENT_TERM';
	var EDIT_PAYMENT_TERM_SUCCESS = exports.EDIT_PAYMENT_TERM_SUCCESS = 'EDIT_PAYMENT_TERM_SUCCESS';
	var EDIT_PAYMENT_TERM_FAILURE = exports.EDIT_PAYMENT_TERM_FAILURE = 'EDIT_PAYMENT_TERM_FAILURE';
	var REQUEST_GENERAL_REPORT = exports.REQUEST_GENERAL_REPORT = 'REQUEST_GENERAL_REPORT';
	var FETCH_GENERAL_REPORT_SUCCESS = exports.FETCH_GENERAL_REPORT_SUCCESS = 'FETCH_GENERAL_REPORT_SUCCESS';
	var FETCH_GENERAL_REPORT_FAILURE = exports.FETCH_GENERAL_REPORT_FAILURE = 'FETCH_GENERAL_REPORT_FAILURE';
	var REQUEST_CITY_REPORT = exports.REQUEST_CITY_REPORT = 'REQUEST_CITY_REPORT';
	var FETCH_CITY_REPORT_SUCCESS = exports.FETCH_CITY_REPORT_SUCCESS = 'FETCH_CITY_REPORT_SUCCESS';
	var FETCH_CITY_REPORT_FAILURE = exports.FETCH_CITY_REPORT_FAILURE = 'FETCH_CITY_REPORT_FAILURE';
	var RESET_CITY_REPORT = exports.RESET_CITY_REPORT = 'RESET_CITY_REPORT';
	var REQUEST_CUSTOMER_STATEMENT = exports.REQUEST_CUSTOMER_STATEMENT = 'REQUEST_CUSTOMER_STATEMENT';
	var FETCH_CUSTOMER_STATEMENT_SUCCESS = exports.FETCH_CUSTOMER_STATEMENT_SUCCESS = 'FETCH_CUSTOMER_STATEMENT_SUCCESS';
	var FETCH_CUSTOMER_STATEMENT_FAILURE = exports.FETCH_CUSTOMER_STATEMENT_FAILURE = 'FETCH_CUSTOMER_STATEMENT_FAILURE';
	var REQUEST_CUSTOMER_STATEMENT_LIST = exports.REQUEST_CUSTOMER_STATEMENT_LIST = 'REQUEST_CUSTOMER_STATEMENT_LIST';
	var FETCH_CUSTOMER_STATEMENT_LIST_SUCCESS = exports.FETCH_CUSTOMER_STATEMENT_LIST_SUCCESS = 'FETCH_CUSTOMER_STATEMENT_LIST_SUCCESS';
	var FETCH_CUSTOMER_STATEMENT_LIST_FAILURE = exports.FETCH_CUSTOMER_STATEMENT_LIST_FAILURE = 'FETCH_CUSTOMER_STATEMENT_LIST_FAILURE';
	var REQUEST_VENDOR_STATEMENT_LIST = exports.REQUEST_VENDOR_STATEMENT_LIST = 'REQUEST_VENDOR_STATEMENT_LIST';
	var FETCH_VENDOR_STATEMENT_LIST_SUCCESS = exports.FETCH_VENDOR_STATEMENT_LIST_SUCCESS = 'FETCH_VENDOR_STATEMENT_LIST_SUCCESS';
	var FETCH_VENDOR_STATEMENT_LIST_FAILURE = exports.FETCH_VENDOR_STATEMENT_LIST_FAILURE = 'FETCH_VENDOR_STATEMENT_LIST_FAILURE';
	var REQUEST_MOBILE_CUSTOMER_STATEMENT = exports.REQUEST_MOBILE_CUSTOMER_STATEMENT = 'REQUEST_MOBILE_CUSTOMER_STATEMENT';
	var FETCH_MOBILE_CUSTOMER_STATEMENT_SUCCESS = exports.FETCH_MOBILE_CUSTOMER_STATEMENT_SUCCESS = 'FETCH_MOBILE_CUSTOMER_STATEMENT_SUCCESS';
	var FETCH_MOBILE_CUSTOMER_STATEMENT_FAILURE = exports.FETCH_MOBILE_CUSTOMER_STATEMENT_FAILURE = 'FETCH_MOBILE_CUSTOMER_STATEMENT_FAILURE';
	var RESET_MOBILE_CUSTOMER_STATEMENT = exports.RESET_MOBILE_CUSTOMER_STATEMENT = 'RESET_MOBILE_CUSTOMER_STATEMENT';
	
	// Vendor action types
	var REQUEST_VENDORS = exports.REQUEST_VENDORS = 'REQUEST_VENDORS';
	var FETCH_VENDORS_SUCCESS = exports.FETCH_VENDORS_SUCCESS = 'FETCH_VENDORS_SUCCESS';
	var FETCH_VENDORS_FAILURE = exports.FETCH_VENDORS_FAILURE = 'FETCH_VENDORS_FAILURE';
	var SELECT_VENDOR = exports.SELECT_VENDOR = 'SELECT_VENDOR';
	var RESET_CURRENT_VENDOR = exports.RESET_CURRENT_VENDOR = 'RESET_CURRENT_VENDOR';
	var REQUEST_CREATING_VENDOR = exports.REQUEST_CREATING_VENDOR = 'REQUEST_CREATING_VENDOR';
	var CREATE_VENDOR_SUCCESS = exports.CREATE_VENDOR_SUCCESS = 'CREATE_VENDOR_SUCCESS';
	var CREATE_VENDOR_FAILURE = exports.CREATE_VENDOR_FAILURE = 'CREATE_VENDOR_FAILURE';
	var REQUEST_EDITING_VENDOR = exports.REQUEST_EDITING_VENDOR = 'REQUEST_EDITING_VENDOR';
	var EDIT_VENDOR_SUCCESS = exports.EDIT_VENDOR_SUCCESS = 'EDIT_VENDOR_SUCCESS';
	var EDIT_VENDOR_FAILURE = exports.EDIT_VENDOR_FAILURE = 'EDIT_VENDOR_FAILURE';
	var REQUEST_VENDOR_DETAIL = exports.REQUEST_VENDOR_DETAIL = 'REQUEST_VENDOR_DETAIL';
	var REQUEST_VENDOR_STATEMENT = exports.REQUEST_VENDOR_STATEMENT = 'REQUEST_VENDOR_STATEMENT';
	var FETCH_VENDOR_STATEMENT_SUCCESS = exports.FETCH_VENDOR_STATEMENT_SUCCESS = 'FETCH_VENDOR_STATEMENT_SUCCESS';
	var FETCH_VENDOR_STATEMENT_FAILURE = exports.FETCH_VENDOR_STATEMENT_FAILURE = 'FETCH_VENDOR_STATEMENT_FAILURE';
	var FETCH_VENDOR_DETAIL_SUCCESS = exports.FETCH_VENDOR_DETAIL_SUCCESS = 'FETCH_VENDOR_DETAIL_SUCCESS';
	var FETCH_VENDOR_DETAIL_FAILURE = exports.FETCH_VENDOR_DETAIL_FAILURE = 'FETCH_VENDOR_DETAIL_FAILURE';
	var REQUEST_VENDOR_INVENTORY_DETAIL = exports.REQUEST_VENDOR_INVENTORY_DETAIL = 'REQUEST_VENDOR_INVENTORY_DETAIL';
	var FETCH_VENDOR_INVENTORY_DETAIL_SUCCESS = exports.FETCH_VENDOR_INVENTORY_DETAIL_SUCCESS = 'FETCH_VENDOR_INVENTORY_DETAIL_SUCCESS';
	var FETCH_VENDOR_INVENTORY_DETAIL_FAILURE = exports.FETCH_VENDOR_INVENTORY_DETAIL_FAILURE = 'FETCH_VENDOR_INVENTORY_DETAIL_FAILURE';
	var REQUEST_VENDOR_RECORDS = exports.REQUEST_VENDOR_RECORDS = 'REQUEST_VENDOR_RECORDS';
	var FETCH_VENDOR_RECORDS_SUCCESS = exports.FETCH_VENDOR_RECORDS_SUCCESS = 'FETCH_VENDOR_RECORDS_SUCCESS';
	var FETCH_VENDOR_RECORDS_FAILURE = exports.FETCH_VENDOR_RECORDS_FAILURE = 'FETCH_VENDOR_RECORDS_FAILURE';
	
	// Agent action types
	var REQUEST_AGENTS = exports.REQUEST_AGENTS = 'REQUEST_AGENTS';
	var FETCH_AGENTS_SUCCESS = exports.FETCH_AGENTS_SUCCESS = 'FETCH_AGENTS_SUCCESS';
	var FETCH_AGENTS_FAILURE = exports.FETCH_AGENTS_FAILURE = 'FETCH_AGENTS_FAILURE';
	var SELECT_AGENT = exports.SELECT_AGENT = 'SELECT_AGENT';
	var RESET_CURRENT_AGENT = exports.RESET_CURRENT_AGENT = 'RESET_CURRENT_AGENT';
	var REQUEST_CREATING_AGENT = exports.REQUEST_CREATING_AGENT = 'REQUEST_CREATING_AGENT';
	var CREATE_AGENT_SUCCESS = exports.CREATE_AGENT_SUCCESS = 'CREATE_AGENT_SUCCESS';
	var CREATE_AGENT_FAILURE = exports.CREATE_AGENT_FAILURE = 'CREATE_AGENT_FAILURE';
	var REQUEST_EDITING_AGENT = exports.REQUEST_EDITING_AGENT = 'REQUEST_EDITING_AGENT';
	var EDIT_AGENT_SUCCESS = exports.EDIT_AGENT_SUCCESS = 'EDIT_AGENT_SUCCESS';
	var EDIT_AGENT_FAILURE = exports.EDIT_AGENT_FAILURE = 'EDIT_AGENT_FAILURE';
	var REQUEST_AGENT_DETAIL = exports.REQUEST_AGENT_DETAIL = 'REQUEST_AGENT_DETAIL';
	var FETCH_AGENT_DETAIL_SUCCESS = exports.FETCH_AGENT_DETAIL_SUCCESS = 'FETCH_AGENT_DETAIL_SUCCESS';
	var FETCH_AGENT_DETAIL_FAILURE = exports.FETCH_AGENT_DETAIL_FAILURE = 'FETCH_AGENT_DETAIL_FAILURE';
	
	// Auth action types
	var REQUEST_AUTH = exports.REQUEST_AUTH = 'REQUEST_AUTH';
	var AUTH_USER = exports.AUTH_USER = 'AUTH_USER';
	var AUTH_USER_PERMISSIONS = exports.AUTH_USER_PERMISSIONS = 'AUTH_USER_PERMISSIONS';
	var UNAUTH_USER = exports.UNAUTH_USER = 'UNAUTH_USER';
	var AUTH_ERROR = exports.AUTH_ERROR = 'AUTH_ERROR';
	var FETCH_MESSAGE = exports.FETCH_MESSAGE = 'FETCH_MESSAGE';
	
	// Purchase Quote action types
	var REQUEST_PURCHASE_QUOTES = exports.REQUEST_PURCHASE_QUOTES = 'REQUEST_PURCHASE_QUOTES';
	var FETCH_PURCHASE_QUOTES_SUCCESS = exports.FETCH_PURCHASE_QUOTES_SUCCESS = 'FETCH_PURCHASE_QUOTES_SUCCESS';
	var FETCH_PURCHASE_QUOTES_FAILURE = exports.FETCH_PURCHASE_QUOTES_FAILURE = 'FETCH_PURCHASE_QUOTES_FAILURE';
	var SELECT_PURCHASE_QUOTE = exports.SELECT_PURCHASE_QUOTE = 'SELECT_PURCHASE_QUOTE';
	var RESET_CURRENT_PURCHASE_QUOTE = exports.RESET_CURRENT_PURCHASE_QUOTE = 'RESET_CURRENT_PURCHASE_QUOTE';
	var REQUEST_PURCHASE_QUOTE_DETAIL = exports.REQUEST_PURCHASE_QUOTE_DETAIL = 'REQUEST_PURCHASE_QUOTE_DETAIL';
	var FETCH_PURCHASE_QUOTE_DETAIL_SUCCESS = exports.FETCH_PURCHASE_QUOTE_DETAIL_SUCCESS = 'FETCH_PURCHASE_QUOTE_DETAIL_SUCCESS';
	var FETCH_PURCHASE_QUOTE_DETAIL_FAILURE = exports.FETCH_PURCHASE_QUOTE_DETAIL_FAILURE = 'FETCH_PURCHASE_QUOTE_DETAIL_FAILURE';
	var REQUEST_CREATING_PURCHASE_QUOTE = exports.REQUEST_CREATING_PURCHASE_QUOTE = 'REQUEST_CREATING_PURCHASE_QUOTE';
	var CREATE_PURCHASE_QUOTE_SUCCESS = exports.CREATE_PURCHASE_QUOTE_SUCCESS = 'CREATE_PURCHASE_QUOTE_SUCCESS';
	var CREATE_PURCHASE_QUOTE_FAILURE = exports.CREATE_PURCHASE_QUOTE_FAILURE = 'CREATE_PURCHASE_QUOTE_FAILURE';
	var REQUEST_PURCHASE_QUOTE_PLACE = exports.REQUEST_PURCHASE_QUOTE_PLACE = 'REQUEST_PURCHASE_QUOTE_PLACE';
	var PURCHASE_QUOTE_PLACE_SUCCESS = exports.PURCHASE_QUOTE_PLACE_SUCCESS = 'PURCHASE_QUOTE_PLACE_SUCCESS';
	var PURCHASE_QUOTE_PLACE_FAILURE = exports.PURCHASE_QUOTE_PLACE_FAILURE = 'PURCHASE_QUOTE_PLACE_FAILURE';
	var REQUEST_EDITING_PURCHASE_QUOTE = exports.REQUEST_EDITING_PURCHASE_QUOTE = 'REQUEST_EDITING_PURCHASE_QUOTE';
	var EDIT_PURCHASE_QUOTE_SUCCESS = exports.EDIT_PURCHASE_QUOTE_SUCCESS = 'EDIT_PURCHASE_QUOTE_SUCCESS';
	var EDIT_PURCHASE_QUOTE_FAILURE = exports.EDIT_PURCHASE_QUOTE_FAILURE = 'EDIT_PURCHASE_QUOTE_FAILURE';
	var REQUEST_NUM_PURCHASE_QUOTES = exports.REQUEST_NUM_PURCHASE_QUOTES = 'REQUEST_NUM_PURCHASE_QUOTES';
	var FETCH_NUM_PURCHASE_QUOTES_SUCCESS = exports.FETCH_NUM_PURCHASE_QUOTES_SUCCESS = 'FETCH_NUM_PURCHASE_QUOTES_SUCCESS';
	var FETCH_NUM_PURCHASE_QUOTES_FAILURE = exports.FETCH_NUM_PURCHASE_QUOTES_FAILURE = 'FETCH_NUM_PURCHASE_QUOTES_FAILURE';
	var REQUEST_TODAYS_INCOMING_ORDERS = exports.REQUEST_TODAYS_INCOMING_ORDERS = 'REQUEST_TODAYS_INCOMING_ORDERS';
	var FETCH_TODAYS_INCOMING_ORDERS_SUCCESS = exports.FETCH_TODAYS_INCOMING_ORDERS_SUCCESS = 'FETCH_TODAYS_INCOMING_ORDERS_SUCCESS';
	var FETCH_TODAYS_INCOMING_ORDERS_FAILURE = exports.FETCH_TODAYS_INCOMING_ORDERS_FAILURE = 'FETCH_TODAYS_INCOMING_ORDERS_FAILURE';
	var REQUEST_DELETE_PURCHASE_QUOTE = exports.REQUEST_DELETE_PURCHASE_QUOTE = 'REQUEST_DELETE_PURCHASE_QUOTE';
	var DELETE_PURCHASE_QUOTE_SUCCESS = exports.DELETE_PURCHASE_QUOTE_SUCCESS = 'DELETE_PURCHASE_QUOTE_SUCCESS';
	var DELETE_PURCHASE_QUOTE_FAILURE = exports.DELETE_PURCHASE_QUOTE_FAILURE = 'DELETE_PURCHASE_QUOTE_FAILURE';
	
	// Purchase Template action types
	var REQUEST_PURCHASE_TEMPLATES = exports.REQUEST_PURCHASE_TEMPLATES = 'REQUEST_PURCHASE_TEMPLATES';
	var FETCH_PURCHASE_TEMPLATES_SUCCESS = exports.FETCH_PURCHASE_TEMPLATES_SUCCESS = 'FETCH_PURCHASE_TEMPLATES_SUCCESS';
	var FETCH_PURCHASE_TEMPLATES_FAILURE = exports.FETCH_PURCHASE_TEMPLATES_FAILURE = 'FETCH_PURCHASE_TEMPLATES_FAILURE';
	var SELECT_PURCHASE_TEMPLATE = exports.SELECT_PURCHASE_TEMPLATE = 'SELECT_PURCHASE_TEMPLATE';
	var RESET_CURRENT_PURCHASE_TEMPLATE = exports.RESET_CURRENT_PURCHASE_TEMPLATE = 'RESET_CURRENT_PURCHASE_TEMPLATE';
	var REQUEST_PURCHASE_TEMPLATE_DETAIL = exports.REQUEST_PURCHASE_TEMPLATE_DETAIL = 'REQUEST_PURCHASE_TEMPLATE_DETAIL';
	var FETCH_PURCHASE_TEMPLATE_DETAIL_SUCCESS = exports.FETCH_PURCHASE_TEMPLATE_DETAIL_SUCCESS = 'FETCH_PURCHASE_TEMPLATE_DETAIL_SUCCESS';
	var FETCH_PURCHASE_TEMPLATE_DETAIL_FAILURE = exports.FETCH_PURCHASE_TEMPLATE_DETAIL_FAILURE = 'FETCH_PURCHASE_TEMPLATE_DETAIL_FAILURE';
	var REQUEST_CREATING_PURCHASE_TEMPLATE = exports.REQUEST_CREATING_PURCHASE_TEMPLATE = 'REQUEST_CREATING_PURCHASE_TEMPLATE';
	var CREATE_PURCHASE_TEMPLATE_SUCCESS = exports.CREATE_PURCHASE_TEMPLATE_SUCCESS = 'CREATE_PURCHASE_TEMPLATE_SUCCESS';
	var CREATE_PURCHASE_TEMPLATE_FAILURE = exports.CREATE_PURCHASE_TEMPLATE_FAILURE = 'CREATE_PURCHASE_TEMPLATE_FAILURE';
	var REQUEST_EDITING_PURCHASE_TEMPLATE = exports.REQUEST_EDITING_PURCHASE_TEMPLATE = 'REQUEST_EDITING_PURCHASE_TEMPLATE';
	var EDIT_PURCHASE_TEMPLATE_SUCCESS = exports.EDIT_PURCHASE_TEMPLATE_SUCCESS = 'EDIT_PURCHASE_TEMPLATE_SUCCESS';
	var EDIT_PURCHASE_TEMPLATE_FAILURE = exports.EDIT_PURCHASE_TEMPLATE_FAILURE = 'EDIT_PURCHASE_TEMPLATE_FAILURE';
	var RESET_CURRENT_PURCHASE_PRODUCT = exports.RESET_CURRENT_PURCHASE_PRODUCT = 'RESET_CURRENT_PURCHASE_PRODUCT';
	var DELETE_PURCHASE_TEMPLATE = exports.DELETE_PURCHASE_TEMPLATE = 'DELETE_PURCHASE_TEMPLATE';
	var DELETE_PURCHASE_TEMPLATE_SUCCESS = exports.DELETE_PURCHASE_TEMPLATE_SUCCESS = 'DELETE_PURCHASE_TEMPLATE_SUCCESS';
	var DELETE_PURCHASE_TEMPLATE_FAILURE = exports.DELETE_PURCHASE_TEMPLATE_FAILURE = 'DELETE_PURCHASE_TEMPLATE_FAILURE';
	var REQUEST_PURCHASE_TEMPLATE_LIST = exports.REQUEST_PURCHASE_TEMPLATE_LIST = 'REQUEST_PURCHASE_TEMPLATE_LIST';
	var FETCH_PURCHASE_TEMPLATE_LIST_SUCCESS = exports.FETCH_PURCHASE_TEMPLATE_LIST_SUCCESS = 'FETCH_PURCHASE_TEMPLATE_LIST_SUCCESS';
	var FETCH_PURCHASE_TEMPLATE_LIST_FAILURE = exports.FETCH_PURCHASE_TEMPLATE_LIST_FAILURE = 'FETCH_PURCHASE_TEMPLATE_LIST_FAILURE';
	
	// Purchase Schedule action types
	var REQUEST_PURCHASE_SCHEDULES = exports.REQUEST_PURCHASE_SCHEDULES = 'REQUEST_PURCHASE_SCHEDULES';
	var FETCH_PURCHASE_SCHEDULES_SUCCESS = exports.FETCH_PURCHASE_SCHEDULES_SUCCESS = 'FETCH_PURCHASE_SCHEDULES_SUCCESS';
	var FETCH_PURCHASE_SCHEDULES_FAILURE = exports.FETCH_PURCHASE_SCHEDULES_FAILURE = 'FETCH_PURCHASE_SCHEDULES_FAILURE';
	var SELECT_PURCHASE_SCHEDULE = exports.SELECT_PURCHASE_SCHEDULE = 'SELECT_PURCHASE_SCHEDULE';
	var RESET_CURRENT_PURCHASE_SCHEDULE = exports.RESET_CURRENT_PURCHASE_SCHEDULE = 'RESET_CURRENT_PURCHASE_SCHEDULE';
	var REQUEST_PURCHASE_SCHEDULE_DETAIL = exports.REQUEST_PURCHASE_SCHEDULE_DETAIL = 'REQUEST_PURCHASE_SCHEDULE_DETAIL';
	var FETCH_PURCHASE_SCHEDULE_DETAIL_SUCCESS = exports.FETCH_PURCHASE_SCHEDULE_DETAIL_SUCCESS = 'FETCH_PURCHASE_SCHEDULE_DETAIL_SUCCESS';
	var FETCH_PURCHASE_SCHEDULE_DETAIL_FAILURE = exports.FETCH_PURCHASE_SCHEDULE_DETAIL_FAILURE = 'FETCH_PURCHASE_SCHEDULE_DETAIL_FAILURE';
	var REQUEST_CREATING_PURCHASE_SCHEDULE = exports.REQUEST_CREATING_PURCHASE_SCHEDULE = 'REQUEST_CREATING_PURCHASE_SCHEDULE';
	var CREATE_PURCHASE_SCHEDULE_SUCCESS = exports.CREATE_PURCHASE_SCHEDULE_SUCCESS = 'CREATE_PURCHASE_SCHEDULE_SUCCESS';
	var CREATE_PURCHASE_SCHEDULE_FAILURE = exports.CREATE_PURCHASE_SCHEDULE_FAILURE = 'CREATE_PURCHASE_SCHEDULE_FAILURE';
	var REQUEST_EDITING_PURCHASE_SCHEDULE = exports.REQUEST_EDITING_PURCHASE_SCHEDULE = 'REQUEST_EDITING_PURCHASE_SCHEDULE';
	var EDIT_PURCHASE_SCHEDULE_SUCCESS = exports.EDIT_PURCHASE_SCHEDULE_SUCCESS = 'EDIT_PURCHASE_SCHEDULE_SUCCESS';
	var EDIT_PURCHASE_SCHEDULE_FAILURE = exports.EDIT_PURCHASE_SCHEDULE_FAILURE = 'EDIT_PURCHASE_SCHEDULE_FAILURE';
	
	// Purchase Return action types
	var REQUEST_PURCHASE_RETURNS = exports.REQUEST_PURCHASE_RETURNS = 'REQUEST_PURCHASE_RETURNS';
	var FETCH_PURCHASE_RETURNS_SUCCESS = exports.FETCH_PURCHASE_RETURNS_SUCCESS = 'FETCH_PURCHASE_RETURNS_SUCCESS';
	var FETCH_PURCHASE_RETURNS_FAILURE = exports.FETCH_PURCHASE_RETURNS_FAILURE = 'FETCH_PURCHASE_RETURNS_FAILURE';
	var SELECT_PURCHASE_RETURN = exports.SELECT_PURCHASE_RETURN = 'SELECT_PURCHASE_RETURN';
	// export const SELECT_PURCHASE_RETURN_VENDOR = 'SELECT_PURCHASE_RETURN_VENDOR';
	var RESET_CURRENT_PURCHASE_RETURN = exports.RESET_CURRENT_PURCHASE_RETURN = 'RESET_CURRENT_PURCHASE_RETURN';
	var REQUEST_PURCHASE_RETURN_DETAIL = exports.REQUEST_PURCHASE_RETURN_DETAIL = 'REQUEST_PURCHASE_RETURN_DETAIL';
	var FETCH_PURCHASE_RETURN_DETAIL_SUCCESS = exports.FETCH_PURCHASE_RETURN_DETAIL_SUCCESS = 'FETCH_PURCHASE_RETURN_DETAIL_SUCCESS';
	var FETCH_PURCHASE_RETURN_DETAIL_FAILURE = exports.FETCH_PURCHASE_RETURN_DETAIL_FAILURE = 'FETCH_PURCHASE_RETURN_DETAIL_FAILURE';
	var REQUEST_CREATING_PURCHASE_RETURN = exports.REQUEST_CREATING_PURCHASE_RETURN = 'REQUEST_CREATING_PURCHASE_RETURN';
	var CREATE_PURCHASE_RETURN_SUCCESS = exports.CREATE_PURCHASE_RETURN_SUCCESS = 'CREATE_PURCHASE_RETURN_SUCCESS';
	var CREATE_PURCHASE_RETURN_FAILURE = exports.CREATE_PURCHASE_RETURN_FAILURE = 'CREATE_PURCHASE_RETURN_FAILURE';
	var REQUEST_EDITING_PURCHASE_RETURN = exports.REQUEST_EDITING_PURCHASE_RETURN = 'REQUEST_EDITING_PURCHASE_RETURN';
	var EDIT_PURCHASE_RETURN_SUCCESS = exports.EDIT_PURCHASE_RETURN_SUCCESS = 'EDIT_PURCHASE_RETURN_SUCCESS';
	var EDIT_PURCHASE_RETURN_FAILURE = exports.EDIT_PURCHASE_RETURN_FAILURE = 'EDIT_PURCHASE_RETURN_FAILURE';
	var COMPLETE_PURCHASE_RETURN = exports.COMPLETE_PURCHASE_RETURN = 'COMPLETE_PURCHASE_RETURN';
	var COMPLETE_PURCHASE_RETURN_SUCCESS = exports.COMPLETE_PURCHASE_RETURN_SUCCESS = 'COMPLETE_PURCHASE_RETURN_SUCCESS';
	var COMPLETE_PURCHASE_RETURN_FAILURE = exports.COMPLETE_PURCHASE_RETURN_FAILURE = 'COMPLETE_PURCHASE_RETURN_FAILURE';
	var REQUEST_PURCHASE_RETURN_PDF = exports.REQUEST_PURCHASE_RETURN_PDF = 'REQUEST_PURCHASE_RETURN_PDF';
	var FETCH_PURCHASE_RETURN_PDF_SUCCESS = exports.FETCH_PURCHASE_RETURN_PDF_SUCCESS = 'FETCH_PURCHASE_RETURN_PDF_SUCCESS';
	var REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL = exports.REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL = 'REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL';
	var REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL_SUCCESS = exports.REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL_SUCCESS = 'REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL_SUCCESS';
	var REQUEST_VOID_PURCHASE_RETURN = exports.REQUEST_VOID_PURCHASE_RETURN = 'REQUEST_VOID_PURCHASE_RETURN';
	var VOID_PURCHASE_RETURN_SUCCESS = exports.VOID_PURCHASE_RETURN_SUCCESS = 'VOID_PURCHASE_RETURN_SUCCESS';
	var VOID_PURCHASE_RETURN_FAILURE = exports.VOID_PURCHASE_RETURN_FAILURE = 'VOID_PURCHASE_RETURN_FAILURE';
	
	// Purchase Order action types
	var REQUEST_PURCHASE_ORDERS = exports.REQUEST_PURCHASE_ORDERS = 'REQUEST_PURCHASE_ORDERS';
	var FETCH_PURCHASE_ORDERS_SUCCESS = exports.FETCH_PURCHASE_ORDERS_SUCCESS = 'FETCH_PURCHASE_ORDERS_SUCCESS';
	var FETCH_PURCHASE_ORDERS_FAILURE = exports.FETCH_PURCHASE_ORDERS_FAILURE = 'FETCH_PURCHASE_ORDERS_FAILURE';
	var REQUEST_PURCHASE_ORDERS_BY_FILTER = exports.REQUEST_PURCHASE_ORDERS_BY_FILTER = 'REQUEST_PURCHASE_ORDERS_BY_FILTER';
	var SELECT_PURCHASE_ORDER = exports.SELECT_PURCHASE_ORDER = 'SELECT_PURCHASE_ORDER';
	var RESET_CURRENT_PURCHASE_ORDER = exports.RESET_CURRENT_PURCHASE_ORDER = 'RESET_CURRENT_PURCHASE_ORDER';
	var REQUEST_PURCHASE_ORDER_DETAIL = exports.REQUEST_PURCHASE_ORDER_DETAIL = 'REQUEST_PURCHASE_ORDER_DETAIL';
	var FETCH_PURCHASE_ORDER_DETAIL_SUCCESS = exports.FETCH_PURCHASE_ORDER_DETAIL_SUCCESS = 'FETCH_PURCHASE_ORDER_DETAIL_SUCCESS';
	var FETCH_PURCHASE_ORDER_DETAIL_FAILURE = exports.FETCH_PURCHASE_ORDER_DETAIL_FAILURE = 'FETCH_PURCHASE_ORDER_DETAIL_FAILURE';
	var REQUEST_CREATING_PURCHASE_ORDER = exports.REQUEST_CREATING_PURCHASE_ORDER = 'REQUEST_CREATING_PURCHASE_ORDER';
	var CREATE_PURCHASE_ORDER_SUCCESS = exports.CREATE_PURCHASE_ORDER_SUCCESS = 'CREATE_PURCHASE_ORDER_SUCCESS';
	var CREATE_PURCHASE_ORDER_FAILURE = exports.CREATE_PURCHASE_ORDER_FAILURE = 'CREATE_PURCHASE_ORDER_FAILURE';
	var REQUEST_EDITING_PURCHASE_ORDER = exports.REQUEST_EDITING_PURCHASE_ORDER = 'REQUEST_EDITING_PURCHASE_ORDER';
	var EDIT_PURCHASE_ORDER_SUCCESS = exports.EDIT_PURCHASE_ORDER_SUCCESS = 'EDIT_PURCHASE_ORDER_SUCCESS';
	var EDIT_PURCHASE_ORDER_FAILURE = exports.EDIT_PURCHASE_ORDER_FAILURE = 'EDIT_PURCHASE_ORDER_FAILURE';
	var REQUEST_PURCHASE_ORDERS_NOT_RECEIVED = exports.REQUEST_PURCHASE_ORDERS_NOT_RECEIVED = 'REQUEST_PURCHASE_ORDERS_NOT_RECEIVED';
	var FETCH_PURCHASE_ORDERS_NOT_RECEIVED_SUCCESS = exports.FETCH_PURCHASE_ORDERS_NOT_RECEIVED_SUCCESS = 'FETCH_PURCHASE_ORDERS_NOT_RECEIVED_SUCCESS';
	var FETCH_PURCHASE_ORDERS_NOT_RECEIVED_FAILURE = exports.FETCH_PURCHASE_ORDERS_NOT_RECEIVED_FAILURE = 'FETCH_PURCHASE_ORDERS_NOT_RECEIVED_FAILURE';
	var REQUEST_TOTAL_PURCHASES = exports.REQUEST_TOTAL_PURCHASES = 'REQUEST_TOTAL_PURCHASES';
	var FETCH_TOTAL_PURCHASES_SUCCESS = exports.FETCH_TOTAL_PURCHASES_SUCCESS = 'FETCH_TOTAL_PURCHASES_SUCCESS';
	var FETCH_TOTAL_PURCHASES_FAILURE = exports.FETCH_TOTAL_PURCHASES_FAILURE = 'FETCH_TOTAL_PURCHASES_FAILURE';
	var REQUEST_PRINT_PURCHASE_ORDER = exports.REQUEST_PRINT_PURCHASE_ORDER = 'REQUEST_PRINT_PURCHASE_ORDER';
	var PRINT_PURCHASE_ORDER_SUCCESS = exports.PRINT_PURCHASE_ORDER_SUCCESS = 'PRINT_PURCHASE_ORDER_SUCCESS';
	var PRINT_PURCHASE_ORDER_FAILURE = exports.PRINT_PURCHASE_ORDER_FAILURE = 'PRINT_PURCHASE_ORDER_FAILURE';
	var REQUEST_DELETE_PURCHASE_ORDER = exports.REQUEST_DELETE_PURCHASE_ORDER = 'REQUEST_DELETE_PURCHASE_ORDER';
	var DELETE_PURCHASE_ORDER_SUCCESS = exports.DELETE_PURCHASE_ORDER_SUCCESS = 'DELETE_PURCHASE_ORDER_SUCCESS';
	var DELETE_PURCHASE_ORDER_FAILURE = exports.DELETE_PURCHASE_ORDER_FAILURE = 'DELETE_PURCHASE_ORDER_FAILURE';
	var REQUEST_PURCHASE_ORDER_PERFORMANCE = exports.REQUEST_PURCHASE_ORDER_PERFORMANCE = 'REQUEST_PURCHASE_ORDER_PERFORMANCE';
	var FETCH_PURCHASE_ORDER_PERFORMANCE_SUCCESS = exports.FETCH_PURCHASE_ORDER_PERFORMANCE_SUCCESS = 'FETCH_PURCHASE_ORDER_PERFORMANCE_SUCCESS';
	var FETCH_PURCHASE_ORDER_PERFORMANCE_FAILURE = exports.FETCH_PURCHASE_ORDER_PERFORMANCE_FAILURE = 'FETCH_PURCHASE_ORDER_PERFORMANCE_FAILURE';
	var REQUEST_PURCHASE_MANAGER_INFO = exports.REQUEST_PURCHASE_MANAGER_INFO = 'REQUEST_PURCHASE_MANAGER_INFO';
	var FETCH_PURCHASE_MANAGER_INFO_SUCCESS = exports.FETCH_PURCHASE_MANAGER_INFO_SUCCESS = 'FETCH_PURCHASE_MANAGER_INFO_SUCCESS';
	var FETCH_PURCHASE_MANAGER_INFO_FAILURE = exports.FETCH_PURCHASE_MANAGER_INFO_FAILURE = 'FETCH_PURCHASE_MANAGER_INFO_FAILURE';
	var REQUEST_LAST_MONTH_PERFORMANCE = exports.REQUEST_LAST_MONTH_PERFORMANCE = 'REQUEST_LAST_MONTH_PERFORMANCE';
	var FETCH_LAST_MONTH_PERFORMANCE_SUCCESS = exports.FETCH_LAST_MONTH_PERFORMANCE_SUCCESS = 'FETCH_LAST_MONTH_PERFORMANCE_SUCCESS';
	var FETCH_LAST_MONTH_PERFORMANCE_FAILURE = exports.FETCH_LAST_MONTH_PERFORMANCE_FAILURE = 'FETCH_LAST_MONTH_PERFORMANCE_FAILURE';
	var REQUEST_PURCHASERS_PERFORMANCE = exports.REQUEST_PURCHASERS_PERFORMANCE = 'REQUEST_PURCHASERS_PERFORMANCE';
	var FETCH_PURCHASERS_PERFORMANCE_SUCCESS = exports.FETCH_PURCHASERS_PERFORMANCE_SUCCESS = 'FETCH_PURCHASERS_PERFORMANCE_SUCCESS';
	var FETCH_PURCHASERS_PERFORMANCE_FAILURE = exports.FETCH_PURCHASERS_PERFORMANCE_FAILURE = 'FETCH_PURCHASERS_PERFORMANCE_FAILURE';
	var REQUEST_PRESIDENT_DASH_INFO = exports.REQUEST_PRESIDENT_DASH_INFO = 'REQUEST_PRESIDENT_DASH_INFO';
	var FETCH_PRESIDENT_DASH_INFO_SUCCESS = exports.FETCH_PRESIDENT_DASH_INFO_SUCCESS = 'FETCH_PRESIDENT_DASH_INFO_SUCCESS';
	var FETCH_PRESIDENT_DASH_INFO_FAILURE = exports.FETCH_PRESIDENT_DASH_INFO_FAILURE = 'FETCH_PRESIDENT_DASH_INFO_FAILURE';
	var REQUEST_OVERALL_PURCHASE_PERFORMANCE = exports.REQUEST_OVERALL_PURCHASE_PERFORMANCE = 'REQUEST_OVERALL_PURCHASE_PERFORMANCE';
	var FETCH_OVERALL_PURCHASE_PERFORMANCE_SUCCESS = exports.FETCH_OVERALL_PURCHASE_PERFORMANCE_SUCCESS = 'FETCH_OVERALL_PURCHASE_PERFORMANCE_SUCCESS';
	var FETCH_OVERALL_PURCHASE_PERFORMANCE_FAILURE = exports.FETCH_OVERALL_PURCHASE_PERFORMANCE_FAILURE = 'FETCH_OVERALL_PURCHASE_PERFORMANCE_FAILURE';
	var REQUEST_INCIDENT_REPORT = exports.REQUEST_INCIDENT_REPORT = 'REQUEST_INCIDENT_REPORT';
	var FETCH_INCIDENT_REPORT_SUCCESS = exports.FETCH_INCIDENT_REPORT_SUCCESS = 'FETCH_INCIDENT_REPORT_SUCCESS';
	var FETCH_INCIDENT_REPORT_FAILURE = exports.FETCH_INCIDENT_REPORT_FAILURE = 'FETCH_INCIDENT_REPORT_FAILURE';
	var REQUEST_PURCHASE_ORDER_LIST = exports.REQUEST_PURCHASE_ORDER_LIST = 'REQUEST_PURCHASE_ORDER_LIST';
	var FETCH_PURCHASE_ORDER_LIST_SUCCESS = exports.FETCH_PURCHASE_ORDER_LIST_SUCCESS = 'FETCH_PURCHASE_ORDER_LIST_SUCCESS';
	var FETCH_PURCHASE_ORDER_LIST_FAILURE = exports.FETCH_PURCHASE_ORDER_LIST_FAILURE = 'FETCH_PURCHASE_ORDER_LIST_FAILURE';
	var SET_PURCHASE_ORDERS_FILTER = exports.SET_PURCHASE_ORDERS_FILTER = 'SET_PURCHASE_ORDERS_FILTER';
	var REQUEST_PURCHASING_PERFORMANCE = exports.REQUEST_PURCHASING_PERFORMANCE = 'REQUEST_PURCHASING_PERFORMANCE';
	var REQUEST_PURCHASING_PERFORMANCE_BY_FILTER = exports.REQUEST_PURCHASING_PERFORMANCE_BY_FILTER = 'REQUEST_PURCHASING_PERFORMANCE_BY_FILTER';
	var FETCH_PURCHASING_PERFORMANCE_SUCCESS = exports.FETCH_PURCHASING_PERFORMANCE_SUCCESS = 'FETCH_PURCHASING_PERFORMANCE_SUCCESS';
	var FETCH_PURCHASING_PERFORMANCE_FAILURE = exports.FETCH_PURCHASING_PERFORMANCE_FAILURE = 'FETCH_PURCHASING_PERFORMANCE_FAILURE';
	var REQUEST_PRICE_ADJUSTMENT = exports.REQUEST_PRICE_ADJUSTMENT = 'REQUEST_PRICE_ADJUSTMENT';
	var FETCH_PRICE_ADJUSTMENT_SUCCESS = exports.FETCH_PRICE_ADJUSTMENT_SUCCESS = 'FETCH_PRICE_ADJUSTMENT_SUCCESS';
	var FETCH_PRICE_ADJUSTMENT_FAILURE = exports.FETCH_PRICE_ADJUSTMENT_FAILURE = 'FETCH_PRICE_ADJUSTMENT_FAILURE';
	var CREATE_PRICE_ADJUSTMENT = exports.CREATE_PRICE_ADJUSTMENT = 'CREATE_PRICE_ADJUSTMENT';
	var CREATE_PRICE_ADJUSTMENT_SUCCESS = exports.CREATE_PRICE_ADJUSTMENT_SUCCESS = 'CREATE_PRICE_ADJUSTMENT_SUCCESS';
	var CREATE_PRICE_ADJUSTMENT_FAILURE = exports.CREATE_PRICE_ADJUSTMENT_FAILURE = 'CREATE_PRICE_ADJUSTMENT_FAILURE';
	var REQUEST_PURCHASE_PIVOT_CHART_ORDERS = exports.REQUEST_PURCHASE_PIVOT_CHART_ORDERS = 'REQUEST_PURCHASE_PIVOT_CHART_ORDERS';
	var FETCH_PURCHASE_PIVOT_CHART_ORDERS_SUCCESS = exports.FETCH_PURCHASE_PIVOT_CHART_ORDERS_SUCCESS = 'FETCH_PURCHASE_PIVOT_CHART_ORDERS_SUCCESS';
	var FETCH_PURCHASE_PIVOT_CHART_ORDERS_FAILURE = exports.FETCH_PURCHASE_PIVOT_CHART_ORDERS_FAILURE = 'FETCH_PURCHASE_PIVOT_CHART_ORDERS_FAILURE';
	var REQUEST_PURCHASE_PIVOT_CHARTS = exports.REQUEST_PURCHASE_PIVOT_CHARTS = 'REQUEST_PURCHASE_PIVOT_CHARTS';
	var FETCH_PURCHASE_PIVOT_CHARTS_SUCCESS = exports.FETCH_PURCHASE_PIVOT_CHARTS_SUCCESS = 'FETCH_PURCHASE_PIVOT_CHARTS_SUCCESS';
	var FETCH_PURCHASE_PIVOT_CHARTS_FAILURE = exports.FETCH_PURCHASE_PIVOT_CHARTS_FAILURE = 'FETCH_PURCHASE_PIVOT_CHARTS_FAILURE';
	var REQUEST_PURCHASE_PIVOT_CHARTS_DETAIL = exports.REQUEST_PURCHASE_PIVOT_CHARTS_DETAIL = 'REQUEST_PURCHASE_PIVOT_CHARTS_DETAIL';
	var FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_SUCCESS = exports.FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_SUCCESS = 'FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_SUCCESS';
	var FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_FAILURE = exports.FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_FAILURE = 'FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_FAILURE';
	var SET_PURCHASE_PIVOT_ID = exports.SET_PURCHASE_PIVOT_ID = 'SET_PURCHASE_PIVOT_ID';
	var RESET_PURCHASE_PIVOT_CHARTS = exports.RESET_PURCHASE_PIVOT_CHARTS = 'RESET_PURCHASE_PIVOT_CHARTS';
	var CREATE_PURCHASE_PIVOT_CHART = exports.CREATE_PURCHASE_PIVOT_CHART = 'CREATE_PURCHASE_PIVOT_CHART';
	var CREATE_PURCHASE_PIVOT_CHART_SUCCESS = exports.CREATE_PURCHASE_PIVOT_CHART_SUCCESS = 'CREATE_PURCHASE_PIVOT_CHART_SUCCESS';
	var CREATE_PURCHASE_PIVOT_CHART_FAILURE = exports.CREATE_PURCHASE_PIVOT_CHART_FAILURE = 'CREATE_PURCHASE_PIVOT_CHART_FAILURE';
	var DUPLICATE_PURCHASE_PIVOT_CHART = exports.DUPLICATE_PURCHASE_PIVOT_CHART = 'DUPLICATE_PURCHASE_PIVOT_CHART';
	var DUPLICATE_PURCHASE_PIVOT_CHART_SUCCESS = exports.DUPLICATE_PURCHASE_PIVOT_CHART_SUCCESS = 'DUPLICATE_PURCHASE_PIVOT_CHART_SUCCESS';
	var DUPLICATE_PURCHASE_PIVOT_CHART_FAILURE = exports.DUPLICATE_PURCHASE_PIVOT_CHART_FAILURE = 'DUPLICATE_PURCHASE_PIVOT_CHART_FAILURE';
	var CLEAR_DUPLICATED_PURCHASE_PIVOT_CHART = exports.CLEAR_DUPLICATED_PURCHASE_PIVOT_CHART = 'CLEAR_DUPLICATED_PURCHASE_PIVOT_CHART';
	var REQUEST_PURCHASE_REFERENCE_PDF = exports.REQUEST_PURCHASE_REFERENCE_PDF = 'REQUEST_PURCHASE_REFERENCE_PDF';
	var FETCH_PURCHASE_REFERENCE_PDF_SUCCESS = exports.FETCH_PURCHASE_REFERENCE_PDF_SUCCESS = 'FETCH_PURCHASE_REFERENCE_PDF_SUCCESS';
	var REQUEST_PURCHASING_REFERENCE = exports.REQUEST_PURCHASING_REFERENCE = 'REQUEST_PURCHASING_REFERENCE';
	var FETCH_PURCHASING_REFERENCE_SUCCESS = exports.FETCH_PURCHASING_REFERENCE_SUCCESS = 'FETCH_PURCHASING_REFERENCE_SUCCESS';
	var FETCH_PURCHASING_REFERENCE_FAILURE = exports.FETCH_PURCHASING_REFERENCE_FAILURE = 'FETCH_PURCHASING_REFERENCE_FAILURE';
	var REQUEST_PURCHASE_PAYMENT_NOT_PAID = exports.REQUEST_PURCHASE_PAYMENT_NOT_PAID = 'REQUEST_PURCHASE_PAYMENT_NOT_PAID';
	var FETCH_PURCHASE_PAYMENT_NOT_PAID_SUCCESS = exports.FETCH_PURCHASE_PAYMENT_NOT_PAID_SUCCESS = 'FETCH_PURCHASE_PAYMENT_NOT_PAID_SUCCESS';
	var FETCH_PURCHASE_PAYMENT_NOT_PAID_FAILURE = exports.FETCH_PURCHASE_PAYMENT_NOT_PAID_FAILURE = 'FETCH_PURCHASE_PAYMENT_NOT_PAID_FAILURE';
	var REQUEST_PURCHASING_PERFORMANCE_BY_PRODUCT = exports.REQUEST_PURCHASING_PERFORMANCE_BY_PRODUCT = 'REQUEST_PURCHASING_PERFORMANCE_BY_PRODUCT';
	var FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_SUCCESS = exports.FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_SUCCESS = 'FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_SUCCESS';
	var FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_FAILURE = exports.FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_FAILURE = 'FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_FAILURE';
	var REQUEST_PURCHASE_PRODUCT_BY_ID = exports.REQUEST_PURCHASE_PRODUCT_BY_ID = 'REQUEST_PURCHASE_PRODUCT_BY_ID';
	var FETCH_PURCHASE_PRODUCT_BY_ID_SUCCESS = exports.FETCH_PURCHASE_PRODUCT_BY_ID_SUCCESS = 'FETCH_PURCHASE_PRODUCT_BY_ID_SUCCESS';
	var FETCH_PURCHASE_PRODUCT_BY_ID_FAILURE = exports.FETCH_PURCHASE_PRODUCT_BY_ID_FAILURE = 'FETCH_PURCHASE_PRODUCT_BY_ID_FAILURE';
	var FETCH_INVENTORIES_DETAILS_SUCCESS = exports.FETCH_INVENTORIES_DETAILS_SUCCESS = 'FETCH_INVENTORIES_DETAILS_SUCCESS';
	var RESET_FILTER_WITH_NEW_ID = exports.RESET_FILTER_WITH_NEW_ID = 'RESET_FILTER_WITH_NEW_ID';
	var FETCH_INVENTORIES_PRODUCT_RECEIVE_SUCCESS = exports.FETCH_INVENTORIES_PRODUCT_RECEIVE_SUCCESS = 'FETCH_INVENTORIES_PRODUCT_RECEIVE_SUCCESS';
	var RESET_RECEIVE_FILTER_WITH_NEW_ID = exports.RESET_RECEIVE_FILTER_WITH_NEW_ID = "RESET_RECEIVE_FILTER_WITH_NEW_ID";
	// Inventory action types
	var REQUEST_INVENTORIES = exports.REQUEST_INVENTORIES = 'REQUEST_INVENTORIES';
	var FETCH_INVENTORIES_SUCCESS = exports.FETCH_INVENTORIES_SUCCESS = 'FETCH_INVENTORIES_SUCCESS';
	var FETCH_INVENTORIES_FAILURE = exports.FETCH_INVENTORIES_FAILURE = 'FETCH_INVENTORIES_FAILURE';
	var REQUEST_DETAILED_INVENTORIES = exports.REQUEST_DETAILED_INVENTORIES = 'REQUEST_DETAILED_INVENTORIES';
	var FETCH_DETAILED_INVENTORIES_SUCCESS = exports.FETCH_DETAILED_INVENTORIES_SUCCESS = 'FETCH_DETAILED_INVENTORIES_SUCCESS';
	var FETCH_DETAILED_INVENTORIES_FAILURE = exports.FETCH_DETAILED_INVENTORIES_FAILURE = 'FETCH_DETAILED_INVENTORIES_FAILURE';
	var REQUEST_LOW_STOCK_INVENTORIES = exports.REQUEST_LOW_STOCK_INVENTORIES = 'REQUEST_LOW_STOCK_INVENTORIES';
	var FETCH_LOW_STOCK_INVENTORIES_SUCCESS = exports.FETCH_LOW_STOCK_INVENTORIES_SUCCESS = 'FETCH_LOW_STOCK_INVENTORIES_SUCCESS';
	var FETCH_LOW_STOCK_INVENTORIES_FAILURE = exports.FETCH_LOW_STOCK_INVENTORIES_FAILURE = 'FETCH_LOW_STOCK_INVENTORIES_FAILURE';
	var REQUEST_EXPIRED_INVENTORIES = exports.REQUEST_EXPIRED_INVENTORIES = 'REQUEST_EXPIRED_INVENTORIES';
	var FETCH_EXPIRED_INVENTORIES_SUCCESS = exports.FETCH_EXPIRED_INVENTORIES_SUCCESS = 'FETCH_EXPIRED_INVENTORIES_SUCCESS';
	var FETCH_EXPIRED_INVENTORIES_FAILURE = exports.FETCH_EXPIRED_INVENTORIES_FAILURE = 'FETCH_EXPIRED_INVENTORIES_FAILURE';
	var REQUEST_INVENTORIES_BY_GROUP = exports.REQUEST_INVENTORIES_BY_GROUP = 'REQUEST_INVENTORIES_BY_GROUP';
	var REQUEST_INVENTORIES_BY_GROUP_SUCCESS = exports.REQUEST_INVENTORIES_BY_GROUP_SUCCESS = 'REQUEST_INVENTORIES_BY_GROUP_SUCCESS';
	var REQUEST_INVENTORIES_BY_GROUP_FAILURE = exports.REQUEST_INVENTORIES_BY_GROUP_FAILURE = 'REQUEST_INVENTORIES_BY_GROUP_FAILURE';
	var REQUEST_INVENTORIES_BY_CATEGORY = exports.REQUEST_INVENTORIES_BY_CATEGORY = 'REQUEST_INVENTORIES_BY_CATEGORY';
	var REQUEST_INVENTORIES_BY_CATEGORY_SUCCESS = exports.REQUEST_INVENTORIES_BY_CATEGORY_SUCCESS = 'REQUEST_INVENTORIES_BY_CATEGORY_SUCCESS';
	var REQUEST_INVENTORIES_BY_CATEGORY_FAILURE = exports.REQUEST_INVENTORIES_BY_CATEGORY_FAILURE = 'REQUEST_INVENTORIES_BY_CATEGORY_FAILURE';
	var REQUEST_INVENTORIES_BY_PERIOD = exports.REQUEST_INVENTORIES_BY_PERIOD = 'REQUEST_INVENTORIES_BY_PERIOD';
	var FETCH_INVENTORIES_BY_PERIOD_SUCCESS = exports.FETCH_INVENTORIES_BY_PERIOD_SUCCESS = 'FETCH_INVENTORIES_BY_PERIOD_SUCCESS';
	var FETCH_INVENTORIES_BY_PERIOD_FAILURE = exports.FETCH_INVENTORIES_BY_PERIOD_FAILURE = 'FETCH_INVENTORIES_BY_PERIOD_FAILURE';
	var REQUEST_LOW_INVENTORIES = exports.REQUEST_LOW_INVENTORIES = 'REQUEST_LOW_INVENTORIES';
	var FETCH_LOW_INVENTORIES_SUCCESS = exports.FETCH_LOW_INVENTORIES_SUCCESS = 'FETCH_LOW_INVENTORIES_SUCCESS';
	var FETCH_LOW_INVENTORIES_FAILURE = exports.FETCH_LOW_INVENTORIES_FAILURE = 'FETCH_LOW_INVENTORIES_FAILURE';
	var REQUEST_WORKING_ORDERS = exports.REQUEST_WORKING_ORDERS = 'REQUEST_WORKING_ORDERS';
	var FETCH_WORKING_ORDERS_SUCCESS = exports.FETCH_WORKING_ORDERS_SUCCESS = 'FETCH_WORKING_ORDERS_SUCCESS';
	var FETCH_WORKING_ORDERS_FAILURE = exports.FETCH_WORKING_ORDERS_FAILURE = 'FETCH_WORKING_ORDERS_FAILURE';
	var CHECK_PASSWORD = exports.CHECK_PASSWORD = 'CHECK_PASSWORD';
	var CHECK_PASSWORD_SUCCESS = exports.CHECK_PASSWORD_SUCCESS = 'CHECK_PASSWORD_SUCCESS';
	var CHECK_PASSWORD_FAILURE = exports.CHECK_PASSWORD_FAILURE = 'CHECK_PASSWORD_FAILURE';
	var CLEAR_CHECK_PASSWORD = exports.CLEAR_CHECK_PASSWORD = 'CLEAR_CHECK_PASSWORD';
	var CHECK_PERMISSIOIN = exports.CHECK_PERMISSIOIN = 'CHECK_PERMISSIOIN';
	var CHECK_PERMISSIOIN_SUCCESS = exports.CHECK_PERMISSIOIN_SUCCESS = 'CHECK_PERMISSIOIN_SUCCESS';
	var CHECK_PERMISSIOIN_FAILURE = exports.CHECK_PERMISSIOIN_FAILURE = 'CHECK_PERMISSIOIN_FAILURE';
	var SET_ORIGIN_PAGE = exports.SET_ORIGIN_PAGE = 'SET_ORIGIN_PAGE';
	var SELECT_INVENTORY = exports.SELECT_INVENTORY = 'SELECT_INVENTORY';
	var RESET_CURRENT_INVENTORY = exports.RESET_CURRENT_INVENTORY = 'RESET_CURRENT_INVENTORY';
	var REQUEST_INVENTORY_DETAIL = exports.REQUEST_INVENTORY_DETAIL = 'REQUEST_INVENTORY_DETAIL';
	var FETCH_INVENTORY_DETAIL_SUCCESS = exports.FETCH_INVENTORY_DETAIL_SUCCESS = 'FETCH_INVENTORY_DETAIL_SUCCESS';
	var FETCH_INVENTORY_DETAIL_FAILURE = exports.FETCH_INVENTORY_DETAIL_FAILURE = 'FETCH_INVENTORY_DETAIL_FAILURE';
	var FETCH_INVENTORY_SCRAP = exports.FETCH_INVENTORY_SCRAP = 'FETCH_INVENTORY_SCRAP';
	var FETCH_INVENTORY_SCRAP_SUCCESS = exports.FETCH_INVENTORY_SCRAP_SUCCESS = 'FETCH_INVENTORY_SCRAP_SUCCESS';
	var FETCH_INVENTORY_SCRAP_FAILURE = exports.FETCH_INVENTORY_SCRAP_FAILURE = 'FETCH_INVENTORY_SCRAP_FAILURE';
	var REQUEST_CREATING_SCRAP_RECORD = exports.REQUEST_CREATING_SCRAP_RECORD = 'REQUEST_CREATING_SCRAP_RECORD';
	var CREATE_SCRAP_RECORD_SUCCESS = exports.CREATE_SCRAP_RECORD_SUCCESS = 'CREATE_SCRAP_RECORD_SUCCESS';
	var CREATE_SCRAP_RECORD_FAILURE = exports.CREATE_SCRAP_RECORD_FAILURE = 'CREATE_SCRAP_RECORD_FAILURE';
	var REQUEST_EDITING_SCRAP_RECORD = exports.REQUEST_EDITING_SCRAP_RECORD = 'REQUEST_EDITING_SCRAP_RECORD';
	var EDIT_SCRAP_RECORD_SUCCESS = exports.EDIT_SCRAP_RECORD_SUCCESS = 'EDIT_SCRAP_RECORD_SUCCESS';
	var EDIT_SCRAP_RECORD_FAILURE = exports.EDIT_SCRAP_RECORD_FAILURE = 'EDIT_SCRAP_RECORD_FAILURE';
	var REQUEST_PUT_AWAY = exports.REQUEST_PUT_AWAY = 'REQUEST_PUT_AWAY';
	var FETCH_PUT_AWAY_SUCCESS = exports.FETCH_PUT_AWAY_SUCCESS = 'FETCH_PUT_AWAY_SUCCESS';
	var FETCH_PUT_AWAY_FAILURE = exports.FETCH_PUT_AWAY_FAILURE = 'FETCH_PUT_AWAY_FAILURE';
	var RESET_CURRENT_PUT_AWAY = exports.RESET_CURRENT_PUT_AWAY = 'RESET_CURRENT_PUT_AWAY';
	var REQUEST_CREATING_PUT_AWAY = exports.REQUEST_CREATING_PUT_AWAY = 'REQUEST_CREATING_PUT_AWAY';
	var CREATE_PUT_AWAY_SUCCESS = exports.CREATE_PUT_AWAY_SUCCESS = 'CREATE_PUT_AWAY_SUCCESS';
	var CREATE_PUT_AWAY_FAILURE = exports.CREATE_PUT_AWAY_FAILURE = 'CREATE_PUT_AWAY_FAILURE';
	var SELECT_PUT_AWAY = exports.SELECT_PUT_AWAY = 'SELECT_PUT_AWAY';
	var REQUEST_PUT_AWAY_DETAIL = exports.REQUEST_PUT_AWAY_DETAIL = 'REQUEST_PUT_AWAY_DETAIL';
	var FETCH_PUT_AWAY_DETAIL_SUCCESS = exports.FETCH_PUT_AWAY_DETAIL_SUCCESS = 'FETCH_PUT_AWAY_DETAIL_SUCCESS';
	var FETCH_PUT_AWAY_DETAIL_FAILURE = exports.FETCH_PUT_AWAY_DETAIL_FAILURE = 'FETCH_PUT_AWAY_DETAIL_FAILURE';
	var REQUEST_EDITING_PUT_AWAY = exports.REQUEST_EDITING_PUT_AWAY = 'REQUEST_EDITING_PUT_AWAY';
	var EDIT_PUT_AWAY_SUCCESS = exports.EDIT_PUT_AWAY_SUCCESS = 'EDIT_PUT_AWAY_SUCCESS';
	var EDIT_PUT_AWAY_FAILURE = exports.EDIT_PUT_AWAY_FAILURE = 'EDIT_PUT_AWAY_FAILURE';
	var AUTO_PUTAWAY = exports.AUTO_PUTAWAY = 'AUTO_PUTAWAY';
	var AUTO_PUTAWAY_SUCCESS = exports.AUTO_PUTAWAY_SUCCESS = 'AUTO_PUTAWAY_SUCCESS';
	var AUTO_PUTAWAY_FAILURE = exports.AUTO_PUTAWAY_FAILURE = 'AUTO_PUTAWAY_FAILURE';
	var REQUEST_BIN_LIST_DETAIL = exports.REQUEST_BIN_LIST_DETAIL = 'REQUEST_BIN_LIST_DETAIL';
	var FETCH_BIN_LIST_DETAIL_SUCCESS = exports.FETCH_BIN_LIST_DETAIL_SUCCESS = 'FETCH_BIN_LIST_DETAIL_SUCCESS';
	var FETCH_BIN_LIST_DETAIL_FAILURE = exports.FETCH_BIN_LIST_DETAIL_FAILURE = 'FETCH_BIN_LIST_DETAIL_FAILURE';
	var REQUEST_CREATING_BINS = exports.REQUEST_CREATING_BINS = 'REQUEST_CREATING_BINS';
	var CREATE_BINS_SUCCESS = exports.CREATE_BINS_SUCCESS = 'CREATE_BINS_SUCCESS';
	var CREATE_BINS_FAILURE = exports.CREATE_BINS_FAILURE = 'CREATE_BINS_FAILURE';
	var SELECT_WAREHOUSE_RECEIVE = exports.SELECT_WAREHOUSE_RECEIVE = 'SELECT_WAREHOUSE_RECEIVE';
	var RESET_CURRENT_WAREHOUSE_RECEIVE = exports.RESET_CURRENT_WAREHOUSE_RECEIVE = 'RESET_CURRENT_WAREHOUSE_RECEIVE';
	var REQUEST_NONZERO_INVENTORIES = exports.REQUEST_NONZERO_INVENTORIES = 'REQUEST_NONZERO_INVENTORIES';
	var FETCH_NONZERO_INVENTORIES_SUCCESS = exports.FETCH_NONZERO_INVENTORIES_SUCCESS = 'FETCH_NONZERO_INVENTORIES_SUCCESS';
	var FETCH_NONZERO_INVENTORIES_FAILURE = exports.FETCH_NONZERO_INVENTORIES_FAILURE = 'FETCH_NONZERO_INVENTORIES_FAILURE';
	var FETCH_INVENTORY_HISTORY = exports.FETCH_INVENTORY_HISTORY = 'FETCH_INVENTORY_HISTORY';
	var FETCH_INVENTORY_HISTORY_SUCCESS = exports.FETCH_INVENTORY_HISTORY_SUCCESS = 'FETCH_INVENTORY_HISTORY_SUCCESS';
	var FETCH_INVENTORY_HISTORY_FAILURE = exports.FETCH_INVENTORY_HISTORY_FAILURE = 'FETCH_INVENTORY_HISTORY_FAILURE';
	var FETCH_INVENTORY_ADJUSTMENT_BATCH_LOG = exports.FETCH_INVENTORY_ADJUSTMENT_BATCH_LOG = "FETCH_INVENTORY_ADJUSTMENT_BATCH_LOG";
	var UPDATE_INVENTORY_FILTER = exports.UPDATE_INVENTORY_FILTER = 'UPDATE_INVENTORY_FILTER';
	var UPDATE_RECEIVE_TABLE_FILTER = exports.UPDATE_RECEIVE_TABLE_FILTER = 'UPDATE_RECEIVE_TABLE_FILTER';
	
	// Favorites action types
	var REQUEST_FAVORITES = exports.REQUEST_FAVORITES = 'REQUEST_FAVORITES';
	var FETCH_FAVORITES_SUCCESS = exports.FETCH_FAVORITES_SUCCESS = 'FETCH_FAVORITES_SUCCESS';
	var FETCH_FAVORITES_FAILURE = exports.FETCH_FAVORITES_FAILURE = 'FETCH_FAVORITES_FAILURE';
	var SELECT_FAVORITES = exports.SELECT_FAVORITES = 'SELECT_FAVORITES';
	var RESET_CURRENT_FAVORITES = exports.RESET_CURRENT_FAVORITES = 'RESET_CURRENT_FAVORITES';
	var REQUEST_FAVORITES_DETAIL = exports.REQUEST_FAVORITES_DETAIL = 'REQUEST_FAVORITES_DETAIL';
	var FETCH_FAVORITES_DETAIL_SUCCESS = exports.FETCH_FAVORITES_DETAIL_SUCCESS = 'FETCH_FAVORITES_DETAIL_SUCCESS';
	var FETCH_FAVORITES_DETAIL_FAILURE = exports.FETCH_FAVORITES_DETAIL_FAILURE = 'FETCH_FAVORITES_DETAIL_FAILURE';
	var REQUEST_ADDING_FAVORITE = exports.REQUEST_ADDING_FAVORITE = 'REQUEST_ADDING_FAVORITE';
	var ADD_FAVORITE_SUCCESS = exports.ADD_FAVORITE_SUCCESS = 'ADD_FAVORITE_SUCCESS';
	var ADD_FAVORITE_FAILURE = exports.ADD_FAVORITE_FAILURE = 'ADD_FAVORITE_FAILURE';
	var REQUEST_DELETE_FAVORITE = exports.REQUEST_DELETE_FAVORITE = 'REQUEST_DELETE_FAVORITE';
	var DELETE_FAVORITE_SUCCESS = exports.DELETE_FAVORITE_SUCCESS = 'DELETE_FAVORITE_SUCCESS';
	var DELETE_FAVORITE_FAILURE = exports.DELETE_FAVORITE_FAILURE = 'DELETE_FAVORITE_FAILURE';
	var ITEM_IN_LIST = exports.ITEM_IN_LIST = 'ITEM_IN_LIST';
	var CLEAR_IN_LIST_ERROR = exports.CLEAR_IN_LIST_ERROR = 'CLEAR_IN_LIST_ERROR';
	var REQUEST_FAVORITE_LIST = exports.REQUEST_FAVORITE_LIST = 'REQUEST_FAVORITE_LIST';
	var FETCH_FAVORITE_LIST_SUCCESS = exports.FETCH_FAVORITE_LIST_SUCCESS = 'FETCH_FAVORITE_LIST_SUCCESS';
	var FETCH_FAVORITE_LIST_FAILURE = exports.FETCH_FAVORITE_LIST_FAILURE = 'FETCH_FAVORITE_LIST_FAILURE';
	var REQUEST_SAVE_FAVORITE_LIST = exports.REQUEST_SAVE_FAVORITE_LIST = 'REQUEST_SAVE_FAVORITE_LIST';
	var SAVE_FAVORITE_LIST_SUCCESS = exports.SAVE_FAVORITE_LIST_SUCCESS = 'SAVE_FAVORITE_LIST_SUCCESS';
	var SAVE_FAVORITE_LIST_FAILURE = exports.SAVE_FAVORITE_LIST_FAILURE = 'SAVE_FAVORITE_LIST_FAILURE';
	
	// Promotions action types
	var REQUEST_PROMOTIONS = exports.REQUEST_PROMOTIONS = 'REQUEST_PROMOTIONS';
	var FETCH_PROMOTIONS_SUCCESS = exports.FETCH_PROMOTIONS_SUCCESS = 'FETCH_PROMOTIONS_SUCCESS';
	var FETCH_PROMOTIONS_FAILURE = exports.FETCH_PROMOTIONS_FAILURE = 'FETCH_PROMOTIONS_FAILURE';
	var SELECT_PROMOTIONS = exports.SELECT_PROMOTIONS = 'SELECT_PROMOTIONS';
	var RESET_CURRENT_PROMOTIONS = exports.RESET_CURRENT_PROMOTIONS = 'RESET_CURRENT_PROMOTIONS';
	var REQUEST_PROMOTIONS_DETAIL = exports.REQUEST_PROMOTIONS_DETAIL = 'REQUEST_PROMOTIONS_DETAIL';
	var FETCH_PROMOTIONS_DETAIL_SUCCESS = exports.FETCH_PROMOTIONS_DETAIL_SUCCESS = 'FETCH_PROMOTIONS_DETAIL_SUCCESS';
	var FETCH_PROMOTIONS_DETAIL_FAILURE = exports.FETCH_PROMOTIONS_DETAIL_FAILURE = 'FETCH_PROMOTIONS_DETAIL_FAILURE';
	var REQUEST_ADDING_PROMOTION = exports.REQUEST_ADDING_PROMOTION = 'REQUEST_ADDING_PROMOTION';
	var ADD_PROMOTION_SUCCESS = exports.ADD_PROMOTION_SUCCESS = 'ADD_PROMOTION_SUCCESS';
	var ADD_PROMOTION_FAILURE = exports.ADD_PROMOTION_FAILURE = 'ADD_PROMOTION_FAILURE';
	var REQUEST_DELETE_PROMOTION = exports.REQUEST_DELETE_PROMOTION = 'REQUEST_DELETE_PROMOTION';
	var DELETE_PROMOTION_SUCCESS = exports.DELETE_PROMOTION_SUCCESS = 'DELETE_PROMOTION_SUCCESS';
	var DELETE_PROMOTION_FAILURE = exports.DELETE_PROMOTION_FAILURE = 'DELETE_PROMOTION_FAILURE';
	var REQUEST_EDITING_PROMOTION = exports.REQUEST_EDITING_PROMOTION = 'REQUEST_EDITING_PROMOTION';
	var EDIT_PROMOTION_SUCCESS = exports.EDIT_PROMOTION_SUCCESS = 'EDIT_PROMOTION_SUCCESS';
	var EDIT_PROMOTION_FAILURE = exports.EDIT_PROMOTION_FAILURE = 'EDIT_PROMOTION_FAILURE';
	var REQUEST_SAVE_PROMOTION = exports.REQUEST_SAVE_PROMOTION = 'REQUEST_SAVE_PROMOTION';
	var SAVE_PROMOTION_SUCCESS = exports.SAVE_PROMOTION_SUCCESS = 'SAVE_PROMOTION_SUCCESS';
	var SAVE_PROMOTION_FAILURE = exports.SAVE_PROMOTION_FAILURE = 'SAVE_PROMOTION_FAILURE';
	var REQUEST_SAVE_PROMO_NOTES = exports.REQUEST_SAVE_PROMO_NOTES = 'REQUEST_SAVE_PROMO_NOTES';
	var SAVE_PROMO_NOTES_SUCCESS = exports.SAVE_PROMO_NOTES_SUCCESS = 'SAVE_PROMO_NOTES_SUCCESS';
	var SAVE_PROMO_NOTES_FAILURE = exports.SAVE_PROMO_NOTES_FAILURE = 'SAVE_PROMO_NOTES_FAILURE';
	var REQUEST_PROMO_NOTES = exports.REQUEST_PROMO_NOTES = 'REQUEST_PROMO_NOTES';
	var FETCH_PROMO_NOTES_SUCCESS = exports.FETCH_PROMO_NOTES_SUCCESS = 'FETCH_PROMO_NOTES_SUCCESS';
	var FETCH_PROMO_NOTES_FAILURE = exports.FETCH_PROMO_NOTES_FAILURE = 'FETCH_PROMO_NOTES_FAILURE';
	var CLEAR_PROMO_NOTES_STATUS = exports.CLEAR_PROMO_NOTES_STATUS = 'CLEAR_PROMO_NOTES_STATUS';
	var SET_CURRENT_PROMO = exports.SET_CURRENT_PROMO = 'SET_CURRENT_PROMO';
	var RESET_CURRENT_PROMO = exports.RESET_CURRENT_PROMO = 'RESET_CURRENT_PROMO';
	var REQUEST_PROMO_DETAILS = exports.REQUEST_PROMO_DETAILS = 'REQUEST_PROMO_DETAILS';
	var FETCH_PROMO_DETAILS_SUCCESS = exports.FETCH_PROMO_DETAILS_SUCCESS = 'FETCH_PROMO_DETAILS_SUCCESS';
	var FETCH_PROMO_DETAILS_FAILURE = exports.FETCH_PROMO_DETAILS_FAILURE = 'FETCH_PROMO_DETAILS_FAILURE';
	var CLEAR_PROMO_DETAIL_STATUS = exports.CLEAR_PROMO_DETAIL_STATUS = 'CLEAR_PROMO_DETAIL_STATUS';
	
	// Previous Orders action types
	var REQUEST_PREVIOUSSOS = exports.REQUEST_PREVIOUSSOS = 'REQUEST_PREVIOUSSOS';
	var FETCH_PREVIOUSSOS_SUCCESS = exports.FETCH_PREVIOUSSOS_SUCCESS = 'FETCH_PREVIOUSSOS_SUCCESS';
	var FETCH_PREVIOUSSOS_FAILURE = exports.FETCH_PREVIOUSSOS_FAILURE = 'FETCH_PREVIOUSSOS_FAILURE';
	var REQUEST_PREVIOUSSO_DETAIL = exports.REQUEST_PREVIOUSSO_DETAIL = 'REQUEST_PREVIOUSSO_DETAIL';
	var FETCH_PREVIOUSSO_DETAIL_SUCCESS = exports.FETCH_PREVIOUSSO_DETAIL_SUCCESS = 'FETCH_PREVIOUSSO_DETAIL_SUCCESS';
	var FETCH_PREVIOUSSO_DETAIL_FAILURE = exports.FETCH_PREVIOUSSO_DETAIL_FAILURE = 'FETCH_PREVIOUSSO_DETAIL_FAILURE';
	var REQUEST_PREVIOUSORDERS = exports.REQUEST_PREVIOUSORDERS = 'REQUEST_PREVIOUSORDERS';
	var FETCH_PREVIOUSORDERS_SUCCESS = exports.FETCH_PREVIOUSORDERS_SUCCESS = 'FETCH_PREVIOUSORDERS_SUCCESS';
	var FETCH_PREVIOUSORDERS_FAILURE = exports.FETCH_PREVIOUSORDERS_FAILURE = 'FETCH_PREVIOUSORDERS_FAILURE';
	var SELECT_PREVIOUSORDERS = exports.SELECT_PREVIOUSORDERS = 'SELECT_PREVIOUSORDERS';
	var RESET_CURRENT_PREVIOUSORDERS = exports.RESET_CURRENT_PREVIOUSORDERS = 'RESET_CURRENT_PREVIOUSORDERS';
	var REQUEST_PREVIOUSORDERS_DETAIL = exports.REQUEST_PREVIOUSORDERS_DETAIL = 'REQUEST_PREVIOUSORDERS_DETAIL';
	var FETCH_PREVIOUSORDERS_DETAIL_SUCCESS = exports.FETCH_PREVIOUSORDERS_DETAIL_SUCCESS = 'FETCH_PREVIOUSORDERS_DETAIL_SUCCESS';
	var FETCH_PREVIOUSORDERS_DETAIL_FAILURE = exports.FETCH_PREVIOUSORDERS_DETAIL_FAILURE = 'FETCH_PREVIOUSORDERS_DETAIL_FAILURE';
	var REQUEST_ADDING_PREVIOUSORDER = exports.REQUEST_ADDING_PREVIOUSORDER = 'REQUEST_ADDING_PREVIOUSORDER';
	var ADD_PREVIOUSORDER_SUCCESS = exports.ADD_PREVIOUSORDER_SUCCESS = 'ADD_PREVIOUSORDER_SUCCESS';
	var ADD_PREVIOUSORDER_FAILURE = exports.ADD_PREVIOUSORDER_FAILURE = 'ADD_PREVIOUSORDER_FAILURE';
	var REQUEST_DELETE_PREVIOUSORDER = exports.REQUEST_DELETE_PREVIOUSORDER = 'REQUEST_DELETE_PREVIOUSORDER';
	var DELETE_PREVIOUSORDER_SUCCESS = exports.DELETE_PREVIOUSORDER_SUCCESS = 'DELETE_PREVIOUSORDER_SUCCESS';
	var DELETE_PREVIOUSORDER_FAILURE = exports.DELETE_PREVIOUSORDER_FAILURE = 'DELETE_PREVIOUSORDER_FAILURE';
	
	// Inventory relocation action types
	var REQUEST_INVENTORY_RELOCATIONS = exports.REQUEST_INVENTORY_RELOCATIONS = 'REQUEST_INVENTORY_RELOCATIONS';
	var FETCH_INVENTORY_RELOCATIONS_SUCCESS = exports.FETCH_INVENTORY_RELOCATIONS_SUCCESS = 'FETCH_INVENTORY_RELOCATIONS_SUCCESS';
	var FETCH_INVENTORY_RELOCATIONS_FAILURE = exports.FETCH_INVENTORY_RELOCATIONS_FAILURE = 'FETCH_INVENTORY_RELOCATIONS_FAILURE';
	var SELECT_INVENTORY_RELOCATION = exports.SELECT_INVENTORY_RELOCATION = 'SELECT_INVENTORY_RELOCATION';
	var RESET_CURRENT_INVENTORY_RELOCATION = exports.RESET_CURRENT_INVENTORY_RELOCATION = 'RESET_CURRENT_INVENTORY_RELOCATION';
	var REQUEST_INVENTORY_RELOCATION_DETAIL = exports.REQUEST_INVENTORY_RELOCATION_DETAIL = 'REQUEST_INVENTORY_RELOCATION_DETAIL';
	var FETCH_INVENTORY_RELOCATION_DETAIL_SUCCESS = exports.FETCH_INVENTORY_RELOCATION_DETAIL_SUCCESS = 'FETCH_INVENTORY_RELOCATION_DETAIL_SUCCESS';
	var FETCH_INVENTORY_RELOCATION_DETAIL_FAILURE = exports.FETCH_INVENTORY_RELOCATION_DETAIL_FAILURE = 'FETCH_INVENTORY_RELOCATION_DETAIL_FAILURE';
	
	var REQUEST_CREATING_INVENTORY_RELOCATION = exports.REQUEST_CREATING_INVENTORY_RELOCATION = 'REQUEST_CREATING_INVENTORY_RELOCATION';
	var CREATE_INVENTORY_RELOCATION_SUCCESS = exports.CREATE_INVENTORY_RELOCATION_SUCCESS = 'CREATE_INVENTORY_RELOCATION_SUCCESS';
	var CREATE_INVENTORY_RELOCATION_FAILURE = exports.CREATE_INVENTORY_RELOCATION_FAILURE = 'CREATE_INVENTORY_RELOCATION_FAILURE';
	var REQUEST_EDITING_INVENTORY_RELOCATION = exports.REQUEST_EDITING_INVENTORY_RELOCATION = 'REQUEST_EDITING_INVENTORY_RELOCATION';
	var EDIT_INVENTORY_RELOCATION_SUCCESS = exports.EDIT_INVENTORY_RELOCATION_SUCCESS = 'EDIT_INVENTORY_RELOCATION_SUCCESS';
	var EDIT_INVENTORY_RELOCATION_FAILURE = exports.EDIT_INVENTORY_RELOCATION_FAILURE = 'EDIT_INVENTORY_RELOCATION_FAILURE';
	
	// Inventory adjustment action types
	var REQUEST_INVENTORY_ADJUSTMENTS = exports.REQUEST_INVENTORY_ADJUSTMENTS = 'REQUEST_INVENTORY_ADJUSTMENTS';
	var REQUEST_INVENTORY_ADJUSTMENTS_DETAIL = exports.REQUEST_INVENTORY_ADJUSTMENTS_DETAIL = 'REQUEST_INVENTORY_ADJUSTMENTS_DETAIL';
	var FETCH_INVENTORY_ADJUSTMENTS_DETAIL_SUCCESS = exports.FETCH_INVENTORY_ADJUSTMENTS_DETAIL_SUCCESS = 'FETCH_INVENTORY_ADJUSTMENTS_DETAIL_SUCCESS';
	var FETCH_INVENTORY_ADJUSTMENTS_DETAIL_FAILURE = exports.FETCH_INVENTORY_ADJUSTMENTS_DETAIL_FAILURE = 'FETCH_INVENTORY_ADJUSTMENTS_DETAIL_FAILURE';
	var FETCH_INVENTORY_ADJUSTMENTS_SUCCESS = exports.FETCH_INVENTORY_ADJUSTMENTS_SUCCESS = 'FETCH_INVENTORY_ADJUSTMENTS_SUCCESS';
	var FETCH_INVENTORY_ADJUSTMENTS_FAILURE = exports.FETCH_INVENTORY_ADJUSTMENTS_FAILURE = 'FETCH_INVENTORY_ADJUSTMENTS_FAILURE';
	var SELECT_INVENTORY_ADJUSTMENT = exports.SELECT_INVENTORY_ADJUSTMENT = 'SELECT_INVENTORY_ADJUSTMENT';
	var RESET_CURRENT_INVENTORY_ADJUSTMENT = exports.RESET_CURRENT_INVENTORY_ADJUSTMENT = 'RESET_CURRENT_INVENTORY_ADJUSTMENT';
	var REQUEST_INVENTORY_ADJUSTMENT_DETAIL = exports.REQUEST_INVENTORY_ADJUSTMENT_DETAIL = 'REQUEST_INVENTORY_ADJUSTMENT_DETAIL';
	var FETCH_INVENTORY_ADJUSTMENT_DETAIL_SUCCESS = exports.FETCH_INVENTORY_ADJUSTMENT_DETAIL_SUCCESS = 'FETCH_INVENTORY_ADJUSTMENT_DETAIL_SUCCESS';
	var FETCH_INVENTORY_ADJUSTMENT_DETAIL_FAILURE = exports.FETCH_INVENTORY_ADJUSTMENT_DETAIL_FAILURE = 'FETCH_INVENTORY_ADJUSTMENT_DETAIL_FAILURE';
	
	var REQUEST_NEW_CONVERT = exports.REQUEST_NEW_CONVERT = 'REQUEST_NEW_CONVERT';
	var NEW_CONVERT_SUCCESS = exports.NEW_CONVERT_SUCCESS = 'NEW_CONVERT_SUCCESS';
	var NEW_CONVERT_FAILURE = exports.NEW_CONVERT_FAILURE = 'NEW_CONVERT_FAILURE';
	
	var REQUEST_CREATING_INVENTORY_ADJUSTMENTS = exports.REQUEST_CREATING_INVENTORY_ADJUSTMENTS = 'REQUEST_CREATING_INVENTORY_ADJUSTMENTS';
	var CREATE_INVENTORY_ADJUSTMENTS_SUCCESS = exports.CREATE_INVENTORY_ADJUSTMENTS_SUCCESS = 'CREATE_INVENTORY_ADJUSTMENTS_SUCCESS';
	var CREATE_INVENTORY_ADJUSTMENTS_FAILURE = exports.CREATE_INVENTORY_ADJUSTMENTS_FAILURE = 'CREATE_INVENTORY_ADJUSTMENTS_FAILURE';
	var REQUEST_EDITING_INVENTORY_ADJUSTMENTS = exports.REQUEST_EDITING_INVENTORY_ADJUSTMENTS = 'REQUEST_EDITING_INVENTORY_ADJUSTMENTS';
	var EDIT_INVENTORY_ADJUSTMENTS_SUCCESS = exports.EDIT_INVENTORY_ADJUSTMENTS_SUCCESS = 'EDIT_INVENTORY_ADJUSTMENTS_SUCCESS';
	var EDIT_INVENTORY_ADJUSTMENTS_FAILURE = exports.EDIT_INVENTORY_ADJUSTMENTS_FAILURE = 'EDIT_INVENTORY_ADJUSTMENTS_FAILURE';
	
	var REQUEST_QUICK_INVENTORY_ADJUSTMENTS = exports.REQUEST_QUICK_INVENTORY_ADJUSTMENTS = 'REQUEST_QUICK_INVENTORY_ADJUSTMENTS';
	var QUICK_INVENTORY_ADJUSTMENTS_SUCCESS = exports.QUICK_INVENTORY_ADJUSTMENTS_SUCCESS = 'QUICK_INVENTORY_ADJUSTMENTS_SUCCESS';
	var QUICK_INVENTORY_ADJUSTMENTS_FAILURE = exports.QUICK_INVENTORY_ADJUSTMENTS_FAILURE = 'QUICK_INVENTORY_ADJUSTMENTS_FAILURE';
	var RESET_QUICK_INVENTORY_ADJUSTMENTS = exports.RESET_QUICK_INVENTORY_ADJUSTMENTS = 'RESET_QUICK_INVENTORY_ADJUSTMENTS';
	// Inventory repackage action types
	var REQUEST_INVENTORY_REPACKAGES = exports.REQUEST_INVENTORY_REPACKAGES = 'REQUEST_INVENTORY_REPACKAGES';
	var FETCH_INVENTORY_REPACKAGES_SUCCESS = exports.FETCH_INVENTORY_REPACKAGES_SUCCESS = 'FETCH_INVENTORY_REPACKAGES_SUCCESS';
	var FETCH_INVENTORY_REPACKAGES_FAILURE = exports.FETCH_INVENTORY_REPACKAGES_FAILURE = 'FETCH_INVENTORY_REPACKAGES_FAILURE';
	var SELECT_INVENTORY_REPACKAGE = exports.SELECT_INVENTORY_REPACKAGE = 'SELECT_INVENTORY_REPACKAGE';
	var RESET_CURRENT_INVENTORY_REPACKAGE = exports.RESET_CURRENT_INVENTORY_REPACKAGE = 'RESET_CURRENT_INVENTORY_REPACKAGE';
	var REQUEST_INVENTORY_REPACKAGE_DETAIL = exports.REQUEST_INVENTORY_REPACKAGE_DETAIL = 'REQUEST_INVENTORY_REPACKAGE_DETAIL';
	var FETCH_INVENTORY_REPACKAGE_DETAIL_SUCCESS = exports.FETCH_INVENTORY_REPACKAGE_DETAIL_SUCCESS = 'FETCH_INVENTORY_REPACKAGE_DETAIL_SUCCESS';
	var FETCH_INVENTORY_REPACKAGE_DETAIL_FAILURE = exports.FETCH_INVENTORY_REPACKAGE_DETAIL_FAILURE = 'FETCH_INVENTORY_REPACKAGE_DETAIL_FAILURE';
	var REQUEST_CREATING_INVENTORY_REPACKAGE = exports.REQUEST_CREATING_INVENTORY_REPACKAGE = 'REQUEST_CREATING_INVENTORY_REPACKAGE';
	var CREATE_INVENTORY_REPACKAGE_SUCCESS = exports.CREATE_INVENTORY_REPACKAGE_SUCCESS = 'CREATE_INVENTORY_REPACKAGE_SUCCESS';
	var CREATE_INVENTORY_REPACKAGE_FAILURE = exports.CREATE_INVENTORY_REPACKAGE_FAILURE = 'CREATE_INVENTORY_REPACKAGE_FAILURE';
	var REQUEST_EDITING_INVENTORY_REPACKAGE = exports.REQUEST_EDITING_INVENTORY_REPACKAGE = 'REQUEST_EDITING_INVENTORY_REPACKAGE';
	var EDIT_INVENTORY_REPACKAGE_SUCCESS = exports.EDIT_INVENTORY_REPACKAGE_SUCCESS = 'EDIT_INVENTORY_REPACKAGE_SUCCESS';
	var EDIT_INVENTORY_REPACKAGE_FAILURE = exports.EDIT_INVENTORY_REPACKAGE_FAILURE = 'EDIT_INVENTORY_REPACKAGE_FAILURE';
	
	// Inventory repackage action types
	var REQUEST_INVENTORY_CONVERTS = exports.REQUEST_INVENTORY_CONVERTS = 'REQUEST_INVENTORY_CONVERTS';
	var FETCH_INVENTORY_CONVERTS_SUCCESS = exports.FETCH_INVENTORY_CONVERTS_SUCCESS = 'FETCH_INVENTORY_CONVERTS_SUCCESS';
	var FETCH_INVENTORY_CONVERTS_FAILURE = exports.FETCH_INVENTORY_CONVERTS_FAILURE = 'FETCH_INVENTORY_CONVERTS_FAILURE';
	var SELECT_INVENTORY_CONVERT = exports.SELECT_INVENTORY_CONVERT = 'SELECT_INVENTORY_CONVERT';
	var RESET_CURRENT_INVENTORY_CONVERT = exports.RESET_CURRENT_INVENTORY_CONVERT = 'RESET_CURRENT_INVENTORY_CONVERT';
	var REQUEST_INVENTORY_CONVERT_DETAIL = exports.REQUEST_INVENTORY_CONVERT_DETAIL = 'REQUEST_INVENTORY_CONVERT_DETAIL';
	var FETCH_INVENTORY_CONVERT_DETAIL_SUCCESS = exports.FETCH_INVENTORY_CONVERT_DETAIL_SUCCESS = 'FETCH_INVENTORY_CONVERT_DETAIL_SUCCESS';
	var FETCH_INVENTORY_CONVERT_DETAIL_FAILURE = exports.FETCH_INVENTORY_CONVERT_DETAIL_FAILURE = 'FETCH_INVENTORY_CONVERT_DETAIL_FAILURE';
	var REQUEST_INVENTORIES_BIN = exports.REQUEST_INVENTORIES_BIN = 'REQUEST_INVENTORIES_BIN';
	var FETCH_INVENTORIES_BIN_SUCCESS = exports.FETCH_INVENTORIES_BIN_SUCCESS = 'FETCH_INVENTORIES_BIN_SUCCESS';
	var FETCH_INVENTORIES_BIN_FAILURE = exports.FETCH_INVENTORIES_BIN_FAILURE = 'FETCH_INVENTORIES_BIN_FAILURE';
	var REQUEST_CREATING_INVENTORY_CONVERT = exports.REQUEST_CREATING_INVENTORY_CONVERT = 'REQUEST_CREATING_INVENTORY_CONVERT';
	var CREATE_INVENTORY_CONVERT_SUCCESS = exports.CREATE_INVENTORY_CONVERT_SUCCESS = 'CREATE_INVENTORY_CONVERT_SUCCESS';
	var CREATE_INVENTORY_CONVERT_FAILURE = exports.CREATE_INVENTORY_CONVERT_FAILURE = 'CREATE_INVENTORY_CONVERT_FAILURE';
	var REQUEST_EDITING_INVENTORY_CONVERT = exports.REQUEST_EDITING_INVENTORY_CONVERT = 'REQUEST_EDITING_INVENTORY_CONVERT';
	var EDIT_INVENTORY_CONVERT_SUCCESS = exports.EDIT_INVENTORY_CONVERT_SUCCESS = 'EDIT_INVENTORY_CONVERT_SUCCESS';
	var EDIT_INVENTORY_CONVERT_FAILURE = exports.EDIT_INVENTORY_CONVERT_FAILURE = 'EDIT_INVENTORY_CONVERT_FAILURE';
	
	// Scrap Records action types
	var REQUEST_SCRAP_RECORDS = exports.REQUEST_SCRAP_RECORDS = 'REQUEST_SCRAP_RECORDS';
	var FETCH_SCRAP_RECORDS_SUCCESS = exports.FETCH_SCRAP_RECORDS_SUCCESS = 'FETCH_SCRAP_RECORDS_SUCCESS';
	var FETCH_SCRAP_RECORDS_FAILURE = exports.FETCH_SCRAP_RECORDS_FAILURE = 'FETCH_SCRAP_RECORDS_FAILURE';
	var SELECT_SCRAP_RECORD = exports.SELECT_SCRAP_RECORD = 'SELECT_SCRAP_RECORD';
	var RESET_CURRENT_SCRAP_RECORD = exports.RESET_CURRENT_SCRAP_RECORD = 'RESET_CURRENT_SCRAP_RECORD';
	var REQUEST_SCRAP_RECORD_DETAIL = exports.REQUEST_SCRAP_RECORD_DETAIL = 'REQUEST_SCRAP_RECORD_DETAIL';
	var FETCH_SCRAP_RECORD_DETAIL_SUCCESS = exports.FETCH_SCRAP_RECORD_DETAIL_SUCCESS = 'FETCH_SCRAP_RECORD_DETAIL_SUCCESS';
	var FETCH_SCRAP_RECORD_DETAIL_FAILURE = exports.FETCH_SCRAP_RECORD_DETAIL_FAILURE = 'FETCH_SCRAP_RECORD_DETAIL_FAILURE';
	
	// Receive action types
	var REQUEST_RECEIVES = exports.REQUEST_RECEIVES = 'REQUEST_RECEIVES';
	var FETCH_RECEIVES_SUCCESS = exports.FETCH_RECEIVES_SUCCESS = 'FETCH_RECEIVES_SUCCESS';
	var FETCH_RECEIVES_FAILURE = exports.FETCH_RECEIVES_FAILURE = 'FETCH_RECEIVES_FAILURE';
	var SELECT_RECEIVE = exports.SELECT_RECEIVE = 'SELECT_RECEIVE';
	var RESET_CURRENT_RECEIVE = exports.RESET_CURRENT_RECEIVE = 'RESET_CURRENT_RECEIVE';
	var REQUEST_CREATING_RECEIVE = exports.REQUEST_CREATING_RECEIVE = 'REQUEST_CREATING_RECEIVE';
	var CREATE_RECEIVE_SUCCESS = exports.CREATE_RECEIVE_SUCCESS = 'CREATE_RECEIVE_SUCCESS';
	var CREATE_RECEIVE_FAILURE = exports.CREATE_RECEIVE_FAILURE = 'CREATE_RECEIVE_FAILURE';
	var RESET_CREATE_RECEIVE = exports.RESET_CREATE_RECEIVE = 'RESET_CREATE_RECEIVE';
	var REQUEST_EDITING_RECEIVE = exports.REQUEST_EDITING_RECEIVE = 'REQUEST_EDITING_RECEIVE';
	var EDIT_RECEIVE_SUCCESS = exports.EDIT_RECEIVE_SUCCESS = 'EDIT_RECEIVE_SUCCESS';
	var EDIT_RECEIVE_FAILURE = exports.EDIT_RECEIVE_FAILURE = 'EDIT_RECEIVE_FAILURE';
	var REQUEST_RECEIVE_DETAIL = exports.REQUEST_RECEIVE_DETAIL = 'REQUEST_RECEIVE_DETAIL';
	var FETCH_RECEIVE_DETAIL_SUCCESS = exports.FETCH_RECEIVE_DETAIL_SUCCESS = 'FETCH_RECEIVE_DETAIL_SUCCESS';
	var FETCH_RECEIVE_DETAIL_FAILURE = exports.FETCH_RECEIVE_DETAIL_FAILURE = 'FETCH_RECEIVE_DETAIL_FAILURE';
	var FETCH_RECEIVE_HISTORY = exports.FETCH_RECEIVE_HISTORY = 'FETCH_RECEIVE_HISTORY';
	var FETCH_RECEIVE_HISTORY_SUCCESS = exports.FETCH_RECEIVE_HISTORY_SUCCESS = 'FETCH_RECEIVE_HISTORY_SUCCESS';
	var FETCH_RECEIVE_HISTORY_FAILURE = exports.FETCH_RECEIVE_HISTORY_FAILURE = 'FETCH_RECEIVE_HISTORY_FAILURE';
	var SELECT_RECEIVE_HISTORY = exports.SELECT_RECEIVE_HISTORY = 'SELECT_RECEIVE_HISTORY';
	var RESET_CURRENT_RECEIVE_HISTORY = exports.RESET_CURRENT_RECEIVE_HISTORY = 'RESET_CURRENT_RECEIVE_HISTORY';
	
	var FETCH_RECEIVE_HISTORY_DETAIL = exports.FETCH_RECEIVE_HISTORY_DETAIL = 'FETCH_RECEIVE_HISTORY_DETAIL';
	var FETCH_RECEIVE_HISTORY_DETAIL_SUCCESS = exports.FETCH_RECEIVE_HISTORY_DETAIL_SUCCESS = 'FETCH_RECEIVE_HISTORY_DETAIL_SUCCESS';
	var FETCH_RECEIVE_HISTORY_DETAIL_FAILURE = exports.FETCH_RECEIVE_HISTORY_DETAIL_FAILURE = 'FETCH_RECEIVE_HISTORY_DETAIL_FAILURE';
	
	var FETCH_ALL_RECEIVE_HISTORY_DETAIL = exports.FETCH_ALL_RECEIVE_HISTORY_DETAIL = 'FETCH_ALL_RECEIVE_HISTORY_DETAIL';
	var FETCH_ALL_RECEIVE_HISTORY_DETAIL_SUCCESS = exports.FETCH_ALL_RECEIVE_HISTORY_DETAIL_SUCCESS = 'FETCH_ALL_RECEIVE_HISTORY_DETAIL_SUCCESS';
	var FETCH_ALL_RECEIVE_HISTORY_DETAIL_FAILURE = exports.FETCH_ALL_RECEIVE_HISTORY_DETAIL_FAILURE = 'FETCH_ALL_RECEIVE_HISTORY_DETAIL_FAILURE';
	var FETCH_RECEIVE_HISTORY_DETAIL_RECORD = exports.FETCH_RECEIVE_HISTORY_DETAIL_RECORD = 'FETCH_RECEIVE_HISTORY_DETAIL_RECORD';
	var FETCH_RECEIVE_HISTORY_DETAIL_RECORD_SUCCESS = exports.FETCH_RECEIVE_HISTORY_DETAIL_RECORD_SUCCESS = 'FETCH_RECEIVE_HISTORY_DETAIL_RECORD_SUCCESS';
	var FETCH_RECEIVE_HISTORY_DETAIL_RECORD_FAILURE = exports.FETCH_RECEIVE_HISTORY_DETAIL_RECORD_FAILURE = 'FETCH_RECEIVE_HISTORY_DETAIL_RECORD_FAILURE';
	
	var REQUEST_EDITING_RECEIVE_HISTORY = exports.REQUEST_EDITING_RECEIVE_HISTORY = 'REQUEST_EDITING_RECEIVE_HISTORY';
	var EDIT_RECEIVE_HISTORY_SUCCESS = exports.EDIT_RECEIVE_HISTORY_SUCCESS = 'EDIT_RECEIVE_HISTORY_SUCCESS';
	var EDIT_RECEIVE_HISTORY_FAILURE = exports.EDIT_RECEIVE_HISTORY_FAILURE = 'EDIT_RECEIVE_HISTORY_FAILURE';
	var RESET_EDIT_RECEIVE_HISTORY = exports.RESET_EDIT_RECEIVE_HISTORY = 'RESET_EDIT_RECEIVE_HISTORY';
	
	var DELETE_RECEIVE = exports.DELETE_RECEIVE = 'DELETE_RECEIVE';
	var DELETE_RECEIVE_FINISHED = exports.DELETE_RECEIVE_FINISHED = 'DELETE_RECEIVE_FINISHED';
	var RESET_DELETE_STATUS = exports.RESET_DELETE_STATUS = 'RESET_DELETE_STATUS';
	
	// Warehouse action types
	var SALES_ORDER_FORM_BATCHES = exports.SALES_ORDER_FORM_BATCHES = 'SALES_ORDER_FORM_BATCHES';
	var REQUEST_WAREHOUSES = exports.REQUEST_WAREHOUSES = 'REQUEST_WAREHOUSES';
	var FETCH_WAREHOUSES_SUCCESS = exports.FETCH_WAREHOUSES_SUCCESS = 'FETCH_WAREHOUSES_SUCCESS';
	var FETCH_WAREHOUSES_FAILURE = exports.FETCH_WAREHOUSES_FAILURE = 'FETCH_WAREHOUSES_FAILURE';
	var RESET_WAREHOUSES = exports.RESET_WAREHOUSES = 'RESET_WAREHOUSES';
	var SELECT_WAREHOUSE = exports.SELECT_WAREHOUSE = 'SELECT_WAREHOUSE';
	var RESET_CURRENT_WAREHOUSE = exports.RESET_CURRENT_WAREHOUSE = 'RESET_CURRENT_WAREHOUSE';
	var REQUEST_WAREHOUSE_DETAIL = exports.REQUEST_WAREHOUSE_DETAIL = 'REQUEST_WAREHOUSE_DETAIL';
	var FETCH_WAREHOUSE_DETAIL_SUCCESS = exports.FETCH_WAREHOUSE_DETAIL_SUCCESS = 'FETCH_WAREHOUSE_DETAIL_SUCCESS';
	var FETCH_WAREHOUSE_DETAIL_FAILURE = exports.FETCH_WAREHOUSE_DETAIL_FAILURE = 'FETCH_WAREHOUSE_DETAIL_FAILURE';
	var REQUEST_CREATING_WAREHOUSE = exports.REQUEST_CREATING_WAREHOUSE = 'REQUEST_CREATING_WAREHOUSE';
	var CREATE_WAREHOUSE_SUCCESS = exports.CREATE_WAREHOUSE_SUCCESS = 'CREATE_WAREHOUSE_SUCCESS';
	var CREATE_WAREHOUSE_FAILURE = exports.CREATE_WAREHOUSE_FAILURE = 'CREATE_WAREHOUSE_FAILURE';
	var REQUEST_EDITING_WAREHOUSE = exports.REQUEST_EDITING_WAREHOUSE = 'REQUEST_EDITING_WAREHOUSE';
	var EDIT_WAREHOUSE_SUCCESS = exports.EDIT_WAREHOUSE_SUCCESS = 'EDIT_WAREHOUSE_SUCCESS';
	var EDIT_WAREHOUSE_FAILURE = exports.EDIT_WAREHOUSE_FAILURE = 'EDIT_WAREHOUSE_FAILURE';
	var REQUEST_DELETE_WAREHOUSE = exports.REQUEST_DELETE_WAREHOUSE = 'REQUEST_DELETE_WAREHOUSE';
	var DELETE_WAREHOUSE_SUCCESS = exports.DELETE_WAREHOUSE_SUCCESS = 'DELETE_WAREHOUSE_SUCCESS';
	var DELETE_WAREHOUSE_FAILURE = exports.DELETE_WAREHOUSE_FAILURE = 'DELETE_WAREHOUSE_FAILURE';
	
	// Zone action types
	var REQUEST_ZONES = exports.REQUEST_ZONES = 'REQUEST_ZONES';
	var FETCH_ZONES_SUCCESS = exports.FETCH_ZONES_SUCCESS = 'FETCH_ZONES_SUCCESS';
	var FETCH_ZONES_FAILURE = exports.FETCH_ZONES_FAILURE = 'FETCH_ZONES_FAILURE';
	var SELECT_ZONE = exports.SELECT_ZONE = 'SELECT_ZONE';
	var RESET_CURRENT_ZONE = exports.RESET_CURRENT_ZONE = 'RESET_CURRENT_ZONE';
	var REQUEST_ZONE_DETAIL = exports.REQUEST_ZONE_DETAIL = 'REQUEST_ZONE_DETAIL';
	var FETCH_ZONE_DETAIL_SUCCESS = exports.FETCH_ZONE_DETAIL_SUCCESS = 'FETCH_ZONE_DETAIL_SUCCESS';
	var FETCH_ZONE_DETAIL_FAILURE = exports.FETCH_ZONE_DETAIL_FAILURE = 'FETCH_ZONE_DETAIL_FAILURE';
	var REQUEST_CREATING_ZONE = exports.REQUEST_CREATING_ZONE = 'REQUEST_CREATING_ZONE';
	var CREATE_ZONE_SUCCESS = exports.CREATE_ZONE_SUCCESS = 'CREATE_ZONE_SUCCESS';
	var CREATE_ZONE_FAILURE = exports.CREATE_ZONE_FAILURE = 'CREATE_ZONE_FAILURE';
	var REQUEST_EDITING_ZONE = exports.REQUEST_EDITING_ZONE = 'REQUEST_EDITING_ZONE';
	var EDIT_ZONE_SUCCESS = exports.EDIT_ZONE_SUCCESS = 'EDIT_ZONE_SUCCESS';
	var EDIT_ZONE_FAILURE = exports.EDIT_ZONE_FAILURE = 'EDIT_ZONE_FAILURE';
	var REQUEST_BINS = exports.REQUEST_BINS = 'REQUEST_BINS';
	var FETCH_BINS_SUCCESS = exports.FETCH_BINS_SUCCESS = 'FETCH_BINS_SUCCESS';
	var FETCH_BINS2_SUCCESS = exports.FETCH_BINS2_SUCCESS = 'FETCH_BINS2_SUCCESS';
	var FETCH_BINS3_SUCCESS = exports.FETCH_BINS3_SUCCESS = 'FETCH_BINS3_SUCCESS';
	var FETCH_BINS_FAILURE = exports.FETCH_BINS_FAILURE = 'FETCH_BINS_FAILURE';
	var RESET_BINS = exports.RESET_BINS = 'RESET_BINS';
	var SELECT_BIN = exports.SELECT_BIN = 'SELECT_BIN';
	var RESET_CURRENT_BIN = exports.RESET_CURRENT_BIN = 'RESET_CURRENT_BIN';
	var REQUEST_BIN_DETAIL = exports.REQUEST_BIN_DETAIL = 'REQUEST_BIN_DETAIL';
	var FETCH_BIN_DETAIL_SUCCESS = exports.FETCH_BIN_DETAIL_SUCCESS = 'FETCH_BIN_DETAIL_SUCCESS';
	var FETCH_BIN_DETAIL_FAILURE = exports.FETCH_BIN_DETAIL_FAILURE = 'FETCH_BIN_DETAIL_FAILURE';
	var REQUEST_CREATING_BIN = exports.REQUEST_CREATING_BIN = 'REQUEST_CREATING_BIN';
	var CREATE_BIN_SUCCESS = exports.CREATE_BIN_SUCCESS = 'CREATE_BIN_SUCCESS';
	var CREATE_BIN_FAILURE = exports.CREATE_BIN_FAILURE = 'CREATE_BIN_FAILURE';
	var REQUEST_EDITING_BIN = exports.REQUEST_EDITING_BIN = 'REQUEST_EDITING_BIN';
	var EDIT_BIN_SUCCESS = exports.EDIT_BIN_SUCCESS = 'EDIT_BIN_SUCCESS';
	var EDIT_BIN_FAILURE = exports.EDIT_BIN_FAILURE = 'EDIT_BIN_FAILURE';
	var REQUEST_DELETE_ZONE = exports.REQUEST_DELETE_ZONE = 'REQUEST_DELETE_ZONE';
	var DELETE_ZONE_SUCCESS = exports.DELETE_ZONE_SUCCESS = 'DELETE_ZONE_SUCCESS';
	var DELETE_ZONE_FAILURE = exports.DELETE_ZONE_FAILURE = 'DELETE_ZONE_FAILURE';
	var REQUEST_DELETE_BIN = exports.REQUEST_DELETE_BIN = 'REQUEST_DELETE_BIN';
	var DELETE_BIN_SUCCESS = exports.DELETE_BIN_SUCCESS = 'DELETE_BIN_SUCCESS';
	var DELETE_BIN_FAILURE = exports.DELETE_BIN_FAILURE = 'DELETE_BIN_FAILURE';
	var FETCH_LEVELS = exports.FETCH_LEVELS = "FETCH_LEVELS";
	var FETCH_LEVELS_SUCCESS = exports.FETCH_LEVELS_SUCCESS = "FETCH_LEVELS_SUCCESS";
	var FETCH_LEVELS2_SUCCESS = exports.FETCH_LEVELS2_SUCCESS = "FETCH_LEVELS2_SUCCESS";
	var FETCH_LEVELS3_SUCCESS = exports.FETCH_LEVELS3_SUCCESS = "FETCH_LEVELS3_SUCCESS";
	var FETCH_LEVELS_ERROR = exports.FETCH_LEVELS_ERROR = "FETCH_LEVELS_FAILURE";
	var CREATE_BARCODE = exports.CREATE_BARCODE = "CREATE_BARCODE";
	var CREATE_BARCODE_SUCCESS = exports.CREATE_BARCODE_SUCCESS = "CREATE_BARCODE_SUCCESS";
	var CREATE_BARCODE_FAILURE = exports.CREATE_BARCODE_FAILURE = "CREATE_BARCODE_FAILURE";
	var SELECT_LEVEL = exports.SELECT_LEVEL = 'SELECT_LEVEL';
	var REQUEST_EDITING_LEVEL = exports.REQUEST_EDITING_LEVEL = 'REQUEST_EDITING_LEVEL';
	var EDITING_LEVEL_SUCCESS = exports.EDITING_LEVEL_SUCCESS = 'EDITING_LEVEL_SUCCESS';
	var EDITING_LEVEL_FAILURE = exports.EDITING_LEVEL_FAILURE = 'EDITING_LEVEL_FAILURE';
	var CREATE_LEVEL_REQUEST = exports.CREATE_LEVEL_REQUEST = 'CREATE_LEVEL_REQUEST;';
	var CREATE_LEVEL_SUCCESS = exports.CREATE_LEVEL_SUCCESS = 'CREATE_LEVEL_SUCCESS';
	var CREATE_LEVEL_FAILURE = exports.CREATE_LEVEL_FAILURE = 'CREATE_LEVEL_FAILURE';
	var ATTACH_ZONE_BIN_LEVEL = exports.ATTACH_ZONE_BIN_LEVEL = 'ATTACH_ZONE_BIN_LEVEL';
	var ATTACH_ZONE_BIN_LEVEL_SUCCESS = exports.ATTACH_ZONE_BIN_LEVEL_SUCCESS = 'ATTACH_ZONE_BIN_LEVEL_SUCCESS';
	var ATTACH_ZONE_BIN_LEVEL_FAILURE = exports.ATTACH_ZONE_BIN_LEVEL_FAILURE = 'ATTACH_ZONE_BIN_LEVEL_FAILURE';
	var REQUEST_DELETE_LEVEL = exports.REQUEST_DELETE_LEVEL = 'REQUEST_DELETE_LEVEL';
	var DELETE_LEVEL_SUCCESS = exports.DELETE_LEVEL_SUCCESS = 'DELETE_LEVEL_SUCCESS';
	var DELETE_LEVEL_FAILURE = exports.DELETE_LEVEL_FAILURE = 'DELETE_LEVEL_FAILURE';
	
	// Sales Order action types
	var REQUEST_SALES_ORDERS = exports.REQUEST_SALES_ORDERS = 'REQUEST_SALES_ORDERS';
	var FETCH_SALES_ORDERS_SUCCESS = exports.FETCH_SALES_ORDERS_SUCCESS = 'FETCH_SALES_ORDERS_SUCCESS';
	var FETCH_SALES_ORDERS_FAILURE = exports.FETCH_SALES_ORDERS_FAILURE = 'FETCH_SALES_ORDERS_FAILURE';
	var REQUEST_SALES_ORDERS_BY_FILTER = exports.REQUEST_SALES_ORDERS_BY_FILTER = 'REQUEST_SALES_ORDERS_BY_FILTER';
	var SELECT_SALES_ORDER = exports.SELECT_SALES_ORDER = 'SELECT_SALES_ORDER';
	var RESET_CURRENT_SALES_ORDER = exports.RESET_CURRENT_SALES_ORDER = 'RESET_CURRENT_SALES_ORDER';
	var REQUEST_SALES_ORDER_DETAIL = exports.REQUEST_SALES_ORDER_DETAIL = 'REQUEST_SALES_ORDER_DETAIL';
	var FETCH_SALES_ORDER_DETAIL_SUCCESS = exports.FETCH_SALES_ORDER_DETAIL_SUCCESS = 'FETCH_SALES_ORDER_DETAIL_SUCCESS';
	var FETCH_SALES_ORDER_DETAIL_FAILURE = exports.FETCH_SALES_ORDER_DETAIL_FAILURE = 'FETCH_SALES_ORDER_DETAIL_FAILURE';
	var REQUEST_SALES_ORDER_DETAIL_BY_NUM = exports.REQUEST_SALES_ORDER_DETAIL_BY_NUM = 'REQUEST_SALES_ORDER_DETAIL_BY_NUM';
	var FETCH_SALES_ORDER_DETAIL_BY_NUM_SUCCESS = exports.FETCH_SALES_ORDER_DETAIL_BY_NUM_SUCCESS = 'FETCH_SALES_ORDER_DETAIL_BY_NUM_SUCCESS';
	var FETCH_SALES_ORDER_DETAIL_BY_NUM_FAILURE = exports.FETCH_SALES_ORDER_DETAIL_BY_NUM_FAILURE = 'FETCH_SALES_ORDER_DETAIL_BY_NUM_FAILURE';
	var REQUEST_CREATING_SALES_ORDER = exports.REQUEST_CREATING_SALES_ORDER = 'REQUEST_CREATING_SALES_ORDER';
	var CREATE_SALES_ORDER_SUCCESS = exports.CREATE_SALES_ORDER_SUCCESS = 'CREATE_SALES_ORDER_SUCCESS';
	var CREATE_SALES_ORDER_FAILURE = exports.CREATE_SALES_ORDER_FAILURE = 'CREATE_SALES_ORDER_FAILURE';
	var REQUEST_EDITING_SALES_ORDER = exports.REQUEST_EDITING_SALES_ORDER = 'REQUEST_EDITING_SALES_ORDER';
	var EDIT_SALES_ORDER_SUCCESS = exports.EDIT_SALES_ORDER_SUCCESS = 'EDIT_SALES_ORDER_SUCCESS';
	var EDIT_SALES_ORDER_FAILURE = exports.EDIT_SALES_ORDER_FAILURE = 'EDIT_SALES_ORDER_FAILURE';
	var REQUEST_SALES_INVENTORY_INFO = exports.REQUEST_SALES_INVENTORY_INFO = 'REQUEST_SALES_INVENTORY_INFO';
	var FETCH_SALES_INVENTORY_INFO_SUCCESS = exports.FETCH_SALES_INVENTORY_INFO_SUCCESS = 'FETCH_SALES_INVENTORY_INFO_SUCCESS';
	var FETCH_SALES_INVENTORY_INFO_FAILURE = exports.FETCH_SALES_INVENTORY_INFO_FAILURE = 'FETCH_SALES_INVENTORY_INFO_FAILURE';
	var REQUEST_SALES_CUSTOMER_DETAIL = exports.REQUEST_SALES_CUSTOMER_DETAIL = 'REQUEST_SALES_CUSTOMER_DETAIL';
	var REQUEST_SALES_SHIPPING_CUSTOMER_DETAIL = exports.REQUEST_SALES_SHIPPING_CUSTOMER_DETAIL = 'REQUEST_SALES_SHIPPING_CUSTOMER_DETAIL';
	var FETCH_SALES_SHIPPING_CUSTOMER_DETAIL_SUCCESS = exports.FETCH_SALES_SHIPPING_CUSTOMER_DETAIL_SUCCESS = 'FETCH_SALES_SHIPPING_CUSTOMER_DETAIL_SUCCESS';
	var FETCH_SALES_CUSTOMER_DETAIL_SUCCESS = exports.FETCH_SALES_CUSTOMER_DETAIL_SUCCESS = 'FETCH_SALES_CUSTOMER_DETAIL_SUCCESS';
	var FETCH_SALES_CUSTOMER_DETAIL_FAILURE = exports.FETCH_SALES_CUSTOMER_DETAIL_FAILURE = 'FETCH_SALES_CUSTOMER_DETAIL_FAILURE';
	var REQUEST_SHIPPING_DETAIL = exports.REQUEST_SHIPPING_DETAIL = 'REQUEST_SHIPPING_DETAIL';
	var FETCH_SHIPPING_DETAIL_SUCCESS = exports.FETCH_SHIPPING_DETAIL_SUCCESS = 'FETCH_SHIPPING_DETAIL_SUCCESS';
	var FETCH_SHIPPING_DETAIL_FAILURE = exports.FETCH_SHIPPING_DETAIL_FAILURE = 'FETCH_SHIPPING_DETAIL_FAILURE';
	var REQUEST_PURCHASES_VENDOR_DETAIL = exports.REQUEST_PURCHASES_VENDOR_DETAIL = 'REQUEST_PURCHASES_VENDOR_DETAIL';
	var FETCH_PURCHASES_VENDOR_DETAIL_SUCCESS = exports.FETCH_PURCHASES_VENDOR_DETAIL_SUCCESS = 'FETCH_PURCHASES_VENDOR_DETAIL_SUCCESS';
	var FETCH_PURCHASES_VENDOR_DETAIL_FAILURE = exports.FETCH_PURCHASES_VENDOR_DETAIL_FAILURE = 'FETCH_PURCHASES_VENDOR_DETAIL_FAILURE';
	var CLEAR_SALES_CUSTOMER_DETAILS = exports.CLEAR_SALES_CUSTOMER_DETAILS = 'CLEAR_SALES_CUSTOMER_DETAILS';
	var SET_SALES_ORDERS_FILTER = exports.SET_SALES_ORDERS_FILTER = 'SET_SALES_ORDERS_FILTER';
	var REQUEST_ITEM_SALES_HISTORY = exports.REQUEST_ITEM_SALES_HISTORY = 'REQUEST_ITEM_SALES_HISTORY';
	var FETCH_ITEM_SALES_HISTORY_SUCCESS = exports.FETCH_ITEM_SALES_HISTORY_SUCCESS = 'FETCH_ITEM_SALES_HISTORY_SUCCESS';
	var FETCH_ITEM_SALES_HISTORY_FAILURE = exports.FETCH_ITEM_SALES_HISTORY_FAILURE = 'FETCH_ITEM_SALES_HISTORY_FAILURE';
	var REQUEST_CUSTOMER_FREQUENT = exports.REQUEST_CUSTOMER_FREQUENT = 'REQUEST_CUSTOMER_FREQUENT';
	var FETCH_CUSTOMER_FREQUENT_SUCCESS = exports.FETCH_CUSTOMER_FREQUENT_SUCCESS = 'FETCH_CUSTOMER_FREQUENT_SUCCESS';
	var FETCH_CUSTOMER_FREQUENT_FAILURE = exports.FETCH_CUSTOMER_FREQUENT_FAILURE = 'FETCH_CUSTOMER_FREQUENT_FAILURE';
	var REQUEST_WHOLESALE = exports.REQUEST_WHOLESALE = 'REQUEST_WHOLESALE';
	var FETCH_WHOLESALE_SUCCESS = exports.FETCH_WHOLESALE_SUCCESS = 'FETCH_WHOLESALE_SUCCESS';
	var FETCH_WHOLESALE_FAILURE = exports.FETCH_WHOLESALE_FAILURE = 'FETCH_WHOLESALE_FAILURE';
	var SELECT_WHOLESALE = exports.SELECT_WHOLESALE = 'SELECT_WHOLESALE';
	var RESET_CURRENT_WHOLESALE = exports.RESET_CURRENT_WHOLESALE = 'RESET_CURRENT_WHOLESALE';
	var REQUEST_WHOLESALE_DETAIL = exports.REQUEST_WHOLESALE_DETAIL = 'REQUEST_WHOLESALE_DETAIL';
	var FETCH_WHOLESALE_DETAIL_SUCCESS = exports.FETCH_WHOLESALE_DETAIL_SUCCESS = 'FETCH_WHOLESALE_DETAIL_SUCCESS';
	var FETCH_WHOLESALE_DETAIL_FAILURE = exports.FETCH_WHOLESALE_DETAIL_FAILURE = 'FETCH_WHOLESALE_DETAIL_FAILURE';
	var REQUEST_CREATING_WHOLESALE = exports.REQUEST_CREATING_WHOLESALE = 'REQUEST_CREATING_WHOLESALE';
	var CREATE_WHOLESALE_SUCCESS = exports.CREATE_WHOLESALE_SUCCESS = 'CREATE_WHOLESALE_SUCCESS';
	var CREATE_WHOLESALE_FAILURE = exports.CREATE_WHOLESALE_FAILURE = 'CREATE_WHOLESALE_FAILURE';
	var REQUEST_EDITING_WHOLESALE = exports.REQUEST_EDITING_WHOLESALE = 'REQUEST_EDITING_WHOLESALE';
	var EDIT_WHOLESALE_SUCCESS = exports.EDIT_WHOLESALE_SUCCESS = 'EDIT_WHOLESALE_SUCCESS';
	var EDIT_WHOLESALE_FAILURE = exports.EDIT_WHOLESALE_FAILURE = 'EDIT_WHOLESALE_FAILURE';
	var REQUEST_VOID_SALES_ORDER = exports.REQUEST_VOID_SALES_ORDER = 'REQUEST_VOID_SALES_ORDER';
	var VOID_SALES_ORDER_SUCCESS = exports.VOID_SALES_ORDER_SUCCESS = 'VOID_SALES_ORDER_SUCCESS';
	var VOID_SALES_ORDER_FAILURE = exports.VOID_SALES_ORDER_FAILURE = 'VOID_SALES_ORDER_FAILURE';
	var REQUEST_WAREHOUSE_SALES_ORDERS = exports.REQUEST_WAREHOUSE_SALES_ORDERS = 'REQUEST_WAREHOUSE_SALES_ORDERS';
	var FETCH_WAREHOUSE_SALES_ORDERS_SUCCESS = exports.FETCH_WAREHOUSE_SALES_ORDERS_SUCCESS = 'FETCH_WAREHOUSE_SALES_ORDERS_SUCCESS';
	var FETCH_WAREHOUSE_SALES_ORDERS_FAILURE = exports.FETCH_WAREHOUSE_SALES_ORDERS_FAILURE = 'FETCH_WAREHOUSE_SALES_ORDERS_FAILURE';
	var REQUEST_WAREHOUSE_PURCHASE_ORDERS = exports.REQUEST_WAREHOUSE_PURCHASE_ORDERS = 'REQUEST_WAREHOUSE_PURCHASE_ORDERS';
	var FETCH_WAREHOUSE_PURCHASE_ORDERS_SUCCESS = exports.FETCH_WAREHOUSE_PURCHASE_ORDERS_SUCCESS = 'FETCH_WAREHOUSE_PURCHASE_ORDERS_SUCCESS';
	var FETCH_WAREHOUSE_PURCHASE_ORDERS_FAILURE = exports.FETCH_WAREHOUSE_PURCHASE_ORDERS_FAILURE = 'FETCH_WAREHOUSE_PURCHASE_ORDERS_FAILURE';
	var REQUEST_WAREHOUSE_BINS = exports.REQUEST_WAREHOUSE_BINS = 'REQUEST_WAREHOUSE_BINS';
	var FETCH_WAREHOUSE_BINS_SUCCESS = exports.FETCH_WAREHOUSE_BINS_SUCCESS = 'FETCH_WAREHOUSE_BINS_SUCCESS';
	var FETCH_WAREHOUSE_BINS_FAILURE = exports.FETCH_WAREHOUSE_BINS_FAILURE = 'FETCH_WAREHOUSE_BINS_FAILURE';
	var REQUEST_CUSTOMER_SALES_HISTORY = exports.REQUEST_CUSTOMER_SALES_HISTORY = 'REQUEST_CUSTOMER_ORDER_SCHEDULES';
	var FETCH_CUSTOMER_SALES_HISTORY_SUCCESS = exports.FETCH_CUSTOMER_SALES_HISTORY_SUCCESS = 'FETCH_CUSTOMER_SALES_HISTORY_SUCCESS';
	var FETCH_CUSTOMER_SALES_HISTORY_FAILURE = exports.FETCH_CUSTOMER_SALES_HISTORY_FAILURE = 'FETCH_CUSTOMER_SALES_HISTORY_FAILURE';
	var REQUEST_CUSTOMER_ORDER_SCHEDULES = exports.REQUEST_CUSTOMER_ORDER_SCHEDULES = 'REQUEST_CUSTOMER_ORDER_SCHEDULES';
	var FETCH_CUSTOMER_ORDER_SCHEDULES_SUCCESS = exports.FETCH_CUSTOMER_ORDER_SCHEDULES_SUCCESS = 'FETCH_CUSTOMER_ORDER_SCHEDULES_SUCCESS';
	var FETCH_CUSTOMER_ORDER_SCHEDULES_FAILURE = exports.FETCH_CUSTOMER_ORDER_SCHEDULES_FAILURE = 'FETCH_CUSTOMER_ORDER_SCHEDULES_FAILURE';
	var REQUEST_TODAYS_OUTGOING_ORDERS = exports.REQUEST_TODAYS_OUTGOING_ORDERS = 'REQUEST_TODAYS_OUTGOING_ORDERS';
	var FETCH_TODAYS_OUTGOING_ORDERS_SUCCESS = exports.FETCH_TODAYS_OUTGOING_ORDERS_SUCCESS = 'FETCH_TODAYS_OUTGOING_ORDERS_SUCCESS';
	var FETCH_TODAYS_OUTGOING_ORDERS_FAILURE = exports.FETCH_TODAYS_OUTGOING_ORDERS_FAILURE = 'FETCH_TODAYS_OUTGOING_ORDERS_FAILURE';
	var REQUEST_SALES_ORDER_LINE_WEIGHTS = exports.REQUEST_SALES_ORDER_LINE_WEIGHTS = 'REQUEST_SALES_ORDER_LINE_WEIGHTS';
	var FETCH_SALES_ORDER_LINE_WEIGHTS_SUCCESS = exports.FETCH_SALES_ORDER_LINE_WEIGHTS_SUCCESS = 'FETCH_SALES_ORDER_LINE_WEIGHTS_SUCCESS';
	var FETCH_SALES_ORDER_LINE_WEIGHTS_FAILURE = exports.FETCH_SALES_ORDER_LINE_WEIGHTS_FAILURE = 'FETCH_SALES_ORDER_LINE_WEIGHTS_FAILURE';
	var REQUEST_SET_ORDER_LINE_WEIGHTS = exports.REQUEST_SET_ORDER_LINE_WEIGHTS = 'REQUEST_SET_ORDER_LINE_WEIGHTS';
	var EDIT_SALES_ORDER_LINE_WEIGHTS_SUCCESS = exports.EDIT_SALES_ORDER_LINE_WEIGHTS_SUCCESS = 'EDIT_SALES_ORDER_LINE_WEIGHTS_SUCCESS';
	var EDIT_SALES_ORDER_LINE_WEIGHTS_FAILURE = exports.EDIT_SALES_ORDER_LINE_WEIGHTS_FAILURE = 'EDIT_SALES_ORDER_LINE_WEIGHTS_FAILURE';
	var CLEAR_SALES_ORDER_LINE_WEIGHTS = exports.CLEAR_SALES_ORDER_LINE_WEIGHTS = 'CLEAR_SALES_ORDER_LINE_WEIGHTS';
	var REQUEST_SET_SHIPPING_WEIGHT = exports.REQUEST_SET_SHIPPING_WEIGHT = 'REQUEST_SET_SHIPPING_WEIGHT';
	var UPDATE_SHIPPING_WEIGHT_SUCCESS = exports.UPDATE_SHIPPING_WEIGHT_SUCCESS = 'UPDATE_SHIPPING_WEIGHT_SUCCESS';
	var UPDATE_SHIPPING_WEIGHT_FAILURE = exports.UPDATE_SHIPPING_WEIGHT_FAILURE = 'UPDATE_SHIPPING_WEIGHT_FAILURE';
	var REQUEST_SET_SHIPPING_WEIGHT_SPLIT = exports.REQUEST_SET_SHIPPING_WEIGHT_SPLIT = 'REQUEST_SET_SHIPPING_WEIGHT_SPLIT';
	var UPDATE_CURRENT_SALES_ORDER_DETAIL_SHIPPINGINFO = exports.UPDATE_CURRENT_SALES_ORDER_DETAIL_SHIPPINGINFO = "UPDATE_CURRENT_SALES_ORDER_DETAIL_SHIPPINGINFO";
	var REQUEST_SALES_ORDER_FORM = exports.REQUEST_SALES_ORDER_FORM = 'REQUEST_SALES_ORDER_FORM';
	var FETCH_SALES_ORDER_FORM_SUCCESS = exports.FETCH_SALES_ORDER_FORM_SUCCESS = 'FETCH_SALES_ORDER_FORM_SUCCESS';
	var FETCH_SALES_ORDER_FORM_FAILURE = exports.FETCH_SALES_ORDER_FORM_FAILURE = 'FETCH_SALES_ORDER_FORM_FAILURE';
	var CLEAR_INVENTORIES = exports.CLEAR_INVENTORIES = 'CLEAR_INVENTORIES';
	var REQUEST_SALES_CSV = exports.REQUEST_SALES_CSV = 'REQUEST_SALES_CSV';
	var FETCH_SALES_CSV_SUCCESS = exports.FETCH_SALES_CSV_SUCCESS = 'FETCH_SALES_CSV_SUCCESS';
	var FETCH_SALES_CSV_FAILURE = exports.FETCH_SALES_CSV_FAILURE = 'FETCH_SALES_CSV_FAILURE';
	var REQUEST_SAVE_POS_SALE = exports.REQUEST_SAVE_POS_SALE = 'REQUEST_SAVE_POS_SALE';
	var SAVE_POS_SALE_SUCCESS = exports.SAVE_POS_SALE_SUCCESS = 'SAVE_POS_SALE_SUCCESS';
	var SAVE_POS_SALE_FAILURE = exports.SAVE_POS_SALE_FAILURE = 'SAVE_POS_SALE_FAILURE';
	var INVALID_CHARACTER_ENTERED = exports.INVALID_CHARACTER_ENTERED = 'INVALID_CHARACTER_ENTERED';
	var CLEAR_ERROR_MESSAGE_IN_POS = exports.CLEAR_ERROR_MESSAGE_IN_POS = 'CLEAR_ERROR_MESSAGE_IN_POS';
	var REQUEST_POS_ORDERS = exports.REQUEST_POS_ORDERS = 'REQUEST_POS_ORDERS';
	var FETCH_POS_ORDERS_SUCCESS = exports.FETCH_POS_ORDERS_SUCCESS = 'FETCH_POS_ORDERS_SUCCESS';
	var FETCH_POS_ORDERS_FAILURE = exports.FETCH_POS_ORDERS_FAILURE = 'FETCH_POS_ORDERS_FAILURE';
	var REQUEST_POS_ORDER_DETAIL = exports.REQUEST_POS_ORDER_DETAIL = 'REQUEST_POS_ORDER_DETAIL';
	var FETCH_POS_ORDER_DETAIL_SUCCESS = exports.FETCH_POS_ORDER_DETAIL_SUCCESS = 'FETCH_POS_ORDER_DETAIL_SUCCESS';
	var FETCH_POS_ORDER_DETAIL_FAILURE = exports.FETCH_POS_ORDER_DETAIL_FAILURE = 'FETCH_POS_ORDER_DETAIL_FAILURE';
	var REQUEST_VOID_POS_ORDER = exports.REQUEST_VOID_POS_ORDER = 'REQUEST_VOID_POS_ORDER';
	var VOID_POS_ORDER_SUCCESS = exports.VOID_POS_ORDER_SUCCESS = 'VOID_POS_ORDER_SUCCESS';
	var VOID_POS_ORDER_FAILURE = exports.VOID_POS_ORDER_FAILURE = 'VOID_POS_ORDER_FAILURE';
	var REQUEST_POS_CREDITS = exports.REQUEST_POS_CREDITS = 'REQUEST_POS_CREDITS';
	var FETCH_POS_CREDITS_SUCCESS = exports.FETCH_POS_CREDITS_SUCCESS = 'FETCH_POS_CREDITS_SUCCESS';
	var FETCH_POS_CREDITS_FAILURE = exports.FETCH_POS_CREDITS_FAILURE = 'FETCH_POS_CREDITS_FAILURE';
	var REQUEST_POS_CREDIT_DETAIL = exports.REQUEST_POS_CREDIT_DETAIL = 'REQUEST_POS_CREDIT_DETAIL';
	var FETCH_POS_CREDIT_DETAIL_SUCCESS = exports.FETCH_POS_CREDIT_DETAIL_SUCCESS = 'FETCH_POS_CREDIT_DETAIL_SUCCESS';
	var FETCH_POS_CREDIT_DETAIL_FAILURE = exports.FETCH_POS_CREDIT_DETAIL_FAILURE = 'FETCH_POS_CREDIT_DETAIL_FAILURE';
	var REQUEST_EDIT_POS_PAYMENT = exports.REQUEST_EDIT_POS_PAYMENT = 'REQUEST_EDIT_POS_PAYMENT';
	var EDIT_POS_PAYMENT_SUCCESS = exports.EDIT_POS_PAYMENT_SUCCESS = 'EDIT_POS_PAYMENT_SUCCESS';
	var EDIT_POS_PAYMENT_FAILURE = exports.EDIT_POS_PAYMENT_FAILURE = 'EDIT_POS_PAYMENT_FAILURE';
	var FETCH_POS_HOLDS_SUCCESS = exports.FETCH_POS_HOLDS_SUCCESS = 'FETCH_POS_HOLDS_SUCCESS';
	var FETCH_POS_HOLDS_DETAILS_SUCCESS = exports.FETCH_POS_HOLDS_DETAILS_SUCCESS = 'FETCH_POS_HOLDS_DETAILS_SUCCESS';
	var CHARGE_NOT_MET = exports.CHARGE_NOT_MET = 'CHARGE_NOT_MET';
	var START_NEW_ORDER = exports.START_NEW_ORDER = 'START_NEW_ORDER';
	var REQUEST_DRAFT_DETAILS = exports.REQUEST_DRAFT_DETAILS = 'REQUEST_DRAFT_DETAILS';
	var LOAD_DRAFT_SUCCESS = exports.LOAD_DRAFT_SUCCESS = 'LOAD_DRAFT_SUCCESS';
	var LOAD_DRAFT_FAILURE = exports.LOAD_DRAFT_FAILURE = 'LOAD_DRAFT_FAILURE';
	var REQUEST_DRAFTS = exports.REQUEST_DRAFTS = 'REQUEST_DRAFTS';
	var FETCH_DRAFTS_SUCCESSFUL = exports.FETCH_DRAFTS_SUCCESSFUL = 'FETCH_DRAFTS_SUCCESSFUL';
	var FETCH_DRAFTS_FAILURE = exports.FETCH_DRAFTS_FAILURE = 'FETCH_DRAFTS_FAILURE';
	var REQUEST_CREATING_SALES_RETURN = exports.REQUEST_CREATING_SALES_RETURN = 'REQUEST_CREATING_SALES_RETURN';
	var CREATE_SALES_RETURN_SUCCESS = exports.CREATE_SALES_RETURN_SUCCESS = 'CREATE_SALES_RETURN_SUCCESS';
	var CREATE_SALES_RETURN_FAILURE = exports.CREATE_SALES_RETURN_FAILURE = 'CREATE_SALES_RETURN_FAILURE';
	var REQUEST_SALES_RETURN_DETAIL = exports.REQUEST_SALES_RETURN_DETAIL = 'REQUEST_SALES_RETURN_DETAIL';
	var FETCH_SALES_RETURN_DETAIL_SUCCESS = exports.FETCH_SALES_RETURN_DETAIL_SUCCESS = 'FETCH_SALES_RETURN_DETAIL_SUCCESS';
	var FETCH_SALES_RETURN_DETAIL_FAILURE = exports.FETCH_SALES_RETURN_DETAIL_FAILURE = 'FETCH_SALES_RETURN_DETAIL_FAILURE';
	var REQUEST_SALES_INVOICES_COMPLETED = exports.REQUEST_SALES_INVOICES_COMPLETED = 'REQUEST_SALES_INVOICES_COMPLETED';
	var FETCH_SALES_INVOICES_COMPLETED_SUCCESS = exports.FETCH_SALES_INVOICES_COMPLETED_SUCCESS = 'FETCH_SALES_INVOICES_COMPLETED_SUCCESS';
	var FETCH_SALES_INVOICES_COMPLETED_FAILURE = exports.FETCH_SALES_INVOICES_COMPLETED_FAILURE = 'FETCH_SALES_INVOICES_COMPLETED_FAILURE';
	var REQUEST_SALES_ORDER_TO_QUOTE = exports.REQUEST_SALES_ORDER_TO_QUOTE = 'REQUEST_SALES_ORDER_TO_QUOTE';
	var SALES_ORDER_TO_QUOTE_SUCCESS = exports.SALES_ORDER_TO_QUOTE_SUCCESS = 'SALES_ORDER_TO_QUOTE_SUCCESS';
	var SALES_ORDER_TO_QUOTE_FAILURE = exports.SALES_ORDER_TO_QUOTE_FAILURE = 'SALES_ORDER_TO_QUOTE_FAILURE';
	var REQUEST_SALES_QUOTE_TO_OPEN = exports.REQUEST_SALES_QUOTE_TO_OPEN = 'REQUEST_SALES_QUOTE_TO_OPEN';
	var REQUEST_SALES_QUOTE_TO_ORDER_SUCCESS = exports.REQUEST_SALES_QUOTE_TO_ORDER_SUCCESS = 'REQUEST_SALES_QUOTE_TO_ORDER_SUCCESS';
	var REQUEST_SALES_QUOTE_TO_ORDER_FAILURE = exports.REQUEST_SALES_QUOTE_TO_ORDER_FAILURE = 'REQUEST_SALES_QUOTE_TO_ORDER_FAILURE';
	var REQUEST_CUSTOMER_ITEM = exports.REQUEST_CUSTOMER_ITEM = 'REQUEST_CUSTOMER_ITEM';
	var FETCH_CUSTOMER_ITEM_SUCCESS = exports.FETCH_CUSTOMER_ITEM_SUCCESS = 'FETCH_CUSTOMER_ITEM_SUCCESS';
	var FETCH_CUSTOMER_ITEM_FAILURE = exports.FETCH_CUSTOMER_ITEM_FAILURE = 'FETCH_CUSTOMER_ITEM_FAILURE';
	var REQUEST_INVENTORY_RETURN = exports.REQUEST_INVENTORY_RETURN = 'REQUEST_INVENTORY_RETURN';
	var FETCH_INVENTORY_RETURN_SUCCESS = exports.FETCH_INVENTORY_RETURN_SUCCESS = 'FETCH_INVENTORY_RETURN_SUCCESS';
	var FETCH_INVENTORY_RETURN_FAILURE = exports.FETCH_INVENTORY_RETURN_FAILURE = 'FETCH_INVENTORY_RETURN_FAILURE';
	var REQUEST_INVENTORY_RETURN_DETAILS = exports.REQUEST_INVENTORY_RETURN_DETAILS = 'REQUEST_INVENTORY_RETURN_DETAILS';
	var FETCH_INVENTORY_RETURN_DETAILS_SUCCESS = exports.FETCH_INVENTORY_RETURN_DETAILS_SUCCESS = 'FETCH_INVENTORY_RETURN_DETAILS_SUCCESS';
	var FETCH_INVENTORY_RETURN_DETAILS_FAILURE = exports.FETCH_INVENTORY_RETURN_DETAILS_FAILURE = 'FETCH_INVENTORY_RETURN_DETAILS_FAILURE';
	var EDIT_INVENTORY_RETURN = exports.EDIT_INVENTORY_RETURN = 'EDIT_INVENTORY_RETURN';
	var EDIT_INVENTORY_RETURN_SUCCESS = exports.EDIT_INVENTORY_RETURN_SUCCESS = 'EDIT_INVENTORY_RETURN_SUCCESS';
	var EDIT_INVENTORY_RETURN_FAILURE = exports.EDIT_INVENTORY_RETURN_FAILURE = 'EDIT_INVENTORY_RETURN_FAILURE';
	var REQUEST_CUSTOMER_PRICES = exports.REQUEST_CUSTOMER_PRICES = 'REQUEST_CUSTOMER_PRICES';
	var FETCH_CUSTOMER_PRICES_SUCCESS = exports.FETCH_CUSTOMER_PRICES_SUCCESS = 'FETCH_CUSTOMER_PRICES_SUCCESS';
	var FETCH_CUSTOMER_PRICES_FAILURE = exports.FETCH_CUSTOMER_PRICES_FAILURE = 'FETCH_CUSTOMER_PRICES_FAILURE';
	var REQUEST_CURRENCY_RATES = exports.REQUEST_CURRENCY_RATES = 'REQUEST_CURRENCY_RATES';
	var FETCH_CURRENCY_RATES_SUCCESS = exports.FETCH_CURRENCY_RATES_SUCCESS = 'FETCH_CURRENCY_RATES_SUCCESS';
	var FETCH_CURRENCY_RATES_FAILURE = exports.FETCH_CURRENCY_RATES_FAILURE = 'FETCH_CURRENCY_RATES_FAILURE';
	var EDIT_MULTI_CURRENCIES = exports.EDIT_MULTI_CURRENCIES = 'EDIT_MULTI_CURRENCIES';
	var EDIT_MULTI_CURRENCIES_SUCCESS = exports.EDIT_MULTI_CURRENCIES_SUCCESS = 'EDIT_MULTI_CURRENCIES_SUCCESS';
	var EDIT_MULTI_CURRENCIES_FAILURE = exports.EDIT_MULTI_CURRENCIES_FAILURE = 'EDIT_MULTI_CURRENCIES_FAILURE';
	var REQUEST_TAX_RATES = exports.REQUEST_TAX_RATES = 'REQUEST_TAX_RATES';
	var FETCH_TAX_RATES_SUCCESS = exports.FETCH_TAX_RATES_SUCCESS = 'FETCH_TAX_RATES_SUCCESS';
	var FETCH_TAX_RATES_FAILURE = exports.FETCH_TAX_RATES_FAILURE = 'FETCH_TAX_RATES_FAILURE';
	var REQUEST_CREATE_TAX_RATE = exports.REQUEST_CREATE_TAX_RATE = 'REQUEST_CREATE_TAX_RATE';
	var CREATE_TAX_RATE_SUCCESS = exports.CREATE_TAX_RATE_SUCCESS = 'CREATE_TAX_RATE_SUCCESS';
	var CREATE_TAX_RATE_FAILURE = exports.CREATE_TAX_RATE_FAILURE = 'CREATE_TAX_RATE_FAILURE';
	var REQUEST_OVERALL_SALES_PERFORMANCE = exports.REQUEST_OVERALL_SALES_PERFORMANCE = 'REQUEST_OVERALL_SALES_PERFORMANCE';
	var FETCH_OVERALL_SALES_PERFORMANCE_SUCCESS = exports.FETCH_OVERALL_SALES_PERFORMANCE_SUCCESS = 'FETCH_OVERALL_SALES_PERFORMANCE_SUCCESS';
	var FETCH_OVERALL_SALES_PERFORMANCE_FAILURE = exports.FETCH_OVERALL_SALES_PERFORMANCE_FAILURE = 'FETCH_OVERALL_SALES_PERFORMANCE_FAILURE';
	var REQUEST_SALES_ORDER_INVENTORY = exports.REQUEST_SALES_ORDER_INVENTORY = 'REQUEST_SALES_ORDER_INVENTORY';
	var FETCH_SALES_ORDER_INVENTORY_SUCCESS = exports.FETCH_SALES_ORDER_INVENTORY_SUCCESS = 'FETCH_SALES_ORDER_INVENTORY_SUCCESS';
	var FETCH_SALES_ORDER_INVENTORY_FAILURE = exports.FETCH_SALES_ORDER_INVENTORY_FAILURE = 'FETCH_SALES_ORDER_INVENTORY_FAILURE';
	var REQUEST_POS_REPORT = exports.REQUEST_POS_REPORT = 'REQUEST_POS_REPORT';
	var FETCH_POS_REPORT_SUCCESS = exports.FETCH_POS_REPORT_SUCCESS = 'FETCH_POS_REPORT_SUCCESS';
	var FETCH_POS_REPORT_FAILURE = exports.FETCH_POS_REPORT_FAILURE = 'FETCH_POS_REPORT_FAILURE';
	var REQUEST_SALES_PERFORMANCE = exports.REQUEST_SALES_PERFORMANCE = 'REQUEST_SALES_PERFORMANCE';
	var REQUEST_SALES_PERFORMANCE_BY_FILTER = exports.REQUEST_SALES_PERFORMANCE_BY_FILTER = 'REQUEST_SALES_PERFORMANCE_BY_FILTER';
	var REQUEST_SALES_PERFORMANCE_SUCCESS = exports.REQUEST_SALES_PERFORMANCE_SUCCESS = 'REQUEST_SALES_PERFORMANCE_SUCCESS';
	var REQUEST_SALES_PERFORMANCE_FAILURE = exports.REQUEST_SALES_PERFORMANCE_FAILURE = 'REQUEST_SALES_PERFORMANCE_FAILURE';
	var REQUEST_USER_PERFORMANCE_BY_FILTER = exports.REQUEST_USER_PERFORMANCE_BY_FILTER = 'REQUEST_USER_PERFORMANCE_BY_FILTER';
	var REQUEST_USER_PERFORMANCE_SUCCESS = exports.REQUEST_USER_PERFORMANCE_SUCCESS = 'REQUEST_USER_PERFORMANCE_SUCCESS';
	var REQUEST_USER_PERFORMANCE_FAILURE = exports.REQUEST_USER_PERFORMANCE_FAILURE = 'REQUEST_USER_PERFORMANCE_FAILURE';
	var REQUEST_SALES_DASHBOARD_DETAIL = exports.REQUEST_SALES_DASHBOARD_DETAIL = 'REQUEST_SALES_DASHBOARD_DETAIL';
	var FETCH_SALES_DASHBOARD_DETAIL_SUCCESS = exports.FETCH_SALES_DASHBOARD_DETAIL_SUCCESS = 'FETCH_SALES_DASHBOARD_DETAIL_SUCCESS';
	var FETCH_SALES_DASHBOARD_DETAIL_FAILURE = exports.FETCH_SALES_DASHBOARD_DETAIL_FAILURE = 'FETCH_SALES_DASHBOARD_DETAIL_FAILURE';
	var REQUEST_SALES_LEVELS = exports.REQUEST_SALES_LEVELS = 'REQUEST_SALES_LEVELS';
	var FETCH_SALES_LEVELS_SUCCESS = exports.FETCH_SALES_LEVELS_SUCCESS = 'FETCH_SALES_LEVELS_SUCCESS';
	var FETCH_SALES_LEVELS_FAILURE = exports.FETCH_SALES_LEVELS_FAILURE = 'FETCH_SALES_LEVELS_FAILURE';
	var REQUEST_REFUND = exports.REQUEST_REFUND = 'REQUEST_REFUND';
	var REQUEST_REFUND_SUCCESS = exports.REQUEST_REFUND_SUCCESS = 'REQUEST_REFUND_SUCCESS';
	var REQUEST_REFUND_FAILURE = exports.REQUEST_REFUND_FAILURE = 'REQUEST_REFUND_FAILURE';
	var REQUEST_REFUND_PDF = exports.REQUEST_REFUND_PDF = 'REQUEST_REFUND_PDF';
	var REQUEST_REFUND_PDF_SUCCESS = exports.REQUEST_REFUND_PDF_SUCCESS = 'REQUEST_REFUND_PDF_SUCCESS';
	var REQUEST_RETURN_VOID = exports.REQUEST_RETURN_VOID = 'REQUEST_RETURN_VOID';
	var REQUEST_RETURN_COMPLETE = exports.REQUEST_RETURN_COMPLETE = 'REQUEST_RETURN_COMPLETE';
	var FETCH_RETURN_SUCCESS = exports.FETCH_RETURN_SUCCESS = 'FETCH_RETURN_SUCCESS';
	var FETCH_RETURN_FAILURE = exports.FETCH_RETURN_FAILURE = 'FETCH_RETURN_FAILURE';
	var REQUEST_PRODUCT_BY_ID = exports.REQUEST_PRODUCT_BY_ID = 'REQUEST_PRODUCT_BY_ID';
	var FETCH_PRODUCT_BY_ID_SUCCESS = exports.FETCH_PRODUCT_BY_ID_SUCCESS = 'FETCH_PRODUCT_BY_ID_SUCCESS';
	var FETCH_PRODUCT_BY_ID_FAILURE = exports.FETCH_PRODUCT_BY_ID_FAILURE = 'FETCH_PRODUCT_BY_ID_FAILURE';
	var FETCH_PRODUCT_BY_ID = exports.FETCH_PRODUCT_BY_ID = 'FETCH_PRODUCT_BY_ID';
	var FETCH_SALES_ORDER_SUGGESTIONS_SUCCESS = exports.FETCH_SALES_ORDER_SUGGESTIONS_SUCCESS = 'FETCH_SALES_ORDER_SUGGESTIONS_SUCCESS';
	var FETCH_SALES_ORDER_SUGGESTIONS_FAILURE = exports.FETCH_SALES_ORDER_SUGGESTIONS_FAILURE = 'FETCH_SALES_ORDER_SUGGESTIONS_FAILURE';
	var FETCH_SALES_ORDER_SUGGESTIONS = exports.FETCH_SALES_ORDER_SUGGESTIONS = 'FETCH_SALES_ORDER_SUGGESTIONS';
	var FETCH_PURCHASE_ORDER_SUGGESTIONS = exports.FETCH_PURCHASE_ORDER_SUGGESTIONS = 'FETCH_PURCHASE_ORDER_SUGGESTIONS';
	var FETCH_PURCHASE_ORDER_SUGGESTIONS_SUCCESS = exports.FETCH_PURCHASE_ORDER_SUGGESTIONS_SUCCESS = 'FETCH_PURCHASE_ORDER_SUGGESTIONS_SUCCESS';
	var FETCH_PURCHASE_ORDER_SUGGESTIONS_FAILURE = exports.FETCH_PURCHASE_ORDER_SUGGESTIONS_FAILURE = 'FETCH_PURCHASE_ORDER_SUGGESTIONS_FAILURE';
	var FETCH_PRODUCT_SUGGESTIONS = exports.FETCH_PRODUCT_SUGGESTIONS = 'FETCH_PRODUCT_SUGGESTIONS';
	var FETCH_PRODUCT_SUGGESTIONS_SUCCESS = exports.FETCH_PRODUCT_SUGGESTIONS_SUCCESS = 'FETCH_PRODUCT_SUGGESTIONS_SUCCESS';
	var FETCH_PRODUCT_SUGGESTIONS_FAILURE = exports.FETCH_PRODUCT_SUGGESTIONS_FAILURE = 'FETCH_PRODUCT_SUGGESTIONS_FAILURE';
	var REQUEST_SALES_TOTALS = exports.REQUEST_SALES_TOTALS = 'REQUEST_SALES_TOTALS';
	var FETCH_SALES_TOTALS_SUCCESS = exports.FETCH_SALES_TOTALS_SUCCESS = 'FETCH_SALES_TOTALS_SUCCESS';
	var FETCH_SALES_TOTALS_FAILURE = exports.FETCH_SALES_TOTALS_FAILURE = 'FETCH_SALES_TOTALS_FAILURE';
	var CREATE_MOBILE_TASK = exports.CREATE_MOBILE_TASK = 'CREATE_MOBILE_TASK_SUCCESS';
	var CREATE_MOBILE_TASK_SUCCESS = exports.CREATE_MOBILE_TASK_SUCCESS = 'CREATE_MOBILE_TASK_SUCCESS';
	var CREATE_MOBILE_TASK_FAILURE = exports.CREATE_MOBILE_TASK_FAILURE = 'CREATE_MOBILE_TASK_SUCCESS';
	
	var KEEP_EST_DATE = exports.KEEP_EST_DATE = 'KEEP_EST_DATE';
	var FINISHED_UNMOUNT = exports.FINISHED_UNMOUNT = 'FINISHED_UNMOUNT';
	var DESTROY_EST_DATE = exports.DESTROY_EST_DATE = 'DESTROY_EST_DATE';
	
	// Favorite List action types
	var REQUEST_CUSTOMER_FAVORITES = exports.REQUEST_CUSTOMER_FAVORITES = 'REQUEST_CUSTOMER_FAVORITES';
	var FETCH_CUSTOMER_FAVORITES_SUCCESS = exports.FETCH_CUSTOMER_FAVORITES_SUCCESS = 'FETCH_CUSTOMER_FAVORITES_SUCCESS';
	var FETCH_CUSTOMER_FAVORITES_FAILURE = exports.FETCH_CUSTOMER_FAVORITES_FAILURE = 'FETCH_CUSTOMER_FAVORITES_FAILURE';
	var SELECT_CUSTOMER_FAVORITES = exports.SELECT_CUSTOMER_FAVORITES = 'SELECT_CUSTOMER_FAVORITES';
	var RESET_CURRENT_CUSTOMER_FAVORITES = exports.RESET_CURRENT_CUSTOMER_FAVORITES = 'RESET_CURRENT_CUSTOMER_FAVORITES';
	var REQUEST_CUSTOMER_FAVORITES_DETAIL = exports.REQUEST_CUSTOMER_FAVORITES_DETAIL = 'REQUEST_CUSTOMER_FAVORITES_DETAIL';
	var FETCH_CUSTOMER_FAVORITES_DETAIL_SUCCESS = exports.FETCH_CUSTOMER_FAVORITES_DETAIL_SUCCESS = 'FETCH_CUSTOMER_FAVORITES_DETAIL_SUCCESS';
	var FETCH_CUSTOMER_FAVORITES_DETAIL_FAILURE = exports.FETCH_CUSTOMER_FAVORITES_DETAIL_FAILURE = 'FETCH_CUSTOMER_FAVORITES_DETAIL_FAILURE';
	var REQUEST_ADDING_CUSTOMER_FAVORITE = exports.REQUEST_ADDING_CUSTOMER_FAVORITE = 'REQUEST_ADDING_CUSTOMER_FAVORITE';
	var ADD_CUSTOMER_FAVORITE_SUCCESS = exports.ADD_CUSTOMER_FAVORITE_SUCCESS = 'ADD_CUSTOMER_FAVORITE_SUCCESS';
	var ADD_CUSTOMER_FAVORITE_FAILURE = exports.ADD_CUSTOMER_FAVORITE_FAILURE = 'ADD_CUSTOMER_FAVORITE_FAILURE';
	var REQUEST_DELETE_CUSTOMER_FAVORITE = exports.REQUEST_DELETE_CUSTOMER_FAVORITE = 'REQUEST_DELETE_CUSTOMER_FAVORITE';
	var DELETE_CUSTOMER_FAVORITE_SUCCESS = exports.DELETE_CUSTOMER_FAVORITE_SUCCESS = 'DELETE_CUSTOMER_FAVORITE_SUCCESS';
	var DELETE_CUSTOMER_FAVORITE_FAILURE = exports.DELETE_CUSTOMER_FAVORITE_FAILURE = 'DELETE_CUSTOMER_FAVORITE_FAILURE';
	var FETCH_CUSTOMERS_WITH_FAVORITES = exports.FETCH_CUSTOMERS_WITH_FAVORITES = 'FETCH_CUSTOMERS_WITH_FAVORITES';
	var REQUEST_CUSTOMERS_WITH_FAVORITES = exports.REQUEST_CUSTOMERS_WITH_FAVORITES = 'REQUEST_CUSTOMERS_WITH_FAVORITES';
	var FETCH_CUSTOMERS_WITH_FAVORITES_SUCCESS = exports.FETCH_CUSTOMERS_WITH_FAVORITES_SUCCESS = 'FETCH_CUSTOMERS_WITH_FAVORITES_SUCCESS';
	var FETCH_CUSTOMERS_WITH_FAVORITES_FAILURE = exports.FETCH_CUSTOMERS_WITH_FAVORITES_FAILURE = 'FETCH_CUSTOMERS_WITH_FAVORITES_FAILURE';
	var REQUEST_ADDING_NEW_FAVORITE_LIST = exports.REQUEST_ADDING_NEW_FAVORITE_LIST = 'REQUEST_ADDING_NEW_FAVORITE_LIST';
	var ADD_NEW_FAVORITE_LIST_SUCCESS = exports.ADD_NEW_FAVORITE_LIST_SUCCESS = 'ADD_NEW_FAVORITE_LIST_SUCCESS';
	var ADD_NEW_FAVORITE_LIST_FAILURE = exports.ADD_NEW_FAVORITE_LIST_FAILURE = 'ADD_NEW_FAVORITE_LIST_FAILURE';
	
	// Group List action types
	var REQUEST_CUSTOMER_GROUPS = exports.REQUEST_CUSTOMER_GROUPS = 'REQUEST_CUSTOMER_GROUPS';
	var FETCH_CUSTOMER_GROUPS_SUCCESS = exports.FETCH_CUSTOMER_GROUPS_SUCCESS = 'FETCH_CUSTOMER_GROUPS_SUCCESS';
	var FETCH_CUSTOMER_GROUPS_FAILURE = exports.FETCH_CUSTOMER_GROUPS_FAILURE = 'FETCH_CUSTOMER_GROUPS_FAILURE';
	var REQUEST_CUSTOMER_GROUPS_DETAIL = exports.REQUEST_CUSTOMER_GROUPS_DETAIL = 'REQUEST_CUSTOMER_GROUPS_DETAIL';
	var FETCH_CUSTOMER_GROUPS_DETAIL_SUCCESS = exports.FETCH_CUSTOMER_GROUPS_DETAIL_SUCCESS = 'FETCH_CUSTOMER_GROUPS_DETAIL_SUCCESS';
	var FETCH_CUSTOMER_GROUPS_DETAIL_FAILURE = exports.FETCH_CUSTOMER_GROUPS_DETAIL_FAILURE = 'FETCH_CUSTOMER_GROUPS_DETAIL_FAILURE';
	var REQUEST_SAVE_PRODUCT_LIST = exports.REQUEST_SAVE_PRODUCT_LIST = 'REQUEST_SAVE_PRODUCT_LIST';
	var SAVE_PRODUCT_LIST_SUCCESS = exports.SAVE_PRODUCT_LIST_SUCCESS = 'SAVE_PRODUCT_LIST_SUCCESS';
	var SAVE_PRODUCT_LIST_FAILURE = exports.SAVE_PRODUCT_LIST_FAILURE = 'SAVE_PRODUCT_LIST_FAILURE';
	
	// Sales Invoice action types
	var REQUEST_SALES_INVOICES = exports.REQUEST_SALES_INVOICES = 'REQUEST_SALES_INVOICES';
	var REQUEST_SALES_INVOICES_BY_NUM = exports.REQUEST_SALES_INVOICES_BY_NUM = 'REQUEST_SALES_INVOICES_BY_NUM';
	var FETCH_SALES_INVOICES_BY_NUM_SUCCESS = exports.FETCH_SALES_INVOICES_BY_NUM_SUCCESS = 'FETCH_SALES_INVOICES_BY_NUM_SUCCESS';
	var FETCH_SALES_INVOICES_BY_NUM_FAILURE = exports.FETCH_SALES_INVOICES_BY_NUM_FAILURE = 'FETCH_SALES_INVOICES_BY_NUM_FAILURE';
	var FETCH_SALES_INVOICES_SUCCESS = exports.FETCH_SALES_INVOICES_SUCCESS = 'FETCH_SALES_INVOICES_SUCCESS';
	var FETCH_SALES_INVOICES_FAILURE = exports.FETCH_SALES_INVOICES_FAILURE = 'FETCH_SALES_INVOICES_FAILURE';
	var SELECT_SALES_INVOICE = exports.SELECT_SALES_INVOICE = 'SELECT_SALES_INVOICE';
	var RESET_CURRENT_SALES_INVOICE = exports.RESET_CURRENT_SALES_INVOICE = 'RESET_CURRENT_SALES_INVOICE';
	var REQUEST_SALES_INVOICE_DETAIL = exports.REQUEST_SALES_INVOICE_DETAIL = 'REQUEST_SALES_INVOICE_DETAIL';
	var FETCH_SALES_INVOICE_DETAIL_SUCCESS = exports.FETCH_SALES_INVOICE_DETAIL_SUCCESS = 'FETCH_SALES_INVOICE_DETAIL_SUCCESS';
	var FETCH_SALES_INVOICE_DETAIL_FAILURE = exports.FETCH_SALES_INVOICE_DETAIL_FAILURE = 'FETCH_SALES_INVOICE_DETAIL_FAILURE';
	var REQUEST_FINALIZE_INVOICE = exports.REQUEST_FINALIZE_INVOICE = 'REQUEST_FINALIZE_INVOICE';
	var FINALIZE_INVOICE_SUCCESS = exports.FINALIZE_INVOICE_SUCCESS = 'FINALIZE_INVOICE_SUCCESS';
	var FINALIZE_INVOICE_FAILURE = exports.FINALIZE_INVOICE_FAILURE = 'FINALIZE_INVOICE_FAILURE';
	var DELIVER_INVOICE_SUCCESS = exports.DELIVER_INVOICE_SUCCESS = 'REQUEST_DELIVER_INVOICE';
	var DELIVER_INVOICE_FAILURE = exports.DELIVER_INVOICE_FAILURE = 'DELIVER_INVOICE_SUCCESS';
	var REQUEST_DELIVER_INVOICE = exports.REQUEST_DELIVER_INVOICE = 'DELIVER_INVOICE_FAILURE';
	var REQUEST_VOID_INVOICE = exports.REQUEST_VOID_INVOICE = 'REQUEST_VOID_INVOICE';
	var VOID_INVOICE_SUCCESS = exports.VOID_INVOICE_SUCCESS = 'VOID_INVOICE_SUCCESS';
	var VOID_INVOICE_FAILURE = exports.VOID_INVOICE_FAILURE = 'VOID_INVOICE_FAILURE';
	var REQUEST_VOID_RETURN = exports.REQUEST_VOID_RETURN = 'REQUEST_VOID_RETURN';
	var VOID_RETURN_SUCCESS = exports.VOID_RETURN_SUCCESS = 'VOID_RETURN_SUCCESS';
	var VOID_RETURN_FAILURE = exports.VOID_RETURN_FAILURE = 'VOID_RETURN_FAILURE';
	var REQUEST_FINALIZED_INVOICES = exports.REQUEST_FINALIZED_INVOICES = 'REQUEST_FINALIZED_INVOICES';
	var FETCH_FINALIZED_INVOICES_SUCCESS = exports.FETCH_FINALIZED_INVOICES_SUCCESS = 'FETCH_FINALIZED_INVOICES_SUCCESS';
	var FETCH_FINALIZED_INVOICES_FAILURE = exports.FETCH_FINALIZED_INVOICES_FAILURE = 'FETCH_FINALIZED_INVOICES_FAILURE';
	var UPDATE_SALES_INVOICE = exports.UPDATE_SALES_INVOICE = 'UPDATE_SALES_INVOICE';
	var UPDATE_SALES_INVOICE_SUCCESS = exports.UPDATE_SALES_INVOICE_SUCCESS = 'UPDATE_SALES_INVOICE_SUCCESS';
	var UPDATE_SALES_INVOICE_FAILURE = exports.UPDATE_SALES_INVOICE_FAILURE = 'UPDATE_SALES_INVOICE_FAILURE';
	var UPDATE_SALES_INVOICE_PAYMENT = exports.UPDATE_SALES_INVOICE_PAYMENT = 'UPDATE_SALES_INVOICE_PAYMENT';
	var UPDATE_SALES_INVOICE_PAYMENT_SUCCESS = exports.UPDATE_SALES_INVOICE_PAYMENT_SUCCESS = 'UPDATE_SALES_INVOICE_PAYMENT_SUCCESS';
	var UPDATE_SALES_INVOICE_PAYMENT_FAILURE = exports.UPDATE_SALES_INVOICE_PAYMENT_FAILURE = 'UPDATE_SALES_INVOICE_PAYMENT_FAILURE';
	var RESET_SALES_INVOICE_PAYMENT = exports.RESET_SALES_INVOICE_PAYMENT = 'RESET_SALES_INVOICE_PAYMENT';
	var CLEAR_UPDATE_SALES_INVOICE = exports.CLEAR_UPDATE_SALES_INVOICE = 'CLEAR_UPDATE_SALES_INVOICE';
	var UPDATE_SALES_INVOICE_RESET = exports.UPDATE_SALES_INVOICE_RESET = 'UPDATE_SALES_INVOICE_RESET';
	var REQUEST_SALES_INVOICE_FORM = exports.REQUEST_SALES_INVOICE_FORM = 'REQUEST_SALES_INVOICE_FORM';
	var FETCH_SALES_INVOICE_FORM_SUCCESS = exports.FETCH_SALES_INVOICE_FORM_SUCCESS = 'FETCH_SALES_INVOICE_FORM_SUCCESS';
	var FETCH_SALES_INVOICE_FORM_FAILURE = exports.FETCH_SALES_INVOICE_FORM_FAILURE = 'FETCH_SALES_INVOICE_FORM_FAILURE';
	var EDIT_SI_CUSTOMER = exports.EDIT_SI_CUSTOMER = 'EDIT_SI_CUSTOMER';
	var EDIT_SI_CUSTOMER_SUCCESS = exports.EDIT_SI_CUSTOMER_SUCCESS = 'EDIT_SI_CUSTOMER_SUCCESS';
	var EDIT_SI_CUSTOMER_FAILURE = exports.EDIT_SI_CUSTOMER_FAILURE = 'EDIT_SI_CUSTOMER_FAILURE';
	var RESET_EDIT_SI_CUSTOMER = exports.RESET_EDIT_SI_CUSTOMER = 'RESET_EDIT_SI_CUSTOMER';
	var REQUEST_UNPAID_INVOICE = exports.REQUEST_UNPAID_INVOICE = 'REQUEST_UNPAID_INVOICE';
	var FETCH_UNPAID_INVOICE_SUCCESS = exports.FETCH_UNPAID_INVOICE_SUCCESS = 'FETCH_UNPAID_INVOICE_SUCCESS';
	var FETCH_UNPAID_INVOICE_FAILURE = exports.FETCH_UNPAID_INVOICE_FAILURE = 'FETCH_UNPAID_INVOICE_FAILURE';
	
	var COMPLETE_PURCHASE_ORDER = exports.COMPLETE_PURCHASE_ORDER = 'COMPLETE_PURCHASE_ORDER';
	var COMPLETE_PURCHASE_ORDER_SUCCESS = exports.COMPLETE_PURCHASE_ORDER_SUCCESS = 'COMPLETE_PURCHASE_ORDER_SUCCESS';
	var COMPLETE_PURCHASE_ORDER_FAILURE = exports.COMPLETE_PURCHASE_ORDER_FAILURE = 'COMPLETE_PURCHASE_ORDER_FAILURE';
	var COPY_PURCHASE_ORDER = exports.COPY_PURCHASE_ORDER = 'COPY_PURCHASE_ORDER';
	var COPY_PURCHASE_ORDER_SUCCESS = exports.COPY_PURCHASE_ORDER_SUCCESS = 'COPY_PURCHASE_ORDER_SUCCESS';
	var COPY_PURCHASE_ORDER_FAILURE = exports.COPY_PURCHASE_ORDER_FAILURE = 'COPY_PURCHASE_ORDER_FAILURE';
	
	// Wholesale action types
	var REQUEST_INVENTORY_BATCHES = exports.REQUEST_INVENTORY_BATCHES = 'REQUEST_INVENTORY_BATCHES';
	var FETCH_INVENTORY_BATCHES_SUCCESS = exports.FETCH_INVENTORY_BATCHES_SUCCESS = 'FETCH_INVENTORY_BATCHES_SUCCESS';
	var FETCH_INVENTORY_BATCHES_FAILURE = exports.FETCH_INVENTORY_BATCHES_FAILURE = 'FETCH_INVENTORY_BATCHES_FAILURE';
	var REQUEST_PRODUCT_INVENTORY_BATCHES = exports.REQUEST_PRODUCT_INVENTORY_BATCHES = 'REQUEST_PRODUCT_INVENTORY_BATCHES';
	var FETCH_PRODUCT_INVENTORY_BATCHES_SUCCESS = exports.FETCH_PRODUCT_INVENTORY_BATCHES_SUCCESS = 'FETCH_PRODUCT_INVENTORY_BATCHES_SUCCESS';
	var FETCH_PRODUCT_INVENTORY_BATCHES_FAILURE = exports.FETCH_PRODUCT_INVENTORY_BATCHES_FAILURE = 'FETCH_PRODUCT_INVENTORY_BATCHES_FAILURE';
	
	// Dispatch action types
	var SAVE_EDITED_STOPS = exports.SAVE_EDITED_STOPS = 'SAVE_EDITED_STOPS';
	var SAVE_EDITED_STOPS_SUCCESS = exports.SAVE_EDITED_STOPS_SUCCESS = 'SAVE_EDITED_STOPS_SUCCESS';
	var SAVE_EDITED_STOPS_FAILURE = exports.SAVE_EDITED_STOPS_FAILURE = 'SAVE_EDITED_STOPS_FAILURE';
	var REQUEST_SAVE_NEW_ROUTES = exports.REQUEST_SAVE_NEW_ROUTES = 'REQUEST_SAVE_NEW_ROUTES';
	var SAVE_NEW_ROUTES_SUCCESS = exports.SAVE_NEW_ROUTES_SUCCESS = 'SAVE_NEW_ROUTES_SUCCESS';
	var SAVE_NEW_ROUTES_FAILURE = exports.SAVE_NEW_ROUTES_FAILURE = 'SAVE_NEW_ROUTES_FAILURE';
	var REQUEST_ROUTES = exports.REQUEST_ROUTES = 'REQUEST_ROUTES';
	var FETCH_ROUTES_SUCCESS = exports.FETCH_ROUTES_SUCCESS = 'FETCH_ROUTES_SUCCESS';
	var FETCH_AUTO_ROUTES_SUCCESS = exports.FETCH_AUTO_ROUTES_SUCCESS = 'FETCH_AUTO_ROUTES_SUCCESS';
	var START_FETCHING_AUTO_ROUTES = exports.START_FETCHING_AUTO_ROUTES = 'START_FETCHING_AUTO_ROUTES';
	var FETCH_ROUTES_FAILURE = exports.FETCH_ROUTES_FAILURE = 'FETCH_ROUTES_FAILURE';
	var REQUEST_STOPS = exports.REQUEST_STOPS = 'REQUEST_STOPS';
	var FETCH_STOPS_SUCCESS = exports.FETCH_STOPS_SUCCESS = 'FETCH_STOPS_SUCCESS';
	var FETCH_STOPS_FAILURE = exports.FETCH_STOPS_FAILURE = 'FETCH_STOPS_FAILURE';
	var REQUEST_EDIT_STOPS = exports.REQUEST_EDIT_STOPS = 'REQUEST_EDIT_STOPS';
	var FETCH_EDIT_STOPS_SUCCESS = exports.FETCH_EDIT_STOPS_SUCCESS = 'FETCH_EDIT_STOPS_SUCCESS';
	var FETCH_EDIT_STOPS_FAILURE = exports.FETCH_EDIT_STOPS_FAILURE = 'FETCH_EDIT_STOPS_FAILURE';
	var REQUEST_SAVE_EDITS = exports.REQUEST_SAVE_EDITS = 'REQUEST_SAVE_EDITS';
	var SAVE_EDITS_SUCCESS = exports.SAVE_EDITS_SUCCESS = 'SAVE_EDITS_SUCCESS';
	var SAVE_EDITS_FAILURE = exports.SAVE_EDITS_FAILURE = 'SAVE_EDITS_FAILURE';
	var CLEAR_EDIT_STATUS = exports.CLEAR_EDIT_STATUS = 'CLEAR_EDIT_STATUS';
	var REQUEST_CUSTOMER_ROUTES = exports.REQUEST_CUSTOMER_ROUTES = 'REQUEST_CUSTOMER_ROUTES';
	var FETCH_CUSTOMER_ROUTES_SUCCESS = exports.FETCH_CUSTOMER_ROUTES_SUCCESS = 'FETCH_CUSTOMER_ROUTES_SUCCESS';
	var FETCH_CUSTOMER_ROUTES_FAILURE = exports.FETCH_CUSTOMER_ROUTES_FAILURE = 'FETCH_CUSTOMER_ROUTES_FAILURE';
	var REQUEST_UNASSIGNED_ORDERS = exports.REQUEST_UNASSIGNED_ORDERS = 'REQUEST_UNASSIGNED_ORDERS';
	var FETCH_UNASSIGNED_ORDERS_SUCCESS = exports.FETCH_UNASSIGNED_ORDERS_SUCCESS = 'FETCH_UNASSIGNED_ORDERS_SUCCESS';
	var FETCH_UNASSIGNED_ORDERS_FAILURE = exports.FETCH_UNASSIGNED_ORDERS_FAILURE = 'FETCH_UNASSIGNED_ORDERS_FAILURE';
	var REQUEST_SALES_ORDERS_BY_DATE = exports.REQUEST_SALES_ORDERS_BY_DATE = 'REQUEST_SALES_ORDERS_BY_DATE';
	var FETCH_SALES_ORDERS_BY_DATE_SUCCESS = exports.FETCH_SALES_ORDERS_BY_DATE_SUCCESS = 'FETCH_SALES_ORDERS_BY_DATE_SUCCESS';
	var FETCH_SALES_ORDERS_BY_DATE_FAILURE = exports.FETCH_SALES_ORDERS_BY_DATE_FAILURE = 'FETCH_SALES_ORDERS_BY_DATE_FAILURE';
	var REQUEST_ASSIGN_ORDER_ROUTE = exports.REQUEST_ASSIGN_ORDER_ROUTE = 'REQUEST_ASSIGN_ORDER_ROUTE';
	var ASSIGN_ORDER_ROUTE_SUCCESS = exports.ASSIGN_ORDER_ROUTE_SUCCESS = 'ASSIGN_ORDER_ROUTE_SUCCESS';
	var ASSIGN_ORDER_ROUTE_FAILURE = exports.ASSIGN_ORDER_ROUTE_FAILURE = 'ASSIGN_ORDER_ROUTE_FAILURE';
	var REQUEST_SAVE_ROUTE_EDITS = exports.REQUEST_SAVE_ROUTE_EDITS = 'REQUEST_SAVE_ROUTE_EDITS';
	var SAVE_ROUTE_EDIT_SUCCESS = exports.SAVE_ROUTE_EDIT_SUCCESS = 'SAVE_ROUTE_EDIT_SUCCESS';
	var SAVE_ROUTE_EDIT_FAILURE = exports.SAVE_ROUTE_EDIT_FAILURE = 'SAVE_ROUTE_EDIT_FAILURE';
	var REQUEST_CONVERT_TO_INVOICE = exports.REQUEST_CONVERT_TO_INVOICE = 'REQUEST_CONVERT_TO_INVOICE';
	var CONVERT_TO_INVOICE_SUCCESS = exports.CONVERT_TO_INVOICE_SUCCESS = 'CONVERT_TO_INVOICE_SUCCESS';
	var CONVERT_TO_INVOICE_FAILURE = exports.CONVERT_TO_INVOICE_FAILURE = 'CONVERT_TO_INVOICE_FAILURE';
	var CLEAR_CONVERT_TO_INVOICE = exports.CLEAR_CONVERT_TO_INVOICE = 'CLEAR_CONVERT_TO_INVOICE';
	var CONVERT_TO_INVOICE_RESET = exports.CONVERT_TO_INVOICE_RESET = 'CONVERT_TO_INVOICE_RESET';
	
	var REQUEST_AR = exports.REQUEST_AR = 'REQUEST_AR';
	var FETCH_AR_SUCCESS = exports.FETCH_AR_SUCCESS = 'FETCH_AR_SUCCESS';
	var FETCH_AR_FAILURE = exports.FETCH_AR_FAILURE = 'FETCH_AR_FAILURE';
	var CREATE_AR = exports.CREATE_AR = 'CREATE_AR';
	var CREATE_AR_SUCCESS = exports.CREATE_AR_SUCCESS = 'CREATE_AR_SUCCESS';
	var CREATE_AR_FAILURE = exports.CREATE_AR_FAILURE = 'CREATE_AR_FAILURE';
	var REFUND_AR = exports.REFUND_AR = 'REFUND_AR';
	var REFUND_AR_SUCCESS = exports.REFUND_AR_SUCCESS = 'REFUND_AR_SUCCESS';
	var REFUND_AR_FAILURE = exports.REFUND_AR_FAILURE = 'REFUND_AR_FAILURE';
	var EDIT_AR = exports.EDIT_AR = 'EDIT_AR';
	var EDIT_AR_SUCCESS = exports.EDIT_AR_SUCCESS = 'EDIT_AR_SUCCESS';
	var EDIT_AR_FAILURE = exports.EDIT_AR_FAILURE = 'EDIT_AR_FAILURE';
	var DELETE_AR = exports.DELETE_AR = 'DELETE_AR';
	var DELETE_AR_SUCCESS = exports.DELETE_AR_SUCCESS = 'DELETE_AR_SUCCESS';
	var DELETE_AR_FAILURE = exports.DELETE_AR_FAILURE = 'DELETE_AR_FAILURE';
	var REQUEST_AR_DETAIL = exports.REQUEST_AR_DETAIL = 'REQUEST_AR_DETAIL';
	var FETCH_AR_DETAIL_SUCCESS = exports.FETCH_AR_DETAIL_SUCCESS = 'FETCH_AR_DETAIL_SUCCESS';
	var FETCH_AR_DETAIL_FAILURE = exports.FETCH_AR_DETAIL_FAILURE = 'FETCH_AR_DETAIL_FAILURE';
	var CLEAR_AR_DETAIL = exports.CLEAR_AR_DETAIL = 'CLEAR_AR_DETAIL';
	var CLEAR_AR_FORM = exports.CLEAR_AR_FORM = 'CLEAR_AR_FORM';
	var REQUEST_INVOICES = exports.REQUEST_INVOICES = 'REQUEST_INVOICES';
	var FETCH_INVOICES_SUCCESS = exports.FETCH_INVOICES_SUCCESS = 'FETCH_INVOICES_SUCCESS';
	var FETCH_INVOICES_FAILURE = exports.FETCH_INVOICES_FAILURE = 'FETCH_INVOICES_FAILURE';
	var REQUEST_CREDITS = exports.REQUEST_CREDITS = 'REQUEST_CREDITS';
	var FETCH_CREDITS_SUCCESS = exports.FETCH_CREDITS_SUCCESS = 'FETCH_CREDITS_SUCCESS';
	var FETCH_CREDITS_FAILURE = exports.FETCH_CREDITS_FAILURE = 'FETCH_CREDITS_FAILURE';
	var CLEAR_CREDITS = exports.CLEAR_CREDITS = 'CLEAR_CREDITS';
	var REQUEST_AR_ACCOUNTS = exports.REQUEST_AR_ACCOUNTS = 'REQUEST_AR_ACCOUNTS';
	var FETCH_AR_ACCOUNTS_SUCCESS = exports.FETCH_AR_ACCOUNTS_SUCCESS = 'FETCH_AR_ACCOUNTS_SUCCESS';
	var FETCH_AR_ACCOUNTS_FAILURE = exports.FETCH_AR_ACCOUNTS_FAILURE = 'FETCH_AR_ACCOUNTS_FAILURE';
	var CLEAR_AR_ACCOUNTS = exports.CLEAR_AR_ACCOUNTS = 'CLEAR_AR_ACCOUNTS';
	var BOUNCE_CHECK = exports.BOUNCE_CHECK = 'BOUNCE_CHECK';
	var BOUNCE_CHECK_SUCCESS = exports.BOUNCE_CHECK_SUCCESS = 'BOUNCE_CHECK_SUCCESS';
	var BOUNCE_CHECK_FAILURE = exports.BOUNCE_CHECK_FAILURE = 'BOUNCE_CHECK_FAILURE';
	
	var REQUEST_AP = exports.REQUEST_AP = 'REQUEST_AP';
	var FETCH_AP_SUCCESS = exports.FETCH_AP_SUCCESS = 'FETCH_AP_SUCCESS';
	var FETCH_AP_FAILURE = exports.FETCH_AP_FAILURE = 'FETCH_AP_FAILURE';
	var CREATE_AP = exports.CREATE_AP = 'CREATE_AP';
	var CREATE_AP_SUCCESS = exports.CREATE_AP_SUCCESS = 'CREATE_AP_SUCCESS';
	var CREATE_AP_FAILURE = exports.CREATE_AP_FAILURE = 'CREATE_AP_FAILURE';
	var EDIT_AP = exports.EDIT_AP = 'EDIT_AP';
	var EDIT_AP_SUCCESS = exports.EDIT_AP_SUCCESS = 'EDIT_AP_SUCCESS';
	var EDIT_AP_FAILURE = exports.EDIT_AP_FAILURE = 'EDIT_AP_FAILURE';
	var DELETE_AP = exports.DELETE_AP = 'DELETE_AP';
	var DELETE_AP_SUCCESS = exports.DELETE_AP_SUCCESS = 'DELETE_AP_SUCCESS';
	var DELETE_AP_FAILURE = exports.DELETE_AP_FAILURE = 'DELETE_AP_FAILURE';
	var REQUEST_AP_DETAIL = exports.REQUEST_AP_DETAIL = 'REQUEST_AP_DETAIL';
	var FETCH_AP_DETAIL_SUCCESS = exports.FETCH_AP_DETAIL_SUCCESS = 'FETCH_AP_DETAIL_SUCCESS';
	var FETCH_AP_DETAIL_FAILURE = exports.FETCH_AP_DETAIL_FAILURE = 'FETCH_AP_DETAIL_FAILURE';
	var CLEAR_AP_DETAIL = exports.CLEAR_AP_DETAIL = 'CLEAR_AP_DETAIL';
	var CLEAR_AP_FORM = exports.CLEAR_AP_FORM = 'CLEAR_AP_FORM';
	
	var REQUEST_STATEMENT = exports.REQUEST_STATEMENT = 'REQUEST_STATEMENT';
	var FETCH_STATEMENT_SUCCESS = exports.FETCH_STATEMENT_SUCCESS = 'FETCH_STATEMENT_SUCCESS';
	var FETCH_STATEMENT_FAILURE = exports.FETCH_STATEMENT_FAILURE = 'FETCH_STATEMENT_FAILURE';
	var REQUEST_STATEMENT_AP = exports.REQUEST_STATEMENT_AP = 'REQUEST_STATEMENT_AP';
	var FETCH_STATEMENT_AP_SUCCESS = exports.FETCH_STATEMENT_AP_SUCCESS = 'FETCH_STATEMENT_AP_SUCCESS';
	var FETCH_STATEMENT_AP_FAILURE = exports.FETCH_STATEMENT_AP_FAILURE = 'FETCH_STATEMENT_AP_FAILURE';
	var RESET_CURRENT_CHECK = exports.RESET_CURRENT_CHECK = 'RESET_CURRENT_CHECK';
	var SELECT_CHECK = exports.SELECT_CHECK = 'SELECT_CHECK';
	
	var REQUEST_BASE_USER = exports.REQUEST_BASE_USER = 'REQUEST_BASE_USER';
	var FETCH_BASE_USER_SUCCESS = exports.FETCH_BASE_USER_SUCCESS = 'FETCH_BASE_USER_SUCCESS';
	var FETCH_BASE_USER_FAILURE = exports.FETCH_BASE_USER_FAILURE = 'FETCH_BASE_USER_FAILURE';
	var REQUEST_BASE_USER_DETAIL = exports.REQUEST_BASE_USER_DETAIL = 'REQUEST_BASE_USER_DETAIL';
	var FETCH_BASE_USER_DETAIL_SUCCESS = exports.FETCH_BASE_USER_DETAIL_SUCCESS = 'FETCH_BASE_USER_DETAIL_SUCCESS';
	var FETCH_BASE_USER_DETAIL_FAILURE = exports.FETCH_BASE_USER_DETAIL_FAILURE = 'FETCH_BASE_USER_DETAIL_FAILURE';
	var REQUEST_MOBILE_USERS = exports.REQUEST_MOBILE_USERS = 'REQUEST_MOBILE_USERS';
	var FETCH_MOBILE_USERS_SUCCESS = exports.FETCH_MOBILE_USERS_SUCCESS = 'FETCH_MOBILE_USERS_SUCCESS';
	var FETCH_MOBILE_USERS_FAILURE = exports.FETCH_MOBILE_USERS_FAILURE = 'FETCH_MOBILE_USERS_FAILURE';
	var SELECT_CURRENT_USER = exports.SELECT_CURRENT_USER = 'SELECT_CURRENT_USER';
	var RESET_CURRENT_USER = exports.RESET_CURRENT_USER = 'RESET_CURRENT_USER';
	var REQUEST_USER_GROUPS = exports.REQUEST_USER_GROUPS = 'REQUEST_USER_GROUPS';
	var FETCH_USER_GROUPS_SUCCESS = exports.FETCH_USER_GROUPS_SUCCESS = 'FETCH_USER_GROUPS_SUCCESS';
	var FETCH_USER_PRODUCT_ALL_GROUPS_SUCCESS = exports.FETCH_USER_PRODUCT_ALL_GROUPS_SUCCESS = 'FETCH_USER_PRODUCT_ALL_GROUPS_SUCCESS';
	var FETCH_USER_GROUPS_FAILURE = exports.FETCH_USER_GROUPS_FAILURE = 'FETCH_USER_GROUPS_FAILURE';
	var SELECT_CURRENT_GROUP = exports.SELECT_CURRENT_GROUP = 'SELECT_CURRENT_GROUP';
	var RESET_CURRENT_USER_GROUP = exports.RESET_CURRENT_USER_GROUP = 'RESET_CURRENT_USER_GROUP';
	var REQUEST_PERMISSIONS = exports.REQUEST_PERMISSIONS = 'REQUEST_PERMISSIONS';
	var FETCH_PERMISSION_SUCCESS = exports.FETCH_PERMISSION_SUCCESS = 'FETCH_PERMISSION_SUCCESS';
	var FETCH_PERMISSION_FAILURE = exports.FETCH_PERMISSION_FAILURE = 'FETCH_PERMISSION_FAILURE';
	var EDIT_GROUP_DETAIL = exports.EDIT_GROUP_DETAIL = 'EDIT_GROUP_DETAIL';
	var EDIT_GROUP_DETAIL_SUCCESS = exports.EDIT_GROUP_DETAIL_SUCCESS = 'EDIT_GROUP_DETAIL_SUCCESS';
	var EDIT_GROUP_DETAIL_FAILURE = exports.EDIT_GROUP_DETAIL_FAILURE = 'EDIT_GROUP_DETAIL_FAILURE';
	var FETCH_PERMISSIONS_SUCCESS = exports.FETCH_PERMISSIONS_SUCCESS = 'FETCH_PERMISSIONS_SUCCESS';
	var FETCH_PERMISSIONS_FAILURE = exports.FETCH_PERMISSIONS_FAILURE = 'FETCH_PERMISSIONS_FAILURE';
	var EDIT_USER_DETAIL = exports.EDIT_USER_DETAIL = 'EDIT_USER_DETAIL';
	var EDIT_USER_DETAIL_SUCCESS = exports.EDIT_USER_DETAIL_SUCCESS = 'EDIT_USER_DETAIL_SUCCESS';
	var EDIT_USER_DETAIL_FAILURE = exports.EDIT_USER_DETAIL_FAILURE = 'EDIT_USER_DETAIL_FAILURE';
	var RESET_USER_DETAIL = exports.RESET_USER_DETAIL = 'RESET_USER_DETAIL';
	var CREATE_USER_DETAIL = exports.CREATE_USER_DETAIL = 'CREATE_USER_DETAIL';
	var CREATE_USER_DETAIL_SUCCESS = exports.CREATE_USER_DETAIL_SUCCESS = 'CREATE_USER_DETAIL_SUCCESS';
	var CREATE_USER_DETAIL_FAILURE = exports.CREATE_USER_DETAIL_FAILURE = 'CREATE_USER_DETAIL_FAILURE';
	var CREATE_GROUP_DETAIL = exports.CREATE_GROUP_DETAIL = 'CREATE_GROUP_DETAIL';
	var CREATE_GROUP_DETAIL_SUCCESS = exports.CREATE_GROUP_DETAIL_SUCCESS = 'CREATE_GROUP_DETAIL_SUCCESS';
	var CREATE_GROUP_DETAIL_FAILURE = exports.CREATE_GROUP_DETAIL_FAILURE = 'CREATE_GROUP_DETAIL_FAILURE';
	var EDIT_PASSWORD = exports.EDIT_PASSWORD = 'EDIT_PASSWORD';
	var EDIT_PASSWORD_SUCCESS = exports.EDIT_PASSWORD_SUCCESS = 'EDIT_PASSWORD_SUCCESS';
	var EDIT_PASSWORD_FAILURE = exports.EDIT_PASSWORD_FAILURE = 'EDIT_PASSWORD_FAILURE';
	var RESET_PASSWORD = exports.RESET_PASSWORD = 'RESET_PASSWORD';
	
	var ATTACH_FILES = exports.ATTACH_FILES = 'ATTACH_FILES';
	var ATTACH_FILES_SUCCESS = exports.ATTACH_FILES_SUCCESS = 'ATTACH_FILES_SUCCESS';
	var ATTACH_FILES_FAILURE = exports.ATTACH_FILES_FAILURE = 'ATTACH_FILES_FAILURE';
	var FETCH_ATTACHED_FILES = exports.FETCH_ATTACHED_FILES = 'FETCH_ATTACHED_FILES';
	var FETCH_ATTACHED_FILES_SUCCESS = exports.FETCH_ATTACHED_FILES_SUCCESS = 'FETCH_ATTACHED_FILES_SUCCESS';
	var FETCH_ATTACHED_FILES_FAILURE = exports.FETCH_ATTACHED_FILES_FAILURE = 'FETCH_ATTACHED_FILES_FAILURE';
	var DELETE_ATTACHED_FILES = exports.DELETE_ATTACHED_FILES = 'DELETE_ATTACHED_FILES';
	var DELETE_ATTACHED_FILES_SUCCESS = exports.DELETE_ATTACHED_FILES_SUCCESS = 'DELETE_ATTACHED_FILES_SUCCESS';
	var DELETE_ATTACHED_FILES_FAILURE = exports.DELETE_ATTACHED_FILES_FAILURE = 'DELETE_ATTACHED_FILES_FAILURE';
	var RESET_ATTACHED_FILES = exports.RESET_ATTACHED_FILES = 'RESET_ATTACHED_FILES';
	
	var ATTACH_DOCUMENT = exports.ATTACH_DOCUMENT = 'ATTACH_DOCUMENT';
	var ATTACH_DOCUMENT_SUCCESS = exports.ATTACH_DOCUMENT_SUCCESS = 'ATTACH_DOCUMENT_SUCCESS';
	var ATTACH_DOCUMENT_FAILURE = exports.ATTACH_DOCUMENT_FAILURE = 'ATTACH_DOCUMENT_FAILURE';
	
	// Dashboard actions
	var REQUEST_DASHBOARD_MESSAGES = exports.REQUEST_DASHBOARD_MESSAGES = 'REQUEST_DASHBOARD_MESSAGES';
	var FETCH_DASHBOARD_MESSAGES_SUCCESS = exports.FETCH_DASHBOARD_MESSAGES_SUCCESS = 'FETCH_DASHBOARD_MESSAGES_SUCCESS';
	var FETCH_DASHBOARD_MESSAGES_FAILURE = exports.FETCH_DASHBOARD_MESSAGES_FAILURE = 'FETCH_DASHBOARD_MESSAGES_FAILURE';
	var POST_DASHBOARD_MESSAGE = exports.POST_DASHBOARD_MESSAGE = 'POST_DASHBOARD_MESSAGE';
	var POST_MESSAGE_SUCCESS = exports.POST_MESSAGE_SUCCESS = 'POST_MESSAGE_SUCCESS';
	var POST_MESSAGE_FAILURE = exports.POST_MESSAGE_FAILURE = 'POST_MESSAGE_FAILURE';
	var REQUEST_CONSOLIDATED_STATISTICS = exports.REQUEST_CONSOLIDATED_STATISTICS = 'REQUEST_CONSOLIDATED_STATISTICS';
	var FETCH_CONSOLODATED_STATISTICS_SUCCESS = exports.FETCH_CONSOLODATED_STATISTICS_SUCCESS = 'FETCH_CONSOLODATED_STATISTICS_SUCCESS';
	var FETCH_CONSOLODATED_STATISTICS_FAILURE = exports.FETCH_CONSOLODATED_STATISTICS_FAILURE = 'FETCH_CONSOLODATED_STATISTICS_FAILURE';
	
	// Register actions
	var REQUEST_REGISTERS = exports.REQUEST_REGISTERS = 'REQUEST_REGISTERS';
	var FETCH_REGISTERS_SUCCESS = exports.FETCH_REGISTERS_SUCCESS = 'FETCH_REGISTERS_SUCCESS';
	var FETCH_REGISTERS_FAILRE = exports.FETCH_REGISTERS_FAILRE = 'FETCH_REGISTERS_FAILRE';
	var REQUEST_REGISTER_SESSIONS = exports.REQUEST_REGISTER_SESSIONS = 'REQUEST_REGISTER_SESSIONS';
	var REQUEST_REGISTER_SESSIONS_DATE = exports.REQUEST_REGISTER_SESSIONS_DATE = 'REQUEST_REGISTER_SESSIONS_DATE';
	var FETCH_REGISTER_SESSIONS_SUCCESS = exports.FETCH_REGISTER_SESSIONS_SUCCESS = 'FETCH_REGISTER_SESSIONS_SUCCESS';
	var FETCH_REGISTER_SESSIONS_FAILURE = exports.FETCH_REGISTER_SESSIONS_FAILURE = 'FETCH_REGISTER_SESSIONS_FAILURE';
	var VERIFY_REGISTER = exports.VERIFY_REGISTER = 'VERIFY_REGISTER';
	
	// Print actions
	var REQUEST_SHIPPING_LIST_PDF = exports.REQUEST_SHIPPING_LIST_PDF = 'REQUEST_SHIPPING_LIST_PDF';
	var FETCH_SHIPPING_LIST_SUCCESS = exports.FETCH_SHIPPING_LIST_SUCCESS = 'FETCH_SHIPPING_LIST_SUCCESS';
	var REQUEST_PACKING_LIST_PDF = exports.REQUEST_PACKING_LIST_PDF = 'REQUEST_PACKING_LIST_PDF';
	var FETCH_PACKING_LIST_SUCCESS = exports.FETCH_PACKING_LIST_SUCCESS = 'FETCH_PACKING_LIST_SUCCESS';
	var REQUEST_SO_PDF = exports.REQUEST_SO_PDF = 'REQUEST_SO_PDF';
	var FETCH_SO_PDF_SUCCESS = exports.FETCH_SO_PDF_SUCCESS = 'FETCH_SO_PDF_SUCCESS';
	var REQUEST_SO_SI_PDF = exports.REQUEST_SO_SI_PDF = 'REQUEST_SO_SI_PDF';
	var FETCH_SO_SI_PDF_SUCCESS = exports.FETCH_SO_SI_PDF_SUCCESS = 'FETCH_SO_SI_PDF_SUCCESS';
	var REQUEST_PICKING_LIST_PDF = exports.REQUEST_PICKING_LIST_PDF = 'REQUEST_PICKING_LIST_PDF';
	var FETCH_PICKING_LIST_SUCCESS = exports.FETCH_PICKING_LIST_SUCCESS = 'FETCH_PICKING_LIST_SUCCESS';
	var REQUEST_PO_PDF = exports.REQUEST_PO_PDF = 'REQUEST_PO_PDF';
	var FETCH_PO_PDF_SUCCESS = exports.FETCH_PO_PDF_SUCCESS = 'FETCH_PO_PDF_SUCCESS';
	var REQUEST_PO_NOSUBTOTAL_PDF = exports.REQUEST_PO_NOSUBTOTAL_PDF = 'REQUEST_PO_NOSUBTOTAL_PDF';
	var REQUEST_PO_NOSUBTOTAL_PDF_SUCCESS = exports.REQUEST_PO_NOSUBTOTAL_PDF_SUCCESS = 'REQUEST_PO_NOSUBTOTAL_PDF_SUCCESS';
	var REQUEST_SI_PDF = exports.REQUEST_SI_PDF = 'REQUEST_SI_PDF';
	var FETCH_SI_PDF_SUCCESS = exports.FETCH_SI_PDF_SUCCESS = 'FETCH_SI_PDF_SUCCESS';
	var FETCH_SI_PDF_FAILURE = exports.FETCH_SI_PDF_FAILURE = 'FETCH_SI_PDF_FAILURE';
	var REQUEST_SI_RETURN_PDF = exports.REQUEST_SI_RETURN_PDF = 'REQUEST_SI_RETURN_PDF';
	var FETCH_SI_RETURN_PDF_SUCCESS = exports.FETCH_SI_RETURN_PDF_SUCCESS = 'FETCH_SI_RETURN_PDF_SUCCESS';
	var FETCH_SI_RETURN_PDF_FAILURE = exports.FETCH_SI_RETURN_PDF_FAILURE = 'FETCH_SI_RETURN_PDF_FAILURE';
	var REQUEST_WR_PDF = exports.REQUEST_WR_PDF = 'REQUEST_WR_PDF';
	var FETCH_WR_PDF_SUCCESS = exports.FETCH_WR_PDF_SUCCESS = 'FETCH_WR_PDF_SUCCESS';
	var REMOVE_SHIPPING_PDF = exports.REMOVE_SHIPPING_PDF = 'REMOVE_SHIPPING_PDF';
	var REQUEST_AR_PDF = exports.REQUEST_AR_PDF = 'REQUEST_AR_PDF';
	var FETCH_AR_PDF_SUCCESS = exports.FETCH_AR_PDF_SUCCESS = 'FETCH_AR_PDF_SUCCESS';
	var REQUEST_AP_PDF = exports.REQUEST_AP_PDF = 'REQUEST_AP_PDF';
	var FETCH_AP_PDF_SUCCESS = exports.FETCH_AP_PDF_SUCCESS = 'FETCH_AP_PDF_SUCCESS';
	var REQUEST_ROUTING_PDF_SUCCESS = exports.REQUEST_ROUTING_PDF_SUCCESS = 'REQUEST_ROUTING_PDF_SUCCESS';
	var REQUEST_ROUTING_PDF_FAILURE = exports.REQUEST_ROUTING_PDF_FAILURE = 'REQUEST_ROUTING_PDF_FAILURE';
	var REQUEST_ROUTING_PDF = exports.REQUEST_ROUTING_PDF = 'REQUEST_ROUTING_PDF';
	var REQUEST_DISPATCH_PICKING_LIST_PDF_SUCCESS = exports.REQUEST_DISPATCH_PICKING_LIST_PDF_SUCCESS = 'REQUEST_DISPATCH_PICKING_LIST_PDF_SUCCESS';
	var REQUEST_DISPATCH_PICKING_LIST_PDF_FAILURE = exports.REQUEST_DISPATCH_PICKING_LIST_PDF_FAILURE = 'REQUEST_DISPATCH_PICKING_LIST_PDF_FAILURE';
	var REQUEST_DISPATCH_PICKING_LIST_PDF = exports.REQUEST_DISPATCH_PICKING_LIST_PDF = 'REQUEST_DISPATCH_PICKING_LIST_PDF';
	var REQUEST_DISPATCH_PACKING_LIST_PDF_SUCCESS = exports.REQUEST_DISPATCH_PACKING_LIST_PDF_SUCCESS = 'REQUEST_DISPATCH_PACKING_LIST_PDF_SUCCESS';
	var REQUEST_DISPATCH_PACKING_LIST_PDF_FAILURE = exports.REQUEST_DISPATCH_PACKING_LIST_PDF_FAILURE = 'REQUEST_DISPATCH_PACKING_LIST_PDF_FAILURE';
	var REQUEST_DISPATCH_PACKING_LIST_PDF = exports.REQUEST_DISPATCH_PACKING_LIST_PDF = 'REQUEST_DISPATCH_PACKING_LIST_PDF';
	var REQUEST_DISPATCH_SALES_INVOICE_PDF_SUCCESS = exports.REQUEST_DISPATCH_SALES_INVOICE_PDF_SUCCESS = 'REQUEST_DISPATCH_SALES_INVOICE_PDF_SUCCESS';
	var REQUEST_DISPATCH_SALES_INVOICE_PDF_FAILURE = exports.REQUEST_DISPATCH_SALES_INVOICE_PDF_FAILURE = 'REQUEST_DISPATCH_SALES_INVOICE_PDF_FAILURE';
	var REQUEST_DISPATCH_SALES_INVOICE_PDF = exports.REQUEST_DISPATCH_SALES_INVOICE_PDF = 'REQUEST_DISPATCH_SALES_INVOICE_PDF';
	var REQUEST_SI_NOSUBTOTAL_PDF = exports.REQUEST_SI_NOSUBTOTAL_PDF = 'REQUEST_SI_NOSUBTOTAL_PDF';
	var REQUEST_SI_NOSUBTOTAL_PDF_SUCCESS = exports.REQUEST_SI_NOSUBTOTAL_PDF_SUCCESS = 'REQUEST_SI_NOSUBTOTAL_PDF_SUCCESS';
	var REQUEST_SI_RETURN_NOSUBTOTAL_PDF = exports.REQUEST_SI_RETURN_NOSUBTOTAL_PDF = 'REQUEST_SI_RETURN_NOSUBTOTAL_PDF';
	var REQUEST_SI_RETURN_NOSUBTOTAL_PDF_SUCCESS = exports.REQUEST_SI_RETURN_NOSUBTOTAL_PDF_SUCCESS = 'REQUEST_SI_RETURN_NOSUBTOTAL_PDF_SUCCESS';
	var REQUEST_BOL_ID_PDF = exports.REQUEST_BOL_ID_PDF = 'REQUEST_BOL_ID_PDF';
	var FETCH_BOL_ID_PDF_SUCCESS = exports.FETCH_BOL_ID_PDF_SUCCESS = 'FETCH_BOL_ID_PDF_SUCCESS';
	var REQUEST_BOL_FBA_PDF = exports.REQUEST_BOL_FBA_PDF = 'REQUEST_BOL_FBA_PDF';
	var FETCH_BOL_WITHOUT_LOG_SUCCESS = exports.FETCH_BOL_WITHOUT_LOG_SUCCESS = 'FETCH_BOL_WITHOUT_LOG_SUCCESS';
	var REQUEST_BOL_WITHOUT_LOG = exports.REQUEST_BOL_WITHOUT_LOG = 'REQUEST_BOL_WITHOUT_LOG';
	var REQUEST_BOL_LABEL = exports.REQUEST_BOL_LABEL = 'REQUEST_BOL_LABEL';
	var FETCH_BOL_LABEL_SUCCESS = exports.FETCH_BOL_LABEL_SUCCESS = 'FETCH_BOL_LABEL_SUCCESS';
	var FETCH_BOL_FBA_PDF_SUCCESS = exports.FETCH_BOL_FBA_PDF_SUCCESS = 'FETCH_BOL_FBA_PDF_SUCCESS';
	var FETCH_BOL_ADDRESS_SUCCESS = exports.FETCH_BOL_ADDRESS_SUCCESS = 'FETCH_BOL_ADDRESS_SUCCESS';
	var FETCH_SP_SUCCESS = exports.FETCH_SP_SUCCESS = 'FETCH_SP_SUCCESS';
	var REQUEST_SP_PDF = exports.REQUEST_SP_PDF = 'REQUEST_SP_PDF';
	var REQUEST_POS_HOLDS_PDF = exports.REQUEST_POS_HOLDS_PDF = 'REQUEST_POS_HOLDS_PDF';
	var FETCH_POS_HOLDS_PDF_SUCCESS = exports.FETCH_POS_HOLDS_PDF_SUCCESS = 'FETCH_POS_HOLDS_PDF_SUCCESS';
	
	// Mobile Management actions
	var FETCH_GREAT_DEALS_NEW_ARRIVALS = exports.FETCH_GREAT_DEALS_NEW_ARRIVALS = 'FETCH_GREAT_DEALS_NEW_ARRIVALS';
	var FETCH_GREAT_DEALS_NEW_ARRIVALS_SUCCESS = exports.FETCH_GREAT_DEALS_NEW_ARRIVALS_SUCCESS = 'FETCH_GREAT_DEALS_NEW_ARRIVALS_SUCCESS';
	var FETCH_GREAT_DEALS_NEW_ARRIVALS_FAILURE = exports.FETCH_GREAT_DEALS_NEW_ARRIVALS_FAILURE = 'FETCH_GREAT_DEALS_NEW_ARRIVALS_FAILURE';
	var UPDATE_GREAT_DEALS = exports.UPDATE_GREAT_DEALS = 'UPDATE_GREAT_DEALS';
	var UPDATE_GREAT_DEALS_SUCCESS = exports.UPDATE_GREAT_DEALS_SUCCESS = 'UPDATE_GREAT_DEALS_SUCCESS';
	var UPDATE_GREAT_DEALS_FAILURE = exports.UPDATE_GREAT_DEALS_FAILURE = 'UPDATE_GREAT_DEALS_FAILURE';
	var UPDATE_NEW_ARRIVALS = exports.UPDATE_NEW_ARRIVALS = 'UPDATE_NEW_ARRIVALS';
	var UPDATE_NEW_ARRIVALS_SUCCESS = exports.UPDATE_NEW_ARRIVALS_SUCCESS = 'UPDATE_NEW_ARRIVALS_SUCCESS';
	var UPDATE_NEW_ARRIVALS_FAILURE = exports.UPDATE_NEW_ARRIVALS_FAILURE = 'UPDATE_NEW_ARRIVALS_FAILURE';
	var GRAB_MOBILE_USER_ID = exports.GRAB_MOBILE_USER_ID = 'GRAB_MOBILE_USER_ID';
	var REQUEST_USERNAME = exports.REQUEST_USERNAME = 'REQUEST_USERNAME';
	var REQUEST_USERNAME_SUCCESS = exports.REQUEST_USERNAME_SUCCESS = 'REQUEST_USERNAME_SUCCESS';
	var REQUEST_USERNAME_FAILURE = exports.REQUEST_USERNAME_FAILURE = 'REQUEST_USERNAME_FAILURE';
	var CLEAR_USERNAME_DATA = exports.CLEAR_USERNAME_DATA = 'CLEAR_USERNAME_DATA';
	// Category Analysis auth_actions
	var CHOOSE_CATEGORY = exports.CHOOSE_CATEGORY = 'CHOOSE_CATEGORY';
	
	var FETCH_BILLBOARD_IMAGES = exports.FETCH_BILLBOARD_IMAGES = 'FETCH_BILLBOARD_IMAGES';
	var FETCH_BILLBOARD_IMAGES_SUCCESS = exports.FETCH_BILLBOARD_IMAGES_SUCCESS = 'FETCHING_BILLBOARD_IMAGES';
	var FETCH_BILLBOARD_IMAGES_FAILURE = exports.FETCH_BILLBOARD_IMAGES_FAILURE = 'FETCHING_BILLBOARD_IMAGES';
	var SAVE_BILLBOARD_IMAGES = exports.SAVE_BILLBOARD_IMAGES = 'SAVE_BILLBOARD_IMAGES';
	var SAVE_BILLBOARD_IMAGES_SUCCESS = exports.SAVE_BILLBOARD_IMAGES_SUCCESS = 'SAVE_BILLBOARD_IMAGES_SUCCESS';
	var SAVE_BILLBOARD_IMAGES_FAILURE = exports.SAVE_BILLBOARD_IMAGES_FAILURE = 'SAVE_BILLBOARD_IMAGES_FAILURE';
	var DELETE_BILLBOARD_IMAGE = exports.DELETE_BILLBOARD_IMAGE = 'DELETE_BILLBOARD_IMAGE';
	var DELETE_BILLBOARD_IMAGE_SUCCESS = exports.DELETE_BILLBOARD_IMAGE_SUCCESS = 'DELETE_BILLBOARD_IMAGE_SUCCESS';
	var DELETE_BILLBOARD_IMAGE_FAILURE = exports.DELETE_BILLBOARD_IMAGE_FAILURE = 'DELETE_BILLBOARD_IMAGE_FAILURE';
	
	//RMA actions
	var REQUEST_CUSTOMER_SEARCH = exports.REQUEST_CUSTOMER_SEARCH = 'REQUEST_CUSTOMER_SEARCH';
	var CUSTOMER_SEARCH_SUCCESS = exports.CUSTOMER_SEARCH_SUCCESS = 'CUSTOMER_SEARCH_SUCCESS';
	var RETURN_SEARCH_SUCCESS = exports.RETURN_SEARCH_SUCCESS = "RETURN_SEARCH_SUCCESS";
	var CUSTOMER_SEARCH_FAILURE = exports.CUSTOMER_SEARCH_FAILURE = 'CUSTOMER_SEARCH_FAILURE';
	var REQUEST_CUSTOMER_CREATE_RETURN = exports.REQUEST_CUSTOMER_CREATE_RETURN = 'REQUEST_CUSTOMER_CREATE_RETURN';
	var CUSTOMER_CREATE_RETURN_SUCCESS = exports.CUSTOMER_CREATE_RETURN_SUCCESS = 'CUSTOMER_CREATE_RETURN_SUCCESS';
	var CUSTOMER_CREATE_RETURN_FAILURE = exports.CUSTOMER_CREATE_RETURN_FAILURE = 'CUSTOMER_CREATE_RETURN_FAILURE';
	var REQUEST_CUSTOMER_EDIT_RETURN = exports.REQUEST_CUSTOMER_EDIT_RETURN = 'REQUEST_CUSTOMER_EDIT_RETURN';
	var CUSTOMER_EDIT_RETURN_SUCCESS = exports.CUSTOMER_EDIT_RETURN_SUCCESS = 'CUSTOMER_EDIT_RETURN_SUCCESS';
	var CUSTOMER_EDIT_RETURN_FAILURE = exports.CUSTOMER_EDIT_RETURN_FAILURE = 'CUSTOMER_EDIT_RETURN_FAILURE';
	var REQUEST_DISPATCH_EDIT_RETURN = exports.REQUEST_DISPATCH_EDIT_RETURN = 'REQUEST_DISPATCH_EDIT_RETURN';
	var DISPATCH_EDIT_RETURN_SUCCESS = exports.DISPATCH_EDIT_RETURN_SUCCESS = 'DISPATCH_EDIT_RETURN_SUCCESS';
	var DISPATCH_EDIT_RETURN_FAILURE = exports.DISPATCH_EDIT_RETURN_FAILURE = 'DISPATCH_EDIT_RETURN_FAILURE';
	var REQUEST_DISPATCH_SEARCH = exports.REQUEST_DISPATCH_SEARCH = 'REQUEST_DISPATCH_SEARCH';
	var DISPATCH_SEARCH_SUCCESS = exports.DISPATCH_SEARCH_SUCCESS = 'DISPATCH_SEARCH_SUCCESS';
	var DISPATCH_SEARCH_FAILURE = exports.DISPATCH_SEARCH_FAILURE = 'DISPATCH_SEARCH_FAILURE';
	var SET_RETURNS_FILTER = exports.SET_RETURNS_FILTER = 'SET_RETURNS_FILTER';
	var RESET_CURRENT_RETURN = exports.RESET_CURRENT_RETURN = 'RESET_CURRENT_RETURN';
	var RESET_CURRENT_FORM = exports.RESET_CURRENT_FORM = 'RESET_CURRENT_FORM';
	var FETCH_CUSTOMERS = exports.FETCH_CUSTOMERS = 'RMA/FETCH_CUSTOMER';
	
	// Adjustment Inventory page actions
	var REQUEST_REASONS = exports.REQUEST_REASONS = 'START_FETCHING_REASONS';
	var REQUEST_REASONS_SUCCESS = exports.REQUEST_REASONS_SUCCESS = 'FETCH_REASONS_SUCCESS';
	var REQUEST_REASONS_FAILURE = exports.REQUEST_REASONS_FAILURE = 'FETCH_REASONS_FAILURE';
	var START_REASON_CREATION = exports.START_REASON_CREATION = 'START_REASON_CREATION';
	var REASON_CREATION_SUCCESS = exports.REASON_CREATION_SUCCESS = 'REASON_CREATION_SUCCESS';
	var REASON_CREATION_FAILURE = exports.REASON_CREATION_FAILURE = 'REASON_CREATION_FAILURE';
	var START_REASON_EDITING = exports.START_REASON_EDITING = 'START_REASON_EDITING';
	var REASON_EDITING_SUCCESS = exports.REASON_EDITING_SUCCESS = 'REASON_EDITING_SUCCESS';
	var REASON_EDITING_FAILURE = exports.REASON_EDITING_FAILURE = 'REASON_EDITING_FAILURE';
	var REQUEST_DELETE_REASON = exports.REQUEST_DELETE_REASON = 'REQUEST_DELETE_REASON';
	var REASON_DELETE_SUCCESS = exports.REASON_DELETE_SUCCESS = 'REASON_DELETE_SUCCESS';
	var REASON_DELETE_FAILURE = exports.REASON_DELETE_FAILURE = 'REASON_DELETE_FAILURE';
	var SELECT_REASON = exports.SELECT_REASON = 'SELECT_REASON';
	var RESET_CURRENT_REASON = exports.RESET_CURRENT_REASON = 'RESET_CURRENT_REASON';
	var REQUEST_ADJUSTMENT_LOGS = exports.REQUEST_ADJUSTMENT_LOGS = 'REQUEST_ADJUSTMENT_LOGS';
	var ADJUSTMENT_LOG_SUCCESS = exports.ADJUSTMENT_LOG_SUCCESS = 'ADJUSTMENT_LOG_SUCCESS';
	var ADJUSTMENT_LOG_FAILURE = exports.ADJUSTMENT_LOG_FAILURE = 'ADJUSTMENT_LOG_FAILURE';
	
	//settings actions
	var REQUEST_ACTION_LOG_BY_FILTER = exports.REQUEST_ACTION_LOG_BY_FILTER = 'REQUEST_ACTION_LOG_BY_FILTER';
	var ACTION_LOG_FILTER_SUCCESS = exports.ACTION_LOG_FILTER_SUCCESS = 'ACTION_LOG_FILTER_SUCESS';
	var ACTION_LOG_FILTER_FAILURE = exports.ACTION_LOG_FILTER_FAILURE = 'ACTION_LOG_FILTER_FAILURE';
	var SET_SELECTED_BUSINESSUSER = exports.SET_SELECTED_BUSINESSUSER = 'SET_SELECTED_BUSINESSUSER';
	
	//mmdriver action types
	var FETCH_MMDRIVER = exports.FETCH_MMDRIVER = 'FETCH_MMDRIVER';
	var FETCH_MMDRIVERS = exports.FETCH_MMDRIVERS = 'FETCH_MMDRIVERS';
	
	//Dispatch Action Types:
	var FETCH_ROUTES_PRINTER_SUCESS = exports.FETCH_ROUTES_PRINTER_SUCESS = "FETCH_ROUTES_PRINTER_SUCESS";
	var SAVE_ROUTES_PRINTER_SUCESS = exports.SAVE_ROUTES_PRINTER_SUCESS = "SAVE_ROUTES_PRINTER_SUCESS";
	var SET_AUTO_ROUTING_BUTTONS_LOADING = exports.SET_AUTO_ROUTING_BUTTONS_LOADING = "SET_AUTO_ROUTING_BUTTONS_LOADING";
	
	//BaseModal Action Types:
	var SET_CONFIRM_PASSCODE_MODAL_VISIBILITY = exports.SET_CONFIRM_PASSCODE_MODAL_VISIBILITY = "SET_CONFIRM_PASSCODE_MODAL_VISIBILITY";
	var SET_PASSCODE_VERFICATION = exports.SET_PASSCODE_VERFICATION = "SET_PASSCODE_VERFICATION";
	
	//Tracking Note Types:
	var FETCH_TRACKING_SUCCESS = exports.FETCH_TRACKING_SUCCESS = "FETCH_TRACKING_SUCCESS";
	var EDIT_TRACKING_SUCCESS = exports.EDIT_TRACKING_SUCCESS = "EDIT_TRACKING_SUCCESS";
	
	//ESL:
	var REQUEST_INITIALIZE_ESL = exports.REQUEST_INITIALIZE_ESL = "REQUEST_INITIALIZE_ESL";
	var REQUEST_DELETE_ESL = exports.REQUEST_DELETE_ESL = "REQUEST_DELETE_ESL";
	var REQUEST_FETCH_ESL_TEMPLATE = exports.REQUEST_FETCH_ESL_TEMPLATE = "REQUEST_FETCH_ESL_TEMPLATE";
	var REQUEST_SAVE_ESL = exports.REQUEST_SAVE_ESL = "REQUEST_SAVE_ESL";
	var REQUEST_FETCH_ESL = exports.REQUEST_FETCH_ESL = "REQUEST_FETCH_ESL";
	
	// Merge Purchase Orders
	var MERGE_PURCHASE_ORDERS_LOADING = exports.MERGE_PURCHASE_ORDERS_LOADING = 'MERGE_PURCHASE_ORDERS_LOADING';
	var MERGE_PURCHASE_ORDERS_SUCCESS = exports.MERGE_PURCHASE_ORDERS_SUCCESS = 'MERGE_PURCHASE_ORDERS_SUCCESS';
	var MERGE_PURCHASE_ORDERS_ERROR = exports.MERGE_PURCHASE_ORDERS_ERROR = 'MERGE_PURCHASE_ORDERS_ERROR';
	
	// WUFS
	var REQUEST_PRE_ORDERS = exports.REQUEST_PRE_ORDERS = 'REQUEST_PRE_ORDERS';
	var FETCH_PRE_ORDERS_SUCCESS = exports.FETCH_PRE_ORDERS_SUCCESS = 'FETCH_PRE_ORDERS_SUCCESS';
	var FETCH_PRE_ORDERS_FAILURE = exports.FETCH_PRE_ORDERS_FAILURE = 'FETCH_PRE_ORDERS_FAILURE';
	var REQUEST_SHIP_TO_ORDERS = exports.REQUEST_SHIP_TO_ORDERS = 'REQUEST_SHIP_TO_ORDERS';
	var FETCH_SHIP_TO_ORDERS_SUCCESS = exports.FETCH_SHIP_TO_ORDERS_SUCCESS = 'FETCH_SHIP_TO_ORDERS_SUCCESS';
	var FETCH_SHIP_TO_ORDERS_FAILURE = exports.FETCH_SHIP_TO_ORDERS_FAILURE = 'FETCH_SHIP_TO_ORDERS_FAILURE';
	var REQUEST_SHIP_FROM_ORDERS = exports.REQUEST_SHIP_FROM_ORDERS = 'REQUEST_SHIP_FROM_ORDERS';
	var FETCH_SHIP_FROM_ORDERS_SUCCESS = exports.FETCH_SHIP_FROM_ORDERS_SUCCESS = 'FETCH_SHIP_FROM_ORDERS_SUCCESS';
	var FETCH_SHIP_FROM_ORDERS_FAILURE = exports.FETCH_SHIP_FROM_ORDERS_FAILURE = 'FETCH_SHIP_FROM_ORDERS_FAILURE';
	var REQUEST_OTHER_SERVICE = exports.REQUEST_OTHER_SERVICE = 'REQUEST_OTHER_SERVICE';
	var FETCH_OTHER_SERVICE_SUCCESS = exports.FETCH_OTHER_SERVICE_SUCCESS = 'FETCH_OTHER_SERVICE_SUCCESS';
	var FETCH_OTHER_SERVICE_FAILURE = exports.FETCH_OTHER_SERVICE_FAILURE = 'FETCH_OTHER_SERVICE_FAILURE';
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(REQUEST_USERS, 'REQUEST_USERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_USERS_SUCCESS, 'FETCH_USERS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_USERS_FAILURE, 'FETCH_USERS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_USER, 'CREATE_USER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_USER, 'SELECT_USER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_POSTS, 'REQUEST_POSTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_POSTS_SUCCESS, 'FETCH_POSTS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_POSTS_FAILURE, 'FETCH_POSTS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_COMMENTS, 'REQUEST_COMMENTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_COMMENTS_SUCCESS, 'FETCH_COMMENTS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_COMMENTS_FAILURE, 'FETCH_COMMENTS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_POST, 'SELECT_POST', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(PRODUCTFORM_ACTIVE_CUSTOMER, 'PRODUCTFORM_ACTIVE_CUSTOMER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_CATEGORY2_PRODUCT, 'DELETE_CATEGORY2_PRODUCT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_CATEGORY2_PRODUCT_SUCCESS, 'DELETE_CATEGORY2_PRODUCT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_CATEGORY2_PRODUCT_FAILURE, 'DELETE_CATEGORY2_PRODUCT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PRODUCTS, 'REQUEST_PRODUCTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRODUCTS_SUCCESS, 'FETCH_PRODUCTS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRODUCTS_FAILURE, 'FETCH_PRODUCTS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CATEGORY2_PRODUCTS_SUCCESS, 'FETCH_CATEGORY2_PRODUCTS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRODUCTS_BY_CATEGORY2_FAILURE, 'FETCH_PRODUCTS_BY_CATEGORY2_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CATEGORY2_PRODUCTS, 'REQUEST_CATEGORY2_PRODUCTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PRODUCT_BY_NUM, 'REQUEST_PRODUCT_BY_NUM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRODUCT_BY_NUM_SUCCESS, 'FETCH_PRODUCT_BY_NUM_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRODUCT_BY_NUM_FAILURE, 'FETCH_PRODUCT_BY_NUM_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_NEXT_PRODUCT, 'REQUEST_NEXT_PRODUCT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_NEXT_PRODUCT_SUCCESS, 'FETCH_NEXT_PRODUCT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_NEXT_PRODUCT_FAILURE, 'FETCH_NEXT_PRODUCT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PREVIOUS_PRODUCT, 'REQUEST_PREVIOUS_PRODUCT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PREVIOUS_PRODUCT_SUCCESS, 'FETCH_PREVIOUS_PRODUCT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PREVIOUS_PRODUCT_FAILURE, 'FETCH_PREVIOUS_PRODUCT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PRODUCTS_BY_VENDOR, 'REQUEST_PRODUCTS_BY_VENDOR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRODUCTS_BY_VENDOR_SUCCESS, 'FETCH_PRODUCTS_BY_VENDOR_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRODUCTS_BY_VENDOR_FAILURE, 'FETCH_PRODUCTS_BY_VENDOR_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_VENDOR_BATCHES, 'FETCH_VENDOR_BATCHES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_VENDOR_BATCHES_SUCCESS, 'FETCH_VENDOR_BATCHES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_VENDOR_BATCHES_FAILURE, 'FETCH_VENDOR_BATCHES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RELATED_PRODUCTS, 'FETCH_RELATED_PRODUCTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RELATED_PRODUCTS_SUCCESS, 'FETCH_RELATED_PRODUCTS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RELATED_PRODUCTS_FAILURE, 'FETCH_RELATED_PRODUCTS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_PRODUCT, 'SELECT_PRODUCT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_PRODUCT, 'RESET_CURRENT_PRODUCT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_CURRENT_PRODUCT, 'CLEAR_CURRENT_PRODUCT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SET_GROUP_CATEGORY, 'SET_GROUP_CATEGORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_PRODUCT, 'REQUEST_CREATING_PRODUCT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_PRODUCT_SUCCESS, 'CREATE_PRODUCT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_PRODUCT_FAILURE, 'CREATE_PRODUCT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_PRODUCT, 'REQUEST_EDITING_PRODUCT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PRODUCT_SUCCESS, 'EDIT_PRODUCT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PRODUCT_FAILURE, 'EDIT_PRODUCT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_MULTI_PRODUCT, 'REQUEST_EDITING_MULTI_PRODUCT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_MULTI_PRODUCT_SUCCESS, 'EDIT_MULTI_PRODUCT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_MULTI_PRODUCT_FAILURE, 'EDIT_MULTI_PRODUCT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PRODUCT_DETAIL, 'REQUEST_PRODUCT_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRODUCT_DETAIL_SUCCESS, 'FETCH_PRODUCT_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRODUCT_DETAIL_FAILURE, 'FETCH_PRODUCT_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DISPLAY_CATEGORIES, 'REQUEST_DISPLAY_CATEGORIES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_DISPLAY_CATEGORIES_SUCCESS, 'FETCH_DISPLAY_CATEGORIES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_DISPLAY_CATEGORIES_FAILURE, 'FETCH_DISPLAY_CATEGORIES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDIT_DISPLAY_CATEGORIES, 'REQUEST_EDIT_DISPLAY_CATEGORIES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_DISPLAY_CATEGORIES_SUCCESS, 'EDIT_DISPLAY_CATEGORIES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_DISPLAY_CATEGORIES_FAILURE, 'EDIT_DISPLAY_CATEGORIES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PRODUCT_INFO, 'REQUEST_PRODUCT_INFO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRODUCT_INFO_SUCCESS, 'FETCH_PRODUCT_INFO_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRODUCT_INFO_FAILURE, 'FETCH_PRODUCT_INFO_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ATTACH_PRODUCT_IMAGE, 'ATTACH_PRODUCT_IMAGE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ATTACH_PRODUCT_IMAGE_SUCCESS, 'ATTACH_PRODUCT_IMAGE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ATTACH_PRODUCT_IMAGE_FAILURE, 'ATTACH_PRODUCT_IMAGE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_ATTACHED_PRODUCT_IMAGE, 'CLEAR_ATTACHED_PRODUCT_IMAGE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SUGGESTED_PROD_NUM, 'FETCH_SUGGESTED_PROD_NUM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SUGGESTED_PROD_NUM_SUCCESS, 'FETCH_SUGGESTED_PROD_NUM_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SUGGESTED_PROD_NUM_FAILURE, 'FETCH_SUGGESTED_PROD_NUM_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SUGGEST_DIGIT, 'FETCH_SUGGEST_DIGIT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SUGGEST_DIGIT_SUCCESS, 'FETCH_SUGGEST_DIGIT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SUGGEST_DIGIT_FAILURE, 'FETCH_SUGGEST_DIGIT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_SUGGEST_DIGIT, 'CLEAR_SUGGEST_DIGIT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PACKAGE_TYPES, 'FETCH_PACKAGE_TYPES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PACKAGE_TYPES_SUCCESS, 'FETCH_PACKAGE_TYPES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PACKAGE_TYPES_FAILURE, 'FETCH_PACKAGE_TYPES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PACKAGE_TYPE, 'EDIT_PACKAGE_TYPE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PACKAGE_TYPE_SUCCESS, 'EDIT_PACKAGE_TYPE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PACKAGE_TYPE_FAILURE, 'EDIT_PACKAGE_TYPE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_PACKAGE_TYPE_EDITED, 'CLEAR_PACKAGE_TYPE_EDITED', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DELETE_PACKAGE_TYPE, 'REQUEST_DELETE_PACKAGE_TYPE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_PACKAGE_TYPE_SUCCESS, 'DELETE_PACKAGE_TYPE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_PACKAGE_TYPE_FAILURE, 'DELETE_PACKAGE_TYPE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_MEASUREMENT_UNIT, 'FETCH_MEASUREMENT_UNIT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_MEASUREMENT_UNIT_SUCCESS, 'FETCH_MEASUREMENT_UNIT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_MEASUREMENT_UNIT_FAILURE, 'FETCH_MEASUREMENT_UNIT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_MEASUREMENT_UNIT, 'EDIT_MEASUREMENT_UNIT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_MEASUREMENT_UNIT_SUCCESS, 'EDIT_MEASUREMENT_UNIT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_MEASUREMENT_UNIT_FAILURE, 'EDIT_MEASUREMENT_UNIT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_MEASUREMENT_UNIT_EDITED, 'CLEAR_MEASUREMENT_UNIT_EDITED', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DELETE_MEASUREMENT_UNIT, 'REQUEST_DELETE_MEASUREMENT_UNIT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_MEASUREMENT_UNIT_SUCCESS, 'DELETE_MEASUREMENT_UNIT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_MEASUREMENT_UNIT_FAILURE, 'DELETE_MEASUREMENT_UNIT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CONVERTABLE_PRODUCTS, 'FETCH_CONVERTABLE_PRODUCTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CONVERTABLE_PRODUCTS_SUCCESS, 'FETCH_CONVERTABLE_PRODUCTS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CONVERTABLE_PRODUCTS_FAILURE, 'FETCH_CONVERTABLE_PRODUCTS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SET_CURRENT_PRODUCT, 'SET_CURRENT_PRODUCT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_GROUPS, 'REQUEST_GROUPS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_GROUPS_SUCCESS, 'FETCH_GROUPS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_GROUPS_FAILURE, 'FETCH_GROUPS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_GROUP, 'SELECT_GROUP', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_GROUP, 'RESET_CURRENT_GROUP', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_GROUP, 'REQUEST_CREATING_GROUP', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_GROUP_SUCCESS, 'CREATE_GROUP_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_GROUP_FAILURE, 'CREATE_GROUP_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_GROUP, 'REQUEST_EDITING_GROUP', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_GROUP_SUCCESS, 'EDIT_GROUP_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_GROUP_FAILURE, 'EDIT_GROUP_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_MULTI_GROUPS, 'REQUEST_EDITING_MULTI_GROUPS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_MULTI_GROUPS_SUCCESS, 'EDIT_MULTI_GROUPS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_MULTI_GROUPS_FAILURE, 'EDIT_MULTI_GROUPS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_GROUP_DETAIL, 'REQUEST_GROUP_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_GROUP_DETAIL_SUCCESS, 'FETCH_GROUP_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_GROUP_DETAIL_FAILURE, 'FETCH_GROUP_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CATEGORIES, 'REQUEST_CATEGORIES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CATEGORIES_SUCCESS, 'FETCH_CATEGORIES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CATEGORIES_FAILURE, 'FETCH_CATEGORIES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_GROUP_CATEGORIES, 'REQUEST_GROUP_CATEGORIES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_GROUP_CATEGORIES_SUCCESS, 'FETCH_GROUP_CATEGORIES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_GROUP_CATEGORIES_FAILURE, 'FETCH_GROUP_CATEGORIES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_CATEGORY, 'SELECT_CATEGORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_CATEGORY, 'RESET_CURRENT_CATEGORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_CATEGORY, 'REQUEST_CREATING_CATEGORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_CATEGORY_SUCCESS, 'CREATE_CATEGORY_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_CATEGORY_FAILURE, 'CREATE_CATEGORY_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_MULTI_TAXES, 'EDIT_MULTI_TAXES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_MULTI_TAXES_SUCCESS, 'EDIT_MULTI_TAXES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_MULTI_TAXES_FAILURE, 'EDIT_MULTI_TAXES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_TAX, 'DELETE_TAX', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_TAX_SUCCESS, 'DELETE_TAX_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_TAX_FAILURE, 'DELETE_TAX_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_CATEGORY, 'REQUEST_EDITING_CATEGORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_CATEGORY_SUCCESS, 'EDIT_CATEGORY_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_CATEGORY_FAILURE, 'EDIT_CATEGORY_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_MULTI_CATEGORIES, 'REQUEST_EDITING_MULTI_CATEGORIES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_MULTI_CATEGORIES_SUCCESS, 'EDIT_MULTI_CATEGORIES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_MULTI_CATEGORIES_FAILURE, 'EDIT_MULTI_CATEGORIES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CATEGORIES_2, 'REQUEST_CATEGORIES_2', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CATEGORIES_2_SUCCESS, 'FETCH_CATEGORIES_2_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CATEGORIES_2_FAILURE, 'FETCH_CATEGORIES_2_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_MULTI_CATEGORIES_2, 'REQUEST_EDITING_MULTI_CATEGORIES_2', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_MULTI_CATEGORIES_2_SUCCESS, 'EDIT_MULTI_CATEGORIES_2_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_MULTI_CATEGORIES_2_FAILURE, 'EDIT_MULTI_CATEGORIES_2_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DELETE_CATEGORY_2, 'REQUEST_DELETE_CATEGORY_2', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_CATEGORY_2_SUCCESS, 'DELETE_CATEGORY_2_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_CATEGORY_2_FAILURE, 'DELETE_CATEGORY_2_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_CATEGORY_2_STATUS, 'CLEAR_CATEGORY_2_STATUS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SET_ROWS_FILTERS, 'SET_ROWS_FILTERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CATEGORIES_2_B2B, 'REQUEST_CATEGORIES_2_B2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CATEGORIES_2_SUCCESS_B2B, 'FETCH_CATEGORIES_2_SUCCESS_B2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CATEGORIES_2_FAILURE_B2B, 'FETCH_CATEGORIES_2_FAILURE_B2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_MULTI_CATEGORIES_2_B2B, 'REQUEST_EDITING_MULTI_CATEGORIES_2_B2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_MULTI_CATEGORIES_2_SUCCESS_B2B, 'EDIT_MULTI_CATEGORIES_2_SUCCESS_B2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_MULTI_CATEGORIES_2_FAILURE_B2B, 'EDIT_MULTI_CATEGORIES_2_FAILURE_B2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DELETE_CATEGORY_2_B2B, 'REQUEST_DELETE_CATEGORY_2_B2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_CATEGORY_2_SUCCESS_B2B, 'DELETE_CATEGORY_2_SUCCESS_B2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_CATEGORY_2_FAILURE_B2B, 'DELETE_CATEGORY_2_FAILURE_B2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_CATEGORY_2_STATUS_B2B, 'CLEAR_CATEGORY_2_STATUS_B2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_CATEGORY_B2B, 'SELECT_CATEGORY_B2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_CATEGORY_B2B, 'RESET_CURRENT_CATEGORY_B2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CATEGORY2_PRODUCTS_B2B, 'REQUEST_CATEGORY2_PRODUCTS_B2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CATEGORY2_PRODUCTS_SUCCESS_B2B, 'FETCH_CATEGORY2_PRODUCTS_SUCCESS_B2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CATEGORY2_PRODUCTS_FAILURE_B2B, 'FETCH_CATEGORY2_PRODUCTS_FAILURE_B2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_ACTION_LOG, 'REQUEST_ACTION_LOG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_ACTION_LOG_SUCCESS, 'FETCH_ACTION_LOG_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_ACTION_LOG_FAILURE, 'FETCH_ACTION_LOG_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CONTINUE_OR_DISCONTINUE_PRODUCT, 'REQUEST_CONTINUE_OR_DISCONTINUE_PRODUCT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_PRODUCT, 'DELETE_PRODUCT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_PRODUCT_SUCCESS, 'DELETE_PRODUCT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_PRODUCT_FAILURE, 'DELETE_PRODUCT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CONTINUE_OR_DISCONTINUE_PRODUCT_SUCCESS, 'CONTINUE_OR_DISCONTINUE_PRODUCT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CONTINUE_OR_DISCONTINUE_PRODUCT_FAILURE, 'CONTINUE_OR_DISCONTINUE_PRODUCT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_MOBILE_DESCRIPTION_BOX_TEXT_SUCCESS, 'SAVE_MOBILE_DESCRIPTION_BOX_TEXT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_MOBILE_DESCRIPTION_BOX_TEXT_FAILURE, 'SAVE_MOBILE_DESCRIPTION_BOX_TEXT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SAVE_MOBILE_DESCRIPTION_BOX_TEXT, 'REQUEST_SAVE_MOBILE_DESCRIPTION_BOX_TEXT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CATEGORY2_ID, 'RESET_CATEGORY2_ID', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_GROUP_AND_CATEGORY, 'RESET_GROUP_AND_CATEGORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CATEGORY, 'RESET_CATEGORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_TYPES, 'REQUEST_TYPES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_TYPES_SUCCESS, 'FETCH_TYPES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_TYPES_FAILURE, 'FETCH_TYPES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PRICELEVELS, 'REQUEST_PRICELEVELS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRICELEVELS_SUCCESS, 'FETCH_PRICELEVELS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRICELEVELS_FAILURE, 'FETCH_PRICELEVELS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_MULTI_PRICELEVELS, 'REQUEST_EDITING_MULTI_PRICELEVELS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_MULTI_PRICELEVELS_SUCCESS, 'EDIT_MULTI_PRICELEVELS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_MULTI_PRICELEVELS_FAILURE, 'EDIT_MULTI_PRICELEVELS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SIMPLIFIED_PRODUCTS, 'REQUEST_SIMPLIFIED_PRODUCTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SIMPLIFIED_PRODUCTS_SUCCESS, 'FETCH_SIMPLIFIED_PRODUCTS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SIMPLIFIED_PRODUCTS_FAILURE, 'FETCH_SIMPLIFIED_PRODUCTS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DELETE_CATEGORY, 'REQUEST_DELETE_CATEGORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_CATEGORY_SUCCESS, 'DELETE_CATEGORY_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_CATEGORY_FAILURE, 'DELETE_CATEGORY_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DELETE_GROUP, 'REQUEST_DELETE_GROUP', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_GROUP_SUCCESS, 'DELETE_GROUP_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_PRODUCT_GROUP_SUCCESS, 'DELETE_PRODUCT_GROUP_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_GROUP_FAILURE, 'DELETE_GROUP_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_CATEGORY_STATUS, 'CLEAR_CATEGORY_STATUS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_GROUP_STATUS, 'CLEAR_GROUP_STATUS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REINITIALZIE_PRODUCT_FORM, 'REINITIALZIE_PRODUCT_FORM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SMALL_PRODUCT_INFO, 'REQUEST_SMALL_PRODUCT_INFO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SMALL_PRODUCT_INFO_SUCCESS, 'FETCH_SMALL_PRODUCT_INFO_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SMALL_PRODUCT_INFO_FAILURE, 'FETCH_SMALL_PRODUCT_INFO_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_SMALL_PRODUCT, 'CLEAR_SMALL_PRODUCT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CRV_VALUES, 'REQUEST_CRV_VALUES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CRV_VALUES_SUCCESS, 'FETCH_CRV_VALUES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CRV_VALUES_FAILURE, 'FETCH_CRV_VALUES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DEFAULT_BUYERS, 'REQUEST_DEFAULT_BUYERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DEFAULT_BUYERS_SUCCESS, 'REQUEST_DEFAULT_BUYERS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DEFAULT_BUYERS_FAILURE, 'REQUEST_DEFAULT_BUYERS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_UPDATE_PRODUCT, 'REQUEST_UPDATE_PRODUCT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(UPDATE_PRODUCT_SUCCEESS, 'UPDATE_PRODUCT_SUCCEESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(UPDATE_PRODUCT_FAILURE, 'UPDATE_PRODUCT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CUSTOMERS, 'REQUEST_CUSTOMERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMERS_SUCCESS, 'FETCH_CUSTOMERS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMERS_FAILURE, 'FETCH_CUSTOMERS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CUSTOMERS_PAGINATE, 'REQUEST_CUSTOMERS_PAGINATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMERS_PAGINATE_SUCCESS, 'FETCH_CUSTOMERS_PAGINATE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMERS_PAGINATE_FAILURE, 'FETCH_CUSTOMERS_PAGINATE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_CUSTOMER, 'SELECT_CUSTOMER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_CUSTOMER, 'RESET_CURRENT_CUSTOMER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_CUSTOMER, 'REQUEST_CREATING_CUSTOMER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_CUSTOMER_SUCCESS, 'CREATE_CUSTOMER_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_CUSTOMER_FAILURE, 'CREATE_CUSTOMER_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_CUSTOMER, 'REQUEST_EDITING_CUSTOMER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_CUSTOMER_SUCCESS, 'EDIT_CUSTOMER_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_CUSTOMER_FAILURE, 'EDIT_CUSTOMER_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CUSTOMER_DETAIL, 'REQUEST_CUSTOMER_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_DETAIL_SUCCESS, 'FETCH_CUSTOMER_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_DETAIL_FAILURE, 'FETCH_CUSTOMER_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CUSTOMER_CREDIT_BY_DATE, 'REQUEST_CUSTOMER_CREDIT_BY_DATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_CREDIT_BY_DATE_SUCCESS, 'FETCH_CUSTOMER_CREDIT_BY_DATE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_CREDIT_BY_DATE_FAILURE, 'FETCH_CUSTOMER_CREDIT_BY_DATE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CUSTOMERS_STATUS, 'REQUEST_CUSTOMERS_STATUS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMERS_STATUS_SUCCESS, 'FETCH_CUSTOMERS_STATUS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMERS_STATUS_FAILURE, 'FETCH_CUSTOMERS_STATUS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PAYMENTTERMS, 'REQUEST_PAYMENTTERMS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PAYMENTTERMS_SUCCESS, 'FETCH_PAYMENTTERMS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PAYMENTTERMS_FAILURE, 'FETCH_PAYMENTTERMS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_PAYMENTTERM, 'SELECT_PAYMENTTERM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_PAYMENTTERM, 'RESET_CURRENT_PAYMENTTERM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CREATE_PAYMENT_TERM, 'RESET_CREATE_PAYMENT_TERM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_EDIT_PAYMENT_TERM, 'RESET_EDIT_PAYMENT_TERM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_PAYMENT_TERM, 'REQUEST_CREATING_PAYMENT_TERM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_PAYMENT_TERM_SUCCESS, 'CREATE_PAYMENT_TERM_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_PAYMENT_TERM_FAILURE, 'CREATE_PAYMENT_TERM_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_PAYMENT_TERM, 'REQUEST_EDITING_PAYMENT_TERM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PAYMENT_TERM_SUCCESS, 'EDIT_PAYMENT_TERM_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PAYMENT_TERM_FAILURE, 'EDIT_PAYMENT_TERM_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_GENERAL_REPORT, 'REQUEST_GENERAL_REPORT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_GENERAL_REPORT_SUCCESS, 'FETCH_GENERAL_REPORT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_GENERAL_REPORT_FAILURE, 'FETCH_GENERAL_REPORT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CITY_REPORT, 'REQUEST_CITY_REPORT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CITY_REPORT_SUCCESS, 'FETCH_CITY_REPORT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CITY_REPORT_FAILURE, 'FETCH_CITY_REPORT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CITY_REPORT, 'RESET_CITY_REPORT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CUSTOMER_STATEMENT, 'REQUEST_CUSTOMER_STATEMENT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_STATEMENT_SUCCESS, 'FETCH_CUSTOMER_STATEMENT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_STATEMENT_FAILURE, 'FETCH_CUSTOMER_STATEMENT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CUSTOMER_STATEMENT_LIST, 'REQUEST_CUSTOMER_STATEMENT_LIST', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_STATEMENT_LIST_SUCCESS, 'FETCH_CUSTOMER_STATEMENT_LIST_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_STATEMENT_LIST_FAILURE, 'FETCH_CUSTOMER_STATEMENT_LIST_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_VENDOR_STATEMENT_LIST, 'REQUEST_VENDOR_STATEMENT_LIST', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_VENDOR_STATEMENT_LIST_SUCCESS, 'FETCH_VENDOR_STATEMENT_LIST_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_VENDOR_STATEMENT_LIST_FAILURE, 'FETCH_VENDOR_STATEMENT_LIST_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_MOBILE_CUSTOMER_STATEMENT, 'REQUEST_MOBILE_CUSTOMER_STATEMENT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_MOBILE_CUSTOMER_STATEMENT_SUCCESS, 'FETCH_MOBILE_CUSTOMER_STATEMENT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_MOBILE_CUSTOMER_STATEMENT_FAILURE, 'FETCH_MOBILE_CUSTOMER_STATEMENT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_MOBILE_CUSTOMER_STATEMENT, 'RESET_MOBILE_CUSTOMER_STATEMENT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_VENDORS, 'REQUEST_VENDORS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_VENDORS_SUCCESS, 'FETCH_VENDORS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_VENDORS_FAILURE, 'FETCH_VENDORS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_VENDOR, 'SELECT_VENDOR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_VENDOR, 'RESET_CURRENT_VENDOR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_VENDOR, 'REQUEST_CREATING_VENDOR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_VENDOR_SUCCESS, 'CREATE_VENDOR_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_VENDOR_FAILURE, 'CREATE_VENDOR_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_VENDOR, 'REQUEST_EDITING_VENDOR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_VENDOR_SUCCESS, 'EDIT_VENDOR_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_VENDOR_FAILURE, 'EDIT_VENDOR_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_VENDOR_DETAIL, 'REQUEST_VENDOR_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_VENDOR_STATEMENT, 'REQUEST_VENDOR_STATEMENT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_VENDOR_STATEMENT_SUCCESS, 'FETCH_VENDOR_STATEMENT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_VENDOR_STATEMENT_FAILURE, 'FETCH_VENDOR_STATEMENT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_VENDOR_DETAIL_SUCCESS, 'FETCH_VENDOR_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_VENDOR_DETAIL_FAILURE, 'FETCH_VENDOR_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_VENDOR_INVENTORY_DETAIL, 'REQUEST_VENDOR_INVENTORY_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_VENDOR_INVENTORY_DETAIL_SUCCESS, 'FETCH_VENDOR_INVENTORY_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_VENDOR_INVENTORY_DETAIL_FAILURE, 'FETCH_VENDOR_INVENTORY_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_VENDOR_RECORDS, 'REQUEST_VENDOR_RECORDS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_VENDOR_RECORDS_SUCCESS, 'FETCH_VENDOR_RECORDS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_VENDOR_RECORDS_FAILURE, 'FETCH_VENDOR_RECORDS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_AGENTS, 'REQUEST_AGENTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_AGENTS_SUCCESS, 'FETCH_AGENTS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_AGENTS_FAILURE, 'FETCH_AGENTS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_AGENT, 'SELECT_AGENT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_AGENT, 'RESET_CURRENT_AGENT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_AGENT, 'REQUEST_CREATING_AGENT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_AGENT_SUCCESS, 'CREATE_AGENT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_AGENT_FAILURE, 'CREATE_AGENT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_AGENT, 'REQUEST_EDITING_AGENT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_AGENT_SUCCESS, 'EDIT_AGENT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_AGENT_FAILURE, 'EDIT_AGENT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_AGENT_DETAIL, 'REQUEST_AGENT_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_AGENT_DETAIL_SUCCESS, 'FETCH_AGENT_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_AGENT_DETAIL_FAILURE, 'FETCH_AGENT_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_AUTH, 'REQUEST_AUTH', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(AUTH_USER, 'AUTH_USER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(AUTH_USER_PERMISSIONS, 'AUTH_USER_PERMISSIONS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(UNAUTH_USER, 'UNAUTH_USER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(AUTH_ERROR, 'AUTH_ERROR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_MESSAGE, 'FETCH_MESSAGE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_QUOTES, 'REQUEST_PURCHASE_QUOTES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_QUOTES_SUCCESS, 'FETCH_PURCHASE_QUOTES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_QUOTES_FAILURE, 'FETCH_PURCHASE_QUOTES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_PURCHASE_QUOTE, 'SELECT_PURCHASE_QUOTE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_PURCHASE_QUOTE, 'RESET_CURRENT_PURCHASE_QUOTE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_QUOTE_DETAIL, 'REQUEST_PURCHASE_QUOTE_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_QUOTE_DETAIL_SUCCESS, 'FETCH_PURCHASE_QUOTE_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_QUOTE_DETAIL_FAILURE, 'FETCH_PURCHASE_QUOTE_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_PURCHASE_QUOTE, 'REQUEST_CREATING_PURCHASE_QUOTE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_PURCHASE_QUOTE_SUCCESS, 'CREATE_PURCHASE_QUOTE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_PURCHASE_QUOTE_FAILURE, 'CREATE_PURCHASE_QUOTE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_QUOTE_PLACE, 'REQUEST_PURCHASE_QUOTE_PLACE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(PURCHASE_QUOTE_PLACE_SUCCESS, 'PURCHASE_QUOTE_PLACE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(PURCHASE_QUOTE_PLACE_FAILURE, 'PURCHASE_QUOTE_PLACE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_PURCHASE_QUOTE, 'REQUEST_EDITING_PURCHASE_QUOTE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PURCHASE_QUOTE_SUCCESS, 'EDIT_PURCHASE_QUOTE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PURCHASE_QUOTE_FAILURE, 'EDIT_PURCHASE_QUOTE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_NUM_PURCHASE_QUOTES, 'REQUEST_NUM_PURCHASE_QUOTES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_NUM_PURCHASE_QUOTES_SUCCESS, 'FETCH_NUM_PURCHASE_QUOTES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_NUM_PURCHASE_QUOTES_FAILURE, 'FETCH_NUM_PURCHASE_QUOTES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_TODAYS_INCOMING_ORDERS, 'REQUEST_TODAYS_INCOMING_ORDERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_TODAYS_INCOMING_ORDERS_SUCCESS, 'FETCH_TODAYS_INCOMING_ORDERS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_TODAYS_INCOMING_ORDERS_FAILURE, 'FETCH_TODAYS_INCOMING_ORDERS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DELETE_PURCHASE_QUOTE, 'REQUEST_DELETE_PURCHASE_QUOTE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_PURCHASE_QUOTE_SUCCESS, 'DELETE_PURCHASE_QUOTE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_PURCHASE_QUOTE_FAILURE, 'DELETE_PURCHASE_QUOTE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_TEMPLATES, 'REQUEST_PURCHASE_TEMPLATES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_TEMPLATES_SUCCESS, 'FETCH_PURCHASE_TEMPLATES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_TEMPLATES_FAILURE, 'FETCH_PURCHASE_TEMPLATES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_PURCHASE_TEMPLATE, 'SELECT_PURCHASE_TEMPLATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_PURCHASE_TEMPLATE, 'RESET_CURRENT_PURCHASE_TEMPLATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_TEMPLATE_DETAIL, 'REQUEST_PURCHASE_TEMPLATE_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_TEMPLATE_DETAIL_SUCCESS, 'FETCH_PURCHASE_TEMPLATE_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_TEMPLATE_DETAIL_FAILURE, 'FETCH_PURCHASE_TEMPLATE_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_PURCHASE_TEMPLATE, 'REQUEST_CREATING_PURCHASE_TEMPLATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_PURCHASE_TEMPLATE_SUCCESS, 'CREATE_PURCHASE_TEMPLATE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_PURCHASE_TEMPLATE_FAILURE, 'CREATE_PURCHASE_TEMPLATE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_PURCHASE_TEMPLATE, 'REQUEST_EDITING_PURCHASE_TEMPLATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PURCHASE_TEMPLATE_SUCCESS, 'EDIT_PURCHASE_TEMPLATE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PURCHASE_TEMPLATE_FAILURE, 'EDIT_PURCHASE_TEMPLATE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_PURCHASE_PRODUCT, 'RESET_CURRENT_PURCHASE_PRODUCT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_PURCHASE_TEMPLATE, 'DELETE_PURCHASE_TEMPLATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_PURCHASE_TEMPLATE_SUCCESS, 'DELETE_PURCHASE_TEMPLATE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_PURCHASE_TEMPLATE_FAILURE, 'DELETE_PURCHASE_TEMPLATE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_TEMPLATE_LIST, 'REQUEST_PURCHASE_TEMPLATE_LIST', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_TEMPLATE_LIST_SUCCESS, 'FETCH_PURCHASE_TEMPLATE_LIST_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_TEMPLATE_LIST_FAILURE, 'FETCH_PURCHASE_TEMPLATE_LIST_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_SCHEDULES, 'REQUEST_PURCHASE_SCHEDULES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_SCHEDULES_SUCCESS, 'FETCH_PURCHASE_SCHEDULES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_SCHEDULES_FAILURE, 'FETCH_PURCHASE_SCHEDULES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_PURCHASE_SCHEDULE, 'SELECT_PURCHASE_SCHEDULE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_PURCHASE_SCHEDULE, 'RESET_CURRENT_PURCHASE_SCHEDULE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_SCHEDULE_DETAIL, 'REQUEST_PURCHASE_SCHEDULE_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_SCHEDULE_DETAIL_SUCCESS, 'FETCH_PURCHASE_SCHEDULE_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_SCHEDULE_DETAIL_FAILURE, 'FETCH_PURCHASE_SCHEDULE_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_PURCHASE_SCHEDULE, 'REQUEST_CREATING_PURCHASE_SCHEDULE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_PURCHASE_SCHEDULE_SUCCESS, 'CREATE_PURCHASE_SCHEDULE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_PURCHASE_SCHEDULE_FAILURE, 'CREATE_PURCHASE_SCHEDULE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_PURCHASE_SCHEDULE, 'REQUEST_EDITING_PURCHASE_SCHEDULE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PURCHASE_SCHEDULE_SUCCESS, 'EDIT_PURCHASE_SCHEDULE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PURCHASE_SCHEDULE_FAILURE, 'EDIT_PURCHASE_SCHEDULE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_RETURNS, 'REQUEST_PURCHASE_RETURNS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_RETURNS_SUCCESS, 'FETCH_PURCHASE_RETURNS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_RETURNS_FAILURE, 'FETCH_PURCHASE_RETURNS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_PURCHASE_RETURN, 'SELECT_PURCHASE_RETURN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_PURCHASE_RETURN, 'RESET_CURRENT_PURCHASE_RETURN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_RETURN_DETAIL, 'REQUEST_PURCHASE_RETURN_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_RETURN_DETAIL_SUCCESS, 'FETCH_PURCHASE_RETURN_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_RETURN_DETAIL_FAILURE, 'FETCH_PURCHASE_RETURN_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_PURCHASE_RETURN, 'REQUEST_CREATING_PURCHASE_RETURN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_PURCHASE_RETURN_SUCCESS, 'CREATE_PURCHASE_RETURN_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_PURCHASE_RETURN_FAILURE, 'CREATE_PURCHASE_RETURN_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_PURCHASE_RETURN, 'REQUEST_EDITING_PURCHASE_RETURN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PURCHASE_RETURN_SUCCESS, 'EDIT_PURCHASE_RETURN_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PURCHASE_RETURN_FAILURE, 'EDIT_PURCHASE_RETURN_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(COMPLETE_PURCHASE_RETURN, 'COMPLETE_PURCHASE_RETURN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(COMPLETE_PURCHASE_RETURN_SUCCESS, 'COMPLETE_PURCHASE_RETURN_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(COMPLETE_PURCHASE_RETURN_FAILURE, 'COMPLETE_PURCHASE_RETURN_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_RETURN_PDF, 'REQUEST_PURCHASE_RETURN_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_RETURN_PDF_SUCCESS, 'FETCH_PURCHASE_RETURN_PDF_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL, 'REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL_SUCCESS, 'REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_VOID_PURCHASE_RETURN, 'REQUEST_VOID_PURCHASE_RETURN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(VOID_PURCHASE_RETURN_SUCCESS, 'VOID_PURCHASE_RETURN_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(VOID_PURCHASE_RETURN_FAILURE, 'VOID_PURCHASE_RETURN_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_ORDERS, 'REQUEST_PURCHASE_ORDERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_ORDERS_SUCCESS, 'FETCH_PURCHASE_ORDERS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_ORDERS_FAILURE, 'FETCH_PURCHASE_ORDERS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_ORDERS_BY_FILTER, 'REQUEST_PURCHASE_ORDERS_BY_FILTER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_PURCHASE_ORDER, 'SELECT_PURCHASE_ORDER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_PURCHASE_ORDER, 'RESET_CURRENT_PURCHASE_ORDER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_ORDER_DETAIL, 'REQUEST_PURCHASE_ORDER_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_ORDER_DETAIL_SUCCESS, 'FETCH_PURCHASE_ORDER_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_ORDER_DETAIL_FAILURE, 'FETCH_PURCHASE_ORDER_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_PURCHASE_ORDER, 'REQUEST_CREATING_PURCHASE_ORDER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_PURCHASE_ORDER_SUCCESS, 'CREATE_PURCHASE_ORDER_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_PURCHASE_ORDER_FAILURE, 'CREATE_PURCHASE_ORDER_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_PURCHASE_ORDER, 'REQUEST_EDITING_PURCHASE_ORDER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PURCHASE_ORDER_SUCCESS, 'EDIT_PURCHASE_ORDER_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PURCHASE_ORDER_FAILURE, 'EDIT_PURCHASE_ORDER_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_ORDERS_NOT_RECEIVED, 'REQUEST_PURCHASE_ORDERS_NOT_RECEIVED', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_ORDERS_NOT_RECEIVED_SUCCESS, 'FETCH_PURCHASE_ORDERS_NOT_RECEIVED_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_ORDERS_NOT_RECEIVED_FAILURE, 'FETCH_PURCHASE_ORDERS_NOT_RECEIVED_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_TOTAL_PURCHASES, 'REQUEST_TOTAL_PURCHASES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_TOTAL_PURCHASES_SUCCESS, 'FETCH_TOTAL_PURCHASES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_TOTAL_PURCHASES_FAILURE, 'FETCH_TOTAL_PURCHASES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PRINT_PURCHASE_ORDER, 'REQUEST_PRINT_PURCHASE_ORDER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(PRINT_PURCHASE_ORDER_SUCCESS, 'PRINT_PURCHASE_ORDER_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(PRINT_PURCHASE_ORDER_FAILURE, 'PRINT_PURCHASE_ORDER_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DELETE_PURCHASE_ORDER, 'REQUEST_DELETE_PURCHASE_ORDER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_PURCHASE_ORDER_SUCCESS, 'DELETE_PURCHASE_ORDER_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_PURCHASE_ORDER_FAILURE, 'DELETE_PURCHASE_ORDER_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_ORDER_PERFORMANCE, 'REQUEST_PURCHASE_ORDER_PERFORMANCE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_ORDER_PERFORMANCE_SUCCESS, 'FETCH_PURCHASE_ORDER_PERFORMANCE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_ORDER_PERFORMANCE_FAILURE, 'FETCH_PURCHASE_ORDER_PERFORMANCE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_MANAGER_INFO, 'REQUEST_PURCHASE_MANAGER_INFO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_MANAGER_INFO_SUCCESS, 'FETCH_PURCHASE_MANAGER_INFO_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_MANAGER_INFO_FAILURE, 'FETCH_PURCHASE_MANAGER_INFO_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_LAST_MONTH_PERFORMANCE, 'REQUEST_LAST_MONTH_PERFORMANCE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_LAST_MONTH_PERFORMANCE_SUCCESS, 'FETCH_LAST_MONTH_PERFORMANCE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_LAST_MONTH_PERFORMANCE_FAILURE, 'FETCH_LAST_MONTH_PERFORMANCE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASERS_PERFORMANCE, 'REQUEST_PURCHASERS_PERFORMANCE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASERS_PERFORMANCE_SUCCESS, 'FETCH_PURCHASERS_PERFORMANCE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASERS_PERFORMANCE_FAILURE, 'FETCH_PURCHASERS_PERFORMANCE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PRESIDENT_DASH_INFO, 'REQUEST_PRESIDENT_DASH_INFO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRESIDENT_DASH_INFO_SUCCESS, 'FETCH_PRESIDENT_DASH_INFO_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRESIDENT_DASH_INFO_FAILURE, 'FETCH_PRESIDENT_DASH_INFO_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_OVERALL_PURCHASE_PERFORMANCE, 'REQUEST_OVERALL_PURCHASE_PERFORMANCE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_OVERALL_PURCHASE_PERFORMANCE_SUCCESS, 'FETCH_OVERALL_PURCHASE_PERFORMANCE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_OVERALL_PURCHASE_PERFORMANCE_FAILURE, 'FETCH_OVERALL_PURCHASE_PERFORMANCE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INCIDENT_REPORT, 'REQUEST_INCIDENT_REPORT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INCIDENT_REPORT_SUCCESS, 'FETCH_INCIDENT_REPORT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INCIDENT_REPORT_FAILURE, 'FETCH_INCIDENT_REPORT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_ORDER_LIST, 'REQUEST_PURCHASE_ORDER_LIST', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_ORDER_LIST_SUCCESS, 'FETCH_PURCHASE_ORDER_LIST_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_ORDER_LIST_FAILURE, 'FETCH_PURCHASE_ORDER_LIST_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SET_PURCHASE_ORDERS_FILTER, 'SET_PURCHASE_ORDERS_FILTER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASING_PERFORMANCE, 'REQUEST_PURCHASING_PERFORMANCE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASING_PERFORMANCE_BY_FILTER, 'REQUEST_PURCHASING_PERFORMANCE_BY_FILTER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASING_PERFORMANCE_SUCCESS, 'FETCH_PURCHASING_PERFORMANCE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASING_PERFORMANCE_FAILURE, 'FETCH_PURCHASING_PERFORMANCE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PRICE_ADJUSTMENT, 'REQUEST_PRICE_ADJUSTMENT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRICE_ADJUSTMENT_SUCCESS, 'FETCH_PRICE_ADJUSTMENT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRICE_ADJUSTMENT_FAILURE, 'FETCH_PRICE_ADJUSTMENT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_PRICE_ADJUSTMENT, 'CREATE_PRICE_ADJUSTMENT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_PRICE_ADJUSTMENT_SUCCESS, 'CREATE_PRICE_ADJUSTMENT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_PRICE_ADJUSTMENT_FAILURE, 'CREATE_PRICE_ADJUSTMENT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_PIVOT_CHART_ORDERS, 'REQUEST_PURCHASE_PIVOT_CHART_ORDERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_PIVOT_CHART_ORDERS_SUCCESS, 'FETCH_PURCHASE_PIVOT_CHART_ORDERS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_PIVOT_CHART_ORDERS_FAILURE, 'FETCH_PURCHASE_PIVOT_CHART_ORDERS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_PIVOT_CHARTS, 'REQUEST_PURCHASE_PIVOT_CHARTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_PIVOT_CHARTS_SUCCESS, 'FETCH_PURCHASE_PIVOT_CHARTS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_PIVOT_CHARTS_FAILURE, 'FETCH_PURCHASE_PIVOT_CHARTS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_PIVOT_CHARTS_DETAIL, 'REQUEST_PURCHASE_PIVOT_CHARTS_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_SUCCESS, 'FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_FAILURE, 'FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SET_PURCHASE_PIVOT_ID, 'SET_PURCHASE_PIVOT_ID', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_PURCHASE_PIVOT_CHARTS, 'RESET_PURCHASE_PIVOT_CHARTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_PURCHASE_PIVOT_CHART, 'CREATE_PURCHASE_PIVOT_CHART', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_PURCHASE_PIVOT_CHART_SUCCESS, 'CREATE_PURCHASE_PIVOT_CHART_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_PURCHASE_PIVOT_CHART_FAILURE, 'CREATE_PURCHASE_PIVOT_CHART_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DUPLICATE_PURCHASE_PIVOT_CHART, 'DUPLICATE_PURCHASE_PIVOT_CHART', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DUPLICATE_PURCHASE_PIVOT_CHART_SUCCESS, 'DUPLICATE_PURCHASE_PIVOT_CHART_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DUPLICATE_PURCHASE_PIVOT_CHART_FAILURE, 'DUPLICATE_PURCHASE_PIVOT_CHART_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_DUPLICATED_PURCHASE_PIVOT_CHART, 'CLEAR_DUPLICATED_PURCHASE_PIVOT_CHART', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_REFERENCE_PDF, 'REQUEST_PURCHASE_REFERENCE_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_REFERENCE_PDF_SUCCESS, 'FETCH_PURCHASE_REFERENCE_PDF_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASING_REFERENCE, 'REQUEST_PURCHASING_REFERENCE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASING_REFERENCE_SUCCESS, 'FETCH_PURCHASING_REFERENCE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASING_REFERENCE_FAILURE, 'FETCH_PURCHASING_REFERENCE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_PAYMENT_NOT_PAID, 'REQUEST_PURCHASE_PAYMENT_NOT_PAID', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_PAYMENT_NOT_PAID_SUCCESS, 'FETCH_PURCHASE_PAYMENT_NOT_PAID_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_PAYMENT_NOT_PAID_FAILURE, 'FETCH_PURCHASE_PAYMENT_NOT_PAID_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASING_PERFORMANCE_BY_PRODUCT, 'REQUEST_PURCHASING_PERFORMANCE_BY_PRODUCT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_SUCCESS, 'FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_FAILURE, 'FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASE_PRODUCT_BY_ID, 'REQUEST_PURCHASE_PRODUCT_BY_ID', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_PRODUCT_BY_ID_SUCCESS, 'FETCH_PURCHASE_PRODUCT_BY_ID_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_PRODUCT_BY_ID_FAILURE, 'FETCH_PURCHASE_PRODUCT_BY_ID_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORIES_DETAILS_SUCCESS, 'FETCH_INVENTORIES_DETAILS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_FILTER_WITH_NEW_ID, 'RESET_FILTER_WITH_NEW_ID', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORIES_PRODUCT_RECEIVE_SUCCESS, 'FETCH_INVENTORIES_PRODUCT_RECEIVE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_RECEIVE_FILTER_WITH_NEW_ID, 'RESET_RECEIVE_FILTER_WITH_NEW_ID', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVENTORIES, 'REQUEST_INVENTORIES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORIES_SUCCESS, 'FETCH_INVENTORIES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORIES_FAILURE, 'FETCH_INVENTORIES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DETAILED_INVENTORIES, 'REQUEST_DETAILED_INVENTORIES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_DETAILED_INVENTORIES_SUCCESS, 'FETCH_DETAILED_INVENTORIES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_DETAILED_INVENTORIES_FAILURE, 'FETCH_DETAILED_INVENTORIES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_LOW_STOCK_INVENTORIES, 'REQUEST_LOW_STOCK_INVENTORIES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_LOW_STOCK_INVENTORIES_SUCCESS, 'FETCH_LOW_STOCK_INVENTORIES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_LOW_STOCK_INVENTORIES_FAILURE, 'FETCH_LOW_STOCK_INVENTORIES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EXPIRED_INVENTORIES, 'REQUEST_EXPIRED_INVENTORIES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_EXPIRED_INVENTORIES_SUCCESS, 'FETCH_EXPIRED_INVENTORIES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_EXPIRED_INVENTORIES_FAILURE, 'FETCH_EXPIRED_INVENTORIES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVENTORIES_BY_GROUP, 'REQUEST_INVENTORIES_BY_GROUP', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVENTORIES_BY_GROUP_SUCCESS, 'REQUEST_INVENTORIES_BY_GROUP_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVENTORIES_BY_GROUP_FAILURE, 'REQUEST_INVENTORIES_BY_GROUP_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVENTORIES_BY_CATEGORY, 'REQUEST_INVENTORIES_BY_CATEGORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVENTORIES_BY_CATEGORY_SUCCESS, 'REQUEST_INVENTORIES_BY_CATEGORY_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVENTORIES_BY_CATEGORY_FAILURE, 'REQUEST_INVENTORIES_BY_CATEGORY_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVENTORIES_BY_PERIOD, 'REQUEST_INVENTORIES_BY_PERIOD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORIES_BY_PERIOD_SUCCESS, 'FETCH_INVENTORIES_BY_PERIOD_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORIES_BY_PERIOD_FAILURE, 'FETCH_INVENTORIES_BY_PERIOD_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_LOW_INVENTORIES, 'REQUEST_LOW_INVENTORIES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_LOW_INVENTORIES_SUCCESS, 'FETCH_LOW_INVENTORIES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_LOW_INVENTORIES_FAILURE, 'FETCH_LOW_INVENTORIES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_WORKING_ORDERS, 'REQUEST_WORKING_ORDERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_WORKING_ORDERS_SUCCESS, 'FETCH_WORKING_ORDERS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_WORKING_ORDERS_FAILURE, 'FETCH_WORKING_ORDERS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CHECK_PASSWORD, 'CHECK_PASSWORD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CHECK_PASSWORD_SUCCESS, 'CHECK_PASSWORD_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CHECK_PASSWORD_FAILURE, 'CHECK_PASSWORD_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_CHECK_PASSWORD, 'CLEAR_CHECK_PASSWORD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CHECK_PERMISSIOIN, 'CHECK_PERMISSIOIN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CHECK_PERMISSIOIN_SUCCESS, 'CHECK_PERMISSIOIN_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CHECK_PERMISSIOIN_FAILURE, 'CHECK_PERMISSIOIN_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SET_ORIGIN_PAGE, 'SET_ORIGIN_PAGE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_INVENTORY, 'SELECT_INVENTORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_INVENTORY, 'RESET_CURRENT_INVENTORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVENTORY_DETAIL, 'REQUEST_INVENTORY_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_DETAIL_SUCCESS, 'FETCH_INVENTORY_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_DETAIL_FAILURE, 'FETCH_INVENTORY_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_SCRAP, 'FETCH_INVENTORY_SCRAP', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_SCRAP_SUCCESS, 'FETCH_INVENTORY_SCRAP_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_SCRAP_FAILURE, 'FETCH_INVENTORY_SCRAP_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_SCRAP_RECORD, 'REQUEST_CREATING_SCRAP_RECORD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_SCRAP_RECORD_SUCCESS, 'CREATE_SCRAP_RECORD_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_SCRAP_RECORD_FAILURE, 'CREATE_SCRAP_RECORD_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_SCRAP_RECORD, 'REQUEST_EDITING_SCRAP_RECORD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_SCRAP_RECORD_SUCCESS, 'EDIT_SCRAP_RECORD_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_SCRAP_RECORD_FAILURE, 'EDIT_SCRAP_RECORD_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PUT_AWAY, 'REQUEST_PUT_AWAY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PUT_AWAY_SUCCESS, 'FETCH_PUT_AWAY_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PUT_AWAY_FAILURE, 'FETCH_PUT_AWAY_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_PUT_AWAY, 'RESET_CURRENT_PUT_AWAY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_PUT_AWAY, 'REQUEST_CREATING_PUT_AWAY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_PUT_AWAY_SUCCESS, 'CREATE_PUT_AWAY_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_PUT_AWAY_FAILURE, 'CREATE_PUT_AWAY_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_PUT_AWAY, 'SELECT_PUT_AWAY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PUT_AWAY_DETAIL, 'REQUEST_PUT_AWAY_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PUT_AWAY_DETAIL_SUCCESS, 'FETCH_PUT_AWAY_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PUT_AWAY_DETAIL_FAILURE, 'FETCH_PUT_AWAY_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_PUT_AWAY, 'REQUEST_EDITING_PUT_AWAY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PUT_AWAY_SUCCESS, 'EDIT_PUT_AWAY_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PUT_AWAY_FAILURE, 'EDIT_PUT_AWAY_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(AUTO_PUTAWAY, 'AUTO_PUTAWAY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(AUTO_PUTAWAY_SUCCESS, 'AUTO_PUTAWAY_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(AUTO_PUTAWAY_FAILURE, 'AUTO_PUTAWAY_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BIN_LIST_DETAIL, 'REQUEST_BIN_LIST_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_BIN_LIST_DETAIL_SUCCESS, 'FETCH_BIN_LIST_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_BIN_LIST_DETAIL_FAILURE, 'FETCH_BIN_LIST_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_BINS, 'REQUEST_CREATING_BINS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_BINS_SUCCESS, 'CREATE_BINS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_BINS_FAILURE, 'CREATE_BINS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_WAREHOUSE_RECEIVE, 'SELECT_WAREHOUSE_RECEIVE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_WAREHOUSE_RECEIVE, 'RESET_CURRENT_WAREHOUSE_RECEIVE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_NONZERO_INVENTORIES, 'REQUEST_NONZERO_INVENTORIES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_NONZERO_INVENTORIES_SUCCESS, 'FETCH_NONZERO_INVENTORIES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_NONZERO_INVENTORIES_FAILURE, 'FETCH_NONZERO_INVENTORIES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_HISTORY, 'FETCH_INVENTORY_HISTORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_HISTORY_SUCCESS, 'FETCH_INVENTORY_HISTORY_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_HISTORY_FAILURE, 'FETCH_INVENTORY_HISTORY_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_ADJUSTMENT_BATCH_LOG, 'FETCH_INVENTORY_ADJUSTMENT_BATCH_LOG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(UPDATE_INVENTORY_FILTER, 'UPDATE_INVENTORY_FILTER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(UPDATE_RECEIVE_TABLE_FILTER, 'UPDATE_RECEIVE_TABLE_FILTER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_FAVORITES, 'REQUEST_FAVORITES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_FAVORITES_SUCCESS, 'FETCH_FAVORITES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_FAVORITES_FAILURE, 'FETCH_FAVORITES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_FAVORITES, 'SELECT_FAVORITES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_FAVORITES, 'RESET_CURRENT_FAVORITES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_FAVORITES_DETAIL, 'REQUEST_FAVORITES_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_FAVORITES_DETAIL_SUCCESS, 'FETCH_FAVORITES_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_FAVORITES_DETAIL_FAILURE, 'FETCH_FAVORITES_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_ADDING_FAVORITE, 'REQUEST_ADDING_FAVORITE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ADD_FAVORITE_SUCCESS, 'ADD_FAVORITE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ADD_FAVORITE_FAILURE, 'ADD_FAVORITE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DELETE_FAVORITE, 'REQUEST_DELETE_FAVORITE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_FAVORITE_SUCCESS, 'DELETE_FAVORITE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_FAVORITE_FAILURE, 'DELETE_FAVORITE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ITEM_IN_LIST, 'ITEM_IN_LIST', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_IN_LIST_ERROR, 'CLEAR_IN_LIST_ERROR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_FAVORITE_LIST, 'REQUEST_FAVORITE_LIST', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_FAVORITE_LIST_SUCCESS, 'FETCH_FAVORITE_LIST_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_FAVORITE_LIST_FAILURE, 'FETCH_FAVORITE_LIST_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SAVE_FAVORITE_LIST, 'REQUEST_SAVE_FAVORITE_LIST', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_FAVORITE_LIST_SUCCESS, 'SAVE_FAVORITE_LIST_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_FAVORITE_LIST_FAILURE, 'SAVE_FAVORITE_LIST_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PROMOTIONS, 'REQUEST_PROMOTIONS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PROMOTIONS_SUCCESS, 'FETCH_PROMOTIONS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PROMOTIONS_FAILURE, 'FETCH_PROMOTIONS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_PROMOTIONS, 'SELECT_PROMOTIONS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_PROMOTIONS, 'RESET_CURRENT_PROMOTIONS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PROMOTIONS_DETAIL, 'REQUEST_PROMOTIONS_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PROMOTIONS_DETAIL_SUCCESS, 'FETCH_PROMOTIONS_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PROMOTIONS_DETAIL_FAILURE, 'FETCH_PROMOTIONS_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_ADDING_PROMOTION, 'REQUEST_ADDING_PROMOTION', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ADD_PROMOTION_SUCCESS, 'ADD_PROMOTION_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ADD_PROMOTION_FAILURE, 'ADD_PROMOTION_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DELETE_PROMOTION, 'REQUEST_DELETE_PROMOTION', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_PROMOTION_SUCCESS, 'DELETE_PROMOTION_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_PROMOTION_FAILURE, 'DELETE_PROMOTION_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_PROMOTION, 'REQUEST_EDITING_PROMOTION', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PROMOTION_SUCCESS, 'EDIT_PROMOTION_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PROMOTION_FAILURE, 'EDIT_PROMOTION_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SAVE_PROMOTION, 'REQUEST_SAVE_PROMOTION', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_PROMOTION_SUCCESS, 'SAVE_PROMOTION_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_PROMOTION_FAILURE, 'SAVE_PROMOTION_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SAVE_PROMO_NOTES, 'REQUEST_SAVE_PROMO_NOTES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_PROMO_NOTES_SUCCESS, 'SAVE_PROMO_NOTES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_PROMO_NOTES_FAILURE, 'SAVE_PROMO_NOTES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PROMO_NOTES, 'REQUEST_PROMO_NOTES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PROMO_NOTES_SUCCESS, 'FETCH_PROMO_NOTES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PROMO_NOTES_FAILURE, 'FETCH_PROMO_NOTES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_PROMO_NOTES_STATUS, 'CLEAR_PROMO_NOTES_STATUS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SET_CURRENT_PROMO, 'SET_CURRENT_PROMO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_PROMO, 'RESET_CURRENT_PROMO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PROMO_DETAILS, 'REQUEST_PROMO_DETAILS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PROMO_DETAILS_SUCCESS, 'FETCH_PROMO_DETAILS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PROMO_DETAILS_FAILURE, 'FETCH_PROMO_DETAILS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_PROMO_DETAIL_STATUS, 'CLEAR_PROMO_DETAIL_STATUS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PREVIOUSSOS, 'REQUEST_PREVIOUSSOS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PREVIOUSSOS_SUCCESS, 'FETCH_PREVIOUSSOS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PREVIOUSSOS_FAILURE, 'FETCH_PREVIOUSSOS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PREVIOUSSO_DETAIL, 'REQUEST_PREVIOUSSO_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PREVIOUSSO_DETAIL_SUCCESS, 'FETCH_PREVIOUSSO_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PREVIOUSSO_DETAIL_FAILURE, 'FETCH_PREVIOUSSO_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PREVIOUSORDERS, 'REQUEST_PREVIOUSORDERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PREVIOUSORDERS_SUCCESS, 'FETCH_PREVIOUSORDERS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PREVIOUSORDERS_FAILURE, 'FETCH_PREVIOUSORDERS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_PREVIOUSORDERS, 'SELECT_PREVIOUSORDERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_PREVIOUSORDERS, 'RESET_CURRENT_PREVIOUSORDERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PREVIOUSORDERS_DETAIL, 'REQUEST_PREVIOUSORDERS_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PREVIOUSORDERS_DETAIL_SUCCESS, 'FETCH_PREVIOUSORDERS_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PREVIOUSORDERS_DETAIL_FAILURE, 'FETCH_PREVIOUSORDERS_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_ADDING_PREVIOUSORDER, 'REQUEST_ADDING_PREVIOUSORDER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ADD_PREVIOUSORDER_SUCCESS, 'ADD_PREVIOUSORDER_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ADD_PREVIOUSORDER_FAILURE, 'ADD_PREVIOUSORDER_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DELETE_PREVIOUSORDER, 'REQUEST_DELETE_PREVIOUSORDER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_PREVIOUSORDER_SUCCESS, 'DELETE_PREVIOUSORDER_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_PREVIOUSORDER_FAILURE, 'DELETE_PREVIOUSORDER_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVENTORY_RELOCATIONS, 'REQUEST_INVENTORY_RELOCATIONS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_RELOCATIONS_SUCCESS, 'FETCH_INVENTORY_RELOCATIONS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_RELOCATIONS_FAILURE, 'FETCH_INVENTORY_RELOCATIONS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_INVENTORY_RELOCATION, 'SELECT_INVENTORY_RELOCATION', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_INVENTORY_RELOCATION, 'RESET_CURRENT_INVENTORY_RELOCATION', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVENTORY_RELOCATION_DETAIL, 'REQUEST_INVENTORY_RELOCATION_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_RELOCATION_DETAIL_SUCCESS, 'FETCH_INVENTORY_RELOCATION_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_RELOCATION_DETAIL_FAILURE, 'FETCH_INVENTORY_RELOCATION_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_INVENTORY_RELOCATION, 'REQUEST_CREATING_INVENTORY_RELOCATION', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_INVENTORY_RELOCATION_SUCCESS, 'CREATE_INVENTORY_RELOCATION_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_INVENTORY_RELOCATION_FAILURE, 'CREATE_INVENTORY_RELOCATION_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_INVENTORY_RELOCATION, 'REQUEST_EDITING_INVENTORY_RELOCATION', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_INVENTORY_RELOCATION_SUCCESS, 'EDIT_INVENTORY_RELOCATION_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_INVENTORY_RELOCATION_FAILURE, 'EDIT_INVENTORY_RELOCATION_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVENTORY_ADJUSTMENTS, 'REQUEST_INVENTORY_ADJUSTMENTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVENTORY_ADJUSTMENTS_DETAIL, 'REQUEST_INVENTORY_ADJUSTMENTS_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_ADJUSTMENTS_DETAIL_SUCCESS, 'FETCH_INVENTORY_ADJUSTMENTS_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_ADJUSTMENTS_DETAIL_FAILURE, 'FETCH_INVENTORY_ADJUSTMENTS_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_ADJUSTMENTS_SUCCESS, 'FETCH_INVENTORY_ADJUSTMENTS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_ADJUSTMENTS_FAILURE, 'FETCH_INVENTORY_ADJUSTMENTS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_INVENTORY_ADJUSTMENT, 'SELECT_INVENTORY_ADJUSTMENT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_INVENTORY_ADJUSTMENT, 'RESET_CURRENT_INVENTORY_ADJUSTMENT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVENTORY_ADJUSTMENT_DETAIL, 'REQUEST_INVENTORY_ADJUSTMENT_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_ADJUSTMENT_DETAIL_SUCCESS, 'FETCH_INVENTORY_ADJUSTMENT_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_ADJUSTMENT_DETAIL_FAILURE, 'FETCH_INVENTORY_ADJUSTMENT_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_NEW_CONVERT, 'REQUEST_NEW_CONVERT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(NEW_CONVERT_SUCCESS, 'NEW_CONVERT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(NEW_CONVERT_FAILURE, 'NEW_CONVERT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_INVENTORY_ADJUSTMENTS, 'REQUEST_CREATING_INVENTORY_ADJUSTMENTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_INVENTORY_ADJUSTMENTS_SUCCESS, 'CREATE_INVENTORY_ADJUSTMENTS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_INVENTORY_ADJUSTMENTS_FAILURE, 'CREATE_INVENTORY_ADJUSTMENTS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_INVENTORY_ADJUSTMENTS, 'REQUEST_EDITING_INVENTORY_ADJUSTMENTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_INVENTORY_ADJUSTMENTS_SUCCESS, 'EDIT_INVENTORY_ADJUSTMENTS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_INVENTORY_ADJUSTMENTS_FAILURE, 'EDIT_INVENTORY_ADJUSTMENTS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_QUICK_INVENTORY_ADJUSTMENTS, 'REQUEST_QUICK_INVENTORY_ADJUSTMENTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(QUICK_INVENTORY_ADJUSTMENTS_SUCCESS, 'QUICK_INVENTORY_ADJUSTMENTS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(QUICK_INVENTORY_ADJUSTMENTS_FAILURE, 'QUICK_INVENTORY_ADJUSTMENTS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_QUICK_INVENTORY_ADJUSTMENTS, 'RESET_QUICK_INVENTORY_ADJUSTMENTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVENTORY_REPACKAGES, 'REQUEST_INVENTORY_REPACKAGES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_REPACKAGES_SUCCESS, 'FETCH_INVENTORY_REPACKAGES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_REPACKAGES_FAILURE, 'FETCH_INVENTORY_REPACKAGES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_INVENTORY_REPACKAGE, 'SELECT_INVENTORY_REPACKAGE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_INVENTORY_REPACKAGE, 'RESET_CURRENT_INVENTORY_REPACKAGE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVENTORY_REPACKAGE_DETAIL, 'REQUEST_INVENTORY_REPACKAGE_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_REPACKAGE_DETAIL_SUCCESS, 'FETCH_INVENTORY_REPACKAGE_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_REPACKAGE_DETAIL_FAILURE, 'FETCH_INVENTORY_REPACKAGE_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_INVENTORY_REPACKAGE, 'REQUEST_CREATING_INVENTORY_REPACKAGE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_INVENTORY_REPACKAGE_SUCCESS, 'CREATE_INVENTORY_REPACKAGE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_INVENTORY_REPACKAGE_FAILURE, 'CREATE_INVENTORY_REPACKAGE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_INVENTORY_REPACKAGE, 'REQUEST_EDITING_INVENTORY_REPACKAGE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_INVENTORY_REPACKAGE_SUCCESS, 'EDIT_INVENTORY_REPACKAGE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_INVENTORY_REPACKAGE_FAILURE, 'EDIT_INVENTORY_REPACKAGE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVENTORY_CONVERTS, 'REQUEST_INVENTORY_CONVERTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_CONVERTS_SUCCESS, 'FETCH_INVENTORY_CONVERTS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_CONVERTS_FAILURE, 'FETCH_INVENTORY_CONVERTS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_INVENTORY_CONVERT, 'SELECT_INVENTORY_CONVERT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_INVENTORY_CONVERT, 'RESET_CURRENT_INVENTORY_CONVERT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVENTORY_CONVERT_DETAIL, 'REQUEST_INVENTORY_CONVERT_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_CONVERT_DETAIL_SUCCESS, 'FETCH_INVENTORY_CONVERT_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_CONVERT_DETAIL_FAILURE, 'FETCH_INVENTORY_CONVERT_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVENTORIES_BIN, 'REQUEST_INVENTORIES_BIN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORIES_BIN_SUCCESS, 'FETCH_INVENTORIES_BIN_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORIES_BIN_FAILURE, 'FETCH_INVENTORIES_BIN_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_INVENTORY_CONVERT, 'REQUEST_CREATING_INVENTORY_CONVERT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_INVENTORY_CONVERT_SUCCESS, 'CREATE_INVENTORY_CONVERT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_INVENTORY_CONVERT_FAILURE, 'CREATE_INVENTORY_CONVERT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_INVENTORY_CONVERT, 'REQUEST_EDITING_INVENTORY_CONVERT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_INVENTORY_CONVERT_SUCCESS, 'EDIT_INVENTORY_CONVERT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_INVENTORY_CONVERT_FAILURE, 'EDIT_INVENTORY_CONVERT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SCRAP_RECORDS, 'REQUEST_SCRAP_RECORDS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SCRAP_RECORDS_SUCCESS, 'FETCH_SCRAP_RECORDS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SCRAP_RECORDS_FAILURE, 'FETCH_SCRAP_RECORDS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_SCRAP_RECORD, 'SELECT_SCRAP_RECORD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_SCRAP_RECORD, 'RESET_CURRENT_SCRAP_RECORD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SCRAP_RECORD_DETAIL, 'REQUEST_SCRAP_RECORD_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SCRAP_RECORD_DETAIL_SUCCESS, 'FETCH_SCRAP_RECORD_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SCRAP_RECORD_DETAIL_FAILURE, 'FETCH_SCRAP_RECORD_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_RECEIVES, 'REQUEST_RECEIVES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RECEIVES_SUCCESS, 'FETCH_RECEIVES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RECEIVES_FAILURE, 'FETCH_RECEIVES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_RECEIVE, 'SELECT_RECEIVE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_RECEIVE, 'RESET_CURRENT_RECEIVE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_RECEIVE, 'REQUEST_CREATING_RECEIVE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_RECEIVE_SUCCESS, 'CREATE_RECEIVE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_RECEIVE_FAILURE, 'CREATE_RECEIVE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CREATE_RECEIVE, 'RESET_CREATE_RECEIVE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_RECEIVE, 'REQUEST_EDITING_RECEIVE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_RECEIVE_SUCCESS, 'EDIT_RECEIVE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_RECEIVE_FAILURE, 'EDIT_RECEIVE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_RECEIVE_DETAIL, 'REQUEST_RECEIVE_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RECEIVE_DETAIL_SUCCESS, 'FETCH_RECEIVE_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RECEIVE_DETAIL_FAILURE, 'FETCH_RECEIVE_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RECEIVE_HISTORY, 'FETCH_RECEIVE_HISTORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RECEIVE_HISTORY_SUCCESS, 'FETCH_RECEIVE_HISTORY_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RECEIVE_HISTORY_FAILURE, 'FETCH_RECEIVE_HISTORY_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_RECEIVE_HISTORY, 'SELECT_RECEIVE_HISTORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_RECEIVE_HISTORY, 'RESET_CURRENT_RECEIVE_HISTORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RECEIVE_HISTORY_DETAIL, 'FETCH_RECEIVE_HISTORY_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RECEIVE_HISTORY_DETAIL_SUCCESS, 'FETCH_RECEIVE_HISTORY_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RECEIVE_HISTORY_DETAIL_FAILURE, 'FETCH_RECEIVE_HISTORY_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_ALL_RECEIVE_HISTORY_DETAIL, 'FETCH_ALL_RECEIVE_HISTORY_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_ALL_RECEIVE_HISTORY_DETAIL_SUCCESS, 'FETCH_ALL_RECEIVE_HISTORY_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_ALL_RECEIVE_HISTORY_DETAIL_FAILURE, 'FETCH_ALL_RECEIVE_HISTORY_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RECEIVE_HISTORY_DETAIL_RECORD, 'FETCH_RECEIVE_HISTORY_DETAIL_RECORD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RECEIVE_HISTORY_DETAIL_RECORD_SUCCESS, 'FETCH_RECEIVE_HISTORY_DETAIL_RECORD_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RECEIVE_HISTORY_DETAIL_RECORD_FAILURE, 'FETCH_RECEIVE_HISTORY_DETAIL_RECORD_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_RECEIVE_HISTORY, 'REQUEST_EDITING_RECEIVE_HISTORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_RECEIVE_HISTORY_SUCCESS, 'EDIT_RECEIVE_HISTORY_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_RECEIVE_HISTORY_FAILURE, 'EDIT_RECEIVE_HISTORY_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_EDIT_RECEIVE_HISTORY, 'RESET_EDIT_RECEIVE_HISTORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_RECEIVE, 'DELETE_RECEIVE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_RECEIVE_FINISHED, 'DELETE_RECEIVE_FINISHED', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_DELETE_STATUS, 'RESET_DELETE_STATUS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SALES_ORDER_FORM_BATCHES, 'SALES_ORDER_FORM_BATCHES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_WAREHOUSES, 'REQUEST_WAREHOUSES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_WAREHOUSES_SUCCESS, 'FETCH_WAREHOUSES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_WAREHOUSES_FAILURE, 'FETCH_WAREHOUSES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_WAREHOUSES, 'RESET_WAREHOUSES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_WAREHOUSE, 'SELECT_WAREHOUSE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_WAREHOUSE, 'RESET_CURRENT_WAREHOUSE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_WAREHOUSE_DETAIL, 'REQUEST_WAREHOUSE_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_WAREHOUSE_DETAIL_SUCCESS, 'FETCH_WAREHOUSE_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_WAREHOUSE_DETAIL_FAILURE, 'FETCH_WAREHOUSE_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_WAREHOUSE, 'REQUEST_CREATING_WAREHOUSE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_WAREHOUSE_SUCCESS, 'CREATE_WAREHOUSE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_WAREHOUSE_FAILURE, 'CREATE_WAREHOUSE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_WAREHOUSE, 'REQUEST_EDITING_WAREHOUSE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_WAREHOUSE_SUCCESS, 'EDIT_WAREHOUSE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_WAREHOUSE_FAILURE, 'EDIT_WAREHOUSE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DELETE_WAREHOUSE, 'REQUEST_DELETE_WAREHOUSE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_WAREHOUSE_SUCCESS, 'DELETE_WAREHOUSE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_WAREHOUSE_FAILURE, 'DELETE_WAREHOUSE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_ZONES, 'REQUEST_ZONES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_ZONES_SUCCESS, 'FETCH_ZONES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_ZONES_FAILURE, 'FETCH_ZONES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_ZONE, 'SELECT_ZONE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_ZONE, 'RESET_CURRENT_ZONE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_ZONE_DETAIL, 'REQUEST_ZONE_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_ZONE_DETAIL_SUCCESS, 'FETCH_ZONE_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_ZONE_DETAIL_FAILURE, 'FETCH_ZONE_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_ZONE, 'REQUEST_CREATING_ZONE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_ZONE_SUCCESS, 'CREATE_ZONE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_ZONE_FAILURE, 'CREATE_ZONE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_ZONE, 'REQUEST_EDITING_ZONE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_ZONE_SUCCESS, 'EDIT_ZONE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_ZONE_FAILURE, 'EDIT_ZONE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BINS, 'REQUEST_BINS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_BINS_SUCCESS, 'FETCH_BINS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_BINS2_SUCCESS, 'FETCH_BINS2_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_BINS3_SUCCESS, 'FETCH_BINS3_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_BINS_FAILURE, 'FETCH_BINS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_BINS, 'RESET_BINS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_BIN, 'SELECT_BIN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_BIN, 'RESET_CURRENT_BIN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BIN_DETAIL, 'REQUEST_BIN_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_BIN_DETAIL_SUCCESS, 'FETCH_BIN_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_BIN_DETAIL_FAILURE, 'FETCH_BIN_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_BIN, 'REQUEST_CREATING_BIN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_BIN_SUCCESS, 'CREATE_BIN_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_BIN_FAILURE, 'CREATE_BIN_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_BIN, 'REQUEST_EDITING_BIN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_BIN_SUCCESS, 'EDIT_BIN_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_BIN_FAILURE, 'EDIT_BIN_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DELETE_ZONE, 'REQUEST_DELETE_ZONE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_ZONE_SUCCESS, 'DELETE_ZONE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_ZONE_FAILURE, 'DELETE_ZONE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DELETE_BIN, 'REQUEST_DELETE_BIN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_BIN_SUCCESS, 'DELETE_BIN_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_BIN_FAILURE, 'DELETE_BIN_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_LEVELS, 'FETCH_LEVELS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_LEVELS_SUCCESS, 'FETCH_LEVELS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_LEVELS2_SUCCESS, 'FETCH_LEVELS2_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_LEVELS3_SUCCESS, 'FETCH_LEVELS3_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_LEVELS_ERROR, 'FETCH_LEVELS_ERROR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_BARCODE, 'CREATE_BARCODE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_BARCODE_SUCCESS, 'CREATE_BARCODE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_BARCODE_FAILURE, 'CREATE_BARCODE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_LEVEL, 'SELECT_LEVEL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_LEVEL, 'REQUEST_EDITING_LEVEL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDITING_LEVEL_SUCCESS, 'EDITING_LEVEL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDITING_LEVEL_FAILURE, 'EDITING_LEVEL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_LEVEL_REQUEST, 'CREATE_LEVEL_REQUEST', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_LEVEL_SUCCESS, 'CREATE_LEVEL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_LEVEL_FAILURE, 'CREATE_LEVEL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ATTACH_ZONE_BIN_LEVEL, 'ATTACH_ZONE_BIN_LEVEL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ATTACH_ZONE_BIN_LEVEL_SUCCESS, 'ATTACH_ZONE_BIN_LEVEL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ATTACH_ZONE_BIN_LEVEL_FAILURE, 'ATTACH_ZONE_BIN_LEVEL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DELETE_LEVEL, 'REQUEST_DELETE_LEVEL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_LEVEL_SUCCESS, 'DELETE_LEVEL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_LEVEL_FAILURE, 'DELETE_LEVEL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_ORDERS, 'REQUEST_SALES_ORDERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_ORDERS_SUCCESS, 'FETCH_SALES_ORDERS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_ORDERS_FAILURE, 'FETCH_SALES_ORDERS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_ORDERS_BY_FILTER, 'REQUEST_SALES_ORDERS_BY_FILTER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_SALES_ORDER, 'SELECT_SALES_ORDER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_SALES_ORDER, 'RESET_CURRENT_SALES_ORDER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_ORDER_DETAIL, 'REQUEST_SALES_ORDER_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_ORDER_DETAIL_SUCCESS, 'FETCH_SALES_ORDER_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_ORDER_DETAIL_FAILURE, 'FETCH_SALES_ORDER_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_ORDER_DETAIL_BY_NUM, 'REQUEST_SALES_ORDER_DETAIL_BY_NUM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_ORDER_DETAIL_BY_NUM_SUCCESS, 'FETCH_SALES_ORDER_DETAIL_BY_NUM_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_ORDER_DETAIL_BY_NUM_FAILURE, 'FETCH_SALES_ORDER_DETAIL_BY_NUM_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_SALES_ORDER, 'REQUEST_CREATING_SALES_ORDER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_SALES_ORDER_SUCCESS, 'CREATE_SALES_ORDER_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_SALES_ORDER_FAILURE, 'CREATE_SALES_ORDER_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_SALES_ORDER, 'REQUEST_EDITING_SALES_ORDER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_SALES_ORDER_SUCCESS, 'EDIT_SALES_ORDER_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_SALES_ORDER_FAILURE, 'EDIT_SALES_ORDER_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_INVENTORY_INFO, 'REQUEST_SALES_INVENTORY_INFO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_INVENTORY_INFO_SUCCESS, 'FETCH_SALES_INVENTORY_INFO_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_INVENTORY_INFO_FAILURE, 'FETCH_SALES_INVENTORY_INFO_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_CUSTOMER_DETAIL, 'REQUEST_SALES_CUSTOMER_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_SHIPPING_CUSTOMER_DETAIL, 'REQUEST_SALES_SHIPPING_CUSTOMER_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_SHIPPING_CUSTOMER_DETAIL_SUCCESS, 'FETCH_SALES_SHIPPING_CUSTOMER_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_CUSTOMER_DETAIL_SUCCESS, 'FETCH_SALES_CUSTOMER_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_CUSTOMER_DETAIL_FAILURE, 'FETCH_SALES_CUSTOMER_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SHIPPING_DETAIL, 'REQUEST_SHIPPING_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SHIPPING_DETAIL_SUCCESS, 'FETCH_SHIPPING_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SHIPPING_DETAIL_FAILURE, 'FETCH_SHIPPING_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PURCHASES_VENDOR_DETAIL, 'REQUEST_PURCHASES_VENDOR_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASES_VENDOR_DETAIL_SUCCESS, 'FETCH_PURCHASES_VENDOR_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASES_VENDOR_DETAIL_FAILURE, 'FETCH_PURCHASES_VENDOR_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_SALES_CUSTOMER_DETAILS, 'CLEAR_SALES_CUSTOMER_DETAILS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SET_SALES_ORDERS_FILTER, 'SET_SALES_ORDERS_FILTER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_ITEM_SALES_HISTORY, 'REQUEST_ITEM_SALES_HISTORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_ITEM_SALES_HISTORY_SUCCESS, 'FETCH_ITEM_SALES_HISTORY_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_ITEM_SALES_HISTORY_FAILURE, 'FETCH_ITEM_SALES_HISTORY_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CUSTOMER_FREQUENT, 'REQUEST_CUSTOMER_FREQUENT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_FREQUENT_SUCCESS, 'FETCH_CUSTOMER_FREQUENT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_FREQUENT_FAILURE, 'FETCH_CUSTOMER_FREQUENT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_WHOLESALE, 'REQUEST_WHOLESALE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_WHOLESALE_SUCCESS, 'FETCH_WHOLESALE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_WHOLESALE_FAILURE, 'FETCH_WHOLESALE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_WHOLESALE, 'SELECT_WHOLESALE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_WHOLESALE, 'RESET_CURRENT_WHOLESALE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_WHOLESALE_DETAIL, 'REQUEST_WHOLESALE_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_WHOLESALE_DETAIL_SUCCESS, 'FETCH_WHOLESALE_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_WHOLESALE_DETAIL_FAILURE, 'FETCH_WHOLESALE_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_WHOLESALE, 'REQUEST_CREATING_WHOLESALE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_WHOLESALE_SUCCESS, 'CREATE_WHOLESALE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_WHOLESALE_FAILURE, 'CREATE_WHOLESALE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDITING_WHOLESALE, 'REQUEST_EDITING_WHOLESALE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_WHOLESALE_SUCCESS, 'EDIT_WHOLESALE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_WHOLESALE_FAILURE, 'EDIT_WHOLESALE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_VOID_SALES_ORDER, 'REQUEST_VOID_SALES_ORDER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(VOID_SALES_ORDER_SUCCESS, 'VOID_SALES_ORDER_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(VOID_SALES_ORDER_FAILURE, 'VOID_SALES_ORDER_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_WAREHOUSE_SALES_ORDERS, 'REQUEST_WAREHOUSE_SALES_ORDERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_WAREHOUSE_SALES_ORDERS_SUCCESS, 'FETCH_WAREHOUSE_SALES_ORDERS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_WAREHOUSE_SALES_ORDERS_FAILURE, 'FETCH_WAREHOUSE_SALES_ORDERS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_WAREHOUSE_PURCHASE_ORDERS, 'REQUEST_WAREHOUSE_PURCHASE_ORDERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_WAREHOUSE_PURCHASE_ORDERS_SUCCESS, 'FETCH_WAREHOUSE_PURCHASE_ORDERS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_WAREHOUSE_PURCHASE_ORDERS_FAILURE, 'FETCH_WAREHOUSE_PURCHASE_ORDERS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_WAREHOUSE_BINS, 'REQUEST_WAREHOUSE_BINS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_WAREHOUSE_BINS_SUCCESS, 'FETCH_WAREHOUSE_BINS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_WAREHOUSE_BINS_FAILURE, 'FETCH_WAREHOUSE_BINS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CUSTOMER_SALES_HISTORY, 'REQUEST_CUSTOMER_SALES_HISTORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_SALES_HISTORY_SUCCESS, 'FETCH_CUSTOMER_SALES_HISTORY_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_SALES_HISTORY_FAILURE, 'FETCH_CUSTOMER_SALES_HISTORY_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CUSTOMER_ORDER_SCHEDULES, 'REQUEST_CUSTOMER_ORDER_SCHEDULES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_ORDER_SCHEDULES_SUCCESS, 'FETCH_CUSTOMER_ORDER_SCHEDULES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_ORDER_SCHEDULES_FAILURE, 'FETCH_CUSTOMER_ORDER_SCHEDULES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_TODAYS_OUTGOING_ORDERS, 'REQUEST_TODAYS_OUTGOING_ORDERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_TODAYS_OUTGOING_ORDERS_SUCCESS, 'FETCH_TODAYS_OUTGOING_ORDERS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_TODAYS_OUTGOING_ORDERS_FAILURE, 'FETCH_TODAYS_OUTGOING_ORDERS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_ORDER_LINE_WEIGHTS, 'REQUEST_SALES_ORDER_LINE_WEIGHTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_ORDER_LINE_WEIGHTS_SUCCESS, 'FETCH_SALES_ORDER_LINE_WEIGHTS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_ORDER_LINE_WEIGHTS_FAILURE, 'FETCH_SALES_ORDER_LINE_WEIGHTS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SET_ORDER_LINE_WEIGHTS, 'REQUEST_SET_ORDER_LINE_WEIGHTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_SALES_ORDER_LINE_WEIGHTS_SUCCESS, 'EDIT_SALES_ORDER_LINE_WEIGHTS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_SALES_ORDER_LINE_WEIGHTS_FAILURE, 'EDIT_SALES_ORDER_LINE_WEIGHTS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_SALES_ORDER_LINE_WEIGHTS, 'CLEAR_SALES_ORDER_LINE_WEIGHTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SET_SHIPPING_WEIGHT, 'REQUEST_SET_SHIPPING_WEIGHT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(UPDATE_SHIPPING_WEIGHT_SUCCESS, 'UPDATE_SHIPPING_WEIGHT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(UPDATE_SHIPPING_WEIGHT_FAILURE, 'UPDATE_SHIPPING_WEIGHT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SET_SHIPPING_WEIGHT_SPLIT, 'REQUEST_SET_SHIPPING_WEIGHT_SPLIT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(UPDATE_CURRENT_SALES_ORDER_DETAIL_SHIPPINGINFO, 'UPDATE_CURRENT_SALES_ORDER_DETAIL_SHIPPINGINFO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_ORDER_FORM, 'REQUEST_SALES_ORDER_FORM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_ORDER_FORM_SUCCESS, 'FETCH_SALES_ORDER_FORM_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_ORDER_FORM_FAILURE, 'FETCH_SALES_ORDER_FORM_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_INVENTORIES, 'CLEAR_INVENTORIES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_CSV, 'REQUEST_SALES_CSV', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_CSV_SUCCESS, 'FETCH_SALES_CSV_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_CSV_FAILURE, 'FETCH_SALES_CSV_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SAVE_POS_SALE, 'REQUEST_SAVE_POS_SALE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_POS_SALE_SUCCESS, 'SAVE_POS_SALE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_POS_SALE_FAILURE, 'SAVE_POS_SALE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(INVALID_CHARACTER_ENTERED, 'INVALID_CHARACTER_ENTERED', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_ERROR_MESSAGE_IN_POS, 'CLEAR_ERROR_MESSAGE_IN_POS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_POS_ORDERS, 'REQUEST_POS_ORDERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_POS_ORDERS_SUCCESS, 'FETCH_POS_ORDERS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_POS_ORDERS_FAILURE, 'FETCH_POS_ORDERS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_POS_ORDER_DETAIL, 'REQUEST_POS_ORDER_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_POS_ORDER_DETAIL_SUCCESS, 'FETCH_POS_ORDER_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_POS_ORDER_DETAIL_FAILURE, 'FETCH_POS_ORDER_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_VOID_POS_ORDER, 'REQUEST_VOID_POS_ORDER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(VOID_POS_ORDER_SUCCESS, 'VOID_POS_ORDER_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(VOID_POS_ORDER_FAILURE, 'VOID_POS_ORDER_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_POS_CREDITS, 'REQUEST_POS_CREDITS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_POS_CREDITS_SUCCESS, 'FETCH_POS_CREDITS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_POS_CREDITS_FAILURE, 'FETCH_POS_CREDITS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_POS_CREDIT_DETAIL, 'REQUEST_POS_CREDIT_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_POS_CREDIT_DETAIL_SUCCESS, 'FETCH_POS_CREDIT_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_POS_CREDIT_DETAIL_FAILURE, 'FETCH_POS_CREDIT_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDIT_POS_PAYMENT, 'REQUEST_EDIT_POS_PAYMENT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_POS_PAYMENT_SUCCESS, 'EDIT_POS_PAYMENT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_POS_PAYMENT_FAILURE, 'EDIT_POS_PAYMENT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_POS_HOLDS_SUCCESS, 'FETCH_POS_HOLDS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_POS_HOLDS_DETAILS_SUCCESS, 'FETCH_POS_HOLDS_DETAILS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CHARGE_NOT_MET, 'CHARGE_NOT_MET', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(START_NEW_ORDER, 'START_NEW_ORDER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DRAFT_DETAILS, 'REQUEST_DRAFT_DETAILS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(LOAD_DRAFT_SUCCESS, 'LOAD_DRAFT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(LOAD_DRAFT_FAILURE, 'LOAD_DRAFT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DRAFTS, 'REQUEST_DRAFTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_DRAFTS_SUCCESSFUL, 'FETCH_DRAFTS_SUCCESSFUL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_DRAFTS_FAILURE, 'FETCH_DRAFTS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATING_SALES_RETURN, 'REQUEST_CREATING_SALES_RETURN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_SALES_RETURN_SUCCESS, 'CREATE_SALES_RETURN_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_SALES_RETURN_FAILURE, 'CREATE_SALES_RETURN_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_RETURN_DETAIL, 'REQUEST_SALES_RETURN_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_RETURN_DETAIL_SUCCESS, 'FETCH_SALES_RETURN_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_RETURN_DETAIL_FAILURE, 'FETCH_SALES_RETURN_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_INVOICES_COMPLETED, 'REQUEST_SALES_INVOICES_COMPLETED', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_INVOICES_COMPLETED_SUCCESS, 'FETCH_SALES_INVOICES_COMPLETED_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_INVOICES_COMPLETED_FAILURE, 'FETCH_SALES_INVOICES_COMPLETED_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_ORDER_TO_QUOTE, 'REQUEST_SALES_ORDER_TO_QUOTE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SALES_ORDER_TO_QUOTE_SUCCESS, 'SALES_ORDER_TO_QUOTE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SALES_ORDER_TO_QUOTE_FAILURE, 'SALES_ORDER_TO_QUOTE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_QUOTE_TO_OPEN, 'REQUEST_SALES_QUOTE_TO_OPEN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_QUOTE_TO_ORDER_SUCCESS, 'REQUEST_SALES_QUOTE_TO_ORDER_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_QUOTE_TO_ORDER_FAILURE, 'REQUEST_SALES_QUOTE_TO_ORDER_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CUSTOMER_ITEM, 'REQUEST_CUSTOMER_ITEM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_ITEM_SUCCESS, 'FETCH_CUSTOMER_ITEM_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_ITEM_FAILURE, 'FETCH_CUSTOMER_ITEM_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVENTORY_RETURN, 'REQUEST_INVENTORY_RETURN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_RETURN_SUCCESS, 'FETCH_INVENTORY_RETURN_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_RETURN_FAILURE, 'FETCH_INVENTORY_RETURN_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVENTORY_RETURN_DETAILS, 'REQUEST_INVENTORY_RETURN_DETAILS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_RETURN_DETAILS_SUCCESS, 'FETCH_INVENTORY_RETURN_DETAILS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_RETURN_DETAILS_FAILURE, 'FETCH_INVENTORY_RETURN_DETAILS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_INVENTORY_RETURN, 'EDIT_INVENTORY_RETURN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_INVENTORY_RETURN_SUCCESS, 'EDIT_INVENTORY_RETURN_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_INVENTORY_RETURN_FAILURE, 'EDIT_INVENTORY_RETURN_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CUSTOMER_PRICES, 'REQUEST_CUSTOMER_PRICES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_PRICES_SUCCESS, 'FETCH_CUSTOMER_PRICES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_PRICES_FAILURE, 'FETCH_CUSTOMER_PRICES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CURRENCY_RATES, 'REQUEST_CURRENCY_RATES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CURRENCY_RATES_SUCCESS, 'FETCH_CURRENCY_RATES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CURRENCY_RATES_FAILURE, 'FETCH_CURRENCY_RATES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_MULTI_CURRENCIES, 'EDIT_MULTI_CURRENCIES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_MULTI_CURRENCIES_SUCCESS, 'EDIT_MULTI_CURRENCIES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_MULTI_CURRENCIES_FAILURE, 'EDIT_MULTI_CURRENCIES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_TAX_RATES, 'REQUEST_TAX_RATES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_TAX_RATES_SUCCESS, 'FETCH_TAX_RATES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_TAX_RATES_FAILURE, 'FETCH_TAX_RATES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATE_TAX_RATE, 'REQUEST_CREATE_TAX_RATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_TAX_RATE_SUCCESS, 'CREATE_TAX_RATE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_TAX_RATE_FAILURE, 'CREATE_TAX_RATE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_OVERALL_SALES_PERFORMANCE, 'REQUEST_OVERALL_SALES_PERFORMANCE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_OVERALL_SALES_PERFORMANCE_SUCCESS, 'FETCH_OVERALL_SALES_PERFORMANCE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_OVERALL_SALES_PERFORMANCE_FAILURE, 'FETCH_OVERALL_SALES_PERFORMANCE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_ORDER_INVENTORY, 'REQUEST_SALES_ORDER_INVENTORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_ORDER_INVENTORY_SUCCESS, 'FETCH_SALES_ORDER_INVENTORY_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_ORDER_INVENTORY_FAILURE, 'FETCH_SALES_ORDER_INVENTORY_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_POS_REPORT, 'REQUEST_POS_REPORT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_POS_REPORT_SUCCESS, 'FETCH_POS_REPORT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_POS_REPORT_FAILURE, 'FETCH_POS_REPORT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_PERFORMANCE, 'REQUEST_SALES_PERFORMANCE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_PERFORMANCE_BY_FILTER, 'REQUEST_SALES_PERFORMANCE_BY_FILTER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_PERFORMANCE_SUCCESS, 'REQUEST_SALES_PERFORMANCE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_PERFORMANCE_FAILURE, 'REQUEST_SALES_PERFORMANCE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_USER_PERFORMANCE_BY_FILTER, 'REQUEST_USER_PERFORMANCE_BY_FILTER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_USER_PERFORMANCE_SUCCESS, 'REQUEST_USER_PERFORMANCE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_USER_PERFORMANCE_FAILURE, 'REQUEST_USER_PERFORMANCE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_DASHBOARD_DETAIL, 'REQUEST_SALES_DASHBOARD_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_DASHBOARD_DETAIL_SUCCESS, 'FETCH_SALES_DASHBOARD_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_DASHBOARD_DETAIL_FAILURE, 'FETCH_SALES_DASHBOARD_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_LEVELS, 'REQUEST_SALES_LEVELS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_LEVELS_SUCCESS, 'FETCH_SALES_LEVELS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_LEVELS_FAILURE, 'FETCH_SALES_LEVELS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_REFUND, 'REQUEST_REFUND', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_REFUND_SUCCESS, 'REQUEST_REFUND_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_REFUND_FAILURE, 'REQUEST_REFUND_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_REFUND_PDF, 'REQUEST_REFUND_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_REFUND_PDF_SUCCESS, 'REQUEST_REFUND_PDF_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_RETURN_VOID, 'REQUEST_RETURN_VOID', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_RETURN_COMPLETE, 'REQUEST_RETURN_COMPLETE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RETURN_SUCCESS, 'FETCH_RETURN_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RETURN_FAILURE, 'FETCH_RETURN_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PRODUCT_BY_ID, 'REQUEST_PRODUCT_BY_ID', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRODUCT_BY_ID_SUCCESS, 'FETCH_PRODUCT_BY_ID_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRODUCT_BY_ID_FAILURE, 'FETCH_PRODUCT_BY_ID_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRODUCT_BY_ID, 'FETCH_PRODUCT_BY_ID', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_ORDER_SUGGESTIONS_SUCCESS, 'FETCH_SALES_ORDER_SUGGESTIONS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_ORDER_SUGGESTIONS_FAILURE, 'FETCH_SALES_ORDER_SUGGESTIONS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_ORDER_SUGGESTIONS, 'FETCH_SALES_ORDER_SUGGESTIONS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_ORDER_SUGGESTIONS, 'FETCH_PURCHASE_ORDER_SUGGESTIONS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_ORDER_SUGGESTIONS_SUCCESS, 'FETCH_PURCHASE_ORDER_SUGGESTIONS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASE_ORDER_SUGGESTIONS_FAILURE, 'FETCH_PURCHASE_ORDER_SUGGESTIONS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRODUCT_SUGGESTIONS, 'FETCH_PRODUCT_SUGGESTIONS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRODUCT_SUGGESTIONS_SUCCESS, 'FETCH_PRODUCT_SUGGESTIONS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRODUCT_SUGGESTIONS_FAILURE, 'FETCH_PRODUCT_SUGGESTIONS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_TOTALS, 'REQUEST_SALES_TOTALS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_TOTALS_SUCCESS, 'FETCH_SALES_TOTALS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_TOTALS_FAILURE, 'FETCH_SALES_TOTALS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_MOBILE_TASK, 'CREATE_MOBILE_TASK', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_MOBILE_TASK_SUCCESS, 'CREATE_MOBILE_TASK_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_MOBILE_TASK_FAILURE, 'CREATE_MOBILE_TASK_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(KEEP_EST_DATE, 'KEEP_EST_DATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FINISHED_UNMOUNT, 'FINISHED_UNMOUNT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DESTROY_EST_DATE, 'DESTROY_EST_DATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CUSTOMER_FAVORITES, 'REQUEST_CUSTOMER_FAVORITES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_FAVORITES_SUCCESS, 'FETCH_CUSTOMER_FAVORITES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_FAVORITES_FAILURE, 'FETCH_CUSTOMER_FAVORITES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_CUSTOMER_FAVORITES, 'SELECT_CUSTOMER_FAVORITES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_CUSTOMER_FAVORITES, 'RESET_CURRENT_CUSTOMER_FAVORITES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CUSTOMER_FAVORITES_DETAIL, 'REQUEST_CUSTOMER_FAVORITES_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_FAVORITES_DETAIL_SUCCESS, 'FETCH_CUSTOMER_FAVORITES_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_FAVORITES_DETAIL_FAILURE, 'FETCH_CUSTOMER_FAVORITES_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_ADDING_CUSTOMER_FAVORITE, 'REQUEST_ADDING_CUSTOMER_FAVORITE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ADD_CUSTOMER_FAVORITE_SUCCESS, 'ADD_CUSTOMER_FAVORITE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ADD_CUSTOMER_FAVORITE_FAILURE, 'ADD_CUSTOMER_FAVORITE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DELETE_CUSTOMER_FAVORITE, 'REQUEST_DELETE_CUSTOMER_FAVORITE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_CUSTOMER_FAVORITE_SUCCESS, 'DELETE_CUSTOMER_FAVORITE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_CUSTOMER_FAVORITE_FAILURE, 'DELETE_CUSTOMER_FAVORITE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMERS_WITH_FAVORITES, 'FETCH_CUSTOMERS_WITH_FAVORITES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CUSTOMERS_WITH_FAVORITES, 'REQUEST_CUSTOMERS_WITH_FAVORITES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMERS_WITH_FAVORITES_SUCCESS, 'FETCH_CUSTOMERS_WITH_FAVORITES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMERS_WITH_FAVORITES_FAILURE, 'FETCH_CUSTOMERS_WITH_FAVORITES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_ADDING_NEW_FAVORITE_LIST, 'REQUEST_ADDING_NEW_FAVORITE_LIST', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ADD_NEW_FAVORITE_LIST_SUCCESS, 'ADD_NEW_FAVORITE_LIST_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ADD_NEW_FAVORITE_LIST_FAILURE, 'ADD_NEW_FAVORITE_LIST_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CUSTOMER_GROUPS, 'REQUEST_CUSTOMER_GROUPS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_GROUPS_SUCCESS, 'FETCH_CUSTOMER_GROUPS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_GROUPS_FAILURE, 'FETCH_CUSTOMER_GROUPS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CUSTOMER_GROUPS_DETAIL, 'REQUEST_CUSTOMER_GROUPS_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_GROUPS_DETAIL_SUCCESS, 'FETCH_CUSTOMER_GROUPS_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_GROUPS_DETAIL_FAILURE, 'FETCH_CUSTOMER_GROUPS_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SAVE_PRODUCT_LIST, 'REQUEST_SAVE_PRODUCT_LIST', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_PRODUCT_LIST_SUCCESS, 'SAVE_PRODUCT_LIST_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_PRODUCT_LIST_FAILURE, 'SAVE_PRODUCT_LIST_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_INVOICES, 'REQUEST_SALES_INVOICES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_INVOICES_BY_NUM, 'REQUEST_SALES_INVOICES_BY_NUM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_INVOICES_BY_NUM_SUCCESS, 'FETCH_SALES_INVOICES_BY_NUM_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_INVOICES_BY_NUM_FAILURE, 'FETCH_SALES_INVOICES_BY_NUM_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_INVOICES_SUCCESS, 'FETCH_SALES_INVOICES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_INVOICES_FAILURE, 'FETCH_SALES_INVOICES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_SALES_INVOICE, 'SELECT_SALES_INVOICE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_SALES_INVOICE, 'RESET_CURRENT_SALES_INVOICE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_INVOICE_DETAIL, 'REQUEST_SALES_INVOICE_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_INVOICE_DETAIL_SUCCESS, 'FETCH_SALES_INVOICE_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_INVOICE_DETAIL_FAILURE, 'FETCH_SALES_INVOICE_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_FINALIZE_INVOICE, 'REQUEST_FINALIZE_INVOICE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FINALIZE_INVOICE_SUCCESS, 'FINALIZE_INVOICE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FINALIZE_INVOICE_FAILURE, 'FINALIZE_INVOICE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELIVER_INVOICE_SUCCESS, 'DELIVER_INVOICE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELIVER_INVOICE_FAILURE, 'DELIVER_INVOICE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DELIVER_INVOICE, 'REQUEST_DELIVER_INVOICE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_VOID_INVOICE, 'REQUEST_VOID_INVOICE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(VOID_INVOICE_SUCCESS, 'VOID_INVOICE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(VOID_INVOICE_FAILURE, 'VOID_INVOICE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_VOID_RETURN, 'REQUEST_VOID_RETURN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(VOID_RETURN_SUCCESS, 'VOID_RETURN_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(VOID_RETURN_FAILURE, 'VOID_RETURN_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_FINALIZED_INVOICES, 'REQUEST_FINALIZED_INVOICES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_FINALIZED_INVOICES_SUCCESS, 'FETCH_FINALIZED_INVOICES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_FINALIZED_INVOICES_FAILURE, 'FETCH_FINALIZED_INVOICES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(UPDATE_SALES_INVOICE, 'UPDATE_SALES_INVOICE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(UPDATE_SALES_INVOICE_SUCCESS, 'UPDATE_SALES_INVOICE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(UPDATE_SALES_INVOICE_FAILURE, 'UPDATE_SALES_INVOICE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(UPDATE_SALES_INVOICE_PAYMENT, 'UPDATE_SALES_INVOICE_PAYMENT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(UPDATE_SALES_INVOICE_PAYMENT_SUCCESS, 'UPDATE_SALES_INVOICE_PAYMENT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(UPDATE_SALES_INVOICE_PAYMENT_FAILURE, 'UPDATE_SALES_INVOICE_PAYMENT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_SALES_INVOICE_PAYMENT, 'RESET_SALES_INVOICE_PAYMENT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_UPDATE_SALES_INVOICE, 'CLEAR_UPDATE_SALES_INVOICE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(UPDATE_SALES_INVOICE_RESET, 'UPDATE_SALES_INVOICE_RESET', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_INVOICE_FORM, 'REQUEST_SALES_INVOICE_FORM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_INVOICE_FORM_SUCCESS, 'FETCH_SALES_INVOICE_FORM_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_INVOICE_FORM_FAILURE, 'FETCH_SALES_INVOICE_FORM_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_SI_CUSTOMER, 'EDIT_SI_CUSTOMER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_SI_CUSTOMER_SUCCESS, 'EDIT_SI_CUSTOMER_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_SI_CUSTOMER_FAILURE, 'EDIT_SI_CUSTOMER_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_EDIT_SI_CUSTOMER, 'RESET_EDIT_SI_CUSTOMER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_UNPAID_INVOICE, 'REQUEST_UNPAID_INVOICE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_UNPAID_INVOICE_SUCCESS, 'FETCH_UNPAID_INVOICE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_UNPAID_INVOICE_FAILURE, 'FETCH_UNPAID_INVOICE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(COMPLETE_PURCHASE_ORDER, 'COMPLETE_PURCHASE_ORDER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(COMPLETE_PURCHASE_ORDER_SUCCESS, 'COMPLETE_PURCHASE_ORDER_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(COMPLETE_PURCHASE_ORDER_FAILURE, 'COMPLETE_PURCHASE_ORDER_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(COPY_PURCHASE_ORDER, 'COPY_PURCHASE_ORDER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(COPY_PURCHASE_ORDER_SUCCESS, 'COPY_PURCHASE_ORDER_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(COPY_PURCHASE_ORDER_FAILURE, 'COPY_PURCHASE_ORDER_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVENTORY_BATCHES, 'REQUEST_INVENTORY_BATCHES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_BATCHES_SUCCESS, 'FETCH_INVENTORY_BATCHES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVENTORY_BATCHES_FAILURE, 'FETCH_INVENTORY_BATCHES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PRODUCT_INVENTORY_BATCHES, 'REQUEST_PRODUCT_INVENTORY_BATCHES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRODUCT_INVENTORY_BATCHES_SUCCESS, 'FETCH_PRODUCT_INVENTORY_BATCHES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRODUCT_INVENTORY_BATCHES_FAILURE, 'FETCH_PRODUCT_INVENTORY_BATCHES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_EDITED_STOPS, 'SAVE_EDITED_STOPS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_EDITED_STOPS_SUCCESS, 'SAVE_EDITED_STOPS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_EDITED_STOPS_FAILURE, 'SAVE_EDITED_STOPS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SAVE_NEW_ROUTES, 'REQUEST_SAVE_NEW_ROUTES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_NEW_ROUTES_SUCCESS, 'SAVE_NEW_ROUTES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_NEW_ROUTES_FAILURE, 'SAVE_NEW_ROUTES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_ROUTES, 'REQUEST_ROUTES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_ROUTES_SUCCESS, 'FETCH_ROUTES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_AUTO_ROUTES_SUCCESS, 'FETCH_AUTO_ROUTES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(START_FETCHING_AUTO_ROUTES, 'START_FETCHING_AUTO_ROUTES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_ROUTES_FAILURE, 'FETCH_ROUTES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_STOPS, 'REQUEST_STOPS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_STOPS_SUCCESS, 'FETCH_STOPS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_STOPS_FAILURE, 'FETCH_STOPS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDIT_STOPS, 'REQUEST_EDIT_STOPS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_EDIT_STOPS_SUCCESS, 'FETCH_EDIT_STOPS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_EDIT_STOPS_FAILURE, 'FETCH_EDIT_STOPS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SAVE_EDITS, 'REQUEST_SAVE_EDITS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_EDITS_SUCCESS, 'SAVE_EDITS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_EDITS_FAILURE, 'SAVE_EDITS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_EDIT_STATUS, 'CLEAR_EDIT_STATUS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CUSTOMER_ROUTES, 'REQUEST_CUSTOMER_ROUTES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_ROUTES_SUCCESS, 'FETCH_CUSTOMER_ROUTES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMER_ROUTES_FAILURE, 'FETCH_CUSTOMER_ROUTES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_UNASSIGNED_ORDERS, 'REQUEST_UNASSIGNED_ORDERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_UNASSIGNED_ORDERS_SUCCESS, 'FETCH_UNASSIGNED_ORDERS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_UNASSIGNED_ORDERS_FAILURE, 'FETCH_UNASSIGNED_ORDERS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_ORDERS_BY_DATE, 'REQUEST_SALES_ORDERS_BY_DATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_ORDERS_BY_DATE_SUCCESS, 'FETCH_SALES_ORDERS_BY_DATE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_ORDERS_BY_DATE_FAILURE, 'FETCH_SALES_ORDERS_BY_DATE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_ASSIGN_ORDER_ROUTE, 'REQUEST_ASSIGN_ORDER_ROUTE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ASSIGN_ORDER_ROUTE_SUCCESS, 'ASSIGN_ORDER_ROUTE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ASSIGN_ORDER_ROUTE_FAILURE, 'ASSIGN_ORDER_ROUTE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SAVE_ROUTE_EDITS, 'REQUEST_SAVE_ROUTE_EDITS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_ROUTE_EDIT_SUCCESS, 'SAVE_ROUTE_EDIT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_ROUTE_EDIT_FAILURE, 'SAVE_ROUTE_EDIT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CONVERT_TO_INVOICE, 'REQUEST_CONVERT_TO_INVOICE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CONVERT_TO_INVOICE_SUCCESS, 'CONVERT_TO_INVOICE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CONVERT_TO_INVOICE_FAILURE, 'CONVERT_TO_INVOICE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_CONVERT_TO_INVOICE, 'CLEAR_CONVERT_TO_INVOICE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CONVERT_TO_INVOICE_RESET, 'CONVERT_TO_INVOICE_RESET', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_AR, 'REQUEST_AR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_AR_SUCCESS, 'FETCH_AR_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_AR_FAILURE, 'FETCH_AR_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_AR, 'CREATE_AR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_AR_SUCCESS, 'CREATE_AR_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_AR_FAILURE, 'CREATE_AR_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REFUND_AR, 'REFUND_AR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REFUND_AR_SUCCESS, 'REFUND_AR_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REFUND_AR_FAILURE, 'REFUND_AR_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_AR, 'EDIT_AR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_AR_SUCCESS, 'EDIT_AR_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_AR_FAILURE, 'EDIT_AR_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_AR, 'DELETE_AR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_AR_SUCCESS, 'DELETE_AR_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_AR_FAILURE, 'DELETE_AR_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_AR_DETAIL, 'REQUEST_AR_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_AR_DETAIL_SUCCESS, 'FETCH_AR_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_AR_DETAIL_FAILURE, 'FETCH_AR_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_AR_DETAIL, 'CLEAR_AR_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_AR_FORM, 'CLEAR_AR_FORM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INVOICES, 'REQUEST_INVOICES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVOICES_SUCCESS, 'FETCH_INVOICES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVOICES_FAILURE, 'FETCH_INVOICES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREDITS, 'REQUEST_CREDITS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CREDITS_SUCCESS, 'FETCH_CREDITS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CREDITS_FAILURE, 'FETCH_CREDITS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_CREDITS, 'CLEAR_CREDITS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_AR_ACCOUNTS, 'REQUEST_AR_ACCOUNTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_AR_ACCOUNTS_SUCCESS, 'FETCH_AR_ACCOUNTS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_AR_ACCOUNTS_FAILURE, 'FETCH_AR_ACCOUNTS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_AR_ACCOUNTS, 'CLEAR_AR_ACCOUNTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(BOUNCE_CHECK, 'BOUNCE_CHECK', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(BOUNCE_CHECK_SUCCESS, 'BOUNCE_CHECK_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(BOUNCE_CHECK_FAILURE, 'BOUNCE_CHECK_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_AP, 'REQUEST_AP', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_AP_SUCCESS, 'FETCH_AP_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_AP_FAILURE, 'FETCH_AP_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_AP, 'CREATE_AP', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_AP_SUCCESS, 'CREATE_AP_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_AP_FAILURE, 'CREATE_AP_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_AP, 'EDIT_AP', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_AP_SUCCESS, 'EDIT_AP_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_AP_FAILURE, 'EDIT_AP_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_AP, 'DELETE_AP', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_AP_SUCCESS, 'DELETE_AP_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_AP_FAILURE, 'DELETE_AP_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_AP_DETAIL, 'REQUEST_AP_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_AP_DETAIL_SUCCESS, 'FETCH_AP_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_AP_DETAIL_FAILURE, 'FETCH_AP_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_AP_DETAIL, 'CLEAR_AP_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_AP_FORM, 'CLEAR_AP_FORM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_STATEMENT, 'REQUEST_STATEMENT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_STATEMENT_SUCCESS, 'FETCH_STATEMENT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_STATEMENT_FAILURE, 'FETCH_STATEMENT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_STATEMENT_AP, 'REQUEST_STATEMENT_AP', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_STATEMENT_AP_SUCCESS, 'FETCH_STATEMENT_AP_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_STATEMENT_AP_FAILURE, 'FETCH_STATEMENT_AP_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_CHECK, 'RESET_CURRENT_CHECK', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_CHECK, 'SELECT_CHECK', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BASE_USER, 'REQUEST_BASE_USER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_BASE_USER_SUCCESS, 'FETCH_BASE_USER_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_BASE_USER_FAILURE, 'FETCH_BASE_USER_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BASE_USER_DETAIL, 'REQUEST_BASE_USER_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_BASE_USER_DETAIL_SUCCESS, 'FETCH_BASE_USER_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_BASE_USER_DETAIL_FAILURE, 'FETCH_BASE_USER_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_MOBILE_USERS, 'REQUEST_MOBILE_USERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_MOBILE_USERS_SUCCESS, 'FETCH_MOBILE_USERS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_MOBILE_USERS_FAILURE, 'FETCH_MOBILE_USERS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_CURRENT_USER, 'SELECT_CURRENT_USER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_USER, 'RESET_CURRENT_USER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_USER_GROUPS, 'REQUEST_USER_GROUPS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_USER_GROUPS_SUCCESS, 'FETCH_USER_GROUPS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_USER_PRODUCT_ALL_GROUPS_SUCCESS, 'FETCH_USER_PRODUCT_ALL_GROUPS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_USER_GROUPS_FAILURE, 'FETCH_USER_GROUPS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_CURRENT_GROUP, 'SELECT_CURRENT_GROUP', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_USER_GROUP, 'RESET_CURRENT_USER_GROUP', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PERMISSIONS, 'REQUEST_PERMISSIONS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PERMISSION_SUCCESS, 'FETCH_PERMISSION_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PERMISSION_FAILURE, 'FETCH_PERMISSION_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_GROUP_DETAIL, 'EDIT_GROUP_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_GROUP_DETAIL_SUCCESS, 'EDIT_GROUP_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_GROUP_DETAIL_FAILURE, 'EDIT_GROUP_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PERMISSIONS_SUCCESS, 'FETCH_PERMISSIONS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PERMISSIONS_FAILURE, 'FETCH_PERMISSIONS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_USER_DETAIL, 'EDIT_USER_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_USER_DETAIL_SUCCESS, 'EDIT_USER_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_USER_DETAIL_FAILURE, 'EDIT_USER_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_USER_DETAIL, 'RESET_USER_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_USER_DETAIL, 'CREATE_USER_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_USER_DETAIL_SUCCESS, 'CREATE_USER_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_USER_DETAIL_FAILURE, 'CREATE_USER_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_GROUP_DETAIL, 'CREATE_GROUP_DETAIL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_GROUP_DETAIL_SUCCESS, 'CREATE_GROUP_DETAIL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_GROUP_DETAIL_FAILURE, 'CREATE_GROUP_DETAIL_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PASSWORD, 'EDIT_PASSWORD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PASSWORD_SUCCESS, 'EDIT_PASSWORD_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_PASSWORD_FAILURE, 'EDIT_PASSWORD_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_PASSWORD, 'RESET_PASSWORD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ATTACH_FILES, 'ATTACH_FILES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ATTACH_FILES_SUCCESS, 'ATTACH_FILES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ATTACH_FILES_FAILURE, 'ATTACH_FILES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_ATTACHED_FILES, 'FETCH_ATTACHED_FILES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_ATTACHED_FILES_SUCCESS, 'FETCH_ATTACHED_FILES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_ATTACHED_FILES_FAILURE, 'FETCH_ATTACHED_FILES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_ATTACHED_FILES, 'DELETE_ATTACHED_FILES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_ATTACHED_FILES_SUCCESS, 'DELETE_ATTACHED_FILES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_ATTACHED_FILES_FAILURE, 'DELETE_ATTACHED_FILES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_ATTACHED_FILES, 'RESET_ATTACHED_FILES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ATTACH_DOCUMENT, 'ATTACH_DOCUMENT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ATTACH_DOCUMENT_SUCCESS, 'ATTACH_DOCUMENT_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ATTACH_DOCUMENT_FAILURE, 'ATTACH_DOCUMENT_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DASHBOARD_MESSAGES, 'REQUEST_DASHBOARD_MESSAGES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_DASHBOARD_MESSAGES_SUCCESS, 'FETCH_DASHBOARD_MESSAGES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_DASHBOARD_MESSAGES_FAILURE, 'FETCH_DASHBOARD_MESSAGES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(POST_DASHBOARD_MESSAGE, 'POST_DASHBOARD_MESSAGE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(POST_MESSAGE_SUCCESS, 'POST_MESSAGE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(POST_MESSAGE_FAILURE, 'POST_MESSAGE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CONSOLIDATED_STATISTICS, 'REQUEST_CONSOLIDATED_STATISTICS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CONSOLODATED_STATISTICS_SUCCESS, 'FETCH_CONSOLODATED_STATISTICS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CONSOLODATED_STATISTICS_FAILURE, 'FETCH_CONSOLODATED_STATISTICS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_REGISTERS, 'REQUEST_REGISTERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_REGISTERS_SUCCESS, 'FETCH_REGISTERS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_REGISTERS_FAILRE, 'FETCH_REGISTERS_FAILRE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_REGISTER_SESSIONS, 'REQUEST_REGISTER_SESSIONS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_REGISTER_SESSIONS_DATE, 'REQUEST_REGISTER_SESSIONS_DATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_REGISTER_SESSIONS_SUCCESS, 'FETCH_REGISTER_SESSIONS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_REGISTER_SESSIONS_FAILURE, 'FETCH_REGISTER_SESSIONS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(VERIFY_REGISTER, 'VERIFY_REGISTER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SHIPPING_LIST_PDF, 'REQUEST_SHIPPING_LIST_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SHIPPING_LIST_SUCCESS, 'FETCH_SHIPPING_LIST_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PACKING_LIST_PDF, 'REQUEST_PACKING_LIST_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PACKING_LIST_SUCCESS, 'FETCH_PACKING_LIST_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SO_PDF, 'REQUEST_SO_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SO_PDF_SUCCESS, 'FETCH_SO_PDF_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SO_SI_PDF, 'REQUEST_SO_SI_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SO_SI_PDF_SUCCESS, 'FETCH_SO_SI_PDF_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PICKING_LIST_PDF, 'REQUEST_PICKING_LIST_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PICKING_LIST_SUCCESS, 'FETCH_PICKING_LIST_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PO_PDF, 'REQUEST_PO_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PO_PDF_SUCCESS, 'FETCH_PO_PDF_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PO_NOSUBTOTAL_PDF, 'REQUEST_PO_NOSUBTOTAL_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PO_NOSUBTOTAL_PDF_SUCCESS, 'REQUEST_PO_NOSUBTOTAL_PDF_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SI_PDF, 'REQUEST_SI_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SI_PDF_SUCCESS, 'FETCH_SI_PDF_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SI_PDF_FAILURE, 'FETCH_SI_PDF_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SI_RETURN_PDF, 'REQUEST_SI_RETURN_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SI_RETURN_PDF_SUCCESS, 'FETCH_SI_RETURN_PDF_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SI_RETURN_PDF_FAILURE, 'FETCH_SI_RETURN_PDF_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_WR_PDF, 'REQUEST_WR_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_WR_PDF_SUCCESS, 'FETCH_WR_PDF_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REMOVE_SHIPPING_PDF, 'REMOVE_SHIPPING_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_AR_PDF, 'REQUEST_AR_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_AR_PDF_SUCCESS, 'FETCH_AR_PDF_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_AP_PDF, 'REQUEST_AP_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_AP_PDF_SUCCESS, 'FETCH_AP_PDF_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_ROUTING_PDF_SUCCESS, 'REQUEST_ROUTING_PDF_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_ROUTING_PDF_FAILURE, 'REQUEST_ROUTING_PDF_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_ROUTING_PDF, 'REQUEST_ROUTING_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DISPATCH_PICKING_LIST_PDF_SUCCESS, 'REQUEST_DISPATCH_PICKING_LIST_PDF_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DISPATCH_PICKING_LIST_PDF_FAILURE, 'REQUEST_DISPATCH_PICKING_LIST_PDF_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DISPATCH_PICKING_LIST_PDF, 'REQUEST_DISPATCH_PICKING_LIST_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DISPATCH_PACKING_LIST_PDF_SUCCESS, 'REQUEST_DISPATCH_PACKING_LIST_PDF_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DISPATCH_PACKING_LIST_PDF_FAILURE, 'REQUEST_DISPATCH_PACKING_LIST_PDF_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DISPATCH_PACKING_LIST_PDF, 'REQUEST_DISPATCH_PACKING_LIST_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DISPATCH_SALES_INVOICE_PDF_SUCCESS, 'REQUEST_DISPATCH_SALES_INVOICE_PDF_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DISPATCH_SALES_INVOICE_PDF_FAILURE, 'REQUEST_DISPATCH_SALES_INVOICE_PDF_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DISPATCH_SALES_INVOICE_PDF, 'REQUEST_DISPATCH_SALES_INVOICE_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SI_NOSUBTOTAL_PDF, 'REQUEST_SI_NOSUBTOTAL_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SI_NOSUBTOTAL_PDF_SUCCESS, 'REQUEST_SI_NOSUBTOTAL_PDF_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SI_RETURN_NOSUBTOTAL_PDF, 'REQUEST_SI_RETURN_NOSUBTOTAL_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SI_RETURN_NOSUBTOTAL_PDF_SUCCESS, 'REQUEST_SI_RETURN_NOSUBTOTAL_PDF_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BOL_ID_PDF, 'REQUEST_BOL_ID_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_BOL_ID_PDF_SUCCESS, 'FETCH_BOL_ID_PDF_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BOL_FBA_PDF, 'REQUEST_BOL_FBA_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_BOL_WITHOUT_LOG_SUCCESS, 'FETCH_BOL_WITHOUT_LOG_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BOL_WITHOUT_LOG, 'REQUEST_BOL_WITHOUT_LOG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BOL_LABEL, 'REQUEST_BOL_LABEL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_BOL_LABEL_SUCCESS, 'FETCH_BOL_LABEL_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_BOL_FBA_PDF_SUCCESS, 'FETCH_BOL_FBA_PDF_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_BOL_ADDRESS_SUCCESS, 'FETCH_BOL_ADDRESS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SP_SUCCESS, 'FETCH_SP_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SP_PDF, 'REQUEST_SP_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_POS_HOLDS_PDF, 'REQUEST_POS_HOLDS_PDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_POS_HOLDS_PDF_SUCCESS, 'FETCH_POS_HOLDS_PDF_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_GREAT_DEALS_NEW_ARRIVALS, 'FETCH_GREAT_DEALS_NEW_ARRIVALS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_GREAT_DEALS_NEW_ARRIVALS_SUCCESS, 'FETCH_GREAT_DEALS_NEW_ARRIVALS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_GREAT_DEALS_NEW_ARRIVALS_FAILURE, 'FETCH_GREAT_DEALS_NEW_ARRIVALS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(UPDATE_GREAT_DEALS, 'UPDATE_GREAT_DEALS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(UPDATE_GREAT_DEALS_SUCCESS, 'UPDATE_GREAT_DEALS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(UPDATE_GREAT_DEALS_FAILURE, 'UPDATE_GREAT_DEALS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(UPDATE_NEW_ARRIVALS, 'UPDATE_NEW_ARRIVALS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(UPDATE_NEW_ARRIVALS_SUCCESS, 'UPDATE_NEW_ARRIVALS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(UPDATE_NEW_ARRIVALS_FAILURE, 'UPDATE_NEW_ARRIVALS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(GRAB_MOBILE_USER_ID, 'GRAB_MOBILE_USER_ID', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_USERNAME, 'REQUEST_USERNAME', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_USERNAME_SUCCESS, 'REQUEST_USERNAME_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_USERNAME_FAILURE, 'REQUEST_USERNAME_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_USERNAME_DATA, 'CLEAR_USERNAME_DATA', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CHOOSE_CATEGORY, 'CHOOSE_CATEGORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_BILLBOARD_IMAGES, 'FETCH_BILLBOARD_IMAGES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_BILLBOARD_IMAGES_SUCCESS, 'FETCH_BILLBOARD_IMAGES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_BILLBOARD_IMAGES_FAILURE, 'FETCH_BILLBOARD_IMAGES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_BILLBOARD_IMAGES, 'SAVE_BILLBOARD_IMAGES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_BILLBOARD_IMAGES_SUCCESS, 'SAVE_BILLBOARD_IMAGES_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_BILLBOARD_IMAGES_FAILURE, 'SAVE_BILLBOARD_IMAGES_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_BILLBOARD_IMAGE, 'DELETE_BILLBOARD_IMAGE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_BILLBOARD_IMAGE_SUCCESS, 'DELETE_BILLBOARD_IMAGE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_BILLBOARD_IMAGE_FAILURE, 'DELETE_BILLBOARD_IMAGE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CUSTOMER_SEARCH, 'REQUEST_CUSTOMER_SEARCH', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CUSTOMER_SEARCH_SUCCESS, 'CUSTOMER_SEARCH_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RETURN_SEARCH_SUCCESS, 'RETURN_SEARCH_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CUSTOMER_SEARCH_FAILURE, 'CUSTOMER_SEARCH_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CUSTOMER_CREATE_RETURN, 'REQUEST_CUSTOMER_CREATE_RETURN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CUSTOMER_CREATE_RETURN_SUCCESS, 'CUSTOMER_CREATE_RETURN_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CUSTOMER_CREATE_RETURN_FAILURE, 'CUSTOMER_CREATE_RETURN_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CUSTOMER_EDIT_RETURN, 'REQUEST_CUSTOMER_EDIT_RETURN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CUSTOMER_EDIT_RETURN_SUCCESS, 'CUSTOMER_EDIT_RETURN_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(CUSTOMER_EDIT_RETURN_FAILURE, 'CUSTOMER_EDIT_RETURN_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DISPATCH_EDIT_RETURN, 'REQUEST_DISPATCH_EDIT_RETURN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DISPATCH_EDIT_RETURN_SUCCESS, 'DISPATCH_EDIT_RETURN_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DISPATCH_EDIT_RETURN_FAILURE, 'DISPATCH_EDIT_RETURN_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DISPATCH_SEARCH, 'REQUEST_DISPATCH_SEARCH', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DISPATCH_SEARCH_SUCCESS, 'DISPATCH_SEARCH_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(DISPATCH_SEARCH_FAILURE, 'DISPATCH_SEARCH_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SET_RETURNS_FILTER, 'SET_RETURNS_FILTER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_RETURN, 'RESET_CURRENT_RETURN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_FORM, 'RESET_CURRENT_FORM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_CUSTOMERS, 'FETCH_CUSTOMERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_REASONS, 'REQUEST_REASONS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_REASONS_SUCCESS, 'REQUEST_REASONS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_REASONS_FAILURE, 'REQUEST_REASONS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(START_REASON_CREATION, 'START_REASON_CREATION', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REASON_CREATION_SUCCESS, 'REASON_CREATION_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REASON_CREATION_FAILURE, 'REASON_CREATION_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(START_REASON_EDITING, 'START_REASON_EDITING', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REASON_EDITING_SUCCESS, 'REASON_EDITING_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REASON_EDITING_FAILURE, 'REASON_EDITING_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DELETE_REASON, 'REQUEST_DELETE_REASON', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REASON_DELETE_SUCCESS, 'REASON_DELETE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REASON_DELETE_FAILURE, 'REASON_DELETE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_REASON, 'SELECT_REASON', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(RESET_CURRENT_REASON, 'RESET_CURRENT_REASON', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_ADJUSTMENT_LOGS, 'REQUEST_ADJUSTMENT_LOGS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ADJUSTMENT_LOG_SUCCESS, 'ADJUSTMENT_LOG_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ADJUSTMENT_LOG_FAILURE, 'ADJUSTMENT_LOG_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_ACTION_LOG_BY_FILTER, 'REQUEST_ACTION_LOG_BY_FILTER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ACTION_LOG_FILTER_SUCCESS, 'ACTION_LOG_FILTER_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(ACTION_LOG_FILTER_FAILURE, 'ACTION_LOG_FILTER_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SET_SELECTED_BUSINESSUSER, 'SET_SELECTED_BUSINESSUSER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_MMDRIVER, 'FETCH_MMDRIVER', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_MMDRIVERS, 'FETCH_MMDRIVERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_ROUTES_PRINTER_SUCESS, 'FETCH_ROUTES_PRINTER_SUCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_ROUTES_PRINTER_SUCESS, 'SAVE_ROUTES_PRINTER_SUCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SET_AUTO_ROUTING_BUTTONS_LOADING, 'SET_AUTO_ROUTING_BUTTONS_LOADING', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SET_CONFIRM_PASSCODE_MODAL_VISIBILITY, 'SET_CONFIRM_PASSCODE_MODAL_VISIBILITY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(SET_PASSCODE_VERFICATION, 'SET_PASSCODE_VERFICATION', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_TRACKING_SUCCESS, 'FETCH_TRACKING_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_TRACKING_SUCCESS, 'EDIT_TRACKING_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_INITIALIZE_ESL, 'REQUEST_INITIALIZE_ESL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_DELETE_ESL, 'REQUEST_DELETE_ESL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_FETCH_ESL_TEMPLATE, 'REQUEST_FETCH_ESL_TEMPLATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SAVE_ESL, 'REQUEST_SAVE_ESL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_FETCH_ESL, 'REQUEST_FETCH_ESL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(MERGE_PURCHASE_ORDERS_LOADING, 'MERGE_PURCHASE_ORDERS_LOADING', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(MERGE_PURCHASE_ORDERS_SUCCESS, 'MERGE_PURCHASE_ORDERS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(MERGE_PURCHASE_ORDERS_ERROR, 'MERGE_PURCHASE_ORDERS_ERROR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PRE_ORDERS, 'REQUEST_PRE_ORDERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRE_ORDERS_SUCCESS, 'FETCH_PRE_ORDERS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRE_ORDERS_FAILURE, 'FETCH_PRE_ORDERS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SHIP_TO_ORDERS, 'REQUEST_SHIP_TO_ORDERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SHIP_TO_ORDERS_SUCCESS, 'FETCH_SHIP_TO_ORDERS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SHIP_TO_ORDERS_FAILURE, 'FETCH_SHIP_TO_ORDERS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SHIP_FROM_ORDERS, 'REQUEST_SHIP_FROM_ORDERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SHIP_FROM_ORDERS_SUCCESS, 'FETCH_SHIP_FROM_ORDERS_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SHIP_FROM_ORDERS_FAILURE, 'FETCH_SHIP_FROM_ORDERS_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_OTHER_SERVICE, 'REQUEST_OTHER_SERVICE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_OTHER_SERVICE_SUCCESS, 'FETCH_OTHER_SERVICE_SUCCESS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_OTHER_SERVICE_FAILURE, 'FETCH_OTHER_SERVICE_FAILURE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/type.js');
	}();

	;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1783);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ControllabledStateInputField = exports.DisabledInputField = exports.ControlledInputField = exports.PasswordInputField = exports.InputField = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(61);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEcity = _root_url.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://ctstage-scm.truckxi.com/api/';
	
	var InputField = exports.InputField = function (_Component) {
	  _inherits(InputField, _Component);
	
	  function InputField() {
	    _classCallCheck(this, InputField);
	
	    return _possibleConstructorReturn(this, (InputField.__proto__ || Object.getPrototypeOf(InputField)).apply(this, arguments));
	  }
	
	  _createClass(InputField, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          input = _props.input,
	          onFocus = _props.onFocus,
	          className = _props.className,
	          _props$meta = _props.meta,
	          touched = _props$meta.touched,
	          error = _props$meta.error;
	
	      if (this.props.decimal) {
	        var decimal = parseInt(this.props.decimal);
	        input.value = (parseFloat(input.value) || 0).toFixed(decimal);
	      }
	      var inputClass = (0, _classnames2.default)({ 'parsley-error': touched && error }, 'form-control', className);
	      if (onFocus != null) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          touched && error && _react2.default.createElement(
	            'span',
	            { className: 'parsley-error-message' },
	            error
	          ),
	          this.props.onChange ? _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { disabled: this.props.disabled, style: this.props.style, standalone: true, type: this.props.type || 'text', maxLength: this.props.maxLength, onChange: this.props.onChange, value: this.props.value || this.props.input.value, className: inputClass, ref: function ref(input) {
	              _this2.myInput = input;
	            }, onKeyPress: this.props.onKeyPress, placeholder: this.props.placeholder, onFocus: onFocus })) : _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { disabled: this.props.disabled, style: this.props.style, maxLength: this.props.maxLength, className: inputClass, ref: function ref(input) {
	              _this2.myInput = input;
	            }, onKeyPress: this.props.onKeyPress, standalone: true, type: 'text', placeholder: this.props.placeholder, onFocus: onFocus }))
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        touched && error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          error
	        ),
	        this.props.onChange ? _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { disabled: this.props.disabled, style: this.props.style, standalone: true, type: this.props.type || 'text', maxLength: this.props.maxLength, onChange: this.props.onChange, value: this.props.value, className: inputClass, ref: function ref(input) {
	            _this2.myInput = input;
	          }, onKeyPress: this.props.onKeyPress, placeholder: this.props.placeholder })) : _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { disabled: this.props.disabled, style: this.props.style, maxLength: this.props.maxLength, className: inputClass, ref: function ref(input) {
	            _this2.myInput = input;
	          }, onKeyPress: this.props.onKeyPress, standalone: true, type: 'text', placeholder: this.props.placeholder }))
	      );
	    }
	  }]);
	
	  return InputField;
	}(_react.Component);
	
	var PasswordInputField = exports.PasswordInputField = function (_Component2) {
	  _inherits(PasswordInputField, _Component2);
	
	  function PasswordInputField() {
	    _classCallCheck(this, PasswordInputField);
	
	    return _possibleConstructorReturn(this, (PasswordInputField.__proto__ || Object.getPrototypeOf(PasswordInputField)).apply(this, arguments));
	  }
	
	  _createClass(PasswordInputField, [{
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          input = _props2.input,
	          onFocus = _props2.onFocus,
	          className = _props2.className,
	          _props2$meta = _props2.meta,
	          touched = _props2$meta.touched,
	          error = _props2$meta.error;
	
	      var inputClass = (0, _classnames2.default)({ 'parsley-error': touched && error }, 'form-control', className);
	      return _react2.default.createElement(
	        'div',
	        null,
	        touched && error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          error
	        ),
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { className: inputClass, ref: function ref(input) {
	            _this4.myInput = input;
	          }, onKeyPress: this.props.onKeyPress, standalone: true, type: 'password', placeholder: this.props.placeholder }))
	      );
	    }
	  }]);
	
	  return PasswordInputField;
	}(_react.Component);
	
	var ControlledInputField = exports.ControlledInputField = function (_Component3) {
	  _inherits(ControlledInputField, _Component3);
	
	  function ControlledInputField() {
	    _classCallCheck(this, ControlledInputField);
	
	    return _possibleConstructorReturn(this, (ControlledInputField.__proto__ || Object.getPrototypeOf(ControlledInputField)).apply(this, arguments));
	  }
	
	  _createClass(ControlledInputField, [{
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _props3 = this.props,
	          input = _props3.input,
	          onFocus = _props3.onFocus,
	          placeholder = _props3.placeholder,
	          className = _props3.className,
	          _props3$meta = _props3.meta,
	          touched = _props3$meta.touched,
	          error = _props3$meta.error;
	
	      if (this.props.decimal) {
	        var decimal = parseInt(this.props.decimal);
	        placeholder = (parseFloat(placeholder) || 0).toFixed(decimal);
	      }
	      var inputClass = (0, _classnames2.default)({ 'parsley-error': touched && error }, 'form-control', className);
	      if (onFocus != null) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          touched && error && _react2.default.createElement(
	            'span',
	            { className: 'parsley-error-message' },
	            error
	          ),
	          _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { className: inputClass, ref: function ref(input) {
	              _this6.myInput = input;
	            }, onKeyPress: this.props.onKeyPress, standalone: true, type: 'text', value: placeholder, onChange: this.props.onChange, onFocus: onFocus, disabled: this.props.disabled }))
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        touched && error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          error
	        ),
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { className: inputClass, ref: function ref(input) {
	            _this6.myInput = input;
	          }, onKeyPress: this.props.onKeyPress, standalone: true, type: 'text', value: placeholder, onChange: this.props.onChange }))
	      );
	    }
	  }]);
	
	  return ControlledInputField;
	}(_react.Component);
	
	var DisabledInputField = exports.DisabledInputField = function (_Component4) {
	  _inherits(DisabledInputField, _Component4);
	
	  function DisabledInputField() {
	    _classCallCheck(this, DisabledInputField);
	
	    return _possibleConstructorReturn(this, (DisabledInputField.__proto__ || Object.getPrototypeOf(DisabledInputField)).apply(this, arguments));
	  }
	
	  _createClass(DisabledInputField, [{
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          input = _props4.input,
	          className = _props4.className,
	          _props4$meta = _props4.meta,
	          touched = _props4$meta.touched,
	          error = _props4$meta.error;
	
	      var inputClass = (0, _classnames2.default)({ 'parsley-error': touched && error }, 'form-control', className);
	      if (this.props.placeholder || this.props.placeholder == '' || this.props.placeholder == 0) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          touched && error && _react2.default.createElement(
	            'span',
	            { className: 'parsley-error-message' },
	            error
	          ),
	          _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { className: inputClass, standalone: true, type: 'text', value: this.props.placeholder, disabled: true }))
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        touched && error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          error
	        ),
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { className: inputClass, standalone: true, type: 'text', disabled: true }))
	      );
	    }
	  }]);
	
	  return DisabledInputField;
	}(_react.Component);
	// let renderInputField = props => {
	//     const inputClass = classNames({ 'parsley-error': props.meta.touched && props.meta.error }, 'form-control')
	//     return (
	//         <div>
	//             {props.meta.touched && props.meta.error && <span className="parsley-error-message">{props.meta.error}</span>}
	//             <Input {...props.input} className={inputClass} type="text"/>
	//         </div>
	//     )
	// }
	
	var ControllabledStateInputField = exports.ControllabledStateInputField = function (_Component5) {
	  _inherits(ControllabledStateInputField, _Component5);
	
	  function ControllabledStateInputField() {
	    _classCallCheck(this, ControllabledStateInputField);
	
	    return _possibleConstructorReturn(this, (ControllabledStateInputField.__proto__ || Object.getPrototypeOf(ControllabledStateInputField)).apply(this, arguments));
	  }
	
	  _createClass(ControllabledStateInputField, [{
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      var _props5 = this.props,
	          input = _props5.input,
	          onFocus = _props5.onFocus,
	          className = _props5.className,
	          _props5$meta = _props5.meta,
	          touched = _props5$meta.touched,
	          error = _props5$meta.error;
	
	      var inputClass = (0, _classnames2.default)({ 'parsley-error': touched && error }, 'form-control', className);
	      var placeholder = '';
	      if (this.props.placeholder) {
	        placeholder = this.props.placeholder.slice(4, 7);
	      }
	
	      if (this.props.isDisabled) {
	        if (this.props.placeholder) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            touched && error && _react2.default.createElement(
	              'span',
	              { className: 'parsley-error-message' },
	              error
	            ),
	            _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { className: inputClass, standalone: true, type: 'text', value: this.props.placeholder, disabled: true }))
	          );
	        }
	        return _react2.default.createElement(
	          'div',
	          null,
	          touched && error && _react2.default.createElement(
	            'span',
	            { className: 'parsley-error-message' },
	            error
	          ),
	          _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { className: inputClass, standalone: true, type: 'text', disabled: true }))
	        );
	      }
	      if (onFocus != null) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          touched && error && _react2.default.createElement(
	            'span',
	            { className: 'parsley-error-message' },
	            error
	          ),
	          _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { className: inputClass, ref: function ref(input) {
	              _this9.myInput = input;
	            }, onKeyPress: this.props.onKeyPress, standalone: true, type: 'text', placeholder: placeholder, onFocus: onFocus }))
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        touched && error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          error
	        ),
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { className: inputClass, ref: function ref(input) {
	            _this9.myInput = input;
	          }, onKeyPress: this.props.onKeyPress, standalone: true, type: 'text', placeholder: placeholder }))
	      );
	    }
	  }]);
	
	  return ControllabledStateInputField;
	}(_react.Component);
	
	var _default = InputField;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(InputField, 'InputField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/inputField.jsx');
	
	  __REACT_HOT_LOADER__.register(PasswordInputField, 'PasswordInputField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/inputField.jsx');
	
	  __REACT_HOT_LOADER__.register(ControlledInputField, 'ControlledInputField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/inputField.jsx');
	
	  __REACT_HOT_LOADER__.register(DisabledInputField, 'DisabledInputField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/inputField.jsx');
	
	  __REACT_HOT_LOADER__.register(ControllabledStateInputField, 'ControllabledStateInputField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/inputField.jsx');
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/inputField.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/inputField.jsx');
	}();

	;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports = vendor;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(17);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1392);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.USER_PRODUCTS_URL = exports.USER_PUT_NOTE_URL = exports.USER_QUERY_NOTE_URL = exports.USER_QUERY_CREDIT_URL = exports.USER_PUT_CREDIT_URL = exports.SALE_PRE_ORDER_SEARCH_URL = exports.SALE_STWH_ORDER_SEARCH_URL = exports.SALE_OTHER_SERVICE_SEARCH_URL = exports.SALE_SHIP_ORDER_SEARCH_URL = exports.VitAppointmentListOrders_URL = exports.MAG_DRAYAGE_LIST = exports.SO_TO_PO_DAVIS_URL = exports.APPROVE_PENDING_PO_URL = exports.SET_QUOTE_URL = exports.MERGE_PURCHASE_ORDERS_API = exports.CARRIER_INFO_URL = exports.PRINT_SHIPPING_LABEL_URL = exports.FETCH_JML_TRACKING_NUMBER_URL = exports.SP_PDF_URL = exports.OVERSEA_PRINT_BOL_LABEL_URL = exports.OVERSEA_PRINT_BOL_WITHOUT_LOG_URL = exports.OVERSEA_ADDRESS_URL = exports.OVERSEA_PRINT_BOL_URL = exports.OVERSEA_DELETE_BOL_IMAGE_URL = exports.OVERSEA_UPLOAD_BOL_IMAGE_URL = exports.OVERSEA_URL = exports.USPRIDE_REPRINT_SO_USPRIDE = exports.USPRIDE_PRINT_SO_USPRIDE = exports.ABCFF_IMPORT = exports.USPRIDE_IMPORT = exports.CHOWBUS_IMPORT = exports.ESL_SAVE = exports.ESL_GET_TEMPLATE = exports.ESL_DELETE = exports.ESL_INITIALIZE = exports.PAYMENT_METHOD_CHANGE_URL = exports.TRACKING_NOTE_URL = exports.BUSINESS_USER_CONVERT = exports.BUSINESS_USERS_URL = exports.USERNAME_URL = exports.ROUTES_PRINTER_TIME = exports.verifyPasscode = exports.MMDRIVERS = exports.ACTION_LOG_FILTER_URL = undefined;
	exports.QUOTE_TO_ORDER_URL = exports.ADJUSTMENT_INVENTORY_URL = exports.SALES_INVOICE_PRINT_NOSUBTOTAL_URL = exports.PURCHASE_ORDER_PRINT_NOSUBTOTAL_URL = exports.BD_RMA_URL = exports.AP_PRINT_URL = exports.AR_PRINT_PLAIN_URL = exports.AR_PRINT_URL = exports.PO_RECEIVE_LINE_PRINT_LABEL_URL = exports.WAREHOUSE_RECEIVE_LINE_PRINT_LABEL_URL = exports.WAREHOUSE_RECEIVE_PRINT_URL = exports.SALES_INVOICE_RETURN_PRINT_NOSUBTOTAL_URL = exports.SALES_INVOICE_RETURN_PRINT_URL = exports.SALES_INVOICE_PRINT_URL = exports.SO_PRINT_SALES_INVOICE_URL = exports.PURCHASE_ORDER_PRINT_URL = exports.PATCH_INVOICE_EMPLOYEE_NOTE_URL = exports.PATCH_SALES_VOID_NOTE_URL = exports.PATCH_SALES_EMPLOYEE_NOTE_URL = exports.FETCH_SALES_ORDER_WEIGHT_TRACKING = exports.PATCH_SALES_ORDER_WEIGHT_MULTI_URL = exports.PATCH_SALES_ORDER_WEIGHT_URL = exports.PURCHASE_ORDER_SUGGESTION_URL = exports.SALES_ORDER_SUGGESTION_URL = exports.PURCHASE_ORDER_PRODUCT_BY_ID_URL = exports.SALES_ORDER_PRODUCT_BY_ID_URL = exports.SALES_ORDER_RESHIP_URL = exports.SALES_ORDER_LABEL_PRINT_URL_BATCH = exports.WIZ_PRINT_BOL = exports.SALES_ORDER_LABEL_PRINT_URL = exports.SALES_ORDER_PRINT_URL = exports.REFUND_SUMMARY_URL = exports.SEND_PACKING_LIST_URL = exports.PACKING_LIST_URL = exports.PICKING_LIST_URL = exports.YING_CUSTOMER_FILE = exports.YING_BOL_URL = exports.RECEIVING_REPORT_URL = exports.SHIPPING_LIST_URL = exports.VERIFY_URL = exports.REGISTER_URL = exports.SESSION_URL = exports.CHANGE_STRIPE_URL = exports.DELETE_USER_URL = exports.MESSAGE_DASHBOARD_URL = exports.FETCH_SALES_ORDER_FORM_URL = exports.RESET_EMAIL_URL = exports.RESET_PASSWORD_URL = exports.BASE_USER_URL = exports.PRODUCT_RECEIVE_HISTORY = exports.POS_REPORT_URL = exports.UPLOAD_URL = exports.AP_URL = exports.AR_URL = exports.CURRENCY_RATES_URL = exports.TAX_RATES_URL = exports.SALES_LOADSPOST_URL = exports.SALES_RETURN_URL = exports.REQUEST_SALES_INVOICE_FORM_URL = exports.DISPATCH_DELIVERY_FEE_URL = exports.WAREHOUSE_BY_COMPANY_URL = exports.COMPANY_URL = exports.DISPATCH_URL = exports.SALES_ORDER_LINE_WEIGHTS_URL = exports.DELIVER_INVOICE_URL = exports.FINALIZE_INVOICE_URL = exports.FINALIZED_INVOICES_URL = exports.INVENTORY_SALES_ORDER_HISTORY_URL = exports.WHOLESALE_BATCH_LOG_URL = exports.ADJUSTMENT_INVENTORY_BATCH_URL = exports.INVENTORY_BATCH_URL = exports.WHOLESALE_BATCH_URL = exports.WHOLESALE_URL = exports.CUSTOMER_FAVORITE_LIST = exports.SALES_ISSUE_CREDIT_URL = exports.PURCHASES_VENDOR_URL = exports.SHIPPING_URL = exports.SALES_CUSTOMER_URL = exports.SALES_INVENTORY_INFO_URL = exports.SALES_INVOICE_VOID_URL = exports.SALES_INVOICE_UPDATE_URL = exports.EDIT_SI_CUSTOMER_URL = exports.SALES_INVOICE_PAYMENT_URL = exports.SALES_INVOICE_COMPLETED_URL = exports.MOBILE_SALES_ORDER_SHIPPINGINFO_URL = exports.SALES_ORDER_DROPDHIP_URL = exports.UNPAID_SALES_INVOICE_URL = exports.SALES_INVOICE_NUM_URL = exports.SALES_INVOICE_URL = exports.FETCH_SALES_INVOICES_BY_TYPE_URL = exports.FETCH_INVOICE_DETAIL_URL = exports.RELEASE_SALES_ORDER_URL = exports.CUSTOMER_CREDIT_LINES_URL = exports.CUSTOMERS_WITH_FAVORITES_URL = exports.CUSTOMER_SALES_HISTORY = exports.POS_HOLDS_PRINT = exports.POS_HOLDS_VOID = exports.POS_HOLDS_URL = exports.POS_CREDIT_URL = exports.POS_CREDITS_URL = undefined;
	exports.POS_SALE_URL = exports.POS_ORDERS_URL = exports.SALES_DASHBOARD_URL = exports.MOBILE_SALES_ORDERS_URL_v2 = exports.MOBILE_SALES_ORDERS_URL = exports.SALES_ORDERS_REFUND = exports.SALES_QUOTE_URL = exports.CHANGE_OB_STATUS_URL = exports.GET_PICKUP_URL = exports.GET_QUOTE_URL = exports.ADD_TRACKING_URL = exports.PRINT_BOL_URL = exports.ASSIGN_BOL_URL = exports.RESYNC_URL = exports.CHANGE_TRACKING_URL = exports.SALES_ORDERS_URL = exports.USER_PRODUCT_GROUPS_URL = exports.USER_PERFORMANCE_URL = exports.SALES_PERFORMANCE_URL = exports.PROMO_NOTES_URL = exports.PROMOTIONS_URL = exports.PREVIOUSORDERS_URL = exports.CUSTOMER_GROUPS_URL = exports.FAVORITES_URL = exports.ITEM_HISTORY_URL = exports.PUT_AWAY_URL = exports.RECEIVE_URL = exports.BINS_URL = exports.ZONES_URL = exports.WAREHOUSES_URL = exports.INVENTORY_SCRAP_URL = exports.SCRAP_RECORDS_URL = exports.INVENTORY_CONVERTS_URL = exports.QUICK_INVENTORY_ADJUSTMENTS_URL = exports.INVENTORY_ADJUSTMENTS_URL = exports.INVENTORY_REPACKAGES_URL = exports.INVENTORY_RELOCATIONS_URL = exports.COMPLETE_OB = exports.EMAIL_POD = exports.EMAIL_UPDATE = exports.INVENTORY_HISTORY_URL = exports.INVENTORY_URL = exports.INBOUND_PRODUCTS_URL = exports.FREQUENT_ITEMS_URL = exports.SALES_ORDER_INVENTORY_URL = exports.DETAILED_INVENTORIES_URL = exports.INVENTORIES_URL = exports.CONSOLODATED_STATISTICS_URL = exports.SALES_LEVELS_URL = exports.OVERALL_SALES_PERFORMANCE_URL = exports.OVERALL_PURCHASE_PERFORMANCE_URL = exports.PURCHASE_TOTALS_URL = exports.LAST_MONTH_PERFORMANCE_URL = exports.PURCHASE_MANAGER_INFO_URL = exports.PURCHASE_ORDER_PERFORMANCE_URL = exports.DASHBOARD_URL = exports.TOTAL_PURCHASES_URL = exports.PURCHASE_ORDERS_NOT_RECEIVED_URL = exports.NUM_PURCHASE_QUOTES_URL = exports.PRESIDENT_DASH_INFO_URL = exports.INCIDENT_REPORT_URL = exports.PURCHASE_URL_2 = exports.PURCHASE_URL = exports.PURCHASE_ORDER_COMPLETE_URL = exports.PURCHASE_ORDERS_URL = exports.PURCHASE_RETURNS_NO_SUBTOTALS = exports.PURCHASE_RETURNS_URL = exports.PURCHASE_SCHEDULES_URL = exports.PURCHASE_TEMPLATES_URL = exports.PURCHASE_QUOTES_URL = exports.INCOMING_ORDERS_BY_DATE_URL = exports.OUTGOING_ORDERS_BY_DATE_URL = exports.FETCH_PRICE_TABLE_URL_VENDOR = exports.FETCH_PRICE_TABLE_URL = exports.ACH_EDIT_URL = exports.FETCH_FJ_CARRIERS_URL = exports.FETCH_FBA_ADDRESS_URL = exports.FETCH_FJ_AGENTS_URL = exports.DISPLAY_CATEGORIES_URL = exports.VENDOR_INVENTORY_URL = exports.OUTSTANDING_VENDOR_URL = exports.VENDOR_URL = exports.PAYMENT_URL = exports.AGENT_URL = exports.CUSTOMERS_STATUS_URL = exports.CUSTOMERS_PAGINATE_URL = exports.CUSTOMERS_URL = exports.TYPES_URL = exports.PRICELEVELS_URL = exports.CATEGORIES_2_B2B_URL = exports.CATEGORIES_2_URL = exports.CATEGORIES_URL = exports.GROUPS_ELEGANT_URL = exports.GROUPS_URL = exports.PRODUCTS_SIMPLIFIED_URL = exports.PRODUCTS_URL = exports.SALES_ORDER_FORM_BACHES = exports.PERMISSION_URL = exports.TRUCKXI_TEST_URL = exports.TRUCKXI_LOGIN_URL = undefined;
	
	var _root_url = __webpack_require__(9);
	
	// export const TRUCKXI_LOGIN_URL = ROOT_URL + 'api-token-auth/';
	// export const TRUCKXI_LOGIN_URL = 'https://afg-oauth.truckxi.com/o/token/';
	// export const TRUCKXI_LOGIN_URL = 'https://no-oauth.truckxi.com/o/token/';
	// export const TRUCKXI_LOGIN_URL = 'https://oauth.truckxi.com/o/token/';
	var TRUCKXI_LOGIN_URL = exports.TRUCKXI_LOGIN_URL = 'https://wecom-scm.truckxi.com/o/token/';
	// export const TRUCKXI_LOGIN_URL = 'https://okc-oauth.truckxi.com/o/token/';
	// export const TRUCKXI_LOGIN_URL = 'https://stageauth.truckxi.com/o/token/';
	var TRUCKXI_TEST_URL = exports.TRUCKXI_TEST_URL = _root_url.ROOT_URL + 'verify/test/';
	var PERMISSION_URL = exports.PERMISSION_URL = _root_url.ROOT_URL + 'v1/baseuser/userpermissions/';
	
	var SALES_ORDER_FORM_BACHES = exports.SALES_ORDER_FORM_BACHES = _root_url.ROOT_URL + 'v2/inventory/';
	var PRODUCTS_URL = exports.PRODUCTS_URL = _root_url.ROOT_URL + 'v1/product/';
	var PRODUCTS_SIMPLIFIED_URL = exports.PRODUCTS_SIMPLIFIED_URL = _root_url.ROOT_URL + 'v1/product/simplified/';
	var GROUPS_URL = exports.GROUPS_URL = _root_url.ROOT_URL + 'v1/product/group/';
	var GROUPS_ELEGANT_URL = exports.GROUPS_ELEGANT_URL = _root_url.ROOT_URL + 'v1/product/group_elegant/';
	var CATEGORIES_URL = exports.CATEGORIES_URL = _root_url.ROOT_URL + 'v1/product/category/';
	var CATEGORIES_2_URL = exports.CATEGORIES_2_URL = _root_url.ROOT_URL + 'v1/product/category2/';
	var CATEGORIES_2_B2B_URL = exports.CATEGORIES_2_B2B_URL = _root_url.ROOT_URL + 'v1/product/category2_b2b/';
	var PRICELEVELS_URL = exports.PRICELEVELS_URL = _root_url.ROOT_URL + 'v1/product/pricelevel/';
	var TYPES_URL = exports.TYPES_URL = _root_url.ROOT_URL + 'v1/product/type/';
	var CUSTOMERS_URL = exports.CUSTOMERS_URL = _root_url.ROOT_URL + 'v1/customer/';
	var CUSTOMERS_PAGINATE_URL = exports.CUSTOMERS_PAGINATE_URL = _root_url.ROOT_URL + 'v1/customer/paginator';
	var CUSTOMERS_STATUS_URL = exports.CUSTOMERS_STATUS_URL = _root_url.ROOT_URL + 'v1/dashboard/outstanding/customer/';
	var AGENT_URL = exports.AGENT_URL = _root_url.ROOT_URL + 'v1/agent/';
	var PAYMENT_URL = exports.PAYMENT_URL = _root_url.ROOT_URL + 'v1/payment/';
	var VENDOR_URL = exports.VENDOR_URL = _root_url.ROOT_URL + 'v1/vendor/';
	var OUTSTANDING_VENDOR_URL = exports.OUTSTANDING_VENDOR_URL = _root_url.ROOT_URL + 'v1/dashboard/outstanding/vendor/';
	var VENDOR_INVENTORY_URL = exports.VENDOR_INVENTORY_URL = _root_url.ROOT_URL + 'v1/inventory/vendor/';
	var DISPLAY_CATEGORIES_URL = exports.DISPLAY_CATEGORIES_URL = _root_url.ROOT_URL + 'v1/product/product_display_category/';
	var FETCH_FJ_AGENTS_URL = exports.FETCH_FJ_AGENTS_URL = _root_url.ROOT_URL + 'v1/customer/agents/';
	var FETCH_FBA_ADDRESS_URL = exports.FETCH_FBA_ADDRESS_URL = _root_url.ROOT_URL + 'v1/sale/order-address';
	var FETCH_FJ_CARRIERS_URL = exports.FETCH_FJ_CARRIERS_URL = _root_url.ROOT_URL + 'v2/sales/order-carriers';
	
	var ACH_EDIT_URL = exports.ACH_EDIT_URL = _root_url.ROOT_URL + 'v1/customer/bank_account/';
	
	var FETCH_PRICE_TABLE_URL = exports.FETCH_PRICE_TABLE_URL = _root_url.ROOT_URL + 'v1/customer/prices/';
	var FETCH_PRICE_TABLE_URL_VENDOR = exports.FETCH_PRICE_TABLE_URL_VENDOR = _root_url.ROOT_URL + 'v1/vendor/prices/';
	
	var OUTGOING_ORDERS_BY_DATE_URL = exports.OUTGOING_ORDERS_BY_DATE_URL = _root_url.ROOT_URL + 'v1/dashboard/warehouse/sales/';
	var INCOMING_ORDERS_BY_DATE_URL = exports.INCOMING_ORDERS_BY_DATE_URL = _root_url.ROOT_URL + 'v1/dashboard/warehouse/purchase/';
	var PURCHASE_QUOTES_URL = exports.PURCHASE_QUOTES_URL = _root_url.ROOT_URL + 'v1/purchase/quote/';
	var PURCHASE_TEMPLATES_URL = exports.PURCHASE_TEMPLATES_URL = _root_url.ROOT_URL + 'v1/purchase/template/';
	var PURCHASE_SCHEDULES_URL = exports.PURCHASE_SCHEDULES_URL = _root_url.ROOT_URL + 'v1/purchase/schedule/';
	var PURCHASE_RETURNS_URL = exports.PURCHASE_RETURNS_URL = _root_url.ROOT_URL + 'v1/purchase/return/';
	var PURCHASE_RETURNS_NO_SUBTOTALS = exports.PURCHASE_RETURNS_NO_SUBTOTALS = _root_url.ROOT_URL + 'v1/purchase/return_no_price/print/';
	var PURCHASE_ORDERS_URL = exports.PURCHASE_ORDERS_URL = _root_url.ROOT_URL + 'v1/purchase/order/';
	var PURCHASE_ORDER_COMPLETE_URL = exports.PURCHASE_ORDER_COMPLETE_URL = _root_url.ROOT_URL + 'v1/purchase/completed/';
	var PURCHASE_URL = exports.PURCHASE_URL = _root_url.ROOT_URL + 'v1/purchase/';
	var PURCHASE_URL_2 = exports.PURCHASE_URL_2 = _root_url.ROOT_URL + 'v1/product/byid/5/';
	var INCIDENT_REPORT_URL = exports.INCIDENT_REPORT_URL = _root_url.ROOT_URL + 'v1/dashboard/incidents/';
	var PRESIDENT_DASH_INFO_URL = exports.PRESIDENT_DASH_INFO_URL = _root_url.ROOT_URL + 'v1/dashboard/president/';
	var NUM_PURCHASE_QUOTES_URL = exports.NUM_PURCHASE_QUOTES_URL = _root_url.ROOT_URL + 'v1/dashboard/quotenum/';
	var PURCHASE_ORDERS_NOT_RECEIVED_URL = exports.PURCHASE_ORDERS_NOT_RECEIVED_URL = _root_url.ROOT_URL + 'v1/dashboard/notreceivednum/';
	var TOTAL_PURCHASES_URL = exports.TOTAL_PURCHASES_URL = _root_url.ROOT_URL + 'v1/dashboard/totalnum/';
	var DASHBOARD_URL = exports.DASHBOARD_URL = _root_url.ROOT_URL + 'v1/dashboard/';
	var PURCHASE_ORDER_PERFORMANCE_URL = exports.PURCHASE_ORDER_PERFORMANCE_URL = _root_url.ROOT_URL + 'v1/dashboard/orders/month/';
	var PURCHASE_MANAGER_INFO_URL = exports.PURCHASE_MANAGER_INFO_URL = _root_url.ROOT_URL + 'v1/dashboard/purchasemanager/';
	var LAST_MONTH_PERFORMANCE_URL = exports.LAST_MONTH_PERFORMANCE_URL = _root_url.ROOT_URL + 'v1/dashboard/orders/month/';
	var PURCHASE_TOTALS_URL = exports.PURCHASE_TOTALS_URL = _root_url.ROOT_URL + 'v1/dashboard/totalpurchases/';
	var OVERALL_PURCHASE_PERFORMANCE_URL = exports.OVERALL_PURCHASE_PERFORMANCE_URL = _root_url.ROOT_URL + 'v1/dashboard/totalpurchases/';
	var OVERALL_SALES_PERFORMANCE_URL = exports.OVERALL_SALES_PERFORMANCE_URL = _root_url.ROOT_URL + 'v1/dashboard/totalsales/';
	var SALES_LEVELS_URL = exports.SALES_LEVELS_URL = _root_url.ROOT_URL + 'v1/dashboard/salesdashboard/';
	var CONSOLODATED_STATISTICS_URL = exports.CONSOLODATED_STATISTICS_URL = _root_url.ROOT_URL + 'v1/dashboard/consolidated_statistics/';
	var INVENTORIES_URL = exports.INVENTORIES_URL = _root_url.ROOT_URL + 'v1/inventory/simplified/';
	var DETAILED_INVENTORIES_URL = exports.DETAILED_INVENTORIES_URL = _root_url.ROOT_URL + 'v1/inventory/detailed/';
	var SALES_ORDER_INVENTORY_URL = exports.SALES_ORDER_INVENTORY_URL = _root_url.ROOT_URL + 'v1/inventory/sales_order/';
	var FREQUENT_ITEMS_URL = exports.FREQUENT_ITEMS_URL = _root_url.ROOT_URL + 'v1/sale/frequent/';
	var INBOUND_PRODUCTS_URL = exports.INBOUND_PRODUCTS_URL = _root_url.ROOT_URL + 'v2/sales/inbound-order-products';
	var INVENTORY_URL = exports.INVENTORY_URL = _root_url.ROOT_URL + 'v1/inventory/';
	var INVENTORY_HISTORY_URL = exports.INVENTORY_HISTORY_URL = _root_url.ROOT_URL + 'v1/inventory/history/';
	var EMAIL_UPDATE = exports.EMAIL_UPDATE = _root_url.ROOT_URL + 'v2/move/email_update/';
	var EMAIL_POD = exports.EMAIL_POD = _root_url.ROOT_URL + 'v2/move/email_pod/';
	var COMPLETE_OB = exports.COMPLETE_OB = _root_url.ROOT_URL + 'v1/sale/complete_outbound/';
	
	var INVENTORY_RELOCATIONS_URL = exports.INVENTORY_RELOCATIONS_URL = _root_url.ROOT_URL + 'v1/warehouse/relocation/';
	var INVENTORY_REPACKAGES_URL = exports.INVENTORY_REPACKAGES_URL = _root_url.ROOT_URL + 'v1/warehouse/repackage/';
	var INVENTORY_ADJUSTMENTS_URL = exports.INVENTORY_ADJUSTMENTS_URL = _root_url.ROOT_URL + 'v1/warehouse/adjustment/';
	var QUICK_INVENTORY_ADJUSTMENTS_URL = exports.QUICK_INVENTORY_ADJUSTMENTS_URL = _root_url.ROOT_URL + 'v1/warehouse/quick/adjustment/';
	var INVENTORY_CONVERTS_URL = exports.INVENTORY_CONVERTS_URL = _root_url.ROOT_URL + 'v1/warehouse/convert/';
	var SCRAP_RECORDS_URL = exports.SCRAP_RECORDS_URL = _root_url.ROOT_URL + 'v1/warehouse/scrap/';
	var INVENTORY_SCRAP_URL = exports.INVENTORY_SCRAP_URL = _root_url.ROOT_URL + 'v1/inventory/bin/';
	var WAREHOUSES_URL = exports.WAREHOUSES_URL = _root_url.ROOT_URL + 'v1/warehouse/';
	var ZONES_URL = exports.ZONES_URL = _root_url.ROOT_URL + 'v1/warehouse/zone/';
	var BINS_URL = exports.BINS_URL = _root_url.ROOT_URL + 'v1/warehouse/bin/';
	var RECEIVE_URL = exports.RECEIVE_URL = _root_url.ROOT_URL + 'v1/warehouse/receive/';
	var PUT_AWAY_URL = exports.PUT_AWAY_URL = _root_url.ROOT_URL + 'v1/warehouse/receive/putaway/';
	var ITEM_HISTORY_URL = exports.ITEM_HISTORY_URL = _root_url.ROOT_URL + 'v1/sale/sales_order/history/';
	
	var FAVORITES_URL = exports.FAVORITES_URL = _root_url.ROOT_URL + 'v1/product/inventoryproduct/';
	var CUSTOMER_GROUPS_URL = exports.CUSTOMER_GROUPS_URL = _root_url.ROOT_URL + 'v1/customer/group/';
	var PREVIOUSORDERS_URL = exports.PREVIOUSORDERS_URL = _root_url.ROOT_URL + 'v1/sale/sales_order/previous/';
	var PROMOTIONS_URL = exports.PROMOTIONS_URL = _root_url.ROOT_URL + 'v1/sale/promotion/';
	var PROMO_NOTES_URL = exports.PROMO_NOTES_URL = _root_url.ROOT_URL + 'v1/sale/notes/';
	var SALES_PERFORMANCE_URL = exports.SALES_PERFORMANCE_URL = _root_url.ROOT_URL + 'v1/sale/performance/';
	var USER_PERFORMANCE_URL = exports.USER_PERFORMANCE_URL = _root_url.ROOT_URL + 'v1/sale/userperformance/';
	var USER_PRODUCT_GROUPS_URL = exports.USER_PRODUCT_GROUPS_URL = _root_url.ROOT_URL + 'v1/product/group_all/';
	
	var SALES_ORDERS_URL = exports.SALES_ORDERS_URL = _root_url.ROOT_URL + 'v1/sale/sales_order/';
	var CHANGE_TRACKING_URL = exports.CHANGE_TRACKING_URL = _root_url.ROOT_URL + 'v1/sale/update_sales_order/';
	
	var RESYNC_URL = exports.RESYNC_URL = _root_url.ROOT_URL + 'v1/shopify/order_resync/';
	
	var ASSIGN_BOL_URL = exports.ASSIGN_BOL_URL = _root_url.ROOT_URL + 'v2/sale/assign_bol/';
	var PRINT_BOL_URL = exports.PRINT_BOL_URL = _root_url.ROOT_URL + 'v2/sale/print_bol/';
	var ADD_TRACKING_URL = exports.ADD_TRACKING_URL = _root_url.ROOT_URL + 'v2/sale/add_tracking/';
	
	var GET_QUOTE_URL = exports.GET_QUOTE_URL = _root_url.ROOT_URL + 'v2/sale/shipping/xpo_quote/';
	var GET_PICKUP_URL = exports.GET_PICKUP_URL = _root_url.ROOT_URL + 'v2/sale/shipping/xpo_pickup/';
	
	var CHANGE_OB_STATUS_URL = exports.CHANGE_OB_STATUS_URL = _root_url.ROOT_URL + 'v2/sale/change_ob_status/';
	
	var SALES_QUOTE_URL = exports.SALES_QUOTE_URL = _root_url.ROOT_URL + 'v1/sale/sales_quote/';
	var SALES_ORDERS_REFUND = exports.SALES_ORDERS_REFUND = _root_url.ROOT_URL + 'v1/sale/sales_order/';
	var MOBILE_SALES_ORDERS_URL = exports.MOBILE_SALES_ORDERS_URL = _root_url.ROOT_URL + 'v1/sale/sales_mobile_order/';
	var MOBILE_SALES_ORDERS_URL_v2 = exports.MOBILE_SALES_ORDERS_URL_v2 = _root_url.ROOT_URL + 'v1/sale/sales_mobile_order_v2/';
	var SALES_DASHBOARD_URL = exports.SALES_DASHBOARD_URL = _root_url.ROOT_URL + 'v1/dispatch/stop/';
	var POS_ORDERS_URL = exports.POS_ORDERS_URL = _root_url.ROOT_URL + 'v1/pos/orders/';
	var POS_SALE_URL = exports.POS_SALE_URL = _root_url.ROOT_URL + 'v1/pos/order/';
	var POS_CREDITS_URL = exports.POS_CREDITS_URL = _root_url.ROOT_URL + 'v1/pos/orders/credits';
	var POS_CREDIT_URL = exports.POS_CREDIT_URL = _root_url.ROOT_URL + 'v1/pos/orders_credit/';
	var POS_HOLDS_URL = exports.POS_HOLDS_URL = _root_url.ROOT_URL + 'v1/pos/hold_orders/';
	var POS_HOLDS_VOID = exports.POS_HOLDS_VOID = _root_url.ROOT_URL + 'v1/pos/void_hold_orders/';
	var POS_HOLDS_PRINT = exports.POS_HOLDS_PRINT = _root_url.ROOT_URL + 'v1/pos/holdorders/print/';
	var CUSTOMER_SALES_HISTORY = exports.CUSTOMER_SALES_HISTORY = _root_url.ROOT_URL + 'v1/sale/sales_order/customer-sales-history?customerId=';
	var CUSTOMERS_WITH_FAVORITES_URL = exports.CUSTOMERS_WITH_FAVORITES_URL = _root_url.ROOT_URL + 'v1/sale/favorite/';
	var CUSTOMER_CREDIT_LINES_URL = exports.CUSTOMER_CREDIT_LINES_URL = _root_url.ROOT_URL + 'v1/dashboard/customercredit/';
	var RELEASE_SALES_ORDER_URL = exports.RELEASE_SALES_ORDER_URL = _root_url.ROOT_URL + 'v1/sale/sales_invoice/';
	var FETCH_INVOICE_DETAIL_URL = exports.FETCH_INVOICE_DETAIL_URL = _root_url.ROOT_URL + 'v1/sale/sales_invoice/search/?pk=';
	var FETCH_SALES_INVOICES_BY_TYPE_URL = exports.FETCH_SALES_INVOICES_BY_TYPE_URL = _root_url.ROOT_URL + 'v1/sale/sales_invoice/search/?SaleStatus=';
	var SALES_INVOICE_URL = exports.SALES_INVOICE_URL = _root_url.ROOT_URL + 'v1/sale/sales_invoice/search/';
	var SALES_INVOICE_NUM_URL = exports.SALES_INVOICE_NUM_URL = _root_url.ROOT_URL + 'v1/sale/sales_invoice/returnable/';
	var UNPAID_SALES_INVOICE_URL = exports.UNPAID_SALES_INVOICE_URL = _root_url.ROOT_URL + 'v1/sale/unpaid_invoices/';
	var SALES_ORDER_DROPDHIP_URL = exports.SALES_ORDER_DROPDHIP_URL = _root_url.ROOT_URL + 'v2/sales/generate-purchase/';
	var MOBILE_SALES_ORDER_SHIPPINGINFO_URL = exports.MOBILE_SALES_ORDER_SHIPPINGINFO_URL = _root_url.ROOT_URL + 'v1/customer/customer_address/';
	
	// export const SALES_INVOICE_COMPLETED_URL = `${ROOT_URL}v1/sale/sales_invoice_completed/`;
	var SALES_INVOICE_COMPLETED_URL = exports.SALES_INVOICE_COMPLETED_URL = _root_url.ROOT_URL + 'v1/sale/sales_invoice/returnable/';
	var SALES_INVOICE_PAYMENT_URL = exports.SALES_INVOICE_PAYMENT_URL = _root_url.ROOT_URL + 'v1/sale/sales_invoice/';
	var EDIT_SI_CUSTOMER_URL = exports.EDIT_SI_CUSTOMER_URL = _root_url.ROOT_URL + 'v1/sale/sales_invoice/editcustomer/';
	
	var SALES_INVOICE_UPDATE_URL = exports.SALES_INVOICE_UPDATE_URL = _root_url.ROOT_URL + 'v1/sale/sales_invoice/';
	var SALES_INVOICE_VOID_URL = exports.SALES_INVOICE_VOID_URL = _root_url.ROOT_URL + 'v1/sale/sales_invoice/void/';
	var SALES_INVENTORY_INFO_URL = exports.SALES_INVENTORY_INFO_URL = _root_url.ROOT_URL + 'v1/inventory/sales_order/search/';
	var SALES_CUSTOMER_URL = exports.SALES_CUSTOMER_URL = _root_url.ROOT_URL + 'v1/sale/customer/';
	var SHIPPING_URL = exports.SHIPPING_URL = _root_url.ROOT_URL + 'v1/customer/addresses/Shipping/';
	var PURCHASES_VENDOR_URL = exports.PURCHASES_VENDOR_URL = _root_url.ROOT_URL + 'v1/ap/report/aged/';
	var SALES_ISSUE_CREDIT_URL = exports.SALES_ISSUE_CREDIT_URL = _root_url.ROOT_URL + 'v1/sale/issue_credit/';
	var CUSTOMER_FAVORITE_LIST = exports.CUSTOMER_FAVORITE_LIST = _root_url.ROOT_URL + 'v1/sale/favorite/line/';
	var WHOLESALE_URL = exports.WHOLESALE_URL = _root_url.ROOT_URL + 'v1/sale/sales_order/wholesale/';
	var WHOLESALE_BATCH_URL = exports.WHOLESALE_BATCH_URL = _root_url.ROOT_URL + 'v1/inventory/batch/';
	var INVENTORY_BATCH_URL = exports.INVENTORY_BATCH_URL = _root_url.ROOT_URL + 'v2/inventory/batch';
	var ADJUSTMENT_INVENTORY_BATCH_URL = exports.ADJUSTMENT_INVENTORY_BATCH_URL = _root_url.ROOT_URL + 'v2/inventory/adjustment';
	var WHOLESALE_BATCH_LOG_URL = exports.WHOLESALE_BATCH_LOG_URL = _root_url.ROOT_URL + 'v2/inventory/batch-log';
	var INVENTORY_SALES_ORDER_HISTORY_URL = exports.INVENTORY_SALES_ORDER_HISTORY_URL = _root_url.ROOT_URL + 'v1/inventory/sales-order-history/';
	var FINALIZED_INVOICES_URL = exports.FINALIZED_INVOICES_URL = _root_url.ROOT_URL + 'v1/sale/sales_invoice/finalized/';
	var FINALIZE_INVOICE_URL = exports.FINALIZE_INVOICE_URL = _root_url.ROOT_URL + 'v1/sale/sales_invoice/finalize/';
	var DELIVER_INVOICE_URL = exports.DELIVER_INVOICE_URL = _root_url.ROOT_URL + 'v1/sale/sales_invoice/deliver/';
	var SALES_ORDER_LINE_WEIGHTS_URL = exports.SALES_ORDER_LINE_WEIGHTS_URL = _root_url.ROOT_URL + 'v1/dispatch/weights/';
	var DISPATCH_URL = exports.DISPATCH_URL = _root_url.ROOT_URL + 'v1/dispatch/';
	var COMPANY_URL = exports.COMPANY_URL = _root_url.ROOT_URL + 'v1/company/';
	var WAREHOUSE_BY_COMPANY_URL = exports.WAREHOUSE_BY_COMPANY_URL = _root_url.ROOT_URL + 'v1/warehouse/get_warehouse_by_company/';
	
	var DISPATCH_DELIVERY_FEE_URL = exports.DISPATCH_DELIVERY_FEE_URL = _root_url.ROOT_URL + 'v1/company/';
	var REQUEST_SALES_INVOICE_FORM_URL = exports.REQUEST_SALES_INVOICE_FORM_URL = _root_url.ROOT_URL + 'v1/sale/printinvoice/';
	var SALES_RETURN_URL = exports.SALES_RETURN_URL = _root_url.ROOT_URL + 'v1/sale/sales_return/';
	var SALES_LOADSPOST_URL = exports.SALES_LOADSPOST_URL = _root_url.ROOT_URL + 'v1/sale/loadspost/';
	var TAX_RATES_URL = exports.TAX_RATES_URL = _root_url.ROOT_URL + 'v1/purchase/taxarea/';
	var CURRENCY_RATES_URL = exports.CURRENCY_RATES_URL = _root_url.ROOT_URL + 'v1/currency/';
	var AR_URL = exports.AR_URL = _root_url.ROOT_URL + 'v1/ar/';
	var AP_URL = exports.AP_URL = _root_url.ROOT_URL + 'v1/ap/';
	var UPLOAD_URL = exports.UPLOAD_URL = _root_url.ROOT_URL + 'v1/upload/';
	var POS_REPORT_URL = exports.POS_REPORT_URL = _root_url.ROOT_URL + 'v1/pos/search/';
	var PRODUCT_RECEIVE_HISTORY = exports.PRODUCT_RECEIVE_HISTORY = _root_url.ROOT_URL + 'v1/inventory/get-receiving-history/';
	
	var BASE_USER_URL = exports.BASE_USER_URL = _root_url.ROOT_URL + 'v1/baseuser/';
	var RESET_PASSWORD_URL = exports.RESET_PASSWORD_URL = _root_url.ROOT_URL + 'v1/baseuser/reset-password/';
	var RESET_EMAIL_URL = exports.RESET_EMAIL_URL = _root_url.ROOT_URL + 'v1/baseuser/mobile-change-email/';
	var FETCH_SALES_ORDER_FORM_URL = exports.FETCH_SALES_ORDER_FORM_URL = _root_url.ROOT_URL + 'v1/sale/printtest/';
	var MESSAGE_DASHBOARD_URL = exports.MESSAGE_DASHBOARD_URL = _root_url.ROOT_URL + 'v1/dashboard/messages/';
	var DELETE_USER_URL = exports.DELETE_USER_URL = _root_url.ROOT_URL + 'v1/baseuser/users/';
	var CHANGE_STRIPE_URL = exports.CHANGE_STRIPE_URL = _root_url.ROOT_URL + 'v1/baseuser/change-stripe/';
	
	var SESSION_URL = exports.SESSION_URL = _root_url.ROOT_URL + 'v1/pos/session/';
	var REGISTER_URL = exports.REGISTER_URL = _root_url.ROOT_URL + 'v1/pos/register/';
	var VERIFY_URL = exports.VERIFY_URL = _root_url.ROOT_URL + 'v1/pos/session/';
	
	var SHIPPING_LIST_URL = exports.SHIPPING_LIST_URL = _root_url.ROOT_URL + 'v1/sale/printshippinglist/';
	
	var RECEIVING_REPORT_URL = exports.RECEIVING_REPORT_URL = _root_url.ROOT_URL + 'v2/sale/receiving_report/';
	
	var YING_BOL_URL = exports.YING_BOL_URL = _root_url.ROOT_URL + 'v2/sale/shipping/xpo_bol/';
	var YING_CUSTOMER_FILE = exports.YING_CUSTOMER_FILE = _root_url.ROOT_URL + 'v2/sales/order-file-upload/';
	
	var PICKING_LIST_URL = exports.PICKING_LIST_URL = _root_url.ROOT_URL + 'v1/sale/printpickinglist/';
	var PACKING_LIST_URL = exports.PACKING_LIST_URL = _root_url.ROOT_URL + 'v1/sale/printpackinglist/';
	var SEND_PACKING_LIST_URL = exports.SEND_PACKING_LIST_URL = _root_url.ROOT_URL + 'v1/sale/send_packing_list/';
	
	var REFUND_SUMMARY_URL = exports.REFUND_SUMMARY_URL = _root_url.ROOT_URL + 'v1/sale/printrefund/';
	var SALES_ORDER_PRINT_URL = exports.SALES_ORDER_PRINT_URL = _root_url.ROOT_URL + 'v1/sale/printorder/';
	var SALES_ORDER_LABEL_PRINT_URL = exports.SALES_ORDER_LABEL_PRINT_URL = _root_url.ROOT_URL + 'v1/sale/printshippinglabel/';
	var WIZ_PRINT_BOL = exports.WIZ_PRINT_BOL = _root_url.ROOT_URL + 'v2/sales/bol/export/';
	var SALES_ORDER_LABEL_PRINT_URL_BATCH = exports.SALES_ORDER_LABEL_PRINT_URL_BATCH = _root_url.ROOT_URL + 'v1/sale/shipping/batch_ship/';
	var SALES_ORDER_RESHIP_URL = exports.SALES_ORDER_RESHIP_URL = _root_url.ROOT_URL + 'v1/sale/sales_order/reship/';
	var SALES_ORDER_PRODUCT_BY_ID_URL = exports.SALES_ORDER_PRODUCT_BY_ID_URL = _root_url.ROOT_URL + 'v1/product/byid/';
	var PURCHASE_ORDER_PRODUCT_BY_ID_URL = exports.PURCHASE_ORDER_PRODUCT_BY_ID_URL = _root_url.ROOT_URL + 'v1/product/';
	
	var SALES_ORDER_SUGGESTION_URL = exports.SALES_ORDER_SUGGESTION_URL = _root_url.ROOT_URL + 'v1/inventory/sales_order/search/simplified/';
	var PURCHASE_ORDER_SUGGESTION_URL = exports.PURCHASE_ORDER_SUGGESTION_URL = _root_url.ROOT_URL + 'v1/product/simplified/';
	var PATCH_SALES_ORDER_WEIGHT_URL = exports.PATCH_SALES_ORDER_WEIGHT_URL = _root_url.ROOT_URL + 'v1/sale/sales_mobile_order/update_weight/';
	var PATCH_SALES_ORDER_WEIGHT_MULTI_URL = exports.PATCH_SALES_ORDER_WEIGHT_MULTI_URL = _root_url.ROOT_URL + 'v1/sale/sales_mobile_order/update_weight_multi/';
	var FETCH_SALES_ORDER_WEIGHT_TRACKING = exports.FETCH_SALES_ORDER_WEIGHT_TRACKING = _root_url.ROOT_URL + 'v1/sale/sales_mobile_order/get_weight_multi/';
	var PATCH_SALES_EMPLOYEE_NOTE_URL = exports.PATCH_SALES_EMPLOYEE_NOTE_URL = _root_url.ROOT_URL + 'v1/sale/sales_mobile_order/update_sales_order_note/';
	var PATCH_SALES_VOID_NOTE_URL = exports.PATCH_SALES_VOID_NOTE_URL = _root_url.ROOT_URL + 'v1/sale/sales_mobile_order/update_sales_order_void/';
	var PATCH_INVOICE_EMPLOYEE_NOTE_URL = exports.PATCH_INVOICE_EMPLOYEE_NOTE_URL = _root_url.ROOT_URL + 'v1/sale/sales_invoice/update_sales_invoice_note/';
	
	var PURCHASE_ORDER_PRINT_URL = exports.PURCHASE_ORDER_PRINT_URL = _root_url.ROOT_URL + 'v1/purchase/order/';
	var SO_PRINT_SALES_INVOICE_URL = exports.SO_PRINT_SALES_INVOICE_URL = _root_url.ROOT_URL + 'v1/sale/printinvoice_by_so/';
	var SALES_INVOICE_PRINT_URL = exports.SALES_INVOICE_PRINT_URL = _root_url.ROOT_URL + 'v1/sale/printinvoice/';
	var SALES_INVOICE_RETURN_PRINT_URL = exports.SALES_INVOICE_RETURN_PRINT_URL = _root_url.ROOT_URL + 'v1/sale/printreturn/';
	var SALES_INVOICE_RETURN_PRINT_NOSUBTOTAL_URL = exports.SALES_INVOICE_RETURN_PRINT_NOSUBTOTAL_URL = _root_url.ROOT_URL + 'v1/sale/printreturn_no_price/';
	var WAREHOUSE_RECEIVE_PRINT_URL = exports.WAREHOUSE_RECEIVE_PRINT_URL = _root_url.ROOT_URL + 'v1/warehouse/receive/print/';
	var WAREHOUSE_RECEIVE_LINE_PRINT_LABEL_URL = exports.WAREHOUSE_RECEIVE_LINE_PRINT_LABEL_URL = _root_url.ROOT_URL + 'v1/warehouse/receive/invoice_line_print/';
	var PO_RECEIVE_LINE_PRINT_LABEL_URL = exports.PO_RECEIVE_LINE_PRINT_LABEL_URL = _root_url.ROOT_URL + 'v1/warehouse/receive/po_line_print/';
	var AR_PRINT_URL = exports.AR_PRINT_URL = _root_url.ROOT_URL + 'v1/ar/report/aged/';
	var AR_PRINT_PLAIN_URL = exports.AR_PRINT_PLAIN_URL = _root_url.ROOT_URL + 'v1/ar/report/plain/';
	var AP_PRINT_URL = exports.AP_PRINT_URL = AP_URL + 'report/aged/';
	var BD_RMA_URL = exports.BD_RMA_URL = _root_url.ROOT_URL + 'v1/bd_rma/';
	var PURCHASE_ORDER_PRINT_NOSUBTOTAL_URL = exports.PURCHASE_ORDER_PRINT_NOSUBTOTAL_URL = _root_url.ROOT_URL + 'v1/purchase/order/print/no_price/';
	var SALES_INVOICE_PRINT_NOSUBTOTAL_URL = exports.SALES_INVOICE_PRINT_NOSUBTOTAL_URL = _root_url.ROOT_URL + 'v1/sale/printinvoice_no_price/';
	
	var ADJUSTMENT_INVENTORY_URL = exports.ADJUSTMENT_INVENTORY_URL = _root_url.ROOT_URL + 'v1/adjustment-inventory/reason';
	var QUOTE_TO_ORDER_URL = exports.QUOTE_TO_ORDER_URL = _root_url.ROOT_URL + 'v1/sale/sales_order/';
	var ACTION_LOG_FILTER_URL = exports.ACTION_LOG_FILTER_URL = _root_url.ROOT_URL + 'v1/dashboard/audit_trail_filter/';
	
	var MMDRIVERS = exports.MMDRIVERS = _root_url.ROOT_URL + 'v1/baseuser/mmdriver-application/';
	var verifyPasscode = exports.verifyPasscode = _root_url.ROOT_URL + 'v1/baseuser/checkpasscode/';
	
	//Dispatch url
	var ROUTES_PRINTER_TIME = exports.ROUTES_PRINTER_TIME = _root_url.ROOT_URL + 'v1/dispatch/route-printing-time';
	
	//Username url
	var USERNAME_URL = exports.USERNAME_URL = _root_url.ROOT_URL + 'v1/baseuser/mobile/';
	
	//Business Users Ecity
	var BUSINESS_USERS_URL = exports.BUSINESS_USERS_URL = _root_url.ROOT_URL + 'v1/baseuser/business-info/';
	var BUSINESS_USER_CONVERT = exports.BUSINESS_USER_CONVERT = _root_url.ROOT_URL + 'v1/baseuser/business-convert/';
	
	//tracking note
	var TRACKING_NOTE_URL = exports.TRACKING_NOTE_URL = _root_url.ROOT_URL + 'v1/purchase/note/';
	
	// Sales Order
	var PAYMENT_METHOD_CHANGE_URL = exports.PAYMENT_METHOD_CHANGE_URL = _root_url.ROOT_URL + 'v1/sale/change_mobile_so_payment_method/';
	
	// ESL
	var ESL_INITIALIZE = exports.ESL_INITIALIZE = _root_url.ROOT_URL + 'v1/esl/product-esl-status/';
	var ESL_DELETE = exports.ESL_DELETE = _root_url.ROOT_URL + 'v1/esl/';
	var ESL_GET_TEMPLATE = exports.ESL_GET_TEMPLATE = _root_url.ROOT_URL + 'v1/esl/templates';
	var ESL_SAVE = exports.ESL_SAVE = _root_url.ROOT_URL + 'v1/esl/';
	
	// Chowbus
	var CHOWBUS_IMPORT = exports.CHOWBUS_IMPORT = _root_url.ROOT_URL + 'v2/import_orders_xls';
	
	// US Pride
	var USPRIDE_IMPORT = exports.USPRIDE_IMPORT = _root_url.ROOT_URL + 'v2/import_orders_uspride/';
	var ABCFF_IMPORT = exports.ABCFF_IMPORT = _root_url.ROOT_URL + 'v2/import_sales_order/';
	var USPRIDE_PRINT_SO_USPRIDE = exports.USPRIDE_PRINT_SO_USPRIDE = _root_url.ROOT_URL + 'v1/sale/shipping/batch_ship/';
	var USPRIDE_REPRINT_SO_USPRIDE = exports.USPRIDE_REPRINT_SO_USPRIDE = _root_url.ROOT_URL + 'v1/sale/shipping/reprint/';
	
	// Oversea
	var OVERSEA_URL = exports.OVERSEA_URL = _root_url.ROOT_URL + 'v1/oversea-warehouse/';
	var OVERSEA_UPLOAD_BOL_IMAGE_URL = exports.OVERSEA_UPLOAD_BOL_IMAGE_URL = _root_url.ROOT_URL + 'v1/oversea-warehouse/upload-amazon-bol/';
	var OVERSEA_DELETE_BOL_IMAGE_URL = exports.OVERSEA_DELETE_BOL_IMAGE_URL = _root_url.ROOT_URL + 'v1/oversea-warehouse/delete-image/';
	var OVERSEA_PRINT_BOL_URL = exports.OVERSEA_PRINT_BOL_URL = _root_url.ROOT_URL + 'v1/oversea-warehouse/printing-so-bol-file/';
	var OVERSEA_ADDRESS_URL = exports.OVERSEA_ADDRESS_URL = _root_url.ROOT_URL + 'v1/oversea-warehouse/amazon-fba-address';
	var OVERSEA_PRINT_BOL_WITHOUT_LOG_URL = exports.OVERSEA_PRINT_BOL_WITHOUT_LOG_URL = _root_url.ROOT_URL + 'v1/oversea-warehouse/printing-bol-file-non-logo/';
	var OVERSEA_PRINT_BOL_LABEL_URL = exports.OVERSEA_PRINT_BOL_LABEL_URL = _root_url.ROOT_URL + 'v1/sale/print_bol_label/';
	
	var SP_PDF_URL = exports.SP_PDF_URL = _root_url.ROOT_URL + 'v1/sale/performance_categories_pdf';
	
	// JML Tracking Numbers
	var FETCH_JML_TRACKING_NUMBER_URL = exports.FETCH_JML_TRACKING_NUMBER_URL = _root_url.ROOT_URL + 'v2/sales/shipping_info/';
	var PRINT_SHIPPING_LABEL_URL = exports.PRINT_SHIPPING_LABEL_URL = _root_url.ROOT_URL + 'v2/sales/shipping/new_label_for_order/';
	
	// carrier info
	var CARRIER_INFO_URL = exports.CARRIER_INFO_URL = _root_url.ROOT_URL + 'v2/shipping/order_ltl_info/';
	
	// Merge PO API
	var MERGE_PURCHASE_ORDERS_API = exports.MERGE_PURCHASE_ORDERS_API = _root_url.ROOT_URL + 'v2/purchase/order/merge';
	
	// Quote
	var SET_QUOTE_URL = exports.SET_QUOTE_URL = _root_url.ROOT_URL + 'v1/sale/sales_order/sq_to_so_adjust_inv/';
	
	// Approve
	var APPROVE_PENDING_PO_URL = exports.APPROVE_PENDING_PO_URL = _root_url.ROOT_URL + 'v1/purchase/order/approve/';
	
	// SO to PO Davis
	var SO_TO_PO_DAVIS_URL = exports.SO_TO_PO_DAVIS_URL = _root_url.ROOT_URL + 'v2/so_to_po_dropship';
	
	var MAG_DRAYAGE_LIST = exports.MAG_DRAYAGE_LIST = _root_url.ROOT_URL + 'v1/product/drayagelist/';
	
	// VIT MSO
	var VitAppointmentListOrders_URL = exports.VitAppointmentListOrders_URL = _root_url.ROOT_URL + 'v1/customer/appointment_list_order/';
	
	// WUFS
	var SALE_SHIP_ORDER_SEARCH_URL = exports.SALE_SHIP_ORDER_SEARCH_URL = _root_url.ROOT_URL + 'v1/sale/ship_order/search/';
	var SALE_OTHER_SERVICE_SEARCH_URL = exports.SALE_OTHER_SERVICE_SEARCH_URL = _root_url.ROOT_URL + 'v1/sale/other_service/search/';
	var SALE_STWH_ORDER_SEARCH_URL = exports.SALE_STWH_ORDER_SEARCH_URL = _root_url.ROOT_URL + 'v1/sale/stwh_order/search/';
	var SALE_PRE_ORDER_SEARCH_URL = exports.SALE_PRE_ORDER_SEARCH_URL = _root_url.ROOT_URL + 'v1/sale/pre_order/search/';
	var USER_PUT_CREDIT_URL = exports.USER_PUT_CREDIT_URL = _root_url.ROOT_URL + 'v1/baseuser/User_Put_Credit';
	var USER_QUERY_CREDIT_URL = exports.USER_QUERY_CREDIT_URL = _root_url.ROOT_URL + 'v1/baseuser/User_Query_Credit';
	var USER_QUERY_NOTE_URL = exports.USER_QUERY_NOTE_URL = _root_url.ROOT_URL + 'v1/baseuser/User_Query_Note';
	var USER_PUT_NOTE_URL = exports.USER_PUT_NOTE_URL = _root_url.ROOT_URL + 'v1/baseuser/User_Put_Note';
	var USER_PRODUCTS_URL = exports.USER_PRODUCTS_URL = _root_url.ROOT_URL + 'v1/baseuser/User_Query_Product_bycustomer';
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TRUCKXI_LOGIN_URL, 'TRUCKXI_LOGIN_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(TRUCKXI_TEST_URL, 'TRUCKXI_TEST_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PERMISSION_URL, 'PERMISSION_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_ORDER_FORM_BACHES, 'SALES_ORDER_FORM_BACHES', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PRODUCTS_URL, 'PRODUCTS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PRODUCTS_SIMPLIFIED_URL, 'PRODUCTS_SIMPLIFIED_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(GROUPS_URL, 'GROUPS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(GROUPS_ELEGANT_URL, 'GROUPS_ELEGANT_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(CATEGORIES_URL, 'CATEGORIES_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(CATEGORIES_2_URL, 'CATEGORIES_2_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(CATEGORIES_2_B2B_URL, 'CATEGORIES_2_B2B_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PRICELEVELS_URL, 'PRICELEVELS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(TYPES_URL, 'TYPES_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(CUSTOMERS_URL, 'CUSTOMERS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(CUSTOMERS_PAGINATE_URL, 'CUSTOMERS_PAGINATE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(CUSTOMERS_STATUS_URL, 'CUSTOMERS_STATUS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(AGENT_URL, 'AGENT_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PAYMENT_URL, 'PAYMENT_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(VENDOR_URL, 'VENDOR_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(OUTSTANDING_VENDOR_URL, 'OUTSTANDING_VENDOR_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(VENDOR_INVENTORY_URL, 'VENDOR_INVENTORY_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(DISPLAY_CATEGORIES_URL, 'DISPLAY_CATEGORIES_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_FJ_AGENTS_URL, 'FETCH_FJ_AGENTS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_FBA_ADDRESS_URL, 'FETCH_FBA_ADDRESS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_FJ_CARRIERS_URL, 'FETCH_FJ_CARRIERS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(ACH_EDIT_URL, 'ACH_EDIT_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRICE_TABLE_URL, 'FETCH_PRICE_TABLE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PRICE_TABLE_URL_VENDOR, 'FETCH_PRICE_TABLE_URL_VENDOR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(OUTGOING_ORDERS_BY_DATE_URL, 'OUTGOING_ORDERS_BY_DATE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(INCOMING_ORDERS_BY_DATE_URL, 'INCOMING_ORDERS_BY_DATE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PURCHASE_QUOTES_URL, 'PURCHASE_QUOTES_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PURCHASE_TEMPLATES_URL, 'PURCHASE_TEMPLATES_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PURCHASE_SCHEDULES_URL, 'PURCHASE_SCHEDULES_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PURCHASE_RETURNS_URL, 'PURCHASE_RETURNS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PURCHASE_RETURNS_NO_SUBTOTALS, 'PURCHASE_RETURNS_NO_SUBTOTALS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PURCHASE_ORDERS_URL, 'PURCHASE_ORDERS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PURCHASE_ORDER_COMPLETE_URL, 'PURCHASE_ORDER_COMPLETE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PURCHASE_URL, 'PURCHASE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PURCHASE_URL_2, 'PURCHASE_URL_2', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(INCIDENT_REPORT_URL, 'INCIDENT_REPORT_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PRESIDENT_DASH_INFO_URL, 'PRESIDENT_DASH_INFO_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(NUM_PURCHASE_QUOTES_URL, 'NUM_PURCHASE_QUOTES_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PURCHASE_ORDERS_NOT_RECEIVED_URL, 'PURCHASE_ORDERS_NOT_RECEIVED_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(TOTAL_PURCHASES_URL, 'TOTAL_PURCHASES_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(DASHBOARD_URL, 'DASHBOARD_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PURCHASE_ORDER_PERFORMANCE_URL, 'PURCHASE_ORDER_PERFORMANCE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PURCHASE_MANAGER_INFO_URL, 'PURCHASE_MANAGER_INFO_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(LAST_MONTH_PERFORMANCE_URL, 'LAST_MONTH_PERFORMANCE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PURCHASE_TOTALS_URL, 'PURCHASE_TOTALS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(OVERALL_PURCHASE_PERFORMANCE_URL, 'OVERALL_PURCHASE_PERFORMANCE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(OVERALL_SALES_PERFORMANCE_URL, 'OVERALL_SALES_PERFORMANCE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_LEVELS_URL, 'SALES_LEVELS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(CONSOLODATED_STATISTICS_URL, 'CONSOLODATED_STATISTICS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(INVENTORIES_URL, 'INVENTORIES_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(DETAILED_INVENTORIES_URL, 'DETAILED_INVENTORIES_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_ORDER_INVENTORY_URL, 'SALES_ORDER_INVENTORY_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(FREQUENT_ITEMS_URL, 'FREQUENT_ITEMS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(INBOUND_PRODUCTS_URL, 'INBOUND_PRODUCTS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(INVENTORY_URL, 'INVENTORY_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(INVENTORY_HISTORY_URL, 'INVENTORY_HISTORY_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(EMAIL_UPDATE, 'EMAIL_UPDATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(EMAIL_POD, 'EMAIL_POD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(COMPLETE_OB, 'COMPLETE_OB', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(INVENTORY_RELOCATIONS_URL, 'INVENTORY_RELOCATIONS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(INVENTORY_REPACKAGES_URL, 'INVENTORY_REPACKAGES_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(INVENTORY_ADJUSTMENTS_URL, 'INVENTORY_ADJUSTMENTS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(QUICK_INVENTORY_ADJUSTMENTS_URL, 'QUICK_INVENTORY_ADJUSTMENTS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(INVENTORY_CONVERTS_URL, 'INVENTORY_CONVERTS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SCRAP_RECORDS_URL, 'SCRAP_RECORDS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(INVENTORY_SCRAP_URL, 'INVENTORY_SCRAP_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(WAREHOUSES_URL, 'WAREHOUSES_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(ZONES_URL, 'ZONES_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(BINS_URL, 'BINS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(RECEIVE_URL, 'RECEIVE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PUT_AWAY_URL, 'PUT_AWAY_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(ITEM_HISTORY_URL, 'ITEM_HISTORY_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(FAVORITES_URL, 'FAVORITES_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(CUSTOMER_GROUPS_URL, 'CUSTOMER_GROUPS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PREVIOUSORDERS_URL, 'PREVIOUSORDERS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PROMOTIONS_URL, 'PROMOTIONS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PROMO_NOTES_URL, 'PROMO_NOTES_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_PERFORMANCE_URL, 'SALES_PERFORMANCE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(USER_PERFORMANCE_URL, 'USER_PERFORMANCE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(USER_PRODUCT_GROUPS_URL, 'USER_PRODUCT_GROUPS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_ORDERS_URL, 'SALES_ORDERS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(CHANGE_TRACKING_URL, 'CHANGE_TRACKING_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(RESYNC_URL, 'RESYNC_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(ASSIGN_BOL_URL, 'ASSIGN_BOL_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PRINT_BOL_URL, 'PRINT_BOL_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(ADD_TRACKING_URL, 'ADD_TRACKING_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(GET_QUOTE_URL, 'GET_QUOTE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(GET_PICKUP_URL, 'GET_PICKUP_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(CHANGE_OB_STATUS_URL, 'CHANGE_OB_STATUS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_QUOTE_URL, 'SALES_QUOTE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_ORDERS_REFUND, 'SALES_ORDERS_REFUND', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(MOBILE_SALES_ORDERS_URL, 'MOBILE_SALES_ORDERS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(MOBILE_SALES_ORDERS_URL_v2, 'MOBILE_SALES_ORDERS_URL_v2', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_DASHBOARD_URL, 'SALES_DASHBOARD_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(POS_ORDERS_URL, 'POS_ORDERS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(POS_SALE_URL, 'POS_SALE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(POS_CREDITS_URL, 'POS_CREDITS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(POS_CREDIT_URL, 'POS_CREDIT_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(POS_HOLDS_URL, 'POS_HOLDS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(POS_HOLDS_VOID, 'POS_HOLDS_VOID', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(POS_HOLDS_PRINT, 'POS_HOLDS_PRINT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(CUSTOMER_SALES_HISTORY, 'CUSTOMER_SALES_HISTORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(CUSTOMERS_WITH_FAVORITES_URL, 'CUSTOMERS_WITH_FAVORITES_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(CUSTOMER_CREDIT_LINES_URL, 'CUSTOMER_CREDIT_LINES_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(RELEASE_SALES_ORDER_URL, 'RELEASE_SALES_ORDER_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_INVOICE_DETAIL_URL, 'FETCH_INVOICE_DETAIL_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_INVOICES_BY_TYPE_URL, 'FETCH_SALES_INVOICES_BY_TYPE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_INVOICE_URL, 'SALES_INVOICE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_INVOICE_NUM_URL, 'SALES_INVOICE_NUM_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(UNPAID_SALES_INVOICE_URL, 'UNPAID_SALES_INVOICE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_ORDER_DROPDHIP_URL, 'SALES_ORDER_DROPDHIP_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(MOBILE_SALES_ORDER_SHIPPINGINFO_URL, 'MOBILE_SALES_ORDER_SHIPPINGINFO_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_INVOICE_COMPLETED_URL, 'SALES_INVOICE_COMPLETED_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_INVOICE_PAYMENT_URL, 'SALES_INVOICE_PAYMENT_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(EDIT_SI_CUSTOMER_URL, 'EDIT_SI_CUSTOMER_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_INVOICE_UPDATE_URL, 'SALES_INVOICE_UPDATE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_INVOICE_VOID_URL, 'SALES_INVOICE_VOID_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_INVENTORY_INFO_URL, 'SALES_INVENTORY_INFO_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_CUSTOMER_URL, 'SALES_CUSTOMER_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SHIPPING_URL, 'SHIPPING_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PURCHASES_VENDOR_URL, 'PURCHASES_VENDOR_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_ISSUE_CREDIT_URL, 'SALES_ISSUE_CREDIT_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(CUSTOMER_FAVORITE_LIST, 'CUSTOMER_FAVORITE_LIST', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(WHOLESALE_URL, 'WHOLESALE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(WHOLESALE_BATCH_URL, 'WHOLESALE_BATCH_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(INVENTORY_BATCH_URL, 'INVENTORY_BATCH_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(ADJUSTMENT_INVENTORY_BATCH_URL, 'ADJUSTMENT_INVENTORY_BATCH_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(WHOLESALE_BATCH_LOG_URL, 'WHOLESALE_BATCH_LOG_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(INVENTORY_SALES_ORDER_HISTORY_URL, 'INVENTORY_SALES_ORDER_HISTORY_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(FINALIZED_INVOICES_URL, 'FINALIZED_INVOICES_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(FINALIZE_INVOICE_URL, 'FINALIZE_INVOICE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(DELIVER_INVOICE_URL, 'DELIVER_INVOICE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_ORDER_LINE_WEIGHTS_URL, 'SALES_ORDER_LINE_WEIGHTS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(DISPATCH_URL, 'DISPATCH_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(COMPANY_URL, 'COMPANY_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(WAREHOUSE_BY_COMPANY_URL, 'WAREHOUSE_BY_COMPANY_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(DISPATCH_DELIVERY_FEE_URL, 'DISPATCH_DELIVERY_FEE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_SALES_INVOICE_FORM_URL, 'REQUEST_SALES_INVOICE_FORM_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_RETURN_URL, 'SALES_RETURN_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_LOADSPOST_URL, 'SALES_LOADSPOST_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(TAX_RATES_URL, 'TAX_RATES_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(CURRENCY_RATES_URL, 'CURRENCY_RATES_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(AR_URL, 'AR_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(AP_URL, 'AP_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(UPLOAD_URL, 'UPLOAD_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(POS_REPORT_URL, 'POS_REPORT_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PRODUCT_RECEIVE_HISTORY, 'PRODUCT_RECEIVE_HISTORY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(BASE_USER_URL, 'BASE_USER_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(RESET_PASSWORD_URL, 'RESET_PASSWORD_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(RESET_EMAIL_URL, 'RESET_EMAIL_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_ORDER_FORM_URL, 'FETCH_SALES_ORDER_FORM_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(MESSAGE_DASHBOARD_URL, 'MESSAGE_DASHBOARD_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_USER_URL, 'DELETE_USER_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(CHANGE_STRIPE_URL, 'CHANGE_STRIPE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SESSION_URL, 'SESSION_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(REGISTER_URL, 'REGISTER_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(VERIFY_URL, 'VERIFY_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SHIPPING_LIST_URL, 'SHIPPING_LIST_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(RECEIVING_REPORT_URL, 'RECEIVING_REPORT_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(YING_BOL_URL, 'YING_BOL_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(YING_CUSTOMER_FILE, 'YING_CUSTOMER_FILE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PICKING_LIST_URL, 'PICKING_LIST_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PACKING_LIST_URL, 'PACKING_LIST_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SEND_PACKING_LIST_URL, 'SEND_PACKING_LIST_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(REFUND_SUMMARY_URL, 'REFUND_SUMMARY_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_ORDER_PRINT_URL, 'SALES_ORDER_PRINT_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_ORDER_LABEL_PRINT_URL, 'SALES_ORDER_LABEL_PRINT_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(WIZ_PRINT_BOL, 'WIZ_PRINT_BOL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_ORDER_LABEL_PRINT_URL_BATCH, 'SALES_ORDER_LABEL_PRINT_URL_BATCH', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_ORDER_RESHIP_URL, 'SALES_ORDER_RESHIP_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_ORDER_PRODUCT_BY_ID_URL, 'SALES_ORDER_PRODUCT_BY_ID_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PURCHASE_ORDER_PRODUCT_BY_ID_URL, 'PURCHASE_ORDER_PRODUCT_BY_ID_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_ORDER_SUGGESTION_URL, 'SALES_ORDER_SUGGESTION_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PURCHASE_ORDER_SUGGESTION_URL, 'PURCHASE_ORDER_SUGGESTION_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PATCH_SALES_ORDER_WEIGHT_URL, 'PATCH_SALES_ORDER_WEIGHT_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PATCH_SALES_ORDER_WEIGHT_MULTI_URL, 'PATCH_SALES_ORDER_WEIGHT_MULTI_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_SALES_ORDER_WEIGHT_TRACKING, 'FETCH_SALES_ORDER_WEIGHT_TRACKING', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PATCH_SALES_EMPLOYEE_NOTE_URL, 'PATCH_SALES_EMPLOYEE_NOTE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PATCH_SALES_VOID_NOTE_URL, 'PATCH_SALES_VOID_NOTE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PATCH_INVOICE_EMPLOYEE_NOTE_URL, 'PATCH_INVOICE_EMPLOYEE_NOTE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PURCHASE_ORDER_PRINT_URL, 'PURCHASE_ORDER_PRINT_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SO_PRINT_SALES_INVOICE_URL, 'SO_PRINT_SALES_INVOICE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_INVOICE_PRINT_URL, 'SALES_INVOICE_PRINT_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_INVOICE_RETURN_PRINT_URL, 'SALES_INVOICE_RETURN_PRINT_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_INVOICE_RETURN_PRINT_NOSUBTOTAL_URL, 'SALES_INVOICE_RETURN_PRINT_NOSUBTOTAL_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(WAREHOUSE_RECEIVE_PRINT_URL, 'WAREHOUSE_RECEIVE_PRINT_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(WAREHOUSE_RECEIVE_LINE_PRINT_LABEL_URL, 'WAREHOUSE_RECEIVE_LINE_PRINT_LABEL_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PO_RECEIVE_LINE_PRINT_LABEL_URL, 'PO_RECEIVE_LINE_PRINT_LABEL_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(AR_PRINT_URL, 'AR_PRINT_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(AR_PRINT_PLAIN_URL, 'AR_PRINT_PLAIN_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(AP_PRINT_URL, 'AP_PRINT_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(BD_RMA_URL, 'BD_RMA_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PURCHASE_ORDER_PRINT_NOSUBTOTAL_URL, 'PURCHASE_ORDER_PRINT_NOSUBTOTAL_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALES_INVOICE_PRINT_NOSUBTOTAL_URL, 'SALES_INVOICE_PRINT_NOSUBTOTAL_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(ADJUSTMENT_INVENTORY_URL, 'ADJUSTMENT_INVENTORY_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(QUOTE_TO_ORDER_URL, 'QUOTE_TO_ORDER_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(ACTION_LOG_FILTER_URL, 'ACTION_LOG_FILTER_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(MMDRIVERS, 'MMDRIVERS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(verifyPasscode, 'verifyPasscode', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(ROUTES_PRINTER_TIME, 'ROUTES_PRINTER_TIME', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(USERNAME_URL, 'USERNAME_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(BUSINESS_USERS_URL, 'BUSINESS_USERS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(BUSINESS_USER_CONVERT, 'BUSINESS_USER_CONVERT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(TRACKING_NOTE_URL, 'TRACKING_NOTE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PAYMENT_METHOD_CHANGE_URL, 'PAYMENT_METHOD_CHANGE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(ESL_INITIALIZE, 'ESL_INITIALIZE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(ESL_DELETE, 'ESL_DELETE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(ESL_GET_TEMPLATE, 'ESL_GET_TEMPLATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(ESL_SAVE, 'ESL_SAVE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(CHOWBUS_IMPORT, 'CHOWBUS_IMPORT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(USPRIDE_IMPORT, 'USPRIDE_IMPORT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(ABCFF_IMPORT, 'ABCFF_IMPORT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(USPRIDE_PRINT_SO_USPRIDE, 'USPRIDE_PRINT_SO_USPRIDE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(USPRIDE_REPRINT_SO_USPRIDE, 'USPRIDE_REPRINT_SO_USPRIDE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(OVERSEA_URL, 'OVERSEA_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(OVERSEA_UPLOAD_BOL_IMAGE_URL, 'OVERSEA_UPLOAD_BOL_IMAGE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(OVERSEA_DELETE_BOL_IMAGE_URL, 'OVERSEA_DELETE_BOL_IMAGE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(OVERSEA_PRINT_BOL_URL, 'OVERSEA_PRINT_BOL_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(OVERSEA_ADDRESS_URL, 'OVERSEA_ADDRESS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(OVERSEA_PRINT_BOL_WITHOUT_LOG_URL, 'OVERSEA_PRINT_BOL_WITHOUT_LOG_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(OVERSEA_PRINT_BOL_LABEL_URL, 'OVERSEA_PRINT_BOL_LABEL_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SP_PDF_URL, 'SP_PDF_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_JML_TRACKING_NUMBER_URL, 'FETCH_JML_TRACKING_NUMBER_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(PRINT_SHIPPING_LABEL_URL, 'PRINT_SHIPPING_LABEL_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(CARRIER_INFO_URL, 'CARRIER_INFO_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(MERGE_PURCHASE_ORDERS_API, 'MERGE_PURCHASE_ORDERS_API', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SET_QUOTE_URL, 'SET_QUOTE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(APPROVE_PENDING_PO_URL, 'APPROVE_PENDING_PO_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SO_TO_PO_DAVIS_URL, 'SO_TO_PO_DAVIS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(MAG_DRAYAGE_LIST, 'MAG_DRAYAGE_LIST', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(VitAppointmentListOrders_URL, 'VitAppointmentListOrders_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALE_SHIP_ORDER_SEARCH_URL, 'SALE_SHIP_ORDER_SEARCH_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALE_OTHER_SERVICE_SEARCH_URL, 'SALE_OTHER_SERVICE_SEARCH_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALE_STWH_ORDER_SEARCH_URL, 'SALE_STWH_ORDER_SEARCH_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(SALE_PRE_ORDER_SEARCH_URL, 'SALE_PRE_ORDER_SEARCH_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(USER_PUT_CREDIT_URL, 'USER_PUT_CREDIT_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(USER_QUERY_CREDIT_URL, 'USER_QUERY_CREDIT_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(USER_QUERY_NOTE_URL, 'USER_QUERY_NOTE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(USER_PUT_NOTE_URL, 'USER_PUT_NOTE_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	
	  __REACT_HOT_LOADER__.register(USER_PRODUCTS_URL, 'USER_PRODUCTS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/url.js');
	}();

	;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VirtualizedSelection = exports.MultiSelection = exports.DisabledSelection = exports.SelectionWide = exports.SelectionWithProps = exports.Selection = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactSelectFastFilterOptions = __webpack_require__(202);
	
	var _reactSelectFastFilterOptions2 = _interopRequireDefault(_reactSelectFastFilterOptions);
	
	var _reactVirtualizedSelect = __webpack_require__(203);
	
	var _reactVirtualizedSelect2 = _interopRequireDefault(_reactVirtualizedSelect);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Selection = exports.Selection = function (_Component) {
	  _inherits(Selection, _Component);
	
	  function Selection() {
	    _classCallCheck(this, Selection);
	
	    return _possibleConstructorReturn(this, (Selection.__proto__ || Object.getPrototypeOf(Selection)).apply(this, arguments));
	  }
	
	  _createClass(Selection, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          input = _props.input,
	          options = _props.options,
	          defaultValue = _props.defaultValue,
	          className = _props.className,
	          _props$meta = _props.meta,
	          touched = _props$meta.touched,
	          error = _props$meta.error;
	
	      var inputClass = (0, _classnames2.default)({ 'parsley-error-div': touched && error }, className, 'testSelect');
	      var isDisabled = false;
	      var matchPos = 'start';
	      if (this.props.disabled) {
	        isDisabled = true;
	      }
	      if (this.props.matchPos) {
	        matchPos = this.props.matchPos;
	      }
	      // console.log(this.props.meta,"and", this.props.input )
	      if (defaultValue) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          touched && error && _react2.default.createElement(
	            'span',
	            { className: 'parsley-error-message' },
	            error
	          ),
	          _react2.default.createElement(_reactSelect2.default, _extends({
	            className: inputClass,
	            matchPos: matchPos,
	            matchProp: 'label',
	            options: options
	          }, input, _defineProperty({
	            value: input.value.value || input.value || defaultValue.value,
	            onBlur: function onBlur() {
	              input.onBlur(input.value);
	            },
	            disabled: isDisabled,
	            onInputKeyDown: this.props.onInputKeyDown,
	            ref: 'select'
	          }, 'onInputKeyDown', this.props.onKeyPress)))
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        touched && error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          error
	        ),
	        _react2.default.createElement(_reactSelect2.default, _extends({
	          className: inputClass,
	          matchPos: matchPos,
	          matchProp: 'label',
	          options: options
	        }, input, _defineProperty({
	          value: input.value.value || input.value,
	          onBlur: function onBlur() {
	            input.onBlur(input.value);
	          },
	          disabled: isDisabled,
	          onInputKeyDown: this.props.onInputKeyDown,
	          ref: 'select'
	        }, 'onInputKeyDown', this.props.onKeyPress)))
	      );
	    }
	  }]);
	
	  return Selection;
	}(_react.Component);
	
	var SelectionWithProps = exports.SelectionWithProps = function (_Component2) {
	  _inherits(SelectionWithProps, _Component2);
	
	  function SelectionWithProps() {
	    _classCallCheck(this, SelectionWithProps);
	
	    return _possibleConstructorReturn(this, (SelectionWithProps.__proto__ || Object.getPrototypeOf(SelectionWithProps)).apply(this, arguments));
	  }
	
	  _createClass(SelectionWithProps, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          input = _props2.input,
	          options = _props2.options,
	          className = _props2.className,
	          _onChange = _props2.onChange,
	          _props2$meta = _props2.meta,
	          touched = _props2$meta.touched,
	          error = _props2$meta.error;
	
	      var inputClass = (0, _classnames2.default)({ 'parsley-error-div': touched && error }, className, "testSelect");
	      return _react2.default.createElement(
	        'div',
	        null,
	        touched && error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          error
	        ),
	        _react2.default.createElement(_reactSelect2.default, _extends({
	          className: inputClass,
	          matchPos: "start",
	          matchProp: 'label',
	          options: options
	        }, input, this.props, {
	          ref: 'select',
	          value: input.value.value || input.value,
	          onBlur: function onBlur() {
	            input.onBlur(input.value);
	          },
	          onChange: function onChange(event) {
	            input.onChange(event);
	            if (typeof _onChange === 'function') {
	              _onChange(event);
	            }
	            _this3.props.onSelect && _this3.props.onSelect(event);
	          }
	        }))
	      );
	    }
	  }]);
	
	  return SelectionWithProps;
	}(_react.Component);
	
	var SelectionWide = exports.SelectionWide = function (_Component3) {
	  _inherits(SelectionWide, _Component3);
	
	  function SelectionWide() {
	    _classCallCheck(this, SelectionWide);
	
	    return _possibleConstructorReturn(this, (SelectionWide.__proto__ || Object.getPrototypeOf(SelectionWide)).apply(this, arguments));
	  }
	
	  _createClass(SelectionWide, [{
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          input = _props3.input,
	          options = _props3.options,
	          className = _props3.className,
	          _props3$meta = _props3.meta,
	          touched = _props3$meta.touched,
	          error = _props3$meta.error;
	
	      var inputClass = (0, _classnames2.default)({ 'parsley-error-div': touched && error }, className, "testSelect");
	      return _react2.default.createElement(
	        'div',
	        null,
	        touched && error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          error
	        ),
	        _react2.default.createElement(_reactSelect2.default, _extends({
	          className: inputClass,
	          matchProp: 'label',
	          options: options
	        }, input, {
	          value: input.value.value || input.value,
	          onBlur: function onBlur() {
	            input.onBlur(input.value);
	          }
	        }))
	      );
	    }
	  }]);
	
	  return SelectionWide;
	}(_react.Component);
	
	var DisabledSelection = exports.DisabledSelection = function (_Component4) {
	  _inherits(DisabledSelection, _Component4);
	
	  function DisabledSelection() {
	    _classCallCheck(this, DisabledSelection);
	
	    return _possibleConstructorReturn(this, (DisabledSelection.__proto__ || Object.getPrototypeOf(DisabledSelection)).apply(this, arguments));
	  }
	
	  _createClass(DisabledSelection, [{
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          input = _props4.input,
	          options = _props4.options,
	          defaultValue = _props4.defaultValue,
	          className = _props4.className,
	          _props4$meta = _props4.meta,
	          touched = _props4$meta.touched,
	          error = _props4$meta.error;
	
	      var inputClass = (0, _classnames2.default)({ 'parsley-error-div': touched && error }, className, "testSelect");
	      return _react2.default.createElement(
	        'div',
	        null,
	        touched && error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          error
	        ),
	        _react2.default.createElement(_reactSelect2.default, _extends({
	          className: inputClass,
	          value: defaultValue,
	          options: options
	        }, input, {
	          onBlur: function onBlur() {
	            input.onBlur(input.value);
	          },
	          disabled: true,
	          ref: 'select'
	        }))
	      );
	    }
	  }]);
	
	  return DisabledSelection;
	}(_react.Component);
	
	var MultiSelection = exports.MultiSelection = function (_Component5) {
	  _inherits(MultiSelection, _Component5);
	
	  function MultiSelection() {
	    _classCallCheck(this, MultiSelection);
	
	    return _possibleConstructorReturn(this, (MultiSelection.__proto__ || Object.getPrototypeOf(MultiSelection)).apply(this, arguments));
	  }
	
	  _createClass(MultiSelection, [{
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          input = _props5.input,
	          options = _props5.options,
	          defaultValue = _props5.defaultValue,
	          className = _props5.className,
	          _props5$meta = _props5.meta,
	          touched = _props5$meta.touched,
	          error = _props5$meta.error;
	
	      var inputClass = (0, _classnames2.default)({ 'parsley-error-div': touched && error }, className, "testSelect");
	      var isDisabled = false;
	      if (this.props.disabled) {
	        isDisabled = true;
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        touched && error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          error
	        ),
	        _react2.default.createElement(_reactSelect2.default, _extends({
	          className: inputClass,
	          multi: true,
	          options: options
	        }, input, {
	          value: input.value.value || input.value,
	          onBlur: function onBlur() {
	            input.onBlur(input.value);
	          },
	          disabled: isDisabled
	        }))
	      );
	    }
	  }]);
	
	  return MultiSelection;
	}(_react.Component);
	
	var VirtualizedSelection = exports.VirtualizedSelection = function (_Component6) {
	  _inherits(VirtualizedSelection, _Component6);
	
	  function VirtualizedSelection() {
	    _classCallCheck(this, VirtualizedSelection);
	
	    return _possibleConstructorReturn(this, (VirtualizedSelection.__proto__ || Object.getPrototypeOf(VirtualizedSelection)).apply(this, arguments));
	  }
	
	  _createClass(VirtualizedSelection, [{
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props,
	          input = _props6.input,
	          options = _props6.options,
	          defaultValue = _props6.defaultValue,
	          className = _props6.className,
	          _props6$meta = _props6.meta,
	          touched = _props6$meta.touched,
	          error = _props6$meta.error;
	
	      var inputClass = (0, _classnames2.default)({ 'parsley-error-div': touched && error }, className, "testSelect");
	      var filterOptions = (0, _reactSelectFastFilterOptions2.default)({ options: options });
	
	      var isDisabled = false;
	      if (this.props.disabled) {
	        isDisabled = true;
	      }
	      if (defaultValue) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          touched && error && _react2.default.createElement(
	            'span',
	            { className: 'parsley-error-message' },
	            error
	          ),
	          _react2.default.createElement(_reactVirtualizedSelect2.default, _extends({
	            className: inputClass,
	            filterOptions: filterOptions,
	            options: options
	          }, input, {
	            value: input.value.value || input.value || defaultValue.value,
	            onBlur: function onBlur() {
	              input.onBlur(input.value);
	            },
	            disabled: isDisabled,
	            onInputKeyDown: this.props.onInputKeyDown
	          }))
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        touched && error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          error
	        ),
	        _react2.default.createElement(_reactVirtualizedSelect2.default, _extends({
	          className: inputClass,
	          filterOptions: filterOptions,
	          options: options
	        }, input, {
	          value: input.value.value || input.value,
	          onBlur: function onBlur() {
	            input.onBlur(input.value);
	          },
	          disabled: isDisabled,
	          onInputKeyDown: this.props.onInputKeyDown
	        }))
	      );
	    }
	  }]);
	
	  return VirtualizedSelection;
	}(_react.Component);
	
	var _default = Selection;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Selection, 'Selection', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/selection.jsx');
	
	  __REACT_HOT_LOADER__.register(SelectionWithProps, 'SelectionWithProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/selection.jsx');
	
	  __REACT_HOT_LOADER__.register(SelectionWide, 'SelectionWide', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/selection.jsx');
	
	  __REACT_HOT_LOADER__.register(DisabledSelection, 'DisabledSelection', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/selection.jsx');
	
	  __REACT_HOT_LOADER__.register(MultiSelection, 'MultiSelection', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/selection.jsx');
	
	  __REACT_HOT_LOADER__.register(VirtualizedSelection, 'VirtualizedSelection', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/selection.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/selection.jsx');
	}();

	;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dateFormat = dateFormat;
	exports.maxDate = maxDate;
	exports.minDate = minDate;
	exports.maxDateUtc = maxDateUtc;
	exports.minDateUtc = minDateUtc;
	exports.convertUtcDate = convertUtcDate;
	exports.convertLocalDate = convertLocalDate;
	exports.getDateRangeBetweenDates = getDateRangeBetweenDates;
	exports.grabMonthsToAndFromDates = grabMonthsToAndFromDates;
	exports.toFromDates = toFromDates;
	exports.toFromDispatchDates = toFromDispatchDates;
	exports.getFromToDates = getFromToDates;
	exports.getFromToDatesWithFilter = getFromToDatesWithFilter;
	exports.convertTimeToUtc = convertTimeToUtc;
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function dateFormat(format, date) {
	  return date ? (0, _moment2.default)(date).format(format || 'YYYY-MM-DD') : (0, _moment2.default)().format(format || 'YYYY-MM-DD');
	}
	
	function maxDate(format) {
	  return (0, _moment2.default)('3000-01-01').format(format || 'YYYY-MM-DD');
	}
	
	function minDate(format) {
	  return (0, _moment2.default)('1900-01-01').format(format || 'YYYY-MM-DD');
	}
	
	function maxDateUtc() {
	  return (0, _moment2.default)('3000-01-01').endOf('day').toISOString();
	}
	
	function minDateUtc() {
	  return (0, _moment2.default)('1900-01-01').startOf('day').toISOString();
	}
	
	function convertUtcDate(date) {
	  return date ? (0, _moment2.default)(date).toISOString() : (0, _moment2.default)().toISOString();
	}
	
	function convertLocalDate(date, format) {
	  return date ? (0, _moment2.default)(date).local().format(format || 'YYYY-MM-DD') : (0, _moment2.default)().local().format(format || 'YYYY-MM-DD');
	}
	
	function getDateRangeBetweenDates(monthsAway) {
	  var startOfMonth = void 0;
	  var days = {};
	  days.lastMonth = false;
	  if (monthsAway === -1 || monthsAway === '-1') {
	    days.days = '-1';
	  } else {
	    var today = (0, _moment2.default)();
	    if (parseInt(monthsAway) > 1) {
	      startOfMonth = (0, _moment2.default)().subtract(monthsAway - 1, 'months').startOf('month');
	      days.days = today.diff(startOfMonth, 'days');
	    } else if (monthsAway === 1 || monthsAway === '1') {
	      startOfMonth = (0, _moment2.default)().subtract(1, 'month').startOf('month');
	      var endOfMonth = (0, _moment2.default)().subtract(1, 'month').endOf('month');
	      days.days = endOfMonth.diff(startOfMonth, 'days');
	      days.lastMonth = true;
	    } else if (monthsAway === 0 || monthsAway === '0') {
	      startOfMonth = (0, _moment2.default)().startOf('month');
	      days.days = today.diff(startOfMonth, 'days');
	    }
	  }
	  return days;
	}
	
	function grabMonthsToAndFromDates(days, fromDate, toDate, lastMonth) {
	  var dateRange = -1;
	  if (days != null) {
	    dateRange = days;
	  }
	  var date = {
	    fromDate: '',
	    toDate: ''
	  };
	  var dateGT = '';
	  var dateLT = '';
	  dateGT = fromDate ? (0, _moment2.default)(fromDate).startOf('day').toISOString() : minDateUtc();
	  dateLT = toDate ? (0, _moment2.default)(toDate).endOf('day').toISOString() : maxDateUtc();
	  if (!(dateRange === '-1' || dateRange === -1)) {
	    dateLT = (0, _moment2.default)().endOf('day').toISOString();
	    dateGT = (0, _moment2.default)(dateLT).startOf('day').subtract(days, 'days').toISOString();
	  }
	  if (lastMonth) {
	    dateGT = (0, _moment2.default)().subtract(1, 'month').startOf('month');
	    dateLT = (0, _moment2.default)(dateGT).endOf('month').subtract(1, 'day');
	    dateGT = dateGT.toISOString();
	    dateLT = dateLT.toISOString();
	  }
	  date.fromDate = dateGT;
	  date.toDate = dateLT;
	  return date;
	}
	
	function toFromDates(days, fromDate, toDate, format) {
	  var dateRange = -1;
	  if (days != null) {
	    dateRange = days;
	  }
	  var date = {
	    fromDate: '',
	    toDate: ''
	  };
	  var dateGT = '';
	  var dateLT = '';
	  if (format) {
	    if (!(dateRange === '-1' || dateRange === -1)) {
	      dateLT = (0, _moment2.default)().local().endOf('day').format(format);
	      if (dateRange === '1' || dateRange === 1) {
	        dateGT = (0, _moment2.default)().local().startOf('day').format(format);
	      } else if (dateRange === '2' || dateRange === 2) {
	        dateGT = (0, _moment2.default)(dateLT).local().subtract('2', 'days').startOf('day').format(format);
	      } else if (dateRange === '7' || dateRange === 7) {
	        dateGT = (0, _moment2.default)(dateLT).local().subtract('7', 'days').startOf('day').format(format);
	      } else if (dateRange === '30' || dateRange === 30) {
	        dateGT = (0, _moment2.default)(dateLT).local().subtract('30', 'days').startOf('day').format(format);
	      } else if (dateRange === '90' || dateRange === 90) {
	        dateGT = (0, _moment2.default)(dateLT).local().subtract('90', 'days').startOf('day').format(format);
	      }
	    }
	  } else {
	    dateGT = fromDate ? (0, _moment2.default)(fromDate).startOf('day').toISOString() : minDateUtc();
	    dateLT = toDate ? (0, _moment2.default)(toDate).endOf('day').toISOString() : maxDateUtc();
	    if (!(dateRange === '-1' || dateRange === -1)) {
	      dateLT = (0, _moment2.default)().endOf('day').toISOString();
	      if (dateRange === '1' || dateRange === 1) {
	        dateGT = (0, _moment2.default)().startOf('day').toISOString();
	      } else if (dateRange === '2' || dateRange === 2) {
	        dateGT = (0, _moment2.default)(dateLT).startOf('day').subtract('2', 'days').toISOString();
	      } else if (dateRange === '7' || dateRange === 7) {
	        dateGT = (0, _moment2.default)(dateLT).startOf('day').subtract('7', 'days').toISOString();
	      } else if (dateRange === '30' || dateRange === 30) {
	        dateGT = (0, _moment2.default)(dateLT).startOf('day').subtract('30', 'days').toISOString();
	      } else if (dateRange === '60' || dateRange === 60) {
	        dateGT = (0, _moment2.default)(dateLT).startOf('day').subtract('60', 'days').toISOString();
	      } else if (dateRange === '90' || dateRange === 90) {
	        dateGT = (0, _moment2.default)(dateLT).startOf('day').subtract('90', 'days').toISOString();
	      } else {
	        dateGT = (0, _moment2.default)(dateLT).startOf('day').subtract(days, 'days').toISOString();
	      }
	    }
	  }
	  date.fromDate = dateGT;
	  date.toDate = dateLT;
	  return date;
	}
	
	function toFromDispatchDates(days, dispatchDateLT, dispatchDateGT, format) {
	  var dateRange = -1;
	  if (days != null) {
	    dateRange = days;
	  }
	  var date = {
	    dispatchDateLT: '',
	    dispatchDateGT: ''
	  };
	  var dateLT = '';
	  var dateGT = '';
	  if (format) {
	    dateGT = dispatchDateGT ? (0, _moment2.default)(dispatchDateGT).startOf('day').toISOString() : minDateUtc();
	    dateLT = dispatchDateLT ? (0, _moment2.default)(dispatchDateLT).endOf('day').toISOString() : maxDateUtc();
	    if (!(dateRange === '-1' || dateRange === -1)) {
	      dateLT = (0, _moment2.default)().local().endOf('day').format(format);
	      if (dateRange === '1' || dateRange === 1) {
	        dateGT = (0, _moment2.default)().local().startOf('day').format(format);
	      } else if (dateRange === '7' || dateRange === 7) {
	        dateGT = (0, _moment2.default)(dateLT).local().subtract('7', 'days').startOf('day').format(format);
	      } else if (dateRange === '30' || dateRange === 30) {
	        dateGT = (0, _moment2.default)(dateLT).local().subtract('30', 'days').startOf('day').format(format);
	      } else if (dateRange === '90' || dateRange === 90) {
	        dateGT = (0, _moment2.default)(dateLT).local().subtract('90', 'days').startOf('day').format(format);
	      }
	    }
	  } else {
	    dateGT = dispatchDateLT ? (0, _moment2.default)(dispatchDateLT).startOf('day').toISOString() : minDateUtc();
	    dateLT = dispatchDateGT ? (0, _moment2.default)(dispatchDateGT).endOf('day').toISOString() : maxDateUtc();
	    if (!(dateRange === '-1' || dateRange === -1)) {
	      dateLT = (0, _moment2.default)().endOf('day').toISOString();
	      if (dateRange === '1' || dateRange === 1) {
	        dateGT = (0, _moment2.default)().startOf('day').toISOString();
	      } else if (dateRange === '7' || dateRange === 7) {
	        dateGT = (0, _moment2.default)(dateLT).startOf('day').subtract('7', 'days').toISOString();
	      } else if (dateRange === '30' || dateRange === 30) {
	        dateGT = (0, _moment2.default)(dateLT).startOf('day').subtract('30', 'days').toISOString();
	      } else if (dateRange === '90' || dateRange === 90) {
	        dateGT = (0, _moment2.default)(dateLT).startOf('day').subtract('90', 'days').toISOString();
	      }
	    }
	  }
	  date.dispatchDateGT = dateGT;
	  date.dispatchDateLT = dateLT;
	  return date;
	}
	
	/*
	* @unit definition, default value = 'day'
	* 'year'    // set to January 1st, 12:00 am this year
	* 'month'   // set to the first of this month, 12:00 am
	* 'quarter'  // set to the beginning of the current quarter, 1st day of months, 12:00 am
	* 'week'    // set to the first day of this week, 12:00 am
	* 'isoWeek' // set to the first day of this week according to ISO 8601, 12:00 am
	* 'day'     // set to 12:00 am today
	* 'date'     // set to 12:00 am today
	* 'hour'    // set to now, but with 0 mins, 0 secs, and 0 ms
	* 'minute'  // set to now, but with 0 seconds and 0 milliseconds
	* 'second'  // same as moment().milliseconds(0);
	*/
	function getFromToDates(date) {
	  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'day';
	
	  if (date) {
	    return {
	      fromDate: convertUtcDate((0, _moment2.default)(date).startOf(unit)),
	      toDate: convertUtcDate((0, _moment2.default)(date).endOf(unit))
	    };
	  }
	  return {};
	}
	
	function getFromToDatesWithFilter(_ref) {
	  var FromDate = _ref.FromDate,
	      ToDate = _ref.ToDate,
	      Year = _ref.Year,
	      Quarter = _ref.Quarter,
	      Month = _ref.Month;
	
	  var fromDate = FromDate ? (0, _moment2.default)(FromDate).startOf('day').toISOString() : minDateUtc();
	  var toDate = ToDate ? (0, _moment2.default)(ToDate).endOf('day').toISOString() : maxDateUtc();
	  if (Year) {
	    if (Month) {
	      // Moment month is 0 based
	      fromDate = (0, _moment2.default)([Year.value, Month.value - 1]);
	      toDate = (0, _moment2.default)(fromDate).endOf('month');
	    } else if (Quarter) {
	      // Starting month: 1 -> 0, 2 -> 3, 3 -> 6, 4 -> 9
	      fromDate = (0, _moment2.default)([Year.value, (Quarter.value - 1) * 3]);
	      // Ending month: 1 -> 2, 2 -> 5, 3 -> 8, 4 -> 11
	      toDate = (0, _moment2.default)([Year.value, Quarter.value * 3 - 1]).endOf('month');
	    } else {
	      // Moment month is 0 based
	      fromDate = (0, _moment2.default)().startOf('year');
	      toDate = (0, _moment2.default)().endOf('year');
	    }
	    fromDate = fromDate.toISOString();
	    toDate = toDate.toISOString();
	  }
	  return { fromDate: fromDate, toDate: toDate };
	}
	
	/**
	 *
	 * @param {Number} hours
	 * @param {Date} date
	 * @returns An ISOString of the specified date and hours in UTC
	 */
	function convertTimeToUtc(hours, date) {
	  return (0, _moment2.default)(date).startOf('day').add(hours, 'hours').toISOString();
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(dateFormat, 'dateFormat', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/cleanDates.jsx');
	
	  __REACT_HOT_LOADER__.register(maxDate, 'maxDate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/cleanDates.jsx');
	
	  __REACT_HOT_LOADER__.register(minDate, 'minDate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/cleanDates.jsx');
	
	  __REACT_HOT_LOADER__.register(maxDateUtc, 'maxDateUtc', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/cleanDates.jsx');
	
	  __REACT_HOT_LOADER__.register(minDateUtc, 'minDateUtc', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/cleanDates.jsx');
	
	  __REACT_HOT_LOADER__.register(convertUtcDate, 'convertUtcDate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/cleanDates.jsx');
	
	  __REACT_HOT_LOADER__.register(convertLocalDate, 'convertLocalDate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/cleanDates.jsx');
	
	  __REACT_HOT_LOADER__.register(getDateRangeBetweenDates, 'getDateRangeBetweenDates', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/cleanDates.jsx');
	
	  __REACT_HOT_LOADER__.register(grabMonthsToAndFromDates, 'grabMonthsToAndFromDates', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/cleanDates.jsx');
	
	  __REACT_HOT_LOADER__.register(toFromDates, 'toFromDates', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/cleanDates.jsx');
	
	  __REACT_HOT_LOADER__.register(toFromDispatchDates, 'toFromDispatchDates', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/cleanDates.jsx');
	
	  __REACT_HOT_LOADER__.register(getFromToDates, 'getFromToDates', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/cleanDates.jsx');
	
	  __REACT_HOT_LOADER__.register(getFromToDatesWithFilter, 'getFromToDatesWithFilter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/cleanDates.jsx');
	
	  __REACT_HOT_LOADER__.register(convertTimeToUtc, 'convertTimeToUtc', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/cleanDates.jsx');
	}();

	;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.fetchPurchaseOrders = fetchPurchaseOrders;
	exports.requestPurchaseOrders = requestPurchaseOrders;
	exports.fetchPurchaseOrdersSuccess = fetchPurchaseOrdersSuccess;
	exports.fetchPurchaseOrdersFailure = fetchPurchaseOrdersFailure;
	exports.fetchPurchaseOrdersByDate = fetchPurchaseOrdersByDate;
	exports.selectPurchaseOrder = selectPurchaseOrder;
	exports.resetCurrentPurchaseOrder = resetCurrentPurchaseOrder;
	exports.fetchPurchaseOrderDetail = fetchPurchaseOrderDetail;
	exports.requestPurchaseOrderDetail = requestPurchaseOrderDetail;
	exports.fetchPurchaseOrderDetailSuccess = fetchPurchaseOrderDetailSuccess;
	exports.fetchPurchaseOrderDetailFailure = fetchPurchaseOrderDetailFailure;
	exports.createPurchaseOrder = createPurchaseOrder;
	exports.createPurchaseOrderSuccess = createPurchaseOrderSuccess;
	exports.createPurchaseOrderFailure = createPurchaseOrderFailure;
	exports.createDropship = createDropship;
	exports.copyPurchaseOrder = copyPurchaseOrder;
	exports.copyPurchaseOrderSuccess = copyPurchaseOrderSuccess;
	exports.copyPurchaseOrderFailure = copyPurchaseOrderFailure;
	exports.createDropshipSuccess = createDropshipSuccess;
	exports.createDropshipFailure = createDropshipFailure;
	exports.editPurchaseOrder = editPurchaseOrder;
	exports.editPurchaseOrderSuccess = editPurchaseOrderSuccess;
	exports.editPurchaseOrderFailure = editPurchaseOrderFailure;
	exports.fetchPurchaseOrdersNotReceived = fetchPurchaseOrdersNotReceived;
	exports.requestPurchaseOrdersNotReceived = requestPurchaseOrdersNotReceived;
	exports.fetchPurchaseOrdersNotReceivedSuccess = fetchPurchaseOrdersNotReceivedSuccess;
	exports.fetchPurchaseOrdersNotReceivedFailure = fetchPurchaseOrdersNotReceivedFailure;
	exports.fetchTotalPurchases = fetchTotalPurchases;
	exports.requestTotalPurchases = requestTotalPurchases;
	exports.fetchTotalPurchasesSuccess = fetchTotalPurchasesSuccess;
	exports.fetchTotalPurchasesFailure = fetchTotalPurchasesFailure;
	exports.fetchTodaysIncomingOrders = fetchTodaysIncomingOrders;
	exports.requestTodaysIncomingOrders = requestTodaysIncomingOrders;
	exports.fetchTodaysIncomingOrdersSuccess = fetchTodaysIncomingOrdersSuccess;
	exports.fetchTodaysIncomingOrdersFailure = fetchTodaysIncomingOrdersFailure;
	exports.fetchIncomingOrdersByDate = fetchIncomingOrdersByDate;
	exports.printPurchaseOrder = printPurchaseOrder;
	exports.printPurchaseOrderSuccess = printPurchaseOrderSuccess;
	exports.printPurchaseOrderFailure = printPurchaseOrderFailure;
	exports.setPriceValues = setPriceValues;
	exports.setDefaultVendorAddress = setDefaultVendorAddress;
	exports.clearRemarks = clearRemarks;
	exports.setDefaults = setDefaults;
	exports.setValue = setValue;
	exports.fetchPurchaseOrderPerformance = fetchPurchaseOrderPerformance;
	exports.fetchPurchaseOrderPerformanceSuccess = fetchPurchaseOrderPerformanceSuccess;
	exports.fetchPurchaseOrderPerformanceFailure = fetchPurchaseOrderPerformanceFailure;
	exports.fetchPurchaseManagerInfo = fetchPurchaseManagerInfo;
	exports.fetchPurchaseManagerInfoSuccess = fetchPurchaseManagerInfoSuccess;
	exports.fetchPurchaseManagerInfoFailure = fetchPurchaseManagerInfoFailure;
	exports.fetchMonthPerformance = fetchMonthPerformance;
	exports.fetchMonthPerformanceSuccess = fetchMonthPerformanceSuccess;
	exports.fetchMonthPerformanceFailure = fetchMonthPerformanceFailure;
	exports.deletePurchaseOrder = deletePurchaseOrder;
	exports.deletePurchaseOrderSuccess = deletePurchaseOrderSuccess;
	exports.deletePurchaseOrderFailure = deletePurchaseOrderFailure;
	exports.fetchPurchasersPerformance = fetchPurchasersPerformance;
	exports.fetchPurchasersPerformanceSuccess = fetchPurchasersPerformanceSuccess;
	exports.fetchPurchasersPerformanceFailure = fetchPurchasersPerformanceFailure;
	exports.fetchPresidentDashInfo = fetchPresidentDashInfo;
	exports.fetchPresidentDAshInfoSuccess = fetchPresidentDAshInfoSuccess;
	exports.fetchPresidentDashInfoFailure = fetchPresidentDashInfoFailure;
	exports.fetchOverallPurchasePerformance = fetchOverallPurchasePerformance;
	exports.fetchOverallPurchasePerformanceSuccess = fetchOverallPurchasePerformanceSuccess;
	exports.fetchOverallPurchasePerformanceFailure = fetchOverallPurchasePerformanceFailure;
	exports.fetchIncidentReport = fetchIncidentReport;
	exports.fetchIncidentReportSuccess = fetchIncidentReportSuccess;
	exports.fetchIncidentReportFailure = fetchIncidentReportFailure;
	exports.setAllProducts = setAllProducts;
	exports.setDefaultSearchType = setDefaultSearchType;
	exports.initializedPurchaseOrderForm = initializedPurchaseOrderForm;
	exports.setDefaultIsDropship = setDefaultIsDropship;
	exports.setDefaultConvertItemPrice = setDefaultConvertItemPrice;
	exports.resetAllProducts = resetAllProducts;
	exports.setDefaultDays = setDefaultDays;
	exports.setDefaultOfForm = setDefaultOfForm;
	exports.changeFieldArrayOfForm = changeFieldArrayOfForm;
	exports.initializeForm = initializeForm;
	exports.fetchPurchaseOrderList = fetchPurchaseOrderList;
	exports.fetchPurchaseOrderListSuccess = fetchPurchaseOrderListSuccess;
	exports.fetchPurchaseOrderListFailure = fetchPurchaseOrderListFailure;
	exports.setPurchaseOrdersFilter = setPurchaseOrdersFilter;
	exports.fetchPurchasingPerformance = fetchPurchasingPerformance;
	exports.fetchPurchasingPerformanceSuccess = fetchPurchasingPerformanceSuccess;
	exports.fetchPurchasingPerformanceFailure = fetchPurchasingPerformanceFailure;
	exports.fetchPriceAdjustment = fetchPriceAdjustment;
	exports.createPriceAdjustment = createPriceAdjustment;
	exports.fetchPurchasePivotChartOrders = fetchPurchasePivotChartOrders;
	exports.fetchPurchasePivotCharts = fetchPurchasePivotCharts;
	exports.fetchPurchasePivotChartsDetail = fetchPurchasePivotChartsDetail;
	exports.setPurchasePivotChart = setPurchasePivotChart;
	exports.resetPurchasePivotCharts = resetPurchasePivotCharts;
	exports.createPurchasePivotChart = createPurchasePivotChart;
	exports.duplicatePivotChart = duplicatePivotChart;
	exports.clearDuplicatedPurchasePivotChart = clearDuplicatedPurchasePivotChart;
	exports.fetchPurchasingReference = fetchPurchasingReference;
	exports.fetchPurchasingReferenceSuccess = fetchPurchasingReferenceSuccess;
	exports.fetchPurchasingReferenceFailure = fetchPurchasingReferenceFailure;
	exports.fetchPurchasePaymentNotPaid = fetchPurchasePaymentNotPaid;
	exports.requestPurchasePaymentNotPaid = requestPurchasePaymentNotPaid;
	exports.fetchPurchasePaymentNotPaidSuccess = fetchPurchasePaymentNotPaidSuccess;
	exports.fetchPurchasePaymentNotPaidFailure = fetchPurchasePaymentNotPaidFailure;
	exports.fetchPurchasingPerformanceByProduct = fetchPurchasingPerformanceByProduct;
	exports.fetchPurchasingPerformanceByProductSuccess = fetchPurchasingPerformanceByProductSuccess;
	exports.fetchPurchasingPerformanceByProductFailure = fetchPurchasingPerformanceByProductFailure;
	exports.fetchPurchaseOrderProductByID = fetchPurchaseOrderProductByID;
	exports.fetchPurchaseOrderProductByIDSuccesful = fetchPurchaseOrderProductByIDSuccesful;
	exports.fetchPurchaseOrderProductByIDFailure = fetchPurchaseOrderProductByIDFailure;
	exports.mergePurchaseOrders = mergePurchaseOrders;
	exports.mergePurchaseOrdersLoading = mergePurchaseOrdersLoading;
	exports.mergePurchaseOrdersSuccess = mergePurchaseOrdersSuccess;
	exports.mergePurchaseOrdersError = mergePurchaseOrdersError;
	exports.approvePendingPO = approvePendingPO;
	exports.emailPO = emailPO;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(205);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _sales_actions = __webpack_require__(28);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_constants.DEFAULT_ERROR;
	
	function fetchPurchaseOrders() {
	  return function (dispatch) {
	    dispatch(requestPurchaseOrders());
	    return _axios2.default.get(_url.PURCHASE_ORDERS_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPurchaseOrdersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPurchaseOrdersFailure(err));
	    });
	  };
	}
	
	function requestPurchaseOrders() {
	  return {
	    type: _type.REQUEST_PURCHASE_ORDERS
	  };
	}
	
	function fetchPurchaseOrdersSuccess(purchaseOrders) {
	  return {
	    type: _type.FETCH_PURCHASE_ORDERS_SUCCESS,
	    payload: purchaseOrders
	  };
	}
	
	function fetchPurchaseOrdersFailure(error) {
	  return {
	    type: _type.FETCH_PURCHASE_ORDERS_FAILURE,
	    payload: error
	  };
	}
	
	function fetchPurchaseOrdersByDate(postingDateGT, postingDateLT, days) {
	  var dates = (0, _cleanDates.toFromDates)(days, postingDateGT, postingDateLT);
	  return function (dispatch) {
	    dispatch(requestPurchaseOrders());
	    return _axios2.default.get(_url.PURCHASE_URL + 'search/?OrderDate__gte=' + dates.fromDate + '&OrderDate__lte=' + dates.toDate, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPurchaseOrdersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPurchaseOrdersFailure(err));
	    });
	  };
	}
	
	function selectPurchaseOrder(purchaseOrder) {
	  return {
	    type: _type.SELECT_PURCHASE_ORDER,
	    payload: purchaseOrder
	  };
	}
	
	function resetCurrentPurchaseOrder() {
	  return {
	    type: _type.RESET_CURRENT_PURCHASE_ORDER
	  };
	}
	
	// Fetch the detail page.
	
	function fetchPurchaseOrderDetail(purchaseOrder_id) {
	  return function (dispatch) {
	    dispatch(requestPurchaseOrderDetail());
	    return _axios2.default.get(_url.PURCHASE_ORDERS_URL + purchaseOrder_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPurchaseOrderDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPurchaseOrderDetailFailure(err));
	    });
	  };
	}
	
	function requestPurchaseOrderDetail() {
	  return {
	    type: _type.REQUEST_PURCHASE_ORDER_DETAIL
	  };
	}
	
	function fetchPurchaseOrderDetailSuccess(purchaseOrderDetail) {
	  purchaseOrderDetail = purchaseOrderDetail.data;
	  // The date data fetched is in the form of string, which needs to be modified into Date type
	  if (purchaseOrderDetail.OrderDate) purchaseOrderDetail.OrderDate = (0, _cleanDates.convertUtcDate)(purchaseOrderDetail.OrderDate);
	  if (purchaseOrderDetail.ETADate) purchaseOrderDetail.ETADate = (0, _cleanDates.convertUtcDate)(purchaseOrderDetail.ETADate);
	  if (purchaseOrderDetail.ReceivedDate) purchaseOrderDetail.ReceivedDate = (0, _cleanDates.convertUtcDate)(purchaseOrderDetail.ReceivedDate);
	  return {
	    type: _type.FETCH_PURCHASE_ORDER_DETAIL_SUCCESS,
	    payload: purchaseOrderDetail
	  };
	}
	
	function fetchPurchaseOrderDetailFailure(error) {
	  return {
	    type: _type.FETCH_PURCHASE_ORDER_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function createPurchaseOrder(_ref, Purchase_Order_Line, AttachedFile, TaxRate, CRV, FinalNetWeight, FinalShippingWeight, TotalPrice, FinalPrice) {
	  var OrderDate = _ref.OrderDate,
	      ETADate = _ref.ETADate,
	      ReceivedDate = _ref.ReceivedDate,
	      NoteToVendor = _ref.NoteToVendor,
	      ReleaseInformation = _ref.ReleaseInformation,
	      CarryType = _ref.CarryType,
	      Discount = _ref.Discount,
	      ShippingCost = _ref.ShippingCost,
	      HandlingCost = _ref.HandlingCost,
	      PurchaseStatus = _ref.PurchaseStatus,
	      PaymentTerm_id = _ref.PaymentTerm_id,
	      MiscCost = _ref.MiscCost,
	      MiscNote = _ref.MiscNote,
	      PriceAdjustment = _ref.PriceAdjustment,
	      PaymentStatus = _ref.PaymentStatus,
	      ConvertItemPrice = _ref.ConvertItemPrice,
	      IsDropship = _ref.IsDropship,
	      Vendor_id = _ref.Vendor_id,
	      Pickup_VendorDetail_id = _ref.Pickup_VendorDetail_id,
	      Deliver_Warehouse_id = _ref.Deliver_Warehouse_id,
	      DispatchMethod_id = _ref.DispatchMethod_id,
	      DispatchOutSourceContact_id = _ref.DispatchOutSourceContact_id,
	      Purchaser_User_id = _ref.Purchaser_User_id,
	      Modifier_User_id = _ref.Modifier_User_id,
	      ShippingMethod = _ref.ShippingMethod,
	      TaxValue = _ref.TaxValue;
	
	  Purchase_Order_Line.map(function (product) {
	    if (product.Product_id) {
	      product.Product_id = product.Product_id.value || product.Product_id;
	    }
	  });
	  if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
	  if (PaymentStatus) PaymentStatus = PaymentStatus.value || PaymentStatus;
	  if (Pickup_VendorDetail_id) Pickup_VendorDetail_id = Pickup_VendorDetail_id.value || Pickup_VendorDetail_id;
	  if (CarryType) CarryType = CarryType.value || CarryType;
	  if (PaymentTerm_id) PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
	  if (Deliver_Warehouse_id) Deliver_Warehouse_id = Deliver_Warehouse_id.value || Deliver_Warehouse_id;
	  if (ShippingMethod) ShippingMethod = ShippingMethod.value || ShippingMethod;
	  if (OrderDate == null) OrderDate = (0, _cleanDates.convertUtcDate)();
	  if (ETADate == null) ETADate = (0, _cleanDates.convertUtcDate)();
	  var TaxAmount = 0;
	  if (TaxValue) TaxAmount = TaxValue.value || TaxValue;
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CREATING_PURCHASE_ORDER });
	    _axios2.default.post(_url.PURCHASE_ORDERS_URL, {
	      Purchase_Order_Line: Purchase_Order_Line,
	      OrderDate: OrderDate,
	      ETADate: ETADate,
	      ReceivedDate: ReceivedDate,
	      FinalNetWeight: FinalNetWeight,
	      FinalShippingWeight: FinalShippingWeight,
	      TotalPrice: TotalPrice,
	      NoteToVendor: NoteToVendor,
	      ReleaseInformation: ReleaseInformation,
	      CarryType: CarryType,
	      Discount: Discount,
	      ShippingCost: ShippingCost,
	      HandlingCost: HandlingCost,
	      PriceAdjustment: PriceAdjustment,
	      MiscCost: MiscCost,
	      MiscNote: MiscNote,
	      TaxRate: TaxRate,
	      TaxAmount: TaxAmount,
	      PurchaseStatus: PurchaseStatus,
	      PaymentTerm_id: PaymentTerm_id,
	      PaymentStatus: PaymentStatus,
	      FinalPrice: FinalPrice,
	      ConvertItemPrice: ConvertItemPrice,
	      IsDropship: IsDropship,
	      Vendor_id: Vendor_id,
	      Pickup_VendorDetail_id: Pickup_VendorDetail_id,
	      Deliver_Warehouse_id: Deliver_Warehouse_id,
	      DispatchMethod_id: DispatchMethod_id,
	      DispatchOutSourceContact_id: DispatchOutSourceContact_id,
	      Purchaser_User_id: Purchaser_User_id,
	      Modifier_User_id: Modifier_User_id,
	      AttachedFile: AttachedFile,
	      ShippingMethod: ShippingMethod,
	      CRV: CRV
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(createPurchaseOrderSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(createPurchaseOrderFailure(err));
	    });
	  };
	}
	
	function createPurchaseOrderSuccess(response) {
	  return {
	    type: _type.CREATE_PURCHASE_ORDER_SUCCESS,
	    payload: response
	  };
	}
	
	function createPurchaseOrderFailure(error) {
	  return {
	    type: _type.CREATE_PURCHASE_ORDER_FAILURE,
	    payload: error
	  };
	}
	
	function createDropship(Deliver_Customer_id, Deliver_CustomerDetail_id, Customer_PaymentTerm_id, _ref2, Purchase_Order_Line, FinalNetWeight, FinalShippingWeight, TotalPrice, FinalPrice) {
	  var OrderDate = _ref2.OrderDate,
	      ETADate = _ref2.ETADate,
	      ReceivedDate = _ref2.ReceivedDate,
	      NoteToVendor = _ref2.NoteToVendor,
	      ReleaseInformation = _ref2.ReleaseInformation,
	      CarryType = _ref2.CarryType,
	      Discount = _ref2.Discount,
	      ShippingCost = _ref2.ShippingCost,
	      HandlingCost = _ref2.HandlingCost,
	      PurchaseStatus = _ref2.PurchaseStatus,
	      MiscCost = _ref2.MiscCost,
	      MiscNote = _ref2.MiscNote,
	      TaxRate = _ref2.TaxRate,
	      PaymentStatus = _ref2.PaymentStatus,
	      PaymentTerm_id = _ref2.PaymentTerm_id,
	      ConvertItemPrice = _ref2.ConvertItemPrice,
	      IsDropship = _ref2.IsDropship,
	      Vendor_id = _ref2.Vendor_id,
	      Pickup_VendorDetail_id = _ref2.Pickup_VendorDetail_id,
	      Deliver_Warehouse_id = _ref2.Deliver_Warehouse_id,
	      DispatchMethod_id = _ref2.DispatchMethod_id,
	      DispatchOutSourceContact_id = _ref2.DispatchOutSourceContact_id,
	      Purchaser_User_id = _ref2.Purchaser_User_id,
	      Modifier_User_id = _ref2.Modifier_User_id;
	
	  Purchase_Order_Line.map(function (product) {
	    if (product.Product_id) {
	      product.Product_id = product.Product_id.value || product.Product_id;
	    }
	  });
	  if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
	  if (PaymentStatus) PaymentStatus = PaymentStatus.value || PaymentStatus;
	  if (Pickup_VendorDetail_id) Pickup_VendorDetail_id = Pickup_VendorDetail_id.value || Pickup_VendorDetail_id;
	  if (CarryType) CarryType = CarryType.value || CarryType;
	  if (PaymentTerm_id) PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
	  if (Deliver_Warehouse_id) Deliver_Warehouse_id = Deliver_Warehouse_id.value || Deliver_Warehouse_id;
	  if (OrderDate == null) OrderDate = (0, _cleanDates.convertUtcDate)();
	  if (ETADate == null) ETADate = (0, _cleanDates.convertUtcDate)();
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CREATING_PURCHASE_ORDER });
	    _axios2.default.post(_url.PURCHASE_ORDERS_URL, {
	      Purchase_Order_Line: Purchase_Order_Line,
	      OrderDate: OrderDate,
	      ETADate: ETADate,
	      ReceivedDate: ReceivedDate,
	      FinalNetWeight: FinalNetWeight,
	      FinalShippingWeight: FinalShippingWeight,
	      TotalPrice: TotalPrice,
	      NoteToVendor: NoteToVendor,
	      ReleaseInformation: ReleaseInformation,
	      CarryType: CarryType,
	      Discount: Discount,
	      ShippingCost: ShippingCost,
	      HandlingCost: HandlingCost,
	      MiscCost: MiscCost,
	      MiscNote: MiscNote,
	      TaxRate: TaxRate,
	      PurchaseStatus: PurchaseStatus,
	      PaymentStatus: PaymentStatus,
	      PaymentTerm_id: PaymentTerm_id,
	      FinalPrice: FinalPrice,
	      ConvertItemPrice: ConvertItemPrice,
	      IsDropship: IsDropship,
	      Vendor_id: Vendor_id,
	      Pickup_VendorDetail_id: Pickup_VendorDetail_id,
	      Deliver_Warehouse_id: Deliver_Warehouse_id,
	      DispatchMethod_id: DispatchMethod_id,
	      DispatchOutSourceContact_id: DispatchOutSourceContact_id,
	      Purchaser_User_id: Purchaser_User_id,
	      Modifier_User_id: Modifier_User_id
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      copyPurchaseOrder(dispatch, response.data.PurchaseOrder_id, Deliver_Customer_id, Deliver_CustomerDetail_id, Customer_PaymentTerm_id);
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(createDropshipFailure(err));
	    });
	  };
	}
	
	function copyPurchaseOrder(dispatch, PurchaseOrder_id, Deliver_Customer_id, Deliver_CustomerDetail_id, PaymentTerm_id) {
	  _axios2.default.post(_url.PURCHASE_URL + 'dropship/' + PurchaseOrder_id, {
	    Deliver_Customer_id: Deliver_Customer_id,
	    Deliver_CustomerDetail_id: Deliver_CustomerDetail_id,
	    PaymentTerm_id: PaymentTerm_id
	  }, {
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (response) {
	    (0, _sales_actions.resetCurrentSalesOrder)();
	    dispatch((0, _sales_actions.selectSalesOrder)(response.data));
	    _reactRouter.browserHistory.push('/salesOrders/' + response.data.SalesOrder_id);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    dispatch(createDropshipFailure(err));
	  });
	}
	
	function copyPurchaseOrderSuccess() {
	  console.log('sucess');
	  return {
	    type: _type.COPY_PURCHASE_ORDER_SUCCESS
	  };
	}
	
	function copyPurchaseOrderFailure(error) {
	  return {
	    type: _type.COPY_PURCHASE_ORDER_FAILURE,
	    payload: error
	  };
	}
	
	function createDropshipSuccess() {
	  return {
	    type: _type.CREATE_PURCHASE_ORDER_SUCCESS
	  };
	}
	
	function createDropshipFailure(error) {
	  return {
	    type: _type.CREATE_PURCHASE_ORDER_FAILURE,
	    payload: error
	  };
	}
	
	function editPurchaseOrder(_ref3, Purchase_Order_Line, AttachedFile, TaxRate, CRV, FinalNetWeight, FinalShippingWeight, TotalPrice, FinalPrice) {
	  var PurchaseOrder_id = _ref3.PurchaseOrder_id,
	      Name = _ref3.Name,
	      OrderDate = _ref3.OrderDate,
	      ETADate = _ref3.ETADate,
	      ReceivedDate = _ref3.ReceivedDate,
	      NoteToVendor = _ref3.NoteToVendor,
	      ReleaseInformation = _ref3.ReleaseInformation,
	      CarryType = _ref3.CarryType,
	      Discount = _ref3.Discount,
	      ShippingCost = _ref3.ShippingCost,
	      HandlingCost = _ref3.HandlingCost,
	      PriceAdjustment = _ref3.PriceAdjustment,
	      MiscCost = _ref3.MiscCost,
	      MiscNote = _ref3.MiscNote,
	      PaymentStatus = _ref3.PaymentStatus,
	      PaymentTerm_id = _ref3.PaymentTerm_id,
	      PurchaseStatus = _ref3.PurchaseStatus,
	      ConvertItemPrice = _ref3.ConvertItemPrice,
	      IsDropship = _ref3.IsDropship,
	      Vendor_id = _ref3.Vendor_id,
	      Pickup_VendorDetail_id = _ref3.Pickup_VendorDetail_id,
	      Deliver_Warehouse_id = _ref3.Deliver_Warehouse_id,
	      DispatchMethod_id = _ref3.DispatchMethod_id,
	      DispatchOutSourceContact_id = _ref3.DispatchOutSourceContact_id,
	      Purchaser_User_id = _ref3.Purchaser_User_id,
	      Modifier_User_id = _ref3.Modifier_User_id,
	      InStock = _ref3.InStock,
	      Ordered = _ref3.Ordered,
	      PreSale = _ref3.PreSale,
	      Salebale = _ref3.Salebale,
	      ShippingMethod = _ref3.ShippingMethod,
	      TaxValue = _ref3.TaxValue;
	
	  Purchase_Order_Line.map(function (product) {
	    if (product.Product_id) {
	      product.Product_id = product.Product_id.value || product.Product_id;
	    }
	  });
	  if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
	  if (PaymentStatus) PaymentStatus = PaymentStatus.value || PaymentStatus;
	  if (PaymentTerm_id) PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
	  if (Pickup_VendorDetail_id) Pickup_VendorDetail_id = Pickup_VendorDetail_id.value || Pickup_VendorDetail_id;
	  if (CarryType) CarryType = CarryType.value || CarryType || 'Dry';
	  if (Deliver_Warehouse_id) Deliver_Warehouse_id = Deliver_Warehouse_id.value || Deliver_Warehouse_id;
	  if (ShippingMethod) ShippingMethod = ShippingMethod.value || ShippingMethod;
	  var TaxAmount = 0;
	  if (TaxValue) TaxAmount = TaxValue.value || TaxValue;
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EDITING_PURCHASE_ORDER });
	    _axios2.default.put(_url.PURCHASE_ORDERS_URL + PurchaseOrder_id, {
	      Purchase_Order_Line: Purchase_Order_Line,
	      Name: Name,
	      OrderDate: OrderDate,
	      ETADate: ETADate,
	      ReceivedDate: ReceivedDate,
	      FinalNetWeight: FinalNetWeight,
	      FinalShippingWeight: FinalShippingWeight,
	      TotalPrice: TotalPrice,
	      NoteToVendor: NoteToVendor,
	      ReleaseInformation: ReleaseInformation,
	      CarryType: CarryType,
	      Discount: Discount,
	      ShippingCost: ShippingCost,
	      HandlingCost: HandlingCost,
	      PriceAdjustment: PriceAdjustment,
	      MiscCost: MiscCost,
	      MiscNote: MiscNote,
	      TaxRate: TaxRate,
	      TaxAmount: TaxAmount,
	      PurchaseStatus: PurchaseStatus,
	      PaymentStatus: PaymentStatus,
	      PaymentTerm_id: PaymentTerm_id,
	      FinalPrice: FinalPrice,
	      ConvertItemPrice: ConvertItemPrice,
	      IsDropship: IsDropship,
	      Vendor_id: Vendor_id,
	      Pickup_VendorDetail_id: Pickup_VendorDetail_id,
	      Deliver_Warehouse_id: Deliver_Warehouse_id,
	      DispatchMethod_id: DispatchMethod_id,
	      DispatchOutSourceContact_id: DispatchOutSourceContact_id,
	      Purchaser_User_id: Purchaser_User_id,
	      Modifier_User_id: Modifier_User_id,
	      AttachedFile: AttachedFile,
	      ShippingMethod: ShippingMethod,
	      CRV: CRV
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editPurchaseOrderSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editPurchaseOrderFailure(err));
	    });
	  };
	}
	
	function editPurchaseOrderSuccess() {
	  return {
	    type: _type.EDIT_PURCHASE_ORDER_SUCCESS
	  };
	}
	
	function editPurchaseOrderFailure(error) {
	  return {
	    type: _type.EDIT_PURCHASE_ORDER_FAILURE,
	    payload: error
	  };
	}
	
	function fetchPurchaseOrdersNotReceived() {
	  return function (dispatch) {
	    dispatch(requestPurchaseOrdersNotReceived());
	    return _axios2.default.get(_url.PURCHASE_ORDERS_NOT_RECEIVED_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPurchaseOrdersNotReceivedSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPurchaseOrdersNotReceivedFailure(err));
	    });
	  };
	}
	
	function requestPurchaseOrdersNotReceived() {
	  return {
	    type: _type.REQUEST_PURCHASE_ORDERS_NOT_RECEIVED
	  };
	}
	
	function fetchPurchaseOrdersNotReceivedSuccess(purchaseOrders) {
	  return {
	    type: _type.FETCH_PURCHASE_ORDERS_NOT_RECEIVED_SUCCESS,
	    payload: purchaseOrders
	  };
	}
	
	function fetchPurchaseOrdersNotReceivedFailure(error) {
	  return {
	    type: _type.FETCH_PURCHASE_ORDERS_NOT_RECEIVED_FAILURE,
	    payload: error
	  };
	}
	
	function fetchTotalPurchases() {
	  return function (dispatch) {
	    dispatch(requestTotalPurchases());
	    return _axios2.default.get(_url.TOTAL_PURCHASES_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchTotalPurchasesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchTotalPurchasesFailure(err));
	    });
	  };
	}
	
	function requestTotalPurchases() {
	  return {
	    type: _type.REQUEST_TOTAL_PURCHASES
	  };
	}
	
	function fetchTotalPurchasesSuccess(totalPurchases) {
	  return {
	    type: _type.FETCH_TOTAL_PURCHASES_SUCCESS,
	    payload: totalPurchases
	  };
	}
	
	function fetchTotalPurchasesFailure(error) {
	  return {
	    type: _type.FETCH_TOTAL_PURCHASES_FAILURE,
	    payload: error
	  };
	}
	
	function fetchTodaysIncomingOrders() {
	  return function (dispatch) {
	    dispatch(requestTodaysIncomingOrders());
	    return _axios2.default.get(_url.INCOMING_ORDERS_BY_DATE_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchTodaysIncomingOrdersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchTodaysIncomingOrdersFailure(err));
	    });
	  };
	}
	
	function requestTodaysIncomingOrders() {
	  return {
	    type: _type.REQUEST_TODAYS_INCOMING_ORDERS
	  };
	}
	
	function fetchTodaysIncomingOrdersSuccess(orders) {
	  return {
	    type: _type.FETCH_TODAYS_INCOMING_ORDERS_SUCCESS,
	    payload: orders
	  };
	}
	
	function fetchTodaysIncomingOrdersFailure(error) {
	  return {
	    type: _type.FETCH_TODAYS_INCOMING_ORDERS_FAILURE,
	    payload: error
	  };
	}
	
	function fetchIncomingOrdersByDate(_ref4) {
	  var fromDate = _ref4.fromDate,
	      toDate = _ref4.toDate;
	
	  return function (dispatch) {
	    dispatch(requestTodaysIncomingOrders());
	    return (0, _axios2.default)({
	      method: 'get',
	      url: _url.INCOMING_ORDERS_BY_DATE_URL,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      params: {
	        start_date: fromDate,
	        end_date: toDate
	      }
	    }).then(function (response) {
	      dispatch(fetchTodaysIncomingOrdersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchTodaysIncomingOrdersFailure(err));
	    });
	  };
	}
	
	function printPurchaseOrder(purchaseOrder_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PRINT_PURCHASE_ORDER });
	    return _axios2.default.get(_url.PURCHASE_ORDERS_URL + 'print/' + purchaseOrder_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      window.open('data:application/pdf,' + escape(response.data));
	      dispatch(printPurchaseOrderSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(printPurchaseOrderFailure(err));
	    });
	  };
	}
	
	function printPurchaseOrderSuccess(orders) {
	  return {
	    type: _type.PRINT_PURCHASE_ORDER_SUCCESS,
	    payload: orders
	  };
	}
	
	function printPurchaseOrderFailure(error) {
	  return {
	    type: _type.PRINT_PURCHASE_ORDER_FAILURE,
	    payload: error
	  };
	}
	
	function setPriceValues(FOBUnit, EstSale, Form) {
	  // clearRemarks();
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)(Form, 'AllProd_FOBUnitPrice', FOBUnit));
	    dispatch((0, _reduxForm.change)(Form, 'AllProd_EstSalePrice', EstSale));
	  };
	}
	
	function setDefaultVendorAddress(address, contact, Form) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)(Form, 'Pickup_VendorAddress_id', address));
	    dispatch((0, _reduxForm.change)(Form, 'Pickup_VendorContact_id', contact));
	  };
	}
	
	function clearRemarks(Form) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)(Form, 'AllProd_Remark', ''));
	    dispatch((0, _reduxForm.change)(Form, 'Remark', ''));
	  };
	}
	
	function setDefaults(Form, value) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)(Form, 'Deliver_Warehouse_id', value));
	  };
	}
	
	function setValue(Form, Field, Value) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)(Form, Field, Value));
	  };
	}
	
	function fetchPurchaseOrderPerformance() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PURCHASE_ORDER_PERFORMANCE });
	    return _axios2.default.get(_url.PURCHASE_ORDER_PERFORMANCE_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPurchaseOrderPerformanceSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPurchaseOrderPerformanceFailure(err));
	    });
	  };
	}
	
	function fetchPurchaseOrderPerformanceSuccess(data) {
	  return {
	    type: _type.FETCH_PURCHASE_ORDER_PERFORMANCE_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchPurchaseOrderPerformanceFailure(error) {
	  return {
	    type: _type.FETCH_PURCHASE_ORDER_PERFORMANCE_FAILURE,
	    payload: error
	  };
	}
	
	function fetchPurchaseManagerInfo() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PURCHASE_MANAGER_INFO });
	    return _axios2.default.get(_url.PURCHASE_MANAGER_INFO_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPurchaseManagerInfoSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPurchaseManagerInfoFailure(err));
	    });
	  };
	}
	
	function fetchPurchaseManagerInfoSuccess(info) {
	  return {
	    type: _type.FETCH_PURCHASE_MANAGER_INFO_SUCCESS,
	    payload: info
	  };
	}
	
	function fetchPurchaseManagerInfoFailure(error) {
	  return {
	    type: _type.FETCH_PURCHASE_MANAGER_INFO_FAILURE,
	    payload: error
	  };
	}
	
	function fetchMonthPerformance() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_LAST_MONTH_PERFORMANCE });
	    return _axios2.default.get(_url.LAST_MONTH_PERFORMANCE_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchMonthPerformanceSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchMonthPerformanceFailure(err));
	    });
	  };
	}
	
	function fetchMonthPerformanceSuccess(data) {
	  return {
	    type: _type.FETCH_LAST_MONTH_PERFORMANCE_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchMonthPerformanceFailure(error) {
	  return {
	    type: _type.FETCH_LAST_MONTH_PERFORMANCE_FAILURE,
	    payload: error
	  };
	}
	
	function deletePurchaseOrder(purchaseOrder_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_DELETE_PURCHASE_ORDER });
	    return _axios2.default.get(_url.PURCHASE_ORDERS_URL + purchaseOrder_id + '/cancel/', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(deletePurchaseOrderSuccess());
	      _reactRouter.browserHistory.push('/purchaseOrder');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(deletePurchaseOrderFailure(err));
	    });
	  };
	}
	
	function deletePurchaseOrderSuccess() {
	  return {
	    type: _type.DELETE_PURCHASE_ORDER_SUCCESS
	  };
	}
	
	function deletePurchaseOrderFailure(error) {
	  return {
	    type: _type.DELETE_PURCHASE_ORDER_FAILURE,
	    payload: error
	  };
	}
	
	function fetchPurchasersPerformance() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PURCHASERS_PERFORMANCE });
	    return _axios2.default.get(_url.LAST_MONTH_PERFORMANCE_URL + 'all/', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPurchasersPerformanceSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPurchasersPerformanceFailure(err));
	    });
	  };
	}
	
	function fetchPurchasersPerformanceSuccess(records) {
	  return {
	    type: _type.FETCH_PURCHASERS_PERFORMANCE_SUCCESS,
	    payload: records
	  };
	}
	
	function fetchPurchasersPerformanceFailure(error) {
	  return {
	    type: _type.FETCH_PURCHASERS_PERFORMANCE_FAILURE,
	    payload: error
	  };
	}
	
	function fetchPresidentDashInfo() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PRESIDENT_DASH_INFO });
	    return _axios2.default.get(_url.PRESIDENT_DASH_INFO_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPresidentDAshInfoSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPresidentDashInfoFailure(err));
	    });
	  };
	}
	
	function fetchPresidentDAshInfoSuccess(info) {
	  return {
	    type: _type.FETCH_PRESIDENT_DASH_INFO_SUCCESS,
	    payload: info
	  };
	}
	
	function fetchPresidentDashInfoFailure(error) {
	  return {
	    type: _type.FETCH_PRESIDENT_DASH_INFO_FAILURE,
	    payload: error
	  };
	}
	
	function fetchOverallPurchasePerformance(type) {
	  var start_date = (0, _moment2.default)().toISOString();
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_OVERALL_PURCHASE_PERFORMANCE });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: _url.OVERALL_PURCHASE_PERFORMANCE_URL,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      params: {
	        type: type,
	        start_date: start_date
	      }
	    }).then(function (response) {
	      dispatch(fetchOverallPurchasePerformanceSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchOverallPurchasePerformanceFailure(err));
	    });
	  };
	}
	
	function fetchOverallPurchasePerformanceSuccess(data) {
	  return {
	    type: _type.FETCH_OVERALL_PURCHASE_PERFORMANCE_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchOverallPurchasePerformanceFailure(error) {
	  return {
	    type: _type.FETCH_OVERALL_PURCHASE_PERFORMANCE_FAILURE,
	    payload: error
	  };
	}
	
	function fetchIncidentReport() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_INCIDENT_REPORT });
	    return _axios2.default.get(_url.INCIDENT_REPORT_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchIncidentReportSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchIncidentReportFailure(err));
	    });
	  };
	}
	
	function fetchIncidentReportSuccess(report) {
	  return {
	    type: _type.FETCH_INCIDENT_REPORT_SUCCESS,
	    payload: report
	  };
	}
	
	function fetchIncidentReportFailure(error) {
	  return {
	    type: _type.FETCH_INCIDENT_REPORT_FAILURE,
	    payload: error
	  };
	}
	
	function setAllProducts(product, Form) {
	  console.log('set all products', product, Form);
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)(Form, 'AllProducts', product));
	  };
	}
	
	function setDefaultSearchType(type, Form) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)(Form, 'searchType', type));
	    dispatch((0, _reduxForm.change)(Form, 'AllProd_Quantity', 1));
	  };
	}
	
	function initializedPurchaseOrderForm(type, Form) {
	  console.log('initializing');
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)(Form, 'searchType', type));
	    dispatch((0, _reduxForm.change)(Form, 'AllProd_Quantity', 1));
	  };
	}
	
	function setDefaultIsDropship(type, Form) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)(Form, 'IsDropship', type));
	  };
	}
	
	function setDefaultConvertItemPrice(type, Form) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)(Form, 'ConvertItemPrice', type));
	  };
	}
	
	function resetAllProducts(Form) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)(Form, 'AllProducts', ''));
	    dispatch((0, _reduxForm.change)(Form, 'AllProd_Quantity', '1'));
	    dispatch((0, _reduxForm.change)(Form, 'AllProd_FOBUnitPrice', ''));
	    dispatch((0, _reduxForm.change)(Form, 'AllProd_EstSalePrice', ''));
	    dispatch((0, _reduxForm.change)(Form, 'ProductInformation', ''));
	    dispatch((0, _reduxForm.change)(Form, 'Quantity', 1));
	    dispatch((0, _reduxForm.change)(Form, 'FOBUnitPrice', ''));
	    dispatch((0, _reduxForm.change)(Form, 'EstSalePrice', ''));
	    dispatch((0, _reduxForm.change)(Form, 'Weight', ''));
	    dispatch((0, _reduxForm.change)(Form, 'AllProd_Remark', ''));
	    dispatch((0, _reduxForm.change)(Form, 'RefSalePrice', ''));
	  };
	}
	
	// export function setInitialForm(currentPurchaseOrderDetail, Form) {
	//   return dispatch => {
	//
	//     dispatch(change(Form, 'Vendor_id', currentPurchaseOrderDetail.Vendor_id));
	//     dispatch(change(Form, 'PurchaseOrder_id', currentPurchaseOrderDetail.PurchaseOrder_id));
	//     dispatch(change(Form, 'OrderDate', currentPurchaseOrderDetail.OrderDate));
	//     dispatch(change(Form, 'ETADate', currentPurchaseOrderDetail.ETADate));
	//     dispatch(change(Form, 'ReceivedDate', currentPurchaseOrderDetail.ReceivedDate));
	//     dispatch(change(Form, 'FinalNetWeight', currentPurchaseOrderDetail.FinalNetWeight));
	//     dispatch(change(Form, 'FinalShippingWeight', currentPurchaseOrderDetail.FinalShippingWeight));
	//     dispatch(change(Form, 'TotalPrice', currentPurchaseOrderDetail.TotalPrice));
	//     dispatch(change(Form, 'NoteToVendor', currentPurchaseOrderDetail.NoteToVendor));
	//     dispatch(change(Form, 'ReleaseInformation', currentPurchaseOrderDetail.ReleaseInformation));
	//     dispatch(change(Form, 'CarryType', currentPurchaseOrderDetail.CarryType));
	//     dispatch(change(Form, 'Discount', currentPurchaseOrderDetail.Discount));
	//     dispatch(change(Form, 'ShippingCost', currentPurchaseOrderDetail.ShippingCost));
	//     dispatch(change(Form, 'HandlingCost', currentPurchaseOrderDetail.HandlingCost));
	//     dispatch(change(Form, 'MiscCost', currentPurchaseOrderDetail.MiscCost));
	//     dispatch(change(Form, 'MiscNote', currentPurchaseOrderDetail.MiscNote));
	//     dispatch(change(Form, 'PaymentStatus', currentPurchaseOrderDetail.PaymentStatus));
	//     dispatch(change(Form, 'PaymentTerm_id', currentPurchaseOrderDetail.PaymentTerm_id));
	//     dispatch(change(Form, 'PurchaseStatus', currentPurchaseOrderDetail.PurchaseStatus));
	//     dispatch(change(Form, 'FinalPrice', currentPurchaseOrderDetail.FinalPrice));
	//     dispatch(change(Form, 'ConvertItemPrice', currentPurchaseOrderDetail.ConvertItemPrice));
	//     dispatch(change(Form, 'Pickup_VendorAddress_id', currentPurchaseOrderDetail.Pickup_VendorAddress_id));
	//     dispatch(change(Form, 'Vendor_id', currentPurchaseOrderDetail.Vendor_id));
	//     dispatch(change(Form, 'PurchaseOrder_id', currentPurchaseOrderDetail.PurchaseOrder_id));
	//     dispatch(change(Form, 'Pickup_VendorContact_id', currentPurchaseOrderDetail.Pickup_VendorContact_id));
	//     dispatch(change(Form, 'Deliver_Warehouse_id', currentPurchaseOrderDetail.Deliver_Warehouse_id));
	//     dispatch(change(Form, 'DispatchMethod_id', currentPurchaseOrderDetail.DispatchMethod_id));
	//     dispatch(change(Form, 'DispatchOutSourceContact_id', currentPurchaseOrderDetail.DispatchOutSourceContact_id));
	//     dispatch(change(Form, 'Purchaser_User_id', currentPurchaseOrderDetail.Purchaser_User_id));
	//     dispatch(change(Form, 'PurchaseOrder_id', currentPurchaseOrderDetail.PurchaseOrder_id));
	//     dispatch(change(Form, 'Modifier_User_id', currentPurchaseOrderDetail.Modifier_User_id));
	//     dispatch(change(Form, 'ShippingMethod', currentPurchaseOrderDetail.ShippingMethod));
	//     dispatch(change(Form, 'IsDropship', currentPurchaseOrderDetail.IsDropship));
	//     dispatch(change(Form, 'searchType', 'RefNum'));
	//   }
	// }
	
	function setDefaultDays(Form) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)(Form, 'Days', '7'));
	  };
	}
	
	function setDefaultOfForm(field, value, Form) {
	  // console.log('set Default Of Form', field, value, Form);
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)(Form, field, value));
	  };
	}
	
	function changeFieldArrayOfForm(field, idx, value, Form) {
	  // console.log('set Default Of Form', field, idx, value, Form);
	  return function (dispatch) {
	    dispatch((0, _reduxForm.arrayRemove)(Form, field, idx));
	    dispatch((0, _reduxForm.arrayInsert)(Form, field, idx, value));
	  };
	}
	
	function initializeForm(data, fields, Form) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.initialize)(Form, data, fields));
	  };
	}
	
	function fetchPurchaseOrderList(pk) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PURCHASE_ORDER_LIST });
	    return _axios2.default.get(_url.PURCHASE_ORDERS_URL + 'detail' + ('/' + pk), {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPurchaseOrderListSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPurchaseOrderListFailure(err));
	    });
	  };
	}
	
	function fetchPurchaseOrderListSuccess(list) {
	  return {
	    type: _type.FETCH_PURCHASE_ORDER_LIST_SUCCESS,
	    payload: list
	  };
	}
	
	function fetchPurchaseOrderListFailure(error) {
	  return {
	    type: _type.FETCH_PURCHASE_ORDER_LIST_FAILURE,
	    payload: error
	  };
	}
	
	function setPurchaseOrdersFilter(data) {
	  return {
	    type: _type.SET_PURCHASE_ORDERS_FILTER,
	    payload: data
	  };
	}
	
	function fetchPurchasingPerformance(days, fromDate, toDate, type, POStatus, Vendor_id) {
	  var dates = (0, _cleanDates.toFromDates)(days, fromDate, toDate);
	  fromDate = 'OrderDate__gte=' + dates.fromDate;
	  toDate = 'OrderDate__lte=' + dates.toDate;
	  if (Vendor_id) {
	    Vendor_id = Vendor_id.value || Vendor_id;
	    Vendor_id = Vendor_id + '/';
	  } else {
	    Vendor_id = '';
	  }
	  if (POStatus) {
	    POStatus = POStatus.value || POStatus;
	    POStatus = '&PurchaseStatus=' + POStatus;
	  } else {
	    POStatus = '&PurchaseStatus=All';
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PURCHASING_PERFORMANCE });
	    return _axios2.default.get(_url.PURCHASE_URL + 'performance/Vendor_id/' + Vendor_id + '?' + fromDate + '&' + toDate + POStatus, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPurchasingPerformanceSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPurchasingPerformanceFailure(err));
	    });
	  };
	}
	
	function fetchPurchasingPerformanceSuccess(data) {
	  return {
	    type: _type.FETCH_PURCHASING_PERFORMANCE_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchPurchasingPerformanceFailure(error) {
	  return {
	    type: _type.FETCH_PURCHASING_PERFORMANCE_FAILURE,
	    payload: error
	  };
	}
	
	function fetchPriceAdjustment(timeframe, _ref5) {
	  var fromDate = _ref5.fromDate,
	      toDate = _ref5.toDate;
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PRICE_ADJUSTMENT });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: _url.WAREHOUSES_URL + 'receiveprice/' + timeframe,
	      params: {
	        start_time: fromDate,
	        end_time: toDate
	      },
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPriceAdjustmentSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPriceAdjustmentFailure(err));
	    });
	  };
	}
	
	function fetchPriceAdjustmentSuccess(data) {
	  return {
	    type: _type.FETCH_PRICE_ADJUSTMENT_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchPriceAdjustmentFailure(error) {
	  return {
	    type: _type.FETCH_PRICE_ADJUSTMENT_FAILURE,
	    payload: error
	  };
	}
	
	function createPriceAdjustment(line) {
	  return function (dispatch) {
	    dispatch({ type: _type.CREATE_PRICE_ADJUSTMENT });
	    return _axios2.default.put(_url.WAREHOUSES_URL + 'receiveprice/', line, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(createPriceAdjustmentSuccess(response));
	      _reactRouter.browserHistory.push('/priceAdjustmentReport');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(createPriceAdjustmentFailure(err));
	    });
	  };
	}
	
	function createPriceAdjustmentSuccess(data) {
	  return {
	    type: _type.CREATE_PRICE_ADJUSTMENT_SUCCESS,
	    payload: data
	  };
	}
	
	function createPriceAdjustmentFailure(error) {
	  return {
	    type: _type.CREATE_PRICE_ADJUSTMENT_FAILURE,
	    payload: error
	  };
	}
	
	function fetchPurchasePivotChartOrders(time) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PURCHASE_PIVOT_CHART_ORDERS });
	    return _axios2.default.get(_url.PURCHASE_URL + 'pivot/' + time, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPurchasePivotChartOrdersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPurchasePivotChartOrdersFailure(err));
	    });
	  };
	}
	
	function fetchPurchasePivotChartOrdersSuccess(data) {
	  return {
	    type: _type.FETCH_PURCHASE_PIVOT_CHART_ORDERS_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchPurchasePivotChartOrdersFailure(error) {
	  return {
	    type: _type.FETCH_PURCHASE_PIVOT_CHART_ORDERS_FAILURE,
	    payload: error
	  };
	}
	
	function fetchPurchasePivotCharts(time) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PURCHASE_PIVOT_CHARTS });
	    return _axios2.default.get(_url.PURCHASE_URL + 'pivot/' + time, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPurchasePivotChartsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPurchasePivotChartsFailure(err));
	    });
	  };
	}
	
	function fetchPurchasePivotChartsSuccess(data) {
	  return {
	    type: _type.FETCH_PURCHASE_PIVOT_CHARTS_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchPurchasePivotChartsFailure(error) {
	  return {
	    type: _type.FETCH_PURCHASE_PIVOT_CHARTS_FAILURE,
	    payload: error
	  };
	}
	
	function fetchPurchasePivotChartsDetail(purchasePivot_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PURCHASE_PIVOT_CHARTS_DETAIL });
	    return _axios2.default.get(_url.PURCHASE_URL + 'pivot/' + purchasePivot_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPurchasePivotChartsDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPurchasePivotChartsDetailFailure(err));
	    });
	  };
	}
	
	function fetchPurchasePivotChartsDetailSuccess(data) {
	  return {
	    type: _type.FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchPurchasePivotChartsDetailFailure(error) {
	  return {
	    type: _type.FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function setPurchasePivotChart(PurchasePivot_id) {
	  return {
	    type: _type.SET_PURCHASE_PIVOT_ID,
	    payload: PurchasePivot_id
	  };
	}
	
	function resetPurchasePivotCharts() {
	  return {
	    type: _type.RESET_PURCHASE_PIVOT_CHARTS
	  };
	}
	
	function createPurchasePivotChart(_ref6, Vendors, Purchase_Pivot_Line) {
	  var PurchasePivot_id = _ref6.PurchasePivot_id,
	      Name = _ref6.Name,
	      Description = _ref6.Description;
	
	  return function (dispatch) {
	    dispatch({ type: _type.CREATE_PURCHASE_PIVOT_CHART });
	    return _axios2.default.post(_url.PURCHASE_URL + 'pivot/', {
	      PurchasePivot_id: PurchasePivot_id,
	      Name: Name,
	      Description: Description,
	      Vendors: Vendors,
	      Purchase_Pivot_Line: Purchase_Pivot_Line
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(createPurchasePivotChartSuccess(response));
	      _reactRouter.browserHistory.push('/purchasePivotChart');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(createPurchasePivotChartFailure(err));
	    });
	  };
	}
	
	function createPurchasePivotChartSuccess(data) {
	  return {
	    type: _type.CREATE_PURCHASE_PIVOT_CHART_SUCCESS,
	    payload: data
	  };
	}
	
	function createPurchasePivotChartFailure(error) {
	  return {
	    type: _type.CREATE_PURCHASE_PIVOT_CHART_FAILURE,
	    payload: error
	  };
	}
	
	function duplicatePivotChart(PurchasePivot_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.DUPLICATE_PURCHASE_PIVOT_CHART });
	    return _axios2.default.get(_url.PURCHASE_URL + 'pivot/copy/' + PurchasePivot_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(duplicatePivotChartSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(duplicatePivotChartFailure(err));
	    });
	  };
	}
	
	function duplicatePivotChartSuccess(data) {
	  return {
	    type: _type.DUPLICATE_PURCHASE_PIVOT_CHART_SUCCESS,
	    payload: data
	  };
	}
	
	function duplicatePivotChartFailure(error) {
	  return {
	    type: _type.DUPLICATE_PURCHASE_PIVOT_CHART_FAILURE,
	    payload: error
	  };
	}
	
	function clearDuplicatedPurchasePivotChart() {
	  return {
	    type: _type.CLEAR_DUPLICATED_PURCHASE_PIVOT_CHART
	  };
	}
	
	function fetchPurchasingReference(type, typeRadios, group, category) {
	  // if (group) {
	  //   group = `ProductGroup_id=${group}`;
	  // } else {
	  //   group = '';
	  // }
	  // if (category) {
	  //   category = `ProductCategory1_id=${category}`;
	  // } else {
	  //   category = '';
	  // }
	  var _getFromToDates = (0, _cleanDates.getFromToDates)((0, _moment2.default)()),
	      toDate = _getFromToDates.toDate;
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PURCHASING_REFERENCE });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: _url.PURCHASE_URL + 'referenceguide/' + type + '/' + typeRadios + '/',
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      params: {
	        ProductGroup_id: group,
	        ProductCategory1_id: category,
	        end_time: toDate
	      }
	    }).then(function (response) {
	      dispatch(fetchPurchasingReferenceSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPurchasingReferenceFailure(err));
	    });
	  };
	}
	
	function fetchPurchasingReferenceSuccess(data) {
	  return {
	    type: _type.FETCH_PURCHASING_REFERENCE_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchPurchasingReferenceFailure(error) {
	  return {
	    type: _type.FETCH_PURCHASING_REFERENCE_FAILURE,
	    payload: error
	  };
	}
	
	function fetchPurchasePaymentNotPaid() {
	  return function (dispatch) {
	    dispatch(requestPurchasePaymentNotPaid());
	    return _axios2.default.get(_url.PURCHASE_ORDERS_NOT_RECEIVED_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPurchasePaymentNotPaidSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPurchasePaymentNotPaidFailure(err));
	    });
	  };
	}
	
	function requestPurchasePaymentNotPaid() {
	  return {
	    type: _type.REQUEST_PURCHASE_PAYMENT_NOT_PAID
	  };
	}
	
	function fetchPurchasePaymentNotPaidSuccess(purchaseOrders) {
	  return {
	    type: _type.FETCH_PURCHASE_PAYMENT_NOT_PAID_SUCCESS,
	    payload: purchaseOrders
	  };
	}
	
	function fetchPurchasePaymentNotPaidFailure(error) {
	  return {
	    type: _type.FETCH_PURCHASE_PAYMENT_NOT_PAID_FAILURE,
	    payload: error
	  };
	}
	
	function fetchPurchasingPerformanceByProduct(days, fromDate, toDate, type, POStatus, Product_id) {
	  var date = getDateByDays(days, fromDate, toDate);
	  fromDate = 'OrderDate__gte=' + date.fromDate;
	  toDate = 'OrderDate__lte=' + date.toDate;
	  if (Product_id) {
	    Product_id = Product_id.value || Product_id;
	    Product_id = parseInt(Product_id);
	    Product_id += '/';
	  } else {
	    Product_id = '';
	  }
	  if (POStatus) {
	    POStatus = POStatus.value || POStatus;
	    POStatus = '&PurchaseStatus=' + POStatus;
	  } else {
	    POStatus = '&PurchaseStatus=All';
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PURCHASING_PERFORMANCE_BY_PRODUCT });
	    return _axios2.default.get(_url.PURCHASE_URL + 'performance/Product_id/' + Product_id + '?' + fromDate + '&' + toDate + POStatus, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPurchasingPerformanceByProductSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPurchasingPerformanceByProductFailure(err));
	    });
	  };
	}
	
	function fetchPurchasingPerformanceByProductSuccess(data) {
	  return {
	    type: _type.FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchPurchasingPerformanceByProductFailure(error) {
	  return {
	    type: _type.FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_FAILURE,
	    payload: error
	  };
	}
	
	function getDateByDays(days, fromDate, toDate) {
	  var dateRange = -1;
	  if (days != null) {
	    dateRange = days;
	  }
	  var date = {
	    fromDate: '',
	    toDate: ''
	  };
	  console.log('dateRange', dateRange, typeof dateRange === 'undefined' ? 'undefined' : _typeof(dateRange));
	  var postingDateGT = fromDate || '1900-01-01';
	  var postingDateLT = toDate || '3000-01-01';
	  if (dateRange != -1) {
	    postingDateLT = (0, _moment2.default)().format('YYYY-MM-DD');
	    if (dateRange == '1') {
	      postingDateGT = postingDateLT;
	    } else if (dateRange == '7') {
	      postingDateGT = (0, _moment2.default)().subtract('7', 'days').format('YYYY-MM-DD');
	    } else if (dateRange == '30') {
	      postingDateGT = (0, _moment2.default)().subtract('30', 'days').format('YYYY-MM-DD');
	    } else if (dateRange == '90') {
	      postingDateGT = (0, _moment2.default)().subtract('90', 'days').format('YYYY-MM-DD');
	    }
	  }
	  date.fromDate = postingDateGT;
	  date.toDate = postingDateLT;
	  return date;
	}
	
	function fetchPurchaseOrderProductByID(id) {
	  return function (dispatch) {
	    return _axios2.default.get('' + _url.PURCHASE_ORDER_PRODUCT_BY_ID_URL + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPurchaseOrderProductByIDSuccesful(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPurchaseOrderProductByIDFailure(err));
	    });
	  };
	}
	
	function fetchPurchaseOrderProductByIDSuccesful(product) {
	  return {
	    type: _type.FETCH_PURCHASE_PRODUCT_BY_ID_SUCCESS,
	    payload: product
	  };
	}
	
	function fetchPurchaseOrderProductByIDFailure(error) {
	  return {
	    type: _type.FETCH_PURCHASE_PRODUCT_BY_ID_FAILURE,
	    payload: error
	  };
	}
	
	function mergePurchaseOrders(orderIds) {
	  return function (dispatch) {
	    var config = {
	      method: 'POST',
	      url: _url.MERGE_PURCHASE_ORDERS_API,
	      data: { 'orderIds': orderIds },
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    };
	    dispatch(mergePurchaseOrdersLoading());
	    (0, _axios2.default)(config).then(function (res) {
	      dispatch(mergePurchaseOrdersSuccess());
	    }, function (err) {
	      dispatch(mergePurchaseOrdersError(err.data));
	    });
	  };
	}
	
	function mergePurchaseOrdersLoading() {
	  return {
	    type: _type.MERGE_PURCHASE_ORDERS_LOADING
	  };
	}
	
	function mergePurchaseOrdersSuccess() {
	  return {
	    type: _type.MERGE_PURCHASE_ORDERS_SUCCESS
	  };
	}
	
	function mergePurchaseOrdersError(err) {
	  return {
	    type: _type.MERGE_PURCHASE_ORDERS_ERROR,
	    payload: err
	  };
	}
	
	function approvePendingPO(ids) {
	  var url = '' + _url.APPROVE_PENDING_PO_URL;
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'post',
	      url: url,
	      data: { purchaseOrders: ids },
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function emailPO(id) {
	  return function (dispatch) {
	    _axios2.default.get(_root_url.ROOT_URL + 'v1/purchase/order/email/' + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      alert(JSON.stringify(response.data));
	    }, function (err) {
	      alert(JSON.stringify(err.data));
	    });
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseOrders, 'fetchPurchaseOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestPurchaseOrders, 'requestPurchaseOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseOrdersSuccess, 'fetchPurchaseOrdersSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseOrdersFailure, 'fetchPurchaseOrdersFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseOrdersByDate, 'fetchPurchaseOrdersByDate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(selectPurchaseOrder, 'selectPurchaseOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetCurrentPurchaseOrder, 'resetCurrentPurchaseOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseOrderDetail, 'fetchPurchaseOrderDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestPurchaseOrderDetail, 'requestPurchaseOrderDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseOrderDetailSuccess, 'fetchPurchaseOrderDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseOrderDetailFailure, 'fetchPurchaseOrderDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(createPurchaseOrder, 'createPurchaseOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(createPurchaseOrderSuccess, 'createPurchaseOrderSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(createPurchaseOrderFailure, 'createPurchaseOrderFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(createDropship, 'createDropship', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(copyPurchaseOrder, 'copyPurchaseOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(copyPurchaseOrderSuccess, 'copyPurchaseOrderSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(copyPurchaseOrderFailure, 'copyPurchaseOrderFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(createDropshipSuccess, 'createDropshipSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(createDropshipFailure, 'createDropshipFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(editPurchaseOrder, 'editPurchaseOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(editPurchaseOrderSuccess, 'editPurchaseOrderSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(editPurchaseOrderFailure, 'editPurchaseOrderFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseOrdersNotReceived, 'fetchPurchaseOrdersNotReceived', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestPurchaseOrdersNotReceived, 'requestPurchaseOrdersNotReceived', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseOrdersNotReceivedSuccess, 'fetchPurchaseOrdersNotReceivedSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseOrdersNotReceivedFailure, 'fetchPurchaseOrdersNotReceivedFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchTotalPurchases, 'fetchTotalPurchases', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestTotalPurchases, 'requestTotalPurchases', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchTotalPurchasesSuccess, 'fetchTotalPurchasesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchTotalPurchasesFailure, 'fetchTotalPurchasesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchTodaysIncomingOrders, 'fetchTodaysIncomingOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestTodaysIncomingOrders, 'requestTodaysIncomingOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchTodaysIncomingOrdersSuccess, 'fetchTodaysIncomingOrdersSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchTodaysIncomingOrdersFailure, 'fetchTodaysIncomingOrdersFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchIncomingOrdersByDate, 'fetchIncomingOrdersByDate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(printPurchaseOrder, 'printPurchaseOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(printPurchaseOrderSuccess, 'printPurchaseOrderSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(printPurchaseOrderFailure, 'printPurchaseOrderFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(setPriceValues, 'setPriceValues', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(setDefaultVendorAddress, 'setDefaultVendorAddress', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(clearRemarks, 'clearRemarks', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(setDefaults, 'setDefaults', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(setValue, 'setValue', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseOrderPerformance, 'fetchPurchaseOrderPerformance', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseOrderPerformanceSuccess, 'fetchPurchaseOrderPerformanceSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseOrderPerformanceFailure, 'fetchPurchaseOrderPerformanceFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseManagerInfo, 'fetchPurchaseManagerInfo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseManagerInfoSuccess, 'fetchPurchaseManagerInfoSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseManagerInfoFailure, 'fetchPurchaseManagerInfoFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchMonthPerformance, 'fetchMonthPerformance', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchMonthPerformanceSuccess, 'fetchMonthPerformanceSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchMonthPerformanceFailure, 'fetchMonthPerformanceFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(deletePurchaseOrder, 'deletePurchaseOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(deletePurchaseOrderSuccess, 'deletePurchaseOrderSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(deletePurchaseOrderFailure, 'deletePurchaseOrderFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasersPerformance, 'fetchPurchasersPerformance', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasersPerformanceSuccess, 'fetchPurchasersPerformanceSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasersPerformanceFailure, 'fetchPurchasersPerformanceFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPresidentDashInfo, 'fetchPresidentDashInfo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPresidentDAshInfoSuccess, 'fetchPresidentDAshInfoSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPresidentDashInfoFailure, 'fetchPresidentDashInfoFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchOverallPurchasePerformance, 'fetchOverallPurchasePerformance', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchOverallPurchasePerformanceSuccess, 'fetchOverallPurchasePerformanceSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchOverallPurchasePerformanceFailure, 'fetchOverallPurchasePerformanceFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchIncidentReport, 'fetchIncidentReport', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchIncidentReportSuccess, 'fetchIncidentReportSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchIncidentReportFailure, 'fetchIncidentReportFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(setAllProducts, 'setAllProducts', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(setDefaultSearchType, 'setDefaultSearchType', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(initializedPurchaseOrderForm, 'initializedPurchaseOrderForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(setDefaultIsDropship, 'setDefaultIsDropship', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(setDefaultConvertItemPrice, 'setDefaultConvertItemPrice', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetAllProducts, 'resetAllProducts', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(setDefaultDays, 'setDefaultDays', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(setDefaultOfForm, 'setDefaultOfForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(changeFieldArrayOfForm, 'changeFieldArrayOfForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(initializeForm, 'initializeForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseOrderList, 'fetchPurchaseOrderList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseOrderListSuccess, 'fetchPurchaseOrderListSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseOrderListFailure, 'fetchPurchaseOrderListFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(setPurchaseOrdersFilter, 'setPurchaseOrdersFilter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasingPerformance, 'fetchPurchasingPerformance', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasingPerformanceSuccess, 'fetchPurchasingPerformanceSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasingPerformanceFailure, 'fetchPurchasingPerformanceFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPriceAdjustment, 'fetchPriceAdjustment', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPriceAdjustmentSuccess, 'fetchPriceAdjustmentSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPriceAdjustmentFailure, 'fetchPriceAdjustmentFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(createPriceAdjustment, 'createPriceAdjustment', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(createPriceAdjustmentSuccess, 'createPriceAdjustmentSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(createPriceAdjustmentFailure, 'createPriceAdjustmentFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasePivotChartOrders, 'fetchPurchasePivotChartOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasePivotChartOrdersSuccess, 'fetchPurchasePivotChartOrdersSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasePivotChartOrdersFailure, 'fetchPurchasePivotChartOrdersFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasePivotCharts, 'fetchPurchasePivotCharts', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasePivotChartsSuccess, 'fetchPurchasePivotChartsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasePivotChartsFailure, 'fetchPurchasePivotChartsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasePivotChartsDetail, 'fetchPurchasePivotChartsDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasePivotChartsDetailSuccess, 'fetchPurchasePivotChartsDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasePivotChartsDetailFailure, 'fetchPurchasePivotChartsDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(setPurchasePivotChart, 'setPurchasePivotChart', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetPurchasePivotCharts, 'resetPurchasePivotCharts', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(createPurchasePivotChart, 'createPurchasePivotChart', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(createPurchasePivotChartSuccess, 'createPurchasePivotChartSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(createPurchasePivotChartFailure, 'createPurchasePivotChartFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(duplicatePivotChart, 'duplicatePivotChart', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(duplicatePivotChartSuccess, 'duplicatePivotChartSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(duplicatePivotChartFailure, 'duplicatePivotChartFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(clearDuplicatedPurchasePivotChart, 'clearDuplicatedPurchasePivotChart', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasingReference, 'fetchPurchasingReference', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasingReferenceSuccess, 'fetchPurchasingReferenceSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasingReferenceFailure, 'fetchPurchasingReferenceFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasePaymentNotPaid, 'fetchPurchasePaymentNotPaid', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestPurchasePaymentNotPaid, 'requestPurchasePaymentNotPaid', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasePaymentNotPaidSuccess, 'fetchPurchasePaymentNotPaidSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasePaymentNotPaidFailure, 'fetchPurchasePaymentNotPaidFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasingPerformanceByProduct, 'fetchPurchasingPerformanceByProduct', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasingPerformanceByProductSuccess, 'fetchPurchasingPerformanceByProductSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasingPerformanceByProductFailure, 'fetchPurchasingPerformanceByProductFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(getDateByDays, 'getDateByDays', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseOrderProductByID, 'fetchPurchaseOrderProductByID', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseOrderProductByIDSuccesful, 'fetchPurchaseOrderProductByIDSuccesful', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseOrderProductByIDFailure, 'fetchPurchaseOrderProductByIDFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(mergePurchaseOrders, 'mergePurchaseOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(mergePurchaseOrdersLoading, 'mergePurchaseOrdersLoading', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(mergePurchaseOrdersSuccess, 'mergePurchaseOrdersSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(mergePurchaseOrdersError, 'mergePurchaseOrdersError', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(approvePendingPO, 'approvePendingPO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(emailPO, 'emailPO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrders_actions.js');
	}();

	;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = checkPermission;
	function checkPermission(permission) {
	    var userPermissions = JSON.parse(localStorage.getItem('userPermissions')) || [];
	    var isPermission = false;
	    if (userPermissions.length) {
	        userPermissions.map(function (p) {
	            if (p.codename === permission) {
	                isPermission = true;
	            }
	        });
	    }
	    return isPermission;
	}
	/*
	These are all the permissions for each page
	
	Purchase Management
	  Purchase Order
	      view_purchase_order
	      add_purchase_order
	      change_purchase_order
	      delete_purchase_order
	      print_purchase_order
	
	  Purchase Return
	      view_purchase_return
	      add_purchase_return
	      change_purchase_return
	      delete_purchase_return
	      print_purchase_return
	
	  Purchase Performance
	      view_purchase_performance
	      print_purchase_performance
	
	  Price Reference
	      view_price_reference
	      change_price_reference
	
	  Purchase Reference
	      view_purchase_reference
	      print_purchase_reference
	
	Sales Management
	  Sales Order
	      view_sales_order
	      add_sales_order
	      change_sales_order
	      delete_sales_order
	      print_sales_order
	
	  Mobile Sales Order
	      view_mobile_order
	      add_mobile_order
	      change_mobile_order
	      delete_mobile_order (delete_sales_order)
	      print_mobile_order
	
	  Sales Invoice
	      view_sales_invoice
	      add_sales_invoice
	      change_sales_invoice
	      delete_sales_invoice
	      print_sales_invoice
	      edit_finalize_sales_invoice
	      edit_customer_sales_invoice
	
	  Promotions
	      view_promotions
	      add_promotions
	      change_promotions
	      delete_promotions
	      print_promotions
	
	  Favorites List
	      view_sales_favorites
	      add_sales_favorites
	      change_sales_favorites
	      delete_sales_favorites
	      print_sales_favorites
	
	  Sales Performance
	      view_sales_performance
	      print_sales_performance
	
	Warehouse Management
	  Inventory
	      view_inventory
	
	  New Receiving
	      view_receive
	      add_receive
	      print_receive
	
	  Receiving
	      view_receive_history
	      change_receive
	      delete_receive
	
	  Inventory Repackage
	      view_repackage
	      add_warehouse_repackage
	      change_warehouse_repackage
	
	
	  Inventory Relocation
	      view_inventory_relocation
	      change_warehouse_relocation
	      delete_warehouse_relocation
	
	  Inventory Adjustment
	      view_inventory_adjustment
	      change_warehouse_adjustment
	      delete_warehouse_adjustment
	
	  Scrap Records
	      view_warehouse_scrap
	      add_warehouse_scrap
	      change_warehouse_scrap
	
	  Outbound
	      view_sales_order //Not a working tab
	
	  Warehouse
	      view_warehouse
	      add_warehouse
	      change_warehouse
	      change_receiving_history_quantity_price
	
	  Product Convert
	      view_product_convert
	      add_product_convert
	
	Dispatch
	  Routing
	      view_routing
	
	  Edit Routes
	      view_edit_route
	
	  Shipping
	      view_shipping
	
	AR/AP
	  Accounts Receivable
	      view_account_receivable
	      add_account_receivable
	      change_account_receivable
	      delete_account_receivable
	      print_account_receivable
	
	  Accounts Payable
	      view_account_payable
	      add_account_payable
	      change_account_payable
	      delete_account_payable
	      print_account_payable
	
	  Purchase Report
	      view_purchase_payment
	      change_purchase_payment
	
	  Sales Invoice (AR Sales Invoice)
	      view_sales_invoice
	      add_sales_invoice
	      change_sales_invoice
	      delete_sales_invoice
	      print_sales_invoice
	      edit_finalize_sales_invoice
	
	  Sales Report
	      view_sales_report
	
	  General Report
	      view_general_report
	      print_general_report
	
	  AR Aged Report
	      view_customer_statement
	      print_customer_statement
	
	  AP Aged Report
	      view_vendor_statement
	      print_vendor_statement
	
	  Customer Statement
	      view_customer_statement
	      print_customer_statement
	
	  Vendor Statement
	      view_vendor_statement
	      print_vendor_statement
	
	  City Report
	      view_city_report
	      print_city_report
	
	  Mobile Customer Statement
	      view_customer_statement
	      print_customer_statement
	
	Returns
	  New Sales Return
	      view_sales_return
	      add_sales_return
	
	  Sales Return
	      change_sales_return
	      delete_sales_return
	
	POS Management
	  POS
	      view_pos
	
	  POS Report
	      view_pos
	
	  POS Order
	      view_pos
	      add_void_order
	
	General Management
	  Product
	      view_product
	      add_product
	      change_product
	      change_shipping_misc
	
	  Customer
	      view_customer
	      change_customer
	      add_customer
	
	  Vendor
	      view_vendor
	      add_vendor
	      change_vendor
	
	  Payment Term
	      view_payment_term
	      add_payment_term
	      change_payment_term
	
	  Groups Management
	    Group / Pkg Type / MM Type
	      view_product_group
	      add_product_group
	      change_product_group
	      delete_product_group
	
	    Category / Category 2
	      view_product_category
	      add_product_category
	      change_product_category
	      delete_product_category
	
	  Price Level
	      view_price_level
	      change_price_level
	
	  President Dashboard
	      view_dashboard_president
	      view_category_analysis
	
	Admin Tools
	  User Management
	      view_baseuser
	      add_baseuser
	      change_baseuser
	
	  Role Management
	      view_group
	      add_group
	      change_group
	
	  Tax Management
	      view_tax_area
	      add_tax_area
	      change_tax_area
	      delete_tax_area
	
	  Currency Management
	      view_currency
	      change_currency
	
	  RMA
	      view_bd_rma_customer
	      change_bd_rma_customer
	      add_bd_rma_customer
	      view_bd_rma
	      change_bd_rma
	*/
	
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(checkPermission, 'checkPermission', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/permissions.jsx');
	}();

	;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(5);

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(4);

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StartOfThisMonthDatePicker = exports.DisabledDatePicker = exports.DatePicker = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(61);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DatePicker = exports.DatePicker = function (_Component) {
	  _inherits(DatePicker, _Component);
	
	  function DatePicker() {
	    _classCallCheck(this, DatePicker);
	
	    var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this));
	
	    _this.state = {
	      input: '',
	      selected: '',
	      placeholder: '',
	      start: '',
	      end: '',
	      minDate: '',
	      maxDate: '',
	      oldIn: '',
	      inDate: '',
	      dropUp: false,
	      errorState: {
	        message: '',
	        status: ''
	      }
	    };
	    return _this;
	  }
	
	  _createClass(DatePicker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          input = _props.input,
	          selected = _props.selected,
	          placeholder = _props.placeholder,
	          start = _props.start,
	          end = _props.end,
	          minDate = _props.minDate,
	          maxDate = _props.maxDate,
	          dropUp = _props.dropUp;
	
	      var inDate = new Date(this.props.input.value);
	      if (start && inDate > maxDate) {
	        this.setState({
	          input: input,
	          selected: selected,
	          placeholder: placeholder,
	          start: start,
	          end: end,
	          dropUp: dropUp,
	          minDate: minDate || new Date(1900, 0, 1),
	          maxDate: maxDate || new Date(2099, 11, 31),
	          oldIn: '',
	          inDate: '',
	          errorState: {
	            message: 'Error in Start Date',
	            status: 'failure'
	          }
	        });
	      } else {
	        this.setState({ input: input, selected: selected, placeholder: placeholder, start: start, end: end, dropUp: dropUp, minDate: minDate || new Date(1900, 0, 1), maxDate: maxDate || new Date(2099, 11, 31), oldIn: this.props.input.value, inDate: new Date(this.props.input.value), errorState: {
	            message: 'Incomplete',
	            status: 'incomplete'
	          }
	        });
	      }
	
	      if (end && inDate < minDate) {
	        this.setState({ input: input, selected: selected, placeholder: placeholder, start: start, end: end, dropUp: dropUp, minDate: minDate || new Date(1900, 0, 1), maxDate: maxDate || new Date(2099, 11, 31), oldIn: '', inDate: '', errorState: {
	            message: 'Error in End Date',
	            status: 'failure'
	          }
	        });
	      } else {
	        this.setState({ input: input, selected: selected, placeholder: placeholder, start: start, end: end, dropUp: dropUp, minDate: minDate || new Date(1900, 0, 1), maxDate: maxDate || new Date(2099, 11, 31), oldIn: this.props.input.value, inDate: new Date(this.props.input.value), errorState: {
	            message: 'Incomplete',
	            status: 'incomplete'
	          }
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var input = nextProps.input,
	          selected = nextProps.selected,
	          placeholder = nextProps.placeholder,
	          start = nextProps.start,
	          end = nextProps.end,
	          minDate = nextProps.minDate,
	          maxDate = nextProps.maxDate,
	          dropUp = nextProps.dropUp;
	
	      var inDate = new Date(nextProps.input.value);
	      if (start && inDate > maxDate) {
	        this.setState({ input: input, selected: selected, placeholder: placeholder, start: start, end: end, dropUp: dropUp, minDate: new Date(1900, 0, 1), maxDate: maxDate || new Date(2099, 11, 31), oldIn: nextProps.input.value, inDate: null, errorState: {
	            message: 'Error in Start Date',
	            status: 'failure'
	          }
	        });
	      } else {
	        this.setState({ input: input, selected: selected, placeholder: placeholder, start: start, end: end, dropUp: dropUp, minDate: new Date(1900, 0, 1), maxDate: maxDate || new Date(2099, 11, 31), oldIn: nextProps.input.value, inDate: new Date(nextProps.input.value), errorState: {
	            message: 'Incomplete',
	            status: 'incomplete'
	          }
	        });
	      }
	      if (end && inDate < minDate) {
	        this.setState({ input: input, selected: selected, placeholder: placeholder, start: start, end: end, dropUp: dropUp, minDate: minDate || new Date(1900, 0, 1), maxDate: new Date(2099, 11, 31), oldIn: nextProps.input.value, inDate: null, errorState: {
	            message: 'Error in End Date',
	            status: 'failure'
	          }
	        });
	      } else {
	        this.setState({ input: input, selected: selected, placeholder: placeholder, start: start, end: end, dropUp: dropUp, minDate: minDate || new Date(1900, 0, 1), maxDate: new Date(2099, 11, 31), oldIn: nextProps.input.value, inDate: new Date(nextProps.input.value), errorState: {
	            message: 'Incomplete',
	            status: 'incomplete'
	          }
	        });
	      }
	      if (start && inDate <= maxDate || end && inDate >= minDate) this.setState({ input: input, selected: selected, placeholder: placeholder, start: start, end: end, dropUp: dropUp, minDate: minDate || new Date(1900, 0, 1), maxDate: maxDate || new Date(2099, 11, 31), oldIn: nextProps.input.value, inDate: new Date(nextProps.input.value), errorState: {
	          message: 'Success',
	          status: 'success'
	        }
	      });
	      if (maxDate === null && minDate === null) {
	        this.setState({ maxDate: new Date(2099, 11, 31), minDate: new Date(1900, 0, 1), inDate: null });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          input = _state.input,
	          selected = _state.selected,
	          placeholder = _state.placeholder,
	          minDate = _state.minDate,
	          maxDate = _state.maxDate,
	          start = _state.start,
	          end = _state.end,
	          oldIn = _state.oldIn,
	          inDate = _state.inDate,
	          dropUp = _state.dropUp;
	      var _props$meta = this.props.meta,
	          touched = _props$meta.touched,
	          error = _props$meta.error;
	
	      var inputClass = (0, _classnames2.default)({ 'parsley-error-div': touched && error }, this.props.className, 'datePicker', "test-rw-input");
	      var date = void 0;
	      if (selected) {
	        date = new Date(selected);
	      }
	      var isDisabled = false;
	      if (this.props.disabled) {
	        isDisabled = true;
	      }
	
	      if (oldIn.length === 0) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          touched && error && _react2.default.createElement(
	            'span',
	            { className: 'parsley-error-message' },
	            error
	          ),
	          _react2.default.createElement(_DateTimePicker2.default, {
	            dropUp: dropUp,
	            className: inputClass,
	            placeholder: placeholder,
	            format: 'MM-DD-YY',
	            time: false,
	            onChange: function onChange(name) {
	              return input.onChange(name);
	            },
	            min: minDate,
	            max: maxDate,
	            defaultValue: date,
	            disabled: isDisabled,
	            style: { readonly: 'true' }
	          })
	        );
	      }
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        touched && error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          error
	        ),
	        _react2.default.createElement(_DateTimePicker2.default, {
	          dropUp: dropUp,
	          placeholder: placeholder,
	          className: inputClass,
	          format: 'MM-DD-YY',
	          time: false,
	          onChange: function onChange(name) {
	            return input.onChange(name);
	          },
	          min: minDate,
	          max: maxDate,
	          value: inDate,
	          disabled: isDisabled
	        })
	      );
	    }
	  }]);
	
	  return DatePicker;
	}(_react.Component);
	
	var DisabledDatePicker = exports.DisabledDatePicker = function (_Component2) {
	  _inherits(DisabledDatePicker, _Component2);
	
	  function DisabledDatePicker() {
	    _classCallCheck(this, DisabledDatePicker);
	
	    return _possibleConstructorReturn(this, (DisabledDatePicker.__proto__ || Object.getPrototypeOf(DisabledDatePicker)).apply(this, arguments));
	  }
	
	  _createClass(DisabledDatePicker, [{
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          input = _props2.input,
	          selected = _props2.selected,
	          placeholder = _props2.placeholder;
	
	      var date = void 0;
	      if (selected !== null) {
	        date = new Date(selected);
	      }
	      if (input.value.length !== 0) {
	        date = new Date(input.value);
	      }
	      return _react2.default.createElement(_DateTimePicker2.default, {
	        placeholder: placeholder,
	        className: 'test-rw-input',
	        format: 'MM-DD-YY',
	        defaultValue: selected,
	        time: false,
	        onChange: function onChange(name) {
	          return input.onChange(name);
	        },
	        value: date || null,
	        disabled: true
	      });
	    }
	  }]);
	
	  return DisabledDatePicker;
	}(_react.Component);
	
	var StartOfThisMonthDatePicker = exports.StartOfThisMonthDatePicker = function (_Component3) {
	  _inherits(StartOfThisMonthDatePicker, _Component3);
	
	  function StartOfThisMonthDatePicker() {
	    _classCallCheck(this, StartOfThisMonthDatePicker);
	
	    var _this3 = _possibleConstructorReturn(this, (StartOfThisMonthDatePicker.__proto__ || Object.getPrototypeOf(StartOfThisMonthDatePicker)).call(this));
	
	    _this3.state = {
	      input: '',
	      selected: '',
	      placeholder: '',
	      start: '',
	      end: '',
	      minDate: '',
	      maxDate: '',
	      oldIn: '',
	      inDate: '',
	      dropUp: false,
	      errorState: {
	        message: '',
	        status: ''
	      }
	    };
	    return _this3;
	  }
	
	  _createClass(StartOfThisMonthDatePicker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props3 = this.props,
	          input = _props3.input,
	          selected = _props3.selected,
	          placeholder = _props3.placeholder,
	          start = _props3.start,
	          end = _props3.end,
	          minDate = _props3.minDate,
	          maxDate = _props3.maxDate,
	          dropUp = _props3.dropUp;
	
	      var inDate = new Date(this.props.input.value);
	      if (start && inDate > maxDate) {
	        this.setState({
	          input: input,
	          selected: selected,
	          placeholder: placeholder,
	          start: start,
	          end: end,
	          dropUp: dropUp,
	          minDate: (0, _moment2.default)(minDate).startOf('month')._d || (0, _moment2.default)().startOf('month')._d,
	          maxDate: maxDate || new Date(2099, 11, 31),
	          oldIn: '',
	          inDate: '',
	          errorState: {
	            message: 'Error in Start Date',
	            status: 'failure'
	          }
	        });
	      } else {
	        this.setState({ input: input, selected: selected, placeholder: placeholder, start: start, end: end, dropUp: dropUp, minDate: (0, _moment2.default)(minDate).startOf('month')._d || (0, _moment2.default)().startOf('month')._d, maxDate: maxDate || new Date(2099, 11, 31), oldIn: this.props.input.value, inDate: new Date(this.props.input.value), errorState: {
	            message: 'Incomplete',
	            status: 'incomplete'
	          }
	        });
	      }
	
	      if (end && inDate < minDate) {
	        this.setState({ input: input, selected: selected, placeholder: placeholder, start: start, end: end, dropUp: dropUp, minDate: (0, _moment2.default)(minDate).startOf('month')._d || (0, _moment2.default)().startOf('month')._d, maxDate: maxDate || new Date(2099, 11, 31), oldIn: '', inDate: '', errorState: {
	            message: 'Error in End Date',
	            status: 'failure'
	          }
	        });
	      } else {
	        this.setState({ input: input, selected: selected, placeholder: placeholder, start: start, end: end, dropUp: dropUp, minDate: (0, _moment2.default)(minDate).startOf('month')._d || (0, _moment2.default)().startOf('month')._d, maxDate: maxDate || new Date(2099, 11, 31), oldIn: this.props.input.value, inDate: new Date(this.props.input.value), errorState: {
	            message: 'Incomplete',
	            status: 'incomplete'
	          }
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var input = nextProps.input,
	          selected = nextProps.selected,
	          placeholder = nextProps.placeholder,
	          start = nextProps.start,
	          end = nextProps.end,
	          minDate = nextProps.minDate,
	          maxDate = nextProps.maxDate,
	          dropUp = nextProps.dropUp;
	
	      var inDate = new Date(nextProps.input.value);
	      if (start && inDate > maxDate) {
	        this.setState({ input: input, selected: selected, placeholder: placeholder, start: start, end: end, dropUp: dropUp, minDate: (0, _moment2.default)(minDate).startOf('month')._d || (0, _moment2.default)().startOf('month')._d, maxDate: maxDate || new Date(2099, 11, 31), oldIn: nextProps.input.value, inDate: null, errorState: {
	            message: 'Error in Start Date',
	            status: 'failure'
	          }
	        });
	      } else {
	        this.setState({ input: input, selected: selected, placeholder: placeholder, start: start, end: end, dropUp: dropUp, minDate: (0, _moment2.default)(minDate).startOf('month')._d || (0, _moment2.default)().startOf('month')._d, maxDate: maxDate || new Date(2099, 11, 31), oldIn: nextProps.input.value, inDate: new Date(nextProps.input.value), errorState: {
	            message: 'Incomplete',
	            status: 'incomplete'
	          }
	        });
	      }
	      if (end && inDate < minDate) {
	        this.setState({ input: input, selected: selected, placeholder: placeholder, start: start, end: end, dropUp: dropUp, minDate: (0, _moment2.default)(minDate).startOf('month')._d || (0, _moment2.default)().startOf('month')._d, maxDate: new Date(2099, 11, 31), oldIn: nextProps.input.value, inDate: null, errorState: {
	            message: 'Error in End Date',
	            status: 'failure'
	          }
	        });
	      } else {
	        this.setState({ input: input, selected: selected, placeholder: placeholder, start: start, end: end, dropUp: dropUp, minDate: (0, _moment2.default)(minDate).startOf('month')._d || (0, _moment2.default)().startOf('month')._d, maxDate: new Date(2099, 11, 31), oldIn: nextProps.input.value, inDate: new Date(nextProps.input.value), errorState: {
	            message: 'Incomplete',
	            status: 'incomplete'
	          }
	        });
	      }
	      if (start && inDate <= maxDate || end && inDate >= minDate) {
	        this.setState({ input: input, selected: selected, placeholder: placeholder, start: start, end: end, dropUp: dropUp, minDate: (0, _moment2.default)(minDate).startOf('month')._d || (0, _moment2.default)().startOf('month')._d, maxDate: maxDate || new Date(2099, 11, 31), oldIn: nextProps.input.value, inDate: new Date(nextProps.input.value), errorState: {
	            message: 'Success',
	            status: 'success'
	          }
	        });
	      }
	      if (maxDate === null && minDate === null) {
	        this.setState({ maxDate: new Date(2099, 11, 31), minDate: (0, _moment2.default)(minDate).startOf('month')._d || (0, _moment2.default)().startOf('month')._d, inDate: null });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          input = _state2.input,
	          selected = _state2.selected,
	          placeholder = _state2.placeholder,
	          minDate = _state2.minDate,
	          maxDate = _state2.maxDate,
	          start = _state2.start,
	          end = _state2.end,
	          oldIn = _state2.oldIn,
	          dropUp = _state2.dropUp;
	      var _props$meta2 = this.props.meta,
	          touched = _props$meta2.touched,
	          error = _props$meta2.error;
	
	      var inputClass = (0, _classnames2.default)({ 'parsley-error-div': touched && error }, this.props.className, 'datePicker', "test-rw-input");
	      var date = void 0;
	      if (this.state.inDate === undefined || this.state.inDate === null) {
	        var today = (0, _moment2.default)()._d;
	        this.setState({
	          inDate: today
	        });
	      }
	      if (selected) {
	        date = new Date(selected);
	      }
	      var isDisabled = false;
	      if (this.props.disabled) {
	        isDisabled = true;
	      }
	
	      if (oldIn.length === 0) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          touched && error && _react2.default.createElement(
	            'span',
	            { className: 'parsley-error-message' },
	            error
	          ),
	          _react2.default.createElement(_DateTimePicker2.default, {
	            dropUp: dropUp,
	            placeholder: placeholder,
	            className: inputClass,
	            format: 'MM-DD-YY',
	            time: false,
	            onChange: function onChange(name) {
	              return input.onChange(name);
	            },
	            min: (0, _moment2.default)(date).startOf('month')._d || (0, _moment2.default)().startOf('month')._d,
	            max: maxDate,
	            defaultValue: date,
	            disabled: isDisabled,
	            style: { readonly: 'true' }
	          })
	        );
	      }
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        touched && error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          error
	        ),
	        _react2.default.createElement(_DateTimePicker2.default, {
	          className: inputClass,
	          dropUp: dropUp,
	          placeholder: placeholder,
	          format: 'MM-DD-YY',
	          time: false,
	          onChange: function onChange(name) {
	            return input.onChange(name);
	          },
	          min: (0, _moment2.default)(this.state.inDate).startOf('month')._d || (0, _moment2.default)().startOf('month')._d,
	          max: maxDate,
	          value: this.state.inDate,
	          disabled: isDisabled
	        })
	      );
	    }
	  }]);
	
	  return StartOfThisMonthDatePicker;
	}(_react.Component);
	
	var _default = DatePicker;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(DatePicker, 'DatePicker', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/datePicker.jsx');
	
	  __REACT_HOT_LOADER__.register(DisabledDatePicker, 'DisabledDatePicker', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/datePicker.jsx');
	
	  __REACT_HOT_LOADER__.register(StartOfThisMonthDatePicker, 'StartOfThisMonthDatePicker', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/datePicker.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/datePicker.jsx');
	}();

	;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.submitBolImageSCM = exports.submitBolImage = exports.deleteBolImageSCM = exports.deleteBolImage = exports.fetchBolImageOCM = exports.fetchBolImage = exports.fetchProductPromotion = exports.fetchBatchesByID = exports.podUPloadSCM = exports.uploadMSO = exports.podUpload = exports.setOrderToOpen = exports.reprintSalesOrderLabelUSPride = exports.printSalesOrderLabelUSPride = exports.sendPacking = exports.getQBAuth = exports.QBAuthStatusCheck = exports.expressMultipleSOInvoices = exports.generateSOWithExcelUSPride = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.updateMSOFormInitialValues = updateMSOFormInitialValues;
	exports.fetchSalesOrders = fetchSalesOrders;
	exports.requestSalesOrders = requestSalesOrders;
	exports.fetchSalesOrdersSuccess = fetchSalesOrdersSuccess;
	exports.fetchSalesOrdersFailure = fetchSalesOrdersFailure;
	exports.fetchProductDetail = fetchProductDetail;
	exports.fetchSalesOdersByDate = fetchSalesOdersByDate;
	exports.selectSalesOrder = selectSalesOrder;
	exports.resetCurrentSalesOrder = resetCurrentSalesOrder;
	exports.keepEstDate = keepEstDate;
	exports.keepEstDateSuccess = keepEstDateSuccess;
	exports.destroyEstDate = destroyEstDate;
	exports.finishUnmount = finishUnmount;
	exports.fetchSalesOrderDetail = fetchSalesOrderDetail;
	exports.requestSalesOrderDetail = requestSalesOrderDetail;
	exports.fetchSalesOrderDetailVIT = fetchSalesOrderDetailVIT;
	exports.fetchSalesOrderDetailIVTSuccess = fetchSalesOrderDetailIVTSuccess;
	exports.fetchSalesOrderDetailSuccess = fetchSalesOrderDetailSuccess;
	exports.fetchSalesOrderDetailFailure = fetchSalesOrderDetailFailure;
	exports.requestSalesOrderDetailByNum = requestSalesOrderDetailByNum;
	exports.fetchSalesOrderDetailByNumSuccess = fetchSalesOrderDetailByNumSuccess;
	exports.fetchSalesOrderDetailByNumFailure = fetchSalesOrderDetailByNumFailure;
	exports.fetchSalesOrderDetailByNum = fetchSalesOrderDetailByNum;
	exports.createSalesQuote = createSalesQuote;
	exports.createSalesOrder = createSalesOrder;
	exports.createSalesOrderSuccess = createSalesOrderSuccess;
	exports.createSalesOrderFailure = createSalesOrderFailure;
	exports.editSalesOrder = editSalesOrder;
	exports.editSalesOrderSuccess = editSalesOrderSuccess;
	exports.editSalesOrderFailure = editSalesOrderFailure;
	exports.voidSalesOrder = voidSalesOrder;
	exports.voidSalesOrderSuccess = voidSalesOrderSuccess;
	exports.voidSalesOrderFailure = voidSalesOrderFailure;
	exports.requestCustomerSalesHistory = requestCustomerSalesHistory;
	exports.fetchCustomerSalesHistorySuccess = fetchCustomerSalesHistorySuccess;
	exports.fetchCustomerSalesHistoryFailure = fetchCustomerSalesHistoryFailure;
	exports.fetchCustomerSalesHistory = fetchCustomerSalesHistory;
	exports.fetchCustomerOrderSchedules = fetchCustomerOrderSchedules;
	exports.fetchCustomerOrderSchedulesByDate = fetchCustomerOrderSchedulesByDate;
	exports.fetchCustomerOrderSchedulesSuccess = fetchCustomerOrderSchedulesSuccess;
	exports.fetchCustomerOrderSchedulesFailure = fetchCustomerOrderSchedulesFailure;
	exports.fetchTodaysOutgoingOrders = fetchTodaysOutgoingOrders;
	exports.requestTodaysOutgoingOrders = requestTodaysOutgoingOrders;
	exports.fetchTodaysOutgoingOrdersSuccess = fetchTodaysOutgoingOrdersSuccess;
	exports.fetchTodaysOutgoingOrdersFailure = fetchTodaysOutgoingOrdersFailure;
	exports.fetchOutgoingOrdersByDate = fetchOutgoingOrdersByDate;
	exports.fetchSalesOrderLineWeights = fetchSalesOrderLineWeights;
	exports.requestSalesOrderLineWeights = requestSalesOrderLineWeights;
	exports.fetchSalesOrderLineWeightsSuccess = fetchSalesOrderLineWeightsSuccess;
	exports.fetchSalesOrderLineWeightsFailure = fetchSalesOrderLineWeightsFailure;
	exports.setOrderLineWeights = setOrderLineWeights;
	exports.requestSetOrderLineWeights = requestSetOrderLineWeights;
	exports.editSalesOrderLineWeightsSuccess = editSalesOrderLineWeightsSuccess;
	exports.editSalesOrderLineWeightsFailure = editSalesOrderLineWeightsFailure;
	exports.clearSalesOrderLineWeights = clearSalesOrderLineWeights;
	exports.fetchSalesOrderForm = fetchSalesOrderForm;
	exports.requestSalesOrderForm = requestSalesOrderForm;
	exports.fetchSalesOrderFormSuccess = fetchSalesOrderFormSuccess;
	exports.fetchSalesOrderFormFailure = fetchSalesOrderFormFailure;
	exports.clearInventories = clearInventories;
	exports.fetchSalesCSV = fetchSalesCSV;
	exports.fetchSalesCSVSuccess = fetchSalesCSVSuccess;
	exports.fetchSalesCSVFailure = fetchSalesCSVFailure;
	exports.savePosSale = savePosSale;
	exports.savePosSaleSuccessful = savePosSaleSuccessful;
	exports.savePosSaleFailure = savePosSaleFailure;
	exports.invalidCharacterEntered = invalidCharacterEntered;
	exports.chargeNotMet = chargeNotMet;
	exports.clearErrorMessageInPOS = clearErrorMessageInPOS;
	exports.startNewOrder = startNewOrder;
	exports.startNewItem = startNewItem;
	exports.setSaleRowValue = setSaleRowValue;
	exports.setSaleOrderProductValues = setSaleOrderProductValues;
	exports.setSaleFavoriteRowValue = setSaleFavoriteRowValue;
	exports.setCredit = setCredit;
	exports.setSubtotal = setSubtotal;
	exports.resetFormInputs = resetFormInputs;
	exports.setValue = setValue;
	exports.fetchPOSDraft = fetchPOSDraft;
	exports.fetchDraftDetailsSuccess = fetchDraftDetailsSuccess;
	exports.fetchDraftDetailsFailure = fetchDraftDetailsFailure;
	exports.fetchDrafts = fetchDrafts;
	exports.fetchDraftsSuccessful = fetchDraftsSuccessful;
	exports.fetchDraftsFailure = fetchDraftsFailure;
	exports.clearForm = clearForm;
	exports.createCreditIssue = createCreditIssue;
	exports.createCreditIssueSuccess = createCreditIssueSuccess;
	exports.createCreditIssueFailure = createCreditIssueFailure;
	exports.createSalesReturn = createSalesReturn;
	exports.createSalesReturnSuccess = createSalesReturnSuccess;
	exports.createSalesReturnFailure = createSalesReturnFailure;
	exports.editSalesReturn = editSalesReturn;
	exports.editSalesReturnSuccess = editSalesReturnSuccess;
	exports.editSalesReturnFailure = editSalesReturnFailure;
	exports.fetchSalesReturnDetail = fetchSalesReturnDetail;
	exports.fetchSalesReturnDetailSuccess = fetchSalesReturnDetailSuccess;
	exports.fetchSalesReturnDetailFailure = fetchSalesReturnDetailFailure;
	exports.fetchInventoryReturns = fetchInventoryReturns;
	exports.fetchInventoryReturnsSuccess = fetchInventoryReturnsSuccess;
	exports.fetchInventoryReturnsFailure = fetchInventoryReturnsFailure;
	exports.fetchInventoryReturnsDetails = fetchInventoryReturnsDetails;
	exports.fetchInventoryReturnsDetailsSuccess = fetchInventoryReturnsDetailsSuccess;
	exports.fetchInventoryReturnsDetailsFailure = fetchInventoryReturnsDetailsFailure;
	exports.editInventoryReturns = editInventoryReturns;
	exports.editInventoryReturnsSuccess = editInventoryReturnsSuccess;
	exports.editInventoryReturnsFailure = editInventoryReturnsFailure;
	exports.fetchCustomerPrices = fetchCustomerPrices;
	exports.fetchCustomerPricesSuccess = fetchCustomerPricesSuccess;
	exports.fetchCustomerPricesFailure = fetchCustomerPricesFailure;
	exports.fetchCurrencyRatesSuccess = fetchCurrencyRatesSuccess;
	exports.fetchCurrencyRatesFailure = fetchCurrencyRatesFailure;
	exports.fetchCurrencyRates = fetchCurrencyRates;
	exports.editMultiCurrencies = editMultiCurrencies;
	exports.fetchTaxRatesSuccess = fetchTaxRatesSuccess;
	exports.fetchTaxRatesFailure = fetchTaxRatesFailure;
	exports.fetchTaxRates = fetchTaxRates;
	exports.editMultiTaxes = editMultiTaxes;
	exports.deleteTax = deleteTax;
	exports.fetchOverallSalesPerformance = fetchOverallSalesPerformance;
	exports.fetchOverallSalesPerformanceSuccess = fetchOverallSalesPerformanceSuccess;
	exports.fetchOverallSalesPerformanceFailure = fetchOverallSalesPerformanceFailure;
	exports.fetchPosReport = fetchPosReport;
	exports.fetchPosReportSuccess = fetchPosReportSuccess;
	exports.fetchPosReportFailure = fetchPosReportFailure;
	exports.fetchSalesInventoryInfo = fetchSalesInventoryInfo;
	exports.fetchSalesInventoryInfoSuccess = fetchSalesInventoryInfoSuccess;
	exports.fetchSalesInventoryInfoFailure = fetchSalesInventoryInfoFailure;
	exports.fetchSalesCustomerDetail = fetchSalesCustomerDetail;
	exports.fetchShippingCustomerDetailSuccess = fetchShippingCustomerDetailSuccess;
	exports.fetchSalesCustomerDetailSuccess = fetchSalesCustomerDetailSuccess;
	exports.fetchSalesCustomerDetailFailure = fetchSalesCustomerDetailFailure;
	exports.fetchAllShipping = fetchAllShipping;
	exports.fetchAllShippingDetailSuccess = fetchAllShippingDetailSuccess;
	exports.fetchAllShippingDetailFailure = fetchAllShippingDetailFailure;
	exports.fetchPurchasesVendorDetail = fetchPurchasesVendorDetail;
	exports.fetchPurchasesVendorDetailSuccess = fetchPurchasesVendorDetailSuccess;
	exports.fetchPurchasesVendorDetailFailure = fetchPurchasesVendorDetailFailure;
	exports.clearSalesCustomerDetails = clearSalesCustomerDetails;
	exports.fetchItemSalesHistory = fetchItemSalesHistory;
	exports.fetchItemSalesHistorySuccess = fetchItemSalesHistorySuccess;
	exports.fetchItemSalesHistoryFailure = fetchItemSalesHistoryFailure;
	exports.fetchCustomerFrequent = fetchCustomerFrequent;
	exports.fetchInboundProducts = fetchInboundProducts;
	exports.fetchCustomerFrequentSuccess = fetchCustomerFrequentSuccess;
	exports.fetchCustomerFrequentFailure = fetchCustomerFrequentFailure;
	exports.initializeForm = initializeForm;
	exports.setSalesOrdersFilter = setSalesOrdersFilter;
	exports.fetchSalesPerformance = fetchSalesPerformance;
	exports.fetchSalesPerformanceSuccess = fetchSalesPerformanceSuccess;
	exports.fetchSalesPerformanceFailure = fetchSalesPerformanceFailure;
	exports.fetchSalesOrdersByFilter = fetchSalesOrdersByFilter;
	exports.fetchSalesDashboardDetail = fetchSalesDashboardDetail;
	exports.requestSalesDashboardDetail = requestSalesDashboardDetail;
	exports.fetchSalesDashboardDetailSuccess = fetchSalesDashboardDetailSuccess;
	exports.fetchSalesDashboardDetailFailure = fetchSalesDashboardDetailFailure;
	exports.loadsPost = loadsPost;
	exports.fetchSalesLevels = fetchSalesLevels;
	exports.fetchSalesLevelsSuccess = fetchSalesLevelsSuccess;
	exports.fetchSalesLevelsFailure = fetchSalesLevelsFailure;
	exports.requestSORefund = requestSORefund;
	exports.requestingSORefund = requestingSORefund;
	exports.requestSORefundSuccess = requestSORefundSuccess;
	exports.requestSORefundFailure = requestSORefundFailure;
	exports.voidReturn = voidReturn;
	exports.completeReturn = completeReturn;
	exports.fetchReturnsSuccess = fetchReturnsSuccess;
	exports.fetchReturnsFailure = fetchReturnsFailure;
	exports.fetchSalesOrderProductByID = fetchSalesOrderProductByID;
	exports.fetchSalesOrderProductByIDSuccesful = fetchSalesOrderProductByIDSuccesful;
	exports.fetchSalesOrderProductByIDFailure = fetchSalesOrderProductByIDFailure;
	exports.initializeSalesOrderForm = initializeSalesOrderForm;
	exports.printSalesOrderSI = printSalesOrderSI;
	exports.printSalesOrder = printSalesOrder;
	exports.printSalesOrderLabel = printSalesOrderLabel;
	exports.printSalesOrderLabelBOL = printSalesOrderLabelBOL;
	exports.printSalesOrderLabelDSQ = printSalesOrderLabelDSQ;
	exports.printShippigLabel = printShippigLabel;
	exports.printSalesOrderLabelBatch = printSalesOrderLabelBatch;
	exports.fetchSalesOrderPDFSuccess = fetchSalesOrderPDFSuccess;
	exports.printShippingList = printShippingList;
	exports.printReceivingReport = printReceivingReport;
	exports.printYingBOL = printYingBOL;
	exports.printYingCustomerFile = printYingCustomerFile;
	exports.printShippingListATL = printShippingListATL;
	exports.fetchShippingListPDFSuccess = fetchShippingListPDFSuccess;
	exports.printPickingList = printPickingList;
	exports.printPickingListPartial = printPickingListPartial;
	exports.printPickingListATL = printPickingListATL;
	exports.printPickingListAFG = printPickingListAFG;
	exports.fetchPickingListPDFSuccess = fetchPickingListPDFSuccess;
	exports.printPackingList = printPackingList;
	exports.printPackingListATL = printPackingListATL;
	exports.fetchPackingListPDFSuccess = fetchPackingListPDFSuccess;
	exports.printMSORefundPDF = printMSORefundPDF;
	exports.fetchSalesTotalsSuccess = fetchSalesTotalsSuccess;
	exports.fetchSalesTotalsFailure = fetchSalesTotalsFailure;
	exports.fetchSalesTotals = fetchSalesTotals;
	exports.orderToQuote = orderToQuote;
	exports.orderToQuoteSuccess = orderToQuoteSuccess;
	exports.orderToQuoteFailure = orderToQuoteFailure;
	exports.quoteToOrder = quoteToOrder;
	exports.quoteToOrderSuccess = quoteToOrderSuccess;
	exports.quoteToOrderFailure = quoteToOrderFailure;
	exports.emailSO = emailSO;
	exports.emailSOCalco = emailSOCalco;
	exports.createMobileTask = createMobileTask;
	exports.createMobileTaskSuccess = createMobileTaskSuccess;
	exports.createMobileTaskFailure = createMobileTaskFailure;
	exports.updateShippingWeightSuccess = updateShippingWeightSuccess;
	exports.updateShippingWeightFailure = updateShippingWeightFailure;
	exports.updateShippingWeight = updateShippingWeight;
	exports.updateShippingWeightSplit = updateShippingWeightSplit;
	exports.fetchShippingWeightTracking = fetchShippingWeightTracking;
	exports.fetchCarrierInfo = fetchCarrierInfo;
	exports.postCarrierInfo = postCarrierInfo;
	exports.fetchJmlTracking = fetchJmlTracking;
	exports.updateEmployeeNote = updateEmployeeNote;
	exports.updateVoidNote = updateVoidNote;
	exports.reshipOrder = reshipOrder;
	exports.setQuoteOrder = setQuoteOrder;
	exports.setDavisPO = setDavisPO;
	exports.fetchBolByIdPDFSuccess = fetchBolByIdPDFSuccess;
	exports.printBolById = printBolById;
	exports.fetchPrintBolWithoutLogSuccess = fetchPrintBolWithoutLogSuccess;
	exports.printBolWithoutLog = printBolWithoutLog;
	exports.fetchPrintBolLabelSuccess = fetchPrintBolLabelSuccess;
	exports.printBolLabel = printBolLabel;
	exports.fetchBolByFbaPDFSuccess = fetchBolByFbaPDFSuccess;
	exports.printBolByFba = printBolByFba;
	exports.fetchSPSuccess = fetchSPSuccess;
	exports.printSP = printSP;
	exports.fetchBolAddressSuccess = fetchBolAddressSuccess;
	exports.fetchBolAddress = fetchBolAddress;
	exports.chowbusImport = chowbusImport;
	exports.getPaymentTerms = getPaymentTerms;
	exports.fetchFJAgents = fetchFJAgents;
	exports.fetchFJCarriers = fetchFJCarriers;
	exports.fetchFBAAddressOptions = fetchFBAAddressOptions;
	exports.fetchCompany = fetchCompany;
	exports.fetchWarehousesByCompany = fetchWarehousesByCompany;
	exports.selectTeapplixShipping = selectTeapplixShipping;
	exports.printTeapplixLabel = printTeapplixLabel;
	exports.deleteTeapplixShipping = deleteTeapplixShipping;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _cleanDates = __webpack_require__(22);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _root_url = __webpack_require__(9);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isMAG = _root_url.ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://magna-scm.truckxi.com/api/';
	
	var isHMM = _root_url.ROOT_URL === 'https://hmm-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://hmm-scm.truckxi.com/api/';
	var isABC = _root_url.ROOT_URL === 'https://abc-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://abc-scm.truckxi.com/api/';
	var isDSQ = _root_url.ROOT_API_URL === 'https://dsq-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://dsq-scm.truckxi.com/api/';
	var isWIZ = _root_url.ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
	var isFJ = _root_url.ROOT_API_URL === 'https://fj-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://fj-scm.truckxi.com/api/';
	var isJTB = _root_url.ROOT_API_URL === 'https://jtb-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://jtb-scm.truckxi.com/api/';
	var isAFM = _root_url.ROOT_API_URL === "https://afm-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://afm-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://afmstage-scm.truckxi.com/api/";
	var isKDW = _root_url.ROOT_API_URL === 'https://kdw-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://kdw-scm.truckxi.com/api/';
	var isABCFF = _root_url.ROOT_API_URL === 'https://abcff-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://abcff-scm.truckxi.com/api/';
	var isYI = _root_url.ROOT_API_URL === 'https://ying-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ying-scm.truckxi.com/api/';
	var isFBD = _root_url.ROOT_API_URL === 'https://fbd-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://fbd-scm.truckxi.com/api/';
	var isWUFS = _root_url.ROOT_API_URL === 'https://wufs-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://wufs-scm.truckxi.com/api/';
	var isTN = _root_url.ROOT_API_URL === "https://tn-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://tn-scm.truckxi.com/api/";
	
	function updateMSOFormInitialValues(data) {
	  return function (dispatch) {
	    dispatch({
	      type: _type.UPDATE_CURRENT_SALES_ORDER_DETAIL_SHIPPINGINFO,
	      payload: data
	    });
	  };
	};
	
	function fetchSalesOrders() {
	  return function (dispatch) {
	    dispatch(requestSalesOrders());
	    return _axios2.default.get(_url.SALES_ORDERS_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesOrdersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesOrdersFailure(err));
	    });
	  };
	}
	
	function requestSalesOrders() {
	  return {
	    type: _type.REQUEST_SALES_ORDERS
	  };
	}
	
	function fetchSalesOrdersSuccess(salesOrders) {
	  return {
	    type: _type.FETCH_SALES_ORDERS_SUCCESS,
	    payload: salesOrders
	  };
	}
	
	function fetchSalesOrdersFailure(error) {
	  return {
	    type: _type.FETCH_SALES_ORDERS_FAILURE,
	    payload: error
	  };
	}
	
	var generateSOWithExcelUSPride = exports.generateSOWithExcelUSPride = function generateSOWithExcelUSPride(file, platform, customer, cb, ecb) {
	  var url = (isABCFF ? _url.ABCFF_IMPORT : _url.USPRIDE_IMPORT) + '?platform=' + platform;
	  if (isABCFF) {
	    url = _url.ABCFF_IMPORT + '?platform=' + platform + '&customer_id=' + customer;
	    // if (platform === 'other') {
	    //   url = `${isABCFF ? ABCFF_IMPORT : USPRIDE_IMPORT}?platform=&customer_id=`
	    // }
	  }
	  (0, _axios2.default)({
	    method: 'post',
	    url: url,
	    data: file,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    cb && cb();
	  }, function (err) {
	    ecb && ecb();
	    alert(err.data);
	  });
	};
	
	var expressMultipleSOInvoices = exports.expressMultipleSOInvoices = function expressMultipleSOInvoices(pks, success, date) {
	  var url = _root_url.ROOT_URL + 'v2/sales/multi_express_invoice/' + pks.join(',');
	  var data = null;
	  if (isTN) {
	    data = { InvoiceShipDate: date };
	  }
	  (0, _axios2.default)({
	    method: 'POST',
	    url: url,
	    data: data,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    alert('success');
	    success && success();
	  }, function (err) {
	    if (isMAG || isTN) {
	      alert(err.data);
	    } else {
	      alert('failed');
	    }
	  });
	};
	
	var QBAuthStatusCheck = exports.QBAuthStatusCheck = function QBAuthStatusCheck(success, fails) {
	  var url = _root_url.ROOT_URL + 'v1/quickbook/check_qb_authorization_status';
	  (0, _axios2.default)({
	    method: 'GET',
	    url: url,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    success();
	  }, function (err) {
	    fails();
	  });
	};
	
	var getQBAuth = exports.getQBAuth = function getQBAuth() {
	  var url = _root_url.ROOT_URL + 'v1/quickbook/get_authorization';
	  (0, _axios2.default)({
	    method: 'GET',
	    url: url,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    var url = res.data;
	    window.open(url, 'QB Auth...');
	  }, function (err) {
	    fails();
	  });
	};
	
	function fetchProductDetail(id, customer_id, company_id, warehouse_id, success) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PRODUCT_BY_ID });
	    return _axios2.default.get('' + _url.SALES_ORDER_PRODUCT_BY_ID_URL + customer_id + '/?Product_id=' + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      success(response.data);
	    }, function (err) {});
	  };
	}
	
	var sendPacking = exports.sendPacking = function sendPacking(data) {
	  return function (dispatch) {
	    (0, _axios2.default)({
	      method: 'get',
	      url: '' + _url.SEND_PACKING_LIST_URL + data,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (res) {
	      alert("Send packing list successfully");
	    }, function (err) {
	      alert('Error: Cannot send picking list.');
	    });
	  };
	};
	
	var printSalesOrderLabelUSPride = exports.printSalesOrderLabelUSPride = function printSalesOrderLabelUSPride(data, cb) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SO_PDF });
	    (0, _axios2.default)({
	      method: 'post',
	      url: isKDW ? '' + _url.PRINT_BOL_URL + data : '' + _url.USPRIDE_PRINT_SO_USPRIDE,
	      data: isKDW ? null : data,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (res) {
	      dispatch(fetchSalesOrderPDFSuccess(res));
	      cb && cb();
	    }, function (err) {
	      // alert(err.data);
	      if (isKDW) {
	        alert('Error: Cannot generate BOL pdf. Please check if order information is complete.');
	      } else {
	        alert('Error: Cannot generate new tracking numbers. Please check Shipstation settings.');
	      }
	      dispatch(fetchSalesOrderPDFSuccess([]));
	    });
	  };
	};
	
	var reprintSalesOrderLabelUSPride = exports.reprintSalesOrderLabelUSPride = function reprintSalesOrderLabelUSPride(data, cb) {
	  return function (dispatch) {
	    (0, _axios2.default)({
	      method: 'post',
	      url: '' + _url.USPRIDE_REPRINT_SO_USPRIDE,
	      data: data,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (res) {
	      dispatch(fetchSalesOrderPDFSuccess(res));
	      cb && cb();
	    }, function (err) {
	      alert(err.data);
	    });
	  };
	};
	
	function fetchSalesOdersByDate(postingDateGT, postingDateLT, days) {
	  var dates = (0, _cleanDates.toFromDates)(days, postingDateGT, postingDateLT);
	  return function (dispatch) {
	    dispatch(requestSalesOrders());
	    return _axios2.default.get(_url.SALES_ORDERS_URL + 'search/?OrderDate__gte=' + dates.fromDate + '&OrderDate__lte=' + dates.toDate, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesOrdersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesOrdersFailure(err));
	    });
	  };
	}
	
	function selectSalesOrder(salesOrder) {
	  return {
	    type: _type.SELECT_SALES_ORDER,
	    payload: salesOrder
	  };
	}
	
	function resetCurrentSalesOrder() {
	  return {
	    type: _type.RESET_CURRENT_SALES_ORDER
	  };
	}
	
	function keepEstDate(date, route) {
	  return function (dispatch) {
	    dispatch(keepEstDateSuccess(date));
	    _reactRouter.browserHistory.push(route);
	  };
	}
	
	function keepEstDateSuccess(date) {
	  return {
	    type: _type.KEEP_EST_DATE,
	    payload: date
	  };
	}
	
	function destroyEstDate() {
	  return {
	    type: _type.DESTROY_EST_DATE
	  };
	}
	
	function finishUnmount() {
	  return {
	    type: _type.FINISHED_UNMOUNT
	  };
	}
	
	// Fetch the detail page.
	function fetchSalesOrderDetail(salesOrder_id, route) {
	  var url = route == 'salesOrders' ? _url.SALES_ORDERS_URL : _url.MOBILE_SALES_ORDERS_URL;
	  return function (dispatch) {
	    dispatch(requestSalesOrderDetail());
	    return _axios2.default.get(url + '?pk=' + salesOrder_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesOrderDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesOrderDetailFailure(err));
	    });
	  };
	}
	
	function requestSalesOrderDetail() {
	  return {
	    type: _type.REQUEST_SALES_ORDER_DETAIL
	  };
	}
	
	function fetchSalesOrderDetailVIT(salesOrder_id, route) {
	  var url = _url.VitAppointmentListOrders_URL;
	  return function (dispatch) {
	    dispatch(requestSalesOrderDetail());
	    return _axios2.default.get(url + '?pk=' + salesOrder_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesOrderDetailIVTSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesOrderDetailFailure(err));
	    });
	  };
	}
	
	function fetchSalesOrderDetailIVTSuccess(salesOrderDetail) {
	  orderDetail = salesOrderDetail.data;
	  return {
	    type: _type.FETCH_SALES_ORDER_DETAIL_SUCCESS,
	    payload: orderDetail
	  };
	}
	
	function fetchSalesOrderDetailSuccess(salesOrderDetail) {
	  salesOrderDetail = salesOrderDetail.data;
	  // The date data fetched is in the form of string, which needs to be modified into Date type
	  if (salesOrderDetail.OrderDate) salesOrderDetail.OrderDate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.OrderDate);
	  if (salesOrderDetail.ETADate) salesOrderDetail.ETADate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.ETADate);
	  if (salesOrderDetail.ReceivedDate) salesOrderDetail.ReceivedDate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.ReceivedDate);
	  if (salesOrderDetail.DispatchDate) salesOrderDetail.DispatchDate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.DispatchDate);
	  return {
	    type: _type.FETCH_SALES_ORDER_DETAIL_SUCCESS,
	    payload: salesOrderDetail
	  };
	}
	
	function fetchSalesOrderDetailFailure(error) {
	  return {
	    type: _type.FETCH_SALES_ORDER_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function requestSalesOrderDetailByNum() {
	  return {
	    type: _type.REQUEST_SALES_ORDER_DETAIL_BY_NUM
	  };
	}
	
	function fetchSalesOrderDetailByNumSuccess(salesOrderDetail) {
	  return {
	    type: _type.FETCH_SALES_ORDER_DETAIL_BY_NUM_SUCCESS,
	    payload: salesOrderDetail.data
	  };
	}
	
	function fetchSalesOrderDetailByNumFailure(error) {
	  return {
	    type: _type.FETCH_SALES_ORDER_DETAIL_BY_NUM_FAILURE,
	    payload: error
	  };
	}
	
	function fetchSalesOrderDetailByNum(SONum) {
	  return function (dispatch) {
	    dispatch(requestSalesOrderDetailByNum());
	    return _axios2.default.get(_url.SALES_ORDERS_URL + '?SONum=' + SONum, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesOrderDetailByNumSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesOrderDetailByNumFailure(err));
	    });
	  };
	}
	function createSalesQuote(_ref) {
	  var Sales_Order_Lines = _ref.Sales_Order_Lines,
	      Deliver_CustomerDetail_id = _ref.Deliver_CustomerDetail_id,
	      Deliver_Customer_id = _ref.Deliver_Customer_id,
	      IsWholesale = _ref.IsWholesale,
	      PaymentTerm_id = _ref.PaymentTerm_id,
	      Agent_id = _ref.Agent_id,
	      Pickup_Warehouse_id = _ref.Pickup_Warehouse_id,
	      OrderDate = _ref.OrderDate,
	      ETADate = _ref.ETADate,
	      DispatchDate = _ref.DispatchDate,
	      CPONum = _ref.CPONum,
	      TrackingNum = _ref.TrackingNum,
	      OrderType = _ref.OrderType,
	      IsDevan = _ref.IsDevan,
	      IsDrayage = _ref.IsDrayage,
	      ContainerNum = _ref.ContainerNum,
	      SSL = _ref.SSL,
	      MBL = _ref.MBL,
	      Pin = _ref.Pin,
	      ChassisType = _ref.ChassisType,
	      PierPass = _ref.PierPass,
	      LastFreeDay = _ref.LastFreeDay,
	      IsFBAAddress = _ref.IsFBAAddress,
	      DestinationAddress = _ref.DestinationAddress,
	      ISANum = _ref.ISANum,
	      Trucker = _ref.Trucker,
	      ReleaseDate = _ref.ReleaseDate,
	      ReadyDate = _ref.ReadyDate,
	      OutboundDate = _ref.OutboundDate,
	      ShipmentID = _ref.ShipmentID,
	      Destination = _ref.Destination,
	      ContainerSize = _ref.ContainerSize,
	      SalesOrderTypeSy = _ref.SalesOrderTypeSy,
	      ISANote = _ref.ISANote,
	      DLNum = _ref.DLNum,
	      Carrier = _ref.Carrier,
	      Port = _ref.Port,
	      LFDate = _ref.LFDate,
	      IsDO = _ref.IsDO,
	      IsDirectShip = _ref.IsDirectShip,
	      IsBOL = _ref.IsBOL,
	      IsSeal = _ref.IsSeal,
	      BOL = _ref.BOL,
	      POD = _ref.POD,
	      IsPOD = _ref.IsPOD,
	      FBARoute = _ref.FBARoute,
	      ReceiveType = _ref.ReceiveType,
	      ReceiveUnit = _ref.ReceiveUnit,
	      DropshipType = _ref.DropshipType,
	      Appointment = _ref.Appointment,
	      AppointmentDate = _ref.AppointmentDate,
	      ShipmentDate = _ref.ShipmentDate,
	      Warehouse_id = _ref.Warehouse_id,
	      TruckingCo = _ref.TruckingCo,
	      DeliverTo = _ref.DeliverTo,
	      IsReturnEmpty = _ref.IsReturnEmpty,
	      ArrivalDate = _ref.ArrivalDate,
	      ReturnDate = _ref.ReturnDate,
	      StorageInDate = _ref.StorageInDate,
	      StorageOutDate = _ref.StorageOutDate,
	      ExtInvoiceNum = _ref.ExtInvoiceNum,
	      Broker = _ref.Broker,
	      Truckload = _ref.Truckload,
	      TruckNum = _ref.TruckNum,
	      Dispatch = _ref.Dispatch,
	      DetentionRate = _ref.DetentionRate,
	      LumperFee = _ref.LumperFee,
	      PalletSpace = _ref.PalletSpace,
	      PickupDriver = _ref.PickupDriver,
	      PickupTrailerNum = _ref.PickupTrailerNum,
	      PickupDate = _ref.PickupDate,
	      PickupTime = _ref.PickupTime,
	      PickupStreet = _ref.PickupStreet,
	      PickupZip = _ref.PickupZip,
	      PickupCity = _ref.PickupCity,
	      PickupState = _ref.PickupState,
	      PickupAppt = _ref.PickupAppt,
	      DropoffDriver = _ref.DropoffDriver,
	      DropoffTrailerNum = _ref.DropoffTrailerNum,
	      DropoffDate = _ref.DropoffDate,
	      DropoffTime = _ref.DropoffTime,
	      DropoffStreet = _ref.DropoffStreet,
	      DropoffZip = _ref.DropoffZip,
	      DropoffCity = _ref.DropoffCity,
	      DropoffState = _ref.DropoffState,
	      DropoffAppt = _ref.DropoffAppt,
	      IsOutbound = _ref.IsOutbound,
	      RefNum = _ref.RefNum,
	      Type = _ref.Type,
	      ClientCustName = _ref.ClientCustName,
	      ShipByDate = _ref.ShipByDate,
	      DocumentDate = _ref.DocumentDate,
	      UpdateTime = _ref.UpdateTime,
	      FinalNetWeight = _ref.FinalNetWeight,
	      FinalShippingWeight = _ref.FinalShippingWeight,
	      TotalPrice = _ref.TotalPrice,
	      FinalWeight = _ref.FinalWeight,
	      CarryType = _ref.CarryType,
	      Discount = _ref.Discount,
	      Savings = _ref.Savings,
	      ShippingCost = _ref.ShippingCost,
	      HandlingCost = _ref.HandlingCost,
	      SalesStatus = _ref.SalesStatus,
	      MiscCost = _ref.MiscCost,
	      MiscNote = _ref.MiscNote,
	      TaxAmount = _ref.TaxAmount,
	      TaxRate = _ref.TaxRate,
	      FinalPrice = _ref.FinalPrice,
	      ConvertItemPrice = _ref.ConvertItemPrice,
	      Deliver_Warehouse_id = _ref.Deliver_Warehouse_id,
	      DispatchMethod_id = _ref.DispatchMethod_id,
	      DispatchOutSourceContact_id = _ref.DispatchOutSourceContact_id,
	      Sales_User_id = _ref.Sales_User_id,
	      Product_id = _ref.Product_id,
	      Modifier_User_id = _ref.Modifier_User_id,
	      Notation = _ref.Notation,
	      EmployeeNote = _ref.EmployeeNote,
	      RouteNote = _ref.RouteNote,
	      Note = _ref.Note,
	      TotalCRV = _ref.TotalCRV,
	      RefPrice = _ref.RefPrice,
	      IsNoReduce = _ref.IsNoReduce,
	      TrailerNum = _ref.TrailerNum,
	      Trailer = _ref.Trailer,
	      DSQID = _ref.DSQID,
	      PickupApptDate = _ref.PickupApptDate,
	      DeliveryApptDate = _ref.DeliveryApptDate,
	      DeliveryDate = _ref.DeliveryDate,
	      PerdiemDate = _ref.PerdiemDate,
	      Yard = _ref.Yard,
	      PortWaitTime = _ref.PortWaitTime,
	      ReturnTo = _ref.ReturnTo,
	      EmptyReadyDate = _ref.EmptyReadyDate,
	      DrayageCity = _ref.DrayageCity,
	      SaleStatus = _ref.SaleStatus,
	      delivery_address = _ref.delivery_address,
	      delivery_eta = _ref.delivery_eta,
	      delivery_lfd = _ref.delivery_lfd,
	      DeliveryStatus = _ref.DeliveryStatus,
	      cntrLocation = _ref.cntrLocation,
	      mag_note_other = _ref.mag_note_other,
	      DeliveryStatusOther = _ref.DeliveryStatusOther,
	      contact_person = _ref.contact_person,
	      contact_email = _ref.contact_email,
	      cntrNum = _ref.cntrNum,
	      bolNum = _ref.bolNum,
	      shipping_line = _ref.shipping_line,
	      size = _ref.size,
	      cargo_weight = _ref.cargo_weight,
	      terminal = _ref.terminal,
	      mag_note = _ref.mag_note,
	      OrderPalletQty = _ref.OrderPalletQty,
	      LooseQty = _ref.LooseQty,
	      ShippingMethod = _ref.ShippingMethod,
	      PONum = _ref.PONum,
	      Company_id = _ref.Company_id;
	
	  if (Company_id && Company_id.value) {
	    Company_id = Company_id.value;
	  }
	  if (PaymentTerm_id && PaymentTerm_id.value) {
	    PaymentTerm_id = PaymentTerm_id.value;
	  }
	  if (Agent_id && Agent_id.value) {
	    Agent_id = Agent_id.value;
	  }
	  if (Warehouse_id && Warehouse_id.value) {
	    Warehouse_id = Warehouse_id.value;
	  }
	  if (isFJ && Carrier && Carrier.value) {
	    Carrier = Carrier.value;
	  }
	  if (DestinationAddress && DestinationAddress.value) {
	    DestinationAddress = DestinationAddress.value;
	  }
	  if (PickupState && PickupState.value) {
	    PickupState = PickupState.value;
	  }
	  if (DropoffState && DropoffState.value) {
	    DropoffState = DropoffState.value;
	  }
	  if (ContainerSize && ContainerSize.value) {
	    ContainerSize = ContainerSize.value;
	  }
	  if (SalesOrderTypeSy && SalesOrderTypeSy.value) {
	    SalesOrderTypeSy = SalesOrderTypeSy.value;
	  }
	  if (ReceiveType && ReceiveType.value) {
	    ReceiveType = ReceiveType.value;
	  }
	  if (ReceiveUnit && ReceiveUnit.value) {
	    ReceiveUnit = ReceiveUnit.value;
	  }
	  if (isJTB && OrderType && OrderType.value) {
	    OrderType = OrderType.value;
	  }
	
	  // let Devan = true;
	  // let Drayage = true;
	  // if (isKDW) {
	  //   if (OrderType === 'DrayageOnly') {
	  //     Devan = false;
	  //     Drayage = true;
	  //   }
	  //   if (OrderType === 'DevanningOnly') {
	  //     Devan = true;
	  //     Drayage = false;
	  //   }
	  //   if (OrderType === 'DrayageAndDevanning') {
	  //     Devan = true;
	  //     Drayage = true;
	  //   }
	  // }
	
	  if ((isMAG || isKDW) && SaleStatus && SaleStatus.value) {
	    SaleStatus = SaleStatus.value;
	  }
	  if ((isMAG || isKDW) && shipping_line && shipping_line.value) {
	    shipping_line = shipping_line.value;
	  }
	  if ((isMAG || isKDW) && terminal && terminal.value) {
	    terminal = terminal.value;
	  }
	  if ((isMAG || isKDW) && mag_note && mag_note.value) {
	    mag_note = mag_note.value;
	  }
	  if ((isMAG || isKDW) && size && size.value) {
	    size = size.value;
	  }
	  if (DropshipType && DropshipType.value) {
	    DropshipType = DropshipType.value;
	  }
	  if (!UpdateTime) UpdateTime = (0, _cleanDates.convertUtcDate)();
	  if (Deliver_Customer_id) Deliver_Customer_id = Deliver_Customer_id.value || Deliver_Customer_id;
	  if (isHMM) {
	    Sales_Order_Lines = Sales_Order_Lines.map(function (line) {
	      return _extends({}, line, {
	        TotalPrice: line.Quantity * line.UnitPrice * line.PackageSize_1
	      });
	    });
	  }
	
	  var dsqWT = false;
	  if (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD) {
	    Sales_Order_Lines.map(function (line, i) {
	      // if ((!line.Quantity || line.Quantity === 0 || line.Quantity === '0') && (!line.PalletQuantity || line.PalletQuantity === 0 || line.PalletQuantity === '0')) {
	      //   alert("Please enter either Box or Pallet quantity for each line.");
	      //   dsqWT = true;
	      // }
	      // if (line.PalletQuantity && (Number(line.PalletQuantity) > 0)) {
	      //   if (line.Quantity && (Number(line.Quantity) > 0)) {
	      //     alert("A single product line cannot contain both Box and Pallet quantities.");
	      //     dsqWT = true;
	      //   }
	      // }
	      if (line.PalletQuantity && Number(line.PalletQuantity) > 0) {
	        if (!line.Quantity || line.Quantity === 0 || line.Quantity === '0') {
	          Sales_Order_Lines[i].Quantity = "1";
	        }
	      }
	    });
	    if (dsqWT) {
	      return;
	    }
	  }
	
	  if (isMAG || isKDW) {
	    Sales_Order_Lines = [{
	      "ProductTax": 0,
	      "CRV": 0,
	      "Product_id": 1,
	      "SalesOrderLine_id": 27,
	      "ImageUrl": null,
	      "RefPrice": 600,
	      "RefNum": "",
	      "TotalNetWeight": 1,
	      "ProductType": "Fixed",
	      "TotalShippingWeight": 0,
	      "MeasureUnit": "LB",
	      "TotalPrice": 600,
	      "NetWeight": 1,
	      "Description": "服务费",
	      "PackageSize": "1case*1case",
	      "PackageSize_1": "1",
	      "IsTaxable": false,
	      "Remark": null,
	      "ProductDescription": "服务费",
	      "Name": "service fee",
	      "ProductNum": "01010001",
	      "PackageType": "case",
	      "Product_id_id": 1,
	      "PickupQuantity": 0,
	      "CostPrice": 0,
	      "IsMobileLine": null,
	      "Order": 1,
	      "Quantity": 1,
	      "IsForFree": false,
	      "ProductName": "service fee",
	      "SalesOrder_id_id": 27,
	      "LoadedQuantity": 0,
	      "Weights": null,
	      "Batch_PONum": null,
	      "UnitPrice": 600
	    }];
	  }
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CREATING_SALES_ORDER });
	    _axios2.default.post('' + _url.SALES_QUOTE_URL, {
	      Sales_Order_Lines: Sales_Order_Lines,
	      Deliver_CustomerDetail_id: Deliver_CustomerDetail_id,
	      Deliver_Customer_id: Deliver_Customer_id,
	      IsWholesale: IsWholesale,
	      PaymentTerm_id: PaymentTerm_id,
	      Agent_id: Agent_id,
	      Pickup_Warehouse_id: Pickup_Warehouse_id,
	      OrderDate: OrderDate,
	      ETADate: ETADate,
	      DispatchDate: DispatchDate,
	      CPONum: CPONum,
	      TrackingNum: TrackingNum,
	      // dsq
	      OrderType: OrderType,
	      IsDevan: IsDevan,
	      IsDrayage: IsDrayage,
	      ContainerNum: ContainerNum,
	      SSL: SSL,
	      MBL: MBL,
	      Pin: Pin,
	      ChassisType: ChassisType,
	      PierPass: PierPass,
	      LastFreeDay: LastFreeDay,
	      IsFBAAddress: IsFBAAddress,
	      DestinationAddress: DestinationAddress,
	      ISANum: ISANum,
	      Trucker: Trucker,
	      ReleaseDate: ReleaseDate,
	      ReadyDate: ReadyDate,
	      OutboundDate: OutboundDate,
	      ShipmentID: ShipmentID,
	      Destination: Destination,
	      ContainerSize: ContainerSize,
	      SalesOrderTypeSy: SalesOrderTypeSy,
	      ISANote: ISANote,
	      DLNum: DLNum,
	      Carrier: Carrier,
	      Port: Port,
	      LFDate: LFDate,
	      IsDO: IsDO,
	      IsDirectShip: IsDirectShip,
	      IsBOL: IsBOL,
	      IsSeal: IsSeal,
	      BOL: BOL,
	      POD: POD,
	      IsPOD: IsPOD,
	      FBARoute: FBARoute,
	      ReceiveType: ReceiveType,
	      ReceiveUnit: ReceiveUnit,
	      DropshipType: DropshipType,
	      Appointment: Appointment,
	      AppointmentDate: AppointmentDate,
	      ShipmentDate: ShipmentDate,
	      Warehouse_id: Warehouse_id,
	      TruckingCo: TruckingCo,
	      DeliverTo: DeliverTo,
	      IsReturnEmpty: IsReturnEmpty,
	      ArrivalDate: ArrivalDate,
	      ReturnDate: ReturnDate,
	      StorageInDate: StorageInDate,
	      StorageOutDate: StorageOutDate,
	      // dsq
	      ExtInvoiceNum: ExtInvoiceNum,
	      Broker: Broker,
	      Truckload: Truckload,
	      TruckNum: TruckNum,
	      Dispatch: Dispatch,
	      DetentionRate: DetentionRate,
	      LumperFee: LumperFee,
	      PalletSpace: PalletSpace,
	      PickupDriver: PickupDriver,
	      PickupTrailerNum: PickupTrailerNum,
	      PickupDate: PickupDate,
	      PickupTime: PickupTime,
	      PickupStreet: PickupStreet,
	      PickupZip: PickupZip,
	      PickupCity: PickupCity,
	      PickupState: PickupState,
	      PickupAppt: PickupAppt,
	      DropoffDriver: DropoffDriver,
	      DropoffTrailerNum: DropoffTrailerNum,
	      DropoffDate: DropoffDate,
	      DropoffTime: DropoffTime,
	      DropoffStreet: DropoffStreet,
	      DropoffZip: DropoffZip,
	      DropoffCity: DropoffCity,
	      DropoffState: DropoffState,
	      DropoffAppt: DropoffAppt,
	      // 
	      IsOutbound: IsOutbound,
	      RefNum: RefNum,
	      Type: Type,
	      ClientCustName: ClientCustName,
	      ShipByDate: ShipByDate,
	      DocumentDate: DocumentDate,
	      UpdateTime: UpdateTime,
	      FinalNetWeight: FinalNetWeight,
	      FinalShippingWeight: FinalShippingWeight,
	      TotalPrice: TotalPrice,
	      FinalWeight: FinalWeight,
	      CarryType: CarryType,
	      Discount: Discount,
	      Savings: Savings,
	      ShippingCost: ShippingCost,
	      HandlingCost: HandlingCost,
	      MiscCost: MiscCost,
	      MiscNote: MiscNote,
	      TaxAmount: TaxAmount,
	      TaxRate: TaxRate,
	      SalesStatus: SalesStatus,
	      FinalPrice: FinalPrice,
	      ConvertItemPrice: ConvertItemPrice,
	      Deliver_Warehouse_id: Deliver_Warehouse_id,
	      DispatchMethod_id: DispatchMethod_id,
	      DispatchOutSourceContact_id: DispatchOutSourceContact_id,
	      Sales_User_id: Sales_User_id,
	      Product_id: Product_id,
	      Modifier_User_id: Modifier_User_id,
	      Notation: Notation,
	      EmployeeNote: EmployeeNote,
	      RouteNote: RouteNote,
	      Note: Note,
	      TotalCRV: TotalCRV,
	      RefPrice: RefPrice,
	      IsNoReduce: IsNoReduce,
	      TrailerNum: TrailerNum,
	      // kdw
	      PickupApptDate: PickupApptDate,
	      DeliveryApptDate: DeliveryApptDate,
	      DeliveryDate: DeliveryDate,
	      PerdiemDate: PerdiemDate,
	      Yard: Yard,
	      PortWaitTime: PortWaitTime,
	      ReturnTo: ReturnTo,
	      EmptyReadyDate: EmptyReadyDate,
	      DrayageCity: DrayageCity,
	
	      Trailer: Trailer,
	      DSQID: DSQID,
	      cntrNum: cntrNum,
	
	      //mag
	      SaleStatus: SaleStatus,
	      delivery_address: delivery_address,
	      delivery_eta: delivery_eta,
	      delivery_lfd: delivery_lfd,
	      DeliveryStatus: DeliveryStatus,
	      cntrLocation: cntrLocation,
	      mag_note_other: mag_note_other,
	      DeliveryStatusOther: DeliveryStatusOther,
	      contact_person: contact_person,
	      contact_email: contact_email,
	      bolNum: bolNum,
	      shipping_line: shipping_line,
	      size: size,
	      cargo_weight: cargo_weight,
	      terminal: terminal,
	      mag_note: mag_note,
	      OrderPalletQty: OrderPalletQty,
	      LooseQty: LooseQty,
	      // cnt
	      ShippingMethod: ShippingMethod,
	      // fung, fv
	      PONum: PONum,
	      //TQ
	      Company_id: Company_id
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(createSalesOrderSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(createSalesOrderFailure(err));
	    });
	  };
	}
	
	function createSalesOrder(_ref2) {
	  var Sales_Order_Lines = _ref2.Sales_Order_Lines,
	      Deliver_CustomerDetail_id = _ref2.Deliver_CustomerDetail_id,
	      Deliver_Customer_id = _ref2.Deliver_Customer_id,
	      IsWholesale = _ref2.IsWholesale,
	      PaymentTerm_id = _ref2.PaymentTerm_id,
	      Agent_id = _ref2.Agent_id,
	      Pickup_Warehouse_id = _ref2.Pickup_Warehouse_id,
	      OrderDate = _ref2.OrderDate,
	      ETADate = _ref2.ETADate,
	      DispatchDate = _ref2.DispatchDate,
	      DispatchStartTime = _ref2.DispatchStartTime,
	      DispatchEndTime = _ref2.DispatchEndTime,
	      CPONum = _ref2.CPONum,
	      TrackingNum = _ref2.TrackingNum,
	      OrderType = _ref2.OrderType,
	      IsDevan = _ref2.IsDevan,
	      IsDrayage = _ref2.IsDrayage,
	      ContainerNum = _ref2.ContainerNum,
	      SSL = _ref2.SSL,
	      MBL = _ref2.MBL,
	      Pin = _ref2.Pin,
	      ChassisType = _ref2.ChassisType,
	      PierPass = _ref2.PierPass,
	      LastFreeDay = _ref2.LastFreeDay,
	      IsFBAAddress = _ref2.IsFBAAddress,
	      DestinationAddress = _ref2.DestinationAddress,
	      ISANum = _ref2.ISANum,
	      Trucker = _ref2.Trucker,
	      ReleaseDate = _ref2.ReleaseDate,
	      ReadyDate = _ref2.ReadyDate,
	      OutboundDate = _ref2.OutboundDate,
	      ShipmentID = _ref2.ShipmentID,
	      Destination = _ref2.Destination,
	      ContainerSize = _ref2.ContainerSize,
	      SalesOrderTypeSy = _ref2.SalesOrderTypeSy,
	      ISANote = _ref2.ISANote,
	      DLNum = _ref2.DLNum,
	      Carrier = _ref2.Carrier,
	      Port = _ref2.Port,
	      LFDate = _ref2.LFDate,
	      IsDO = _ref2.IsDO,
	      IsDirectShip = _ref2.IsDirectShip,
	      IsBOL = _ref2.IsBOL,
	      IsSeal = _ref2.IsSeal,
	      BOL = _ref2.BOL,
	      POD = _ref2.POD,
	      IsPOD = _ref2.IsPOD,
	      FBARoute = _ref2.FBARoute,
	      ReceiveType = _ref2.ReceiveType,
	      ReceiveUnit = _ref2.ReceiveUnit,
	      DropshipType = _ref2.DropshipType,
	      Appointment = _ref2.Appointment,
	      AppointmentDate = _ref2.AppointmentDate,
	      ShipmentDate = _ref2.ShipmentDate,
	      Warehouse_id = _ref2.Warehouse_id,
	      TruckingCo = _ref2.TruckingCo,
	      DeliverTo = _ref2.DeliverTo,
	      IsReturnEmpty = _ref2.IsReturnEmpty,
	      ArrivalDate = _ref2.ArrivalDate,
	      ReturnDate = _ref2.ReturnDate,
	      StorageInDate = _ref2.StorageInDate,
	      StorageOutDate = _ref2.StorageOutDate,
	      ExtInvoiceNum = _ref2.ExtInvoiceNum,
	      Broker = _ref2.Broker,
	      Truckload = _ref2.Truckload,
	      TruckNum = _ref2.TruckNum,
	      Dispatch = _ref2.Dispatch,
	      DetentionRate = _ref2.DetentionRate,
	      LumperFee = _ref2.LumperFee,
	      PalletSpace = _ref2.PalletSpace,
	      PickupDriver = _ref2.PickupDriver,
	      PickupTrailerNum = _ref2.PickupTrailerNum,
	      PickupDate = _ref2.PickupDate,
	      PickupTime = _ref2.PickupTime,
	      PickupStreet = _ref2.PickupStreet,
	      PickupZip = _ref2.PickupZip,
	      PickupCity = _ref2.PickupCity,
	      PickupState = _ref2.PickupState,
	      PickupAppt = _ref2.PickupAppt,
	      DropoffDriver = _ref2.DropoffDriver,
	      DropoffTrailerNum = _ref2.DropoffTrailerNum,
	      DropoffDate = _ref2.DropoffDate,
	      DropoffTime = _ref2.DropoffTime,
	      DropoffStreet = _ref2.DropoffStreet,
	      DropoffZip = _ref2.DropoffZip,
	      DropoffCity = _ref2.DropoffCity,
	      DropoffState = _ref2.DropoffState,
	      DropoffAppt = _ref2.DropoffAppt,
	      IsOutbound = _ref2.IsOutbound,
	      RefNum = _ref2.RefNum,
	      Type = _ref2.Type,
	      ClientCustName = _ref2.ClientCustName,
	      ShipByDate = _ref2.ShipByDate,
	      DocumentDate = _ref2.DocumentDate,
	      UpdateTime = _ref2.UpdateTime,
	      FinalNetWeight = _ref2.FinalNetWeight,
	      FinalShippingWeight = _ref2.FinalShippingWeight,
	      TotalPrice = _ref2.TotalPrice,
	      FinalWeight = _ref2.FinalWeight,
	      CarryType = _ref2.CarryType,
	      Discount = _ref2.Discount,
	      Savings = _ref2.Savings,
	      ShippingCost = _ref2.ShippingCost,
	      HandlingCost = _ref2.HandlingCost,
	      SalesStatus = _ref2.SalesStatus,
	      MiscCost = _ref2.MiscCost,
	      MiscNote = _ref2.MiscNote,
	      TaxAmount = _ref2.TaxAmount,
	      TaxRate = _ref2.TaxRate,
	      FinalPrice = _ref2.FinalPrice,
	      ConvertItemPrice = _ref2.ConvertItemPrice,
	      Deliver_Warehouse_id = _ref2.Deliver_Warehouse_id,
	      DispatchMethod_id = _ref2.DispatchMethod_id,
	      DispatchOutSourceContact_id = _ref2.DispatchOutSourceContact_id,
	      Sales_User_id = _ref2.Sales_User_id,
	      Product_id = _ref2.Product_id,
	      Modifier_User_id = _ref2.Modifier_User_id,
	      Notation = _ref2.Notation,
	      EmployeeNote = _ref2.EmployeeNote,
	      RouteNote = _ref2.RouteNote,
	      Note = _ref2.Note,
	      TotalCRV = _ref2.TotalCRV,
	      RefPrice = _ref2.RefPrice,
	      IsNoReduce = _ref2.IsNoReduce,
	      TrailerNum = _ref2.TrailerNum,
	      PickupApptDate = _ref2.PickupApptDate,
	      DeliveryApptDate = _ref2.DeliveryApptDate,
	      DeliveryDate = _ref2.DeliveryDate,
	      PerdiemDate = _ref2.PerdiemDate,
	      Yard = _ref2.Yard,
	      PortWaitTime = _ref2.PortWaitTime,
	      ReturnTo = _ref2.ReturnTo,
	      EmptyReadyDate = _ref2.EmptyReadyDate,
	      DrayageCity = _ref2.DrayageCity,
	      Trailer = _ref2.Trailer,
	      DSQID = _ref2.DSQID,
	      SaleStatus = _ref2.SaleStatus,
	      delivery_address = _ref2.delivery_address,
	      delivery_eta = _ref2.delivery_eta,
	      delivery_lfd = _ref2.delivery_lfd,
	      DeliveryStatus = _ref2.DeliveryStatus,
	      cntrLocation = _ref2.cntrLocation,
	      mag_note_other = _ref2.mag_note_other,
	      DeliveryStatusOther = _ref2.DeliveryStatusOther,
	      contact_person = _ref2.contact_person,
	      contact_email = _ref2.contact_email,
	      cntrNum = _ref2.cntrNum,
	      bolNum = _ref2.bolNum,
	      shipping_line = _ref2.shipping_line,
	      size = _ref2.size,
	      cargo_weight = _ref2.cargo_weight,
	      terminal = _ref2.terminal,
	      mag_note = _ref2.mag_note,
	      OrderPalletQty = _ref2.OrderPalletQty,
	      LooseQty = _ref2.LooseQty,
	      ShippingMethod = _ref2.ShippingMethod,
	      PONum = _ref2.PONum,
	      Company_id = _ref2.Company_id;
	
	  if (Company_id && Company_id.value) {
	    Company_id = Company_id.value;
	  }
	  if (PaymentTerm_id && PaymentTerm_id.value) {
	    PaymentTerm_id = PaymentTerm_id.value;
	  }
	  if (Agent_id && Agent_id.value) {
	    Agent_id = Agent_id.value;
	  }
	  if (Warehouse_id && Warehouse_id.value) {
	    Warehouse_id = Warehouse_id.value;
	  }
	  if (isFJ && Carrier && Carrier.value) {
	    Carrier = Carrier.value;
	  }
	  if (DestinationAddress && DestinationAddress.value) {
	    DestinationAddress = DestinationAddress.value;
	  }
	  if (PickupState && PickupState.value) {
	    PickupState = PickupState.value;
	  }
	  if (DropoffState && DropoffState.value) {
	    DropoffState = DropoffState.value;
	  }
	  if (ContainerSize && ContainerSize.value) {
	    ContainerSize = ContainerSize.value;
	  }
	  if (SalesOrderTypeSy && SalesOrderTypeSy.value) {
	    SalesOrderTypeSy = SalesOrderTypeSy.value;
	  }
	  if (ReceiveType && ReceiveType.value) {
	    ReceiveType = ReceiveType.value;
	  }
	  if (ReceiveUnit && ReceiveUnit.value) {
	    ReceiveUnit = ReceiveUnit.value;
	  }
	  if (isJTB && OrderType && OrderType.value) {
	    OrderType = OrderType.value;
	  }
	  // let Devan = true;
	  // let Drayage = true;
	  // if (isKDW) {
	  //   if (OrderType === 'DrayageOnly') {
	  //     Devan = false;
	  //     Drayage = true;
	  //   }
	  //   if (OrderType === 'DevanningOnly') {
	  //     Devan = true;
	  //     Drayage = false;
	  //   }
	  //   if (OrderType === 'DrayageAndDevanning') {
	  //     Devan = true;
	  //     Drayage = true;
	  //   }
	  // }
	
	  if ((isMAG || isKDW) && SaleStatus && SaleStatus.value) {
	    SaleStatus = SaleStatus.value;
	  }
	  if ((isMAG || isKDW) && shipping_line && shipping_line.value) {
	    shipping_line = shipping_line.value;
	  }
	  if ((isMAG || isKDW) && terminal && terminal.value) {
	    terminal = terminal.value;
	  }
	  if ((isMAG || isKDW) && mag_note && mag_note.value) {
	    mag_note = mag_note.value;
	  }
	  if ((isMAG || isKDW) && size && size.value) {
	    size = size.value;
	  }
	  if (DropshipType && DropshipType.value) {
	    DropshipType = DropshipType.value;
	  }
	  if (!UpdateTime) UpdateTime = (0, _cleanDates.convertUtcDate)();
	  if (Deliver_Customer_id) Deliver_Customer_id = Deliver_Customer_id.value || Deliver_Customer_id;
	  if (isHMM) {
	    Sales_Order_Lines = Sales_Order_Lines.map(function (line) {
	      return _extends({}, line, {
	        TotalPrice: line.Quantity * line.UnitPrice * line.PackageSize_1
	      });
	    });
	  }
	
	  var dsqWT = false;
	  if (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD) {
	    Sales_Order_Lines.map(function (line, i) {
	      // if ((!line.Quantity || line.Quantity === 0 || line.Quantity === '0') && (!line.PalletQuantity || line.PalletQuantity === 0 || line.PalletQuantity === '0')) {
	      //   alert("Please enter either Box or Pallet quantity for each line.");
	      //   dsqWT = true;
	      // }
	      // if (line.PalletQuantity && (Number(line.PalletQuantity) > 0)) {
	      //   if (line.Quantity && (Number(line.Quantity) > 0)) {
	      //     alert("A single product line cannot contain both Box and Pallet quantities.");
	      //     dsqWT = true;
	      //   }
	      // }
	      if (line.PalletQuantity && Number(line.PalletQuantity) > 0) {
	        if (!line.Quantity || line.Quantity === 0 || line.Quantity === '0') {
	          Sales_Order_Lines[i].Quantity = "1";
	        }
	      }
	    });
	    if (dsqWT) {
	      return;
	    }
	  }
	
	  if (isMAG || isKDW) {
	    Sales_Order_Lines = [{
	      "ProductTax": 0,
	      "CRV": 0,
	      "Product_id": 1,
	      "SalesOrderLine_id": 27,
	      "ImageUrl": null,
	      "RefPrice": 600,
	      "RefNum": "",
	      "TotalNetWeight": 1,
	      "ProductType": "Fixed",
	      "TotalShippingWeight": 0,
	      "MeasureUnit": "LB",
	      "TotalPrice": 600,
	      "NetWeight": 1,
	      "Description": "服务费",
	      "PackageSize": "1case*1case",
	      "PackageSize_1": "1",
	      "IsTaxable": false,
	      "Remark": null,
	      "ProductDescription": "服务费",
	      "Name": "service fee",
	      "ProductNum": "01010001",
	      "PackageType": "case",
	      "Product_id_id": 1,
	      "PickupQuantity": 0,
	      "CostPrice": 0,
	      "IsMobileLine": null,
	      "Order": 1,
	      "Quantity": 1,
	      "IsForFree": false,
	      "ProductName": "service fee",
	      "SalesOrder_id_id": 27,
	      "LoadedQuantity": 0,
	      "Weights": null,
	      "Batch_PONum": null,
	      "UnitPrice": 600
	    }];
	  }
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CREATING_SALES_ORDER });
	    _axios2.default.post(_url.SALES_ORDERS_URL, {
	      Sales_Order_Lines: Sales_Order_Lines,
	      Deliver_CustomerDetail_id: Deliver_CustomerDetail_id,
	      Deliver_Customer_id: Deliver_Customer_id,
	      IsWholesale: IsWholesale,
	      PaymentTerm_id: PaymentTerm_id,
	      Agent_id: Agent_id,
	      Pickup_Warehouse_id: Pickup_Warehouse_id,
	      OrderDate: OrderDate,
	      ETADate: ETADate,
	      DispatchDate: DispatchDate,
	      DispatchStartTime: DispatchStartTime,
	      DispatchEndTime: DispatchEndTime,
	      CPONum: CPONum,
	      TrackingNum: TrackingNum,
	      // dsq
	      OrderType: OrderType,
	      IsDevan: IsDevan,
	      IsDrayage: IsDrayage,
	      ContainerNum: ContainerNum,
	      SSL: SSL,
	      MBL: MBL,
	      Pin: Pin,
	      ChassisType: ChassisType,
	      PierPass: PierPass,
	      LastFreeDay: LastFreeDay,
	      IsFBAAddress: IsFBAAddress,
	      DestinationAddress: DestinationAddress,
	      ISANum: ISANum,
	      Trucker: Trucker,
	      ReleaseDate: ReleaseDate,
	      ReadyDate: ReadyDate,
	      OutboundDate: OutboundDate,
	      ShipmentID: ShipmentID,
	      Destination: Destination,
	      ContainerSize: ContainerSize,
	      SalesOrderTypeSy: SalesOrderTypeSy,
	      ISANote: ISANote,
	      DLNum: DLNum,
	      Carrier: Carrier,
	      Port: Port,
	      LFDate: LFDate,
	      IsDO: IsDO,
	      IsDirectShip: IsDirectShip,
	      IsBOL: IsBOL,
	      IsSeal: IsSeal,
	      BOL: BOL,
	      POD: POD,
	      IsPOD: IsPOD,
	      FBARoute: FBARoute,
	      ReceiveType: ReceiveType,
	      ReceiveUnit: ReceiveUnit,
	      DropshipType: DropshipType,
	      Appointment: Appointment,
	      AppointmentDate: AppointmentDate,
	      ShipmentDate: ShipmentDate,
	      Warehouse_id: Warehouse_id,
	      TruckingCo: TruckingCo,
	      DeliverTo: DeliverTo,
	      IsReturnEmpty: IsReturnEmpty,
	      ArrivalDate: ArrivalDate,
	      ReturnDate: ReturnDate,
	      StorageInDate: StorageInDate,
	      StorageOutDate: StorageOutDate,
	      // dsq
	      ExtInvoiceNum: ExtInvoiceNum,
	      Broker: Broker,
	      Truckload: Truckload,
	      TruckNum: TruckNum,
	      Dispatch: Dispatch,
	      DetentionRate: DetentionRate,
	      LumperFee: LumperFee,
	      PalletSpace: PalletSpace,
	      PickupDriver: PickupDriver,
	      PickupTrailerNum: PickupTrailerNum,
	      PickupDate: PickupDate,
	      PickupTime: PickupTime,
	      PickupStreet: PickupStreet,
	      PickupZip: PickupZip,
	      PickupCity: PickupCity,
	      PickupState: PickupState,
	      PickupAppt: PickupAppt,
	      DropoffDriver: DropoffDriver,
	      DropoffTrailerNum: DropoffTrailerNum,
	      DropoffDate: DropoffDate,
	      DropoffTime: DropoffTime,
	      DropoffStreet: DropoffStreet,
	      DropoffZip: DropoffZip,
	      DropoffCity: DropoffCity,
	      DropoffState: DropoffState,
	      DropoffAppt: DropoffAppt,
	      // 
	      IsOutbound: IsOutbound,
	      RefNum: RefNum,
	      Type: Type,
	      ClientCustName: ClientCustName,
	      ShipByDate: ShipByDate,
	      DocumentDate: DocumentDate,
	      UpdateTime: UpdateTime,
	      FinalNetWeight: FinalNetWeight,
	      FinalShippingWeight: FinalShippingWeight,
	      TotalPrice: TotalPrice,
	      FinalWeight: FinalWeight,
	      CarryType: CarryType,
	      Discount: Discount,
	      Savings: Savings,
	      ShippingCost: ShippingCost,
	      HandlingCost: HandlingCost,
	      MiscCost: MiscCost,
	      MiscNote: MiscNote,
	      TaxAmount: TaxAmount,
	      TaxRate: TaxRate,
	      SalesStatus: SalesStatus,
	      FinalPrice: FinalPrice,
	      ConvertItemPrice: ConvertItemPrice,
	      Deliver_Warehouse_id: Deliver_Warehouse_id,
	      DispatchMethod_id: DispatchMethod_id,
	      DispatchOutSourceContact_id: DispatchOutSourceContact_id,
	      Sales_User_id: Sales_User_id,
	      Product_id: Product_id,
	      Modifier_User_id: Modifier_User_id,
	      Notation: Notation,
	      EmployeeNote: EmployeeNote,
	      RouteNote: RouteNote,
	      Note: Note,
	      TotalCRV: TotalCRV,
	      RefPrice: RefPrice,
	      IsNoReduce: IsNoReduce,
	      TrailerNum: TrailerNum,
	      // kdw
	      PickupApptDate: PickupApptDate,
	      DeliveryApptDate: DeliveryApptDate,
	      DeliveryDate: DeliveryDate,
	      PerdiemDate: PerdiemDate,
	      Yard: Yard,
	      PortWaitTime: PortWaitTime,
	      ReturnTo: ReturnTo,
	      EmptyReadyDate: EmptyReadyDate,
	      DrayageCity: DrayageCity,
	
	      Trailer: Trailer,
	      DSQID: DSQID,
	      cntrNum: cntrNum,
	
	      //mag
	      SaleStatus: SaleStatus,
	      delivery_address: delivery_address,
	      delivery_eta: delivery_eta,
	      delivery_lfd: delivery_lfd,
	      DeliveryStatus: DeliveryStatus,
	      cntrLocation: cntrLocation,
	      mag_note_other: mag_note_other,
	      DeliveryStatusOther: DeliveryStatusOther,
	      contact_person: contact_person,
	      contact_email: contact_email,
	      bolNum: bolNum,
	      shipping_line: shipping_line,
	      size: size,
	      cargo_weight: cargo_weight,
	      terminal: terminal,
	      mag_note: mag_note,
	      OrderPalletQty: OrderPalletQty,
	      LooseQty: LooseQty,
	      // cnt
	      ShippingMethod: ShippingMethod,
	      // fung, fv
	      PONum: PONum,
	      //TQ
	      Company_id: Company_id
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(createSalesOrderSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(createSalesOrderFailure(err));
	    });
	  };
	}
	
	function createSalesOrderSuccess(order) {
	  return {
	    type: _type.CREATE_SALES_ORDER_SUCCESS,
	    payload: order
	  };
	}
	
	function createSalesOrderFailure(error) {
	  return {
	    type: _type.CREATE_SALES_ORDER_FAILURE,
	    payload: error
	  };
	}
	
	function editSalesOrder(_ref3, SalesOrder_id) {
	  var Sales_Order_Lines = _ref3.Sales_Order_Lines,
	      SONum = _ref3.SONum,
	      Deliver_CustomerDetail_id = _ref3.Deliver_CustomerDetail_id,
	      Deliver_Customer_id = _ref3.Deliver_Customer_id,
	      Delivery = _ref3.Delivery,
	      IsWholesale = _ref3.IsWholesale,
	      PaymentTerm_id = _ref3.PaymentTerm_id,
	      Agent_id = _ref3.Agent_id,
	      Pickup_Warehouse_id = _ref3.Pickup_Warehouse_id,
	      OrderDate = _ref3.OrderDate,
	      ETADate = _ref3.ETADate,
	      DispatchDate = _ref3.DispatchDate,
	      DispatchStartTime = _ref3.DispatchStartTime,
	      DispatchEndTime = _ref3.DispatchEndTime,
	      CPONum = _ref3.CPONum,
	      TrackingNum = _ref3.TrackingNum,
	      OrderType = _ref3.OrderType,
	      IsDevan = _ref3.IsDevan,
	      IsDrayage = _ref3.IsDrayage,
	      ContainerNum = _ref3.ContainerNum,
	      SSL = _ref3.SSL,
	      MBL = _ref3.MBL,
	      Pin = _ref3.Pin,
	      ChassisType = _ref3.ChassisType,
	      PierPass = _ref3.PierPass,
	      LastFreeDay = _ref3.LastFreeDay,
	      IsFBAAddress = _ref3.IsFBAAddress,
	      DestinationAddress = _ref3.DestinationAddress,
	      ISANum = _ref3.ISANum,
	      Trucker = _ref3.Trucker,
	      ReleaseDate = _ref3.ReleaseDate,
	      ReadyDate = _ref3.ReadyDate,
	      OutboundDate = _ref3.OutboundDate,
	      ShipmentID = _ref3.ShipmentID,
	      Destination = _ref3.Destination,
	      ContainerSize = _ref3.ContainerSize,
	      SalesOrderTypeSy = _ref3.SalesOrderTypeSy,
	      ISANote = _ref3.ISANote,
	      DLNum = _ref3.DLNum,
	      Carrier = _ref3.Carrier,
	      Port = _ref3.Port,
	      LFDate = _ref3.LFDate,
	      IsDO = _ref3.IsDO,
	      IsDirectShip = _ref3.IsDirectShip,
	      IsBOL = _ref3.IsBOL,
	      IsSeal = _ref3.IsSeal,
	      BOL = _ref3.BOL,
	      POD = _ref3.POD,
	      IsPOD = _ref3.IsPOD,
	      FBARoute = _ref3.FBARoute,
	      ReceiveType = _ref3.ReceiveType,
	      ReceiveUnit = _ref3.ReceiveUnit,
	      DropshipType = _ref3.DropshipType,
	      Appointment = _ref3.Appointment,
	      AppointmentDate = _ref3.AppointmentDate,
	      ShipmentDate = _ref3.ShipmentDate,
	      Warehouse_id = _ref3.Warehouse_id,
	      TruckingCo = _ref3.TruckingCo,
	      DeliverTo = _ref3.DeliverTo,
	      IsReturnEmpty = _ref3.IsReturnEmpty,
	      ArrivalDate = _ref3.ArrivalDate,
	      ReturnDate = _ref3.ReturnDate,
	      StorageInDate = _ref3.StorageInDate,
	      StorageOutDate = _ref3.StorageOutDate,
	      ExtInvoiceNum = _ref3.ExtInvoiceNum,
	      Broker = _ref3.Broker,
	      Truckload = _ref3.Truckload,
	      TruckNum = _ref3.TruckNum,
	      Dispatch = _ref3.Dispatch,
	      DetentionRate = _ref3.DetentionRate,
	      LumperFee = _ref3.LumperFee,
	      PalletSpace = _ref3.PalletSpace,
	      PickupDriver = _ref3.PickupDriver,
	      PickupTrailerNum = _ref3.PickupTrailerNum,
	      PickupDate = _ref3.PickupDate,
	      PickupTime = _ref3.PickupTime,
	      PickupStreet = _ref3.PickupStreet,
	      PickupZip = _ref3.PickupZip,
	      PickupCity = _ref3.PickupCity,
	      PickupState = _ref3.PickupState,
	      PickupAppt = _ref3.PickupAppt,
	      DropoffDriver = _ref3.DropoffDriver,
	      DropoffTrailerNum = _ref3.DropoffTrailerNum,
	      DropoffDate = _ref3.DropoffDate,
	      DropoffTime = _ref3.DropoffTime,
	      DropoffStreet = _ref3.DropoffStreet,
	      DropoffZip = _ref3.DropoffZip,
	      DropoffCity = _ref3.DropoffCity,
	      DropoffState = _ref3.DropoffState,
	      DropoffAppt = _ref3.DropoffAppt,
	      IsOutbound = _ref3.IsOutbound,
	      RefNum = _ref3.RefNum,
	      Type = _ref3.Type,
	      ClientCustName = _ref3.ClientCustName,
	      ShipByDate = _ref3.ShipByDate,
	      FinalNetWeight = _ref3.FinalNetWeight,
	      TrailerNum = _ref3.TrailerNum,
	      PickupApptDate = _ref3.PickupApptDate,
	      DeliveryApptDate = _ref3.DeliveryApptDate,
	      DeliveryDate = _ref3.DeliveryDate,
	      PerdiemDate = _ref3.PerdiemDate,
	      Yard = _ref3.Yard,
	      PortWaitTime = _ref3.PortWaitTime,
	      ReturnTo = _ref3.ReturnTo,
	      EmptyReadyDate = _ref3.EmptyReadyDate,
	      DrayageCity = _ref3.DrayageCity,
	      Trailer = _ref3.Trailer,
	      DSQID = _ref3.DSQID,
	      cntrNum = _ref3.cntrNum,
	      SaleStatus = _ref3.SaleStatus,
	      delivery_address = _ref3.delivery_address,
	      delivery_eta = _ref3.delivery_eta,
	      delivery_lfd = _ref3.delivery_lfd,
	      DeliveryStatus = _ref3.DeliveryStatus,
	      cntrLocation = _ref3.cntrLocation,
	      mag_note_other = _ref3.mag_note_other,
	      DeliveryStatusOther = _ref3.DeliveryStatusOther,
	      contact_person = _ref3.contact_person,
	      contact_email = _ref3.contact_email,
	      bolNum = _ref3.bolNum,
	      shipping_line = _ref3.shipping_line,
	      size = _ref3.size,
	      cargo_weight = _ref3.cargo_weight,
	      terminal = _ref3.terminal,
	      mag_note = _ref3.mag_note,
	      OrderPalletQty = _ref3.OrderPalletQty,
	      LooseQty = _ref3.LooseQty,
	      TotalCRV = _ref3.TotalCRV,
	      TotalPrice = _ref3.TotalPrice,
	      FinalWeight = _ref3.FinalWeight,
	      CarryType = _ref3.CarryType,
	      Discount = _ref3.Discount,
	      Savings = _ref3.Savings,
	      ShippingCost = _ref3.ShippingCost,
	      HandlingCost = _ref3.HandlingCost,
	      SalesStatus = _ref3.SalesStatus,
	      MiscCost = _ref3.MiscCost,
	      MiscNote = _ref3.MiscNote,
	      TaxAmount = _ref3.TaxAmount,
	      TaxRate = _ref3.TaxRate,
	      FinalPrice = _ref3.FinalPrice,
	      ConvertItemPrice = _ref3.ConvertItemPrice,
	      Deliver_Warehouse_id = _ref3.Deliver_Warehouse_id,
	      DispatchMethod_id = _ref3.DispatchMethod_id,
	      DispatchOutSourceContact_id = _ref3.DispatchOutSourceContact_id,
	      Sales_User_id = _ref3.Sales_User_id,
	      Product_id = _ref3.Product_id,
	      Modifier_User_id = _ref3.Modifier_User_id,
	      Notation = _ref3.Notation,
	      RouteNote = _ref3.RouteNote,
	      Note = _ref3.Note,
	      RefPrice = _ref3.RefPrice,
	      IsNoReduce = _ref3.IsNoReduce,
	      Notes = _ref3.Notes,
	      PONum = _ref3.PONum,
	      Company_id = _ref3.Company_id;
	
	  if (Company_id && Company_id.value) {
	    Company_id = Company_id.value;
	  }
	  if (PaymentTerm_id && PaymentTerm_id.value) {
	    PaymentTerm_id = PaymentTerm_id.value;
	  }
	  if (isFJ && Carrier && Carrier.value) {
	    Carrier = Carrier.value;
	  }
	  if (Agent_id && Agent_id.value) {
	    Agent_id = Agent_id.value;
	  }
	  if (Warehouse_id && Warehouse_id.value) {
	    Warehouse_id = Warehouse_id.value;
	  }
	  if (DestinationAddress && DestinationAddress.value) {
	    DestinationAddress = DestinationAddress.value;
	  }
	  if (PickupState && PickupState.value) {
	    PickupState = PickupState.value;
	  }
	  if (DropoffState && DropoffState.value) {
	    DropoffState = DropoffState.value;
	  }
	  if (ContainerSize && ContainerSize.value) {
	    ContainerSize = ContainerSize.value;
	  }
	  if (SalesOrderTypeSy && SalesOrderTypeSy.value) {
	    SalesOrderTypeSy = SalesOrderTypeSy.value;
	  }
	  if (ReceiveType && ReceiveType.value) {
	    ReceiveType = ReceiveType.value;
	  }
	  if (ReceiveUnit && ReceiveUnit.value) {
	    ReceiveUnit = ReceiveUnit.value;
	  }
	  if (isJTB && OrderType && OrderType.value) {
	    OrderType = OrderType.value;
	  }
	  // let Devan = true;
	  // let Drayage = true;
	  // if (isKDW) {
	  //   if (OrderType === 'DrayageOnly') {
	  //     Devan = false;
	  //     Drayage = true;
	  //   }
	  //   if (OrderType === 'DevanningOnly') {
	  //     Devan = true;
	  //     Drayage = false;
	  //   }
	  //   if (OrderType === 'DrayageAndDevanning') {
	  //     Devan = true;
	  //     Drayage = true;
	  //   }
	  // }
	
	  if ((isMAG || isKDW) && SaleStatus && SaleStatus.value) {
	    SaleStatus = SaleStatus.value;
	  }
	  if ((isMAG || isKDW) && shipping_line && shipping_line.value) {
	    shipping_line = shipping_line.value;
	  }
	  if ((isMAG || isKDW) && terminal && terminal.value) {
	    terminal = terminal.value;
	  }
	  if ((isMAG || isKDW) && mag_note && mag_note.value) {
	    mag_note = mag_note.value;
	  }
	  if ((isMAG || isKDW) && size && size.value) {
	    size = size.value;
	  }
	
	  var dsqWT = false;
	  if (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD) {
	    Sales_Order_Lines.map(function (line, i) {
	      // if ((!line.Quantity || line.Quantity === 0 || line.Quantity === '0') && (!line.PalletQuantity || line.PalletQuantity === 0 || line.PalletQuantity === '0')) {
	      //   alert("Please enter either Box or Pallet quantity for each line.");
	      //   dsqWT = true;
	      // }
	      // if (line.PalletQuantity && (Number(line.PalletQuantity) > 0)) {
	      //   if (line.Quantity && (Number(line.Quantity) > 0)) {
	      //     alert("A single product line cannot contain both Box and Pallet quantities.");
	      //     dsqWT = true;
	      //   }
	      // }
	      if (line.PalletQuantity && Number(line.PalletQuantity) > 0) {
	        if (!line.Quantity || line.Quantity === 0 || line.Quantity === '0') {
	          Sales_Order_Lines[i].Quantity = "1";
	        }
	      }
	    });
	    if (dsqWT) {
	      return;
	    }
	  }
	  if (DropshipType && DropshipType.value) {
	    DropshipType = DropshipType.value;
	  }
	  if (!OrderDate) OrderDate = (0, _cleanDates.convertUtcDate)();
	  if (Deliver_Customer_id) Deliver_Customer_id = Deliver_Customer_id.value || Deliver_Customer_id;
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EDITING_SALES_ORDER });
	    _axios2.default.put(_url.SALES_ORDERS_URL + SalesOrder_id, {
	      Sales_Order_Lines: Sales_Order_Lines,
	      SONum: SONum,
	      Deliver_CustomerDetail_id: Deliver_CustomerDetail_id,
	      Deliver_Customer_id: Deliver_Customer_id,
	      Delivery: Delivery,
	      IsWholesale: IsWholesale,
	      PaymentTerm_id: PaymentTerm_id,
	      Agent_id: Agent_id,
	      Pickup_Warehouse_id: Pickup_Warehouse_id,
	      OrderDate: OrderDate,
	      ETADate: ETADate,
	      DispatchDate: DispatchDate,
	      DispatchStartTime: DispatchStartTime,
	      DispatchEndTime: DispatchEndTime,
	      CPONum: CPONum,
	      TrackingNum: TrackingNum,
	      // dsq
	      OrderType: OrderType,
	      IsDevan: IsDevan,
	      IsDrayage: IsDrayage,
	      ContainerNum: ContainerNum,
	      SSL: SSL,
	      MBL: MBL,
	      Pin: Pin,
	      ChassisType: ChassisType,
	      PierPass: PierPass,
	      LastFreeDay: LastFreeDay,
	      IsFBAAddress: IsFBAAddress,
	      DestinationAddress: DestinationAddress,
	      ISANum: ISANum,
	      Trucker: Trucker,
	      ReleaseDate: ReleaseDate,
	      ReadyDate: ReadyDate,
	      OutboundDate: OutboundDate,
	      ShipmentID: ShipmentID,
	      Destination: Destination,
	      ContainerSize: ContainerSize,
	      SalesOrderTypeSy: SalesOrderTypeSy,
	      ISANote: ISANote,
	      DLNum: DLNum,
	      Carrier: Carrier,
	      Port: Port,
	      LFDate: LFDate,
	      IsDO: IsDO,
	      IsDirectShip: IsDirectShip,
	      IsBOL: IsBOL,
	      IsSeal: IsSeal,
	      BOL: BOL,
	      POD: POD,
	      IsPOD: IsPOD,
	      FBARoute: FBARoute,
	      ReceiveType: ReceiveType,
	      ReceiveUnit: ReceiveUnit,
	      DropshipType: DropshipType,
	      Appointment: Appointment,
	      AppointmentDate: AppointmentDate,
	      ShipmentDate: ShipmentDate,
	      Warehouse_id: Warehouse_id,
	      TruckingCo: TruckingCo,
	      DeliverTo: DeliverTo,
	      IsReturnEmpty: IsReturnEmpty,
	      ArrivalDate: ArrivalDate,
	      ReturnDate: ReturnDate,
	      StorageInDate: StorageInDate,
	      StorageOutDate: StorageOutDate,
	      // 
	      ExtInvoiceNum: ExtInvoiceNum,
	      Broker: Broker,
	      Truckload: Truckload,
	      TruckNum: TruckNum,
	      Dispatch: Dispatch,
	      DetentionRate: DetentionRate,
	      LumperFee: LumperFee,
	      PalletSpace: PalletSpace,
	      PickupDriver: PickupDriver,
	      PickupTrailerNum: PickupTrailerNum,
	      PickupDate: PickupDate,
	      PickupTime: PickupTime,
	      PickupStreet: PickupStreet,
	      PickupZip: PickupZip,
	      PickupCity: PickupCity,
	      PickupState: PickupState,
	      PickupAppt: PickupAppt,
	      DropoffDriver: DropoffDriver,
	      DropoffTrailerNum: DropoffTrailerNum,
	      DropoffDate: DropoffDate,
	      DropoffTime: DropoffTime,
	      DropoffStreet: DropoffStreet,
	      DropoffZip: DropoffZip,
	      DropoffCity: DropoffCity,
	      DropoffState: DropoffState,
	      DropoffAppt: DropoffAppt,
	      // 
	      IsOutbound: IsOutbound,
	      TrailerNum: TrailerNum,
	      // kdw
	      PickupApptDate: PickupApptDate,
	      DeliveryApptDate: DeliveryApptDate,
	      DeliveryDate: DeliveryDate,
	      PerdiemDate: PerdiemDate,
	      Yard: Yard,
	      PortWaitTime: PortWaitTime,
	      ReturnTo: ReturnTo,
	      EmptyReadyDate: EmptyReadyDate,
	      DrayageCity: DrayageCity,
	
	      Trailer: Trailer,
	      DSQID: DSQID,
	      cntrNum: cntrNum,
	
	      //mag
	      SaleStatus: SaleStatus,
	      delivery_address: delivery_address,
	      delivery_eta: delivery_eta,
	      delivery_lfd: delivery_lfd,
	      DeliveryStatus: DeliveryStatus,
	      cntrLocation: cntrLocation,
	      mag_note_other: mag_note_other,
	      DeliveryStatusOther: DeliveryStatusOther,
	      contact_person: contact_person,
	      contact_email: contact_email,
	      bolNum: bolNum,
	      shipping_line: shipping_line,
	      size: size,
	      cargo_weight: cargo_weight,
	      terminal: terminal,
	      mag_note: mag_note,
	      OrderPalletQty: OrderPalletQty,
	      LooseQty: LooseQty,
	      // dsq
	      RefNum: RefNum,
	      Type: Type,
	      ClientCustName: ClientCustName,
	      ShipByDate: ShipByDate,
	      FinalNetWeight: FinalNetWeight,
	      // FinalShippingWeight,
	      TotalCRV: TotalCRV,
	      TotalPrice: TotalPrice,
	      FinalWeight: FinalWeight,
	      CarryType: CarryType,
	      Discount: Discount,
	      Savings: Savings,
	      ShippingCost: ShippingCost,
	      HandlingCost: HandlingCost,
	      SalesStatus: SalesStatus,
	      MiscCost: MiscCost,
	      MiscNote: MiscNote,
	      TaxAmount: TaxAmount,
	      TaxRate: TaxRate,
	      FinalPrice: FinalPrice,
	      ConvertItemPrice: ConvertItemPrice,
	      Deliver_Warehouse_id: Deliver_Warehouse_id,
	      DispatchMethod_id: DispatchMethod_id,
	      DispatchOutSourceContact_id: DispatchOutSourceContact_id,
	      Sales_User_id: Sales_User_id,
	      Product_id: Product_id,
	      Modifier_User_id: Modifier_User_id,
	      Notation: Notation,
	      // EmployeeNote,
	      RouteNote: RouteNote,
	      Note: Note,
	      RefPrice: RefPrice,
	      IsNoReduce: IsNoReduce,
	      Notes: Notes,
	      // fung, fv
	      PONum: PONum,
	      //TQ
	      Company_id: Company_id
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editSalesOrderSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editSalesOrderFailure(err));
	    });
	  };
	}
	
	function editSalesOrderSuccess(order) {
	  return {
	    type: _type.EDIT_SALES_ORDER_SUCCESS,
	    payload: order
	  };
	}
	
	function editSalesOrderFailure(error) {
	  return {
	    type: _type.EDIT_SALES_ORDER_FAILURE,
	    payload: error
	  };
	}
	
	var setOrderToOpen = exports.setOrderToOpen = function setOrderToOpen(soid, success) {
	  return function (dispatch) {
	    (0, _axios2.default)({
	      method: 'PUT',
	      url: _root_url.ROOT_URL + 'v1/sale/reopen/' + soid,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (res) {
	      success();
	    }).catch(function (err) {
	      alert('ERROR');
	    });
	  };
	};
	
	function voidSalesOrder(salesOrder_id) {
	  var route = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_VOID_SALES_ORDER });
	    _axios2.default.put(_url.SALES_ORDERS_URL + 'cancel/' + salesOrder_id + '/', {}, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(voidSalesOrderSuccess());
	      if (route) {
	        if (route === 'mobileSalesOrders') {
	          _reactRouter.browserHistory.push('/mobileSalesOrders');
	        } else {
	          _reactRouter.browserHistory.push('/salesOrders');
	        }
	      }
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(voidSalesOrderFailure(err));
	    });
	  };
	}
	
	function voidSalesOrderSuccess() {
	  return {
	    type: _type.VOID_SALES_ORDER_SUCCESS
	  };
	}
	
	function voidSalesOrderFailure(response) {
	  return {
	    type: _type.VOID_SALES_ORDER_FAILURE,
	    payload: response
	  };
	}
	
	// fetch SO customer sales history
	function requestCustomerSalesHistory() {
	  return {
	    type: _type.REQUEST_CUSTOMER_SALES_HISTORY
	  };
	}
	
	function fetchCustomerSalesHistorySuccess(history) {
	  return {
	    type: _type.FETCH_CUSTOMER_SALES_HISTORY_SUCCESS,
	    payload: history
	  };
	}
	
	function fetchCustomerSalesHistoryFailure(error) {
	  return {
	    type: _type.FETCH_CUSTOMER_SALES_HISTORY_FAILURE,
	    payload: error
	  };
	}
	
	function fetchCustomerSalesHistory(customerId) {
	  return function (dispatch) {
	    dispatch(requestCustomerSalesHistory());
	    return _axios2.default.get('' + _url.CUSTOMER_SALES_HISTORY + customerId, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchCustomerSalesHistorySuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCustomerSalesHistoryFailure(err));
	    });
	  };
	}
	
	// fetch SO customer order sc
	function fetchCustomerOrderSchedules() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CUSTOMER_ORDER_SCHEDULES });
	    _axios2.default.get(_url.SALES_DASHBOARD_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchCustomerOrderSchedulesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCustomerOrderSchedulesFailure(err));
	    });
	  };
	}
	
	function fetchCustomerOrderSchedulesByDate(date) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CUSTOMER_ORDER_SCHEDULES });
	    _axios2.default.get(_url.SALES_DASHBOARD_URL + date, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchCustomerOrderSchedulesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCustomerOrderSchedulesFailure(err));
	    });
	  };
	}
	
	function fetchCustomerOrderSchedulesSuccess(orderSchedules) {
	  return {
	    type: _type.FETCH_CUSTOMER_ORDER_SCHEDULES_SUCCESS,
	    payload: orderSchedules
	  };
	}
	
	function fetchCustomerOrderSchedulesFailure(error) {
	  return {
	    type: _type.FETCH_CUSTOMER_ORDER_SCHEDULES_FAILURE,
	    payload: error
	  };
	}
	
	function fetchTodaysOutgoingOrders() {
	  return function (dispatch) {
	    dispatch(requestTodaysOutgoingOrders());
	    return _axios2.default.get(_url.OUTGOING_ORDERS_BY_DATE_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchTodaysOutgoingOrdersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchTodaysOutgoingOrdersFailure(err));
	    });
	  };
	}
	
	function requestTodaysOutgoingOrders() {
	  return {
	    type: _type.REQUEST_TODAYS_OUTGOING_ORDERS
	  };
	}
	
	function fetchTodaysOutgoingOrdersSuccess(orders) {
	  return {
	    type: _type.FETCH_TODAYS_OUTGOING_ORDERS_SUCCESS,
	    payload: orders
	  };
	}
	
	function fetchTodaysOutgoingOrdersFailure(error) {
	  return {
	    type: _type.FETCH_TODAYS_OUTGOING_ORDERS_FAILURE,
	    payload: error
	  };
	}
	
	var podUpload = exports.podUpload = function podUpload(salesorderId, data, success) {
	  (0, _axios2.default)({
	    method: 'POST',
	    data: data,
	    url: _root_url.ROOT_URL + 'v1/oversea-warehouse/upload-pod-files/' + salesorderId,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (response) {
	    success();
	  }, function (err) {
	    alert('error uploading pod file');
	  });
	};
	
	var uploadMSO = exports.uploadMSO = function uploadMSO(data, success) {
	  (0, _axios2.default)({
	    method: 'POST',
	    data: data,
	    url: _root_url.ROOT_URL + 'v2/amzey_import_orders/',
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (response) {
	    success();
	  }, function (err) {
	    alert('error uploading mso order' + JSON.stringify(err.data || data));
	  });
	};
	
	var podUPloadSCM = exports.podUPloadSCM = function podUPloadSCM(salesorderId, data, success) {
	  (0, _axios2.default)({
	    method: 'POST',
	    data: data,
	    url: _root_url.ROOT_URL + 'v1/sale/upload_pod_file/' + salesorderId,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (response) {
	    success();
	  }, function (err) {
	    alert('error uploading pod file');
	  });
	};
	
	function fetchOutgoingOrdersByDate(_ref4) {
	  var fromDate = _ref4.fromDate,
	      toDate = _ref4.toDate;
	
	  return function (dispatch) {
	    dispatch(requestTodaysOutgoingOrders());
	    return (0, _axios2.default)({
	      method: 'get',
	      url: _url.OUTGOING_ORDERS_BY_DATE_URL,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      params: {
	        start_date: fromDate,
	        end_date: toDate
	      }
	    }).then(function (response) {
	      dispatch(fetchTodaysOutgoingOrdersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchTodaysOutgoingOrdersFailure(err));
	    });
	  };
	}
	
	function fetchSalesOrderLineWeights(line_id) {
	  return function (dispatch) {
	    dispatch(requestSalesOrderLineWeights());
	    return _axios2.default.get(_url.SALES_ORDER_LINE_WEIGHTS_URL + line_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesOrderLineWeightsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesOrderLineWeightsFailure(err));
	    });
	  };
	}
	
	function requestSalesOrderLineWeights() {
	  return {
	    type: _type.REQUEST_SALES_ORDER_LINE_WEIGHTS
	  };
	}
	
	function fetchSalesOrderLineWeightsSuccess(weights) {
	  return {
	    type: _type.FETCH_SALES_ORDER_LINE_WEIGHTS_SUCCESS,
	    payload: weights
	  };
	}
	
	function fetchSalesOrderLineWeightsFailure(error) {
	  return {
	    type: _type.FETCH_SALES_ORDER_LINE_WEIGHTS_FAILURE,
	    payload: error
	  };
	}
	
	function setOrderLineWeights(line_id, lines) {
	  var Weights = [];
	  lines.map(function (row) {
	    Weights.push(parseFloat(row.Weight));
	  });
	  return function (dispatch) {
	    dispatch(requestSetOrderLineWeights());
	    return _axios2.default.post(_url.SALES_ORDER_LINE_WEIGHTS_URL + line_id, {
	      Weights: Weights
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editSalesOrderLineWeightsSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editSalesOrderLineWeightsFailure(err));
	    });
	  };
	}
	
	function requestSetOrderLineWeights() {
	  return {
	    type: _type.REQUEST_SET_ORDER_LINE_WEIGHTS
	  };
	}
	
	function editSalesOrderLineWeightsSuccess() {
	  return {
	    type: _type.EDIT_SALES_ORDER_LINE_WEIGHTS_SUCCESS
	  };
	}
	
	function editSalesOrderLineWeightsFailure(error) {
	  return {
	    type: _type.EDIT_SALES_ORDER_LINE_WEIGHTS_FAILURE,
	    payload: error
	  };
	}
	
	function clearSalesOrderLineWeights() {
	  return {
	    type: _type.CLEAR_SALES_ORDER_LINE_WEIGHTS
	  };
	}
	
	function fetchSalesOrderForm() {
	  return function (dispatch) {
	    dispatch(requestSalesOrderForm());
	    return _axios2.default.get(_url.FETCH_SALES_ORDER_FORM_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesOrderFormSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesOrderFormFailure(err));
	    });
	  };
	}
	
	function requestSalesOrderForm() {
	  return {
	    type: _type.REQUEST_SALES_ORDER_FORM
	  };
	}
	
	function fetchSalesOrderFormSuccess(form) {
	  return {
	    type: _type.FETCH_SALES_ORDER_FORM_SUCCESS,
	    payload: form
	  };
	}
	
	function fetchSalesOrderFormFailure(error) {
	  return {
	    type: _type.FETCH_SALES_ORDER_FORM_FAILURE,
	    payload: error
	  };
	}
	
	function clearInventories() {
	  return {
	    type: _type.CLEAR_INVENTORIES
	  };
	}
	
	function fetchSalesCSV() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SALES_CSV });
	    return _axios2.default.post(_root_url.ROOT_URL + 'v1/dashboard/salesiif/',
	    // DASHBOARD_URL + 'salescsv/',
	    {}, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesCSVSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesCSVFailure(err));
	    });
	  };
	}
	
	function fetchSalesCSVSuccess(form) {
	  return {
	    type: _type.FETCH_SALES_CSV_SUCCESS,
	    payload: form
	  };
	}
	
	function fetchSalesCSVFailure(error) {
	  return {
	    type: _type.FETCH_SALES_CSV_FAILURE,
	    payload: error
	  };
	}
	
	function savePosSale(_ref5) {
	  var Order_id = _ref5.Order_id,
	      Order_Num = _ref5.Order_Num,
	      Subtotal = _ref5.Subtotal,
	      FinalPrice = _ref5.FinalPrice,
	      TaxRate = _ref5.TaxRate,
	      Sales_User = _ref5.Sales_User,
	      Warehouse_id = _ref5.Warehouse_id,
	      Note = _ref5.Note,
	      POS_Order_Lines = _ref5.POS_Order_Lines,
	      SaleStatus = _ref5.SaleStatus;
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SAVE_POS_SALE });
	    return _axios2.default.post(_url.POS_SALE_URL, {
	      Order_id: Order_id,
	      Order_Num: Order_Num,
	      Subtotal: Subtotal,
	      FinalPrice: FinalPrice,
	      TaxRate: TaxRate,
	      Sales_User: Sales_User,
	      Warehouse_id: Warehouse_id,
	      Note: Note,
	      POS_Order_Lines: POS_Order_Lines,
	      SaleStatus: SaleStatus
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch((0, _reduxForm.change)('pos', 'ProductNum', ''));
	      dispatch((0, _reduxForm.change)('pos', 'Quantity', ''));
	      dispatch((0, _reduxForm.change)('pos', 'CashCharge', ''));
	      dispatch((0, _reduxForm.change)('pos', 'CheckCharge', ''));
	      dispatch((0, _reduxForm.change)('pos', 'CreditCharge', ''));
	      dispatch((0, _reduxForm.change)('pos', 'FinalCharge', ''));
	      dispatch(savePosSaleSuccessful(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(savePosSaleFailure(err));
	    });
	  };
	}
	
	function savePosSaleSuccessful(response) {
	  return {
	    type: _type.SAVE_POS_SALE_SUCCESS
	  };
	}
	
	function savePosSaleFailure(error) {
	  return {
	    type: _type.SAVE_POS_SALE_FAILURE,
	    payload: error
	  };
	}
	
	function invalidCharacterEntered() {
	  return {
	    type: _type.INVALID_CHARACTER_ENTERED
	  };
	}
	
	function chargeNotMet() {
	  return {
	    type: _type.CHARGE_NOT_MET
	  };
	}
	
	function clearErrorMessageInPOS() {
	  return {
	    type: _type.CLEAR_ERROR_MESSAGE_IN_POS
	  };
	}
	
	function startNewOrder() {
	  return {
	    type: _type.START_NEW_ORDER
	  };
	}
	
	function startNewItem() {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)('pos', 'ProductNum', ''));
	    dispatch((0, _reduxForm.change)('pos', 'Quantity', ''));
	  };
	}
	
	function setSaleRowValue(CustomerLevel, form, row) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)(form, 'UnitPrice', row['PriceLv' + CustomerLevel] ? row['PriceLv' + CustomerLevel] : row.Price));
	    dispatch((0, _reduxForm.change)(form, 'Weight', row.NetWeight));
	  };
	}
	
	function setSaleOrderProductValues(CustomerPrice, form, product) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)(form, 'UnitPrice', CustomerPrice));
	    dispatch((0, _reduxForm.change)(form, 'Weight', product.NetWeight));
	    dispatch((0, _reduxForm.change)(form, 'ProductCost', product.ProductCost));
	    dispatch((0, _reduxForm.change)(form, 'PackageSize_1', product.PackageSize_1));
	  };
	}
	
	function setSaleFavoriteRowValue(title, form, row) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)(form, 'ProductInformation', title));
	  };
	}
	
	function setCredit(value) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'creditRadios', value));
	  };
	}
	
	function setSubtotal(value) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'Subtotal', value));
	  };
	}
	
	function resetFormInputs() {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'Quantity', '1'));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'UnitPrice', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'ProductInformation', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'Weight', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'itemNotation', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'ProductCost', ''));
	
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'ReceivedQuantity', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'ShipmentID', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'ServiceType', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'CustomerRef', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'Unloader', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'TruckVendor', ''));
	
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'ISANum', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'BillablePallets', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'PalletQuantity', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'BoxQuantity', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'PieceQuantity', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'RealPallets', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'BoxPerPallet', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'FBACode', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'DispatchType', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'BoxVol', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'BoxLength', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'BoxWidth', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'BoxHeight', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'InnerLabelQty', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'OuterLabelQty', ''));
	
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'BoxWeight', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'RepackedPalletQuantity', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'PalletLength', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'PalletWidth', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'PalletHeight', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'PalletVol', ''));
	
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'UnitQuantity', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'PerBoxQty', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'UnitLength', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'UnitWidth', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'UnitHeight', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'UnitVol', ''));
	
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'PalletWeight', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'IsOversize', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'IsOverweight', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'PortDray', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'DrayageTrucker', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'TotalShippingWeight', 0));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'Location', ''));
	
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'Zone', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'Section', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'Bin', ''));
	
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'FBARoute', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'DimUnit', ''));
	
	    // dispatch(change('salesOrderForm', 'VendorStyleNum', ''));
	    // dispatch(change('salesOrderForm', 'TJXStyleNum', ''));
	    // dispatch(change('salesOrderForm', 'LineDescription', ''));
	    // dispatch(change('salesOrderForm', 'UPC', ''));
	    // dispatch(change('salesOrderForm', 'Color', ''));
	    // dispatch(change('salesOrderForm', 'Size', ''));
	    // dispatch(change('salesOrderForm', 'TotalUnits', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'StoreReady', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'PalletStackable', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'Preticketed', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'CantonNum', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'OriginCountry', ''));
	
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'PackageSize_1', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'jmlPackageSize_1', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'jmlBox', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'WeightUnit', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'TrailerNum', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'POList', ''));
	    dispatch((0, _reduxForm.change)('salesOrderForm', 'POD', ''));
	  };
	}
	
	function setValue(form, field, value) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)(form, field, value));
	  };
	}
	
	function fetchPOSDraft(pk) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_DRAFT_DETAILS });
	    return _axios2.default.get(_url.POS_SALE_URL + pk, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchDraftDetailsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchDraftDetailsFailure(err));
	    });
	  };
	}
	
	function fetchDraftDetailsSuccess(details) {
	  return {
	    type: _type.LOAD_DRAFT_SUCCESS,
	    payload: details
	  };
	}
	
	function fetchDraftDetailsFailure(error) {
	  return {
	    type: _type.LOAD_DRAFT_FAILURE,
	    payload: error
	  };
	}
	
	function fetchDrafts() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_DRAFTS });
	    return _axios2.default.get(_url.POS_SALE_URL + 'draft', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchDraftsSuccessful(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchDraftsFailure(err));
	    });
	  };
	}
	
	function fetchDraftsSuccessful(drafts) {
	  return {
	    type: _type.FETCH_DRAFTS_SUCCESSFUL,
	    payload: drafts
	  };
	}
	
	function fetchDraftsFailure(error) {
	  return {
	    type: _type.FETCH_DRAFTS_FAILURE,
	    payload: error
	  };
	}
	
	function clearForm() {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)('pos', 'ProductNum', ''));
	    dispatch((0, _reduxForm.change)('pos', 'Quantity', ''));
	    dispatch((0, _reduxForm.change)('pos', 'CashCharge', ''));
	    dispatch((0, _reduxForm.change)('pos', 'CheckCharge', ''));
	    dispatch((0, _reduxForm.change)('pos', 'CreditCharge', ''));
	    dispatch((0, _reduxForm.change)('pos', 'FinalCharge', ''));
	  };
	}
	
	// export function createSalesReturn({
	//             Promo,
	//             Tax,
	//             ReStockingFee,
	//             Note
	//           },{
	//             SalesInvoiceCompleted_id,
	//             CustomerNum
	//           },
	//           TotalPrice,
	//           Sales_Return_Line,
	//           CustomerNumWithoutInvoice,
	//           ReturnStatus) {
	//             let FinalPrice = (parseFloat(Promo) || 0) + (parseFloat(Tax) || 0) + (parseFloat(ReStockingFee) || 0) + (parseFloat(TotalPrice) || 0)
	//             let ReturnDate = new Date;
	//             if(CustomerNumWithoutInvoice)
	//               CustomerNumWithoutInvoice = CustomerNumWithoutInvoice.value || CustomerNumWithoutInvoice;
	//             CustomerNum = CustomerNum || CustomerNumWithoutInvoice;
	//             return dispatch => {
	// dispatch({ type: REQUEST_CREATING_SALES_RETURN });
	// axios.post(SALES_RETURN_URL,
	//     {
	//         Promo,
	//         Tax,
	//         ReStockingFee,
	//         TotalPrice,
	//         FinalPrice,
	//         SalesInvoiceCompleted_id,
	//         CustomerNum,
	//         ReturnDate,
	//         Sales_Return_Line,
	//         ReturnStatus,
	//         Note
	//     },
	//     {
	//         headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	//     }
	// )
	// .then(response => {
	//     dispatch(createSalesReturnSuccess());
	//     browserHistory.push('/customerReturn');
	// })
	// .catch(response => {
	//     dispatch(createSalesReturnFailure(response));
	// })
	//   }
	// }
	
	function createCreditIssue(Deliver_Customer_id, TotalPrice, TaxRate, Tax, CRV, RestockingFee, FinalPrice, Note, invoice, PostingDate) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CREATING_SALES_RETURN });
	    var Sales_Return_Line = [];
	    for (var i = 0; i < invoice.rows.length; i++) {
	      var newEntry = {};
	      newEntry.Product_id = invoice.rows[i].Product_id;
	      newEntry.Name = invoice.rows[i].Name;
	      newEntry.Description = invoice.rows[i].Description;
	      newEntry.ProductType = invoice.rows[i].ProductType;
	      newEntry.UnitPrice = parseFloat(invoice.rows[i].UnitPrice);
	      newEntry.ReturnQuantity = parseFloat(invoice.rows[i].ReturnQuantity);
	      newEntry.ReturnCRV = parseFloat(invoice.rows[i].CRV);
	      newEntry.ReturnTotalPrice = parseFloat(invoice.rows[i].ReturnTotalPrice);
	      newEntry.ReturnWeight = parseFloat(invoice.rows[i].ReturnWeight);
	      newEntry.ReturnWeightsList = invoice.rows[i].Weights;
	      newEntry.ReturnReason = invoice.rows[i].ReturnReason;
	      newEntry.IsProductReturned = invoice.rows[i].IsProductReturned;
	      Sales_Return_Line.push(newEntry);
	    }
	    TotalPrice = parseFloat(TotalPrice);
	    Tax = parseFloat(Tax);
	    CRV = parseFloat(CRV);
	    RestockingFee = parseFloat(RestockingFee);
	    FinalPrice = parseFloat(FinalPrice);
	    _axios2.default.post(_url.SALES_ISSUE_CREDIT_URL, {
	      Deliver_Customer_id: Deliver_Customer_id,
	      Sales_Return_Line: Sales_Return_Line,
	      TotalPrice: TotalPrice,
	      TaxRate: TaxRate,
	      Tax: Tax,
	      CRV: CRV,
	      RestockingFee: RestockingFee,
	      FinalPrice: FinalPrice,
	      Note: Note,
	      PostingDate: (0, _cleanDates.convertUtcDate)(PostingDate)
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(createCreditIssueSuccess());
	      _reactRouter.browserHistory.push('/inventoryReturn');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(createCreditIssueFailure(err));
	    });
	  };
	}
	
	function createCreditIssueSuccess() {
	  return {
	    type: _type.CREATE_SALES_RETURN_SUCCESS
	  };
	}
	
	function createCreditIssueFailure(error) {
	  return {
	    type: _type.CREATE_SALES_RETURN_FAILURE,
	    payload: error
	  };
	}
	
	function createSalesReturn(InvoiceNum, TotalPrice, Tax, CRV, RestockingFee, FinalPrice, Note, invoice, SalesInvoice_id, CreditInvoiceNum, PostingDate) {
	  var Redeliver = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : false;
	  var ReturnedSavings = arguments[12];
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CREATING_SALES_RETURN });
	    var SRNum = InvoiceNum + 'R';
	    var Sales_Return_Line = [];
	    for (var i = 0; i < invoice.selectedRows.length; i++) {
	      var newEntry = {};
	      newEntry.Product_id = invoice.selectedRows[i].Product_id;
	      newEntry.SalesInvoiceLine_id = invoice.selectedRows[i].SalesInvoiceLine_id;
	      newEntry.Name = invoice.selectedRows[i].Name;
	      newEntry.Description = invoice.selectedRows[i].Description;
	      newEntry.ProductType = invoice.selectedRows[i].ProductType;
	      newEntry.UnitPrice = parseFloat(invoice.selectedRows[i].UnitPrice);
	      newEntry.ReturnQuantity = parseFloat(invoice.selectedRows[i].ReturnQuantity);
	      newEntry.ReturnCRV = parseFloat(invoice.selectedRows[i].ReturnCRV);
	      newEntry.ReturnTotalPrice = parseFloat(invoice.selectedRows[i].ReturnTotalPrice);
	      newEntry.ReturnReason = invoice.selectedRows[i].ReturnReason;
	      newEntry.ReturnWeight = parseFloat(invoice.selectedRows[i].ReturnWeight);
	      if (invoice.selectedRows[i].ProductType === 'Non-Fixed') {
	        newEntry.ReturnWeightsList = invoice.selectedRows[i].ReturnWeightsList;
	      }
	      if (_root_url.isJML) {
	        newEntry.ReturnBox = invoice.selectedRows[i].ReturnBox;
	        newEntry.jmlPackageSize1 = invoice.selectedRows[i].jmlPackageSize1;
	        newEntry.Batch_id = invoice.selectedRows[i].Batch_id;
	      }
	      Sales_Return_Line.push(newEntry);
	    }
	    TotalPrice = parseFloat(TotalPrice);
	    ReturnedSavings = parseFloat(ReturnedSavings);
	    Tax = parseFloat(Tax);
	    CRV = parseFloat(CRV);
	    RestockingFee = parseFloat(RestockingFee);
	    FinalPrice = parseFloat(FinalPrice);
	    _axios2.default.post(_url.SALES_RETURN_URL + '?SalesInvoice_id=' + SalesInvoice_id + '&Redeliver=' + Redeliver, {
	      SRNum: SRNum,
	      Sales_Return_Line: Sales_Return_Line,
	      TotalPrice: TotalPrice,
	      ReturnedSavings: ReturnedSavings,
	      Tax: Tax,
	      CRV: CRV,
	      RestockingFee: RestockingFee,
	      FinalPrice: FinalPrice,
	      Note: Note,
	      PostingDate: (0, _cleanDates.convertUtcDate)(PostingDate),
	      CreditInvoiceNum: CreditInvoiceNum || ''
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(createSalesReturnSuccess());
	      _reactRouter.browserHistory.push('/inventoryReturn');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(createSalesReturnFailure(err));
	    });
	  };
	}
	
	function createSalesReturnSuccess() {
	  return {
	    type: _type.CREATE_SALES_RETURN_SUCCESS
	  };
	}
	
	function createSalesReturnFailure(error) {
	  return {
	    type: _type.CREATE_SALES_RETURN_FAILURE,
	    payload: error
	  };
	}
	
	function editSalesReturn(SRNum, TotalPrice, Tax, CRV, RestockingFee, FinalPrice, Note, invoice, SalesReturn_id, CreditInvoiceNum, PostingDate, ReturnedSavings) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CREATING_SALES_RETURN });
	    var Sales_Return_Line = [];
	    for (var i = 0; i < invoice.selectedRows.length; i++) {
	      var newEntry = {};
	      newEntry.Product_id = invoice.selectedRows[i].Product_id;
	      newEntry.SalesInvoiceLine_id = invoice.selectedRows[i].SalesInvoiceLine_id;
	      newEntry.Name = invoice.selectedRows[i].Name;
	      newEntry.Description = invoice.selectedRows[i].Description;
	      newEntry.ProductType = invoice.selectedRows[i].ProductType;
	      newEntry.UnitPrice = parseFloat(invoice.selectedRows[i].UnitPrice);
	      newEntry.ReturnQuantity = parseFloat(invoice.selectedRows[i].ReturnQuantity);
	      newEntry.ReturnCRV = parseFloat(invoice.selectedRows[i].ReturnCRV);
	      newEntry.ReturnTotalPrice = parseFloat(invoice.selectedRows[i].ReturnTotalPrice);
	      newEntry.ReturnReason = invoice.selectedRows[i].ReturnReason;
	      newEntry.SalesReturnLine_id = invoice.selectedRows[i].SalesReturnLine_id;
	      if (invoice.selectedRows[i].ProductType === 'Non-Fixed') {
	        newEntry.ReturnWeight = parseFloat(invoice.selectedRows[i].ReturnWeight);
	        newEntry.ReturnWeightsList = invoice.selectedRows[i].ReturnWeightsList;
	      }
	      if (_root_url.isJML) {
	        newEntry.ReturnBox = invoice.selectedRows[i].ReturnBox ? Number(invoice.selectedRows[i].ReturnBox) : 0;
	        newEntry.jmlPackageSize1 = invoice.selectedRows[i].jmlPackageSize1;
	        newEntry.Batch_id = invoice.selectedRows[i].Batch_id;
	      }
	      Sales_Return_Line.push(newEntry);
	    }
	    TotalPrice = parseFloat(TotalPrice);
	    ReturnedSavings = parseFloat(ReturnedSavings);
	    Tax = parseFloat(Tax);
	    CRV = parseFloat(CRV);
	    RestockingFee = parseFloat(RestockingFee);
	    FinalPrice = parseFloat(FinalPrice);
	    _axios2.default.put(_url.SALES_RETURN_URL + SalesReturn_id, {
	      SRNum: SRNum,
	      Sales_Return_Line: Sales_Return_Line,
	      TotalPrice: TotalPrice,
	      ReturnedSavings: ReturnedSavings,
	      Tax: Tax,
	      CRV: CRV,
	      RestockingFee: RestockingFee,
	      FinalPrice: FinalPrice,
	      Note: Note,
	      PostingDate: (0, _cleanDates.convertUtcDate)(PostingDate),
	      CreditInvoiceNum: CreditInvoiceNum || ''
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editSalesReturnSuccess());
	      _reactRouter.browserHistory.push('/inventoryReturn');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editSalesReturnFailure(err));
	    });
	  };
	}
	
	function editSalesReturnSuccess() {
	  return {
	    type: _type.CREATE_SALES_RETURN_SUCCESS
	  };
	}
	
	function editSalesReturnFailure(error) {
	  return {
	    type: _type.CREATE_SALES_RETURN_FAILURE,
	    payload: error
	  };
	}
	
	function fetchSalesReturnDetail(id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SALES_RETURN_DETAIL });
	    return _axios2.default.get(_url.SALES_RETURN_URL + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesReturnDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesReturnDetailFailure(err));
	    });
	  };
	}
	
	function fetchSalesReturnDetailSuccess(form) {
	  return {
	    type: _type.FETCH_SALES_RETURN_DETAIL_SUCCESS,
	    payload: form
	  };
	}
	
	function fetchSalesReturnDetailFailure(error) {
	  return {
	    type: _type.FETCH_SALES_RETURN_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function fetchInventoryReturns(SalesReturn_id__ReturnDate__gte, SalesReturn_id__ReturnDate__lte, days) {
	  var dates = (0, _cleanDates.toFromDates)(days, SalesReturn_id__ReturnDate__gte, SalesReturn_id__ReturnDate__lte);
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_INVENTORY_RETURN });
	    return _axios2.default.get(_url.SALES_RETURN_URL + '?PostingDate__gte=' + dates.fromDate + '&PostingDate__lte=' + dates.toDate, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchInventoryReturnsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchInventoryReturnsFailure(err));
	    });
	  };
	}
	
	function fetchInventoryReturnsSuccess(form) {
	  return {
	    type: _type.FETCH_INVENTORY_RETURN_SUCCESS,
	    payload: form
	  };
	}
	
	function fetchInventoryReturnsFailure(error) {
	  return {
	    type: _type.FETCH_INVENTORY_RETURN_FAILURE,
	    payload: error
	  };
	}
	
	function fetchInventoryReturnsDetails(SalesReturn_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_INVENTORY_RETURN_DETAILS });
	    return _axios2.default.get(_url.SALES_RETURN_URL + SalesReturn_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchInventoryReturnsDetailsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchInventoryReturnsDetailsFailure(err));
	    });
	  };
	}
	
	function fetchInventoryReturnsDetailsSuccess(form) {
	  return {
	    type: _type.FETCH_INVENTORY_RETURN_DETAILS_SUCCESS,
	    payload: form
	  };
	}
	
	function fetchInventoryReturnsDetailsFailure(error) {
	  return {
	    type: _type.FETCH_INVENTORY_RETURN_DETAILS_FAILURE,
	    payload: error
	  };
	}
	
	function editInventoryReturns(SalesReturnLine) {
	  return function (dispatch) {
	    dispatch({ type: _type.EDIT_INVENTORY_RETURN });
	    return _axios2.default.put(_url.SALES_RETURN_URL + 'inventory/', {
	      SalesReturnLine: SalesReturnLine
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editInventoryReturnsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editInventoryReturnsFailure(err));
	    });
	  };
	}
	
	function editInventoryReturnsSuccess(form) {
	  return {
	    type: _type.EDIT_INVENTORY_RETURN_SUCCESS,
	    payload: form
	  };
	}
	
	function editInventoryReturnsFailure(error) {
	  return {
	    type: _type.EDIT_INVENTORY_RETURN_FAILURE,
	    payload: error
	  };
	}
	
	function fetchCustomerPrices(pk) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CUSTOMER_PRICES });
	    return _axios2.default.get(_url.INVENTORIES_URL + pk, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchCustomerPricesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCustomerPricesFailure(err));
	    });
	  };
	}
	
	function fetchCustomerPricesSuccess(prices) {
	  return {
	    type: _type.FETCH_CUSTOMER_PRICES_SUCCESS,
	    payload: prices
	  };
	}
	
	function fetchCustomerPricesFailure(error) {
	  return {
	    type: _type.FETCH_CUSTOMER_PRICES_FAILURE,
	    payload: error
	  };
	}
	
	function fetchCurrencyRatesSuccess(rates) {
	  return {
	    type: _type.FETCH_CURRENCY_RATES_SUCCESS,
	    payload: rates
	  };
	}
	
	function fetchCurrencyRatesFailure(error) {
	  return {
	    type: _type.FETCH_CURRENCY_RATES_FAILURE,
	    payload: error
	  };
	}
	
	function fetchCurrencyRates() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CURRENCY_RATES });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: _url.CURRENCY_RATES_URL,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchCurrencyRatesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCurrencyRatesFailure(err));
	    });
	  };
	}
	
	function editMultiCurrenciesSuccess(data) {
	  return {
	    type: _type.EDIT_MULTI_CURRENCIES_SUCCESS,
	    payload: data
	  };
	}
	
	function editMultiCurrenciesFailure(error) {
	  return {
	    type: _type.EDIT_MULTI_CURRENCIES_FAILURE,
	    payload: error
	  };
	}
	
	function editMultiCurrencies(currencies) {
	  return function (dispatch) {
	    dispatch({ type: _type.EDIT_MULTI_CURRENCIES });
	    return (0, _axios2.default)({
	      method: 'put',
	      url: _url.CURRENCY_RATES_URL,
	      data: currencies,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editMultiCurrenciesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editMultiCurrenciesFailure(err));
	    });
	  };
	}
	
	function fetchTaxRatesSuccess(rates) {
	  return {
	    type: _type.FETCH_TAX_RATES_SUCCESS,
	    payload: rates
	  };
	}
	
	function fetchTaxRatesFailure(error) {
	  return {
	    type: _type.FETCH_TAX_RATES_FAILURE,
	    payload: error
	  };
	}
	
	function fetchTaxRates(pk) {
	  if (pk === undefined) {
	    pk = '';
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_TAX_RATES });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: _url.TAX_RATES_URL + pk,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchTaxRatesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchTaxRatesFailure(err));
	    });
	  };
	}
	
	function editMultiTaxesSuccess(data) {
	  return {
	    type: _type.EDIT_MULTI_TAXES_SUCCESS,
	    payload: data
	  };
	}
	
	function editMultiTaxesFailure(error) {
	  return {
	    type: _type.EDIT_MULTI_TAXES_FAILURE,
	    payload: error
	  };
	}
	
	function editMultiTaxes(taxes) {
	  return function (dispatch) {
	    dispatch({ type: _type.EDIT_MULTI_TAXES });
	    return (0, _axios2.default)({
	      method: 'post',
	      url: _url.TAX_RATES_URL,
	      data: taxes,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editMultiTaxesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editMultiTaxesFailure(err));
	    });
	  };
	}
	
	function deleteTaxSuccess(data) {
	  return {
	    type: _type.DELETE_TAX_SUCCESS,
	    payload: data
	  };
	}
	
	function deleteTaxFailure(error) {
	  return {
	    type: _type.DELETE_TAX_FAILURE,
	    payload: error
	  };
	}
	
	function deleteTax(taxAreaId) {
	  return function (dispatch) {
	    dispatch({ type: _type.DELETE_TAX });
	    return (0, _axios2.default)({
	      method: 'delete',
	      url: _url.TAX_RATES_URL + taxAreaId,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(deleteTaxSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(deleteTaxFailure(err));
	    });
	  };
	}
	
	function fetchOverallSalesPerformance(type) {
	  var start_date = (0, _moment2.default)().toISOString();
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_OVERALL_SALES_PERFORMANCE });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: _url.OVERALL_SALES_PERFORMANCE_URL,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      params: {
	        type: type,
	        start_date: start_date
	      }
	    }).then(function (response) {
	      dispatch(fetchOverallSalesPerformanceSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchOverallSalesPerformanceFailure(err));
	    });
	  };
	}
	
	function fetchOverallSalesPerformanceSuccess(data) {
	  return {
	    type: _type.FETCH_OVERALL_SALES_PERFORMANCE_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchOverallSalesPerformanceFailure(error) {
	  return {
	    type: _type.FETCH_OVERALL_SALES_PERFORMANCE_FAILURE,
	    payload: error
	  };
	}
	
	function fetchPosReport(type, days, fromDate, toDate, division, num, salesID) {
	  if (salesID == null) {
	    salesID = '';
	  } else {
	    salesID = '&Order_id__Sales_user=' + salesID;
	  }
	  var dates = (0, _cleanDates.toFromDates)(days, fromDate, toDate);
	
	  if (days == null || days == -1 || days == 'none') days = '';else days = '/' + days;
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_POS_REPORT });
	    return _axios2.default.get(_url.POS_REPORT_URL + type + days + '/' + ('?Order_id__Date__gte=' + dates.fromDate + '&Order_id__Date__lte=' + dates.toDate + division + num + salesID), {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPosReportSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPosReportFailure(err));
	    });
	  };
	}
	
	function fetchPosReportSuccess(results) {
	  return {
	    type: _type.FETCH_POS_REPORT_SUCCESS,
	    payload: results
	  };
	}
	
	function fetchPosReportFailure(error) {
	  return {
	    type: _type.FETCH_POS_REPORT_FAILURE,
	    payload: error
	  };
	}
	
	function fetchSalesInventoryInfo(customer_id, type, value) {
	  if (value == null) value = ' ';
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SALES_INVENTORY_INFO });
	    return _axios2.default.get(_url.SALES_INVENTORY_INFO_URL + customer_id + '/?' + type + '=' + value, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesInventoryInfoSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesInventoryInfoFailure(err));
	    });
	  };
	}
	
	function fetchSalesInventoryInfoSuccess(info) {
	  return {
	    type: _type.FETCH_SALES_INVENTORY_INFO_SUCCESS,
	    payload: info
	  };
	}
	
	function fetchSalesInventoryInfoFailure(error) {
	  return {
	    type: _type.FETCH_SALES_INVENTORY_INFO_FAILURE,
	    payload: error
	  };
	}
	
	function fetchSalesCustomerDetail(pk, SalesOrder_id, isShippingCustomer) {
	  var url = _url.SALES_CUSTOMER_URL + (SalesOrder_id ? SalesOrder_id + '/order' : pk);
	  return function (dispatch) {
	    if (isShippingCustomer) {
	      dispatch({ type: _type.REQUEST_SALES_SHIPPING_CUSTOMER_DETAIL });
	    } else {
	      dispatch({ type: _type.REQUEST_SALES_CUSTOMER_DETAIL });
	    }
	    return _axios2.default.get(url, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      if (isShippingCustomer) {
	        dispatch(fetchShippingCustomerDetailSuccess(response));
	      } else {
	        dispatch(fetchSalesCustomerDetailSuccess(response));
	      }
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesCustomerDetailFailure(err));
	    });
	  };
	}
	
	function fetchShippingCustomerDetailSuccess(details) {
	  return { type: _type.FETCH_SALES_SHIPPING_CUSTOMER_DETAIL_SUCCESS, payload: details };
	}
	
	function fetchSalesCustomerDetailSuccess(details) {
	  return { type: _type.FETCH_SALES_CUSTOMER_DETAIL_SUCCESS, payload: details };
	}
	
	function fetchSalesCustomerDetailFailure(error) {
	  return { type: _type.FETCH_SALES_CUSTOMER_DETAIL_FAILURE, payload: error };
	}
	
	function fetchAllShipping() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SHIPPING_DETAIL });
	    return _axios2.default.get(_url.SHIPPING_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchAllShippingDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchAllShippingDetailFailure(err));
	    });
	  };
	}
	
	function fetchAllShippingDetailSuccess(details) {
	  return {
	    type: _type.FETCH_SHIPPING_DETAIL_SUCCESS,
	    payload: details
	  };
	}
	
	function fetchAllShippingDetailFailure(error) {
	  return {
	    type: _type.FETCH_SHIPPING_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function fetchPurchasesVendorDetail(Vendor_id) {
	  var url = _url.PURCHASES_VENDOR_URL + Vendor_id + '/';
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PURCHASES_VENDOR_DETAIL });
	    return _axios2.default.get(url, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPurchasesVendorDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPurchasesVendorDetailFailure(err));
	    });
	  };
	}
	
	function fetchPurchasesVendorDetailSuccess(details) {
	  return {
	    type: _type.FETCH_PURCHASES_VENDOR_DETAIL_SUCCESS,
	    payload: details
	  };
	}
	
	function fetchPurchasesVendorDetailFailure(error) {
	  return {
	    type: _type.FETCH_PURCHASES_VENDOR_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function clearSalesCustomerDetails() {
	  return {
	    type: _type.CLEAR_SALES_CUSTOMER_DETAILS
	  };
	}
	
	function fetchItemSalesHistory(Customer_id, Product_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_ITEM_SALES_HISTORY });
	    return _axios2.default.get(_url.ITEM_HISTORY_URL + Customer_id + '/' + Product_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchItemSalesHistorySuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchItemSalesHistoryFailure(err));
	    });
	  };
	}
	
	function fetchItemSalesHistorySuccess(hist) {
	  return {
	    type: _type.FETCH_ITEM_SALES_HISTORY_SUCCESS,
	    payload: hist
	  };
	}
	
	function fetchItemSalesHistoryFailure(error) {
	  return {
	    type: _type.FETCH_ITEM_SALES_HISTORY_FAILURE,
	    payload: error
	  };
	}
	
	function fetchCustomerFrequent(Customer_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CUSTOMER_FREQUENT });
	    return _axios2.default.get(_url.FREQUENT_ITEMS_URL + Customer_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchCustomerFrequentSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCustomerFrequentFailure(err));
	    });
	  };
	}
	
	function fetchInboundProducts() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CUSTOMER_FREQUENT });
	    return _axios2.default.get(_url.INBOUND_PRODUCTS_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchCustomerFrequentSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCustomerFrequentFailure(err));
	    });
	  };
	}
	
	function fetchCustomerFrequentSuccess(items) {
	  return {
	    type: _type.FETCH_CUSTOMER_FREQUENT_SUCCESS,
	    payload: items
	  };
	}
	
	function fetchCustomerFrequentFailure(error) {
	  return {
	    type: _type.FETCH_CUSTOMER_FREQUENT_FAILURE,
	    payload: error
	  };
	}
	
	function initializeForm(data, fields, Form) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.initialize)(Form, data, fields));
	  };
	}
	
	function setSalesOrdersFilter(data) {
	  return {
	    type: _type.SET_SALES_ORDERS_FILTER,
	    payload: data
	  };
	}
	
	function fetchSalesPerformance(salesType, days, fromDate, toDate, type, productNum, group, category, aggregate) {
	  var dates = (0, _cleanDates.toFromDates)(days, fromDate, toDate);
	  if (salesType == 'salesorder') {
	    fromDate = 'SalesInvoice_id__DispatchDate__gte=' + dates.fromDate;
	    toDate = 'SalesInvoice_id__DispatchDate__lte=' + dates.toDate;
	  } else if (salesType == 'posorder') {
	    fromDate = 'Order_id__Date__gte=' + dates.fromDate;
	    toDate = 'Order_id__Date__lte=' + dates.toDate;
	  } else if (salesType == 'all') {
	    fromDate = 'date__gte=' + dates.fromDate;
	    toDate = 'date__lte=' + dates.toDate;
	  }
	  if (productNum) {
	    productNum = '&Product_id__ProductNum=' + productNum;
	    group = '';
	    category = '';
	    aggregate = '';
	  } else {
	    productNum = '';
	    if (group) {
	      group = '&Product_id__ProductGroup_id=' + group;
	    } else {
	      group = '';
	    }
	    if (category) {
	      category = '&Product_id__ProductCategory1_id=' + category;
	    } else {
	      category = '';
	    }
	    if (aggregate) {
	      aggregate = '&Aggregate=' + aggregate;
	    } else {
	      aggregate = '';
	    }
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SALES_PERFORMANCE });
	    return _axios2.default.get(_url.SALES_PERFORMANCE_URL + type + '/' + salesType + '/?' + fromDate + '&' + toDate + productNum + group + category + aggregate, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesPerformanceSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesPerformanceFailure(err));
	    });
	  };
	}
	
	function fetchSalesPerformanceSuccess(data) {
	  return {
	    type: _type.REQUEST_SALES_PERFORMANCE_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchSalesPerformanceFailure(error) {
	  return {
	    type: _type.REQUEST_SALES_PERFORMANCE_FAILURE,
	    payload: error
	  };
	}
	
	function fetchSalesOrdersByFilter(postingDateGT, postingDateLT, days, status, user, productNum, route) {
	  var url = route == 'salesOrders' ? _url.SALES_ORDERS_URL : _url.MOBILE_SALES_ORDERS_URL;
	  var dates = (0, _cleanDates.toFromDates)(days, postingDateGT, postingDateLT);
	  if (status == 'all') {
	    status = '';
	  } else {
	    status = '&SaleStatus=' + status;
	  }
	  if (user) {
	    user = '&Sales_User_id=' + user;
	  } else {
	    user = '';
	  }
	
	  var belongWarehouse = '';
	  if (isAFM) {
	    if (!localStorage.getItem('warehouseLocation') || localStorage.getItem('warehouseLocation') === '') {
	      belongWarehouse = '';
	    } else {
	      belongWarehouse = '&BelongWarehouse=' + localStorage.getItem('warehouseLocation');
	    }
	  }
	
	  if (productNum) {
	    productNum = '&ProductNum=' + productNum;
	  } else {
	    productNum = '';
	  }
	  return function (dispatch) {
	    dispatch(requestSalesOrders());
	    return _axios2.default.get(url + 'search/' + ('?OrderDate__gte=' + dates.fromDate + '&OrderDate__lte=' + dates.toDate + status + user + productNum + belongWarehouse), {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesOrdersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesOrdersFailure(err));
	    });
	  };
	}
	
	function fetchSalesDashboardDetail() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SALES_DASHBOARD_DETAIL });
	    return _axios2.default.get(_url.DASHBOARD_URL + 'salesdashboard/', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesDashboardDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesDashboardDetailFailure(err));
	    });
	  };
	}
	
	function requestSalesDashboardDetail() {
	  return {
	    type: _type.REQUEST_SALES_DASHBOARD_DETAIL
	  };
	}
	
	function fetchSalesDashboardDetailSuccess(dashboardSalesDetail) {
	  return {
	    type: _type.FETCH_SALES_DASHBOARD_DETAIL_SUCCESS,
	    payload: dashboardSalesDetail
	  };
	}
	
	function fetchSalesDashboardDetailFailure(error) {
	  return {
	    type: _type.FETCH_SALES_DASHBOARD_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function loadsPost(pk) {
	  return function (dispatch) {
	    return _axios2.default.get(_url.SALES_LOADSPOST_URL + pk + '/', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function fetchSalesLevels() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SALES_LEVELS });
	    return _axios2.default.get(_url.SALES_LEVELS_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesLevelsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesLevelsFailure(err));
	    });
	  };
	}
	
	function fetchSalesLevelsSuccess(levels) {
	  return {
	    type: _type.FETCH_SALES_LEVELS_SUCCESS,
	    payload: levels
	  };
	}
	
	function fetchSalesLevelsFailure(error) {
	  return {
	    type: _type.FETCH_SALES_LEVELS_FAILURE,
	    payload: error
	  };
	}
	
	/* Payment refund for MSO */
	/* id: MSO id */
	function requestSORefund(id, props) {
	  return function (dispatch) {
	    dispatch(requestingSORefund());
	    var token = localStorage.getItem('token');
	    var data = {
	      Amount: props.refundAmount * 100,
	      Reason: props.refundReason
	    };
	    return (0, _axios2.default)({
	      method: 'post',
	      url: '' + _url.SALES_ORDERS_REFUND + id + '/refund',
	      headers: { Authorization: 'Bearer ' + token },
	      data: data
	    }).then(function (response) {
	      dispatch(requestSORefundSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(requestSORefundFailure(err));
	    });
	  };
	}
	
	function requestingSORefund() {
	  return {
	    type: _type.REQUEST_REFUND
	  };
	}
	
	function requestSORefundSuccess(data) {
	  return {
	    type: _type.REQUEST_REFUND_SUCCESS,
	    payload: data
	  };
	}
	
	function requestSORefundFailure(error) {
	  return {
	    type: _type.REQUEST_REFUND_FAILURE,
	    payload: error
	  };
	}
	
	function voidReturn(SalesReturn_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_RETURN_VOID });
	    return _axios2.default.post(_url.SALES_RETURN_URL + SalesReturn_id + '/void', {
	      SalesReturn_id: SalesReturn_id
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchReturnsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchReturnsFailure(err));
	    });
	  };
	}
	
	function completeReturn(SalesReturn_id, InvoiceDetails) {
	  var Sales_Return_Line = [];
	  var newEntry = {};
	  for (var i = 0; i < InvoiceDetails.length; i++) {
	    newEntry.SalesReturnLine_id = InvoiceDetails[i].SalesReturnLine_id;
	    newEntry.RestockQuantity = InvoiceDetails[i].RestockQuantity;
	    newEntry.RestockWeight = InvoiceDetails[i].RestockWeight ? InvoiceDetails[i].RestockWeight : 0;
	    // Sales_Return_Line.push(newEntry);
	    if (_root_url.isJML) {
	      Sales_Return_Line.push({
	        SalesReturnLine_id: InvoiceDetails[i].SalesReturnLine_id,
	        RestockBox: InvoiceDetails[i].RestockBox ? Number(InvoiceDetails[i].RestockBox) : 0,
	        RestockQuantity: InvoiceDetails[i].RestockQuantity,
	        RestockWeight: InvoiceDetails[i].RestockWeight ? InvoiceDetails[i].RestockWeight : 0,
	        Batch_id: InvoiceDetails[i].Batch_id,
	        jmlPackageSize1: InvoiceDetails[i].jmlPackageSize1
	      });
	    } else {
	      Sales_Return_Line.push({ SalesReturnLine_id: InvoiceDetails[i].SalesReturnLine_id, RestockQuantity: InvoiceDetails[i].RestockQuantity, RestockWeight: InvoiceDetails[i].RestockWeight ? InvoiceDetails[i].RestockWeight : 0 });
	    }
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_RETURN_COMPLETE });
	    return _axios2.default.post(_url.SALES_RETURN_URL + SalesReturn_id + '/complete', {
	      Sales_Return_Line: Sales_Return_Line
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchReturnsSuccess(response));
	      _reactRouter.browserHistory.push('/inventoryReturn');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchReturnsFailure(err));
	      console.log('ERROR IN response');
	    });
	  };
	}
	
	function fetchReturnsSuccess(data) {
	  return {
	    type: _type.FETCH_RETURN_SUCCESS,
	    payload: data
	  };
	}
	function fetchReturnsFailure(error) {
	  return {
	    type: _type.FETCH_RETURN_FAILURE,
	    payload: error
	  };
	}
	
	function fetchSalesOrderProductByID(id, customer_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PRODUCT_BY_ID });
	    return _axios2.default.get('' + _url.SALES_ORDER_PRODUCT_BY_ID_URL + customer_id + '/?Product_id=' + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesOrderProductByIDSuccesful(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesOrderProductByIDFailure(err));
	    });
	  };
	}
	
	var fetchBatchesByID = exports.fetchBatchesByID = function fetchBatchesByID(Product_id) {
	  var isSO = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  return function (dispatch) {
	    var url = _url.INVENTORY_BATCH_URL + '?product=' + Product_id + '&belong_warehouse=false';
	    if (_root_url.isJML && isSO) {
	      url += '&is_so=1';
	    }
	    return _axios2.default.get(url, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _type.SALES_ORDER_FORM_BATCHES,
	        payload: response.data
	      });
	      // dispatch(fetchSalesOrderProductByIDSuccesful(response));
	    }, function (err) {
	      alert(JSON.stringify(err.data));
	      // if (err.status === 500 || err.status === 404) {
	      //   err.data = DEFAULT_ERROR;
	      // }
	      // dispatch(fetchSalesOrderProductByIDFailure(err));
	    });
	  };
	};
	
	var fetchProductPromotion = exports.fetchProductPromotion = function fetchProductPromotion(product_id, customer) {
	  var success = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
	  return function (dispatch) {
	    dispatch({
	      type: 'salesOrderForm/productpromotionfetching'
	    });
	    var url = _url.PROMOTIONS_URL + '?Product_id=' + product_id;
	    _axios2.default.get(url, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      // console.log('response', response, dispatch);
	      dispatch({
	        type: 'salesOrderForm/productpromotion',
	        payload: response.data.promotions
	      });
	      success();
	      // dispatch(fetchSalesOrderProductByIDSuccesful(response));
	    }, function (err) {
	      // if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
	      //   document.getElementById('tokenInvalid').style.display = 'flex'
	      //   return
	      // }
	      // if (err.status === 500 || err.status === 404) {
	      //   err.data = DEFAULT_ERROR;
	      // }
	      // dispatch(fetchSalesOrderProductByIDFailure(err));
	    });
	  };
	};
	
	function fetchSalesOrderProductByIDSuccesful(product) {
	  return {
	    type: _type.FETCH_PRODUCT_BY_ID_SUCCESS,
	    payload: product
	  };
	}
	
	function fetchSalesOrderProductByIDFailure(error) {
	  return {
	    type: _type.FETCH_PRODUCT_BY_ID_FAILURE,
	    payload: error
	  };
	}
	
	function initializeSalesOrderForm(type, Form) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)(Form, 'searchType', type));
	    dispatch((0, _reduxForm.change)(Form, 'Quantity', 1));
	  };
	}
	
	function printSalesOrderSI(salesInvoiceID) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SO_SI_PDF });
	    return _axios2.default.get(_url.SO_PRINT_SALES_INVOICE_URL + salesInvoiceID, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch({
	        type: _type.FETCH_SO_SI_PDF_SUCCESS,
	        payload: response
	      });
	    }, function (err) {
	      console.log('ERROR IN response', err);
	    });
	  };
	}
	
	function printSalesOrder(salesOrder_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SO_PDF });
	    return _axios2.default.get(_url.SALES_ORDER_PRINT_URL + salesOrder_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchSalesOrderPDFSuccess(response));
	    }, function (err) {
	      console.log('ERROR IN response', err);
	    });
	  };
	}
	
	function printSalesOrderLabel(salesOrder_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SO_PDF });
	    return _axios2.default.get(_url.SALES_ORDER_LABEL_PRINT_URL + salesOrder_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchSalesOrderPDFSuccess(response));
	    }, function (err) {
	      console.log('ERROR IN response', err);
	    });
	  };
	}
	
	function printSalesOrderLabelBOL(salesOrder_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SO_PDF });
	    return _axios2.default.get(_url.WIZ_PRINT_BOL + salesOrder_id + '?mode=pdf', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchSalesOrderPDFSuccess(response));
	    }, function (err) {
	      console.log('ERROR IN response', err);
	    });
	  };
	}
	
	function printSalesOrderLabelDSQ(salesOrderLine_ids) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SO_PDF });
	    return _axios2.default.get(_url.SALES_ORDER_LABEL_PRINT_URL + salesOrderLine_ids, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchSalesOrderPDFSuccess(response));
	    }, function (err) {
	      console.log('ERROR IN response', err);
	    });
	  };
	}
	
	function printShippigLabel(salesOrder_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SO_PDF });
	    return _axios2.default.get(_url.PRINT_SHIPPING_LABEL_URL + salesOrder_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchSalesOrderPDFSuccess(response));
	    }).catch(function (err) {
	      _axios2.default.get(_url.PRINT_SHIPPING_LABEL_URL + salesOrder_id, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {}, function (error) {
	        alert('Error printing shippng lable: ' + error.data);
	      });
	    });
	  };
	}
	
	function printSalesOrderLabelBatch(salesOrder_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SO_PDF });
	    return _axios2.default.post(_url.SALES_ORDER_LABEL_PRINT_URL_BATCH, {
	      salesOrder_id: salesOrder_id
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchSalesOrderPDFSuccess(response));
	    }, function (err) {
	      console.log('ERROR IN response', err);
	    });
	  };
	}
	
	function fetchSalesOrderPDFSuccess(FileData) {
	  return {
	    type: _type.FETCH_SO_PDF_SUCCESS,
	    payload: FileData
	  };
	}
	
	// export function removeSalesOrderPDF() {
	//   return {
	//     type: REMOVE_SHIPPING_PDF
	//   }
	// }
	
	function printShippingList(salesOrder_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SHIPPING_LIST_PDF });
	    return _axios2.default.get(_url.SHIPPING_LIST_URL + salesOrder_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchShippingListPDFSuccess(response));
	    }, function (err) {
	      console.log('ERROR IN response', err);
	    });
	  };
	}
	
	function printReceivingReport(salesOrder_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SHIPPING_LIST_PDF });
	    return _axios2.default.get(_url.RECEIVING_REPORT_URL + salesOrder_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchShippingListPDFSuccess(response));
	    }, function (err) {
	      alert("Could not fetch Receiving Report");
	      console.log('ERROR IN response', err);
	    });
	  };
	}
	
	function printYingBOL(salesOrder_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SHIPPING_LIST_PDF });
	    return _axios2.default.get(_url.YING_BOL_URL + salesOrder_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchShippingListPDFSuccess(response));
	    }, function (err) {
	      alert("Could not fetch BOL");
	      console.log('ERROR IN response', err);
	    });
	  };
	}
	
	function printYingCustomerFile(salesOrder_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SHIPPING_LIST_PDF });
	    return _axios2.default.get(_url.YING_CUSTOMER_FILE + salesOrder_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchShippingListPDFSuccess(response));
	    }, function (err) {
	      alert("Could not fetch File");
	      console.log('ERROR IN response', err);
	    });
	  };
	}
	
	function printShippingListATL(salesOrder_id) {
	  var data = { pk: salesOrder_id };
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SHIPPING_LIST_PDF });
	    return _axios2.default.post(_url.SHIPPING_LIST_URL + 'shippinglist', data, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchShippingListPDFSuccess(response));
	    }, function (err) {
	      console.log('ERROR IN response', err);
	    });
	  };
	}
	
	function fetchShippingListPDFSuccess(FileData) {
	  return {
	    type: _type.FETCH_SHIPPING_LIST_SUCCESS,
	    payload: FileData
	  };
	}
	
	function printPickingList(salesOrder_id) {
	  if (salesOrder_id) {
	    return function (dispatch) {
	      dispatch({ type: _type.REQUEST_PICKING_LIST_PDF });
	      return _axios2.default.get(_url.PICKING_LIST_URL + salesOrder_id, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	        responseType: 'blob'
	      }).then(function (response) {
	        dispatch(fetchPickingListPDFSuccess(response));
	      }, function (err) {
	        console.log('ERROR IN response', err);
	      });
	    };
	  }
	}
	
	function printPickingListPartial(label) {
	  if (label) {
	    return function (dispatch) {
	      dispatch({ type: _type.REQUEST_PICKING_LIST_PDF });
	      return _axios2.default.get(_root_url.ROOT_URL + 'v2/sale/partial_picking_list/' + label, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	        responseType: 'blob'
	      }).then(function (response) {
	        dispatch(fetchPickingListPDFSuccess(response));
	      }, function (err) {
	        console.log('ERROR IN response', err);
	      });
	    };
	  }
	}
	
	function printPickingListATL(salesOrder_id) {
	  // if (salesOrder_id) {
	  var data = { pk: salesOrder_id };
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PICKING_LIST_PDF });
	    return _axios2.default.post(_url.PACKING_LIST_URL + 'driverlist', data, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchPickingListPDFSuccess(response));
	    }, function (err) {
	      console.log('ERROR IN response', err);
	    });
	  };
	  // }
	}
	
	function printPickingListAFG(salesOrder_id, users, sort) {
	  if (users === '0' || !users) {
	    users = 1;
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PICKING_LIST_PDF });
	    return _axios2.default.get(_url.PICKING_LIST_URL + salesOrder_id + '?assign=' + users + '&orderBy=' + sort, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchPickingListPDFSuccess(response));
	    }, function (err) {
	      console.log('ERROR IN response', err);
	    });
	  };
	}
	
	function fetchPickingListPDFSuccess(FileData) {
	  return {
	    type: _type.FETCH_PICKING_LIST_SUCCESS,
	    payload: FileData
	  };
	}
	
	function printPackingList(salesOrder_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PACKING_LIST_PDF });
	    return _axios2.default.get(_url.PACKING_LIST_URL + salesOrder_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchPackingListPDFSuccess(response));
	    }, function (err) {
	      console.log('ERROR IN response', err);
	    });
	  };
	}
	
	function printPackingListATL(salesOrder_id) {
	  var data = { pk: salesOrder_id };
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PACKING_LIST_PDF });
	    return _axios2.default.post(_url.PICKING_LIST_URL + 'pickinglist', data, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchPackingListPDFSuccess(response));
	    }, function (err) {
	      console.log('ERROR IN response', err);
	    });
	  };
	}
	
	function fetchPackingListPDFSuccess(FileData) {
	  return {
	    type: _type.FETCH_PACKING_LIST_SUCCESS,
	    payload: FileData
	  };
	}
	
	function fetchMSORefundPDFSuccess(FileData) {
	  return {
	    type: _type.REQUEST_REFUND_PDF_SUCCESS,
	    payload: FileData
	  };
	}
	
	function printMSORefundPDF(salesOrderID) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_REFUND_PDF });
	    var token = localStorage.getItem('token');
	    return (0, _axios2.default)({
	      method: 'get',
	      url: '' + _url.REFUND_SUMMARY_URL + salesOrderID,
	      headers: { Authorization: 'Bearer ' + token },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchMSORefundPDFSuccess(response));
	    }, function (err) {
	      console.log('ERROR IN response', err);
	    });
	  };
	}
	
	function fetchSalesTotalsSuccess(totals) {
	  return {
	    type: _type.FETCH_SALES_TOTALS_SUCCESS,
	    payload: totals
	  };
	}
	
	function fetchSalesTotalsFailure(error) {
	  return {
	    type: _type.FETCH_SALES_TOTALS_FAILURE,
	    payload: error
	  };
	}
	
	function fetchSalesTotals(type) {
	  var start_date = (0, _moment2.default)().toISOString();
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SALES_TOTALS });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: _url.OVERALL_SALES_PERFORMANCE_URL,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      params: {
	        type: type,
	        start_date: start_date
	      }
	    }).then(function (response) {
	      dispatch(fetchSalesTotalsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesTotalsFailure(err));
	    });
	  };
	}
	
	function orderToQuote(salesId) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SALES_ORDER_TO_QUOTE });
	    return (0, _axios2.default)({
	      method: 'PUT',
	      url: _url.QUOTE_TO_ORDER_URL + 'so_to_sq/' + salesId,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(orderToQuoteSuccess(response));
	    }, function (err) {
	      dispatch(orderToQuoteFailure(err));
	    });
	  };
	}
	
	function orderToQuoteSuccess(response) {
	  return {
	    type: _type.SALES_ORDER_TO_QUOTE_SUCCESS
	  };
	}
	
	function orderToQuoteFailure(err) {
	  return {
	    type: _type.SALES_ORDER_TO_QUOTE_FAILURE,
	    payload: err
	  };
	}
	
	function quoteToOrder(salesId) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SALES_QUOTE_TO_OPEN });
	    return (0, _axios2.default)({
	      method: 'PUT',
	      url: _url.QUOTE_TO_ORDER_URL + 'sq_to_so/' + salesId,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(quoteToOrderSuccess(response));
	    }, function (err) {
	      dispatch(quoteToOrderFailure(err));
	    });
	  };
	}
	
	function quoteToOrderSuccess(response) {
	  return {
	    type: _type.REQUEST_SALES_QUOTE_TO_ORDER_SUCCESS
	  };
	}
	
	function quoteToOrderFailure(err) {
	  return {
	    type: _type.REQUEST_SALES_QUOTE_TO_ORDER_FAILURE,
	    payload: err
	  };
	}
	
	function emailSO(salesOrder_id) {
	  return function (dispatch) {
	    _axios2.default.get(_root_url.ROOT_URL + 'v1/sale/emailorder/' + salesOrder_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      alert(JSON.stringify(response.data));
	    }, function (err) {
	      alert(JSON.stringify(err.data));
	    });
	  };
	}
	
	function emailSOCalco(salesOrder_id, subject, content, email, phone, email_to) {
	  // let data = {subject, content, email_to};
	  var data = {};
	  return function (dispatch) {
	    _axios2.default.post(_root_url.ROOT_URL + 'v1/sale/emailorder/' + salesOrder_id,
	    // { subject, content },
	    data, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      alert(JSON.stringify(response.data));
	    }, function (err) {
	      alert(JSON.stringify(err.data));
	    });
	  };
	}
	
	function createMobileTask(salesOrder_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.CREATE_MOBILE_TASK });
	    _axios2.default.post(_url.MOBILE_SALES_ORDERS_URL + 'create_onfleet_task/' + salesOrder_id, {}, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      alert(JSON.stringify(response.data));
	      dispatch(createMobileTaskSuccess(response));
	    }, function (err) {
	      alert(JSON.stringify(err.data));
	      dispatch(createMobileTaskFailure(err));
	    });
	  };
	}
	
	function createMobileTaskSuccess(response) {
	  return {
	    type: _type.CREATE_MOBILE_TASK_SUCCESS
	  };
	}
	
	function createMobileTaskFailure(err) {
	  return {
	    type: _type.CREATE_MOBILE_TASK_FAILURE,
	    payload: err
	  };
	}
	
	// export function requestSetShippingWeight() {
	//   return {
	//     type: REQUEST_SET_SHIPPING_WEIGHT,
	//   };
	// }
	
	function updateShippingWeightSuccess(data) {
	  return {
	    type: _type.UPDATE_SHIPPING_WEIGHT_SUCCESS
	    // payload: data,
	  };
	}
	
	function updateShippingWeightFailure(error) {
	  return {
	    type: _type.UPDATE_SHIPPING_WEIGHT_FAILURE,
	    payload: error
	  };
	}
	
	function updateShippingWeight(salesOrder_id, finalShippingWeight) {
	  var output = {
	    finalShippingWeight: Number(finalShippingWeight)
	  };
	  var url = '' + _url.PATCH_SALES_ORDER_WEIGHT_URL + salesOrder_id;
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SET_SHIPPING_WEIGHT });
	    return (0, _axios2.default)({
	      method: 'patch',
	      url: url,
	      data: output,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      // alert(JSON.stringify(response.data));
	      // alert(JSON.stringify('Shipping Weight Patched Successfully'));
	      dispatch(updateShippingWeightSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	        alert(JSON.stringify(err.data));
	      }
	      dispatch(updateShippingWeightFailure(err));
	    });
	  };
	}
	
	function updateShippingWeightSplit(salesOrder_id, splitWeightArray) {
	  var output = [];
	  splitWeightArray.map(function (r) {
	    if (!isFinite(r.Package_Weight)) {
	      alert("\"" + r.Package_Weight + "\" is not a number and has been omitted!");
	    }
	    if (r.Package_Weight && isFinite(r.Package_Weight)) {
	      output.push({ Package_Weight: Number(r.Package_Weight), Package_Note: r.Package_Note ? r.Package_Note : "", Tracking_Number: r.Tracking_Number ? r.Tracking_Number : "", recreate: r.recreate });
	    }
	  });
	  if (output.length === 0) {
	    alert("Must have at least one valid pack weight.");
	    return;
	  }
	  var url = '' + _url.PATCH_SALES_ORDER_WEIGHT_MULTI_URL + salesOrder_id;
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SET_SHIPPING_WEIGHT_SPLIT });
	    return (0, _axios2.default)({
	      method: 'patch',
	      url: url,
	      data: output,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      // alert(JSON.stringify(response.data));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	        alert(JSON.stringify(err.data));
	      }
	    });
	  };
	}
	
	function fetchShippingWeightTracking(salesOrder_id) {
	  var url = '' + _url.FETCH_SALES_ORDER_WEIGHT_TRACKING + salesOrder_id;
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'get',
	      url: url,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function fetchCarrierInfo(salesOrder_id) {
	  var url = '' + _url.CARRIER_INFO_URL + salesOrder_id;
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'get',
	      url: url,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function postCarrierInfo(salesOrder_id, output) {
	  var url = '' + _url.CARRIER_INFO_URL + salesOrder_id;
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'post',
	      url: url,
	      data: output,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function fetchJmlTracking(salesOrder_id) {
	  var url = '' + _url.FETCH_JML_TRACKING_NUMBER_URL + salesOrder_id;
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'get',
	      url: url,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function updateEmployeeNote(salesOrder_id, employeeNoteText) {
	  var output = {
	    EmployeeNote: employeeNoteText
	  };
	  var url = '' + _url.PATCH_SALES_EMPLOYEE_NOTE_URL + salesOrder_id;
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'patch',
	      url: url,
	      data: output,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function updateVoidNote(salesOrder_id, voidString) {
	  var output = {
	    VoidNote: voidString
	  };
	  var url = '' + _url.PATCH_SALES_VOID_NOTE_URL + salesOrder_id;
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'patch',
	      url: url,
	      data: output,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function reshipOrder(salesOrder_id) {
	  var url = '' + _url.SALES_ORDER_RESHIP_URL + salesOrder_id + '/';
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'put',
	      url: url,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      // alert(JSON.stringify(response.data));
	      alert("Order has been reshipped!");
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        // err.data = DEFAULT_ERROR;
	      }
	      alert("Reshipping failed: " + err);
	    });
	  };
	}
	
	function setQuoteOrder(salesOrder_id, customer_id) {
	  var url = '' + _url.SET_QUOTE_URL + salesOrder_id + '/' + customer_id;
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'put',
	      url: url,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      // alert(JSON.stringify(response.data));
	      // alert("Quotes set to Orders!");
	    }, function (err) {
	      console.log("err", err);
	      if (err.status === 500 || err.status === 404) {
	        // err.data = DEFAULT_ERROR;
	      }
	      alert("Quote to order failed: " + err.data);
	    });
	  };
	}
	
	function setDavisPO(salesOrder_id) {
	  var url = '' + _url.SO_TO_PO_DAVIS_URL;
	  var data = { SalesOrder_id: salesOrder_id };
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'post',
	      url: url,
	      data: data,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      // alert(JSON.stringify(response.data));
	      alert("Sent to Davis PO: " + response.data);
	    }, function (err) {
	      console.log("err", err);
	      if (err.status === 500 || err.status === 404) {
	        // err.data = DEFAULT_ERROR;
	      }
	      alert("SO to PO failed: " + err.data);
	    });
	  };
	}
	
	/**
	  * Gets previously set product images
	  *
	  * @param {Number} salesOrder_id
	  * @param {func} handleSuccess
	  * @param {func} handleFailure
	  */
	var fetchBolImage = exports.fetchBolImage = function fetchBolImage(salesOrder_id, handleSuccess, handleFailure) {
	  var token = localStorage.getItem('token');
	  var config = {
	    method: 'get',
	    url: _url.MOBILE_SALES_ORDERS_URL + '?pk=' + salesOrder_id
	  };
	  (0, _axios2.default)(_extends({}, config, {
	    headers: { Authorization: 'Bearer ' + token }
	  })).then(function (response) {
	    handleSuccess(response.data);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	};
	
	var fetchBolImageOCM = exports.fetchBolImageOCM = function fetchBolImageOCM(salesOrder_id, handleSuccess, handleFailure) {
	  var token = localStorage.getItem('token');
	  var config = {
	    method: 'get',
	    url: _root_url.ROOT_URL + 'v1/sale/sales_order/?pk=' + salesOrder_id
	  };
	  (0, _axios2.default)(_extends({}, config, {
	    headers: { Authorization: 'Bearer ' + token }
	  })).then(function (response) {
	    handleSuccess(response.data);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	};
	
	/**
	  * Delete previously saved image
	  *
	  * @param {Number} imageId
	  * @param {func} handleSuccess
	  * @param {func} handleFailure
	  */
	var deleteBolImage = exports.deleteBolImage = function deleteBolImage(imageId, handleSuccess, handleFailure) {
	  var token = localStorage.getItem('token');
	  var config = {
	    method: 'delete',
	    url: '' + _url.OVERSEA_DELETE_BOL_IMAGE_URL + imageId
	  };
	  (0, _axios2.default)(_extends({}, config, {
	    headers: { Authorization: 'Bearer ' + token }
	  })).then(function (response) {
	    handleSuccess(response.data);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	};
	
	var deleteBolImageSCM = exports.deleteBolImageSCM = function deleteBolImageSCM(imageId, handleSuccess, handleFailure) {
	  var token = localStorage.getItem('token');
	  var config = {
	    method: 'delete',
	    url: _root_url.ROOT_URL + 'v1/sale/so_images_delete/' + imageId
	  };
	  (0, _axios2.default)(_extends({}, config, {
	    headers: { Authorization: 'Bearer ' + token }
	  })).then(function (response) {
	    handleSuccess(response.data);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	};
	/**
	  * Updates product images
	  *
	  * @param {Number} salesOrder_id
	  * @param {func} handleSuccess
	  * @param {func} handleFailure
	  */
	var submitBolImage = exports.submitBolImage = function submitBolImage(salesOrder_id, images, handleSuccess, handleFailure) {
	  var url = '' + _url.OVERSEA_UPLOAD_BOL_IMAGE_URL + salesOrder_id;
	
	  var data = new FormData();
	  for (var i = 0; i < images.length; i++) {
	    data.append('image', images[i].file[0]);
	  }
	
	  var config = {
	    method: 'post',
	    url: '' + _url.OVERSEA_UPLOAD_BOL_IMAGE_URL + salesOrder_id,
	    data: data
	  };
	  (0, _axios2.default)(_extends({}, config, {
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  })).then(function (response) {
	    handleSuccess(response.data);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      // err.data = DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	};
	
	var submitBolImageSCM = exports.submitBolImageSCM = function submitBolImageSCM(salesOrder_id, images, handleSuccess, handleFailure) {
	  var url = _root_url.ROOT_URL + 'v1/sale/upload_so_images/' + salesOrder_id;
	
	  var data = new FormData();
	  for (var i = 0; i < images.length; i++) {
	    data.append('images', images[i].file[0]);
	  }
	
	  var config = {
	    method: 'post',
	    url: url,
	    data: data
	  };
	  (0, _axios2.default)(_extends({}, config, {
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  })).then(function (response) {
	    handleSuccess(response.data);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      // err.data = DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	};
	
	function fetchBolByIdPDFSuccess(FileData) {
	  return {
	    type: _type.FETCH_BOL_ID_PDF_SUCCESS,
	    payload: FileData
	  };
	}
	
	function printBolById(salesOrder_id) {
	  if (salesOrder_id) {
	    return function (dispatch) {
	      dispatch({ type: _type.REQUEST_BOL_ID_PDF });
	      return _axios2.default.get(_url.OVERSEA_PRINT_BOL_URL + salesOrder_id, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	        responseType: 'blob'
	      }).then(function (response) {
	        dispatch(fetchBolByIdPDFSuccess(response));
	      }, function (err) {
	        console.log('Print Bol failed', err);
	      });
	    };
	  }
	}
	
	function fetchPrintBolWithoutLogSuccess(FileData) {
	  return {
	    type: _type.FETCH_BOL_WITHOUT_LOG_SUCCESS,
	    payload: FileData
	  };
	}
	
	function printBolWithoutLog(salesOrder_id) {
	  if (salesOrder_id) {
	    return function (dispatch) {
	      dispatch({ type: _type.REQUEST_BOL_WITHOUT_LOG });
	      return _axios2.default.get(_url.OVERSEA_PRINT_BOL_WITHOUT_LOG_URL + salesOrder_id, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	        responseType: 'blob'
	      }).then(function (response) {
	        dispatch(fetchBolByIdPDFSuccess(response));
	      }, function (err) {
	        console.log('Print Bol failed', err);
	      });
	    };
	  }
	}
	
	function fetchPrintBolLabelSuccess(FileData) {
	  return {
	    type: _type.FETCH_BOL_LABEL_SUCCESS,
	    payload: FileData
	  };
	}
	
	function printBolLabel(salesOrder_id) {
	  if (salesOrder_id) {
	    return function (dispatch) {
	      dispatch({ type: _type.REQUEST_BOL_LABEL });
	      return _axios2.default.get(_url.OVERSEA_PRINT_BOL_LABEL_URL + salesOrder_id, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	        responseType: 'blob'
	      }).then(function (response) {
	        dispatch(fetchPrintBolLabelSuccess(response));
	      }, function (err) {
	        console.log('Print Bol label failed', err);
	      });
	    };
	  }
	}
	
	function fetchBolByFbaPDFSuccess(FileData) {
	  return {
	    type: _type.FETCH_BOL_FBA_PDF_SUCCESS,
	    payload: FileData
	  };
	}
	
	function printBolByFba(fba_code) {
	  if (fba_code) {
	    return function (dispatch) {
	      dispatch({ type: _type.REQUEST_BOL_FBA_PDF });
	      return _axios2.default.get(_url.OVERSEA_PRINT_BOL_URL + '?FBACode=' + fba_code, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	        responseType: 'blob'
	      }).then(function (response) {
	        dispatch(fetchBolByFbaPDFSuccess(response));
	      }, function (err) {
	        if (err.status === 400) {
	          alert('cannot find sales order');
	        }
	        console.log('Print Bol failed', err);
	      });
	    };
	  }
	}
	
	function fetchSPSuccess(FileData) {
	  return {
	    type: _type.FETCH_SP_SUCCESS,
	    payload: FileData
	  };
	}
	
	function printSP(days, fromDate, toDate) {
	  var dates = (0, _cleanDates.toFromDates)(days, fromDate, toDate);
	
	  var psfromDate = 'date__gte=' + dates.fromDate;
	  var pstoDate = 'date__lte=' + dates.toDate;
	
	  var belongWarehouse = '';
	  if (isAFM) {
	    if (!localStorage.getItem('warehouseLocation') || localStorage.getItem('warehouseLocation') === '') {
	      belongWarehouse = '';
	    } else {
	      belongWarehouse = '&BelongWarehouse=' + localStorage.getItem('warehouseLocation');
	    }
	  }
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SP_PDF });
	    return _axios2.default.get(_url.SP_PDF_URL + '?' + psfromDate + '&' + pstoDate + belongWarehouse, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchSPSuccess(response));
	    }, function (err) {
	      if (err.status === 400) {
	        alert('fetch failed');
	      }
	    });
	  };
	}
	
	function fetchBolAddressSuccess(address) {
	  return {
	    type: _type.FETCH_BOL_ADDRESS_SUCCESS,
	    payload: address
	  };
	}
	
	function fetchBolAddress() {
	  return function (dispatch) {
	    return _axios2.default.get(_url.OVERSEA_ADDRESS_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchBolAddressSuccess(response));
	    }, function (err) {
	      console.log('fetch Bol Address failed:', err);
	    });
	  };
	}
	
	function chowbusImport(file) {
	  var url = '' + _url.CHOWBUS_IMPORT;
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'post',
	      url: url,
	      data: file,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function getPaymentTerms() {
	  var url = '' + _url.PAYMENT_URL;
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'get',
	      url: url,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function fetchFJAgents(customer) {
	  var url = '' + _url.FETCH_FJ_AGENTS_URL + customer;
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'get',
	      url: url,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function fetchFJCarriers() {
	  var url = '' + _url.FETCH_FJ_CARRIERS_URL;
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'get',
	      url: url,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function fetchFBAAddressOptions() {
	  var url = '' + _url.FETCH_FBA_ADDRESS_URL;
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'get',
	      url: url,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function fetchCompany() {
	  var url = '' + _url.COMPANY_URL;
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'get',
	      url: url,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function fetchWarehousesByCompany(id) {
	  var url = '' + _url.WAREHOUSE_BY_COMPANY_URL + id;
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'get',
	      url: url,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function selectTeapplixShipping(method, salesOrderId) {
	  var success = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SO_PDF });
	    return _axios2.default.post(_root_url.ROOT_URL + 'v2/shipping/teapplix_label/' + salesOrderId, {
	      'shipping_method': method
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      success();
	      dispatch(printTeapplixLabel(salesOrderId));
	    }, function (err) {
	      dispatch(fetchSalesOrderPDFSuccess([]));
	      alert('Failed on select teapplix label: ' + JSON.stringify(err.data));
	    });
	  };
	}
	
	function printTeapplixLabel(salesOrder_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SO_PDF });
	    return _axios2.default.get(_root_url.ROOT_URL + 'v2/shipping/teapplix_label/' + salesOrder_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchSalesOrderPDFSuccess(response));
	    }, function (err) {
	      dispatch(fetchSalesOrderPDFSuccess([]));
	      alert('No label, please make sure to select your shipping method');
	    });
	  };
	}
	
	function deleteTeapplixShipping(salesOrder_id, success) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SO_PDF });
	    return _axios2.default.delete(_root_url.ROOT_URL + 'v2/shipping/teapplix_label/' + salesOrder_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesOrderPDFSuccess([]));
	      success();
	    }, function (err) {
	      dispatch(fetchSalesOrderPDFSuccess([]));
	      alert('Failed on delete teapplix label: ' + err.data);
	    });
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(updateMSOFormInitialValues, 'updateMSOFormInitialValues', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrders, 'fetchSalesOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestSalesOrders, 'requestSalesOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrdersSuccess, 'fetchSalesOrdersSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrdersFailure, 'fetchSalesOrdersFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(generateSOWithExcelUSPride, 'generateSOWithExcelUSPride', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(expressMultipleSOInvoices, 'expressMultipleSOInvoices', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(QBAuthStatusCheck, 'QBAuthStatusCheck', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(getQBAuth, 'getQBAuth', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductDetail, 'fetchProductDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(sendPacking, 'sendPacking', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printSalesOrderLabelUSPride, 'printSalesOrderLabelUSPride', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(reprintSalesOrderLabelUSPride, 'reprintSalesOrderLabelUSPride', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOdersByDate, 'fetchSalesOdersByDate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(selectSalesOrder, 'selectSalesOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetCurrentSalesOrder, 'resetCurrentSalesOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(keepEstDate, 'keepEstDate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(keepEstDateSuccess, 'keepEstDateSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(destroyEstDate, 'destroyEstDate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(finishUnmount, 'finishUnmount', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderDetail, 'fetchSalesOrderDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestSalesOrderDetail, 'requestSalesOrderDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderDetailVIT, 'fetchSalesOrderDetailVIT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderDetailIVTSuccess, 'fetchSalesOrderDetailIVTSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderDetailSuccess, 'fetchSalesOrderDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderDetailFailure, 'fetchSalesOrderDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestSalesOrderDetailByNum, 'requestSalesOrderDetailByNum', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderDetailByNumSuccess, 'fetchSalesOrderDetailByNumSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderDetailByNumFailure, 'fetchSalesOrderDetailByNumFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderDetailByNum, 'fetchSalesOrderDetailByNum', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(createSalesQuote, 'createSalesQuote', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(createSalesOrder, 'createSalesOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(createSalesOrderSuccess, 'createSalesOrderSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(createSalesOrderFailure, 'createSalesOrderFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(editSalesOrder, 'editSalesOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(editSalesOrderSuccess, 'editSalesOrderSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(editSalesOrderFailure, 'editSalesOrderFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(setOrderToOpen, 'setOrderToOpen', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(voidSalesOrder, 'voidSalesOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(voidSalesOrderSuccess, 'voidSalesOrderSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(voidSalesOrderFailure, 'voidSalesOrderFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestCustomerSalesHistory, 'requestCustomerSalesHistory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerSalesHistorySuccess, 'fetchCustomerSalesHistorySuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerSalesHistoryFailure, 'fetchCustomerSalesHistoryFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerSalesHistory, 'fetchCustomerSalesHistory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerOrderSchedules, 'fetchCustomerOrderSchedules', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerOrderSchedulesByDate, 'fetchCustomerOrderSchedulesByDate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerOrderSchedulesSuccess, 'fetchCustomerOrderSchedulesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerOrderSchedulesFailure, 'fetchCustomerOrderSchedulesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchTodaysOutgoingOrders, 'fetchTodaysOutgoingOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestTodaysOutgoingOrders, 'requestTodaysOutgoingOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchTodaysOutgoingOrdersSuccess, 'fetchTodaysOutgoingOrdersSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchTodaysOutgoingOrdersFailure, 'fetchTodaysOutgoingOrdersFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(podUpload, 'podUpload', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(uploadMSO, 'uploadMSO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(podUPloadSCM, 'podUPloadSCM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchOutgoingOrdersByDate, 'fetchOutgoingOrdersByDate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderLineWeights, 'fetchSalesOrderLineWeights', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestSalesOrderLineWeights, 'requestSalesOrderLineWeights', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderLineWeightsSuccess, 'fetchSalesOrderLineWeightsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderLineWeightsFailure, 'fetchSalesOrderLineWeightsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(setOrderLineWeights, 'setOrderLineWeights', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestSetOrderLineWeights, 'requestSetOrderLineWeights', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(editSalesOrderLineWeightsSuccess, 'editSalesOrderLineWeightsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(editSalesOrderLineWeightsFailure, 'editSalesOrderLineWeightsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(clearSalesOrderLineWeights, 'clearSalesOrderLineWeights', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderForm, 'fetchSalesOrderForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestSalesOrderForm, 'requestSalesOrderForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderFormSuccess, 'fetchSalesOrderFormSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderFormFailure, 'fetchSalesOrderFormFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(clearInventories, 'clearInventories', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesCSV, 'fetchSalesCSV', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesCSVSuccess, 'fetchSalesCSVSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesCSVFailure, 'fetchSalesCSVFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(savePosSale, 'savePosSale', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(savePosSaleSuccessful, 'savePosSaleSuccessful', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(savePosSaleFailure, 'savePosSaleFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(invalidCharacterEntered, 'invalidCharacterEntered', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(chargeNotMet, 'chargeNotMet', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(clearErrorMessageInPOS, 'clearErrorMessageInPOS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(startNewOrder, 'startNewOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(startNewItem, 'startNewItem', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(setSaleRowValue, 'setSaleRowValue', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(setSaleOrderProductValues, 'setSaleOrderProductValues', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(setSaleFavoriteRowValue, 'setSaleFavoriteRowValue', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(setCredit, 'setCredit', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(setSubtotal, 'setSubtotal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetFormInputs, 'resetFormInputs', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(setValue, 'setValue', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPOSDraft, 'fetchPOSDraft', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchDraftDetailsSuccess, 'fetchDraftDetailsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchDraftDetailsFailure, 'fetchDraftDetailsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchDrafts, 'fetchDrafts', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchDraftsSuccessful, 'fetchDraftsSuccessful', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchDraftsFailure, 'fetchDraftsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(clearForm, 'clearForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(createCreditIssue, 'createCreditIssue', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(createCreditIssueSuccess, 'createCreditIssueSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(createCreditIssueFailure, 'createCreditIssueFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(createSalesReturn, 'createSalesReturn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(createSalesReturnSuccess, 'createSalesReturnSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(createSalesReturnFailure, 'createSalesReturnFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(editSalesReturn, 'editSalesReturn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(editSalesReturnSuccess, 'editSalesReturnSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(editSalesReturnFailure, 'editSalesReturnFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesReturnDetail, 'fetchSalesReturnDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesReturnDetailSuccess, 'fetchSalesReturnDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesReturnDetailFailure, 'fetchSalesReturnDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchInventoryReturns, 'fetchInventoryReturns', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchInventoryReturnsSuccess, 'fetchInventoryReturnsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchInventoryReturnsFailure, 'fetchInventoryReturnsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchInventoryReturnsDetails, 'fetchInventoryReturnsDetails', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchInventoryReturnsDetailsSuccess, 'fetchInventoryReturnsDetailsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchInventoryReturnsDetailsFailure, 'fetchInventoryReturnsDetailsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(editInventoryReturns, 'editInventoryReturns', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(editInventoryReturnsSuccess, 'editInventoryReturnsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(editInventoryReturnsFailure, 'editInventoryReturnsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerPrices, 'fetchCustomerPrices', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerPricesSuccess, 'fetchCustomerPricesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerPricesFailure, 'fetchCustomerPricesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCurrencyRatesSuccess, 'fetchCurrencyRatesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCurrencyRatesFailure, 'fetchCurrencyRatesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCurrencyRates, 'fetchCurrencyRates', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiCurrenciesSuccess, 'editMultiCurrenciesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiCurrenciesFailure, 'editMultiCurrenciesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiCurrencies, 'editMultiCurrencies', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchTaxRatesSuccess, 'fetchTaxRatesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchTaxRatesFailure, 'fetchTaxRatesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchTaxRates, 'fetchTaxRates', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiTaxesSuccess, 'editMultiTaxesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiTaxesFailure, 'editMultiTaxesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiTaxes, 'editMultiTaxes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteTaxSuccess, 'deleteTaxSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteTaxFailure, 'deleteTaxFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteTax, 'deleteTax', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchOverallSalesPerformance, 'fetchOverallSalesPerformance', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchOverallSalesPerformanceSuccess, 'fetchOverallSalesPerformanceSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchOverallSalesPerformanceFailure, 'fetchOverallSalesPerformanceFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPosReport, 'fetchPosReport', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPosReportSuccess, 'fetchPosReportSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPosReportFailure, 'fetchPosReportFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesInventoryInfo, 'fetchSalesInventoryInfo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesInventoryInfoSuccess, 'fetchSalesInventoryInfoSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesInventoryInfoFailure, 'fetchSalesInventoryInfoFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesCustomerDetail, 'fetchSalesCustomerDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchShippingCustomerDetailSuccess, 'fetchShippingCustomerDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesCustomerDetailSuccess, 'fetchSalesCustomerDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesCustomerDetailFailure, 'fetchSalesCustomerDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchAllShipping, 'fetchAllShipping', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchAllShippingDetailSuccess, 'fetchAllShippingDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchAllShippingDetailFailure, 'fetchAllShippingDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasesVendorDetail, 'fetchPurchasesVendorDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasesVendorDetailSuccess, 'fetchPurchasesVendorDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasesVendorDetailFailure, 'fetchPurchasesVendorDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(clearSalesCustomerDetails, 'clearSalesCustomerDetails', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchItemSalesHistory, 'fetchItemSalesHistory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchItemSalesHistorySuccess, 'fetchItemSalesHistorySuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchItemSalesHistoryFailure, 'fetchItemSalesHistoryFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerFrequent, 'fetchCustomerFrequent', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchInboundProducts, 'fetchInboundProducts', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerFrequentSuccess, 'fetchCustomerFrequentSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerFrequentFailure, 'fetchCustomerFrequentFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(initializeForm, 'initializeForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(setSalesOrdersFilter, 'setSalesOrdersFilter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesPerformance, 'fetchSalesPerformance', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesPerformanceSuccess, 'fetchSalesPerformanceSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesPerformanceFailure, 'fetchSalesPerformanceFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrdersByFilter, 'fetchSalesOrdersByFilter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesDashboardDetail, 'fetchSalesDashboardDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestSalesDashboardDetail, 'requestSalesDashboardDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesDashboardDetailSuccess, 'fetchSalesDashboardDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesDashboardDetailFailure, 'fetchSalesDashboardDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(loadsPost, 'loadsPost', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesLevels, 'fetchSalesLevels', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesLevelsSuccess, 'fetchSalesLevelsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesLevelsFailure, 'fetchSalesLevelsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestSORefund, 'requestSORefund', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestingSORefund, 'requestingSORefund', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestSORefundSuccess, 'requestSORefundSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestSORefundFailure, 'requestSORefundFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(voidReturn, 'voidReturn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(completeReturn, 'completeReturn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchReturnsSuccess, 'fetchReturnsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchReturnsFailure, 'fetchReturnsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderProductByID, 'fetchSalesOrderProductByID', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchBatchesByID, 'fetchBatchesByID', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductPromotion, 'fetchProductPromotion', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderProductByIDSuccesful, 'fetchSalesOrderProductByIDSuccesful', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderProductByIDFailure, 'fetchSalesOrderProductByIDFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(initializeSalesOrderForm, 'initializeSalesOrderForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printSalesOrderSI, 'printSalesOrderSI', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printSalesOrder, 'printSalesOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printSalesOrderLabel, 'printSalesOrderLabel', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printSalesOrderLabelBOL, 'printSalesOrderLabelBOL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printSalesOrderLabelDSQ, 'printSalesOrderLabelDSQ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printShippigLabel, 'printShippigLabel', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printSalesOrderLabelBatch, 'printSalesOrderLabelBatch', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderPDFSuccess, 'fetchSalesOrderPDFSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printShippingList, 'printShippingList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printReceivingReport, 'printReceivingReport', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printYingBOL, 'printYingBOL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printYingCustomerFile, 'printYingCustomerFile', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printShippingListATL, 'printShippingListATL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchShippingListPDFSuccess, 'fetchShippingListPDFSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printPickingList, 'printPickingList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printPickingListPartial, 'printPickingListPartial', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printPickingListATL, 'printPickingListATL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printPickingListAFG, 'printPickingListAFG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPickingListPDFSuccess, 'fetchPickingListPDFSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printPackingList, 'printPackingList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printPackingListATL, 'printPackingListATL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPackingListPDFSuccess, 'fetchPackingListPDFSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchMSORefundPDFSuccess, 'fetchMSORefundPDFSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printMSORefundPDF, 'printMSORefundPDF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesTotalsSuccess, 'fetchSalesTotalsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesTotalsFailure, 'fetchSalesTotalsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesTotals, 'fetchSalesTotals', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(orderToQuote, 'orderToQuote', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(orderToQuoteSuccess, 'orderToQuoteSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(orderToQuoteFailure, 'orderToQuoteFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(quoteToOrder, 'quoteToOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(quoteToOrderSuccess, 'quoteToOrderSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(quoteToOrderFailure, 'quoteToOrderFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(emailSO, 'emailSO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(emailSOCalco, 'emailSOCalco', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(createMobileTask, 'createMobileTask', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(createMobileTaskSuccess, 'createMobileTaskSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(createMobileTaskFailure, 'createMobileTaskFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(updateShippingWeightSuccess, 'updateShippingWeightSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(updateShippingWeightFailure, 'updateShippingWeightFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(updateShippingWeight, 'updateShippingWeight', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(updateShippingWeightSplit, 'updateShippingWeightSplit', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchShippingWeightTracking, 'fetchShippingWeightTracking', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCarrierInfo, 'fetchCarrierInfo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(postCarrierInfo, 'postCarrierInfo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchJmlTracking, 'fetchJmlTracking', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(updateEmployeeNote, 'updateEmployeeNote', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(updateVoidNote, 'updateVoidNote', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(reshipOrder, 'reshipOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(setQuoteOrder, 'setQuoteOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(setDavisPO, 'setDavisPO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchBolImage, 'fetchBolImage', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchBolImageOCM, 'fetchBolImageOCM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteBolImage, 'deleteBolImage', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteBolImageSCM, 'deleteBolImageSCM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(submitBolImage, 'submitBolImage', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(submitBolImageSCM, 'submitBolImageSCM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchBolByIdPDFSuccess, 'fetchBolByIdPDFSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printBolById, 'printBolById', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPrintBolWithoutLogSuccess, 'fetchPrintBolWithoutLogSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printBolWithoutLog, 'printBolWithoutLog', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPrintBolLabelSuccess, 'fetchPrintBolLabelSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printBolLabel, 'printBolLabel', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchBolByFbaPDFSuccess, 'fetchBolByFbaPDFSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printBolByFba, 'printBolByFba', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSPSuccess, 'fetchSPSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printSP, 'printSP', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchBolAddressSuccess, 'fetchBolAddressSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchBolAddress, 'fetchBolAddress', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(chowbusImport, 'chowbusImport', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(getPaymentTerms, 'getPaymentTerms', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchFJAgents, 'fetchFJAgents', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchFJCarriers, 'fetchFJCarriers', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchFBAAddressOptions, 'fetchFBAAddressOptions', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCompany, 'fetchCompany', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchWarehousesByCompany, 'fetchWarehousesByCompany', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(selectTeapplixShipping, 'selectTeapplixShipping', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(printTeapplixLabel, 'printTeapplixLabel', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteTeapplixShipping, 'deleteTeapplixShipping', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(isMAG, 'isMAG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(isHMM, 'isHMM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(isABC, 'isABC', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(isDSQ, 'isDSQ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(isWIZ, 'isWIZ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(isFJ, 'isFJ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(isJTB, 'isJTB', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(isAFM, 'isAFM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(isKDW, 'isKDW', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(isABCFF, 'isABCFF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(isYI, 'isYI', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(isFBD, 'isFBD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(isWUFS, 'isWUFS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	
	  __REACT_HOT_LOADER__.register(isTN, 'isTN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/sales_actions.js');
	}();

	;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(171);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.productUpload = exports.saveCalculationType = exports.deleteProductImages = exports.getProductImages = exports.updateProductImages = exports.duplicateProduct = exports.fetchCustomers = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.requestProducts = requestProducts;
	exports.fetchProductsSuccess = fetchProductsSuccess;
	exports.fetchProductsFailure = fetchProductsFailure;
	exports.fetchProducts = fetchProducts;
	exports.requestProductsByGroup = requestProductsByGroup;
	exports.fetchProductsByGroupSuccess = fetchProductsByGroupSuccess;
	exports.fetchProductsByGroupFailure = fetchProductsByGroupFailure;
	exports.fetchProductsByGroup = fetchProductsByGroup;
	exports.requestProductsByCategory = requestProductsByCategory;
	exports.fetchProductsByCategorySuccess = fetchProductsByCategorySuccess;
	exports.fetchProductsByCategoryFailure = fetchProductsByCategoryFailure;
	exports.fetchProductsByCategory = fetchProductsByCategory;
	exports.requestProductsByCategory2 = requestProductsByCategory2;
	exports.fetchProductsByCategory2Success = fetchProductsByCategory2Success;
	exports.fetchProductsByCategory2Failure = fetchProductsByCategory2Failure;
	exports.fetchCategory2Products = fetchCategory2Products;
	exports.requestProductsByCategory2B2B = requestProductsByCategory2B2B;
	exports.resetCategory2Id = resetCategory2Id;
	exports.fetchProductsByCategory2SuccessB2B = fetchProductsByCategory2SuccessB2B;
	exports.fetchProductsByCategory2FailureB2B = fetchProductsByCategory2FailureB2B;
	exports.fetchCategory2ProductsB2B = fetchCategory2ProductsB2B;
	exports.requestProductsByVendor = requestProductsByVendor;
	exports.fetchProductsByVendorSuccess = fetchProductsByVendorSuccess;
	exports.fetchProductsByVendorFailure = fetchProductsByVendorFailure;
	exports.fetchProductsByVendor = fetchProductsByVendor;
	exports.requestProductInfo = requestProductInfo;
	exports.fetchProductInfoSuccess = fetchProductInfoSuccess;
	exports.fetchProductInfoFailure = fetchProductInfoFailure;
	exports.fetchProductInfo = fetchProductInfo;
	exports.fetchProductInfo2 = fetchProductInfo2;
	exports.selectProduct = selectProduct;
	exports.resetCurrentProduct = resetCurrentProduct;
	exports.clearCurrentProduct = clearCurrentProduct;
	exports.setGroupCategory = setGroupCategory;
	exports.reinitialize = reinitialize;
	exports.createProduct = createProduct;
	exports.requestCreatingProduct = requestCreatingProduct;
	exports.createProductSuccess = createProductSuccess;
	exports.createProductFailure = createProductFailure;
	exports.editProductSuccess = editProductSuccess;
	exports.editProductFailure = editProductFailure;
	exports.editProduct = editProduct;
	exports.editMultiProductSuccess = editMultiProductSuccess;
	exports.editMultiProductFailure = editMultiProductFailure;
	exports.editMultiProducts = editMultiProducts;
	exports.requestProductDetail = requestProductDetail;
	exports.fetchProductDetailSuccess = fetchProductDetailSuccess;
	exports.fetchProductDetailFailure = fetchProductDetailFailure;
	exports.fetchProductDetail = fetchProductDetail;
	exports.resetGroupAndCategory = resetGroupAndCategory;
	exports.requestGroups = requestGroups;
	exports.fetchGroupsSuccess = fetchGroupsSuccess;
	exports.fetchGroupsFailure = fetchGroupsFailure;
	exports.fetchGroups = fetchGroups;
	exports.fetchGroupsElegant = fetchGroupsElegant;
	exports.selectGroup = selectGroup;
	exports.resetCurrentGroup = resetCurrentGroup;
	exports.createGroupSuccess = createGroupSuccess;
	exports.createGroupFailure = createGroupFailure;
	exports.createGroup = createGroup;
	exports.editGroupSuccess = editGroupSuccess;
	exports.editGroupFailure = editGroupFailure;
	exports.editGroup = editGroup;
	exports.editMultiGroupsSuccess = editMultiGroupsSuccess;
	exports.editMultiGroupsFailure = editMultiGroupsFailure;
	exports.editMultiGroups = editMultiGroups;
	exports.editMultiGroupsElegant = editMultiGroupsElegant;
	exports.requestCategories = requestCategories;
	exports.fetchCategoriesSuccess = fetchCategoriesSuccess;
	exports.fetchCategoriesFailure = fetchCategoriesFailure;
	exports.fetchCategories = fetchCategories;
	exports.resetCategory = resetCategory;
	exports.selectCategory = selectCategory;
	exports.selectCategoryB2B = selectCategoryB2B;
	exports.resetCurrentCategory = resetCurrentCategory;
	exports.resetCurrentCategoryB2B = resetCurrentCategoryB2B;
	exports.requestCreatingCategory = requestCreatingCategory;
	exports.createCategorySuccess = createCategorySuccess;
	exports.createCategoryFailure = createCategoryFailure;
	exports.createCategory = createCategory;
	exports.editCategorySuccess = editCategorySuccess;
	exports.editCategoryFailure = editCategoryFailure;
	exports.editCategory = editCategory;
	exports.editMultiCategoriesSuccess = editMultiCategoriesSuccess;
	exports.editMultiCategoriesFailure = editMultiCategoriesFailure;
	exports.editMultiCategories = editMultiCategories;
	exports.requestCategories2 = requestCategories2;
	exports.fetchCategories2Success = fetchCategories2Success;
	exports.fetchCategories2Failure = fetchCategories2Failure;
	exports.fetchCategories2 = fetchCategories2;
	exports.requestCategories2B2B = requestCategories2B2B;
	exports.fetchCategories2SuccessB2B = fetchCategories2SuccessB2B;
	exports.fetchCategories2FailureB2B = fetchCategories2FailureB2B;
	exports.fetchCategories2B2B = fetchCategories2B2B;
	exports.editMultiCategories2Success = editMultiCategories2Success;
	exports.editMultiCategories2Failure = editMultiCategories2Failure;
	exports.editMultiCategories2 = editMultiCategories2;
	exports.editMultiCategories2SuccessB2B = editMultiCategories2SuccessB2B;
	exports.editMultiCategories2FailureB2B = editMultiCategories2FailureB2B;
	exports.editMultiCategories2B2B = editMultiCategories2B2B;
	exports.deleteCategory2Success = deleteCategory2Success;
	exports.deleteCategory2Failure = deleteCategory2Failure;
	exports.deleteCategory2 = deleteCategory2;
	exports.deleteCategory2SuccessB2B = deleteCategory2SuccessB2B;
	exports.deleteCategory2FailureB2B = deleteCategory2FailureB2B;
	exports.deleteCategory2B2B = deleteCategory2B2B;
	exports.clearCategory2Status = clearCategory2Status;
	exports.clearCategory2StatusB2B = clearCategory2StatusB2B;
	exports.requestTypes = requestTypes;
	exports.fetchTypesSuccess = fetchTypesSuccess;
	exports.fetchTypesFailure = fetchTypesFailure;
	exports.fetchTypes = fetchTypes;
	exports.requestPriceLevels = requestPriceLevels;
	exports.fetchPriceLevelsSuccess = fetchPriceLevelsSuccess;
	exports.fetchPriceLevelsFailure = fetchPriceLevelsFailure;
	exports.fetchPriceLevels = fetchPriceLevels;
	exports.editMultiPriceLevelsSuccess = editMultiPriceLevelsSuccess;
	exports.editMultiPriceLevelsFailure = editMultiPriceLevelsFailure;
	exports.editMultiPriceLevels = editMultiPriceLevels;
	exports.fetchSimplifiedProductsSuccess = fetchSimplifiedProductsSuccess;
	exports.fetchSimplifiedProductsFailure = fetchSimplifiedProductsFailure;
	exports.fetchSimplifiedProducts = fetchSimplifiedProducts;
	exports.fetchGroupCategoriesSuccess = fetchGroupCategoriesSuccess;
	exports.fetchGroupCategoriesFailure = fetchGroupCategoriesFailure;
	exports.fetchGroupCategories = fetchGroupCategories;
	exports.setValue = setValue;
	exports.fetchProductByNumSuccess = fetchProductByNumSuccess;
	exports.fetchProductByNumFailure = fetchProductByNumFailure;
	exports.fetchProductByNum = fetchProductByNum;
	exports.fetchNextProduct = fetchNextProduct;
	exports.fetchNextProductWithGeno = fetchNextProductWithGeno;
	exports.fetchPreviousProduct = fetchPreviousProduct;
	exports.fetchPreviousProductWithGeno = fetchPreviousProductWithGeno;
	exports.deleteCategorySuccess = deleteCategorySuccess;
	exports.deleteCategoryFailure = deleteCategoryFailure;
	exports.deleteCategory = deleteCategory;
	exports.clearDeleteCategoryStatus = clearDeleteCategoryStatus;
	exports.deleteGroupSuccess = deleteGroupSuccess;
	exports.deleteGroupFailure = deleteGroupFailure;
	exports.clearDeleteGroupStatus = clearDeleteGroupStatus;
	exports.deleteGroup = deleteGroup;
	exports.fetchSmallProductInfoSuccess = fetchSmallProductInfoSuccess;
	exports.fetchSmallProductInfoFailure = fetchSmallProductInfoFailure;
	exports.fetchSmallProductInfo = fetchSmallProductInfo;
	exports.clearSmallProdStatus = clearSmallProdStatus;
	exports.fetchCRVValuesSuccess = fetchCRVValuesSuccess;
	exports.fetchCRVValuesFailure = fetchCRVValuesFailure;
	exports.fetchCRVValues = fetchCRVValues;
	exports.fetchDefaultBuyers = fetchDefaultBuyers;
	exports.attachProductImageSuccess = attachProductImageSuccess;
	exports.attachProductImageFailure = attachProductImageFailure;
	exports.attachProductImage = attachProductImage;
	exports.clearAttachedProductImage = clearAttachedProductImage;
	exports.saveCategory2Products = saveCategory2Products;
	exports.saveCategory2ProductsB2B = saveCategory2ProductsB2B;
	exports.setCurrentProduct = setCurrentProduct;
	exports.fetchRelatedProducts = fetchRelatedProducts;
	exports.fetchSuggestedProdNum = fetchSuggestedProdNum;
	exports.fetchSuggestDigit = fetchSuggestDigit;
	exports.clearSuggestDigit = clearSuggestDigit;
	exports.fetchPackageTypes = fetchPackageTypes;
	exports.editPackageType = editPackageType;
	exports.clearPackageTypeEdited = clearPackageTypeEdited;
	exports.deletePackageTypeSuccess = deletePackageTypeSuccess;
	exports.deletePackageTypeFailure = deletePackageTypeFailure;
	exports.deletePackageType = deletePackageType;
	exports.fetchMeasurementUnit = fetchMeasurementUnit;
	exports.editMeasurementUnit = editMeasurementUnit;
	exports.clearMeasurementUnitEdited = clearMeasurementUnitEdited;
	exports.deleteMeasurementUnitSuccess = deleteMeasurementUnitSuccess;
	exports.deleteMeasurementUnitFailure = deleteMeasurementUnitFailure;
	exports.deleteMeasurementUnit = deleteMeasurementUnit;
	exports.fetchConvertableProducts = fetchConvertableProducts;
	exports.attachDocumentSuccess = attachDocumentSuccess;
	exports.attachDocumentFailure = attachDocumentFailure;
	exports.attachDocument = attachDocument;
	exports.continueProduct = continueProduct;
	exports.discontinueProduct = discontinueProduct;
	exports.deleteProduct = deleteProduct;
	exports.updateProductGroupSuccess = updateProductGroupSuccess;
	exports.updateProductGroupFailure = updateProductGroupFailure;
	exports.updateProductGroup = updateProductGroup;
	exports.saveMobileDescriptionBoxTextSuccess = saveMobileDescriptionBoxTextSuccess;
	exports.saveMobileDescriptionBoxTextFailure = saveMobileDescriptionBoxTextFailure;
	exports.saveMobileDescriptionBoxText = saveMobileDescriptionBoxText;
	exports.fetchMobileDescriptionBoxText = fetchMobileDescriptionBoxText;
	exports.requestDisplayCategories = requestDisplayCategories;
	exports.fetchDisplayCategoriesSuccess = fetchDisplayCategoriesSuccess;
	exports.fetchDisplayCategoriesFailure = fetchDisplayCategoriesFailure;
	exports.fetchDisplayCategories = fetchDisplayCategories;
	exports.requestEditDisplayCategories = requestEditDisplayCategories;
	exports.editDisplayCategoriesSuccess = editDisplayCategoriesSuccess;
	exports.editDisplayCategoriesFailure = editDisplayCategoriesFailure;
	exports.editDisplayCategories = editDisplayCategories;
	exports.fetchQuickAccess = fetchQuickAccess;
	exports.requestInitializeESL = requestInitializeESL;
	exports.initializeESL = initializeESL;
	exports.requestDeleteESL = requestDeleteESL;
	exports.deleteESL = deleteESL;
	exports.requestFetchESLTemplate = requestFetchESLTemplate;
	exports.fetchESLTemplate = fetchESLTemplate;
	exports.requestFetchESL = requestFetchESL;
	exports.fetchESL = fetchESL;
	exports.requestSaveESL = requestSaveESL;
	exports.saveESL = saveESL;
	exports.setRowsFilters = setRowsFilters;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _root_url = __webpack_require__(9);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isHMM = _root_url.ROOT_API_URL === 'https://hmm-scm.truckxi.com/api/';
	var isAPO = _root_url.ROOT_API_URL === 'https://admin.apoodr.com/api/' || _root_url.ROOT_URL === 'https://admin.apoodr.com/api/';
	var isATL = _root_url.ROOT_API_URL === 'https://alton-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://alton-scm.truckxi.com/api/';
	var isAFM = _root_url.ROOT_API_URL === "https://afm-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://afm-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://afmstage-scm.truckxi.com/api/";
	var isUSPride = _root_url.ROOT_API_URL === 'https://uspride-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://uspride-scm.truckxi.com/api/';
	var isTN = _root_url.ROOT_API_URL === "https://tn-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://tn-scm.truckxi.com/api/";
	var isRS = _root_url.ROOT_API_URL === 'https://redstone-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://redstone-scm.truckxi.com/api/';
	
	var isNumeric = function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	};
	
	function requestProducts() {
	  return {
	    type: _type.REQUEST_PRODUCTS
	  };
	}
	function fetchProductsSuccess(products) {
	  return {
	    type: _type.FETCH_PRODUCTS_SUCCESS,
	    payload: products
	  };
	}
	function fetchProductsFailure(error) {
	  return {
	    type: _type.FETCH_PRODUCTS_FAILURE,
	    payload: error
	  };
	}
	function fetchProducts() {
	  return function (dispatch) {
	    dispatch(requestProducts());
	    return _axios2.default.get(_url.PRODUCTS_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchProductsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchProductsFailure(err));
	    });
	  };
	}
	
	var fetchCustomers = exports.fetchCustomers = function fetchCustomers(bool) {
	  return function (dispatch) {
	    var mobile = '';
	    if (bool === true) {
	      mobile = '&include_Mobile_Customer=true';
	    }
	
	    (0, _axios2.default)({
	      method: 'GET',
	      url: _url.CUSTOMERS_URL + '?Customer_id__IsActive=1' + mobile,
	      headers: {
	        Authorization: 'Bearer ' + localStorage.getItem('token')
	      }
	    }).then(function (res) {
	      dispatch({
	        type: _type.PRODUCTFORM_ACTIVE_CUSTOMER,
	        payload: res.data
	      });
	    }).catch(function (err) {
	      alert(err);
	    });
	  };
	};
	
	function requestProductsByGroup() {
	  return {
	    type: _type.REQUEST_PRODUCTS
	  };
	}
	function fetchProductsByGroupSuccess(products) {
	  return {
	    type: _type.FETCH_PRODUCTS_SUCCESS,
	    payload: products
	  };
	}
	function fetchProductsByGroupFailure(error) {
	  return {
	    type: _type.FETCH_PRODUCTS_FAILURE,
	    payload: error
	  };
	}
	function fetchProductsByGroup(id) {
	  if (id === -1) {
	    return function (dispatch) {
	      dispatch(fetchProducts());
	    };
	  }
	  return function (dispatch) {
	    dispatch(requestProductsByGroup());
	    return _axios2.default.get(_url.PRODUCTS_URL + 'search/?ProductGroup_id=' + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchProductsByGroupSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchProductsByGroupFailure(err));
	    });
	  };
	}
	
	function requestProductsByCategory() {
	  return {
	    type: _type.REQUEST_PRODUCTS
	  };
	}
	function fetchProductsByCategorySuccess(products) {
	  return {
	    type: _type.FETCH_PRODUCTS_SUCCESS,
	    payload: products
	  };
	}
	function fetchProductsByCategoryFailure(error) {
	  return {
	    type: _type.FETCH_PRODUCTS_FAILURE,
	    payload: error
	  };
	}
	function fetchProductsByCategory(id) {
	  var handleSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	  var handleFailure = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
	  var requestedFromProductFormPage = arguments[3];
	
	  if (id === -1) {
	    return function (dispatch) {
	      dispatch(fetchProducts());
	    };
	  }
	  return function (dispatch) {
	    dispatch(requestProductsByCategory());
	    var query = isAPO && requestedFromProductFormPage ? '&related=true' : '';
	    var url = _url.PRODUCTS_URL + 'search/?ProductCategory1_id=' + id + query;
	    if (isUSPride) {
	      url = _url.PRODUCTS_URL + 'search/';
	    }
	    return _axios2.default.get(
	    // `${PRODUCTS_URL}search/?ProductCategory1_id=${id}${query}`,
	    url, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      handleSuccess(response);
	      dispatch(fetchProductsByCategorySuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      handleFailure(err);
	      dispatch(fetchProductsByCategoryFailure(err));
	    });
	  };
	}
	
	function requestProductsByCategory2(id) {
	  return {
	    type: _type.REQUEST_CATEGORY2_PRODUCTS,
	    payload: id
	  };
	}
	
	function fetchProductsByCategory2Success(products) {
	  return {
	    type: _type.FETCH_CATEGORY2_PRODUCTS_SUCCESS,
	    payload: products
	  };
	}
	function fetchProductsByCategory2Failure(error) {
	  return {
	    type: _type.FETCH_CATEGORY2_PRODUCTS_FAILURE,
	    payload: error
	  };
	}
	
	function fetchCategory2Products(id, warehouse) {
	  if (id === -1) {
	    return function (dispatch) {
	      dispatch(fetchProducts());
	    };
	  }
	  return function (dispatch) {
	    dispatch(requestProductsByCategory2(id));
	    return _axios2.default.get(_url.PRODUCTS_URL + 'category2/' + id + '/product?' + (isAFM && 'BelongWarehouse=') + (isAFM && warehouse), {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchProductsByCategory2Success(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchProductsByCategory2Failure(err));
	    });
	  };
	}
	
	function requestProductsByCategory2B2B(id) {
	  return {
	    type: _type.REQUEST_CATEGORY2_PRODUCTS_B2B,
	    payload: id
	  };
	}
	
	function resetCategory2Id() {
	  return {
	    type: _type.RESET_CATEGORY2_ID
	  };
	}
	
	function fetchProductsByCategory2SuccessB2B(products) {
	  return {
	    type: _type.FETCH_CATEGORY2_PRODUCTS_SUCCESS_B2B,
	    payload: products
	  };
	}
	function fetchProductsByCategory2FailureB2B(error) {
	  return {
	    type: _type.FETCH_CATEGORY2_PRODUCTS_FAILURE_B2B,
	    payload: error
	  };
	}
	
	function fetchCategory2ProductsB2B(id) {
	  if (id === -1) {
	    return function (dispatch) {
	      dispatch(fetchProducts());
	    };
	  }
	  return function (dispatch) {
	    dispatch(requestProductsByCategory2B2B(id));
	    return _axios2.default.get(_url.PRODUCTS_URL + 'category2_b2b/' + id + '/product', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchProductsByCategory2SuccessB2B(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchProductsByCategory2FailureB2B(err));
	    });
	  };
	}
	
	function requestProductsByVendor() {
	  return {
	    type: _type.REQUEST_PRODUCTS_BY_VENDOR
	  };
	}
	function fetchProductsByVendorSuccess(products) {
	  return {
	    type: _type.FETCH_PRODUCTS_BY_VENDOR_SUCCESS,
	    payload: products
	  };
	}
	function fetchProductsByVendorFailure(error) {
	  return {
	    type: _type.FETCH_PRODUCTS_BY_VENDOR_FAILURE,
	    payload: error
	  };
	}
	function fetchProductsByVendor(Vendor_id) {
	  return function (dispatch) {
	    dispatch(requestProductsByVendor());
	    return _axios2.default.get(_url.PRODUCTS_URL + 'vendor/' + Vendor_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchProductsByVendorSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchProductsByVendorFailure(err));
	    });
	  };
	}
	
	function requestProductInfo() {
	  return {
	    type: _type.REQUEST_PRODUCT_INFO
	  };
	}
	function fetchProductInfoSuccess(productInfo) {
	  return {
	    type: _type.FETCH_PRODUCT_INFO_SUCCESS,
	    payload: productInfo
	  };
	}
	function fetchProductInfoFailure(error) {
	  return {
	    type: _type.FETCH_PRODUCT_INFO_FAILURE,
	    payload: error
	  };
	}
	function fetchProductInfo(Product_id) {
	  return function (dispatch) {
	    dispatch(requestProductInfo());
	    return _axios2.default.get(_url.PURCHASE_URL + 'line/info/' + Product_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchProductInfoSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchProductInfoFailure(err));
	    });
	  };
	}
	
	function fetchProductInfo2(Product_id) {
	  var url = _url.PURCHASE_URL_2 + '?Product_id=' + Product_id;
	  if (isTN) {
	    url = _url.SALES_ORDER_PRODUCT_BY_ID_URL + '10/?Product_id=' + Product_id;
	  }
	
	  return function (dispatch) {
	    dispatch(requestProductInfo());
	    return _axios2.default.get(url, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchProductInfoSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchProductInfoFailure(err));
	    });
	  };
	}
	
	function selectProduct(product) {
	  return {
	    type: _type.SELECT_PRODUCT,
	    payload: product
	  };
	}
	function resetCurrentProduct() {
	  return {
	    type: _type.RESET_CURRENT_PRODUCT
	  };
	}
	
	function clearCurrentProduct() {
	  return {
	    type: _type.CLEAR_CURRENT_PRODUCT
	  };
	}
	function setGroupCategory(currentGroupCategory) {
	  return {
	    type: _type.SET_GROUP_CATEGORY,
	    payload: currentGroupCategory
	  };
	}
	
	function reinitialize(data) {
	  return {
	    type: _type.REINITIALZIE_PRODUCT_FORM,
	    payload: data
	  };
	}
	
	// Actions to deal with the promise of posting function.
	function createProduct(_ref, _ref2) {
	  var AutoPO = _ref.AutoPO,
	      default_po_quantity = _ref.default_po_quantity,
	      LimitQuantityPerOrder = _ref.LimitQuantityPerOrder,
	      MixedProductBaseUnit = _ref.MixedProductBaseUnit,
	      MixedProduct = _ref.MixedProduct,
	      BinRangeList = _ref.BinRangeList,
	      ProductNum = _ref.ProductNum,
	      RefNum = _ref.RefNum,
	      Name = _ref.Name,
	      Description = _ref.Description,
	      ConvertType = _ref.ConvertType,
	      ConvertNum = _ref.ConvertNum,
	      CRV = _ref.CRV,
	      CRV_id = _ref.CRV_id,
	      PackageSize = _ref.PackageSize,
	      Width = _ref.Width,
	      Length = _ref.Length,
	      Height = _ref.Height,
	      HMartCode = _ref.HMartCode,
	      MeasureUnit = _ref.MeasureUnit,
	      NetWeight = _ref.NetWeight,
	      ShippingWeight = _ref.ShippingWeight,
	      MaxWeightRange = _ref.MaxWeightRange,
	      MinWeightRange = _ref.MinWeightRange,
	      MaxStockRange = _ref.MaxStockRange,
	      MinStockRange = _ref.MinStockRange,
	      ShiftLife = _ref.ShiftLife,
	      ProductBarcode = _ref.ProductBarcode,
	      Purchaser_User_id = _ref.Purchaser_User_id,
	      IsStopPurchase = _ref.IsStopPurchase,
	      Sales_User_id = _ref.Sales_User_id,
	      default_purchaser_user_id = _ref.default_purchaser_user_id,
	      InternalBarcode = _ref.InternalBarcode,
	      IsDiscontinued = _ref.IsDiscontinued,
	      IsB2B = _ref.IsB2B,
	      IsB2C = _ref.IsB2C,
	      IsTaxable = _ref.IsTaxable,
	      IsAllTaxable = _ref.IsAllTaxable,
	      IsNonFood = _ref.IsNonFood,
	      IsOverSaleable = _ref.IsOverSaleable,
	      IsPromotion = _ref.IsPromotion,
	      IsStopSale = _ref.IsStopSale,
	      GeneralNum = _ref.GeneralNum,
	      IsWholesaleOnly = _ref.IsWholesaleOnly,
	      IsMobile = _ref.IsMobile,
	      IsSoldNationwide = _ref.IsSoldNationwide,
	      IsNewArrival = _ref.IsNewArrival,
	      IsGreatDeal = _ref.IsGreatDeal,
	      PurchaseConvertUnit = _ref.PurchaseConvertUnit,
	      IsProposition65 = _ref.IsProposition65,
	      IsSyncToScales = _ref.IsSyncToScales,
	      Tare = _ref.Tare,
	      ZoneLevel2 = _ref.ZoneLevel2,
	      ZoneLevel3 = _ref.ZoneLevel3,
	      ZoneLevel4 = _ref.ZoneLevel4,
	      ZoneLevel5 = _ref.ZoneLevel5,
	      ZoneLevel6 = _ref.ZoneLevel6,
	      ZoneLevel7 = _ref.ZoneLevel7,
	      ZoneLevel8 = _ref.ZoneLevel8,
	      IsSyncToESL = _ref.IsSyncToESL,
	      IsAFGChioce = _ref.IsAFGChioce,
	      IsAlcohol = _ref.IsAlcohol,
	      NetCost = _ref.NetCost,
	      ProductCost = _ref.ProductCost,
	      LowestSalePrice = _ref.LowestSalePrice,
	      RefPrice = _ref.RefPrice,
	      Related_Product_id = _ref.Related_Product_id,
	      ProductGroup_id = _ref.ProductGroup_id,
	      ProductCategory1_id = _ref.ProductCategory1_id,
	      ProductCategory2_id = _ref.ProductCategory2_id,
	      Default_Warehouse_id = _ref.Default_Warehouse_id,
	      Default_WarehouseZone_id = _ref.Default_WarehouseZone_id,
	      Default_WarehouseFromBin_id = _ref.Default_WarehouseFromBin_id,
	      Default_WarehouseToBin_id = _ref.Default_WarehouseToBin_id,
	      PackageType = _ref.PackageType,
	      ProductType = _ref.ProductType,
	      Vendors = _ref.Vendors,
	      SmallProdNum = _ref.SmallProdNum,
	      SmallNetWeight = _ref.SmallNetWeight,
	      SmallFixedWeight = _ref.SmallFixedWeight,
	      SmallCatchWeight = _ref.SmallCatchWeight,
	      UnitPerPallet = _ref.UnitPerPallet,
	      VendorProdNo = _ref.VendorProdNo,
	      IsRelated = _ref.IsRelated,
	      IsLarge = _ref.IsLarge,
	      InStockPrice = _ref.InStockPrice,
	      RoundPriceLevels = _ref.RoundPriceLevels,
	      PriceType = _ref.PriceType,
	      PackageSize_1 = _ref.PackageSize_1,
	      PackageType_2 = _ref.PackageType_2,
	      PackageSize_2 = _ref.PackageSize_2,
	      MeasureUnit_2 = _ref.MeasureUnit_2,
	      CalcoDispatchCase = _ref.CalcoDispatchCase,
	      CalcoDispatchBag = _ref.CalcoDispatchBag,
	      DimensionUnit = _ref.DimensionUnit,
	      DimensionHeight = _ref.DimensionHeight,
	      DimensionLength = _ref.DimensionLength,
	      DimensionWidth = _ref.DimensionWidth,
	      Volume = _ref.Volume,
	      ViewableLanguages = _ref.ViewableLanguages,
	      ShippingFeeUnitPrice = _ref.ShippingFeeUnitPrice,
	      TaxAmount = _ref.TaxAmount,
	      Temperature = _ref.Temperature,
	      MiscUnitPrice = _ref.MiscUnitPrice,
	      Zone = _ref.Zone,
	      Bin = _ref.Bin,
	      Level = _ref.Level,
	      Zone2 = _ref.Zone2,
	      Bin2 = _ref.Bin2,
	      Level2 = _ref.Level2,
	      Zone3 = _ref.Zone3,
	      Bin3 = _ref.Bin3,
	      Level3 = _ref.Level3,
	      Brand = _ref.Brand,
	      VendorStyleNum = _ref.VendorStyleNum,
	      TJXStyleNum = _ref.TJXStyleNum,
	      UPC = _ref.UPC,
	      GTIN = _ref.GTIN,
	      Color = _ref.Color,
	      Size = _ref.Size,
	      English_Details_Brand = _ref.English_Details_Brand,
	      Chinese_Details_Brand = _ref.Chinese_Details_Brand,
	      English_Brand_Origin = _ref.English_Brand_Origin,
	      Chinese_Brand_Origin = _ref.Chinese_Brand_Origin,
	      English_Details_NetContent = _ref.English_Details_NetContent,
	      Chinese_Details_NetContent = _ref.Chinese_Details_NetContent,
	      English_Details_Made_In = _ref.English_Details_Made_In,
	      Chinese_Details_Made_In = _ref.Chinese_Details_Made_In,
	      English_Details_Organic = _ref.English_Details_Organic,
	      Chinese_Details_Organic = _ref.Chinese_Details_Organic,
	      English_Details_Contains_Sugar = _ref.English_Details_Contains_Sugar,
	      Chinese_Details_Contains_Sugar = _ref.Chinese_Details_Contains_Sugar,
	      English_Details_Flavor = _ref.English_Details_Flavor,
	      Chinese_Details_Flavor = _ref.Chinese_Details_Flavor,
	      English_Details_Ingredients = _ref.English_Details_Ingredients,
	      Chinese_Details_Ingredients = _ref.Chinese_Details_Ingredients,
	      customerId = _ref.customerId,
	      Customer = _ref.Customer,
	      LotNum = _ref.LotNum;
	  var priceLv1 = _ref2.priceLv1,
	      priceLv2 = _ref2.priceLv2,
	      priceLv3 = _ref2.priceLv3,
	      priceLv4 = _ref2.priceLv4,
	      priceLv5 = _ref2.priceLv5,
	      p1Percentage = _ref2.p1Percentage,
	      p2Percentage = _ref2.p2Percentage,
	      p3Percentage = _ref2.p3Percentage,
	      p4Percentage = _ref2.p4Percentage,
	      p5Percentage = _ref2.p5Percentage,
	      ProductSKU = _ref2.ProductSKU,
	      meta_info = _ref2.meta_info;
	
	  if (GTIN) GTIN = GTIN.value || GTIN;
	  var ArrivalPrice = Number(MiscUnitPrice) + Number(ShippingFeeUnitPrice) + Number(ProductCost);
	  var newVendors = [];
	  if (Vendors) {
	    Vendors.map(function (vendor) {
	      if (vendor.Vendor_id) {
	        vendor.Vendor_id = vendor.Vendor_id.value || vendor.Vendor_id;
	      }
	      newVendors.push(vendor);
	    });
	  }
	  if (Related_Product_id) Related_Product_id = Related_Product_id.value || Related_Product_id;
	  if (ProductGroup_id) ProductGroup_id = ProductGroup_id.value || ProductGroup_id;
	  if (ProductCategory1_id) ProductCategory1_id = ProductCategory1_id.value || ProductCategory1_id;
	  if (ProductCategory2_id) ProductCategory2_id = ProductCategory2_id.value || ProductCategory2_id;
	  if (PackageType) PackageType = PackageType.value || PackageType;
	  if (ProductType) ProductType = ProductType.value || ProductType;
	  if (Default_Warehouse_id) Default_Warehouse_id = Default_Warehouse_id.value || Default_Warehouse_id;
	  if (Default_WarehouseZone_id) Default_WarehouseZone_id = Default_WarehouseZone_id.value || Default_WarehouseZone_id;
	
	  if (!IsDiscontinued) IsDiscontinued = 'false';
	  if (!IsTaxable) IsTaxable = 'false';
	  if (!IsAllTaxable) IsAllTaxable = 'false';
	  if (!IsNonFood) IsNonFood = 'false';
	  if (!IsOverSaleable) IsOverSaleable = 'false';
	  if (!IsPromotion) IsPromotion = 'false';
	  if (!IsWholesaleOnly) IsWholesaleOnly = 'false';
	  if (PackageType_2) PackageType_2 = PackageType_2.value || PackageType_2;
	  if (MeasureUnit_2) MeasureUnit_2 = MeasureUnit_2.value || MeasureUnit_2;
	  if (MeasureUnit) {
	    MeasureUnit = MeasureUnit.value || MeasureUnit;
	  }
	  var mixedProduct = [];
	  if (MixedProduct) {
	    for (var i = 0; i < MixedProduct.length; i++) {
	      var temp = {};
	      if (MixedProductBaseUnit.value) {
	        temp.Unit = MixedProductBaseUnit.value;
	      } else {
	        temp.Unit = MixedProductBaseUnit;
	      }
	      if (MixedProduct[i].MixedUnit.value) {
	        temp.MixedUnit = MixedProduct[i].MixedUnit.value;
	      } else {
	        temp.MixedUnit = MixedProduct[i].MixedUnit;
	      }
	      temp.ProductName = MixedProduct[i].ProductName;
	      temp.ProductNum = MixedProduct[i].ProductNum;
	      temp.ProductSKU = MixedProduct[i].ProductSKU;
	      temp.Quantity = MixedProduct[i].Quantity;
	      mixedProduct[i] = temp;
	    }
	  }
	  if (!isNumeric(LimitQuantityPerOrder)) {
	    if (LimitQuantityPerOrder === null || LimitQuantityPerOrder === "" || !LimitQuantityPerOrder) {
	      LimitQuantityPerOrder = 0;
	    } else {
	      alert("Limited Qty/Order must be a number!");
	      return function (dispatch) {
	        dispatch({ type: _type.CREATE_PRODUCT_FAILURE });
	      };
	    }
	  }
	  if (LimitQuantityPerOrder < 0) {
	    LimitQuantityPerOrder = 0;
	  }
	
	  var binRangeList = [];
	  if (BinRangeList) {
	    binRangeList = BinRangeList.slice();
	    BinRangeList.map(function (bin, index) {
	      if (_typeof(bin.DefaultBin) === 'object' && bin.DefaultBin.value) {
	        binRangeList[index].DefaultBin = bin.DefaultBin.value;
	      } else {
	        binRangeList[index].DefaultBin = bin.DefaultBin;
	      }
	      if (_typeof(bin.Default_Level) === 'object' && bin.Default_Level.value) {
	        binRangeList[index].Default_Level = bin.Default_Level.value;
	      } else {
	        binRangeList[index].Default_Level = bin.Default_Level;
	      }
	    });
	  }
	  if (DimensionUnit && DimensionUnit.value) {
	    DimensionUnit = DimensionUnit.value;
	  }
	  if (Customer && Customer.value) {
	    Customer = Customer.value;
	  }
	  if (customerId && customerId.value) {
	    customerId = customerId.value;
	  }
	
	  var dataParams = {
	    customerId: customerId,
	    Customer: Customer,
	    AutoPO: AutoPO,
	    default_po_quantity: default_po_quantity,
	    meta_title: meta_info.meta_title,
	    meta_keywords: meta_info.meta_keywords,
	    meta_description: meta_info.meta_description,
	    LimitQuantityPerOrder: LimitQuantityPerOrder,
	    MixedProduct: mixedProduct,
	    BinRangeList: binRangeList,
	    ProductNum: ProductNum,
	    RefNum: RefNum,
	    Name: Name,
	    Description: Description,
	    ConvertType: ConvertType,
	    ConvertNum: ConvertNum,
	    CRV: CRV,
	    CRV_id: CRV_id && CRV_id.value || CRV_id,
	    Purchaser_User_id: Purchaser_User_id && Purchaser_User_id.value || Purchaser_User_id,
	    IsStopPurchase: IsStopPurchase,
	    Sales_User_id: Sales_User_id && Sales_User_id.value || Sales_User_id,
	    default_purchaser_user_id: default_purchaser_user_id && default_purchaser_user_id.value || default_purchaser_user_id,
	    PackageSize: PackageSize,
	    Width: Width,
	    Length: Length,
	    Height: Height,
	    HMartCode: HMartCode,
	    MeasureUnit: MeasureUnit,
	    NetWeight: NetWeight,
	    ShippingWeight: ShippingWeight,
	    MaxWeightRange: MaxWeightRange,
	    MinWeightRange: MinWeightRange,
	    MaxStockRange: MaxStockRange,
	    MinStockRange: MinStockRange,
	    ShiftLife: ShiftLife,
	    ProductBarcode: ProductBarcode,
	    InternalBarcode: InternalBarcode,
	    IsDiscontinued: IsDiscontinued,
	    IsB2B: IsB2B,
	    IsB2C: IsB2C,
	    IsTaxable: IsTaxable,
	    IsAllTaxable: IsAllTaxable,
	    IsNonFood: IsNonFood,
	    IsOverSaleable: IsOverSaleable,
	    IsPromotion: IsPromotion,
	    IsStopSale: IsStopSale,
	    GeneralNum: GeneralNum,
	    IsWholesaleOnly: IsWholesaleOnly,
	    IsMobile: IsMobile,
	    IsSoldNationwide: IsSoldNationwide,
	    IsNewArrival: IsNewArrival,
	    IsGreatDeal: IsGreatDeal,
	    PurchaseConvertUnit: PurchaseConvertUnit,
	    IsProposition65: IsProposition65,
	    IsSyncToScales: IsSyncToScales,
	    Tare: Tare,
	    ZoneLevel2: ZoneLevel2,
	    ZoneLevel3: ZoneLevel3,
	    ZoneLevel4: ZoneLevel4,
	    ZoneLevel5: ZoneLevel5,
	    ZoneLevel6: ZoneLevel6,
	    ZoneLevel7: ZoneLevel7,
	    ZoneLevel8: ZoneLevel8,
	    IsSyncToESL: IsSyncToESL,
	    IsAFGChioce: IsAFGChioce,
	    IsAlcohol: IsAlcohol,
	    NetCost: NetCost,
	    ProductCost: ProductCost,
	    LowestSalePrice: LowestSalePrice,
	    RefPrice: RefPrice,
	    PriceLv1: priceLv1,
	    PriceLv2: priceLv2,
	    PriceLv3: priceLv3,
	    PriceLv4: priceLv4,
	    PriceLv5: priceLv5,
	    P1Percentage: p1Percentage,
	    P2Percentage: p2Percentage,
	    P3Percentage: p3Percentage,
	    P4Percentage: p4Percentage,
	    P5Percentage: p5Percentage,
	    Related_Product_id: Related_Product_id,
	    ProductGroup_id: ProductGroup_id,
	    ProductCategory1_id: ProductCategory1_id,
	    ProductCategory2_id: ProductCategory2_id,
	    Default_Warehouse_id: Default_Warehouse_id,
	    Default_WarehouseZone_id: Default_WarehouseZone_id,
	    Default_WarehouseToBin_id: Default_WarehouseToBin_id,
	    Default_WarehouseFromBin_id: Default_WarehouseFromBin_id,
	    PackageType: PackageType,
	    ProductType: ProductType,
	    UnitPerPallet: UnitPerPallet,
	    Vendors: newVendors,
	    SmallProdNum: SmallProdNum,
	    SmallNetWeight: SmallNetWeight,
	    SmallFixedWeight: SmallFixedWeight,
	    SmallCatchWeight: SmallCatchWeight,
	    VendorProdNo: VendorProdNo,
	    IsRelated: IsRelated,
	    IsLarge: IsLarge,
	    InStockPrice: InStockPrice,
	    RoundPriceLevels: RoundPriceLevels,
	    PriceType: PriceType,
	    PackageSize_1: PackageSize_1,
	    PackageType_2: PackageType_2,
	    PackageSize_2: PackageSize_2,
	    MeasureUnit_2: MeasureUnit_2,
	    CalcoDispatchCase: CalcoDispatchCase,
	    CalcoDispatchBag: CalcoDispatchBag,
	    DimensionUnit: DimensionUnit,
	    DimensionHeight: DimensionHeight,
	    DimensionLength: DimensionLength,
	    DimensionWidth: DimensionWidth,
	    Volume: Volume,
	    ViewableLanguages: ViewableLanguages,
	    ProductSKU: ProductSKU,
	    ShippingFeeUnitPrice: ShippingFeeUnitPrice,
	    TaxAmount: TaxAmount,
	    Temperature: Temperature,
	    MiscUnitPrice: MiscUnitPrice,
	    ArrivalPrice: ArrivalPrice,
	    Zone: Zone,
	    Bin: Bin,
	    Level: Level,
	    Zone2: Zone2,
	    Bin2: Bin2,
	    Level2: Level2,
	    Zone3: Zone3,
	    Bin3: Bin3,
	    Level3: Level3,
	    Brand: Brand,
	    VendorStyleNum: VendorStyleNum,
	    TJXStyleNum: TJXStyleNum,
	    UPC: UPC,
	    GTIN: GTIN,
	    Color: Color,
	    Size: Size,
	    English_Details_Brand: English_Details_Brand,
	    Chinese_Details_Brand: Chinese_Details_Brand,
	    English_Brand_Origin: English_Brand_Origin,
	    Chinese_Brand_Origin: Chinese_Brand_Origin,
	    English_Details_NetContent: English_Details_NetContent,
	    Chinese_Details_NetContent: Chinese_Details_NetContent,
	    English_Details_Made_In: English_Details_Made_In,
	    Chinese_Details_Made_In: Chinese_Details_Made_In,
	    English_Details_Organic: English_Details_Organic,
	    Chinese_Details_Organic: Chinese_Details_Organic,
	    English_Details_Contains_Sugar: English_Details_Contains_Sugar,
	    Chinese_Details_Contains_Sugar: Chinese_Details_Contains_Sugar,
	    English_Details_Flavor: English_Details_Flavor,
	    Chinese_Details_Flavor: Chinese_Details_Flavor,
	    English_Details_Ingredients: English_Details_Ingredients,
	    Chinese_Details_Ingredients: Chinese_Details_Ingredients
	  };
	
	  if (_root_url.isCNT) {
	    dataParams.LotNum = LotNum == undefined ? '' : LotNum;
	  }
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CREATING_PRODUCT });
	    _axios2.default.post(_url.PRODUCTS_URL, dataParams, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(createProductSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404 || err.status === 400) {
	        // err.data = DEFAULT_ERROR;
	      }
	      dispatch(createProductFailure(err));
	    });
	  };
	}
	function requestCreatingProduct() {
	  return {
	    type: _type.REQUEST_CREATING_PRODUCT
	
	  };
	}
	function createProductSuccess(response) {
	  return {
	    type: _type.CREATE_PRODUCT_SUCCESS,
	    payload: response
	  };
	}
	function createProductFailure(error) {
	  return {
	    type: _type.CREATE_PRODUCT_FAILURE,
	    payload: error
	  };
	}
	
	/**
	 * Duplicates the current product
	 * @param {number} prodId current product's id
	 * @param {string} prodNum new generated product number
	 */
	var duplicateProduct = exports.duplicateProduct = function duplicateProduct(prodId, prodNum) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CREATING_PRODUCT });
	    var config = {
	      method: 'post',
	      url: _url.PRODUCTS_URL + 'duplicate/' + prodId,
	      data: {
	        ProductNum: prodNum
	      }
	    };
	    (0, _axios2.default)(_extends({}, config, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    })).then(function (response) {
	      dispatch(createProductSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(createProductFailure(err));
	    });
	  };
	};
	
	function editProductSuccess(response) {
	  return {
	    type: _type.EDIT_PRODUCT_SUCCESS,
	    payload: response
	  };
	}
	function editProductFailure(error) {
	  return {
	    type: _type.EDIT_PRODUCT_FAILURE,
	    payload: error
	  };
	}
	function editProduct(_ref3, _ref4, returnToLastPage) {
	  var AutoPO = _ref3.AutoPO,
	      default_po_quantity = _ref3.default_po_quantity,
	      LimitQuantityPerOrder = _ref3.LimitQuantityPerOrder,
	      MixedProductBaseUnit = _ref3.MixedProductBaseUnit,
	      MixedProduct = _ref3.MixedProduct,
	      Bin = _ref3.Bin,
	      BinRangeList = _ref3.BinRangeList,
	      ConvertNum = _ref3.ConvertNum,
	      ConvertType = _ref3.ConvertType,
	      CRV = _ref3.CRV,
	      CRV_id = _ref3.CRV_id,
	      Default_Warehouse_id = _ref3.Default_Warehouse_id,
	      Default_WarehouseFromBin_id = _ref3.Default_WarehouseFromBin_id,
	      Default_WarehouseToBin_id = _ref3.Default_WarehouseToBin_id,
	      Default_WarehouseZone_id = _ref3.Default_WarehouseZone_id,
	      Description = _ref3.Description,
	      Height = _ref3.Height,
	      HMartCode = _ref3.HMartCode,
	      InStockPrice = _ref3.InStockPrice,
	      InternalBarcode = _ref3.InternalBarcode,
	      IsB2B = _ref3.IsB2B,
	      IsB2C = _ref3.IsB2C,
	      IsDiscontinued = _ref3.IsDiscontinued,
	      IsLarge = _ref3.IsLarge,
	      IsOverSaleable = _ref3.IsOverSaleable,
	      IsPromotion = _ref3.IsPromotion,
	      IsRelated = _ref3.IsRelated,
	      IsStopSale = _ref3.IsStopSale,
	      GeneralNum = _ref3.GeneralNum,
	      IsTaxable = _ref3.IsTaxable,
	      IsAllTaxable = _ref3.IsAllTaxable,
	      IsNonFood = _ref3.IsNonFood,
	      IsWholesaleOnly = _ref3.IsWholesaleOnly,
	      IsMobile = _ref3.IsMobile,
	      IsSoldNationwide = _ref3.IsSoldNationwide,
	      IsNewArrival = _ref3.IsNewArrival,
	      IsGreatDeal = _ref3.IsGreatDeal,
	      PurchaseConvertUnit = _ref3.PurchaseConvertUnit,
	      IsProposition65 = _ref3.IsProposition65,
	      IsSyncToScales = _ref3.IsSyncToScales,
	      Tare = _ref3.Tare,
	      ZoneLevel2 = _ref3.ZoneLevel2,
	      ZoneLevel3 = _ref3.ZoneLevel3,
	      ZoneLevel4 = _ref3.ZoneLevel4,
	      ZoneLevel5 = _ref3.ZoneLevel5,
	      ZoneLevel6 = _ref3.ZoneLevel6,
	      ZoneLevel7 = _ref3.ZoneLevel7,
	      ZoneLevel8 = _ref3.ZoneLevel8,
	      IsSyncToESL = _ref3.IsSyncToESL,
	      IsAFGChioce = _ref3.IsAFGChioce,
	      IsAlcohol = _ref3.IsAlcohol,
	      Length = _ref3.Length,
	      Level = _ref3.Level,
	      LowestSalePrice = _ref3.LowestSalePrice,
	      MaxStockRange = _ref3.MaxStockRange,
	      MaxWeightRange = _ref3.MaxWeightRange,
	      MeasureUnit = _ref3.MeasureUnit,
	      MeasureUnit_2 = _ref3.MeasureUnit_2,
	      DimensionUnit = _ref3.DimensionUnit,
	      DimensionHeight = _ref3.DimensionHeight,
	      DimensionLength = _ref3.DimensionLength,
	      DimensionWidth = _ref3.DimensionWidth,
	      Volume = _ref3.Volume,
	      MinStockRange = _ref3.MinStockRange,
	      MinWeightRange = _ref3.MinWeightRange,
	      Name = _ref3.Name,
	      NetCost = _ref3.NetCost,
	      NetWeight = _ref3.NetWeight,
	      PackageSize = _ref3.PackageSize,
	      PackageSize_1 = _ref3.PackageSize_1,
	      PackageSize_2 = _ref3.PackageSize_2,
	      CalcoDispatchCase = _ref3.CalcoDispatchCase,
	      CalcoDispatchBag = _ref3.CalcoDispatchBag,
	      PackageType = _ref3.PackageType,
	      PackageType_2 = _ref3.PackageType_2,
	      PriceType = _ref3.PriceType,
	      Product_id = _ref3.Product_id,
	      ProductBarcode = _ref3.ProductBarcode,
	      ProductCategory1_id = _ref3.ProductCategory1_id,
	      ProductCategory2_id = _ref3.ProductCategory2_id,
	      ProductCost = _ref3.ProductCost,
	      ProductGroup_id = _ref3.ProductGroup_id,
	      ProductNum = _ref3.ProductNum,
	      ProductType = _ref3.ProductType,
	      Purchaser_User_id = _ref3.Purchaser_User_id,
	      IsStopPurchase = _ref3.IsStopPurchase,
	      Sales_User_id = _ref3.Sales_User_id,
	      default_purchaser_user_id = _ref3.default_purchaser_user_id,
	      RefNum = _ref3.RefNum,
	      RefPrice = _ref3.RefPrice,
	      Related_Product_id = _ref3.Related_Product_id,
	      RoundPriceLevels = _ref3.RoundPriceLevels,
	      ShiftLife = _ref3.ShiftLife,
	      ShippingWeight = _ref3.ShippingWeight,
	      UnitPerPallet = _ref3.UnitPerPallet,
	      VendorProdNo = _ref3.VendorProdNo,
	      Vendors = _ref3.Vendors,
	      Width = _ref3.Width,
	      Zone = _ref3.Zone,
	      ViewableLanguages = _ref3.ViewableLanguages,
	      ShippingFeeUnitPrice = _ref3.ShippingFeeUnitPrice,
	      TaxAmount = _ref3.TaxAmount,
	      Temperature = _ref3.Temperature,
	      MiscUnitPrice = _ref3.MiscUnitPrice,
	      Brand = _ref3.Brand,
	      VendorStyleNum = _ref3.VendorStyleNum,
	      TJXStyleNum = _ref3.TJXStyleNum,
	      UPC = _ref3.UPC,
	      GTIN = _ref3.GTIN,
	      Color = _ref3.Color,
	      Size = _ref3.Size,
	      Zone2 = _ref3.Zone2,
	      Bin2 = _ref3.Bin2,
	      Level2 = _ref3.Level2,
	      Zone3 = _ref3.Zone3,
	      Bin3 = _ref3.Bin3,
	      Level3 = _ref3.Level3,
	      English_Details_Brand = _ref3.English_Details_Brand,
	      Chinese_Details_Brand = _ref3.Chinese_Details_Brand,
	      English_Brand_Origin = _ref3.English_Brand_Origin,
	      Chinese_Brand_Origin = _ref3.Chinese_Brand_Origin,
	      English_Details_NetContent = _ref3.English_Details_NetContent,
	      Chinese_Details_NetContent = _ref3.Chinese_Details_NetContent,
	      English_Details_Made_In = _ref3.English_Details_Made_In,
	      Chinese_Details_Made_In = _ref3.Chinese_Details_Made_In,
	      English_Details_Organic = _ref3.English_Details_Organic,
	      Chinese_Details_Organic = _ref3.Chinese_Details_Organic,
	      English_Details_Contains_Sugar = _ref3.English_Details_Contains_Sugar,
	      Chinese_Details_Contains_Sugar = _ref3.Chinese_Details_Contains_Sugar,
	      English_Details_Flavor = _ref3.English_Details_Flavor,
	      Chinese_Details_Flavor = _ref3.Chinese_Details_Flavor,
	      English_Details_Ingredients = _ref3.English_Details_Ingredients,
	      Chinese_Details_Ingredients = _ref3.Chinese_Details_Ingredients,
	      customerId = _ref3.customerId,
	      Customer = _ref3.Customer,
	      LotNum = _ref3.LotNum;
	  var priceLv1 = _ref4.priceLv1,
	      priceLv2 = _ref4.priceLv2,
	      priceLv3 = _ref4.priceLv3,
	      priceLv4 = _ref4.priceLv4,
	      priceLv5 = _ref4.priceLv5,
	      p1Percentage = _ref4.p1Percentage,
	      p2Percentage = _ref4.p2Percentage,
	      p3Percentage = _ref4.p3Percentage,
	      p4Percentage = _ref4.p4Percentage,
	      p5Percentage = _ref4.p5Percentage,
	      relatedProducts = _ref4.relatedProducts,
	      ProductSKU = _ref4.ProductSKU,
	      meta_info = _ref4.meta_info;
	
	  if (GTIN) GTIN = GTIN.value || GTIN;
	  var ArrivalPrice = Number(MiscUnitPrice) + Number(ShippingFeeUnitPrice) + Number(ProductCost);
	  if (isHMM) {
	    ArrivalPrice = Number(MiscUnitPrice) + Number(ShippingFeeUnitPrice) + Number(ProductCost) + Number(TaxAmount);
	  }
	  var newVendors = [];
	  if (Vendors) {
	    Vendors.map(function (vendor) {
	      if (vendor.Vendor_id) {
	        vendor.Vendor_id = vendor.Vendor_id.value || vendor.Vendor_id;
	      }
	      newVendors.push(vendor);
	    });
	  }
	  if (Related_Product_id) Related_Product_id = Related_Product_id.value || Related_Product_id;
	  if (ProductGroup_id) ProductGroup_id = ProductGroup_id.value || ProductGroup_id;
	  if (ProductCategory1_id) ProductCategory1_id = ProductCategory1_id.value || ProductCategory1_id;
	  if (ProductCategory2_id) ProductCategory2_id = ProductCategory2_id.value || ProductCategory2_id;
	  if (PackageType) PackageType = PackageType.value || PackageType;
	  if (ProductType) ProductType = ProductType.value || ProductType;
	  if (Default_Warehouse_id) Default_Warehouse_id = Default_Warehouse_id.value || Default_Warehouse_id;
	  if (Default_WarehouseZone_id) Default_WarehouseZone_id = Default_WarehouseZone_id.value || Default_WarehouseZone_id;
	  if (!IsDiscontinued) IsDiscontinued = 'false';
	  if (!IsTaxable) IsTaxable = 'false';
	  if (!IsAllTaxable) IsAllTaxable = 'false';
	  if (!IsNonFood) IsNonFood = 'false';
	  if (!IsOverSaleable) IsOverSaleable = 'false';
	  if (!IsPromotion) IsPromotion = 'false';
	  if (!IsWholesaleOnly) IsWholesaleOnly = 'false';
	  if (PackageType_2) PackageType_2 = PackageType_2.value || PackageType_2;
	  if (MeasureUnit_2) MeasureUnit_2 = MeasureUnit_2.value || MeasureUnit_2;
	  if (MeasureUnit) {
	    MeasureUnit = MeasureUnit.value || MeasureUnit;
	  }
	
	  var mixedProduct = [];
	  if (MixedProduct) {
	    for (var i = 0; i < MixedProduct.length; i++) {
	      var temp = {};
	      if (MixedProductBaseUnit.value) {
	        temp.Unit = MixedProductBaseUnit.value;
	      } else {
	        temp.Unit = MixedProductBaseUnit;
	      }
	      if (MixedProduct[i].MixedUnit.value) {
	        temp.MixedUnit = MixedProduct[i].MixedUnit.value;
	      } else {
	        temp.MixedUnit = MixedProduct[i].MixedUnit;
	      }
	      temp.ProductName = MixedProduct[i].ProductName;
	      temp.ProductNum = MixedProduct[i].ProductNum;
	      temp.ProductSKU = MixedProduct[i].ProductSKU;
	      temp.Quantity = MixedProduct[i].Quantity;
	      mixedProduct[i] = temp;
	    }
	  }
	
	  if (!isNumeric(LimitQuantityPerOrder)) {
	    if (LimitQuantityPerOrder === null || LimitQuantityPerOrder === "" || !LimitQuantityPerOrder) {
	      LimitQuantityPerOrder = 0;
	    } else {
	      alert("Limited Qty/Order must be a number!");
	      return function (dispatch) {
	        dispatch({ type: _type.EDIT_PRODUCT_FAILURE });
	      };
	    }
	  }
	  if (LimitQuantityPerOrder < 0) {
	    LimitQuantityPerOrder = 0;
	  }
	
	  var binRangeList = [];
	  if (BinRangeList) {
	    binRangeList = BinRangeList.slice();
	    BinRangeList.map(function (bin, index) {
	      if (_typeof(bin.DefaultBin) === 'object' && bin.DefaultBin.value) {
	        binRangeList[index].DefaultBin = bin.DefaultBin.value;
	      } else {
	        binRangeList[index].DefaultBin = bin.DefaultBin;
	      }
	      if (_typeof(bin.Default_Level) === 'object' && bin.Default_Level.value) {
	        binRangeList[index].Default_Level = bin.Default_Level.value;
	      } else {
	        binRangeList[index].Default_Level = bin.Default_Level;
	      }
	    });
	  }
	  if (DimensionUnit && DimensionUnit.value) {
	    DimensionUnit = DimensionUnit.value;
	  }
	  if (Customer && Customer.value) {
	    Customer = Customer.value;
	  }
	  if (customerId && customerId.value) {
	    customerId = customerId.value;
	  }
	  var dataParams = {
	    customerId: customerId,
	    Customer: Customer,
	    AutoPO: AutoPO,
	    default_po_quantity: default_po_quantity,
	    meta_title: meta_info.meta_title,
	    meta_keywords: meta_info.meta_keywords,
	    meta_description: meta_info.meta_description,
	    LimitQuantityPerOrder: LimitQuantityPerOrder,
	    MixedProduct: mixedProduct,
	    Bin: Bin,
	    BinRangeList: binRangeList,
	    ConvertNum: ConvertNum,
	    ConvertType: ConvertType,
	    CRV: CRV,
	    CRV_id: CRV_id && CRV_id.value || CRV_id,
	    Default_Warehouse_id: Default_Warehouse_id,
	    Default_WarehouseFromBin_id: Default_WarehouseFromBin_id,
	    Default_WarehouseToBin_id: Default_WarehouseToBin_id,
	    Default_WarehouseZone_id: Default_WarehouseZone_id,
	    Description: Description,
	    Height: Height,
	    HMartCode: HMartCode,
	    InStockPrice: InStockPrice,
	    InternalBarcode: InternalBarcode,
	    IsDiscontinued: IsDiscontinued,
	    IsB2B: IsB2B,
	    IsB2C: IsB2C,
	    IsLarge: IsLarge,
	    IsOverSaleable: IsOverSaleable,
	    IsPromotion: IsPromotion,
	    IsRelated: IsRelated,
	    IsStopSale: IsStopSale,
	    GeneralNum: GeneralNum,
	    IsTaxable: IsTaxable,
	    IsAllTaxable: IsAllTaxable,
	    IsNonFood: IsNonFood,
	    IsWholesaleOnly: IsWholesaleOnly,
	    IsMobile: IsMobile,
	    IsSoldNationwide: IsSoldNationwide,
	    IsNewArrival: IsNewArrival,
	    IsGreatDeal: IsGreatDeal,
	    PurchaseConvertUnit: PurchaseConvertUnit,
	    IsProposition65: IsProposition65,
	    IsSyncToScales: IsSyncToScales,
	    Tare: Tare,
	    ZoneLevel2: ZoneLevel2,
	    ZoneLevel3: ZoneLevel3,
	    ZoneLevel4: ZoneLevel4,
	    ZoneLevel5: ZoneLevel5,
	    ZoneLevel6: ZoneLevel6,
	    ZoneLevel7: ZoneLevel7,
	    ZoneLevel8: ZoneLevel8,
	    IsSyncToESL: IsSyncToESL,
	    IsAFGChioce: IsAFGChioce,
	    IsAlcohol: IsAlcohol,
	    Length: Length,
	    Level: Level,
	    LowestSalePrice: LowestSalePrice,
	    MaxStockRange: MaxStockRange,
	    MaxWeightRange: MaxWeightRange,
	    MeasureUnit: MeasureUnit,
	    MeasureUnit_2: MeasureUnit_2,
	    DimensionUnit: DimensionUnit,
	    DimensionHeight: DimensionHeight,
	    DimensionLength: DimensionLength,
	    DimensionWidth: DimensionWidth,
	    Volume: Volume,
	    MinStockRange: MinStockRange,
	    MinWeightRange: MinWeightRange,
	    Name: Name,
	    NetCost: NetCost,
	    NetWeight: NetWeight,
	    P1Percentage: p1Percentage,
	    P2Percentage: p2Percentage,
	    P3Percentage: p3Percentage,
	    P4Percentage: p4Percentage,
	    P5Percentage: p5Percentage,
	    PackageSize: PackageSize,
	    PackageSize_1: PackageSize_1,
	    PackageSize_2: PackageSize_2,
	    CalcoDispatchCase: CalcoDispatchCase,
	    CalcoDispatchBag: CalcoDispatchBag,
	    PackageType: PackageType,
	    PackageType_2: PackageType_2,
	    PriceLv1: priceLv1,
	    PriceLv2: priceLv2,
	    PriceLv3: priceLv3,
	    PriceLv4: priceLv4 || 1000,
	    PriceLv5: priceLv5 || 1000,
	    PriceType: PriceType,
	    ProductBarcode: ProductBarcode,
	    ProductCategory1_id: ProductCategory1_id,
	    ProductCategory2_id: ProductCategory2_id,
	    ProductCost: ProductCost,
	    ProductGroup_id: ProductGroup_id,
	    ProductNum: ProductNum,
	    ProductType: ProductType,
	    Purchaser_User_id: Purchaser_User_id && Purchaser_User_id.value || Purchaser_User_id,
	    IsStopPurchase: IsStopPurchase,
	    Sales_User_id: Sales_User_id && Sales_User_id.value || Sales_User_id,
	    default_purchaser_user_id: default_purchaser_user_id && default_purchaser_user_id.value || default_purchaser_user_id,
	    RefNum: RefNum,
	    RefPrice: RefPrice,
	    Related_Product_id: Related_Product_id,
	    relations: relatedProducts,
	    RoundPriceLevels: RoundPriceLevels,
	    ShiftLife: ShiftLife,
	    ShippingWeight: ShippingWeight,
	    UnitPerPallet: UnitPerPallet,
	    VendorProdNo: VendorProdNo,
	    Vendors: newVendors,
	    Width: Width,
	    Zone: Zone,
	    ViewableLanguages: ViewableLanguages,
	    ProductSKU: ProductSKU,
	    ShippingFeeUnitPrice: ShippingFeeUnitPrice,
	    TaxAmount: TaxAmount,
	    Temperature: Temperature,
	    MiscUnitPrice: MiscUnitPrice,
	    ArrivalPrice: ArrivalPrice,
	    Brand: Brand,
	    VendorStyleNum: VendorStyleNum,
	    TJXStyleNum: TJXStyleNum,
	    UPC: UPC,
	    GTIN: GTIN,
	    Color: Color,
	    Size: Size,
	    Zone2: Zone2,
	    Bin2: Bin2,
	    Level2: Level2,
	    Zone3: Zone3,
	    Bin3: Bin3,
	    Level3: Level3,
	    English_Details_Brand: English_Details_Brand,
	    Chinese_Details_Brand: Chinese_Details_Brand,
	    English_Brand_Origin: English_Brand_Origin,
	    Chinese_Brand_Origin: Chinese_Brand_Origin,
	    English_Details_NetContent: English_Details_NetContent,
	    Chinese_Details_NetContent: Chinese_Details_NetContent,
	    English_Details_Made_In: English_Details_Made_In,
	    Chinese_Details_Made_In: Chinese_Details_Made_In,
	    English_Details_Organic: English_Details_Organic,
	    Chinese_Details_Organic: Chinese_Details_Organic,
	    English_Details_Contains_Sugar: English_Details_Contains_Sugar,
	    Chinese_Details_Contains_Sugar: Chinese_Details_Contains_Sugar,
	    English_Details_Flavor: English_Details_Flavor,
	    Chinese_Details_Flavor: Chinese_Details_Flavor,
	    English_Details_Ingredients: English_Details_Ingredients,
	    Chinese_Details_Ingredients: Chinese_Details_Ingredients
	  };
	  if (_root_url.isCNT) {
	    dataParams.LotNum = LotNum == undefined ? '' : LotNum;
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EDITING_PRODUCT });
	    _axios2.default.put(_url.PRODUCTS_URL + Product_id, dataParams, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      if (returnToLastPage) {
	        _reactRouter.browserHistory.goBack();
	      }
	      dispatch(editProductSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404 || err.status === 400) {
	        // err.data = DEFAULT_ERROR;
	      }
	      dispatch(editProductFailure(err));
	    });
	  };
	}
	
	function editMultiProductSuccess() {
	  return {
	    type: _type.EDIT_MULTI_PRODUCT_SUCCESS
	  };
	}
	function editMultiProductFailure(error) {
	  return {
	    type: _type.EDIT_MULTI_PRODUCT_FAILURE,
	    payload: error
	  };
	}
	function editMultiProducts(editedProducts) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EDITING_MULTI_PRODUCT });
	    _axios2.default.put(_url.PRODUCTS_URL, editedProducts, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function () {
	      dispatch(editMultiProductSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editMultiProductFailure(err));
	    });
	  };
	}
	
	// Fetch the detail page
	function requestProductDetail() {
	  return {
	    type: _type.REQUEST_PRODUCT_DETAIL
	  };
	}
	function fetchProductDetailSuccess(productDetail) {
	  productDetail = productDetail.data;
	  return {
	    type: _type.FETCH_PRODUCT_DETAIL_SUCCESS,
	    payload: productDetail
	  };
	}
	function fetchProductDetailFailure(error) {
	  return {
	    type: _type.FETCH_PRODUCT_DETAIL_FAILURE,
	    payload: error
	  };
	}
	function fetchProductDetail(product_id) {
	  return function (dispatch) {
	    dispatch(requestProductDetail());
	    return _axios2.default.get(_url.PRODUCTS_URL + product_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchProductDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchProductDetailFailure(err));
	    });
	  };
	}
	
	// Product Group Actions
	function resetGroupAndCategory() {
	  return {
	    type: _type.RESET_GROUP_AND_CATEGORY
	  };
	}
	
	function requestGroups() {
	  return {
	    type: _type.REQUEST_GROUPS
	  };
	}
	function fetchGroupsSuccess(groups) {
	  return {
	    type: _type.FETCH_GROUPS_SUCCESS,
	    payload: groups
	  };
	}
	function fetchGroupsFailure(error) {
	  return {
	    type: _type.FETCH_GROUPS_FAILURE,
	    payload: error
	  };
	}
	function fetchGroups() {
	  return function (dispatch) {
	    dispatch(requestGroups());
	    return _axios2.default.get(_url.GROUPS_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchGroupsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchGroupsFailure(err));
	    });
	  };
	}
	
	function fetchGroupsElegant() {
	  return function (dispatch) {
	    dispatch(requestGroups());
	    return _axios2.default.get(_url.GROUPS_ELEGANT_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchGroupsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchGroupsFailure(err));
	    });
	  };
	}
	
	function selectGroup(group) {
	  return {
	    type: _type.SELECT_GROUP,
	    payload: group
	  };
	}
	function resetCurrentGroup() {
	  return {
	    type: _type.RESET_CURRENT_GROUP
	  };
	}
	
	function createGroupSuccess() {
	  return {
	    type: _type.CREATE_GROUP_SUCCESS
	  };
	}
	function createGroupFailure(error) {
	  return {
	    type: _type.CREATE_GROUP_FAILURE,
	    payload: error
	  };
	}
	function createGroup(_ref5) {
	  var Name = _ref5.Name,
	      Description = _ref5.Description,
	      IsEnabled = _ref5.IsEnabled;
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CREATING_GROUP });
	    _axios2.default.post(_url.GROUPS_URL, {
	      Name: Name,
	      Description: Description,
	      IsEnabled: IsEnabled
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function () {
	      dispatch(createGroupSuccess());
	      _reactRouter.browserHistory.push('/products/groups');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(createGroupFailure(err));
	    });
	  };
	}
	
	function editGroupSuccess() {
	  return {
	    type: _type.EDIT_GROUP_SUCCESS
	  };
	}
	function editGroupFailure(error) {
	  return {
	    type: _type.EDIT_GROUP_FAILURE,
	    payload: error
	  };
	}
	function editGroup(_ref6) {
	  var ProductGroup_id = _ref6.ProductGroup_id,
	      Name = _ref6.Name,
	      Description = _ref6.Description,
	      IsEnabled = _ref6.IsEnabled;
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EDITING_GROUP });
	    _axios2.default.put(_url.GROUPS_URL + ProductGroup_id, {
	      Name: Name,
	      Description: Description,
	      IsEnabled: IsEnabled
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function () {
	      dispatch(editGroupSuccess());
	      _reactRouter.browserHistory.push('/products/groups'); // If editd succesfully, refresh the paymentTerm page.
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editGroupFailure(err));
	    });
	  };
	}
	
	function editMultiGroupsSuccess() {
	  return {
	    type: _type.EDIT_MULTI_GROUPS_SUCCESS
	  };
	}
	function editMultiGroupsFailure(error) {
	  return {
	    type: _type.EDIT_MULTI_GROUPS_FAILURE,
	    payload: error
	  };
	}
	function editMultiGroups(editedGroups) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EDITING_MULTI_GROUPS });
	    _axios2.default.put(_url.GROUPS_URL, editedGroups, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function () {
	      dispatch(editMultiGroupsSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      // if 400 error, dont override its message
	      dispatch(editMultiGroupsFailure(err));
	    });
	  };
	}
	
	function editMultiGroupsElegant(editedGroups) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EDITING_MULTI_GROUPS });
	    _axios2.default.put(_url.GROUPS_ELEGANT_URL, editedGroups, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function () {
	      dispatch(editMultiGroupsSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      // if 400 error, dont override its message
	      dispatch(editMultiGroupsFailure(err));
	    });
	  };
	}
	
	// Product Categories Actions
	function requestCategories() {
	  return {
	    type: _type.REQUEST_CATEGORIES
	  };
	}
	function fetchCategoriesSuccess(categories) {
	  return {
	    type: _type.FETCH_CATEGORIES_SUCCESS,
	    payload: categories
	  };
	}
	function fetchCategoriesFailure(error) {
	  return {
	    type: _type.FETCH_CATEGORIES_FAILURE,
	    payload: error
	  };
	}
	function fetchCategories() {
	  return function (dispatch) {
	    dispatch(requestCategories());
	    return _axios2.default.get(_url.CATEGORIES_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchCategoriesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCategoriesFailure(err));
	    });
	  };
	}
	
	function resetCategory() {
	  return {
	    type: _type.RESET_CATEGORY
	  };
	}
	function selectCategory(category) {
	  return {
	    type: _type.SELECT_CATEGORY,
	    payload: category
	  };
	}
	function selectCategoryB2B(category) {
	  return {
	    type: _type.SELECT_CATEGORY_B2B,
	    payload: category
	  };
	}
	
	function resetCurrentCategory() {
	  return {
	    type: _type.RESET_CURRENT_CATEGORY
	  };
	}
	function resetCurrentCategoryB2B() {
	  return {
	    type: _type.RESET_CURRENT_CATEGORY_B2B
	  };
	}
	
	function requestCreatingCategory() {
	  return {
	    type: _type.REQUEST_CREATING_CATEGORY
	  };
	}
	function createCategorySuccess() {
	  return {
	    type: _type.CREATE_CATEGORY_SUCCESS
	  };
	}
	function createCategoryFailure(error) {
	  return {
	    type: _type.CREATE_CATEGORY_FAILURE,
	    payload: error
	  };
	}
	function createCategory(_ref7, type) {
	  var Name = _ref7.Name,
	      Description = _ref7.Description,
	      IsEnabled = _ref7.IsEnabled,
	      ProductGroup_id = _ref7.ProductGroup_id;
	
	  ProductGroup_id = ProductGroup_id.value || ProductGroup_id;
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CREATING_CATEGORY });
	    _axios2.default.post(_url.CATEGORIES_URL, {
	      Name: Name,
	      Description: Description,
	      IsEnabled: IsEnabled,
	      ProductGroup_id: ProductGroup_id
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function () {
	      dispatch(createCategorySuccess());
	      if (type !== 'productForm') {
	        _reactRouter.browserHistory.push('/products/categories');
	      }
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(createCategoryFailure(err));
	    });
	  };
	}
	
	function editCategorySuccess() {
	  return {
	    type: _type.EDIT_CATEGORY_SUCCESS
	  };
	}
	function editCategoryFailure(error) {
	  return {
	    type: _type.EDIT_CATEGORY_FAILURE,
	    payload: error
	  };
	}
	function editCategory(_ref8) {
	  var ProductCategory_id = _ref8.ProductCategory_id,
	      Name = _ref8.Name,
	      Description = _ref8.Description,
	      IsEnabled = _ref8.IsEnabled,
	      ProductGroup_id = _ref8.ProductGroup_id;
	
	  ProductGroup_id = ProductGroup_id.value || ProductGroup_id;
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EDITING_CATEGORY });
	    _axios2.default.put(_url.CATEGORIES_URL + ProductCategory_id, {
	      Name: Name,
	      Description: Description,
	      IsEnabled: IsEnabled,
	      ProductGroup_id: ProductGroup_id
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function () {
	      dispatch(editCategorySuccess());
	      _reactRouter.browserHistory.push('/products/categories'); // If editd succesfully, refresh the paymentTerm page.
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editCategoryFailure(err));
	    });
	  };
	}
	
	function editMultiCategoriesSuccess() {
	  return {
	    type: _type.EDIT_MULTI_CATEGORIES_SUCCESS
	  };
	}
	function editMultiCategoriesFailure(error) {
	  return {
	    type: _type.EDIT_MULTI_CATEGORIES_FAILURE,
	    payload: error
	  };
	}
	function editMultiCategories(editedCategoriess) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EDITING_MULTI_CATEGORIES });
	    _axios2.default.put(_url.CATEGORIES_URL, editedCategoriess, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function () {
	      dispatch(editMultiCategoriesSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editMultiCategoriesFailure(err));
	    });
	  };
	}
	
	function requestCategories2() {
	  return {
	    type: _type.REQUEST_CATEGORIES_2
	  };
	}
	function fetchCategories2Success(categories) {
	  return {
	    type: _type.FETCH_CATEGORIES_2_SUCCESS,
	    payload: categories
	  };
	}
	function fetchCategories2Failure(error) {
	  return {
	    type: _type.FETCH_CATEGORIES_2_FAILURE,
	    payload: error
	  };
	}
	function fetchCategories2() {
	  return function (dispatch) {
	    dispatch(requestCategories2());
	    return _axios2.default.get(_url.CATEGORIES_2_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchCategories2Success(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCategories2Failure(err));
	    });
	  };
	}
	
	function requestCategories2B2B() {
	  return {
	    type: _type.REQUEST_CATEGORIES_2_B2B
	  };
	}
	function fetchCategories2SuccessB2B(categories) {
	  return {
	    type: _type.FETCH_CATEGORIES_2_SUCCESS_B2B,
	    payload: categories
	  };
	}
	function fetchCategories2FailureB2B(error) {
	  return {
	    type: _type.FETCH_CATEGORIES_2_FAILURE_B2B,
	    payload: error
	  };
	}
	function fetchCategories2B2B() {
	  return function (dispatch) {
	    dispatch(requestCategories2B2B());
	    return _axios2.default.get(_url.CATEGORIES_2_B2B_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchCategories2SuccessB2B(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCategories2FailureB2B(err));
	    });
	  };
	}
	
	function editMultiCategories2Success() {
	  return {
	    type: _type.EDIT_MULTI_CATEGORIES_2_SUCCESS
	  };
	}
	function editMultiCategories2Failure(error) {
	  return {
	    type: _type.EDIT_MULTI_CATEGORIES_2_FAILURE,
	    payload: error
	  };
	}
	function editMultiCategories2(editedCategories) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EDITING_MULTI_CATEGORIES_2 });
	    _axios2.default.put(_url.CATEGORIES_2_URL, editedCategories, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function () {
	      dispatch(editMultiCategories2Success());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editMultiCategories2Failure(err));
	    });
	  };
	}
	
	function editMultiCategories2SuccessB2B() {
	  return {
	    type: _type.EDIT_MULTI_CATEGORIES_2_SUCCESS_B2B
	  };
	}
	function editMultiCategories2FailureB2B(error) {
	  return {
	    type: _type.EDIT_MULTI_CATEGORIES_2_FAILURE_B2B,
	    payload: error
	  };
	}
	function editMultiCategories2B2B(editedCategories) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EDITING_MULTI_CATEGORIES_2_B2B });
	    _axios2.default.put(_url.CATEGORIES_2_B2B_URL, editedCategories, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function () {
	      dispatch(editMultiCategories2SuccessB2B());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editMultiCategories2FailureB2B(err));
	    });
	  };
	}
	
	function deleteCategory2Success() {
	  return {
	    type: _type.DELETE_CATEGORY_2_SUCCESS
	  };
	}
	function deleteCategory2Failure(error) {
	  return {
	    type: _type.DELETE_CATEGORY_2_FAILURE,
	    payload: error
	  };
	}
	function deleteCategory2(id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_DELETE_CATEGORY_2 });
	    _axios2.default.delete(_url.CATEGORIES_2_URL + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function () {
	      dispatch(deleteCategory2Success());
	      dispatch(fetchCategories2());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(deleteCategory2Failure(err));
	    });
	  };
	}
	
	function deleteCategory2SuccessB2B() {
	  return {
	    type: _type.DELETE_CATEGORY_2_SUCCESS_B2B
	  };
	}
	function deleteCategory2FailureB2B(error) {
	  return {
	    type: _type.DELETE_CATEGORY_2_FAILURE_B2B,
	    payload: error
	  };
	}
	function deleteCategory2B2B(id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_DELETE_CATEGORY_2_B2B });
	    _axios2.default.delete(_url.CATEGORIES_2_B2B_URL + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function () {
	      dispatch(deleteCategory2SuccessB2B());
	      dispatch(fetchCategories2B2B());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(deleteCategory2FailureB2B(err));
	    });
	  };
	}
	
	function clearCategory2Status() {
	  return {
	    type: _type.CLEAR_CATEGORY_2_STATUS
	  };
	}
	
	function clearCategory2StatusB2B() {
	  return {
	    type: _type.CLEAR_CATEGORY_2_STATUS_B2B
	  };
	}
	
	// Product Types Actions
	function requestTypes() {
	  return {
	    type: _type.REQUEST_TYPES
	  };
	}
	function fetchTypesSuccess(types) {
	  return {
	    type: _type.FETCH_TYPES_SUCCESS,
	    payload: types
	  };
	}
	function fetchTypesFailure(error) {
	  return {
	    type: _type.FETCH_TYPES_FAILURE,
	    payload: error
	  };
	}
	function fetchTypes() {
	  return function (dispatch) {
	    dispatch(requestTypes());
	    return _axios2.default.get(_url.TYPES_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchTypesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchTypesFailure(err));
	    });
	  };
	}
	
	// Product Pricelevel Actions
	function requestPriceLevels() {
	  return {
	    type: _type.REQUEST_PRICELEVELS
	  };
	}
	function fetchPriceLevelsSuccess(priceLevels) {
	  return {
	    type: _type.FETCH_PRICELEVELS_SUCCESS,
	    payload: priceLevels
	  };
	}
	function fetchPriceLevelsFailure(error) {
	  return {
	    type: _type.FETCH_PRICELEVELS_FAILURE,
	    payload: error
	  };
	}
	function fetchPriceLevels(type, id) {
	  var query = '';
	  if (type !== 'All') {
	    query = '?' + type + '=' + id;
	  }
	  return function (dispatch) {
	    dispatch(requestPriceLevels());
	    return _axios2.default.get(_url.PRODUCTS_URL + 'pricelevel/' + query, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPriceLevelsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPriceLevelsFailure(err));
	    });
	  };
	}
	
	function editMultiPriceLevelsSuccess() {
	  return {
	    type: _type.EDIT_MULTI_PRICELEVELS_SUCCESS
	  };
	}
	function editMultiPriceLevelsFailure(error) {
	  return {
	    type: _type.EDIT_MULTI_PRICELEVELS_FAILURE,
	    payload: error
	  };
	}
	function editMultiPriceLevels(editedPriceLevels) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EDITING_MULTI_PRICELEVELS });
	    _axios2.default.put(_url.PRICELEVELS_URL, editedPriceLevels, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function () {
	      dispatch(editMultiPriceLevelsSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editMultiPriceLevelsFailure(err));
	    });
	  };
	}
	
	function fetchSimplifiedProductsSuccess(products) {
	  return {
	    type: _type.FETCH_SIMPLIFIED_PRODUCTS_SUCCESS,
	    payload: products
	  };
	}
	function fetchSimplifiedProductsFailure(error) {
	  return {
	    type: _type.FETCH_SIMPLIFIED_PRODUCTS_FAILURE,
	    payload: error
	  };
	}
	function fetchSimplifiedProducts(searchType, searchValue) {
	  var RESEARCH_URL = '';
	  if (searchType && searchValue) {
	    RESEARCH_URL = '?' + searchType + '=' + searchValue;
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SIMPLIFIED_PRODUCTS });
	    _axios2.default.get(_url.PRODUCTS_SIMPLIFIED_URL + RESEARCH_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSimplifiedProductsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSimplifiedProductsFailure(err));
	    });
	  };
	}
	
	function fetchGroupCategoriesSuccess(categories) {
	  return {
	    type: _type.FETCH_GROUP_CATEGORIES_SUCCESS,
	    payload: categories
	  };
	}
	
	function fetchGroupCategoriesFailure(error) {
	  return {
	    type: _type.FETCH_GROUP_CATEGORIES_FAILURE,
	    payload: error
	  };
	}
	function fetchGroupCategories(group_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_GROUP_CATEGORIES });
	    _axios2.default.get(_url.GROUPS_URL + 'categories/' + group_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchGroupCategoriesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchGroupCategoriesFailure(err));
	    });
	  };
	}
	
	function setValue(form, field, value) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)(form, field, value));
	  };
	}
	
	function fetchProductByNumSuccess(details) {
	  return {
	    type: _type.FETCH_PRODUCT_BY_NUM_SUCCESS,
	    payload: details
	  };
	}
	function fetchProductByNumFailure(error) {
	  return {
	    type: _type.FETCH_PRODUCT_BY_NUM_FAILURE,
	    payload: error
	  };
	}
	function fetchProductByNum(ProductNum, _ref9) {
	  var isHMM = _ref9.isHMM,
	      GeneralNumber = _ref9.GeneralNumber;
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PRODUCT_BY_NUM });
	    _axios2.default.get(_url.PRODUCTS_URL + 'search/?' + (isHMM ? 'GeneralNum' : 'ProductNum') + '=' + (isHMM ? GeneralNumber : ProductNum), {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchProductByNumSuccess(response));
	      dispatch(fetchProductDetail(response.data[0].Product_id));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchProductByNumFailure(err));
	    });
	  };
	}
	
	function fetchNextProduct(id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PRODUCT_BY_NUM });
	    _axios2.default.get(_url.PRODUCTS_URL + 'next/' + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchProductDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchProductDetailFailure(err));
	    });
	  };
	}
	
	function fetchNextProductWithGeno(GeneralNum) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PRODUCT_BY_NUM });
	    _axios2.default.get(_url.PRODUCTS_URL + 'nextGeneralNum/' + GeneralNum, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchProductDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchProductDetailFailure(err));
	    });
	  };
	}
	
	function fetchPreviousProduct(id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PRODUCT_BY_NUM });
	    _axios2.default.get(_url.PRODUCTS_URL + 'previous/' + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchProductDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchProductDetailFailure(err));
	    });
	  };
	}
	
	function fetchPreviousProductWithGeno(GeneralNum) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PRODUCT_BY_NUM });
	    _axios2.default.get(_url.PRODUCTS_URL + 'previousGeneralNum/' + GeneralNum, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchProductDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchProductDetailFailure(err));
	    });
	  };
	}
	
	function deleteCategorySuccess() {
	  return {
	    type: _type.DELETE_CATEGORY_SUCCESS
	  };
	}
	function deleteCategoryFailure(error) {
	  return {
	    type: _type.DELETE_CATEGORY_FAILURE,
	    payload: error
	  };
	}
	function deleteCategory(id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_DELETE_CATEGORY });
	    _axios2.default.delete(_url.CATEGORIES_URL + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function () {
	      dispatch(deleteCategorySuccess());
	      dispatch(fetchCategories());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(deleteCategoryFailure(err));
	    });
	  };
	}
	
	function clearDeleteCategoryStatus() {
	  return {
	    type: _type.CLEAR_CATEGORY_STATUS
	  };
	}
	
	// DELETE GROUP --- DELETE GROUP --- DELETE GROUP --- DELETE GROUP --- DELETE GROUP
	function deleteGroupSuccess() {
	  return {
	    type: _type.DELETE_PRODUCT_GROUP_SUCCESS
	  };
	}
	function deleteGroupFailure(error) {
	  return {
	    type: _type.DELETE_GROUP_FAILURE,
	    payload: error
	  };
	}
	function clearDeleteGroupStatus() {
	  return {
	    type: _type.CLEAR_GROUP_STATUS
	  };
	}
	function deleteGroup(id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_DELETE_GROUP });
	    _axios2.default.delete(_url.GROUPS_URL + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function () {
	      dispatch(deleteGroupSuccess());
	      dispatch(fetchGroups());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(deleteGroupFailure(err));
	    });
	  };
	}
	
	// FETCH
	function fetchSmallProductInfoSuccess(info) {
	  return {
	    type: _type.FETCH_SMALL_PRODUCT_INFO_SUCCESS,
	    payload: info
	  };
	}
	function fetchSmallProductInfoFailure(error) {
	  return {
	    type: _type.FETCH_SMALL_PRODUCT_INFO_FAILURE,
	    payload: error
	  };
	}
	function fetchSmallProductInfo(ProductNum) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SMALL_PRODUCT_INFO });
	    _axios2.default.get(_url.PRODUCTS_URL + 'search/?ProductNum=' + ProductNum, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSmallProductInfoSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSmallProductInfoFailure(err));
	    });
	  };
	}
	
	function clearSmallProdStatus() {
	  return {
	    type: _type.CLEAR_SMALL_PRODUCT
	  };
	}
	
	function fetchCRVValuesSuccess(values) {
	  return {
	    type: _type.FETCH_CRV_VALUES_SUCCESS,
	    payload: values
	  };
	}
	function fetchCRVValuesFailure(error) {
	  return {
	    type: _type.FETCH_CRV_VALUES_FAILURE,
	    payload: error
	  };
	}
	function fetchCRVValues() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CRV_VALUES });
	    _axios2.default.get(_url.PRODUCTS_URL + 'crv/', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchCRVValuesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCRVValuesFailure(err));
	    });
	  };
	}
	
	function fetchDefaultBuyersSuccess(data) {
	  return {
	    type: _type.REQUEST_DEFAULT_BUYERS_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchDefaultBuyersError(error) {
	  return {
	    type: _type.REQUEST_DEFAULT_BUYERS_FAILURE,
	    payload: error
	  };
	}
	
	function fetchDefaultBuyers() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_DEFAULT_BUYERS });
	    (0, _axios2.default)({
	      method: 'get',
	      url: _url.BASE_USER_URL + 'users/',
	      headers: {
	        Authorization: 'Bearer ' + localStorage.getItem('token')
	      }
	    }).then(function (response) {
	      dispatch(fetchDefaultBuyersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchDefaultBuyersError(err));
	    });
	  };
	}
	
	function attachProductImageSuccess() {
	  return {
	    type: _type.ATTACH_PRODUCT_IMAGE_SUCCESS
	  };
	}
	function attachProductImageFailure(error) {
	  return {
	    type: _type.ATTACH_PRODUCT_IMAGE_FAILURE,
	    payload: error
	  };
	}
	function attachProductImage(Product_id, img) {
	  return function (dispatch) {
	    dispatch({ type: _type.ATTACH_PRODUCT_IMAGE });
	    var data = new FormData();
	    data.append('Thumbnail', img);
	    return _axios2.default.post(_url.PRODUCTS_URL + 'image/' + Product_id, data, {
	      headers: {
	        Authorization: 'Bearer ' + localStorage.getItem('token')
	      }
	    }).then(function () {
	      dispatch(attachProductImageSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(attachProductImageFailure(err));
	    });
	  };
	}
	
	function clearAttachedProductImage() {
	  return {
	    type: _type.CLEAR_ATTACHED_PRODUCT_IMAGE
	  };
	}
	
	function saveCategory2Products(products, category2Id, handleSuccess, handleFailure) {
	  return (0, _axios2.default)({
	    method: 'put',
	    url: _url.PRODUCTS_URL + 'category2/' + category2Id + '/product',
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	    data: {
	      product_ids: products
	    }
	  }).then(function (response) {
	    handleSuccess(response);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	}
	
	function saveCategory2ProductsB2B(products, category2Id, handleSuccess, handleFailure) {
	  return (0, _axios2.default)({
	    method: 'put',
	    url: _url.PRODUCTS_URL + 'category2_b2b/' + category2Id + '/product',
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	    data: {
	      product_ids: products
	    }
	  }).then(function (response) {
	    handleSuccess(response);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	}
	
	function setCurrentProduct(Product_id) {
	  return {
	    type: _type.SET_CURRENT_PRODUCT,
	    payload: Product_id
	  };
	}
	
	function fetchRelatedProductsSuccess(data) {
	  return {
	    type: _type.FETCH_RELATED_PRODUCTS_SUCCESS,
	    payload: data
	  };
	}
	function fetchRelatedProductsFailure(error) {
	  return {
	    type: _type.FETCH_RELATED_PRODUCTS_FAILURE,
	    payload: error
	  };
	}
	function fetchRelatedProducts(ProductNum) {
	  return function (dispatch) {
	    dispatch({ type: _type.FETCH_RELATED_PRODUCTS });
	    _axios2.default.get(_url.INVENTORY_CONVERTS_URL + 'products/' + ProductNum, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchRelatedProductsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchRelatedProductsFailure(err));
	    });
	  };
	}
	
	function fetchSuggestedProdNumSuccess(data) {
	  return {
	    type: _type.FETCH_SUGGESTED_PROD_NUM_SUCCESS,
	    payload: data
	  };
	}
	function fetchSuggestedProdNumFailure(error) {
	  return {
	    type: _type.FETCH_SUGGESTED_PROD_NUM_FAILURE,
	    payload: error
	  };
	}
	function fetchSuggestedProdNum(ProductCategory_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.FETCH_SUGGESTED_PROD_NUM });
	    _axios2.default.get(_url.PRODUCTS_URL + 'suggestednum/' + ProductCategory_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSuggestedProdNumSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSuggestedProdNumFailure(err));
	    });
	  };
	}
	
	function fetchSuggestDigitSuccess(data) {
	  return {
	    type: _type.FETCH_SUGGEST_DIGIT_SUCCESS,
	    payload: data
	  };
	}
	function fetchSuggestDigitFailure(error) {
	  return {
	    type: _type.FETCH_SUGGEST_DIGIT_FAILURE,
	    payload: error
	  };
	}
	function fetchSuggestDigit(prodNum) {
	  return function (dispatch) {
	    dispatch({ type: _type.FETCH_SUGGEST_DIGIT });
	    _axios2.default.get(_url.PRODUCTS_URL + 'suggest/' + prodNum, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSuggestDigitSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSuggestDigitFailure(err));
	    });
	  };
	}
	
	function clearSuggestDigit() {
	  return {
	    type: _type.CLEAR_SUGGEST_DIGIT
	  };
	}
	
	function fetchPackageTypesSuccess(data) {
	  return {
	    type: _type.FETCH_PACKAGE_TYPES_SUCCESS,
	    payload: data
	  };
	}
	function fetchPackageTypesFailure(error) {
	  return {
	    type: _type.FETCH_PACKAGE_TYPES_FAILURE,
	    data: error
	  };
	}
	function fetchPackageTypes() {
	  return function (dispatch) {
	    dispatch({ type: _type.FETCH_PACKAGE_TYPES });
	    _axios2.default.get(_url.PRODUCTS_URL + 'packagetype/', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPackageTypesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPackageTypesFailure(err));
	    });
	  };
	}
	
	function editPackageTypeSuccess(data) {
	  return {
	    type: _type.EDIT_PACKAGE_TYPE_SUCCESS,
	    payload: data
	  };
	}
	function editPackageTypeFailure(error) {
	  return {
	    type: _type.EDIT_PACKAGE_TYPE_FAILURE,
	    payload: error
	  };
	}
	function editPackageType(packageTypes) {
	  return function (dispatch) {
	    dispatch({ type: _type.EDIT_PACKAGE_TYPE });
	    _axios2.default.post(_url.PRODUCTS_URL + 'packagetype/', packageTypes, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editPackageTypeSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editPackageTypeFailure(err));
	    });
	  };
	}
	
	function clearPackageTypeEdited() {
	  return {
	    type: _type.CLEAR_PACKAGE_TYPE_EDITED
	  };
	}
	
	function deletePackageTypeSuccess() {
	  return {
	    type: _type.DELETE_PACKAGE_TYPE_SUCCESS
	  };
	}
	function deletePackageTypeFailure(error) {
	  return {
	    type: _type.DELETE_PACKAGE_TYPE_FAILURE,
	    payload: error
	  };
	}
	function deletePackageType(id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_DELETE_PACKAGE_TYPE });
	    _axios2.default.delete(_url.PRODUCTS_URL + 'packagetype/' + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function () {
	      dispatch(fetchPackageTypes());
	      dispatch(deletePackageTypeSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(deletePackageTypeFailure(err));
	    });
	  };
	}
	
	function fetchMeasurementUnitSuccess(data) {
	  return {
	    type: _type.FETCH_MEASUREMENT_UNIT_SUCCESS,
	    payload: data
	  };
	}
	function fetchMeasurementUnitFailure(error) {
	  return {
	    type: _type.FETCH_MEASUREMENT_UNIT_FAILURE,
	    data: error
	  };
	}
	function fetchMeasurementUnit() {
	  return function (dispatch) {
	    dispatch({ type: _type.FETCH_MEASUREMENT_UNIT });
	    _axios2.default.get(_url.PRODUCTS_URL + 'measureunit/', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchMeasurementUnitSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchMeasurementUnitFailure(err));
	    });
	  };
	}
	
	function editMeasurementUnitSuccess(data) {
	  return {
	    type: _type.EDIT_MEASUREMENT_UNIT_SUCCESS,
	    payload: data
	  };
	}
	function editMeasurementUnitFailure(error) {
	  return {
	    type: _type.EDIT_MEASUREMENT_UNIT_FAILURE,
	    data: error
	  };
	}
	function editMeasurementUnit(measurementUnit) {
	  return function (dispatch) {
	    dispatch({ type: _type.EDIT_MEASUREMENT_UNIT });
	    _axios2.default.post(_url.PRODUCTS_URL + 'measureunit/', measurementUnit, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editMeasurementUnitSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editMeasurementUnitFailure(err));
	    });
	  };
	}
	
	function clearMeasurementUnitEdited() {
	  return {
	    type: _type.CLEAR_MEASUREMENT_UNIT_EDITED
	  };
	}
	
	function deleteMeasurementUnitSuccess() {
	  return {
	    type: _type.DELETE_MEASUREMENT_UNIT_SUCCESS
	  };
	}
	function deleteMeasurementUnitFailure(error) {
	  return {
	    type: _type.DELETE_MEASUREMENT_UNIT_FAILURE,
	    payload: error
	  };
	}
	function deleteMeasurementUnit(id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_DELETE_MEASUREMENT_UNIT });
	    _axios2.default.delete(_url.PRODUCTS_URL + 'measureunit/' + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function () {
	      dispatch(fetchMeasurementUnit());
	      dispatch(deleteMeasurementUnitSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(deleteMeasurementUnitFailure(err));
	    });
	  };
	}
	
	function fetchConvertableProductsSuccess(data) {
	  return {
	    type: _type.FETCH_CONVERTABLE_PRODUCTS_SUCCESS,
	    payload: data
	  };
	}
	function fetchConvertableProductsFailure(error) {
	  return {
	    type: _type.FETCH_CONVERTABLE_PRODUCTS_FAILURE,
	    data: error
	  };
	}
	function fetchConvertableProducts(pn, type) {
	  var createParam = void 0;
	  if (type === 'create') {
	    createParam = true;
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.FETCH_CONVERTABLE_PRODUCTS });
	    _axios2.default.get(_url.PRODUCTS_URL + 'convertable/' + pn, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      params: {
	        create: createParam
	      }
	    }).then(function (response) {
	      dispatch(fetchConvertableProductsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchConvertableProductsFailure(err));
	    });
	  };
	}
	
	function attachDocumentSuccess() {
	  return {
	    type: _type.ATTACH_DOCUMENT_SUCCESS
	  };
	}
	function attachDocumentFailure(error) {
	  return {
	    type: _type.ATTACH_DOCUMENT_FAILURE,
	    payload: error
	  };
	}
	function attachDocument(files) {
	  return function (dispatch) {
	    dispatch({ type: _type.ATTACH_DOCUMENT });
	    var data = new FormData();
	    data.append('file', files[0]);
	
	    return _axios2.default.post(_url.UPLOAD_URL + 'document/', data, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(attachDocumentSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(attachDocumentFailure(err));
	    });
	  };
	}
	
	function continueOrDiscontinueProductSuccess() {
	  return {
	    type: _type.CONTINUE_OR_DISCONTINUE_PRODUCT_SUCCESS
	  };
	}
	
	function continueOrDiscontinueProductError(error) {
	  return {
	    type: _type.CONTINUE_OR_DISCONTINUE_PRODUCT_FAILURE,
	    payload: error
	  };
	}
	
	function continueProduct(productId) {
	  return function (dispatch) {
	    dispatch({
	      type: _type.REQUEST_CONTINUE_OR_DISCONTINUE_PRODUCT
	    });
	    return (0, _axios2.default)({
	      method: 'PUT',
	      url: '' + _url.PRODUCTS_URL + productId + '/continue',
	      headers: {
	        Authorization: 'Bearer ' + localStorage.getItem('token')
	      }
	    }).then(function () {
	      dispatch(continueOrDiscontinueProductSuccess());
	    }, function (err) {
	      dispatch(continueOrDiscontinueProductError(err));
	    });
	  };
	}
	
	function discontinueProduct(productId) {
	  return function (dispatch) {
	    dispatch({
	      type: _type.REQUEST_CONTINUE_OR_DISCONTINUE_PRODUCT
	    });
	    return (0, _axios2.default)({
	      method: 'PUT',
	      url: '' + _url.PRODUCTS_URL + productId + '/discontinue',
	      headers: {
	        Authorization: 'Bearer ' + localStorage.getItem('token')
	      }
	    }).then(function () {
	      dispatch(continueOrDiscontinueProductSuccess());
	    }, function (err) {
	      dispatch(continueOrDiscontinueProductError(err));
	    });
	  };
	}
	
	function deleteProductSuccess() {
	  return {
	    type: _type.DELETE_PRODUCT_SUCCESS
	  };
	}
	function deleteProductError(error) {
	  return {
	    type: _type.DELETE_PRODUCT_FAILURE,
	    payload: error
	  };
	}
	function deleteProduct(productId) {
	  return function (dispatch) {
	    dispatch({
	      type: _type.DELETE_PRODUCT
	    });
	    return (0, _axios2.default)({
	      method: 'DELETE',
	      url: '' + _url.PRODUCTS_URL + productId,
	      headers: {
	        Authorization: 'Bearer ' + localStorage.getItem('token')
	      }
	    }).then(function () {
	      dispatch(deleteProductSuccess());
	    }, function (error) {
	      dispatch(deleteProductError(error));
	    });
	  };
	}
	
	function updateProductGroupSuccess() {
	  return {
	    type: _type.UPDATE_PRODUCT_SUCCEESS
	  };
	}
	function updateProductGroupFailure(error) {
	  return {
	    type: _type.UPDATE_PRODUCT_FAILURE,
	    payload: error
	  };
	}
	function updateProductGroup(productId, newProductNum) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_UPDATE_PRODUCT });
	    var token = localStorage.getItem('token');
	    return (0, _axios2.default)({
	      method: 'post',
	      url: _url.PRODUCTS_URL + 'new_product_num/' + productId,
	      headers: { Authorization: 'Bearer ' + token },
	      data: {
	        ProductNum: newProductNum
	      }
	    }).then(function () {
	      dispatch(updateProductGroupSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(updateProductGroupFailure(err));
	    });
	  };
	}
	
	function saveMobileDescriptionBoxTextSuccess(response) {
	  return {
	    type: _type.SAVE_MOBILE_DESCRIPTION_BOX_TEXT_SUCCESS,
	    payload: response
	  };
	}
	function saveMobileDescriptionBoxTextFailure(error) {
	  return {
	    type: _type.SAVE_MOBILE_DESCRIPTION_BOX_TEXT_FAILURE,
	    payload: error
	  };
	}
	
	/**
	  * Api call to save mobile description box text
	  *
	  * @param {Number} productId
	  * @param {String} mobileDescBoxText string of html
	  */
	function saveMobileDescriptionBoxText(productId, mobileDescBoxText) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SAVE_MOBILE_DESCRIPTION_BOX_TEXT });
	    var token = localStorage.getItem('token');
	    return (0, _axios2.default)({
	      method: 'put',
	      url: '' + _url.PRODUCTS_URL + productId + '/rich-text',
	      headers: { Authorization: 'Bearer ' + token },
	      data: {
	        rich_text_description: mobileDescBoxText
	      }
	    }).then(function (response) {
	      dispatch(saveMobileDescriptionBoxTextSuccess(response));
	    }, function (error) {
	      dispatch(saveMobileDescriptionBoxTextFailure(error));
	    });
	  };
	}
	
	/**
	  * Gets the previously saved description text
	  *
	  * @param {Number} productId
	  * @param {func} handleSuccess
	  * @param {func} handleFailure
	  */
	function fetchMobileDescriptionBoxText(productId, handleSuccess, handleFailure) {
	  var token = localStorage.getItem('token');
	  return (0, _axios2.default)({
	    method: 'get',
	    url: '' + _url.PRODUCTS_URL + productId + '/rich-text',
	    headers: { Authorization: 'Bearer ' + token }
	  }).then(function (response) {
	    handleSuccess(response);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	}
	
	/**
	  * Updates product images
	  *
	  * @param {Number} productId
	  * @param {func} handleSuccess
	  * @param {func} handleFailure
	  */
	var updateProductImages = exports.updateProductImages = function updateProductImages(productId, images, handleSuccess, handleFailure) {
	  var token = localStorage.getItem('token');
	  var config = {
	    method: 'put',
	    url: '' + _url.PRODUCTS_URL + productId + '/image',
	    data: {
	      Images: images
	    }
	  };
	  (0, _axios2.default)(_extends({}, config, {
	    headers: { Authorization: 'Bearer ' + token }
	  })).then(function (response) {
	    handleSuccess(response.data);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      // err.data = DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	};
	
	/**
	  * Gets previously set product images
	  *
	  * @param {Number} productId
	  * @param {func} handleSuccess
	  * @param {func} handleFailure
	  */
	var getProductImages = exports.getProductImages = function getProductImages(productId, handleSuccess, handleFailure) {
	  var token = localStorage.getItem('token');
	  var config = {
	    method: 'get',
	    url: '' + _url.PRODUCTS_URL + productId + '/image'
	  };
	  (0, _axios2.default)(_extends({}, config, {
	    headers: { Authorization: 'Bearer ' + token }
	  })).then(function (response) {
	    handleSuccess(response.data);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	};
	
	/**
	  * Delete previously saved image
	  *
	  * @param {Number} imageId
	  * @param {func} handleSuccess
	  * @param {func} handleFailure
	  */
	var deleteProductImages = exports.deleteProductImages = function deleteProductImages(imageId, handleSuccess, handleFailure) {
	  var token = localStorage.getItem('token');
	  var config = {
	    method: 'delete',
	    url: _url.PRODUCTS_URL + 'image/' + imageId
	  };
	  (0, _axios2.default)(_extends({}, config, {
	    headers: { Authorization: 'Bearer ' + token }
	  })).then(function (response) {
	    handleSuccess(response.data);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	};
	
	var saveCalculationType = exports.saveCalculationType = function saveCalculationType(type, handleSuccess, handleFailure) {
	  var token = localStorage.getItem('token');
	  var config = {
	    method: 'post',
	    url: ''
	  };
	  (0, _axios2.default)(_extends({}, config, {
	    headers: { Authorization: 'Bearer ' + token }
	  })).then(function (response) {
	    handleSuccess(response.data);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	};
	
	// Get Display Categories
	function requestDisplayCategories() {
	  return {
	    type: _type.REQUEST_DISPLAY_CATEGORIES
	  };
	}
	function fetchDisplayCategoriesSuccess(displayCategories) {
	  displayCategories = displayCategories.data;
	  return {
	    type: _type.FETCH_DISPLAY_CATEGORIES_SUCCESS,
	    payload: displayCategories
	  };
	}
	function fetchDisplayCategoriesFailure(error) {
	  return {
	    type: _type.FETCH_DISPLAY_CATEGORIES_FAILURE,
	    payload: error
	  };
	}
	function fetchDisplayCategories(product_id) {
	  return function (dispatch) {
	    dispatch(requestDisplayCategories());
	    return _axios2.default.get(_url.DISPLAY_CATEGORIES_URL + product_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchDisplayCategoriesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchDisplayCategoriesFailure(err));
	    });
	  };
	}
	
	// Post Display Categories
	function requestEditDisplayCategories() {
	  return {
	    type: _type.REQUEST_EDIT_DISPLAY_CATEGORIES
	  };
	}
	function editDisplayCategoriesSuccess(response) {
	  return {
	    type: _type.EDIT_DISPLAY_CATEGORIES_SUCCESS,
	    payload: response
	  };
	}
	function editDisplayCategoriesFailure(error) {
	  return {
	    type: _type.EDIT_DISPLAY_CATEGORIES_FAILURE,
	    payload: error
	  };
	}
	function editDisplayCategories(productId, outputCategories) {
	  return function (dispatch) {
	    dispatch(requestEditDisplayCategories());
	    _axios2.default.put('' + _url.DISPLAY_CATEGORIES_URL + productId, outputCategories, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editDisplayCategoriesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editDisplayCategoriesFailure(err));
	    });
	  };
	}
	
	// Products Quick Access
	function fetchQuickAccess(ProductNum, handleSuccess, handleFailure) {
	  return (0, _axios2.default)({
	    method: 'get',
	    url: _url.PRODUCTS_URL + 'search/?ProductNum=' + ProductNum,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (response) {
	    handleSuccess(response);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      alert("Server Error, please refresh. If problem persists, contact Administrator.");
	    }
	    if (err.status === 400) {
	      handleFailure(err);
	    }
	  });
	}
	
	function requestInitializeESL() {
	  return {
	    type: _type.REQUEST_INITIALIZE_ESL
	  };
	}
	function initializeESL(productId) {
	  return function (dispatch) {
	    dispatch(requestInitializeESL());
	    return (0, _axios2.default)({
	      method: 'put',
	      url: '' + _url.ESL_INITIALIZE + productId,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function requestDeleteESL() {
	  return {
	    type: _type.REQUEST_DELETE_ESL
	  };
	}
	function deleteESL(productId) {
	  return function (dispatch) {
	    dispatch(requestInitializeESL());
	    return (0, _axios2.default)({
	      method: 'delete',
	      url: '' + _url.ESL_DELETE + productId,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function requestFetchESLTemplate() {
	  return {
	    type: _type.REQUEST_FETCH_ESL_TEMPLATE
	  };
	}
	function fetchESLTemplate() {
	  return function (dispatch) {
	    dispatch(requestFetchESLTemplate());
	    return (0, _axios2.default)({
	      method: 'get',
	      url: '' + _url.ESL_GET_TEMPLATE,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function requestFetchESL() {
	  return {
	    type: _type.REQUEST_FETCH_ESL
	  };
	}
	function fetchESL(productId) {
	  return function (dispatch) {
	    dispatch(requestFetchESL());
	    return (0, _axios2.default)({
	      method: 'get',
	      url: '' + _url.ESL_SAVE,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function requestSaveESL() {
	  return {
	    type: _type.REQUEST_SAVE_ESL
	  };
	}
	function saveESL(productId, ESLCode, TemplateId, TemplateName) {
	  return function (dispatch) {
	    dispatch(requestSaveESL());
	    return (0, _axios2.default)({
	      method: 'post',
	      url: '' + _url.ESL_SAVE,
	      data: {
	        ProductId: productId,
	        ESLCode: ESLCode,
	        TemplateId: TemplateId,
	        TemplateName: TemplateName
	      },
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	var productUpload = exports.productUpload = function productUpload(file, success) {
	  (0, _axios2.default)({
	    method: 'POST',
	    data: file,
	    url: _root_url.ROOT_URL + 'v2/product/import-product',
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (response) {
	    success();
	  }, function (err) {
	    alert('error uploading product.');
	  });
	};
	
	function setRowsFilters(filters) {
	  return {
	    type: _type.SET_ROWS_FILTERS,
	    payload: filters
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestProducts, 'requestProducts', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductsSuccess, 'fetchProductsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductsFailure, 'fetchProductsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProducts, 'fetchProducts', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomers, 'fetchCustomers', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestProductsByGroup, 'requestProductsByGroup', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductsByGroupSuccess, 'fetchProductsByGroupSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductsByGroupFailure, 'fetchProductsByGroupFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductsByGroup, 'fetchProductsByGroup', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestProductsByCategory, 'requestProductsByCategory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductsByCategorySuccess, 'fetchProductsByCategorySuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductsByCategoryFailure, 'fetchProductsByCategoryFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductsByCategory, 'fetchProductsByCategory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestProductsByCategory2, 'requestProductsByCategory2', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductsByCategory2Success, 'fetchProductsByCategory2Success', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductsByCategory2Failure, 'fetchProductsByCategory2Failure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCategory2Products, 'fetchCategory2Products', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestProductsByCategory2B2B, 'requestProductsByCategory2B2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetCategory2Id, 'resetCategory2Id', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductsByCategory2SuccessB2B, 'fetchProductsByCategory2SuccessB2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductsByCategory2FailureB2B, 'fetchProductsByCategory2FailureB2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCategory2ProductsB2B, 'fetchCategory2ProductsB2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestProductsByVendor, 'requestProductsByVendor', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductsByVendorSuccess, 'fetchProductsByVendorSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductsByVendorFailure, 'fetchProductsByVendorFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductsByVendor, 'fetchProductsByVendor', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestProductInfo, 'requestProductInfo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductInfoSuccess, 'fetchProductInfoSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductInfoFailure, 'fetchProductInfoFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductInfo, 'fetchProductInfo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductInfo2, 'fetchProductInfo2', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(selectProduct, 'selectProduct', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetCurrentProduct, 'resetCurrentProduct', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(clearCurrentProduct, 'clearCurrentProduct', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(setGroupCategory, 'setGroupCategory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(reinitialize, 'reinitialize', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(createProduct, 'createProduct', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestCreatingProduct, 'requestCreatingProduct', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(createProductSuccess, 'createProductSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(createProductFailure, 'createProductFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(duplicateProduct, 'duplicateProduct', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editProductSuccess, 'editProductSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editProductFailure, 'editProductFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editProduct, 'editProduct', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiProductSuccess, 'editMultiProductSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiProductFailure, 'editMultiProductFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiProducts, 'editMultiProducts', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestProductDetail, 'requestProductDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductDetailSuccess, 'fetchProductDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductDetailFailure, 'fetchProductDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductDetail, 'fetchProductDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetGroupAndCategory, 'resetGroupAndCategory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestGroups, 'requestGroups', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchGroupsSuccess, 'fetchGroupsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchGroupsFailure, 'fetchGroupsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchGroups, 'fetchGroups', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchGroupsElegant, 'fetchGroupsElegant', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(selectGroup, 'selectGroup', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetCurrentGroup, 'resetCurrentGroup', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(createGroupSuccess, 'createGroupSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(createGroupFailure, 'createGroupFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(createGroup, 'createGroup', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editGroupSuccess, 'editGroupSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editGroupFailure, 'editGroupFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editGroup, 'editGroup', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiGroupsSuccess, 'editMultiGroupsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiGroupsFailure, 'editMultiGroupsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiGroups, 'editMultiGroups', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiGroupsElegant, 'editMultiGroupsElegant', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestCategories, 'requestCategories', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCategoriesSuccess, 'fetchCategoriesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCategoriesFailure, 'fetchCategoriesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCategories, 'fetchCategories', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetCategory, 'resetCategory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(selectCategory, 'selectCategory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(selectCategoryB2B, 'selectCategoryB2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetCurrentCategory, 'resetCurrentCategory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetCurrentCategoryB2B, 'resetCurrentCategoryB2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestCreatingCategory, 'requestCreatingCategory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(createCategorySuccess, 'createCategorySuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(createCategoryFailure, 'createCategoryFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(createCategory, 'createCategory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editCategorySuccess, 'editCategorySuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editCategoryFailure, 'editCategoryFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editCategory, 'editCategory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiCategoriesSuccess, 'editMultiCategoriesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiCategoriesFailure, 'editMultiCategoriesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiCategories, 'editMultiCategories', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestCategories2, 'requestCategories2', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCategories2Success, 'fetchCategories2Success', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCategories2Failure, 'fetchCategories2Failure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCategories2, 'fetchCategories2', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestCategories2B2B, 'requestCategories2B2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCategories2SuccessB2B, 'fetchCategories2SuccessB2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCategories2FailureB2B, 'fetchCategories2FailureB2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCategories2B2B, 'fetchCategories2B2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiCategories2Success, 'editMultiCategories2Success', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiCategories2Failure, 'editMultiCategories2Failure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiCategories2, 'editMultiCategories2', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiCategories2SuccessB2B, 'editMultiCategories2SuccessB2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiCategories2FailureB2B, 'editMultiCategories2FailureB2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiCategories2B2B, 'editMultiCategories2B2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteCategory2Success, 'deleteCategory2Success', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteCategory2Failure, 'deleteCategory2Failure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteCategory2, 'deleteCategory2', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteCategory2SuccessB2B, 'deleteCategory2SuccessB2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteCategory2FailureB2B, 'deleteCategory2FailureB2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteCategory2B2B, 'deleteCategory2B2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(clearCategory2Status, 'clearCategory2Status', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(clearCategory2StatusB2B, 'clearCategory2StatusB2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestTypes, 'requestTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchTypesSuccess, 'fetchTypesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchTypesFailure, 'fetchTypesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchTypes, 'fetchTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestPriceLevels, 'requestPriceLevels', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPriceLevelsSuccess, 'fetchPriceLevelsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPriceLevelsFailure, 'fetchPriceLevelsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPriceLevels, 'fetchPriceLevels', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiPriceLevelsSuccess, 'editMultiPriceLevelsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiPriceLevelsFailure, 'editMultiPriceLevelsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMultiPriceLevels, 'editMultiPriceLevels', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSimplifiedProductsSuccess, 'fetchSimplifiedProductsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSimplifiedProductsFailure, 'fetchSimplifiedProductsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSimplifiedProducts, 'fetchSimplifiedProducts', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchGroupCategoriesSuccess, 'fetchGroupCategoriesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchGroupCategoriesFailure, 'fetchGroupCategoriesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchGroupCategories, 'fetchGroupCategories', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(setValue, 'setValue', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductByNumSuccess, 'fetchProductByNumSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductByNumFailure, 'fetchProductByNumFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductByNum, 'fetchProductByNum', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchNextProduct, 'fetchNextProduct', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchNextProductWithGeno, 'fetchNextProductWithGeno', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPreviousProduct, 'fetchPreviousProduct', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPreviousProductWithGeno, 'fetchPreviousProductWithGeno', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteCategorySuccess, 'deleteCategorySuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteCategoryFailure, 'deleteCategoryFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteCategory, 'deleteCategory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(clearDeleteCategoryStatus, 'clearDeleteCategoryStatus', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteGroupSuccess, 'deleteGroupSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteGroupFailure, 'deleteGroupFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(clearDeleteGroupStatus, 'clearDeleteGroupStatus', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteGroup, 'deleteGroup', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSmallProductInfoSuccess, 'fetchSmallProductInfoSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSmallProductInfoFailure, 'fetchSmallProductInfoFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSmallProductInfo, 'fetchSmallProductInfo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(clearSmallProdStatus, 'clearSmallProdStatus', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCRVValuesSuccess, 'fetchCRVValuesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCRVValuesFailure, 'fetchCRVValuesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCRVValues, 'fetchCRVValues', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchDefaultBuyersSuccess, 'fetchDefaultBuyersSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchDefaultBuyersError, 'fetchDefaultBuyersError', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchDefaultBuyers, 'fetchDefaultBuyers', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(attachProductImageSuccess, 'attachProductImageSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(attachProductImageFailure, 'attachProductImageFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(attachProductImage, 'attachProductImage', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(clearAttachedProductImage, 'clearAttachedProductImage', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(saveCategory2Products, 'saveCategory2Products', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(saveCategory2ProductsB2B, 'saveCategory2ProductsB2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(setCurrentProduct, 'setCurrentProduct', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchRelatedProductsSuccess, 'fetchRelatedProductsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchRelatedProductsFailure, 'fetchRelatedProductsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchRelatedProducts, 'fetchRelatedProducts', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSuggestedProdNumSuccess, 'fetchSuggestedProdNumSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSuggestedProdNumFailure, 'fetchSuggestedProdNumFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSuggestedProdNum, 'fetchSuggestedProdNum', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSuggestDigitSuccess, 'fetchSuggestDigitSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSuggestDigitFailure, 'fetchSuggestDigitFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSuggestDigit, 'fetchSuggestDigit', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(clearSuggestDigit, 'clearSuggestDigit', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPackageTypesSuccess, 'fetchPackageTypesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPackageTypesFailure, 'fetchPackageTypesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPackageTypes, 'fetchPackageTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editPackageTypeSuccess, 'editPackageTypeSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editPackageTypeFailure, 'editPackageTypeFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editPackageType, 'editPackageType', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(clearPackageTypeEdited, 'clearPackageTypeEdited', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deletePackageTypeSuccess, 'deletePackageTypeSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deletePackageTypeFailure, 'deletePackageTypeFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deletePackageType, 'deletePackageType', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchMeasurementUnitSuccess, 'fetchMeasurementUnitSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchMeasurementUnitFailure, 'fetchMeasurementUnitFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchMeasurementUnit, 'fetchMeasurementUnit', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMeasurementUnitSuccess, 'editMeasurementUnitSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMeasurementUnitFailure, 'editMeasurementUnitFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editMeasurementUnit, 'editMeasurementUnit', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(clearMeasurementUnitEdited, 'clearMeasurementUnitEdited', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteMeasurementUnitSuccess, 'deleteMeasurementUnitSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteMeasurementUnitFailure, 'deleteMeasurementUnitFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteMeasurementUnit, 'deleteMeasurementUnit', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchConvertableProductsSuccess, 'fetchConvertableProductsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchConvertableProductsFailure, 'fetchConvertableProductsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchConvertableProducts, 'fetchConvertableProducts', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(attachDocumentSuccess, 'attachDocumentSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(attachDocumentFailure, 'attachDocumentFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(attachDocument, 'attachDocument', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(continueOrDiscontinueProductSuccess, 'continueOrDiscontinueProductSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(continueOrDiscontinueProductError, 'continueOrDiscontinueProductError', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(continueProduct, 'continueProduct', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(discontinueProduct, 'discontinueProduct', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteProductSuccess, 'deleteProductSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteProductError, 'deleteProductError', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteProduct, 'deleteProduct', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(updateProductGroupSuccess, 'updateProductGroupSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(updateProductGroupFailure, 'updateProductGroupFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(updateProductGroup, 'updateProductGroup', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(saveMobileDescriptionBoxTextSuccess, 'saveMobileDescriptionBoxTextSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(saveMobileDescriptionBoxTextFailure, 'saveMobileDescriptionBoxTextFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(saveMobileDescriptionBoxText, 'saveMobileDescriptionBoxText', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchMobileDescriptionBoxText, 'fetchMobileDescriptionBoxText', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(updateProductImages, 'updateProductImages', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(getProductImages, 'getProductImages', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteProductImages, 'deleteProductImages', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(saveCalculationType, 'saveCalculationType', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestDisplayCategories, 'requestDisplayCategories', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchDisplayCategoriesSuccess, 'fetchDisplayCategoriesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchDisplayCategoriesFailure, 'fetchDisplayCategoriesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchDisplayCategories, 'fetchDisplayCategories', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestEditDisplayCategories, 'requestEditDisplayCategories', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editDisplayCategoriesSuccess, 'editDisplayCategoriesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editDisplayCategoriesFailure, 'editDisplayCategoriesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(editDisplayCategories, 'editDisplayCategories', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchQuickAccess, 'fetchQuickAccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestInitializeESL, 'requestInitializeESL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(initializeESL, 'initializeESL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestDeleteESL, 'requestDeleteESL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteESL, 'deleteESL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestFetchESLTemplate, 'requestFetchESLTemplate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchESLTemplate, 'fetchESLTemplate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestFetchESL, 'requestFetchESL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchESL, 'fetchESL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestSaveESL, 'requestSaveESL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(saveESL, 'saveESL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(productUpload, 'productUpload', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(setRowsFilters, 'setRowsFilters', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(isHMM, 'isHMM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(isAPO, 'isAPO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(isATL, 'isATL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(isAFM, 'isAFM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(isUSPride, 'isUSPride', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(isTN, 'isTN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(isRS, 'isRS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	
	  __REACT_HOT_LOADER__.register(isNumeric, 'isNumeric', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/products_actions.js');
	}();

	;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _numberWithCommas = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CashFormatter = function (_Component) {
	  _inherits(CashFormatter, _Component);
	
	  function CashFormatter() {
	    _classCallCheck(this, CashFormatter);
	
	    return _possibleConstructorReturn(this, (CashFormatter.__proto__ || Object.getPrototypeOf(CashFormatter)).apply(this, arguments));
	  }
	
	  _createClass(CashFormatter, [{
	    key: 'render',
	    value: function render() {
	      var value = this.props.value;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        value !== null && !isNaN(value) && '$' + (0, _numberWithCommas.numberWithCommas)(value)
	      );
	    }
	  }]);
	
	  return CashFormatter;
	}(_react.Component);
	
	var _default = CashFormatter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CashFormatter, 'CashFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/cashFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/cashFormatter.jsx');
	}();

	;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConfirmActionModal = function (_Component) {
	  _inherits(ConfirmActionModal, _Component);
	
	  function ConfirmActionModal() {
	    _classCallCheck(this, ConfirmActionModal);
	
	    var _this = _possibleConstructorReturn(this, (ConfirmActionModal.__proto__ || Object.getPrototypeOf(ConfirmActionModal)).call(this));
	
	    _this.state = {};
	    _this.caseAction = _this.caseAction.bind(_this);
	    return _this;
	  }
	
	  _createClass(ConfirmActionModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {}
	  }, {
	    key: 'caseAction',
	    value: function caseAction() {
	      switch (this.props.case) {
	        case 'removeItem':
	          this.props.removeItem(this.props.index);
	        case 'clearForm':
	          this.props.clearForm();
	      }
	      this.props.closeC();
	    }
	  }, {
	    key: 'renderPrompt',
	    value: function renderPrompt() {
	      switch (this.props.case) {
	        case 'confirmProductRepeat':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'duplicate_product_promotion' })
	          );
	        case 'convertUneven':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'products_do_not_convert_evenly' })
	          );
	        case 'removeItem':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Are_you_sure_you_want_to_remove_item?' })
	          );
	        case 'clearForm':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Are_you_sure_you_want_to_clear_order?' })
	          );
	        case 'noPermission':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'You_do_not_have_permission' })
	          );
	        case 'itemOutOfStock':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Item_is_out_of_stock' })
	          );
	        case 'itemAlreadyInOrder':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_item_already_in_sales_order' })
	          );
	        case 'addingDuplicate':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'h4',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_add_duplicate_item' })
	            )
	          );
	        case 'completeSheet':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'are_you_sure_you_want_to_complete_this_sheet?' }),
	            '\xA0',
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'you_will_not_be_able_to_create_new_receivings_after' })
	          );
	        case 'quantityZero':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'value_has_been_left_0_Continue' })
	          );
	        case 'noCustomerChosen':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_choose_customer_first' })
	          );
	        case 'zeroQuantity':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity_cannot_have_a_zero_value' })
	            ),
	            this.props.zeroArray.map(function (obj) {
	              return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 6, xsOffset: 3, className: 'centerStyle' },
	                  obj.Name
	                )
	              );
	            })
	          );
	        case 'zeroWeight':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight(s)_cannot_have_a_zero_value' })
	            )
	          );
	        case 'belowRefPrice':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'your_current_sale_price_is_below_lowest_sale_price' })
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'the_reference_is' }),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'warning' },
	                this.props.rowEdited.LowestSalePrice
	              )
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'your_current_sale_price_is' }),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'warning' },
	                this.props.newPrice
	              )
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'want_to_sale_at_current_price' }),
	              '?'
	            )
	          );
	        case 'belowLowestSalePrice':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'your_current_sale_price_is_below_lowest_sale_price' })
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'the_lowest_sale_price_is' }),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'warning' },
	                this.props.lowestSalePrice
	              )
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'your_current_sale_price_is' }),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'warning' },
	                this.props.currentPrice
	              )
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'want_to_sale_at_current_price' }),
	              '?'
	            )
	          );
	        case 'belowLowestSalePriceAndDuplicate':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_add_duplicate_item' })
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'your_current_sale_price_is_below_lowest_sale_price' })
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'the_lowest_sale_price_is' }),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'warning' },
	                this.props.lowestSalePrice
	              )
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'your_current_sale_price_is' }),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'warning' },
	                this.props.currentPrice
	              )
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'want_to_sale_at_current_price' }),
	              '?'
	            )
	          );
	        case 'confirmPassword':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'type_in_your_password' })
	            )
	          );
	        case 'editSOPermission':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_ask_for_manager_login' })
	            )
	          );
	        case 'editRecPermission':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_ask_for_manager_login' })
	            )
	          );
	        case 'editDeliveryFeeRate':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_ask_for_manager_login' })
	            )
	          );
	        case 'voidStatus':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              this.props.apNum ? _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: this.props.voidStatus }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  this.props.apNum
	                ),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: this.props.voidStatusEnd })
	              ) : _react2.default.createElement(_reactReduxI18n.Translate, { value: this.props.voidStatus })
	            )
	          );
	        case 'chooseGroup':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_choose_customers_group' })
	            )
	          );
	        case 'chooseTimePeriod':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_choose_start_date_and_end_date' })
	            )
	          );
	        case 'chooseItemTwo':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_choose_item_b' })
	            )
	          );
	        case 'chooseItemOne':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_choose_an_item_for_promotion' })
	            )
	          );
	        case 'zerototalPrice':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_price_cannot_be_zero' })
	          );
	        case 'paymentTermMissing':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_payment_term_first' })
	          );
	        case 'confirmRefund':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_confirm_refund_order' })
	          );
	        case 'deleteGroup':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_confirm_delete' })
	          );
	        case 'addCustToGroup':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_confirm_add_customer_to_group' })
	          );
	        case 'groupChange':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_confirm_change_group_without_save_products' })
	          );
	        case 'chooseProduct':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'you_must_select_an_item' })
	          );
	        default:
	          return this.props.case || null;
	      }
	    }
	  }, {
	    key: 'renderButtons',
	    value: function renderButtons() {
	      var _this2 = this;
	
	      switch (this.props.case) {
	        case 'noPermission':
	        case 'itemOutOfStock':
	        case 'itemAlreadyInOrder':
	        case 'noCustomerChosen':
	        case 'zeroQuantity':
	        case 'zeroWeight':
	        case 'quantityZero':
	        case 'convertUneven':
	        case 'chooseGroup':
	        case 'chooseTimePeriod':
	        case 'chooseItemTwo':
	        case 'chooseItemOne':
	        case 'zerototalPrice':
	        case 'chooseProduct':
	          return _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsStyle: 'primary', className: 'mt mr', onClick: this.props.closeC },
	            _react2.default.createElement('em', { className: 'fa fa-check' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Confirm' })
	          );
	        case 'confirmPassword':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-4 col-xs-offset-4' },
	              _react2.default.createElement(_reactBootstrap.Input, { type: 'password', ref: function ref(input) {
	                  return _this2.input = input;
	                } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-1 col-xs-offset-5', style: { marginTop: '50px' } },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'primary', className: 'mt mr', onClick: function onClick() {
	                    _this2.props.closeC(_this2.input.refs.input.value);
	                  } },
	                _react2.default.createElement('em', { className: 'fa fa-check' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Confirm' })
	              )
	            )
	          );
	        case 'editSOPermission':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-4 col-xs-offset-4' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'username' })
	              ),
	              _react2.default.createElement(_reactBootstrap.Input, { type: 'text', ref: function ref(input) {
	                  return _this2.inputText = input;
	                } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-4 col-xs-offset-4' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'password' })
	              ),
	              _react2.default.createElement(_reactBootstrap.Input, { type: 'password', ref: function ref(input) {
	                  return _this2.inputPassword = input;
	                } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-1 col-xs-offset-5' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'primary', className: 'mt mr', onClick: function onClick() {
	                    _this2.props.checkPermission(_this2.inputText.refs.input.value, _this2.inputPassword.refs.input.value);
	                  } },
	                _react2.default.createElement('em', { className: 'fa fa-check' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	              )
	            )
	          );
	        case 'editRecPermission':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-4 col-xs-offset-4' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'username' })
	              ),
	              _react2.default.createElement(_reactBootstrap.Input, { type: 'text', ref: function ref(input) {
	                  return _this2.inputText = input;
	                } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-4 col-xs-offset-4' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'password' })
	              ),
	              _react2.default.createElement(_reactBootstrap.Input, { type: 'password', ref: function ref(input) {
	                  return _this2.inputPassword = input;
	                } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-1 col-xs-offset-5' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'primary', className: 'mt mr', onClick: function onClick() {
	                    _this2.props.checkPermission(_this2.inputText.refs.input.value, _this2.inputPassword.refs.input.value);
	                  } },
	                _react2.default.createElement('em', { className: 'fa fa-check' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm' })
	              )
	            )
	          );
	        case 'editDeliveryFeeRate':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-4 col-xs-offset-4' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'username' })
	              ),
	              _react2.default.createElement(_reactBootstrap.Input, { type: 'text', ref: function ref(input) {
	                  return _this2.inputText = input;
	                } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-4 col-xs-offset-4' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'password' })
	              ),
	              _react2.default.createElement(_reactBootstrap.Input, { type: 'password', ref: function ref(input) {
	                  return _this2.inputPassword = input;
	                } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-1 col-xs-offset-5' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'primary', className: 'mt mr', onClick: function onClick() {
	                    _this2.props.checkPermission(_this2.inputText.refs.input.value, _this2.inputPassword.refs.input.value);
	                  } },
	                _react2.default.createElement('em', { className: 'fa fa-check' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm' })
	              )
	            )
	          );
	        case 'addingDuplicate':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'primary', className: 'mt mr', onClick: function onClick() {
	                  _this2.props.caseAction();_this2.props.closeC();
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'continue' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'danger', className: 'mt mr', onClick: function onClick() {
	                  _this2.props.closeC();
	                } },
	              _react2.default.createElement('em', { className: 'fa fa-close' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	            )
	          );
	        case 'voidStatus':
	          return _react2.default.createElement('span', null);
	        case 'completeSheet':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'primary', className: 'mt mr', onClick: function onClick() {
	                  _this2.props.caseAction(_this2.props.formProps);
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Confirm' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'danger', className: 'mt mr', onClick: function onClick() {
	                  _this2.props.closeC();
	                } },
	              _react2.default.createElement('em', { className: 'fa fa-close' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Cancel' })
	            )
	          );
	        case 'paymentTermMissing':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'primary', className: 'mt mr', onClick: function onClick() {
	                  _this2.props.closeC();
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Confirm' })
	            )
	          );
	        case 'confirmRefund':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'primary', className: 'mt mr', onClick: function onClick() {
	                  _this2.props.handleRefundConfirm();_this2.props.closeConfirmRefund();
	                } },
	              _react2.default.createElement('em', { className: 'fa fa-check' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Confirm' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'danger', className: 'mt mr', onClick: function onClick() {
	                  _this2.props.closeConfirmRefund();
	                } },
	              _react2.default.createElement('em', { className: 'fa fa-close' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Cancel' })
	            )
	          );
	        case 'belowRefPrice':
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'primary', className: 'mt mr', onClick: function onClick() {
	                  _this2.props.updatePrice();_this2.props.closeC();
	                } },
	              _react2.default.createElement('em', { className: 'fa fa-check' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Confirm' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'danger', className: 'mt mr', onClick: function onClick() {
	                  _this2.props.closeC();
	                } },
	              _react2.default.createElement('em', { className: 'fa fa-close' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Cancel' })
	            )
	          );
	        default:
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'primary', className: 'mt mr', onClick: function onClick() {
	                  _this2.props.caseAction();_this2.props.closeC();
	                } },
	              _react2.default.createElement('em', { className: 'fa fa-check' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Confirm' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'danger', className: 'mt mr', onClick: function onClick() {
	                  _this2.props.closeC();
	                } },
	              _react2.default.createElement('em', { className: 'fa fa-close' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Cancel' })
	            )
	          );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          closeC = _props.closeC,
	          checkPasswordFailure = _props.checkPasswordFailure,
	          checkPermissionSuccess = _props.checkPermissionSuccess;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12, className: 'text-center', style: { marginTop: '20px' } },
	            this.renderPrompt()
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12, className: 'text-center' },
	            this.renderButtons()
	          )
	        ),
	        _react2.default.createElement('br', null),
	        checkPasswordFailure && _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'text-center alert alert-danger' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'your_password_is_not_correct' })
	        ),
	        checkPermissionSuccess && !checkPermissionSuccess.manager && _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'text-center alert alert-danger' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no_permission' })
	        )
	      );
	    }
	  }]);
	
	  return ConfirmActionModal;
	}(_react.Component);
	
	ConfirmActionModal.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = ConfirmActionModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ConfirmActionModal, 'ConfirmActionModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/confirmActionModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/confirmActionModal.jsx');
	}();

	;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchBaseUsers = fetchBaseUsers;
	exports.fetchBusinessUsersAPI = fetchBusinessUsersAPI;
	exports.setSelectedBusinessUser = setSelectedBusinessUser;
	exports.handleEditUserConfirm = handleEditUserConfirm;
	exports.verifyBusinessUser = verifyBusinessUser;
	exports.requestBaseUsers = requestBaseUsers;
	exports.fetchBaseUsersSuccess = fetchBaseUsersSuccess;
	exports.fetchBaseUsersFailure = fetchBaseUsersFailure;
	exports.fetchMobileUsers = fetchMobileUsers;
	exports.fetchUserDetail = fetchUserDetail;
	exports.fetchUserDetailSuccess = fetchUserDetailSuccess;
	exports.fetchUserDetailFailure = fetchUserDetailFailure;
	exports.selectCurrentUser = selectCurrentUser;
	exports.resetCurrentUser = resetCurrentUser;
	exports.fetchGroups = fetchGroups;
	exports.fetchProductAllGroups = fetchProductAllGroups;
	exports.fetchProductAllGroupsSuccess = fetchProductAllGroupsSuccess;
	exports.fetchGroupsSuccess = fetchGroupsSuccess;
	exports.fetchGroupsFailure = fetchGroupsFailure;
	exports.fetchGroupDetail = fetchGroupDetail;
	exports.fetchGroupDetailSuccess = fetchGroupDetailSuccess;
	exports.fetchGroupDetailFailure = fetchGroupDetailFailure;
	exports.selectCurrentGroup = selectCurrentGroup;
	exports.resetCurrentGroup = resetCurrentGroup;
	exports.fetchPermissions = fetchPermissions;
	exports.fetchPermissionsSuccess = fetchPermissionsSuccess;
	exports.fetchPermissionsFailure = fetchPermissionsFailure;
	exports.resetUserDetail = resetUserDetail;
	exports.editUserPermission = editUserPermission;
	exports.createUserDetail = createUserDetail;
	exports.createUserDetailSuccess = createUserDetailSuccess;
	exports.createUserDetailFailure = createUserDetailFailure;
	exports.editUserDetail = editUserDetail;
	exports.editUserDetailSuccess = editUserDetailSuccess;
	exports.editUserDetailFailure = editUserDetailFailure;
	exports.editPassword = editPassword;
	exports.editPasswordSuccess = editPasswordSuccess;
	exports.editPasswordFailure = editPasswordFailure;
	exports.editGroupDetail = editGroupDetail;
	exports.editGroupDetailSuccess = editGroupDetailSuccess;
	exports.editGroupDetailFailure = editGroupDetailFailure;
	exports.createGroupDetail = createGroupDetail;
	exports.createGroupDetailSuccess = createGroupDetailSuccess;
	exports.createGroupDetailFailure = createGroupDetailFailure;
	exports.resetPassword = resetPassword;
	exports.checkPassword = checkPassword;
	exports.clearCheckPassword = clearCheckPassword;
	exports.checkPermission = checkPermission;
	exports.fetchActionLog = fetchActionLog;
	exports.fetchActionLogByFilter = fetchActionLogByFilter;
	exports.fetchActionLogByFilterSuccess = fetchActionLogByFilterSuccess;
	exports.fetchActionLogByFilterFailure = fetchActionLogByFilterFailure;
	exports.grabMobileUserID = grabMobileUserID;
	exports.fetchUsername = fetchUsername;
	exports.requestUsername = requestUsername;
	exports.requestUsernameSuccess = requestUsernameSuccess;
	exports.requestUsernameFailure = requestUsernameFailure;
	exports.clearUsernameData = clearUsernameData;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _root_url = __webpack_require__(9);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchBaseUsers() {
	  return function (dispatch) {
	    dispatch(requestBaseUsers());
	    return _axios2.default.get(_url.BASE_USER_URL + 'users/',
	    // return axios.post(ROOT_URL + 'v1/dashboard/salescsv', {},
	    {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchBaseUsersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchBaseUsersFailure(err));
	    });
	  };
	}
	
	function fetchBusinessUsersAPI(params, cb) {
	  //serving a feature of Ecity only
	  //fetching business users
	  var generateParams = params ? {
	    update_time__gt: params.fromDate, update_time__lt: params.toDate
	  } : {};
	  _axios2.default.get(_url.BUSINESS_USERS_URL, {
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	    params: generateParams
	  }).then(function (res) {
	    cb({ businessUsersTable: {
	        rows: res.data
	      } });
	  }).catch(function (err) {});
	}
	
	function setSelectedBusinessUser(selectedUser) {
	  //associates with Ecity business user feature
	  return function (dispatch) {
	    dispatch({
	      type: _type.SET_SELECTED_BUSINESSUSER,
	      payload: selectedUser
	    });
	  };
	}
	
	function handleEditUserConfirm(userDetail) {
	  //serves business user feature of Ecity
	
	
	  if (userDetail.is_process && userDetail.is_process.value) {
	    userDetail.is_process = userDetail.is_process.value;
	  }
	  if (userDetail.gender && userDetail.gender.value) {
	    userDetail.gender = userDetail.gender.value;
	  }
	  if (userDetail.is_retailer && userDetail.is_retailer.value) {
	    userDetail.is_retailer = userDetail.is_retailer.value;
	  }
	  if (userDetail.business_type && userDetail.business_type.value) {
	    userDetail.business_type = userDetail.business_type.value;
	  }
	  if (userDetail.customer_group_id && userDetail.customer_group_id.value) {
	    userDetail.customer_group_id = userDetail.customer_group_id.value;
	  } else {
	    userDetail.customer_group_id = null;
	  }
	
	  var cleanData = _extends({}, userDetail);
	  var config = {
	    url: '' + _url.BUSINESS_USERS_URL + userDetail.user_id,
	    data: cleanData,
	    method: 'PUT',
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  };
	  return (0, _axios2.default)(config);
	}
	
	function verifyBusinessUser(userDetail) {
	  //serves business user feature of Ecity
	  var config = {
	    url: '' + _url.BUSINESS_USER_CONVERT + userDetail.user_id,
	    method: 'POST',
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  };
	  return (0, _axios2.default)(config);
	}
	
	function requestBaseUsers() {
	  return {
	    type: _type.REQUEST_BASE_USER
	  };
	}
	
	function fetchBaseUsersSuccess(baseUsers) {
	  return {
	    type: _type.FETCH_BASE_USER_SUCCESS,
	    payload: baseUsers
	  };
	}
	
	function fetchBaseUsersFailure(error) {
	  return {
	    type: _type.FETCH_BASE_USER_FAILURE,
	    payload: error
	  };
	}
	
	function fetchMobileUsersSuccess(response) {
	  return {
	    type: _type.FETCH_MOBILE_USERS_SUCCESS,
	    payload: response
	  };
	}
	
	function fetchMobileUsersFailure(error) {
	  return {
	    type: _type.FETCH_MOBILE_USERS_FAILURE,
	    payload: error
	  };
	}
	
	function fetchMobileUsers(currentPage, limit, customerNo, firstName, lastName, email, phone, active) {
	  if (!limit) {
	    limit = 'all';
	  }
	  currentPage = currentPage + 1;
	  var url = _url.BASE_USER_URL + 'mobile-paginator';
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_MOBILE_USERS });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: url,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      params: {
	        page: currentPage,
	        limit: limit,
	        CustomerNum: customerNo,
	        FirstName: firstName,
	        LastName: lastName,
	        email: email,
	        phone: phone,
	        IsActive: active
	      }
	    }).then(function (response) {
	      dispatch(fetchMobileUsersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchMobileUsersFailure(err));
	    });
	  };
	}
	
	function fetchUserDetail(user_id) {
	  return function (dispatch) {
	    dispatch({
	      type: _type.REQUEST_BASE_USER_DETAIL
	    });
	    return _axios2.default.get(_url.BASE_USER_URL + 'users/' + user_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchUserDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchUserDetailFailure(err));
	    });
	  };
	}
	
	function fetchUserDetailSuccess(baseUserDetail) {
	  return {
	    type: _type.FETCH_BASE_USER_DETAIL_SUCCESS,
	    payload: baseUserDetail
	  };
	}
	
	function fetchUserDetailFailure(error) {
	  return {
	    type: _type.FETCH_BASE_USER_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function selectCurrentUser(user_id) {
	  return {
	    type: _type.SELECT_CURRENT_USER,
	    payload: user_id
	  };
	}
	
	function resetCurrentUser() {
	  return {
	    type: _type.RESET_CURRENT_USER
	  };
	}
	
	function fetchGroups() {
	  return function (dispatch) {
	    dispatch({
	      type: _type.REQUEST_USER_GROUPS
	    });
	    return _axios2.default.get(_url.BASE_USER_URL + 'groups/', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchGroupsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchGroupsFailure(err));
	    });
	  };
	}
	function fetchProductAllGroups() {
	  return function (dispatch) {
	    return _axios2.default.get(_url.USER_PRODUCT_GROUPS_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchProductAllGroupsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	    });
	  };
	}
	
	function fetchProductAllGroupsSuccess(productGroups) {
	  return {
	    type: _type.FETCH_USER_PRODUCT_ALL_GROUPS_SUCCESS,
	    payload: productGroups
	  };
	}
	
	function fetchGroupsSuccess(groups) {
	  return {
	    type: _type.FETCH_USER_GROUPS_SUCCESS,
	    payload: groups
	  };
	}
	
	function fetchGroupsFailure(error) {
	  return {
	    type: _type.FETCH_USER_GROUPS_FAILURE,
	    payload: error
	  };
	}
	
	function fetchGroupDetail(group_id) {
	  return function (dispatch) {
	    dispatch({
	      type: _type.REQUEST_GROUP_DETAIL
	    });
	    return _axios2.default.get(_url.BASE_USER_URL + 'groups/' + group_id + '/', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchGroupDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchGroupDetailFailure(err));
	    });
	  };
	}
	
	function fetchGroupDetailSuccess(groupDetail) {
	  return {
	    type: _type.FETCH_GROUP_DETAIL_SUCCESS,
	    payload: groupDetail
	  };
	}
	
	function fetchGroupDetailFailure(error) {
	  return {
	    type: _type.FETCH_GROUP_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function selectCurrentGroup(group_id) {
	  return {
	    type: _type.SELECT_CURRENT_GROUP,
	    payload: group_id
	  };
	}
	
	function resetCurrentGroup() {
	  return {
	    type: _type.RESET_CURRENT_USER_GROUP
	  };
	}
	
	function fetchPermissions() {
	  return function (dispatch) {
	    dispatch({
	      type: _type.REQUEST_PERMISSIONS
	    });
	    return _axios2.default.get(_url.BASE_USER_URL + 'permissions/', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPermissionsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPermissionsFailure(err));
	    });
	  };
	}
	
	function fetchPermissionsSuccess(permissions) {
	  return {
	    type: _type.FETCH_PERMISSIONS_SUCCESS,
	    payload: permissions
	  };
	}
	
	function fetchPermissionsFailure(error) {
	  return {
	    type: _type.FETCH_PERMISSIONS_FAILURE,
	    payload: error
	  };
	}
	
	function resetUserDetail() {
	  return {
	    type: _type.RESET_USER_DETAIL
	  };
	}
	function editUserPermission(permissions) {
	  var formattedPermissions = [];
	  for (var i = 0; i < permissions.length; i++) {
	    formattedPermissions.push({ codename: permissions[i] });
	  }
	  localStorage.setItem('userPermissions', JSON.stringify(formattedPermissions));
	}
	
	function createUserDetail(_ref, permissions, groups) {
	  var email = _ref.email,
	      username = _ref.username,
	      password = _ref.password,
	      FirstName = _ref.FirstName,
	      LastName = _ref.LastName,
	      passcode = _ref.passcode,
	      IsOfficeOnly = _ref.IsOfficeOnly,
	      _ref$product_group_li = _ref.product_group_list,
	      product_group_list = _ref$product_group_li === undefined ? '' : _ref$product_group_li;
	
	  return function (dispatch) {
	    var data = {
	      username: username,
	      email: email,
	      password: password,
	      groups: groups,
	      permissions: permissions,
	      FirstName: FirstName,
	      LastName: LastName,
	      passcode: passcode,
	      IsOfficeOnly: IsOfficeOnly
	    };
	    if (_root_url.isJML) {
	      data.product_group_list = product_group_list;
	    }
	    dispatch({ type: _type.CREATE_USER_DETAIL });
	    return _axios2.default.post(_url.BASE_USER_URL + 'register/', data, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(createUserDetailSuccess(response));
	      // dispatch(editUserPermission(permissions));
	      _reactRouter.browserHistory.push('/userManagement');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(createUserDetailFailure(err));
	    });
	  };
	}
	
	function createUserDetailSuccess(response) {
	  return {
	    type: _type.CREATE_USER_DETAIL_SUCCESS,
	    payload: response
	  };
	}
	
	function createUserDetailFailure(error) {
	  return {
	    type: _type.CREATE_USER_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function editUserDetail(_ref2, permissions, groups, type) {
	  var email = _ref2.email,
	      id = _ref2.id,
	      username = _ref2.username,
	      FirstName = _ref2.FirstName,
	      LastName = _ref2.LastName,
	      passcode = _ref2.passcode,
	      IsOfficeOnly = _ref2.IsOfficeOnly,
	      _ref2$product_group_l = _ref2.product_group_list,
	      product_group_list = _ref2$product_group_l === undefined ? '' : _ref2$product_group_l;
	
	  return function (dispatch) {
	    var data = {
	      username: username,
	      email: email,
	      groups: groups,
	      permissions: permissions,
	      FirstName: FirstName,
	      LastName: LastName,
	      passcode: passcode,
	      IsOfficeOnly: IsOfficeOnly
	    };
	    if (_root_url.isJML) {
	      data.product_group_list = product_group_list;
	    }
	    dispatch({
	      type: _type.EDIT_USER_DETAIL
	    });
	    return _axios2.default.put(_url.BASE_USER_URL + 'users/' + id + '/', data, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editUserDetailSuccess(response));
	      //dispatch(editUserPermission(permissions));
	      if (type == 1) {
	        _reactRouter.browserHistory.push('/userManagement');
	      }
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editUserDetailFailure(err));
	    });
	  };
	}
	
	function editUserDetailSuccess(response) {
	  return {
	    type: _type.EDIT_USER_DETAIL_SUCCESS,
	    payload: response
	  };
	}
	
	function editUserDetailFailure(error) {
	  return {
	    type: _type.EDIT_USER_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function editPassword(_ref3) {
	  var password = _ref3.password,
	      new_password = _ref3.new_password,
	      renew_password = _ref3.renew_password,
	      BaseUser_id = _ref3.BaseUser_id;
	
	  return function (dispatch) {
	    dispatch({
	      type: _type.EDIT_PASSWORD
	    });
	    return _axios2.default.put(_url.BASE_USER_URL + 'password/' + BaseUser_id + '/', {
	      password: password,
	      new_password: new_password,
	      renew_password: renew_password
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editPasswordSuccess(response));
	      if (type == 1) {
	        _reactRouter.browserHistory.push('/userManagement');
	      }
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editPasswordFailure(err));
	    });
	  };
	}
	
	function editPasswordSuccess(response) {
	  return {
	    type: _type.EDIT_PASSWORD_SUCCESS,
	    payload: response
	  };
	}
	
	function editPasswordFailure(error) {
	  return {
	    type: _type.EDIT_PASSWORD_FAILURE,
	    payload: error
	  };
	}
	
	function editGroupDetail(id, _ref4, permissions) {
	  var name = _ref4.name;
	
	  return function (dispatch) {
	    dispatch({
	      type: _type.EDIT_GROUP_DETAIL
	    });
	    return _axios2.default.put(_url.BASE_USER_URL + 'groups/' + id + '/', {
	      name: name,
	      permissions: permissions
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editGroupDetailSuccess(response));
	      _reactRouter.browserHistory.push('/groupManagement');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editGroupDetailFailure(err));
	    });
	  };
	}
	
	function editGroupDetailSuccess(response) {
	  return {
	    type: _type.EDIT_GROUP_DETAIL_SUCCESS,
	    payload: response
	  };
	}
	
	function editGroupDetailFailure(error) {
	  return {
	    type: _type.EDIT_GROUP_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function createGroupDetail(_ref5, permissions) {
	  var name = _ref5.name;
	
	  return function (dispatch) {
	    dispatch({
	      type: _type.CREATE_GROUP_DETAIL
	    });
	    return _axios2.default.post(_url.BASE_USER_URL + 'groups/', {
	      name: name,
	      permissions: permissions
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(createGroupDetailSuccess(response));
	      _reactRouter.browserHistory.push('/groupManagement');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(createGroupDetailFailure(err));
	    });
	  };
	}
	
	function createGroupDetailSuccess(response) {
	  return {
	    type: _type.CREATE_GROUP_DETAIL_SUCCESS,
	    payload: response
	  };
	}
	
	function createGroupDetailFailure(error) {
	  return {
	    type: _type.CREATE_GROUP_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function resetPassword() {
	  return {
	    type: _type.RESET_PASSWORD
	  };
	}
	
	function checkPassword(password) {
	  return function (dispatch) {
	    dispatch({ type: _type.CHECK_PASSWORD });
	    return _axios2.default.post(_url.BASE_USER_URL + 'checkpassword/', { password: password }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(checkPasswordSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(checkPasswordFailure(err));
	    });
	  };
	}
	
	function checkPasswordSuccess(data) {
	  return {
	    type: _type.CHECK_PASSWORD_SUCCESS,
	    payload: data
	  };
	}
	
	function checkPasswordFailure(error) {
	  return {
	    type: _type.CHECK_PASSWORD_FAILURE,
	    payload: error
	  };
	}
	
	function clearCheckPassword() {
	  return {
	    type: _type.CLEAR_CHECK_PASSWORD
	  };
	}
	
	function checkPermission(username, password) {
	  return function (dispatch) {
	    dispatch({ type: _type.CHECK_PERMISSIOIN });
	    return _axios2.default.post(_url.BASE_USER_URL + 'manager/', {
	      username: username,
	      password: password
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(checkPermissionSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(checkPermissionFailure(err));
	    });
	  };
	}
	
	function checkPermissionSuccess(data) {
	  return {
	    type: _type.CHECK_PERMISSIOIN_SUCCESS,
	    payload: data
	  };
	}
	
	function checkPermissionFailure(error) {
	  return {
	    type: _type.CHECK_PERMISSIOIN_FAILURE,
	    payload: error
	  };
	}
	
	function fetchActionLogSuccess(data) {
	  return {
	    type: _type.FETCH_ACTION_LOG_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchActionLogFailure(error) {
	  return {
	    type: _type.FETCH_ACTION_LOG_FAILURE,
	    payload: error
	  };
	}
	
	function fetchActionLog() {
	  var url = _root_url.ROOT_URL + 'v1/dashboard/audit_trail';
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_ACTION_LOG });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: url,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchActionLogSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchActionLogFailure(err));
	    });
	  };
	}
	
	function fetchActionLogByFilter(action, field, days, fromDate, toDate) {
	  var dates = (0, _cleanDates.toFromDates)(days, fromDate, toDate);
	  if (!field) {
	    field = '';
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_ACTION_LOG_BY_FILTER });
	    return _axios2.default.get(_url.ACTION_LOG_FILTER_URL + '?Action=' + action + '&Field=' + field + '&Date__gte=' + dates.fromDate + '&Date__lte=' + dates.toDate, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchActionLogByFilterSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchActionLogByFilterFailure(err));
	    });
	  };
	}
	
	function fetchActionLogByFilterSuccess(data) {
	  return {
	    type: _type.ACTION_LOG_FILTER_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchActionLogByFilterFailure(err) {
	  return {
	    type: _type.ACTION_LOG_FILTER_FAILURE,
	    payload: err
	  };
	}
	
	function grabMobileUserID(id) {
	  return {
	    type: _type.GRAB_MOBILE_USER_ID,
	    payload: id
	  };
	}
	
	function fetchUsername(id) {
	  return function (dispatch) {
	    dispatch(requestUsername());
	    return _axios2.default.get('' + _url.USERNAME_URL + id + '/', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(requestUsernameSuccess(response.data));
	    }, function (err) {
	      dispatch(requestUsernameFailure(err));
	    });
	  };
	}
	
	function requestUsername() {
	  return {
	    type: _type.REQUEST_USERNAME
	  };
	}
	
	function requestUsernameSuccess(data) {
	  return {
	    type: _type.REQUEST_USERNAME_SUCCESS,
	    payload: data.username
	  };
	}
	
	function requestUsernameFailure(err) {
	  return {
	    type: _type.REQUEST_USERNAME_FAILURE,
	    payload: err
	  };
	}
	
	function clearUsernameData() {
	  return {
	    type: _type.CLEAR_USERNAME_DATA
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchBaseUsers, 'fetchBaseUsers', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchBusinessUsersAPI, 'fetchBusinessUsersAPI', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(setSelectedBusinessUser, 'setSelectedBusinessUser', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(handleEditUserConfirm, 'handleEditUserConfirm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(verifyBusinessUser, 'verifyBusinessUser', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(requestBaseUsers, 'requestBaseUsers', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchBaseUsersSuccess, 'fetchBaseUsersSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchBaseUsersFailure, 'fetchBaseUsersFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchMobileUsersSuccess, 'fetchMobileUsersSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchMobileUsersFailure, 'fetchMobileUsersFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchMobileUsers, 'fetchMobileUsers', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchUserDetail, 'fetchUserDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchUserDetailSuccess, 'fetchUserDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchUserDetailFailure, 'fetchUserDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(selectCurrentUser, 'selectCurrentUser', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(resetCurrentUser, 'resetCurrentUser', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchGroups, 'fetchGroups', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchProductAllGroups, 'fetchProductAllGroups', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchProductAllGroupsSuccess, 'fetchProductAllGroupsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchGroupsSuccess, 'fetchGroupsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchGroupsFailure, 'fetchGroupsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchGroupDetail, 'fetchGroupDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchGroupDetailSuccess, 'fetchGroupDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchGroupDetailFailure, 'fetchGroupDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(selectCurrentGroup, 'selectCurrentGroup', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(resetCurrentGroup, 'resetCurrentGroup', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPermissions, 'fetchPermissions', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPermissionsSuccess, 'fetchPermissionsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPermissionsFailure, 'fetchPermissionsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(resetUserDetail, 'resetUserDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(editUserPermission, 'editUserPermission', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(createUserDetail, 'createUserDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(createUserDetailSuccess, 'createUserDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(createUserDetailFailure, 'createUserDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(editUserDetail, 'editUserDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(editUserDetailSuccess, 'editUserDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(editUserDetailFailure, 'editUserDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(editPassword, 'editPassword', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(editPasswordSuccess, 'editPasswordSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(editPasswordFailure, 'editPasswordFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(editGroupDetail, 'editGroupDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(editGroupDetailSuccess, 'editGroupDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(editGroupDetailFailure, 'editGroupDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(createGroupDetail, 'createGroupDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(createGroupDetailSuccess, 'createGroupDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(createGroupDetailFailure, 'createGroupDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(resetPassword, 'resetPassword', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(checkPassword, 'checkPassword', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(checkPasswordSuccess, 'checkPasswordSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(checkPasswordFailure, 'checkPasswordFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(clearCheckPassword, 'clearCheckPassword', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(checkPermission, 'checkPermission', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(checkPermissionSuccess, 'checkPermissionSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(checkPermissionFailure, 'checkPermissionFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchActionLogSuccess, 'fetchActionLogSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchActionLogFailure, 'fetchActionLogFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchActionLog, 'fetchActionLog', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchActionLogByFilter, 'fetchActionLogByFilter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchActionLogByFilterSuccess, 'fetchActionLogByFilterSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchActionLogByFilterFailure, 'fetchActionLogByFilterFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(grabMobileUserID, 'grabMobileUserID', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchUsername, 'fetchUsername', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(requestUsername, 'requestUsername', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(requestUsernameSuccess, 'requestUsernameSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(requestUsernameFailure, 'requestUsernameFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(clearUsernameData, 'clearUsernameData', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/settings_actions.jsx');
	}();

	;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(21);

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.numberWithCommas = numberWithCommas;
	function numberWithCommas(x) {
	  if (x) {
	    var parts = x.toString().split('.');
	    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	    if (parts[1]) {
	      parts[1] = parts[1].length === 1 ? parts[1] + '0' : parts[1];
	    } else {
	      parts[1] = '00';
	    }
	    return parts.join('.');
	  }
	  return '0';
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(numberWithCommas, 'numberWithCommas', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/numberWithCommas.jsx');
	}();

	;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	  Example of SpinnerButton:
	  <SpinnerButton
	    bsStyle="success"
	    onClick={() => {
	      this.customOnClick();
	    }}
	    loading={this.props.somethingIsLoading}
	    icon={"default button icon"}
	    translation={"normal_translation_format"}
	  />
	*/
	
	var SpinnerButton = function SpinnerButton(props) {
	  return _react2.default.createElement(
	    _reactBootstrap.Button,
	    _extends({
	      bsStyle: 'primary',
	      type: 'button'
	    }, props),
	    _react2.default.createElement('em', { className: 'fa ' + (props.loading ? 'fa-spinner fa-spin' : props.icon) }),
	    props.translation
	  );
	};
	
	SpinnerButton.defaultProps = {
	  icon: '',
	  loading: false,
	  translation: ''
	};
	
	SpinnerButton.propTypes = {
	  icon: _propTypes2.default.string,
	  loading: _propTypes2.default.bool,
	  translation: _propTypes2.default.node
	};
	
	var _default = SpinnerButton;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SpinnerButton, 'SpinnerButton', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/SpinnerButton.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/SpinnerButton.jsx');
	}();

	;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1819);

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchReceiveHistoryFilterInitial = undefined;
	exports.handleInventoryClick = handleInventoryClick;
	exports.updateFilter = updateFilter;
	exports.updateReceiveTableFilter = updateReceiveTableFilter;
	exports.fetchReceiveHistory = fetchReceiveHistory;
	exports.fetchInventoriesDetails = fetchInventoriesDetails;
	exports.fetchInventories = fetchInventories;
	exports.fetchInventoriesSuccess = fetchInventoriesSuccess;
	exports.fetchInventoriesFailure = fetchInventoriesFailure;
	exports.fetchInventoriesByGroup = fetchInventoriesByGroup;
	exports.fetchInventoriesByGroupSuccess = fetchInventoriesByGroupSuccess;
	exports.fetchInventoriesByGroupFailure = fetchInventoriesByGroupFailure;
	exports.fetchInventoriesByCategory = fetchInventoriesByCategory;
	exports.fetchInventoriesByCategorySuccess = fetchInventoriesByCategorySuccess;
	exports.fetchInventoriesByCategoryFailure = fetchInventoriesByCategoryFailure;
	exports.fetchDetailedInventories = fetchDetailedInventories;
	exports.fetchDetailedInventoriesSuccess = fetchDetailedInventoriesSuccess;
	exports.fetchDetailedInventoriesFailure = fetchDetailedInventoriesFailure;
	exports.fetchLowStockInventoryInventories = fetchLowStockInventoryInventories;
	exports.fetchLowStockInventoryInventoriesSuccess = fetchLowStockInventoryInventoriesSuccess;
	exports.fetchLowStockInventoryInventoriesFailure = fetchLowStockInventoryInventoriesFailure;
	exports.fetchExpiredInventories = fetchExpiredInventories;
	exports.fetchExpiredInventoriesSuccess = fetchExpiredInventoriesSuccess;
	exports.fetchExpiredInventoriesFailure = fetchExpiredInventoriesFailure;
	exports.selectInventory = selectInventory;
	exports.resetCurrentInventory = resetCurrentInventory;
	exports.fetchInventoryDetail = fetchInventoryDetail;
	exports.fetchInventoryDetailSuccess = fetchInventoryDetailSuccess;
	exports.fetchInventoryDetailFailure = fetchInventoryDetailFailure;
	exports.fetchSalesOrderInventory = fetchSalesOrderInventory;
	exports.fetchSalesOrderInventorySuccess = fetchSalesOrderInventorySuccess;
	exports.fetchSalesOrderInventoryFailure = fetchSalesOrderInventoryFailure;
	exports.fetchAllInventories = fetchAllInventories;
	exports.fetchInventoriesByPeriod = fetchInventoriesByPeriod;
	exports.fetchInventoriesByPeriodSuccess = fetchInventoriesByPeriodSuccess;
	exports.fetchInventoriesByPeriodFailure = fetchInventoriesByPeriodFailure;
	exports.setOriginPage = setOriginPage;
	exports.fetchNonZeroInventories = fetchNonZeroInventories;
	exports.fetchNonZeroInventoriesSuccess = fetchNonZeroInventoriesSuccess;
	exports.fetchNonZeroInventoriesFailure = fetchNonZeroInventoriesFailure;
	exports.fetchLowInventories = fetchLowInventories;
	exports.fetchLowInventoriesSuccess = fetchLowInventoriesSuccess;
	exports.fetchLowInventoriesFailure = fetchLowInventoriesFailure;
	exports.fetchWorkingOrders = fetchWorkingOrders;
	exports.fetchWorkingOrdersSuccess = fetchWorkingOrdersSuccess;
	exports.fetchWorkingOrdersFailure = fetchWorkingOrdersFailure;
	exports.voidWorkingOrder = voidWorkingOrder;
	exports.fetchReturnBatch = fetchReturnBatch;
	exports.fetchReturnBatchSuccess = fetchReturnBatchSuccess;
	exports.fetchReturnBatchFailure = fetchReturnBatchFailure;
	exports.fetchInventoryHistorySuccess = fetchInventoryHistorySuccess;
	exports.fetchInventoryHistoryFailure = fetchInventoryHistoryFailure;
	exports.fetchInventoryHistory = fetchInventoryHistory;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url2 = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Inventories Actions
	var generateNewReceiveFilter = function generateNewReceiveFilter() {
	  var date = new Date();
	  var last = new Date(date.getTime() - 7 * 24 * 60 * 60 * 1000);
	  return {
	    start_date: last,
	    end_date: date
	  };
	};
	
	var fetchReceiveHistoryFilterInitial = exports.fetchReceiveHistoryFilterInitial = function fetchReceiveHistoryFilterInitial() {
	  return function (dispatch) {
	    dispatch({ type: _type.RESET_RECEIVE_FILTER_WITH_NEW_ID, payload: generateNewReceiveFilter() });
	  };
	};
	
	var generateNewFilter = function generateNewFilter(id) {
	  var date = new Date();
	  var last = new Date(date.getTime() - 7 * 24 * 60 * 60 * 1000);
	  return {
	    start_date: last,
	    end_date: date
	  };
	};
	
	function handleInventoryClick(id) {
	  return function (dispatch) {
	    dispatch({ type: _type.RESET_FILTER_WITH_NEW_ID, payload: generateNewFilter(id) });
	  };
	}
	
	function updateFilter(data) {
	  return function (dispatch) {
	    dispatch({
	      type: _type.UPDATE_INVENTORY_FILTER,
	      payload: data
	    });
	  };
	}
	
	function updateReceiveTableFilter(data) {
	  return function (dispatch) {
	    dispatch({
	      type: _type.UPDATE_RECEIVE_TABLE_FILTER,
	      payload: data
	    });
	  };
	}
	
	function fetchReceiveHistory(id) {
	  return function (dispatch, getState) {
	    var receiveTableFilter = getState().inventoryAdjustments.receiveTableFilter;
	    var date = (0, _cleanDates.toFromDates)(null, receiveTableFilter.start_date, receiveTableFilter.end_date);
	    _axios2.default.get('' + _url2.PRODUCT_RECEIVE_HISTORY + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      params: {
	        start_date: date.fromDate,
	        end_date: date.toDate
	      }
	    }).then(function (res) {
	      dispatch({
	        type: _type.FETCH_INVENTORIES_PRODUCT_RECEIVE_SUCCESS,
	        payload: res.data
	      });
	    }).catch(function (err) {
	      console.log('error fethcing receiving history of a product', err);
	    });
	  };
	}
	
	function fetchInventoriesDetails(id) {
	  return function (dispatch, getState) {
	    var filters = getState().inventoryAdjustments.filters;
	    var date = (0, _cleanDates.toFromDates)(null, filters.start_date, filters.end_date);
	    _axios2.default.get('' + _url2.INVENTORY_SALES_ORDER_HISTORY_URL + id, {
	      params: {
	        end_date: date.toDate,
	        start_date: date.fromDate
	      },
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (res) {
	      dispatch(fetchInventoriesDetailsSuccess(res.data));
	      dispatch({ type: _type.FETCH_INVENTORIES_DETAILS_SUCCESS });
	    }).catch(function (err) {
	      console.log('err fetching inventories details', err);
	    });
	  };
	}
	
	function fetchInventoriesDetailsSuccess(data) {
	  return {
	    type: _type.FETCH_INVENTORY_ADJUSTMENT_BATCH_LOG,
	    payload: data
	  };
	}
	function fetchInventories() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_INVENTORIES });
	    return _axios2.default.get(_url2.INVENTORIES_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchInventoriesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchInventoriesFailure(err));
	    });
	  };
	}
	
	function fetchInventoriesSuccess(inventories) {
	  return {
	    type: _type.FETCH_INVENTORIES_SUCCESS,
	    payload: inventories
	  };
	}
	
	function fetchInventoriesFailure(error) {
	  return {
	    type: _type.FETCH_INVENTORIES_FAILURE,
	    payload: error
	  };
	}
	
	function fetchInventoriesByGroup(id) {
	  if (id == -1) {
	    return function (dispatch) {
	      dispatch(fetchDetailedInventories());
	    };
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_INVENTORIES_BY_GROUP });
	    return _axios2.default.get(_url2.INVENTORY_URL + 'group/' + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchInventoriesByGroupSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchInventoriesByGroupFailure(err));
	    });
	  };
	}
	
	function fetchInventoriesByGroupSuccess(response) {
	  return {
	    type: _type.REQUEST_INVENTORIES_BY_GROUP_SUCCESS,
	    payload: response
	  };
	}
	
	function fetchInventoriesByGroupFailure(error) {
	  return {
	    type: _type.REQUEST_INVENTORIES_BY_GROUP_FAILURE,
	    payload: error
	  };
	}
	
	function fetchInventoriesByCategory(id) {
	  if (id == -1) {
	    return function (dispatch) {
	      dispatch(fetchDetailedInventories());
	    };
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_INVENTORIES_BY_CATEGORY });
	    return _axios2.default.get(_url2.INVENTORY_URL + 'category/' + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchInventoriesByCategorySuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchInventoriesByCategoryFailure(err));
	    });
	  };
	}
	
	function fetchInventoriesByCategorySuccess(response) {
	  return {
	    type: _type.REQUEST_INVENTORIES_BY_CATEGORY_SUCCESS,
	    payload: response
	  };
	}
	
	function fetchInventoriesByCategoryFailure(error) {
	  return {
	    type: _type.REQUEST_INVENTORIES_BY_CATEGORY_FAILURE,
	    payload: error
	  };
	}
	
	function fetchDetailedInventories() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_DETAILED_INVENTORIES });
	    return _axios2.default.get(_url2.DETAILED_INVENTORIES_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchDetailedInventoriesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchDetailedInventoriesFailure(err));
	    });
	  };
	}
	
	function fetchDetailedInventoriesSuccess(inventory) {
	  return {
	    type: _type.FETCH_DETAILED_INVENTORIES_SUCCESS,
	    payload: inventory
	  };
	}
	
	function fetchDetailedInventoriesFailure(error) {
	  return {
	    type: _type.FETCH_DETAILED_INVENTORIES_FAILURE,
	    payload: error
	  };
	}
	
	function fetchLowStockInventoryInventories() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_LOW_STOCK_INVENTORIES });
	    return _axios2.default.get(_url2.INVENTORY_URL + 'lowstock/', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchLowStockInventoryInventoriesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchLowStockInventoryInventoriesFailure(err));
	    });
	  };
	}
	
	function fetchLowStockInventoryInventoriesSuccess(lowStockInventories) {
	  return {
	    type: _type.FETCH_LOW_STOCK_INVENTORIES_SUCCESS,
	    payload: lowStockInventories
	  };
	}
	
	function fetchLowStockInventoryInventoriesFailure(error) {
	  return {
	    type: _type.FETCH_LOW_STOCK_INVENTORIES_FAILURE,
	    payload: error
	  };
	}
	
	function fetchExpiredInventories() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EXPIRED_INVENTORIES });
	    return _axios2.default.get(_url2.INVENTORY_URL + 'batch/', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchExpiredInventoriesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchExpiredInventoriesFailure(err));
	    });
	  };
	}
	
	function fetchExpiredInventoriesSuccess(expiredInventories) {
	  return {
	    type: _type.FETCH_EXPIRED_INVENTORIES_SUCCESS,
	    payload: expiredInventories
	  };
	}
	
	function fetchExpiredInventoriesFailure(error) {
	  return {
	    type: _type.FETCH_EXPIRED_INVENTORIES_FAILURE,
	    payload: error
	  };
	}
	
	function selectInventory(inventory) {
	  return {
	    type: _type.SELECT_INVENTORY,
	    payload: inventory
	  };
	}
	
	function resetCurrentInventory() {
	  return {
	    type: _type.RESET_CURRENT_INVENTORY
	  };
	}
	
	function fetchInventoryDetail(inventory_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_INVENTORY_DETAIL });
	    return _axios2.default.get(_url2.INVENTORY_URL + inventory_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchInventoryDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchInventoryDetailFailure(err));
	    });
	  };
	}
	
	function fetchInventoryDetailSuccess(inventoryDetail) {
	  return {
	    type: _type.FETCH_INVENTORY_DETAIL_SUCCESS,
	    payload: inventoryDetail
	  };
	}
	
	function fetchInventoryDetailFailure(error) {
	  return {
	    type: _type.FETCH_INVENTORY_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function fetchSalesOrderInventory() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SALES_ORDER_INVENTORY });
	    return _axios2.default.get(_url2.SALES_ORDER_INVENTORY_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesOrderInventorySuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesOrderInventoryFailure(err));
	    });
	  };
	}
	
	function fetchSalesOrderInventorySuccess(inventory) {
	  return {
	    type: _type.FETCH_SALES_ORDER_INVENTORY_SUCCESS,
	    payload: inventory
	  };
	}
	
	function fetchSalesOrderInventoryFailure(error) {
	  return {
	    type: _type.FETCH_SALES_ORDER_INVENTORY_FAILURE,
	    payload: error
	  };
	}
	
	function fetchAllInventories(type) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_INVENTORIES_BY_PERIOD });
	    return _axios2.default.get(_url2.DETAILED_INVENTORIES_URL + type, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchInventoriesByPeriodSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchInventoriesByPeriodFailure(err));
	    });
	  };
	}
	
	function fetchInventoriesByPeriod(type, division, startDate, endDate, warehouse) {
	  var dates = (0, _cleanDates.toFromDates)(-1, startDate, endDate);
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_INVENTORIES_BY_PERIOD });
	    if (type !== 'Inactive' && type !== 'Active') {
	      var _url = void 0;
	      if (division === '') {
	        _url = '' + _url2.DETAILED_INVENTORIES_URL + type + '/' + (warehouse !== '' ? '?' + warehouse : '');
	      } else {
	        _url = '' + _url2.DETAILED_INVENTORIES_URL + type + '/?' + division + (warehouse !== '' ? '&' + warehouse : '');
	      }
	      return _axios2.default.get(_url, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        dispatch(fetchInventoriesByPeriodSuccess(response));
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = _constants.DEFAULT_ERROR;
	        }
	        dispatch(fetchInventoriesByPeriodFailure(err));
	      });
	    }
	    var warehouseQuery = warehouse !== '' ? '&' + warehouse : '';
	    var url = void 0;
	    if (division === '') {
	      url = '' + _url2.DETAILED_INVENTORIES_URL + type + '/?startdate=' + dates.fromDate + '&enddate=' + dates.toDate + warehouseQuery;
	    } else {
	      url = '' + _url2.DETAILED_INVENTORIES_URL + type + '/?' + division + '&startdate=' + dates.fromDate + '&enddate=' + dates.toDate + warehouseQuery;
	    }
	    return _axios2.default.get(url, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchInventoriesByPeriodSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchInventoriesByPeriodFailure(err));
	    });
	  };
	}
	
	function fetchInventoriesByPeriodSuccess(inventory) {
	  return {
	    type: _type.FETCH_INVENTORIES_BY_PERIOD_SUCCESS,
	    payload: inventory
	  };
	}
	
	function fetchInventoriesByPeriodFailure(error) {
	  return {
	    type: _type.FETCH_INVENTORIES_BY_PERIOD_FAILURE,
	    payload: error
	  };
	}
	
	function setOriginPage(page) {
	  return {
	    type: _type.SET_ORIGIN_PAGE,
	    payload: page
	  };
	}
	
	function fetchNonZeroInventories() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_INVENTORIES_BY_PERIOD });
	    return _axios2.default.get(_url2.DETAILED_INVENTORIES_URL + 'NonZero', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchNonZeroInventoriesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchNonZeroInventoriesFailure(err));
	    });
	  };
	}
	
	function fetchNonZeroInventoriesSuccess(items) {
	  return {
	    type: _type.FETCH_NONZERO_INVENTORIES_SUCCESS,
	    payload: items
	  };
	}
	
	function fetchNonZeroInventoriesFailure(error) {
	  return {
	    type: _type.FETCH_NONZERO_INVENTORIES_FAILURE,
	    payload: error
	  };
	}
	
	function fetchLowInventories(PackageSize, Stock) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_LOW_INVENTORIES });
	    var url = _url2.WAREHOUSES_URL + 'lowinventory/';
	    if (PackageSize && Stock) {
	      url = url + '?PackageSize=' + PackageSize + '&Stock=' + Stock;
	    } else if (PackageSize) {
	      url = url + '?PackageSize=' + PackageSize;
	    } else if (Stock) {
	      url = url + '?Stock=' + Stock;
	    }
	    return _axios2.default.get(url, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchLowInventoriesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchLowInventoriesFailure(err));
	    });
	  };
	}
	
	function fetchLowInventoriesSuccess(items) {
	  return {
	    type: _type.FETCH_LOW_INVENTORIES_SUCCESS,
	    payload: items
	  };
	}
	
	function fetchLowInventoriesFailure(error) {
	  return {
	    type: _type.FETCH_LOW_INVENTORIES_FAILURE,
	    payload: error
	  };
	}
	
	function fetchWorkingOrders(date) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_WORKING_ORDERS });
	    return _axios2.default.get(_url2.WAREHOUSES_URL + 'lowinventory/?Date=' + date, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchWorkingOrdersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchWorkingOrdersFailure(err));
	    });
	  };
	}
	
	function fetchWorkingOrdersSuccess(data) {
	  return {
	    type: _type.FETCH_WORKING_ORDERS_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchWorkingOrdersFailure(error) {
	  return {
	    type: _type.FETCH_WORKING_ORDERS_FAILURE,
	    payload: error
	  };
	}
	
	function voidWorkingOrder(warehouseConvertId, handleSuccess, handleFailure) {
	  return (0, _axios2.default)({
	    method: 'delete',
	    url: _url2.WAREHOUSES_URL + 'convert/' + warehouseConvertId,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (response) {
	    handleSuccess(response);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err);
	  });
	}
	
	function fetchReturnBatch(searchType, searchValue) {
	  var RESEARCH_URL = '';
	  if (searchType && searchValue) {
	    RESEARCH_URL = '?' + searchType + '=' + searchValue;
	  }
	  var URL = _url2.INVENTORY_URL + 'returnbatch/' + RESEARCH_URL;
	  return function (dispatch) {
	    dispatch({ type: _type.FETCH_VENDOR_BATCHES });
	    _axios2.default.get(URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchReturnBatchSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchReturnBatchFailure(err));
	    });
	  };
	}
	
	function fetchReturnBatchSuccess(products) {
	  return {
	    type: _type.FETCH_VENDOR_BATCHES_SUCCESS,
	    payload: products
	  };
	}
	
	function fetchReturnBatchFailure(error) {
	  return {
	    type: _type.FETCH_VENDOR_BATCHES_FAILURE,
	    payload: error
	  };
	}
	
	function fetchInventoryHistorySuccess(products) {
	  return {
	    type: _type.FETCH_INVENTORY_HISTORY_SUCCESS,
	    payload: products
	  };
	}
	
	function fetchInventoryHistoryFailure(error) {
	  return {
	    type: _type.FETCH_INVENTORY_HISTORY_FAILURE,
	    payload: error
	  };
	}
	
	function fetchInventoryHistory(productId, fromDate, toDate) {
	  var dates = (0, _cleanDates.toFromDates)(-1, fromDate, toDate);
	  return function (dispatch) {
	    dispatch({ type: _type.FETCH_INVENTORY_HISTORY });
	    _axios2.default.get('' + _url2.INVENTORY_HISTORY_URL + productId + '?start_date=' + dates.fromDate + '&end_date=' + dates.toDate, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchInventoryHistorySuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchInventoryHistoryFailure(err));
	    });
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchReceiveHistoryFilterInitial, 'fetchReceiveHistoryFilterInitial', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(handleInventoryClick, 'handleInventoryClick', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(updateFilter, 'updateFilter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(updateReceiveTableFilter, 'updateReceiveTableFilter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchReceiveHistory, 'fetchReceiveHistory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInventoriesDetails, 'fetchInventoriesDetails', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInventoriesDetailsSuccess, 'fetchInventoriesDetailsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInventories, 'fetchInventories', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInventoriesSuccess, 'fetchInventoriesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInventoriesFailure, 'fetchInventoriesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInventoriesByGroup, 'fetchInventoriesByGroup', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInventoriesByGroupSuccess, 'fetchInventoriesByGroupSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInventoriesByGroupFailure, 'fetchInventoriesByGroupFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInventoriesByCategory, 'fetchInventoriesByCategory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInventoriesByCategorySuccess, 'fetchInventoriesByCategorySuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInventoriesByCategoryFailure, 'fetchInventoriesByCategoryFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchDetailedInventories, 'fetchDetailedInventories', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchDetailedInventoriesSuccess, 'fetchDetailedInventoriesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchDetailedInventoriesFailure, 'fetchDetailedInventoriesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchLowStockInventoryInventories, 'fetchLowStockInventoryInventories', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchLowStockInventoryInventoriesSuccess, 'fetchLowStockInventoryInventoriesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchLowStockInventoryInventoriesFailure, 'fetchLowStockInventoryInventoriesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchExpiredInventories, 'fetchExpiredInventories', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchExpiredInventoriesSuccess, 'fetchExpiredInventoriesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchExpiredInventoriesFailure, 'fetchExpiredInventoriesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(selectInventory, 'selectInventory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(resetCurrentInventory, 'resetCurrentInventory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInventoryDetail, 'fetchInventoryDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInventoryDetailSuccess, 'fetchInventoryDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInventoryDetailFailure, 'fetchInventoryDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderInventory, 'fetchSalesOrderInventory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderInventorySuccess, 'fetchSalesOrderInventorySuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderInventoryFailure, 'fetchSalesOrderInventoryFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchAllInventories, 'fetchAllInventories', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInventoriesByPeriod, 'fetchInventoriesByPeriod', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInventoriesByPeriodSuccess, 'fetchInventoriesByPeriodSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInventoriesByPeriodFailure, 'fetchInventoriesByPeriodFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(setOriginPage, 'setOriginPage', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchNonZeroInventories, 'fetchNonZeroInventories', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchNonZeroInventoriesSuccess, 'fetchNonZeroInventoriesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchNonZeroInventoriesFailure, 'fetchNonZeroInventoriesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchLowInventories, 'fetchLowInventories', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchLowInventoriesSuccess, 'fetchLowInventoriesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchLowInventoriesFailure, 'fetchLowInventoriesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchWorkingOrders, 'fetchWorkingOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchWorkingOrdersSuccess, 'fetchWorkingOrdersSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchWorkingOrdersFailure, 'fetchWorkingOrdersFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(voidWorkingOrder, 'voidWorkingOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchReturnBatch, 'fetchReturnBatch', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchReturnBatchSuccess, 'fetchReturnBatchSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchReturnBatchFailure, 'fetchReturnBatchFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInventoryHistorySuccess, 'fetchInventoryHistorySuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInventoryHistoryFailure, 'fetchInventoryHistoryFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInventoryHistory, 'fetchInventoryHistory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(generateNewReceiveFilter, 'generateNewReceiveFilter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(generateNewFilter, 'generateNewFilter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventories_actions.jsx');
	}();

	;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatDate = exports.DateFormatter = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cleanDates = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DateFormatter = exports.DateFormatter = _react2.default.createClass({
	  displayName: 'DateFormatter',
	  render: function render() {
	    return this.props.value ? _react2.default.createElement(
	      'span',
	      null,
	      (0, _cleanDates.convertLocalDate)(this.props.value, 'MMM DD YYYY')
	    ) : _react2.default.createElement(
	      'span',
	      { className: 'label label-danger' },
	      '-'
	    );
	  }
	});
	
	var formatDate = exports.formatDate = function formatDate(date) {
	  if (!date) {
	    return;
	  }
	  var formattedDate = date.getFullYear() + '-';
	  formattedDate += date.getMonth() + 1 + '-';
	  if (date.getDate() < 10) {
	    formattedDate += '0' + date.getDate();
	  } else {
	    formattedDate += date.getDate();
	  }
	  return formattedDate;
	};
	
	var _default = DateFormatter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(DateFormatter, 'DateFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/dateFormat.jsx');
	
	  __REACT_HOT_LOADER__.register(formatDate, 'formatDate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/dateFormat.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/dateFormat.jsx');
	}();

	;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GenericSelection = function GenericSelection(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'label',
	      { htmlFor: 'selection', className: 'control-label' },
	      _react2.default.createElement(
	        'span',
	        { className: 'selection-label' },
	        props.translation,
	        props.colon ? ':' : ''
	      ),
	      _react2.default.createElement(_reactSelect2.default, {
	        id: 'selection',
	        className: 'selection-dropdown',
	        clearable: false,
	        value: props.value,
	        options: props.options,
	        onChange: function onChange(e) {
	          props.setSelected(e);
	        },
	        disabled: props.disabled,
	        placeholder: props.placeholder
	      })
	    )
	  );
	};
	
	GenericSelection.defaultProps = {
	  translation: '',
	  disabled: false,
	  colon: false
	};
	
	GenericSelection.propTypes = {
	  value: _propTypes2.default.string.isRequired,
	  options: _propTypes2.default.shape({}).isRequired,
	  setSelected: _propTypes2.default.func.isRequired,
	  translation: _propTypes2.default.node,
	  disabled: _propTypes2.default.bool,
	  colon: _propTypes2.default.bool
	};
	
	var _default = GenericSelection;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(GenericSelection, 'GenericSelection', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/GenericSelection.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/GenericSelection.jsx');
	}();

	;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (moment) {
	  if (typeof moment !== 'function') throw new TypeError('You must provide a valid moment object');
	
	  var localField = typeof moment().locale === 'function' ? 'locale' : 'lang',
	      hasLocaleData = !!moment.localeData;
	
	  if (!hasLocaleData) throw new TypeError('The Moment localizer depends on the `localeData` api, please provide a moment object v2.2.0 or higher');
	
	  function getMoment(culture, value, format) {
	    return culture ? moment(value, format)[localField](culture) : moment(value, format);
	  }
	
	  function endOfDecade(date) {
	    return moment(date).add(10, 'year').add(-1, 'millisecond').toDate();
	  }
	
	  function endOfCentury(date) {
	    return moment(date).add(100, 'year').add(-1, 'millisecond').toDate();
	  }
	
	  var localizer = {
	    formats: {
	      date: 'L',
	      time: 'LT',
	      default: 'lll',
	      header: 'MMMM YYYY',
	      footer: 'LL',
	      weekday: 'dd',
	      dayOfMonth: 'DD',
	      month: 'MMM',
	      year: 'YYYY',
	
	      decade: function decade(date, culture, localizer) {
	        return localizer.format(date, 'YYYY', culture) + ' - ' + localizer.format(endOfDecade(date), 'YYYY', culture);
	      },
	      century: function century(date, culture, localizer) {
	        return localizer.format(date, 'YYYY', culture) + ' - ' + localizer.format(endOfCentury(date), 'YYYY', culture);
	      }
	    },
	
	    firstOfWeek: function firstOfWeek(culture) {
	      return moment.localeData(culture).firstDayOfWeek();
	    },
	    parse: function parse(value, format, culture) {
	      if (!value) return null;
	      var m = getMoment(culture, value, format);
	      if (m.isValid()) return m.toDate();
	      return null;
	    },
	    format: function format(value, _format, culture) {
	      return getMoment(culture, value).format(_format);
	    }
	  };
	
	  _configure2.default.setDateLocalizer(localizer);
	
	  return localizer;
	};
	
	var _configure = __webpack_require__(824);
	
	var _configure2 = _interopRequireDefault(_configure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.requestCustomers = requestCustomers;
	exports.fetchCustomersSuccess = fetchCustomersSuccess;
	exports.fetchCustomersFailure = fetchCustomersFailure;
	exports.fetchCustomers = fetchCustomers;
	exports.requestCustomersPaginate = requestCustomersPaginate;
	exports.fetchCustomersPaginateSuccess = fetchCustomersPaginateSuccess;
	exports.fetchCustomersPaginateFailure = fetchCustomersPaginateFailure;
	exports.fetchCustomersPaginate = fetchCustomersPaginate;
	exports.fetchActiveCustomers = fetchActiveCustomers;
	exports.selectCustomer = selectCustomer;
	exports.resetCurrentCustomer = resetCurrentCustomer;
	exports.requestCreatingCustomer = requestCreatingCustomer;
	exports.createCustomerSuccess = createCustomerSuccess;
	exports.createCustomerFailure = createCustomerFailure;
	exports.createCustomer = createCustomer;
	exports.editCustomerSuccess = editCustomerSuccess;
	exports.editCustomerFailure = editCustomerFailure;
	exports.editCustomer = editCustomer;
	exports.editCustomerGroup = editCustomerGroup;
	exports.requestEditingCustomer = requestEditingCustomer;
	exports.requestCustomerDetail = requestCustomerDetail;
	exports.fetchCustomerDetailSuccess = fetchCustomerDetailSuccess;
	exports.fetchCustomerDetailFailure = fetchCustomerDetailFailure;
	exports.fetchCustomerDetail = fetchCustomerDetail;
	exports.requestCustomerCreditByDate = requestCustomerCreditByDate;
	exports.fetchCustomerCreditByDateSuccess = fetchCustomerCreditByDateSuccess;
	exports.fetchCustomerCreditByDateFailure = fetchCustomerCreditByDateFailure;
	exports.fetchCustomerCreditByDate = fetchCustomerCreditByDate;
	exports.fetchCustomersStatusSuccess = fetchCustomersStatusSuccess;
	exports.fetchCustomersStatusFailure = fetchCustomersStatusFailure;
	exports.fetchCustomersStatus = fetchCustomersStatus;
	exports.attachDocumentSuccess = attachDocumentSuccess;
	exports.attachDocumentFailure = attachDocumentFailure;
	exports.attachDocument = attachDocument;
	exports.fetchFJAgents = fetchFJAgents;
	exports.updateFJAgents = updateFJAgents;
	exports.deleteFJAgents = deleteFJAgents;
	exports.fetchPT = fetchPT;
	exports.updatePT = updatePT;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _root_url = __webpack_require__(9);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isMAG = _root_url.ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://magna-scm.truckxi.com/api/';
	var isYI = _root_url.ROOT_API_URL === 'https://ying-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ying-scm.truckxi.com/api/';
	
	function requestCustomers() {
	  return {
	    type: _type.REQUEST_CUSTOMERS
	  };
	}
	
	function fetchCustomersSuccess(customers) {
	  return {
	    type: _type.FETCH_CUSTOMERS_SUCCESS,
	    payload: customers
	  };
	}
	
	function fetchCustomersFailure(error) {
	  return {
	    type: _type.FETCH_CUSTOMERS_FAILURE,
	    payload: error
	  };
	}
	
	function fetchCustomers() {
	  var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
	
	  return function (dispatch) {
	    dispatch(requestCustomers());
	    return _axios2.default.get(_url.CUSTOMERS_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchCustomersSuccess(response));
	      cb();
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCustomersFailure(err));
	    });
	  };
	}
	
	function requestCustomersPaginate() {
	  return {
	    type: _type.REQUEST_CUSTOMERS_PAGINATE
	  };
	}
	
	function fetchCustomersPaginateSuccess(customers) {
	  return {
	    type: _type.FETCH_CUSTOMERS_PAGINATE_SUCCESS,
	    payload: customers
	  };
	}
	
	function fetchCustomersPaginateFailure(error) {
	  return {
	    type: _type.FETCH_CUSTOMERS_PAGINATE_FAILURE,
	    payload: error
	  };
	}
	
	function fetchCustomersPaginate(currentPage, limit, searchFilter) {
	  if (!limit) {
	    limit = 'all';
	  }
	  currentPage = currentPage + 1;
	  var url = '' + _url.CUSTOMERS_PAGINATE_URL;
	  return function (dispatch) {
	    dispatch(requestCustomersPaginate());
	    return (0, _axios2.default)({
	      method: 'get',
	      url: url,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      params: {
	        page: currentPage,
	        limit: limit,
	        CustomerNum: searchFilter.CustomerNum,
	        Name: searchFilter.Name,
	        Email: searchFilter.email,
	        Description: searchFilter.Description,
	        IsWholesale: searchFilter.IsWholesale,
	        PriceLevel: searchFilter.PriceLevel,
	        IsActive: searchFilter.IsActive,
	        MemberCard: searchFilter.MemberCard,
	        Reseller: searchFilter.Reseller,
	        phone: searchFilter.Telephone,
	        address: searchFilter.Street,
	        City: searchFilter.City
	      }
	    }).then(function (response) {
	      dispatch(fetchCustomersPaginateSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCustomersPaginateFailure(err));
	    });
	  };
	}
	
	function fetchActiveCustomers() {
	  return function (dispatch) {
	    dispatch(requestCustomers());
	    return (0, _axios2.default)({
	      method: 'get',
	      url: _url.CUSTOMERS_URL + '?Customer_id__IsActive=1',
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchCustomersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCustomersFailure(err));
	    });
	  };
	}
	
	function selectCustomer(customer) {
	  return {
	    type: _type.SELECT_CUSTOMER,
	    payload: customer
	  };
	}
	
	function resetCurrentCustomer() {
	  return {
	    type: _type.RESET_CURRENT_CUSTOMER
	  };
	}
	
	// Actions to deal with the promise of posting function.
	function requestCreatingCustomer() {
	  return {
	    type: _type.REQUEST_CREATING_CUSTOMER
	  };
	}
	
	function createCustomerSuccess() {
	  return {
	    type: _type.CREATE_CUSTOMER_SUCCESS
	  };
	}
	
	function createCustomerFailure(error) {
	  return {
	    type: _type.CREATE_CUSTOMER_FAILURE,
	    payload: error
	  };
	}
	
	function createCustomer(_ref, _ref2) {
	  var Billing = _ref.Billing,
	      CreditLimit = _ref.CreditLimit,
	      CustomerNum = _ref.CustomerNum,
	      DeliverPlan_id = _ref.DeliverPlan_id,
	      Description = _ref.Description,
	      email = _ref.email,
	      IsActive = _ref.IsActive,
	      IsPrtGeneralInfor = _ref.IsPrtGeneralInfor,
	      IsPrtReminder = _ref.IsPrtReminder,
	      IsShowPrice = _ref.IsShowPrice,
	      IsShippingFee = _ref.IsShippingFee,
	      IsWholesale = _ref.IsWholesale,
	      Mailing = _ref.Mailing,
	      Name = _ref.Name,
	      ContactName = _ref.ContactName,
	      Notation = _ref.Notation,
	      PaymentTerm_id = _ref.PaymentTerm_id,
	      StorageFeeType = _ref.StorageFeeType,
	      PriceLevel = _ref.PriceLevel,
	      RefNum = _ref.RefNum,
	      Sales_User_id = _ref.Sales_User_id,
	      Shipping = _ref.Shipping,
	      Wholesale_ResaleNo = _ref.Wholesale_ResaleNo,
	      FinanceEmail = _ref.FinanceEmail,
	      OperationEmail = _ref.OperationEmail,
	      EIN = _ref.EIN,
	      StorageFreeDays = _ref.StorageFreeDays,
	      FlatMarkup = _ref.FlatMarkup,
	      PctMarkup = _ref.PctMarkup,
	      DLN = _ref.DLN,
	      Reseller = _ref.Reseller,
	      MemberCard = _ref.MemberCard,
	      DiscountPercentage = _ref.DiscountPercentage,
	      Route_id = _ref.Route_id;
	  var BusinessType = _ref2.businessType,
	      CreditStatus = _ref2.creditStatus,
	      IsStripe = _ref2.IsStripe,
	      Sub_Customer_id = _ref2.Sub_Customer_id;
	
	  // if(ControlledMailingAddress) {
	  //   MailingAddress = {...ControlledMailingAddress};
	  // }
	  // if(ControlledMailingContact) {
	  //   MailingContact = {...ControlledMailingContact};
	  // }
	  // if(ShippingAddress && currentShippingAddress) {
	  //   if(ShippingAddress[0] && currentShippingAddress) {
	  //     ShippingAddress[0] = {...ShippingAddress[0], ...currentShippingAddress};
	  //   }
	  // }
	  // if(ShippingContact && currentShippingContact) {
	  //   if(ShippingContact[0] && currentShippingContact) {
	  //     ShippingContact[0] = {...ShippingContact[0], currentShippingContact};
	  //   }
	  // }
	  if (PaymentTerm_id) {
	    PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
	  }
	  if (StorageFeeType) {
	    StorageFeeType = StorageFeeType.value || StorageFeeType;
	  }
	  if (Sales_User_id) {
	    Sales_User_id = Sales_User_id.value || Sales_User_id;
	  }
	  if (Shipping && Shipping.length > 0 && isMAG) {
	    Shipping.map(function (r, index) {
	      if (r.DrayageCode && r.DrayageCode.value) {
	        r.DrayageCode = r.DrayageCode.value;
	      }
	    });
	  }
	
	  var noBilling = false;
	  if (isYI && (!Billing || Object.keys(Billing).length === 0)) {
	    noBilling = true;
	  }
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CREATING_CUSTOMER });
	    _axios2.default.post(_url.CUSTOMERS_URL, noBilling ? {
	      CustomerNum: CustomerNum,
	      RefNum: RefNum,
	      Name: Name,
	      ContactName: ContactName,
	      Description: Description,
	      IsWholesale: IsWholesale,
	      IsShowPrice: IsShowPrice,
	      IsShippingFee: IsShippingFee,
	      CreditLimit: CreditLimit,
	      CreditStatus: CreditStatus,
	      PriceLevel: PriceLevel,
	      IsActive: IsActive,
	      DeliverPlan_id: DeliverPlan_id,
	      IsPrtReminder: IsPrtReminder,
	      IsPrtGeneralInfor: IsPrtGeneralInfor,
	      Sales_User_id: Sales_User_id,
	      PaymentTerm_id: PaymentTerm_id,
	      StorageFeeType: StorageFeeType,
	      Notation: Notation,
	      Shipping: Shipping,
	      // Mailing,
	      // Billing,
	      email: email,
	      BusinessType: BusinessType,
	      IsStripe: IsStripe,
	      Wholesale_ResaleNo: Wholesale_ResaleNo,
	      FinanceEmail: FinanceEmail,
	      OperationEmail: OperationEmail,
	      EIN: EIN,
	      StorageFreeDays: StorageFreeDays,
	      FlatMarkup: FlatMarkup,
	      PctMarkup: PctMarkup,
	      DLN: DLN,
	      Reseller: Reseller,
	      MemberCard: MemberCard,
	      Sub_Customer_id: Sub_Customer_id,
	      DiscountPercentage: DiscountPercentage,
	      Route_id: Route_id
	    } : {
	      CustomerNum: CustomerNum,
	      RefNum: RefNum,
	      Name: Name,
	      ContactName: ContactName,
	      Description: Description,
	      IsWholesale: IsWholesale,
	      IsShowPrice: IsShowPrice,
	      IsShippingFee: IsShippingFee,
	      CreditLimit: CreditLimit,
	      CreditStatus: CreditStatus,
	      PriceLevel: PriceLevel,
	      IsActive: IsActive,
	      DeliverPlan_id: DeliverPlan_id,
	      IsPrtReminder: IsPrtReminder,
	      IsPrtGeneralInfor: IsPrtGeneralInfor,
	      Sales_User_id: Sales_User_id,
	      PaymentTerm_id: PaymentTerm_id,
	      StorageFeeType: StorageFeeType,
	      Notation: Notation,
	      Shipping: Shipping,
	      Mailing: Mailing,
	      Billing: Billing,
	      email: email,
	      BusinessType: BusinessType,
	      IsStripe: IsStripe,
	      Wholesale_ResaleNo: Wholesale_ResaleNo,
	      FinanceEmail: FinanceEmail,
	      OperationEmail: OperationEmail,
	      EIN: EIN,
	      StorageFreeDays: StorageFreeDays,
	      FlatMarkup: FlatMarkup,
	      PctMarkup: PctMarkup,
	      DLN: DLN,
	      Reseller: Reseller,
	      MemberCard: MemberCard,
	      Sub_Customer_id: Sub_Customer_id,
	      DiscountPercentage: DiscountPercentage,
	      Route_id: Route_id
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function () {
	      dispatch(createCustomerSuccess());
	      _reactRouter.browserHistory.push('/customers');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(createCustomerFailure(err));
	    });
	  };
	}
	
	// Edit Customer
	function editCustomerSuccess() {
	  return {
	    type: _type.EDIT_CUSTOMER_SUCCESS
	  };
	}
	function editCustomerFailure(error) {
	  return {
	    type: _type.EDIT_CUSTOMER_FAILURE,
	    payload: error
	  };
	}
	function editCustomer(_ref3, _ref4) {
	  var Customer_id = _ref3.Customer_id,
	      CustomerNum = _ref3.CustomerNum,
	      RefNum = _ref3.RefNum,
	      Name = _ref3.Name,
	      ContactName = _ref3.ContactName,
	      Description = _ref3.Description,
	      IsWholesale = _ref3.IsWholesale,
	      IsShowPrice = _ref3.IsShowPrice,
	      IsShippingFee = _ref3.IsShippingFee,
	      CreditLimit = _ref3.CreditLimit,
	      PriceLevel = _ref3.PriceLevel,
	      IsActive = _ref3.IsActive,
	      DeliverPlan_id = _ref3.DeliverPlan_id,
	      IsPrtReminder = _ref3.IsPrtReminder,
	      IsPrtGeneralInfor = _ref3.IsPrtGeneralInfor,
	      Sales_User_id = _ref3.Sales_User_id,
	      PaymentTerm_id = _ref3.PaymentTerm_id,
	      StorageFeeType = _ref3.StorageFeeType,
	      Notation = _ref3.Notation,
	      Shipping = _ref3.Shipping,
	      Mailing = _ref3.Mailing,
	      Billing = _ref3.Billing,
	      email = _ref3.email,
	      Wholesale_ResaleNo = _ref3.Wholesale_ResaleNo,
	      FinanceEmail = _ref3.FinanceEmail,
	      OperationEmail = _ref3.OperationEmail,
	      EIN = _ref3.EIN,
	      StorageFreeDays = _ref3.StorageFreeDays,
	      FlatMarkup = _ref3.FlatMarkup,
	      PctMarkup = _ref3.PctMarkup,
	      DLN = _ref3.DLN,
	      Reseller = _ref3.Reseller,
	      MemberCard = _ref3.MemberCard,
	      DiscountPercentage = _ref3.DiscountPercentage,
	      Route_id = _ref3.Route_id;
	  var BusinessType = _ref4.businessType,
	      CreditStatus = _ref4.creditStatus,
	      IsStripe = _ref4.IsStripe,
	      Sub_Customer_id = _ref4.Sub_Customer_id;
	
	  // if(ControlledMailingAddress) {
	  //   MailingAddress = {...ControlledMailingAddress};
	  // }
	  // if(ControlledMailingContact) {
	  //   MailingContact = {...ControlledMailingContact};
	  // }
	  // if(ShippingAddress && currentShippingAddress) {
	  //   if(ShippingAddress[0] && currentShippingAddress) {
	  //     ShippingAddress[0] = {...ShippingAddress[0], ...currentShippingAddress};
	  //   }
	  // }
	  // if(ShippingContact && currentShippingContact) {
	  //   if(ShippingContact[0] && currentShippingContact) {
	  //     ShippingContact[0] = currentShippingContact;
	  //   }
	  // }
	  if (PaymentTerm_id) {
	    PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
	  }
	  if (StorageFeeType) {
	    StorageFeeType = StorageFeeType.value || StorageFeeType;
	  }
	  if (Sales_User_id) {
	    Sales_User_id = Sales_User_id.value || Sales_User_id;
	  }
	  if (Shipping && Shipping.length > 0 && isMAG) {
	    Shipping.map(function (r, index) {
	      if (r.DrayageCode && r.DrayageCode.value) {
	        r.DrayageCode = r.DrayageCode.value;
	      }
	    });
	  }
	
	  var noBilling = false;
	  if (isYI && (!Billing || Object.keys(Billing).length === 0)) {
	    noBilling = true;
	  }
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EDITING_CUSTOMER });
	    _axios2.default.put(_url.CUSTOMERS_URL + Customer_id, noBilling ? {
	      CustomerNum: CustomerNum,
	      RefNum: RefNum,
	      Name: Name,
	      ContactName: ContactName,
	      Description: Description,
	      IsWholesale: IsWholesale,
	      IsShowPrice: IsShowPrice,
	      IsShippingFee: IsShippingFee,
	      CreditLimit: CreditLimit,
	      CreditStatus: CreditStatus,
	      PriceLevel: PriceLevel,
	      IsActive: IsActive,
	      DeliverPlan_id: DeliverPlan_id,
	      IsPrtReminder: IsPrtReminder,
	      IsPrtGeneralInfor: IsPrtGeneralInfor,
	      Sales_User_id: Sales_User_id,
	      PaymentTerm_id: PaymentTerm_id,
	      StorageFeeType: StorageFeeType,
	      Notation: Notation,
	      Shipping: Shipping,
	      // Mailing,
	      // Billing,
	      email: email,
	      BusinessType: BusinessType,
	      IsStripe: IsStripe,
	      Wholesale_ResaleNo: Wholesale_ResaleNo,
	      FinanceEmail: FinanceEmail,
	      OperationEmail: OperationEmail,
	      EIN: EIN,
	      StorageFreeDays: StorageFreeDays,
	      FlatMarkup: FlatMarkup,
	      PctMarkup: PctMarkup,
	      DLN: DLN,
	      Reseller: Reseller,
	      MemberCard: MemberCard,
	      Sub_Customer_id: Sub_Customer_id,
	      DiscountPercentage: DiscountPercentage,
	      Route_id: Route_id
	    } : {
	      CustomerNum: CustomerNum,
	      RefNum: RefNum,
	      Name: Name,
	      ContactName: ContactName,
	      Description: Description,
	      IsWholesale: IsWholesale,
	      IsShowPrice: IsShowPrice,
	      IsShippingFee: IsShippingFee,
	      CreditLimit: CreditLimit,
	      CreditStatus: CreditStatus,
	      PriceLevel: PriceLevel,
	      IsActive: IsActive,
	      DeliverPlan_id: DeliverPlan_id,
	      IsPrtReminder: IsPrtReminder,
	      IsPrtGeneralInfor: IsPrtGeneralInfor,
	      Sales_User_id: Sales_User_id,
	      PaymentTerm_id: PaymentTerm_id,
	      StorageFeeType: StorageFeeType,
	      Notation: Notation,
	      Shipping: Shipping,
	      Mailing: Mailing,
	      Billing: Billing,
	      email: email,
	      BusinessType: BusinessType,
	      IsStripe: IsStripe,
	      Wholesale_ResaleNo: Wholesale_ResaleNo,
	      FinanceEmail: FinanceEmail,
	      OperationEmail: OperationEmail,
	      EIN: EIN,
	      StorageFreeDays: StorageFreeDays,
	      FlatMarkup: FlatMarkup,
	      PctMarkup: PctMarkup,
	      DLN: DLN,
	      Reseller: Reseller,
	      MemberCard: MemberCard,
	      Sub_Customer_id: Sub_Customer_id,
	      DiscountPercentage: DiscountPercentage,
	      Route_id: Route_id
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function () {
	      dispatch(editCustomerSuccess());
	      _reactRouter.browserHistory.push('/customers'); // If editd succesfully, refresh the paymentTerm page.
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editCustomerFailure(err));
	    });
	  };
	}
	
	function editCustomerGroup(_ref5) {
	  var Customer_id = _ref5.Customer_id,
	      CustomerGroup_id = _ref5.CustomerGroup_id;
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EDITING_CUSTOMER });
	    _axios2.default.put(_url.CUSTOMERS_URL + Customer_id, {
	      CustomerGroup_id: CustomerGroup_id
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function () {
	      dispatch(editCustomerSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editCustomerFailure(err));
	    });
	  };
	}
	
	function requestEditingCustomer() {
	  return {
	    type: _type.REQUEST_EDITING_CUSTOMER
	  };
	}
	
	// Fetch the detail page.
	function requestCustomerDetail() {
	  return {
	    type: _type.REQUEST_CUSTOMER_DETAIL
	  };
	}
	function fetchCustomerDetailSuccess(customerDetail) {
	  return {
	    type: _type.FETCH_CUSTOMER_DETAIL_SUCCESS,
	    payload: customerDetail
	  };
	}
	function fetchCustomerDetailFailure(error) {
	  return {
	    type: _type.FETCH_CUSTOMER_DETAIL_FAILURE,
	    payload: error
	  };
	}
	function fetchCustomerDetail(customer_id) {
	  return function (dispatch) {
	    dispatch(requestCustomerDetail());
	    return _axios2.default.get(_url.CUSTOMERS_URL + customer_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchCustomerDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCustomerDetailFailure(err));
	    });
	  };
	}
	
	// fetch Customer Credit By Date
	function requestCustomerCreditByDate() {
	  return {
	    type: _type.REQUEST_CUSTOMER_CREDIT_BY_DATE
	  };
	}
	
	function fetchCustomerCreditByDateSuccess(customerDetail) {
	  return {
	    type: _type.FETCH_CUSTOMER_CREDIT_BY_DATE_SUCCESS,
	    payload: customerDetail
	  };
	}
	function fetchCustomerCreditByDateFailure(error) {
	  return {
	    type: _type.FETCH_CUSTOMER_CREDIT_BY_DATE_FAILURE,
	    payload: error
	  };
	}
	function fetchCustomerCreditByDate(date) {
	  return function (dispatch) {
	    dispatch(requestCustomerCreditByDate());
	    return _axios2.default.get(_url.CUSTOMER_CREDIT_LINES_URL + date, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchCustomerCreditByDateSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCustomerCreditByDateFailure(err));
	    });
	  };
	}
	
	// Fetch Customers Status
	function fetchCustomersStatusSuccess(statuses) {
	  return {
	    type: _type.FETCH_CUSTOMERS_STATUS_SUCCESS,
	    payload: statuses
	  };
	}
	function fetchCustomersStatusFailure(error) {
	  return {
	    type: _type.FETCH_CUSTOMERS_STATUS_FAILURE,
	    payload: error
	  };
	}
	function fetchCustomersStatus() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CUSTOMERS_STATUS });
	    return _axios2.default.get(_url.CUSTOMERS_STATUS_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchCustomersStatusSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCustomersStatusFailure(err));
	    });
	  };
	}
	
	// Attach Document
	function attachDocumentSuccess() {
	  return {
	    type: _type.ATTACH_DOCUMENT_SUCCESS
	  };
	}
	function attachDocumentFailure(error) {
	  return {
	    type: _type.ATTACH_DOCUMENT_FAILURE,
	    payload: error
	  };
	}
	function attachDocument(files) {
	  return function (dispatch) {
	    dispatch({ type: _type.ATTACH_DOCUMENT });
	    var data = new FormData();
	    data.append('customer_file', files[0]);
	
	    return _axios2.default.post(_url.UPLOAD_URL + 'customer/', data, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(attachDocumentSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(attachDocumentFailure(err));
	    });
	  };
	}
	
	function fetchFJAgents(customer) {
	  var url = '' + _url.FETCH_FJ_AGENTS_URL + customer;
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'get',
	      url: url,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function updateFJAgents(customer, agentsArray) {
	  var output = [];
	  agentsArray.map(function (r) {
	    if (r.name) {
	      output.push(r);
	    }
	  });
	  // if (output.length === 0) {
	  //   alert("Must have at least one valid agent name");
	  //   return;
	  // }
	  var url = '' + _url.FETCH_FJ_AGENTS_URL + customer;
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'post',
	      url: url,
	      data: output,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function deleteFJAgents(agent) {
	  var url = '' + _url.FETCH_FJ_AGENTS_URL + agent;
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'delete',
	      url: url,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function fetchPT(customer, type) {
	  var url = '';
	  if (type === "Vendor") {
	    url = '' + _url.FETCH_PRICE_TABLE_URL_VENDOR + customer;
	  } else {
	    url = '' + _url.FETCH_PRICE_TABLE_URL + customer;
	  }
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'get',
	      url: url,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	
	function updatePT(customer, priceArray, type) {
	  // let output = [];
	  // priceArray.map(r => {
	  //   if (r.name) {
	  //     output.push(r);
	  //   }
	  // });
	  var output = { fees: priceArray };
	  var url = '';
	  if (type === "Vendor") {
	    url = '' + _url.FETCH_PRICE_TABLE_URL_VENDOR + customer;
	  } else {
	    url = '' + _url.FETCH_PRICE_TABLE_URL + customer;
	  }
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'post',
	      url: url,
	      data: output,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestCustomers, 'requestCustomers', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomersSuccess, 'fetchCustomersSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomersFailure, 'fetchCustomersFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomers, 'fetchCustomers', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestCustomersPaginate, 'requestCustomersPaginate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomersPaginateSuccess, 'fetchCustomersPaginateSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomersPaginateFailure, 'fetchCustomersPaginateFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomersPaginate, 'fetchCustomersPaginate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchActiveCustomers, 'fetchActiveCustomers', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(selectCustomer, 'selectCustomer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetCurrentCustomer, 'resetCurrentCustomer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestCreatingCustomer, 'requestCreatingCustomer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(createCustomerSuccess, 'createCustomerSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(createCustomerFailure, 'createCustomerFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(createCustomer, 'createCustomer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(editCustomerSuccess, 'editCustomerSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(editCustomerFailure, 'editCustomerFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(editCustomer, 'editCustomer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(editCustomerGroup, 'editCustomerGroup', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestEditingCustomer, 'requestEditingCustomer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestCustomerDetail, 'requestCustomerDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerDetailSuccess, 'fetchCustomerDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerDetailFailure, 'fetchCustomerDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerDetail, 'fetchCustomerDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestCustomerCreditByDate, 'requestCustomerCreditByDate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerCreditByDateSuccess, 'fetchCustomerCreditByDateSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerCreditByDateFailure, 'fetchCustomerCreditByDateFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerCreditByDate, 'fetchCustomerCreditByDate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomersStatusSuccess, 'fetchCustomersStatusSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomersStatusFailure, 'fetchCustomersStatusFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomersStatus, 'fetchCustomersStatus', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(attachDocumentSuccess, 'attachDocumentSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(attachDocumentFailure, 'attachDocumentFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(attachDocument, 'attachDocument', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchFJAgents, 'fetchFJAgents', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(updateFJAgents, 'updateFJAgents', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteFJAgents, 'deleteFJAgents', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPT, 'fetchPT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(updatePT, 'updatePT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(isMAG, 'isMAG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	
	  __REACT_HOT_LOADER__.register(isYI, 'isYI', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/customers_actions.js');
	}();

	;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.changeField = undefined;
	exports.fetchAR = fetchAR;
	exports.fetchARSuccess = fetchARSuccess;
	exports.fetchARFailure = fetchARFailure;
	exports.createAR = createAR;
	exports.createARSuccess = createARSuccess;
	exports.createARFailure = createARFailure;
	exports.editAR = editAR;
	exports.editARSuccess = editARSuccess;
	exports.editARFailure = editARFailure;
	exports.deleteAR = deleteAR;
	exports.refundARSuccess = refundARSuccess;
	exports.refundARFailure = refundARFailure;
	exports.refundAR = refundAR;
	exports.bounceCheck = bounceCheck;
	exports.fetchARInvoices = fetchARInvoices;
	exports.fetchInvoicesSuccess = fetchInvoicesSuccess;
	exports.fetchInvoicesFailure = fetchInvoicesFailure;
	exports.fetchARCredits = fetchARCredits;
	exports.fetchCreditsSuccess = fetchCreditsSuccess;
	exports.fetchCreditsFailure = fetchCreditsFailure;
	exports.clearCredits = clearCredits;
	exports.fetchARAccounts = fetchARAccounts;
	exports.fetchAccountsSuccess = fetchAccountsSuccess;
	exports.fetchAccountsFailure = fetchAccountsFailure;
	exports.clearARAccounts = clearARAccounts;
	exports.fetchARDetail = fetchARDetail;
	exports.fetchARDetailSuccess = fetchARDetailSuccess;
	exports.fetchARDetailFailure = fetchARDetailFailure;
	exports.clearARDetail = clearARDetail;
	exports.clearARForm = clearARForm;
	exports.fetchAP = fetchAP;
	exports.fetchAPSuccess = fetchAPSuccess;
	exports.fetchAPFailure = fetchAPFailure;
	exports.createAP = createAP;
	exports.createAPSuccess = createAPSuccess;
	exports.createAPFailure = createAPFailure;
	exports.editAP = editAP;
	exports.editAPSuccess = editAPSuccess;
	exports.editAPFailure = editAPFailure;
	exports.deleteAP = deleteAP;
	exports.fetchAPInvoices = fetchAPInvoices;
	exports.fetchAPCredits = fetchAPCredits;
	exports.fetchAPDetail = fetchAPDetail;
	exports.fetchAPDetailSuccess = fetchAPDetailSuccess;
	exports.fetchAPDetailFailure = fetchAPDetailFailure;
	exports.clearAPDetail = clearAPDetail;
	exports.clearAPForm = clearAPForm;
	exports.fetchStatement = fetchStatement;
	exports.fetchStatementSuccess = fetchStatementSuccess;
	exports.fetchStatementFailure = fetchStatementFailure;
	exports.fetchStatementAP = fetchStatementAP;
	exports.fetchStatementAPSuccess = fetchStatementAPSuccess;
	exports.fetchStatementAPFailure = fetchStatementAPFailure;
	exports.fetchGeneralReport = fetchGeneralReport;
	exports.fetchGeneralReportSuccess = fetchGeneralReportSuccess;
	exports.fetchGeneralReportFailure = fetchGeneralReportFailure;
	exports.fetchCityReport = fetchCityReport;
	exports.fetchCityReportSuccess = fetchCityReportSuccess;
	exports.fetchCityReportFailure = fetchCityReportFailure;
	exports.resetCityReport = resetCityReport;
	exports.fetchCustomerStatement = fetchCustomerStatement;
	exports.fetchCustomerStatementSuccess = fetchCustomerStatementSuccess;
	exports.fetchCustomerStatementFailure = fetchCustomerStatementFailure;
	exports.fetchVendorStatement = fetchVendorStatement;
	exports.fetchVendorStatementSuccess = fetchVendorStatementSuccess;
	exports.fetchVendorStatementFailure = fetchVendorStatementFailure;
	exports.fetchCustomerStatementListSuccess = fetchCustomerStatementListSuccess;
	exports.fetchCustomerStatementListFailure = fetchCustomerStatementListFailure;
	exports.fetchCustomerStatementList = fetchCustomerStatementList;
	exports.fetchVendorStatementList = fetchVendorStatementList;
	exports.fetchVendorStatementListSuccess = fetchVendorStatementListSuccess;
	exports.fetchVendorStatementListFailure = fetchVendorStatementListFailure;
	exports.fetchMobileCustomerStatement = fetchMobileCustomerStatement;
	exports.fetchMobileCustomerStatementSuccess = fetchMobileCustomerStatementSuccess;
	exports.fetchMobileCustomerStatementFailure = fetchMobileCustomerStatementFailure;
	exports.resetMobileCustomerStatement = resetMobileCustomerStatement;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _root_url = __webpack_require__(9);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isAFG = _root_url.ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afgstage-scm.truckxi.com/api/';
	
	function fetchAR(fromDate, toDate, days) {
	  var dates = (0, _cleanDates.toFromDates)(days, fromDate, toDate);
	  fromDate = "PaymentDate__gte=" + dates.fromDate + "&";
	  toDate = "PaymentDate__lte=" + dates.toDate;
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_AR });
	    return _axios2.default.get(_url.AR_URL + 'payment/?' + fromDate + toDate, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchARSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchARFailure(err));
	    });
	  };
	}
	
	function fetchARSuccess(response) {
	  return {
	    type: _type.FETCH_AR_SUCCESS,
	    payload: response
	  };
	}
	
	function fetchARFailure(response) {
	  return {
	    type: _type.FETCH_AR_FAILURE,
	    payload: response
	  };
	}
	
	function createAR(_ref, Invoices) {
	  var Customer = _ref.Customer,
	      TotalPayment = _ref.TotalPayment,
	      PaymentDate = _ref.PaymentDate,
	      PenaltyAmount = _ref.PenaltyAmount,
	      Method = _ref.Method,
	      CheckNum = _ref.CheckNum,
	      Credits = _ref.Credits,
	      Account = _ref.Account,
	      AccountName = _ref.AccountName,
	      Discount = _ref.Discount,
	      DiscountedAmount = _ref.DiscountedAmount,
	      Waive = _ref.Waive,
	      WaiveAmount = _ref.WaiveAmount,
	      TotalAmount = _ref.TotalAmount,
	      Note = _ref.Note;
	
	  if (Customer) Customer = Customer.value || Customer;
	  if (Account) Account = Account.value || Account;
	  if (Method) Method = Method.value || Method;
	  return function (dispatch) {
	    dispatch({ type: _type.CREATE_AR });
	    return _axios2.default.post(_url.AR_URL + 'payment/', {
	      Customer: Customer,
	      TotalPayment: TotalPayment,
	      PaymentDate: PaymentDate,
	      PenaltyAmount: PenaltyAmount,
	      Method: Method,
	      CheckNum: CheckNum,
	      Credits: Credits,
	      Account: Account,
	      AccountName: AccountName,
	      Discount: Discount,
	      Waive: Waive,
	      WaiveAmount: WaiveAmount,
	      TotalAmount: TotalAmount,
	      DiscountedAmount: DiscountedAmount,
	      Note: Note,
	      Invoices: Invoices
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(createARSuccess(response));
	      _reactRouter.browserHistory.push('/AR');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(createARFailure(err));
	    });
	  };
	}
	
	function createARSuccess(response) {
	  return {
	    type: _type.CREATE_AR_SUCCESS,
	    payload: response
	  };
	}
	
	function createARFailure(response) {
	  return {
	    type: _type.CREATE_AR_FAILURE,
	    payload: response
	  };
	}
	
	function editAR(_ref2, Invoices) {
	  var Customer = _ref2.Customer,
	      Payment_id = _ref2.Payment_id,
	      PaymentDate = _ref2.PaymentDate,
	      PenaltyAmount = _ref2.PenaltyAmount,
	      TotalPayment = _ref2.TotalPayment,
	      Method = _ref2.Method,
	      CheckNum = _ref2.CheckNum,
	      Account = _ref2.Account,
	      AccountName = _ref2.AccountName,
	      Discount = _ref2.Discount,
	      DiscountedAmount = _ref2.DiscountedAmount,
	      Note = _ref2.Note,
	      Waive = _ref2.Waive,
	      WaiveAmount = _ref2.WaiveAmount,
	      TotalAmount = _ref2.TotalAmount;
	
	  if (Customer) Customer = Customer.value || Customer;
	  if (Account) Account = Account.value || Account;
	  if (Method) Method = Method.value || Method;
	  return function (dispatch) {
	    dispatch({ type: _type.EDIT_AR });
	    return _axios2.default.put(_url.AR_URL + 'payment/' + Payment_id, {
	      Customer: Customer,
	      PaymentDate: PaymentDate,
	      TotalPayment: TotalPayment,
	      PenaltyAmount: PenaltyAmount,
	      Method: Method,
	      CheckNum: CheckNum,
	      Account: Account,
	      AccountName: AccountName,
	      Discount: Discount,
	      DiscountedAmount: DiscountedAmount,
	      Note: Note,
	      Waive: Waive,
	      WaiveAmount: WaiveAmount,
	      TotalAmount: TotalAmount,
	      Invoices: Invoices
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editARSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editARFailure(err));
	    });
	  };
	}
	
	function editARSuccess(response) {
	  return {
	    type: _type.EDIT_AR_SUCCESS,
	    payload: response
	  };
	}
	
	function editARFailure(response) {
	  return {
	    type: _type.EDIT_AR_FAILURE,
	    payload: response
	  };
	}
	
	function deleteAR(Payment_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.DELETE_AR });
	    return _axios2.default.delete(_url.AR_URL + 'payment/' + Payment_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(deleteARSuccess(response));
	      _reactRouter.browserHistory.push('/AR');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(deleteARFailure(err));
	    });
	  };
	}
	
	function deleteARSuccess(response) {
	  return {
	    type: _type.DELETE_AR_SUCCESS,
	    payload: response
	  };
	}
	
	function deleteARFailure(response) {
	  return {
	    type: _type.DELETE_AR_FAILURE,
	    payload: response
	  };
	}
	
	function refundARSuccess(response) {
	  return {
	    type: _type.REFUND_AR_SUCCESS,
	    payload: response
	  };
	}
	
	function refundARFailure(response) {
	  return {
	    type: _type.REFUND_AR_FAILURE,
	    payload: response
	  };
	}
	
	var changeField = exports.changeField = function changeField(field, value, form) {
	  return function (dispatch) {
	    return dispatch((0, _reduxForm.change)(form, field, value));
	  };
	};
	/*
	*@refundProps - { Account, Customer, TotalPayment, PaymentDate, Method, CheckNum }
	*@Invoices - List of invoices in the right table of CreateAR
	*/
	function refundAR(refundProps, Invoices) {
	  var PaymentDate = refundProps.PaymentDate,
	      TotalPayment = refundProps.TotalPayment,
	      CheckNum = refundProps.CheckNum;
	
	  var Customer = refundProps.Customer ? refundProps.Customer.value || refundProps.Customer : null;
	  var Account = refundProps.Account ? refundProps.Account.value || refundProps.Account : null;
	  var Method = refundProps.Method ? refundProps.Method.value || refundProps.Method : null;
	  return function (dispatch) {
	    dispatch({ type: _type.REFUND_AR });
	    return (0, _axios2.default)({
	      method: 'post',
	      url: _url.AR_URL + 'refund/',
	      data: {
	        Customer: Customer,
	        TotalPayment: TotalPayment,
	        PaymentDate: PaymentDate,
	        Method: Method,
	        CheckNum: CheckNum,
	        Account: Account,
	        Invoices: Invoices
	      },
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(refundARSuccess(response));
	      _reactRouter.browserHistory.push('/AR');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(refundARFailure(err));
	    });
	  };
	}
	
	/* id: AR payment_id */
	function bounceCheck(id) {
	  var token = localStorage.getItem('token');
	  return function (dispatch) {
	    dispatch({ type: _type.BOUNCE_CHECK });
	    return (0, _axios2.default)({
	      method: 'post',
	      url: _url.AR_URL + 'bounce/' + id,
	      headers: { Authorization: 'Bearer ' + token }
	    }).then(function (response) {
	      dispatch(bounceCheckSuccess(response));
	      _reactRouter.browserHistory.push('/AR');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(bounceCheckFailure(err));
	    });
	  };
	}
	
	function bounceCheckSuccess(response) {
	  return {
	    type: _type.BOUNCE_CHECK_SUCCESS,
	    payload: response
	  };
	}
	
	function bounceCheckFailure(response) {
	  return {
	    type: _type.BOUNCE_CHECK_FAILURE,
	    payload: response
	  };
	}
	
	function fetchARInvoices(customer_id, invoiceDate, fromDate, toDate) {
	  var dates = (0, _cleanDates.toFromDates)(-1, fromDate, toDate);
	  if (invoiceDate == "range" && fromDate) {
	    fromDate = "PostingDate__gte=" + dates.fromDate + "&";
	  } else {
	    fromDate = "";
	  }
	  if (invoiceDate == "range" && toDate) {
	    toDate = "PostingDate__lte=" + dates.toDate + "&";
	  } else {
	    toDate = "";
	  }
	  customer_id = "Deliver_Customer_id=" + customer_id;
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_INVOICES });
	    return _axios2.default.get(_url.AR_URL + 'invoices/?' + fromDate + toDate + customer_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchInvoicesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchInvoicesFailure(err));
	    });
	  };
	}
	
	function fetchInvoicesSuccess(response) {
	  return {
	    type: _type.FETCH_INVOICES_SUCCESS,
	    payload: response
	  };
	}
	
	function fetchInvoicesFailure(response) {
	  return {
	    type: _type.FETCH_INVOICES_FAILURE,
	    payload: response
	  };
	}
	
	function fetchARCredits(customer_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CREDITS });
	    return _axios2.default.get(_url.AR_URL + 'credits/' + customer_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchCreditsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCreditsFailure(err));
	    });
	  };
	}
	
	function fetchCreditsSuccess(data) {
	  return {
	    type: _type.FETCH_CREDITS_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchCreditsFailure(error) {
	  return {
	    type: _type.FETCH_CREDITS_FAILURE,
	    payload: error
	  };
	}
	
	function clearCredits() {
	  return {
	    type: _type.CLEAR_CREDITS
	  };
	}
	
	function fetchARAccounts() {
	  var token = localStorage.getItem('token');
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_AR_ACCOUNTS });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: _url.AR_URL + 'accounts/',
	      headers: { Authorization: 'Bearer ' + token }
	    }).then(function (response) {
	      dispatch(fetchAccountsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchAccountsFailure(err));
	    });
	  };
	}
	
	function fetchAccountsSuccess(data) {
	  return {
	    type: _type.FETCH_AR_ACCOUNTS_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchAccountsFailure(error) {
	  return {
	    type: _type.FETCH_AR_ACCOUNTS_FAILURE,
	    payload: error
	  };
	}
	
	function clearARAccounts() {
	  return {
	    type: _type.CLEAR_AR_ACCOUNTS
	  };
	}
	
	function fetchARDetail(checkID) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_AR_DETAIL });
	    return _axios2.default.get(_url.AR_URL + 'payment/' + checkID, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchARDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchARDetailFailure(err));
	    });
	  };
	}
	
	function fetchARDetailSuccess(response) {
	  return {
	    type: _type.FETCH_AR_DETAIL_SUCCESS,
	    payload: response
	  };
	}
	
	function fetchARDetailFailure(response) {
	  return {
	    type: _type.FETCH_AR_DETAIL_FAILURE,
	    payload: response
	  };
	}
	
	function clearARDetail() {
	  return {
	    type: _type.CLEAR_AR_DETAIL
	  };
	}
	
	function clearARForm() {
	  return {
	    type: _type.CLEAR_AR_FORM
	  };
	}
	
	function fetchAP(fromDate, toDate, days) {
	  var dates = (0, _cleanDates.toFromDates)(days, fromDate, toDate);
	  fromDate = "PaymentDate__gte=" + dates.fromDate + "&";
	  toDate = "PaymentDate__lte=" + dates.toDate;
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_AP });
	    return _axios2.default.get(_url.AP_URL + 'payment/?' + fromDate + toDate, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchAPSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchAPFailure(err));
	    });
	  };
	}
	
	function fetchAPSuccess(response) {
	  return {
	    type: _type.FETCH_AP_SUCCESS,
	    payload: response
	  };
	}
	
	function fetchAPFailure(response) {
	  return {
	    type: _type.FETCH_AP_FAILURE,
	    payload: response
	  };
	}
	
	function createAP(_ref3, Invoices) {
	  var Vendor = _ref3.Vendor,
	      TotalPayment = _ref3.TotalPayment,
	      PaymentDate = _ref3.PaymentDate,
	      Method = _ref3.Method,
	      CheckNum = _ref3.CheckNum,
	      Credits = _ref3.Credits,
	      Account = _ref3.Account,
	      AccountName = _ref3.AccountName,
	      Discount = _ref3.Discount,
	      Note = _ref3.Note,
	      WaiveAmount = _ref3.WaiveAmount;
	
	  if (Vendor) Vendor = Vendor.value || Vendor;
	  if (Account) Account = Account.value || Account;
	  if (Method) Method = Method.value || Method;
	  return function (dispatch) {
	    dispatch({ type: _type.CREATE_AP });
	    return _axios2.default.post(_url.AP_URL + 'payment/', {
	      Vendor: Vendor,
	      TotalPayment: TotalPayment,
	      PaymentDate: PaymentDate,
	      Method: Method,
	      CheckNum: CheckNum,
	      Credits: Credits,
	      Account: Account,
	      AccountName: AccountName,
	      Discount: Discount,
	      WaiveAmount: WaiveAmount,
	      Note: Note,
	      Invoices: Invoices
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(createAPSuccess(response));
	      _reactRouter.browserHistory.push('/AP');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(createAPFailure(err));
	    });
	  };
	}
	
	function createAPSuccess(response) {
	  return {
	    type: _type.CREATE_AP_SUCCESS,
	    payload: response
	  };
	}
	
	function createAPFailure(response) {
	  return {
	    type: _type.CREATE_AP_FAILURE,
	    payload: response
	  };
	}
	
	function editAP(_ref4, Invoices) {
	  var TotalPayment = _ref4.TotalPayment,
	      Method = _ref4.Method,
	      PostingDate = _ref4.PostingDate,
	      PaymentDate = _ref4.PaymentDate,
	      PaymentID = _ref4.PaymentID,
	      CheckNum = _ref4.CheckNum,
	      WaiveAmount = _ref4.WaiveAmount,
	      Discount = _ref4.Discount,
	      Account = _ref4.Account,
	      AccountName = _ref4.AccountName,
	      Credits = _ref4.Credits,
	      Note = _ref4.Note;
	
	  if (Credits) {
	    Credits = Credits.map(function (credit) {
	      return credit.value || credit;
	    });
	  } else {
	    Credits = [];
	  }
	  Method = Method.value || Method;
	  return function (dispatch) {
	    dispatch({ type: _type.EDIT_AP });
	    return (0, _axios2.default)({
	      method: 'put',
	      url: _url.AP_URL + 'payment/' + PaymentID,
	      data: {
	        CheckNum: CheckNum,
	        TotalPayment: TotalPayment,
	        Method: Method,
	        PostingDate: PostingDate,
	        PaymentDate: PaymentDate,
	        WaiveAmount: WaiveAmount,
	        Discount: Discount,
	        Account: Account,
	        AccountName: AccountName,
	        Credits: Credits,
	        Note: Note,
	        Invoices: Invoices
	      },
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editAPSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editAPFailure(err));
	    });
	  };
	}
	
	function editAPSuccess(response) {
	  return {
	    type: _type.EDIT_AP_SUCCESS,
	    payload: response
	  };
	}
	
	function editAPFailure(response) {
	  return {
	    type: _type.EDIT_AP_FAILURE,
	    payload: response
	  };
	}
	
	function deleteAP(Payment_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.DELETE_AP });
	    return _axios2.default.delete(_url.AP_URL + 'payment/' + Payment_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(deleteAPSuccess(response));
	      _reactRouter.browserHistory.push('/AP');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(deleteAPFailure(err));
	    });
	  };
	}
	
	function deleteAPSuccess(response) {
	  return {
	    type: _type.DELETE_AP_SUCCESS,
	    payload: response
	  };
	}
	
	function deleteAPFailure(response) {
	  return {
	    type: _type.DELETE_AP_FAILURE,
	    payload: response
	  };
	}
	
	function fetchAPInvoices(vendor_id, invoiceDate, fromDate, toDate) {
	  var dates = (0, _cleanDates.toFromDates)(-1, fromDate, toDate);
	  if (invoiceDate == "range" && fromDate) {
	    fromDate = "PostingDate__gte=" + dates.fromDate + "&";
	  } else {
	    fromDate = "";
	  }
	  if (invoiceDate == "range" && toDate) {
	    toDate = "PostingDate__lte=" + dates.toDate + "&";
	  } else {
	    toDate = "";
	  }
	  vendor_id = "Vendor_id=" + vendor_id;
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_INVOICES });
	    return _axios2.default.get(_url.AP_URL + 'invoices/?' + fromDate + toDate + vendor_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchInvoicesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchInvoicesFailure(err));
	    });
	  };
	}
	
	function fetchAPCredits(vendor_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CREDITS });
	    return _axios2.default.get(_url.AP_URL + 'credits/' + vendor_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchCreditsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCreditsFailure(err));
	    });
	  };
	}
	
	function fetchAPDetail(checkID) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_AP_DETAIL });
	    return _axios2.default.get(_url.AP_URL + 'payment/' + checkID, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchAPDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchAPDetailFailure(err));
	    });
	  };
	}
	
	function fetchAPDetailSuccess(response) {
	  return {
	    type: _type.FETCH_AP_DETAIL_SUCCESS,
	    payload: response
	  };
	}
	
	function fetchAPDetailFailure(response) {
	  return {
	    type: _type.FETCH_AP_DETAIL_FAILURE,
	    payload: response
	  };
	}
	
	function clearAPDetail() {
	  return {
	    type: _type.CLEAR_AP_DETAIL
	  };
	}
	
	function clearAPForm() {
	  return {
	    type: _type.CLEAR_AP_FORM
	  };
	}
	
	function fetchStatement(CustomerNum, type, StartDate, EndDate) {
	  var dates = (0, _cleanDates.toFromDates)(-1, StartDate, EndDate);
	  StartDate = dates.fromDate;
	  EndDate = dates.toDate;
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_STATEMENT });
	    return _axios2.default.post(_url.AR_URL + 'statement/' + type + '/print/', {
	      CustomerNum: CustomerNum,
	      StartDate: StartDate,
	      EndDate: EndDate
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      window.open("data:application/pdf," + escape(response.data));
	      dispatch(fetchStatementSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchStatementFailure(err));
	    });
	  };
	}
	
	function fetchStatementSuccess(response) {
	  return {
	    type: _type.FETCH_STATEMENT_SUCCESS,
	    payload: response
	  };
	}
	
	function fetchStatementFailure(response) {
	  return {
	    type: _type.FETCH_STATEMENT_FAILURE,
	    payload: response
	  };
	}
	
	function fetchStatementAP(VendorNum, type, StartDate, EndDate) {
	  var dates = (0, _cleanDates.toFromDates)(-1, StartDate, EndDate);
	  StartDate = dates.fromDate;
	  EndDate = dates.toDate;
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_STATEMENT_AP });
	    return _axios2.default.post(_url.AP_URL + 'statement/' + type + '/print/', {
	      VendorNum: VendorNum,
	      StartDate: StartDate,
	      EndDate: EndDate
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      window.open("data:application/pdf," + escape(response.data));
	      dispatch(fetchStatementAPSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchStatementAPFailure(err));
	    });
	  };
	}
	
	function fetchStatementAPSuccess(response) {
	  return {
	    type: _type.FETCH_STATEMENT_AP_SUCCESS,
	    payload: response
	  };
	}
	
	function fetchStatementAPFailure(response) {
	  return {
	    type: _type.FETCH_STATEMENT_AP_FAILURE,
	    payload: response
	  };
	}
	
	function fetchGeneralReport(type, salesType, typeRadios, fromDate, toDate, state) {
	  var params = {
	    type: typeRadios,
	    start_date: fromDate,
	    end_date: toDate
	  };
	  if (isAFG) {
	    params['state'] = state;
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_GENERAL_REPORT });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: _url.AR_URL + 'report/' + type + '/' + salesType + '/',
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      params: params
	    }).then(function (response) {
	      dispatch(fetchGeneralReportSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchGeneralReportFailure(err));
	    });
	  };
	}
	
	function fetchGeneralReportSuccess(data) {
	  return {
	    type: _type.FETCH_GENERAL_REPORT_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchGeneralReportFailure(error) {
	  return {
	    type: _type.FETCH_GENERAL_REPORT_FAILURE,
	    payload: error
	  };
	}
	
	function fetchCityReport(_ref5) {
	  var fromDate = _ref5.fromDate,
	      toDate = _ref5.toDate;
	
	  var token = localStorage.getItem('token');
	  var dates = (0, _cleanDates.toFromDates)(-1, fromDate, toDate);
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CITY_REPORT });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: _url.AR_URL + 'cityreport/?start_date=' + dates.fromDate + '&end_date=' + dates.toDate,
	      headers: { Authorization: 'Bearer ' + token }
	    }).then(function (response) {
	      dispatch(fetchCityReportSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCityReportFailure(err));
	    });
	  };
	}
	
	function fetchCityReportSuccess(data) {
	  return {
	    type: _type.FETCH_CITY_REPORT_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchCityReportFailure(error) {
	  return {
	    type: _type.FETCH_CITY_REPORT_FAILURE,
	    payload: error
	  };
	}
	
	function resetCityReport() {
	  return function (dispatch) {
	    dispatch({ type: _type.RESET_CITY_REPORT });
	  };
	}
	
	function fetchCustomerStatement(fromDate, endDate, customerID, statementType, paymentCutoffDate) {
	  var token = localStorage.getItem('token');
	  var dates = (0, _cleanDates.toFromDates)(-1, fromDate, endDate);
	  var postingDateGT = 'start_date=' + dates.fromDate;
	  var postingDateLT = 'end_date=' + dates.toDate;
	  var url = _url.AR_URL + 'report/aged/' + customerID + '/?' + postingDateGT + '&' + postingDateLT + '&cut_off_date=' + (0, _cleanDates.getFromToDates)(paymentCutoffDate).toDate;
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CUSTOMER_STATEMENT });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: url,
	      headers: { Authorization: 'Bearer ' + token }
	    }).then(function (response) {
	      dispatch(fetchCustomerStatementSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCustomerStatementFailure(err));
	    });
	  };
	}
	
	function fetchCustomerStatementSuccess(data) {
	  return {
	    type: _type.FETCH_CUSTOMER_STATEMENT_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchCustomerStatementFailure(error) {
	  return {
	    type: _type.FETCH_CUSTOMER_STATEMENT_FAILURE,
	    payload: error
	  };
	}
	
	function fetchVendorStatement(fromDate, endDate, vendorID, statementType, paymentCutoffDate) {
	  var token = localStorage.getItem('token');
	  var dates = (0, _cleanDates.toFromDates)(-1, fromDate, endDate);
	  var postingDateGT = 'start_date=' + dates.fromDate;
	  var postingDateLT = 'end_date=' + dates.toDate;
	  var url = _url.AP_URL + 'report/aged/' + vendorID + '/?' + postingDateGT + '&' + postingDateLT + '&cut_off_date=' + (0, _cleanDates.getFromToDates)(paymentCutoffDate).toDate;
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_VENDOR_STATEMENT });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: url,
	      headers: { Authorization: 'Bearer ' + token }
	    }).then(function (response) {
	      dispatch(fetchVendorStatementSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchVendorStatementFailure(err));
	    });
	  };
	}
	
	function fetchVendorStatementSuccess(data) {
	  return {
	    type: _type.FETCH_VENDOR_STATEMENT_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchVendorStatementFailure(error) {
	  return {
	    type: _type.FETCH_VENDOR_STATEMENT_FAILURE,
	    payload: error
	  };
	}
	
	function fetchCustomerStatementListSuccess(data) {
	  return {
	    type: _type.FETCH_CUSTOMER_STATEMENT_LIST_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchCustomerStatementListFailure(error) {
	  return {
	    type: _type.FETCH_CUSTOMER_STATEMENT_LIST_FAILURE,
	    payload: error
	  };
	}
	
	function fetchCustomerStatementList(type, date, paymentTerm) {
	  var _getFromToDates = (0, _cleanDates.getFromToDates)(date),
	      toDate = _getFromToDates.toDate;
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CUSTOMER_STATEMENT_LIST });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: _url.AR_URL + 'statement/show/' + type + '/',
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      params: {
	        PostingDate: toDate,
	        PaymentTerm_Name: paymentTerm && paymentTerm.label
	      }
	    }).then(function (response) {
	      dispatch(fetchCustomerStatementListSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCustomerStatementListFailure(err));
	    });
	  };
	}
	
	function fetchVendorStatementList(type, days) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_VENDOR_STATEMENT_LIST });
	    var date = moment(days).endOf('day');
	    date = date.toISOString();
	    return _axios2.default.get(_url.AP_URL + 'report/aged/' + type + "/show/?PostingDate=" + date, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchVendorStatementListSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchVendorStatementListFailure(err));
	    });
	  };
	}
	
	function fetchVendorStatementListSuccess(data) {
	  return {
	    type: _type.FETCH_VENDOR_STATEMENT_LIST_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchVendorStatementListFailure(error) {
	  return {
	    type: _type.FETCH_VENDOR_STATEMENT_LIST_FAILURE,
	    payload: error
	  };
	}
	
	function fetchMobileCustomerStatement(_ref6, type) {
	  var fromDate = _ref6.fromDate,
	      toDate = _ref6.toDate;
	
	  var url = _url.AR_URL + 'statement/mobile/show/';
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_MOBILE_CUSTOMER_STATEMENT });
	    var token = localStorage.getItem('token');
	    return (0, _axios2.default)({
	      method: 'get',
	      url: url,
	      headers: { Authorization: 'Bearer ' + token },
	      params: {
	        type: type,
	        start_date: fromDate,
	        end_date: toDate
	      }
	    }).then(function (response) {
	      dispatch(fetchMobileCustomerStatementSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchMobileCustomerStatementFailure(err));
	    });
	  };
	}
	
	function fetchMobileCustomerStatementSuccess(data) {
	  return {
	    type: _type.FETCH_MOBILE_CUSTOMER_STATEMENT_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchMobileCustomerStatementFailure(error) {
	  return {
	    type: _type.FETCH_MOBILE_CUSTOMER_STATEMENT_FAILURE,
	    payload: error
	  };
	}
	
	function resetMobileCustomerStatement() {
	  return function (dispatch) {
	    dispatch({ type: _type.RESET_MOBILE_CUSTOMER_STATEMENT });
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchAR, 'fetchAR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchARSuccess, 'fetchARSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchARFailure, 'fetchARFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(createAR, 'createAR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(createARSuccess, 'createARSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(createARFailure, 'createARFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(editAR, 'editAR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(editARSuccess, 'editARSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(editARFailure, 'editARFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(deleteAR, 'deleteAR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(deleteARSuccess, 'deleteARSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(deleteARFailure, 'deleteARFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(refundARSuccess, 'refundARSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(refundARFailure, 'refundARFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(changeField, 'changeField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(refundAR, 'refundAR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(bounceCheck, 'bounceCheck', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(bounceCheckSuccess, 'bounceCheckSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(bounceCheckFailure, 'bounceCheckFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchARInvoices, 'fetchARInvoices', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInvoicesSuccess, 'fetchInvoicesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInvoicesFailure, 'fetchInvoicesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchARCredits, 'fetchARCredits', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchCreditsSuccess, 'fetchCreditsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchCreditsFailure, 'fetchCreditsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(clearCredits, 'clearCredits', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchARAccounts, 'fetchARAccounts', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchAccountsSuccess, 'fetchAccountsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchAccountsFailure, 'fetchAccountsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(clearARAccounts, 'clearARAccounts', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchARDetail, 'fetchARDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchARDetailSuccess, 'fetchARDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchARDetailFailure, 'fetchARDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(clearARDetail, 'clearARDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(clearARForm, 'clearARForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchAP, 'fetchAP', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchAPSuccess, 'fetchAPSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchAPFailure, 'fetchAPFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(createAP, 'createAP', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(createAPSuccess, 'createAPSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(createAPFailure, 'createAPFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(editAP, 'editAP', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(editAPSuccess, 'editAPSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(editAPFailure, 'editAPFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(deleteAP, 'deleteAP', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(deleteAPSuccess, 'deleteAPSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(deleteAPFailure, 'deleteAPFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchAPInvoices, 'fetchAPInvoices', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchAPCredits, 'fetchAPCredits', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchAPDetail, 'fetchAPDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchAPDetailSuccess, 'fetchAPDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchAPDetailFailure, 'fetchAPDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(clearAPDetail, 'clearAPDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(clearAPForm, 'clearAPForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchStatement, 'fetchStatement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchStatementSuccess, 'fetchStatementSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchStatementFailure, 'fetchStatementFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchStatementAP, 'fetchStatementAP', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchStatementAPSuccess, 'fetchStatementAPSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchStatementAPFailure, 'fetchStatementAPFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchGeneralReport, 'fetchGeneralReport', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchGeneralReportSuccess, 'fetchGeneralReportSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchGeneralReportFailure, 'fetchGeneralReportFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchCityReport, 'fetchCityReport', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchCityReportSuccess, 'fetchCityReportSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchCityReportFailure, 'fetchCityReportFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(resetCityReport, 'resetCityReport', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerStatement, 'fetchCustomerStatement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerStatementSuccess, 'fetchCustomerStatementSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerStatementFailure, 'fetchCustomerStatementFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchVendorStatement, 'fetchVendorStatement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchVendorStatementSuccess, 'fetchVendorStatementSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchVendorStatementFailure, 'fetchVendorStatementFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerStatementListSuccess, 'fetchCustomerStatementListSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerStatementListFailure, 'fetchCustomerStatementListFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerStatementList, 'fetchCustomerStatementList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchVendorStatementList, 'fetchVendorStatementList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchVendorStatementListSuccess, 'fetchVendorStatementListSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchVendorStatementListFailure, 'fetchVendorStatementListFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchMobileCustomerStatement, 'fetchMobileCustomerStatement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchMobileCustomerStatementSuccess, 'fetchMobileCustomerStatementSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchMobileCustomerStatementFailure, 'fetchMobileCustomerStatementFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(resetMobileCustomerStatement, 'resetMobileCustomerStatement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(isAFG, 'isAFG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/arap_actions.jsx');
	}();

	;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchWarehouses = fetchWarehouses;
	exports.searchWarehouses = searchWarehouses;
	exports.fetchWarehousesSuccess = fetchWarehousesSuccess;
	exports.fetchWarehousesFailure = fetchWarehousesFailure;
	exports.selectWarehouse = selectWarehouse;
	exports.resetCurrentWarehouse = resetCurrentWarehouse;
	exports.resetWarehouses = resetWarehouses;
	exports.fetchWarehouseDetail = fetchWarehouseDetail;
	exports.fetchWarehouseDetailSuccess = fetchWarehouseDetailSuccess;
	exports.fetchWarehouseDetailFailure = fetchWarehouseDetailFailure;
	exports.createWarehouse = createWarehouse;
	exports.createWarehouseSuccess = createWarehouseSuccess;
	exports.createWarehouseFailure = createWarehouseFailure;
	exports.editWarehouse = editWarehouse;
	exports.editWarehouseDefault = editWarehouseDefault;
	exports.editWarehouseSuccess = editWarehouseSuccess;
	exports.editWarehouseSuccessDefault = editWarehouseSuccessDefault;
	exports.editWarehouseFailure = editWarehouseFailure;
	exports.fetchWarehouseSalesOrders = fetchWarehouseSalesOrders;
	exports.fetchWarehouseSalesOrdersSuccess = fetchWarehouseSalesOrdersSuccess;
	exports.fetchWarehouseSalesOrdersFailure = fetchWarehouseSalesOrdersFailure;
	exports.fetchWarehousePurchaseOrders = fetchWarehousePurchaseOrders;
	exports.fetchWarehousePurchaseOrdersSuccess = fetchWarehousePurchaseOrdersSuccess;
	exports.fetchWarehousePurchaseOrdersFailure = fetchWarehousePurchaseOrdersFailure;
	exports.fetchWarehouseBins = fetchWarehouseBins;
	exports.fetchWarehouseBinsSuccess = fetchWarehouseBinsSuccess;
	exports.fetchWarehouseBinsFailure = fetchWarehouseBinsFailure;
	exports.deleteWarehouse = deleteWarehouse;
	exports.deleteWarehouseSuccess = deleteWarehouseSuccess;
	exports.deleteWarehouseFailure = deleteWarehouseFailure;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Warehouses Actions
	
	function fetchWarehouses() {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_WAREHOUSES });
	        return _axios2.default.get(_url.WAREHOUSES_URL, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchWarehousesSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchWarehousesFailure(err));
	        });
	    };
	}
	
	function searchWarehouses(name) {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_WAREHOUSES });
	        return _axios2.default.get(_url.WAREHOUSES_URL + "?Name=" + name, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchWarehousesSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchWarehousesFailure(err));
	        });
	    };
	}
	
	function fetchWarehousesSuccess(warehouses) {
	    return {
	        type: _type.FETCH_WAREHOUSES_SUCCESS,
	        payload: warehouses
	    };
	}
	
	function fetchWarehousesFailure(error) {
	    return {
	        type: _type.FETCH_WAREHOUSES_FAILURE,
	        payload: error
	    };
	}
	
	function selectWarehouse(warehouse) {
	    return {
	        type: _type.SELECT_WAREHOUSE,
	        payload: warehouse
	    };
	}
	
	function resetCurrentWarehouse() {
	    return {
	        type: _type.RESET_CURRENT_WAREHOUSE
	    };
	}
	
	function resetWarehouses() {
	    return {
	        type: _type.RESET_WAREHOUSES
	    };
	}
	
	function fetchWarehouseDetail(warehouse_id) {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_WAREHOUSE_DETAIL });
	        return _axios2.default.get(_url.WAREHOUSES_URL + warehouse_id, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchWarehouseDetailSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchWarehouseDetailFailure(err));
	        });
	    };
	}
	
	function fetchWarehouseDetailSuccess(warehouseDetail) {
	    return {
	        type: _type.FETCH_WAREHOUSE_DETAIL_SUCCESS,
	        payload: warehouseDetail
	    };
	}
	
	function fetchWarehouseDetailFailure(error) {
	    return {
	        type: _type.FETCH_WAREHOUSE_DETAIL_FAILURE,
	        payload: error
	    };
	}
	
	function createWarehouse(_ref) {
	    var Name = _ref.Name,
	        Street = _ref.Street,
	        City = _ref.City,
	        State = _ref.State,
	        Zip = _ref.Zip,
	        Latitude = _ref.Latitude,
	        Longitude = _ref.Longitude,
	        FirstName = _ref.FirstName,
	        LastName = _ref.LastName,
	        Telephone = _ref.Telephone,
	        Cellphone = _ref.Cellphone,
	        Fax = _ref.Fax,
	        Email = _ref.Email;
	
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_CREATING_WAREHOUSE });
	        _axios2.default.post(_url.WAREHOUSES_URL, {
	            Name: Name,
	            Street: Street,
	            City: City,
	            State: State,
	            Zip: Zip,
	            Latitude: Latitude,
	            Longitude: Longitude,
	            FirstName: FirstName,
	            LastName: LastName,
	            Telephone: Telephone,
	            Cellphone: Cellphone,
	            Fax: Fax,
	            Email: Email
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(createWarehouseSuccess());
	            _reactRouter.browserHistory.push('/warehouses');
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(createWarehouseFailure(err));
	        });
	    };
	}
	
	function createWarehouseSuccess() {
	    return {
	        type: _type.CREATE_WAREHOUSE_SUCCESS
	    };
	}
	
	function createWarehouseFailure(error) {
	    return {
	        type: _type.CREATE_WAREHOUSE_FAILURE,
	        payload: error
	    };
	}
	
	function editWarehouse(_ref2) {
	    var Warehouse_id = _ref2.Warehouse_id,
	        Name = _ref2.Name,
	        Street = _ref2.Street,
	        City = _ref2.City,
	        State = _ref2.State,
	        Zip = _ref2.Zip,
	        Latitude = _ref2.Latitude,
	        Longitude = _ref2.Longitude,
	        FirstName = _ref2.FirstName,
	        LastName = _ref2.LastName,
	        Telephone = _ref2.Telephone,
	        Cellphone = _ref2.Cellphone,
	        Fax = _ref2.Fax,
	        Email = _ref2.Email;
	
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_EDITING_WAREHOUSE });
	        _axios2.default.put(_url.WAREHOUSES_URL + Warehouse_id, {
	            Name: Name,
	            Street: Street,
	            City: City,
	            State: State,
	            Zip: Zip,
	            Latitude: Latitude,
	            Longitude: Longitude,
	            FirstName: FirstName,
	            LastName: LastName,
	            Telephone: Telephone,
	            Cellphone: Cellphone,
	            Fax: Fax,
	            Email: Email
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(editWarehouseSuccess());
	            _reactRouter.browserHistory.push('/warehouses'); // If editd succesfully, refresh the paymentTerm page.
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(editWarehouseFailure(err));
	        });
	    };
	}
	function editWarehouseDefault(Warehouse_id, IsDefault) {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_EDITING_WAREHOUSE });
	        _axios2.default.put(_url.WAREHOUSES_URL + Warehouse_id, {
	            IsDefault: IsDefault
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(editWarehouseSuccessDefault(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(editWarehouseFailure(err));
	        });
	    };
	}
	
	function editWarehouseSuccess() {
	    return {
	        type: _type.EDIT_WAREHOUSE_SUCCESS
	    };
	}
	
	function editWarehouseSuccessDefault(response) {
	    return {
	        type: _type.EDIT_WAREHOUSE_SUCCESS,
	        payload: response
	    };
	}
	
	function editWarehouseFailure(error) {
	    return {
	        type: _type.EDIT_WAREHOUSE_FAILURE,
	        payload: error
	    };
	}
	
	function fetchWarehouseSalesOrders(Warehouse_id) {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_WAREHOUSE_SALES_ORDERS });
	        return _axios2.default.get(_url.DASHBOARD_URL + "warehouse/sales/" + Warehouse_id, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchWarehouseSalesOrdersSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchWarehouseSalesOrdersFailure(err));
	        });
	    };
	}
	
	function fetchWarehouseSalesOrdersSuccess(salesOrders) {
	    return {
	        type: _type.FETCH_WAREHOUSE_SALES_ORDERS_SUCCESS,
	        payload: salesOrders
	    };
	}
	
	function fetchWarehouseSalesOrdersFailure(error) {
	    return {
	        type: _type.FETCH_WAREHOUSE_SALES_ORDERS_FAILURE,
	        payload: error
	    };
	}
	
	function fetchWarehousePurchaseOrders(Warehouse_id) {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_WAREHOUSE_PURCHASE_ORDERS });
	        return _axios2.default.get(_url.DASHBOARD_URL + "warehouse/purchase/" + Warehouse_id, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchWarehousePurchaseOrdersSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchWarehousePurchaseOrdersFailure(err));
	        });
	    };
	}
	
	function fetchWarehousePurchaseOrdersSuccess(purchaseOrders) {
	    return {
	        type: _type.FETCH_WAREHOUSE_PURCHASE_ORDERS_SUCCESS,
	        payload: purchaseOrders
	    };
	}
	
	function fetchWarehousePurchaseOrdersFailure(error) {
	    return {
	        type: _type.FETCH_WAREHOUSE_PURCHASE_ORDERS_FAILURE,
	        payload: error
	    };
	}
	
	function fetchWarehouseBins(Warehouse_id) {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_WAREHOUSE_BINS });
	        return _axios2.default.get(_url.WAREHOUSES_URL + Warehouse_id, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchWarehouseBinsSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchWarehouseBinsFailure(err));
	        });
	    };
	}
	
	function fetchWarehouseBinsSuccess(WarehouseInformation) {
	    return {
	        type: _type.FETCH_WAREHOUSE_BINS_SUCCESS,
	        payload: WarehouseInformation
	    };
	}
	
	function fetchWarehouseBinsFailure(error) {
	    return {
	        type: _type.FETCH_WAREHOUSE_BINS_FAILURE,
	        payload: error
	    };
	}
	
	function deleteWarehouse(id) {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_DELETE_WAREHOUSE });
	        _axios2.default.delete(_url.WAREHOUSES_URL + id, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(deleteWarehouseSuccess());
	            dispatch(fetchWarehouses());
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(deleteWarehouseFailure(err));
	        });
	    };
	}
	
	function deleteWarehouseSuccess() {
	    return {
	        type: _type.DELETE_WAREHOUSE_SUCCESS
	    };
	}
	
	function deleteWarehouseFailure(error) {
	    return {
	        type: _type.DELETE_WAREHOUSE_FAILURE,
	        payload: error
	    };
	}
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(fetchWarehouses, 'fetchWarehouses', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(searchWarehouses, 'searchWarehouses', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchWarehousesSuccess, 'fetchWarehousesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchWarehousesFailure, 'fetchWarehousesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(selectWarehouse, 'selectWarehouse', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(resetCurrentWarehouse, 'resetCurrentWarehouse', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(resetWarehouses, 'resetWarehouses', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchWarehouseDetail, 'fetchWarehouseDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchWarehouseDetailSuccess, 'fetchWarehouseDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchWarehouseDetailFailure, 'fetchWarehouseDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(createWarehouse, 'createWarehouse', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(createWarehouseSuccess, 'createWarehouseSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(createWarehouseFailure, 'createWarehouseFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(editWarehouse, 'editWarehouse', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(editWarehouseDefault, 'editWarehouseDefault', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(editWarehouseSuccess, 'editWarehouseSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(editWarehouseSuccessDefault, 'editWarehouseSuccessDefault', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(editWarehouseFailure, 'editWarehouseFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchWarehouseSalesOrders, 'fetchWarehouseSalesOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchWarehouseSalesOrdersSuccess, 'fetchWarehouseSalesOrdersSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchWarehouseSalesOrdersFailure, 'fetchWarehouseSalesOrdersFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchWarehousePurchaseOrders, 'fetchWarehousePurchaseOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchWarehousePurchaseOrdersSuccess, 'fetchWarehousePurchaseOrdersSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchWarehousePurchaseOrdersFailure, 'fetchWarehousePurchaseOrdersFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchWarehouseBins, 'fetchWarehouseBins', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchWarehouseBinsSuccess, 'fetchWarehouseBinsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchWarehouseBinsFailure, 'fetchWarehouseBinsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(deleteWarehouse, 'deleteWarehouse', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(deleteWarehouseSuccess, 'deleteWarehouseSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	
	    __REACT_HOT_LOADER__.register(deleteWarehouseFailure, 'deleteWarehouseFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/warehouses_actions.js');
	}();

	;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1533);

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchVendors = fetchVendors;
	exports.fetchActiveVendors = fetchActiveVendors;
	exports.requestVendors = requestVendors;
	exports.fetchVendorsSuccess = fetchVendorsSuccess;
	exports.fetchVendorsFailure = fetchVendorsFailure;
	exports.selectVendor = selectVendor;
	exports.resetCurrentVendor = resetCurrentVendor;
	exports.createVendor = createVendor;
	exports.requestCreatingVendor = requestCreatingVendor;
	exports.createVendorSuccess = createVendorSuccess;
	exports.createVendorFailure = createVendorFailure;
	exports.editVendor = editVendor;
	exports.requestEditingVendor = requestEditingVendor;
	exports.editVendorSuccess = editVendorSuccess;
	exports.editVendorFailure = editVendorFailure;
	exports.fetchVendorDetail = fetchVendorDetail;
	exports.requestVendorDetail = requestVendorDetail;
	exports.fetchVendorDetailSuccess = fetchVendorDetailSuccess;
	exports.fetchVendorDetailFailure = fetchVendorDetailFailure;
	exports.fetchVendorInventoryDetail = fetchVendorInventoryDetail;
	exports.requestVendorInventoryDetail = requestVendorInventoryDetail;
	exports.fetchVendorInventoryDetailSuccess = fetchVendorInventoryDetailSuccess;
	exports.fetchVendorInventoryDetailFailure = fetchVendorInventoryDetailFailure;
	exports.fetchVendorRecords = fetchVendorRecords;
	exports.requestVendorRecords = requestVendorRecords;
	exports.fetchVendorRecordsSuccess = fetchVendorRecordsSuccess;
	exports.fetchVendorRecordsFailure = fetchVendorRecordsFailure;
	exports.getVendorBatches = getVendorBatches;
	exports.attachDocument = attachDocument;
	exports.attachDocumentSuccess = attachDocumentSuccess;
	exports.attachDocumentFailure = attachDocumentFailure;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reduxForm2 = _interopRequireDefault(_reduxForm);
	
	var _reactRouter = __webpack_require__(13);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchVendors() {
	  return function (dispatch) {
	    dispatch(requestVendors());
	    return _axios2.default.get(_url.VENDOR_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchVendorsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchVendorsFailure(err));
	    });
	  };
	}
	
	function fetchActiveVendors() {
	  return function (dispatch) {
	    dispatch(requestVendors());
	    return (0, _axios2.default)({
	      method: 'get',
	      url: _url.VENDOR_URL + '?Vendor_id__IsActive=1',
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchVendorsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchVendorsFailure(err));
	    });
	  };
	}
	
	function requestVendors() {
	  return {
	    type: _type.REQUEST_VENDORS
	  };
	}
	
	function fetchVendorsSuccess(vendors) {
	  return {
	    type: _type.FETCH_VENDORS_SUCCESS,
	    payload: vendors
	  };
	}
	
	function fetchVendorsFailure(error) {
	  return {
	    type: _type.FETCH_VENDORS_FAILURE,
	    payload: error
	  };
	}
	
	function selectVendor(vendor) {
	  return {
	    type: _type.SELECT_VENDOR,
	    payload: vendor
	  };
	}
	
	function resetCurrentVendor() {
	  return {
	    type: _type.RESET_CURRENT_VENDOR
	  };
	}
	
	// Actions to deal with the promise of posting function.
	
	function createVendor(_ref) {
	  var VendorNum = _ref.VendorNum,
	      RefNum = _ref.RefNum,
	      Phone = _ref.Phone,
	      Name = _ref.Name,
	      Description = _ref.Description,
	      CreditStatus = _ref.CreditStatus,
	      IsActive = _ref.IsActive,
	      Purchaser_User_id = _ref.Purchaser_User_id,
	      PaymentTerm_id = _ref.PaymentTerm_id,
	      default_purchaser_user_id = _ref.default_purchaser_user_id,
	      Shipping = _ref.Shipping,
	      Mailing = _ref.Mailing,
	      Billing = _ref.Billing;
	
	  if (PaymentTerm_id) {
	    PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
	  }
	  if (default_purchaser_user_id) {
	    default_purchaser_user_id = default_purchaser_user_id.value || default_purchaser_user_id;
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CREATING_VENDOR });
	    _axios2.default.post(_url.VENDOR_URL, {
	      VendorNum: VendorNum,
	      RefNum: RefNum,
	      Phone: Phone,
	      Name: Name,
	      Description: Description,
	      CreditStatus: CreditStatus,
	      IsActive: IsActive,
	      Purchaser_User_id: Purchaser_User_id,
	      PaymentTerm_id: PaymentTerm_id,
	      default_purchaser_user_id: default_purchaser_user_id,
	      Shipping: Shipping,
	      Mailing: Mailing,
	      Billing: Billing
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(createVendorSuccess());
	      _reactRouter.browserHistory.push('/vendors');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(createVendorFailure(err));
	    });
	  };
	}
	
	function requestCreatingVendor() {
	  return {
	    type: _type.REQUEST_CREATING_VENDOR
	  };
	}
	
	function createVendorSuccess() {
	  return {
	    type: _type.CREATE_VENDOR_SUCCESS
	  };
	}
	
	function createVendorFailure(error) {
	  return {
	    type: _type.CREATE_VENDOR_FAILURE,
	    payload: error
	  };
	}
	
	function editVendor(_ref2) {
	  var Vendor_id = _ref2.Vendor_id,
	      VendorNum = _ref2.VendorNum,
	      RefNum = _ref2.RefNum,
	      Phone = _ref2.Phone,
	      Name = _ref2.Name,
	      Description = _ref2.Description,
	      CreditStatus = _ref2.CreditStatus,
	      IsActive = _ref2.IsActive,
	      Purchaser_User_id = _ref2.Purchaser_User_id,
	      PaymentTerm_id = _ref2.PaymentTerm_id,
	      default_purchaser_user_id = _ref2.default_purchaser_user_id,
	      Shipping = _ref2.Shipping,
	      Mailing = _ref2.Mailing,
	      Billing = _ref2.Billing;
	
	  if (PaymentTerm_id) {
	    PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
	  }
	  if (default_purchaser_user_id) {
	    default_purchaser_user_id = default_purchaser_user_id.value || default_purchaser_user_id;
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EDITING_VENDOR });
	    _axios2.default.put(_url.VENDOR_URL + Vendor_id, {
	      VendorNum: VendorNum,
	      RefNum: RefNum,
	      Phone: Phone,
	      Name: Name,
	      Description: Description,
	      CreditStatus: CreditStatus,
	      IsActive: IsActive,
	      Purchaser_User_id: Purchaser_User_id,
	      PaymentTerm_id: PaymentTerm_id,
	      default_purchaser_user_id: default_purchaser_user_id,
	      Shipping: Shipping,
	      Mailing: Mailing,
	      Billing: Billing
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editVendorSuccess());
	      _reactRouter.browserHistory.push('/vendors'); // If editd succesfully, refresh the paymentTerm page.
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editVendorFailure(err));
	    });
	  };
	}
	
	function requestEditingVendor() {
	  return {
	    type: _type.REQUEST_EDITING_VENDOR
	  };
	}
	
	function editVendorSuccess() {
	  return {
	    type: _type.EDIT_VENDOR_SUCCESS
	  };
	}
	
	function editVendorFailure(error) {
	  return {
	    type: _type.EDIT_VENDOR_FAILURE,
	    payload: error
	  };
	}
	
	// Fetch the detail page.
	function fetchVendorDetail(vendor_id) {
	  return function (dispatch) {
	    dispatch(requestVendorDetail());
	    return _axios2.default.get(_url.VENDOR_URL + vendor_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchVendorDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchVendorDetailFailure(err));
	    });
	  };
	}
	
	function requestVendorDetail() {
	  return {
	    type: _type.REQUEST_VENDOR_DETAIL
	  };
	}
	
	function fetchVendorDetailSuccess(vendorDetail) {
	  return {
	    type: _type.FETCH_VENDOR_DETAIL_SUCCESS,
	    payload: vendorDetail
	  };
	}
	
	function fetchVendorDetailFailure(error) {
	  return {
	    type: _type.FETCH_VENDOR_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function fetchVendorInventoryDetail(vendor_id) {
	  return function (dispatch) {
	    dispatch(requestVendorInventoryDetail());
	    return _axios2.default.get(_url.VENDOR_INVENTORY_URL + vendor_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchVendorInventoryDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchVendorInventoryDetailFailure(err));
	    });
	  };
	}
	
	function requestVendorInventoryDetail() {
	  return {
	    type: _type.REQUEST_VENDOR_INVENTORY_DETAIL
	  };
	}
	
	function fetchVendorInventoryDetailSuccess(vendorDetail) {
	  return {
	    type: _type.FETCH_VENDOR_INVENTORY_DETAIL_SUCCESS,
	    payload: vendorDetail
	  };
	}
	
	function fetchVendorInventoryDetailFailure(error) {
	  return {
	    type: _type.FETCH_VENDOR_INVENTORY_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function fetchVendorRecords() {
	  return function (dispatch) {
	    dispatch(requestVendorRecords());
	    return _axios2.default.get(_url.OUTSTANDING_VENDOR_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchVendorRecordsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchVendorRecordsFailure(err));
	    });
	  };
	}
	
	function requestVendorRecords() {
	  return {
	    type: _type.REQUEST_VENDOR_RECORDS
	  };
	}
	
	function fetchVendorRecordsSuccess(records) {
	  return {
	    type: _type.FETCH_VENDOR_RECORDS_SUCCESS,
	    payload: records
	  };
	}
	
	function fetchVendorRecordsFailure(error) {
	  return {
	    type: _type.FETCH_VENDOR_RECORDS_FAILURE,
	    payload: error
	  };
	}
	
	function getVendorBatches(vendor_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.FETCH_VENDOR_BATCHES });
	    return _axios2.default.get(_url.VENDOR_INVENTORY_URL + vendor_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(getVendorBatchesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(getVendorBatchesFailure(err));
	    });
	  };
	}
	
	function getVendorBatchesSuccess(data) {
	  return {
	    type: _type.FETCH_VENDOR_BATCHES_SUCCESS,
	    payload: data
	  };
	}
	
	function getVendorBatchesFailure(error) {
	  return {
	    type: _type.FETCH_VENDOR_BATCHES_FAILURE,
	    payload: error
	  };
	}
	
	function attachDocument(files) {
	  return function (dispatch) {
	    dispatch({ type: _type.ATTACH_DOCUMENT });
	    var data = new FormData();
	    data.append('vendor_file', files[0]);
	    //UPLOAD_URL + 'vendor/' <--- old api
	    return _axios2.default.post(_url.VENDOR_URL + 'import/', data, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	
	    }).then(function (response) {
	      dispatch(attachDocumentSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(attachDocumentFailure(err));
	    });
	  };
	}
	
	function attachDocumentSuccess() {
	  return {
	    type: _type.ATTACH_DOCUMENT_SUCCESS
	  };
	}
	
	function attachDocumentFailure(error) {
	  return {
	    type: _type.ATTACH_DOCUMENT_FAILURE,
	    payload: error
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchVendors, 'fetchVendors', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchActiveVendors, 'fetchActiveVendors', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestVendors, 'requestVendors', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchVendorsSuccess, 'fetchVendorsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchVendorsFailure, 'fetchVendorsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(selectVendor, 'selectVendor', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetCurrentVendor, 'resetCurrentVendor', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(createVendor, 'createVendor', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestCreatingVendor, 'requestCreatingVendor', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(createVendorSuccess, 'createVendorSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(createVendorFailure, 'createVendorFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(editVendor, 'editVendor', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestEditingVendor, 'requestEditingVendor', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(editVendorSuccess, 'editVendorSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(editVendorFailure, 'editVendorFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchVendorDetail, 'fetchVendorDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestVendorDetail, 'requestVendorDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchVendorDetailSuccess, 'fetchVendorDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchVendorDetailFailure, 'fetchVendorDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchVendorInventoryDetail, 'fetchVendorInventoryDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestVendorInventoryDetail, 'requestVendorInventoryDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchVendorInventoryDetailSuccess, 'fetchVendorInventoryDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchVendorInventoryDetailFailure, 'fetchVendorInventoryDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchVendorRecords, 'fetchVendorRecords', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestVendorRecords, 'requestVendorRecords', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchVendorRecordsSuccess, 'fetchVendorRecordsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchVendorRecordsFailure, 'fetchVendorRecordsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(getVendorBatches, 'getVendorBatches', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(getVendorBatchesSuccess, 'getVendorBatchesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(getVendorBatchesFailure, 'getVendorBatchesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(attachDocument, 'attachDocument', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(attachDocumentSuccess, 'attachDocumentSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	
	  __REACT_HOT_LOADER__.register(attachDocumentFailure, 'attachDocumentFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/vendors_actions.js');
	}();

	;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.printSalesInvoiceForCustomerStatement = exports.fetchLineLabel = undefined;
	exports.printPurchaseOrder = printPurchaseOrder;
	exports.printPurchaseOrderNoSubtotals = printPurchaseOrderNoSubtotals;
	exports.printPurchaseOrderNoSubtotalsSuccess = printPurchaseOrderNoSubtotalsSuccess;
	exports.printPurchaseReturn = printPurchaseReturn;
	exports.printPurchaseReference = printPurchaseReference;
	exports.printPickup = printPickup;
	exports.printSalesInvoice = printSalesInvoice;
	exports.printSalesInvoiceReturn = printSalesInvoiceReturn;
	exports.printSalesInvoiceNoSubtotals = printSalesInvoiceNoSubtotals;
	exports.printSalesInvoiceNoSubtotalsSuccess = printSalesInvoiceNoSubtotalsSuccess;
	exports.printSalesInvoiceReturnsNoSubtotals = printSalesInvoiceReturnsNoSubtotals;
	exports.printSalesInvoiceReturnNoSubtotalsSuccess = printSalesInvoiceReturnNoSubtotalsSuccess;
	exports.fetchSalesInvoicesPdfFailure = fetchSalesInvoicesPdfFailure;
	exports.fetchSalesInvoicesReturnPdfFailure = fetchSalesInvoicesReturnPdfFailure;
	exports.printWarehouseReceive = printWarehouseReceive;
	exports.printARReport = printARReport;
	exports.printPlainARReport = printPlainARReport;
	exports.printAPReport = printAPReport;
	exports.printDispatchRoute = printDispatchRoute;
	exports.printDispatchPickingList = printDispatchPickingList;
	exports.printDispatchPackingList = printDispatchPackingList;
	exports.printDispatchSalesInvoice = printDispatchSalesInvoice;
	exports.printPurchaseReturnNoSubtotals = printPurchaseReturnNoSubtotals;
	exports.printPurchaseReturnNoSubtotalsSuccess = printPurchaseReturnNoSubtotalsSuccess;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function printPurchaseOrder(purchaseOrderID) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PO_PDF });
	    return _axios2.default.get(_url.PURCHASE_ORDER_PRINT_URL + 'print/' + purchaseOrderID, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchPurchaseOrderPDFSuccess(response));
	    }, function (err) {
	      console.log('ERROR IN response', err);
	    });
	  };
	}
	
	function fetchPurchaseOrderPDFSuccess(FileData) {
	  return {
	    type: _type.FETCH_PO_PDF_SUCCESS,
	    payload: FileData
	  };
	}
	
	function fetchPurchaseReturnPDFSuccess(fileData) {
	  return {
	    type: _type.FETCH_PURCHASE_RETURN_PDF_SUCCESS,
	    payload: fileData
	  };
	}
	
	function printPurchaseOrderNoSubtotals(purchaseOrderID) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PO_NOSUBTOTAL_PDF });
	    return _axios2.default.get('' + _url.PURCHASE_ORDER_PRINT_NOSUBTOTAL_URL + purchaseOrderID, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(printPurchaseOrderNoSubtotalsSuccess(response));
	    }, function (err) {
	      console.log('Print Error', err);
	    });
	  };
	}
	
	function printPurchaseOrderNoSubtotalsSuccess(fileData) {
	  return {
	    type: _type.REQUEST_PO_NOSUBTOTAL_PDF_SUCCESS,
	    payload: fileData
	  };
	}
	
	function printPurchaseReturn(purchaseReturnID) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PURCHASE_RETURN_PDF });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: _url.PURCHASE_RETURNS_URL + 'print/' + purchaseReturnID,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchPurchaseReturnPDFSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      alert(JSON.stringify(err.data));
	    });
	  };
	}
	
	function fetchPurchaseReferencePDFSuccess(fileData) {
	  return {
	    type: _type.FETCH_PURCHASE_REFERENCE_PDF_SUCCESS,
	    payload: fileData
	  };
	}
	
	function printPurchaseReference(_ref) {
	  var typeradio = _ref.typeradio,
	      group = _ref.group,
	      category = _ref.category,
	      endTime = _ref.endTime;
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PURCHASE_REFERENCE_PDF });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: _url.PURCHASE_URL + 'referenceguide/print/' + typeradio + '/',
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob',
	      params: {
	        ProductGroup_id: group,
	        ProductCategory1_id: category,
	        end_time: endTime
	      }
	    }).then(function (response) {
	      dispatch(fetchPurchaseReferencePDFSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      alert(JSON.stringify(err.data));
	    });
	  };
	}
	
	function printPickup(purchaseOrderID) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PO_PDF });
	    return _axios2.default.get(_url.PURCHASE_ORDER_PRINT_URL + 'pickupprint/' + purchaseOrderID, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchPrintPickupSuccess(response));
	    }, function (err) {
	      console.log('ERROR IN response', err);
	    });
	  };
	}
	
	function fetchPrintPickupSuccess(FileData) {
	  return {
	    type: _type.FETCH_PO_PDF_SUCCESS,
	    payload: FileData
	  };
	}
	
	function printSalesInvoice(salesInvoiceID) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SI_PDF });
	    return _axios2.default.get(_url.SALES_INVOICE_PRINT_URL + salesInvoiceID, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchSalesInvoicePdfSuccess(response));
	    }, function (err) {
	      console.log('ERROR IN response', err);
	      dispatch(fetchSalesInvoicesPdfFailure(err));
	    });
	  };
	}
	
	function printSalesInvoiceReturn(salesInvoiceReturnID) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SI_RETURN_PDF });
	    return _axios2.default.get(_url.SALES_INVOICE_RETURN_PRINT_URL + salesInvoiceReturnID, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      console.log(response);
	      dispatch(fetchSalesInvoiceReturnPdfSuccess(response));
	    }, function (err) {
	      console.log('ERROR IN response', err);
	      dispatch(fetchSalesInvoicesReturnPdfFailure(err));
	    });
	  };
	}
	
	function printSalesInvoiceNoSubtotals(salesInvoiceId) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SI_NOSUBTOTAL_PDF });
	    return _axios2.default.get(_url.SALES_INVOICE_PRINT_NOSUBTOTAL_URL + salesInvoiceId, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(printSalesInvoiceNoSubtotalsSuccess(response));
	    }, function (err) {
	      console.log('Print Error', err);
	    });
	  };
	}
	
	function printSalesInvoiceNoSubtotalsSuccess(fileData) {
	  return {
	    type: _type.REQUEST_SI_NOSUBTOTAL_PDF_SUCCESS,
	    payload: fileData
	  };
	}
	
	function printSalesInvoiceReturnsNoSubtotals(salesInvoiceId) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SI_RETURN_NOSUBTOTAL_PDF });
	    return _axios2.default.get(_url.SALES_INVOICE_RETURN_PRINT_NOSUBTOTAL_URL + salesInvoiceId, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(printSalesInvoiceReturnNoSubtotalsSuccess(response));
	    }, function (err) {
	      console.log('Print Error', err);
	    });
	  };
	}
	
	function printSalesInvoiceReturnNoSubtotalsSuccess(fileData) {
	  return {
	    type: _type.REQUEST_SI_RETURN_NOSUBTOTAL_PDF_SUCCESS,
	    payload: fileData
	  };
	}
	
	function fetchSalesInvoicePdfSuccess(FileData) {
	  return {
	    type: _type.FETCH_SI_PDF_SUCCESS,
	    payload: FileData
	  };
	}
	
	function fetchSalesInvoicesPdfFailure(error) {
	  return {
	    type: _type.FETCH_SI_PDF_FAILURE,
	    payload: error
	  };
	}
	
	function fetchSalesInvoiceReturnPdfSuccess(FileData) {
	  return {
	    type: _type.FETCH_SI_RETURN_PDF_SUCCESS,
	    payload: FileData
	  };
	}
	
	function fetchSalesInvoicesReturnPdfFailure(error) {
	  return {
	    type: _type.FETCH_SI_RETURN_PDF_FAILURE,
	    payload: error
	  };
	}
	
	function printWarehouseReceive(warehouseReceiveNum) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_WR_PDF });
	    return _axios2.default.get(_url.WAREHOUSE_RECEIVE_PRINT_URL + warehouseReceiveNum, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchWarehouseReceiveSuccess(response));
	    }, function (err) {
	      console.log('ERROR IN response', err);
	    });
	  };
	}
	
	var fetchLineLabel = exports.fetchLineLabel = function fetchLineLabel(WarehouseReceive_id, WarehouseReceiveLine_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_WR_PDF });
	    _axios2.default.get(_url.RECEIVE_URL + 'print_label/' + WarehouseReceive_id + '/' + WarehouseReceiveLine_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchWarehouseReceiveSuccess(response));
	    }, function (err) {
	      console.log('ERROR IN response', err);
	    });
	  };
	};
	
	function fetchWarehouseReceiveSuccess(FileData) {
	  return {
	    type: _type.FETCH_WR_PDF_SUCCESS,
	    payload: FileData
	  };
	}
	
	/*
	  makes a get request for an AR report and signals for success and failure
	  params:
	    customerId: number,
	    fromDate: string string in simplified extended ISO format (YYYY-MM-DDTHH:mm:ss.sssZ),
	    toDate: string string in simplified extended ISO format (YYYY-MM-DDTHH:mm:ss.sssZ),
	    cutoffDate: string string in simplified extended ISO format (YYYY-MM-DDTHH:mm:ss.sssZ),
	    isSimplified: boolean
	  returns:
	    function for thunk middleware
	*/
	
	function fetchARReportSuccess(fileData) {
	  return {
	    type: _type.FETCH_AR_PDF_SUCCESS,
	    payload: fileData
	  };
	}
	
	var printSalesInvoiceForCustomerStatement = exports.printSalesInvoiceForCustomerStatement = function printSalesInvoiceForCustomerStatement(invoiceId) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_AR_PDF });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: '' + _url.SALES_INVOICE_PRINT_URL + invoiceId,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchARReportSuccess(response));
	    }, function () {
	      alert(JSON.stringify(_constants.DEFAULT_ERROR));
	    });
	  };
	};
	
	function printARReport(customerId, fromDate, toDate, cutoffDate, isSimplified) {
	  var mode = isSimplified ? 'simplifiedprint' : 'print';
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_AR_PDF });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: '' + _url.AR_PRINT_URL + customerId + '/' + mode + '/',
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob',
	      params: {
	        start_date: fromDate,
	        end_date: toDate,
	        cut_off_date: cutoffDate
	      }
	    }).then(function (response) {
	      dispatch(fetchARReportSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      } else if (err.status === 400) {
	        err.data = 'No Invoices in this Date Range';
	      }
	      alert(JSON.stringify(err.data));
	    });
	  };
	}
	
	function printPlainARReport(customerId, fromDate, toDate, cutoffDate, mode) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_AR_PDF });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: '' + _url.AR_PRINT_PLAIN_URL + customerId + '/' + mode + '/',
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob',
	      params: {
	        start_date: fromDate,
	        end_date: toDate
	      }
	    }).then(function (response) {
	      dispatch(fetchARReportSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      } else if (err.status === 400) {
	        err.data = 'No Invoices in this Date Range';
	      }
	      alert(JSON.stringify(err.data));
	    });
	  };
	}
	
	function fetchAPReportSuccess(fileData) {
	  return {
	    type: _type.FETCH_AP_PDF_SUCCESS,
	    payload: fileData
	  };
	}
	
	/*
	  makes a get request for an AP report and signals for success and failure
	  params:
	    vendorrId: number,
	    fromDate: string in simplified extended ISO format (YYYY-MM-DDTHH:mm:ss.sssZ),
	    toDate: string string in simplified extended ISO format (YYYY-MM-DDTHH:mm:ss.sssZ),
	    cutoffDate: string in simplified extended ISO format (YYYY-MM-DDTHH:mm:ss.sssZ),
	    isSimplified: boolean
	  returns:
	    function for thunk middleware
	*/
	function printAPReport(vendorId, fromDate, toDate, paymentCutoffDate, isSimplified) {
	  var type = isSimplified ? 'simplifiedprint' : 'print';
	  var url = '' + _url.AP_PRINT_URL + vendorId + '/' + type + '/';
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_AP_PDF });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: url,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob',
	      params: {
	        start_date: fromDate,
	        end_date: toDate,
	        cut_off_date: paymentCutoffDate
	      }
	    }).then(function (response) {
	      dispatch(fetchAPReportSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      } else if (err.status === 400) {
	        err.data = 'No Invoices in this Date Range';
	      }
	      alert(JSON.stringify(err.data));
	    });
	  };
	}
	
	function fetchRoutesPdfSuccess(fileData) {
	  return {
	    type: _type.REQUEST_ROUTING_PDF_SUCCESS,
	    payload: fileData
	  };
	}
	
	function fetchRoutesPdfFailure(error) {
	  return {
	    type: _type.REQUEST_ROUTING_PDF_FAILURE,
	    payload: error
	  };
	}
	
	function printDispatchRoute(routeId, date) {
	  var _getFromToDates = (0, _cleanDates.getFromToDates)(date),
	      fromDate = _getFromToDates.fromDate,
	      toDate = _getFromToDates.toDate;
	
	  var url = _url.DISPATCH_URL + 'route/' + routeId + '/print?start_time=' + fromDate + '&end_time=' + toDate;
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_ROUTING_PDF });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: url,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchRoutesPdfSuccess(response));
	    }, function (err) {
	      dispatch(fetchRoutesPdfFailure(err));
	    });
	  };
	}
	
	function fetchDispatchPickingListPdfSuccess(fileData) {
	  return {
	    type: _type.REQUEST_DISPATCH_PICKING_LIST_PDF_SUCCESS,
	    payload: fileData
	  };
	}
	
	function fetchDispatchPickingListPdfFailure(error) {
	  return {
	    type: _type.REQUEST_DISPATCH_PICKING_LIST_PDF_FAILURE,
	    payload: error
	  };
	}
	
	function printDispatchPickingList(routeId, date) {
	  var _getFromToDates2 = (0, _cleanDates.getFromToDates)(date),
	      fromDate = _getFromToDates2.fromDate,
	      toDate = _getFromToDates2.toDate;
	
	  var url = _url.DISPATCH_URL + 'route/' + routeId + '/print_picking_list?start_time=' + fromDate + '&end_time=' + toDate;
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_DISPATCH_PICKING_LIST_PDF });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: url,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchDispatchPickingListPdfSuccess(response));
	    }, function (err) {
	      dispatch(fetchDispatchPickingListPdfFailure(err));
	    });
	  };
	}
	
	function fetchDispatchPackingListPdfSuccess(fileData) {
	  return {
	    type: _type.REQUEST_DISPATCH_PACKING_LIST_PDF_SUCCESS,
	    payload: fileData
	  };
	}
	
	function fetchDispatchPackingListPdfFailure(error) {
	  return {
	    type: _type.REQUEST_DISPATCH_PACKING_LIST_PDF_FAILURE,
	    payload: error
	  };
	}
	
	function printDispatchPackingList(routeId, date) {
	  var _getFromToDates3 = (0, _cleanDates.getFromToDates)(date),
	      fromDate = _getFromToDates3.fromDate,
	      toDate = _getFromToDates3.toDate;
	
	  var url = _url.DISPATCH_URL + 'print_packing_list/' + routeId + '?start_time=' + fromDate + '&end_time=' + toDate;
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_DISPATCH_PACKING_LIST_PDF });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: url,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchDispatchPackingListPdfSuccess(response));
	    }, function (err) {
	      dispatch(fetchDispatchPackingListPdfFailure(err));
	    });
	  };
	}
	
	function fetchDispatchSalesInvoicePdfSuccess(fileData) {
	  return {
	    type: _type.REQUEST_DISPATCH_SALES_INVOICE_PDF_SUCCESS,
	    payload: fileData
	  };
	}
	
	function fetchDispatchSalesInvoicePdfFailure(error) {
	  return {
	    type: _type.REQUEST_DISPATCH_SALES_INVOICE_PDF_FAILURE,
	    payload: error
	  };
	}
	
	function printDispatchSalesInvoice(routeId, date) {
	  var _getFromToDates4 = (0, _cleanDates.getFromToDates)(date),
	      fromDate = _getFromToDates4.fromDate,
	      toDate = _getFromToDates4.toDate;
	
	  var url = _url.DISPATCH_URL + 'route/' + routeId + '/print_sales_invoice?start_time=' + fromDate + '&end_time=' + toDate;
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_DISPATCH_SALES_INVOICE_PDF });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: url,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(fetchDispatchSalesInvoicePdfSuccess(response));
	    }, function (err) {
	      dispatch(fetchDispatchSalesInvoicePdfFailure(err));
	    });
	  };
	}
	
	function printPurchaseReturnNoSubtotals(returnId) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL });
	    return _axios2.default.get(_url.PURCHASE_RETURNS_NO_SUBTOTALS + returnId, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch(printPurchaseReturnNoSubtotalsSuccess(response));
	    }, function (err) {
	      console.log('Purchase Return Error', err);
	    });
	  };
	}
	
	function printPurchaseReturnNoSubtotalsSuccess(fileData) {
	  return {
	    type: _type.REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL_SUCCESS,
	    payload: fileData
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(printPurchaseOrder, 'printPurchaseOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseOrderPDFSuccess, 'fetchPurchaseOrderPDFSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseReturnPDFSuccess, 'fetchPurchaseReturnPDFSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(printPurchaseOrderNoSubtotals, 'printPurchaseOrderNoSubtotals', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(printPurchaseOrderNoSubtotalsSuccess, 'printPurchaseOrderNoSubtotalsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(printPurchaseReturn, 'printPurchaseReturn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseReferencePDFSuccess, 'fetchPurchaseReferencePDFSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(printPurchaseReference, 'printPurchaseReference', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(printPickup, 'printPickup', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPrintPickupSuccess, 'fetchPrintPickupSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(printSalesInvoice, 'printSalesInvoice', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(printSalesInvoiceReturn, 'printSalesInvoiceReturn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(printSalesInvoiceNoSubtotals, 'printSalesInvoiceNoSubtotals', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(printSalesInvoiceNoSubtotalsSuccess, 'printSalesInvoiceNoSubtotalsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(printSalesInvoiceReturnsNoSubtotals, 'printSalesInvoiceReturnsNoSubtotals', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(printSalesInvoiceReturnNoSubtotalsSuccess, 'printSalesInvoiceReturnNoSubtotalsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesInvoicePdfSuccess, 'fetchSalesInvoicePdfSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesInvoicesPdfFailure, 'fetchSalesInvoicesPdfFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesInvoiceReturnPdfSuccess, 'fetchSalesInvoiceReturnPdfSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesInvoicesReturnPdfFailure, 'fetchSalesInvoicesReturnPdfFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(printWarehouseReceive, 'printWarehouseReceive', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchLineLabel, 'fetchLineLabel', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchWarehouseReceiveSuccess, 'fetchWarehouseReceiveSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchARReportSuccess, 'fetchARReportSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(printSalesInvoiceForCustomerStatement, 'printSalesInvoiceForCustomerStatement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(printARReport, 'printARReport', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(printPlainARReport, 'printPlainARReport', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchAPReportSuccess, 'fetchAPReportSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(printAPReport, 'printAPReport', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchRoutesPdfSuccess, 'fetchRoutesPdfSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchRoutesPdfFailure, 'fetchRoutesPdfFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(printDispatchRoute, 'printDispatchRoute', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchDispatchPickingListPdfSuccess, 'fetchDispatchPickingListPdfSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchDispatchPickingListPdfFailure, 'fetchDispatchPickingListPdfFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(printDispatchPickingList, 'printDispatchPickingList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchDispatchPackingListPdfSuccess, 'fetchDispatchPackingListPdfSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchDispatchPackingListPdfFailure, 'fetchDispatchPackingListPdfFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(printDispatchPackingList, 'printDispatchPackingList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchDispatchSalesInvoicePdfSuccess, 'fetchDispatchSalesInvoicePdfSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchDispatchSalesInvoicePdfFailure, 'fetchDispatchSalesInvoicePdfFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(printDispatchSalesInvoice, 'printDispatchSalesInvoice', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(printPurchaseReturnNoSubtotals, 'printPurchaseReturnNoSubtotals', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	
	  __REACT_HOT_LOADER__.register(printPurchaseReturnNoSubtotalsSuccess, 'printPurchaseReturnNoSubtotalsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/print_actions.js');
	}();

	;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Example of usage:
	  {
	    GenericDatePicker({
	      setDate: this.setPoDate,
	      selectedDate: this.state.poDateChosen,
	    })
	  }
	*/
	
	var GenericDatePicker = function GenericDatePicker(props) {
	  return _react2.default.createElement(
	    'label',
	    { htmlFor: 'dateRange-radio-filter' },
	    _react2.default.createElement(_DateTimePicker2.default, {
	      id: props.id,
	      format: 'MM-DD-YY',
	      className: 'test-rw-input'
	      // onChange={(e) => { props.setDate(e); }}
	      , onCurrentDateChange: function onCurrentDateChange(e) {
	        props.onChange ? console.log("none") : props.setDate(e);
	      },
	      time: false,
	      placeholder: 'Date',
	      value: props.selectedDate,
	      onBlur: props.onBlur,
	      onChange: props.onChange
	    })
	  );
	};
	
	GenericDatePicker.propTypes = {
	  id: _propTypes2.default.string,
	  setDate: _propTypes2.default.func.isRequired,
	  selectedDate: _propTypes2.default.instanceOf(Date).isRequired
	};
	
	GenericDatePicker.defaultProps = {
	  id: undefined
	};
	
	var _default = GenericDatePicker;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(GenericDatePicker, 'GenericDatePicker', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/GenericDatePicker.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/GenericDatePicker.jsx');
	}();

	;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isUSPride = _root_url.ROOT_API_URL === "https://uspride-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://uspride-scm.truckxi.com/api/";
	
	var getBsStyle = function getBsStyle(input, value) {
	  return input === value ? 'success' : 'primary';
	};
	/* Example of date filter for date range
	  {
	    dateFilterRadios({
	      handleOnClick: this.fetchSalesInvoiceByDetails,
	      setFromDate: this.setFromDate,
	      setToDate: this.setToDate,
	      FromDate: this.state.FromDate,
	      ToDate: this.state.ToDate,
	      Days: this.state.Days,
	    })
	  }
	*/
	var dateFilterRadios = function dateFilterRadios(props) {
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.Days, '1') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'today-radio-filter1' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'today-radio-filter1',
	            type: 'radio',
	            name: 'dateFilterRadios',
	            value: '1',
	            checked: props.Days === '1' || props.Days === 1,
	            onChange: function onChange() {
	              props.handleOnClick('1');
	            }
	          })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'today' })
	        )
	      )
	    ),
	    isUSPride && _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.Days, '2') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'twoDay-radio-filter1' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'twoDay-radio-filter1',
	            type: 'radio',
	            name: 'dateFilterRadios',
	            value: '2',
	            checked: props.Days === '2' || props.Days === 2,
	            onChange: function onChange() {
	              props.handleOnClick('2');
	            }
	          })),
	          '2 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.Days, '7') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'sevenDay-radio-filter1' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'sevenDay-radio-filter1',
	            type: 'radio',
	            name: 'dateFilterRadios',
	            value: '7',
	            checked: props.Days === '7' || props.Days === 7,
	            onChange: function onChange() {
	              props.handleOnClick('7');
	            }
	          })),
	          '7 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.Days, '30') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'thirtyDay-radio-filter1' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'thirtyDay-radio-filter1',
	            type: 'radio',
	            name: 'dateFilterRadios',
	            value: '30',
	            checked: props.Days === '30' || props.Days === 30,
	            onChange: function onChange() {
	              props.handleOnClick('30');
	            }
	          })),
	          '30 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.Days, '90') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'ninetyDay-radio-filter1' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'ninetyDay-radio-filter1',
	            type: 'radio',
	            name: 'dateFilterRadios',
	            value: '90',
	            checked: props.Days === '90' || props.Days === 90,
	            onChange: function onChange() {
	              props.handleOnClick('90');
	            }
	          })),
	          '90 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.Days, '-1') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'dateRange-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'dateRange-radio-filter',
	            type: 'radio',
	            name: 'dateFilterRadios',
	            value: '-1',
	            checked: props.Days === '-1' || props.Days === -1,
	            onChange: function onChange() {
	              props.setToRangeSearch();
	            }
	          })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date_range' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      {
	        bsStyle: 'primary',
	        disabled: props.Days !== '-1' && props.Days !== -1
	      },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'dateRange-radio-filter' },
	        _react2.default.createElement(_DateTimePicker2.default, {
	          id: 'from-datepicker1',
	          format: 'MM-DD-YY',
	          className: 'test-rw-input',
	          onChange: function onChange(e) {
	            props.setFromDate(e);
	          },
	          time: false,
	          placeholder: 'Start',
	          disabled: props.Days !== '-1' && props.Days !== -1,
	          value: props.FromDate
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      {
	        bsStyle: 'primary',
	        disabled: props.Days !== '-1' && props.Days !== -1
	      },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'dateRange-radio-filter' },
	        _react2.default.createElement(_DateTimePicker2.default, {
	          id: 'to-datepicker1',
	          format: 'MM-DD-YY',
	          className: 'test-rw-input',
	          onChange: function onChange(e) {
	            props.setToDate(e);
	          },
	          time: false,
	          placeholder: 'End',
	          disabled: props.Days !== '-1' && props.Days !== -1,
	          value: props.ToDate
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      {
	        className: 'search-button',
	        bsStyle: 'primary',
	        disabled: props.Days !== '-1' && props.Days !== -1,
	        onClick: function onClick() {
	          props.handleOnClick('-1');
	        }
	      },
	      _react2.default.createElement('em', { className: 'fa fa-search' })
	    )
	  );
	};
	
	dateFilterRadios.propTypes = {
	  input: _react2.default.PropTypes.node.isRequired,
	  handleOnClick: _react2.default.PropTypes.func.isRequired,
	  setFromDate: _react2.default.PropTypes.func.isRequired,
	  setToDate: _react2.default.PropTypes.func.isRequired,
	  FromDate: _react2.default.PropTypes.string.isRequired,
	  ToDate: _react2.default.PropTypes.string.isRequired,
	  Days: _react2.default.PropTypes.string.isRequired,
	  setToRangeSearch: _react2.default.PropTypes.func.isRequired
	};
	
	var _default = dateFilterRadios;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isUSPride, 'isUSPride', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/dateFilterRadios.jsx');
	
	  __REACT_HOT_LOADER__.register(getBsStyle, 'getBsStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/dateFilterRadios.jsx');
	
	  __REACT_HOT_LOADER__.register(dateFilterRadios, 'dateFilterRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/dateFilterRadios.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/dateFilterRadios.jsx');
	}();

	;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getBsStyle = function getBsStyle(input, value) {
	  return input === value ? 'success' : 'primary';
	};
	var isAFM = _root_url.ROOT_API_URL === "https://afm-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://afm-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://afmstage-scm.truckxi.com/api/";
	/* Example of button filter
	{
	  genericRadioFilter({
	    content: [
	      {
	          option: 'all',
	          id: 'all-radio-filter',
	          name: 'statusFilterRadios',
	          labelName: 'all',
	      },
	      {
	          option: 'open',
	          id: 'open-radio-filter',
	          name: 'statusFilterRadios',
	          labelName: 'open',
	      }
	    ],
	    value: 'open',
	    handleOnClick: this.handleOnClick,
	    type: 'buttons',
	  })
	}
	*/
	
	/* Example of generic filter
	{
	  genericRadioFilter({
	    content: [
	      {
	          option: 'all',
	          id: 'all-radio-filter',
	          name: 'statusFilterRadios',
	          labelName: 'all',
	          className: 'col-xs-2 all-class',
	      },
	      {
	          option: 'open',
	          id: 'open-radio-filter',
	          name: 'statusFilterRadios',
	          labelName: 'open',
	          className: 'col-xs-2 open-class',
	      }
	    ],
	    value: 'open',
	    handleOnClick: this.handleOnClick,
	    title: 'search-product-by',
	    label: true,
	    labelClassName: 'col-xs-4 search-by-max-width',
	  })
	}
	*/
	var renderSections = function renderSections(content, type, inputNode, value, handleOnClick) {
	  var sections = [];
	  if (type === 'buttons') {
	    content.map(function (props) {
	      sections.push(_react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: getBsStyle(props.option, value), style: { marginLeft: isAFM && props && props.labelName === 'order' ? '130px' : '5px' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'radio' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: props.id },
	            _react2.default.createElement('input', _extends({}, inputNode, {
	              id: props.id,
	              name: props.name,
	              type: 'radio',
	              value: props.option,
	              checked: props.option === value,
	              onClick: function onClick() {
	                handleOnClick(props.option);
	              }
	            })),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: props.labelName })
	          )
	        )
	      ));
	    });
	  } else {
	    content.map(function (props) {
	      sections.push(_react2.default.createElement(
	        'label',
	        { htmlFor: props.id, className: props.className },
	        _react2.default.createElement('input', _extends({}, inputNode, {
	          id: props.id,
	          name: props.name,
	          type: 'radio',
	          value: props.option,
	          checked: props.option === value,
	          onClick: function onClick() {
	            handleOnClick(props.option);
	          }
	        })),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: props.labelName })
	      ));
	    });
	  }
	  return sections;
	};
	
	var genericRadioFilter = function genericRadioFilter(props) {
	  return props.type === 'buttons' ? _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'radio-filter-buttons' },
	    renderSections(props.content, props.type, props.input, props.value, props.handleOnClick)
	  ) : _react2.default.createElement(
	    'div',
	    { className: 'form-group', id: 'search-product-by', style: { paddingBottom: '10px' } },
	    props.label ? _react2.default.createElement(
	      'label',
	      { className: props.labelClassName },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: props.title }),
	      ':'
	    ) : '',
	    renderSections(props.content, props.type, props.input, props.value, props.handleOnClick)
	  );
	};
	
	genericRadioFilter.defaultProps = {
	  type: 'generic',
	  label: false,
	  labelClassName: '',
	  title: ''
	};
	
	genericRadioFilter.propTypes = {
	  input: _react2.default.PropTypes.node.isRequired,
	  handleOnClick: _react2.default.PropTypes.func.isRequired,
	  content: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object).isRequired,
	  value: _react2.default.PropTypes.string.isRequired,
	  title: _react2.default.PropTypes.string,
	  type: _react2.default.PropTypes.string,
	  label: _react2.default.PropTypes.bool,
	  labelClassName: _react2.default.PropTypes.string
	};
	
	var _default = genericRadioFilter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getBsStyle, 'getBsStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/genericRadioFilter.jsx');
	
	  __REACT_HOT_LOADER__.register(isAFM, 'isAFM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/genericRadioFilter.jsx');
	
	  __REACT_HOT_LOADER__.register(renderSections, 'renderSections', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/genericRadioFilter.jsx');
	
	  __REACT_HOT_LOADER__.register(genericRadioFilter, 'genericRadioFilter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/genericRadioFilter.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/genericRadioFilter.jsx');
	}();

	;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactAutosuggest = __webpack_require__(85);
	
	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
	
	var _reactIsolatedScroll = __webpack_require__(87);
	
	var _reactIsolatedScroll2 = _interopRequireDefault(_reactIsolatedScroll);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _autoSuggest_actions = __webpack_require__(72);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* --------------- */
	/*    Component    */
	/* --------------- */
	var GenericProductSuggest = function (_Component) {
	  _inherits(GenericProductSuggest, _Component);
	
	  function GenericProductSuggest() {
	    _classCallCheck(this, GenericProductSuggest);
	
	    var _this = _possibleConstructorReturn(this, (GenericProductSuggest.__proto__ || Object.getPrototypeOf(GenericProductSuggest)).call(this));
	
	    _this.onChange = function (event, _ref) {
	      var newValue = _ref.newValue;
	
	      _this.setState({
	        value: newValue
	      });
	    };
	
	    _this.onSuggestionsFetchRequested = function (_ref2) {
	      var value = _ref2.value;
	
	      _this.loadSuggestions(value);
	    };
	
	    _this.onSuggestionsClearRequested = function () {
	      _this.setState({
	        suggestions: []
	      });
	    };
	
	    _this.onKeyPress = function () {
	      false;
	    };
	
	    _this.onSuggestionSelected = function (event, _ref3) {
	      var suggestion = _ref3.suggestion;
	
	      var savedEvent = event.target;
	      // function to get product here
	      event.stopPropagation();
	      event.preventDefault();
	      // console.log('searching by', suggestion);
	      if (_this.props.setProductNum) {
	        _this.props.setProductNum(suggestion.ProductNum);
	      }
	      _this.props.fetchOrdersByProduct(suggestion.ProductNum, suggestion, savedEvent);
	    };
	
	    _this.getSuggestionValue = function (suggestion) {
	      console.log("suggestion: ", suggestion);
	      switch (_this.props.SearchType) {
	        case 'ProductNum':
	          return suggestion.ProductNum + ' | ' + suggestion.Name;
	        case 'RefNum':
	          return suggestion.RefNum + ' | ' + suggestion.Name;
	        case 'InStock':
	          return suggestion.InStock;
	        case 'Name':
	          return suggestion.Name;
	        case 'Description':
	          return suggestion.Description + ' | ' + suggestion.Name;
	
	        default:
	          return null;
	      }
	    };
	
	    _this.renderSuggestion = function (suggestion) {
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        _defineProperty({ className: 'suggestion', id: 'suggestion-render' }, 'className', 'sales-auto-suggest-suggestions'),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          suggestion.ProductNum
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          suggestion.RefNum
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          suggestion.InStock
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 5 },
	          suggestion.Name
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 1 },
	          suggestion.Description
	        )
	      );
	    };
	
	    _this.renderSearchTypeHeader = function () {
	      switch (_this.props.SearchType) {
	        case 'ProductNum':
	          return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' });
	        default:
	          return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' });
	      }
	    };
	
	    _this.renderSuggestionsContainer = function (_ref4) {
	      var containerProps = _ref4.containerProps,
	          children = _ref4.children;
	
	      var ref = containerProps.ref,
	          restContainerProps = _objectWithoutProperties(containerProps, ['ref']);
	
	      var callRef = function callRef(scrollingDiv) {
	        if (scrollingDiv !== null) {
	          ref(scrollingDiv.component);
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        restContainerProps,
	        _react2.default.createElement(
	          'div',
	          { className: 'container', style: { width: '100%' }, id: 'suggestion-container' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { style: { padding: '10px 5px', margin: '0px' }, className: 'sales-auto-suggest-suggestions', id: 'sales-auto-suggest-header' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 2 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 2 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 2 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 5 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 1 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactIsolatedScroll2.default,
	          { id: 'suggestions-customer-container', ref: callRef },
	          children
	        )
	      );
	    };
	
	    _this.state = {
	      value: '',
	      suggestions: [],
	      Product_id: 0,
	      noSuggestions: false
	    };
	    _this.lastRequestId = null;
	    return _this;
	  }
	
	  _createClass(GenericProductSuggest, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var isInputBlank = nextProps.value === '';
	      var noSuggestions = !isInputBlank && nextProps.productSuggestions.length === 0;
	      this.setState({ noSuggestions: noSuggestions });
	      if (nextProps.productSuggestions !== this.props.productSuggestions) {
	        this.setState({ isLoading: false, suggestions: [].concat(_toConsumableArray(nextProps.productSuggestions.slice(0, 200))) });
	      }
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus(event) {
	      event.target.select();
	    }
	  }, {
	    key: 'loadSuggestions',
	    value: function loadSuggestions(value) {
	      this.props.fetchProductSuggestions(this.props.SearchType, value);
	    }
	  }, {
	    key: 'renderErrorMessage',
	    value: function renderErrorMessage() {
	      var noSuggestions = this.state.noSuggestions;
	
	      if (noSuggestions && !this.props.productSuggestionsIsLoading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'no-suggestions' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no_data_found' })
	        );
	      }
	      return _react2.default.createElement('div', null);
	    }
	  }, {
	    key: 'renderSearchTypeValue',
	    value: function renderSearchTypeValue(suggestion) {
	      switch (this.props.SearchType) {
	        case 'ProductNum':
	          return suggestion.ProductNum;
	        default:
	          return suggestion.RefNum;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var suggestions = this.state.suggestions;
	
	      var inputProps = {
	        value: this.props.value,
	        onChange: this.props.onChange,
	        onKeyPress: this.onKeyPress,
	        onFocus: this.onFocus,
	        id: 'purchase-auto-suggest'
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactAutosuggest2.default, {
	          suggestions: suggestions,
	          onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
	          onSuggestionsClearRequested: this.onSuggestionsClearRequested,
	          focusInputOnSuggestionClick: false,
	          getSuggestionValue: this.getSuggestionValue,
	          renderSuggestion: this.renderSuggestion,
	          renderSuggestionsContainer: this.renderSuggestionsContainer,
	          onSuggestionSelected: this.onSuggestionSelected,
	          highlightFirstSuggestion: true,
	          inputProps: inputProps
	        }),
	        this.renderErrorMessage()
	      );
	    }
	  }]);
	
	  return GenericProductSuggest;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    productSuggestions: state.autoSuggest.productSuggestions,
	    productSuggestionsIsLoading: state.autoSuggest.productSuggestionsIsLoading,
	    productSuggestionsError: state.autoSuggest.productSuggestionsError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchPurchaseOrderProductByID: _purchaseOrders_actions.fetchPurchaseOrderProductByID, fetchProductSuggestions: _autoSuggest_actions.fetchProductSuggestions })(GenericProductSuggest);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Common/GenericProductSuggest.jsx');
	
	  __REACT_HOT_LOADER__.register(GenericProductSuggest, 'GenericProductSuggest', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Common/GenericProductSuggest.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Common/GenericProductSuggest.jsx');
	}();

	;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchSalesInvoices = fetchSalesInvoices;
	exports.fetchSalesInvoicesSuccess = fetchSalesInvoicesSuccess;
	exports.fetchSalesInvoicesFailure = fetchSalesInvoicesFailure;
	exports.fetchSalesInvoicesByNum = fetchSalesInvoicesByNum;
	exports.fetchSalesInvoicesByNumSuccess = fetchSalesInvoicesByNumSuccess;
	exports.fetchSalesInvoicesByNumFailure = fetchSalesInvoicesByNumFailure;
	exports.fetchSalesInvoicesCompleted = fetchSalesInvoicesCompleted;
	exports.fetchSalesInvoicesCompletedSuccess = fetchSalesInvoicesCompletedSuccess;
	exports.fetchSalesInvoicesCompletedFailure = fetchSalesInvoicesCompletedFailure;
	exports.fetchSalesInvoiceCompletedDetail = fetchSalesInvoiceCompletedDetail;
	exports.requestSalesInvoiceCompletedDetail = requestSalesInvoiceCompletedDetail;
	exports.fetchSalesInvoiceCompletedDetailSuccess = fetchSalesInvoiceCompletedDetailSuccess;
	exports.fetchSalesInvoiceCompletedDetailFailure = fetchSalesInvoiceCompletedDetailFailure;
	exports.selectSalesInvoice = selectSalesInvoice;
	exports.resetCurrentSalesInvoice = resetCurrentSalesInvoice;
	exports.resetCurrentSalesInvoicePromise = resetCurrentSalesInvoicePromise;
	exports.fetchSalesInvoicesByType = fetchSalesInvoicesByType;
	exports.fetchSalesInvoiceDetail = fetchSalesInvoiceDetail;
	exports.requestSalesInvoiceDetail = requestSalesInvoiceDetail;
	exports.fetchSalesInvoiceDetailSuccess = fetchSalesInvoiceDetailSuccess;
	exports.fetchSalesInvoiceDetailFailure = fetchSalesInvoiceDetailFailure;
	exports.fetchFinalizedInvoices = fetchFinalizedInvoices;
	exports.requestFinalizedInvoices = requestFinalizedInvoices;
	exports.fetchFinalizedInvoicesSuccess = fetchFinalizedInvoicesSuccess;
	exports.fetchFinalizedInvoicesFailure = fetchFinalizedInvoicesFailure;
	exports.updateSalesInvoice = updateSalesInvoice;
	exports.updateSalesInvoiceSuccess = updateSalesInvoiceSuccess;
	exports.updateSalesInvoiceFailure = updateSalesInvoiceFailure;
	exports.clearUpdateSalesInvoice = clearUpdateSalesInvoice;
	exports.updateSalesInvoiceReset = updateSalesInvoiceReset;
	exports.finalizeInvoiceSuccess = finalizeInvoiceSuccess;
	exports.finalizeInvoiceFailure = finalizeInvoiceFailure;
	exports.finalizeInvoice = finalizeInvoice;
	exports.deliverInvoiceSuccess = deliverInvoiceSuccess;
	exports.deliverInvoiceFailure = deliverInvoiceFailure;
	exports.deliverInvoice = deliverInvoice;
	exports.printInvoice = printInvoice;
	exports.fetchInvoiceFormSuccess = fetchInvoiceFormSuccess;
	exports.fetchInvoiceFormFailure = fetchInvoiceFormFailure;
	exports.fetchCustomerItem = fetchCustomerItem;
	exports.fetchUnpaidInvoicesSuccess = fetchUnpaidInvoicesSuccess;
	exports.fetchUnpaidInvoicesFailure = fetchUnpaidInvoicesFailure;
	exports.fetchUnpaidInvoices = fetchUnpaidInvoices;
	exports.fetchCustomerItemSuccess = fetchCustomerItemSuccess;
	exports.fetchCustomerItemFailure = fetchCustomerItemFailure;
	exports.voidInvoice = voidInvoice;
	exports.voidInvoiceSuccess = voidInvoiceSuccess;
	exports.voidInvoiceFailure = voidInvoiceFailure;
	exports.voidReturnSuccess = voidReturnSuccess;
	exports.voidReturnFailure = voidReturnFailure;
	exports.voidReturn = voidReturn;
	exports.editSICustomer = editSICustomer;
	exports.resetEditSICustomer = resetEditSICustomer;
	exports.setField = setField;
	exports.resetFormInputs = resetFormInputs;
	exports.resetIssueInputs = resetIssueInputs;
	exports.updateInvoiceEmployeeNote = updateInvoiceEmployeeNote;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _cleanDates = __webpack_require__(22);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	var _RootUrl = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isEcity = _RootUrl.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || _RootUrl.ROOT_API_URL === 'https://ctstage-scm.truckxi.com/api/';
	// Inventories Actions
	
	function fetchSalesInvoices(type, postingDateGT, postingDateLT, Customer_id, days, status, orderSeller, productNum, isReport) {
	  if (Customer_id != null && Customer_id != '') {
	    Customer_id = '&Deliver_Customer_id=' + Customer_id;
	  } else {
	    Customer_id = '';
	  }
	  var dates = (0, _cleanDates.toFromDates)(days, postingDateGT, postingDateLT);
	  if (status != null) {
	    status = '&SaleStatus=' + status;
	  } else {
	    status = '';
	  }
	
	  var seller = orderSeller;
	  var product = productNum;
	  var report = isReport;
	
	  if (seller) {
	    seller = isEcity ? '&Deliver_Customer_id__Sales_User_id=' + seller : '&Sales_User_id=' + seller;
	  } else {
	    seller = '';
	  }
	
	  if (product) {
	    product = '&ProductNum=' + product;
	  } else {
	    product = '';
	  }
	
	  if (isReport) {
	    report = '&Report=true';
	  } else {
	    report = '&Report=false';
	  }
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SALES_INVOICES });
	    return _axios2.default.get(_url.SALES_INVOICE_URL + type + '?PostingDate__gte=' + dates.fromDate + '&PostingDate__lte=' + dates.toDate + Customer_id + status + seller + product + report, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesInvoicesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesInvoicesFailure(err));
	    });
	  };
	}
	
	function fetchSalesInvoicesSuccess(salesInvoices) {
	  return {
	    type: _type.FETCH_SALES_INVOICES_SUCCESS,
	    payload: salesInvoices
	  };
	}
	
	function fetchSalesInvoicesFailure(error) {
	  return {
	    type: _type.FETCH_SALES_INVOICES_FAILURE,
	    payload: error
	  };
	}
	
	function fetchSalesInvoicesByNum(
	// type,
	postingDateGT, postingDateLT,
	// Customer_id,
	//days,
	InvoiceNum, customerid) {
	  var dates = (0, _cleanDates.toFromDates)(-1, postingDateGT, postingDateLT);
	  if (postingDateGT != null && postingDateGT != '') {
	    postingDateGT = '?PostingDate__gte=' + dates.fromDate;
	  } else {
	    postingDateGT = '';
	  }
	
	  if (postingDateLT != null && postingDateLT != '') {
	    postingDateLT = '&PostingDate__lte=' + dates.toDate;
	  } else {
	    postingDateLT = '';
	  }
	
	  if (InvoiceNum != null && InvoiceNum != '') {
	    InvoiceNum = '&InvoiceNum=' + InvoiceNum;
	  } else {
	    InvoiceNum = '';
	  }
	  // if (days != null && days > 0)
	  //   days = days + "/";
	  // else
	  //   days = '';
	  // if (status != null)
	  //   status = '&SaleStatus=' + status;
	  // else
	  //   status = '';
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SALES_INVOICES_BY_NUM });
	    return _axios2.default.get(_url.SALES_INVOICE_NUM_URL + (customerid ? customerid + '/' : '') + postingDateGT + postingDateLT + InvoiceNum, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesInvoicesByNumSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesInvoicesByNumFailure(err));
	    });
	  };
	}
	
	function fetchSalesInvoicesByNumSuccess(salesInvoices) {
	  return {
	    type: _type.FETCH_SALES_INVOICES_BY_NUM_SUCCESS,
	    payload: salesInvoices
	  };
	}
	
	function fetchSalesInvoicesByNumFailure(error) {
	  return {
	    type: _type.FETCH_SALES_INVOICES_BY_NUM_FAILURE,
	    payload: error
	  };
	}
	
	function fetchSalesInvoicesCompleted(postingDateGT, postingDateLT, CustomerNum)
	// InvoiceNum
	{
	  var dates = (0, _cleanDates.toFromDates)(-1, postingDateGT, postingDateLT);
	  if (postingDateGT != null && postingDateGT != '') {
	    postingDateGT = '?PostingDate__gte=' + dates.fromDate;
	  } else {
	    postingDateGT = '';
	  }
	
	  if (postingDateLT != null && postingDateLT != '') {
	    postingDateLT = '&PostingDate__lte=' + dates.toDate;
	  } else {
	    postingDateLT = '';
	  }
	
	  if (CustomerNum != null) {
	    CustomerNum += '/';
	  } else {
	    CustomerNum = '';
	  }
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SALES_INVOICES_COMPLETED });
	    return _axios2.default.get(_url.SALES_INVOICE_COMPLETED_URL + CustomerNum + postingDateGT + postingDateLT, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesInvoicesCompletedSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesInvoicesCompletedFailure(err));
	    });
	  };
	}
	
	function fetchSalesInvoicesCompletedSuccess(salesInvoices) {
	  return {
	    type: _type.FETCH_SALES_INVOICES_COMPLETED_SUCCESS,
	    payload: salesInvoices
	  };
	}
	
	function fetchSalesInvoicesCompletedFailure(error) {
	  return {
	    type: _type.FETCH_SALES_INVOICES_COMPLETED_FAILURE,
	    payload: error
	  };
	}
	
	function fetchSalesInvoiceCompletedDetail(pk) {
	  if (arguments.length == 2) {
	    return function (dispatch) {
	      dispatch(requestSalesInvoiceCompletedDetail());
	      return _axios2.default.get(_url.SALES_INVOICE_COMPLETED_URL + '?InvoiceNum=' + pk, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        dispatch(fetchSalesInvoiceCompletedDetailSuccess(response));
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = _constants.DEFAULT_ERROR;
	        }
	        dispatch(fetchSalesInvoiceCompletedDetailFailure(err));
	      });
	    };
	  }
	  return function (dispatch) {
	    dispatch(requestSalesInvoiceCompletedDetail());
	    return _axios2.default.get(_url.RELEASE_SALES_ORDER_URL + '?pk=' + pk, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesInvoiceCompletedDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesInvoiceCompletedDetailFailure(err));
	    });
	  };
	}
	
	function requestSalesInvoiceCompletedDetail() {
	  return {
	    type: _type.REQUEST_SALES_INVOICE_DETAIL
	  };
	}
	
	function fetchSalesInvoiceCompletedDetailSuccess(salesInvoiceDetail) {
	  // The date data fetched is in the form of string, which needs to be modified into Date type
	  if (salesInvoiceDetail.data.OrderDate) salesInvoiceDetail.data.OrderDate = (0, _cleanDates.convertUtcDate)(salesInvoiceDetail.data.OrderDate);
	  if (salesInvoiceDetail.data.ETADate) salesInvoiceDetail.data.ETADate = (0, _cleanDates.convertUtcDate)(salesInvoiceDetail.data.ETADate);
	  if (salesInvoiceDetail.data.ReceivedDate) salesInvoiceDetail.data.ReceivedDate = (0, _cleanDates.convertUtcDate)(salesInvoiceDetail.data.ReceivedDate);
	
	  return {
	    type: _type.FETCH_SALES_INVOICE_DETAIL_SUCCESS,
	    payload: salesInvoiceDetail
	  };
	}
	
	function fetchSalesInvoiceCompletedDetailFailure(error) {
	  return {
	    type: _type.FETCH_SALES_INVOICE_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function selectSalesInvoice(salesInvoice) {
	  return function (dispatch) {
	    return new Promise(function (resolve) {
	      dispatch({
	        type: _type.SELECT_SALES_INVOICE,
	        payload: salesInvoice
	      });
	      resolve();
	    });
	  };
	}
	
	function resetCurrentSalesInvoice() {
	  return {
	    type: _type.RESET_CURRENT_SALES_INVOICE
	  };
	}
	
	function resetCurrentSalesInvoicePromise() {
	  return function (dispatch) {
	    return new Promise(function (resolve) {
	      dispatch({
	        type: _type.RESET_CURRENT_SALES_INVOICE
	      });
	      resolve();
	    });
	  };
	}
	
	function fetchSalesInvoicesByType(type) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SALES_INVOICES });
	    return _axios2.default.get(_url.FETCH_SALES_INVOICES_BY_TYPE_URL + type, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesInvoicesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesInvoicesFailure(err));
	    });
	  };
	}
	
	// export function fetchSalesInvoicesByDetails() {
	//     return dispatch => {
	//         dispatch(requestSalesInvoicesByDetails());
	//         return axios.get(FETCH_INVOICE_DETAIL_URL + status + '/' + SalesInvoice_id,
	//             {
	//                 headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	//             }
	//         )
	//             .then(response => {
	//                 dispatch(fetchSalesInvoicesByDetailsSuccess(response));
	//             })
	//             .catch(response => {
	//                 dispatch(fetchSalesInvoicesByDetailsFailure(response));
	//             })
	//     }
	// }
	//
	// export function requestSalesINvoicesByDetails() {
	//     return {
	//         type: REQUEST_SALES_INVOICES_BY_DETAILS
	//     }
	// }
	//
	// export function fetchSalesInvoicesByDetailsSuccess(Invoices) {
	//     return {
	//         type: FETCH_SALES_INVOICES_BY_DETAILS_SUCCESS,
	//         payload: Invoices
	//     }
	// }
	//
	// export function fetchSalesInvoicesByDetailsFailure(error) {
	//     return {
	//         type: FETCH_SALES_INVOICES_BY_DETAILS_FAILURE,
	//         payload: error
	//     }
	// }
	
	function fetchSalesInvoiceDetail(pk) {
	  if (arguments.length == 2) {
	    return function (dispatch) {
	      dispatch(requestSalesInvoiceDetail());
	      return _axios2.default.get(_url.RELEASE_SALES_ORDER_URL + 'search/?InvoiceNum=' + pk, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        dispatch(fetchSalesInvoiceDetailSuccess(response));
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = _constants.DEFAULT_ERROR;
	        }
	        dispatch(fetchSalesInvoiceDetailFailure(err));
	      });
	    };
	  }
	  return function (dispatch) {
	    dispatch(requestSalesInvoiceDetail());
	    return _axios2.default.get(_url.FETCH_INVOICE_DETAIL_URL + pk, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesInvoiceDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesInvoiceDetailFailure(err));
	    });
	  };
	}
	
	function requestSalesInvoiceDetail() {
	  return {
	    type: _type.REQUEST_SALES_INVOICE_DETAIL
	  };
	}
	
	function fetchSalesInvoiceDetailSuccess(salesInvoiceDetail) {
	  salesInvoiceDetail = salesInvoiceDetail.data;
	  // The date data fetched is in the form of string, which needs to be modified into Date type
	  if (salesInvoiceDetail.OrderDate) salesInvoiceDetail.OrderDate = (0, _cleanDates.convertUtcDate)(salesInvoiceDetail.OrderDate);
	  if (salesInvoiceDetail.ETADate) salesInvoiceDetail.ETADate = (0, _cleanDates.convertUtcDate)(salesInvoiceDetail.ETADate);
	  if (salesInvoiceDetail.ReceivedDate) salesInvoiceDetail.ReceivedDate = (0, _cleanDates.convertUtcDate)(salesInvoiceDetail.ReceivedDate);
	  return {
	    type: _type.FETCH_SALES_INVOICE_DETAIL_SUCCESS,
	    payload: salesInvoiceDetail
	  };
	}
	
	function fetchSalesInvoiceDetailFailure(error) {
	  return {
	    type: _type.FETCH_SALES_INVOICE_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function fetchFinalizedInvoices() {
	  return function (dispatch) {
	    dispatch(requestFinalizedInvoices());
	    return _axios2.default.get(_url.FINALIZED_INVOICES_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchFinalizedInvoicesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchFinalizedInvoicesFailure(err));
	    });
	  };
	}
	
	function requestFinalizedInvoices() {
	  return {
	    type: _type.REQUEST_FINALIZED_INVOICES
	  };
	}
	
	function fetchFinalizedInvoicesSuccess(response) {
	  return {
	    type: _type.FETCH_FINALIZED_INVOICES_SUCCESS,
	    payload: response
	  };
	}
	
	function fetchFinalizedInvoicesFailure(error) {
	  return {
	    type: _type.FETCH_FINALIZED_INVOICES_FAILURE,
	    payload: error
	  };
	}
	
	function updateSalesInvoice(_ref, status, pk, PaymentType, PaymentNum, Notation) {
	  var DocumentDate = _ref.DocumentDate,
	      PONum = _ref.PONum,
	      Sales_Invoice_Lines = _ref.Sales_Invoice_Lines,
	      PostingDate = _ref.PostingDate,
	      InvoiceNum = _ref.InvoiceNum,
	      CreateTime = _ref.CreateTime,
	      InvoiceShipDate = _ref.InvoiceShipDate;
	
	  return function (dispatch) {
	    dispatch({ type: _type.UPDATE_SALES_INVOICE });
	    return _axios2.default.put(_url.SALES_INVOICE_UPDATE_URL + pk + '/', {
	      DocumentDate: DocumentDate,
	      Notation: Notation,
	      PaymentNum: PaymentNum,
	      PaymentType: PaymentType,
	      PONum: PONum,
	      Sales_Invoice_Lines: Sales_Invoice_Lines,
	      PostingDate: PostingDate,
	      InvoiceNum: InvoiceNum,
	      CreateTime: CreateTime,
	      InvoiceShipDate: InvoiceShipDate
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(updateSalesInvoiceSuccess(response));
	      // browserHistory.push('/salesInvoice/');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(updateSalesInvoiceFailure(err));
	    });
	  };
	}
	
	function updateSalesInvoiceSuccess(salesInvoiceUpdated) {
	  return {
	    type: _type.UPDATE_SALES_INVOICE_SUCCESS,
	    payload: salesInvoiceUpdated
	  };
	}
	
	function updateSalesInvoiceFailure(error) {
	  return {
	    type: _type.UPDATE_SALES_INVOICE_FAILURE,
	    payload: error
	  };
	}
	
	function clearUpdateSalesInvoice() {
	  return {
	    type: _type.CLEAR_UPDATE_SALES_INVOICE
	  };
	}
	
	function updateSalesInvoiceReset() {
	  return {
	    type: _type.UPDATE_SALES_INVOICE_RESET
	  };
	}
	
	function finalizeInvoiceSuccess() {
	  return {
	    type: _type.FINALIZE_INVOICE_SUCCESS
	  };
	}
	
	function finalizeInvoiceFailure(error) {
	  return {
	    type: _type.FINALIZE_INVOICE_FAILURE,
	    payload: error
	  };
	}
	
	function finalizeInvoice(salesInvoiceIdList) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_FINALIZE_INVOICE });
	    return (0, _axios2.default)({
	      method: 'put',
	      url: '' + _url.FINALIZE_INVOICE_URL,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      data: {
	        ids: salesInvoiceIdList
	      }
	    }).then(function (response) {
	      dispatch(finalizeInvoiceSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(finalizeInvoiceFailure(err));
	    });
	  };
	}
	
	function deliverInvoiceSuccess() {
	  return {
	    type: _type.DELIVER_INVOICE_SUCCESS
	  };
	}
	
	function deliverInvoiceFailure(error) {
	  return {
	    type: _type.DELIVER_INVOICE_FAILURE,
	    payload: error
	  };
	}
	
	function deliverInvoice(salesInvoiceIdList) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_DELIVER_INVOICE });
	    return (0, _axios2.default)({
	      method: 'put',
	      url: '' + _url.DELIVER_INVOICE_URL,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      data: {
	        ids: salesInvoiceIdList
	      }
	    }).then(function (response) {
	      dispatch(deliverInvoiceSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(deliverInvoiceFailure(err));
	    });
	  };
	}
	
	function toBinaryString(data) {
	  console.log('61');
	  var ret = [];
	  var len = data.length;
	  var byte = void 0;
	  for (var i = 0; i < len; i++) {
	    byte = (data.charCodeAt(i) & 0xFF) >>> 0;
	    ret.push(String.fromCharCode(byte));
	  }
	
	  return ret.join('');
	}
	
	function printInvoice(pk) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SALES_INVOICE_FORM });
	    return _axios2.default.get(_url.REQUEST_SALES_INVOICE_FORM_URL + pk, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      var newWindow = window.open('data:application/pdf,' + escape(response.data));
	      dispatch(fetchInvoiceFormSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchInvoiceFormFailure(err));
	    });
	  };
	}
	
	function fetchInvoiceFormSuccess(response) {
	  return {
	    type: _type.FETCH_SALES_INVOICE_FORM_SUCCESS,
	    payload: response
	  };
	}
	
	function fetchInvoiceFormFailure(error) {
	  return {
	    type: _type.FETCH_SALES_INVOICE_FORM_FAILURE,
	    payload: error
	  };
	}
	
	function fetchCustomerItem(customerNum) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CUSTOMER_ITEM });
	    return _axios2.default.get(_url.SALES_INVOICE_UPDATE_URL + 'customer/' + customerNum + '/', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchCustomerItemSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCustomerItemFailure(err));
	    });
	  };
	}
	
	function fetchUnpaidInvoicesSuccess(response) {
	  return {
	    type: _type.FETCH_UNPAID_INVOICE_SUCCESS,
	    payload: response
	  };
	}
	
	function fetchUnpaidInvoicesFailure(error) {
	  return {
	    type: _type.FETCH_UNPAID_INVOICE_FAILURE,
	    payload: error
	  };
	}
	
	function fetchUnpaidInvoices(custId) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_UNPAID_INVOICE });
	    return _axios2.default.get('' + _url.UNPAID_SALES_INVOICE_URL + custId, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchUnpaidInvoicesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchUnpaidInvoicesFailure(err));
	    });
	  };
	}
	
	function fetchCustomerItemSuccess(items) {
	  return {
	    type: _type.FETCH_CUSTOMER_ITEM_SUCCESS,
	    payload: items
	  };
	}
	
	function fetchCustomerItemFailure(error) {
	  return {
	    type: _type.FETCH_CUSTOMER_ITEM_FAILURE,
	    payload: error
	  };
	}
	
	function voidInvoice(pk) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_VOID_INVOICE });
	    var token = localStorage.getItem('token');
	    return (0, _axios2.default)({
	      method: 'post',
	      url: '' + _url.SALES_INVOICE_VOID_URL + pk + '/',
	      headers: { Authorization: 'Bearer ' + token }
	    }).then(function (response) {
	      dispatch(voidInvoiceSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(voidInvoiceFailure(err));
	    });
	  };
	}
	
	function voidInvoiceSuccess() {
	  return {
	    type: _type.VOID_INVOICE_SUCCESS
	  };
	}
	
	function voidInvoiceFailure(error) {
	  return {
	    type: _type.VOID_INVOICE_FAILURE,
	    payload: error
	  };
	}
	
	function voidReturnSuccess() {
	  return {
	    type: _type.VOID_RETURN_SUCCESS
	  };
	}
	
	function voidReturnFailure(error) {
	  return {
	    type: _type.VOID_RETURN_FAILURE,
	    payload: error
	  };
	}
	
	function voidReturn(id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_VOID_RETURN });
	    var token = localStorage.getItem('token');
	    return (0, _axios2.default)({
	      method: 'post',
	      url: '' + _url.SALES_RETURN_URL + id + '/void',
	      headers: { Authorization: 'Bearer ' + token }
	    }).then(function (response) {
	      dispatch(voidReturnSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(voidReturnFailure(err));
	    });
	  };
	}
	
	function editSICustomerSuccess() {
	  return {
	    type: _type.EDIT_SI_CUSTOMER_SUCCESS
	  };
	}
	
	function editSICustomerFailure(error) {
	  return {
	    type: _type.EDIT_SI_CUSTOMER_FAILURE,
	    payload: error
	  };
	}
	
	function editSICustomer(id, _ref2) {
	  var Deliver_Customer_id = _ref2.Deliver_Customer_id,
	      Deliver_CustomerDetail_id = _ref2.Deliver_CustomerDetail_id;
	
	  return function (dispatch) {
	    dispatch({ type: _type.EDIT_SI_CUSTOMER });
	    var token = localStorage.getItem('token');
	    return (0, _axios2.default)({
	      method: 'put',
	      url: '' + _url.EDIT_SI_CUSTOMER_URL + id + '/',
	      headers: { Authorization: 'Bearer ' + token },
	      data: {
	        Deliver_Customer_id: Deliver_Customer_id,
	        Deliver_CustomerDetail_id: Deliver_CustomerDetail_id
	      }
	    }).then(function (response) {
	      dispatch(selectSalesInvoice(response.data)).then(function () {
	        dispatch(editSICustomerSuccess());
	      });
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editSICustomerFailure(err));
	    });
	  };
	}
	
	function resetEditSICustomer() {
	  return {
	    type: _type.RESET_EDIT_SI_CUSTOMER
	  };
	}
	
	function setField(field, value) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)('salesInvoice', field, value));
	  };
	}
	
	function resetFormInputs() {
	  return function (dispatch) {
	    // dispatch(change('editSalesInvoice', 'Quantity', ''));
	    dispatch((0, _reduxForm.change)('editSalesInvoice', 'UnitPrice', ''));
	    dispatch((0, _reduxForm.change)('editSalesInvoice', 'ProductInformation', ''));
	    dispatch((0, _reduxForm.change)('editSalesInvoice', 'Weight', ''));
	    dispatch((0, _reduxForm.change)('editSalesInvoice', 'itemNotation', ''));
	  };
	}
	
	function resetIssueInputs() {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)('customerIssueCredit', 'Quantity', ''));
	    dispatch((0, _reduxForm.change)('customerIssueCredit', 'UnitPrice', ''));
	    dispatch((0, _reduxForm.change)('customerIssueCredit', 'ProductInformation', ''));
	    dispatch((0, _reduxForm.change)('customerIssueCredit', 'Weight', ''));
	    dispatch((0, _reduxForm.change)('customerIssueCredit', 'itemNotation', ''));
	  };
	}
	
	function updateInvoiceEmployeeNote(invoice_id, employeeNoteText) {
	  var output = {
	    EmployeeNote: employeeNoteText
	  };
	  var url = '' + _url.PATCH_INVOICE_EMPLOYEE_NOTE_URL + invoice_id;
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: 'patch',
	      url: url,
	      data: output,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchSalesInvoices, 'fetchSalesInvoices', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchSalesInvoicesSuccess, 'fetchSalesInvoicesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchSalesInvoicesFailure, 'fetchSalesInvoicesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchSalesInvoicesByNum, 'fetchSalesInvoicesByNum', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchSalesInvoicesByNumSuccess, 'fetchSalesInvoicesByNumSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchSalesInvoicesByNumFailure, 'fetchSalesInvoicesByNumFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchSalesInvoicesCompleted, 'fetchSalesInvoicesCompleted', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchSalesInvoicesCompletedSuccess, 'fetchSalesInvoicesCompletedSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchSalesInvoicesCompletedFailure, 'fetchSalesInvoicesCompletedFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchSalesInvoiceCompletedDetail, 'fetchSalesInvoiceCompletedDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(requestSalesInvoiceCompletedDetail, 'requestSalesInvoiceCompletedDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchSalesInvoiceCompletedDetailSuccess, 'fetchSalesInvoiceCompletedDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchSalesInvoiceCompletedDetailFailure, 'fetchSalesInvoiceCompletedDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(selectSalesInvoice, 'selectSalesInvoice', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(resetCurrentSalesInvoice, 'resetCurrentSalesInvoice', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(resetCurrentSalesInvoicePromise, 'resetCurrentSalesInvoicePromise', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchSalesInvoicesByType, 'fetchSalesInvoicesByType', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchSalesInvoiceDetail, 'fetchSalesInvoiceDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(requestSalesInvoiceDetail, 'requestSalesInvoiceDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchSalesInvoiceDetailSuccess, 'fetchSalesInvoiceDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchSalesInvoiceDetailFailure, 'fetchSalesInvoiceDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchFinalizedInvoices, 'fetchFinalizedInvoices', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(requestFinalizedInvoices, 'requestFinalizedInvoices', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchFinalizedInvoicesSuccess, 'fetchFinalizedInvoicesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchFinalizedInvoicesFailure, 'fetchFinalizedInvoicesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(updateSalesInvoice, 'updateSalesInvoice', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(updateSalesInvoiceSuccess, 'updateSalesInvoiceSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(updateSalesInvoiceFailure, 'updateSalesInvoiceFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(clearUpdateSalesInvoice, 'clearUpdateSalesInvoice', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(updateSalesInvoiceReset, 'updateSalesInvoiceReset', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(finalizeInvoiceSuccess, 'finalizeInvoiceSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(finalizeInvoiceFailure, 'finalizeInvoiceFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(finalizeInvoice, 'finalizeInvoice', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(deliverInvoiceSuccess, 'deliverInvoiceSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(deliverInvoiceFailure, 'deliverInvoiceFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(deliverInvoice, 'deliverInvoice', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(toBinaryString, 'toBinaryString', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(printInvoice, 'printInvoice', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInvoiceFormSuccess, 'fetchInvoiceFormSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInvoiceFormFailure, 'fetchInvoiceFormFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerItem, 'fetchCustomerItem', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchUnpaidInvoicesSuccess, 'fetchUnpaidInvoicesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchUnpaidInvoicesFailure, 'fetchUnpaidInvoicesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchUnpaidInvoices, 'fetchUnpaidInvoices', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerItemSuccess, 'fetchCustomerItemSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerItemFailure, 'fetchCustomerItemFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(voidInvoice, 'voidInvoice', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(voidInvoiceSuccess, 'voidInvoiceSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(voidInvoiceFailure, 'voidInvoiceFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(voidReturnSuccess, 'voidReturnSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(voidReturnFailure, 'voidReturnFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(voidReturn, 'voidReturn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(editSICustomerSuccess, 'editSICustomerSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(editSICustomerFailure, 'editSICustomerFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(editSICustomer, 'editSICustomer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(resetEditSICustomer, 'resetEditSICustomer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(setField, 'setField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(resetFormInputs, 'resetFormInputs', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(resetIssueInputs, 'resetIssueInputs', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(updateInvoiceEmployeeNote, 'updateInvoiceEmployeeNote', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoice_actions.jsx');
	}();

	;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.assignDriverToRoute = exports.deleteRoute = exports.printPickinglistAll = exports.printPickinglist = exports.changeStopIndex = exports.updateStopsOfAutoRoutes = exports.fetchAutoRouteStops = exports.fetchAutoRoutes = exports.generateRoute = exports.changeFormValue = undefined;
	exports.requestRoutes = requestRoutes;
	exports.fetchRoutesSuccess = fetchRoutesSuccess;
	exports.fetchAutoRoutesSuccess = fetchAutoRoutesSuccess;
	exports.fetchRoutesFailure = fetchRoutesFailure;
	exports.fetchRoutesPrinter = fetchRoutesPrinter;
	exports.saveRoutesPrinterSuccess = saveRoutesPrinterSuccess;
	exports.saveRoutesPrinter = saveRoutesPrinter;
	exports.fetchRoutes = fetchRoutes;
	exports.requestStops = requestStops;
	exports.fetchStopsSuccess = fetchStopsSuccess;
	exports.fetchStopsFailure = fetchStopsFailure;
	exports.fetchStops = fetchStops;
	exports.requestSaveNewRoute = requestSaveNewRoute;
	exports.saveNewRouteSuccess = saveNewRouteSuccess;
	exports.saveNewRouteFailure = saveNewRouteFailure;
	exports.saveNewRoute = saveNewRoute;
	exports.requestSaveEditedStops = requestSaveEditedStops;
	exports.saveEditedStopsSuccess = saveEditedStopsSuccess;
	exports.saveEditedStopsFailure = saveEditedStopsFailure;
	exports.saveEditedStops = saveEditedStops;
	exports.fetchEditStops = fetchEditStops;
	exports.requestEditStops = requestEditStops;
	exports.fetchEditStopsSuccess = fetchEditStopsSuccess;
	exports.fetchEditStopsFailure = fetchEditStopsFailure;
	exports.saveEdits = saveEdits;
	exports.requestSaveEdits = requestSaveEdits;
	exports.saveEditsSuccess = saveEditsSuccess;
	exports.saveEditsFailure = saveEditsFailure;
	exports.clearEditStatus = clearEditStatus;
	exports.fetchSalesOrdersByDate = fetchSalesOrdersByDate;
	exports.requestSalesOrdersByDate = requestSalesOrdersByDate;
	exports.fetchSalesOrdersByDateSuccess = fetchSalesOrdersByDateSuccess;
	exports.fetchSalesOrdersByDateFailure = fetchSalesOrdersByDateFailure;
	exports.requestCustomerRoutes = requestCustomerRoutes;
	exports.fetchCustomerRoutesSuccess = fetchCustomerRoutesSuccess;
	exports.fetchCustomerRoutesFailure = fetchCustomerRoutesFailure;
	exports.fetchCustomerRoutes = fetchCustomerRoutes;
	exports.fetchUnassignedOrders = fetchUnassignedOrders;
	exports.requestUnassignedOrders = requestUnassignedOrders;
	exports.fetchUnassignedOrdersSuccess = fetchUnassignedOrdersSuccess;
	exports.fetchUnassignedOrdersFailure = fetchUnassignedOrdersFailure;
	exports.requestAssignOrderRoute = requestAssignOrderRoute;
	exports.assignOrderRouteSuccess = assignOrderRouteSuccess;
	exports.assignOrderRouteFailure = assignOrderRouteFailure;
	exports.assignOrderRoute = assignOrderRoute;
	exports.requestRouteEdits = requestRouteEdits;
	exports.saveRouteEditsSuccessful = saveRouteEditsSuccessful;
	exports.saveRouteEditsFailure = saveRouteEditsFailure;
	exports.saveRouteEdits = saveRouteEdits;
	exports.convertToInvoice = convertToInvoice;
	exports.requestConvertToInvoice = requestConvertToInvoice;
	exports.convertToInvoiceSuccess = convertToInvoiceSuccess;
	exports.convertToInvoiceFailure = convertToInvoiceFailure;
	exports.clearConvertingToInvoice = clearConvertingToInvoice;
	exports.convertingToInvoiceReset = convertingToInvoiceReset;
	exports.fetchDrivers = fetchDrivers;
	exports.fetchAllDrivers = fetchAllDrivers;
	exports.fetchDriverCodes = fetchDriverCodes;
	exports.sendDriverInvite = sendDriverInvite;
	exports.fetchDeliveryFee = fetchDeliveryFee;
	exports.saveDeliveryFees = saveDeliveryFees;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _map = __webpack_require__(55);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _root_url = __webpack_require__(9);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isABC = _root_url.ROOT_API_URL === "https://abc-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://abc-scm.truckxi.com/api/";
	
	var form = "AutoRouting";
	
	function requestRoutes() {
	  return {
	    type: _type.REQUEST_ROUTES
	  };
	}
	
	function fetchRoutesSuccess(routes) {
	  return {
	    type: _type.FETCH_ROUTES_SUCCESS,
	    payload: routes
	  };
	}
	
	function fetchAutoRoutesSuccess(autoRoutes) {
	  return {
	    type: _type.FETCH_AUTO_ROUTES_SUCCESS,
	    payload: autoRoutes
	  };
	}
	
	function fetchRoutesFailure(error) {
	  return {
	    type: _type.FETCH_ROUTES_FAILURE,
	    payload: error
	  };
	}
	
	function fetchRoutesPrinterSuccess(data) {
	  return {
	    type: _type.FETCH_ROUTES_PRINTER_SUCESS,
	    payload: data
	  };
	}
	
	function setButtonsLoading(value) {
	  return {
	    type: _type.SET_AUTO_ROUTING_BUTTONS_LOADING,
	    payload: value
	  };
	}
	
	function startFetchingAutoRoutes() {
	  return {
	    type: _type.START_FETCHING_AUTO_ROUTES
	  };
	}
	
	var changeFormValue = exports.changeFormValue = function changeFormValue(change, field, value) {
	  return function (dispatch) {
	    dispatch(change(form, field, value));
	  };
	};
	
	function fetchRoutesPrinter() {
	  return function (dispatch) {
	    return (0, _axios2.default)({
	      method: "GET",
	      url: "" + _url.ROUTES_PRINTER_TIME,
	      headers: { Authorization: "Bearer " + localStorage.getItem("token") }
	    }).then(function (res) {
	      dispatch(fetchRoutesPrinterSuccess(res.data));
	    }).catch(function (err) {
	      console.log("err fetching routes printer time", err);
	    });
	  };
	}
	
	function saveRoutesPrinterSuccess(bool) {
	  return {
	    type: _type.SAVE_ROUTES_PRINTER_SUCESS,
	    payload: bool
	  };
	}
	
	function saveRoutesPrinter(data) {
	  return function (dispatch) {
	    dispatch(saveRoutesPrinterSuccess(false));
	    (0, _axios2.default)({
	      method: "PUT",
	      url: "" + _url.ROUTES_PRINTER_TIME,
	      data: data,
	      headers: { Authorization: "Bearer " + localStorage.getItem("token") }
	    }).then(function () {
	      dispatch(saveRoutesPrinterSuccess(true));
	    }).catch(function (err) {
	      console.log("err fetching routes printer time", err);
	    });
	  };
	}
	
	function fetchRoutes(date) {
	  var dateParam = void 0;
	  if (!date) {
	    dateParam = "";
	  } else {
	    var _getFromToDates = (0, _cleanDates.getFromToDates)(date),
	        fromDate = _getFromToDates.fromDate,
	        toDate = _getFromToDates.toDate;
	
	    dateParam = "?StartDate=" + fromDate + "&EndDate=" + toDate;
	  }
	  return function (dispatch) {
	    dispatch(requestRoutes());
	    return (0, _axios2.default)({
	      method: "get",
	      url: _url.DISPATCH_URL + "route/" + dateParam,
	      headers: { Authorization: "Bearer " + localStorage.getItem("token") }
	    }).then(function (response) {
	      dispatch(fetchRoutesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchRoutesFailure(err));
	    });
	  };
	}
	
	var generateRoute = exports.generateRoute = function generateRoute(_ref, success, fail) {
	  var startDateGenerate = _ref.startDateGenerate,
	      endDateGenerate = _ref.endDateGenerate,
	      MaxTotalHours = _ref.MaxTotalHours,
	      RouteCounts = _ref.RouteCounts,
	      ServiceMinutes = _ref.ServiceMinutes,
	      IsForenoon = _ref.IsForenoon;
	  return function (dispatch) {
	    dispatch(setButtonsLoading(true));
	
	    var _toFromDates = (0, _cleanDates.toFromDates)(-1, startDateGenerate, endDateGenerate),
	        fromDate = _toFromDates.fromDate,
	        toDate = _toFromDates.toDate;
	
	    var payload = {
	      StartDeliveryDate: fromDate,
	      EndDeliveryDate: toDate,
	      MaxTotalHours: MaxTotalHours,
	      RouteCounts: RouteCounts,
	      ServiceMinutes: ServiceMinutes,
	      IsForenoon: IsForenoon
	    };
	    return (0, _axios2.default)({
	      method: "POST",
	      data: payload,
	      url: _url.DISPATCH_URL + "optimizer-route",
	      headers: { Authorization: "Bearer " + localStorage.getItem("token") }
	    }).then(function (response) {
	      dispatch(setButtonsLoading(false));
	      success();
	    }, function (err) {
	      fail();
	      alert(err.data);
	      dispatch(setButtonsLoading(false));
	    });
	  };
	};
	
	var fetchAutoRoutes = exports.fetchAutoRoutes = function fetchAutoRoutes(fromDate, toDate) {
	  return function (dispatch) {
	    dispatch(startFetchingAutoRoutes());
	    return (0, _axios2.default)({
	      method: "GET",
	      // data: payload,
	      url: _url.DISPATCH_URL + "optimizer-route-list/?StartDeliveryDate=" + fromDate + "&EndDeliveryDate=" + toDate,
	      headers: { Authorization: "Bearer " + localStorage.getItem("token") }
	    }).then(function (response) {
	      dispatch(fetchAutoRoutesSuccess(response));
	    }, function (err) {});
	  };
	};
	
	var fetchAutoRouteStops = exports.fetchAutoRouteStops = function fetchAutoRouteStops(RouteId) {
	  return function (dispatch) {
	    // const {
	    //   fromDate,
	    //   toDate,
	    // } = toFromDates(-1, StartDeliveryDate, EndDeliveryDate);
	    if (!RouteId) {
	      dispatch(fetchStopsSuccess({
	        data: []
	      }));
	      return;
	    }
	    (0, _axios2.default)({
	      method: "GET",
	      // data: payload,
	      url: _url.DISPATCH_URL + "optimizer-route-list/" + RouteId,
	      headers: { Authorization: "Bearer " + localStorage.getItem("token") }
	    }).then(function (response) {
	      dispatch(fetchStopsSuccess(response));
	    }, function (err) {
	      // if (err.status === 500 || err.status === 404) {
	      //   err.data = DEFAULT_ERROR;
	      // }
	      // dispatch(fetchRoutesFailure(err));
	    });
	  };
	};
	
	var updateStopsOfAutoRoutes = exports.updateStopsOfAutoRoutes = function updateStopsOfAutoRoutes(_ref2) {
	  var routeId = _ref2.routeId,
	      method = _ref2.method,
	      data = _ref2.data,
	      _ref2$callback = _ref2.callback,
	      callback = _ref2$callback === undefined ? function () {} : _ref2$callback;
	  return function (dispatch) {
	    (0, _axios2.default)({
	      method: "PUT",
	      data: data,
	      url: _url.DISPATCH_URL + "update-route-stop/" + routeId + "/" + method,
	      headers: { Authorization: "Bearer " + localStorage.getItem("token") }
	    }).then(function (response) {
	      dispatch(fetchStopsSuccess(response));
	      callback();
	    }, function (err) {
	      // if (err.status === 500 || err.status === 404) {
	      //   err.data = DEFAULT_ERROR;
	      // }
	      // dispatch(fetchRoutesFailure(err));
	    });
	  };
	};
	
	var changeStopIndex = exports.changeStopIndex = function changeStopIndex(data, success) {
	  return function (dispatch) {
	    (0, _axios2.default)({
	      method: "PUT",
	      data: data,
	      url: _url.DISPATCH_URL + "update-route-stop-index",
	      headers: { Authorization: "Bearer " + localStorage.getItem("token") }
	    }).then(function (response) {
	      success();
	    }, function (err) {
	      alert('error updating stop index');
	    });
	  };
	};
	
	function requestStops() {
	  return {
	    type: _type.REQUEST_STOPS
	  };
	}
	
	function fetchStopsSuccess(stops) {
	  return {
	    type: _type.FETCH_STOPS_SUCCESS,
	    payload: stops
	  };
	}
	
	function fetchStopsFailure(error) {
	  return {
	    type: _type.FETCH_STOPS_FAILURE,
	    payload: error
	  };
	}
	
	function fetchStops(routeNum, date) {
	  var _getFromToDates2 = (0, _cleanDates.getFromToDates)(date),
	      fromDate = _getFromToDates2.fromDate,
	      toDate = _getFromToDates2.toDate;
	
	  return function (dispatch) {
	    dispatch(requestStops());
	    return _axios2.default.get(_url.DISPATCH_URL + "stop/" + routeNum + "?StartDate=" + fromDate + "&EndDate=" + toDate, {
	      headers: { Authorization: "Bearer " + localStorage.getItem("token") }
	    }).then(function (response) {
	      dispatch(fetchStopsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchStopsFailure(err));
	    });
	  };
	}
	
	function requestSaveNewRoute() {
	  return {
	    type: _type.REQUEST_SAVE_NEW_ROUTES
	  };
	}
	
	function saveNewRouteSuccess(routes) {
	  return {
	    type: _type.SAVE_NEW_ROUTES_SUCCESS,
	    payload: routes
	  };
	}
	
	function saveNewRouteFailure(error) {
	  return {
	    type: _type.SAVE_NEW_ROUTES_FAILURE,
	    payload: error
	  };
	}
	
	function saveNewRoute(Day, callback) {
	  return function (dispatch) {
	    dispatch(requestRoutes());
	    return _axios2.default.post(_url.DISPATCH_URL + "route/", {
	      Day: Day
	    }, {
	      headers: { Authorization: "Bearer " + localStorage.getItem("token") }
	    }).then(function (response) {
	      Promise.resolve(dispatch(saveNewRouteSuccess(response))).then(function () {
	        return callback();
	      });
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(saveNewRouteFailure(err));
	    });
	  };
	}
	
	function requestSaveEditedStops() {
	  return {
	    type: _type.SAVE_EDITED_STOPS
	  };
	}
	
	function saveEditedStopsSuccess(stops) {
	  return {
	    type: _type.SAVE_EDITED_STOPS_SUCCESS,
	    payload: stops
	  };
	}
	
	function saveEditedStopsFailure(error) {
	  return {
	    type: _type.SAVE_EDITED_STOPS_FAILURE,
	    payload: error
	  };
	}
	
	function saveEditedStops(Stops, date, DispatchRouteId) {
	  var _getFromToDates3 = (0, _cleanDates.getFromToDates)(date),
	      fromDate = _getFromToDates3.fromDate,
	      toDate = _getFromToDates3.toDate;
	
	  return function (dispatch) {
	    dispatch(requestSaveEditedStops());
	    return _axios2.default.put(_url.DISPATCH_URL + "stop/?StartDate=" + fromDate + "&EndDate=" + toDate, {
	      DispatchRouteId: DispatchRouteId,
	      Stops: Stops
	    }, {
	      headers: { Authorization: "Bearer " + localStorage.getItem("token") }
	    }).then(function (response) {
	      dispatch(saveEditedStopsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(saveEditedStopsFailure(err));
	    });
	  };
	}
	
	function fetchEditStops(date, Route_id) {
	  return function (dispatch) {
	    dispatch(requestEditStops());
	    return _axios2.default.get(_url.DISPATCH_URL + "stop/" + (0, _cleanDates.convertUtcDate)(date) + "/" + Route_id, {
	      headers: { Authorization: "Bearer " + localStorage.getItem("token") }
	    }).then(function (response) {
	      dispatch(fetchEditStopsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchEditStopsFailure(err));
	    });
	  };
	}
	
	function requestEditStops() {
	  return {
	    type: _type.REQUEST_EDIT_STOPS
	  };
	}
	
	function fetchEditStopsSuccess(stops) {
	  return {
	    type: _type.FETCH_EDIT_STOPS_SUCCESS,
	    payload: stops
	  };
	}
	
	function fetchEditStopsFailure(error) {
	  return {
	    type: _type.FETCH_EDIT_STOPS_FAILURE,
	    payload: error
	  };
	}
	
	function saveEdits(_ref3) {
	  var TempDate = _ref3.TempDate,
	      TempDispatchRoute_id = _ref3.TempDispatchRoute_id,
	      Stops = _ref3.Stops;
	
	  TempDate = TempDate ? (0, _cleanDates.convertUtcDate)(TempDate) : "";
	  return function (dispatch) {
	    dispatch(requestSaveEdits());
	    return _axios2.default.put(_url.DISPATCH_URL + "stop/", {
	      TempDate: TempDate,
	      TempDispatchRoute_id: TempDispatchRoute_id,
	      Stops: Stops
	    }, {
	      headers: { Authorization: "Bearer " + localStorage.getItem("token") }
	    }).then(function (response) {
	      dispatch(saveEditsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(saveEditsFailure(err));
	    });
	  };
	}
	
	function requestSaveEdits() {
	  return {
	    type: _type.REQUEST_SAVE_EDITS
	  };
	}
	
	function saveEditsSuccess() {
	  return {
	    type: _type.SAVE_EDITS_SUCCESS
	  };
	}
	
	function saveEditsFailure(error) {
	  return {
	    type: _type.SAVE_EDITS_FAILURE,
	    payload: error
	  };
	}
	
	function clearEditStatus() {
	  return {
	    type: _type.CLEAR_EDIT_STATUS
	  };
	}
	
	function fetchSalesOrdersByDate(_ref4) {
	  var fromDate = _ref4.fromDate,
	      toDate = _ref4.toDate;
	
	  return function (dispatch) {
	    dispatch(requestSalesOrdersByDate());
	    var dates = (0, _cleanDates.toFromDates)(-1, fromDate, toDate);
	    return (0, _axios2.default)({
	      method: "get",
	      url: _url.OUTGOING_ORDERS_BY_DATE_URL,
	      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
	      params: {
	        start_date: dates.fromDate,
	        end_date: dates.toDate
	      }
	    }).then(function (response) {
	      dispatch(fetchSalesOrdersByDateSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesOrdersByDateFailure(err));
	    });
	  };
	}
	
	function requestSalesOrdersByDate() {
	  return {
	    type: _type.REQUEST_SALES_ORDERS_BY_DATE
	  };
	}
	
	function fetchSalesOrdersByDateSuccess(orders) {
	  return {
	    type: _type.FETCH_SALES_ORDERS_BY_DATE_SUCCESS,
	    payload: orders
	  };
	}
	
	function fetchSalesOrdersByDateFailure(error) {
	  return {
	    type: _type.FETCH_SALES_ORDERS_BY_DATE_FAILURE,
	    payload: error
	  };
	}
	
	function requestCustomerRoutes() {
	  return {
	    type: _type.REQUEST_CUSTOMER_ROUTES
	  };
	}
	
	function fetchCustomerRoutesSuccess(routes) {
	  return {
	    type: _type.FETCH_CUSTOMER_ROUTES_SUCCESS,
	    payload: routes
	  };
	}
	
	function fetchCustomerRoutesFailure(error) {
	  return {
	    type: _type.FETCH_CUSTOMER_ROUTES_FAILURE,
	    payload: error
	  };
	}
	
	function fetchCustomerRoutes(day) {
	  var dayString = day === "All" ? "" : "?Day=" + day;
	  return function (dispatch) {
	    dispatch(requestCustomerRoutes());
	    return _axios2.default.get(_url.DISPATCH_URL + "customers/" + dayString, {
	      headers: { Authorization: "Bearer " + localStorage.getItem("token") }
	    }).then(function (response) {
	      dispatch(fetchCustomerRoutesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchCustomerRoutesFailure(err));
	    });
	  };
	}
	
	function fetchUnassignedOrders(date) {
	  var _getFromToDates4 = (0, _cleanDates.getFromToDates)(date),
	      fromDate = _getFromToDates4.fromDate,
	      toDate = _getFromToDates4.toDate;
	
	  var belongWarehouse = "";
	  if (!localStorage.getItem("warehouseLocation") || localStorage.getItem("warehouseLocation") === "") {
	    belongWarehouse = "";
	  } else {
	    belongWarehouse = "&BelongWarehouse=" + localStorage.getItem("warehouseLocation");
	  }
	  return function (dispatch) {
	    dispatch(requestUnassignedOrders());
	    return _axios2.default.get(_url.DISPATCH_URL + "orders/?StartDate=" + fromDate + "&EndDate=" + toDate + belongWarehouse, {
	      headers: { Authorization: "Bearer " + localStorage.getItem("token") }
	    }).then(function (response) {
	      dispatch(fetchUnassignedOrdersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchUnassignedOrdersFailure(err));
	    });
	  };
	}
	
	function requestUnassignedOrders() {
	  return {
	    type: _type.REQUEST_UNASSIGNED_ORDERS
	  };
	}
	
	function fetchUnassignedOrdersSuccess(orders) {
	  return {
	    type: _type.FETCH_UNASSIGNED_ORDERS_SUCCESS,
	    payload: orders
	  };
	}
	
	function fetchUnassignedOrdersFailure(error) {
	  return {
	    type: _type.FETCH_UNASSIGNED_ORDERS_FAILURE,
	    payload: error
	  };
	}
	
	function requestAssignOrderRoute() {
	  return {
	    type: _type.REQUEST_ASSIGN_ORDER_ROUTE
	  };
	}
	
	function assignOrderRouteSuccess() {
	  return {
	    type: _type.ASSIGN_ORDER_ROUTE_SUCCESS
	  };
	}
	
	function assignOrderRouteFailure(error) {
	  return {
	    type: _type.ASSIGN_ORDER_ROUTE_FAILURE,
	    payload: error
	  };
	}
	
	function assignOrderRoute(orders) {
	  return function (dispatch) {
	    dispatch(requestAssignOrderRoute());
	    return _axios2.default.post(_url.DISPATCH_URL + "stop/", {
	      orders: orders
	    }, {
	      headers: { Authorization: "Bearer " + localStorage.getItem("token") }
	    }).then(function (response) {
	      dispatch(assignOrderRouteSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(assignOrderRouteFailure(err));
	    });
	  };
	}
	
	function requestRouteEdits() {
	  return {
	    type: _type.REQUEST_SAVE_ROUTE_EDITS
	  };
	}
	
	function saveRouteEditsSuccessful() {
	  return {
	    type: _type.SAVE_ROUTE_EDIT_SUCCESS
	  };
	}
	
	function saveRouteEditsFailure(error) {
	  return {
	    type: _type.SAVE_ROUTE_EDIT_FAILURE,
	    payload: error
	  };
	}
	
	function saveRouteEdits(OldRoute, NewRoute, email, driverId) {
	  return function (dispatch) {
	    dispatch(requestRouteEdits());
	    return (0, _axios2.default)({
	      method: "put",
	      url: _url.DISPATCH_URL + "customers/",
	      data: {
	        OldRoute: OldRoute,
	        NewRoute: NewRoute,
	        Email: email,
	        driver_id: driverId
	      },
	      headers: { Authorization: "Bearer " + localStorage.getItem("token") }
	    }).then(function (response) {
	      dispatch(saveRouteEditsSuccessful(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(saveRouteEditsFailure(err));
	    });
	  };
	}
	
	function convertToInvoice(pk, lines, PaymentType, PaymentNum, isPartial, InvoiceShipDate, shipment_info) {
	  if (!PaymentType) {
	    PaymentType = "Not Paid";
	  }
	  return function (dispatch) {
	    dispatch(requestConvertToInvoice());
	    var type = isPartial ? "partial" : "completed";
	    var url = !isABC ? "" + _url.RELEASE_SALES_ORDER_URL + pk + "/" : "" + _url.RELEASE_SALES_ORDER_URL + pk + "/" + type;
	    return _axios2.default.post(url, {
	      Sales_Order_Lines: lines,
	      PaymentType: PaymentType,
	      PaymentNum: PaymentNum,
	      InvoiceShipDate: InvoiceShipDate,
	      shipment_info: shipment_info
	    }, {
	      headers: { Authorization: "Bearer " + localStorage.getItem("token") }
	    }).then(function (response) {
	      dispatch(convertToInvoiceSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(convertToInvoiceFailure(err));
	    });
	  };
	}
	
	function requestConvertToInvoice() {
	  return {
	    type: _type.REQUEST_CONVERT_TO_INVOICE
	  };
	}
	
	function convertToInvoiceSuccess(invoice) {
	  return {
	    type: _type.CONVERT_TO_INVOICE_SUCCESS,
	    payload: invoice
	  };
	}
	
	function convertToInvoiceFailure(error) {
	  return {
	    type: _type.CONVERT_TO_INVOICE_FAILURE,
	    payload: error
	  };
	}
	
	function clearConvertingToInvoice() {
	  return {
	    type: _type.CLEAR_CONVERT_TO_INVOICE
	  };
	}
	
	function convertingToInvoiceReset() {
	  return {
	    type: _type.CONVERT_TO_INVOICE_RESET
	  };
	}
	
	var salesOrderShape = function salesOrderShape() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return (0, _map2.default)(data, function (obj) {
	    return {
	      soNum: obj.SONum,
	      shipmentDate: obj.ShipmentDate,
	      driverFee: obj.driver_fee,
	      truckxiFee: obj.truckxi_fee,
	      totalDeliveryFee: obj.total_delivery_fee
	    };
	  });
	};
	
	var desiredDriversShape = function desiredDriversShape() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return (0, _map2.default)(data, function (obj) {
	    return {
	      driverLicenseNumber: obj.driver_license_number,
	      email: obj.email,
	      name: obj.first_name + " " + obj.last_name,
	      id: obj.id,
	      isActive: obj.is_active,
	      isExternalWorker: obj.is_external_worker,
	      licensePlate: obj.license_plate,
	      phone: obj.phone,
	      userId: obj.user_id,
	      salesOrders: salesOrderShape(obj.sales_orders)
	    };
	  });
	};
	
	function fetchDrivers(startDate, endDate, handleSuccess, handleFailure) {
	  var _toFromDates2 = (0, _cleanDates.toFromDates)(-1, startDate, endDate),
	      fromDate = _toFromDates2.fromDate,
	      toDate = _toFromDates2.toDate;
	
	  var config = {
	    method: "get",
	    url: _url.BASE_USER_URL + "driver/",
	    params: {
	      sales_orders__ShipmentDate__gte: fromDate,
	      sales_orders__ShipmentDate__let: toDate
	    },
	    headers: {
	      Authorization: "Bearer " + localStorage.getItem("token")
	    }
	  };
	  (0, _axios2.default)(config).then(function (response) {
	    handleSuccess(desiredDriversShape(response.data));
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err);
	  });
	}
	
	var printPickinglist = exports.printPickinglist = function printPickinglist(routeId) {
	  return function (dispatch) {
	    (0, _axios2.default)({
	      method: 'GET',
	      url: _root_url.ROOT_URL + "v1/sale/printpickinglistnew/" + routeId,
	      headers: {
	        Authorization: "Bearer " + localStorage.getItem("token")
	      },
	      responseType: 'blob'
	    }).then(function (res) {
	      dispatch({
	        type: 'AUTO_ROUTING/routePickingList',
	        payload: res.data
	      });
	    }, function (err) {
	      alert('err on deleting selected route', err);
	    });
	  };
	};
	
	var printPickinglistAll = exports.printPickinglistAll = function printPickinglistAll(routeId) {
	  return function (dispatch) {
	    (0, _axios2.default)({
	      method: 'GET',
	      url: _root_url.ROOT_URL + "v1/sale/printpickingliststop/" + routeId,
	      headers: {
	        Authorization: "Bearer " + localStorage.getItem("token")
	      },
	      responseType: 'blob'
	    }).then(function (res) {
	      dispatch({
	        type: 'AUTO_ROUTING/routePickingList',
	        payload: res.data
	      });
	    }, function (err) {
	      alert('err on deleting selected route', err);
	    });
	  };
	};
	
	var deleteRoute = exports.deleteRoute = function deleteRoute(routeId, success) {
	  // console.log("deleteRoute run routeId ", routeId);
	  // success();
	  (0, _axios2.default)({
	    method: 'POST',
	    url: _root_url.ROOT_URL + "v1/dispatch/optimizer-route/" + routeId
	  }).then(function (res) {
	    success();
	  }, function (err) {
	    alert('err on deleting selected route', err);
	  });
	};
	
	var assignDriverToRoute = exports.assignDriverToRoute = function assignDriverToRoute(data, success, fail) {
	  var config = {
	    method: "POST",
	    url: _url.DISPATCH_URL + "assign-route-to-driver",
	    data: data,
	    headers: {
	      Authorization: "Bearer " + localStorage.getItem("token")
	    }
	  };
	  (0, _axios2.default)(config).then(function (response) {
	    success();
	  }, function (err) {
	    fail();
	  });
	};
	
	function fetchAllDrivers(handleSuccess, handleFailure) {
	  var config = {
	    method: "get",
	    url: _url.BASE_USER_URL + "driver/",
	    headers: {
	      Authorization: "Bearer " + localStorage.getItem("token")
	    }
	  };
	  (0, _axios2.default)(config).then(function (response) {
	    handleSuccess(desiredDriversShape(response.data));
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err);
	  });
	}
	
	var desiredDriverCodesShape = function desiredDriverCodesShape() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return {
	    internalCode: data.internal_driver_registration_code,
	    externalCode: data.external_driver_registration_code
	  };
	};
	
	function fetchDriverCodes(handleSuccess, handleFailure) {
	  var config = {
	    method: "get",
	    url: _url.BASE_USER_URL + "driver-registration-code",
	    headers: {
	      Authorization: "Bearer " + localStorage.getItem("token")
	    }
	  };
	  (0, _axios2.default)(config).then(function (response) {
	    handleSuccess(desiredDriverCodesShape(response.data));
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err);
	  });
	}
	
	function sendDriverInvite(email, isExternal, handleSuccess, handleFailure) {
	  var config = {
	    method: "post",
	    url: _url.BASE_USER_URL + "invite-driver",
	    data: {
	      email: email,
	      is_external_worker: isExternal
	    },
	    headers: {
	      Authorization: "Bearer " + localStorage.getItem("token")
	    }
	  };
	  (0, _axios2.default)(config).then(function () {
	    handleSuccess();
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err);
	  });
	}
	
	var desiredDeliveryFeeShape = function desiredDeliveryFeeShape() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return (0, _map2.default)(data, function (obj) {
	    return {
	      driverFeeRate: obj.sales_order_driver_fee_rate,
	      truckxiFeeRate: obj.sales_order_truckxi_fee_rate
	    };
	  });
	};
	
	function fetchDeliveryFee(handleSuccess, handleFailure) {
	  var config = {
	    method: "get",
	    url: _url.DISPATCH_DELIVERY_FEE_URL,
	    headers: {
	      Authorization: "Bearer " + localStorage.getItem("token")
	    }
	  };
	  (0, _axios2.default)(config).then(function (response) {
	    handleSuccess(desiredDeliveryFeeShape(response.data));
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err);
	  });
	}
	
	function saveDeliveryFees(driverFeeRate, truckxiFeeRate, handleSuccess, handleFailure) {
	  var config = {
	    method: "put",
	    url: _url.DISPATCH_DELIVERY_FEE_URL,
	    data: {
	      sales_order_driver_fee_rate: driverFeeRate,
	      sales_order_truckxi_fee_rate: truckxiFeeRate
	    },
	    headers: {
	      Authorization: "Bearer " + localStorage.getItem("token")
	    }
	  };
	  (0, _axios2.default)(config).then(function () {
	    handleSuccess();
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err);
	  });
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestRoutes, "requestRoutes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchRoutesSuccess, "fetchRoutesSuccess", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchAutoRoutesSuccess, "fetchAutoRoutesSuccess", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchRoutesFailure, "fetchRoutesFailure", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchRoutesPrinterSuccess, "fetchRoutesPrinterSuccess", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(setButtonsLoading, "setButtonsLoading", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(startFetchingAutoRoutes, "startFetchingAutoRoutes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(changeFormValue, "changeFormValue", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchRoutesPrinter, "fetchRoutesPrinter", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(saveRoutesPrinterSuccess, "saveRoutesPrinterSuccess", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(saveRoutesPrinter, "saveRoutesPrinter", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchRoutes, "fetchRoutes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(generateRoute, "generateRoute", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchAutoRoutes, "fetchAutoRoutes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchAutoRouteStops, "fetchAutoRouteStops", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(updateStopsOfAutoRoutes, "updateStopsOfAutoRoutes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(changeStopIndex, "changeStopIndex", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(requestStops, "requestStops", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchStopsSuccess, "fetchStopsSuccess", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchStopsFailure, "fetchStopsFailure", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchStops, "fetchStops", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(requestSaveNewRoute, "requestSaveNewRoute", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(saveNewRouteSuccess, "saveNewRouteSuccess", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(saveNewRouteFailure, "saveNewRouteFailure", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(saveNewRoute, "saveNewRoute", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(requestSaveEditedStops, "requestSaveEditedStops", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(saveEditedStopsSuccess, "saveEditedStopsSuccess", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(saveEditedStopsFailure, "saveEditedStopsFailure", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(saveEditedStops, "saveEditedStops", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchEditStops, "fetchEditStops", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(requestEditStops, "requestEditStops", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchEditStopsSuccess, "fetchEditStopsSuccess", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchEditStopsFailure, "fetchEditStopsFailure", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(saveEdits, "saveEdits", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(requestSaveEdits, "requestSaveEdits", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(saveEditsSuccess, "saveEditsSuccess", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(saveEditsFailure, "saveEditsFailure", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(clearEditStatus, "clearEditStatus", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrdersByDate, "fetchSalesOrdersByDate", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(requestSalesOrdersByDate, "requestSalesOrdersByDate", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrdersByDateSuccess, "fetchSalesOrdersByDateSuccess", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrdersByDateFailure, "fetchSalesOrdersByDateFailure", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(requestCustomerRoutes, "requestCustomerRoutes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchCustomerRoutesSuccess, "fetchCustomerRoutesSuccess", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchCustomerRoutesFailure, "fetchCustomerRoutesFailure", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchCustomerRoutes, "fetchCustomerRoutes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchUnassignedOrders, "fetchUnassignedOrders", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(requestUnassignedOrders, "requestUnassignedOrders", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchUnassignedOrdersSuccess, "fetchUnassignedOrdersSuccess", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchUnassignedOrdersFailure, "fetchUnassignedOrdersFailure", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(requestAssignOrderRoute, "requestAssignOrderRoute", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(assignOrderRouteSuccess, "assignOrderRouteSuccess", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(assignOrderRouteFailure, "assignOrderRouteFailure", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(assignOrderRoute, "assignOrderRoute", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(requestRouteEdits, "requestRouteEdits", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(saveRouteEditsSuccessful, "saveRouteEditsSuccessful", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(saveRouteEditsFailure, "saveRouteEditsFailure", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(saveRouteEdits, "saveRouteEdits", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(convertToInvoice, "convertToInvoice", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(requestConvertToInvoice, "requestConvertToInvoice", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(convertToInvoiceSuccess, "convertToInvoiceSuccess", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(convertToInvoiceFailure, "convertToInvoiceFailure", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(clearConvertingToInvoice, "clearConvertingToInvoice", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(convertingToInvoiceReset, "convertingToInvoiceReset", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchDrivers, "fetchDrivers", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(printPickinglist, "printPickinglist", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(printPickinglistAll, "printPickinglistAll", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(deleteRoute, "deleteRoute", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(assignDriverToRoute, "assignDriverToRoute", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchAllDrivers, "fetchAllDrivers", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchDriverCodes, "fetchDriverCodes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(sendDriverInvite, "sendDriverInvite", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchDeliveryFee, "fetchDeliveryFee", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(saveDeliveryFees, "saveDeliveryFees", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(isABC, "isABC", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(form, "form", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(salesOrderShape, "salesOrderShape", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(desiredDriversShape, "desiredDriversShape", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(desiredDriverCodesShape, "desiredDriverCodesShape", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	
	  __REACT_HOT_LOADER__.register(desiredDeliveryFeeShape, "desiredDeliveryFeeShape", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dispatch_actions.jsx");
	}();

	;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchPaymentTerms = fetchPaymentTerms;
	exports.requestPaymentTerms = requestPaymentTerms;
	exports.fetchPaymentTermsSuccess = fetchPaymentTermsSuccess;
	exports.fetchPaymentTermsFailure = fetchPaymentTermsFailure;
	exports.selectPaymentTerm = selectPaymentTerm;
	exports.resetCurrentPaymentTerm = resetCurrentPaymentTerm;
	exports.resetCreatePaymentTerm = resetCreatePaymentTerm;
	exports.resetEditPaymentTerm = resetEditPaymentTerm;
	exports.createPaymentTerm = createPaymentTerm;
	exports.createPaymentTermSuccess = createPaymentTermSuccess;
	exports.createPaymentTermFailure = createPaymentTermFailure;
	exports.editPaymentTerm = editPaymentTerm;
	exports.editPaymentTermSuccess = editPaymentTermSuccess;
	exports.editPaymentTermFailure = editPaymentTermFailure;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchPaymentTerms() {
	    return function (dispatch) {
	        dispatch(requestPaymentTerms());
	        return _axios2.default.get(_url.PAYMENT_URL, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchPaymentTermsSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchPaymentTermsFailure(err));
	        });
	    };
	}
	
	function requestPaymentTerms() {
	    return {
	        type: _type.REQUEST_PAYMENTTERMS
	    };
	}
	
	function fetchPaymentTermsSuccess(paymentTerms) {
	    return {
	        type: _type.FETCH_PAYMENTTERMS_SUCCESS,
	        payload: paymentTerms
	    };
	}
	
	function fetchPaymentTermsFailure(error) {
	    return {
	        type: _type.FETCH_PAYMENTTERMS_FAILURE,
	        payload: error
	    };
	}
	
	function selectPaymentTerm(paymentTerm) {
	    return {
	        type: _type.SELECT_PAYMENTTERM,
	        payload: paymentTerm
	    };
	}
	
	function resetCurrentPaymentTerm() {
	    return {
	        type: _type.RESET_CURRENT_PAYMENTTERM
	    };
	}
	
	function resetCreatePaymentTerm() {
	    return {
	        type: _type.RESET_CREATE_PAYMENT_TERM
	    };
	}
	
	function resetEditPaymentTerm() {
	    return {
	        type: _type.RESET_EDIT_PAYMENT_TERM
	    };
	}
	
	// Actions to deal with the promise of posting function.
	
	function createPaymentTerm(_ref) {
	    var Name = _ref.Name,
	        Description = _ref.Description,
	        TermDays = _ref.TermDays,
	        Termtype = _ref.Termtype;
	
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_CREATING_PAYMENT_TERM });
	        _axios2.default.post(_url.PAYMENT_URL, { Name: Name, Description: Description, TermDays: TermDays, Termtype: Termtype }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(createPaymentTermSuccess());
	            _reactRouter.browserHistory.push('/paymentTerms'); // If created succesfully, refresh the paymentTerm page.
	        }, function (err) {
	            var data = err.data;
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(createPaymentTermFailure(err));
	            throw new _reduxForm.SubmissionError(data);
	        });
	    };
	}
	
	// export function requestCreatingPaymentTerm() {
	//     return {
	//         type: REQUEST_CREATING_PAYMENT_TERM
	//     }
	// }
	
	function createPaymentTermSuccess() {
	    return {
	        type: _type.CREATE_PAYMENT_TERM_SUCCESS
	    };
	}
	
	function createPaymentTermFailure(error) {
	    return {
	        type: _type.CREATE_PAYMENT_TERM_FAILURE,
	        payload: error
	    };
	}
	
	function editPaymentTerm(_ref2) {
	    var PaymentTerm_id = _ref2.PaymentTerm_id,
	        Name = _ref2.Name,
	        Description = _ref2.Description,
	        TermDays = _ref2.TermDays,
	        Termtype = _ref2.Termtype;
	
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_EDITING_PAYMENT_TERM });
	        _axios2.default.put(_url.PAYMENT_URL + PaymentTerm_id, { Name: Name, Description: Description, TermDays: TermDays, Termtype: Termtype }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(editPaymentTermSuccess());
	            _reactRouter.browserHistory.push('/paymentTerms'); // If editd succesfully, refresh the paymentTerm page.
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(editPaymentTermFailure(err));
	        });
	    };
	}
	
	// export function requestCreatingPaymentTerm() {
	//     return {
	//         type: REQUEST_EDITING_PAYMENT_TERM
	//     }
	// }
	
	function editPaymentTermSuccess() {
	    return {
	        type: _type.EDIT_PAYMENT_TERM_SUCCESS
	    };
	}
	
	function editPaymentTermFailure(error) {
	    return {
	        type: _type.EDIT_PAYMENT_TERM_FAILURE,
	        payload: error
	    };
	}
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(fetchPaymentTerms, 'fetchPaymentTerms', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/paymentTerms_actions.js');
	
	    __REACT_HOT_LOADER__.register(requestPaymentTerms, 'requestPaymentTerms', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/paymentTerms_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPaymentTermsSuccess, 'fetchPaymentTermsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/paymentTerms_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPaymentTermsFailure, 'fetchPaymentTermsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/paymentTerms_actions.js');
	
	    __REACT_HOT_LOADER__.register(selectPaymentTerm, 'selectPaymentTerm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/paymentTerms_actions.js');
	
	    __REACT_HOT_LOADER__.register(resetCurrentPaymentTerm, 'resetCurrentPaymentTerm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/paymentTerms_actions.js');
	
	    __REACT_HOT_LOADER__.register(resetCreatePaymentTerm, 'resetCreatePaymentTerm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/paymentTerms_actions.js');
	
	    __REACT_HOT_LOADER__.register(resetEditPaymentTerm, 'resetEditPaymentTerm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/paymentTerms_actions.js');
	
	    __REACT_HOT_LOADER__.register(createPaymentTerm, 'createPaymentTerm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/paymentTerms_actions.js');
	
	    __REACT_HOT_LOADER__.register(createPaymentTermSuccess, 'createPaymentTermSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/paymentTerms_actions.js');
	
	    __REACT_HOT_LOADER__.register(createPaymentTermFailure, 'createPaymentTermFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/paymentTerms_actions.js');
	
	    __REACT_HOT_LOADER__.register(editPaymentTerm, 'editPaymentTerm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/paymentTerms_actions.js');
	
	    __REACT_HOT_LOADER__.register(editPaymentTermSuccess, 'editPaymentTermSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/paymentTerms_actions.js');
	
	    __REACT_HOT_LOADER__.register(editPaymentTermFailure, 'editPaymentTermFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/paymentTerms_actions.js');
	}();

	;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(810),
	    baseIteratee = __webpack_require__(88),
	    baseMap = __webpack_require__(768),
	    isArray = __webpack_require__(78);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PriceFormatter = function (_Component) {
	  _inherits(PriceFormatter, _Component);
	
	  function PriceFormatter() {
	    _classCallCheck(this, PriceFormatter);
	
	    return _possibleConstructorReturn(this, (PriceFormatter.__proto__ || Object.getPrototypeOf(PriceFormatter)).apply(this, arguments));
	  }
	
	  _createClass(PriceFormatter, [{
	    key: "render",
	    value: function render() {
	      var value = this.props.value;
	
	      var floatValue = parseFloat(value);
	      if (floatValue || floatValue === 0) {
	        return _react2.default.createElement(
	          "span",
	          null,
	          parseFloat(roundTo(floatValue, 2)).toFixed(2)
	        );
	      }
	      return _react2.default.createElement(
	        "span",
	        { className: "label label-danger" },
	        "-"
	      );
	    }
	  }]);
	
	  return PriceFormatter;
	}(_react.Component);
	
	var _default = PriceFormatter;
	exports.default = _default;
	
	
	function roundTo(n, digits) {
	  if (digits === undefined) {
	    digits = 0;
	  }
	  var multiplicator = Math.pow(10, digits);
	  n = parseFloat((n * multiplicator).toFixed(11));
	  var test = Math.round(n) / multiplicator;
	  return +test.toFixed(2);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(roundTo, "roundTo", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/priceFormatter.jsx");
	
	  __REACT_HOT_LOADER__.register(PriceFormatter, "PriceFormatter", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/priceFormatter.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/priceFormatter.jsx");
	}();

	;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TypeRadios = _react2.default.createClass({
	  displayName: 'TypeRadios',
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'form-group', id: 'search-product-by' },
	      _react2.default.createElement(
	        'label',
	        { className: 'col-xs-1', style: { width: '55px', paddingRight: '0px' } },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'search' }),
	        ':'
	      ),
	      this.props.InvoiceNoSearch && _react2.default.createElement(
	        'label',
	        { className: 'col-xs-2', style: { width: '60px', paddingRight: '0px' } },
	        _react2.default.createElement('input', {
	          style: { marginRight: '3px' },
	          type: 'radio',
	          value: 'invoiceNo',
	          onChange: this.props.handleOptionChange,
	          checked: this.props.value === 'invoiceNo'
	        }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'SO_no' })
	      ),
	      this.props.TrackingNoSearch && _react2.default.createElement(
	        'label',
	        { className: 'col-xs-2', style: { width: '78px', paddingRight: '0px' } },
	        _react2.default.createElement('input', {
	          style: { marginRight: '3px' },
	          type: 'radio',
	          value: 'trackingNo',
	          onChange: this.props.handleOptionChange,
	          checked: this.props.value === 'trackingNo'
	        }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'track_no' })
	      ),
	      this.props.CPONumSearch && _react2.default.createElement(
	        'label',
	        { className: 'col-xs-2', style: { width: '78px', paddingRight: '0px' } },
	        _react2.default.createElement('input', {
	          style: { marginRight: '3px' },
	          type: 'radio',
	          value: 'CPONum',
	          onChange: this.props.handleOptionChange,
	          checked: this.props.value === 'CPONum'
	        }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cpo_num' })
	      ),
	      this.props.CPONumSearch && _react2.default.createElement(
	        'label',
	        { className: 'col-xs-2', style: { width: '50px', paddingRight: '0px' } },
	        _react2.default.createElement('input', {
	          style: { marginRight: '3px' },
	          type: 'radio',
	          value: 'Type',
	          onChange: this.props.handleOptionChange,
	          checked: this.props.value === 'Type'
	        }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'type' })
	      ),
	      this.props.groupSearch && _react2.default.createElement(
	        'label',
	        { className: 'col-xs-2', style: { width: '70px', paddingRight: '0px' } },
	        _react2.default.createElement('input', {
	          style: { marginRight: '3px' },
	          type: 'radio',
	          value: 'Group',
	          onChange: this.props.handleOptionChange,
	          checked: this.props.value === 'Group'
	        }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'group' })
	      ),
	      _react2.default.createElement(
	        'label',
	        { className: 'col-xs-2', style: { width: '75px', paddingRight: '0px' } },
	        _react2.default.createElement('input', {
	          style: { marginRight: '3px' },
	          type: 'radio',
	          value: 'ProductNum',
	          onChange: this.props.handleOptionChange,
	          checked: this.props.value === 'ProductNum'
	        }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' })
	      ),
	      _react2.default.createElement(
	        'label',
	        { className: 'col-xs-2', style: { width: '70px', paddingRight: '0px' } },
	        _react2.default.createElement('input', {
	          style: { marginRight: '3px' },
	          type: 'radio',
	          value: 'RefNum',
	          onChange: this.props.handleOptionChange,
	          checked: this.props.value === 'RefNum'
	        }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' })
	      ),
	      _react2.default.createElement(
	        'label',
	        { className: 'col-xs-2', style: { width: '60px', paddingRight: '0px' } },
	        _react2.default.createElement('input', {
	          style: { marginRight: '3px' },
	          type: 'radio',
	          value: 'Name',
	          onChange: this.props.handleOptionChange,
	          checked: this.props.value === 'Name'
	        }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	      ),
	      _react2.default.createElement(
	        'label',
	        { className: 'col-xs-2', style: { width: '60px', paddingRight: '0px' } },
	        _react2.default.createElement('input', {
	          style: { marginRight: '3px' },
	          type: 'radio',
	          value: 'Description',
	          onChange: this.props.handleOptionChange,
	          checked: this.props.value === 'Description'
	        }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' })
	      )
	    );
	  }
	});
	
	var _default = TypeRadios;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TypeRadios, 'TypeRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Common/TypeRadios.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Common/TypeRadios.jsx');
	}();

	;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchFavorites = fetchFavorites;
	exports.fetchFavoritesSuccess = fetchFavoritesSuccess;
	exports.fetchFavoritesFailure = fetchFavoritesFailure;
	exports.selectFavorites = selectFavorites;
	exports.resetCurrentFavorites = resetCurrentFavorites;
	exports.fetchFavoritesDetail = fetchFavoritesDetail;
	exports.fetchFavoritesDetailSuccess = fetchFavoritesDetailSuccess;
	exports.fetchFavoritesDetailFailure = fetchFavoritesDetailFailure;
	exports.addNewFavorite = addNewFavorite;
	exports.addFavoriteSuccess = addFavoriteSuccess;
	exports.addFavoriteFailure = addFavoriteFailure;
	exports.deleteFavorite = deleteFavorite;
	exports.deleteFavoriteSuccess = deleteFavoriteSuccess;
	exports.deleteFavoriteFailure = deleteFavoriteFailure;
	exports.addNewFavoriteList = addNewFavoriteList;
	exports.fetchFavoriteList = fetchFavoriteList;
	exports.fetchFavoriteListSuccess = fetchFavoriteListSuccess;
	exports.fetchFavoriteListFailure = fetchFavoriteListFailure;
	exports.saveFavoriteList = saveFavoriteList;
	exports.saveFavoriteListSuccess = saveFavoriteListSuccess;
	exports.saveFavoriteListFailure = saveFavoriteListFailure;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Inventories Actions
	
	function fetchFavorites() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_FAVORITES });
	    return _axios2.default.get(_url.FAVORITES_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchFavoritesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchFavoritesFailure(err));
	    });
	  };
	}
	
	function fetchFavoritesSuccess(favorites) {
	  return {
	    type: _type.FETCH_FAVORITES_SUCCESS,
	    payload: favorites
	  };
	}
	
	function fetchFavoritesFailure(error) {
	  return {
	    type: _type.FETCH_FAVORITES_FAILURE,
	    payload: error
	  };
	}
	
	function selectFavorites(favorites) {
	  return {
	    type: _type.SELECT_FAVORITES,
	    payload: favorites
	  };
	}
	
	function resetCurrentFavorites() {
	  return {
	    type: _type.RESET_CURRENT_FAVORITES
	  };
	}
	
	function fetchFavoritesDetail(favorites_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_FAVORITES_DETAIL });
	    return _axios2.default.get(_url.FAVORITES_URL + favorites_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchFavoritesDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchFavoritesDetailFailure(err));
	    });
	  };
	}
	
	function fetchFavoritesDetailSuccess(favoritesDetail) {
	  return {
	    type: _type.FETCH_FAVORITES_DETAIL_SUCCESS,
	    payload: favoritesDetail
	  };
	}
	
	function fetchFavoritesDetailFailure(error) {
	  return {
	    type: _type.FETCH_FAVORITES_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function addNewFavorite(_ref) {
	  var Product_id = _ref.Product_id,
	      ProductNum = _ref.ProductNum,
	      RefNum = _ref.RefNum,
	      ProductName = _ref.ProductName,
	      PreSale = _ref.PreSale,
	      InStock = _ref.InStock,
	      Ordered = _ref.Ordered,
	      Price = _ref.Price;
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_ADDING_FAVORITE });
	    _axios2.default.post(_url.FAVORITES_URL, {
	      Product_id: Product_id,
	      ProductNum: ProductNum,
	      RefNum: RefNum,
	      ProductName: ProductName,
	      PreSale: PreSale,
	      InStock: InStock,
	      Ordered: Ordered,
	      Price: Price
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(addFavoriteSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(addFavoriteFailure(err));
	    });
	  };
	}
	
	function addFavoriteSuccess() {
	  return {
	    type: _type.ADD_FAVORITE_SUCCESS
	  };
	}
	
	function addFavoriteFailure(response) {
	  return {
	    type: _type.ADD_FAVORITE_FAILURE,
	    payload: response
	  };
	}
	
	function deleteFavorite(Product_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_DELETE_FAVORITE });
	    _axios2.default.delete(_url.FAVORITES_URL + Product_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(deleteFavoriteSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(deleteFavoriteFailure());
	    });
	  };
	}
	
	function deleteFavoriteSuccess() {
	  return {
	    type: _type.DELETE_FAVORITE_SUCCESS
	  };
	}
	
	function deleteFavoriteFailure(response) {
	  return {
	    type: _type.DELETE_FAVORITE_FAILURE,
	    payload: response
	  };
	}
	
	function addNewFavoriteList(Customer_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_ADDING_NEW_FAVORITE_LIST });
	    _axios2.default.post(_url.CUSTOMERS_WITH_FAVORITES_URL + Customer_id, {}, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(addFavoriteSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(addFavoriteFailure(err));
	    });
	  };
	}
	
	function fetchFavoriteList(pk) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_FAVORITE_LIST });
	    return _axios2.default.get(_url.CUSTOMERS_WITH_FAVORITES_URL + pk, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchFavoriteListSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchFavoriteListFailure(err));
	    });
	  };
	}
	
	function fetchFavoriteListSuccess(list) {
	  return {
	    type: _type.FETCH_FAVORITE_LIST_SUCCESS,
	    payload: list
	  };
	}
	
	function fetchFavoriteListFailure(error) {
	  return {
	    type: _type.FETCH_FAVORITE_LIST_FAILURE,
	    payload: error
	  };
	}
	
	function saveFavoriteList(_ref2) {
	  var Customer_id = _ref2.Customer_id,
	      Sales_FavoriteList_Lines = _ref2.Sales_FavoriteList_Lines;
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SAVE_FAVORITE_LIST });
	    _axios2.default.post(_url.CUSTOMERS_WITH_FAVORITES_URL, {
	      Customer_id: Customer_id,
	      Sales_FavoriteList_Lines: Sales_FavoriteList_Lines
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(saveFavoriteListSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(saveFavoriteListFailure(err));
	    });
	  };
	}
	
	function saveFavoriteListSuccess() {
	  return {
	    type: _type.SAVE_FAVORITE_LIST_SUCCESS
	  };
	}
	
	function saveFavoriteListFailure(error) {
	  return {
	    type: _type.SAVE_FAVORITE_LIST_FAILURE,
	    payload: error
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchFavorites, 'fetchFavorites', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favorites_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchFavoritesSuccess, 'fetchFavoritesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favorites_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchFavoritesFailure, 'fetchFavoritesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favorites_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(selectFavorites, 'selectFavorites', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favorites_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(resetCurrentFavorites, 'resetCurrentFavorites', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favorites_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchFavoritesDetail, 'fetchFavoritesDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favorites_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchFavoritesDetailSuccess, 'fetchFavoritesDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favorites_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchFavoritesDetailFailure, 'fetchFavoritesDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favorites_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(addNewFavorite, 'addNewFavorite', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favorites_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(addFavoriteSuccess, 'addFavoriteSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favorites_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(addFavoriteFailure, 'addFavoriteFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favorites_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(deleteFavorite, 'deleteFavorite', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favorites_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(deleteFavoriteSuccess, 'deleteFavoriteSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favorites_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(deleteFavoriteFailure, 'deleteFavoriteFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favorites_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(addNewFavoriteList, 'addNewFavoriteList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favorites_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchFavoriteList, 'fetchFavoriteList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favorites_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchFavoriteListSuccess, 'fetchFavoriteListSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favorites_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchFavoriteListFailure, 'fetchFavoriteListFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favorites_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(saveFavoriteList, 'saveFavoriteList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favorites_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(saveFavoriteListSuccess, 'saveFavoriteListSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favorites_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(saveFavoriteListFailure, 'saveFavoriteListFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favorites_actions.jsx');
	}();

	;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchInventoryConverts = fetchInventoryConverts;
	exports.fetchInventoryConvertsSuccess = fetchInventoryConvertsSuccess;
	exports.fetchInventoryConvertsFailure = fetchInventoryConvertsFailure;
	exports.selectInventoryConvert = selectInventoryConvert;
	exports.resetCurrentInventoryConvert = resetCurrentInventoryConvert;
	exports.fetchInventoryConvertDetail = fetchInventoryConvertDetail;
	exports.fetchInventoryConvertDetailSuccess = fetchInventoryConvertDetailSuccess;
	exports.fetchInventoryConvertDetailFailure = fetchInventoryConvertDetailFailure;
	exports.fetchInventories = fetchInventories;
	exports.fetchInventoriesSuccess = fetchInventoriesSuccess;
	exports.fetchInventoriesFailure = fetchInventoriesFailure;
	exports.createInventoryConvert = createInventoryConvert;
	exports.createInventoryConvertSuccess = createInventoryConvertSuccess;
	exports.createInventoryConvertFailure = createInventoryConvertFailure;
	exports.editInventoryConvert = editInventoryConvert;
	exports.editInventoryConvertSuccess = editInventoryConvertSuccess;
	exports.editInventoryConvertFailure = editInventoryConvertFailure;
	exports.setField = setField;
	exports.createNewConvert = createNewConvert;
	exports.createNewConvertSuccess = createNewConvertSuccess;
	exports.createNewConvertFailure = createNewConvertFailure;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchInventoryConverts() {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_INVENTORY_CONVERTS });
	        return _axios2.default.get(_url.INVENTORY_CONVERTS_URL, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchInventoryConvertsSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchInventoryConvertsFailure(err));
	        });
	    };
	}
	
	// InventoryConverts Actions
	function fetchInventoryConvertsSuccess(inventoryConverts) {
	    return {
	        type: _type.FETCH_INVENTORY_CONVERTS_SUCCESS,
	        payload: inventoryConverts
	    };
	}
	
	function fetchInventoryConvertsFailure(error) {
	    return {
	        type: _type.FETCH_INVENTORY_CONVERTS_FAILURE,
	        payload: error
	    };
	}
	
	function selectInventoryConvert(inventoryConvert) {
	    return {
	        type: _type.SELECT_INVENTORY_CONVERT,
	        payload: inventoryConvert
	    };
	}
	
	function resetCurrentInventoryConvert() {
	    return {
	        type: _type.RESET_CURRENT_INVENTORY_CONVERT
	    };
	}
	
	function fetchInventoryConvertDetail(inventoryConvert_id) {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_INVENTORY_CONVERT_DETAIL });
	        return _axios2.default.get(_url.INVENTORY_CONVERTS_URL + inventoryConvert_id, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchInventoryConvertDetailSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchInventoryConvertDetailFailure(err));
	        });
	    };
	}
	
	function fetchInventoryConvertDetailSuccess(inventoryConvertDetail) {
	    inventoryConvertDetail = inventoryConvertDetail.data;
	    if (inventoryConvertDetail.PostingDate) inventoryConvertDetail.PostingDate = (0, _cleanDates.convertUtcDate)(inventoryConvertDetail.PostingDate);
	    return {
	        type: _type.FETCH_INVENTORY_CONVERT_DETAIL_SUCCESS,
	        payload: inventoryConvertDetail
	    };
	}
	
	function fetchInventoryConvertDetailFailure(error) {
	    return {
	        type: _type.FETCH_INVENTORY_CONVERT_DETAIL_FAILURE,
	        payload: error
	    };
	}
	
	function fetchInventories() {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_INVENTORIES_BIN });
	        return _axios2.default.get(_url.INVENTORIES_URL + 'bin/', {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchInventoriesSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchInventoriesFailure(err));
	        });
	    };
	}
	
	function fetchInventoriesSuccess(inventories) {
	    return {
	        type: _type.FETCH_INVENTORIES_BIN_SUCCESS,
	        payload: inventories
	    };
	}
	
	function fetchInventoriesFailure(error) {
	    return {
	        type: _type.FETCH_INVENTORIES_BIN_FAILURE,
	        payload: error
	    };
	}
	
	function createInventoryConvert(Warehouse_id, PostingDate, Note, ProcessingFee, Warehouse_Convert_Line) {
	    if (PostingDate) PostingDate = (0, _cleanDates.convertUtcDate)(PostingDate);
	    // if(Warehouse_Convert_Line) {
	    //   Warehouse_Convert_Line.map(line => {
	    //     line['WarehouseBin_id'] = line.WarehouseBin_id.WarehouseBin_id;
	    //     line['WarehouseZone_id'] = line.WarehouseZone_id.WarehouseZone_id;
	    //   })
	    // }
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_CREATING_INVENTORY_CONVERT });
	        _axios2.default.post(_url.INVENTORY_CONVERTS_URL, {
	            Warehouse_id: Warehouse_id,
	            PostingDate: PostingDate,
	            Note: Note,
	            ProcessingFee: ProcessingFee,
	            Warehouse_Convert_Line: Warehouse_Convert_Line
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(createInventoryConvertSuccess());
	            _reactRouter.browserHistory.push('/inventories/convert');
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(createInventoryConvertFailure(err));
	        });
	    };
	}
	
	function createInventoryConvertSuccess() {
	    return {
	        type: _type.CREATE_INVENTORY_CONVERT_SUCCESS
	    };
	}
	
	function createInventoryConvertFailure(error) {
	    return {
	        type: _type.CREATE_INVENTORY_CONVERT_FAILURE,
	        payload: error
	    };
	}
	
	function editInventoryConvert(WarehouseConvert_id, Warehouse_id, PostingDate, Note, ProcessingFee, Warehouse_Convert_Line) {
	    if (PostingDate) PostingDate = (0, _cleanDates.convertUtcDate)(PostingDate);
	    if (Warehouse_Convert_Line) {
	        Warehouse_Convert_Line.map(function (line) {
	            line['WarehouseBin_id'] = line.WarehouseBin_id.WarehouseBin_id;
	            line['WarehouseZone_id'] = line.WarehouseZone_id.WarehouseZone_id;
	        });
	    }
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_EDITING_INVENTORY_CONVERT });
	        _axios2.default.put(_url.INVENTORY_CONVERTS_URL + WarehouseConvert_id, {
	            Warehouse_id: Warehouse_id,
	            PostingDate: PostingDate,
	            Note: Note,
	            ProcessingFee: ProcessingFee,
	            Warehouse_Convert_Line: Warehouse_Convert_Line
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(editInventoryConvertSuccess());
	            _reactRouter.browserHistory.push('/inventories/convert');
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(editInventoryConvertFailure(err));
	        });
	    };
	}
	
	function editInventoryConvertSuccess() {
	    return {
	        type: _type.EDIT_INVENTORY_CONVERT_SUCCESS
	    };
	}
	
	function editInventoryConvertFailure(error) {
	    return {
	        type: _type.EDIT_INVENTORY_CONVERT_FAILURE,
	        payload: error
	    };
	}
	
	function setField(field, value) {
	    console.log("setting field: ", field, value);
	    return function (dispatch) {
	        dispatch((0, _reduxForm.change)('productConvertDetail', field, value));
	    };
	}
	
	function createNewConvert(_ref) {
	    var ProductNum = _ref.ProductNum,
	        RelatedProductNum = _ref.RelatedProductNum,
	        Quantity = _ref.Quantity,
	        RelatedQuantity = _ref.RelatedQuantity;
	
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_NEW_CONVERT });
	        _axios2.default.post(_url.INVENTORY_CONVERTS_URL, {
	            ProductNum: ProductNum,
	            RelatedProductNum: RelatedProductNum,
	            Quantity: Quantity,
	            RelatedQuantity: RelatedQuantity
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(createNewConvertSuccess());
	            _reactRouter.browserHistory.push('/productConvertReport');
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(createNewConvertFailure(err));
	        });
	    };
	}
	
	function createNewConvertSuccess() {
	    return {
	        type: _type.NEW_CONVERT_SUCCESS
	    };
	}
	
	function createNewConvertFailure(error) {
	    return {
	        type: _type.NEW_CONVERT_FAILURE,
	        payload: error
	    };
	}
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(fetchInventoryConverts, 'fetchInventoryConverts', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryConverts_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchInventoryConvertsSuccess, 'fetchInventoryConvertsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryConverts_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchInventoryConvertsFailure, 'fetchInventoryConvertsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryConverts_actions.js');
	
	    __REACT_HOT_LOADER__.register(selectInventoryConvert, 'selectInventoryConvert', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryConverts_actions.js');
	
	    __REACT_HOT_LOADER__.register(resetCurrentInventoryConvert, 'resetCurrentInventoryConvert', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryConverts_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchInventoryConvertDetail, 'fetchInventoryConvertDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryConverts_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchInventoryConvertDetailSuccess, 'fetchInventoryConvertDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryConverts_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchInventoryConvertDetailFailure, 'fetchInventoryConvertDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryConverts_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchInventories, 'fetchInventories', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryConverts_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchInventoriesSuccess, 'fetchInventoriesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryConverts_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchInventoriesFailure, 'fetchInventoriesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryConverts_actions.js');
	
	    __REACT_HOT_LOADER__.register(createInventoryConvert, 'createInventoryConvert', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryConverts_actions.js');
	
	    __REACT_HOT_LOADER__.register(createInventoryConvertSuccess, 'createInventoryConvertSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryConverts_actions.js');
	
	    __REACT_HOT_LOADER__.register(createInventoryConvertFailure, 'createInventoryConvertFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryConverts_actions.js');
	
	    __REACT_HOT_LOADER__.register(editInventoryConvert, 'editInventoryConvert', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryConverts_actions.js');
	
	    __REACT_HOT_LOADER__.register(editInventoryConvertSuccess, 'editInventoryConvertSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryConverts_actions.js');
	
	    __REACT_HOT_LOADER__.register(editInventoryConvertFailure, 'editInventoryConvertFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryConverts_actions.js');
	
	    __REACT_HOT_LOADER__.register(setField, 'setField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryConverts_actions.js');
	
	    __REACT_HOT_LOADER__.register(createNewConvert, 'createNewConvert', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryConverts_actions.js');
	
	    __REACT_HOT_LOADER__.register(createNewConvertSuccess, 'createNewConvertSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryConverts_actions.js');
	
	    __REACT_HOT_LOADER__.register(createNewConvertFailure, 'createNewConvertFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryConverts_actions.js');
	}();

	;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchZones = fetchZones;
	exports.searchZones = searchZones;
	exports.fetchZonesSuccess = fetchZonesSuccess;
	exports.fetchZonesFailure = fetchZonesFailure;
	exports.selectZone = selectZone;
	exports.selectLevel = selectLevel;
	exports.resetCurrentZone = resetCurrentZone;
	exports.fetchZoneDetail = fetchZoneDetail;
	exports.fetchZoneDetailSuccess = fetchZoneDetailSuccess;
	exports.fetchZoneDetailFailure = fetchZoneDetailFailure;
	exports.createZone = createZone;
	exports.createZoneSuccess = createZoneSuccess;
	exports.createZoneFailure = createZoneFailure;
	exports.editZone = editZone;
	exports.editZoneSuccess = editZoneSuccess;
	exports.editZoneFailure = editZoneFailure;
	exports.searchBins = searchBins;
	exports.getBinsByZone = getBinsByZone;
	exports.getBinsByZoneSuccess = getBinsByZoneSuccess;
	exports.getBins2ByZoneSuccess = getBins2ByZoneSuccess;
	exports.getBins3ByZoneSuccess = getBins3ByZoneSuccess;
	exports.getBinsByZoneFailure = getBinsByZoneFailure;
	exports.getLevelsByBin = getLevelsByBin;
	exports.fetchLevelsSuccess = fetchLevelsSuccess;
	exports.fetchLevels2Success = fetchLevels2Success;
	exports.fetchLevels3Success = fetchLevels3Success;
	exports.fetchLevelsFailure = fetchLevelsFailure;
	exports.fetchBins = fetchBins;
	exports.generateZoneBarcode = generateZoneBarcode;
	exports.generateZoneBarcodeSuccess = generateZoneBarcodeSuccess;
	exports.generateZoneBarcodeFailure = generateZoneBarcodeFailure;
	exports.fetchBinsSuccess = fetchBinsSuccess;
	exports.fetchBinsFailure = fetchBinsFailure;
	exports.resetBins = resetBins;
	exports.selectBin = selectBin;
	exports.resetCurrentBin = resetCurrentBin;
	exports.fetchBinDetail = fetchBinDetail;
	exports.fetchBinDetailSuccess = fetchBinDetailSuccess;
	exports.fetchBinDetailFailure = fetchBinDetailFailure;
	exports.createBin = createBin;
	exports.createBinSuccess = createBinSuccess;
	exports.createLevelSuccess = createLevelSuccess;
	exports.createLevelFailure = createLevelFailure;
	exports.createBinFailure = createBinFailure;
	exports.editBin = editBin;
	exports.editBinSuccess = editBinSuccess;
	exports.editBinFailure = editBinFailure;
	exports.deleteZone = deleteZone;
	exports.deleteZoneSuccess = deleteZoneSuccess;
	exports.deleteZoneFailure = deleteZoneFailure;
	exports.deleteBin = deleteBin;
	exports.deleteLevelSuccess = deleteLevelSuccess;
	exports.deleteLevelFailure = deleteLevelFailure;
	exports.deleteBinSuccess = deleteBinSuccess;
	exports.deleteBinFailure = deleteBinFailure;
	exports.deleteBinsBD = deleteBinsBD;
	exports.generateBin = generateBin;
	exports.editBins = editBins;
	exports.editLevels = editLevels;
	exports.editLevelSuccess = editLevelSuccess;
	exports.editLevelFailure = editLevelFailure;
	exports.attachZoneBinLevel = attachZoneBinLevel;
	exports.attachZoneBinLevelSuccess = attachZoneBinLevelSuccess;
	exports.attachZoneBinLevelFailure = attachZoneBinLevelFailure;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _root_url = __webpack_require__(9);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Zones Actions
	
	function fetchZones(Warehouse_id) {
	  var url = _url.ZONES_URL + (Warehouse_id ? Warehouse_id : '');
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_ZONES });
	    return _axios2.default.get(url, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchZonesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchZonesFailure(err));
	    });
	  };
	}
	
	function searchZones(name) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_ZONES });
	    return _axios2.default.get(_url.ZONES_URL + '?Name=' + name, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchZonesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchZonesFailure(err));
	    });
	  };
	}
	
	function fetchZonesSuccess(zones) {
	  return {
	    type: _type.FETCH_ZONES_SUCCESS,
	    payload: zones
	  };
	}
	
	function fetchZonesFailure(error) {
	  return {
	    type: _type.FETCH_ZONES_FAILURE,
	    payload: error
	  };
	}
	
	function selectZone(zone) {
	  return {
	    type: _type.SELECT_ZONE,
	    payload: zone
	  };
	}
	
	function selectLevel(zone) {
	  return {
	    type: _type.SELECT_LEVEL,
	    payload: zone
	  };
	}
	
	function resetCurrentZone() {
	  return {
	    type: _type.RESET_CURRENT_ZONE
	  };
	}
	
	function fetchZoneDetail(zone_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_ZONE_DETAIL });
	    return _axios2.default.get(_url.ZONES_URL + zone_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchZoneDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchZoneDetailFailure(err));
	    });
	  };
	}
	
	function fetchZoneDetailSuccess(zoneDetail) {
	  return {
	    type: _type.FETCH_ZONE_DETAIL_SUCCESS,
	    payload: zoneDetail
	  };
	}
	
	function fetchZoneDetailFailure(error) {
	  return {
	    type: _type.FETCH_ZONE_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function createZone(_ref, warehouse_id) {
	  var zone_num = _ref.zone_num,
	      description = _ref.description;
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CREATING_ZONE });
	    _axios2.default.post(_url.ZONES_URL, {
	      zone_num: zone_num,
	      description: description,
	      warehouse_id: warehouse_id
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(createZoneSuccess(response));
	      _reactRouter.browserHistory.push('/warehouses/detail');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(createZoneFailure(err));
	    });
	  };
	}
	
	function createZoneSuccess(data) {
	  return {
	    type: _type.CREATE_ZONE_SUCCESS,
	    payload: data
	  };
	}
	
	function createZoneFailure(error) {
	  return {
	    type: _type.CREATE_ZONE_FAILURE,
	    payload: error
	  };
	}
	
	function editZone(_ref2) {
	  var WarehouseZone_id = _ref2.WarehouseZone_id,
	      zone_num = _ref2.zone_num,
	      description = _ref2.description;
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EDITING_ZONE });
	    _axios2.default.put(_url.ZONES_URL + WarehouseZone_id, {
	      zone_num: zone_num,
	      description: description
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editZoneSuccess(response));
	      _reactRouter.browserHistory.push('/warehouses/detail'); // If editd succesfully, refresh the paymentTerm page.
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editZoneFailure(err));
	    });
	  };
	}
	
	function editZoneSuccess(data) {
	  return {
	    type: _type.EDIT_ZONE_SUCCESS,
	    payload: data
	  };
	}
	
	function editZoneFailure(error) {
	  return {
	    type: _type.EDIT_ZONE_FAILURE,
	    payload: error
	  };
	}
	
	function searchBins(name) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_BINS });
	    return _axios2.default.get(_url.BINS_URL + '?Name=' + name, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchBinsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchBinsFailure(err));
	    });
	  };
	}
	
	function getBinsByZone(zoneId, idx) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_BINS });
	    return (0, _axios2.default)({
	      method: 'GET',
	      url: '' + _url.ZONES_URL + zoneId + '/section/',
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      if (idx === 1) {
	        dispatch(getBinsByZoneSuccess(response));
	      } else if (idx === 2) {
	        dispatch(getBins2ByZoneSuccess(response));
	      } else if (idx === 3) {
	        dispatch(getBins3ByZoneSuccess(response));
	      } else {
	        dispatch(getBinsByZoneSuccess(response));
	      }
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(getBinsByZoneFailure(err));
	    });
	  };
	}
	
	function getBinsByZoneSuccess(bins) {
	  return {
	    type: _type.FETCH_BINS_SUCCESS,
	    payload: bins
	  };
	}
	function getBins2ByZoneSuccess(bins2) {
	  return {
	    type: _type.FETCH_BINS2_SUCCESS,
	    payload: bins2
	  };
	}
	function getBins3ByZoneSuccess(bins3) {
	  return {
	    type: _type.FETCH_BINS3_SUCCESS,
	    payload: bins3
	  };
	}
	
	function getBinsByZoneFailure(error) {
	  return {
	    type: _type.FETCH_BINS_FAILURE,
	    payload: error
	  };
	}
	
	function getLevelsByBin(binId, idx) {
	  return function (dispatch) {
	    dispatch({ type: _type.FETCH_LEVELS });
	    return (0, _axios2.default)({
	      method: 'GET',
	      url: _url.WAREHOUSES_URL + 'section/' + binId + '/bin/',
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      if (idx === 1) {
	        dispatch(fetchLevelsSuccess(response));
	      } else if (idx === 2) {
	        dispatch(fetchLevels2Success(response));
	      } else if (idx === 3) {
	        dispatch(fetchLevels3Success(response));
	      } else {
	        dispatch(fetchLevelsSuccess(response));
	      }
	    }, function (err) {
	      if (err.status === 500 || err.status == 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchLevelsFailure(err));
	    });
	  };
	}
	
	function fetchLevelsSuccess(levels) {
	  return {
	    type: _type.FETCH_LEVELS_SUCCESS,
	    payload: levels
	  };
	}
	function fetchLevels2Success(levels2) {
	  return {
	    type: _type.FETCH_LEVELS2_SUCCESS,
	    payload: levels2
	  };
	}
	function fetchLevels3Success(levels3) {
	  return {
	    type: _type.FETCH_LEVELS3_SUCCESS,
	    payload: levels3
	  };
	}
	
	function fetchLevelsFailure(error) {
	  return {
	    type: _type.FETCH_LEVELS_ERROR,
	    payload: error
	  };
	}
	
	function fetchBins(zoneID) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_BINS });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: '' + _url.ZONES_URL + zoneID + '/bin/',
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchBinsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchBinsFailure(err));
	    });
	  };
	}
	
	function generateZoneBarcode(warehouseNum, zoneId, binId, levelId) {
	  var query = '';
	  if (zoneId && binId && levelId) {
	    query = warehouseNum + '-' + zoneId + '-' + binId + '-' + levelId;
	  } else if (zoneId && binId && !levelId) {
	    query = warehouseNum + '-' + zoneId + '-' + binId;
	  } else {
	    query = warehouseNum + '-' + zoneId;
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.CREATE_BARCODE });
	    return (0, _axios2.default)({
	      method: 'GET',
	      url: _url.WAREHOUSES_URL + 'printzonebinlevelbarcode/' + query,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(generateZoneBarcodeSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.stats == 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(generateZoneBarcodeSuccess(err));
	    });
	  };
	}
	
	function generateZoneBarcodeSuccess(barcode) {
	  return {
	    type: _type.CREATE_BARCODE_SUCCESS,
	    payload: barcode
	  };
	}
	
	function generateZoneBarcodeFailure(error) {
	  return {
	    type: _type.CREATE_BARCODE_FAILURE,
	    payload: error
	  };
	}
	
	function fetchBinsSuccess(bins) {
	  return {
	    type: _type.FETCH_LEVELS_SUCCESS,
	    payload: bins
	  };
	}
	
	function fetchBinsFailure(error) {
	  return {
	    type: _type.FETCH_BINS_FAILURE,
	    payload: error
	  };
	}
	
	function resetBins() {
	  return {
	    type: _type.RESET_BINS
	  };
	}
	
	function selectBin(zone) {
	  return {
	    type: _type.SELECT_BIN,
	    payload: zone
	  };
	}
	
	function resetCurrentBin() {
	  return {
	    type: _type.RESET_CURRENT_BIN
	  };
	}
	
	function fetchBinDetail(bin_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_BIN_DETAIL });
	    return _axios2.default.get(_url.BINS_URL + bin_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchBinDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchBinDetailFailure(err));
	    });
	  };
	}
	
	function fetchBinDetailSuccess(binDetail) {
	  return {
	    type: _type.FETCH_BIN_DETAIL_SUCCESS,
	    payload: binDetail
	  };
	}
	
	function fetchBinDetailFailure(error) {
	  return {
	    type: _type.FETCH_BIN_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function createBin(_ref3) {
	  var bin_num = _ref3.bin_num,
	      description = _ref3.description,
	      section_id = _ref3.section_id;
	
	  return function (dispatch) {
	    dispatch({ type: _type.CREATE_LEVEL_REQUEST });
	    return _axios2.default.post(_url.BINS_URL, {
	      bin_num: bin_num,
	      description: description,
	      section_id: section_id
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(createLevelSuccess(response));
	      // browserHistory.push('/zoneDetail');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(createLevelFailure(err));
	    });
	  };
	}
	
	function createBinSuccess(data) {
	  return {
	    type: _type.CREATE_BIN_SUCCESS,
	    payload: data
	  };
	}
	
	function createLevelSuccess(data) {
	  return {
	    type: _type.CREATE_LEVEL_SUCCESS,
	    payload: data
	  };
	}
	
	function createLevelFailure(err) {
	  return {
	    type: _type.CREATE_LEVEL_FAILURE,
	    payload: err
	  };
	}
	
	function createBinFailure(error) {
	  return {
	    type: _type.CREATE_BIN_FAILURE,
	    payload: error
	  };
	}
	
	function editBin(_ref4) {
	  var WarehouseBin_id = _ref4.WarehouseBin_id,
	      Name = _ref4.Name,
	      description = _ref4.description;
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EDITING_BIN });
	    _axios2.default.put(_url.BINS_URL + WarehouseBin_id, {
	      Name: Name,
	      description: description
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editBinSuccess(response));
	      // browserHistory.push('/zoneDetail'); // If edited succesfully, refresh the paymentTerm page.
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editBinFailure(err));
	    });
	  };
	}
	
	function editBinSuccess(data) {
	  return {
	    type: _type.EDIT_BIN_SUCCESS,
	    payload: data
	  };
	}
	
	function editBinFailure(error) {
	  return {
	    type: _type.EDIT_BIN_FAILURE,
	    payload: error
	  };
	}
	
	function deleteZone(id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_DELETE_ZONE });
	    _axios2.default.delete(_url.ZONES_URL + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(deleteZoneSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(deleteZoneFailure(err));
	    });
	  };
	}
	
	function deleteZoneSuccess() {
	  return {
	    type: _type.DELETE_ZONE_SUCCESS
	  };
	}
	
	function deleteZoneFailure(error) {
	  return {
	    type: _type.DELETE_ZONE_FAILURE,
	    payload: error
	  };
	}
	
	function deleteBin(id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_DELETE_LEVEL });
	    return _axios2.default.delete(_url.BINS_URL + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(deleteLevelSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(deleteLevelFailure(err));
	    });
	  };
	}
	function deleteLevelSuccess() {
	  return {
	    type: _type.DELETE_LEVEL_SUCCESS
	  };
	}
	
	function deleteLevelFailure(err) {
	  return {
	    type: _type.DELETE_LEVEL_FAILURE,
	    data: err
	  };
	}
	
	function deleteBinSuccess() {
	  return {
	    type: _type.DELETE_BIN_SUCCESS
	  };
	}
	
	function deleteBinFailure(error) {
	  return {
	    type: _type.DELETE_BIN_FAILURE,
	    payload: error
	  };
	}
	
	function deleteBinsBD(id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_DELETE_BIN });
	    return _axios2.default.delete(_url.WAREHOUSES_URL + 'section/' + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(deleteBinSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(deleteBinFailure(err));
	    });
	  };
	}
	
	function generateBin(_ref5) {
	  var section_num = _ref5.section_num,
	      description = _ref5.description,
	      zone_id = _ref5.zone_id;
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CREATING_BIN });
	    return _axios2.default.post(_url.WAREHOUSES_URL + 'section/', {
	      section_num: section_num,
	      description: description,
	      zone_id: zone_id
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(createBinSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(createBinFailure(err));
	    });
	  };
	}
	
	function editBins(_ref6, id) {
	  var section_num = _ref6.section_num,
	      description = _ref6.description,
	      zone_id = _ref6.zone_id;
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EDITING_BIN });
	    _axios2.default.put(_url.WAREHOUSES_URL + 'section/' + id, {
	      section_num: section_num,
	      description: description,
	      zone_id: zone_id
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editBinSuccess(response));
	      // browserHistory.push('/warehouses/detail'); // If editd succesfully, refresh the paymentTerm page.
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editBinFailure(err));
	    });
	  };
	}
	
	function editLevels(_ref7, id) {
	  var bin_num = _ref7.bin_num,
	      description = _ref7.description,
	      section_id = _ref7.section_id;
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EDITING_LEVEL });
	    _axios2.default.put(_url.WAREHOUSES_URL + 'bin/' + id, {
	      bin_num: bin_num,
	      description: description
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editLevelSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editLevelFailure(err));
	    });
	  };
	}
	
	function editLevelSuccess(data) {
	  return {
	    type: _type.EDITING_LEVEL_SUCCESS,
	    payload: data
	  };
	}
	
	function editLevelFailure(err) {
	  return {
	    type: _type.EDITING_LEVEL_FAILURE,
	    payload: err
	  };
	}
	
	function attachZoneBinLevel(file, warehouse_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.ATTACH_ZONE_BIN_LEVEL });
	    var zone_bin_level_file = new FormData();
	    zone_bin_level_file.append('zone_bin_level_file', file);
	    zone_bin_level_file.append('warehouse_id', warehouse_id);
	    return _axios2.default.post(_root_url.ROOT_URL + 'v1/upload/zonebinlevel/', zone_bin_level_file, {
	      headers: {
	        Authorization: 'Bearer ' + localStorage.getItem('token')
	      }
	    }).then(function (response) {
	      console.log("attachZoneBinLevel:", response);
	      dispatch(attachZoneBinLevelSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.status = _constants.DEFAULT_ERROR;
	      }
	      dispatch(attachZoneBinLevelFailure(err));
	    });
	  };
	}
	
	function attachZoneBinLevelSuccess(data) {
	  return {
	    type: _type.ATTACH_ZONE_BIN_LEVEL_SUCCESS
	  };
	}
	
	function attachZoneBinLevelFailure(err) {
	  return {
	    type: _type.ATTACH_ZONE_BIN_LEVEL_FAILURE,
	    payload: err
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchZones, 'fetchZones', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(searchZones, 'searchZones', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchZonesSuccess, 'fetchZonesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchZonesFailure, 'fetchZonesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(selectZone, 'selectZone', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(selectLevel, 'selectLevel', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetCurrentZone, 'resetCurrentZone', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchZoneDetail, 'fetchZoneDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchZoneDetailSuccess, 'fetchZoneDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchZoneDetailFailure, 'fetchZoneDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(createZone, 'createZone', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(createZoneSuccess, 'createZoneSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(createZoneFailure, 'createZoneFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(editZone, 'editZone', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(editZoneSuccess, 'editZoneSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(editZoneFailure, 'editZoneFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(searchBins, 'searchBins', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(getBinsByZone, 'getBinsByZone', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(getBinsByZoneSuccess, 'getBinsByZoneSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(getBins2ByZoneSuccess, 'getBins2ByZoneSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(getBins3ByZoneSuccess, 'getBins3ByZoneSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(getBinsByZoneFailure, 'getBinsByZoneFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(getLevelsByBin, 'getLevelsByBin', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchLevelsSuccess, 'fetchLevelsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchLevels2Success, 'fetchLevels2Success', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchLevels3Success, 'fetchLevels3Success', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchLevelsFailure, 'fetchLevelsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchBins, 'fetchBins', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(generateZoneBarcode, 'generateZoneBarcode', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(generateZoneBarcodeSuccess, 'generateZoneBarcodeSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(generateZoneBarcodeFailure, 'generateZoneBarcodeFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchBinsSuccess, 'fetchBinsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchBinsFailure, 'fetchBinsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetBins, 'resetBins', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(selectBin, 'selectBin', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetCurrentBin, 'resetCurrentBin', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchBinDetail, 'fetchBinDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchBinDetailSuccess, 'fetchBinDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchBinDetailFailure, 'fetchBinDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(createBin, 'createBin', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(createBinSuccess, 'createBinSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(createLevelSuccess, 'createLevelSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(createLevelFailure, 'createLevelFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(createBinFailure, 'createBinFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(editBin, 'editBin', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(editBinSuccess, 'editBinSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(editBinFailure, 'editBinFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteZone, 'deleteZone', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteZoneSuccess, 'deleteZoneSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteZoneFailure, 'deleteZoneFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteBin, 'deleteBin', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteLevelSuccess, 'deleteLevelSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteLevelFailure, 'deleteLevelFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteBinSuccess, 'deleteBinSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteBinFailure, 'deleteBinFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteBinsBD, 'deleteBinsBD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(generateBin, 'generateBin', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(editBins, 'editBins', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(editLevels, 'editLevels', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(editLevelSuccess, 'editLevelSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(editLevelFailure, 'editLevelFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(attachZoneBinLevel, 'attachZoneBinLevel', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(attachZoneBinLevelSuccess, 'attachZoneBinLevelSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	
	  __REACT_HOT_LOADER__.register(attachZoneBinLevelFailure, 'attachZoneBinLevelFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/zones_actions.js');
	}();

	;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(749);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(101)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./react-select.css", function() {
				var newContent = require("!!../../css-loader/index.js!./react-select.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchPurchaseQuotes = fetchPurchaseQuotes;
	exports.requestPurchaseQuotes = requestPurchaseQuotes;
	exports.fetchPurchaseQuotesSuccess = fetchPurchaseQuotesSuccess;
	exports.fetchPurchaseQuotesFailure = fetchPurchaseQuotesFailure;
	exports.selectPurchaseQuote = selectPurchaseQuote;
	exports.resetCurrentPurchaseQuote = resetCurrentPurchaseQuote;
	exports.fetchPurchaseQuoteDetail = fetchPurchaseQuoteDetail;
	exports.requestPurchaseQuoteDetail = requestPurchaseQuoteDetail;
	exports.fetchPurchaseQuoteDetailSuccess = fetchPurchaseQuoteDetailSuccess;
	exports.fetchPurchaseQuoteDetailFailure = fetchPurchaseQuoteDetailFailure;
	exports.createPurchaseQuote = createPurchaseQuote;
	exports.createPurchaseQuoteSuccess = createPurchaseQuoteSuccess;
	exports.createPurchaseQuoteFailure = createPurchaseQuoteFailure;
	exports.purchaseQuotePlace = purchaseQuotePlace;
	exports.purchaseQuotePlaceSuccess = purchaseQuotePlaceSuccess;
	exports.purchaseQuotePlaceFailure = purchaseQuotePlaceFailure;
	exports.editPurchaseQuote = editPurchaseQuote;
	exports.editPurchaseQuoteSuccess = editPurchaseQuoteSuccess;
	exports.editPurchaseQuoteFailure = editPurchaseQuoteFailure;
	exports.fetchNumPurchaseQuotes = fetchNumPurchaseQuotes;
	exports.requestNumPurchaseQuotes = requestNumPurchaseQuotes;
	exports.fetchNumPurchaseQuotesSuccess = fetchNumPurchaseQuotesSuccess;
	exports.fetchNumPurchaseQuotesFailure = fetchNumPurchaseQuotesFailure;
	exports.deletePurchaseQuote = deletePurchaseQuote;
	exports.deletePurchaseQuoteSuccess = deletePurchaseQuoteSuccess;
	exports.deletePurchaseQuoteFailure = deletePurchaseQuoteFailure;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function fetchPurchaseQuotes() {
	    return function (dispatch) {
	        dispatch(requestPurchaseQuotes());
	        return _axios2.default.get(_url.PURCHASE_QUOTES_URL, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchPurchaseQuotesSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchPurchaseQuotesFailure(err));
	        });
	    };
	}
	
	function requestPurchaseQuotes() {
	    return {
	        type: _type.REQUEST_PURCHASE_QUOTES
	    };
	}
	
	function fetchPurchaseQuotesSuccess(purchaseQuotes) {
	    return {
	        type: _type.FETCH_PURCHASE_QUOTES_SUCCESS,
	        payload: purchaseQuotes
	    };
	}
	
	function fetchPurchaseQuotesFailure(error) {
	    return {
	        type: _type.FETCH_PURCHASE_QUOTES_FAILURE,
	        payload: error
	    };
	}
	
	function selectPurchaseQuote(purchaseQuote) {
	    return {
	        type: _type.SELECT_PURCHASE_QUOTE,
	        payload: purchaseQuote
	    };
	}
	
	function resetCurrentPurchaseQuote() {
	    return {
	        type: _type.RESET_CURRENT_PURCHASE_QUOTE
	    };
	}
	
	// Fetch the detail page.
	
	function fetchPurchaseQuoteDetail(customer_id) {
	    return function (dispatch) {
	        dispatch(requestPurchaseQuoteDetail());
	        return _axios2.default.get(_url.PURCHASE_QUOTES_URL + customer_id, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchPurchaseQuoteDetailSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchPurchaseQuoteDetailFailure(err));
	        });
	    };
	}
	
	function requestPurchaseQuoteDetail() {
	    return {
	        type: _type.REQUEST_PURCHASE_QUOTE_DETAIL
	    };
	}
	
	function fetchPurchaseQuoteDetailSuccess(purchaseQuoteDetail) {
	    purchaseQuoteDetail = purchaseQuoteDetail.data;
	    // The date data fetched is in the form of string, which needs to be modified into Date type
	    if (purchaseQuoteDetail.OrderDate) purchaseQuoteDetail.OrderDate = new Date(purchaseQuoteDetail.OrderDate);
	    if (purchaseQuoteDetail.ETADate) purchaseQuoteDetail.ETADate = new Date(purchaseQuoteDetail.ETADate);
	    if (purchaseQuoteDetail.ReceivedDate) purchaseQuoteDetail.ReceivedDate = new Date(purchaseQuoteDetail.ReceivedDate);
	    return {
	        type: _type.FETCH_PURCHASE_QUOTE_DETAIL_SUCCESS,
	        payload: purchaseQuoteDetail
	    };
	}
	
	function fetchPurchaseQuoteDetailFailure(error) {
	    return {
	        type: _type.FETCH_PURCHASE_QUOTE_DETAIL_FAILURE,
	        payload: error
	    };
	}
	
	function createPurchaseQuote(_ref, Purchase_Order_Line, TaxRate, CRV, FinalNetWeight, FinalShippingWeight, TotalPrice, FinalPrice) {
	    var OrderDate = _ref.OrderDate,
	        ETADate = _ref.ETADate,
	        ReceivedDate = _ref.ReceivedDate,
	        NoteToVendor = _ref.NoteToVendor,
	        ReleaseInformation = _ref.ReleaseInformation,
	        CarryType = _ref.CarryType,
	        Discount = _ref.Discount,
	        ShippingCost = _ref.ShippingCost,
	        HandlingCost = _ref.HandlingCost,
	        MiscCost = _ref.MiscCost,
	        MiscNote = _ref.MiscNote,
	        ConvertItemPrice = _ref.ConvertItemPrice,
	        Vendor_id = _ref.Vendor_id,
	        VendorNum = _ref.VendorNum,
	        Pickup_VendorDetail_id = _ref.Pickup_VendorDetail_id,
	        Deliver_Warehouse_id = _ref.Deliver_Warehouse_id,
	        DispatchMethod_id = _ref.DispatchMethod_id,
	        DispatchOutSourceContact_id = _ref.DispatchOutSourceContact_id,
	        Purchaser_User_id = _ref.Purchaser_User_id,
	        Modifier_User_id = _ref.Modifier_User_id,
	        PaymentTerm_id = _ref.PaymentTerm_id,
	        ShippingMethod = _ref.ShippingMethod;
	
	    Purchase_Order_Line.map(function (product) {
	        if (product.Product_id) product.Product_id = product.Product_id.value || product.Product_id;
	    });
	    if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
	    if (Pickup_VendorDetail_id) Pickup_VendorDetail_id = Pickup_VendorDetail_id.value || Pickup_VendorDetail_id;
	    if (CarryType) CarryType = CarryType.value || CarryType;
	    if (Deliver_Warehouse_id) Deliver_Warehouse_id = Deliver_Warehouse_id.value || Deliver_Warehouse_id;
	    if (PaymentTerm_id) PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
	    if (ShippingMethod) ShippingMethod = ShippingMethod.value || ShippingMethod;
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_CREATING_PURCHASE_QUOTE });
	        _axios2.default.post(_url.PURCHASE_QUOTES_URL, {
	            Purchase_Order_Line: Purchase_Order_Line,
	            OrderDate: OrderDate,
	            ETADate: ETADate,
	            ReceivedDate: ReceivedDate,
	            FinalNetWeight: FinalNetWeight,
	            FinalShippingWeight: FinalShippingWeight,
	            TotalPrice: TotalPrice,
	            NoteToVendor: NoteToVendor,
	            ReleaseInformation: ReleaseInformation,
	            CarryType: CarryType,
	            Discount: Discount,
	            ShippingCost: ShippingCost,
	            HandlingCost: HandlingCost,
	            MiscCost: MiscCost,
	            MiscNote: MiscNote,
	            TaxRate: TaxRate,
	            FinalPrice: FinalPrice,
	            ConvertItemPrice: ConvertItemPrice,
	            Vendor_id: Vendor_id,
	            VendorNum: VendorNum,
	            Pickup_VendorDetail_id: Pickup_VendorDetail_id,
	            Deliver_Warehouse_id: Deliver_Warehouse_id,
	            DispatchMethod_id: DispatchMethod_id,
	            DispatchOutSourceContact_id: DispatchOutSourceContact_id,
	            Purchaser_User_id: Purchaser_User_id,
	            Modifier_User_id: Modifier_User_id,
	            PaymentTerm_id: PaymentTerm_id,
	            CRV: CRV,
	            ShippingMethod: ShippingMethod
	
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(createPurchaseQuoteSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(createPurchaseQuoteFailure(err));
	        });
	    };
	}
	
	function createPurchaseQuoteSuccess(response) {
	    return {
	        type: _type.CREATE_PURCHASE_QUOTE_SUCCESS,
	        payload: response
	    };
	}
	
	function createPurchaseQuoteFailure(error) {
	    return {
	        type: _type.CREATE_PURCHASE_QUOTE_FAILURE,
	        payload: error
	    };
	}
	
	function purchaseQuotePlace(_ref2, Purchase_Order_Line, TaxRate, CRV, FinalNetWeight, FinalShippingWeight, TotalPrice, FinalPrice) {
	    var PurchaseOrder_id = _ref2.PurchaseOrder_id,
	        Name = _ref2.Name,
	        OrderDate = _ref2.OrderDate,
	        ETADate = _ref2.ETADate,
	        ReceivedDate = _ref2.ReceivedDate,
	        NoteToVendor = _ref2.NoteToVendor,
	        ReleaseInformation = _ref2.ReleaseInformation,
	        CarryType = _ref2.CarryType,
	        Discount = _ref2.Discount,
	        ShippingCost = _ref2.ShippingCost,
	        HandlingCost = _ref2.HandlingCost,
	        MiscCost = _ref2.MiscCost,
	        MiscNote = _ref2.MiscNote,
	        PurchaseStatus = _ref2.PurchaseStatus,
	        PaymentStatus = _ref2.PaymentStatus,
	        ConvertItemPrice = _ref2.ConvertItemPrice,
	        Vendor_id = _ref2.Vendor_id,
	        Pickup_VendorDetail_id = _ref2.Pickup_VendorDetail_id,
	        Deliver_Warehouse_id = _ref2.Deliver_Warehouse_id,
	        DispatchMethod_id = _ref2.DispatchMethod_id,
	        DispatchOutSourceContact_id = _ref2.DispatchOutSourceContact_id,
	        Purchaser_User_id = _ref2.Purchaser_User_id,
	        Modifier_User_id = _ref2.Modifier_User_id,
	        PaymentTerm_id = _ref2.PaymentTerm_id,
	        ShippingMethod = _ref2.ShippingMethod;
	
	    if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
	    if (Pickup_VendorDetail_id) Pickup_VendorDetail_id = Pickup_VendorDetail_id.value || Pickup_VendorDetail_id;
	    if (CarryType) CarryType = CarryType.value || CarryType || "Dry";
	    if (Deliver_Warehouse_id) Deliver_Warehouse_id = Deliver_Warehouse_id.value || Deliver_Warehouse_id;
	    if (PaymentTerm_id) PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
	    if (PaymentStatus) PaymentStatus = PaymentStatus.value || PaymentStatus;
	    if (Deliver_Warehouse_id) Deliver_Warehouse_id = Deliver_Warehouse_id.value || Deliver_Warehouse_id;
	    if (ShippingMethod) ShippingMethod = ShippingMethod.value || ShippingMethod;
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_PURCHASE_QUOTE_PLACE });
	        _axios2.default.put(_url.PURCHASE_QUOTES_URL + PurchaseOrder_id + '/place/', _defineProperty({
	            Purchase_Order_Line: Purchase_Order_Line,
	            Name: Name,
	            OrderDate: OrderDate,
	            ETADate: ETADate,
	            ReceivedDate: ReceivedDate,
	            FinalNetWeight: FinalNetWeight,
	            FinalShippingWeight: FinalShippingWeight,
	            TotalPrice: TotalPrice,
	            NoteToVendor: NoteToVendor,
	            ReleaseInformation: ReleaseInformation,
	            CarryType: CarryType,
	            Discount: Discount,
	            ShippingCost: ShippingCost,
	            HandlingCost: HandlingCost,
	            MiscCost: MiscCost,
	            MiscNote: MiscNote,
	            TaxRate: TaxRate,
	            PurchaseStatus: PurchaseStatus,
	            FinalPrice: FinalPrice,
	            ConvertItemPrice: ConvertItemPrice,
	            Vendor_id: Vendor_id,
	            Pickup_VendorDetail_id: Pickup_VendorDetail_id,
	            Deliver_Warehouse_id: Deliver_Warehouse_id,
	            DispatchMethod_id: DispatchMethod_id,
	            DispatchOutSourceContact_id: DispatchOutSourceContact_id,
	            Purchaser_User_id: Purchaser_User_id,
	            Modifier_User_id: Modifier_User_id,
	            PaymentTerm_id: PaymentTerm_id,
	            CRV: CRV,
	            ShippingMethod: ShippingMethod
	        }, 'Deliver_Warehouse_id', Deliver_Warehouse_id), {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(purchaseQuotePlaceSuccess());
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(purchaseQuotePlaceFailure(err));
	        });
	    };
	}
	
	function purchaseQuotePlaceSuccess() {
	    return {
	        type: _type.PURCHASE_QUOTE_PLACE_SUCCESS
	    };
	}
	
	function purchaseQuotePlaceFailure(error) {
	    return {
	        type: _type.PURCHASE_QUOTE_PLACE_FAILURE,
	        payload: error
	    };
	}
	
	function editPurchaseQuote(_ref3, Purchase_Order_Line, TaxRate, CRV, FinalNetWeight, FinalShippingWeight, TotalPrice, FinalPrice) {
	    var PurchaseOrder_id = _ref3.PurchaseOrder_id,
	        Name = _ref3.Name,
	        OrderDate = _ref3.OrderDate,
	        ETADate = _ref3.ETADate,
	        ReceivedDate = _ref3.ReceivedDate,
	        NoteToVendor = _ref3.NoteToVendor,
	        ReleaseInformation = _ref3.ReleaseInformation,
	        CarryType = _ref3.CarryType,
	        Discount = _ref3.Discount,
	        ShippingCost = _ref3.ShippingCost,
	        HandlingCost = _ref3.HandlingCost,
	        MiscCost = _ref3.MiscCost,
	        MiscNote = _ref3.MiscNote,
	        PurchaseStatus = _ref3.PurchaseStatus,
	        ConvertItemPrice = _ref3.ConvertItemPrice,
	        Vendor_id = _ref3.Vendor_id,
	        Pickup_VendorDetail_id = _ref3.Pickup_VendorDetail_id,
	        Deliver_Warehouse_id = _ref3.Deliver_Warehouse_id,
	        DispatchMethod_id = _ref3.DispatchMethod_id,
	        DispatchOutSourceContact_id = _ref3.DispatchOutSourceContact_id,
	        Purchaser_User_id = _ref3.Purchaser_User_id,
	        Modifier_User_id = _ref3.Modifier_User_id,
	        PaymentTerm_id = _ref3.PaymentTerm_id,
	        ShippingMethod = _ref3.ShippingMethod;
	
	
	    Purchase_Order_Line.map(function (product) {
	        if (product.Product_id) {
	            product.Product_id = product.Product_id.value || product.Product_id;
	        }
	    });
	    if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
	    if (Pickup_VendorDetail_id) Pickup_VendorDetail_id = Pickup_VendorDetail_id.value || Pickup_VendorDetail_id;
	    if (CarryType) CarryType = CarryType.value || CarryType;
	    if (Deliver_Warehouse_id) Deliver_Warehouse_id = Deliver_Warehouse_id.value || Deliver_Warehouse_id;
	    if (PaymentTerm_id) PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
	    if (ShippingMethod) ShippingMethod = ShippingMethod.value || ShippingMethod;
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_EDITING_PURCHASE_QUOTE });
	        _axios2.default.put(_url.PURCHASE_QUOTES_URL + PurchaseOrder_id, {
	            Purchase_Order_Line: Purchase_Order_Line,
	            Name: Name,
	            OrderDate: OrderDate,
	            ETADate: ETADate,
	            ReceivedDate: ReceivedDate,
	            FinalNetWeight: FinalNetWeight,
	            FinalShippingWeight: FinalShippingWeight,
	            TotalPrice: TotalPrice,
	            NoteToVendor: NoteToVendor,
	            ReleaseInformation: ReleaseInformation,
	            CarryType: CarryType,
	            Discount: Discount,
	            ShippingCost: ShippingCost,
	            HandlingCost: HandlingCost,
	            MiscCost: MiscCost,
	            MiscNote: MiscNote,
	            TaxRate: TaxRate,
	            PurchaseStatus: PurchaseStatus,
	            FinalPrice: FinalPrice,
	            ConvertItemPrice: ConvertItemPrice,
	            Vendor_id: Vendor_id,
	            Pickup_VendorDetail_id: Pickup_VendorDetail_id,
	            Deliver_Warehouse_id: Deliver_Warehouse_id,
	            DispatchMethod_id: DispatchMethod_id,
	            DispatchOutSourceContact_id: DispatchOutSourceContact_id,
	            Purchaser_User_id: Purchaser_User_id,
	            Modifier_User_id: Modifier_User_id,
	            PaymentTerm_id: PaymentTerm_id,
	            ShippingMethod: ShippingMethod,
	            CRV: CRV
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(editPurchaseQuoteSuccess());
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(editPurchaseQuoteFailure(err));
	        });
	    };
	}
	
	function editPurchaseQuoteSuccess() {
	    return {
	        type: _type.EDIT_PURCHASE_QUOTE_SUCCESS
	    };
	}
	
	function editPurchaseQuoteFailure(error) {
	    return {
	        type: _type.EDIT_PURCHASE_QUOTE_FAILURE,
	        payload: error
	    };
	}
	
	function fetchNumPurchaseQuotes() {
	    return function (dispatch) {
	        dispatch(requestNumPurchaseQuotes());
	        return _axios2.default.get(_url.NUM_PURCHASE_QUOTES_URL, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchNumPurchaseQuotesSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchNumPurchaseQuotesFailure(err));
	        });
	    };
	}
	
	function requestNumPurchaseQuotes() {
	    return {
	        type: _type.REQUEST_NUM_PURCHASE_QUOTES
	    };
	}
	
	function fetchNumPurchaseQuotesSuccess(numPurchaseQuotes) {
	    return {
	        type: _type.FETCH_NUM_PURCHASE_QUOTES_SUCCESS,
	        payload: numPurchaseQuotes
	    };
	}
	
	function fetchNumPurchaseQuotesFailure(error) {
	    return {
	        type: _type.FETCH_NUM_PURCHASE_QUOTES_FAILURE,
	        payload: error
	    };
	}
	
	function deletePurchaseQuote(purchaseOrder_id) {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_DELETE_PURCHASE_QUOTE });
	        return _axios2.default.delete(_url.PURCHASE_QUOTES_URL + purchaseOrder_id, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(deletePurchaseQuoteSuccess());
	            _reactRouter.browserHistory.push('/purchaseQuote');
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(deletePurchaseQuoteFailure(err));
	        });
	    };
	}
	
	function deletePurchaseQuoteSuccess() {
	    return {
	        type: _type.DELETE_PURCHASE_QUOTE_SUCCESS
	    };
	}
	
	function deletePurchaseQuoteFailure(error) {
	    return {
	        type: _type.DELETE_PURCHASE_QUOTE_FAILURE,
	        payload: error
	    };
	}
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseQuotes, 'fetchPurchaseQuotes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(requestPurchaseQuotes, 'requestPurchaseQuotes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseQuotesSuccess, 'fetchPurchaseQuotesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseQuotesFailure, 'fetchPurchaseQuotesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(selectPurchaseQuote, 'selectPurchaseQuote', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(resetCurrentPurchaseQuote, 'resetCurrentPurchaseQuote', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseQuoteDetail, 'fetchPurchaseQuoteDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(requestPurchaseQuoteDetail, 'requestPurchaseQuoteDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseQuoteDetailSuccess, 'fetchPurchaseQuoteDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseQuoteDetailFailure, 'fetchPurchaseQuoteDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(createPurchaseQuote, 'createPurchaseQuote', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(createPurchaseQuoteSuccess, 'createPurchaseQuoteSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(createPurchaseQuoteFailure, 'createPurchaseQuoteFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(purchaseQuotePlace, 'purchaseQuotePlace', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(purchaseQuotePlaceSuccess, 'purchaseQuotePlaceSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(purchaseQuotePlaceFailure, 'purchaseQuotePlaceFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(editPurchaseQuote, 'editPurchaseQuote', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(editPurchaseQuoteSuccess, 'editPurchaseQuoteSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(editPurchaseQuoteFailure, 'editPurchaseQuoteFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchNumPurchaseQuotes, 'fetchNumPurchaseQuotes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(requestNumPurchaseQuotes, 'requestNumPurchaseQuotes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchNumPurchaseQuotesSuccess, 'fetchNumPurchaseQuotesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchNumPurchaseQuotesFailure, 'fetchNumPurchaseQuotesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(deletePurchaseQuote, 'deletePurchaseQuote', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(deletePurchaseQuoteSuccess, 'deletePurchaseQuoteSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	
	    __REACT_HOT_LOADER__.register(deletePurchaseQuoteFailure, 'deletePurchaseQuoteFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseQuotes_actions.js');
	}();

	;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/forbid-prop-types */
	
	
	var PrintIframe = function (_Component) {
	  _inherits(PrintIframe, _Component);
	
	  function PrintIframe() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PrintIframe);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PrintIframe.__proto__ || Object.getPrototypeOf(PrintIframe)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnLoad = function () {
	      var _this$props = _this.props,
	          loaded = _this$props.loaded,
	          name = _this$props.name,
	          onLoad = _this$props.onLoad;
	
	      if (!loaded) {
	        var pdfFrame = window.frames[name];
	        pdfFrame.focus();
	        pdfFrame.print();
	        if (typeof onLoad === 'function') {
	          onLoad();
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PrintIframe, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          pdf = _props.pdf,
	          style = _props.style,
	          title = _props.title;
	
	      if (pdf) {
	        var file = window.URL.createObjectURL(pdf);
	        return _react2.default.createElement('iframe', _extends({}, this.props, {
	          title: title,
	          style: _extends({}, style, { display: 'none' }),
	          onLoad: this.handleOnLoad,
	          src: file
	        }));
	      }
	      return null;
	    }
	  }]);
	
	  return PrintIframe;
	}(_react.Component);
	
	PrintIframe.defaultProps = {
	  id: 'pdf',
	  onLoad: function onLoad() {},
	  pdf: null,
	  style: {},
	  title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	};
	
	PrintIframe.propTypes = {
	  id: _propTypes2.default.string,
	  loaded: _propTypes2.default.bool.isRequired,
	  name: _propTypes2.default.string.isRequired,
	  onLoad: _propTypes2.default.func,
	  pdf: _propTypes2.default.object,
	  style: _propTypes2.default.any,
	  title: _propTypes2.default.element
	};
	
	var _default = PrintIframe;
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PrintIframe, 'PrintIframe', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/PrintIframe.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/PrintIframe.jsx');
	}();

	;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RowRenderer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RowRenderer = exports.RowRenderer = function (_Component) {
	  _inherits(RowRenderer, _Component);
	
	  function RowRenderer() {
	    _classCallCheck(this, RowRenderer);
	
	    return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(RowRenderer, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { onDoubleClick: function onDoubleClick() {
	            _this2.props.onDoubleClick(_this2.props.row, _this2.props.from, _this2.props.to);
	          } },
	        _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	      );
	    }
	  }]);
	
	  return RowRenderer;
	}(_react.Component);
	
	var _default = RowRenderer;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/rowRenderer.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/rowRenderer.jsx');
	}();

	;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchPurchaseTemplates = fetchPurchaseTemplates;
	exports.requestPurchaseTemplates = requestPurchaseTemplates;
	exports.fetchPurchaseTemplatesSuccess = fetchPurchaseTemplatesSuccess;
	exports.fetchPurchaseTemplatesFailure = fetchPurchaseTemplatesFailure;
	exports.selectPurchaseTemplate = selectPurchaseTemplate;
	exports.resetCurrentPurchaseTemplate = resetCurrentPurchaseTemplate;
	exports.fetchPurchaseTemplateDetail = fetchPurchaseTemplateDetail;
	exports.requestPurchaseTemplateDetail = requestPurchaseTemplateDetail;
	exports.fetchPurchaseTemplateDetailSuccess = fetchPurchaseTemplateDetailSuccess;
	exports.fetchPurchaseTemplateDetailFailure = fetchPurchaseTemplateDetailFailure;
	exports.createPurchaseTemplate = createPurchaseTemplate;
	exports.createPurchaseTemplateSuccess = createPurchaseTemplateSuccess;
	exports.createPurchaseTemplateFailure = createPurchaseTemplateFailure;
	exports.editPurchaseTemplate = editPurchaseTemplate;
	exports.editPurchaseTemplateSuccess = editPurchaseTemplateSuccess;
	exports.editPurchaseTemplateFailure = editPurchaseTemplateFailure;
	exports.convertTemplateToQuote = convertTemplateToQuote;
	exports.requestConvertingTemplate = requestConvertingTemplate;
	exports.convertTemplateSuccess = convertTemplateSuccess;
	exports.convertTemplateFailure = convertTemplateFailure;
	exports.convertTemplateToSchedule = convertTemplateToSchedule;
	exports.requestConvertingTemplateToSchedule = requestConvertingTemplateToSchedule;
	exports.convertTemplateToScheduleSuccess = convertTemplateToScheduleSuccess;
	exports.convertTemplateToScheduleFailure = convertTemplateToScheduleFailure;
	exports.deletePurchaseTemplate = deletePurchaseTemplate;
	exports.deletePurchaseTemplateSuccess = deletePurchaseTemplateSuccess;
	exports.deletePurchaseTemplateFailure = deletePurchaseTemplateFailure;
	exports.fetchPurchaseTemplateList = fetchPurchaseTemplateList;
	exports.fetchPurchaseTemplateListSuccess = fetchPurchaseTemplateListSuccess;
	exports.fetchPurchaseTemplateListFailure = fetchPurchaseTemplateListFailure;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function fetchPurchaseTemplates() {
	    return function (dispatch) {
	        dispatch(requestPurchaseTemplates());
	        return _axios2.default.get(_url.PURCHASE_TEMPLATES_URL, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchPurchaseTemplatesSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchPurchaseTemplatesFailure(err));
	        });
	    };
	}
	
	function requestPurchaseTemplates() {
	    return {
	        type: _type.REQUEST_PURCHASE_TEMPLATES
	    };
	}
	
	function fetchPurchaseTemplatesSuccess(purchaseTemplates) {
	    return {
	        type: _type.FETCH_PURCHASE_TEMPLATES_SUCCESS,
	        payload: purchaseTemplates
	    };
	}
	
	function fetchPurchaseTemplatesFailure(error) {
	    return {
	        type: _type.FETCH_PURCHASE_TEMPLATES_FAILURE,
	        payload: error
	    };
	}
	
	function selectPurchaseTemplate(purchaseTemplate) {
	    return {
	        type: _type.SELECT_PURCHASE_TEMPLATE,
	        payload: purchaseTemplate
	    };
	}
	
	function resetCurrentPurchaseTemplate() {
	    return {
	        type: _type.RESET_CURRENT_PURCHASE_TEMPLATE
	    };
	}
	
	// Fetch the detail page.
	
	function fetchPurchaseTemplateDetail(customer_id) {
	    return function (dispatch) {
	        dispatch(requestPurchaseTemplateDetail());
	        return _axios2.default.get(_url.PURCHASE_TEMPLATES_URL + customer_id, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchPurchaseTemplateDetailSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchPurchaseTemplateDetailFailure(err));
	        });
	    };
	}
	
	function requestPurchaseTemplateDetail() {
	    return {
	        type: _type.REQUEST_PURCHASE_TEMPLATE_DETAIL
	    };
	}
	
	function fetchPurchaseTemplateDetailSuccess(purchaseTemplateDetail) {
	    purchaseTemplateDetail = purchaseTemplateDetail.data;
	    // The date data fetched is in the form of string, which needs to be modified into Date type
	    if (purchaseTemplateDetail.OrderDate) purchaseTemplateDetail.OrderDate = new Date(purchaseTemplateDetail.OrderDate);
	    if (purchaseTemplateDetail.ETADate) purchaseTemplateDetail.ETADate = new Date(purchaseTemplateDetail.ETADate);
	    if (purchaseTemplateDetail.ReceivedDate) purchaseTemplateDetail.ReceivedDate = new Date(purchaseTemplateDetail.ReceivedDate);
	    return {
	        type: _type.FETCH_PURCHASE_TEMPLATE_DETAIL_SUCCESS,
	        payload: purchaseTemplateDetail
	    };
	}
	
	function fetchPurchaseTemplateDetailFailure(error) {
	    return {
	        type: _type.FETCH_PURCHASE_TEMPLATE_DETAIL_FAILURE,
	        payload: error
	    };
	}
	
	function createPurchaseTemplate(_ref, Purchase_Template_Line, TaxRate, CRV, FinalNetWeight, FinalShippingWeight, TotalPrice, FinalPrice) {
	    var Name = _ref.Name,
	        NoteToVendor = _ref.NoteToVendor,
	        ReleaseInformation = _ref.ReleaseInformation,
	        CarryType = _ref.CarryType,
	        ShippingMethod = _ref.ShippingMethod,
	        Discount = _ref.Discount,
	        ShippingCost = _ref.ShippingCost,
	        HandlingCost = _ref.HandlingCost,
	        MiscCost = _ref.MiscCost,
	        MiscNote = _ref.MiscNote,
	        ConvertItemPrice = _ref.ConvertItemPrice,
	        Vendor_id = _ref.Vendor_id,
	        Pickup_VendorDetail_id = _ref.Pickup_VendorDetail_id,
	        Deliver_Warehouse_id = _ref.Deliver_Warehouse_id,
	        DispatchMethod_id = _ref.DispatchMethod_id,
	        DispatchOutSourceContact_id = _ref.DispatchOutSourceContact_id,
	        Purchaser_User_id = _ref.Purchaser_User_id,
	        Modifier_User_id = _ref.Modifier_User_id,
	        PaymentStatus = _ref.PaymentStatus;
	
	    Purchase_Template_Line.map(function (product) {
	        if (product.Product_id) product.Product_id = product.Product_id.value || product.Product_id;
	    });
	    if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
	    if (Pickup_VendorDetail_id) Pickup_VendorDetail_id = Pickup_VendorDetail_id.value || Pickup_VendorDetail_id;
	    if (CarryType) CarryType = CarryType.value || CarryType;
	    if (PaymentStatus) PaymentStatus = PaymentStatus.value || PaymentStatus;
	    if (ShippingMethod) ShippingMethod = ShippingMethod.value || ShippingMethod;
	    if (Deliver_Warehouse_id) Deliver_Warehouse_id = Deliver_Warehouse_id.value || Deliver_Warehouse_id;
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_CREATING_PURCHASE_TEMPLATE });
	        _axios2.default.post(_url.PURCHASE_TEMPLATES_URL, _defineProperty({
	            Name: Name,
	            FinalNetWeight: FinalNetWeight,
	            FinalShippingWeight: FinalShippingWeight,
	            TotalPrice: TotalPrice,
	            NoteToVendor: NoteToVendor,
	            ReleaseInformation: ReleaseInformation,
	            CarryType: CarryType,
	            ShippingMethod: ShippingMethod,
	            Discount: Discount,
	            ShippingCost: ShippingCost,
	            HandlingCost: HandlingCost,
	            MiscCost: MiscCost,
	            MiscNote: MiscNote,
	            TaxRate: TaxRate,
	            FinalPrice: FinalPrice,
	            ConvertItemPrice: ConvertItemPrice,
	            Deliver_Warehouse_id: Deliver_Warehouse_id,
	            DispatchMethod_id: DispatchMethod_id,
	            DispatchOutSourceContact_id: DispatchOutSourceContact_id,
	            Purchaser_User_id: Purchaser_User_id,
	            Modifier_User_id: Modifier_User_id,
	            Vendor_id: Vendor_id,
	            Pickup_VendorDetail_id: Pickup_VendorDetail_id,
	            Purchase_Template_Line: Purchase_Template_Line,
	            PaymentStatus: PaymentStatus,
	            CRV: CRV
	        }, 'ShippingMethod', ShippingMethod), {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(createPurchaseTemplateSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(createPurchaseTemplateFailure(err));
	        });
	    };
	}
	
	function createPurchaseTemplateSuccess(response) {
	    return {
	        type: _type.CREATE_PURCHASE_TEMPLATE_SUCCESS,
	        payload: response
	    };
	}
	
	function createPurchaseTemplateFailure(error) {
	    return {
	        type: _type.CREATE_PURCHASE_TEMPLATE_FAILURE,
	        payload: error
	    };
	}
	
	function editPurchaseTemplate(_ref2, Purchase_Template_Line, TaxRate, CRV, FinalNetWeight, FinalShippingWeight, TotalPrice, FinalPrice) {
	    var PurchaseTemplate_id = _ref2.PurchaseTemplate_id,
	        Name = _ref2.Name,
	        NoteToVendor = _ref2.NoteToVendor,
	        ReleaseInformation = _ref2.ReleaseInformation,
	        CarryType = _ref2.CarryType,
	        Discount = _ref2.Discount,
	        ShippingCost = _ref2.ShippingCost,
	        HandlingCost = _ref2.HandlingCost,
	        MiscCost = _ref2.MiscCost,
	        MiscNote = _ref2.MiscNote,
	        ConvertItemPrice = _ref2.ConvertItemPrice,
	        Vendor_id = _ref2.Vendor_id,
	        Pickup_VendorDetail_id = _ref2.Pickup_VendorDetail_id,
	        Deliver_Warehouse_id = _ref2.Deliver_Warehouse_id,
	        DispatchMethod_id = _ref2.DispatchMethod_id,
	        DispatchOutSourceContact_id = _ref2.DispatchOutSourceContact_id,
	        Purchaser_User_id = _ref2.Purchaser_User_id,
	        Modifier_User_id = _ref2.Modifier_User_id,
	        PaymentStatus = _ref2.PaymentStatus,
	        ShippingMethod = _ref2.ShippingMethod;
	
	    Purchase_Template_Line.map(function (product) {
	        if (product.Product_id) product.Product_id = product.Product_id.value || product.Product_id;
	    });
	    if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
	    if (Pickup_VendorDetail_id) Pickup_VendorDetail_id = Pickup_VendorDetail_id.value || Pickup_VendorDetail_id;
	    if (CarryType) CarryType = CarryType.value || CarryType;
	    if (PaymentStatus) PaymentStatus = PaymentStatus.value || PaymentStatus;
	    if (ShippingMethod) ShippingMethod = ShippingMethod.value || ShippingMethod;
	    if (Deliver_Warehouse_id) Deliver_Warehouse_id = Deliver_Warehouse_id.value || Deliver_Warehouse_id;
	    return function (dispatch) {
	        var _axios$put;
	
	        dispatch({ type: _type.REQUEST_EDITING_PURCHASE_TEMPLATE });
	        _axios2.default.put(_url.PURCHASE_TEMPLATES_URL + PurchaseTemplate_id, (_axios$put = {
	            Name: Name,
	            FinalNetWeight: FinalNetWeight,
	            FinalShippingWeight: FinalShippingWeight,
	            TotalPrice: TotalPrice,
	            NoteToVendor: NoteToVendor,
	            ReleaseInformation: ReleaseInformation,
	            CarryType: CarryType,
	            ShippingMethod: ShippingMethod,
	            Discount: Discount,
	            ShippingCost: ShippingCost,
	            HandlingCost: HandlingCost,
	            MiscCost: MiscCost,
	            MiscNote: MiscNote,
	            TaxRate: TaxRate,
	            FinalPrice: FinalPrice,
	            ConvertItemPrice: ConvertItemPrice,
	            Deliver_Warehouse_id: Deliver_Warehouse_id,
	            DispatchMethod_id: DispatchMethod_id,
	            DispatchOutSourceContact_id: DispatchOutSourceContact_id,
	            Purchaser_User_id: Purchaser_User_id,
	            Modifier_User_id: Modifier_User_id,
	            Vendor_id: Vendor_id,
	            Pickup_VendorDetail_id: Pickup_VendorDetail_id,
	            Purchase_Template_Line: Purchase_Template_Line,
	            PaymentStatus: PaymentStatus
	        }, _defineProperty(_axios$put, 'ShippingMethod', ShippingMethod), _defineProperty(_axios$put, 'CRV', CRV), _axios$put), {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(editPurchaseTemplateSuccess());
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(editPurchaseTemplateFailure(err));
	        });
	    };
	}
	
	function editPurchaseTemplateSuccess() {
	    return {
	        type: _type.EDIT_PURCHASE_TEMPLATE_SUCCESS
	    };
	}
	
	function editPurchaseTemplateFailure(error) {
	    return {
	        type: _type.EDIT_PURCHASE_TEMPLATE_FAILURE,
	        payload: error
	    };
	}
	
	// Fetch the detail page.
	
	function convertTemplateToQuote(template_id) {
	    return function (dispatch) {
	        dispatch(requestConvertingTemplate());
	        return _axios2.default.get(_url.PURCHASE_TEMPLATES_URL + template_id + "/convert/", {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(convertTemplateSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(convertTemplateFailure(err));
	        });
	    };
	}
	
	function requestConvertingTemplate() {
	    return {
	        type: _type.REQUEST_PURCHASE_QUOTE_DETAIL
	    };
	}
	
	function convertTemplateSuccess(purchaseQuoteDetail) {
	    purchaseQuoteDetail = purchaseQuoteDetail.data;
	    // The date data fetched is in the form of string, which needs to be modified into Date type
	    if (purchaseQuoteDetail.OrderDate) purchaseQuoteDetail.OrderDate = new Date(purchaseQuoteDetail.OrderDate);
	    if (purchaseQuoteDetail.ETADate) purchaseQuoteDetail.ETADate = new Date(purchaseQuoteDetail.ETADate);
	    if (purchaseQuoteDetail.ReceivedDate) purchaseQuoteDetail.ReceivedDate = new Date(purchaseQuoteDetail.ReceivedDate);
	    return {
	        type: _type.FETCH_PURCHASE_QUOTE_DETAIL_SUCCESS,
	        payload: purchaseQuoteDetail
	    };
	}
	
	function convertTemplateFailure(error) {
	    return {
	        type: _type.FETCH_PURCHASE_QUOTE_DETAIL_FAILURE,
	        payload: error
	    };
	}
	
	function convertTemplateToSchedule(template_id) {
	    return function (dispatch) {
	        dispatch(requestConvertingTemplateToSchedule());
	        return _axios2.default.get(_url.PURCHASE_TEMPLATES_URL + template_id + "/schedule/", {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(convertTemplateToScheduleSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(convertTemplateToScheduleFailure(err));
	        });
	    };
	}
	
	function requestConvertingTemplateToSchedule() {
	    return {
	        type: _type.REQUEST_PURCHASE_SCHEDULE_DETAIL
	    };
	}
	
	function convertTemplateToScheduleSuccess(purchaseScheduleDetail) {
	    purchaseScheduleDetail = purchaseScheduleDetail.data;
	    // The date data fetched is in the form of string, which needs to be modified into Date type
	    if (purchaseScheduleDetail.StartDate) purchaseScheduleDetail.StartDate = new Date(purchaseScheduleDetail.StartDate);
	    if (purchaseScheduleDetail.NextExecuteDate) purchaseScheduleDetail.NextExecuteDate = new Date(purchaseScheduleDetail.NextExecuteDate);
	    return {
	        type: _type.FETCH_PURCHASE_SCHEDULE_DETAIL_SUCCESS,
	        payload: purchaseScheduleDetail
	    };
	}
	
	function convertTemplateToScheduleFailure(error) {
	    return {
	        type: _type.FETCH_PURCHASE_SCHEDULE_DETAIL_FAILURE,
	        payload: error
	    };
	}
	
	function deletePurchaseTemplate(template_id) {
	    return function (dispatch) {
	        dispatch({ type: _type.DELETE_PURCHASE_TEMPLATE });
	        return _axios2.default.delete(_url.PURCHASE_TEMPLATES_URL + template_id, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(deletePurchaseTemplateSuccess());
	            _reactRouter.browserHistory.push('/purchaseTemplate'); // If editd succesfully, refresh the paymentTerm page.
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(deletePurchaseTemplateFailure(err));
	        });
	    };
	}
	
	function deletePurchaseTemplateSuccess() {
	    return {
	        type: _type.DELETE_PURCHASE_TEMPLATE_SUCCESS
	    };
	}
	
	function deletePurchaseTemplateFailure(error) {
	    return {
	        type: _type.DELETE_PURCHASE_TEMPLATE_FAILURE,
	        payload: error
	    };
	}
	
	function fetchPurchaseTemplateList(pk) {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_PURCHASE_TEMPLATE_LIST });
	        return _axios2.default.get(_url.PURCHASE_TEMPLATES_URL + 'detail' + '/' + pk, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchPurchaseTemplateListSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchPurchaseTemplateListFailure(err));
	        });
	    };
	}
	
	function fetchPurchaseTemplateListSuccess(list) {
	    return {
	        type: _type.FETCH_PURCHASE_TEMPLATE_LIST_SUCCESS,
	        payload: list
	    };
	}
	
	function fetchPurchaseTemplateListFailure(error) {
	    return {
	        type: _type.FETCH_PURCHASE_TEMPLATE_LIST_FAILURE,
	        payload: error
	    };
	}
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseTemplates, 'fetchPurchaseTemplates', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(requestPurchaseTemplates, 'requestPurchaseTemplates', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseTemplatesSuccess, 'fetchPurchaseTemplatesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseTemplatesFailure, 'fetchPurchaseTemplatesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(selectPurchaseTemplate, 'selectPurchaseTemplate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(resetCurrentPurchaseTemplate, 'resetCurrentPurchaseTemplate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseTemplateDetail, 'fetchPurchaseTemplateDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(requestPurchaseTemplateDetail, 'requestPurchaseTemplateDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseTemplateDetailSuccess, 'fetchPurchaseTemplateDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseTemplateDetailFailure, 'fetchPurchaseTemplateDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(createPurchaseTemplate, 'createPurchaseTemplate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(createPurchaseTemplateSuccess, 'createPurchaseTemplateSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(createPurchaseTemplateFailure, 'createPurchaseTemplateFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(editPurchaseTemplate, 'editPurchaseTemplate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(editPurchaseTemplateSuccess, 'editPurchaseTemplateSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(editPurchaseTemplateFailure, 'editPurchaseTemplateFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(convertTemplateToQuote, 'convertTemplateToQuote', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(requestConvertingTemplate, 'requestConvertingTemplate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(convertTemplateSuccess, 'convertTemplateSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(convertTemplateFailure, 'convertTemplateFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(convertTemplateToSchedule, 'convertTemplateToSchedule', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(requestConvertingTemplateToSchedule, 'requestConvertingTemplateToSchedule', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(convertTemplateToScheduleSuccess, 'convertTemplateToScheduleSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(convertTemplateToScheduleFailure, 'convertTemplateToScheduleFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(deletePurchaseTemplate, 'deletePurchaseTemplate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(deletePurchaseTemplateSuccess, 'deletePurchaseTemplateSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(deletePurchaseTemplateFailure, 'deletePurchaseTemplateFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseTemplateList, 'fetchPurchaseTemplateList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseTemplateListSuccess, 'fetchPurchaseTemplateListSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseTemplateListFailure, 'fetchPurchaseTemplateListFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseTemplates_actions.js');
	}();

	;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchReceives = fetchReceives;
	exports.requestReceives = requestReceives;
	exports.fetchReceivesSuccess = fetchReceivesSuccess;
	exports.fetchReceivesFailure = fetchReceivesFailure;
	exports.selectReceive = selectReceive;
	exports.resetCurrentReceive = resetCurrentReceive;
	exports.createReceive = createReceive;
	exports.createReceiveSuccess = createReceiveSuccess;
	exports.createReceiveFailure = createReceiveFailure;
	exports.resetCreateReceive = resetCreateReceive;
	exports.editReceive = editReceive;
	exports.editReceiveSuccess = editReceiveSuccess;
	exports.editReceiveFailure = editReceiveFailure;
	exports.fetchReceiveDetail = fetchReceiveDetail;
	exports.requestReceiveDetail = requestReceiveDetail;
	exports.fetchReceiveDetailSuccess = fetchReceiveDetailSuccess;
	exports.fetchReceiveDetailFailure = fetchReceiveDetailFailure;
	exports.convertPOToReceive = convertPOToReceive;
	exports.completePurchaseOrder = completePurchaseOrder;
	exports.completePurchaseOrderSuccess = completePurchaseOrderSuccess;
	exports.completePurchaseOrderFailure = completePurchaseOrderFailure;
	exports.fetchReceiveHistory = fetchReceiveHistory;
	exports.fetchReceiveHistoryByDate = fetchReceiveHistoryByDate;
	exports.fetchReceiveHistorySuccess = fetchReceiveHistorySuccess;
	exports.fetchReceiveHistoryFailure = fetchReceiveHistoryFailure;
	exports.selectReceiveHistory = selectReceiveHistory;
	exports.resetCurrentReceiveHistory = resetCurrentReceiveHistory;
	exports.fetchReceiveHistoryDetail = fetchReceiveHistoryDetail;
	exports.fetchReceiveHistoryDetailSuccess = fetchReceiveHistoryDetailSuccess;
	exports.fetchReceiveHistoryDetailFailure = fetchReceiveHistoryDetailFailure;
	exports.fetchAllReceiveHistoryDetail = fetchAllReceiveHistoryDetail;
	exports.fetchAllReceiveHistoryDetailSuccess = fetchAllReceiveHistoryDetailSuccess;
	exports.fetchAllReceiveHistoryDetailFailure = fetchAllReceiveHistoryDetailFailure;
	exports.fetchReceiveHistoryDetailRecord = fetchReceiveHistoryDetailRecord;
	exports.fetchReceiveHistoryDetailRecordSuccess = fetchReceiveHistoryDetailRecordSuccess;
	exports.fetchReceiveHistoryDetailRecordFailure = fetchReceiveHistoryDetailRecordFailure;
	exports.editReceiveHistory = editReceiveHistory;
	exports.editReceiveHistorySuccess = editReceiveHistorySuccess;
	exports.editReceiveHistoryFailure = editReceiveHistoryFailure;
	exports.resetEditReceiveHistory = resetEditReceiveHistory;
	exports.voidReceiving = voidReceiving;
	exports.voidReceivingFinished = voidReceivingFinished;
	exports.resetDeleteStatus = resetDeleteStatus;
	exports.attachFile = attachFile;
	exports.attachFileSuccess = attachFileSuccess;
	exports.attachFileFailure = attachFileFailure;
	exports.fetchAttachedFile = fetchAttachedFile;
	exports.fetchAttachedFileSuccess = fetchAttachedFileSuccess;
	exports.fetchAttachedFileFailure = fetchAttachedFileFailure;
	exports.deleteAttachedFile = deleteAttachedFile;
	exports.deleteAttachedFileSuccess = deleteAttachedFileSuccess;
	exports.deleteAttachedFileFailure = deleteAttachedFileFailure;
	exports.resetAttachedFile = resetAttachedFile;
	exports.setPostingDate = setPostingDate;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(13);
	
	var _cleanDates = __webpack_require__(22);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _root_url = __webpack_require__(9);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchReceives() {
	  return function (dispatch) {
	    dispatch(requestReceives());
	    return _axios2.default.get(_url.RECEIVE_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchReceivesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchReceivesFailure(err));
	    });
	  };
	}
	
	function requestReceives() {
	  return {
	    type: _type.REQUEST_RECEIVES
	  };
	}
	
	function fetchReceivesSuccess(receives) {
	  return {
	    type: _type.FETCH_RECEIVES_SUCCESS,
	    payload: receives
	  };
	}
	
	function fetchReceivesFailure(error) {
	  return {
	    type: _type.FETCH_RECEIVES_FAILURE,
	    payload: error
	  };
	}
	
	function selectReceive(receive) {
	  return {
	    type: _type.SELECT_RECEIVE,
	    payload: receive
	  };
	}
	
	function resetCurrentReceive() {
	  return {
	    type: _type.RESET_CURRENT_RECEIVE
	  };
	}
	
	// Actions to deal with the promise of posting function.
	
	function createReceive(PostingDate, InvoiceDate, HandlingCost, MiscCost, ShippingCost, PriceAdjustment, ShareCost, PONum, Note, Warehouse_id, VendorPicklistNum, Vendor_id, ReceivingPrice, InvoiceFinalPrice, Warehouse_Receive_Line, _ref, completeReceive) {
	  var InvoiceNum = _ref.InvoiceNum,
	      PackingNum = _ref.PackingNum,
	      container_num = _ref.container_num;
	
	  // let FinalPrice = (parseFloat(TotalPrice) || 0) + (parseFloat(HandlingCost) || 0) + (parseFloat(MiscCost) || 0) + (parseFloat(ShippingCost) || 0);
	  Warehouse_Receive_Line.map(function (product) {
	    product['StorageRate'] = product.StorageRate || 0;
	    if (product.Product_id) {
	      product.Product_id = product.Product_id.Product_id || product.Product_id;
	    }
	    if (product['subWeights']) {
	      product['Weights'] = [];
	      product.subWeights.map(function (w) {
	        product['Weights'].push(parseFloat(w.Weight));
	      });
	    }
	    if (!product.Remark) {
	      product.Remark = "";
	    }
	  });
	
	  InvoiceFinalPrice = parseFloat(InvoiceFinalPrice);
	  return function (dispatch) {
	    if (Warehouse_Receive_Line.length > 0) {
	      dispatch({ type: _type.REQUEST_CREATING_RECEIVE });
	      _axios2.default.post(_url.RECEIVE_URL + 'history/' + PONum, {
	        PostingDate: PostingDate,
	        InvoiceDate: InvoiceDate,
	        HandlingCost: HandlingCost,
	        MiscCost: MiscCost,
	        ShippingCost: ShippingCost,
	        PriceAdjustment: PriceAdjustment,
	        ShareCost: ShareCost,
	        PONum: PONum,
	        Note: Note,
	        Warehouse_id: Warehouse_id,
	        VendorPicklistNum: VendorPicklistNum,
	        Vendor_id: Vendor_id,
	        // TotalPrice,
	        // FinalPrice,
	        ReceivingPrice: ReceivingPrice,
	        InvoiceNum: InvoiceNum,
	        PackingNum: PackingNum,
	        container_num: container_num,
	        InvoiceFinalPrice: InvoiceFinalPrice,
	        Warehouse_Receive_Line: Warehouse_Receive_Line
	      }, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        if ( /*response.status == 200 || */completeReceive == true) {
	          _axios2.default.get(_url.PURCHASE_ORDERS_URL + PONum + '/complete/', {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	          }).then(function (res) {
	            dispatch(createReceiveSuccess(response));
	          }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	              err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(createReceiveFailure(err));
	          });
	        } else {
	          dispatch(createReceiveSuccess(response));
	          // browserHistory.push('/inventories/receive/');
	        }
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = _constants.DEFAULT_ERROR;
	        }
	        dispatch(createReceiveFailure(err));
	      });
	    } else if (Warehouse_Receive_Line.length === 0) {
	      if ( /*response.status == 200 || */completeReceive === true) {
	        dispatch({ type: _type.REQUEST_CREATING_RECEIVE });
	        _axios2.default.get(_url.PURCHASE_ORDERS_URL + PONum + '/complete/', {
	          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (res) {
	          dispatch(createReceiveSuccess(res));
	          _reactRouter.browserHistory.push('/inventories/receive/');
	        }, function (err) {
	          if (err.status === 500 || err.status === 404) {
	            err.data = _constants.DEFAULT_ERROR;
	          }
	          dispatch(createReceiveFailure(err));
	        });
	      }
	    }
	  };
	}
	
	// export function requestCreatingReceive() {
	//     return {
	//         type: REQUEST_CREATING_RECEIVE
	//     }
	// }
	
	function createReceiveSuccess(response) {
	  return {
	    type: _type.CREATE_RECEIVE_SUCCESS,
	    payload: response
	  };
	}
	
	function createReceiveFailure(error) {
	  return {
	    type: _type.CREATE_RECEIVE_FAILURE,
	    payload: error
	  };
	}
	
	function resetCreateReceive() {
	  return {
	    type: _type.RESET_CREATE_RECEIVE
	  };
	}
	
	function editReceive(_ref2) {
	  var Receive_id = _ref2.Receive_id,
	      ReceiveNum = _ref2.ReceiveNum,
	      RefNum = _ref2.RefNum,
	      Name = _ref2.Name,
	      Description = _ref2.Description,
	      CreditStatus = _ref2.CreditStatus,
	      IsActive = _ref2.IsActive,
	      Purchaser_User_id = _ref2.Purchaser_User_id,
	      PaymentTerm_id = _ref2.PaymentTerm_id,
	      ShippingContact = _ref2.ShippingContact,
	      ShippingAddress = _ref2.ShippingAddress,
	      MailingAddress = _ref2.MailingAddress,
	      MailingContact = _ref2.MailingContact,
	      BillingAddress = _ref2.BillingAddress,
	      BillingContact = _ref2.BillingContact,
	      Purchase_Order_Line = _ref2.Purchase_Order_Line;
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EDITING_RECEIVE });
	    _axios2.default.put(_url.RECEIVE_URL + 'history/' + Receive_id, {
	      ReceiveNum: ReceiveNum,
	      RefNum: RefNum,
	      Name: Name,
	      Description: Description,
	      CreditStatus: CreditStatus,
	      IsActive: IsActive,
	      Purchaser_User_id: Purchaser_User_id,
	      PaymentTerm_id: PaymentTerm_id.value,
	      ShippingContact: ShippingContact,
	      ShippingAddress: ShippingAddress,
	      MailingAddress: MailingAddress,
	      MailingContact: MailingContact,
	      BillingAddress: BillingAddress,
	      BillingContact: BillingContact,
	      Purchase_Order_Line: Purchase_Order_Line
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editReceiveSuccess());
	      _reactRouter.browserHistory.push('/receives'); // If editd succesfully, refresh the paymentTerm page.
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editReceiveFailure(err));
	    });
	  };
	}
	
	// export function requestCreatingReceive() {
	//     return {
	//         type: REQUEST_EDITING_RECEIVE
	//     }
	// }
	
	function editReceiveSuccess() {
	  return {
	    type: _type.EDIT_RECEIVE_SUCCESS
	  };
	}
	
	function editReceiveFailure(error) {
	  return {
	    type: _type.EDIT_RECEIVE_FAILURE,
	    payload: error
	  };
	}
	
	// Fetch the detail page.
	
	function fetchReceiveDetail(PONum) {
	  return function (dispatch) {
	    dispatch(requestReceiveDetail());
	    return _axios2.default.get(_url.RECEIVE_URL + PONum,
	    // return axios.get(RECEIVE_URL + 'history/' + 'P1609220000',
	    {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchReceiveDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchReceiveDetailFailure(err));
	    });
	  };
	}
	
	function requestReceiveDetail() {
	  return {
	    type: _type.REQUEST_RECEIVE_DETAIL
	  };
	}
	
	function fetchReceiveDetailSuccess(receiveDetail) {
	  return {
	    type: _type.FETCH_RECEIVE_DETAIL_SUCCESS,
	    payload: receiveDetail
	  };
	}
	
	function fetchReceiveDetailFailure(error) {
	  return {
	    type: _type.FETCH_RECEIVE_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function convertPOToReceive(PO_id) {
	  return function (dispatch) {
	    dispatch(requestReceiveDetail());
	    return _axios2.default.get(_url.RECEIVE_URL + PO_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchReceiveDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchReceiveDetailFailure(err));
	    });
	  };
	}
	
	function completePurchaseOrder(PONum) {
	  //force to complete
	  return function (dispatch) {
	    dispatch({ type: _type.COMPLETE_PURCHASE_ORDER }); //add this type later...
	    return _axios2.default.get(_url.PURCHASE_ORDER_COMPLETE_URL + PONum, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(completePurchaseOrderSuccess());
	      _reactRouter.browserHistory.push('/inventories/receive/');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(completePurchaseOrderFailure(err));
	    });
	  };
	}
	
	function completePurchaseOrderSuccess() {
	  return {
	    type: _type.COMPLETE_PURCHASE_ORDER_SUCCESS
	  };
	}
	
	function completePurchaseOrderFailure(error) {
	  return {
	    type: _type.COMPLETE_PURCHASE_ORDER_FAILURE,
	    payload: error
	  };
	}
	
	function fetchReceiveHistory(status) {
	  if (status == "Arrived") {
	    return function (dispatch) {
	      dispatch({ type: _type.FETCH_RECEIVE_HISTORY }); //add this type later...
	      return _axios2.default.get(_url.RECEIVE_URL + 'history/?ArrivalStatus=Arrived', {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        dispatch(fetchReceiveHistorySuccess(response));
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = _constants.DEFAULT_ERROR;
	        }
	        dispatch(fetchReceiveHistoryFailure(err));
	      });
	    };
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.FETCH_RECEIVE_HISTORY }); //add this type later...
	    return _axios2.default.get(_url.RECEIVE_URL + 'history/', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchReceiveHistorySuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchReceiveHistoryFailure(err));
	    });
	  };
	}
	
	function fetchReceiveHistoryByDate(SalesOrder_gte, SalesOrder_lte, days, isReport) {
	  var dates = (0, _cleanDates.toFromDates)(days, SalesOrder_gte, SalesOrder_lte);
	  var report = isReport;
	  if (isReport) {
	    report = '&Report=true';
	  } else {
	    report = '&Report=false';
	  }
	
	  return function (dispatch) {
	    dispatch({ type: _type.FETCH_RECEIVE_HISTORY }); // add this type later...
	    return _axios2.default.get(_url.WAREHOUSES_URL + 'search/?PostingDate__gte=' + dates.fromDate + '&PostingDate__lte=' + dates.toDate + report, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchReceiveHistorySuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchReceiveHistoryFailure(err));
	    });
	  };
	}
	
	function fetchReceiveHistorySuccess(receiveHistory) {
	  return {
	    type: _type.FETCH_RECEIVE_HISTORY_SUCCESS,
	    payload: receiveHistory
	  };
	}
	
	function fetchReceiveHistoryFailure(error) {
	  return {
	    type: _type.FETCH_RECEIVE_HISTORY_FAILURE,
	    payload: error
	  };
	}
	
	function selectReceiveHistory(receiveHisoty) {
	  return {
	    type: _type.SELECT_RECEIVE_HISTORY,
	    payload: receiveHisoty
	  };
	}
	
	function resetCurrentReceiveHistory() {
	  return {
	    type: _type.RESET_CURRENT_RECEIVE_HISTORY
	  };
	}
	
	function fetchReceiveHistoryDetail(WarehouseReceive_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.FETCH_RECEIVE_HISTORY_DETAIL });
	    return _axios2.default.get(_url.RECEIVE_URL + 'line/inbound/' + WarehouseReceive_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchReceiveHistoryDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchReceiveHistoryDetailFailure(err));
	    });
	  };
	}
	
	function fetchReceiveHistoryDetailSuccess(receiveHistoryDetail) {
	  return {
	    type: _type.FETCH_RECEIVE_HISTORY_DETAIL_SUCCESS,
	    payload: receiveHistoryDetail
	  };
	}
	
	function fetchReceiveHistoryDetailFailure(error) {
	  return {
	    type: _type.FETCH_RECEIVE_HISTORY_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function fetchAllReceiveHistoryDetail() {
	  return function (dispatch) {
	    dispatch({ type: _type.FETCH_RECEIVE_HISTORY_DETAIL });
	    return _axios2.default.get(_url.RECEIVE_URL + 'line/inbound/', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchAllReceiveHistoryDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchAllReceiveHistoryDetailFailure(err));
	    });
	  };
	}
	
	function fetchAllReceiveHistoryDetailSuccess(receiveHistoryDetail) {
	  return {
	    type: _type.FETCH_RECEIVE_HISTORY_DETAIL_SUCCESS,
	    payload: receiveHistoryDetail
	  };
	}
	
	function fetchAllReceiveHistoryDetailFailure(error) {
	  return {
	    type: _type.FETCH_RECEIVE_HISTORY_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function fetchReceiveHistoryDetailRecord(WarehouseReceive_id, Warehouse_ReceiveCompleted_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.FETCH_RECEIVE_HISTORY_DETAIL_RECORD });
	    // if(Warehouse_ReceiveCompleted_id) {
	    //   return axios.get(RECEIVE_URL + 'complete/' + Warehouse_ReceiveCompleted_id,
	    //       {
	    //           headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    //       })
	    //       .then(response => {
	    //           dispatch(fetchReceiveHistoryDetailRecordSuccess(response));
	    //       })
	    //       .catch(response => {
	    //           dispatch(fetchReceiveHistoryDetailRecordFailure(response));
	    //       })
	    // }
	    // else {
	    return _axios2.default.get(_url.RECEIVE_URL + 'history/' + WarehouseReceive_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchReceiveHistoryDetailRecordSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchReceiveHistoryDetailRecordFailure(err));
	    });
	    // }
	  };
	}
	
	// export function fetchReceiveHistoryDetailRecordSuccess(receiveHistoryDetail) {
	//     return {
	//         type: FETCH_RECEIVE_HISTORY_DETAIL_RECORD_SUCCESS,
	//         payload: receiveHistoryDetail
	//     };
	// }
	
	function fetchReceiveHistoryDetailRecordSuccess(receiveHistoryDetail) {
	  if (receiveHistoryDetail && receiveHistoryDetail.data) {
	    receiveHistoryDetail.data.Warehouse_Receive_Line.forEach(function (line, index) {
	      var expire_datetime = '';
	      if (line.expire_datetime) {
	        expire_datetime = (0, _moment2.default)(line.expire_datetime).format('MM-DD-YYYY');
	      }
	      receiveHistoryDetail.data.Warehouse_Receive_Line[index].expire_datetime = expire_datetime;
	      // if (line.package_date) {
	      //   receiveHistoryDetail.Warehouse_Receive_Line[index].package_date = moment(line.package_date).format('MM-DD-YYYY');
	      // }
	    });
	  }
	  return {
	    type: _type.FETCH_RECEIVE_HISTORY_DETAIL_RECORD_SUCCESS,
	    payload: receiveHistoryDetail
	  };
	}
	
	function fetchReceiveHistoryDetailRecordFailure(error) {
	  return {
	    type: _type.FETCH_RECEIVE_HISTORY_DETAIL_RECORD_FAILURE,
	    payload: error
	  };
	}
	
	/* Edid receiving and edit purchase payment are sharing this action */
	function editReceiveHistory(_ref3, Warehouse_Receive_Line, isPayment, TotalPrice, FinalPrice) {
	  var WarehouseReceiveCompleted_id = _ref3.WarehouseReceiveCompleted_id,
	      WarehouseReceive_id = _ref3.WarehouseReceive_id,
	      PaymentStatus = _ref3.PaymentStatus,
	      PostingDate = _ref3.PostingDate,
	      InvoiceDate = _ref3.InvoiceDate,
	      HandlingCost = _ref3.HandlingCost,
	      MiscCost = _ref3.MiscCost,
	      ShippingCost = _ref3.ShippingCost,
	      PriceAdjustment = _ref3.PriceAdjustment,
	      InvoiceFinalPrice = _ref3.InvoiceFinalPrice,
	      InvoiceNum = _ref3.InvoiceNum,
	      PackingNum = _ref3.PackingNum,
	      container_num = _ref3.container_num,
	      Note = _ref3.Note;
	
	  //let FinalPrice = (parseFloat(TotalPrice) || 0) + (parseFloat(HandlingCost) || 0) + (parseFloat(MiscCost) || 0) + (parseFloat(ShippingCost) || 0);
	  if (PaymentStatus) PaymentStatus = PaymentStatus.value || PaymentStatus;
	  if (WarehouseReceiveCompleted_id) {
	    var Warehouse_Receive_Line_Completed = Warehouse_Receive_Line;
	    Warehouse_Receive_Line_Completed.map(function (product) {
	      if (product['subWeights']) {
	        product['Weights'] = [];
	        product.subWeights.map(function (w) {
	          product['Weights'].push(parseFloat(w.Weight));
	        });
	      }
	    });
	    return function (dispatch) {
	      dispatch({ type: _type.REQUEST_EDITING_RECEIVE_HISTORY });
	      _axios2.default.put(_url.RECEIVE_URL + 'complete/' + WarehouseReceiveCompleted_id, {
	        PaymentStatus: PaymentStatus,
	        Warehouse_Receive_Line_Completed: Warehouse_Receive_Line_Completed,
	        HandlingCost: HandlingCost,
	        PostingDate: PostingDate,
	        InvoiceDate: InvoiceDate,
	        MiscCost: MiscCost,
	        ShippingCost: ShippingCost,
	        PriceAdjustment: PriceAdjustment,
	        InvoiceFinalPrice: InvoiceFinalPrice,
	        TotalPrice: TotalPrice,
	        FinalPrice: FinalPrice,
	        InvoiceNum: InvoiceNum,
	        PackingNum: PackingNum,
	        container_num: container_num,
	        Note: Note
	      }, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        dispatch(editReceiveHistorySuccess(response));
	        // if(isPayment === "isPayment") {
	        //   browserHistory.push('/purchasePayment'); // If editd succesfully, refresh the paymentTerm page.
	        // }
	        // else
	        // console.log("did it get here?");
	        // browserHistory.push('/inventories/receiveHistory'); // If editd succesfully, refresh the paymentTerm page.
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = _constants.DEFAULT_ERROR;
	        }
	        dispatch(editReceiveHistoryFailure(err));
	      });
	    };
	  } else {
	    return function (dispatch) {
	      dispatch({ type: _type.REQUEST_EDITING_RECEIVE_HISTORY });
	      Warehouse_Receive_Line.map(function (product) {
	        if (product['subWeights']) {
	          product['Weights'] = [];
	          product.subWeights.map(function (w) {
	            product['Weights'].push(parseFloat(w.Weight));
	          });
	        }
	        if (_root_url.isJML && product['expire_datetime']) {
	          product['expire_datetime'] = (0, _cleanDates.convertUtcDate)(product['expire_datetime']);
	        }
	      });
	      _axios2.default.put(_url.RECEIVE_URL + 'history/' + WarehouseReceive_id, {
	        PaymentStatus: PaymentStatus,
	        PostingDate: PostingDate,
	        InvoiceDate: InvoiceDate,
	        Warehouse_Receive_Line: Warehouse_Receive_Line,
	        HandlingCost: HandlingCost,
	        MiscCost: MiscCost,
	        ShippingCost: ShippingCost,
	        PriceAdjustment: PriceAdjustment,
	        InvoiceFinalPrice: InvoiceFinalPrice,
	        TotalPrice: TotalPrice,
	        FinalPrice: FinalPrice,
	        InvoiceNum: InvoiceNum,
	        PackingNum: PackingNum,
	        container_num: container_num,
	        Note: Note
	      }, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        dispatch(editReceiveHistorySuccess(response));
	        // if(isPayment === "isPayment") {
	        //   browserHistory.push('/purchasePayment'); // If editd succesfully, refresh the paymentTerm page.
	        // }
	        // else
	        // console.log("did it get here?");
	        // browserHistory.push('/inventories/receiveHistory');
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = _constants.DEFAULT_ERROR;
	        }
	        dispatch(editReceiveHistoryFailure(err));
	      });
	    };
	  }
	}
	
	function editReceiveHistorySuccess(payload) {
	  return {
	    type: _type.EDIT_RECEIVE_HISTORY_SUCCESS,
	    payload: payload
	  };
	}
	
	function editReceiveHistoryFailure(error) {
	  return {
	    type: _type.EDIT_RECEIVE_HISTORY_FAILURE,
	    payload: error
	  };
	}
	
	function resetEditReceiveHistory() {
	  return {
	    type: _type.RESET_EDIT_RECEIVE_HISTORY
	  };
	}
	
	function voidReceiving(WarehouseReceiveId) {
	  return function (dispatch) {
	    dispatch({ type: _type.DELETE_RECEIVE });
	    return _axios2.default.delete(_url.RECEIVE_URL + 'history/' + WarehouseReceiveId, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(voidReceivingFinished(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(voidReceivingFinished(err));
	    });
	  };
	}
	
	function voidReceivingFinished(response) {
	  return {
	    type: _type.DELETE_RECEIVE_FINISHED,
	    payload: response
	  };
	}
	
	function resetDeleteStatus() {
	  return {
	    type: _type.RESET_DELETE_STATUS
	  };
	}
	
	function attachFile(WarehouseReceiveNum, files) {
	  return function (dispatch) {
	    dispatch({ type: _type.ATTACH_FILES });
	    var data = new FormData();
	    data.append('file', files[0]);
	    data.append('WarehouseReceiveNum', WarehouseReceiveNum);
	
	    return _axios2.default.post(_url.UPLOAD_URL + 'warehouse/', data, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(attachFileSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(attachFileFailure(err));
	    });
	  };
	}
	
	function attachFileSuccess() {
	  return {
	    type: _type.ATTACH_FILES_SUCCESS
	  };
	}
	
	function attachFileFailure(error) {
	  return {
	    type: _type.ATTACH_FILES_FAILURE,
	    payload: error
	  };
	}
	
	function fetchAttachedFile(WarehouseReceiveNum, Name) {
	  return function (dispatch) {
	    dispatch({ type: _type.FETCH_ATTACHED_FILES });
	    return _axios2.default.post(_url.UPLOAD_URL + 'download/warehouse/', {
	      WarehouseReceiveNum: WarehouseReceiveNum,
	      Name: Name
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchAttachedFileSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchAttachedFileFailure(err));
	    });
	  };
	}
	
	function fetchAttachedFileSuccess(files) {
	  return {
	    type: _type.FETCH_ATTACHED_FILES_SUCCESS,
	    payload: files
	  };
	}
	
	function fetchAttachedFileFailure(error) {
	  return {
	    type: _type.FETCH_ATTACHED_FILES_FAILURE,
	    payload: error
	  };
	}
	
	function deleteAttachedFile(WarehouseReceiveNum, Name) {
	  return function (dispatch) {
	    dispatch({ type: _type.DELETE_ATTACHED_FILES });
	    return _axios2.default.post(_url.UPLOAD_URL + 'delete/warehouse/', {
	      WarehouseReceiveNum: WarehouseReceiveNum,
	      Name: Name
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(deleteAttachedFileSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(deleteAttachedFileFailure(err));
	    });
	  };
	}
	
	function deleteAttachedFileSuccess(files) {
	  return {
	    type: _type.DELETE_ATTACHED_FILES_SUCCESS,
	    payload: files
	  };
	}
	
	function deleteAttachedFileFailure(error) {
	  return {
	    type: _type.DELETE_ATTACHED_FILES_FAILURE,
	    payload: error
	  };
	}
	
	function resetAttachedFile() {
	  return {
	    type: _type.RESET_ATTACHED_FILES
	  };
	}
	
	function setPostingDate(date, Form) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)(Form, 'PostingDate', date));
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchReceives, 'fetchReceives', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestReceives, 'requestReceives', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchReceivesSuccess, 'fetchReceivesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchReceivesFailure, 'fetchReceivesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(selectReceive, 'selectReceive', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetCurrentReceive, 'resetCurrentReceive', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(createReceive, 'createReceive', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(createReceiveSuccess, 'createReceiveSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(createReceiveFailure, 'createReceiveFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetCreateReceive, 'resetCreateReceive', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(editReceive, 'editReceive', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(editReceiveSuccess, 'editReceiveSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(editReceiveFailure, 'editReceiveFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchReceiveDetail, 'fetchReceiveDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestReceiveDetail, 'requestReceiveDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchReceiveDetailSuccess, 'fetchReceiveDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchReceiveDetailFailure, 'fetchReceiveDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(convertPOToReceive, 'convertPOToReceive', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(completePurchaseOrder, 'completePurchaseOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(completePurchaseOrderSuccess, 'completePurchaseOrderSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(completePurchaseOrderFailure, 'completePurchaseOrderFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchReceiveHistory, 'fetchReceiveHistory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchReceiveHistoryByDate, 'fetchReceiveHistoryByDate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchReceiveHistorySuccess, 'fetchReceiveHistorySuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchReceiveHistoryFailure, 'fetchReceiveHistoryFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(selectReceiveHistory, 'selectReceiveHistory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetCurrentReceiveHistory, 'resetCurrentReceiveHistory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchReceiveHistoryDetail, 'fetchReceiveHistoryDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchReceiveHistoryDetailSuccess, 'fetchReceiveHistoryDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchReceiveHistoryDetailFailure, 'fetchReceiveHistoryDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchAllReceiveHistoryDetail, 'fetchAllReceiveHistoryDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchAllReceiveHistoryDetailSuccess, 'fetchAllReceiveHistoryDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchAllReceiveHistoryDetailFailure, 'fetchAllReceiveHistoryDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchReceiveHistoryDetailRecord, 'fetchReceiveHistoryDetailRecord', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchReceiveHistoryDetailRecordSuccess, 'fetchReceiveHistoryDetailRecordSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchReceiveHistoryDetailRecordFailure, 'fetchReceiveHistoryDetailRecordFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(editReceiveHistory, 'editReceiveHistory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(editReceiveHistorySuccess, 'editReceiveHistorySuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(editReceiveHistoryFailure, 'editReceiveHistoryFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetEditReceiveHistory, 'resetEditReceiveHistory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(voidReceiving, 'voidReceiving', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(voidReceivingFinished, 'voidReceivingFinished', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetDeleteStatus, 'resetDeleteStatus', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(attachFile, 'attachFile', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(attachFileSuccess, 'attachFileSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(attachFileFailure, 'attachFileFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchAttachedFile, 'fetchAttachedFile', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchAttachedFileSuccess, 'fetchAttachedFileSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchAttachedFileFailure, 'fetchAttachedFileFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteAttachedFile, 'deleteAttachedFile', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteAttachedFileSuccess, 'deleteAttachedFileSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteAttachedFileFailure, 'deleteAttachedFileFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetAttachedFile, 'resetAttachedFile', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	
	  __REACT_HOT_LOADER__.register(setPostingDate, 'setPostingDate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/receive_actions.js');
	}();

	;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.priceLevelPercentageFieldsMap = exports.priceLevelFieldsMap = exports.calculatePriceLevelSalesMargin = exports.calculatePriceLevelSalesMarginNormal = exports.calculatePriceLevelSalesMarginUnit = exports.calculatePriceLevel = exports.calculatePriceLevelNormal = exports.calculatePriceLevelUnit = exports.calculatePricePercentageSalesMargin = exports.calculatePricePercentage = exports.getRoundingFunc = exports.normalizeFourDecimals = exports.roundUp = undefined;
	exports.roundTo = roundTo;
	exports.roundToDecimals = roundToDecimals;
	exports.decimalPlaces = decimalPlaces;
	exports.isNumber = isNumber;
	exports.calculateTax = calculateTax;
	exports.calculateSavingAmount = calculateSavingAmount;
	exports.calculateSavings = calculateSavings;
	
	var _map = __webpack_require__(55);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _invert = __webpack_require__(790);
	
	var _invert2 = _interopRequireDefault(_invert);
	
	var _isFinite = __webpack_require__(791);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	var _RootUrl = __webpack_require__(9);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isEcity = _RootUrl.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || _RootUrl.ROOT_API_URL === 'https://ctstage-scm.truckxi.com/api/';
	var isHMM = _RootUrl.ROOT_API_URL === 'https://hmm-scm.truckxi.com/api/';
	var isMyumyu = _RootUrl.ROOT_API_URL === 'https://mmstage-scm.truckxi.com/api/' || _RootUrl.ROOT_API_URL === 'https://myumyu-scm.truckxi.com/api/';
	var isAFG = _RootUrl.ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || _RootUrl.ROOT_URL === 'https://afg-scm.truckxi.com/api/';
	var isWecom = _RootUrl.ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/' || _RootUrl.ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/';
	var isAFM = _RootUrl.ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || _RootUrl.ROOT_URL === 'https://afm-scm.truckxi.com/api/';
	var isUSPride = _RootUrl.ROOT_API_URL === 'https://uspride-scm.truckxi.com/api/' || _RootUrl.ROOT_URL === 'https://uspride-scm.truckxi.com/api/';
	var isATL = _RootUrl.ROOT_API_URL === 'https://alton-scm.truckxi.com/api/' || _RootUrl.ROOT_URL === 'https://alton-scm.truckxi.com/api/';
	var isRS = _RootUrl.ROOT_API_URL === 'https://redstone-scm.truckxi.com/api/' || _RootUrl.ROOT_URL === 'https://redstone-scm.truckxi.com/api/';
	
	function roundTo(n, digits) {
	  if (digits === undefined) {
	    digits = 0;
	  }
	
	  var multiplicator = Math.pow(10, digits);
	  n = parseFloat((parseFloat(n) * multiplicator).toFixed(11));
	  var test = Math.round(n) / multiplicator;
	  return +test.toFixed(2);
	}
	
	function roundToDecimals(n) {
	  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	
	  var multiplicator = Math.pow(10, decimals);
	  n = parseFloat((parseFloat(n) * multiplicator).toFixed(11));
	  var test = Math.round(n) / multiplicator;
	  return +test.toFixed(decimals);
	}
	
	var roundUp = exports.roundUp = function roundUp(price) {
	  var refPrice = parseFloat(price);
	  var val = parseInt(refPrice * 10, 10);
	  val /= 10;
	  var left = +(refPrice - val).toFixed(8);
	  var rounded = 0;
	  if (left === 0) {
	    rounded = 0;
	  } else if (left > 0 && left <= 0.05) {
	    rounded = 0.05;
	  } else if (left > 0.05 && left <= 0.09) {
	    rounded = 0.09;
	  } else {
	    rounded = 0.1;
	  }
	  rounded += val;
	  rounded = rounded.toFixed(2);
	  return rounded;
	};
	
	var normalizeFourDecimals = exports.normalizeFourDecimals = function normalizeFourDecimals(value) {
	  if (value === null || value === '' || value === undefined) {
	    return '';
	  }
	  var v = value.toString().replace(/[^\d.]/g, '');
	  v = v.slice(0, v.indexOf('.') >= 0 ? v.indexOf('.') + 5 : undefined);
	  return v;
	};
	
	var CALCULATION_TYPE = {
	  NORMAL: 'normal',
	  UNIT: 'unit'
	};
	
	var getRoundingFunc = exports.getRoundingFunc = function getRoundingFunc() {
	  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : CALCULATION_TYPE.NORMAL;
	
	  if (type === CALCULATION_TYPE.UNIT) {
	    return roundUp;
	  }
	  return roundTo;
	};
	
	function decimalPlaces(num) {
	  var match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
	  if (!match) {
	    return 0;
	  }
	  return Math.max(0,
	  // Number of digits right of decimal point.
	  (match[1] ? match[1].length : 0) - (
	  // Adjust for scientific notation.
	  match[2] ? +match[2] : 0));
	}
	
	function isNumber(num) {
	  return !Number.isNaN(parseFloat(num)) && Number.isFinite(parseFloat(num));
	}
	
	/**
	 *
	 * @param {Array} lines // lines of products
	 * @param {Number} discount // ex: 15
	 * @param {Number} taxRate // ex: 0.03
	 */
	function calculateTax(lines) {
	  var discount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var taxRate = arguments[2];
	
	  var taxableTotal = 0;
	  if (lines && lines.length > 0) {
	    (0, _map2.default)(lines, function (line) {
	      if (line.IsTaxable) {
	        var totalPriceWithSavings = 0;
	        if (isHMM) {
	          totalPriceWithSavings = parseFloat(line.Quantity * line.UnitPrice * line.PackageSize_1) * ((100 - parseFloat(discount)) / 100);
	        } else {
	          totalPriceWithSavings = parseFloat(line.TotalPrice) * ((100 - parseFloat(discount)) / 100);
	        }
	        taxableTotal += roundTo(totalPriceWithSavings, 2);
	      }
	    });
	  }
	  return roundTo(taxableTotal * taxRate, 2).toFixed(2);
	}
	
	/**
	 *
	 * @param {Number} totalPrice
	 * @param {Number} discount
	 */
	function calculateSavingAmount(totalPrice, discount) {
	  return roundTo(parseFloat(totalPrice) * (parseFloat(discount) / 100), 2);
	}
	
	/**
	 *
	 * @param {Number} discount
	 * @param {Number} savings
	 * @param {Number} totalPrice
	 * @param {Number} totalCRV
	 * @param {Number} totalTax
	 */
	function calculateSavings(discount, savings, totalPrice, totalCRV, totalTax, delivery) {
	  if (isMyumyu || isAFG || _root_url.isRivera || isWecom || isAFM || _root_url.isElegant) {
	    if (discount > 0) {
	      return (roundTo(roundTo(parseFloat(totalPrice), 2) - calculateSavingAmount(totalPrice, discount) + roundTo(parseFloat(totalCRV), 2) + roundTo(parseFloat(totalTax), 2), 2) + roundTo(parseFloat(delivery), 2)).toFixed(2);
	    }
	    return (roundTo(roundTo(parseFloat(totalPrice), 2) - roundTo(parseFloat(savings), 2), 2) + roundTo(parseFloat(totalCRV), 2) + roundTo(parseFloat(totalTax), 2) + roundTo(parseFloat(delivery), 2)).toFixed(2);
	  }
	  if (discount > 0) {
	    return roundTo(roundTo(parseFloat(totalPrice), 2) - calculateSavingAmount(totalPrice, discount) + roundTo(parseFloat(totalCRV), 2) + roundTo(parseFloat(totalTax), 2), 2).toFixed(2);
	  }
	  return (roundTo(roundTo(parseFloat(totalPrice), 2) - roundTo(parseFloat(savings), 2), 2) + roundTo(parseFloat(totalCRV), 2) + roundTo(parseFloat(totalTax), 2)).toFixed(2);
	}
	
	/**
	 * Calculates price percentage for `Cost Margin` percentage
	 * Formula: (priceLvl $ - refPrice / refPrice) * 100%
	 * @param {Number} price product priceLvl price
	 * @param {Number} refPrice referencing price for calculation
	 * @returns Price percentage by `Cost Margin`
	 */
	var calculatePricePercentage = exports.calculatePricePercentage = function calculatePricePercentage(price, refPrice, arrivalPrice) {
	  var percentage = roundToDecimals((parseFloat(price) || 0) / (parseFloat(refPrice) || 0) * 100 - 100, 4);
	  if (isEcity) {
	    percentage = parseFloat(price - arrivalPrice) / parseFloat(price) * 100;
	  }
	  if (isUSPride || isATL || isRS) {
	    percentage = (1 - arrivalPrice / price) * 100;
	  }
	  return (0, _isFinite2.default)(percentage) ? percentage.toFixed(4) : 0;
	};
	
	/**
	 * Calculates price percentage for `Sales Margin` percentage
	 * Formula: (priceLvl $ - refPrice / priceLvl $) * 100%
	 * @param {Number} price product priceLvl price
	 * @param {Number} refPrice referencing price for calculation
	 * @returns Price percentage by `Sales Margin`
	 */
	var calculatePricePercentageSalesMargin = exports.calculatePricePercentageSalesMargin = function calculatePricePercentageSalesMargin(price, refPrice) {
	  var percentage = roundTo(((parseFloat(price) || 0) - (parseFloat(refPrice) || 0)) / (parseFloat(price) || 0) * 100, 3);
	  return (0, _isFinite2.default)(percentage) ? percentage.toFixed(2) : 0;
	};
	
	/**
	 * Calculates priceLvl price with rounding 0.0 ~ 0.5 -> 0.5, 0.6 ~ 0.9 -> 0.9
	 * @param {Number} pricePercentage product price level percentage
	 * @param {Number} refPrice product reference price
	 */
	var calculatePriceLevelUnit = exports.calculatePriceLevelUnit = function calculatePriceLevelUnit(pricePercentage, refPrice) {
	  return roundTo(roundUp(((parseFloat(pricePercentage) || 0) + 100) * (parseFloat(refPrice) || 0) * 0.01), 3).toFixed(2);
	};
	
	/**
	 * Calculates priceLvl price
	 * @param {Number} pricePercentage product price level percentage
	 * @param {Number} refPrice product reference price
	 */
	
	var calculatePriceLevelNormal = exports.calculatePriceLevelNormal = function calculatePriceLevelNormal(pricePercentage, refPrice) {
	  var ArrivalPrice = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	  // if(isHMM) {
	  //   const result = parseFloat((parseFloat(ArrivalPrice) / ( 1 - parseFloat(pricePercentage)/100 )).toFixed(2));
	  //   return result;
	  // }
	  if (isEcity || isUSPride || isATL || isRS) {
	    var result = ArrivalPrice / (1 - pricePercentage / 100);
	    return roundToDecimals(result);
	  }
	  return roundToDecimals((((parseFloat(pricePercentage) || 0) + 100) * (parseFloat(refPrice) || 0) * 0.01).toFixed(4), isHMM ? 2 : 4);
	};
	
	/**
	 * Gives corresponding calculation function
	 * @param {String} type of CALCULATION_TYPE
	 * @returns calculate price level function of type
	 */
	var calculatePriceLevel = exports.calculatePriceLevel = function calculatePriceLevel(type) {
	  if (type === CALCULATION_TYPE.UNIT) {
	    return calculatePriceLevelUnit;
	  }
	  return calculatePriceLevelNormal;
	};
	
	/**
	 * Calculates priceLvl price with rounding 0.0 ~ 0.5 -> 0.5, 0.6 ~ 0.9 -> 0.9
	 * @param {Number} pricePercentage product price level percentage
	 * @param {Number} refPrice product reference price
	 */
	var calculatePriceLevelSalesMarginUnit = exports.calculatePriceLevelSalesMarginUnit = function calculatePriceLevelSalesMarginUnit(pricePercentage, refPrice) {
	  var price = roundTo(roundUp((parseFloat(refPrice) || 0) / ((100 - (parseFloat(pricePercentage) || 0)) / 100)), 3);
	  return (0, _isFinite2.default)(price) ? price.toFixed(2) : 0;
	};
	
	/**
	 * Calculates priceLvl price
	 * @param {Number} pricePercentage product price level percentage
	 * @param {Number} refPrice product reference price
	 */
	var calculatePriceLevelSalesMarginNormal = exports.calculatePriceLevelSalesMarginNormal = function calculatePriceLevelSalesMarginNormal(pricePercentage, refPrice) {
	  var price = roundTo(((parseFloat(refPrice) || 0) / ((100 - (parseFloat(pricePercentage) || 0)) / 100)).toFixed(2), 3);
	  return (0, _isFinite2.default)(price) ? price.toFixed(2) : 0;
	};
	
	/**
	 * Gives corresponding calculation function
	 * @param {String} type of CALCULATION_TYPE
	 * @returns calculate price level function of type
	 */
	var calculatePriceLevelSalesMargin = exports.calculatePriceLevelSalesMargin = function calculatePriceLevelSalesMargin(type) {
	  if (type === CALCULATION_TYPE.UNIT) {
	    return calculatePriceLevelSalesMarginUnit;
	  }
	  return calculatePriceLevelSalesMarginNormal;
	};
	
	/**
	 * Maps price level field name to price level percentage field name
	 */
	var priceLevelFieldsMap = exports.priceLevelFieldsMap = {
	  PriceLv1: 'P1Percentage',
	  PriceLv2: 'P2Percentage',
	  PriceLv3: 'P3Percentage',
	  PriceLv4: 'P4Percentage',
	  PriceLv5: 'P5Percentage'
	};
	
	/**
	 * Inverted map of priceLevelFieldsMap
	 * Maps price level percentage field name to price level field name
	 */
	var priceLevelPercentageFieldsMap = exports.priceLevelPercentageFieldsMap = (0, _invert2.default)(priceLevelFieldsMap);
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(roundTo, 'roundTo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(roundToDecimals, 'roundToDecimals', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(roundUp, 'roundUp', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(normalizeFourDecimals, 'normalizeFourDecimals', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(getRoundingFunc, 'getRoundingFunc', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(decimalPlaces, 'decimalPlaces', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(isNumber, 'isNumber', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(calculateTax, 'calculateTax', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(calculateSavingAmount, 'calculateSavingAmount', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(calculateSavings, 'calculateSavings', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(calculatePricePercentage, 'calculatePricePercentage', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(calculatePricePercentageSalesMargin, 'calculatePricePercentageSalesMargin', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(calculatePriceLevelUnit, 'calculatePriceLevelUnit', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(calculatePriceLevelNormal, 'calculatePriceLevelNormal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(calculatePriceLevel, 'calculatePriceLevel', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(calculatePriceLevelSalesMarginUnit, 'calculatePriceLevelSalesMarginUnit', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(calculatePriceLevelSalesMarginNormal, 'calculatePriceLevelSalesMarginNormal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(calculatePriceLevelSalesMargin, 'calculatePriceLevelSalesMargin', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(priceLevelFieldsMap, 'priceLevelFieldsMap', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(priceLevelPercentageFieldsMap, 'priceLevelPercentageFieldsMap', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(isHMM, 'isHMM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(isMyumyu, 'isMyumyu', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(isAFG, 'isAFG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(isWecom, 'isWecom', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(isAFM, 'isAFM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(isUSPride, 'isUSPride', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(isATL, 'isATL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(isRS, 'isRS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	
	  __REACT_HOT_LOADER__.register(CALCULATION_TYPE, 'CALCULATION_TYPE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/NumberUtil.js');
	}();

	;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExcelColumn = _reactDataGrid.shapes.ExcelColumn;
	
	var FilterByStart = function (_React$Component) {
	  _inherits(FilterByStart, _React$Component);
	
	  function FilterByStart(props) {
	    _classCallCheck(this, FilterByStart);
	
	    var _this = _possibleConstructorReturn(this, (FilterByStart.__proto__ || Object.getPrototypeOf(FilterByStart)).call(this, props));
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.inputRef = null;
	    return _this;
	  }
	
	  _createClass(FilterByStart, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var getValidFilterValues = this.props.getValidFilterValues;
	
	      if (_lodash2.default.isFunction(getValidFilterValues)) {
	        this.inputRef.value = getValidFilterValues(this.props.column.key);
	      }
	    }
	  }, {
	    key: 'filterValues',
	    value: function filterValues(row, columnFilter, columnKey) {
	      if (columnFilter.filterTerm == null) {
	        return true;
	      }
	      var result = false;
	      // implement default filter logic
	      var value = row[columnKey];
	      var rule = columnFilter.filterTerm;
	      if (value && value.indexOf(rule) === 0) {
	        result = true;
	      }
	      return result;
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(e) {
	      var value = e.target.value;
	      this.props.onChange({ filterTerm: value, column: this.props.column, rawValue: value, filterValues: this.filterValues });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var inputKey = 'header-filter-' + this.props.column.key;
	      var columnStyle = {
	        float: 'left',
	        marginRight: 0,
	        marginTop: '5px',
	        maxWidth: '100%'
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: columnStyle },
	        _react2.default.createElement('input', { ref: function ref(inputRef) {
	            return _this2.inputRef = inputRef;
	          }, key: inputKey, type: 'text', placeholder: 'e.g. 01', className: 'form-control input-sm byStart', onChange: this.handleChange })
	      );
	    }
	  }]);
	
	  return FilterByStart;
	}(_react2.default.Component);
	
	FilterByStart.propTypes = {
	  onChange: _react2.default.PropTypes.func.isRequired,
	  column: _react2.default.PropTypes.shape(ExcelColumn)
	};
	
	var _default = FilterByStart;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ExcelColumn, 'ExcelColumn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/filterByStart.jsx');
	
	  __REACT_HOT_LOADER__.register(FilterByStart, 'FilterByStart', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/filterByStart.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/filterByStart.jsx');
	}();

	;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(746);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(101)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../css-loader/index.js!../../../less-loader/index.js!./react-widgets.less", function() {
				var newContent = require("!!../../../css-loader/index.js!../../../less-loader/index.js!./react-widgets.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.voidSelectedPosHoldsOrder = undefined;
	exports.fetchPosHoldsOrdersDetail = fetchPosHoldsOrdersDetail;
	exports.fetchPosHoldsOrders = fetchPosHoldsOrders;
	exports.printPosHolds = printPosHolds;
	exports.setField = setField;
	exports.fetchRegisters = fetchRegisters;
	exports.fetchRegistersSuccess = fetchRegistersSuccess;
	exports.fetchRegistersFailure = fetchRegistersFailure;
	exports.fetchAllRegisterSessions = fetchAllRegisterSessions;
	exports.fetchRegisterSessions = fetchRegisterSessions;
	exports.fetchRegisterSessionsByDate = fetchRegisterSessionsByDate;
	exports.fetchRegisterSessionsSuccess = fetchRegisterSessionsSuccess;
	exports.fetchRegisterSessionsFailure = fetchRegisterSessionsFailure;
	exports.verifyRegisters = verifyRegisters;
	exports.fetchPosOrders = fetchPosOrders;
	exports.requestPosOrders = requestPosOrders;
	exports.fetchPosOrdersSuccess = fetchPosOrdersSuccess;
	exports.fetchPosOrdersFailure = fetchPosOrdersFailure;
	exports.fetchPosOrdersByDate = fetchPosOrdersByDate;
	exports.fetchPosOrderDetail = fetchPosOrderDetail;
	exports.requestPosOrderDetail = requestPosOrderDetail;
	exports.fetchPosOrderDetailSuccess = fetchPosOrderDetailSuccess;
	exports.fetchPosOrderDetailFailure = fetchPosOrderDetailFailure;
	exports.fetchPosOrdersByFilter = fetchPosOrdersByFilter;
	exports.voidPosOrder = voidPosOrder;
	exports.voidPosOrderSuccess = voidPosOrderSuccess;
	exports.voidPosOrderFailure = voidPosOrderFailure;
	exports.editPosPayment = editPosPayment;
	exports.requestPosCredits = requestPosCredits;
	exports.fetchPosCreditsSuccess = fetchPosCreditsSuccess;
	exports.fetchPosCreditsFailure = fetchPosCreditsFailure;
	exports.fetchPosCredits = fetchPosCredits;
	exports.fetchPosCreditsByDate = fetchPosCreditsByDate;
	exports.fetchPosCreditsByFilter = fetchPosCreditsByFilter;
	exports.requestPosCreditDetail = requestPosCreditDetail;
	exports.fetchPosCreditDetailSuccess = fetchPosCreditDetailSuccess;
	exports.fetchPosCreditDetailFailure = fetchPosCreditDetailFailure;
	exports.fetchPosCreditDetail = fetchPosCreditDetail;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reduxForm = __webpack_require__(3);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchPosHoldsOrderDetailSuccess(data) {
	  return {
	    type: _type.FETCH_POS_HOLDS_DETAILS_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchPosHoldsOrdersDetail(id) {
	  return function (dispatch) {
	    _axios2.default.get('' + _url.POS_HOLDS_URL + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (res) {
	      dispatch(fetchPosHoldsOrderDetailSuccess(res.data));
	    }).catch(function (err) {
	      console.log('err', err);
	    });
	  };
	}
	
	function fetchposHoldsSuccess(data) {
	  return {
	    type: _type.FETCH_POS_HOLDS_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchPosHoldsOrders(_ref) {
	  var status = _ref.status,
	      FromDate = _ref.FromDate,
	      ToDate = _ref.ToDate,
	      days = _ref.days;
	
	  return function (dispatch) {
	    dispatch(fetchposHoldsSuccess([]));
	    var dates = (0, _cleanDates.toFromDates)(days, FromDate, ToDate);
	    _axios2.default.get(_url.POS_HOLDS_URL + '?Date__gte=' + dates.fromDate + '&Date__lte=' + dates.toDate, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (res) {
	      dispatch(fetchposHoldsSuccess(res.data));
	    }).catch(function (err) {
	      console.log('err fetching post holds orders', err);
	    });
	  };
	}
	
	var voidSelectedPosHoldsOrder = exports.voidSelectedPosHoldsOrder = function voidSelectedPosHoldsOrder(id, callback) {
	  return function (dispatch) {
	    _axios2.default.delete('' + _url.POS_HOLDS_VOID + id + '/', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (res) {
	      callback();
	    }).catch(function (err) {
	      alert('err deleting pos holds with id', id);
	    });
	  };
	};
	
	function printPosHolds(id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_POS_HOLDS_PDF });
	    return _axios2.default.get(_url.POS_HOLDS_PRINT + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      responseType: 'blob'
	    }).then(function (response) {
	      dispatch({
	        type: _type.FETCH_POS_HOLDS_PDF_SUCCESS,
	        payload: response
	      });
	    }, function (err) {
	      console.log('ERROR IN response', err);
	    });
	  };
	}
	
	function setField(fieldName, value) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)('posReport', fieldName, value));
	  };
	}
	
	function fetchRegisters(FromDate, ToDate) {
	  var dates = (0, _cleanDates.toFromDates)(-1, FromDate, ToDate);
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_REGISTERS });
	    return _axios2.default.get(_url.REGISTER_URL + '?CashInTime__gte=' + dates.fromDate + '&CashInTime__lte=' + dates.toDate, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchRegistersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchRegistersFailure(err));
	    });
	  };
	}
	
	function fetchRegistersSuccess(registers) {
	  return {
	    type: _type.FETCH_REGISTERS_SUCCESS,
	    payload: registers
	  };
	}
	
	function fetchRegistersFailure(error) {
	  return {
	    type: _type.FETCH_REGISTERS_FAILRE,
	    payload: error
	  };
	}
	
	function fetchAllRegisterSessions(fromDate, toDate) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_REGISTER_SESSIONS });
	    var dates = (0, _cleanDates.toFromDates)(-1, fromDate, toDate);
	    return _axios2.default.get(_url.SESSION_URL + '?CashInTime__gte=' + dates.fromDate + '&CashInTime__lte=' + dates.toDate, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchRegisterSessionsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchRegisterSessionsFailure(err));
	    });
	  };
	}
	
	function fetchRegisterSessions(registerID) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_REGISTER_SESSIONS });
	    var date = new Date();
	    var formattedDate = date.getFullYear() + '-';
	    formattedDate += date.getMonth() + 1 + '-';
	    if (date.getDate() < 10) {
	      formattedDate += '0' + date.getDate();
	    } else {
	      formattedDate += date.getDate();
	    }
	    var dates = (0, _cleanDates.toFromDates)(-1, formattedDate, formattedDate);
	    return _axios2.default.get(_url.REGISTER_URL + registerID + '?CashInTime__gte=' + dates.fromDate + '&CashInTime__lte=' + dates.toDate, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchRegisterSessionsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchRegisterSessionsFailure(err));
	    });
	  };
	}
	
	function fetchRegisterSessionsByDate(registerID, fromDate, toDate) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_REGISTER_SESSIONS_DATE });
	    var dates = (0, _cleanDates.toFromDates)(-1, fromDate, toDate);
	    return _axios2.default.get(_url.REGISTER_URL + registerID + '?CashInTime__gte=' + dates.fromDate + '&CashInTime__lte=' + dates.toDate, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchRegisterSessionsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchRegisterSessionsFailure(err));
	    });
	  };
	}
	
	function fetchRegisterSessionsSuccess(sessions) {
	  return {
	    type: _type.FETCH_REGISTER_SESSIONS_SUCCESS,
	    payload: sessions
	  };
	}
	
	function fetchRegisterSessionsFailure(error) {
	  return {
	    type: _type.FETCH_REGISTER_SESSIONS_FAILURE,
	    payload: error
	  };
	}
	
	function verifyRegisters(session_id, fields) {
	  return function (dispatch) {
	    dispatch({ type: _type.VERIFY_REGISTER });
	    var CountedCash = fields.CountedCash,
	        CountedStoreCredit = fields.CountedStoreCredit,
	        CountedCard = fields.CountedCard,
	        CountedCheck = fields.CountedCheck,
	        TotalCounted = fields.TotalCounted,
	        Balance = fields.Balance,
	        NumCardTransaction = fields.NumCardTransaction,
	        NumCheck = fields.NumCheck;
	
	    return _axios2.default.post(_url.VERIFY_URL + session_id + '/verify', {
	      CountedCash: CountedCash,
	      CountedStoreCredit: CountedStoreCredit,
	      CountedCard: CountedCard,
	      CountedCheck: CountedCheck,
	      TotalCounted: TotalCounted,
	      Balance: Balance,
	      NumCardTransaction: NumCardTransaction,
	      NumCheck: NumCheck
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchRegisterSessionsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchRegisterSessionsFailure(err));
	    });
	  };
	}
	
	function fetchPosOrders() {
	  return function (dispatch) {
	    dispatch(requestPosOrders());
	    return _axios2.default.get(_url.POS_ORDERS_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPosOrdersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPosOrdersFailure(err));
	    });
	  };
	}
	
	function requestPosOrders() {
	  return {
	    type: _type.REQUEST_POS_ORDERS
	  };
	}
	
	function fetchPosOrdersSuccess(salesOrders) {
	  return {
	    type: _type.FETCH_POS_ORDERS_SUCCESS,
	    payload: salesOrders
	  };
	}
	
	function fetchPosOrdersFailure(error) {
	  return {
	    type: _type.FETCH_POS_ORDERS_FAILURE,
	    payload: error
	  };
	}
	
	function fetchPosOrdersByDate(postingDateGT, postingDateLT, days) {
	  var dates = (0, _cleanDates.toFromDates)(days, postingDateGT, postingDateLT);
	  return function (dispatch) {
	    dispatch(requestPosOrders());
	    return _axios2.default.get(_url.POS_ORDERS_URL + "search/?OrderDate__gte=" + dates.fromDate + "&OrderDate__lte=" + dates.toDate, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPosOrdersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPosOrdersFailure(err));
	    });
	  };
	}
	
	function fetchPosOrderDetail(Order_id) {
	  return function (dispatch) {
	    dispatch(requestPosOrderDetail());
	    return _axios2.default.get(_url.POS_ORDERS_URL + Order_id + '/', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPosOrderDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPosOrderDetailFailure(err));
	    });
	  };
	}
	
	function requestPosOrderDetail() {
	  return {
	    type: _type.REQUEST_POS_ORDER_DETAIL
	  };
	}
	
	function fetchPosOrderDetailSuccess(salesOrderDetail) {
	  salesOrderDetail = salesOrderDetail.data;
	  // The date data fetched is in the form of string, which needs to be modified into Date type
	  if (salesOrderDetail.OrderDate) salesOrderDetail.OrderDate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.OrderDate);
	  if (salesOrderDetail.ETADate) salesOrderDetail.ETADate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.ETADate);
	  if (salesOrderDetail.ReceivedDate) salesOrderDetail.ReceivedDate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.ReceivedDate);
	  if (salesOrderDetail.DispatchDate) salesOrderDetail.DispatchDate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.DispatchDate);
	  return {
	    type: _type.FETCH_POS_ORDER_DETAIL_SUCCESS,
	    payload: salesOrderDetail
	  };
	}
	
	function fetchPosOrderDetailFailure(error) {
	  return {
	    type: _type.FETCH_POS_ORDER_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function fetchPosOrdersByFilter(postingDateGT, postingDateLT, days, status, customer, type) {
	  var SaleStatus = status && status !== 'all' ? '&SaleStatus=' + status : '';
	  var dates = (0, _cleanDates.toFromDates)(days, postingDateGT, postingDateLT);
	  if (customer) {
	    customer = '&Customer__Customer_id=' + customer;
	  } else {
	    customer = '';
	  }
	  if (!type) {
	    type = '';
	  }
	
	  return function (dispatch) {
	    dispatch(requestPosOrders());
	    return _axios2.default.get(_url.POS_ORDERS_URL + "?Date__gte=" + dates.fromDate + "&Date__lte=" + dates.toDate + SaleStatus + customer + type, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPosOrdersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPosOrdersFailure(err));
	    });
	  };
	}
	
	function voidPosOrder(Order_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_VOID_POS_ORDER });
	    _axios2.default.delete(_url.POS_ORDERS_URL + Order_id + '/', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(voidPosOrderSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(voidPosOrderFailure(err));
	    });
	  };
	}
	
	function voidPosOrderSuccess() {
	  return {
	    type: _type.VOID_POS_ORDER_SUCCESS
	  };
	}
	
	function voidPosOrderFailure(err) {
	  return {
	    type: _type.VOID_POS_ORDER_FAILURE,
	    payload: err
	  };
	}
	
	function editPosPaymentSuccess(response) {
	  return function (dispatch) {
	    return new Promise(function (resolve) {
	      dispatch({
	        type: _type.EDIT_POS_PAYMENT_SUCCESS,
	        payload: response
	      });
	      resolve();
	    });
	  };
	}
	
	function editPosPaymentFailure(error) {
	  return {
	    type: _type.EDIT_POS_PAYMENT_FAILURE,
	    payload: error
	  };
	}
	
	function editPosPayment(posOrderID, data) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EDIT_POS_PAYMENT });
	    (0, _axios2.default)({
	      method: 'put',
	      data: data,
	      url: '' + _url.POS_ORDERS_URL + posOrderID + '/',
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editPosPaymentSuccess(response)).then(function () {
	        dispatch(fetchPosOrderDetail(posOrderID));
	      });
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editPosPaymentFailure(err));
	    });
	  };
	}
	
	// POS Credit action
	function requestPosCredits() {
	  return {
	    type: _type.REQUEST_POS_CREDITS
	  };
	}
	
	function fetchPosCreditsSuccess(salesOrders) {
	  return {
	    type: _type.FETCH_POS_CREDITS_SUCCESS,
	    payload: salesOrders
	  };
	}
	
	function fetchPosCreditsFailure(error) {
	  return {
	    type: _type.FETCH_POS_CREDITS_FAILURE,
	    payload: error
	  };
	}
	
	function fetchPosCredits() {
	  var token = localStorage.getItem('token');
	  return function (dispatch) {
	    dispatch(requestPosCredits());
	    return _axios2.default.get(_url.POS_CREDITS_URL, {
	      headers: { Authorization: 'Bearer ' + token }
	    }).then(function (response) {
	      dispatch(fetchPosCreditsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPosCreditsFailure(err));
	    });
	  };
	}
	
	function fetchPosCreditsByDate(postingDateGT, postingDateLT, days) {
	  var dates = (0, _cleanDates.toFromDates)(days, postingDateGT, postingDateLT);
	  var token = localStorage.getItem('token');
	  return function (dispatch) {
	    dispatch(requestPosOrders());
	    return _axios2.default.get(_url.POS_CREDITS_URL + '?Date__gte=' + dates.fromDate + '&Date__lte=' + dates.toDate, {
	      headers: { Authorization: 'Bearer ' + token }
	    }).then(function (response) {
	      dispatch(fetchPosOrdersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPosOrdersFailure(err));
	    });
	  };
	}
	
	function fetchPosCreditsByFilter(postingDateGT, postingDateLT, days, status) {
	  var SaleStatus = status && status !== 'all' ? '&SaleStatus__in=' + status : '';
	  var dates = (0, _cleanDates.toFromDates)(days, postingDateGT, postingDateLT);
	  var token = localStorage.getItem('token');
	  return function (dispatch) {
	    dispatch(requestPosCredits());
	    return _axios2.default.get(_url.POS_CREDITS_URL + '?Date__gte=' + dates.fromDate + '&Date__lte=' + dates.toDate + SaleStatus, {
	      headers: { Authorization: 'Bearer ' + token }
	    }).then(function (response) {
	      dispatch(fetchPosCreditsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPosCreditsFailure(err));
	    });
	  };
	}
	
	function requestPosCreditDetail() {
	  return {
	    type: _type.REQUEST_POS_CREDIT_DETAIL
	  };
	}
	
	function fetchPosCreditDetailSuccess(salesCreditDetail) {
	  salesCreditDetail = salesCreditDetail.data;
	  // The date data fetched is in the form of string, which needs to be modified into Date type
	  if (salesCreditDetail.CreateDatetime) salesCreditDetail.CreateDatetime = (0, _cleanDates.convertUtcDate)(salesCreditDetail.CreateDatetime);
	  return {
	    type: _type.FETCH_POS_CREDIT_DETAIL_SUCCESS,
	    payload: salesCreditDetail
	  };
	}
	
	function fetchPosCreditDetailFailure(error) {
	  return {
	    type: _type.FETCH_POS_CREDIT_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function fetchPosCreditDetail(Order_num) {
	  var token = localStorage.getItem('token');
	  return function (dispatch) {
	    dispatch(requestPosCreditDetail());
	    return _axios2.default.get('' + _url.POS_CREDIT_URL + Order_num, {
	      headers: { Authorization: 'Bearer ' + token }
	    }).then(function (response) {
	      dispatch(fetchPosCreditDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPosCreditDetailFailure(err));
	    });
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchPosHoldsOrderDetailSuccess, 'fetchPosHoldsOrderDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPosHoldsOrdersDetail, 'fetchPosHoldsOrdersDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchposHoldsSuccess, 'fetchposHoldsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPosHoldsOrders, 'fetchPosHoldsOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(voidSelectedPosHoldsOrder, 'voidSelectedPosHoldsOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(printPosHolds, 'printPosHolds', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(setField, 'setField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchRegisters, 'fetchRegisters', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchRegistersSuccess, 'fetchRegistersSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchRegistersFailure, 'fetchRegistersFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchAllRegisterSessions, 'fetchAllRegisterSessions', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchRegisterSessions, 'fetchRegisterSessions', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchRegisterSessionsByDate, 'fetchRegisterSessionsByDate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchRegisterSessionsSuccess, 'fetchRegisterSessionsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchRegisterSessionsFailure, 'fetchRegisterSessionsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(verifyRegisters, 'verifyRegisters', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPosOrders, 'fetchPosOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(requestPosOrders, 'requestPosOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPosOrdersSuccess, 'fetchPosOrdersSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPosOrdersFailure, 'fetchPosOrdersFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPosOrdersByDate, 'fetchPosOrdersByDate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPosOrderDetail, 'fetchPosOrderDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(requestPosOrderDetail, 'requestPosOrderDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPosOrderDetailSuccess, 'fetchPosOrderDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPosOrderDetailFailure, 'fetchPosOrderDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPosOrdersByFilter, 'fetchPosOrdersByFilter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(voidPosOrder, 'voidPosOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(voidPosOrderSuccess, 'voidPosOrderSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(voidPosOrderFailure, 'voidPosOrderFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(editPosPaymentSuccess, 'editPosPaymentSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(editPosPaymentFailure, 'editPosPaymentFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(editPosPayment, 'editPosPayment', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(requestPosCredits, 'requestPosCredits', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPosCreditsSuccess, 'fetchPosCreditsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPosCreditsFailure, 'fetchPosCreditsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPosCredits, 'fetchPosCredits', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPosCreditsByDate, 'fetchPosCreditsByDate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPosCreditsByFilter, 'fetchPosCreditsByFilter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(requestPosCreditDetail, 'requestPosCreditDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPosCreditDetailSuccess, 'fetchPosCreditDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPosCreditDetailFailure, 'fetchPosCreditDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPosCreditDetail, 'fetchPosCreditDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/pos_actions.jsx');
	}();

	;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchPromotions = fetchPromotions;
	exports.selectPromotions = selectPromotions;
	exports.resetCurrentPromotions = resetCurrentPromotions;
	exports.fetchPromotionsDetail = fetchPromotionsDetail;
	exports.fetchPromotionsDetailSuccess = fetchPromotionsDetailSuccess;
	exports.fetchPromotionsDetailFailure = fetchPromotionsDetailFailure;
	exports.addNewPromotion = addNewPromotion;
	exports.addPromotionSuccess = addPromotionSuccess;
	exports.addPromotionFailure = addPromotionFailure;
	exports.saveEdittedPromotion = saveEdittedPromotion;
	exports.deletePromotion = deletePromotion;
	exports.setPromoRowValue = setPromoRowValue;
	exports.setField = setField;
	exports.savePromotion = savePromotion;
	exports.savePromoNotes = savePromoNotes;
	exports.savePromoNotesSuccess = savePromoNotesSuccess;
	exports.savePromoNotesFailure = savePromoNotesFailure;
	exports.fetchPromoNotes = fetchPromoNotes;
	exports.fetchPromoNotesSuccess = fetchPromoNotesSuccess;
	exports.fetchPromoNotesFailure = fetchPromoNotesFailure;
	exports.setCurrentPromo = setCurrentPromo;
	exports.resetCurrentPromo = resetCurrentPromo;
	exports.fetchPromoDetails = fetchPromoDetails;
	exports.fetchPromoDetailsByProduct = fetchPromoDetailsByProduct;
	exports.clearPromoDetailStatus = clearPromoDetailStatus;
	exports.fetchGroups = fetchGroups;
	exports.fetchGroupCategories = fetchGroupCategories;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Inventories Actions
	
	function fetchPromotions(handleSuccess, handleFailure) {
	  return (0, _axios2.default)({
	    method: 'get',
	    url: _url.PROMOTIONS_URL,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (response) {
	    handleSuccess(response);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	}
	
	function selectPromotions(promotions) {
	  return {
	    type: _type.SELECT_PROMOTIONS,
	    payload: promotions
	  };
	}
	
	function resetCurrentPromotions() {
	  return {
	    type: _type.RESET_CURRENT_PROMOTIONS
	  };
	}
	
	function fetchPromotionsDetail(promotions_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PROMOTIONS_DETAIL });
	    return _axios2.default.get(_url.PROMOTIONS_URL + promotions_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPromotionsDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPromotionsDetailFailure(err));
	    });
	  };
	}
	
	function fetchPromotionsDetailSuccess(promotionsDetail) {
	  promotionsDetail = promotionsDetail.data;
	  if (promotionsDetail.EndDate) promotionsDetail.EndDate = new Date(promotionsDetail.EndDate);
	  if (promotionsDetail.StartDate) promotionsDetail.StartDate = new Date(promotionsDetail.StartDate);
	  console.log("2", promotionsDetail);
	  return {
	    type: _type.FETCH_PROMOTIONS_DETAIL_SUCCESS,
	    payload: promotionsDetail
	  };
	}
	
	function fetchPromotionsDetailFailure(error) {
	  return {
	    type: _type.FETCH_PROMOTIONS_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function addNewPromotion(_ref, CustomersFull) {
	  var Name = _ref.Name,
	      Type = _ref.Type,
	      Product = _ref.Product,
	      Qualification = _ref.Qualification,
	      Discount = _ref.Discount,
	      StartDate = _ref.StartDate,
	      EndDate = _ref.EndDate;
	
	  var Customers = [];
	  CustomersFull.map(function (customer) {
	    Customers.push(customer.Customer_id);
	  });
	  Product = Product.value;
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_ADDING_PROMOTION });
	    _axios2.default.post(_url.PROMOTIONS_URL, {
	      Name: Name,
	      Type: Type,
	      Product: Product,
	      Qualification: Qualification,
	      Discount: Discount,
	      StartDate: StartDate,
	      EndDate: EndDate,
	      Customers: Customers
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(addPromotionSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(addPromotionFailure(err));
	    });
	  };
	}
	
	function addPromotionSuccess() {
	  return {
	    type: _type.ADD_PROMOTION_SUCCESS
	  };
	}
	
	function addPromotionFailure(response) {
	  return {
	    type: _type.ADD_PROMOTION_FAILURE,
	    payload: response
	  };
	}
	
	function saveEdittedPromotion(promotionId, promotionLine, handleSuccess, handleFailure) {
	  return (0, _axios2.default)({
	    method: 'put',
	    url: '' + _url.PROMOTIONS_URL + promotionId,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	    data: promotionLine
	  }).then(function (response) {
	    handleSuccess(response);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	}
	
	function deletePromotion(promotionId, handleSuccess, handleFailure) {
	  (0, _axios2.default)({
	    method: 'delete',
	    url: '' + _url.PROMOTIONS_URL + promotionId,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (response) {
	    handleSuccess(response);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	}
	
	function setPromoRowValue(title, form) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)(form, 'ProductInformation', title));
	  };
	}
	
	function setField(field, value) {
	  console.log("setting field", field, value);
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)('promotions', field, value));
	  };
	}
	
	function savePromotion(promotionLine, handleSuccess, handleFailure) {
	  return (0, _axios2.default)({
	    method: 'post',
	    url: '' + _url.PROMOTIONS_URL,
	    data: promotionLine,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (response) {
	    handleSuccess(response);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	}
	
	function savePromoNotes(_ref2) {
	  var PromotionsNote = _ref2.PromotionsNote,
	      SalesNote = _ref2.SalesNote;
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_SAVE_PROMO_NOTES });
	    _axios2.default.put(_url.PROMO_NOTES_URL, {
	      PromotionsNote: PromotionsNote,
	      SalesNote: SalesNote
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(savePromoNotesSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(savePromoNotesFailure(err));
	    });
	  };
	}
	
	function savePromoNotesSuccess() {
	  return {
	    type: _type.SAVE_PROMO_NOTES_SUCCESS
	  };
	}
	
	function savePromoNotesFailure(error) {
	  return {
	    type: _type.SAVE_PROMO_NOTES_FAILURE,
	    payload: error
	  };
	}
	
	function fetchPromoNotes() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PROMO_NOTES });
	    _axios2.default.get(_url.PROMO_NOTES_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPromoNotesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPromoNotesFailure(err));
	    });
	  };
	}
	
	function fetchPromoNotesSuccess(notes) {
	  return {
	    type: _type.FETCH_PROMO_NOTES_SUCCESS,
	    payload: notes
	  };
	}
	
	function fetchPromoNotesFailure(error) {
	  return {
	    type: _type.FETCH_PROMO_NOTES_FAILURE,
	    payload: error
	  };
	}
	
	function setCurrentPromo(Product_id) {
	  return {
	    type: _type.SET_CURRENT_PROMO,
	    payload: Product_id
	  };
	}
	
	function resetCurrentPromo() {
	  return {
	    type: _type.RESET_CURRENT_PROMO
	  };
	}
	
	function fetchPromoDetails(promotionLineId, handleSuccess, handleFailure) {
	  return (0, _axios2.default)({
	    method: 'get',
	    url: '' + _url.PROMOTIONS_URL + promotionLineId,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (response) {
	    handleSuccess(response);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	}
	
	function fetchPromoDetailsByProduct(productId, handleSuccess, handleFailure) {
	  return (0, _axios2.default)({
	    method: 'get',
	    url: '' + _url.PROMOTIONS_URL,
	    params: {
	      Product_id: productId
	    },
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (response) {
	    handleSuccess(response);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	}
	
	function clearPromoDetailStatus() {
	  return {
	    type: _type.CLEAR_PROMO_DETAIL_STATUS
	  };
	}
	
	function fetchGroups(handleSuccess, handleFailure) {
	  return (0, _axios2.default)({
	    method: 'get',
	    url: _url.GROUPS_URL,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (response) {
	    handleSuccess(response.data);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	}
	
	function fetchGroupCategories(group_id, handleSuccess, handleFailure) {
	  return (0, _axios2.default)({
	    method: 'get',
	    url: _url.GROUPS_URL + 'categories/' + group_id,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (response) {
	    handleSuccess(response.data);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchPromotions, 'fetchPromotions', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(selectPromotions, 'selectPromotions', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(resetCurrentPromotions, 'resetCurrentPromotions', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPromotionsDetail, 'fetchPromotionsDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPromotionsDetailSuccess, 'fetchPromotionsDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPromotionsDetailFailure, 'fetchPromotionsDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(addNewPromotion, 'addNewPromotion', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(addPromotionSuccess, 'addPromotionSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(addPromotionFailure, 'addPromotionFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(saveEdittedPromotion, 'saveEdittedPromotion', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(deletePromotion, 'deletePromotion', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(setPromoRowValue, 'setPromoRowValue', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(setField, 'setField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(savePromotion, 'savePromotion', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(savePromoNotes, 'savePromoNotes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(savePromoNotesSuccess, 'savePromoNotesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(savePromoNotesFailure, 'savePromoNotesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPromoNotes, 'fetchPromoNotes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPromoNotesSuccess, 'fetchPromoNotesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPromoNotesFailure, 'fetchPromoNotesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(setCurrentPromo, 'setCurrentPromo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(resetCurrentPromo, 'resetCurrentPromo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPromoDetails, 'fetchPromoDetails', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPromoDetailsByProduct, 'fetchPromoDetailsByProduct', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(clearPromoDetailStatus, 'clearPromoDetailStatus', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchGroups, 'fetchGroups', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchGroupCategories, 'fetchGroupCategories', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/promotions_actions.jsx');
	}();

	;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProductAutoSuggestEpic = exports.PurchaseAutoSuggestEpic = exports.SalesAutoSuggestEpic = undefined;
	exports.fetchSalesOrderSuggestions = fetchSalesOrderSuggestions;
	exports.fetchPurchaseOrderSuggestions = fetchPurchaseOrderSuggestions;
	exports.fetchProductSuggestions = fetchProductSuggestions;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	__webpack_require__(205);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import 'rxjs/add/operator/mergeMap';
	// import 'rxjs/add/operator/debounceTime';
	function fetchSalesOrderSuggestions(customerNumber, searchType, value, group) {
	  if (_root_url.isSY && group) {
	    group = '&ProductGroup_id=' + group.value;
	  } else {
	    group = '';
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.FETCH_SALES_ORDER_SUGGESTIONS, payload: { customerNumber: customerNumber, searchType: searchType, value: value, group: group } });
	  };
	}
	
	var SalesAutoSuggestEpic = exports.SalesAutoSuggestEpic = function SalesAutoSuggestEpic(action$) {
	  return action$.ofType(_type.FETCH_SALES_ORDER_SUGGESTIONS).switchMap(function (action) {
	    return _axios2.default.get('' + _url.SALES_ORDER_SUGGESTION_URL + action.payload.customerNumber + '/?' + action.payload.searchType + '=' + action.payload.value + action.payload.group, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  }).map(function (response) {
	    return { type: _type.FETCH_SALES_ORDER_SUGGESTIONS_SUCCESS, payload: response };
	  }).catch(function (err, source) {
	    return source;
	  });
	};
	
	function fetchPurchaseOrderSuggestions(searchType, value) {
	  return function (dispatch) {
	    dispatch({ type: _type.FETCH_PURCHASE_ORDER_SUGGESTIONS, payload: { searchType: searchType, value: value } });
	  };
	}
	
	var PurchaseAutoSuggestEpic = exports.PurchaseAutoSuggestEpic = function PurchaseAutoSuggestEpic(action$) {
	  return action$.ofType(_type.FETCH_PURCHASE_ORDER_SUGGESTIONS).switchMap(function (action) {
	    return _axios2.default.get(_url.PURCHASE_ORDER_SUGGESTION_URL + '?' + action.payload.searchType + '=' + action.payload.value, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  }).map(function (response) {
	    return { type: _type.FETCH_PURCHASE_ORDER_SUGGESTIONS_SUCCESS, payload: response };
	  }).catch(function (err) {
	    return { type: _type.FETCH_PURCHASE_ORDER_SUGGESTIONS_FAILURE, payload: err };
	  });
	};
	
	function fetchProductSuggestions(searchType, value) {
	  return function (dispatch) {
	    dispatch({ type: _type.FETCH_PRODUCT_SUGGESTIONS, payload: { searchType: searchType, value: value } });
	  };
	}
	
	var ProductAutoSuggestEpic = exports.ProductAutoSuggestEpic = function ProductAutoSuggestEpic(action$) {
	  return action$.ofType(_type.FETCH_PRODUCT_SUGGESTIONS).switchMap(function (action) {
	    return _axios2.default.get(_url.PURCHASE_ORDER_SUGGESTION_URL + '?' + action.payload.searchType + '=' + action.payload.value, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  }).map(function (response) {
	    return { type: _type.FETCH_PRODUCT_SUGGESTIONS_SUCCESS, payload: response };
	  }).catch(function (err) {
	    return { type: _type.FETCH_PRODUCT_SUGGESTIONS_FAILURE, payload: err };
	  });
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderSuggestions, 'fetchSalesOrderSuggestions', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/autoSuggest_actions.js');
	
	  __REACT_HOT_LOADER__.register(SalesAutoSuggestEpic, 'SalesAutoSuggestEpic', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/autoSuggest_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseOrderSuggestions, 'fetchPurchaseOrderSuggestions', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/autoSuggest_actions.js');
	
	  __REACT_HOT_LOADER__.register(PurchaseAutoSuggestEpic, 'PurchaseAutoSuggestEpic', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/autoSuggest_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchProductSuggestions, 'fetchProductSuggestions', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/autoSuggest_actions.js');
	
	  __REACT_HOT_LOADER__.register(ProductAutoSuggestEpic, 'ProductAutoSuggestEpic', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/autoSuggest_actions.js');
	}();

	;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDropzone = __webpack_require__(45);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var propTypes = {
	  dependentValues: _propTypes2.default.shape({
	    Name: _propTypes2.default.string,
	    Description: _propTypes2.default.string,
	    Index: _propTypes2.default.number
	  }),
	  showImageOnly: _propTypes2.default.bool,
	  renderImage: _propTypes2.default.func,
	  onRowValueChange: _propTypes2.default.func,
	  onDrop: _propTypes2.default.func
	};
	
	var defaultProps = {
	  showImageOnly: true,
	  dependentValues: {},
	  renderImage: function renderImage() {},
	  onRowValueChange: function onRowValueChange() {},
	  onDrop: function onDrop() {},
	  onImageManagement: function onImageManagement() {}
	};
	
	var Category2ImageFormatter = _react2.default.createClass({
	  displayName: 'Category2ImageFormatter',
	  getInitialState: function getInitialState() {
	    return {
	      name: '',
	      description: ''
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    var _props$dependentValue = this.props.dependentValues,
	        Name = _props$dependentValue.Name,
	        Description = _props$dependentValue.Description;
	
	    var name = Name || '';
	    var description = Description || '';
	    this.setState({ name: name, description: description });
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.dependentValues && nextProps.dependentValues !== this.props.dependentValues) {
	      var _nextProps$dependentV = nextProps.dependentValues,
	          Name = _nextProps$dependentV.Name,
	          Description = _nextProps$dependentV.Description;
	
	      var name = Name || '';
	      var description = Description || '';
	      this.setState({ name: name, description: description });
	    }
	  },
	  onChange: function onChange(event, field) {
	    this.setState(_defineProperty({}, field, event.target.value));
	  },
	  renderNameAndDescription: function renderNameAndDescription() {
	    var _this = this;
	
	    return !this.props.showImageOnly && _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'name' },
	          _react2.default.createElement(_reactBootstrap.Input, {
	            type: 'text',
	            name: 'name',
	            placeholder: _reactReduxI18n.I18n.t('name'),
	            value: this.state.name,
	            onChange: function onChange(event) {
	              return _this.onChange(event, event.target.name);
	            },
	            onBlur: function onBlur(event) {
	              return _this.props.onRowValueChange(event, _this.props.dependentValues, 'Name');
	            }
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'description' },
	          _react2.default.createElement(_reactBootstrap.Input, {
	            type: 'text',
	            name: 'description',
	            placeholder: _reactReduxI18n.I18n.t('description'),
	            value: this.state.description,
	            onChange: function onChange(event) {
	              return _this.onChange(event, event.target.name);
	            },
	            onBlur: function onBlur(event) {
	              return _this.props.onRowValueChange(event, _this.props.dependentValues, 'Description');
	            }
	          })
	        )
	      )
	    );
	  },
	  renderDropzone: function renderDropzone(Index) {
	    var _this2 = this;
	
	    var className = !this.props.showImageOnly ? 'category2-thumbnail-cell' : 'group-thumbnail-cell';
	    var dropBtnId = !this.props.showImageOnly ? 'dropzone-button-absolute' : 'dropzone-button';
	    if (_root_url.isElegant) {
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(
	          _reactDropzone2.default,
	          {
	            onDrop: this.props.onDrop.bind(Index, this),
	            className: 'image-dropzone',
	            accept: 'image/*'
	          },
	          _react2.default.createElement(
	            'div',
	            { id: 'image-container' },
	            this.props.renderImage(Index)
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            id: dropBtnId,
	            bsStyle: 'primary',
	            type: 'button',
	            onClick: function onClick() {
	              return _this2.props.onImageManagement(Index);
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-plus' })
	        ),
	        this.renderNameAndDescription()
	      );
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: className },
	      _react2.default.createElement(
	        'div',
	        { id: 'image-container' },
	        this.props.renderImage(Index)
	      ),
	      _react2.default.createElement(
	        _reactDropzone2.default,
	        {
	          onDrop: this.props.onDrop.bind(Index, this),
	          className: 'image-dropzone',
	          accept: 'image/*'
	        },
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                id: 'dropzone-button',
	                bsStyle: 'primary',
	                type: 'button'
	              },
	              _react2.default.createElement('em', { className: 'fa fa-plus' })
	            )
	          )
	        )
	      ),
	      this.renderNameAndDescription()
	    );
	  },
	  render: function render() {
	    var Index = this.props.dependentValues.Index;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      this.renderDropzone(Index)
	    );
	  }
	});
	
	Category2ImageFormatter.propTypes = propTypes;
	Category2ImageFormatter.defaultProps = defaultProps;
	
	var _default = Category2ImageFormatter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/ImageFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/ImageFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(Category2ImageFormatter, 'Category2ImageFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/ImageFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/ImageFormatter.jsx');
	}();

	;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _sales_actions = __webpack_require__(28);
	
	var _setWeightModal = __webpack_require__(333);
	
	var _setWeightModal2 = _interopRequireDefault(_setWeightModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setWeightModal = (0, _reduxForm.reduxForm)({
	  form: 'setWeightModal'
	  // validate
	})(_setWeightModal2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('setWeightModal');
	
	function mapStateToProps(state) {
	  var totalWeight = selector(state, 'TotalWeight');
	  return {
	    totalWeight: totalWeight,
	
	    salesOrderLineWeights: state.salesOrders.salesOrderLineWeights,
	    salesOrderLineWeightsIsLoading: state.salesOrders.salesOrderLineWeightsIsLoading,
	    salesOrderLineWeightsError: state.salesOrders.salesOrderLineWeightsError,
	
	    salesOrderLineWeightsIsEditing: state.salesOrders.salesOrderLineWeightsIsEditing,
	    editSalesOrderLineWeightsSuccess: state.salesOrders.editSalesOrderLineWeightsSuccess,
	    editSalesOrderLineWeightsError: state.salesOrders.editSalesOrderLineWeightsError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchSalesOrderLineWeights: _sales_actions.fetchSalesOrderLineWeights, setOrderLineWeights: _sales_actions.setOrderLineWeights, clearSalesOrderLineWeights: _sales_actions.clearSalesOrderLineWeights })(setWeightModal);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/setWeightModal.jsx');
	
	  __REACT_HOT_LOADER__.register(setWeightModal, 'setWeightModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/setWeightModal.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/setWeightModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/setWeightModal.jsx');
	}();

	;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _inventories_actions = __webpack_require__(38);
	
	var _purchaseQuotes_actions = __webpack_require__(62);
	
	var _favorites_actions = __webpack_require__(58);
	
	var _favoriteList_actions = __webpack_require__(89);
	
	var _favoriteModal = __webpack_require__(335);
	
	var _favoriteModal2 = _interopRequireDefault(_favoriteModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.Name) {
	        errors.Name = 'Required';
	    }
	    if (values.IsEnabled === null) {
	        errors.IsEnabled = 'Required';
	    }
	    return errors;
	};
	
	var newFavoriteModal = (0, _reduxForm.reduxForm)({
	    form: 'newFavoriteModal'
	})(_favoriteModal2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('newFavoriteModal');
	
	function mapStateToProps(state) {
	    var inventoryItemValue = selector(state, 'InventoryItem_id');
	    return {
	        inventoryItemValue: inventoryItemValue,
	
	        currenInventoryItem: state.inventories.currentInventory,
	        inventoryItems: state.inventories.all,
	        isLoading: state.inventories.isLoading,
	        error: state.inventories.error,
	
	        inList: state.customerFavorites.inList
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { addNewCustomerFavorite: _favoriteList_actions.addNewCustomerFavorite, addNewFavorite: _favorites_actions.addNewFavorite, fetchInventories: _inventories_actions.fetchInventories, selectInventory: _inventories_actions.selectInventory, resetCurrentInventory: _inventories_actions.resetCurrentInventory,
	    inListError: _favoriteList_actions.inListError, clearInListError: _favoriteList_actions.clearInListError })(newFavoriteModal);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Favorites/favoriteModal.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Favorites/favoriteModal.jsx');
	
	    __REACT_HOT_LOADER__.register(newFavoriteModal, 'newFavoriteModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Favorites/favoriteModal.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Favorites/favoriteModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Favorites/favoriteModal.jsx');
	}();

	;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _purchaseTemplates_actions = __webpack_require__(65);
	
	var _purchaseQuotes_actions = __webpack_require__(62);
	
	var _purchaseQuoteModal = __webpack_require__(442);
	
	var _purchaseQuoteModal2 = _interopRequireDefault(_purchaseQuoteModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.Name) {
	        errors.Name = 'Required';
	    }
	    if (values.IsEnabled === null) {
	        errors.IsEnabled = 'Required';
	    }
	    return errors;
	};
	
	var purchaseQuoteModal = (0, _reduxForm.reduxForm)({
	    form: 'purchaseQuoteModal'
	})(_purchaseQuoteModal2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('purchaseQuoteModal');
	
	function mapStateToProps(state) {
	    var purchaseTemplateValue = selector(state, 'PurchaseTemplate_id');
	    return {
	        purchaseTemplateValue: purchaseTemplateValue,
	
	        currentPurchaseTemplate: state.purchaseTemplates.currentPurchaseTemplate,
	        purchaseTemplates: state.purchaseTemplates.all,
	        isLoading: state.purchaseTemplates.isLoading,
	        error: state.purchaseTemplates.error
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchPurchaseTemplates: _purchaseTemplates_actions.fetchPurchaseTemplates, selectPurchaseTemplate: _purchaseTemplates_actions.selectPurchaseTemplate, resetCurrentPurchaseTemplate: _purchaseTemplates_actions.resetCurrentPurchaseTemplate, resetCurrentPurchaseQuote: _purchaseQuotes_actions.resetCurrentPurchaseQuote })(purchaseQuoteModal);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseQuoteModal.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseQuoteModal.jsx');
	
	    __REACT_HOT_LOADER__.register(purchaseQuoteModal, 'purchaseQuoteModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseQuoteModal.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseQuoteModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseQuoteModal.jsx');
	}();

	;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _sales_actions = __webpack_require__(28);
	
	var _promotions_actions = __webpack_require__(71);
	
	var _salesInventoryInfo = __webpack_require__(499);
	
	var _salesInventoryInfo2 = _interopRequireDefault(_salesInventoryInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    salesInventoryInfo: state.salesOrders.salesInventoryInfo,
	    salesInventoryInfoIsLoading: state.salesOrders.salesInventoryInfoIsLoading,
	    salesInventoryInfoError: state.salesOrders.salesInventoryInfoError
	  };
	}
	
	var salesInventoryInfo = (0, _reduxForm.reduxForm)({
	  form: 'salesInventoryInfo'
	})(_salesInventoryInfo2.default);
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchSalesInventoryInfo: _sales_actions.fetchSalesInventoryInfo, fetchItemSalesHistory: _sales_actions.fetchItemSalesHistory, setPromoRowValue: _promotions_actions.setPromoRowValue, setSaleFavoriteRowValue: _sales_actions.setSaleFavoriteRowValue })(salesInventoryInfo);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesInventoryInfo.jsx');
	
	  __REACT_HOT_LOADER__.register(salesInventoryInfo, 'salesInventoryInfo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesInventoryInfo.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesInventoryInfo.jsx');
	}();

	;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(85);

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.requestPermissions = requestPermissions;
	exports.fetchPermissionsSuccess = fetchPermissionsSuccess;
	exports.fetchPermissionsFailure = fetchPermissionsFailure;
	exports.setPermissions = setPermissions;
	exports.signinUser = signinUser;
	exports.signupUser = signupUser;
	exports.authError = authError;
	exports.signoutUser = signoutUser;
	exports.checkStatues = checkStatues;
	exports.authUser = authUser;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _root_url = __webpack_require__(9);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isAFM = _root_url.ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afm-scm.truckxi.com/api/';
	var isOCM = _root_url.ROOT_API_URL === 'https://ocm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ocm-scm.truckxi.com/api/';
	
	// If successfully signed in or signed up, save the token, set state and
	// navigate user to the 'User' page.
	
	function requestPermissions() {
	  return {
	    type: _type.REQUEST_PERMISSIONS
	  };
	}
	
	function fetchPermissionsSuccess(response) {
	  localStorage.setItem('userPermissions', JSON.stringify(response.data.permissions));
	  localStorage.setItem('companyCode', response.data.companyCode);
	  return {
	    type: _type.FETCH_PERMISSION_SUCCESS
	  };
	}
	
	function fetchPermissionsFailure(error) {
	  return {
	    type: _type.FETCH_PERMISSION_FAILURE,
	    payload: error
	  };
	}
	
	function setPermissions(token) {
	  return function (dispatch) {
	    dispatch(requestPermissions());
	    return _axios2.default.get(_url.PERMISSION_URL, {
	      headers: { Authorization: 'Bearer ' + token }
	    }).then(function (response) {
	      dispatch(fetchPermissionsSuccess(response));
	
	      if (isAFM) {
	        if ((0, _permissions2.default)('view_belongwarehouse_All')) {
	          localStorage.setItem('warehouseLocation', '');
	        } else if ((0, _permissions2.default)('view_belongwarehouse_Beaverton')) {
	          localStorage.setItem('warehouseLocation', 'Beaverton');
	        } else if ((0, _permissions2.default)('view_belongwarehouse_Bellevue')) {
	          localStorage.setItem('warehouseLocation', 'Bellevue');
	        } else if ((0, _permissions2.default)('view_belongwarehouse_Seattle')) {
	          localStorage.setItem('warehouseLocation', 'Seattle');
	        } else {
	          localStorage.setItem('warehouseLocation', 'none');
	        }
	      } else {
	        localStorage.setItem('warehouseLocation', '');
	      }
	
	      var companyCode = localStorage.getItem('companyCode');
	      if (companyCode == 'LAC') {
	        _reactRouter.browserHistory.push('/routing');
	        return;
	      }
	      _reactRouter.browserHistory.push('/dashboard');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      if (err.status == 400 && err.data) {
	        alert(err.data);
	      }
	      dispatch(fetchPermissionsFailure(err));
	    });
	  };
	}
	
	function signinUser(_ref) {
	  var username = _ref.username,
	      password = _ref.password;
	
	  return function (dispatch) {
	    var querystring = __webpack_require__(801);
	    _axios2.default.post(_url.TRUCKXI_LOGIN_URL, querystring.stringify({
	      username: username,
	      password: password,
	      grant_type: 'password',
	      client_id: '67P7iQKIr5LmnYWjKgYr5gfnULpAeWI7BEuJnuDP',
	      'Content-Type': 'application/x-www-form-urlencoded'
	    })).then(function (response) {
	      dispatch({ type: _type.AUTH_USER, payload: response.data.access_token });
	      // dispatch({ type: AUTH_USER_PERMISSIONS, payload: response.data.user_permissions });
	      localStorage.setItem('token', response.data.access_token);
	      localStorage.setItem('username', username);
	      // localStorage.setItem('userType', response.data.user_type);
	      // localStorage.setItem('userPermissions', response.data.user_permissions);
	      //browserHistory.push('/dashboard');
	      dispatch(setPermissions(response.data.access_token));
	    }).catch(function (error) {
	      dispatch(authError('Bad Login Info'));
	    });
	  };
	}
	
	function signupUser(_ref2) {
	  var username = _ref2.username,
	      password = _ref2.password;
	
	  return function (dispatch) {
	    _axios2.default.post(_root_url.ROOT_URL + '/signup', { username: username, password: password }).then(function (response) {
	      dispatch({ type: _type.AUTH_USER });
	      localStorage.setItem('token', response.data.token);
	      _reactRouter.browserHistory.push('/users');
	    }).catch(function () {
	      dispatch(authError('Bad Signup Info'));
	    });
	  };
	}
	
	function authError(error) {
	  return {
	    type: _type.AUTH_ERROR,
	    payload: error
	  };
	}
	
	// If user logged out, redirect him to the home page, reset the state
	// and remove the token.
	
	function signoutUser() {
	  return function (dispatch) {
	    dispatch({ type: _type.UNAUTH_USER });
	    localStorage.removeItem('token');
	    _reactRouter.browserHistory.push('/');
	  };
	}
	
	function checkStatues() {
	  return function (dispatch) {
	    if (localStorage.getItem('token')) {
	      dispatch({ type: _type.REQUEST_AUTH });
	      return _axios2.default.get(_url.TRUCKXI_TEST_URL, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(authUser(dispatch)
	      // (dispatch) => {
	      // dispatch({ type: AUTH_USER, payload: localStorage.getItem('userType')})
	      // dispatch({ type: AUTH_USER_PERMISSIONS, payload: localStorage.getItem('userPermissions') });
	      // }
	      ).catch(function (error) {
	        dispatch({ type: _type.UNAUTH_USER });
	        if (error.status == 401) {
	          alert("You have been logged out because you signed in on another device.");
	        }
	        _reactRouter.browserHistory.push('/login');
	      });
	    }
	    _reactRouter.browserHistory.push('/login');
	  };
	}
	
	function authUser(dispatch) {
	  dispatch({ type: _type.AUTH_USER, payload: localStorage.getItem('userType') });
	  dispatch({ type: _type.AUTH_USER_PERMISSIONS, payload: localStorage.getItem('userPermissions') });
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestPermissions, 'requestPermissions', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/auth_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPermissionsSuccess, 'fetchPermissionsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/auth_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPermissionsFailure, 'fetchPermissionsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/auth_actions.js');
	
	  __REACT_HOT_LOADER__.register(setPermissions, 'setPermissions', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/auth_actions.js');
	
	  __REACT_HOT_LOADER__.register(signinUser, 'signinUser', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/auth_actions.js');
	
	  __REACT_HOT_LOADER__.register(signupUser, 'signupUser', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/auth_actions.js');
	
	  __REACT_HOT_LOADER__.register(authError, 'authError', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/auth_actions.js');
	
	  __REACT_HOT_LOADER__.register(signoutUser, 'signoutUser', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/auth_actions.js');
	
	  __REACT_HOT_LOADER__.register(checkStatues, 'checkStatues', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/auth_actions.js');
	
	  __REACT_HOT_LOADER__.register(authUser, 'authUser', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/auth_actions.js');
	
	  __REACT_HOT_LOADER__.register(isAFM, 'isAFM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/auth_actions.js');
	
	  __REACT_HOT_LOADER__.register(isOCM, 'isOCM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/auth_actions.js');
	}();

	;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setPasscodeVerificationStatus = exports.handleVerifyPasscodeResult = exports.setConfirmPasscodeModalVisibility = undefined;
	
	var _type = __webpack_require__(14);
	
	function setVisibilityPasscode(visibility) {
	  return {
	    type: _type.SET_CONFIRM_PASSCODE_MODAL_VISIBILITY,
	    payload: visibility
	  };
	}
	
	function passcodeVerification(verified) {
	  return {
	    type: _type.SET_PASSCODE_VERFICATION,
	    payload: verified
	  };
	}
	
	var setConfirmPasscodeModalVisibility = exports.setConfirmPasscodeModalVisibility = function setConfirmPasscodeModalVisibility(visibility) {
	  return function (dispatch) {
	    dispatch(setVisibilityPasscode(visibility));
	  };
	};
	
	var handleVerifyPasscodeResult = exports.handleVerifyPasscodeResult = function handleVerifyPasscodeResult(verified) {
	  return function (dispatch) {
	    dispatch(setVisibilityPasscode());
	    if (verified) {
	      dispatch(passcodeVerification(verified));
	    }
	  };
	};
	
	var setPasscodeVerificationStatus = exports.setPasscodeVerificationStatus = function setPasscodeVerificationStatus(verified) {
	  return function (dispatch) {
	    dispatch(passcodeVerification(verified));
	  };
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(setVisibilityPasscode, 'setVisibilityPasscode', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/baseModal_actions.js');
	
	  __REACT_HOT_LOADER__.register(passcodeVerification, 'passcodeVerification', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/baseModal_actions.js');
	
	  __REACT_HOT_LOADER__.register(setConfirmPasscodeModalVisibility, 'setConfirmPasscodeModalVisibility', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/baseModal_actions.js');
	
	  __REACT_HOT_LOADER__.register(handleVerifyPasscodeResult, 'handleVerifyPasscodeResult', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/baseModal_actions.js');
	
	  __REACT_HOT_LOADER__.register(setPasscodeVerificationStatus, 'setPasscodeVerificationStatus', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/baseModal_actions.js');
	}();

	;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchPutAway = fetchPutAway;
	exports.fetchPutAwaySuccess = fetchPutAwaySuccess;
	exports.fetchPutAwayFailure = fetchPutAwayFailure;
	exports.resetCurrentPutAway = resetCurrentPutAway;
	exports.selectPutAway = selectPutAway;
	exports.fetchPutAwayDetail = fetchPutAwayDetail;
	exports.fetchPutAwayDetailSuccess = fetchPutAwayDetailSuccess;
	exports.fetchPutAwayDetailFailure = fetchPutAwayDetailFailure;
	exports.createPutAway = createPutAway;
	exports.createPutAwaySuccess = createPutAwaySuccess;
	exports.createPutAwayFailure = createPutAwayFailure;
	exports.editPutAway = editPutAway;
	exports.editPutAwaySuccess = editPutAwaySuccess;
	exports.editPutAwayFailure = editPutAwayFailure;
	exports.fetchBinList = fetchBinList;
	exports.fetchBinListSuccess = fetchBinListSuccess;
	exports.fetchBinListFailure = fetchBinListFailure;
	exports.createBins = createBins;
	exports.createBinsSuccess = createBinsSuccess;
	exports.createBinsFailure = createBinsFailure;
	exports.selectWarehouseReceive = selectWarehouseReceive;
	exports.resetCurrentWarehouseReceive = resetCurrentWarehouseReceive;
	exports.fetchBinListFromZone = fetchBinListFromZone;
	exports.fetchBinListFromZoneSuccess = fetchBinListFromZoneSuccess;
	exports.fetchBinListFromZoneFailure = fetchBinListFromZoneFailure;
	exports.autoPutaway = autoPutaway;
	exports.autoPutawaySuccess = autoPutawaySuccess;
	exports.autoPutawayFailure = autoPutawayFailure;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// ScrapRecords Actions
	
	function fetchPutAway() {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_PUT_AWAY });
	        return _axios2.default.get(_url.PUT_AWAY_URL, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchPutAwaySuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchPutAwayFailure(err));
	        });
	    };
	}
	
	function fetchPutAwaySuccess(PutAway) {
	    return {
	        type: _type.FETCH_PUT_AWAY_SUCCESS,
	        payload: PutAway
	    };
	}
	
	function fetchPutAwayFailure(error) {
	    return {
	        type: _type.FETCH_PUT_AWAY_FAILURE,
	        payload: error
	    };
	}
	function resetCurrentPutAway() {
	    return {
	        type: _type.RESET_CURRENT_PUT_AWAY
	    };
	}
	
	function selectPutAway(putAway) {
	    return {
	        type: _type.SELECT_PUT_AWAY,
	        payload: putAway
	    };
	}
	
	function fetchPutAwayDetail(warehousePutAway_id) {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_PUT_AWAY_DETAIL });
	        return _axios2.default.get(_url.PUT_AWAY_URL + warehousePutAway_id, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchPutAwayDetailSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchPutAwayDetailFailure(err));
	        });
	    };
	}
	
	function fetchPutAwayDetailSuccess(putAwayDetail) {
	    return {
	        type: _type.FETCH_PUT_AWAY_DETAIL_SUCCESS,
	        payload: putAwayDetail
	    };
	}
	
	function fetchPutAwayDetailFailure(error) {
	    return {
	        type: _type.FETCH_PUT_AWAY_DETAIL_FAILURE,
	        payload: error
	    };
	}
	
	function createPutAway(_ref, _ref2, Warehouse_PutAway_Line) {
	    var CreateTime = _ref.CreateTime,
	        UpdateTime = _ref.UpdateTime;
	    var PONum = _ref2.PONum,
	        WarehouseReceiveNum = _ref2.WarehouseReceiveNum,
	        Create_Username = _ref2.Create_Username,
	        Modify_Username = _ref2.Modify_Username,
	        PostingDate = _ref2.PostingDate,
	        Note = _ref2.Note,
	        Owner = _ref2.Owner,
	        Warehouse_id = _ref2.Warehouse_id,
	        WarehouseReceive = _ref2.WarehouseReceive;
	
	    if (WarehouseReceive) {
	        PONum = WarehouseReceive.PONum;
	        WarehouseReceiveNum = WarehouseReceive.WarehouseReceiveNum;
	        Owner = WarehouseReceive.Owner;
	        Warehouse_id = WarehouseReceive.Warehouse_id;
	    }
	    CreateTime = CreateTime ? (0, _cleanDates.convertUtcDate)(CreateTime) : '';
	    UpdateTime = UpdateTime ? (0, _cleanDates.convertUtcDate)(UpdateTime) : '';
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_CREATING_PUT_AWAY });
	        _axios2.default.post(_url.PUT_AWAY_URL, {
	            PONum: PONum,
	            WarehouseReceiveNum: WarehouseReceiveNum,
	            Create_Username: Create_Username,
	            Modify_Username: Modify_Username,
	            PostingDate: PostingDate,
	            CreateTime: CreateTime,
	            UpdateTime: UpdateTime,
	            Note: Note,
	            Owner: Owner,
	            Warehouse_id: Warehouse_id,
	            Warehouse_PutAway_Line: Warehouse_PutAway_Line
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(createPutAwaySuccess());
	            _reactRouter.browserHistory.push('/putAway');
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(createPutAwayFailure(err));
	        });
	    };
	}
	
	function createPutAwaySuccess() {
	    return {
	        type: _type.CREATE_PUT_AWAY_SUCCESS
	    };
	}
	
	function createPutAwayFailure(error) {
	    return {
	        type: _type.CREATE_PUT_AWAY_FAILURE,
	        payload: error
	    };
	}
	
	function editPutAway(_ref3, _ref4, Warehouse_PutAway_Line, WarehousePutAway_id) {
	    var CreateTime = _ref3.CreateTime,
	        UpdateTime = _ref3.UpdateTime;
	    var PONum = _ref4.PONum,
	        WarehouseReceiveNum = _ref4.WarehouseReceiveNum,
	        Create_Username = _ref4.Create_Username,
	        Modify_Username = _ref4.Modify_Username,
	        PostingDate = _ref4.PostingDate,
	        Note = _ref4.Note,
	        Owner = _ref4.Owner,
	        Warehouse_id = _ref4.Warehouse_id;
	
	    CreateTime = CreateTime ? (0, _cleanDates.convertUtcDate)(CreateTime) : '';
	    UpdateTime = UpdateTime ? (0, _cleanDates.convertUtcDate)(UpdateTime) : '';
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_EDITING_PUT_AWAY });
	        _axios2.default.put(_url.PUT_AWAY_URL + WarehousePutAway_id, {
	            PONum: PONum,
	            WarehouseReceiveNum: WarehouseReceiveNum,
	            Create_Username: Create_Username,
	            Modify_Username: Modify_Username,
	            PostingDate: PostingDate,
	            CreateTime: CreateTime,
	            UpdateTime: UpdateTime,
	            Note: Note,
	            Owner: Owner,
	            Warehouse_id: Warehouse_id,
	            Warehouse_PutAway_Line: Warehouse_PutAway_Line
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(editPutAwaySuccess());
	            _reactRouter.browserHistory.push('/putAway');
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(editPutAwayFailure(err));
	        });
	    };
	}
	
	function editPutAwaySuccess() {
	    return {
	        type: _type.EDIT_PUT_AWAY_SUCCESS
	    };
	}
	
	function editPutAwayFailure(error) {
	    return {
	        type: _type.EDIT_PUT_AWAY_FAILURE,
	        payload: error
	    };
	}
	
	function fetchBinList(warehouseReceive_id) {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_BIN_LIST_DETAIL });
	        return _axios2.default.get(_url.PUT_AWAY_URL + 'detail/' + warehouseReceive_id, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchBinListSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchBinListFailure(err));
	        });
	    };
	}
	
	function fetchBinListSuccess(binList) {
	    return {
	        type: _type.FETCH_BIN_LIST_DETAIL_SUCCESS,
	        payload: binList
	    };
	}
	
	function fetchBinListFailure(error) {
	    return {
	        type: _type.FETCH_BIN_LIST_DETAIL_FAILURE,
	        payload: error
	    };
	}
	
	function createBins(Product_id, WarehouseReceiveLine_id, error, BinList) {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_CREATING_BINS });
	        _axios2.default.post(_url.BINS_URL + 'auto/', {
	            Product_id: Product_id,
	            WarehouseReceiveLine_id: WarehouseReceiveLine_id,
	            error: error,
	            BinList: BinList
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(createBinsSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(createBinsFailure(err));
	        });
	    };
	}
	
	function createBinsSuccess(response) {
	    return {
	        type: _type.CREATE_BINS_SUCCESS,
	        payload: response
	    };
	}
	
	function createBinsFailure(error) {
	    return {
	        type: _type.CREATE_BINS_FAILURE,
	        payload: error
	    };
	}
	
	function selectWarehouseReceive(Product_id, WarehouseReceiveLine_id, error, BinList) {
	    var currentWarehouseReceive = new Object();
	    currentWarehouseReceive['Product_id'] = Product_id;
	    currentWarehouseReceive['WarehouseReceiveLine_id'] = WarehouseReceiveLine_id;
	    currentWarehouseReceive['error'] = error;
	    currentWarehouseReceive['BinList'] = BinList;
	    return {
	        type: _type.SELECT_WAREHOUSE_RECEIVE,
	        payload: currentWarehouseReceive
	    };
	}
	
	function resetCurrentWarehouseReceive() {
	    return {
	        type: _type.RESET_CURRENT_WAREHOUSE_RECEIVE
	    };
	}
	
	function fetchBinListFromZone(WarehouseZone_id, _ref5) {
	    var WarehouseReceiveLine_id = _ref5.WarehouseReceiveLine_id,
	        error = _ref5.error,
	        BinList = _ref5.BinList;
	
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_BIN_LIST_DETAIL });
	        return _axios2.default.post(_url.BINS_URL + 'relocate/', {
	            WarehouseZone_id: WarehouseZone_id,
	            WarehouseReceiveLine_id: WarehouseReceiveLine_id,
	            error: error,
	            BinList: BinList
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchBinListFromZoneSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchBinListFromZoneFailure(err));
	        });
	    };
	}
	
	function fetchBinListFromZoneSuccess(binList) {
	    return {
	        type: _type.FETCH_BIN_LIST_DETAIL_SUCCESS,
	        payload: binList
	    };
	}
	
	function fetchBinListFromZoneFailure(error) {
	    return {
	        type: _type.FETCH_BIN_LIST_DETAIL_FAILURE,
	        payload: error
	    };
	}
	
	function autoPutaway(Warehouse_Receives) {
	    return function (dispatch) {
	        dispatch({ type: _type.AUTO_PUTAWAY });
	        return _axios2.default.post(_url.PUT_AWAY_URL + 'auto/', {
	            Warehouse_Receives: Warehouse_Receives
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(autoPutawaySuccess(response));
	            _reactRouter.browserHistory.push('/inventories/receiveHistory');
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(autoPutawayFailure(err));
	        });
	    };
	}
	
	function autoPutawaySuccess(files) {
	    return {
	        type: _type.AUTO_PUTAWAY_SUCCESS,
	        payload: files
	    };
	}
	
	function autoPutawayFailure(error) {
	    return {
	        type: _type.AUTO_PUTAWAY_FAILURE,
	        payload: error
	    };
	}
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(fetchPutAway, 'fetchPutAway', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchPutAwaySuccess, 'fetchPutAwaySuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchPutAwayFailure, 'fetchPutAwayFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(resetCurrentPutAway, 'resetCurrentPutAway', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(selectPutAway, 'selectPutAway', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchPutAwayDetail, 'fetchPutAwayDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchPutAwayDetailSuccess, 'fetchPutAwayDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchPutAwayDetailFailure, 'fetchPutAwayDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(createPutAway, 'createPutAway', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(createPutAwaySuccess, 'createPutAwaySuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(createPutAwayFailure, 'createPutAwayFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(editPutAway, 'editPutAway', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(editPutAwaySuccess, 'editPutAwaySuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(editPutAwayFailure, 'editPutAwayFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchBinList, 'fetchBinList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchBinListSuccess, 'fetchBinListSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchBinListFailure, 'fetchBinListFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(createBins, 'createBins', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(createBinsSuccess, 'createBinsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(createBinsFailure, 'createBinsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(selectWarehouseReceive, 'selectWarehouseReceive', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(resetCurrentWarehouseReceive, 'resetCurrentWarehouseReceive', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchBinListFromZone, 'fetchBinListFromZone', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchBinListFromZoneSuccess, 'fetchBinListFromZoneSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchBinListFromZoneFailure, 'fetchBinListFromZoneFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(autoPutaway, 'autoPutaway', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(autoPutawaySuccess, 'autoPutawaySuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(autoPutawayFailure, 'autoPutawayFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/putAway_actions.jsx');
	}();

	;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VirtualizedDetailedSelection = exports.DetailedSelection = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactVirtualizedSelect = __webpack_require__(203);
	
	var _reactVirtualizedSelect2 = _interopRequireDefault(_reactVirtualizedSelect);
	
	var _reactSelectFastFilterOptions = __webpack_require__(202);
	
	var _reactSelectFastFilterOptions2 = _interopRequireDefault(_reactSelectFastFilterOptions);
	
	__webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InventoryOption = _react2.default.createClass({
	  displayName: 'InventoryOption',
	
	  propTypes: {
	    children: _react2.default.PropTypes.node,
	    className: _react2.default.PropTypes.string,
	    isDisabled: _react2.default.PropTypes.bool,
	    isFocused: _react2.default.PropTypes.bool,
	    isSelected: _react2.default.PropTypes.bool,
	    onFocus: _react2.default.PropTypes.func,
	    onSelect: _react2.default.PropTypes.func,
	    option: _react2.default.PropTypes.object.isRequired
	  },
	
	  handleMouseDown: function handleMouseDown(event) {
	    event.preventDefault();
	    event.stopPropagation();
	    this.props.onSelect(this.props.option, event);
	  },
	  handleMouseEnter: function handleMouseEnter(event) {
	    this.props.onFocus(this.props.option, event);
	  },
	  handleMouseMove: function handleMouseMove(event) {
	    if (this.props.isFocused) return;
	    this.props.onFocus(this.props.option, event);
	  },
	  render: function render() {
	    var selectionStyle = {
	      borderRadius: 3,
	      display: 'inline-block',
	      marginRight: 10,
	      position: 'relative',
	      top: -2,
	      verticalAlign: 'middle',
	      whiteSpace: 'pre',
	      fontFamily: 'monospace',
	      fontSize: 10
	    };
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: this.props.className,
	        onMouseDown: this.handleMouseDown,
	        onMouseEnter: this.handleMouseEnter,
	        onMouseMove: this.handleMouseMove,
	        title: this.props.option.title
	      },
	      _react2.default.createElement(
	        'span',
	        { style: selectionStyle },
	        this.props.option.label
	      )
	    );
	  }
	});
	
	function VirtualizedInventoryOption(_ref) {
	  var focusedOption = _ref.focusedOption,
	      focusedOptionIndex = _ref.focusedOptionIndex,
	      focusOption = _ref.focusOption,
	      key = _ref.key,
	      labelKey = _ref.labelKey,
	      option = _ref.option,
	      options = _ref.options,
	      selectValue = _ref.selectValue,
	      style = _ref.style,
	      valueArray = _ref.valueArray;
	
	  var selectionStyle = {
	    borderRadius: 3,
	    display: 'inline-block',
	    marginRight: 10,
	    position: 'relative',
	    top: -2,
	    verticalAlign: 'middle',
	    whiteSpace: 'pre',
	    fontFamily: 'monospace',
	    fontSize: 10
	  };
	
	  var classNames = [];
	  if (option === focusedOption) {
	    classNames.push('vOptionFocused');
	  }
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: classNames.join(' '),
	      style: style,
	      key: key,
	      onClick: function onClick() {
	        return selectValue(option);
	      },
	      onMouseOver: function onMouseOver() {
	        return focusOption(option);
	      },
	      title: option.title
	    },
	    _react2.default.createElement(
	      'span',
	      { style: selectionStyle },
	      option.label
	    )
	  );
	}
	
	var DetailedSelection = exports.DetailedSelection = function (_Component) {
	  _inherits(DetailedSelection, _Component);
	
	  function DetailedSelection() {
	    _classCallCheck(this, DetailedSelection);
	
	    return _possibleConstructorReturn(this, (DetailedSelection.__proto__ || Object.getPrototypeOf(DetailedSelection)).apply(this, arguments));
	  }
	
	  _createClass(DetailedSelection, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          input = _props.input,
	          options = _props.options,
	          defaultValue = _props.defaultValue;
	
	      if (defaultValue) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 12 },
	              this.props.meta.touched && this.props.meta.error && _react2.default.createElement(
	                'span',
	                { className: 'parsley-error-message' },
	                this.props.meta.error
	              )
	            )
	          ),
	          _react2.default.createElement(_reactSelect2.default, _extends({
	            className: 'testSelect',
	            optionComponent: InventoryOption,
	            options: options
	          }, input, {
	            value: input.value.value || input.value || defaultValue.value,
	            onBlur: function onBlur() {
	              input.onBlur(input.value);
	            },
	            ref: 'select',
	            onInputKeyDown: this.props.onKeyPress
	          }))
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            this.props.meta.touched && this.props.meta.error && _react2.default.createElement(
	              'span',
	              { className: 'parsley-error-message' },
	              this.props.meta.error
	            )
	          )
	        ),
	        _react2.default.createElement(_reactSelect2.default, _extends({
	          className: 'testSelect',
	          optionComponent: InventoryOption,
	          options: options
	        }, input, {
	          value: input.value.value || input.value,
	          onBlur: function onBlur() {
	            input.onBlur(input.value);
	          },
	          ref: 'select',
	          onInputKeyDown: this.props.onKeyPress
	        }))
	      );
	    }
	  }]);
	
	  return DetailedSelection;
	}(_react.Component);
	
	var VirtualizedDetailedSelection = exports.VirtualizedDetailedSelection = function (_Component2) {
	  _inherits(VirtualizedDetailedSelection, _Component2);
	
	  function VirtualizedDetailedSelection() {
	    _classCallCheck(this, VirtualizedDetailedSelection);
	
	    return _possibleConstructorReturn(this, (VirtualizedDetailedSelection.__proto__ || Object.getPrototypeOf(VirtualizedDetailedSelection)).apply(this, arguments));
	  }
	
	  _createClass(VirtualizedDetailedSelection, [{
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          input = _props2.input,
	          options = _props2.options,
	          defaultValue = _props2.defaultValue;
	
	      var filterOptions = (0, _reactSelectFastFilterOptions2.default)({ options: options });
	
	      if (defaultValue) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 12 },
	              this.props.meta.touched && this.props.meta.error && _react2.default.createElement(
	                'span',
	                { className: 'parsley-error-message' },
	                this.props.meta.error
	              )
	            )
	          ),
	          _react2.default.createElement(_reactVirtualizedSelect2.default, _extends({
	            className: 'testSelect',
	            filterOptions: filterOptions,
	            optionRenderer: VirtualizedInventoryOption,
	            options: options
	          }, input, {
	            value: input.value.value || input.value || defaultValue.value,
	            onBlur: function onBlur() {
	              input.onBlur(input.value);
	            },
	            onInputKeyDown: this.props.onKeyPress
	          }))
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            this.props.meta.touched && this.props.meta.error && _react2.default.createElement(
	              'span',
	              { className: 'parsley-error-message' },
	              this.props.meta.error
	            )
	          )
	        ),
	        _react2.default.createElement(_reactVirtualizedSelect2.default, _extends({
	          className: 'testSelect',
	          filterOptions: filterOptions,
	          optionRenderer: VirtualizedInventoryOption,
	          options: options
	        }, input, {
	          value: input.value.value || input.value,
	          onBlur: function onBlur() {
	            input.onBlur(input.value);
	          },
	          onInputKeyDown: this.props.onKeyPress
	        }))
	      );
	    }
	  }]);
	
	  return VirtualizedDetailedSelection;
	}(_react.Component);
	
	var _default = DetailedSelection;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(VirtualizedInventoryOption, 'VirtualizedInventoryOption', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/detailedSelection.jsx');
	
	  __REACT_HOT_LOADER__.register(DetailedSelection, 'DetailedSelection', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/detailedSelection.jsx');
	
	  __REACT_HOT_LOADER__.register(VirtualizedDetailedSelection, 'VirtualizedDetailedSelection', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/detailedSelection.jsx');
	
	  __REACT_HOT_LOADER__.register(InventoryOption, 'InventoryOption', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/detailedSelection.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/detailedSelection.jsx');
	}();

	;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Time = function (_Component) {
	  _inherits(Time, _Component);
	
	  function Time() {
	    _classCallCheck(this, Time);
	
	    var _this = _possibleConstructorReturn(this, (Time.__proto__ || Object.getPrototypeOf(Time)).call(this));
	
	    var now = new Date();
	    _this.state = { time: now };
	    return _this;
	  }
	
	  _createClass(Time, [{
	    key: 'tick',
	    value: function tick() {
	      var now = new Date();
	      this.setState({ time: now });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.timerID = setInterval(function () {
	        _this2.tick();
	      }, 1000);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timerID);
	    }
	  }, {
	    key: 'pad',
	    value: function pad(n) {
	      return n < 10 ? "0" + n : n;
	    }
	  }, {
	    key: 'getTime',
	    value: function getTime() {
	      var time = this.state.time;
	
	      var hour = time.getHours();
	      var minute = time.getMinutes();
	      minute = this.pad(minute);
	      var half = '';
	      if (hour > 11) {
	        half = 'PM';
	        if (hour > 12) {
	          hour = hour - 12;
	        }
	      } else {
	        half = 'AM';
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          hour,
	          _react2.default.createElement(
	            'span',
	            { className: 'p-sm' },
	            ':'
	          ),
	          minute,
	          _react2.default.createElement(
	            'span',
	            { className: 'pl-sm' },
	            half
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var time = this.state.time;
	
	      var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	      return _react2.default.createElement(
	        'div',
	        { className: 'col-sm-5ths' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel widget' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'row-table' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 5, className: 'bg-purple-dark' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                time.getMonth() + 1,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'pl' },
	                  ' / ',
	                  this.state.time.getDate()
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 7 },
	              _react2.default.createElement(
	                'h3',
	                null,
	                dayNames[time.getDay()]
	              ),
	              this.getTime()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Time;
	}(_react.Component);
	
	var _default = Time;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Time, 'Time', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/time.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/time.jsx');
	}();

	;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(758),
	    baseFilter = __webpack_require__(764),
	    baseIteratee = __webpack_require__(88),
	    isArray = __webpack_require__(78);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity]
	 *  The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1413);

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1510);

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1704);

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(558);

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchCustomerFavorites = fetchCustomerFavorites;
	exports.fetchCustomerFavoritesSuccess = fetchCustomerFavoritesSuccess;
	exports.fetchCustomerFavoritesFailure = fetchCustomerFavoritesFailure;
	exports.selectCustomerFavorites = selectCustomerFavorites;
	exports.resetCurrentCustomerFavorites = resetCurrentCustomerFavorites;
	exports.fetchCustomerFavoritesDetail = fetchCustomerFavoritesDetail;
	exports.fetchCustomerFavoritesDetailSuccess = fetchCustomerFavoritesDetailSuccess;
	exports.fetchCustomerFavoritesDetailFailure = fetchCustomerFavoritesDetailFailure;
	exports.addNewCustomerFavorite = addNewCustomerFavorite;
	exports.addCustomerFavoriteSuccess = addCustomerFavoriteSuccess;
	exports.addCustomerFavoriteFailure = addCustomerFavoriteFailure;
	exports.deleteCustomerFavorite = deleteCustomerFavorite;
	exports.deleteCustomerFavoriteSuccess = deleteCustomerFavoriteSuccess;
	exports.deleteCustomerFavoriteFailure = deleteCustomerFavoriteFailure;
	exports.fetchCustomersWithFavorites = fetchCustomersWithFavorites;
	exports.fetchCustomersWithFavoritesSuccess = fetchCustomersWithFavoritesSuccess;
	exports.fetchCustomersWithFavoritesFailure = fetchCustomersWithFavoritesFailure;
	exports.inListError = inListError;
	exports.clearInListError = clearInListError;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Inventories Actions
	
	function fetchCustomerFavorites(Customer_id) {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_CUSTOMER_FAVORITES });
	        return _axios2.default.get(_url.CUSTOMERS_WITH_FAVORITES_URL + Customer_id, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchCustomerFavoritesSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchCustomerFavoritesFailure(err));
	        });
	    };
	}
	
	function fetchCustomerFavoritesSuccess(favorites) {
	    return {
	        type: _type.FETCH_CUSTOMER_FAVORITES_SUCCESS,
	        payload: favorites
	    };
	}
	
	function fetchCustomerFavoritesFailure(error) {
	    return {
	        type: _type.FETCH_CUSTOMER_FAVORITES_FAILURE,
	        payload: error
	    };
	}
	
	function selectCustomerFavorites(favorites) {
	    return {
	        type: _type.SELECT_CUSTOMER_FAVORITES,
	        payload: favorites
	    };
	}
	
	function resetCurrentCustomerFavorites() {
	    return {
	        type: _type.RESET_CURRENT_CUSTOMER_FAVORITES
	    };
	}
	
	function fetchCustomerFavoritesDetail(favorites_id) {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_CUSTOMER_FAVORITES_DETAIL });
	        return _axios2.default.get(_url.CUSTOMERS_WITH_FAVORITES_URL + favorites_id, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchCustomerFavoritesDetailSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchCustomerFavoritesDetailFailure(err));
	        });
	    };
	}
	
	function fetchCustomerFavoritesDetailSuccess(favoritesDetail) {
	    return {
	        type: _type.FETCH_CUSTOMER_FAVORITES_DETAIL_SUCCESS,
	        payload: favoritesDetail
	    };
	}
	
	function fetchCustomerFavoritesDetailFailure(error) {
	    return {
	        type: _type.FETCH_CUSTOMER_FAVORITES_DETAIL_FAILURE,
	        payload: error
	    };
	}
	
	function addNewCustomerFavorite(Sales_FavoriteList_Lines, SalesFavoriteList_id) {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_ADDING_CUSTOMER_FAVORITE });
	        _axios2.default.put(_url.CUSTOMER_FAVORITE_LIST + SalesFavoriteList_id, {
	            Sales_FavoriteList_Lines: Sales_FavoriteList_Lines
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(addCustomerFavoriteSuccess());
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(addCustomerFavoriteFailure(err));
	        });
	    };
	}
	
	function addCustomerFavoriteSuccess() {
	    return {
	        type: _type.ADD_CUSTOMER_FAVORITE_SUCCESS
	    };
	}
	
	function addCustomerFavoriteFailure(response) {
	    return {
	        type: _type.ADD_CUSTOMER_FAVORITE_FAILURE,
	        payload: response
	    };
	}
	
	function deleteCustomerFavorite(Product_id) {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_DELETE_CUSTOMER_FAVORITE });
	        _axios2.default.delete(_url.CUSTOMERS_WITH_FAVORITES_URL + 'line/' + Product_id, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(deleteCustomerFavoriteSuccess());
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(deleteCustomerFavoriteFailure());
	        });
	    };
	}
	
	function deleteCustomerFavoriteSuccess() {
	    return {
	        type: _type.DELETE_CUSTOMER_FAVORITE_SUCCESS
	    };
	}
	
	function deleteCustomerFavoriteFailure(response) {
	    return {
	        type: _type.DELETE_CUSTOMER_FAVORITE_FAILURE,
	        payload: response
	    };
	}
	
	function fetchCustomersWithFavorites() {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_CUSTOMERS_WITH_FAVORITES });
	        _axios2.default.get(_url.CUSTOMERS_WITH_FAVORITES_URL, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchCustomersWithFavoritesSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchCustomersWithFavoritesFailure(err));
	        });
	    };
	}
	
	function fetchCustomersWithFavoritesSuccess(response) {
	    return {
	        type: _type.FETCH_CUSTOMERS_WITH_FAVORITES_SUCCESS,
	        payload: response
	    };
	}
	
	function fetchCustomersWithFavoritesFailure(response) {
	    return {
	        type: _type.FETCH_CUSTOMERS_WITH_FAVORITES_FAILURE,
	        payload: response
	    };
	}
	
	function inListError() {
	    return {
	        type: _type.ITEM_IN_LIST
	    };
	}
	
	function clearInListError() {
	    return {
	        type: _type.CLEAR_IN_LIST_ERROR
	    };
	}
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(fetchCustomerFavorites, 'fetchCustomerFavorites', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favoriteList_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchCustomerFavoritesSuccess, 'fetchCustomerFavoritesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favoriteList_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchCustomerFavoritesFailure, 'fetchCustomerFavoritesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favoriteList_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(selectCustomerFavorites, 'selectCustomerFavorites', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favoriteList_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(resetCurrentCustomerFavorites, 'resetCurrentCustomerFavorites', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favoriteList_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchCustomerFavoritesDetail, 'fetchCustomerFavoritesDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favoriteList_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchCustomerFavoritesDetailSuccess, 'fetchCustomerFavoritesDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favoriteList_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchCustomerFavoritesDetailFailure, 'fetchCustomerFavoritesDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favoriteList_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(addNewCustomerFavorite, 'addNewCustomerFavorite', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favoriteList_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(addCustomerFavoriteSuccess, 'addCustomerFavoriteSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favoriteList_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(addCustomerFavoriteFailure, 'addCustomerFavoriteFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favoriteList_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(deleteCustomerFavorite, 'deleteCustomerFavorite', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favoriteList_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(deleteCustomerFavoriteSuccess, 'deleteCustomerFavoriteSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favoriteList_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(deleteCustomerFavoriteFailure, 'deleteCustomerFavoriteFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favoriteList_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchCustomersWithFavorites, 'fetchCustomersWithFavorites', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favoriteList_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchCustomersWithFavoritesSuccess, 'fetchCustomersWithFavoritesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favoriteList_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchCustomersWithFavoritesFailure, 'fetchCustomersWithFavoritesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favoriteList_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(inListError, 'inListError', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favoriteList_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(clearInListError, 'clearInListError', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/favoriteList_actions.jsx');
	}();

	;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createGroup = createGroup;
	exports.deleteGroup = deleteGroup;
	exports.fetchCustomerGroupsDetail = fetchCustomerGroupsDetail;
	exports.saveCustomerList = saveCustomerList;
	exports.fetchCustomerGroups = fetchCustomerGroups;
	exports.fetchCustomers = fetchCustomers;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *
	 * @param {String} name // Desired group name
	 * @param {Func} handleSuccess
	 * @param {Func} handleFailure
	 */
	function createGroup(name, handleSuccess, handleFailure) {
	  return (0, _axios2.default)({
	    method: 'post',
	    url: _url.CUSTOMER_GROUPS_URL,
	    data: {
	      Name: name
	    },
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (response) {
	    handleSuccess(response);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	}
	
	/**
	 *
	 * @param {Number} customerGroupId // Id of group to delete
	 * @param {Func} handleSuccess
	 * @param {Func} handleFailure
	 */
	function deleteGroup(customerGroupId, handleSuccess, handleFailure) {
	  return (0, _axios2.default)({
	    method: 'delete',
	    url: '' + _url.CUSTOMER_GROUPS_URL + customerGroupId,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (response) {
	    handleSuccess(response);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	}
	
	/**
	 *
	 * @param {Number} customerGroupId // Id of group details to fetch
	 * @param {Func} handleSuccess
	 * @param {Func} handleFailure
	 */
	function fetchCustomerGroupsDetail(customerGroupId, handleSuccess, handleFailure) {
	  return (0, _axios2.default)({
	    method: 'get',
	    url: '' + _url.CUSTOMER_GROUPS_URL + customerGroupId,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (response) {
	    handleSuccess(response);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	}
	
	/**
	 *
	 * @param {ArrayOf(Numbers)} customerIds // List of customers to add to specified group
	 * @param {String} customerGroupName // Name of group
	 * @param {Number} customerGroupId // Id of group
	 * @param {Func} handleSuccess
	 * @param {Func} handleFailure
	 */
	function saveCustomerList(customerIds, customerGroupName, customerGroupId, handleSuccess, handleFailure) {
	  return (0, _axios2.default)({
	    method: 'put',
	    url: '' + _url.CUSTOMER_GROUPS_URL + customerGroupId,
	    data: {
	      customer_ids: customerIds,
	      Name: customerGroupName
	    },
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (response) {
	    handleSuccess(response);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	}
	
	/**
	 *
	 * @param {Func} handleSuccess
	 * @param {Func} handleFailure
	 */
	function fetchCustomerGroups(handleSuccess, handleFailure) {
	  return (0, _axios2.default)({
	    method: 'get',
	    url: _url.CUSTOMER_GROUPS_URL,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (response) {
	    handleSuccess(response);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	}
	
	/**
	 *
	 * @param {Func} handleSuccess
	 * @param {Func} handleFailure
	 */
	function fetchCustomers(handleSuccess, handleFailure) {
	  return (0, _axios2.default)({
	    method: 'get',
	    url: _url.CUSTOMERS_URL + 'list',
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (response) {
	    handleSuccess(response);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(createGroup, 'createGroup', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/groupList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(deleteGroup, 'deleteGroup', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/groupList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerGroupsDetail, 'fetchCustomerGroupsDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/groupList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(saveCustomerList, 'saveCustomerList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/groupList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerGroups, 'fetchCustomerGroups', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/groupList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchCustomers, 'fetchCustomers', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/groupList_actions.jsx');
	}();

	;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.requestShipToOrders = requestShipToOrders;
	exports.fetchShipToOrdersSuccess = fetchShipToOrdersSuccess;
	exports.fetchShipToOrdersFailure = fetchShipToOrdersFailure;
	exports.fetchShipToOrders = fetchShipToOrders;
	exports.selectSalesOrder = selectSalesOrder;
	exports.resetCurrentSalesOrder = resetCurrentSalesOrder;
	exports.fetchSalesOrderDetail = fetchSalesOrderDetail;
	exports.requestSalesOrderDetail = requestSalesOrderDetail;
	exports.fetchSalesOrderDetailSuccess = fetchSalesOrderDetailSuccess;
	exports.fetchSalesOrderDetailFailure = fetchSalesOrderDetailFailure;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _root_url = __webpack_require__(9);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function requestShipToOrders() {
	  return {
	    type: _type.REQUEST_SHIP_TO_ORDERS
	  };
	}
	
	function fetchShipToOrdersSuccess(shipToOrders) {
	  return {
	    type: _type.FETCH_SHIP_TO_ORDERS_SUCCESS,
	    payload: shipToOrders
	  };
	}
	
	function fetchShipToOrdersFailure(error) {
	  return {
	    type: _type.FETCH_SHIP_TO_ORDERS_FAILURE,
	    payload: error
	  };
	}
	
	function fetchShipToOrders() {
	  return function (dispatch) {
	    dispatch(requestShipToOrders());
	    return _axios2.default.get(_url.SALE_STWH_ORDER_SEARCH_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchShipToOrdersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchShipToOrdersFailure(err));
	    });
	  };
	}
	
	function selectSalesOrder(salesOrder) {
	  return {
	    type: _type.SELECT_SALES_ORDER,
	    payload: salesOrder
	  };
	}
	
	function resetCurrentSalesOrder() {
	  return {
	    type: _type.RESET_CURRENT_SALES_ORDER
	  };
	}
	
	// Fetch the detail page.
	function fetchSalesOrderDetail(salesOrder_id, route) {
	  var url = route == 'salesOrders' ? _url.SALES_ORDERS_URL : _url.MOBILE_SALES_ORDERS_URL;
	  return function (dispatch) {
	    dispatch(requestSalesOrderDetail());
	    return _axios2.default.get(url + '?pk=' + salesOrder_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesOrderDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesOrderDetailFailure(err));
	    });
	  };
	}
	
	function requestSalesOrderDetail() {
	  return {
	    type: _type.REQUEST_SALES_ORDER_DETAIL
	  };
	}
	
	function fetchSalesOrderDetailSuccess(salesOrderDetail) {
	  salesOrderDetail = salesOrderDetail.data;
	  // The date data fetched is in the form of string, which needs to be modified into Date type
	  if (salesOrderDetail.OrderDate) salesOrderDetail.OrderDate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.OrderDate);
	  if (salesOrderDetail.ETADate) salesOrderDetail.ETADate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.ETADate);
	  if (salesOrderDetail.ReceivedDate) salesOrderDetail.ReceivedDate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.ReceivedDate);
	  if (salesOrderDetail.DispatchDate) salesOrderDetail.DispatchDate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.DispatchDate);
	  return {
	    type: _type.FETCH_SALES_ORDER_DETAIL_SUCCESS,
	    payload: salesOrderDetail
	  };
	}
	
	function fetchSalesOrderDetailFailure(error) {
	  return {
	    type: _type.FETCH_SALES_ORDER_DETAIL_FAILURE,
	    payload: error
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestShipToOrders, 'requestShipToOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/shipToOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchShipToOrdersSuccess, 'fetchShipToOrdersSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/shipToOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchShipToOrdersFailure, 'fetchShipToOrdersFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/shipToOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchShipToOrders, 'fetchShipToOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/shipToOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(selectSalesOrder, 'selectSalesOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/shipToOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetCurrentSalesOrder, 'resetCurrentSalesOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/shipToOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderDetail, 'fetchSalesOrderDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/shipToOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestSalesOrderDetail, 'requestSalesOrderDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/shipToOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderDetailSuccess, 'fetchSalesOrderDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/shipToOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderDetailFailure, 'fetchSalesOrderDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/shipToOrders_actions.js');
	}();

	;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _selection = __webpack_require__(21);
	
	var _arap_actions = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountDropdown = function (_Component) {
	  _inherits(AccountDropdown, _Component);
	
	  function AccountDropdown() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AccountDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AccountDropdown.__proto__ || Object.getPrototypeOf(AccountDropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      accountOptions: []
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AccountDropdown, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.clearARAccounts();
	      this.props.fetchARAccounts();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.accountList && this.props.accountList !== nextProps.accountList) {
	        this.setAccountOptions(nextProps.accountList);
	      }
	    }
	  }, {
	    key: 'setAccountOptions',
	    value: function setAccountOptions(accounts) {
	      var accountOptions = [];
	      if (accounts) {
	        accounts.map(function (account) {
	          accountOptions.push({
	            value: account.Account_id || account.id,
	            label: account.Name || account.name
	          });
	        });
	      }
	      this.setState({ accountOptions: accountOptions });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.accountsIsLoading && !this.props.accountsError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.accountsError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'something_unexpected_happened' })
	          )
	        );
	      }
	      var accountOptions = this.state.accountOptions;
	
	      return _react2.default.createElement(_reduxForm.Field, _extends({}, this.props, { name: 'Account', component: _selection.Selection, options: accountOptions }));
	    }
	  }]);
	
	  return AccountDropdown;
	}(_react.Component);
	
	/*
	  arAccounts: {
	    accountList,
	    accountsIsLoading,
	    accountsError,
	  }
	*/
	
	
	function mapStateToProps(state) {
	  return _extends({}, state.arap.arAccounts);
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchARAccounts: _arap_actions.fetchARAccounts,
	  clearARAccounts: _arap_actions.clearARAccounts
	})(AccountDropdown);
	
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/accountDropdown.jsx');
	
	  __REACT_HOT_LOADER__.register(AccountDropdown, 'AccountDropdown', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/accountDropdown.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/accountDropdown.jsx');
	}();

	;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AfterAddonPercentControlField = exports.AfterAddonPercentField = exports.DisabledAfterAddonField = exports.AfterAddonField = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	__webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AfterAddonField = exports.AfterAddonField = function (_Component) {
	  _inherits(AfterAddonField, _Component);
	
	  function AfterAddonField() {
	    _classCallCheck(this, AfterAddonField);
	
	    return _possibleConstructorReturn(this, (AfterAddonField.__proto__ || Object.getPrototypeOf(AfterAddonField)).apply(this, arguments));
	  }
	
	  _createClass(AfterAddonField, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          input = _props.input,
	          options = _props.options,
	          onFocus = _props.onFocus;
	
	      if (onFocus != null) {
	        return _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, {
	          ref: function ref(input) {
	            _this2.myInput = input;
	          },
	          onKeyPress: this.props.onKeyPress,
	          standalone: true,
	          type: 'text',
	          addonAfter: '.00',
	          style: { zIndex: 0 },
	          onFocus: onFocus
	        }));
	      }
	      return _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, {
	        ref: function ref(input) {
	          _this2.myInput = input;
	        },
	        onKeyPress: this.props.onKeyPress,
	        standalone: true,
	        type: 'text',
	        addonAfter: '.00',
	        style: { zIndex: 0 }
	      }));
	    }
	  }]);
	
	  return AfterAddonField;
	}(_react.Component);
	
	var DisabledAfterAddonField = exports.DisabledAfterAddonField = function (_Component2) {
	  _inherits(DisabledAfterAddonField, _Component2);
	
	  function DisabledAfterAddonField() {
	    _classCallCheck(this, DisabledAfterAddonField);
	
	    return _possibleConstructorReturn(this, (DisabledAfterAddonField.__proto__ || Object.getPrototypeOf(DisabledAfterAddonField)).apply(this, arguments));
	  }
	
	  _createClass(DisabledAfterAddonField, [{
	    key: 'render',
	    value: function render() {
	      var input = this.props.input;
	
	      return _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { standalone: true, disabled: true, type: 'text', addonAfter: '.00' }));
	    }
	  }]);
	
	  return DisabledAfterAddonField;
	}(_react.Component);
	
	var AfterAddonPercentField = exports.AfterAddonPercentField = function (_Component3) {
	  _inherits(AfterAddonPercentField, _Component3);
	
	  function AfterAddonPercentField() {
	    _classCallCheck(this, AfterAddonPercentField);
	
	    return _possibleConstructorReturn(this, (AfterAddonPercentField.__proto__ || Object.getPrototypeOf(AfterAddonPercentField)).apply(this, arguments));
	  }
	
	  _createClass(AfterAddonPercentField, [{
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var input = this.props.input;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.meta.touched && this.props.meta.error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          this.props.meta.error
	        ),
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { ref: function ref(input) {
	            _this5.myInput = input;
	          }, standalone: true, type: 'text', addonAfter: '%' }))
	      );
	    }
	  }]);
	
	  return AfterAddonPercentField;
	}(_react.Component);
	
	var AfterAddonPercentControlField = exports.AfterAddonPercentControlField = function (_Component4) {
	  _inherits(AfterAddonPercentControlField, _Component4);
	
	  function AfterAddonPercentControlField() {
	    _classCallCheck(this, AfterAddonPercentControlField);
	
	    return _possibleConstructorReturn(this, (AfterAddonPercentControlField.__proto__ || Object.getPrototypeOf(AfterAddonPercentControlField)).apply(this, arguments));
	  }
	
	  _createClass(AfterAddonPercentControlField, [{
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var _props2 = this.props,
	          input = _props2.input,
	          onFocus = _props2.onFocus,
	          placeholder = _props2.placeholder;
	
	      if (this.props.decimal) {
	        var decimal = parseInt(this.props.decimal);
	        placeholder = (parseFloat(placeholder) || 0).toFixed(decimal);
	      }
	      if (onFocus != null) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          this.props.meta.touched && this.props.meta.error && _react2.default.createElement(
	            'span',
	            { className: 'parsley-error-message' },
	            this.props.meta.error
	          ),
	          _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { standalone: true, type: 'text', ref: function ref(input) {
	              _this7.myInput = input;
	            }, onKeyPress: this.props.onKeyPress, addonAfter: '%', value: placeholder, onChange: this.props.onChange, onFocus: onFocus }))
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.meta.touched && this.props.meta.error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          this.props.meta.error
	        ),
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { standalone: true, type: 'text', ref: function ref(input) {
	            _this7.myInput = input;
	          }, onKeyPress: this.props.onKeyPress, addonAfter: '%', value: placeholder, onChange: this.props.onChange }))
	      );
	    }
	  }]);
	
	  return AfterAddonPercentControlField;
	}(_react.Component);
	
	var _default = AfterAddonField;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(AfterAddonField, 'AfterAddonField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/afterAddonField.jsx');
	
	  __REACT_HOT_LOADER__.register(DisabledAfterAddonField, 'DisabledAfterAddonField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/afterAddonField.jsx');
	
	  __REACT_HOT_LOADER__.register(AfterAddonPercentField, 'AfterAddonPercentField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/afterAddonField.jsx');
	
	  __REACT_HOT_LOADER__.register(AfterAddonPercentControlField, 'AfterAddonPercentControlField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/afterAddonField.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/afterAddonField.jsx');
	}();

	;

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PaymentMethodOptions = [{ value: 'Check', label: 'Check' }, { value: 'DirDep', label: 'Dir. Dep.' }, { value: 'MoneyOrder', label: 'Money Order' }, { value: 'CompanyCheck', label: 'Company Chk' }, { value: 'Cash', label: 'Cash' }, { value: 'PersonalCheck', label: 'Personal Chk' }, { value: 'WireTransfer', label: 'Wire Transfer' }, { value: 'CreditCard', label: 'Credit Card' }, { value: 'Stripe', label: 'Stripe' }, { value: 'BadDebt', label: 'Bad Debt' }];
	
	var _default = PaymentMethodOptions;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PaymentMethodOptions, 'PaymentMethodOptions', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/arapPaymentOptions.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/arapPaymentOptions.js');
	}();

	;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExcelColumn = _reactDataGrid.shapes.ExcelColumn;
	
	var FilterMultiKeyword = function (_React$Component) {
	  _inherits(FilterMultiKeyword, _React$Component);
	
	  function FilterMultiKeyword(props) {
	    _classCallCheck(this, FilterMultiKeyword);
	
	    var _this = _possibleConstructorReturn(this, (FilterMultiKeyword.__proto__ || Object.getPrototypeOf(FilterMultiKeyword)).call(this, props));
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.inputRef = null;
	    return _this;
	  }
	
	  _createClass(FilterMultiKeyword, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var getValidFilterValues = this.props.getValidFilterValues;
	
	      if (_lodash2.default.isFunction(getValidFilterValues)) {
	        this.inputRef.value = getValidFilterValues(this.props.column.key);
	      }
	    }
	  }, {
	    key: 'filterValues',
	    value: function filterValues(row, columnFilter, columnKey) {
	      if (columnFilter.filterTerm == null) {
	        return true;
	      }
	      var result = true;
	      var value = '';
	      // implement default filter logic
	      if (row[columnKey] !== null) {
	        value = row[columnKey].toLowerCase();
	      }
	      var rule = columnFilter.filterTerm;
	      rule.map(function (r) {
	        if (r !== null) {
	          result = result && value.includes(r.toLowerCase());
	        }
	      });
	      return result;
	    }
	  }, {
	    key: 'getRules',
	    value: function getRules(value) {
	      var rules = value.split(' ');
	      return rules;
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(e) {
	      var value = e.target.value;
	      var filters = this.getRules(value);
	      this.props.onChange({ filterTerm: filters.length > 0 ? filters : null, column: this.props.column, rawValue: value, filterValues: this.filterValues });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var inputKey = 'filter-multi-keyword' + this.props.column.key;
	      var columnStyle = {
	        float: 'left',
	        marginRight: 0,
	        marginTop: '5px',
	        maxWidth: '100%'
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: columnStyle },
	        _react2.default.createElement('input', { ref: function ref(inputRef) {
	            return _this2.inputRef = inputRef;
	          }, key: inputKey, type: 'text', placeholder: 'Multi Keywords Search', className: 'form-control input-sm multiKeyword', onChange: this.handleChange })
	      );
	    }
	  }]);
	
	  return FilterMultiKeyword;
	}(_react2.default.Component);
	
	FilterMultiKeyword.propTypes = {
	  onChange: _react2.default.PropTypes.func.isRequired,
	  column: _react2.default.PropTypes.shape(ExcelColumn)
	};
	
	var _default = FilterMultiKeyword;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ExcelColumn, 'ExcelColumn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/filterMultiKeyword.jsx');
	
	  __REACT_HOT_LOADER__.register(FilterMultiKeyword, 'FilterMultiKeyword', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/filterMultiKeyword.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/filterMultiKeyword.jsx');
	}();

	;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(61);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IsActive = function (_Component) {
	  _inherits(IsActive, _Component);
	
	  function IsActive() {
	    _classCallCheck(this, IsActive);
	
	    return _possibleConstructorReturn(this, (IsActive.__proto__ || Object.getPrototypeOf(IsActive)).apply(this, arguments));
	  }
	
	  _createClass(IsActive, [{
	    key: 'render',
	
	    // Bad implementation, cannot set the value attribute of Input componnet to a boolean.
	    value: function render() {
	      var input = this.props.input;
	
	      var titleClass = (0, _classnames2.default)({ 'parsley-error-label': this.props.meta.touched && this.props.meta.error }, 'control-label');
	      return _react2.default.createElement(
	        'div',
	        { className: 'boolean-field' },
	        this.props.meta.touched && this.props.meta.error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          this.props.meta.error
	        ),
	        _react2.default.createElement(
	          'label',
	          { className: titleClass },
	          this.props.labelName
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'boolean-input' },
	          _react2.default.createElement(
	            'label',
	            { className: 'boolean' },
	            _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { type: 'radio', value: true, checked: input.value === true || input.value === 'true' })),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'boolean' },
	            _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { type: 'radio', value: false, checked: input.value === false || input.value === 'false' })),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	          )
	        )
	      );
	
	      // backup copy of return in case anything goes wrong fall back to this
	      // return (
	      //   <div>
	      //     <Row><Col sm={ 12 }>{this.props.meta.touched && this.props.meta.error && <span className="parsley-error-message">{this.props.meta.error}</span>}</Col></Row>
	      //     <Row className="marginTopStyle">
	      //         <label className="marginTopStyle textAlignStyle" className={titleClass}>{this.props.labelName}</label>
	      //         <Col sm={ 2 }></Col>
	      //         <Col sm={ 2 }>
	      //             <label>
	      //                  <Input {...input} type="radio" value={true} checked={input.value == true || input.value == "true" }/><Translate value="yes" />
	      //             </label>
	      //         </Col>
	      //         <Col sm={ 2 }>
	      //             <label>
	      //                 <Input {...input} type="radio" value={false} checked={input.value == false || input.value == "false" }/><Translate value="no" />
	      //             </label>
	      //         </Col>
	      //     </Row>
	      //   </div>
	      // )
	    }
	  }]);
	
	  return IsActive;
	}(_react.Component);
	
	var _default = IsActive;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(IsActive, 'IsActive', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/isActive.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/isActive.jsx');
	}();

	;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _numberWithCommas = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PercentFormatter = function (_Component) {
	  _inherits(PercentFormatter, _Component);
	
	  function PercentFormatter() {
	    _classCallCheck(this, PercentFormatter);
	
	    return _possibleConstructorReturn(this, (PercentFormatter.__proto__ || Object.getPrototypeOf(PercentFormatter)).apply(this, arguments));
	  }
	
	  _createClass(PercentFormatter, [{
	    key: 'render',
	    value: function render() {
	      var value = this.props.value;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        value !== null && !isNaN(value) && (0, _numberWithCommas.numberWithCommas)(value) + '%'
	      );
	    }
	  }]);
	
	  return PercentFormatter;
	}(_react.Component);
	
	var _default = PercentFormatter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PercentFormatter, 'PercentFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/percentFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/percentFormatter.jsx');
	}();

	;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _products_actions = __webpack_require__(30);
	
	var _packageTypes = __webpack_require__(416);
	
	var packageTypes = (0, _reduxForm.reduxForm)({
	  form: 'packageTypes'
	})(_packageTypes.PackageTypes);
	
	function mapStateToProps(state) {
	  return {
	    packageTypesFetched: state.products.packageTypesFetched,
	    fetchingPackageTypes: state.products.fetchingPackageTypes,
	    packageTypeFetchError: state.products.packageTypeFetchError,
	    editingPackageTypes: state.products.editingPackageTypes,
	    packageTypesEdited: state.products.packageTypesEdited,
	    packageTypeEditError: state.products.packageTypeEditError,
	    deletingPackageTypes: state.products.deletingPackageTypes,
	    deletePackageTypesSuccess: state.products.deletePackageTypesSuccess,
	    deletePackageTypesError: state.products.deletePackageTypesError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchPackageTypes: _products_actions.fetchPackageTypes, editPackageType: _products_actions.editPackageType, clearPackageTypeEdited: _products_actions.clearPackageTypeEdited, deletePackageType: _products_actions.deletePackageType
	})(packageTypes);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/packageTypes.jsx');
	
	  __REACT_HOT_LOADER__.register(packageTypes, 'packageTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/packageTypes.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/packageTypes.jsx');
	}();

	;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _vendorForm = __webpack_require__(421);
	
	var _vendorForm2 = _interopRequireDefault(_vendorForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	    return {
	        currentVendor: state.vendors.currentVendor,
	        isCreating: state.vendors.isCreating,
	        createError: state.vendors.createError,
	        created: state.vendors.created,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.Name) {
	        errors.Name = 'Required';
	    }
	
	    return errors;
	};
	
	var vendorForm = (0, _reduxForm.reduxForm)({
	    form: 'vendorForm',
	    validate: validate
	})(_vendorForm2.default);
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(vendorForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/vendorForm.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/vendorForm.jsx');
	
	    __REACT_HOT_LOADER__.register(vendorForm, 'vendorForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/vendorForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/vendorForm.jsx');
	}();

	;

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1509);

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1708);

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1737);

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1794);

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(338);

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchReasons = fetchReasons;
	exports.fetchReasonsSuccess = fetchReasonsSuccess;
	exports.fetchReasonsFailure = fetchReasonsFailure;
	exports.createReason = createReason;
	exports.createReasonSuccess = createReasonSuccess;
	exports.createReasonFailure = createReasonFailure;
	exports.editReason = editReason;
	exports.editReasonSuccess = editReasonSuccess;
	exports.editReasonsFailure = editReasonsFailure;
	exports.deleteReason = deleteReason;
	exports.deleteReasonSuccess = deleteReasonSuccess;
	exports.deleteReasonFailure = deleteReasonFailure;
	exports.selectReason = selectReason;
	exports.resetCurrentReason = resetCurrentReason;
	exports.grabAdjustmentLogs = grabAdjustmentLogs;
	exports.grabAdjustmentLogsSuccess = grabAdjustmentLogsSuccess;
	exports.grabAdjustmentLogsFailure = grabAdjustmentLogsFailure;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	var _type = __webpack_require__(14);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchReasons() {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_REASONS });
	        return _axios2.default.get(_url.ADJUSTMENT_INVENTORY_URL, {
	            headers: { Authorization: "Bearer " + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchReasonsSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.status = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchReasonsFailure(err));
	        });
	    };
	}
	
	function fetchReasonsSuccess(data) {
	    return {
	        type: _type.REQUEST_REASONS_SUCCESS,
	        payload: data
	    };
	}
	
	function fetchReasonsFailure(err) {
	    return {
	        type: _type.REQUEST_REASONS_FAILURE,
	        payload: err
	    };
	}
	
	function createReason(_ref) {
	    var ReasonDesc = _ref.ReasonDesc;
	
	    return function (dispatch) {
	        dispatch({ type: _type.START_REASON_CREATION });
	        return _axios2.default.post(_url.ADJUSTMENT_INVENTORY_URL + "/", [{
	            ReasonDesc: ReasonDesc
	        }], {
	            headers: { Authorization: "Bearer " + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(createReasonSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.status = _constants.DEFAULT_ERROR;
	            }
	            dispatch(createReasonFailure(err));
	        });
	    };
	}
	
	function createReasonSuccess(data) {
	    return {
	        type: _type.REASON_CREATION_SUCCESS,
	        payload: data
	    };
	}
	
	function createReasonFailure(err) {
	    return {
	        type: _type.REASON_CREATION_FAILURE,
	        payload: err
	    };
	}
	
	function editReason(_ref2, id) {
	    var ReasonDesc = _ref2.ReasonDesc;
	
	    return function (dispatch) {
	        dispatch({ type: _type.START_REASON_EDITING });
	        return _axios2.default.post(_url.ADJUSTMENT_INVENTORY_URL + "/", [{
	            id: id,
	            ReasonDesc: ReasonDesc
	        }], {
	            headers: { Authorization: "Bearer " + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(editReasonSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.status = _constants.DEFAULT_ERROR;
	            }
	            dispatch(editReasonsFailure(err));
	        });
	    };
	}
	
	function editReasonSuccess(data) {
	    return {
	        type: _type.REASON_EDITING_SUCCESS,
	        payload: data
	    };
	}
	
	function editReasonsFailure(err) {
	    return {
	        type: _type.REASON_EDITING_FAILURE,
	        payload: err
	    };
	}
	
	function deleteReason(id) {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_DELETE_REASON });
	        return _axios2.default.delete(_url.ADJUSTMENT_INVENTORY_URL + "/" + id, {
	            headers: { Authorization: "Bearer " + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(deleteReasonSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status == 404) {
	                err.status = _constants.DEFAULT_ERROR;
	            }
	            dispatch(deleteReasonFailure(err));
	        });
	    };
	}
	
	function deleteReasonSuccess(data) {
	    return {
	        type: _type.REASON_DELETE_SUCCESS,
	        payload: data
	    };
	}
	
	function deleteReasonFailure(err) {
	    return {
	        type: _type.REASON_DELETE_FAILURE,
	        payload: err
	    };
	}
	
	function selectReason(data) {
	    return {
	        type: _type.SELECT_REASON,
	        payload: data
	    };
	}
	
	function resetCurrentReason() {
	    return {
	        type: _type.RESET_CURRENT_REASON
	    };
	}
	
	function grabAdjustmentLogs(limit) {
	    if (!limit) {
	        limit = 100;
	    }
	
	    var page = 1;
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_ADJUSTMENT_LOGS });
	        return _axios2.default.get(_root_url.ROOT_URL + "v1/adjustment-inventory/?limit=" + limit + "&page=" + page, {
	            headers: { Authorization: "Bearer " + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(grabAdjustmentLogsSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.status = _constants.DEFAULT_ERROR;
	            }
	            dispatch(grabAdjustmentLogsFailure(err));
	        });
	    };
	}
	
	function grabAdjustmentLogsSuccess(data) {
	    return {
	        type: _type.ADJUSTMENT_LOG_SUCCESS,
	        payload: data
	    };
	}
	
	function grabAdjustmentLogsFailure(err) {
	    return {
	        type: _type.ADJUSTMENT_LOG_FAILURE,
	        payload: err
	    };
	}
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(fetchReasons, "fetchReasons", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/adjustmentInventory_actions.js");
	
	    __REACT_HOT_LOADER__.register(fetchReasonsSuccess, "fetchReasonsSuccess", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/adjustmentInventory_actions.js");
	
	    __REACT_HOT_LOADER__.register(fetchReasonsFailure, "fetchReasonsFailure", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/adjustmentInventory_actions.js");
	
	    __REACT_HOT_LOADER__.register(createReason, "createReason", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/adjustmentInventory_actions.js");
	
	    __REACT_HOT_LOADER__.register(createReasonSuccess, "createReasonSuccess", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/adjustmentInventory_actions.js");
	
	    __REACT_HOT_LOADER__.register(createReasonFailure, "createReasonFailure", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/adjustmentInventory_actions.js");
	
	    __REACT_HOT_LOADER__.register(editReason, "editReason", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/adjustmentInventory_actions.js");
	
	    __REACT_HOT_LOADER__.register(editReasonSuccess, "editReasonSuccess", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/adjustmentInventory_actions.js");
	
	    __REACT_HOT_LOADER__.register(editReasonsFailure, "editReasonsFailure", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/adjustmentInventory_actions.js");
	
	    __REACT_HOT_LOADER__.register(deleteReason, "deleteReason", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/adjustmentInventory_actions.js");
	
	    __REACT_HOT_LOADER__.register(deleteReasonSuccess, "deleteReasonSuccess", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/adjustmentInventory_actions.js");
	
	    __REACT_HOT_LOADER__.register(deleteReasonFailure, "deleteReasonFailure", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/adjustmentInventory_actions.js");
	
	    __REACT_HOT_LOADER__.register(selectReason, "selectReason", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/adjustmentInventory_actions.js");
	
	    __REACT_HOT_LOADER__.register(resetCurrentReason, "resetCurrentReason", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/adjustmentInventory_actions.js");
	
	    __REACT_HOT_LOADER__.register(grabAdjustmentLogs, "grabAdjustmentLogs", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/adjustmentInventory_actions.js");
	
	    __REACT_HOT_LOADER__.register(grabAdjustmentLogsSuccess, "grabAdjustmentLogsSuccess", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/adjustmentInventory_actions.js");
	
	    __REACT_HOT_LOADER__.register(grabAdjustmentLogsFailure, "grabAdjustmentLogsFailure", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/adjustmentInventory_actions.js");
	}();

	;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchAgentList = fetchAgentList;
	exports.changeAgentStatus = changeAgentStatus;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _isEmpty = __webpack_require__(191);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cleanAgentList = function cleanAgentList() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return !(0, _isEmpty2.default)(data) ? data.map(function (agent) {
	    return {
	      id: agent.id,
	      phone: agent.phone,
	      email: agent.email,
	      userId: agent.userId,
	      isActive: agent.is_active,
	      firstName: agent.first_name,
	      lastName: agent.last_name,
	      action: agent.is_active ? 'deactivate' : 'activate'
	    };
	  }) : [];
	};
	
	function fetchAgentList(handleSuccess, handleFailure) {
	  var url = _url.BASE_USER_URL + 'agent/';
	  (0, _axios2.default)({
	    method: 'get',
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	    url: url
	  }).then(function (response) {
	    handleSuccess(cleanAgentList(response.data));
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err);
	  });
	}
	
	function changeAgentStatus(id, isActive, handleSuccess, handleFailure) {
	  var url = _url.BASE_USER_URL + 'agent/' + id + '/';
	  (0, _axios2.default)({
	    method: 'put',
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	    data: {
	      is_active: isActive
	    },
	    url: url
	  }).then(function () {
	    handleSuccess();
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err);
	  });
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchAgentList, 'fetchAgentList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/agents_actions.js');
	
	  __REACT_HOT_LOADER__.register(changeAgentStatus, 'changeAgentStatus', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/agents_actions.js');
	
	  __REACT_HOT_LOADER__.register(cleanAgentList, 'cleanAgentList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/agents_actions.js');
	}();

	;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchInventoryAdjustments = fetchInventoryAdjustments;
	exports.fetchInventoryAdjustmentsSuccess = fetchInventoryAdjustmentsSuccess;
	exports.fetchInventoryAdjustmentsFailure = fetchInventoryAdjustmentsFailure;
	exports.fetchInventoryAdjustmentsDetail = fetchInventoryAdjustmentsDetail;
	exports.fetchInventoryAdjustmentsDetailSuccess = fetchInventoryAdjustmentsDetailSuccess;
	exports.fetchInventoryAdjustmentsDetailFailure = fetchInventoryAdjustmentsDetailFailure;
	exports.selectInventoryAdjustment = selectInventoryAdjustment;
	exports.resetCurrentInventoryAdjustment = resetCurrentInventoryAdjustment;
	exports.fetchInventoryAdjustmentDetail = fetchInventoryAdjustmentDetail;
	exports.fetchInventoryAdjustmentDetailSuccess = fetchInventoryAdjustmentDetailSuccess;
	exports.fetchInventoryAdjustmentDetailFailure = fetchInventoryAdjustmentDetailFailure;
	exports.createInventoryAdjustment = createInventoryAdjustment;
	exports.createInventoryAdjustmentSuccess = createInventoryAdjustmentSuccess;
	exports.createInventoryAdjustmentFailure = createInventoryAdjustmentFailure;
	exports.editInventoryAdjustment = editInventoryAdjustment;
	exports.editInventoryAdjustmentSuccess = editInventoryAdjustmentSuccess;
	exports.editInventoryAdjustmentFailure = editInventoryAdjustmentFailure;
	exports.quickAdjustment = quickAdjustment;
	exports.quickAdjustmentSuccess = quickAdjustmentSuccess;
	exports.quickAdjustmentFailure = quickAdjustmentFailure;
	exports.resetQuickInventoryAdjustments = resetQuickInventoryAdjustments;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// InventoryAdjustments Actions
	
	function fetchInventoryAdjustments() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_INVENTORY_ADJUSTMENTS });
	    return _axios2.default.get(_url.INVENTORY_ADJUSTMENTS_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchInventoryAdjustmentsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchInventoryAdjustmentsFailure(err));
	    });
	  };
	}
	
	function fetchInventoryAdjustmentsSuccess(inventoryAdjustments) {
	  return {
	    type: _type.FETCH_INVENTORY_ADJUSTMENTS_SUCCESS,
	    payload: inventoryAdjustments
	  };
	}
	
	function fetchInventoryAdjustmentsFailure(error) {
	  return {
	    type: _type.FETCH_INVENTORY_ADJUSTMENTS_FAILURE,
	    payload: error
	  };
	}
	
	function fetchInventoryAdjustmentsDetail(id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_INVENTORY_ADJUSTMENTS_DETAIL });
	    return _axios2.default.get(_url.INVENTORY_ADJUSTMENTS_URL + '?pk=' + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchInventoryAdjustmentsDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchInventoryAdjustmentsDetailFailure(err));
	    });
	  };
	}
	
	function fetchInventoryAdjustmentsDetailSuccess(data) {
	  return {
	    type: _type.FETCH_INVENTORY_ADJUSTMENTS_DETAIL_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchInventoryAdjustmentsDetailFailure(error) {
	  return {
	    type: _type.FETCH_INVENTORY_ADJUSTMENTS_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function selectInventoryAdjustment(inventoryAdjustment) {
	  return {
	    type: _type.SELECT_INVENTORY_ADJUSTMENT,
	    payload: inventoryAdjustment
	  };
	}
	
	function resetCurrentInventoryAdjustment() {
	  return {
	    type: _type.RESET_CURRENT_INVENTORY_ADJUSTMENT
	  };
	}
	
	function fetchInventoryAdjustmentDetail(inventoryAdjustment_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_INVENTORY_ADJUSTMENT_DETAIL });
	    return _axios2.default.get(_url.INVENTORY_ADJUSTMENTS_URL + inventoryAdjustment_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchInventoryAdjustmentDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchInventoryAdjustmentDetailFailure(err));
	    });
	  };
	}
	
	function fetchInventoryAdjustmentDetailSuccess(inventoryAdjustmentDetail) {
	  inventoryAdjustmentDetail = inventoryAdjustmentDetail.data;
	  if (inventoryAdjustmentDetail.PostingDate) inventoryAdjustmentDetail.PostingDate = (0, _cleanDates.convertUtcDate)(inventoryAdjustmentDetail.PostingDate);
	  return {
	    type: _type.FETCH_INVENTORY_ADJUSTMENT_DETAIL_SUCCESS,
	    payload: inventoryAdjustmentDetail
	  };
	}
	
	function fetchInventoryAdjustmentDetailFailure(error) {
	  return {
	    type: _type.FETCH_INVENTORY_ADJUSTMENT_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function createInventoryAdjustment(Warehouse_id, PostingDate, Note, Warehouse_Adjustment_Line) {
	  if (PostingDate) PostingDate = (0, _cleanDates.convertUtcDate)(PostingDate);
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CREATING_INVENTORY_ADJUSTMENTS });
	    _axios2.default.post(_url.INVENTORY_ADJUSTMENTS_URL, {
	      Warehouse_id: Warehouse_id,
	      PostingDate: PostingDate,
	      Note: Note,
	      Warehouse_Adjustment_Line: Warehouse_Adjustment_Line
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(createInventoryAdjustmentSuccess());
	      _reactRouter.browserHistory.push('/inventories/adjustment');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(createInventoryAdjustmentFailure(err));
	    });
	  };
	}
	
	function createInventoryAdjustmentSuccess() {
	  return {
	    type: _type.CREATE_INVENTORY_ADJUSTMENTS_SUCCESS
	  };
	}
	
	function createInventoryAdjustmentFailure(error) {
	  return {
	    type: _type.CREATE_INVENTORY_ADJUSTMENTS_FAILURE,
	    payload: error
	  };
	}
	
	function editInventoryAdjustment(WarehouseAdjustment_id, Warehouse_id, PostingDate, Note, Warehouse_Adjustment_Line) {
	  if (PostingDate) PostingDate = (0, _cleanDates.convertUtcDate)(PostingDate);
	  if (Warehouse_Adjustment_Line) {
	    Warehouse_Adjustment_Line.map(function (line) {
	      line.WarehouseBin_id = line.WarehouseBin_id.WarehouseBin_id;
	      line.WarehouseZone_id = line.WarehouseZone_id.WarehouseZone_id;
	    });
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_EDITING_INVENTORY_ADJUSTMENTS });
	    _axios2.default.put(_url.INVENTORY_ADJUSTMENTS_URL + WarehouseAdjustment_id, {
	      Warehouse_id: Warehouse_id,
	      PostingDate: PostingDate,
	      Note: Note,
	      Warehouse_Adjustment_Line: Warehouse_Adjustment_Line
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editInventoryAdjustmentSuccess());
	      _reactRouter.browserHistory.push('/inventories/adjustment');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(editInventoryAdjustmentFailure(err));
	    });
	  };
	}
	
	function editInventoryAdjustmentSuccess() {
	  return {
	    type: _type.EDIT_INVENTORY_ADJUSTMENTS_SUCCESS
	  };
	}
	
	function editInventoryAdjustmentFailure(error) {
	  return {
	    type: _type.EDIT_INVENTORY_ADJUSTMENTS_FAILURE,
	    payload: error
	  };
	}
	
	function quickAdjustment(_ref, Warehouse_Adjustment_Line) {
	  var ProductNum = _ref.ProductNum,
	      Warehouse_id = _ref.Warehouse_id;
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_QUICK_INVENTORY_ADJUSTMENTS });
	    _axios2.default.post(_url.QUICK_INVENTORY_ADJUSTMENTS_URL, {
	      ProductNum: ProductNum,
	      Warehouse_id: Warehouse_id,
	      Warehouse_Adjustment_Line: Warehouse_Adjustment_Line
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(quickAdjustmentSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(quickAdjustmentFailure(err));
	    });
	  };
	}
	
	function quickAdjustmentSuccess() {
	  return {
	    type: _type.QUICK_INVENTORY_ADJUSTMENTS_SUCCESS
	  };
	}
	
	function quickAdjustmentFailure(error) {
	  return {
	    type: _type.QUICK_INVENTORY_ADJUSTMENTS_FAILURE,
	    payload: error
	  };
	}
	
	function resetQuickInventoryAdjustments() {
	  return {
	    type: _type.RESET_QUICK_INVENTORY_ADJUSTMENTS
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchInventoryAdjustments, 'fetchInventoryAdjustments', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryAdjustments_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchInventoryAdjustmentsSuccess, 'fetchInventoryAdjustmentsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryAdjustments_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchInventoryAdjustmentsFailure, 'fetchInventoryAdjustmentsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryAdjustments_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchInventoryAdjustmentsDetail, 'fetchInventoryAdjustmentsDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryAdjustments_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchInventoryAdjustmentsDetailSuccess, 'fetchInventoryAdjustmentsDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryAdjustments_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchInventoryAdjustmentsDetailFailure, 'fetchInventoryAdjustmentsDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryAdjustments_actions.js');
	
	  __REACT_HOT_LOADER__.register(selectInventoryAdjustment, 'selectInventoryAdjustment', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryAdjustments_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetCurrentInventoryAdjustment, 'resetCurrentInventoryAdjustment', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryAdjustments_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchInventoryAdjustmentDetail, 'fetchInventoryAdjustmentDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryAdjustments_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchInventoryAdjustmentDetailSuccess, 'fetchInventoryAdjustmentDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryAdjustments_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchInventoryAdjustmentDetailFailure, 'fetchInventoryAdjustmentDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryAdjustments_actions.js');
	
	  __REACT_HOT_LOADER__.register(createInventoryAdjustment, 'createInventoryAdjustment', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryAdjustments_actions.js');
	
	  __REACT_HOT_LOADER__.register(createInventoryAdjustmentSuccess, 'createInventoryAdjustmentSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryAdjustments_actions.js');
	
	  __REACT_HOT_LOADER__.register(createInventoryAdjustmentFailure, 'createInventoryAdjustmentFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryAdjustments_actions.js');
	
	  __REACT_HOT_LOADER__.register(editInventoryAdjustment, 'editInventoryAdjustment', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryAdjustments_actions.js');
	
	  __REACT_HOT_LOADER__.register(editInventoryAdjustmentSuccess, 'editInventoryAdjustmentSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryAdjustments_actions.js');
	
	  __REACT_HOT_LOADER__.register(editInventoryAdjustmentFailure, 'editInventoryAdjustmentFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryAdjustments_actions.js');
	
	  __REACT_HOT_LOADER__.register(quickAdjustment, 'quickAdjustment', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryAdjustments_actions.js');
	
	  __REACT_HOT_LOADER__.register(quickAdjustmentSuccess, 'quickAdjustmentSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryAdjustments_actions.js');
	
	  __REACT_HOT_LOADER__.register(quickAdjustmentFailure, 'quickAdjustmentFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryAdjustments_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetQuickInventoryAdjustments, 'resetQuickInventoryAdjustments', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryAdjustments_actions.js');
	}();

	;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchInventoryRelocations = fetchInventoryRelocations;
	exports.fetchInventoryRelocationsSuccess = fetchInventoryRelocationsSuccess;
	exports.fetchInventoryRelocationsFailure = fetchInventoryRelocationsFailure;
	exports.selectInventoryRelocation = selectInventoryRelocation;
	exports.resetCurrentInventoryRelocation = resetCurrentInventoryRelocation;
	exports.fetchInventoryRelocationDetail = fetchInventoryRelocationDetail;
	exports.fetchInventoryRelocationDetailSuccess = fetchInventoryRelocationDetailSuccess;
	exports.fetchInventoryRelocationDetailFailure = fetchInventoryRelocationDetailFailure;
	exports.createInventoryRelocation = createInventoryRelocation;
	exports.createInventoryRelocationSuccess = createInventoryRelocationSuccess;
	exports.createInventoryRelocationFailure = createInventoryRelocationFailure;
	exports.editInventoryRelocation = editInventoryRelocation;
	exports.editInventoryRelocationSuccess = editInventoryRelocationSuccess;
	exports.editInventoryRelocationFailure = editInventoryRelocationFailure;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchInventoryRelocations() {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_INVENTORY_RELOCATIONS });
	        return _axios2.default.get(_url.INVENTORY_RELOCATIONS_URL, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchInventoryRelocationsSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchInventoryRelocationsFailure(err));
	        });
	    };
	}
	
	// InventoryRelocations Actions
	function fetchInventoryRelocationsSuccess(inventoryRelocations) {
	    return {
	        type: _type.FETCH_INVENTORY_RELOCATIONS_SUCCESS,
	        payload: inventoryRelocations
	    };
	}
	
	function fetchInventoryRelocationsFailure(error) {
	    return {
	        type: _type.FETCH_INVENTORY_RELOCATIONS_FAILURE,
	        payload: error
	    };
	}
	
	function selectInventoryRelocation(inventoryRelocation) {
	    return {
	        type: _type.SELECT_INVENTORY_RELOCATION,
	        payload: inventoryRelocation
	    };
	}
	
	function resetCurrentInventoryRelocation() {
	    return {
	        type: _type.RESET_CURRENT_INVENTORY_RELOCATION
	    };
	}
	
	function fetchInventoryRelocationDetail(inventoryRelocation_id) {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_INVENTORY_RELOCATION_DETAIL });
	        return _axios2.default.get(_url.INVENTORY_RELOCATIONS_URL + inventoryRelocation_id, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchInventoryRelocationDetailSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchInventoryRelocationDetailFailure(err));
	        });
	    };
	}
	
	function fetchInventoryRelocationDetailSuccess(inventoryRelocationDetail) {
	    inventoryRelocationDetail = inventoryRelocationDetail.data;
	    if (inventoryRelocationDetail.PostingDate) inventoryRelocationDetail.PostingDate = (0, _cleanDates.convertUtcDate)(inventoryRelocationDetail.PostingDate);
	    return {
	        type: _type.FETCH_INVENTORY_RELOCATION_DETAIL_SUCCESS,
	        payload: inventoryRelocationDetail
	    };
	}
	
	function fetchInventoryRelocationDetailFailure(error) {
	    return {
	        type: _type.FETCH_INVENTORY_RELOCATION_DETAIL_FAILURE,
	        payload: error
	    };
	}
	
	function createInventoryRelocation(Warehouse_id, PostingDate, Note, Warehouse_Relocation_Line) {
	    if (PostingDate) PostingDate = (0, _cleanDates.convertUtcDate)(PostingDate);else PostingDate = (0, _cleanDates.convertUtcDate)();
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_CREATING_INVENTORY_RELOCATION });
	        _axios2.default.post(_url.INVENTORY_RELOCATIONS_URL, {
	            Warehouse_id: Warehouse_id,
	            PostingDate: PostingDate,
	            Note: Note,
	            Warehouse_Relocation_Line: Warehouse_Relocation_Line
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(createInventoryRelocationSuccess());
	            _reactRouter.browserHistory.push('/inventories/relocation');
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(createInventoryRelocationFailure(err));
	        });
	    };
	}
	
	function createInventoryRelocationSuccess() {
	    return {
	        type: _type.CREATE_INVENTORY_RELOCATION_SUCCESS
	    };
	}
	
	function createInventoryRelocationFailure(error) {
	    return {
	        type: _type.CREATE_INVENTORY_RELOCATION_FAILURE,
	        payload: error
	    };
	}
	
	function editInventoryRelocation(WarehouseRelocation_id, Warehouse_id, PostingDate, Note, Warehouse_Relocation_Line) {
	    if (PostingDate) PostingDate = (0, _cleanDates.convertUtcDate)(PostingDate);else PostingDate = (0, _cleanDates.convertUtcDate)();
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_EDITING_INVENTORY_RELOCATION });
	        _axios2.default.put(_url.INVENTORY_RELOCATIONS_URL + WarehouseRelocation_id, {
	            Warehouse_id: Warehouse_id,
	            PostingDate: PostingDate,
	            Note: Note,
	            Warehouse_Relocation_Line: Warehouse_Relocation_Line
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(editInventoryRelocationSuccess());
	            _reactRouter.browserHistory.push('/inventories/relocation');
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(editInventoryRelocationFailure(err));
	        });
	    };
	}
	
	function editInventoryRelocationSuccess() {
	    return {
	        type: _type.EDIT_INVENTORY_RELOCATION_SUCCESS
	    };
	}
	
	function editInventoryRelocationFailure(error) {
	    return {
	        type: _type.EDIT_INVENTORY_RELOCATION_FAILURE,
	        payload: error
	    };
	}
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(fetchInventoryRelocations, 'fetchInventoryRelocations', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRelocations_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchInventoryRelocationsSuccess, 'fetchInventoryRelocationsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRelocations_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchInventoryRelocationsFailure, 'fetchInventoryRelocationsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRelocations_actions.js');
	
	    __REACT_HOT_LOADER__.register(selectInventoryRelocation, 'selectInventoryRelocation', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRelocations_actions.js');
	
	    __REACT_HOT_LOADER__.register(resetCurrentInventoryRelocation, 'resetCurrentInventoryRelocation', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRelocations_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchInventoryRelocationDetail, 'fetchInventoryRelocationDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRelocations_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchInventoryRelocationDetailSuccess, 'fetchInventoryRelocationDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRelocations_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchInventoryRelocationDetailFailure, 'fetchInventoryRelocationDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRelocations_actions.js');
	
	    __REACT_HOT_LOADER__.register(createInventoryRelocation, 'createInventoryRelocation', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRelocations_actions.js');
	
	    __REACT_HOT_LOADER__.register(createInventoryRelocationSuccess, 'createInventoryRelocationSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRelocations_actions.js');
	
	    __REACT_HOT_LOADER__.register(createInventoryRelocationFailure, 'createInventoryRelocationFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRelocations_actions.js');
	
	    __REACT_HOT_LOADER__.register(editInventoryRelocation, 'editInventoryRelocation', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRelocations_actions.js');
	
	    __REACT_HOT_LOADER__.register(editInventoryRelocationSuccess, 'editInventoryRelocationSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRelocations_actions.js');
	
	    __REACT_HOT_LOADER__.register(editInventoryRelocationFailure, 'editInventoryRelocationFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRelocations_actions.js');
	}();

	;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PurchaseOrderListEpic = exports.uploadPOPOD = exports.savePOImages = exports.fetchPOImages = exports.deletePOImage = undefined;
	exports.fetchPurchaseOrdersByFilter = fetchPurchaseOrdersByFilter;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isEcity = _root_url.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://ctstage-scm.truckxi.com/api/';
	
	var deletePOImage = exports.deletePOImage = function deletePOImage(imageid, success, failed) {
	  (0, _axios2.default)({
	    method: 'DELETE',
	    url: _root_url.ROOT_URL + 'v1/purchase/po_images_delete/' + imageid,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    success(res);
	  }).catch(function (err) {
	    failed();
	  });
	};
	
	var fetchPOImages = exports.fetchPOImages = function fetchPOImages(poid, success, failed) {
	  (0, _axios2.default)({
	    method: 'GET',
	    url: _root_url.ROOT_URL + 'v2/purchase/order/' + poid + '?depth=1',
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    success(res);
	  }).catch(function (err) {
	    failed();
	  });
	};
	
	var savePOImages = exports.savePOImages = function savePOImages(poid, images, success, failed) {
	  var data = new FormData();
	  for (var i = 0; i < images.length; i++) {
	    data.append('images', images[i].file[0]);
	  }
	  (0, _axios2.default)({
	    method: 'POST',
	    url: _root_url.ROOT_URL + 'v1/purchase/upload_po_images/' + poid,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	    data: data
	  }).then(function (res) {
	    success();
	  }).catch(function (err) {
	    failed();
	  });
	};
	
	var uploadPOPOD = exports.uploadPOPOD = function uploadPOPOD(poid, formData, success, failed) {
	  return function (dispatch) {
	    (0, _axios2.default)({
	      method: 'POST',
	      url: _root_url.ROOT_URL + 'v1/purchase/upload_pod_file/' + poid,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      data: formData
	    }).then(function (res) {
	      success();
	    }).catch(function (err) {
	      failed();
	    });
	  };
	};
	
	function fetchPurchaseOrdersByFilter(postingDateGT, postingDateLT, days, orderStatus, orderUser, searchProductNum) {
	  var status = orderStatus;
	  var user = orderUser;
	  var productNum = searchProductNum;
	  var dates = (0, _cleanDates.toFromDates)(days, postingDateGT, postingDateLT);
	  if (status === 'all') {
	    status = '';
	  } else if (status === 'Partial') {
	    status = '&PurchaseStatus=Partially%20Received';
	  } else {
	    status = '&PurchaseStatus=' + status;
	  }
	  if (user) {
	    user = isEcity ? '&vendor__default_purchaser_user_id=' + user : '&Purchaser_User_id=' + user;
	  } else {
	    user = '';
	  }
	
	  if (productNum) {
	    productNum = '&ProductNum=' + productNum;
	  } else {
	    productNum = '';
	  }
	  return function (dispatch) {
	    dispatch({
	      type: _type.REQUEST_PURCHASE_ORDERS_BY_FILTER,
	      payload: {
	        dates: dates,
	        status: status,
	        user: user,
	        productNum: productNum
	      }
	    });
	  };
	}
	
	var PurchaseOrderListEpic = exports.PurchaseOrderListEpic = function PurchaseOrderListEpic(action$) {
	  return action$.ofType(_type.REQUEST_PURCHASE_ORDERS_BY_FILTER).switchMap(function (action) {
	    return _axios2.default.get(_url.PURCHASE_URL + 'search/?OrderDate__gte=' + action.payload.dates.fromDate + '&OrderDate__lte=' + action.payload.dates.toDate + action.payload.status + action.payload.user + action.payload.productNum, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  }).map(function (response) {
	    return { type: _type.FETCH_PURCHASE_ORDERS_SUCCESS, payload: response };
	  }).catch(function (err) {
	    return { type: _type.FETCH_PURCHASE_ORDERS_FAILURE, payload: err };
	  });
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(deletePOImage, 'deletePOImage', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPOImages, 'fetchPOImages', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(savePOImages, 'savePOImages', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(uploadPOPOD, 'uploadPOPOD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPurchaseOrdersByFilter, 'fetchPurchaseOrdersByFilter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(PurchaseOrderListEpic, 'PurchaseOrderListEpic', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseOrderList_actions.jsx');
	}();

	;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchPurchaseReturns = fetchPurchaseReturns;
	exports.requestPurchaseReturns = requestPurchaseReturns;
	exports.fetchPurchaseReturnsSuccess = fetchPurchaseReturnsSuccess;
	exports.fetchPurchaseReturnsFailure = fetchPurchaseReturnsFailure;
	exports.selectPurchaseReturn = selectPurchaseReturn;
	exports.selectVendor = selectVendor;
	exports.resetCurrentPurchaseReturn = resetCurrentPurchaseReturn;
	exports.fetchPurchaseReturnDetail = fetchPurchaseReturnDetail;
	exports.requestPurchaseReturnDetail = requestPurchaseReturnDetail;
	exports.fetchPurchaseReturnDetailSuccess = fetchPurchaseReturnDetailSuccess;
	exports.fetchPurchaseReturnDetailFailure = fetchPurchaseReturnDetailFailure;
	exports.createPurchaseReturn = createPurchaseReturn;
	exports.createPurchaseReturnSuccess = createPurchaseReturnSuccess;
	exports.createPurchaseReturnFailure = createPurchaseReturnFailure;
	exports.editPurchaseReturn = editPurchaseReturn;
	exports.editPurchaseReturnSuccess = editPurchaseReturnSuccess;
	exports.editPurchaseReturnFailure = editPurchaseReturnFailure;
	exports.completePurchaseReturn = completePurchaseReturn;
	exports.completePurchaseReturnSuccess = completePurchaseReturnSuccess;
	exports.completePurchaseReturnFailure = completePurchaseReturnFailure;
	exports.voidPurchaseReturn = voidPurchaseReturn;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchPurchaseReturns(FromDate, ToDate, days, Status) {
	    var dates = (0, _cleanDates.toFromDates)(days, FromDate, ToDate);
	    var fromDate = '?PostingDate__gte=' + dates.fromDate;
	    var toDate = '&PostingDate__lte=' + dates.toDate;
	    var status = Status && Status !== 'all' ? '&ReturnStatus=' + Status : '';
	    return function (dispatch) {
	        dispatch(requestPurchaseReturns());
	        return _axios2.default.get(_url.PURCHASE_RETURNS_URL + fromDate + toDate + status, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchPurchaseReturnsSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchPurchaseReturnsFailure(err));
	        });
	    };
	}
	
	function requestPurchaseReturns() {
	    return {
	        type: _type.REQUEST_PURCHASE_RETURNS
	    };
	}
	
	function fetchPurchaseReturnsSuccess(purchaseReturns) {
	    return {
	        type: _type.FETCH_PURCHASE_RETURNS_SUCCESS,
	        payload: purchaseReturns
	    };
	}
	
	function fetchPurchaseReturnsFailure(error) {
	    return {
	        type: _type.FETCH_PURCHASE_RETURNS_FAILURE,
	        payload: error
	    };
	}
	
	function selectPurchaseReturn(purchaseReturn) {
	    return {
	        type: _type.SELECT_PURCHASE_RETURN,
	        payload: purchaseReturn
	    };
	}
	
	function selectVendor(vendor) {
	    return {
	        type: _type.SELECT_VENDOR,
	        payload: vendor
	    };
	}
	
	function resetCurrentPurchaseReturn() {
	    return {
	        type: _type.RESET_CURRENT_PURCHASE_RETURN
	    };
	}
	
	// Fetch the detail page.
	
	function fetchPurchaseReturnDetail(pr_id, prc_id) {
	    return function (dispatch) {
	        dispatch(requestPurchaseReturnDetail());
	        if (prc_id) {
	            return _axios2.default.get(_url.PURCHASE_RETURNS_URL + 'completed/' + prc_id, {
	                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	            }).then(function (response) {
	                dispatch(fetchPurchaseReturnDetailSuccess(response));
	            }, function (err) {
	                if (err.status === 500 || err.status === 404) {
	                    err.data = _constants.DEFAULT_ERROR;
	                }
	                dispatch(fetchPurchaseReturnDetailFailure(err));
	            });
	        } else {
	            return _axios2.default.get(_url.PURCHASE_RETURNS_URL + pr_id, {
	                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	            }).then(function (response) {
	                dispatch(fetchPurchaseReturnDetailSuccess(response));
	            }, function (err) {
	                if (err.status === 500 || err.status === 404) {
	                    err.data = _constants.DEFAULT_ERROR;
	                }
	                dispatch(fetchPurchaseReturnDetailFailure(err));
	            });
	        }
	    };
	}
	
	function requestPurchaseReturnDetail() {
	    return {
	        type: _type.REQUEST_PURCHASE_RETURN_DETAIL
	    };
	}
	
	function fetchPurchaseReturnDetailSuccess(purchaseReturnDetail) {
	    purchaseReturnDetail = purchaseReturnDetail.data;
	    if (purchaseReturnDetail.ReturnDate) purchaseReturnDetail.ReturnDate = (0, _cleanDates.convertUtcDate)(purchaseReturnDetail.ReturnDate);
	    return {
	        type: _type.FETCH_PURCHASE_RETURN_DETAIL_SUCCESS,
	        payload: purchaseReturnDetail
	    };
	}
	
	// export function fetchPurchaseReturnCompletedDetail(pr_id) {
	//     return dispatch => {
	//         dispatch(requestPurchaseReturnCompletedDetail());
	//         return axios.get(PURCHASE_RETURNS_URL + pr_id,
	//             {
	//                 headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	//             }
	//         )
	//             .then(response => {
	//                 dispatch(fetchPurchaseReturnCompletedDetailSuccess(response));
	//             })
	//             .catch(response => {
	//                 dispatch(fetchPurchaseReturnCompletedDetailFailure(response));
	//             })
	//     }
	// }
	//
	// export function requestPurchaseReturnCompletedDetail() {
	//     return {
	//         type: REQUEST_PURCHASE_RETURN_DETAIL,
	//     };
	// }
	//
	// export function fetchPurchaseReturnCompletedDetailSuccess(purchaseReturnDetail) {
	//     purchaseReturnDetail = purchaseReturnDetail.data;
	//     if(purchaseReturnDetail.ReturnDate) purchaseReturnDetail.ReturnDate = new Date(purchaseReturnDetail.ReturnDate);
	//     return {
	//         type: FETCH_PURCHASE_RETURN_DETAIL_SUCCESS,
	//         payload: purchaseReturnDetail
	//     };
	// }
	
	function fetchPurchaseReturnDetailFailure(error) {
	    return {
	        type: _type.FETCH_PURCHASE_RETURN_DETAIL_FAILURE,
	        payload: error
	    };
	}
	
	function createPurchaseReturn(_ref, Purchase_Return_Line, isPurchaseCredit) {
	    var PostingDate = _ref.PostingDate,
	        ReturnReason = _ref.ReturnReason,
	        FinalNetWeight = _ref.FinalNetWeight,
	        FinalShippingWeight = _ref.FinalShippingWeight,
	        TotalPrice = _ref.TotalPrice,
	        NoteToVendor = _ref.NoteToVendor,
	        ReleaseInformation = _ref.ReleaseInformation,
	        CarryType = _ref.CarryType,
	        Discount = _ref.Discount,
	        ShippingCost = _ref.ShippingCost,
	        HandlingCost = _ref.HandlingCost,
	        Adjustment = _ref.Adjustment,
	        PurchaseStatus = _ref.PurchaseStatus,
	        MiscCost = _ref.MiscCost,
	        MiscNote = _ref.MiscNote,
	        TaxRate = _ref.TaxRate,
	        PaymentStatus = _ref.PaymentStatus,
	        FinalPrice = _ref.FinalPrice,
	        Vendor_id = _ref.Vendor_id,
	        Deliver_VendorDetail_id = _ref.Deliver_VendorDetail_id,
	        Pickup_Warehouse_id = _ref.Pickup_Warehouse_id,
	        DispatchMethod_id = _ref.DispatchMethod_id,
	        DispatchOutSourceContact_id = _ref.DispatchOutSourceContact_id,
	        Purchaser_User_id = _ref.Purchaser_User_id,
	        Modifier_User_id = _ref.Modifier_User_id,
	        PaymentTerm_id = _ref.PaymentTerm_id,
	        ShippingMethod = _ref.ShippingMethod,
	        MemoNum = _ref.MemoNum;
	
	    // Purchase_Return_Line.map(
	    //     product => {
	    //         // product.WarehouseBin_id = product.WarehouseBin_id.WarehouseBin_id || product.WarehouseBin_id;
	    //         // product.WarehouseZone_id = product.WarehouseZone_id.WarehouseZone_id || product.WarehouseZone_id;
	    //         if (product.Product_id)
	    //             product.Product_id = product.Product_id.value || product.Product_id;
	    //     }
	    // )
	    if (PostingDate) PostingDate = (0, _cleanDates.convertUtcDate)(PostingDate);
	    if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
	    if (PaymentStatus) PaymentStatus = PaymentStatus.value || PaymentStatus;
	    if (Deliver_VendorDetail_id) Deliver_VendorDetail_id = Deliver_VendorDetail_id.value || Deliver_VendorDetail_id;
	    if (CarryType) CarryType = CarryType.value || CarryType;
	    if (ReturnReason) ReturnReason = ReturnReason.value || ReturnReason;
	    if (Pickup_Warehouse_id) Pickup_Warehouse_id = Pickup_Warehouse_id.value || Pickup_Warehouse_id;
	    if (PaymentTerm_id) PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
	    if (ShippingMethod) ShippingMethod = ShippingMethod.value || ShippingMethod;
	
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_CREATING_PURCHASE_RETURN });
	
	        return _axios2.default.post(_url.PURCHASE_RETURNS_URL, {
	            Purchase_Return_Line: Purchase_Return_Line,
	            PostingDate: PostingDate,
	            ReturnReason: ReturnReason,
	            TotalPrice: TotalPrice,
	            NoteToVendor: NoteToVendor,
	            ReleaseInformation: ReleaseInformation,
	            CarryType: CarryType,
	            Discount: Discount,
	            ShippingCost: ShippingCost,
	            HandlingCost: HandlingCost,
	            Adjustment: Adjustment,
	            PurchaseStatus: PurchaseStatus,
	            MiscCost: MiscCost,
	            MiscNote: MiscNote,
	            TaxRate: TaxRate,
	            PaymentStatus: PaymentStatus,
	            FinalPrice: FinalPrice,
	            Vendor_id: Vendor_id,
	            Deliver_VendorDetail_id: Deliver_VendorDetail_id,
	            Pickup_Warehouse_id: Pickup_Warehouse_id,
	            DispatchMethod_id: DispatchMethod_id,
	            DispatchOutSourceContact_id: DispatchOutSourceContact_id,
	            Purchaser_User_id: Purchaser_User_id,
	            Modifier_User_id: Modifier_User_id,
	            PaymentTerm_id: PaymentTerm_id,
	            ShippingMethod: ShippingMethod,
	            MemoNum: MemoNum,
	            IsPurchaseCredit: isPurchaseCredit
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(createPurchaseReturnSuccess());
	            _reactRouter.browserHistory.push('/purchaseReturn');
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(createPurchaseReturnFailure(err));
	        });
	    };
	}
	
	function createPurchaseReturnSuccess() {
	    return {
	        type: _type.CREATE_PURCHASE_RETURN_SUCCESS
	    };
	}
	
	function createPurchaseReturnFailure(error) {
	    return {
	        type: _type.CREATE_PURCHASE_RETURN_FAILURE,
	        payload: error
	    };
	}
	
	function editPurchaseReturn(_ref2, Purchase_Return_Line) {
	    var PurchaseReturnCompleted_id = _ref2.PurchaseReturnCompleted_id,
	        PurchaseReturn_id = _ref2.PurchaseReturn_id,
	        PostingDate = _ref2.PostingDate,
	        ReturnReason = _ref2.ReturnReason,
	        FinalNetWeight = _ref2.FinalNetWeight,
	        FinalShippingWeight = _ref2.FinalShippingWeight,
	        TotalPrice = _ref2.TotalPrice,
	        NoteToVendor = _ref2.NoteToVendor,
	        ReleaseInformation = _ref2.ReleaseInformation,
	        CarryType = _ref2.CarryType,
	        Discount = _ref2.Discount,
	        ShippingCost = _ref2.ShippingCost,
	        HandlingCost = _ref2.HandlingCost,
	        Adjustment = _ref2.Adjustment,
	        PurchaseStatus = _ref2.PurchaseStatus,
	        MiscCost = _ref2.MiscCost,
	        MiscNote = _ref2.MiscNote,
	        TaxRate = _ref2.TaxRate,
	        PaymentStatus = _ref2.PaymentStatus,
	        FinalPrice = _ref2.FinalPrice,
	        Vendor_id = _ref2.Vendor_id,
	        Deliver_VendorDetail_id = _ref2.Deliver_VendorDetail_id,
	        Pickup_Warehouse_id = _ref2.Pickup_Warehouse_id,
	        DispatchMethod_id = _ref2.DispatchMethod_id,
	        DispatchOutSourceContact_id = _ref2.DispatchOutSourceContact_id,
	        Purchaser_User_id = _ref2.Purchaser_User_id,
	        Modifier_User_id = _ref2.Modifier_User_id,
	        PaymentTerm_id = _ref2.PaymentTerm_id,
	        ShippingMethod = _ref2.ShippingMethod,
	        MemoNum = _ref2.MemoNum;
	
	    FinalShippingWeight = 0;
	    Purchase_Return_Line.map(function (product) {
	        if (product.WarehouseBin_id) product.WarehouseBin_id = product.WarehouseBin_id.WarehouseBin_id || product.WarehouseBin_id;
	        if (product.WarehouseZone_id) product.WarehouseZone_id = product.WarehouseZone_id.WarehouseZone_id || product.WarehouseZone_id;
	        if (product.Product_id) product.Product_id = product.Product_id.value || product.Product_id;
	    });
	    if (PostingDate) PostingDate = (0, _cleanDates.convertUtcDate)(PostingDate);
	    if (ShippingMethod) ShippingMethod = ShippingMethod.value || ShippingMethod;
	    if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
	    if (PaymentStatus) PaymentStatus = PaymentStatus.value || PaymentStatus;
	    if (Deliver_VendorDetail_id) Deliver_VendorDetail_id = Deliver_VendorDetail_id.value || Deliver_VendorDetail_id;
	    if (CarryType) CarryType = CarryType.value || CarryType;
	    if (ReturnReason) ReturnReason = ReturnReason.value || ReturnReason;
	    if (Pickup_Warehouse_id) Pickup_Warehouse_id = Pickup_Warehouse_id.value || Pickup_Warehouse_id;
	    if (PaymentTerm_id) PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
	    if (PurchaseReturnCompleted_id) {
	        var Purchase_Return_Line_Completed = Purchase_Return_Line;
	        return function (dispatch) {
	            dispatch({ type: _type.REQUEST_EDITING_PURCHASE_RETURN });
	            _axios2.default.put(_url.PURCHASE_RETURNS_URL + 'completed/' + PurchaseReturnCompleted_id, {
	                Purchase_Return_Line_Completed: Purchase_Return_Line_Completed,
	                PostingDate: PostingDate,
	                ReturnReason: ReturnReason,
	                FinalNetWeight: FinalNetWeight,
	                FinalShippingWeight: FinalShippingWeight,
	                TotalPrice: TotalPrice,
	                NoteToVendor: NoteToVendor,
	                ReleaseInformation: ReleaseInformation,
	                CarryType: CarryType,
	                Discount: Discount,
	                ShippingCost: ShippingCost,
	                HandlingCost: HandlingCost,
	                Adjustment: Adjustment,
	                PurchaseStatus: PurchaseStatus,
	                MiscCost: MiscCost,
	                MiscNote: MiscNote,
	                TaxRate: TaxRate,
	                PaymentStatus: PaymentStatus,
	                FinalPrice: FinalPrice,
	                Vendor_id: Vendor_id,
	                Deliver_VendorDetail_id: Deliver_VendorDetail_id,
	                Pickup_Warehouse_id: Pickup_Warehouse_id,
	                DispatchMethod_id: DispatchMethod_id,
	                DispatchOutSourceContact_id: DispatchOutSourceContact_id,
	                Purchaser_User_id: Purchaser_User_id,
	                Modifier_User_id: Modifier_User_id,
	                PaymentTerm_id: PaymentTerm_id,
	                MemoNum: MemoNum
	            }, {
	                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	            }).then(function (response) {
	                dispatch(editPurchaseReturnSuccess());
	                _reactRouter.browserHistory.push('/purchaseReturn'); // If editd succesfully, refresh the paymentTerm page.
	            }, function (err) {
	                if (err.status === 500 || err.status === 404) {
	                    err.data = _constants.DEFAULT_ERROR;
	                }
	                dispatch(editPurchaseReturnFailure(err));
	            });
	        };
	    } else {
	        return function (dispatch) {
	            dispatch({ type: _type.REQUEST_EDITING_PURCHASE_RETURN });
	            _axios2.default.put(_url.PURCHASE_RETURNS_URL + PurchaseReturn_id, {
	                Purchase_Return_Line: Purchase_Return_Line,
	                PostingDate: PostingDate,
	                ReturnReason: ReturnReason,
	                FinalNetWeight: FinalNetWeight,
	                FinalShippingWeight: FinalShippingWeight,
	                TotalPrice: TotalPrice,
	                NoteToVendor: NoteToVendor,
	                ReleaseInformation: ReleaseInformation,
	                CarryType: CarryType,
	                Discount: Discount,
	                ShippingCost: ShippingCost,
	                HandlingCost: HandlingCost,
	                Adjustment: Adjustment,
	                PurchaseStatus: PurchaseStatus,
	                MiscCost: MiscCost,
	                MiscNote: MiscNote,
	                TaxRate: TaxRate,
	                PaymentStatus: PaymentStatus,
	                FinalPrice: FinalPrice,
	                Vendor_id: Vendor_id,
	                Deliver_VendorDetail_id: Deliver_VendorDetail_id,
	                Pickup_Warehouse_id: Pickup_Warehouse_id,
	                DispatchMethod_id: DispatchMethod_id,
	                DispatchOutSourceContact_id: DispatchOutSourceContact_id,
	                Purchaser_User_id: Purchaser_User_id,
	                Modifier_User_id: Modifier_User_id,
	                PaymentTerm_id: PaymentTerm_id,
	                MemoNum: MemoNum
	            }, {
	                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	            }).then(function (response) {
	                dispatch(editPurchaseReturnSuccess());
	                _reactRouter.browserHistory.push('/purchaseReturn'); // If editd succesfully, refresh the paymentTerm page.
	            }, function (err) {
	                if (err.status === 500 || err.status === 404) {
	                    err.data = _constants.DEFAULT_ERROR;
	                }
	                dispatch(editPurchaseReturnFailure(err));
	            });
	        };
	    }
	}
	
	function editPurchaseReturnSuccess() {
	    return {
	        type: _type.EDIT_PURCHASE_RETURN_SUCCESS
	    };
	}
	
	function editPurchaseReturnFailure(error) {
	    return {
	        type: _type.EDIT_PURCHASE_RETURN_FAILURE,
	        payload: error
	    };
	}
	
	function completePurchaseReturn(pr_id) {
	    return function (dispatch) {
	        dispatch({ type: _type.COMPLETE_PURCHASE_RETURN });
	        return _axios2.default.get(_url.PURCHASE_RETURNS_URL + 'open/' + pr_id, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(completePurchaseReturnSuccess());
	            _reactRouter.browserHistory.push('/purchaseReturn');
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(completePurchaseReturnFailure(err));
	        });
	    };
	}
	
	function completePurchaseReturnSuccess() {
	    return {
	        type: _type.COMPLETE_PURCHASE_RETURN_SUCCESS
	    };
	}
	
	function completePurchaseReturnFailure(response) {
	    return {
	        type: _type.COMPLETE_PURCHASE_RETURN_FAILURE,
	        payload: response
	    };
	}
	
	function voidPurchaseReturnSuccess() {
	    return {
	        type: _type.VOID_PURCHASE_RETURN_SUCCESS
	    };
	}
	
	function voidPurchaseReturnFailure(error) {
	    return {
	        type: _type.VOID_PURCHASE_RETURN_FAILURE,
	        payload: error
	    };
	}
	
	function voidPurchaseReturn(id) {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_VOID_PURCHASE_RETURN });
	        var token = localStorage.getItem('token');
	        return (0, _axios2.default)({
	            method: 'delete',
	            url: '' + _url.PURCHASE_RETURNS_URL + id,
	            headers: { Authorization: 'Bearer ' + token }
	        }).then(function (response) {
	            dispatch(voidPurchaseReturnSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(voidPurchaseReturnFailure(err));
	        });
	    };
	}
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseReturns, 'fetchPurchaseReturns', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	
	    __REACT_HOT_LOADER__.register(requestPurchaseReturns, 'requestPurchaseReturns', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseReturnsSuccess, 'fetchPurchaseReturnsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseReturnsFailure, 'fetchPurchaseReturnsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	
	    __REACT_HOT_LOADER__.register(selectPurchaseReturn, 'selectPurchaseReturn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	
	    __REACT_HOT_LOADER__.register(selectVendor, 'selectVendor', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	
	    __REACT_HOT_LOADER__.register(resetCurrentPurchaseReturn, 'resetCurrentPurchaseReturn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseReturnDetail, 'fetchPurchaseReturnDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	
	    __REACT_HOT_LOADER__.register(requestPurchaseReturnDetail, 'requestPurchaseReturnDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseReturnDetailSuccess, 'fetchPurchaseReturnDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseReturnDetailFailure, 'fetchPurchaseReturnDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	
	    __REACT_HOT_LOADER__.register(createPurchaseReturn, 'createPurchaseReturn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	
	    __REACT_HOT_LOADER__.register(createPurchaseReturnSuccess, 'createPurchaseReturnSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	
	    __REACT_HOT_LOADER__.register(createPurchaseReturnFailure, 'createPurchaseReturnFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	
	    __REACT_HOT_LOADER__.register(editPurchaseReturn, 'editPurchaseReturn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	
	    __REACT_HOT_LOADER__.register(editPurchaseReturnSuccess, 'editPurchaseReturnSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	
	    __REACT_HOT_LOADER__.register(editPurchaseReturnFailure, 'editPurchaseReturnFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	
	    __REACT_HOT_LOADER__.register(completePurchaseReturn, 'completePurchaseReturn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	
	    __REACT_HOT_LOADER__.register(completePurchaseReturnSuccess, 'completePurchaseReturnSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	
	    __REACT_HOT_LOADER__.register(completePurchaseReturnFailure, 'completePurchaseReturnFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	
	    __REACT_HOT_LOADER__.register(voidPurchaseReturnSuccess, 'voidPurchaseReturnSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	
	    __REACT_HOT_LOADER__.register(voidPurchaseReturnFailure, 'voidPurchaseReturnFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	
	    __REACT_HOT_LOADER__.register(voidPurchaseReturn, 'voidPurchaseReturn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseReturns_actions.js');
	}();

	;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchPurchaseSchedules = fetchPurchaseSchedules;
	exports.requestPurchaseSchedules = requestPurchaseSchedules;
	exports.fetchPurchaseSchedulesSuccess = fetchPurchaseSchedulesSuccess;
	exports.fetchPurchaseSchedulesFailure = fetchPurchaseSchedulesFailure;
	exports.selectPurchaseSchedule = selectPurchaseSchedule;
	exports.resetCurrentPurchaseSchedule = resetCurrentPurchaseSchedule;
	exports.fetchPurchaseScheduleDetail = fetchPurchaseScheduleDetail;
	exports.requestPurchaseScheduleDetail = requestPurchaseScheduleDetail;
	exports.fetchPurchaseScheduleDetailSuccess = fetchPurchaseScheduleDetailSuccess;
	exports.fetchPurchaseScheduleDetailFailure = fetchPurchaseScheduleDetailFailure;
	exports.createPurchaseSchedule = createPurchaseSchedule;
	exports.createPurchaseScheduleSuccess = createPurchaseScheduleSuccess;
	exports.createPurchaseScheduleFailure = createPurchaseScheduleFailure;
	exports.editPurchaseSchedule = editPurchaseSchedule;
	exports.editPurchaseScheduleSuccess = editPurchaseScheduleSuccess;
	exports.editPurchaseScheduleFailure = editPurchaseScheduleFailure;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchPurchaseSchedules() {
	    return function (dispatch) {
	        dispatch(requestPurchaseSchedules());
	        return _axios2.default.get(_url.PURCHASE_SCHEDULES_URL, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchPurchaseSchedulesSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchPurchaseSchedulesFailure(err));
	        });
	    };
	}
	
	function requestPurchaseSchedules() {
	    return {
	        type: _type.REQUEST_PURCHASE_SCHEDULES
	    };
	}
	
	function fetchPurchaseSchedulesSuccess(purchaseSchedules) {
	    return {
	        type: _type.FETCH_PURCHASE_SCHEDULES_SUCCESS,
	        payload: purchaseSchedules
	    };
	}
	
	function fetchPurchaseSchedulesFailure(error) {
	    return {
	        type: _type.FETCH_PURCHASE_SCHEDULES_FAILURE,
	        payload: error
	    };
	}
	
	function selectPurchaseSchedule(purchaseSchedule) {
	    return {
	        type: _type.SELECT_PURCHASE_SCHEDULE,
	        payload: purchaseSchedule
	    };
	}
	
	function resetCurrentPurchaseSchedule() {
	    return {
	        type: _type.RESET_CURRENT_PURCHASE_SCHEDULE
	    };
	}
	
	// Fetch the detail page.
	
	function fetchPurchaseScheduleDetail(customer_id) {
	    return function (dispatch) {
	        dispatch(requestPurchaseScheduleDetail());
	        return _axios2.default.get(_url.PURCHASE_SCHEDULES_URL + customer_id, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchPurchaseScheduleDetailSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchPurchaseScheduleDetailFailure(err));
	        });
	    };
	}
	
	function requestPurchaseScheduleDetail() {
	    return {
	        type: _type.REQUEST_PURCHASE_SCHEDULE_DETAIL
	    };
	}
	
	function fetchPurchaseScheduleDetailSuccess(purchaseScheduleDetail) {
	    purchaseScheduleDetail = purchaseScheduleDetail.data;
	    // The date data fetched is in the form of string, which needs to be modified into Date type
	    if (purchaseScheduleDetail.StartDate) purchaseScheduleDetail.StartDate = new Date(purchaseScheduleDetail.StartDate);
	    if (purchaseScheduleDetail.NextExecuteDate) purchaseScheduleDetail.NextExecuteDate = new Date(purchaseScheduleDetail.NextExecuteDate);
	    return {
	        type: _type.FETCH_PURCHASE_SCHEDULE_DETAIL_SUCCESS,
	        payload: purchaseScheduleDetail
	    };
	}
	
	function fetchPurchaseScheduleDetailFailure(error) {
	    return {
	        type: _type.FETCH_PURCHASE_SCHEDULE_DETAIL_FAILURE,
	        payload: error
	    };
	}
	
	function createPurchaseSchedule(_ref) {
	    var Name = _ref.Name,
	        Description = _ref.Description,
	        StartDate = _ref.StartDate,
	        RepeatFrequency = _ref.RepeatFrequency,
	        RepeatInterval = _ref.RepeatInterval,
	        OneTimeDate = _ref.OneTimeDate,
	        NextExecuteDate = _ref.NextExecuteDate,
	        IsEnabled = _ref.IsEnabled,
	        PurchaseTemplate = _ref.PurchaseTemplate;
	
	    if (RepeatFrequency) RepeatFrequency = RepeatFrequency.value || RepeatFrequency;
	    if (typeof RepeatInterval !== 'undefined') {
	        if (typeof RepeatInterval.value !== 'undefined') RepeatInterval = RepeatInterval.value;
	    }
	    if (StartDate) {
	        var year = StartDate.getFullYear();
	        var month = StartDate.getMonth() + 1;
	        var day = StartDate.getDate();
	        var hours = StartDate.getHours();
	        var minutes = StartDate.getMinutes();
	        var seconds = StartDate.getSeconds();
	        StartDate = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
	    }
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_CREATING_PURCHASE_SCHEDULE });
	        _axios2.default.post(_url.PURCHASE_SCHEDULES_URL, {
	            Name: Name,
	            Description: Description,
	            StartDate: StartDate,
	            RepeatFrequency: RepeatFrequency,
	            RepeatInterval: RepeatInterval,
	            OneTimeDate: OneTimeDate,
	            NextExecuteDate: NextExecuteDate,
	            IsEnabled: IsEnabled,
	            PurchaseTemplate_id: PurchaseTemplate.PurchaseTemplate_id
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(createPurchaseScheduleSuccess());
	            _reactRouter.browserHistory.push('/purchaseSchedule');
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(createPurchaseScheduleFailure(err));
	        });
	    };
	}
	
	function createPurchaseScheduleSuccess() {
	    return {
	        type: _type.CREATE_PURCHASE_SCHEDULE_SUCCESS
	    };
	}
	
	function createPurchaseScheduleFailure(error) {
	    return {
	        type: _type.CREATE_PURCHASE_SCHEDULE_FAILURE,
	        payload: error
	    };
	}
	
	function editPurchaseSchedule(_ref2) {
	    var PurchaseSchedule_id = _ref2.PurchaseSchedule_id,
	        Name = _ref2.Name,
	        Description = _ref2.Description,
	        StartDate = _ref2.StartDate,
	        RepeatFrequency = _ref2.RepeatFrequency,
	        RepeatInterval = _ref2.RepeatInterval,
	        OneTimeDate = _ref2.OneTimeDate,
	        NextExecuteDate = _ref2.NextExecuteDate,
	        IsEnabled = _ref2.IsEnabled,
	        PurchaseTemplate = _ref2.PurchaseTemplate;
	
	    if (RepeatFrequency) RepeatFrequency = RepeatFrequency.value || RepeatFrequency;
	    if (RepeatInterval.value === 0) RepeatInterval = 0;else if (RepeatInterval) RepeatInterval = RepeatInterval.value || RepeatInterval;
	    if (StartDate) {
	        var year = StartDate.getFullYear();
	        var month = StartDate.getMonth() + 1;
	        var day = StartDate.getDate();
	        var hours = StartDate.getHours();
	        var minutes = StartDate.getMinutes();
	        var seconds = StartDate.getSeconds();
	        StartDate = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
	    }
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_EDITING_PURCHASE_SCHEDULE });
	        _axios2.default.put(_url.PURCHASE_SCHEDULES_URL + PurchaseSchedule_id, {
	            Name: Name,
	            Description: Description,
	            StartDate: StartDate,
	            RepeatFrequency: RepeatFrequency,
	            RepeatInterval: RepeatInterval,
	            OneTimeDate: OneTimeDate,
	            NextExecuteDate: NextExecuteDate,
	            IsEnabled: IsEnabled,
	            PurchaseTemplate_id: PurchaseTemplate.PurchaseTemplate_id
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(editPurchaseScheduleSuccess());
	            _reactRouter.browserHistory.push('/purchaseSchedule'); // If editd succesfully, refresh the paymentTerm page.
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(editPurchaseScheduleFailure(err));
	        });
	    };
	}
	
	function editPurchaseScheduleSuccess() {
	    return {
	        type: _type.EDIT_PURCHASE_SCHEDULE_SUCCESS
	    };
	}
	
	function editPurchaseScheduleFailure(error) {
	    return {
	        type: _type.EDIT_PURCHASE_SCHEDULE_FAILURE,
	        payload: error
	    };
	}
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseSchedules, 'fetchPurchaseSchedules', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseSchedules_actions.js');
	
	    __REACT_HOT_LOADER__.register(requestPurchaseSchedules, 'requestPurchaseSchedules', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseSchedules_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseSchedulesSuccess, 'fetchPurchaseSchedulesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseSchedules_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseSchedulesFailure, 'fetchPurchaseSchedulesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseSchedules_actions.js');
	
	    __REACT_HOT_LOADER__.register(selectPurchaseSchedule, 'selectPurchaseSchedule', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseSchedules_actions.js');
	
	    __REACT_HOT_LOADER__.register(resetCurrentPurchaseSchedule, 'resetCurrentPurchaseSchedule', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseSchedules_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseScheduleDetail, 'fetchPurchaseScheduleDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseSchedules_actions.js');
	
	    __REACT_HOT_LOADER__.register(requestPurchaseScheduleDetail, 'requestPurchaseScheduleDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseSchedules_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseScheduleDetailSuccess, 'fetchPurchaseScheduleDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseSchedules_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchPurchaseScheduleDetailFailure, 'fetchPurchaseScheduleDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseSchedules_actions.js');
	
	    __REACT_HOT_LOADER__.register(createPurchaseSchedule, 'createPurchaseSchedule', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseSchedules_actions.js');
	
	    __REACT_HOT_LOADER__.register(createPurchaseScheduleSuccess, 'createPurchaseScheduleSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseSchedules_actions.js');
	
	    __REACT_HOT_LOADER__.register(createPurchaseScheduleFailure, 'createPurchaseScheduleFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseSchedules_actions.js');
	
	    __REACT_HOT_LOADER__.register(editPurchaseSchedule, 'editPurchaseSchedule', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseSchedules_actions.js');
	
	    __REACT_HOT_LOADER__.register(editPurchaseScheduleSuccess, 'editPurchaseScheduleSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseSchedules_actions.js');
	
	    __REACT_HOT_LOADER__.register(editPurchaseScheduleFailure, 'editPurchaseScheduleFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchaseSchedules_actions.js');
	}();

	;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RowLabelField = function RowLabelField(props) {
	  var value = props.value,
	      translation = props.translation,
	      left = props.left,
	      right = props.right;
	
	  return _react2.default.createElement(
	    _reactBootstrap.Row,
	    props,
	    _react2.default.createElement(
	      _reactBootstrap.Col,
	      { xs: left },
	      _react2.default.createElement(
	        'label',
	        null,
	        _lodash2.default.isString(translation) ? _react2.default.createElement(_reactReduxI18n.Translate, { value: translation }) : translation
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Col,
	      { xs: right },
	      _react2.default.createElement(
	        'label',
	        { className: 'pull-right' },
	        value
	      )
	    )
	  );
	};
	
	RowLabelField.defaultProps = {
	  translation: '',
	  value: '',
	  left: 6,
	  right: 6
	};
	
	RowLabelField.propTypes = {
	  translation: _propTypes2.default.node,
	  value: _propTypes2.default.node,
	  left: _propTypes2.default.number,
	  right: _propTypes2.default.number
	};
	
	var _default = RowLabelField;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(RowLabelField, 'RowLabelField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/RowLabelField.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/RowLabelField.jsx');
	}();

	;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _url = __webpack_require__(20);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  closeConfirm: _propTypes2.default.func,
	  text: _propTypes2.default.string
	};
	
	// instruction
	// step 1
	//  import setConfirmPasscodeModalVisibility from actions/baseModal_actions
	// step 2
	//  confirmPasscodeModal: {
	//    visibility: false,
	//    verified: false,
	//  },
	//  map confirmPasscodeModal state to the prop of the component you wish to use passcode modal
	//  confirmPasscodeVerified: state.baseModals.confirmPasscodeModal.verified,
	// step 3
	//  after passcode has been verified, modal closes itself and state.baseModals.confirmPasscodeModal.verified will be true,
	//  then you do w/e you have to do, then set the value of verified to false using setPasscodeVerificationStatus(false);
	//  done
	
	var VerifyPasscodeModal = function (_Component) {
	  _inherits(VerifyPasscodeModal, _Component);
	
	  function VerifyPasscodeModal() {
	    _classCallCheck(this, VerifyPasscodeModal);
	
	    var _this = _possibleConstructorReturn(this, (VerifyPasscodeModal.__proto__ || Object.getPrototypeOf(VerifyPasscodeModal)).call(this));
	
	    _this.checkPasscode = function () {
	      _this.setState({
	        errMsg: ''
	      });
	      var promise = new Promise(function (resolve, reject) {
	        (0, _axios2.default)({
	          method: 'POST',
	          url: _url.verifyPasscode,
	          data: {
	            passcode: _this.state.passcode
	          },
	          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (res) {
	          resolve(res);
	        }).catch(function (err) {
	          reject(err);
	        });
	      });
	
	      promise.then(function (result) {
	        _this.props.closeConfirm(true);
	      }, function (err) {
	        _this.setState({
	          errMsg: err.data
	        });
	      });
	    };
	
	    _this.state = {
	      passcode: '',
	      errMsg: ''
	    };
	    return _this;
	  }
	
	  _createClass(VerifyPasscodeModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {}
	  }, {
	    key: 'handlePasscodeChange',
	    value: function handlePasscodeChange(e) {
	      this.setState({
	        passcode: e.target.value
	      });
	    }
	  }, {
	    key: 'renderButtons',
	    value: function renderButtons() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { bsStyle: 'primary', className: 'mt mr', onClick: this.checkPasscode },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Confirm' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { bsStyle: 'primary', className: 'mt mr', onClick: function onClick() {
	              _this2.props.closeConfirm();
	            } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	        )
	      );
	    }
	  }, {
	    key: 'renderInput',
	    value: function renderInput() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'span',
	        { style: { margin: '50px 0' } },
	        _react2.default.createElement('input', { type: 'password', value: this.state.passcode, onChange: function onChange(e) {
	            return _this3.handlePasscodeChange(e);
	          }, style: { border: '1px solid black', borderRadius: '4px', margin: '50px 0', padding: '10px' } })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var errMsg = this.state.errMsg;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        this.props.text && _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12, className: 'text-center', style: { marginTop: '20px', fontSize: '20px', fontWeight: '400' } },
	            this.props.text
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12, className: 'text-center', style: { marginTop: '20px' } },
	            this.renderInput()
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12, className: 'text-center' },
	            this.renderButtons()
	          )
	        ),
	        _react2.default.createElement('br', null),
	        errMsg && _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'text-center alert alert-danger' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'your_passcode_is_not_correct' })
	        )
	      );
	    }
	  }]);
	
	  return VerifyPasscodeModal;
	}(_react.Component);
	
	VerifyPasscodeModal.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	VerifyPasscodeModal.propTypes = propTypes;
	
	var _default = VerifyPasscodeModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/VerifyPasscodeModal.jsx');
	
	  __REACT_HOT_LOADER__.register(VerifyPasscodeModal, 'VerifyPasscodeModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/VerifyPasscodeModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/VerifyPasscodeModal.jsx');
	}();

	;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(61);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConvertItemPrice = function (_Component) {
	  _inherits(ConvertItemPrice, _Component);
	
	  function ConvertItemPrice() {
	    _classCallCheck(this, ConvertItemPrice);
	
	    return _possibleConstructorReturn(this, (ConvertItemPrice.__proto__ || Object.getPrototypeOf(ConvertItemPrice)).apply(this, arguments));
	  }
	
	  _createClass(ConvertItemPrice, [{
	    key: 'render',
	    value: function render() {
	      var titleClass = (0, _classnames2.default)({ 'parsley-error-label': this.props.meta.touched && this.props.meta.error }, 'control-label', 'col-sm-5');
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          this.props.meta.touched && this.props.meta.error && _react2.default.createElement(
	            'span',
	            { className: 'parsley-error-message' },
	            this.props.meta.error
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 5 },
	          _react2.default.createElement(
	            'label',
	            { className: titleClass },
	            this.props.labelName
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 1 },
	          _react2.default.createElement(
	            'label',
	            { className: 'inlineLabel radioMargin' },
	            _react2.default.createElement(_reactBootstrap.Input, _extends({}, this.props.input, { type: 'radio', value: 'FOB', checked: this.props.input.value === 'FOB' }))
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 3, className: 'custom-col-width' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'FOB'
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 1 },
	          _react2.default.createElement(
	            'label',
	            { className: 'inlineLabel radioMargin' },
	            _react2.default.createElement(_reactBootstrap.Input, _extends({}, this.props.input, { type: 'radio', value: 'CIF', checked: this.props.input.value === 'CIF' }))
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            null,
	            'CIF'
	          )
	        )
	      );
	    }
	  }]);
	
	  return ConvertItemPrice;
	}(_react.Component);
	
	var _default = ConvertItemPrice;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ConvertItemPrice, 'ConvertItemPrice', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/convertItemPrice.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/convertItemPrice.jsx');
	}();

	;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	__webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HiddenInputField = function (_Component) {
	  _inherits(HiddenInputField, _Component);
	
	  function HiddenInputField() {
	    _classCallCheck(this, HiddenInputField);
	
	    return _possibleConstructorReturn(this, (HiddenInputField.__proto__ || Object.getPrototypeOf(HiddenInputField)).apply(this, arguments));
	  }
	
	  _createClass(HiddenInputField, [{
	    key: 'render',
	    value: function render() {
	      var input = this.props.input;
	
	      return _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, {
	        className: 'hidden',
	        standalone: true,
	        type: 'text',
	        value: input.V,
	        onChange: input.onChange(this.props.V)
	      }));
	    }
	  }]);
	
	  return HiddenInputField;
	}(_react.Component);
	
	var _default = HiddenInputField;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(HiddenInputField, 'HiddenInputField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/hiddenInputField.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/hiddenInputField.jsx');
	}();

	;

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// All keys and security staff are saved here.
	// !!!!!!! Never upload onto Git with Keys.
	
	var __GAPI_KEY__ = exports.__GAPI_KEY__ = "AIzaSyDn0hOAdoUrO-FaWJe16Im6FyK9AFs5Cgs";
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(__GAPI_KEY__, "__GAPI_KEY__", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/keys.js");
	}();

	;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DisabledPriceField = exports.PriceField = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	__webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PriceField = exports.PriceField = function (_Component) {
	  _inherits(PriceField, _Component);
	
	  function PriceField() {
	    _classCallCheck(this, PriceField);
	
	    return _possibleConstructorReturn(this, (PriceField.__proto__ || Object.getPrototypeOf(PriceField)).apply(this, arguments));
	  }
	
	  _createClass(PriceField, [{
	    key: 'render',
	    value: function render() {
	      var input = this.props.input;
	
	      return _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { standalone: true, type: 'text', addonBefore: '$', addonAfter: '.0000' }));
	    }
	  }]);
	
	  return PriceField;
	}(_react.Component);
	
	var DisabledPriceField = exports.DisabledPriceField = function (_Component2) {
	  _inherits(DisabledPriceField, _Component2);
	
	  function DisabledPriceField() {
	    _classCallCheck(this, DisabledPriceField);
	
	    return _possibleConstructorReturn(this, (DisabledPriceField.__proto__ || Object.getPrototypeOf(DisabledPriceField)).apply(this, arguments));
	  }
	
	  _createClass(DisabledPriceField, [{
	    key: 'render',
	    value: function render() {
	      var input = this.props.input;
	
	      return _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { standalone: true, type: 'text', disabled: true, value: this.props.V, addonBefore: '$', addonAfter: '.0000', onChange: input.onChange(this.props.V) }));
	    }
	  }]);
	
	  return DisabledPriceField;
	}(_react.Component);
	
	var _default = PriceField;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PriceField, 'PriceField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/priceField.jsx');
	
	  __REACT_HOT_LOADER__.register(DisabledPriceField, 'DisabledPriceField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/priceField.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/priceField.jsx');
	}();

	;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PromotionsTable = __webpack_require__(482);
	
	Object.defineProperty(exports, 'PromotionsTable', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PromotionsTable).default;
	  }
	});
	
	var _PromotionsProductSearch = __webpack_require__(481);
	
	Object.defineProperty(exports, 'PromotionsProductSearch', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PromotionsProductSearch).default;
	  }
	});
	
	var _PromotionSetup = __webpack_require__(480);
	
	Object.defineProperty(exports, 'PromotionSetup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PromotionSetup).default;
	  }
	});
	
	var _BuyAGetBProductSearches = __webpack_require__(475);
	
	Object.defineProperty(exports, 'BuyAGetBProductSearches', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BuyAGetBProductSearches).default;
	  }
	});
	
	var _ByQuantityFields = __webpack_require__(476);
	
	Object.defineProperty(exports, 'ByQuantityFields', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ByQuantityFields).default;
	  }
	});
	
	var _ByTotalPriceProductFields = __webpack_require__(478);
	
	Object.defineProperty(exports, 'ByTotalPriceProductFields', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ByTotalPriceProductFields).default;
	  }
	});
	
	var _ByTotalPriceDiscountFields = __webpack_require__(477);
	
	Object.defineProperty(exports, 'ByTotalPriceDiscountFields', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ByTotalPriceDiscountFields).default;
	  }
	});
	
	var _BuyAGetBFields = __webpack_require__(474);
	
	Object.defineProperty(exports, 'BuyAGetBFields', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BuyAGetBFields).default;
	  }
	});
	
	var _EditPromotionModal = __webpack_require__(479);
	
	Object.defineProperty(exports, 'EditPromotionModal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EditPromotionModal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	}();

	;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isIncompleteForm = exports.clearForm = exports.populateFields = exports.cleanProduct = exports.desiredShapeByTotalPriceDiscount = exports.desiredShapeByTotalPriceProduct = exports.desiredShapeBuyAGetB = exports.desiredShapeByQuantity = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(19);
	
	var _isEmpty = __webpack_require__(191);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _cleanDates = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var desiredShapeByQuantity = exports.desiredShapeByQuantity = function desiredShapeByQuantity(promotion) {
	  var quantityFrom = promotion.quantityFrom,
	      quantityTo = promotion.quantityTo,
	      discountValue = promotion.discountValue,
	      discountType = promotion.discountType,
	      paymentTypeSelected = promotion.paymentTypeSelected,
	      customerGroupSelected = promotion.customerGroupSelected,
	      methodSelected = promotion.methodSelected,
	      startDateSelected = promotion.startDateSelected,
	      endDateSelected = promotion.endDateSelected,
	      selectedProduct = promotion.selectedProduct,
	      applyLv1 = promotion.applyLv1,
	      applyLv2 = promotion.applyLv2,
	      applyLv3 = promotion.applyLv3,
	      applyLv4 = promotion.applyLv4,
	      applyLv5 = promotion.applyLv5,
	      productSearchType = promotion.productSearchType,
	      selectedGroup = promotion.selectedGroup,
	      selectedCategory = promotion.selectedCategory;
	
	  var ViewablePriceLevelsArray = [];
	  var ViewablePriceLevels = '';
	  for (var i = 0; i < 5; i++) {
	    if (promotion && promotion['applyLv' + (i + 1)] === true) {
	      ViewablePriceLevelsArray.push('PriceLv' + (i + 1));
	    }
	  }
	  ViewablePriceLevels = ViewablePriceLevelsArray.join(',');
	
	  var _toFromDates = (0, _cleanDates.toFromDates)(-1, startDateSelected, endDateSelected),
	      fromDate = _toFromDates.fromDate,
	      toDate = _toFromDates.toDate;
	
	  if (productSearchType === 'Group') {
	    return {
	      Method: 'ByQuantity',
	      ProductGroup_id: selectedGroup,
	      ProductCategory1_id: selectedCategory,
	      StartDate: fromDate,
	      EndDate: toDate,
	      Group: customerGroupSelected,
	      PaymentType: paymentTypeSelected,
	      Qualification: methodSelected,
	      FromQty: quantityFrom || 0,
	      ToQty: quantityTo || 0,
	      Off: discountValue || 0,
	      IsPercent: discountType === 'Percent',
	      ViewablePriceLevels: ViewablePriceLevels
	    };
	  }
	  return {
	    Method: 'ByQuantity',
	    Product_id: selectedProduct.currentProdId,
	    StartDate: fromDate,
	    EndDate: toDate,
	    Group: customerGroupSelected,
	    PaymentType: paymentTypeSelected,
	    Qualification: methodSelected,
	    FromQty: quantityFrom || 0,
	    ToQty: quantityTo || 0,
	    Off: discountValue || 0,
	    IsPercent: discountType === 'Percent',
	    ViewablePriceLevels: ViewablePriceLevels
	  };
	};
	
	var desiredShapeBuyAGetB = exports.desiredShapeBuyAGetB = function desiredShapeBuyAGetB(promotion) {
	  var methodSelected = promotion.methodSelected,
	      discountValue = promotion.discountValue,
	      discountType = promotion.discountType,
	      paymentTypeSelected = promotion.paymentTypeSelected,
	      customerGroupSelected = promotion.customerGroupSelected,
	      startDateSelected = promotion.startDateSelected,
	      endDateSelected = promotion.endDateSelected,
	      selectedProductA = promotion.selectedProductA,
	      selectedProductB = promotion.selectedProductB,
	      productQuantityA = promotion.productQuantityA,
	      productQuantityB = promotion.productQuantityB;
	
	  var _toFromDates2 = (0, _cleanDates.toFromDates)(-1, startDateSelected, endDateSelected),
	      fromDate = _toFromDates2.fromDate,
	      toDate = _toFromDates2.toDate;
	
	  return {
	    Method: 'BuyAGetB',
	    Product_id: selectedProductA.currentProdId,
	    RelatedProduct_id: selectedProductB.currentProdId,
	    StartDate: fromDate,
	    EndDate: toDate,
	    Group: customerGroupSelected,
	    PaymentType: paymentTypeSelected,
	    FromQty: Number(parseFloat(productQuantityA, 10).toFixed(2)) || 0,
	    RelatedQuantity: Number(parseFloat(productQuantityB, 10).toFixed(2)) || 0,
	    Qualification: methodSelected,
	    Off: discountValue || 100,
	    IsPercent: discountValue ? discountType === 'Percent' : true
	  };
	};
	
	var desiredShapeByTotalPriceProduct = exports.desiredShapeByTotalPriceProduct = function desiredShapeByTotalPriceProduct(promotion) {
	  var paymentTypeSelected = promotion.paymentTypeSelected,
	      customerGroupSelected = promotion.customerGroupSelected,
	      startDateSelected = promotion.startDateSelected,
	      endDateSelected = promotion.endDateSelected,
	      selectedProduct = promotion.selectedProduct,
	      minPurchasePrice = promotion.minPurchasePrice,
	      productQuantityB = promotion.productQuantityB,
	      promoCode = promotion.promoCode,
	      autoApply = promotion.autoApply,
	      IsOneTime = promotion.IsOneTime,
	      SalesType = promotion.SalesType;
	
	  var _toFromDates3 = (0, _cleanDates.toFromDates)(-1, startDateSelected, endDateSelected),
	      fromDate = _toFromDates3.fromDate,
	      toDate = _toFromDates3.toDate;
	
	  return {
	    Method: 'ByTotalPriceProduct',
	    Product_id: selectedProduct.currentProdId,
	    StartDate: fromDate,
	    EndDate: toDate,
	    Group: customerGroupSelected,
	    PaymentType: paymentTypeSelected,
	    MinPurchase: minPurchasePrice,
	    RelatedQuantity: Number(parseFloat(productQuantityB, 10).toFixed(2)) || 0,
	    Off: 100,
	    IsPercent: true,
	    PromoCode: promoCode,
	    AutoApply: autoApply,
	    IsOneTime: IsOneTime,
	    SalesType: SalesType
	  };
	};
	
	var desiredShapeByTotalPriceDiscount = exports.desiredShapeByTotalPriceDiscount = function desiredShapeByTotalPriceDiscount(promotion) {
	  var promoCode = promotion.promoCode,
	      discountValue = promotion.discountValue,
	      discountType = promotion.discountType,
	      paymentTypeSelected = promotion.paymentTypeSelected,
	      customerGroupSelected = promotion.customerGroupSelected,
	      startDateSelected = promotion.startDateSelected,
	      endDateSelected = promotion.endDateSelected,
	      minPurchasePrice = promotion.minPurchasePrice,
	      autoApply = promotion.autoApply,
	      IsOneTime = promotion.IsOneTime,
	      IsPublic = promotion.IsPublic,
	      SalesType = promotion.SalesType;
	
	  var _toFromDates4 = (0, _cleanDates.toFromDates)(-1, startDateSelected, endDateSelected),
	      fromDate = _toFromDates4.fromDate,
	      toDate = _toFromDates4.toDate;
	
	  return {
	    Method: 'ByTotalPriceDiscount',
	    PromoCode: promoCode,
	    AutoApply: autoApply,
	    IsOneTime: IsOneTime,
	    IsPublic: IsPublic,
	    StartDate: fromDate,
	    EndDate: toDate,
	    Group: customerGroupSelected,
	    PaymentType: paymentTypeSelected,
	    MinPurchase: minPurchasePrice,
	    Off: discountValue || 0,
	    IsPercent: discountType === 'Percent',
	    SalesType: SalesType
	  };
	};
	
	var cleanProduct = exports.cleanProduct = function cleanProduct(product) {
	  return {
	    inStock: product.InStock,
	    purchased: product.Purchased,
	    presale: product.PreSale,
	    netWeight: product.NetWeight,
	    shipWeight: product.NetWeight,
	    priceLv1: product.PriceLv1,
	    priceLv2: product.PriceLv2,
	    priceLv3: product.PriceLv3,
	    priceLv4: product.PriceLv4,
	    priceLv5: product.PriceLv5,
	    currentRefPrice: product.RefPrice,
	    currentProdId: product.Product_id,
	    currentProdName: product.Name,
	    currentProdNum: product.ProductNum,
	    currentProductDescription: product.Description,
	    currentRefNum: product.RefNum,
	    currentUnitType: product.ProductType,
	    currentPackageSize: product.PackageSize,
	    currentProductWeight: product.NetWeight,
	    currentProductCRV: product.CRV,
	    currentProductTaxable: String(product.isTaxable)
	  };
	};
	
	var populateFields = exports.populateFields = function populateFields(state, promotion) {
	  var FromQty = promotion.FromQty,
	      ToQty = promotion.ToQty,
	      Off = promotion.Off,
	      IsPercent = promotion.IsPercent,
	      PaymentType = promotion.PaymentType,
	      Group = promotion.Group,
	      Qualification = promotion.Qualification,
	      StartDate = promotion.StartDate,
	      EndDate = promotion.EndDate,
	      RelatedQuantity = promotion.RelatedQuantity,
	      MinPurchase = promotion.MinPurchase,
	      PromoCode = promotion.PromoCode,
	      Product = promotion.Product,
	      RelatedProduct = promotion.RelatedProduct,
	      AutoApply = promotion.AutoApply,
	      IsOneTime = promotion.IsOneTime,
	      IsPublic = promotion.IsPublic,
	      SalesType = promotion.SalesType,
	      ViewablePriceLevels = promotion.ViewablePriceLevels,
	      ProductGroup_id = promotion.ProductGroup_id,
	      ProductCategory1_id = promotion.ProductCategory1_id;
	
	  var splitArray = [];
	  var outputArray = [false, false, false, false, false];
	  if (ViewablePriceLevels) {
	    splitArray = ViewablePriceLevels.split(',');
	  }
	  splitArray.map(function (r) {
	    if (r === 'PriceLv1') {
	      outputArray[0] = true;
	    }
	    if (r === 'PriceLv2') {
	      outputArray[1] = true;
	    }
	    if (r === 'PriceLv3') {
	      outputArray[2] = true;
	    }
	    if (r === 'PriceLv4') {
	      outputArray[3] = true;
	    }
	    if (r === 'PriceLv5') {
	      outputArray[4] = true;
	    }
	  });
	  var product = Product ? cleanProduct(Product) : {};
	  var relatedProduct = RelatedProduct ? cleanProduct(RelatedProduct) : {};
	  return _extends({}, state, {
	    quantityFrom: FromQty || '',
	    quantityTo: ToQty || '',
	    discountValue: Off ? Off.toFixed(2) : '',
	    discountType: IsPercent ? 'Percent' : 'Dollar',
	    paymentTypeSelected: PaymentType || '',
	    customerGroupSelected: Group || '',
	    methodSelected: Qualification || '',
	    startDateSelected: new Date(StartDate) || undefined,
	    endDateSelected: new Date(EndDate) || undefined,
	    productQuantityA: FromQty || '',
	    productQuantityB: RelatedQuantity || '',
	    selectedProduct: product || {},
	    selectedProductA: product || {},
	    selectedProductB: relatedProduct || {},
	    minPurchasePrice: MinPurchase ? MinPurchase.toFixed(2) : '0',
	    promoCode: PromoCode || '',
	    autoApply: AutoApply,
	    IsOneTime: IsOneTime,
	    IsPublic: IsPublic,
	    SalesType: SalesType,
	    applyLv1: outputArray[0],
	    applyLv2: outputArray[1],
	    applyLv3: outputArray[2],
	    applyLv4: outputArray[3],
	    applyLv5: outputArray[4],
	    selectedGroup: ProductGroup_id || '',
	    selectedCategory: ProductCategory1_id || ''
	  }, ProductGroup_id ? { productSearchType: 'Group' } : {});
	};
	
	var clearForm = exports.clearForm = function clearForm(state) {
	  return _extends({}, state, {
	    selectedProduct: {},
	    selectedProductA: {},
	    selectedProductB: {},
	    suggestValue: '',
	    suggestValueA: '',
	    suggestValueB: '',
	    methodSelected: '',
	    quantityFrom: '',
	    quantityTo: '',
	    discountValue: '',
	    discountType: 'Dollar',
	    productQuantityA: '',
	    productQuantityB: '',
	    minPurchasePrice: '',
	    promoCode: '',
	    autoApply: false,
	    IsOneTime: false,
	    IsPublic: false
	  });
	};
	
	var isIncompleteForm = exports.isIncompleteForm = function isIncompleteForm(state, type) {
	  var startDateSelected = state.startDateSelected,
	      endDateSelected = state.endDateSelected,
	      customerGroupSelected = state.customerGroupSelected,
	      paymentTypeSelected = state.paymentTypeSelected,
	      methodSelected = state.methodSelected,
	      selectedProduct = state.selectedProduct,
	      selectedGroup = state.selectedGroup,
	      selectedCategory = state.selectedCategory,
	      quantityFrom = state.quantityFrom,
	      quantityTo = state.quantityTo,
	      discountValue = state.discountValue,
	      selectedProductA = state.selectedProductA,
	      selectedProductB = state.selectedProductB,
	      productQuantityA = state.productQuantityA,
	      productQuantityB = state.productQuantityB,
	      minPurchasePrice = state.minPurchasePrice;
	
	  if (!startDateSelected || !endDateSelected || !customerGroupSelected || !paymentTypeSelected) {
	    return true;
	  }
	
	  if (type === 'ByQuantity') {
	    return (0, _isEmpty2.default)(selectedProduct) && selectedGroup === '' || !methodSelected || !discountValue || !quantityFrom;
	  } else if (type === 'BuyAGetB') {
	    return (0, _isEmpty2.default)(selectedProductA) || (0, _isEmpty2.default)(selectedProductB) || !productQuantityA || !productQuantityB || !methodSelected
	    // || !discountValue
	    ;
	  } else if (type === 'ByTotalPriceProduct') {
	    return (0, _isEmpty2.default)(selectedProduct) || !minPurchasePrice || !productQuantityB;
	  } else if (type === 'ByTotalPriceDiscount') {
	    return !minPurchasePrice || !discountValue;
	  }
	  return false;
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(desiredShapeByQuantity, 'desiredShapeByQuantity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/utils.js');
	
	  __REACT_HOT_LOADER__.register(desiredShapeBuyAGetB, 'desiredShapeBuyAGetB', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/utils.js');
	
	  __REACT_HOT_LOADER__.register(desiredShapeByTotalPriceProduct, 'desiredShapeByTotalPriceProduct', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/utils.js');
	
	  __REACT_HOT_LOADER__.register(desiredShapeByTotalPriceDiscount, 'desiredShapeByTotalPriceDiscount', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/utils.js');
	
	  __REACT_HOT_LOADER__.register(cleanProduct, 'cleanProduct', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/utils.js');
	
	  __REACT_HOT_LOADER__.register(populateFields, 'populateFields', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/utils.js');
	
	  __REACT_HOT_LOADER__.register(clearForm, 'clearForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/utils.js');
	
	  __REACT_HOT_LOADER__.register(isIncompleteForm, 'isIncompleteForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/utils.js');
	}();

	;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _sales_actions = __webpack_require__(28);
	
	var _returnModal = __webpack_require__(467);
	
	var _returnModal2 = _interopRequireDefault(_returnModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var returnModal = (0, _reduxForm.reduxForm)({
	  form: 'returnModal'
	  // validate
	})(_returnModal2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('returnModal');
	
	function mapStateToProps(state) {
	  var totalWeight = selector(state, 'TotalWeight');
	  return {
	    totalWeight: totalWeight,
	
	    salesOrderLineWeights: state.salesOrders.salesOrderLineWeights,
	    salesOrderLineWeightsIsLoading: state.salesOrders.salesOrderLineWeightsIsLoading,
	    salesOrderLineWeightsError: state.salesOrders.salesOrderLineWeightsError,
	
	    salesOrderLineWeightsIsEditing: state.salesOrders.salesOrderLineWeightsIsEditing,
	    editSalesOrderLineWeightsSuccess: state.salesOrders.editSalesOrderLineWeightsSuccess,
	    editSalesOrderLineWeightsError: state.salesOrders.editSalesOrderLineWeightsError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchSalesOrderLineWeights: _sales_actions.fetchSalesOrderLineWeights, setOrderLineWeights: _sales_actions.setOrderLineWeights, clearSalesOrderLineWeights: _sales_actions.clearSalesOrderLineWeights })(returnModal);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/returnModal.jsx');
	
	  __REACT_HOT_LOADER__.register(returnModal, 'returnModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/returnModal.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/returnModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/returnModal.jsx');
	}();

	;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(809);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(762);
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, true, true);
	}
	
	module.exports = cloneDeep;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(765),
	    baseIteratee = __webpack_require__(88),
	    toInteger = __webpack_require__(127);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity]
	 *  The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(182),
	    baseEach = __webpack_require__(128),
	    baseIteratee = __webpack_require__(88),
	    isArray = __webpack_require__(78);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = forEach;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(796);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1325);

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1400);

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1408);

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(210);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchDashboardMessages = fetchDashboardMessages;
	exports.postDashboardMessage = postDashboardMessage;
	exports.fetchConsolidatedStatistics = fetchConsolidatedStatistics;
	exports.setField = setField;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(13);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	var _cleanDates = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchDashboardMessages() {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_DASHBOARD_MESSAGES });
	    return _axios2.default.get(_url.MESSAGE_DASHBOARD_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchDashboardMessagesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchDashboardMessagesFailure(err));
	    });
	  };
	}
	
	function fetchDashboardMessagesSuccess(messages) {
	  return {
	    type: _type.FETCH_DASHBOARD_MESSAGES_SUCCESS,
	    payload: messages
	  };
	}
	
	function fetchDashboardMessagesFailure(error) {
	  return {
	    type: _type.FETCH_DASHBOARD_MESSAGES_FAILURE,
	    payload: error
	  };
	}
	
	function postDashboardMessage(Message) {
	  return function (dispatch) {
	    dispatch({ type: _type.POST_DASHBOARD_MESSAGE });
	    return _axios2.default.post(_url.MESSAGE_DASHBOARD_URL, {
	      Message: Message.message
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(postDashboardMessageSuccess(response));
	      console.log('dispatching a change');
	      dispatch((0, _reduxForm.change)('generalDashboard', 'MessageField', ''));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      console.log('error found', err);
	      dispatch(postDashboardMessageFailure(err));
	    });
	  };
	}
	
	function postDashboardMessageSuccess(messages) {
	  return {
	    type: _type.POST_MESSAGE_SUCCESS,
	    payload: messages
	  };
	}
	
	function postDashboardMessageFailure(error) {
	  return {
	    type: _type.POST_MESSAGE_FAILURE,
	    payloard: error
	  };
	}
	
	function fetchConsolidatedStatistics(from, to) {
	  var fromDate = moment(from).startOf('day').toISOString();
	  var toDate = moment(to).endOf('day').toISOString();
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CONSOLIDATED_STATISTICS });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: _url.CONSOLODATED_STATISTICS_URL,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      params: {
	        start_date: fromDate,
	        end_date: toDate
	      }
	    }).then(function (response) {
	      dispatch(fetchConsolidatedStatisticsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchConsolidatedStatisticsFailure(err));
	    });
	  };
	}
	
	function fetchConsolidatedStatisticsSuccess(messages) {
	  return {
	    type: _type.FETCH_CONSOLODATED_STATISTICS_SUCCESS,
	    payload: messages
	  };
	}
	
	function fetchConsolidatedStatisticsFailure(error) {
	  return {
	    type: _type.FETCH_CONSOLODATED_STATISTICS_FAILURE,
	    payload: error
	  };
	}
	
	function setField(form, field, value) {
	  return function (dispatch) {
	    dispatch((0, _reduxForm.change)(form, field, value));
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchDashboardMessages, 'fetchDashboardMessages', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dashboard_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchDashboardMessagesSuccess, 'fetchDashboardMessagesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dashboard_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchDashboardMessagesFailure, 'fetchDashboardMessagesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dashboard_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(postDashboardMessage, 'postDashboardMessage', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dashboard_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(postDashboardMessageSuccess, 'postDashboardMessageSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dashboard_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(postDashboardMessageFailure, 'postDashboardMessageFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dashboard_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchConsolidatedStatistics, 'fetchConsolidatedStatistics', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dashboard_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchConsolidatedStatisticsSuccess, 'fetchConsolidatedStatisticsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dashboard_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchConsolidatedStatisticsFailure, 'fetchConsolidatedStatisticsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dashboard_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(setField, 'setField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/dashboard_actions.jsx');
	}();

	;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchInventoryRepackages = fetchInventoryRepackages;
	exports.fetchInventoryRepackagesSuccess = fetchInventoryRepackagesSuccess;
	exports.fetchInventoryRepackagesFailure = fetchInventoryRepackagesFailure;
	exports.selectInventoryRepackage = selectInventoryRepackage;
	exports.resetCurrentInventoryRepackage = resetCurrentInventoryRepackage;
	exports.fetchInventoryRepackageDetail = fetchInventoryRepackageDetail;
	exports.fetchInventoryRepackageDetailSuccess = fetchInventoryRepackageDetailSuccess;
	exports.fetchInventoryRepackageDetailFailure = fetchInventoryRepackageDetailFailure;
	exports.createInventoryRepackage = createInventoryRepackage;
	exports.createInventoryRepackageSuccess = createInventoryRepackageSuccess;
	exports.createInventoryRepackageFailure = createInventoryRepackageFailure;
	exports.editInventoryRepackage = editInventoryRepackage;
	exports.editInventoryRepackageSuccess = editInventoryRepackageSuccess;
	exports.editInventoryRepackageFailure = editInventoryRepackageFailure;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchInventoryRepackages() {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_INVENTORY_REPACKAGES });
	        return _axios2.default.get(_url.INVENTORY_REPACKAGES_URL, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchInventoryRepackagesSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchInventoryRepackagesFailure(err));
	        });
	    };
	}
	
	// InventoryRepackages Actions
	function fetchInventoryRepackagesSuccess(inventoryRepackages) {
	    return {
	        type: _type.FETCH_INVENTORY_REPACKAGES_SUCCESS,
	        payload: inventoryRepackages
	    };
	}
	
	function fetchInventoryRepackagesFailure(error) {
	    return {
	        type: _type.FETCH_INVENTORY_REPACKAGES_FAILURE,
	        payload: error
	    };
	}
	
	function selectInventoryRepackage(inventoryRepackage) {
	    return {
	        type: _type.SELECT_INVENTORY_REPACKAGE,
	        payload: inventoryRepackage
	    };
	}
	
	function resetCurrentInventoryRepackage() {
	    return {
	        type: _type.RESET_CURRENT_INVENTORY_REPACKAGE
	    };
	}
	
	function fetchInventoryRepackageDetail(inventoryRepackage_id) {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_INVENTORY_REPACKAGE_DETAIL });
	        return _axios2.default.get(_url.INVENTORY_REPACKAGES_URL + inventoryRepackage_id, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchInventoryRepackageDetailSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchInventoryRepackageDetailFailure(err));
	        });
	    };
	}
	
	function fetchInventoryRepackageDetailSuccess(inventoryRepackageDetail) {
	    inventoryRepackageDetail = inventoryRepackageDetail.data;
	    if (inventoryRepackageDetail.PostingDate) inventoryRepackageDetail.PostingDate = (0, _cleanDates.convertUtcDate)(inventoryRepackageDetail.PostingDate);
	    return {
	        type: _type.FETCH_INVENTORY_REPACKAGE_DETAIL_SUCCESS,
	        payload: inventoryRepackageDetail
	    };
	}
	
	function fetchInventoryRepackageDetailFailure(error) {
	    return {
	        type: _type.FETCH_INVENTORY_REPACKAGE_DETAIL_FAILURE,
	        payload: error
	    };
	}
	
	function createInventoryRepackage(Warehouse_id, PostingDate, Note, Warehouse_Repackage_Line) {
	    console.log("l", Warehouse_Repackage_Line);
	    if (PostingDate) PostingDate = (0, _cleanDates.convertUtcDate)(PostingDate);
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_CREATING_INVENTORY_REPACKAGE });
	        // if(Warehouse_Repackage_Line) {
	        //   Warehouse_Repackage_Line.map(line => {
	        //     line['WarehouseBin_id'] = line.WarehouseBin_id.WarehouseBin_id;
	        //     line['WarehouseZone_id'] = line.WarehouseZone_id.WarehouseZone_id;
	        //   })
	        // }
	        _axios2.default.post(_url.INVENTORY_REPACKAGES_URL, {
	            Warehouse_id: Warehouse_id,
	            PostingDate: PostingDate,
	            Note: Note,
	            Warehouse_Repackage_Line: Warehouse_Repackage_Line
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(createInventoryRepackageSuccess());
	            _reactRouter.browserHistory.push('/inventories/repackage');
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(createInventoryRepackageFailure(err));
	        });
	    };
	}
	
	function createInventoryRepackageSuccess() {
	    return {
	        type: _type.CREATE_INVENTORY_REPACKAGE_SUCCESS
	    };
	}
	
	function createInventoryRepackageFailure(error) {
	    return {
	        type: _type.CREATE_INVENTORY_REPACKAGE_FAILURE,
	        payload: error
	    };
	}
	
	function editInventoryRepackage(WarehouseRepackage_id, Warehouse_id, PostingDate, Note, Warehouse_Repackage_Line) {
	    if (PostingDate) PostingDate = (0, _cleanDates.convertUtcDate)(PostingDate);
	    if (Warehouse_Repackage_Line) {
	        Warehouse_Repackage_Line.map(function (line) {
	            line['WarehouseBin_id'] = line.WarehouseBin_id.WarehouseBin_id;
	            line['WarehouseZone_id'] = line.WarehouseZone_id.WarehouseZone_id;
	        });
	    }
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_EDITING_INVENTORY_REPACKAGE });
	        _axios2.default.put(_url.INVENTORY_REPACKAGES_URL + WarehouseRepackage_id, {
	            Warehouse_id: Warehouse_id,
	            PostingDate: PostingDate,
	            Note: Note,
	            Warehouse_Repackage_Line: Warehouse_Repackage_Line
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(editInventoryRepackageSuccess());
	            _reactRouter.browserHistory.push('/inventories/repackage');
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(editInventoryRepackageFailure(err));
	        });
	    };
	}
	
	function editInventoryRepackageSuccess() {
	    return {
	        type: _type.EDIT_INVENTORY_REPACKAGE_SUCCESS
	    };
	}
	
	function editInventoryRepackageFailure(error) {
	    return {
	        type: _type.EDIT_INVENTORY_REPACKAGE_FAILURE,
	        payload: error
	    };
	}
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(fetchInventoryRepackages, 'fetchInventoryRepackages', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRepackages_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchInventoryRepackagesSuccess, 'fetchInventoryRepackagesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRepackages_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchInventoryRepackagesFailure, 'fetchInventoryRepackagesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRepackages_actions.js');
	
	    __REACT_HOT_LOADER__.register(selectInventoryRepackage, 'selectInventoryRepackage', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRepackages_actions.js');
	
	    __REACT_HOT_LOADER__.register(resetCurrentInventoryRepackage, 'resetCurrentInventoryRepackage', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRepackages_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchInventoryRepackageDetail, 'fetchInventoryRepackageDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRepackages_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchInventoryRepackageDetailSuccess, 'fetchInventoryRepackageDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRepackages_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchInventoryRepackageDetailFailure, 'fetchInventoryRepackageDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRepackages_actions.js');
	
	    __REACT_HOT_LOADER__.register(createInventoryRepackage, 'createInventoryRepackage', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRepackages_actions.js');
	
	    __REACT_HOT_LOADER__.register(createInventoryRepackageSuccess, 'createInventoryRepackageSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRepackages_actions.js');
	
	    __REACT_HOT_LOADER__.register(createInventoryRepackageFailure, 'createInventoryRepackageFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRepackages_actions.js');
	
	    __REACT_HOT_LOADER__.register(editInventoryRepackage, 'editInventoryRepackage', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRepackages_actions.js');
	
	    __REACT_HOT_LOADER__.register(editInventoryRepackageSuccess, 'editInventoryRepackageSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRepackages_actions.js');
	
	    __REACT_HOT_LOADER__.register(editInventoryRepackageFailure, 'editInventoryRepackageFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/inventoryRepackages_actions.js');
	}();

	;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.changeToChinese = changeToChinese;
	exports.changeToEnglish = changeToEnglish;
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function changeToChinese() {
	  return function (dispatch) {
	    dispatch((0, _reactReduxI18n.setLocale)('ch'));
	    localStorage.setItem('lang', 'ch');
	  };
	}
	
	function changeToEnglish() {
	  return function (dispatch) {
	    dispatch((0, _reactReduxI18n.setLocale)('en'));
	    localStorage.setItem('lang', 'en');
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(changeToChinese, 'changeToChinese', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/language_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(changeToEnglish, 'changeToEnglish', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/language_actions.jsx');
	}();

	;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchFAQBoxText = exports.saveFAQBoxText = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchGreatDealsNewArrivals = fetchGreatDealsNewArrivals;
	exports.updateGreatDeals = updateGreatDeals;
	exports.updateNewArrivals = updateNewArrivals;
	exports.fetchBillboardImages = fetchBillboardImages;
	exports.saveBillboardImages = saveBillboardImages;
	exports.deleteBillboardImage = deleteBillboardImage;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _type = __webpack_require__(14);
	
	var _root_url = __webpack_require__(9);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchingGreatDealsNewArrivals() {
	  return {
	    type: _type.FETCH_GREAT_DEALS_NEW_ARRIVALS
	  };
	}
	
	function fetchGreatDealsNewArrivalsSuccess(data) {
	  return {
	    type: _type.FETCH_GREAT_DEALS_NEW_ARRIVALS_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchGreatDealsNewArrivalsFailure(error) {
	  return {
	    type: _type.FETCH_GREAT_DEALS_NEW_ARRIVALS_FAILURE,
	    payload: error
	  };
	}
	
	function fetchGreatDealsNewArrivals() {
	  return function (dispatch) {
	    dispatch(fetchingGreatDealsNewArrivals());
	    var token = localStorage.getItem('token');
	    return (0, _axios2.default)({
	      method: 'get',
	      url: _root_url.ROOT_URL + 'v1/product/great_deal_new_arrival/',
	      headers: { Authorization: 'Bearer ' + token }
	    }).then(function (response) {
	      dispatch(fetchGreatDealsNewArrivalsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchGreatDealsNewArrivalsFailure(err));
	    });
	  };
	}
	
	function updatingGreatDeals() {
	  return {
	    type: _type.UPDATE_GREAT_DEALS
	  };
	}
	
	function updateGreatDealsSuccess(data) {
	  return {
	    type: _type.UPDATE_GREAT_DEALS_SUCCESS,
	    payload: data
	  };
	}
	
	function updateGreatDealsFailure(error) {
	  return {
	    type: _type.UPDATE_GREAT_DEALS_FAILURE,
	    payload: error
	  };
	}
	
	/*
	* @ids - array of product ids
	* @isGreatDeal - boolean type indicating whether isGreatDeal or not for the
	*                list of products (ids)
	*/
	function updateGreatDeals(ids, isGreatDeal) {
	  return function (dispatch) {
	    dispatch(updatingGreatDeals());
	    var token = localStorage.getItem('token');
	    return (0, _axios2.default)({
	      method: 'put',
	      url: _root_url.ROOT_URL + 'v1/product/great_deal/',
	      headers: { Authorization: 'Bearer ' + token },
	      data: {
	        Product_ids: ids,
	        IsGreatDeal: isGreatDeal
	      }
	    }).then(function (response) {
	      dispatch(updateGreatDealsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(updateGreatDealsFailure(err));
	    });
	  };
	}
	
	function updatingNewArrivals() {
	  return {
	    type: _type.UPDATE_NEW_ARRIVALS
	  };
	}
	
	function updateNewArrivalsSuccess(data) {
	  return {
	    type: _type.UPDATE_NEW_ARRIVALS_SUCCESS,
	    payload: data
	  };
	}
	
	function updateNewArrivalsFailure(error) {
	  return {
	    type: _type.UPDATE_NEW_ARRIVALS_FAILURE,
	    payload: error
	  };
	}
	
	/*
	* @ids - array of product ids
	* @isNewArrival - boolean type indicating whether isNewArrival or not for the
	*                list of products (ids)
	*/
	function updateNewArrivals(ids, isNewArrival) {
	  return function (dispatch) {
	    dispatch(updatingNewArrivals());
	    var token = localStorage.getItem('token');
	    return (0, _axios2.default)({
	      method: 'put',
	      url: _root_url.ROOT_URL + 'v1/product/new_arrival/',
	      headers: { Authorization: 'Bearer ' + token },
	      data: {
	        Product_ids: ids,
	        IsNewArrival: isNewArrival
	      }
	    }).then(function (response) {
	      dispatch(updateNewArrivalsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(updateNewArrivalsFailure(err));
	    });
	  };
	}
	
	function fetchingBillboardImages() {
	  return {
	    type: _type.FETCH_BILLBOARD_IMAGES
	  };
	}
	
	function fetchBillboardImagesSuccess(data) {
	  return {
	    type: _type.FETCH_BILLBOARD_IMAGES_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchBillboardImagesFailure(error) {
	  return {
	    type: _type.FETCH_BILLBOARD_IMAGES_FAILURE,
	    payload: error
	  };
	}
	
	function fetchBillboardImages() {
	  return function (dispatch) {
	    dispatch(fetchingBillboardImages());
	    var token = localStorage.getItem('token');
	    return (0, _axios2.default)({
	      method: 'get',
	      url: _root_url.ROOT_URL + 'v1/mobile/billboard/',
	      headers: { Authorization: 'Bearer ' + token }
	    }).then(function (response) {
	      dispatch(fetchBillboardImagesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchBillboardImagesFailure(err));
	    });
	  };
	}
	
	function savingBillboardImages() {
	  return {
	    type: _type.SAVE_BILLBOARD_IMAGES
	  };
	}
	
	function saveBillboardImagesSuccess(data) {
	  return {
	    type: _type.SAVE_BILLBOARD_IMAGES_SUCCESS,
	    payload: data
	  };
	}
	
	function saveBillboardImagesFailure(error) {
	  return {
	    type: _type.SAVE_BILLBOARD_IMAGES_FAILURE,
	    payload: error
	  };
	}
	
	/*
	*@billboardImagesList = ["Image", "Index", "IsEnabled", "URL", "Language"]
	*/
	function saveBillboardImages(billboardImagesList) {
	  return function (dispatch) {
	    dispatch(savingBillboardImages());
	    var token = localStorage.getItem('token');
	    return (0, _axios2.default)({
	      method: 'post',
	      url: _root_url.ROOT_URL + 'v1/mobile/billboard/',
	      headers: { Authorization: 'Bearer ' + token },
	      data: billboardImagesList
	    }).then(function (response) {
	      dispatch(saveBillboardImagesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(saveBillboardImagesFailure(err));
	    });
	  };
	}
	
	function deletingBillboardImage() {
	  return {
	    type: _type.DELETE_BILLBOARD_IMAGE
	  };
	}
	
	function deleteBillboardImageSuccess(data) {
	  return {
	    type: _type.DELETE_BILLBOARD_IMAGE_SUCCESS,
	    payload: data
	  };
	}
	
	function deleteBillboardImageFailure(error) {
	  return {
	    type: _type.DELETE_BILLBOARD_IMAGE_FAILURE,
	    payload: error
	  };
	}
	
	/*
	*@id of the image. Only images that are saved on the backend
	*  have an id.
	*/
	function deleteBillboardImage(id) {
	  return function (dispatch) {
	    dispatch(deletingBillboardImage());
	    var token = localStorage.getItem('token');
	    return (0, _axios2.default)({
	      method: 'delete',
	      url: _root_url.ROOT_URL + 'v1/mobile/billboard/' + id,
	      headers: { Authorization: 'Bearer ' + token }
	    }).then(function (response) {
	      dispatch(deleteBillboardImageSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(deleteBillboardImageFailure(err));
	    });
	  };
	}
	
	/**
	* @param {String} html serialized string html
	* @param {func} handleSuccess callback function for success
	* @param {func} handleFailure callback function for failure
	*/
	var saveFAQBoxText = exports.saveFAQBoxText = function saveFAQBoxText(html, handleSuccess, handleFailure) {
	  var config = {
	    method: 'put',
	    url: _root_url.ROOT_URL + 'v1/mobile/faq',
	    data: {
	      rich_text: html
	    }
	  };
	  var token = localStorage.getItem('token');
	  (0, _axios2.default)(_extends({}, config, {
	    headers: { Authorization: 'Bearer ' + token }
	  })).then(function (response) {
	    handleSuccess(response.data);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	};
	
	/**
	* @param {func} handleSuccess callback function for success
	* @param {func} handleFailure callback function for failure
	*/
	var fetchFAQBoxText = exports.fetchFAQBoxText = function fetchFAQBoxText(handleSuccess, handleFailure) {
	  var config = {
	    method: 'get',
	    url: _root_url.ROOT_URL + 'v1/mobile/faq'
	  };
	  var token = localStorage.getItem('token');
	  (0, _axios2.default)(_extends({}, config, {
	    headers: { Authorization: 'Bearer ' + token }
	  })).then(function (response) {
	    handleSuccess(response.data);
	  }, function (err) {
	    if (err.status === 500 || err.status === 404) {
	      err.data = _constants.DEFAULT_ERROR;
	    }
	    handleFailure(err.data);
	  });
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchingGreatDealsNewArrivals, 'fetchingGreatDealsNewArrivals', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchGreatDealsNewArrivalsSuccess, 'fetchGreatDealsNewArrivalsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchGreatDealsNewArrivalsFailure, 'fetchGreatDealsNewArrivalsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchGreatDealsNewArrivals, 'fetchGreatDealsNewArrivals', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(updatingGreatDeals, 'updatingGreatDeals', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(updateGreatDealsSuccess, 'updateGreatDealsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(updateGreatDealsFailure, 'updateGreatDealsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(updateGreatDeals, 'updateGreatDeals', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(updatingNewArrivals, 'updatingNewArrivals', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(updateNewArrivalsSuccess, 'updateNewArrivalsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(updateNewArrivalsFailure, 'updateNewArrivalsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(updateNewArrivals, 'updateNewArrivals', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchingBillboardImages, 'fetchingBillboardImages', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchBillboardImagesSuccess, 'fetchBillboardImagesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchBillboardImagesFailure, 'fetchBillboardImagesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchBillboardImages, 'fetchBillboardImages', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(savingBillboardImages, 'savingBillboardImages', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(saveBillboardImagesSuccess, 'saveBillboardImagesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(saveBillboardImagesFailure, 'saveBillboardImagesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(saveBillboardImages, 'saveBillboardImages', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(deletingBillboardImage, 'deletingBillboardImage', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteBillboardImageSuccess, 'deleteBillboardImageSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteBillboardImageFailure, 'deleteBillboardImageFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteBillboardImage, 'deleteBillboardImage', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(saveFAQBoxText, 'saveFAQBoxText', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchFAQBoxText, 'fetchFAQBoxText', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mobileManagement_actions.js');
	}();

	;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.requestOtherService = requestOtherService;
	exports.fetchOtherServiceSuccess = fetchOtherServiceSuccess;
	exports.fetchOtherServiceFailure = fetchOtherServiceFailure;
	exports.fetchOtherService = fetchOtherService;
	exports.selectSalesOrder = selectSalesOrder;
	exports.resetCurrentSalesOrder = resetCurrentSalesOrder;
	exports.fetchSalesOrderDetail = fetchSalesOrderDetail;
	exports.requestSalesOrderDetail = requestSalesOrderDetail;
	exports.fetchSalesOrderDetailSuccess = fetchSalesOrderDetailSuccess;
	exports.fetchSalesOrderDetailFailure = fetchSalesOrderDetailFailure;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _root_url = __webpack_require__(9);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function requestOtherService() {
	  return {
	    type: _type.REQUEST_OTHER_SERVICE
	  };
	}
	
	function fetchOtherServiceSuccess(otherService) {
	  return {
	    type: _type.FETCH_OTHER_SERVICE_SUCCESS,
	    payload: otherService
	  };
	}
	
	function fetchOtherServiceFailure(error) {
	  return {
	    type: _type.FETCH_OTHER_SERVICE_FAILURE,
	    payload: error
	  };
	}
	
	function fetchOtherService() {
	  return function (dispatch) {
	    dispatch(requestOtherService());
	    return _axios2.default.get(_url.SALE_OTHER_SERVICE_SEARCH_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchOtherServiceSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchOtherServiceFailure(err));
	    });
	  };
	}
	
	function selectSalesOrder(salesOrder) {
	  return {
	    type: _type.SELECT_SALES_ORDER,
	    payload: salesOrder
	  };
	}
	
	function resetCurrentSalesOrder() {
	  return {
	    type: _type.RESET_CURRENT_SALES_ORDER
	  };
	}
	
	// Fetch the detail page.
	function fetchSalesOrderDetail(salesOrder_id, route) {
	  var url = route == 'salesOrders' ? _url.SALES_ORDERS_URL : _url.MOBILE_SALES_ORDERS_URL;
	  return function (dispatch) {
	    dispatch(requestSalesOrderDetail());
	    return _axios2.default.get(url + '?pk=' + salesOrder_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesOrderDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesOrderDetailFailure(err));
	    });
	  };
	}
	
	function requestSalesOrderDetail() {
	  return {
	    type: _type.REQUEST_SALES_ORDER_DETAIL
	  };
	}
	
	function fetchSalesOrderDetailSuccess(salesOrderDetail) {
	  salesOrderDetail = salesOrderDetail.data;
	  // The date data fetched is in the form of string, which needs to be modified into Date type
	  if (salesOrderDetail.OrderDate) salesOrderDetail.OrderDate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.OrderDate);
	  if (salesOrderDetail.ETADate) salesOrderDetail.ETADate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.ETADate);
	  if (salesOrderDetail.ReceivedDate) salesOrderDetail.ReceivedDate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.ReceivedDate);
	  if (salesOrderDetail.DispatchDate) salesOrderDetail.DispatchDate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.DispatchDate);
	  return {
	    type: _type.FETCH_SALES_ORDER_DETAIL_SUCCESS,
	    payload: salesOrderDetail
	  };
	}
	
	function fetchSalesOrderDetailFailure(error) {
	  return {
	    type: _type.FETCH_SALES_ORDER_DETAIL_FAILURE,
	    payload: error
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestOtherService, 'requestOtherService', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/otherService_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchOtherServiceSuccess, 'fetchOtherServiceSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/otherService_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchOtherServiceFailure, 'fetchOtherServiceFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/otherService_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchOtherService, 'fetchOtherService', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/otherService_actions.js');
	
	  __REACT_HOT_LOADER__.register(selectSalesOrder, 'selectSalesOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/otherService_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetCurrentSalesOrder, 'resetCurrentSalesOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/otherService_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderDetail, 'fetchSalesOrderDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/otherService_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestSalesOrderDetail, 'requestSalesOrderDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/otherService_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderDetailSuccess, 'fetchSalesOrderDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/otherService_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderDetailFailure, 'fetchSalesOrderDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/otherService_actions.js');
	}();

	;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchPreviousOrdersSuccess = fetchPreviousOrdersSuccess;
	exports.fetchPreviousOrdersFailure = fetchPreviousOrdersFailure;
	exports.fetchPreviousOrders = fetchPreviousOrders;
	exports.fetchPreviousSOsSuccess = fetchPreviousSOsSuccess;
	exports.fetchPreviousSOsFailure = fetchPreviousSOsFailure;
	exports.fetchPreviousSalesOrderByCustomer = fetchPreviousSalesOrderByCustomer;
	exports.fetchSalesOrderDetailSuccess = fetchSalesOrderDetailSuccess;
	exports.fetchSalesOrderDetailFailure = fetchSalesOrderDetailFailure;
	exports.fetchPreviousOrdersFromALLSOsSuccess = fetchPreviousOrdersFromALLSOsSuccess;
	exports.fetchPreviousOrdersFromALLSOsFailure = fetchPreviousOrdersFromALLSOsFailure;
	exports.fetchPreviousOrdersFromALLSalesOrder = fetchPreviousOrdersFromALLSalesOrder;
	exports.fetchPreviousOrderBySearchSuccess = fetchPreviousOrderBySearchSuccess;
	exports.ffetchPreviousOrderBySearchFailure = ffetchPreviousOrderBySearchFailure;
	exports.fetchPreviousOrderBySearch = fetchPreviousOrderBySearch;
	exports.fetchPreviousOrderById = fetchPreviousOrderById;
	exports.fetchPreviousSalesOrderByIndexFromLast = fetchPreviousSalesOrderByIndexFromLast;
	exports.selectPreviousOrders = selectPreviousOrders;
	exports.resetCurrentPreviousOrders = resetCurrentPreviousOrders;
	exports.fetchPreviousOrdersDetail = fetchPreviousOrdersDetail;
	exports.fetchPreviousOrdersDetailSuccess = fetchPreviousOrdersDetailSuccess;
	exports.fetchPreviousOrdersDetailFailure = fetchPreviousOrdersDetailFailure;
	exports.addNewPreviousOrder = addNewPreviousOrder;
	exports.addPreviousOrderSuccess = addPreviousOrderSuccess;
	exports.addPreviousOrderFailure = addPreviousOrderFailure;
	exports.deletePreviousOrder = deletePreviousOrder;
	exports.deletePreviousOrderSuccess = deletePreviousOrderSuccess;
	exports.deletePreviousOrderFailure = deletePreviousOrderFailure;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Inventories Actions
	
	function fetchPreviousOrdersSuccess(previousOrders) {
	  return {
	    type: _type.FETCH_PREVIOUSORDERS_SUCCESS,
	    payload: previousOrders
	  };
	}
	
	function fetchPreviousOrdersFailure(error) {
	  return {
	    type: _type.FETCH_PREVIOUSORDERS_FAILURE,
	    payload: error
	  };
	}
	
	function fetchPreviousOrders(customerID, fromDate, toDate) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PREVIOUSORDERS });
	    var dates = (0, _cleanDates.toFromDates)(-1, fromDate, toDate);
	    return _axios2.default.get(_url.PREVIOUSORDERS_URL + customerID + '?StartDate=' + dates.fromDate + '&EndDate=' + dates.toDate, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPreviousOrdersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPreviousOrdersFailure(err));
	    });
	  };
	}
	
	// Fetch previous sales order
	function fetchPreviousSOsSuccess(previousSOs) {
	  return {
	    type: _type.FETCH_PREVIOUSSOS_SUCCESS,
	    payload: previousSOs
	  };
	}
	
	function fetchPreviousSOsFailure(error) {
	  return {
	    type: _type.FETCH_PREVIOUSSOS_FAILURE,
	    payload: error
	  };
	}
	function fetchPreviousSalesOrderByCustomer(customerId, postingDateGT, postingDateLT) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PREVIOUSSOS });
	    // default 90 days
	    var days = 90;
	    var dates = (0, _cleanDates.toFromDates)(days, postingDateGT, postingDateLT);
	    return _axios2.default.get(_url.SALES_ORDERS_URL + 'search/?Deliver_Customer_id=' + customerId + '&OrderDate__gte=' + dates.fromDate + '&OrderDate__lte=' + dates.toDate, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPreviousSOsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPreviousSOsFailure(err));
	    });
	  };
	}
	
	function fetchSalesOrderDetailSuccess(salesOrderDetail) {
	  return {
	    type: _type.FETCH_PREVIOUSSO_DETAIL_SUCCESS,
	    payload: salesOrderDetail
	  };
	}
	
	function fetchSalesOrderDetailFailure(error) {
	  return {
	    type: _type.FETCH_PREVIOUSSO_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	// Fetch products from all previous sales order
	function fetchPreviousOrdersFromALLSOsSuccess(products) {
	  return {
	    type: _type.FETCH_PREVIOUSSO_DETAIL_SUCCESS,
	    payload: products
	  };
	}
	function fetchPreviousOrdersFromALLSOsFailure(error) {
	  return {
	    type: _type.FETCH_PREVIOUSSO_DETAIL_FAILURE,
	    payload: error
	  };
	}
	function fetchPreviousOrdersFromALLSalesOrder(customerId, postingDateGT, postingDateLT) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PREVIOUSSO_DETAIL });
	    // default 90 days
	    var days = 90;
	    var dates = (0, _cleanDates.toFromDates)(days, postingDateGT, postingDateLT);
	    return _axios2.default.get(_url.SALES_ORDERS_URL + 'previous_date?Deliver_Customer_id=' + customerId + '&OrderDate__gte=' + dates.fromDate + '&OrderDate__lte=' + dates.toDate, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPreviousOrdersFromALLSOsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPreviousOrdersFromALLSOsFailure(err));
	    });
	  };
	}
	
	// Fetch SO from select search
	function fetchPreviousOrderBySearchSuccess(salesOrderDetail) {
	  return {
	    type: _type.FETCH_PREVIOUSSO_DETAIL_SUCCESS,
	    payload: salesOrderDetail
	  };
	}
	function ffetchPreviousOrderBySearchFailure(error) {
	  return {
	    type: _type.FETCH_PREVIOUSSO_DETAIL_FAILURE,
	    payload: error
	  };
	}
	function fetchPreviousOrderBySearch(SONum) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PREVIOUSSO_DETAIL });
	    return _axios2.default.get(_url.SALES_ORDERS_URL + '?SONum=' + SONum, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPreviousOrderBySearchSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(ffetchPreviousOrderBySearchFailure(err));
	    });
	  };
	}
	
	// Fetch products from select sales order
	function fetchPreviousOrderById(salesOrder_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PREVIOUSSO_DETAIL });
	    return _axios2.default.get(_url.SALES_ORDERS_URL + '?pk=' + salesOrder_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesOrderDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesOrderDetailFailure(err));
	    });
	  };
	}
	
	function fetchPreviousSalesOrderByIndexFromLast(customerId, indexFromLast) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PREVIOUSORDERS });
	    return (0, _axios2.default)({
	      method: 'GET',
	      url: '' + _url.PREVIOUSORDERS_URL + customerId + '/' + indexFromLast,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPreviousOrdersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPreviousOrdersFailure(err));
	    });
	  };
	}
	
	function selectPreviousOrders(previousOrders) {
	  return {
	    type: _type.SELECT_PREVIOUSORDERS,
	    payload: previousOrders
	  };
	}
	
	function resetCurrentPreviousOrders() {
	  return {
	    type: _type.RESET_CURRENT_PREVIOUSORDERS
	  };
	}
	
	function fetchPreviousOrdersDetail(previousOrders_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PREVIOUSORDERS_DETAIL });
	    return _axios2.default.get(_url.PREVIOUSORDERS_URL + previousOrders_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPreviousOrdersDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPreviousOrdersDetailFailure(err));
	    });
	  };
	}
	
	function fetchPreviousOrdersDetailSuccess(previousOrdersDetail) {
	  return {
	    type: _type.FETCH_PREVIOUSORDERS_DETAIL_SUCCESS,
	    payload: previousOrdersDetail
	  };
	}
	
	function fetchPreviousOrdersDetailFailure(error) {
	  return {
	    type: _type.FETCH_PREVIOUSORDERS_DETAIL_FAILURE,
	    payload: error
	  };
	}
	
	function addNewPreviousOrder(_ref) {
	  var Product_id = _ref.Product_id,
	      ProductNum = _ref.ProductNum,
	      RefNum = _ref.RefNum,
	      ProductName = _ref.ProductName,
	      PreSale = _ref.PreSale,
	      InStock = _ref.InStock,
	      Ordered = _ref.Ordered,
	      Price = _ref.Price;
	
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_ADDING_PREVIOUSORDER });
	    _axios2.default.post(_url.PREVIOUSORDERS_URL, {
	      Product_id: Product_id,
	      ProductNum: ProductNum,
	      RefNum: RefNum,
	      ProductName: ProductName,
	      PreSale: PreSale,
	      InStock: InStock,
	      Ordered: Ordered,
	      Price: Price
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(addPreviousOrderSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(addPreviousOrderFailure(err));
	    });
	  };
	}
	
	function addPreviousOrderSuccess() {
	  return {
	    type: _type.ADD_PREVIOUSORDER_SUCCESS
	  };
	}
	
	function addPreviousOrderFailure(response) {
	  return {
	    type: _type.ADD_PREVIOUSORDER_FAILURE,
	    payload: response
	  };
	}
	
	function deletePreviousOrder(Product_id) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_DELETE_PREVIOUSORDER });
	    _axios2.default.delete(_url.PREVIOUSORDERS_URL + Product_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(deletePreviousOrderSuccess());
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(deletePreviousOrderFailure());
	    });
	  };
	}
	
	function deletePreviousOrderSuccess() {
	  return {
	    type: _type.DELETE_PREVIOUSORDER_SUCCESS
	  };
	}
	
	function deletePreviousOrderFailure(response) {
	  return {
	    type: _type.DELETE_PREVIOUSORDER_FAILURE,
	    payload: response
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchPreviousOrdersSuccess, 'fetchPreviousOrdersSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPreviousOrdersFailure, 'fetchPreviousOrdersFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPreviousOrders, 'fetchPreviousOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPreviousSOsSuccess, 'fetchPreviousSOsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPreviousSOsFailure, 'fetchPreviousSOsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPreviousSalesOrderByCustomer, 'fetchPreviousSalesOrderByCustomer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderDetailSuccess, 'fetchSalesOrderDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderDetailFailure, 'fetchSalesOrderDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPreviousOrdersFromALLSOsSuccess, 'fetchPreviousOrdersFromALLSOsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPreviousOrdersFromALLSOsFailure, 'fetchPreviousOrdersFromALLSOsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPreviousOrdersFromALLSalesOrder, 'fetchPreviousOrdersFromALLSalesOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPreviousOrderBySearchSuccess, 'fetchPreviousOrderBySearchSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(ffetchPreviousOrderBySearchFailure, 'ffetchPreviousOrderBySearchFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPreviousOrderBySearch, 'fetchPreviousOrderBySearch', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPreviousOrderById, 'fetchPreviousOrderById', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPreviousSalesOrderByIndexFromLast, 'fetchPreviousSalesOrderByIndexFromLast', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(selectPreviousOrders, 'selectPreviousOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(resetCurrentPreviousOrders, 'resetCurrentPreviousOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPreviousOrdersDetail, 'fetchPreviousOrdersDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPreviousOrdersDetailSuccess, 'fetchPreviousOrdersDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchPreviousOrdersDetailFailure, 'fetchPreviousOrdersDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(addNewPreviousOrder, 'addNewPreviousOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(addPreviousOrderSuccess, 'addPreviousOrderSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(addPreviousOrderFailure, 'addPreviousOrderFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(deletePreviousOrder, 'deletePreviousOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(deletePreviousOrderSuccess, 'deletePreviousOrderSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(deletePreviousOrderFailure, 'deletePreviousOrderFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/previousOrders_actions.jsx');
	}();

	;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PurchasingPerformanceListEpic = undefined;
	exports.fetchPurchasePerformanceByFilter = fetchPurchasePerformanceByFilter;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchPurchasePerformanceByFilter(days, fromDate, toDate, type, POStatus, Vendor_id, ProductNum) {
	  console.log('fetching dude', Vendor_id, ProductNum);
	  var dates = (0, _cleanDates.toFromDates)(days, fromDate, toDate);
	  console.log('yo here are the dates', dates);
	  var searchBy = void 0;
	  if (Vendor_id) {
	    Vendor_id = Vendor_id.value || Vendor_id;
	    searchBy = 'Vendor_id/' + Vendor_id + '/';
	  } else {
	    searchBy = 'ProductNum/' + ProductNum + '/';
	  }
	  if (POStatus) {
	    POStatus = POStatus.value || POStatus;
	    POStatus = '&PurchaseStatus=' + POStatus;
	  } else {
	    POStatus = '&PurchaseStatus=All';
	  }
	  return function (dispatch) {
	    dispatch({
	      type: _type.REQUEST_PURCHASING_PERFORMANCE_BY_FILTER,
	      payload: {
	        Vendor_id: Vendor_id,
	        dates: dates,
	        POStatus: POStatus,
	        searchBy: searchBy
	      }
	    });
	  };
	}
	
	var PurchasingPerformanceListEpic = exports.PurchasingPerformanceListEpic = function PurchasingPerformanceListEpic(action$) {
	  return action$.ofType(_type.REQUEST_PURCHASING_PERFORMANCE_BY_FILTER).switchMap(function (action) {
	    return _axios2.default.get(_url.PURCHASE_URL + 'performance/' + action.payload.searchBy + '?OrderDate__gte=' + action.payload.dates.fromDate + '&OrderDate__lte=' + action.payload.dates.toDate + action.payload.POStatus, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  }).map(function (response) {
	    return { type: _type.FETCH_PURCHASING_PERFORMANCE_SUCCESS, payload: response };
	  }).catch(function (err) {
	    return { type: _type.FETCH_PURCHASING_PERFORMANCE_FAILURE, payload: err };
	  });
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchPurchasePerformanceByFilter, 'fetchPurchasePerformanceByFilter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchasingPerformanceList_actions.js');
	
	  __REACT_HOT_LOADER__.register(PurchasingPerformanceListEpic, 'PurchasingPerformanceListEpic', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/purchasingPerformanceList_actions.js');
	}();

	;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.editRMAOrder = exports.uploadRMA = exports.changeRMAStatus = exports.createRMAOrder = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.fetchCustomers = fetchCustomers;
	exports.fetchCustomerReturnsByFilter = fetchCustomerReturnsByFilter;
	exports.fetchCustomerReturnsByFilterSuccess = fetchCustomerReturnsByFilterSuccess;
	exports.fetchCustomerReturnsByFilterFailure = fetchCustomerReturnsByFilterFailure;
	exports.createCustomerReturn = createCustomerReturn;
	exports.createCustomerReturnSuccess = createCustomerReturnSuccess;
	exports.createCustomerReturnFailure = createCustomerReturnFailure;
	exports.editCustomerReturn = editCustomerReturn;
	exports.editCustomerReturnSuccess = editCustomerReturnSuccess;
	exports.editCustomerReturnFailure = editCustomerReturnFailure;
	exports.fetchCustomerReturn = fetchCustomerReturn;
	exports.fetchReturnSuccess = fetchReturnSuccess;
	exports.dispatchEditReturn = dispatchEditReturn;
	exports.dispatchEditReturnSuccess = dispatchEditReturnSuccess;
	exports.dispatchEditReturnFailure = dispatchEditReturnFailure;
	exports.fetchDispatchReturns = fetchDispatchReturns;
	exports.fetchDispatchReturnsSuccess = fetchDispatchReturnsSuccess;
	exports.fetchDispatchReturnsFailure = fetchDispatchReturnsFailure;
	exports.setReturnsFilter = setReturnsFilter;
	exports.resetCurrentForm = resetCurrentForm;
	exports.clearCurrentReturn = clearCurrentReturn;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createRMAOrder = exports.createRMAOrder = function createRMAOrder(payload, success, failed) {
	  return function (dispatch) {
	    (0, _axios2.default)({
	      method: 'POST',
	      url: _url.BD_RMA_URL + 'order/',
	      data: payload,
	      headers: {
	        Authorization: 'Bearer ' + localStorage.getItem('token')
	      }
	    }).then(function (res) {
	      success();
	    }).catch(function (err) {
	      failed(err.data);
	    });
	  };
	};
	
	var changeRMAStatus = exports.changeRMAStatus = function changeRMAStatus(id, status, success, failed) {
	  return function (dispatch) {
	    (0, _axios2.default)({
	      method: 'PUT',
	      url: _url.BD_RMA_URL + 'change-status/' + id,
	      data: {
	        status: status
	      },
	      headers: {
	        Authorization: 'Bearer ' + localStorage.getItem('token')
	      }
	    }).then(function (res) {
	      success();
	    }).catch(function (err) {
	      failed();
	    });
	  };
	};
	
	var uploadRMA = exports.uploadRMA = function uploadRMA(data, success) {
	  return function (dispatch) {
	    (0, _axios2.default)({
	      method: 'POST',
	      url: _url.BD_RMA_URL + 'import-order ',
	      data: data,
	      headers: {
	        Authorization: 'Bearer ' + localStorage.getItem('token'),
	        "Content-Type": "multipart/form-data"
	      }
	    }).then(function (res) {
	      success();
	      alert('success');
	    }).catch(function (err) {
	      alert('ERROR: ' + err.data);
	    });
	  };
	};
	
	var editRMAOrder = exports.editRMAOrder = function editRMAOrder(payload, id, succes, failed) {
	  return function (dispatch) {
	    (0, _axios2.default)({
	      method: 'PUT',
	      url: _url.BD_RMA_URL + 'order/' + id,
	      data: payload,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (res) {
	      succes();
	    }).catch(function (err) {
	      failed();
	    });
	  };
	};
	
	function fetchCustomers(bool) {
	  return function (dispatch) {
	    var mobile = '';
	    if (bool === true) {
	      mobile = '&include_Mobile_Customer=true';
	    }
	
	    _axios2.default.get(_url.CUSTOMERS_URL + '?Customer_id__IsActive=1' + mobile, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _type.FETCH_CUSTOMERS,
	        payload: response.data
	      });
	      // dispatch(fetchReturnSuccess(response.data))
	    }).catch(function (err) {
	      // console.log('fetch fail this is the err', err)
	    });
	  };
	}
	
	function fetchCustomerReturnsByFilter(postingDateGT, postingDateLT, days, status, page, currentCustomer, search) {
	  var dates = (0, _cleanDates.toFromDates)(days, postingDateGT, postingDateLT);
	  if (status) {
	    if (status == 'all') {
	      status = '';
	    } else {
	      status = '&Fix_Status=' + status;
	    }
	  }
	  var rma_num = '',
	      customer = '';
	  // let customer = '';
	  if (currentCustomer) {
	    customer = '&customerId=' + currentCustomer.value;
	  };
	  if (search) {
	    rma_num = '&keyword=' + search;
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CUSTOMER_SEARCH });
	    return _axios2.default.get(_url.BD_RMA_URL + 'order/?start_date=' + dates.fromDate + '&end_date=' + dates.toDate + '&limit=20&page=' + page + rma_num + customer, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchCustomerReturnsByFilterSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = DEFAULT_ERROR;
	      }
	      dispatch(fetchCustomerReturnsByFilterFailure(err));
	    });
	  };
	}
	
	function fetchCustomerReturnsByFilterSuccess(data) {
	  return {
	    type: _type.CUSTOMER_SEARCH_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchCustomerReturnsByFilterFailure(err) {
	  return {
	    type: _type.CUSTOMER_SEARCH_FAILURE
	  };
	}
	
	function createCustomerReturn(_ref) {
	  var RMA_Content = _ref.RMA_Content,
	      RMA_Service_Type = _ref.RMA_Service_Type,
	      RMA_Num = _ref.RMA_Num,
	      Product_SN = _ref.Product_SN,
	      Product_Description = _ref.Product_Description,
	      Return_Logitics_Company = _ref.Return_Logitics_Company,
	      Return_Tracking_Num = _ref.Return_Tracking_Num,
	      Is_Urgent = _ref.Is_Urgent,
	      Is_Warranty = _ref.Is_Warranty,
	      Customer_Name = _ref.Customer_Name,
	      Customer_Mobile = _ref.Customer_Mobile,
	      Customer_Address = _ref.Customer_Address,
	      Customer_Email = _ref.Customer_Email,
	      Submit_Description1 = _ref.Submit_Description1,
	      Submit_Description2 = _ref.Submit_Description2,
	      Product_Model = _ref.Product_Model;
	
	  if ((typeof Is_Urgent === 'undefined' ? 'undefined' : _typeof(Is_Urgent)) === "object") {
	    Is_Urgent = Is_Urgent.value;
	  }
	  if ((typeof Is_Warranty === 'undefined' ? 'undefined' : _typeof(Is_Warranty)) === "object") {
	    Is_Warranty = Is_Warranty.value;
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CUSTOMER_CREATE_RETURN });
	    return _axios2.default.post('' + _url.BD_RMA_URL, {
	      RMA_Content: RMA_Content,
	      RMA_Service_Type: RMA_Service_Type,
	      RMA_Num: RMA_Num,
	      Product_SN: Product_SN,
	      Product_Description: Product_Description,
	      Return_Logitics_Company: Return_Logitics_Company,
	      Return_Tracking_Num: Return_Tracking_Num,
	      Is_Urgent: Is_Urgent,
	      Is_Warranty: Is_Warranty,
	      Customer_Name: Customer_Name,
	      Customer_Mobile: Customer_Mobile,
	      Customer_Address: Customer_Address,
	      Customer_Email: Customer_Email,
	      Submit_Description1: Submit_Description1,
	      Submit_Description2: Submit_Description2,
	      Product_Model: Product_Model
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(createCustomerReturnSuccess(response));
	      _reactRouter.browserHistory.push('/customerRMA');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = DEFAULT_ERROR;
	      }
	      alert(err.data);
	      dispatch(createCustomerReturnFailure(err));
	    });
	  };
	}
	
	function createCustomerReturnSuccess(data) {
	  return {
	    type: _type.CUSTOMER_CREATE_RETURN_SUCCESS,
	    payload: data
	  };
	}
	
	function createCustomerReturnFailure(err) {
	  return {
	    type: _type.CUSTOMER_CREATE_RETURN_FAILURE
	  };
	}
	
	function editCustomerReturn(_ref2) {
	  var RMA_ID = _ref2.RMA_ID,
	      RMA_Content = _ref2.RMA_Content,
	      RMA_Service_Type = _ref2.RMA_Service_Type,
	      RMA_Num = _ref2.RMA_Num,
	      Product_SN = _ref2.Product_SN,
	      Product_Description = _ref2.Product_Description,
	      Return_Logitics_Company = _ref2.Return_Logitics_Company,
	      Return_Tracking_Num = _ref2.Return_Tracking_Num,
	      Is_Urgent = _ref2.Is_Urgent,
	      Is_Warranty = _ref2.Is_Warranty,
	      Customer_Name = _ref2.Customer_Name,
	      Customer_Mobile = _ref2.Customer_Mobile,
	      Customer_Address = _ref2.Customer_Address,
	      Customer_Email = _ref2.Customer_Email,
	      Submit_Description1 = _ref2.Submit_Description1,
	      Submit_Description2 = _ref2.Submit_Description2,
	      Product_Model = _ref2.Product_Model,
	      Openbox_Description = _ref2.Openbox_Description,
	      Product_Detail_Info = _ref2.Product_Detail_Info,
	      Warehouse_Check_Info = _ref2.Warehouse_Check_Info,
	      Fix_Status = _ref2.Fix_Status,
	      Fix_Description1 = _ref2.Fix_Description1,
	      Fix_Description2 = _ref2.Fix_Description2,
	      Dispatch_Logiticis_Company = _ref2.Dispatch_Logiticis_Company,
	      Dispatch_Tracking_Num = _ref2.Dispatch_Tracking_Num,
	      Dispatch_Fee = _ref2.Dispatch_Fee,
	      Dispatch_Date = _ref2.Dispatch_Date,
	      Person_Dispatch = _ref2.Person_Dispatch,
	      Dispatch_Description1 = _ref2.Dispatch_Description1,
	      Dispatch_Description2 = _ref2.Dispatch_Description2,
	      onCustomerEditPage = _ref2.onCustomerEditPage;
	
	  if ((typeof Is_Urgent === 'undefined' ? 'undefined' : _typeof(Is_Urgent)) === "object") {
	    Is_Urgent = Is_Urgent.value;
	  }
	  if ((typeof Is_Warranty === 'undefined' ? 'undefined' : _typeof(Is_Warranty)) === "object") {
	    Is_Warranty = Is_Warranty.value;
	  }
	  if ((typeof Fix_Status === 'undefined' ? 'undefined' : _typeof(Fix_Status)) === "object") {
	    Fix_Status = Fix_Status.value;
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_CUSTOMER_EDIT_RETURN });
	    return _axios2.default.put('' + _url.BD_RMA_URL + RMA_ID, {
	      RMA_Content: RMA_Content,
	      RMA_Service_Type: RMA_Service_Type,
	      RMA_Num: RMA_Num,
	      Product_SN: Product_SN,
	      Product_Description: Product_Description,
	      Return_Logitics_Company: Return_Logitics_Company,
	      Return_Tracking_Num: Return_Tracking_Num,
	      Is_Urgent: Is_Urgent,
	      Is_Warranty: Is_Warranty,
	      Customer_Name: Customer_Name,
	      Customer_Mobile: Customer_Mobile,
	      Customer_Address: Customer_Address,
	      Customer_Email: Customer_Email,
	      Submit_Description1: Submit_Description1,
	      Submit_Description2: Submit_Description2,
	      Openbox_Description: Openbox_Description,
	      Product_Detail_Info: Product_Detail_Info,
	      Warehouse_Check_Info: Warehouse_Check_Info,
	      Fix_Status: Fix_Status,
	      Fix_Description1: Fix_Description1,
	      Fix_Description2: Fix_Description2,
	      Dispatch_Logiticis_Company: Dispatch_Logiticis_Company,
	      Dispatch_Tracking_Num: Dispatch_Tracking_Num,
	      Dispatch_Fee: Dispatch_Fee,
	      Dispatch_Date: Dispatch_Date,
	      Person_Dispatch: Person_Dispatch,
	      Dispatch_Description1: Dispatch_Description1,
	      Dispatch_Description2: Dispatch_Description2,
	      Product_Model: Product_Model
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(editCustomerReturnSuccess(response));
	      if (onCustomerEditPage) {
	        _reactRouter.browserHistory.push('/customerRMA');
	      } else {
	        _reactRouter.browserHistory.push('/dispatchRMA');
	      }
	    }, function (err) {
	      // if (err.status === 500 || err.status === 404) {
	      //     err.status = DEFAULT_ERROR;
	      // }
	      alert(JSON.stringify(err.data));
	      dispatch(editCustomerReturnFailure(err));
	    });
	  };
	}
	
	function editCustomerReturnSuccess(data) {
	  return {
	    type: _type.CUSTOMER_EDIT_RETURN_SUCCESS,
	    payload: data
	  };
	}
	
	function editCustomerReturnFailure(err) {
	  return {
	    type: _type.CUSTOMER_EDIT_RETURN_FAILURE
	  };
	}
	
	function fetchCustomerReturn(id) {
	  return function (dispatch) {
	    _axios2.default.get(_url.BD_RMA_URL + 'order/' + id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchReturnSuccess(response.data));
	    }).catch(function (err) {
	      console.log('fetch fail this is the err', err);
	    });
	  };
	}
	
	function fetchReturnSuccess(data) {
	  return {
	    type: _type.RETURN_SEARCH_SUCCESS,
	    payload: data
	  };
	}
	
	function dispatchEditReturn(_ref3, fixId) {
	  var Fix_Status = _ref3.Fix_Status,
	      Dispatch_Logiticis_Company = _ref3.Dispatch_Logiticis_Company,
	      Dispatch_Tracking_Num = _ref3.Dispatch_Tracking_Num,
	      Dispatch_Fee = _ref3.Dispatch_Fee,
	      Dispatch_Date = _ref3.Dispatch_Date,
	      Person_Dispatch = _ref3.Person_Dispatch,
	      Dispatch_Description1 = _ref3.Dispatch_Description1,
	      Dispatch_Description2 = _ref3.Dispatch_Description2;
	
	  return function (dispatch) {
	    dispatch(_type.REQUEST_DISPATCH_EDIT_RETURN);
	    return _axios2.default.put(_url.BD_RMA_URL + 'fix/' + fixId, {
	      Fix_Status: Fix_Status,
	      Dispatch_Logiticis_Company: Dispatch_Logiticis_Company,
	      Dispatch_Tracking_Num: Dispatch_Tracking_Num,
	      Dispatch_Fee: Dispatch_Fee,
	      Dispatch_Date: Dispatch_Date,
	      Person_Dispatch: Person_Dispatch,
	      Dispatch_Description1: Dispatch_Description1,
	      Dispatch_Description2: Dispatch_Description2
	    }, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(dispatchEditReturnSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = DEFAULT_ERROR;
	      }
	      dispatch(dispatchEditReturnFailure(err));
	    });
	  };
	}
	
	function dispatchEditReturnSuccess(data) {
	  return {
	    type: _type.DISPATCH_EDIT_RETURN_SUCCESS,
	    payload: data
	  };
	}
	
	function dispatchEditReturnFailure(err) {
	  return {
	    type: _type.DISPATCH_EDIT_RETURN_FAILURE
	  };
	}
	
	function fetchDispatchReturns(postingDateGT, postingDateLT, days, status, search) {
	  var dates = (0, _cleanDates.toFromDates)(days, postingDateGT, postingDateLT);
	  if (status) {
	    if (status == 'all') {
	      status = '';
	    } else {
	      status = '&Fix_Status=' + status;
	    }
	  }
	  if (search) {
	    search = '&search=' + search;
	  } else {
	    search = '';
	  }
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_DISPATCH_SEARCH });
	    return _axios2.default.get(_url.BD_RMA_URL + 'fix/search/?Date_Created__gte=' + dates.fromDate + '&Date_Created__lte=' + dates.toDate + status + search, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchDispatchReturnsSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = DEFAULT_ERROR;
	      }
	      dispatch(fetchDispatchReturnsFailure(err));
	    });
	  };
	}
	
	function fetchDispatchReturnsSuccess(data) {
	  return {
	    type: _type.DISPATCH_SEARCH_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchDispatchReturnsFailure(err) {
	  return {
	    type: _type.DISPATCH_SEARCH_FAILURE
	  };
	}
	
	function setReturnsFilter(data) {
	  return {
	    type: _type.SET_RETURNS_FILTER,
	    payload: data
	  };
	}
	
	function resetCurrentForm() {
	  return {
	    type: _type.RESET_CURRENT_FORM
	  };
	}
	
	function clearCurrentReturn() {
	  return {
	    type: _type.RESET_CURRENT_RETURN
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(createRMAOrder, 'createRMAOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(changeRMAStatus, 'changeRMAStatus', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(uploadRMA, 'uploadRMA', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(editRMAOrder, 'editRMAOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomers, 'fetchCustomers', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerReturnsByFilter, 'fetchCustomerReturnsByFilter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerReturnsByFilterSuccess, 'fetchCustomerReturnsByFilterSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerReturnsByFilterFailure, 'fetchCustomerReturnsByFilterFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(createCustomerReturn, 'createCustomerReturn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(createCustomerReturnSuccess, 'createCustomerReturnSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(createCustomerReturnFailure, 'createCustomerReturnFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(editCustomerReturn, 'editCustomerReturn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(editCustomerReturnSuccess, 'editCustomerReturnSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(editCustomerReturnFailure, 'editCustomerReturnFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerReturn, 'fetchCustomerReturn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchReturnSuccess, 'fetchReturnSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(dispatchEditReturn, 'dispatchEditReturn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(dispatchEditReturnSuccess, 'dispatchEditReturnSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(dispatchEditReturnFailure, 'dispatchEditReturnFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchDispatchReturns, 'fetchDispatchReturns', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchDispatchReturnsSuccess, 'fetchDispatchReturnsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchDispatchReturnsFailure, 'fetchDispatchReturnsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(setReturnsFilter, 'setReturnsFilter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetCurrentForm, 'resetCurrentForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	
	  __REACT_HOT_LOADER__.register(clearCurrentReturn, 'clearCurrentReturn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/rma_actions.js');
	}();

	;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SalesOrderListEpic = exports.searchInvoicesByTrackingNo = exports.uploadSOPOD = exports.uploadSOImage = exports.setOrdersToOpen = exports.searchInvoicesByInvoiceNo = undefined;
	exports.fetchSalesOrdersByFilter = fetchSalesOrdersByFilter;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _Observable = __webpack_require__(828);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import 'rxjs/add/operator/switchMap';
	
	var isDSQ = _root_url.ROOT_API_URL === 'https://dsq-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://dsq-scm.truckxi.com/api/';
	var isWIZ = _root_url.ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
	var isFJ = _root_url.ROOT_API_URL === 'https://fj-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://fj-scm.truckxi.com/api/';
	var isJTB = _root_url.ROOT_API_URL === 'https://jtb-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://jtb-scm.truckxi.com/api/';
	var isAFM = _root_url.ROOT_API_URL === "https://afm-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://afm-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://afmstage-scm.truckxi.com/api/";
	var isABC = _root_url.ROOT_API_URL === "https://abc-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://abc-scm.truckxi.com/api/";
	var isKDW = _root_url.ROOT_API_URL === 'https://kdw-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://kdw-scm.truckxi.com/api/';
	var isABCFF = _root_url.ROOT_API_URL === 'https://abcff-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://abcff-scm.truckxi.com/api/';
	var isYI = _root_url.ROOT_API_URL === 'https://ying-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ying-scm.truckxi.com/api/';
	var isFBD = _root_url.ROOT_API_URL === 'https://fbd-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://fbd-scm.truckxi.com/api/';
	var isWUFS = _root_url.ROOT_API_URL === 'https://wufs-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://wufs-scm.truckxi.com/api/';
	var isEcity = _root_url.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://ctstage-scm.truckxi.com/api/';
	
	function fetchSalesOrdersByFilter(postingDateGT, postingDateLT, days, status, user, productNum, route, dispatchDateGT, dispatchDateLT, dispatchDays, limit, page, searchFilter, warehouse) {
	  var url = route == 'salesOrders' ? _url.SALES_ORDERS_URL : _url.MOBILE_SALES_ORDERS_URL;
	  var dates = (0, _cleanDates.toFromDates)(days, postingDateGT, postingDateLT);
	  var dispatchDates = (0, _cleanDates.toFromDispatchDates)(dispatchDays, dispatchDateGT, dispatchDateLT);
	  if (status == 'all') {
	    status = '';
	  } else {
	    status = '&SaleStatus=' + status;
	  }
	
	  if (user && user.value) {
	    user = user.value;
	  }
	  if (user) {
	    user = isEcity ? '&Deliver_Customer_id__Sales_User_id=' + user : '&Sales_User_id=' + user;
	  } else {
	    user = '';
	  }
	
	  if (warehouse && warehouse.value) {
	    warehouse = warehouse.value;
	  }
	  if (warehouse) {
	    warehouse = '&Pickup_Warehouse_id_id=' + warehouse;
	  } else {
	    warehouse = '';
	  }
	
	  if (productNum) {
	    productNum = '&ProductNum=' + productNum;
	  } else {
	    productNum = '';
	  }
	
	  var belongWarehouse = '';
	  if (isAFM) {
	    if (!localStorage.getItem('warehouseLocation') || localStorage.getItem('warehouseLocation') === '' || localStorage.getItem('warehouseLocation') === 'none') {
	      belongWarehouse = '';
	    } else {
	      belongWarehouse = '&BelongWarehouse=' + localStorage.getItem('warehouseLocation');
	    }
	  }
	
	  var pageL = '';
	  var limitL = '';
	  var soNumL = '';
	  var companyL = '';
	  var fbaL = '';
	  var bolL = '';
	  var isaL = '';
	  var shippingL = '';
	  var containerL = '';
	
	  if (isABC && route !== 'salesOrders') {
	    url = route == 'salesOrders' ? _url.SALES_ORDERS_URL : _url.MOBILE_SALES_ORDERS_URL_v2;
	    if (page) {
	      pageL = '&page=' + (page + 1);
	    } else {
	      pageL = '&page=1';
	    }
	    if (limit) {
	      limitL = '&limit=' + limit;
	    } else {
	      limitL = '&limit=99999';
	    }
	
	    // if (searchFilter) {
	    if (searchFilter.SONum) {
	      soNumL = '&SONum=' + searchFilter.SONum;
	    }
	    if (searchFilter.CompanyName) {
	      companyL = '&CompanyName=' + searchFilter.CompanyName;
	    }
	    if (searchFilter.FBACode) {
	      fbaL = '&FBACode=' + searchFilter.FBACode;
	    }
	    if (searchFilter.CustomerBOLNo) {
	      bolL = '&BOLNum=' + searchFilter.CustomerBOLNo;
	    }
	    if (searchFilter.IsaNo) {
	      isaL = '&ISANum=' + searchFilter.IsaNo;
	    }
	    if (searchFilter.ShippingStatus) {
	      shippingL = '&ShippingStatus=' + searchFilter.ShippingStatus;
	    }
	    if (searchFilter.ContainerNo) {
	      containerL = '&ContainerNum=' + searchFilter.ContainerNo;
	    }
	    // }
	  }
	
	  var IsOutbound = '';
	  if (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
	    url = _url.SALES_ORDERS_URL;
	    if (route === 'salesOrders') {
	      IsOutbound = '&IsOutbound=false';
	    } else if (route === 'outboundOrders') {
	      IsOutbound = '&IsOutbound=true';
	    } else if (route === 'mobileSalesOrders') {
	      // IsOutbound = `&IsOutbound=`;
	      IsOutbound = '';
	      url = _url.MOBILE_SALES_ORDERS_URL;
	    }
	  }
	
	  return function (dispatch) {
	    dispatch({
	      type: _type.REQUEST_SALES_ORDERS_BY_FILTER,
	      payload: {
	        url: url,
	        dates: dates,
	        status: status,
	        user: user,
	        warehouse: warehouse,
	        productNum: productNum,
	        dispatchDates: dispatchDates,
	        belongWarehouse: belongWarehouse,
	        IsOutbound: IsOutbound,
	        pageL: pageL,
	        limitL: limitL,
	        soNumL: soNumL,
	        companyL: companyL,
	        fbaL: fbaL,
	        bolL: bolL,
	        isaL: isaL,
	        shippingL: shippingL,
	        containerL: containerL
	      }
	    });
	  };
	}
	
	var searchInvoicesByInvoiceNo = exports.searchInvoicesByInvoiceNo = function searchInvoicesByInvoiceNo(searchType, searchTerm, pathname, limit, page) {
	  return function (dispatch) {
	
	    var url = pathname === '/salesOrders' ? _url.SALES_ORDERS_URL : _url.MOBILE_SALES_ORDERS_URL;
	    var params = {};
	
	    if (searchType !== 'invoiceNo') {
	      params[searchType] = searchTerm;
	    } else {
	      params['search'] = searchTerm;
	    }
	
	    if (!localStorage.getItem('warehouseLocation') || localStorage.getItem('warehouseLocation') === '') {
	      // params['BelongWarehouse'] = ;
	    } else {
	      params['BelongWarehouse'] = localStorage.getItem('warehouseLocation');
	    }
	
	    if (isABC && pathname !== '/salesOrders') {
	      url = pathname === '/salesOrders' ? _url.SALES_ORDERS_URL : _url.MOBILE_SALES_ORDERS_URL_v2;
	      if (page) {
	        params['page'] = page + 1;
	      } else {
	        params['page'] = 1;
	      }
	      if (limit) {
	        params['limit'] = limit;
	      } else {
	        params['limit'] = 99999;
	      }
	    }
	
	    _axios2.default.get(url + 'search/', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      params: params
	    }).then(function (res) {
	      dispatch({
	        type: _type.FETCH_SALES_ORDERS_SUCCESS, payload: res
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: _type.FETCH_SALES_ORDERS_FAILURE,
	        payload: JSON.stringify(err)
	      });
	    });
	  };
	};
	
	var setOrdersToOpen = exports.setOrdersToOpen = function setOrdersToOpen(SalesOrderids, success, failed) {
	  return function (dispatch) {
	    (0, _axios2.default)({
	      method: 'PUT',
	      url: _url.SALES_ORDERS_URL + 'open/',
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      data: {
	        ids: SalesOrderids.split(',')
	      }
	    }).then(function (res) {
	      success();
	    }).catch(function (err) {
	      failed();
	    });
	  };
	};
	
	var uploadSOImage = exports.uploadSOImage = function uploadSOImage(formData, success, failed) {
	  return function (dispatch) {
	    console.log('uploadSOImage run');
	    return;
	    (0, _axios2.default)({
	      method: 'POST',
	      // url: `${SALES_ORDERS_URL}open/`,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      data: formData
	    }).then(function (res) {
	      success();
	    }).catch(function (err) {
	      failed();
	    });
	  };
	};
	
	var uploadSOPOD = exports.uploadSOPOD = function uploadSOPOD(formData, success, failed) {
	  return function (dispatch) {
	    console.log('uploadSOPOD run');
	    return;
	    (0, _axios2.default)({
	      method: 'POST',
	      // url: `${SALES_ORDERS_URL}open/`,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      data: formData
	    }).then(function (res) {
	      success();
	    }).catch(function (err) {
	      failed();
	    });
	  };
	};
	
	var searchInvoicesByTrackingNo = exports.searchInvoicesByTrackingNo = function searchInvoicesByTrackingNo(searchTerm, pathname) {
	  return function (dispatch) {
	    var url = pathname === '/salesOrders' ? _url.SALES_ORDERS_URL : _url.MOBILE_SALES_ORDERS_URL;
	    var params = {};
	    params['searchTrackingNo'] = searchTerm;
	    if (!localStorage.getItem('warehouseLocation') || localStorage.getItem('warehouseLocation') === '') {
	      // params['BelongWarehouse'] = ;
	    } else {
	      params['BelongWarehouse'] = localStorage.getItem('warehouseLocation');
	    }
	    _axios2.default.get(url + 'search/', {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      params: params
	    }).then(function (res) {
	      dispatch({
	        type: _type.FETCH_SALES_ORDERS_SUCCESS, payload: res
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: _type.FETCH_SALES_ORDERS_FAILURE,
	        payload: JSON.stringify(err)
	      });
	    });
	  };
	};
	
	var SalesOrderListEpic = exports.SalesOrderListEpic = function SalesOrderListEpic(action$) {
	  return action$.ofType(_type.REQUEST_SALES_ORDERS_BY_FILTER).switchMap(function (action) {
	    return _axios2.default.get(action.payload.url + 'search/?OrderDate__gte=' + action.payload.dates.fromDate + '&OrderDate__lte=' + action.payload.dates.toDate + '&DispatchDate__gte=' + action.payload.dispatchDates.dispatchDateGT + '&DispatchDate__lte=' + action.payload.dispatchDates.dispatchDateLT + action.payload.status + action.payload.user + action.payload.warehouse + action.payload.productNum + action.payload.belongWarehouse + action.payload.IsOutbound + (action.payload.pageL ? action.payload.pageL : '') + (action.payload.limitL ? action.payload.limitL : '') + (action.payload.soNumL ? action.payload.soNumL : '') + (action.payload.companyL ? action.payload.companyL : '') + (action.payload.fbaL ? action.payload.fbaL : '') + (action.payload.containerL ? action.payload.containerL : '') + (action.payload.isaL ? action.payload.isaL : '') + (action.payload.shippingL ? action.payload.shippingL : '') + (action.payload.bolL ? action.payload.bolL : ''), //${action.payload.pageL}${action.payload.limitL}${action.payload.soNum}${action.payload.companyL}${action.payload.fbaL}
	    {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  }).map(function (response) {
	    return { type: _type.FETCH_SALES_ORDERS_SUCCESS, payload: response };
	  }).catch(function (err, source) {
	    return source;
	    // return ActionsObservable.of({
	    //   type: FETCH_SALES_ORDERS_FAILURE,
	    //   payload: JSON.stringify(err),
	    // })
	  });
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrdersByFilter, 'fetchSalesOrdersByFilter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(searchInvoicesByInvoiceNo, 'searchInvoicesByInvoiceNo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(setOrdersToOpen, 'setOrdersToOpen', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(uploadSOImage, 'uploadSOImage', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(uploadSOPOD, 'uploadSOPOD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(searchInvoicesByTrackingNo, 'searchInvoicesByTrackingNo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(SalesOrderListEpic, 'SalesOrderListEpic', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(isDSQ, 'isDSQ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(isWIZ, 'isWIZ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(isFJ, 'isFJ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(isJTB, 'isJTB', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(isAFM, 'isAFM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(isABC, 'isABC', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(isKDW, 'isKDW', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(isABCFF, 'isABCFF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(isYI, 'isYI', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(isFBD, 'isFBD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(isWUFS, 'isWUFS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesOrderList_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesOrderList_actions.jsx');
	}();

	;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SalesPerformanceListEpic = undefined;
	exports.fetchSalesPerformanceByFilter = fetchSalesPerformanceByFilter;
	exports.fetchUserPerformanceByFilter = fetchUserPerformanceByFilter;
	exports.requestUserPerformanceByFilter = requestUserPerformanceByFilter;
	exports.requestUserPerformanceSuccess = requestUserPerformanceSuccess;
	exports.requestUserPerformanceFailure = requestUserPerformanceFailure;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isAFM = _root_url.ROOT_API_URL === "https://afm-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://afm-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://afmstage-scm.truckxi.com/api/";
	var isATL = _root_url.ROOT_API_URL === 'https://alton-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://alton-scm.truckxi.com/api/';
	var isEcity = _root_url.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://ctstage-scm.truckxi.com/api/';
	
	function fetchSalesPerformanceByFilter(orderType, salesType, days, fromDate, toDate, type, productNum, group, category, aggregate, user, customer) {
	  var dates = (0, _cleanDates.toFromDates)(days, fromDate, toDate);
	  if (salesType === 'salesorder') {
	    fromDate = 'SalesInvoice_id__DispatchDate__gte=' + dates.fromDate;
	    toDate = 'SalesInvoice_id__DispatchDate__lte=' + dates.toDate;
	  } else if (salesType === 'posorder') {
	    fromDate = 'Order_id__Date__gte=' + dates.fromDate;
	    toDate = 'Order_id__Date__lte=' + dates.toDate;
	  } else if (salesType === 'all') {
	    fromDate = 'date__gte=' + dates.fromDate;
	    toDate = 'date__lte=' + dates.toDate;
	  } else {
	    fromDate = 'date__gte=' + dates.fromDate;
	    toDate = 'date__lte=' + dates.toDate;
	  }
	  if (productNum) {
	    productNum = '&Product_id__ProductNum=' + productNum;
	    group = '';
	    category = '';
	    aggregate = '';
	    user = '';
	    customer = '';
	  } else {
	    productNum = '';
	    if (group) {
	      group = '&Product_id__ProductGroup_id=' + group;
	    } else {
	      group = '';
	    }
	    if (category) {
	      category = '&Product_id__ProductCategory1_id=' + category;
	    } else {
	      category = '';
	    }
	    if (aggregate) {
	      aggregate = '&Aggregate=' + aggregate;
	    } else {
	      aggregate = '';
	    }
	    if (user) {
	      user = '&Sales_User_id=' + user;
	    } else {
	      user = '';
	    }
	    if (customer) {
	      customer = '&SalesInvoice_id__Deliver_Customer_id=' + customer;
	    } else {
	      customer = '';
	    }
	  }
	  var belongWarehouse = '';
	  if (!localStorage.getItem('warehouseLocation') || localStorage.getItem('warehouseLocation') === '') {
	    belongWarehouse = '';
	  } else {
	    belongWarehouse = '&BelongWarehouse=' + localStorage.getItem('warehouseLocation');
	  }
	  if ((isAFM || isATL) && orderType) {
	    // orderType = `&order_type=${orderType}`;
	    orderType = '';
	  } else {
	    orderType = '';
	  }
	  return function (dispatch) {
	    dispatch({
	      type: _type.REQUEST_SALES_PERFORMANCE_BY_FILTER,
	      payload: {
	        type: type,
	        salesType: salesType,
	        fromDate: fromDate,
	        toDate: toDate,
	        productNum: productNum,
	        group: group,
	        category: category,
	        aggregate: aggregate,
	        user: user,
	        belongWarehouse: belongWarehouse,
	        customer: customer,
	        orderType: orderType
	      }
	    });
	  };
	}
	
	var SalesPerformanceListEpic = exports.SalesPerformanceListEpic = function SalesPerformanceListEpic(action$) {
	  return action$.ofType(_type.REQUEST_SALES_PERFORMANCE_BY_FILTER).switchMap(function (action) {
	    return _axios2.default.get(_url.SALES_PERFORMANCE_URL + action.payload.type + '/' + action.payload.salesType + '/?' + action.payload.fromDate + '&' + action.payload.toDate + action.payload.productNum + action.payload.group + action.payload.category + action.payload.aggregate + action.payload.user + action.payload.belongWarehouse + action.payload.orderType + action.payload.customer, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    });
	  }).map(function (response) {
	    return { type: _type.REQUEST_SALES_PERFORMANCE_SUCCESS, payload: response };
	  }).catch(function (err) {
	    return { type: _type.REQUEST_SALES_PERFORMANCE_FAILURE, payload: err };
	  });
	};
	
	function fetchUserPerformanceByFilter(fromDate, toDate, userId, mode, days, lastMonth) {
	  var dates = void 0;
	  if ((days !== -1 || days !== '-1') && !lastMonth) {
	    dates = (0, _cleanDates.grabMonthsToAndFromDates)(days, fromDate, toDate, false);
	  } else if ((days !== -1 || days !== '-1') && lastMonth) {
	    dates = (0, _cleanDates.grabMonthsToAndFromDates)(days, fromDate, toDate, lastMonth);
	  } else {
	    dates = (0, _cleanDates.toFromDates)(days, fromDate, toDate);
	  }
	  return function (dispatch) {
	    dispatch(requestUserPerformanceByFilter());
	    return _axios2.default.get('' + _url.USER_PERFORMANCE_URL, {
	      params: {
	        startDate: dates.fromDate,
	        endDate: dates.toDate,
	        userId: userId,
	        mode: mode
	      },
	      headers: {
	        Authorization: 'Bearer ' + localStorage.getItem('token')
	      }
	    }).then(function (response) {
	      dispatch(requestUserPerformanceSuccess(response.data));
	    }, function (err) {
	      dispatch(requestUserPerformanceFailure(err));
	    });
	  };
	}
	
	function requestUserPerformanceByFilter() {
	  return {
	    type: _type.REQUEST_USER_PERFORMANCE_BY_FILTER
	  };
	}
	
	function requestUserPerformanceSuccess(response) {
	  return {
	    type: _type.REQUEST_USER_PERFORMANCE_SUCCESS,
	    payload: response
	  };
	}
	
	function requestUserPerformanceFailure(error) {
	  return {
	    type: _type.REQUEST_USER_PERFORMANCE_FAILURE,
	    payload: error
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchSalesPerformanceByFilter, 'fetchSalesPerformanceByFilter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesPerformanceList_actions.js');
	
	  __REACT_HOT_LOADER__.register(SalesPerformanceListEpic, 'SalesPerformanceListEpic', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesPerformanceList_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchUserPerformanceByFilter, 'fetchUserPerformanceByFilter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesPerformanceList_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestUserPerformanceByFilter, 'requestUserPerformanceByFilter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesPerformanceList_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestUserPerformanceSuccess, 'requestUserPerformanceSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesPerformanceList_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestUserPerformanceFailure, 'requestUserPerformanceFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesPerformanceList_actions.js');
	
	  __REACT_HOT_LOADER__.register(isAFM, 'isAFM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesPerformanceList_actions.js');
	
	  __REACT_HOT_LOADER__.register(isATL, 'isATL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesPerformanceList_actions.js');
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesPerformanceList_actions.js');
	}();

	;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchScrapRecords = fetchScrapRecords;
	exports.fetchScrapRecordsSuccess = fetchScrapRecordsSuccess;
	exports.fetchScrapRecordsFailure = fetchScrapRecordsFailure;
	exports.selectScrapRecord = selectScrapRecord;
	exports.resetCurrentScrapRecord = resetCurrentScrapRecord;
	exports.fetchScrapRecordDetail = fetchScrapRecordDetail;
	exports.fetchScrapRecordDetailSuccess = fetchScrapRecordDetailSuccess;
	exports.fetchScrapRecordDetailFailure = fetchScrapRecordDetailFailure;
	exports.fetchInventoryScrap = fetchInventoryScrap;
	exports.fetchInventoryScrapSuccess = fetchInventoryScrapSuccess;
	exports.fetchInventoryScrapFailure = fetchInventoryScrapFailure;
	exports.createScrapRecord = createScrapRecord;
	exports.createScrapRecordSuccess = createScrapRecordSuccess;
	exports.createScrapRecordFailure = createScrapRecordFailure;
	exports.editScrapRecord = editScrapRecord;
	exports.editScrapRecordSuccess = editScrapRecordSuccess;
	exports.editScrapRecordFailure = editScrapRecordFailure;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchScrapRecords() {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_SCRAP_RECORDS });
	        return _axios2.default.get(_url.SCRAP_RECORDS_URL, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchScrapRecordsSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchScrapRecordsFailure(err));
	        });
	    };
	}
	
	// ScrapRecords Actions
	function fetchScrapRecordsSuccess(scrapRecords) {
	    return {
	        type: _type.FETCH_SCRAP_RECORDS_SUCCESS,
	        payload: scrapRecords
	    };
	}
	
	function fetchScrapRecordsFailure(error) {
	    return {
	        type: _type.FETCH_SCRAP_RECORDS_FAILURE,
	        payload: error
	    };
	}
	
	function selectScrapRecord(scrapRecord) {
	    return {
	        type: _type.SELECT_SCRAP_RECORD,
	        payload: scrapRecord
	    };
	}
	
	function resetCurrentScrapRecord() {
	    return {
	        type: _type.RESET_CURRENT_SCRAP_RECORD
	    };
	}
	
	function fetchScrapRecordDetail(scrapRecord_id) {
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_SCRAP_RECORD_DETAIL });
	        return _axios2.default.get(_url.SCRAP_RECORDS_URL + scrapRecord_id, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchScrapRecordDetailSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchScrapRecordDetailFailure(err));
	        });
	    };
	}
	
	function fetchScrapRecordDetailSuccess(scrapRecordDetail) {
	    return {
	        type: _type.FETCH_SCRAP_RECORD_DETAIL_SUCCESS,
	        payload: scrapRecordDetail
	    };
	}
	
	function fetchScrapRecordDetailFailure(error) {
	    return {
	        type: _type.FETCH_SCRAP_RECORD_DETAIL_FAILURE,
	        payload: error
	    };
	}
	
	function fetchInventoryScrap(productNum) {
	    return function (dispatch) {
	        dispatch({ type: _type.FETCH_INVENTORY_SCRAP });
	        return _axios2.default.get(_url.INVENTORY_SCRAP_URL + productNum, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchInventoryScrapSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchInventoryScrapFailure(err));
	        });
	    };
	}
	
	function fetchInventoryScrapSuccess(inventories) {
	    return {
	        type: _type.FETCH_INVENTORY_SCRAP_SUCCESS,
	        payload: inventories
	    };
	}
	
	function fetchInventoryScrapFailure(error) {
	    return {
	        type: _type.FETCH_INVENTORY_SCRAP_FAILURE,
	        payload: error
	    };
	}
	
	function createScrapRecord(formProps, Warehouse_id, Warehouse_Scrap_Line) {
	    var PostingDate = formProps.PostingDate;
	    if (PostingDate) PostingDate = new Date(PostingDate);else PostingDate = new Date();
	    Warehouse_Scrap_Line.map(function (line) {
	        line['WarehouseBin_id'] = line.WarehouseBin_id;
	        line['WarehouseZone_id'] = line.WarehouseZone_id;
	    });
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_CREATING_SCRAP_RECORD });
	        _axios2.default.post(_url.SCRAP_RECORDS_URL, {
	            PostingDate: PostingDate,
	            Warehouse_id: Warehouse_id,
	            Warehouse_Scrap_Line: Warehouse_Scrap_Line
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(createScrapRecordSuccess());
	            _reactRouter.browserHistory.push('/scrapRecords');
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(createScrapRecordFailure(err));
	        });
	    };
	}
	
	function createScrapRecordSuccess() {
	    return {
	        type: _type.CREATE_SCRAP_RECORD_SUCCESS
	    };
	}
	
	function createScrapRecordFailure(error) {
	    return {
	        type: _type.CREATE_SCRAP_RECORD_FAILURE,
	        payload: error
	    };
	}
	
	function editScrapRecord(WarehouseScrap_id, formProps, Warehouse_id, Warehouse_Scrap_Line) {
	    var PostingDate = formProps.PostingDate;
	    if (PostingDate) PostingDate = new Date(PostingDate);
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_EDITING_SCRAP_RECORD });
	        _axios2.default.put(_url.SCRAP_RECORDS_URL + WarehouseScrap_id, {
	            PostingDate: PostingDate,
	            Warehouse_id: Warehouse_id,
	            Warehouse_Scrap_Line: Warehouse_Scrap_Line
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(editScrapRecordSuccess());
	            _reactRouter.browserHistory.push('/scrapRecords');
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(editScrapRecordFailure(err));
	        });
	    };
	}
	
	function editScrapRecordSuccess() {
	    return {
	        type: _type.EDIT_SCRAP_RECORD_SUCCESS
	    };
	}
	
	function editScrapRecordFailure(error) {
	    return {
	        type: _type.EDIT_SCRAP_RECORD_FAILURE,
	        payload: error
	    };
	}
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(fetchScrapRecords, 'fetchScrapRecords', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/scrapRecords_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchScrapRecordsSuccess, 'fetchScrapRecordsSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/scrapRecords_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchScrapRecordsFailure, 'fetchScrapRecordsFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/scrapRecords_actions.js');
	
	    __REACT_HOT_LOADER__.register(selectScrapRecord, 'selectScrapRecord', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/scrapRecords_actions.js');
	
	    __REACT_HOT_LOADER__.register(resetCurrentScrapRecord, 'resetCurrentScrapRecord', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/scrapRecords_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchScrapRecordDetail, 'fetchScrapRecordDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/scrapRecords_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchScrapRecordDetailSuccess, 'fetchScrapRecordDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/scrapRecords_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchScrapRecordDetailFailure, 'fetchScrapRecordDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/scrapRecords_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchInventoryScrap, 'fetchInventoryScrap', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/scrapRecords_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchInventoryScrapSuccess, 'fetchInventoryScrapSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/scrapRecords_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchInventoryScrapFailure, 'fetchInventoryScrapFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/scrapRecords_actions.js');
	
	    __REACT_HOT_LOADER__.register(createScrapRecord, 'createScrapRecord', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/scrapRecords_actions.js');
	
	    __REACT_HOT_LOADER__.register(createScrapRecordSuccess, 'createScrapRecordSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/scrapRecords_actions.js');
	
	    __REACT_HOT_LOADER__.register(createScrapRecordFailure, 'createScrapRecordFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/scrapRecords_actions.js');
	
	    __REACT_HOT_LOADER__.register(editScrapRecord, 'editScrapRecord', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/scrapRecords_actions.js');
	
	    __REACT_HOT_LOADER__.register(editScrapRecordSuccess, 'editScrapRecordSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/scrapRecords_actions.js');
	
	    __REACT_HOT_LOADER__.register(editScrapRecordFailure, 'editScrapRecordFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/scrapRecords_actions.js');
	}();

	;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.requestShipFromOrders = requestShipFromOrders;
	exports.fetchShipFromOrdersSuccess = fetchShipFromOrdersSuccess;
	exports.fetchShipFromOrdersFailure = fetchShipFromOrdersFailure;
	exports.fetchShipFromOrders = fetchShipFromOrders;
	exports.selectSalesOrder = selectSalesOrder;
	exports.resetCurrentSalesOrder = resetCurrentSalesOrder;
	exports.fetchSalesOrderDetail = fetchSalesOrderDetail;
	exports.requestSalesOrderDetail = requestSalesOrderDetail;
	exports.fetchSalesOrderDetailSuccess = fetchSalesOrderDetailSuccess;
	exports.fetchSalesOrderDetailFailure = fetchSalesOrderDetailFailure;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _root_url = __webpack_require__(9);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function requestShipFromOrders() {
	  return {
	    type: _type.REQUEST_SHIP_FROM_ORDERS
	  };
	}
	
	function fetchShipFromOrdersSuccess(shipToOrders) {
	  return {
	    type: _type.FETCH_SHIP_FROM_ORDERS_SUCCESS,
	    payload: shipToOrders
	  };
	}
	
	function fetchShipFromOrdersFailure(error) {
	  return {
	    type: _type.FETCH_SHIP_FROM_ORDERS_FAILURE,
	    payload: error
	  };
	}
	
	function fetchShipFromOrders() {
	  return function (dispatch) {
	    dispatch(requestShipFromOrders());
	    return _axios2.default.get(_url.SALE_SHIP_ORDER_SEARCH_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchShipFromOrdersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchShipFromOrdersFailure(err));
	    });
	  };
	}
	
	function selectSalesOrder(salesOrder) {
	  return {
	    type: _type.SELECT_SALES_ORDER,
	    payload: salesOrder
	  };
	}
	
	function resetCurrentSalesOrder() {
	  return {
	    type: _type.RESET_CURRENT_SALES_ORDER
	  };
	}
	
	// Fetch the detail page.
	function fetchSalesOrderDetail(salesOrder_id, route) {
	  var url = route == 'salesOrders' ? _url.SALES_ORDERS_URL : _url.MOBILE_SALES_ORDERS_URL;
	  return function (dispatch) {
	    dispatch(requestSalesOrderDetail());
	    return _axios2.default.get(url + '?pk=' + salesOrder_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesOrderDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesOrderDetailFailure(err));
	    });
	  };
	}
	
	function requestSalesOrderDetail() {
	  return {
	    type: _type.REQUEST_SALES_ORDER_DETAIL
	  };
	}
	
	function fetchSalesOrderDetailSuccess(salesOrderDetail) {
	  salesOrderDetail = salesOrderDetail.data;
	  // The date data fetched is in the form of string, which needs to be modified into Date type
	  if (salesOrderDetail.OrderDate) salesOrderDetail.OrderDate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.OrderDate);
	  if (salesOrderDetail.ETADate) salesOrderDetail.ETADate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.ETADate);
	  if (salesOrderDetail.ReceivedDate) salesOrderDetail.ReceivedDate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.ReceivedDate);
	  if (salesOrderDetail.DispatchDate) salesOrderDetail.DispatchDate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.DispatchDate);
	  return {
	    type: _type.FETCH_SALES_ORDER_DETAIL_SUCCESS,
	    payload: salesOrderDetail
	  };
	}
	
	function fetchSalesOrderDetailFailure(error) {
	  return {
	    type: _type.FETCH_SALES_ORDER_DETAIL_FAILURE,
	    payload: error
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestShipFromOrders, 'requestShipFromOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/shipFromOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchShipFromOrdersSuccess, 'fetchShipFromOrdersSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/shipFromOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchShipFromOrdersFailure, 'fetchShipFromOrdersFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/shipFromOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchShipFromOrders, 'fetchShipFromOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/shipFromOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(selectSalesOrder, 'selectSalesOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/shipFromOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetCurrentSalesOrder, 'resetCurrentSalesOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/shipFromOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderDetail, 'fetchSalesOrderDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/shipFromOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestSalesOrderDetail, 'requestSalesOrderDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/shipFromOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderDetailSuccess, 'fetchSalesOrderDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/shipFromOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderDetailFailure, 'fetchSalesOrderDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/shipFromOrders_actions.js');
	}();

	;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchUsers = fetchUsers;
	exports.requestUsers = requestUsers;
	exports.fetchUsersSuccess = fetchUsersSuccess;
	exports.fetchUsersFailure = fetchUsersFailure;
	exports.createUsers = createUsers;
	exports.selectUser = selectUser;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _type = __webpack_require__(14);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var USERS_URL = 'http://jsonplaceholder.typicode.com/users/';
	
	function fetchUsers() {
	    return function (dispatch) {
	        dispatch(requestUsers());
	        return _axios2.default.get(USERS_URL).then(function (response) {
	            dispatch(fetchUsersSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchUsersFailure(err));
	        });
	    };
	}
	
	function requestUsers() {
	    return {
	        type: _type.REQUEST_USERS
	    };
	}
	
	function fetchUsersSuccess(users) {
	    return {
	        type: _type.FETCH_USERS_SUCCESS,
	        payload: users
	    };
	}
	
	function fetchUsersFailure(error) {
	    return {
	        type: _type.FETCH_USERS_FAILURE,
	        payload: error
	    };
	}
	
	function createUsers(props) {
	    var request = _axios2.default.post(USERS_URL, props);
	    return {
	        type: _type.CREATE_USER,
	        payload: request
	    };
	}
	
	function selectUser(user) {
	    return {
	        type: _type.SELECT_USER,
	        payload: user
	    };
	}
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(fetchUsers, 'fetchUsers', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/users_actions.js');
	
	    __REACT_HOT_LOADER__.register(requestUsers, 'requestUsers', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/users_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchUsersSuccess, 'fetchUsersSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/users_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchUsersFailure, 'fetchUsersFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/users_actions.js');
	
	    __REACT_HOT_LOADER__.register(createUsers, 'createUsers', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/users_actions.js');
	
	    __REACT_HOT_LOADER__.register(selectUser, 'selectUser', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/users_actions.js');
	
	    __REACT_HOT_LOADER__.register(USERS_URL, 'USERS_URL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/users_actions.js');
	}();

	;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchInventoryBatches = fetchInventoryBatches;
	exports.fetchInventoryBatchesSuccess = fetchInventoryBatchesSuccess;
	exports.fetchInventoryBatchesFailure = fetchInventoryBatchesFailure;
	exports.postProductInventoryBatches = postProductInventoryBatches;
	exports.fetchProductInventoryBatches = fetchProductInventoryBatches;
	exports.fetchProductInventoryBatchesSuccess = fetchProductInventoryBatchesSuccess;
	exports.fetchProductInventoryBatchesFailure = fetchProductInventoryBatchesFailure;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Inventories Actions v1
	function fetchInventoryBatches(ProductNum) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_INVENTORY_BATCHES });
	    return _axios2.default.get(_url.WHOLESALE_BATCH_URL + ProductNum, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchInventoryBatchesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchInventoryBatchesFailure(err));
	    });
	  };
	}
	
	function fetchInventoryBatchesSuccess(batches) {
	  return {
	    type: _type.FETCH_INVENTORY_BATCHES_SUCCESS,
	    payload: batches
	  };
	}
	
	function fetchInventoryBatchesFailure(error) {
	  return {
	    type: _type.FETCH_INVENTORY_BATCHES_FAILURE,
	    payload: error
	  };
	}
	
	// Inventories Actions v2
	function postProductInventoryBatches(id, qty) {
	  return function (dispatch, getState) {
	    var batches = getState().wholesaleModal.productInventory.batches;
	    var computedData = {
	      inventory_adjustment_lines: batches.map(function (elem) {
	        return _extends({}, elem, {
	          quantity: qty
	        });
	      }),
	      product: id
	    };
	
	    return (0, _axios2.default)({
	      method: 'post',
	      url: _url.ADJUSTMENT_INVENTORY_BATCH_URL,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      data: computedData
	    }).then(function (response) {
	      alert('Modify inventory success.');
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      alert('Error modify inventory. Please check your fields or retry.');
	    });
	  };
	}
	
	function fetchProductInventoryBatches(ProductNum) {
	  return function (dispatch) {
	    dispatch({ type: _type.REQUEST_PRODUCT_INVENTORY_BATCHES });
	    return (0, _axios2.default)({
	      method: 'get',
	      url: _url.INVENTORY_BATCH_URL,
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	      params: {
	        belong_warehouse: false,
	        product: ProductNum
	      }
	    }).then(function (response) {
	      dispatch(fetchProductInventoryBatchesSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchProductInventoryBatchesFailure(err));
	    });
	  };
	}
	
	function fetchProductInventoryBatchesSuccess(batches) {
	  return {
	    type: _type.FETCH_PRODUCT_INVENTORY_BATCHES_SUCCESS,
	    payload: batches
	  };
	}
	
	function fetchProductInventoryBatchesFailure(error) {
	  return {
	    type: _type.FETCH_PRODUCT_INVENTORY_BATCHES_FAILURE,
	    payload: error
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchInventoryBatches, 'fetchInventoryBatches', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesaleModal_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInventoryBatchesSuccess, 'fetchInventoryBatchesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesaleModal_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchInventoryBatchesFailure, 'fetchInventoryBatchesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesaleModal_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(postProductInventoryBatches, 'postProductInventoryBatches', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesaleModal_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchProductInventoryBatches, 'fetchProductInventoryBatches', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesaleModal_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchProductInventoryBatchesSuccess, 'fetchProductInventoryBatchesSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesaleModal_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchProductInventoryBatchesFailure, 'fetchProductInventoryBatchesFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesaleModal_actions.jsx');
	}();

	;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchWholesale = fetchWholesale;
	exports.requestWholesale = requestWholesale;
	exports.fetchWholesaleSuccess = fetchWholesaleSuccess;
	exports.fetchWholesaleFailure = fetchWholesaleFailure;
	exports.selectWholesale = selectWholesale;
	exports.resetCurrentWholesale = resetCurrentWholesale;
	exports.fetchWholesaleOrderDetail = fetchWholesaleOrderDetail;
	exports.requestWholesaleDetail = requestWholesaleDetail;
	exports.fetchWholesaleDetailSuccess = fetchWholesaleDetailSuccess;
	exports.fetchWholesaleDetailFailure = fetchWholesaleDetailFailure;
	exports.createWholesale = createWholesale;
	exports.createWholesaleSuccess = createWholesaleSuccess;
	exports.createWholesaleFailure = createWholesaleFailure;
	exports.editWholesale = editWholesale;
	exports.editWholesaleSuccess = editWholesaleSuccess;
	exports.editWholesaleFailure = editWholesaleFailure;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchWholesale() {
	    return function (dispatch) {
	        dispatch(requestWholesale());
	        return _axios2.default.get(_url.WHOLESALE_URL, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchWholesaleSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchWholesaleFailure(err));
	        });
	    };
	}
	
	function requestWholesale() {
	    return {
	        type: _type.REQUEST_WHOLESALE
	    };
	}
	
	function fetchWholesaleSuccess(wholesale) {
	    return {
	        type: _type.FETCH_WHOLESALE_SUCCESS,
	        payload: wholesale
	    };
	}
	
	function fetchWholesaleFailure(error) {
	    return {
	        type: _type.FETCH_WHOLESALE_FAILURE,
	        payload: error
	    };
	}
	
	function selectWholesale(wholesale) {
	    return {
	        type: _type.SELECT_WHOLESALE,
	        payload: wholesale
	    };
	}
	
	function resetCurrentWholesale() {
	    return {
	        type: _type.RESET_CURRENT_WHOLESALE
	    };
	}
	
	// Fetch the detail page.
	
	function fetchWholesaleOrderDetail(wholesale_id) {
	    return function (dispatch) {
	        dispatch(requestWholesaleDetail());
	        return _axios2.default.get(_url.SALES_ORDERS_URL + wholesale_id, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(fetchWholesaleDetailSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(fetchWholesaleDetailFailure(err));
	        });
	    };
	}
	
	function requestWholesaleDetail() {
	    return {
	        type: _type.REQUEST_WHOLESALE_DETAIL
	    };
	}
	
	function fetchWholesaleDetailSuccess(wholesaleDetail) {
	    wholesaleDetail = wholesaleDetail.data;
	    // The date data fetched is in the form of string, which needs to be modified into Date type
	    if (wholesaleDetail.OrderDate) wholesaleDetail.OrderDate = new Date(wholesaleDetail.OrderDate);
	    if (wholesaleDetail.ETADate) wholesaleDetail.ETADate = new Date(wholesaleDetail.ETADate);
	    if (wholesaleDetail.ReceivedDate) wholesaleDetail.ReceivedDate = new Date(wholesaleDetail.ReceivedDate);
	    return {
	        type: _type.FETCH_WHOLESALE_DETAIL_SUCCESS,
	        payload: wholesaleDetail
	    };
	}
	
	function fetchWholesaleDetailFailure(error) {
	    return {
	        type: _type.FETCH_WHOLESALE_DETAIL_FAILURE,
	        payload: error
	    };
	}
	
	function createWholesale(_ref) {
	    var Sales_Order_Line = _ref.Sales_Order_Line,
	        OrderDate = _ref.OrderDate,
	        ETADate = _ref.ETADate,
	        ReceivedDate = _ref.ReceivedDate,
	        FinalNetWeight = _ref.FinalNetWeight,
	        FinalShippingWeight = _ref.FinalShippingWeight,
	        TotalPrice = _ref.TotalPrice,
	        NoteToVendor = _ref.NoteToVendor,
	        ReleaseInformation = _ref.ReleaseInformation,
	        CarryType = _ref.CarryType,
	        Discount = _ref.Discount,
	        ShippingCost = _ref.ShippingCost,
	        HandlingCost = _ref.HandlingCost,
	        SalesStatus = _ref.SalesStatus,
	        MiscCost = _ref.MiscCost,
	        MiscNote = _ref.MiscNote,
	        TaxRate = _ref.TaxRate,
	        PaymentStatus = _ref.PaymentStatus,
	        FinalPrice = _ref.FinalPrice,
	        ConvertItemPrice = _ref.ConvertItemPrice,
	        Vendor_id = _ref.Vendor_id,
	        Pickup_VendorAddress_id = _ref.Pickup_VendorAddress_id,
	        Pickup_VendorContact_id = _ref.Pickup_VendorContact_id,
	        Deliver_Warehouse_id = _ref.Deliver_Warehouse_id,
	        DispatchMethod_id = _ref.DispatchMethod_id,
	        DispatchOutSourceContact_id = _ref.DispatchOutSourceContact_id,
	        Sales_User_id = _ref.Sales_User_id,
	        Modifier_User_id = _ref.Modifier_User_id;
	
	    Sales_Order_Line.map(function (product) {
	        if (product.Product_id) product.Product_id = product.Product_id.value || product.Product_id;
	    });
	    if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
	    if (Pickup_VendorAddress_id) Pickup_VendorAddress_id = Pickup_VendorAddress_id.value || Pickup_VendorAddress_id;
	    if (Pickup_VendorContact_id) Pickup_VendorContact_id = Pickup_VendorContact_id.value || Pickup_VendorContact_id;
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_CREATING_WHOLESALE });
	        _axios2.default.post(WHOLESALES_URL, {
	            Sales_Order_Line: Sales_Order_Line,
	            OrderDate: OrderDate,
	            ETADate: ETADate,
	            ReceivedDate: ReceivedDate,
	            FinalNetWeight: FinalNetWeight,
	            FinalShippingWeight: FinalShippingWeight,
	            TotalPrice: TotalPrice,
	            NoteToVendor: NoteToVendor,
	            ReleaseInformation: ReleaseInformation,
	            CarryType: CarryType,
	            Discount: Discount,
	            ShippingCost: ShippingCost,
	            HandlingCost: HandlingCost,
	            MiscCost: MiscCost,
	            MiscNote: MiscNote,
	            TaxRate: TaxRate,
	            SalesStatus: SalesStatus,
	            PaymentStatus: PaymentStatus,
	            FinalPrice: FinalPrice,
	            ConvertItemPrice: ConvertItemPrice,
	            Vendor_id: Vendor_id,
	            Pickup_VendorAddress_id: Pickup_VendorAddress_id,
	            Pickup_VendorContact_id: Pickup_VendorContact_id,
	            Deliver_Warehouse_id: Deliver_Warehouse_id,
	            DispatchMethod_id: DispatchMethod_id,
	            DispatchOutSourceContact_id: DispatchOutSourceContact_id,
	            Sales_User_id: Sales_User_id,
	            Modifier_User_id: Modifier_User_id
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(createWholesaleSuccess());
	            _reactRouter.browserHistory.push('/wholesale');
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(createWholesaleFailure(err));
	        });
	    };
	}
	
	function createWholesaleSuccess() {
	    return {
	        type: _type.CREATE_WHOLESALE_SUCCESS
	    };
	}
	
	function createWholesaleFailure(error) {
	    return {
	        type: _type.CREATE_WHOLESALE_FAILURE,
	        payload: error
	    };
	}
	
	function editWholesale(_ref2) {
	    var Wholesale_id = _ref2.Wholesale_id,
	        Sales_Order_Line = _ref2.Sales_Order_Line,
	        ETADate = _ref2.ETADate;
	
	    Sales_Order_Line.map(function (product) {
	        if (product.Product_id) product.Product_id = product.Product_id.value || product.Product_id;
	    });
	    return function (dispatch) {
	        dispatch({ type: _type.REQUEST_EDITING_WHOLESALE });
	        _axios2.default.put(WHOLESALES_URL + Wholesale_id, {
	            Sales_Order_Line: Sales_Order_Line,
	            ETADate: ETADate
	        }, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            dispatch(editWholesaleSuccess());
	            _reactRouter.browserHistory.push('/salesOrder'); // If editd succesfully, refresh the paymentTerm page.
	        }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	                err.data = _constants.DEFAULT_ERROR;
	            }
	            dispatch(editWholesaleFailure(err));
	        });
	    };
	}
	
	function editWholesaleSuccess() {
	    return {
	        type: _type.EDIT_WHOLESALE_SUCCESS
	    };
	}
	
	function editWholesaleFailure(error) {
	    return {
	        type: _type.EDIT_WHOLESALE_FAILURE,
	        payload: error
	    };
	}
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(fetchWholesale, 'fetchWholesale', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesale_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(requestWholesale, 'requestWholesale', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesale_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchWholesaleSuccess, 'fetchWholesaleSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesale_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchWholesaleFailure, 'fetchWholesaleFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesale_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(selectWholesale, 'selectWholesale', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesale_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(resetCurrentWholesale, 'resetCurrentWholesale', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesale_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchWholesaleOrderDetail, 'fetchWholesaleOrderDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesale_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(requestWholesaleDetail, 'requestWholesaleDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesale_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchWholesaleDetailSuccess, 'fetchWholesaleDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesale_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(fetchWholesaleDetailFailure, 'fetchWholesaleDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesale_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(createWholesale, 'createWholesale', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesale_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(createWholesaleSuccess, 'createWholesaleSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesale_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(createWholesaleFailure, 'createWholesaleFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesale_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(editWholesale, 'editWholesale', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesale_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(editWholesaleSuccess, 'editWholesaleSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesale_actions.jsx');
	
	    __REACT_HOT_LOADER__.register(editWholesaleFailure, 'editWholesaleFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/wholesale_actions.jsx');
	}();

	;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _moment3 = __webpack_require__(41);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _moment4.default)(_moment2.default);
	
	var DateFormatter = function (_Component) {
	  _inherits(DateFormatter, _Component);
	
	  function DateFormatter() {
	    _classCallCheck(this, DateFormatter);
	
	    return _possibleConstructorReturn(this, (DateFormatter.__proto__ || Object.getPrototypeOf(DateFormatter)).apply(this, arguments));
	  }
	
	  _createClass(DateFormatter, [{
	    key: 'render',
	    value: function render() {
	      var value = this.props.value;
	
	      var date = value ? (0, _moment2.default)(value).format('MMM DD YYYY') : '-';
	      return _react2.default.createElement(
	        'span',
	        null,
	        date
	      );
	      // return <div className='align-center'>-</div>;
	      // return <div />;
	    }
	  }]);
	
	  return DateFormatter;
	}(_react.Component);
	
	var _default = DateFormatter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(DateFormatter, 'DateFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/CustomerStatement/dateFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/CustomerStatement/dateFormatter.jsx');
	}();

	;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CheckboxFormatter = function CheckboxFormatter(props) {
	  return _react2.default.createElement('input', {
	    id: 'cell-checkbox',
	    type: 'checkbox',
	    value: props.value,
	    checked: props.checked,
	    onClick: function onClick() {
	      props.handleOnClick(props);
	    },
	    disabled: props.disabled
	  });
	};
	
	CheckboxFormatter.defaultProps = {
	  value: false
	};
	
	CheckboxFormatter.propTypes = {
	  value: _propTypes2.default.bool,
	  handleOnClick: _propTypes2.default.func.isRequired
	};
	
	var _default = CheckboxFormatter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CheckboxFormatter, 'CheckboxFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/CheckboxFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/CheckboxFormatter.jsx');
	}();

	;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	  Why does this component exist?
	
	  This component exists because the Toolbar component within the React-Data-Grid-Addons library
	  has substandard functionality and does not possess a way to keep filters open on page load!
	
	  This component takes the place of the <Toolbar/> component in React-Data-Grid.
	
	  The enableFilter prop passed down from the Customers/Vendors page is what renders the
	  Filter Rows button. The onToggleFilter within the CDM sets the filter to be open
	  on render.
	*/
	
	var FilterToolbar = function (_React$Component) {
	  _inherits(FilterToolbar, _React$Component);
	
	  function FilterToolbar() {
	    _classCallCheck(this, FilterToolbar);
	
	    return _possibleConstructorReturn(this, (FilterToolbar.__proto__ || Object.getPrototypeOf(FilterToolbar)).apply(this, arguments));
	  }
	
	  _createClass(FilterToolbar, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.onToggleFilter();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_reactDataGridAddons.Toolbar, this.props);
	    }
	  }]);
	
	  return FilterToolbar;
	}(_react2.default.Component);
	
	var _default = FilterToolbar;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(FilterToolbar, "FilterToolbar", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/FilterToolbar.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/FilterToolbar.jsx");
	}();

	;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactAutosuggest = __webpack_require__(85);
	
	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
	
	var _reactIsolatedScroll = __webpack_require__(87);
	
	var _reactIsolatedScroll2 = _interopRequireDefault(_reactIsolatedScroll);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _autoSuggest_actions = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* ----------- */
	/*    Utils    */
	/* ----------- */
	
	// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_Special_Characters
	function escapeRegexCharacters(str) {
	  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	}
	
	/* --------------- */
	/*    Component    */
	/* --------------- */
	
	var PurchaseOrderAutoSuggest = function (_Component) {
	  _inherits(PurchaseOrderAutoSuggest, _Component);
	
	  function PurchaseOrderAutoSuggest() {
	    _classCallCheck(this, PurchaseOrderAutoSuggest);
	
	    var _this = _possibleConstructorReturn(this, (PurchaseOrderAutoSuggest.__proto__ || Object.getPrototypeOf(PurchaseOrderAutoSuggest)).call(this));
	
	    _this.onChange = function (event, _ref) {
	      var newValue = _ref.newValue;
	
	      _this.setState({ value: newValue });
	    };
	
	    _this.onSuggestionsFetchRequested = function (_ref2) {
	      var value = _ref2.value;
	
	      _this.loadSuggestions(value);
	    };
	
	    _this.onSuggestionsClearRequested = function () {
	      _this.setState({ suggestions: [] });
	    };
	
	    _this.onKeyPress = function () {
	      return false;
	    };
	
	    _this.onSuggestionSelected = function (event, _ref3) {
	      var suggestion = _ref3.suggestion;
	
	      // function to get product here
	      event.stopPropagation();
	      event.preventDefault();
	      _this.props.fetchPurchaseOrderProductByID(suggestion.Product_id);
	      _this.props.handleFocusQty();
	    };
	
	    _this.getSuggestionValue = function (suggestion) {
	      switch (_this.props.SearchType) {
	        case 'ProductNum':
	          return suggestion.ProductNum + ' | ' + suggestion.Name;
	        case 'RefNum':
	          return suggestion.RefNum + ' | ' + suggestion.Name;
	        case 'Name':
	          return suggestion.Name;
	        case 'Description':
	          return suggestion.Description + ' | ' + suggestion.Name;
	
	        default:
	          return null;
	      }
	    };
	
	    _this.renderSuggestion = function (suggestion) {
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        _defineProperty({ className: 'suggestion', id: 'suggestion-render' }, 'className', 'sales-auto-suggest-suggestions'),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _this.renderSearchTypeValue(suggestion)
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 4 },
	          suggestion.Name
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 1 },
	          suggestion.Description
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 1, id: 'price-col' },
	          suggestion.ProductCost
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 1, style: { overflow: 'hidden' } },
	          suggestion.MeasureUnit
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 1 },
	          suggestion.InStock
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 1 },
	          suggestion.Purchased
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 1 },
	          suggestion.PreSale
	        )
	      );
	    };
	
	    _this.renderSearchTypeHeader = function () {
	      switch (_this.props.SearchType) {
	        case 'ProductNum':
	          return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' });
	        default:
	          return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' });
	      }
	    };
	
	    _this.renderSuggestionsContainer = function (_ref4) {
	      var containerProps = _ref4.containerProps,
	          children = _ref4.children;
	
	      var ref = containerProps.ref,
	          restContainerProps = _objectWithoutProperties(containerProps, ['ref']);
	
	      var callRef = function callRef(scrollingDiv) {
	        if (scrollingDiv !== null) {
	          ref(scrollingDiv.component);
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        restContainerProps,
	        _react2.default.createElement(
	          'div',
	          { className: 'container', style: { width: '100%' }, id: 'suggestion-container' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { style: { padding: '10px 5px', margin: '0px' }, className: 'sales-auto-suggest-suggestions', id: 'sales-auto-suggest-header' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 2 },
	              _this.renderSearchTypeHeader()
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 1 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 1, id: 'price-col' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 1, style: { overflow: 'hidden' } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 1 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'instock' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 1 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchased' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 1 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'presale' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactIsolatedScroll2.default,
	          { id: 'suggestions-customer-container', ref: callRef },
	          children
	        )
	      );
	    };
	
	    _this.state = {
	      value: '',
	      suggestions: [],
	      // isLoading: false,
	      noSuggestions: false
	    };
	
	    _this.lastRequestId = null;
	    return _this;
	  }
	
	  _createClass(PurchaseOrderAutoSuggest, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var isInputBlank = nextProps.value === '';
	      var noSuggestions = !isInputBlank && nextProps.purchaseOrderSuggestions.length === 0;
	      this.setState({ noSuggestions: noSuggestions });
	      if (nextProps.purchaseOrderSuggestions !== this.props.purchaseOrderSuggestions) {
	        this.setState({ suggestions: [].concat(_toConsumableArray(nextProps.purchaseOrderSuggestions.slice(0, 200))) });
	      }
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus(event) {
	      event.target.select();
	    }
	  }, {
	    key: 'loadSuggestions',
	    value: function loadSuggestions(value) {
	      // if (value.length < 3) {
	      //   return;
	      // }
	      // Cancel the previous request
	      // if (this.lastRequestId !== null) {
	      //   clearTimeout(this.lastRequestId);
	      // }
	
	      // this.setState({
	      //   isLoading: true,
	      //   suggest: [],
	      // });
	
	      this.props.fetchPurchaseOrderSuggestions(this.props.SearchType, value);
	
	      // Fake request
	      // this.lastRequestId = setTimeout(() => {
	      //   axios.get(`${ROOT_URL}v1/product/simplified/?${this.props.SearchType}=${value}`,
	      //   {
	      //       headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      //   })
	      //   .then(response => {
	      //     const suggestionData = [...response.data];
	      //     this.setState({
	      //       isLoading: false,
	      //       suggestions: suggestionData,
	      //     });
	      //   }, err => {
	      //     console.log('error occured in search', err);
	      //   });
	      // }, 100);
	    }
	  }, {
	    key: 'renderErrorMessage',
	    value: function renderErrorMessage() {
	      var noSuggestions = this.state.noSuggestions;
	
	      if (noSuggestions && !this.props.purchaseOrderSuggestionsIsLoading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'no-suggestions' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no_data_found' })
	        );
	      }
	      return _react2.default.createElement('div', null);
	    }
	  }, {
	    key: 'renderSearchTypeValue',
	    value: function renderSearchTypeValue(suggestion) {
	      switch (this.props.SearchType) {
	        case 'ProductNum':
	          return suggestion.ProductNum;
	        default:
	          return suggestion.RefNum;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var suggestions = this.state.suggestions;
	
	      var inputProps = {
	        value: this.props.value,
	        onChange: this.props.onChange,
	        onKeyPress: this.onKeyPress,
	        onFocus: this.onFocus,
	        id: 'purchase-auto-suggest'
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactAutosuggest2.default, {
	          suggestions: suggestions,
	          onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
	          onSuggestionsClearRequested: this.onSuggestionsClearRequested,
	          focusInputOnSuggestionClick: false,
	          getSuggestionValue: this.getSuggestionValue,
	          renderSuggestion: this.renderSuggestion,
	          renderSuggestionsContainer: this.renderSuggestionsContainer,
	          onSuggestionSelected: this.onSuggestionSelected,
	          highlightFirstSuggestion: true,
	          inputProps: inputProps
	        }),
	        this.renderErrorMessage()
	      );
	    }
	  }]);
	
	  return PurchaseOrderAutoSuggest;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    purchaseOrderSuggestions: state.autoSuggest.purchaseOrderSuggestions,
	    purchaseOrderSuggestionsIsLoading: state.autoSuggest.purchaseOrderSuggestionsIsLoading,
	    purchaseOrderSuggestionsError: state.autoSuggest.purchaseOrderSuggestionsError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchPurchaseOrderProductByID: _purchaseOrders_actions.fetchPurchaseOrderProductByID, fetchPurchaseOrderSuggestions: _autoSuggest_actions.fetchPurchaseOrderSuggestions })(PurchaseOrderAutoSuggest);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(escapeRegexCharacters, 'escapeRegexCharacters', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/PurchaseOrderAutoSuggest.jsx');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/PurchaseOrderAutoSuggest.jsx');
	
	  __REACT_HOT_LOADER__.register(PurchaseOrderAutoSuggest, 'PurchaseOrderAutoSuggest', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/PurchaseOrderAutoSuggest.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/PurchaseOrderAutoSuggest.jsx');
	}();

	;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _startsWith = __webpack_require__(793);
	
	var _startsWith2 = _interopRequireDefault(_startsWith);
	
	var _endsWith = __webpack_require__(788);
	
	var _endsWith2 = _interopRequireDefault(_endsWith);
	
	var _slateReact = __webpack_require__(827);
	
	var _slate = __webpack_require__(819);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _slateHtmlSerializer = __webpack_require__(826);
	
	var _slateHtmlSerializer2 = _interopRequireDefault(_slateHtmlSerializer);
	
	var _imageExtensions = __webpack_require__(807);
	
	var _imageExtensions2 = _interopRequireDefault(_imageExtensions);
	
	var _slateSchemaViolations = __webpack_require__(845);
	
	var _isUrl = __webpack_require__(808);
	
	var _isUrl2 = _interopRequireDefault(_isUrl);
	
	var _reactNotificationSystem = __webpack_require__(103);
	
	var _reactNotificationSystem2 = _interopRequireDefault(_reactNotificationSystem);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	  Example Usage:
	  <RichTextEditor
	    closeRichTextModal={() => { this.closeMobileDescBox(); }}
	    saveHtml={(htmlText) => { this.saveRichText(htmlText); }}
	    htmlString={mobileDescriptionHTML}
	    placeholder="Enter the product description."
	    saveSuccess={this.props.saveMobileDescriptionTextSuccess}
	  />
	*/
	
	var propTypes = {
	  attributes: _propTypes2.default.shape({
	    'data-key': _propTypes2.default.string
	  }),
	  children: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    key: _propTypes2.default.string,
	    type: _propTypes2.default.string,
	    props: _propTypes2.default.object
	  })),
	  node: _propTypes2.default.shape({}),
	  mark: _propTypes2.default.shape({}),
	  isSelected: _propTypes2.default.bool,
	  htmlString: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  isLoadingSave: _propTypes2.default.bool,
	  saveSuccess: _propTypes2.default.bool,
	  closeRichTextModal: _propTypes2.default.func,
	  saveHtml: _propTypes2.default.func
	};
	
	var defaultProps = {
	  attributes: {},
	  children: {},
	  node: {},
	  mark: {},
	  isSelected: false,
	  htmlString: '',
	  placeholder: '',
	  isLoadingSave: false,
	  saveSuccess: null,
	  closeRichTextModal: function closeRichTextModal() {},
	  saveHtml: function saveHtml() {}
	};
	
	/*
	 * A function to determine whether a URL has an image extension.
	 *
	 * @param {String} url
	 * @return {Boolean}
	 */
	
	function isImage(url) {
	  return !!_imageExtensions2.default.find(url.endsWith);
	}
	
	/**
	 * A change function to standardize inserting images.
	 *
	 * @param {Change} change
	 * @param {String} src
	 * @param {Range} target
	 */
	
	function insertImage(change, src, target) {
	  if (target) {
	    change.select(target);
	  }
	
	  change.insertBlock({
	    type: 'image',
	    isVoid: true,
	    data: { src: src }
	  });
	}
	
	function insertLink(change, title, link, node) {
	  if (node) {
	    change.removeNodeByKey(node.key);
	  }
	  change.insertBlock({
	    type: 'link',
	    isVoid: true,
	    data: {
	      href: link,
	      title: title
	    }
	  });
	}
	
	function isIframe(str) {
	  return (0, _startsWith2.default)(str, '<iframe') && (0, _endsWith2.default)(str, '</iframe>');
	}
	
	var blockTags = {
	  p: 'paragraph',
	  ul: 'bulleted-list',
	  li: 'list-item',
	  ol: 'numbered-list',
	  img: 'image',
	  iframe: 'video',
	  a: 'link'
	};
	
	var markTags = {
	  em: 'italic',
	  strong: 'bold',
	  u: 'underlined'
	};
	
	var schema = {
	  document: {
	    nodes: [{ types: ['paragraph', 'bulleted-list', 'list-item', 'numbered-list', 'image', 'link'] }],
	    last: { types: ['paragraph'] },
	    normalize: function normalize(change, reason, context) {
	      switch (reason) {
	        case _slateSchemaViolations.LAST_CHILD_TYPE_INVALID:
	          {
	            var paragraph = _slate.Block.create('paragraph');
	            return change.insertNodeByKey(context.node.key, context.node.nodes.size, paragraph);
	          }
	        case _slateSchemaViolations.CHILD_TYPE_INVALID:
	          {
	            var src = context.child.data.get('src');
	            var _paragraph = _slate.Block.create({
	              object: 'block',
	              type: 'paragraph',
	              nodes: [{
	                object: 'text',
	                leaves: [{
	                  text: '<iframe title="video" style={{ width: \'100vw\', height: \'56.25vw\' }} src="' + src + '" frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen></iframe>'
	                }]
	              }]
	            });
	            return change.replaceNodeByKey(context.child.key, _paragraph);
	          }
	        default:
	          return null;
	      }
	    }
	  }
	};
	
	var rules = [{
	  deserialize: function deserialize(el, next) {
	    var type = blockTags[el.tagName.toLowerCase()];
	    if (!type) {
	      return undefined;
	    }
	    if (type === 'video') {
	      var src = el.getAttribute('src');
	      return {
	        object: 'block',
	        type: type,
	        data: {
	          src: src
	        },
	        isVoid: true,
	        nodes: next(el.chlidNodes)
	      };
	    }
	    if (type === 'image') {
	      return {
	        object: 'block',
	        type: type,
	        data: {
	          src: el.getAttribute('src'),
	          style: el.getAttribute('style'),
	          alt: el.getAttribute('alt'),
	          className: null
	        },
	        isVoid: true,
	        nodes: next(el.childNodes)
	      };
	    }
	    if (type === 'link') {
	      return {
	        object: 'block',
	        type: type,
	        data: {
	          href: el.getAttribute('href'),
	          title: el.text,
	          style: el.getAttribute('style')
	        }
	      };
	    }
	    return {
	      object: 'block',
	      type: type,
	      nodes: next(el.childNodes)
	    };
	  },
	  serialize: function serialize(obj, children) {
	    if (obj.object !== 'block') {
	      return undefined;
	    }
	    switch (obj.type) {
	      case 'paragraph':
	        {
	          if (isIframe(obj.text)) {
	            var video = obj.text.split(' ');
	            var src = void 0;
	            video.forEach(function (part) {
	              if ((0, _startsWith2.default)(part, 'src')) {
	                src = part.substr(5);
	                src = src.substr(0, src.length - 1);
	              }
	            });
	            var videoIframe = _react2.default.createElement('iframe', {
	              title: 'video',
	              style: { width: '100vw', height: '56.25vw' },
	              src: src,
	              frameBorder: '0',
	              allow: 'autoplay; encrypted-media',
	              allowFullScreen: true
	            });
	            return videoIframe;
	          }
	          return _react2.default.createElement(
	            'p',
	            { style: { maxWidth: '100%' } },
	            children
	          );
	        }
	      case 'bulleted-list':
	        return _react2.default.createElement(
	          'ul',
	          { style: { maxWidth: '100%' } },
	          children
	        );
	      case 'list-item':
	        return _react2.default.createElement(
	          'li',
	          { style: { maxWidth: '100%' } },
	          children
	        );
	      case 'numbered-list':
	        return _react2.default.createElement(
	          'ol',
	          { style: { maxWidth: '100%' } },
	          children
	        );
	      case 'image':
	        {
	          var _src = obj.data.get('src');
	          var style = {
	            display: 'block',
	            maxWidth: '100%'
	            // maxHeight: '20em',
	          };
	          return _react2.default.createElement('img', { src: _src, alt: '', style: style });
	        }
	      case 'link':
	        var href = obj.data.get('href');
	        var title = obj.data.get('title');
	        return _react2.default.createElement(
	          'a',
	          { href: href },
	          title
	        );
	      default:
	        return undefined;
	    }
	  }
	}, {
	  deserialize: function deserialize(el, next) {
	    var type = markTags[el.tagName.toLowerCase()];
	    if (!type) {
	      return undefined;
	    }
	    return {
	      object: 'mark',
	      type: type,
	      nodes: next(el.childNodes)
	    };
	  },
	  serialize: function serialize(obj, children) {
	    if (obj.object !== 'mark') {
	      return undefined;
	    }
	    switch (obj.type) {
	      case 'bold':
	        return _react2.default.createElement(
	          'strong',
	          null,
	          children
	        );
	      case 'italic':
	        return _react2.default.createElement(
	          'em',
	          null,
	          children
	        );
	      case 'underlined':
	        return _react2.default.createElement(
	          'u',
	          null,
	          children
	        );
	      default:
	        return undefined;
	    }
	  }
	}];
	
	var initialValue = _slate.Value.fromJSON({
	  document: {
	    nodes: [{
	      object: 'block',
	      type: 'paragraph',
	      nodes: [{
	        object: 'text',
	        leaves: [{
	          text: ''
	        }]
	      }]
	    }]
	  }
	});
	
	var html = new _slateHtmlSerializer2.default({ rules: rules });
	
	/**
	 * Define the default node type.
	 *
	 * @type {String}
	 */
	
	var DEFAULT_NODE = 'paragraph';
	
	/**
	 * The rich text example.
	 *
	 * @type {Component}
	 */
	
	var RichTextEditor = function (_React$Component) {
	  _inherits(RichTextEditor, _React$Component);
	
	  /**
	   * Deserialize the initial editor value.
	   *
	   * @type {Object}
	   */
	  function RichTextEditor(props) {
	    _classCallCheck(this, RichTextEditor);
	
	    var _this = _possibleConstructorReturn(this, (RichTextEditor.__proto__ || Object.getPrototypeOf(RichTextEditor)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      value: _slate.Value.fromJSON(initialValue),
	      linkModalVisibility: false,
	      currentNode: null
	    };
	    return _this;
	  }
	
	  _createClass(RichTextEditor, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var htmlString = this.props.htmlString;
	
	      if (htmlString.length > 0) {
	        this.setInitialText();
	      }
	      this._notificationSystem = this.refs.notificationSystem;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.saveSuccess && nextProps.saveSuccess !== this.props.saveSuccess) {
	        this.handleAddNotification('save_successful', 'success');
	      }
	    }
	
	    /**
	     * On change, save the new `value`.
	     *
	     * @param {Change} change
	     */
	
	    /**
	     * When a mark button is clicked, toggle the current mark.
	     *
	     * @param {Event} event
	     * @param {String} type
	     */
	
	    /**
	     * When a block button is clicked, toggle the block type.
	     *
	     * @param {Event} event
	     * @param {String} type
	     */
	
	    /**
	     * On drop, insert the image wherever it is dropped.
	     *
	     * @param {Event} event
	     * @param {Change} change
	     * @param {Editor} editor
	     */
	
	    /**
	     * Check if the any of the currently selected blocks are of `type`.
	     *
	     * @param {String} type
	     * @return {Boolean}
	     */
	
	    /**
	     * Check if the current selection has a mark with `type` in it.
	     *
	     * @param {String} type
	     * @return {Boolean}
	     */
	
	    /**
	     * Render the toolbar.
	     *
	     * @return {Element}
	     */
	
	    /**
	     * Render a mark-toggling toolbar button.
	     *
	     * @param {String} type
	     * @param {String} icon
	     * @return {Element}
	     */
	
	    /**
	     * Render a block-toggling toolbar button.
	     *
	     * @param {String} type
	     * @param {String} icon
	     * @return {Element}
	     */
	
	    /**
	     * Render the Slate editor.
	     *
	     * @return {Element}
	     */
	
	    /**
	     * Render a Slate node.
	     *
	     * @param {Object} props
	     * @return {Element}
	     */
	
	    /**
	     * Render a Slate mark.
	     *
	     * @param {Object} props
	     * @return {Element}
	     */
	
	  }, {
	    key: 'render',
	
	
	    /**
	     * Render.
	     *
	     * @return {Element}
	     */
	
	    value: function render() {
	      var style = {
	        NotificationItem: { // Override the notification item
	          DefaultStyle: { // Applied to every notification, regardless of the notification level
	            margin: '10px 5px 2px 1px'
	          },
	          success: { // Applied only to the success notification item
	            color: 'red'
	          }
	        }
	      };
	      return _react2.default.createElement(
	        'div',
	        { id: 'rich-text-editor' },
	        this.renderToolbar(),
	        this.renderEditor(),
	        _react2.default.createElement(_reactNotificationSystem2.default, { ref: 'notificationSystem', style: style })
	      );
	    }
	  }]);
	
	  return RichTextEditor;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onChange = function (_ref) {
	    var value = _ref.value;
	
	    _this2.setState({ value: value });
	  };
	
	  this.onClickMark = function (event, type) {
	    event.preventDefault();
	    var value = _this2.state.value;
	
	    var change = value.change().toggleMark(type);
	    _this2.onChange(change);
	  };
	
	  this.onClickBlock = function (event, type) {
	    event.preventDefault();
	    var value = _this2.state.value;
	
	    var change = value.change();
	    var document = value.document;
	
	    // Handle everything but list buttons.
	
	    if (type !== 'bulleted-list' && type !== 'numbered-list') {
	      var isActive = _this2.hasBlock(type);
	      var isList = _this2.hasBlock('list-item');
	
	      if (isList) {
	        change.setBlocks(isActive ? DEFAULT_NODE : type).unwrapBlock('bulleted-list').unwrapBlock('numbered-list');
	      } else {
	        change.setBlocks(isActive ? DEFAULT_NODE : type);
	      }
	    } else {
	      // Handle the extra wrapping required for list buttons.
	      var _isList = _this2.hasBlock('list-item');
	      var isType = value.blocks.some(function (block) {
	        return !!document.getClosest(block.key, function (parent) {
	          return parent.type === type;
	        });
	      });
	
	      if (_isList && isType) {
	        change.setBlocks(DEFAULT_NODE).unwrapBlock('bulleted-list').unwrapBlock('numbered-list');
	      } else if (_isList) {
	        change.unwrapBlock(type === 'bulleted-list' ? 'numbered-list' : 'bulleted-list').wrapBlock(type);
	      } else {
	        change.setBlocks('list-item').wrapBlock(type);
	      }
	    }
	
	    _this2.onChange(change);
	  };
	
	  this.onClickImage = function (event) {
	    event.preventDefault();
	    var file = event.target.files[0];
	    if (!file) {
	      return;
	    }
	    var src = void 0;
	    var reader = new FileReader();
	    reader.onload = function () {
	      src = reader.result;
	      var change = _this2.state.value.change().call(insertImage, src);
	      _this2.onChange(change);
	    };
	    var blob = file.slice(0, file.size, file.type);
	    reader.readAsDataURL(blob);
	  };
	
	  this.onDropOrPaste = function (event, change, editor) {
	    var target = (0, _slateReact.getEventRange)(event, change.value);
	    if (!target && event.type === 'drop') {
	      return;
	    }
	    var transfer = (0, _slateReact.getEventTransfer)(event);
	    var type = transfer.type,
	        text = transfer.text,
	        files = transfer.files;
	
	
	    if (type === 'files') {
	      files.forEach(function (file) {
	        var reader = new FileReader();
	
	        var _file$type$split = file.type.split('/'),
	            _file$type$split2 = _slicedToArray(_file$type$split, 1),
	            mime = _file$type$split2[0];
	
	        if (mime === 'image') {
	          reader.addEventListener('load', function () {
	            editor.change(function (c) {
	              c.call(insertImage, reader.result, target);
	            });
	          });
	          reader.readAsDataURL(file);
	        }
	      });
	    }
	
	    if (type === 'text') {
	      if (!(0, _isUrl2.default)(text)) {
	        return;
	      }
	      if (!isImage(text)) {
	        return;
	      }
	      change.call(insertImage, text, target);
	    }
	  };
	
	  this.setInitialText = function () {
	    var htmlString = _this2.props.htmlString;
	
	    var value = html.deserialize(htmlString);
	    _this2.setState({ value: value });
	  };
	
	  this._notificationSystem = null;
	
	  this.hasBlock = function (type) {
	    var value = _this2.state.value;
	
	    return value.blocks.some(function (node) {
	      return node.type === type;
	    });
	  };
	
	  this.hasMark = function (type) {
	    var value = _this2.state.value;
	
	    return value.activeMarks.some(function (mark) {
	      return mark.type === type;
	    });
	  };
	
	  this.handleSave = function () {
	    var serializedValue = html.serialize(_this2.state.value);
	    _this2.props.saveHtml(serializedValue);
	  };
	
	  this.handleAddNotification = function (title, level) {
	    _this2.refs.notificationSystem.addNotification({
	      title: _react2.default.createElement(_reactReduxI18n.Translate, { value: title }),
	      level: level
	    });
	  };
	
	  this.handleToggleLinkModalVisibility = function () {
	    _this2.setState({
	      linkModalVisibility: !_this2.state.linkModalVisibility,
	      currentNode: { title: '', link: '' }
	    });
	  };
	
	  this.handleLinkModalTitleChange = function (_ref2) {
	    var target = _ref2.target;
	
	    _this2.setState({
	      currentNode: _extends({}, _this2.state.currentNode, { title: target.value })
	    });
	  };
	
	  this.handleLinkModalLinkChange = function (_ref3) {
	    var target = _ref3.target;
	
	    _this2.setState({
	      currentNode: _extends({}, _this2.state.currentNode, { link: target.value })
	    });
	  };
	
	  this.handleInsertALink = function () {
	    if (_this2.state.currentNode) {
	      var change = _this2.state.value.change().call(insertLink, _this2.state.currentNode.title, _this2.state.currentNode.link, _this2.state.currentNode.node);
	      _this2.onChange(change);
	      _this2.setState({
	        currentNode: null,
	        linkModalVisibility: false
	      });
	    }
	  };
	
	  this.handleClickLink = function (event, node) {
	    _this2.setState({
	      currentNode: { node: node, title: node.data.get('title'), link: node.data.get('href') },
	      linkModalVisibility: true
	    });
	  };
	
	  this.renderToolbar = function () {
	    return _react2.default.createElement(
	      'div',
	      { className: 'menu toolbar-menu' },
	      _this2.renderMarkButton('bold', 'fa fa-bold'),
	      _this2.renderMarkButton('italic', 'fa fa-italic'),
	      _this2.renderMarkButton('underlined', 'fa fa-underline'),
	      _this2.renderBlockButton('numbered-list', 'fa fa-list-ol'),
	      _this2.renderBlockButton('bulleted-list', 'fa fa-list'),
	      _this2.renderImageButton('fa fa-image'),
	      _this2.renderLinkButton('fa fa-link'),
	      _this2.renderSaveButton()
	    );
	  };
	
	  this.renderSaveButton = function () {
	    var className = _root_url.isSY ? 'save-button-with-link' : 'save-button';
	    return _react2.default.createElement(_SpinnerButton2.default, {
	      bsStyle: 'success',
	      className: className,
	      onClick: _this2.handleSave,
	      disabled: _this2.props.isLoadingSave,
	      loading: _this2.props.isLoadingSave,
	      icon: 'fa-save',
	      translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	    });
	  };
	
	  this.renderLinkButton = function (icon) {
	    return _root_url.isSY && _react2.default.createElement(
	      'div',
	      { className: 'link-button-wrapper' },
	      _this2.state.linkModalVisibility && _react2.default.createElement(
	        'div',
	        { className: 'link-modal' },
	        _react2.default.createElement(
	          'div',
	          { className: 'link-modal-title' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'insert_link' }),
	          _react2.default.createElement('em', { className: 'fa fa-close', onMouseDown: _this2.handleToggleLinkModalVisibility })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'title' })
	            ),
	            _react2.default.createElement('input', { value: _this2.state.currentNode ? _this2.state.currentNode.title : '', onChange: _this2.handleLinkModalTitleChange })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'link' })
	            ),
	            _react2.default.createElement('input', { value: _this2.state.currentNode ? _this2.state.currentNode.link : '', onChange: _this2.handleLinkModalLinkChange })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12, className: 'button-wrapper' },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { className: 'insert-button', onMouseDown: _this2.handleInsertALink },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'insert' })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        { className: 'link-button', onMouseDown: _this2.handleToggleLinkModalVisibility },
	        _react2.default.createElement('em', { className: icon })
	      )
	    );
	  };
	
	  this.renderImageButton = function (icon) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'image-button-wrapper' },
	      _react2.default.createElement('input', {
	        id: 'myInput',
	        type: 'file',
	        ref: function ref(_ref4) {
	          _this2.upload = _ref4;
	        },
	        style: { display: 'none' },
	        onChange: _this2.onClickImage
	      }),
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        { className: 'image-button', onMouseDown: function onMouseDown() {
	            _this2.upload.click();
	          } },
	        _react2.default.createElement('em', { className: icon })
	      )
	    );
	  };
	
	  this.renderMarkButton = function (type, icon) {
	    var isActive = _this2.hasMark(type);
	    var onMouseDown = function onMouseDown(event) {
	      return _this2.onClickMark(event, type);
	    };
	
	    return _react2.default.createElement(
	      _reactBootstrap.Button,
	      { className: 'format-buttons', onMouseDown: onMouseDown, 'data-active': isActive },
	      _react2.default.createElement('em', { className: icon })
	    );
	  };
	
	  this.renderBlockButton = function (type, icon) {
	    var isActive = _this2.hasBlock(type);
	    var onMouseDown = function onMouseDown(event) {
	      return _this2.onClickBlock(event, type);
	    };
	
	    return _react2.default.createElement(
	      _reactBootstrap.Button,
	      { className: 'format-buttons', onMouseDown: onMouseDown, 'data-active': isActive },
	      _react2.default.createElement('em', { className: icon })
	    );
	  };
	
	  this.renderEditor = function () {
	    return _react2.default.createElement(
	      'div',
	      { className: 'editor' },
	      _react2.default.createElement(_slateReact.Editor, {
	        placeholder: _this2.props.placeholder,
	        value: _this2.state.value,
	        onChange: _this2.onChange,
	        onDrop: _this2.onDropOrPaste,
	        onPaste: _this2.onDropOrPaste,
	        renderNode: _this2.renderNode,
	        renderMark: _this2.renderMark,
	        schema: schema,
	        spellCheck: true
	      })
	    );
	  };
	
	  this.renderNode = function (props) {
	    var attributes = props.attributes,
	        children = props.children,
	        node = props.node,
	        isSelected = props.isSelected;
	
	    switch (node.type) {
	      case 'bulleted-list':
	        return _react2.default.createElement(
	          'ul',
	          attributes,
	          children
	        );
	      case 'list-item':
	        return _react2.default.createElement(
	          'li',
	          attributes,
	          children
	        );
	      case 'numbered-list':
	        return _react2.default.createElement(
	          'ol',
	          attributes,
	          children
	        );
	      case 'image':
	        {
	          var src = node.data.get('src');
	          var className = isSelected ? 'active' : null;
	          var style = { display: 'block' };
	          return _react2.default.createElement('img', _extends({ src: src, alt: '', className: className, style: style }, attributes));
	        }
	      case 'video':
	        {
	          return _react2.default.createElement('iframe', { title: 'video' });
	        }
	      case 'link':
	        {
	          var href = node.data.get('href');
	          var title = node.data.get('title');
	          return _react2.default.createElement(
	            'a',
	            _extends({ href: href }, attributes, { onClick: function onClick(event) {
	                event.preventDefault();
	                _this2.handleClickLink(event, node);
	              } }),
	            title
	          );
	        }
	      default:
	        return null;
	    }
	  };
	
	  this.renderMark = function (props) {
	    var children = props.children,
	        mark = props.mark;
	
	    switch (mark.type) {
	      case 'bold':
	        return _react2.default.createElement(
	          'strong',
	          null,
	          children
	        );
	      case 'italic':
	        return _react2.default.createElement(
	          'em',
	          null,
	          children
	        );
	      case 'underlined':
	        return _react2.default.createElement(
	          'u',
	          null,
	          children
	        );
	      default:
	        return null;
	    }
	  };
	};
	
	RichTextEditor.propTypes = propTypes;
	RichTextEditor.defaultProps = defaultProps;
	
	var _default = RichTextEditor;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isImage, 'isImage', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/RichTextEditor.jsx');
	
	  __REACT_HOT_LOADER__.register(insertImage, 'insertImage', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/RichTextEditor.jsx');
	
	  __REACT_HOT_LOADER__.register(insertLink, 'insertLink', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/RichTextEditor.jsx');
	
	  __REACT_HOT_LOADER__.register(isIframe, 'isIframe', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/RichTextEditor.jsx');
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/RichTextEditor.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/RichTextEditor.jsx');
	
	  __REACT_HOT_LOADER__.register(blockTags, 'blockTags', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/RichTextEditor.jsx');
	
	  __REACT_HOT_LOADER__.register(markTags, 'markTags', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/RichTextEditor.jsx');
	
	  __REACT_HOT_LOADER__.register(schema, 'schema', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/RichTextEditor.jsx');
	
	  __REACT_HOT_LOADER__.register(rules, 'rules', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/RichTextEditor.jsx');
	
	  __REACT_HOT_LOADER__.register(initialValue, 'initialValue', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/RichTextEditor.jsx');
	
	  __REACT_HOT_LOADER__.register(html, 'html', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/RichTextEditor.jsx');
	
	  __REACT_HOT_LOADER__.register(DEFAULT_NODE, 'DEFAULT_NODE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/RichTextEditor.jsx');
	
	  __REACT_HOT_LOADER__.register(RichTextEditor, 'RichTextEditor', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/RichTextEditor.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/RichTextEditor.jsx');
	}();

	;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactAutosuggest = __webpack_require__(85);
	
	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
	
	var _reactIsolatedScroll = __webpack_require__(87);
	
	var _reactIsolatedScroll2 = _interopRequireDefault(_reactIsolatedScroll);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _sales_actions = __webpack_require__(28);
	
	var _autoSuggest_actions = __webpack_require__(72);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isChinaTown = _root_url.ROOT_API_URL === 'https://erp.chinatown-supermarket.com/api/' || _root_url.ROOT_URL === 'https://erp.chinatown-supermarket.com/api/';
	var isHMM = _root_url.ROOT_API_URL === 'https://hmm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://hmm-scm.truckxi.com/api/';
	var isOCM = _root_url.ROOT_API_URL === 'https://ocm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ocm-scm.truckxi.com/api/';
	var isTN = _root_url.ROOT_API_URL === "https://tn-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://tn-scm.truckxi.com/api/";
	
	/* ----------- */
	/*    Utils    */
	/* ----------- */
	
	// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_Special_Characters
	function escapeRegexCharacters(str) {
	  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	}
	
	/* --------------- */
	/*    Component    */
	/* --------------- */
	
	var SalesOrderAutoSuggest = function (_Component) {
	  _inherits(SalesOrderAutoSuggest, _Component);
	
	  function SalesOrderAutoSuggest(props) {
	    _classCallCheck(this, SalesOrderAutoSuggest);
	
	    var _this = _possibleConstructorReturn(this, (SalesOrderAutoSuggest.__proto__ || Object.getPrototypeOf(SalesOrderAutoSuggest)).call(this, props));
	
	    _this.onChange = function (event, _ref) {
	      var newValue = _ref.newValue;
	
	      _this.setState({
	        value: newValue
	      });
	    };
	
	    _this.onSuggestionsClearRequested = function () {
	      _this.setState({
	        suggestions: []
	      });
	    };
	
	    _this.onSuggestionSelected = function (event, _ref2) {
	      var suggestion = _ref2.suggestion,
	          suggestionValue = _ref2.suggestionValue,
	          suggestionIndex = _ref2.suggestionIndex,
	          sectionIndex = _ref2.sectionIndex,
	          method = _ref2.method;
	
	      // function to get product here
	      event.stopPropagation();
	      event.preventDefault();
	      // this.props.fetchSalesOrderProductByID(suggestion.Product_id, this.state.CustomerNumber, this.props.selectedCompany ? this.props.selectedCompany.value : null);
	      _this.props.fetchSalesOrderProductByID(suggestion.Product_id, _this.state.CustomerNumber, _this.props.Company_id, _this.props.Pickup_Warehouse_id);
	      (isTN || _root_url.isJML) && _this.props.fetchBatchesByID(suggestion.Product_id, _root_url.isJML);
	      _this.props.fetchProductPromotion(suggestion.Product_id, _this.props.Company_id, _this.state.CustomerNumber);
	      _this.props.fetchItemSalesHistory(_this.state.CustomerNumber, suggestion.Product_id);
	      _this.props.handleFocusQty();
	    };
	
	    _this.onKeyPress = function () {
	      return false;
	      // this.props.handleKeyPress('quantity', event);
	    };
	
	    _this.getSuggestionValue = function (suggestion) {
	      switch (_this.props.SearchType) {
	        case 'ProductNum':
	          return suggestion.ProductNO + ' | ' + suggestion.Name;
	        case 'RefNum':
	          return suggestion.RefNum + ' | ' + suggestion.Name;
	        case 'Name':
	          return suggestion.Name;
	        case 'Description':
	          return suggestion.Description + ' | ' + suggestion.Name;
	        case 'GeneralNum':
	          return suggestion.GeneralNum + ' | ' + suggestion.Name;
	        default:
	          return null;
	      }
	    };
	
	    _this.renderSuggestion = function (suggestion) {
	      var _React$createElement;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        (_React$createElement = {
	          className: 'suggestion',
	          id: 'suggestion-render'
	        }, _defineProperty(_React$createElement, 'className', 'sales-auto-suggest-suggestions'), _defineProperty(_React$createElement, 'style', { fontSize: isHMM ? '13px' : '15px' }), _React$createElement),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: isHMM || _root_url.isSY ? 1 : 2 },
	          _this.renderSearchTypeValue(suggestion)
	        ),
	        _root_url.isSY && _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement('img', { src: suggestion.Thumbnail, alt: 'Product image' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: isOCM ? 3 : isHMM ? 2 : 4 },
	          suggestion.Name
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: isOCM ? 2 : isHMM ? 4 : 1 },
	          suggestion.Description
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 1, id: 'price-col' },
	          suggestion.Price
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 1, style: { overflow: 'hidden' } },
	          suggestion.MeasureUnit
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 1 },
	          suggestion.InStock
	        ),
	        !_root_url.isSY && _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 1 },
	          suggestion.Purchased
	        ),
	        !_root_url.isSY && _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 1 },
	          suggestion.PreSale
	        )
	      );
	    };
	
	    _this.renderSearchTypeHeader = function () {
	      switch (_this.props.SearchType) {
	        case 'ProductNum':
	          return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' });
	        default:
	          return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' });
	      }
	    };
	
	    _this.renderSuggestionsContainer = function (_ref3) {
	      var containerProps = _ref3.containerProps,
	          children = _ref3.children;
	
	      var ref = containerProps.ref,
	          restContainerProps = _objectWithoutProperties(containerProps, ['ref']);
	
	      var callRef = function callRef(scrollingDiv) {
	        if (scrollingDiv !== null) {
	          ref(scrollingDiv.component);
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        restContainerProps,
	        _react2.default.createElement(
	          'div',
	          { className: 'container', style: { width: '100%' }, id: 'suggestion-container' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { style: { padding: '10px 5px', margin: '0px' }, className: 'sales-auto-suggest-suggestions', id: 'sales-auto-suggest-header' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: isHMM || _root_url.isSY ? 1 : 2 },
	              _this.renderSearchTypeHeader()
	            ),
	            _root_url.isSY && _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 2 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'image' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: isOCM ? 3 : isHMM ? 2 : 4 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: isOCM ? 2 : isHMM ? 4 : 1 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 1, id: 'price-col' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 1, style: { overflow: 'hidden' } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 1 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'instock' })
	            ),
	            !_root_url.isSY && _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 1 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchased' })
	            ),
	            !_root_url.isSY && _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 1 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'presale' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactIsolatedScroll2.default,
	          { id: 'suggestions-customer-container', ref: callRef },
	          children
	        )
	      );
	    };
	
	    _this.state = {
	      value: '',
	      suggestions: [],
	      CustomerNumber: null,
	      noSuggestions: false
	    };
	
	    _this.lastRequestId = null;
	    _this.onSuggestionsFetchRequested = _lodash2.default.throttle(function (_ref4) {
	      var value = _ref4.value;
	
	      _this.loadSuggestions(value);
	    }, 200);
	    return _this;
	  }
	
	  _createClass(SalesOrderAutoSuggest, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var CustomerNumber = this.props.CustomerNumber;
	      if (this.props.CustomerNumber && this.props.CustomerNumber.value) {
	        CustomerNumber = this.props.CustomerNumber.value;
	      }
	      this.setState({ CustomerNumber: CustomerNumber });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var isInputBlank = nextProps.value === '';
	      var noSuggestions = !isInputBlank && nextProps.salesOrderSuggestions.length === 0;
	      this.setState({ noSuggestions: noSuggestions });
	      if (nextProps.CustomerNumber && nextProps.CustomerNumber !== this.props.CustomerNumber) {
	        var CustomerNumber = nextProps.CustomerNumber;
	        if (nextProps.CustomerNumber && nextProps.CustomerNumber.value) {
	          CustomerNumber = nextProps.CustomerNumber.value;
	        }
	        this.setState({ CustomerNumber: CustomerNumber });
	      }
	
	      if (nextProps.salesOrderSuggestions !== this.props.salesOrderSuggestions) {
	        this.setState({
	          suggestions: [].concat(_toConsumableArray(nextProps.salesOrderSuggestions.slice(0, 200)))
	        });
	        if (this.props.SearchType === 'Barcode' && nextProps.salesOrderSuggestions.length === 1) {
	          // selectInventoryInfo get info
	          // this.props.fetchSalesOrderProductByID(suggestion.Product_id, this.state.CustomerNumber);
	          this.props.fetchSalesOrderProductByID(nextProps.salesOrderSuggestions[0].Product_id, this.state.CustomerNumber);
	          // this.props.fetchSalesOrderProductByID(nextProps.salesOrderSuggestions[0].Product_id, this.state.CustomerNumber, this.props.Company_id);
	          this.props.fetchItemSalesHistory(this.state.CustomerNumber, nextProps.salesOrderSuggestions[0].Product_id);
	          this.props.handleFocusQty();
	        }
	      }
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus(event) {
	      event.target.select();
	    }
	  }, {
	    key: 'loadSuggestions',
	    value: function loadSuggestions(value) {
	      // if (value.length < 3) {
	      //   return;
	      // }
	      // Cancel the previous request
	      // if (this.lastRequestId !== null) {
	      //   clearTimeout(this.lastRequestId);
	      // }
	
	      // this.setState({
	      //   isLoading: true,
	      //   suggest: [],
	      // });
	
	
	      // Fake request
	      // this.lastRequestId = setTimeout(() => {
	      if (this.state.CustomerNumber == null) {
	        return;
	      }
	      this.props.fetchSalesOrderSuggestions(this.state.CustomerNumber, this.props.SearchType, value, this.props.Group);
	      // this.props.fetchSalesOrderSuggestions(this.state.CustomerNumber, this.props.SearchType, value, this.props.Company_id, this.props.Pickup_Warehouse_id);
	    }
	  }, {
	    key: 'renderErrorMessage',
	    value: function renderErrorMessage() {
	      var noSuggestions = this.state.noSuggestions;
	
	      if (noSuggestions && !this.props.salesOrderSuggestionsIsLoading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'no-suggestions' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no_data_found' })
	        );
	      }
	      return _react2.default.createElement('div', null);
	    }
	  }, {
	    key: 'renderSearchTypeValue',
	    value: function renderSearchTypeValue(suggestion) {
	      switch (this.props.SearchType) {
	        case 'ProductNum':
	          return suggestion.ProductNO;
	        default:
	          return suggestion.RefNum;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var suggestions = this.state.suggestions;
	
	      var inputProps = {
	        value: this.props.value,
	        onChange: this.props.onChange,
	        onKeyPress: this.onKeyPress,
	        onFocus: this.onFocus,
	        id: 'sales-auto-suggest'
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactAutosuggest2.default, {
	          suggestions: suggestions,
	          onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
	          onSuggestionsClearRequested: this.onSuggestionsClearRequested,
	          focusInputOnSuggestionClick: false,
	          getSuggestionValue: this.getSuggestionValue,
	          renderSuggestion: this.renderSuggestion,
	          renderSuggestionsContainer: this.renderSuggestionsContainer,
	          onSuggestionSelected: this.onSuggestionSelected,
	          highlightFirstSuggestion: true,
	          inputProps: inputProps
	        }),
	        this.renderErrorMessage()
	      );
	    }
	  }]);
	
	  return SalesOrderAutoSuggest;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    salesOrderSuggestions: state.autoSuggest.salesOrderSuggestions,
	    salesOrderSuggestionsIsLoading: state.autoSuggest.salesOrderSuggestionsIsLoading,
	    salesOrderSuggestionsError: state.autoSuggest.salesOrderSuggestionsError
	    // selectedCompany: state.header.selectedCompany,
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchSalesOrderProductByID: _sales_actions.fetchSalesOrderProductByID, fetchItemSalesHistory: _sales_actions.fetchItemSalesHistory, fetchSalesOrderSuggestions: _autoSuggest_actions.fetchSalesOrderSuggestions, fetchBatchesByID: _sales_actions.fetchBatchesByID, fetchProductPromotion: _sales_actions.fetchProductPromotion })(SalesOrderAutoSuggest);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(escapeRegexCharacters, 'escapeRegexCharacters', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/SalesOrderAutoSuggest.jsx');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/SalesOrderAutoSuggest.jsx');
	
	  __REACT_HOT_LOADER__.register(isChinaTown, 'isChinaTown', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/SalesOrderAutoSuggest.jsx');
	
	  __REACT_HOT_LOADER__.register(isHMM, 'isHMM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/SalesOrderAutoSuggest.jsx');
	
	  __REACT_HOT_LOADER__.register(isOCM, 'isOCM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/SalesOrderAutoSuggest.jsx');
	
	  __REACT_HOT_LOADER__.register(isTN, 'isTN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/SalesOrderAutoSuggest.jsx');
	
	  __REACT_HOT_LOADER__.register(SalesOrderAutoSuggest, 'SalesOrderAutoSuggest', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/SalesOrderAutoSuggest.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/SalesOrderAutoSuggest.jsx');
	}();

	;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _numberWithCommas = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoldCashFormatter = function (_Component) {
	  _inherits(BoldCashFormatter, _Component);
	
	  function BoldCashFormatter() {
	    _classCallCheck(this, BoldCashFormatter);
	
	    return _possibleConstructorReturn(this, (BoldCashFormatter.__proto__ || Object.getPrototypeOf(BoldCashFormatter)).apply(this, arguments));
	  }
	
	  _createClass(BoldCashFormatter, [{
	    key: 'render',
	    value: function render() {
	      var value = this.props.value;
	
	      return _react2.default.createElement(
	        'span',
	        { style: { 'font-weight': 'bold' } },
	        value !== null && !isNaN(value) && '$' + (0, _numberWithCommas.numberWithCommas)(value)
	      );
	    }
	  }]);
	
	  return BoldCashFormatter;
	}(_react.Component);
	
	var _default = BoldCashFormatter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(BoldCashFormatter, 'BoldCashFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/boldCashFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/boldCashFormatter.jsx');
	}();

	;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoldTextFormatter = function (_Component) {
	  _inherits(BoldTextFormatter, _Component);
	
	  function BoldTextFormatter() {
	    _classCallCheck(this, BoldTextFormatter);
	
	    return _possibleConstructorReturn(this, (BoldTextFormatter.__proto__ || Object.getPrototypeOf(BoldTextFormatter)).apply(this, arguments));
	  }
	
	  _createClass(BoldTextFormatter, [{
	    key: 'render',
	    value: function render() {
	      var value = this.props.value;
	
	      return _react2.default.createElement(
	        'span',
	        { style: { 'font-weight': 'bold' } },
	        value || '-'
	      );
	    }
	  }]);
	
	  return BoldTextFormatter;
	}(_react.Component);
	
	var _default = BoldTextFormatter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(BoldTextFormatter, 'BoldTextFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/boldTextFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/boldTextFormatter.jsx');
	}();

	;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactDayPicker = __webpack_require__(201);
	
	var _reactDayPicker2 = _interopRequireDefault(_reactDayPicker);
	
	__webpack_require__(192);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _cleanDates = __webpack_require__(22);
	
	var _root_url = __webpack_require__(9);
	
	var _immutable = __webpack_require__(193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Calendar = function (_Component) {
	  _inherits(Calendar, _Component);
	
	  function Calendar() {
	    _classCallCheck(this, Calendar);
	
	    var _this = _possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call(this));
	
	    _this.handleDayClick = function (day, _ref) {
	      var disabled = _ref.disabled,
	          selected = _ref.selected;
	
	      if (disabled) {
	        return;
	      }
	      _this.setState({
	        selectedDay: selected ? null : day
	      });
	    };
	
	    _this.isPermitted = function (message) {
	      if (message === 'edit') {
	        return (0, _permissions2.default)('change_price_reference');
	      } else if (message === 'view') {
	        return (0, _permissions2.default)('view_price_reference');
	      }
	      return false;
	    };
	
	    _this.state = {
	      selectedDay: new Date()
	    };
	    _this.renderDay = _this.renderDay.bind(_this);
	    _this.onMonthChange = _this.onMonthChange.bind(_this);
	    _this.renderButton = _this.renderButton.bind(_this);
	    return _this;
	  }
	
	  _createClass(Calendar, [{
	    key: 'onMonthChange',
	    value: function onMonthChange(date) {
	      var dates = (0, _cleanDates.getFromToDates)(date, 'month');
	      this.props.fetchInfo('month', dates);
	    }
	  }, {
	    key: 'sundays',
	    value: function sundays(day) {
	      return day.getDay() === 0;
	    }
	  }, {
	    key: 'dateFormatter',
	    value: function dateFormatter(day) {
	      var y = day.getFullYear().toString();
	      var m = day.getMonth() + 1;
	      if (m < 10) {
	        m = '0' + m;
	      } else {
	        m = m.toString();
	      }
	      var d = day.getDate();
	      if (d < 10) {
	        d = '0' + d;
	      } else {
	        d = d.toString();
	      }
	      return y + m + d;
	    }
	  }, {
	    key: 'renderButton',
	    value: function renderButton(day) {
	      var _this2 = this;
	
	      var d = this.dateFormatter(day);
	      var todayD = this.dateFormatter(new Date());
	      var message = d < todayD ? 'view' : 'edit';
	      var permission = this.isPermitted(message);
	
	      var handleButtonClick = function handleButtonClick() {
	        if (_this2.props.type === 'priceAdjustment') {
	          var dates = (0, _cleanDates.getFromToDates)(day);
	          _this2.props.fetchInfo('day', dates);
	          _this2.context.router.push(_this2.props.url);
	          permission = _this2.isPermitted(message);
	        } else if (_this2.props.type === 'purchasePivotChart') {
	          _this2.props.fetchPurchasePivotCharts(d);
	          _this2.props.openChartModal(d);
	          _this2.props.selectDate(d);
	        }
	      };
	      if (d <= todayD) {
	        return _react2.default.createElement(
	          _reactBootstrap.Button,
	          { bsStyle: 'primary', onClick: handleButtonClick, disabled: !permission },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: message })
	        );
	      }
	    }
	  }, {
	    key: 'renderDay',
	    value: function renderDay(day) {
	      var date = day.getDate();
	      var d = date.toString();
	      if (date < 10) {
	        d = '0' + d;
	      }
	      var renderButton = this.renderButton;
	      var index = _lodash2.default.findIndex(this.props.data, { Date: d });
	
	      console.log(this.props.type);
	      {
	        if (index > -1 && this.props.type === "priceAdjustment") {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'date' },
	              date
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'done' }),
	              ' ',
	              this.props.data[index].Done
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pass' }),
	              ' ',
	              this.props.data[index].Pass
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'update' }),
	              ' ',
	              this.props.data[index].Update
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'undone' }),
	              ' ',
	              this.props.data[index].Undone
	            ),
	            ';',
	            renderButton(day)
	          );
	        } else if (index > -1 && this.props.type === "purchasePivotChart") {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'date' },
	              date
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              this.props.data[index].Order,
	              ' ',
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'orders' })
	            ),
	            renderButton(day)
	          );
	        }
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'emptyDate' },
	            date
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_reactDayPicker2.default, {
	        initialMonth: new Date(),
	        selectedDays: this.state.selectedDay,
	        onDayClick: this.handleDayClick,
	        onMonthChange: this.onMonthChange,
	        renderDay: this.renderDay
	      });
	    }
	  }]);
	
	  return Calendar;
	}(_react.Component);
	
	Calendar.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = Calendar;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Calendar, 'Calendar', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/calendar.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/calendar.jsx');
	}();

	;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CellFormatter = function (_Component) {
	  _inherits(CellFormatter, _Component);
	
	  function CellFormatter() {
	    _classCallCheck(this, CellFormatter);
	
	    return _possibleConstructorReturn(this, (CellFormatter.__proto__ || Object.getPrototypeOf(CellFormatter)).apply(this, arguments));
	  }
	
	  _createClass(CellFormatter, [{
	    key: 'render',
	    value: function render() {
	      var value = this.props.value;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        value || '-'
	      );
	    }
	  }]);
	
	  return CellFormatter;
	}(_react.Component);
	
	var _default = CellFormatter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CellFormatter, 'CellFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/cellFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/cellFormatter.jsx');
	}();

	;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IsEnabled = function (_Component) {
	  _inherits(IsEnabled, _Component);
	
	  function IsEnabled() {
	    _classCallCheck(this, IsEnabled);
	
	    return _possibleConstructorReturn(this, (IsEnabled.__proto__ || Object.getPrototypeOf(IsEnabled)).apply(this, arguments));
	  }
	
	  _createClass(IsEnabled, [{
	    key: 'render',
	    value: function render() {
	      var titleClass = (0, _classnames2.default)({ 'parsley-error-label': this.props.meta.touched && this.props.meta.error }, 'control-label', 'marginTopStyle', 'textAlignStyle');
	      var input = this.props.input;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            this.props.meta.touched && this.props.meta.error && _react2.default.createElement(
	              'span',
	              { className: 'parsley-error-message' },
	              this.props.meta.error
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              { className: titleClass },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'is_enabled' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 2 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { type: 'radio', value: true, checked: input.value === true || input.value === 'true' })),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 2 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { type: 'radio', value: false, checked: input.value === false || input.value === 'false' })),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return IsEnabled;
	}(_react.Component);
	
	var _default = IsEnabled;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(IsEnabled, 'IsEnabled', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/isEnabled.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/isEnabled.jsx');
	}();

	;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _driverList = __webpack_require__(298);
	
	var _driverList2 = _interopRequireDefault(_driverList);
	
	var _isaEdit = __webpack_require__(301);
	
	var _isaEdit2 = _interopRequireDefault(_isaEdit);
	
	var _ctnEdit = __webpack_require__(295);
	
	var _ctnEdit2 = _interopRequireDefault(_ctnEdit);
	
	var _shippingStatusEdit = __webpack_require__(305);
	
	var _shippingStatusEdit2 = _interopRequireDefault(_shippingStatusEdit);
	
	var _Notes = __webpack_require__(290);
	
	var _Notes2 = _interopRequireDefault(_Notes);
	
	var _LocationChange = __webpack_require__(289);
	
	var _LocationChange2 = _interopRequireDefault(_LocationChange);
	
	var _InboundDateChange = __webpack_require__(287);
	
	var _InboundDateChange2 = _interopRequireDefault(_InboundDateChange);
	
	var _BatchesModal = __webpack_require__(284);
	
	var _BatchesModal2 = _interopRequireDefault(_BatchesModal);
	
	var _DeliveryTimeChange = __webpack_require__(285);
	
	var _DeliveryTimeChange2 = _interopRequireDefault(_DeliveryTimeChange);
	
	var _PickupTimeChange = __webpack_require__(291);
	
	var _PickupTimeChange2 = _interopRequireDefault(_PickupTimeChange);
	
	var _ExcelUploadOption = __webpack_require__(286);
	
	var _ExcelUploadOption2 = _interopRequireDefault(_ExcelUploadOption);
	
	var _LabelPrintModal = __webpack_require__(288);
	
	var _LabelPrintModal2 = _interopRequireDefault(_LabelPrintModal);
	
	var _ShippingRateModal = __webpack_require__(293);
	
	var _ShippingRateModal2 = _interopRequireDefault(_ShippingRateModal);
	
	var _PromotionAddingModal = __webpack_require__(292);
	
	var _PromotionAddingModal2 = _interopRequireDefault(_PromotionAddingModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var salesOrderModals = {
	  DriverListModal: _driverList2.default,
	  ISAEditModal: _isaEdit2.default,
	  CTNEditModal: _ctnEdit2.default,
	  ShippingStatusEditModal: _shippingStatusEdit2.default,
	  Notes: _Notes2.default,
	  LocationChange: _LocationChange2.default,
	  InboundDateChange: _InboundDateChange2.default,
	  BatchesModal: _BatchesModal2.default,
	  DeliveryTimeChange: _DeliveryTimeChange2.default,
	  PickupTimeChange: _PickupTimeChange2.default,
	  ExcelUploadOption: _ExcelUploadOption2.default,
	  LabelPrintModal: _LabelPrintModal2.default,
	  ShippingRateModal: _ShippingRateModal2.default,
	  PromotionAddingModal: _PromotionAddingModal2.default
	};
	
	var _default = salesOrderModals;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(salesOrderModals, 'salesOrderModals', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/index.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/index.jsx');
	}();

	;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PriceTableModal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isMAG = _root_url.ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://magna-scm.truckxi.com/api/';
	
	var Selectors = _reactDataGridAddons.Data.Selectors;
	
	var PriceTableModal = exports.PriceTableModal = function (_Component) {
	    _inherits(PriceTableModal, _Component);
	
	    function PriceTableModal() {
	        _classCallCheck(this, PriceTableModal);
	
	        var _this = _possibleConstructorReturn(this, (PriceTableModal.__proto__ || Object.getPrototypeOf(PriceTableModal)).call(this));
	
	        _this.initializeModal = function (array) {
	            var index = 0;
	            var formatter = [];
	            if (array && array.length > 0) {
	                array.map(function (r) {
	                    formatter.push({ Idx: index++, customer: r.customer, id: r.id, price: r.price, product: r.product, product_name: r.product_name, customer_price: r.customer_price, driver_price: r.driver_price });
	                });
	            } else {
	                formatter.push({ Idx: 0, name: "", note: "", customer: _this.props.fjCustomerId });
	            }
	            _this.setState({
	                rows: formatter,
	                selectedRows: [],
	                editedRows: []
	            });
	        };
	
	        _this.handleOnSave = function (e) {
	            e.preventDefault();
	            _this.state.rows.map(function (r) {
	                // r.recreate = false;
	            });
	            _this.props.updatePT(_this.props.fjCustomerId, _this.state.rows, _this.props.type).then(function (response) {
	                // alert(JSON.stringify(response.data));
	                alert("Price Table Updated");
	                _this.props.closePTModal();
	            }, function (err) {
	                if (err.status === 500 || err.status === 404) {
	                    alert("Server error, please refresh page. If problem persists, contact administrator.");
	                } else {
	                    alert(JSON.stringify(err.data));
	                }
	            });
	            // this.props.onSave(this.state.rows);
	        };
	
	        _this.state = {
	            rows: [],
	            selectedRows: null,
	            editedRows: [],
	            filters: {}
	
	        };
	        return _this;
	    }
	
	    _createClass(PriceTableModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.props.fetchPT(this.props.fjCustomerId, this.props.type).then(function (response) {
	                if (response.data) {
	                    _this2.initializeModal(response.data);
	                }
	            }, function (err) {
	                if (err.status === 500 || err.status === 404) {
	                    alert("Server error, please refresh page. If problem persists, contact administrator.");
	                } else {
	                    alert(JSON.stringify(err.data));
	                }
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	    }, {
	        key: 'renderAgentTable',
	
	
	        // clickNew(e) {
	        //     e.preventDefault();
	        //     let rows = Selectors.getRows(this.state);
	        //     let index = rows.length;
	        //     let newRow = { name: null, note: null, customer: this.props.fjCustomerId, Idx: index };
	        //     rows.push(newRow);
	        //     let editedRows = [...this.state.editedRows];
	        //     editedRows.push(newRow)
	        //     this.setState({ rows, editedRows })
	        // }
	
	        // deleteCategory(e) {
	        //     e.preventDefault();
	        //     let rows = [...this.state.rows];
	        //     let editedRows = [...this.state.editedRows];
	        //     let index = _.findIndex(rows, { Idx: this.state.selectedRows[0].Idx })
	
	        //     if (this.state.selectedRows[0].id) {
	        //         this.props.deleteFJAgents(this.state.selectedRows[0].id).then((response) => {
	        //             alert("Agent Deleted");
	        //             rows.splice(index, 1);
	        //             index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
	        //             editedRows.splice(index, 1);
	        //             this.setState({ rows, editedRows, selectedRows: [] })
	        //             // this.props.fetchFJAgents(this.props.fjCustomerId).then((response) => {
	        //             //     if (response.data) {
	        //             //         this.initializeModal(response.data);
	        //             //     }
	        //             // }, (err) => {
	        //             //     if (err.status === 500 || err.status === 404) {
	        //             //         alert("Server error, please refresh page. If problem persists, contact administrator.");
	        //             //     }
	        //             // });
	        //         }, (err) => {
	        //             if (err.status === 500 || err.status === 404 || err.status === 405) {
	        //                 alert("Error cannot delete agent.");
	        //             }
	        //         });
	        //     }
	
	        //     // rows.splice(index, 1);
	        //     // index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
	        //     // editedRows.splice(index, 1);
	        //     // this.setState({ rows, editedRows, selectedRows: [] })
	        // }
	
	        value: function renderAgentTable() {
	            var _this3 = this;
	
	            var getRows = function getRows() {
	                return Selectors.getRows(_this3.state);
	            };
	            var getSize = function getSize() {
	                return getRows().length;
	            };
	            var rowGetter = function rowGetter(rowIdx) {
	                var rows = getRows();
	                return rows[rowIdx];
	            };
	            var handleRowUpdated = function handleRowUpdated(e) {
	                _this3.setState({ sortColumn: null, sortDirection: null });
	                var rows = getRows();
	                var editedRows = _this3.state.editedRows.slice(0);
	                Object.assign(rows[e.rowIdx], e.updated);
	                editedRows.forEach(function (element, index) {
	                    if (element.Idx === rows[e.rowIdx].Idx) editedRows.splice(index, 1);
	                }, _this3);
	                editedRows.push(rows[e.rowIdx]);
	                _this3.setState({
	                    rows: rows,
	                    editedRows: editedRows
	                });
	            };
	
	            var handleFilterChange = function handleFilterChange(filter) {
	                var newFilters = Object.assign({}, _this3.state.filters);
	                if (filter.filterTerm) {
	                    newFilters[filter.column.key] = filter;
	                } else {
	                    delete newFilters[filter.column.key];
	                }
	                _this3.setState({ filters: newFilters });
	            };
	
	            // const onRowsSelected = (rows) => {
	            //     let newRows = getRows();
	            //     newRows.map(r => {
	            //         r.isSelected = false;
	            //     })
	            //     rows.map(r => {
	            //         newRows[r.rowIdx].isSelected = true;
	            //     });
	            //     this.setState({ rows: newRows, selectedRows: [rows[0].row] });
	            // }
	            var onRowsSelected = function onRowsSelected(rows) {
	                var newRows = getRows();
	                var selectedRows = [].concat(_toConsumableArray(_this3.state.selectedRows));
	                rows.map(function (r) {
	                    newRows[r.rowIdx].isSelected = true;
	                    selectedRows.push(r.row);
	                });
	                _this3.setState({ rows: newRows, selectedRows: selectedRows });
	            };
	            // const onRowsDeselected = (rows) => {
	            //     let newRows = getRows();
	            //     rows.map(r => {
	            //         newRows[r.rowIdx].isSelected = false;
	            //     });
	            //     this.setState({ rows: newRows, selectedRows: [] });
	            // }
	            var onRowsDeselected = function onRowsDeselected(rows) {
	                var newRows = [].concat(_toConsumableArray(_this3.state.rows));
	                var selectedRows = [].concat(_toConsumableArray(_this3.state.selectedRows));
	                rows.map(function (r) {
	                    newRows[r.rowIdx].isSelected = false;
	                    var rowIndex = selectedRows.indexOf(r.row);
	                    selectedRows.splice(rowIndex, 1);
	                });
	                _this3.setState({ rows: newRows, selectedRows: selectedRows });
	            };
	
	            // const columns = !isMAG ? [
	            var columns = true ? [{
	                key: 'product_name',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'service' }),
	                resizable: true,
	                // sortable: true,
	                filterable: true,
	                // editable: true,
	                width: 320
	            }, {
	                key: 'price',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price' }),
	                resizable: true,
	                // sortable: true,
	                // filterable: true,
	                editable: true,
	                width: 230
	            }] : [{
	                key: 'product_name',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'service' }),
	                resizable: true,
	                // sortable: true,
	                filterable: true,
	                // editable: true,
	                width: 300
	            }, {
	                key: 'customer_price',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_price' }),
	                resizable: true,
	                // sortable: true,
	                // filterable: true,
	                editable: true,
	                width: 130
	            }, {
	                key: 'driver_price',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'driver_price' }),
	                resizable: true,
	                // sortable: true,
	                // filterable: true,
	                editable: true,
	                width: 130
	            }];
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { style: { maxWidth: '550px', marginLeft: '25px' } },
	                        _react2.default.createElement(_reactDataGrid2.default, {
	                            toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                            onAddFilter: handleFilterChange
	                            // rowKey="Idx"
	                            , enableCellSelect: true,
	                            columns: columns,
	                            rowGetter: rowGetter,
	                            rowsCount: getSize(),
	                            minHeight: 400,
	                            rowHeight: 25,
	                            headerRowHeight: 45
	                            // enableRowSelect='single'
	                            , onRowUpdated: handleRowUpdated
	                            // rowSelection={{
	                            // showCheckbox: true,
	                            // onRowsSelected,
	                            // onRowsDeselected,
	                            // selectBy: {
	                            //     isSelectedKey: 'isSelected'
	                            // }
	                            // }}
	                        })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            _objectDestructuringEmpty(this.props);
	
	            _objectDestructuringEmpty(this.state);
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactBootstrap.ButtonToolbar, { style: { marginLeft: '5px', marginBottom: '7px' } }),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: 'text-center' },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            this.renderAgentTable()
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'centerStyle', style: { marginTop: '20px' } },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            style: { marginRight: '5px' },
	                            bsStyle: 'success',
	                            onClick: function onClick(e) {
	                                _this4.handleOnSave(e);
	                            }
	                        },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PriceTableModal;
	}(_react.Component);
	
	var _default = PriceTableModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(PriceTableModal, 'PriceTableModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/priceTableModal.jsx');
	
	    __REACT_HOT_LOADER__.register(isMAG, 'isMAG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/priceTableModal.jsx');
	
	    __REACT_HOT_LOADER__.register(Selectors, 'Selectors', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/priceTableModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/priceTableModal.jsx');
	}();

	;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TaxSelectionModal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TaxSelectionModal = exports.TaxSelectionModal = function (_Component) {
	  _inherits(TaxSelectionModal, _Component);
	
	  function TaxSelectionModal() {
	    _classCallCheck(this, TaxSelectionModal);
	
	    return _possibleConstructorReturn(this, (TaxSelectionModal.__proto__ || Object.getPrototypeOf(TaxSelectionModal)).apply(this, arguments));
	  }
	
	  _createClass(TaxSelectionModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'label',
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax_rate' })
	        ),
	        _react2.default.createElement(_reactSelect2.default, {
	          options: this.props.taxRateOptions,
	          value: this.props.taxValue,
	          onChange: this.props.onChange
	        })
	      );
	    }
	  }]);
	
	  return TaxSelectionModal;
	}(_react.Component);
	
	var _default = TaxSelectionModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TaxSelectionModal, 'TaxSelectionModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/taxSelectionModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/taxSelectionModal.jsx');
	}();

	;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DisabledWeightField = function (_Component) {
	  _inherits(DisabledWeightField, _Component);
	
	  function DisabledWeightField() {
	    _classCallCheck(this, DisabledWeightField);
	
	    return _possibleConstructorReturn(this, (DisabledWeightField.__proto__ || Object.getPrototypeOf(DisabledWeightField)).apply(this, arguments));
	  }
	
	  _createClass(DisabledWeightField, [{
	    key: 'render',
	    value: function render() {
	      var input = this.props.input;
	
	      return _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { disabled: true, standalone: true, type: 'text', value: this.props.V, addonAfter: 'lb', onChange: this.props.input.onChange(this.props.V) }));
	    }
	  }]);
	
	  return DisabledWeightField;
	}(_react.Component);
	
	var _default = DisabledWeightField;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(DisabledWeightField, 'DisabledWeightField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/weightField.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/weightField.jsx');
	}();

	;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactGoogleMaps = __webpack_require__(821);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _require = __webpack_require__(802),
	    MarkerWithLabel = _require.MarkerWithLabel;
	
	var propTypes = {
	  orderPoints: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    lat: _propTypes2.default.number,
	    lng: _propTypes2.default.number
	  })),
	  centerCoordinates: _propTypes2.default.shape({
	    lat: _propTypes2.default.number,
	    lng: _propTypes2.default.number
	  }),
	  isMarkerShown: _propTypes2.default.bool,
	  driverLocation: _propTypes2.default.string,
	  googleMapURL: _propTypes2.default.string,
	  loadingElement: _propTypes2.default.node,
	  containerElement: _propTypes2.default.node,
	  mapElement: _propTypes2.default.node
	};
	
	var defaultProps = {
	  orderPoints: {},
	  centerCoordnates: {},
	  isMarkerShown: false,
	  driverLocation: '',
	  googleMapURL: '',
	  loadingElement: null,
	  containerElement: null,
	  mapElement: null
	};
	
	var DispatchMap = (0, _reactGoogleMaps.withScriptjs)((0, _reactGoogleMaps.withGoogleMap)(function (_ref) {
	  var orderPoints = _ref.orderPoints,
	      centerCoordinates = _ref.centerCoordinates,
	      isMarkerShown = _ref.isMarkerShown,
	      driverLocation = _ref.driverLocation;
	
	  // extends bounds to accomodate all coordinates
	  var bounds = new window.google.maps.LatLngBounds();
	
	  var driverLat = driverLocation.split(',')[0];
	  var driverLng = driverLocation.split(',')[1];
	  var car = {
	    url: "http://maps.google.com/mapfiles/kml/pal4/icon15.png",
	    size: new google.maps.Size(32, 32)
	  };
	
	  if (orderPoints.length > 0) {
	    orderPoints.map(function (point) {
	      var lat = point.lat,
	          lng = point.lng;
	
	      var latLng = new window.google.maps.LatLng(lat, lng);
	      bounds.extend(latLng);
	    });
	  }
	  /* fitBounds: used to center the map view
	   * panTo: used to set a default location when
	   *        there are no location points
	   */
	  var mapRef = function mapRef(map) {
	    if (map) {
	      map.fitBounds(bounds);
	      if (orderPoints.length === 0) {
	        map.panTo(centerCoordinates);
	      }
	    }
	  };
	  return _react2.default.createElement(
	    _reactGoogleMaps.GoogleMap,
	    {
	      ref: mapRef,
	      zoom: 8,
	      center: centerCoordinates,
	      options: { maxZoom: 17 }
	    },
	    isMarkerShown && orderPoints.map(function (point) {
	      return _react2.default.createElement(
	        MarkerWithLabel,
	        {
	          key: point.ActiveStopNum,
	          position: { lat: point.lat, lng: point.lng },
	          labelAnchor: new google.maps.Point(0, 0),
	          labelStyle: { backgroundColor: 'white', fontSize: '14px' }
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          point.deliver_eta_info.duration_text
	        )
	      );
	    }),
	    isMarkerShown && orderPoints.map(function (point) {
	      return _react2.default.createElement(_reactGoogleMaps.Marker, {
	        key: point.ActiveStopNum,
	        label: String(point.ActiveStopNum),
	        position: { lat: point.lat, lng: point.lng }
	      });
	    }),
	    _react2.default.createElement(_reactGoogleMaps.Marker, {
	      key: 1,
	      label: 1,
	      position: { lat: Number(driverLat), lng: Number(driverLng) },
	      icon: car
	    })
	  );
	}));
	
	DispatchMap.propTypes = propTypes;
	DispatchMap.defaultProps = defaultProps;
	
	var _default = DispatchMap;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/DispatchMap.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/DispatchMap.jsx');
	
	  __REACT_HOT_LOADER__.register(DispatchMap, 'DispatchMap', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/DispatchMap.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/DispatchMap.jsx');
	}();

	;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _selection = __webpack_require__(21);
	
	var _warehouses_actions = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarehouseDropdown = function (_Component) {
	  _inherits(WarehouseDropdown, _Component);
	
	  function WarehouseDropdown() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, WarehouseDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WarehouseDropdown.__proto__ || Object.getPrototypeOf(WarehouseDropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      warehouseOptions: []
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(WarehouseDropdown, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.fetchWarehouses();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.warehouseList !== nextProps.warehouseList) {
	        this.setWarehouseOptions(nextProps.warehouseList);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.resetWarehouses();
	    }
	  }, {
	    key: 'setWarehouseOptions',
	    value: function setWarehouseOptions(warehouses) {
	      var warehouseOptions = [];
	      if (warehouses) {
	        warehouses.map(function (warehouse) {
	          warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name });
	        });
	      }
	      this.setState({ warehouseOptions: warehouseOptions });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.warehouseListIsLoading && !this.props.fetchWarehousesError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.fetchWarehousesError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_cannot_be_loaded' })
	          )
	        );
	      }
	      var warehouseOptions = this.state.warehouseOptions;
	
	      return _react2.default.createElement(_reduxForm.Field, _extends({}, this.props, { name: 'Warehouse', component: _selection.Selection, options: warehouseOptions }));
	    }
	  }]);
	
	  return WarehouseDropdown;
	}(_react.Component);
	
	/*
	  arAccounts: {
	    accountList,
	    accountsIsLoading,
	    accountsError,
	  }
	*/
	
	
	function mapStateToProps(state) {
	  return {
	    warehouseList: state.warehouses.all,
	    warehouseListIsLoading: state.warehouses.isLoading,
	    fetchWarehousesError: state.warehouses.fetchWarehousesError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchWarehouses: _warehouses_actions.fetchWarehouses,
	  resetWarehouses: _warehouses_actions.resetWarehouses
	})(WarehouseDropdown);
	
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/warehouseDropdown.jsx');
	
	  __REACT_HOT_LOADER__.register(WarehouseDropdown, 'WarehouseDropdown', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/warehouseDropdown.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/warehouseDropdown.jsx');
	}();

	;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isGV = _root_url.ROOT_API_URL === 'https://gvyummy-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://gvyummy-scm.truckxi.com/api/';
	
	var Footer = function (_Component) {
	    _inherits(Footer, _Component);
	
	    function Footer() {
	        _classCallCheck(this, Footer);
	
	        return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
	    }
	
	    _createClass(Footer, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'footer',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    !isGV && _react2.default.createElement(
	                        'span',
	                        { style: { float: 'left' } },
	                        '\xA9 2019 - Truckxi.com'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { style: { float: 'right' } },
	                        'v.',
	                        _root_url.VERSION_NUM
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Footer;
	}(_react.Component);
	
	var _default = Footer;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(isGV, 'isGV', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Footer.jsx');
	
	    __REACT_HOT_LOADER__.register(Footer, 'Footer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Footer.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Footer.jsx');
	}();

	;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pubsubJs = __webpack_require__(130);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _Header = __webpack_require__(166);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _baseModals = __webpack_require__(393);
	
	var _baseModals2 = _interopRequireDefault(_baseModals);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _auth_actions = __webpack_require__(79);
	
	var _language_actions = __webpack_require__(134);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { fetchWarehouses } from '../../actions/warehouses_actions';
	
	
	var isAFM = _root_url.ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afm-scm.truckxi.com/api/';
	var isHF = _root_url.ROOT_API_URL === 'https://hfstage-erp.truckxi.com/api/' || _root_url.ROOT_URL === 'https://hfstage-erp.truckxi.com/api/';
	var isOCM = _root_url.ROOT_API_URL === 'https://ocm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ocm-scm.truckxi.com/api/';
	
	//import {logoStyle, logo1Style} from '../Common/style';
	
	var Header = function (_Component) {
	    _inherits(Header, _Component);
	
	    function Header() {
	        _classCallCheck(this, Header);
	
	        var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this));
	
	        _this.state = {
	            confirmRefreshOpen: false,
	            warehouseLocationDisplay: null,
	            warehouseLocation: null,
	            warehouseLocationSelection: [],
	
	            companyLocationDisplay: null,
	            companyLocation: null,
	            companyLocationSelection: []
	        };
	        _this.pageRefreshOpen = _this.pageRefreshOpen.bind(_this);
	        _this.pageRefreshClose = _this.pageRefreshClose.bind(_this);
	        return _this;
	    }
	
	    _createClass(Header, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            (0, _Header2.default)();
	            // this.props.fetchWarehouses();
	        }
	    }, {
	        key: 'toggleUserblock',
	        value: function toggleUserblock(e) {
	            e.preventDefault();
	            _pubsubJs2.default.publish('toggleUserblock');
	        }
	    }, {
	        key: 'logOut',
	        value: function logOut() {
	            this.props.signoutUser();
	        }
	    }, {
	        key: 'pageRefreshOpen',
	        value: function pageRefreshOpen() {
	            this.setState({ confirmRefreshOpen: true });
	        }
	    }, {
	        key: 'pageRefreshClose',
	        value: function pageRefreshClose() {
	            this.setState({ confirmRefreshOpen: false });
	        }
	    }, {
	        key: 'pageRefreshConfirm',
	        value: function pageRefreshConfirm() {
	            this.setState({ confirmRefreshOpen: false });
	            setTimeout(function () {
	                window.location.reload(true);
	            }, 2000);
	            window.location.pathname = '/';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                warehouseLocation = _state.warehouseLocation,
	                warehouseLocationDisplay = _state.warehouseLocationDisplay,
	                warehouseLocationSelection = _state.warehouseLocationSelection,
	                companyLocation = _state.companyLocation,
	                companyLocationDisplay = _state.companyLocationDisplay,
	                companyLocationSelection = _state.companyLocationSelection;
	
	            if (isAFM) {
	                if (warehouseLocationSelection.length < 1) {
	                    if ((0, _permissions2.default)('view_belongwarehouse_All')) {
	                        warehouseLocationSelection.push({
	                            label: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all_locations' }),
	                            value: ''
	                        }, {
	                            label: "Beaverton",
	                            value: 'Beaverton'
	                        }, {
	                            label: "Bellevue",
	                            value: 'Bellevue'
	                        }, {
	                            label: "Seattle",
	                            value: 'Seattle'
	                        });
	                        this.setState({ warehouseLocationSelection: warehouseLocationSelection });
	                    } else if ((0, _permissions2.default)('view_belongwarehouse_Beaverton')) {
	                        warehouseLocationSelection.push({
	                            label: "Beaverton",
	                            value: 'Beaverton'
	                        });
	                        this.setState({ warehouseLocationSelection: warehouseLocationSelection });
	                    } else if ((0, _permissions2.default)('view_belongwarehouse_Bellevue')) {
	                        warehouseLocationSelection.push({
	                            label: "Bellevue",
	                            value: 'Bellevue'
	                        });
	                        this.setState({ warehouseLocationSelection: warehouseLocationSelection });
	                    } else if ((0, _permissions2.default)('view_belongwarehouse_Seattle')) {
	                        warehouseLocationSelection.push({
	                            label: "Seattle",
	                            value: 'Seattle'
	                        });
	                        this.setState({ warehouseLocationSelection: warehouseLocationSelection });
	                    }
	                }
	
	                if (localStorage.getItem('warehouseLocation') === '' || !localStorage.getItem('warehouseLocation')) {
	                    warehouseLocation = '';
	                    warehouseLocationDisplay = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all_locations' });
	                } else if (localStorage.getItem('warehouseLocation') === 'Beaverton') {
	                    warehouseLocation = 'Beaverton';
	                    warehouseLocationDisplay = 'Beaverton';
	                } else if (localStorage.getItem('warehouseLocation') === 'Bellevue') {
	                    warehouseLocation = 'Bellevue';
	                    warehouseLocationDisplay = 'Bellevue';
	                } else if (localStorage.getItem('warehouseLocation') === 'Seattle') {
	                    warehouseLocation = 'Seattle';
	                    warehouseLocationDisplay = 'Seattle';
	                }
	            }
	
	            var handleWarehouseLocationChange = function handleWarehouseLocationChange(el) {
	                var _state2 = _this2.state,
	                    warehouseLocationDisplay = _state2.warehouseLocationDisplay,
	                    warehouseLocation = _state2.warehouseLocation;
	
	                warehouseLocationDisplay = el.label;
	                warehouseLocation = el.value;
	                localStorage.setItem('warehouseLocation', warehouseLocation);
	                _this2.setState({ warehouseLocationDisplay: warehouseLocationDisplay, warehouseLocation: warehouseLocation });
	                window.location.reload();
	                // window.location.pathname = `/`;
	            };
	
	            var ddAlertTitle = _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement('em', { className: 'fa fa-gear' })
	            );
	            var langIcon = _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement('em', { className: 'fa fa-language' })
	            );
	            var refreshDialogueStyle = {
	                width: '450px',
	                height: '200px',
	                marginLeft: '-10%'
	            };
	            var refresh_system = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'refresh_system' });
	
	            return _react2.default.createElement(
	                'header',
	                { className: 'topnavbar-wrapper' },
	                _react2.default.createElement(
	                    'nav',
	                    { role: 'navigation', className: 'navbar topnavbar' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'navbar-header' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#/', className: 'navbar-brand' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'brand-logo text-center' },
	                                !isHF && _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'SCM'
	                                ),
	                                isHF && _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'ERP'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'brand-logo-collapsed' },
	                                _react2.default.createElement('img', { src: '/img/logo1.png', alt: 'App Logo', className: 'img-responsive logo1Style' })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'nav-wrapper' },
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'nav navbar-nav' },
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '#', 'data-trigger-resize': '', 'data-toggle-state': 'aside-collapsed', className: 'hidden-xs' },
	                                    _react2.default.createElement('em', { className: 'fa fa-navicon' })
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '#', 'data-toggle-state': 'aside-toggled', 'data-no-persist': 'true', className: 'visible-xs sidebar-toggle' },
	                                    _react2.default.createElement('em', { className: 'fa fa-navicon' })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'nav navbar-nav navbar-right' },
	                            isAFM && _react2.default.createElement(
	                                'li',
	                                { style: { padding: '11px' } },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Dropdown,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Dropdown.Toggle,
	                                        { style: { width: '120px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' } },
	                                        warehouseLocationDisplay
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Dropdown.Menu,
	                                        { className: 'super-colors' },
	                                        warehouseLocationSelection.map(function (el) {
	                                            return _react2.default.createElement(
	                                                _reactBootstrap.MenuItem,
	                                                { onClick: function onClick() {
	                                                        return handleWarehouseLocationChange(el);
	                                                    } },
	                                                el.label
	                                            );
	                                        })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { onClick: this.pageRefreshOpen },
	                                    _react2.default.createElement('em', { className: 'fa fa-refresh' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.NavDropdown,
	                                { noCaret: true, title: langIcon },
	                                _react2.default.createElement(
	                                    _reactBootstrap.MenuItem,
	                                    { className: 'animated flipInX', event: true, key: 2.1, onClick: function onClick(e) {
	                                            e.preventDefault();
	                                            _this2.props.changeToEnglish();
	                                        } },
	                                    'English'
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.MenuItem,
	                                    { className: 'animated flipInX', event: true, key: 2.2, onClick: function onClick(e) {
	                                            e.preventDefault();
	                                            _this2.props.changeToChinese();
	                                        } },
	                                    '\u4E2D\u6587'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.NavDropdown,
	                                { noCaret: true, eventKey: 3, title: ddAlertTitle, id: 'basic-nav-dropdown' },
	                                _react2.default.createElement(
	                                    _reactBootstrap.MenuItem,
	                                    { onClick: this.logOut.bind(this), className: 'animated flipInX', eventKey: 3.3 },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'logout' })
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_baseModals2.default, null),
	                _react2.default.createElement(
	                    _reactSkylight.SkyLightStateless,
	                    { dialogStyles: refreshDialogueStyle, isVisible: this.state.confirmRefreshOpen, onCloseClicked: function onCloseClicked() {
	                            _this2.pageRefreshClose();
	                        }, title: refresh_system },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'centerStyle', style: { marginTop: '20px' } },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm_refresh' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'centerStyle' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'danger',
	                                    onClick: function onClick() {
	                                        _this2.pageRefreshClose();
	                                    }
	                                },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '\xA0\xA0\xA0'
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'success',
	                                    onClick: function onClick() {
	                                        _this2.pageRefreshConfirm();
	                                    }
	                                },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm' })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Header;
	}(_react.Component);
	
	Header.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	
	var _default = (0, _reactRedux.connect)(null, { signoutUser: _auth_actions.signoutUser, changeToEnglish: _language_actions.changeToEnglish, changeToChinese: _language_actions.changeToChinese })(Header);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(isAFM, 'isAFM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Header.jsx');
	
	    __REACT_HOT_LOADER__.register(isHF, 'isHF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Header.jsx');
	
	    __REACT_HOT_LOADER__.register(isOCM, 'isOCM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Header.jsx');
	
	    __REACT_HOT_LOADER__.register(Header, 'Header', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Header.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Header.jsx');
	}();

	;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toggleState = __webpack_require__(317);
	
	var _toggleState2 = _interopRequireDefault(_toggleState);
	
	var _fullscreen = __webpack_require__(274);
	
	var _fullscreen2 = _interopRequireDefault(_fullscreen);
	
	var _triggerResize = __webpack_require__(318);
	
	var _triggerResize2 = _interopRequireDefault(_triggerResize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = function _default() {
	
	    // Toggle state
	    (0, _toggleState2.default)();
	
	    // Fullscreen toggler
	    (0, _fullscreen2.default)();
	
	    // Trigger resize
	    (0, _triggerResize2.default)();
	
	    // NAVBAR SEARCH
	    // -----------------------------------
	    var navSearch = new navbarSearchInput();
	
	    // Open search input
	    var $searchOpen = $('[data-search-open]');
	
	    $searchOpen.on('click', function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	    }).on('click', navSearch.toggle);
	
	    // Close search input
	    var $searchDismiss = $('[data-search-dismiss]');
	    var inputSelector = '.navbar-form input[type="text"]';
	
	    $(inputSelector).on('click', function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	    }).on('keyup', function (e) {
	        if (e.keyCode == 27) // ESC
	            navSearch.dismiss();
	    });
	
	    // click anywhere closes the search
	    $(document).on('click', navSearch.dismiss);
	    // dismissable options
	    $searchDismiss.on('click', function (e) {
	        e.stopPropagation();
	    }).on('click', navSearch.dismiss);
	
	    function navbarSearchInput() {
	        var navbarFormSelector = 'form.navbar-form';
	        return {
	            toggle: function toggle() {
	
	                var navbarForm = $(navbarFormSelector);
	
	                navbarForm.toggleClass('open');
	
	                var isOpen = navbarForm.hasClass('open');
	
	                navbarForm.find('input')[isOpen ? 'focus' : 'blur']();
	            },
	
	            dismiss: function dismiss() {
	                $(navbarFormSelector).removeClass('open') // Close control
	                .find('input[type="text"]').blur() // remove focus
	                .val('') // Empty input
	                ;
	            }
	        };
	    }
	};
	
	exports.default = _default;
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }

	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Header.run.js');
	}();

	;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _Offsidebar = __webpack_require__(390);
	
	var _Offsidebar2 = _interopRequireDefault(_Offsidebar);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Offsidebar = function (_Component) {
	    _inherits(Offsidebar, _Component);
	
	    function Offsidebar(props, context) {
	        _classCallCheck(this, Offsidebar);
	
	        var _this = _possibleConstructorReturn(this, (Offsidebar.__proto__ || Object.getPrototypeOf(Offsidebar)).call(this, props, context));
	
	        _this.state = {
	            key: 1
	        };
	        return _this;
	    }
	
	    _createClass(Offsidebar, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            (0, _Offsidebar2.default)();
	        }
	    }, {
	        key: 'handleSelect',
	        value: function handleSelect(key) {
	            this.setState({
	                key: key
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var tabIconA = _react2.default.createElement('em', { className: 'icon-equalizer fa-lg' });
	            var tabIconB = _react2.default.createElement('em', { className: 'icon-user fa-lg' });
	            return _react2.default.createElement(
	                'aside',
	                { className: 'offsidebar hide' },
	                _react2.default.createElement(
	                    _reactBootstrap.Tabs,
	                    { activeKey: this.state.key, onSelect: this.handleSelect.bind(this), justified: true },
	                    _react2.default.createElement(
	                        _reactBootstrap.Tab,
	                        { eventKey: 1, title: tabIconA },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/warehouse' },
	                            _react2.default.createElement(
	                                'h3',
	                                { 'data-toggle-state': 'offsidebar-open', className: 'text-center text-thin' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_dashboard' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/sales' },
	                            _react2.default.createElement(
	                                'h3',
	                                { 'data-toggle-state': 'offsidebar-open', className: 'text-center text-thin' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_dashboard' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/purchase' },
	                            _react2.default.createElement(
	                                'h3',
	                                { 'data-toggle-state': 'offsidebar-open', className: 'text-center text-thin' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_dashboard' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/purchaseManagerDashboard' },
	                            _react2.default.createElement(
	                                'h3',
	                                { 'data-toggle-state': 'offsidebar-open', className: 'text-center text-thin' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_manager' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/presidentDashboard' },
	                            _react2.default.createElement(
	                                'h3',
	                                { 'data-toggle-state': 'offsidebar-open', className: 'text-center text-thin' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'president_dashboard' })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Offsidebar;
	}(_react.Component);
	
	var _default = Offsidebar;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(Offsidebar, 'Offsidebar', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Offsidebar.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Offsidebar.jsx');
	}();

	;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _url = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var paymentMethodList = ['wechatpay', 'alipay', 'creditcard', 'paypal', 'Zelle', 'ApplePay', 'Venmo', 'Cash', 'Other'];
	
	var styles = {
	  container: {
	    width: '100%',
	    margin: '10px auto',
	    display: 'flex',
	    flexDirection: 'column',
	    textAlign: 'center',
	    alignItems: 'center'
	  }
	};
	
	var PaymentMethodModal = function (_Component) {
	  _inherits(PaymentMethodModal, _Component);
	
	  function PaymentMethodModal(props) {
	    _classCallCheck(this, PaymentMethodModal);
	
	    var _this = _possibleConstructorReturn(this, (PaymentMethodModal.__proto__ || Object.getPrototypeOf(PaymentMethodModal)).call(this, props));
	
	    _this.handleSaveButtonClick = function () {
	      var so_id = null;
	      var si_id = null;
	      if (_this.props.salesOrder[0].SalesOrder_id) {
	        so_id = _this.props.salesOrder[0].SalesOrder_id;
	      }
	      if (_this.props.salesOrder[0].SalesInvoice_id) {
	        si_id = _this.props.salesOrder[0].SalesInvoice_id;
	      }
	      var payment_method = _this.state.selectedPaymentMethod;
	      _axios2.default.post(_url.PAYMENT_METHOD_CHANGE_URL, {
	        so_id: so_id,
	        si_id: si_id,
	        payment_method: payment_method
	      }, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        var returnId = _this.props.salesOrder[0].SalesOrder_id ? _this.props.salesOrder[0].SalesOrder_id : _this.props.salesOrder[0].SalesInvoice_id;
	        _this.props.successSaved(returnId, payment_method);
	      }, function (err) {
	        alert(err.data);
	        // console.log('err', err);
	      });
	    };
	
	    _this.state = {
	      selectedPaymentMethod: null
	    };
	    return _this;
	  }
	
	  _createClass(PaymentMethodModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.salesOrder && this.props.salesOrder[0]) {
	        this.setState({
	          selectedPaymentMethod: this.props.salesOrder[0].PaymentType
	        });
	      }
	    }
	  }, {
	    key: 'renderSaveButton',
	    value: function renderSaveButton() {
	      return _react2.default.createElement(
	        'div',
	        {
	          style: {
	            width: '100%',
	            marginTop: '5px',
	            alighItems: 'center',
	            textAlign: 'center'
	          }
	        },
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success'
	            // type="reset"
	            // disabled={this.shouldQuoteButtonDisable()}
	            , onClick: this.handleSaveButtonClick
	          },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	        )
	      );
	    }
	  }, {
	    key: 'renderEachMethod',
	    value: function renderEachMethod(method) {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'label',
	          {
	            style: {
	              // width: '200px',
	              // display: 'inline-block',
	              fontSize: '18px'
	            },
	            onClick: function onClick() {
	              return _this2.setState({ selectedPaymentMethod: method });
	            }
	          },
	          method
	        ),
	        _react2.default.createElement('input', {
	          style: { marginLeft: '20px' },
	          type: 'radio',
	          name: 'paymentMethod',
	          value: method,
	          checked: this.state.selectedPaymentMethod === method,
	          onChange: function onChange(e) {
	            return _this2.setState({ selectedPaymentMethod: e.currentTarget.value });
	          }
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.container },
	        paymentMethodList.map(function (method) {
	          return _this3.renderEachMethod(method);
	        }),
	        this.renderSaveButton()
	      );
	    }
	  }]);
	
	  return PaymentMethodModal;
	}(_react.Component);
	
	var _default = PaymentMethodModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(paymentMethodList, 'paymentMethodList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PaymentMethodModal.jsx');
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PaymentMethodModal.jsx');
	
	  __REACT_HOT_LOADER__.register(PaymentMethodModal, 'PaymentMethodModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PaymentMethodModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PaymentMethodModal.jsx');
	}();

	;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reduxForm = __webpack_require__(3);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(6);
	
	var _map = __webpack_require__(55);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _settings_actions = __webpack_require__(33);
	
	var _businessUserEditModal = __webpack_require__(519);
	
	var _businessUserEditModal2 = _interopRequireDefault(_businessUserEditModal);
	
	var _dateFilterRadios = __webpack_require__(49);
	
	var _dateFilterRadios2 = _interopRequireDefault(_dateFilterRadios);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _cleanDates = __webpack_require__(22);
	
	var _root_url = __webpack_require__(9);
	
	var _groupList_actions = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var daysSelection = [{
	  label: '7 Days',
	  value: 7
	}, {
	  label: '30 Days',
	  value: 30
	}, {
	  label: '90 Days',
	  value: 90
	}, {
	  label: 'All',
	  value: 'all'
	}];
	
	var BusinessUsersModal = function (_Component) {
	  _inherits(BusinessUsersModal, _Component);
	
	  function BusinessUsersModal() {
	    _classCallCheck(this, BusinessUsersModal);
	
	    var _this = _possibleConstructorReturn(this, (BusinessUsersModal.__proto__ || Object.getPrototypeOf(BusinessUsersModal)).call(this));
	
	    _this.getCustomerOptions = function () {
	      var customerList = _this.state.customerList;
	
	      var customerOptions = [];
	      (0, _map2.default)(customerList, function (customer) {
	        var option = { value: customer.CustomerGroup_id, label: customer.Name };
	        customerOptions.push(option);
	      });
	      return customerOptions;
	    };
	
	    _this.handleFetchCustomerGroups = function () {
	      var handleSuccess = function handleSuccess(response) {
	        _this.setState({ customerList: response.data });
	      };
	
	      var handleFailure = function handleFailure(error) {
	        alert(JSON.stringify(error));
	      };
	
	      (0, _groupList_actions.fetchCustomerGroups)(handleSuccess, handleFailure);
	    };
	
	    _this.fetchDetailWithFilter = function () {
	      var setState = _this.setState.bind(_this);
	      var _this$state$businessU = _this.state.businessUsersTableFilter,
	          days = _this$state$businessU.days,
	          fromDate = _this$state$businessU.fromDate,
	          toDate = _this$state$businessU.toDate;
	
	      if (days.value === 'all') {
	        (0, _settings_actions.fetchBusinessUsersAPI)(undefined, setState);
	        return;
	      }
	      if (fromDate && toDate) days = { value: '-1' };
	      var newDate = (0, _cleanDates.toFromDates)(days.value, fromDate, toDate);
	      (0, _settings_actions.fetchBusinessUsersAPI)(newDate, setState);
	    };
	
	    _this.generateDaysDropdownSelection = function (daysSelection, currentSelected, handleDaysClick) {
	      return _react2.default.createElement(
	        _reactBootstrap.Dropdown,
	        { id: 'dropdown-custom-1' },
	        _react2.default.createElement(
	          _reactBootstrap.Dropdown.Toggle,
	          null,
	          currentSelected.label
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Dropdown.Menu,
	          { className: 'super-colors' },
	          daysSelection.map(function (el) {
	            return _react2.default.createElement(
	              _reactBootstrap.MenuItem,
	              { onClick: function onClick() {
	                  return handleDaysClick(el);
	                } },
	              el.label
	            );
	          })
	        )
	      );
	    };
	
	    _this.handleDaysClick = function (el) {
	      _this.setState({
	        businessUsersTableFilter: {
	          fromDate: null,
	          toDate: null,
	          days: el
	        }
	      }, function () {
	        _this.fetchDetailWithFilter();
	      });
	    };
	
	    _this.renderFilter = function () {
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 1 },
	          _this.generateDaysDropdownSelection(daysSelection, _this.state.businessUsersTableFilter.days, _this.handleDaysClick)
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(_DateTimePicker2.default, {
	            id: 'from-datepicker',
	            format: 'MM-DD-YY',
	            onChange: function onChange(e) {
	              if (_this.state.businessUsersTableFilter.toDate && e > _this.state.businessUsersTableFilter.toDate) {
	                return;
	              }
	              _this.setState({ businessUsersTableFilter: _extends({}, _this.state.businessUsersTableFilter, { fromDate: e }) }, function () {
	                if (_this.state.businessUsersTableFilter.fromDate && _this.state.businessUsersTableFilter.toDate) {
	                  _this.fetchDetailWithFilter();
	                }
	              });
	            },
	            time: false,
	            placeholder: 'Start',
	            value: _this.state.businessUsersTableFilter.fromDate
	          })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(_DateTimePicker2.default, {
	            id: 'to-datepicker',
	            format: 'MM-DD-YY',
	            onChange: function onChange(e) {
	              if (e < _this.state.businessUsersTableFilter.fromDate) {
	                return;
	              }
	              _this.setState({ businessUsersTableFilter: _extends({}, _this.state.businessUsersTableFilter, { toDate: e }) }, function () {
	                if (_this.state.businessUsersTableFilter.fromDate && _this.state.businessUsersTableFilter.toDate) {
	                  _this.fetchDetailWithFilter();
	                }
	              });
	            },
	            min: _this.state.businessUsersTableFilter.fromDate,
	            time: false,
	            placeholder: 'End',
	            value: _this.state.businessUsersTableFilter.toDate
	          })
	        )
	      );
	    };
	
	    _this.handleBusinessUserEditConfirm = function (userDetail) {
	      (0, _settings_actions.handleEditUserConfirm)(userDetail).then(function (res) {
	        _this.setModalClose();
	        _this.fetchDetailWithFilter();
	      }).catch(function (err) {});
	    };
	
	    _this.renderSkyLightStateless = function () {
	      return _react2.default.createElement(
	        _reactSkylight.SkyLightStateless,
	        {
	          dialogStyles: { height: '450px' },
	          isVisible: _this.state.businessUserEditModal.isVisible,
	          onCloseClicked: _this.setModalClose,
	          title: "Business Users Edit"
	        },
	        _react2.default.createElement(_businessUserEditModal2.default, { user: _this.state.selectedRow, cancel: _this.setModalClose, confirm: _this.handleBusinessUserEditConfirm, customerOptions: _this.getCustomerOptions() })
	      );
	    };
	
	    _this.setFromDate = function (fromDate) {
	      return _this.setState({ businessUsersTableFilter: _extends({}, _this.state.businessUsersTableFilter, { fromDate: fromDate }) });
	    };
	
	    _this.setToDate = function (toDate) {
	      return _this.setState({ businessUsersTableFilter: _extends({}, _this.state.businessUsersTableFilter, { toDate: toDate }) });
	    };
	
	    _this.setToRangeSearch = function () {
	      return _this.setState({ businessUsersTableFilter: _extends({}, _this.state.businessUsersTableFilter, { days: '-1' }) });
	    };
	
	    _this.setModalOpen = function () {
	      return _this.setState({ businessUserEditModal: _extends({}, _this.state.businessUserEditModal, { isVisible: true }) });
	    };
	
	    _this.setModalClose = function () {
	      return _this.setState({ businessUserEditModal: _extends({}, _this.state.businessUserEditModal, { isVisible: false }) });
	    };
	
	    _this.state = {
	      businessUsersTable: {
	        row: [],
	        filters: {},
	        isLoading: true
	      },
	      businessUsersTableFilter: {
	        fromDate: null,
	        toDate: null,
	        days: {
	          label: '7 Days',
	          value: 7
	        }
	      },
	      selectedRow: null,
	      businessUserEditModal: {
	        isVisible: false
	      },
	      customerList: []
	    };
	    return _this;
	  }
	
	  _createClass(BusinessUsersModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (_root_url.isElegant) {
	        this.handleFetchCustomerGroups();
	      }
	      this.fetchDetailWithFilter();
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this2 = this;
	
	      if (this.state.businessUsersTable.isLoading) return _react2.default.createElement(_spinner2.default, null);else {
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.businessUsersTable);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var businessUsersTable = Object.assign({}, _this2.state.businessUsersTable, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this2.setState({ businessUsersTable: businessUsersTable });
	        };
	
	        var handleFilterChange = function handleFilterChange(filter) {
	          var newFilters = Object.assign({}, _this2.state.businessUsersTable.filters);
	          if (filter.filterTerm) {
	            newFilters[filter.column.key] = filter;
	          } else {
	            delete newFilters[filter.column.key];
	          }
	          var businessUsersTable = _extends({}, _this2.state.businessUsersTable, { filters: newFilters });
	          _this2.setState({ businessUsersTable: businessUsersTable });
	        };
	
	        var onClearFilters = function onClearFilters() {
	          // all filters removed
	          var businessUsersTable = _extends({}, _this2.state.businessUsersTable, { filters: {} });
	          _this2.setState({ businessUsersTable: businessUsersTable });
	        };
	
	        //onRowClick will pass the data of clicked row to a component where the data can be edit
	        var onRowClick = function onRowClick(index) {
	          if (index === -1) return;
	          _this2.props.setSelectedBusinessUser(_this2.state.businessUsersTable.rows[index]);
	          _this2.setState({
	            selectedRow: _this2.state.businessUsersTable.rows[index]
	          }, _this2.setModalOpen);
	        };
	
	        var businessUsersModalComponent = this;
	        var statusFormatter = _react2.default.createClass({
	          displayName: 'statusFormatter',
	          handleConfirmVerificationClick: function handleConfirmVerificationClick(event) {
	            event.stopPropagation();
	            (0, _settings_actions.verifyBusinessUser)(this.props.dependentValues).then(function (res) {
	              businessUsersModalComponent.fetchDetailWithFilter();
	            }).catch(function (err) {
	              if (typeof err.data === 'string') {
	                alert(err.data);
	                return;
	              }
	              if (Array.isArray(err.data)) {
	                var message = '';
	                err.data.forEach(function (errMessage, idx) {
	                  message += idx + 1 + ': ' + errMessage + '.';
	                });
	                alert(message);
	                return;
	              }
	              if (_typeof(err.data) === 'object') {
	                var _message = '';
	                for (var key in err.data) {
	                  if (typeof err.data.key === 'string') {
	                    _message += '(' + err.data.key + ').';
	                  } else {
	                    for (var i = 0; i < err.data[key].length; i++) {
	                      _message += '(' + key + ': ' + err.data[key][i] + ').';
	                    }
	                  }
	                }
	                alert(_message);
	              }
	              // alert(err.data);
	            });
	          },
	          render: function render() {
	            var _this3 = this;
	
	            if (this.props.value) return _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Business_already_verified' })
	            );
	            return _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'success', onClick: function onClick(e) {
	                  return _this3.handleConfirmVerificationClick(e);
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm_verification' })
	            );
	          }
	        });
	
	        // Column difinition
	        var columns = [{
	          key: 'business_name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'business_name' }),
	          resizable: true,
	          width: 200,
	          sortable: true,
	          filterable: true
	        }, {
	          key: 'full_name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'full_name' }),
	          resizable: true,
	          width: 150,
	          sortable: true,
	          filterable: true
	        }, {
	          key: 'phone_number',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone_number' }),
	          resizable: true,
	          width: 150,
	          sortable: true,
	          filterable: true
	        }, {
	          key: 'email',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' }),
	          resizable: true,
	          width: 220,
	          sortable: true,
	          filterable: true
	        },
	        // {
	        //   key: 'street',
	        //   name: <Translate value="street" />,
	        //   resizable: true,
	        //   width: 200,
	        //   sortable: true,
	        //   filterable: true
	        // },
	        {
	          key: 'street',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'street' }),
	          resizable: true,
	          width: 200,
	          sortable: true,
	          filterable: true
	        }, {
	          key: 'is_process',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	          resizable: true,
	          width: 170,
	          sortable: true,
	          filterable: false,
	          formatter: statusFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }];
	
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '100%' } },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              onGridSort: handleGridSort,
	              onAddFilter: handleFilterChange,
	              onClearFilters: onClearFilters,
	              rowKey: 'id',
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onRowClick: onRowClick,
	              columns: columns,
	              rowHeight: 25,
	              minHeight: 265,
	              rowGetter: rowGetter,
	              rowsCount: getSize()
	            })
	          )
	        );
	      }
	    }
	
	    //Filter helper functions
	
	
	    //BusinessUserEdit Modal helper function
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { style: { width: '100%' } },
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            null,
	            this.renderFilter()
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              this.renderTable()
	            )
	          )
	        ),
	        this.renderSkyLightStateless()
	      );
	    }
	  }]);
	
	  return BusinessUsersModal;
	}(_react.Component);
	
	var mapDispatchToProps = {
	  setSelectedBusinessUser: _settings_actions.setSelectedBusinessUser
	};
	
	var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(BusinessUsersModal);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(daysSelection, 'daysSelection', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/businessUsersModal.jsx');
	
	  __REACT_HOT_LOADER__.register(BusinessUsersModal, 'BusinessUsersModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/businessUsersModal.jsx');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/businessUsersModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/businessUsersModal.jsx');
	}();

	;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  marginLeft: '10%',
	  marginRight: '10%',
	  padding: '30px',
	  textAlign: 'center',
	  fontSize: '25px'
	};
	
	var buttonWrapperStyle = {
	  display: 'flex',
	  textAlign: 'center',
	  alignItems: 'center',
	  justifyContent: 'center'
	};
	
	var Modal = function Modal(_ref) {
	  var content = _ref.content,
	      onConfirm = _ref.onConfirm,
	      onCancel = _ref.onCancel;
	  return _react2.default.createElement(
	    _ContentWrapper2.default,
	    null,
	    _react2.default.createElement(
	      _reactBootstrap.Row,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 12, style: { padding: '20px' } },
	        _react2.default.createElement(
	          'div',
	          { style: styles },
	          content
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Row,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 6, style: buttonWrapperStyle },
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'btn btn-primary col-sm-6 buttonStyle',
	            onClick: onCancel
	          },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 6, style: buttonWrapperStyle },
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'btn btn-primary col-sm-6 buttonStyle',
	            onClick: onConfirm
	          },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirmNcontinue' })
	        )
	      )
	    )
	  );
	};
	
	var ConfirmModal = function ConfirmModal(_ref2) {
	  var title = _ref2.title,
	      content = _ref2.content,
	      onConfirm = _ref2.onConfirm,
	      onCancel = _ref2.onCancel,
	      isVisible = _ref2.isVisible;
	  return _react2.default.createElement(
	    _reactSkylight.SkyLightStateless,
	    {
	      dialogStyles: { height: '350px' },
	      isVisible: isVisible,
	      onCloseClicked: onCancel,
	      title: title
	    },
	    _react2.default.createElement(Modal, {
	      content: content,
	      onConfirm: onConfirm,
	      onCancel: onCancel
	    })
	  );
	};
	
	var _default = ConfirmModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/common/confirmModal.jsx');
	
	  __REACT_HOT_LOADER__.register(buttonWrapperStyle, 'buttonWrapperStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/common/confirmModal.jsx');
	
	  __REACT_HOT_LOADER__.register(Modal, 'Modal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/common/confirmModal.jsx');
	
	  __REACT_HOT_LOADER__.register(ConfirmModal, 'ConfirmModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/common/confirmModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/common/confirmModal.jsx');
	}();

	;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _paymentTerms_actions = __webpack_require__(54);
	
	var _customers_actions = __webpack_require__(42);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _products_actions = __webpack_require__(30);
	
	var _customerForm = __webpack_require__(323);
	
	var _customerForm2 = _interopRequireDefault(_customerForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	  var errors = {};
	  if (!values.Name) {
	    errors.Name = 'Required';
	  }
	  if (!values.CustomerNum) {
	    errors.CustomerNum = 'Required';
	  }
	  // if (!values.CreditLimit) {
	  //     errors.CreditLimit = 'Required'
	  // }
	  if (!values.PriceLevel) {
	    errors.PriceLevel = 'Required';
	  }
	  if (values.IsWholesale === null) {
	    errors.IsWholesale = 'Required';
	  }
	  if (values.IsActive === null) {
	    errors.IsActive = 'Required';
	  }
	  if (values.PaymentTerm_id === null || typeof values.PaymentTerm_id === 'undefined') {
	    errors.PaymentTerm_id = 'Required';
	  }
	
	  return errors;
	};
	
	var customerForm = (0, _reduxForm.reduxForm)({
	  form: 'customerForm',
	  validate: validate,
	  enableReinitialize: true,
	  touchOnChange: true,
	  touchOnBlur: false
	})(_customerForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('customerForm');
	
	function mapStateToProps(state) {
	  var paymentTerm_id = selector(state, 'PaymentTerm_id');
	  var isActive = selector(state, 'IsActive');
	  var IsShowPrice = selector(state, 'IsShowPrice');
	  var IsShippingFee = selector(state, 'IsShippingFee');
	  var billing = selector(state, 'Billing');
	  var mailing = selector(state, 'Mailing');
	  var shipping = selector(state, 'Shipping');
	  var notation = selector(state, 'Notation');
	  var contactName = selector(state, 'ContactName');
	
	  return {
	    paymentTerm_id: paymentTerm_id,
	    isActive: isActive,
	    IsShowPrice: IsShowPrice,
	    IsShippingFee: IsShippingFee,
	    billing: billing,
	    mailing: mailing,
	    shipping: shipping,
	    notation: notation,
	    contactName: contactName,
	    currentCustomer: state.customers.currentCustomer,
	    currentCustomerDetail: state.customers.currentCustomerDetail,
	    detailIsLoading: state.customers.detailIsLoading,
	    detailError: state.customers.detailError,
	    initialValues: state.customers.currentCustomerDetail,
	    isCreating: state.customers.isCreating,
	    createError: state.customers.createError,
	    created: state.customers.created,
	    isEditing: state.vendors.isEditing,
	    editError: state.vendors.editError,
	    edited: state.vendors.edited,
	
	    defaultBuyers: state.products.defaultBuyers,
	    defaultBuyersIsLoading: state.products.defaultBuyersIsLoading,
	    defaultBuyersError: state.products.defaultBuyersError,
	
	    paymentTerms: state.paymentTerms.all,
	    paymentTermsIsLoading: state.paymentTerms.isLoading,
	    paymentTermsError: state.paymentTerms.error,
	    userPermissions: state.auth.userPermissions,
	
	    customers: state.customers.all
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchPaymentTerms: _paymentTerms_actions.fetchPaymentTerms,
	  createCustomer: _customers_actions.createCustomer,
	  editCustomer: _customers_actions.editCustomer,
	  fetchCustomerDetail: _customers_actions.fetchCustomerDetail,
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	  changeFieldArrayOfForm: _purchaseOrders_actions.changeFieldArrayOfForm,
	  fetchDefaultBuyers: _products_actions.fetchDefaultBuyers,
	  resetCurrentCustomer: _customers_actions.resetCurrentCustomer,
	  fetchCustomers: _customers_actions.fetchCustomers,
	  fetchFJAgents: _customers_actions.fetchFJAgents,
	  updateFJAgents: _customers_actions.updateFJAgents,
	  deleteFJAgents: _customers_actions.deleteFJAgents,
	  fetchPT: _customers_actions.fetchPT,
	  updatePT: _customers_actions.updatePT
	})(customerForm);
	
	exports.default = _default;
	
	// fields: ['Customer_id', 'CustomerNum', 'RefNum', 'Name', 'Description', 'Bill_CustomerContact_id',
	//     'Mail_CustomerContact_id', 'Ship_CustomerContact_id', 'Bill_CustomerAddress_id', 'Mail_CustomerAddress_id',
	//     'Ship_CustomerAddress_id', 'IsWholesale', 'Sales_User_id', 'PaymentTerm_id', 'CreditLimit', 'CreditStatus',
	//     'PriceLevel', 'IsActive', 'DeliverPlan_id', 'IsPrtReminder', 'IsPrtGeneralInfor', 'Addresses[].Name', 'Addresses[].State',
	//     'Addresses[].City', 'Addresses[].Tax_rate', 'Wholesale_ResaleNo']
	
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Customers/customerForm.jsx');
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Customers/customerForm.jsx');
	
	  __REACT_HOT_LOADER__.register(customerForm, 'customerForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Customers/customerForm.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Customers/customerForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Customers/customerForm.jsx');
	}();

	;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _paymentTerms_actions = __webpack_require__(54);
	
	var _paymentTermForm = __webpack_require__(325);
	
	var _paymentTermForm2 = _interopRequireDefault(_paymentTermForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    currentPaymentTerm: state.paymentTerms.currentPaymentTerm,
	    initialValues: state.paymentTerms.currentPaymentTerm,
	    isCreating: state.paymentTerms.isCreating,
	    createError: state.paymentTerms.createError,
	    created: state.paymentTerms.created,
	    isEditing: state.paymentTerms.isEditing,
	    editError: state.paymentTerms.editError,
	    edited: state.paymentTerms.edited,
	    userPermissions: state.auth.userPermissions
	  };
	}
	
	var validate = function validate(values) {
	  var errors = {};
	  if (!values.Name) {
	    errors.Name = 'Required';
	  }
	  if (!values.TermDays) {
	    errors.TermDays = 'Required';
	  } else if (isNaN(Number(values.TermDays))) {
	    errors.TermDays = 'Term Days should be a number.';
	  }
	  if (!values.Termtype) {
	    errors.Termtype = 'Required';
	  }
	  return errors;
	};
	
	var paymentTermForm = (0, _reduxForm.reduxForm)({
	  form: 'paymentTermForm',
	  validate: validate
	})(_paymentTermForm2.default);
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  createPaymentTerm: _paymentTerms_actions.createPaymentTerm, editPaymentTerm: _paymentTerms_actions.editPaymentTerm, resetCreatePaymentTerm: _paymentTerms_actions.resetCreatePaymentTerm, resetEditPaymentTerm: _paymentTerms_actions.resetEditPaymentTerm
	})(paymentTermForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Customers/paymentTermForm.jsx');
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Customers/paymentTermForm.jsx');
	
	  __REACT_HOT_LOADER__.register(paymentTermForm, 'paymentTermForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Customers/paymentTermForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Customers/paymentTermForm.jsx');
	}();

	;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _zones_actions = __webpack_require__(60);
	
	var _binForm = __webpack_require__(352);
	
	var _binForm2 = _interopRequireDefault(_binForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.Name) {
	        errors.Name = 'Required';
	    }
	    return errors;
	};
	
	var binForm = (0, _reduxForm.reduxForm)({
	    form: 'binForm',
	    validate: validate
	})(_binForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('binForm');
	
	function mapStateToProps(state) {
	    return _defineProperty({
	        currentWarehouse: state.warehouses.currentWarehouse,
	        currentZone: state.zones.currentZone,
	
	        currentBin: state.zones.currentBin,
	        currentBinDetail: state.zones.currentBinDetail,
	        detailIsLoading: state.zones.binDetailIsLoading,
	        detailError: state.zones.binDetailError,
	        initialValues: state.zones.currentBinDetail,
	        isCreating: state.zones.binIsCreating,
	        createError: state.zones.binCreateError,
	        created: state.zones.binCreated,
	        isEditing: state.zones.binIsEditing,
	        editError: state.zones.binEditError,
	        edited: state.zones.binEdited,
	        userPermissions: state.auth.userPermissions
	    }, 'initialValues', state.zones.currentBin);
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { createBin: _zones_actions.createBin, editBin: _zones_actions.editBin, fetchBinDetail: _zones_actions.fetchBinDetail })(binForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/binForm.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/binForm.jsx');
	
	    __REACT_HOT_LOADER__.register(binForm, 'binForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/binForm.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/binForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/binForm.jsx');
	}();

	;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _setReceiveWeightModal = __webpack_require__(378);
	
	var _setReceiveWeightModal2 = _interopRequireDefault(_setReceiveWeightModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	  var errors = {};
	  if (values.importLine && !values.importLine.match(/^[0-9]*\.?[0-9]+( [0-9]*\.?[0-9]+)*$/)) {
	    errors.importLine = 'Invalid input format, please separate values with a whitespace';
	  }
	  return errors;
	};
	// import { fetchReceiveLineWeights, setReceiveLineWeights } from '../../actions/receive_actions';
	
	
	var setReceiveWeightModal = (0, _reduxForm.reduxForm)({
	  form: 'setReceiveWeightModal',
	  validate: validate
	})(_setReceiveWeightModal2.default);
	var selector = (0, _reduxForm.formValueSelector)('setReceiveWeightModal');
	
	function mapStateToProps(state) {
	  var totalWeight = selector(state, 'TotalWeight');
	  var importLine = selector(state, 'importLine');
	  return {
	    totalWeight: totalWeight,
	    importLine: importLine,
	
	    salesOrderLineWeights: state.salesOrders.salesOrderLineWeights,
	    salesOrderLineWeightsIsLoading: state.salesOrders.salesOrderLineWeightsIsLoading,
	    salesOrderLineWeightsError: state.salesOrders.salesOrderLineWeightsError,
	
	    salesOrderLineWeightsIsEditing: state.salesOrders.salesOrderLineWeightsIsEditing,
	    editSalesOrderLineWeightsSuccess: state.salesOrders.editSalesOrderLineWeightsSuccess,
	    editSalesOrderLineWeightsError: state.salesOrders.editSalesOrderLineWeightsError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {})(setReceiveWeightModal);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/setReceiveWeightModal.jsx');
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/setReceiveWeightModal.jsx');
	
	  __REACT_HOT_LOADER__.register(setReceiveWeightModal, 'setReceiveWeightModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/setReceiveWeightModal.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/setReceiveWeightModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/setReceiveWeightModal.jsx');
	}();

	;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _warehouses_actions = __webpack_require__(44);
	
	var _warehouseForm = __webpack_require__(381);
	
	var _warehouseForm2 = _interopRequireDefault(_warehouseForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.Name) {
	        errors.Name = 'Required';
	    }
	    return errors;
	};
	
	var warehouseForm = (0, _reduxForm.reduxForm)({
	    form: 'warehouseForm',
	    validate: validate
	})(_warehouseForm2.default);
	
	// const selector = formValueSelector('warehouseForm')
	
	function mapStateToProps(state) {
	    return {
	        currentWarehouse: state.warehouses.currentWarehouse,
	        initialValues: state.warehouses.currentWarehouse,
	        isCreating: state.warehouses.isCreating,
	        createError: state.warehouses.createError,
	        created: state.warehouses.created,
	        isEditing: state.warehouses.isEditing,
	        editError: state.warehouses.editError,
	        edited: state.warehouses.edited,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { createWarehouse: _warehouses_actions.createWarehouse, editWarehouse: _warehouses_actions.editWarehouse, fetchWarehouseDetail: _warehouses_actions.fetchWarehouseDetail })(warehouseForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/warehouseForm.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/warehouseForm.jsx');
	
	    __REACT_HOT_LOADER__.register(warehouseForm, 'warehouseForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/warehouseForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/warehouseForm.jsx');
	}();

	;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _zones_actions = __webpack_require__(60);
	
	var _products_actions = __webpack_require__(30);
	
	var _zoneForm = __webpack_require__(384);
	
	var _zoneForm2 = _interopRequireDefault(_zoneForm);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var validate = function validate(values) {
	  var errors = {};
	
	  if (!values.Name) {
	    errors.Name = 'Required';
	  }
	
	  if (values.Name) {
	    var str = values.Name.replace(/\s/g, '');
	    if (str !== values.Name) {
	      errors.Name = 'Please remove all spaces.';
	    }
	  }
	  return errors;
	};
	
	var zoneForm = (0, _reduxForm.reduxForm)({
	  form: 'zoneForm',
	  validate: validate
	})(_zoneForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('zoneForm');
	
	function mapStateToProps(state) {
	  var _ref;
	
	  var zone_num = selector(state, 'zone_num');
	  var description = selector(state, 'description');
	  var section_num = selector(state, 'section_num');
	  var bin_num = selector(state, 'bin_num');
	  var binDescription = selector(state, 'binDescription');
	  var levelDescription = selector(state, 'levelDescription');
	  return _ref = {
	    zone_num: zone_num,
	    description: description,
	    section_num: section_num,
	    bin_num: bin_num,
	    binDescription: binDescription,
	    levelDescription: levelDescription,
	    currentWarehouse: state.warehouses.currentWarehouse,
	    currentWarehouseDetail: state.warehouses.currentWarehouseDetail,
	    currentZone: state.zones.currentZone,
	    currentZoneDetail: state.zones.currentZoneDetail,
	    detailIsLoading: state.zones.detailIsLoading,
	    detailError: state.zones.detailError,
	    initialValues: state.zones.currentZoneDetail,
	    isCreating: state.zones.isCreating,
	    createError: state.zones.createError,
	    created: state.zones.created,
	    binCreateError: state.zones.binCreateError,
	    binCreated: state.zones.binCreated,
	    levelCreateError: state.zones.levelCreateError,
	    levelCreated: state.zones.levelCreated,
	    isEditing: state.zones.isEditing,
	    editError: state.zones.editError,
	    edited: state.zones.edited
	  }, _defineProperty(_ref, 'initialValues', state.zones.currentZone), _defineProperty(_ref, 'currentBin', state.zones.currentBin), _defineProperty(_ref, 'currentLevel', state.zones.currentLevel), _ref;
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  change: _reduxForm.change,
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	  setValue: _products_actions.setValue,
	  editLevels: _zones_actions.editLevels,
	  editBins: _zones_actions.editBins,
	  createBin: _zones_actions.createBin,
	  generateBin: _zones_actions.generateBin,
	  fetchWarehouseBins: _zones_actions.fetchWarehouseBins,
	  createZone: _zones_actions.createZone,
	  editZone: _zones_actions.editZone,
	  fetchZoneDetail: _zones_actions.fetchZoneDetail
	})(zoneForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/zoneForm.jsx');
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/zoneForm.jsx');
	
	  __REACT_HOT_LOADER__.register(zoneForm, 'zoneForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/zoneForm.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/zoneForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/zoneForm.jsx');
	}();

	;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _warehouses_actions = __webpack_require__(44);
	
	var _inventories_actions = __webpack_require__(38);
	
	var _favorites_actions = __webpack_require__(58);
	
	var _purchaseQuotes_actions = __webpack_require__(62);
	
	var _putAway_actions = __webpack_require__(81);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _zoneInformation = __webpack_require__(385);
	
	var _zoneInformation2 = _interopRequireDefault(_zoneInformation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var zoneInformation = (0, _reduxForm.reduxForm)({
	    form: 'zoneInformation'
	})(_zoneInformation2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('zoneInformation');
	
	function mapStateToProps(state) {
	    var warehouseChosen = selector(state, 'Warehouse');
	
	    return {
	        warehouseChosen: warehouseChosen,
	
	        salesOrders: state.warehouses.salesOrders,
	        SOIsLoading: state.warehouses.salesOrdersIsLoading,
	        SOError: state.warehouses.salesOrdersError,
	
	        currentPurchaseOrder: state.purchaseOrders.currentPurchaseOrder,
	
	        purchaseOrders: state.warehouses.purchaseOrders,
	        POIsLoading: state.warehouses.purchaseOrdersIsLoading,
	        POError: state.warehouses.purchaseOrdersError,
	
	        warehouses: state.warehouses.all,
	        warehousesIsLoading: state.warehouses.isLoading,
	        warehousesError: state.warehouses.error,
	
	        warehouseBinsDetail: state.warehouses.warehouseBinsDetail,
	        warehouseBinsDetailIsLoading: state.warehouses.warehouseBinsDetailIsLoading,
	        warehouseBinsDetailError: state.warehouses.warehouseBinsDetailError,
	
	        inventories: state.inventories.all,
	        favorites: state.favorites.all,
	        inventoryIsLoading: state.inventories.isLoading,
	        favoritesAreLoading: state.favorites.isLoading,
	        inventoryError: state.inventories.error,
	        favoritesError: state.favorites.error,
	        currentInventory: state.inventories.currentInventory,
	        currentFavorites: state.favorites.currentFavorites,
	
	        numPurchaseQuotes: state.purchaseQuotes.numPurchaseQuotes,
	        numPurchaseQuotesLoading: state.purchaseQuotes.numPurchaseQuotesLoading,
	        numPurchaseQuotesError: state.purchaseQuotes.numPurchaseQuotesError,
	        numPurchaseOrdersNotReceived: state.purchaseOrders.numPurchaseOrdersNotReceived,
	        numPurchaseOrdersNotReceivedLoading: state.purchaseOrders.numPurchaseOrdersNotReceivedLoading,
	        numPurchaseOrdersNotReceivedError: state.purchaseOrders.numPurchaseOrdersNotReceivedError,
	        numTotalPurchases: state.purchaseOrders.numTotalPurchases,
	        numTotalPurchasesError: state.purchaseOrders.numTotalPurchasesError,
	        numTotalPurchasesLoading: state.purchaseOrders.numTotalPurchasesLoading,
	        currentWarehouseReceive: state.putAway.currentWarehouseReceive
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchBinListFromZone: _putAway_actions.fetchBinListFromZone, fetchPurchaseOrders: _purchaseOrders_actions.fetchPurchaseOrders, selectPurchaseOrder: _purchaseOrders_actions.selectPurchaseOrder, resetCurrentPurchaseOrder: _purchaseOrders_actions.resetCurrentPurchaseOrder,
	    fetchInventories: _inventories_actions.fetchInventories, fetchFavorites: _favorites_actions.fetchFavorites, selectInventory: _inventories_actions.selectInventory, selectFavorites: _favorites_actions.selectFavorites,
	    resetCurrentInventory: _inventories_actions.resetCurrentInventory, resetCurrentFavorites: _favorites_actions.resetCurrentFavorites, deleteFavorite: _favorites_actions.deleteFavorite,
	    fetchNumPurchaseQuotes: _purchaseQuotes_actions.fetchNumPurchaseQuotes, fetchPurchaseOrdersNotReceived: _purchaseOrders_actions.fetchPurchaseOrdersNotReceived, fetchTotalPurchases: _purchaseOrders_actions.fetchTotalPurchases,
	    fetchWarehouses: _warehouses_actions.fetchWarehouses, fetchWarehouseSalesOrders: _warehouses_actions.fetchWarehouseSalesOrders, fetchWarehousePurchaseOrders: _warehouses_actions.fetchWarehousePurchaseOrders,
	    fetchWarehouseBins: _warehouses_actions.fetchWarehouseBins })(zoneInformation);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/zoneInformation.jsx');
	
	    __REACT_HOT_LOADER__.register(zoneInformation, 'zoneInformation', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/zoneInformation.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/zoneInformation.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/zoneInformation.jsx');
	}();

	;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _products_actions = __webpack_require__(30);
	
	var _reactRedux = __webpack_require__(6);
	
	var _categories = __webpack_require__(400);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	    return {
	        categories: state.products.groupCategories,
	        categoryIsLoading: state.products.groupCategoryIsLoading,
	        categoryError: state.products.groupCategoryError,
	        currentCategory: state.products.currentCategory,
	        multiIsEditing: state.products.multiCategoryIsEditing,
	        multiError: state.products.multiCategoryEditError,
	        multiEdited: state.products.multiCategoryEdited,
	        userPermissions: state.auth.userPermissions,
	        deletingCategory: state.products.deletingCategory,
	        deleteCategorySuccess: state.products.deleteCategorySuccess,
	        deleteCategoryError: state.products.deleteCategoryError,
	        currentGroup: state.products.currentGroup
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchCategories: _products_actions.fetchCategories, selectCategory: _products_actions.selectCategory, resetCurrentCategory: _products_actions.resetCurrentCategory, editMultiCategories: _products_actions.editMultiCategories, deleteCategory: _products_actions.deleteCategory, clearDeleteCategoryStatus: _products_actions.clearDeleteCategoryStatus, fetchGroupCategories: _products_actions.fetchGroupCategories })(_categories2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/categories.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/categories.jsx');
	}();

	;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _products_actions = __webpack_require__(30);
	
	var _categoryForm = __webpack_require__(401);
	
	var _categoryForm2 = _interopRequireDefault(_categoryForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.Name) {
	        errors.Name = 'Required';
	    }
	    if (values.IsEnabled === null) {
	        errors.IsEnabled = 'Required';
	    }
	    return errors;
	};
	
	var categoryForm = (0, _reduxForm.reduxForm)({
	    form: 'categoryForm',
	    validate: validate
	})(_categoryForm2.default);
	
	function mapStateToProps(state) {
	    return {
	        groups: state.products.groups,
	        groupIsLoading: state.products.groupIsLoading,
	        groupError: state.products.groupError,
	        currentCategory: state.products.currentCategory,
	        initialValues: state.products.currentCategory,
	        isCreating: state.products.categoryIsCreating,
	        createError: state.products.categoryCreateError,
	        created: state.products.categoryCreated,
	        isEditing: state.products.categoryIsEditing,
	        editError: state.products.categoryEditError,
	        edited: state.products.categoryEdited,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchCategories: _products_actions.fetchCategories, createCategory: _products_actions.createCategory, editCategory: _products_actions.editCategory, fetchGroups: _products_actions.fetchGroups, resetCategory: _products_actions.resetCategory })(categoryForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/categoryForm.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/categoryForm.jsx');
	
	    __REACT_HOT_LOADER__.register(categoryForm, 'categoryForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/categoryForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/categoryForm.jsx');
	}();

	;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _products_actions = __webpack_require__(30);
	
	var _groupForm = __webpack_require__(413);
	
	var _groupForm2 = _interopRequireDefault(_groupForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.Name) {
	        errors.Name = 'Required';
	    }
	    if (values.IsEnabled === null) {
	        errors.IsEnabled = 'Required';
	    }
	    return errors;
	};
	
	var groupForm = (0, _reduxForm.reduxForm)({
	    form: 'groupForm',
	    validate: validate
	})(_groupForm2.default);
	
	function mapStateToProps(state) {
	    return {
	        currentGroup: state.products.currentGroup,
	        initialValues: state.products.currentGroup,
	        isCreating: state.products.groupIsCreating,
	        createError: state.products.groupCreateError,
	        created: state.products.groupCreated,
	        isEditing: state.products.groupIsEditing,
	        editError: state.products.groupEditError,
	        edited: state.products.groupEdited,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchGroups: _products_actions.fetchGroups, createGroup: _products_actions.createGroup, editGroup: _products_actions.editGroup })(groupForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/groupForm.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/groupForm.jsx');
	
	    __REACT_HOT_LOADER__.register(groupForm, 'groupForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/groupForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/groupForm.jsx');
	}();

	;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _products_actions = __webpack_require__(30);
	
	var _inventories_actions = __webpack_require__(38);
	
	var _inventoryInfo = __webpack_require__(425);
	
	var _inventoryInfo2 = _interopRequireDefault(_inventoryInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	    return {
	        simplifiedProducts: state.products.simplifiedProducts,
	        simplifiedProductsIsLoading: state.products.simplifiedProductsIsLoading,
	        simplifiedProductsError: state.products.simplifiedProductsError
	    };
	}
	
	var inventoryInfo = (0, _reduxForm.reduxForm)({
	    form: 'inventoryInfo',
	    destroyOnUnmount: false
	})(_inventoryInfo2.default);
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchSimplifiedProducts: _products_actions.fetchSimplifiedProducts, fetchReturnBatch: _inventories_actions.fetchReturnBatch })(inventoryInfo);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/inventoryInfo.jsx');
	
	    __REACT_HOT_LOADER__.register(inventoryInfo, 'inventoryInfo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/inventoryInfo.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/inventoryInfo.jsx');
	}();

	;

/***/ }),
/* 182 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 183 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(194),
	    eq = __webpack_require__(831);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 185 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.clamp` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 */
	function baseClamp(number, lower, upper) {
	  if (number === number) {
	    if (upper !== undefined) {
	      number = number <= upper ? number : upper;
	    }
	    if (lower !== undefined) {
	      number = number >= lower ? number : lower;
	    }
	  }
	  return number;
	}
	
	module.exports = baseClamp;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(184),
	    baseAssignValue = __webpack_require__(194);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	var castSlice = __webpack_require__(770),
	    hasUnicode = __webpack_require__(189),
	    stringToArray = __webpack_require__(785),
	    toString = __webpack_require__(129);
	
	/**
	 * Creates a function like `_.lowerFirst`.
	 *
	 * @private
	 * @param {string} methodName The name of the `String` case method to use.
	 * @returns {Function} Returns the new case function.
	 */
	function createCaseFirst(methodName) {
	  return function(string) {
	    string = toString(string);
	
	    var strSymbols = hasUnicode(string)
	      ? stringToArray(string)
	      : undefined;
	
	    var chr = strSymbols
	      ? strSymbols[0]
	      : string.charAt(0);
	
	    var trailing = strSymbols
	      ? castSlice(strSymbols, 1).join('')
	      : string.slice(1);
	
	    return chr[methodName]() + trailing;
	  };
	}
	
	module.exports = createCaseFirst;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(842),
	    stubArray = __webpack_require__(794);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	module.exports = getSymbols;


/***/ }),
/* 189 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(207),
	    stubFalse = __webpack_require__(795);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(838)(module)))

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(196),
	    isArguments = __webpack_require__(843),
	    isArray = __webpack_require__(78),
	    isArrayLike = __webpack_require__(131),
	    isBuffer = __webpack_require__(190),
	    isPrototype = __webpack_require__(197),
	    nativeKeys = __webpack_require__(814);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' ||
	        typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !nativeKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(747);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(101)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(132);

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1324);

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1340);

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1351);

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1362);

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1409);

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1411);

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1517);

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1525);

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1776);

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1802);

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1951);

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1959);

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(255);

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(73);

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(86);

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(13);
	
	var _localize = __webpack_require__(278);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _loadCss = __webpack_require__(277);
	
	var _loadCss2 = _interopRequireDefault(_loadCss);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(206);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _Base = __webpack_require__(386);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	var _BasePage = __webpack_require__(388);
	
	var _BasePage2 = _interopRequireDefault(_BasePage);
	
	var _BaseHorizontal = __webpack_require__(387);
	
	var _BaseHorizontal2 = _interopRequireDefault(_BaseHorizontal);
	
	var _users = __webpack_require__(692);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _userForm = __webpack_require__(691);
	
	var _userForm2 = _interopRequireDefault(_userForm);
	
	var _products = __webpack_require__(615);
	
	var _products2 = _interopRequireDefault(_products);
	
	var _productForm = __webpack_require__(613);
	
	var _productForm2 = _interopRequireDefault(_productForm);
	
	var _groups = __webpack_require__(610);
	
	var _groups2 = _interopRequireDefault(_groups);
	
	var _categories = __webpack_require__(178);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	var _customers = __webpack_require__(558);
	
	var _customers2 = _interopRequireDefault(_customers);
	
	var _customerForm = __webpack_require__(171);
	
	var _customerForm2 = _interopRequireDefault(_customerForm);
	
	var _vendors = __webpack_require__(694);
	
	var _vendors2 = _interopRequireDefault(_vendors);
	
	var _vendorDetailForm = __webpack_require__(693);
	
	var _vendorDetailForm2 = _interopRequireDefault(_vendorDetailForm);
	
	var _agents = __webpack_require__(553);
	
	var _agents2 = _interopRequireDefault(_agents);
	
	var _agentForm = __webpack_require__(552);
	
	var _agentForm2 = _interopRequireDefault(_agentForm);
	
	var _priceLevel = __webpack_require__(612);
	
	var _priceLevel2 = _interopRequireDefault(_priceLevel);
	
	var _paymentTerms = __webpack_require__(603);
	
	var _paymentTerms2 = _interopRequireDefault(_paymentTerms);
	
	var _generalDashboardRevision = __webpack_require__(568);
	
	var _generalDashboardRevision2 = _interopRequireDefault(_generalDashboardRevision);
	
	var _CategoryAnalysis = __webpack_require__(566);
	
	var _CategoryAnalysis2 = _interopRequireDefault(_CategoryAnalysis);
	
	var _presidentDashboard = __webpack_require__(618);
	
	var _presidentDashboard2 = _interopRequireDefault(_presidentDashboard);
	
	var _purchaseDashboard = __webpack_require__(621);
	
	var _purchaseDashboard2 = _interopRequireDefault(_purchaseDashboard);
	
	var _purchaseManagerDashboard = __webpack_require__(622);
	
	var _purchaseManagerDashboard2 = _interopRequireDefault(_purchaseManagerDashboard);
	
	var _warehouseDashboard = __webpack_require__(642);
	
	var _warehouseDashboard2 = _interopRequireDefault(_warehouseDashboard);
	
	var _salesDashboard = __webpack_require__(667);
	
	var _salesDashboard2 = _interopRequireDefault(_salesDashboard);
	
	var _purchaseQuoteList = __webpack_require__(631);
	
	var _purchaseQuoteList2 = _interopRequireDefault(_purchaseQuoteList);
	
	var _purchaseTemplateList = __webpack_require__(639);
	
	var _purchaseTemplateList2 = _interopRequireDefault(_purchaseTemplateList);
	
	var _purchaseScheduleList = __webpack_require__(636);
	
	var _purchaseScheduleList2 = _interopRequireDefault(_purchaseScheduleList);
	
	var _purchaseReturnList = __webpack_require__(634);
	
	var _purchaseReturnList2 = _interopRequireDefault(_purchaseReturnList);
	
	var _purchaseOrderList = __webpack_require__(624);
	
	var _purchaseOrderList2 = _interopRequireDefault(_purchaseOrderList);
	
	var _purchaseQuoteForm = __webpack_require__(630);
	
	var _purchaseQuoteForm2 = _interopRequireDefault(_purchaseQuoteForm);
	
	var _purchaseScheduleForm = __webpack_require__(635);
	
	var _purchaseScheduleForm2 = _interopRequireDefault(_purchaseScheduleForm);
	
	var _purchaseTemplateForm = __webpack_require__(638);
	
	var _purchaseTemplateForm2 = _interopRequireDefault(_purchaseTemplateForm);
	
	var _purchaseOrderForm = __webpack_require__(623);
	
	var _purchaseOrderForm2 = _interopRequireDefault(_purchaseOrderForm);
	
	var _purchaseReturnForm = __webpack_require__(633);
	
	var _purchaseReturnForm2 = _interopRequireDefault(_purchaseReturnForm);
	
	var _purchasingPerformance = __webpack_require__(640);
	
	var _purchasingPerformance2 = _interopRequireDefault(_purchasingPerformance);
	
	var _priceAdjustment = __webpack_require__(619);
	
	var _priceAdjustment2 = _interopRequireDefault(_priceAdjustment);
	
	var _priceAdjustmentDetail = __webpack_require__(620);
	
	var _priceAdjustmentDetail2 = _interopRequireDefault(_priceAdjustmentDetail);
	
	var _purchasePaymentList = __webpack_require__(626);
	
	var _purchasePaymentList2 = _interopRequireDefault(_purchasePaymentList);
	
	var _purchasePaymentDetail = __webpack_require__(625);
	
	var _purchasePaymentDetail2 = _interopRequireDefault(_purchasePaymentDetail);
	
	var _purchasePivotChartDetail = __webpack_require__(628);
	
	var _purchasePivotChartDetail2 = _interopRequireDefault(_purchasePivotChartDetail);
	
	var _purchasePivotChart = __webpack_require__(627);
	
	var _purchasePivotChart2 = _interopRequireDefault(_purchasePivotChart);
	
	var _purchaseReference = __webpack_require__(632);
	
	var _purchaseReference2 = _interopRequireDefault(_purchaseReference);
	
	var _inventories = __webpack_require__(574);
	
	var _inventories2 = _interopRequireDefault(_inventories);
	
	var _inventoryDetail = __webpack_require__(579);
	
	var _inventoryDetail2 = _interopRequireDefault(_inventoryDetail);
	
	var _inventoryLowStock = __webpack_require__(581);
	
	var _inventoryLowStock2 = _interopRequireDefault(_inventoryLowStock);
	
	var _inventoryExpired = __webpack_require__(580);
	
	var _inventoryExpired2 = _interopRequireDefault(_inventoryExpired);
	
	var _inventoryAdjustments = __webpack_require__(576);
	
	var _inventoryAdjustments2 = _interopRequireDefault(_inventoryAdjustments);
	
	var _inventoryAdjustmentForm = __webpack_require__(575);
	
	var _inventoryAdjustmentForm2 = _interopRequireDefault(_inventoryAdjustmentForm);
	
	var _inventoryRelocations = __webpack_require__(584);
	
	var _inventoryRelocations2 = _interopRequireDefault(_inventoryRelocations);
	
	var _inventoryRelocationForm = __webpack_require__(582);
	
	var _inventoryRelocationForm2 = _interopRequireDefault(_inventoryRelocationForm);
	
	var _inventoryRelocationFromInbound = __webpack_require__(583);
	
	var _inventoryRelocationFromInbound2 = _interopRequireDefault(_inventoryRelocationFromInbound);
	
	var _inventoryRepackages = __webpack_require__(586);
	
	var _inventoryRepackages2 = _interopRequireDefault(_inventoryRepackages);
	
	var _inventoryRepackageForm = __webpack_require__(585);
	
	var _inventoryRepackageForm2 = _interopRequireDefault(_inventoryRepackageForm);
	
	var _inventoryConverts = __webpack_require__(578);
	
	var _inventoryConverts2 = _interopRequireDefault(_inventoryConverts);
	
	var _inventoryConvertForm = __webpack_require__(577);
	
	var _inventoryConvertForm2 = _interopRequireDefault(_inventoryConvertForm);
	
	var _scrapRecords = __webpack_require__(597);
	
	var _scrapRecords2 = _interopRequireDefault(_scrapRecords);
	
	var _scrapRecordForm = __webpack_require__(596);
	
	var _scrapRecordForm2 = _interopRequireDefault(_scrapRecordForm);
	
	var _putAway = __webpack_require__(589);
	
	var _putAway2 = _interopRequireDefault(_putAway);
	
	var _putAwayForm = __webpack_require__(590);
	
	var _putAwayForm2 = _interopRequireDefault(_putAwayForm);
	
	var _inboundForm = __webpack_require__(573);
	
	var _inboundForm2 = _interopRequireDefault(_inboundForm);
	
	var _receiveList = __webpack_require__(594);
	
	var _receiveList2 = _interopRequireDefault(_receiveList);
	
	var _receiveForm = __webpack_require__(591);
	
	var _receiveForm2 = _interopRequireDefault(_receiveForm);
	
	var _receiveHistoryList = __webpack_require__(593);
	
	var _receiveHistoryList2 = _interopRequireDefault(_receiveHistoryList);
	
	var _receiveHistoryDetail = __webpack_require__(592);
	
	var _receiveHistoryDetail2 = _interopRequireDefault(_receiveHistoryDetail);
	
	var _warehouses = __webpack_require__(600);
	
	var _warehouses2 = _interopRequireDefault(_warehouses);
	
	var _warehouseForm = __webpack_require__(175);
	
	var _warehouseForm2 = _interopRequireDefault(_warehouseForm);
	
	var _warehouseDetail = __webpack_require__(599);
	
	var _warehouseDetail2 = _interopRequireDefault(_warehouseDetail);
	
	var _zoneForm = __webpack_require__(176);
	
	var _zoneForm2 = _interopRequireDefault(_zoneForm);
	
	var _zoneDetail = __webpack_require__(601);
	
	var _zoneDetail2 = _interopRequireDefault(_zoneDetail);
	
	var _binForm = __webpack_require__(173);
	
	var _binForm2 = _interopRequireDefault(_binForm);
	
	var _binDetail = __webpack_require__(572);
	
	var _binDetail2 = _interopRequireDefault(_binDetail);
	
	var _productConvert = __webpack_require__(587);
	
	var _productConvert2 = _interopRequireDefault(_productConvert);
	
	var _productConvertDetail = __webpack_require__(588);
	
	var _productConvertDetail2 = _interopRequireDefault(_productConvertDetail);
	
	var _salesOrders = __webpack_require__(670);
	
	var _salesOrders2 = _interopRequireDefault(_salesOrders);
	
	var _posOrders = __webpack_require__(664);
	
	var _posOrders2 = _interopRequireDefault(_posOrders);
	
	var _posCredits = __webpack_require__(662);
	
	var _posCredits2 = _interopRequireDefault(_posCredits);
	
	var _posHolds = __webpack_require__(663);
	
	var _posHolds2 = _interopRequireDefault(_posHolds);
	
	var _salesOrderForm = __webpack_require__(669);
	
	var _salesOrderForm2 = _interopRequireDefault(_salesOrderForm);
	
	var _wholesale = __webpack_require__(676);
	
	var _wholesale2 = _interopRequireDefault(_wholesale);
	
	var _wholesaleOrderForm = __webpack_require__(678);
	
	var _wholesaleOrderForm2 = _interopRequireDefault(_wholesaleOrderForm);
	
	var _favoriteList = __webpack_require__(658);
	
	var _favoriteList2 = _interopRequireDefault(_favoriteList);
	
	var _groupList = __webpack_require__(659);
	
	var _groupList2 = _interopRequireDefault(_groupList);
	
	var _salesInvoice = __webpack_require__(668);
	
	var _salesInvoice2 = _interopRequireDefault(_salesInvoice);
	
	var _editSalesInvoice = __webpack_require__(657);
	
	var _editSalesInvoice2 = _interopRequireDefault(_editSalesInvoice);
	
	var _viewPosOrder = __webpack_require__(675);
	
	var _viewPosOrder2 = _interopRequireDefault(_viewPosOrder);
	
	var _PromotionsPage = __webpack_require__(655);
	
	var _PromotionsPage2 = _interopRequireDefault(_PromotionsPage);
	
	var _posReport = __webpack_require__(665);
	
	var _posReport2 = _interopRequireDefault(_posReport);
	
	var _salesPerformance = __webpack_require__(671);
	
	var _salesPerformance2 = _interopRequireDefault(_salesPerformance);
	
	var _shipToOrders = __webpack_require__(674);
	
	var _shipToOrders2 = _interopRequireDefault(_shipToOrders);
	
	var _preOrders = __webpack_require__(666);
	
	var _preOrders2 = _interopRequireDefault(_preOrders);
	
	var _shipFromOrders = __webpack_require__(673);
	
	var _shipFromOrders2 = _interopRequireDefault(_shipFromOrders);
	
	var _otherService = __webpack_require__(661);
	
	var _otherService2 = _interopRequireDefault(_otherService);
	
	var _shipping = __webpack_require__(565);
	
	var _shipping2 = _interopRequireDefault(_shipping);
	
	var _routing = __webpack_require__(564);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _editRoutes = __webpack_require__(563);
	
	var _editRoutes2 = _interopRequireDefault(_editRoutes);
	
	var _Drivers = __webpack_require__(560);
	
	var _Drivers2 = _interopRequireDefault(_Drivers);
	
	var _AutoRouting = __webpack_require__(559);
	
	var _AutoRouting2 = _interopRequireDefault(_AutoRouting);
	
	var _ARList = __webpack_require__(542);
	
	var _ARList2 = _interopRequireDefault(_ARList);
	
	var _ARDetail = __webpack_require__(541);
	
	var _ARDetail2 = _interopRequireDefault(_ARDetail);
	
	var _createAR = __webpack_require__(546);
	
	var _createAR2 = _interopRequireDefault(_createAR);
	
	var _editAR = __webpack_require__(549);
	
	var _editAR2 = _interopRequireDefault(_editAR);
	
	var _APList = __webpack_require__(536);
	
	var _APList2 = _interopRequireDefault(_APList);
	
	var _APDetail = __webpack_require__(535);
	
	var _APDetail2 = _interopRequireDefault(_APDetail);
	
	var _createAP = __webpack_require__(537);
	
	var _createAP2 = _interopRequireDefault(_createAP);
	
	var _editAP = __webpack_require__(538);
	
	var _editAP2 = _interopRequireDefault(_editAP);
	
	var _SIPaymentList = __webpack_require__(544);
	
	var _SIPaymentList2 = _interopRequireDefault(_SIPaymentList);
	
	var _SIPaymentForm = __webpack_require__(543);
	
	var _SIPaymentForm2 = _interopRequireDefault(_SIPaymentForm);
	
	var _generalReport = __webpack_require__(550);
	
	var _generalReport2 = _interopRequireDefault(_generalReport);
	
	var _mobileCustomerStatement = __webpack_require__(551);
	
	var _mobileCustomerStatement2 = _interopRequireDefault(_mobileCustomerStatement);
	
	var _customerStatement = __webpack_require__(547);
	
	var _customerStatement2 = _interopRequireDefault(_customerStatement);
	
	var _customerStatementMain = __webpack_require__(548);
	
	var _customerStatementMain2 = _interopRequireDefault(_customerStatementMain);
	
	var _vendorStatement = __webpack_require__(539);
	
	var _vendorStatement2 = _interopRequireDefault(_vendorStatement);
	
	var _vendorStatementMain = __webpack_require__(540);
	
	var _vendorStatementMain2 = _interopRequireDefault(_vendorStatementMain);
	
	var _cityReport = __webpack_require__(545);
	
	var _cityReport2 = _interopRequireDefault(_cityReport);
	
	var _userManagement = __webpack_require__(688);
	
	var _userManagement2 = _interopRequireDefault(_userManagement);
	
	var _userManagementDetail = __webpack_require__(689);
	
	var _userManagementDetail2 = _interopRequireDefault(_userManagementDetail);
	
	var _mobileUserMessagesManagement = __webpack_require__(684);
	
	var _mobileUserMessagesManagement2 = _interopRequireDefault(_mobileUserMessagesManagement);
	
	var _mobileUserProducts = __webpack_require__(685);
	
	var _mobileUserProducts2 = _interopRequireDefault(_mobileUserProducts);
	
	var _groupManagement = __webpack_require__(682);
	
	var _groupManagement2 = _interopRequireDefault(_groupManagement);
	
	var _groupManagementDetail = __webpack_require__(683);
	
	var _groupManagementDetail2 = _interopRequireDefault(_groupManagementDetail);
	
	var _taxManagement = __webpack_require__(687);
	
	var _taxManagement2 = _interopRequireDefault(_taxManagement);
	
	var _currencyManagement = __webpack_require__(681);
	
	var _currencyManagement2 = _interopRequireDefault(_currencyManagement);
	
	var _AgentManagement = __webpack_require__(244);
	
	var _AgentManagement2 = _interopRequireDefault(_AgentManagement);
	
	var _report = __webpack_require__(459);
	
	var _ActionLog = __webpack_require__(679);
	
	var _ActionLog2 = _interopRequireDefault(_ActionLog);
	
	var _customerReturn = __webpack_require__(648);
	
	var _customerReturn2 = _interopRequireDefault(_customerReturn);
	
	var _customerReturnForm = __webpack_require__(649);
	
	var _customerReturnForm2 = _interopRequireDefault(_customerReturnForm);
	
	var _customerIssueCredit = __webpack_require__(646);
	
	var _customerIssueCredit2 = _interopRequireDefault(_customerIssueCredit);
	
	var _restockReturnForm = __webpack_require__(651);
	
	var _restockReturnForm2 = _interopRequireDefault(_restockReturnForm);
	
	var _creditForm = __webpack_require__(645);
	
	var _creditForm2 = _interopRequireDefault(_creditForm);
	
	var _inventoryReturn = __webpack_require__(650);
	
	var _inventoryReturn2 = _interopRequireDefault(_inventoryReturn);
	
	var _MobileManagement = __webpack_require__(567);
	
	var _MobileManagement2 = _interopRequireDefault(_MobileManagement);
	
	var _adjustmentInventory = __webpack_require__(570);
	
	var _adjustmentInventory2 = _interopRequireDefault(_adjustmentInventory);
	
	var _rmaForm = __webpack_require__(644);
	
	var _rmaForm2 = _interopRequireDefault(_rmaForm);
	
	var _rma = __webpack_require__(643);
	
	var _rma2 = _interopRequireDefault(_rma);
	
	var _login = __webpack_require__(554);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _signup = __webpack_require__(556);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	var _require_auth = __webpack_require__(555);
	
	var _require_auth2 = _interopRequireDefault(_require_auth);
	
	var _userBased_auth = __webpack_require__(557);
	
	var _userBased_auth2 = _interopRequireDefault(_userBased_auth);
	
	var _reducers = __webpack_require__(708);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _reduxObservable = __webpack_require__(204);
	
	var _reduxThunk = __webpack_require__(825);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _auth_actions = __webpack_require__(79);
	
	var _type = __webpack_require__(14);
	
	var _ch = __webpack_require__(754);
	
	var _ch2 = _interopRequireDefault(_ch);
	
	var _en = __webpack_require__(755);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _MMdriver = __webpack_require__(602);
	
	var _MMdriver2 = _interopRequireDefault(_MMdriver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Init translation system
	/*!
	 *
	 * TruckxiSCM
	 *
	 * Version: 0.0.2
	 * Author: @geno_diaz
	 * E-mail: GenoCDiaz@gmail.com
	 *
	 */
	
	(0, _localize2.default)();
	// Init css loader (for themes)
	
	
	// Import Translation files
	
	// import createLogger from 'redux-logger';
	
	(0, _loadCss2.default)();
	
	var epicMiddleware = (0, _reduxObservable.createEpicMiddleware)(_reducers.rootEpic);
	
	var configureStore = function configureStore(state, middleware) {
	                        var response = (0, _redux.createStore)(_reducers2.default, state, middleware);
	
	                        return response;
	};
	
	var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
	// const middlewares = [reduxThunk, createLogger({ collapsed: true })];
	var middlewares = [_reduxThunk2.default, epicMiddleware];
	var middleware = composeEnhancers(_redux.applyMiddleware.apply(undefined, middlewares));
	
	// const middlewares = [thunk, router, ReduxPromise];
	
	var store = configureStore({}, middleware);
	// const createStoreWithMiddleware = applyMiddleware(middleware)();
	// const store = createStoreWithMiddleware(reducers);
	
	var translationsObject = {};
	translationsObject.en = _en2.default;
	translationsObject.ch = _ch2.default;
	(0, _reactReduxI18n.syncTranslationWithStore)(store);
	store.dispatch((0, _reactReduxI18n.loadTranslations)(translationsObject));
	store.dispatch((0, _reactReduxI18n.setLocale)('en'));
	
	// Check
	var token = localStorage.getItem('token');
	var user = localStorage.getItem('userType');
	// if (token) {
	//     store.dispatch(checkStatues());
	// }
	
	var Root = _react2.default.createClass({
	                        displayName: 'Root',
	
	                        // Refresh function, not suggested to be used, may cause some issue.
	
	                        childContextTypes: {
	                                                refresh: _react2.default.PropTypes.func
	                        },
	
	                        getChildContext: function getChildContext() {
	                                                var _this = this;
	
	                                                return {
	                                                                        refresh: function refresh() {
	                                                                                                return _this.forceUpdate();
	                                                                        }
	                                                };
	                        },
	                        render: function render() {
	                                                return _react2.default.createElement(
	                                                                        _reactRedux.Provider,
	                                                                        { store: store },
	                                                                        _react2.default.createElement(
	                                                                                                _reactRouter.Router,
	                                                                                                {
	                                                                                                                        history: _reactRouter.browserHistory
	                                                                                                },
	                                                                                                _react2.default.createElement(
	                                                                                                                        _reactRouter.Route,
	                                                                                                                        { path: '/', component: (0, _require_auth2.default)(_Base2.default) },
	                                                                                                                        _react2.default.createElement(_reactRouter.IndexRoute, { component: (0, _require_auth2.default)(_generalDashboardRevision2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'dashboard', component: (0, _require_auth2.default)(_generalDashboardRevision2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'generaldashboard', component: (0, _require_auth2.default)(_generalDashboardRevision2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchaseManagerDashboard', component: (0, _require_auth2.default)(_purchaseManagerDashboard2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'presidentDashboard', component: (0, _require_auth2.default)(_presidentDashboard2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'categoryAnalysis', component: (0, _require_auth2.default)(_CategoryAnalysis2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'warehouse', component: (0, _require_auth2.default)(_warehouseDashboard2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'sales', component: (0, _require_auth2.default)(_salesDashboard2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'users', component: (0, _require_auth2.default)(_users2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'users/new', component: (0, _require_auth2.default)(_userForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'users/:id', component: (0, _require_auth2.default)(_userForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'customers', component: (0, _require_auth2.default)(_customers2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'customers/new', component: (0, _require_auth2.default)(_customerForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'customers/:id', component: (0, _require_auth2.default)(_customerForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'products', component: (0, _require_auth2.default)(_products2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'products/new', component: (0, _require_auth2.default)(_productForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'products/groups', component: (0, _require_auth2.default)(_groups2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'products/categories', component: (0, _require_auth2.default)(_categories2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'products/:id', component: (0, _require_auth2.default)(_productForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'vendors', component: (0, _require_auth2.default)(_vendors2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'vendors/new', component: (0, _require_auth2.default)(_vendorDetailForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'vendors/:id', component: (0, _require_auth2.default)(_vendorDetailForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'agents', component: (0, _require_auth2.default)(_agents2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'agents/new', component: (0, _require_auth2.default)(_agentForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'agents/:id', component: (0, _require_auth2.default)(_agentForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'priceLevel', component: (0, _require_auth2.default)(_priceLevel2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'paymentTerms', component: (0, _require_auth2.default)(_paymentTerms2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchase', component: (0, _require_auth2.default)(_purchaseDashboard2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchaseQuote', component: (0, _require_auth2.default)(_purchaseQuoteList2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchaseQuote/new', component: (0, _require_auth2.default)(_purchaseOrderForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchaseQuote/:id', component: (0, _require_auth2.default)(_purchaseOrderForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchaseTemplate', component: (0, _require_auth2.default)(_purchaseTemplateList2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchaseTemplate/new', component: (0, _require_auth2.default)(_purchaseOrderForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchaseTemplate/:id', component: (0, _require_auth2.default)(_purchaseOrderForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchaseSchedule', component: (0, _require_auth2.default)(_purchaseScheduleList2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchaseSchedule/new', component: (0, _require_auth2.default)(_purchaseScheduleForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchaseSchedule/:id', component: (0, _require_auth2.default)(_purchaseScheduleForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchaseReturn', component: (0, _require_auth2.default)(_purchaseReturnList2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchaseReturn/new', component: (0, _require_auth2.default)(_purchaseReturnForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchaseReturn/newCredit', component: (0, _require_auth2.default)(_purchaseReturnForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchaseReturn/:id', component: (0, _require_auth2.default)(_purchaseReturnForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchaseOrder', component: (0, _require_auth2.default)(_purchaseOrderList2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchaseOrder/new', component: (0, _require_auth2.default)(_purchaseOrderForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchaseOrder/:id', component: (0, _require_auth2.default)(_purchaseOrderForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchasingPerformanceReport', component: (0, _require_auth2.default)(_purchasingPerformance2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'priceAdjustmentReport', component: (0, _require_auth2.default)(_priceAdjustment2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'priceAdjustmentDetail', component: (0, _require_auth2.default)(_priceAdjustmentDetail2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchasePayment', component: (0, _require_auth2.default)(_purchasePaymentList2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchasePayment/:id', component: (0, _require_auth2.default)(_purchasePaymentDetail2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchasePivotChart', component: (0, _require_auth2.default)(_purchasePivotChart2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchasePivotChart/:id', component: (0, _require_auth2.default)(_purchasePivotChartDetail2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchasePivotChart/new', component: (0, _require_auth2.default)(_purchasePivotChartDetail2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchaseReferenceReport', component: (0, _require_auth2.default)(_purchaseReference2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'salesOrders', component: (0, _require_auth2.default)(_salesOrders2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'salesOrders/new', component: (0, _require_auth2.default)(_salesOrderForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'salesOrders/:id', component: (0, _require_auth2.default)(_salesOrderForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'outboundOrders', component: (0, _require_auth2.default)(_salesOrders2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'outboundOrders/new', component: (0, _require_auth2.default)(_salesOrderForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'outboundOrders/:id', component: (0, _require_auth2.default)(_salesOrderForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'mobileSalesOrders', component: (0, _require_auth2.default)(_salesOrders2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'mobileSalesOrders/new', component: (0, _require_auth2.default)(_salesOrderForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'mobileSalesOrders/:id', component: (0, _require_auth2.default)(_salesOrderForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'wholesale', component: (0, _require_auth2.default)(_wholesale2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'wholesale/new', component: (0, _require_auth2.default)(_wholesaleOrderForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'favoriteList', component: (0, _require_auth2.default)(_favoriteList2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'groupList', component: (0, _require_auth2.default)(_groupList2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'promotions', component: (0, _require_auth2.default)(_PromotionsPage2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'salesInvoice', component: (0, _require_auth2.default)(_salesInvoice2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'salesInvoice/:id', component: (0, _require_auth2.default)(_editSalesInvoice2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'shipToOrders', component: (0, _require_auth2.default)(_shipToOrders2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'preOrders', component: (0, _require_auth2.default)(_preOrders2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'shipFromOrders', component: (0, _require_auth2.default)(_shipFromOrders2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'otherService', component: (0, _require_auth2.default)(_otherService2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'pos', component: _report.POSPicture }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'posReport', component: (0, _require_auth2.default)(_posReport2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'posOrders', component: (0, _require_auth2.default)(_posOrders2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'posOrders/:id', component: (0, _require_auth2.default)(_viewPosOrder2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'posCredits', component: (0, _require_auth2.default)(_posCredits2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'SalesPerformanceReport', component: (0, _require_auth2.default)(_salesPerformance2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'posHolds', component: (0, _require_auth2.default)(_posHolds2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories', component: (0, _require_auth2.default)(_inventories2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories/detail', component: (0, _require_auth2.default)(_inventoryDetail2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories/detail/:id', component: (0, _require_auth2.default)(_inventoryDetail2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories/lowStock', component: (0, _require_auth2.default)(_inventoryLowStock2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories/expired', component: (0, _require_auth2.default)(_inventoryExpired2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories/repackage', component: (0, _require_auth2.default)(_inventoryRepackages2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories/repackage/new', component: (0, _require_auth2.default)(_inventoryRepackageForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories/repackage/:id', component: (0, _require_auth2.default)(_inventoryRepackageForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories/convert', component: (0, _require_auth2.default)(_inventoryConverts2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories/convert/new', component: (0, _require_auth2.default)(_inventoryConvertForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories/convert/:id', component: (0, _require_auth2.default)(_inventoryConvertForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories/receive', component: (0, _require_auth2.default)(_receiveList2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories/receive/:id', component: (0, _require_auth2.default)(_receiveForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories/receive/new', component: (0, _require_auth2.default)(_receiveForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories/receiveHistory', component: (0, _require_auth2.default)(_receiveHistoryList2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories/receiveHistory/:id', component: (0, _require_auth2.default)(_receiveHistoryDetail2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories/relocation', component: (0, _require_auth2.default)(_inventoryRelocations2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories/relocation/new', component: (0, _require_auth2.default)(_inventoryRelocationForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories/relocation/:id', component: (0, _require_auth2.default)(_inventoryRelocationForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories/relocation/inbound', component: (0, _require_auth2.default)(_inventoryRelocationFromInbound2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories/adjustment', component: (0, _require_auth2.default)(_inventoryAdjustments2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories/adjustment/new', component: (0, _require_auth2.default)(_inventoryAdjustmentForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventories/adjustment/:id', component: (0, _require_auth2.default)(_inventoryAdjustmentForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'scrapRecords', component: (0, _require_auth2.default)(_scrapRecords2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'scrapRecords/new', component: (0, _require_auth2.default)(_scrapRecordForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'scrapRecords/:id', component: (0, _require_auth2.default)(_scrapRecordForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'putAway', component: (0, _require_auth2.default)(_putAway2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'putAway/new', component: (0, _require_auth2.default)(_putAwayForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'putAway/inbound', component: (0, _require_auth2.default)(_inboundForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'putAway/:id', component: (0, _require_auth2.default)(_putAwayForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'warehouses', component: (0, _require_auth2.default)(_warehouses2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'warehouses/form', component: (0, _require_auth2.default)(_warehouseForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'warehouses/detail', component: (0, _require_auth2.default)(_warehouseDetail2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'zoneForm', component: (0, _require_auth2.default)(_zoneForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'zoneDetail', component: (0, _require_auth2.default)(_zoneDetail2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'binForm', component: (0, _require_auth2.default)(_binForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'binDetail', component: (0, _require_auth2.default)(_binDetail2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'productConvertReport', component: (0, _require_auth2.default)(_productConvert2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'productConvertReport/new', component: (0, _require_auth2.default)(_productConvertDetail2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'adjustmentInventory', component: _adjustmentInventory2.default }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'mobileManagement', component: (0, _require_auth2.default)(_MobileManagement2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'rmaForm', component: (0, _require_auth2.default)(_rmaForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'customerRMA', component: (0, _require_auth2.default)(_rma2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'customerRMA/new', component: (0, _require_auth2.default)(_rmaForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'dispatchRMA', component: (0, _require_auth2.default)(_rma2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'dispatchRMA/:id', component: (0, _require_auth2.default)(_rmaForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'customerRMA/:id', component: (0, _require_auth2.default)(_rmaForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'shipping', component: (0, _require_auth2.default)(_shipping2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'routing', component: (0, _require_auth2.default)(_routing2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'autorouting', component: (0, _require_auth2.default)(_AutoRouting2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'editRoutes', component: (0, _require_auth2.default)(_editRoutes2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'drivers', component: (0, _require_auth2.default)(_Drivers2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'customerReturn', component: (0, _require_auth2.default)(_customerReturn2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'customerReturn/new', component: (0, _require_auth2.default)(_customerReturnForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'customerReturn/:id', component: (0, _require_auth2.default)(_customerReturnForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'customerIssueCredit', component: (0, _require_auth2.default)(_customerIssueCredit2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'restockReturn/:id', component: (0, _require_auth2.default)(_restockReturnForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'customerCredit/new', component: (0, _require_auth2.default)(_creditForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'customerCredit/:id', component: (0, _require_auth2.default)(_creditForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'inventoryReturn', component: (0, _require_auth2.default)(_inventoryReturn2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'AR', component: (0, _require_auth2.default)(_ARList2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'AR/new', component: (0, _require_auth2.default)(_createAR2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'AR/:id', component: (0, _require_auth2.default)(_editAR2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'AP', component: (0, _require_auth2.default)(_APList2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'AP/new', component: (0, _require_auth2.default)(_createAP2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'AP/:id', component: (0, _require_auth2.default)(_editAP2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'arSalesInvoice', component: (0, _require_auth2.default)(_salesInvoice2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'salesInvoicePayment', component: (0, _require_auth2.default)(_SIPaymentList2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'salesInvoicePayment/:id', component: (0, _require_auth2.default)(_SIPaymentForm2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'generalReport', component: (0, _require_auth2.default)(_generalReport2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'customerStatement', component: (0, _require_auth2.default)(_customerStatement2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'customerStatementMain', component: (0, _require_auth2.default)(_customerStatementMain2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'vendorStatement', component: (0, _require_auth2.default)(_vendorStatement2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'vendorStatementMain', component: (0, _require_auth2.default)(_vendorStatementMain2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'mobileCustomerStatement', component: (0, _require_auth2.default)(_mobileCustomerStatement2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'cityReport', component: (0, _require_auth2.default)(_cityReport2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'userManagement', component: (0, _require_auth2.default)(_userManagement2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'userManagement/:id', component: (0, _require_auth2.default)(_userManagementDetail2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'userManagement/new', component: (0, _require_auth2.default)(_userManagementDetail2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'userManagement/mobileUserMessages/:id', component: (0, _require_auth2.default)(_mobileUserMessagesManagement2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'userManagement/mobileUserProducts/:id', component: (0, _require_auth2.default)(_mobileUserProducts2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'groupManagement', component: (0, _require_auth2.default)(_groupManagement2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'groupManagement/new', component: (0, _require_auth2.default)(_groupManagementDetail2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'groupManagement/:id', component: (0, _require_auth2.default)(_groupManagementDetail2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'taxManagement', component: (0, _require_auth2.default)(_taxManagement2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'currencyManagement', component: (0, _require_auth2.default)(_currencyManagement2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'agentManagement', component: (0, _require_auth2.default)(_AgentManagement2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'actionLog', component: (0, _require_auth2.default)(_ActionLog2.default) }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'priceAdjustment', component: _report.PriceAdjustment }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'productConvert', component: _report.ProductConvert }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchasePivot', component: _report.PurchasePivot }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchaseReference', component: _report.PurchaseReference }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'purchasePerformance', component: _report.PurchasePerformance }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'salesPerformance', component: _report.SalesPerformance }),
	                                                                                                                        _react2.default.createElement(_reactRouter.Route, { path: 'mmdriver', component: _MMdriver2.default })
	                                                                                                ),
	                                                                                                _react2.default.createElement(_reactRouter.Route, { path: '/login', component: _login2.default }),
	                                                                                                _react2.default.createElement(_reactRouter.Route, { path: '/signup', component: _signup2.default })
	                                                                        )
	                                                );
	                        }
	});
	
	_reactDom2.default.render(_react2.default.createElement(Root, null), document.getElementById('app'));
	;
	
	var _temp = function () {
	                        if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	                                                return;
	                        }
	
	                        __REACT_HOT_LOADER__.register(translationsObject, 'translationsObject', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/App.jsx');
	
	                        __REACT_HOT_LOADER__.register(epicMiddleware, 'epicMiddleware', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/App.jsx');
	
	                        __REACT_HOT_LOADER__.register(configureStore, 'configureStore', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/App.jsx');
	
	                        __REACT_HOT_LOADER__.register(composeEnhancers, 'composeEnhancers', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/App.jsx');
	
	                        __REACT_HOT_LOADER__.register(middlewares, 'middlewares', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/App.jsx');
	
	                        __REACT_HOT_LOADER__.register(middleware, 'middleware', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/App.jsx');
	
	                        __REACT_HOT_LOADER__.register(store, 'store', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/App.jsx');
	
	                        __REACT_HOT_LOADER__.register(token, 'token', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/App.jsx');
	
	                        __REACT_HOT_LOADER__.register(user, 'user', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/App.jsx');
	
	                        __REACT_HOT_LOADER__.register(Root, 'Root', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/App.jsx');
	}();

	;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchMMDriversByTime = fetchMMDriversByTime;
	exports.editDriverInfomation = editDriverInfomation;
	
	var _url = __webpack_require__(20);
	
	var _type = __webpack_require__(14);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchMMDriversSuccess(data) {
	  return {
	    type: _type.FETCH_MMDRIVERS,
	    payload: data
	  };
	}
	
	function fetchMMDriversByTime(from, to) {
	  return function (dispatch) {
	    _axios2.default.get(_url.MMDRIVERS + '?update_time__gt=' + from + '&update_time__lt=' + to, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (res) {
	      dispatch(fetchMMDriversSuccess(res.data));
	    }, function (err) {
	      // if (err.status === 500 || err.status === 404) {
	      //  err.data = DEFAULT_ERROR;
	      // }
	    });
	  };
	}
	
	function editDriverInfomation(data) {
	  return function (dispatch) {
	    _axios2.default.put('' + _url.MMDRIVERS + data.driver_id, data, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (res) {
	      window.location.reload(false);
	    }).catch(function (err) {
	      console.log('err catching', err);
	    });
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchMMDriversSuccess, 'fetchMMDriversSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mmdriver-actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchMMDriversByTime, 'fetchMMDriversByTime', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mmdriver-actions.js');
	
	  __REACT_HOT_LOADER__.register(editDriverInfomation, 'editDriverInfomation', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/mmdriver-actions.js');
	}();

	;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.requestPreOrders = requestPreOrders;
	exports.fetchPreOrdersSuccess = fetchPreOrdersSuccess;
	exports.fetchPreOrdersFailure = fetchPreOrdersFailure;
	exports.fetchPreOrders = fetchPreOrders;
	exports.selectSalesOrder = selectSalesOrder;
	exports.resetCurrentSalesOrder = resetCurrentSalesOrder;
	exports.fetchSalesOrderDetail = fetchSalesOrderDetail;
	exports.requestSalesOrderDetail = requestSalesOrderDetail;
	exports.fetchSalesOrderDetailSuccess = fetchSalesOrderDetailSuccess;
	exports.fetchSalesOrderDetailFailure = fetchSalesOrderDetailFailure;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _cleanDates = __webpack_require__(22);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _root_url = __webpack_require__(9);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function requestPreOrders() {
	  return {
	    type: _type.REQUEST_PRE_ORDERS
	  };
	}
	
	function fetchPreOrdersSuccess(preOrders) {
	  return {
	    type: _type.FETCH_PRE_ORDERS_SUCCESS,
	    payload: preOrders
	  };
	}
	
	function fetchPreOrdersFailure(error) {
	  return {
	    type: _type.FETCH_PRE_ORDERS_FAILURE,
	    payload: error
	  };
	}
	
	function fetchPreOrders() {
	  return function (dispatch) {
	    dispatch(requestPreOrders());
	    return _axios2.default.get(_url.SALE_PRE_ORDER_SEARCH_URL, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchPreOrdersSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchPreOrdersFailure(err));
	    });
	  };
	}
	
	function selectSalesOrder(salesOrder) {
	  return {
	    type: _type.SELECT_SALES_ORDER,
	    payload: salesOrder
	  };
	}
	
	function resetCurrentSalesOrder() {
	  return {
	    type: _type.RESET_CURRENT_SALES_ORDER
	  };
	}
	
	// Fetch the detail page.
	function fetchSalesOrderDetail(salesOrder_id, route) {
	  var url = route == 'salesOrders' ? _url.SALES_ORDERS_URL : _url.MOBILE_SALES_ORDERS_URL;
	  return function (dispatch) {
	    dispatch(requestSalesOrderDetail());
	    return _axios2.default.get(url + '?pk=' + salesOrder_id, {
	      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch(fetchSalesOrderDetailSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(fetchSalesOrderDetailFailure(err));
	    });
	  };
	}
	
	function requestSalesOrderDetail() {
	  return {
	    type: _type.REQUEST_SALES_ORDER_DETAIL
	  };
	}
	
	function fetchSalesOrderDetailSuccess(salesOrderDetail) {
	  salesOrderDetail = salesOrderDetail.data;
	  // The date data fetched is in the form of string, which needs to be modified into Date type
	  if (salesOrderDetail.OrderDate) salesOrderDetail.OrderDate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.OrderDate);
	  if (salesOrderDetail.ETADate) salesOrderDetail.ETADate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.ETADate);
	  if (salesOrderDetail.ReceivedDate) salesOrderDetail.ReceivedDate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.ReceivedDate);
	  if (salesOrderDetail.DispatchDate) salesOrderDetail.DispatchDate = (0, _cleanDates.convertUtcDate)(salesOrderDetail.DispatchDate);
	  return {
	    type: _type.FETCH_SALES_ORDER_DETAIL_SUCCESS,
	    payload: salesOrderDetail
	  };
	}
	
	function fetchSalesOrderDetailFailure(error) {
	  return {
	    type: _type.FETCH_SALES_ORDER_DETAIL_FAILURE,
	    payload: error
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestPreOrders, 'requestPreOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/preOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPreOrdersSuccess, 'fetchPreOrdersSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/preOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPreOrdersFailure, 'fetchPreOrdersFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/preOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPreOrders, 'fetchPreOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/preOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(selectSalesOrder, 'selectSalesOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/preOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(resetCurrentSalesOrder, 'resetCurrentSalesOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/preOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderDetail, 'fetchSalesOrderDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/preOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(requestSalesOrderDetail, 'requestSalesOrderDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/preOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderDetailSuccess, 'fetchSalesOrderDetailSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/preOrders_actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchSalesOrderDetailFailure, 'fetchSalesOrderDetailFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/preOrders_actions.js');
	}();

	;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateSalesInvoicePayment = updateSalesInvoicePayment;
	exports.requestUpdateSalesInvoicePayment = requestUpdateSalesInvoicePayment;
	exports.updateSalesInvoicePaymentSuccess = updateSalesInvoicePaymentSuccess;
	exports.requestUpdateSalesInvoicePaymentFailure = requestUpdateSalesInvoicePaymentFailure;
	exports.resetSalesInvoicePayment = resetSalesInvoicePayment;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function updateSalesInvoicePayment(pk, _ref) {
	  var Note = _ref.Note,
	      PaymentStatusRecord = _ref.PaymentStatusRecord;
	
	  return function (dispatch) {
	    var token = localStorage.getItem('token');
	    dispatch(requestUpdateSalesInvoicePayment());
	    return (0, _axios2.default)({
	      method: 'put',
	      url: '' + _url.SALES_INVOICE_PAYMENT_URL + pk + '/payment/',
	      data: { Note: Note, PaymentStatusRecord: PaymentStatusRecord },
	      headers: { Authorization: 'Bearer ' + token }
	    }).then(function (response) {
	      dispatch(updateSalesInvoicePaymentSuccess(response));
	    }, function (err) {
	      if (err.status === 500 || err.status === 404) {
	        err.data = _constants.DEFAULT_ERROR;
	      }
	      dispatch(requestUpdateSalesInvoicePaymentFailure(err));
	    });
	  };
	}
	
	function requestUpdateSalesInvoicePayment() {
	  return {
	    type: _type.UPDATE_SALES_INVOICE_PAYMENT
	  };
	}
	
	function updateSalesInvoicePaymentSuccess(payload) {
	  return {
	    type: _type.UPDATE_SALES_INVOICE_PAYMENT_SUCCESS,
	    payload: payload
	  };
	}
	
	function requestUpdateSalesInvoicePaymentFailure(payload) {
	  return {
	    type: _type.UPDATE_SALES_INVOICE_PAYMENT_FAILURE,
	    payload: payload
	  };
	}
	
	function resetSalesInvoicePayment() {
	  return {
	    type: _type.RESET_SALES_INVOICE_PAYMENT
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(updateSalesInvoicePayment, 'updateSalesInvoicePayment', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoicePayment_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(requestUpdateSalesInvoicePayment, 'requestUpdateSalesInvoicePayment', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoicePayment_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(updateSalesInvoicePaymentSuccess, 'updateSalesInvoicePaymentSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoicePayment_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(requestUpdateSalesInvoicePaymentFailure, 'requestUpdateSalesInvoicePaymentFailure', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoicePayment_actions.jsx');
	
	  __REACT_HOT_LOADER__.register(resetSalesInvoicePayment, 'resetSalesInvoicePayment', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/salesInvoicePayment_actions.jsx');
	}();

	;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.editTrackingNote = editTrackingNote;
	exports.fetchTrackingNote = fetchTrackingNote;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _type = __webpack_require__(14);
	
	var _url = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function editTrackingNote(orderId, data) {
	    return function (dispatch) {
	        (0, _axios2.default)({
	            method: 'post',
	            data: {
	                notes: data
	            },
	            url: '' + _url.TRACKING_NOTE_URL + orderId,
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	            // alert(JSON.stringify(response));
	            dispatch(editTrackingNoteSuccess(response));
	        }, function (err) {
	            if (err.status === 500 || err.status === 404 || err.status === 400) {
	                alert(JSON.stringify(err.data));
	            }
	        });
	    };
	}
	
	function editTrackingNoteSuccess(response) {
	    return {
	        type: _type.EDIT_TRACKING_SUCCESS,
	        payload: response
	    };
	}
	
	function fetchTrackingNote(orderId) {
	    return function (dispatch) {
	        var id = orderId;
	        _axios2.default.get('' + _url.TRACKING_NOTE_URL + id, {
	            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (res) {
	            dispatch(fetchTrackingNoteSuccess(res.data.records));
	        }).catch(function (err) {
	            console.log(err);
	            // alert(JSON.stringify(err.data));
	        });
	    };
	}
	
	function fetchTrackingNoteSuccess(data) {
	    return {
	        type: _type.FETCH_TRACKING_SUCCESS,
	        payload: data
	    };
	}
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(editTrackingNote, 'editTrackingNote', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/tracking_actions.js');
	
	    __REACT_HOT_LOADER__.register(editTrackingNoteSuccess, 'editTrackingNoteSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/tracking_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchTrackingNote, 'fetchTrackingNote', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/tracking_actions.js');
	
	    __REACT_HOT_LOADER__.register(fetchTrackingNoteSuccess, 'fetchTrackingNoteSuccess', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/actions/tracking_actions.js');
	}();

	;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _inputField = __webpack_require__(16);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _selection = __webpack_require__(21);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _datePicker = __webpack_require__(27);
	
	var _rowRenderer = __webpack_require__(64);
	
	var _rowRenderer2 = _interopRequireDefault(_rowRenderer);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _dateFormat = __webpack_require__(39);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getBsStyle = function getBsStyle(input, value) {
	  return input == value ? "success" : "primary";
	};
	
	var renderRadio = function renderRadio(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-6' },
	      _react2.default.createElement(
	        'label',
	        null,
	        _react2.default.createElement('input', _extends({}, props.input, {
	          type: 'radio',
	          value: 'waive',
	          checked: props.input.value === "waive"
	        })),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'waive' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-6' },
	      _react2.default.createElement(
	        'label',
	        null,
	        _react2.default.createElement('input', _extends({}, props.input, {
	          type: 'radio',
	          value: 'noWaive',
	          checked: props.input.value === "noWaive"
	        })),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no_waive' })
	      )
	    )
	  );
	};
	
	var renderDatePicker = function renderDatePicker(fieldName, placeholder) {
	  return _react2.default.createElement(
	    _reactBootstrap.Button,
	    { bsStyle: 'primary' },
	    _react2.default.createElement(_reduxForm.Field, { name: fieldName, placeholder: placeholder, component: _datePicker.DatePicker })
	  );
	};
	
	var renderInvoiceDateRadio = function renderInvoiceDateRadio(props) {
	  var FromDate = "FromDate";
	  var ToDate = "ToDate";
	  if (props.input.name == "InvoiceDateBySequence") {
	    FromDate = FromDate + "BySequence";
	    ToDate = ToDate + "BySequence";
	  }
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'mb-md radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, "all") },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'all-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            type: 'radio',
	            id: 'all-radio-filter',
	            className: 'statusFilterRadios',
	            value: 'all',
	            checked: props.input.value === "all"
	          })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, "range") },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'range-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            type: 'radio',
	            id: 'range-radio-filter',
	            className: 'statusFilterRadios',
	            value: 'range',
	            checked: props.input.value === "range"
	          })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'range' })
	        )
	      )
	    ),
	    props.input.value === "range" && renderDatePicker(FromDate, "Start"),
	    props.input.value === "range" && renderDatePicker(ToDate, "End")
	  );
	};
	
	var APDetail = function (_Component) {
	  _inherits(APDetail, _Component);
	
	  function APDetail() {
	    _classCallCheck(this, APDetail);
	
	    var _this = _possibleConstructorReturn(this, (APDetail.__proto__ || Object.getPrototypeOf(APDetail)).call(this));
	
	    _this.state = {
	      dirty: false,
	
	      invoices: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	      selectedInvoices: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	      invoicesBySequence: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	      unpaidAmount: 0,
	      totalAmount: 0,
	      checkAuthorizeOpen: false,
	      invoicesKey: 1,
	      action: null
	    };
	    _this.moveInvoices = _this.moveInvoices.bind(_this);
	    _this.checkAuthorize = _this.checkAuthorize.bind(_this);
	    _this.openCheckAuthorize = _this.openCheckAuthorize.bind(_this);
	    _this.closeCheckAuthorize = _this.closeCheckAuthorize.bind(_this);
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    _this.clearTable = _this.clearTable.bind(_this);
	    return _this;
	  }
	
	  _createClass(APDetail, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.context.router.routes[1].path == "AP/new") {
	        this.props.clearAPDetail();
	        this.props.setDefaultOfForm('Waive', 'noWaive', 'apDetail');
	      } else if (this.props.apDetail) {
	        var rows = [].concat(_toConsumableArray(this.props.apDetail.Invoices));
	        var invoicesBySequence = _extends({}, this.state.invoicesBySequence, { rows: rows });
	        var unpaidAmount = this.state.unpaidAmount;
	        this.props.apDetail.Invoices.map(function (r) {
	          unpaidAmount += r.UnpaidAmount;
	        });
	        var totalAmount = parseFloat(unpaidAmount) || 0;
	        this.setState.apply(this, _toConsumableArray(this.state).concat([{ invoicesBySequence: invoicesBySequence, unpaidAmount: unpaidAmount, totalAmount: totalAmount }]));
	        if (this.props.apDetail.Waive > 0) {
	          this.props.setDefaultOfForm('Waive', 'waive', 'apDetail');
	        } else {
	          this.props.setDefaultOfForm('Waive', 'noWaive', 'apDetail');
	        }
	      }
	      this.props.clearCredits();
	      this.props.fetchVendors();
	      this.props.setDefaultOfForm('InvoiceDate', 'all', 'apDetail');
	      this.props.setDefaultOfForm('InvoiceDateBySequence', 'all', 'apDetail');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.vendor_id && nextProps.vendor_id != this.props.vendor_id) {
	        var fromDate = void 0;
	        var toDate = void 0;
	        var invoiceDate = void 0;
	        if (this.state.invoicesKey == 1) {
	          fromDate = (0, _dateFormat.formatDate)(this.props.fromDate);
	          toDate = (0, _dateFormat.formatDate)(this.props.toDate);
	          invoiceDate = this.props.invoiceDate;
	        } else if (this.state.invoicesKey == 2) {
	          fromDate = (0, _dateFormat.formatDate)(this.props.fromDateBySequence);
	          toDate = (0, _dateFormat.formatDate)(this.props.toDateBySequence);
	          invoiceDate = this.props.invoiceDateBySequence;
	        }
	        this.props.fetchVendorDetail(nextProps.vendor_id.value || nextProps.vendor_id);
	        this.props.fetchAPCredits(nextProps.vendor_id.value || nextProps.vendor_id);
	        if (!this.props.apDetail) {
	          this.props.fetchAPInvoices(nextProps.vendor_id.value || nextProps.vendor_id, invoiceDate, fromDate, toDate);
	        }
	      }
	      if (nextProps.invoices && nextProps.invoices != this.props.invoices) {
	        if (this.state.invoicesKey == 1) {
	          var invoicesBySequence = _extends({}, this.state.invoicesBySequence, { rows: nextProps.invoices });
	          var totalAmount = 0;
	          nextProps.invoices.map(function (invoice) {
	            totalAmount += parseFloat(invoice.UnpaidAmount) || 0;
	          });
	          totalAmount = totalAmount.toFixed(2);
	          this.setState({ invoicesBySequence: invoicesBySequence, totalAmount: totalAmount });
	        } else if (this.state.invoicesKey == 2) {
	          var invoices = _extends({}, this.state.invoices, { rows: nextProps.invoices });
	          var selectedInvoices = _extends({}, this.state.selectedInvoices, { rows: [] });
	          this.setState({ invoices: invoices, selectedInvoices: selectedInvoices });
	        }
	      }
	      if (nextProps.invoiceDate && nextProps.invoiceDate != this.props.invoiceDate) {
	        var _fromDate = (0, _dateFormat.formatDate)(this.props.fromDate);
	        var _toDate = (0, _dateFormat.formatDate)(this.props.toDate);
	        if (this.props.vendor_id && !this.props.apDetail) {
	          this.props.fetchAPInvoices(this.props.vendor_id.value || this.props.vendor_id, nextProps.invoiceDate, _fromDate, _toDate);
	        }
	      }
	      if (nextProps.fromDate && nextProps.fromDate != this.props.fromDate) {
	        var _fromDate2 = (0, _dateFormat.formatDate)(nextProps.fromDate);
	        var _toDate2 = (0, _dateFormat.formatDate)(this.props.toDate);
	        if (this.props.vendor_id && !this.props.apDetail) {
	          this.props.fetchAPInvoices(this.props.vendor_id.value || this.props.vendor_id, this.props.invoiceDate, _fromDate2, _toDate2);
	        }
	      }
	      if (nextProps.toDate && nextProps.toDate != this.props.toDate) {
	        var _fromDate3 = (0, _dateFormat.formatDate)(this.props.fromDate);
	        var _toDate3 = (0, _dateFormat.formatDate)(nextProps.toDate);
	        if (this.props.vendor_id && !this.props.apDetail) {
	          this.props.fetchAPInvoices(this.props.vendor_id.value || this.props.vendor_id, this.props.invoiceDate, _fromDate3, _toDate3);
	        }
	      }
	      if (nextProps.invoiceDateBySequence && nextProps.invoiceDateBySequence != this.props.invoiceDateBySequence) {
	        var fromDateBySequence = (0, _dateFormat.formatDate)(this.props.fromDateBySequence);
	        var toDateBySequence = (0, _dateFormat.formatDate)(this.props.toDateBySequence);
	        if (this.props.vendor_id && !this.props.apDetail) {
	          this.props.fetchAPInvoices(this.props.vendor_id.value || this.props.vendor_id, nextProps.invoiceDateBySequence, fromDateBySequence, toDateBySequence);
	        }
	      }
	      if (nextProps.fromDateBySequence && nextProps.fromDateBySequence != this.props.fromDateBySequence) {
	        var _fromDateBySequence = (0, _dateFormat.formatDate)(nextProps.fromDateBySequence);
	        var _toDateBySequence = (0, _dateFormat.formatDate)(this.props.toDateBySequence);
	        if (this.props.vendor_id && !this.props.apDetail) {
	          this.props.fetchAPInvoices(this.props.vendor_id.value || this.props.vendor_id, this.props.invoiceDateBySequence, _fromDateBySequence, _toDateBySequence);
	        }
	      }
	      if (nextProps.toDateBySequence && nextProps.toDateBySequence != this.props.toDateBySequence) {
	        var _fromDateBySequence2 = (0, _dateFormat.formatDate)(this.props.fromDateBySequence);
	        var _toDateBySequence2 = (0, _dateFormat.formatDate)(nextProps.toDateBySequence);
	        if (this.props.vendor_id && !this.props.apDetail) {
	          this.props.fetchAPInvoices(this.props.vendor_id.value || this.props.vendor_id, this.props.invoiceDateBySequence, _fromDateBySequence2, _toDateBySequence2);
	        }
	      }
	      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess != this.props.checkPasswordSuccess) {
	        this.closeCheckAuthorize();
	        var formProps = {
	          Vendor: this.props.vendor_id,
	          TotalPayment: this.props.totalPayment,
	          Method: this.props.method,
	          CheckNum: this.props.checkNum,
	          Account: this.props.account,
	          Discount: this.props.discount,
	          Waive: this.props.waive,
	          Note: this.props.note
	        };
	        if (this.state.action == "apply") {
	          this.handleFormSubmit(formProps);
	        } else if (this.state.action == "remove") {
	          this.props.deleteAP(this.props.apDetail.Payment_id);
	        }
	      }
	    }
	  }, {
	    key: 'calculateWaiveAmount',
	    value: function calculateWaiveAmount() {
	      var discount = parseFloat(this.props.discount) || 0;
	      var totalAmount = parseFloat(this.state.totalAmount) || 0;
	      var finalAmount = (100 - discount) / 100 * totalAmount;
	      finalAmount = finalAmount.toFixed(2) || 0;
	      var totalPayment = parseFloat(this.props.totalPayment) || 0;
	      var waiveAmount = finalAmount - totalPayment;
	      waiveAmount = waiveAmount.toFixed(2);
	      return waiveAmount;
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      var waiveAmount = this.calculateWaiveAmount();
	      var rows = void 0;
	      if (this.state.invoicesKey == 1) {
	        rows = _reactDataGridAddons.Data.Selectors.getRows(this.state.invoicesBySequence);
	      } else if (this.state.invoicesKey == 2) {
	        rows = _reactDataGridAddons.Data.Selectors.getRows(this.state.selectedInvoices);
	      }
	      if (this.props.apDetail) {
	        if (!this.checkPermission("change_account_receivable")) {
	          this.props.editAP(formProps, waiveAmount, rows);
	        } else {
	          alert("You have no permission!");
	        }
	      } else {
	        this.props.createAP(formProps, waiveAmount, rows);
	      }
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(invoicesKey) {
	      if (invoicesKey == 1 && this.state.selectedInvoices.rows.length == 0) {
	        var fromDateBySequence = (0, _dateFormat.formatDate)(this.props.fromDateBySequence);
	        var toDateBySequence = (0, _dateFormat.formatDate)(this.props.toDateBySequence);
	        if (this.props.vendor_id && !this.props.apDetail) {
	          this.props.fetchAPInvoices(this.props.vendor_id.value || this.props.vendor_id, this.props.invoiceDateBySequence, fromDateBySequence, toDateBySequence);
	        }
	        this.setState({ invoicesKey: invoicesKey });
	      } else if (invoicesKey == 2 && this.state.invoicesBySequence.rows.length == 0) {
	        var fromDate = (0, _dateFormat.formatDate)(this.props.fromDate);
	        var toDate = (0, _dateFormat.formatDate)(this.props.toDate);
	        if (this.props.vendor_id && !this.props.apDetail) {
	          this.props.fetchAPInvoices(this.props.vendor_id.value || this.props.vendor_id, this.props.invoiceDate, fromDate, toDate);
	        }
	        this.setState({ invoicesKey: invoicesKey });
	      } else {
	        alert("clear current table first!");
	      }
	    }
	  }, {
	    key: 'clearTable',
	    value: function clearTable(table) {
	      if (table == "invoicesBySequence") {
	        var invoicesBySequence = _extends({}, this.state.invoicesBySequence, { rows: [] });
	        this.setState({ invoicesBySequence: invoicesBySequence, totalAmount: 0 });
	      } else if (table == "selectedInvoices") {
	        var invoicesRows = [].concat(_toConsumableArray(this.state.invoices.rows), _toConsumableArray(this.state.selectedInvoices.rows));
	        var invoices = _extends({}, this.state.invoices, { rows: invoicesRows });
	        var selectedInvoices = _extends({}, this.state.selectedInvoices, { rows: [] });
	        this.setState({ invoices: invoices, selectedInvoices: selectedInvoices, totalAmount: 0 });
	      }
	    }
	  }, {
	    key: 'checkAuthorize',
	    value: function checkAuthorize(password) {
	      this.props.checkPassword(password);
	    }
	  }, {
	    key: 'openCheckAuthorize',
	    value: function openCheckAuthorize(action) {
	      this.props.clearCheckPassword();
	      this.setState({ checkAuthorizeOpen: true, action: action });
	    }
	  }, {
	    key: 'closeCheckAuthorize',
	    value: function closeCheckAuthorize() {
	      this.setState({ checkAuthorizeOpen: false });
	    }
	  }, {
	    key: 'getVendorOptions',
	    value: function getVendorOptions(field) {
	      var vendorOptions = [];
	      this.props.vendors.map(function (vendor) {
	        vendorOptions.push({ value: vendor.Vendor_id, label: vendor[field] });
	      });
	      return vendorOptions;
	    }
	  }, {
	    key: 'getCreditOptions',
	    value: function getCreditOptions() {
	      var creditOptions = [];
	      if (this.props.credits) {
	        this.props.credits.map(function (credit) {
	          //check the field name of credits when backend finish the API
	          creditOptions.push({ value: credit.SalesReturn_id, label: credit.SRNum + ' | ' + credit.FinalPrice });
	        });
	      }
	      return creditOptions;
	    }
	  }, {
	    key: 'getBillingAddress',
	    value: function getBillingAddress() {
	      var currentVendorDetail = this.props.currentVendorDetail;
	
	      var Address1 = "";
	      var Address2 = "";
	      if (currentVendorDetail && currentVendorDetail.Billing) {
	        Address1 = currentVendorDetail.Billing.Street;
	        Address2 = currentVendorDetail.Billing.City + " " + currentVendorDetail.Billing.State + currentVendorDetail.Billing.Zip;
	      }
	      return [Address1, Address2];
	    }
	  }, {
	    key: 'moveInvoices',
	    value: function moveInvoices(invoice, from, to) {
	      var invoices = _extends({}, this.state.invoices);
	      var selectedInvoices = _extends({}, this.state.selectedInvoices);
	      var index = void 0;
	      if (from == "invoices") {
	        index = _lodash2.default.findIndex(invoices.rows, { WarehouseReceive_id: invoice.WarehouseReceive_id });
	        if (index > -1) invoices.rows.splice(index, 1);
	        index = _lodash2.default.findIndex(selectedInvoices.rows, { WarehouseReceive_id: invoice.WarehouseReceive_id });
	        if (index == -1) selectedInvoices.rows.push(invoice);
	      } else if (from == "selectedInvoices") {
	        index = _lodash2.default.findIndex(selectedInvoices.rows, { WarehouseReceive_id: invoice.WarehouseReceive_id });
	        if (index > -1) selectedInvoices.rows.splice(index, 1);
	        index = _lodash2.default.findIndex(invoices.rows, { WarehouseReceive_id: invoice.WarehouseReceive_id });
	        if (index == -1) invoices.rows.push(invoice);
	      }
	      var totalAmount = 0;
	      selectedInvoices.rows.map(function (r) {
	        totalAmount += parseFloat(r.UnpaidAmount) || 0;
	      });
	      this.setState({ invoices: invoices, selectedInvoices: selectedInvoices, totalAmount: totalAmount });
	    }
	  }, {
	    key: 'renderVendors',
	    value: function renderVendors() {
	      if (this.props.vendorsIsLoading && !this.props.vendorsError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.vendorsError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.vendorsError)
	        )
	      );else {
	        var vendorNameOptions = this.getVendorOptions("Name"); // Return a JSON in the format of React-Select's options
	        var vendorNumOptions = this.getVendorOptions("VendorNum");
	        var vendorPhoneOptions = this.getVendorOptions("Telephone"); // Return a JSON in the format of React-Select's options
	        var vendorDescOptions = this.getVendorOptions("Description");
	        var billingAddress = ["", ""];
	        var _props = this.props,
	            vendor_id = _props.vendor_id,
	            currentVendorDetail = _props.currentVendorDetail;
	
	        var contact = null;
	        var phone = null;
	        if (vendor_id && currentVendorDetail && currentVendorDetail.Billing) {
	          contact = currentVendorDetail.Billing.FirstName + " " + currentVendorDetail.Billing.LastName;
	          phone = currentVendorDetail.Billing.Telephone;
	          billingAddress = this.getBillingAddress();
	        }
	        var SelectionForVendor = this.props.apDetail ? _selection.DisabledSelection : _selection.Selection;
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'mb0' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 4 },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-sm-4 inlineLabel' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_no' }),
	                _react2.default.createElement(
	                  'span',
	                  { style: { color: 'red' } },
	                  '*'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 8, className: 'mb-md' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'Vendor', component: SelectionForVendor, matchPos: 'any', options: vendorNumOptions })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-sm-4 inlineLabel' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_name' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 8, className: 'mb-md' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'Vendor', component: SelectionForVendor, matchPos: 'any', options: vendorNameOptions })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 4 },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-sm-4 inlineLabel' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 8, className: 'mb-md' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'Vendor', component: SelectionForVendor, matchPos: 'any', options: vendorPhoneOptions })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-sm-4 inlineLabel' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 8, className: 'mb-md' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'Vendor', component: SelectionForVendor, matchPos: 'any', options: vendorDescOptions })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 4 },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-sm-3' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'contact' }),
	                ':'
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 9 },
	                contact
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-sm-3' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' }),
	                ':'
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 9 },
	                phone
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-sm-3' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' }),
	                ':'
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 9 },
	                billingAddress[0],
	                _react2.default.createElement('br', null),
	                billingAddress[1]
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderInvoices',
	    value: function renderInvoices() {
	      var _this2 = this;
	
	      if (this.props.invoicesIsLoading && !this.props.invoicesError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.invoicesError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.invoicesError)
	        )
	      );else {
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.invoices);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var invoices = Object.assign({}, _this2.state.invoices, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this2.setState({ invoices: invoices });
	        };
	
	        // Column difinition
	
	        var columns = [{
	          key: 'WarehouseReceiveNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_num' }),
	          width: 110,
	          resizable: true,
	          sortable: true,
	          filterable: true
	        }, {
	          key: 'PostingDate',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	          width: 90,
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          formatter: _dateFormat.DateFormatter
	        }, {
	          key: 'Amount',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'amount' }),
	          width: 80,
	          resizable: true,
	          sortable: true,
	          filterable: true
	        }, {
	          key: 'UnpaidAmount',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' }),
	          width: 80,
	          resizable: true,
	          sortable: true,
	          filterable: true
	        }];
	
	        return _react2.default.createElement(
	          'div',
	          { style: { maxWidth: '100%' }, id: 'APDetail-dataGrid1' },
	          _react2.default.createElement(_reactDataGrid2.default, {
	            rowRenderer: _react2.default.createElement(_rowRenderer2.default, {
	              onDoubleClick: this.moveInvoices,
	              from: 'invoices',
	              to: 'selectedInvoices'
	            }),
	            onGridSort: handleGridSort,
	            columns: columns,
	            rowHeight: 25,
	            minHeight: 390,
	            rowGetter: rowGetter,
	            rowsCount: getSize()
	          })
	        );
	      }
	    }
	  }, {
	    key: 'renderSelectedInvoices',
	    value: function renderSelectedInvoices() {
	      var _this3 = this;
	
	      // if (this.props.vendorsIsLoading && !this.props.vendorsError) return <Spinner/>
	      // else if (this.props.vendorsError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.vendorsError)}</div></ContentWrapper>
	      // else {
	      // Parameters of the react-data-grid
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.selectedInvoices);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var selectedInvoices = Object.assign({}, _this3.state.selectedInvoices, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this3.setState({ selectedInvoices: selectedInvoices });
	      };
	
	      // Column difinition
	
	      var columns = [{
	        key: 'WarehouseReceiveNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_num' }),
	        width: 110,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'PostingDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	        width: 90,
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'Amount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'amount' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'UnpaidAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        'div',
	        { style: { maxWidth: '100%' }, id: 'APDetail-dataGrid2' },
	        _react2.default.createElement(_reactDataGrid2.default, {
	          rowRenderer: _react2.default.createElement(_rowRenderer2.default, {
	            onDoubleClick: this.moveInvoices,
	            from: 'selectedInvoices',
	            to: 'invoices'
	          }),
	          onGridSort: handleGridSort,
	          columns: columns,
	          rowHeight: 25,
	          minHeight: 390,
	          rowGetter: rowGetter,
	          rowsCount: getSize()
	        })
	      );
	      // }
	    }
	  }, {
	    key: 'renderInvoicesBySequence',
	    value: function renderInvoicesBySequence() {
	      var _this4 = this;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.invoicesBySequence);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var invoicesBySequence = Object.assign({}, _this4.state.invoicesBySequence, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this4.setState({ invoicesBySequence: invoicesBySequence });
	      };
	
	      // Column difinition
	
	      var columns = [{
	        key: 'WarehouseReceiveNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_num' }),
	        width: 110,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'PostingDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	        width: 90,
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'Amount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'amount' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'UnpaidAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        'div',
	        { style: { maxWidth: '100%' }, id: 'APDetail-dataGrid3' },
	        _react2.default.createElement(_reactDataGrid2.default, {
	          onGridSort: handleGridSort,
	          columns: columns,
	          rowHeight: 25,
	          minHeight: 390,
	          rowGetter: rowGetter,
	          rowsCount: getSize()
	        })
	      );
	    }
	  }, {
	    key: 'renderCheckNum',
	    value: function renderCheckNum() {
	      return _react2.default.createElement(_reduxForm.Field, { name: 'CheckNum', component: _inputField.InputField });
	    }
	  }, {
	    key: 'renderCredits',
	    value: function renderCredits() {
	      if (this.props.creditsIsLoading && !this.props.creditsError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.creditsError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.creditsError)
	        )
	      );else {
	        var creditOptions = this.getCreditOptions(); // Return a JSON in the format of React-Select's options
	        return _react2.default.createElement(_reduxForm.Field, { name: 'Credits', component: _selection.MultiSelection, options: creditOptions });
	      }
	    }
	  }, {
	    key: 'renderResponse',
	    value: function renderResponse() {
	      var _props2 = this.props,
	          apCreated = _props2.apCreated,
	          apEdited = _props2.apEdited,
	          apCreateError = _props2.apCreateError,
	          apEditError = _props2.apEditError,
	          apIsCreating = _props2.apIsCreating,
	          apIsEditing = _props2.apIsEditing;
	
	      if (apCreated || apEdited) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-success' },
	          'Success!'
	        )
	      );else if (apIsCreating && !apCreateError || apIsEditing && !apEditError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-info' },
	          '...',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reading_data' })
	        )
	      );else if (apCreateError || apEditError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          apCreateError
	        )
	      );
	    }
	  }, {
	    key: 'checkPermission',
	    value: function checkPermission(permission) {
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props3 = this.props,
	          handleSubmit = _props3.handleSubmit,
	          apCreated = _props3.apCreated,
	          apEdited = _props3.apEdited,
	          apCreateError = _props3.apCreateError,
	          apEditError = _props3.apEditError,
	          apIsCreating = _props3.apIsCreating,
	          apIsEditing = _props3.apIsEditing;
	
	      var PaymentMethodOptions = [{ value: "Check", label: "Check" }, { value: "MoneyOrder", label: "Money Order" }, { value: "CompanyCheck", label: "Company Chk" }, { value: "CashCheck", label: "Cash Chk" }, { value: "PersonalCheck", label: "Personal Chk" }, { value: "WireTransfer", label: "Wire Transfer" }, { value: "CreditCard", label: "Credit Card" }, { value: "BadDebt", label: "Bad Debt" }, { value: "Credit", label: "Credit" }];
	      var accountOptions = [{ value: "Checking/Saving:1140-EAST WEST BANK #5883", label: "Checking/Saving:1140-EAST WEST BANK #5883" }, { value: "Checking/Saving:1130-China Trust Bank(USA)#3668", label: "Checking/Saving:1130-China Trust Bank(USA)#3668" }];
	      var paymentMethodIsCredit = this.props.method == "Credit" || this.props.method && this.props.method.value == "Credit";
	      var bySequenceTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_sequence' });
	      var byInvoicesTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_invoices' });
	      var discount = parseFloat(this.props.discount) || 0;
	      var totalAmount = parseFloat(this.state.totalAmount) || 0;
	      var finalAmount = (100 - discount) / 100 * totalAmount;
	      finalAmount = finalAmount.toFixed(2) || 0;
	      var waiveAmount = void 0;
	      if (this.props.apDetail) {
	        waiveAmount = this.props.apDetail.Waive;
	      } else {
	        waiveAmount = this.calculateWaiveAmount();
	      }
	
	      var createDialogStyle = {
	        width: '550px',
	        height: '300px',
	        marginLeft: '-15%'
	      };
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'form',
	          { method: 'get', action: '#' },
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_slashsign_ap' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ap_vendor_payment' })
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'AP-detail' },
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  type: 'button',
	                  onClick: function onClick() {
	                    _this5.context.router.push('/AP');
	                  }
	                },
	                _react2.default.createElement('em', { className: 'fa fa-close' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { id: 'vendors' },
	              this.renderVendors()
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Tabs,
	              { activeKey: this.state.invoicesKey, justified: true, onSelect: this.handleSelect },
	              _react2.default.createElement(
	                _reactBootstrap.Tab,
	                { eventKey: 1, title: bySequenceTitle },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { id: 'date-range-picker', className: 'form-horizontal' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-7' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'floatLeft' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_date' })
	                    ),
	                    _react2.default.createElement(_reduxForm.Field, { name: 'InvoiceDateBySequence', component: renderInvoiceDateRadio })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-offset-3 col-sm-2' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'mr-lg' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_balance' }),
	                      ' :',
	                      this.state.totalAmount
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'danger',
	                        className: 'floatRight',
	                        onClick: function onClick() {
	                          _this5.clearTable("invoicesBySequence");
	                        }
	                      },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'clear' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    this.renderInvoicesBySequence()
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Tab,
	                { eventKey: 2, title: byInvoicesTitle },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { id: 'date-range-picker', className: 'form-horizontal' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-7' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'floatLeft' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_date' })
	                    ),
	                    _react2.default.createElement(_reduxForm.Field, { name: 'InvoiceDate', component: renderInvoiceDateRadio })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-offset-3 col-sm-2' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'danger',
	                        className: 'floatRight',
	                        onClick: function onClick() {
	                          _this5.clearTable("selectedInvoices");
	                        }
	                      },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'clear' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 6 },
	                    this.renderInvoices()
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 6 },
	                    this.renderSelectedInvoices()
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { id: 'check-out-information' },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1 text-nowrap inlineLabel' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_method' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'asteriksReq' },
	                    '*'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Method', className: 'select-menu-drop-up', component: _selection.Selection, matchPos: 'any', options: PaymentMethodOptions })
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1 inlineLabel' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check_number' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  paymentMethodIsCredit && this.renderCredits(),
	                  !paymentMethodIsCredit && this.renderCheckNum()
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1 inlineLabel' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Discount', component: _inputField.InputField })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Waive', component: renderRadio })
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'waive_amount' }),
	                  ' :'
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1' },
	                  waiveAmount
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1 inlineLabel' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account' }),
	                  _react2.default.createElement(
	                    'span',
	                    { style: { color: 'red' } },
	                    '*'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Account', component: _inputField.InputField })
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1 text-nowrap inlineLabel' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pay_amount' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'asteriksReq' },
	                    '*'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'TotalPayment', component: _inputField.InputField })
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-offset-5 col-sm-1' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	                  ' :'
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1' },
	                  finalAmount
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { id: 'hint' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1 inlineLabel' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'hint' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 5 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Note', component: _inputField.InputField })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                { id: 'apply-and-remove-buttons' },
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'primary',
	                    type: 'button',
	                    onClick: handleSubmit(function () {
	                      _this5.openCheckAuthorize("apply");
	                    }),
	                    disabled: this.props.apDetail
	                  },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'apply' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'danger',
	                    type: 'button',
	                    onClick: function onClick() {
	                      _this5.openCheckAuthorize("remove");
	                    },
	                    disabled: !this.props.apDetail
	                  },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'remove' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              this.renderResponse()
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogStyle,
	            isVisible: this.state.checkAuthorizeOpen,
	            onCloseClicked: this.closeCheckAuthorize
	          },
	          _react2.default.createElement(_confirmActionModal2.default, {
	            'case': 'confirmPassword',
	            closeC: this.checkAuthorize,
	            checkPasswordFailure: this.props.checkPasswordFailure
	          })
	        )
	      );
	    }
	  }]);
	
	  return APDetail;
	}(_react.Component);
	
	APDetail.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = APDetail;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getBsStyle, 'getBsStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/APDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(renderRadio, 'renderRadio', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/APDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(renderDatePicker, 'renderDatePicker', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/APDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(renderInvoiceDateRadio, 'renderInvoiceDateRadio', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/APDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(APDetail, 'APDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/APDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/APDetail.jsx');
	}();

	;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _moment3 = __webpack_require__(41);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _datePicker = __webpack_require__(27);
	
	var _dateFormat = __webpack_require__(39);
	
	var _inputField = __webpack_require__(16);
	
	var _root_url = __webpack_require__(9);
	
	var _cleanDates = __webpack_require__(22);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _numberWithCommas = __webpack_require__(35);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _moment4.default)(_moment2.default);
	
	var getBsStyle = function getBsStyle(input, value) {
	  return input === value ? 'success' : 'primary';
	};
	
	var renderRadios = function renderRadios(props) {
	  var renderStartDatePicker = function renderStartDatePicker(days) {
	    if (days === '-1') {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: 'primary' },
	        _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', placeholder: 'Start', component: _datePicker.DatePicker })
	      );
	    }
	    return _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: 'primary' },
	      _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', placeholder: 'Start', component: _datePicker.DisabledDatePicker })
	    );
	  };
	  var renderEndDatePicker = function renderEndDatePicker(days) {
	    if (days === '-1') {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: 'primary' },
	        _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', placeholder: 'End', component: _datePicker.DatePicker })
	      );
	    }
	    return _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: 'primary' },
	      _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', placeholder: 'End', component: _datePicker.DisabledDatePicker })
	    );
	  };
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '1') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'today-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'today-radio-filter',
	            type: 'radio',
	            name: 'dateFilterRadios',
	            value: '1',
	            onClick: function onClick() {
	              props.fetchAP(1);
	            },
	            checked: props.input.value === '1'
	          })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'today' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '7') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'sevenDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'sevenDay-radio-filter',
	            type: 'radio',
	            name: 'dateFilterRadios',
	            value: '7',
	            onClick: function onClick() {
	              props.fetchAP(7);
	            },
	            checked: props.input.value === '7'
	          })),
	          '7 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '30') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'thirtyDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'thirtyDay-radio-filter',
	            type: 'radio',
	            name: 'dateFilterRadios',
	            value: '30',
	            onClick: function onClick() {
	              props.fetchAP(30);
	            },
	            checked: props.input.value === '30'
	          })),
	          '30 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '90') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'ninetyDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'ninetyDay-radio-filter',
	            type: 'radio',
	            name: 'dateFilterRadios',
	            value: '90',
	            onClick: function onClick() {
	              props.fetchAP(90);
	            },
	            checked: props.input.value === '90'
	          })),
	          '90 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '-1') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'dateRange-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'dateRange-radio-filter',
	            type: 'radio',
	            name: 'dateFilterRadios',
	            value: '-1',
	            checked: props.input.value === '-1'
	          })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date_range' })
	        )
	      )
	    ),
	    renderStartDatePicker(props.days),
	    renderEndDatePicker(props.days)
	  );
	};
	
	var APList = function (_Component) {
	  _inherits(APList, _Component);
	
	  function APList() {
	    _classCallCheck(this, APList);
	
	    var _this = _possibleConstructorReturn(this, (APList.__proto__ || Object.getPrototypeOf(APList)).call(this));
	
	    _this.checkAuthorize = function (password) {
	      _this.props.checkPassword(password);
	    };
	
	    _this.openCheckAuthorize = function (action) {
	      _this.props.clearCheckPassword();
	      _this.setState({ checkAuthorizeOpen: true, action: action });
	    };
	
	    _this.closeCheckAuthorize = function () {
	      _this.setState({ checkAuthorizeOpen: false });
	    };
	
	    _this.state = {
	      ap: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      apDetail: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      apOpen: false,
	      vendor: null,
	      payment_id: null,
	      title: '',
	      total: 0,
	      fromDate: '1900-01-01',
	      toDate: '3000-01-01',
	      rowsCount: 0
	    };
	    _this.fetchAP = _this.fetchAP.bind(_this);
	    _this.editAP = _this.editAP.bind(_this);
	    _this.createAP = _this.createAP.bind(_this);
	    return _this;
	  }
	
	  _createClass(APList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var fromDate = '1900-01-01';
	      var toDate = '3000-01-01';
	      var days = '7';
	      this.props.setDefaultOfForm('Days', '7', 'apList');
	      this.props.fetchAP(fromDate, toDate, days);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.ap && nextProps.ap !== this.props.ap) {
	        var ap = _extends({}, this.state.ap, { rows: nextProps.ap.Payments });
	        this.setState({ ap: ap, total: nextProps.ap.Total });
	      }
	      if (nextProps.apDetail && nextProps.apDetail !== this.props.apDetail) {
	        var apDetail = _extends({}, this.state.apDetail, { rows: nextProps.apDetail.Invoices });
	        this.setState({ apDetail: apDetail });
	      }
	      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
	        this.closeCheckAuthorize();
	        this.voidAP();
	      }
	      if (nextProps.days !== this.props.days) {
	        this.props.setDefaultOfForm('FromDate', null, 'apList');
	        this.props.setDefaultOfForm('ToDate', null, 'apList');
	      }
	      if (nextProps.fromDate && nextProps.fromDate !== this.props.fromDate) {
	        this.setState({ fromDate: nextProps.fromDate }, this.fetchAP);
	      }
	      if (nextProps.toDate && nextProps.toDate !== this.props.toDate) {
	        this.setState({ toDate: nextProps.toDate }, this.fetchAP);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.ap !== this.state.ap) {
	        this.setState({ rowsCount: _reactDataGridAddons.Data.Selectors.getRows(this.state.ap).length });
	      }
	    }
	  }, {
	    key: 'voidAP',
	    value: function voidAP() {
	      var _this2 = this;
	
	      this.state.ap.selectedRows.map(function (row) {
	        _this2.props.deleteAP(row.Payment_id).then(function () {
	          _this2.fetchAP();
	        });
	      });
	      // let newRows = this.state.ap.rows;
	      // this.state.ap.selectedRows.map(row => {
	      //   this.props.deleteAP(row.Payment_id);
	      //   newRows = newRows.filter((obj) => obj !== row);
	      //   const ap = { ...this.state.ap, rows: newRows };
	      //   this.setState({ ap });
	      // });
	    }
	  }, {
	    key: 'fetchAP',
	    value: function fetchAP(days) {
	      var fromDate = '1900-01-01';
	      var toDate = '3000-01-01';
	      if (this.state.fromDate != null) {
	        fromDate = (0, _moment2.default)(this.state.fromDate).format('YYYY-MM-DD');
	      }
	      if (this.state.toDate != null) {
	        toDate = (0, _moment2.default)(this.state.toDate).format('YYYY-MM-DD');
	      }
	      this.props.fetchAP(fromDate, toDate, days);
	    }
	  }, {
	    key: 'editAP',
	    value: function editAP() {
	      var _this3 = this;
	
	      this.props.fetchAPDetail(this.state.ap.selectedRows[0].Payment_id).then(function () {
	        _this3.context.router.push('/AP/' + _this3.state.ap.selectedRows[0].Payment_id);
	      });
	    }
	  }, {
	    key: 'createAP',
	    value: function createAP() {
	      this.props.clearAPDetail();
	      this.context.router.push('/AP/new');
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this4 = this;
	
	      if (this.props.isLoading && !this.props.error) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.error) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'something_unexpected_happened' })
	          )
	        );
	      }
	      // Parameters of the react-data-grid
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.ap);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var ap = Object.assign({}, _this4.state.ap, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this4.setState({ ap: ap });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this4.state.ap.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var ap = _extends({}, _this4.state.ap, { filters: newFilters });
	        _this4.setState({ ap: ap });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        //all filters removed
	        var ap = _extends({}, _this4.state.ap, { filters: {} });
	        _this4.setState({ ap: ap });
	      };
	
	      // Handle the row select function
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var selectedRows = [];
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	          selectedRows.push(r.row);
	        });
	        var ap = _extends({}, _this4.state.ap, { rows: newRows, selectedRows: selectedRows });
	        _this4.setState({ ap: ap });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = getRows();
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        var selectedRows = [];
	        var ap = _extends({}, _this4.state.ap, { rows: newRows, selectedRows: selectedRows });
	        _this4.setState({ ap: ap });
	      };
	
	      var onRowClick = function onRowClick(rowIdx, row) {
	        if (rowIdx > -1) {
	          _this4.props.fetchAPDetail(row.Payment_id);
	        }
	      };
	
	      // Column difinition
	
	      var columns = [{
	        key: 'APNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ap_num' }),
	        width: 110,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'PaymentDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pmt_date' }),
	        width: 90,
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'PostingDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_time' }),
	        width: 90,
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'VendorName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_name' }),
	        width: 150,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        width: 150,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'Method',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'method' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'CheckNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'TotalPayment',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'amount' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'AccountName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account' }),
	        width: 150,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'Status',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        width: 70,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'Note',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '100%' }, id: 'APList-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              onClearFilters: onClearFilters,
	              columns: columns,
	              rowHeight: 25,
	              headerRowHeight: 45,
	              minHeight: 320,
	              enableRowSelect: 'single',
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              onRowClick: onRowClick,
	              rowSelection: {
	                showCheckbox: true,
	                enableShiftSelect: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              }
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDetailTable',
	    value: function renderDetailTable() {
	      var _this5 = this;
	
	      if (this.props.apDetailIsLoading && !this.props.apDetailError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.apDetailError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'something_unexpected_happened' })
	          )
	        );
	      }
	      // Parameters of the react-data-grid
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this5.state.apDetail);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var apDetail = Object.assign({}, _this5.state.apDetail, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this5.setState({ apDetail: apDetail });
	      };
	
	      // Column difinition
	
	      var columns = [{
	        key: 'ReceiveNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_num' }),
	        width: 150,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'InvoiceNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        width: 150,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'PostingDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_date' }),
	        width: 120,
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_name' }),
	        width: 150,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        width: 150,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'UnpaidAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'Amount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'DiscountedAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount' }),
	        width: 85,
	        resizable: true,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'Note',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	        width: 150,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '100%' }, id: 'APList-dataGrid2' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              onGridSort: handleGridSort,
	              columns: columns,
	              rowHeight: 25,
	              minHeight: 220,
	              rowGetter: rowGetter,
	              rowsCount: getSize()
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderExportButton',
	    value: function renderExportButton() {
	      var days = this.props.days;
	      var _props = this.props,
	          f = _props.fromDate,
	          t = _props.toDate;
	
	      days = days || 7;
	
	      var _toFromDates = (0, _cleanDates.toFromDates)(days, f, t),
	          fromDate = _toFromDates.fromDate,
	          toDate = _toFromDates.toDate;
	
	      var params = 'PaymentDate__gte=' + fromDate + '&PaymentDate__lte=' + toDate;
	      var token = localStorage.getItem('token');
	      var url = _root_url.ROOT_URL + '/v1/ap/payment/export/?' + params + '&Bearer=' + token;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          href: url
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var shouldRemoveDisable = this.state.ap.selectedRows.length !== 1;
	      var createDialogStyle = {
	        width: '550px',
	        height: '300px',
	        marginLeft: '-15%'
	      };
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_slashsign_ap' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: true },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account_payable_payment_report' })
	          )
	        ),
	        ' ',
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          null,
	          this.renderExportButton()
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'AP' },
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            { id: 'date-range-picker', className: 'form-horizontal' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 1 },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_date' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'colon' },
	                    ':'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 11 },
	                _react2.default.createElement(_reduxForm.Field, { name: 'Days', component: renderRadios, fetchAP: this.fetchAP, days: this.props.days })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            { id: 'ap-table', className: 'position-relative table-collapse-fix' },
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { className: 'table-buttons' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  onClick: this.createAP,
	                  disabled: !(0, _permissions2.default)('add_account_payable')
	                },
	                _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'warning',
	                  onClick: this.editAP,
	                  disabled: !this.state.ap.selectedRows || this.state.ap.selectedRows.length !== 1 || !(0, _permissions2.default)('change_account_payable')
	                },
	                _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  type: 'button',
	                  onClick: function onClick() {
	                    _this6.openCheckAuthorize('remove');
	                  },
	                  disabled: shouldRemoveDisable || !(0, _permissions2.default)('delete_account_payable')
	                },
	                _react2.default.createElement('em', { className: 'fa fa-trash' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'void' })
	              )
	            ),
	            this.renderTable(),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'grand-total' },
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 5 },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rows' }),
	                  ':\xA0',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'font-color-orange' },
	                    this.state.rowsCount
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 6 },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { style: { 'margin-top': '2px' }, xs: 2, xsOffset: 1 },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { style: { 'display': 'inline-flex' } },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'grand_total' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'dollar-sign' },
	                        ' $$'
	                      ),
	                      ':'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 2 },
	                  _react2.default.createElement(_reduxForm.Field, { component: _inputField.DisabledInputField, placeholder: this.state.total || 0 })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_detail' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            { id: 'ap-table-detail', className: 'details-table-collapse-fix' },
	            this.renderDetailTable()
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogStyle,
	            isVisible: this.state.checkAuthorizeOpen,
	            onCloseClicked: this.closeCheckAuthorize
	          },
	          _react2.default.createElement(_confirmActionModal2.default, {
	            'case': 'confirmPassword',
	            closeC: this.checkAuthorize,
	            checkPasswordFailure: this.props.checkPasswordFailure
	          })
	        )
	      );
	    }
	  }]);
	
	  return APList;
	}(_react.Component);
	
	APList.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = APList;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getBsStyle, 'getBsStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/APList.jsx');
	
	  __REACT_HOT_LOADER__.register(renderRadios, 'renderRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/APList.jsx');
	
	  __REACT_HOT_LOADER__.register(APList, 'APList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/APList.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/APList.jsx');
	}();

	;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BalanceCellFormatter = function (_Component) {
	  _inherits(BalanceCellFormatter, _Component);
	
	  function BalanceCellFormatter() {
	    _classCallCheck(this, BalanceCellFormatter);
	
	    return _possibleConstructorReturn(this, (BalanceCellFormatter.__proto__ || Object.getPrototypeOf(BalanceCellFormatter)).apply(this, arguments));
	  }
	
	  _createClass(BalanceCellFormatter, [{
	    key: 'render',
	    value: function render() {
	      var _props$dependentValue = this.props.dependentValues,
	          UnpaidAmount = _props$dependentValue.UnpaidAmount,
	          DiscountedAmount = _props$dependentValue.DiscountedAmount;
	
	      var discountedAmount = DiscountedAmount || 0;
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.cloneElement(this.props.children, {
	          value: (UnpaidAmount - discountedAmount).toFixed(2)
	        })
	      );
	    }
	  }]);
	
	  return BalanceCellFormatter;
	}(_react.Component);
	
	var _default = BalanceCellFormatter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(BalanceCellFormatter, 'BalanceCellFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/CreateAP/BalanceCellFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/CreateAP/BalanceCellFormatter.jsx');
	}();

	;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _rowRenderer = __webpack_require__(64);
	
	var _dateFormat = __webpack_require__(39);
	
	var _BalanceCellFormatter = __webpack_require__(216);
	
	var _BalanceCellFormatter2 = _interopRequireDefault(_BalanceCellFormatter);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var APReceiveTable = function (_Component) {
	  _inherits(APReceiveTable, _Component);
	
	  function APReceiveTable() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, APReceiveTable);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = APReceiveTable.__proto__ || Object.getPrototypeOf(APReceiveTable)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      rows: [],
	      sortColumn: null,
	      sortDirection: null
	    }, _this.getRows = function () {
	      return _reactDataGridAddons.Data.Selectors.getRows(_this.state);
	    }, _this.getSize = function () {
	      return _this.getRows().length;
	    }, _this.rowGetter = function (rowIdx) {
	      var rows = _this.getRows();
	      return rows[rowIdx];
	    }, _this.handleGridSort = function (sortColumn, sortDirection) {
	      _this.setState({
	        rows: _this.getRows(),
	        sortColumn: sortColumn,
	        sortDirection: sortDirection
	      });
	    }, _this.handleGridRowsUpdated = function (_ref2) {
	      var fromRow = _ref2.fromRow,
	          toRow = _ref2.toRow,
	          updated = _ref2.updated;
	
	      var rows = _this.getRows();
	
	      for (var i = fromRow; i <= toRow; i++) {
	        var rowToUpdate = rows[i];
	        var updatedRow = _extends({}, rowToUpdate, updated);
	        rows[i] = updatedRow;
	      }
	      if (_this.props.from === 'selectedInvoices') {
	        _this.setState({ rows: rows });
	        _this.props.handleCellUpdate(rows);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(APReceiveTable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.rows) {
	        var rows = this.props.rows;
	
	        this.setState({ rows: rows });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.rows !== this.props.rows) {
	        var rows = nextProps.rows;
	
	        this.setState({ rows: rows });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var columns = [{
	        key: 'ReceiveNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'InvoiceNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'PostingDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'Amount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'amount' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'UnpaidAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _react2.default.createElement(
	          _BalanceCellFormatter2.default,
	          null,
	          _react2.default.createElement(_cashFormatter2.default, null)
	        ),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }];
	
	      var _props = this.props,
	          moveInvoices = _props.moveInvoices,
	          from = _props.from,
	          to = _props.to;
	
	      if (from === 'selectedInvoices') {
	        var column = {
	          key: 'DiscountedAmount',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount' }),
	          resizable: true,
	          filterable: true,
	          editable: true,
	          formatter: _cashFormatter2.default
	        };
	        columns.splice(4, 0, column);
	      }
	      return _react2.default.createElement(
	        'div',
	        { style: { maxWidth: '100%' }, id: 'APReceiveTable-dataGrid1' },
	        _react2.default.createElement(_reactDataGrid2.default, {
	          enableCellSelect: true,
	          rowRenderer: _react2.default.createElement(_rowRenderer.RowRenderer, {
	            onDoubleClick: moveInvoices,
	            from: from,
	            to: to
	          }),
	          onGridSort: this.handleGridSort,
	          columns: columns,
	          rowHeight: 25,
	          minHeight: 390,
	          rowGetter: this.rowGetter,
	          rowsCount: this.getSize(),
	          onGridRowsUpdated: this.handleGridRowsUpdated
	        })
	      );
	    }
	  }]);
	
	  return APReceiveTable;
	}(_react.Component);
	
	var _default = APReceiveTable;
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(APReceiveTable, 'APReceiveTable', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/CreateAP/apReceiveTable.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/CreateAP/apReceiveTable.jsx');
	}();

	;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(3);
	
	var _queryString = __webpack_require__(198);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _inputField = __webpack_require__(16);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _selection = __webpack_require__(21);
	
	var _datePicker = __webpack_require__(27);
	
	var _dateFormat = __webpack_require__(39);
	
	var _apReceiveTable = __webpack_require__(217);
	
	var _apReceiveTable2 = _interopRequireDefault(_apReceiveTable);
	
	var _accountDropdown = __webpack_require__(92);
	
	var _accountDropdown2 = _interopRequireDefault(_accountDropdown);
	
	var _arapPaymentOptions = __webpack_require__(94);
	
	var _arapPaymentOptions2 = _interopRequireDefault(_arapPaymentOptions);
	
	var _numberWithCommas = __webpack_require__(35);
	
	var _url = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreateAP = function (_Component) {
	  _inherits(CreateAP, _Component);
	
	  function CreateAP() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CreateAP);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CreateAP.__proto__ || Object.getPrototypeOf(CreateAP)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      invoices: [],
	      selectedInvoices: [],
	      unpaidAmount: 0,
	      totalAmount: 0,
	      totalDiscount: 0,
	      checkAuthorizeOpen: false,
	      action: null,
	      waiveAmount: 0,
	      checkNumbers: [],
	      checkNumbersInputHasWarning: false
	    }, _this.getBsStyle = function (input, value) {
	      return input === value ? 'success' : 'primary';
	    }, _this.moveInvoices = function (invoice, from) {
	      var _this$state = _this.state,
	          invoices = _this$state.invoices,
	          selectedInvoices = _this$state.selectedInvoices;
	
	      var index = void 0;
	      if (from === 'invoices') {
	        index = _lodash2.default.findIndex(invoices, { WarehouseReceive_id: invoice.WarehouseReceive_id });
	        if (index > -1) {
	          invoices.splice(index, 1);
	        }
	        index = _lodash2.default.findIndex(selectedInvoices, { WarehouseReceive_id: invoice.WarehouseReceive_id });
	        if (index === -1) {
	          selectedInvoices.push(invoice);
	        }
	      } else if (from === 'selectedInvoices') {
	        index = _lodash2.default.findIndex(selectedInvoices, { WarehouseReceive_id: invoice.WarehouseReceive_id });
	        if (index > -1) {
	          selectedInvoices.splice(index, 1);
	        }
	        index = _lodash2.default.findIndex(invoices, { WarehouseReceive_id: invoice.WarehouseReceive_id });
	        if (index === -1) {
	          delete invoice.DiscountedAmount;
	          invoices.push(invoice);
	        }
	      }
	      var totalAmount = 0;
	      selectedInvoices.map(function (r) {
	        totalAmount += parseFloat(r.UnpaidAmount) || 0;
	      });
	      _this.setState({ invoices: invoices, selectedInvoices: selectedInvoices, totalAmount: totalAmount });
	    }, _this.debouncedCreateAP = _lodash2.default.debounce(function (formProps, rows) {
	      _this.props.createAP(formProps, rows).then(function () {
	        if (_this.props.apCreated && !_this.props.apCreateError) {
	          _this.props.router.push('/AP');
	        }
	      });
	    }, 500, { maxWait: 1000 }), _this.handleFormSubmit = function (formProps) {
	      // const formProps = {
	      //   Vendor: this.props.vendorID,
	      //   TotalPayment: parseFloat(this.props.totalPayment).toFixed(2),
	      //   Method: this.props.method,
	      //   CheckNum: this.props.checkNum,
	      //   Account: this.props.account,
	      //   Discount: parseFloat(this.props.discount),
	      //   Note: this.props.note,
	      //   // Waive: this.props.waive,
	      //   WaiveAmount: parseFloat(this.state.waiveAmount).toFixed(2),
	      //   TotalAmount: parseFloat(this.state.totalAmount).toFixed(2),
	      // };
	      var rows = _this.selectedTable.state.rows;
	
	      _this.debouncedCreateAP(formProps, rows);
	    }, _this.handleWaiveInputChange = function (event) {
	      _this.setState({
	        waiveAmount: event.target.value
	      });
	    }, _this.handleDiscountCellChange = function (rows) {
	      var totalDiscount = 0;
	      var totalAmount = 0;
	      rows.map(function (row) {
	        totalDiscount += parseFloat(row.DiscountedAmount || 0);
	        totalAmount += parseFloat(row.UnpaidAmount || 0);
	      });
	      _this.setState({
	        totalDiscount: totalDiscount,
	        totalAmount: totalAmount
	      });
	    }, _this.renderInputField = function (props) {
	      var _props$meta = props.meta,
	          touched = _props$meta.touched,
	          error = _props$meta.error,
	          className = props.className;
	
	      var inputClass = (0, _classnames2.default)({ 'parsley-error': touched && error }, 'form-control', className);
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, {
	          className: inputClass,
	          type: 'text',
	          onChange: function onChange(event) {
	            props.input.onChange(event);
	          },
	          disabled: props.disabled
	        })),
	        touched && error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          error
	        )
	      );
	    }, _this.renderInvoiceDateRadio = function (props) {
	      var fromDate = 'FromDate';
	      var toDate = 'ToDate';
	      return _react2.default.createElement(
	        _reactBootstrap.ButtonToolbar,
	        { className: 'mb-md radio-filter-buttons' },
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { bsStyle: _this.getBsStyle(props.input.value, 'all') },
	          _react2.default.createElement(
	            'div',
	            { className: 'radio' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'all-radio-filter' },
	              _react2.default.createElement('input', _extends({}, props.input, {
	                type: 'radio',
	                id: 'all-radio-filter',
	                className: 'statusFilterRadios',
	                value: 'all',
	                checked: props.input.value === 'all'
	              })),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { bsStyle: _this.getBsStyle(props.input.value, 'range') },
	          _react2.default.createElement(
	            'div',
	            { className: 'radio' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'dateRange-radio-filter' },
	              _react2.default.createElement('input', _extends({}, props.input, {
	                type: 'radio',
	                id: 'dateRange-radio-filter',
	                className: 'statusFilterRadios',
	                value: 'range',
	                checked: props.input.value === 'range'
	              })),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date_range' })
	            )
	          )
	        ),
	        _this.renderDatePicker(fromDate, 'Start'),
	        _this.renderDatePicker(toDate, 'End')
	      );
	    }, _this.renderWaiveInputField = function (props) {
	      var _props$meta2 = props.meta,
	          touched = _props$meta2.touched,
	          error = _props$meta2.error,
	          className = props.className;
	
	      var inputClass = (0, _classnames2.default)({ 'parsley-error': touched && error }, 'form-control', className);
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, {
	          className: inputClass,
	          type: 'text',
	          onChange: function onChange(event) {
	            props.input.onChange(event);
	            _this.handleWaiveInputChange(event);
	          },
	          disabled: props.disabled
	        })),
	        touched && error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          error
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CreateAP, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.clearAPDetail();
	      this.props.clearCredits();
	      this.props.fetchVendors();
	      var queryObj = _queryString2.default.parse(this.props.location.search);
	      var vendId = queryObj.vend_id;
	      if (vendId) {
	        this.props.changeField('Vendor', parseFloat(vendId), 'createAP');
	      }
	      this.props.setDefaultOfForm('waiveAmount', 0.00, 'createAP');
	      this.props.setDefaultOfForm('InvoiceDate', 'all', 'createAP');
	      this.getCheckNumbers();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.vendorID && nextProps.vendorID !== this.props.vendorID) {
	        var fromDate = (0, _dateFormat.formatDate)(this.props.fromDate);
	        var toDate = (0, _dateFormat.formatDate)(this.props.toDate);
	        var invoiceDate = this.props.invoiceDate;
	        this.props.fetchVendorDetail(nextProps.vendorID.value || nextProps.vendorID);
	        this.props.fetchAPCredits(nextProps.vendorID.value || nextProps.vendorID);
	        this.props.fetchAPInvoices(nextProps.vendorID.value || nextProps.vendorID, invoiceDate, fromDate, toDate);
	      }
	      if (nextProps.invoices && nextProps.invoices !== this.props.invoices) {
	        var invoices = nextProps.invoices;
	        var selectedInvoices = [];
	        this.setState({ invoices: invoices, selectedInvoices: selectedInvoices });
	      }
	      if (nextProps.invoiceDate && nextProps.invoiceDate !== this.props.invoiceDate) {
	        var _fromDate = (0, _dateFormat.formatDate)(this.props.fromDate);
	        var _toDate = (0, _dateFormat.formatDate)(this.props.toDate);
	        if (this.props.vendorID) {
	          this.props.fetchAPInvoices(this.props.vendorID.value || this.props.vendorID, nextProps.invoiceDate, _fromDate, _toDate);
	        }
	      }
	
	      if (!nextProps.invoiceDate) {
	        this.props.setDefaultOfForm('InvoiceDate', 'all', 'createAP');
	      }
	
	      if (nextProps.fromDate && nextProps.fromDate !== this.props.fromDate) {
	        var _fromDate2 = (0, _dateFormat.formatDate)(nextProps.fromDate);
	        var _toDate2 = (0, _dateFormat.formatDate)(this.props.toDate);
	        if (this.props.vendorID) {
	          this.props.fetchAPInvoices(this.props.vendorID.value || this.props.vendorID, this.props.invoiceDate, _fromDate2, _toDate2);
	        }
	      }
	      if (nextProps.toDate && nextProps.toDate !== this.props.toDate) {
	        var _fromDate3 = (0, _dateFormat.formatDate)(this.props.fromDate);
	        var _toDate3 = (0, _dateFormat.formatDate)(nextProps.toDate);
	        if (this.props.vendorID && !this.props.apDetail) {
	          this.props.fetchAPInvoices(this.props.vendorID.value || this.props.vendorID, this.props.invoiceDate, _fromDate3, _toDate3);
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var totalDiscount = this.state.totalDiscount;
	
	      if (totalDiscount !== prevState.totalDiscount) {
	        this.props.dispatch((0, _reduxForm.change)('createAP', 'Discount', parseFloat(totalDiscount).toFixed(2) || 0));
	      }
	    }
	  }, {
	    key: 'getCheckNumbers',
	    value: function getCheckNumbers() {
	      var _this2 = this;
	
	      _axios2.default.get(_url.AP_URL + 'check_num/', {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        _this2.setState({
	          checkNumbers: response.data
	        });
	      });
	    }
	  }, {
	    key: 'getVendorOptions',
	    value: function getVendorOptions(field) {
	      var vendorOptions = [];
	      this.props.vendors.map(function (vendor) {
	        vendorOptions.push({ value: vendor.Vendor_id, label: vendor[field] });
	      });
	      return vendorOptions;
	    }
	  }, {
	    key: 'getBillingAddress',
	    value: function getBillingAddress() {
	      var currentVendorDetail = this.props.currentVendorDetail;
	
	      var Address1 = '';
	      var Address2 = '';
	      if (currentVendorDetail && currentVendorDetail.Billing) {
	        Address1 = currentVendorDetail.Billing.Street;
	        Address2 = currentVendorDetail.Billing.City + ', ' + currentVendorDetail.Billing.State + ' ' + currentVendorDetail.Billing.Zip;
	      }
	      return [Address1, Address2];
	    }
	  }, {
	    key: 'renderDatePicker',
	    value: function renderDatePicker(fieldName, placeholder) {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: 'primary' },
	        _react2.default.createElement(_reduxForm.Field, { name: fieldName, disabled: this.props.invoiceDate !== 'range', placeholder: placeholder, component: _datePicker.DatePicker })
	      );
	    }
	  }, {
	    key: 'renderVendors',
	    value: function renderVendors() {
	      if (this.props.vendorsIsLoading && !this.props.vendorsError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.vendorsError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'something_unexpected_happened' })
	          )
	        );
	      }
	      var vendorNameOptions = this.getVendorOptions('Name'); // Return a JSON in the format of React-Select's options
	      var vendorNumOptions = this.getVendorOptions('VendorNum');
	      var vendorPhoneOptions = this.getVendorOptions('Telephone'); // Return a JSON in the format of React-Select's options
	      var vendorDescOptions = this.getVendorOptions('Description');
	      var billingAddress = ['', ''];
	      var _props = this.props,
	          vendorID = _props.vendorID,
	          currentVendorDetail = _props.currentVendorDetail;
	
	      var contact = null;
	      var phone = null;
	      if (vendorID && currentVendorDetail && currentVendorDetail.Billing) {
	        contact = currentVendorDetail.Billing.FirstName + ' ' + currentVendorDetail.Billing.LastName;
	        phone = currentVendorDetail.Billing.Telephone;
	        billingAddress = this.getBillingAddress();
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row /* id='hint' */,
	          { className: 'mb0' },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-4 inlineLabel' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_no' }),
	              _react2.default.createElement(
	                'span',
	                { style: { color: 'red' } },
	                '*'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 8, className: 'mb-md' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'Vendor', component: _selection.Selection, matchPos: 'any', options: vendorNumOptions })
	            ),
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-4 inlineLabel' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_name' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 8, className: 'mb-md' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'Vendor', component: _selection.Selection, matchPos: 'any', options: vendorNameOptions })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-4 inlineLabel' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 8, className: 'mb-md' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'Vendor', component: _selection.Selection, matchPos: 'any', options: vendorPhoneOptions })
	            ),
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-4 inlineLabel' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 8, className: 'mb-md' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'Vendor', component: _selection.Selection, options: vendorDescOptions })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'contact' }),
	              ':'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 9 },
	              contact
	            ),
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' }),
	              ':'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 9 },
	              billingAddress[0],
	              _react2.default.createElement('br', null),
	              billingAddress[1]
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'handleCheckNumChange',
	    value: function handleCheckNumChange(e) {
	      var stringValue = "" + e.target.value;
	      if (this.state.checkNumbers.includes(stringValue)) {
	        this.setState({
	          checkNumbersInputHasWarning: true
	        });
	      } else {
	        this.setState({
	          checkNumbersInputHasWarning: false
	        });
	      }
	    }
	  }, {
	    key: 'renderCheckNum',
	    value: function renderCheckNum() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reduxForm.Field, { name: 'CheckNum', component: _inputField.InputField, onChange: this.handleCheckNumChange.bind(this) }),
	        this.state.checkNumbersInputHasWarning && _react2.default.createElement(
	          'p',
	          { style: { position: "absolute", top: "23px" } },
	          'Reminder: Check num already exists'
	        )
	      );
	    }
	  }, {
	    key: 'renderCredits',
	    value: function renderCredits() {
	      if (this.props.creditsIsLoading && !this.props.creditsError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.creditsError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'something_unexpected_happened' })
	          )
	        );
	      }
	      var creditOptions = this.getCreditOptions(); // Return a JSON in the format of React-Select's options
	      return _react2.default.createElement(_reduxForm.Field, { name: 'Credits', component: _selection.MultiSelection, options: creditOptions });
	    }
	  }, {
	    key: 'renderInvoices',
	    value: function renderInvoices() {
	      if (this.props.invoicesIsLoading && !this.props.invoicesError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.invoicesError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.invoicesError)
	          )
	        );
	      }
	      var invoices = this.state.invoices;
	
	      return _react2.default.createElement(_apReceiveTable2.default, {
	        rows: invoices,
	        moveInvoices: this.moveInvoices,
	        from: 'invoices',
	        to: 'selectedInvoices'
	      });
	    }
	  }, {
	    key: 'renderSelectedInvoices',
	    value: function renderSelectedInvoices() {
	      var _this3 = this;
	
	      var selectedInvoices = this.state.selectedInvoices;
	
	      return _react2.default.createElement(_apReceiveTable2.default, {
	        ref: function ref(selectedTable) {
	          _this3.selectedTable = selectedTable;
	        },
	        rows: selectedInvoices,
	        moveInvoices: this.moveInvoices,
	        from: 'selectedInvoices',
	        to: 'invoices',
	        handleCellUpdate: this.handleDiscountCellChange
	      });
	    }
	  }, {
	    key: 'renderResponse',
	    value: function renderResponse() {
	      var _props2 = this.props,
	          apCreated = _props2.apCreated,
	          apCreateError = _props2.apCreateError,
	          apIsCreating = _props2.apIsCreating;
	
	      if (apCreated) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-success' },
	            'Success!'
	          )
	        );
	      } else if (apIsCreating && !apCreateError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-info' },
	            '...',
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reading_data' })
	          )
	        );
	      } // else if (apCreateError) {
	      //   return (
	      //     <ContentWrapper>
	      //       <div className='alert alert-danger'>
	      //         <Translate value="something_unexpected_happened" />
	      //       </div>
	      //     </ContentWrapper>
	      //   );
	      // }
	      return _react2.default.createElement(_ContentWrapper2.default, null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          handleSubmit = _props3.handleSubmit,
	          pristine = _props3.pristine,
	          method = _props3.method,
	          submitting = _props3.submitting;
	
	
	      var paymentMethodIsCredit = method === 'Credit' || method && method.value === 'Credit';
	
	      var twoDecimalZero = 0 .toFixed(2);
	      var discount = parseFloat(this.props.discount) || twoDecimalZero;
	      var totalAmount = parseFloat(this.state.totalAmount) || twoDecimalZero;
	      var balance = (totalAmount - discount).toFixed(2) || twoDecimalZero;
	      var waiveAmount = this.state.waiveAmount;
	      var totalPayment = parseFloat(this.props.totalPayment) || twoDecimalZero;
	      var finalBalance = (balance - waiveAmount - totalPayment).toFixed(2) || twoDecimalZero;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit(this.handleFormSubmit) },
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_slashsign_ap' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account_payable' })
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'AP-detail' },
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  type: 'submit',
	                  disabled: pristine || submitting
	                },
	                _react2.default.createElement('em', { className: 'fa fa-save' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  type: 'button',
	                  onClick: function onClick() {
	                    return document.referrer === window.location.href ? _this4.props.router.push('/AP') : _this4.props.router.goBack();
	                  }
	                },
	                _react2.default.createElement('em', { className: 'fa fa-close' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { id: 'vendors' },
	              this.renderVendors()
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { id: 'date-range-picker', className: 'form-horizontal' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-7' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'floatLeft' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_date' })
	                  ),
	                  _react2.default.createElement(_reduxForm.Field, { name: 'InvoiceDate', component: this.renderInvoiceDateRadio })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 6 },
	                  this.renderInvoices()
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 6 },
	                  this.renderSelectedInvoices()
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { id: 'check-out-information' },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'text-nowrap inlineLabel' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_method' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'asteriksReq' },
	                      '*'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Method', className: 'select-menu-drop-up', component: _selection.Selection, options: _arapPaymentOptions2.default })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'inlineLabel' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check_number' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  paymentMethodIsCredit && this.renderCredits(),
	                  !paymentMethodIsCredit && this.renderCheckNum()
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 3 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'inlineLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'waive' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 6, smOffset: 1 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'WaiveAmount', component: this.renderWaiveInputField })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 2 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 4 },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_date' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'asteriksReq text-nowrap' },
	                          '*'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 7 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'PaymentDate', component: _datePicker.DatePicker, dropUp: true, maxDate: new Date() })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' }),
	                    ' :'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    '$' + (0, _numberWithCommas.numberWithCommas)(balance)
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1 inlineLabel' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account' }),
	                  _react2.default.createElement(
	                    'span',
	                    { style: { color: 'red' } },
	                    '*'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(_accountDropdown2.default, { className: 'select-menu-drop-up' })
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1 text-nowrap inlineLabel' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pay_amount' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'asteriksReq' },
	                    '*'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'TotalPayment', component: _inputField.InputField })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 4 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'inlineLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 3 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'Discount', component: this.renderInputField, placeholder: '$', disabled: true })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_balance' }),
	                  ' :'
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1' },
	                  '$' + (0, _numberWithCommas.numberWithCommas)(finalBalance)
	                )
	              ),
	              _react2.default.createElement('div', { className: 'horizontal-divider' }),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'inlineLabel' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Note' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 5 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Note', component: _inputField.InputField })
	                ),
	                _react2.default.createElement(_reactBootstrap.Col, { sm: 3, smOffset: 2 })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              this.renderResponse()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CreateAP;
	}(_react.Component);
	
	var _default = CreateAP;
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CreateAP, 'CreateAP', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/CreateAP/createAP.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/CreateAP/createAP.jsx');
	}();

	;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BalanceCellFormatter = function (_Component) {
	  _inherits(BalanceCellFormatter, _Component);
	
	  function BalanceCellFormatter() {
	    _classCallCheck(this, BalanceCellFormatter);
	
	    return _possibleConstructorReturn(this, (BalanceCellFormatter.__proto__ || Object.getPrototypeOf(BalanceCellFormatter)).apply(this, arguments));
	  }
	
	  _createClass(BalanceCellFormatter, [{
	    key: 'render',
	    value: function render() {
	      var _props$dependentValue = this.props.dependentValues,
	          PreviousBalance = _props$dependentValue.PreviousBalance,
	          Amount = _props$dependentValue.Amount,
	          DiscountedAmount = _props$dependentValue.DiscountedAmount;
	
	      var previousBalance = PreviousBalance || 0;
	      var amount = Amount || 0;
	      var discountedAmount = DiscountedAmount || 0;
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.cloneElement(this.props.children, {
	          value: (previousBalance - amount - discountedAmount).toFixed(2)
	        })
	      );
	    }
	  }]);
	
	  return BalanceCellFormatter;
	}(_react.Component);
	
	var _default = BalanceCellFormatter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(BalanceCellFormatter, 'BalanceCellFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/EditAP/balanceCellFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/EditAP/balanceCellFormatter.jsx');
	}();

	;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _selection = __webpack_require__(21);
	
	var _datePicker = __webpack_require__(27);
	
	var _dateFormat = __webpack_require__(39);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _editAPTable = __webpack_require__(221);
	
	var _editAPTable2 = _interopRequireDefault(_editAPTable);
	
	var _accountDropdown = __webpack_require__(92);
	
	var _accountDropdown2 = _interopRequireDefault(_accountDropdown);
	
	var _arapPaymentOptions = __webpack_require__(94);
	
	var _arapPaymentOptions2 = _interopRequireDefault(_arapPaymentOptions);
	
	var _url = __webpack_require__(20);
	
	var _inputField = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditAP = function (_Component) {
	  _inherits(EditAP, _Component);
	
	  function EditAP() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EditAP);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditAP.__proto__ || Object.getPrototypeOf(EditAP)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      rows: [],
	      unpaidAmount: 0,
	      totalAmount: 0,
	      checkAuthorizeOpen: false,
	      action: null,
	      waiveAmount: 0,
	      totalPayment: 0,
	      isAPEditable: true,
	      allCheckNumbers: [],
	      checkNumbersInputHasWarning: false
	    }, _this.getBsStyle = function (input, value) {
	      return input === value ? 'success' : 'primary';
	    }, _this.checkAuthorize = function (password) {
	      _this.props.checkPassword(password);
	    }, _this.openCheckAuthorize = function (action) {
	      _this.props.clearCheckPassword();
	      _this.setState({ checkAuthorizeOpen: true, action: action });
	    }, _this.closeCheckAuthorize = function () {
	      _this.setState({ checkAuthorizeOpen: false });
	    }, _this.debouncedEditAP = _lodash2.default.debounce(function (formProps, rows) {
	      _this.props.editAP(formProps, rows).then(function () {
	        if (_this.props.apEdited && !_this.props.apEditError) {
	          _this.props.router.push('/AP');
	        }
	      });
	    }, 500, { maxWait: 1000 }), _this.handleFormSubmit = function () {
	      var formProps = {
	        PaymentID: _this.props.apDetail.Payment_id,
	        TotalPayment: parseFloat(_this.props.totalPayment || 0).toFixed(2),
	        PaymentDate: _this.props.paymentDate,
	        Method: _this.props.method,
	        CheckNum: _this.props.checkNum,
	        Account: _this.props.account.value,
	        AccountName: _this.props.account.label,
	        Discount: parseFloat(_this.props.discount || 0).toFixed(2),
	        Note: _this.props.note,
	        WaiveAmount: parseFloat(_this.state.waiveAmount || 0).toFixed(2),
	        TotalAmount: parseFloat(_this.state.totalAmount || 0).toFixed(2)
	      };
	      var rows = _this.apTable.state.rows;
	
	      _this.debouncedEditAP(formProps, rows);
	      //TODO show modal ask for staying on the page
	    }, _this.handleWaiveInputChange = function (event) {
	      _this.setState({
	        waiveAmount: event.target.value
	      });
	    }, _this.handlePaymentCellChange = function (rows) {
	      var totalPayment = 0;
	      var totalAmount = 0;
	      rows.map(function (row) {
	        totalPayment += parseFloat(row.Amount) || 0;
	        totalAmount += parseFloat(row.PreviousBalance) || 0;
	      });
	      _this.setState({
	        totalPayment: totalPayment,
	        totalAmount: totalAmount
	      });
	    }, _this.handlePaymentAmountInputChange = function (event) {
	      var payment = parseFloat(event.target.value || 0).toFixed(2) || 0;
	      var rows = [].concat(_toConsumableArray(_this.state.rows));
	      for (var i = 0; i < rows.length; i++) {
	        var rowToUpdate = rows[i];
	        var PreviousBalance = rowToUpdate.PreviousBalance;
	
	        var unpaidAmount = PreviousBalance || 0;
	        if (payment >= unpaidAmount) {
	          rowToUpdate.Amount = +parseFloat(unpaidAmount).toFixed(2);
	          rowToUpdate.UnpaidAmount = 0;
	          payment -= unpaidAmount;
	        } else {
	          rowToUpdate.Amount = +parseFloat(payment).toFixed(2);
	          rowToUpdate.UnpaidAmount = +parseFloat(parseFloat(unpaidAmount) - parseFloat(payment)).toFixed(2);
	          payment = 0;
	        }
	        // overpay condition, add payment to last row
	        if (payment > 0 && i === rows.length - 1) {
	          rowToUpdate.Amount += +parseFloat(payment).toFixed(2);
	          rowToUpdate.UnpaidAmount -= +parseFloat(payment).toFixed(2);
	        }
	        rows[i] = rowToUpdate;
	      }
	      _this.setState({ rows: rows });
	    }, _this.renderInputField = function (props) {
	      var _props$meta = props.meta,
	          touched = _props$meta.touched,
	          error = _props$meta.error,
	          className = props.className;
	
	      var inputClass = (0, _classnames2.default)({ 'parsley-error': touched && error }, 'form-control', className);
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, {
	          className: inputClass,
	          type: 'text',
	          onChange: function onChange(event) {
	            props.input.onChange(event);
	            if (typeof props.handleOnChange === 'function') {
	              props.handleOnChange(event);
	            }
	          },
	          disabled: props.disabled
	        })),
	        touched && error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          error
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EditAP, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.clearAPForm();
	      this.props.clearCredits();
	      this.getCheckNumbers();
	      var id = this.props.routeParams.id;
	
	      if (id) {
	        this.props.fetchAPDetail(id);
	      } else {
	        this.context.router.push('/AP/');
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // console.log('nextprops', nextprops);
	      if (nextProps.apDetail && nextProps.apDetail !== this.props.apDetail) {
	        var _nextProps$apDetail = nextProps.apDetail,
	            Status = _nextProps$apDetail.Status,
	            Invoices = _nextProps$apDetail.Invoices,
	            WaiveAmount = _nextProps$apDetail.WaiveAmount,
	            TotalPayment = _nextProps$apDetail.TotalPayment;
	
	        var isAPEditable = Status !== 'Void';
	        var totalAmount = 0;
	        if (Invoices) {
	          Invoices.map(function (invoice) {
	            totalAmount += invoice.PreviousBalance;
	          });
	        }
	        this.setState({
	          rows: Invoices || [],
	          waiveAmount: WaiveAmount,
	          totalPayment: TotalPayment,
	          totalAmount: totalAmount,
	          isAPEditable: isAPEditable
	        });
	      }
	      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
	        this.closeCheckAuthorize();
	        if (this.state.action === 'apply') {
	          this.handleFormSubmit();
	        } else if (this.state.action === 'remove') {
	          this.props.deleteAP(this.props.apDetail.Payment_id);
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var totalPayment = this.state.totalPayment;
	
	      if (totalPayment !== prevState.totalPayment) {
	        this.props.dispatch((0, _reduxForm.change)('editAP', 'TotalPayment', parseFloat(totalPayment).toFixed(2) || 0));
	      }
	    }
	  }, {
	    key: 'getCheckNumbers',
	    value: function getCheckNumbers() {
	      var _this2 = this;
	
	      _axios2.default.get(_url.AP_URL + 'check_num/', {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        _this2.setState({
	          allCheckNumbers: response.data
	        });
	      });
	    }
	  }, {
	    key: 'getBillingAddress',
	    value: function getBillingAddress() {
	      var apDetail = this.props.apDetail;
	
	      var Address1 = '';
	      var Address2 = '';
	      if (apDetail && apDetail.Vendor_Detail) {
	        Address1 = apDetail.Vendor_Detail.Street;
	        Address2 = apDetail.Vendor_Detail.City + ', ' + apDetail.Vendor_Detail.State + ' ' + apDetail.Vendor_Detail.Zip;
	      }
	      return [Address1, Address2];
	    }
	  }, {
	    key: 'checkPermission',
	    value: function checkPermission(permission) {
	      return false;
	    }
	  }, {
	    key: 'renderVendors',
	    value: function renderVendors() {
	      var _props = this.props,
	          apDetail = _props.apDetail,
	          apDetailIsLoading = _props.apDetailIsLoading,
	          apDetailError = _props.apDetailError;
	
	      if (!apDetail || apDetailIsLoading) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (apDetailError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'something_unexpected_happened' })
	          )
	        );
	      }
	      var VendorNum = apDetail.VendorNum,
	          VendorName = apDetail.VendorName,
	          Vendor_Detail = apDetail.Vendor_Detail;
	
	      var contact = null;
	      var phone = null;
	      var note = '';
	      var billingAddress = ['', ''];
	
	      if (Vendor_Detail) {
	        contact = Vendor_Detail.FirstName + ' ' + Vendor_Detail.LastName;
	        phone = Vendor_Detail.Telephone;
	        billingAddress = this.getBillingAddress();
	        note = Vendor_Detail.Note;
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'mb0' },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-4 inlineLabel' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_no' }),
	              _react2.default.createElement(
	                'span',
	                { style: { color: 'red' } },
	                '*'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 8, className: 'mb-md' },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                value: VendorNum,
	                disabled: true
	              })
	            ),
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-4 inlineLabel' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_name' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 8, className: 'mb-md' },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                value: VendorName,
	                disabled: true
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-4 inlineLabel' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 8, className: 'mb-md' },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                value: phone,
	                disabled: true
	              })
	            ),
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-4 inlineLabel' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 8, className: 'mb-md' },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                value: note,
	                disabled: true
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'contact' }),
	              ':'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 9 },
	              contact
	            ),
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' }),
	              ':'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 9 },
	              billingAddress[0],
	              _react2.default.createElement('br', null),
	              billingAddress[1]
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderInvoices',
	    value: function renderInvoices() {
	      var _this3 = this;
	
	      if (this.props.invoicesIsLoading && !this.props.invoicesError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.invoicesError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'something_unexpected_happened' })
	          )
	        );
	      }
	      var rows = this.state.rows;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(_editAPTable2.default, {
	            ref: function ref(apTable) {
	              _this3.apTable = apTable;
	            },
	            handlePaymentCellChange: this.handlePaymentCellChange,
	            rows: rows
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderAPMetaInfo',
	    value: function renderAPMetaInfo() {
	      var apDetail = this.props.apDetail;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 2 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ID' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 8 },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                value: apDetail && apDetail.APNum || '',
	                disabled: true
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 10 },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 3, xsOffset: 1 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'user' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 7 },
	                  _react2.default.createElement(_reactBootstrap.Input, {
	                    type: 'text',
	                    value: apDetail && apDetail.FullName || 'N/A',
	                    disabled: true
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'creation_date' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 7 },
	                  _react2.default.createElement(_reactBootstrap.Input, {
	                    type: 'text',
	                    value: apDetail && apDetail.PostingDate ? (0, _dateFormat.formatDate)(new Date(apDetail.PostingDate)) : 'N/A',
	                    disabled: true
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'modified_date' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 7 },
	                  _react2.default.createElement(_reactBootstrap.Input, {
	                    type: 'text',
	                    value: apDetail && apDetail.ModifyDate ? (0, _dateFormat.formatDate)(new Date(apDetail.ModifyDate)) : 'N/A',
	                    disabled: true
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_date' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 7 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'PaymentDate', component: _datePicker.DatePicker, dropUp: true, maxDate: new Date() })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'handleCheckNumChange',
	    value: function handleCheckNumChange(e) {
	      var stringValue = "" + e.target.value;
	      if (this.state.allCheckNumbers.includes(stringValue) && stringValue !== this.props.originalCheckNumber) {
	        this.setState({
	          checkNumbersInputHasWarning: true
	        });
	      } else {
	        this.setState({
	          checkNumbersInputHasWarning: false
	        });
	      }
	    }
	  }, {
	    key: 'renderCheckNum',
	    value: function renderCheckNum() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reduxForm.Field, { name: 'CheckNum', component: this.renderInputField, handleOnChange: this.handleCheckNumChange.bind(this) }),
	        this.state.checkNumbersInputHasWarning && _react2.default.createElement(
	          'p',
	          { style: { position: "absolute", top: "23px" } },
	          'Reminder: Check num already exists'
	        )
	      );
	    }
	  }, {
	    key: 'renderCredits',
	    value: function renderCredits() {
	      if (this.props.creditsIsLoading && !this.props.creditsError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.creditsError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'something_unexpected_happened' })
	          )
	        );
	      }
	      var creditOptions = this.getCreditOptions(); // Return a JSON in the format of React-Select's options
	      return _react2.default.createElement(_reduxForm.Field, { name: 'Credits', component: _selection.MultiSelection, options: creditOptions });
	    }
	  }, {
	    key: 'renderResponse',
	    value: function renderResponse() {
	      var _props2 = this.props,
	          apEdited = _props2.apEdited,
	          apEditError = _props2.apEditError,
	          apIsEditing = _props2.apIsEditing;
	
	      if (apEdited) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-success' },
	            'Success!'
	          )
	        );
	      } else if (apIsEditing && !apEditError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-info' },
	            '...',
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saving' })
	          )
	        );
	      } // else if (apEditError) {
	      //   return (
	      //     <ContentWrapper>
	      //       <div className='alert alert-danger'>
	      //         { apEditError }
	      //       </div>
	      //     </ContentWrapper>
	      //   );
	      // }
	      return _react2.default.createElement(_ContentWrapper2.default, null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var createDialogStyle = {
	        width: '550px',
	        height: '300px',
	        marginLeft: '-15%'
	      };
	
	      var _props3 = this.props,
	          method = _props3.method,
	          submitting = _props3.submitting;
	      var isAPEditable = this.state.isAPEditable;
	
	
	      var paymentMethodIsCredit = method === 'Credit' || method && method.value === 'Credit';
	
	      var twoDecimalZero = 0 .toFixed(2);
	      var discount = parseFloat(this.props.discount) || twoDecimalZero;
	      var totalAmount = parseFloat(this.state.totalAmount) || twoDecimalZero;
	      var balance = (totalAmount - discount).toFixed(2) || twoDecimalZero;
	      var waiveAmount = this.state.waiveAmount || twoDecimalZero;
	      var totalPayment = parseFloat(this.props.totalPayment) || twoDecimalZero;
	      var finalBalance = (balance - waiveAmount - totalPayment).toFixed(2) || twoDecimalZero;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'form',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_slashsign_ap' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account_payable' })
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'AP-edit' },
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  type: 'button',
	                  onClick: function onClick() {
	                    _this4.props.router.push('/AP');
	                  }
	                },
	                _react2.default.createElement('em', { className: 'fa fa-close' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { id: 'vendors' },
	              this.renderVendors()
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              null,
	              this.renderInvoices()
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { id: 'check-out-information' },
	              this.renderAPMetaInfo(),
	              _react2.default.createElement('div', { className: 'horizontal-divider' }),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'upper-row-positioning' },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'text-nowrap inlineLabel' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_method' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'asteriksReq' },
	                      '*'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(_reduxForm.Field, {
	                    name: 'Method',
	                    className: 'select-menu-drop-up',
	                    component: _selection.Selection,
	                    options: _arapPaymentOptions2.default,
	                    disabled: !isAPEditable
	                  })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'inlineLabel' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check_number' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  paymentMethodIsCredit && this.renderCredits(),
	                  !paymentMethodIsCredit && this.renderCheckNum()
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 6 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'inlineLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount' }),
	                        ' ($)'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 6 },
	                      _react2.default.createElement(_reduxForm.Field, {
	                        name: 'Discount',
	                        component: this.renderInputField,
	                        disabled: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'inlineLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'waive' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 6, smOffset: 1 },
	                      _react2.default.createElement(_reduxForm.Field, {
	                        name: 'WaiveAmount',
	                        component: this.renderInputField,
	                        handleOnChange: this.handleWaiveInputChange,
	                        disabled: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' }),
	                    ' :'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    balance
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'lower-row-positioning' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1 inlineLabel' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account' }),
	                  _react2.default.createElement(
	                    'span',
	                    { style: { color: 'red' } },
	                    '*'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(_accountDropdown2.default, { className: 'select-menu-drop-up', disabled: !isAPEditable })
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1 text-nowrap inlineLabel' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pay_amount' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'asteriksReq' },
	                    '*'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2, className: 'total-payment-field' },
	                  _react2.default.createElement(_reduxForm.Field, {
	                    name: 'TotalPayment',
	                    component: this.renderInputField,
	                    handleOnChange: this.handlePaymentAmountInputChange,
	                    disabled: !isAPEditable
	                  })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'inlineLabel' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(_reduxForm.Field, {
	                    name: 'Note',
	                    component: this.renderInputField,
	                    disabled: !isAPEditable
	                  })
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1 col-sm-offset-1' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_balance' }),
	                  ' :'
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1' },
	                  finalBalance
	                )
	              ),
	              _react2.default.createElement('div', { className: 'horizontal-divider divider' }),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { id: 'hint' },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 4, className: 'vertical-divider' },
	                  _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    { id: 'ap-apply-button' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'success',
	                        type: 'button',
	                        onClick: function onClick() {
	                          _this4.openCheckAuthorize('apply');
	                        },
	                        disabled: submitting || !isAPEditable
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-save' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'danger',
	                        type: 'button',
	                        onClick: function onClick() {
	                          _this4.openCheckAuthorize('remove');
	                        },
	                        disabled: submitting || !isAPEditable
	                      },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'remove' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 5 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'authorize-label' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'authorization_required' })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              this.renderResponse()
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogStyle,
	            isVisible: this.state.checkAuthorizeOpen,
	            onCloseClicked: this.closeCheckAuthorize
	          },
	          _react2.default.createElement(_confirmActionModal2.default, {
	            'case': 'confirmPassword',
	            closeC: this.checkAuthorize,
	            checkPasswordFailure: this.props.checkPasswordFailure
	          })
	        )
	      );
	    }
	  }]);
	
	  return EditAP;
	}(_react.Component);
	
	var _default = EditAP;
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(EditAP, 'EditAP', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/EditAP/editAP.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/EditAP/editAP.jsx');
	}();

	;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _dateFormat = __webpack_require__(39);
	
	var _priceFormatter = __webpack_require__(56);
	
	var _priceFormatter2 = _interopRequireDefault(_priceFormatter);
	
	var _balanceCellFormatter = __webpack_require__(219);
	
	var _balanceCellFormatter2 = _interopRequireDefault(_balanceCellFormatter);
	
	var _NumberUtil = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditAPTable = function (_Component) {
	  _inherits(EditAPTable, _Component);
	
	  function EditAPTable(props) {
	    _classCallCheck(this, EditAPTable);
	
	    var _this = _possibleConstructorReturn(this, (EditAPTable.__proto__ || Object.getPrototypeOf(EditAPTable)).call(this, props));
	
	    _this.getRows = function () {
	      return _reactDataGridAddons.Data.Selectors.getRows(_this.state);
	    };
	
	    _this.getSize = function () {
	      return _this.getRows().length;
	    };
	
	    _this.rowGetter = function (i) {
	      return JSON.parse(JSON.stringify(_this.getRows()[i]));
	    };
	
	    _this.handleGridSort = function (sortColumn, sortDirection) {
	      _this.setState({
	        rows: _this.getRows(),
	        sortColumn: sortColumn,
	        sortDirection: sortDirection
	      });
	    };
	
	    _this.handleGridRowsUpdated = function (_ref) {
	      var fromRow = _ref.fromRow,
	          toRow = _ref.toRow,
	          updated = _ref.updated;
	
	      if (!(0, _NumberUtil.isNumber)(updated.Amount)) {
	        return;
	      }
	      var rows = _this.getRows();
	      for (var i = fromRow; i <= toRow; i += 1) {
	        var rowToUpdate = rows[i];
	        var updatedRow = _extends({}, rowToUpdate, updated);
	        rows[i] = updatedRow;
	      }
	      _this.setState({ rows: rows }, function () {
	        _this.props.handlePaymentCellChange(_this.state.rows);
	      });
	    };
	
	    _this.state = {
	      rows: [],
	      sortColumn: null,
	      sortDirection: null
	    };
	    return _this;
	  }
	
	  _createClass(EditAPTable, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.rows !== this.props.rows) {
	        var rows = nextProps.rows;
	
	        this.setState({ rows: rows });
	      }
	    }
	
	    // Grid does not properly re-render when more than one row is updated at a time
	    // Problem solved, for more info Refer to link:
	    // https://github.com/adazzle/react-data-grid/issues/332
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var columns = [{
	        key: 'ReceiveNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'InvoiceNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'PostingDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_date' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'BillDueDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'due_date' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'FinalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'amount' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _priceFormatter2.default
	      }, {
	        key: 'Amount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        editable: true,
	        formatter: _priceFormatter2.default
	      }, {
	        key: 'DiscountedAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount' }),
	        resizable: true,
	        filterable: true,
	        formatter: _priceFormatter2.default
	      }, {
	        key: 'UnpaidAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'remaining_balance' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _react2.default.createElement(
	          _balanceCellFormatter2.default,
	          null,
	          _react2.default.createElement(_priceFormatter2.default, null)
	        ),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }];
	
	      return _react2.default.createElement(
	        'div',
	        { style: { maxWidth: '100%' }, id: 'editAPTable-dataGrid1' },
	        _react2.default.createElement(_reactDataGrid2.default, {
	          enableCellSelect: true,
	          onGridSort: this.handleGridSort,
	          columns: columns,
	          rowHeight: 25,
	          minHeight: 350,
	          rowGetter: this.rowGetter,
	          rowsCount: this.getSize(),
	          onGridRowsUpdated: this.handleGridRowsUpdated
	        })
	      );
	    }
	  }]);
	
	  return EditAPTable;
	}(_react.Component);
	
	var _default = EditAPTable;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(EditAPTable, 'EditAPTable', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/EditAP/editAPTable.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/EditAP/editAPTable.jsx');
	}();

	;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _root_url = __webpack_require__(9);
	
	var _priceFormatter = __webpack_require__(56);
	
	var _priceFormatter2 = _interopRequireDefault(_priceFormatter);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _cellFormatter = __webpack_require__(156);
	
	var _cellFormatter2 = _interopRequireDefault(_cellFormatter);
	
	var _dateFormatter = __webpack_require__(147);
	
	var _dateFormatter2 = _interopRequireDefault(_dateFormatter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VendorStatementDetailTable = function (_Component) {
	  _inherits(VendorStatementDetailTable, _Component);
	
	  function VendorStatementDetailTable(props) {
	    _classCallCheck(this, VendorStatementDetailTable);
	
	    var _this = _possibleConstructorReturn(this, (VendorStatementDetailTable.__proto__ || Object.getPrototypeOf(VendorStatementDetailTable)).call(this, props));
	
	    _this.getRows = function () {
	      return _reactDataGridAddons.Data.Selectors.getRows(_this.state);
	    };
	
	    _this.getSize = function () {
	      return _this.getRows().length;
	    };
	
	    _this.rowGetter = function (i) {
	      return JSON.parse(JSON.stringify(_this.getRows()[i]));
	    };
	
	    _this.handleGridSort = function (sortColumn, sortDirection) {
	      _this.setState(function (prevState) {
	        return _extends({}, prevState, {
	          sortColumn: sortColumn,
	          sortDirection: sortDirection
	        });
	      });
	    };
	
	    _this.state = {
	      rows: props.rows,
	      sortColumn: null,
	      sortDirection: null
	    };
	    return _this;
	  }
	
	  // Grid does not properly re-render when more than one row is updated at a time
	  // Problem solved, for more info Refer to link:
	  // https://github.com/adazzle/react-data-grid/issues/332
	
	
	  _createClass(VendorStatementDetailTable, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // const columns = [
	      //   {
	      //       key: 'invoice_number',
	      //       name: <Translate value="invoice_no" />,
	      //       resizable: true,
	      //       sortable: true,
	      //       width: 100,
	      //   },
	      //   {
	      //       key: 'invoice_date',
	      //       name: <Translate value="invoice_date" />,
	      //       resizable: true,
	      //       sortable: true,
	      //       width: 90,
	      //       formatter: DateFormatter,
	      //   },
	      //   {
	      //       key: 'due_date',
	      //       name: <Translate value="due_date" />,
	      //       resizable: true,
	      //       sortable: true,
	      //       width: 90,
	      //       formatter: DateFormatter,
	      //   },
	      //   {
	      //       key: 'payment_received_date',
	      //       name: <Translate value="pmt_rcv_date" />,
	      //       resizable: true,
	      //       sortable: true,
	      //       formatter: DateFormatter,
	      //       width: 90,
	      //   },
	      //   {
	      //       key: 'ap_number',
	      //       name: <Translate value="a"p_#' />,
	      //       resizable: true,
	      //       sortable: true,
	      //       formatter: CellFormatter,
	      //       width: 100,
	      //   },
	      //   {
	      //       key: 'invoice_amount',
	      //       name: <Translate value="invoice_amount" />,
	      //       resizable: true,
	      //       sortable: true,
	      //       formatter: CashFormatter,
	      //       width: 80,
	      //   },
	      //   {
	      //       key: 'balance',
	      //       name: <Translate value="invoice_balance" />,
	      //       resizable: true,
	      //       sortable: true,
	      //       formatter: CashFormatter,
	      //       width: 80,
	      //   },
	      //   {
	      //       key: 'payment_paid_amount',
	      //       name: <Translate value="pmt_paid_amount" />,
	      //       resizable: true,
	      //       sortable: true,
	      //       formatter: CashFormatter,
	      //       width: 80,
	      //   },
	      //   {
	      //       key: 'remaining_balance',
	      //       name: <Translate value="balance" />,
	      //       resizable: true,
	      //       sortable: true,
	      //       formatter: CashFormatter,
	      //       width: 80,
	      //       getRowMetaData: (row) => row,
	      //   },
	      //   {
	      //       key: 'type',
	      //       name: <Translate value="type" />,
	      //       resizable: true,
	      //       sortable: true,
	      //       formatter: CellFormatter,
	      //       width: 150,
	      //   },
	      // ];
	
	      var columns = [{
	        key: 'PostingDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	        resizable: true,
	        sortable: true,
	        formatter: _dateFormatter2.default,
	        width: 90
	      }, {
	        key: 'Title',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'title' }),
	        resizable: true,
	        sortable: true,
	        width: 120
	      }, {
	        key: 'InvoiceNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        formatter: function formatter(_ref) {
	          var value = _ref.value;
	          return _react2.default.createElement(
	            'div',
	            {
	              style: { width: '100%', height: '100%' },
	              onDoubleClick: function onDoubleClick() {
	                if (value.substring(0, 1) === 'P' && value.substring(0, 2) !== 'PR') {
	                  _this2.props.printWarehouseReceive(value);
	                } else {
	                  alert("Cannot print this invoice");
	                }
	              }
	            },
	            value
	          );
	        },
	        width: 100
	      }, {
	        key: 'CheckNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: 'Amount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'charges' }),
	        resizable: true,
	        sortable: true,
	        formatter: _cashFormatter2.default,
	        width: 80
	      }, {
	        key: 'Payment',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credits' }),
	        resizable: true,
	        sortable: true,
	        formatter: _cashFormatter2.default,
	        width: 80
	      }, {
	        key: 'Balance',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' }),
	        resizable: true,
	        sortable: true,
	        formatter: _cashFormatter2.default,
	        width: 80
	      }];
	
	      var minHeight = this.props.minHeight;
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'VendorStatementDetailTable-dataGrid1' },
	        _react2.default.createElement(_reactDataGrid2.default, {
	          enableCellSelect: true,
	          onGridSort: this.handleGridSort,
	          columns: columns,
	          rowHeight: 25,
	          headerRowHeight: 45,
	          minHeight: minHeight || 150,
	          rowGetter: this.rowGetter,
	          rowsCount: this.getSize()
	        })
	      );
	    }
	  }]);
	
	  return VendorStatementDetailTable;
	}(_react.Component);
	
	var _default = VendorStatementDetailTable;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(VendorStatementDetailTable, 'VendorStatementDetailTable', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/VendorStatement/vendorStatementDetailTable.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/VendorStatement/vendorStatementDetailTable.jsx');
	}();

	;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _moment3 = __webpack_require__(41);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _numberWithCommas = __webpack_require__(35);
	
	var _selection = __webpack_require__(21);
	
	var _constants = __webpack_require__(11);
	
	var _RowLabelField = __webpack_require__(114);
	
	var _RowLabelField2 = _interopRequireDefault(_RowLabelField);
	
	var _cleanDates = __webpack_require__(22);
	
	var _vendorStatementDetailTable = __webpack_require__(222);
	
	var _vendorStatementDetailTable2 = _interopRequireDefault(_vendorStatementDetailTable);
	
	var _root_url = __webpack_require__(9);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _PrintIframe = __webpack_require__(63);
	
	var _PrintIframe2 = _interopRequireDefault(_PrintIframe);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	var _GenericDatePicker = __webpack_require__(48);
	
	var _GenericDatePicker2 = _interopRequireDefault(_GenericDatePicker);
	
	var _genericRadioFilter = __webpack_require__(50);
	
	var _genericRadioFilter2 = _interopRequireDefault(_genericRadioFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _moment4.default)(_moment2.default);
	
	var getBsStyle = function getBsStyle(input, value) {
	  return input === value ? 'success' : 'primary';
	};
	
	var VendorStatement = function (_Component) {
	  _inherits(VendorStatement, _Component);
	
	  _createClass(VendorStatement, null, [{
	    key: 'getQuarter',
	    value: function getQuarter() {
	      return Math.ceil((new Date().getMonth() + 1) / 3);
	    }
	  }]);
	
	  function VendorStatement() {
	    _classCallCheck(this, VendorStatement);
	
	    var _this = _possibleConstructorReturn(this, (VendorStatement.__proto__ || Object.getPrototypeOf(VendorStatement)).call(this));
	
	    _this.handlePrintFrameOnLoad = function () {
	      _this.setState({ pdfFrameLoaded: true });
	    };
	
	    _this.handlePrintFrameWarehouseOnLoad = function () {
	      _this.setState({ pdfFrameWarehouseLoaded: true });
	    };
	
	    _this.handleResize = function () {
	      _this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.vendorsPage - 100 });
	    };
	
	    _this.fetchVendorStatement = function (props) {
	      var Vendor = props.Vendor,
	          StatementType = props.StatementType;
	
	      if (Vendor) {
	        var vendor = Vendor.value || Vendor;
	        //const { fromDate, toDate } = getFromToDatesWithFilter(props);
	        _this.props.fetchVendorStatement(_this.state.fromDate, _this.state.toDate, vendor, StatementType, _this.state.paymentCutoffDate);
	      }
	    };
	
	    _this.handleTypeFilterChange = function (event) {
	      var filter = event.target.value;
	      var statementLines = _this.state.statementLines;
	
	      var filteredLines = void 0;
	      if (filter !== 'all') {
	        filteredLines = statementLines.filter(function (line) {
	          return line.type === filter;
	        });
	      } else {
	        filteredLines = statementLines;
	      }
	      _this.setState({
	        invoiceFilter: filter,
	        filteredLines: filteredLines
	      });
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.vendorsPage - 100,
	      statementLines: [],
	      // filteredLines: [],
	      invoiceAmount: 0,
	      paymentAmount: 0,
	      totalBalance: 0,
	      remainBalance: 0,
	      previousBalance: 0,
	      pdfFrameLoaded: true,
	      pdfFrameWarehouseLoaded: true,
	      // yearChanged: false,
	      // invoiceFilter: 'all',
	      fromDate: new Date('2017-08-18T00:00:00-0700'),
	      toDate: new Date(),
	      paymentCutoffDate: new Date(),
	      typeRadios: 'range',
	      year: new Date().getFullYear(),
	      month: new Date().getMonth() + 1,
	      quarter: VendorStatement.getQuarter()
	    };
	
	    _this.setMonthSelected = _this.setMonthSelected.bind(_this);
	    _this.setQuarterSelected = _this.setQuarterSelected.bind(_this);
	    _this.handleDateFilterChange = _this.handleDateFilterChange.bind(_this);
	    _this.setFromDate = _this.setFromDate.bind(_this);
	    _this.setToDate = _this.setToDate.bind(_this);
	    _this.setPaymentCutoffDate = _this.setPaymentCutoffDate.bind(_this);
	    return _this;
	  }
	
	  _createClass(VendorStatement, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var currentVendor = this.props.currentVendor;
	
	      if (currentVendor) {
	        this.props.fetchVendors();
	        this.props.setValue('vendorStatement', 'Vendor', { value: currentVendor.vendor_id });
	      } else {
	        this.props.fetchVendors();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      window.addEventListener('resize', this.handleResize);
	      // this.props.setDefaultOfForm('typeRadios', 'range', 'vendorStatement');
	      // this.props.setDefaultOfForm('FromDate', new Date('2017-08-18T00:00:00-0700'), 'vendorStatement');
	      // this.props.setDefaultOfForm('ToDate', new Date(), 'vendorStatement');
	      // this.props.setDefaultOfForm('StatementType', 'forwarded', 'vendorStatement');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.vendorStatement && nextProps.vendorStatement !== this.props.vendorStatement) {
	        var statementLines = nextProps.vendorStatement.ap_payment_lines;
	        var invoiceAmount = nextProps.vendorStatement.invoice_amount;
	        var paymentAmount = nextProps.vendorStatement.payment_amount;
	        var totalBalance = nextProps.vendorStatement.total_balance;
	        var remainingBalance = nextProps.vendorStatement.remaining_balance;
	        var forwardedBalance = nextProps.vendorStatement.forwarded_amount;
	        // let remainBalance = nextProps.vendorStatement.RemainingBalance;
	        // let previousBalance = 0;
	        // if (this.props.StatementType === 'forwarded') {
	        //   previousBalance = nextProps.vendorStatement.PreviousBalance;
	        //   remainBalance += previousBalance;
	        // }
	        // let filteredLines;
	        // const { invoiceFilter } = this.state;
	        // if (invoiceFilter !== 'all') {
	        //   filteredLines = statementLines.filter(line => line.type === invoiceFilter);
	        // } else {
	        //   filteredLines = statementLines;
	        // }
	        this.setState({
	          statementLines: statementLines,
	          // filteredLines,
	          invoiceAmount: invoiceAmount,
	          paymentAmount: paymentAmount,
	          totalBalance: totalBalance,
	          remainingBalance: remainingBalance,
	          forwardedBalance: forwardedBalance
	        });
	      }
	      // if (nextProps.StatementType && nextProps.StatementType !== this.props.StatementType) {
	      //   let year = '';
	      //   let month = '';
	      //   let quarter = '';
	      //   let date = -1;
	      //   const fromDate = this.props.FromDate ? formatDate(this.props.FromDate) : '1900-01-01';
	      //   const toDate = this.props.ToDate ? formatDate(this.props.ToDate) : '3000-01-01';
	      //   if (this.props.Vendor) {
	      //     const vendor = this.props.Vendor.value || this.props.Vendor;
	      //     if (this.props.Year) {
	      //       year = this.props.Year.value;
	      //       if (this.props.Month) {
	      //         if (this.props.Month.value < 10) {
	      //             month += `0${this.props.Month.value}`;
	      //         } else {
	      //           month = this.props.Month.value;
	      //         }
	      //       }
	      //       if (this.props.Quarter) {
	      //         quarter = this.props.Quarter.value;
	      //       }
	      //       date = `${year}${month}${quarter}`;
	      //       this.props.fetchVendorStatement(fromDate, toDate, vendor, nextProps.StatementType, date);
	      //     } else {
	      //       this.props.fetchVendorStatement(fromDate, toDate, vendor, nextProps.StatementType, date);
	      //     }
	      //   }
	      // }
	      if (nextProps.typeRadios && nextProps.typeRadios !== this.props.typeRadios) {
	        this.resetDates();
	      }
	
	      // if (!this.props.typeRadios) {
	      //   this.props.setDefaultOfForm('typeRadios', 'range', 'vendorStatement');
	      //   this.props.setDefaultOfForm('FromDate', new Date('2017-08-18T00:00:00-0700'), 'vendorStatement');
	      //   this.props.setDefaultOfForm('ToDate', new Date(), 'vendorStatement');
	      // }
	      // if (nextProps.Year && nextProps.Year !== this.props.Year) {
	      //   this.setState({ yearChanged: !this.state.yearChanged });
	      // }
	
	      if (nextProps.Vendor && nextProps.Vendor !== this.props.Vendor) {
	        // console.log("this props, and nextProps", this.props, nextProps);
	        this.props.fetchVendorDetail(nextProps.Vendor.value || nextProps.Vendor);
	        // this.fetchVendorStatement(nextProps);
	        var _statementLines = [];
	        var _invoiceAmount = 0;
	        var _paymentAmount = 0;
	        var _totalBalance = 0;
	        var _remainingBalance = 0;
	        var _forwardedBalance = 0;
	        this.setState({
	          invoiceAmount: _invoiceAmount,
	          paymentAmount: _paymentAmount,
	          totalBalance: _totalBalance,
	          remainingBalance: _remainingBalance,
	          forwardedBalance: _forwardedBalance,
	          statementLines: _statementLines
	        });
	        this.fetchVendorStatement(nextProps);
	      }
	
	      if (nextProps.apReport && nextProps.apReport !== this.props.apReport) {
	        this.setState({ pdfFrameLoaded: false });
	      }
	      if (nextProps.warehouseReceivePdf && nextProps.warehouseReceivePdf !== this.props.warehouseReceivePdf) {
	        this.setState({ pdfFrameWarehouseLoaded: false });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState.pdfFrameLoaded !== this.state.pdfFrameLoaded && this.state.pdfFrameLoaded === false) {
	        return false;
	      }
	      if (nextState.pdfFrameWarehouseLoaded !== this.state.pdfFrameWarehouseLoaded && this.state.pdfFrameWarehouseLoaded === false) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'setToDate',
	    value: function setToDate(e) {
	      var _this2 = this;
	
	      if (!this.props.Vendor) {
	        alert('Please select a Vendor!');
	        return;
	      }
	      if (e < this.state.fromDate) {
	        return;
	      }
	      this.setState({ toDate: e }, function () {
	        _this2.props.fetchVendorStatement(_this2.state.fromDate, e, _this2.props.Vendor.value, _this2.props.StatementType, _this2.state.paymentCutoffDate);
	      });
	    }
	  }, {
	    key: 'setFromDate',
	    value: function setFromDate(e) {
	      var _this3 = this;
	
	      if (!this.props.Vendor) {
	        alert('Please select a Vendor!');
	        return;
	      }
	      if (e > this.state.toDate) {
	        return;
	      }
	      this.setState({ fromDate: e }, function () {
	        _this3.props.fetchVendorStatement(e, _this3.state.toDate, _this3.props.Vendor.value, _this3.props.StatementType, _this3.state.paymentCutoffDate);
	      });
	    }
	  }, {
	    key: 'setMonthSelected',
	    value: function setMonthSelected(e) {
	      if (!this.props.Vendor) {
	        alert('Please select a Vendor!');
	        return;
	      }
	      this.setState({ month: e.value }, this.formatFetchMonth);
	    }
	  }, {
	    key: 'setQuarterSelected',
	    value: function setQuarterSelected(e) {
	      if (!this.props.Vendor) {
	        alert('Please select a Vendor!');
	        return;
	      }
	      this.setState({ quarter: e.value }, this.formatFetchQuarter);
	    }
	  }, {
	    key: 'setPaymentCutoffDate',
	    value: function setPaymentCutoffDate(e) {
	      var _this4 = this;
	
	      if (!this.props.Vendor) {
	        alert('Please select a Vendor!');
	        return;
	      }
	      this.setState({ paymentCutoffDate: e }, function () {
	        _this4.props.fetchVendorStatement(_this4.state.fromDate, _this4.state.toDate, _this4.props.Vendor.value, _this4.props.StatementType, e);
	      });
	    }
	  }, {
	    key: 'getYearOptions',
	    value: function getYearOptions() {
	      var yearOptions = [];
	      var year = new Date().getFullYear() + 1;
	      while (year > 2017) {
	        year -= 1;
	        yearOptions.push({ value: year, label: year });
	      }
	      return yearOptions;
	    }
	  }, {
	    key: 'getMonthOptions',
	    value: function getMonthOptions() {
	      var year = this.state.year;
	
	      var dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	      var monthOptions = [];
	      var currentyear = new Date().getFullYear();
	      var month = 0;
	      if (year) {
	        if (year < currentyear) {
	          month = 12;
	        } else {
	          month = new Date().getMonth() + 1;
	        }
	        for (var i = 1; i < month + 1; i += 1) {
	          monthOptions.push({ value: i, label: dateMap[i - 1] });
	        }
	      }
	      return monthOptions;
	    }
	  }, {
	    key: 'getQuarterOptions',
	    value: function getQuarterOptions() {
	      var year = this.state.year;
	
	      var quarterOptions = [];
	      var currentyear = new Date().getFullYear();
	      var quarter = 0;
	      if (year) {
	        if (year < currentyear) {
	          quarter = 4;
	        } else {
	          var month = new Date().getMonth() + 1;
	          quarter = Math.ceil(month / 3);
	        }
	      }
	      for (var i = 1; i < quarter + 1; i += 1) {
	        quarterOptions.push({ value: i, label: i });
	      }
	      return quarterOptions;
	    }
	  }, {
	    key: 'getVendorNameOptions',
	    value: function getVendorNameOptions() {
	      var vendorOptions = [];
	      this.props.vendors.map(function (vendor) {
	        vendorOptions.push({ value: vendor.Vendor_id, label: vendor.Name });
	      });
	      return vendorOptions;
	    }
	  }, {
	    key: 'getVendorNumOptions',
	    value: function getVendorNumOptions() {
	      var vendorOptions = [];
	      this.props.vendors.map(function (vendor) {
	        vendorOptions.push({ value: vendor.Vendor_id, label: vendor.VendorNum });
	      });
	      return vendorOptions;
	    }
	  }, {
	    key: 'getVendorPhoneOptions',
	    value: function getVendorPhoneOptions() {
	      var vendorOptions = [];
	      this.props.vendors.map(function (vendor) {
	        vendorOptions.push({ value: vendor.Vendor_id, label: vendor.Telephone });
	      });
	      return vendorOptions;
	    }
	  }, {
	    key: 'getVendorDescriptionOptions',
	    value: function getVendorDescriptionOptions() {
	      var vendorOptions = [];
	      this.props.vendors.map(function (vendor) {
	        vendorOptions.push({ value: vendor.Vendor_id, label: vendor.Description });
	      });
	      return vendorOptions;
	    }
	  }, {
	    key: 'getBillingAddress1',
	    value: function getBillingAddress1() {
	      var currentVendorDetail = this.props.currentVendorDetail;
	
	      if (currentVendorDetail && currentVendorDetail.Billing) {
	        var Address1 = currentVendorDetail.Billing.Street;
	        return Address1;
	      }
	      return '';
	    }
	  }, {
	    key: 'getBillingAddress2',
	    value: function getBillingAddress2() {
	      var currentVendorDetail = this.props.currentVendorDetail;
	
	      if (currentVendorDetail && currentVendorDetail.Billing) {
	        var Address2 = currentVendorDetail.Billing.City + ' ' + currentVendorDetail.Billing.State + ' ' + currentVendorDetail.Billing.Zip;
	        return Address2;
	      }
	      return '';
	    }
	  }, {
	    key: 'resetDates',
	    value: function resetDates() {
	      // this.props.setValue('vendorStatement', 'FromDate', '');
	      // this.props.setValue('vendorStatement', 'ToDate', '');
	      this.props.setValue('vendorStatement', 'Year', '');
	      this.props.setValue('vendorStatement', 'Month', '');
	      this.props.setValue('vendorStatement', 'Quarter', '');
	    }
	  }, {
	    key: 'formatFetchMonth',
	    value: function formatFetchMonth() {
	      var _this5 = this;
	
	      var _state = this.state,
	          year = _state.year,
	          month = _state.month,
	          typeRadios = _state.typeRadios;
	
	      var FromDate = (0, _moment2.default)([year, month - 1]);
	      var ToDate = (0, _moment2.default)(FromDate).endOf('month');
	      FromDate = FromDate.toISOString();
	      ToDate = ToDate.toISOString();
	      this.setState({
	        fromDate: FromDate, toDate: ToDate, typeRadios: typeRadios
	      }, function () {
	        _this5.props.fetchVendorStatement(FromDate, ToDate, _this5.props.Vendor.value, _this5.props.StatementType, _this5.state.paymentCutoffDate);
	      });
	    }
	  }, {
	    key: 'formatFetchQuarter',
	    value: function formatFetchQuarter() {
	      var _this6 = this;
	
	      var _state2 = this.state,
	          year = _state2.year,
	          quarter = _state2.quarter,
	          typeRadios = _state2.typeRadios;
	
	      var FromDate = (0, _moment2.default)([year, (quarter - 1) * 3]);
	      var ToDate = (0, _moment2.default)([year, quarter * 3 - 1]).endOf('month');
	      FromDate = FromDate.toISOString();
	      ToDate = ToDate.toISOString();
	      this.setState({
	        fromDate: FromDate, toDate: ToDate, typeRadios: typeRadios
	      }, function () {
	        _this6.props.fetchVendorStatement(FromDate, ToDate, _this6.props.Vendor.value, _this6.props.StatementType, _this6.state.paymentCutoffDate);
	      });
	    }
	  }, {
	    key: 'handleDateFilterChange',
	    value: function handleDateFilterChange(type) {
	      var _this7 = this;
	
	      if (!this.props.Vendor) {
	        alert('Please select a Vendor!');
	        return;
	      }
	      if (type === 'month') {
	        this.setState({ typeRadios: type, year: new Date().getFullYear(), month: new Date().getMonth() + 1 }, this.formatFetchMonth);
	      } else if (type === 'quarter') {
	        this.setState({ typeRadios: type, year: new Date().getFullYear(), quarter: VendorStatement.getQuarter() }, this.formatFetchQuarter);
	      } else if (type === 'range' && type !== this.state.typeRadios) {
	        this.setState({
	          typeRadios: type, fromDate: new Date('2017-08-18T00:00:00-0700'), toDate: new Date()
	        }, function () {
	          _this7.props.fetchVendorStatement(_this7.state.fromDate, _this7.state.toDate, _this7.props.Vendor.value, _this7.props.StatementType);
	        });
	      }
	    }
	  }, {
	    key: 'renderDateSelector',
	    value: function renderDateSelector() {
	      var _this8 = this;
	
	      var yearOptions = this.getYearOptions();
	      if (this.state.typeRadios === 'range') {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'report-table-filters', id: 'vendor-statement-date-selector' },
	            _react2.default.createElement(
	              'label',
	              { className: 'from-label' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'from' })
	            ),
	            (0, _GenericDatePicker2.default)({
	              setDate: this.setFromDate,
	              selectedDate: this.state.fromDate
	            }),
	            _react2.default.createElement(
	              'label',
	              { className: 'to-label' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'to' })
	            ),
	            (0, _GenericDatePicker2.default)({
	              setDate: this.setToDate,
	              selectedDate: this.state.toDate
	            })
	          )
	        );
	      } else if (this.state.typeRadios === 'month') {
	        var monthOptions = this.getMonthOptions();
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { className: 'report-table-filters', id: 'vendor-statement-date-selector' },
	            (0, _GenericSelection2.default)({
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'year' }),
	              options: yearOptions,
	              value: this.state.year,
	              setSelected: function setSelected(e) {
	                _this8.setState({ year: e.value });
	              }
	            }),
	            (0, _GenericSelection2.default)({
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'month' }),
	              options: monthOptions,
	              value: this.state.month,
	              setSelected: this.setMonthSelected
	            })
	          )
	        );
	      }
	      var quarterOptions = this.getQuarterOptions();
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 12 },
	        _react2.default.createElement(
	          'div',
	          { className: 'report-table-filters', id: 'vendor-statement-date-selector' },
	          (0, _GenericSelection2.default)({
	            translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'year' }),
	            options: yearOptions,
	            value: this.state.year,
	            setSelected: function setSelected(e) {
	              _this8.setState({ year: e.value });
	            }
	          }),
	          (0, _GenericSelection2.default)({
	            translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quarter' }),
	            options: quarterOptions,
	            value: this.state.quarter,
	            setSelected: this.setQuarterSelected
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderVendorDetail',
	    value: function renderVendorDetail() {
	      var vendorNameOptions = this.getVendorNameOptions();
	      var vendorNumOptions = this.getVendorNumOptions();
	      var vendorPhoneOptions = this.getVendorPhoneOptions();
	      var currentVendorDetail = this.props.currentVendorDetail;
	
	      var contact = null;
	      var phone = null;
	      if (currentVendorDetail && currentVendorDetail.Billing) {
	        contact = currentVendorDetail.Billing.FirstName + ' ' + currentVendorDetail.Billing.LastName;
	        phone = currentVendorDetail.Billing.Telephone;
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 4, id: 'vendor-details' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_information' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'asteriksReq' },
	                '*'
	              ),
	              ' '
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'vendor-name-dropdown', className: 'col-xs-8' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'Vendor', component: _selection.Selection, matchPos: 'any', options: vendorNameOptions })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_no' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'vendor-id-dropdown', className: 'col-xs-8' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'Vendor', component: _selection.Selection, matchPos: 'any', options: vendorNumOptions })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'vendor-phone-dropdown', className: 'col-xs-8' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'Vendor', component: _selection.Selection, matchPos: 'any', options: vendorPhoneOptions })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 4, xsOffset: 1, id: 'billing-info' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'billing_information' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'contact' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 9 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                !this.props.currentVendorDetail && _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 9 },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_please_select_a_vendor' })
	                ),
	                this.props.currentVendorDetail && contact
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 9 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                !this.props.currentVendorDetail && _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-9' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: '' })
	                ),
	                this.props.currentVendorDetail && phone
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group mb0' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' })
	            ),
	            this.props.currentVendorDetail && _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 9 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                this.getBillingAddress1()
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                this.getBillingAddress2()
	              )
	            )
	          )
	        ),
	        ' '
	      );
	    }
	  }, {
	    key: 'renderAmountDetail',
	    value: function renderAmountDetail() {
	      var _state3 = this.state,
	          invoiceAmount = _state3.invoiceAmount,
	          paymentAmount = _state3.paymentAmount,
	          totalBalance = _state3.totalBalance,
	          remainingBalance = _state3.remainingBalance,
	          forwardedBalance = _state3.forwardedBalance;
	      // const { StatementType } = this.props;
	      // const renderprevious = () => {
	      //   if (StatementType === 'forwarded') {
	      //     return (
	      //       <RowLabelField
	      //         translation='previous_balance_forward: '
	      //         value={`$${previousBalance}`}
	      //       />
	      //     );
	      //   }
	      // };
	
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 3 },
	        _react2.default.createElement(_RowLabelField2.default, {
	          translation: 'balance_forward: ',
	          value: '$' + (0, _numberWithCommas.numberWithCommas)(forwardedBalance) || 0,
	          right: 4
	        }),
	        _react2.default.createElement(_RowLabelField2.default, {
	          translation: 'total_invoice_amount: ',
	          value: '$' + (0, _numberWithCommas.numberWithCommas)(invoiceAmount) || 0,
	          right: 4
	        }),
	        _react2.default.createElement(_RowLabelField2.default, {
	          translation: 'total_payment: ',
	          value: '$' + (0, _numberWithCommas.numberWithCommas)(paymentAmount) || 0,
	          right: 4
	        }),
	        _react2.default.createElement(_RowLabelField2.default, {
	          translation: 'outstanding_balance: ',
	          value: '$' + (0, _numberWithCommas.numberWithCommas)(totalBalance) || 0,
	          right: 4
	        }),
	        _react2.default.createElement(_RowLabelField2.default, {
	          translation: 'remaining_balance: ',
	          value: '$' + (0, _numberWithCommas.numberWithCommas)(remainingBalance) || 0,
	          right: 4
	        })
	      );
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      if (this.props.vendorStatementIsLoading && !this.props.vendorStatementError) {
	        return _react2.default.createElement(
	          'div',
	          { id: 'spinner' },
	          _react2.default.createElement(_spinner2.default, null)
	        );
	      } else if (this.props.vendorStatementError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'something_unexpected_happened' })
	          )
	        );
	      }
	      var statementLines = this.state.statementLines;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { className: 'react-table-ar-ap-vendor-statement' },
	            _react2.default.createElement(_vendorStatementDetailTable2.default, {
	              printWarehouseReceive: this.props.printWarehouseReceive,
	              rows: statementLines,
	              minHeight: 500
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderToolbarButtons',
	    value: function renderToolbarButtons() {
	      var _this9 = this;
	
	      var Vendor = this.props.Vendor;
	      // const { fromDate, toDate } = getFromToDatesWithFilter(this.props);
	
	      var _state4 = this.state,
	          fromDate = _state4.fromDate,
	          toDate = _state4.toDate;
	
	      var dates = (0, _cleanDates.toFromDates)(-1, fromDate, toDate);
	      var vendor = void 0;
	      if (Vendor) {
	        vendor = Vendor.value || Vendor;
	      }
	      var paymentCutoffDate = (0, _cleanDates.getFromToDates)(this.state.paymentCutoffDate).toDate;
	      var token = localStorage.getItem('token');
	      var apUrl = vendor ? '/AP/new?vend_id=' + vendor : '/AP/new';
	      var simplifiedExport = _root_url.ROOT_URL + 'v1/ap/report/aged/' + vendor + '/simplifiedexcel/?start_date=' + dates.fromDate + '&end_date=' + dates.toDate + '&cut_off_date=' + paymentCutoffDate + '&Bearer=' + token;
	      var detailedExport = _root_url.ROOT_URL + 'v1/ap/report/aged/' + vendor + '/excel/?start_date=' + dates.fromDate + '&end_date=' + dates.toDate + '&cut_off_date=' + paymentCutoffDate + '&Bearer=' + token;
	      return _react2.default.createElement(
	        _reactBootstrap.ButtonToolbar,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            href: apUrl,
	            disabled: !(0, _permissions2.default)('change_account_payable')
	          },
	          _react2.default.createElement('em', { className: 'fa fa-plus' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_ap' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            href: simplifiedExport,
	            disabled: !vendor || !(0, _permissions2.default)('print_vendor_statement')
	          },
	          _react2.default.createElement('em', { className: 'fa fa-download' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'simplified_excel' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            href: detailedExport,
	            disabled: !vendor || !(0, _permissions2.default)('print_vendor_statement')
	          },
	          _react2.default.createElement('em', { className: 'fa fa-download' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'detailed_excel' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            type: 'button',
	            onClick: function onClick() {
	              _this9.props.printAPReport(vendor, dates.fromDate, dates.toDate, paymentCutoffDate, true);
	            },
	            disabled: !vendor || !(0, _permissions2.default)('print_vendor_statement')
	          },
	          _react2.default.createElement('em', { className: 'fa fa-print' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'simplified_statement' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            type: 'button',
	            onClick: function onClick() {
	              _this9.props.printAPReport(vendor, dates.fromDate, dates.toDate, paymentCutoffDate, false);
	            },
	            disabled: !vendor || !(0, _permissions2.default)('print_vendor_statement')
	          },
	          _react2.default.createElement('em', { className: 'fa fa-print' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'detailed_statement' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'danger',
	            type: 'button',
	            onClick: function onClick() {
	              _this9.props.router.push('/vendorStatementMain');
	            }
	          },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'back' })
	        )
	      );
	    }
	  }, {
	    key: 'renderPrintIframe',
	    value: function renderPrintIframe() {
	      var pdfFrameLoaded = this.state.pdfFrameLoaded;
	      var apReport = this.props.apReport;
	
	      return _react2.default.createElement(_PrintIframe2.default, {
	        id: 'vendorStatementPDF',
	        loaded: pdfFrameLoaded,
	        name: 'vendorStatementPDF',
	        onLoad: this.handlePrintFrameOnLoad,
	        pdf: apReport,
	        title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ap_report' })
	      });
	    }
	  }, {
	    key: 'renderPrintWarehouseIframe',
	    value: function renderPrintWarehouseIframe() {
	      var pdfFrameWarehouseLoaded = this.state.pdfFrameWarehouseLoaded;
	      var warehouseReceivePdf = this.props.warehouseReceivePdf;
	
	      return _react2.default.createElement(_PrintIframe2.default, {
	        id: 'warehousePDF',
	        loaded: pdfFrameWarehouseLoaded,
	        name: 'warehousePDF',
	        onLoad: this.handlePrintFrameWarehouseOnLoad,
	        pdf: warehouseReceivePdf,
	        title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_print' })
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_slashsign_ap' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_statement' })
	          )
	        ),
	        this.renderToolbarButtons(),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'vendor-statement' },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'fieldset',
	              { className: 'form-horizontal' },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { id: 'vendor-statement-vendor-info' },
	                this.renderVendorDetail()
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { id: 'date-range-picker', className: 'form-horizontal' },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 1, id: 'filter-title-center' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'text-right' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'statement_range' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'colon' },
	                      ':'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    'div',
	                    { id: 'status-filter-radios' },
	                    (0, _genericRadioFilter2.default)({
	                      content: [{
	                        option: 'range',
	                        id: 'dateRange-radio-filter',
	                        name: 'dateFilterRadios',
	                        labelName: 'date_range'
	                      }, {
	                        option: 'quarter',
	                        id: 'quarter-radio-filter',
	                        name: 'dateFilterRadios',
	                        labelName: 'quarter'
	                      }, {
	                        option: 'month',
	                        id: 'month-radio-filter',
	                        name: 'dateFilterRadios',
	                        labelName: 'month'
	                      }],
	                      value: this.state.typeRadios,
	                      handleOnClick: this.handleDateFilterChange,
	                      type: 'buttons'
	                    })
	                  ),
	                  this.renderDateSelector()
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 1, id: 'filter-title-center' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'text-right' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_cutoff_date' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'colon' },
	                      ':'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 2, id: 'status-filter-radios' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    (0, _GenericDatePicker2.default)({
	                      setDate: this.setPaymentCutoffDate,
	                      selectedDate: this.state.paymentCutoffDate
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { style: { position: "relative", left: "5px", top: "3px" } },
	                    '(simplified statement only)'
	                  )
	                ),
	                this.renderAmountDetail()
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'position-relative table-collapse-fix mb0' },
	                  this.renderTable()
	                )
	              )
	            )
	          )
	        ),
	        this.renderPrintIframe(),
	        this.renderPrintWarehouseIframe()
	      );
	    }
	  }]);
	
	  return VendorStatement;
	}(_react.Component);
	
	var _default = VendorStatement;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getBsStyle, 'getBsStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/vendorStatement.jsx');
	
	  __REACT_HOT_LOADER__.register(VendorStatement, 'VendorStatement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/vendorStatement.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/vendorStatement.jsx');
	}();

	;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _moment3 = __webpack_require__(41);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _datePicker = __webpack_require__(27);
	
	var _inputField = __webpack_require__(16);
	
	var _priceFormatter = __webpack_require__(56);
	
	var _priceFormatter2 = _interopRequireDefault(_priceFormatter);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _numberWithCommas = __webpack_require__(35);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _moment4.default)(_moment2.default);
	
	var getBsStyle = function getBsStyle(input, value) {
	  return input === value ? 'success' : 'primary';
	};
	
	var RowRenderer = function (_Component) {
	  _inherits(RowRenderer, _Component);
	
	  function RowRenderer() {
	    _classCallCheck(this, RowRenderer);
	
	    return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(RowRenderer, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      //here we are just changing the style
	      //but we could replace this with anything we liked, cards, images, etc
	      //usually though it will just be a matter of wrapping a div, and then calling back through to the grid
	      return _react2.default.createElement(
	        'div',
	        { onDoubleClick: function onDoubleClick() {
	            _this2.props.onDoubleClick(_this2.props.row);
	          } },
	        _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	      );
	    }
	  }]);
	
	  return RowRenderer;
	}(_react.Component);
	
	RowRenderer.PropTypes = {
	  onDoubleClick: _react2.default.PropTypes.func
	};
	
	var renderVendorTypeRadios = function renderVendorTypeRadios(props) {
	  var titleClass = (0, _classnames2.default)({ 'parsley-error-label': props.meta.error }, 'col-xs-4');
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'long-radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'All') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'all-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'all-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'All', checked: props.input.value === 'All' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'Active') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'active-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'active-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'Active', checked: props.input.value === 'Active' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'active' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'Inactive') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'inactive-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'inactive-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'Inactive', checked: props.input.value === 'Inactive' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inactive' })
	        )
	      )
	    )
	  );
	};
	
	var VendorStatementMain = function (_Component2) {
	  _inherits(VendorStatementMain, _Component2);
	
	  function VendorStatementMain() {
	    _classCallCheck(this, VendorStatementMain);
	
	    var _this3 = _possibleConstructorReturn(this, (VendorStatementMain.__proto__ || Object.getPrototypeOf(VendorStatementMain)).call(this));
	
	    _this3.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.vendorsPage,
	      rows: [],
	      filters: {},
	      sortColumn: null,
	      sortDirection: null,
	
	      amount00_30: 0,
	      amount31_60: 0,
	      amount61_90: 0,
	      amount_91: 0,
	      current: 0,
	      grand_amount: 0,
	      Days: ''
	    };
	    _this3.handleResize = _this3.handleResize.bind(_this3);
	    //this.fetchCustomerStatementList = this.fetchCustomerStatementList.bind(this);
	    _this3.fetchVendorStatementList = _this3.fetchVendorStatementList.bind(_this3);
	    _this3.statementDetail = _this3.statementDetail.bind(_this3);
	    return _this3;
	  }
	
	  _createClass(VendorStatementMain, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.setDefaultOfForm('typeRadios', 'Active', 'vendorStatementMain');
	      this.props.setDefaultOfForm('Days', new Date(), 'vendorStatementMain');
	      //this.props.fetchCustomerStatementList('Active', formatDate(new Date()));
	      this.props.fetchVendorStatementList('Active', (0, _moment2.default)().format('YYYY-MM-DD'));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      window.addEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.vendorStatementList && nextProps.vendorStatementList !== this.props.vendorStatementList) {
	        var _nextProps$vendorStat = nextProps.vendorStatementList,
	            statement_lines = _nextProps$vendorStat.statement_lines,
	            amount00_30 = _nextProps$vendorStat.amount00_30,
	            amount31_60 = _nextProps$vendorStat.amount31_60,
	            amount61_90 = _nextProps$vendorStat.amount61_90,
	            amount_91 = _nextProps$vendorStat.amount_91,
	            current = _nextProps$vendorStat.current,
	            grand_amount = _nextProps$vendorStat.grand_amount;
	
	
	        this.setState({
	          rows: statement_lines,
	          amount00_30: parseFloat(amount00_30).toFixed(2) || 0,
	          amount31_60: parseFloat(amount31_60).toFixed(2) || 0,
	          amount61_90: parseFloat(amount61_90).toFixed(2) || 0,
	          amount_91: parseFloat(amount_91).toFixed(2) || 0,
	          current: parseFloat(current).toFixed(2) || 0,
	          grand_amount: parseFloat(grand_amount).toFixed(2) || 0
	        });
	      }
	
	      if (nextProps.typeRadios && nextProps.typeRadios != this.props.typeRadios) {
	        if (this.props.Days) {
	          var days = (0, _moment2.default)(this.props.Days).format('YYYY-MM-DD');
	          //this.props.fetchCustomerStatementList(nextProps.typeRadios, days)
	          this.props.fetchVendorStatementList(nextProps.typeRadios, days);
	        }
	      }
	      if (nextProps.Days && nextProps.Days !== this.props.Days) {
	        var Days = nextProps.Days;
	
	        this.setState({ Days: Days }, this.fetchVendorStatementList);
	      }
	      if (!nextProps.typeRadios) {
	        this.props.setDefaultOfForm('typeRadios', 'Active', 'vendorStatementMain');
	      }
	      if (!nextProps.Days) {
	        this.props.setDefaultOfForm('Days', new Date(), 'vendorStatementMain');
	      }
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.vendorsPage });
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      var formattedDate = date.getFullYear() + '-';
	
	      formattedDate += date.getMonth() + 1 + '-';
	      if (date.getDate() < 10) {
	        formattedDate += '0' + date.getDate();
	      } else {
	        formattedDate += date.getDate();
	      }
	
	      return formattedDate;
	    }
	  }, {
	    key: 'statementDetail',
	    value: function statementDetail() {
	
	      var currentVendor = arguments[0];
	      this.props.resetCurrentVendor();
	      this.props.selectVendor(currentVendor);
	      this.context.router.push('/vendorStatement');
	    }
	    // this.context.router.push('/products/'+currentInventory.Product_id);
	
	
	    // fetchCustomerStatementList() {
	    //   if (this.props.Days){
	    //     let days = this.formatDate(this.props.Days)
	    //     this.props.fetchCustomerStatementList(this.props.typeRadios, days);
	    //     }
	    //   }
	
	  }, {
	    key: 'fetchVendorStatementList',
	    value: function fetchVendorStatementList() {
	      if (this.state.Days) {
	        var days = (0, _moment2.default)(this.state.Days).format('YYYY-MM-DD');
	        this.props.fetchVendorStatementList(this.props.typeRadios, days);
	      }
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this4 = this;
	
	      if (this.props.vendorStatementListIsLoading && !this.props.vendorStatementListError) {
	        return _react2.default.createElement(
	          'div',
	          { id: 'spinner' },
	          _react2.default.createElement(_spinner2.default, null)
	        );
	      } else if (this.props.vendorStatementListError) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'something_unexpected_happened' })
	        );
	      } else {
	        // Parameters of the react-data-grid
	
	        var tableHeight = window.innerHeight < 930 ? 510 : 510;
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this4.state);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          _this4.setState(function (prevState) {
	            return _extends({}, prevState, {
	              sortColumn: sortColumn,
	              sortDirection: sortDirection
	            });
	          });
	        };
	
	        var handleFilterChange = function handleFilterChange(filter) {
	          var newFilters = Object.assign({}, _this4.state.filters);
	          if (filter.filterTerm) {
	            newFilters[filter.column.key] = filter;
	          } else {
	            delete newFilters[filter.column.key];
	          }
	          _this4.setState({ filters: newFilters });
	        };
	
	        //Custom Formatter component
	
	        var DateFormatter = _react2.default.createClass({
	          displayName: 'DateFormatter',
	          render: function render() {
	            if (this.props.value) {
	              var dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	              var date = new Date(this.props.value);
	              var index = dateMap.indexOf(date.toString().slice(4, 3));
	              var localDate = index + date.toString().slice(8, 6);
	              return _react2.default.createElement(
	                'span',
	                null,
	                date.toString().slice(4, 15)
	              );;
	            } else return _react2.default.createElement(
	              'span',
	              { className: 'label label-danger' },
	              '-'
	            );
	          }
	        });
	
	        // Column difinition
	
	        var columns = [{
	          key: 'VendorNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_num' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 120
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_name' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 200
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 100
	        },
	        /* { // Commented: 11/17/17 branch: feature/ARAP
	            key: 'current',
	            name: <Translate value="current" />,
	            resizable: true,
	            sortable: true,
	            width: 80,
	            formatter: PriceFormatter,
	        }, */
	        {
	          key: 'amount00_30',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '00_dashsign_30_days' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 80,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'amount31_60',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '31_dashsign_60_days' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 80,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'amount61_90',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '61_dashsign_90_days' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 80,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'amount_91',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '91_plussign_days' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 80,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'total_amount',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_amount' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 100,
	          formatter: _cashFormatter2.default
	        }];
	
	        //React Table Purchase Order Full Table
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { className: 'react-table-ar-ap-vendor-list-statement', id: 'VendorStatementMain-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: this.statementDetail }),
	                rowKey: 'Deliver_Vendor_id',
	                enableCellSelect: true,
	                onGridSort: handleGridSort,
	                columns: columns,
	                rowHeight: 25,
	                headerRowHeight: 45,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                minHeight: tableHeight
	                // toolbar={<Toolbar enableFilter />}
	                // onAddFilter={handleFilterChange}
	              })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderSimplifiedExportButton',
	    value: function renderSimplifiedExportButton() {
	      var typeRadios = this.props.typeRadios;
	      var date = this.props.Days;
	
	      date = (0, _moment2.default)(date).endOf('day').toISOString();
	      date = 'PostingDate=' + date;
	      var token = localStorage.getItem('token');
	      var url = _root_url.ROOT_URL + 'v1/ap/report/aged/' + (typeRadios || 'Active') + '/simplified/?' + date + '&Bearer=' + token;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          href: url
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'simplified_excel' })
	      );
	    }
	  }, {
	    key: 'renderDetailedExportButton',
	    value: function renderDetailedExportButton() {
	      var token = localStorage.getItem('token');
	      var typeRadios = this.props.typeRadios;
	      var date = this.props.Days;
	
	      date = (0, _moment2.default)(date).endOf('day').toISOString();
	      date = 'PostingDate=' + date;
	      var exportUrl = _root_url.ROOT_URL + 'v1/ap/report/aged/' + (typeRadios || 'Active') + '/excel/?' + date + '&Bearer=' + token;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'pull-right',
	          href: exportUrl
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'detailed_excel' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_slashsign_ap' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ap_aged_report' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            null,
	            this.renderSimplifiedExportButton(),
	            this.renderDetailedExportButton()
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'vendor-statement' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { id: 'date-range-picker', className: 'form-horizontal' },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      'h3',
	                      { className: 'text-right text-nowrap' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'statement_date' }),
	                      _react2.default.createElement(
	                        'span',
	                        { classNames: 'colon' },
	                        ':'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 10 },
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'statusFilterRadios' },
	                      _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        { className: 'radio-filter-buttons' },
	                        _react2.default.createElement(
	                          _reactBootstrap.Button,
	                          { bsStyle: 'primary' },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Days', placeholder: 'Date', component: _datePicker.DatePicker })
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      'h3',
	                      { className: 'text-right text-nowrap' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_status' }),
	                      _react2.default.createElement(
	                        'span',
	                        { classNames: 'colon' },
	                        ':'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 10 },
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'statusFilterRadios' },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'typeRadios', component: renderVendorTypeRadios })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 12 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { className: 'position-relative mb0', id: 'table-height-fix' },
	                    this.renderTable()
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 12 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { className: 'position-relative mb0' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-6 text-nowrap' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: '00_dashsign_30_days' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'dollar-sign' },
	                          ' $$'
	                        ),
	                        ':\xA0'
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'amount00_30', component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.amount00_30) || 0 })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-6 text-nowrap' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: '31_dashsign_60_days' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'dollar-sign' },
	                          ' $$'
	                        ),
	                        ':\xA0'
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'amount31_60', component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.amount31_60) || 0 })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-6 text-nowrap' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: '61_dashsign_90_days' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'dollar-sign' },
	                          ' $$'
	                        ),
	                        ':\xA0'
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'amount61_90', component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.amount61_90) || 0 })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-6 text-nowrap' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: '91_plussign_days' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'dollar-sign' },
	                          ' $$'
	                        ),
	                        ':\xA0'
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'amount_91', component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.amount_91) || 0 })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-6 text-nowrap' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'grand_total' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'dollar-sign' },
	                          ' $$'
	                        ),
	                        ':\xA0'
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'grand_amount', component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.grand_amount) || 0 })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	        //---------------
	        // End HTML: Purchase Order List
	        //---------------
	
	      );
	    }
	  }]);
	
	  return VendorStatementMain;
	}(_react.Component);
	
	VendorStatementMain.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = VendorStatementMain;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getBsStyle, 'getBsStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/vendorStatementMain.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/vendorStatementMain.jsx');
	
	  __REACT_HOT_LOADER__.register(renderVendorTypeRadios, 'renderVendorTypeRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/vendorStatementMain.jsx');
	
	  __REACT_HOT_LOADER__.register(VendorStatementMain, 'VendorStatementMain', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/vendorStatementMain.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AP/vendorStatementMain.jsx');
	}();

	;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _inputField = __webpack_require__(16);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _selection = __webpack_require__(21);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _datePicker = __webpack_require__(27);
	
	var _rowRenderer = __webpack_require__(64);
	
	var _rowRenderer2 = _interopRequireDefault(_rowRenderer);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _dateFormat = __webpack_require__(39);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getBsStyle = function getBsStyle(input, value) {
	  return input == value ? "success" : "primary";
	};
	
	var renderRadio = function renderRadio(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-6' },
	      _react2.default.createElement(
	        'label',
	        null,
	        _react2.default.createElement('input', _extends({}, props.input, {
	          type: 'radio',
	          value: 'waive',
	          checked: props.input.value === "waive"
	        })),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'waive' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-6' },
	      _react2.default.createElement(
	        'label',
	        null,
	        _react2.default.createElement('input', _extends({}, props.input, {
	          type: 'radio',
	          value: 'noWaive',
	          checked: props.input.value === "noWaive"
	        })),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no_waive' })
	      )
	    )
	  );
	};
	
	var renderDatePicker = function renderDatePicker(fieldName, placeholder) {
	  return _react2.default.createElement(
	    _reactBootstrap.Button,
	    { bsStyle: 'primary' },
	    _react2.default.createElement(_reduxForm.Field, { name: fieldName, placeholder: placeholder, component: _datePicker.DatePicker })
	  );
	};
	
	var renderInvoiceDateRadio = function renderInvoiceDateRadio(props) {
	  var FromDate = "FromDate";
	  var ToDate = "ToDate";
	  if (props.input.name == "InvoiceDateBySequence") {
	    FromDate = FromDate + "BySequence";
	    ToDate = ToDate + "BySequence";
	  }
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'mb-md radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, "all") },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'all-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            type: 'radio',
	            id: 'all-radio-filter',
	            className: 'statusFilterRadios',
	            value: 'all',
	            checked: props.input.value === "all"
	          })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, "range") },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'range-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            type: 'radio',
	            id: 'range-radio-filter',
	            className: 'statusFilterRadios',
	            value: 'range',
	            checked: props.input.value === "range"
	          })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'range' })
	        )
	      )
	    ),
	    props.input.value === "range" && renderDatePicker(FromDate, "Start"),
	    props.input.value === "range" && renderDatePicker(ToDate, "End")
	  );
	};
	
	var ARDetail = function (_Component) {
	  _inherits(ARDetail, _Component);
	
	  function ARDetail() {
	    _classCallCheck(this, ARDetail);
	
	    var _this = _possibleConstructorReturn(this, (ARDetail.__proto__ || Object.getPrototypeOf(ARDetail)).call(this));
	
	    _this.state = {
	      dirty: false,
	
	      invoices: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	      selectedInvoices: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	      invoicesBySequence: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	      unpaidAmount: 0,
	      totalAmount: 0,
	      checkAuthorizeOpen: false,
	      invoicesKey: 1,
	      action: null
	    };
	    _this.moveInvoices = _this.moveInvoices.bind(_this);
	    _this.checkAuthorize = _this.checkAuthorize.bind(_this);
	    _this.openCheckAuthorize = _this.openCheckAuthorize.bind(_this);
	    _this.closeCheckAuthorize = _this.closeCheckAuthorize.bind(_this);
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    _this.clearTable = _this.clearTable.bind(_this);
	    return _this;
	  }
	
	  _createClass(ARDetail, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.context.router.routes[1].path == "AR/new") {
	        this.props.clearARDetail();
	        this.props.setDefaultOfForm('Waive', 'noWaive', 'arDetail');
	      } else if (this.props.arDetail) {
	        var rows = [].concat(_toConsumableArray(this.props.arDetail.Invoices));
	        var invoicesBySequence = _extends({}, this.state.invoicesBySequence, { rows: rows });
	        var unpaidAmount = this.state.unpaidAmount;
	        this.props.arDetail.Invoices.map(function (r) {
	          unpaidAmount += r.UnpaidAmount;
	        });
	        var totalAmount = parseFloat(unpaidAmount) || 0;
	        this.setState.apply(this, _toConsumableArray(this.state).concat([{ invoicesBySequence: invoicesBySequence, unpaidAmount: unpaidAmount, totalAmount: totalAmount }]));
	        if (this.props.arDetail.Waive > 0) {
	          this.props.setDefaultOfForm('Waive', 'waive', 'arDetail');
	        } else {
	          this.props.setDefaultOfForm('Waive', 'noWaive', 'arDetail');
	        }
	      }
	      this.props.clearCredits();
	      this.props.fetchCustomers();
	      this.props.setDefaultOfForm('InvoiceDate', 'all', 'arDetail');
	      this.props.setDefaultOfForm('InvoiceDateBySequence', 'all', 'arDetail');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.customer_id && nextProps.customer_id != this.props.customer_id) {
	        var fromDate = void 0;
	        var toDate = void 0;
	        var invoiceDate = void 0;
	        if (this.state.invoicesKey == 1) {
	          fromDate = (0, _dateFormat.formatDate)(this.props.fromDate);
	          toDate = (0, _dateFormat.formatDate)(this.props.toDate);
	          invoiceDate = this.props.invoiceDate;
	        } else if (this.state.invoicesKey == 2) {
	          fromDate = (0, _dateFormat.formatDate)(this.props.fromDateBySequence);
	          toDate = (0, _dateFormat.formatDate)(this.props.toDateBySequence);
	          invoiceDate = this.props.invoiceDateBySequence;
	        }
	        this.props.fetchCustomerDetail(nextProps.customer_id.value || nextProps.customer_id);
	        this.props.fetchARCredits(nextProps.customer_id.value || nextProps.customer_id);
	        if (!this.props.arDetail) {
	          this.props.fetchARInvoices(nextProps.customer_id.value || nextProps.customer_id, invoiceDate, fromDate, toDate);
	        }
	      }
	      if (nextProps.invoices && nextProps.invoices != this.props.invoices) {
	        if (this.state.invoicesKey == 1) {
	          var invoicesBySequence = _extends({}, this.state.invoicesBySequence, { rows: nextProps.invoices });
	          var totalAmount = 0;
	          nextProps.invoices.map(function (invoice) {
	            totalAmount += parseFloat(invoice.UnpaidAmount) || 0;
	          });
	          totalAmount = totalAmount.toFixed(2);
	          this.setState({ invoicesBySequence: invoicesBySequence, totalAmount: totalAmount });
	        } else if (this.state.invoicesKey == 2) {
	          var invoices = _extends({}, this.state.invoices, { rows: nextProps.invoices });
	          var selectedInvoices = _extends({}, this.state.selectedInvoices, { rows: [] });
	          this.setState({ invoices: invoices, selectedInvoices: selectedInvoices });
	        }
	      }
	      if (nextProps.invoiceDate && nextProps.invoiceDate != this.props.invoiceDate) {
	        var _fromDate = (0, _dateFormat.formatDate)(this.props.fromDate);
	        var _toDate = (0, _dateFormat.formatDate)(this.props.toDate);
	        if (this.props.customer_id && !this.props.arDetail) {
	          this.props.fetchARInvoices(this.props.customer_id.value || this.props.customer_id, nextProps.invoiceDate, _fromDate, _toDate);
	        }
	      }
	      if (nextProps.fromDate && nextProps.fromDate != this.props.fromDate) {
	        var _fromDate2 = (0, _dateFormat.formatDate)(nextProps.fromDate);
	        var _toDate2 = (0, _dateFormat.formatDate)(this.props.toDate);
	        if (this.props.customer_id && !this.props.arDetail) {
	          this.props.fetchARInvoices(this.props.customer_id.value || this.props.customer_id, this.props.invoiceDate, _fromDate2, _toDate2);
	        }
	      }
	      if (nextProps.toDate && nextProps.toDate != this.props.toDate) {
	        var _fromDate3 = (0, _dateFormat.formatDate)(this.props.fromDate);
	        var _toDate3 = (0, _dateFormat.formatDate)(nextProps.toDate);
	        if (this.props.customer_id && !this.props.arDetail) {
	          this.props.fetchARInvoices(this.props.customer_id.value || this.props.customer_id, this.props.invoiceDate, _fromDate3, _toDate3);
	        }
	      }
	      if (nextProps.invoiceDateBySequence && nextProps.invoiceDateBySequence != this.props.invoiceDateBySequence) {
	        var fromDateBySequence = (0, _dateFormat.formatDate)(this.props.fromDateBySequence);
	        var toDateBySequence = (0, _dateFormat.formatDate)(this.props.toDateBySequence);
	        if (this.props.customer_id && !this.props.arDetail) {
	          this.props.fetchARInvoices(this.props.customer_id.value || this.props.customer_id, nextProps.invoiceDateBySequence, fromDateBySequence, toDateBySequence);
	        }
	      }
	      if (nextProps.fromDateBySequence && nextProps.fromDateBySequence != this.props.fromDateBySequence) {
	        var _fromDateBySequence = (0, _dateFormat.formatDate)(nextProps.fromDateBySequence);
	        var _toDateBySequence = (0, _dateFormat.formatDate)(this.props.toDateBySequence);
	        if (this.props.customer_id && !this.props.arDetail) {
	          this.props.fetchARInvoices(this.props.customer_id.value || this.props.customer_id, this.props.invoiceDateBySequence, _fromDateBySequence, _toDateBySequence);
	        }
	      }
	      if (nextProps.toDateBySequence && nextProps.toDateBySequence != this.props.toDateBySequence) {
	        var _fromDateBySequence2 = (0, _dateFormat.formatDate)(this.props.fromDateBySequence);
	        var _toDateBySequence2 = (0, _dateFormat.formatDate)(nextProps.toDateBySequence);
	        if (this.props.customer_id && !this.props.arDetail) {
	          this.props.fetchARInvoices(this.props.customer_id.value || this.props.customer_id, this.props.invoiceDateBySequence, _fromDateBySequence2, _toDateBySequence2);
	        }
	      }
	      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess != this.props.checkPasswordSuccess) {
	        this.closeCheckAuthorize();
	        var formProps = {
	          Customer: this.props.customer_id,
	          TotalPayment: this.props.totalPayment,
	          Method: this.props.method,
	          CheckNum: this.props.checkNum,
	          Account: this.props.account,
	          Discount: this.props.discount,
	          Waive: this.props.waive,
	          Note: this.props.note
	        };
	        if (this.state.action == "apply") {
	          this.handleFormSubmit(formProps);
	        } else if (this.state.action == "remove") {
	          this.props.deleteAR(this.props.arDetail.Payment_id);
	        }
	      }
	    }
	  }, {
	    key: 'calculateWaiveAmount',
	    value: function calculateWaiveAmount() {
	      var discount = parseFloat(this.props.discount) || 0;
	      var totalAmount = parseFloat(this.state.totalAmount) || 0;
	      var finalAmount = (100 - discount) / 100 * totalAmount;
	      finalAmount = finalAmount.toFixed(2) || 0;
	      var totalPayment = parseFloat(this.props.totalPayment) || 0;
	      var waiveAmount = finalAmount - totalPayment;
	      waiveAmount = waiveAmount.toFixed(2);
	      return waiveAmount;
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      var waiveAmount = this.calculateWaiveAmount();
	      var rows = void 0;
	      if (this.state.invoicesKey == 1) {
	        rows = _reactDataGridAddons.Data.Selectors.getRows(this.state.invoicesBySequence);
	      } else if (this.state.invoicesKey == 2) {
	        rows = _reactDataGridAddons.Data.Selectors.getRows(this.state.selectedInvoices);
	      }
	      if (this.props.arDetail) {
	        if (!this.checkPermission("change_account_receivable")) {
	          this.props.editAR(formProps, waiveAmount, rows);
	        } else {
	          alert("You have no permission!");
	        }
	      } else {
	        this.props.createAR(formProps, waiveAmount, rows);
	      }
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(invoicesKey) {
	      if (invoicesKey == 1 && this.state.selectedInvoices.rows.length == 0) {
	        var fromDateBySequence = (0, _dateFormat.formatDate)(this.props.fromDateBySequence);
	        var toDateBySequence = (0, _dateFormat.formatDate)(this.props.toDateBySequence);
	        if (this.props.customer_id && !this.props.arDetail) {
	          this.props.fetchARInvoices(this.props.customer_id.value || this.props.customer_id, this.props.invoiceDateBySequence, fromDateBySequence, toDateBySequence);
	        }
	        this.setState({ invoicesKey: invoicesKey });
	      } else if (invoicesKey == 2 && this.state.invoicesBySequence.rows.length == 0) {
	        var fromDate = (0, _dateFormat.formatDate)(this.props.fromDate);
	        var toDate = (0, _dateFormat.formatDate)(this.props.toDate);
	        if (this.props.customer_id && !this.props.arDetail) {
	          this.props.fetchARInvoices(this.props.customer_id.value || this.props.customer_id, this.props.invoiceDate, fromDate, toDate);
	        }
	        this.setState({ invoicesKey: invoicesKey });
	      } else {
	        alert("clear current table first!");
	      }
	    }
	  }, {
	    key: 'clearTable',
	    value: function clearTable(table) {
	      if (table == "invoicesBySequence") {
	        var invoicesBySequence = _extends({}, this.state.invoicesBySequence, { rows: [] });
	        this.setState({ invoicesBySequence: invoicesBySequence, totalAmount: 0 });
	      } else if (table == "selectedInvoices") {
	        var invoicesRows = [].concat(_toConsumableArray(this.state.invoices.rows), _toConsumableArray(this.state.selectedInvoices.rows));
	        var invoices = _extends({}, this.state.invoices, { rows: invoicesRows });
	        var selectedInvoices = _extends({}, this.state.selectedInvoices, { rows: [] });
	        this.setState({ invoices: invoices, selectedInvoices: selectedInvoices, totalAmount: 0 });
	      }
	    }
	  }, {
	    key: 'checkAuthorize',
	    value: function checkAuthorize(password) {
	      this.props.checkPassword(password);
	    }
	  }, {
	    key: 'openCheckAuthorize',
	    value: function openCheckAuthorize(action) {
	      this.props.clearCheckPassword();
	      this.setState({ checkAuthorizeOpen: true, action: action });
	    }
	  }, {
	    key: 'closeCheckAuthorize',
	    value: function closeCheckAuthorize() {
	      this.setState({ checkAuthorizeOpen: false });
	    }
	  }, {
	    key: 'getCustomerOptions',
	    value: function getCustomerOptions(field) {
	      var customerOptions = [];
	      this.props.customers.map(function (customer) {
	        customerOptions.push({ value: customer.Customer_id, label: customer[field] });
	      });
	      return customerOptions;
	    }
	  }, {
	    key: 'getCreditOptions',
	    value: function getCreditOptions() {
	      var creditOptions = [];
	      if (this.props.credits) {
	        this.props.credits.map(function (credit) {
	          //check the field name of credits when backend finish the API
	          creditOptions.push({ value: credit.SalesReturn_id, label: credit.SRNum + ' | ' + credit.FinalPrice });
	        });
	      }
	      return creditOptions;
	    }
	  }, {
	    key: 'getBillingAddress',
	    value: function getBillingAddress() {
	      var currentCustomerDetail = this.props.currentCustomerDetail;
	
	      var Address1 = "";
	      var Address2 = "";
	      if (currentCustomerDetail && currentCustomerDetail.Billing) {
	        Address1 = currentCustomerDetail.Billing.Street;
	        Address2 = currentCustomerDetail.Billing.City + " " + currentCustomerDetail.Billing.State + currentCustomerDetail.Billing.Zip;
	      }
	      return [Address1, Address2];
	    }
	  }, {
	    key: 'moveInvoices',
	    value: function moveInvoices(invoice, from, to) {
	      var invoices = _extends({}, this.state.invoices);
	      var selectedInvoices = _extends({}, this.state.selectedInvoices);
	      var index = void 0;
	      if (from == "invoices") {
	        index = _lodash2.default.findIndex(invoices.rows, { SalesInvoice_id: invoice.SalesInvoice_id });
	        if (index > -1) invoices.rows.splice(index, 1);
	        index = _lodash2.default.findIndex(selectedInvoices.rows, { SalesInvoice_id: invoice.SalesInvoice_id });
	        if (index == -1) selectedInvoices.rows.push(invoice);
	      } else if (from == "selectedInvoices") {
	        index = _lodash2.default.findIndex(selectedInvoices.rows, { SalesInvoice_id: invoice.SalesInvoice_id });
	        if (index > -1) selectedInvoices.rows.splice(index, 1);
	        index = _lodash2.default.findIndex(invoices.rows, { SalesInvoice_id: invoice.SalesInvoice_id });
	        if (index == -1) invoices.rows.push(invoice);
	      }
	      var totalAmount = 0;
	      selectedInvoices.rows.map(function (r) {
	        totalAmount += parseFloat(r.UnpaidAmount) || 0;
	      });
	      this.setState({ invoices: invoices, selectedInvoices: selectedInvoices, totalAmount: totalAmount });
	    }
	  }, {
	    key: 'renderCustomers',
	    value: function renderCustomers() {
	      if (this.props.customersIsLoading && !this.props.customersError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.customersError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.customersError)
	        )
	      );else {
	        var customerNameOptions = this.getCustomerOptions("Name"); // Return a JSON in the format of React-Select's options
	        var customerNumOptions = this.getCustomerOptions("CustomerNum");
	        var customerPhoneOptions = this.getCustomerOptions("Telephone"); // Return a JSON in the format of React-Select's options
	        var customerDescOptions = this.getCustomerOptions("Description");
	        var billingAddress = ["", ""];
	        var _props = this.props,
	            customer_id = _props.customer_id,
	            currentCustomerDetail = _props.currentCustomerDetail;
	
	        var contact = null;
	        var phone = null;
	        if (customer_id && currentCustomerDetail && currentCustomerDetail.Billing) {
	          contact = currentCustomerDetail.Billing.FirstName + " " + currentCustomerDetail.Billing.LastName;
	          phone = currentCustomerDetail.Billing.Telephone;
	          billingAddress = this.getBillingAddress();
	        }
	        var SelectionForCustomer = this.props.arDetail ? _selection.DisabledSelection : _selection.Selection;
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'mb0' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 4 },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-sm-4 inlineLabel' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_no' }),
	                _react2.default.createElement(
	                  'span',
	                  { style: { color: 'red' } },
	                  '*'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 8, className: 'mb-md' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'Customer', component: SelectionForCustomer, matchPos: 'any', options: customerNumOptions })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-sm-4 inlineLabel' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 8, className: 'mb-md' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'Customer', component: SelectionForCustomer, matchPos: 'any', options: customerNameOptions })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 4 },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-sm-4 inlineLabel' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 8, className: 'mb-md' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'Customer', component: SelectionForCustomer, matchPos: 'any', options: customerPhoneOptions })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-sm-4 inlineLabel' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 8, className: 'mb-md' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'Customer', component: SelectionForCustomer, matchPos: 'any', options: customerDescOptions })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 4 },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-sm-3' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'contact' }),
	                ':'
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 9 },
	                contact
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-sm-3' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' }),
	                ':'
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 9 },
	                phone
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-sm-3' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' }),
	                ':'
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 9 },
	                billingAddress[0],
	                _react2.default.createElement('br', null),
	                billingAddress[1]
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderInvoices',
	    value: function renderInvoices() {
	      var _this2 = this;
	
	      if (this.props.invoicesIsLoading && !this.props.invoicesError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.invoicesError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.invoicesError)
	        )
	      );else {
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.invoices);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var invoices = Object.assign({}, _this2.state.invoices, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this2.setState({ invoices: invoices });
	        };
	
	        // Column difinition
	
	        var columns = [{
	          key: 'InvoiceNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	          width: 110,
	          resizable: true,
	          sortable: true,
	          filterable: true
	        }, {
	          key: 'PostingDate',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	          width: 90,
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          formatter: _dateFormat.DateFormatter
	        }, {
	          key: 'Amount',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'amount' }),
	          width: 80,
	          resizable: true,
	          sortable: true,
	          filterable: true
	        }, {
	          key: 'UnpaidAmount',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' }),
	          width: 80,
	          resizable: true,
	          sortable: true,
	          filterable: true
	        }];
	
	        return _react2.default.createElement(
	          'div',
	          { style: { maxWidth: '100%' }, id: 'ARDetail-dataGrid1' },
	          _react2.default.createElement(_reactDataGrid2.default, {
	            rowRenderer: _react2.default.createElement(_rowRenderer2.default, {
	              onDoubleClick: this.moveInvoices,
	              from: 'invoices',
	              to: 'selectedInvoices'
	            }),
	            onGridSort: handleGridSort,
	            columns: columns,
	            rowHeight: 25,
	            minHeight: 390,
	            rowGetter: rowGetter,
	            rowsCount: getSize()
	          })
	        );
	      }
	    }
	  }, {
	    key: 'renderSelectedInvoices',
	    value: function renderSelectedInvoices() {
	      var _this3 = this;
	
	      // if (this.props.customersIsLoading && !this.props.customersError) return <Spinner/>
	      // else if (this.props.customersError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.customersError)}</div></ContentWrapper>
	      // else {
	      // Parameters of the react-data-grid
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.selectedInvoices);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var selectedInvoices = Object.assign({}, _this3.state.selectedInvoices, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this3.setState({ selectedInvoices: selectedInvoices });
	      };
	
	      // Column difinition
	
	      var columns = [{
	        key: 'InvoiceNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        width: 110,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'PostingDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	        width: 90,
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'Amount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'amount' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'UnpaidAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'ARDetail-dataGrid2' },
	        _react2.default.createElement(_reactDataGrid2.default, {
	          rowRenderer: _react2.default.createElement(_rowRenderer2.default, {
	            onDoubleClick: this.moveInvoices,
	            from: 'selectedInvoices',
	            to: 'invoices'
	          }),
	          onGridSort: handleGridSort,
	          columns: columns,
	          rowHeight: 25,
	          minHeight: 390,
	          rowGetter: rowGetter,
	          rowsCount: getSize()
	        })
	      );
	      // }
	    }
	  }, {
	    key: 'renderInvoicesBySequence',
	    value: function renderInvoicesBySequence() {
	      var _this4 = this;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.invoicesBySequence);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var invoicesBySequence = Object.assign({}, _this4.state.invoicesBySequence, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this4.setState({ invoicesBySequence: invoicesBySequence });
	      };
	
	      // Column difinition
	
	      var columns = [{
	        key: 'InvoiceNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        width: 110,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'PostingDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	        width: 90,
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'Amount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'amount' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'UnpaidAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        'div',
	        { style: { maxWidth: '100%' }, id: 'ARDetail-dataGrid3' },
	        _react2.default.createElement(_reactDataGrid2.default, {
	          onGridSort: handleGridSort,
	          columns: columns,
	          rowHeight: 25,
	          minHeight: 390,
	          rowGetter: rowGetter,
	          rowsCount: getSize()
	        })
	      );
	    }
	  }, {
	    key: 'renderCheckNum',
	    value: function renderCheckNum() {
	      return _react2.default.createElement(_reduxForm.Field, { name: 'CheckNum', component: _inputField.InputField });
	    }
	  }, {
	    key: 'renderCredits',
	    value: function renderCredits() {
	      if (this.props.creditsIsLoading && !this.props.creditsError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.creditsError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.creditsError)
	        )
	      );else {
	        var creditOptions = this.getCreditOptions(); // Return a JSON in the format of React-Select's options
	        return _react2.default.createElement(_reduxForm.Field, { name: 'Credits', component: _selection.MultiSelection, options: creditOptions });
	      }
	    }
	  }, {
	    key: 'renderResponse',
	    value: function renderResponse() {
	      var _props2 = this.props,
	          arCreated = _props2.arCreated,
	          arEdited = _props2.arEdited,
	          arCreateError = _props2.arCreateError,
	          arEditError = _props2.arEditError,
	          arIsCreating = _props2.arIsCreating,
	          arIsEditing = _props2.arIsEditing;
	
	      if (arCreated || arEdited) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-success' },
	          'Success!'
	        )
	      );else if (arIsCreating && !arCreateError || arIsEditing && !arEditError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-info' },
	          '...',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reading_data' })
	        )
	      );else if (arCreateError || arEditError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          arCreateError
	        )
	      );
	    }
	  }, {
	    key: 'checkPermission',
	    value: function checkPermission(permission) {
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props3 = this.props,
	          handleSubmit = _props3.handleSubmit,
	          arCreated = _props3.arCreated,
	          arEdited = _props3.arEdited,
	          arCreateError = _props3.arCreateError,
	          arEditError = _props3.arEditError,
	          arIsCreating = _props3.arIsCreating,
	          arIsEditing = _props3.arIsEditing;
	
	      var PaymentMethodOptions = [{ value: "Check", label: "Check" }, { value: "MoneyOrder", label: "Money Order" }, { value: "CompanyCheck", label: "Company Chk" }, { value: "CashCheck", label: "Cash Chk" }, { value: "PersonalCheck", label: "Personal Chk" }, { value: "WireTransfer", label: "Wire Transfer" }, { value: "CreditCard", label: "Credit Card" }, { value: "BadDebt", label: "Bad Debt" }, { value: "Credit", label: "Credit" }];
	      var accountOptions = [{ value: "Checking/Saving:1140-EAST WEST BANK #5883", label: "Checking/Saving:1140-EAST WEST BANK #5883" }, { value: "Checking/Saving:1130-China Trust Bank(USA)#3668", label: "Checking/Saving:1130-China Trust Bank(USA)#3668" }];
	      var paymentMethodIsCredit = this.props.method == "Credit" || this.props.method && this.props.method.value == "Credit";
	      var bySequenceTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_sequence' });
	      var byInvoicesTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_invoices' });
	      var discount = parseFloat(this.props.discount) || 0;
	      var totalAmount = parseFloat(this.state.totalAmount) || 0;
	      var finalAmount = (100 - discount) / 100 * totalAmount;
	      finalAmount = finalAmount.toFixed(2) || 0;
	      var waiveAmount = void 0;
	      if (this.props.arDetail) {
	        waiveAmount = this.props.arDetail.Waive;
	      } else {
	        waiveAmount = this.calculateWaiveAmount();
	      }
	
	      var createDialogStyle = {
	        width: '550px',
	        height: '300px',
	        marginLeft: '-15%'
	      };
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'form',
	          { method: 'get', action: '#' },
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_slashsign_ap' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_customer_payment' })
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'AR-detail' },
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  type: 'button',
	                  onClick: function onClick() {
	                    _this5.context.router.push('/AR');
	                  }
	                },
	                _react2.default.createElement('em', { className: 'fa fa-close' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { id: 'customers' },
	              this.renderCustomers()
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Tabs,
	              { activeKey: this.state.invoicesKey, justified: true, onSelect: this.handleSelect },
	              _react2.default.createElement(
	                _reactBootstrap.Tab,
	                { eventKey: 1, title: bySequenceTitle },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { id: 'date-range-picker', className: 'form-horizontal' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-7' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'floatLeft' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_date' })
	                    ),
	                    _react2.default.createElement(_reduxForm.Field, { name: 'InvoiceDateBySequence', component: renderInvoiceDateRadio })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-offset-3 col-sm-2' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'mr-lg' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_balance' }),
	                      ' :',
	                      this.state.totalAmount
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'danger',
	                        className: 'floatRight',
	                        onClick: function onClick() {
	                          _this5.clearTable("invoicesBySequence");
	                        }
	                      },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'clear' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    this.renderInvoicesBySequence()
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Tab,
	                { eventKey: 2, title: byInvoicesTitle },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { id: 'date-range-picker', className: 'form-horizontal' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-7' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'floatLeft' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_date' })
	                    ),
	                    _react2.default.createElement(_reduxForm.Field, { name: 'InvoiceDate', component: renderInvoiceDateRadio })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-offset-3 col-sm-2' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'danger',
	                        className: 'floatRight',
	                        onClick: function onClick() {
	                          _this5.clearTable("selectedInvoices");
	                        }
	                      },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'clear' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 6 },
	                    this.renderInvoices()
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 6 },
	                    this.renderSelectedInvoices()
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { id: 'check-out-information' },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1 text-nowrap inlineLabel' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_method' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'asteriksReq' },
	                    '*'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Method', className: 'select-menu-drop-up', component: _selection.Selection, matchPos: 'any', options: PaymentMethodOptions })
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1 inlineLabel' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check_number' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  paymentMethodIsCredit && this.renderCredits(),
	                  !paymentMethodIsCredit && this.renderCheckNum()
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1 inlineLabel' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Discount', component: _inputField.InputField })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Waive', component: renderRadio })
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'waive_amount' }),
	                  ' :'
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1' },
	                  waiveAmount
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1 inlineLabel' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account' }),
	                  _react2.default.createElement(
	                    'span',
	                    { style: { color: 'red' } },
	                    '*'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Account', component: _inputField.InputField })
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1 text-nowrap inlineLabel' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pay_amount' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'asteriksReq' },
	                    '*'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'TotalPayment', component: _inputField.InputField })
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-offset-5 col-sm-1' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	                  ' :'
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1' },
	                  finalAmount
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { id: 'hint' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1 inlineLabel' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'hint' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 5 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Note', component: _inputField.InputField })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                { id: 'apply-and-remove-buttons' },
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'primary',
	                    type: 'button',
	                    onClick: handleSubmit(function () {
	                      _this5.openCheckAuthorize("apply");
	                    }),
	                    disabled: this.props.arDetail
	                  },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'apply' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'danger',
	                    type: 'button',
	                    onClick: function onClick() {
	                      _this5.openCheckAuthorize("remove");
	                    },
	                    disabled: !this.props.arDetail
	                  },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'remove' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              this.renderResponse()
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogStyle,
	            isVisible: this.state.checkAuthorizeOpen,
	            onCloseClicked: this.closeCheckAuthorize
	          },
	          _react2.default.createElement(_confirmActionModal2.default, {
	            'case': 'confirmPassword',
	            closeC: this.checkAuthorize,
	            checkPasswordFailure: this.props.checkPasswordFailure
	          })
	        )
	      );
	    }
	  }]);
	
	  return ARDetail;
	}(_react.Component);
	
	ARDetail.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = ARDetail;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getBsStyle, 'getBsStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/ARDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(renderRadio, 'renderRadio', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/ARDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(renderDatePicker, 'renderDatePicker', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/ARDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(renderInvoiceDateRadio, 'renderInvoiceDateRadio', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/ARDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(ARDetail, 'ARDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/ARDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/ARDetail.jsx');
	}();

	;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reduxForm = __webpack_require__(3);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _moment3 = __webpack_require__(41);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _datePicker = __webpack_require__(27);
	
	var _inputField = __webpack_require__(16);
	
	var _dateFormat = __webpack_require__(39);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _priceFormatter = __webpack_require__(56);
	
	var _priceFormatter2 = _interopRequireDefault(_priceFormatter);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _root_url = __webpack_require__(9);
	
	var _cleanDates = __webpack_require__(22);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _moment4.default)(_moment2.default);
	
	var getBsStyle = function getBsStyle(input, value) {
	  return input === value ? 'success' : 'primary';
	};
	
	var renderRadios = function renderRadios(props) {
	  var renderStartDatePicker = function renderStartDatePicker(days) {
	    if (days === '-1') {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: 'primary' },
	        _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', placeholder: 'Start', component: _datePicker.DatePicker })
	      );
	    }
	    return _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: 'primary' },
	      _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', placeholder: 'Start', component: _datePicker.DisabledDatePicker })
	    );
	  };
	  var renderEndDatePicker = function renderEndDatePicker(days) {
	    if (days === '-1') {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: 'primary' },
	        _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', placeholder: 'End', component: _datePicker.DatePicker })
	      );
	    }
	    return _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: 'primary' },
	      _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', placeholder: 'End', component: _datePicker.DisabledDatePicker })
	    );
	  };
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '1') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'today-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'today-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '1', onClick: function onClick() {
	              return props.fetchAR(1);
	            }, checked: props.input.value === '1' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'today' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '7') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'sevenDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'sevenDay-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '7', onClick: function onClick() {
	              return props.fetchAR(7);
	            }, checked: props.input.value === '7' })),
	          '7 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '30') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'thirtyDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'thirtyDay-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '30', onClick: function onClick() {
	              return props.fetchAR(30);
	            }, checked: props.input.value === '30' })),
	          '30 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '90') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'ninetyDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'ninetyDay-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '90', onClick: function onClick() {
	              return props.fetchAR(90);
	            }, checked: props.input.value === '90' })),
	          '90 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '-1') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'dateRange-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'dateRange-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '-1', checked: props.input.value === '-1' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date_range' })
	        )
	      )
	    ),
	    renderStartDatePicker(props.days),
	    renderEndDatePicker(props.days)
	  );
	};
	
	var ARList = function (_Component) {
	  _inherits(ARList, _Component);
	
	  function ARList() {
	    _classCallCheck(this, ARList);
	
	    var _this = _possibleConstructorReturn(this, (ARList.__proto__ || Object.getPrototypeOf(ARList)).call(this));
	
	    _this.state = {
	      ar: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      arDetail: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      arOpen: false,
	      customer: null,
	      payment_id: null,
	      title: '',
	      checkAuthorizeOpen: false,
	      total: 0,
	      fromDate: '1900-01-01',
	      toDate: '3000-01-01',
	      rowsCount: 0
	    };
	    _this.fetchAR = _this.fetchAR.bind(_this);
	    _this.editAR = _this.editAR.bind(_this);
	    _this.createAR = _this.createAR.bind(_this);
	    _this.checkAuthorize = _this.checkAuthorize.bind(_this);
	    _this.openCheckAuthorize = _this.openCheckAuthorize.bind(_this);
	    _this.closeCheckAuthorize = _this.closeCheckAuthorize.bind(_this);
	    return _this;
	  }
	
	  _createClass(ARList, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var fromDate = '1900-01-01';
	      var toDate = '3000-01-01';
	      var days = '7';
	      this.props.fetchAR(fromDate, toDate, days);
	      this.props.setDefaultOfForm('Days', '7', 'arList');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.ar && nextProps.ar !== this.props.ar) {
	        var ar = _extends({}, this.state.ar, { rows: nextProps.ar.Payments });
	        this.setState({ ar: ar, total: nextProps.ar.Total });
	      }
	      if (nextProps.arDetail && nextProps.arDetail !== this.props.arDetail) {
	        var arDetail = _extends({}, this.state.arDetail, { rows: nextProps.arDetail.Invoices });
	        this.setState({ arDetail: arDetail });
	      }
	      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
	        this.closeCheckAuthorize();
	        this.voidAR();
	      }
	      if (nextProps.days !== this.props.days) {
	        this.props.setDefaultOfForm('FromDate', null, 'arList');
	        this.props.setDefaultOfForm('ToDate', null, 'arList');
	      }
	      if (!nextProps.days) {
	        this.props.setDefaultOfForm('Days', '7', 'arList');
	      }
	      if (nextProps.fromDate && nextProps.fromDate !== this.props.fromDate) {
	        this.setState({ fromDate: nextProps.fromDate }, this.fetchAR);
	      }
	      if (nextProps.toDate && nextProps.toDate !== this.props.toDate) {
	        this.setState({ toDate: nextProps.toDate }, this.fetchAR);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.ar !== this.state.ar) {
	        this.setState({ rowsCount: _reactDataGridAddons.Data.Selectors.getRows(this.state.ar).length });
	      }
	    }
	  }, {
	    key: 'voidAR',
	    value: function voidAR() {
	      var _this2 = this;
	
	      var newRows = this.state.ar.rows;
	      this.state.ar.selectedRows.map(function (row) {
	        _this2.props.deleteAR(row.Payment_id);
	        newRows = newRows.filter(function (obj) {
	          return obj !== row;
	        });
	        var ar = _extends({}, _this2.state.ar, { rows: newRows });
	        _this2.setState({ ar: ar });
	      });
	    }
	  }, {
	    key: 'fetchAR',
	    value: function fetchAR(days) {
	      var fromDate = '1900-01-01';
	      var toDate = '3000-01-01';
	      if (this.state.fromDate != null) {
	        fromDate = (0, _moment2.default)(this.state.fromDate).format('YYYY-MM-DD');
	      }
	      if (this.state.toDate != null) {
	        toDate = (0, _moment2.default)(this.state.toDate).format('YYYY-MM-DD');
	      }
	      this.props.fetchAR(fromDate, toDate, days);
	    }
	  }, {
	    key: 'editAR',
	    value: function editAR() {
	      this.context.router.push('/AR/' + this.state.ar.selectedRows[0].Payment_id);
	    }
	  }, {
	    key: 'createAR',
	    value: function createAR() {
	      this.props.clearARDetail();
	      this.context.router.push('/AR/new');
	    }
	  }, {
	    key: 'checkAuthorize',
	    value: function checkAuthorize(password) {
	      this.props.checkPassword(password);
	    }
	  }, {
	    key: 'openCheckAuthorize',
	    value: function openCheckAuthorize(action) {
	      this.props.clearCheckPassword();
	      this.setState({ checkAuthorizeOpen: true, action: action });
	    }
	  }, {
	    key: 'closeCheckAuthorize',
	    value: function closeCheckAuthorize() {
	      this.setState({ checkAuthorizeOpen: false });
	    }
	  }, {
	    key: 'shouldVoidButtonDisable',
	    value: function shouldVoidButtonDisable() {
	      var selectedRows = this.state.ar.selectedRows;
	
	      // Always disable void if selected more than 1 row
	
	      if (selectedRows.length !== 1) {
	        return true;
	      }
	
	      var status = selectedRows[0] ? selectedRows[0].Status : 'disable';
	      var disabled = status === 'Bounced Check' || status === 'Void' || status === 'disable';
	      return disabled;
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this3 = this;
	
	      if (this.props.isLoading && !this.props.error) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.error) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.error)
	          )
	        );
	      }
	      // Parameters of the react-data-grid
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.ar);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var ar = Object.assign({}, _this3.state.ar, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this3.setState({ ar: ar });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this3.state.ar.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var ar = _extends({}, _this3.state.ar, { filters: newFilters });
	        _this3.setState({ ar: ar });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        //all filters removed
	        var ar = _extends({}, _this3.state.ar, { filters: {} });
	        _this3.setState({ ar: ar });
	      };
	
	      // Handle the row select function
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var selectedRows = [];
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	          selectedRows.push(r.row);
	        });
	        var ar = _extends({}, _this3.state.ar, { rows: newRows, selectedRows: selectedRows });
	        _this3.setState({ ar: ar });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = getRows();
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        var selectedRows = [];
	        var ar = _extends({}, _this3.state.ar, { rows: newRows, selectedRows: selectedRows });
	        _this3.setState({ ar: ar });
	      };
	
	      var onRowClick = function onRowClick(rowIdx, row) {
	        if (rowIdx > -1) {
	          _this3.props.fetchARDetail(row.Payment_id);
	        }
	      };
	
	      // Column difinition
	
	      var columns = [{
	        key: 'ARNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_num' }),
	        width: 110,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'PaymentDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pmt_date' }),
	        width: 90,
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'PostingDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_time' }),
	        width: 90,
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'CustomerName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' }),
	        width: 150,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        width: 150,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'Method',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'method' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'CheckNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'TotalPayment',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'amount' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'AccountName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account' }),
	        width: 150,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'Status',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        width: 70,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'PaymentType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'Note',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '100%' }, id: 'ARList-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              onClearFilters: onClearFilters,
	              columns: columns,
	              rowHeight: 25,
	              minHeight: 320,
	              headerRowHeight: 45,
	              enableRowSelect: 'single',
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              onRowClick: onRowClick,
	              rowSelection: {
	                showCheckbox: true,
	                enableShiftSelect: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              }
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDetailTable',
	    value: function renderDetailTable() {
	      var _this4 = this;
	
	      if (this.props.arDetailIsLoading && !this.props.arDetailError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.arDetailError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.arDetailError)
	          )
	        );
	      }
	      // Parameters of the react-data-grid
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.arDetail);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var arDetail = Object.assign({}, _this4.state.arDetail, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this4.setState({ arDetail: arDetail });
	      };
	
	      // Column difinition
	
	      var columns = [{
	        key: 'InvoiceNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        width: 150,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'PostingDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_date' }),
	        width: 120,
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' }),
	        width: 150,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        width: 150,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'UnpaidAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'Amount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'Note',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	        width: 150,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '100%' }, id: 'ARList-dataGrid2' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              onGridSort: handleGridSort,
	              columns: columns,
	              rowHeight: 25,
	              minHeight: 220,
	              rowGetter: rowGetter,
	              rowsCount: getSize()
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderPrint',
	    value: function renderPrint() {
	      var url = _root_url.ROOT_URL + 'v1/sale/printorder/?Bearer=' + localStorage.getItem('token');
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          href: url,
	          disabled: true
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	      );
	    }
	  }, {
	    key: 'renderExportButton',
	    value: function renderExportButton() {
	      var days = this.props.days;
	      var _props = this.props,
	          f = _props.fromDate,
	          t = _props.toDate;
	
	      days = days || 7;
	
	      var _toFromDates = (0, _cleanDates.toFromDates)(days, f, t),
	          fromDate = _toFromDates.fromDate,
	          toDate = _toFromDates.toDate;
	
	      var params = 'PaymentDate__gte=' + fromDate + '&PaymentDate__lte=' + toDate;
	      var token = localStorage.getItem('token');
	      var url = _root_url.ROOT_URL + '/v1/ar/payment/export/?' + params + '&Bearer=' + token;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          href: url,
	          disabled: !(0, _permissions2.default)('print_account_receivable')
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var createDialogStyle = {
	        width: '550px',
	        height: '300px',
	        marginLeft: '-15%'
	      };
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_slashsign_ap' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: true },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account_receivable_receive_report' })
	          )
	        ),
	        ' ',
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          null,
	          this.renderExportButton()
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'AR' },
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            { id: 'date-range-picker', className: 'form-horizontal' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 1 },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_date' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'colon' },
	                    ':'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 11 },
	                _react2.default.createElement(_reduxForm.Field, { name: 'Days', component: renderRadios, fetchAR: this.fetchAR, days: this.props.days })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            { id: 'ar-table', className: 'position-relative table-collapse-fix' },
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { className: 'table-buttons' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  onClick: this.createAR,
	                  disabled: !(0, _permissions2.default)('add_account_receivable')
	                },
	                _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'warning',
	                  onClick: this.editAR,
	                  disabled: !this.state.ar.selectedRows || this.state.ar.selectedRows.length !== 1 || !(0, _permissions2.default)('change_account_receivable')
	                },
	                _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  type: 'button',
	                  onClick: function onClick() {
	                    _this5.openCheckAuthorize('remove');
	                  },
	                  disabled: this.shouldVoidButtonDisable() || !(0, _permissions2.default)('delete_account_receivable')
	                },
	                _react2.default.createElement('em', { className: 'fa fa-trash' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'void' })
	              )
	            ),
	            this.renderTable(),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'grand-total' },
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 5 },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rows' }),
	                  ':\xA0',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'font-color-orange' },
	                    this.state.rowsCount
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 6 },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { style: { 'margin-top': '2px' }, xs: 2, xsOffset: 1 },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { style: { 'display': 'inline-flex' } },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'grand_total' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'dollar-sign' },
	                        ' $$'
	                      ),
	                      ':'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 2 },
	                  _react2.default.createElement(_reduxForm.Field, { component: _inputField.DisabledInputField, placeholder: this.state.total || 0 })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_detail' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            { id: 'ar-table-detail', className: 'details-table-collapse-fix' },
	            this.renderDetailTable()
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogStyle,
	            isVisible: this.state.checkAuthorizeOpen,
	            onCloseClicked: this.closeCheckAuthorize
	          },
	          _react2.default.createElement(_confirmActionModal2.default, {
	            'case': 'confirmPassword',
	            closeC: this.checkAuthorize,
	            checkPasswordFailure: this.props.checkPasswordFailure
	          })
	        )
	      );
	    }
	  }]);
	
	  return ARList;
	}(_react.Component);
	
	ARList.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = ARList;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getBsStyle, 'getBsStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/ARList.jsx');
	
	  __REACT_HOT_LOADER__.register(renderRadios, 'renderRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/ARList.jsx');
	
	  __REACT_HOT_LOADER__.register(ARList, 'ARList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/ARList.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/ARList.jsx');
	}();

	;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _moment3 = __webpack_require__(41);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _numberWithCommas = __webpack_require__(35);
	
	var _constants = __webpack_require__(11);
	
	var _cityReportTable = __webpack_require__(229);
	
	var _cityReportTable2 = _interopRequireDefault(_cityReportTable);
	
	var _cityReportSearchPanel = __webpack_require__(228);
	
	var _cityReportSearchPanel2 = _interopRequireDefault(_cityReportSearchPanel);
	
	var _cleanDates = __webpack_require__(22);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _moment4.default)(_moment2.default);
	
	var CityReport = function (_Component) {
	  _inherits(CityReport, _Component);
	
	  function CityReport() {
	    _classCallCheck(this, CityReport);
	
	    var _this = _possibleConstructorReturn(this, (CityReport.__proto__ || Object.getPrototypeOf(CityReport)).call(this));
	
	    _this.handleResize = function () {
	      _this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton });
	    };
	
	    _this.handleFieldUpdate = function (data) {
	      _this.setState(_defineProperty({}, data.name, data.value));
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.customers,
	      cityReportLines: [],
	      fromDate: (0, _moment2.default)().subtract(7, 'days').format('YYYY-MM-DD'),
	      toDate: (0, _moment2.default)().format('YYYY-MM-DD'),
	      sale: 0,
	      purchase: 0,
	      ar: 0,
	      ap: 0
	    };
	    return _this;
	  }
	
	  _createClass(CityReport, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      window.addEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.cityReportLines !== nextProps.cityReportLines) {
	        var _nextProps$cityReport = nextProps.cityReportLines,
	            Cities = _nextProps$cityReport.Cities,
	            TotalSale = _nextProps$cityReport.TotalSale,
	            TotalPurchase = _nextProps$cityReport.TotalPurchase,
	            TotalAR = _nextProps$cityReport.TotalAR,
	            TotalAP = _nextProps$cityReport.TotalAP;
	
	        this.setState({
	          cityReportLines: Cities, sale: TotalSale, purchase: TotalPurchase, ar: TotalAR, ap: TotalAP
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.resetCityReport();
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'renderCityReportTable',
	    value: function renderCityReportTable() {
	      var _state = this.state,
	          cityReportLines = _state.cityReportLines,
	          tableHeight = _state.tableHeight;
	
	      return _react2.default.createElement(_cityReportTable2.default, {
	        rows: cityReportLines,
	        minHeight: 500
	      });
	    }
	  }, {
	    key: 'renderPrintButton',
	    value: function renderPrintButton() {
	      var _state2 = this.state,
	          fromDate = _state2.fromDate,
	          toDate = _state2.toDate;
	
	      var dates = (0, _cleanDates.toFromDates)(-1, fromDate, toDate);
	      fromDate = 'start_date=' + dates.fromDate;
	      toDate = 'end_date=' + dates.toDate;
	      var token = 'Bearer=' + localStorage.getItem('token');
	      var url = _root_url.ROOT_URL + 'v1/ar/cityreport/export/?' + fromDate + '&' + toDate + '&' + token;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          href: url,
	          disabled: !(0, _permissions2.default)('print_city_report')
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_slashsign_ap' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city_report' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          null,
	          this.renderPrintButton()
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'city-report' },
	          _react2.default.createElement(_cityReportSearchPanel2.default, {
	            handleFieldUpdate: this.handleFieldUpdate
	          }),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            { id: 'city-report-table' },
	            this.renderCityReportTable()
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'div',
	                { style: { 'text-align': 'center' } },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 3 },
	                  _react2.default.createElement(
	                    'label',
	                    { style: { display: 'inline-flex', 'margin-top': '3px', 'margin-left': '10px' } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sale_total' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'dollar-sign' },
	                      ' $$'
	                    ),
	                    ':\xA0',
	                    _react2.default.createElement(_reactBootstrap.Input, { disabled: true, type: 'text', value: '' + (0, _numberWithCommas.numberWithCommas)(this.state.sale) || 0 })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 3 },
	                  _react2.default.createElement(
	                    'label',
	                    { style: { display: 'inline-flex', 'margin-top': '3px', 'margin-left': '10px' } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_total' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'dollar-sign' },
	                      ' $$'
	                    ),
	                    ':\xA0',
	                    _react2.default.createElement(_reactBootstrap.Input, { disabled: true, type: 'text', value: '' + (0, _numberWithCommas.numberWithCommas)(this.state.purchase) || 0 })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 3 },
	                  _react2.default.createElement(
	                    'label',
	                    { style: { display: 'inline-flex', 'margin-top': '3px', 'margin-left': '10px' } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_total' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'dollar-sign' },
	                      ' $$'
	                    ),
	                    ':\xA0',
	                    _react2.default.createElement(_reactBootstrap.Input, { disabled: true, type: 'text', value: '' + (0, _numberWithCommas.numberWithCommas)(this.state.ar) || 0 })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 3 },
	                  _react2.default.createElement(
	                    'label',
	                    { style: { display: 'inline-flex', 'margin-top': '3px', 'margin-left': '10px' } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ap_total' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'dollar-sign' },
	                      ' $$'
	                    ),
	                    ':\xA0',
	                    _react2.default.createElement(_reactBootstrap.Input, { disabled: true, type: 'text', value: '' + (0, _numberWithCommas.numberWithCommas)(this.state.ap) || 0 })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CityReport;
	}(_react.Component);
	
	var _default = CityReport;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CityReport, 'CityReport', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/CityReport/cityReport.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/CityReport/cityReport.jsx');
	}();

	;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _moment3 = __webpack_require__(41);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _datePicker = __webpack_require__(27);
	
	var _arap_actions = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _moment4.default)(_moment2.default);
	
	var CityReportSearchPanel = function (_Component) {
	  _inherits(CityReportSearchPanel, _Component);
	
	  function CityReportSearchPanel() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CityReportSearchPanel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CityReportSearchPanel.__proto__ || Object.getPrototypeOf(CityReportSearchPanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      maxDate: new Date(),
	      fromDate: '1900-01-01',
	      toDate: '3000-01-01'
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CityReportSearchPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.setDefaultOfForm('fromDate', (0, _moment2.default)().subtract(7, 'days').toDate(), 'cityReportSearchPanelForm');
	      this.props.setDefaultOfForm('toDate', (0, _moment2.default)().toDate(), 'cityReportSearchPanelForm');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!nextProps.fromDate) {
	        this.props.setDefaultOfForm('fromDate', (0, _moment2.default)().subtract(7, 'days').toDate(), 'cityReportSearchPanelForm');
	      }
	      if (!nextProps.toDate) {
	        this.props.setDefaultOfForm('toDate', (0, _moment2.default)().toDate(), 'cityReportSearchPanelForm');
	      }
	      if (nextProps.fromDate && this.props.fromDate !== nextProps.fromDate) {
	        // const { fromDate } = this.getFormattedDates();
	        this.setState({ fromDate: nextProps.fromDate, toDate: nextProps.toDate }, this.fetchCityReport);
	        this.props.handleFieldUpdate({ name: 'fromDate', value: nextProps.fromDate });
	      }
	      if (nextProps.toDate && this.props.toDate !== nextProps.toDate) {
	        // const { toDate } = this.getFormattedDates();
	        this.setState({ fromDate: nextProps.fromDate, toDate: nextProps.toDate }, this.fetchCityReport);
	        this.props.handleFieldUpdate({ name: 'toDate', value: nextProps.toDate });
	      }
	    }
	  }, {
	    key: 'getFormattedDates',
	    value: function getFormattedDates() {
	      var defaultFrom = (0, _moment2.default)().subtract(7, 'days').format('YYYY-MM-DD');
	      var defaultEnd = (0, _moment2.default)().format('YYYY-MM-DD');
	      var fromDate = this.state.fromDate ? (0, _moment2.default)(this.state.fromDate).format('YYYY-MM-DD') : defaultFrom;
	      var toDate = this.state.toDate ? (0, _moment2.default)(this.state.toDate).format('YYYY-MM-DD') : defaultEnd;
	      return { fromDate: fromDate, toDate: toDate };
	    }
	
	    // handleFormSubmit = (formProps) => {
	    //   const { fromDate, toDate } = this.getFormatedDates(formProps);
	    //   this.props.fetchCityReport({ fromDate, toDate });
	    // }
	
	  }, {
	    key: 'fetchCityReport',
	    value: function fetchCityReport() {
	      var _state = this.state,
	          fromDate = _state.fromDate,
	          toDate = _state.toDate;
	
	      this.props.fetchCityReport({ fromDate: fromDate, toDate: toDate });
	    }
	  }, {
	    key: 'renderSpinner',
	    value: function renderSpinner() {
	      if (this.props.cityReportIsLoading && !this.props.cityReportError) {
	        return _react2.default.createElement(
	          'div',
	          { id: 'spinner' },
	          _react2.default.createElement(_spinner2.default, null)
	        );
	      } // else if (this.props.cityReportError) {
	      //   return (
	      //     <ContentWrapper>
	      //       <div className="alert alert-danger">
	      //         <Translate value="something_unexpected_happened" />
	      //       </div>
	      //     </ContentWrapper>
	      //   );
	      // }
	      return _react2.default.createElement('div', null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var maxDate = this.state.maxDate;
	      var _props = this.props,
	          fromDate = _props.fromDate,
	          toDate = _props.toDate;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Panel,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 5 },
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 1 },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'pull-right' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'from' })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'control-date-picker' },
	                  _react2.default.createElement(_reduxForm.Field, {
	                    name: 'fromDate',
	                    component: _datePicker.DatePicker,
	                    placeholder: 'From',
	                    maxDate: toDate
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 1 },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'pull-right' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'to' })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'control-date-picker' },
	                  _react2.default.createElement(_reduxForm.Field, {
	                    name: 'toDate',
	                    component: _datePicker.DatePicker,
	                    placeholder: 'To',
	                    minDate: fromDate,
	                    maxDate: maxDate
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              this.renderSpinner()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CityReportSearchPanel;
	}(_react.Component);
	
	var CityReportSearchPanelForm = (0, _reduxForm.reduxForm)({
	  form: 'cityReportSearchPanelForm'
	})(CityReportSearchPanel);
	
	var selector = (0, _reduxForm.formValueSelector)('cityReportSearchPanelForm');
	
	function mapStateToProps(state) {
	  var fromDate = selector(state, 'fromDate');
	  var toDate = selector(state, 'toDate');
	  return {
	    fromDate: fromDate,
	    toDate: toDate,
	    cityReportIsLoading: state.arap.cityReport.cityReportIsLoading,
	    cityReportError: state.arap.cityReport.cityReportError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchCityReport: _arap_actions.fetchCityReport,
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm
	})(CityReportSearchPanelForm);
	
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/CityReport/cityReportSearchPanel.jsx');
	
	  __REACT_HOT_LOADER__.register(CityReportSearchPanel, 'CityReportSearchPanel', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/CityReport/cityReportSearchPanel.jsx');
	
	  __REACT_HOT_LOADER__.register(CityReportSearchPanelForm, 'CityReportSearchPanelForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/CityReport/cityReportSearchPanel.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/CityReport/cityReportSearchPanel.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/CityReport/cityReportSearchPanel.jsx');
	}();

	;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CityReportTable = function (_Component) {
	  _inherits(CityReportTable, _Component);
	
	  function CityReportTable() {
	    _classCallCheck(this, CityReportTable);
	
	    var _this = _possibleConstructorReturn(this, (CityReportTable.__proto__ || Object.getPrototypeOf(CityReportTable)).call(this));
	
	    _this.getRows = function () {
	      return _reactDataGridAddons.Data.Selectors.getRows(_this.state);
	    };
	
	    _this.getSize = function () {
	      return _this.getRows().length;
	    };
	
	    _this.rowGetter = function (i) {
	      return JSON.parse(JSON.stringify(_this.getRows()[i]));
	    };
	
	    _this.handleGridSort = function (sortColumn, sortDirection) {
	      _this.setState({
	        rows: _this.getRows(),
	        sortColumn: sortColumn,
	        sortDirection: sortDirection
	      });
	    };
	
	    _this.state = {
	      rows: [],
	      sortColumn: null,
	      sortDirection: null
	    };
	    return _this;
	  }
	
	  _createClass(CityReportTable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.rows) {
	        var rows = this.props.rows;
	
	        this.setState({ rows: rows });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.rows !== this.props.rows) {
	        var rows = nextProps.rows;
	
	        this.setState({ rows: rows });
	      }
	    }
	
	    // Grid does not properly re-render when more than one row is updated at a time
	    // Problem solved, for more info Refer to link:
	    // https://github.com/adazzle/react-data-grid/issues/332
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var columns = [{
	        key: 'city',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city' }),
	        resizable: true,
	        filterable: true,
	        width: 200
	      }, {
	        key: 'sales',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        filterable: true,
	        width: 100,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'purchase',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase' }),
	        resizable: true,
	        filterable: true,
	        width: 100,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'ar',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_ar' }),
	        resizable: true,
	        filterable: true,
	        width: 100,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'ap',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_ap' }),
	        resizable: true,
	        filterable: true,
	        width: 100,
	        formatter: _cashFormatter2.default
	      }];
	
	      var minHeight = this.props.minHeight;
	
	
	      return _react2.default.createElement(
	        'div',
	        _defineProperty({ id: 'city-report-table' }, 'id', 'CityReportTable-dataGrid1'),
	        _react2.default.createElement(_reactDataGrid2.default, {
	          enableCellSelect: true,
	          onGridSort: this.handleGridSort,
	          columns: columns,
	          rowHeight: 25,
	          minHeight: minHeight || 500,
	          rowGetter: this.rowGetter,
	          rowsCount: this.getSize()
	        })
	      );
	    }
	  }]);
	
	  return CityReportTable;
	}(_react.Component);
	
	var _default = CityReportTable;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CityReportTable, 'CityReportTable', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/CityReport/cityReportTable.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/CityReport/cityReportTable.jsx');
	}();

	;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _priceFormatter = __webpack_require__(56);
	
	var _priceFormatter2 = _interopRequireDefault(_priceFormatter);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _cellFormatter = __webpack_require__(156);
	
	var _cellFormatter2 = _interopRequireDefault(_cellFormatter);
	
	var _dateFormatter = __webpack_require__(147);
	
	var _dateFormatter2 = _interopRequireDefault(_dateFormatter);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isMAG = _root_url.ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://magna-scm.truckxi.com/api/';
	
	var propTypes = {
	  onSalesInvoiceNumDoubleClick: _propTypes2.default.func.isRequired,
	  onSalesReturnNumDoubleClick: _propTypes2.default.func.isRequired,
	  minHeight: _propTypes2.default.number
	};
	
	var defaultProps = {
	  minHeight: 150
	};
	
	var CustomerStatementDetailTable = function (_Component) {
	  _inherits(CustomerStatementDetailTable, _Component);
	
	  function CustomerStatementDetailTable(props) {
	    _classCallCheck(this, CustomerStatementDetailTable);
	
	    var _this = _possibleConstructorReturn(this, (CustomerStatementDetailTable.__proto__ || Object.getPrototypeOf(CustomerStatementDetailTable)).call(this, props));
	
	    _this.getRows = function () {
	      return _reactDataGridAddons.Data.Selectors.getRows(_this.state);
	    };
	
	    _this.getSize = function () {
	      return _this.getRows().length;
	    };
	
	    _this.rowGetter = function (i) {
	      return JSON.parse(JSON.stringify(_this.getRows()[i]));
	    };
	
	    _this.handleGridSort = function (sortColumn, sortDirection) {
	      _this.setState(function (prevState) {
	        return _extends({}, prevState, {
	          sortColumn: sortColumn,
	          sortDirection: sortDirection
	        });
	      });
	    };
	
	    _this.state = {
	      rows: props.rows,
	      sortColumn: null,
	      sortDirection: null
	    };
	    return _this;
	  }
	
	  // Grid does not properly re-render when more than one row is updated at a time
	  // Problem solved, for more info Refer to link:
	  // https://github.com/adazzle/react-data-grid/issues/332
	
	
	  _createClass(CustomerStatementDetailTable, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          minHeight = _props.minHeight,
	          onSalesInvoiceNumDoubleClick = _props.onSalesInvoiceNumDoubleClick,
	          onSalesReturnNumDoubleClick = _props.onSalesReturnNumDoubleClick;
	      // const columns = [
	      //   {
	      //       key: 'invoice_number',
	      //       name: <Translate value="invoice_no" />,
	      //       resizable: true,
	      //       sortable: true,
	      //       width: 100,
	      //   },
	      //   {
	      //       key: 'invoice_date',
	      //       name: <Translate value="invoice_date" />,
	      //       resizable: true,
	      //       sortable: true,
	      //       width: 90,
	      //       formatter: DateFormatter,
	      //   },
	      //   {
	      //       key: 'due_date',
	      //       name: <Translate value="due_date" />,
	      //       resizable: true,
	      //       sortable: true,
	      //       width: 90,
	      //       formatter: DateFormatter,
	      //   },
	      //   {
	      //       key: 'payment_received_date',
	      //       name: <Translate value="pmt_rcv_date" />,
	      //       resizable: true,
	      //       sortable: true,
	      //       formatter: DateFormatter,
	      //       width: 90,
	      //   },
	      //   {
	      //       key: 'ar_number',
	      //       name: <Translate value="a"r_#' />,
	      //       resizable: true,
	      //       sortable: true,
	      //       formatter: CellFormatter,
	      //       width: 100,
	      //   },
	      //   {
	      //       key: 'invoice_amount',
	      //       name: <Translate value="invoice_amount" />,
	      //       resizable: true,
	      //       sortable: true,
	      //       formatter: PriceFormatter,
	      //       width: 80,
	      //   },
	      //   {
	      //       key: 'balance',
	      //       name: <Translate value="invoice_balance" />,
	      //       resizable: true,
	      //       sortable: true,
	      //       formatter: PriceFormatter,
	      //       width: 80,
	      //   },
	      //   {
	      //       key: 'payment_received_amount',
	      //       name: <Translate value="pmt_rcv_amount" />,
	      //       resizable: true,
	      //       sortable: true,
	      //       formatter: PriceFormatter,
	      //       width: 80,
	      //   },
	      //   {
	      //       key: 'remaining_balance',
	      //       name: <Translate value="balance" />,
	      //       resizable: true,
	      //       sortable: true,
	      //       formatter: PriceFormatter,
	      //       width: 80,
	      //       getRowMetaData: (row) => row,
	      //   },
	      //   {
	      //       key: 'type',
	      //       name: <Translate value="type" />,
	      //       resizable: true,
	      //       sortable: true,
	      //       formatter: CellFormatter,
	      //       width: 150,
	      //   },
	      // ];
	
	      var columns = [{
	        key: 'PostingDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	        resizable: true,
	        sortable: true,
	        formatter: _dateFormatter2.default,
	        width: 90
	      }, {
	        key: 'Title',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'title' }),
	        resizable: true,
	        sortable: true,
	        width: 120
	      }, {
	        key: 'InvoiceNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        formatter: function formatter(_ref) {
	          var value = _ref.value,
	              dependentValues = _ref.dependentValues;
	          return _react2.default.createElement(
	            'div',
	            {
	              onDoubleClick: function onDoubleClick() {
	                if (dependentValues.Title === "Credit Invoice") {
	                  onSalesReturnNumDoubleClick(dependentValues.InvoiceId);
	                } else if (value.substring(0, 2) === 'SI') {
	                  onSalesInvoiceNumDoubleClick(value);
	                } else {
	                  alert('Cannot print this invoice.');
	                }
	              }
	            },
	            value
	          );
	        },
	        width: 100,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'PaymentStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pmt_status' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: 'UnpaidAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unpaid_amount' }),
	        resizable: true,
	        sortable: true,
	        formatter: function formatter(_ref2) {
	          var value = _ref2.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value !== "" && value !== null && '$',
	            value
	          );
	        },
	        width: 100
	      }, {
	        key: 'CheckNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: 'Amount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'charges' }),
	        resizable: true,
	        sortable: true,
	        formatter: _cashFormatter2.default,
	        width: 80
	      }, {
	        key: 'Payment',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credits' }),
	        resizable: true,
	        sortable: true,
	        formatter: _cashFormatter2.default,
	        width: 80
	      }, {
	        key: 'Balance',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' }),
	        resizable: true,
	        sortable: true,
	        formatter: _cashFormatter2.default,
	        width: 80
	      }];
	      if (isMAG) {
	        columns = [{
	          key: 'PostingDate',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	          resizable: true,
	          sortable: true,
	          formatter: _dateFormatter2.default,
	          width: 90
	        }, {
	          key: 'Title',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'title' }),
	          resizable: true,
	          sortable: true,
	          width: 120
	        }, {
	          key: 'InvoiceNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	          resizable: true,
	          sortable: true,
	          formatter: function formatter(_ref3) {
	            var value = _ref3.value,
	                dependentValues = _ref3.dependentValues;
	            return _react2.default.createElement(
	              'div',
	              {
	                onDoubleClick: function onDoubleClick() {
	                  if (dependentValues.Title === "Credit Invoice") {
	                    onSalesReturnNumDoubleClick(dependentValues.InvoiceId);
	                  } else if (value.substring(0, 2) === 'SI') {
	                    onSalesInvoiceNumDoubleClick(value);
	                  } else {
	                    alert('Cannot print this invoice.');
	                  }
	                }
	              },
	              value
	            );
	          },
	          width: 100,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'ContainerNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_num' }),
	          resizable: true,
	          sortable: true,
	          width: 120
	        }, {
	          key: 'PaymentStatus',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pmt_status' }),
	          resizable: true,
	          sortable: true,
	          width: 100
	        }, {
	          key: 'UnpaidAmount',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unpaid_amount' }),
	          resizable: true,
	          sortable: true,
	          formatter: function formatter(_ref4) {
	            var value = _ref4.value;
	            return _react2.default.createElement(
	              'div',
	              null,
	              value !== "" && value !== null && '$',
	              value
	            );
	          },
	          width: 100
	        }, {
	          key: 'CheckNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check_num' }),
	          resizable: true,
	          sortable: true,
	          width: 100
	        }, {
	          key: 'Amount',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'charges' }),
	          resizable: true,
	          sortable: true,
	          formatter: _cashFormatter2.default,
	          width: 80
	        }, {
	          key: 'Payment',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credits' }),
	          resizable: true,
	          sortable: true,
	          formatter: _cashFormatter2.default,
	          width: 80
	        }, {
	          key: 'Balance',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' }),
	          resizable: true,
	          sortable: true,
	          formatter: _cashFormatter2.default,
	          width: 80
	        }];
	      }
	      if (_root_url.isLO) {
	        var unpaidIndex = columns.findIndex(function (column) {
	          return column.key === 'UnpaidAmount';
	        });
	        if (unpaidIndex !== -1) {
	          columns[unpaidIndex].formatter = _cashFormatter2.default;
	        }
	      }
	      return _react2.default.createElement(
	        'div',
	        { id: 'CustomerStatementDetailTable-dataGrid1' },
	        _react2.default.createElement(_reactDataGrid2.default, {
	          enableCellSelect: true,
	          onGridSort: this.handleGridSort,
	          columns: columns,
	          rowHeight: 25,
	          headerRowHeight: 45,
	          minHeight: minHeight,
	          rowGetter: this.rowGetter,
	          rowsCount: this.getSize()
	        })
	      );
	    }
	  }]);
	
	  return CustomerStatementDetailTable;
	}(_react.Component);
	
	CustomerStatementDetailTable.propTypes = propTypes;
	CustomerStatementDetailTable.defaultProps = defaultProps;
	var _default = CustomerStatementDetailTable;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isMAG, 'isMAG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/CustomerStatement/customerStatementDetailTable.jsx');
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/CustomerStatement/customerStatementDetailTable.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/CustomerStatement/customerStatementDetailTable.jsx');
	
	  __REACT_HOT_LOADER__.register(CustomerStatementDetailTable, 'CustomerStatementDetailTable', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/CustomerStatement/customerStatementDetailTable.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/CustomerStatement/customerStatementDetailTable.jsx');
	}();

	;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _dateFormat = __webpack_require__(39);
	
	var _priceFormatter = __webpack_require__(56);
	
	var _priceFormatter2 = _interopRequireDefault(_priceFormatter);
	
	var _paymentCellFormatter = __webpack_require__(233);
	
	var _paymentCellFormatter2 = _interopRequireDefault(_paymentCellFormatter);
	
	var _finalBalanceCellFormatter = __webpack_require__(232);
	
	var _finalBalanceCellFormatter2 = _interopRequireDefault(_finalBalanceCellFormatter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ARModifiableTable = function (_Component) {
	  _inherits(ARModifiableTable, _Component);
	
	  function ARModifiableTable() {
	    _classCallCheck(this, ARModifiableTable);
	
	    var _this = _possibleConstructorReturn(this, (ARModifiableTable.__proto__ || Object.getPrototypeOf(ARModifiableTable)).call(this));
	
	    _this.getRows = function () {
	      return _reactDataGridAddons.Data.Selectors.getRows(_this.state);
	    };
	
	    _this.getSize = function () {
	      return _this.getRows().length;
	    };
	
	    _this.rowGetter = function (i) {
	      return JSON.parse(JSON.stringify(_this.getRows()[i]));
	    };
	
	    _this.handleGridSort = function (sortColumn, sortDirection) {
	      _this.setState({
	        rows: _this.getRows(),
	        sortColumn: sortColumn,
	        sortDirection: sortDirection
	      });
	    };
	
	    _this.handleGridRowsUpdated = function (_ref) {
	      var fromRow = _ref.fromRow,
	          toRow = _ref.toRow,
	          updated = _ref.updated;
	
	      var rows = _this.state.rows.slice();
	
	      for (var i = fromRow; i <= toRow; i++) {
	        var rowToUpdate = rows[i];
	        var updatedRow = _extends({}, rowToUpdate, updated);
	        rows[i] = updatedRow;
	      }
	      if (_this.state.rows !== rows) {
	        _this.setState({ rows: rows });
	        _this.props.handlePaymentCellChange(rows);
	      }
	    };
	
	    _this.state = {
	      rows: [],
	      sortColumn: null,
	      sortDirection: null
	    };
	    return _this;
	  }
	
	  _createClass(ARModifiableTable, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.rows !== this.props.rows) {
	        var rows = nextProps.rows;
	
	        this.setState({ rows: rows });
	      }
	    }
	
	    // Grid does not properly re-render when more than one row is updated at a time
	    // Problem solved, for more info Refer to link:
	    // https://github.com/adazzle/react-data-grid/issues/332
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var columns = [{
	        key: 'InvoiceNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        filterable: true
	      }, {
	        key: 'PostingDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_date' }),
	        resizable: true,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'BillDueDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'due_date' }),
	        resizable: true,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'FinalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_amount' }),
	        resizable: true,
	        filterable: true,
	        formatter: _priceFormatter2.default
	      }, {
	        key: 'PreviousBalance',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_balance' }),
	        resizable: true,
	        filterable: true,
	        formatter: _priceFormatter2.default
	      }, {
	        key: 'Amount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	        resizable: true,
	        filterable: true,
	        editable: this.props.editable,
	        formatter: _react2.default.createElement(
	          _paymentCellFormatter2.default,
	          null,
	          _react2.default.createElement(_priceFormatter2.default, null)
	        )
	      },
	      // {
	      //     key: 'DiscountedAmount',
	      //     name: <Translate value="discount" />,
	      //     resizable: true,
	      //     filterable: true,
	      //     formatter: PriceFormatter,
	      // },
	      {
	        key: 'UnpaidAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'remaining_balance' }),
	        resizable: true,
	        filterable: true,
	        formatter: _react2.default.createElement(
	          _finalBalanceCellFormatter2.default,
	          null,
	          _react2.default.createElement(_priceFormatter2.default, null)
	        ),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }];
	
	      return _react2.default.createElement(
	        'div',
	        { style: { maxWidth: '100%' }, id: 'ARModifiableTable-dataGrid1' },
	        _react2.default.createElement(_reactDataGrid2.default, {
	          enableCellSelect: true,
	          onGridSort: this.handleGridSort,
	          columns: columns,
	          rowHeight: 25,
	          minHeight: 350,
	          rowGetter: this.rowGetter,
	          rowsCount: this.getSize(),
	          onGridRowsUpdated: this.handleGridRowsUpdated
	        })
	      );
	    }
	  }]);
	
	  return ARModifiableTable;
	}(_react.Component);
	
	var _default = ARModifiableTable;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ARModifiableTable, 'ARModifiableTable', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/EditAR/arModifiableTable.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/EditAR/arModifiableTable.jsx');
	}();

	;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FinalBalanceCellFormatter = function (_Component) {
	  _inherits(FinalBalanceCellFormatter, _Component);
	
	  function FinalBalanceCellFormatter() {
	    _classCallCheck(this, FinalBalanceCellFormatter);
	
	    return _possibleConstructorReturn(this, (FinalBalanceCellFormatter.__proto__ || Object.getPrototypeOf(FinalBalanceCellFormatter)).apply(this, arguments));
	  }
	
	  _createClass(FinalBalanceCellFormatter, [{
	    key: 'render',
	    value: function render() {
	      var _props$dependentValue = this.props.dependentValues,
	          PreviousBalance = _props$dependentValue.PreviousBalance,
	          Amount = _props$dependentValue.Amount,
	          DiscountedAmount = _props$dependentValue.DiscountedAmount;
	
	      var discountedAmount = DiscountedAmount || 0;
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.cloneElement(this.props.children, {
	          value: PreviousBalance - Amount - discountedAmount
	        })
	      );
	    }
	  }]);
	
	  return FinalBalanceCellFormatter;
	}(_react.Component);
	
	var _default = FinalBalanceCellFormatter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(FinalBalanceCellFormatter, 'FinalBalanceCellFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/EditAR/finalBalanceCellFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/EditAR/finalBalanceCellFormatter.jsx');
	}();

	;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentCellFormatter = function (_Component) {
	  _inherits(PaymentCellFormatter, _Component);
	
	  function PaymentCellFormatter() {
	    _classCallCheck(this, PaymentCellFormatter);
	
	    return _possibleConstructorReturn(this, (PaymentCellFormatter.__proto__ || Object.getPrototypeOf(PaymentCellFormatter)).apply(this, arguments));
	  }
	
	  _createClass(PaymentCellFormatter, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.cloneElement(this.props.children, _extends({}, this.props))
	      );
	    }
	  }]);
	
	  return PaymentCellFormatter;
	}(_react.Component);
	
	var _default = PaymentCellFormatter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PaymentCellFormatter, 'PaymentCellFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/EditAR/paymentCellFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/EditAR/paymentCellFormatter.jsx');
	}();

	;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _moment3 = __webpack_require__(41);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _inputField = __webpack_require__(16);
	
	var _selection = __webpack_require__(21);
	
	var _SIPaymentFormTable = __webpack_require__(235);
	
	var _SIPaymentFormTable2 = _interopRequireDefault(_SIPaymentFormTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _moment4.default)(_moment2.default);
	
	var SIPaymentForm = function (_Component) {
	  _inherits(SIPaymentForm, _Component);
	
	  function SIPaymentForm() {
	    _classCallCheck(this, SIPaymentForm);
	
	    var _this = _possibleConstructorReturn(this, (SIPaymentForm.__proto__ || Object.getPrototypeOf(SIPaymentForm)).call(this));
	
	    _this.handleFormSubmit = function (formProps) {
	      _this.setState({ dirty: false });
	      if (!_this.checkPermission('change_purchase_payment')) {
	        var _this$props = _this.props,
	            id = _this$props.params.id,
	            salesInvoiceDetail = _this$props.salesInvoiceDetail;
	        var Note = formProps.Note,
	            PaymentStatusRecord = formProps.PaymentStatusRecord;
	
	        Note = Note || '';
	        PaymentStatusRecord = PaymentStatusRecord && PaymentStatusRecord.value;
	        if (PaymentStatusRecord === '') {
	          PaymentStatusRecord = salesInvoiceDetail.PaymentStatusRecord;
	        }
	        // test if url id param is valid
	        if (id && /[0-9]+/.test(id)) {
	          _this.props.updateSalesInvoicePayment(id, { Note: Note, PaymentStatusRecord: PaymentStatusRecord });
	        } else {
	          alert('Invalid sales invoice ID');
	        }
	      } else {
	        alert('You have no permission!');
	      }
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton,
	      rows: []
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    return _this;
	  }
	
	  _createClass(SIPaymentForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var id = this.props.params.id;
	
	      if (id && /[0-9]+/.test(id)) {
	        this.props.fetchSalesInvoiceDetail(id);
	      } else {
	        this.props.router.push('/salesInvoicePayment');
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.salesInvoiceDetail != null && nextProps.salesInvoiceDetail !== this.props.salesInvoiceDetail) {
	        var salesInvoiceDetail = nextProps.salesInvoiceDetail;
	
	        if (salesInvoiceDetail.Sales_Invoice_Lines) {
	          this.setState({ rows: salesInvoiceDetail.Sales_Invoice_Lines });
	        } else {
	          this.setState({ rows: [] });
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	      this.props.resetCurrentSalesInvoice();
	      this.props.resetSalesInvoicePayment();
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton });
	    }
	  }, {
	    key: 'checkPermission',
	    value: function checkPermission(permission) {
	      return false;
	    }
	  }, {
	    key: 'renderSIInformation',
	    value: function renderSIInformation() {
	      var _props = this.props,
	          salesInvoiceDetail = _props.salesInvoiceDetail,
	          detailIsLoading = _props.detailIsLoading,
	          detailError = _props.detailError;
	
	      if (detailIsLoading && !detailError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.detailError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            this.props.detailError
	          )
	        );
	      }
	
	      var _ref = salesInvoiceDetail || {},
	          SONum = _ref.SONum,
	          salesPerson = _ref.Sales_User_Name,
	          customerNum = _ref.Customer_Number,
	          customerName = _ref.Customer_Name,
	          customerDescription = _ref.Customer_Description,
	          OrderDate = _ref.OrderDate,
	          ETADate = _ref.ETADate,
	          PostingDate = _ref.PostingDate,
	          SOFinalPrice = _ref.SOFinalPrice,
	          totalPrice = _ref.TotalPrice,
	          finalPrice = _ref.FinalPrice;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Panel,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            { className: 'receive-form-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'details' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-4 marginTopStyle po-information' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'si_no' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 7 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'InvoiceNum', component: _inputField.DisabledInputField })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            { className: 'receive-form-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_no' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              SONum
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_person' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              salesPerson
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-6 marginTopStyle' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, {
	                name: 'Note',
	                component: 'Textarea',
	                className: 'form-control',
	                style: { minHeight: '55px', maxHeight: '55px' }
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            { className: 'receive-form-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_id' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              customerNum
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              customerName
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              customerDescription
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            { className: 'receive-form-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dates' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_date' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              OrderDate && (0, _moment2.default)(OrderDate).format('MM/DD/YYYY')
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'eta_date' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              ETADate && (0, _moment2.default)(ETADate).format('MM/DD/YYYY')
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_date' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              PostingDate && (0, _moment2.default)(PostingDate).format('MM/DD/YYYY')
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            { className: 'receive-form-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_details' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              SOFinalPrice
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              totalPrice
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              finalPrice
	            )
	          ),
	          this.renderPaymentStatus()
	        )
	      );
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      if (this.props.detailIsLoading && !this.props.detailError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.detailError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            this.props.detailError
	          )
	        );
	      }
	
	      var rows = this.state.rows;
	
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(_SIPaymentFormTable2.default, { rows: rows })
	        )
	      );
	    }
	  }, {
	    key: 'renderPaymentStatus',
	    value: function renderPaymentStatus() {
	      var paymentStatusOptions = [{ value: 'Not Paid', label: 'Not Paid' }, { value: 'Partially Paid', label: 'Partially Paid' }, { value: 'Paid', label: 'Paid' }];
	
	      var salesInvoiceDetail = this.props.salesInvoiceDetail;
	
	      var defaultPayment = null;
	      if (salesInvoiceDetail) {
	        var paymentStatusRecord = salesInvoiceDetail.PaymentStatusRecord;
	        defaultPayment = { value: paymentStatusRecord, label: paymentStatusRecord };
	      }
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 6 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_status' }),
	            ' ',
	            _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              '*'
	            ),
	            ' '
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 6 },
	          _react2.default.createElement(_reduxForm.Field, {
	            name: 'PaymentStatusRecord',
	            component: _selection.Selection,
	            options: paymentStatusOptions,
	            defaultValue: defaultPayment
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderResponse',
	    value: function renderResponse() {
	      var _props2 = this.props,
	          salesInvoicePaymentUpdated = _props2.salesInvoicePaymentUpdated,
	          updateSalesInvoicePaymentError = _props2.updateSalesInvoicePaymentError,
	          salesInvoicePaymentIsUpdating = _props2.salesInvoicePaymentIsUpdating;
	
	      if (salesInvoicePaymentUpdated) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-success' },
	            'Success!'
	          )
	        );
	      } else if (salesInvoicePaymentIsUpdating && !updateSalesInvoicePaymentError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-info' },
	            '...',
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'updating_data' })
	          )
	        );
	      } else if (updateSalesInvoicePaymentError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            updateSalesInvoicePaymentError
	          )
	        );
	      }
	      return _react2.default.createElement(_ContentWrapper2.default, null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          handleSubmit = _props3.handleSubmit,
	          salesInvoiceDetail = _props3.salesInvoiceDetail,
	          detailIsLoading = _props3.detailIsLoading,
	          detailError = _props3.detailError;
	
	      if (detailIsLoading && !detailError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.detailError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            this.props.detailError
	          )
	        );
	      }
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit(this.handleFormSubmit) },
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_slashsign_ap' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'si_payment_details' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                onClick: function onClick() {
	                  _this2.context.router.push('/salesInvoicePayment');
	                },
	                bsStyle: 'danger'
	              },
	              _react2.default.createElement('em', { className: 'fa fa-close' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                className: 'btn btn-primary',
	                style: { marginRight: '20px' },
	                type: 'submit'
	              },
	              _react2.default.createElement('em', { className: 'fa fa-save', style: { marginRight: '10px' } }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { fluid: 'true', id: 'purchase-payment-detail' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                'h2',
	                { className: 'mt0' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'si_payment' })
	              ),
	              _react2.default.createElement(
	                'h3',
	                null,
	                salesInvoiceDetail && salesInvoiceDetail.WarehouseName
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              this.renderResponse()
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              this.renderSIInformation()
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              null,
	              this.renderTable()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SIPaymentForm;
	}(_react.Component);
	
	SIPaymentForm.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = SIPaymentForm;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SIPaymentForm, 'SIPaymentForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/SIPaymentForm/SIPaymentForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/SIPaymentForm/SIPaymentForm.jsx');
	}();

	;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IsVariableFormatter = _react2.default.createClass({
	  displayName: 'IsVariableFormatter',
	  render: function render() {
	    if (this.props.dependentValues.ProductType === 'Non-Fixed') {
	      return _react2.default.createElement(
	        'span',
	        null,
	        this.props.value,
	        ' ',
	        _react2.default.createElement(
	          'label',
	          { className: 'label label-success' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'non_fixed' })
	        )
	      );
	    } else if (this.props.dependentValues.ProductType === 'Per-Pound') {
	      return _react2.default.createElement(
	        'span',
	        null,
	        this.props.value,
	        ' ',
	        _react2.default.createElement(
	          'label',
	          { className: 'label label-primary' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'per_pound' })
	        )
	      );
	    }
	    return _react2.default.createElement(
	      'span',
	      null,
	      this.props.value
	    );
	  }
	});
	
	var SIPaymentFormTable = function (_Component) {
	  _inherits(SIPaymentFormTable, _Component);
	
	  function SIPaymentFormTable() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SIPaymentFormTable);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SIPaymentFormTable.__proto__ || Object.getPrototypeOf(SIPaymentFormTable)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      rows: [],
	      sortColumn: null,
	      sortDirection: null
	    }, _this.getRows = function () {
	      return _reactDataGridAddons.Data.Selectors.getRows(_this.props);
	    }, _this.getSize = function () {
	      return _this.getRows().length;
	    }, _this.rowGetter = function (i) {
	      return JSON.parse(JSON.stringify(_this.getRows()[i]));
	    }, _this.handleGridSort = function (sortColumn, sortDirection) {
	      _this.setState({
	        rows: _this.getRows(),
	        sortColumn: sortColumn,
	        sortDirection: sortDirection
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SIPaymentFormTable, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.rows !== this.props.rows) {
	        var rows = nextProps.rows;
	
	        this.setState({ rows: rows });
	      }
	    }
	
	    // Grid does not properly re-render when more than one row is updated at a time
	    // Problem solved, for more info Refer to link:
	    // https://github.com/adazzle/react-data-grid/issues/332
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var columns = [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70
	      }, {
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: 'LoadedQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'NetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true
	      }, {
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        sortable: true,
	        width: 80
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'TotalNetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'ItemNotation',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        sortable: true,
	        width: 150,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        'div',
	        { style: { maxWidth: '100%' }, id: 'SIPaymentFormTable-dataGrid1' },
	        _react2.default.createElement(_reactDataGrid2.default, {
	          rowKey: 'ProductNum',
	          onGridSort: this.handleGridSort,
	          columns: columns,
	          rowHeight: 25,
	          headerRowHeight: 45,
	          minHeight: 485,
	          rowGetter: this.rowGetter,
	          rowsCount: this.getSize()
	        })
	      );
	    }
	  }]);
	
	  return SIPaymentFormTable;
	}(_react.Component);
	
	var _default = SIPaymentFormTable;
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(IsVariableFormatter, 'IsVariableFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/SIPaymentForm/SIPaymentFormTable.jsx');
	
	  __REACT_HOT_LOADER__.register(SIPaymentFormTable, 'SIPaymentFormTable', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/SIPaymentForm/SIPaymentFormTable.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/SIPaymentForm/SIPaymentFormTable.jsx');
	}();

	;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentAmountFormatter = function (_Component) {
	  _inherits(PaymentAmountFormatter, _Component);
	
	  function PaymentAmountFormatter() {
	    _classCallCheck(this, PaymentAmountFormatter);
	
	    return _possibleConstructorReturn(this, (PaymentAmountFormatter.__proto__ || Object.getPrototypeOf(PaymentAmountFormatter)).apply(this, arguments));
	  }
	
	  _createClass(PaymentAmountFormatter, [{
	    key: 'render',
	    value: function render() {
	      var _props$dependentValue = this.props.dependentValues,
	          finalPrice = _props$dependentValue.FinalPrice,
	          unpaidAmount = _props$dependentValue.UnpaidAmount;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.cloneElement(this.props.children, {
	          value: finalPrice - unpaidAmount
	        })
	      );
	    }
	  }]);
	
	  return PaymentAmountFormatter;
	}(_react.Component);
	
	var _default = PaymentAmountFormatter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PaymentAmountFormatter, 'PaymentAmountFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/SIPaymentList/PaymentAmountFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/SIPaymentList/PaymentAmountFormatter.jsx');
	}();

	;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _moment3 = __webpack_require__(41);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _datePicker = __webpack_require__(27);
	
	var _dateFormat = __webpack_require__(39);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _priceFormatter = __webpack_require__(56);
	
	var _priceFormatter2 = _interopRequireDefault(_priceFormatter);
	
	var _numberWithCommas = __webpack_require__(35);
	
	var _inputField = __webpack_require__(16);
	
	var _cleanDates = __webpack_require__(22);
	
	var _dateFilterRadios = __webpack_require__(49);
	
	var _dateFilterRadios2 = _interopRequireDefault(_dateFilterRadios);
	
	var _root_url = __webpack_require__(9);
	
	var _PaymentAmountFormatter = __webpack_require__(236);
	
	var _PaymentAmountFormatter2 = _interopRequireDefault(_PaymentAmountFormatter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _moment4.default)(_moment2.default);
	
	var SIPaymentList = function (_Component) {
	  _inherits(SIPaymentList, _Component);
	
	  function SIPaymentList() {
	    _classCallCheck(this, SIPaymentList);
	
	    var _this = _possibleConstructorReturn(this, (SIPaymentList.__proto__ || Object.getPrototypeOf(SIPaymentList)).call(this));
	
	    _this.invoiceDetail = function (e) {
	      e.preventDefault();
	      var selectedRow = _this.state.tableData.selectedRows[0];
	      _this.context.router.push('/salesInvoicePayment/' + selectedRow.SalesInvoice_id);
	    };
	
	    _this.formatDate = function (date) {
	      return (0, _moment2.default)(date).format('YYYY-MM-DD');
	    };
	
	    _this.fetchSalesInvoiceByDetails = function (days) {
	      if (days != '-1') {
	        _this.setState({ FromDate: undefined, ToDate: undefined, Days: days }, function () {
	          _this.props.fetchSalesInvoices('all/', _this.state.FromDate, _this.state.ToDate, null, _this.state.Days, null, null, null, true);
	        });
	      } else {
	        _this.setState({ Days: '-1' }, function () {
	          _this.props.fetchSalesInvoices('all/', _this.state.FromDate, _this.state.ToDate, null, _this.state.Days, null, null, null, true);
	        });
	      }
	    };
	
	    _this.setToDate = function (e) {
	      if (e < _this.state.FromDate) {
	        return;
	      }
	      _this.setState({ ToDate: e });
	    };
	
	    _this.setFromDate = function (e) {
	      if (e > _this.state.ToDate) {
	        return;
	      }
	      _this.setState({ FromDate: e });
	    };
	
	    _this.setToRangeSearch = function (e) {
	      _this.setState({ Days: '-1' });
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.editSalesInvPage,
	      createOpen: false,
	      tableData: {
	        rows: [],
	        selectedRows: null,
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      // rows: [],
	      // selectedRows: null,
	      // editedRows: [],
	      // filters: {},
	      // sortColumn: null,
	      // sortDirection: null,
	      gourpOpen: false,
	      total: 0,
	      paid: 0,
	      balance: 0,
	      Days: '7',
	      FromDate: undefined,
	      ToDate: undefined,
	      rowsCount: 0
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.invoiceDetail = _this.invoiceDetail.bind(_this);
	    return _this;
	  }
	
	  _createClass(SIPaymentList, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      document.title = _root_url.companyCodeTitle;
	      this.props.setDefaultDays('SIPaymentList');
	      // last param set to true, indecating it's sales report
	      this.props.fetchSalesInvoices('all/', '1900-01-01', '3000-01-01', null, '7', null, null, null, true);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.handleResize);
	      this.props.setDefaultDays('SIPaymentList');
	      this.props.fetchSalesInvoices('all/', '1900-01-01', '3000-01-01', null, '7', null, null, null, true);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.salesInvoice && nextProps.salesInvoice !== this.props.salesInvoice) {
	        var invoices = nextProps.salesInvoice.Invoices;
	        var total = nextProps.salesInvoice.TotalFinalPrice;
	        var paid = nextProps.salesInvoice.TotalPaid;
	        var balance = nextProps.salesInvoice.TotalBalance;
	        var tableData = _extends({}, this.state.tableData, { rows: invoices });
	        this.setState({
	          tableData: tableData,
	          total: total,
	          paid: paid,
	          balance: balance
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.tableData !== this.state.tableData) {
	        this.setState({ rowsCount: _reactDataGridAddons.Data.Selectors.getRows(this.state.tableData).length });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.editSalesInvPage });
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this2 = this;
	
	      if (this.props.isLoading && !this.props.error) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.error) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.error)
	          )
	        );
	      }
	
	      // Parameters of the react-data-grid
	      var tableHeight = window.innerHeight < 930 ? 460 : 460;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.tableData);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the row select function
	      var onRowSelect = function onRowSelect(rows) {
	        var tableData = _extends({}, _this2.state.tableData, { selectedRows: rows });
	        _this2.setState({ tableData: tableData });
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this2.state.tableData, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this2.setState({ tableData: state });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this2.state.tableData.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var tableData = _extends({}, _this2.state.tableData, { filters: newFilters });
	        _this2.setState({ tableData: tableData });
	      };
	
	      // Column difinition
	      var columns = [{
	        key: 'InvoiceNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'si_no' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'SONum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'related_no' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true
	      }, {
	        key: 'PostingDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'posting_date' }),
	        resizable: true,
	        sortable: true,
	        width: 130,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'CustomerNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'Customer_Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: 'FinalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 75,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'PaymentAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'paid_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 75,
	        filterable: true,
	        formatter: _cashFormatter2.default,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'UnpaidAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'Sales_Username',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: 'Owner',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'owner' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: 'PaymentType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'SaleStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'si_status' }),
	        resizable: true,
	        sortable: true,
	        width: 85,
	        filterable: true
	      }, {
	        key: 'PaymentStatusRecord',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pmt_status' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'CheckNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'Note',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { id: 'SIPaymentList' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'InvoiceNum',
	                onGridSort: handleGridSort,
	                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                onAddFilter: handleFilterChange,
	                columns: columns,
	                rowGetter: rowGetter,
	                headerRowHeight: 45,
	                rowsCount: getSize(),
	                rowHeight: 25,
	                minHeight: tableHeight,
	                enableRowSelect: 'single',
	                onRowSelect: onRowSelect
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 2 },
	                _react2.default.createElement(
	                  'label',
	                  { style: { 'display': 'inline-flex', 'margin-top': '15px' } },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rows' }),
	                  ':\xA0',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'font-color-orange' },
	                    this.state.rowsCount
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(
	                  'label',
	                  { style: { display: 'inline-flex', 'margin-top': '15px', 'margin-left': '10px' } },
	                  _react2.default.createElement(
	                    'span',
	                    { style: { 'margin-top': '3px' } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_sells' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'dollar-sign' },
	                      ' $$'
	                    ),
	                    ':\xA0'
	                  ),
	                  _react2.default.createElement(_reduxForm.Field, { component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.total) || 0 })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(
	                  'label',
	                  { style: { display: 'inline-flex', 'margin-top': '15px', 'margin-left': '10px' } },
	                  _react2.default.createElement(
	                    'span',
	                    { style: { 'margin-top': '3px' } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'returns' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'dollar-sign' },
	                      ' $$'
	                    ),
	                    ':\xA0'
	                  ),
	                  _react2.default.createElement(_reduxForm.Field, { component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.paid) || 0 })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(
	                  'label',
	                  { style: { display: 'inline-flex', 'margin-top': '15px', 'margin-left': '10px' } },
	                  _react2.default.createElement(
	                    'span',
	                    { style: { 'margin-top': '3px' } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_sales' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'dollar-sign' },
	                      ' $$'
	                    ),
	                    ':\xA0'
	                  ),
	                  _react2.default.createElement(_reduxForm.Field, { component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.balance) || 0 })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDatePickers',
	    value: function renderDatePickers() {
	      if (this.props.Days === '-1') {
	        return _react2.default.createElement(
	          'div',
	          { className: 'form-group date-picker-positioner' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-2 from-label col-xs-offset-5' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'from' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-2 control-date-picker' },
	            _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', component: _datePicker.DatePicker, disabled: this.props.Days !== '-1' })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-1 to-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'to' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-2 control-date-picker' },
	            _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', component: _datePicker.DatePicker, disabled: this.props.Days !== '-1' })
	          )
	        );
	      }
	      // else return(
	      //   <Row>
	      //     <Col xs={ 10 }></Col>
	      //     <Col xs={ 2 }>
	      //       <Button
	      //         bsStyle='primary'
	      //         onClick={() =>{ this.fetchSalesInvoiceByDetails(); }}><Translate value"submit" />
	      //       </Button>
	      //     </Col>
	      //   </Row>
	      // )
	    }
	  }, {
	    key: 'renderPrint',
	    value: function renderPrint() {
	      var salesInvoiceID = this.state.tableData.selectedRows && this.state.tableData.selectedRows.length === 1 && this.state.tableData.selectedRows[0].SalesInvoice_id;
	      if (!salesInvoiceID) {
	        return;
	      }
	      var url = _root_url.ROOT_URL + 'v1/sale/printinvoice/' + salesInvoiceID + '?Bearer=' + localStorage.getItem('token');
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          href: url
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_si' })
	      );
	    }
	  }, {
	    key: 'renderReturnPrint',
	    value: function renderReturnPrint() {
	      var salesReturnID = this.state.tableData.selectedRows && this.state.tableData.selectedRows.length === 1 && this.state.tableData.selectedRows[0].SalesReturn_id;
	      if (!salesReturnID) {
	        return;
	      }
	      var url = _root_url.ROOT_URL + 'v1/sale/printreturn/' + salesReturnID + '?Bearer=' + localStorage.getItem('token');
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          href: url
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_return' })
	      );
	    }
	  }, {
	    key: 'renderButtonToolbar',
	    value: function renderButtonToolbar() {
	      var _state = this.state,
	          fromDate = _state.FromDate,
	          toDate = _state.ToDate;
	      var days = this.state.Days;
	
	      var dates = (0, _cleanDates.toFromDates)(days, fromDate, toDate);
	      fromDate = 'PostingDate__gte=' + dates.fromDate;
	      toDate = 'PostingDate__lte=' + dates.toDate;
	      var token = 'Bearer=' + localStorage.getItem('token');
	      var url = _root_url.ROOT_URL + 'v1/sale/sales_invoice/search/all/exportpayment/?' + fromDate + '&' + toDate + '&' + token;
	      var byUserUrl = _root_url.ROOT_URL + 'v1/sale/sales_invoice/search/all/export_by_user/?' + fromDate + '&' + toDate + '&' + token;
	      return _react2.default.createElement(
	        _reactBootstrap.ButtonToolbar,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            href: byUserUrl
	          },
	          _react2.default.createElement('em', { className: 'fa fa-download' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel_by_user' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            href: url
	          },
	          _react2.default.createElement('em', { className: 'fa fa-download' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_slashsign_ap' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_report' })
	          )
	        ),
	        this.renderButtonToolbar(),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'purchase-payment' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { id: 'date-range-picker', className: 'form-horizontal' },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 1 },
	                    _react2.default.createElement(
	                      'h3',
	                      { className: 'filter-title text-nowrap' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'posting_date' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'colon' },
	                        ':'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 11 },
	                    (0, _dateFilterRadios2.default)({
	                      handleOnClick: this.fetchSalesInvoiceByDetails,
	                      setFromDate: this.setFromDate,
	                      setToDate: this.setToDate,
	                      setToRangeSearch: this.setToRangeSearch,
	                      FromDate: this.state.FromDate,
	                      ToDate: this.state.ToDate,
	                      Days: this.state.Days
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { className: 'position-relative table-collapse-fix' },
	                _react2.default.createElement(
	                  _reactBootstrap.ButtonToolbar,
	                  { className: 'table-buttons' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                      bsStyle: 'primary',
	                      disabled: !this.state.tableData.selectedRows || this.state.tableData.selectedRows.length !== 1,
	                      onClick: this.invoiceDetail
	                    },
	                    _react2.default.createElement('em', { className: 'fa fa-file-text' }),
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'detail' })
	                  ),
	                  this.renderPrint(),
	                  this.renderReturnPrint()
	                ),
	                this.renderTable()
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SIPaymentList;
	}(_react.Component);
	
	SIPaymentList.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = SIPaymentList;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SIPaymentList, 'SIPaymentList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/SIPaymentList/SIPaymentList.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/SIPaymentList/SIPaymentList.jsx');
	}();

	;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _queryString = __webpack_require__(198);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _inputField = __webpack_require__(16);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _rowRenderer = __webpack_require__(64);
	
	var _selection = __webpack_require__(21);
	
	var _datePicker = __webpack_require__(27);
	
	var _dateFormat = __webpack_require__(39);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _accountDropdown = __webpack_require__(92);
	
	var _accountDropdown2 = _interopRequireDefault(_accountDropdown);
	
	var _arapPaymentOptions = __webpack_require__(94);
	
	var _arapPaymentOptions2 = _interopRequireDefault(_arapPaymentOptions);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _numberWithCommas = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreateAR = function (_Component) {
	  _inherits(CreateAR, _Component);
	
	  function CreateAR() {
	    _classCallCheck(this, CreateAR);
	
	    var _this = _possibleConstructorReturn(this, (CreateAR.__proto__ || Object.getPrototypeOf(CreateAR)).call(this));
	
	    _this.debouncedCreateAR = _lodash2.default.debounce(function (formProps, rows) {
	      _this.props.createAR(formProps, rows).then(function () {
	        if (_this.props.arCreated && !_this.props.arCreateError) {
	          _this.props.router.push('/AR');
	        }
	      });
	    }, 500, { maxWait: 1000 });
	
	    _this.state = {
	      invoices: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	      selectedInvoices: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	      unpaidAmount: 0,
	      totalAmount: 0,
	      checkAuthorizeOpen: false,
	      action: null,
	      waiveShouldDisable: true,
	      waiveAmount: 0,
	      penaltyAmount: 0,
	      warnPaymentDate: false
	    };
	    _this.moveInvoices = _this.moveInvoices.bind(_this);
	    _this.renderWaiveCheckbox = _this.renderWaiveCheckbox.bind(_this);
	    _this.checkAuthorize = _this.checkAuthorize.bind(_this);
	    _this.handleWaiveCheckboxChange = _this.handleWaiveCheckboxChange.bind(_this);
	    _this.renderInvoiceDateRadio = _this.renderInvoiceDateRadio.bind(_this);
	    _this.closeCheckAuthorize = _this.closeCheckAuthorize.bind(_this);
	    _this.checkAuthorize = _this.checkAuthorize.bind(_this);
	    _this.handleWaiveInputChange = _this.handleWaiveInputChange.bind(_this);
	    _this.renderWaiveInputField = _this.renderWaiveInputField.bind(_this);
	    _this.handleFormSubmit = _this.handleFormSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(CreateAR, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.clearARDetail();
	      this.props.clearARForm();
	      this.props.clearCredits();
	      this.props.fetchCustomers();
	      var queryObj = _queryString2.default.parse(this.props.location.search);
	      var custId = queryObj.cust_id;
	      if (custId) {
	        this.props.changeField('Customer', parseFloat(custId), 'createAR');
	      }
	      this.props.setDefaultOfForm('waiveAmount', 0.00, 'createAR');
	      this.props.setDefaultOfForm('penaltyAmount', 0.00, 'createAR');
	      this.props.setDefaultOfForm('InvoiceDate', 'all', 'createAR');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.penaltyAmount !== this.props.penaltyAmount) {
	        var penaltyAmount = parseFloat(nextProps.penaltyAmount) || 0;
	        this.setState({ penaltyAmount: penaltyAmount });
	      }
	      if (nextProps.customer_id && nextProps.customer_id !== this.props.customer_id) {
	        var fromDate = (0, _dateFormat.formatDate)(this.props.fromDate);
	        var toDate = (0, _dateFormat.formatDate)(this.props.toDate);
	        var invoiceDate = this.props.invoiceDate;
	        this.props.fetchCustomerDetail(nextProps.customer_id.value || nextProps.customer_id);
	        this.props.fetchARCredits(nextProps.customer_id.value || nextProps.customer_id);
	        this.props.fetchARInvoices(nextProps.customer_id.value || nextProps.customer_id, invoiceDate, fromDate, toDate);
	      }
	      if (nextProps.invoices && nextProps.invoices !== this.props.invoices) {
	        var invoices = _extends({}, this.state.invoices, { rows: nextProps.invoices });
	        var selectedInvoices = _extends({}, this.state.selectedInvoices, { rows: [] });
	        this.setState({ invoices: invoices, selectedInvoices: selectedInvoices });
	      }
	      if (nextProps.invoiceDate && nextProps.invoiceDate !== this.props.invoiceDate) {
	        var _fromDate = (0, _dateFormat.formatDate)(this.props.fromDate);
	        var _toDate = (0, _dateFormat.formatDate)(this.props.toDate);
	        if (this.props.customer_id) {
	          this.props.fetchARInvoices(this.props.customer_id.value || this.props.customer_id, nextProps.invoiceDate, _fromDate, _toDate);
	        }
	      }
	
	      if (!nextProps.invoiceDate) {
	        this.props.setDefaultOfForm('InvoiceDate', 'all', 'createAR');
	      }
	
	      if (nextProps.fromDate && nextProps.fromDate !== this.props.fromDate) {
	        var _fromDate2 = (0, _dateFormat.formatDate)(nextProps.fromDate);
	        var _toDate2 = (0, _dateFormat.formatDate)(this.props.toDate);
	        if (this.props.customer_id) {
	          this.props.fetchARInvoices(this.props.customer_id.value || this.props.customer_id, this.props.invoiceDate, _fromDate2, _toDate2);
	        }
	      }
	      if (nextProps.toDate && nextProps.toDate !== this.props.toDate) {
	        var _fromDate3 = (0, _dateFormat.formatDate)(this.props.fromDate);
	        var _toDate3 = (0, _dateFormat.formatDate)(nextProps.toDate);
	        if (this.props.customer_id) {
	          this.props.fetchARInvoices(this.props.customer_id.value || this.props.customer_id, this.props.invoiceDate, _fromDate3, _toDate3);
	        }
	      }
	      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
	        this.closeCheckAuthorize();
	        var formProps = {
	          Customer: this.props.customer_id,
	          TotalPayment: this.props.totalPayment,
	          Method: this.props.method,
	          CheckNum: this.props.checkNum,
	          Account: this.props.account,
	          Discount: this.props.discount,
	          Waive: this.props.waive,
	          Note: this.props.note,
	          WaiveAmount: this.props.waiveAmount,
	          PenaltyAmount: this.props.penaltyAmount
	        };
	        // this.handleFormSubmit(formProps);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.clearARForm();
	      this.props.clearCredits();
	    }
	  }, {
	    key: 'getBsStyle',
	    value: function getBsStyle(input, value) {
	      return input === value ? 'success' : 'primary';
	    }
	  }, {
	    key: 'checkAuthorize',
	    value: function checkAuthorize(password) {
	      this.props.checkPassword(password);
	    }
	  }, {
	    key: 'openCheckAuthorize',
	    value: function openCheckAuthorize(action) {
	      this.props.clearCheckPassword();
	      this.setState({ checkAuthorizeOpen: true, action: action });
	    }
	  }, {
	    key: 'closeCheckAuthorize',
	    value: function closeCheckAuthorize() {
	      this.setState({ checkAuthorizeOpen: false });
	    }
	  }, {
	    key: 'calculateWaiveAmount',
	    value: function calculateWaiveAmount() {
	      var discount = parseFloat(this.props.discount) || 0;
	      var totalAmount = parseFloat(this.state.totalAmount) || 0;
	      var finalAmount = (100 - discount) / 100 * totalAmount;
	      finalAmount = finalAmount.toFixed(2) || 0;
	      var totalPayment = parseFloat(this.props.totalPayment) || 0;
	      var waiveAmount = finalAmount - totalPayment;
	      waiveAmount = waiveAmount.toFixed(2);
	      return waiveAmount;
	    }
	  }, {
	    key: 'refund',
	    value: function refund(finalBalance) {
	      var _this2 = this;
	
	      var refundProps = {
	        Account: this.props.account,
	        Customer: this.props.customer_id,
	        CheckNum: this.props.checkNum,
	        Method: this.props.method,
	        TotalPayment: finalBalance,
	        PaymentDate: this.props.paymentDate
	      };
	      var rows = _reactDataGridAddons.Data.Selectors.getRows(this.state.selectedInvoices);
	      this.props.refundAR(refundProps, rows).then(function () {
	        if (_this2.props.arRefunded && !_this2.props.arRefundError) {
	          _this2.props.router.push('/AR');
	        }
	      });
	    }
	  }, {
	    key: 'moveInvoices',
	    value: function moveInvoices(invoice, from) {
	      var invoices = _extends({}, this.state.invoices);
	      var selectedInvoices = _extends({}, this.state.selectedInvoices);
	      var index = void 0;
	      if (from === 'invoices') {
	        index = _lodash2.default.findIndex(invoices.rows, { SalesInvoice_id: invoice.SalesInvoice_id });
	        if (index > -1) {
	          invoices.rows.splice(index, 1);
	        }
	        index = _lodash2.default.findIndex(selectedInvoices.rows, { SalesInvoice_id: invoice.SalesInvoice_id });
	        if (index === -1) {
	          selectedInvoices.rows.push(invoice);
	        }
	      } else if (from === 'selectedInvoices') {
	        index = _lodash2.default.findIndex(selectedInvoices.rows, { SalesInvoice_id: invoice.SalesInvoice_id });
	        if (index > -1) {
	          selectedInvoices.rows.splice(index, 1);
	        }
	        index = _lodash2.default.findIndex(invoices.rows, { SalesInvoice_id: invoice.SalesInvoice_id });
	        if (index === -1) {
	          invoices.rows.push(invoice);
	        }
	      }
	      var totalAmount = 0;
	      selectedInvoices.rows.map(function (r) {
	        totalAmount += parseFloat(r.UnpaidAmount) || 0;
	      });
	      this.setState({ invoices: invoices, selectedInvoices: selectedInvoices, totalAmount: totalAmount });
	    }
	  }, {
	    key: 'getCustomerOptions',
	    value: function getCustomerOptions(field) {
	      var customerOptions = [];
	      this.props.customers.map(function (customer) {
	        customerOptions.push({ value: customer.Customer_id, label: customer[field] });
	      });
	      return customerOptions;
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit() {
	      if (!this.props.paymentDate) {
	        this.setState({ warnPaymentDate: true });
	        return;
	      } else {
	        this.setState({ warnPaymentDate: false });
	      }
	      var formProps = {
	        Customer: this.props.customer_id,
	        TotalPayment: parseFloat(this.props.totalPayment || 0).toFixed(2),
	        PenaltyAmount: parseFloat(this.props.penaltyAmount || 0).toFixed(2),
	        PaymentDate: this.props.paymentDate,
	        Method: this.props.method,
	        CheckNum: this.props.checkNum,
	        Account: this.props.account.value,
	        AccountName: this.props.account.label,
	        // Discount: parseFloat(this.props.discount),
	        // DiscountedAmount: ((parseFloat(this.state.totalAmount) * parseFloat(this.props.discount)) / 100).toFixed(2) || 0,
	        Note: this.props.note,
	        Waive: this.props.waive,
	        WaiveAmount: parseFloat(this.state.waiveAmount || 0).toFixed(2),
	        TotalAmount: parseFloat(this.state.totalAmount || 0).toFixed(2)
	      };
	      var rows = _reactDataGridAddons.Data.Selectors.getRows(this.state.selectedInvoices);
	      // rows.map(row => {
	      //   const discountAmount = ((parseFloat(row.UnpaidAmount) * parseFloat(this.props.discount)) / 100).toFixed(2);
	      //   row.DiscountedAmount = discountAmount || 0;
	      // });
	
	      this.debouncedCreateAR(formProps, rows);
	    }
	  }, {
	    key: 'renderDatePicker',
	    value: function renderDatePicker(fieldName, placeholder) {
	      return _react2.default.createElement(
	        _reactBootstrap.Button /* id="date-range-radio-button" */,
	        { bsStyle: 'primary' },
	        _react2.default.createElement(_reduxForm.Field, { name: fieldName, disabled: this.props.invoiceDate !== 'range', placeholder: placeholder, component: _datePicker.DatePicker })
	      );
	    }
	  }, {
	    key: 'getBillingAddress',
	    value: function getBillingAddress() {
	      var currentCustomerDetail = this.props.currentCustomerDetail;
	
	      var Address1 = '';
	      var Address2 = '';
	      if (currentCustomerDetail && currentCustomerDetail.Billing) {
	        Address1 = currentCustomerDetail.Billing.Street;
	        Address2 = currentCustomerDetail.Billing.City + ', ' + currentCustomerDetail.Billing.State + ' ' + currentCustomerDetail.Billing.Zip;
	      }
	      return [Address1, Address2];
	    }
	  }, {
	    key: 'renderCustomers',
	    value: function renderCustomers() {
	      if (this.props.customersIsLoading && !this.props.customersError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.customersError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'something_unexpected_happened' })
	          )
	        );
	      }
	      var customerNameOptions = this.getCustomerOptions('Name'); // Return a JSON in the format of React-Select's options
	      var customerNumOptions = this.getCustomerOptions('CustomerNum');
	      var customerPhoneOptions = this.getCustomerOptions('Telephone'); // Return a JSON in the format of React-Select's options
	      var customerDescOptions = this.getCustomerOptions('Description');
	      var billingAddress = ['', ''];
	      var _props = this.props,
	          customer_id = _props.customer_id,
	          currentCustomerDetail = _props.currentCustomerDetail;
	
	      var contact = null;
	      var phone = null;
	      if (customer_id && currentCustomerDetail && currentCustomerDetail.Billing) {
	        contact = currentCustomerDetail.Billing.FirstName + ' ' + currentCustomerDetail.Billing.LastName;
	        phone = currentCustomerDetail.Billing.Telephone;
	        billingAddress = this.getBillingAddress();
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row /* id='hint' */,
	          { className: 'mb0' },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-4 inlineLabel' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_no' }),
	              _react2.default.createElement(
	                'span',
	                { style: { color: 'red' } },
	                '*'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 8, className: 'mb-md' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'Customer', component: _selection.Selection, matchPos: 'any', options: customerNumOptions })
	            ),
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-4 inlineLabel' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 8, className: 'mb-md' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'Customer', component: _selection.Selection, matchPos: 'any', options: customerNameOptions })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-4 inlineLabel' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 8, className: 'mb-md' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'Customer', component: _selection.Selection, matchPos: 'any', options: customerPhoneOptions })
	            ),
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-4 inlineLabel' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 8, className: 'mb-md' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'Customer', component: _selection.Selection, options: customerDescOptions })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'contact' }),
	              ':'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 9 },
	              contact
	            ),
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' }),
	              ':'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 9 },
	              phone
	            ),
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' }),
	              ':'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 9 },
	              billingAddress[0],
	              _react2.default.createElement('br', null),
	              billingAddress[1]
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderInvoices',
	    value: function renderInvoices() {
	      var _this3 = this;
	
	      if (this.props.invoicesIsLoading && !this.props.invoicesError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.invoicesError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.invoicesError)
	          )
	        );
	      }
	
	      // Parameters of the react-data-grid
	      var getRows = function getRows() {
	        var rows = _reactDataGridAddons.Data.Selectors.getRows(_this3.state.invoices);
	        return rows;
	      };
	
	      var getSize = function getSize() {
	        var len = getRows().length;
	        return len;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var invoices = Object.assign({}, _this3.state.invoices, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this3.setState({ invoices: invoices });
	      };
	
	      // Column difinition
	
	      var columns = [{
	        key: 'InvoiceNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'PostingDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_date' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'BillDueDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'due_date' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'Amount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'amount' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'UnpaidAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }];
	
	      return _react2.default.createElement(
	        'div',
	        { style: { maxWidth: '100%' }, id: 'CreateAR-dataGrid1' },
	        _react2.default.createElement(_reactDataGrid2.default, {
	          rowRenderer: _react2.default.createElement(_rowRenderer.RowRenderer, {
	            onDoubleClick: this.moveInvoices,
	            from: 'invoices',
	            to: 'selectedInvoices'
	          }),
	          onGridSort: handleGridSort,
	          columns: columns,
	          rowHeight: 25,
	          minHeight: 390,
	          rowGetter: rowGetter,
	          rowsCount: getSize()
	        })
	      );
	    }
	  }, {
	    key: 'renderSelectedInvoices',
	    value: function renderSelectedInvoices() {
	      var _this4 = this;
	
	      // if (this.props.customersIsLoading && !this.props.customersError) return <Spinner/>
	      // else if (this.props.customersError) return <ContentWrapper><div className='alert alert-danger'>{JSON.stringify(this.props.customersError)}</div></ContentWrapper>
	      // else {
	      // Parameters of the react-data-grid
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.selectedInvoices);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var selectedInvoices = Object.assign({}, _this4.state.selectedInvoices, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this4.setState({ selectedInvoices: selectedInvoices });
	      };
	
	      // Column difinition
	
	      var columns = [{
	        key: 'InvoiceNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'PostingDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_date' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'BillDueDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'due_date' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'Amount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'amount' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'UnpaidAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }];
	
	      return _react2.default.createElement(
	        'div',
	        { style: { maxWidth: '100%' }, id: 'CreateAR-dataGrid2' },
	        _react2.default.createElement(_reactDataGrid2.default, {
	          rowRenderer: _react2.default.createElement(_rowRenderer.RowRenderer, {
	            onDoubleClick: this.moveInvoices,
	            from: 'selectedInvoices',
	            to: 'invoices'
	          }),
	          onGridSort: handleGridSort,
	          columns: columns,
	          rowHeight: 25,
	          minHeight: 390,
	          rowGetter: rowGetter,
	          rowsCount: getSize()
	        })
	      );
	      // }
	    }
	  }, {
	    key: 'renderCheckNum',
	    value: function renderCheckNum() {
	      return _react2.default.createElement(_reduxForm.Field, { name: 'CheckNum', component: _inputField.InputField });
	    }
	  }, {
	    key: 'getCreditOptions',
	    value: function getCreditOptions() {
	      var creditOptions = [];
	      if (this.props.credits) {
	        this.props.credits.map(function (credit) {
	          //check the field name of credits when backend finish the API
	          creditOptions.push({ value: credit.SalesReturn_id, label: credit.SRNum + ' | ' + credit.FinalPrice });
	        });
	      }
	      return creditOptions;
	    }
	  }, {
	    key: 'renderCredits',
	    value: function renderCredits() {
	      if (this.props.creditsIsLoading && !this.props.creditsError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.creditsError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.creditsError)
	          )
	        );
	      }
	      var creditOptions = this.getCreditOptions(); // Return a JSON in the format of React-Select's options
	      return _react2.default.createElement(_reduxForm.Field, { name: 'Credits', component: _selection.MultiSelection, options: creditOptions });
	    }
	  }, {
	    key: 'renderResponse',
	    value: function renderResponse() {
	      var _props2 = this.props,
	          arCreated = _props2.arCreated,
	          arCreateError = _props2.arCreateError,
	          arIsCreating = _props2.arIsCreating,
	          arIsRefunding = _props2.arIsRefunding,
	          arRefunded = _props2.arRefunded,
	          arRefundError = _props2.arRefundError;
	
	      if (arCreated || arRefunded) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-success' },
	            'Success!'
	          )
	        );
	      } else if (arIsCreating && !arCreateError || arIsRefunding && !arRefundError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-info' },
	            '...',
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reading_data' })
	          )
	        );
	      } // else if (arCreateError) {
	      //   return (
	      //     <ContentWrapper>
	      //       <div className='alert alert-danger'>
	      //         {arCreateError}
	      //       </div>
	      //     </ContentWrapper>
	      //   );
	      // }
	      return _react2.default.createElement(_ContentWrapper2.default, null);
	    }
	  }, {
	    key: 'checkPermission',
	    value: function checkPermission(permission) {
	      return false;
	    }
	  }, {
	    key: 'renderInvoiceDateRadio',
	    value: function renderInvoiceDateRadio(props) {
	      var fromDate = 'FromDate';
	      var toDate = 'ToDate';
	      return _react2.default.createElement(
	        _reactBootstrap.ButtonToolbar,
	        { className: 'mb-md radio-filter-buttons' },
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { bsStyle: this.getBsStyle(props.input.value, 'all') },
	          _react2.default.createElement(
	            'div',
	            { className: 'radio' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'all-radio-filter' },
	              _react2.default.createElement('input', _extends({}, props.input, {
	                type: 'radio',
	                id: 'all-radio-filter',
	                className: 'statusFilterRadios',
	                value: 'all',
	                checked: props.input.value === 'all'
	              })),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { bsStyle: this.getBsStyle(props.input.value, 'range') },
	          _react2.default.createElement(
	            'div',
	            { className: 'radio' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'dateRange-radio-filter' },
	              _react2.default.createElement('input', _extends({}, props.input, {
	                type: 'radio',
	                id: 'dateRange-radio-filter',
	                className: 'statusFilterRadios',
	                value: 'range',
	                checked: props.input.value === 'range'
	              })),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date_range' })
	            )
	          )
	        ),
	        this.renderDatePicker(fromDate, 'Start'),
	        this.renderDatePicker(toDate, 'End')
	      );
	    }
	  }, {
	    key: 'handleWaiveCheckboxChange',
	    value: function handleWaiveCheckboxChange(event) {
	      var target = event.target;
	      console.log('handleWaiveCheckboxChange', target, target.checked);
	
	      if (!target.checked) {
	        this.props.setDefaultOfForm('waiveAmount', 0.00, 'createAR');
	        this.setState({
	          waiveAmount: 0.00
	        });
	      } else {
	        this.props.setDefaultOfForm('waiveAmount', this.calculateWaiveAmount(), 'createAR');
	        this.setState({
	          waiveAmount: this.calculateWaiveAmount()
	        });
	      }
	      this.setState({
	        waiveShouldDisable: !target.checked
	      });
	    }
	  }, {
	    key: 'renderWaiveCheckbox',
	    value: function renderWaiveCheckbox(props) {
	      console.log('renderWaiveCheckbox', props);
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 6 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement('input', _extends({}, props.input, {
	              type: 'checkbox',
	              value: 'waive',
	              checked: props.input.value,
	              onChange: this.handleWaiveCheckboxChange
	            }))
	          )
	        )
	      );
	    }
	  }, {
	    key: 'handleWaiveInputChange',
	    value: function handleWaiveInputChange(event) {
	      this.setState({
	        waiveAmount: event.target.value
	      });
	    }
	  }, {
	    key: 'renderWaiveInputField',
	    value: function renderWaiveInputField(props) {
	      var _this5 = this;
	
	      var _props$meta = props.meta,
	          touched = _props$meta.touched,
	          error = _props$meta.error,
	          className = props.className;
	
	      var inputClass = (0, _classnames2.default)({ 'parsley-error': touched && error }, 'form-control', className);
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, {
	          className: inputClass,
	          type: 'text',
	          onChange: function onChange(event) {
	            props.input.onChange(event);
	            _this5.handleWaiveInputChange(event);
	          },
	          disabled: props.disabled
	        })),
	        touched && error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          error
	        )
	      );
	    }
	  }, {
	    key: 'renderPaymentDateError',
	    value: function renderPaymentDateError() {
	      if (this.state.warnPaymentDate) {
	        return _react2.default.createElement(
	          'label',
	          { className: 'alert alert-danger' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_date_required' })
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var createDialogStyle = {
	        width: '550px',
	        height: '300px',
	        marginLeft: '-15%'
	      };
	
	      var _props3 = this.props,
	          handleSubmit = _props3.handleSubmit,
	          pristine = _props3.pristine,
	          method = _props3.method,
	          submitting = _props3.submitting;
	      var _state = this.state,
	          waiveShouldDisable = _state.waiveShouldDisable,
	          waiveAmount = _state.waiveAmount,
	          penaltyAmount = _state.penaltyAmount;
	
	
	      var paymentMethodIsCredit = method === 'Credit' || method && method.value === 'Credit';
	
	      var twoDecimalZero = 0 .toFixed(2);
	      var discount = parseFloat(this.props.discount) || twoDecimalZero;
	      var totalAmount = parseFloat(this.state.totalAmount) || twoDecimalZero;
	      var balance = ((100 - discount) / 100 * totalAmount).toFixed(2) || twoDecimalZero;
	      var totalPayment = parseFloat(this.props.totalPayment) || twoDecimalZero;
	      var finalBalance = (penaltyAmount + (balance - waiveAmount - totalPayment)).toFixed(2) || twoDecimalZero;
	      // finalBalance = finalBalance > 0 ? finalBalance : twoDecimalZero;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit(this.handleFormSubmit) },
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_slashsign_ap' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account_receivable' })
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'AR-create' },
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  type: 'submit',
	                  disabled: pristine || submitting
	                },
	                _react2.default.createElement('em', { className: 'fa fa-save' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  type: 'button',
	                  onClick: function onClick() {
	                    return document.referrer === window.location.href ? _this6.props.router.push('/AR') : _this6.props.router.goBack();
	                  }
	                },
	                _react2.default.createElement('em', { className: 'fa fa-close' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { id: 'customers' },
	              this.renderCustomers()
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { id: 'date-range-picker', className: 'form-horizontal' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-7' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'floatLeft' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_date' })
	                  ),
	                  _react2.default.createElement(_reduxForm.Field, { name: 'InvoiceDate', component: this.renderInvoiceDateRadio })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 6 },
	                  this.renderInvoices()
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 6 },
	                  this.renderSelectedInvoices()
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { id: 'check-out-information' },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'text-nowrap inlineLabel' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_method' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'asteriksReq' },
	                      '*'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Method', className: 'select-menu-drop-up', component: _selection.Selection, options: _arapPaymentOptions2.default })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'inlineLabel' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check_number' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  paymentMethodIsCredit && this.renderCredits(),
	                  !paymentMethodIsCredit && this.renderCheckNum()
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 3 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'inlineLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'waive' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 6, smOffset: 1 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'waiveAmount', component: this.renderWaiveInputField })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 2 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 4 },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_date' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'asteriksReq text-nowrap' },
	                          '*'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 7 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'PaymentDate', component: _datePicker.DatePicker, dropUp: true, maxDate: new Date() })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' }),
	                    ' :'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    '$' + (0, _numberWithCommas.numberWithCommas)(balance)
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1 inlineLabel' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account' }),
	                  _react2.default.createElement(
	                    'span',
	                    { style: { color: 'red' } },
	                    '*'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(_accountDropdown2.default, { className: 'select-menu-drop-up' })
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1 text-nowrap inlineLabel' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_amount' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'asteriksReq' },
	                    '*'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  totalPayment === twoDecimalZero && finalBalance < 0 ? _react2.default.createElement(_reduxForm.Field, { name: 'TotalPaymentDisabled', component: _inputField.DisabledInputField }) : _react2.default.createElement(_reduxForm.Field, { name: 'TotalPayment', component: _inputField.InputField })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'penalty' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 3 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'PenaltyAmount', component: _inputField.InputField })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_balance' }),
	                  ' :'
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1' },
	                  '$' + (0, _numberWithCommas.numberWithCommas)(finalBalance)
	                )
	              ),
	              _react2.default.createElement('div', { className: 'horizontal-divider' }),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'inlineLabel' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Note' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 5 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Note', component: _inputField.InputField })
	                ),
	                _react2.default.createElement(_reactBootstrap.Col, { sm: 4 }),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                      disabled: finalBalance >= 0 || totalPayment !== twoDecimalZero,
	                      bsStyle: 'primary',
	                      onClick: handleSubmit(function () {
	                        _this6.refund(finalBalance);
	                      })
	                    },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'refund' })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              this.renderResponse()
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogStyle,
	            isVisible: this.state.checkAuthorizeOpen,
	            onCloseClicked: this.closeCheckAuthorize
	          },
	          _react2.default.createElement(_confirmActionModal2.default, {
	            'case': 'confirmPassword',
	            closeC: this.checkAuthorize,
	            checkPasswordFailure: this.props.checkPasswordFailure
	          })
	        )
	      );
	    }
	  }]);
	
	  return CreateAR;
	}(_react.Component);
	
	var _default = CreateAR;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CreateAR, 'CreateAR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/createAR.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/createAR.jsx');
	}();

	;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _moment3 = __webpack_require__(41);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _selection = __webpack_require__(21);
	
	var _constants = __webpack_require__(11);
	
	var _RowLabelField = __webpack_require__(114);
	
	var _RowLabelField2 = _interopRequireDefault(_RowLabelField);
	
	var _customerStatementDetailTable = __webpack_require__(230);
	
	var _customerStatementDetailTable2 = _interopRequireDefault(_customerStatementDetailTable);
	
	var _root_url = __webpack_require__(9);
	
	var _cleanDates = __webpack_require__(22);
	
	var _numberWithCommas = __webpack_require__(35);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	var _GenericDatePicker = __webpack_require__(48);
	
	var _GenericDatePicker2 = _interopRequireDefault(_GenericDatePicker);
	
	var _genericRadioFilter = __webpack_require__(50);
	
	var _genericRadioFilter2 = _interopRequireDefault(_genericRadioFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEcity = _root_url.ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === "https://dev-scm.truckxi.com/api/";
	
	(0, _moment4.default)(_moment2.default);
	
	var getBsStyle = function getBsStyle(input, value) {
	  return input === value ? 'success' : 'primary';
	};
	
	var CustomerStatement = function (_Component) {
	  _inherits(CustomerStatement, _Component);
	
	  _createClass(CustomerStatement, null, [{
	    key: 'getQuarter',
	    value: function getQuarter() {
	      return Math.ceil((new Date().getMonth() + 1) / 3);
	    }
	  }]);
	
	  function CustomerStatement() {
	    _classCallCheck(this, CustomerStatement);
	
	    var _this = _possibleConstructorReturn(this, (CustomerStatement.__proto__ || Object.getPrototypeOf(CustomerStatement)).call(this));
	
	    _this.handleResize = function () {
	      _this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.customersPage - 100 });
	    };
	
	    _this.fetchCustomerStatement = function (props) {
	      var Customer = props.Customer,
	          StatementType = props.StatementType;
	
	      if (Customer) {
	        var customer = Customer.value || Customer;
	        // const { fromDate, toDate } = getFromToDatesWithFilter(props);
	        _this.props.fetchCustomerStatement(_this.state.fromDate, _this.state.toDate, customer, StatementType, _this.state.paymentCutoffDate);
	      }
	    };
	
	    _this.handleTypeFilterChange = function (event) {
	      var filter = event.target.value;
	      var statementLines = _this.state.statementLines;
	
	      var filteredLines = void 0;
	      if (filter !== 'all') {
	        filteredLines = statementLines.filter(function (line) {
	          return line.type === filter;
	        });
	      } else {
	        filteredLines = statementLines;
	      }
	      _this.setState({
	        invoiceFilter: filter,
	        filteredLines: filteredLines
	      });
	    };
	
	    _this.IFrameIsLoaded = function () {
	      if (!_this.state.PdfFrameLoaded) {
	        var pdfFrame = window.frames["Pdf"];
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this.setState({ PdfFrameLoaded: true });
	      }
	    };
	
	    _this.renderCustomerPaymentTerm = function () {
	      // this.props.customers.filter(customer => customer)
	      if (_this.props.salesCustomerDetails) {
	        return _this.props.salesCustomerDetails.PaymentTermDesc;
	      }
	      return 'N/A';
	    };
	
	    _this.renderCustomerDefaultSales = function () {
	      // this.props.customers.filter(customer => customer)
	      if (_this.props.salesCustomerDetails) {
	        return _this.props.salesCustomerDetails.SalesUserName;
	      }
	      return 'N/A';
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.customersPage - 100,
	      statementLines: [],
	      // filteredLines: [],
	      invoiceAmount: 0,
	      paymentAmount: 0,
	      totalBalance: 0,
	      remainingBalance: 0,
	      forwardedBalance: 0,
	      PdfFrameLoaded: true,
	      // yearChanged: false,
	      // invoiceFilter: 'all',
	      fromDate: new Date('2017-08-18T00:00:00-0700'),
	      toDate: new Date(),
	      paymentCutoffDate: new Date(),
	      typeRadios: 'range',
	      year: new Date().getFullYear(),
	      month: new Date().getMonth() + 1,
	      quarter: CustomerStatement.getQuarter()
	    };
	
	    _this.setMonthSelected = _this.setMonthSelected.bind(_this);
	    _this.setQuarterSelected = _this.setQuarterSelected.bind(_this);
	    _this.handleDateFilterChange = _this.handleDateFilterChange.bind(_this);
	    _this.setFromDate = _this.setFromDate.bind(_this);
	    _this.setToDate = _this.setToDate.bind(_this);
	    _this.setPaymentCutoffDate = _this.setPaymentCutoffDate.bind(_this);
	    return _this;
	  }
	
	  _createClass(CustomerStatement, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // this.props.setDefaultOfForm('typeRadios', 'range', 'customerStatement');
	      // this.props.setDefaultOfForm('FromDate', new Date('2017-08-18T00:00:00-0700'), 'customerStatement');
	      // this.props.setDefaultOfForm('ToDate', new Date(), 'customerStatement');
	      var currentCustomer = this.props.currentCustomer;
	
	      if (currentCustomer && currentCustomer.Deliver_Customer_id) {
	        this.props.fetchCustomers();
	        this.props.setValue('customerStatement', 'Customer', { value: currentCustomer.Deliver_Customer_id });
	      } else {
	        this.props.fetchCustomers();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      window.addEventListener('resize', this.handleResize);
	      // this.props.setDefaultOfForm('StatementType', 'forwarded', 'customerStatement');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.customerStatement && nextProps.customerStatement !== this.props.customerStatement) {
	        var statementLines = nextProps.customerStatement.ar_payment_lines;
	        var invoiceAmount = nextProps.customerStatement.invoice_amount;
	        var paymentAmount = nextProps.customerStatement.payment_amount;
	        var totalBalance = nextProps.customerStatement.total_balance;
	        var remainingBalance = nextProps.customerStatement.remaining_balance;
	        var forwardedBalance = nextProps.customerStatement.forwarded_amount;
	        // if (this.props.StatementType === 'forwarded') {
	        //   forwardedBalance = nextProps.customerStatement.PreviousBalance;
	        //   remainingBalance += forwardedBalance;
	        // }
	        // let filteredLines;
	        // const { invoiceFilter } = this.state;
	        // if (invoiceFilter !== 'all') {
	        //   filteredLines = statementLines.filter(line => line.type === invoiceFilter);
	        // } else {
	        //   filteredLines = statementLines;
	        // }
	        this.setState({
	          statementLines: statementLines,
	          // filteredLines,
	          invoiceAmount: invoiceAmount,
	          paymentAmount: paymentAmount,
	          totalBalance: totalBalance,
	          remainingBalance: remainingBalance,
	          forwardedBalance: forwardedBalance
	        });
	      }
	      // if (nextProps.StatementType && nextProps.StatementType !== this.props.StatementType) {
	      //   let year = '';
	      //   let month = '';
	      //   let quarter = '';
	      //   let date = -1;
	      //   const fromDate = this.props.FromDate ? formatDate(this.props.FromDate) : '1900-01-01';
	      //   const toDate = this.props.ToDate ? formatDate(this.props.ToDate) : '3000-01-01';
	      //   if (this.props.Customer) {
	      //     const customer = this.props.Customer.value || this.props.Customer;
	      //     if (this.props.Year) {
	      //       year = this.props.Year.value;
	      //       if (this.props.Month) {
	      //         if (this.props.Month.value < 10) {
	      //             month += `0${this.props.Month.value}`;
	      //         } else {
	      //           month = this.props.Month.value;
	      //         }
	      //       }
	      //       if (this.props.Quarter) {
	      //         quarter = this.props.Quarter.value;
	      //       }
	      //       date = `${year}${month}${quarter}`;
	      //       this.props.fetchCustomerStatement(fromDate, toDate, customer, nextProps.StatementType, date);
	      //     } else {
	      //       this.props.fetchCustomerStatement(fromDate, toDate, customer, nextProps.StatementType, date);
	      //     }
	      //   }
	      // }
	      if (nextProps.typeRadios && nextProps.typeRadios !== this.props.typeRadios) {
	        this.resetDates();
	      }
	
	      // if (!this.props.typeRadios) {
	      //   this.props.setDefaultOfForm('typeRadios', 'range', 'customerStatement');
	      //   this.props.setDefaultOfForm('FromDate', new Date('2017-08-18T00:00:00-0700'), 'customerStatement');
	      //   this.props.setDefaultOfForm('ToDate', new Date(), 'customerStatement');
	      // }
	      // if (nextProps.Year && nextProps.Year !== this.props.Year) {
	      //   this.setState({ yearChanged: !this.state.yearChanged });
	      // }
	
	      if (nextProps.Customer && nextProps.Customer !== this.props.Customer) {
	        this.props.fetchSalesCustomerDetail(nextProps.Customer.value || nextProps.Customer);
	        var _statementLines = [];
	        var _invoiceAmount = 0;
	        var _paymentAmount = 0;
	        var _totalBalance = 0;
	        var _remainingBalance = 0;
	        var _forwardedBalance = 0;
	        this.setState({
	          invoiceAmount: _invoiceAmount,
	          paymentAmount: _paymentAmount,
	          totalBalance: _totalBalance,
	          remainingBalance: _remainingBalance,
	          forwardedBalance: _forwardedBalance,
	          statementLines: _statementLines
	        });
	        // this.resetDates();
	        this.fetchCustomerStatement(nextProps);
	      }
	
	      if (nextProps.arReport && nextProps.arReport !== this.props.arReport) {
	        this.setState({ PdfFrameLoaded: false });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState.PdfFrameLoaded !== this.state.PdfFrameLoaded && this.state.PdfFrameLoaded === false) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'setToDate',
	    value: function setToDate(e) {
	      var _this2 = this;
	
	      if (!this.props.Customer) {
	        alert('Please select a customer!');
	        return;
	      }
	      if (e < this.state.fromDate) {
	        return;
	      }
	      this.setState({ toDate: e }, function () {
	        _this2.props.fetchCustomerStatement(_this2.state.fromDate, e, _this2.props.Customer.value, _this2.props.StatementType, _this2.state.paymentCutoffDate);
	      });
	    }
	  }, {
	    key: 'setFromDate',
	    value: function setFromDate(e) {
	      var _this3 = this;
	
	      if (!this.props.Customer) {
	        alert('Please select a customer!');
	        return;
	      }
	      if (e > this.state.toDate) {
	        return;
	      }
	      this.setState({ fromDate: e }, function () {
	        _this3.props.fetchCustomerStatement(e, _this3.state.toDate, _this3.props.Customer.value, _this3.props.StatementType, _this3.state.paymentCutoffDate);
	      });
	    }
	  }, {
	    key: 'setMonthSelected',
	    value: function setMonthSelected(e) {
	      if (!this.props.Customer) {
	        alert('Please select a customer!');
	        return;
	      }
	      this.setState({ month: e.value }, this.formatFetchMonth);
	    }
	  }, {
	    key: 'setQuarterSelected',
	    value: function setQuarterSelected(e) {
	      if (!this.props.Customer) {
	        alert('Please select a Customer!');
	        return;
	      }
	      this.setState({ quarter: e.value }, this.formatFetchQuarter);
	    }
	  }, {
	    key: 'getYearOptions',
	    value: function getYearOptions() {
	      var yearOptions = [];
	      var year = new Date().getFullYear() + 1;
	      while (year > 2017) {
	        year -= 1;
	        yearOptions.push({ value: year, label: year });
	      }
	      return yearOptions;
	    }
	  }, {
	    key: 'getMonthOptions',
	    value: function getMonthOptions() {
	      var year = this.state.year;
	
	      var dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	      var monthOptions = [];
	      var currentyear = new Date().getFullYear();
	      var month = 0;
	      if (year) {
	        if (year < currentyear) {
	          month = 12;
	        } else {
	          month = new Date().getMonth() + 1;
	        }
	        for (var i = 1; i < month + 1; i += 1) {
	          monthOptions.push({ value: i, label: dateMap[i - 1] });
	        }
	      }
	      return monthOptions;
	    }
	  }, {
	    key: 'getQuarterOptions',
	    value: function getQuarterOptions() {
	      var year = this.state.year;
	
	      var quarterOptions = [];
	      var currentyear = new Date().getFullYear();
	      var quarter = 0;
	      if (year) {
	        if (year < currentyear) {
	          quarter = 4;
	        } else {
	          var month = new Date().getMonth() + 1;
	          quarter = Math.ceil(month / 3);
	        }
	      }
	      for (var i = 1; i < quarter + 1; i += 1) {
	        quarterOptions.push({ value: i, label: i });
	      }
	      return quarterOptions;
	    }
	  }, {
	    key: 'setPaymentCutoffDate',
	    value: function setPaymentCutoffDate(e) {
	      var _this4 = this;
	
	      if (!this.props.Customer) {
	        alert('Please select a customer!');
	        return;
	      }
	      this.setState({ paymentCutoffDate: e }, function () {
	        _this4.props.fetchCustomerStatement(_this4.state.fromDate, _this4.state.toDate, _this4.props.Customer.value, _this4.props.StatementType, e);
	      });
	    }
	  }, {
	    key: 'getCustomerNameOptions',
	    value: function getCustomerNameOptions() {
	      var customerOptions = [];
	      this.props.customers.map(function (customer) {
	        customerOptions.push({ value: customer.Customer_id, label: customer.Name });
	      });
	      return customerOptions;
	    }
	  }, {
	    key: 'getCustomerNumOptions',
	    value: function getCustomerNumOptions() {
	      var customerOptions = [];
	      this.props.customers.map(function (customer) {
	        customerOptions.push({ value: customer.Customer_id, label: customer.CustomerNum });
	      });
	      return customerOptions;
	    }
	  }, {
	    key: 'getCustomerPhoneOptions',
	    value: function getCustomerPhoneOptions() {
	      var customerOptions = [];
	      this.props.customers.map(function (customer) {
	        customerOptions.push({ value: customer.Customer_id, label: customer.Telephone });
	      });
	      return customerOptions;
	    }
	  }, {
	    key: 'getCustomerDescriptionOptions',
	    value: function getCustomerDescriptionOptions() {
	      var customerOptions = [];
	      this.props.customers.map(function (customer) {
	        customerOptions.push({ value: customer.Customer_id, label: customer.Description });
	      });
	      return customerOptions;
	    }
	  }, {
	    key: 'formatFetchMonth',
	    value: function formatFetchMonth() {
	      var _this5 = this;
	
	      var _state = this.state,
	          year = _state.year,
	          month = _state.month,
	          typeRadios = _state.typeRadios;
	
	      var FromDate = (0, _moment2.default)([year, month - 1]);
	      var ToDate = (0, _moment2.default)(FromDate).endOf('month');
	      FromDate = FromDate.toISOString();
	      ToDate = ToDate.toISOString();
	      this.setState({
	        fromDate: FromDate, toDate: ToDate, typeRadios: typeRadios
	      }, function () {
	        _this5.props.fetchCustomerStatement(FromDate, ToDate, _this5.props.Customer.value, _this5.props.StatementType, _this5.state.paymentCutoffDate);
	      });
	    }
	  }, {
	    key: 'formatFetchQuarter',
	    value: function formatFetchQuarter() {
	      var _this6 = this;
	
	      var _state2 = this.state,
	          year = _state2.year,
	          quarter = _state2.quarter,
	          typeRadios = _state2.typeRadios;
	
	      var FromDate = (0, _moment2.default)([year, (quarter - 1) * 3]);
	      var ToDate = (0, _moment2.default)([year, quarter * 3 - 1]).endOf('month');
	      FromDate = FromDate.toISOString();
	      ToDate = ToDate.toISOString();
	      this.setState({
	        fromDate: FromDate, toDate: ToDate, typeRadios: typeRadios
	      }, function () {
	        _this6.props.fetchCustomerStatement(FromDate, ToDate, _this6.props.Customer.value, _this6.props.StatementType, _this6.state.paymentCutoffDate);
	      });
	    }
	  }, {
	    key: 'resetDates',
	    value: function resetDates() {
	      // this.props.setValue('customerStatement', 'FromDate', '');
	      // this.props.setValue('customerStatement', 'ToDate', '');
	      this.props.setValue('customerStatement', 'Year', '');
	      this.props.setValue('customerStatement', 'Month', '');
	      this.props.setValue('customerStatement', 'Quarter', '');
	    }
	  }, {
	    key: 'handleDateFilterChange',
	    value: function handleDateFilterChange(type) {
	      var _this7 = this;
	
	      if (!this.props.Customer) {
	        alert('Please select a Customer!');
	        return;
	      }
	      if (type === 'month') {
	        this.setState({ typeRadios: type, year: new Date().getFullYear(), month: new Date().getMonth() + 1 }, this.formatFetchMonth);
	      } else if (type === 'quarter') {
	        this.setState({ typeRadios: type, year: new Date().getFullYear(), quarter: CustomerStatement.getQuarter() }, this.formatFetchQuarter);
	      } else if (type === 'range' && type !== this.state.typeRadios) {
	        this.setState({
	          typeRadios: type, fromDate: new Date('2017-08-18T00:00:00-0700'), toDate: new Date()
	        }, function () {
	          _this7.props.fetchCustomerStatement(_this7.state.fromDate, _this7.state.toDate, _this7.props.Customer.value, _this7.props.StatementType, _this7.state.paymentCutoffDate);
	        });
	      }
	    }
	  }, {
	    key: 'renderIFrame',
	    value: function renderIFrame() {
	      if (this.props.arReport) {
	        var file = window.URL.createObjectURL(this.props.arReport);
	        return _react2.default.createElement('iframe', { style: { display: 'none' }, onLoad: this.IFrameIsLoaded, id: 'Pdf', name: 'Pdf', src: file });
	      }
	    }
	  }, {
	    key: 'renderDateSelector',
	    value: function renderDateSelector() {
	      var _this8 = this;
	
	      var yearOptions = this.getYearOptions();
	      if (this.state.typeRadios === 'range') {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'report-table-filters', id: 'customer-statement-date-selector' },
	            _react2.default.createElement(
	              'label',
	              { className: 'from-label' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'from' })
	            ),
	            (0, _GenericDatePicker2.default)({
	              setDate: this.setFromDate,
	              selectedDate: this.state.fromDate,
	              onChange: function onChange(e) {
	                _this8.setFromDate(e);
	              }
	            }),
	            _react2.default.createElement(
	              'label',
	              { className: 'to-label' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'to' })
	            ),
	            (0, _GenericDatePicker2.default)({
	              setDate: this.setToDate,
	              selectedDate: this.state.toDate,
	              onChange: function onChange(e) {
	                _this8.setToDate(e);
	              }
	            })
	          )
	        );
	      } else if (this.state.typeRadios === 'month') {
	        var monthOptions = this.getMonthOptions();
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { className: 'report-table-filters', id: 'customer-statement-date-selector' },
	            (0, _GenericSelection2.default)({
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'year' }),
	              options: yearOptions,
	              value: this.state.year,
	              setSelected: function setSelected(e) {
	                _this8.setState({ year: e.value });
	              }
	            }),
	            (0, _GenericSelection2.default)({
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'month' }),
	              options: monthOptions,
	              value: this.state.month,
	              setSelected: this.setMonthSelected
	            })
	          )
	        );
	      }
	      var quarterOptions = this.getQuarterOptions();
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 12 },
	        _react2.default.createElement(
	          'div',
	          { className: 'report-table-filters', id: 'customer-statement-date-selector' },
	          (0, _GenericSelection2.default)({
	            translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'year' }),
	            options: yearOptions,
	            value: this.state.year,
	            setSelected: function setSelected(e) {
	              _this8.setState({ year: e.value });
	            }
	          }),
	          (0, _GenericSelection2.default)({
	            translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quarter' }),
	            options: quarterOptions,
	            value: this.state.quarter,
	            setSelected: this.setQuarterSelected
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderCustomerDetail',
	    value: function renderCustomerDetail() {
	      var customerNameOptions = this.getCustomerNameOptions();
	      var customerNumOptions = this.getCustomerNumOptions();
	      var customerPhoneOptions = this.getCustomerPhoneOptions();
	      var customerDescriptionOptions = this.getCustomerDescriptionOptions();
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 4, id: 'customer-details' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Customer Information' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'asteriksReq' },
	                '*'
	              ),
	              ' '
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'customer-name-dropdown', className: 'col-xs-8' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'Customer', component: _selection.Selection, matchPos: 'any', options: customerNameOptions })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'customer-id-dropdown', className: 'col-xs-8' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'Customer', component: _selection.Selection, matchPos: 'any', options: customerNumOptions })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'customer-phone-dropdown', className: 'col-xs-8' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'Customer', component: _selection.Selection, matchPos: 'any', options: customerPhoneOptions })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-8' },
	              this.renderCustomerPaymentTerm()
	            )
	          ),
	          isEcity && _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'default_sales' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-8' },
	              this.renderCustomerDefaultSales()
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 4, xsOffset: 1, id: 'billing-info' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Billing Information' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'contact' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 9 },
	              !this.props.salesCustomerDetails && _react2.default.createElement(
	                'label',
	                { className: 'text-nowrap' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_a_customer' })
	              ),
	              this.props.salesCustomerDetails && _react2.default.createElement(
	                'span',
	                null,
	                this.props.salesCustomerDetails.Contact
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	            ),
	            this.props.salesCustomerDetails && _react2.default.createElement(
	              'div',
	              { className: 'col-xs-9' },
	              this.props.salesCustomerDetails.Telephone
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group mb0' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' })
	            ),
	            this.props.salesCustomerDetails && _react2.default.createElement(
	              'div',
	              { className: 'col-xs-9' },
	              _react2.default.createElement(
	                'div',
	                null,
	                this.props.salesCustomerDetails.Address1
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                this.props.salesCustomerDetails.Address2
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderAmountDetail',
	    value: function renderAmountDetail() {
	      var _state3 = this.state,
	          invoiceAmount = _state3.invoiceAmount,
	          paymentAmount = _state3.paymentAmount,
	          totalBalance = _state3.totalBalance,
	          remainingBalance = _state3.remainingBalance,
	          forwardedBalance = _state3.forwardedBalance;
	      // const { StatementType } = this.props;
	      // const renderprevious = () => {
	      //   if (StatementType === 'forwarded') {
	      //     return (
	      //       <RowLabelField
	      //         translation='previous_balance_forward: '
	      //         value={`$${forwardedBalance}`}
	      //       />
	      //     );
	      //   }
	      // };
	
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 3, id: 'zmount-details' },
	        _react2.default.createElement(_RowLabelField2.default, {
	          translation: 'balance_forward: ',
	          value: '$' + (0, _numberWithCommas.numberWithCommas)(forwardedBalance) || 0,
	          right: 4
	        }),
	        _react2.default.createElement(_RowLabelField2.default, {
	          translation: 'total_invoice_amount: ',
	          value: '$' + (0, _numberWithCommas.numberWithCommas)(invoiceAmount) || 0,
	          right: 4
	        }),
	        _react2.default.createElement(_RowLabelField2.default, {
	          translation: 'total_payment: ',
	          value: '$' + (0, _numberWithCommas.numberWithCommas)(paymentAmount) || 0,
	          right: 4
	        }),
	        _react2.default.createElement(_RowLabelField2.default, {
	          translation: 'outstanding_balance: ',
	          value: '$' + (0, _numberWithCommas.numberWithCommas)(totalBalance) || 0,
	          right: 4
	        }),
	        _react2.default.createElement(_RowLabelField2.default, {
	          translation: 'remaining_balance: ',
	          value: '$' + (0, _numberWithCommas.numberWithCommas)(remainingBalance) || 0,
	          right: 4
	        })
	      );
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      if (this.props.customerStatementIsLoading && !this.props.customerStatementError) {
	        return _react2.default.createElement(
	          'div',
	          { id: 'spinner' },
	          _react2.default.createElement(_spinner2.default, null)
	        );
	      } else if (this.props.customerStatementError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'something_unexpected_happened' })
	          )
	        );
	      }
	      var statementLines = this.state.statementLines;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { className: 'react-table-ar-ap-customer-statement' },
	            _react2.default.createElement(_customerStatementDetailTable2.default, {
	              rows: statementLines,
	              minHeight: 500,
	              onSalesInvoiceNumDoubleClick: this.props.printSalesInvoiceForCustomerStatement,
	              onSalesReturnNumDoubleClick: this.props.printSalesInvoiceReturn
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderToolbarButtons',
	    value: function renderToolbarButtons() {
	      var _this9 = this;
	
	      var Customer = this.props.Customer;
	      var _state4 = this.state,
	          fromDate = _state4.fromDate,
	          toDate = _state4.toDate;
	
	      var dates = (0, _cleanDates.toFromDates)(-1, fromDate, toDate);
	      var customer = void 0;
	      if (Customer) {
	        customer = Customer.value || Customer;
	      }
	      var paymentCutoffDate = (0, _cleanDates.getFromToDates)(this.state.paymentCutoffDate).toDate;
	      var token = localStorage.getItem('token');
	      var arUrl = customer ? '/AR/new?cust_id=' + customer : '/AR/new';
	      var simplifiedExport = _root_url.ROOT_URL + 'v1/ar/report/aged/' + customer + '/simplifiedexcel/?start_date=' + dates.fromDate + '&end_date=' + dates.toDate + '&cut_off_date=' + paymentCutoffDate + '&Bearer=' + token;
	      var detailedExport = _root_url.ROOT_URL + 'v1/ar/report/aged/' + customer + '/excel/?start_date=' + dates.fromDate + '&end_date=' + dates.toDate + '&cut_off_date=' + paymentCutoffDate + '&Bearer=' + token;
	      return _react2.default.createElement(
	        _reactBootstrap.ButtonToolbar,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            href: arUrl,
	            disabled: !(0, _permissions2.default)('change_account_receivable')
	          },
	          _react2.default.createElement('em', { className: 'fa fa-plus' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_ar' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            href: simplifiedExport,
	            disabled: !customer || !(0, _permissions2.default)('print_customer_statement')
	          },
	          _react2.default.createElement('em', { className: 'fa fa-download' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'simplified_excel' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            href: detailedExport,
	            disabled: !customer || !(0, _permissions2.default)('print_customer_statement')
	          },
	          _react2.default.createElement('em', { className: 'fa fa-download' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'detailed_excel' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.DropdownButton,
	          {
	            bsStyle: 'primary',
	            disabled: !customer || !(0, _permissions2.default)('print_customer_statement'),
	            title: _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement('em', { className: 'fa fa-print' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_statements' })
	            ),
	            noCaret: true,
	            id: 'dropdown-statement'
	          },
	          _react2.default.createElement(
	            _reactBootstrap.MenuItem,
	            {
	              eventKey: '1',
	              onSelect: function onSelect() {
	                _this9.props.printARReport(customer, dates.fromDate, dates.toDate, paymentCutoffDate, false);
	              }
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'detailed_statement' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.MenuItem,
	            {
	              eventKey: '2',
	              onSelect: function onSelect() {
	                _this9.props.printARReport(customer, dates.fromDate, dates.toDate, paymentCutoffDate, true);
	              }
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'simplified_statement' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.MenuItem,
	            {
	              eventKey: '3',
	              onSelect: function onSelect() {
	                _this9.props.printPlainARReport(customer, dates.fromDate, dates.toDate, paymentCutoffDate, 'print');
	              }
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'detailed_plain_statement' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.MenuItem,
	            {
	              eventKey: '4',
	              onSelect: function onSelect() {
	                _this9.props.printPlainARReport(customer, dates.fromDate, dates.toDate, paymentCutoffDate, 'simplified-print');
	              }
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'simplified_plain_statement' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.MenuItem,
	            {
	              eventKey: '5',
	              onSelect: function onSelect() {
	                _this9.props.printPlainARReport(customer, dates.fromDate, dates.toDate, paymentCutoffDate, 'monthly-print');
	              }
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'monthly_statement' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.MenuItem,
	            {
	              eventKey: '6',
	              onSelect: function onSelect() {
	                _this9.props.printPlainARReport(customer, dates.fromDate, dates.toDate, paymentCutoffDate, 'payment-term-print');
	              }
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'danger',
	            type: 'button',
	            onClick: function onClick() {
	              _this9.props.router.push('/customerStatementMain');
	            }
	          },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'back' })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_slashsign_ap' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_statement' })
	          )
	        ),
	        this.renderToolbarButtons(),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'customer-statement' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'fieldset',
	                { className: 'form-horizontal' },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { id: 'customer-statement-customer-info' },
	                  this.renderCustomerDetail()
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            { id: 'date-range-picker', className: 'form-horizontal' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 1, id: 'filter-title-center' },
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'text-right' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'statement_range' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'colon' },
	                    ':'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 4 },
	                _react2.default.createElement(
	                  'div',
	                  { id: 'status-filter-radios' },
	                  (0, _genericRadioFilter2.default)({
	                    content: [{
	                      option: 'range',
	                      id: 'dateRange-radio-filter',
	                      name: 'dateFilterRadios',
	                      labelName: 'date_range'
	                    }, {
	                      option: 'quarter',
	                      id: 'quarter-radio-filter',
	                      name: 'dateFilterRadios',
	                      labelName: 'quarter'
	                    }, {
	                      option: 'month',
	                      id: 'month-radio-filter',
	                      name: 'dateFilterRadios',
	                      labelName: 'month'
	                    }],
	                    value: this.state.typeRadios,
	                    handleOnClick: this.handleDateFilterChange,
	                    type: 'buttons'
	                  })
	                ),
	                this.renderDateSelector()
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 1, id: 'filter-title-center' },
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'text-right' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_cutoff_date' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'colon' },
	                    ':'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 2, id: 'status-filter-radios' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  (0, _GenericDatePicker2.default)({
	                    setDate: this.setPaymentCutoffDate,
	                    selectedDate: this.state.paymentCutoffDate
	                  })
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { style: { position: "relative", left: "5px", top: "3px" } },
	                  '(simplified statement only)'
	                )
	              ),
	              this.renderAmountDetail()
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { className: 'position-relative table-collapse-fix mb0' },
	                this.renderTable()
	              )
	            )
	          )
	        ),
	        this.renderIFrame()
	      );
	    }
	  }]);
	
	  return CustomerStatement;
	}(_react.Component);
	
	var _default = CustomerStatement;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/customerStatement.jsx');
	
	  __REACT_HOT_LOADER__.register(getBsStyle, 'getBsStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/customerStatement.jsx');
	
	  __REACT_HOT_LOADER__.register(CustomerStatement, 'CustomerStatement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/customerStatement.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/customerStatement.jsx');
	}();

	;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _moment3 = __webpack_require__(41);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _datePicker = __webpack_require__(27);
	
	var _inputField = __webpack_require__(16);
	
	var _priceFormatter = __webpack_require__(56);
	
	var _priceFormatter2 = _interopRequireDefault(_priceFormatter);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _numberWithCommas = __webpack_require__(35);
	
	var _selection = __webpack_require__(21);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEcity = _root_url.ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/';
	
	(0, _moment4.default)(_moment2.default);
	
	var getBsStyle = function getBsStyle(input, value) {
	  return input === value ? 'success' : 'primary';
	};
	
	var RowRenderer = function (_Component) {
	  _inherits(RowRenderer, _Component);
	
	  function RowRenderer() {
	    _classCallCheck(this, RowRenderer);
	
	    return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(RowRenderer, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      //here we are just changing the style
	      //but we could replace this with anything we liked, cards, images, etc
	      //usually though it will just be a matter of wrapping a div, and then calling back through to the grid
	      return _react2.default.createElement(
	        'div',
	        { onDoubleClick: function onDoubleClick() {
	            _this2.props.onDoubleClick(_this2.props.row);
	          } },
	        _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	      );
	    }
	  }]);
	
	  return RowRenderer;
	}(_react.Component);
	
	RowRenderer.PropTypes = {
	  onDoubleClick: _react2.default.PropTypes.func
	};
	
	var renderCustomerTypeRadios = function renderCustomerTypeRadios(props) {
	  var titleClass = (0, _classnames2.default)({ 'parsley-error-label': props.meta.error }, 'col-xs-4');
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'long-radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'all') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'all-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'all-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'all', checked: props.input.value === 'all' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'Active') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'active-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'active-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'Active', checked: props.input.value === 'Active' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'active' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'Inactive') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'inactive-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'inactive-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'Inactive', checked: props.input.value === 'Inactive' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inactive' })
	        )
	      )
	    )
	  );
	};
	
	var CustomerStatementMain = function (_Component2) {
	  _inherits(CustomerStatementMain, _Component2);
	
	  function CustomerStatementMain() {
	    _classCallCheck(this, CustomerStatementMain);
	
	    var _this3 = _possibleConstructorReturn(this, (CustomerStatementMain.__proto__ || Object.getPrototypeOf(CustomerStatementMain)).call(this));
	
	    _this3.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.customersPage,
	      rows: [],
	      filters: {},
	      sortColumn: null,
	      sortDirection: null,
	
	      amount00_07: 0,
	      amount08_30: 0,
	      amount00_30: 0,
	      amount31_60: 0,
	      amount61_90: 0,
	      amount_91: 0,
	      current: 0,
	      grand_amount: 0,
	      Days: '',
	      PaymentTerm: ''
	    };
	    _this3.handleResize = _this3.handleResize.bind(_this3);
	    _this3.fetchCustomerStatementList = _this3.fetchCustomerStatementList.bind(_this3);
	    _this3.statementDetail = _this3.statementDetail.bind(_this3);
	    return _this3;
	  }
	
	  _createClass(CustomerStatementMain, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.setDefaultOfForm('typeRadios', 'Active', 'customerStatementMain');
	      this.props.setDefaultOfForm('Days', new Date(), 'customerStatementMain');
	      this.props.setDefaultOfForm('PaymentTerm', '', 'customerStatementMain');
	      this.props.fetchCustomerStatementList('Active', (0, _moment2.default)().format('YYYY-MM-DD'));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      window.addEventListener('resize', this.handleResize);
	      this.props.fetchPaymentTerms();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!nextProps.typeRadios) {
	        this.props.setDefaultOfForm('typeRadios', 'Active', 'customerStatementMain');
	      }
	      if (!nextProps.Days) {
	        this.props.setDefaultOfForm('Days', new Date(), 'customerStatementMain');
	      }
	      if (!nextProps.PaymentTerm) {
	        this.props.setDefaultOfForm('PaymentTerm', '', 'customerStatementMain');
	      }
	      if (nextProps.customerStatementList && nextProps.customerStatementList !== this.props.customerStatementList) {
	        var _nextProps$customerSt = nextProps.customerStatementList,
	            statement_lines = _nextProps$customerSt.statement_lines,
	            amount00_07 = _nextProps$customerSt.amount00_07,
	            amount08_30 = _nextProps$customerSt.amount08_30,
	            amount00_30 = _nextProps$customerSt.amount00_30,
	            amount31_60 = _nextProps$customerSt.amount31_60,
	            amount61_90 = _nextProps$customerSt.amount61_90,
	            amount_91 = _nextProps$customerSt.amount_91,
	            current = _nextProps$customerSt.current,
	            grand_amount = _nextProps$customerSt.grand_amount;
	
	
	        this.setState({
	          rows: statement_lines,
	          amount00_07: parseFloat(amount00_07).toFixed(2) || 0,
	          amount08_30: parseFloat(amount08_30).toFixed(2) || 0,
	          amount00_30: parseFloat(amount00_30).toFixed(2) || 0,
	          amount31_60: parseFloat(amount31_60).toFixed(2) || 0,
	          amount61_90: parseFloat(amount61_90).toFixed(2) || 0,
	          amount_91: parseFloat(amount_91).toFixed(2) || 0,
	          current: parseFloat(current).toFixed(2) || 0,
	          grand_amount: parseFloat(grand_amount).toFixed(2) || 0
	        });
	      }
	
	      if (nextProps.typeRadios && nextProps.typeRadios !== this.props.typeRadios) {
	        if (this.props.Days) {
	          var days = (0, _moment2.default)(this.props.Days).format('YYYY-MM-DD');
	          this.props.fetchCustomerStatementList(nextProps.typeRadios, days, this.state.PaymentTerm);
	        }
	      }
	      if (nextProps.Days && nextProps.Days !== this.props.Days) {
	        var Days = nextProps.Days;
	
	        this.setState({ Days: Days }, this.fetchCustomerStatementList);
	      }
	      if (nextProps.PaymentTerm && nextProps.PaymentTerm !== this.props.PaymentTerm) {
	        var PaymentTerm = nextProps.PaymentTerm;
	
	        this.setState({ PaymentTerm: PaymentTerm }, this.fetchCustomerStatementList);
	      }
	      if (this.props.PaymentTerm && nextProps.PaymentTerm == null) {
	        this.setState({ PaymentTerm: '' }, this.fetchCustomerStatementList);
	      }
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.customersPage });
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      var formattedDate = date.getFullYear() + '-';
	      formattedDate += date.getMonth() + 1 + '-';
	      if (date.getDate() < 10) {
	        formattedDate += '0' + date.getDate();
	      } else {
	        formattedDate += date.getDate();
	      }
	      return formattedDate;
	    }
	  }, {
	    key: 'statementDetail',
	    value: function statementDetail() {
	      var currentCustomer = arguments[0];
	      this.props.resetCurrentCustomer();
	      this.props.selectCustomer(currentCustomer);
	      this.context.router.push('/customerStatement');
	    }
	    // this.context.router.push('/products/'+currentInventory.Product_id);
	
	  }, {
	    key: 'fetchCustomerStatementList',
	    value: function fetchCustomerStatementList() {
	      if (this.state.Days) {
	        var days = (0, _moment2.default)(this.state.Days).format('YYYY-MM-DD');
	        this.props.fetchCustomerStatementList(this.props.typeRadios, days, this.state.PaymentTerm);
	      }
	    }
	  }, {
	    key: 'getPaymentTerms',
	    value: function getPaymentTerms() {
	      var PaymentTerms = [];
	      this.props.paymentTerms.map(function (payment) {
	        PaymentTerms.push({ value: payment.id, label: payment.name });
	      });
	      return PaymentTerms;
	    }
	  }, {
	    key: 'renderPaymentTerms',
	    value: function renderPaymentTerms() {
	      if (this.props.isLoading) return _react2.default.createElement(_spinner2.default, null); // If is loading, show a spinner.
	      var PaymentTerms = this.getPaymentTerms();
	      return _react2.default.createElement(
	        'div',
	        { style: { width: "130px" } },
	        _react2.default.createElement(_reduxForm.Field, { name: 'PaymentTerm', component: _selection.Selection, options: PaymentTerms })
	      );
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this4 = this;
	
	      if (this.props.customerStatementListIsLoading && !this.props.customerStatementListError) {
	        return _react2.default.createElement(
	          'div',
	          { id: 'spinner' },
	          _react2.default.createElement(_spinner2.default, null)
	        );
	      } else if (this.props.customerStatementListError) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'something_unexpected_happened' })
	        );
	      } else {
	        // Parameters of the react-data-grid
	        var tableHeight = window.innerHeight < 930 ? 510 : 510;
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this4.state);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          _this4.setState(function (prevState) {
	            return _extends({}, prevState, {
	              sortColumn: sortColumn,
	              sortDirection: sortDirection
	            });
	          });
	        };
	
	        var handleFilterChange = function handleFilterChange(filter) {
	          var newFilters = Object.assign({}, _this4.state.filters);
	          if (filter.filterTerm) {
	            newFilters[filter.column.key] = filter;
	          } else {
	            delete newFilters[filter.column.key];
	          }
	          _this4.setState({ filters: newFilters });
	        };
	
	        //Custom Formatter component
	        var DateFormatter = _react2.default.createClass({
	          displayName: 'DateFormatter',
	          render: function render() {
	            if (this.props.value) {
	              var dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	              var date = new Date(this.props.value);
	              var index = dateMap.indexOf(date.toString().slice(4, 3));
	              var localDate = index + date.toString().slice(8, 6);
	              return _react2.default.createElement(
	                'span',
	                null,
	                date.toString().slice(4, 15)
	              );;
	            } else return _react2.default.createElement(
	              'span',
	              { className: 'label label-danger' },
	              '-'
	            );
	          }
	        });
	
	        // Column difinition
	        var columns = [{
	          key: 'CustomerNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_num' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 120
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 200
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 100
	        },
	        /* { // Commented 11/17/17 branch: feature/ARAP
	            key: 'current',
	            name: <Translate value="current" />,
	            resizable: true,
	            sortable: true,
	            width: 80,
	            formatter: PriceFormatter,
	        }, */
	        {
	          key: 'PaymentTerm_Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 100
	        }, {
	          key: 'amount00_30',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '00_dashsign_30_days' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 80,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'amount31_60',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '31_dashsign_60_days' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 80,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'amount61_90',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '61_dashsign_90_days' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 80,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'amount_91',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '91_plussign_days' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 80,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'total_amount',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_amount' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 100,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'Sales_User_Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 100
	        }];
	
	        if (isEcity) {
	          var indexEstDelivery = _.findIndex(columns, { key: 'amount00_30' });
	          var estColum1 = {
	            key: 'amount00_07',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '00_dashsign_07_days' }),
	            resizable: true,
	            sortable: true,
	            width: 80,
	            formatter: _cashFormatter2.default
	          };
	          var estColum2 = {
	            key: 'amount08_30',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '08_dashsign_30_days' }),
	            resizable: true,
	            sortable: true,
	            width: 80,
	            formatter: _cashFormatter2.default
	          };
	          columns.splice(indexEstDelivery, 1, estColum1);
	          columns.splice(indexEstDelivery + 1, 0, estColum2);
	        }
	
	        //React Table Purchase Order Full Table
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { className: 'react-table-ar-ap-customer-list-statement', id: 'CustomerStatementMain-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: this.statementDetail }),
	                rowKey: 'Deliver_Customer_id',
	                enableCellSelect: true,
	                onGridSort: handleGridSort,
	                columns: columns,
	                rowHeight: 25,
	                headerRowHeight: 45,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                minHeight: tableHeight
	                // toolbar={<Toolbar enableFilter />}
	                // onAddFilter={handleFilterChange}
	              })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderSimplifiedExportButton',
	    value: function renderSimplifiedExportButton() {
	      var typeRadios = this.props.typeRadios;
	      var date = this.props.Days;
	
	      date = (0, _moment2.default)(date).endOf('day').toISOString();
	      date = 'PostingDate=' + date;
	      var token = localStorage.getItem('token');
	      var url = _root_url.ROOT_URL + 'v1/ar/statement/excel/' + (typeRadios || 'Active') + '/?' + date + '&Bearer=' + token;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          href: url
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'simplified_excel' })
	      );
	    }
	  }, {
	    key: 'renderDetailedExportButton',
	    value: function renderDetailedExportButton() {
	      var typeRadios = this.props.typeRadios;
	      var date = this.props.Days;
	
	      date = (0, _moment2.default)(date).endOf('day').toISOString();
	      date = 'PostingDate=' + date;
	      var token = localStorage.getItem('token');
	      var exportUrl = _root_url.ROOT_URL + 'v1/ar/report/aged/' + (typeRadios || 'Active') + '/excel/?' + date + '&Bearer=' + token;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'pull-right',
	          href: exportUrl
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'detailed_excel' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_slashsign_ap' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_aged_report' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            null,
	            this.renderSimplifiedExportButton(),
	            this.renderDetailedExportButton()
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'customer-statement' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { id: 'date-range-picker', className: 'form-horizontal' },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      'h3',
	                      { className: 'text-right text-nowrap' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'statement_date' }),
	                      _react2.default.createElement(
	                        'span',
	                        { classNames: 'colon' },
	                        ':'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 10 },
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'statusFilterRadios' },
	                      _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        { className: 'radio-filter-buttons' },
	                        _react2.default.createElement(
	                          _reactBootstrap.Button,
	                          { bsStyle: 'primary' },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Days', placeholder: 'Date', component: _datePicker.DatePicker })
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      'h3',
	                      { className: 'text-right text-nowrap' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_status' }),
	                      _react2.default.createElement(
	                        'span',
	                        { classNames: 'colon' },
	                        ':'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 10 },
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'statusFilterRadios' },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'typeRadios', component: renderCustomerTypeRadios })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 12 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { className: 'position-relative mb0', id: 'table-height-fix' },
	                    _root_url.isRivera && _react2.default.createElement(
	                      'div',
	                      { style: { display: "flex" } },
	                      _react2.default.createElement(
	                        'label',
	                        {
	                          style: { marginRight: "10px", marginBottom: "10px" },
	                          className: 'control-label'
	                        },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term_short' })
	                      ),
	                      this.renderPaymentTerms()
	                    ),
	                    this.renderTable()
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 12 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { className: 'position-relative mb0' },
	                    !isEcity && _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-6 text-nowrap' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: '00_dashsign_30_days' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'dollar-sign' },
	                          ' $$'
	                        ),
	                        ':\xA0'
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'amount00_30', component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.amount00_30) || 0 })
	                      )
	                    ),
	                    isEcity && _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 2 },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-xs-6 text-nowrap' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: '00_dashsign_07_days' }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            ' $$'
	                          ),
	                          ':\xA0'
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 7 },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'amount00_07', component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.amount00_07) || 0 })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 2 },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-xs-6 text-nowrap' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: '08_dashsign_30_days' }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            ' $$'
	                          ),
	                          ':\xA0'
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 7 },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'amount08_30', component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.amount08_30) || 0 })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-6 text-nowrap' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: '31_dashsign_60_days' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'dollar-sign' },
	                          ' $$'
	                        ),
	                        ':\xA0'
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'amount31_60', component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.amount31_60) || 0 })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-6 text-nowrap' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: '61_dashsign_90_days' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'dollar-sign' },
	                          ' $$'
	                        ),
	                        ':\xA0'
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'amount61_90', component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.amount61_90) || 0 })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-6 text-nowrap' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: '91_plussign_days' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'dollar-sign' },
	                          ' $$'
	                        ),
	                        ':\xA0'
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'amount_91', component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.amount_91) || 0 })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-6 text-nowrap' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'grand_total' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'dollar-sign' },
	                          ' $$'
	                        ),
	                        ':\xA0'
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'grand_amount', component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.grand_amount) || 0 })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	        //---------------
	        // End HTML: Purchase Order List
	        //---------------
	
	      );
	    }
	  }]);
	
	  return CustomerStatementMain;
	}(_react.Component);
	
	CustomerStatementMain.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = CustomerStatementMain;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/customerStatementMain.jsx');
	
	  __REACT_HOT_LOADER__.register(getBsStyle, 'getBsStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/customerStatementMain.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/customerStatementMain.jsx');
	
	  __REACT_HOT_LOADER__.register(renderCustomerTypeRadios, 'renderCustomerTypeRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/customerStatementMain.jsx');
	
	  __REACT_HOT_LOADER__.register(CustomerStatementMain, 'CustomerStatementMain', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/customerStatementMain.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/customerStatementMain.jsx');
	}();

	;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _inputField = __webpack_require__(16);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _selection = __webpack_require__(21);
	
	var _datePicker = __webpack_require__(27);
	
	var _dateFormat = __webpack_require__(39);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _arModifiableTable = __webpack_require__(231);
	
	var _arModifiableTable2 = _interopRequireDefault(_arModifiableTable);
	
	var _accountDropdown = __webpack_require__(92);
	
	var _accountDropdown2 = _interopRequireDefault(_accountDropdown);
	
	var _arapPaymentOptions = __webpack_require__(94);
	
	var _arapPaymentOptions2 = _interopRequireDefault(_arapPaymentOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditAR = function (_Component) {
	  _inherits(EditAR, _Component);
	
	  function EditAR() {
	    _classCallCheck(this, EditAR);
	
	    var _this = _possibleConstructorReturn(this, (EditAR.__proto__ || Object.getPrototypeOf(EditAR)).call(this));
	
	    _this.debouncedEditAR = _lodash2.default.debounce(function (formProps, rows) {
	      _this.props.editAR(formProps, rows).then(function () {
	        if (_this.props.arEdited && !_this.props.arEditError) {
	          _this.props.router.push('/AR');
	        }
	      });
	    }, 500, { maxWait: 1000 });
	
	    _this.handlePaymentCellChange = function (rows) {
	      var totalPayment = 0;
	      var totalAmount = 0;
	      rows.map(function (row) {
	        totalPayment += parseFloat(row.Amount) || 0;
	        totalAmount += parseFloat(row.PreviousBalance) || 0;
	      });
	      _this.setState({
	        totalPayment: totalPayment,
	        totalAmount: totalAmount
	      });
	    };
	
	    _this.handlePaymentAmountInputChange = function (event) {
	      // charCode 13 = key 'Enter'
	      // if (event.charCode === 13) {
	      var payment = parseFloat(event.target.value || 0).toFixed(2) || 0;
	      var rows = [].concat(_toConsumableArray(_this.state.rows));
	      for (var i = 0; i < rows.length; i++) {
	        var rowToUpdate = rows[i];
	        var PreviousBalance = rowToUpdate.PreviousBalance;
	
	        var unpaidAmount = PreviousBalance || 0;
	        if (payment >= unpaidAmount) {
	          rowToUpdate.Amount = +parseFloat(unpaidAmount).toFixed(2);
	          rowToUpdate.UnpaidAmount = 0;
	          payment -= unpaidAmount;
	        } else {
	          rowToUpdate.Amount = +parseFloat(payment).toFixed(2);
	          rowToUpdate.UnpaidAmount = +parseFloat(parseFloat(unpaidAmount) - parseFloat(payment)).toFixed(2);
	          payment = 0;
	        }
	        // overpay condition, add payment to last row
	        if (payment > 0 && i === rows.length - 1) {
	          rowToUpdate.Amount += +parseFloat(payment).toFixed(2);
	          rowToUpdate.UnpaidAmount -= +parseFloat(payment).toFixed(2);
	        }
	        rows[i] = rowToUpdate;
	        // totalAmount += PreviousBalance;
	      }
	      _this.setState({ rows: rows });
	      // }
	    };
	
	    _this.renderInputField = function (props) {
	      var _props$meta = props.meta,
	          touched = _props$meta.touched,
	          error = _props$meta.error,
	          className = props.className;
	
	      var inputClass = (0, _classnames2.default)({ 'parsley-error': touched && error }, 'form-control', className);
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, {
	          className: inputClass,
	          type: 'text',
	          onChange: function onChange(event) {
	            props.input.onChange(event);
	            props.handleOnChange(event);
	          },
	          disabled: props.disabled
	        })),
	        touched && error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          error
	        )
	      );
	    };
	
	    _this.state = {
	      rows: [],
	      unpaidAmount: 0,
	      totalAmount: 0,
	      checkAuthorizeOpen: false,
	      action: null,
	      waiveShouldDisable: true,
	      waiveAmount: 0,
	      penaltyAmount: 0,
	      totalPayment: 0,
	      isAREditable: false
	    };
	    _this.renderWaiveCheckbox = _this.renderWaiveCheckbox.bind(_this);
	    _this.checkAuthorize = _this.checkAuthorize.bind(_this);
	    _this.handleWaiveCheckboxChange = _this.handleWaiveCheckboxChange.bind(_this);
	    _this.closeCheckAuthorize = _this.closeCheckAuthorize.bind(_this);
	    _this.handleWaiveInputChange = _this.handleWaiveInputChange.bind(_this);
	    _this.handleFormSubmit = _this.handleFormSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(EditAR, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.clearARForm();
	      this.props.clearCredits();
	      var id = this.props.routeParams.id;
	
	      if (id) {
	        this.props.fetchARDetail(id);
	      } else {
	        this.context.router.push('/AR/');
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.penaltyAmount !== this.props.penaltyAmount) {
	        var penaltyAmount = parseFloat(nextProps.penaltyAmount) || 0;
	        this.setState({ penaltyAmount: penaltyAmount });
	      }
	      if (nextProps.arDetail && nextProps.arDetail !== this.props.arDetail) {
	        var _nextProps$arDetail = nextProps.arDetail,
	            Status = _nextProps$arDetail.Status,
	            Invoices = _nextProps$arDetail.Invoices,
	            Waive = _nextProps$arDetail.Waive,
	            WaiveAmount = _nextProps$arDetail.WaiveAmount,
	            PenaltyAmount = _nextProps$arDetail.PenaltyAmount,
	            TotalPayment = _nextProps$arDetail.TotalPayment;
	
	        var isAREditable = Status === 'Bounced Check' || Status === 'Void';
	        var totalAmount = 0;
	        if (Invoices) {
	          Invoices.map(function (invoice) {
	            totalAmount += invoice.PreviousBalance;
	          });
	        }
	        this.setState({
	          rows: Invoices || [],
	          waiveShouldDisable: !Waive,
	          waiveAmount: WaiveAmount,
	          penaltyAmount: PenaltyAmount,
	          isAREditable: isAREditable,
	          totalPayment: TotalPayment,
	          totalAmount: totalAmount
	        });
	      }
	      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
	        this.closeCheckAuthorize();
	        if (this.state.action === 'apply') {
	          this.handleFormSubmit();
	        } else if (this.state.action === 'remove') {
	          this.props.deleteAR(this.props.arDetail.Payment_id);
	        } else if (this.state.action === 'bounce') {
	          this.props.bounceCheck(this.props.arDetail.Payment_id);
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var totalPayment = this.state.totalPayment;
	
	      if (totalPayment !== prevState.totalPayment) {
	        this.props.dispatch((0, _reduxForm.change)('editAR', 'TotalPayment', parseFloat(totalPayment).toFixed(2) || 0));
	      }
	    }
	  }, {
	    key: 'getBsStyle',
	    value: function getBsStyle(input, value) {
	      return input === value ? 'success' : 'primary';
	    }
	  }, {
	    key: 'checkAuthorize',
	    value: function checkAuthorize(password) {
	      this.props.checkPassword(password);
	    }
	  }, {
	    key: 'openCheckAuthorize',
	    value: function openCheckAuthorize(action) {
	      this.props.clearCheckPassword();
	      this.setState({ checkAuthorizeOpen: true, action: action });
	    }
	  }, {
	    key: 'closeCheckAuthorize',
	    value: function closeCheckAuthorize() {
	      this.setState({ checkAuthorizeOpen: false });
	    }
	  }, {
	    key: 'calculateWaiveAmount',
	    value: function calculateWaiveAmount() {
	      var discount = parseFloat(this.props.discount) || 0;
	      var totalAmount = parseFloat(this.state.totalAmount) || 0;
	      var finalAmount = (100 - discount) / 100 * totalAmount;
	      finalAmount = finalAmount.toFixed(2) || 0;
	      var totalPayment = parseFloat(this.props.totalPayment) || 0;
	      var waiveAmount = finalAmount - totalPayment;
	      waiveAmount = waiveAmount.toFixed(2);
	      return waiveAmount;
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit() {
	      var formProps = {
	        Customer: this.props.customer_id,
	        Payment_id: this.props.arDetail.Payment_id,
	        TotalPayment: parseFloat(this.props.totalPayment || 0).toFixed(2),
	        PaymentDate: this.props.paymentDate,
	        PenaltyAmount: parseFloat(this.props.penaltyAmount || 0).toFixed(2),
	        Method: this.props.method,
	        CheckNum: this.props.checkNum,
	        Account: this.props.account.value,
	        AccountName: this.props.account.label,
	        // Discount: parseFloat(this.props.discount) || 0,
	        // DiscountedAmount: ((parseFloat(this.state.totalAmount) * parseFloat(this.props.discount)) / 100).toFixed(2) || 0,
	        Note: this.props.note,
	        Waive: this.props.waive,
	        WaiveAmount: parseFloat(this.state.waiveAmount || 0).toFixed(2),
	        TotalAmount: parseFloat(this.state.totalAmount || 0).toFixed(2)
	      };
	      var rows = this.arTable.state.rows;
	
	
	      this.debouncedEditAR(formProps, rows);
	      // console.log(formProps, rows);
	      //TODO show modal ask for staying on the page
	    }
	  }, {
	    key: 'getBillingAddress',
	    value: function getBillingAddress() {
	      var arDetail = this.props.arDetail;
	
	      var Address1 = '';
	      var Address2 = '';
	      if (arDetail && arDetail.Customer_Detail) {
	        Address1 = arDetail.Customer_Detail.Street;
	        Address2 = arDetail.Customer_Detail.City + ', ' + arDetail.Customer_Detail.State + ' ' + arDetail.Customer_Detail.Zip;
	      }
	      return [Address1, Address2];
	    }
	  }, {
	    key: 'getCreditOptions',
	    value: function getCreditOptions() {
	      var creditOptions = [];
	      if (this.props.credits) {
	        this.props.credits.map(function (credit) {
	          //check the field name of credits when backend finish the API
	          creditOptions.push({ value: credit.SalesReturn_id, label: credit.SRNum + ' | ' + credit.FinalPrice });
	        });
	      }
	      return creditOptions;
	    }
	  }, {
	    key: 'checkPermission',
	    value: function checkPermission(permission) {
	      return false;
	    }
	  }, {
	    key: 'handleWaiveCheckboxChange',
	    value: function handleWaiveCheckboxChange(event) {
	      var target = event.target;
	      console.log('handleWaiveCheckboxChange', target);
	
	      if (!target.checked) {
	        this.props.setDefaultOfForm('WaiveAmount', 0.00, 'editAR');
	        this.setState({
	          waiveAmount: 0.00
	        });
	      } else {
	        this.props.setDefaultOfForm('WaiveAmount', this.calculateWaiveAmount(), 'editAR');
	        this.setState({
	          waiveAmount: this.calculateWaiveAmount()
	        });
	      }
	      this.setState({
	        waiveShouldDisable: !target.checked
	      });
	    }
	  }, {
	    key: 'handleWaiveInputChange',
	    value: function handleWaiveInputChange(event) {
	      this.setState({
	        waiveAmount: event.target.value
	      });
	    }
	
	    // handleTotalBalanceChange = (rows) => {
	    //   let totalBalance = 0;
	    //   rows.map(row => {
	    //     totalBalance += parseFloat(row.UnpaidAmount) || 0;
	    //   });
	    //   this.setState({ totalBalance });
	    // }
	
	  }, {
	    key: 'renderCustomers',
	
	
	    // handleDiscountInputChange = (event) => {
	    //   if (event.charCode === 13) {
	    //     const { discount } = this.props;
	    //     const rows = [...this.state.rows];
	    //     rows.map(row => {
	    //       const discountAmount = ((parseFloat(row.PreviousBalance) * parseFloat(discount)) / 100).toFixed(2);
	    //       row.DiscountedAmount = discountAmount || 0;
	    //     });
	    //     this.setState({ rows });
	    //   }
	    // }
	
	    value: function renderCustomers() {
	      var _props = this.props,
	          arDetail = _props.arDetail,
	          arDetailIsLoading = _props.arDetailIsLoading,
	          arDetailError = _props.arDetailError;
	
	      if (!arDetail || arDetailIsLoading) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (arDetailError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'something_unexpected_happened' })
	          )
	        );
	      }
	      var CustomerNum = arDetail.CustomerNum,
	          CustomerName = arDetail.CustomerName,
	          Customer_Detail = arDetail.Customer_Detail;
	
	      var contact = null;
	      var phone = null;
	      var note = '';
	      var billingAddress = ['', ''];
	
	      if (Customer_Detail) {
	        contact = Customer_Detail.FirstName + ' ' + Customer_Detail.LastName;
	        phone = Customer_Detail.Telephone;
	        billingAddress = this.getBillingAddress();
	        note = Customer_Detail.Note;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'mb0' },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-4 inlineLabel' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_no' }),
	              _react2.default.createElement(
	                'span',
	                { style: { color: 'red' } },
	                '*'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 8, className: 'mb-md' },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                value: CustomerNum,
	                disabled: true
	              })
	            ),
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-4 inlineLabel' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 8, className: 'mb-md' },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                value: CustomerName,
	                disabled: true
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-4 inlineLabel' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 8, className: 'mb-md' },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                value: phone,
	                disabled: true
	              })
	            ),
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-4 inlineLabel' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 8, className: 'mb-md' },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                value: note,
	                disabled: true
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'contact' }),
	              ':'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 9 },
	              contact
	            ),
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' }),
	              ':'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 9 },
	              billingAddress[0],
	              _react2.default.createElement('br', null),
	              billingAddress[1]
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderInvoices',
	    value: function renderInvoices() {
	      var _this2 = this;
	
	      if (this.props.invoicesIsLoading && !this.props.invoicesError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.invoicesError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'something_unexpected_happened' })
	          )
	        );
	      }
	      var _state = this.state,
	          rows = _state.rows,
	          isAREditable = _state.isAREditable;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(_arModifiableTable2.default, {
	            ref: function ref(arTable) {
	              _this2.arTable = arTable;
	            },
	            rows: rows,
	            handlePaymentCellChange: this.handlePaymentCellChange,
	            handleTotalBalanceChange: this.handleTotalBalanceChange,
	            editable: !isAREditable
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderCheckNum',
	    value: function renderCheckNum() {
	      return _react2.default.createElement(_reduxForm.Field, { name: 'CheckNum', component: _inputField.InputField });
	    }
	  }, {
	    key: 'renderCredits',
	    value: function renderCredits() {
	      if (this.props.creditsIsLoading && !this.props.creditsError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.creditsError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'something_unexpected_happened' })
	          )
	        );
	      }
	      var creditOptions = this.getCreditOptions(); // Return a JSON in the format of React-Select's options
	      return _react2.default.createElement(_reduxForm.Field, { name: 'Credits', component: _selection.MultiSelection, options: creditOptions });
	    }
	  }, {
	    key: 'renderResponse',
	    value: function renderResponse() {
	      var _props2 = this.props,
	          arEdited = _props2.arEdited,
	          arEditError = _props2.arEditError,
	          arIsEditing = _props2.arIsEditing;
	
	      if (arEdited) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-success' },
	            'Success!'
	          )
	        );
	      } else if (arIsEditing && !arEditError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-info' },
	            '...',
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reading_data' })
	          )
	        );
	      } //else if (arEditError) {
	      //   return (
	      //     <ContentWrapper>
	      //       <div className='alert alert-danger'>
	      //         { arEditError }
	      //       </div>
	      //     </ContentWrapper>
	      //   );
	      // }
	      return _react2.default.createElement(_ContentWrapper2.default, null);
	    }
	  }, {
	    key: 'renderWaiveCheckbox',
	    value: function renderWaiveCheckbox(props) {
	      console.log('renderWaiveCheckbox', props);
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 6 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement('input', _extends({}, props.input, {
	              type: 'checkbox',
	              value: 'waive',
	              checked: props.input.value,
	              onChange: this.handleWaiveCheckboxChange
	            }))
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderARMetaInfo',
	    value: function renderARMetaInfo() {
	      var arDetail = this.props.arDetail;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 2 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ID' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 8 },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                value: arDetail && arDetail.ARNum || '',
	                disabled: true
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 10 },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 3, xsOffset: 1 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'user' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 7 },
	                  _react2.default.createElement(_reactBootstrap.Input, {
	                    type: 'text',
	                    value: arDetail && arDetail.FullName || 'N/A',
	                    disabled: true
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'creation_date' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 7 },
	                  _react2.default.createElement(_reactBootstrap.Input, {
	                    type: 'text',
	                    value: arDetail && arDetail.PostingDate ? (0, _dateFormat.formatDate)(new Date(arDetail.PostingDate)) : 'N/A',
	                    disabled: true
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'modified_date' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 7 },
	                  _react2.default.createElement(_reactBootstrap.Input, {
	                    type: 'text',
	                    value: arDetail && arDetail.ModifyDate ? (0, _dateFormat.formatDate)(new Date(arDetail.ModifyDate)) : 'N/A',
	                    disabled: true
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_date' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 7 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'PaymentDate', component: _datePicker.DatePicker, dropUp: true, maxDate: new Date() })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var createDialogStyle = {
	        width: '550px',
	        height: '300px',
	        marginLeft: '-15%'
	      };
	
	      var _props3 = this.props,
	          pristine = _props3.pristine,
	          method = _props3.method,
	          submitting = _props3.submitting;
	      var _state2 = this.state,
	          waiveShouldDisable = _state2.waiveShouldDisable,
	          isAREditable = _state2.isAREditable,
	          waiveAmount = _state2.waiveAmount,
	          penaltyAmount = _state2.penaltyAmount;
	
	
	      var paymentMethodIsCredit = method === 'Credit' || method && method.value === 'Credit';
	
	      var twoDecimalZero = 0 .toFixed(2);
	      var discount = parseFloat(this.props.discount) || twoDecimalZero;
	      var totalAmount = parseFloat(this.state.totalAmount) || twoDecimalZero;
	      var balance = ((100 - discount) / 100 * totalAmount).toFixed(2) || twoDecimalZero;
	      var totalPayment = parseFloat(this.props.totalPayment) || twoDecimalZero;
	      var finalBalance = (penaltyAmount + (balance - waiveAmount - totalPayment)).toFixed(2) || twoDecimalZero;
	      // finalBalance = finalBalance > 0 ? finalBalance : twoDecimalZero;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'form',
	          { method: 'get', action: '#' },
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_slashsign_ap' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account_receivable' })
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'AR-edit' },
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  type: 'button',
	                  onClick: function onClick() {
	                    _this3.props.router.push('/AR');
	                  }
	                },
	                _react2.default.createElement('em', { className: 'fa fa-close' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { id: 'customers' },
	              this.renderCustomers()
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              null,
	              this.renderInvoices()
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { id: 'check-out-information' },
	              this.renderARMetaInfo(),
	              _react2.default.createElement('div', { className: 'horizontal-divider' }),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'upper-row-positioning' },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'text-nowrap inlineLabel' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_method' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'asteriksReq' },
	                      '*'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(_reduxForm.Field, {
	                    name: 'Method',
	                    className: 'select-menu-drop-up',
	                    component: _selection.Selection,
	                    options: _arapPaymentOptions2.default,
	                    disabled: isAREditable
	                  })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'inlineLabel' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check_number' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  paymentMethodIsCredit && this.renderCredits(),
	                  !paymentMethodIsCredit && this.renderCheckNum()
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 3 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'inlineLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'waive' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 6, smOffset: 1 },
	                      _react2.default.createElement(_reduxForm.Field, {
	                        name: 'WaiveAmount',
	                        component: this.renderInputField,
	                        handleOnChange: this.handleWaiveInputChange,
	                        disabled: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 2 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 4 },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'penalty' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reduxForm.Field, {
	                        name: 'PenaltyAmount',
	                        component: _inputField.InputField,
	                        disabled: isAREditable
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' }),
	                    ' :'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 1 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    balance
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'lower-row-positioning' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1 inlineLabel' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account' }),
	                  _react2.default.createElement(
	                    'span',
	                    { style: { color: 'red' } },
	                    '*'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(_accountDropdown2.default, { className: 'select-menu-drop-up' })
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1 text-nowrap inlineLabel' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_amount' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'asteriksReq' },
	                    '*'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2, className: 'total-payment-field' },
	                  _react2.default.createElement(_reduxForm.Field, {
	                    name: 'TotalPayment',
	                    component: this.renderInputField,
	                    handleOnChange: this.handlePaymentAmountInputChange,
	                    disabled: isAREditable
	                  })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 4 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'inlineLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 8 },
	                      _react2.default.createElement(_reduxForm.Field, {
	                        name: 'Note',
	                        component: _inputField.InputField,
	                        disabled: isAREditable
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_balance' }),
	                  ' :'
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-1' },
	                  finalBalance
	                )
	              ),
	              _react2.default.createElement('div', { className: 'horizontal-divider divider' }),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { id: 'hint' },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 4, className: 'vertical-divider' },
	                  _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    { id: 'ar-apply-button' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'success',
	                        type: 'button',
	                        onClick: function onClick() {
	                          _this3.openCheckAuthorize('apply');
	                        },
	                        disabled: submitting || isAREditable
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-save' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'danger',
	                        type: 'button',
	                        onClick: function onClick() {
	                          _this3.openCheckAuthorize('remove');
	                        },
	                        disabled: submitting || isAREditable
	                      },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'remove' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: '',
	                        onClick: function onClick() {
	                          _this3.openCheckAuthorize('bounce');
	                        },
	                        disabled: submitting || isAREditable
	                      },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bounced_check' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 5 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'authorize-label' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'authorization_required' })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              this.renderResponse()
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogStyle,
	            isVisible: this.state.checkAuthorizeOpen,
	            onCloseClicked: this.closeCheckAuthorize
	          },
	          _react2.default.createElement(_confirmActionModal2.default, {
	            'case': 'confirmPassword',
	            closeC: this.checkAuthorize,
	            checkPasswordFailure: this.props.checkPasswordFailure
	          })
	        )
	      );
	    }
	  }]);
	
	  return EditAR;
	}(_react.Component);
	
	var _default = EditAR;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(EditAR, 'EditAR', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/editAR.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/editAR.jsx');
	}();

	;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _inputField = __webpack_require__(16);
	
	var _cleanDates = __webpack_require__(22);
	
	var _numberWithCommas = __webpack_require__(35);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _genericRadioFilter = __webpack_require__(50);
	
	var _genericRadioFilter2 = _interopRequireDefault(_genericRadioFilter);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	var _GenericDatePicker = __webpack_require__(48);
	
	var _GenericDatePicker2 = _interopRequireDefault(_GenericDatePicker);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isAFG = _root_url.ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afgstage-scm.truckxi.com/api/';
	
	var getBsStyle = function getBsStyle(input, value) {
	  return input === value ? 'success' : 'primary';
	};
	
	var GeneralReport = function (_Component) {
	  _inherits(GeneralReport, _Component);
	
	  _createClass(GeneralReport, null, [{
	    key: 'getQuarter',
	    value: function getQuarter() {
	      return Math.ceil((new Date().getMonth() + 1) / 3);
	    }
	  }]);
	
	  function GeneralReport() {
	    _classCallCheck(this, GeneralReport);
	
	    var _this = _possibleConstructorReturn(this, (GeneralReport.__proto__ || Object.getPrototypeOf(GeneralReport)).call(this));
	
	    _this.getFormattedDate = function () {
	      var _this$state = _this.state,
	          year = _this$state.year,
	          month = _this$state.month,
	          SalesType = _this$state.SalesType,
	          typeRadios = _this$state.typeRadios,
	          state = _this$state.state,
	          quarter = _this$state.quarter,
	          fromDate = _this$state.fromDate,
	          toDate = _this$state.toDate;
	
	      if (typeRadios === 'year') {
	        var FromDate = year + '-01-01';
	        var ToDate = year + '-12-31';
	        var dates = (0, _cleanDates.toFromDates)(-1, FromDate, ToDate);
	        return {
	          fromDate: dates.fromDate, toDate: dates.toDate
	        };
	      }
	
	      if (typeRadios === 'quarter') {
	        var fromDate2 = (0, _moment2.default)([year, (quarter - 1) * 3]);
	        var toDate2 = (0, _moment2.default)([year, quarter * 3 - 1]).endOf('month');
	        fromDate2 = fromDate2.toISOString();
	        toDate2 = toDate2.toISOString();
	        return {
	          fromDate: fromDate2, toDate: toDate2
	        };
	      }
	
	      if (typeRadios === 'month') {
	        var _fromDate = (0, _moment2.default)([year, month - 1]);
	        var _toDate = (0, _moment2.default)(_fromDate).endOf('month');
	        _fromDate = _fromDate.toISOString();
	        _toDate = _toDate.toISOString();
	        return {
	          fromDate: _fromDate, toDate: _toDate
	        };
	      }
	
	      if (typeRadios === 'range') {
	        var _fromDate2 = fromDate.toISOString();
	        var _toDate2 = toDate.toISOString();
	        return {
	          fromDate: _fromDate2,
	          toDate: _toDate2
	        };
	      }
	    };
	
	    _this.handleSearchButtonClick = function () {
	      var typeRadios = _this.state.typeRadios;
	
	      if (typeRadios === "month") {
	        _this.formatFetchMonth();
	        return;
	      }
	      if (typeRadios === "quarter") {
	        _this.formatFetchQuarter();
	        return;
	      }
	      if (typeRadios === "year") {
	        _this.formatFetchYear();
	        return;
	      }
	      if (typeRadios === "range") {
	        _this.formatFetchRange();
	        return;
	      }
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton,
	      reportLines: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      // GrandPurchase : 0,
	      GrandSale: 0,
	      GrandAR: 0,
	      GrandAP: 0,
	      GrandTax: 0,
	      GrandVoid: 0,
	      fromDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
	      toDate: new Date(),
	      SalesType: 'all',
	      typeRadios: 'month',
	      year: new Date().getFullYear(),
	      month: new Date().getMonth() + 1,
	      quarter: GeneralReport.getQuarter(),
	      state: ''
	    };
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.fetchGeneralReport = _this.fetchGeneralReport.bind(_this);
	    _this.formatFetchRange = _this.formatFetchRange.bind(_this);
	    _this.formatFetchYear = _this.formatFetchYear.bind(_this);
	    _this.formatFetchMonth = _this.formatFetchMonth.bind(_this);
	    _this.formatFetchQuarter = _this.formatFetchQuarter.bind(_this);
	    _this.formatFetchState = _this.formatFetchState.bind(_this);
	    _this.handleStatusFilterChange = _this.handleStatusFilterChange.bind(_this);
	    _this.handleDateFilterChange = _this.handleDateFilterChange.bind(_this);
	    _this.setToDate = _this.setToDate.bind(_this);
	    _this.setFromDate = _this.setFromDate.bind(_this);
	    _this.setYearSelected = _this.setYearSelected.bind(_this);
	    _this.setMonthSelected = _this.setMonthSelected.bind(_this);
	    _this.setStateSelected = _this.setStateSelected.bind(_this);
	    _this.setQuarterSelected = _this.setQuarterSelected.bind(_this);
	    return _this;
	  }
	
	  _createClass(GeneralReport, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // this.formatFetchMonth();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      window.addEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.generalReport && nextProps.generalReport !== this.props.generalReport) {
	        var reportLines = _extends({}, this.state.reportLines, { rows: nextProps.generalReport.reportLines });
	        var _nextProps$generalRep = nextProps.generalReport,
	            GrandPurchase = _nextProps$generalRep.GrandPurchase,
	            GrandSale = _nextProps$generalRep.GrandSale,
	            GrandAR = _nextProps$generalRep.GrandAR,
	            GrandAP = _nextProps$generalRep.GrandAP,
	            GrandTax = _nextProps$generalRep.GrandTax,
	            GrandVoid = _nextProps$generalRep.GrandVoid;
	
	        this.setState({
	          reportLines: reportLines, GrandPurchase: GrandPurchase, GrandSale: GrandSale, GrandAR: GrandAR, GrandAP: GrandAP, GrandTax: GrandTax, GrandVoid: GrandVoid
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'setToDate',
	    value: function setToDate(e) {
	      if (e < this.state.fromDate) {
	        return;
	      }
	      this.setState({ toDate: e });
	    }
	  }, {
	    key: 'setFromDate',
	    value: function setFromDate(e) {
	      if (e > this.state.toDate) {
	        return;
	      }
	      this.setState({ fromDate: e });
	    }
	  }, {
	    key: 'setYearSelected',
	    value: function setYearSelected(e) {
	      // this.setState({ year: e.value }, this.formatFetchYear);
	      this.setState({ year: e.value });
	    }
	  }, {
	    key: 'setMonthSelected',
	    value: function setMonthSelected(e) {
	      // this.setState({ month: e.value }, this.formatFetchMonth);
	      this.setState({ month: e.value });
	    }
	  }, {
	    key: 'setStateSelected',
	    value: function setStateSelected(e) {
	      // this.setState({ state: e.value }, this.formatFetchState);
	      this.setState({ state: e.value });
	    }
	  }, {
	    key: 'setQuarterSelected',
	    value: function setQuarterSelected(e) {
	      // this.setState({ quarter: e.value }, this.formatFetchQuarter);
	      this.setState({ quarter: e.value });
	    }
	  }, {
	    key: 'getYearOptions',
	    value: function getYearOptions() {
	      var yearOptions = [];
	      var year = new Date().getFullYear() + 1;
	      while (year > 2017) {
	        year -= 1;
	        yearOptions.push({ value: year, label: year });
	      }
	      return yearOptions;
	    }
	  }, {
	    key: 'getMonthOptions',
	    value: function getMonthOptions() {
	      var year = this.state.year;
	
	      var dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	      var monthOptions = [];
	      var currentyear = new Date().getFullYear();
	      var month = 0;
	      if (year) {
	        if (year < currentyear) {
	          month = 12;
	        } else {
	          month = new Date().getMonth() + 1;
	        }
	        for (var i = 1; i < month + 1; i += 1) {
	          monthOptions.push({ value: i, label: dateMap[i - 1] });
	        }
	      }
	      return monthOptions;
	    }
	  }, {
	    key: 'getQuarterOptions',
	    value: function getQuarterOptions() {
	      var year = this.state.year;
	
	      var quarterOptions = [];
	      var currentyear = new Date().getFullYear();
	      var quarter = 0;
	      if (year) {
	        if (year < currentyear) {
	          quarter = 4;
	        } else {
	          var month = new Date().getMonth() + 1;
	          quarter = Math.ceil(month / 3);
	        }
	      }
	      for (var i = 1; i < quarter + 1; i += 1) {
	        quarterOptions.push({ value: i, label: i });
	      }
	      return quarterOptions;
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton });
	    }
	  }, {
	    key: 'formatFetchRange',
	    value: function formatFetchRange() {
	      var _state = this.state,
	          SalesType = _state.SalesType,
	          typeRadios = _state.typeRadios,
	          fromDate = _state.fromDate,
	          toDate = _state.toDate,
	          state = _state.state;
	
	      this.setState({
	        fromDate: fromDate, toDate: toDate, SalesType: SalesType, typeRadios: typeRadios, state: state
	      }, this.fetchGeneralReport);
	    }
	  }, {
	    key: 'formatFetchYear',
	    value: function formatFetchYear() {
	      var _state2 = this.state,
	          SalesType = _state2.SalesType,
	          typeRadios = _state2.typeRadios,
	          year = _state2.year,
	          state = _state2.state;
	
	      var FromDate = year + '-01-01';
	      var ToDate = year + '-12-31';
	      var dates = (0, _cleanDates.toFromDates)(-1, FromDate, ToDate);
	      this.setState({
	        fromDate: dates.fromDate, toDate: dates.toDate, SalesType: SalesType, typeRadios: typeRadios, state: state
	      }, this.fetchGeneralReport);
	    }
	  }, {
	    key: 'formatFetchMonth',
	    value: function formatFetchMonth() {
	      var _state3 = this.state,
	          year = _state3.year,
	          month = _state3.month,
	          SalesType = _state3.SalesType,
	          typeRadios = _state3.typeRadios,
	          state = _state3.state;
	
	      var FromDate = (0, _moment2.default)([year, month - 1]);
	      var ToDate = (0, _moment2.default)(FromDate).endOf('month');
	      FromDate = FromDate.toISOString();
	      ToDate = ToDate.toISOString();
	      this.setState({
	        fromDate: FromDate, toDate: ToDate, SalesType: SalesType, typeRadios: typeRadios, state: state
	      }, this.fetchGeneralReport);
	    }
	  }, {
	    key: 'formatFetchQuarter',
	    value: function formatFetchQuarter() {
	      var _state4 = this.state,
	          year = _state4.year,
	          quarter = _state4.quarter,
	          SalesType = _state4.SalesType,
	          typeRadios = _state4.typeRadios,
	          state = _state4.state;
	
	      var FromDate = (0, _moment2.default)([year, (quarter - 1) * 3]);
	      var ToDate = (0, _moment2.default)([year, quarter * 3 - 1]).endOf('month');
	      FromDate = FromDate.toISOString();
	      ToDate = ToDate.toISOString();
	      this.setState({
	        fromDate: FromDate, toDate: ToDate, SalesType: SalesType, typeRadios: typeRadios, state: state
	      }, this.fetchGeneralReport);
	    }
	  }, {
	    key: 'formatFetchState',
	    value: function formatFetchState() {
	      var _state5 = this.state,
	          year = _state5.year,
	          month = _state5.month,
	          quarter = _state5.quarter,
	          SalesType = _state5.SalesType,
	          typeRadios = _state5.typeRadios,
	          state = _state5.state;
	
	      this.setState({
	        SalesType: SalesType, typeRadios: typeRadios, state: state
	      }, this.fetchGeneralReport);
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      var formattedDate = '';
	      if (date.getMonth() + 1 < 10) {
	        formattedDate = '0' + (date.getMonth() + 1) + '/';
	      } else {
	        formattedDate = date.getMonth() + 1 + '/';
	      }
	      if (date.getDate() < 10) {
	        formattedDate += '0' + date.getDate() + '/';
	      } else {
	        formattedDate += date.getDate() + '/';
	      }
	      formattedDate += date.getFullYear();
	      return formattedDate;
	    }
	  }, {
	    key: 'fetchGeneralReport',
	    value: function fetchGeneralReport() {
	      var typeRadios = this.state.typeRadios;
	
	      var typeRadios2 = '';
	      if (typeRadios === 'range') {
	        typeRadios2 = 'month';
	      } else {
	        typeRadios2 = typeRadios;
	      }
	      this.props.fetchGeneralReport('show', this.state.SalesType, typeRadios2, this.state.fromDate, this.state.toDate, this.state.state);
	    }
	  }, {
	    key: 'handleStatusFilterChange',
	    value: function handleStatusFilterChange(status) {
	      // old version fetch reports on filter buttons click
	      // const { typeRadios } = this.state;
	      // if (typeRadios === 'year') {
	      //   this.setState({ SalesType: status }, this.formatFetchYear);
	      // } else if (typeRadios === 'month') {
	      //   this.setState({ SalesType: status }, this.formatFetchMonth);
	      // } else {
	      //   this.setState({ SalesType: status }, this.formatFetchQuarter);
	      // }
	
	      // preserve the filters and fetch reports with preserved filter when search button is clicked
	      this.setState({ SalesType: status });
	    }
	  }, {
	    key: 'handleDateFilterChange',
	    value: function handleDateFilterChange(type) {
	      // old version fetch reports on filter buttons click
	      // if (type === 'year') {
	      //   this.setState({ typeRadios: type, year: new Date().getFullYear() }, this.formatFetchYear);
	      // } else if (type === 'month') {
	      //   this.setState({ typeRadios: type, year: new Date().getFullYear(), month: new Date().getMonth() + 1 }, this.formatFetchMonth);
	      // } else {
	      //   this.setState({ typeRadios: type, year: new Date().getFullYear(), quarter: GeneralReport.getQuarter() }, this.formatFetchQuarter);
	      // }
	
	      var _state6 = this.state,
	          fromDate = _state6.fromDate,
	          toDate = _state6.toDate;
	
	
	      if (type === 'year') {
	        this.setState({ typeRadios: type, year: new Date().getFullYear() });
	      } else if (type === 'month') {
	        this.setState({ typeRadios: type, year: new Date().getFullYear(), month: new Date().getMonth() + 1 });
	      } else if (type === 'range') {
	        this.setState({ typeRadios: type, fromDate: fromDate, toDate: toDate });
	      } else {
	        this.setState({ typeRadios: type, year: new Date().getFullYear(), quarter: GeneralReport.getQuarter() });
	      }
	    }
	  }, {
	    key: 'renderDateSelector',
	    value: function renderDateSelector() {
	      var _this2 = this;
	
	      var yearOptions = this.getYearOptions();
	      var date = new Date();
	      var stateOptions = [{ value: '', label: 'All' }, { value: 'ca', label: 'CA' }, { value: 'others', label: 'Others' }];
	
	      if (this.state.typeRadios === 'range') {
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 6 },
	            _react2.default.createElement(
	              'div',
	              { className: 'report-table-filters', id: 'general-report-date-selector' },
	              _react2.default.createElement(
	                'label',
	                { className: 'from-label' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'from' })
	              ),
	              (0, _GenericDatePicker2.default)({
	                setDate: this.setFromDate,
	                selectedDate: this.state.fromDate,
	                onChange: function onChange(e) {
	                  _this2.setFromDate(e);
	                }
	              }),
	              _react2.default.createElement(
	                'label',
	                { className: 'to-label' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'to' })
	              ),
	              (0, _GenericDatePicker2.default)({
	                setDate: this.setToDate,
	                selectedDate: this.state.toDate,
	                onChange: function onChange(e) {
	                  _this2.setToDate(e);
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(
	              _reactBootstrap.Button
	              // className="search-button"
	              ,
	              {
	                bsStyle: 'primary',
	                onClick: function onClick() {
	                  _this2.handleSearchButtonClick();
	                }
	              },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'search' })
	            )
	          )
	        );
	      } else if (this.state.typeRadios === 'month') {
	        var monthOptions = this.getMonthOptions();
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 6 },
	            _react2.default.createElement(
	              'div',
	              { className: 'report-table-filters', id: 'general-report-date-selector' },
	              (0, _GenericSelection2.default)({
	                translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'year' }),
	                options: yearOptions,
	                value: this.state.year,
	                setSelected: function setSelected(e) {
	                  _this2.setState({ year: e.value });
	                }
	              }),
	              (0, _GenericSelection2.default)({
	                translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'month' }),
	                options: monthOptions,
	                value: this.state.month,
	                setSelected: this.setMonthSelected
	              }),
	              isAFG && (0, _GenericSelection2.default)({
	                translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'state' }),
	                options: stateOptions,
	                value: this.state.state,
	                setSelected: this.setStateSelected
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'primary',
	                onClick: function onClick() {
	                  _this2.handleSearchButtonClick();
	                }
	              },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'search' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 1 },
	            _react2.default.createElement(
	              'h3',
	              { className: 'filter-title' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: this.formatDate(date) })
	            )
	          )
	        );
	      } else if (this.state.typeRadios === 'quarter') {
	        var quarterOptions = this.getQuarterOptions();
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 6 },
	            _react2.default.createElement(
	              'div',
	              { className: 'report-table-filters', id: 'general-report-date-selector' },
	              (0, _GenericSelection2.default)({
	                translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'year' }),
	                options: yearOptions,
	                value: this.state.year,
	                setSelected: function setSelected(e) {
	                  _this2.setState({ year: e.value });
	                }
	              }),
	              (0, _GenericSelection2.default)({
	                translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quarter' }),
	                options: quarterOptions,
	                value: this.state.quarter,
	                setSelected: this.setQuarterSelected
	              }),
	              isAFG && (0, _GenericSelection2.default)({
	                translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'state' }),
	                options: stateOptions,
	                value: this.state.state,
	                setSelected: this.setStateSelected
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'primary',
	                onClick: function onClick() {
	                  _this2.handleSearchButtonClick();
	                }
	              },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'search' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 1 },
	            _react2.default.createElement(
	              'h3',
	              { className: 'filter-title' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: this.formatDate(date) })
	            )
	          )
	        );
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 12 },
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 6 },
	          _react2.default.createElement(
	            'div',
	            { className: 'report-table-filters', id: 'general-report-date-selector' },
	            (0, _GenericSelection2.default)({
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'year' }),
	              options: yearOptions,
	              value: this.state.year,
	              setSelected: this.setYearSelected
	            }),
	            isAFG && (0, _GenericSelection2.default)({
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'state' }),
	              options: stateOptions,
	              value: this.state.state,
	              setSelected: this.setStateSelected
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 4 },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'primary',
	              onClick: function onClick() {
	                _this2.handleSearchButtonClick();
	              }
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'search' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 1 },
	          _react2.default.createElement(
	            'h3',
	            { className: 'filter-title' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: this.formatDate(date) })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this3 = this;
	
	      if (this.props.generalReportIsLoading && !this.props.generalReportError) {
	        return _react2.default.createElement(
	          'div',
	          { id: 'spinner' },
	          _react2.default.createElement(_spinner2.default, null)
	        );
	      } else if (this.props.generalReportError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.generalReportError)
	          )
	        );
	      } else {
	        // Parameters of the react-data-grid
	
	        var tableHeight = window.innerHeight < 930 ? 470 : 470;
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.reportLines);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var lines = Object.assign({}, _this3.state.reportLines, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this3.setState({ reportLines: lines });
	        };
	
	        //Custom Formatter component
	
	        var DateFormatter = _react2.default.createClass({
	          displayName: 'DateFormatter',
	          render: function render() {
	            if (this.props.value) {
	              var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	              var date = new Date(this.props.value);
	              var index = dateMap.indexOf(date.toString().slice(4, 3));
	              var localDate = index + date.toString().slice(8, 6);
	              return _react2.default.createElement(
	                'span',
	                null,
	                date.toString().slice(4, 15)
	              );;
	            } else return _react2.default.createElement(
	              'span',
	              { className: 'label label-danger' },
	              '-'
	            );
	          }
	        });
	
	        // Formatter for Percentages
	        var PercentFormat = _react2.default.createClass({
	          displayName: 'PercentFormat',
	          render: function render() {
	            var value = this.props.value;
	
	            return _react2.default.createElement(
	              'span',
	              null,
	              value !== null && !isNaN(value) && value + '%'
	            );
	          }
	        });
	
	        // Column difinition
	
	        var columns = [{
	          key: 'month',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'M' }),
	          resizable: true,
	          sortable: true,
	          width: 40
	        }, {
	          key: 'day',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'D' }),
	          resizable: true,
	          sortable: true,
	          width: 40
	        }, {
	          key: 'total_purchase',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase' }),
	          resizable: true,
	          sortable: true,
	          width: 110,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'total_sales',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sale' }),
	          resizable: true,
	          sortable: true,
	          width: 110,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'total_ar',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'A/R' }),
	          resizable: true,
	          sortable: true,
	          width: 110,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'total_ap',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_ap' }),
	          resizable: true,
	          sortable: true,
	          width: 110,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'total_tax',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	          resizable: true,
	          sortable: true,
	          width: 110,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'total_profit',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'profit' }),
	          resizable: true,
	          sortable: true,
	          width: 110,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'total_margin',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'margin' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          formatter: PercentFormat
	        }, {
	          key: 'total_void',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bounce' }),
	          resizable: true,
	          sortable: true,
	          width: 110,
	          formatter: _cashFormatter2.default
	        }];
	
	        //React Table Purchase Order Full Table
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { className: 'react-table-ar-ap-general-report', id: 'GeneralReport-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                enableCellSelect: true,
	                onGridSort: handleGridSort,
	                columns: columns,
	                rowHeight: 25,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                minHeight: tableHeight
	              })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state7 = this.state,
	          SalesType = _state7.SalesType,
	          typeRadios = _state7.typeRadios,
	          state = _state7.state;
	
	      var _getFormattedDate = this.getFormattedDate(),
	          fromDate = _getFormattedDate.fromDate,
	          toDate = _getFormattedDate.toDate;
	
	      var typeRadios2 = typeRadios;
	      if (typeRadios === 'range') {
	        typeRadios2 = 'month';
	      }
	      var params = 'type=' + typeRadios2 + '&start_date=' + fromDate + '&end_date=' + toDate;
	      if (isAFG) {
	        params = 'type=' + typeRadios2 + '&start_date=' + fromDate + '&end_date=' + toDate + '&state=' + state;
	      }
	      var printUrl = _root_url.ROOT_URL + 'v1/ar/report/print/' + (SalesType || 'all') + '/?' + params + '&Bearer=' + localStorage.getItem('token');
	      var excelUrl = _root_url.ROOT_URL + 'v1/ar/report/excel/' + (SalesType || 'all') + '/?' + params + '&Bearer=' + localStorage.getItem('token');
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_slashsign_ap' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_report' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsStyle: 'primary', href: printUrl },
	            _react2.default.createElement('em', { className: 'fa fa-print' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsStyle: 'success', href: excelUrl },
	            _react2.default.createElement('em', { className: 'fa fa-download' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'general-report' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { id: 'date-range-picker', className: 'form-horizontal' },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 1 },
	                    _react2.default.createElement(
	                      'h3',
	                      { className: 'text-nowrap' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_type' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'colon' },
	                        ':'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 10 },
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'statusFilterRadios' },
	                      (0, _genericRadioFilter2.default)({
	                        content: [{
	                          option: 'all',
	                          id: 'all-radio-filter',
	                          name: 'statusFilterRadios',
	                          labelName: 'all'
	                        }, {
	                          option: 'pos',
	                          id: 'pos-radio-filter',
	                          name: 'statusFilterRadios',
	                          labelName: 'pos'
	                        }, {
	                          option: 'si',
	                          id: 'salesOrder-radio-filter',
	                          name: 'statusFilterRadios',
	                          labelName: 'sales_order'
	                        }, {
	                          option: 'mso',
	                          id: 'mobileSalesOrder-radio-filter',
	                          name: 'statusFilterRadios',
	                          labelName: 'MSO'
	                        }],
	                        value: this.state.SalesType,
	                        handleOnClick: this.handleStatusFilterChange,
	                        type: 'buttons'
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 1 },
	                    _react2.default.createElement(
	                      'h3',
	                      { className: 'text-nowrap' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'time_range' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'colon' },
	                        ':'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 6 },
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'statusFilterRadios' },
	                      (0, _genericRadioFilter2.default)({
	                        content: [{
	                          option: 'year',
	                          id: 'year-radio-filter',
	                          name: 'dateFilterRadios',
	                          labelName: 'year'
	                        }, {
	                          option: 'quarter',
	                          id: 'quarter-radio-filter',
	                          name: 'dateFilterRadios',
	                          labelName: 'quarter'
	                        }, {
	                          option: 'month',
	                          id: 'month-radio-filter',
	                          name: 'dateFilterRadios',
	                          labelName: 'month'
	                        }, {
	                          option: 'range',
	                          id: 'dateRange-radio-filter',
	                          name: 'dateFilterRadios',
	                          labelName: 'date_range'
	                        }],
	                        value: this.state.typeRadios,
	                        handleOnClick: this.handleDateFilterChange,
	                        type: 'buttons'
	                      })
	                    )
	                  ),
	                  this.renderDateSelector()
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 12 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { className: 'position-relative mb0', id: 'table-collapse-fix' },
	                    this.renderTable()
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 12 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { className: 'position-relative table-collapse-fix mb0' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-6 text-nowrap' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_purchase' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'dollar-sign' },
	                          ' $$'
	                        ),
	                        ':\xA0'
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 6 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'GrandPurchase', component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.GrandPurchase) || 0 })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-6 text-nowrap' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_sales_invoices' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'dollar-sign' },
	                          ' $$'
	                        ),
	                        ':\xA0'
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 6 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'GrandSale', component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.GrandSale) || 0 })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-6 text-nowrap' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_AR' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'dollar-sign' },
	                          ' $$'
	                        ),
	                        ':\xA0'
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 6 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'GrandAR', component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.GrandAR) || 0 })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-6 text-nowrap' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_AP' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'dollar-sign' },
	                          ' $$'
	                        ),
	                        ':\xA0'
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 6 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'GrandAP', component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.GrandAP) || 0 })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-6 text-nowrap' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_tax' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'dollar-sign' },
	                          ' $$'
	                        ),
	                        ':\xA0'
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 6 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'GrandTax', component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.GrandTax) || 0 })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-6 text-nowrap' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_bounce' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'dollar-sign' },
	                          ' $$'
	                        ),
	                        ':\xA0'
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 6 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'GrandVoid', component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.GrandVoid) || 0 })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	      //---------------
	      // End HTML: Purchase Order List
	      //---------------
	
	      ;
	    }
	  }]);
	
	  return GeneralReport;
	}(_react.Component);
	
	var _default = GeneralReport;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isAFG, 'isAFG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/generalReport.jsx');
	
	  __REACT_HOT_LOADER__.register(getBsStyle, 'getBsStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/generalReport.jsx');
	
	  __REACT_HOT_LOADER__.register(GeneralReport, 'GeneralReport', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/generalReport.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/generalReport.jsx');
	}();

	;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _datePicker = __webpack_require__(27);
	
	var _selection = __webpack_require__(21);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _RowLabelField = __webpack_require__(114);
	
	var _RowLabelField2 = _interopRequireDefault(_RowLabelField);
	
	var _constants = __webpack_require__(11);
	
	var _cleanDates = __webpack_require__(22);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _numberWithCommas = __webpack_require__(35);
	
	var _genericRadioFilter = __webpack_require__(50);
	
	var _genericRadioFilter2 = _interopRequireDefault(_genericRadioFilter);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	var _GenericDatePicker = __webpack_require__(48);
	
	var _GenericDatePicker2 = _interopRequireDefault(_GenericDatePicker);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getBsStyle = function getBsStyle(input, value) {
	  return input === value ? 'success' : 'primary';
	};
	
	var MobileCustomerStatement = function (_Component) {
	  _inherits(MobileCustomerStatement, _Component);
	
	  _createClass(MobileCustomerStatement, null, [{
	    key: 'getQuarter',
	    value: function getQuarter() {
	      return Math.ceil((new Date().getMonth() + 1) / 3);
	    }
	  }]);
	
	  function MobileCustomerStatement() {
	    _classCallCheck(this, MobileCustomerStatement);
	
	    var _this = _possibleConstructorReturn(this, (MobileCustomerStatement.__proto__ || Object.getPrototypeOf(MobileCustomerStatement)).call(this));
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.customersPage,
	      statementLines: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      invoiceAmount: 0,
	      receiveAmount: 0,
	      orderAmount: 0,
	      totalOrders: 0,
	      totalCaptured: 0,
	      totalInvoices: 0,
	      yearChanged: false,
	      // fromDate: new Date('2017-08-18T00:00:00-0700'),
	      fromDate: new Date(),
	      toDate: new Date(),
	      typeRadios: 'range',
	      year: new Date().getFullYear(),
	      month: new Date().getMonth() + 1,
	      quarter: MobileCustomerStatement.getQuarter()
	    };
	
	    _this.setToDate = _this.setToDate.bind(_this);
	    _this.setFromDate = _this.setFromDate.bind(_this);
	    _this.formatFetchYear = _this.formatFetchYear.bind(_this);
	    _this.formatFetchMonth = _this.formatFetchMonth.bind(_this);
	    _this.formatFetchQuarter = _this.formatFetchQuarter.bind(_this);
	    _this.handleDateFilterChange = _this.handleDateFilterChange.bind(_this);
	    _this.setYearSelected = _this.setYearSelected.bind(_this);
	    _this.setMonthSelected = _this.setMonthSelected.bind(_this);
	    _this.setQuarterSelected = _this.setQuarterSelected.bind(_this);
	    return _this;
	  }
	
	  _createClass(MobileCustomerStatement, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // this.props.setDefaultOfForm('typeRadios', 'range', 'mobileCustomerStatement');
	      // this.props.setDefaultOfForm('FromDate', new Date('2017-08-18T00:00:00-0700'), 'mobileCustomerStatement');
	      // this.props.setDefaultOfForm('ToDate', new Date(), 'mobileCustomerStatement');
	      var date = new Date();
	      this.state.fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
	      this.state.toDate = new Date(date.getFullYear(), date.getMonth(), this.daysInMonth(date.getMonth() + 1, date.getFullYear()));
	      this.fetchCustomerStatement();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          mobileCustomerStatement = _props.mobileCustomerStatement,
	          typeRadios = _props.typeRadios;
	
	
	      if (mobileCustomerStatement !== nextProps.mobileCustomerStatement) {
	        this.setState(_extends({}, nextProps.mobileCustomerStatement, {
	          statementLines: {
	            rows: nextProps.mobileCustomerStatement.rows
	          }
	        }));
	      }
	
	      if (typeRadios !== nextProps.typeRadios) {
	        this.props.resetMobileCustomerStatement();
	        this.resetDates();
	      }
	    }
	  }, {
	    key: 'setYearSelected',
	    value: function setYearSelected(e) {
	      this.setState({ year: e.value }, this.formatFetchYear);
	    }
	  }, {
	    key: 'setMonthSelected',
	    value: function setMonthSelected(e) {
	      this.setState({ month: e.value }, this.formatFetchMonth);
	    }
	  }, {
	    key: 'setQuarterSelected',
	    value: function setQuarterSelected(e) {
	      this.setState({ quarter: e.value }, this.formatFetchQuarter);
	    }
	  }, {
	    key: 'setToDate',
	    value: function setToDate(e) {
	      var _this2 = this;
	
	      if (e < this.state.fromDate) {
	        return;
	      }
	      this.setState({ toDate: e }, function () {
	        _this2.fetchCustomerStatement();
	      });
	    }
	  }, {
	    key: 'setFromDate',
	    value: function setFromDate(e) {
	      var _this3 = this;
	
	      if (e > this.state.toDate) {
	        return;
	      }
	      this.setState({ fromDate: e }, function () {
	        _this3.fetchCustomerStatement();
	      });
	    }
	  }, {
	    key: 'getYearOptions',
	    value: function getYearOptions() {
	      var yearOptions = [];
	      var year = new Date().getFullYear() + 1;
	      while (year > 2017) {
	        year -= 1;
	        yearOptions.push({ value: year, label: year });
	      }
	      return yearOptions;
	    }
	  }, {
	    key: 'getMonthOptions',
	    value: function getMonthOptions() {
	      var year = this.state.year;
	
	      var dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	      var monthOptions = [];
	      var currentyear = new Date().getFullYear();
	      var month = 0;
	      if (year) {
	        if (year < currentyear) {
	          month = 12;
	        } else {
	          month = new Date().getMonth() + 1;
	        }
	        for (var i = 1; i < month + 1; i += 1) {
	          monthOptions.push({ value: i, label: dateMap[i - 1] });
	        }
	      }
	      return monthOptions;
	    }
	  }, {
	    key: 'getQuarterOptions',
	    value: function getQuarterOptions() {
	      var year = this.state.year;
	
	      var quarterOptions = [];
	      var currentyear = new Date().getFullYear();
	      var quarter = 0;
	      if (year) {
	        if (year < currentyear) {
	          quarter = 4;
	        } else {
	          var month = new Date().getMonth() + 1;
	          quarter = Math.ceil(month / 3);
	        }
	      }
	      for (var i = 1; i < quarter + 1; i += 1) {
	        quarterOptions.push({ value: i, label: i });
	      }
	      return quarterOptions;
	    }
	  }, {
	    key: 'formatFetchYear',
	    value: function formatFetchYear() {
	      var _state = this.state,
	          SalesType = _state.SalesType,
	          typeRadios = _state.typeRadios,
	          year = _state.year;
	
	      var FromDate = year + '-01-01';
	      var ToDate = year + '-12-31';
	      var dates = (0, _cleanDates.toFromDates)(-1, FromDate, ToDate);
	      this.setState({
	        fromDate: dates.fromDate, toDate: dates.toDate, SalesType: SalesType, typeRadios: typeRadios
	      }, this.fetchCustomerStatement);
	    }
	  }, {
	    key: 'formatFetchMonth',
	    value: function formatFetchMonth() {
	      var _state2 = this.state,
	          year = _state2.year,
	          month = _state2.month,
	          SalesType = _state2.SalesType,
	          typeRadios = _state2.typeRadios;
	
	      var FromDate = (0, _moment2.default)([year, month - 1]);
	      var ToDate = (0, _moment2.default)(FromDate).endOf('month');
	      FromDate = FromDate.toISOString();
	      ToDate = ToDate.toISOString();
	      this.setState({
	        fromDate: FromDate, toDate: ToDate, SalesType: SalesType, typeRadios: typeRadios
	      }, this.fetchCustomerStatement);
	    }
	  }, {
	    key: 'formatFetchQuarter',
	    value: function formatFetchQuarter() {
	      var _state3 = this.state,
	          year = _state3.year,
	          quarter = _state3.quarter,
	          SalesType = _state3.SalesType,
	          typeRadios = _state3.typeRadios;
	
	      var FromDate = (0, _moment2.default)([year, (quarter - 1) * 3]);
	      var ToDate = (0, _moment2.default)([year, quarter * 3 - 1]).endOf('month');
	      FromDate = FromDate.toISOString();
	      ToDate = ToDate.toISOString();
	      this.setState({
	        fromDate: FromDate, toDate: ToDate, SalesType: SalesType, typeRadios: typeRadios
	      }, this.fetchCustomerStatement);
	    }
	  }, {
	    key: 'daysInMonth',
	    value: function daysInMonth(month, year) {
	      return new Date(year, month, 0).getDate();
	    }
	  }, {
	    key: 'handleDateFilterChange',
	    value: function handleDateFilterChange(type) {
	      var date = new Date();
	      if (type === 'year') {
	        this.setState({ typeRadios: type, year: new Date().getFullYear() }, this.formatFetchYear);
	      } else if (type === 'month') {
	        this.setState({ typeRadios: type, year: new Date().getFullYear(), month: new Date().getMonth() + 1 }, this.formatFetchMonth);
	      } else if (type === 'quarter') {
	        this.setState({ typeRadios: type, year: new Date().getFullYear(), quarter: MobileCustomerStatement.getQuarter() }, this.formatFetchQuarter);
	      } else if (type === 'range' && type !== this.state.typeRadios) {
	        this.setState({ typeRadios: type, fromDate: new Date(date.getFullYear(), date.getMonth(), 1), toDate: new Date(date.getFullYear(), date.getMonth(), this.daysInMonth(date.getMonth() + 1, date.getFullYear())) }, this.fetchCustomerStatement);
	      }
	    }
	
	    // handleSelectionOnChange = (event) => {
	    //   if (event) {
	    //     const data = (() => {
	    //       const { Year, Quarter, Month, FromDate, ToDate, typeRadios } = this.props;
	    //       return { Year, Quarter, Month, FromDate, ToDate, typeRadios };
	    //     })();
	    //     const { fromDate, toDate } = getFromToDatesWithFilter({ ...data, [event.name]: event.value });
	    //     this.props.fetchMobileCustomerStatement({ fromDate, toDate }, typeRadios);
	    //   }
	    // }
	
	  }, {
	    key: 'fetchCustomerStatement',
	    value: function fetchCustomerStatement() {
	      var _state4 = this.state,
	          fromDate = _state4.fromDate,
	          toDate = _state4.toDate,
	          typeRadios = _state4.typeRadios;
	      // const { fromDate, toDate } = getFromToDatesWithFilter({
	      //   Year, Month, Quarter, FromDate, ToDate,
	      // });
	
	      this.props.fetchMobileCustomerStatement({ fromDate: fromDate, toDate: toDate }, typeRadios);
	    }
	  }, {
	    key: 'resetDates',
	    value: function resetDates() {
	      this.props.setValue('mobileCustomerStatement', 'Year', '');
	      this.props.setValue('mobileCustomerStatement', 'Month', '');
	      this.props.setValue('mobileCustomerStatement', 'Quarter', '');
	    }
	  }, {
	    key: 'renderDateSelector',
	    value: function renderDateSelector() {
	      var _this4 = this;
	
	      var yearOptions = this.getYearOptions();
	      if (this.state.typeRadios === 'range') {
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { className: 'report-table-filters', id: 'mobile-customer-statement-date-selector' },
	            _react2.default.createElement(
	              'label',
	              { className: 'from-label' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'from' })
	            ),
	            (0, _GenericDatePicker2.default)({
	              setDate: this.setFromDate,
	              selectedDate: this.state.fromDate
	            }),
	            _react2.default.createElement(
	              'label',
	              { className: 'to-label' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'to' })
	            ),
	            (0, _GenericDatePicker2.default)({
	              setDate: this.setToDate,
	              selectedDate: this.state.toDate
	            })
	          )
	        );
	      } else if (this.state.typeRadios === 'month') {
	        var monthOptions = this.getMonthOptions();
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { className: 'report-table-filters', id: 'mobile-customer-statement-date-selector' },
	            (0, _GenericSelection2.default)({
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'year' }),
	              options: yearOptions,
	              value: this.state.year,
	              setSelected: function setSelected(e) {
	                _this4.setState({ year: e.value });
	              }
	            }),
	            (0, _GenericSelection2.default)({
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'month' }),
	              options: monthOptions,
	              value: this.state.month,
	              setSelected: this.setMonthSelected
	            })
	          )
	        );
	      } else if (this.state.typeRadios === 'quarter') {
	        var quarterOptions = this.getQuarterOptions();
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { className: 'report-table-filters', id: 'mobile-customer-statement-date-selector' },
	            (0, _GenericSelection2.default)({
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'year' }),
	              options: yearOptions,
	              value: this.state.year,
	              setSelected: function setSelected(e) {
	                _this4.setState({ year: e.value });
	              }
	            }),
	            (0, _GenericSelection2.default)({
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quarter' }),
	              options: quarterOptions,
	              value: this.state.quarter,
	              setSelected: this.setQuarterSelected
	            })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 12 },
	        _react2.default.createElement(
	          'div',
	          { className: 'report-table-filters', id: 'mobile-customer-statement-date-selector' },
	          (0, _GenericSelection2.default)({
	            translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'year' }),
	            options: yearOptions,
	            value: this.state.year,
	            setSelected: this.setYearSelected
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderAmountDetail',
	    value: function renderAmountDetail() {
	      var _state5 = this.state,
	          invoiceAmount = _state5.invoiceAmount,
	          receiveAmount = _state5.receiveAmount,
	          orderAmount = _state5.orderAmount,
	          totalOrders = _state5.totalOrders,
	          totalInvoices = _state5.totalInvoices,
	          totalCaptured = _state5.totalCaptured;
	
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 3, id: 'mso-amount-details' },
	          _react2.default.createElement(_RowLabelField2.default, {
	            translation: 'total_order_amount:',
	            value: '$' + (0, _numberWithCommas.numberWithCommas)(orderAmount) || 0
	          }),
	          _react2.default.createElement(_RowLabelField2.default, {
	            translation: 'total_invoice_amount:',
	            value: '$' + (0, _numberWithCommas.numberWithCommas)(invoiceAmount) || 0
	          }),
	          _react2.default.createElement(_RowLabelField2.default, {
	            translation: 'total_received_amount:',
	            value: '$' + (0, _numberWithCommas.numberWithCommas)(receiveAmount) || 0
	          })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2, id: 'mso-order-details' },
	          _react2.default.createElement(_RowLabelField2.default, {
	            translation: 'total_orders:',
	            value: '' + totalOrders
	          }),
	          _react2.default.createElement(_RowLabelField2.default, {
	            translation: 'total_invoices:',
	            value: '' + totalInvoices
	          }),
	          _react2.default.createElement(_RowLabelField2.default, {
	            translation: 'total_paid_orders:',
	            value: '' + totalCaptured
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this5 = this;
	
	      var _props$mobileCustomer = this.props.mobileCustomerStatement,
	          mobileCustomerStatementIsLoading = _props$mobileCustomer.mobileCustomerStatementIsLoading,
	          mobileCustomerStatementError = _props$mobileCustomer.mobileCustomerStatementError;
	      var typeRadios = this.state.typeRadios;
	
	      if (mobileCustomerStatementIsLoading && !mobileCustomerStatementError) {
	        return _react2.default.createElement(
	          'div',
	          { id: 'spinner' },
	          _react2.default.createElement(_spinner2.default, null)
	        );
	      } else if (mobileCustomerStatementError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            _react2.default.createElement(
	              'label',
	              null,
	              'Oops... Something Unexpected Happend.'
	            )
	          )
	        );
	      }
	      // Parameters of the react-data-grid
	      var tableHeight = window.innerHeight < 930 ? 510 : 510;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this5.state.statementLines);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var lines = Object.assign({}, _this5.state.statementLines, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this5.setState({ statementLines: lines });
	      };
	
	      var firstCol = function firstCol() {
	        if (typeRadios === 'year' || typeRadios === 'quarter') {
	          return [{
	            key: 'month',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'month' }),
	            resizable: true,
	            sortable: true,
	            width: 80
	          }];
	        }
	        return [{
	          key: 'day',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	          resizable: true,
	          sortable: true,
	          width: 80
	        }];
	      };
	
	      // Column difinition
	      var columns = firstCol().concat([{
	        key: 'order_amount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_amount' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'invoice_amount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_amount' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'receive_amount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'total_order',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '#_orders' }),
	        resizable: true,
	        sortable: true,
	        width: 80
	      }, {
	        key: 'total_invoice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '#_invoices' }),
	        resizable: true,
	        sortable: true,
	        width: 80
	      }, {
	        key: 'total_capture',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '#_paid_orders' }),
	        resizable: true,
	        sortable: true,
	        width: 120
	      }]);
	
	      //React Table Purchase Order Full Table
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { className: 'react-table-ar-ap-customer-list-statement', id: 'MobileCustomerStatement-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              onGridSort: handleGridSort,
	              columns: columns,
	              headerRowHeight: 45,
	              rowHeight: 25,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: tableHeight
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state6 = this.state,
	          fromDate = _state6.fromDate,
	          toDate = _state6.toDate,
	          typeRadios = _state6.typeRadios;
	      // const { fromDate, toDate } = getFromToDatesWithFilter({ Year, Month, Quarter, FromDate, ToDate });
	
	      var params = 'type=' + typeRadios + '&start_date=' + fromDate + '&end_date=' + toDate;
	
	      var printUrl = _root_url.ROOT_URL + 'v1/ar/statement/mobile/print/?' + params + '&Bearer=' + localStorage.getItem('token');
	      var excelUrl = _root_url.ROOT_URL + 'v1/ar/statement/mobile/excel/?' + params + '&Bearer=' + localStorage.getItem('token');
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_slashsign_ap' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mobile_customer_statement' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'primary',
	              href: printUrl,
	              disabled: true
	            },
	            _react2.default.createElement('em', { className: 'fa fa-print' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'success',
	              href: excelUrl,
	              disabled: true
	            },
	            _react2.default.createElement('em', { className: 'fa fa-download' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'mobile-customer-statement' },
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            { id: 'date-range-picker', className: 'form-horizontal' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 7 },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 2 },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'text-right' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'statement_range' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'colon' },
	                      ':'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { id: 'status-filter-radios' },
	                  (0, _genericRadioFilter2.default)({
	                    content: [{
	                      option: 'range',
	                      id: 'dateRange-radio-filter',
	                      name: 'dateFilterRadios',
	                      labelName: 'date_range'
	                    }, {
	                      option: 'year',
	                      id: 'year-radio-filter',
	                      name: 'dateFilterRadios',
	                      labelName: 'year'
	                    }, {
	                      option: 'quarter',
	                      id: 'quarter-radio-filter',
	                      name: 'dateFilterRadios',
	                      labelName: 'quarter'
	                    }, {
	                      option: 'month',
	                      id: 'month-radio-filter',
	                      name: 'dateFilterRadios',
	                      labelName: 'month'
	                    }],
	                    value: this.state.typeRadios,
	                    handleOnClick: this.handleDateFilterChange,
	                    type: 'buttons'
	                  })
	                ),
	                this.renderDateSelector()
	              ),
	              this.renderAmountDetail(),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'date-title' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: (0, _moment2.default)().format('YYYY-MM-DD') })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            { className: 'position-relative table-collapse-fix mb0' },
	            this.renderTable()
	          )
	        )
	      );
	    }
	  }]);
	
	  return MobileCustomerStatement;
	}(_react.Component);
	
	var _default = MobileCustomerStatement;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getBsStyle, 'getBsStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/mobileCustomerStatement.jsx');
	
	  __REACT_HOT_LOADER__.register(MobileCustomerStatement, 'MobileCustomerStatement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/mobileCustomerStatement.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/AR/mobileCustomerStatement.jsx');
	}();

	;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _agents_actions = __webpack_require__(108);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  value: _propTypes2.default.string,
	  dependentValues: _propTypes2.default.shape({
	    id: _propTypes2.default.number
	  }),
	  onClick: _propTypes2.default.func.isRequired
	};
	
	var defaultProps = {
	  value: '',
	  dependentValues: {}
	};
	
	var AgentManagement = function (_Component) {
	  _inherits(AgentManagement, _Component);
	
	  function AgentManagement(props) {
	    _classCallCheck(this, AgentManagement);
	
	    var _this = _possibleConstructorReturn(this, (AgentManagement.__proto__ || Object.getPrototypeOf(AgentManagement)).call(this, props));
	
	    _this.handleFetchAgentList = function () {
	      var handleSuccess = function handleSuccess(response) {
	        var agentList = _extends({}, _this.state.agentList, { rows: response });
	        _this.setState({
	          agentList: agentList,
	          isAgentListLoading: false
	        });
	      };
	
	      var handleFailure = function handleFailure() {
	        _this.setState({ isAgentListLoading: false });
	      };
	
	      _this.setState({ isAgentListLoading: true }, function () {
	        (0, _agents_actions.fetchAgentList)(handleSuccess, handleFailure);
	      });
	    };
	
	    _this.handleChangeStatusClick = function (action, id) {
	      var handleSuccess = function handleSuccess() {
	        _this.handleFetchAgentList();
	      };
	
	      var handleFailure = function handleFailure(err) {
	        alert(JSON.stringify(err.data));
	      };
	
	      var isActive = false;
	      if (action === 'activate') {
	        isActive = true;
	      }
	      (0, _agents_actions.changeAgentStatus)(id, isActive, handleSuccess, handleFailure);
	    };
	
	    _this.renderAgentsTable = function () {
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this.state.agentList);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var agentList = Object.assign({}, _this.state.agentList, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this.setState({ agentList: agentList });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this.state.agentList.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var agentList = _extends({}, _this.state.agentList, { filters: newFilters });
	        _this.setState({ agentList: agentList });
	      };
	
	      var handleClearFilters = function handleClearFilters() {
	        var agentList = _extends({}, _this.state.agentList, { filters: {} });
	        _this.setState({ agentList: agentList });
	      };
	
	      var IsActiveFormatter = _react2.default.createClass({
	        displayName: 'IsActiveFormatter',
	        render: function render() {
	          if (this.props.value) {
	            return _react2.default.createElement(
	              'span',
	              { className: 'label label-success' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'active' })
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inactive' })
	          );
	        }
	      });
	
	      var ActionFormatter = _react2.default.createClass({
	        displayName: 'ActionFormatter',
	        render: function render() {
	          var _this2 = this;
	
	          var _props = this.props,
	              value = _props.value,
	              dependentValues = _props.dependentValues;
	
	          if (value === 'deactivate') {
	            return _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                disabled: !(0, _permissions2.default)('change_agent'),
	                onClick: function onClick() {
	                  return _this2.props.onClick(value, dependentValues.id);
	                }
	              },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deactivate' })
	            );
	          }
	          return _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'primary',
	              disabled: !(0, _permissions2.default)('change_agent'),
	              onClick: function onClick() {
	                return _this2.props.onClick(value, dependentValues.id);
	              }
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'activate' })
	          );
	        }
	      });
	
	      var columns = [{
	        key: 'email',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' }),
	        resizable: true,
	        width: 220,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'firstName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'first_name' }),
	        resizable: true,
	        width: 180,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'lastName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_name' }),
	        resizable: true,
	        width: 180,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'phone',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' }),
	        resizable: true,
	        width: 180,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'isActive',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        width: 120,
	        sortable: true,
	        filterable: true,
	        formatter: IsActiveFormatter
	      }, {
	        key: 'action',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'action' }),
	        resizable: false,
	        width: 120,
	        sortable: true,
	        filterable: true,
	        formatter: _react2.default.createElement(ActionFormatter, { onClick: _this.handleChangeStatusClick }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }];
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { id: 'AgentManagement-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'id',
	                onGridSort: handleGridSort,
	                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                rowHeight: 35,
	                onAddFilter: handleFilterChange,
	                onClearFilters: handleClearFilters,
	                columns: columns,
	                minHeight: 620,
	                rowGetter: rowGetter,
	                rowsCount: getSize()
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'total-users' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'total-users' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_agents' }),
	            ':\xA0',
	            _react2.default.createElement(
	              'span',
	              { className: 'font-color-orange' },
	              _this.state.agentList.rows.length
	            )
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      agentList: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      isAgentListLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(AgentManagement, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      this.handleFetchAgentList();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var isAgentListLoading = this.state.isAgentListLoading;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Admin' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'user_management' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'settings-user-management' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 6 },
	              _react2.default.createElement(
	                'h1',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'agents' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            null,
	            isAgentListLoading && _react2.default.createElement(_spinner2.default, { className: 'spinner' }),
	            this.renderAgentsTable()
	          )
	        )
	      );
	    }
	  }]);
	
	  return AgentManagement;
	}(_react.Component);
	
	AgentManagement.propTypes = propTypes;
	AgentManagement.defaultProps = defaultProps;
	
	var _default = AgentManagement;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Agents/AgentManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Agents/AgentManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(AgentManagement, 'AgentManagement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Agents/AgentManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Agents/AgentManagement.jsx');
	}();

	;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(13);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _isActive = __webpack_require__(96);
	
	var _isActive2 = _interopRequireDefault(_isActive);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _paymentTermForm = __webpack_require__(172);
	
	var _paymentTermForm2 = _interopRequireDefault(_paymentTermForm);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helping function to render a multi-fields form. Reference on redux-form array.
	
	var renderShippingAddresses = function renderShippingAddresses(_ref) {
	    var fields = _ref.fields;
	    return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { type: 'button', className: 'btn btn-green btn-green-default', onClick: function onClick() {
	                                fields.push({}); // pushes empty child field onto the end of the array
	                            } },
	                        _react2.default.createElement('i', null),
	                        ' ',
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_shipping_address' })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    !fields.length && _react2.default.createElement(
	                        'div',
	                        { className: 'marginTopStyle' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no_shipping_address' })
	                    ),
	                    fields.map(function (ShippingAddress, index) {
	                        return _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { key: index },
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 12 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    { className: 'marginTopStyle' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-5' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_address_poundsign' }),
	                                        index + 1
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        { className: 'col-sm-3 btn btn-warning', type: 'button', onClick: function onClick() {
	                                                fields.remove(index); // remove from index
	                                            } },
	                                        _react2.default.createElement('i', null),
	                                        ' ',
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'remove' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    { className: 'marginTopStyle' },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 2, className: 'marginTopStyle' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' }),
	                                        ': '
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 8 },
	                                        _react2.default.createElement(_reduxForm.Field, { name: ShippingAddress + '.Name', component: _inputField2.default })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    { className: 'marginTopStyle' },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 2, className: 'marginTopStyle' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'street' }),
	                                        ': '
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 8 },
	                                        _react2.default.createElement(_reduxForm.Field, { name: ShippingAddress + '.Street', component: _inputField2.default })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    { className: 'marginTopStyle' },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 2, className: 'marginTopStyle' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'state' }),
	                                        ': '
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 2 },
	                                        _react2.default.createElement(_reduxForm.Field, { name: ShippingAddress + '.State', component: _inputField2.default })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 2, className: 'marginTopStyle' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city' }),
	                                        ': '
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 2 },
	                                        _react2.default.createElement(_reduxForm.Field, { name: ShippingAddress + '.City', component: _inputField2.default })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 2, className: 'marginTopStyle' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zip' }),
	                                        ': '
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 2 },
	                                        _react2.default.createElement(_reduxForm.Field, { name: ShippingAddress + '.Zip', component: _inputField2.default })
	                                    )
	                                )
	                            )
	                        );
	                    })
	                )
	            )
	        )
	    );
	};
	
	var renderShippingContacts = function renderShippingContacts(_ref2) {
	    var fields = _ref2.fields;
	    return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { type: 'button', className: 'btn btn-green btn-green-default', onClick: function onClick() {
	                                fields.push({}); // pushes empty child field onto the end of the array
	                            } },
	                        _react2.default.createElement('i', null),
	                        ' ',
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_pickup' })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    !fields.length && _react2.default.createElement(
	                        'div',
	                        { className: 'marginTopStyle' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no_pickup' })
	                    ),
	                    fields.map(function (ShippingContact, index) {
	                        return _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { key: index },
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 12 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    { className: 'marginTopStyle' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-5' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_poundsign' }),
	                                        index + 1
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        { className: 'col-sm-3 btn btn-warning', type: 'button', onClick: function onClick() {
	                                                fields.remove(index); // remove from index
	                                            } },
	                                        _react2.default.createElement('i', null),
	                                        ' ',
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'remove' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    { className: 'marginTopStyle' },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 2, className: 'marginTopStyle' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'first_name' }),
	                                        ': '
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 2 },
	                                        _react2.default.createElement(_reduxForm.Field, { name: ShippingContact + '.FirstName', component: _inputField2.default })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 2, className: 'marginTopStyle' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_name' }),
	                                        ': '
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 2 },
	                                        _react2.default.createElement(_reduxForm.Field, { name: ShippingContact + '.LastName', component: _inputField2.default })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 2, className: 'marginTopStyle' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'middle_name' }),
	                                        ': '
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 2 },
	                                        _react2.default.createElement(_reduxForm.Field, { name: ShippingContact + '.MiddleName', component: _inputField2.default })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    { className: 'marginTopStyle' },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 2, className: 'marginTopStyle' },
	                                        'Tel: '
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _react2.default.createElement(_reduxForm.Field, { name: ShippingContact + '.Telephone', component: _inputField2.default })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    { className: 'marginTopStyle' },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 2, className: 'marginTopStyle' },
	                                        'Fax: '
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _react2.default.createElement(_reduxForm.Field, { name: ShippingContact + '.Fax', component: _inputField2.default })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    { className: 'marginTopStyle' },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 2, className: 'marginTopStyle' },
	                                        'E-mail: '
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _react2.default.createElement(_reduxForm.Field, { name: ShippingContact + '.Email', component: _inputField2.default })
	                                    )
	                                )
	                            )
	                        );
	                    })
	                )
	            )
	        )
	    );
	};
	
	var AgentForm = function (_Component) {
	    _inherits(AgentForm, _Component);
	
	    function AgentForm() {
	        _classCallCheck(this, AgentForm);
	
	        var _this = _possibleConstructorReturn(this, (AgentForm.__proto__ || Object.getPrototypeOf(AgentForm)).call(this));
	
	        _this.state = {
	            paymentTermOpen: false,
	            dirty: false
	        };
	        _this.openPaymentTerm = _this.openPaymentTerm.bind(_this);
	        _this.closePaymentTerm = _this.closePaymentTerm.bind(_this);
	        return _this;
	    }
	
	    _createClass(AgentForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            (0, _reduxForm.reset)('productForm');
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var currentAgent = this.props.currentAgent;
	
	            if (currentAgent) this.props.fetchAgentDetail(currentAgent.Agent_id).then(function () {
	                return _this2.props.fetchPaymentTerms();
	            });else this.props.fetchPaymentTerms();
	            // making a leaving hook to confirm leaving
	            this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            (0, _reduxForm.reset)('productForm');
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.dirty != this.props.dirty) {
	                this.setState({
	                    dirty: nextProps.dirty
	                });
	            }
	        }
	    }, {
	        key: 'routerWillLeave',
	        value: function routerWillLeave(nextLocation) {
	            if (this.state.dirty) return 'Your work is not saved! Are you sure you want to leave?';
	        }
	
	        // Helper function to pop up the add payment term function
	
	    }, {
	        key: 'openPaymentTerm',
	        value: function openPaymentTerm() {
	            this.setState({ paymentTermOpen: true });
	        }
	    }, {
	        key: 'closePaymentTerm',
	        value: function closePaymentTerm() {
	            this.setState({ paymentTermOpen: false });
	        }
	    }, {
	        key: 'onSubmit',
	        value: function onSubmit(props) {
	            if (!this.props.params.id) this.props.createProduct(props);else this.props.editProduct(props);
	        }
	    }, {
	        key: 'handleFormSubmit',
	        value: function handleFormSubmit(formProps) {
	            this.setState({ dirty: false });
	            if (!this.props.currentAgent) this.props.createAgent(formProps);else {
	                if (!this.checkPermission("change_agent")) this.props.editAgent(formProps);else alert("You have no permission!");
	            }
	        }
	    }, {
	        key: 'title',
	        value: function title() {
	            if (!this.props.params.id) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Breadcrumb,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb.Item,
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_management' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb.Item,
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'agent' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb.Item,
	                        { active: 'true' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_a_new_agent' })
	                    )
	                );
	            }
	            return _react2.default.createElement(
	                _reactBootstrap.Breadcrumb,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Breadcrumb.Item,
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_management' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Breadcrumb.Item,
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'agent' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Breadcrumb.Item,
	                    { active: 'true' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_agent' })
	                )
	            );
	        }
	    }, {
	        key: 'renderPaymentTerms',
	        value: function renderPaymentTerms() {
	            var _this3 = this;
	
	            if (this.props.paymentTermsIsLoading) return _react2.default.createElement(_spinner2.default, null); // If payment term is loading, show a spinner.
	            else {
	                    var paymentTermOptions = this.getPaymentTermOptions();
	                    return _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 8 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'PaymentTerm_id', component: _selection2.default, options: paymentTermOptions })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-primary', onClick: function onClick() {
	                                        _this3.openPaymentTerm();
	                                    } },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add' })
	                            )
	                        )
	                    );
	                }
	        }
	    }, {
	        key: 'getPaymentTermOptions',
	        value: function getPaymentTermOptions() {
	            var paymentTermOptions = [];
	            this.props.paymentTerms.map(function (paymentTerm) {
	                paymentTermOptions.push({ value: paymentTerm.PaymentTerm_id, label: paymentTerm.Name });
	            });
	            return paymentTermOptions;
	        }
	
	        // In case we need the shipping information for Agent
	
	        // <Panel header="Shipping Information">
	        //     <FieldArray name="ShippingAddress" component={renderShippingAddresses} />
	        //     <br/>
	        //     <FieldArray name="ShippingContact" component={renderShippingContacts} />
	        // </Panel>
	
	    }, {
	        key: 'checkPermission',
	        value: function checkPermission(permission) {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var agentInformation = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'agent_information' });
	            var activeCustomer = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'active_customer' });
	            var billingInformation = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'billing_information' });
	            var mailingInformation = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mailing_information' });
	            var addANewPaymentTerm = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_a_new_payment_term' });
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                submitting = _props.submitting,
	                pristine = _props.pristine;
	
	            if (this.props.detailIsLoading && !this.props.detailError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement('br', null),
	                '...',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reading_data' })
	            );else if (this.props.detailError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                return _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        this.props.name
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        null,
	                        this.title(),
	                        _react2.default.createElement(
	                            'form',
	                            { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	                            _react2.default.createElement('hr', null),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 6 },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Panel,
	                                        { header: agentInformation },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 4 },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'agent_name' })
	                                                    ),
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'Name', component: _inputField2.default })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 4 },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'agent_num' })
	                                                    ),
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'AgentNum', component: _inputField2.default })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 4 },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' })
	                                                    ),
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'RefNum', component: _inputField2.default })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 12 },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	                                                    ),
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'Description', component: _inputField2.default })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 12 },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit_status' })
	                                                    ),
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'CreditStatus', component: _inputField2.default })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(_reduxForm.Field, { name: 'IsActive', labelName: activeCustomer, component: _isActive2.default })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Panel,
	                                        { header: mailingInformation },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 12 },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group' },
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Row,
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 12 },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mailing_address' })
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Row,
	                                                        { className: 'marginTopStyle' },
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 2 },
	                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                                                            ': '
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 8 },
	                                                            _react2.default.createElement(_reduxForm.Field, { name: 'MailingAddress.Name', component: _inputField2.default })
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Row,
	                                                        { className: 'marginTopStyle' },
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 2 },
	                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'street' }),
	                                                            ': '
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 6 },
	                                                            _react2.default.createElement(_reduxForm.Field, { name: 'MailingAddress.Street', component: _inputField2.default })
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Row,
	                                                        { className: 'marginTopStyle' },
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 2 },
	                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'state' }),
	                                                            ': '
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 2 },
	                                                            _react2.default.createElement(_reduxForm.Field, { name: 'MailingAddress.State', component: _inputField2.default })
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 2 },
	                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city' }),
	                                                            ': '
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 2 },
	                                                            _react2.default.createElement(_reduxForm.Field, { name: 'MailingAddress.City', component: _inputField2.default })
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 2 },
	                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zip' }),
	                                                            ': '
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 2 },
	                                                            _react2.default.createElement(_reduxForm.Field, { name: 'MailingAddress.Zip', component: _inputField2.default })
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 12 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mailing_contact' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 2, className: 'marginTopStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'first_name' }),
	                                                ': '
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 2 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: 'MailingContact.FirstName', component: _inputField2.default })
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 2, className: 'marginTopStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_name' }),
	                                                ': '
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 2 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: 'MailingContact.LastName', component: _inputField2.default })
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 2, className: 'marginTopStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'middle_name' }),
	                                                ': '
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 2 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: 'MailingContact.MiddleName', component: _inputField2.default })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginTopStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 2, className: 'marginTopStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tel' }),
	                                                ': '
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: 'MailingContact.Telephone', component: _inputField2.default })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginTopStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 2, className: 'marginTopStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fax' }),
	                                                ': '
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: 'MailingContact.Fax', component: _inputField2.default })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginTopStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 2, className: 'marginTopStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' }),
	                                                ': '
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: 'MailingContact.Email', component: _inputField2.default })
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 6 },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Panel,
	                                        { header: billingInformation },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 12 },
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Row,
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Col,
	                                                        { sm: 12 },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term' })
	                                                        )
	                                                    )
	                                                ),
	                                                this.renderPaymentTerms()
	                                            )
	                                        ),
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 12 },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group' },
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Row,
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 12 },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'billing_address' })
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Row,
	                                                        { className: 'marginTopStyle' },
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 2 },
	                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                                                            ': '
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 8 },
	                                                            _react2.default.createElement(_reduxForm.Field, { name: 'BillingAddress.Name', component: _inputField2.default })
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Row,
	                                                        { className: 'marginTopStyle' },
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 2 },
	                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'street' }),
	                                                            ': '
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 6 },
	                                                            _react2.default.createElement(_reduxForm.Field, { name: 'BillingAddress.Street', component: _inputField2.default })
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Row,
	                                                        { className: 'marginTopStyle' },
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 2 },
	                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'state' }),
	                                                            ': '
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 2 },
	                                                            _react2.default.createElement(_reduxForm.Field, { name: 'BillingAddress.State', component: _inputField2.default })
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 2 },
	                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city' }),
	                                                            ': '
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 2 },
	                                                            _react2.default.createElement(_reduxForm.Field, { name: 'BillingAddress.City', component: _inputField2.default })
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 2 },
	                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zip' }),
	                                                            ': '
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 2 },
	                                                            _react2.default.createElement(_reduxForm.Field, { name: 'BillingAddress.Zip', component: _inputField2.default })
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 12 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'billing_contact' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 2, className: 'marginTopStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'first_name' }),
	                                                ': '
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 2 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: 'BillingContact.FirstName', component: _inputField2.default })
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 2, className: 'marginTopStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_name' }),
	                                                ': '
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 2 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: 'BillingContact.LastName', component: _inputField2.default })
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 2, className: 'marginTopStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'middle_name' }),
	                                                ': '
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 2 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: 'BillingContact.MiddleName', component: _inputField2.default })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginTopStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 2, className: 'marginTopStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tel_colonsign' }),
	                                                ' '
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: 'BillingContact.Telephone', component: _inputField2.default })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginTopStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 2, className: 'marginTopStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fax_colonsign' }),
	                                                ' '
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: 'BillingContact.Fax', component: _inputField2.default })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginTopStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 2, className: 'marginTopStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email_colonsign' }),
	                                                ' '
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: 'BillingContact.Email', component: _inputField2.default })
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(_reactBootstrap.Row, null),
	                            _react2.default.createElement(
	                                'button',
	                                { action: 'submit', className: 'btn btn-primary', disabled: submitting || pristine },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	                            ),
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/agents', className: 'btn btn-danger buttonStyle' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	                            ),
	                            this.props.isCreating || this.props.isEditing && _react2.default.createElement(_spinner2.default, null),
	                            this.props.createError && _react2.default.createElement(
	                                'div',
	                                { className: 'alert alert-danger marginTopStyle' },
	                                JSON.stringify(this.props.createError)
	                            ),
	                            this.props.editError && _react2.default.createElement(
	                                'div',
	                                { className: 'alert alert-danger marginTopStyle' },
	                                JSON.stringify(this.props.editError)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactSkylight.SkyLightStateless,
	                            { isVisible: this.state.paymentTermOpen, onCloseClicked: function onCloseClicked() {
	                                    _this4.closePaymentTerm();
	                                }, title: addANewPaymentTerm },
	                            _react2.default.createElement(_paymentTermForm2.default, { closePT: this.closePaymentTerm })
	                        )
	                    )
	                );
	            }
	        }
	    }]);
	
	    return AgentForm;
	}(_react.Component);
	
	AgentForm.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	
	var _default = (0, _reactRouter.withRouter)(AgentForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(renderShippingAddresses, 'renderShippingAddresses', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Agents/agentForm.jsx');
	
	    __REACT_HOT_LOADER__.register(renderShippingContacts, 'renderShippingContacts', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Agents/agentForm.jsx');
	
	    __REACT_HOT_LOADER__.register(AgentForm, 'AgentForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Agents/agentForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Agents/agentForm.jsx');
	}();

	;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _constants = __webpack_require__(11);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Agents = function (_Component) {
	    _inherits(Agents, _Component);
	
	    function Agents() {
	        _classCallCheck(this, Agents);
	
	        var _this = _possibleConstructorReturn(this, (Agents.__proto__ || Object.getPrototypeOf(Agents)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	            rows: [],
	            selectedRows: null,
	            filters: {},
	            sortColumn: null,
	            sortDirection: null
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        return _this;
	    }
	
	    _createClass(Agents, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchAgents();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	
	        // Once groups is ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.agents && nextProps.agents != this.props.agents) {
	                this.setState({
	                    rows: nextProps.agents
	                });
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	        }
	
	        // Set agent being selected to be currentAgent and navigate user to the edit page
	
	    }, {
	        key: 'setCurrentAgent',
	        value: function setCurrentAgent(e) {
	            e.preventDefault();
	            var currentAgent = this.state.selectedRows[0];
	            this.props.resetCurrentAgent();
	            this.props.selectAgent(currentAgent);
	            this.context.router.push('/agents/' + currentAgent.Agent_id);
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            this.props.resetCurrentAgent();
	            this.context.router.push('/agents/new');
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this2 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this2.setState(state);
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this2.state.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    _this2.setState({ filters: newFilters });
	                };
	
	                //Custom Formatter component
	                var IsActiveFormatter = _react2.default.createClass({
	                    displayName: 'IsActiveFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-success' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'active' })
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inactive' })
	                        );
	                    }
	                });
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    _this2.setState({ selectedRows: rows });
	                };
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'AgentNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'agent_num' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    width: 80
	                }, {
	                    key: 'Name',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    width: 150
	                }, {
	                    key: 'Description',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    width: 100
	                }, {
	                    key: 'PaymentTerm_id',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    width: 150
	                }, {
	                    key: 'CreditStatus',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit_status' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    width: 100
	                }, {
	                    key: 'IsActive',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'active' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    width: 80,
	                    formatter: IsActiveFormatter
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'agents-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'Agent_id',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: this.state.tableHeight,
	                                enableRowSelect: 'single',
	                                onRowUpdated: this.handleRowUpdated,
	                                onRowSelect: onRowSelect
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'checkPermission',
	        value: function checkPermission(permission) {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var height = (this.state.tableHeight + 130).toString();
	            var tableCollapseFix = { height: height };
	            return (
	                //---------------
	                // Begin HTML: Create New/Edit agent
	                //---------------
	                _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_management' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            { active: 'true' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'agents' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Grid,
	                        { fluid: 'true', id: 'agents-page' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { md: 12 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { className: 'position-relative', style: tableCollapseFix },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            {
	                                                bsStyle: 'primary',
	                                                className: 'marginLeftStyle',
	                                                onClick: function onClick(event) {
	                                                    _this3.clickNew(event);
	                                                },
	                                                disabled: this.checkPermission("add_agent") },
	                                            _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_agent' })
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            {
	                                                bsStyle: 'primary',
	                                                className: 'marginLeftStyle',
	                                                onClick: function onClick(event) {
	                                                    _this3.setCurrentAgent(event);
	                                                },
	                                                disabled: !this.state.selectedRows || this.state.selectedRows.length != 1 },
	                                            _react2.default.createElement('em', { className: 'fa fa-pencil marginRightStyle' }),
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_agent' })
	                                        )
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    this.renderTable()
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Agents;
	}(_react.Component);
	
	Agents.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = Agents;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(Agents, 'Agents', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Agents/agents.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Agents/agents.jsx');
	}();

	;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(13);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _Header = __webpack_require__(165);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isGV = _root_url.ROOT_API_URL === 'https://gvyummy-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://scm.gvyummy.com/api/';
	var isCNT = _root_url.ROOT_API_URL === 'https://erp.chinatown-supermarket.com/api/' || _root_url.ROOT_URL === 'https://erp.chinatown-supermarket.com/api/';
	
	var Login = function (_Component) {
	    _inherits(Login, _Component);
	
	    function Login() {
	        _classCallCheck(this, Login);
	
	        return _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).apply(this, arguments));
	    }
	
	    _createClass(Login, [{
	        key: 'handleFormSubmit',
	
	
	        // When the form submitted, signup the user with username and password.
	
	        value: function handleFormSubmit(_ref) {
	            var username = _ref.username,
	                password = _ref.password;
	
	            this.props.signinUser({ username: username, password: password });
	        }
	
	        // Error dealing
	
	    }, {
	        key: 'renderAlert',
	        value: function renderAlert() {
	            if (this.props.errorMessage) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'oops' }),
	                        '!'
	                    ),
	                    ' ',
	                    this.props.errorMessage
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                pristine = _props.pristine,
	                reset = _props.reset,
	                submitting = _props.submitting;
	
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { id: 'loginPanel' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'block-center wd-xxl' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel panel-dark panel-flat' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'panel-heading text-center' },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '#' },
	                                    !isGV && !isCNT && _react2.default.createElement('img', { src: 'img/logo.png', alt: 'Image', className: 'block-center img-rounded' }),
	                                    isCNT && _react2.default.createElement(
	                                        'p',
	                                        { style: { color: 'white', fontSize: '26px', marginBottom: '0px' } },
	                                        'Chinatown Wholesale'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'panel-body' },
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: 'text-center pv' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sign_in_to_continue' })
	                                ),
	                                _react2.default.createElement(
	                                    'form',
	                                    { className: 'mb-lg', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group has-feedback' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'username' })
	                                        ),
	                                        _react2.default.createElement(_reduxForm.Field, _defineProperty({ className: 'largeInput', name: 'username', component: 'input', id: 'exampleInputusername1', type: 'username', placeholder: 'Username', autoComplete: 'off', required: 'required' }, 'className', 'form-control')),
	                                        _react2.default.createElement('span', { className: 'fa fa-envelope form-control-feedback text-muted' })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group has-feedback' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'password' })
	                                        ),
	                                        _react2.default.createElement(_reduxForm.Field, _defineProperty({ className: 'largeInput', name: 'password', component: 'input', id: 'exampleInputPassword1', type: 'password', placeholder: 'Password', required: 'required' }, 'className', 'form-control')),
	                                        _react2.default.createElement('span', { className: 'fa fa-lock form-control-feedback text-muted' })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            _react2.default.createElement('input', { type: 'checkbox', value: '', name: 'remember' }),
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'remember_me' })
	                                        )
	                                    ),
	                                    this.renderAlert(),
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'submit', className: 'btn btn-block btn-success mt-lg' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'login', defaultMessage: 'Login', description: 'Login' })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Login;
	}(_react.Component);
	
	var _default = Login;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(isGV, 'isGV', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Auth/login.jsx');
	
	    __REACT_HOT_LOADER__.register(isCNT, 'isCNT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Auth/login.jsx');
	
	    __REACT_HOT_LOADER__.register(Login, 'Login', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Auth/login.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Auth/login.jsx');
	}();

	;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Signup = function (_Component) {
	    _inherits(Signup, _Component);
	
	    function Signup() {
	        _classCallCheck(this, Signup);
	
	        return _possibleConstructorReturn(this, (Signup.__proto__ || Object.getPrototypeOf(Signup)).apply(this, arguments));
	    }
	
	    _createClass(Signup, [{
	        key: 'handleFormSubmit',
	        value: function handleFormSubmit(formProps) {
	            this.props.signupUser(formProps);
	        }
	
	        // Error dealing.
	
	    }, {
	        key: 'renderAlert',
	        value: function renderAlert() {
	            if (this.props.errorMessage) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'oops' }),
	                        '!'
	                    ),
	                    this.props.errorMessage
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                _props$fields = _props.fields,
	                email = _props$fields.email,
	                password = _props$fields.password,
	                passwordConfirm = _props$fields.passwordConfirm;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'block-center mt-xl wd-xl' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-dark panel-flat' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading text-center' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#' },
	                            _react2.default.createElement('img', { src: 'img/logo.png', alt: 'Image', className: 'block-center img-rounded' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'text-center pv' },
	                            'SIGNUP TO GET INSTANT ACCESS.'
	                        ),
	                        _react2.default.createElement(
	                            'form',
	                            { onSubmit: handleSubmit(this.handleFormSubmit.bind(this)), className: 'mb-lg' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'form-group has-feedback' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { htmlFor: 'signupInputEmail1', className: 'text-muted' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email_address' })
	                                ),
	                                _react2.default.createElement('input', _extends({}, email, { id: 'signupInputEmail1', type: 'email', placeholder: 'Enter email', autoComplete: 'off', required: 'required', className: 'form-control' })),
	                                _react2.default.createElement('span', { className: 'fa fa-envelope form-control-feedback text-muted' }),
	                                email.touched && email.error && _react2.default.createElement(
	                                    'div',
	                                    { className: 'alert alert-danger' },
	                                    email.error
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'form-group has-feedback' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { htmlFor: 'signupInputPassword1', className: 'text-muted' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'password' })
	                                ),
	                                _react2.default.createElement('input', _extends({}, password, { id: 'signupInputPassword1', type: 'password', placeholder: 'Password', autoComplete: 'off', required: 'required', className: 'form-control' })),
	                                _react2.default.createElement('span', { className: 'fa fa-lock form-control-feedback text-muted' }),
	                                password.touched && password.error && _react2.default.createElement(
	                                    'div',
	                                    { className: 'alert alert-danger' },
	                                    password.error
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'form-group has-feedback' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { htmlFor: 'signupInputRePassword1', className: 'text-muted' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'retype_password' })
	                                ),
	                                _react2.default.createElement('input', _extends({}, passwordConfirm, { id: 'signupInputRePassword1', type: 'password', placeholder: 'Retype Password', autoComplete: 'off', required: 'required', 'data-parsley-equalto': '#signupInputPassword1',
	                                    className: 'form-control' })),
	                                _react2.default.createElement('span', { className: 'fa fa-lock form-control-feedback text-muted' }),
	                                passwordConfirm.touched && passwordConfirm.error && _react2.default.createElement(
	                                    'div',
	                                    { className: 'alert alert-danger' },
	                                    passwordConfirm.error
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'clearfix' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'checkbox c-checkbox pull-left mt0' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        _react2.default.createElement('input', { type: 'checkbox', value: '', required: 'required', name: 'agreed' }),
	                                        _react2.default.createElement('em', { className: 'fa fa-check' }),
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_agree_terms' })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { action: 'submit', className: 'btn btn-block btn-primary mt-lg' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_account' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'pt-lg text-center' },
	                            'Have an account?'
	                        ),
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/login', className: 'btn btn-block btn-default' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'login' })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Signup;
	}(_react.Component);
	
	var _default = Signup;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(Signup, 'Signup', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Auth/signup.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Auth/signup.jsx');
	}();

	;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AltonChildModal = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Selectors = _reactDataGridAddons.Data.Selectors;
	
	var AltonChildModal = exports.AltonChildModal = function (_Component) {
	    _inherits(AltonChildModal, _Component);
	
	    function AltonChildModal() {
	        _classCallCheck(this, AltonChildModal);
	
	        var _this = _possibleConstructorReturn(this, (AltonChildModal.__proto__ || Object.getPrototypeOf(AltonChildModal)).call(this));
	
	        _this.state = {
	
	            agentList: {
	                rows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            }
	
	            // rows: [],
	            // selectedRows: null,
	            // editedRows: [],
	            // filters: {},
	        };
	        return _this;
	    }
	
	    _createClass(AltonChildModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var agentList = this.state.agentList;
	
	            _axios2.default.get(_root_url.ROOT_URL + 'v1/product/child_products/' + this.props.altonSelectedProd,
	            // `${ROOT_URL}v1/product/child_products/2497`,
	            {
	                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	            }).then(function (response) {
	                agentList.rows = response.data;
	                _this2.setState({ agentList: agentList });
	                // this.setState({rows: response.data});
	            }, function (err) {
	                if (err.data) {
	                    alert(err.data);
	                } else {
	                    alert("Server issue detected, please contact admin.");
	                }
	            });
	            // let {selectedBatch} = this.state;
	            // this.setState({ selectedBatch });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	    }, {
	        key: 'renderAgentTable',
	        value: function renderAgentTable() {
	            var _this3 = this;
	
	            var getRows = function getRows() {
	                return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.agentList);
	            };
	
	            var getSize = function getSize() {
	                return getRows().length;
	            };
	            var rowGetter = function rowGetter(rowIdx) {
	                var rows = getRows();
	                return rows[rowIdx];
	            };
	
	            var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                var agentList = Object.assign({}, _this3.state.agentList, { sortColumn: sortColumn, sortDirection: sortDirection });
	                _this3.setState({ agentList: agentList });
	            };
	
	            var handleFilterChange = function handleFilterChange(filter) {
	                var newFilters = Object.assign({}, _this3.state.agentList.filters);
	                if (filter.filterTerm) {
	                    newFilters[filter.column.key] = filter;
	                } else {
	                    delete newFilters[filter.column.key];
	                }
	                var agentList = _extends({}, _this3.state.agentList, { filters: newFilters });
	                _this3.setState({ agentList: agentList });
	            };
	
	            var handleClearFilters = function handleClearFilters() {
	                var agentList = _extends({}, _this3.state.agentList, { filters: {} });
	                _this3.setState({ agentList: agentList });
	            };
	
	            var columns = [{
	                key: 'related_name',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'related_name' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 290
	            }, {
	                key: 'related_refnum',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'related_refnum' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 130
	            }, {
	                key: 'convert_number',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'convert_num' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 130
	                // formatter: ({ value }) => (
	                //     <div>
	                //       { value ? "true" : "false" }
	                //     </div>
	                //   ),
	            }];
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { style: { maxWidth: '550px', marginLeft: '25px' } },
	                        _react2.default.createElement(_reactDataGrid2.default, {
	                            enableCellSelect: true,
	                            columns: columns,
	                            rowGetter: rowGetter,
	                            rowsCount: getSize(),
	                            minHeight: 300,
	                            rowHeight: 25,
	                            headerRowHeight: 45,
	                            toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                            onGridSort: handleGridSort,
	                            onAddFilter: handleFilterChange,
	                            onClearFilters: handleClearFilters
	
	                            //   onRowUpdated={handleRowUpdated}
	                        })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            _objectDestructuringEmpty(this.props);
	
	            _objectDestructuringEmpty(this.state);
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: 'text-center' },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            this.renderAgentTable()
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AltonChildModal;
	}(_react.Component);
	
	var _default = AltonChildModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(AltonChildModal, 'AltonChildModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/AltonChildModal.jsx');
	
	    __REACT_HOT_LOADER__.register(Selectors, 'Selectors', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/AltonChildModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/AltonChildModal.jsx');
	}();

	;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BatchesModal2 = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Selectors = _reactDataGridAddons.Data.Selectors;
	
	var BatchesModal2 = exports.BatchesModal2 = function (_Component) {
	  _inherits(BatchesModal2, _Component);
	
	  function BatchesModal2() {
	    _classCallCheck(this, BatchesModal2);
	
	    var _this = _possibleConstructorReturn(this, (BatchesModal2.__proto__ || Object.getPrototypeOf(BatchesModal2)).call(this));
	
	    _this.processBatchSelection = function () {
	      var batches = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      var avaliableBatches = batches.filter(function (batch) {
	        return true;
	      });
	      avaliableBatches = avaliableBatches.sort(function (a, b) {
	        if (a.expire_datetime > b.expire_datetime) {
	          return 1;
	        }
	        return -1;
	      });
	      avaliableBatches = avaliableBatches.map(function (batch) {
	        return {
	          label: '\n        ' + batch.batch_num + ': ' + batch.quantity + '\n        ' + (batch.location ? '- Location: ' + batch.location : '- Location: N/A') + '\n        ' + (batch.pallet_barcode ? '- PLT barcode: ' + batch.pallet_barcode : '- PLT barcode: N/A'),
	          value: batch.id,
	          expiredDate: batch.expire_datetime
	        };
	      });
	      return avaliableBatches;
	    };
	
	    _this.handleBatchSelected = function (selectedBatch) {
	      return _this.setState({ selectedBatch: selectedBatch });
	    };
	
	    _this.handleOnSubmit = function (e) {
	      var _this$state = _this.state,
	          selectedBatch = _this$state.selectedBatch,
	          outputExpire = _this$state.outputExpire;
	      var lineBatchRows = _this.props.lineBatchRows;
	
	
	      _this.props.lineBatchRows.map(function (r, index) {
	        if (r.SalesOrderLine_id === _this.props.lineBatchIdx) {
	          lineBatchRows[index].Batch_id_id = selectedBatch.value;
	          lineBatchRows[index].Batch_id = selectedBatch.value;
	          lineBatchRows[index].BatchExpiredDate = selectedBatch.expiredDate;
	        }
	      });
	
	      _this.props.onEditBatch(_this.props.lineBatchRows);
	      // const batch = selectedBatch.value ? selectedBatch : this.state.batchSelection[0];
	      // this.props.onSelectedBatch(batch.value, batch.expiredDate);
	    };
	
	    _this.state = {
	      selectedBatch: {
	        label: 'default',
	        value: null,
	        expire: null
	      },
	      batchSelection: [],
	      outputExpire: null
	    };
	    return _this;
	  }
	
	  _createClass(BatchesModal2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var selectedBatch = this.state.selectedBatch;
	
	      this.setState({ selectedBatch: selectedBatch });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var selectedBatch = this.state.selectedBatch;
	      // if (this.props.batchesInfo !== nextProps.batchesInfo) {
	
	      nextProps.batchesInfo && nextProps.batchesInfo.batches && nextProps.batchesInfo.batches.map(function (r) {
	        if (r.id === _this2.props.lineBatchId) {
	          selectedBatch.label = '\n          ' + r.batch_num + ': ' + r.quantity + '\n          ' + (r.location ? '- Location: ' + r.location : '- Location: N/A') + '\n          ' + (r.pallet_barcode ? '- PLT barcode: ' + r.pallet_barcode : '- PLT barcode: N/A');
	          selectedBatch.value = r.id;
	          selectedBatch.expiredDate = r.expire_datetime;
	        }
	      });
	
	      this.setState({
	        batchSelection: this.processBatchSelection(nextProps.batchesInfo.batches),
	        selectedBatch: selectedBatch
	      });
	      //   }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      _objectDestructuringEmpty(this.props);
	
	      var selectedBatch = this.state.selectedBatch;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { style: { marginBottom: "12px" } },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              { style: { float: 'right' } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_batch' }),
	              ':'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 9 },
	            _react2.default.createElement(
	              _reactBootstrap.Dropdown,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Dropdown.Toggle,
	                {
	                  style: {
	                    width: "400px",
	                    backgroundColor: "white",
	                    border: "1px solid #555555",
	                    color: "black",
	                    fontWeight: "400"
	                  }
	                },
	                selectedBatch.label || selectedBatch
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Dropdown.Menu,
	                { className: 'super-colors' },
	                this.state.batchSelection.map(function (batch) {
	                  return _react2.default.createElement(
	                    _reactBootstrap.MenuItem,
	                    { onClick: function onClick() {
	                        return _this3.handleBatchSelected(batch);
	                      }, style: {
	                        width: "400px",
	                        backgroundColor: "white",
	                        color: "black",
	                        fontWeight: "400"
	                      } },
	                    batch.label
	                  );
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'centerStyle', style: { marginTop: "50px" } },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'success',
	              onClick: function onClick(e) {
	                _this3.handleOnSubmit(e);
	              }
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_this_batch' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return BatchesModal2;
	}(_react.Component);
	
	var _default = BatchesModal2;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(BatchesModal2, 'BatchesModal2', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/BatchesModal2.jsx');
	
	  __REACT_HOT_LOADER__.register(Selectors, 'Selectors', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/BatchesModal2.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/BatchesModal2.jsx');
	}();

	;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DisplayDataGrid = function (_Component) {
	  _inherits(DisplayDataGrid, _Component);
	
	  function DisplayDataGrid() {
	    _classCallCheck(this, DisplayDataGrid);
	
	    var _this = _possibleConstructorReturn(this, (DisplayDataGrid.__proto__ || Object.getPrototypeOf(DisplayDataGrid)).call(this));
	
	    _this.getRows = function () {
	      return _reactDataGridAddons.Data.Selectors.getRows(_this.state.data);
	    };
	
	    _this.getSize = function () {
	      return _this.getRows().length;
	    };
	
	    _this.rowGetter = function (rowIdx) {
	      var rows = _this.getRows();
	      return rows[rowIdx];
	    };
	
	    _this.handleGridSort = function (sortColumn, sortDirection) {
	      var data = _extends({}, _this.state.data, { sortColumn: sortColumn, sortDirection: sortDirection });
	      _this.setState({ data: data });
	    };
	
	    _this.state = {
	      data: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null
	      }
	    };
	    return _this;
	  }
	
	  _createClass(DisplayDataGrid, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.rows) {
	        var data = _extends({}, this.state.data, { rows: this.props.rows });
	        this.setState({ data: data });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.columns && nextProps.columns !== this.props.columns) {
	        this.setState({ columns: nextProps.columns });
	      }
	
	      if (nextProps.rows && nextProps.rows !== this.props.rows) {
	        var data = _extends({}, this.state.data, { rows: nextProps.rows });
	        this.setState({ data: data });
	      }
	    }
	
	    // Handle the sortable function
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { id: 'DisplayDataGrid-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, _extends({
	              rowKey: 'Name'
	            }, this.props, {
	              onGridSort: this.handleGridSort,
	              rowGetter: this.rowGetter,
	              rowsCount: this.getSize()
	            }))
	          )
	        )
	      );
	    }
	  }]);
	
	  return DisplayDataGrid;
	}(_react.Component);
	
	var _default = DisplayDataGrid;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(DisplayDataGrid, 'DisplayDataGrid', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/DisplayDataGrid.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/DisplayDataGrid.jsx');
	}();

	;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAvatarEditor = __webpack_require__(818);
	
	var _reactAvatarEditor2 = _interopRequireDefault(_reactAvatarEditor);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Editor = function (_React$Component) {
	  _inherits(Editor, _React$Component);
	
	  function Editor() {
	    _classCallCheck(this, Editor);
	
	    var _this = _possibleConstructorReturn(this, (Editor.__proto__ || Object.getPrototypeOf(Editor)).call(this));
	
	    _this.handleSave = function (data) {
	      var dataURI = _this.editor.getImage().toDataURL();
	
	      var byteString = void 0;
	      if (dataURI.split(',')[0].indexOf('base64') >= 0) {
	        byteString = atob(dataURI.split(',')[1]);
	      } else {
	        byteString = unescape(dataURI.split(',')[1]);
	      }
	
	      // separate out the mime component
	      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
	
	      // write the bytes of the string to a typed array
	      var ia = new Uint8Array(byteString.length);
	      for (var i = 0; i < byteString.length; i++) {
	        ia[i] = byteString.charCodeAt(i);
	      }
	
	      var blb = new Blob([ia], { type: mimeString });
	
	      var rect = _this.editor.getCroppingRect();
	      _this.props.upload(_this.props.Product_id, blb);
	      _this.setState({
	        preview: {
	          dataURI: dataURI,
	          rect: rect,
	          scale: _this.state.scale,
	          width: _this.state.width,
	          height: _this.state.height,
	          borderRadius: _this.state.borderRadius
	        }
	      });
	    };
	
	    _this.handleScale = function (e) {
	      _this.props.clearAttachedProductImage();
	      var scale = parseFloat(e.target.value);
	      _this.setState({ scale: scale });
	    };
	
	    _this.rotateLeft = function (e) {
	      e.preventDefault();
	      _this.setState({
	        rotate: _this.state.rotate - 90
	      });
	    };
	
	    _this.rotateRight = function (e) {
	      e.preventDefault();
	      _this.setState({
	        rotate: _this.state.rotate + 90
	      });
	    };
	
	    _this.handleBorderRadius = function (e) {
	      var borderRadius = parseInt(e.target.value);
	      _this.setState({ borderRadius: borderRadius });
	    };
	
	    _this.handleXPosition = function (e) {
	      var x = parseFloat(e.target.value);
	      _this.setState({ position: _extends({}, _this.state.position, { x: x }) });
	    };
	
	    _this.handleYPosition = function (e) {
	      var y = parseFloat(e.target.value);
	      _this.setState({ position: _extends({}, _this.state.position, { y: y }) });
	    };
	
	    _this.handleWidth = function (e) {
	      var width = parseInt(e.target.value);
	      _this.setState({ width: width });
	    };
	
	    _this.handleHeight = function (e) {
	      var height = parseInt(e.target.value);
	      _this.setState({ height: height });
	    };
	
	    _this.setEditorRef = function (editor) {
	      if (editor) _this.editor = editor;
	    };
	
	    _this.handlePositionChange = function (position) {
	      _this.props.clearAttachedProductImage();
	      _this.setState({ position: position });
	    };
	
	    _this.state = {
	      position: { x: 0.5, y: 0.5 },
	      scale: 1,
	      rotate: 0,
	      borderRadius: 0,
	      preview: null,
	      width: 60,
	      height: 60
	    };
	    return _this;
	  }
	
	  _createClass(Editor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ width: this.props.width, height: this.props.height });
	    }
	  }, {
	    key: 'logCallback',
	    value: function logCallback(e) {}
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'editor' },
	        _react2.default.createElement(_reactAvatarEditor2.default, {
	          ref: this.setEditorRef,
	          scale: parseFloat(this.state.scale),
	          width: this.state.width,
	          height: this.state.height,
	          position: this.state.position,
	          onPositionChange: this.handlePositionChange,
	          rotate: parseFloat(this.state.rotate),
	          borderRadius: this.state.borderRadius,
	          border: 10,
	          onSave: this.handleSave,
	          onLoadFailure: this.logCallback.bind(this, 'onLoadFailed'),
	          onLoadSuccess: this.logCallback.bind(this, 'onLoadSuccess'),
	          onImageReady: this.logCallback.bind(this, 'onImageReady'),
	          onImageLoad: this.logCallback.bind(this, 'onImageLoad'),
	          onDropFile: this.logCallback.bind(this, 'onDropFile'),
	          image: this.props.image
	        }),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement('input', {
	            style: { display: 'inline-flex' },
	            name: 'scale',
	            type: 'range',
	            onChange: this.handleScale,
	            min: '1',
	            max: '2',
	            step: '0.01',
	            defaultValue: '1'
	          }),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'success',
	              onClick: this.handleSave
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Editor;
	}(_react2.default.Component);
	
	// Used to display the cropping rect
	
	
	var ImageWithRect = function (_React$Component2) {
	  _inherits(ImageWithRect, _React$Component2);
	
	  function ImageWithRect(props) {
	    _classCallCheck(this, ImageWithRect);
	
	    var _this2 = _possibleConstructorReturn(this, (ImageWithRect.__proto__ || Object.getPrototypeOf(ImageWithRect)).call(this, props));
	
	    _this2.setCanvas = _this2.setCanvas.bind(_this2);
	    _this2.handleImageLoad = _this2.handleImageLoad.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(ImageWithRect, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.redraw();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.redraw();
	    }
	  }, {
	    key: 'setCanvas',
	    value: function setCanvas(canvas) {
	      if (canvas) this.canvas = canvas;
	    }
	  }, {
	    key: 'handleImageLoad',
	    value: function handleImageLoad() {
	      var ctx = this.canvas.getContext('2d');
	      var _props = this.props,
	          image = _props.image,
	          rect = _props.rect,
	          width = _props.width,
	          height = _props.height;
	
	
	      ctx.clearRect(0, 0, width, height);
	
	      ctx.strokeStyle = 'red';
	
	      if (rect && (rect.width > 1 || rect.height > 1)) {
	        ctx.drawImage(this.imgElement, Math.round(-rect.x * (width / rect.width)), Math.round(-rect.y * (height / rect.height)), Math.round(width / rect.width), Math.round(height / rect.height));
	
	        if (rect) {
	          ctx.strokeRect(1, 1, Math.round(width) - 2, Math.round(height) - 2);
	        }
	      } else {
	        ctx.drawImage(this.imgElement, 0, 0, width, height);
	
	        if (rect) {
	          ctx.strokeRect(Math.round(rect.x * width) + 0.5, Math.round(rect.y * height) + 0.5, Math.round(rect.width * width), Math.round(rect.height * height));
	        }
	      }
	    }
	  }, {
	    key: 'redraw',
	    value: function redraw() {
	      var img = new Image();
	
	      img.src = this.props.image;
	      img.onload = this.handleImageLoad;
	      this.imgElement = img;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('canvas', {
	        ref: this.setCanvas,
	        style: this.props.style,
	        width: this.props.width,
	        height: this.props.height
	      });
	    }
	  }]);
	
	  return ImageWithRect;
	}(_react2.default.Component);
	
	var _default = Editor;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Editor, 'Editor', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/Editor.jsx');
	
	  __REACT_HOT_LOADER__.register(ImageWithRect, 'ImageWithRect', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/Editor.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/Editor.jsx');
	}();

	;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDropzone = __webpack_require__(45);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var propTypes = {
	  dependentValues: _propTypes2.default.shape({
	    Name: _propTypes2.default.string,
	    Description: _propTypes2.default.string,
	    Index: _propTypes2.default.number
	  }),
	  showImageOnly: _propTypes2.default.bool,
	  renderImage: _propTypes2.default.func,
	  onRowValueChange: _propTypes2.default.func,
	  onDrop: _propTypes2.default.func
	};
	
	var defaultProps = {
	  showImageOnly: true,
	  dependentValues: {},
	  renderImage: function renderImage() {},
	  onRowValueChange: function onRowValueChange() {},
	  onDrop: function onDrop() {}
	};
	
	var Category2ImageFormatterB2B = _react2.default.createClass({
	  displayName: 'Category2ImageFormatterB2B',
	  getInitialState: function getInitialState() {
	    return {
	      name: '',
	      description: ''
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    var _props$dependentValue = this.props.dependentValues,
	        Name = _props$dependentValue.Name,
	        Description = _props$dependentValue.Description;
	
	    var name = Name || '';
	    var description = Description || '';
	    this.setState({ name: name, description: description });
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.dependentValues && nextProps.dependentValues !== this.props.dependentValues) {
	      var _nextProps$dependentV = nextProps.dependentValues,
	          Name = _nextProps$dependentV.Name,
	          Description = _nextProps$dependentV.Description;
	
	      var name = Name || '';
	      var description = Description || '';
	      this.setState({ name: name, description: description });
	    }
	  },
	  onChange: function onChange(event, field) {
	    this.setState(_defineProperty({}, field, event.target.value));
	  },
	  render: function render() {
	    var _this = this;
	
	    var Index = this.props.dependentValues.Index;
	
	    return _react2.default.createElement(
	      'div',
	      { className: !this.props.showImageOnly ? 'category2-thumbnail-cell' : 'group-thumbnail-cell' },
	      _react2.default.createElement(
	        'div',
	        { id: 'image-container' },
	        this.props.renderImage(Index)
	      ),
	      _react2.default.createElement(
	        _reactDropzone2.default,
	        {
	          onDrop: this.props.onDrop.bind(Index, this),
	          className: 'image-dropzone',
	          accept: 'image/*'
	        },
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                id: 'dropzone-button',
	                bsStyle: 'primary',
	                type: 'button'
	              },
	              _react2.default.createElement('em', { className: 'fa fa-plus' })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        !this.props.showImageOnly && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'name' },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                name: 'name',
	                placeholder: _reactReduxI18n.I18n.t('name'),
	                value: this.state.name,
	                onChange: function onChange(event) {
	                  return _this.onChange(event, event.target.name);
	                },
	                onBlur: function onBlur(event) {
	                  return _this.props.onRowValueChange(event, _this.props.dependentValues, 'Name');
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'description' },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                name: 'description',
	                placeholder: _reactReduxI18n.I18n.t('description'),
	                value: this.state.description,
	                onChange: function onChange(event) {
	                  return _this.onChange(event, event.target.name);
	                },
	                onBlur: function onBlur(event) {
	                  return _this.props.onRowValueChange(event, _this.props.dependentValues, 'Description');
	                }
	              })
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	Category2ImageFormatterB2B.propTypes = propTypes;
	Category2ImageFormatterB2B.defaultProps = defaultProps;
	
	var _default = Category2ImageFormatterB2B;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/ImageFormatterB2B.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/ImageFormatterB2B.jsx');
	
	  __REACT_HOT_LOADER__.register(Category2ImageFormatterB2B, 'Category2ImageFormatterB2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/ImageFormatterB2B.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/ImageFormatterB2B.jsx');
	}();

	;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactAutosuggest = __webpack_require__(85);
	
	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
	
	var _reactIsolatedScroll = __webpack_require__(87);
	
	var _reactIsolatedScroll2 = _interopRequireDefault(_reactIsolatedScroll);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _autoSuggest_actions = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MixProductAutoSuggest = function (_Component) {
	  _inherits(MixProductAutoSuggest, _Component);
	
	  function MixProductAutoSuggest() {
	    _classCallCheck(this, MixProductAutoSuggest);
	
	    var _this = _possibleConstructorReturn(this, (MixProductAutoSuggest.__proto__ || Object.getPrototypeOf(MixProductAutoSuggest)).call(this));
	
	    _this.onChange = function (event, _ref) {
	      var newValue = _ref.newValue;
	
	      _this.setState({ value: newValue });
	    };
	
	    _this.onSuggestionsFetchRequested = function (_ref2) {
	      var value = _ref2.value;
	
	      _this.loadSuggestions(value);
	    };
	
	    _this.onSuggestionsClearRequested = function () {
	      _this.setState({ suggestions: [] });
	    };
	
	    _this.onKeyPress = function () {
	      false;
	    };
	
	    _this.onSuggestionSelected = function (event, _ref3) {
	      var suggestion = _ref3.suggestion;
	
	      event.stopPropagation();
	      event.preventDefault();
	      _this.props.handleFocusQty(suggestion);
	    };
	
	    _this.getSuggestionValue = function (suggestion) {
	      switch (_this.props.SearchType) {
	        case 'ProductNum':
	          return suggestion.ProductNum + ' | ' + suggestion.Name;
	        case 'RefNum':
	          return suggestion.RefNum + ' | ' + suggestion.Name;
	        case 'Name':
	          return suggestion.Name;
	        case 'Description':
	          return suggestion.Description + ' | ' + suggestion.Name;
	
	        default:
	          return null;
	      }
	    };
	
	    _this.renderSuggestion = function (suggestion) {
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        _defineProperty({ className: 'suggestion', id: 'suggestion-render' }, 'className', 'sales-auto-suggest-suggestions'),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _this.renderSearchTypeValue(suggestion)
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 5 },
	          suggestion.Name
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 5 },
	          suggestion.Description
	        )
	      );
	    };
	
	    _this.renderSearchTypeHeader = function () {
	      switch (_this.props.SearchType) {
	        case 'ProductNum':
	          return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' });
	        default:
	          return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' });
	      }
	    };
	
	    _this.renderSuggestionsContainer = function (_ref4) {
	      var containerProps = _ref4.containerProps,
	          children = _ref4.children;
	
	      var ref = containerProps.ref,
	          restContainerProps = _objectWithoutProperties(containerProps, ['ref']);
	
	      var callRef = function callRef(scrollingDiv) {
	        if (scrollingDiv !== null) {
	          ref(scrollingDiv.component);
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        restContainerProps,
	        _react2.default.createElement(
	          'div',
	          { className: 'container', style: { width: '100%' }, id: 'suggestion-container' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { style: { padding: '10px 5px', margin: '0px' }, className: 'sales-auto-suggest-suggestions', id: 'sales-auto-suggest-header' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 2 },
	              _this.renderSearchTypeHeader()
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 5 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 5 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactIsolatedScroll2.default,
	          { style: { height: '200px' }, id: 'suggestions-customer-container', ref: callRef },
	          children
	        )
	      );
	    };
	
	    _this.state = {
	      value: '',
	      suggestions: [],
	      // isLoading: false,
	      noSuggestions: false
	    };
	
	    _this.lastRequestId = null;
	    return _this;
	  }
	
	  _createClass(MixProductAutoSuggest, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var isInputBlank = nextProps.value === '';
	      var noSuggestions = !isInputBlank && nextProps.purchaseOrderSuggestions.length === 0;
	      this.setState({ noSuggestions: noSuggestions });
	      if (nextProps.purchaseOrderSuggestions !== this.props.purchaseOrderSuggestions) {
	        this.setState({ suggestions: [].concat(_toConsumableArray(nextProps.purchaseOrderSuggestions.slice(0, 200))) });
	      }
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus(event) {
	      event.target.select();
	    }
	  }, {
	    key: 'loadSuggestions',
	    value: function loadSuggestions(value) {
	      this.props.fetchPurchaseOrderSuggestions(this.props.SearchType, value);
	    }
	  }, {
	    key: 'renderErrorMessage',
	    value: function renderErrorMessage() {
	      var noSuggestions = this.state.noSuggestions;
	
	      if (noSuggestions && !this.props.purchaseOrderSuggestionsIsLoading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'no-suggestions' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no_data_found' })
	        );
	      }
	      return _react2.default.createElement('div', null);
	    }
	  }, {
	    key: 'renderSearchTypeValue',
	    value: function renderSearchTypeValue(suggestion) {
	      switch (this.props.SearchType) {
	        case 'ProductNum':
	          return suggestion.ProductNum;
	        default:
	          return suggestion.RefNum;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var suggestions = this.state.suggestions;
	
	      var inputProps = {
	        value: this.props.value,
	        onChange: this.props.onChange,
	        onKeyPress: this.onKeyPress,
	        onFocus: this.onFocus,
	        id: 'purchase-auto-suggest'
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactAutosuggest2.default, {
	          suggestions: suggestions,
	          onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
	          onSuggestionsClearRequested: this.onSuggestionsClearRequested,
	          focusInputOnSuggestionClick: false,
	          getSuggestionValue: this.getSuggestionValue,
	          renderSuggestion: this.renderSuggestion,
	          renderSuggestionsContainer: this.renderSuggestionsContainer,
	          onSuggestionSelected: this.onSuggestionSelected,
	          highlightFirstSuggestion: true,
	          inputProps: inputProps
	        }),
	        this.renderErrorMessage()
	      );
	    }
	  }]);
	
	  return MixProductAutoSuggest;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    purchaseOrderSuggestions: state.autoSuggest.purchaseOrderSuggestions,
	    purchaseOrderSuggestionsIsLoading: state.autoSuggest.purchaseOrderSuggestionsIsLoading,
	    purchaseOrderSuggestionsError: state.autoSuggest.purchaseOrderSuggestionsError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchPurchaseOrderSuggestions: _autoSuggest_actions.fetchPurchaseOrderSuggestions })(MixProductAutoSuggest);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/MixProductAutoSuggest.jsx');
	
	  __REACT_HOT_LOADER__.register(MixProductAutoSuggest, 'MixProductAutoSuggest', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/MixProductAutoSuggest.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/MixProductAutoSuggest.jsx');
	}();

	;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MixProductTypeRadios = _react2.default.createClass({
	  displayName: 'MixProductTypeRadios',
	  render: function render() {
	    return _react2.default.createElement(
	      _reactBootstrap.Row,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 4 },
	        _react2.default.createElement(
	          'label',
	          { style: { paddingLeft: '0px' }, className: 'col-xs-4 search-by-max-width' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'search_type' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'form-group', id: 'search-product-by' },
	        _react2.default.createElement(
	          'label',
	          { className: 'col-xs-3 pl' },
	          _react2.default.createElement('input', {
	            type: 'radio',
	            value: 'RefNum',
	            onChange: this.props.handleOptionChange,
	            checked: this.props.value === 'RefNum'
	          }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' })
	        ),
	        _react2.default.createElement(
	          'label',
	          { className: 'col-xs-3' },
	          _react2.default.createElement('input', {
	            type: 'radio',
	            value: 'Name',
	            onChange: this.props.handleOptionChange,
	            checked: this.props.value === 'Name'
	          }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	        )
	      )
	    );
	  }
	});
	
	var _default = MixProductTypeRadios;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(MixProductTypeRadios, 'MixProductTypeRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/MixProductTypeRadios.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/MixProductTypeRadios.jsx');
	}();

	;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MultiBatchModal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _dateFormat = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Selectors = _reactDataGridAddons.Data.Selectors;
	
	var MultiBatchModal = exports.MultiBatchModal = function (_Component) {
	  _inherits(MultiBatchModal, _Component);
	
	  function MultiBatchModal() {
	    _classCallCheck(this, MultiBatchModal);
	
	    var _this = _possibleConstructorReturn(this, (MultiBatchModal.__proto__ || Object.getPrototypeOf(MultiBatchModal)).call(this));
	
	    _this.initializeModal = function (array) {
	      var index = 0;
	      var formatter = [];
	      if (array && array.length > 0) {
	        array.map(function (r) {
	          formatter.push({
	            Idx: index++,
	            batchId: r.id,
	            quantity: "0",
	            expire_datetime: r.expire_datetime,
	            batch_num: r.batch_num,
	            pallet_barcode: r.pallet_barcode,
	            location: r.location,
	            availableQty: r.quantity
	          });
	        });
	      } else {
	        formatter.push({
	          Idx: 0,
	          batchId: null,
	          quantity: "0",
	          expire_datetime: null,
	          batch_num: null,
	          location: null,
	          pallet_barcode: null,
	          availableQty: null
	        });
	      }
	      _this.setState({
	        rows: formatter,
	        selectedRows: [],
	        editedRows: []
	      });
	    };
	
	    _this.handleOnSubmit = function (e) {
	      var rows = _this.state.rows;
	
	      _this.props.onSelectedMultiBatch(rows);
	    };
	
	    _this.state = {
	      rows: [],
	      selectedRows: null,
	      editedRows: [],
	      filters: {},
	      quantityRemaining: 0
	    };
	    return _this;
	  }
	
	  _createClass(MultiBatchModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.batchesInfo) {
	        this.initializeModal(this.props.batchesInfo.batches);
	        this.setState({ quantityRemaining: this.props.quantityValue });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.quantityValue) {
	        this.setState({ quantityRemaining: Number(nextProps.quantityValue) });
	      }
	      if (this.props.batchesInfo.batches !== nextProps.batchesInfo.batches) {
	        this.initializeModal(nextProps.batchesInfo.batches);
	      }
	    }
	  }, {
	    key: 'onClickAddAll',
	    value: function onClickAddAll(idx) {
	      var _state = this.state,
	          rows = _state.rows,
	          quantityRemaining = _state.quantityRemaining;
	
	      rows.map(function (r, index) {
	        if (r.Idx === idx) {
	          quantityRemaining = Number(quantityRemaining) + Number(rows[index].quantity);
	          if (r.availableQty <= quantityRemaining) {
	            rows[index].quantity = r.availableQty;
	            quantityRemaining = Number(quantityRemaining) - Number(r.availableQty);
	          } else {
	            rows[index].quantity = quantityRemaining;
	            quantityRemaining = 0;
	          }
	        }
	      });
	      this.setState({ rows: rows, quantityRemaining: quantityRemaining });
	    }
	  }, {
	    key: 'onClickRemoveAll',
	    value: function onClickRemoveAll(idx) {
	      var _state2 = this.state,
	          rows = _state2.rows,
	          quantityRemaining = _state2.quantityRemaining;
	
	      rows.map(function (r, index) {
	        if (r.Idx === idx) {
	          quantityRemaining = Number(quantityRemaining) + Number(rows[index].quantity);
	          rows[index].quantity = 0;
	        }
	      });
	      this.setState({ rows: rows, quantityRemaining: quantityRemaining });
	    }
	  }, {
	    key: 'renderAgentTable',
	    value: function renderAgentTable() {
	      var _this2 = this,
	          _ref2;
	
	      var getRows = function getRows() {
	        return Selectors.getRows(_this2.state);
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        _this2.setState({ sortColumn: null, sortDirection: null });
	        var quantityRemaining = _this2.state.quantityRemaining;
	
	        var rows = getRows();
	        var editedRows = _this2.state.editedRows.slice(0);
	
	        if (e.updated && e.updated.quantity > rows[e.rowIdx].availableQty) {
	          alert("Cannot exceed available quantity.");
	          return;
	        } else if (Number(e.updated.quantity) < Number(rows[e.rowIdx].quantity)) {
	          _this2.setState({ quantityRemaining: Number(quantityRemaining) + Number(rows[e.rowIdx].quantity) - Number(e.updated.quantity) });
	        } else if (e.updated && Number(e.updated.quantity) > Number(quantityRemaining)) {
	          alert("Cannot exceed remaining quantity.");
	          return;
	        } else if (Number(e.updated.quantity) !== Number(rows[e.rowIdx].quantity)) {
	          _this2.setState({ quantityRemaining: Number(quantityRemaining) + Number(rows[e.rowIdx].quantity) - Number(e.updated.quantity) });
	        }
	
	        Object.assign(rows[e.rowIdx], e.updated);
	        editedRows.forEach(function (element, index) {
	          if (element.Idx === rows[e.rowIdx].Idx) {
	            editedRows.splice(index, 1);
	          }
	        }, _this2);
	        editedRows.push(rows[e.rowIdx]);
	        _this2.setState({
	          rows: rows,
	          editedRows: editedRows
	        });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var selectedRows = [].concat(_toConsumableArray(_this2.state.selectedRows));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	          selectedRows.push(r.row);
	        });
	        _this2.setState({ rows: newRows, selectedRows: selectedRows });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = [].concat(_toConsumableArray(_this2.state.rows));
	        var selectedRows = [].concat(_toConsumableArray(_this2.state.selectedRows));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	          var rowIndex = selectedRows.indexOf(r.row);
	          selectedRows.splice(rowIndex, 1);
	        });
	        _this2.setState({ rows: newRows, selectedRows: selectedRows });
	      };
	
	      var columns = [(_ref2 = {
	        key: 'Idx',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'operation' }),
	        resizable: true,
	        width: 100,
	        formatter: function formatter(_ref) {
	          var value = _ref.value,
	              dependentValues = _ref.dependentValues;
	          return _react2.default.createElement(
	            'div',
	            {
	              style: { width: '100%' }
	            },
	            _react2.default.createElement(
	              'span',
	              { onClick: function onClick() {
	                  _this2.onClickAddAll(value);
	                },
	                style: { cursor: "pointer", color: "green", marginRight: '12px' }
	              },
	              '+All'
	            ),
	            _react2.default.createElement(
	              'span',
	              { onClick: function onClick() {
	                  _this2.onClickRemoveAll(value);
	                },
	                style: { cursor: "pointer", color: "red" }
	              },
	              '-All'
	            )
	          );
	        }
	      }, _defineProperty(_ref2, 'width', 100), _defineProperty(_ref2, 'getRowMetaData', function getRowMetaData(row) {
	        return row;
	      }), _ref2), {
	        key: 'quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        editable: true,
	        width: 90
	      }, {
	        key: 'location',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'availableQty',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'available' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'pallet_barcode',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_barcode' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 120,
	        formatter: _dateFormat.DateFormatter2
	      }, {
	        key: 'batch_num',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 120
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          'label',
	          { style: { color: 'orange', fontSize: '15px' } },
	          'Quantity Remaining: ',
	          this.state.quantityRemaining
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '550px', marginLeft: '25px' } },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              enableCellSelect: true,
	              columns: columns,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: 300,
	              rowHeight: 25,
	              headerRowHeight: 45,
	              onRowUpdated: handleRowUpdated
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          setModalVisibility = _props.setModalVisibility,
	          isVisible = _props.isVisible;
	
	      _objectDestructuringEmpty(this.state);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { className: 'text-center' },
	            _react2.default.createElement(
	              'span',
	              null,
	              this.renderAgentTable()
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'centerStyle', style: { marginTop: '20px' } },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              style: { marginRight: '5px' },
	              bsStyle: 'success',
	              onClick: function onClick(e) {
	                _this3.handleOnSubmit(e);
	              }
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_batches' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return MultiBatchModal;
	}(_react.Component);
	
	var _default = MultiBatchModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(MultiBatchModal, 'MultiBatchModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/MultiBatchModal.jsx');
	
	  __REACT_HOT_LOADER__.register(Selectors, 'Selectors', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/MultiBatchModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/MultiBatchModal.jsx');
	}();

	;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MultiBatchModal2 = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _dateFormat = __webpack_require__(39);
	
	var _NumberUtil = __webpack_require__(67);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Selectors = _reactDataGridAddons.Data.Selectors;
	
	var MultiBatchModal2 = exports.MultiBatchModal2 = function (_Component) {
	  _inherits(MultiBatchModal2, _Component);
	
	  function MultiBatchModal2() {
	    _classCallCheck(this, MultiBatchModal2);
	
	    var _this = _possibleConstructorReturn(this, (MultiBatchModal2.__proto__ || Object.getPrototypeOf(MultiBatchModal2)).call(this));
	
	    _this.initializeModal = function (array) {
	      var index = 0;
	      var formatter = [];
	      if (array && array.length > 0) {
	        array.map(function (r) {
	          formatter.push({
	            Idx: index++,
	            batchId: r.id,
	            quantity: "0",
	            expire_datetime: r.expire_datetime,
	            batch_num: r.batch_num,
	            pallet_barcode: r.pallet_barcode,
	            location: r.location,
	            availableQty: _root_url.isJML ? r.box : r.quantity,
	            pcs: _root_url.isJML ? r.pcs : 0
	          });
	        });
	      } else {
	        formatter.push({
	          Idx: 0,
	          batchId: null,
	          quantity: "0",
	          expire_datetime: null,
	          batch_num: null,
	          location: null,
	          pallet_barcode: null,
	          availableQty: null
	        });
	      }
	      _this.setState({
	        rows: formatter,
	        selectedRows: [],
	        editedRows: []
	      });
	    };
	
	    _this.handleOnSubmit = function (e) {
	      var rows = _this.state.rows;
	
	      // get the selected line
	
	      var selected = _this.props.lineBatchRows.filter(function (item) {
	        return item.Index === _this.props.lineBatchIdx;
	      });
	      // this.props.onEditBatch(this.props.lineBatchRows);
	      _this.props.onSelectedMultiBatch(selected.length >= 1 ? selected[0] : [], rows);
	    };
	
	    _this.state = {
	      rows: [],
	      selectedRows: null,
	      editedRows: [],
	      filters: {},
	      quantityRemaining: 0
	    };
	    return _this;
	  }
	
	  _createClass(MultiBatchModal2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.batchesInfo) {
	        this.initializeModal(this.props.batchesInfo.batches);
	        this.setState({ quantityRemaining: this.props.quantityValue });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.quantityValue) {
	        this.setState({ quantityRemaining: Number(nextProps.quantityValue) });
	      }
	      if (this.props.batchesInfo.batches !== nextProps.batchesInfo.batches) {
	        this.initializeModal(nextProps.batchesInfo.batches);
	      }
	    }
	  }, {
	    key: 'onClickAddAll',
	    value: function onClickAddAll(idx) {
	      var _this2 = this;
	
	      var _state = this.state,
	          rows = _state.rows,
	          quantityRemaining = _state.quantityRemaining;
	
	      rows.map(function (r, index) {
	        if (r.Idx === idx) {
	          quantityRemaining = Number(quantityRemaining) + Number(rows[index].quantity);
	          if (r.availableQty <= quantityRemaining) {
	            if (_root_url.isJML && r.availableQty <= 0 && _this2.props.selectedInventoryRow.IsOverSaleable) {
	              rows[index].quantity = Number(quantityRemaining);
	              quantityRemaining = 0;
	            } else {
	              rows[index].quantity = r.availableQty;
	              quantityRemaining = Number(quantityRemaining) - Number(r.availableQty);
	            }
	          } else {
	            rows[index].quantity = quantityRemaining;
	            quantityRemaining = 0;
	          }
	        }
	      });
	      this.setState({ rows: rows, quantityRemaining: quantityRemaining });
	    }
	  }, {
	    key: 'onClickRemoveAll',
	    value: function onClickRemoveAll(idx) {
	      var _state2 = this.state,
	          rows = _state2.rows,
	          quantityRemaining = _state2.quantityRemaining;
	
	      rows.map(function (r, index) {
	        if (r.Idx === idx) {
	          quantityRemaining = Number(quantityRemaining) + Number(rows[index].quantity);
	          rows[index].quantity = 0;
	        }
	      });
	      this.setState({ rows: rows, quantityRemaining: quantityRemaining });
	    }
	  }, {
	    key: 'renderAgentTable',
	    value: function renderAgentTable() {
	      var _this3 = this,
	          _ref2;
	
	      var getRows = function getRows() {
	        return Selectors.getRows(_this3.state);
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        _this3.setState({ sortColumn: null, sortDirection: null });
	        var quantityRemaining = _this3.state.quantityRemaining;
	
	        var rows = getRows();
	        var editedRows = _this3.state.editedRows.slice(0);
	
	        if (e.updated && e.updated.quantity > rows[e.rowIdx].availableQty && (!_root_url.isJML || _root_url.isJML && !_this3.props.selectedInventoryRow.IsOverSaleable)) {
	          alert("Cannot exceed available quantity.");
	          return;
	        } else if (Number(e.updated.quantity) < Number(rows[e.rowIdx].quantity)) {
	          _this3.setState({ quantityRemaining: Number(quantityRemaining) + Number(rows[e.rowIdx].quantity) - Number(e.updated.quantity) });
	        } else if (e.updated && Number(e.updated.quantity) > Number(quantityRemaining)) {
	          alert("Cannot exceed remaining quantity.");
	          return;
	        } else if (Number(e.updated.quantity) !== Number(rows[e.rowIdx].quantity)) {
	          _this3.setState({ quantityRemaining: Number(quantityRemaining) + Number(rows[e.rowIdx].quantity) - Number(e.updated.quantity) });
	        }
	
	        Object.assign(rows[e.rowIdx], e.updated);
	        editedRows.forEach(function (element, index) {
	          if (element.Idx === rows[e.rowIdx].Idx) {
	            editedRows.splice(index, 1);
	          }
	        }, _this3);
	        editedRows.push(rows[e.rowIdx]);
	        _this3.setState({
	          rows: rows,
	          editedRows: editedRows
	        });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var selectedRows = [].concat(_toConsumableArray(_this3.state.selectedRows));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	          selectedRows.push(r.row);
	        });
	        _this3.setState({ rows: newRows, selectedRows: selectedRows });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = [].concat(_toConsumableArray(_this3.state.rows));
	        var selectedRows = [].concat(_toConsumableArray(_this3.state.selectedRows));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	          var rowIndex = selectedRows.indexOf(r.row);
	          selectedRows.splice(rowIndex, 1);
	        });
	        _this3.setState({ rows: newRows, selectedRows: selectedRows });
	      };
	
	      var columns = [(_ref2 = {
	        key: 'Idx',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'operation' }),
	        resizable: true,
	        width: 100,
	        formatter: function formatter(_ref) {
	          var value = _ref.value,
	              dependentValues = _ref.dependentValues;
	          return _react2.default.createElement(
	            'div',
	            {
	              style: { width: '100%' }
	            },
	            _react2.default.createElement(
	              'span',
	              { onClick: function onClick() {
	                  _this3.onClickAddAll(value);
	                },
	                style: { cursor: "pointer", color: "green", marginRight: '12px' }
	              },
	              '+All'
	            ),
	            _react2.default.createElement(
	              'span',
	              { onClick: function onClick() {
	                  _this3.onClickRemoveAll(value);
	                },
	                style: { cursor: "pointer", color: "red" }
	              },
	              '-All'
	            )
	          );
	        }
	      }, _defineProperty(_ref2, 'width', 100), _defineProperty(_ref2, 'getRowMetaData', function getRowMetaData(row) {
	        return row;
	      }), _ref2), {
	        key: 'quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        editable: true,
	        width: 90
	      }, {
	        key: 'location',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'availableQty',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'available' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }].concat(_toConsumableArray(_root_url.isJML ? [{
	        key: 'pcs',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pc_box' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }] : []), [{
	        key: 'pallet_barcode',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_barcode' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 120,
	        formatter: _dateFormat.DateFormatter2
	      }, {
	        key: 'batch_num',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 120
	      }]);
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          'label',
	          { style: { color: 'orange', fontSize: '15px' } },
	          'Quantity Remaining: ',
	          this.state.quantityRemaining
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: _root_url.isJML ? '600px' : '550px', marginLeft: '25px' } },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              enableCellSelect: true,
	              columns: columns,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: 300,
	              rowHeight: 25,
	              headerRowHeight: 45,
	              onRowUpdated: handleRowUpdated
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          setModalVisibility = _props.setModalVisibility,
	          isVisible = _props.isVisible;
	
	      _objectDestructuringEmpty(this.state);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { className: 'text-center' },
	            _react2.default.createElement(
	              'span',
	              null,
	              this.renderAgentTable()
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'centerStyle', style: { marginTop: '20px' } },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              style: { marginRight: '5px' },
	              bsStyle: 'success',
	              onClick: function onClick(e) {
	                _this4.handleOnSubmit(e);
	              }
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_batches' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return MultiBatchModal2;
	}(_react.Component);
	
	var _default = MultiBatchModal2;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(MultiBatchModal2, 'MultiBatchModal2', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/MultiBatchModal2.jsx');
	
	  __REACT_HOT_LOADER__.register(Selectors, 'Selectors', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/MultiBatchModal2.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/MultiBatchModal2.jsx');
	}();

	;

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = printError;
	function printError(err) {
	  var reader = new FileReader();
	  reader.onload = function () {
	    alert(reader.result);
	  };
	  // Start reading the blob as text.
	  reader.readAsText(err.data);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(printError, "printError", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/PrintError.jsx");
	}();

	;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isFunction = __webpack_require__(844);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  onDoubleClick: _propTypes2.default.func,
	  value: _propTypes2.default.string,
	  dependentValues: _propTypes2.default.shape({})
	};
	
	var defaultProps = {
	  onDoubleClick: undefined,
	  value: '',
	  dependentValues: {}
	};
	
	var ProdNumFormatter = function ProdNumFormatter(props) {
	  return _react2.default.createElement(
	    'span',
	    {
	      onDoubleClick: function onDoubleClick() {
	        if ((0, _isFunction2.default)(props.onDoubleClick)) {
	          if ((0, _permissions2.default)('change_product')) {
	            props.onDoubleClick(props.dependentValues);
	          } else {
	            alert(_reactReduxI18n.I18n.t('msg_no_permission'));
	          }
	        }
	      }
	    },
	    _react2.default.createElement(
	      'span',
	      { style: { color: '#585858' } },
	      props.value.slice(0, 2)
	    ),
	    _react2.default.createElement(
	      'span',
	      { style: { color: '#0B609F' } },
	      props.value.slice(2, 4)
	    ),
	    _react2.default.createElement(
	      'span',
	      { style: { color: 'black' } },
	      props.value.slice(4, 7)
	    ),
	    _react2.default.createElement(
	      'span',
	      { style: { color: 'black' } },
	      props.value.slice(7)
	    )
	  );
	};
	
	ProdNumFormatter.propTypes = propTypes;
	ProdNumFormatter.defaultProps = defaultProps;
	
	var _default = ProdNumFormatter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/ProdNumFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/ProdNumFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(ProdNumFormatter, 'ProdNumFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/ProdNumFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/ProdNumFormatter.jsx');
	}();

	;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShippingInfoConfirmModal = function (_Component) {
	  _inherits(ShippingInfoConfirmModal, _Component);
	
	  function ShippingInfoConfirmModal() {
	    _classCallCheck(this, ShippingInfoConfirmModal);
	
	    // this.state = {
	    //   shippingInfo: props.shippingInfo,
	    //   selectedAddressId: props.selectedAddressId,
	    // };
	    var _this = _possibleConstructorReturn(this, (ShippingInfoConfirmModal.__proto__ || Object.getPrototypeOf(ShippingInfoConfirmModal)).call(this));
	
	    _this.handleInputFieldChange = function (_ref) {
	      var name = _ref.name,
	          value = _ref.value;
	      return _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.handleSubmit = function () {};
	
	    _this.showSelectedShippingAddress = function () {
	      var address = '';
	      if (!_this.props.salesShippingCustomerDetails || !_this.props.salesShippingCustomerDetails.Shipping || !_this.props.CustomerDetail_id) {
	        return 'No shipping information found!';
	      }
	      var CustomerDetail_id = _this.props.CustomerDetail_id.value || _this.props.CustomerDetail_id;
	      _this.props.salesShippingCustomerDetails.Shipping.forEach(function (shippingAddress) {
	        if (shippingAddress.CustomerDetail_id === CustomerDetail_id) {
	          return address = (shippingAddress.AddressName || '') + " " + (shippingAddress.Street || '') + " " + (shippingAddress.City || '') + " " + (shippingAddress.State || '') + " " + (shippingAddress.Zip || '');
	        }
	      });
	      return address;
	    };
	
	    return _this;
	  }
	
	  _createClass(ShippingInfoConfirmModal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          handleReturnClick = _props.handleReturnClick,
	          handleSaveClick = _props.handleSaveClick;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            "h4",
	            null,
	            "This Sales Order will Be Shippied To: ",
	            this.showSelectedShippingAddress()
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: "centerStyle", style: { marginTop: "40px" } },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: "primary",
	              className: "mr-1",
	              onClick: function onClick(e) {
	                handleReturnClick();
	              }
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "return" })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: "success",
	              style: { marginLeft: '20px' },
	              disabled: !this.props.CustomerDetail_id,
	              onClick: function onClick(e) {
	                handleSaveClick();
	              }
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "save" })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ShippingInfoConfirmModal;
	}(_react.Component);
	
	var _default = ShippingInfoConfirmModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ShippingInfoConfirmModal, "ShippingInfoConfirmModal", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/ShippingInfoConfirmModal.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/ShippingInfoConfirmModal.jsx");
	}();

	;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SplitTrackingNumberModal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isAFG = _root_url.ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afgstage-scm.truckxi.com/api/';
	var isJML = _root_url.ROOT_API_URL === "https://jml-scm.truckxi.com/api/";
	var isSY = _root_url.ROOT_API_URL === 'https://admin.apoodr.com/api/';
	
	var Selectors = _reactDataGridAddons.Data.Selectors;
	
	var SplitTrackingNumberModal = exports.SplitTrackingNumberModal = function (_Component) {
	    _inherits(SplitTrackingNumberModal, _Component);
	
	    function SplitTrackingNumberModal() {
	        _classCallCheck(this, SplitTrackingNumberModal);
	
	        var _this = _possibleConstructorReturn(this, (SplitTrackingNumberModal.__proto__ || Object.getPrototypeOf(SplitTrackingNumberModal)).call(this));
	
	        _this.initializeModal = function (data) {
	            var index = 0;
	            var formatter = [];
	            var trackString = "";
	            if (data) {
	                if (data.weights) {
	                    data.weights.map(function (r) {
	                        formatter.push({ Idx: index, Package_Weight: r.weight, Package_Note: r.note, Package_Tracking: r.tracking, Package_Service: r.service, Package_Tracking_Link: r.tracking_link });
	                        if (!trackString) {
	                            trackString += String(r.tracking);
	                        } else {
	                            trackString += ',' + String(r.tracking);
	                        }
	                        index++;
	                    });
	                } else {
	                    formatter.push({ Idx: 0, Package_Weight: "", Package_Note: "", Package_Tracking: "", Package_Service: "", Package_Tracking_Link: "" });
	                }
	            }
	            _this.setState({
	                rows: formatter,
	                selectedRows: null,
	                editedRows: [],
	                trackString: trackString
	            });
	        };
	
	        _this.onTrackingNumRouter = function (trackingNum) {
	            var url = 'https://www.fedex.com/apps/fedextrack/?tracknumbers=' + trackingNum;
	            var win = window.open(url);
	            if (win != null) {
	                win.focus();
	            }
	        };
	
	        _this.onTrackingNumRouterJML = function (dependentValues) {
	            var url = '' + dependentValues.track_url;
	            var win = window.open(url);
	            if (win != null) {
	                win.focus();
	            }
	        };
	
	        _this.trackAll = function (e) {
	            e.preventDefault();
	            var url = 'https://www.fedex.com/apps/fedextrack/?tracknumbers=' + _this.state.trackString;
	            var win = window.open(url);
	            if (win != null) {
	                win.focus();
	            }
	        };
	
	        _this.jmlPrint = function (e) {
	            e.preventDefault();
	            _this.props.jmlPrintLabel(_this.props.salesOrderId);
	            setTimeout(function () {
	                _this.props.fetchJmlTracking(_this.props.salesOrderId).then(function (response) {
	                    if (response.data) {
	                        _this.setState({ rows: response.data });
	                    }
	                }, function (err) {
	                    if (err.status === 500 || err.status === 404) {
	                        alert("Server error, please refresh page. If problem persists, contact administrator.");
	                    }
	                });
	            }, 7000);
	        };
	
	        _this.state = {
	            rows: [],
	            selectedRows: null,
	            editedRows: [],
	            filters: {},
	
	            trackString: ""
	        };
	        return _this;
	    }
	
	    _createClass(SplitTrackingNumberModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            if (isAFG) {
	                this.props.fetchShippingWeightTracking(this.props.salesOrderId).then(function (response) {
	                    if (response.data) {
	                        _this2.initializeModal(response.data);
	                    }
	                }, function (err) {
	                    if (err.status === 500 || err.status === 404) {
	                        alert("Server error, please refresh page. If problem persists, contact administrator.");
	                    }
	                });
	            }
	            if (isJML || isSY) {
	                this.props.fetchJmlTracking(this.props.salesOrderId).then(function (response) {
	                    if (response.data) {
	                        _this2.setState({ rows: response.data });
	                    }
	                }, function (err) {
	                    if (err.status === 500 || err.status === 404) {
	                        alert("Server error, please refresh page. If problem persists, contact administrator.");
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	    }, {
	        key: 'renderTrackingTable',
	        value: function renderTrackingTable() {
	            var _this3 = this;
	
	            var getRows = function getRows() {
	                return Selectors.getRows(_this3.state);
	            };
	            var getSize = function getSize() {
	                return getRows().length;
	            };
	            var rowGetter = function rowGetter(rowIdx) {
	                var rows = getRows();
	                return rows[rowIdx];
	            };
	
	            var columns = isAFG ? [{
	                key: 'Package_Tracking',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tracking_num' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 200,
	                formatter: function formatter(_ref) {
	                    var value = _ref.value;
	                    return _react2.default.createElement(
	                        'div',
	                        {
	                            style: { width: '100%', height: '100%' },
	                            onDoubleClick: function onDoubleClick() {
	                                _this3.onTrackingNumRouter(value);
	                            }
	                        },
	                        value
	                    );
	                }
	            }, {
	                key: 'Package_Weight',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight_lbs' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 150
	            }, {
	                key: 'Package_Service',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'service' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 150
	            }, {
	                key: 'Package_Tracking_Link',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tracking_link' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 200,
	                formatter: function formatter(_ref2) {
	                    var value = _ref2.value;
	
	                    return _react2.default.createElement(
	                        'a',
	                        {
	                            target: '_blank',
	                            href: value
	                        },
	                        value
	                    );
	                }
	            }, {
	                key: 'Package_Note',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 350
	            }] : [{
	                key: 'tracking',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tracking_num' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 325,
	                formatter: function formatter(_ref3) {
	                    var value = _ref3.value,
	                        dependentValues = _ref3.dependentValues;
	                    return _react2.default.createElement(
	                        'div',
	                        {
	                            style: { width: '100%', height: '100%' },
	                            onDoubleClick: function onDoubleClick() {
	                                _this3.onTrackingNumRouterJML(dependentValues);
	                            }
	                        },
	                        value
	                    );
	                },
	                getRowMetaData: function getRowMetaData(row) {
	                    return row;
	                }
	            },
	            // {
	            //     key: 'service_code',
	            //     name: <Translate value="service_code" />,
	            //     resizable: true,
	            //     sortable: true,
	            //     filterable: true,
	            //     width: 325,
	            // },
	            {
	                key: 'carrier_code',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier_code' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 325
	            }];
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { style: { maxWidth: '650px', marginLeft: '25px' } },
	                        _react2.default.createElement(_reactDataGrid2.default, {
	                            enableCellSelect: true,
	                            columns: columns,
	                            rowGetter: rowGetter,
	                            rowsCount: getSize(),
	                            minHeight: 150,
	                            rowHeight: 25
	                        })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: 'text-center' },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            this.renderTrackingTable()
	                        )
	                    )
	                ),
	                (isJML || isSY) && _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'centerStyle', style: { marginTop: '15px' } },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'primary',
	                            onClick: function onClick(e) {
	                                _this4.jmlPrint(e);
	                            }
	                        },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_new_label' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SplitTrackingNumberModal;
	}(_react.Component);
	
	var _default = SplitTrackingNumberModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(SplitTrackingNumberModal, 'SplitTrackingNumberModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/SplitTrackingNumberModal.jsx');
	
	    __REACT_HOT_LOADER__.register(isAFG, 'isAFG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/SplitTrackingNumberModal.jsx');
	
	    __REACT_HOT_LOADER__.register(isJML, 'isJML', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/SplitTrackingNumberModal.jsx');
	
	    __REACT_HOT_LOADER__.register(isSY, 'isSY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/SplitTrackingNumberModal.jsx');
	
	    __REACT_HOT_LOADER__.register(Selectors, 'Selectors', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/SplitTrackingNumberModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/SplitTrackingNumberModal.jsx');
	}();

	;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _reactNotificationSystem = __webpack_require__(103);
	
	var _reactNotificationSystem2 = _interopRequireDefault(_reactNotificationSystem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TuiEditor = function (_React$Component) {
	  _inherits(TuiEditor, _React$Component);
	
	  function TuiEditor() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TuiEditor);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TuiEditor.__proto__ || Object.getPrototypeOf(TuiEditor)).call.apply(_ref, [this].concat(args))), _this), _this.editor = null, _this._notificationSystem = null, _this.handleAddNotification = function (title, level) {
	      _this.refs.notificationSystem.addNotification({
	        title: _react2.default.createElement(_reactReduxI18n.Translate, { value: title }),
	        level: level
	      });
	    }, _this.handleSave = function () {
	      _this.props.saveHtml(_this.editor.getHTML());
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TuiEditor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var Editor = window.toastui.Editor;
	      var colorSyntax = Editor.plugin.colorSyntax;
	
	      this.editor = new Editor({
	        el: document.querySelector('#tui-editor'),
	        height: '400px',
	        initialValue: this.props.htmlString,
	        initialEditType: 'wysiwyg',
	        previewStyle: 'tab',
	        customHTMLSanitizer: function customHTMLSanitizer(html) {
	          return html;
	        },
	        change: function change() {},
	        plugins: [colorSyntax]
	      });
	      this._notificationSystem = this.refs.notificationSystem;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.editor !== null) {
	        this.editor.destroy();
	        this.editor = null;
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps, nextContext) {
	      if (nextProps.saveSuccess && nextProps.saveSuccess !== this.props.saveSuccess) {
	        this.handleAddNotification('save_successful', 'success');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = {
	        NotificationItem: { // Override the notification item
	          DefaultStyle: { // Applied to every notification, regardless of the notification level
	            margin: '10px 5px 2px 1px'
	          },
	          success: { // Applied only to the success notification item
	            color: 'red'
	          }
	        }
	      };
	      return _react2.default.createElement(
	        'div',
	        { id: 'tui-text-editor' },
	        _react2.default.createElement('div', { id: 'tui-editor' }),
	        _react2.default.createElement(_SpinnerButton2.default, {
	          bsStyle: 'success',
	          className: 'save-button-right',
	          onClick: this.handleSave,
	          disabled: this.props.isLoadingSave,
	          loading: this.props.isLoadingSave,
	          icon: 'fa-save',
	          translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	        }),
	        _react2.default.createElement(_reactNotificationSystem2.default, { ref: 'notificationSystem', style: style })
	      );
	    }
	  }]);
	
	  return TuiEditor;
	}(_react2.default.Component);
	
	var _default = TuiEditor;
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TuiEditor, 'TuiEditor', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/TuiEditor.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/TuiEditor.jsx');
	}();

	;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AgentChangeModal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Selectors = _reactDataGridAddons.Data.Selectors;
	
	var AgentChangeModal = exports.AgentChangeModal = function (_Component) {
	    _inherits(AgentChangeModal, _Component);
	
	    function AgentChangeModal() {
	        _classCallCheck(this, AgentChangeModal);
	
	        var _this = _possibleConstructorReturn(this, (AgentChangeModal.__proto__ || Object.getPrototypeOf(AgentChangeModal)).call(this));
	
	        _this.initializeModal = function (array) {
	            var index = 0;
	            var formatter = [];
	            if (array && array.length > 0) {
	                array.map(function (r) {
	                    formatter.push({ Idx: index++, customer: r.customer, id: r.id, name: r.name, note: r.note, ref_num: r.ref_num });
	                });
	            } else {
	                formatter.push({ Idx: 0, name: "", note: "", customer: _this.props.fjCustomerId });
	            }
	            _this.setState({
	                rows: formatter,
	                selectedRows: [],
	                editedRows: []
	            });
	        };
	
	        _this.handleOnSave = function (e) {
	            e.preventDefault();
	            _this.state.rows.map(function (r) {
	                // r.recreate = false;
	            });
	            _this.props.updateFJAgents(_this.props.fjCustomerId, _this.state.rows).then(function (response) {
	                // alert(JSON.stringify(response.data));
	                alert("Agents Saved");
	                _this.props.closeAgentModal();
	            }, function (err) {
	                if (err.status === 500 || err.status === 404) {
	                    alert(JSON.stringify(err.data));
	                }
	            });
	            // this.props.onSave(this.state.rows);
	        };
	
	        _this.state = {
	            rows: [],
	            selectedRows: null,
	            editedRows: [],
	            filters: {}
	
	        };
	        return _this;
	    }
	
	    _createClass(AgentChangeModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.props.fetchFJAgents(this.props.fjCustomerId).then(function (response) {
	                if (response.data) {
	                    _this2.initializeModal(response.data);
	                }
	            }, function (err) {
	                if (err.status === 500 || err.status === 404) {
	                    alert("Server error, please refresh page. If problem persists, contact administrator.");
	                }
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            var rows = Selectors.getRows(this.state);
	            var index = rows.length;
	            var newRow = { name: null, note: null, customer: this.props.fjCustomerId, Idx: index };
	            rows.push(newRow);
	            var editedRows = [].concat(_toConsumableArray(this.state.editedRows));
	            editedRows.push(newRow);
	            this.setState({ rows: rows, editedRows: editedRows });
	        }
	    }, {
	        key: 'deleteCategory',
	        value: function deleteCategory(e) {
	            var _this3 = this;
	
	            e.preventDefault();
	            var rows = [].concat(_toConsumableArray(this.state.rows));
	            var editedRows = [].concat(_toConsumableArray(this.state.editedRows));
	            var index = _.findIndex(rows, { Idx: this.state.selectedRows[0].Idx });
	
	            if (this.state.selectedRows[0].id) {
	                this.props.deleteFJAgents(this.state.selectedRows[0].id).then(function (response) {
	                    alert("Agent Deleted");
	                    rows.splice(index, 1);
	                    index = _.findIndex(editedRows, { Idx: _this3.state.selectedRows[0].Idx });
	                    editedRows.splice(index, 1);
	                    _this3.setState({ rows: rows, editedRows: editedRows, selectedRows: [] });
	                    // this.props.fetchFJAgents(this.props.fjCustomerId).then((response) => {
	                    //     if (response.data) {
	                    //         this.initializeModal(response.data);
	                    //     }
	                    // }, (err) => {
	                    //     if (err.status === 500 || err.status === 404) {
	                    //         alert("Server error, please refresh page. If problem persists, contact administrator.");
	                    //     }
	                    // });
	                }, function (err) {
	                    if (err.status === 500 || err.status === 404 || err.status === 405) {
	                        alert("Error cannot delete agent.");
	                    }
	                });
	            }
	
	            // rows.splice(index, 1);
	            // index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
	            // editedRows.splice(index, 1);
	            // this.setState({ rows, editedRows, selectedRows: [] })
	        }
	    }, {
	        key: 'renderAgentTable',
	        value: function renderAgentTable() {
	            var _this4 = this;
	
	            var getRows = function getRows() {
	                return Selectors.getRows(_this4.state);
	            };
	            var getSize = function getSize() {
	                return getRows().length;
	            };
	            var rowGetter = function rowGetter(rowIdx) {
	                var rows = getRows();
	                return rows[rowIdx];
	            };
	            var handleRowUpdated = function handleRowUpdated(e) {
	                _this4.setState({ sortColumn: null, sortDirection: null });
	                var rows = getRows();
	                var editedRows = _this4.state.editedRows.slice(0);
	                Object.assign(rows[e.rowIdx], e.updated);
	                editedRows.forEach(function (element, index) {
	                    if (element.Idx === rows[e.rowIdx].Idx) editedRows.splice(index, 1);
	                }, _this4);
	                editedRows.push(rows[e.rowIdx]);
	                _this4.setState({
	                    rows: rows,
	                    editedRows: editedRows
	                });
	            };
	            // const onRowsSelected = (rows) => {
	            //     let newRows = getRows();
	            //     newRows.map(r => {
	            //         r.isSelected = false;
	            //     })
	            //     rows.map(r => {
	            //         newRows[r.rowIdx].isSelected = true;
	            //     });
	            //     this.setState({ rows: newRows, selectedRows: [rows[0].row] });
	            // }
	            var onRowsSelected = function onRowsSelected(rows) {
	                var newRows = getRows();
	                var selectedRows = [].concat(_toConsumableArray(_this4.state.selectedRows));
	                rows.map(function (r) {
	                    newRows[r.rowIdx].isSelected = true;
	                    selectedRows.push(r.row);
	                });
	                _this4.setState({ rows: newRows, selectedRows: selectedRows });
	            };
	            // const onRowsDeselected = (rows) => {
	            //     let newRows = getRows();
	            //     rows.map(r => {
	            //         newRows[r.rowIdx].isSelected = false;
	            //     });
	            //     this.setState({ rows: newRows, selectedRows: [] });
	            // }
	            var onRowsDeselected = function onRowsDeselected(rows) {
	                var newRows = [].concat(_toConsumableArray(_this4.state.rows));
	                var selectedRows = [].concat(_toConsumableArray(_this4.state.selectedRows));
	                rows.map(function (r) {
	                    newRows[r.rowIdx].isSelected = false;
	                    var rowIndex = selectedRows.indexOf(r.row);
	                    selectedRows.splice(rowIndex, 1);
	                });
	                _this4.setState({ rows: newRows, selectedRows: selectedRows });
	            };
	
	            var columns = [{
	                key: 'name',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                editable: true,
	                width: 200
	            }, {
	                key: 'note',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                editable: true,
	                width: 300
	            }];
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { style: { maxWidth: '550px', marginLeft: '25px' } },
	                        _react2.default.createElement(_reactDataGrid2.default
	                        // rowKey="Idx"
	                        , { enableCellSelect: true,
	                            columns: columns,
	                            rowGetter: rowGetter,
	                            rowsCount: getSize(),
	                            minHeight: 400,
	                            rowHeight: 25,
	                            headerRowHeight: 45,
	                            enableRowSelect: 'single',
	                            onRowUpdated: handleRowUpdated,
	                            rowSelection: {
	                                showCheckbox: true,
	                                onRowsSelected: onRowsSelected,
	                                onRowsDeselected: onRowsDeselected,
	                                selectBy: {
	                                    isSelectedKey: 'isSelected'
	                                }
	                            }
	                        })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            _objectDestructuringEmpty(this.props);
	
	            _objectDestructuringEmpty(this.state);
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    { style: { marginLeft: '5px', marginBottom: '7px' } },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'primary',
	                            onClick: function onClick(event) {
	                                _this5.clickNew(event);
	                            }
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            style: { marginRight: '5px' },
	                            bsStyle: 'danger',
	                            onClick: function onClick(event) {
	                                _this5.deleteCategory(event);
	                            },
	                            disabled: !this.state.selectedRows || this.state.selectedRows.length != 1
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-trash marginRightStyle' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: 'text-center' },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            this.renderAgentTable()
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'centerStyle', style: { marginTop: '20px' } },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            style: { marginRight: '5px' },
	                            bsStyle: 'success',
	                            onClick: function onClick(e) {
	                                _this5.handleOnSave(e);
	                            }
	                        },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AgentChangeModal;
	}(_react.Component);
	
	var _default = AgentChangeModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(AgentChangeModal, 'AgentChangeModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/agentChangeModal.jsx');
	
	    __REACT_HOT_LOADER__.register(Selectors, 'Selectors', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/agentChangeModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/agentChangeModal.jsx');
	}();

	;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BOLListModal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _GenericDatePicker = __webpack_require__(48);
	
	var _GenericDatePicker2 = _interopRequireDefault(_GenericDatePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Selectors = _reactDataGridAddons.Data.Selectors;
	
	var BOLListModal = exports.BOLListModal = function (_Component) {
	    _inherits(BOLListModal, _Component);
	
	    function BOLListModal() {
	        _classCallCheck(this, BOLListModal);
	
	        var _this = _possibleConstructorReturn(this, (BOLListModal.__proto__ || Object.getPrototypeOf(BOLListModal)).call(this));
	
	        _this.handleOnSave = function (e) {
	            e.preventDefault();
	            _this.state.rows.map(function (r) {
	                // r.recreate = false;
	            });
	            // this.props.updateFJAgents(this.props.fjCustomerId, this.state.rows).then((response) => {
	            //     // alert(JSON.stringify(response.data));
	            //     alert("Agents Saved");
	            //     this.props.closeAgentModal();
	            //   }, (err) => {
	            //     if (err.status === 500 || err.status === 404) {
	            //       alert(JSON.stringify(err.data));
	            //     }
	            //   });
	            // this.props.onSave(this.state.rows);
	        };
	
	        _this.handlePrintPdf = function (e) {
	            e.preventDefault();
	            _this.props.printSalesOrderLabelBOL(_this.state.selectedRows[0].id);
	            // this.props.testHAHA(376);
	        };
	
	        _this.handleEdit = function (e) {
	            e.preventDefault();
	            (0, _axios2.default)({
	                method: 'PUT',
	                data: { ship_date: _this.state.ship_date },
	                url: _root_url.ROOT_URL + 'v2/sales/bol/' + _this.state.selectedRows[0].id + '/',
	                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	            }).then(function (res) {
	                (0, _axios2.default)({
	                    method: 'GET',
	                    url: _root_url.ROOT_URL + 'v2/sales/bol/',
	                    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	                }).then(function (res) {
	                    _this.setState({
	                        rows: res.data,
	                        selectedRows: [],
	                        editedRows: []
	                    });
	                }, function (err) {});
	                _this.setState({ editShipDateVisible: false });
	            }, function (err) {
	                // this.setState({editShipDateVisible: false});
	            });
	        };
	
	        _this.handleDelete = function (e) {
	            e.preventDefault();
	
	            (0, _axios2.default)({
	                method: 'DELETE',
	                url: _root_url.ROOT_URL + 'v2/sales/bol/' + _this.state.selectedRows[0].id + '/',
	                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	            }).then(function (res) {
	
	                (0, _axios2.default)({
	                    method: 'GET',
	                    url: _root_url.ROOT_URL + 'v2/sales/bol/',
	                    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	                }).then(function (res) {
	                    _this.setState({
	                        rows: res.data,
	                        selectedRows: [],
	                        editedRows: []
	                    });
	                }, function (err) {});
	            }, function (err) {
	                alert("Error, could not delete BOL.");
	            });
	        };
	
	        _this.state = {
	            rows: [],
	            selectedRows: [],
	            editedRows: [],
	            filters: {},
	            sortColumn: null,
	            sortDirection: null,
	
	            details: {
	                rows: [],
	                selectedRows: null,
	                editedRows: [],
	                filters: {}
	            },
	
	            editShipDateVisible: false,
	            ship_date: null
	        };
	        _this.setShipDate = _this.setShipDate.bind(_this);
	        return _this;
	    }
	
	    _createClass(BOLListModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            // this.props.fetchFJAgents(this.props.fjCustomerId).then((response) => {
	            //     if (response.data) {
	            //         this.initializeModal(response.data);
	            //     }
	            // }, (err) => {
	            //     if (err.status === 500 || err.status === 404) {
	            //         alert("Server error, please refresh page. If problem persists, contact administrator.");
	            //     }
	            // });
	            var url = '';
	            // if (this.props.salesOrderNum) {
	            //     url = `${ROOT_URL}v2/sales/bol/?sales_order__SONum=${this.props.salesOrderNum}`;
	            // } else {
	            url = _root_url.ROOT_URL + 'v2/sales/bol/';
	            // }
	            (0, _axios2.default)({
	                method: 'GET',
	                url: url,
	                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	            }).then(function (res) {
	                _this2.setState({
	                    rows: res.data,
	                    selectedRows: [],
	                    editedRows: []
	                });
	            }, function (err) {});
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	
	        // initializeModal = (array) => {
	        //     let index = 0;
	        //     let formatter = [];
	        //     if (array && array.length > 0) {
	        //         array.map(r => {
	        //             formatter.push({ Idx: index++, customer: r.customer, id: r.id, name: r.name, note: r.note, ref_num: r.ref_num });
	        //         })
	        //     } else {
	        //         formatter.push({ Idx: 0, name: "", note: "" });
	        //     }
	        //     this.setState({
	        //         rows: formatter,
	        //         selectedRows: [],
	        //         editedRows: [],
	        //     });
	        // }
	
	    }, {
	        key: 'setShipDate',
	        value: function setShipDate(e) {
	            // if (!this.props.Vendor) {
	            //   alert('Please select a Vendor!');
	            //   return;
	            // }
	            // if (e > this.state.toDate) {
	            //   return;
	            // }
	            this.setState({ ship_date: e });
	        }
	    }, {
	        key: 'renderExcel',
	
	
	        // handleExcel = (e) => {
	        //     e.preventDefault();
	        // }
	
	        value: function renderExcel() {
	            var selectedRows = this.state.selectedRows;
	
	            var temp = null;
	            if (selectedRows && selectedRows.length > 0) {
	                temp = selectedRows[0].id;
	            }
	            var exportUrl = _root_url.ROOT_URL + 'v2/sales/bol/export/' + temp + '?mode=xls&Bearer=' + localStorage.getItem("token");
	            return _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                    bsStyle: 'success',
	                    type: 'button',
	                    href: exportUrl,
	                    disabled: selectedRows.length !== 1
	                },
	                _react2.default.createElement('em', { className: 'fa fa-download' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'export_excel' })
	            );
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            var rows = Selectors.getRows(this.state);
	            var index = rows.length;
	            var newRow = { name: null, note: null, customer: this.props.fjCustomerId, Idx: index };
	            rows.push(newRow);
	            var editedRows = [].concat(_toConsumableArray(this.state.editedRows));
	            editedRows.push(newRow);
	            this.setState({ rows: rows, editedRows: editedRows });
	        }
	    }, {
	        key: 'deleteCategory',
	        value: function deleteCategory(e) {
	            e.preventDefault();
	            var rows = [].concat(_toConsumableArray(this.state.rows));
	            var editedRows = [].concat(_toConsumableArray(this.state.editedRows));
	            var index = _.findIndex(rows, { Idx: this.state.selectedRows[0].Idx });
	
	            if (this.state.selectedRows[0].id) {}
	            // this.props.deleteFJAgents(this.state.selectedRows[0].id).then((response) => {
	            //     alert("Agent Deleted");
	            //     rows.splice(index, 1);
	            //     index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
	            //     editedRows.splice(index, 1);
	            //     this.setState({ rows, editedRows, selectedRows: [] })
	            //     // this.props.fetchFJAgents(this.props.fjCustomerId).then((response) => {
	            //     //     if (response.data) {
	            //     //         this.initializeModal(response.data);
	            //     //     }
	            //     // }, (err) => {
	            //     //     if (err.status === 500 || err.status === 404) {
	            //     //         alert("Server error, please refresh page. If problem persists, contact administrator.");
	            //     //     }
	            //     // });
	            // }, (err) => {
	            //     if (err.status === 500 || err.status === 404 || err.status === 405) {
	            //         alert("Error cannot delete agent.");
	            //     }
	            // });
	
	
	            // rows.splice(index, 1);
	            // index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
	            // editedRows.splice(index, 1);
	            // this.setState({ rows, editedRows, selectedRows: [] })
	        }
	    }, {
	        key: 'renderAgentTable',
	        value: function renderAgentTable() {
	            var _this3 = this;
	
	            var getRows = function getRows() {
	                return Selectors.getRows(_this3.state);
	            };
	            var getSize = function getSize() {
	                return getRows().length;
	            };
	            var rowGetter = function rowGetter(rowIdx) {
	                var rows = getRows();
	                return rows[rowIdx];
	            };
	            var handleRowUpdated = function handleRowUpdated(e) {
	                _this3.setState({ sortColumn: null, sortDirection: null });
	                var rows = getRows();
	                var editedRows = _this3.state.editedRows.slice(0);
	                Object.assign(rows[e.rowIdx], e.updated);
	                editedRows.forEach(function (element, index) {
	                    if (element.Idx === rows[e.rowIdx].Idx) editedRows.splice(index, 1);
	                }, _this3);
	                editedRows.push(rows[e.rowIdx]);
	                _this3.setState({
	                    rows: rows,
	                    editedRows: editedRows
	                });
	            };
	            // const onRowsSelected = (rows) => {
	            //     let newRows = getRows();
	            //     newRows.map(r => {
	            //         r.isSelected = false;
	            //     })
	            //     rows.map(r => {
	            //         newRows[r.rowIdx].isSelected = true;
	            //     });
	            //     this.setState({ rows: newRows, selectedRows: [rows[0].row] });
	            // }
	            var onRowsSelected = function onRowsSelected(rows) {
	                var newRows = getRows();
	                var selectedRows = [].concat(_toConsumableArray(_this3.state.selectedRows));
	                rows.map(function (r) {
	                    newRows[r.rowIdx].isSelected = true;
	                    selectedRows.push(r.row);
	                });
	                _this3.setState({ rows: newRows, selectedRows: selectedRows });
	            };
	            // const onRowsDeselected = (rows) => {
	            //     let newRows = getRows();
	            //     rows.map(r => {
	            //         newRows[r.rowIdx].isSelected = false;
	            //     });
	            //     this.setState({ rows: newRows, selectedRows: [] });
	            // }
	            var onRowsDeselected = function onRowsDeselected(rows) {
	                var newRows = [].concat(_toConsumableArray(_this3.state.rows));
	                var selectedRows = [].concat(_toConsumableArray(_this3.state.selectedRows));
	                rows.map(function (r) {
	                    newRows[r.rowIdx].isSelected = false;
	                    var rowIndex = selectedRows.indexOf(r.row);
	                    selectedRows.splice(rowIndex, 1);
	                });
	                _this3.setState({ rows: newRows, selectedRows: selectedRows });
	            };
	
	            var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                var state = Object.assign({}, _this3.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                _this3.setState(state);
	            };
	
	            var handleFilterChange = function handleFilterChange(filter) {
	                var newFilters = Object.assign({}, _this3.state.filters);
	                if (filter.filterTerm) {
	                    newFilters[filter.column.key] = filter;
	                } else {
	                    delete newFilters[filter.column.key];
	                }
	                _this3.setState({ filters: newFilters });
	            };
	
	            var SecondsDateFormatter = _react2.default.createClass({
	                displayName: 'SecondsDateFormatter',
	                render: function render() {
	                    if (this.props.value) {
	                        var date = (0, _moment2.default)(this.props.value).format("MM-DD-YY HH:mm");
	                        return _react2.default.createElement(
	                            'span',
	                            null,
	                            date
	                        );
	                    }
	                    return _react2.default.createElement(
	                        'span',
	                        { className: 'label label-danger' },
	                        '-'
	                    );
	                }
	            });
	
	            var DateFormatter2 = _react2.default.createClass({
	                displayName: 'DateFormatter2',
	                render: function render() {
	                    if (this.props.value) {
	                        var date = (0, _moment2.default)(this.props.value).format("MM-DD-YY");
	                        return _react2.default.createElement(
	                            'span',
	                            null,
	                            date
	                        );
	                    }
	                    return _react2.default.createElement(
	                        'span',
	                        { className: 'label label-danger' },
	                        '-'
	                    );
	                }
	            });
	
	            var columns = [
	            // {
	            //     key: 'so_num',
	            //     name: <Translate value="so_num" />,
	            //     resizable: true,
	            //     sortable: true,
	            //     filterable: true,
	            //     width: 120,
	            // },
	            {
	                key: 'trailer_num',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trailer' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 120
	            }, {
	                key: 'load_num',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'load' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 120
	            }, {
	                key: 'isa_num',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'isa' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 100
	            }, {
	                key: 'pro_num',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pro' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 100
	            }, {
	                key: 'seal_num',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'seal' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 100
	            }, {
	                key: 'ship_date',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_date' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 100,
	                formatter: DateFormatter2
	            }, {
	                key: 'ship_name',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 100
	            }, {
	                key: 'ship_street',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'street' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 100
	            }, {
	                key: 'ship_city',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 100
	            }, {
	                key: 'ship_state',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'state' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 100
	            }, {
	                key: 'ship_zip',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zip' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 100
	            }, {
	                key: 'create_datetime',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'created' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 110,
	                formatter: SecondsDateFormatter
	            }, {
	                key: "is_3party",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '3rd_party' }),
	                resizable: true,
	                sortable: true,
	                // filterable: true,
	                width: 100,
	                formatter: function formatter(_ref) {
	                    var value = _ref.value;
	                    return _react2.default.createElement(
	                        'div',
	                        null,
	                        value === true || value === 'true' ? "true" : "false"
	                    );
	                }
	            }, {
	                key: "is_collect",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'collect' }),
	                resizable: true,
	                sortable: true,
	                // filterable: true,
	                width: 100,
	                formatter: function formatter(_ref2) {
	                    var value = _ref2.value;
	                    return _react2.default.createElement(
	                        'div',
	                        null,
	                        value === true || value === 'true' ? "true" : "false"
	                    );
	                }
	            }, {
	                key: "is_prepaid",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prepaid' }),
	                resizable: true,
	                sortable: true,
	                // filterable: true,
	                width: 100,
	                formatter: function formatter(_ref3) {
	                    var value = _ref3.value;
	                    return _react2.default.createElement(
	                        'div',
	                        null,
	                        value === true || value === 'true' ? "true" : "false"
	                    );
	                }
	            }];
	
	            var onRowClick = function onRowClick(rowIdx, row) {
	                if (rowIdx !== -1) {
	                    var rows = getRows();
	                    rows.map(function (r) {
	                        r.isSelected = false;
	                    });
	                    var selectedRows = [rows[rowIdx]];
	                    rows[rowIdx].isSelected = true;
	                    _this3.setState({ rows: rows, selectedRows: selectedRows });
	
	                    //   const salesOrders = { ...this.state.salesOrders, rows, selectedRows };
	                    //   this.setState({ salesOrders });
	                    //   this.props.fetchSalesOrderDetail(row.SalesOrder_id, route);
	                    var temp = {
	                        rows: [],
	                        selectedRows: null,
	                        editedRows: [],
	                        filters: {}
	                    };
	                    if (selectedRows && selectedRows[0]) {
	                        temp.rows = selectedRows[0].lines;
	                        _this3.setState({ details: temp });
	                    }
	                }
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_reactDataGrid2.default
	                        // rowKey="Idx"
	
	                        // rowKey="Idx"
	                        , { enableCellSelect: true,
	                            onGridSort: handleGridSort,
	                            onAddFilter: handleFilterChange,
	                            columns: columns,
	                            rowGetter: rowGetter,
	                            rowsCount: getSize(),
	                            minHeight: 295,
	                            rowHeight: 25,
	                            headerRowHeight: 45,
	                            toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                            enableRowSelect: 'single',
	                            onRowUpdated: handleRowUpdated,
	                            rowSelection: {
	                                showCheckbox: true,
	                                onRowsSelected: onRowsSelected,
	                                onRowsDeselected: onRowsDeselected,
	                                selectBy: {
	                                    isSelectedKey: 'isSelected'
	                                }
	                            },
	                            onRowClick: onRowClick
	                        })
	                    )
	                )
	            );
	        }
	
	        ////////////
	        ////////////////////////////////////////////////////////////////////////
	        ////////////
	
	    }, {
	        key: 'renderDetailTable',
	        value: function renderDetailTable() {
	            var _this4 = this;
	
	            var getRows = function getRows() {
	                return Selectors.getRows(_this4.state.details);
	            };
	            var getSize = function getSize() {
	                return getRows().length;
	            };
	            var rowGetter = function rowGetter(rowIdx) {
	                var rows = getRows();
	                return rows[rowIdx];
	            };
	
	            var columns = [{
	                key: 'sku',
	                name: 'SKU',
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 150
	            }, {
	                key: 'fba',
	                name: 'FBA',
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 120
	            },
	            // {
	            //     key: 'prod_name',
	            //     name: <Translate value="product_name" />,
	            //     resizable: true,
	            //     sortable: true,
	            //     filterable: true,
	            //     width: 200,
	            // },
	            {
	                key: 'quantity',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 100
	            }, {
	                key: 'note',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 250
	            }];
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_reactDataGrid2.default, { enableCellSelect: true,
	                            columns: columns,
	                            rowGetter: rowGetter,
	                            rowsCount: getSize(),
	                            minHeight: 140,
	                            rowHeight: 25,
	                            headerRowHeight: 45
	                            // enableRowSelect='single'
	                            // rowSelection={{
	                            //     showCheckbox: true,
	                            //     onRowsSelected,
	                            //     onRowsDeselected,
	                            //     selectBy: {
	                            //         isSelectedKey: 'isSelected'
	                            //     }
	                            // }}
	                        })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            _objectDestructuringEmpty(this.props);
	
	            _objectDestructuringEmpty(this.state);
	
	            var dialogStyleWiz = {
	                width: "550px",
	                height: "200px",
	                marginLeft: "-10%"
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: 'text-center' },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { padding: '0px 25px' } },
	                            this.renderAgentTable()
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        { style: { padding: '0px 25px', fontWeight: 'bold', fontSize: '18px', marginTop: '5px', marginBottom: '0px' } },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'details' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: 'text-center' },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { padding: '0px 25px' } },
	                            this.renderDetailTable()
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'centerStyle', style: { marginTop: '15px' } },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            style: { marginRight: '5px' },
	                            bsStyle: 'warning',
	                            onClick: function onClick(e) {
	                                _this5.setState({ editShipDateVisible: true });
	                            },
	                            disabled: this.state.selectedRows.length !== 1
	                        },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_date' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            style: { marginRight: '5px' },
	                            bsStyle: 'success',
	                            onClick: function onClick(e) {
	                                _this5.handlePrintPdf(e);
	                            },
	                            disabled: this.state.selectedRows.length !== 1
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-print' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_pdf' })
	                    ),
	                    this.renderExcel(),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            style: { marginLeft: '5px' },
	                            bsStyle: 'danger',
	                            onClick: function onClick(e) {
	                                _this5.handleDelete(e);
	                            },
	                            disabled: this.state.selectedRows.length !== 1
	                        },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactSkylight.SkyLightStateless,
	                    {
	                        dialogStyles: dialogStyleWiz,
	                        isVisible: this.state.editShipDateVisible,
	                        onCloseClicked: function onCloseClicked() {
	                            _this5.setState({ editShipDateVisible: false });
	                            // this.closeDSQPrint();
	                        },
	                        title: "Ship Date"
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6 },
	                                _react2.default.createElement(
	                                    'label',
	                                    { style: { marginRight: '5px' } },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_date' }),
	                                    ':'
	                                ),
	                                (0, _GenericDatePicker2.default)({
	                                    setDate: this.setShipDate,
	                                    selectedDate: this.state.ship_date,
	                                    onChange: function onChange(e) {
	                                        _this5.setShipDate(e);
	                                    }
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'centerStyle', style: { marginTop: '15px' } },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    style: { marginRight: '5px' },
	                                    bsStyle: 'success',
	                                    onClick: function onClick(e) {
	                                        _this5.handleEdit(e);
	                                    },
	                                    disabled: false
	                                },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return BOLListModal;
	}(_react.Component);
	
	var _default = BOLListModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(BOLListModal, 'BOLListModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/bolListModal.jsx');
	
	    __REACT_HOT_LOADER__.register(Selectors, 'Selectors', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/bolListModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/bolListModal.jsx');
	}();

	;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoldDecimalTextFormatter = function (_Component) {
	  _inherits(BoldDecimalTextFormatter, _Component);
	
	  function BoldDecimalTextFormatter() {
	    _classCallCheck(this, BoldDecimalTextFormatter);
	
	    return _possibleConstructorReturn(this, (BoldDecimalTextFormatter.__proto__ || Object.getPrototypeOf(BoldDecimalTextFormatter)).apply(this, arguments));
	  }
	
	  _createClass(BoldDecimalTextFormatter, [{
	    key: 'render',
	    value: function render() {
	      var value = this.props.value;
	
	      return _react2.default.createElement(
	        'span',
	        { style: { 'font-weight': 'bold' } },
	        value && parseFloat(value).toFixed(4) || '-'
	      );
	    }
	  }]);
	
	  return BoldDecimalTextFormatter;
	}(_react.Component);
	
	var _default = BoldDecimalTextFormatter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(BoldDecimalTextFormatter, 'BoldDecimalTextFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/boldDecimalTextFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/boldDecimalTextFormatter.jsx');
	}();

	;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CarrierInfoModal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Selectors = _reactDataGridAddons.Data.Selectors;
	
	var CarrierInfoModal = exports.CarrierInfoModal = function (_Component) {
	    _inherits(CarrierInfoModal, _Component);
	
	    function CarrierInfoModal() {
	        _classCallCheck(this, CarrierInfoModal);
	
	        var _this = _possibleConstructorReturn(this, (CarrierInfoModal.__proto__ || Object.getPrototypeOf(CarrierInfoModal)).call(this));
	
	        _this.handleOnSubmit = function (e) {
	            e.preventDefault();
	            var _this$state = _this.state,
	                carrierData = _this$state.carrierData,
	                otherText = _this$state.otherText;
	
	
	            if (carrierData && carrierData.LTLCarrier === 'Other' && otherText) {
	                carrierData.LTLCarrier = carrierData.LTLCarrier + ": " + otherText;
	            }
	
	            _this.props.postCarrierInfo(_this.props.salesOrderId, _this.state.carrierData).then(function (response) {
	                alert("Carrier Info Saved");
	                _this.props.closeCarrierInfoModal();
	            }, function (err) {
	                alert("Submit error:" + err.data);
	            });
	        };
	
	        _this.onChangeBol = function (e) {
	            var carrierData = _this.state.carrierData;
	
	            carrierData.BOLNum = e.target.value;
	            _this.setState({ carrierData: carrierData });
	        };
	
	        _this.onChangePro = function (e) {
	            var carrierData = _this.state.carrierData;
	
	            carrierData.PRONum = e.target.value;
	            _this.setState({ carrierData: carrierData });
	        };
	
	        _this.onChangeLTL = function (e) {
	            var carrierData = _this.state.carrierData;
	
	            carrierData.LTLCarrier = e.value;
	            _this.setState({ carrierData: carrierData });
	        };
	
	        _this.onChangeOtherText = function (e) {
	            var otherText = _this.state.otherText;
	
	            otherText = e.target.value;
	            _this.setState({ otherText: otherText });
	        };
	
	        _this.state = {
	            carrierData: {
	                BOLNum: "",
	                LTLCarrier: "",
	                PRONum: ""
	            },
	            otherText: ""
	        };
	        return _this;
	    }
	
	    _createClass(CarrierInfoModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.props.fetchCarrierInfo(this.props.salesOrderId).then(function (response) {
	                if (response.data) {
	                    _this2.initializeData(response.data);
	                    // this.setState({ carrierData: response.data });
	                }
	            }, function (err) {
	                if (err.status === 500 || err.status === 404) {
	                    alert("Server error, please refresh page. If problem persists, contact administrator.");
	                }
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	    }, {
	        key: 'initializeData',
	        value: function initializeData(data) {
	            var front = "";
	            var back = "";
	            if (data && data.LTLCarrier && data.LTLCarrier.split(': ').length > 1) {
	                front = data.LTLCarrier.split(': ')[0];
	                back = data.LTLCarrier.split(': ')[1];
	                data.LTLCarrier = front;
	            }
	            this.setState({ carrierData: data, otherText: back });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            _objectDestructuringEmpty(this.props);
	
	            var _state = this.state,
	                carrierData = _state.carrierData,
	                otherText = _state.otherText;
	
	
	            var LTLOptions = [{
	                label: 'R & L Carriers Inc',
	                value: 'R & L Carriers Inc'
	            }, {
	                label: 'Roadrunner Transportation Services',
	                value: 'Roadrunner Transportation Services'
	            }, {
	                label: 'Estes Express Lines',
	                value: 'Estes Express Lines'
	            }, {
	                label: 'Daylight Transport',
	                value: 'Daylight Transport'
	            }, {
	                label: 'YRC',
	                value: 'YRC'
	            }, {
	                label: 'UPS Freight',
	                value: 'UPS Freight'
	            }, {
	                label: 'SAIA',
	                value: 'SAIA'
	            }, {
	                label: 'USF Reddaway',
	                value: 'USF Reddaway'
	            }, {
	                label: 'Mountain Valley Express',
	                value: 'Mountain Valley Express'
	            }, {
	                label: 'ProTrains International',
	                value: 'ProTrains International'
	            }, {
	                label: 'Other',
	                value: 'Other'
	            }];
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bol_num' }),
	                            ':'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pro_num' }),
	                            ':'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(_reactBootstrap.Input, {
	                            type: 'number',
	                            value: carrierData.BOLNum,
	                            onChange: this.onChangeBol
	                            // disabled={true}
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(_reactBootstrap.Input, {
	                            type: 'number',
	                            value: carrierData.PRONum,
	                            onChange: this.onChangePro
	                            // disabled={true}
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 10 },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ltl_carrier' }),
	                            ':'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { style: { marginBottom: '12px' } },
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 10 },
	                        _react2.default.createElement(
	                            _reactBootstrap.Dropdown,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Dropdown.Toggle,
	                                { style: { width: '300px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' } },
	                                carrierData.LTLCarrier
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Dropdown.Menu,
	                                { className: 'super-colors' },
	                                LTLOptions.map(function (el) {
	                                    return _react2.default.createElement(
	                                        _reactBootstrap.MenuItem,
	                                        { onClick: function onClick() {
	                                                return _this3.onChangeLTL(el);
	                                            } },
	                                        el.label
	                                    );
	                                })
	                            )
	                        )
	                    )
	                ),
	                carrierData.LTLCarrier === 'Other' && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 10 },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_clarify_other' }),
	                                ':'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(_reactBootstrap.Input, {
	                                type: 'text',
	                                value: otherText,
	                                onChange: this.onChangeOtherText
	                                // disabled={true}
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'centerStyle', style: { marginTop: '0px' } },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'success',
	                            onClick: function onClick(e) {
	                                _this3.handleOnSubmit(e);
	                            }
	                            // disabled={!this.state.selectedRows || this.state.selectedRows.length < 1}
	                        },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CarrierInfoModal;
	}(_react.Component);
	
	var _default = CarrierInfoModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(CarrierInfoModal, 'CarrierInfoModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/carrierInfoModal.jsx');
	
	    __REACT_HOT_LOADER__.register(Selectors, 'Selectors', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/carrierInfoModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/carrierInfoModal.jsx');
	}();

	;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CtRowRenderer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CtRowRenderer = exports.CtRowRenderer = function (_Component) {
	    _inherits(CtRowRenderer, _Component);
	
	    function CtRowRenderer() {
	        _classCallCheck(this, CtRowRenderer);
	
	        return _possibleConstructorReturn(this, (CtRowRenderer.__proto__ || Object.getPrototypeOf(CtRowRenderer)).apply(this, arguments));
	    }
	
	    _createClass(CtRowRenderer, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                isEcity = _props.isEcity,
	                permissionCheck = _props.permissionCheck;
	            var _props$row = this.props.row,
	                SalesMargin = _props$row.SalesMargin,
	                RealSalesMargin = _props$row.RealSalesMargin;
	
	            if (isEcity && permissionCheck && Number(RealSalesMargin) < 14 || isEcity && !permissionCheck && Number(SalesMargin) < 14) {
	                return _react2.default.createElement(
	                    'div',
	                    { style: { color: 'red' } },
	                    _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	                );
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	                );
	            }
	        }
	    }]);
	
	    return CtRowRenderer;
	}(_react.Component);
	
	var _default = CtRowRenderer;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(CtRowRenderer, 'CtRowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/ctRowRenderer.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/ctRowRenderer.jsx');
	}();

	;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getBsStyle = function getBsStyle(input, value) {
	  return input === value ? 'success' : 'primary';
	};
	/* Example of date filter for date range but with days not hardcoded like the dateFilterRadios.
	  {
	    dateFilterRadios({
	      handleOnClick: this.fetchSalesInvoiceByDetails,
	      setFromDate: this.setFromDate,
	      setToDate: this.setToDate,
	      FromDate: this.state.FromDate,
	      ToDate: this.state.ToDate,
	      Days: this.state.Days,
	    })
	  }
	*/
	
	var customizableDateFilterRadios = function customizableDateFilterRadios(props) {
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.userTimeSelection, '0'), style: { width: '150px' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'thisMonth-radio-filter10' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'thisMonth-radio-filter10',
	            type: 'radio',
	            name: 'customizableDateFilterRadios',
	            value: '0',
	            checked: (props.userTimeSelection === '0' || props.userTimeSelection === 0) && (props.userDays !== -1 || props.userDays !== '-1'),
	            onChange: function onChange() {
	              props.handleOnClick('0');
	            }
	          })),
	          'Current Month'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.userTimeSelection, '1'), style: { width: '150px' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'LastMonth-radio-filter10' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'LastMonth-radio-filter10',
	            type: 'radio',
	            name: 'customizableDateFilterRadios',
	            value: '1',
	            checked: (props.userTimeSelection === '1' || props.userTimeSelection === 1) && (props.userDays !== -1 || props.userDays !== '-1'),
	            onChange: function onChange() {
	              props.handleOnClick('1');
	            }
	          })),
	          'Last Month'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.userTimeSelection, '2'), style: { width: '130px' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'sevenDay-radio-filter10' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'sevenDay-radio-filter10',
	            type: 'radio',
	            name: 'customizableDateFilterRadios',
	            value: '2',
	            checked: (props.userTimeSelection === '2' || props.userTimeSelection === 2) && (props.userDays !== -1 || props.userDays !== '-1'),
	            onChange: function onChange() {
	              props.handleOnClick('2');
	            }
	          })),
	          '2 Months'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.userTimeSelection, '3'), style: { width: '130px' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'thirtyDay-radio-filter10' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'thirtyDay-radio-filter10',
	            type: 'radio',
	            name: 'customizableDateFilterRadios',
	            value: '3',
	            checked: (props.userTimeSelection === '3' || props.userTimeSelection === 3) && (props.userDays !== -1 || props.userDays !== '-1'),
	            onChange: function onChange() {
	              props.handleOnClick('3');
	            }
	          })),
	          '3 Months'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.userTimeSelection, -1), style: { width: '130px' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'dateRange-radio-filter10' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'dateRange-radio-filter10',
	            type: 'radio',
	            name: 'customizableDateFilterRadios',
	            value: '-1',
	            checked: props.userTimeSelection === '-1' || props.userTimeSelection === -1,
	            onChange: function onChange() {
	              props.userSetToRangeSearch();
	            }
	          })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date_range' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      {
	        bsStyle: 'primary',
	        disabled: props.userDays !== '-1' && props.userDays !== -1
	      },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'dateRange-radio-filter10' },
	        _react2.default.createElement(_DateTimePicker2.default, {
	          id: 'from-datepicker1',
	          format: 'MM-DD-YY',
	          className: 'test-rw-input',
	          onChange: function onChange(e) {
	            props.userSetFromDate(e);
	          },
	          time: false,
	          placeholder: 'Start',
	          disabled: props.userDays !== '-1' && props.userDays !== -1,
	          value: props.userFromDate
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      {
	        bsStyle: 'primary',
	        disabled: props.userDays !== '-1' && props.userDays !== -1
	      },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'dateRange-radio-filter10' },
	        _react2.default.createElement(_DateTimePicker2.default, {
	          id: 'to-datepicker1',
	          format: 'MM-DD-YY',
	          className: 'test-rw-input',
	          onChange: function onChange(e) {
	            props.userSetToDate(e);
	          },
	          time: false,
	          placeholder: 'End',
	          disabled: props.userDays !== '-1' && props.userDays !== -1,
	          value: props.userToDate
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      {
	        className: 'search-button',
	        bsStyle: 'primary',
	        disabled: props.userDays !== '-1' && props.userDays !== -1 || !props.userToDate || !props.userFromDate,
	        onClick: function onClick() {
	          props.handleOnClick('-1');
	        }
	      },
	      _react2.default.createElement('em', { className: 'fa fa-search' })
	    )
	  );
	};
	
	customizableDateFilterRadios.propTypes = {
	  input: _react2.default.PropTypes.node.isRequired,
	  handleOnClick: _react2.default.PropTypes.func.isRequired,
	  setFromDate: _react2.default.PropTypes.func.isRequired,
	  setToDate: _react2.default.PropTypes.func.isRequired,
	  FromDate: _react2.default.PropTypes.string.isRequired,
	  ToDate: _react2.default.PropTypes.string.isRequired,
	  userDays: _react2.default.PropTypes.string.isRequired,
	  setToRangeSearch: _react2.default.PropTypes.func.isRequired
	};
	
	var _default = customizableDateFilterRadios;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getBsStyle, 'getBsStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/customizableDateFilterRadios.jsx');
	
	  __REACT_HOT_LOADER__.register(customizableDateFilterRadios, 'customizableDateFilterRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/customizableDateFilterRadios.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/customizableDateFilterRadios.jsx');
	}();

	;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DiscountChangeModal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DiscountChangeModal = exports.DiscountChangeModal = function (_Component) {
	    _inherits(DiscountChangeModal, _Component);
	
	    function DiscountChangeModal() {
	        _classCallCheck(this, DiscountChangeModal);
	
	        var _this = _possibleConstructorReturn(this, (DiscountChangeModal.__proto__ || Object.getPrototypeOf(DiscountChangeModal)).call(this));
	
	        _this.handleOnConfirm = function (e) {
	            e.preventDefault();
	            _this.props.onDiscountSavingsConfirm(_this.state.discount, _this.state.savings);
	        };
	
	        _this.onChangeDiscount = function (e) {
	            _this.setState({ discount: e.target.value });
	        };
	
	        _this.onChangeSavings = function (e) {
	            _this.setState({ savings: e.target.value });
	        };
	
	        _this.state = {
	            discount: 0,
	            savings: 0
	        };
	        return _this;
	    }
	
	    _createClass(DiscountChangeModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setState({ discount: this.props.SODiscount, savings: this.props.SOSavings });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount' }),
	                            '(%)'
	                        ),
	                        _react2.default.createElement(_reactBootstrap.Input, {
	                            type: 'text',
	                            value: this.state.discount,
	                            onChange: this.onChangeDiscount
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'savings' }),
	                            '($)'
	                        ),
	                        _react2.default.createElement(_reactBootstrap.Input, {
	                            type: 'text',
	                            value: this.state.savings,
	                            onChange: this.onChangeSavings
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'centerStyle', style: { marginTop: '25px' } },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            style: { marginRight: '5px' },
	                            bsStyle: 'primary',
	                            onClick: function onClick(e) {
	                                _this2.handleOnConfirm(e);
	                            }
	                        },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DiscountChangeModal;
	}(_react.Component);
	
	var _default = DiscountChangeModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(DiscountChangeModal, 'DiscountChangeModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/discountChangeModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/discountChangeModal.jsx');
	}();

	;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getBsStyle = function getBsStyle(input, value) {
	  return input === value ? 'success' : 'primary';
	};
	/* Example of date filter for date range
	  {
	    dateFilterRadios({
	      handleOnClick: this.fetchSalesInvoiceByDetails,
	      setFromDate: this.setFromDate,
	      setToDate: this.setToDate,
	      FromDate: this.state.FromDate,
	      ToDate: this.state.ToDate,
	      Days: this.state.Days,
	    })
	  }
	*/
	var dispatchFilterRadios = function dispatchFilterRadios(props) {
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.Days, '1') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'today-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'today-radio-filter',
	            type: 'radio',
	            name: 'dispatchFilterRadios',
	            value: '1',
	            checked: props.Days === '1' || props.Days === 1,
	            onChange: function onChange() {
	              props.handleOnClick('1');
	            }
	          })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'today' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.Days, '7') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'sevenDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'sevenDay-radio-filter',
	            type: 'radio',
	            name: 'dispatchFilterRadios',
	            value: '7',
	            checked: props.Days === '7' || props.Days === 7,
	            onChange: function onChange() {
	              props.handleOnClick('7');
	            }
	          })),
	          '7 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.Days, '30') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'thirtyDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'thirtyDay-radio-filter',
	            type: 'radio',
	            name: 'dispatchFilterRadios',
	            value: '30',
	            checked: props.Days === '30' || props.Days === 30,
	            onChange: function onChange() {
	              props.handleOnClick('30');
	            }
	          })),
	          '30 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.Days, '90') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'ninetyDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'ninetyDay-radio-filter',
	            type: 'radio',
	            name: 'dispatchFilterRadios',
	            value: '90',
	            checked: props.Days === '90' || props.Days === 90,
	            onChange: function onChange() {
	              props.handleOnClick('90');
	            }
	          })),
	          '90 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.Days, '-1') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'dateRange-radio-filter1' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'dateRange-radio-filter1',
	            type: 'radio',
	            name: 'dispatchFilterRadios',
	            value: '-1',
	            checked: props.Days === '-1' || props.Days === -1,
	            onChange: function onChange() {
	              props.setToRangeSearch();
	            }
	          })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date_range' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      {
	        bsStyle: 'primary',
	        disabled: props.Days !== '-1' && props.Days !== -1
	      },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'dateRange-radio-filter1' },
	        _react2.default.createElement(_DateTimePicker2.default, {
	          id: 'from-datepicker',
	          format: 'MM-DD-YY',
	          className: 'test-rw-input',
	          onChange: function onChange(e) {
	            props.setFromDate(e);
	          },
	          time: false,
	          placeholder: 'Start',
	          disabled: props.Days !== '-1' && props.Days !== -1,
	          value: props.FromDate
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      {
	        bsStyle: 'primary',
	        disabled: props.Days !== '-1' && props.Days !== -1
	      },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'dateRange-radio-filter1' },
	        _react2.default.createElement(_DateTimePicker2.default, {
	          id: 'to-datepicker',
	          format: 'MM-DD-YY',
	          className: 'test-rw-input',
	          onChange: function onChange(e) {
	            props.setToDate(e);
	          },
	          time: false,
	          placeholder: 'End',
	          disabled: props.Days !== '-1' && props.Days !== -1,
	          value: props.ToDate
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      {
	        className: 'search-button',
	        bsStyle: 'primary',
	        disabled: props.Days !== '-1' && props.Days !== -1,
	        onClick: function onClick() {
	          props.handleOnClick('-1');
	        }
	      },
	      _react2.default.createElement('em', { className: 'fa fa-search' })
	    )
	  );
	};
	
	dispatchFilterRadios.propTypes = {
	  input: _react2.default.PropTypes.node.isRequired,
	  handleOnClick: _react2.default.PropTypes.func.isRequired,
	  setFromDate: _react2.default.PropTypes.func.isRequired,
	  setToDate: _react2.default.PropTypes.func.isRequired,
	  FromDate: _react2.default.PropTypes.string.isRequired,
	  ToDate: _react2.default.PropTypes.string.isRequired,
	  Days: _react2.default.PropTypes.string.isRequired,
	  setToRangeSearch: _react2.default.PropTypes.func.isRequired
	};
	
	var _default = dispatchFilterRadios;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getBsStyle, 'getBsStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/dispatchFilterRadios.jsx');
	
	  __REACT_HOT_LOADER__.register(dispatchFilterRadios, 'dispatchFilterRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/dispatchFilterRadios.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/dispatchFilterRadios.jsx');
	}();

	;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DisplayCategoryModal = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactSkylight = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RowRenderer = function (_Component) {
	    _inherits(RowRenderer, _Component);
	
	    function RowRenderer() {
	        _classCallCheck(this, RowRenderer);
	
	        return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	    }
	
	    _createClass(RowRenderer, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { onDoubleClick: function onDoubleClick() {
	                        _this2.props.onDoubleClick(_this2.props.row);
	                    } },
	                _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	            );
	        }
	    }]);
	
	    return RowRenderer;
	}(_react.Component);
	
	var DisplayCategoryModal = exports.DisplayCategoryModal = function (_Component2) {
	    _inherits(DisplayCategoryModal, _Component2);
	
	    function DisplayCategoryModal() {
	        _classCallCheck(this, DisplayCategoryModal);
	
	        var _this3 = _possibleConstructorReturn(this, (DisplayCategoryModal.__proto__ || Object.getPrototypeOf(DisplayCategoryModal)).call(this));
	
	        _this3.handleGroupChange = function (el) {
	            _this3.setState({
	                groupOptionsDisplay: el.label,
	                currentGroup: el.value
	            });
	        };
	
	        _this3.state = {
	            groupOptionsDisplay: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' }),
	            currentGroup: 'all',
	            currentNotIncludedCategories: {
	                rows: [],
	                filters: {},
	                selectedRows: null,
	                sortColumn: null,
	                sortDirection: null
	            },
	            currentIncludedCategories: {
	                rows: [],
	                filters: {},
	                selectedRows: null,
	                sortColumn: null,
	                sortDirection: null
	            },
	            filterNotIncluded: {
	                rows: [],
	                filters: {},
	                selectedRows: null,
	                sortColumn: null,
	                sortDirection: null
	            },
	            filterIncluded: {
	                rows: [],
	                filters: {},
	                selectedRows: null,
	                sortColumn: null,
	                sortDirection: null
	            },
	            productId: null,
	            outputCategories: null
	        };
	        _this3.moveNotIncluded = _this3.moveNotIncluded.bind(_this3);
	        _this3.moveIncluded = _this3.moveIncluded.bind(_this3);
	        _this3.handleSaveClicked = _this3.handleSaveClicked.bind(_this3);
	        return _this3;
	    }
	
	    _createClass(DisplayCategoryModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.getDisplayCategories(this.props.productId);
	            this.setState({
	                productId: this.props.productId
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var currentNotIncludedCategories = { rows: [] };
	            var currentIncludedCategories = { rows: [] };
	            var formatArray = null;
	            if (nextProps.displayCategories) {
	                nextProps.displayCategories.map(function (displayCategories) {
	                    formatArray = Object.values(displayCategories.Categories);
	                    formatArray.map(function (Categories) {
	                        if (Categories.IsSelected === true) {
	                            currentIncludedCategories['rows'].push({ IsSelected: Categories.IsSelected, ProductCategoryDisplay_id: Categories.ProductCategoryDisplay_id, Name: Categories.Name, DisplayName: Categories.Name + ' (' + displayCategories.Name + ')', GroupId: displayCategories.ProductGroup_id, GroupName: displayCategories.Name });
	                        } else {
	                            currentNotIncludedCategories['rows'].push({ IsSelected: Categories.IsSelected, ProductCategoryDisplay_id: Categories.ProductCategoryDisplay_id, Name: Categories.Name, DisplayName: Categories.Name + ' (' + displayCategories.Name + ')', GroupId: displayCategories.ProductGroup_id, GroupName: displayCategories.Name });
	                        }
	                    });
	                });
	                this.setState({
	                    currentNotIncludedCategories: currentNotIncludedCategories,
	                    currentIncludedCategories: currentIncludedCategories,
	                    outputCategories: nextProps.displayCategories
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            // console.log("dropdown",  this.state.currentGroup,  this.state.groupOptionsDisplay);
	        }
	    }, {
	        key: 'getGroupOptions',
	        value: function getGroupOptions() {
	            var groupOptions = [];
	            this.props.displayCategories.map(function (displayCategories) {
	                groupOptions.push({ value: displayCategories.ProductGroup_id, label: displayCategories.Name });
	            });
	            groupOptions.push({ value: 'all', label: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' }) });
	            return groupOptions;
	        }
	    }, {
	        key: 'renderGroupFilter',
	        value: function renderGroupFilter() {
	            var _this4 = this;
	
	            var groupOptions = this.getGroupOptions();
	            return _react2.default.createElement(
	                'div',
	                { style: { marginLeft: '10px', marginBottom: '15px' } },
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        null,
	                        _react2.default.createElement(
	                            'label',
	                            { style: { width: '150px', fontSize: '14px' } },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'group_list' }),
	                            ':'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Dropdown,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Dropdown.Toggle,
	                                { style: { width: '150px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' } },
	                                this.state.groupOptionsDisplay
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Dropdown.Menu,
	                                { className: 'super-colors' },
	                                groupOptions.map(function (el) {
	                                    return _react2.default.createElement(
	                                        _reactBootstrap.MenuItem,
	                                        { onClick: function onClick() {
	                                                return _this4.handleGroupChange(el);
	                                            } },
	                                        el.label
	                                    );
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'moveNotIncluded',
	        value: function moveNotIncluded(category) {
	            var leftRows = [].concat(_toConsumableArray(this.state.currentNotIncludedCategories.rows));
	            var rightRows = [].concat(_toConsumableArray(this.state.currentIncludedCategories.rows));
	            var index = _.findIndex(leftRows, { ProductCategoryDisplay_id: category.ProductCategoryDisplay_id });
	            if (index > -1) {
	                leftRows.splice(index, 1);
	                rightRows.push(category);
	            }
	            var leftCategories = _extends({}, this.state.currentNotIncludedCategories, { rows: leftRows
	                // .sort((a,b) => {return a.name.localeCompare(b.name)})
	            });var rightCategories = _extends({}, this.state.currentIncludedCategories, { rows: rightRows });
	            this.setState({ currentNotIncludedCategories: leftCategories, currentIncludedCategories: rightCategories });
	        }
	    }, {
	        key: 'moveIncluded',
	        value: function moveIncluded(category) {
	            var leftRows = [].concat(_toConsumableArray(this.state.currentNotIncludedCategories.rows));
	            var rightRows = [].concat(_toConsumableArray(this.state.currentIncludedCategories.rows));
	            var index = _.findIndex(rightRows, { ProductCategoryDisplay_id: category.ProductCategoryDisplay_id });
	            if (index > -1) {
	                rightRows.splice(index, 1);
	                leftRows.push(category);
	            }
	            var leftCategories = _extends({}, this.state.currentNotIncludedCategories, { rows: leftRows });
	            var rightCategories = _extends({}, this.state.currentIncludedCategories, { rows: rightRows });
	            this.setState({ currentNotIncludedCategories: leftCategories, currentIncludedCategories: rightCategories });
	        }
	    }, {
	        key: 'handleSaveClicked',
	        value: function handleSaveClicked() {
	            var _this5 = this;
	
	            var outputFormatArray = null;
	            this.state.outputCategories.map(function (groups) {
	                outputFormatArray = Object.values(groups.Categories);
	                outputFormatArray.map(function (categories) {
	                    _this5.state.currentIncludedCategories.rows.map(function (included) {
	                        if (categories.ProductCategoryDisplay_id === included.ProductCategoryDisplay_id) {
	                            categories.IsSelected = true;
	                        }
	                    });
	                    _this5.state.currentNotIncludedCategories.rows.map(function (notIncluded) {
	                        if (categories.ProductCategoryDisplay_id === notIncluded.ProductCategoryDisplay_id) {
	                            categories.IsSelected = false;
	                        }
	                    });
	                });
	            });
	            this.props.editDisplayCategories(this.state.productId, this.state.outputCategories);
	            this.props.closeModal();
	        }
	    }, {
	        key: 'renderNotIncluded',
	        value: function renderNotIncluded() {
	            var _this6 = this;
	
	            this.state.filterNotIncluded = {
	                rows: [],
	                filters: {},
	                selectedRows: null,
	                sortColumn: null,
	                sortDirection: null
	            };
	            if (this.state.currentGroup === 'all') {
	                this.state.filterNotIncluded.rows = this.state.currentNotIncludedCategories.rows;
	            } else {
	                this.state.currentNotIncludedCategories.rows.map(function (row) {
	                    if (row.GroupId === _this6.state.currentGroup) {
	                        _this6.state.filterNotIncluded.rows.push(row);
	                    }
	                });
	            }
	
	            var getRows = function getRows() {
	                return _reactDataGridAddons.Data.Selectors.getRows(_this6.state.filterNotIncluded);
	            };
	            var getSize = function getSize() {
	                return getRows().length;
	            };
	            var rowGetter = function rowGetter(rowIdx) {
	                var rows = getRows();
	                return rows[rowIdx];
	            };
	            var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                var filterNotIncluded = Object.assign({}, _this6.state.filterNotIncluded, { sortColumn: sortColumn, sortDirection: sortDirection });
	                _this6.setState({ filterNotIncluded: filterNotIncluded });
	            };
	            var handleFilterChange = function handleFilterChange(filter) {
	                var newFilters = Object.assign({}, _this6.state.filterNotIncluded.filters);
	                if (filter.filterTerm) {
	                    newFilters[filter.column.key] = filter;
	                } else {
	                    delete newFilters[filter.column.key];
	                }
	                var filterNotIncluded = _extends({}, _this6.state.filterNotIncluded, { filters: newFilters });
	                _this6.setState({ filterNotIncluded: filterNotIncluded });
	            };
	            var columns = [{
	                key: 'DisplayName',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category_hidden' }),
	                resizable: true,
	                width: 328,
	                sortable: true,
	                filterable: true
	            }];
	
	            return _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(
	                    'div',
	                    { style: { maxWidth: '100%' }, id: 'DisplayCategoryModal-dataGrid1' },
	                    _react2.default.createElement(_reactDataGrid2.default, {
	                        rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: this.moveNotIncluded }),
	                        rowKey: 'ProductCategoryDisplay_id',
	                        onGridSort: handleGridSort,
	                        toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                        onAddFilter: handleFilterChange,
	                        columns: columns,
	                        rowHeight: 25,
	                        minHeight: 285,
	                        rowGetter: rowGetter,
	                        rowsCount: getSize()
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'renderIncluded',
	        value: function renderIncluded() {
	            var _this7 = this;
	
	            this.state.filterIncluded = {
	                rows: [],
	                filters: {},
	                selectedRows: null,
	                sortColumn: null,
	                sortDirection: null
	            };
	            if (this.state.currentGroup === 'all') {
	                this.state.filterIncluded.rows = this.state.currentIncludedCategories.rows;
	            } else {
	                this.state.currentIncludedCategories.rows.map(function (row) {
	                    if (row.GroupId === _this7.state.currentGroup) {
	                        _this7.state.filterIncluded.rows.push(row);
	                    }
	                });
	            }
	
	            var getRows = function getRows() {
	                return _reactDataGridAddons.Data.Selectors.getRows(_this7.state.filterIncluded);
	            };
	            var getSize = function getSize() {
	                return getRows().length;
	            };
	            var rowGetter = function rowGetter(rowIdx) {
	                var rows = getRows();
	                return rows[rowIdx];
	            };
	            var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                var filterIncluded = Object.assign({}, _this7.state.filterIncluded, { sortColumn: sortColumn, sortDirection: sortDirection });
	                _this7.setState({ filterIncluded: filterIncluded });
	            };
	            var handleFilterChange = function handleFilterChange(filter) {
	                var newFilters = Object.assign({}, _this7.state.filterIncluded.filters);
	                if (filter.filterTerm) {
	                    newFilters[filter.column.key] = filter;
	                } else {
	                    delete newFilters[filter.column.key];
	                }
	                var filterIncluded = _extends({}, _this7.state.filterIncluded, { filters: newFilters });
	                _this7.setState({ filterIncluded: filterIncluded });
	            };
	            var columns = [{
	                key: 'DisplayName',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category_visible' }),
	                resizable: true,
	                width: 328,
	                sortable: true,
	                filterable: true
	            }];
	
	            return _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(
	                    'div',
	                    { style: { maxWidth: '100%' }, id: 'DisplayCategoryModal-dataGrid2' },
	                    _react2.default.createElement(_reactDataGrid2.default, {
	                        rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: this.moveIncluded }),
	                        rowKey: 'ProductCategoryDisplay_id',
	                        onGridSort: handleGridSort,
	                        toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                        onAddFilter: handleFilterChange,
	                        columns: columns,
	                        rowHeight: 25,
	                        minHeight: 285,
	                        rowGetter: rowGetter,
	                        rowsCount: getSize()
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12, style: { position: 'absolute' } },
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'success',
	                                type: 'button',
	                                style: { marginTop: '21px', marginLeft: '165px' },
	                                onClick: this.handleSaveClicked
	                            },
	                            _react2.default.createElement('em', { className: 'fa fa-save' }),
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                        )
	                    )
	                ),
	                this.renderGroupFilter(),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    this.renderNotIncluded(),
	                    this.renderIncluded()
	                )
	            );
	        }
	    }]);
	
	    return DisplayCategoryModal;
	}(_react.Component);
	
	var _default = DisplayCategoryModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(DisplayCategoryModal, 'DisplayCategoryModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/displayCategoryModal.jsx');
	
	    __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/displayCategoryModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/displayCategoryModal.jsx');
	}();

	;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DSQPrintModal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Selectors = _reactDataGridAddons.Data.Selectors;
	
	var DSQPrintModal = exports.DSQPrintModal = function (_Component) {
	    _inherits(DSQPrintModal, _Component);
	
	    function DSQPrintModal() {
	        _classCallCheck(this, DSQPrintModal);
	
	        var _this = _possibleConstructorReturn(this, (DSQPrintModal.__proto__ || Object.getPrototypeOf(DSQPrintModal)).call(this));
	
	        _this.handleOnSave = function (e) {
	            e.preventDefault();
	            _this.state.rows.map(function (r) {
	                // r.recreate = false;
	            });
	            if (_this.state.selectedRows.length < 1) {
	                alert("At least one product is required.");
	                return;
	            }
	            var tempArray = [];
	            var tempString = "";
	            if (_this.state.selectedRows && _this.state.selectedRows.length > 0) {
	                _this.state.selectedRows.map(function (r) {
	                    tempArray.push(r.SalesOrderLine_id);
	                });
	                tempString = tempArray.join(',');
	            }
	            _this.props.printSalesOrderLabelDSQ(tempString);
	            // this.props.updateFJAgents(this.props.fjCustomerId, this.state.rows).then((response) => {
	            //     // alert(JSON.stringify(response.data));
	            //     alert("Agents Saved");
	            //     this.props.closeAgentModal();
	            //   }, (err) => {
	            //     if (err.status === 500 || err.status === 404) {
	            //       alert(JSON.stringify(err.data));
	            //     }
	            //   });
	            // this.props.onSave(this.state.rows);
	        };
	
	        _this.state = {
	            rows: [],
	            selectedRows: null,
	            editedRows: [],
	            filters: {},
	            sortColumn: null,
	            sortDirection: null,
	
	            details: {
	                rows: [],
	                selectedRows: null,
	                editedRows: [],
	                filters: {}
	            }
	        };
	        return _this;
	    }
	
	    _createClass(DSQPrintModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            // this.props.fetchFJAgents(this.props.fjCustomerId).then((response) => {
	            //     if (response.data) {
	            //         this.initializeModal(response.data);
	            //     }
	            // }, (err) => {
	            //     if (err.status === 500 || err.status === 404) {
	            //         alert("Server error, please refresh page. If problem persists, contact administrator.");
	            //     }
	            // });
	
	            var url = _root_url.ROOT_URL + 'v1/sale/sales_order/?pk=' + this.props.singleSalesOrderId;
	            (0, _axios2.default)({
	                method: 'GET',
	                url: url,
	                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	            }).then(function (res) {
	                _this2.setState({
	                    rows: res.data.Sales_Order_Lines,
	                    selectedRows: [],
	                    editedRows: []
	                });
	            }, function (err) {});
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	
	        // initializeModal = (array) => {
	        //     let index = 0;
	        //     let formatter = [];
	        //     if (array && array.length > 0) {
	        //         array.map(r => {
	        //             formatter.push({ Idx: index++, customer: r.customer, id: r.id, name: r.name, note: r.note, ref_num: r.ref_num });
	        //         })
	        //     } else {
	        //         formatter.push({ Idx: 0, name: "", note: "" });
	        //     }
	        //     this.setState({
	        //         rows: formatter,
	        //         selectedRows: [],
	        //         editedRows: [],
	        //     });
	        // }
	
	    }, {
	        key: 'deleteCategory',
	
	
	        // clickNew(e) {
	        //     e.preventDefault();
	        //     let rows = Selectors.getRows(this.state);
	        //     let index = rows.length;
	        //     let newRow = { name: null, note: null, customer: this.props.fjCustomerId, Idx: index };
	        //     rows.push(newRow);
	        //     let editedRows = [...this.state.editedRows];
	        //     editedRows.push(newRow)
	        //     this.setState({ rows, editedRows })
	        // }
	
	        value: function deleteCategory(e) {
	            e.preventDefault();
	            var rows = [].concat(_toConsumableArray(this.state.rows));
	            var editedRows = [].concat(_toConsumableArray(this.state.editedRows));
	            var index = _.findIndex(rows, { Idx: this.state.selectedRows[0].Idx });
	
	            if (this.state.selectedRows[0].id) {}
	            // this.props.deleteFJAgents(this.state.selectedRows[0].id).then((response) => {
	            //     alert("Agent Deleted");
	            //     rows.splice(index, 1);
	            //     index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
	            //     editedRows.splice(index, 1);
	            //     this.setState({ rows, editedRows, selectedRows: [] })
	            //     // this.props.fetchFJAgents(this.props.fjCustomerId).then((response) => {
	            //     //     if (response.data) {
	            //     //         this.initializeModal(response.data);
	            //     //     }
	            //     // }, (err) => {
	            //     //     if (err.status === 500 || err.status === 404) {
	            //     //         alert("Server error, please refresh page. If problem persists, contact administrator.");
	            //     //     }
	            //     // });
	            // }, (err) => {
	            //     if (err.status === 500 || err.status === 404 || err.status === 405) {
	            //         alert("Error cannot delete agent.");
	            //     }
	            // });
	
	
	            // rows.splice(index, 1);
	            // index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
	            // editedRows.splice(index, 1);
	            // this.setState({ rows, editedRows, selectedRows: [] })
	        }
	    }, {
	        key: 'renderAgentTable',
	        value: function renderAgentTable() {
	            var _this3 = this;
	
	            var getRows = function getRows() {
	                return Selectors.getRows(_this3.state);
	            };
	            var getSize = function getSize() {
	                return getRows().length;
	            };
	            var rowGetter = function rowGetter(rowIdx) {
	                var rows = getRows();
	                return rows[rowIdx];
	            };
	            var handleRowUpdated = function handleRowUpdated(e) {
	                _this3.setState({ sortColumn: null, sortDirection: null });
	                var rows = getRows();
	                var editedRows = _this3.state.editedRows.slice(0);
	                Object.assign(rows[e.rowIdx], e.updated);
	                editedRows.forEach(function (element, index) {
	                    if (element.Idx === rows[e.rowIdx].Idx) editedRows.splice(index, 1);
	                }, _this3);
	                editedRows.push(rows[e.rowIdx]);
	                _this3.setState({
	                    rows: rows,
	                    editedRows: editedRows
	                });
	            };
	            // const onRowsSelected = (rows) => {
	            //     let newRows = getRows();
	            //     newRows.map(r => {
	            //         r.isSelected = false;
	            //     })
	            //     rows.map(r => {
	            //         newRows[r.rowIdx].isSelected = true;
	            //     });
	            //     this.setState({ rows: newRows, selectedRows: [rows[0].row] });
	            // }
	            var onRowsSelected = function onRowsSelected(rows) {
	                var newRows = getRows();
	                var selectedRows = [].concat(_toConsumableArray(_this3.state.selectedRows));
	                rows.map(function (r) {
	                    newRows[r.rowIdx].isSelected = true;
	                    selectedRows.push(r.row);
	                });
	                _this3.setState({ rows: newRows, selectedRows: selectedRows });
	            };
	            // const onRowsDeselected = (rows) => {
	            //     let newRows = getRows();
	            //     rows.map(r => {
	            //         newRows[r.rowIdx].isSelected = false;
	            //     });
	            //     this.setState({ rows: newRows, selectedRows: [] });
	            // }
	            var onRowsDeselected = function onRowsDeselected(rows) {
	                var newRows = [].concat(_toConsumableArray(_this3.state.rows));
	                var selectedRows = [].concat(_toConsumableArray(_this3.state.selectedRows));
	                rows.map(function (r) {
	                    newRows[r.rowIdx].isSelected = false;
	                    var rowIndex = selectedRows.indexOf(r.row);
	                    selectedRows.splice(rowIndex, 1);
	                });
	                _this3.setState({ rows: newRows, selectedRows: selectedRows });
	            };
	
	            var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                var state = Object.assign({}, _this3.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                _this3.setState(state);
	            };
	
	            var handleFilterChange = function handleFilterChange(filter) {
	                var newFilters = Object.assign({}, _this3.state.filters);
	                if (filter.filterTerm) {
	                    newFilters[filter.column.key] = filter;
	                } else {
	                    delete newFilters[filter.column.key];
	                }
	                _this3.setState({ filters: newFilters });
	            };
	
	            var SecondsDateFormatter = _react2.default.createClass({
	                displayName: 'SecondsDateFormatter',
	                render: function render() {
	                    if (this.props.value) {
	                        var date = (0, _moment2.default)(this.props.value).format("MM-DD-YY HH:mm");
	                        return _react2.default.createElement(
	                            'span',
	                            null,
	                            date
	                        );
	                    }
	                    return _react2.default.createElement(
	                        'span',
	                        { className: 'label label-danger' },
	                        '-'
	                    );
	                }
	            });
	
	            var columns = [
	            // {
	            //   key: "ContainerNum",
	            //   name: <Translate value="container_num" />,
	            //   resizable: true,
	            //   sortable: true,
	            //   width: 100,
	            // },
	            {
	                key: "ProductNum",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	                resizable: true,
	                sortable: true,
	                width: 100
	            }, {
	                key: "RefNum",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	                resizable: true,
	                sortable: true,
	                width: 70
	            }, {
	                key: "Name",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                resizable: true,
	                sortable: true,
	                width: 150
	            }, {
	                key: "Description",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                resizable: true,
	                sortable: true,
	                width: 150
	            }, {
	                key: "ReceivedQuantity",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'received_qty' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 100
	            }, {
	                key: "FBACode",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_code' }),
	                resizable: true,
	                sortable: true,
	                width: 90
	            }, {
	                key: "FBARoute",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_route' }),
	                resizable: true,
	                sortable: true,
	                width: 90
	            }, {
	                key: "TrailerNum",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trailer' }),
	                resizable: true,
	                sortable: true,
	                width: 90
	            }, {
	                key: "POList",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_list' }),
	                resizable: true,
	                sortable: true,
	                width: 90
	            }, {
	                key: "POD",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pod' }),
	                resizable: true,
	                sortable: true,
	                width: 90
	            }, {
	                key: "DimUnit",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dim_unit' }),
	                resizable: true,
	                sortable: true,
	                width: 90
	            }, {
	                key: "BoxLength",
	                name: "Box L",
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 80
	            }, {
	                key: "BoxWidth",
	                name: "Box W",
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 80
	            }, {
	                key: "BoxHeight",
	                name: "Box H",
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 80
	            }, {
	                key: "BoxVol",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_vol' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 100
	            }, {
	                key: "BoxWeight",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 100
	            }, {
	                key: "PalletLength",
	                name: "Plt L",
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 80
	            }, {
	                key: "PalletWidth",
	                name: "Plt W",
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 80
	            }, {
	                key: "PalletHeight",
	                name: "Plt H",
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 80
	            }, {
	                key: "PalletVol",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_vol' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 100
	            }, {
	                key: "PalletWeight",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_weight' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 100
	            }, {
	                key: "Quantity",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	                resizable: true,
	                width: 100,
	                sortable: true
	            }, {
	                key: "PickupQuantity",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped_qty' }),
	                resizable: true,
	                width: 80,
	                sortable: true
	            }, {
	                key: "PackageType",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	                resizable: true,
	                width: 80,
	                sortable: true
	            }, {
	                key: "UnitPrice",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	                resizable: true,
	                width: 70,
	                sortable: true,
	                formatter: _cashFormatter2.default
	            },
	            // ...showProductCost() ? [{
	            //   key: "CostPrice",
	            //   name: <Translate value="cost_price" />,
	            //   resizable: true,
	            //   width: 70,
	            //   sortable: true,
	            // }] : [],
	            // {
	            //   key: 'CostPrice',
	            //   name: <Translate value="cost_price" />,
	            //   resizable: true,
	            //   width: 70,
	            //   sortable: true,
	            //   // formatter: CashFormatter,
	            // },
	            {
	                key: "TotalPrice",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	                resizable: true,
	                width: 70,
	                sortable: true,
	                formatter: _cashFormatter2.default
	            }, {
	                key: "ProductTax",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	                resizable: true,
	                width: 70,
	                sortable: true,
	                formatter: _cashFormatter2.default
	            }, {
	                key: "NetWeight",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_weight' }),
	                resizable: true,
	                width: 70,
	                sortable: true
	                // formatter: CashFormatter,
	            }, {
	                key: "TotalNetWeight",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_weight' }),
	                resizable: true,
	                width: 70,
	                sortable: true
	                // formatter: CashFormatter,
	            }];
	
	            var onRowClick = function onRowClick(rowIdx, row) {
	                if (rowIdx !== -1) {
	                    var rows = getRows();
	                    rows.map(function (r) {
	                        r.isSelected = false;
	                    });
	                    var selectedRows = [rows[rowIdx]];
	                    rows[rowIdx].isSelected = true;
	                    //   const salesOrders = { ...this.state.salesOrders, rows, selectedRows };
	                    //   this.setState({ salesOrders });
	                    //   this.props.fetchSalesOrderDetail(row.SalesOrder_id, route);
	                    var temp = {
	                        rows: [],
	                        selectedRows: null,
	                        editedRows: [],
	                        filters: {}
	                    };
	                    if (selectedRows && selectedRows[0]) {
	                        temp.rows = selectedRows[0].lines;
	                        _this3.setState({ details: temp });
	                    }
	                }
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_reactDataGrid2.default
	                        // rowKey="Idx"
	
	                        // rowKey="Idx"
	                        , { enableCellSelect: true,
	                            onGridSort: handleGridSort,
	                            onAddFilter: handleFilterChange,
	                            columns: columns,
	                            rowGetter: rowGetter,
	                            rowsCount: getSize(),
	                            minHeight: 350,
	                            rowHeight: 25,
	                            headerRowHeight: 45,
	                            toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                            enableRowSelect: 'single',
	                            onRowUpdated: handleRowUpdated,
	                            rowSelection: {
	                                showCheckbox: true,
	                                onRowsSelected: onRowsSelected,
	                                onRowsDeselected: onRowsDeselected,
	                                selectBy: {
	                                    isSelectedKey: 'isSelected'
	                                }
	                            }
	                            // onRowClick={onRowClick}
	                        })
	                    )
	                )
	            );
	        }
	
	        ////////////
	        ////////////////////////////////////////////////////////////////////////
	        ////////////
	
	    }, {
	        key: 'renderDetailTable',
	        value: function renderDetailTable() {
	            var _this4 = this;
	
	            var getRows = function getRows() {
	                return Selectors.getRows(_this4.state.details);
	            };
	            var getSize = function getSize() {
	                return getRows().length;
	            };
	            var rowGetter = function rowGetter(rowIdx) {
	                var rows = getRows();
	                return rows[rowIdx];
	            };
	
	            var columns = [{
	                key: 'sku',
	                name: 'SKU',
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 150
	            }, {
	                key: 'fba',
	                name: 'FBA',
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 120
	            },
	            // {
	            //     key: 'prod_name',
	            //     name: <Translate value="product_name" />,
	            //     resizable: true,
	            //     sortable: true,
	            //     filterable: true,
	            //     width: 200,
	            // },
	            {
	                key: 'quantity',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 100
	            }, {
	                key: 'note',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 250
	            }];
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_reactDataGrid2.default, { enableCellSelect: true,
	                            columns: columns,
	                            rowGetter: rowGetter,
	                            rowsCount: getSize(),
	                            minHeight: 140,
	                            rowHeight: 25,
	                            headerRowHeight: 45
	                            // enableRowSelect='single'
	                            // rowSelection={{
	                            //     showCheckbox: true,
	                            //     onRowsSelected,
	                            //     onRowsDeselected,
	                            //     selectBy: {
	                            //         isSelectedKey: 'isSelected'
	                            //     }
	                            // }}
	                        })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            _objectDestructuringEmpty(this.props);
	
	            _objectDestructuringEmpty(this.state);
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: 'text-center' },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { padding: '0px 25px' } },
	                            this.renderAgentTable()
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'centerStyle', style: { marginTop: '15px' } },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            style: { marginRight: '5px' },
	                            bsStyle: 'success',
	                            onClick: function onClick(e) {
	                                _this5.handleOnSave(e);
	                            }
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-print' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_label' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DSQPrintModal;
	}(_react.Component);
	
	var _default = DSQPrintModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(DSQPrintModal, 'DSQPrintModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/dsqPrintModal.jsx');
	
	    __REACT_HOT_LOADER__.register(Selectors, 'Selectors', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/dsqPrintModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/dsqPrintModal.jsx');
	}();

	;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addShippingAddress = function addShippingAddress(data, receivingCustomer, success) {
	  (0, _axios2.default)({
	    method: 'PUT',
	    data: data,
	    url: _root_url.ROOT_URL + 'v1/customer/' + receivingCustomer,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    success();
	  }, function (err) {});
	};
	
	// const addFBAAddress = (data) => {
	//     axios({
	//       method: 'POST',
	//       data,
	//       url: `${ROOT_URL}v1/sale/order-address`,
	//       headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
	//     })
	//     .then(res => {
	//         alert("FBA Address Added");
	//         this.props.closeFBAEditModal();
	//       }, err => {
	//         alert("Error adding FBA Address");  
	//       })
	//   }
	
	var dataValid = function dataValid(data) {
	  if (!data.name || !data.city || !data.state || !data.street || !data.zipcode) {
	    return;
	  }
	  return true;
	};
	
	var fetchCustomerDetails = function fetchCustomerDetails(receivingCustomer, success) {
	  (0, _axios2.default)({
	    method: 'GET',
	    url: _root_url.ROOT_URL + '/v1/customer/' + receivingCustomer,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    success(res);
	  }, function (err) {});
	};
	
	var FBAAddressEditModal = function (_Component) {
	  _inherits(FBAAddressEditModal, _Component);
	
	  function FBAAddressEditModal() {
	    _classCallCheck(this, FBAAddressEditModal);
	
	    var _this = _possibleConstructorReturn(this, (FBAAddressEditModal.__proto__ || Object.getPrototypeOf(FBAAddressEditModal)).call(this));
	
	    _this.handleInputFieldChange = function (_ref) {
	      var name = _ref.name,
	          value = _ref.value;
	      return _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.handleSubmit = function () {
	
	      if (!dataValid(_this.state)) {
	        alert('name and address details are required');
	        return;
	      }
	
	      // this.setState({
	      //   buttonDisabled: true,
	      // })
	      // const customerDetails = {
	      //   ...this.state.customerDetails
	      // }
	
	      var data = _extends({}, _this.state);
	
	      (0, _axios2.default)({
	        method: 'POST',
	        data: data,
	        url: _root_url.ROOT_URL + 'v1/sale/order-address',
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (res) {
	        alert("FBA Address Added");
	        _this.props.closeFBAEditModal();
	        _this.props.modalFetchFBA();
	      }, function (err) {
	        alert("Error adding FBA Address");
	      });
	
	      // addShippingAddress(customerDetails, this.props.receivingCustomer, () => {
	      //   this.props.reFetchSalesCustomers();
	      //   this.setState({
	      //     buttonDisabled: false,
	      //   })
	      // })
	    };
	
	    _this.state = {
	      name: "",
	      // address: "",
	      city: "",
	      state: "",
	      street: "",
	      zipcode: "",
	      phone: "",
	      note: ""
	    };
	    return _this;
	  }
	
	  _createClass(FBAAddressEditModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // fetchCustomerDetails(this.props.receivingCustomer, this.handleFetchCustomerDetailsSuccess)
	    }
	
	    // handleFetchCustomerDetailsSuccess = ({ data }) => {
	    //   this.setState({
	    //     name: "",
	    //     address: "",
	    //     phone: "",
	    //     note: "",
	    //     customerDetails: data,
	    //   })
	    // }
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          name = _state.name,
	          city = _state.city,
	          state = _state.state,
	          street = _state.street,
	          zipcode = _state.zipcode,
	          phone = _state.phone,
	          note = _state.note;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	              ':'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(_reactBootstrap.Input, {
	              type: 'text',
	              name: 'name',
	              value: name,
	              onChange: function onChange(e) {
	                return _this2.handleInputFieldChange(e.target);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'street' }),
	              ':'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city' }),
	              ':'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(_reactBootstrap.Input, {
	              type: 'text',
	              name: 'street',
	              value: street,
	              onChange: function onChange(e) {
	                return _this2.handleInputFieldChange(e.target);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(_reactBootstrap.Input, {
	              type: 'text',
	              name: 'city',
	              value: city,
	              onChange: function onChange(e) {
	                return _this2.handleInputFieldChange(e.target);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'state' }),
	              ':'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zipcode' }),
	              ':'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(_reactBootstrap.Input, {
	              type: 'text',
	              name: 'state',
	              value: state,
	              onChange: function onChange(e) {
	                return _this2.handleInputFieldChange(e.target);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(_reactBootstrap.Input, {
	              type: 'text',
	              name: 'zipcode',
	              value: zipcode,
	              onChange: function onChange(e) {
	                return _this2.handleInputFieldChange(e.target);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' }),
	              ':'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	              ':'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(_reactBootstrap.Input, {
	              type: 'text',
	              name: 'phone',
	              value: phone,
	              onChange: function onChange(e) {
	                return _this2.handleInputFieldChange(e.target);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(_reactBootstrap.Input, {
	              type: 'text',
	              name: 'note',
	              value: note,
	              onChange: function onChange(e) {
	                return _this2.handleInputFieldChange(e.target);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'centerStyle', style: { marginTop: "0px" } },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'success',
	              disabled: false,
	              onClick: function onClick(e) {
	                _this2.handleSubmit();
	              }
	              // disabled={!this.state.selectedRows || this.state.selectedRows.length < 1}
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return FBAAddressEditModal;
	}(_react.Component);
	
	var _default = FBAAddressEditModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(addShippingAddress, 'addShippingAddress', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/fbaAddressEditModal.jsx');
	
	  __REACT_HOT_LOADER__.register(dataValid, 'dataValid', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/fbaAddressEditModal.jsx');
	
	  __REACT_HOT_LOADER__.register(fetchCustomerDetails, 'fetchCustomerDetails', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/fbaAddressEditModal.jsx');
	
	  __REACT_HOT_LOADER__.register(FBAAddressEditModal, 'FBAAddressEditModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/fbaAddressEditModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/fbaAddressEditModal.jsx');
	}();

	;

/***/ }),
/* 274 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// FULLSCREEN
	// -----------------------------------
	
	function initScreenfull() {
	  if (typeof screenfull === 'undefined') return;
	
	  var $doc = $(document);
	  var $fsToggler = $(this);
	
	  // Not supported under IE
	  var ua = window.navigator.userAgent;
	  if (ua.indexOf('MSIE') > 0 || !!ua.match(/Trident.*rv\:11\./)) {
	    $fsToggler.addClass('hide');
	  }
	
	  if (!$fsToggler.is(':visible')) {
	    return;
	  } // hidden on mobiles or IE
	
	  $fsToggler.on('click', function (e) {
	    e.preventDefault();
	    if (screenfull.enabled) {
	      screenfull.toggle();
	      // Switch icon indicator
	      toggleFSIcon($fsToggler);
	    } else {
	      console.log('Fullscreen not enabled');
	    }
	  });
	
	  if (screenfull.raw && screenfull.raw.fullscreenchange) $doc.on(screenfull.raw.fullscreenchange, function () {
	    toggleFSIcon($fsToggler);
	  });
	
	  function toggleFSIcon($element) {
	    if (screenfull.isFullscreen) {
	      $element.children('em').removeClass('fa-expand').addClass('fa-compress');
	    } else {
	      $element.children('em').removeClass('fa-compress').addClass('fa-expand');
	    }
	  }
	}
	
	var _default = function _default() {
	  $('[data-toggle-fullscreen]').each(initScreenfull);
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initScreenfull, 'initScreenfull', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/fullscreen.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/fullscreen.js');
	}();

	;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GenerateBOLModal = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reduxForm = __webpack_require__(3);
	
	var _datePicker = __webpack_require__(27);
	
	var _GenericDatePicker = __webpack_require__(48);
	
	var _GenericDatePicker2 = _interopRequireDefault(_GenericDatePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Selectors = _reactDataGridAddons.Data.Selectors;
	
	
	var dataValid = function dataValid(data) {
	  // if (!data.name || !data.address) {
	  //   return;
	  // }
	  return true;
	};
	
	var GenerateBOLModal = exports.GenerateBOLModal = function (_Component) {
	  _inherits(GenerateBOLModal, _Component);
	
	  function GenerateBOLModal() {
	    _classCallCheck(this, GenerateBOLModal);
	
	    var _this = _possibleConstructorReturn(this, (GenerateBOLModal.__proto__ || Object.getPrototypeOf(GenerateBOLModal)).call(this));
	
	    _this.handleInputFieldChange = function (_ref) {
	      var name = _ref.name,
	          value = _ref.value;
	
	      _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.handleInputFieldChangeBool = function (field, value) {
	      _this.setState(_defineProperty({}, field, value.checked));
	    };
	
	    _this.handleSubmit = function () {
	
	      if (!dataValid(_this.state)) {
	        alert(' are required');
	        return;
	      }
	
	      // this.setState({
	      //   buttonDisabled: true,
	      // })
	      // const customerDetails = {
	      //   ...this.state.customerDetails
	      // }
	
	      var data = _extends({}, _this.state);
	
	      // console.log("SUBMIT", data);
	      (0, _axios2.default)({
	        method: 'POST',
	        data: data,
	        url: _root_url.ROOT_URL + 'v2/sales/bol/' + _this.props.salesOrderIdString + '/',
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (res) {
	        alert("BOL Generated");
	        _this.props.closeGenerateBOLModal();
	        //   this.props.modalFetchFBA();
	      }, function (err) {
	        alert("Error generating BOL");
	      });
	
	      // addShippingAddress(customerDetails, this.props.receivingCustomer, () => {
	      //   this.props.reFetchSalesCustomers();
	      //   this.setState({
	      //     buttonDisabled: false,
	      //   })
	      // })
	    };
	
	    _this.state = {
	      trailer_num: "",
	      // load_num: "",
	      isa_num: "",
	      pro_num: "",
	      seal_num: "",
	      is_3party: false,
	      is_collect: false,
	      is_prepaid: false,
	      // ship_street: "",
	      // ship_city: "",
	      // ship_state: "",
	      // ship_name: "",
	      // ship_zip: "",
	      ship_date: null
	    };
	    _this.setShipDate = _this.setShipDate.bind(_this);
	    return _this;
	  }
	
	  _createClass(GenerateBOLModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      //   console.log("st", this.props.salesOrderIdString);
	      //   console.log("st", this.props.salesOrderNumString);
	
	      // fetchCustomerDetails(this.props.receivingCustomer, this.handleFetchCustomerDetailsSuccess)
	    }
	
	    // handleFetchCustomerDetailsSuccess = ({ data }) => {
	    //   this.setState({
	    //     name: "",
	    //     address: "",
	    //     phone: "",
	    //     note: "",
	    //     customerDetails: data,
	    //   })
	    // }
	
	  }, {
	    key: 'setShipDate',
	    value: function setShipDate(e) {
	      // if (!this.props.Vendor) {
	      //   alert('Please select a Vendor!');
	      //   return;
	      // }
	      // if (e > this.state.toDate) {
	      //   return;
	      // }
	      this.setState({ ship_date: e });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          trailer_num = _state.trailer_num,
	          isa_num = _state.isa_num,
	          pro_num = _state.pro_num,
	          seal_num = _state.seal_num,
	          is_3party = _state.is_3party,
	          is_collect = _state.is_collect,
	          is_prepaid = _state.is_prepaid,
	          ship_date = _state.ship_date;
	
	
	      var testing = true;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'selected_orders' }),
	              ':'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'p',
	              { style: { overflowWrap: 'break-word', height: '35px', overflowY: "scroll" } },
	              this.props.salesOrderNumString
	            )
	          )
	        ),
	        testing && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trailer_num' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_date' }),
	                ':'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                name: 'trailer_num',
	                value: trailer_num,
	                onChange: function onChange(e) {
	                  return _this2.handleInputFieldChange(e.target);
	                }
	              })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              (0, _GenericDatePicker2.default)({
	                setDate: this.setShipDate,
	                selectedDate: this.state.ship_date,
	                onChange: function onChange(e) {
	                  _this2.setShipDate(e);
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'isa_num' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pro_num' }),
	                ':'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                name: 'isa_num',
	                value: isa_num,
	                onChange: function onChange(e) {
	                  return _this2.handleInputFieldChange(e.target);
	                }
	              })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                name: 'pro_num',
	                value: pro_num,
	                onChange: function onChange(e) {
	                  return _this2.handleInputFieldChange(e.target);
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'seal_num' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 2 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: '3rd_party' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 2 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'collect' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 2 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prepaid' }),
	                ':'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                name: 'seal_num',
	                value: seal_num,
	                onChange: function onChange(e) {
	                  return _this2.handleInputFieldChange(e.target);
	                }
	              })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 2 },
	              _react2.default.createElement('input', { type: 'checkbox', value: 'true', checked: this.state.is_3party == true || this.state.is_3party == "true", onClick: function onClick(e) {
	                  _this2.handleInputFieldChangeBool("is_3party", e.target);
	                } })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 2 },
	              _react2.default.createElement('input', { type: 'checkbox', value: 'true', checked: this.state.is_collect == true || this.state.is_collect == "true", onClick: function onClick(e) {
	                  _this2.handleInputFieldChangeBool("is_collect", e.target);
	                } })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 2 },
	              _react2.default.createElement('input', { type: 'checkbox', value: 'true', checked: this.state.is_prepaid == true || this.state.is_prepaid == "true", onClick: function onClick(e) {
	                  _this2.handleInputFieldChangeBool("is_prepaid", e.target);
	                } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'centerStyle', style: { marginTop: "0px" } },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'success',
	              disabled: false,
	              onClick: function onClick(e) {
	                _this2.handleSubmit();
	              }
	              // disabled={!this.state.selectedRows || this.state.selectedRows.length < 1}
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return GenerateBOLModal;
	}(_react.Component);
	
	var _default = GenerateBOLModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(GenerateBOLModal, 'GenerateBOLModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/generateBOLModal.jsx');
	
	  __REACT_HOT_LOADER__.register(Selectors, 'Selectors', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/generateBOLModal.jsx');
	
	  __REACT_HOT_LOADER__.register(dataValid, 'dataValid', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/generateBOLModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/generateBOLModal.jsx');
	}();

	;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isChinaTown = _root_url.ROOT_API_URL === 'https://erp.chinatown-supermarket.com/api/' || _root_url.ROOT_URL === 'https://erp.chinatown-supermarket.com/api/';
	
	var ItemHistoryGrid = function (_Component) {
	  _inherits(ItemHistoryGrid, _Component);
	
	  function ItemHistoryGrid() {
	    _classCallCheck(this, ItemHistoryGrid);
	
	    var _this = _possibleConstructorReturn(this, (ItemHistoryGrid.__proto__ || Object.getPrototypeOf(ItemHistoryGrid)).call(this));
	
	    _this.state = {
	      itemHistory: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null
	      }
	    };
	    return _this;
	  }
	
	  _createClass(ItemHistoryGrid, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.salesItemHistory && nextProps.salesItemHistory !== this.props.salesItemHistory) {
	        var name = '';
	        if (nextProps.salesItemHistory[0]) {
	          name = nextProps.salesItemHistory[0].Name;
	        }
	        var historyRows = [].concat(_toConsumableArray(nextProps.salesItemHistory));
	        historyRows.map(function (row) {
	          row.Date = String(row.Date).substring(0, 10);
	        });
	        var itemHistory = _extends({}, this.state.itemHistory, { rows: historyRows });
	        this.setState({ itemHistory: itemHistory, productHistoryLabel: name });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (this.props.salesItemHistoryIsLoading && !this.props.salesItemHistoryError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.salesItemHistoryError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.salesItemHistoryError)
	        )
	      );else {
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.itemHistory);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var itemHistory = _extends({}, _this2.state.itemHistory, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this2.setState({ itemHistory: itemHistory });
	        };
	
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { className: 'react-table-customizer', id: 'ItemHistoryGrid-dataGrid1', style: { marginBottom: isChinaTown ? '10px' : '0' } },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                onGridSort: handleGridSort,
	                columns: this.props.columns,
	                rowHeight: 25,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                enableRowSelect: this.props.enableRowSelect,
	                minHeight: this.props.minHeight,
	                onRowUpdated: this.props.handleRowUpdated,
	                onRowClick: this.props.onRowClick,
	                rowSelection: this.props.rowSelection
	              })
	            )
	          )
	        );
	      }
	    }
	  }]);
	
	  return ItemHistoryGrid;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    salesItemHistory: state.salesOrders.salesItemHistory,
	    salesItemHistoryIsLoading: state.salesOrders.salesItemHistoryIsLoading,
	    salesItemHistoryError: state.salesOrders.salesItemHistoryError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {})(ItemHistoryGrid);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/itemHistoryGrid.jsx');
	
	  __REACT_HOT_LOADER__.register(isChinaTown, 'isChinaTown', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/itemHistoryGrid.jsx');
	
	  __REACT_HOT_LOADER__.register(ItemHistoryGrid, 'ItemHistoryGrid', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/itemHistoryGrid.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/itemHistoryGrid.jsx');
	}();

	;

/***/ }),
/* 277 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _default = function _default() {
	  $(document).on('click', '[data-load-css]', function (e) {
	    var element = $(this);
	    if (element.is('a')) e.preventDefault();
	    var uri = element.data('loadCss'),
	        link;
	    if (uri) {
	      link = createLink(uri);
	      if (!link) {
	        $.error('Error creating stylesheet link element.');
	      }
	    } else {
	      $.error('No stylesheet location defined.');
	    }
	  });
	
	  function createLink(uri) {
	    var linkId = 'autoloaded-stylesheet',
	        oldLink = $('#' + linkId).attr('id', linkId + '-old');
	
	    $('head').append($('<link/>').attr({
	      'id': linkId,
	      'rel': 'stylesheet',
	      'href': uri
	    }));
	
	    if (oldLink.length) {
	      oldLink.remove();
	    }
	    return $('#' + linkId);
	  }
	};
	
	// LOAD CUSTOM CSS
	// -----------------------------------
	
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/load-css.js');
	}();

	;

/***/ }),
/* 278 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// TRANSLATION
	// -----------------------------------
	
	var preferredLang = 'en';
	var pathPrefix = 'server/i18n'; // folder of json files
	var packName = 'site';
	var storageKey = 'jq-appLang';
	
	var _default = function _default() {
	  if (!$.fn.localize) return;
	
	  // detect saved language or use default
	  var currLang = $.localStorage.get(storageKey) || preferredLang;
	  // set initial options
	  var opts = {
	    language: currLang,
	    pathPrefix: pathPrefix,
	    callback: function callback(data, defaultCallback) {
	      $.localStorage.set(storageKey, currLang); // save the language
	      defaultCallback(data);
	    }
	  };
	  // Set initial language
	  setLanguage(opts);
	
	  // Listen for changes
	  $(document).on('click', '[data-set-lang]', function () {
	    currLang = $(this).data('setLang');
	    if (currLang) {
	      opts.language = currLang;
	      setLanguage(opts);
	      activateDropdown($(this));
	    }
	  });
	
	  function setLanguage(options) {
	    $("[data-localize]").localize(packName, options);
	  }
	
	  // Set the current clicked text as the active dropdown text
	  function activateDropdown(elem) {
	    var menu = elem.parents('.dropdown-menu');
	    if (menu.length) {
	      var toggle = menu.prev('button, a');
	      toggle.text(elem.text());
	    }
	  }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(preferredLang, 'preferredLang', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/localize.js');
	
	  __REACT_HOT_LOADER__.register(pathPrefix, 'pathPrefix', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/localize.js');
	
	  __REACT_HOT_LOADER__.register(packName, 'packName', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/localize.js');
	
	  __REACT_HOT_LOADER__.register(storageKey, 'storageKey', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/localize.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/localize.js');
	}();

	;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	var _apis = __webpack_require__(280);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { fetchZones, fetchBins, fetchLevels } from './api';
	
	var modalStyle = {
	  width: '300px',
	  height: '360px',
	  marginLeft: '-7%',
	  marginTop: '-12%'
	};
	
	var propTypes = {
	  isVisible: _propTypes2.default.bool,
	  setModalVisibility: _propTypes2.default.array,
	  onConfirm: _propTypes2.default.func
	};
	
	var defaultProps = {
	  isVisible: false,
	  setModalVisibility: function setModalVisibility() {},
	  onConfirm: function onConfirm() {},
	  selectedRows: []
	};
	
	var prcessZoneData = function prcessZoneData(zones) {
	  return zones.map(function (zone) {
	    return {
	      label: zone.Name,
	      value: zone.id
	    };
	  });
	};
	
	var prcessBinData = function prcessBinData(bins) {
	  return bins.map(function (bin) {
	    return {
	      label: bin.section_num,
	      value: bin.id
	    };
	  });
	};
	
	var processLevelData = function processLevelData(levels) {
	  return levels.map(function (level) {
	    return {
	      label: level.bin_num,
	      value: level.id,
	      color: level.color
	    };
	  });
	};
	
	var initialTableData = {
	  rows: [],
	  selectedRow: {
	    label: '',
	    value: ''
	  }
	};
	
	var RowRenderer = function (_Component) {
	  _inherits(RowRenderer, _Component);
	
	  function RowRenderer() {
	    _classCallCheck(this, RowRenderer);
	
	    return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(RowRenderer, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { onDoubleClick: function onDoubleClick() {
	            _this2.props.onDoubleClick(_this2.props.row);
	          } },
	        _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: "row" }, this.props))
	      );
	    }
	  }]);
	
	  return RowRenderer;
	}(_react.Component);
	
	var LocationSelect = function (_Component2) {
	  _inherits(LocationSelect, _Component2);
	
	  function LocationSelect(props) {
	    _classCallCheck(this, LocationSelect);
	
	    var _this3 = _possibleConstructorReturn(this, (LocationSelect.__proto__ || Object.getPrototypeOf(LocationSelect)).call(this, props));
	
	    _this3.handleConfirmClick = function () {
	      var selectedRows = _this3.props.selectedRows;
	
	      var id = selectedRows[0] ? selectedRows[0].Customer_id : null;
	      var success = function success() {
	        alert('success');
	        _this3.props.setModalVisibility();
	      };
	      var failed = function failed() {
	        alert('failed');
	      };
	      (0, _apis.createWebUser)(id, _this3.state, success, failed);
	    };
	
	    _this3.renderLevelTable = function () {
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.levelTable);
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return Object.assign({}, rows[rowIdx]);
	      };
	
	      var columns = [{
	        key: 'label',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: "level" }),
	        resizable: true,
	        sortable: true,
	        // width: 200,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(_reactDataGrid2.default, {
	        rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: _this3.handleLevelSelect }),
	        columns: columns,
	        rowGetter: rowGetter,
	        rowsCount: getSize()
	      });
	    };
	
	    _this3.handleInputChange = function (field, _ref) {
	      var target = _ref.target;
	      var value = target.value;
	
	      _this3.setState(_defineProperty({}, field, value));
	    };
	
	    _this3.state = {
	      email: '',
	      password: '',
	      phone: ''
	    };
	    return _this3;
	  }
	
	  _createClass(LocationSelect, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // this.fetchZones();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { style: _defineProperty({ width: '100%', height: '100%', padding: '10px' }, "padding", '30px') },
	        _react2.default.createElement("div", { style: { display: 'flex', fontSize: '40px', flexDirection: 'row', textAlign: 'center', justifyContent: 'center', alignItems: 'center' } }),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "email" }),
	              ": "
	            ),
	            _react2.default.createElement(_reactBootstrap.Input, { type: "text", value: this.state.email, onChange: function onChange(e) {
	                return _this4.handleInputChange('email', e);
	              } })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "password" }),
	              ": "
	            ),
	            _react2.default.createElement(_reactBootstrap.Input, { type: "password", value: this.state.password, onChange: function onChange(e) {
	                return _this4.handleInputChange('password', e);
	              } })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "phone" }),
	              ": "
	            ),
	            _react2.default.createElement(_reactBootstrap.Input, { type: "text", value: this.state.phone, onChange: function onChange(e) {
	                return _this4.handleInputChange('phone', e);
	              } })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { width: '100%', justifyContent: 'end', alignContent: 'end', textAlign: 'end', alignItems: 'end', paddingTop: '40px' } },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: "primary",
	              className: "print-btn",
	              type: "button"
	              // disabled={selectedRows.length !== 1}
	              , onClick: this.handleConfirmClick
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "confirm" })
	          )
	        )
	      );
	    }
	  }]);
	
	  return LocationSelect;
	}(_react.Component);
	
	var WebUserModal = function WebUserModal(_ref3) {
	  var setModalVisibility = _ref3.setModalVisibility,
	      isVisible = _ref3.isVisible,
	      onConfirm = _ref3.onConfirm,
	      selectedRows = _ref3.selectedRows;
	  return _react2.default.createElement(
	    _reactSkylight.SkyLightStateless,
	    {
	      title: 'Web User',
	      onCloseClicked: setModalVisibility,
	      dialogStyles: modalStyle,
	      isVisible: isVisible
	    },
	    _react2.default.createElement(LocationSelect, { onConfirm: onConfirm, setModalVisibility: setModalVisibility, selectedRows: selectedRows })
	  );
	};
	
	WebUserModal.propTypes = propTypes;
	WebUserModal.defaultProps = defaultProps;
	
	var _default = WebUserModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(modalStyle, "modalStyle", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/generalManagement/WebUserModal.jsx");
	
	  __REACT_HOT_LOADER__.register(propTypes, "propTypes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/generalManagement/WebUserModal.jsx");
	
	  __REACT_HOT_LOADER__.register(defaultProps, "defaultProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/generalManagement/WebUserModal.jsx");
	
	  __REACT_HOT_LOADER__.register(prcessZoneData, "prcessZoneData", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/generalManagement/WebUserModal.jsx");
	
	  __REACT_HOT_LOADER__.register(prcessBinData, "prcessBinData", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/generalManagement/WebUserModal.jsx");
	
	  __REACT_HOT_LOADER__.register(processLevelData, "processLevelData", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/generalManagement/WebUserModal.jsx");
	
	  __REACT_HOT_LOADER__.register(initialTableData, "initialTableData", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/generalManagement/WebUserModal.jsx");
	
	  __REACT_HOT_LOADER__.register(RowRenderer, "RowRenderer", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/generalManagement/WebUserModal.jsx");
	
	  __REACT_HOT_LOADER__.register(LocationSelect, "LocationSelect", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/generalManagement/WebUserModal.jsx");
	
	  __REACT_HOT_LOADER__.register(WebUserModal, "WebUserModal", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/generalManagement/WebUserModal.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/generalManagement/WebUserModal.jsx");
	}();

	;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createWebUser = undefined;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createWebUser = exports.createWebUser = function createWebUser(id, payload, success, failed) {
	  (0, _axios2.default)({
	    method: 'POST',
	    url: _root_url.ROOT_URL + 'v1/customer/create_web_account/' + id,
	    data: payload,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    success();
	  }, function (err) {
	    alert(JSON.stringify(err.data));
	  });
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(createWebUser, 'createWebUser', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/generalManagement/apis.js');
	}();

	;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _WebUserModal = __webpack_require__(279);
	
	var _WebUserModal2 = _interopRequireDefault(_WebUserModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var generalManagement = {
	  WebUserModal: _WebUserModal2.default
	};
	var _default = generalManagement;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(generalManagement, 'generalManagement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/generalManagement/index.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/generalManagement/index.js');
	}();

	;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalStyle = {
	  width: '500px',
	  height: '200px',
	  marginLeft: '-10%'
	};
	
	var propTypes = {
	  // selectedSalesOrder: PropTypes.object
	};
	
	var defaultProps = {
	  // selectedSalesOrder: {},
	};
	
	var Confirmation = function Confirmation(_ref) {
	  var onConfirm = _ref.onConfirm;
	
	  return _react2.default.createElement(
	    "div",
	    { style: { justifyContent: 'center', alignContent: 'center' } },
	    _react2.default.createElement(
	      "h1",
	      { style: { textAlign: 'center' } },
	      "Void Selected Order?"
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Row,
	      { className: "centerStyle", style: { marginTop: "50px" } },
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: "danger",
	          onClick: function onClick(e) {
	            // this.handleOnSubmit(e);
	            onConfirm();
	          }
	          // disabled={!this.state.selectedDriver}
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: "void" })
	      )
	    )
	  );
	};
	
	var Modal = function Modal(_ref2) {
	  var setModalVisibility = _ref2.setModalVisibility,
	      isVisible = _ref2.isVisible,
	      onConfirm = _ref2.onConfirm;
	  return _react2.default.createElement(
	    _reactSkylight.SkyLightStateless,
	    {
	      title: 'Confirmation',
	      onCloseClicked: setModalVisibility,
	      dialogStyles: modalStyle,
	      isVisible: isVisible
	    },
	    _react2.default.createElement(Confirmation, { onConfirm: onConfirm, setModalVisibility: setModalVisibility })
	  );
	};
	
	Modal.propTypes = propTypes;
	Modal.defaultProps = defaultProps;
	
	var _default = Modal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(modalStyle, "modalStyle", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/rma/Confirmation.jsx");
	
	  __REACT_HOT_LOADER__.register(propTypes, "propTypes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/rma/Confirmation.jsx");
	
	  __REACT_HOT_LOADER__.register(defaultProps, "defaultProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/rma/Confirmation.jsx");
	
	  __REACT_HOT_LOADER__.register(Confirmation, "Confirmation", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/rma/Confirmation.jsx");
	
	  __REACT_HOT_LOADER__.register(Modal, "Modal", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/rma/Confirmation.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/rma/Confirmation.jsx");
	}();

	;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Confirmation = __webpack_require__(282);
	
	var _Confirmation2 = _interopRequireDefault(_Confirmation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rmaModals = {
	  Confirmation: _Confirmation2.default
	};
	
	var _default = rmaModals;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(rmaModals, 'rmaModals', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/rma/index.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/rma/index.js');
	}();

	;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BatchesModal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactSkylight = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  selectedOrders: _propTypes2.default.array
	};
	
	var defaultProps = {
	  selectedOrders: []
	};
	
	var modalStyle = {
	  width: '600px',
	  height: '200px',
	  marginLeft: '-10%'
	};
	
	var BatchesModal = exports.BatchesModal = function (_Component) {
	  _inherits(BatchesModal, _Component);
	
	  function BatchesModal() {
	    _classCallCheck(this, BatchesModal);
	
	    var _this = _possibleConstructorReturn(this, (BatchesModal.__proto__ || Object.getPrototypeOf(BatchesModal)).call(this));
	
	    _this.handleOnSubmit = function (e) {
	      var selectedBatch = _this.state.selectedBatch;
	
	      var batch = selectedBatch.value ? selectedBatch : _this.state.batchSelection[0];
	
	      _this.props.onSelectedBatch(batch.value, batch.expiredDate, batch.palletBarcode);
	    };
	
	    _this.handleBatchSelected = function (selectedBatch) {
	      return _this.setState({ selectedBatch: selectedBatch });
	    };
	
	    _this.processBatchSelection = function () {
	      var batches = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      var avaliableBatches = batches.filter(function (batch) {
	        if (_this.props.salesOrderProduct !== null) {
	          if (batch.quantity <= 0 && !_this.props.salesOrderProduct.IsOverSaleable) {
	            return false;
	          }
	        }
	        return true;
	      });
	      avaliableBatches = avaliableBatches.sort(function (a, b) {
	        if (a.expire_datetime > b.expire_datetime) {
	          return 1;
	        }
	        return -1;
	      });
	      avaliableBatches = avaliableBatches.map(function (batch) {
	        return {
	          label: "  \n        " + batch.batch_num + ": " + batch.inventory_qty + "\n        " + (batch.location ? "- Location: " + batch.location : '- Location: N/A') + "\n        " + (batch.pallet_barcode ? "- PLT barcode: " + batch.pallet_barcode : '- PLT barcode: N/A'),
	          value: batch.id,
	          expiredDate: batch.expire_datetime,
	          palletBarcode: batch.pallet_barcode
	        };
	      });
	      return avaliableBatches;
	    };
	
	    _this.state = {
	      selectedBatch: {
	        label: 'default',
	        value: null
	      },
	      batchSelection: []
	    };
	    return _this;
	  }
	
	  _createClass(BatchesModal, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.batchesInfo.batches !== nextProps.batchesInfo.batches) {
	        this.setState({
	          batchSelection: this.processBatchSelection(nextProps.batchesInfo.batches)
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var selectedBatch = this.state.selectedBatch;
	      var _props = this.props,
	          setModalVisibility = _props.setModalVisibility,
	          isVisible = _props.isVisible;
	      // const batchSelection = this.processBatchSelection(this.props.batchesInfo.batches);
	
	      return _react2.default.createElement(
	        _reactSkylight.SkyLightStateless,
	        {
	          title: 'Select Batch',
	          onCloseClicked: setModalVisibility,
	          dialogStyles: modalStyle,
	          isVisible: isVisible
	        },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { style: { marginBottom: "12px" } },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 3 },
	              _react2.default.createElement(
	                "label",
	                { style: { float: 'right' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: "selecte_batch" }),
	                ":"
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 9 },
	              _react2.default.createElement(
	                _reactBootstrap.Dropdown,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Dropdown.Toggle,
	                  {
	                    style: {
	                      width: "400px",
	                      backgroundColor: "white",
	                      border: "1px solid #555555",
	                      color: "black",
	                      fontWeight: "400"
	                    }
	                  },
	                  selectedBatch.label || selectedBatch
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Dropdown.Menu,
	                  { className: "super-colors" },
	                  this.state.batchSelection.map(function (batch) {
	                    return _react2.default.createElement(
	                      _reactBootstrap.MenuItem,
	                      { onClick: function onClick() {
	                          return _this2.handleBatchSelected(batch);
	                        }, style: {
	                          width: "400px",
	                          backgroundColor: "white",
	                          color: "black",
	                          fontWeight: "400"
	                        } },
	                      batch.label
	                    );
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: "centerStyle", style: { marginTop: "50px" } },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: "success",
	                onClick: function onClick(e) {
	                  _this2.handleOnSubmit(e);
	                }
	              },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "select_this_batch" })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BatchesModal;
	}(_react.Component);
	
	BatchesModal.propTypes = propTypes;
	BatchesModal.defaultProps = defaultProps;
	
	var _default = BatchesModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(BatchesModal, "BatchesModal", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/BatchesModal.jsx");
	
	  __REACT_HOT_LOADER__.register(propTypes, "propTypes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/BatchesModal.jsx");
	
	  __REACT_HOT_LOADER__.register(defaultProps, "defaultProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/BatchesModal.jsx");
	
	  __REACT_HOT_LOADER__.register(modalStyle, "modalStyle", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/BatchesModal.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/BatchesModal.jsx");
	}();

	;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _inputField = __webpack_require__(16);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	var _datePicker = __webpack_require__(27);
	
	var _selection = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var changeDeliveryTime = function changeDeliveryTime(data, success, sales_order_id) {
	  (0, _axios2.default)({
	    method: 'PUT',
	    url: _root_url.ROOT_URL + "v1/sale/sales_order/" + sales_order_id + "/dispatch_date",
	    data: data,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    success();
	  }, function (err) {
	    console.log(err);
	    // alert(err.statusText);
	  });
	};
	
	var fetchDeliveryTime = function fetchDeliveryTime(cb) {
	  (0, _axios2.default)({
	    method: 'GET',
	    url: _root_url.ROOT_URL + "v1/mobile/delivery_time",
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    cb(res.data);
	  }, function (err) {
	    console.log(err);
	    // alert(err.statusText);
	  });
	};
	
	var fetchDeliveryTimeNext = function fetchDeliveryTimeNext(cb) {
	  (0, _axios2.default)({
	    method: 'GET',
	    url: _root_url.ROOT_URL + "v1/mobile/delivery_time_next",
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    cb(res.data);
	  }, function (err) {
	    console.log(err);
	    // alert(err.statusText);
	  });
	};
	
	var modalStyle = {
	  width: '300px',
	  height: '220px',
	  marginLeft: '-5%'
	};
	
	var propTypes = {
	  selectedRows: _propTypes2.default.array,
	  onSuccess: _propTypes2.default.func
	};
	
	var defaultProps = {
	  onSuccess: function onSuccess() {},
	  selectedRows: []
	};
	
	var form = function (_Component) {
	  _inherits(form, _Component);
	
	  function form() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, form);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = form.__proto__ || Object.getPrototypeOf(form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      DispatchDateOptions: []
	    }, _this.handleFormSubmit = function (formProps) {
	      if (!formProps.DispatchDate) return;
	      var success = function success() {
	        _this.props.onSuccess();
	      };
	      changeDeliveryTime({
	        DispatchDate: formProps.DispatchDate.value
	      }, success, _this.props.selectedRows[0].SalesOrder_id);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(form, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      fetchDeliveryTime(function (date1) {
	        fetchDeliveryTimeNext(function (date2) {
	          var DispatchDateOptions = [].concat(_toConsumableArray(date1), _toConsumableArray(date2)).map(function (d) {
	            return {
	              label: d.name,
	              value: d.value
	            };
	          });
	          _this2.setState({
	            DispatchDateOptions: DispatchDateOptions
	          });
	        });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var handleSubmit = this.props.handleSubmit;
	
	      return _react2.default.createElement(
	        "form",
	        { style: { width: '100%', padding: '10px' } },
	        _react2.default.createElement(
	          "div",
	          { className: "form-group", style: { marginTop: '10px' } },
	          _react2.default.createElement(
	            "div",
	            { className: "col-xs-12" },
	            _react2.default.createElement(_reduxForm.Field, { name: "DispatchDate", component: _selection.Selection, options: this.state.DispatchDateOptions })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '100%', marginTop: '70px' } },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: "primary",
	              className: "print-btn",
	              type: "button",
	              onClick: this.props.setModalVisibility
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "cancel" })
	          ),
	          _react2.default.createElement("span", { style: { width: '50px' } }),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: "success",
	              className: "print-btn",
	              type: "button",
	              onClick: handleSubmit(this.handleFormSubmit)
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "confirm" })
	          )
	        )
	      );
	    }
	  }]);
	
	  return form;
	}(_react.Component);
	
	var DeliveryTimeChangeForm = (0, _reduxForm.reduxForm)({
	  // a unique name for the form
	  form: 'DeliveryTimeChangeForm',
	  enableReinitialize: true
	})(form);
	
	var DeliveryTimeChange = function DeliveryTimeChange(_ref2) {
	  var setModalVisibility = _ref2.setModalVisibility,
	      isVisible = _ref2.isVisible,
	      estDeliveryEditingSOID = _ref2.estDeliveryEditingSOID,
	      selectedRows = _ref2.selectedRows,
	      onSuccess = _ref2.onSuccess;
	  return _react2.default.createElement(
	    _reactSkylight.SkyLightStateless,
	    {
	      title: 'Delivery Time',
	      onCloseClicked: setModalVisibility,
	      dialogStyles: modalStyle,
	      isVisible: isVisible
	    },
	    _react2.default.createElement(DeliveryTimeChangeForm, { setModalVisibility: setModalVisibility, estDeliveryEditingSOID: estDeliveryEditingSOID, selectedRows: selectedRows, onSuccess: onSuccess })
	  );
	};
	
	DeliveryTimeChange.propTypes = propTypes;
	DeliveryTimeChange.defaultProps = defaultProps;
	
	var _default = DeliveryTimeChange;
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(changeDeliveryTime, "changeDeliveryTime", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/DeliveryTimeChange.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchDeliveryTime, "fetchDeliveryTime", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/DeliveryTimeChange.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchDeliveryTimeNext, "fetchDeliveryTimeNext", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/DeliveryTimeChange.jsx");
	
	  __REACT_HOT_LOADER__.register(modalStyle, "modalStyle", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/DeliveryTimeChange.jsx");
	
	  __REACT_HOT_LOADER__.register(propTypes, "propTypes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/DeliveryTimeChange.jsx");
	
	  __REACT_HOT_LOADER__.register(defaultProps, "defaultProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/DeliveryTimeChange.jsx");
	
	  __REACT_HOT_LOADER__.register(form, "form", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/DeliveryTimeChange.jsx");
	
	  __REACT_HOT_LOADER__.register(DeliveryTimeChangeForm, "DeliveryTimeChangeForm", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/DeliveryTimeChange.jsx");
	
	  __REACT_HOT_LOADER__.register(DeliveryTimeChange, "DeliveryTimeChange", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/DeliveryTimeChange.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/DeliveryTimeChange.jsx");
	}();

	;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reduxForm = __webpack_require__(3);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(6);
	
	var _inputField = __webpack_require__(16);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	var _datePicker = __webpack_require__(27);
	
	var _selection = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var changeDeliveryTime = function changeDeliveryTime(data, success, sales_order_id) {
	  (0, _axios2.default)({
	    method: 'PUT',
	    url: _root_url.ROOT_URL + "v1/sale/sales_order/" + sales_order_id + "/dispatch_date",
	    data: data,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    success();
	  }, function (err) {
	    console.log(err);
	    // alert(err.statusText);
	  });
	};
	
	// PUT--------    {{url}}v1/oversea-warehouse/change_location/37?location=222
	var fetchAvaliablePickupTime = function fetchAvaliablePickupTime(date, success) {
	  (0, _axios2.default)({
	    method: 'GET',
	    url: _root_url.ROOT_URL + "v1/mobile/pickup_time?pickup_date=" + date,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    console.log('res', res);
	    success(res.data);
	  }, function (err) {
	    console.log(err);
	    // alert(err.statusText);
	  });
	};
	
	var modalStyle = {
	  width: '350px',
	  height: '150px',
	  marginLeft: '-5%'
	};
	
	var propTypes = {
	  onSuccess: _propTypes2.default.func
	};
	
	var defaultProps = {
	  onSuccess: function onSuccess() {}
	};
	
	var form = function (_Component) {
	  _inherits(form, _Component);
	
	  function form() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, form);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = form.__proto__ || Object.getPrototypeOf(form)).call.apply(_ref, [this].concat(args))), _this), _this.renderUploadInputs = function () {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement("input", {
	          type: "file",
	          style: { display: "none" },
	          onClick: function onClick(e) {
	            e.target.value = null;
	          },
	          onChange: function onChange(e) {
	            var formData = new FormData();
	            formData.append("FILE", e.target.files[0]);
	            if (e.target.files[0]) {
	              _axios2.default.post(_root_url.ROOT_URL + "v2/import_orders_tn", formData, {
	                headers: {
	                  Authorization: "Bearer " + localStorage.getItem("token")
	                }
	              }).then(function (res) {
	                alert("SO Imported Successfully");
	                _this.props.onSuccess();
	              }, function (err) {
	                if (err.data) {
	                  alert(err.data);
	                } else {
	                  alert("Server issue detected, please contact admin.");
	                }
	              });
	            }
	          },
	          ref: "msoCreateInputRef"
	        }),
	        _react2.default.createElement("input", {
	          type: "file",
	          style: { display: "none" },
	          onClick: function onClick(e) {
	            e.target.value = null;
	          },
	          onChange: function onChange(e) {
	            var formData = new FormData();
	            formData.append("FILE", e.target.files[0]);
	            if (e.target.files[0]) {
	              _axios2.default.post(_root_url.ROOT_URL + "v2/tn_order_import_original", formData, {
	                headers: {
	                  Authorization: "Bearer " + localStorage.getItem("token")
	                }
	              }).then(function (res) {
	                alert("SO Imported Successfully");
	                _this.props.onSuccess();
	              }, function (err) {
	                if (err.data) {
	                  alert(err.data);
	                } else {
	                  alert("Server issue detected, please contact admin.");
	                }
	              });
	            }
	          },
	          ref: "msoCreateInputRefOriginal"
	        })
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(form, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var handleSubmit = this.props.handleSubmit;
	
	      return _react2.default.createElement(
	        "form",
	        { style: { width: '100%', padding: '10px' } },
	        this.renderUploadInputs(),
	        _react2.default.createElement(
	          "div",
	          { style: { display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '100%', marginTop: '10px' } },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: "primary",
	              className: "print-btn",
	              type: "button",
	              onClick: function onClick() {
	                _this2.refs.msoCreateInputRefOriginal.click();
	              }
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "original" })
	          ),
	          _react2.default.createElement("span", { style: { width: '50px' } }),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: "primary",
	              className: "print-btn",
	              type: "button",
	              onClick: function onClick() {
	                _this2.refs.msoCreateInputRef.click();
	              }
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "new" })
	          )
	        )
	      );
	    }
	  }]);
	
	  return form;
	}(_react.Component);
	
	var formName = 'excelUploadOption';
	
	var selector = (0, _reduxForm.formValueSelector)(formName);
	
	var ExcelUploadOptionForm = (0, _reduxForm.reduxForm)({
	  // a unique name for the form
	  form: formName,
	  enableReinitialize: true
	})(form);
	
	var ExcelUploadOption = function ExcelUploadOption(_ref2) {
	  var setModalVisibility = _ref2.setModalVisibility,
	      isVisible = _ref2.isVisible,
	      onSuccess = _ref2.onSuccess;
	  return _react2.default.createElement(
	    _reactSkylight.SkyLightStateless,
	    {
	      title: 'Upload Options',
	      onCloseClicked: setModalVisibility,
	      dialogStyles: modalStyle,
	      isVisible: isVisible
	    },
	    _react2.default.createElement(ExcelUploadOptionForm, {
	      setModalVisibility: setModalVisibility,
	      onSuccess: onSuccess
	    })
	  );
	};
	
	ExcelUploadOption.propTypes = propTypes;
	ExcelUploadOption.defaultProps = defaultProps;
	
	var mapState = function mapState(state) {
	  return {
	    date: selector(state, 'date')
	  };
	};
	var mapProps = function mapProps(dispatch) {
	  return {
	    setFormValue: function setFormValue(field, value) {
	      dispatch((0, _reduxForm.change)(formName, field, value));
	    }
	  };
	};
	
	var _default = (0, _reactRedux.connect)(mapState, mapProps)(ExcelUploadOption);
	
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(changeDeliveryTime, "changeDeliveryTime", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ExcelUploadOption.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchAvaliablePickupTime, "fetchAvaliablePickupTime", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ExcelUploadOption.jsx");
	
	  __REACT_HOT_LOADER__.register(modalStyle, "modalStyle", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ExcelUploadOption.jsx");
	
	  __REACT_HOT_LOADER__.register(propTypes, "propTypes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ExcelUploadOption.jsx");
	
	  __REACT_HOT_LOADER__.register(defaultProps, "defaultProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ExcelUploadOption.jsx");
	
	  __REACT_HOT_LOADER__.register(form, "form", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ExcelUploadOption.jsx");
	
	  __REACT_HOT_LOADER__.register(formName, "formName", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ExcelUploadOption.jsx");
	
	  __REACT_HOT_LOADER__.register(selector, "selector", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ExcelUploadOption.jsx");
	
	  __REACT_HOT_LOADER__.register(ExcelUploadOptionForm, "ExcelUploadOptionForm", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ExcelUploadOption.jsx");
	
	  __REACT_HOT_LOADER__.register(ExcelUploadOption, "ExcelUploadOption", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ExcelUploadOption.jsx");
	
	  __REACT_HOT_LOADER__.register(mapState, "mapState", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ExcelUploadOption.jsx");
	
	  __REACT_HOT_LOADER__.register(mapProps, "mapProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ExcelUploadOption.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ExcelUploadOption.jsx");
	}();

	;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateSalesOrder = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _inputField = __webpack_require__(16);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	var _datePicker = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// PUT--------    {{url}}v1/oversea-warehouse/change_location/37?location=222
	
	var updateSalesOrder = exports.updateSalesOrder = function updateSalesOrder(salesOrderId, payload, success) {
	  (0, _axios2.default)({
	    method: 'PUT',
	    url: _root_url.ROOT_URL + "v1/oversea-warehouse/update-bol-info/" + salesOrderId,
	    data: payload,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    success();
	  }, function (err) {
	    console.log(err);
	    // alert(err.statusText);
	  });
	};
	
	var modalStyle = {
	  width: '500px',
	  height: '420px',
	  marginLeft: '-10%'
	};
	
	var propTypes = {
	  selectedRows: _propTypes2.default.array,
	  onSuccess: _propTypes2.default.func
	};
	
	var defaultProps = {
	  onSuccess: function onSuccess() {},
	  selectedRows: []
	};
	
	var InboundDateChangeForm = function (_Component) {
	  _inherits(InboundDateChangeForm, _Component);
	
	  function InboundDateChangeForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InboundDateChangeForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InboundDateChangeForm.__proto__ || Object.getPrototypeOf(InboundDateChangeForm)).call.apply(_ref, [this].concat(args))), _this), _this.handleConfirmClick = function (form) {
	      var ESTInboundDate = form.ESTInboundDate,
	          IsaNo = form.IsaNo,
	          Reason = form.Reason,
	          Location = form.Location,
	          PickUpDriverName = form.PickUpDriverName,
	          OutboundDriverName = form.OutboundDriverName,
	          ContainerNo = form.ContainerNo,
	          CustomerBOL = form.CustomerBOL;
	      var _this$props = _this.props,
	          selectedRows = _this$props.selectedRows,
	          onSuccess = _this$props.onSuccess;
	
	
	      var inboundDate = ESTInboundDate ? new Date(ESTInboundDate).toISOString() : '';
	
	      var payload = {
	        BOLInfo: {
	          ESTInboundDate: inboundDate,
	          IsaNo: IsaNo,
	          Reason: Reason,
	          Location: Location,
	          PickUpDriverName: PickUpDriverName,
	          OutboundDriverName: OutboundDriverName,
	          ContainerNo: ContainerNo,
	          CustomerBOL: CustomerBOL
	        }
	      };
	      updateSalesOrder(selectedRows[0].SalesOrder_id, payload, onSuccess);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InboundDateChangeForm, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _props = this.props,
	          _props$selectedRows = _slicedToArray(_props.selectedRows, 1),
	          row = _props$selectedRows[0],
	          change = _props.change;
	
	      change('CustomerBOL', row.CustomerBOLNo);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          handleSubmit = _props2.handleSubmit,
	          setModalVisibility = _props2.setModalVisibility;
	
	      return _react2.default.createElement(
	        "form",
	        { style: { width: '100%', padding: '10px' } },
	        _react2.default.createElement(
	          "div",
	          { className: "form-group", style: { marginTop: '10px' } },
	          _react2.default.createElement(
	            "label",
	            { className: "col-xs-5" },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "inbound_date" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-xs-7" },
	            _react2.default.createElement(_reduxForm.Field, { name: "ESTInboundDate", component: _datePicker.StartOfThisMonthDatePicker })
	          )
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "div",
	          { className: "form-group", style: { marginTop: '10px' } },
	          _react2.default.createElement(
	            "label",
	            { className: "col-xs-5" },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "isa_no" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-xs-7" },
	            _react2.default.createElement(_reduxForm.Field, { name: "IsaNo", component: _inputField.InputField })
	          )
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "div",
	          { className: "form-group", style: { marginTop: '10px' } },
	          _react2.default.createElement(
	            "label",
	            { className: "col-xs-5" },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "reason" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-xs-7" },
	            _react2.default.createElement(_reduxForm.Field, { name: "Reason", component: _inputField.InputField })
	          )
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "div",
	          { className: "form-group", style: { marginTop: '10px' } },
	          _react2.default.createElement(
	            "label",
	            { className: "col-xs-5" },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "location" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-xs-7" },
	            _react2.default.createElement(_reduxForm.Field, { name: "Location", component: _inputField.InputField })
	          )
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "div",
	          { className: "form-group", style: { marginTop: '10px' } },
	          _react2.default.createElement(
	            "label",
	            { className: "col-xs-5" },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "container_no" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-xs-7" },
	            _react2.default.createElement(_reduxForm.Field, { name: "ContainerNo", component: _inputField.InputField })
	          )
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "div",
	          { className: "form-group", style: { marginTop: '10px' } },
	          _react2.default.createElement(
	            "label",
	            { className: "col-xs-5" },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "customer_bol" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-xs-7" },
	            _react2.default.createElement(_reduxForm.Field, { name: "CustomerBOL", component: _inputField.InputField })
	          )
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "div",
	          { className: "form-group", style: { marginTop: '10px' } },
	          _react2.default.createElement(
	            "label",
	            { className: "col-xs-5" },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "pick_up_driver" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-xs-7" },
	            _react2.default.createElement(_reduxForm.Field, { name: "PickUpDriverName", component: _inputField.InputField })
	          )
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "div",
	          { className: "form-group", style: { marginTop: '10px' } },
	          _react2.default.createElement(
	            "label",
	            { className: "col-xs-5" },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "outbound_driver" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-xs-7" },
	            _react2.default.createElement(_reduxForm.Field, { name: "OutboundDriverName", component: _inputField.InputField })
	          )
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "div",
	          { style: { display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '100%', marginTop: '15px' } },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: "success",
	              className: "print-btn",
	              type: "button",
	              onClick: handleSubmit(this.handleConfirmClick)
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "confirm" })
	          ),
	          _react2.default.createElement("span", { style: { width: '50px' } }),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: "primary",
	              className: "print-btn",
	              type: "button",
	              onClick: function onClick() {
	                return setModalVisibility();
	              }
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "cancel" })
	          )
	        )
	      );
	    }
	  }]);
	
	  return InboundDateChangeForm;
	}(_react.Component);
	
	var RDInboundDateChangeForm = (0, _reduxForm.reduxForm)({
	  // a unique name for the form
	  form: 'InboundDateChangeForm',
	  enableReinitialize: true
	})(InboundDateChangeForm);
	
	var InboundDateChange = function InboundDateChange(_ref2) {
	  var setModalVisibility = _ref2.setModalVisibility,
	      isVisible = _ref2.isVisible,
	      onSuccess = _ref2.onSuccess,
	      selectedRows = _ref2.selectedRows;
	  return _react2.default.createElement(
	    _reactSkylight.SkyLightStateless,
	    {
	      title: 'Sales Order Edit',
	      onCloseClicked: setModalVisibility,
	      dialogStyles: modalStyle,
	      isVisible: isVisible
	    },
	    _react2.default.createElement(RDInboundDateChangeForm, { initialValues: selectedRows[0], selectedRows: selectedRows, onSuccess: onSuccess, setModalVisibility: setModalVisibility })
	  );
	};
	
	InboundDateChange.propTypes = propTypes;
	InboundDateChange.defaultProps = defaultProps;
	
	var _default = InboundDateChange;
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(updateSalesOrder, "updateSalesOrder", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/InboundDateChange.jsx");
	
	  __REACT_HOT_LOADER__.register(modalStyle, "modalStyle", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/InboundDateChange.jsx");
	
	  __REACT_HOT_LOADER__.register(propTypes, "propTypes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/InboundDateChange.jsx");
	
	  __REACT_HOT_LOADER__.register(defaultProps, "defaultProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/InboundDateChange.jsx");
	
	  __REACT_HOT_LOADER__.register(InboundDateChangeForm, "InboundDateChangeForm", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/InboundDateChange.jsx");
	
	  __REACT_HOT_LOADER__.register(RDInboundDateChangeForm, "RDInboundDateChangeForm", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/InboundDateChange.jsx");
	
	  __REACT_HOT_LOADER__.register(InboundDateChange, "InboundDateChange", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/InboundDateChange.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/InboundDateChange.jsx");
	}();

	;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// PUT--------    {{url}}v1/oversea-warehouse/change_location/37?location=222
	
	// export const updateLocation = (salesOrderId, location, success) => {
	//   axios({
	//     method: 'PUT',
	//     url: `${ROOT_URL}v1/oversea-warehouse/change_location/${salesOrderId}?location=${location}`,
	//     headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	//   })
	//   .then(res => {
	//     success();
	//   }, err => {
	//     alert(err.statusText);
	//   })
	// }
	var styles = {
	  label: {
	    textDecoration: 'underline',
	    fontSize: '17px',
	    fontWeight: 'bold',
	    cursor: 'pointer'
	  }
	};
	
	var modalStyle = {
	  width: '500px',
	  height: '300px',
	  marginLeft: '-10%'
	};
	
	var propTypes = {
	  selectedRows: _propTypes2.default.array,
	  onSuccess: _propTypes2.default.func
	};
	
	var defaultProps = {
	  onSuccess: function onSuccess() {},
	  selectedRows: []
	};
	
	var LabelPrint = function (_Component) {
	  _inherits(LabelPrint, _Component);
	
	  function LabelPrint() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LabelPrint);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LabelPrint.__proto__ || Object.getPrototypeOf(LabelPrint)).call.apply(_ref, [this].concat(args))), _this), _this.generateShippingLabels = function () {
	      if (!_this.props.salesOrders.selectedRows.length) {
	        return [];
	      }
	      if (!_this.props.salesOrders.selectedRows[0].PartialShipments) {
	        return "No Label Found";
	      }
	
	      return _this.props.salesOrders.selectedRows[0].PartialShipments.split(',').map(function (label) {
	        return _react2.default.createElement(
	          "li",
	          { style: styles.label, onClick: function onClick() {
	              return _this.handleLabelClick(label);
	            } },
	          label
	        );
	      });
	    }, _this.handleLabelClick = function (label) {
	      _this.props.printPickingListPartial(label);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	  // constructor(props) {
	  //   super(props);
	  //   this.state = {
	  //     location: props.selectedRows.length ? props.selectedRows[0].Location : '',
	  //   };
	  // }
	
	  // componentDidUpdate(prevProps,prevState){
	  //   if (prevProps.selectedRows[0] !== this.props.selectedRows[0]) {
	  //     this.setState({
	  //       location: this.props.selectedRows[0] ? this.props.selectedRows[0].Location : ''
	  //     })
	  //   }
	  // }
	
	  // handleConfirmClick = () => {
	  //   const {
	  //     selectedRows,
	  //     onSuccess,
	  //   } = this.props;
	  //   const {
	  //     location,
	  //   } = this.state;
	  //   updateLocation(selectedRows[0].SalesOrder_id, location, onSuccess);
	  // }
	
	
	  _createClass(LabelPrint, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { style: { width: '100%', height: '80%', padding: '10px', overflow: 'auto' } },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "ul",
	            null,
	            this.generateShippingLabels()
	          )
	        )
	      );
	    }
	  }]);
	
	  return LabelPrint;
	}(_react.Component);
	
	var LabelPrintModal = function LabelPrintModal(_ref2) {
	  var setModalVisibility = _ref2.setModalVisibility,
	      isVisible = _ref2.isVisible,
	      salesOrders = _ref2.salesOrders,
	      printPickingListPartial = _ref2.printPickingListPartial;
	  return _react2.default.createElement(
	    _reactSkylight.SkyLightStateless,
	    {
	      title: 'Partial Shipments',
	      onCloseClicked: setModalVisibility,
	      dialogStyles: modalStyle,
	      isVisible: isVisible
	    },
	    _react2.default.createElement(LabelPrint, { salesOrders: salesOrders, printPickingListPartial: printPickingListPartial })
	  );
	};
	
	LabelPrintModal.propTypes = propTypes;
	LabelPrintModal.defaultProps = defaultProps;
	
	var _default = LabelPrintModal;
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, "styles", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/LabelPrintModal.jsx");
	
	  __REACT_HOT_LOADER__.register(modalStyle, "modalStyle", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/LabelPrintModal.jsx");
	
	  __REACT_HOT_LOADER__.register(propTypes, "propTypes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/LabelPrintModal.jsx");
	
	  __REACT_HOT_LOADER__.register(defaultProps, "defaultProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/LabelPrintModal.jsx");
	
	  __REACT_HOT_LOADER__.register(LabelPrint, "LabelPrint", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/LabelPrintModal.jsx");
	
	  __REACT_HOT_LOADER__.register(LabelPrintModal, "LabelPrintModal", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/LabelPrintModal.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/LabelPrintModal.jsx");
	}();

	;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateLocation = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// PUT--------    {{url}}v1/oversea-warehouse/change_location/37?location=222
	
	var updateLocation = exports.updateLocation = function updateLocation(salesOrderId, location, success) {
	  (0, _axios2.default)({
	    method: 'PUT',
	    url: _root_url.ROOT_URL + "v1/oversea-warehouse/change_location/" + salesOrderId + "?location=" + location,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    success();
	  }, function (err) {
	    alert(err.statusText);
	  });
	};
	
	var modalStyle = {
	  width: '500px',
	  height: '300px',
	  marginLeft: '-10%'
	};
	
	var propTypes = {
	  selectedRows: _propTypes2.default.array,
	  onSuccess: _propTypes2.default.func
	};
	
	var defaultProps = {
	  onSuccess: function onSuccess() {},
	  selectedRows: []
	};
	
	var LocationChangeForm = function (_Component) {
	  _inherits(LocationChangeForm, _Component);
	
	  function LocationChangeForm(props) {
	    _classCallCheck(this, LocationChangeForm);
	
	    var _this = _possibleConstructorReturn(this, (LocationChangeForm.__proto__ || Object.getPrototypeOf(LocationChangeForm)).call(this, props));
	
	    _this.handleConfirmClick = function () {
	      var _this$props = _this.props,
	          selectedRows = _this$props.selectedRows,
	          onSuccess = _this$props.onSuccess;
	      var location = _this.state.location;
	
	      updateLocation(selectedRows[0].SalesOrder_id, location, onSuccess);
	    };
	
	    _this.state = {
	      location: props.selectedRows.length ? props.selectedRows[0].Location : ''
	    };
	    return _this;
	  }
	
	  _createClass(LocationChangeForm, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevProps.selectedRows[0] !== this.props.selectedRows[0]) {
	        this.setState({
	          location: this.props.selectedRows[0] ? this.props.selectedRows[0].Location : ''
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { style: { width: '100%', height: '100%', padding: '10px' } },
	        _react2.default.createElement(
	          "h4",
	          null,
	          "Location Change"
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement("input", {
	            type: "text",
	            style: {
	              width: '200px',
	              border: '1px solid black',
	              padding: '2px',
	              borderRadius: '5px',
	              marginBottom: '10px'
	            },
	            onChange: function onChange(_ref) {
	              var target = _ref.target;
	              return _this2.setState({
	                location: target.value
	              });
	            },
	            value: this.state.location
	          })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: "primary",
	            className: "print-btn",
	            type: "button"
	            // disabled={selectedRows.length !== 1}
	            , onClick: function onClick() {
	              _this2.handleConfirmClick();
	            }
	          },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: "confirm" })
	        )
	      );
	    }
	  }]);
	
	  return LocationChangeForm;
	}(_react.Component);
	
	var LocationChange = function LocationChange(_ref2) {
	  var setModalVisibility = _ref2.setModalVisibility,
	      isVisible = _ref2.isVisible,
	      onSuccess = _ref2.onSuccess,
	      selectedRows = _ref2.selectedRows;
	  return _react2.default.createElement(
	    _reactSkylight.SkyLightStateless,
	    {
	      title: 'Edit Location',
	      onCloseClicked: setModalVisibility,
	      dialogStyles: modalStyle,
	      isVisible: isVisible
	    },
	    _react2.default.createElement(LocationChangeForm, { selectedRows: selectedRows, onSuccess: onSuccess })
	  );
	};
	
	LocationChange.propTypes = propTypes;
	LocationChange.defaultProps = defaultProps;
	
	var _default = LocationChange;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(updateLocation, "updateLocation", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/LocationChange.jsx");
	
	  __REACT_HOT_LOADER__.register(modalStyle, "modalStyle", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/LocationChange.jsx");
	
	  __REACT_HOT_LOADER__.register(propTypes, "propTypes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/LocationChange.jsx");
	
	  __REACT_HOT_LOADER__.register(defaultProps, "defaultProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/LocationChange.jsx");
	
	  __REACT_HOT_LOADER__.register(LocationChangeForm, "LocationChangeForm", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/LocationChange.jsx");
	
	  __REACT_HOT_LOADER__.register(LocationChange, "LocationChange", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/LocationChange.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/LocationChange.jsx");
	}();

	;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalStyle = {
	  width: '500px',
	  height: '300px',
	  marginLeft: '-10%'
	};
	
	var propTypes = {
	  selectedSalesOrder: _propTypes2.default.object
	};
	
	var defaultProps = {
	  selectedSalesOrder: {}
	};
	
	var testNoteComponent = function testNoteComponent(_ref) {
	  var _ref$input = _ref.input,
	      onChange = _ref$input.onChange,
	      value = _ref$input.value;
	  return _react2.default.createElement("textarea", {
	    onChange: onChange,
	    value: value,
	    style: {
	      width: '100%',
	      height: '78%',
	      border: '1px solid black'
	    }
	  });
	};
	
	var Notes = function Notes(_ref2) {
	  var setModalVisibility = _ref2.setModalVisibility,
	      isVisible = _ref2.isVisible;
	  return _react2.default.createElement(
	    _reactSkylight.SkyLightStateless,
	    {
	      title: 'Edit Notes',
	      onCloseClicked: setModalVisibility,
	      dialogStyles: modalStyle,
	      isVisible: isVisible
	    },
	    _react2.default.createElement(_reduxForm.Field, { name: "Notes", component: testNoteComponent })
	  );
	};
	
	Notes.propTypes = propTypes;
	Notes.defaultProps = defaultProps;
	
	var _default = Notes;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(modalStyle, "modalStyle", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/Notes.jsx");
	
	  __REACT_HOT_LOADER__.register(propTypes, "propTypes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/Notes.jsx");
	
	  __REACT_HOT_LOADER__.register(defaultProps, "defaultProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/Notes.jsx");
	
	  __REACT_HOT_LOADER__.register(testNoteComponent, "testNoteComponent", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/Notes.jsx");
	
	  __REACT_HOT_LOADER__.register(Notes, "Notes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/Notes.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/Notes.jsx");
	}();

	;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reduxForm = __webpack_require__(3);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(6);
	
	var _inputField = __webpack_require__(16);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	var _datePicker = __webpack_require__(27);
	
	var _selection = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var changeDeliveryTime = function changeDeliveryTime(data, success, sales_order_id) {
	  (0, _axios2.default)({
	    method: 'PUT',
	    url: _root_url.ROOT_URL + "v1/sale/sales_order/" + sales_order_id + "/dispatch_date",
	    data: data,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    success();
	  }, function (err) {
	    console.log(err);
	    // alert(err.statusText);
	  });
	};
	
	// PUT--------    {{url}}v1/oversea-warehouse/change_location/37?location=222
	var fetchAvaliablePickupTime = function fetchAvaliablePickupTime(date, success) {
	  (0, _axios2.default)({
	    method: 'GET',
	    url: _root_url.ROOT_URL + "v1/mobile/pickup_time?pickup_date=" + date,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    console.log('res', res);
	    success(res.data);
	  }, function (err) {
	    console.log(err);
	    // alert(err.statusText);
	  });
	};
	
	var modalStyle = {
	  width: '300px',
	  height: '270px',
	  marginLeft: '-5%'
	};
	
	var propTypes = {
	  selectedRows: _propTypes2.default.array,
	  onSuccess: _propTypes2.default.func
	};
	
	var defaultProps = {
	  onSuccess: function onSuccess() {},
	  selectedRows: []
	};
	
	var form = function (_Component) {
	  _inherits(form, _Component);
	
	  function form() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, form);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = form.__proto__ || Object.getPrototypeOf(form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      DispatchDateOptions: []
	    }, _this.handleFormSubmit = function (formProps) {
	      if (!formProps.DispatchDate) return;
	      var success = function success() {
	        _this.props.onSuccess();
	      };
	      changeDeliveryTime({
	        DispatchDate: formProps.DispatchDate.value
	      }, success, _this.props.selectedRows[0].SalesOrder_id);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(form, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this2 = this;
	
	      if (prevProps.date !== this.props.date && this.props.date) {
	        this.props.setFormValue('DispatchDate', null);
	        this.setState({
	          DispatchDateOptions: []
	        });
	        var pickupDate = (0, _moment2.default)(this.props.date).format('YYYY-MM-DD');
	        fetchAvaliablePickupTime(pickupDate, function (pickupTimes) {
	          _this2.setState({
	            DispatchDateOptions: pickupTimes.map(function (time) {
	              return {
	                label: time.name,
	                value: time.value
	              };
	            })
	          });
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var handleSubmit = this.props.handleSubmit;
	
	      return _react2.default.createElement(
	        "form",
	        { style: { width: '100%', padding: '10px' } },
	        _react2.default.createElement(
	          "div",
	          { className: "form-group", style: { marginTop: '10px' } },
	          _react2.default.createElement(
	            "div",
	            { className: "col-xs-12" },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "pickup_date" }),
	            ":"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-xs-12" },
	            _react2.default.createElement(_reduxForm.Field, { name: "date", component: _datePicker.DatePicker, selected: this.props.date })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "form-group", style: { marginTop: '40px' } },
	          _react2.default.createElement(
	            "div",
	            { className: "col-xs-12" },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "pickup_time" }),
	            ":"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-xs-12" },
	            _react2.default.createElement(_reduxForm.Field, { name: "DispatchDate", component: _selection.Selection, options: this.state.DispatchDateOptions })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '100%', marginTop: '130px' } },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: "primary",
	              className: "print-btn",
	              type: "button",
	              onClick: this.props.setModalVisibility
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "cancel" })
	          ),
	          _react2.default.createElement("span", { style: { width: '50px' } }),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: "success",
	              className: "print-btn",
	              type: "button",
	              onClick: handleSubmit(this.handleFormSubmit)
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "confirm" })
	          )
	        )
	      );
	    }
	  }]);
	
	  return form;
	}(_react.Component);
	
	var formName = 'PickupTimeChangeForm';
	
	var selector = (0, _reduxForm.formValueSelector)(formName);
	
	var DeliveryTimeChangeForm = (0, _reduxForm.reduxForm)({
	  // a unique name for the form
	  form: formName,
	  enableReinitialize: true
	})(form);
	
	var PickupTimeChange = function PickupTimeChange(_ref2) {
	  var setModalVisibility = _ref2.setModalVisibility,
	      isVisible = _ref2.isVisible,
	      estDeliveryEditingSOID = _ref2.estDeliveryEditingSOID,
	      selectedRows = _ref2.selectedRows,
	      onSuccess = _ref2.onSuccess,
	      date = _ref2.date,
	      setFormValue = _ref2.setFormValue;
	  return _react2.default.createElement(
	    _reactSkylight.SkyLightStateless,
	    {
	      title: 'Pickup Time',
	      onCloseClicked: setModalVisibility,
	      dialogStyles: modalStyle,
	      isVisible: isVisible
	    },
	    _react2.default.createElement(DeliveryTimeChangeForm, {
	      setModalVisibility: setModalVisibility,
	      estDeliveryEditingSOID: estDeliveryEditingSOID,
	      selectedRows: selectedRows,
	      onSuccess: onSuccess,
	      date: date,
	      setFormValue: setFormValue
	    })
	  );
	};
	
	PickupTimeChange.propTypes = propTypes;
	PickupTimeChange.defaultProps = defaultProps;
	
	var mapState = function mapState(state) {
	  return {
	    date: selector(state, 'date')
	  };
	};
	var mapProps = function mapProps(dispatch) {
	  return {
	    setFormValue: function setFormValue(field, value) {
	      dispatch((0, _reduxForm.change)(formName, field, value));
	    }
	  };
	};
	
	var _default = (0, _reactRedux.connect)(mapState, mapProps)(PickupTimeChange);
	
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(changeDeliveryTime, "changeDeliveryTime", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/PickupTimeChange.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchAvaliablePickupTime, "fetchAvaliablePickupTime", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/PickupTimeChange.jsx");
	
	  __REACT_HOT_LOADER__.register(modalStyle, "modalStyle", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/PickupTimeChange.jsx");
	
	  __REACT_HOT_LOADER__.register(propTypes, "propTypes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/PickupTimeChange.jsx");
	
	  __REACT_HOT_LOADER__.register(defaultProps, "defaultProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/PickupTimeChange.jsx");
	
	  __REACT_HOT_LOADER__.register(form, "form", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/PickupTimeChange.jsx");
	
	  __REACT_HOT_LOADER__.register(formName, "formName", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/PickupTimeChange.jsx");
	
	  __REACT_HOT_LOADER__.register(selector, "selector", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/PickupTimeChange.jsx");
	
	  __REACT_HOT_LOADER__.register(DeliveryTimeChangeForm, "DeliveryTimeChangeForm", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/PickupTimeChange.jsx");
	
	  __REACT_HOT_LOADER__.register(PickupTimeChange, "PickupTimeChange", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/PickupTimeChange.jsx");
	
	  __REACT_HOT_LOADER__.register(mapState, "mapState", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/PickupTimeChange.jsx");
	
	  __REACT_HOT_LOADER__.register(mapProps, "mapProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/PickupTimeChange.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/PickupTimeChange.jsx");
	}();

	;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(3);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var modalStyle = {
	  width: '500px',
	  height: '300px',
	  marginLeft: '-10%'
	};
	
	var propTypes = {
	  selectedRows: _propTypes2.default.array,
	  onSuccess: _propTypes2.default.func
	};
	
	var defaultProps = {
	  onSuccess: function onSuccess() {},
	  selectedRows: []
	};
	
	var PromotionAdding = function (_Component) {
	  _inherits(PromotionAdding, _Component);
	
	  function PromotionAdding() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PromotionAdding);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PromotionAdding.__proto__ || Object.getPrototypeOf(PromotionAdding)).call.apply(_ref, [this].concat(args))), _this), _this.handleConfirmClick = function () {
	      _this.props.onClose();
	      _this.props.onConfirm();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PromotionAdding, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var filterdPromotion = this.props.productPromotions.filter(function (p) {
	        return p.Method === "BuyAGetB" && p.IsPercent && p.Off === 100;
	      });
	      return _react2.default.createElement(
	        "div",
	        { style: { width: '100%', height: '100%', padding: '10px' } },
	        _react2.default.createElement(
	          "h4",
	          null,
	          "Apply Promotion?"
	        ),
	        _lodash2.default.map(filterdPromotion, function (promotion) {
	          return _react2.default.createElement(
	            "div",
	            null,
	            promotion.DiscountDescription
	          );
	        }),
	        _react2.default.createElement(
	          "div",
	          { style: { position: 'absolute', bottom: '30px', right: '20px' } },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: "primary",
	              className: "print-btn",
	              type: "button"
	              // disabled={selectedRows.length !== 1}
	              , onClick: function onClick() {
	                _this2.handleConfirmClick();
	              }
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "apply" })
	          )
	        )
	      );
	    }
	  }]);
	
	  return PromotionAdding;
	}(_react.Component);
	
	var PromotionAddingModal = function PromotionAddingModal(_ref2) {
	  var onClose = _ref2.onClose,
	      isVisible = _ref2.isVisible,
	      onConfirm = _ref2.onConfirm,
	      productPromotions = _ref2.productPromotions;
	  return _react2.default.createElement(
	    _reactSkylight.SkyLightStateless,
	    {
	      title: 'Promotion Found',
	      onCloseClicked: onClose,
	      dialogStyles: modalStyle,
	      isVisible: isVisible
	    },
	    _react2.default.createElement(PromotionAdding, { onClose: onClose, onConfirm: onConfirm, productPromotions: productPromotions })
	  );
	};
	
	PromotionAddingModal.propTypes = propTypes;
	PromotionAddingModal.defaultProps = defaultProps;
	
	var _default = PromotionAddingModal;
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(modalStyle, "modalStyle", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/PromotionAddingModal.jsx");
	
	  __REACT_HOT_LOADER__.register(propTypes, "propTypes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/PromotionAddingModal.jsx");
	
	  __REACT_HOT_LOADER__.register(defaultProps, "defaultProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/PromotionAddingModal.jsx");
	
	  __REACT_HOT_LOADER__.register(PromotionAdding, "PromotionAdding", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/PromotionAddingModal.jsx");
	
	  __REACT_HOT_LOADER__.register(PromotionAddingModal, "PromotionAddingModal", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/PromotionAddingModal.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/PromotionAddingModal.jsx");
	}();

	;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchRates = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(3);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	var _dateFormat = __webpack_require__(39);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// PUT--------    {{url}}v1/oversea-warehouse/change_location/37?location=222
	
	
	var fetchRates = exports.fetchRates = function fetchRates(SalesOrder_id, success, failed) {
	  (0, _axios2.default)({
	    method: 'GET',
	    url: _root_url.ROOT_URL + "v2/shipping/teapplix_quote/" + SalesOrder_id,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    if (res.data) {
	      success(res.data);
	    }
	  }, function (err) {
	    alert('fetch rate failed');
	  });
	};
	
	var modalStyle = {
	  width: '500px',
	  height: '450px',
	  marginLeft: '-15%',
	  marginTop: '-18%'
	};
	
	var propTypes = {
	  setModalVisibility: _propTypes2.default.func.isRequired,
	  isVisible: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  setModalVisibility: function setModalVisibility() {},
	  isVisible: false
	};
	
	var ToolTipFormatter = _react2.default.createClass({
	  displayName: "ToolTipFormatter",
	  render: function render() {
	    return _react2.default.createElement(
	      "span",
	      { "data-tip": true, "data-for": this.props.dependentValues.PromotionLine_id },
	      this.props.value
	    );
	  }
	});
	
	var AutoApplyFormatter = _react2.default.createClass({
	  displayName: "AutoApplyFormatter",
	  render: function render() {
	    return _react2.default.createElement(
	      "span",
	      null,
	      this.props.value ? 'Yes' : 'No'
	    );
	  }
	});
	
	var columns = [{
	  key: 'Name',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: "name" }),
	  resizable: true,
	  sortable: true,
	  width: 300,
	  filterable: true
	}, {
	  key: 'Total',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: "total" }),
	  resizable: true,
	  sortable: true,
	  width: 100,
	  filterable: true
	}];
	
	var ShippingRate = function (_Component) {
	  _inherits(ShippingRate, _Component);
	
	  function ShippingRate() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ShippingRate);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ShippingRate.__proto__ || Object.getPrototypeOf(ShippingRate)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      rows: [],
	      isLoading: true,
	      selectedRow: []
	    }, _this.initialRates = function () {
	      var selectedSalesOrder = _this.props.salesOrders.selectedRows[0];
	      var id = selectedSalesOrder.SalesOrder_id;
	
	      var success = function success(_ref2) {
	        var _ref2$rates = _ref2.rates,
	            rates = _ref2$rates === undefined ? [] : _ref2$rates;
	
	        _this.setState({
	          rows: rates,
	          isLoading: false
	        });
	      };
	      var failed = function failed() {
	        // console.log('faield');
	      };
	
	      fetchRates(id, success, failed);
	    }, _this.onRowSelect = function (row) {
	      _this.setState({
	        selectedRow: row
	      });
	    }, _this.handlePrintClick = function () {
	      if (_this.state.selectedRow[0]) {
	        _this.props.handleTeapplixPrintClick(_this.state.selectedRow[0]);
	      }
	    }, _this.renderRatesTable = function () {
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this.state);
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(_reactDataGrid2.default, {
	            rowKey: "Code",
	            columns: columns,
	            rowHeight: 25,
	            headerRowHeight: 45,
	            rowGetter: rowGetter,
	            rowsCount: getSize(),
	            minHeight: 250,
	            enableRowSelect: "single",
	            onRowSelect: _this.onRowSelect
	          })
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ShippingRate, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.initialRates();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      if (this.state.isLoading) return _react2.default.createElement(_spinner2.default, null);
	      return _react2.default.createElement(
	        "div",
	        { style: { width: '100%', height: '100%', padding: '10px' } },
	        this.renderRatesTable(),
	        _react2.default.createElement(
	          "div",
	          { style: { position: 'absolute', bottom: '30px', right: '20px' } },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: "primary",
	              className: "print-btn",
	              type: "button",
	              onClick: function onClick() {
	                _this2.props.setModalVisibility(false);
	              },
	              style: { margin: '10px' }
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "cancel" })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: "primary",
	              className: "print-btn",
	              type: "button",
	              onClick: function onClick() {
	                _this2.handlePrintClick();
	              },
	              style: { margin: '10px' }
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "print" })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ShippingRate;
	}(_react.Component);
	
	var ShippingRateModal = function ShippingRateModal(_ref3) {
	  var setModalVisibility = _ref3.setModalVisibility,
	      isVisible = _ref3.isVisible,
	      salesOrders = _ref3.salesOrders,
	      handleTeapplixPrintClick = _ref3.handleTeapplixPrintClick;
	  return _react2.default.createElement(
	    _reactSkylight.SkyLightStateless,
	    {
	      title: 'Rates',
	      onCloseClicked: setModalVisibility,
	      dialogStyles: modalStyle,
	      isVisible: isVisible
	    },
	    _react2.default.createElement(ShippingRate, { setModalVisibility: setModalVisibility, isVisible: isVisible, salesOrders: salesOrders, handleTeapplixPrintClick: handleTeapplixPrintClick })
	  );
	};
	
	ShippingRateModal.propTypes = propTypes;
	ShippingRateModal.defaultProps = defaultProps;
	
	var _default = ShippingRateModal;
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchRates, "fetchRates", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ShippingRateModal.jsx");
	
	  __REACT_HOT_LOADER__.register(modalStyle, "modalStyle", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ShippingRateModal.jsx");
	
	  __REACT_HOT_LOADER__.register(propTypes, "propTypes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ShippingRateModal.jsx");
	
	  __REACT_HOT_LOADER__.register(defaultProps, "defaultProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ShippingRateModal.jsx");
	
	  __REACT_HOT_LOADER__.register(ToolTipFormatter, "ToolTipFormatter", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ShippingRateModal.jsx");
	
	  __REACT_HOT_LOADER__.register(AutoApplyFormatter, "AutoApplyFormatter", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ShippingRateModal.jsx");
	
	  __REACT_HOT_LOADER__.register(columns, "columns", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ShippingRateModal.jsx");
	
	  __REACT_HOT_LOADER__.register(ShippingRate, "ShippingRate", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ShippingRateModal.jsx");
	
	  __REACT_HOT_LOADER__.register(ShippingRateModal, "ShippingRateModal", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ShippingRateModal.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ShippingRateModal.jsx");
	}();

	;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CtnEditModal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _redux = __webpack_require__(296);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  selectedSalesOrder: _propTypes2.default.object
	};
	
	var defaultProps = {
	  selectedSalesOrder: {}
	};
	
	var CtnEditModal = exports.CtnEditModal = function (_Component) {
	  _inherits(CtnEditModal, _Component);
	
	  function CtnEditModal(props) {
	    _classCallCheck(this, CtnEditModal);
	
	    var _this = _possibleConstructorReturn(this, (CtnEditModal.__proto__ || Object.getPrototypeOf(CtnEditModal)).call(this, props));
	
	    _this.handleSubmitClick = function () {
	      var _this$props = _this.props,
	          SalesOrder_id = _this$props.selectedSalesOrder.SalesOrder_id,
	          handleCTNNoUpdateSuccess = _this$props.handleCTNNoUpdateSuccess;
	      var ctnNo = _this.state.ctnNo;
	
	      var payload = {
	        salesOrderId: SalesOrder_id,
	        CTNNo: ctnNo
	      };
	      (0, _redux.updateCTNNo)(payload, handleCTNNoUpdateSuccess);
	    };
	
	    _this.state = {
	      ctnNo: props.selectedSalesOrder.ctnNo
	    };
	    return _this;
	  }
	
	  _createClass(CtnEditModal, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var ctnNo = this.state.ctnNo;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { style: { marginBottom: "12px" } },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              "label",
	              { style: { float: 'right' } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "container_no" }),
	              ":"
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 7 },
	            _react2.default.createElement(_reactBootstrap.Input, {
	              type: "string",
	              value: ctnNo,
	              onChange: function onChange(e) {
	                _this2.setState({ ctnNo: e.target.value });
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: "centerStyle", style: { marginTop: "50px" } },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: "success",
	              onClick: this.handleSubmitClick,
	              disabled: !ctnNo
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "submit" })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CtnEditModal;
	}(_react.Component);
	
	CtnEditModal.propTypes = propTypes;
	CtnEditModal.defaultProps = defaultProps;
	
	var _default = CtnEditModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CtnEditModal, "CtnEditModal", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ctnEdit/CtnEditModal.jsx");
	
	  __REACT_HOT_LOADER__.register(propTypes, "propTypes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ctnEdit/CtnEditModal.jsx");
	
	  __REACT_HOT_LOADER__.register(defaultProps, "defaultProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ctnEdit/CtnEditModal.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ctnEdit/CtnEditModal.jsx");
	}();

	;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CtnEditModal = __webpack_require__(294);
	
	var _CtnEditModal2 = _interopRequireDefault(_CtnEditModal);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var _default = _CtnEditModal2.default;
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ctnEdit/index.jsx');
	}();

	;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateCTNNo = undefined;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var updateCTNNo = exports.updateCTNNo = function updateCTNNo(_ref, success) {
	  var salesOrderId = _ref.salesOrderId,
	      CTNNo = _ref.CTNNo;
	
	  (0, _axios2.default)({
	    method: 'PUT',
	    data: { ContainerNo: CTNNo },
	    url: _root_url.ROOT_URL + 'v1/sale/set-container-no/' + salesOrderId,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    success();
	  }, function (err) {
	    alert(err);
	  });
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(updateCTNNo, 'updateCTNNo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/ctnEdit/redux.jsx');
	}();

	;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DriverListModal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _redux = __webpack_require__(299);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  selectedOrders: _propTypes2.default.array
	};
	
	var defaultProps = {
	  selectedOrders: []
	};
	
	var DriverListModal = exports.DriverListModal = function (_Component) {
	  _inherits(DriverListModal, _Component);
	
	  function DriverListModal() {
	    _classCallCheck(this, DriverListModal);
	
	    var _this = _possibleConstructorReturn(this, (DriverListModal.__proto__ || Object.getPrototypeOf(DriverListModal)).call(this));
	
	    _this.handleDriversFetchSuccess = function () {
	      var drivers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      return _this.setState({ drivers: drivers });
	    };
	
	    _this.handleOnSubmit = function (e) {
	      var _this$props = _this.props,
	          selectedOrders = _this$props.selectedOrders,
	          handleSuccess = _this$props.handleSuccess,
	          assigningInboundDriver = _this$props.assigningInboundDriver,
	          assigningOutboundDriver = _this$props.assigningOutboundDriver;
	      var selectedDriver = _this.state.selectedDriver;
	
	
	      var payload = {
	        DriverId: selectedDriver.value,
	        SalesOrderIds: selectedOrders.map(function (selectedOrder) {
	          return selectedOrder.SalesOrder_id;
	        })
	      };
	      var type = assigningInboundDriver ? 'inbound' : 'outbound';
	      (0, _redux.assignOrdersToDriver)(payload, handleSuccess, type);
	    };
	
	    _this.handleDriverSelect = function (selectedDriver) {
	      return _this.setState({ selectedDriver: selectedDriver });
	    };
	
	    _this.state = {
	      drivers: [],
	      selectedDriver: ''
	    };
	    return _this;
	  }
	
	  _createClass(DriverListModal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _redux.fetchDrivers)(this.handleDriversFetchSuccess);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          selectedDriver = _state.selectedDriver,
	          drivers = _state.drivers;
	
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { style: { marginBottom: "12px" } },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              "label",
	              { style: { float: 'right' } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "driver" }),
	              ":"
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 9 },
	            _react2.default.createElement(
	              _reactBootstrap.Dropdown,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Dropdown.Toggle,
	                {
	                  style: {
	                    width: "300px",
	                    backgroundColor: "white",
	                    border: "1px solid #555555",
	                    color: "black",
	                    fontWeight: "400"
	                  }
	                },
	                selectedDriver.label || selectedDriver
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Dropdown.Menu,
	                { className: "super-colors" },
	                drivers.map(function (el) {
	                  return _react2.default.createElement(
	                    _reactBootstrap.MenuItem,
	                    { onClick: function onClick() {
	                        return _this2.handleDriverSelect(el);
	                      }, style: {
	                        width: "300px",
	                        backgroundColor: "white",
	                        color: "black",
	                        fontWeight: "400"
	                      } },
	                    el.label
	                  );
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: "centerStyle", style: { marginTop: "50px" } },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: "success",
	              onClick: function onClick(e) {
	                _this2.handleOnSubmit(e);
	              },
	              disabled: !this.state.selectedDriver
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "assign" })
	          )
	        )
	      );
	    }
	  }]);
	
	  return DriverListModal;
	}(_react.Component);
	
	DriverListModal.propTypes = propTypes;
	DriverListModal.defaultProps = defaultProps;
	
	var _default = DriverListModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(DriverListModal, "DriverListModal", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/driverList/DriverListModal.jsx");
	
	  __REACT_HOT_LOADER__.register(propTypes, "propTypes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/driverList/DriverListModal.jsx");
	
	  __REACT_HOT_LOADER__.register(defaultProps, "defaultProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/driverList/DriverListModal.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/driverList/DriverListModal.jsx");
	}();

	;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DriverListModal = __webpack_require__(297);
	
	var _DriverListModal2 = _interopRequireDefault(_DriverListModal);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var _default = _DriverListModal2.default;
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/driverList/index.jsx');
	}();

	;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.assignOrdersToDriver = exports.fetchDrivers = undefined;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var processDrivers = function processDrivers() {
	  var drivers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  return drivers.map(function (driver) {
	    return {
	      label: (driver.first_name || '') + ' ' + (driver.last_name || ''),
	      value: driver.id
	    };
	  });
	};
	var fetchDrivers = exports.fetchDrivers = function fetchDrivers(callback) {
	  (0, _axios2.default)({
	    method: 'GET',
	    url: _root_url.ROOT_URL + 'v1/baseuser/driver/',
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    callback(processDrivers(res.data));
	  }, function (err) {
	    alert(err);
	  });
	};
	var assignOrdersToDriver = exports.assignOrdersToDriver = function assignOrdersToDriver(data, success, type) {
	  (0, _axios2.default)({
	    method: 'PUT',
	    url: _root_url.ROOT_URL + 'v1/sale/sales-order-assign-driver/' + type,
	    data: data,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    success();
	  }, function () {});
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchDrivers, 'fetchDrivers', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/driverList/redux.jsx');
	
	  __REACT_HOT_LOADER__.register(assignOrdersToDriver, 'assignOrdersToDriver', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/driverList/redux.jsx');
	
	  __REACT_HOT_LOADER__.register(processDrivers, 'processDrivers', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/driverList/redux.jsx');
	}();

	;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IsaEditModal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _redux = __webpack_require__(302);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  selectedSalesOrder: _propTypes2.default.object
	};
	
	var defaultProps = {
	  selectedSalesOrder: {}
	};
	
	var IsaEditModal = exports.IsaEditModal = function (_Component) {
	  _inherits(IsaEditModal, _Component);
	
	  function IsaEditModal(props) {
	    _classCallCheck(this, IsaEditModal);
	
	    var _this = _possibleConstructorReturn(this, (IsaEditModal.__proto__ || Object.getPrototypeOf(IsaEditModal)).call(this, props));
	
	    _this.handleSubmitClick = function () {
	      var _this$props = _this.props,
	          SalesOrder_id = _this$props.selectedSalesOrder.SalesOrder_id,
	          handleISANoUpdateSuccess = _this$props.handleISANoUpdateSuccess;
	      var isaNo = _this.state.isaNo;
	
	      var payload = {
	        salesOrderId: SalesOrder_id,
	        ISANo: isaNo
	      };
	      (0, _redux.updateISANo)(payload, handleISANoUpdateSuccess);
	    };
	
	    _this.state = {
	      isaNo: props.selectedSalesOrder.IsaNo
	    };
	    return _this;
	  }
	
	  _createClass(IsaEditModal, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var isaNo = this.state.isaNo;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { style: { marginBottom: "12px" } },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              "label",
	              { style: { float: 'right' } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "isa_no" }),
	              ":"
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 7 },
	            _react2.default.createElement(_reactBootstrap.Input, {
	              type: "string",
	              value: isaNo,
	              onChange: function onChange(e) {
	                _this2.setState({ isaNo: e.target.value });
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: "centerStyle", style: { marginTop: "50px" } },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: "success",
	              onClick: this.handleSubmitClick,
	              disabled: !isaNo
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "submit" })
	          )
	        )
	      );
	    }
	  }]);
	
	  return IsaEditModal;
	}(_react.Component);
	
	IsaEditModal.propTypes = propTypes;
	IsaEditModal.defaultProps = defaultProps;
	
	var _default = IsaEditModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(IsaEditModal, "IsaEditModal", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/isaEdit/IsaEditModal.jsx");
	
	  __REACT_HOT_LOADER__.register(propTypes, "propTypes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/isaEdit/IsaEditModal.jsx");
	
	  __REACT_HOT_LOADER__.register(defaultProps, "defaultProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/isaEdit/IsaEditModal.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/isaEdit/IsaEditModal.jsx");
	}();

	;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _IsaEditModal = __webpack_require__(300);
	
	var _IsaEditModal2 = _interopRequireDefault(_IsaEditModal);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var _default = _IsaEditModal2.default;
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/isaEdit/index.jsx');
	}();

	;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateISANo = undefined;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var updateISANo = exports.updateISANo = function updateISANo(_ref, success) {
	  var salesOrderId = _ref.salesOrderId,
	      ISANo = _ref.ISANo;
	
	  (0, _axios2.default)({
	    method: 'PUT',
	    data: { ISANo: ISANo },
	    url: _root_url.ROOT_URL + 'v1/sale/sales-order-set-isa/' + salesOrderId,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    success();
	  }, function (err) {
	    alert(err);
	  });
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(updateISANo, 'updateISANo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/isaEdit/redux.jsx');
	}();

	;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _action = __webpack_require__(304);
	
	var _datePicker = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  modal: {
	    width: '40%',
	    height: '560px',
	    marginLeft: '-20%',
	    top: '36%'
	  },
	  container: {
	    display: 'flex',
	    // alignItems: 'center',
	    flexDirection: 'column'
	    // justifyContent: 'space-between',
	  },
	  input: {
	    border: '1px solid black',
	    marginLeft: '20px',
	    width: '190px',
	    padding: '2px',
	    borderRadius: '5px'
	  },
	  col: {
	    marginTop: '20px'
	  }
	};
	
	var ShippingStatusEditModal = function (_React$Component) {
	  _inherits(ShippingStatusEditModal, _React$Component);
	
	  function ShippingStatusEditModal(props) {
	    _classCallCheck(this, ShippingStatusEditModal);
	
	    var _this = _possibleConstructorReturn(this, (ShippingStatusEditModal.__proto__ || Object.getPrototypeOf(ShippingStatusEditModal)).call(this, props));
	
	    _this.renderHeader = function () {
	      return _react2.default.createElement(
	        'h1',
	        null,
	        'Shipping Status Edit'
	      );
	    };
	
	    _this.renderDatePicker = function () {
	      return _react2.default.createElement(
	        'div',
	        { style: { width: '290px' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-4' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'operation_date' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-8' },
	            _react2.default.createElement(_reduxForm.Field, { name: 'operationDate', selected: _this.state.defaultDate, component: _datePicker.StartOfThisMonthDatePicker })
	          )
	        )
	      );
	    };
	
	    _this.changeStatus = function (e, isPartial, form) {
	      var _form$operationDate = form.operationDate,
	          operationDate = _form$operationDate === undefined ? new Date() : _form$operationDate;
	      var _this$props$currentSa = _this.props.currentSalesOrderDetail,
	          ShippingStatus = _this$props$currentSa.ShippingStatus,
	          SalesOrder_id = _this$props$currentSa.SalesOrder_id;
	      // const shouldAccumulateQty = ShippingStatus === 'Partial_Outbound' || ShippingStatus === 'Outbound';
	
	      var shouldAccumulateQty = false;
	      var OrderLines = _this.state.rows.map(function (row) {
	        return _extends({
	          ProductId: row.Product_id,
	          SalesOrderLineId: row.SalesOrderLine_id,
	          Qty: (shouldAccumulateQty ? parseFloat(row.qty || 0) + row.Quantity : parseFloat(row.qty)) || 0
	        }, row.boxQty ? {
	          boxQty: parseFloat(row.boxQty)
	        } : {});
	      });
	
	      var payload = {
	        OrderLines: OrderLines,
	        processDate: operationDate.toISOString()
	      };
	      (0, _action.changeStatus)(ShippingStatus, SalesOrder_id, payload, isPartial, function () {
	        _this.props.reloadThePage();
	      });
	    };
	
	    _this.renderButtons = function () {
	      var handleSubmit = _this.props.handleSubmit;
	
	
	      var displayText = function displayText() {
	        if (!_this.props.currentSalesOrderDetail) return 'null';
	
	        var ShippingStatus = _this.props.currentSalesOrderDetail.ShippingStatus;
	
	
	        if (ShippingStatus === 'Inbound' || ShippingStatus === 'Partial_Outbound' || ShippingStatus === 'Outbound') {
	          return 'outbound';
	        }
	        return 'inbound';
	      };
	      return _react2.default.createElement(
	        _reactBootstrap.ButtonToolbar,
	        { style: { marginTop: '20px' } },
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            onClick: handleSubmit(function (form) {
	              return _this.changeStatus(null, false, form);
	            })
	          },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: displayText() })
	        ),
	        displayText() === 'outbound' && _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            onClick: handleSubmit(function (form) {
	              return _this.changeStatus(null, true, form);
	            })
	          },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'p-outbound' })
	        )
	      );
	    };
	
	    _this.state = {
	      rows: props.currentSalesOrderDetail ? props.currentSalesOrderDetail.Sales_Order_Lines.map(function (line) {
	        if (line.ProductNum === "01010001") {
	          return _extends({}, line, {
	            Quantity: props.currentSalesOrderDetail.TotalOutboundQuantity
	          });
	        };
	        return line;
	      }) : [],
	      defaultDate: new Date()
	    };
	    return _this;
	  }
	
	  _createClass(ShippingStatusEditModal, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this2 = this;
	
	      if (!this.props.isVisible && prevProps.isVisible) {
	        this.setState({
	          rows: [].concat(_toConsumableArray(this.props.currentSalesOrderDetail.Sales_Order_Lines)).map(function (line) {
	            if (line.ProductNum === "01010001") {
	              return _extends({}, line, {
	                Quantity: _this2.props.currentSalesOrderDetail.TotalOutboundQuantity
	              });
	            };
	            return line;
	          })
	        });
	      }
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this3 = this;
	
	      var _props$currentSalesOr = this.props.currentSalesOrderDetail,
	          currentSalesOrderDetail = _props$currentSalesOr === undefined ? {} : _props$currentSalesOr;
	
	
	      var that = this;
	      // Parameters of the react-data-grid
	      var allRows = _reactDataGridAddons.Data.Selectors.getRows(this.state);
	      var getRows = function getRows() {
	        return allRows;
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return Object.assign({ Idx: rowIdx + 1 }, rows[rowIdx]);
	      };
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this3.state, {
	          sortColumn: sortColumn,
	          sortDirection: sortDirection
	        });
	        _this3.setState(state);
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        // return;
	        var cellKey = e.cellKey,
	            rowIdx = e.rowIdx,
	            value = e.updated[cellKey];
	
	        var rows = getRows();
	        var filteredRows = _this3.state.filteredRows;
	        var index = void 0;
	        rows[rowIdx][cellKey] = value;
	        _this3.setState({ rows: rows });
	      };
	
	      var isInbound = currentSalesOrderDetail && currentSalesOrderDetail.ShippingStatus === 'Inbound';
	      var isPartial = currentSalesOrderDetail && (currentSalesOrderDetail.ShippingStatus === 'Partial_Outbound' || currentSalesOrderDetail.ShippingStatus === 'Outbound');
	
	      var IsVariableFormatter = _react2.default.createClass({
	        displayName: 'IsVariableFormatter',
	        render: function render() {
	          var _this4 = this;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                className: 'textAlignStyle',
	                style: { height: '23px', width: '39px', padding: '0px' },
	                onClick: function onClick() {
	                  var Index = _this4.props.dependentValues.Index;
	                  that.removeRow(Index);
	                }
	              },
	              'X'
	            )
	          );
	        }
	      });
	      // Column difinition
	      var columns = [{
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'RefNo',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'FBA_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PoNo',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pro_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'OriginalQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }].concat(_toConsumableArray(isInbound || isPartial ? [{
	        key: 'InboundQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inbound_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }] : {}), _toConsumableArray(isPartial ? [{
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'outbounded_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true
	      }] : {}), [{
	        key: 'qty',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }], _toConsumableArray(isInbound || isPartial ? [{
	        key: 'boxQty',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty_box' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }] : {}));
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { className: 'react-customizer', id: 'SalesOrderForm-dataGrid3' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'ProductNum',
	              enableCellSelect: true,
	              onGridSort: handleGridSort,
	              columns: columns,
	              rowHeight: 25,
	              headerRowHeight: 45,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              onRowUpdated: handleRowUpdated
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isVisible = _props.isVisible,
	          onClose = _props.onClose,
	          currentSalesOrderDetail = _props.currentSalesOrderDetail,
	          handleSubmit = _props.handleSubmit;
	      var data = this.state.data;
	
	
	      return _react2.default.createElement(
	        _reactSkylight.SkyLightStateless,
	        {
	          dialogStyles: styles.modal,
	          isVisible: isVisible,
	          onCloseClicked: onClose
	        },
	        _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit },
	          this.renderHeader(),
	          this.renderDatePicker(),
	          this.renderTable(),
	          this.renderButtons()
	        )
	      );
	    }
	  }]);
	
	  return ShippingStatusEditModal;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    // vendors: state.vendors.all,
	  };
	};
	
	var ShippingStatusEditModalWithRedux = (0, _reduxForm.reduxForm)({
	  form: 'ShippingStatusEditModal'
	})(ShippingStatusEditModal);
	
	var _default = ShippingStatusEditModalWithRedux;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/shippingStatusEdit/Modal.jsx');
	
	  __REACT_HOT_LOADER__.register(ShippingStatusEditModal, 'ShippingStatusEditModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/shippingStatusEdit/Modal.jsx');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/shippingStatusEdit/Modal.jsx');
	
	  __REACT_HOT_LOADER__.register(ShippingStatusEditModalWithRedux, 'ShippingStatusEditModalWithRedux', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/shippingStatusEdit/Modal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/shippingStatusEdit/Modal.jsx');
	}();

	;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.changeStatus = exports.fetchSODetailWitSONum = undefined;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fetchSODetailWitSONum = exports.fetchSODetailWitSONum = function fetchSODetailWitSONum(SONum) {
	  // dispatch/shipping/
	  (0, _axios2.default)({
	    method: 'GET',
	    // data: { ContainerNo: CTNNo },
	    url: _root_url.ROOT_URL + 'v1/dispatch/shipping/' + SONum,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    console.log('res', res);
	  }, function (err) {
	    alert(err);
	  });
	};
	
	var changeStatus = exports.changeStatus = function changeStatus(currentStatus, salesOrderId, payload, isPartial, success) {
	  var status = '';
	  if ((currentStatus === 'Inbound' || currentStatus === 'Partial_Outbound') && !isPartial) {
	    status = 'Outbound';
	  } else if (isPartial) {
	    status = 'Partial_Outbound';
	  } else {
	    status = 'Inbound';
	  }
	
	  (0, _axios2.default)({
	    method: 'PUT',
	    data: payload,
	    url: _root_url.ROOT_URL + 'v1/oversea-warehouse/update-sales-order/' + salesOrderId + '/' + status,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    success();
	  }, function (err) {
	    alert(err);
	  });
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchSODetailWitSONum, 'fetchSODetailWitSONum', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/shippingStatusEdit/action.jsx');
	
	  __REACT_HOT_LOADER__.register(changeStatus, 'changeStatus', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/shippingStatusEdit/action.jsx');
	}();

	;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(303);
	
	var _Modal2 = _interopRequireDefault(_Modal);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var _default = _Modal2.default;
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/salesOrder/shippingStatusEdit/index.jsx');
	}();

	;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DispatcherBindModal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _redux = __webpack_require__(308);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  // selectedOrders: PropTypes.array
	};
	
	var defaultProps = {
	  // selectedOrders: []
	};
	
	var DispatcherBindModal = exports.DispatcherBindModal = function (_Component) {
	  _inherits(DispatcherBindModal, _Component);
	
	  function DispatcherBindModal() {
	    _classCallCheck(this, DispatcherBindModal);
	
	    var _this = _possibleConstructorReturn(this, (DispatcherBindModal.__proto__ || Object.getPrototypeOf(DispatcherBindModal)).call(this));
	
	    _this.handleOnSubmit = function (e) {
	      var _this$props = _this.props,
	          selectedMobileUserId = _this$props.selectedMobileUserId,
	          handleDispatcherBindSuccess = _this$props.handleDispatcherBindSuccess;
	      var selectedUser = _this.state.selectedUser;
	
	
	      var payload = {
	        BaseUserId: selectedUser.value || selectedUser,
	        MobileUserIds: [selectedMobileUserId]
	      };
	
	      (0, _redux.dispatchBindWithSCMUser)(payload, handleDispatcherBindSuccess);
	    };
	
	    _this.handleDriverSelect = function (selectedUser) {
	      return _this.setState({ selectedUser: selectedUser });
	    };
	
	    _this.state = {
	      selectedUser: ''
	    };
	    return _this;
	  }
	
	  _createClass(DispatcherBindModal, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var selectedUser = this.state.selectedUser;
	
	      var scmUsers = this.props.scmUsers.map(function (user) {
	        return {
	          label: (user.FirstName || '') + " " + (user.LastName || ''),
	          value: user.BaseUser_id
	        };
	      });
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { style: { marginBottom: "12px" } },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              "label",
	              { style: { float: 'right' } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "scm_user" }),
	              ":"
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 9 },
	            _react2.default.createElement(
	              _reactBootstrap.Dropdown,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Dropdown.Toggle,
	                {
	                  style: {
	                    width: "300px",
	                    backgroundColor: "white",
	                    border: "1px solid #555555",
	                    color: "black",
	                    fontWeight: "400"
	                  }
	                },
	                selectedUser.label || selectedUser
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Dropdown.Menu,
	                { className: "super-colors" },
	                scmUsers.map(function (el) {
	                  return _react2.default.createElement(
	                    _reactBootstrap.MenuItem,
	                    { onClick: function onClick() {
	                        return _this2.handleDriverSelect(el);
	                      }, style: {
	                        width: "300px",
	                        backgroundColor: "white",
	                        color: "black",
	                        fontWeight: "400"
	                      } },
	                    el.label
	                  );
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: "centerStyle", style: { marginTop: "50px" } },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: "success",
	              onClick: function onClick(e) {
	                _this2.handleOnSubmit(e);
	              },
	              disabled: !this.state.selectedUser
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "bind" })
	          )
	        )
	      );
	    }
	  }]);
	
	  return DispatcherBindModal;
	}(_react.Component);
	
	DispatcherBindModal.propTypes = propTypes;
	DispatcherBindModal.defaultProps = defaultProps;
	
	var _default = DispatcherBindModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(DispatcherBindModal, "DispatcherBindModal", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/userManagement/dispatcherBind/dispatcherBindModal.jsx");
	
	  __REACT_HOT_LOADER__.register(propTypes, "propTypes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/userManagement/dispatcherBind/dispatcherBindModal.jsx");
	
	  __REACT_HOT_LOADER__.register(defaultProps, "defaultProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/userManagement/dispatcherBind/dispatcherBindModal.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/userManagement/dispatcherBind/dispatcherBindModal.jsx");
	}();

	;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dispatcherBindModal = __webpack_require__(306);
	
	var _dispatcherBindModal2 = _interopRequireDefault(_dispatcherBindModal);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var _default = _dispatcherBindModal2.default;
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/userManagement/dispatcherBind/index.jsx');
	}();

	;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dispatchBindWithSCMUser = undefined;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dispatchBindWithSCMUser = exports.dispatchBindWithSCMUser = function dispatchBindWithSCMUser(data, callback) {
	  (0, _axios2.default)({
	    method: 'PUT',
	    data: data,
	    url: _root_url.ROOT_URL + 'v1/baseuser/set-dispatcher',
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    callback();
	  }, function (err) {
	    alert(err);
	  });
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(dispatchBindWithSCMUser, 'dispatchBindWithSCMUser', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/userManagement/dispatcherBind/redux.jsx');
	}();

	;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dispatcherBind = __webpack_require__(307);
	
	var _dispatcherBind2 = _interopRequireDefault(_dispatcherBind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userManagementModals = {
	  DispatcherBindModal: _dispatcherBind2.default
	};
	var _default = userManagementModals;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(userManagementModals, 'userManagementModals', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/userManagement/index.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/userManagement/index.jsx');
	}();

	;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _api = __webpack_require__(311);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var modalStyle = {
	  width: '700px',
	  height: '600px',
	  marginLeft: '-10%',
	  marginTop: '-20%'
	};
	
	var propTypes = {
	  selectedRows: _propTypes2.default.array,
	  onSuccess: _propTypes2.default.func
	};
	
	var defaultProps = {
	  onSuccess: function onSuccess() {},
	  selectedRows: []
	};
	
	var prcessZoneData = function prcessZoneData(zones) {
	  return zones.map(function (zone) {
	    return {
	      label: zone.Name,
	      value: zone.id
	    };
	  });
	};
	
	var prcessBinData = function prcessBinData(bins) {
	  return bins.map(function (bin) {
	    return {
	      label: bin.section_num,
	      value: bin.id
	    };
	  });
	};
	
	var processLevelData = function processLevelData(levels) {
	  return levels.map(function (level) {
	    return {
	      label: level.bin_num,
	      value: level.id,
	      color: level.color
	    };
	  });
	};
	
	var initialTableData = {
	  rows: [],
	  selectedRow: {
	    label: '',
	    value: ''
	  }
	};
	
	var RowRenderer = function (_Component) {
	  _inherits(RowRenderer, _Component);
	
	  function RowRenderer() {
	    _classCallCheck(this, RowRenderer);
	
	    return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(RowRenderer, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { onDoubleClick: function onDoubleClick() {
	            _this2.props.onDoubleClick(_this2.props.row);
	          } },
	        _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: "row" }, this.props))
	      );
	    }
	  }]);
	
	  return RowRenderer;
	}(_react.Component);
	
	var LocationSelect = function (_Component2) {
	  _inherits(LocationSelect, _Component2);
	
	  function LocationSelect(props) {
	    _classCallCheck(this, LocationSelect);
	
	    var _this3 = _possibleConstructorReturn(this, (LocationSelect.__proto__ || Object.getPrototypeOf(LocationSelect)).call(this, props));
	
	    _this3.handleConfirmClick = function () {
	      var payload = {
	        location: _this3.generateSelectedLocation(),
	        color: _this3.state.levelTable.selectedRow.color
	      };
	      _this3.props.onConfirm(payload);
	    };
	
	    _this3.fetchZones = function () {
	      var success = function success(zones) {
	        _this3.setState({
	          zoneTable: _extends({}, _this3.state.zoneTable, {
	            rows: prcessZoneData(zones)
	          })
	        });
	      };
	      (0, _api.fetchZones)(1, success);
	    };
	
	    _this3.handleZoneSelect = function (row) {
	      _this3.setState({
	        zoneTable: _extends({}, _this3.state.zoneTable, {
	          selectedRow: row
	        }),
	        binTable: _extends({}, initialTableData),
	        levelTable: _extends({}, initialTableData)
	      });
	
	      var success = function success(bins) {
	        _this3.setState({
	          binTable: _extends({}, _this3.state.binTable, {
	            rows: prcessBinData(bins)
	          })
	        });
	      };
	      (0, _api.fetchBins)(row.value, success);
	    };
	
	    _this3.handleBinSelect = function (bin) {
	      var _this3$state = _this3.state,
	          zoneTable = _this3$state.zoneTable,
	          binTable = _this3$state.binTable;
	
	
	      _this3.setState({
	        binTable: _extends({}, _this3.state.binTable, {
	          selectedRow: bin
	        }),
	        levelTable: _extends({}, initialTableData)
	      });
	      var success = function success(levels) {
	        _this3.setState({
	          levelTable: _extends({}, _this3.state.levelTable, {
	            rows: processLevelData(levels)
	          })
	        });
	      };
	
	      (0, _api.fetchLevels)(bin.value, success);
	    };
	
	    _this3.handleLevelSelect = function (level) {
	      _this3.setState({
	        levelTable: _extends({}, _this3.state.levelTable, {
	          selectedRow: level
	        })
	      });
	    };
	
	    _this3.renderZoneTable = function () {
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.zoneTable);
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return Object.assign({}, rows[rowIdx]);
	      };
	
	      var columns = [{
	        key: 'label',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: "zone" }),
	        resizable: true,
	        sortable: true,
	        // width: 200,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(_reactDataGrid2.default, {
	        rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: _this3.handleZoneSelect }),
	        columns: columns,
	        rowGetter: rowGetter,
	        rowsCount: getSize()
	      });
	    };
	
	    _this3.renderBinTable = function () {
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.binTable);
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return Object.assign({}, rows[rowIdx]);
	      };
	
	      var columns = [{
	        key: 'label',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: "bin" }),
	        resizable: true,
	        sortable: true,
	        // width: 200,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(_reactDataGrid2.default, {
	        rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: _this3.handleBinSelect }),
	        columns: columns,
	        rowGetter: rowGetter,
	        rowsCount: getSize()
	      });
	    };
	
	    _this3.renderLevelTable = function () {
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.levelTable);
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return Object.assign({}, rows[rowIdx]);
	      };
	
	      var columns = [{
	        key: 'label',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: "level" }),
	        resizable: true,
	        sortable: true,
	        // width: 200,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(_reactDataGrid2.default, {
	        rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: _this3.handleLevelSelect }),
	        columns: columns,
	        rowGetter: rowGetter,
	        rowsCount: getSize()
	      });
	    };
	
	    _this3.generateSelectedLocation = function () {
	      var _this3$state2 = _this3.state,
	          zoneTable = _this3$state2.zoneTable,
	          binTable = _this3$state2.binTable,
	          levelTable = _this3$state2.levelTable;
	
	
	      var location = '';
	      if (zoneTable.selectedRow.value) {
	        location = zoneTable.selectedRow.label;
	      }
	      if (binTable.selectedRow.value) {
	        location = location + "-" + binTable.selectedRow.label;
	      }
	      if (levelTable.selectedRow.value) {
	        location = location + "-" + levelTable.selectedRow.label;
	      }
	      return location;
	    };
	
	    _this3.state = {
	      // location: props.selectedRows.length ? props.selectedRows[0].Location : '',
	      zoneTable: _extends({}, initialTableData),
	      binTable: _extends({}, initialTableData),
	      levelTable: _extends({}, initialTableData)
	
	    };
	    return _this3;
	  }
	
	  _createClass(LocationSelect, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.fetchZones();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	
	      return _react2.default.createElement(
	        "div",
	        { style: { width: '100%', height: '100%', padding: '10px' } },
	        _react2.default.createElement(
	          "div",
	          { style: { display: 'flex', fontSize: '40px', flexDirection: 'row', textAlign: 'center', justifyContent: 'center', alignItems: 'center' } },
	          _react2.default.createElement(
	            "div",
	            { style: { paddingRight: '10px' } },
	            "Selected Location:  "
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            this.generateSelectedLocation()
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { display: 'flex', flexDirection: 'row', width: '100%', heiight: '', border: '1px olid red' } },
	          _react2.default.createElement(
	            "div",
	            { style: { width: '33.3%', border: '1px solid green' } },
	            this.renderZoneTable()
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { width: '33.3%', border: '1px solid green' } },
	            this.renderBinTable()
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { width: '33.3%', border: '1px solid green' } },
	            this.renderLevelTable()
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { width: '100%', justifyContent: 'end', alignContent: 'end', textAlign: 'end', alignItems: 'end', paddingTop: '40px' } },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: "primary",
	              className: "print-btn",
	              type: "button"
	              // disabled={selectedRows.length !== 1}
	              , onClick: this.handleConfirmClick
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "confirm" })
	          )
	        )
	      );
	    }
	  }]);
	
	  return LocationSelect;
	}(_react.Component);
	
	var LocationSelectModal = function LocationSelectModal(_ref) {
	  var setModalVisibility = _ref.setModalVisibility,
	      isVisible = _ref.isVisible,
	      onConfirm = _ref.onConfirm,
	      editingLine = _ref.editingLine;
	  return _react2.default.createElement(
	    _reactSkylight.SkyLightStateless,
	    {
	      title: 'Location Select',
	      onCloseClicked: setModalVisibility,
	      dialogStyles: modalStyle,
	      isVisible: isVisible
	    },
	    _react2.default.createElement(LocationSelect, { onConfirm: onConfirm, selectedWarehouse: 1, editingLine: editingLine })
	  );
	};
	
	LocationSelectModal.propTypes = propTypes;
	LocationSelectModal.defaultProps = defaultProps;
	
	var _default = LocationSelectModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(modalStyle, "modalStyle", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/warehouseManagement/LocationSelectModal.jsx");
	
	  __REACT_HOT_LOADER__.register(propTypes, "propTypes", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/warehouseManagement/LocationSelectModal.jsx");
	
	  __REACT_HOT_LOADER__.register(defaultProps, "defaultProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/warehouseManagement/LocationSelectModal.jsx");
	
	  __REACT_HOT_LOADER__.register(prcessZoneData, "prcessZoneData", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/warehouseManagement/LocationSelectModal.jsx");
	
	  __REACT_HOT_LOADER__.register(prcessBinData, "prcessBinData", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/warehouseManagement/LocationSelectModal.jsx");
	
	  __REACT_HOT_LOADER__.register(processLevelData, "processLevelData", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/warehouseManagement/LocationSelectModal.jsx");
	
	  __REACT_HOT_LOADER__.register(initialTableData, "initialTableData", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/warehouseManagement/LocationSelectModal.jsx");
	
	  __REACT_HOT_LOADER__.register(RowRenderer, "RowRenderer", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/warehouseManagement/LocationSelectModal.jsx");
	
	  __REACT_HOT_LOADER__.register(LocationSelect, "LocationSelect", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/warehouseManagement/LocationSelectModal.jsx");
	
	  __REACT_HOT_LOADER__.register(LocationSelectModal, "LocationSelectModal", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/warehouseManagement/LocationSelectModal.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/warehouseManagement/LocationSelectModal.jsx");
	}();

	;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchLevels = exports.fetchBins = exports.fetchZones = undefined;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fetchZones = exports.fetchZones = function fetchZones(warehouseid, success) {
	  (0, _axios2.default)({
	    method: 'GET',
	    url: _root_url.ROOT_URL + 'v1/warehouse/' + warehouseid,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    var Warehouse_Zone = res.data.Warehouse_Zone;
	
	    success(Warehouse_Zone);
	  }, function (err) {
	    alert(err);
	  });
	};
	
	var fetchBins = exports.fetchBins = function fetchBins(binId, success) {
	  (0, _axios2.default)({
	    method: 'GET',
	    url: _root_url.ROOT_URL + 'v1/warehouse/zone/' + binId + '/section/',
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    var data = res.data;
	
	    success(data);
	  }, function (err) {
	    alert(err);
	  });
	};
	
	var fetchLevels = exports.fetchLevels = function fetchLevels(section_id, success) {
	  (0, _axios2.default)({
	    method: 'GET',
	    url: _root_url.ROOT_URL + 'v1/warehouse/section/' + section_id + '/bin',
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    var data = res.data;
	
	    success(data);
	  }, function (err) {
	    alert(err);
	  });
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchZones, 'fetchZones', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/warehouseManagement/api.js');
	
	  __REACT_HOT_LOADER__.register(fetchBins, 'fetchBins', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/warehouseManagement/api.js');
	
	  __REACT_HOT_LOADER__.register(fetchLevels, 'fetchLevels', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/warehouseManagement/api.js');
	}();

	;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LocationSelectModal = __webpack_require__(310);
	
	var _LocationSelectModal2 = _interopRequireDefault(_LocationSelectModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warehouseManagement = {
	  LocationSelectModal: _LocationSelectModal2.default
	};
	var _default = warehouseManagement;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(warehouseManagement, 'warehouseManagement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/warehouseManagement/index.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/modals/warehouseManagement/index.jsx');
	}();

	;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.POSGraphModal = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _reactChartjs = __webpack_require__(102);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isMMD = _root_url.ROOT_API_URL === "https://mmdavis-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === 'https://mmdavis-scm.truckxi.com/api/';
	
	var Selectors = _reactDataGridAddons.Data.Selectors;
	
	var POSGraphModal = exports.POSGraphModal = function (_Component) {
	    _inherits(POSGraphModal, _Component);
	
	    function POSGraphModal() {
	        _classCallCheck(this, POSGraphModal);
	
	        var _this = _possibleConstructorReturn(this, (POSGraphModal.__proto__ || Object.getPrototypeOf(POSGraphModal)).call(this));
	
	        _this.fetchGraphData = function () {
	            var _this$state = _this.state,
	                graphType = _this$state.graphType,
	                hourDate = _this$state.hourDate,
	                fromDate = _this$state.fromDate,
	                toDate = _this$state.toDate;
	
	            var from = null;
	            var to = null;
	
	            if (graphType === 'Day' && fromDate && toDate) {
	                from = (0, _moment2.default)(fromDate).startOf('day').toISOString();
	                to = (0, _moment2.default)(toDate).endOf('day').toISOString();
	            } else if (graphType === 'Hour') {
	                from = (0, _moment2.default)(hourDate).startOf('day').toISOString();
	                to = (0, _moment2.default)(hourDate).endOf('day').toISOString();
	            } else {
	                return;
	            }
	
	            _this.state.totalCustomers = 0;
	            _this.state.totalRevenue = 0;
	
	            var url = _root_url.ROOT_URL + 'v1/pos/order_revenue_report?Type=' + graphType + '&StartDate=' + from + '&EndDate=' + to;
	            (0, _axios2.default)({
	                method: 'GET',
	                url: url,
	                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	            }).then(function (res) {
	                var sortData = [];
	                var tempTime = "";
	                res.data.map(function (r, i) {
	                    _this.state.totalCustomers = _this.state.totalCustomers + r.Customers;
	                    _this.state.totalRevenue = _this.state.totalRevenue + r.Revenue;
	                    if (graphType === 'Hour') {
	                        if (i * 100 < 1000) {
	                            tempTime = '0' + i + ':00';
	                            tempTime = (0, _moment2.default)(tempTime, 'HH:mm').format('hh:mm a');
	                            sortData.push(_extends({}, r, { HourTime: tempTime, Revenue: r.Revenue ? r.Revenue.toFixed(2) : 0 }));
	                        } else {
	                            tempTime = i + ':00';
	                            tempTime = (0, _moment2.default)(tempTime, 'HH:mm').format('hh:mm a');
	                            sortData.push(_extends({}, r, { HourTime: tempTime, Revenue: r.Revenue ? r.Revenue.toFixed(2) : 0 }));
	                        }
	                    } else {
	                        tempTime = (0, _moment2.default)(r.Date).format("MM-DD-YY");
	                        sortData.push(_extends({}, r, { Date: tempTime, Revenue: r.Revenue ? r.Revenue.toFixed(2) : 0 }));
	                    }
	                });
	
	                _this.setState({
	                    rows: sortData,
	                    selectedRows: [],
	                    editedRows: []
	                });
	            }, function (err) {});
	        };
	
	        _this.handleOnSave = function (e) {
	            e.preventDefault();
	            _this.state.rows.map(function (r) {
	                // r.recreate = false;
	            });
	            if (_this.state.selectedRows.length < 1) {
	                alert("At least one product is required.");
	                return;
	            }
	            var tempArray = [];
	            var tempString = "";
	            if (_this.state.selectedRows && _this.state.selectedRows.length > 0) {
	                _this.state.selectedRows.map(function (r) {
	                    tempArray.push(r.SalesOrderLine_id);
	                });
	                tempString = tempArray.join(',');
	            }
	            // this.props.printSalesOrderLabelDSQ(tempString);
	            // this.props.updateFJAgents(this.props.fjCustomerId, this.state.rows).then((response) => {
	            //     // alert(JSON.stringify(response.data));
	            //     alert("Agents Saved");
	            //     this.props.closeAgentModal();
	            //   }, (err) => {
	            //     if (err.status === 500 || err.status === 404) {
	            //       alert(JSON.stringify(err.data));
	            //     }
	            //   });
	            // this.props.onSave(this.state.rows);
	        };
	
	        _this.state = {
	            rows: [],
	            selectedRows: null,
	            editedRows: [],
	            filters: {},
	            sortColumn: null,
	            sortDirection: null,
	
	            graphType: 'Hour',
	            hourDate: null,
	            fromDate: null,
	            toDate: null,
	
	            totalCustomers: 0,
	            totalRevenue: 0
	        };
	        return _this;
	    }
	
	    _createClass(POSGraphModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // this.props.fetchFJAgents(this.props.fjCustomerId).then((response) => {
	            //     if (response.data) {
	            //         this.initializeModal(response.data);
	            //     }
	            // }, (err) => {
	            //     if (err.status === 500 || err.status === 404) {
	            //         alert("Server error, please refresh page. If problem persists, contact administrator.");
	            //     }
	            // });
	
	            this.state.hourDate = new Date();
	            this.fetchGraphData();
	
	            // axios({
	            //     method: 'GET',
	            //     url: url,
	            //     headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
	            // })
	            //     .then(res => {
	            //         this.setState({
	            //             rows: res.data.Sales_Order_Lines,
	            //             selectedRows: [],
	            //             editedRows: [],
	            //         });
	            //     }, err => {
	            //     })
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	
	        // initializeModal = (array) => {
	        //     let index = 0;
	        //     let formatter = [];
	        //     if (array && array.length > 0) {
	        //         array.map(r => {
	        //             formatter.push({ Idx: index++, customer: r.customer, id: r.id, name: r.name, note: r.note, ref_num: r.ref_num });
	        //         })
	        //     } else {
	        //         formatter.push({ Idx: 0, name: "", note: "" });
	        //     }
	        //     this.setState({
	        //         rows: formatter,
	        //         selectedRows: [],
	        //         editedRows: [],
	        //     });
	        // }
	
	    }, {
	        key: 'shiftLeft',
	        value: function shiftLeft(arr) {
	            var first = arr.shift();
	            arr.push(first);
	            return arr;
	        }
	    }, {
	        key: 'renderGraph',
	        value: function renderGraph() {
	            var _state = this.state,
	                rows = _state.rows,
	                graphType = _state.graphType;
	            // const rand = () => Math.round(Math.random() * 20 - 10);
	
	            var dataC = [];
	            var dataR = [];
	
	            var labels = [];
	
	            if (rows) {
	                rows.map(function (r) {
	                    dataC.push(r.Customers);
	                    dataR.push(r.Revenue);
	                    if (graphType === 'Hour') {
	                        labels.push(r.HourTime);
	                    } else {
	                        labels.push(r.Date);
	                    }
	                });
	            }
	
	            if (isMMD && graphType === 'Hour') {
	                dataC.splice(2, 6);
	                dataR.splice(2, 6);
	                labels.splice(2, 6);
	                dataC = this.shiftLeft(dataC);
	                dataR = this.shiftLeft(dataR);
	                labels = this.shiftLeft(labels);
	                dataC = this.shiftLeft(dataC);
	                dataR = this.shiftLeft(dataR);
	                labels = this.shiftLeft(labels);
	            }
	
	            var data = {
	                labels: labels,
	                datasets: [{
	                    type: 'line',
	                    label: 'Net Revenue',
	                    borderColor: 'rgb(54, 162, 235)',
	                    borderWidth: 2,
	                    fill: false,
	                    data: dataR,
	                    yAxisID: 'y-axis-2'
	                }, {
	                    type: 'bar',
	                    label: 'Customers',
	                    backgroundColor: '#ff8b3d',
	                    data: dataC,
	                    borderColor: 'white',
	                    borderWidth: 2,
	                    yAxisID: 'y-axis-1'
	                }]
	            };
	
	            var options = {
	                scales: {
	                    yAxes: [{
	                        scaleLabel: { display: true, labelString: 'Customers', fontColor: 'rgb(220, 147, 76)' },
	                        type: 'linear',
	                        display: true,
	                        position: 'right',
	                        id: 'y-axis-1',
	                        gridLines: { display: false }
	                    }, {
	                        type: 'linear',
	                        display: true,
	                        position: 'left',
	                        id: 'y-axis-2',
	                        text: 'Revenue',
	                        scaleLabel: { display: true, labelString: 'Net Revenue', fontColor: 'rgb(54, 162, 235)' },
	                        gridLines: { display: false }
	                    }]
	                }
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12, style: { marginTop: '20px' } },
	                    _react2.default.createElement(_reactChartjs.Bar, { data: data, options: options })
	                )
	            );
	        }
	    }, {
	        key: 'renderAgentTable',
	        value: function renderAgentTable() {
	            var _this2 = this;
	
	            var getRows = function getRows() {
	                return Selectors.getRows(_this2.state);
	            };
	            var getSize = function getSize() {
	                return getRows().length;
	            };
	            var rowGetter = function rowGetter(rowIdx) {
	                var rows = getRows();
	                return rows[rowIdx];
	            };
	            var handleRowUpdated = function handleRowUpdated(e) {
	                _this2.setState({ sortColumn: null, sortDirection: null });
	                var rows = getRows();
	                var editedRows = _this2.state.editedRows.slice(0);
	                Object.assign(rows[e.rowIdx], e.updated);
	                editedRows.forEach(function (element, index) {
	                    if (element.Idx === rows[e.rowIdx].Idx) editedRows.splice(index, 1);
	                }, _this2);
	                editedRows.push(rows[e.rowIdx]);
	                _this2.setState({
	                    rows: rows,
	                    editedRows: editedRows
	                });
	            };
	            // const onRowsSelected = (rows) => {
	            //     let newRows = getRows();
	            //     newRows.map(r => {
	            //         r.isSelected = false;
	            //     })
	            //     rows.map(r => {
	            //         newRows[r.rowIdx].isSelected = true;
	            //     });
	            //     this.setState({ rows: newRows, selectedRows: [rows[0].row] });
	            // }
	            var onRowsSelected = function onRowsSelected(rows) {
	                var newRows = getRows();
	                var selectedRows = [].concat(_toConsumableArray(_this2.state.selectedRows));
	                rows.map(function (r) {
	                    newRows[r.rowIdx].isSelected = true;
	                    selectedRows.push(r.row);
	                });
	                _this2.setState({ rows: newRows, selectedRows: selectedRows });
	            };
	            // const onRowsDeselected = (rows) => {
	            //     let newRows = getRows();
	            //     rows.map(r => {
	            //         newRows[r.rowIdx].isSelected = false;
	            //     });
	            //     this.setState({ rows: newRows, selectedRows: [] });
	            // }
	            var onRowsDeselected = function onRowsDeselected(rows) {
	                var newRows = [].concat(_toConsumableArray(_this2.state.rows));
	                var selectedRows = [].concat(_toConsumableArray(_this2.state.selectedRows));
	                rows.map(function (r) {
	                    newRows[r.rowIdx].isSelected = false;
	                    var rowIndex = selectedRows.indexOf(r.row);
	                    selectedRows.splice(rowIndex, 1);
	                });
	                _this2.setState({ rows: newRows, selectedRows: selectedRows });
	            };
	
	            var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                _this2.setState(state);
	            };
	
	            var handleFilterChange = function handleFilterChange(filter) {
	                var newFilters = Object.assign({}, _this2.state.filters);
	                if (filter.filterTerm) {
	                    newFilters[filter.column.key] = filter;
	                } else {
	                    delete newFilters[filter.column.key];
	                }
	                _this2.setState({ filters: newFilters });
	            };
	
	            var SecondsDateFormatter = _react2.default.createClass({
	                displayName: 'SecondsDateFormatter',
	                render: function render() {
	                    if (this.props.value) {
	                        var date = (0, _moment2.default)(this.props.value).format("MM-DD-YY HH:mm");
	                        return _react2.default.createElement(
	                            'span',
	                            null,
	                            date
	                        );
	                    }
	                    return _react2.default.createElement(
	                        'span',
	                        { className: 'label label-danger' },
	                        '-'
	                    );
	                }
	            });
	
	            var columns = [].concat(_toConsumableArray(this.state.graphType === 'Hour' ? [{
	                key: "HourTime",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'hour' }),
	                resizable: true,
	                sortable: true,
	                width: 100,
	                filterable: true
	            }] : [{
	                key: "Date",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	                resizable: true,
	                sortable: true,
	                width: 100,
	                filterable: true
	            }]), [{
	                key: "Customers",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customers' }),
	                resizable: true,
	                sortable: true,
	                width: 100,
	                filterable: true
	            }, {
	                key: "Revenue",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_revenue' }),
	                resizable: true,
	                sortable: true,
	                width: 110,
	                filterable: true,
	                formatter: function formatter(_ref) {
	                    var value = _ref.value;
	                    return _react2.default.createElement(
	                        'div',
	                        { style: { width: "100%", height: "100%", textAlign: "center" } },
	                        '$',
	                        value
	                    );
	                }
	            }]);
	
	            var onRowClick = function onRowClick(rowIdx, row) {
	                if (rowIdx !== -1) {
	                    var rows = getRows();
	                    rows.map(function (r) {
	                        r.isSelected = false;
	                    });
	                    var selectedRows = [rows[rowIdx]];
	                    rows[rowIdx].isSelected = true;
	                    //   const salesOrders = { ...this.state.salesOrders, rows, selectedRows };
	                    //   this.setState({ salesOrders });
	                    //   this.props.fetchSalesOrderDetail(row.SalesOrder_id, route);
	                    var temp = {
	                        rows: [],
	                        selectedRows: null,
	                        editedRows: [],
	                        filters: {}
	                    };
	                    if (selectedRows && selectedRows[0]) {
	                        temp.rows = selectedRows[0].lines;
	                        _this2.setState({ details: temp });
	                    }
	                }
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_reactDataGrid2.default
	                        // rowKey="Idx"
	                        // enableCellSelect={true}
	                        , { onGridSort: handleGridSort,
	                            onAddFilter: handleFilterChange,
	                            columns: columns,
	                            rowGetter: rowGetter,
	                            rowsCount: getSize(),
	                            minHeight: 420,
	                            rowHeight: 25,
	                            headerRowHeight: 45,
	                            toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true })
	                            // enableRowSelect='single'
	                            // onRowUpdated={handleRowUpdated}
	                            // rowSelection={{
	                            //     showCheckbox: true,
	                            //     onRowsSelected,
	                            //     onRowsDeselected,
	                            //     selectBy: {
	                            //         isSelectedKey: 'isSelected'
	                            //     }
	                            // }}
	                            // onRowClick={onRowClick}
	                        })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            _objectDestructuringEmpty(this.props);
	
	            var _state2 = this.state,
	                graphType = _state2.graphType,
	                hourDate = _state2.hourDate,
	                fromDate = _state2.fromDate,
	                toDate = _state2.toDate,
	                totalCustomers = _state2.totalCustomers,
	                totalRevenue = _state2.totalRevenue;
	
	
	            var from = null;
	            var to = null;
	            if (graphType === 'Day' && fromDate && toDate) {
	                from = (0, _moment2.default)(fromDate).startOf('day').toISOString();
	                to = (0, _moment2.default)(toDate).endOf('day').toISOString();
	            } else if (graphType === 'Hour') {
	                from = (0, _moment2.default)(hourDate).startOf('day').toISOString();
	                to = (0, _moment2.default)(hourDate).endOf('day').toISOString();
	            }
	            var params = 'Type=' + graphType + '&StartDate=' + from + '&EndDate=' + to;
	            var token = localStorage.getItem('token');
	            var excelURL = _root_url.ROOT_URL + 'v1/pos/order_revenue_report?' + params + '&Bearer=' + token + '&action=excel';
	            var isExcelDisabled = false;
	            if (graphType === 'Day' && (!fromDate || !toDate)) {
	                isExcelDisabled = true;
	            } else if (graphType === 'Hour' && !hourDate) {
	                isExcelDisabled = true;
	            }
	
	            var graphTypeOptions = [{
	                label: 'Hour',
	                value: 'Hour'
	            }, {
	                label: 'Day',
	                value: 'Day'
	            }];
	
	            var graphTypeChange = function graphTypeChange(e) {
	                console.log("graphType", e.value);
	                _this3.setState({ graphType: e.value, totalCustomers: 0, totalRevenue: 0, hourDate: null, fromDate: null, toDate: null, rows: [] });
	            };
	
	            var hourDateChange = function hourDateChange(e) {
	                var hourDate = _this3.state.hourDate;
	
	                console.log("hour", e);
	                _this3.setState({ hourDate: e });
	                _this3.state.hourDate = e;
	                _this3.fetchGraphData();
	            };
	
	            var fromDateChange = function fromDateChange(e) {
	                var _state3 = _this3.state,
	                    toDate = _state3.toDate,
	                    fromDate = _state3.fromDate;
	
	                console.log("from", e);
	                if (toDate && e > toDate) {
	                    alert("Selection must be earlier than ending date.");
	                    return;
	                }
	                if ((0, _moment2.default)(toDate).diff((0, _moment2.default)(e), 'days') > 31) {
	                    alert("Time difference limit of 30 days.");
	                    return;
	                }
	                _this3.setState({ fromDate: e });
	                _this3.state.fromDate = e;
	                _this3.fetchGraphData();
	            };
	
	            var toDateChange = function toDateChange(e) {
	                var _state4 = _this3.state,
	                    toDate = _state4.toDate,
	                    fromDate = _state4.fromDate;
	
	                console.log("to", e);
	                if (fromDate && e < fromDate) {
	                    alert("Selection must be later than starting date.");
	                    return;
	                }
	                if ((0, _moment2.default)(e).diff((0, _moment2.default)(fromDate), 'days') > 31) {
	                    alert("Time difference limit of 30 days.");
	                    return;
	                }
	                _this3.setState({ toDate: e });
	                _this3.state.toDate = e;
	                _this3.fetchGraphData();
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-1', style: { textAlign: 'right', marginTop: '3px' } },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'graph_type' }),
	                        ':'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-1' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Dropdown,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Dropdown.Toggle,
	                                { style: { height: '24px', width: '100px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' } },
	                                graphType ? graphType : 'SELECT'
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Dropdown.Menu,
	                                { className: 'super-colors' },
	                                graphTypeOptions.map(function (el) {
	                                    return _react2.default.createElement(
	                                        _reactBootstrap.MenuItem,
	                                        { onClick: function onClick() {
	                                                return graphTypeChange(el);
	                                            } },
	                                        el.label
	                                    );
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-1', style: { textAlign: 'right', marginTop: '3px' } },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	                        ':'
	                    ),
	                    graphType === 'Hour' && _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-2' },
	                        _react2.default.createElement(_DateTimePicker2.default, {
	                            id: 'all-register-datepicker',
	                            format: 'MM-DD-YY'
	                            // max={Today}
	                            // step={10}
	                            , onChange: function onChange(e) {
	                                hourDateChange(e);
	                            },
	                            time: false,
	                            value: hourDate
	                        })
	                    ),
	                    graphType === 'Day' && _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-2' },
	                        _react2.default.createElement(_DateTimePicker2.default, {
	                            id: 'all-register-datepicker',
	                            format: 'MM-DD-YY'
	                            // max={Today}
	                            // step={10}
	                            , onChange: function onChange(e) {
	                                fromDateChange(e);
	                            },
	                            time: false,
	                            value: fromDate
	                        })
	                    ),
	                    graphType === 'Day' && _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-1', style: { width: '40px', textAlign: 'center', marginTop: '3px' } },
	                        'to'
	                    ),
	                    graphType === 'Day' && _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-2' },
	                        _react2.default.createElement(_DateTimePicker2.default, {
	                            id: 'all-register-datepicker',
	                            format: 'MM-DD-YY'
	                            // max={Today}
	                            // step={10}
	                            , onChange: function onChange(e) {
	                                toDateChange(e);
	                            },
	                            time: false,
	                            value: toDate
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-1', style: { marginLeft: '20px' } },
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'success',
	                                className: 'export-to-excel'
	                                // type='button'
	                                , disabled: isExcelDisabled,
	                                href: excelURL
	                            },
	                            _react2.default.createElement('em', { className: 'fa fa-download' }),
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 9, className: 'text-center' },
	                            _react2.default.createElement(
	                                'div',
	                                { style: { padding: '0px 0px' } },
	                                this.renderGraph()
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 3, className: 'text-center' },
	                            _react2.default.createElement(
	                                'div',
	                                { style: { padding: '0px 0px' } },
	                                this.renderAgentTable(),
	                                _react2.default.createElement(
	                                    'div',
	                                    { style: { fontSize: '12px', marginTop: '3px', padding: '0px 5px', justifyContent: 'space-between', display: 'flex' } },
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        'Total Customers: ',
	                                        _react2.default.createElement(
	                                            'span',
	                                            { style: { color: 'rgb(220, 147, 76)', fontWeight: 'bold' } },
	                                            totalCustomers
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        'Total Revenue: ',
	                                        _react2.default.createElement(
	                                            'span',
	                                            { style: { color: 'rgb(220, 147, 76)', fontWeight: 'bold' } },
	                                            '$',
	                                            totalRevenue ? totalRevenue.toFixed(2) : 0
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return POSGraphModal;
	}(_react.Component);
	
	var _default = POSGraphModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(POSGraphModal, 'POSGraphModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/posGraphModal.jsx');
	
	    __REACT_HOT_LOADER__.register(isMMD, 'isMMD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/posGraphModal.jsx');
	
	    __REACT_HOT_LOADER__.register(Selectors, 'Selectors', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/posGraphModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/posGraphModal.jsx');
	}();

	;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PriceLevel = function (_Component) {
	  _inherits(PriceLevel, _Component);
	
	  function PriceLevel() {
	    _classCallCheck(this, PriceLevel);
	
	    return _possibleConstructorReturn(this, (PriceLevel.__proto__ || Object.getPrototypeOf(PriceLevel)).apply(this, arguments));
	  }
	
	  _createClass(PriceLevel, [{
	    key: 'render',
	    value: function render() {
	      var titleClass = (0, _classnames2.default)({ 'parsley-error-label': this.props.meta.touched && this.props.meta.error }, 'control-label');
	      var _props = this.props,
	          input = _props.input,
	          isRequired = _props.isRequired;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'price-level-setup boolean-field' },
	        this.props.meta.touched && this.props.meta.error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          this.props.meta.error
	        ),
	        _react2.default.createElement(
	          'label',
	          { className: titleClass },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price_level_percent' }),
	          isRequired && _react2.default.createElement(
	            'span',
	            { className: 'asteriksReq' },
	            '*'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'boolean-input' },
	          _react2.default.createElement(
	            'label',
	            { className: 'boolean' },
	            _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { type: 'radio', value: '1', checked: input.value === 1 || input.value === '1' })),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv1' })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'boolean' },
	            _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { type: 'radio', value: '2', checked: input.value === 2 || input.value === '2' })),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv2' })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'boolean' },
	            _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { type: 'radio', value: '3', checked: input.value === 3 || input.value === '3' })),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv3' })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'boolean' },
	            _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { type: 'radio', value: '4', checked: input.value === 4 || input.value === '4' })),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv4' })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'boolean' },
	            _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { type: 'radio', value: '5', checked: input.value === 5 || input.value === '5' })),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv5' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return PriceLevel;
	}(_react.Component);
	
	var _default = PriceLevel;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PriceLevel, 'PriceLevel', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/priceLevel.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/priceLevel.jsx');
	}();

	;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Radio = function (_Component) {
	  _inherits(Radio, _Component);
	
	  function Radio() {
	    _classCallCheck(this, Radio);
	
	    return _possibleConstructorReturn(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).apply(this, arguments));
	  }
	
	  _createClass(Radio, [{
	    key: 'render',
	    value: function render() {
	      var titleClass = (0, _classnames2.default)({ 'parsley-error-label': this.props.meta.touched && this.props.meta.error }, 'control-label', 'marginTopStyle', 'textAlignStyle');
	      var input = this.props.input;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            this.props.meta.touched && this.props.meta.error && _react2.default.createElement(
	              'span',
	              { className: 'parsley-error-message' },
	              this.props.meta.error
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 8 },
	            _react2.default.createElement(
	              'label',
	              { className: titleClass },
	              this.props.title,
	              ' (*)'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 2 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { type: 'radio', value: true, checked: input.value === true || input.value === 'true' })),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 2 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactBootstrap.Input, _extends({}, input, { type: 'radio', value: false, checked: input.value === false || input.value === 'false' })),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Radio;
	}(_react.Component);
	
	var _default = Radio;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Radio, 'Radio', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/radio.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/radio.jsx');
	}();

	;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isHMM = _root_url.ROOT_API_URL === 'https://hmm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://hmm-scm.truckxi.com/api/';
	var isMAG = _root_url.ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://magna-scm.truckxi.com/api/';
	
	var addShippingAddress = function addShippingAddress(data, receivingCustomer, success, failure) {
	  (0, _axios2.default)({
	    method: 'PUT',
	    data: data,
	    url: _root_url.ROOT_URL + "v1/customer/" + receivingCustomer,
	    headers: { Authorization: "Bearer " + localStorage.getItem('token') }
	  }).then(function (res) {
	    success();
	  }, function (err) {
	    failure();
	    var data = err.data;
	    alert(JSON.stringify(data));
	  });
	};
	
	var dataValid = function dataValid(data) {
	  if (isHMM) {
	    if (!data.AddressName || !data.Telephone) {
	      return;
	    }
	  } else if (isMAG) {
	    if (!data.AddressName || !data.Street || !data.City || !data.State || !data.Zip || !data.DrayageCode) {
	      return;
	    }
	  } else {
	    if (!data.AddressName || !data.Telephone || !data.Street || !data.Cellphone || !data.City || !data.Email || !data.State || !data.Zip) {
	      return;
	    }
	  }
	  return true;
	};
	
	var fetchCustomerDetails = function fetchCustomerDetails(receivingCustomer, success) {
	  (0, _axios2.default)({
	    method: 'GET',
	    url: _root_url.ROOT_URL + "/v1/customer/" + receivingCustomer,
	    headers: { Authorization: "Bearer " + localStorage.getItem('token') }
	  }).then(function (res) {
	    success(res);
	  }, function (err) {});
	};
	
	var ShippingAddressEditmodal = function (_Component) {
	  _inherits(ShippingAddressEditmodal, _Component);
	
	  function ShippingAddressEditmodal() {
	    _classCallCheck(this, ShippingAddressEditmodal);
	
	    var _this = _possibleConstructorReturn(this, (ShippingAddressEditmodal.__proto__ || Object.getPrototypeOf(ShippingAddressEditmodal)).call(this));
	
	    _this.handleInputFieldChange = function (_ref) {
	      var name = _ref.name,
	          value = _ref.value;
	      return _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.handleFetchCustomerDetailsSuccess = function (_ref2) {
	      var data = _ref2.data;
	
	      _this.setState({
	        IsDefault: "true",
	        AddressName: "",
	        Telephone: "",
	        Street: "",
	        City: "",
	        State: "",
	        Zip: "",
	        Email: "",
	        Cellphone: "",
	        DrayageCode: "",
	        customerDetails: data
	      });
	    };
	
	    _this.handleSubmit = function () {
	
	      if (!dataValid(_this.state)) {
	        alert('fill in required fields');
	        return;
	      }
	
	      _this.setState({
	        buttonDisabled: true
	      });
	      var customerDetails = _extends({}, _this.state.customerDetails);
	
	      var data = _extends({}, _this.state);
	
	      delete data.customerDetails;
	
	      // customerDetails.Shipping = [data];
	      customerDetails.Shipping.push(data);
	
	      addShippingAddress(customerDetails, _this.props.receivingCustomer, function () {
	        _this.props.reFetchSalesCustomers();
	        _this.setState({
	          buttonDisabled: false
	        });
	      }, function () {
	        _this.setState({
	          buttonDisabled: false
	        });
	        customerDetails.Shipping.splice(-1, 1);
	      });
	    };
	
	    _this.state = {
	      buttonDisabled: false
	    };
	    return _this;
	  }
	
	  _createClass(ShippingAddressEditmodal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      fetchCustomerDetails(this.props.receivingCustomer, this.handleFetchCustomerDetailsSuccess);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          AddressName = _state.AddressName,
	          Telephone = _state.Telephone,
	          Street = _state.Street,
	          City = _state.City,
	          State = _state.State,
	          Zip = _state.Zip,
	          Cellphone = _state.Cellphone,
	          Email = _state.Email,
	          DrayageCode = _state.DrayageCode;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              "label",
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "name" }),
	              _react2.default.createElement(
	                "span",
	                { style: { color: 'red' } },
	                isMAG ? "*" : ""
	              ),
	              ":"
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              "label",
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "cell_phone" }),
	              ":"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(_reactBootstrap.Input, {
	              type: "text",
	              name: "AddressName",
	              value: AddressName,
	              onChange: function onChange(e) {
	                return _this2.handleInputFieldChange(e.target);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(_reactBootstrap.Input, {
	              type: "text",
	              name: "Telephone",
	              value: Telephone,
	              onChange: function onChange(e) {
	                return _this2.handleInputFieldChange(e.target);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              "label",
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "alt_phone" }),
	              ":"
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              "label",
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "email" }),
	              ":"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(_reactBootstrap.Input, {
	              type: "text",
	              name: "Cellphone",
	              value: Cellphone,
	              onChange: function onChange(e) {
	                return _this2.handleInputFieldChange(e.target);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(_reactBootstrap.Input, {
	              type: "text",
	              name: "Email",
	              value: Email,
	              onChange: function onChange(e) {
	                return _this2.handleInputFieldChange(e.target);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              "label",
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "street" }),
	              _react2.default.createElement(
	                "span",
	                { style: { color: 'red' } },
	                isMAG ? "*" : ""
	              ),
	              ":"
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              "label",
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "city" }),
	              _react2.default.createElement(
	                "span",
	                { style: { color: 'red' } },
	                isMAG ? "*" : ""
	              ),
	              ":"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(_reactBootstrap.Input, {
	              type: "text",
	              name: "Street",
	              value: Street,
	              onChange: function onChange(e) {
	                return _this2.handleInputFieldChange(e.target);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(_reactBootstrap.Input, {
	              type: "text",
	              name: "City",
	              value: City,
	              onChange: function onChange(e) {
	                return _this2.handleInputFieldChange(e.target);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              "label",
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "state" }),
	              _react2.default.createElement(
	                "span",
	                { style: { color: 'red' } },
	                isMAG ? "*" : ""
	              ),
	              ":"
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              "label",
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "zip" }),
	              _react2.default.createElement(
	                "span",
	                { style: { color: 'red' } },
	                isMAG ? "*" : ""
	              ),
	              ":"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(_reactBootstrap.Input, {
	              type: "text",
	              name: "State",
	              value: State,
	              onChange: function onChange(e) {
	                return _this2.handleInputFieldChange(e.target);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(_reactBootstrap.Input, {
	              type: "text",
	              name: "Zip",
	              value: Zip,
	              onChange: function onChange(e) {
	                return _this2.handleInputFieldChange(e.target);
	              }
	            })
	          )
	        ),
	        isMAG && _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              "label",
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "drayage_code" }),
	              _react2.default.createElement(
	                "span",
	                { style: { color: 'red' } },
	                isMAG ? "*" : ""
	              ),
	              ":"
	            )
	          )
	        ),
	        isMAG && _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(_reactBootstrap.Input, {
	              type: "text",
	              name: "DrayageCode",
	              value: DrayageCode,
	              onChange: function onChange(e) {
	                return _this2.handleInputFieldChange(e.target);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: "centerStyle", style: { marginTop: "0px" } },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: "success",
	              disabled: this.state.buttonDisabled,
	              onClick: function onClick(e) {
	                _this2.handleSubmit();
	              }
	              // disabled={!this.state.selectedRows || this.state.selectedRows.length < 1}
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "submit" })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ShippingAddressEditmodal;
	}(_react.Component);
	
	var _default = ShippingAddressEditmodal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isHMM, "isHMM", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/shippingInfoEditModal.jsx");
	
	  __REACT_HOT_LOADER__.register(isMAG, "isMAG", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/shippingInfoEditModal.jsx");
	
	  __REACT_HOT_LOADER__.register(addShippingAddress, "addShippingAddress", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/shippingInfoEditModal.jsx");
	
	  __REACT_HOT_LOADER__.register(dataValid, "dataValid", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/shippingInfoEditModal.jsx");
	
	  __REACT_HOT_LOADER__.register(fetchCustomerDetails, "fetchCustomerDetails", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/shippingInfoEditModal.jsx");
	
	  __REACT_HOT_LOADER__.register(ShippingAddressEditmodal, "ShippingAddressEditmodal", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/shippingInfoEditModal.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/shippingInfoEditModal.jsx");
	}();

	;

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// TOGGLE STATE
	// -----------------------------------
	
	var STORAGE_KEY_NAME = 'jq-toggleState';
	
	// Helper object to check for words in a phrase //
	
	var WordChecker = function () {
	    function WordChecker() {
	        _classCallCheck(this, WordChecker);
	    }
	
	    _createClass(WordChecker, null, [{
	        key: 'hasWord',
	        value: function hasWord(phrase, word) {
	            return new RegExp('(^|\\s)' + word + '(\\s|$)').test(phrase);
	        }
	    }, {
	        key: 'addWord',
	        value: function addWord(phrase, word) {
	            if (!this.hasWord(phrase, word)) {
	                return phrase + (phrase ? ' ' : '') + word;
	            }
	        }
	    }, {
	        key: 'removeWord',
	        value: function removeWord(phrase, word) {
	            if (this.hasWord(phrase, word)) {
	                return phrase.replace(new RegExp('(^|\\s)*' + word + '(\\s|$)*', 'g'), '');
	            }
	        }
	    }]);
	
	    return WordChecker;
	}();
	
	;
	
	// Handle states to/from localstorage
	
	var StateToggler = function () {
	    function StateToggler() {
	        _classCallCheck(this, StateToggler);
	    }
	
	    _createClass(StateToggler, [{
	        key: 'addState',
	
	
	        // Add a state to the browser storage to be restored later
	        value: function addState(classname) {
	            var data = $.localStorage.get(STORAGE_KEY_NAME);
	
	            if (!data) {
	                data = classname;
	            } else {
	                data = WordChecker.addWord(data, classname);
	            }
	
	            $.localStorage.set(STORAGE_KEY_NAME, data);
	        }
	
	        // Remove a state from the browser storage
	
	    }, {
	        key: 'removeState',
	        value: function removeState(classname) {
	            var data = $.localStorage.get(STORAGE_KEY_NAME);
	            // nothing to remove
	            if (!data) return;
	
	            data = WordChecker.removeWord(data, classname);
	
	            $.localStorage.set(STORAGE_KEY_NAME, data);
	        }
	
	        // Load the state string and restore the classlist
	
	    }, {
	        key: 'restoreState',
	        value: function restoreState($elem) {
	            var data = $.localStorage.get(STORAGE_KEY_NAME);
	
	            // nothing to restore
	            if (!data) return;
	            $elem.addClass(data);
	        }
	    }]);
	
	    return StateToggler;
	}();
	
	function initStateToggler() {
	
	    var element = $(this);
	    var $body = $('body');
	    var toggle = new StateToggler();
	
	    // restore body classes on init
	    toggle.restoreState($body);
	
	    element.on('click', function (e) {
	        // e.stopPropagation();
	
	        if (this.tagName === 'A') e.preventDefault();
	
	        var element = $(this),
	            classname = element.data('toggleState'),
	            target = element.data('target'),
	            noPersist = element.attr('data-no-persist') !== undefined;
	
	        // Specify a target selector to toggle classname
	        // use body by default
	        var $target = target ? $(target) : $body;
	
	        if (classname) {
	            if ($target.hasClass(classname)) {
	                $target.removeClass(classname);
	                if (!noPersist) toggle.removeState(classname);
	            } else {
	                $target.addClass(classname);
	                if (!noPersist) toggle.addState(classname);
	            }
	        }
	        // some elements may need this when toggled class change the content size
	        // e.g. sidebar collapsed mode and jqGrid
	        $(window).resize();
	    });
	}
	
	var _default = function _default() {
	
	    $('[data-toggle-state]').each(initStateToggler);
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(initStateToggler, 'initStateToggler', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/toggle-state.js');
	
	    __REACT_HOT_LOADER__.register(STORAGE_KEY_NAME, 'STORAGE_KEY_NAME', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/toggle-state.js');
	
	    __REACT_HOT_LOADER__.register(WordChecker, 'WordChecker', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/toggle-state.js');
	
	    __REACT_HOT_LOADER__.register(StateToggler, 'StateToggler', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/toggle-state.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/toggle-state.js');
	}();

	;

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _default = function _default() {
	
	    var element = $('[data-trigger-resize]');
	    var value = element.data('triggerResize');
	
	    element.on('click', function () {
	        setTimeout(function () {
	            // all IE friendly dispatchEvent
	            var evt = document.createEvent('UIEvents');
	            evt.initUIEvent('resize', true, false, window, 0);
	            window.dispatchEvent(evt);
	            // modern dispatchEvent way
	            // window.dispatchEvent(new Event('resize'));
	        }, value || 300);
	    });
	};
	
	/**=========================================================
	 * Module: trigger-resize.js
	 * Triggers a window resize event from any element
	 =========================================================*/

	exports.default = _default;
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }

	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/trigger-resize.js');
	}();

	;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactDayPicker = __webpack_require__(201);
	
	var _reactDayPicker2 = _interopRequireDefault(_reactDayPicker);
	
	__webpack_require__(192);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _cleanDates = __webpack_require__(22);
	
	var _root_url = __webpack_require__(9);
	
	var _immutable = __webpack_require__(193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VITCalendar = function (_Component) {
	  _inherits(VITCalendar, _Component);
	
	  function VITCalendar() {
	    _classCallCheck(this, VITCalendar);
	
	    var _this = _possibleConstructorReturn(this, (VITCalendar.__proto__ || Object.getPrototypeOf(VITCalendar)).call(this));
	
	    _this.handleDayClick = function (day, _ref) {
	      var disabled = _ref.disabled,
	          selected = _ref.selected;
	
	      if (disabled) {
	        return;
	      }
	      _this.setState({
	        selectedDay: selected ? null : day
	      });
	    };
	
	    _this.isPermitted = function (message) {
	      if (message === 'edit') {
	        return (0, _permissions2.default)('change_price_reference');
	      } else if (message === 'view') {
	        return (0, _permissions2.default)('view_price_reference');
	      }
	      return false;
	    };
	
	    _this.state = {
	      selectedDay: new Date()
	    };
	    _this.renderDay = _this.renderDay.bind(_this);
	    _this.onMonthChange = _this.onMonthChange.bind(_this);
	    _this.renderButton = _this.renderButton.bind(_this);
	    return _this;
	  }
	
	  _createClass(VITCalendar, [{
	    key: 'onMonthChange',
	    value: function onMonthChange(date) {
	      var dates = (0, _cleanDates.getFromToDates)(date, 'month');
	      this.props.fetchInfo('month', dates);
	    }
	  }, {
	    key: 'sundays',
	    value: function sundays(day) {
	      return day.getDay() === 0;
	    }
	  }, {
	    key: 'dateFormatter',
	    value: function dateFormatter(day) {
	      var y = day.getFullYear().toString();
	      var m = day.getMonth() + 1;
	      if (m < 10) {
	        m = '0' + m;
	      } else {
	        m = m.toString();
	      }
	      var d = day.getDate();
	      if (d < 10) {
	        d = '0' + d;
	      } else {
	        d = d.toString();
	      }
	      return y + m + d;
	    }
	  }, {
	    key: 'renderButton',
	    value: function renderButton(day) {
	      var _this2 = this;
	
	      var d = this.dateFormatter(day);
	      var todayD = this.dateFormatter(new Date());
	      var message = d < todayD ? 'view' : 'edit';
	      var permission = this.isPermitted(message);
	
	      var handleButtonClick = function handleButtonClick() {
	        if (_this2.props.type === 'priceAdjustment') {
	          var dates = (0, _cleanDates.getFromToDates)(day);
	          _this2.props.fetchInfo('day', dates);
	          //this.props.url = 'VitCalendarDetail'
	          _this2.context.router.push(_this2.props.url);
	          permission = _this2.isPermitted(message);
	        } else if (_this2.props.type === 'purchasePivotChart') {
	          _this2.props.fetchPurchasePivotCharts(d);
	          _this2.props.openChartModal(d);
	          _this2.props.selectDate(d);
	        }
	      };
	      if (d <= todayD) {
	        return _react2.default.createElement(
	          _reactBootstrap.Button,
	          { bsStyle: 'primary', onClick: handleButtonClick, disabled: !permission },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: message })
	        );
	      } else return _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: 'primary', onClick: handleButtonClick, disabled: !permission },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: message })
	      );
	    }
	  }, {
	    key: 'renderDay',
	    value: function renderDay(day) {
	      var date = day.getDate();
	      var d = date.toString();
	      if (date < 10) {
	        d = '0' + d;
	      }
	      var renderButton = this.renderButton;
	      var totalEvents = [];
	      var openEvents = [];
	      var cancelledEvents = [];
	      if (this.props.data !== null) {
	        totalEvents = this.props.data.filter(function (ele) {
	          return ele.appointment_time.split("_")[0].split("-")[2] === d;
	        });
	        openEvents = totalEvents.filter(function (ele) {
	          return ele.status === 'Open';
	        });
	        cancelledEvents = totalEvents.filter(function (ele) {
	          return ele.status === 'Cancelled';
	        });
	      }
	      var index = 1;
	
	      if (index > -1 && this.props.type === "priceAdjustment") {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'date' },
	            date
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Appointment' }),
	            ': ',
	            openEvents.length
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Cancelled' }),
	            ': ',
	            cancelledEvents.length
	          ),
	          renderButton(day)
	        );
	      } else if (index > -1 && this.props.type === "purchasePivotChart") {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'date' },
	            date
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            this.props.data[index].Order,
	            ' ',
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'orders' })
	          ),
	          renderButton(day)
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'emptyDate' },
	          date
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_reactDayPicker2.default, {
	        initialMonth: new Date(),
	        selectedDays: this.state.selectedDay,
	        onDayClick: this.handleDayClick,
	        onMonthChange: this.onMonthChange,
	        renderDay: this.renderDay
	      });
	    }
	  }]);
	
	  return VITCalendar;
	}(_react.Component);
	
	VITCalendar.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = VITCalendar;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(VITCalendar, 'VITCalendar', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/vitCalendar.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/vitCalendar.jsx');
	}();

	;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.WeightChangeModal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WeightChangeModal = exports.WeightChangeModal = function (_Component) {
	    _inherits(WeightChangeModal, _Component);
	
	    function WeightChangeModal() {
	        _classCallCheck(this, WeightChangeModal);
	
	        return _possibleConstructorReturn(this, (WeightChangeModal.__proto__ || Object.getPrototypeOf(WeightChangeModal)).apply(this, arguments));
	    }
	
	    _createClass(WeightChangeModal, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4 },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_shipping_weight' })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4 },
	                        _react2.default.createElement(_reactBootstrap.Input, {
	                            type: 'number'
	                            // value={this.props.finalShippingWeight}
	                            , onChange: this.props.onChange
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'primary',
	                                    onClick: this.props.onClickButton
	                                },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return WeightChangeModal;
	}(_react.Component);
	
	var _default = WeightChangeModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(WeightChangeModal, 'WeightChangeModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/weightChangeModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/weightChangeModal.jsx');
	}();

	;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.WeightChangeModalMulti = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Selectors = _reactDataGridAddons.Data.Selectors;
	
	var WeightChangeModalMulti = exports.WeightChangeModalMulti = function (_Component) {
	    _inherits(WeightChangeModalMulti, _Component);
	
	    function WeightChangeModalMulti() {
	        _classCallCheck(this, WeightChangeModalMulti);
	
	        var _this = _possibleConstructorReturn(this, (WeightChangeModalMulti.__proto__ || Object.getPrototypeOf(WeightChangeModalMulti)).call(this));
	
	        _this.initializeModal = function (array) {
	            var index = 0;
	            var formatter = [];
	            var sum = 0;
	            if (array && array.length > 0) {
	                array.map(function (r) {
	                    formatter.push({ Idx: index++, Package_Weight: r.weight, Package_Note: r.note, Tracking_Number: r.tracking });
	                    sum += Number(r.weight);
	                });
	            } else {
	                formatter.push({ Idx: 0, Package_Weight: "", Package_Note: "", Tracking_Number: "" });
	            }
	            _this.setState({
	                rows: formatter,
	                sumShippingWeight: sum,
	                selectedRows: [],
	                editedRows: []
	            });
	        };
	
	        _this.handleOnSave = function (e) {
	            e.preventDefault();
	            _this.state.rows.map(function (r) {
	                r.recreate = false;
	            });
	            _this.props.onSave(_this.state.rows);
	        };
	
	        _this.handleOnSavePrint = function (e) {
	            e.preventDefault();
	            _this.state.rows.map(function (r) {
	                r.recreate = false;
	            });
	            _this.props.onSavePrint(_this.state.rows);
	        };
	
	        _this.handleOnRecreate = function (e) {
	            e.preventDefault();
	            var selectedRows = _this.state.selectedRows;
	
	            selectedRows.map(function (r) {
	                r.recreate = true;
	            });
	            _this.props.onSavePrint(selectedRows);
	        };
	
	        _this.state = {
	            rows: [],
	            selectedRows: null,
	            editedRows: [],
	            filters: {},
	
	            sumShippingWeight: 0
	        };
	        return _this;
	    }
	
	    _createClass(WeightChangeModalMulti, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.props.fetchShippingWeightTracking(this.props.salesOrderId).then(function (response) {
	                if (response.data) {
	                    _this2.initializeModal(response.data.weights);
	                }
	            }, function (err) {
	                if (err.status === 500 || err.status === 404) {
	                    alert("Server error, please refresh page. If problem persists, contact administrator.");
	                }
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            var rows = Selectors.getRows(this.state);
	            var index = rows.length;
	            var newRow = { Package_Weight: null, Package_Note: null, Tracking_Number: null, Idx: index };
	            rows.push(newRow);
	            var editedRows = [].concat(_toConsumableArray(this.state.editedRows));
	            editedRows.push(newRow);
	            this.setState({ rows: rows, editedRows: editedRows });
	        }
	    }, {
	        key: 'deleteCategory',
	        value: function deleteCategory(e) {
	            e.preventDefault();
	            var rows = [].concat(_toConsumableArray(this.state.rows));
	            var editedRows = [].concat(_toConsumableArray(this.state.editedRows));
	            var index = _.findIndex(rows, { Idx: this.state.selectedRows[0].Idx });
	            rows.splice(index, 1);
	            index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx });
	            editedRows.splice(index, 1);
	            this.setState({ rows: rows, editedRows: editedRows, selectedRows: [] });
	        }
	    }, {
	        key: 'renderWeightChangeTable',
	        value: function renderWeightChangeTable() {
	            var _this3 = this;
	
	            var getRows = function getRows() {
	                return Selectors.getRows(_this3.state);
	            };
	            var getSize = function getSize() {
	                return getRows().length;
	            };
	            var rowGetter = function rowGetter(rowIdx) {
	                var rows = getRows();
	                return rows[rowIdx];
	            };
	            var handleRowUpdated = function handleRowUpdated(e) {
	                _this3.setState({ sortColumn: null, sortDirection: null });
	                var rows = getRows();
	                var sumShippingWeight = 0;
	                var editedRows = _this3.state.editedRows.slice(0);
	                Object.assign(rows[e.rowIdx], e.updated);
	                editedRows.forEach(function (element, index) {
	                    if (element.Idx === rows[e.rowIdx].Idx) editedRows.splice(index, 1);
	                }, _this3);
	                editedRows.push(rows[e.rowIdx]);
	                rows.map(function (r) {
	                    if (isFinite(r.Package_Weight)) {
	                        sumShippingWeight += Number(r.Package_Weight);
	                    }
	                });
	                _this3.setState({
	                    rows: rows,
	                    editedRows: editedRows,
	                    sumShippingWeight: sumShippingWeight
	                });
	            };
	            // const onRowsSelected = (rows) => {
	            //     let newRows = getRows();
	            //     newRows.map(r => {
	            //         r.isSelected = false;
	            //     })
	            //     rows.map(r => {
	            //         newRows[r.rowIdx].isSelected = true;
	            //     });
	            //     this.setState({ rows: newRows, selectedRows: [rows[0].row] });
	            // }
	            var onRowsSelected = function onRowsSelected(rows) {
	                var newRows = getRows();
	                var selectedRows = [].concat(_toConsumableArray(_this3.state.selectedRows));
	                rows.map(function (r) {
	                    newRows[r.rowIdx].isSelected = true;
	                    selectedRows.push(r.row);
	                });
	                _this3.setState({ rows: newRows, selectedRows: selectedRows });
	            };
	            // const onRowsDeselected = (rows) => {
	            //     let newRows = getRows();
	            //     rows.map(r => {
	            //         newRows[r.rowIdx].isSelected = false;
	            //     });
	            //     this.setState({ rows: newRows, selectedRows: [] });
	            // }
	            var onRowsDeselected = function onRowsDeselected(rows) {
	                var newRows = [].concat(_toConsumableArray(_this3.state.rows));
	                var selectedRows = [].concat(_toConsumableArray(_this3.state.selectedRows));
	                rows.map(function (r) {
	                    newRows[r.rowIdx].isSelected = false;
	                    var rowIndex = selectedRows.indexOf(r.row);
	                    selectedRows.splice(rowIndex, 1);
	                });
	                _this3.setState({ rows: newRows, selectedRows: selectedRows });
	            };
	
	            var columns = [{
	                key: 'Package_Weight',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight_lbs' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                editable: true,
	                width: 100
	            }, {
	                key: 'Package_Note',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                editable: true,
	                width: 250
	            }, {
	                key: 'Tracking_Number',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tracking_num' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 150
	            }];
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { style: { maxWidth: '550px', marginLeft: '25px' } },
	                        _react2.default.createElement(_reactDataGrid2.default
	                        // rowKey="Idx"
	                        , { enableCellSelect: true,
	                            columns: columns,
	                            rowGetter: rowGetter,
	                            rowsCount: getSize(),
	                            minHeight: 150,
	                            rowHeight: 25,
	                            headerRowHeight: 45,
	                            enableRowSelect: 'single',
	                            onRowUpdated: handleRowUpdated,
	                            rowSelection: {
	                                showCheckbox: true,
	                                onRowsSelected: onRowsSelected,
	                                onRowsDeselected: onRowsDeselected,
	                                selectBy: {
	                                    isSelectedKey: 'isSelected'
	                                }
	                            }
	                        })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var finalShippingWeight = this.props.finalShippingWeight;
	            var sumShippingWeight = this.state.sumShippingWeight;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    { style: { marginLeft: '5px', marginBottom: '7px' } },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'primary',
	                            onClick: function onClick(event) {
	                                _this4.clickNew(event);
	                            }
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            style: { marginRight: '5px' },
	                            bsStyle: 'danger',
	                            onClick: function onClick(event) {
	                                _this4.deleteCategory(event);
	                            },
	                            disabled: !this.state.selectedRows || this.state.selectedRows.length != 1
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-trash marginRightStyle' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: 'text-center' },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            this.renderWeightChangeTable()
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { style: { marginLeft: '5px', marginTop: '5px' } },
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4 },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_shipping_weight_lbs' }),
	                            ':'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { style: { marginLeft: '5px' } },
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4 },
	                        _react2.default.createElement(_reactBootstrap.Input, {
	                            type: 'number'
	                            // value={finalShippingWeight}
	                            , value: sumShippingWeight,
	                            onChange: this.props.onChange,
	                            disabled: true
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'centerStyle', style: { marginTop: '0px' } },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            style: { marginRight: '5px' },
	                            bsStyle: 'primary',
	                            onClick: function onClick(e) {
	                                _this4.handleOnSave(e);
	                            }
	                        },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            style: { marginRight: '5px' },
	                            bsStyle: 'success',
	                            onClick: function onClick(e) {
	                                _this4.handleOnSavePrint(e);
	                            }
	                        },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save_and_print' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'success',
	                            onClick: function onClick(e) {
	                                _this4.handleOnRecreate(e);
	                            },
	                            disabled: !this.state.selectedRows || this.state.selectedRows.length < 1
	                        },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'recreate' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return WeightChangeModalMulti;
	}(_react.Component);
	
	var _default = WeightChangeModalMulti;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(WeightChangeModalMulti, 'WeightChangeModalMulti', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/weightChangeModalMulti.jsx');
	
	    __REACT_HOT_LOADER__.register(Selectors, 'Selectors', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/weightChangeModalMulti.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/weightChangeModalMulti.jsx');
	}();

	;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.WIZPODModal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Selectors = _reactDataGridAddons.Data.Selectors;
	
	var WIZPODModal = exports.WIZPODModal = function (_Component) {
	    _inherits(WIZPODModal, _Component);
	
	    function WIZPODModal() {
	        _classCallCheck(this, WIZPODModal);
	
	        var _this = _possibleConstructorReturn(this, (WIZPODModal.__proto__ || Object.getPrototypeOf(WIZPODModal)).call(this));
	
	        _this.handleOnSave = function (e) {
	            e.preventDefault();
	            _this.state.rows.map(function (r) {
	                // r.recreate = false;
	            });
	            if (_this.state.selectedRows.length < 1) {
	                alert("At least one product is required.");
	                return;
	            }
	            var tempArray = [];
	            var tempString = "";
	            if (_this.state.selectedRows && _this.state.selectedRows.length > 0) {
	                _this.state.selectedRows.map(function (r) {
	                    tempArray.push(r.SalesOrderLine_id);
	                });
	                tempString = tempArray.join(',');
	            }
	            _this.props.printSalesOrderLabelDSQ(tempString);
	            // this.props.updateFJAgents(this.props.fjCustomerId, this.state.rows).then((response) => {
	            //     // alert(JSON.stringify(response.data));
	            //     alert("Agents Saved");
	            //     this.props.closeAgentModal();
	            //   }, (err) => {
	            //     if (err.status === 500 || err.status === 404) {
	            //       alert(JSON.stringify(err.data));
	            //     }
	            //   });
	            // this.props.onSave(this.state.rows);
	        };
	
	        _this.state = {
	            rows: [],
	            selectedRows: null,
	            editedRows: [],
	            filters: {},
	            sortColumn: null,
	            sortDirection: null,
	
	            details: {
	                rows: [],
	                selectedRows: null,
	                editedRows: [],
	                filters: {}
	            }
	        };
	        return _this;
	    }
	
	    _createClass(WIZPODModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // this.props.fetchFJAgents(this.props.fjCustomerId).then((response) => {
	            //     if (response.data) {
	            //         this.initializeModal(response.data);
	            //     }
	            // }, (err) => {
	            //     if (err.status === 500 || err.status === 404) {
	            //         alert("Server error, please refresh page. If problem persists, contact administrator.");
	            //     }
	            // });
	
	            this.wizfetchblah();
	
	            // let url = `${ROOT_URL}v2/sales/pod/${this.props.singleSalesOrderId}/`;
	            // axios({
	            //     method: 'GET',
	            //     url: url,
	            //     headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
	            // })
	            //     .then(res => {
	            //         this.setState({
	            //             rows: res.data,
	            //             selectedRows: [],
	            //             editedRows: [],
	            //         });
	            //     }, err => {
	            //     })
	        }
	    }, {
	        key: 'wizfetchblah',
	        value: function wizfetchblah() {
	            var _this2 = this;
	
	            var url = _root_url.ROOT_URL + 'v2/sales/pod/' + this.props.singleSalesOrderId + '/';
	            (0, _axios2.default)({
	                method: 'GET',
	                url: url,
	                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	            }).then(function (res) {
	                _this2.setState({
	                    rows: res.data,
	                    selectedRows: [],
	                    editedRows: []
	                });
	            }, function (err) {});
	        }
	    }, {
	        key: 'deletePOD',
	        value: function deletePOD(value) {
	            var _this3 = this;
	
	            var url = _root_url.ROOT_URL + 'v2/sales/pod/' + value + '/';
	            (0, _axios2.default)({
	                method: 'DELETE',
	                url: url,
	                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	            }).then(function (res) {
	                alert("POD Deleted.");
	                _this3.wizfetchblah();
	            }, function (err) {});
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	
	        // initializeModal = (array) => {
	        //     let index = 0;
	        //     let formatter = [];
	        //     if (array && array.length > 0) {
	        //         array.map(r => {
	        //             formatter.push({ Idx: index++, customer: r.customer, id: r.id, name: r.name, note: r.note, ref_num: r.ref_num });
	        //         })
	        //     } else {
	        //         formatter.push({ Idx: 0, name: "", note: "" });
	        //     }
	        //     this.setState({
	        //         rows: formatter,
	        //         selectedRows: [],
	        //         editedRows: [],
	        //     });
	        // }
	
	    }, {
	        key: 'deleteCategory',
	
	
	        // clickNew(e) {
	        //     e.preventDefault();
	        //     let rows = Selectors.getRows(this.state);
	        //     let index = rows.length;
	        //     let newRow = { name: null, note: null, customer: this.props.fjCustomerId, Idx: index };
	        //     rows.push(newRow);
	        //     let editedRows = [...this.state.editedRows];
	        //     editedRows.push(newRow)
	        //     this.setState({ rows, editedRows })
	        // }
	
	        value: function deleteCategory(e) {
	            e.preventDefault();
	            var rows = [].concat(_toConsumableArray(this.state.rows));
	            var editedRows = [].concat(_toConsumableArray(this.state.editedRows));
	            var index = _.findIndex(rows, { Idx: this.state.selectedRows[0].Idx });
	
	            if (this.state.selectedRows[0].id) {}
	            // this.props.deleteFJAgents(this.state.selectedRows[0].id).then((response) => {
	            //     alert("Agent Deleted");
	            //     rows.splice(index, 1);
	            //     index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
	            //     editedRows.splice(index, 1);
	            //     this.setState({ rows, editedRows, selectedRows: [] })
	            //     // this.props.fetchFJAgents(this.props.fjCustomerId).then((response) => {
	            //     //     if (response.data) {
	            //     //         this.initializeModal(response.data);
	            //     //     }
	            //     // }, (err) => {
	            //     //     if (err.status === 500 || err.status === 404) {
	            //     //         alert("Server error, please refresh page. If problem persists, contact administrator.");
	            //     //     }
	            //     // });
	            // }, (err) => {
	            //     if (err.status === 500 || err.status === 404 || err.status === 405) {
	            //         alert("Error cannot delete agent.");
	            //     }
	            // });
	
	
	            // rows.splice(index, 1);
	            // index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
	            // editedRows.splice(index, 1);
	            // this.setState({ rows, editedRows, selectedRows: [] })
	        }
	    }, {
	        key: 'renderAgentTable',
	        value: function renderAgentTable() {
	            var _this4 = this;
	
	            var getRows = function getRows() {
	                return Selectors.getRows(_this4.state);
	            };
	            var getSize = function getSize() {
	                return getRows().length;
	            };
	            var rowGetter = function rowGetter(rowIdx) {
	                var rows = getRows();
	                return rows[rowIdx];
	            };
	            var handleRowUpdated = function handleRowUpdated(e) {
	                _this4.setState({ sortColumn: null, sortDirection: null });
	                var rows = getRows();
	                var editedRows = _this4.state.editedRows.slice(0);
	                Object.assign(rows[e.rowIdx], e.updated);
	                editedRows.forEach(function (element, index) {
	                    if (element.Idx === rows[e.rowIdx].Idx) editedRows.splice(index, 1);
	                }, _this4);
	                editedRows.push(rows[e.rowIdx]);
	                _this4.setState({
	                    rows: rows,
	                    editedRows: editedRows
	                });
	            };
	            // const onRowsSelected = (rows) => {
	            //     let newRows = getRows();
	            //     newRows.map(r => {
	            //         r.isSelected = false;
	            //     })
	            //     rows.map(r => {
	            //         newRows[r.rowIdx].isSelected = true;
	            //     });
	            //     this.setState({ rows: newRows, selectedRows: [rows[0].row] });
	            // }
	            var onRowsSelected = function onRowsSelected(rows) {
	                var newRows = getRows();
	                var selectedRows = [].concat(_toConsumableArray(_this4.state.selectedRows));
	                rows.map(function (r) {
	                    newRows[r.rowIdx].isSelected = true;
	                    selectedRows.push(r.row);
	                });
	                _this4.setState({ rows: newRows, selectedRows: selectedRows });
	            };
	            // const onRowsDeselected = (rows) => {
	            //     let newRows = getRows();
	            //     rows.map(r => {
	            //         newRows[r.rowIdx].isSelected = false;
	            //     });
	            //     this.setState({ rows: newRows, selectedRows: [] });
	            // }
	            var onRowsDeselected = function onRowsDeselected(rows) {
	                var newRows = [].concat(_toConsumableArray(_this4.state.rows));
	                var selectedRows = [].concat(_toConsumableArray(_this4.state.selectedRows));
	                rows.map(function (r) {
	                    newRows[r.rowIdx].isSelected = false;
	                    var rowIndex = selectedRows.indexOf(r.row);
	                    selectedRows.splice(rowIndex, 1);
	                });
	                _this4.setState({ rows: newRows, selectedRows: selectedRows });
	            };
	
	            var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                var state = Object.assign({}, _this4.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                _this4.setState(state);
	            };
	
	            var handleFilterChange = function handleFilterChange(filter) {
	                var newFilters = Object.assign({}, _this4.state.filters);
	                if (filter.filterTerm) {
	                    newFilters[filter.column.key] = filter;
	                } else {
	                    delete newFilters[filter.column.key];
	                }
	                _this4.setState({ filters: newFilters });
	            };
	
	            var SecondsDateFormatter = _react2.default.createClass({
	                displayName: 'SecondsDateFormatter',
	                render: function render() {
	                    if (this.props.value) {
	                        var date = (0, _moment2.default)(this.props.value).format("MM-DD-YY HH:mm");
	                        return _react2.default.createElement(
	                            'span',
	                            null,
	                            date
	                        );
	                    }
	                    return _react2.default.createElement(
	                        'span',
	                        { className: 'label label-danger' },
	                        '-'
	                    );
	                }
	            });
	
	            var columns = [
	            // {
	            //   key: "ContainerNum",
	            //   name: <Translate value="container_num" />,
	            //   resizable: true,
	            //   sortable: true,
	            //   width: 100,
	            // },
	            {
	                key: "filename",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'file_name' }),
	                resizable: true,
	                sortable: true,
	                width: 180,
	                filterable: true
	            }, {
	                key: "description",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	                resizable: true,
	                sortable: true,
	                width: 180,
	                filterable: true
	            }, {
	                key: "url",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'download' }),
	                resizable: true,
	                sortable: true,
	                width: 160,
	                formatter: function formatter(_ref) {
	                    var value = _ref.value;
	                    return _react2.default.createElement(
	                        'div',
	                        {
	                            style: { width: '100%', height: '100%' }
	                            //   onClick={() => {
	                            //    console.log("1");
	                            //   }}
	                        },
	                        _react2.default.createElement(
	                            'a',
	                            { href: value },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'download' })
	                        )
	                    );
	                }
	            }, {
	                key: "id",
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete_double' }),
	                resizable: true,
	                sortable: true,
	                width: 130,
	                formatter: function formatter(_ref2) {
	                    var value = _ref2.value;
	                    return _react2.default.createElement(
	                        'div',
	                        {
	                            style: { width: '100%', height: '100%' }
	                            // onClick={() => {
	                            //  this.deletePOD(value);
	                            // }}
	                        },
	                        _react2.default.createElement(
	                            'p',
	                            { style: { color: 'red', margin: '0px', cursor: 'pointer' }, onDoubleClick: function onDoubleClick() {
	                                    _this4.deletePOD(value);
	                                } },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                        )
	                    );
	                }
	            }];
	
	            var onRowClick = function onRowClick(rowIdx, row) {
	                if (rowIdx !== -1) {
	                    var rows = getRows();
	                    rows.map(function (r) {
	                        r.isSelected = false;
	                    });
	                    var selectedRows = [rows[rowIdx]];
	                    rows[rowIdx].isSelected = true;
	                    //   const salesOrders = { ...this.state.salesOrders, rows, selectedRows };
	                    //   this.setState({ salesOrders });
	                    //   this.props.fetchSalesOrderDetail(row.SalesOrder_id, route);
	                    var temp = {
	                        rows: [],
	                        selectedRows: null,
	                        editedRows: [],
	                        filters: {}
	                    };
	                    if (selectedRows && selectedRows[0]) {
	                        temp.rows = selectedRows[0].lines;
	                        _this4.setState({ details: temp });
	                    }
	                }
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_reactDataGrid2.default
	                        // rowKey="Idx"
	                        // enableCellSelect={true}
	
	                        // rowKey="Idx"
	                        , { onGridSort: handleGridSort,
	                            onAddFilter: handleFilterChange,
	                            columns: columns,
	                            rowGetter: rowGetter,
	                            rowsCount: getSize(),
	                            minHeight: 350,
	                            rowHeight: 25,
	                            headerRowHeight: 45,
	                            toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true })
	                            // enableRowSelect='single'
	                            , onRowUpdated: handleRowUpdated
	                            // rowSelection={{
	                            //     showCheckbox: true,
	                            //     onRowsSelected,
	                            //     onRowsDeselected,
	                            //     selectBy: {
	                            //         isSelectedKey: 'isSelected'
	                            //     }
	                            // }}
	                            // onRowClick={onRowClick}
	                        })
	                    )
	                )
	            );
	        }
	
	        ////////////
	        ////////////////////////////////////////////////////////////////////////
	        ////////////
	
	    }, {
	        key: 'renderDetailTable',
	        value: function renderDetailTable() {
	            var _this5 = this;
	
	            var getRows = function getRows() {
	                return Selectors.getRows(_this5.state.details);
	            };
	            var getSize = function getSize() {
	                return getRows().length;
	            };
	            var rowGetter = function rowGetter(rowIdx) {
	                var rows = getRows();
	                return rows[rowIdx];
	            };
	
	            var columns = [{
	                key: 'sku',
	                name: 'SKU',
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 150
	            }, {
	                key: 'fba',
	                name: 'FBA',
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 120
	            },
	            // {
	            //     key: 'prod_name',
	            //     name: <Translate value="product_name" />,
	            //     resizable: true,
	            //     sortable: true,
	            //     filterable: true,
	            //     width: 200,
	            // },
	            {
	                key: 'quantity',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 100
	            }, {
	                key: 'note',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 250
	            }];
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_reactDataGrid2.default, { enableCellSelect: true,
	                            columns: columns,
	                            rowGetter: rowGetter,
	                            rowsCount: getSize(),
	                            minHeight: 140,
	                            rowHeight: 25,
	                            headerRowHeight: 45
	                            // enableRowSelect='single'
	                            // rowSelection={{
	                            //     showCheckbox: true,
	                            //     onRowsSelected,
	                            //     onRowsDeselected,
	                            //     selectBy: {
	                            //         isSelectedKey: 'isSelected'
	                            //     }
	                            // }}
	                        })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            _objectDestructuringEmpty(this.props);
	
	            _objectDestructuringEmpty(this.state);
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: 'text-center' },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { padding: '0px 25px' } },
	                            this.renderAgentTable()
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'centerStyle', style: { marginTop: '15px' } },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            style: { marginRight: '5px' },
	                            bsStyle: 'success',
	                            onClick: function onClick() {
	                                _this6.refs.msoCreateInputRef4.click();
	                            }
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-print' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'upload_pod' })
	                    ),
	                    _react2.default.createElement('input', {
	                        type: 'file',
	                        style: { display: "none" },
	                        onClick: function onClick(e) {
	                            e.target.value = null;
	                        },
	                        onChange: function onChange(e) {
	                            var wURL = _root_url.ROOT_URL + 'v2/sales/pod/' + _this6.props.singleSalesOrderId + '/';
	                            var formData = new FormData();
	                            formData.append("FILE", e.target.files[0]);
	                            if (e.target.files[0]) {
	                                _axios2.default.post(wURL, formData, {
	                                    headers: {
	                                        Authorization: 'Bearer ' + localStorage.getItem("token")
	                                    }
	                                }).then(function (res) {
	                                    alert("POD uploaded successfully");
	                                    _this6.wizfetchblah();
	                                    // this.fetchSalesOrdersByDetails(
	                                    //   this.state.days
	                                    // );
	                                }, function (err) {
	                                    if (err.data) {
	                                        alert(err.data);
	                                    } else {
	                                        alert("Server issue detected, please contact admin.");
	                                    }
	                                });
	                            }
	                        },
	                        ref: 'msoCreateInputRef4'
	                    })
	                )
	            );
	        }
	    }]);
	
	    return WIZPODModal;
	}(_react.Component);
	
	var _default = WIZPODModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(WIZPODModal, 'WIZPODModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/wizPODModal.jsx');
	
	    __REACT_HOT_LOADER__.register(Selectors, 'Selectors', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/wizPODModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Common/wizPODModal.jsx');
	}();

	;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(13);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactTooltip = __webpack_require__(105);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _inputField = __webpack_require__(16);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	var _priceLevel = __webpack_require__(314);
	
	var _priceLevel2 = _interopRequireDefault(_priceLevel);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _selection = __webpack_require__(21);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _root_url = __webpack_require__(9);
	
	var _agentChangeModal = __webpack_require__(263);
	
	var _priceTableModal = __webpack_require__(159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var isHMM = _root_url.ROOT_API_URL === 'https://hmm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://hmm-scm.truckxi.com/api/';
	var isAFG = _root_url.ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afg-scm.truckxi.com/api/';
	var isCO = _root_url.ROOT_API_URL === 'https://co-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://co-scm.truckxi.com/api/';
	var isFJ = _root_url.ROOT_API_URL === 'https://fj-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://fj-scm.truckxi.com/api/';
	var isMAG = _root_url.ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://magna-scm.truckxi.com/api/';
	var isWIZ = _root_url.ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
	var isTQ = _root_url.ROOT_API_URL === 'https://topquality-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://topquality-scm.truckxi.com/api/';
	var isOCM = _root_url.ROOT_API_URL === 'https://ocm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ocm-scm.truckxi.com/api/';
	var isKDW = _root_url.ROOT_API_URL === 'https://kdw-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://kdw-scm.truckxi.com/api/';
	var isYI = _root_url.ROOT_API_URL === 'https://ying-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ying-scm.truckxi.com/api/';
	var isAPO = _root_url.ROOT_API_URL === 'https://admin.apoodr.com/api/' || _root_url.ROOT_URL === 'https://admin.apoodr.com/api/';
	
	var renderEmails = function renderEmails(props) {
	  var fields = props.fields;
	
	  return _react2.default.createElement(
	    _reactBootstrap.Row,
	    null,
	    _react2.default.createElement(
	      _reactBootstrap.Col,
	      { xs: 12, className: 'add-bin-range-section' },
	      _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'primary',
	              type: 'button',
	              onClick: function onClick() {
	                fields.push({}); // pushes empty child field onto the end of the array
	              }
	            },
	            _react2.default.createElement('em', { className: 'fa fa-plus' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          fields.map(function (email, index) {
	            return _react2.default.createElement(
	              _reactBootstrap.Row,
	              { key: index, className: 'additional-bin-range' },
	              _react2.default.createElement(
	                'div',
	                { className: 'customer-email-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'customer-email-row-title', style: { paddingLeft: '8px' } },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' }),
	                    ' #',
	                    index + 1
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'customer-email-row-fields' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'customer-email-row-fields-input' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_reduxForm.Field, { name: email + '.email', component: _inputField.InputField, placeholder: 'Email' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'customer-email-row-fields-checkbox-section' },
	                    _react2.default.createElement(
	                      _reactTooltip2.default,
	                      { id: 'bypass-checkbox', place: 'top', type: 'dark', effect: 'solid' },
	                      _reactReduxI18n.I18n.t('tooltip_customer_bypass_payment')
	                    ),
	                    _react2.default.createElement(
	                      _reactTooltip2.default,
	                      { id: 'showall-checkbox', place: 'top', type: 'dark', effect: 'solid' },
	                      _reactReduxI18n.I18n.t('tooltip_customer_manager')
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'customer-email-row-fields-checkbox' },
	                      _react2.default.createElement(_reduxForm.Field, {
	                        name: email + '.BypassPayment',
	                        component: 'input',
	                        type: 'checkbox'
	                      }),
	                      _react2.default.createElement(
	                        'span',
	                        { 'data-tip': true, 'data-for': 'bypass-checkbox' },
	                        _reactReduxI18n.I18n.t('bypass')
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'customer-email-row-fields-checkbox' },
	                      _react2.default.createElement(_reduxForm.Field, {
	                        name: email + '.IsManager',
	                        component: 'input',
	                        type: 'checkbox'
	                      }),
	                      _react2.default.createElement(
	                        'span',
	                        { 'data-tip': true, 'data-for': 'showall-checkbox' },
	                        _reactReduxI18n.I18n.t('manager')
	                      )
	                    )
	                  )
	                )
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	var renderIsDefault = function renderIsDefault(props) {
	  // Bad implementation, cannot set the value attribute of Input componnet to a boolean.
	  var titleClass = (0, _classnames2.default)({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'control-label');
	  return _react2.default.createElement(
	    'div',
	    { className: 'boolean-field' },
	    props.meta.touched && props.meta.error && _react2.default.createElement(
	      'span',
	      { className: 'parsley-error-message' },
	      props.meta.error
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: titleClass },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'default_address' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'boolean' },
	      _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { type: 'radio', value: true, checked: props.input.value === true || props.input.value === 'true' })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'boolean' },
	      _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { type: 'radio', value: false, checked: props.input.value === false || props.input.value === 'false' })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	    )
	  );
	};
	
	var renderAfterAddonField = function renderAfterAddonField(props) {
	  var _extends2;
	
	  return _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, (_extends2 = { standalone: true, type: 'text' }, _defineProperty(_extends2, 'standalone', true), _defineProperty(_extends2, 'addonAfter', '.00'), _defineProperty(_extends2, 'style', { zIndex: 0 }), _extends2)));
	};
	
	var renderRadios = function renderRadios(props) {
	  var titleClass = (0, _classnames2.default)({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'control-label');
	  return _react2.default.createElement(
	    'div',
	    { className: 'boolean-field' },
	    props.meta.touched && props.meta.error && _react2.default.createElement(
	      'span',
	      { className: 'parsley-error-message' },
	      props.meta.error
	    ),
	    props.error && console.log(props.input.name + ' ' + props.error),
	    props.input.name === 'IsWholesale' && _react2.default.createElement(
	      'label',
	      { className: titleClass },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'wholesale' })
	    ),
	    props.input.name === 'IsShowPrice' && _react2.default.createElement(
	      'label',
	      { className: titleClass },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'show_price' })
	    ),
	    props.input.name === 'IsShippingFee' && _react2.default.createElement(
	      'label',
	      { className: titleClass },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_fee' })
	    ),
	    props.input.name === 'IsActive' && _react2.default.createElement(
	      'label',
	      { className: titleClass },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'active' }),
	      ' ',
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer' })
	    ),
	    props.input.name === 'IsPrtReminder' && _react2.default.createElement(
	      'label',
	      { className: titleClass },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_reminder' })
	    ),
	    props.input.name === 'IsPrtGeneralInfor' && _react2.default.createElement(
	      'label',
	      { className: titleClass },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_general_information' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'boolean' },
	      _react2.default.createElement(
	        'label',
	        null,
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { type: 'radio', value: 'true', checked: props.input.value === true || props.input.value === 'true' })),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'boolean' },
	      _react2.default.createElement(
	        'label',
	        null,
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { type: 'radio', value: 'false', checked: props.input.value === false || props.input.value === 'false' })),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	      )
	    )
	  );
	};
	
	// Helping function to render a multi-fields form. Reference on redux-form array.
	
	var renderShipping = function (_Component) {
	  _inherits(renderShipping, _Component);
	
	  function renderShipping() {
	    _classCallCheck(this, renderShipping);
	
	    var _this = _possibleConstructorReturn(this, (renderShipping.__proto__ || Object.getPrototypeOf(renderShipping)).call(this));
	
	    _this.state = {
	      confirmOpen: false,
	      agentModalOpen: false,
	      ptModalOpen: false,
	      drayageOptions: [],
	      drayageLala: false
	    };
	    return _this;
	  }
	
	  _createClass(renderShipping, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var drayageOptions = this.state.drayageOptions;
	
	      var tempName = '';
	      _axios2.default.get(_root_url.ROOT_URL + 'v1/product/search/?ProductCategory1_id=3', {
	        headers: {
	          Authorization: 'Bearer ' + localStorage.getItem("token")
	        }
	      }).then(function (res) {
	        res.data.map(function (r) {
	          // tempName = r.Name.replace('CLIENT DRAYAGE ', '');
	          tempName = r.Name;
	          drayageOptions.push({ label: tempName, value: r.RefNum });
	        });
	        _this2.setState({ drayageOptions: drayageOptions });
	      }, function (err) {
	        if (err.data) {
	          alert(err.data);
	        } else {
	          alert("Server issue detected, please contact admin.");
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      var _state = this.state,
	          drayageOptions = _state.drayageOptions,
	          drayageLala = _state.drayageLala;
	
	      if (!drayageLala) {
	        this.setState({ drayageOptions: [] });
	        setTimeout(function () {
	          _this3.setState({ drayageOptions: drayageOptions, drayageLala: true });
	        }, 800);
	      }
	    }
	  }, {
	    key: 'copyBillingToShipping',
	    value: function copyBillingToShipping(e) {
	      e.preventDefault();
	      var shippingInfo = _extends({}, this.props.billing, { Type: 'Shipping' });
	      var shipping = this.props.shipping;
	
	      if (shipping && shipping.length > 0 && shipping[0]) {
	        shippingInfo.CustomerDetail_id = shipping[0].CustomerDetail_id;
	      } else {
	        delete shippingInfo.CustomerDetail_id;
	      }
	      this.props.changeFieldArrayOfForm('Shipping', 0, shippingInfo, 'customerForm');
	    }
	  }, {
	    key: 'renderDeleteButton',
	    value: function renderDeleteButton(index, fields) {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'danger',
	          className: 'trash',
	          type: 'reset',
	          onClick: function onClick() {
	            fields.remove(index);
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-trash-o' })
	      );
	    }
	  }, {
	    key: 'renderAutoFillButton',
	    value: function renderAutoFillButton() {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'default',
	          className: 'auto-fill',
	          type: 'button',
	          onClick: this.copyBillingToShipping.bind(this)
	        },
	        _react2.default.createElement('em', { className: 'fa fa-edit' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'auto_fill' })
	      );
	    }
	  }, {
	    key: 'renderAddress',
	    value: function renderAddress(Shipping, index) {
	      var drayageOptions = this.state.drayageOptions;
	      // const drayageOptions = [
	      //   {label: "LOS ANGELES", value: "LOS ANGELES"},
	      //   {label: "CITY OF INDUSTRY", value: "CITY OF INDUSTRY"},
	      //   {label: "SANTA FE SPRING", value: "SANTA FE SPRING"},
	      //   {label: "PICO RIVERA", value: "PICO RIVERA"},
	      //   {label: "WALNUT", value: "WALNUT"},
	      //   {label: "DOSS-POMONA", value: "DOSS-POMONA"},
	      //   {label: "POMONA", value: "POMONA"},
	      //   {label: "MONTCLAIR", value: "MONTCLAIR"},
	      //   {label: "CHINO", value: "CHINO"},
	      //   {label: "CHINO HILLS", value: "CHINO HILLS"},
	      //   {label: "EASTVALE", value: "EASTVALE"},
	      //   {label: "ONTARIO-1", value: "ONTARIO-1"},
	      //   {label: "ONTARIO-2", value: "ONTARIO-2"},
	      //   {label: "FONTANA-1", value: "FONTANA-1"},
	      //   {label: "FONTANA-2", value: "FONTANA-2"},
	      //   {label: "RANCHO CUCAMANGO", value: "RANCHO CUCAMANGO"},
	      //   {label: "RIVERSIDE", value: "RIVERSIDE"},
	      //   {label: "SAN BERNARDINO", value: "SAN BERNARDINO"},
	      //   {label: "AMAZON-ONT8", value: "AMAZON-ONT8"},
	      //   {label: "AMAZON-LAX9", value: "AMAZON-LAX9"},
	      //   {label: "AMAZON-LGB8", value: "AMAZON-LGB8"},
	      //   {label: "ROCHA", value: "ROCHA"},
	      //   {label: "IDC-WALNUT", value: "IDC-WALNUT"},
	      //   {label: "IDC-BUENA PARK", value: "IDC-BUENA PARK"},
	      //   {label: "IDC-LYWOOD", value: "IDC-LYWOOD"},
	      //   {label: "SIGNIFY", value: "SIGNIFY"},
	      //   {label: "HUBBELL", value: "HUBBELL"},
	      //   {label: "TIRECO", value: "TIRECO"},
	      //   {label: "UNISCO", value: "UNISCO"},
	      //   {label: "GE LIGHTLING", value: "GE LIGHTLING"},
	      //   {label: "FNS-FONTANA", value: "FNS-FONTANA"},
	      //   {label: "FNS-SAN BERNARDINO", value: "FNS-SAN BERNARDINO"},
	      //   {label: "KOHLER", value: "KOHLER"},
	      //   {label: "CIC", value: "CIC"},      
	      // ];
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'form-horizontal' },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-2' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 10 },
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.AddressName', component: _inputField.InputField })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'form-horizontal' },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-2' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'street' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'asteriksReq' },
	                '*'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 10 },
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.Street', component: _inputField.InputField })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'asteriksReq' },
	                  '*'
	                )
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.City', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'state' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'asteriksReq' },
	                  '*'
	                )
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.State', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zip' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'asteriksReq' },
	                  '*'
	                )
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.Zip', component: _inputField.InputField })
	            )
	          )
	        ),
	        isMAG && _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'drayage_code' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.DrayageCode', matchPos: 'any', component: _selection.Selection, options: drayageOptions })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'first_name' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.FirstName', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_name' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.LastName', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.Email', component: _inputField.InputField })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tel' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.Telephone', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'alt_phone' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.Cellphone', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fax' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.Fax', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, {
	                name: Shipping + '.Note',
	                maxLength: 150,
	                component: 'Textarea',
	                className: 'form-control',
	                style: { minHeight: '40px' }
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var fields = this.props.fields;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            className: 'plus',
	            type: 'button',
	            onClick: function onClick() {
	              fields.push({});
	            } // pushes empty child field onto the end of the array
	          },
	          _react2.default.createElement('em', { className: 'fa fa-plus' })
	        ),
	        !fields.length && _react2.default.createElement(
	          'div',
	          { className: 'marginTopStyle' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no_shipping_information' })
	        ),
	        fields.map(function (Shipping, index) {
	          return _react2.default.createElement(
	            _reactBootstrap.Row,
	            { key: index },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 12 },
	              _react2.default.createElement(
	                'div',
	                { className: 'position-relative' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_poundsign' }),
	                  index + 1
	                ),
	                index === 0 && _this4.renderAutoFillButton(),
	                _this4.renderDeleteButton(index, fields)
	              ),
	              _this4.renderAddress(Shipping, index),
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.IsDefault', component: renderIsDefault })
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return renderShipping;
	}(_react.Component);
	
	var CustomerForm = function (_Component2) {
	  _inherits(CustomerForm, _Component2);
	
	  function CustomerForm() {
	    _classCallCheck(this, CustomerForm);
	
	    var _this5 = _possibleConstructorReturn(this, (CustomerForm.__proto__ || Object.getPrototypeOf(CustomerForm)).call(this));
	
	    _this5.setCustomer = function (e) {
	      var rows = _this5.state.rows;
	
	      var duplicate = false;
	      for (var i = 0; i < rows.length; i++) {
	        if (e && e.value && rows[i].customer_id === e.value) {
	          duplicate = true;
	          return;
	        }
	      }
	      if (e && e.value && duplicate === false) {
	        rows.push({ customer_id: e.value, customer_name: e.label, customer_num: e.customer_num });
	      }
	      _this5.setState({ rows: rows });
	    };
	
	    _this5.state = {
	      dirty: false,
	      case: 'paymentTermMissing',
	      businessType: 'Restaurant',
	      creditStatus: 'Good',
	      IsStripe: false,
	      customerOptions: [],
	      rows: [],
	      filters: {},
	      Sub_Customer_id: "",
	      fjCustomerId: "",
	      customerCredit: 0,
	      customerCreditModal: null,
	      customerCreditNote: null
	    };
	    _this5.openConfirm = _this5.openConfirm.bind(_this5);
	    _this5.closeConfirm = _this5.closeConfirm.bind(_this5);
	    _this5.openCredit = _this5.openCredit.bind(_this5);
	    _this5.closeCredit = _this5.closeCredit.bind(_this5);
	    _this5.openAgentModal = _this5.openAgentModal.bind(_this5);
	    _this5.closeAgentModal = _this5.closeAgentModal.bind(_this5);
	    _this5.openPTModal = _this5.openPTModal.bind(_this5);
	    _this5.closePTModal = _this5.closePTModal.bind(_this5);
	    return _this5;
	  }
	
	  _createClass(CustomerForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      (0, _reduxForm.reset)('customerForm');
	    }
	
	    // Deal with the preload of data.
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this6 = this;
	
	      this.props.fetchCustomers().then(function () {
	        _this6.getCustomerOptions();
	      });
	      var currentCustomer = this.props.currentCustomer;
	
	      if (currentCustomer) {
	        this.setState({ fjCustomerId: currentCustomer.Customer_id });
	        this.props.fetchCustomerDetail(currentCustomer.Customer_id).then(function () {
	          return _this6.props.fetchPaymentTerms();
	        });
	      } else {
	        this.props.fetchPaymentTerms();
	        if (_root_url.isEcity) {
	          this.props.setDefaultOfForm('PriceLevel', '3', 'customerForm');
	        } else {
	          this.props.setDefaultOfForm('PriceLevel', '5', 'customerForm');
	        }
	        this.props.setDefaultOfForm('IsWholesale', 'false', 'customerForm');
	        this.props.setDefaultOfForm('IsShowPrice', 'true', 'customerForm');
	        this.props.setDefaultOfForm('IsShippingFee', 'true', 'customerForm');
	        this.props.setDefaultOfForm('IsActive', 'true', 'customerForm');
	        this.props.setDefaultOfForm('IsPrtReminder', 'false', 'customerForm');
	        this.props.setDefaultOfForm('IsPrtGeneralInfor', 'false', 'customerForm');
	      }
	      this.props.fetchDefaultBuyers();
	
	      if (isYI && currentCustomer) {
	        _axios2.default.get(_root_url.ROOT_URL + 'v1/customer/credit/balance/' + currentCustomer.Customer_id, {
	          headers: {
	            Authorization: 'Bearer ' + localStorage.getItem("token")
	          }
	        }).then(function (res) {
	          if (res && res.data.record) {
	            if (res.data.record.length === 0) {
	              _this6.setState({ customerCredit: 0 });
	            } else {
	              _this6.setState({ customerCredit: res.data.record[0].total_balance });
	            }
	          }
	          // this.setState({customerCredit: res.data});
	        }, function (err) {
	          // if (err.data) {
	          //   alert(err.data);
	          // } else {
	          // alert("Server issue detected, please contact admin. Could not fetch Credits.");
	          // }
	        });
	      }
	
	      // making a leaving hook to confirm leaving
	      this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.dirty !== this.props.dirty) {
	        this.setState({
	          dirty: nextProps.dirty
	        });
	      }
	      // if((nextProps.isActive === true || nextProps.isActive === "true") && nextProps.isActive != this.props.isActive) {
	      //   if(!this.props.paymentTerm_id && !nextProps.paymentTerm_id) {
	      //     this.props.setDefaultOfForm('IsActive', "false", 'customerForm');
	      //     this.openConfirm();
	      //   }
	      // }
	      if (nextProps.paymentTerm_id != this.props.paymentTerm_id) {
	        if (!nextProps.paymentTerm_id || nextProps.paymentTerm_id.length === 0) {
	          if (_root_url.isSY) {
	            this.props.setDefaultOfForm('IsShippingFee', 'true', 'customerForm');
	          }
	          this.props.setDefaultOfForm('IsActive', 'true', 'customerForm');
	          this.props.setDefaultOfForm('PaymentTerm_id', null, 'customerForm');
	          this.openConfirm();
	        }
	      }
	      if (nextProps.currentCustomerDetail && nextProps.currentCustomerDetail !== this.props.currentCustomerDetail) {
	        var _nextProps$currentCus = nextProps.currentCustomerDetail,
	            BusinessType = _nextProps$currentCus.BusinessType,
	            CreditStatus = _nextProps$currentCus.CreditStatus,
	            IsStripe = _nextProps$currentCus.IsStripe;
	
	        if (BusinessType) {
	          this.setState({ businessType: BusinessType });
	        }
	        if (CreditStatus) {
	          this.setState({ creditStatus: CreditStatus });
	        }
	        if (IsStripe) {
	          this.setState({ IsStripe: true });
	        } else {
	          this.setState({ IsStripe: false });
	        }
	      }
	      if (nextProps.currentCustomerDetail && nextProps.currentCustomerDetail !== this.props.currentCustomerDetail && nextProps.currentCustomerDetail.Sub_Customer_id) {
	        this.formatCustomerInput(nextProps.currentCustomerDetail.Sub_Customer_id);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      (0, _reduxForm.reset)('customerForm');
	    }
	  }, {
	    key: 'routerWillLeave',
	    value: function routerWillLeave(nextLocation) {
	      if (this.state.dirty) return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'work_not_saved_warning' });
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      this.formatCustomerOutput();
	      this.setState({ dirty: false });
	      this.checkPermission('change_customer');
	      if (!this.props.currentCustomer) {
	        this.props.createCustomer(formProps, this.state);
	      } else {
	        if (!this.checkPermission("change_customer")) {
	          this.props.editCustomer(formProps, this.state);
	        } else {
	          alert("You have no permission!");
	        }
	      }
	    }
	  }, {
	    key: 'openConfirm',
	    value: function openConfirm() {
	      this.setState({ confirmOpen: true });
	    }
	  }, {
	    key: 'closeConfirm',
	    value: function closeConfirm() {
	      this.setState({ confirmOpen: false });
	    }
	  }, {
	    key: 'openCredit',
	    value: function openCredit() {
	      var customerCredit = this.state.customerCredit;
	
	      this.setState({ creditOpen: true, customerCreditModal: 0, customerCreditNote: null });
	    }
	  }, {
	    key: 'closeCredit',
	    value: function closeCredit() {
	      this.setState({ creditOpen: false });
	    }
	  }, {
	    key: 'onCreditChange',
	    value: function onCreditChange(e) {
	      this.setState({ customerCreditModal: e.target.value });
	    }
	  }, {
	    key: 'onCreditNoteChange',
	    value: function onCreditNoteChange(e) {
	      this.setState({ customerCreditNote: e.target.value });
	    }
	  }, {
	    key: 'saveCredit',
	    value: function saveCredit() {
	      var _this7 = this;
	
	      var _state2 = this.state,
	          customerCreditModal = _state2.customerCreditModal,
	          customerCreditNote = _state2.customerCreditNote,
	          customerCredit = _state2.customerCredit;
	      var currentCustomer = this.props.currentCustomer;
	
	
	      var data = {
	        amount: customerCreditModal,
	        note: customerCreditNote
	      };
	      _axios2.default.put(_root_url.ROOT_URL + 'v1/customer/credit/balance/' + currentCustomer.Customer_id, data, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        alert("Customer Credit Changed");
	        _this7.setState({ customerCredit: Number(customerCredit) + Number(customerCreditModal), creditOpen: false });
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	      });
	    }
	  }, {
	    key: 'openAgentModal',
	    value: function openAgentModal() {
	      this.setState({ agentModalOpen: true });
	    }
	  }, {
	    key: 'closeAgentModal',
	    value: function closeAgentModal() {
	      this.setState({ agentModalOpen: false });
	    }
	  }, {
	    key: 'openPTModal',
	    value: function openPTModal() {
	      this.setState({ ptModalOpen: true });
	    }
	  }, {
	    key: 'closePTModal',
	    value: function closePTModal() {
	      this.setState({ ptModalOpen: false });
	    }
	  }, {
	    key: 'breadcrumb',
	    value: function breadcrumb() {
	      if (!this.props.params.id) {
	        return _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_management' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_customer' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Breadcrumb,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb.Item,
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_management' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb.Item,
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customers' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb.Item,
	          { active: 'true' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_customer' })
	        )
	      );
	    }
	  }, {
	    key: 'renderPaymentTerms',
	    value: function renderPaymentTerms() {
	      if (this.props.paymentTermsIsLoading) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } // If group is loading, show a spinner.
	      var paymentTermOptions = this.getPaymentTermOptions();
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reduxForm.Field, { name: 'PaymentTerm_id', matchPos: 'any', component: _selection.Selection, options: paymentTermOptions })
	      );
	    }
	  }, {
	    key: 'getPaymentTermOptions',
	    value: function getPaymentTermOptions() {
	      var paymentTermOptions = [];
	      this.props.paymentTerms.map(function (paymentTerm) {
	        paymentTermOptions.push({ value: paymentTerm.PaymentTerm_id, label: paymentTerm.Name });
	      });
	      return paymentTermOptions;
	    }
	  }, {
	    key: 'copyBillingToMailing',
	    value: function copyBillingToMailing(e) {
	      e.preventDefault();
	      if (this.props.billing) {
	        var mailingInfo = _extends({}, this.props.billing, { Type: 'Mailing' });
	        this.props.setDefaultOfForm('Mailing', mailingInfo, 'customerForm');
	      }
	    }
	  }, {
	    key: 'checkPermission',
	    value: function checkPermission(permission) {
	      return false;
	    }
	  }, {
	    key: 'getDefaultBuyerOptions',
	    value: function getDefaultBuyerOptions() {
	      var salesUserOptions = [];
	      (this.props.defaultBuyers || []).forEach(function (defaultBuyer) {
	        salesUserOptions.push({
	          value: defaultBuyer.BaseUser_id,
	          label: defaultBuyer.username
	        });
	      });
	      return salesUserOptions;
	    }
	  }, {
	    key: 'renderDefaultSales',
	    value: function renderDefaultSales() {
	      var defaultBuyerOptions = this.getDefaultBuyerOptions();
	      return _react2.default.createElement(_reduxForm.Field, { name: 'Sales_User_id', component: _selection.Selection, options: defaultBuyerOptions });
	    }
	  }, {
	    key: 'renderStorageFeeType',
	    value: function renderStorageFeeType() {
	      var defaultBuyerOptions = [{ label: "Pallet Count", value: "PALLET_COUNT" }, { label: "Box CBM", value: "BOX_CBM" }];
	      return _react2.default.createElement(_reduxForm.Field, { name: 'StorageFeeType', component: _selection.Selection, options: defaultBuyerOptions });
	    }
	  }, {
	    key: 'getCustomerOptions',
	    value: function getCustomerOptions() {
	      var customerOptions = [];
	      this.props.customers.map(function (customer) {
	        customerOptions.push({ value: customer.Customer_id, label: customer.Name, customer_num: customer.CustomerNum });
	      });
	      this.setState({ customerOptions: customerOptions });
	    }
	  }, {
	    key: 'removeCustomer',
	    value: function removeCustomer(customer_id) {
	      var rows = this.state.rows;
	
	      rows = rows.filter(function (obj) {
	        var match = obj.customer_id !== customer_id;
	        return match;
	      });
	      this.setState({ rows: rows });
	    }
	  }, {
	    key: 'formatCustomerInput',
	    value: function formatCustomerInput(inputString) {
	      var stringArray = [];
	      var line = null;
	      var output = [];
	
	      stringArray = inputString.split(',');
	      stringArray.map(function (a) {
	        if (a.split(':')[1]) {
	          line = { customer_id: a.split(':')[0], customer_name: a.split(':')[1].split(';')[0], customer_num: a.split(':')[1].split(';')[1] };
	          output.push(line);
	        }
	      });
	      this.setState({ rows: output });
	    }
	  }, {
	    key: 'formatCustomerOutput',
	    value: function formatCustomerOutput() {
	      var rows = this.state.rows;
	
	      var outputString = "";
	      if (rows && rows.length > 0) {
	        rows.map(function (r) {
	          outputString += r.customer_id + ":" + r.customer_name + ";" + r.customer_num + ",";
	        });
	        outputString = outputString.slice(0, -1);
	      }
	      this.state.Sub_Customer_id = outputString;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this,
	          _React$createElement;
	
	      var _state3 = this.state,
	          customerOptions = _state3.customerOptions,
	          customerTableData = _state3.customerTableData;
	
	      var that = this;
	      var customerDetails = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_details' })
	      );
	      var billingDetails = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'billing_details' })
	      );
	      var mailingDetails = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mailing_details' })
	      );
	      var shippingDetails = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_details' })
	      );
	      var customerLink = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_link' })
	      );
	      var emails = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'app_email' })
	      );
	      var confirmAction = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm_action' });
	      var agentAction = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'agents' });
	      var creditTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_credit' });
	      var priceTable = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_price_table' });
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          submitting = _props.submitting,
	          pristine = _props.pristine,
	          isCreating = _props.isCreating,
	          isEditing = _props.isEditing;
	
	      var createDialogStyle = {
	        height: '600px',
	        marginTop: '-20%',
	        width: '680px',
	        marginLeft: '-10%',
	        left: '45%'
	      };
	      var createDialogStyle2 = {
	        height: '600px',
	        marginTop: '-20%',
	        width: '600px',
	        marginLeft: '-10%',
	        left: '45%'
	      };
	      var creditDialogue = {
	        height: '200px',
	        marginTop: '-10%',
	        width: '350px',
	        marginLeft: '-10%',
	        left: '55%'
	      };
	      var createDialogStylePT = {
	        height: '600px',
	        marginTop: '-20%',
	        width: '600px',
	        marginLeft: '-10%',
	        left: '45%'
	      };
	      var businessTypeOptions = isHMM ? [{ label: 'WHOLESALER', value: 'WHOLESALER' }, { label: 'BUILDER', value: 'BUILDER' }, { label: 'CONTRACTOR', value: 'CONTRACTOR' }, { label: 'RETAILER', value: 'RETAILER' }, { label: 'CUSTOMER', value: 'CUSTOMER' }] : isFJ ? [{ label: 'Freight Broker', value: 'Freight Broker' }, { label: 'Freight Forwarder', value: 'Freight Forwarder' }, { label: 'Direct Customer', value: 'Direct Customer' }, { label: 'Warehouse', value: 'Warehouse' }, { label: 'Consolidator', value: 'Consolidator' }] : isTQ ? [{ label: 'Retail', value: 'Retail' }, { label: 'Tenant', value: 'Tenant' }, { label: 'Wholesale', value: 'Wholesale' }, { label: 'Service', value: 'Service' }] : isWIZ ? [{ label: 'Customer', value: 'Customer' }, { label: 'Agent', value: 'Agent' }] : _root_url.isFV ? [{ label: 'Restaurant', value: 'Restaurant' }, { label: 'Warehouse', value: 'Warehouse' }, { label: 'Market', value: 'Market' }] : isAPO ? [{ label: 'Contractor', value: 'Contractor' }, { label: 'Retailer', value: 'Retailer' }, { label: 'Distributor', value: 'Distributor' }, { label: 'Wholesale', value: 'Wholesale' }] : [{ label: 'Restaurant', value: 'Restaurant' }, { label: 'Warehouse', value: 'Warehouse' }, { label: 'Tour Group', value: 'Tour Group' }, { label: 'Hotel', value: 'Hotel' }];
	
	      var creditOptions = [{ label: 'Good', value: 'Good' }, { label: 'Bad', value: 'Bad' }, { label: 'COD', value: 'COD' }];
	
	      var paymentMethodOptions = [{ label: 'Anywhere', value: false }, { label: 'Stripe', value: true }];
	
	      var delFormatter = _react2.default.createClass({
	        displayName: 'delFormatter',
	        render: function render() {
	          var _this8 = this;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                className: 'textAlignStyle',
	                style: { height: '23px', width: '39px', padding: '0px' },
	                onClick: function onClick() {
	                  // const ProductNum = this.props.dependentValues.ProductNum;
	                  var Index = _this8.props.dependentValues.customer_id;
	                  that.removeCustomer(Index);
	                }
	              },
	              'X'
	            )
	          );
	        }
	      });
	
	      var columns = [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: delFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'customer_name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' }),
	        width: 200,
	        resizable: false,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'customer_num',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_num' }),
	        width: 160,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }];
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this9.state);
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this9.state.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        _this9.setState({ filters: newFilters });
	      };
	      var onClearFilters = function onClearFilters() {
	        _this9.setState({ filters: {} });
	      };
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this9.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this9.setState(state);
	      };
	
	      if (this.props.detailIsLoading && !this.props.detailError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement('br', null),
	          '...',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reading_data' })
	        );
	      } else if (this.props.detailError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.error)
	          )
	        );
	      }
	
	      var currentCustomer = this.props.currentCustomer;
	
	      var token = localStorage.getItem('token');
	
	      var memberCardURL = _root_url.ROOT_URL + 'v1/customer/print_member/' + (currentCustomer && currentCustomer.Customer_id) + '?Bearer=' + token;
	
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'form',
	            { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	            this.breadcrumb(),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              null,
	              isFJ && _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  type: 'button',
	                  onClick: function onClick() {
	                    return _this9.openAgentModal();
	                  },
	                  disabled: this.context.router.routes[1].path === 'customers/new'
	                },
	                _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'agents' })
	              ),
	              (isWIZ || isMAG || isKDW) && _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  type: 'button',
	                  onClick: function onClick() {
	                    return _this9.openPTModal();
	                  },
	                  disabled: this.context.router.routes[1].path === 'customers/new'
	                },
	                _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price_table' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  type: 'button',
	                  onClick: handleSubmit(this.handleFormSubmit.bind(this)),
	                  disabled: submitting || isEditing || isCreating
	                },
	                _react2.default.createElement('em', { className: 'fa fa-save' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  type: 'reset',
	                  onClick: function onClick() {
	                    return window.history.back();
	                  }
	                },
	                _react2.default.createElement('em', { className: 'fa fa-close' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	              )
	            ),
	            ' ',
	            _react2.default.createElement(
	              _reactBootstrap.Grid,
	              { id: 'customer-form' },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 8 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { id: 'customer-details', header: customerDetails, style: { height: isKDW || _root_url.isSY ? '430px' : '395px' } },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 8 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: _root_url.isSY ? "company_name" : "name" }),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'asteriksReq' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Name', component: _inputField.InputField })
	                        ),
	                        _root_url.isSY && _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'contact_name' })
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'ContactName', component: _inputField.InputField })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group description-business-type-form-group' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'description-input-field' },
	                            _react2.default.createElement(
	                              'label',
	                              { htmlFor: 'description' },
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	                            ),
	                            _react2.default.createElement(_reduxForm.Field, { name: 'Description', component: _inputField.InputField, className: 'inputFieldStyle' })
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'business-type-form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              { htmlFor: 'business-type' },
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'business_type' })
	                            ),
	                            _react2.default.createElement(_GenericSelection2.default, {
	                              options: businessTypeOptions,
	                              value: this.state.businessType,
	                              setSelected: function setSelected(e) {
	                                _this9.setState({ businessType: e.value });
	                              }
	                            })
	                          ),
	                          isYI && _react2.default.createElement(
	                            'div',
	                            { style: { marginLeft: '10px' } },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit_amount' })
	                            ),
	                            _react2.default.createElement('input', { type: 'text', value: this.state.customerCredit, disabled: true, onChange: function onChange(e) {
	                                return console.log(e);
	                              }, style: { border: '1px solid black', height: '30px', borderRadius: '4px', margin: '0', padding: '10px' } }),
	                            _react2.default.createElement(
	                              _reactBootstrap.Button,
	                              {
	                                bsStyle: 'primary',
	                                type: 'button',
	                                style: { marginLeft: '2px' },
	                                disabled: !currentCustomer,
	                                onClick: function onClick() {
	                                  return _this9.openCredit();
	                                }
	                              },
	                              _react2.default.createElement('em', { className: 'fa fa-edit' })
	                            )
	                          ),
	                          _root_url.isCalco && _react2.default.createElement(
	                            'div',
	                            { className: 'business-type-form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              { htmlFor: 'business-type' },
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_method' })
	                            ),
	                            _react2.default.createElement(_GenericSelection2.default, {
	                              options: paymentMethodOptions,
	                              value: this.state.IsStripe,
	                              setSelected: function setSelected(e) {
	                                _this9.setState({ IsStripe: e.value });
	                              }
	                            })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term' }),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'asteriksReq' },
	                              '*'
	                            )
	                          ),
	                          this.renderPaymentTerms()
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          null,
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit_limit' })
	                              ),
	                              _react2.default.createElement(_reduxForm.Field, (_React$createElement = { name: 'CreditLimit', component: renderAfterAddonField, standalone: true, type: 'text' }, _defineProperty(_React$createElement, 'standalone', true), _defineProperty(_React$createElement, 'addonAfter', '.00'), _React$createElement))
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'credit-type-form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'credit-type' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit_status' })
	                              ),
	                              _react2.default.createElement(_GenericSelection2.default, {
	                                options: creditOptions,
	                                value: this.state.creditStatus,
	                                setSelected: function setSelected(e) {
	                                  _this9.setState({ creditStatus: e.value });
	                                }
	                              })
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 7 },
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          null,
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'asteriksReq' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement(_reduxForm.Field, { name: 'CustomerNum', component: _inputField.InputField })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' })
	                              ),
	                              _react2.default.createElement(_reduxForm.Field, { name: 'RefNum', component: _inputField.InputField })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6, className: 'no-padding' },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'PriceLevel', component: _priceLevel2.default, isRequired: true })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          null,
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ein' })
	                              ),
	                              _react2.default.createElement(_reduxForm.Field, { name: 'EIN', component: _inputField.InputField })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'driver_license' })
	                              ),
	                              _react2.default.createElement(_reduxForm.Field, { name: 'DLN', component: _inputField.InputField })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reseller' })
	                              ),
	                              _react2.default.createElement(_reduxForm.Field, { name: 'Reseller', component: _inputField.InputField })
	                            )
	                          )
	                        ),
	                        _root_url.isCalco && _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          null,
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'route_id' })
	                              ),
	                              _react2.default.createElement(_reduxForm.Field, { name: 'Route_id', component: _inputField.InputField })
	                            )
	                          )
	                        ),
	                        _root_url.isEcity && _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          null,
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'member_card' })
	                              ),
	                              _react2.default.createElement(_reduxForm.Field, { name: 'MemberCard', component: _inputField.InputField, disabled: true })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'member_card_download' })
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                  bsStyle: 'success',
	                                  type: 'button',
	                                  href: memberCardURL
	                                  // disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1}
	                                },
	                                _react2.default.createElement('em', { className: 'fa fa-download' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'member_card' })
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 3 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'IsWholesale', component: renderRadios }),
	                        !_root_url.isElegant && _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          { className: 'form-horizontal' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              { className: 'col-sm-6' },
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'resale_no' })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-sm-6' },
	                              _react2.default.createElement(_reduxForm.Field, { name: 'Wholesale_ResaleNo', component: _inputField.InputField })
	                            )
	                          )
	                        ),
	                        isCO && _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          { className: 'form-horizontal' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(
	                              'label',
	                              { className: 'col-sm-6' },
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_discount' })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-sm-6' },
	                              _react2.default.createElement(_reduxForm.Field, { name: 'DiscountPercentage', component: _inputField.InputField })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(_reduxForm.Field, { name: 'IsShowPrice', component: renderRadios }),
	                        _root_url.isSY && _react2.default.createElement(_reduxForm.Field, { name: 'IsShippingFee', component: renderRadios }),
	                        _react2.default.createElement(_reduxForm.Field, { name: 'IsActive', component: renderRadios, paymentTerm_id: this.props.paymentTerm_id, setDefaultOfForm: this.props.setDefaultOfForm })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' })
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Notation', maxLength: 150, component: _inputField.InputField })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: isKDW ? 3 : 6 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'default_sales' })
	                          ),
	                          this.renderDefaultSales()
	                        )
	                      ),
	                      isKDW && _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 3 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_free_days' })
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'StorageFreeDays', component: _inputField.InputField })
	                        )
	                      )
	                    ),
	                    isKDW && _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'finance_email_list' })
	                          ),
	                          _react2.default.createElement(
	                            'span',
	                            { style: { color: 'red', marginLeft: '5px' } },
	                            'Press Enter for more emails'
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'FinanceEmail', component: 'Textarea', className: 'form-control', style: { minHeight: '50px' } })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'operation_email_list' })
	                          ),
	                          _react2.default.createElement(
	                            'span',
	                            { style: { color: 'red', marginLeft: '5px' } },
	                            'Press Enter for more emails'
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'OperationEmail', component: 'Textarea', className: 'form-control', style: { minHeight: '50px' } })
	                        )
	                      )
	                    ),
	                    isYI && _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'percentage_fee' }),
	                            '(%)'
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'PctMarkup', component: _inputField.InputField })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'flat_fee' }),
	                            '($)'
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'FlatMarkup', component: _inputField.InputField })
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 4 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { id: 'e-mails', header: emails },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(_reduxForm.FieldArray, { name: 'email', component: renderEmails })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 4 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { id: 'billing-details', header: billingDetails },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      { className: 'form-horizontal' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-sm-2' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-10' },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Billing.AddressName', component: _inputField.InputField })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      { className: 'form-horizontal' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-sm-2' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'street' }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'asteriksReq' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-10' },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Billing.Street', component: _inputField.InputField })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city' }),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'asteriksReq' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Billing.City', component: _inputField.InputField })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 3 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'state' }),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'asteriksReq' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Billing.State', component: _inputField.InputField })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 3 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zip' }),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'asteriksReq' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Billing.Zip', component: _inputField.InputField })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: isTQ || isOCM ? 6 : 4 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'first_name' })
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Billing.FirstName', component: _inputField.InputField })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: isTQ || isOCM ? 6 : 4 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_name' })
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Billing.LastName', component: _inputField.InputField })
	                        )
	                      ),
	                      !(isTQ || isOCM || isMAG) && _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' })
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Billing.Email', component: _inputField.InputField, maxLength: 200 })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      !_root_url.isSY && _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tel' }),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'asteriksReq' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Billing.Telephone', component: _inputField.InputField })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'alt_phone' })
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Billing.Cellphone', component: _inputField.InputField })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fax' })
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Billing.Fax', component: _inputField.InputField })
	                        )
	                      )
	                    ),
	                    _root_url.isSY && _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tel' })
	                          ),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'asteriksReq' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'press_enter_for_phones' })
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, {
	                            name: 'Billing.Telephone',
	                            component: 'Textarea',
	                            className: 'form-control resize-vertical',
	                            style: { minHeight: '40px' },
	                            resize: 'vertical'
	                          })
	                        )
	                      )
	                    ),
	                    (isTQ || isOCM || isMAG) && _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' })
	                          ),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'asteriksReq' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'press_enter_for_emails' })
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, {
	                            name: 'Billing.Email',
	                            component: 'Textarea',
	                            className: 'form-control resize-vertical',
	                            style: { minHeight: '40px' },
	                            resize: 'vertical'
	                          })
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 4 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { id: 'mailing-details', header: mailingDetails },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      { className: 'form-horizontal' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-sm-2' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { sm: 6 },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Mailing.AddressName', component: _inputField.InputField })
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { sm: 4 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                              bsStyle: 'default',
	                              className: 'auto-fill',
	                              type: 'button',
	                              onClick: this.copyBillingToMailing.bind(this)
	                            },
	                            _react2.default.createElement('em', { className: 'fa fa-edit' }),
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'auto_fill' })
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      { className: 'form-horizontal' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-sm-2' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'street' }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'asteriksReq' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { sm: 10 },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Mailing.Street', component: _inputField.InputField })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city' }),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'asteriksReq' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Mailing.City', component: _inputField.InputField })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 3 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'state' }),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'asteriksReq' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Mailing.State', component: _inputField.InputField })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 3 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zip' }),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'asteriksReq' },
	                              '*'
	                            )
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Mailing.Zip', component: _inputField.InputField })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'first_name' })
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Mailing.FirstName', component: _inputField.InputField })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_name' })
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Mailing.LastName', component: _inputField.InputField })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' })
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Mailing.Email', component: _inputField.InputField })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tel' })
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Mailing.Telephone', component: _inputField.InputField })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'alt_phone' })
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Mailing.Cellphone', component: _inputField.InputField })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4 },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fax' })
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Mailing.Fax', component: _inputField.InputField })
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 4 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { id: 'shipping-details', header: shippingDetails },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_address' })
	                    ),
	                    _react2.default.createElement(_reduxForm.FieldArray, {
	                      name: 'Shipping',
	                      component: renderShipping,
	                      billing: this.props.billing,
	                      shipping: this.props.shipping // {this.props.billingAddress}
	                      , changeFieldArrayOfForm: this.props.changeFieldArrayOfForm
	                    })
	                  )
	                )
	              ),
	              (isAFG || _root_url.isEcity) && _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 4 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { id: 'customer-link', header: customerLink },
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(_reduxForm.Field, {
	                        name: 'receivingCustomer',
	                        matchPos: 'any',
	                        placeholder: _react2.default.createElement(
	                          'span',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer' }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'asteriksReq' },
	                            '*'
	                          )
	                        ),
	                        onSelect: function onSelect(e) {
	                          return _this9.setCustomer(e);
	                        },
	                        component: _selection.SelectionWithProps,
	                        options: customerOptions
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'react-customizer', id: 'customer-dataGrid3' },
	                      _react2.default.createElement(_reactDataGrid2.default, {
	                        rowKey: 'customer_id',
	                        columns: columns,
	                        rowHeight: 25,
	                        headerRowHeight: 45,
	                        minHeight: 175,
	                        rowGetter: rowGetter,
	                        rowsCount: getSize(),
	                        toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                        onAddFilter: handleFilterChange,
	                        onClearFilters: onClearFilters,
	                        onGridSort: handleGridSort
	                      })
	                    )
	                  )
	                )
	              ),
	              this.props.isCreating || this.props.isEditing && _react2.default.createElement(_spinner2.default, null)
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: createDialogStyle, isVisible: this.state.confirmOpen, onCloseClicked: function onCloseClicked() {
	                  _this9.closeConfirm();
	                }, title: confirmAction },
	              _react2.default.createElement(_confirmActionModal2.default, { 'case': this.state.case, closeC: this.closeConfirm })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: createDialogStyle2, isVisible: this.state.agentModalOpen, onCloseClicked: function onCloseClicked() {
	                  _this9.closeAgentModal();
	                }, title: agentAction },
	              _react2.default.createElement(_agentChangeModal.AgentChangeModal, {
	                fjCustomerId: this.state.fjCustomerId,
	                fetchFJAgents: this.props.fetchFJAgents,
	                updateFJAgents: this.props.updateFJAgents,
	                deleteFJAgents: this.props.deleteFJAgents,
	                closeAgentModal: this.closeAgentModal
	                // salesOrderId={singleSalesOrderId}
	                // fetchShippingWeightTracking={this.props.fetchShippingWeightTracking}
	                // finalShippingWeight={this.state.finalShippingWeight}
	                // onSave={this.onChangeWeightSubmit}
	                // onSavePrint={this.onChangeWeightSubmitPrint}
	                // onChange={this.onShippingWeightChange}
	              })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: creditDialogue, isVisible: this.state.creditOpen, onCloseClicked: function onCloseClicked() {
	                  _this9.closeCredit();
	                }, title: creditTitle },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { className: 'centerStyle' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_credit_amount' }),
	                    ':\xA0'
	                  ),
	                  _react2.default.createElement('input', { type: 'number', value: this.state.customerCreditModal, disabled: false, onChange: function onChange(e) {
	                      return _this9.onCreditChange(e);
	                    }, style: { border: '1px solid black', height: '30px', borderRadius: '4px', margin: '0', padding: '10px' } })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { className: 'centerStyle' },
	                  _react2.default.createElement(
	                    'label',
	                    { style: { width: '116px' } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	                    ':\xA0'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', value: this.state.customerCreditNote, disabled: false, onChange: function onChange(e) {
	                      return _this9.onCreditNoteChange(e);
	                    }, style: { border: '1px solid black', height: '30px', borderRadius: '4px', margin: '0', padding: '10px' } })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { className: 'centerStyle', style: { marginTop: '10px' } },
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                      bsStyle: 'primary',
	                      type: 'button',
	                      style: { marginLeft: '0px' },
	                      onClick: function onClick() {
	                        return _this9.saveCredit();
	                      }
	                    },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm' })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                      bsStyle: 'danger',
	                      type: 'button',
	                      style: { marginLeft: '10px' },
	                      onClick: function onClick() {
	                        return _this9.closeCredit();
	                      }
	                    },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: createDialogStylePT, isVisible: this.state.ptModalOpen, onCloseClicked: function onCloseClicked() {
	                  _this9.closePTModal();
	                }, title: priceTable },
	              _react2.default.createElement(_priceTableModal.PriceTableModal, {
	                fjCustomerId: this.state.fjCustomerId,
	                fetchPT: this.props.fetchPT,
	                updatePT: this.props.updatePT
	                // deleteFJAgents = {this.props.deleteFJAgents}
	                , closePTModal: this.closePTModal
	              })
	            )
	          )
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return CustomerForm;
	}(_react.Component);
	
	CustomerForm.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var _default = (0, _reactRouter.withRouter)(CustomerForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isHMM, 'isHMM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customerForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isAFG, 'isAFG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customerForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isCO, 'isCO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customerForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isFJ, 'isFJ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customerForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isMAG, 'isMAG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customerForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isWIZ, 'isWIZ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customerForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isTQ, 'isTQ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customerForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isOCM, 'isOCM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customerForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isKDW, 'isKDW', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customerForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isYI, 'isYI', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customerForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isAPO, 'isAPO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customerForm.jsx');
	
	  __REACT_HOT_LOADER__.register(renderEmails, 'renderEmails', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customerForm.jsx');
	
	  __REACT_HOT_LOADER__.register(renderIsDefault, 'renderIsDefault', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customerForm.jsx');
	
	  __REACT_HOT_LOADER__.register(renderAfterAddonField, 'renderAfterAddonField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customerForm.jsx');
	
	  __REACT_HOT_LOADER__.register(renderRadios, 'renderRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customerForm.jsx');
	
	  __REACT_HOT_LOADER__.register(renderShipping, 'renderShipping', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customerForm.jsx');
	
	  __REACT_HOT_LOADER__.register(CustomerForm, 'CustomerForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customerForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customerForm.jsx');
	}();

	;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDropzone = __webpack_require__(45);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	var _url = __webpack_require__(20);
	
	var _constants = __webpack_require__(11);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _FilterToolbar = __webpack_require__(149);
	
	var _FilterToolbar2 = _interopRequireDefault(_FilterToolbar);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactPaginate = __webpack_require__(104);
	
	var _reactPaginate2 = _interopRequireDefault(_reactPaginate);
	
	var _generalManagement = __webpack_require__(281);
	
	var _generalManagement2 = _interopRequireDefault(_generalManagement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WebUserModal = _generalManagement2.default.WebUserModal;
	
	
	var isEcity = _root_url.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://ctstage-scm.truckxi.com/api/';
	
	var RowRenderer = function (_Component) {
	  _inherits(RowRenderer, _Component);
	
	  function RowRenderer() {
	    _classCallCheck(this, RowRenderer);
	
	    return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(RowRenderer, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // here we are just changing the style
	      // but we could replace this with anything we liked, cards, images, etc
	      // usually though it will just be a matter of wrapping a div, and then calling back through to the grid
	      return _react2.default.createElement(
	        'div',
	        {
	          onDoubleClick: function onDoubleClick() {
	            _this2.props.onDoubleClick(_this2.props.row);
	          }
	        },
	        _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	      );
	    }
	  }]);
	
	  return RowRenderer;
	}(_react.Component);
	
	var Customers = function (_Component2) {
	  _inherits(Customers, _Component2);
	
	  function Customers() {
	    _classCallCheck(this, Customers);
	
	    var _this3 = _possibleConstructorReturn(this, (Customers.__proto__ || Object.getPrototypeOf(Customers)).call(this));
	
	    _this3.componentWillReceiveProps = function (nextProps) {
	      if (nextProps.customers && nextProps.customers !== _this3.props.customers) {
	        if (nextProps.currentCustomer) {
	          _this3.setState({
	            selectedRows: nextProps.customers.filter(function (customer) {
	              return customer.Customer_id === _this3.props.currentCustomer.Customer_id;
	            }).map(function (customer) {
	              return _extends({}, customer, { isSelected: true });
	            })
	          });
	        }
	        var currentCustomerId = _this3.props.currentCustomer ? _this3.props.currentCustomer.Customer_id : null;
	        _this3.setState({
	          rows: nextProps.customers.map(function (customer) {
	            return _extends({}, customer, { isSelected: customer.Customer_id === currentCustomerId });
	          })
	        });
	      }
	    };
	
	    _this3.setWebUserModalVisibility = function () {
	      var isWebUserModalVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this3.setState({ isWebUserModalVisible: isWebUserModalVisible });
	    };
	
	    _this3.state = {
	      isWebUserModalVisible: false,
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.customersPage,
	
	      currentPage: 0,
	      limit: isEcity ? null : 25,
	      searchFilter: {
	        CustomerNum: '',
	        Name: '',
	        email: '',
	        Description: '',
	        IsWholesale: '',
	        PriceLevel: '',
	        IsActive: '',
	        MemberCard: '',
	        Reseller: '',
	        Telephone: '',
	        Street: '',
	        City: ''
	      },
	      wholesaleDisplay: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' }),
	      activeDisplay: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' }),
	      limitDisplay: isEcity ? 'all' : '25',
	      rows: [],
	      selectedRows: [],
	      filters: {},
	      sortColumn: null,
	      sortDirection: null,
	      files: null
	    };
	
	    _this3.handleResize = _this3.handleResize.bind(_this3);
	    return _this3;
	  }
	
	  _createClass(Customers, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this4 = this;
	
	      document.title = _root_url.companyCodeTitle;
	      window.addEventListener('resize', this.handleResize);
	      // this.props.fetchCustomers();
	      this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
	      if (_root_url.isSY) {
	        // fetch editable customer for the user
	        _axios2.default.get(_url.CUSTOMERS_URL + '?my_customers_only=True', {
	          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	          _this4.setState({ editableCustomer: response.data });
	        }, function (err) {
	          alert(JSON.stringify(err.data));
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	
	    // Once customers are ready, reset state.
	
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.customersPage });
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(files) {
	      if (files) {
	        alert('Upload takes time, please stay on the current page');
	      }
	      this.props.attachDocument(files);
	      this.setState({
	        files: files
	      });
	    }
	
	    // Helper function to render an icon for the stock statues of customer.
	
	  }, {
	    key: 'renderIsActive',
	    value: function renderIsActive(isActive) {
	      if (isActive) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'label label-success' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'active' })
	        );
	      }
	      return _react2.default.createElement(
	        'span',
	        { className: 'label label-danger' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inactive' })
	      );
	    }
	  }, {
	    key: 'renderIsWholesale',
	    value: function renderIsWholesale(isWholeSale) {
	      if (isWholeSale) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'label label-success' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	        );
	      }
	      return _react2.default.createElement(
	        'span',
	        { className: 'label label-danger' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	      );
	    }
	
	    // Set customer being selected to be currentCustomer and navigate user to the edit page
	
	  }, {
	    key: 'setCurrentCustomer',
	    value: function setCurrentCustomer(e) {
	      e.preventDefault();
	      var currentCustomer = this.state.selectedRows[0];
	      var customerFromOriginalData = this.props.customers.filter(function (customer) {
	        return customer.Customer_id === currentCustomer.Customer_id;
	      })[0];
	      this.props.resetCurrentCustomer();
	      this.props.selectCustomer(customerFromOriginalData);
	      this.context.router.push('/customers/' + customerFromOriginalData.Customer_id);
	    }
	
	    // Reset the currentCustomer and navigate to the create page
	
	  }, {
	    key: 'clickNew',
	    value: function clickNew(e) {
	      e.preventDefault();
	      this.props.resetCurrentCustomer();
	      this.context.router.push('/customers/new');
	    }
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this5 = this;
	
	      if (this.props.isLoading && !this.props.error) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_spinner2.default, null)
	        );
	      } else if (this.props.error) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.error)
	          )
	        );
	      }
	
	      var modifiedRows = this.state.rows.map(function (customer) {
	        return _extends({}, customer, {
	          IsActive: customer.IsActive ? 'active' : 'inactive',
	          IsWholesale: customer.IsWholesale ? 'yes' : 'no'
	        });
	      });
	
	      var getRows = function getRows() {
	        var data = _extends({}, _this5.state, {
	          rows: modifiedRows
	        });
	        return _reactDataGridAddons.Data.Selectors.getRows(data);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this5.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this5.setState(state);
	      };
	
	      // Custom Formatter component
	      var IsActiveFormatter = _react2.default.createClass({
	        displayName: 'IsActiveFormatter',
	        render: function render() {
	          if (this.props.value === 'active') {
	            return _react2.default.createElement(
	              'span',
	              { className: 'label label-success' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'active' })
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inactive' })
	          );
	        }
	      });
	
	      var IsWholesaleFormatter = _react2.default.createClass({
	        displayName: 'IsWholesaleFormatter',
	        render: function render() {
	          if (this.props.value === 'yes') {
	            return _react2.default.createElement(
	              'span',
	              { className: 'label label-success' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	          );
	        }
	      });
	
	      // Handle the row select function
	      var onRowSelect = function onRowSelect(rows) {
	        _this5.setState({ selectedRows: rows });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = [].concat(_toConsumableArray(_this5.state.rows));
	        var selectedRows = _this5.state.selectedRows;
	
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	
	        selectedRows = [];
	        rows.map(function (row) {
	          var index = _lodash2.default.findIndex(_this5.state.rows, { 'Customer_id': row.row.Customer_id });
	          newRows[index].isSelected = true;
	          selectedRows.push(row.row);
	        });
	
	        _this5.setState({ rows: newRows, selectedRows: selectedRows, selectedRowsIdx: rows[0].rowIdx });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = [].concat(_toConsumableArray(_this5.state.rows));
	        rows.map(function (row) {
	          var index = _lodash2.default.findIndex(_this5.state.rows, { 'Customer_id': row.row.Customer_id });
	          newRows[index].isSelected = false;
	        });
	        var selectedRows = [];
	        newRows.map(function (r) {
	          if (r.isSelected) {
	            selectedRows.push(r);
	          }
	        });
	        _this5.setState({ rows: newRows, selectedRows: selectedRows });
	      };
	
	      var handleOnPageChange = function handleOnPageChange(data) {
	        _this5.state.currentPage = data.selected;
	        _this5.props.fetchCustomersPaginate(_this5.state.currentPage, _this5.state.limit, _this5.state.searchFilter);
	      };
	
	      // Column difinition
	      var columns = [{
	        key: 'CustomerNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_no' }),
	        width: 130,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }].concat(_toConsumableArray(_root_url.isCalco ? [{
	        key: 'Route_id',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'route_id' }),
	        width: 100,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }] : []), [{
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 200
	      }, {
	        key: 'Telephone',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 110
	      }, {
	        key: 'Street',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 190
	      }], _toConsumableArray(isEcity ? [{
	        key: 'City',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }] : [{
	        key: 'email',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 110
	      }]), [{
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        width: 200,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'IsWholesale',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'wholesale' }),
	        width: 100,
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: IsWholesaleFormatter
	      }, {
	        key: 'PriceLevel',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price_lvl' }),
	        width: 90,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'IsActive',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'active' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: IsActiveFormatter
	      }]);
	
	      if (isEcity) {
	        var indexDescription = _lodash2.default.findIndex(columns, { key: 'Description' });
	        var memberCardColumn = {
	          key: 'MemberCard',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'member_card' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 130
	        };
	        var resellerColumn = {
	          key: 'Reseller',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reseller' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 80
	        };
	        columns.splice(indexDescription, 0, resellerColumn);
	        columns.splice(indexDescription, 0, memberCardColumn);
	      }
	
	      var isEditable = false;
	      if (_root_url.isSY && this.state.selectedRows.length === 1) {
	        if (this.state.editableCustomer.findIndex(function (e) {
	          return e.Customer_id === _this5.state.selectedRows[0].Customer_id;
	        }) !== -1) {
	          isEditable = true;
	        }
	        if ((0, _permissions2.default)('edit_all_customer')) {
	          isEditable = true;
	        }
	      }
	
	      return (
	        // React Table Customers
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { md: 12 },
	              _react2.default.createElement(
	                'div',
	                { id: 'Customers-dataGrid1', style: { marginTop: '80px' } },
	                _react2.default.createElement(_reactDataGrid2.default, {
	                  rowRenderer: _react2.default.createElement(RowRenderer, {
	                    onDoubleClick: function onDoubleClick(customerFromOriginalData) {
	                      if (isEditable) {
	                        _this5.props.resetCurrentCustomer();
	                        _this5.props.selectCustomer(customerFromOriginalData);
	                        _this5.context.router.push('/customers/' + customerFromOriginalData.Customer_id);
	                      }
	                    }
	                  }),
	                  rowKey: 'Customer_id',
	                  enableCellSelect: true,
	                  onGridSort: handleGridSort
	                  // toolbar={<FilterToolbar enableFilter />}
	                  // onAddFilter={handleFilterChange}
	                  , columns: columns,
	                  rowHeight: 25,
	                  rowGetter: rowGetter,
	                  rowsCount: getSize(),
	                  minHeight: this.state.tableHeight - 95,
	                  enableRowSelect: 'single',
	                  onRowUpdated: this.handleRowUpdated,
	                  onRowSelect: onRowSelect,
	                  minColumnWidth: 300,
	                  rowSelection: {
	                    showCheckbox: true,
	                    onRowsSelected: onRowsSelected,
	                    onRowsDeselected: onRowsDeselected,
	                    selectBy: {
	                      isSelectedKey: 'isSelected'
	                    }
	                  }
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { md: 12 },
	              _react2.default.createElement(
	                'div',
	                { style: { width: '630px' }, id: 'react-pagination' },
	                _react2.default.createElement(_reactPaginate2.default, {
	                  previousLabel: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prev_page' }),
	                  nextLabel: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'next_page' }),
	                  containerClassName: 'pagination',
	                  activeClassName: 'active',
	                  marginPagesDisplayed: 2,
	                  pageRangeDisplayed: 5,
	                  pageCount: this.props.customerTotalPages,
	                  onPageChange: handleOnPageChange,
	                  forcePage: this.state.currentPage
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { style: { padding: '10px', paddingTop: '0px', fontSize: 'small' } },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_customers' }),
	              ':\xA0',
	              _react2.default.createElement(
	                'span',
	                { className: 'font-color-orange' },
	                this.props.customerTotalCount
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderSearchFilter',
	    value: function renderSearchFilter() {
	      var _this6 = this;
	
	      var isWholesaleSelection = [{
	        label: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' }),
	        value: '',
	        name: 'IsWholesale'
	      }, {
	        label: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' }),
	        value: '1',
	        name: 'IsWholesale'
	      }, {
	        label: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' }),
	        value: '0',
	        name: 'IsWholesale'
	      }];
	
	      var isActiveSelection = [{
	        label: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' }),
	        value: '',
	        name: 'IsActive'
	      }, {
	        label: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'active' }),
	        value: '1',
	        name: 'IsActive'
	      }, {
	        label: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inactive' }),
	        value: '0',
	        name: 'IsActive'
	      }];
	
	      var limitSelection = [{
	        label: '25',
	        value: 25,
	        name: 'limit'
	      }, {
	        label: '50',
	        value: 50,
	        name: 'limit'
	      }, {
	        label: '100',
	        value: 100,
	        name: 'limit'
	      }, {
	        label: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' }),
	        value: null,
	        name: 'limit'
	      }];
	
	      var handleOnSubmit = function handleOnSubmit(event) {
	        event.preventDefault();
	      };
	
	      var handleFilterChange = function handleFilterChange(event) {
	        _this6.state.currentPage = 0;
	        var keys = Object.keys(_this6.state.searchFilter);
	        for (var i = 0; i < keys.length; i++) {
	          if (event.target.name === keys[i]) {
	            _this6.state.searchFilter[keys[i]] = event.target.value;
	          }
	        }
	        _this6.props.fetchCustomersPaginate(_this6.state.currentPage, _this6.state.limit, _this6.state.searchFilter);
	      };
	
	      var handleFilterChangeDropdown = function handleFilterChangeDropdown(el) {
	        _this6.state.currentPage = 0;
	        var keys = Object.keys(_this6.state.searchFilter);
	        for (var i = 0; i < keys.length; i++) {
	          if (el.name === keys[i]) {
	            _this6.state.searchFilter[keys[i]] = el.value;
	            if (el.name === 'IsWholesale') {
	              _this6.state.wholesaleDisplay = el.label;
	            } else if (el.name === 'IsActive') {
	              _this6.state.activeDisplay = el.label;
	            }
	          }
	        }
	        _this6.props.fetchCustomersPaginate(_this6.state.currentPage, _this6.state.limit, _this6.state.searchFilter);
	      };
	
	      var handleLimitChange = function handleLimitChange(el) {
	        _this6.state.currentPage = 0;
	        _this6.state.limit = el.value;
	        _this6.state.limitDisplay = el.label;
	        _this6.props.fetchCustomersPaginate(_this6.state.currentPage, _this6.state.limit, _this6.state.searchFilter);
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: { width: '1400px' } },
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { md: 12 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group', style: { marginBottom: '0px', marginTop: '30px', position: 'absolute', zIndex: 2 }, id: 'search-product-by' },
	              _react2.default.createElement(
	                'form',
	                { autoComplete: 'off', onSubmit: handleOnSubmit },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'col-sm-3', style: { width: '120px' } },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_no' })
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'col-sm-3', style: { width: '120px' } },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'col-sm-3', style: { width: '120px' } },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'col-sm-3', style: { width: '120px' } },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' })
	                    ),
	                    isEcity && _react2.default.createElement(
	                      'label',
	                      { className: 'col-sm-3', style: { width: '120px' } },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city' })
	                    ),
	                    !isEcity && _react2.default.createElement(
	                      'label',
	                      { className: 'col-sm-3', style: { width: '120px' } },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' })
	                    ),
	                    isEcity && _react2.default.createElement(
	                      'label',
	                      { className: 'col-sm-3', style: { width: '120px' } },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'member_card' })
	                    ),
	                    isEcity && _react2.default.createElement(
	                      'label',
	                      { className: 'col-sm-3', style: { width: '120px' } },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reseller' })
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'col-sm-3', style: { width: '120px' } },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'col-sm-3', style: { width: '90px' } },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'wholesale' })
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'col-sm-3', style: { width: '120px' } },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price_lvl' })
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'col-sm-3', style: { width: '115px' } },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'active' })
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'col-sm-3', style: { width: '90px' } },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'limit' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { className: 'col-sm-3', style: { width: '120px' } },
	                    _react2.default.createElement(_reactBootstrap.Input, { name: 'CustomerNum', type: 'text', onChange: handleFilterChange })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { className: 'col-sm-3', style: { width: '120px' } },
	                    _react2.default.createElement(_reactBootstrap.Input, { name: 'Name', type: 'text', onChange: handleFilterChange })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { className: 'col-sm-3', style: { width: '120px' } },
	                    _react2.default.createElement(_reactBootstrap.Input, { name: 'Telephone', type: 'text', onChange: handleFilterChange })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { className: 'col-sm-3', style: { width: '120px' } },
	                    _react2.default.createElement(_reactBootstrap.Input, { name: 'Street', type: 'text', onChange: handleFilterChange })
	                  ),
	                  isEcity ? _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { className: 'col-sm-3', style: { width: '120px' } },
	                    _react2.default.createElement(_reactBootstrap.Input, { name: 'City', type: 'text', onChange: handleFilterChange })
	                  ) : _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { className: 'col-sm-3', style: { width: '120px' } },
	                    _react2.default.createElement(_reactBootstrap.Input, { name: 'email', type: 'text', onChange: handleFilterChange })
	                  ),
	                  isEcity && _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { className: 'col-sm-3', style: { width: '120px' } },
	                    _react2.default.createElement(_reactBootstrap.Input, { name: 'MemberCard', type: 'text', onChange: handleFilterChange })
	                  ),
	                  isEcity && _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { className: 'col-sm-3', style: { width: '120px' } },
	                    _react2.default.createElement(_reactBootstrap.Input, { name: 'Reseller', type: 'text', onChange: handleFilterChange })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { className: 'col-sm-3', style: { width: '120px' } },
	                    _react2.default.createElement(_reactBootstrap.Input, { name: 'Description', type: 'text', onChange: handleFilterChange })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { className: 'col-sm-3', style: { width: '90px' } },
	                    _react2.default.createElement(
	                      _reactBootstrap.Dropdown,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Dropdown.Toggle,
	                        { style: { width: '75px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' } },
	                        this.state.wholesaleDisplay
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Dropdown.Menu,
	                        { className: 'super-colors' },
	                        isWholesaleSelection.map(function (el) {
	                          return _react2.default.createElement(
	                            _reactBootstrap.MenuItem,
	                            { onClick: function onClick() {
	                                return handleFilterChangeDropdown(el);
	                              } },
	                            el.label
	                          );
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { className: 'col-sm-3', style: { width: '120px' } },
	                    _react2.default.createElement(_reactBootstrap.Input, { name: 'PriceLevel', type: 'number', onChange: handleFilterChange })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { className: 'col-sm-3', style: { width: '115px' } },
	                    _react2.default.createElement(
	                      _reactBootstrap.Dropdown,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Dropdown.Toggle,
	                        { style: { width: '100px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' } },
	                        this.state.activeDisplay
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Dropdown.Menu,
	                        { className: 'super-colors' },
	                        isActiveSelection.map(function (el) {
	                          return _react2.default.createElement(
	                            _reactBootstrap.MenuItem,
	                            { onClick: function onClick() {
	                                return handleFilterChangeDropdown(el);
	                              } },
	                            el.label
	                          );
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { className: 'col-sm-3', style: { width: '90px' } },
	                    _react2.default.createElement(
	                      _reactBootstrap.Dropdown,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Dropdown.Toggle,
	                        { style: { width: '60px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' } },
	                        this.state.limitDisplay
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Dropdown.Menu,
	                        { className: 'super-colors' },
	                        limitSelection.map(function (el) {
	                          return _react2.default.createElement(
	                            _reactBootstrap.MenuItem,
	                            { onClick: function onClick() {
	                                return handleLimitChange(el);
	                              } },
	                            el.label
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var height = (this.state.tableHeight + 70).toString();
	      var tableCollapseFix = { height: height };
	      var token = localStorage.getItem('token');
	      var excelUrl = _root_url.ROOT_URL + 'v1/customer/export/?Bearer=' + localStorage.getItem('token');
	      var memberCardURL = this.state.selectedRows.length && _root_url.ROOT_URL + 'v1/customer/print_member/' + this.state.selectedRows[0].Customer_id + '?Bearer=' + token;
	      var isEditable = false;
	      if (_root_url.isSY && this.state.selectedRows.length === 1) {
	        if (this.state.editableCustomer.findIndex(function (e) {
	          return e.Customer_id === _this7.state.selectedRows[0].Customer_id;
	        }) !== -1) {
	          isEditable = true;
	        }
	        if ((0, _permissions2.default)('edit_all_customer')) {
	          isEditable = true;
	        }
	      }
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customers' })
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { fluid: 'true', id: 'customers-page' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'manage_customers' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'position-relative mb0', style: tableCollapseFix },
	                  _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    { className: 'table-buttons', style: { display: 'flex' } },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'success',
	                        type: 'submit',
	                        onClick: function onClick(event) {
	                          _this7.clickNew(event);
	                        },
	                        disabled: !(0, _permissions2.default)('add_customer')
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'warning',
	                        type: 'button',
	                        onClick: function onClick(event) {
	                          _this7.setCurrentCustomer(event);
	                        },
	                        disabled: !this.state.selectedRows || this.state.selectedRows.length !== 1 || !(0, _permissions2.default)('change_customer') || _root_url.isSY && !isEditable
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'success',
	                        type: 'button',
	                        href: excelUrl
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-download' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'export' })
	                    ),
	                    _react2.default.createElement(
	                      _reactDropzone2.default,
	                      { onDrop: this.onDrop.bind(this), style: { 'padding-left': '5px' }, className: 'upload-button' },
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { bsStyle: 'primary', disabled: !(0, _permissions2.default)('add_customer') || this.props.isAttachingDocument },
	                        _react2.default.createElement('em', { className: 'fa ' + (this.props.isAttachingDocument ? 'fa-spinner fa-spin' : 'fa-file-text') }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'upload_import' }),
	                        ' (CSV)'
	                      )
	                    ),
	                    _root_url.isFBD && _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'success',
	                        type: 'button'
	                        // href={excelUrl}
	                        , disabled: this.state.selectedRows.length !== 1,
	                        onClick: function onClick() {
	                          _this7.setWebUserModalVisibility(true);
	                        }
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-user' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_web_user' })
	                    ),
	                    isEcity && _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'success',
	                        type: 'button',
	                        href: memberCardURL,
	                        disabled: !this.state.selectedRows || this.state.selectedRows.length !== 1
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-download' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'member_card' })
	                    )
	                  ),
	                  this.renderSearchFilter(),
	                  this.renderTable()
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(WebUserModal, {
	            isVisible: this.state.isWebUserModalVisible,
	            setModalVisibility: this.setWebUserModalVisibility,
	            selectedRows: this.state.selectedRows
	          })
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return Customers;
	}(_react.Component);
	
	Customers.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = Customers;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(WebUserModal, 'WebUserModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customers.jsx');
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customers.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customers.jsx');
	
	  __REACT_HOT_LOADER__.register(Customers, 'Customers', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customers.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/customers.jsx');
	}();

	;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _inputField = __webpack_require__(16);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentTermForm = function (_Component) {
	  _inherits(PaymentTermForm, _Component);
	
	  function PaymentTermForm() {
	    _classCallCheck(this, PaymentTermForm);
	
	    return _possibleConstructorReturn(this, (PaymentTermForm.__proto__ || Object.getPrototypeOf(PaymentTermForm)).apply(this, arguments));
	  }
	
	  _createClass(PaymentTermForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.resetCreatePaymentTerm();
	      this.props.resetEditPaymentTerm();
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      if (this.props.currentPaymentTerm) {
	        if (!this.checkPermission('change_paymentterm')) {
	          this.props.editPaymentTerm(formProps);
	        } else {
	          alert('You have no permission!');
	        }
	      } else {
	        this.props.createPaymentTerm(formProps);
	      }
	    }
	  }, {
	    key: 'checkPermission',
	    value: function checkPermission(permission) {
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          closePT = _props.closePT,
	          submitting = _props.submitting,
	          pristine = _props.pristine,
	          valid = _props.valid;
	
	      return _react2.default.createElement(
	        'form',
	        { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 6 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term_name' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'asteriksReq' },
	                  '*'
	                )
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: 'Name', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'term_days' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'asteriksReq' },
	                  '*'
	                )
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: 'TermDays', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'term_types' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'asteriksReq' },
	                  '*'
	                )
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: 'Termtype', component: _inputField.InputField })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: 'Description', component: _inputField.InputField })
	            )
	          )
	        ),
	        _react2.default.createElement(_reduxForm.Field, { name: 'PaymentTerm_id', component: 'input', type: 'text', className: 'form-control', style: { display: 'none' } }),
	        _react2.default.createElement(
	          'button',
	          {
	            action: 'submit',
	            className: 'btn btn-success buttonStyle',
	            disabled: submitting || pristine,
	            style: { marginTop: '25px', float: 'right' }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-save' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	        ),
	        this.props.isCreating || this.props.isEditing && _react2.default.createElement(_spinner2.default, null),
	        this.props.createError && _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger marginTopStyle' },
	          JSON.stringify(this.props.createError)
	        ),
	        this.props.editError && _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger marginTopStyle' },
	          JSON.stringify(this.props.editError)
	        )
	      );
	    }
	  }]);
	
	  return PaymentTermForm;
	}(_react.Component);
	
	var _default = PaymentTermForm;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PaymentTermForm, 'PaymentTermForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/paymentTermForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Customers/paymentTermForm.jsx');
	}();

	;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _GenericDatePicker = __webpack_require__(48);
	
	var _GenericDatePicker2 = _interopRequireDefault(_GenericDatePicker);
	
	var _cleanDates = __webpack_require__(22);
	
	var _keys = __webpack_require__(118);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _PrintIframe = __webpack_require__(63);
	
	var _PrintIframe2 = _interopRequireDefault(_PrintIframe);
	
	var _DispatchMap = __webpack_require__(162);
	
	var _DispatchMap2 = _interopRequireDefault(_DispatchMap);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _selection = __webpack_require__(21);
	
	var _dispatch_actions = __webpack_require__(53);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var timeOptions = [{
	  label: 'forenoon',
	  value: true
	}, {
	  label: 'afternoon',
	  value: false
	}];
	
	var _require = __webpack_require__(5),
	    _require$Draggable = _require.Draggable,
	    DraggableContainer = _require$Draggable.Container,
	    RowActionsCell = _require$Draggable.RowActionsCell,
	    DropTargetRowContainer = _require$Draggable.DropTargetRowContainer,
	    Selectors = _require.Data.Selectors;
	
	var DropDownEditor = _reactDataGridAddons.Editors.DropDownEditor;
	
	
	var RowRenderer = DropTargetRowContainer(_reactDataGrid2.default.Row);
	
	var propTypes = {
	  rowKey: _propTypes2.default.string,
	  value: _propTypes2.default.node,
	  stopsIsLoading: _propTypes2.default.bool,
	  routesIsLoading: _propTypes2.default.bool,
	  savingStopEdits: _propTypes2.default.bool,
	  routingPdfFailure: _propTypes2.default.bool,
	  assigningOrderRoute: _propTypes2.default.bool,
	  requestingRoutingPdf: _propTypes2.default.bool,
	  pickingListPdfFailure: _propTypes2.default.bool,
	  packingListPdfFailure: _propTypes2.default.bool,
	  salesInvoicePdfFailure: _propTypes2.default.bool,
	  requestingPickingListPdf: _propTypes2.default.bool,
	  requestingPackingListPdf: _propTypes2.default.bool,
	  unassignedOrdersIsLoading: _propTypes2.default.bool,
	  requestingDispatchSalesInvoicePdf: _propTypes2.default.bool,
	  routesError: _propTypes2.default.oneOfType([_propTypes2.default.shape({}), _propTypes2.default.bool]),
	  stopsError: _propTypes2.default.oneOfType([_propTypes2.default.shape({}), _propTypes2.default.bool]),
	  unassignedOrdersError: _propTypes2.default.shape({}),
	  routes: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  // stops: PropTypes.shape({
	  //   Active: PropTypes.arrayOf(
	  //     PropTypes.shape({
	  //       ActiveStopNum: PropTypes.number,
	  //       City: PropTypes.string,
	  //       CustomerNum: PropTypes.string,
	  //       Description: PropTypes.string,
	  //       IsActive: PropTypes.bool,
	  //       Name: PropTypes.string,
	  //     })
	  //   ),
	  //   DriverLocation: PropTypes.string,
	  //   Inactive: PropTypes.arrayOf(
	  //     PropTypes.shape({
	  //       // Same as active
	  //       StopNum: PropTypes.number,
	  //     })
	  //   ),
	  //   Warehouse: PropTypes.shape({
	  //     lat: PropTypes.number,
	  //     lng: PropTypes.number,
	  //   }),
	  // }),
	  dependentValues: _propTypes2.default.shape({
	    TempDate: _propTypes2.default.string
	  }),
	  unassignedOrders: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  routingPdf: _propTypes2.default.shape({}),
	  pickingListPdf: _propTypes2.default.shape({}),
	  packingListPdf: _propTypes2.default.shape({}),
	  dispatchSalesInvoicePdf: _propTypes2.default.shape({}),
	  remove: _propTypes2.default.func,
	  fetchStops: _propTypes2.default.func,
	  fetchRoutes: _propTypes2.default.func,
	  saveEditedStops: _propTypes2.default.func,
	  assignOrderRoute: _propTypes2.default.func,
	  printDispatchRoute: _propTypes2.default.func,
	  fetchUnassignedOrders: _propTypes2.default.func,
	  printDispatchPickingList: _propTypes2.default.func,
	  printDispatchPackingList: _propTypes2.default.func,
	  printDispatchSalesInvoice: _propTypes2.default.func
	};
	
	var defaultProps = {
	  value: null,
	  rowKey: 'ActiveStopNum',
	  stopsIsLoading: false,
	  routesIsLoading: false,
	  savingStopEdits: false,
	  routingPdfFailure: false,
	  assigningOrderRoute: false,
	  requestingRoutingPdf: false,
	  pickingListPdfFailure: false,
	  packingListPdfFailure: false,
	  salesInvoicePdfFailure: false,
	  requestingPickingListPdf: false,
	  requestingPackingListPdf: false,
	  unassignedOrdersIsLoading: false,
	  requestingDispatchSalesInvoicePdf: false,
	  stopsError: {},
	  routesError: {},
	  routes: [],
	  stops: {},
	  dependentValues: {},
	  unassignedOrders: [],
	  routingPdf: {},
	  pickingListPdf: {},
	  packingListPdf: {},
	  unassignedOrdersError: {},
	  dispatchSalesInvoicePdf: {},
	  remove: function remove() {},
	  fetchStops: function fetchStops() {},
	  fetchRoutes: function fetchRoutes() {},
	  saveEditedStops: function saveEditedStops() {},
	  assignOrderRoute: function assignOrderRoute() {},
	  printDispatchRoute: function printDispatchRoute() {},
	  fetchUnassignedOrders: function fetchUnassignedOrders() {},
	  printDispatchPickingList: function printDispatchPickingList() {},
	  printDispatchPackingList: function printDispatchPackingList() {},
	  printDispatchSalesInvoice: function printDispatchSalesInvoice() {}
	};
	
	var contextTypes = {
	  router: _propTypes2.default.shape({})
	};
	
	var AutoRouting = function (_Component) {
	  _inherits(AutoRouting, _Component);
	
	  function AutoRouting() {
	    _classCallCheck(this, AutoRouting);
	
	    var _this = _possibleConstructorReturn(this, (AutoRouting.__proto__ || Object.getPrototypeOf(AutoRouting)).call(this));
	
	    _this.onPDFIFrameLoaded = function () {
	      if (!_this.state.pdfFrameLoaded) {
	        var pdfFrame = window.frames.autRoutingPDFFrame;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this.setState({ pdfFrameLoaded: true });
	      }
	    };
	
	    _this.handleFetchDrivers = function () {
	      var startDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "1900-01-01T08:00:00.000Z";
	      var endDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "3000-01-02T07:59:59.999Z";
	
	      var handleSuccess = function handleSuccess(drivers) {
	        _this.setState({
	          drivers: drivers
	        });
	      };
	      var handleFailure = function handleFailure() {
	        _this.setState({
	          drivers: []
	        });
	      };
	      (0, _dispatch_actions.fetchDrivers)(startDate, endDate, handleSuccess, handleFailure);
	    };
	
	    _this.toggleGoogleMaps = function () {
	      _this.setState({ showGoogleMaps: !_this.state.showGoogleMaps });
	    };
	
	    _this.handlePickingListPrint = function () {
	      var selectedRows = _this.state.routes.selectedRows;
	
	
	      _this.props.printPickinglist(selectedRows[0].id);
	    };
	
	    _this.handlePickingListAllPrint = function () {
	      var selectedRows = _this.state.routes.selectedRows;
	
	
	      _this.props.printPickinglistAll(selectedRows[0].id);
	    };
	
	    _this.handleDeleteRouteClick = function () {
	      var selectedRows = _this.state.routes.selectedRows;
	
	      var success = function success() {
	        _this.setState({
	          routes: _extends({}, _this.state.routes, {
	            selectedRows: []
	          }),
	          RouteId: null
	        }, function () {
	          _this.props.fetchAutoRouteStops(null);
	          _this.handleCheckRouteClick();
	        });
	      };
	      (0, _dispatch_actions.deleteRoute)(selectedRows[0].id, success);
	    };
	
	    _this.setRouteDateChosen = function (routeDateChosen) {
	      return _this.setState({ routeDateChosen: routeDateChosen });
	    };
	
	    _this.handleGenerateRouteClick = function (form) {
	      var MaxTotalHours = form.MaxTotalHours,
	          RouteCounts = form.RouteCounts,
	          ServiceMinutes = form.ServiceMinutes,
	          IsForenoon = form.IsForenoon;
	
	      _this.setState({
	        isGeneratingRoutes: true
	      });
	      if (isNaN(parseInt(MaxTotalHours)) || isNaN(parseInt(RouteCounts)) || isNaN(parseInt(ServiceMinutes))) {
	        alert('Integer only');
	        return;
	      }
	      var routeDateChosen = _this.state.routeDateChosen;
	
	      var _getFromToDates = (0, _cleanDates.getFromToDates)(routeDateChosen),
	          fromDate = _getFromToDates.fromDate,
	          toDate = _getFromToDates.toDate;
	
	      if (!fromDate || !toDate || fromDate > toDate) {
	        alert(_reactReduxI18n.I18n.t('please_select_a_start_date_that_is_before_the_end_date'));
	        return;
	      }
	
	      var newForm = {
	        MaxTotalHours: parseInt(MaxTotalHours),
	        RouteCounts: parseInt(RouteCounts),
	        ServiceMinutes: parseInt(ServiceMinutes),
	        IsForenoon: IsForenoon.value
	      };
	      newForm['startDateGenerate'] = fromDate;
	      newForm['endDateGenerate'] = toDate;
	
	      var success = function success() {
	        alert('Success!');
	        _this.setGenerateRouteModalVisibility(false);
	        _this.setState({
	          isGeneratingRoutes: false
	        });
	        _this.handleCheckRouteClick();
	      };
	      var fail = function fail() {
	        _this.setState({
	          isGeneratingRoutes: false
	        });
	      };
	      _this.props.generateRoute(newForm, success, fail);
	    };
	
	    _this.handleCheckRouteClick = function () {
	      var routeDateChosen = _this.state.routeDateChosen;
	
	      var _getFromToDates2 = (0, _cleanDates.getFromToDates)(routeDateChosen),
	          fromDate = _getFromToDates2.fromDate,
	          toDate = _getFromToDates2.toDate;
	
	      if (!fromDate || !toDate || fromDate > toDate) {
	        alert(_reactReduxI18n.I18n.t('please_select_a_start_date_that_is_before_the_end_date'));
	        return;
	      }
	
	      _this.props.fetchAutoRoutes(fromDate, toDate);
	    };
	
	    _this.setStopFormModalVisibility = function () {
	      var stopsFormModalVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this.setState({ stopsFormModalVisible: stopsFormModalVisible });
	    };
	
	    _this.setStopDeleteModalVisibility = function () {
	      var stopsDeleteFormModalVisibility = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this.setState({ stopsDeleteFormModalVisibility: stopsDeleteFormModalVisibility });
	    };
	
	    _this.setAssignDriverModalVisibility = function () {
	      var assignDriverModalVisibility = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this.setState({ assignDriverModalVisibility: assignDriverModalVisibility });
	    };
	
	    _this.setGenerateRouteModalVisibility = function () {
	      var generateRouteModalVisibility = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this.setState({ generateRouteModalVisibility: generateRouteModalVisibility });
	    };
	
	    _this.stopFormValidation = function (form) {
	      var error = [];
	      if (!form.OrderNo) {
	        error.push('missing sales order number');
	      }
	      if (!form.StopIndex) {
	        error.push('missing target stop index');
	      }
	      return error;
	    };
	
	    _this.handleFormSubmit = function (form) {
	      var error = _this.stopFormValidation(form);
	      if (error.length) {
	        alert(_reactReduxI18n.I18n.t('form_not_valid'));
	        return;
	      }
	
	      // routeId, method, data, callback
	      var success = function success() {
	        _this.props.reset();
	        _this.setStopFormModalVisibility(false);
	        _this.props.fetchAutoRouteStops(_this.state.RouteId);
	      };
	
	      var payload = {
	        routeId: _this.state.RouteId,
	        data: form,
	        method: 'add',
	        callback: function callback() {
	          success();
	        }
	      };
	      _this.props.updateStopsOfAutoRoutes(payload);
	    };
	
	    _this.handleStopDeleteSubmit = function (form) {
	      var StopIds = [];
	      if (!form.deleteStopIndex || !_this.state.activeStops.rows[form.deleteStopIndex - 1]) {
	        alert("Input iindex is not valid");
	        return;
	      }
	      var id = _this.state.activeStops.rows[form.deleteStopIndex - 1].id;
	      StopIds.push(id);
	      var success = function success() {
	        _this.props.reset();
	        _this.setStopDeleteModalVisibility(false);
	        _this.props.fetchAutoRouteStops(_this.state.RouteId);
	      };
	      var payload = {
	        routeId: _this.state.routes.selectedRows[0].RouteId,
	        data: { StopIds: StopIds },
	        method: 'remove',
	        callback: function callback() {
	          success();
	        }
	      };
	      _this.props.updateStopsOfAutoRoutes(payload);
	    };
	
	    _this.assignDriver = function () {
	      _this.props.change('route_id', _this.state.RouteId);
	      _this.props.change('Driver_id', _this.state.routes.selectedRows[0].DriverId);
	      _this.setAssignDriverModalVisibility(true);
	    };
	
	    _this.handleAssignDriverSubmit = function (form) {
	      if (!form.Driver_id || !form.route_id) {
	        alert('Form not valid');
	        return;
	      }
	      var success = function success() {
	        _this.setAssignDriverModalVisibility(false);
	        _this.handleCheckRouteClick();
	      };
	      var fail = function fail() {
	        alert('Error updating routes');
	      };
	      var payload = {
	        Route_id: form.route_id.value || form.route_id,
	        Driver_id: form.Driver_id.value || form.Driver_id
	      };
	      (0, _dispatch_actions.assignDriverToRoute)(payload, success, fail);
	    };
	
	    _this.generateRoutesOptions = function () {
	      if (_this.state.routes.rows) {
	        return _this.state.routes.rows.map(function (route) {
	          return {
	            label: route.RouteName,
	            value: route.id
	          };
	        });
	      }
	      return [];
	    };
	
	    _this.generateDriverOptions = function () {
	      if (_this.state.drivers) {
	        return _this.state.drivers.map(function (driver) {
	          return {
	            label: driver.name,
	            value: driver.id
	          };
	        });
	      }
	      return [];
	    };
	
	    _this.renderModals = function () {
	      var createDialogStyle = {
	        width: '550px',
	        height: '400px',
	        marginLeft: '-15%'
	      };
	      var handleSubmit = _this.props.handleSubmit;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogStyle,
	            isVisible: _this.state.stopsFormModalVisible,
	            onCloseClicked: function onCloseClicked() {
	              _this.props.reset();
	              _this.setStopFormModalVisibility(false);
	            }
	          },
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            null,
	            _react2.default.createElement(
	              'form',
	              {
	                method: 'get',
	                action: '#',
	                onSubmit: handleSubmit(_this.handleFormSubmit)
	              },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'stop_form' })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 6 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_number' })
	                    ),
	                    _react2.default.createElement(_reduxForm.Field, { name: 'OrderNo', component: _inputField2.default })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 6 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'stop_index' })
	                    ),
	                    _react2.default.createElement(_reduxForm.Field, { name: 'StopIndex', component: _inputField2.default })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'success',
	                    type: 'submit',
	                    onClick: function onClick(event) {
	                      handleSubmit(_this.handleFormSubmit);
	                    },
	                    disabled: false
	                  },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Add' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'primary',
	                    type: 'submit',
	                    onClick: function onClick(event) {
	                      _this.props.reset();
	                      _this.setStopFormModalVisibility(false);
	                    },
	                    disabled: false
	                  },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogStyle,
	            isVisible: _this.state.stopsDeleteFormModalVisibility,
	            onCloseClicked: _this.setStopDeleteModalVisibility
	          },
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            null,
	            _react2.default.createElement(
	              'form',
	              {
	                method: 'get',
	                action: '#',
	                onSubmit: handleSubmit(_this.handleStopDeleteSubmit)
	              },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete_stop' })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 6 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'stop_index_position' })
	                    ),
	                    _react2.default.createElement(_reduxForm.Field, { name: 'deleteStopIndex', component: _inputField2.default })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'danger',
	                    type: 'submit',
	                    onClick: function onClick(event) {
	                      handleSubmit(_this.handleStopDeleteSubmit);
	                    },
	                    disabled: false
	                  },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'primary',
	                    type: 'submit',
	                    onClick: function onClick(event) {
	                      _this.props.reset();
	                      _this.setStopDeleteModalVisibility(false);
	                    },
	                    disabled: false
	                  },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogStyle,
	            isVisible: _this.state.assignDriverModalVisibility,
	            onCloseClicked: _this.setAssignDriverModalVisibility
	          },
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            null,
	            _react2.default.createElement(
	              'form',
	              {
	                method: 'get',
	                action: '#',
	                onSubmit: handleSubmit(_this.handleAssignDriverSubmit)
	              },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'assign_driver' })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 6 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'route_name' })
	                    ),
	                    _react2.default.createElement(_reduxForm.Field, {
	                      name: 'route_id',
	                      component: _selection.Selection,
	                      options: _this.generateRoutesOptions()
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 6 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'stop_index_position' })
	                    ),
	                    _react2.default.createElement(_reduxForm.Field, {
	                      name: 'Driver_id',
	                      component: _selection.Selection,
	                      options: _this.generateDriverOptions()
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'success',
	                    type: 'submit',
	                    onClick: function onClick(event) {
	                      handleSubmit(_this.handleAssignDriverSubmit);
	                    },
	                    disabled: false
	                  },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'assign' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'primary',
	                    type: 'submit',
	                    onClick: function onClick(event) {
	                      _this.props.reset();
	                      _this.setAssignDriverModalVisibility(false);
	                    },
	                    disabled: false
	                  },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogStyle,
	            isVisible: _this.state.generateRouteModalVisibility,
	            onCloseClicked: _this.setGenerateRouteModalVisibility
	          },
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            null,
	            _react2.default.createElement(
	              'form',
	              {
	                method: 'get',
	                action: '#',
	                onSubmit: handleSubmit(_this.handleGenerateRouteClick)
	              },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'generate_route' })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 6 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'route_counts' })
	                    ),
	                    _react2.default.createElement(_reduxForm.Field, { name: 'RouteCounts', component: _inputField2.default, initialValue: 6 })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 6 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'max_total_hours' })
	                    ),
	                    _react2.default.createElement(_reduxForm.Field, { name: 'MaxTotalHours', component: _inputField2.default, initialValue: 8 })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 6 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'service_minutes' })
	                    ),
	                    _react2.default.createElement(_reduxForm.Field, { name: 'ServiceMinutes', component: _inputField2.default })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 6 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'time' })
	                    ),
	                    _react2.default.createElement(_reduxForm.Field, { name: 'IsForenoon', component: _selection.Selection, options: timeOptions })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'success',
	                    type: 'submit',
	                    onClick: function onClick(event) {
	                      handleSubmit(_this.handleGenerateRouteClick);
	                    },
	                    disabled: _this.state.isGeneratingRoutes
	                  },
	                  _this.state.isGeneratingRoutes ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'generating' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'generate' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'primary',
	                    type: 'submit',
	                    onClick: function onClick(event) {
	                      _this.props.reset();
	                      _this.setGenerateRouteModalVisibility(false);
	                    },
	                    disabled: false
	                  },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	                )
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      routeOptions: [],
	
	      routes: {
	        rows: [],
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	      activeStops: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null,
	        selectedRowIdx: null
	      },
	      inactiveStops: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      orders: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null,
	        filters: null,
	        filteredRows: [],
	        selectedRow: null,
	        editedRows: []
	      },
	
	      RouteId: null,
	      tabKey: 1,
	      routePdfFrameLoaded: true,
	      pickingListPdfFrameLoaded: true,
	      packingListPdfFrameLoaded: true,
	      salesInvoicePdfFrameLoaded: true,
	
	      showGoogleMaps: false,
	      centerCoordinates: {
	        lat: 34.019733,
	        lng: -117.958672
	      },
	
	      routeDateChosen: new Date(),
	
	      isOverLayLoadingActive: false,
	
	      stopsFormData: {
	        orderNo: '',
	        StopIndex: null
	      }, // abort
	      stopsFormModalVisible: false,
	      stopsDeleteFormModalVisibility: false,
	      assignDriverModalVisibility: false,
	      generateRouteModalVisibility: false,
	
	      pdfFrameLoaded: true
	    };
	
	    _this.setRouteDateChosen = _this.setRouteDateChosen.bind(_this);
	    return _this;
	  }
	
	  _createClass(AutoRouting, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.handleFetchDrivers();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.routes && nextProps.routes !== this.props.routes) {
	        var newRoutes = _lodash2.default.cloneDeep(nextProps.routes);
	        var routes = {
	          rows: newRoutes,
	          selectedRows: [],
	          sortColumn: null,
	          sortDirection: null
	        };
	        this.setState({ routes: routes });
	      }
	
	      if (nextProps.stops && nextProps.stops !== this.props.stops) {
	        // const centerCoordinates = nextProps.stops.Warehouse;
	        var activeStops = {
	          rows: [].concat(_toConsumableArray(nextProps.stops)),
	          sortColumn: null,
	          sortDirection: null,
	          selectedRow: null
	        };
	
	        this.setState({ activeStops: activeStops });
	      }
	
	      if (nextProps.pdfFile && nextProps.pdfFile !== this.props.pdfFile) {
	        this.setState({ pdfFrameLoaded: false });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextState) {
	      if (nextState.pdfFrameLoaded !== this.state.pdfFrameLoaded && this.state.pdfFrameLoaded === false) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'renderPDFIFrame',
	    value: function renderPDFIFrame() {
	      if (this.props.pdfFile) {
	        var file = window.URL.createObjectURL(this.props.pdfFile);
	        return _react2.default.createElement('iframe', {
	          style: { display: "none" },
	          onLoad: this.onPDFIFrameLoaded,
	          id: 'autRoutingPDFFrame',
	          name: 'autRoutingPDFFrame',
	          src: file
	        });
	      }
	    }
	  }, {
	    key: 'handleTabSelect',
	    value: function handleTabSelect(tabKey) {
	      this.setState({ tabKey: tabKey });
	    }
	  }, {
	    key: 'removeRow',
	    value: function removeRow(dependentValues) {
	      var rows = [].concat(_toConsumableArray(this.state.activeStops.rows));
	      rows = rows.filter(function (row) {
	        var match = row.ActiveStopNum !== dependentValues.ActiveStopNum;
	        return match;
	      });
	      rows.map(function (row, index) {
	        row.ActiveStopNum = index + 1;
	      });
	      var activeStops = _extends({}, this.state.activeStops, { rows: rows });
	      this.setState({ activeStops: activeStops });
	    }
	  }, {
	    key: 'renderRoutes',
	    value: function renderRoutes() {
	      var _this2 = this;
	
	      if (this.props.routesIsLoading && !this.props.routesError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.routesError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger', id: 'dispatch-errors' },
	            JSON.stringify(this.props.routesError)
	          )
	        );
	      }
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.routes);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var routes = _extends({}, _this2.state.routes, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this2.setState({ routes: routes });
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        var rows = _this2.state.routes.rows.slice(0);
	        Object.assign(rows[e.rowIdx], e.updated);
	        var routes = _extends({}, _this2.state.routes, { rows: rows });
	        _this2.setState({ routes: routes });
	      };
	
	      var onCellSelected = function onCellSelected(coordinates) {
	        var newRows = getRows();
	        if (_this2.state.routes.selectedRows[0] === newRows[coordinates.rowIdx]) {
	          return;
	        }
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        var selectedRows = [newRows[coordinates.rowIdx]];
	        newRows[coordinates.rowIdx].isSelected = true;
	        var routes = _extends({}, _this2.state.routes, { rows: newRows, selectedRows: selectedRows });
	        _this2.setState({
	          routes: routes,
	          RouteId: newRows[coordinates.rowIdx].id
	        }, function () {
	          _this2.props.fetchAutoRouteStops(_this2.state.RouteId);
	        });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var selectedRows = [];
	        if (_this2.state.routes.selectedRows[0] === rows[0]) {
	          return;
	        }
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	          selectedRows.push(r.row);
	        });
	        var routes = _extends({}, _this2.state.routes, { rows: newRows, selectedRows: selectedRows });
	        _this2.setState({
	          routes: routes,
	          RouteId: rows[0].row.id
	        }, function () {
	          _this2.props.fetchAutoRouteStops(_this2.state.RouteId);
	        });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = getRows();
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        var routes = _extends({}, _this2.state.routes, { rows: newRows, selectedRows: [] });
	        _this2.setState({
	          routes: routes
	          // RouteId: 0,
	        }, function () {
	          // this.props.fetchAutoRouteStops(this.state.RouteId);
	        });
	      };
	
	      var columns = [{
	        key: 'RouteName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'route_name' }),
	        resizable: true,
	        filterable: true
	      }, {
	        key: 'RoutedStopsCount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'stop_counts' }),
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'TotalItemsCount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'item_count' }),
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'TotalMiles',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_miles' }),
	        resizable: true,
	        sortable: true
	      }, {
	        key: 'DriverFirstName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'driver_name' }),
	        resizable: true,
	        sortable: true
	      }, {
	        key: 'TotalServiceMinutes',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'service_mins' }),
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }];
	      var orderPoints = this.state.activeStops.rows.map(function (stop) {
	        return {
	          ActiveStopNum: stop.StopIndex,
	          lat: stop.LatitudeY,
	          lng: stop.LongitudeX,
	          deliver_eta_info: {
	            duration_text: stop.EtaUTC
	          },
	          details: stop
	        };
	      });
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        this.state.showGoogleMaps ? _react2.default.createElement(_DispatchMap2.default, {
	          isMarkerShown: !_lodash2.default.isEmpty(this.state.activeStops.rows),
	          orderPoints: orderPoints,
	          driverLocation: this.props.stops.DriverLocation,
	          centerCoordinates: this.state.centerCoordinates,
	          googleMapURL: 'https://maps.googleapis.com/maps/api/js?key=' + _keys.__GAPI_KEY__ + '&v=3.exp&libraries=geometry,drawing,places',
	          loadingElement: _react2.default.createElement('div', { style: { height: '100%' } }),
	          containerElement: _react2.default.createElement('div', { style: { height: '300px' } }),
	          mapElement: _react2.default.createElement('div', { style: { height: '100%' } })
	        }) : _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { id: 'Routing-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'DispatchRoute_id',
	              onGridSort: handleGridSort,
	              columns: columns,
	              rowHeight: 25,
	              headerRowHeight: 50,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: 295,
	              onRowUpdated: handleRowUpdated,
	              enableRowSelect: 'single',
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              },
	              onCellSelected: onCellSelected
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderStops',
	    value: function renderStops() {
	      var _this3 = this;
	
	      if (this.props.stopsIsLoading && !this.props.stopsError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.stopsError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger', id: 'dispatch-errors' },
	            JSON.stringify(this.props.stopsError)
	          )
	        );
	      }
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.tabKey === 1 ? _this3.state.activeStops : _this3.state.inactiveStops);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        if (_this3.state.tabKey === 1) {
	          var stops = _extends({}, _this3.state.activeStops, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this3.setState({ activeStops: stops });
	        } else {
	          var _stops = _extends({}, _this3.state.inactiveStops, {
	            sortColumn: sortColumn,
	            sortDirection: sortDirection
	          });
	          _this3.setState({ inactiveStops: _stops });
	        }
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        if (_this3.state.tabKey === 1) {
	          var rows = _this3.state.activeStops.rows.slice(0);
	          Object.assign(rows[e.rowIdx], e.updated);
	          var stops = _extends({}, _this3.state.activeStops, { rows: rows });
	          _this3.setState({ activeStops: stops });
	        } else {
	          var _rows = _this3.state.inactiveStops.rows.slice(0);
	          Object.assign(_rows[e.rowIdx], e.updated);
	          var _stops2 = _extends({}, _this3.state.inactiveStops, { rows: _rows });
	          _this3.setState({ inactiveStops: _stops2 });
	        }
	      };
	
	      var isDraggedRowSelected = function isDraggedRowSelected(selectedRows, rowDragSource) {
	        if (selectedRows && selectedRows.length > 0) {
	          var key = _this3.props.rowKey;
	          return selectedRows.filter(function (r) {
	            return r[key] === rowDragSource.data[key];
	          }).length > 0;
	        }
	        return false;
	      };
	
	      var reorderRows = function reorderRows(e) {
	        var selectedRows = Selectors.getSelectedRowsByKey({
	          rowKey: _this3.props.rowKey,
	          selectedKeys: [],
	          rows: _this3.state.activeStops.rows
	        });
	        var draggedRows = isDraggedRowSelected(selectedRows, e.rowSource) ? selectedRows : [e.rowSource.data];
	        var undraggedRows = _this3.state.activeStops.rows.filter(function (r) {
	          return draggedRows.indexOf(r) === -1;
	        });
	        var args = [e.rowTarget.idx, 0].concat(draggedRows);
	        Array.prototype.splice.apply(undraggedRows, args);
	        undraggedRows.map(function (row, index) {
	          row.ActiveStopNum = index + 1;
	        });
	        var activeStops = _extends({}, _this3.state.activeStops, { rows: undraggedRows });
	        var data = {
	          stops: [{
	            id: e.rowSource.data.id,
	            index: e.rowTarget.data.StopIndex
	          }, {
	            id: e.rowTarget.data.id,
	            index: e.rowSource.data.StopIndex
	          }]
	        };
	
	        _this3.props.changeStopIndex(data, function () {
	          _this3.setState({ activeStops: activeStops });
	        });
	      };
	
	      var DeleteFormatter = _react2.default.createClass({
	        displayName: 'DeleteFormatter',
	        render: function render() {
	          var _this4 = this;
	
	          if (this.props.dependentValues.TempDate) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  className: 'textAlignStyle',
	                  style: { height: '23px', width: '39px', padding: '0px' },
	                  onClick: function onClick() {
	                    _this4.props.remove(_this4.props.dependentValues);
	                  }
	                },
	                'X'
	              )
	            );
	          }
	          return _react2.default.createElement('div', null);
	        }
	      });
	
	      var TimeFormatter = _react2.default.createClass({
	        displayName: 'TimeFormatter',
	        render: function render() {
	          return this.props.value ? _react2.default.createElement(
	            'span',
	            null,
	            (0, _cleanDates.convertLocalDate)(this.props.value, "h:mm A")
	          ) : _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var handleRowClick = function handleRowClick(rowIdx, row) {
	        _this3.setState({
	          activeStops: _extends({}, _this3.state.activeStops, {
	            selectedRowIdx: rowIdx
	          })
	        });
	      };
	
	      var columns = [{
	        key: 'OrderNo',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_num' }),
	        width: 95,
	        resizable: true
	      }, {
	        key: 'EtaUTC',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'eta' }),
	        width: 130,
	        resizable: true
	      }, {
	        key: 'EtdUTC',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'etd' }),
	        width: 130,
	        resizable: true
	      }, {
	        key: 'Address',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' }),
	        width: 215,
	        resizable: true
	      }];
	
	      if (this.state.tabKey === 1) {
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              DraggableContainer,
	              null,
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: this.props.rowKey,
	                onGridSort: handleGridSort,
	                rowActionsCell: RowActionsCell,
	                columns: columns,
	                rowHeight: 25,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                handleRowC: true,
	                enableRowSelect: 'single',
	                rowRenderer: _react2.default.createElement(RowRenderer, { onRowDrop: reorderRows }),
	                minHeight: 300,
	                onRowUpdated: handleRowUpdated,
	                onRowClick: handleRowClick
	              })
	            )
	          )
	        );
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { id: 'Routing-dataGrid2' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'Product_id',
	              onGridSort: handleGridSort,
	              columns: columns,
	              rowHeight: 25,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: 300,
	              onRowUpdated: handleRowUpdated
	            })
	          )
	        )
	      );
	    }
	
	    // Date Filter helper functions start
	
	    // Date Filter helper functions end
	
	    // Modals and modal helper functions
	
	  }, {
	    key: 'renderExportRouteButtons',
	    value: function renderExportRouteButtons() {
	      var _state = this.state,
	          routes = _state.routes,
	          routeDateChosen = _state.routeDateChosen;
	
	      var id = '';
	      if (routes.selectedRows.length) {
	        id = routes.selectedRows[0].id;
	      }
	
	      var _getFromToDates3 = (0, _cleanDates.getFromToDates)(routeDateChosen),
	          fromDate = _getFromToDates3.fromDate,
	          toDate = _getFromToDates3.toDate;
	
	      var token = localStorage.getItem('token');
	      var exportRouteUrl = _root_url.ROOT_URL + 'v1/dispatch/export-routes?RouteId=' + id + '&StartDeliveryDate=' + fromDate + '&EndDeliveryDate=' + toDate + '&Bearer=' + token;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          className: 'toggle-maps-button',
	          bsStyle: 'success',
	          href: exportRouteUrl,
	          disabled: this.state.routeDateChosen === undefined,
	          onClick: this.exportRoute
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'export_route' })
	      );
	    }
	  }, {
	    key: 'render',
	
	    // Modals and modal helper functions end
	    value: function render() {
	      var _this5 = this;
	
	      var change = this.props.change;
	
	      return (
	        //---------------
	        // Begin HTML: Create New/Edit routing
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'routing' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'dispatch-routing' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { style: { height: '100px' } },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 2 },
	                      _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', flexDirection: 'row' } },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'label-and-date-picker' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'time' }),
	                          ':\xA0',
	                          _react2.default.createElement(_GenericDatePicker2.default, {
	                            setDate: this.setRouteDateChosen,
	                            onChange: this.setRouteDateChosen,
	                            selectedDate: this.state.routeDateChosen
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 10 },
	                      _react2.default.createElement(_SpinnerButton2.default, {
	                        bsStyle: 'primary',
	                        onClick: function onClick() {
	                          return _this5.handleCheckRouteClick();
	                        },
	                        icon: 'fa-search',
	                        translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check_route' }),
	                        disabled: false
	                      }),
	                      '\xA0',
	                      _react2.default.createElement(_SpinnerButton2.default, {
	                        bsStyle: 'primary',
	                        onClick: function onClick() {
	                          return _this5.setGenerateRouteModalVisibility(true);
	                        },
	                        loading: this.props.buttonLoadingVisible,
	                        icon: 'fa-map',
	                        translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'generate_route' }),
	                        disabled: this.props.buttonLoadingVisible
	                      }),
	                      _react2.default.createElement(
	                        'span',
	                        {
	                          style: {
	                            color: 'red',
	                            fontSize: '12px',
	                            marginLeft: '4px'
	                          }
	                        },
	                        'This action will take approx. 1 min.'
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { style: { height: '400px' } },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 1 },
	                      _react2.default.createElement(
	                        'h3',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'route_details' })
	                      )
	                    ),
	                    this.renderExportRouteButtons(),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        className: 'toggle-maps-button',
	                        bsStyle: 'success',
	                        disabled: this.state.routes.selectedRows.length !== 1,
	                        onClick: this.assignDriver
	                      },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'assign_driver' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        className: 'toggle-maps-button',
	                        bsStyle: 'primary',
	                        onClick: this.toggleGoogleMaps
	                      },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'toggle_map' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        className: 'toggle-maps-button',
	                        bsStyle: 'primary',
	                        style: { paddingRight: '5px' },
	                        disabled: this.state.routes.selectedRows.length !== 1,
	                        onClick: this.handleDeleteRouteClick
	                      },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete_route' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        className: 'toggle-maps-button',
	                        bsStyle: 'primary',
	                        style: { paddingRight: '5px' },
	                        disabled: this.state.routes.selectedRows.length !== 1,
	                        onClick: this.handlePickingListPrint
	                      },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'picking_list' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        className: 'toggle-maps-button',
	                        bsStyle: 'primary',
	                        style: { paddingRight: '5px' },
	                        disabled: this.state.routes.selectedRows.length !== 1,
	                        onClick: this.handlePickingListAllPrint
	                      },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all_picking' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 12 },
	                      this.renderRoutes()
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { style: { height: '400px' } },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 6 },
	                      _react2.default.createElement(
	                        'h3',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'stop_details' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        className: 'toggle-maps-button',
	                        bsStyle: 'success',
	                        type: 'submit',
	                        onClick: function onClick(event) {
	                          var StopIndex = _this5.state.activeStops.selectedRowIdx ? _this5.state.activeStops.selectedRowIdx + 1 : '1';
	                          _this5.props.change('StopIndex', StopIndex);
	                          _this5.setStopFormModalVisibility(true);
	                        },
	                        disabled: !this.state.routes.selectedRows.length
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_stop' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        className: 'toggle-maps-button',
	                        bsStyle: 'danger',
	                        type: 'submit',
	                        onClick: function onClick(event) {
	                          var deleteStopIndex = _this5.state.activeStops.selectedRowIdx ? _this5.state.activeStops.selectedRowIdx + 1 : '1';
	                          _this5.props.change('deleteStopIndex', deleteStopIndex);
	                          _this5.setStopDeleteModalVisibility(true);
	                        },
	                        disabled: !this.state.routes.selectedRows.length
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-trash' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete_stop' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 12 },
	                      this.renderStops()
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          this.renderPDFIFrame(),
	          this.renderModals()
	        )
	      );
	    }
	  }]);
	
	  return AutoRouting;
	}(_react.Component);
	
	AutoRouting.propTypes = propTypes;
	AutoRouting.defaultProps = defaultProps;
	AutoRouting.contextTypes = contextTypes;
	
	var _default = AutoRouting;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(timeOptions, 'timeOptions', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/AutoRouting.jsx');
	
	  __REACT_HOT_LOADER__.register(DropDownEditor, 'DropDownEditor', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/AutoRouting.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/AutoRouting.jsx');
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/AutoRouting.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/AutoRouting.jsx');
	
	  __REACT_HOT_LOADER__.register(contextTypes, 'contextTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/AutoRouting.jsx');
	
	  __REACT_HOT_LOADER__.register(AutoRouting, 'AutoRouting', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/AutoRouting.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/AutoRouting.jsx');
	}();

	;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _map = __webpack_require__(55);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _cloneDeep = __webpack_require__(124);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _numberWithCommas = __webpack_require__(35);
	
	var _GenericDatePicker = __webpack_require__(48);
	
	var _GenericDatePicker2 = _interopRequireDefault(_GenericDatePicker);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _dispatch_actions = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  value: _propTypes2.default.node,
	  checkPermissionSuccess: _propTypes2.default.boolean,
	  checkPermission: _propTypes2.default.func
	};
	
	var defaultProps = {
	  value: null,
	  checkPermissionSuccess: false,
	  checkPermission: function checkPermission() {}
	};
	
	var Drivers = function (_Component) {
	  _inherits(Drivers, _Component);
	
	  function Drivers(props) {
	    _classCallCheck(this, Drivers);
	
	    var _this = _possibleConstructorReturn(this, (Drivers.__proto__ || Object.getPrototypeOf(Drivers)).call(this, props));
	
	    _this.setStartDate = function (e) {
	      if (_this.state.startDateSelected && e < _this.state.startDateSelected) {
	        alert(_reactReduxI18n.I18n.t('please_select_a_start_date_that_is_before_the_end_date'));
	        return;
	      }
	      _this.setState({ startDate: e }, function () {
	        var endDate = _this.state.endDate;
	
	        _this.handleFetchDrivers(e, endDate);
	      });
	    };
	
	    _this.setEndDate = function (e) {
	      if (_this.state.endDateSelected && e > _this.state.endDateSelected) {
	        alert(_reactReduxI18n.I18n.t('please_select_an_end_date_that_is_after_the_start_date'));
	        return;
	      }
	      _this.setState({ endDate: e }, function () {
	        var startDate = _this.state.startDate;
	
	        _this.handleFetchDrivers(startDate, e);
	      });
	    };
	
	    _this.openPermissionModal = function () {
	      _this.setState({ isPermissionModalOpen: true });
	    };
	
	    _this.closePermissionModal = function () {
	      _this.setState({ isPermissionModalOpen: false });
	    };
	
	    _this.openDeliveryFeeModal = function () {
	      _this.setState({ isDeliveryFeeModalOpen: true });
	    };
	
	    _this.closeDeliveryFeeModal = function () {
	      _this.setState({ isDeliveryFeeModalOpen: false });
	    };
	
	    _this.openInviteModal = function () {
	      _this.setState({ isInviteModalOpen: true });
	    };
	
	    _this.closeInviteModal = function () {
	      _this.setState({ isInviteModalOpen: false });
	    };
	
	    _this.handleFetchDrivers = function (startDate, endDate) {
	      var handleSuccess = function handleSuccess(drivers) {
	        var selectedDriverIdx = _this.state.selectedDriverIdx;
	
	        var deliveryHistoryRows = void 0;
	        var deliveryHistory = (0, _cloneDeep2.default)(_this.state.deliveryHistory);
	        if (selectedDriverIdx !== null) {
	          (0, _map2.default)(drivers, function (row, index) {
	            if (index === selectedDriverIdx) {
	              deliveryHistoryRows = row.salesOrders;
	              row.isSelected = true;
	            }
	          });
	        }
	        deliveryHistory = _extends({}, _this.state.deliveryHistory, {
	          rows: deliveryHistoryRows
	        });
	        var driversList = _extends({}, _this.state.driversList, { rows: drivers });
	        _this.setState({
	          driversList: driversList,
	          deliveryHistory: deliveryHistory,
	          isLoadingDrivers: false
	        });
	      };
	      var handleFailure = function handleFailure() {
	        _this.setState({ isLoadingDrivers: false });
	      };
	      _this.setState({ isLoadingDrivers: true }, function () {
	        (0, _dispatch_actions.fetchDrivers)(startDate, endDate, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.handleFetchDriverCodes = function () {
	      var handleSuccess = function handleSuccess(_ref) {
	        var internalCode = _ref.internalCode,
	            externalCode = _ref.externalCode;
	
	        _this.setState({
	          internalCode: internalCode,
	          externalCode: externalCode
	        });
	      };
	      (0, _dispatch_actions.fetchDriverCodes)(handleSuccess, function () {});
	    };
	
	    _this.handleFetchDeliveryFee = function () {
	      var handleSuccess = function handleSuccess(response) {
	        (0, _map2.default)(response, function (data) {
	          var driverFeeRate = data.driverFeeRate,
	              truckxiFeeRate = data.truckxiFeeRate;
	
	          _this.setState({
	            driverFeeRate: driverFeeRate,
	            truckxiFeeRate: truckxiFeeRate
	          });
	        });
	      };
	      (0, _dispatch_actions.fetchDeliveryFee)(handleSuccess, function () {});
	    };
	
	    _this.handleSaveDeliveryFees = function () {
	      var handleSuccess = function handleSuccess() {
	        _this.setState({ isLoadingSaveDeliveryFees: false }, function () {
	          _this.closeDeliveryFeeModal();
	        });
	      };
	      var handleFailure = function handleFailure(error) {
	        _this.setState({ isLoadingSaveDeliveryFees: false });
	        alert(JSON.stringify(error.data.message));
	      };
	      var _this$state = _this.state,
	          driverFeeRate = _this$state.driverFeeRate,
	          truckxiFeeRate = _this$state.truckxiFeeRate;
	
	      _this.setState({ isLoadingSaveDeliveryFees: true }, function () {
	        (0, _dispatch_actions.saveDeliveryFees)(driverFeeRate, truckxiFeeRate, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.handleSendDriverInvite = function () {
	      var _this$state2 = _this.state,
	          email = _this$state2.email,
	          isExternal = _this$state2.isExternal;
	
	      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
	        alert(_reactReduxI18n.I18n.t('please_enter_a_valid_email'));
	        return;
	      }
	      var handleSuccess = function handleSuccess() {
	        _this.setState({
	          email: '',
	          isLoadingSendInvite: false
	        });
	        _this.closeInviteModal();
	      };
	      var handleFailure = function handleFailure(error) {
	        _this.setState({ isLoadingSendInvite: false });
	        alert(JSON.stringify(error.data.message));
	      };
	      _this.setState({ isLoadingSendInvite: true }, function () {
	        (0, _dispatch_actions.sendDriverInvite)(email, isExternal, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.renderDrivers = function () {
	      if (_this.state.isLoadingDrivers) {
	        return _react2.default.createElement(_spinner2.default, null);
	      }
	
	      var getRows = function getRows() {
	        var rows = _reactDataGridAddons.Data.Selectors.getRows(_this.state.driversList);
	        return rows;
	      };
	
	      var getSize = function getSize() {
	        var rowLength = getRows().length;
	        return rowLength;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var driversList = _extends({}, _this.state.driversList, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this.setState({ driversList: driversList });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var deliveryHistoryRows = void 0;
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows.map(function (r) {
	          deliveryHistoryRows = newRows[r.rowIdx].salesOrders;
	          newRows[r.rowIdx].isSelected = true;
	        });
	        var driversList = _extends({}, _this.state.driversList, {
	          rows: newRows,
	          selectedRows: [rows[0].row]
	        });
	        var deliveryHistory = _extends({}, _this.state.deliveryHistory, {
	          rows: deliveryHistoryRows
	        });
	        _this.setState({
	          driversList: driversList,
	          deliveryHistory: deliveryHistory,
	          selectedDriverIdx: rows[0].rowIdx
	        });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this.state.driversList.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var driversList = _extends({}, _this.state.driversList, { filters: newFilters });
	        _this.setState({ driversList: driversList });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        var driversList = _extends({}, _this.state.driversList, { filters: {} });
	        _this.setState({ driversList: driversList });
	      };
	
	      var columns = [{
	        key: 'name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'email',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' }),
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 12 },
	        _react2.default.createElement(
	          'div',
	          { id: 'Drivers-dataGrid1' },
	          _react2.default.createElement(_reactDataGrid2.default, {
	            rowKey: 'name',
	            onGridSort: handleGridSort,
	            columns: columns,
	            rowHeight: 25,
	            rowGetter: rowGetter,
	            toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	            onClearFilters: onClearFilters,
	            onAddFilter: handleFilterChange,
	            rowsCount: getSize(),
	            minHeight: 530,
	            enableRowSelect: 'single',
	            rowSelection: {
	              showCheckbox: true,
	              onRowsSelected: onRowsSelected,
	              selectBy: {
	                isSelectedKey: 'isSelected'
	              }
	            }
	          })
	        )
	      );
	    };
	
	    _this.renderDeliveryHistory = function () {
	      if (_this.state.isLoadingDeliveryHistory) {
	        return _react2.default.createElement(_spinner2.default, null);
	      }
	
	      var getRows = function getRows() {
	        var rows = _reactDataGridAddons.Data.Selectors.getRows(_this.state.deliveryHistory);
	        return rows;
	      };
	
	      var getSize = function getSize() {
	        var rowLength = getRows().length;
	        return rowLength;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var deliveryHistory = _extends({}, _this.state.deliveryHistory, {
	          sortColumn: sortColumn,
	          sortDirection: sortDirection
	        });
	        _this.setState({ deliveryHistory: deliveryHistory });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this.state.deliveryHistory.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var deliveryHistory = _extends({}, _this.state.deliveryHistory, { filters: newFilters });
	        _this.setState({ deliveryHistory: deliveryHistory });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        var deliveryHistory = _extends({}, _this.state.deliveryHistory, { filters: {} });
	        _this.setState({ deliveryHistory: deliveryHistory });
	      };
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var date = new Date(this.props.value);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var columns = [{
	        key: 'soNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'shipmentDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipment_date' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: 'driverFee',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'driver_fee' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'truckxiFee',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'truckxi_fee' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'totalDeliveryFee',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_delivery_fee' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }];
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 12 },
	        _react2.default.createElement(
	          'div',
	          { id: 'DeliveryHistory-dataGrid1' },
	          _react2.default.createElement(_reactDataGrid2.default, {
	            rowKey: 'soNum',
	            onGridSort: handleGridSort,
	            columns: columns,
	            rowHeight: 25,
	            rowGetter: rowGetter,
	            toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	            onClearFilters: onClearFilters,
	            onAddFilter: handleFilterChange,
	            rowsCount: getSize(),
	            minHeight: 540
	          })
	        )
	      );
	    };
	
	    _this.renderDriverInvite = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'invite-drivers-section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'invite-label-area' },
	          _react2.default.createElement(
	            'div',
	            { className: 'code-section' },
	            _react2.default.createElement(
	              'div',
	              { className: 'invite-label' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'internal' }),
	              ':\xA0'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'invite-code font-color-grey' },
	              _this.state.internalCode
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'code-section' },
	            _react2.default.createElement(
	              'div',
	              { className: 'invite-label' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'external' }),
	              ':\xA0'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'invite-code font-color-grey' },
	              _this.state.externalCode
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            onClick: _this.openInviteModal
	          },
	          _react2.default.createElement('em', { className: 'fa fa-envelope' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'send_invite' })
	        )
	      );
	    };
	
	    _this.renderInviteModal = function () {
	      return _react2.default.createElement(
	        'div',
	        { id: 'driver-invite-modal' },
	        _react2.default.createElement(
	          'div',
	          { className: 'invite-type-section' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'internal-option' },
	            _react2.default.createElement('input', {
	              type: 'checkbox',
	              name: 'internal-list-option',
	              checked: !_this.state.isExternal,
	              onClick: function onClick() {
	                _this.setState({ isExternal: false });
	              }
	            }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'internal' })
	          ),
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'external-option' },
	            _react2.default.createElement('input', {
	              type: 'checkbox',
	              name: 'external-option',
	              checked: _this.state.isExternal,
	              onClick: function onClick() {
	                _this.setState({ isExternal: true });
	              }
	            }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'external' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'invite-email-section' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enter_email_of_driver' }),
	          _react2.default.createElement('input', {
	            name: 'driver-email',
	            type: 'text',
	            className: 'email-input',
	            value: _this.state.email,
	            onChange: function onChange(e) {
	              _this.setState({ email: e.target.value });
	            }
	          })
	        ),
	        _react2.default.createElement(_SpinnerButton2.default, {
	          bsStyle: 'primary',
	          onClick: _this.handleSendDriverInvite,
	          loading: _this.state.isLoadingSendInvite,
	          icon: 'fa-envelope',
	          translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invite' }),
	          disabled: _this.state.isLoadingSendInvite
	        })
	      );
	    };
	
	    _this.renderDeliveryFeeModal = function () {
	      return _react2.default.createElement(
	        'div',
	        { id: 'delivery-fee-modal' },
	        _react2.default.createElement(
	          'div',
	          { className: 'delivery-fee-section' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'driver-fee', className: 'label-input' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'driver_fee' }),
	              ':\xA0'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('input', {
	                type: 'text',
	                name: 'driver-fee',
	                className: 'fee-input',
	                value: _this.state.driverFeeRate,
	                onChange: function onChange(e) {
	                  _this.setState({ driverFeeRate: e.target.value });
	                }
	              }),
	              _react2.default.createElement(
	                'span',
	                null,
	                '%'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'truckxi-fee', className: 'label-input' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'truckxi_fee' }),
	              ':\xA0'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('input', {
	                type: 'text',
	                name: 'truckxi-fee',
	                className: 'fee-input',
	                value: _this.state.truckxiFeeRate,
	                onChange: function onChange(e) {
	                  _this.setState({ truckxiFeeRate: e.target.value });
	                }
	              }),
	              _react2.default.createElement(
	                'span',
	                null,
	                '%'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_SpinnerButton2.default, {
	          bsStyle: 'success',
	          onClick: _this.handleSaveDeliveryFees,
	          loading: _this.state.isLoadingSaveDeliveryFees,
	          icon: 'fa-save',
	          translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' }),
	          disabled: _this.state.isLoadingSaveDeliveryFees
	        })
	      );
	    };
	
	    _this.state = {
	      isLoadingDrivers: false,
	      isLoadingSendInvite: false,
	      isLoadingDeliveryHistory: false,
	      isLoadingSaveDeliveryFees: false,
	      isInviteModalOpen: false,
	      isPermissionModalOpen: false,
	      isDeliveryFeeModalOpen: false,
	      isExternal: false,
	      email: '',
	      driversList: {
	        rows: [],
	        filters: {},
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	      deliveryHistory: {
	        rows: [],
	        filters: {},
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	      internalCode: undefined,
	      externalCode: undefined,
	      selectedDriverIdx: null,
	      totalDriverFee: 0,
	      totalTruckxiFee: 0,
	      totalDeliveryFee: 0,
	      driverFeeRate: 0,
	      truckxiFeeRate: 0,
	      startDate: undefined,
	      endDate: undefined
	    };
	    return _this;
	  }
	
	  _createClass(Drivers, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.handleFetchDrivers();
	      this.handleFetchDriverCodes();
	      this.handleFetchDeliveryFee();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.deliveryHistory !== this.state.deliveryHistory) {
	        var totalDriverFee = 0;
	        var totalTruckxiFee = 0;
	        var totalDeliveryFee = 0;
	        (0, _map2.default)(this.state.deliveryHistory.rows, function (row) {
	          totalDriverFee += row.driverFee;
	          totalTruckxiFee += row.truckxiFee;
	          totalDeliveryFee += row.totalDeliveryFee;
	        });
	        this.setState({
	          totalDriverFee: totalDriverFee,
	          totalTruckxiFee: totalTruckxiFee,
	          totalDeliveryFee: totalDeliveryFee
	        });
	      }
	
	      if (this.props.checkPermissionSuccess && prevProps.checkPermissionSuccess !== this.props.checkPermissionSuccess) {
	        if (this.props.checkPermissionSuccess.manager) {
	          this.closePermissionModal();
	          this.openDeliveryFeeModal();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var createDialogStyle = {
	        width: '450px',
	        height: '250px',
	        marginLeft: '-10%',
	        top: '55%'
	      };
	      var permissionDialog = {
	        width: '650px',
	        marginLeft: '-15%'
	      };
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'drivers' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'primary',
	              onClick: this.openPermissionModal
	            },
	            _react2.default.createElement('em', { className: 'fa fa-dollar' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'manage_fees' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'drivers' },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { className: 'table-panel' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'drivers' })
	              ),
	              this.renderDriverInvite(),
	              this.renderDrivers()
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 8 },
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { className: 'table-panel' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'orders_delivered' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'date-pickers' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'label-and-date-picker' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'from' }),
	                  ':\xA0',
	                  _react2.default.createElement(_GenericDatePicker2.default, {
	                    setDate: this.setStartDate,
	                    selectedDate: this.state.startDate
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'label-and-date-picker' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'to' }),
	                  ':\xA0',
	                  _react2.default.createElement(_GenericDatePicker2.default, {
	                    setDate: this.setEndDate,
	                    selectedDate: this.state.endDate
	                  })
	                )
	              ),
	              this.renderDeliveryHistory(),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xsOffset: 3, xs: 3, className: 'delivery-fee-col' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'total-delivery-fee' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_driver_fee' }),
	                  ':\xA0'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'font-color-grey' },
	                  '$' + (0, _numberWithCommas.numberWithCommas)(this.state.totalDriverFee.toFixed(2))
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3, className: 'truckxi-fee-col' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'total-truckxi-fee' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_truckxi_fee' }),
	                  ':\xA0'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'font-color-grey' },
	                  '$' + (0, _numberWithCommas.numberWithCommas)(this.state.totalTruckxiFee.toFixed(2))
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3, className: 'delivery-fee-col' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'total-delivery-fee' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_delivery_fee' }),
	                  ':\xA0'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'font-color-grey' },
	                  '$' + (0, _numberWithCommas.numberWithCommas)(this.state.totalDeliveryFee.toFixed(2))
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: permissionDialog,
	            isVisible: this.state.isPermissionModalOpen,
	            onCloseClicked: function onCloseClicked() {
	              _this2.closePermissionModal();
	            },
	            title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'permission_to_change_delivery_fees' })
	          },
	          _react2.default.createElement(_confirmActionModal2.default, {
	            'case': 'editDeliveryFeeRate',
	            checkPermission: this.props.checkPermission,
	            checkPermissionSuccess: this.props.checkPermissionSuccess
	          })
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogStyle,
	            isVisible: this.state.isInviteModalOpen,
	            onCloseClicked: this.closeInviteModal,
	            title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invite' })
	          },
	          this.renderInviteModal()
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogStyle,
	            isVisible: this.state.isDeliveryFeeModalOpen,
	            onCloseClicked: this.closeDeliveryFeeModal,
	            title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delivery_fees' })
	          },
	          this.renderDeliveryFeeModal()
	        )
	      );
	    }
	  }]);
	
	  return Drivers;
	}(_react.Component);
	
	Drivers.propTypes = propTypes;
	Drivers.defaultProps = defaultProps;
	
	var _default = Drivers;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/Drivers.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/Drivers.jsx');
	
	  __REACT_HOT_LOADER__.register(Drivers, 'Drivers', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/Drivers.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/Drivers.jsx');
	}();

	;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	var _rowRenderer = __webpack_require__(64);
	
	var _rowRenderer2 = _interopRequireDefault(_rowRenderer);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _dispatch_actions = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(5),
	    _require$Draggable = _require.Draggable,
	    DraggableContainer = _require$Draggable.Container,
	    RowActionsCell = _require$Draggable.RowActionsCell,
	    DropTargetRowContainer = _require$Draggable.DropTargetRowContainer,
	    Selectors = _require.Data.Selectors;
	
	var RowRenderer = DropTargetRowContainer(_rowRenderer2.default);
	
	var EditRouteModal = function (_Component) {
	  _inherits(EditRouteModal, _Component);
	
	  _createClass(EditRouteModal, null, [{
	    key: 'getDayOptions',
	    value: function getDayOptions() {
	      var days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
	      var dayOptions = [];
	      days.map(function (day) {
	        dayOptions.push({ value: day, label: day });
	      });
	      return dayOptions;
	    }
	  }]);
	
	  function EditRouteModal(props) {
	    _classCallCheck(this, EditRouteModal);
	
	    var _this = _possibleConstructorReturn(this, (EditRouteModal.__proto__ || Object.getPrototypeOf(EditRouteModal)).call(this, props));
	
	    _this.handleFetchDrivers = function () {
	      var handleSuccess = function handleSuccess(drivers) {
	        _this.setState({ drivers: drivers });
	      };
	      (0, _dispatch_actions.fetchAllDrivers)(handleSuccess, function () {});
	    };
	
	    _this.state = {
	      sourceCustomers: {
	        rows: [],
	        selectedRows: []
	      },
	      destCustomers: {
	        rows: [],
	        selectedRows: []
	      },
	      routes: [],
	      drivers: [],
	      selectedRoute: '',
	      selectedDriver: '',
	      selectedDay: '',
	      selectedCustomer: '',
	      selectedAllRoutes: '',
	      sourceStopDay: '',
	      sourceRouteDay: '',
	      destStopDay: '',
	      destRouteDay: '',
	      cellSelected: '',
	      email: ''
	    };
	
	    _this.setSelectedRoute = _this.setSelectedRoute.bind(_this);
	    _this.setSelectedDriver = _this.setSelectedDriver.bind(_this);
	    _this.setSelectedDay = _this.setSelectedDay.bind(_this);
	    _this.setSelectedCustomer = _this.setSelectedCustomer.bind(_this);
	    _this.setSelectedAllRoutes = _this.setSelectedAllRoutes.bind(_this);
	    _this.removeSourceRow = _this.removeSourceRow.bind(_this);
	    _this.removeDestRow = _this.removeDestRow.bind(_this);
	    _this.moveLeftToRight = _this.moveLeftToRight.bind(_this);
	    _this.moveRightToLeft = _this.moveRightToLeft.bind(_this);
	    return _this;
	  }
	
	  _createClass(EditRouteModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.handleFetchDrivers();
	      this.setState({
	        email: this.props.selectedRoute.email || ''
	      });
	      this.setDayAndRoute();
	    }
	  }, {
	    key: 'setSelectedDay',
	    value: function setSelectedDay(e) {
	      var routeLetter = void 0;
	      var routes = [];
	      if (e.value === 'Monday') {
	        routeLetter = 'A';
	      } else if (e.value === 'Tuesday') {
	        routeLetter = 'B';
	      } else if (e.value === 'Wednesday') {
	        routeLetter = 'C';
	      } else if (e.value === 'Thursday') {
	        routeLetter = 'D';
	      } else if (e.value === 'Friday') {
	        routeLetter = 'E';
	      } else if (e.value === 'Saturday') {
	        routeLetter = 'F';
	      } else if (e.value === 'Sunday') {
	        routeLetter = 'G';
	      }
	      this.props.allRoutes.map(function (route) {
	        if (route.RouteNum.includes(routeLetter)) {
	          routes.push([route.RouteNum, route.Email, route.driver_id]);
	        }
	      });
	      this.setState({
	        selectedDay: e.value,
	        selectedRoute: '',
	        selectedDriver: '',
	        selectedAllRoutes: '',
	        sourceCustomers: {},
	        destCustomers: {},
	        routes: routes
	      });
	    }
	  }, {
	    key: 'setSelectedRoute',
	    value: function setSelectedRoute(e) {
	      var sourceRouteDay = void 0;
	      var sourceStopDay = void 0;
	      switch (e.value.slice(0, 1)) {
	        case 'A':
	          sourceRouteDay = 'MonRoute';
	          sourceStopDay = 'MonStop';
	          break;
	        case 'B':
	          sourceRouteDay = 'TuesRoute';
	          sourceStopDay = 'TuesStop';
	          break;
	        case 'C':
	          sourceRouteDay = 'WedRoute';
	          sourceStopDay = 'WedStop';
	          break;
	        case 'D':
	          sourceRouteDay = 'ThursRoute';
	          sourceStopDay = 'ThursStop';
	          break;
	        case 'E':
	          sourceRouteDay = 'FriRoute';
	          sourceStopDay = 'FriStop';
	          break;
	        case 'F':
	          sourceRouteDay = 'SatRoute';
	          sourceStopDay = 'SatStop';
	          break;
	        case 'G':
	          sourceRouteDay = 'SundayRoute';
	          sourceStopDay = 'SundayRoute';
	          break;
	        default:
	          return;
	      }
	      var rows = this.props.customersWithStops.rows.filter(function (obj) {
	        return obj[sourceRouteDay] === e.value;
	      });
	      rows = _lodash2.default.sortBy(rows, function (key) {
	        return key[sourceStopDay];
	      });
	      rows.map(function (row, index) {
	        row[sourceStopDay] = index + 1;
	      });
	      var sourceCustomers = _extends({}, this.state.sourceCustomers, { rows: rows });
	      this.setState({
	        selectedRoute: e,
	        sourceCustomers: sourceCustomers,
	        sourceStopDay: sourceStopDay,
	        sourceRouteDay: sourceRouteDay,
	        selectedAllRoutes: '',
	        selectedDriver: e.driver || '',
	        destCustomers: {},
	        email: e.email || ''
	      });
	    }
	  }, {
	    key: 'setSelectedCustomer',
	    value: function setSelectedCustomer(e) {
	      this.setState({ selectedCustomer: e });
	    }
	  }, {
	    key: 'setSelectedDriver',
	    value: function setSelectedDriver(e) {
	      this.setState({ selectedDriver: e });
	    }
	  }, {
	    key: 'setSelectedAllRoutes',
	    value: function setSelectedAllRoutes(e) {
	      var destRouteDay = void 0;
	      var destStopDay = void 0;
	      switch (e.value.slice(0, 1)) {
	        case 'A':
	          destRouteDay = 'MonRoute';
	          destStopDay = 'MonStop';
	          break;
	        case 'B':
	          destRouteDay = 'TuesRoute';
	          destStopDay = 'TuesStop';
	          break;
	        case 'C':
	          destRouteDay = 'WedRoute';
	          destStopDay = 'WedStop';
	          break;
	        case 'D':
	          destRouteDay = 'ThursRoute';
	          destStopDay = 'ThursStop';
	          break;
	        case 'E':
	          destRouteDay = 'FriRoute';
	          destStopDay = 'FriStop';
	          break;
	        case 'F':
	          destRouteDay = 'SatRoute';
	          destStopDay = 'SatStop';
	          break;
	        case 'G':
	          destRouteDay = 'SundayRoute';
	          destStopDay = 'SundayRoute';
	          break;
	        default:
	          return;
	      }
	      var rows = this.props.customersWithStops.rows.filter(function (obj) {
	        return obj[destRouteDay] === e.value;
	      });
	      rows = _lodash2.default.sortBy(rows, function (key) {
	        return key[destStopDay];
	      });
	      var destCustomers = _extends({}, this.state.destCustomers, { rows: rows });
	      rows.map(function (row, index) {
	        row[destStopDay] = index + 1;
	      });
	      this.setState({
	        selectedAllRoutes: e, destCustomers: destCustomers, destStopDay: destStopDay, destRouteDay: destRouteDay
	      });
	    }
	  }, {
	    key: 'setDayAndRoute',
	    value: function setDayAndRoute() {
	      var selectedDay = this.props.selectedDay ? this.props.selectedDay : '';
	      var selectedRoute = this.props.selectedRoute ? this.props.selectedRoute : '';
	      var selectedCustomer = this.props.selectedCustomer ? this.props.selectedCustomer : '';
	      if (selectedDay !== '') {
	        this.setSelectedDay(selectedDay);
	      }
	      if (selectedRoute !== '') {
	        this.setSelectedRoute(selectedRoute);
	      }
	      if (selectedCustomer !== '') {
	        this.setSelectedCustomer(selectedCustomer);
	      }
	    }
	  }, {
	    key: 'getRouteOptions',
	    value: function getRouteOptions() {
	      var routes = this.state.routes;
	
	      var routeOptions = [];
	      routes.map(function (route) {
	        routeOptions.push({
	          value: route[0],
	          label: route[0],
	          email: route[1],
	          driver: route[2]
	        });
	      });
	      return routeOptions;
	    }
	  }, {
	    key: 'getCustomerOptions',
	    value: function getCustomerOptions() {
	      var allCustomers = this.props.allCustomers;
	
	      var customerOptions = [];
	      allCustomers.map(function (customer) {
	        customerOptions.push({ value: customer, label: customer.Name });
	      });
	      return customerOptions;
	    }
	  }, {
	    key: 'getAllRouteOptions',
	    value: function getAllRouteOptions() {
	      var _this2 = this;
	
	      var allRoutes = this.props.allRoutes;
	
	      var allRouteOptions = [];
	      allRoutes.map(function (route) {
	        if (route.RouteNum !== _this2.state.selectedRoute.value) {
	          allRouteOptions.push({ value: route.RouteNum, label: route.RouteNum });
	        }
	      });
	      allRouteOptions = _lodash2.default.sortBy(allRouteOptions, function (key) {
	        return key.value;
	      });
	      return allRouteOptions;
	    }
	  }, {
	    key: 'getDriverOptions',
	    value: function getDriverOptions() {
	      var drivers = this.state.drivers;
	
	      var driverOptions = [];
	      drivers.map(function (driver) {
	        driverOptions.push({ value: driver.id, label: driver.name });
	      });
	      return driverOptions;
	    }
	  }, {
	    key: 'addCustomer',
	    value: function addCustomer() {
	      var _this3 = this;
	
	      if (!this.state.selectedCustomer.value || !this.state.selectedDay || !this.state.selectedRoute) {
	        return;
	      }
	      var index = _lodash2.default.findIndex(this.state.sourceCustomers.rows, function (row) {
	        return row.Name === _this3.state.selectedCustomer.value.Name;
	      });
	      if (index !== -1) {
	        alert('This customer is already on this route!');
	        return;
	      }
	      var rows = [].concat(_toConsumableArray(this.state.sourceCustomers.rows));
	      var newCustomer = _extends({}, this.state.selectedCustomer.value, _defineProperty({}, this.state.sourceStopDay, rows.length + 1));
	      rows.push(newCustomer);
	      var sourceCustomers = _extends({}, this.state.sourceCustomers, { rows: rows });
	      this.setState({ sourceCustomers: sourceCustomers });
	    }
	  }, {
	    key: 'removeSourceRow',
	    value: function removeSourceRow(dependentValues) {
	      var _this4 = this;
	
	      var rows = [].concat(_toConsumableArray(this.state.sourceCustomers.rows));
	      var stopNum = dependentValues[this.state.sourceStopDay];
	      rows = rows.filter(function (row) {
	        var match = row[_this4.state.sourceStopDay] !== stopNum;
	        return match;
	      });
	      rows.map(function (row, index) {
	        row[_this4.state.sourceStopDay] = index + 1;
	      });
	      var sourceCustomers = _extends({}, this.state.sourceCustomers, { rows: rows });
	      this.setState({ sourceCustomers: sourceCustomers });
	    }
	  }, {
	    key: 'removeDestRow',
	    value: function removeDestRow(dependentValues) {
	      var _this5 = this;
	
	      var rows = [].concat(_toConsumableArray(this.state.destCustomers.rows));
	      var stopNum = dependentValues[this.state.destStopDay];
	      rows = rows.filter(function (row) {
	        var match = row[_this5.state.destStopDay] !== stopNum;
	        return match;
	      });
	      rows.map(function (row, index) {
	        row[_this5.state.destStopDay] = index + 1;
	      });
	      var destCustomers = _extends({}, this.state.destCustomers, { rows: rows });
	      this.setState({ destCustomers: destCustomers });
	    }
	  }, {
	    key: 'moveLeftToRight',
	    value: function moveLeftToRight(e) {
	      var _this6 = this,
	          _extends3;
	
	      if (this.state.cellSelected === 'Delete') {
	        return;
	      }
	      var invalid = _lodash2.default.findIndex(this.state.destCustomers.rows, function (row) {
	        return row.Name === e.Name;
	      });
	      if (invalid !== -1) {
	        alert('This customer is already on the route!');
	        return;
	      }
	      if (!this.state.selectedAllRoutes) {
	        alert('Please select a new route!');
	        return;
	      }
	      if (!this.state.selectedAllRoutes) {
	        alert('Please select a new route!');
	        return;
	      }
	      var leftRows = this.state.sourceCustomers.rows;
	      var rightRows = this.state.destCustomers.rows;
	      var stopNum = e[this.state.sourceStopDay];
	      leftRows = leftRows.filter(function (row) {
	        var match = row[_this6.state.sourceStopDay] !== stopNum;
	        return match;
	      });
	      leftRows.map(function (row, index) {
	        row[_this6.state.sourceStopDay] = index + 1;
	      });
	      var newStopNumber = rightRows.length + 1;
	      var newCustomer = _extends({}, e, (_extends3 = {}, _defineProperty(_extends3, this.state.destStopDay, newStopNumber), _defineProperty(_extends3, this.state.destRouteDay, this.state.selectedAllRoutes.value), _extends3));
	      rightRows.push(newCustomer);
	      var sourceCustomers = _extends({}, this.state.sourceCustomers, { rows: leftRows });
	      var destCustomers = _extends({}, this.state.destCustomers, { rows: rightRows });
	      this.setState({ sourceCustomers: sourceCustomers, destCustomers: destCustomers });
	    }
	  }, {
	    key: 'moveRightToLeft',
	    value: function moveRightToLeft(e) {
	      var _this7 = this,
	          _extends4;
	
	      var invalid = _lodash2.default.findIndex(this.state.sourceCustomers.rows, function (row) {
	        return row.Name === e.Name;
	      });
	      if (invalid !== -1) {
	        alert('This customer is already on the route!');
	        return;
	      }
	      var leftRows = this.state.sourceCustomers.rows;
	      var rightRows = this.state.destCustomers.rows;
	      var stopNum = e[this.state.destStopDay];
	      rightRows = rightRows.filter(function (row) {
	        var match = row[_this7.state.destStopDay] !== stopNum;
	        return match;
	      });
	      rightRows.map(function (row, index) {
	        row[_this7.state.destStopDay] = index + 1;
	      });
	      var newStopNumber = leftRows.length + 1;
	      var newCustomer = _extends({}, e, (_extends4 = {}, _defineProperty(_extends4, this.state.sourceStopDay, newStopNumber), _defineProperty(_extends4, this.state.sourceRouteDay, this.state.selectedRoute.value), _extends4));
	      leftRows.push(newCustomer);
	      var sourceCustomers = _extends({}, this.state.sourceCustomers, { rows: leftRows });
	      var destCustomers = _extends({}, this.state.destCustomers, { rows: rightRows });
	      this.setState({ sourceCustomers: sourceCustomers, destCustomers: destCustomers });
	    }
	  }, {
	    key: 'saveRouteEdits',
	    value: function saveRouteEdits() {
	      var _state = this.state,
	          sourceCustomers = _state.sourceCustomers,
	          destCustomers = _state.destCustomers,
	          sourceStopDay = _state.sourceStopDay,
	          destStopDay = _state.destStopDay,
	          selectedRoute = _state.selectedRoute,
	          selectedAllRoutes = _state.selectedAllRoutes,
	          email = _state.email,
	          selectedDriver = _state.selectedDriver;
	
	      if (!selectedRoute) {
	        alert('Select a route!');
	        return;
	      }
	      if (!selectedAllRoutes && !destCustomers) {
	        alert('Select a new route!');
	        return;
	      }
	      var driverId = '';
	      if (selectedRoute) {
	        driverId = selectedDriver.value;
	      }
	      // if (!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))) {
	      //   alert('Email is not valid,Please input again.');
	      //   return;
	      // }
	      var oldRoute = {
	        RouteNum: '',
	        Stops: []
	      };
	      var newRoute = {
	        RouteNum: '',
	        Stops: []
	      };
	      oldRoute.RouteNum = selectedRoute.value;
	      newRoute.RouteNum = selectedAllRoutes ? selectedAllRoutes.value : null;
	      sourceCustomers.rows.map(function (row) {
	        oldRoute.Stops.push({ StopNum: row[sourceStopDay], Customer: row.Customer_id });
	      });
	      if (selectedAllRoutes !== '') {
	        destCustomers.rows.map(function (row) {
	          newRoute.Stops.push({ StopNum: row[destStopDay], Customer: row.Customer_id });
	        });
	      }
	      this.props.action(oldRoute, newRoute, email, driverId);
	    }
	  }, {
	    key: 'renderSourceGrid',
	    value: function renderSourceGrid() {
	      var _this8 = this;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this8.state.sourceCustomers);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var isDraggedRowSelected = function isDraggedRowSelected(selectedRows, rowDragSource) {
	        if (selectedRows && selectedRows.length > 0) {
	          var key = _this8.props.rowKey;
	          return selectedRows.filter(function (r) {
	            return r[key] === rowDragSource.data[key];
	          }).length > 0;
	        }
	        return false;
	      };
	
	      var reorderRows = function reorderRows(e) {
	        var selectedRows = Selectors.getSelectedRowsByKey({ rowKey: _this8.props.rowKey, selectedKeys: [], rows: _this8.state.sourceCustomers.rows });
	        var draggedRows = isDraggedRowSelected(selectedRows, e.rowSource) ? selectedRows : [e.rowSource.data];
	        var undraggedRows = _this8.state.sourceCustomers.rows.filter(function (r) {
	          return draggedRows.indexOf(r) === -1;
	        });
	        var args = [e.rowTarget.idx, 0].concat(draggedRows);
	        Array.prototype.splice.apply(undraggedRows, args);
	        undraggedRows.map(function (row, index) {
	          row[_this8.state.sourceStopDay] = index + 1;
	        });
	        var sourceCustomers = _extends({}, _this8.state.sourceCustomers, { rows: undraggedRows });
	        _this8.setState({ sourceCustomers: sourceCustomers });
	      };
	
	      var onCellSelected = function onCellSelected(coordinates) {
	        if (coordinates.idx === 1) {
	          _this8.setState({ cellSelected: 'Delete' });
	        } else {
	          _this8.setState({ cellSelected: 'NotDelete' });
	        }
	      };
	
	      var DeleteFormatter = _react2.default.createClass({
	        displayName: 'DeleteFormatter',
	        render: function render() {
	          var _this9 = this;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                className: 'textAlignStyle',
	                style: { height: '23px', width: '39px', padding: '0px' },
	                onClick: function onClick() {
	                  _this9.props.remove(_this9.props.dependentValues);
	                }
	              },
	              'X'
	            )
	          );
	        }
	      });
	
	      var columns = [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: _react2.default.createElement(DeleteFormatter, { remove: this.removeSourceRow }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' }),
	        resizable: true,
	        editable: false
	      }, {
	        key: 'CustomerNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_number' }),
	        resizable: true,
	        editable: false
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            DraggableContainer,
	            { style: { maxWidth: '100%' } },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              columns: columns,
	              rowHeight: 25,
	              minHeight: 490,
	              enableRowSelect: 'single',
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              rowActionsCell: RowActionsCell,
	              onCellSelected: onCellSelected,
	              rowRenderer: _react2.default.createElement(RowRenderer, { onRowDrop: reorderRows, onDoubleClick: this.moveLeftToRight })
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDestGrid',
	    value: function renderDestGrid() {
	      var _this10 = this;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this10.state.destCustomers);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var isDraggedRowSelected = function isDraggedRowSelected(selectedRows, rowDragSource) {
	        if (selectedRows && selectedRows.length > 0) {
	          var key = _this10.props.rowKey;
	          return selectedRows.filter(function (r) {
	            return r[key] === rowDragSource.data[key];
	          }).length > 0;
	        }
	        return false;
	      };
	
	      var reorderRows = function reorderRows(e) {
	        var selectedRows = Selectors.getSelectedRowsByKey({ rowKey: _this10.props.rowKey, selectedKeys: [], rows: _this10.state.destCustomers.rows });
	        var draggedRows = isDraggedRowSelected(selectedRows, e.rowSource) ? selectedRows : [e.rowSource.data];
	        var undraggedRows = _this10.state.destCustomers.rows.filter(function (r) {
	          return draggedRows.indexOf(r) === -1;
	        });
	        var args = [e.rowTarget.idx, 0].concat(draggedRows);
	        Array.prototype.splice.apply(undraggedRows, args);
	        undraggedRows.map(function (row, index) {
	          row[_this10.state.destStopDay] = index + 1;
	        });
	        var destCustomers = _extends({}, _this10.state.destCustomers, { rows: undraggedRows });
	        _this10.setState({ destCustomers: destCustomers });
	      };
	
	      var DeleteFormatter = _react2.default.createClass({
	        displayName: 'DeleteFormatter',
	        render: function render() {
	          var _this11 = this;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                className: 'textAlignStyle',
	                style: { height: '23px', width: '39px', padding: '0px' },
	                onClick: function onClick() {
	                  _this11.props.remove(_this11.props.dependentValues);
	                }
	              },
	              'X'
	            )
	          );
	        }
	      });
	
	      var columns = [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: _react2.default.createElement(DeleteFormatter, { remove: this.removeDestRow }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' }),
	        resizable: true,
	        editable: false
	      }, {
	        key: 'CustomerNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_number' }),
	        resizable: true,
	        editable: false
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            DraggableContainer,
	            { style: { maxWidth: '100%' } },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              columns: columns,
	              rowHeight: 25,
	              minHeight: 490,
	              enableRowSelect: 'single',
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              rowActionsCell: RowActionsCell,
	              rowRenderer: _react2.default.createElement(RowRenderer, { onRowDrop: reorderRows, onDoubleClick: this.moveRightToLeft })
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this12 = this;
	
	      var routeOptions = this.getRouteOptions();
	      var dayOptions = EditRouteModal.getDayOptions();
	      var customerOptions = this.getCustomerOptions();
	      var driverOptions = this.getDriverOptions();
	      var allRouteOptions = this.getAllRouteOptions();
	      return _react2.default.createElement(
	        'div',
	        { id: 'edit-route-modal' },
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 10 },
	            _react2.default.createElement(
	              'div',
	              { className: 'selection' },
	              (0, _GenericSelection2.default)({
	                translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_day' }),
	                options: dayOptions,
	                value: this.state.selectedDay,
	                setSelected: this.setSelectedDay
	              }),
	              (0, _GenericSelection2.default)({
	                translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_route' }),
	                options: routeOptions,
	                value: this.state.selectedRoute,
	                setSelected: this.setSelectedRoute
	              }),
	              (0, _GenericSelection2.default)({
	                translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_driver' }),
	                options: driverOptions,
	                value: this.state.selectedDriver,
	                setSelected: this.setSelectedDriver
	              }),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: '' },
	                  'Phone'
	                ),
	                _react2.default.createElement('input', {
	                  style: {
	                    border: '1px solid black',
	                    marginLeft: '10px',
	                    borderRadius: '4px',
	                    padding: '3px 5px',
	                    height: '25px'
	                  },
	                  type: 'text',
	                  value: this.state.email,
	                  onChange: function onChange(e) {
	                    _this12.setState({ email: e.target.value });
	                  }
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 2 },
	            _react2.default.createElement(
	              'div',
	              { className: 'save-buttons' },
	              _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                null,
	                _react2.default.createElement(_SpinnerButton2.default, {
	                  bsStyle: 'success',
	                  onClick: function onClick() {
	                    _this12.saveRouteEdits();
	                  },
	                  loading: this.props.savingRouteEdits,
	                  icon: 'fa-save',
	                  translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' }),
	                  disabled: this.props.savingRouteEdits
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement('div', { className: 'horizontal-divider' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { className: 'selection', id: 'customer-selection' },
	              (0, _GenericSelection2.default)({
	                translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_customer' }),
	                options: customerOptions,
	                value: this.state.selectedCustomer,
	                setSelected: this.setSelectedCustomer
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'add-button' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'primary',
	                  onClick: function onClick() {
	                    _this12.addCustomer();
	                  }
	                },
	                _react2.default.createElement('em', { className: 'fa fa-plus' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'selection', id: 'new-route-selection' },
	              (0, _GenericSelection2.default)({
	                translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_new_route' }),
	                options: allRouteOptions,
	                value: this.state.selectedAllRoutes,
	                setSelected: this.setSelectedAllRoutes
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 6 },
	            this.renderSourceGrid()
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 6 },
	            this.renderDestGrid()
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditRouteModal;
	}(_react.Component);
	
	EditRouteModal.defaultProps = {
	  allRoutes: [],
	  customersWithStops: {},
	  allCustomers: [],
	  dependentValues: {},
	  remove: null,
	  rowKey: 'Name',
	  savingRouteEdits: false,
	  selectedDay: null,
	  selectedRoute: null,
	  selectedCustomer: null
	};
	
	EditRouteModal.propTypes = {
	  allRoutes: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  customersWithStops: _propTypes2.default.shape({
	    filteredRows: _propTypes2.default.arrayOf(_propTypes2.default.object),
	    rows: _propTypes2.default.arrayOf(_propTypes2.default.object),
	    selectedRow: _propTypes2.default.object,
	    sortColumn: _propTypes2.default.string,
	    sortDirection: _propTypes2.default.string
	  }),
	  allCustomers: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  dependentValues: _propTypes2.default.shape({}),
	  remove: _propTypes2.default.func,
	  rowKey: _propTypes2.default.string,
	  savingRouteEdits: _propTypes2.default.bool,
	  action: _propTypes2.default.func.isRequired,
	  selectedDay: _propTypes2.default.string,
	  selectedRoute: _propTypes2.default.string,
	  selectedCustomer: _propTypes2.default.string
	};
	
	var _default = EditRouteModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/EditRouteModal.jsx');
	
	  __REACT_HOT_LOADER__.register(EditRouteModal, 'EditRouteModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/EditRouteModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/EditRouteModal.jsx');
	}();

	;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _dispatch_actions = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditRoutePrinterModal = function (_Component) {
	  _inherits(EditRoutePrinterModal, _Component);
	
	  function EditRoutePrinterModal(props) {
	    _classCallCheck(this, EditRoutePrinterModal);
	
	    var _this = _possibleConstructorReturn(this, (EditRoutePrinterModal.__proto__ || Object.getPrototypeOf(EditRoutePrinterModal)).call(this, props));
	
	    _this.save = function () {
	      _this.props.saveRoutesPrinter(_this.state.rows);
	    };
	
	    _this.renderTable = function () {
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this.state);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        var rows = getRows();
	        Object.assign(rows[e.rowIdx], e.updated);
	        _this.setState({
	          rows: rows
	        });
	      };
	
	      var columns = [{
	        key: 'RouterId',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'RouterId' }),
	        resizable: true,
	        width: 90,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'RunTime',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'RunTime' }),
	        resizable: true,
	        editable: true,
	        width: 90,
	        sortable: true,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'router_printer_table001',
	              enableCellSelect: true,
	              onRowUpdated: handleRowUpdated,
	              rowHeight: 25,
	              minHeight: 675,
	              columns: columns,
	              rowGetter: rowGetter,
	              rowsCount: getSize()
	            })
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      // data: this.props.allRoutes,
	      rows: []
	    };
	    return _this;
	  }
	
	  _createClass(EditRoutePrinterModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.fetchRoutesPrinter();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.routesPrinters) {
	        this.setState({
	          rows: nextProps.routesPrinters
	        });
	      }
	      if (nextProps.savePrinterSuccess) {
	        this.props.saveRoutesPrinterSuccess(false);
	        this.props.close();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'edit-route-modal' },
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          { style: { marginBottom: '10px' } },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'primary',
	              className: 'buttonStyle',
	              onClick: function onClick(event) {
	                return _this2.save(event);
	              }
	            },
	            _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	          )
	        ),
	        this.renderTable()
	      );
	    }
	  }]);
	
	  return EditRoutePrinterModal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    routesPrinters: state.dispatch.routesPrinters,
	    savePrinterSuccess: state.dispatch.savePrinterSuccess
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchRoutesPrinter: _dispatch_actions.fetchRoutesPrinter,
	  saveRoutesPrinter: _dispatch_actions.saveRoutesPrinter,
	  saveRoutesPrinterSuccess: _dispatch_actions.saveRoutesPrinterSuccess
	})(EditRoutePrinterModal);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/EditRoutePrinterModal.jsx');
	
	  __REACT_HOT_LOADER__.register(EditRoutePrinterModal, 'EditRoutePrinterModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/EditRoutePrinterModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/EditRoutePrinterModal.jsx');
	}();

	;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewRouteModal = function (_Component) {
	  _inherits(NewRouteModal, _Component);
	
	  _createClass(NewRouteModal, null, [{
	    key: 'getDayOptions',
	    value: function getDayOptions() {
	      var days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
	      var dayOptions = [];
	      days.map(function (day) {
	        dayOptions.push({ value: day, label: day });
	      });
	      return dayOptions;
	    }
	  }, {
	    key: 'pad',
	    value: function pad(number) {
	      var leadingZeros = void 0;
	      if (number < 10) {
	        leadingZeros = '00';
	      } else if (number > 10 && number < 100) {
	        leadingZeros = '0';
	      } else {
	        leadingZeros = '';
	      }
	      return leadingZeros;
	    }
	  }]);
	
	  function NewRouteModal(props) {
	    _classCallCheck(this, NewRouteModal);
	
	    var _this = _possibleConstructorReturn(this, (NewRouteModal.__proto__ || Object.getPrototypeOf(NewRouteModal)).call(this, props));
	
	    _this.state = {
	      day: '',
	      routeLetter: '',
	      routes: []
	    };
	
	    _this.setSelected = _this.setSelected.bind(_this);
	    _this.addNewRoute = _this.addNewRoute.bind(_this);
	    return _this;
	  }
	
	  _createClass(NewRouteModal, [{
	    key: 'setSelected',
	    value: function setSelected(e) {
	      var routeLetter = void 0;
	      if (e.value === 'Monday') {
	        routeLetter = 'A';
	      } else if (e.value === 'Tuesday') {
	        routeLetter = 'B';
	      } else if (e.value === 'Wednesday') {
	        routeLetter = 'C';
	      } else if (e.value === 'Thursday') {
	        routeLetter = 'D';
	      } else if (e.value === 'Friday') {
	        routeLetter = 'E';
	      } else if (e.value === 'Saturday') {
	        routeLetter = 'F';
	      } else if (e.value === 'Sunday') {
	        routeLetter = 'G';
	      }
	      var routes = this.props.routes.filter(function (route) {
	        return route.RouteNum.includes(routeLetter);
	      });
	      this.setState({ day: e.value, routes: routes, routeLetter: routeLetter });
	    }
	  }, {
	    key: 'addNewRoute',
	    value: function addNewRoute() {
	      this.props.action(this.state.day);
	    }
	  }, {
	    key: 'renderNewRoute',
	    value: function renderNewRoute() {
	      var lastIndex = this.state.routes.length - 1;
	      var numString = lastIndex === -1 ? '0' : this.state.routes[lastIndex].RouteNum.substr(1);
	      var routesDigits = parseInt(numString, 10) + 1;
	      var leadingZeros = NewRouteModal.pad(routesDigits);
	      return '' + this.state.routeLetter + leadingZeros + routesDigits;
	    }
	  }, {
	    key: 'renderRoutes',
	    value: function renderRoutes() {
	      if (!this.state.routes.length === 0) {
	        return _react2.default.createElement('div', null);
	      }
	      var itemList = this.state.routes.map(function (route) {
	        return _react2.default.createElement(
	          'li',
	          null,
	          route.RouteNum
	        );
	      });
	      return itemList;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var dayOptions = NewRouteModal.getDayOptions();
	      return _react2.default.createElement(
	        'div',
	        { id: 'new-route-modal' },
	        _react2.default.createElement(
	          'div',
	          { className: 'selection' },
	          (0, _GenericSelection2.default)({
	            translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_day' }),
	            options: dayOptions,
	            value: this.state.day,
	            setSelected: this.setSelected
	          })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'ul',
	              null,
	              this.renderRoutes()
	            )
	          )
	        ),
	        this.state.day && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'new-route-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_route' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'colon' },
	              ':'
	            ),
	            this.renderNewRoute()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'add-button' },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                disabled: this.props.savingNewRoute,
	                onClick: function onClick() {
	                  _this2.addNewRoute();
	                }
	              },
	              _react2.default.createElement('em', { className: 'fa fa-plus' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NewRouteModal;
	}(_react.Component);
	
	NewRouteModal.defaultProps = {
	  routes: {}
	};
	
	NewRouteModal.propTypes = {
	  routes: _propTypes2.default.object,
	  action: _propTypes2.default.func.isRequired,
	  saveNewRoute: _propTypes2.default.func.isRequired,
	  savingNewRoute: _propTypes2.default.bool.isRequired
	};
	
	var _default = NewRouteModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(NewRouteModal, 'NewRouteModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/NewRouteModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/NewRouteModal.jsx');
	}();

	;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _constants = __webpack_require__(11);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _genericRadioFilter = __webpack_require__(50);
	
	var _genericRadioFilter2 = _interopRequireDefault(_genericRadioFilter);
	
	var _EditRouteModal = __webpack_require__(561);
	
	var _EditRouteModal2 = _interopRequireDefault(_EditRouteModal);
	
	var _NewRouteModal = __webpack_require__(562);
	
	var _NewRouteModal2 = _interopRequireDefault(_NewRouteModal);
	
	var _EditRoutePrinterModal = __webpack_require__(329);
	
	var _EditRoutePrinterModal2 = _interopRequireDefault(_EditRoutePrinterModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditRoutes = function (_Component) {
	  _inherits(EditRoutes, _Component);
	
	  function EditRoutes() {
	    _classCallCheck(this, EditRoutes);
	
	    var _this = _possibleConstructorReturn(this, (EditRoutes.__proto__ || Object.getPrototypeOf(EditRoutes)).call(this));
	
	    _this.dayDict = {
	      MonStop: 'MonRoute',
	      TuesStop: 'TuesRoute',
	      WedStop: 'WedRoute',
	      ThursStop: 'ThursRoute',
	      FriStop: 'FriStop',
	      SatStop: 'SatStop',
	      SunStop: 'SunStop'
	    };
	
	    _this.closeEditRoutePrinterModal = function () {
	      _this.setState({ editRoutePrinterOpen: false });
	    };
	
	    _this.state = {
	      customers: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null,
	        filters: null,
	        filteredRows: [],
	        selectedRow: null
	      },
	      allRoutes: {},
	      customersWithStops: {},
	      day: 'All',
	      newRouteOpen: false,
	      editRouteOpen: false,
	      editRoutePrinterOpen: false,
	      selectedRoute: '',
	      selectedDay: '',
	      selectedCustomer: ''
	    };
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.handleOnClick = _this.handleOnClick.bind(_this);
	    _this.addNewRoute = _this.addNewRoute.bind(_this);
	    _this.openNewRouteModal = _this.openNewRouteModal.bind(_this);
	    _this.closeNewRouteModal = _this.closeNewRouteModal.bind(_this);
	    _this.openEditRouteModal = _this.openEditRouteModal.bind(_this);
	    _this.closeEditRouteModal = _this.closeEditRouteModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(EditRoutes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.handleResize);
	      this.props.fetchRoutes();
	      this.props.fetchActiveCustomers();
	      this.props.fetchCustomerRoutes(this.state.day);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.customerRoutes && nextProps.customerRoutes !== this.props.customerRoutes) {
	        var newCustomerRoutes = [].concat(_toConsumableArray(nextProps.customerRoutes));
	        newCustomerRoutes.map(function (row) {
	          row.MonStop = row.Stops[0].StopNum ? row.Stops[0].StopNum : '-';
	          row.MonRoute = row.Stops[0].RouteNum ? row.Stops[0].RouteNum : '-';
	          row.TuesStop = row.Stops[1].StopNum ? row.Stops[1].StopNum : '-';
	          row.TuesRoute = row.Stops[1].RouteNum ? row.Stops[1].RouteNum : '-';
	          row.WedStop = row.Stops[2].StopNum ? row.Stops[2].StopNum : '-';
	          row.WedRoute = row.Stops[2].RouteNum ? row.Stops[2].RouteNum : '-';
	          row.ThursStop = row.Stops[3].StopNum ? row.Stops[3].StopNum : '-';
	          row.ThursRoute = row.Stops[3].RouteNum ? row.Stops[3].RouteNum : '-';
	          row.FriStop = row.Stops[4].StopNum ? row.Stops[4].StopNum : '-';
	          row.FriRoute = row.Stops[4].RouteNum ? row.Stops[4].RouteNum : '-';
	          row.SatStop = row.Stops[5].StopNum ? row.Stops[5].StopNum : '-';
	          row.SatRoute = row.Stops[5].RouteNum ? row.Stops[5].RouteNum : '-';
	          row.SundayStop = row.Stops[6].StopNum ? row.Stops[6].StopNum : '-';
	          row.SundayRoute = row.Stops[6].RouteNum ? row.Stops[6].RouteNum : '-';
	        });
	        var customers = _extends({}, this.state.customers, { rows: newCustomerRoutes });
	        if (this.state.day === 'All') {
	          this.setState({ customersWithStops: customers });
	        }
	        this.setState({ customers: customers });
	      }
	
	      if (nextProps.routes && nextProps.routes !== this.props.routes) {
	        var routes = {
	          mon: ['-'],
	          tues: ['-'],
	          wed: ['-'],
	          thurs: ['-'],
	          fri: ['-'],
	          sat: ['-'],
	          sun: ['-']
	        };
	        nextProps.routes.map(function (route) {
	          // routes.push(route.RouteNum);
	          if (route.RouteNum.includes('A')) {
	            routes.mon.push(String(route.RouteNum));
	          } else if (route.RouteNum.includes('B')) {
	            routes.tues.push(String(route.RouteNum));
	          } else if (route.RouteNum.includes('C')) {
	            routes.wed.push(String(route.RouteNum));
	          } else if (route.RouteNum.includes('D')) {
	            routes.thurs.push(String(route.RouteNum));
	          } else if (route.RouteNum.includes('E')) {
	            routes.fri.push(String(route.RouteNum));
	          } else if (route.RouteNum.includes('F')) {
	            routes.sat.push(String(route.RouteNum));
	          } else if (route.RouteNum.includes('G')) {
	            routes.sun.push(String(route.RouteNum));
	          }
	        });
	        this.setState({ routes: routes }, function () {
	          return _this2.setState({ allRoutes: nextProps.routes });
	        });
	      }
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	    }
	  }, {
	    key: 'saveRouteEdits',
	    value: function saveRouteEdits(oldRoute, newRoute, email, driverId) {
	      var _this3 = this;
	
	      this.props.saveRouteEdits(oldRoute, newRoute, email, driverId).then(function () {
	        _this3.props.fetchCustomerRoutes('All');
	      });
	      this.setState({ editRouteOpen: false, day: 'All' });
	    }
	  }, {
	    key: 'openNewRouteModal',
	    value: function openNewRouteModal() {
	      this.setState({ newRouteOpen: true });
	    }
	  }, {
	    key: 'closeNewRouteModal',
	    value: function closeNewRouteModal() {
	      this.setState({ newRouteOpen: false });
	    }
	  }, {
	    key: 'openEditRouteModal',
	    value: function openEditRouteModal() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      if (!args[1]) {
	        return;
	      }
	      var selectedDay = void 0;
	      var selectedRoute = void 0;
	      var selectedCustomer = void 0;
	      switch (args[1]) {
	        case 'Monday':
	          selectedDay = { value: 'Monday', label: 'Monday' };
	          selectedRoute = { value: args[0].MonRoute, label: args[0].MonRoute, email: args[0].Stops[0].Email };
	          break;
	        case 'Tuesday':
	          selectedDay = { value: 'Tuesday', label: 'Tuesday' };
	          selectedRoute = { value: args[0].TuesRoute, label: args[0].TuesRoute, email: args[0].Stops[1].Email };
	          break;
	        case 'Wednesday':
	          selectedDay = { value: 'Wednesday', label: 'Wednesday' };
	          selectedRoute = { value: args[0].WedRoute, label: args[0].WedRoute, email: args[0].Stops[2].Email };
	          break;
	        case 'Thursday':
	          selectedDay = { value: 'Thursday', label: 'Thursday' };
	          selectedRoute = { value: args[0].ThursRoute, label: args[0].ThursRoute, email: args[0].Stops[3].Email };
	          break;
	        case 'Friday':
	          selectedDay = { value: 'Friday', label: 'Friday' };
	          selectedRoute = { value: args[0].FriRoute, label: args[0].FriRoute, email: args[0].Stops[4].Email };
	          break;
	        case 'Saturday':
	          selectedDay = { value: 'Saturday', label: 'Saturday' };
	          selectedRoute = { value: args[0].SatRoute, label: args[0].SatRoute, email: args[0].Stops[5].Email };
	          break;
	        case 'Sunday':
	          selectedDay = { value: 'Sunday', label: 'Sunday' };
	          selectedRoute = { value: args[0].SundayRoute, label: args[0].SundayRoute, email: args[0].Stops[6].Email };
	          break;
	        default:
	          break;
	      }
	      if (selectedRoute && selectedRoute.value === '-') {
	        selectedCustomer = { value: args[0].Name, label: args[0].Name };
	      }
	      this.setState({
	        editRouteOpen: true, selectedDay: selectedDay, selectedRoute: selectedRoute, selectedCustomer: selectedCustomer
	      });
	    }
	  }, {
	    key: 'openEditRoutePrinterModal',
	    value: function openEditRoutePrinterModal() {
	      this.setState({
	        editRoutePrinterOpen: true
	      });
	    }
	  }, {
	    key: 'closeEditRouteModal',
	    value: function closeEditRouteModal() {
	      this.setState({ editRouteOpen: false });
	    }
	  }, {
	    key: 'addNewRoute',
	    value: function addNewRoute(day) {
	      var _this4 = this;
	
	      this.props.saveNewRoute(day, this.props.fetchRoutes).then(function () {
	        _this4.props.fetchCustomerRoutes('All');
	      });
	      this.setState({ newRouteOpen: false, day: 'All' });
	    }
	  }, {
	    key: 'handleOnClick',
	    value: function handleOnClick(day) {
	      var _this5 = this;
	
	      this.setState({ day: day }, function () {
	        _this5.props.fetchCustomerRoutes(day);
	      });
	    }
	  }, {
	    key: 'renderCustomerRoutes',
	    value: function renderCustomerRoutes() {
	      var _this6 = this;
	
	      if (this.props.customerRoutesIsLoading && !this.props.customerRoutesError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.customerRoutesError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.customerRoutesError)
	        )
	      );
	
	      // Parameters of the react-data-grid
	      var tableHeight = window.innerHeight < 900 ? 545 : 545;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this6.state.customers);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var customers = Object.assign({}, _this6.state.customers, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this6.setState({ customers: customers });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var filteredRows = [].concat(_toConsumableArray(_this6.state.customers.rows));
	        var newFilters = Object.assign({}, _this6.state.customers.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var customers = _extends({}, _this6.state.customers, { filters: newFilters, filteredRows: filteredRows });
	        _this6.setState({ customers: customers });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        var customers = _extends({}, _this6.state.customers, { filteredRows: [], filters: {} });
	        _this6.setState({ customers: customers });
	      };
	
	      var handleRowUpdated = function handleRowUpdated() {
	        _this6.setState({ editRouteOpen: true });
	      };
	
	      var RowRenderer = _react2.default.createClass({
	        displayName: 'RowRenderer',
	
	        PropTypes: {
	          onDoubleClick: _react2.default.PropTypes.func
	        },
	        render: function render() {
	          var _this7 = this;
	
	          return _react2.default.createElement(
	            'div',
	            { onDoubleClick: function onDoubleClick() {
	                _this7.props.onDoubleClick(_this7.props);
	              } },
	            _react2.default.createElement(_reactDataGrid2.default.Row, _extends({
	              ref: 'row'
	            }, this.props))
	          );
	        }
	      });
	
	      var StopFormatter = _react2.default.createClass({
	        displayName: 'StopFormatter',
	        render: function render() {
	          if (this.props.value.StopNum) return _react2.default.createElement(
	            'span',
	            null,
	            this.props.value.StopNum
	          );
	          return _react2.default.createElement(
	            'span',
	            null,
	            '-'
	          );
	        }
	      });
	
	      var RouteFormatter = _react2.default.createClass({
	        displayName: 'RouteFormatter',
	        render: function render() {
	          if (this.props.value.DispatchRoute_id) return _react2.default.createElement(
	            'span',
	            null,
	            this.props.value.DispatchRoute_id
	          );
	          return _react2.default.createElement(
	            'span',
	            null,
	            '-'
	          );
	        }
	      });
	
	      var MondayRouteFormatter = _react2.default.createClass({
	        displayName: 'MondayRouteFormatter',
	        render: function render() {
	          var _this8 = this;
	
	          if (this.props.value) {
	            return _react2.default.createElement(
	              'span',
	              { onDoubleClick: function onDoubleClick() {
	                  _this8.props.onDoubleClick(_this8.props.dependentValues, 'Monday');
	                } },
	              _react2.default.createElement(
	                'span',
	                { style: { color: 'blue' } },
	                this.props.value
	              )
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            '-'
	          );
	        }
	      });
	
	      var TuesdayRouteFormatter = _react2.default.createClass({
	        displayName: 'TuesdayRouteFormatter',
	        render: function render() {
	          var _this9 = this;
	
	          if (this.props.value) {
	            return _react2.default.createElement(
	              'span',
	              { onDoubleClick: function onDoubleClick() {
	                  _this9.props.onDoubleClick(_this9.props.dependentValues, 'Tuesday');
	                } },
	              _react2.default.createElement(
	                'span',
	                { style: { color: 'royalblue' } },
	                this.props.value
	              )
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            '-'
	          );
	        }
	      });
	
	      var WednesdayRouteFormatter = _react2.default.createClass({
	        displayName: 'WednesdayRouteFormatter',
	        render: function render() {
	          var _this10 = this;
	
	          if (this.props.value) {
	            return _react2.default.createElement(
	              'span',
	              { onDoubleClick: function onDoubleClick() {
	                  _this10.props.onDoubleClick(_this10.props.dependentValues, 'Wednesday');
	                } },
	              _react2.default.createElement(
	                'span',
	                { style: { color: 'teal' } },
	                this.props.value
	              )
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            '-'
	          );
	        }
	      });
	
	      var ThursdayRouteFormatter = _react2.default.createClass({
	        displayName: 'ThursdayRouteFormatter',
	        render: function render() {
	          var _this11 = this;
	
	          if (this.props.value) {
	            return _react2.default.createElement(
	              'span',
	              { onDoubleClick: function onDoubleClick() {
	                  _this11.props.onDoubleClick(_this11.props.dependentValues, 'Thursday');
	                } },
	              _react2.default.createElement(
	                'span',
	                { style: { color: 'green' } },
	                this.props.value
	              )
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            '-'
	          );
	        }
	      });
	
	      var FridayRouteFormatter = _react2.default.createClass({
	        displayName: 'FridayRouteFormatter',
	        render: function render() {
	          var _this12 = this;
	
	          if (this.props.value) {
	            return _react2.default.createElement(
	              'span',
	              { onDoubleClick: function onDoubleClick() {
	                  _this12.props.onDoubleClick(_this12.props.dependentValues, 'Friday');
	                } },
	              _react2.default.createElement(
	                'span',
	                { style: { color: 'indigo' } },
	                this.props.value
	              )
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            '-'
	          );
	        }
	      });
	
	      var SaturdayRouteFormatter = _react2.default.createClass({
	        displayName: 'SaturdayRouteFormatter',
	        render: function render() {
	          var _this13 = this;
	
	          if (this.props.value) {
	            return _react2.default.createElement(
	              'span',
	              { onDoubleClick: function onDoubleClick() {
	                  _this13.props.onDoubleClick(_this13.props.dependentValues, 'Saturday');
	                } },
	              _react2.default.createElement(
	                'span',
	                { style: { color: 'rebeccapurple' } },
	                this.props.value
	              )
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            '-'
	          );
	        }
	      });
	
	      var SundayRouteFormatter = _react2.default.createClass({
	        displayName: 'SundayRouteFormatter',
	        render: function render() {
	          var _this14 = this;
	
	          if (this.props.value) {
	            return _react2.default.createElement(
	              'span',
	              { onDoubleClick: function onDoubleClick() {
	                  _this14.props.onDoubleClick(_this14.props.dependentValues, 'Sunday');
	                } },
	              _react2.default.createElement(
	                'span',
	                { style: { color: 'purple' } },
	                this.props.value
	              )
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            '-'
	          );
	        }
	      });
	
	      var MondayStopFormatter = _react2.default.createClass({
	        displayName: 'MondayStopFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            { style: { color: 'blue' } },
	            this.props.value
	          );
	          return _react2.default.createElement(
	            'span',
	            null,
	            '-'
	          );
	        }
	      });
	
	      var TuesdayStopFormatter = _react2.default.createClass({
	        displayName: 'TuesdayStopFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            { style: { color: 'royalblue' } },
	            this.props.value
	          );
	          return _react2.default.createElement(
	            'span',
	            null,
	            '-'
	          );
	        }
	      });
	
	      var WednesdayStopFormatter = _react2.default.createClass({
	        displayName: 'WednesdayStopFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            { style: { color: 'teal' } },
	            this.props.value
	          );
	          return _react2.default.createElement(
	            'span',
	            null,
	            '-'
	          );
	        }
	      });
	
	      var ThursdayStopFormatter = _react2.default.createClass({
	        displayName: 'ThursdayStopFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            { style: { color: 'green' } },
	            this.props.value
	          );
	          return _react2.default.createElement(
	            'span',
	            null,
	            '-'
	          );
	        }
	      });
	
	      var FridayStopFormatter = _react2.default.createClass({
	        displayName: 'FridayStopFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            { style: { color: 'indigo' } },
	            this.props.value
	          );
	          return _react2.default.createElement(
	            'span',
	            null,
	            '-'
	          );
	        }
	      });
	
	      var SaturdayStopFormatter = _react2.default.createClass({
	        displayName: 'SaturdayStopFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            { style: { color: 'rebeccapurple' } },
	            this.props.value
	          );
	          return _react2.default.createElement(
	            'span',
	            null,
	            '-'
	          );
	        }
	      });
	
	      var SundayStopFormatter = _react2.default.createClass({
	        displayName: 'SundayStopFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            { style: { color: 'purple' } },
	            this.props.value
	          );
	          return _react2.default.createElement(
	            'span',
	            null,
	            '-'
	          );
	        }
	      });
	
	      // Column difinition
	      var columns = [{
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: 'CustomerNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_number' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'MonRoute',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mon_route' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true,
	        formatter: _react2.default.createElement(MondayRouteFormatter, { onDoubleClick: this.openEditRouteModal }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'MonStop',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mon_stop' }),
	        resizable: true,
	        sortable: true,
	        width: 50,
	        filterable: true,
	        formatter: MondayStopFormatter
	      }, {
	        key: 'TuesRoute',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tue_route' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true,
	        formatter: _react2.default.createElement(TuesdayRouteFormatter, { onDoubleClick: this.openEditRouteModal }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'TuesStop',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tue_stop' }),
	        resizable: true,
	        sortable: true,
	        width: 50,
	        filterable: true,
	        formatter: TuesdayStopFormatter
	      }, {
	        key: 'WedRoute',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'wed_route' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true,
	        formatter: _react2.default.createElement(WednesdayRouteFormatter, { onDoubleClick: this.openEditRouteModal }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'WedStop',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'wed_stop' }),
	        resizable: true,
	        sortable: true,
	        width: 50,
	        filterable: true,
	        formatter: WednesdayStopFormatter
	      }, {
	        key: 'ThursRoute',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'thu_route' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true,
	        formatter: _react2.default.createElement(ThursdayRouteFormatter, { onDoubleClick: this.openEditRouteModal }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'ThursStop',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'thu_stop' }),
	        resizable: true,
	        sortable: true,
	        width: 50,
	        filterable: true,
	        formatter: ThursdayStopFormatter
	      }, {
	        key: 'FriRoute',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fri_route' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true,
	        formatter: _react2.default.createElement(FridayRouteFormatter, { onDoubleClick: this.openEditRouteModal }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'FriStop',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fri_stop' }),
	        resizable: true,
	        sortable: true,
	        width: 50,
	        filterable: true,
	        formatter: FridayStopFormatter
	      }, {
	        key: 'SatRoute',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sat_route' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true,
	        formatter: _react2.default.createElement(SaturdayRouteFormatter, { onDoubleClick: this.openEditRouteModal }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'SatStop',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sat_stop' }),
	        resizable: true,
	        sortable: true,
	        width: 50,
	        filterable: true,
	        formatter: SaturdayStopFormatter
	      }, {
	        key: 'SunRoute',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sun_route' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true,
	        formatter: _react2.default.createElement(SundayRouteFormatter, { onDoubleClick: this.openEditRouteModal }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'SunStop',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sun_stop' }),
	        resizable: true,
	        sortable: true,
	        width: 50,
	        filterable: true,
	        formatter: SundayStopFormatter
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12, id: 'EditRoutes-dataGrid1' },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '99%' } },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'Customer_id',
	              onGridSort: handleGridSort,
	              onAddFilter: handleFilterChange,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              enableCellSelect: true,
	              columns: columns,
	              rowHeight: 25,
	              headerRowHeight: 50,
	              rowGetter: rowGetter,
	              rowsCount: getSize()
	              // rowRenderer={<RowRenderer onDoubleClick={this.openEditRouteModal} />}
	              , minHeight: tableHeight
	              // onRowUpdated={handleRowUpdated}
	              , onClearFilters: onClearFilters
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this15 = this;
	
	      var newRouteModal = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_route' });
	      var editRouteModal = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_routes' });
	      var createNewRouteDialogStyle = {
	        width: '500px',
	        marginLeft: '-10%'
	      };
	      var createEditRouteDialogStyle = {
	        width: '1200px',
	        height: '650px',
	        marginTop: '-330px',
	        marginLeft: '-30%'
	      };
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_routes' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'disptach-edit-routes' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { id: 'date-range-picker', className: 'form-horizontal' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 1 },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'filter-title' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'filter' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'colon' },
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 11 },
	                      (0, _genericRadioFilter2.default)({
	                        content: [{
	                          option: 'All',
	                          id: 'all-radio-filter',
	                          name: 'dayFilterRadios',
	                          labelName: 'all'
	                        }, {
	                          option: 'Monday',
	                          id: 'mon-radio-filter',
	                          name: 'dayFilterRadios',
	                          labelName: 'mon'
	                        }, {
	                          option: 'Tuesday',
	                          id: 'tues-radio-filter',
	                          name: 'dayFilterRadios',
	                          labelName: 'tues'
	                        }, {
	                          option: 'Wednesday',
	                          id: 'wed-radio-filter',
	                          name: 'dayFilterRadios',
	                          labelName: 'wed'
	                        }, {
	                          option: 'Thursday',
	                          id: 'thu-radio-filter',
	                          name: 'dayFilterRadios',
	                          labelName: 'thu'
	                        }, {
	                          option: 'Friday',
	                          id: 'fri-radio-filter',
	                          name: 'dayFilterRadios',
	                          labelName: 'fri'
	                        }, {
	                          option: 'Saturday',
	                          id: 'sat-radio-filter',
	                          name: 'dayFilterRadios',
	                          labelName: 'sat'
	                        }, {
	                          option: 'Sunday',
	                          id: 'sun-radio-filter',
	                          name: 'dayFilterRadios',
	                          labelName: 'sun'
	                        }],
	                        value: this.state.day,
	                        handleOnClick: this.handleOnClick,
	                        type: 'buttons'
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'position-relative', id: 'routes-table' },
	                  _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    { className: 'table-buttons' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'primary',
	                        onClick: function onClick() {
	                          _this15.openNewRouteModal();
	                        }
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_new_route' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'warning',
	                        onClick: function onClick() {
	                          _this15.openEditRouteModal(null, 'all');
	                        }
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_route' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'warning',
	                        onClick: function onClick() {
	                          _this15.openEditRoutePrinterModal(null, 'all');
	                        }
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_printer' })
	                    )
	                  ),
	                  this.renderCustomerRoutes()
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createNewRouteDialogStyle,
	              isVisible: this.state.newRouteOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this15.closeNewRouteModal();
	              },
	              title: newRouteModal
	            },
	            _react2.default.createElement(_NewRouteModal2.default, {
	              routes: this.state.allRoutes,
	              close: this.closeNewRouteModal,
	              action: function action(day) {
	                _this15.addNewRoute(day);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createEditRouteDialogStyle,
	              isVisible: this.state.editRouteOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this15.closeEditRouteModal();
	              },
	              title: editRouteModal
	            },
	            _react2.default.createElement(_EditRouteModal2.default, {
	              allRoutes: this.state.allRoutes,
	              customersWithStops: this.state.customersWithStops,
	              allCustomers: this.props.allCustomers,
	              selectedRoute: this.state.selectedRoute,
	              selectedDay: this.state.selectedDay,
	              selectedCustomer: this.state.selectedCustomer,
	              close: this.closeEditRouteModal,
	              action: function action(oldRoute, newRoute, email, driverId) {
	                _this15.saveRouteEdits(oldRoute, newRoute, email, driverId);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createEditRouteDialogStyle,
	              isVisible: this.state.editRoutePrinterOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this15.closeEditRoutePrinterModal();
	              },
	              title: editRouteModal
	            },
	            _react2.default.createElement(_EditRoutePrinterModal2.default, {
	              close: this.closeEditRoutePrinterModal
	            })
	          )
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return EditRoutes;
	}(_react.Component);
	
	EditRoutes.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = EditRoutes;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(EditRoutes, 'EditRoutes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/editRoutes.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/editRoutes.jsx');
	}();

	;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _GenericDatePicker = __webpack_require__(48);
	
	var _GenericDatePicker2 = _interopRequireDefault(_GenericDatePicker);
	
	var _cleanDates = __webpack_require__(22);
	
	var _keys = __webpack_require__(118);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _PrintIframe = __webpack_require__(63);
	
	var _PrintIframe2 = _interopRequireDefault(_PrintIframe);
	
	var _DispatchMap = __webpack_require__(162);
	
	var _DispatchMap2 = _interopRequireDefault(_DispatchMap);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEcity = _root_url.ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === "https://dev-scm.truckxi.com/api/";
	
	var _require = __webpack_require__(5),
	    _require$Draggable = _require.Draggable,
	    DraggableContainer = _require$Draggable.Container,
	    RowActionsCell = _require$Draggable.RowActionsCell,
	    DropTargetRowContainer = _require$Draggable.DropTargetRowContainer,
	    Selectors = _require.Data.Selectors;
	
	var DropDownEditor = _reactDataGridAddons.Editors.DropDownEditor;
	
	
	var RowRenderer = DropTargetRowContainer(_reactDataGrid2.default.Row);
	
	var propTypes = {
	  rowKey: _propTypes2.default.string,
	  value: _propTypes2.default.node,
	  stopsIsLoading: _propTypes2.default.bool,
	  routesIsLoading: _propTypes2.default.bool,
	  savingStopEdits: _propTypes2.default.bool,
	  routingPdfFailure: _propTypes2.default.bool,
	  assigningOrderRoute: _propTypes2.default.bool,
	  requestingRoutingPdf: _propTypes2.default.bool,
	  pickingListPdfFailure: _propTypes2.default.bool,
	  packingListPdfFailure: _propTypes2.default.bool,
	  salesInvoicePdfFailure: _propTypes2.default.bool,
	  requestingPickingListPdf: _propTypes2.default.bool,
	  requestingPackingListPdf: _propTypes2.default.bool,
	  unassignedOrdersIsLoading: _propTypes2.default.bool,
	  requestingDispatchSalesInvoicePdf: _propTypes2.default.bool,
	  routesError: _propTypes2.default.oneOfType([_propTypes2.default.shape({}), _propTypes2.default.bool]),
	  stopsError: _propTypes2.default.oneOfType([_propTypes2.default.shape({}), _propTypes2.default.bool]),
	  unassignedOrdersError: _propTypes2.default.shape({}),
	  routes: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  stops: _propTypes2.default.shape({
	    Active: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      ActiveStopNum: _propTypes2.default.number,
	      City: _propTypes2.default.string,
	      CustomerNum: _propTypes2.default.string,
	      Description: _propTypes2.default.string,
	      IsActive: _propTypes2.default.bool,
	      Name: _propTypes2.default.string
	    })),
	    DriverLocation: _propTypes2.default.string,
	    Inactive: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      // Same as active
	      StopNum: _propTypes2.default.number
	    })),
	    Warehouse: _propTypes2.default.shape({
	      lat: _propTypes2.default.number,
	      lng: _propTypes2.default.number
	    })
	  }),
	  dependentValues: _propTypes2.default.shape({
	    TempDate: _propTypes2.default.string
	  }),
	  unassignedOrders: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  routingPdf: _propTypes2.default.shape({}),
	  pickingListPdf: _propTypes2.default.shape({}),
	  packingListPdf: _propTypes2.default.shape({}),
	  dispatchSalesInvoicePdf: _propTypes2.default.shape({}),
	  remove: _propTypes2.default.func,
	  fetchStops: _propTypes2.default.func,
	  fetchRoutes: _propTypes2.default.func,
	  saveEditedStops: _propTypes2.default.func,
	  assignOrderRoute: _propTypes2.default.func,
	  printDispatchRoute: _propTypes2.default.func,
	  fetchUnassignedOrders: _propTypes2.default.func,
	  printDispatchPickingList: _propTypes2.default.func,
	  printDispatchPackingList: _propTypes2.default.func,
	  printDispatchSalesInvoice: _propTypes2.default.func
	};
	
	var defaultProps = {
	  value: null,
	  rowKey: 'ActiveStopNum',
	  stopsIsLoading: false,
	  routesIsLoading: false,
	  savingStopEdits: false,
	  routingPdfFailure: false,
	  assigningOrderRoute: false,
	  requestingRoutingPdf: false,
	  pickingListPdfFailure: false,
	  packingListPdfFailure: false,
	  salesInvoicePdfFailure: false,
	  requestingPickingListPdf: false,
	  requestingPackingListPdf: false,
	  unassignedOrdersIsLoading: false,
	  requestingDispatchSalesInvoicePdf: false,
	  stopsError: {},
	  routesError: {},
	  routes: [],
	  stops: {},
	  dependentValues: {},
	  unassignedOrders: [],
	  routingPdf: {},
	  pickingListPdf: {},
	  packingListPdf: {},
	  unassignedOrdersError: {},
	  dispatchSalesInvoicePdf: {},
	  remove: function remove() {},
	  fetchStops: function fetchStops() {},
	  fetchRoutes: function fetchRoutes() {},
	  saveEditedStops: function saveEditedStops() {},
	  assignOrderRoute: function assignOrderRoute() {},
	  printDispatchRoute: function printDispatchRoute() {},
	  fetchUnassignedOrders: function fetchUnassignedOrders() {},
	  printDispatchPickingList: function printDispatchPickingList() {},
	  printDispatchPackingList: function printDispatchPackingList() {},
	  printDispatchSalesInvoice: function printDispatchSalesInvoice() {}
	};
	
	var contextTypes = {
	  router: _propTypes2.default.shape({})
	};
	
	var Routing = function (_Component) {
	  _inherits(Routing, _Component);
	
	  function Routing() {
	    _classCallCheck(this, Routing);
	
	    var _this = _possibleConstructorReturn(this, (Routing.__proto__ || Object.getPrototypeOf(Routing)).call(this));
	
	    _this.toggleGoogleMaps = function () {
	      _this.setState({ showGoogleMaps: !_this.state.showGoogleMaps });
	    };
	
	    _this.saveChanges = function () {
	      var _this$state = _this.state,
	          routes = _this$state.routes,
	          activeStops = _this$state.activeStops,
	          deliveryDateChosen = _this$state.deliveryDateChosen,
	          dispatchRouteId = _this$state.dispatchRouteId;
	
	      var editedRows = _lodash2.default.filter(_this.state.orders.editedRows, function (row) {
	        return row.RouteNum !== '';
	      });
	      if (editedRows.length < 0 && routes.length < 0) {
	        return;
	      }
	      editedRows = _this.formatDeliveryTime(editedRows);
	      var routeNum = _this.state.routes.selectedRows[0].RouteNum;
	      _this.props.saveEditedStops(activeStops.rows, deliveryDateChosen, dispatchRouteId).then(function () {
	        _this.props.assignOrderRoute(editedRows).then(function () {
	          _this.props.fetchStops(routeNum, deliveryDateChosen);
	          _this.props.fetchUnassignedOrders(deliveryDateChosen);
	          var orders = _extends({}, _this.state.orders, { editedRows: [] });
	          _this.setState({ orders: orders });
	        });
	      });
	    };
	
	    _this.formatDeliveryTime = function (editedRows) {
	      editedRows.map(function (row) {
	        if (row.ETADate) {
	          var periodOfTheDay = row.ETADate.substr(-2);
	          var etaDate = parseInt(row.ETADate, 10);
	          if (periodOfTheDay === 'PM' && etaDate !== 12) {
	            etaDate = 12 + parseInt(row.ETADate, 10);
	          }
	          row.ETADate = (0, _cleanDates.convertTimeToUtc)(etaDate, row.DispatchDate);
	        } else {
	          // Makes sure empty strings are not passed to backend
	          row.ETADate = undefined;
	        }
	      });
	      return editedRows;
	    };
	
	    _this.state = {
	      routeOptions: [],
	
	      routes: {
	        rows: [],
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	      activeStops: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	      inactiveStops: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      orders: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null,
	        filters: null,
	        filteredRows: [],
	        selectedRow: null,
	        editedRows: []
	      },
	      deliveryDateChosen: new Date(),
	      dispatchRouteId: null,
	      tabKey: 1,
	      routePdfFrameLoaded: true,
	      pickingListPdfFrameLoaded: true,
	      packingListPdfFrameLoaded: true,
	      salesInvoicePdfFrameLoaded: true,
	
	      showGoogleMaps: false,
	      centerCoordinates: {
	        lat: 34.019733,
	        lng: -117.958672
	      }
	    };
	
	    _this.setDeliveryDate = _this.setDeliveryDate.bind(_this);
	    _this.handleTabSelect = _this.handleTabSelect.bind(_this);
	    _this.routeIFrameIsLoaded = _this.routeIFrameIsLoaded.bind(_this);
	    _this.pickingListIFrameIsLoaded = _this.pickingListIFrameIsLoaded.bind(_this);
	    _this.packingListIFrameIsLoaded = _this.packingListIFrameIsLoaded.bind(_this);
	    _this.salesInvoiceIFrameIsLoaded = _this.salesInvoiceIFrameIsLoaded.bind(_this);
	    _this.removeRow = _this.removeRow.bind(_this);
	    return _this;
	  }
	
	  _createClass(Routing, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.fetchRoutes(this.state.deliveryDateChosen);
	      this.props.fetchUnassignedOrders(this.state.deliveryDateChosen);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.routes && nextProps.routes !== this.props.routes) {
	        var newRoutes = _lodash2.default.cloneDeep(nextProps.routes);
	        var dispatchRouteId = void 0;
	        if (newRoutes.length > 0) {
	          dispatchRouteId = newRoutes[0].DispatchRoute_id;
	          newRoutes[0].isSelected = true;
	        }
	        var routes = _extends({}, this.state.routes, {
	          rows: newRoutes,
	          selectedRows: [newRoutes[0]]
	        });
	        this.setState({ routes: routes, dispatchRouteId: dispatchRouteId }, function () {
	          _this2.props.fetchStops(routes.rows[0].RouteNum, _this2.state.deliveryDateChosen);
	        });
	      }
	
	      if (nextProps.stops && nextProps.stops.Warehouse && nextProps.stops.Warehouse !== this.props.stops.Warehouse) {
	        var centerCoordinates = nextProps.stops.Warehouse;
	        this.setState({ centerCoordinates: centerCoordinates });
	      }
	
	      if (nextProps.stops && nextProps.stops.Active && nextProps.stops.Active !== this.props.stops.Active) {
	        var newStops = _lodash2.default.cloneDeep(nextProps.stops.Active);
	        var activeStops = _extends({}, this.state.activeStops, { rows: newStops });
	        this.setState({ activeStops: activeStops });
	      }
	
	      if (nextProps.stops && nextProps.stops.Inactive && nextProps.stops.Inactive !== this.props.stops.Inactive) {
	        var _newStops = _lodash2.default.cloneDeep(nextProps.stops.Inactive);
	        var inactiveStops = _extends({}, this.state.inactiveStops, { rows: _newStops });
	        this.setState({ inactiveStops: inactiveStops });
	      }
	
	      if (nextProps.unassignedOrders && nextProps.unassignedOrders !== this.props.unassignedOrders) {
	        var routeOptions = [''];
	        nextProps.routes.map(function (route) {
	          routeOptions.push(route.RouteNum);
	        });
	        var orders = _extends({}, this.state.orders, { rows: nextProps.unassignedOrders.filter(function (order) {
	            if (isEcity) {
	              return order.IsMobile;
	            }
	            return true;
	          }) });
	        this.setState({ orders: orders, routeOptions: routeOptions });
	      }
	
	      if (nextProps.routingPdf && nextProps.routingPdf !== this.props.routingPdf) {
	        this.setState({ routePdfFrameLoaded: false });
	      }
	
	      if (nextProps.pickingListPdf && nextProps.pickingListPdf !== this.props.pickingListPdf) {
	        this.setState({ pickingListPdfFrameLoaded: false });
	      }
	
	      if (nextProps.packingListPdf && nextProps.packingListPdf !== this.props.packingListPdf) {
	        this.setState({ packingListPdfFrameLoaded: false });
	      }
	
	      if (nextProps.dispatchSalesInvoicePdf && nextProps.dispatchSalesInvoicePdf !== this.props.dispatchSalesInvoicePdf) {
	        this.setState({ salesInvoicePdfFrameLoaded: false });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState.routePdfFrameLoaded !== this.state.routePdfFrameLoaded && this.state.routePdfFrameLoaded === false) {
	        return false;
	      }
	      if (nextState.pickingListPdfFrameLoaded !== this.state.pickingListPdfFrameLoaded && this.state.pickingListPdfFrameLoaded === false) {
	        return false;
	      }
	      if (nextState.packingListPdfFrameLoaded !== this.state.packingListPdfFrameLoaded && this.state.packingListPdfFrameLoaded === false) {
	        return false;
	      }
	      if (nextState.salesInvoicePdfFrameLoaded !== this.state.salesInvoicePdfFrameLoaded && this.state.salesInvoicePdfFrameLoaded === false) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'setDeliveryDate',
	    value: function setDeliveryDate(e) {
	      var _this3 = this;
	
	      var orders = _extends({}, this.state.orders, { editedRows: [] });
	      this.setState({
	        orders: orders,
	        deliveryDateChosen: e
	      }, function () {
	        _this3.props.fetchRoutes(_this3.state.deliveryDateChosen).then(function () {
	          _this3.props.fetchStops(_this3.state.routes.rows[0].RouteNum, _this3.state.deliveryDateChosen);
	          _this3.setState({ dispatchRouteId: _this3.state.routes.rows[0].DispatchRoute_id });
	        });
	        _this3.props.fetchUnassignedOrders(_this3.state.deliveryDateChosen);
	      });
	    }
	  }, {
	    key: 'handleTabSelect',
	    value: function handleTabSelect(tabKey) {
	      this.setState({ tabKey: tabKey });
	    }
	  }, {
	    key: 'removeRow',
	    value: function removeRow(dependentValues) {
	      var rows = [].concat(_toConsumableArray(this.state.activeStops.rows));
	      rows = rows.filter(function (row) {
	        var match = row.ActiveStopNum !== dependentValues.ActiveStopNum;
	        return match;
	      });
	      rows.map(function (row, index) {
	        row.ActiveStopNum = index + 1;
	      });
	      var activeStops = _extends({}, this.state.activeStops, { rows: rows });
	      this.setState({ activeStops: activeStops });
	    }
	  }, {
	    key: 'routeIFrameIsLoaded',
	    value: function routeIFrameIsLoaded() {
	      this.setState({ routePdfFrameLoaded: true });
	    }
	  }, {
	    key: 'pickingListIFrameIsLoaded',
	    value: function pickingListIFrameIsLoaded() {
	      this.setState({ pickingListPdfFrameLoaded: true });
	    }
	  }, {
	    key: 'packingListIFrameIsLoaded',
	    value: function packingListIFrameIsLoaded() {
	      this.setState({ packingListPdfFrameLoaded: true });
	    }
	  }, {
	    key: 'salesInvoiceIFrameIsLoaded',
	    value: function salesInvoiceIFrameIsLoaded() {
	      this.setState({ salesInvoicePdfFrameLoaded: true });
	    }
	  }, {
	    key: 'renderPrintRouteIFrame',
	    value: function renderPrintRouteIFrame() {
	      var routePdfFrameLoaded = this.state.routePdfFrameLoaded;
	      var routingPdf = this.props.routingPdf;
	
	      return _react2.default.createElement(_PrintIframe2.default, {
	        id: 'routePdf',
	        loaded: routePdfFrameLoaded,
	        name: 'routePdf',
	        onLoad: this.routeIFrameIsLoaded,
	        pdf: routingPdf,
	        title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_routing' })
	      });
	    }
	  }, {
	    key: 'renderPrintPickingListIFrame',
	    value: function renderPrintPickingListIFrame() {
	      var pickingListPdfFrameLoaded = this.state.pickingListPdfFrameLoaded;
	      var pickingListPdf = this.props.pickingListPdf;
	
	      return _react2.default.createElement(_PrintIframe2.default, {
	        id: 'pickingListPdf',
	        loaded: pickingListPdfFrameLoaded,
	        name: 'pickingListPdf',
	        onLoad: this.pickingListIFrameIsLoaded,
	        pdf: pickingListPdf,
	        title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_picking_list' })
	      });
	    }
	  }, {
	    key: 'renderPrintPackingListIFrame',
	    value: function renderPrintPackingListIFrame() {
	      var packingListPdfFrameLoaded = this.state.packingListPdfFrameLoaded;
	      var packingListPdf = this.props.packingListPdf;
	
	      return _react2.default.createElement(_PrintIframe2.default, {
	        id: 'packingListPdf',
	        loaded: packingListPdfFrameLoaded,
	        name: 'packingListPdf',
	        onLoad: this.packingListIFrameIsLoaded,
	        pdf: packingListPdf,
	        title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_packing_list' })
	      });
	    }
	  }, {
	    key: 'renderPrintSalesInvoiceIFrame',
	    value: function renderPrintSalesInvoiceIFrame() {
	      var salesInvoicePdfFrameLoaded = this.state.salesInvoicePdfFrameLoaded;
	      var dispatchSalesInvoicePdf = this.props.dispatchSalesInvoicePdf;
	
	      return _react2.default.createElement(_PrintIframe2.default, {
	        id: 'dispatchSalesInvoicePdf',
	        loaded: salesInvoicePdfFrameLoaded,
	        name: 'dispatchSalesInvoicePdf',
	        onLoad: this.salesInvoiceIFrameIsLoaded,
	        pdf: dispatchSalesInvoicePdf,
	        title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_si' })
	      });
	    }
	  }, {
	    key: 'renderRoutes',
	    value: function renderRoutes() {
	      var _this4 = this;
	
	      if (this.props.routesIsLoading && !this.props.routesError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.routesError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger', id: 'dispatch-errors' },
	            JSON.stringify(this.props.routesError)
	          )
	        );
	      }
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.routes);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var routes = _extends({}, _this4.state.routes, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this4.setState({ routes: routes });
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        var rows = _this4.state.routes.rows.slice(0);
	        Object.assign(rows[e.rowIdx], e.updated);
	        var routes = _extends({}, _this4.state.routes, { rows: rows });
	        _this4.setState({ routes: routes });
	      };
	
	      var onCellSelected = function onCellSelected(coordinates) {
	        var newRows = getRows();
	        if (_this4.state.routes.selectedRows[0] === newRows[coordinates.rowIdx]) {
	          return;
	        }
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        var selectedRows = [newRows[coordinates.rowIdx]];
	        newRows[coordinates.rowIdx].isSelected = true;
	        var routes = _extends({}, _this4.state.routes, { rows: newRows, selectedRows: selectedRows });
	        _this4.setState({ routes: routes, dispatchRouteId: newRows[coordinates.rowIdx].DispatchRoute_id }, function () {
	          _this4.props.fetchStops(newRows[coordinates.rowIdx].RouteNum, _this4.state.deliveryDateChosen);
	        });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var selectedRows = [];
	        if (_this4.state.routes.selectedRows[0] === rows[0]) {
	          return;
	        }
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	          selectedRows.push(r.row);
	        });
	        var routes = _extends({}, _this4.state.routes, { rows: newRows, selectedRows: selectedRows });
	        _this4.setState({ routes: routes, dispatchRouteId: rows[0].row.DispatchRoute_id }, function () {
	          _this4.props.fetchStops(rows[0].row.RouteNum, _this4.state.deliveryDateChosen);
	        });
	      };
	
	      var columns = [{
	        key: 'RouteNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'route_number' }),
	        resizable: true,
	        filterable: true
	      }, {
	        key: 'DriverName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'driver_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'Vehicle',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vehicle' }),
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'Distance',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'distance' }),
	        resizable: true,
	        sortable: true
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        this.state.showGoogleMaps ? _react2.default.createElement(_DispatchMap2.default, {
	          isMarkerShown: !_lodash2.default.isEmpty(this.state.activeStops.rows),
	          orderPoints: this.state.activeStops.rows,
	          driverLocation: this.props.stops.DriverLocation,
	          centerCoordinates: this.state.centerCoordinates,
	          googleMapURL: 'https://maps.googleapis.com/maps/api/js?key=' + _keys.__GAPI_KEY__ + '&v=3.exp&libraries=geometry,drawing,places',
	          loadingElement: _react2.default.createElement('div', { style: { height: '100%' } }),
	          containerElement: _react2.default.createElement('div', { style: { height: '300px' } }),
	          mapElement: _react2.default.createElement('div', { style: { height: '100%' } })
	        }) : _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { id: 'Routing-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'DispatchRoute_id',
	              onGridSort: handleGridSort,
	              columns: columns,
	              rowHeight: 25,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: 295,
	              onRowUpdated: handleRowUpdated,
	              enableRowSelect: 'single',
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              },
	              onCellSelected: onCellSelected
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderStops',
	    value: function renderStops() {
	      var _this5 = this;
	
	      if (this.props.stopsIsLoading && !this.props.stopsError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.stopsError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger', id: 'dispatch-errors' },
	            JSON.stringify(this.props.stopsError)
	          )
	        );
	      }
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this5.state.tabKey === 1 ? _this5.state.activeStops : _this5.state.inactiveStops);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        if (_this5.state.tabKey === 1) {
	          var stops = _extends({}, _this5.state.activeStops, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this5.setState({ activeStops: stops });
	        } else {
	          var _stops = _extends({}, _this5.state.inactiveStops, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this5.setState({ inactiveStops: _stops });
	        }
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        if (_this5.state.tabKey === 1) {
	          var rows = _this5.state.activeStops.rows.slice(0);
	          Object.assign(rows[e.rowIdx], e.updated);
	          var stops = _extends({}, _this5.state.activeStops, { rows: rows });
	          _this5.setState({ activeStops: stops });
	        } else {
	          var _rows = _this5.state.inactiveStops.rows.slice(0);
	          Object.assign(_rows[e.rowIdx], e.updated);
	          var _stops2 = _extends({}, _this5.state.inactiveStops, { rows: _rows });
	          _this5.setState({ inactiveStops: _stops2 });
	        }
	      };
	
	      var isDraggedRowSelected = function isDraggedRowSelected(selectedRows, rowDragSource) {
	        if (selectedRows && selectedRows.length > 0) {
	          var key = _this5.props.rowKey;
	          return selectedRows.filter(function (r) {
	            return r[key] === rowDragSource.data[key];
	          }).length > 0;
	        }
	        return false;
	      };
	
	      var reorderRows = function reorderRows(e) {
	        var selectedRows = Selectors.getSelectedRowsByKey({ rowKey: _this5.props.rowKey, selectedKeys: [], rows: _this5.state.activeStops.rows });
	        var draggedRows = isDraggedRowSelected(selectedRows, e.rowSource) ? selectedRows : [e.rowSource.data];
	        var undraggedRows = _this5.state.activeStops.rows.filter(function (r) {
	          return draggedRows.indexOf(r) === -1;
	        });
	        var args = [e.rowTarget.idx, 0].concat(draggedRows);
	        Array.prototype.splice.apply(undraggedRows, args);
	        undraggedRows.map(function (row, index) {
	          row.ActiveStopNum = index + 1;
	        });
	        var activeStops = _extends({}, _this5.state.activeStops, { rows: undraggedRows });
	        _this5.setState({ activeStops: activeStops });
	      };
	
	      var DeleteFormatter = _react2.default.createClass({
	        displayName: 'DeleteFormatter',
	        render: function render() {
	          var _this6 = this;
	
	          if (this.props.dependentValues.TempDate) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  className: 'textAlignStyle',
	                  style: { height: '23px', width: '39px', padding: '0px' },
	                  onClick: function onClick() {
	                    _this6.props.remove(_this6.props.dependentValues);
	                  }
	                },
	                'X'
	              )
	            );
	          }
	          return _react2.default.createElement('div', null);
	        }
	      });
	
	      var TimeFormatter = _react2.default.createClass({
	        displayName: 'TimeFormatter',
	        render: function render() {
	          return this.props.value ? _react2.default.createElement(
	            'span',
	            null,
	            (0, _cleanDates.convertLocalDate)(this.props.value, 'h:mm A')
	          ) : _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var columns = this.state.tabKey === 1 ? [{
	        key: 'Del',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: _react2.default.createElement(DeleteFormatter, { remove: this.removeRow }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'CustomerNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer' }),
	        width: 95,
	        resizable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	        width: 130,
	        resizable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        width: 110,
	        resizable: true
	      }, {
	        key: 'Address',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' }),
	        width: 280,
	        resizable: true
	      }, {
	        key: 'Phone',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' }),
	        width: 100,
	        resizable: true
	      }, {
	        key: 'ETADate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'time' }),
	        width: 100,
	        resizable: true,
	        formatter: TimeFormatter
	      }] : [{
	        key: 'CustomerNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer' }),
	        width: 95,
	        resizable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	        width: 130,
	        resizable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        width: 110,
	        resizable: true
	      }, {
	        key: 'City',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city' }),
	        width: 100,
	        resizable: true
	      }, {
	        key: 'StopNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'stop_no' }),
	        width: 90,
	        resizable: true
	      }];
	
	      if (this.state.tabKey === 1) {
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              DraggableContainer,
	              null,
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: this.props.rowKey,
	                onGridSort: handleGridSort,
	                rowActionsCell: RowActionsCell,
	                columns: columns,
	                rowHeight: 25,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                enableRowSelect: 'single',
	                rowRenderer: _react2.default.createElement(RowRenderer, { onRowDrop: reorderRows }),
	                minHeight: 300,
	                onRowUpdated: handleRowUpdated
	              })
	            )
	          )
	        );
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { id: 'Routing-dataGrid2' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'Product_id',
	              onGridSort: handleGridSort,
	              columns: columns,
	              rowHeight: 25,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: 300,
	              onRowUpdated: handleRowUpdated
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderUnassignedOrders',
	    value: function renderUnassignedOrders() {
	      var _this7 = this;
	
	      if (this.props.unassignedOrdersIsLoading && !this.props.unassignedOrdersError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.unassignedOrdersError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger', id: 'dispatch-errors' },
	            JSON.stringify(this.props.unassignedOrdersError)
	          )
	        );
	      }
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this7.state.orders);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var orders = _extends({}, _this7.state.orders, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this7.setState({ orders: orders });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var filteredRows = [].concat(_toConsumableArray(_this7.state.orders.rows));
	        var newFilters = Object.assign({}, _this7.state.orders.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var orders = _extends({}, _this7.state.orders, { filters: newFilters, filteredRows: filteredRows });
	        _this7.setState({ orders: orders });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        var orders = _extends({}, _this7.state.orders, { filters: {} });
	        _this7.setState({ orders: orders });
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        var rows = _lodash2.default.cloneDeep(_this7.state.orders.rows);
	        var editedRows = _lodash2.default.cloneDeep(_this7.state.orders.editedRows);
	        var filteredRows = _this7.state.orders.filteredRows;
	
	        var existingRow = rows[e.rowIdx];
	        var indexToRemove = _lodash2.default.findIndex(editedRows, function (row) {
	          return row.SONum === existingRow.SONum;
	        });
	        if (indexToRemove > -1) {
	          editedRows.splice(indexToRemove, 1);
	        }
	        if (filteredRows.length > 0) {
	          var index = _lodash2.default.findIndex(rows, ['SONum', filteredRows[e.rowIdx].SONum]);
	          Object.assign(rows[index], e.updated);
	          editedRows.push(rows[index]);
	        } else {
	          Object.assign(rows[e.rowIdx], e.updated);
	          editedRows.push(rows[e.rowIdx]);
	        }
	        var orders = _extends({}, _this7.state.orders, { rows: rows, editedRows: editedRows });
	        _this7.setState({ orders: orders });
	      };
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var date = new Date(this.props.value);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var timeOptions = ['', '6:00 AM', '7:00 AM', '8:00 AM', '9:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM', '7:00 PM', '8:00 PM'];
	
	      var columns = [{
	        key: 'SONum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_no' }),
	        resizable: true,
	        sortable: true,
	        width: 140,
	        filterable: true
	      }, {
	        key: 'Deliver_Customer_num',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_no' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }].concat(_toConsumableArray(_root_url.isCalco ? [{
	        key: 'Deliver_CustomerRoute_id',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'route_id' }),
	        width: 100,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }] : []), [{
	        key: 'Deliver_CustomerName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' }),
	        resizable: true,
	        sortable: true,
	        width: 220,
	        filterable: true
	      }, {
	        key: 'Address',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' }),
	        resizable: true,
	        filterable: true,
	        sortable: true,
	        width: 280
	      }, {
	        key: 'DispatchDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'scheduled_shipping_date' }),
	        resizable: true,
	        filterable: false,
	        width: 140,
	        formatter: DateFormatter
	      }, {
	        key: 'SaleStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Status' }),
	        resizable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: 'ETADate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'time' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editor: _react2.default.createElement(DropDownEditor, { options: timeOptions })
	      }, {
	        key: 'RouteNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'route_number' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        editor: _react2.default.createElement(DropDownEditor, { options: this.state.routeOptions }),
	        filterable: true
	      }]);
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { id: 'Routing-dataGrid3' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'SONum',
	              onGridSort: handleGridSort,
	              columns: columns,
	              headerRowHeight: 45,
	              enableCellSelect: true,
	              onAddFilter: handleFilterChange,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              rowHeight: 25,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              onRowUpdated: handleRowUpdated,
	              onClearFilters: onClearFilters,
	              minHeight: 280
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      return (
	        //---------------
	        // Begin HTML: Create New/Edit routing
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'routing' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            null,
	            _react2.default.createElement(_SpinnerButton2.default, {
	              bsStyle: 'success',
	              onClick: this.saveChanges,
	              loading: this.props.savingStopEdits || this.props.assigningOrderRoute,
	              icon: 'fa-save',
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' }),
	              disabled: this.props.savingStopEdits || this.props.assigningOrderRoute
	            }),
	            _react2.default.createElement(_SpinnerButton2.default, {
	              bsStyle: 'primary',
	              onClick: function onClick() {
	                return _this8.props.printDispatchRoute(_this8.state.dispatchRouteId, _this8.state.deliveryDateChosen);
	              },
	              loading: this.props.requestingRoutingPdf && !this.props.routingPdfFailure,
	              icon: 'fa-print',
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_route' }),
	              disabled: this.props.requestingRoutingPdf && !this.props.routingPdfFailure || !this.state.dispatchRouteId
	            }),
	            _react2.default.createElement(_SpinnerButton2.default, {
	              bsStyle: 'primary',
	              onClick: function onClick() {
	                return _this8.props.printDispatchPickingList(_this8.state.dispatchRouteId, _this8.state.deliveryDateChosen);
	              },
	              loading: this.props.requestingPickingListPdf && !this.props.pickingListPdfFailure,
	              icon: 'fa-print',
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'picking_list' }),
	              disabled: this.props.requestingPickingListPdf && !this.props.pickingListPdfFailure || !this.state.dispatchRouteId
	            }),
	            _react2.default.createElement(_SpinnerButton2.default, {
	              bsStyle: 'primary',
	              onClick: function onClick() {
	                return _this8.props.printDispatchPackingList(_this8.state.dispatchRouteId, _this8.state.deliveryDateChosen);
	              },
	              loading: this.props.requestingPackingListPdf && !this.props.packingListPdfFailure,
	              icon: 'fa-print',
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'packing_list' }),
	              disabled: this.props.requestingPackingListPdf && !this.props.packingListPdfFailure || !this.state.dispatchRouteId
	            }),
	            _react2.default.createElement(_SpinnerButton2.default, {
	              bsStyle: 'primary',
	              onClick: function onClick() {
	                return _this8.props.printDispatchSalesInvoice(_this8.state.dispatchRouteId, _this8.state.deliveryDateChosen);
	              },
	              loading: this.props.requestingDispatchSalesInvoicePdf && !this.props.salesInvoicePdfFailure,
	              icon: 'fa-print',
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_si' }),
	              disabled: this.props.requestingDispatchSalesInvoicePdf && !this.props.salesInvoicePdfFailure || !this.state.dispatchRouteId
	            })
	          ),
	          _react2.default.createElement(_GenericDatePicker2.default, {
	            id: 'routing-date-picker',
	            setDate: this.setDeliveryDate,
	            selectedDate: this.state.deliveryDateChosen
	          }),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'dispatch-routing' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { style: { height: '350px' } },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 6 },
	                      _react2.default.createElement(
	                        'h3',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'route_details' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        className: 'toggle-maps-button',
	                        bsStyle: 'primary',
	                        onClick: this.toggleGoogleMaps
	                      },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'toggle_map' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 12 },
	                      this.renderRoutes()
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(
	                  _reactBootstrap.Tabs,
	                  {
	                    activeKey: this.state.tabKey,
	                    justified: true,
	                    onSelect: this.handleTabSelect,
	                    className: 'tabs-panel'
	                  },
	                  _react2.default.createElement(
	                    _reactBootstrap.Tab,
	                    { eventKey: 1, title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'active_stops' }) },
	                    this.renderStops()
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Tab,
	                    { eventKey: 2, title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'default_stops' }) },
	                    this.renderStops()
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { style: { height: '350px' } },
	                  _react2.default.createElement(
	                    'h3',
	                    { style: { position: 'absolute' } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unassigned_orders' })
	                  ),
	                  this.renderUnassignedOrders()
	                )
	              )
	            ),
	            this.renderPrintRouteIFrame(),
	            this.renderPrintPickingListIFrame(),
	            this.renderPrintPackingListIFrame(),
	            this.renderPrintSalesInvoiceIFrame()
	          )
	        )
	      );
	    }
	  }]);
	
	  return Routing;
	}(_react.Component);
	
	Routing.propTypes = propTypes;
	Routing.defaultProps = defaultProps;
	Routing.contextTypes = contextTypes;
	
	var _default = Routing;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/routing.jsx');
	
	  __REACT_HOT_LOADER__.register(DropDownEditor, 'DropDownEditor', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/routing.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/routing.jsx');
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/routing.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/routing.jsx');
	
	  __REACT_HOT_LOADER__.register(contextTypes, 'contextTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/routing.jsx');
	
	  __REACT_HOT_LOADER__.register(Routing, 'Routing', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/routing.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/routing.jsx');
	}();

	;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _inputField = __webpack_require__(16);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEcity = _root_url.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://ctstage-scm.truckxi.com/api/';
	
	var SetWeightModal = function (_Component) {
	  _inherits(SetWeightModal, _Component);
	
	  function SetWeightModal() {
	    _classCallCheck(this, SetWeightModal);
	
	    var _this = _possibleConstructorReturn(this, (SetWeightModal.__proto__ || Object.getPrototypeOf(SetWeightModal)).call(this));
	
	    _this.handleKeyPress = function (event) {
	      if (event.charCode === 13 && _this.state.selectedWeight) {
	        event.preventDefault();
	        // ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	        var weights = _extends({}, _this.state.weights);
	
	        if (_this.state.selectedWeightIdx === _this.state.weights.rows.length) {
	          weights.rows[_this.state.selectedWeightIdx - 1].Weight = _this.state.selectedWeight;
	          _this.setState({ selectedWeight: '', selectedWeightIdx: 0, weights: weights });
	        } else if (_this.state.selectedWeightIdx) {
	          weights.rows[_this.state.selectedWeightIdx - 1].Weight = _this.state.selectedWeight;
	          _this.setState({ selectedWeight: '', selectedWeightIdx: _this.state.selectedWeightIdx + 1, weights: weights });
	        } else {
	          _this.setState({ selectedWeight: '', selectedWeightIdx: _this.state.selectedWeightIdx + 1 }, function () {
	            _this.handleFinish();
	          });
	        }
	      } else if (event.charCode === 13 && _this.state.selectedWeightIdx === 0) {
	        _this.setState({ selectedWeight: '', selectedWeightIdx: _this.state.selectedWeightIdx + 1 }, function () {
	          _this.handleFinish();
	        });
	      }
	    };
	
	    _this.handleChange = function (event) {
	      _this.setState({ selectedWeight: event.target.value });
	    };
	
	    _this.renderWeightsSubmit = function () {
	      var confirmWeights = _this.state.selectedWeightIdx === 0 ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'press_enter_to_confirm_weights' }) : '';
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { style: { paddingLeft: '50px' } },
	          _react2.default.createElement(
	            'h3',
	            { style: { paddingLeft: '18px' } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'set_weights' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(_reactBootstrap.Input, {
	              type: 'number',
	              addonBefore: _this.state.selectedWeightIdx || '',
	              name: 'selectedWeight',
	              autoFocus: !isEcity,
	              value: _this.state.selectedWeight,
	              onChange: _this.handleChange,
	              disabled: _this.state.needsDelete,
	              onKeyPress: function onKeyPress(event) {
	                _this.handleKeyPress(event);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          null,
	          _react2.default.createElement(
	            'span',
	            { style: { color: 'green', paddingLeft: '28px' } },
	            confirmWeights
	          )
	        )
	      );
	    };
	
	    _this.openConfirm = function () {
	      return _this.setState({ confirmOpen: true });
	    };
	
	    _this.closeConfirm = function () {
	      return _this.setState({ confirmOpen: false, zeroInList: false });
	    };
	
	    _this.isZeroWeight = function (weights) {
	      var weightChecker = false;
	      var zeroRows = _extends({}, _this.state.weights);
	      for (var i = 0; i < weights.length; i++) {
	        if (parseFloat(weights[i].Weight) <= 0) {
	          zeroRows.rows[i].zeroFound = true;
	          _this.setState({ zeroInList: true, weights: zeroRows }, _this.openConfirm());
	          weightChecker = true;
	        }
	      }
	      _this.setState({ zeroInList: false });
	      return weightChecker;
	    };
	
	    _this.handleFinish = function () {
	      if (!_this.props.invoice) {
	        if (!_this.isZeroWeight(_this.state.weights.rows)) {
	          _this.props.setOrderLineWeights(_this.props.rowChosen, _this.state.weights.rows);
	          var totalWeight = 0;
	          var rows = [];
	          _this.state.weights.rows.map(function (row) {
	            if (row.Weight) {
	              totalWeight += parseFloat(row.Weight);
	              rows.push(parseFloat(row.Weight));
	            }
	          });
	          _this.props.returnTotalWeight(totalWeight.toFixed(4), rows);
	          _this.setState({ changed: true }, function () {
	            _this.props.closeC();
	          });
	        }
	      } else {
	        if (!_this.isZeroWeight(_this.state.weights.rows)) {
	          _this.props.setWeights(_this.props.rowChosen, _this.state.weights.rows, _this.props.editedRow);
	          var _totalWeight = 0;
	          var _rows = [];
	          _this.state.weights.rows.map(function (row) {
	            if (row.Weight) {
	              _totalWeight += parseFloat(row.Weight);
	              _rows.push(parseFloat(row.Weight));
	            }
	          });
	          _this.props.returnTotalWeight(_totalWeight.toFixed(4), _rows);
	          _this.setState({ changeStyle: true, changed: true }, function () {
	            _this.props.closeC();
	          });
	        }
	      }
	    };
	
	    _this.state = {
	      needsDelete: false,
	      rowsToDelete: 0,
	      finished: false,
	      oldLoaded: 0,
	      changed: false,
	      weights: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	      changeStyle: false,
	      confirmOpen: false,
	      case: 'zeroWeight',
	      selectedWeightIdx: 1,
	      selectedWeight: ''
	    };
	    return _this;
	  }
	
	  _createClass(SetWeightModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.invoice) {
	        var rows = [];
	        this.props.currentWeights.map(function (weight) {
	          rows.push({ Weight: weight });
	        });
	
	        var oldLoaded = rows.length;
	        if (rows.length < this.props.totalLoaded) {
	          var temp = rows.length;
	          for (var i = 0; i < this.props.totalLoaded - temp; i++) {
	            rows.push({ Weight: 0 });
	          }
	        }
	        var weights = _extends({}, this.state.weights, { rows: rows });
	
	        if (parseFloat(this.props.totalLoaded) < rows.length) {
	          var rowsToDelete = rows.length - this.props.totalLoaded;
	          this.setState({ needsDelete: true, rowsToDelete: rowsToDelete, oldLoaded: oldLoaded });
	        } else {
	          this.setState({ needsDelete: false, oldLoaded: oldLoaded });
	        }
	        this.setState({ weights: weights });
	      } else {
	        this.props.fetchSalesOrderLineWeights(this.props.rowChosen);
	      }
	      _reactDom2.default.findDOMNode(this.refs['TotalWeight'].getRenderedComponent().myInput.refs.input).focus();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (parseFloat(nextProps.totalLoaded) < nextProps.salesOrderLineWeights.length && !this.state.finished) {
	        var rowsToDelete = nextProps.salesOrderLineWeights.length - nextProps.totalLoaded;
	        this.setState({ needsDelete: true, rowsToDelete: rowsToDelete });
	      } else {
	        this.setState({ needsDelete: false });
	      }
	      if (nextProps.totalWeight !== this.props.totalWeight) {
	        var avgWeight = (parseFloat(nextProps.totalWeight) || 0) / (parseFloat(this.state.weights.rows.length) || 1);
	        avgWeight = avgWeight.toFixed(4);
	        this.state.weights.rows.map(function (r) {
	          r.Weight = avgWeight;
	        });
	      }
	      if (nextProps.salesOrderLineWeights && nextProps.salesOrderLineWeights !== this.props.salesOrderLineWeights) {
	        var tempWeights = [];
	
	        nextProps.salesOrderLineWeights.map(function (weight) {
	          tempWeights.push({ Weight: weight });
	        });
	
	        if (nextProps.salesOrderLineWeights.length >= this.props.totalLoaded) {
	          var newWeights = tempWeights; // .splice(0, parseInt(this.props.totalLoaded));
	          var weights = _extends({}, this.state.weights, { rows: newWeights });
	          this.setState({ weights: weights });
	        } else {
	          var temp = tempWeights.length;
	          for (var i = 0; i < this.props.totalLoaded - temp; i++) {
	            tempWeights.push({ 'Weight': 0 });
	          }
	          var _weights = _extends({}, this.state.weights, { rows: tempWeights });
	          this.setState({ weights: _weights });
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!this.state.changed) {
	        this.props.keepLoaded(this.state.oldLoaded);
	      }
	      this.props.clearSalesOrderLineWeights();
	    }
	  }, {
	    key: 'fillWithLastValue',
	    value: function fillWithLastValue() {
	      var index = 0;
	      var newWeights = _extends({}, this.state.weights);
	
	      for (var i = 0; i < this.state.weights.rows.length; i++) {
	        if (this.state.weights.rows[i].Weight === 0) {
	          index = i;
	          break;
	        }
	      }
	
	      if (index > 0) {
	        var fillValue = this.state.weights.rows[index - 1].Weight;
	
	        for (var i = index; i < this.state.weights.rows.length; i++) {
	          newWeights.rows[i].Weight = fillValue;
	        }
	        this.setState({ weights: newWeights });
	      }
	    }
	  }, {
	    key: 'clearAllValues',
	    value: function clearAllValues() {
	      var newWeights = [].concat(_toConsumableArray(this.state.weights.rows));
	      newWeights.map(function (row) {
	        row.Weight = 0;
	      });
	
	      var weights = _extends({}, this.state.weights, { rows: newWeights });
	      this.setState({ weights: weights });
	    }
	  }, {
	    key: 'renderWeightInputs',
	    value: function renderWeightInputs() {
	      var _this2 = this;
	
	      var _props = this.props,
	          salesOrderLineWeightsIsLoading = _props.salesOrderLineWeightsIsLoading,
	          salesOrderLineWeightsError = _props.salesOrderLineWeightsError;
	
	      if (salesOrderLineWeightsIsLoading && !salesOrderLineWeightsError) {
	        return _react2.default.createElement(_spinner2.default, { className: 'marginTopStyle' });
	      } else if (salesOrderLineWeightsError) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(salesOrderLineWeightsError)
	        );
	      }
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.weights);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return Object.assign({ Idx: rowIdx + 1 }, rows[rowIdx]);
	      };
	
	      // Handle the row select function
	
	      var onRowSelect = function onRowSelect(rows) {
	        var weights = _extends({}, _this2.state.weights, { rows: rows });
	        _this2.setState({ weights: weights });
	      };
	
	      var onRowClick = function onRowClick(rowIdx, row) {
	        _this2.setState({ selectedWeight: row.Weight, selectedWeightIdx: row.Idx });
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        var rows = getRows();
	        var updated = { Weight: parseFloat(e.updated.Weight) };
	        Object.assign(rows[e.rowIdx], updated);
	        var weights = _extends({}, _this2.state.weights, { rows: rows });
	        _this2.setState({ weights: weights });
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var weights = Object.assign({}, _this2.state.weights, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this2.setState({ weights: weights });
	      };
	
	      // Custom Formatter component
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	            var date = new Date(this.props.value);
	            var index = dateMap.indexOf(date.toString().slice(4, 3));
	            var localDate = index + date.toString().slice(8, 6);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var that = this;
	      var deleteFormatter = _react2.default.createClass({
	        displayName: 'deleteFormatter',
	        render: function render() {
	          var _this3 = this;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                className: 'textAlignStyle',
	                type: 'button',
	                onClick: function onClick() {
	                  var weights = that.state.weights;
	                  weights.rows.splice(_this3.props.dependentValues.Idx - 1, 1);
	                  var rowsToDelete = that.state.rowsToDelete - 1;
	                  if (rowsToDelete === 0) {
	                    that.setState({ needsDelete: false, rowsToDelete: rowsToDelete, weights: weights, finished: true });
	                  } else {
	                    that.setState({ rowsToDelete: rowsToDelete, weights: weights });
	                  }
	                }
	              },
	              'X'
	            )
	          );
	        }
	      });
	
	      // Column difinition
	      var ZeroFormatter = _react2.default.createClass({
	        displayName: 'ZeroFormatter',
	        render: function render() {
	          if (this.props.value <= 0 && this.props.dependentValues.zeroFound) {
	            return _react2.default.createElement(
	              'div',
	              { style: { backgroundColor: 'yellow' } },
	              this.props.value
	            );
	          }
	          return _react2.default.createElement(
	            'div',
	            null,
	            this.props.value
	          );
	        }
	      });
	
	      var columns = [{
	        key: 'Idx',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	        width: 30,
	        resizable: false,
	        filterable: true
	      }, {
	        key: 'Weight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight' }),
	        width: 100,
	        resizable: true,
	        filterable: true,
	        editable: true,
	        formatter: ZeroFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }];
	      var delColumns = [{
	        key: 'Idx',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	        width: 30,
	        resizable: false,
	        filterable: true
	      }, {
	        key: 'Weight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight' }),
	        width: 100,
	        resizable: true,
	        filterable: true
	      }, {
	        key: 'Delete',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '' }),
	        width: 60,
	        formatter: deleteFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }];
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 6 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '99%' } },
	            !this.state.needsDelete ? _react2.default.createElement(
	              'div',
	              { id: 'SetWeightModal-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                style: { height: '10%' },
	                onGridSort: handleGridSort,
	                columns: columns,
	                enableCellSelect: true,
	                rowHeight: 25,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                minHeight: 275,
	                onRowClick: onRowClick,
	                onRowUpdated: handleRowUpdated,
	                disable: true
	              })
	            ) : _react2.default.createElement(
	              'div',
	              { id: 'SetWeightModal-dataGrid2' },
	              _react2.default.createElement(
	                'span',
	                { style: { color: 'red' } },
	                'DELETE ',
	                this.state.rowsToDelete,
	                ' ROW(S)'
	              ),
	              _react2.default.createElement(_reactDataGrid2.default, {
	                style: { height: '10%' },
	                onGridSort: handleGridSort,
	                columns: delColumns,
	                enableCellSelect: true,
	                rowHeight: 25,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                minHeight: 275,
	                onRowUpdated: handleRowUpdated
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 6 },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary col-sm-11 buttonStyle', type: 'button', disabled: this.state.needsDelete, onClick: function onClick() {
	                _this2.fillWithLastValue();
	              } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fill_with_latest_value' })
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-danger col-sm-11 buttonStyle', type: 'button', disabled: this.state.needsDelete, onClick: function onClick() {
	                _this2.clearAllValues();
	              } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'clear_all_values' })
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          this.renderWeightsSubmit()
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var createDialogStyle = {
	        height: '200px',
	        marginTop: '-20%',
	        width: '300px',
	        marginLeft: '-10%',
	        left: '45%'
	      };
	      var confirmAction = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm_action' });
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement('hr', null),
	        this.renderWeightInputs(),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_weight' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'TotalWeight',
	              ref: 'TotalWeight',
	              withRef: true,
	              onKeyPress: function onKeyPress(event) {
	                if (event.charCode == 13 && _this4.props.totalWeight) {
	                  _this4.handleFinish();
	                }
	              },
	              component: !this.state.needsDelete ? _inputField.InputField : _inputField.DisabledInputField
	            })
	          )
	        ),
	        _react2.default.createElement('br', null),
	        !this.props.invoice ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary col-sm-11 buttonStyle', type: 'button', disabled: this.state.needsDelete, onClick: function onClick() {
	                  _this4.handleFinish();
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save_weights' })
	            )
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-danger col-sm-11 buttonStyle', type: 'button', disabled: this.state.needsDelete, onClick: function onClick() {
	                  _this4.props.closeC();
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discard_changes' })
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'button',
	              { className: this.state.changeStyle ? "btn btn-success col-sm-11 buttonStyle" : "btn btn-primary col-sm-11 buttonStyle", type: 'button', disabled: this.state.needsDelete, onClick: function onClick() {
	                  _this4.handleFinish();
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'load_weights' })
	            )
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-danger col-sm-11 buttonStyle', type: 'button', onClick: function onClick() {
	                  _this4.props.closeC();
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'close' })
	            )
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_reactBootstrap.Row, null),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          { dialogStyles: createDialogStyle, isVisible: this.state.confirmOpen, onCloseClicked: function onCloseClicked() {
	              _this4.closeConfirm();
	            }, title: confirmAction },
	          _react2.default.createElement(_confirmActionModal2.default, { 'case': this.state.case, closeC: this.closeConfirm })
	        )
	      );
	    }
	  }]);
	
	  return SetWeightModal;
	}(_react.Component);
	
	SetWeightModal.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = SetWeightModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/setWeightModal.jsx');
	
	  __REACT_HOT_LOADER__.register(SetWeightModal, 'SetWeightModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/setWeightModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/setWeightModal.jsx');
	}();

	;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _cleanDates = __webpack_require__(22);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _datePicker = __webpack_require__(27);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _setWeightModal = __webpack_require__(74);
	
	var _setWeightModal2 = _interopRequireDefault(_setWeightModal);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Shipping = function (_Component) {
	  _inherits(Shipping, _Component);
	
	  function Shipping() {
	    _classCallCheck(this, Shipping);
	
	    var _this = _possibleConstructorReturn(this, (Shipping.__proto__ || Object.getPrototypeOf(Shipping)).call(this));
	
	    _this.keepLoaded = function (oldLoaded) {
	      var products = _extends({}, _this.state.products);
	      products.rows[_this.state.currentRow].LoadedQuantity = oldLoaded;
	      _this.setState({ products: products });
	    };
	
	    _this.state = {
	      // Control state of Modal
	      confirmActionOpen: false,
	      setWeightOpen: false,
	
	      orderNum: '',
	      customerName: '',
	      totalLoaded: null,
	      rowChosen: null,
	      currentRow: null,
	
	      products: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      salesOrders: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null
	      }
	    };
	
	    _this.openSetWeight = _this.openSetWeight.bind(_this);
	    _this.closeSetWeight = _this.closeSetWeight.bind(_this);
	    _this.openAction = _this.openAction.bind(_this);
	    _this.closeAction = _this.closeAction.bind(_this);
	    return _this;
	  }
	
	  _createClass(Shipping, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Grab salesOrders to choose from
	      this.props.fetchSalesOrdersByDate((0, _cleanDates.getFromToDates)(new Date()));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.salesOrders && nextProps.salesOrders !== this.props.salesOrders) {
	        var salesOrders = _extends({}, this.state.salesOrders, { rows: nextProps.salesOrders.SO });
	        if (this.state.orderNum) {
	          for (var i = 0; i < salesOrders.rows.length; i++) {
	            if (salesOrders.rows[i].SONum === this.state.orderNum) {
	              salesOrders.rows[i].selected = true;
	              break;
	            }
	          }
	        }
	        this.setState({ salesOrders: salesOrders });
	      }
	
	      if (nextProps.chosenOrderNum && nextProps.chosenOrderNum !== this.props.chosenOrderNum) {
	        this.props.fetchSalesOrderDetail(nextProps.chosenOrderNum.value);
	      }
	
	      if (nextProps.salesOrderDetail && nextProps.salesOrderDetail !== this.props.salesOrderDetail) {
	        var products = {};
	        if (nextProps.salesOrderDetail.Sales_Order_Lines) {
	          products = _extends({}, this.state.products, { rows: nextProps.salesOrderDetail.Sales_Order_Lines });
	        }
	        this.setState({ products: products });
	      }
	
	      if (nextProps.ShippingDate && nextProps.ShippingDate !== this.props.ShippingDate) {
	        this.props.fetchSalesOrdersByDate((0, _cleanDates.getFromToDates)(nextProps.ShippingDate));
	      }
	    }
	  }, {
	    key: 'closeSetWeight',
	    value: function closeSetWeight() {
	      this.setState({ setWeightOpen: false });
	    }
	  }, {
	    key: 'openSetWeight',
	    value: function openSetWeight() {
	      this.setState({ setWeightOpen: true });
	    }
	  }, {
	    key: 'openAction',
	    value: function openAction() {
	      this.setState({ confirmActionOpen: true });
	    }
	  }, {
	    key: 'closeAction',
	    value: function closeAction() {
	      this.setState({ confirmActionOpen: false });
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      var formattedDate = void 0;
	      if (date.getMonth() < 9) {
	        // getMonth returns 0-11
	        formattedDate = '0' + (parseInt(date.getMonth()) + 1);
	      } else {
	        // TURN THESE TO STRINGS
	        formattedDate = String(parseInt(date.getMonth() + 1));
	      }
	
	      if (date.getDate() < 10) {
	        formattedDate += '0' + date.getDate();
	      } else {
	        formattedDate += String(date.getDate());
	      }
	
	      formattedDate += String(date.getFullYear());
	      return formattedDate;
	    }
	  }, {
	    key: 'createInvoice',
	    value: function createInvoice() {
	      var _this2 = this;
	
	      this.props.convertToInvoice(this.props.salesOrderDetail.SalesOrder_id, this.state.products.rows).then(function () {
	        if (_this2.props.ShippingDate) _this2.props.fetchSalesOrdersByDate((0, _cleanDates.getFromToDates)(_this2.props.ShippingDate));else {
	          _this2.props.fetchSalesOrdersByDate((0, _cleanDates.getFromToDates)(new Date()));
	        }
	      });
	      var products = _extends({}, this.state.products, { rows: [], sortColumn: null, sortDirection: null, orderNum: null });
	      this.setState({ products: products });
	    }
	  }, {
	    key: 'autoLoad',
	    value: function autoLoad() {
	      var productRows = [].concat(_toConsumableArray(this.state.products.rows));
	      productRows.map(function (row) {
	        if (row.ProductType === 'Fixed' || row.ProductType === 'Per-Pound') {
	          if (row.LoadedQuantity === 0) {
	            row.LoadedQuantity = row.Quantity;
	            row.TotalWeight = parseFloat(row.LoadedQuantity) * parseFloat(row.NetWeight);
	            row.TotalNetWeight = parseFloat(row.LoadedQuantity) * parseFloat(row.NetWeight);
	          }
	        }
	        if (row.ProductType === 'Fixed') {
	          row.TotalPrice = roundTo(parseFloat(row.LoadedQuantity) * parseFloat(row.UnitPrice), 2);
	        }
	        if (row.ProductType === 'Per-Pound') {
	          row.TotalPrice = roundTo(parseFloat(row.TotalNetWeight) * parseFloat(row.UnitPrice), 2);
	        }
	      });
	
	      var products = _extends({}, this.state.products, { rows: productRows });
	      this.setState({ products: products });
	    }
	  }, {
	    key: 'checkRows',
	    value: function checkRows() {
	      var _this3 = this;
	
	      var valid = true;
	
	      this.state.products.rows.map(function (row) {
	        if (row.LoadedQuantity === 0) {
	          _this3.setState({ confirmActionOpen: true });
	          valid = false;
	        }
	      });
	      if (valid) {
	        this.createInvoice();
	      }
	    }
	  }, {
	    key: 'returnTotalWeight',
	    value: function returnTotalWeight(totalWeight, weights) {
	      var products = _extends({}, this.state.products);
	      products.rows[this.state.currentRow].TotalNetWeight = parseFloat(totalWeight);
	      products.rows[this.state.currentRow].TotalWeight = parseFloat(totalWeight);
	      products.rows[this.state.currentRow].Weights = weights;
	      products.rows[this.state.currentRow].TotalPrice = roundTo(parseFloat(totalWeight) * parseFloat(products.rows[this.state.currentRow].UnitPrice), 2);
	      this.setState({ products: products });
	    }
	  }, {
	    key: 'renderSalesOrderSelection',
	    value: function renderSalesOrderSelection() {
	      var _this4 = this;
	
	      if (this.props.salesOrdersIsLoading && !this.props.salesOrdersError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.salesOrdersError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.salesOrdersError)
	        )
	      );
	
	      // Parameters of the react-data-grid
	      var tableHeight = window.innerHeight < 900 ? 635 : 635;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.salesOrders);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var salesOrders = _extends({}, _this4.state.salesOrders, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this4.setState({ salesOrders: salesOrders });
	      };
	
	      var onRowSelect = function onRowSelect(rows) {
	        var salesOrders = _extends({}, _this4.state.salesOrders, { selectedRows: rows });
	        _this4.setState({ salesOrders: salesOrders });
	      };
	
	      var onRowClick = function onRowClick(rowIdx, row) {
	        if (row) {
	          var salesOrders = _extends({}, _this4.state.salesOrders);
	          _this4.setState({ orderNum: row.SONum, salesOrders: salesOrders, customerName: row.Deliver_CustomerName }, function () {
	            if (_this4.props.ShippingDate) {
	              _this4.props.fetchSalesOrdersByDate((0, _cleanDates.getFromToDates)(_this4.props.ShippingDate));
	            } else {
	              _this4.props.fetchSalesOrdersByDate((0, _cleanDates.getFromToDates)(new Date()));
	            }
	          });
	          _this4.props.fetchSalesOrderDetail(row.SalesOrder_id);
	        }
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        var salesOrders = _extends({}, _this4.state.salesOrders, { filters: {} });
	        _this4.setState({ salesOrders: salesOrders });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this4.state.salesOrders.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var salesOrders = _extends({}, _this4.state.salesOrders, { filters: newFilters });
	        _this4.setState({ salesOrders: salesOrders });
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        var rows = _this4.state.salesOrders.rows.slice(0);
	        Object.assign(rows[e.rowIdx], e.updated);
	        var salesOrders = _extends({}, _this4.state.salesOrders, { rows: rows });
	        _this4.setState({ salesOrders: salesOrders });
	      };
	
	      var RowRenderer = _react2.default.createClass({
	        displayName: 'RowRenderer',
	
	        render: function render() {
	          if (this.props.row.selected) {
	            return _react2.default.createElement(
	              'div',
	              { style: { color: 'blue' } },
	              _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	            );
	          }
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	          );
	        }
	      });
	
	      // Column difinition
	      var columns = [{
	        key: 'SONum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_no' }),
	        resizable: true,
	        sortable: true,
	        width: 130,
	        filterable: true
	      },
	      // {
	      //     key: 'RouteNum',
	      //     name: <Translate value="route_num" />,
	      //     resizable: true,
	      //     sortable: true,
	      //     width: 110,
	      //     filterable: true,
	      // },
	      {
	        key: 'Deliver_CustomerName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { id: 'Shipping-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'SalesOrder_id',
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              onClearFilters: onClearFilters,
	              columns: columns,
	              rowHeight: 25,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              onRowClick: onRowClick,
	              minHeight: tableHeight,
	              onRowUpdated: handleRowUpdated,
	              rowRenderer: RowRenderer,
	              onRowSelect: onRowSelect
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderSalesOrderDetail',
	    value: function renderSalesOrderDetail() {
	      var _this5 = this;
	
	      var that = this;
	      if (this.props.salesOrderIsLoading && !this.props.salesOrderError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.salesOrderError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.salesOrderError)
	        )
	      );
	
	      // Parameters of the react-data-grid
	      var tableHeight = window.innerHeight < 900 ? 635 : 635;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this5.state.products);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        var products = _extends({}, _this5.state.products, { filters: {} });
	        _this5.setState({ products: products });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        _this5.state.salesOrders.rows = _this5.props.salesOrders;
	        var newFilters = Object.assign({}, _this5.state.products.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var products = _extends({}, _this5.state.products, { filters: newFilters });
	        _this5.setState({ products: products });
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var products = _extends({}, _this5.state.products, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this5.setState({ products: products });
	      };
	
	      function onDoubleClick(row) {
	        this.setState({ totalLoaded: row.loaded_quantity, setWeightOpen: true, rowChosen: row.salesOrderLine_id });
	      }
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        var rows = getRows(); // this.state.products.rows.slice(0);
	        if (_this5.state.rowIdx) {
	          rows[_this5.state.rowIdx].selected = true;
	        }
	        Object.assign(rows[e.rowIdx], e.updated);
	        if (rows[e.rowIdx].ProductType === 'Fixed' || rows[e.rowIdx].ProductType === 'Per-Pound') {
	          if (rows[e.rowIdx].LoadedQuantity === '') {
	            rows[e.rowIdx].TotalWeight = 0;
	            rows[e.rowIdx].TotalNetWeight = 0;
	            rows[e.rowIdx].TotalPrice = 0;
	          } else {
	            rows[e.rowIdx].TotalWeight = parseFloat(rows[e.rowIdx].LoadedQuantity) * parseFloat(rows[e.rowIdx].NetWeight);
	            rows[e.rowIdx].TotalNetWeight = parseFloat(rows[e.rowIdx].LoadedQuantity) * parseFloat(rows[e.rowIdx].NetWeight);
	          }
	        }
	        if (rows[e.rowIdx].ProductType === 'Fixed') {
	          rows[e.rowIdx].TotalPrice = +roundTo(parseFloat(rows[e.rowIdx].LoadedQuantity) * parseFloat(rows[e.rowIdx].UnitPrice), 2);
	        }
	        if (rows[e.rowIdx].ProductType === 'Per-Pound') {
	          rows[e.rowIdx].TotalPrice = +roundTo(parseFloat(rows[e.rowIdx].TotalNetWeight) * parseFloat(rows[e.rowIdx].UnitPrice), 2);
	        }
	        var products = _extends({}, _this5.state.products, { rows: rows });
	
	        if (rows[e.rowIdx].ProductType === 'Fixed' || rows[e.rowIdx].ProductType === 'Per-Pound') {
	          that.setState({ products: products, totalLoaded: rows[e.rowIdx].LoadedQuantity, rowChosen: rows[e.rowIdx].SalesOrderLine_id, currentRow: e.rowIdx });
	        } else {
	          that.setState({ products: products, totalLoaded: rows[e.rowIdx].LoadedQuantity, rowChosen: rows[e.rowIdx].SalesOrderLine_id, setWeightOpen: true, currentRow: e.rowIdx });
	        }
	      };
	
	      var RowRenderer = _react2.default.createClass({
	        displayName: 'RowRenderer',
	
	
	        PropTypes: {
	          onDoubleClick: _react2.default.PropTypes.func
	        },
	
	        render: function render() {
	          return _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props, { onDoubleClick: this.props.onDoubleClick }));
	        }
	      });
	
	      // Custom Formatter component
	      var IsVariableFormatter = _react2.default.createClass({
	        displayName: 'IsVariableFormatter',
	        render: function render() {
	          if (this.props.dependentValues.ProductType === 'Fixed') {
	            return _react2.default.createElement(
	              'span',
	              null,
	              this.props.value,
	              ' '
	            );
	          } else if (this.props.dependentValues.ProductType === 'Non-Fixed') {
	            return _react2.default.createElement(
	              'span',
	              null,
	              this.props.value,
	              ' ',
	              _react2.default.createElement(
	                'label',
	                { className: 'label label-success' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'non_fixed' })
	              )
	            );
	          } else if (this.props.dependentValues.ProductType === 'Per-Pound') {
	            return _react2.default.createElement(
	              'span',
	              null,
	              this.props.value,
	              ' ',
	              _react2.default.createElement(
	                'label',
	                { className: 'label label-primary' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'per_pound' })
	              )
	            );
	          }
	        }
	      });
	
	      // Column difinition
	      var columns = [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        width: 220,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150,
	        filterable: true
	      }, {
	        key: 'MeasureUnit',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mm_unit' }),
	        resizable: true,
	        sortable: true,
	        width: 75,
	        filterable: true
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'LoadedQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'loaded_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        editable: true
	      }, {
	        key: 'TotalWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 80
	      }, {
	        key: 'Batch_PONum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { id: 'Shipping-dataGrid2' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'Product_id',
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              onClearFilters: onClearFilters,
	              columns: columns,
	              rowHeight: 25,
	              headerRowHeight: 45,
	              enableCellSelect: true,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: onDoubleClick }),
	              minHeight: tableHeight,
	              onRowUpdated: handleRowUpdated
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderPrint',
	    value: function renderPrint() {
	      var date = this.props.ShippingDate || new Date();
	      var year = date.getFullYear();
	      var month = date.getMonth() + 1;
	      var day = date.getDate();
	      if (month < 10) {
	        month = "0" + month;
	      }
	      if (day < 10) {
	        day = "0" + day;
	      }
	      date = "" + year + month + day;
	      var shipping_url = _root_url.ROOT_URL + 'v1/sale/printpickinglist/' + date + "?Bearer=" + localStorage.getItem('token');
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          'a',
	          { className: 'btn btn-primary', href: shipping_url, style: { marginLeft: '5px' } },
	          _react2.default.createElement('em', { className: 'fa fa-print' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_shipping' })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var createDialogStyle = {
	        width: '500px',
	        height: '600px',
	        top: '45%',
	        marginLeft: '-10%'
	      };
	
	      return (
	        //---------------
	        // Begin HTML: Create New/Edit shipping
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'dispatch-shipping' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 4 },
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_details', style: { textTransform: 'uppercase' } })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 8 },
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_order_details', style: { textTransform: 'uppercase' } }),
	                  ' ',
	                  _react2.default.createElement(
	                    'span',
	                    { style: { backgroundColor: '#FFECB3' } },
	                    this.state.orderNum ? '(' + this.state.orderNum + ') ' + this.state.customerName : ''
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 4 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { id: 'order-selection-panel' },
	                  _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    { className: 'table-buttons', style: { marginBottom: '15px' } },
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 4 },
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date_filter' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 5 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'ShippingDate', selected: new Date(), component: _datePicker.DatePicker })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    this.renderSalesOrderSelection()
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 8 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { id: 'shipping-detail-panel', className: 'position-relative' },
	                  _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    { className: 'table-buttons', style: { left: 25 } },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'primary',
	                        disabled: this.state.products.rows.length === 0,
	                        onClick: function onClick() {
	                          return _this6.autoLoad();
	                        }
	                      },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'auto_load' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'success',
	                        disabled: this.props.salesOrderDetail == null,
	                        onClick: function onClick() {
	                          return _this6.checkRows();
	                        }
	                      },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Finish_Shipping' })
	                    ),
	                    this.renderPrint()
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 12 },
	                      this.renderSalesOrderDetail()
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                dialogStyles: createDialogStyle,
	                isVisible: this.state.setWeightOpen,
	                onCloseClicked: function onCloseClicked() {
	                  _this6.closeSetWeight();
	                },
	                title: 'Set Product Weights'
	              },
	              _react2.default.createElement(_setWeightModal2.default, {
	                closeC: this.closeSetWeight,
	                keepLoaded: this.keepLoaded,
	                totalLoaded: this.state.totalLoaded,
	                rowChosen: this.state.rowChosen,
	                returnTotalWeight: this.returnTotalWeight.bind(this)
	              })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                dialogStyles: createDialogStyle,
	                isVisible: this.state.confirmActionOpen,
	                onCloseClicked: function onCloseClicked() {
	                  _this6.closeAction();
	                },
	                title: 'Confirm Action'
	              },
	              _react2.default.createElement(_confirmActionModal2.default, {
	                closeC: this.closeAction,
	                'case': "quantityZero",
	                caseAction: this.createInvoice.bind(this)
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Shipping;
	}(_react.Component);
	
	Shipping.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = Shipping;
	exports.default = _default;
	
	
	function roundTo(n, digits) {
	  if (digits === undefined) {
	    digits = 0;
	  }
	
	  var multiplicator = Math.pow(10, digits);
	  n = parseFloat((n * multiplicator).toFixed(11));
	  var test = Math.round(n) / multiplicator;
	  return +test.toFixed(2);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(roundTo, 'roundTo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/shipping.jsx');
	
	  __REACT_HOT_LOADER__.register(Shipping, 'Shipping', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/shipping.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Dispatch/shipping.jsx');
	}();

	;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxForm = __webpack_require__(3);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _detailedSelection = __webpack_require__(82);
	
	var _detailedSelection2 = _interopRequireDefault(_detailedSelection);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewFavoriteModal = function (_Component) {
	  _inherits(NewFavoriteModal, _Component);
	
	  function NewFavoriteModal() {
	    _classCallCheck(this, NewFavoriteModal);
	
	    var _this = _possibleConstructorReturn(this, (NewFavoriteModal.__proto__ || Object.getPrototypeOf(NewFavoriteModal)).call(this));
	
	    _this.state = {
	      inventoryOptions: []
	    };
	    return _this;
	  }
	
	  _createClass(NewFavoriteModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.fetchInventories();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.inventoryItems && nextProps.inventoryItems != this.props.inventoryItems) {
	        var inventoryItemOptions = [{ value: '', label: "No.       |  Name           |  Description" }];
	        nextProps.inventoryItems.map(function (inventoryItem) {
	          var text = "                                                              ";
	          var output = [inventoryItem.ProductNum.slice(0, 8), text].join('');
	          output = [output.slice(0, 8), '  |  ', inventoryItem.Name.slice(0, 12), text].join('');
	          output = [output.slice(0, 26), '  |  ', inventoryItem.Description.slice(0, 50), text].join('');
	          output = output.slice(0, 86);
	          inventoryItemOptions.push({ value: inventoryItem.Product_id, label: output });
	        });
	        console.log("inventoryOptions", inventoryItemOptions);
	        this.setState({ inventoryOptions: inventoryItemOptions });
	      }
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      var _props = this.props,
	          inventoryItems = _props.inventoryItems,
	          closeA = _props.closeA,
	          SalesFavoriteList_id = _props.SalesFavoriteList_id,
	          currentList = _props.currentList;
	
	      console.log("inventoryItems", inventoryItems);
	      console.log("formProps", formProps);
	      console.log("currentList", currentList);
	      var check = _lodash2.default.findIndex(currentList.rows, { 'Product_id': formProps.InventoryItem_id.value });
	      if (check > -1) {
	        this.props.inListError();
	        return;
	      } else {
	        this.props.clearInListError();
	      }
	      var index = _lodash2.default.findIndex(inventoryItems, { 'Product_id': formProps.InventoryItem_id.value });
	
	      var newFav = _extends({}, inventoryItems[index]);
	      console.log("newfav", inventoryItems[index]);
	      newFav.ProductName = inventoryItems[index].Name;
	      console.log(newFav);
	      // if (inventoryItems[index].Product) {
	      //   newFav.ProductName = inventoryItems[index].Product["Name"];
	      // }
	      if (SalesFavoriteList_id) {
	        // this.props.addNewCustomerFavorite(newFav, SalesFavoriteList_id);
	      } else {
	        console.log("ABOUT TO CALL", newFav);
	        this.props.addNewFavorite(newFav);
	      }
	      console.log("about to call closeA");
	      closeA(inventoryItems[index]);
	    }
	  }, {
	    key: 'moveToFavotitesList',
	    value: function moveToFavotitesList() {}
	  }, {
	    key: 'renderInventoryItems',
	    value: function renderInventoryItems() {
	      if (this.props.isLoading) return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 12, className: 'marginTopStyle' },
	        _react2.default.createElement(_spinner2.default, null)
	      );else {
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12, className: 'marginTopStyle' },
	          _react2.default.createElement(
	            'label',
	            { className: 'centerStyle' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_an_inventory_item', defaultMessage: 'Select an Inventory Item', description: 'Select an Inventory Item' })
	          ),
	          _react2.default.createElement(_reduxForm.Field, { name: 'InventoryItem_id', component: _detailedSelection2.default, options: this.state.inventoryOptions })
	        );
	      }
	    }
	  }, {
	    key: 'renderAddItemResults',
	    value: function renderAddItemResults() {
	      if (!this.props.inList) return;else return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'item_already_in_list' })
	        )
	      );
	    }
	
	    // Once User choose a Template, show him some detail
	
	  }, {
	    key: 'renderInventoryItemDetail',
	    value: function renderInventoryItemDetail(id) {
	      var inventoryItems = this.props.inventoryItems;
	
	      var index = _lodash2.default.findIndex(inventoryItems, { 'id': id });
	      if (index > -1) {
	        var description;
	        var name;
	        var refPurchasePrice;
	
	        if (inventoryItems[index].ProductNum) {
	          if (inventoryItems[index].ProductNum.Description) {
	            description = inventoryItems[index].ProductNum.Description;
	          } else {
	            description = '';
	          }
	          if (inventoryItems[index].ProductNum.Name) {
	            name = inventoryItems[index].ProductNum.Name;
	          } else {
	            name = '';
	          }
	        }
	        if (inventoryItems[index].RefPurchasingPrice) {
	          refPurchasePrice = inventoryItems[index].RefPurchasingPrice;
	        } else {
	          refPurchasePrice = '';
	        }
	
	        if (description && name && refPurchasePrice) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 12 },
	                'Inventory Item Name: ',
	                name
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 12 },
	                'Description: ',
	                description
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 12 },
	                'Ref Purchase Price: ',
	                refPurchasePrice
	              )
	            )
	          );
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          handleSubmit = _props2.handleSubmit,
	          closeC = _props2.closeC,
	          submitting = _props2.submitting,
	          pristine = _props2.pristine,
	          inventoryItemValue = _props2.inventoryItemValue;
	
	      var height = 40 .toString();
	      var tableCollapseFix = { height: height };
	      return _react2.default.createElement(
	        'form',
	        { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { style: tableCollapseFix },
	          this.renderInventoryItems()
	        ),
	        inventoryItemValue && this.renderInventoryItemDetail(inventoryItemValue.value),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'success',
	              type: 'submit',
	              action: 'submit',
	              disabled: submitting },
	            _react2.default.createElement('em', { className: 'fa fa-save' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_new_favorite', defaultMessage: 'Add New Favorite', description: 'save' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'danger',
	              type: 'reset',
	              onClick: function onClick(event) {
	                event.preventDefault();closeC();_this2.props.clearInListError();
	              } },
	            _react2.default.createElement('em', { className: 'fa fa-close' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel', defaultMessage: 'Cancel', description: 'Cancel' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(_reactBootstrap.Col, { sm: 4 }),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            this.renderAddItemResults()
	          )
	        )
	      );
	    }
	  }]);
	
	  return NewFavoriteModal;
	}(_react.Component);
	
	NewFavoriteModal.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = NewFavoriteModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(NewFavoriteModal, 'NewFavoriteModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Favorites/favoriteModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Favorites/favoriteModal.jsx');
	}();

	;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactDropzone = __webpack_require__(45);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isAFM = _root_url.ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afm-scm.truckxi.com/api/';
	
	var _require = __webpack_require__(5),
	    _require$Draggable = _require.Draggable,
	    DraggableContainer = _require$Draggable.Container,
	    RowActionsCell = _require$Draggable.RowActionsCell,
	    DropTargetRowContainer = _require$Draggable.DropTargetRowContainer,
	    Selectors = _require.Data.Selectors;
	
	var RowRenderer = DropTargetRowContainer(_reactDataGrid2.default.Row);
	
	var BillboardImagesTable = function (_Component) {
	  _inherits(BillboardImagesTable, _Component);
	
	  function BillboardImagesTable(props) {
	    _classCallCheck(this, BillboardImagesTable);
	
	    var _this = _possibleConstructorReturn(this, (BillboardImagesTable.__proto__ || Object.getPrototypeOf(BillboardImagesTable)).call(this, props));
	
	    _this.onDrop = function (row, files) {
	      if (!files) {
	        return;
	      }
	      var reader = new FileReader();
	      reader.onload = function () {
	        var index = row.props.rowIdx;
	        var newRows = _lodash2.default.cloneDeep(_this.state.rows);
	        newRows[index].Image = reader.result;
	        _this.setState({ rows: newRows });
	      };
	      // get the first file and convert to blob object (Blob.slice([start [, end [, contentType]]))
	      var blob = files[0].slice(0, files[0].size, files[0].type);
	      reader.readAsDataURL(blob);
	    };
	
	    _this.saveImages = function (e) {
	      e.preventDefault();
	      var rows = _this.state.rows.filter(function (row) {
	        var match = row.Image !== undefined;
	        return match;
	      });
	      _this.setState({ rows: rows }, function () {
	        _this.props.saveBillboardImages(_this.state.rows).then(function () {
	          _this.props.reload();
	        });
	      });
	    };
	
	    _this.addNewImageRow = function (e) {
	      e.preventDefault();
	      var rows = _reactDataGridAddons.Data.Selectors.getRows(_this.state);
	      if (rows.length === 20) {
	        alert('Max of 20 images!');
	        return;
	      }
	      var index = rows.length;
	      var newRow = {
	        IsEnabled: true, Index: index
	      };
	      rows.push(newRow);
	      _this.setState({ rows: rows });
	    };
	
	    _this.deleteRow = function () {
	      var selectedRows = _this.state.selectedRows;
	
	      if (!selectedRows || selectedRows.length === 0) {
	        alert('Select a row to delete!');
	        return;
	      }
	      var id = selectedRows[0].id;
	
	      if (id) {
	        _this.props.delete(id).then(function () {
	          _this.props.reload();
	        });
	      } else {
	        var rows = _lodash2.default.cloneDeep(_this.state.rows);
	        var index = _lodash2.default.findIndex(rows, { Index: selectedRows[0].Index });
	        rows.splice(index, 1);
	        rows.map(function (row, rowIndex) {
	          row.Index = rowIndex;
	        });
	        _this.setState({ rows: rows, selectedRows: [] });
	      }
	    };
	
	    _this.renderImage = function (index) {
	      var imageFile = _this.state.rows[index].Image || '/img/dummy.png';
	      return _react2.default.createElement(
	        'div',
	        { className: 'img-view' },
	        _react2.default.createElement('img', {
	          src: imageFile,
	          alt: 'Upload',
	          className: 'default-image'
	        })
	      );
	    };
	
	    _this.state = {
	      rows: [],
	      selectedRows: null,
	      sortColumn: null,
	      sortDirection: null
	    };
	    return _this;
	  }
	
	  _createClass(BillboardImagesTable, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.rows && nextProps.rows !== this.props.rows) {
	        nextProps.rows.map(function (row, index) {
	          row.Index = index;
	        });
	        this.setState({ rows: nextProps.rows });
	      }
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this2 = this;
	
	      if (this.props.rowsIsLoading) {
	        return _react2.default.createElement(_spinner2.default, null);
	      }
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        // merge updated row with current row and rerender by setting state
	        _this2.setState({ sortColumn: null, sortDirection: null });
	        var rows = getRows();
	        Object.assign(rows[e.rowIdx], e.updated);
	        _this2.setState({ rows: rows });
	      };
	
	      var handleIsEnabledClick = function handleIsEnabledClick(isEnabled) {
	        var rows = getRows();
	        if (isEnabled.value === false) {
	          var enabledCount = 0;
	          rows.map(function (row) {
	            if (row.IsEnabled === true) {
	              enabledCount += 1;
	            }
	          });
	          if (enabledCount === 6) {
	            alert('Only 6 images can be enabled at a time');
	            return;
	          }
	        }
	        var index = _lodash2.default.findIndex(rows, { Index: isEnabled.dependentValues.Index });
	        rows[index].IsEnabled = !rows[index].IsEnabled;
	        _this2.setState({ rows: rows });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        _this2.setState({
	          rows: newRows, selectedRows: [rows[0].row]
	        });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = getRows();
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        _this2.setState({ rows: newRows, selectedRows: [] });
	      };
	
	      var isDraggedRowSelected = function isDraggedRowSelected(selectedRows, rowDragSource) {
	        if (selectedRows && selectedRows.length > 0) {
	          var key = _this2.props.rowKey;
	          return selectedRows.filter(function (r) {
	            return r[key] === rowDragSource.data[key];
	          }).length > 0;
	        }
	        return false;
	      };
	
	      var reorderRows = function reorderRows(e) {
	        var selectedRows = Selectors.getSelectedRowsByKey({ rowKey: _this2.props.rowKey, selectedKeys: [], rows: _this2.state.rows });
	        var draggedRows = isDraggedRowSelected(selectedRows, e.rowSource) ? selectedRows : [e.rowSource.data];
	        var undraggedRows = _this2.state.rows.filter(function (r) {
	          return draggedRows.indexOf(r) === -1;
	        });
	        var args = [e.rowTarget.idx, 0].concat(draggedRows);
	        Array.prototype.splice.apply(undraggedRows, args);
	        undraggedRows.map(function (row, index) {
	          row.Index = index;
	        });
	        _this2.setState({ rows: undraggedRows });
	      };
	
	      var IsEnabledFormatter = _react2.default.createClass({
	        displayName: 'IsEnabledFormatter',
	        render: function render() {
	          var _this3 = this;
	
	          return _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'center' } },
	            _react2.default.createElement('input', {
	              id: 'billboard-image-enable',
	              type: 'checkbox',
	              value: 'true',
	              checked: this.props.value === true || this.props.value === 'true',
	              onClick: function onClick() {
	                handleIsEnabledClick(_this3.props);
	              }
	            })
	          );
	        }
	      });
	
	      var ThumbnailFormatter = _react2.default.createClass({
	        displayName: 'ThumbnailFormatter',
	        render: function render() {
	          return _react2.default.createElement(
	            'div',
	            { id: 'billboard-image-container' },
	            _react2.default.createElement(
	              _reactDropzone2.default,
	              {
	                onDrop: this.props.onDrop.bind(this.props.dependentValues.Index, this),
	                className: 'billboard-image-dropzone',
	                accept: 'image/*'
	              },
	              _react2.default.createElement(
	                'div',
	                null,
	                this.props.renderImage(this.props.dependentValues.Index)
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  id: 'dropzone-button',
	                  bsStyle: 'primary',
	                  type: 'button'
	                },
	                _react2.default.createElement('em', { className: 'fa fa-plus' })
	              )
	            )
	          );
	        }
	      });
	
	      var InputFormatter = _react2.default.createClass({
	        displayName: 'InputFormatter',
	        onChange: function onChange(url) {
	          var newRows = getRows();
	          var index = this.props.dependentValues.Index;
	          newRows[index].URL = url;
	          this.setState({ rows: newRows });
	        },
	        render: function render() {
	          var _this4 = this;
	
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactBootstrap.Input, {
	              type: 'text',
	              name: 'url',
	              onChange: function onChange(event) {
	                return _this4.onChange(event.target.value);
	              },
	              value: this.props.dependentValues.URL
	            })
	          );
	        }
	      });
	
	      var LinkTypeFormatter = _react2.default.createClass({
	        displayName: 'LinkTypeFormatter',
	        handleTypeSelect: function handleTypeSelect(type) {
	          var newRows = getRows();
	          var index = this.props.dependentValues.Index;
	          newRows[index].MIMEType = type;
	          this.setState({ rows: newRows });
	        },
	        render: function render() {
	          var _this5 = this;
	
	          var linkOptions = [{ value: 'URL', label: 'URL' }, { value: 'Category2', label: 'Category2' }, { value: 'Group', label: 'Group' }, { value: 'Category', label: 'Category' }];
	          return _react2.default.createElement(
	            'div',
	            { className: 'billboard-display-options2' },
	            _react2.default.createElement(_GenericSelection2.default, {
	              options: linkOptions,
	              value: this.props.dependentValues.MIMEType,
	              setSelected: function setSelected(e) {
	                _this5.handleTypeSelect(e.value);
	              }
	            })
	          );
	        }
	      });
	
	      var LangFormatter = _react2.default.createClass({
	        displayName: 'LangFormatter',
	        handleLangSelect: function handleLangSelect(lang) {
	          var newRows = getRows();
	          var index = this.props.dependentValues.Index;
	          newRows[index].Language = lang;
	          this.setState({ rows: newRows });
	        },
	        render: function render() {
	          var _this6 = this;
	
	          var langOptions = [{ value: 'en', label: 'EN' }, { value: 'ch', label: 'CH' }];
	          return _react2.default.createElement(
	            'div',
	            { className: 'billboard-display-options' },
	            _react2.default.createElement(_GenericSelection2.default, {
	              options: langOptions,
	              value: this.props.dependentValues.Language,
	              setSelected: function setSelected(e) {
	                _this6.handleLangSelect(e.value);
	              }
	            })
	          );
	        }
	      });
	
	      var CustomerFormatter = _react2.default.createClass({
	        displayName: 'CustomerFormatter',
	        handleCustomerSelect: function handleCustomerSelect(customer) {
	          var newRows = getRows();
	          var index = this.props.dependentValues.Index;
	          newRows[index].CustomerType = customer;
	          this.setState({ rows: newRows });
	        },
	        render: function render() {
	          var _this7 = this;
	
	          var customerOptions = [{ value: 'all', label: 'All' }, { value: 'b2b', label: 'B2B' }, { value: 'b2c', label: 'B2C' }];
	          return _react2.default.createElement(
	            'div',
	            { className: 'billboard-display-options' },
	            _react2.default.createElement(_GenericSelection2.default, {
	              options: customerOptions,
	              value: this.props.dependentValues.CustomerType,
	              setSelected: function setSelected(e) {
	                _this7.handleCustomerSelect(e.value);
	              }
	            })
	          );
	        }
	      });
	
	      var columns = [{
	        key: 'Thumbnail',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'thumbnail' }),
	        resizeable: true,
	        width: 400,
	        sortable: false,
	        editable: false,
	        filterable: false,
	        formatter: _react2.default.createElement(ThumbnailFormatter, { renderImage: this.renderImage, onDrop: this.onDrop }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'IsEnabled',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: IsEnabledFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'URL',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'link' }),
	        resizable: true,
	        width: 320,
	        filterable: true,
	        formatter: InputFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'Language',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'language' }),
	        resizable: true,
	        width: 95,
	        filterable: false,
	        formatter: LangFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'CustomerType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'b2b_b2c' }),
	        resizable: true,
	        width: 75,
	        filterable: false,
	        formatter: CustomerFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }];
	
	      if (isAFM) {
	        var indexCol = _lodash2.default.findIndex(columns, { key: "URL" });
	        var typeColumn = {
	          key: 'MIMEType',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Type' }),
	          resizable: true,
	          width: 150,
	          filterable: true,
	          formatter: LinkTypeFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        };
	        columns.splice(indexCol, 0, typeColumn);
	      }
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            DraggableContainer,
	            null,
	            _react2.default.createElement(_reactDataGrid2.default, {
	              columns: columns,
	              enableCellSelect: true,
	              minHeight: 620,
	              rowHeight: 200,
	              headerRowHeight: 25,
	              enableRowSelect: 'single',
	              onRowUpdated: handleRowUpdated,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              rowActionsCell: RowActionsCell,
	              rowRenderer: _react2.default.createElement(RowRenderer, { onRowDrop: reorderRows }),
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, null),
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              }
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          saving = _props.saving,
	          deleting = _props.deleting;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Panel,
	        { id: 'mobile-billboard-images' },
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            null,
	            _react2.default.createElement(_SpinnerButton2.default, {
	              bsStyle: 'success',
	              disabled: saving,
	              onClick: this.saveImages,
	              loading: saving,
	              icon: 'fa-save',
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	            }),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                onClick: this.addNewImageRow
	              },
	              _react2.default.createElement('em', { className: 'fa fa-plus' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	            ),
	            _react2.default.createElement(_SpinnerButton2.default, {
	              bsStyle: 'danger',
	              disabled: deleting,
	              onClick: this.deleteRow,
	              loading: deleting,
	              icon: 'fa-trash',
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	            })
	          ),
	          this.renderTable()
	        )
	      );
	    }
	  }]);
	
	  return BillboardImagesTable;
	}(_react.Component);
	
	BillboardImagesTable.defaultProps = {
	  rows: [],
	  rowsIsLoading: false,
	  rowKey: 'Index',
	  value: false,
	  saving: false,
	  dependentValues: {},
	  deleting: false,
	  renderImage: function renderImage() {},
	  onDrop: function onDrop() {},
	  saveBillboardImages: function saveBillboardImages() {},
	  reload: function reload() {},
	  delete: function _delete() {}
	};
	
	BillboardImagesTable.propTypes = {
	  rows: _propTypes2.default.array,
	  rowsIsLoading: _propTypes2.default.bool,
	  rowKey: _propTypes2.default.string,
	  dependentValues: _propTypes2.default.shape({
	    Index: _propTypes2.default.number,
	    URL: _propTypes2.default.string,
	    Language: _propTypes2.default.string,
	    MIMEType: _propTypes2.default.string,
	    CustomerType: _propTypes2.default.string
	  }),
	  reload: _propTypes2.default.func,
	  saveBillboardImages: _propTypes2.default.func,
	  saving: _propTypes2.default.bool,
	  renderImage: _propTypes2.default.func,
	  onDrop: _propTypes2.default.func,
	  value: _propTypes2.default.bool,
	  delete: _propTypes2.default.func,
	  deleting: _propTypes2.default.bool
	};
	
	var _default = BillboardImagesTable;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isAFM, 'isAFM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/General/BillboardImagesTable.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/General/BillboardImagesTable.jsx');
	
	  __REACT_HOT_LOADER__.register(BillboardImagesTable, 'BillboardImagesTable', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/General/BillboardImagesTable.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/General/BillboardImagesTable.jsx');
	}();

	;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategorySidebar = function CategorySidebar(_ref) {
	  var categories = _ref.categories,
	      subCategories = _ref.subCategories,
	      expandedCategoryId = _ref.expandedCategoryId,
	      handleExpandGroup = _ref.handleExpandGroup,
	      handleCategoryClick = _ref.handleCategoryClick;
	  return _react2.default.createElement(
	    _reactBootstrap.Panel,
	    { id: 'category-nav', className: 'panelStyle' },
	    _react2.default.createElement(
	      _reactBootstrap.Panel,
	      { className: 'panelStyle' },
	      _react2.default.createElement(
	        'div',
	        { style: { fontWeight: 'bold', cursor: 'pointer' }, name: 'group', id: 'g-1', onClick: function onClick() {
	            handleCategoryClick('All');
	          } },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' })
	      )
	    ),
	    categories && categories.map(function (category) {
	      var groupNum = parseInt(category.GroupNum);
	      if (groupNum < 10) groupNum = '0' + groupNum;
	      var id = category.ProductGroup_id;
	      var description = 'Misc';
	      if (localStorage.getItem('lang') === 'ch') {
	        description = 'Description';
	      } else if (localStorage.getItem('lang') === 'en') {
	        description = 'Name';
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Panel,
	        { className: 'panelStyle' },
	        _react2.default.createElement(
	          'div',
	          {
	            style: { fontFamily: 'Arial Black', cursor: 'pointer' },
	            name: 'group',
	            id: 'g' + id,
	            onClick: function onClick() {
	              handleExpandGroup(id);handleCategoryClick(category[description], id);
	            }
	          },
	          _react2.default.createElement(
	            'label',
	            { style: { fontWeight: 'bold' } },
	            groupNum
	          ),
	          ' ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: category[description] })
	        ),
	        expandedCategoryId === id && subCategories && _react2.default.createElement(
	          'div',
	          null,
	          subCategories.map(function (category) {
	            return _react2.default.createElement(
	              'li',
	              {
	                className: 'clickListLi',
	                style: { fontFamily: 'Arial', cursor: 'pointer' },
	                name: 'category', id: 'c' + category.ProductCategory_id,
	                onClick: function onClick() {
	                  handleCategoryClick(category.Description, null, category.ProductCategory_id);
	                }
	              },
	              _react2.default.createElement(
	                'label',
	                { style: { fontWeight: 'bold' } },
	                category.CategoryNum
	              ),
	              ' ' + category.Description
	            );
	          })
	        )
	      );
	    })
	  );
	};
	
	var _default = CategorySidebar;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CategorySidebar, 'CategorySidebar', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/General/CategoryAnalysis/components/CategorySidebar.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/General/CategoryAnalysis/components/CategorySidebar.jsx');
	}();

	;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(102);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesPerformanceGraph = function SalesPerformanceGraph(_ref) {
	  var salesPerformanceData = _ref.salesPerformanceData,
	      activeCategoryName = _ref.activeCategoryName,
	      salesPerformanceDateFilterValue = _ref.salesPerformanceDateFilterValue,
	      handleChangeSalesPerformanceDateFilter = _ref.handleChangeSalesPerformanceDateFilter;
	  return _react2.default.createElement(
	    _reactBootstrap.Panel,
	    {
	      header: _react2.default.createElement(
	        'h4',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_cost' }),
	        ': ',
	        activeCategoryName
	      ),
	      className: 'income-expense-chart',
	      style: { height: 300 }
	    },
	    _react2.default.createElement(
	      _reactBootstrap.Row,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 4, smOffset: 4 },
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'optionStyle' },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              'p',
	              { className: 'radio-inline' },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'radio',
	                value: 'week',
	                checked: salesPerformanceDateFilterValue === 'weekly',
	                onClick: function onClick() {
	                  handleChangeSalesPerformanceDateFilter('weekly');
	                }
	              }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Weekly' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              'label',
	              { className: 'radio-inline' },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'radio',
	                value: 'month',
	                checked: salesPerformanceDateFilterValue === 'monthly',
	                onClick: function onClick() {
	                  handleChangeSalesPerformanceDateFilter('monthly');
	                }
	              }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Monthly' })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Col,
	      null,
	      _react2.default.createElement(_reactChartjs.Bar, {
	        data: salesPerformanceData,
	        height: 200,
	        width: 300,
	        options: {
	          maintainAspectRatio: false,
	          scales: {
	            yAxes: [{
	              ticks: {
	                beginAtZero: true
	              }
	            }]
	          }
	        }
	      })
	    )
	  );
	};
	
	var _default = SalesPerformanceGraph;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SalesPerformanceGraph, 'SalesPerformanceGraph', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/General/CategoryAnalysis/components/SalesPerformanceGraph.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/General/CategoryAnalysis/components/SalesPerformanceGraph.jsx');
	}();

	;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _utils = __webpack_require__(340);
	
	var _CategorySidebar = __webpack_require__(337);
	
	var _CategorySidebar2 = _interopRequireDefault(_CategorySidebar);
	
	var _SalesPerformanceGraph = __webpack_require__(338);
	
	var _SalesPerformanceGraph2 = _interopRequireDefault(_SalesPerformanceGraph);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CategoryAnalysis = function (_Component) {
	  _inherits(CategoryAnalysis, _Component);
	
	  function CategoryAnalysis() {
	    _classCallCheck(this, CategoryAnalysis);
	
	    var _this = _possibleConstructorReturn(this, (CategoryAnalysis.__proto__ || Object.getPrototypeOf(CategoryAnalysis)).call(this));
	
	    _this.state = {
	      // category side bar
	      expandedCategoryId: -1,
	
	      // sales performace graph
	      activeCategoryName: 'All',
	      activeGroupId: null,
	      activeCategoryId: null,
	      salesPerformanceDateFilter: 'weekly',
	      salesPerformanceDataIsLoading: false,
	      salesPerformanceData: null,
	      salesPerformanceDataError: null
	    };
	
	    _this.handleExpandGroup = _this.handleExpandGroup.bind(_this);
	    _this.handleCategoryClick = _this.handleCategoryClick.bind(_this);
	    _this.handleChangeSalesPerformanceDateFilter = _this.handleChangeSalesPerformanceDateFilter.bind(_this);
	    return _this;
	  }
	
	  _createClass(CategoryAnalysis, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.fetchGroups();
	      this.handleFetchSalesPerformanceData();
	    }
	  }, {
	    key: 'handleFetchSalesPerformanceData',
	    value: function handleFetchSalesPerformanceData() {
	      var _this2 = this;
	
	      this.setState({
	        salesPerformanceDataIsLoading: true,
	        salesPerformanceDataError: null
	      });
	      (0, _utils.fetchSalesPerformanceData)(this.state.salesPerformanceDateFilter, this.state.activeGroupId, this.state.activeCategoryId).then(function (response) {
	        _this2.setState({
	          salesPerformanceDataIsLoading: false,
	          salesPerformanceData: response.data,
	          salesPerformanceDataError: null
	        });
	      }, function (err) {
	        _this2.setState({
	          salesPerformanceDataIsLoading: false,
	          salesPerformanceDataError: err
	        });
	      });
	    }
	  }, {
	    key: 'handleChangeSalesPerformanceDateFilter',
	    value: function handleChangeSalesPerformanceDateFilter(type) {
	      var _this3 = this;
	
	      if (type === 'weekly' || type === 'monthly') {
	        this.setState({
	          salesPerformanceDateFilter: type
	        }, function () {
	          _this3.handleFetchSalesPerformanceData();
	        });
	      }
	    }
	  }, {
	    key: 'handleCategoryClick',
	    value: function handleCategoryClick(name) {
	      var _this4 = this;
	
	      var groupId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var categoryId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      this.setState({
	        activeCategoryName: name,
	        activeGroupId: groupId,
	        activeCategoryId: categoryId
	      }, function () {
	        _this4.handleFetchSalesPerformanceData();
	      });
	    }
	  }, {
	    key: 'handleExpandGroup',
	    value: function handleExpandGroup(id) {
	      this.setState({
	        expandedCategoryId: id
	      });
	      this.props.fetchGroupCategories(id);
	    }
	  }, {
	    key: 'createSalesObject',
	    value: function createSalesObject() {
	      return {
	        labels: [],
	        datasets: [{
	          label: 'Total Cost',
	          backgroundColor: 'rgba(255,99,132,0.6)',
	          borderColor: 'rgba(255,99,133,1)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgba(255,99,133,0.8)',
	          hoverBorderColor: 'rgba(255,99,133,1)',
	          data: []
	        }, {
	          label: 'Total Sales',
	          backgroundColor: 'rgba(20, 92, 169, 0.4)',
	          borderColor: 'rgba(20, 92, 169, 1)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgba(20, 92, 169, 0.6)',
	          hoverBorderColor: 'rgba(20, 92, 169, 1)',
	          data: []
	        }]
	      };
	    }
	  }, {
	    key: 'cleanSalesPerformanceData',
	    value: function cleanSalesPerformanceData() {
	      var _this5 = this;
	
	      var months = [0, 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	      var salesTotals = this.createSalesObject();
	      this.state.salesPerformanceData.forEach(function (record) {
	        if (_this5.state.salesPerformanceDateFilter === 'monthly') {
	          salesTotals.labels.push(months[record.Month]);
	        } else {
	          salesTotals.labels.push(record.Day);
	        }
	
	        salesTotals.datasets[0].data.push(record.TotalCost);
	        salesTotals.datasets[1].data.push(record.TotalSales);
	      });
	      return salesTotals;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_management' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category_analysis' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 2 },
	              _react2.default.createElement(_CategorySidebar2.default, {
	                categories: this.props.categories,
	                subCategories: this.props.subCategories,
	                expandedCategoryId: this.state.expandedCategoryId,
	                handleExpandGroup: this.handleExpandGroup,
	                handleCategoryClick: this.handleCategoryClick
	              })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 10 },
	              this.state.salesPerformanceDataIsLoading ? _react2.default.createElement(_spinner2.default, null) : _react2.default.createElement(_SalesPerformanceGraph2.default, {
	                salesPerformanceData: this.cleanSalesPerformanceData(),
	                activeCategoryName: this.state.activeCategoryName,
	                salesPerformanceDateFilterValue: this.state.salesPerformanceDateFilter,
	                handleChangeSalesPerformanceDateFilter: this.handleChangeSalesPerformanceDateFilter
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CategoryAnalysis;
	}(_react.Component);
	
	var _default = CategoryAnalysis;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CategoryAnalysis, 'CategoryAnalysis', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/General/CategoryAnalysis/index.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/General/CategoryAnalysis/index.jsx');
	}();

	;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchSalesPerformanceData = fetchSalesPerformanceData;
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchSalesPerformanceData(type) {
	  var groupId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  var categoryId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var url = _root_url.ROOT_URL + 'v1/dashboard/category_analysis/chart';
	  var params = {
	    type: type
	  };
	  if (groupId) params.group = groupId;
	  if (categoryId) params.category = categoryId;
	
	  return (0, _axios2.default)({
	    method: 'get',
	    url: url,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
	    params: params
	  });
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchSalesPerformanceData, 'fetchSalesPerformanceData', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/General/CategoryAnalysis/utils.js');
	}();

	;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _GenericProductSuggest = __webpack_require__(51);
	
	var _GenericProductSuggest2 = _interopRequireDefault(_GenericProductSuggest);
	
	var _MobileManagementTable = __webpack_require__(342);
	
	var _MobileManagementTable2 = _interopRequireDefault(_MobileManagementTable);
	
	var _BillboardImagesTable = __webpack_require__(336);
	
	var _BillboardImagesTable2 = _interopRequireDefault(_BillboardImagesTable);
	
	var _RichTextEditor = __webpack_require__(151);
	
	var _RichTextEditor2 = _interopRequireDefault(_RichTextEditor);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _mobileManagement_actions = __webpack_require__(135);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var createDialogStyle = {
	  width: '800px',
	  height: '800px',
	  marginLeft: '-15%',
	  top: '30%'
	};
	
	var MobileManagement = function (_Component) {
	  _inherits(MobileManagement, _Component);
	
	  function MobileManagement(props) {
	    _classCallCheck(this, MobileManagement);
	
	    var _this = _possibleConstructorReturn(this, (MobileManagement.__proto__ || Object.getPrototypeOf(MobileManagement)).call(this, props));
	
	    _this.onSuggestionSelected = function (productNum, suggestions) {
	      _this.setState({ selectedProduct: suggestions }, _this.addProductToTable);
	    };
	
	    _this.addProductToTable = function () {
	      _this.setState(function (prevState) {
	        var productList = prevState.productList,
	            selectedProduct = prevState.selectedProduct;
	
	        var index = _.findIndex(productList, { Product_id: selectedProduct.Product_id });
	        if (index === -1) {
	          productList.push(selectedProduct);
	        } else {
	          alert('Product is already in the list');
	        }
	        return { productList: productList, selectedProduct: null, suggestValue: '' };
	      });
	    };
	
	    _this.handleOptionChange = function (changeEvent) {
	      _this.setState({ productSearchType: changeEvent.target.value });
	    };
	
	    _this.handleSelect = function (tabKey) {
	      _this.setState({ tabKey: tabKey });
	    };
	
	    _this.openFAQBox = function () {
	      _this.setState({ isFAQBoxOpen: true });
	    };
	
	    _this.closeFAQBox = function () {
	      _this.setState({ isFAQBoxOpen: false });
	    };
	
	    _this.saveRichText = function (htmlText) {
	      var handleSuccess = function handleSuccess() {
	        _this.setState({
	          isLoadingFAQSave: false,
	          saveFAQRichTextSuccess: true
	        });
	      };
	      var handleFailure = function handleFailure(error) {
	        alert(error);
	        _this.setState({
	          isLoadingFAQSave: false,
	          saveFAQRichTextSuccess: false
	        });
	      };
	      _this.setState({
	        isLoadingFAQSave: true,
	        saveFAQRichTextSuccess: false
	      }, function () {
	        return (0, _mobileManagement_actions.saveFAQBoxText)(htmlText, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.fetchRichText = function () {
	      var handleSuccess = function handleSuccess(response) {
	        _this.setState({
	          faqRichText: response.rich_text,
	          isLoadingFAQRichText: false
	        }, function () {
	          return _this.openFAQBox();
	        });
	      };
	      var handleFailure = function handleFailure(error) {
	        alert(error);
	        _this.setState({
	          faqRichText: '',
	          isLoadingFAQRichText: false
	        }, function () {
	          return _this.openFAQBox();
	        });
	      };
	      _this.setState({
	        isLoadingFAQRichText: true
	      }, function () {
	        return (0, _mobileManagement_actions.fetchFAQBoxText)(handleSuccess, handleFailure);
	      });
	    };
	
	    _this.state = {
	      suggestValue: '',
	      productSearchType: 'ProductNum',
	      selectedProduct: null,
	      productList: [],
	      tabKey: 1,
	      isFAQBoxOpen: false,
	      faqRichText: undefined,
	      isLoadingFAQSave: false,
	      saveFAQRichTextSuccess: false
	    };
	    return _this;
	  }
	
	  _createClass(MobileManagement, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      // this.props.fetchGreatDealsNewArrivals();
	      this.props.fetchBillboardImages();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.productList !== nextProps.productList) {
	        this.setState({ productList: nextProps.productList });
	      }
	    }
	  }, {
	    key: 'renderAutoSuggest',
	    value: function renderAutoSuggest() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'control-dropdown' },
	        _react2.default.createElement(_GenericProductSuggest2.default, {
	          value: this.state.suggestValue,
	          onChange: function onChange(e, _ref) {
	            var newValue = _ref.newValue;
	            _this2.setState({ suggestValue: newValue });
	          },
	          SearchType: this.state.productSearchType,
	          fetchOrdersByProduct: this.onSuggestionSelected
	        })
	      );
	    }
	  }, {
	    key: 'renderBillboardImagesTable',
	    value: function renderBillboardImagesTable() {
	      var _props = this.props,
	          billboardImagesList = _props.billboardImagesList,
	          billboardImagesIsLoading = _props.billboardImagesIsLoading,
	          saveBillboardImages = _props.saveBillboardImages,
	          savingBillboardImages = _props.savingBillboardImages,
	          fetchBillboardImages = _props.fetchBillboardImages,
	          deleteBillboardImage = _props.deleteBillboardImage,
	          deletingBillboardImage = _props.deletingBillboardImage;
	
	      return _react2.default.createElement(_BillboardImagesTable2.default, {
	        rows: billboardImagesList,
	        rowsIsLoading: billboardImagesIsLoading,
	        saveBillboardImages: saveBillboardImages,
	        saving: savingBillboardImages,
	        reload: fetchBillboardImages,
	        'delete': deleteBillboardImage,
	        deleting: deletingBillboardImage
	      });
	    }
	  }, {
	    key: 'renderGreatDealsTable',
	    value: function renderGreatDealsTable() {
	      var productList = this.state.productList;
	      var _props2 = this.props,
	          productListIsLoading = _props2.productListIsLoading,
	          updateGreatDeals = _props2.updateGreatDeals,
	          updateNewArrivals = _props2.updateNewArrivals,
	          isUpdating = _props2.isUpdating;
	
	      return _react2.default.createElement(_MobileManagementTable2.default
	      // title={<Translate value="great_deals/new_arrivals" />}
	      , { rows: productList,
	        rowsIsLoading: productListIsLoading,
	        saveProducts: {
	          saveGreatDeals: updateGreatDeals,
	          saveNewArrivals: updateNewArrivals
	        },
	        isUpdating: isUpdating
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_management' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: true },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mobile_management' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          { id: 'breadcrumbButtonGroup' },
	          _react2.default.createElement(_SpinnerButton2.default, {
	            bsStyle: 'primary',
	            onClick: this.fetchRichText,
	            disabled: this.state.isLoadingFAQRichText,
	            loading: this.state.isLoadingFAQRichText,
	            icon: 'fa-pencil',
	            translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'faq' })
	          })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'mobile-management' },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 10, xsOffset: 1 },
	            _react2.default.createElement(
	              _reactBootstrap.Tabs,
	              { activeKey: this.state.tabKey, justified: true, onSelect: this.handleSelect },
	              _react2.default.createElement(
	                _reactBootstrap.Tab,
	                { eventKey: 1, title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'billboard_images' }) },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  null,
	                  this.renderBillboardImagesTable()
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogStyle,
	              isVisible: this.state.isFAQBoxOpen,
	              onCloseClicked: this.closeFAQBox,
	              title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'faq' })
	            },
	            _react2.default.createElement(_RichTextEditor2.default, {
	              htmlString: this.state.faqRichText,
	              placeholder: 'Enter the frequently asked questions.',
	              saveHtml: function saveHtml(richText) {
	                _this3.saveRichText(richText);
	              },
	              isLoadingSave: this.state.isLoadingFAQSave,
	              saveSuccess: this.state.saveFAQRichTextSuccess
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return MobileManagement;
	}(_react.Component);
	
	MobileManagement.defaultProps = {
	  isUpdating: false,
	  isUpdated: false,
	  productList: [],
	  productListIsLoading: false,
	  billboardImagesList: [],
	  billboardImagesIsLoading: false,
	  savingBillboardImages: false,
	  deletingBillboardImage: false
	};
	
	MobileManagement.propTypes = {
	  fetchGreatDealsNewArrivals: _propTypes2.default.func.isRequired,
	  fetchBillboardImages: _propTypes2.default.func.isRequired,
	  isUpdating: _propTypes2.default.bool,
	  isUpdated: _propTypes2.default.bool,
	  productList: _propTypes2.default.array,
	  productListIsLoading: _propTypes2.default.bool,
	  updateGreatDeals: _propTypes2.default.func.isRequired,
	  updateNewArrivals: _propTypes2.default.func.isRequired,
	  billboardImagesList: _propTypes2.default.array,
	  billboardImagesIsLoading: _propTypes2.default.bool,
	  saveBillboardImages: _propTypes2.default.func.isRequired,
	  savingBillboardImages: _propTypes2.default.bool,
	  deleteBillboardImage: _propTypes2.default.func.isRequired,
	  deletingBillboardImage: _propTypes2.default.bool
	};
	
	var _default = MobileManagement;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(createDialogStyle, 'createDialogStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/General/MobileManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(MobileManagement, 'MobileManagement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/General/MobileManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/General/MobileManagement.jsx');
	}();

	;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _CheckboxFormatter = __webpack_require__(148);
	
	var _CheckboxFormatter2 = _interopRequireDefault(_CheckboxFormatter);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MobileManagementTable = function (_Component) {
	  _inherits(MobileManagementTable, _Component);
	
	  function MobileManagementTable(props) {
	    _classCallCheck(this, MobileManagementTable);
	
	    var _this = _possibleConstructorReturn(this, (MobileManagementTable.__proto__ || Object.getPrototypeOf(MobileManagementTable)).call(this, props));
	
	    _this.saveProducts = function () {
	      var _this$props$saveProdu = _this.props.saveProducts,
	          saveGreatDeals = _this$props$saveProdu.saveGreatDeals,
	          saveNewArrivals = _this$props$saveProdu.saveNewArrivals;
	      var editedRows = _this.state.editedRows;
	
	      var greatDeals = [];
	      var nonGreatDeals = [];
	      var newArrivals = [];
	      var nonNewArrivals = [];
	      _lodash2.default.forEach(editedRows, function (row) {
	        if (row.IsGreatDeal) {
	          greatDeals.push(row.Product_id);
	        } else {
	          nonGreatDeals.push(row.Product_id);
	        }
	        if (row.IsNewArrival) {
	          newArrivals.push(row.Product_id);
	        } else {
	          nonNewArrivals.push(row.Product_id);
	        }
	      });
	      saveGreatDeals(greatDeals, true);
	      saveGreatDeals(nonGreatDeals, false);
	      saveNewArrivals(newArrivals, true);
	      saveNewArrivals(nonNewArrivals, false);
	    };
	
	    _this.state = {
	      sortColumn: null,
	      sortDirection: null,
	      filters: null,
	      rows: props.rows,
	      selectedRows: [],
	      editedRows: []
	    };
	    return _this;
	  }
	
	  _createClass(MobileManagementTable, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.rows && nextProps.rows !== this.props.rows) {
	        this.setState({ rows: nextProps.rows });
	      }
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this2 = this;
	
	      if (this.props.rowsIsLoading) {
	        return _react2.default.createElement(_spinner2.default, null);
	      }
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this2.setState(state);
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this2.state.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        _this2.setState({ filters: newFilters });
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        // merge updated row with current row and rerender by setting state
	        _this2.setState({ sortColumn: null, sortDirection: null });
	        var rows = getRows();
	        var editedRows = _this2.state.editedRows.slice(0);
	        Object.assign(rows[e.rowIdx], e.updated);
	        // if the element is already edited, remove the old one.
	        editedRows.forEach(function (element, index) {
	          if (element.Idx === rows[e.rowIdx].Idx) {
	            editedRows.splice(index, 1);
	          }
	        }, _this2);
	        // push the row into the editedRows array
	        editedRows.push(rows[e.rowIdx]);
	        _this2.setState({ rows: rows, editedRows: editedRows });
	      };
	
	      var handleIsEnabledClick = function handleIsEnabledClick(isEnabled) {
	        var rows = getRows();
	        var index = _lodash2.default.findIndex(rows, { Product_id: isEnabled.dependentValues.Product_id });
	        rows[index][isEnabled.column.key] = !rows[index][isEnabled.column.key];
	        var editedRows = [].concat(_toConsumableArray(_this2.state.editedRows));
	        editedRows.map(function (row, idx) {
	          if (row.Product_id === rows[index].Product_id) {
	            editedRows.splice(idx, 1);
	          }
	        });
	        editedRows.push(rows[index]);
	        _this2.setState({ rows: rows, editedRows: editedRows });
	      };
	
	      var columns = [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 250
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 200
	      }, {
	        key: 'IsGreatDeal',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'great_deals' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        formatter: _react2.default.createElement(_CheckboxFormatter2.default, { handleOnClick: handleIsEnabledClick }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'IsNewArrival',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_arrivals' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        formatter: _react2.default.createElement(_CheckboxFormatter2.default, { handleOnClick: handleIsEnabledClick }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactDataGrid2.default, {
	              columns: columns,
	              enableCellSelect: true,
	              minHeight: 620,
	              onAddFilter: handleFilterChange,
	              onGridSort: handleGridSort,
	              onRowUpdated: handleRowUpdated,
	              rowGetter: rowGetter,
	              rowHeight: 45,
	              rowsCount: getSize(),
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true })
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var shouldDisable = this.state.editedRows.length === 0;
	      var isUpdating = this.props.isUpdating;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Panel,
	        { id: 'mobile-management-detail' },
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            null,
	            _react2.default.createElement(_SpinnerButton2.default, {
	              className: 'save-button',
	              bsStyle: 'success',
	              disabled: shouldDisable || isUpdating,
	              onClick: this.saveProducts,
	              loading: isUpdating,
	              icon: 'fa-save',
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	            })
	          ),
	          this.renderTable()
	        )
	      );
	    }
	  }]);
	
	  return MobileManagementTable;
	}(_react.Component);
	
	MobileManagementTable.defaultProps = {
	  rows: []
	  // title: '',
	};
	
	MobileManagementTable.propTypes = {
	  rows: _propTypes2.default.array,
	  // title: PropTypes.string,
	  rowsIsLoading: _propTypes2.default.bool.isRequired,
	  saveProducts: _propTypes2.default.shape({
	    saveGreatDeals: _propTypes2.default.func,
	    saveNewArrivals: _propTypes2.default.func
	  }).isRequired,
	  isUpdating: _propTypes2.default.bool.isRequired
	};
	
	var _default = MobileManagementTable;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(MobileManagementTable, 'MobileManagementTable', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/General/MobileManagementTable.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/General/MobileManagementTable.jsx');
	}();

	;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _moment3 = __webpack_require__(41);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _datePicker = __webpack_require__(27);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _GenericDatePicker = __webpack_require__(48);
	
	var _GenericDatePicker2 = _interopRequireDefault(_GenericDatePicker);
	
	var _cleanDates = __webpack_require__(22);
	
	var _inputField = __webpack_require__(16);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _moment4.default)(_moment2.default);
	
	var GeneralDashboard = function (_Component) {
	  _inherits(GeneralDashboard, _Component);
	
	  function GeneralDashboard() {
	    _classCallCheck(this, GeneralDashboard);
	
	    var _this = _possibleConstructorReturn(this, (GeneralDashboard.__proto__ || Object.getPrototypeOf(GeneralDashboard)).call(this));
	
	    _this.setPoDate = function (e) {
	      _this.setState({ poDateChosen: e }, function () {
	        _this.props.fetchIncomingOrdersByDate((0, _cleanDates.getFromToDates)(_this.state.poDateChosen));
	      });
	    };
	
	    _this.setSoDate = function (e) {
	      _this.setState({ soDateChosen: e }, function () {
	        _this.props.fetchOutgoingOrdersByDate((0, _cleanDates.getFromToDates)(_this.state.soDateChosen));
	      });
	    };
	
	    _this.state = {
	      tableHeight: 540,
	
	      Messages: [],
	
	      POs: {
	        rows: [],
	        allRows: [],
	        setDate: null,
	        selectedRows: null,
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      SOs: {
	        rows: [],
	        allRows: [],
	        setDate: null,
	        selectedRows: null,
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      MSOs: {
	        rows: [],
	        allRows: [],
	        setDate: null,
	        selectedRows: null,
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      poDateChosen: new Date(),
	      soDateChosen: new Date()
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.addNewMessage = _this.addNewMessage.bind(_this);
	    return _this;
	  }
	
	  _createClass(GeneralDashboard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      this.props.fetchDashboardMessages();
	      this.props.fetchIncomingOrdersByDate((0, _cleanDates.getFromToDates)(new Date()));
	      this.props.fetchOutgoingOrdersByDate((0, _cleanDates.getFromToDates)(new Date()));
	      this.props.setField('generalDashboard', 'selectedPODate', new Date());
	      this.props.setField('generalDashboard', 'selectedSODate', new Date());
	    }
	
	    // Once products are ready, reset state.
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.todaysIncomingOrders && nextProps.todaysIncomingOrders !== this.props.todaysIncomingOrders) {
	        var POs = _extends({}, this.state.POs, { rows: nextProps.todaysIncomingOrders });
	        this.setState({ POs: POs });
	      }
	
	      if (nextProps.todaysOutgoingOrders && nextProps.todaysOutgoingOrders !== this.props.todaysOutgoingOrders) {
	        var SOs = _extends({}, this.state.SOs, { rows: [].concat(_toConsumableArray(nextProps.todaysOutgoingOrders.SO)) });
	        var MSOs = _extends({}, this.state.MSOs, { rows: [].concat(_toConsumableArray(nextProps.todaysOutgoingOrders.MSO)) });
	        this.setState({ SOs: SOs, MSOs: MSOs });
	      }
	
	      // if (nextProps.poDateChosen && nextProps.poDateChosen !== this.props.poDateChosen) {
	      //   this.props.fetchIncomingOrdersByDate(getFromToDates(nextProps.poDateChosen));
	      // }
	
	      // if (nextProps.soDateChosen && nextProps.soDateChosen !== this.props.soDateChosen) {
	      //   this.props.fetchOutgoingOrdersByDate(getFromToDates(nextProps.soDateChosen));
	      // }
	
	      if (nextProps.messages && nextProps.messages !== this.props.messages) {
	        var Messages = nextProps.messages;
	        this.setState({ Messages: Messages }, function () {
	          _this2.updateScroll();
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.noButton });
	    }
	  }, {
	    key: 'updateScroll',
	    value: function updateScroll() {
	      var element = document.getElementById('message-box');
	      element.scrollTop = element.scrollHeight;
	    }
	  }, {
	    key: 'addNewMessage',
	    value: function addNewMessage() {
	      var newMessage = {
	        message: this.props.Message
	      };
	      this.props.postDashboardMessage(newMessage);
	    }
	  }, {
	    key: 'renderPurchaseOrderTable',
	
	
	    // Render the table head and bind it to the datatable plugin to show a sortable table.
	    value: function renderPurchaseOrderTable() {
	      var _this3 = this;
	
	      if (this.props.todaysIncomingOrdersIsLoading && !this.props.todaysIncomingOrdersError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.todaysIncomingOrdersError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.todaysIncomingOrdersError)
	          )
	        ); // Parameters of the react-data-grid
	      }
	
	      var getRows = function getRows() {
	        var Rows = _reactDataGridAddons.Data.Selectors.getRows(_this3.state.POs);
	        return Rows;
	      };
	
	      var getSize = function getSize() {
	        var RowSize = getRows().length;
	        return RowSize;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var POs = _extends({}, _this3.state.POs, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this3.setState({ POs: POs });
	      };
	
	      // Handle the row select function
	
	      var onRowSelect = function onRowSelect(rows) {
	        var POs = _extends({}, _this3.state.POs, { selectedRows: rows });
	        _this3.setState({ POs: POs });
	      };
	
	      // Custom Formatter component
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var date = new Date(this.props.value);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      // Column difinition
	
	      var columns = [{
	        key: 'PONum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'Vendor_Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor' }),
	        resizable: true,
	        sortable: true,
	        width: 200
	      }, {
	        key: 'FinalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'OrderDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: DateFormatter
	      }, {
	        key: 'ETADate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ETA' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: DateFormatter
	      }, {
	        key: 'Purchaser_User_Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchaser' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'PurchaseStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 110
	      }];
	
	      return (
	        // React Table Purchase Orders
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { id: 'purchase-orders-arriving-table' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'PurchaseOrder_id',
	                onGridSort: handleGridSort,
	                columns: columns,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                minHeight: 305,
	                rowHeight: 25,
	                onRowSelect: onRowSelect
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderSalesOrderTable',
	    value: function renderSalesOrderTable() {
	      var _this4 = this;
	
	      if (this.props.todaysOutgoingOrdersIsLoading && !this.props.todaysOutgoingOrdersError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.todaysOutgoingOrdersError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.todaysOutgoingOrdersError)
	          )
	        ); // Parameters of the react-data-grid
	      }
	
	      var getRows = function getRows() {
	        var Rows = _reactDataGridAddons.Data.Selectors.getRows(_this4.state.SOs);
	        return Rows;
	      };
	
	      var getSize = function getSize() {
	        var RowSize = getRows().length;
	        return RowSize;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var SOs = _extends({}, _this4.state.SOs, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this4.setState({ SOs: SOs });
	      };
	
	      // Custom Formatter component
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var date = new Date(this.props.value);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      // Column difinition
	
	      var columns = [{
	        key: 'SONum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_no' }),
	        resizable: true,
	        sortable: true,
	        width: 120
	      }, {
	        key: 'Deliver_CustomerName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: 'FinalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'OrderDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: DateFormatter
	      }, {
	        key: 'DispatchDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: DateFormatter
	      }, {
	        key: 'Sales_User_Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: 'SaleStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 110
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { id: 'sales-orders-shipping-table' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'SalesOrder_id',
	              onGridSort: handleGridSort,
	              columns: columns,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: 305,
	              rowHeight: 25
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderMobileSalesOrderTable',
	    value: function renderMobileSalesOrderTable() {
	      var _this5 = this;
	
	      if (this.props.todaysOutgoingOrdersIsLoading && !this.props.todaysOutgoingOrdersError || this.props.todaysOutgoingOrdersIsLoading && !this.props.todaysOutgoingOrdersError) return;else if (this.props.todaysOutgoingOrdersError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.todaysOutgoingOrdersError)
	          )
	        ); // Parameters of the react-data-grid
	      }
	
	      var getRows = function getRows() {
	        var Rows = _reactDataGridAddons.Data.Selectors.getRows(_this5.state.MSOs);
	        return Rows;
	      };
	
	      var getSize = function getSize() {
	        var RowSize = getRows().length;
	        return RowSize;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var MSOs = _extends({}, _this5.state.MSOs, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this5.setState({ MSOs: MSOs });
	      };
	
	      // Custom Formatter component
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var date = new Date(this.props.value);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      // Column difinition
	
	      var columns = [{
	        key: 'SONum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_no' }),
	        resizable: true,
	        sortable: true,
	        width: 120
	      }, {
	        key: 'Deliver_CustomerName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: 'FinalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'OrderDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: DateFormatter
	      }, {
	        key: 'DispatchDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: DateFormatter
	      }, {
	        key: 'Sales_User_Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: 'SaleStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 110
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'h4',
	            { id: 'mso-header' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mso_scheduled_shipping' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { id: 'mobile-sales-orders-shipping-table' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'SalesOrder_id',
	              onGridSort: handleGridSort,
	              columns: columns,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: 305,
	              rowHeight: 25
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderMessages',
	    value: function renderMessages() {
	      if (this.props.messagesIsLoading) {
	        return _react2.default.createElement(_spinner2.default, null);
	      }
	
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 12 },
	        this.state.Messages.map(function (message) {
	          return _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'user-message' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 11 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'message-name' },
	                      message.Name
	                    ),
	                    ':'
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 10 },
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'message-content' },
	                        message.Message
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 1, className: 'message-timestamp' },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 12 },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'pull-right' },
	                    (0, _moment2.default)(message.Date).format('h:mm A')
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 12 },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'pull-right' },
	                    (0, _moment2.default)(message.Date).format('MM/DD/YYYY')
	                  )
	                )
	              )
	            )
	          );
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var handleSubmit = this.props.handleSubmit;
	
	      var purchaseOrderTablePanelHeader = _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 5 },
	          _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_scheduled_arrival' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 7, className: 'text-right' },
	          _react2.default.createElement(
	            'h5',
	            { className: 'filter-title' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'eta_date' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'colon' },
	              ':'
	            )
	          ),
	          (0, _GenericDatePicker2.default)({
	            setDate: this.setPoDate,
	            selectedDate: this.state.poDateChosen
	          })
	        )
	      );
	      var salesOrderTablePanelHeader = _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 5 },
	          _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_scheduled_shipping' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 7, className: 'text-right' },
	          _react2.default.createElement(
	            'h5',
	            { className: 'filter-title' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch_date' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'colon' },
	              ':'
	            )
	          ),
	          (0, _GenericDatePicker2.default)({
	            setDate: this.setSoDate,
	            selectedDate: this.state.soDateChosen
	          })
	        )
	      );
	      var mobileSalesOrderTablePanelHeader = _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 8 },
	          _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mso_scheduled_shipping' })
	          )
	        )
	      );
	      var messageBoardHeader = _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'h4',
	            { style: { display: 'inline' } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'message_board' })
	          ),
	          this.props.Message && this.props.Message.length > 499 && _react2.default.createElement(
	            'div',
	            { id: 'limit-warning' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'character_limit_reached' }),
	            ' (500)'
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'primary',
	              id: 'refresh-button',
	              onClick: this.props.fetchDashboardMessages
	            },
	            _react2.default.createElement('em', { className: 'fa fa-refresh' })
	          )
	        )
	      );
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dashboard' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'general-dashboard', fluid: 'true' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'form',
	              { onSubmit: handleSubmit },
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 6 },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Panel,
	                      { header: purchaseOrderTablePanelHeader, className: 'table-collapse-fix-revision' },
	                      this.renderPurchaseOrderTable()
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Panel,
	                      { header: messageBoardHeader, id: 'message-panel' },
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { id: 'message-box' },
	                        this.renderMessages()
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 11 },
	                          _react2.default.createElement(_reduxForm.Field, {
	                            name: 'MessageField',
	                            component: _inputField.InputField,
	                            maxLength: '500',
	                            onKeyPress: function onKeyPress(event) {
	                              if (event.charCode === 13) {
	                                if (_this6.props.Message.length > 0) {
	                                  _this6.addNewMessage();
	                                }
	                              }
	                            }
	                          })
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 1 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                              bsStyle: 'primary',
	                              className: 'pull-right',
	                              onClick: this.addNewMessage
	                            },
	                            _react2.default.createElement('em', { className: 'fa fa-paper-plane-o' })
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 6 },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Panel,
	                      { header: salesOrderTablePanelHeader, className: 'sales-panel' },
	                      this.renderSalesOrderTable(),
	                      this.renderMobileSalesOrderTable()
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return GeneralDashboard;
	}(_react.Component);
	
	GeneralDashboard.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = GeneralDashboard;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(GeneralDashboard, 'GeneralDashboard', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/General/generalDashboardRevision.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/General/generalDashboardRevision.jsx');
	}();

	;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Marker = exports.camelize = exports.Map = exports.Container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _server = __webpack_require__(820);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _constants = __webpack_require__(11);
	
	var _keys = __webpack_require__(118);
	
	var _googleApiComponent = __webpack_require__(346);
	
	var _googleApiComponent2 = _interopRequireDefault(_googleApiComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = exports.Container = function (_Component) {
	    _inherits(Container, _Component);
	
	    function Container(props) {
	        _classCallCheck(this, Container);
	
	        var _this = _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).call(this, props));
	
	        _this.state = {
	            showingInfoWindow: false,
	            activeMarker: {},
	            selectedPlace: {}
	        };
	        _this.onMapClicked = _this.onMapClicked.bind(_this);
	        _this.onMarkerClick = _this.onMarkerClick.bind(_this);
	        _this.onInfoWindowClose = _this.onInfoWindowClose.bind(_this);
	        return _this;
	    }
	
	    _createClass(Container, [{
	        key: 'onMarkerClick',
	        value: function onMarkerClick(props, marker, e) {
	            this.setState({
	                selectedPlace: props,
	                activeMarker: marker,
	                showingInfoWindow: true
	            });
	        }
	    }, {
	        key: 'onInfoWindowClose',
	        value: function onInfoWindowClose() {
	            this.setState({
	                showingInfoWindow: false,
	                activeMarker: null
	            });
	        }
	    }, {
	        key: 'onMapClicked',
	        value: function onMapClicked(props) {
	            if (this.state.showingInfoWindow) {
	                this.setState({
	                    showingInfoWindow: false,
	                    activeMarker: null
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                currentWarehouse = _props.currentWarehouse,
	                responsive = _props.responsive;
	
	            // console.log(this.state.selectedPlace);
	            // console.log(this.state.activeMarker);
	
	            if (!this.props.loaded) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    'Loading...'
	                );
	            }
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    Map,
	                    { google: this.props.google, currentWarehouse: currentWarehouse.coordinate, responsive: responsive },
	                    _react2.default.createElement(Marker, {
	                        position: currentWarehouse.coordinate,
	                        onClick: this.onMarkerClick,
	                        name: currentWarehouse.WarehouseTitle,
	                        contact: currentWarehouse.Contact,
	                        address: currentWarehouse.Address
	                    })
	                )
	            );
	        }
	    }]);
	
	    return Container;
	}(_react.Component);
	
	// <InfoWindow
	//     marker={this.state.activeMarker}
	//     visible={this.state.showingInfoWindow}
	//     onClose={this.onInfoWindowClose}>
	//     <div>
	//         {this.state.selectedPlace.name &&
	//             <div>
	//                 <h3>{this.state.selectedPlace.name}</h3>
	//                 <ul>
	//                     <li>Contact: {this.state.selectedPlace.contact || "-"}</li>
	//                     <li>Address: {this.state.selectedPlace.address || "-"}</li>
	//                 </ul>
	//             </div>}
	//         {!this.state.selectedPlace.name && <h3>Current Location</h3>}
	//     </div>
	// </InfoWindow>
	
	var Map = exports.Map = function (_Component2) {
	    _inherits(Map, _Component2);
	
	    function Map(props) {
	        _classCallCheck(this, Map);
	
	        var _this2 = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));
	
	        var _this2$props$initialC = _this2.props.initialCenter,
	            lat = _this2$props$initialC.lat,
	            lng = _this2$props$initialC.lng;
	
	        _this2.state = {
	            // define the height of the map
	            mapHeight: window.innerHeight - _constants.UI_HEIGHT.noButton,
	
	            // listen to the current location
	            currentLocation: {
	                lat: lat,
	                lng: lng
	            }
	
	        };
	        _this2.handleResize = _this2.handleResize.bind(_this2);
	        return _this2;
	    }
	
	    _createClass(Map, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this3 = this;
	
	            window.addEventListener('resize', this.handleResize);
	
	            if (this.props.centerAroundCurrentLocation) {
	                if (navigator && navigator.geolocation) {
	                    navigator.geolocation.getCurrentPosition(function (pos) {
	                        var coords = pos.coords;
	                        _this3.setState({
	                            currentLocation: {
	                                lat: coords.latitude,
	                                lng: coords.longitude
	                            }
	                        });
	                    });
	                }
	            }
	
	            // Load the google map when component mount.
	            this.loadMap();
	        }
	
	        // Load the map when google props changed.
	
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (prevProps.google !== this.props.google) {
	                this.loadMap();
	            }
	
	            // Move the map's center to current location
	            if (prevState.currentLocation !== this.state.currentLocation) {
	                this.moveMap();
	            }
	
	            if (prevProps.currentWarehouse !== this.props.currentWarehouse && this.props.currentWarehouse) {
	                this.setState({ currentLocation: this.props.currentWarehouse });
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // resize the map to fit resolution
	
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ mapHeight: window.innerHeight - _constants.UI_HEIGHT.noButton });
	        }
	    }, {
	        key: 'loadMap',
	        value: function loadMap() {
	            if (this.props && this.props.google) {
	                // google is available
	                var google = this.props.google;
	
	                var maps = google.maps;
	
	                var mapRef = this.refs.map;
	                var node = _reactDom2.default.findDOMNode(mapRef);
	
	                var zoom = this.props.zoom;
	                var _state$currentLocatio = this.state.currentLocation,
	                    lat = _state$currentLocatio.lat,
	                    lng = _state$currentLocatio.lng;
	
	                var center = new maps.LatLng(lat, lng);
	                var mapConfig = Object.assign({}, {
	                    center: center,
	                    zoom: zoom
	                });
	                this.map = new maps.Map(node, mapConfig);
	            }
	        }
	
	        // use panTo to rerender the map
	
	    }, {
	        key: 'moveMap',
	        value: function moveMap() {
	            var map = this.map;
	            var curr = this.state.currentLocation;
	
	            var google = this.props.google;
	            var maps = google.maps;
	
	            if (map) {
	                var center = new maps.LatLng(curr.lat, curr.lng);
	                map.panTo(center);
	            }
	        }
	    }, {
	        key: 'renderChildren',
	        value: function renderChildren() {
	            var _this4 = this;
	
	            var children = this.props.children;
	            // If no children, return a null
	
	            if (!children) return;
	
	            // Make a clone for each child with given props
	            return _react2.default.Children.map(children, function (c) {
	                return _react2.default.cloneElement(c, {
	                    map: _this4.map,
	                    google: _this4.props.google,
	                    mapCenter: _this4.state.currentLocation
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var height = this.props.responsive ? this.state.mapHeight : "100px";
	            var style = {
	                width: '100%',
	                height: height
	            };
	            return _react2.default.createElement(
	                'div',
	                { ref: 'map', style: style },
	                'Loading map...',
	                this.renderChildren()
	            );
	        }
	    }]);
	
	    return Map;
	}(_react.Component);
	
	// Map props definition
	
	
	Map.propTypes = {
	    google: _react2.default.PropTypes.object,
	    zoom: _react2.default.PropTypes.number,
	    initialCenter: _react2.default.PropTypes.object,
	    centerAroundCurrentLocation: _react2.default.PropTypes.bool
	
	    // Map default values
	};Map.defaultProps = {
	    zoom: 13,
	    // San Francisco, by default
	    initialCenter: {
	        lat: 33.992233,
	        lng: -117.9142382
	    },
	    centerAroundCurrentLocation: true
	};
	
	var wrappedPromise = function wrappedPromise() {
	    var wrappedPromise = {},
	        promise = new Promise(function (resolve, reject) {
	        wrappedPromise.resolve = resolve;
	        wrappedPromise.reject = reject;
	    });
	    wrappedPromise.then = promise.then.bind(promise);
	    wrappedPromise.catch = promise.catch.bind(promise);
	    wrappedPromise.promise = promise;
	
	    return wrappedPromise;
	};
	
	var camelize = exports.camelize = function camelize(str) {
	    return str.split(' ').map(function (word) {
	        return word.charAt(0).toUpperCase() + word.slice(1);
	    }).join('');
	};
	
	var evtNames = ['click', 'mouseover', 'recenter'];
	
	var Marker = exports.Marker = function (_Component3) {
	    _inherits(Marker, _Component3);
	
	    function Marker() {
	        _classCallCheck(this, Marker);
	
	        return _possibleConstructorReturn(this, (Marker.__proto__ || Object.getPrototypeOf(Marker)).apply(this, arguments));
	    }
	
	    _createClass(Marker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.markerPromise = wrappedPromise();
	            this.renderMarker();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.map !== prevProps.map || this.props.position !== prevProps.position) {
	                this.renderMarker();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.marker) {
	                this.marker.setMap(null);
	            }
	        }
	    }, {
	        key: 'getMarker',
	        value: function getMarker() {
	            return this.markerPromise;
	        }
	    }, {
	        key: 'handleEvent',
	        value: function handleEvent(evt) {
	            var _this6 = this;
	
	            return function (e) {
	                var evtName = 'on' + camelize(evt);
	                if (_this6.props[evtName]) {
	                    _this6.props[evtName](_this6.props, _this6.marker, e);
	                }
	            };
	        }
	    }, {
	        key: 'renderMarker',
	        value: function renderMarker() {
	            var _this7 = this;
	
	            var _props2 = this.props,
	                map = _props2.map,
	                google = _props2.google,
	                position = _props2.position,
	                mapCenter = _props2.mapCenter;
	
	
	            if (!google) {
	                return null;
	            }
	
	            var pos = position || mapCenter;
	            position = new google.maps.LatLng(pos.lat, pos.lng);
	
	            var pref = {
	                map: map,
	                position: position
	            };
	
	            this.marker = new google.maps.Marker(pref);
	
	            evtNames.forEach(function (e) {
	                _this7.marker.addListener(e, _this7.handleEvent(e));
	            });
	
	            this.markerPromise.resolve(this.marker);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return Marker;
	}(_react.Component);
	
	Marker.propTypes = {
	    position: _react2.default.PropTypes.object,
	    map: _react2.default.PropTypes.object
	};
	
	evtNames.forEach(function (e) {
	    return Marker.propTypes[e] = _react2.default.PropTypes.func;
	});
	
	// InfoWndow Component
	
	var InfoWindow = function (_React$Component) {
	    _inherits(InfoWindow, _React$Component);
	
	    function InfoWindow(props) {
	        _classCallCheck(this, InfoWindow);
	
	        var _this8 = _possibleConstructorReturn(this, (InfoWindow.__proto__ || Object.getPrototypeOf(InfoWindow)).call(this, props));
	
	        _this8.updateContent = _this8.updateContent.bind(_this8);
	        return _this8;
	    }
	
	    _createClass(InfoWindow, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            var _props3 = this.props,
	                google = _props3.google,
	                map = _props3.map;
	
	
	            if (!google || !map) {
	                return;
	            }
	
	            if (this.props.map !== prevProps.map) {
	                this.renderInfoWindow();
	            }
	            if (this.props.children !== prevProps.children) {
	                this.updateContent();
	            }
	            if (this.props.visible !== prevProps.visible || this.props.marker !== prevProps.marker) {
	                this.props.visible ? this.openWindow() : this.closeWindow();
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'openWindow',
	        value: function openWindow() {
	            console.log(this);
	            this.infowindow.open(this.props.map, this.props.marker);
	        }
	    }, {
	        key: 'closeWindow',
	        value: function closeWindow() {
	            console.log(this);
	            this.infowindow.close();
	        }
	    }, {
	        key: 'updateContent',
	        value: function updateContent() {
	            var content = this.renderChildren();
	            this.infowindow.setContent(content);
	            this.infowindow.open(this.props.map, this.props.marker);
	        }
	    }, {
	        key: 'renderInfoWindow',
	        value: function renderInfoWindow() {
	            console.log("Info", this.props);
	            var _props4 = this.props,
	                map = _props4.map,
	                google = _props4.google,
	                mapCenter = _props4.mapCenter;
	
	
	            if (!google || !google.maps) {
	                return;
	            }
	
	            var iw = this.infowindow = new google.maps.InfoWindow({
	                content: ''
	            });
	        }
	    }, {
	        key: 'renderChildren',
	        value: function renderChildren() {
	            console.log("children", this.props);
	            var children = this.props.children;
	
	            return _server2.default.renderToString(children);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return InfoWindow;
	}(_react2.default.Component);
	
	InfoWindow.propTypes = {
	    children: _react2.default.PropTypes.element.isRequired,
	    map: _react2.default.PropTypes.object,
	    marker: _react2.default.PropTypes.object,
	    visible: _react2.default.PropTypes.bool
	};
	
	InfoWindow.defaultProps = {
	    visible: false
	};
	
	var _default = (0, _googleApiComponent2.default)({
	    apiKey: _keys.__GAPI_KEY__
	})(Container);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(Container, 'Container', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/GoogleMap/googleMapContainer.jsx');
	
	    __REACT_HOT_LOADER__.register(Map, 'Map', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/GoogleMap/googleMapContainer.jsx');
	
	    __REACT_HOT_LOADER__.register(camelize, 'camelize', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/GoogleMap/googleMapContainer.jsx');
	
	    __REACT_HOT_LOADER__.register(Marker, 'Marker', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/GoogleMap/googleMapContainer.jsx');
	
	    __REACT_HOT_LOADER__.register(wrappedPromise, 'wrappedPromise', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/GoogleMap/googleMapContainer.jsx');
	
	    __REACT_HOT_LOADER__.register(evtNames, 'evtNames', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/GoogleMap/googleMapContainer.jsx');
	
	    __REACT_HOT_LOADER__.register(InfoWindow, 'InfoWindow', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/GoogleMap/googleMapContainer.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/GoogleMap/googleMapContainer.jsx');
	}();

	;

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// Auto generate Google Api Url
	
	var GoogleApi = exports.GoogleApi = function GoogleApi(opts) {
	    opts = opts || {};
	
	    var apiKey = opts.apiKey;
	    var libraries = opts.libraries || [];
	    var client = opts.client;
	    var URL = 'https://maps.googleapis.com/maps/api/js';
	
	    var googleVersion = '3.22';
	    var script = null;
	    var google = window.google = null;
	    var loading = false;
	    var channel = null;
	    var language = null;
	    var region = null;
	
	    var onLoadEvents = [];
	
	    var url = function url() {
	        var url = URL;
	        var params = {
	            key: apiKey,
	            callback: 'CALLBACK_NAME',
	            libraries: libraries.join(','),
	            client: client,
	            v: googleVersion,
	            channel: channel,
	            language: language,
	            region: region
	        };
	
	        var paramStr = Object.keys(params).filter(function (k) {
	            return !!params[k];
	        }).map(function (k) {
	            return k + '=' + params[k];
	        }).join('&');
	
	        return url + '?' + paramStr;
	    };
	
	    return url();
	};
	
	var _default = GoogleApi;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(GoogleApi, 'GoogleApi', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/GoogleMap/utils/googleApi.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/GoogleMap/utils/googleApi.jsx');
	}();

	;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.wrapper = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _scriptCache = __webpack_require__(347);
	
	var _scriptCache2 = _interopRequireDefault(_scriptCache);
	
	var _googleApi = __webpack_require__(345);
	
	var _googleApi2 = _interopRequireDefault(_googleApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapConfig = {};
	var defaultCreateCache = function defaultCreateCache(options) {
	    options = options || {};
	    var apiKey = options.apiKey;
	    var libraries = options.libraries || ['places'];
	
	    return (0, _scriptCache2.default)({
	        google: (0, _googleApi2.default)({ apiKey: apiKey, libraries: libraries })
	    });
	};
	
	var wrapper = exports.wrapper = function wrapper(options) {
	    return function (WrappedComponent) {
	        var apiKey = options.apiKey;
	        var libraries = options.libraries || ['places'];
	        var createCache = options.createCache || defaultCreateCache;
	
	        var Wrapper = function (_React$Component) {
	            _inherits(Wrapper, _React$Component);
	
	            function Wrapper(props, context) {
	                _classCallCheck(this, Wrapper);
	
	                var _this = _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).call(this, props, context));
	
	                _this.scriptCache = createCache(options);
	                _this.scriptCache.google.onLoad(_this.onLoad.bind(_this));
	
	                _this.state = {
	                    loaded: false,
	                    map: null,
	                    google: null
	                };
	                return _this;
	            }
	
	            _createClass(Wrapper, [{
	                key: 'onLoad',
	                value: function onLoad(err, tag) {
	                    // TODO: finde better way to recompile the scriptCache
	
	                    if (!window.google) {
	                        window.location.reload();
	                    }
	                    this._gapi = window.google;
	                    this.setState({ loaded: true, google: this._gapi });
	                }
	            }, {
	                key: 'render',
	                value: function render() {
	                    var props = Object.assign({}, this.props, {
	                        loaded: this.state.loaded,
	                        google: window.google
	                    });
	
	                    return _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(WrappedComponent, props)
	                    );
	                }
	            }]);
	
	            return Wrapper;
	        }(_react2.default.Component);
	
	        Wrapper.contextTypes = {
	            refresh: _react2.default.PropTypes.func
	        };
	
	
	        return Wrapper;
	    };
	};
	
	var _default = wrapper;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(wrapper, 'wrapper', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/GoogleMap/utils/googleApiComponent.jsx');
	
	    __REACT_HOT_LOADER__.register(defaultMapConfig, 'defaultMapConfig', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/GoogleMap/utils/googleApiComponent.jsx');
	
	    __REACT_HOT_LOADER__.register(defaultCreateCache, 'defaultCreateCache', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/GoogleMap/utils/googleApiComponent.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/GoogleMap/utils/googleApiComponent.jsx');
	}();

	;

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// Generate a script tag to be used in HTML
	
	var counter = 0;
	var scriptMap = window._scriptMap || new Map();
	
	var ScriptCache = exports.ScriptCache = function (global) {
	    global._scriptMap = global._scriptMap || scriptMap;
	    return function ScriptCache(scripts) {
	        var Cache = {};
	
	        Cache._onLoad = function (key) {
	            return function (cb) {
	                var stored = scriptMap.get(key);
	                if (stored) {
	                    stored.promise.then(function () {
	                        stored.error ? cb(stored.error) : cb(null, stored);
	                        return stored;
	                    });
	                } else {
	                    // TODO:
	                }
	            };
	        };
	
	        Cache._scriptTag = function (key, src) {
	            if (!scriptMap.has(key)) {
	                var tag = document.createElement('script');
	                var promise = new Promise(function (resolve, reject) {
	                    var resolved = false,
	                        errored = false,
	                        body = document.getElementsByTagName('body')[0];
	
	                    tag.type = 'text/javascript';
	                    tag.async = false; // Load in order
	
	                    var cbName = 'loaderCB' + counter++ + Date.now();
	                    var cb = void 0;
	
	                    var handleResult = function handleResult(state) {
	                        return function (evt) {
	                            var stored = scriptMap.get(key);
	                            if (state === 'loaded') {
	                                stored.resolved = true;
	                                resolve(src);
	                                // stored.handlers.forEach(h => h.call(null, stored))
	                                // stored.handlers = []
	                            } else if (state === 'error') {
	                                stored.errored = true;
	                                // stored.handlers.forEach(h => h.call(null, stored))
	                                // stored.handlers = [];
	                                reject(evt);
	                            }
	                            stored.loaded = true;
	
	                            cleanup();
	                        };
	                    };
	
	                    var cleanup = function cleanup() {
	                        if (global[cbName] && typeof global[cbName] === 'function') {
	                            global[cbName] = null;
	                            delete global[cbName];
	                        }
	                    };
	
	                    tag.onload = handleResult('loaded');
	                    tag.onerror = handleResult('error');
	                    tag.onreadystatechange = function () {
	                        handleResult(tag.readyState);
	                    };
	
	                    // Pick off callback, if there is one
	                    if (src.match(/callback=CALLBACK_NAME/)) {
	                        src = src.replace(/(callback=)[^\&]+/, '$1' + cbName);
	                        cb = window[cbName] = tag.onload;
	                    } else {
	                        tag.addEventListener('load', tag.onload);
	                    }
	                    tag.addEventListener('error', tag.onerror);
	
	                    tag.src = src;
	                    body.appendChild(tag);
	
	                    return tag;
	                });
	                var initialState = {
	                    loaded: false,
	                    error: false,
	                    promise: promise,
	                    tag: tag
	                };
	                scriptMap.set(key, initialState);
	            }
	            return scriptMap.get(key);
	        };
	
	        // let scriptTags = document.querySelectorAll('script')
	        //
	        // NodeList.prototype.filter = Array.prototype.filter;
	        // NodeList.prototype.map = Array.prototype.map;
	        // const initialScripts = scriptTags
	        //   .filter(s => !!s.src)
	        //   .map(s => s.src.split('?')[0])
	        //   .reduce((memo, script) => {
	        //     memo[script] = script;
	        //     return memo;
	        //   }, {});
	
	        Object.keys(scripts).forEach(function (key) {
	            var script = scripts[key];
	
	            var tag = window._scriptMap.has(key) ? window._scriptMap.get(key).tag : Cache._scriptTag(key, script);
	
	            Cache[key] = {
	                tag: tag,
	                onLoad: Cache._onLoad(key)
	            };
	        });
	
	        return Cache;
	    };
	}(window);
	
	var _default = ScriptCache;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(ScriptCache, 'ScriptCache', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/GoogleMap/utils/scriptCache.jsx');
	
	    __REACT_HOT_LOADER__.register(counter, 'counter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/GoogleMap/utils/scriptCache.jsx');
	
	    __REACT_HOT_LOADER__.register(scriptMap, 'scriptMap', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/GoogleMap/utils/scriptCache.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/GoogleMap/utils/scriptCache.jsx');
	}();

	;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdjustInventoryForm = function (_Component) {
	  _inherits(AdjustInventoryForm, _Component);
	
	  function AdjustInventoryForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AdjustInventoryForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdjustInventoryForm.__proto__ || Object.getPrototypeOf(AdjustInventoryForm)).call.apply(_ref, [this].concat(args))), _this), _this.handleFormSubmit = function (formProps) {
	      var props = _extends({}, formProps, { ReasonDesc: formProps.ReasonDesc });
	      if (_this.props.reason) {
	        var id = _this.props.reason.id;
	        _this.props.editReason(props, id);
	      } else {
	        _this.props.createReason(props);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AdjustInventoryForm, [{
	    key: 'renderForm',
	    value: function renderForm() {
	      var _props = this.props,
	          detailError = _props.detailError,
	          detailIsLoading = _props.detailIsLoading;
	
	      if (detailIsLoading && !detailError) return _react2.default.createElement(_spinner2.default, { className: 'marginTopStyle' });else if (detailError) return _react2.default.createElement(
	        'div',
	        { className: 'alert alert-danger' },
	        JSON.stringify(this.props.detailError)
	      );
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(_reactBootstrap.Col, { sm: 1 }),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement('em', { className: 'fa fa-building-o marginRightStyle' }),
	                '| ',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reason' }),
	                ' (*) '
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 12 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'ReasonDesc', component: _inputField2.default, placeholder: 'Reason' })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          handleSubmit = _props2.handleSubmit,
	          submitting = _props2.submitting,
	          pristine = _props2.pristine,
	          valid = _props2.valid,
	          closeG = _props2.closeG;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'form',
	          { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-right' },
	            this.props.isCreating || this.props.isEditing && _react2.default.createElement(_spinner2.default, null),
	            _react2.default.createElement(
	              'button',
	              { action: 'submit', className: 'btn btn-primary buttonStyle', disabled: submitting || pristine || !valid },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-danger buttonStyle', onClick: function onClick(event) {
	                  event.preventDefault();closeG();
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	            )
	          ),
	          this.renderForm()
	        )
	      );
	    }
	  }]);
	
	  return AdjustInventoryForm;
	}(_react.Component);
	
	var _default = (0, _reactRouter.withRouter)(AdjustInventoryForm);
	
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(AdjustInventoryForm, 'AdjustInventoryForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/adjustInventoryForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/adjustInventoryForm.jsx');
	}();

	;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _adjustInventoryForm = __webpack_require__(569);
	
	var _adjustInventoryForm2 = _interopRequireDefault(_adjustInventoryForm);
	
	var _adjustmentLog = __webpack_require__(571);
	
	var _adjustmentLog2 = _interopRequireDefault(_adjustmentLog);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdjustmentInventory = function (_Component) {
	  _inherits(AdjustmentInventory, _Component);
	
	  function AdjustmentInventory() {
	    _classCallCheck(this, AdjustmentInventory);
	
	    var _this = _possibleConstructorReturn(this, (AdjustmentInventory.__proto__ || Object.getPrototypeOf(AdjustmentInventory)).call(this));
	
	    _this.componentWillMount = function () {
	      _this.props.fetchReasons().then(function () {
	        return _this.setState({ rows: _this.props.reasons });
	      });
	    };
	
	    _this.componentDidUpdate = function (prevProps) {
	      if (_this.props.deleted && _this.props.deleted !== prevProps.deleted) {
	        _this.props.fetchReasons().then(function () {
	          return _this.setState({ rows: _this.props.reasons });
	        });
	      }
	
	      if (_this.props.edited && _this.props.edited !== prevProps.edited) {
	        _this.closeEdit();
	        _this.props.fetchReasons().then(function () {
	          return _this.setState({ rows: _this.props.reasons });
	        });
	      }
	
	      if (_this.props.created && _this.props.created !== prevProps.created) {
	        _this.closeCreate();
	        _this.props.fetchReasons().then(function () {
	          return _this.setState({ rows: _this.props.reasons });
	        });
	      }
	    };
	
	    _this.closeCreate = function () {
	      _this.setState({ creating: false });
	    };
	
	    _this.openCreate = function () {
	      _this.setState({ creating: true });
	    };
	
	    _this.closeEdit = function () {
	      _this.setState({ editing: false });
	    };
	
	    _this.openEdit = function () {
	      _this.setState({ editing: true });
	    };
	
	    _this.closeDelete = function () {
	      _this.setState({ deleting: false });
	    };
	
	    _this.openDelete = function () {
	      _this.setState({ deleting: true });
	    };
	
	    _this.deleteReason = function (e) {
	      e.preventDefault();
	      var id = _this.state.selectedRows[0].id;
	      _this.props.deleteReason(id);
	      _this.closeDelete();
	    };
	
	    _this.editReason = function (e) {
	      e.preventDefault();
	      var selectedRows = _this.state.selectedRows;
	
	      _this.props.resetCurrentReason();
	      var currentReason = selectedRows[0];
	      _this.props.selectReason(currentReason);
	      _this.openEdit();
	    };
	
	    _this.createReason = function (e) {
	      e.preventDefault();
	      _this.props.resetCurrentReason();
	      _this.openCreate();
	    };
	
	    _this.renderTable = function () {
	      if (_this.props.isLoading && !_this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (_this.props.error) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          _this.props.error
	        )
	      );
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this.state);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return Object.assign({ Idx: rowIdx }, rows[rowIdx]);
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this.state.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        _this.setState({ filters: newFilters });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var selectedRows = [newRows[rows[0].rowIdx]];
	        var zoneId = rows[0].row.WarehouseZone_id;
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        _this.setState({ selectedRows: selectedRows });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var rowIndexes = rows.map(function (r) {
	          return r.rowIdx;
	        });
	        var newRows = [].concat(_toConsumableArray(_this.state.rows));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        _this.setState({ rows: newRows, selectedRows: [] });
	      };
	
	      var columns = [{
	        key: 'ReasonDesc',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reason' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 450
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '99%' }, id: 'ProductConvert-dataGrid2' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowkey: 'id',
	              enableCellSelect: true,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              columns: columns,
	              onAddFilter: handleFilterChange,
	              headerRowHeight: 60,
	              rowHeight: 45,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: 570,
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              }
	            })
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      stuff: null,
	      rows: [],
	      selectedRows: [],
	      enabledRow: null,
	      newRows: [],
	      filters: {},
	      save: false,
	      saveOpen: false,
	      creating: false,
	      deleting: false,
	      editing: false
	    };
	    return _this;
	  }
	
	  _createClass(AdjustmentInventory, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_management' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_adjustment' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { sm: 12 },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { style: { marginTop: 30 }, header: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reason_management' }), id: 'category2-detail' },
	              _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'success',
	                    type: 'button',
	                    onClick: function onClick(e) {
	                      return _this2.createReason(e);
	                    }
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'warning',
	                    type: 'button',
	                    onClick: function onClick(e) {
	                      return _this2.editReason(e);
	                    }
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'danger',
	                    type: 'button',
	                    onClick: this.openDelete
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-trash-o' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                )
	              ),
	              this.renderTable()
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 8 },
	            _react2.default.createElement(_adjustmentLog2.default, null)
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            onCloseClicked: function onCloseClicked() {
	              return _this2.closeCreate();
	            },
	            title: 'Create Reason',
	            isVisible: this.state.creating
	          },
	          _react2.default.createElement(_adjustInventoryForm2.default, {
	            closeG: this.closeCreate
	          })
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            onCloseClicked: function onCloseClicked() {
	              return _this2.closeEdit();
	            },
	            title: 'Edit Reason',
	            isVisible: this.state.editing
	          },
	          _react2.default.createElement(_adjustInventoryForm2.default, {
	            closeG: this.closeEdit
	          })
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            onCloseClicked: function onCloseClicked() {
	              return _this2.closeDelete();
	            },
	            title: 'Delete Reason?',
	            isVisible: this.state.deleting
	          },
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'centerStyle' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	            )
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'text-center' },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { onClick: function onClick(e) {
	                  return _this2.deleteReason(e);
	                }, className: 'text-center', bsStyle: 'primary', type: 'button' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { onClick: this.closeDelete, className: 'text-center', bsStyle: 'danger', type: 'button' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdjustmentInventory;
	}(_react.Component);
	
	var _default = AdjustmentInventory;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(AdjustmentInventory, 'AdjustmentInventory', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/adjustmentInventory.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/adjustmentInventory.jsx');
	}();

	;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _cleanDates = __webpack_require__(22);
	
	var _inputField = __webpack_require__(16);
	
	var _reduxForm = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateFormatter = _react2.default.createClass({
	  displayName: 'DateFormatter',
	  render: function render() {
	    return this.props.value ? _react2.default.createElement(
	      'span',
	      null,
	      (0, _cleanDates.convertLocalDate)(this.props.value, 'MMM DD YYYY')
	    ) : null;
	  }
	});
	
	var AdjustmentLog = function (_Component) {
	  _inherits(AdjustmentLog, _Component);
	
	  function AdjustmentLog() {
	    _classCallCheck(this, AdjustmentLog);
	
	    var _this = _possibleConstructorReturn(this, (AdjustmentLog.__proto__ || Object.getPrototypeOf(AdjustmentLog)).call(this));
	
	    _this.searchLimit = function (e) {
	      if (/^\d+$/.test(_this.props.limit)) {
	        _this.props.grabAdjustmentLogs(_this.props.limit);
	      } else {
	        _this.props.grabAdjustmentLogs(100);
	      }
	    };
	
	    _this.renderLimit = function () {
	      var handleSubmit = _this.props.handleSubmit;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                onClick: function onClick(e) {
	                  return _this.searchLimit(e);
	                },
	                type: 'submit'
	              },
	              _react2.default.createElement('em', { className: 'fa fa-search marginRightStyle' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Show Number of Changes' })
	            )
	          ),
	          _react2.default.createElement(
	            'form',
	            { onSubmit: handleSubmit(_this.searchLimit) },
	            _react2.default.createElement(_reduxForm.Field, {
	              style: { width: 350, marginTop: 10 },
	              component: _inputField.InputField,
	              name: 'limit',
	              placeholder: 'Number of Results...'
	            })
	          )
	        )
	      );
	    };
	
	    _this.handleLimit = function (limit) {
	      _this.setState({ limit: limit });
	    };
	
	    _this.renderTable = function () {
	      if (_this.props.isLoading && !_this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (_this.props.error) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          _this.props.error
	        )
	      );
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this.state);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return Object.assign({ Idx: rowIdx }, rows[rowIdx]);
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this.state.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        _this.setState({ filters: newFilters });
	      };
	
	      var columns = [{
	        key: 'ProductName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 200,
	        minColumnWidth: 10
	      }, {
	        key: 'ReasonDesc',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reason' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 150,
	        minColumnWidth: 10
	      }, {
	        key: 'AdjustmentQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity_change' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        minColumnWidth: 10
	      }, {
	        key: 'CurrentQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prior_quantity' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        minColumnWidth: 10
	      }, {
	        key: 'new_quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_quantity' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 120,
	        minColumnWidth: 10
	      }, {
	        key: 'BatchNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_number' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        minColumnWidth: 10
	      }, {
	        key: 'CreateTime',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'created' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 120,
	        minColumnWidth: 10,
	        formatter: DateFormatter
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12, style: { marginTop: 25 } },
	          _react2.default.createElement(
	            'div',
	            { key: Math.random(), style: { maxWidth: '99%' }, id: 'ProductConvert-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowkey: 'id',
	              enableCellSelect: true,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              columns: columns,
	              onAddFilter: handleFilterChange,
	              headerRowHeight: 60,
	              rowHeight: 40,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: 541
	            })
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      rows: [],
	      limit: 0
	    };
	    return _this;
	  }
	
	  _createClass(AdjustmentLog, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.grabAdjustmentLogs();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      if (this.props.logs && this.props.logs !== prevProps.logs) {
	        var rows = [];
	        this.props.logs.adjustment_inventory_logs.map(function (log) {
	          log.new_quantity = log.CurrentQuantity + log.AdjustmentQuantity;
	          rows.push(log);
	          _this2.setState({
	            rows: rows
	          });
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactBootstrap.Panel,
	        { style: { marginTop: 30 }, header: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'change_log' }), id: 'category2-detail' },
	        this.renderLimit(),
	        this.renderTable()
	      );
	    }
	  }]);
	
	  return AdjustmentLog;
	}(_react.Component);
	
	var _default = AdjustmentLog;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(DateFormatter, 'DateFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/adjustmentLog.jsx');
	
	  __REACT_HOT_LOADER__.register(AdjustmentLog, 'AdjustmentLog', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/adjustmentLog.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/adjustmentLog.jsx');
	}();

	;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactRouter = __webpack_require__(13);
	
	var _constants = __webpack_require__(11);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import {buttonStyle, marginTopStyle, centerStyle, descriptionStyle} from '../Common/style';
	
	
	var BinForm = function (_Component) {
	    _inherits(BinForm, _Component);
	
	    function BinForm() {
	        _classCallCheck(this, BinForm);
	
	        var _this = _possibleConstructorReturn(this, (BinForm.__proto__ || Object.getPrototypeOf(BinForm)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.binDetail
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        return _this;
	    }
	
	    _createClass(BinForm, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	
	            if (!this.props.currentBin) this.context.router.push('/warehouses');else this.props.fetchBinDetail(this.props.currentBin);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.binDetail });
	        }
	    }, {
	        key: 'editBin',
	        value: function editBin(id) {
	            this.context.router.push("/binForm");
	        }
	    }, {
	        key: 'renderProducts',
	        value: function renderProducts() {
	            var products = this.props.currentBinDetail.Product;
	            if (products) {
	                return products.map(function (product) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'marginTopStyle' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            ' ',
	                            product.Name,
	                            ' '
	                        )
	                    );
	                });
	            }
	        }
	    }, {
	        key: 'renderBinDetail',
	        value: function renderBinDetail() {
	            var _props = this.props,
	                detailError = _props.detailError,
	                detailIsLoading = _props.detailIsLoading,
	                currentBinDetail = _props.currentBinDetail;
	
	            if (detailIsLoading && !detailError) return _react2.default.createElement(_spinner2.default, { className: 'marginTopStyle' });else if (detailError) return _react2.default.createElement(
	                'div',
	                { className: 'alert alert-danger' },
	                JSON.stringify(detailError)
	            );else if (currentBinDetail) {
	                var _props$currentBinDeta = this.props.currentBinDetail,
	                    Name = _props$currentBinDeta.Name,
	                    Description = _props$currentBinDeta.Description,
	                    IsAtInbound = _props$currentBinDeta.IsAtInbound,
	                    IsAtOutbound = _props$currentBinDeta.IsAtOutbound,
	                    WarehouseBin_id = _props$currentBinDeta.WarehouseBin_id;
	
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin_name' }),
	                                Name || 'Name'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_bin_id' }),
	                            ': ',
	                            WarehouseBin_id
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'marginTopStyle' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement('em', { className: 'fa fa-building-o marginRightStyle' }),
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }) || 'Description'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'marginTopStyle' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'is_at_inbound_area' }),
	                            ': ',
	                            IsAtInbound ? 'yes' : 'no'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'marginTopStyle' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'is_at_outbound_area' }),
	                            ': ',
	                            IsAtOutbound ? 'yes' : 'no'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'marginTopStyle' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'products' }),
	                            ': '
	                        )
	                    ),
	                    this.renderProducts()
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/zoneDetail', className: 'btn btn-green buttonStyle' },
	                            _react2.default.createElement('em', { className: 'fa fa-mail-reply' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'pull-right' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-primary buttonStyle' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { className: 'marginTopStyle', style: { height: this.state.tableHeight } },
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin_detail_view' }),
	                            ' | ',
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin' })
	                        )
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(_reactBootstrap.Col, { sm: 1 }),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 2 },
	                            this.renderBinDetail()
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 11, smOffset: 1 },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 3 },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 1 },
	                                                    _react2.default.createElement('div', { className: 'iconred' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 9 },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inbound_area' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 3 },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 1 },
	                                                    _react2.default.createElement('div', { className: 'iconblue' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 9 },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'outbound_area' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 3 },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 1 },
	                                                    _react2.default.createElement('div', { className: 'icongray' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 9 },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all_bins' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 3 },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 1 },
	                                                    _react2.default.createElement('div', { className: 'iconyellow' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 9 },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'selected_bins' })
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 12 },
	                                            _react2.default.createElement(_reactBootstrap.Image, { src: 'http://placehold.it/720x420', thumbnail: true, responsive: true })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return BinForm;
	}(_react.Component);
	
	BinForm.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = BinForm;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(BinForm, 'BinForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/binDetail.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/binDetail.jsx');
	}();

	;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactRouter = __webpack_require__(13);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _inputField = __webpack_require__(16);
	
	var _radio = __webpack_require__(315);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style'
	
	var renderColor = function renderColor(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'optionStyle' },
	    _react2.default.createElement(
	      _reactBootstrap.Row,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 12 },
	        props.meta.touched && props.meta.error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          props.meta.error
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Row,
	      null,
	      _react2.default.createElement(_reactBootstrap.Col, { sm: 1 }),
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 2 },
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { type: 'radio', value: 'Tomato', checked: props.input.value === "Tomato" })),
	        _react2.default.createElement(
	          'span',
	          { style: { color: 'Tomato' } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Red' })
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 2 },
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { type: 'radio', value: 'MediumPurple', checked: props.input.value === "MediumPurple" })),
	        _react2.default.createElement(
	          'span',
	          { style: { color: 'MediumPurple' } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Purple' })
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 2 },
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { type: 'radio', value: 'GoldenRod', checked: props.input.value === "GoldenRod" })),
	        _react2.default.createElement(
	          'span',
	          { style: { color: 'GoldenRod' } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Golden' })
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 2 },
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { type: 'radio', value: 'MediumSeaGreen', checked: props.input.value === "MediumSeaGreen" })),
	        _react2.default.createElement(
	          'span',
	          { style: { color: 'MediumSeaGreen' } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Green' })
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 2 },
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { type: 'radio', value: 'CornflowerBlue', checked: props.input.value === "CornflowerBlue" })),
	        _react2.default.createElement(
	          'span',
	          { style: { color: 'CornflowerBlue' } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Blue' })
	        )
	      )
	    )
	  );
	};
	
	var BinForm = function (_Component) {
	  _inherits(BinForm, _Component);
	
	  function BinForm() {
	    _classCallCheck(this, BinForm);
	
	    return _possibleConstructorReturn(this, (BinForm.__proto__ || Object.getPrototypeOf(BinForm)).apply(this, arguments));
	  }
	
	  _createClass(BinForm, [{
	    key: 'componentWillReceiveProps',
	
	    // static contextTypes = {
	    //     router: React.PropTypes.object
	    // };
	    //
	    // constructor() {
	    //     super();
	    //     this.state = {
	    //         dirty: false
	    //     };
	    // }
	    //
	    // componentDidMount() {
	    //     // making a leaving hook to confirm leaving
	    //     this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
	    //
	    //     if (this.props.currentBin) this.props.fetchBinDetail(this.props.currentBin);
	    //     else if (this.props.currentZone) this.context.router.push("/warehouse");
	    // }
	    //
	    // componentWillReceiveProps(nextProps) {
	    //     if (nextProps.dirty != this.props.dirty) {
	    //         this.setState({
	    //             dirty: nextProps.dirty
	    //         });
	    //     }
	    // }
	    //
	    // routerWillLeave(nextLocation) {
	    //     if (this.state.dirty) return <Translate value="work_not_saved_warning" />
	    // }
	
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.createError && !this.props.createError) {
	        alert(nextProps.createError);
	      }
	      if (nextProps.editError && !this.props.editError) {
	        alert(nextProps.editError);
	      }
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      // this.setState({ dirty: false });
	      var props = _extends({}, formProps, { Description: formProps.Description || '' });
	      if (this.props.currentBin) {
	        this.props.editBin(props);
	      } else {
	        this.props.createBin(props, this.props.currentWarehouse, this.props.currentZone);
	      }
	    }
	
	    // title() {
	    //     if (this.props.currentBin) return <Translate value="bin_detail_view" /> | <Translate value="edit_bin" />;
	    //     else return <Translate value="bin_detail_view" /> | <Translate value="create_bin" />;
	    // }
	
	  }, {
	    key: 'checkPermission',
	    value: function checkPermission(permission) {
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          closeG = _props.closeG,
	          submitting = _props.submitting,
	          pristine = _props.pristine,
	          valid = _props.valid;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'form',
	          { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 9 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(_reactBootstrap.Col, { sm: 2 }),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 8 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement('em', { className: 'fa fa-building-o marginRightStyle' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin_name' }),
	                      ' (*) '
	                    ),
	                    _react2.default.createElement(_reduxForm.Field, { name: 'Name', component: _inputField.InputField, placeholder: 'Bin Name' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(_reactBootstrap.Col, { sm: 2 }),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 8 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement('em', { className: 'fa fa-building-o marginRightStyle' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'Description', component: _inputField.InputField, className: 'form-control' })
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 3 },
	              this.props.isCreating || this.props.isEditing && _react2.default.createElement(_spinner2.default, null),
	              _react2.default.createElement(
	                'button',
	                { action: 'submit', className: 'btn btn-primary buttonStyle', disabled: submitting || pristine || !valid || this.checkPermission("change_warehouse") },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { onClick: closeG, bsStyle: 'warning', className: 'buttonStyle' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	              )
	            )
	          ),
	          _react2.default.createElement(_reactBootstrap.Row, null)
	        )
	      );
	    }
	  }]);
	
	  return BinForm;
	}(_react.Component);
	
	var _default = (0, _reactRouter.withRouter)(BinForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(renderColor, 'renderColor', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/binForm.jsx');
	
	  __REACT_HOT_LOADER__.register(BinForm, 'BinForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/binForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/binForm.jsx');
	}();

	;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _datePicker = __webpack_require__(27);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(13);
	
	var _inputField = __webpack_require__(16);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _zoneInformation = __webpack_require__(177);
	
	var _zoneInformation2 = _interopRequireDefault(_zoneInformation);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle} from '../Common/style'
	
	var renderDatePicker = function renderDatePicker(props) {
	    return _react2.default.createElement(_DateTimePicker2.default, {
	        format: 'YYYY-MM-DD',
	        defaultValue: null,
	        time: false,
	        onChange: function onChange(name) {
	            return props.input.onChange(name);
	        },
	        value: props.input.value || null });
	};
	
	var InboundForm = function (_Component) {
	    _inherits(InboundForm, _Component);
	
	    function InboundForm() {
	        _classCallCheck(this, InboundForm);
	
	        var _this = _possibleConstructorReturn(this, (InboundForm.__proto__ || Object.getPrototypeOf(InboundForm)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	            dirty: false,
	
	            receiveHistories: {
	                rows: [],
	                selectedRows: null,
	                editedRows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null,
	                gourpOpen: false
	            },
	
	            receiveHistory: {
	                rows: [],
	                selectedRows: null,
	                editedRows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null,
	                gourpOpen: false
	            },
	
	            newPutAway: {
	                rows: [],
	                selectedRows: null,
	                editedRows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null,
	                gourpOpen: false
	            },
	            showZonesOpen: false
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        _this.openShowZones = _this.openShowZones.bind(_this);
	        _this.closeShowZones = _this.closeShowZones.bind(_this);
	        return _this;
	    }
	
	    _createClass(InboundForm, [{
	        key: 'openShowZones',
	        value: function openShowZones() {
	            this.setState({ showZonesOpen: true });
	        }
	    }, {
	        key: 'closeShowZones',
	        value: function closeShowZones() {
	            this.setState({ showZonesOpen: false });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchAllReceiveHistoryDetail();
	            this.props.fetchWarehouses();
	            this.props.fetchWarehouseDetail(1);
	            if (this.props.currentPutAway) {
	                this.props.fetchPutAwayDetail(this.props.currentPutAway.WarehousePutAway_id);
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once scrapRecords is ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            if (nextProps.Default_Warehouse_id && nextProps.Default_Warehouse_id != this.props.Default_Warehouse_id) {
	                if (nextProps.Default_Warehouse_id.value) this.props.fetchWarehouseDetail(nextProps.Default_Warehouse_id.value);
	            }
	            if (nextProps.binList && nextProps.binList != this.props.binList) {
	                if (nextProps.binList.error) {
	                    // var r = confirm(<Translate value="space_not_enough_create_bins" />);
	                    // if(r == true){
	                    //   this.props.createBins(nextProps.binList.Product_id, this.state.receiveHistory.selectedRows[0].WarehouseReceiveLine_id, nextProps.binList.error, nextProps.binList.BinList);
	                    // }
	                    // else {
	                    var r1 = confirm(_react2.default.createElement(_reactReduxI18n.Translate, { value: 'space_not_enough_relocate' }));
	                    if (r1 == true) {
	                        this.props.resetCurrentWarehouseReceive();
	                        this.props.selectWarehouseReceive(nextProps.binList.Product_id, this.state.receiveHistory.selectedRows[0].WarehouseReceiveLine_id, nextProps.binList.error, nextProps.binList.BinList);
	                        this.openShowZones();
	                    }
	                    // }
	                } else {
	                    var receiveHistory = this.state.newPutAway.rows;
	                    var selected = Object.assign({}, this.state.receiveHistory.selectedRows[0]);
	                    var binList = nextProps.binList.BinList;
	                    var oldBinList = nextProps.binList.OldBinList;
	                    var totalNum = selected.Quantity;
	                    var unitPerPallet = selected.UnitPerPallet;
	                    if (!unitPerPallet) unitPerPallet = 0;
	                    if (binList.length > 0) {
	                        binList.map(function (bin) {
	                            bin["isSelected"] = false;
	                            bin["ProductName"] = selected.ProductName;
	                            bin["ProductNum"] = nextProps.binList.ProductNum;
	                            bin["Product_id"] = nextProps.binList.Product_id;
	                            bin["ProductDescription"] = selected.ProductDescription;
	                            bin["RcvQuantity"] = nextProps.binList.RcvQuantity;
	                            bin["BinName"] = bin.Name;
	                            bin["ZoneName"] = bin.WarehouseZone_id.Name;
	                            bin["WarehouseZone_id"] = bin.WarehouseZone_id.WarehouseZone_id;
	                            if (Number(totalNum) < Number(unitPerPallet)) {
	                                bin["PutAwayQuantity"] = totalNum < 0 ? 0 : totalNum;
	                            } else {
	                                bin["PutAwayQuantity"] = unitPerPallet;
	                            }
	                            bin["Pallet"] = 1;
	                            bin["Quantity"] = selected.Quantity;
	                            totalNum = Number(totalNum) - Number(unitPerPallet);
	                            if (_this2.props.currentPutAway) bin["WarehouseReceiveNum"] = _this2.props.currentPutAway.WarehouseReceiveNum;
	                        });
	                    } else {
	                        selected["isSelected"] = false;
	                        binList.push(selected);
	                    }
	                    var newBinList = binList.concat(receiveHistory);
	                    if (oldBinList) {
	                        oldBinList.map(function (bin) {
	                            bin["isSelected"] = false;
	                            bin["ProductName"] = selected.ProductName;
	                            bin["ProductDescription"] = selected.ProductDescription;
	                            bin["ProductNum"] = nextProps.binList.ProductNum;
	                            bin["Product_id"] = nextProps.binList.Product_id;
	                            bin["RcvQuantity"] = nextProps.binList.RcvQuantity;
	                            bin["BinName"] = bin.Name;
	                            bin["ZoneName"] = bin.WarehouseZone_id.Name;
	                            bin["WarehouseZone_id"] = bin.WarehouseZone_id.WarehouseZone_id;
	                            if (Number(totalNum) < Number(unitPerPallet)) {
	                                bin["PutAwayQuantity"] = totalNum < 0 ? 0 : totalNum;
	                            } else {
	                                bin["PutAwayQuantity"] = unitPerPallet;
	                            }
	                            bin["Pallet"] = 1;
	                            bin["Quantity"] = selected.Quantity;
	                            totalNum = Number(totalNum) - Number(unitPerPallet);
	                            if (_this2.props.currentPutAway) bin["WarehouseReceiveNum"] = _this2.props.currentPutAway.WarehouseReceiveNum || _this2.props.currentPutAway.WarehouseReceive.WarehouseReceiveNum;
	                        });
	                        newBinList = newBinList.concat(oldBinList);
	                    }
	                    var newPutAway = _extends({}, this.state.newPutAway, { rows: newBinList });
	                    this.setState({ newPutAway: newPutAway });
	                    // this.props.fetchZoneDetail(newBinList[0].WarehouseZone_id);
	                }
	            }
	            if (nextProps.currentPutAwayDetail && nextProps.currentPutAwayDetail != this.props.currentPutAwayDetail) {
	                var warehouse_PutAway_Line = nextProps.currentPutAwayDetail.Warehouse_PutAway_Line;
	                warehouse_PutAway_Line.map(function (line) {
	                    line['ZoneName'] = line.WarehouseZone_id.Name;
	                    line['BinName'] = line.WarehouseBin_id.Name;
	                    line['WarehouseZone_id'] = line.WarehouseZone_id.WarehouseZone_id;
	                    line['WarehouseBin_id'] = line.WarehouseBin_id.Warehouse_id;
	                });
	                var _newPutAway = _extends({}, this.state.newPutAway, { rows: warehouse_PutAway_Line });
	                this.setState({ newPutAway: _newPutAway });
	            }
	            if (nextProps.receiveHistoryDetail && nextProps.receiveHistoryDetail != this.props.receiveHistoryDetail) {
	                var _receiveHistory = Object.assign({}, this.state.receiveHistory);
	                if (nextProps.receiveHistoryDetail.Warehouse_Receive_Line) {
	                    var warehouse_Receive_Line = nextProps.receiveHistoryDetail.Warehouse_Receive_Line;
	                    _receiveHistory = _extends({}, _receiveHistory, { rows: warehouse_Receive_Line });
	                } else {
	                    _receiveHistory = _extends({}, _receiveHistory, { rows: nextProps.receiveHistoryDetail });
	                }
	                this.setState({ receiveHistory: _receiveHistory });
	            }
	            if (nextProps.receiveHistory && nextProps.receiveHistory != this.props.receiveHistory) {
	                var receiveHistories = nextProps.receiveHistory;
	                receiveHistories.map(function (receiveHistory) {
	                    receiveHistory["Vendor"] = receiveHistory.Purchase.Vendor.Name;
	                    receiveHistory["Purchaser"] = receiveHistory.Purchase.Purchaser.username;
	                    receiveHistory["FinalPrice"] = receiveHistory.Purchase.FinalPrice;
	                });
	                var newReceiveHistories = _extends({}, this.state.receiveHistories, { rows: receiveHistories });
	                this.setState({
	                    receiveHistories: newReceiveHistories
	                });
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	        }
	
	        // Set scrapRecords being selected to be currentScrapRecord and navigate user to the edit page
	
	    }, {
	        key: 'setCurrentPutAway',
	        value: function setCurrentPutAway(e) {
	            e.preventDefault();
	            var currentScrapRecord = this.state.selectedRows[0];
	            this.props.selectScrapRecord(currentScrapRecord);
	            this.context.router.push('/scrapRecords/' + currentScrapRecord.WarehouseScrapNum);
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            this.props.fetchReceiveHistoryDetail(this.state.receiveHistories.selectedRows[0].WarehouseReceive_id);
	        }
	    }, {
	        key: 'fetchAllReceiveHistories',
	        value: function fetchAllReceiveHistories(e) {
	            e.preventDefault();
	            this.props.fetchAllReceiveHistoryDetail();
	        }
	    }, {
	        key: 'clickNewPutAway',
	        value: function clickNewPutAway(e) {
	            e.preventDefault();
	            this.props.fetchBinList(this.state.receiveHistory.selectedRows[0].WarehouseReceiveLine_id);
	        }
	    }, {
	        key: 'zoneDetail',
	        value: function zoneDetail(e) {
	            e.preventDefault();
	            this.props.fetchZoneDetail(this.props.Default_WarehouseZone_id.value);
	        }
	    }, {
	        key: 'renderReceiveHistory',
	        value: function renderReceiveHistory() {
	            var _this3 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.receiveHistory);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var receiveHistory = Object.assign({}, _this3.state.receiveHistory, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this3.setState({ receiveHistory: receiveHistory });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this3.state.receiveHistory.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var receiveHistory = _extends({}, _this3.state.receiveHistory, { filters: newFilters });
	                    _this3.setState({ receiveHistory: receiveHistory });
	                };
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var receiveHistory = _extends({}, _this3.state.receiveHistory, { selectedRows: rows });
	                    _this3.setState({ receiveHistory: receiveHistory });
	                };
	
	                // Handle the editable function
	
	                // const handleRowUpdated = e => {
	                //     // merge updated row with current row and rerender by setting state
	                //     let rows = this.state.rows.slice(0);
	                //     let editedRows = this.state.editedRows.slice(0);
	                //     Object.assign(rows[e.rowIdx], e.updated);
	                //     // if the element is already edited, remove the old one.
	                //     editedRows.forEach((element, index) => {
	                //         if (element.Product_id === rows[e.rowIdx].Product_id)
	                //             editedRows.splice(index, 1)
	                //     }, this);
	                //     // push the row into the editedRows array
	                //     editedRows.push(rows[e.rowIdx]);
	                //     this.setState({
	                //         rows: rows,
	                //         editedRows: editedRows
	                //     });
	                // }
	
	                //Custom Formatter component
	                var IsEnabledFormatter = _react2.default.createClass({
	                    displayName: 'IsEnabledFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-success' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disable' })
	                        );
	                    }
	                });
	
	                var columns = [{
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    locked: true
	                }, {
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'ProductDescription',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_description' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'Quantity',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'RcvTotalPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_total_price' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }];
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'InboundForm-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'WarehouseReceiveLine_id',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: this.state.tableHeight,
	                                enableRowSelect: 'single',
	                                onRowSelect: onRowSelect
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderNewPutAway',
	        value: function renderNewPutAway() {
	            var _this4 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.newPutAway);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var newPutAway = Object.assign({}, _this4.state.newPutAway, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this4.setState({ newPutAway: newPutAway });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this4.state.newPutAway.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var newPutAway = _extends({}, _this4.state.newPutAway, { filters: newFilters });
	                    _this4.setState({ newPutAway: newPutAway });
	                };
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var newPutAway = _extends({}, _this4.state.newPutAway, { selectedRows: rows });
	                    _this4.setState({ newPutAway: newPutAway });
	                };
	
	                var onRowsSelected = function onRowsSelected(rows) {
	                    var newRows = _this4.state.newPutAway.rows;
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = true;
	                    });
	                    var newPutAway = _extends({}, _this4.state.newPutAway, { rows: newRows });
	                    _this4.setState({ newPutAway: newPutAway });
	                };
	
	                var onRowsDeselected = function onRowsDeselected(rows) {
	                    var newRows = _this4.state.newPutAway.rows;
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = false;
	                    });
	                    // var rowIndexes = rows.map(r => r.rowIdx);
	                    var newPutAway = _extends({}, _this4.state.newPutAway, { rows: newRows });
	                    _this4.setState({ newPutAway: newPutAway });
	                };
	
	                // Handle the editable function
	
	                var handleRowUpdated = function handleRowUpdated(e) {
	                    // merge updated row with current row and rerender by setting state
	                    var rows = _this4.state.newPutAway.rows.slice(0);
	                    var editedRows = _this4.state.newPutAway.editedRows.slice(0);
	                    Object.assign(rows[e.rowIdx], e.updated);
	                    // if the element is already edited, remove the old one.
	                    editedRows.forEach(function (element, index) {
	                        if (element.Product_id === rows[e.rowIdx].Product_id) editedRows.splice(index, 1);
	                    }, _this4);
	                    // push the row into the editedRows array
	                    editedRows.push(rows[e.rowIdx]);
	                    var newPutAway = _extends({}, _this4.state.newPutAway, { rows: rows, editedRows: editedRows });
	                    _this4.setState({ newPutAway: newPutAway });
	                };
	
	                //Custom Formatter component
	                var IsEnabledFormatter = _react2.default.createClass({
	                    displayName: 'IsEnabledFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-success' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disable' })
	                        );
	                    }
	                });
	
	                var columns = [{
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    locked: true
	                }, {
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'ProductDescription',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_description' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'Quantity',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'ZoneName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_name' }),
	                    resizable: true,
	                    sortable: true,
	                    editable: true,
	                    filterable: true
	                }, {
	                    key: 'BinName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin_name' }),
	                    resizable: true,
	                    sortable: true,
	                    editable: true,
	                    filterable: true
	                }, {
	                    key: 'PutAwayQuantity',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'putaway_quantity' }),
	                    resizable: true,
	                    sortable: true,
	                    editable: true,
	                    filterable: true
	                }];
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'InboundForm-dataGrid2' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'WarehouseReceiveLine_id',
	                                enableCellSelect: true,
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: this.state.tableHeight,
	                                enableRowSelect: 'single',
	                                onRowUpdated: handleRowUpdated,
	                                rowSelection: {
	                                    showCheckbox: true,
	                                    enableShiftSelect: true,
	                                    onRowsSelected: onRowsSelected,
	                                    onRowsDeselected: onRowsDeselected,
	                                    selectBy: {
	                                        isSelectedKey: 'isSelected'
	                                    }
	                                }
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderProducts',
	        value: function renderProducts(bin) {
	            var products = bin.Product;
	            if (products) {
	                return products.map(function (product) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'marginTopStyle' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            ' ',
	                            product.Name,
	                            ' '
	                        )
	                    );
	                });
	            }
	        }
	    }, {
	        key: 'renderBins',
	        value: function renderBins() {
	            var _this5 = this;
	
	            var _props = this.props,
	                currentZoneDetail = _props.currentZoneDetail,
	                bins = _props.bins,
	                detailError = _props.detailError,
	                detailIsLoading = _props.detailIsLoading;
	
	            if (detailIsLoading && !detailError) return _react2.default.createElement(_spinner2.default, { className: 'marginTopStyle' });else if (detailError) return _react2.default.createElement(
	                'div',
	                { className: 'alert alert-danger' },
	                JSON.stringify(this.props.detailError)
	            );
	            if (bins) {
	                return bins.map(function (bin) {
	                    var Name = bin.Name,
	                        Description = bin.Description,
	                        WarehouseBin_id = bin.WarehouseBin_id;
	
	                    return _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 12 },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 12 },
	                                            _react2.default.createElement('em', { className: 'fa fa-institution marginRightStyle' }),
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin' }),
	                                                ' ',
	                                                Name || 'Name'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 12 },
	                                            _react2.default.createElement('em', { className: 'fa fa-institution marginRightStyle' }),
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'id' }),
	                                                ' ',
	                                                WarehouseBin_id || 'WarehouseBin_id'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 12 },
	                                            _react2.default.createElement('em', { className: 'fa fa-building marginLeftStyle marginRightStyle' }),
	                                            currentZoneDetail && currentZoneDetail.Name || 'ZoneName'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'products' }),
	                                            ':'
	                                        )
	                                    ),
	                                    _this5.renderProducts(bin)
	                                )
	                            )
	                        )
	                    );
	                });
	            }
	        }
	    }, {
	        key: 'handleFormSubmit',
	        value: function handleFormSubmit(formProps) {
	            this.setState({ dirty: false });
	            // if(this.props.currentPutAwayDetail){
	            //   let warehousePutAway_id = this.props.currentPutAwayDetail.WarehousePutAway_id
	            //   this.props.editPutAway(formProps, this.props.currentPutAwayDetail, this.state.newPutAway.rows, warehousePutAway_id);
	            // }
	            // else
	            this.props.createPutAway(formProps, this.state.receiveHistory.selectedRows[0], this.state.newPutAway.rows);
	            // if (!this.props.currentPurchaseTemplate) this.props.createPurchaseTemplate(formProps, Data.Selectors.getRows(this.state));
	            // else this.props.editPurchaseTemplate(formProps, Data.Selectors.getRows(this.state));
	        }
	    }, {
	        key: 'deletePutAway',
	        value: function deletePutAway(e) {
	            e.preventDefault();
	            var newPutAway = this.state.newPutAway;
	
	            var newPutAwayRows = [].concat(_toConsumableArray(newPutAway.rows));
	
	            newPutAwayRows = newPutAwayRows.filter(function (obj) {
	                return obj.isSelected == false || obj.isSelected == null;
	            });
	
	            var newNewPutAway = _extends({}, newPutAway, { rows: newPutAwayRows });
	            this.setState({
	                newPutAway: newNewPutAway
	            });
	        }
	    }, {
	        key: 'getWarehouseOptions',
	        value: function getWarehouseOptions() {
	            var warehouseOptions = [];
	            this.props.warehouses.map(function (warehouse) {
	                warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name });
	            });
	            return warehouseOptions;
	        }
	    }, {
	        key: 'getZoneOptions',
	        value: function getZoneOptions() {
	            var zoneOptions = [];
	            if (this.props.currentWarehouseDetail) {
	                this.props.currentWarehouseDetail.Warehouse_Zone.map(function (zone) {
	                    zoneOptions.push({ value: zone.WarehouseZone_id, label: zone.Name });
	                });
	            }
	            return zoneOptions;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            var _props2 = this.props,
	                handleSubmit = _props2.handleSubmit,
	                submitting = _props2.submitting,
	                pristine = _props2.pristine;
	
	            var titleClass = (0, _classnames2.default)('control-label', 'col-sm-4');
	            var createDialogStyle = {
	                height: '700px',
	                width: '600px',
	                marginLeft: '-10%'
	            };
	            var warehouseOptions = this.getWarehouseOptions();
	            var zoneOptions = this.getZoneOptions();
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content-heading' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'put_away_form' })
	                ),
	                _react2.default.createElement(
	                    'form',
	                    { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'pull-right' },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    { className: 'btn btn-primary marginLeftStyle' },
	                                    _react2.default.createElement('em', { className: 'fa fa-print marginRightStyle' }),
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        className: 'btn btn-primary marginLeftStyle',
	                                        type: 'submit' },
	                                    _react2.default.createElement('em', { className: 'fa fa-trash marginRightStyle' }),
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 9 },
	                        this.renderReceiveHistory(),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    className: 'btn btn-primary marginLeftStyle',
	                                    onClick: function onClick(e) {
	                                        return _this6.clickNewPutAway(e);
	                                    } },
	                                _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_put_away' })
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: 'btn btn-warning',
	                                    onClick: function onClick(e) {
	                                        return _this6.deletePutAway(e);
	                                    }
	                                },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                            )
	                        ),
	                        this.renderNewPutAway()
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 3 },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_date' }),
	                                    ':',
	                                    _react2.default.createElement(
	                                        'span',
	                                        { style: { color: "red" } },
	                                        '*'
	                                    )
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { selected: new Date(), component: _datePicker.DisabledDatePicker, name: 'CreateTime' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'update_date' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { style: { color: "red" } },
	                                        '*'
	                                    )
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { selected: new Date(), component: _datePicker.DisabledDatePicker, name: 'UpdateTime' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_select_warehouse' })
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Default_Warehouse_id', component: _selection2.default, options: warehouseOptions })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_select_warehouse_zone' })
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Default_WarehouseZone_id', component: _selection2.default, options: zoneOptions })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        className: 'btn btn-primary marginLeftStyle',
	                                        onClick: function onClick(e) {
	                                            return _this6.zoneDetail(e);
	                                        } },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_detail' })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'marginTopStyle' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Panel,
	                                { style: { overflow: "hidden" } },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    { style: { overflowY: "scroll", maxHeight: 2 * this.state.tableHeight } },
	                                    this.renderBins()
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactSkylight.SkyLightStateless,
	                    { dialogStyles: createDialogStyle, isVisible: this.state.showZonesOpen, onCloseClicked: function onCloseClicked() {
	                            _this6.closeShowZones();
	                        }, title: 'choose_a_zone_to_relocate' },
	                    _react2.default.createElement(_zoneInformation2.default, null)
	                )
	            );
	        }
	    }]);
	
	    return InboundForm;
	}(_react.Component);
	
	InboundForm.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = InboundForm;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(renderDatePicker, 'renderDatePicker', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inboundForm.jsx');
	
	    __REACT_HOT_LOADER__.register(InboundForm, 'InboundForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inboundForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inboundForm.jsx');
	}();

	;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _moment3 = __webpack_require__(41);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _datePicker = __webpack_require__(27);
	
	var _cleanDates = __webpack_require__(22);
	
	var _filterByStart = __webpack_require__(68);
	
	var _filterByStart2 = _interopRequireDefault(_filterByStart);
	
	var _filterMultiKeyword = __webpack_require__(95);
	
	var _filterMultiKeyword2 = _interopRequireDefault(_filterMultiKeyword);
	
	var _selection = __webpack_require__(21);
	
	var _url = __webpack_require__(20);
	
	var _numberWithCommas = __webpack_require__(35);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle} from '../Common/style'
	
	var isMyuMyu = _root_url.ROOT_API_URL === "https://mmstage-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === "https://myumyu-scm.truckxi.com/api/";
	
	(0, _moment4.default)(_moment2.default);
	
	var RowRenderer = function (_Component) {
	  _inherits(RowRenderer, _Component);
	
	  function RowRenderer() {
	    _classCallCheck(this, RowRenderer);
	
	    return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(RowRenderer, [{
	    key: 'setScrollLeft',
	    value: function setScrollLeft(scrollBy) {
	      // To freeze couple columns
	      this.refs.row.setScrollLeft(scrollBy);
	    }
	  }, {
	    key: 'getRowStyle',
	    value: function getRowStyle() {
	      return {
	        color: this.getRowBackground()
	      };
	    }
	  }, {
	    key: 'getRowBackground',
	    value: function getRowBackground() {
	      return this.props.row.InStock > 0 ? 'black' : _constants.BACKGROUND_COLOR.OutofStock;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      //here we are just changing the style
	      //but we could replace this with anything we liked, cards, images, etc
	      //usually though it will just be a matter of wrapping a div, and then calling back through to the grid
	      return _react2.default.createElement(
	        'div',
	        { style: this.getRowStyle() },
	        _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	      );
	    }
	  }]);
	
	  return RowRenderer;
	}(_react.Component);
	
	RowRenderer.PropTypes = {
	  onDoubleClick: _react2.default.PropTypes.func
	};
	
	var Inventories = function (_Component2) {
	  _inherits(Inventories, _Component2);
	
	  function Inventories() {
	    _classCallCheck(this, Inventories);
	
	    var _this2 = _possibleConstructorReturn(this, (Inventories.__proto__ || Object.getPrototypeOf(Inventories)).call(this));
	
	    _this2.fetchInventoriesByWarehouse = function (id) {
	      var _this2$props = _this2.props,
	          f = _this2$props.fromDate,
	          t = _this2$props.toDate,
	          typeRadios = _this2$props.typeRadios;
	      var periodRadios = _this2.props.periodRadios;
	
	      var _this2$getFormattedDa = _this2.getFormattedDatesFromPeriod(periodRadios, { fromDate: f, toDate: t }),
	          fromDate = _this2$getFormattedDa.fromDate,
	          toDate = _this2$getFormattedDa.toDate;
	
	      // id not undefined means warehouse dropdown updated
	
	
	      var warehouse = '';
	      if (!id) {
	        warehouse = _this2.getWarehouseQueryLine();
	      } else {
	        warehouse = _this2.getWarehouseQueryLineByID(id);
	      }
	      var _this2$state = _this2.state,
	          currentCategory = _this2$state.currentCategory,
	          currentGroup = _this2$state.currentGroup;
	
	      var division = '';
	      if (currentCategory && currentCategory !== -1) {
	        division = 'ProductNum__ProductCategory1_id=' + currentCategory;
	      } else if (currentGroup && currentGroup !== -1) {
	        division = 'ProductNum__ProductGroup_id=' + currentGroup;
	      }
	      _this2.props.fetchInventoriesByPeriod(typeRadios, division, fromDate, toDate, warehouse);
	    };
	
	    _this2.handleWarehouseOnChange = function (event) {
	      if (event) {
	        _this2.fetchInventoriesByWarehouse(event.value);
	      }
	    };
	
	    _this2.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.inventoriesPage,
	
	      rows: [],
	      selectedRows: [],
	      editedRows: [],
	      filters: {},
	      sortColumn: null,
	      sortDirection: null,
	      gourpOpen: false,
	      currentGroup: null,
	      currentCategory: null,
	      groupExpanded: false,
	      clear: true,
	      renderRows: true,
	      totalInventoryPrice: 0
	    };
	
	    _this2.handleResize = _this2.handleResize.bind(_this2);
	    // this.zoneLevel = this.zoneLevel.bind(this);
	    _this2.inventoryDetail = _this2.inventoryDetail.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(Inventories, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.setValue('inventories', 'typeRadios', 'All');
	      this.props.setValue('inventories', 'periodRadios', '7');
	      this.props.resetGroupAndCategory();
	      this.props.fetchWarehouses();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      // window.addEventListener('resize', this.handleResize);
	      this.props.fetchGroups();
	      // this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
	
	      var currentCategoryGroup = this.props.currentCategoryGroup;
	      var typeRadios = 'All';
	      var fromDate = '1900-01-01';
	      var toDate = '3000-01-01';
	      if (currentCategoryGroup) {
	        typeRadios = currentCategoryGroup.typeRadios || typeRadios;
	        fromDate = currentCategoryGroup.fromDate || fromDate;
	        toDate = currentCategoryGroup.toDate || toDate;
	      }
	      if (currentCategoryGroup && currentCategoryGroup.currentRows && currentCategoryGroup.currentRows.length != 0) {
	        var selectedRows = [];
	        var newInventories = currentCategoryGroup.currentRows;
	        if (this.props.currentCategoryGroup && this.props.currentCategoryGroup.currentProduct_id) {
	          newInventories.map(function (inventory) {
	            if (inventory.Product_id == _this3.props.currentCategoryGroup.currentProduct_id) {
	              inventory.isSelected = true;
	              selectedRows.push(inventory);
	            }
	          });
	        }
	        this.setState({
	          rows: newInventories,
	          selectedRows: selectedRows,
	          renderRows: false
	        });
	        if (selectedRows.length != 0) this.props.setGroupCategory({ currentRows: newInventories });
	      }
	      if (currentCategoryGroup && currentCategoryGroup.currentGroup) {
	        if (currentCategoryGroup.currentGroup != -1) this.props.fetchGroupCategories(currentCategoryGroup.currentGroup);
	        this.setState({
	          currentGroup: currentCategoryGroup.currentGroup,
	          currentCategory: currentCategoryGroup.currentCategory,
	          groupExpanded: true
	        });
	      }
	      if (typeRadios == '-1') {
	        this.props.setValue('inventories', 'FromDate', fromDate);
	        this.props.setValue('inventories', 'ToDate', toDate);
	      } else {
	        this.props.setValue('inventories', 'periodRadios', '7');
	      }
	      // setTimeout(() => {this.props.setValue('inventories', 'typeRadios', typeRadios)}, 1000);
	      this.props.setValue('inventories', 'typeRadios', typeRadios);
	    }
	
	    // routerWillLeave(nextLocation) {
	    //   this.props.resetGroupAndCategory();
	    // }
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var productGroup_id = this.state.currentGroup;
	      var productCategory_id = this.state.currentCategory;
	      var groups = document.getElementsByName('group');
	      var i = 0;
	      for (; i < groups.length; i++) {
	        if (groups[i].id != 'g' + productGroup_id) {
	          groups[i].style.backgroundColor = null;
	        } else {
	          groups[i].style.backgroundColor = _constants.APP_COLORS['active-category-background-nav'];
	        }
	      }
	      var categories = document.getElementsByName('category');
	      i = 0;
	      if (categories) {
	        for (; i < categories.length; i++) {
	          if (categories[i].id != 'c' + productCategory_id) {
	            categories[i].style.backgroundColor = null;
	          } else {
	            categories[i].style.backgroundColor = _constants.APP_COLORS['active-category-background-nav'];
	          }
	        }
	      }
	      if (_reactDataGridAddons.Data.Selectors.getRows(prevState) !== _reactDataGridAddons.Data.Selectors.getRows(this.state)) {
	        var totalInventoryPrice = 0;
	        var inventories = _reactDataGridAddons.Data.Selectors.getRows(this.state);
	        inventories.forEach(function (inventory) {
	          totalInventoryPrice += inventory.InventoryPrice;
	        });
	        this.setState({
	          totalInventoryPrice: totalInventoryPrice
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.clear) this.props.setGroupCategory(null);
	      this.props.setOriginPage('inventories');
	      this.props.resetWarehouses();
	      // window.removeEventListener('resize', this.handleResize);
	    }
	
	    // Once inventories is ready, reset state.
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this4 = this;
	
	      if (nextProps.product && nextProps.product != this.props.product) {
	        var index = _.findIndex(this.state.rows, { Product_id: nextProps.product });
	        this.state.rows.map(function (r) {
	          return r.isSelected = false;
	        });
	        if (index > -1) {
	          this.state.rows[index].isSelected = true;
	          this.setState({ selectedRows: [this.state.rows[index]] });
	        } else {
	          this.setState({ selectedRows: [] });
	        }
	      }
	      if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
	        var newInventories = [].concat(_toConsumableArray(nextProps.inventories));
	        var selectedRows = [];
	        if (newInventories.length != 0 && this.props.currentCategoryGroup && this.props.currentCategoryGroup.currentProduct_id) {
	          newInventories.map(function (inventory) {
	            if (inventory.Product_id == _this4.props.currentCategoryGroup.currentProduct_id) {
	              inventory.isSelected = true;
	              selectedRows.push(inventory);
	            }
	          });
	        }
	        if (selectedRows.length != 0) this.props.setGroupCategory(null);
	        this.setState({
	          rows: newInventories,
	          selectedRows: selectedRows
	        });
	      }
	
	      if (nextProps.groups && nextProps.groups != this.props.groups) {
	        var productGroup_id = nextProps.groups[0].ProductGroup_id;
	        var _props = this.props,
	            f = _props.fromDate,
	            t = _props.toDate,
	            periodRadios = _props.periodRadios;
	
	        var _getFormattedDatesFro = this.getFormattedDatesFromPeriod(periodRadios, { fromDate: f, toDate: t }),
	            fromDate = _getFormattedDatesFro.fromDate,
	            toDate = _getFormattedDatesFro.toDate;
	
	        var warehouse = this.getWarehouseQueryLine();
	
	        if (this.state.currentCategory == -1 && this.state.currentGroup == -1) {
	          if (this.props.typeRadios) this.props.fetchInventoriesByPeriod(this.props.typeRadios, '', fromDate, toDate, warehouse);
	        } else if (this.state.currentCategory && this.state.currentCategory != -1) {
	          if (this.props.typeRadios) this.props.fetchInventoriesByPeriod(this.props.typeRadios, 'ProductNum__ProductCategory1_id=' + this.state.currentCategory, fromDate, toDate, warehouse);
	        } else if (this.state.currentGroup && this.state.currentGroup != -1) {
	          if (this.props.typeRadios) this.props.fetchInventoriesByPeriod(this.props.typeRadios, 'ProductNum__ProductGroup_id=' + this.state.currentGroup, fromDate, toDate, warehouse);
	        } else {
	          // this.props.fetchInventoriesByGroup(productGroup_id);
	          if (this.props.typeRadios) this.props.fetchInventoriesByPeriod(this.props.typeRadios, 'ProductNum__ProductGroup_id=' + productGroup_id, fromDate, toDate, warehouse);
	          this.setState({ currentGroup: productGroup_id });
	        }
	      }
	
	      // if (nextProps.inventoriesByGroup && nextProps.inventoriesByGroup != this.props.inventoriesByGroup) {
	      //     let newInventories = [...nextProps.inventoriesByGroup];
	      //     let selectedRows =[];
	      //     if(newInventories.length != 0 && this.props.currentCategoryGroup && this.props.currentCategoryGroup.currentProduct_id) {
	      //
	      //       newInventories.map(inventory => {
	      //         if(inventory.Product_id == this.props.currentCategoryGroup.currentProduct_id) {
	      //           inventory.isSelected = true;
	      //           selectedRows.push(inventory);
	      //         }
	      //       })
	      //     }
	      //     if(selectedRows.length != 0)
	      //       this.props.setGroupCategory(null);
	      //     this.setState({
	      //         rows: newInventories,
	      //         selectedRows: selectedRows
	      //     });
	      //
	      // }
	      // if (nextProps.inventoriesByCategory && nextProps.inventoriesByCategory != this.props.inventoriesByCategory) {
	      //     let newInventories = [...nextProps.inventoriesByCategory];
	      //     let selectedRows =[];
	      //     if(newInventories.length != 0 && this.props.currentCategoryGroup && this.props.currentCategoryGroup.currentProduct_id) {
	      //       newInventories.map(inventory => {
	      //         if(inventory.Product_id == this.props.currentCategoryGroup.currentProduct_id) {
	      //           inventory.isSelected = true;
	      //           selectedRows.push(inventory);
	      //         }
	      //       })
	      //     }
	      //     if(selectedRows.length != 0)
	      //       this.props.setGroupCategory(null);
	      //     this.setState({
	      //         rows: newInventories,
	      //         selectedRows: selectedRows
	      //     });
	      // }
	
	      if (nextProps.fromDate && nextProps.fromDate != this.props.fromDate) {
	        if (nextProps.fromDate !== '') {
	          var _f = nextProps.fromDate;
	
	          var _getFormattedDates = this.getFormattedDates({ fromDate: _f, toDate: this.props.toDate }),
	              _fromDate = _getFormattedDates.fromDate,
	              _toDate = _getFormattedDates.toDate;
	
	          var _warehouse = this.getWarehouseQueryLine();
	
	          console.log('====================', _fromDate);
	          console.log('====================', _toDate);
	          this.props.setValue('inventories', 'periodRadios', '-1');
	          // this.props.fetchInventoriesByPeriod(nextProps.typeRadios, 'ProductNum__ProductCategory1_id=' + this.state.currentCategory, fromDate, toDate);
	
	          if (this.state.currentCategory == -1 && this.state.currentGroup == -1) {
	            if (nextProps.typeRadios) this.props.fetchInventoriesByPeriod(nextProps.typeRadios, '', _fromDate, _toDate, _warehouse);
	          } else if (this.state.currentCategory && this.state.currentCategory != -1) {
	            if (nextProps.typeRadios) this.props.fetchInventoriesByPeriod(nextProps.typeRadios, 'ProductNum__ProductCategory1_id=' + this.state.currentCategory, _fromDate, _toDate, _warehouse);
	          } else if (this.state.currentGroup && this.state.currentGroup != -1) {
	            if (nextProps.typeRadios) this.props.fetchInventoriesByPeriod(nextProps.typeRadios, 'ProductNum__ProductGroup_id=' + this.state.currentGroup, _fromDate, _toDate, _warehouse);
	          }
	        }
	      }
	
	      if (nextProps.toDate && nextProps.toDate != this.props.toDate) {
	        if (nextProps.toDate !== '') {
	          var _t = nextProps.toDate;
	
	          var _getFormattedDates2 = this.getFormattedDates({ toDate: _t, fromDate: this.props.fromDate }),
	              _fromDate2 = _getFormattedDates2.fromDate,
	              _toDate2 = _getFormattedDates2.toDate;
	
	          var _warehouse2 = this.getWarehouseQueryLine();
	          this.props.setValue('inventories', 'periodRadios', '-1');
	          // this.props.fetchInventoriesByPeriod(nextProps.typeRadios, 'ProductNum__ProductCategory1_id=' + this.state.currentCategory, fromDate, toDate);
	
	          if (this.state.currentCategory == -1 && this.state.currentGroup == -1) {
	            if (nextProps.typeRadios) this.props.fetchInventoriesByPeriod(nextProps.typeRadios, '', _fromDate2, _toDate2, _warehouse2);
	          } else if (this.state.currentCategory && this.state.currentCategory != -1) {
	            if (nextProps.typeRadios) this.props.fetchInventoriesByPeriod(nextProps.typeRadios, 'ProductNum__ProductCategory1_id=' + this.state.currentCategory, _fromDate2, _toDate2, _warehouse2);
	          } else if (this.state.currentGroup && this.state.currentGroup != -1) {
	            if (nextProps.typeRadios) this.props.fetchInventoriesByPeriod(nextProps.typeRadios, 'ProductNum__ProductGroup_id=' + this.state.currentGroup, _fromDate2, _toDate2, _warehouse2);
	          }
	        }
	      }
	
	      if (nextProps.typeRadios && nextProps.typeRadios != this.props.typeRadios) {
	        // if (nextProps.typeRadios == 'All' && this.props.typeRadios == null) return;
	        var _props2 = this.props,
	            _f2 = _props2.fromDate,
	            _t2 = _props2.toDate;
	        var _periodRadios = nextProps.periodRadios;
	
	        var _getFormattedDatesFro2 = this.getFormattedDatesFromPeriod(_periodRadios, { fromDate: _f2, toDate: _t2 }),
	            _fromDate3 = _getFormattedDatesFro2.fromDate,
	            _toDate3 = _getFormattedDatesFro2.toDate;
	        // periodRadios = `/${periodRadios}`;
	
	
	        var _warehouse3 = this.getWarehouseQueryLine();
	
	        // if(nextProps.periodRadios == '-1')
	        //   periodRadios = '';
	        if (this.state.currentCategory && this.state.currentCategory != -1) {
	          this.props.fetchInventoriesByPeriod(nextProps.typeRadios, 'ProductNum__ProductCategory1_id=' + this.state.currentCategory, _fromDate3, _toDate3, _warehouse3);
	        } else if (this.state.currentGroup && this.state.currentGroup != -1) {
	          this.props.fetchInventoriesByPeriod(nextProps.typeRadios, 'ProductNum__ProductGroup_id=' + this.state.currentGroup, _fromDate3, _toDate3, _warehouse3);
	        } else if (this.state.currentGroup == -1 && this.state.currentCategory == -1) {
	          this.props.fetchInventoriesByPeriod(nextProps.typeRadios, '', _fromDate3, _toDate3, _warehouse3);
	        }
	        // this.props.setValue('inventories', 'FromDate', '');
	        // if (nextProps.typeRadios == 'InStock'
	        // || nextProps.typeRadios == 'OutStock'
	        // || nextProps.typeRadios == 'All'
	        // || nextProps.typeRadios == 'NonZero') {
	        //   if (this.state.currentCategory && this.state.currentCategory != -1) {
	        //     this.props.fetchInventoriesByPeriod(nextProps.typeRadios, 'ProductNum__ProductCategory1_id=' + this.state.currentCategory, fromDate, toDate);
	        //   }
	        //   else if (this.state.currentGroup && this.state.currentGroup != -1) {
	        //     this.props.fetchInventoriesByPeriod(nextProps.typeRadios, 'ProductNum__ProductGroup_id=' + this.state.currentGroup, fromDate, toDate);
	        //   }
	        //   else if (this.state.currentGroup == -1 && this.state.currentCategory == -1){
	        //       this.props.fetchAllInventories(nextProps.typeRadios);
	        //   }
	        // } else {
	        //
	        // }
	      }
	
	      if (nextProps.periodRadios && nextProps.periodRadios != this.props.periodRadios) {
	        var _props3 = this.props,
	            _f3 = _props3.fromDate,
	            _t3 = _props3.toDate;
	        var _periodRadios2 = nextProps.periodRadios;
	
	        var _getFormattedDatesFro3 = this.getFormattedDatesFromPeriod(_periodRadios2, { fromDate: _f3, toDate: _t3 }),
	            _fromDate4 = _getFormattedDatesFro3.fromDate,
	            _toDate4 = _getFormattedDatesFro3.toDate;
	        // periodRadios = `/${periodRadios}`;
	
	
	        var _warehouse4 = this.getWarehouseQueryLine();
	
	        // if(nextProps.periodRadios == '-1')
	        //   periodRadios = '';
	
	        if (this.props.periodRadios == null) return;
	        if (nextProps.periodRadios != '-1') {
	          this.props.setValue('inventories', 'FromDate', '');
	          this.props.setValue('inventories', 'ToDate', '');
	        }
	
	        if (this.state.currentCategory && this.state.currentCategory != -1) {
	          this.props.fetchInventoriesByPeriod(this.props.typeRadios, 'ProductNum__ProductCategory1_id=' + this.state.currentCategory, _fromDate4, _toDate4, _warehouse4);
	        } else if (this.state.currentGroup && this.state.currentGroup != -1) {
	          this.props.fetchInventoriesByPeriod(this.props.typeRadios, 'ProductNum__ProductGroup_id=' + this.state.currentGroup, _fromDate4, _toDate4, _warehouse4);
	        } else if (this.state.currentGroup == -1 && this.state.currentCategory == -1) {
	          this.props.fetchInventoriesByPeriod(this.props.typeRadios, '', _fromDate4, _toDate4, _warehouse4);
	        }
	      }
	
	      if (nextProps.inventoriesByPeriod && nextProps.inventoriesByPeriod != this.props.inventoriesByPeriod) {
	        var _newInventories = [].concat(_toConsumableArray(nextProps.inventoriesByPeriod));
	        if (this.props.currentCategoryGroup && this.props.currentCategoryGroup.currentRows) {
	          this.props.setGroupCategory(null);
	          this.setState({ renderRows: true });
	        } else {
	          var _selectedRows = [];
	          if (_newInventories.length != 0 && this.props.currentCategoryGroup && this.props.currentCategoryGroup.currentProduct_id) {
	            _newInventories.map(function (inventory) {
	              if (inventory.Product_id == _this4.props.currentCategoryGroup.currentProduct_id) {
	                inventory.isSelected = true;
	                _selectedRows.push(inventory);
	              }
	            });
	          }
	          this.setState({
	            rows: _newInventories,
	            selectedRows: _selectedRows
	          });
	          this.props.setGroupCategory(null);
	        }
	      }
	
	      if (this.props.warehouseList !== nextProps.warehouseList) {
	        var warehouseList = nextProps.warehouseList;
	
	        warehouseList.map(function (warehouse) {
	          if (warehouse.IsDefault) {
	            var defaultWarehouse = { value: warehouse.Warehouse_id, label: warehouse.Name };
	            _this4.props.setValue('inventories', 'Warehouse', defaultWarehouse);
	          }
	        });
	      }
	
	      // if (nextProps.nonZeroInventories && nextProps.nonZeroInventories != this.props.nonZeroInventories) {
	      //   console.log('nonzero inventories received');
	      //   let newInventories = [...nextProps.nonZeroInventories];
	      //   this.setState({
	      //       rows: newInventories,
	      //   });
	      // }
	    }
	  }, {
	    key: 'getFormattedDates',
	    value: function getFormattedDates(dates) {
	      var fromDate = dates.fromDate,
	          toDate = dates.toDate;
	
	      if (!fromDate) {
	        fromDate = '2016-01-01';
	      } else {
	        fromDate = (0, _moment2.default)(fromDate).format('YYYY-MM-DD');
	      }
	      if (!toDate) {
	        toDate = '3000-01-01';
	      } else {
	        toDate = (0, _moment2.default)(toDate).format('YYYY-MM-DD');
	      }
	      return { fromDate: fromDate, toDate: toDate };
	    }
	  }, {
	    key: 'getFormattedDatesFromPeriod',
	    value: function getFormattedDatesFromPeriod(period, dates) {
	      var _getFormattedDates3 = this.getFormattedDates(dates),
	          fromDate = _getFormattedDates3.fromDate,
	          toDate = _getFormattedDates3.toDate;
	
	      if (period && period !== '-1') {
	        toDate = (0, _moment2.default)().format('YYYY-MM-DD');
	        if (period === '1') {
	          fromDate = toDate;
	        } else if (period === '2') {
	          toDate = (0, _moment2.default)().subtract(1, 'days').format('YYYY-MM-DD');
	          fromDate = toDate;
	        } else {
	          fromDate = (0, _moment2.default)().subtract(parseFloat(period) - 1, 'days').format('YYYY-MM-DD');
	        }
	      }
	      // console.log(period, dates, { fromDate, toDate });
	      return { fromDate: fromDate, toDate: toDate };
	    }
	  }, {
	    key: 'getWarehouseQueryLine',
	    value: function getWarehouseQueryLine() {
	      var warehouse = this.props.warehouse;
	
	      if (!warehouse || warehouse.value === -1) {
	        warehouse = '';
	      } else {
	        warehouse = 'Warehouse_id=' + warehouse.value;
	      }
	      return warehouse;
	    }
	  }, {
	    key: 'getWarehouseQueryLineByID',
	    value: function getWarehouseQueryLineByID(id) {
	      var warehouse = '';
	      if (!id || id === -1) {
	        warehouse = '';
	      } else {
	        warehouse = 'Warehouse_id=' + id;
	      }
	      return warehouse;
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton });
	    }
	
	    // Set inventories being selected to be currentInventory and navigate user to the edit page
	    // test
	
	  }, {
	    key: 'setCurrentInventory',
	    value: function setCurrentInventory(e) {
	      e.preventDefault();
	      var currentInventory = this.state.selectedRows[0];
	      this.props.selectInventory(currentInventory);
	    }
	  }, {
	    key: 'clickNew',
	    value: function clickNew(e) {
	      e.preventDefault();
	      this.props.resetCurrentInventory();
	    }
	
	    // zoneLevel() {
	    //   // e.preventDefault();
	    //   console.log('arguments', arguments);
	    //   this.setState({clear: false});
	    //   const currentInventory = arguments[0];
	    //
	    //   let fromDate = this.props.fromDate;
	    //   let toDate = this.props.toDate;
	    //   if (fromDate == null) {
	    //     fromDate = '1900-01-01';
	    //   }
	    //   if (toDate == null) {
	    //     toDate = '3000-01-01';
	    //   }
	    //
	    //   this.props.resetCurrentInventory();
	    //   this.props.selectProduct(currentInventory);
	    //   let currentRows = [];
	    //   let colKey = Object.getOwnPropertyNames(this.state.filters)[0];
	    //   if(colKey) {
	    //     let filterMethod = this.state.filters[colKey] && this.state.filters[colKey].column.filterRenderer && this.state.filters[colKey].column.filterRenderer.name;
	    //     this.state.rows.map(row => {
	    //       let r = row[colKey].toString().toLowerCase();
	    //       let term = this.state.filters[colKey].filterTerm.toString().toLowerCase()
	    //       let index = (r).indexOf(term)
	    //       if(filterMethod && index == 0) {
	    //         currentRows.push(row);
	    //       }
	    //       else if (!filterMethod && index > -1) {
	    //         currentRows.push(row);
	    //       }
	    //     })
	    //   }
	    //   else {
	    //     currentRows = this.state.rows;
	    //   }
	    //   currentRows.map(r => {
	    //     r.isSelected = false;
	    //   })
	    //   this.props.setGroupCategory({
	    //     currentGroup: this.state.currentGroup,
	    //     currentCategory: this.state.currentCategory,
	    //     currentProduct_id: currentInventory.Product_id,
	    //     typeRadios: this.props.typeRadios,
	    //     fromDate: fromDate,
	    //     toDate: toDate,
	    //     currentRows: currentRows
	    //   });
	    //   // this.context.router.push('/inventories/detail/');
	    //   this.context.router.push('/products/'+currentInventory.Product_id);
	    // }
	
	  }, {
	    key: 'inventoryDetail',
	    value: function inventoryDetail() {
	      // e.preventDefault();
	      this.setState({ clear: false });
	      var currentInventory = arguments[0];
	      console.log("what is args", arguments);
	
	      var fromDate = this.props.fromDate;
	      var toDate = this.props.toDate;
	      if (fromDate == null) {
	        fromDate = '1900-01-01';
	      }
	      if (toDate == null) {
	        toDate = '3000-01-01';
	      }
	
	      this.props.resetCurrentInventory();
	      if (arguments[1] == 'productDetail') {
	        this.props.selectProduct(currentInventory);
	      } else {
	        this.props.selectInventory(currentInventory);
	      }
	      // let currentRows = [];
	      // let colKey = Object.getOwnPropertyNames(this.state.filters)[0];
	      var currentRows = _reactDataGridAddons.Data.Selectors.getRows(this.state);
	      // if(colKey) {
	      //   let filterMethod = this.state.filters[colKey] && this.state.filters[colKey].column.filterRenderer && this.state.filters[colKey].column.filterRenderer.name;
	      //   this.state.rows.map(row => {
	      //     let r = row[colKey].toString().toLowerCase();
	      //     let term = this.state.filters[colKey].filterTerm.toString().toLowerCase()
	      //     let index = (r).indexOf(term)
	      //     if(filterMethod && index == 0) {
	      //       currentRows.push(row);
	      //     }
	      //     else if (!filterMethod && index > -1) {
	      //       currentRows.push(row);
	      //     }
	      //   })
	      // }
	      // else {
	      //   currentRows = this.state.rows;
	      // }
	      currentRows.map(function (r) {
	        r.isSelected = false;
	      });
	      this.props.setGroupCategory({
	        currentGroup: this.state.currentGroup,
	        currentCategory: this.state.currentCategory,
	        currentProduct_id: currentInventory.Product_id,
	        typeRadios: this.props.typeRadios,
	        fromDate: fromDate,
	        toDate: toDate,
	        currentRows: currentRows
	      });
	
	      if (arguments[1] == 'productDetail') {
	        this.context.router.push('/products/' + currentInventory.Product_id);
	      } else {
	        this.context.router.push('/inventories/detail/');
	      }
	      // this.context.router.push('/products/'+currentInventory.Product_id);
	    }
	  }, {
	    key: 'getWarehouseList',
	    value: function getWarehouseList() {
	      var warehouseList = this.props.warehouseList;
	
	      var options = [{ value: -1, label: 'All' }];
	      warehouseList.map(function (warehouse) {
	        options.push({ value: warehouse.Warehouse_id, label: warehouse.Name });
	      });
	      return options;
	    }
	  }, {
	    key: 'pushInventoryAdjustment',
	    value: function pushInventoryAdjustment(e) {
	      e.preventDefault();
	      this.context.router.push('/inventories/adjustment');
	    }
	  }, {
	    key: 'pushInventoryRelocation',
	    value: function pushInventoryRelocation(e) {
	      e.preventDefault();
	      this.context.router.push('inventories/relocation');
	    }
	  }, {
	    key: 'fetchLowStockInventory',
	    value: function fetchLowStockInventory(e) {
	      e.preventDefault();
	      this.context.router.push('/inventories/lowStock/');
	    }
	  }, {
	    key: 'fetchExpiredInventory',
	    value: function fetchExpiredInventory(e) {
	      e.preventDefault();
	      this.context.router.push('/inventories/expired/');
	    }
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this5 = this;
	
	      var _props4 = this.props,
	          isLoading = _props4.isLoading,
	          inventoriesByGroupIsLoading = _props4.inventoriesByGroupIsLoading,
	          inventoriesByCategoryIsLoading = _props4.inventoriesByCategoryIsLoading,
	          inventoriesByPeriodIsLoading = _props4.inventoriesByPeriodIsLoading;
	
	      if (isLoading || inventoriesByGroupIsLoading || inventoriesByCategoryIsLoading || inventoriesByPeriodIsLoading) return _react2.default.createElement(_spinner2.default, null);else {
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this5.state);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the row select function
	
	        var onRowSelect = function onRowSelect(rows) {
	          _this5.setState.apply(_this5, _toConsumableArray(_this5.state).concat([{ selectedRows: rows }]));
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var state = Object.assign({}, _this5.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this5.setState(state);
	        };
	
	        var handleFilterChange = function handleFilterChange(filter) {
	          _this5.setState({ rows: _this5.props.inventoriesByPeriod });
	          var newFilters = Object.assign({}, _this5.state.filters);
	          if (filter.filterTerm) {
	            newFilters[filter.column.key] = filter;
	          } else {
	            delete newFilters[filter.column.key];
	          }
	          _this5.setState({ filters: newFilters });
	        };
	
	        var getValidFilterValues = function getValidFilterValues(columnId) {
	          var values = _this5.state.rows.map(function (r) {
	            return r[columnId];
	          });
	          return values.filter(function (item, i, a) {
	            return i === a.indexOf(item);
	          });
	        };
	
	        var onClearFilters = function onClearFilters() {
	          //all filters removed
	          _this5.setState({ filters: {}, rows: _this5.props.inventoriesByPeriod });
	        };
	
	        // Handle the editable function
	
	        var handleRowUpdated = function handleRowUpdated(e) {
	          // merge updated row with current row and rerender by setting state
	          var rows = _this5.state.rows.slice(0);
	          var editedRows = _this5.state.editedRows.slice(0);
	          Object.assign(rows[e.rowIdx], e.updated);
	          // if the element is already edited, remove the old one.
	          editedRows.forEach(function (element, index) {
	            if (element.Product_id === rows[e.rowIdx].Product_id) editedRows.splice(index, 1);
	          }, _this5);
	          // push the row into the editedRows array
	          editedRows.push(rows[e.rowIdx]);
	          _this5.setState({
	            rows: rows,
	            editedRows: editedRows
	          });
	        };
	
	        //Custom Formatter component
	        var IsEnabledFormatter = _react2.default.createClass({
	          displayName: 'IsEnabledFormatter',
	          render: function render() {
	            if (this.props.value) return _react2.default.createElement(
	              'span',
	              { className: 'label label-success' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	            );else return _react2.default.createElement(
	              'span',
	              { className: 'label label-danger' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disable' })
	            );
	          }
	        });
	
	        var ProdNumFormatter = _react2.default.createClass({
	          displayName: 'ProdNumFormatter',
	          render: function render() {
	            var _this6 = this;
	
	            return _react2.default.createElement(
	              'span',
	              {
	                onDoubleClick: function onDoubleClick() {
	                  if ((0, _permissions2.default)('change_product')) {
	                    _this6.props.zoneLevel(_this6.props.dependentValues, 'productDetail');
	                  } else {
	                    alert(_reactReduxI18n.I18n.t('msg_no_permission'));
	                  }
	                }
	              },
	              _react2.default.createElement(
	                'span',
	                { style: { color: '#585858' } },
	                this.props.value.slice(0, 2)
	              ),
	              _react2.default.createElement(
	                'span',
	                { style: { color: '#0B609F' } },
	                this.props.value.slice(2, 4)
	              ),
	              _react2.default.createElement(
	                'span',
	                { style: { color: 'black' } },
	                this.props.value.slice(4, 7)
	              ),
	              _react2.default.createElement(
	                'span',
	                { style: { color: 'black' } },
	                this.props.value.slice(7)
	              )
	            );
	          }
	        });
	
	        ProdNumFormatter.PropTypes = {
	          onDoubleClick: _react2.default.PropTypes.func
	        };
	
	        var DoubleClickFormatter = _react2.default.createClass({
	          displayName: 'DoubleClickFormatter',
	
	          PropTypes: {
	            onDoubleClick: _react2.default.PropTypes.func
	          },
	          render: function render() {
	            var _this7 = this;
	
	            var value = void 0;
	            if (this.props.value || this.props.value === 0) {
	              if (this.props.price) {
	                value = '$' + (0, _numberWithCommas.numberWithCommas)((this.props.value || 0).toFixed(2));
	              } else {
	                value = this.props.value;
	              }
	            }
	            return _react2.default.createElement(
	              'span',
	              {
	                onDoubleClick: function onDoubleClick() {
	                  if ((0, _permissions2.default)('change_inventory')) {
	                    _this7.props.zoneLevel(_this7.props.dependentValues);
	                  } else {
	                    alert(_reactReduxI18n.I18n.t('msg_no_permission'));
	                  }
	                }
	              },
	              value
	            );
	          }
	        });
	
	        var ProductIsStopSaleBackGroundFormatter = function ProductIsStopSaleBackGroundFormatter(_ref) {
	          var children = _ref.children,
	              props = _objectWithoutProperties(_ref, ['children']);
	
	          var getRowBackground = function getRowBackground() {
	            if (props.dependentValues.IsStopSale) {
	              return _constants.BACKGROUND_COLOR.tintedPink;
	            }
	          };
	          return _react2.default.createElement(
	            'div',
	            { style: { backgroundColor: getRowBackground() } },
	            _react2.default.cloneElement(children, props)
	          );
	        };
	
	        var TotalWeightFormatter = _react2.default.createClass({
	          displayName: 'TotalWeightFormatter',
	          render: function render() {
	            var _this8 = this;
	
	            var ProductType = this.props.dependentValues.ProductType;
	
	            var shouldShowValue = ProductType === 'Non-Fixed' || ProductType === 'Per-Pound';
	            var value = !shouldShowValue ? '' : this.props.value;
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                {
	                  onDoubleClick: function onDoubleClick() {
	                    if ((0, _permissions2.default)('change_inventory')) {
	                      _this8.props.zoneLevel(_this8.props.dependentValues);
	                    } else {
	                      alert(_reactReduxI18n.I18n.t('msg_no_permission'));
	                    }
	                  }
	                },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  value
	                )
	              )
	            );
	          }
	        });
	
	        var onRowsSelected = function onRowsSelected(rows) {
	          var newRows = [].concat(_toConsumableArray(_this5.state.rows));
	          var selectedRows = _this5.state.selectedRows;
	
	          newRows.map(function (r) {
	            r.isSelected = false;
	          });
	
	          selectedRows = [];
	          rows.map(function (row) {
	            var index = _.findIndex(_this5.state.rows, { 'ProductNum': row.row.ProductNum });
	            newRows[index].isSelected = true;
	            selectedRows.push(row);
	          });
	
	          _this5.setState({ rows: newRows, selectedRows: selectedRows });
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          var newRows = [].concat(_toConsumableArray(_this5.state.rows));
	          rows.map(function (row) {
	            var index = _.findIndex(_this5.state.rows, { 'ProductNum': row.row.ProductNum });
	            newRows[index].isSelected = false;
	          });
	          var selectedRows = [];
	          newRows.map(function (r) {
	            if (r.isSelected) selectedRows.push(r);
	          });
	          _this5.setState({ rows: newRows, selectedRows: selectedRows });
	        };
	
	        // Discontinued Product Background Color Formatter
	        var DiscontinuedProductCellBackGroundFormatter = function DiscontinuedProductCellBackGroundFormatter(props) {
	          var rowBackground = props.dependentValues.IsDiscontinued ? _constants.BACKGROUND_COLOR.lightGray : '';
	          return _react2.default.createElement(
	            'div',
	            { style: { backgroundColor: rowBackground } },
	            _react2.default.createElement(
	              'span',
	              null,
	              props.value
	            )
	          );
	        };
	
	        // Column difinition
	
	        var columns = [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          sortable: true,
	          width: 70,
	          filterable: true,
	          filterRenderer: _filterByStart2.default,
	          formatter: _react2.default.createElement(
	            ProductIsStopSaleBackGroundFormatter,
	            null,
	            _react2.default.createElement(ProdNumFormatter, { zoneLevel: this.inventoryDetail })
	          ),
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'GeneralNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: isMyuMyu ? "index_no" : "general_no" }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true,
	          filterRenderer: _filterByStart2.default,
	          formatter: DiscontinuedProductCellBackGroundFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'RefNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	          resizable: true,
	          sortable: true,
	          width: 70,
	          filterable: true,
	          filterRenderer: _filterByStart2.default,
	          formatter: _react2.default.createElement(
	            ProductIsStopSaleBackGroundFormatter,
	            null,
	            _react2.default.createElement(DoubleClickFormatter, { zoneLevel: this.inventoryDetail })
	          ),
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	          resizable: true,
	          sortable: true,
	          width: 250,
	          filterable: true,
	          filterRenderer: _filterMultiKeyword2.default,
	          formatter: _react2.default.createElement(
	            ProductIsStopSaleBackGroundFormatter,
	            null,
	            _react2.default.createElement(DoubleClickFormatter, { zoneLevel: this.inventoryDetail })
	          ),
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true,
	          width: 130,
	          filterable: true,
	          formatter: _react2.default.createElement(DoubleClickFormatter, { zoneLevel: this.inventoryDetail }),
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'PackageType',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true,
	          formatter: _react2.default.createElement(DoubleClickFormatter, { zoneLevel: this.inventoryDetail }),
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'PackageSize',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true,
	          formatter: _react2.default.createElement(DoubleClickFormatter, { zoneLevel: this.inventoryDetail }),
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'TotalWeight',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	          resizable: true,
	          sortable: true,
	          width: 70,
	          filterable: true,
	          formatter: _react2.default.createElement(TotalWeightFormatter, { zoneLevel: this.inventoryDetail }),
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'ProductType',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_type' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true,
	          formatter: _react2.default.createElement(DoubleClickFormatter, { zoneLevel: this.inventoryDetail }),
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'PriceLv5',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sale_dollarsign' }),
	          resizable: true,
	          sortable: true,
	          width: 60,
	          filterable: true,
	          formatter: _react2.default.createElement(DoubleClickFormatter, { zoneLevel: this.inventoryDetail, price: true }),
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'InStock',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'stock' }),
	          resizable: true,
	          sortable: true,
	          width: 60,
	          filterable: true,
	          formatter: _react2.default.createElement(DoubleClickFormatter, { zoneLevel: this.inventoryDetail }),
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'PreSale',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'presale' }),
	          resizable: true,
	          sortable: true,
	          width: 75,
	          filterable: true,
	          formatter: _react2.default.createElement(DoubleClickFormatter, { zoneLevel: this.inventoryDetail }),
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'Purchased',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchased' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true,
	          formatter: _react2.default.createElement(DoubleClickFormatter, { zoneLevel: this.inventoryDetail }),
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'InventoryPrice',
	          name: _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_price' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'asteriksReq' },
	              '*'
	            )
	          ),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true,
	          formatter: _react2.default.createElement(DoubleClickFormatter, { zoneLevel: this.inventoryDetail, price: true }),
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'Buyer',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchaser' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true,
	          formatter: _react2.default.createElement(DoubleClickFormatter, { zoneLevel: this.inventoryDetail }),
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }];
	
	        // Dynamically add warehouse columns with instock level
	        var _props5 = this.props,
	            warehouseList = _props5.warehouseList,
	            warehouse = _props5.warehouse;
	
	        if (warehouseList && warehouse) {
	          if (warehouse.value && warehouse.value === -1) {
	            columns.push({
	              key: 'Markup',
	              name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'avg_markup_percentsign' }),
	              resizable: true,
	              sortable: true,
	              width: 100,
	              filterable: true,
	              formatter: _react2.default.createElement(DoubleClickFormatter, { zoneLevel: this.inventoryDetail }),
	              getRowMetaData: function getRowMetaData(row) {
	                return row;
	              }
	            });
	            warehouseList.map(function (item) {
	              columns.push({
	                key: 'Warehouse_' + item.Warehouse_id,
	                name: item.Name,
	                resizable: true,
	                sortable: true,
	                width: 130,
	                filterable: true,
	                formatter: _react2.default.createElement(DoubleClickFormatter, { zoneLevel: _this5.inventoryDetail }),
	                getRowMetaData: function getRowMetaData(row) {
	                  return row;
	                }
	              });
	            });
	          } else if (warehouse.value && warehouse.value !== -1) {
	            // columns.push({
	            //   // key: 'Default_WarehouseZone_Name',
	            //   key: 'Zone', // fake zone, will need to change back to Default_WarehouseZone_Name
	            //   name: <Translate value="zone" />,
	            //   resizable: true,
	            //   sortable: true,
	            //   width: 60,
	            //   filterable: true,
	            //   formatter: <DoubleClickFormatter zoneLevel={this.inventoryDetail} />,
	            //   getRowMetaData: (row) => row
	            // });
	            // columns.push({
	            //   // key: 'Default_WarehouseBin_Name',
	            //   key: 'Bin', // fake Bin, will need to change back to Default_WarehouseBin_Name
	            //   name: <Translate value="bin" />,
	            //   resizable: true,
	            //   sortable: true,
	            //   width: 60,
	            //   filterable: true,
	            //   formatter: <DoubleClickFormatter zoneLevel={this.inventoryDetail} />,
	            //   getRowMetaData: (row) => row
	            // });
	            columns.push({
	              // key: 'Default_WarehouseBin_Name',
	              key: 'Location', // fake Bin, will need to change back to Default_WarehouseBin_Name
	              name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' }),
	              resizable: true,
	              sortable: true,
	              width: 100,
	              filterable: true,
	              formatter: _react2.default.createElement(DoubleClickFormatter, { zoneLevel: this.inventoryDetail }),
	              getRowMetaData: function getRowMetaData(row) {
	                return row;
	              }
	            });
	          }
	        }
	
	        return (
	          //React Table Inventory List
	          _react2.default.createElement(
	            'div',
	            { className: 'react-table-customizer', id: 'react_table_inventory' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowRenderer: _react2.default.createElement(RowRenderer, {
	                onDoubleClick: function onDoubleClick(data) {
	                  if ((0, _permissions2.default)('change_inventory')) {
	                    _this5.inventoryDetail(data);
	                  } else {
	                    alert(_reactReduxI18n.I18n.t('msg_no_permission'));
	                  }
	                }
	              }),
	              rowKey: 'id',
	              enableCellSelect: true,
	              rowHeight: 25,
	              headerRowHeight: 45,
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              getValidFilterValues: getValidFilterValues,
	              onClearFilters: onClearFilters,
	              columns: columns,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: this.state.tableHeight,
	              enableRowSelect: 'single',
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              }
	            })
	          )
	        );
	      }
	    }
	  }, {
	    key: 'handleClickCategory',
	    value: function handleClickCategory(id) {
	      var _props6 = this.props,
	          f = _props6.fromDate,
	          t = _props6.toDate;
	      var periodRadios = this.props.periodRadios;
	
	      var _getFormattedDatesFro4 = this.getFormattedDatesFromPeriod(periodRadios, { fromDate: f, toDate: t }),
	          fromDate = _getFormattedDatesFro4.fromDate,
	          toDate = _getFormattedDatesFro4.toDate;
	
	      var warehouse = this.getWarehouseQueryLine();
	      // periodRadios = '/' + this.props.periodRadios;
	      // if(this.props.periodRadios == '-1')
	      //   periodRadios = '';
	      this.props.fetchInventoriesByPeriod(this.props.typeRadios, 'ProductNum__ProductCategory1_id=' + id, fromDate, toDate, warehouse);
	      this.setState({ currentCategory: id });
	    }
	  }, {
	    key: 'renderCategories',
	    value: function renderCategories(group_id) {
	      var _this9 = this;
	
	      if (!this.props.groupCategories) return;
	      var groupCategories = this.props.groupCategories;
	      var description = void 0;
	      if (localStorage.getItem('lang') == 'ch') {
	        description = 'Description';
	      } else if (localStorage.getItem('lang') == 'en') {
	        description = 'Name';
	      }
	      if (this.state.currentGroup == group_id && this.state.groupExpanded) return groupCategories.map(function (category) {
	        return _react2.default.createElement(
	          'li',
	          { className: 'clickListLi', style: { color: _constants.APP_COLORS['sub-category-nav'], fontFamily: 'Arial' }, name: 'category', id: 'c' + category.ProductCategory_id, onClick: _this9.handleClickCategory.bind(_this9, category.ProductCategory_id) },
	          _react2.default.createElement(
	            'label',
	            { style: { fontWeight: 'bold' } },
	            category.CategoryNum
	          ),
	          ' ' + category[description]
	        );
	      });else return;
	    }
	  }, {
	    key: 'handleClickGroup',
	    value: function handleClickGroup(group, id) {
	      var groupExpanded = this.state.groupExpanded;
	      var _props7 = this.props,
	          f = _props7.fromDate,
	          t = _props7.toDate;
	      var periodRadios = this.props.periodRadios;
	
	      var _getFormattedDatesFro5 = this.getFormattedDatesFromPeriod(periodRadios, { fromDate: f, toDate: t }),
	          fromDate = _getFormattedDatesFro5.fromDate,
	          toDate = _getFormattedDatesFro5.toDate;
	
	      var warehouse = this.getWarehouseQueryLine();
	      // periodRadios = '/' + this.props.periodRadios;
	      // if(this.props.periodRadios == '-1')
	      //   periodRadios = '';
	      if (group && this.state.currentGroup == group.ProductGroup_id) {
	        this.setState({ groupExpanded: !groupExpanded });
	        if (!groupExpanded) {
	          this.setState({ currentCategory: -1 });
	          this.props.fetchInventoriesByPeriod(this.props.typeRadios, 'ProductNum__ProductGroup_id=' + group.ProductGroup_id, fromDate, toDate, warehouse);
	          this.props.fetchGroupCategories(group.ProductGroup_id);
	        }
	      } else if (group) {
	        this.setState({ currentGroup: group.ProductGroup_id, groupExpanded: true, currentCategory: -1 });
	        this.props.fetchInventoriesByPeriod(this.props.typeRadios, 'ProductNum__ProductGroup_id=' + group.ProductGroup_id, fromDate, toDate, warehouse);
	        this.props.fetchGroupCategories(group.ProductGroup_id);
	      } else {
	        this.setState({ currentGroup: -1, currentCategory: -1 });
	        this.props.fetchInventoriesByPeriod(this.props.typeRadios, '', fromDate, toDate, warehouse);
	      }
	    }
	  }, {
	    key: 'renderGroups',
	    value: function renderGroups() {
	      var _this10 = this;
	
	      if (!this.props.groups) return;
	      var groups = this.props.groups;
	      return groups.map(function (group) {
	        var GroupNum = parseInt(group.GroupNum);
	        if (GroupNum < 10) GroupNum = '0' + GroupNum;
	        var description = void 0;
	        if (localStorage.getItem('lang') == 'ch') {
	          description = 'Description';
	        } else if (localStorage.getItem('lang') == 'en') {
	          description = 'Name';
	        }
	        return _react2.default.createElement(
	          _reactBootstrap.Panel,
	          { className: 'panelStyle' },
	          _react2.default.createElement(
	            'div',
	            { style: { color: _constants.APP_COLORS['category-nav'], fontFamily: 'Arial Black', cursor: 'pointer' }, name: 'group', id: 'g' + group.ProductGroup_id, onClick: _this10.handleClickGroup.bind(_this10, group, 'g' + group.ProductGroup_id) },
	            _react2.default.createElement(
	              'label',
	              { style: { fontWeight: 'bold' } },
	              GroupNum
	            ),
	            ' ',
	            ' ' + group[description]
	          ),
	          _this10.renderCategories(group.ProductGroup_id)
	        );
	      });
	    }
	  }, {
	    key: 'renderPeriods',
	    value: function renderPeriods() {
	      if (this.props.typeRadios == 'Inactive' || this.props.typeRadios == 'Active') {
	        return _react2.default.createElement(_reduxForm.Field, { name: 'periodRadios', component: renderPeriodRadios, typeRadios: this.props.typeRadios });
	      }
	    }
	  }, {
	    key: 'renderPrint',
	    value: function renderPrint() {
	      var type = this.props.typeRadios;
	      var division = '';
	      if (this.state.currentCategory == -1 && this.state.currentGroup == -1) {
	        division = '';
	      } else if (this.state.currentCategory && this.state.currentCategory != -1) {
	        division = 'ProductNum__ProductCategory1_id=' + this.state.currentCategory;
	      } else if (this.state.currentGroup && this.state.currentGroup != -1) {
	        division = 'ProductNum__ProductGroup_id=' + this.state.currentGroup;
	      }
	
	      var _props8 = this.props,
	          f = _props8.fromDate,
	          t = _props8.toDate;
	      var periodRadios = this.props.periodRadios;
	
	      var _getFormattedDatesFro6 = this.getFormattedDatesFromPeriod(periodRadios, { fromDate: f, toDate: t }),
	          fromDate = _getFormattedDatesFro6.fromDate,
	          toDate = _getFormattedDatesFro6.toDate;
	
	      var warehouse = this.getWarehouseQueryLine();
	      var warehouseQuery = warehouse !== '' ? '&' + warehouse : '';
	      // periodRadios = '';
	      // if(this.props.periodRadios != '-1') {
	      //   periodRadios = '/' + this.props.periodRadios;
	      // }
	      var dates = (0, _cleanDates.toFromDates)(-1, fromDate, toDate);
	      var token = localStorage.getItem('token');
	      var url = void 0;
	      if (type !== 'Inactive' && type !== 'Active') {
	        if (division === '') {
	          url = '' + _url.DETAILED_INVENTORIES_URL + type + '/export?Bearer=' + token + warehouseQuery;
	        } else {
	          url = '' + _url.DETAILED_INVENTORIES_URL + type + '/export?' + division + warehouseQuery + '&Bearer=' + token;
	        }
	      } else {
	        if (division === '') {
	          url = '' + _url.DETAILED_INVENTORIES_URL + type + '/export?startdate=' + dates.fromDate + '&enddate=' + dates.toDate + warehouseQuery + '&Bearer=' + token;
	        } else {
	          url = '' + _url.DETAILED_INVENTORIES_URL + type + '/export?' + division + '&startdate=' + dates.fromDate + '&enddate=' + dates.toDate + warehouseQuery + '&Bearer=' + token;
	        }
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          href: (0, _permissions2.default)('export_inventory') && url,
	          onClick: function onClick(event) {
	            if ((0, _permissions2.default)('export_inventory')) {
	              event.persist();
	            } else {
	              alert(_reactReduxI18n.I18n.t('msg_no_permission'));
	            }
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	      );
	    }
	  }, {
	    key: 'renderWarehouseList',
	    value: function renderWarehouseList() {
	      // If group is loading, show a spinner.
	      if (this.props.warehouseListIsLoading && !this.props.fetchWarehousesError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.fetchWarehousesError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_cannot_be_loaded' })
	          )
	        );
	      }
	      var options = this.getWarehouseList();
	      // console.log('renderWarehouseList', options, defaultWarehouse);
	      return _react2.default.createElement(_reduxForm.Field, { name: 'Warehouse', component: _selection.SelectionWithProps, options: options, onChange: this.handleWarehouseOnChange });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory' })
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { fluid: 'true', id: 'inventory-page' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { id: 'date-range-picker', className: 'form-horizontal' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 1 },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'filter-title' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_condition' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'colon' },
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 4 },
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'typeRadios', component: renderRedesignRadiosRowOne })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'typeRadios', component: renderRedesignRadiosRowTwo })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 1 },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'filter-title' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_date' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'colon' },
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 5 },
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'periodRadios', component: renderRedesignDateRadiosOne, typeRadios: this.props.typeRadios })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'periodRadios', component: renderRedesignDateRadiosTwo, typeRadios: this.props.typeRadios, Days: this.props.periodRadios })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 2, className: 'product-categories-nav' },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { id: 'category-nav', className: 'panelStyle', style: { maxHeight: this.state.tableHeight + 71, overflowY: 'scroll', width: '100%' } },
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { className: 'panelStyle' },
	                    _react2.default.createElement(
	                      'div',
	                      { style: { color: _constants.APP_COLORS['category-nav'], fontWeight: 'bold', cursor: 'pointer' }, name: 'group', id: 'g-1', onClick: this.handleClickGroup.bind(this, null, '-1') },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' })
	                    )
	                  ),
	                  this.renderGroups()
	                )
	              ),
	              ' ',
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 10 },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { md: 12 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Panel,
	                      { className: 'position-relative', id: 'table-panel' },
	                      _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        { className: 'table-buttons' },
	                        this.renderPrint()
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'table-filters', style: { zIndex: 1 } },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'control-label' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'control-dropdown' },
	                          this.renderWarehouseList()
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 4 },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'total-inventory-price inventory-notes' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'total-inventory-price-label' },
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_inventory_price' }),
	                              ':\xA0'
	                            ),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'font-color-orange' },
	                              '$' + (0, _numberWithCommas.numberWithCommas)((this.state.totalInventoryPrice || 0).toFixed(2))
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 3 },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'inventory-notes' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'pull-right' },
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_inventory_price_equation' })
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { sm: 12 },
	                          this.renderTable()
	                        )
	                      )
	                    )
	                  )
	                ),
	                ' '
	              ),
	              ' '
	            ),
	            ' '
	          )
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return Inventories;
	}(_react.Component);
	
	Inventories.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	var renderTypeRadios = function renderTypeRadios(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group col-md-12' },
	    _react2.default.createElement(
	      _reactBootstrap.Row,
	      null,
	      _react2.default.createElement(
	        'label',
	        { className: 'col-sm-4' },
	        _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'All',
	          checked: props.input.value === 'All' })),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' })
	      ),
	      _react2.default.createElement(
	        'label',
	        { className: 'col-sm-4' },
	        _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'InStock',
	          checked: props.input.value === 'InStock' })),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'in_stock' })
	      ),
	      _react2.default.createElement(
	        'label',
	        { className: 'col-sm-4' },
	        _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'Inactive',
	          checked: props.input.value === 'Inactive' })),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'in_stock_inactive' })
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Row,
	      null,
	      _react2.default.createElement(
	        'label',
	        { className: 'col-sm-4' },
	        _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'NonZero',
	          checked: props.input.value === 'NonZero' })),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'non_zero' })
	      ),
	      _react2.default.createElement(
	        'label',
	        { className: 'col-sm-4' },
	        _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'OutStock',
	          checked: props.input.value === 'OutStock' })),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'out_of_stock' })
	      ),
	      _react2.default.createElement(
	        'label',
	        { className: 'col-sm-4' },
	        _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'Active',
	          checked: props.input.value === 'Active' })),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'out_of_stock_active' })
	      )
	    )
	  );
	};
	
	var renderPeriodRadios = function renderPeriodRadios(props) {
	  var titleClass = (0, _classnames2.default)({ 'col-md-offset-1': props.typeRadios === 'Inactive' }, { 'col-md-offset-1': props.typeRadios === 'Active' }, 'col-md-1');
	  var renderDatePickers = function renderDatePickers(value) {
	    if (value === '-1') return _react2.default.createElement(
	      'div',
	      { className: 'form-group date-picker-positioner' },
	      _react2.default.createElement(
	        'label',
	        { className: 'col-md-1 from-label col-md-offset-4' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'from' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-1 control-date-picker' },
	        _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', component: _datePicker.DatePicker })
	      ),
	      _react2.default.createElement(
	        'label',
	        { className: 'col-md-1 to-label' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'to' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-1 control-date-picker' },
	        _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', component: _datePicker.DatePicker })
	      )
	    );else {
	      return;
	    }
	  };
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactBootstrap.Row,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          'label',
	          { className: titleClass },
	          _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: '7',
	            checked: props.input.value === '7' })),
	          '7 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        ),
	        _react2.default.createElement(
	          'label',
	          { className: 'col-md-1' },
	          _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: '30',
	            checked: props.input.value === '30' })),
	          '30 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        ),
	        _react2.default.createElement(
	          'label',
	          { className: 'col-md-1' },
	          _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: '90',
	            checked: props.input.value === '90' })),
	          '90 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        ),
	        _react2.default.createElement(
	          'label',
	          { className: 'col-md-1' },
	          _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: '-1',
	            checked: props.input.value === '-1' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date_range' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Row,
	      null,
	      renderDatePickers(props.input.value)
	    )
	  );
	};
	
	var getBsStyle = function getBsStyle(input, value) {
	  return input == value ? 'success' : 'primary';
	};
	
	var renderRedesignRadiosRowOne = function renderRedesignRadiosRowOne(props) {
	  var titleClass = (0, _classnames2.default)({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'col-xs-2');
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'All') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'all-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'all-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'All', checked: props.input.value === 'All' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'InStock') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'all-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'all-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'InStock', checked: props.input.value === 'InStock' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'in_stock' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'Inactive'), className: 'radio-button-long' },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio', style: { width: '150px' } },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'all-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'all-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'Inactive', checked: props.input.value === 'Inactive' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'in_stock_inactive' })
	        )
	      )
	    )
	  );
	};
	
	var renderRedesignRadiosRowTwo = function renderRedesignRadiosRowTwo(props) {
	  var titleClass = (0, _classnames2.default)({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'col-xs-2');
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'NonZero') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'all-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'all-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'NonZero', checked: props.input.value === 'NonZero' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'non_zero' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'OutStock') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'all-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'all-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'OutStock', checked: props.input.value === 'OutStock' })),
	          _react2.default.createElement(
	            'span',
	            { style: { left: '15px' } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'out_of_stock' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'Active'), className: 'radio-button-long' },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio', style: { width: '150px' } },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'all-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'all-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'Active', checked: props.input.value === 'Active' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'out_of_stock_active' })
	        )
	      )
	    )
	  );
	};
	
	var renderRedesignDateRadiosOne = function renderRedesignDateRadiosOne(props) {
	  var titleClass = (0, _classnames2.default)({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'col-xs-2');
	  var buttonShouldDisable = props.typeRadios !== 'Inactive' && props.typeRadios !== 'Active';
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '1'), disabled: buttonShouldDisable },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'all-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'all-radio-filter',
	            type: 'radio',
	            name: 'dateRangeFilterRadios',
	            value: '1',
	            checked: props.input.value === '1',
	            disabled: buttonShouldDisable
	          })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'today' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '2'), disabled: buttonShouldDisable },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'all-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'all-radio-filter',
	            type: 'radio',
	            name: 'dateRangeFilterRadios',
	            value: '2',
	            checked: props.input.value === '2',
	            disabled: buttonShouldDisable
	          })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yesterday' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '7'), disabled: buttonShouldDisable },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'all-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'all-radio-filter',
	            type: 'radio',
	            name: 'dateRangeFilterRadios',
	            value: '7',
	            checked: props.input.value === '7',
	            disabled: buttonShouldDisable
	          })),
	          '7 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '30'), disabled: buttonShouldDisable },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'all-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'all-radio-filter',
	            type: 'radio',
	            name: 'dateRangeFilterRadios',
	            value: '30',
	            checked: props.input.value === '30',
	            disabled: buttonShouldDisable
	          })),
	          '30 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    )
	  );
	};
	
	var renderRedesignDateRadiosTwo = function renderRedesignDateRadiosTwo(props) {
	  console.log('props you are looking for', props);
	  var titleClass = (0, _classnames2.default)({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'col-xs-2');
	  var buttonShouldDisable = props.typeRadios !== 'Inactive' && props.typeRadios !== 'Active';
	  var renderStartDatePicker = function renderStartDatePicker(days) {
	    if (!buttonShouldDisable && days == -1) {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: 'primary' },
	        _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', placeholder: 'Start', component: _datePicker.DatePicker })
	      );
	    }
	    return _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: 'primary', disabled: buttonShouldDisable },
	      _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', placeholder: 'Start', component: _datePicker.DisabledDatePicker })
	    );
	  };
	  var renderEndDatePicker = function renderEndDatePicker(days) {
	    if (!buttonShouldDisable && days == -1) {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: 'primary' },
	        _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', placeholder: 'End', component: _datePicker.DatePicker })
	      );
	    }
	    return _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: 'primary', disabled: buttonShouldDisable },
	      _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', placeholder: 'End', component: _datePicker.DisabledDatePicker })
	    );
	  };
	
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '-1'), disabled: buttonShouldDisable },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'dateRange-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'dateRange-radio-filter',
	            type: 'radio',
	            name: 'dateFilterRadios',
	            value: '-1',
	            checked: props.input.value === '-1',
	            disabled: buttonShouldDisable
	          })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date_range' })
	        )
	      )
	    ),
	    renderStartDatePicker(props.Days),
	    renderEndDatePicker(props.Days)
	  );
	};
	
	var _default = Inventories;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isMyuMyu, 'isMyuMyu', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventories.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventories.jsx');
	
	  __REACT_HOT_LOADER__.register(Inventories, 'Inventories', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventories.jsx');
	
	  __REACT_HOT_LOADER__.register(renderTypeRadios, 'renderTypeRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventories.jsx');
	
	  __REACT_HOT_LOADER__.register(renderPeriodRadios, 'renderPeriodRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventories.jsx');
	
	  __REACT_HOT_LOADER__.register(getBsStyle, 'getBsStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventories.jsx');
	
	  __REACT_HOT_LOADER__.register(renderRedesignRadiosRowOne, 'renderRedesignRadiosRowOne', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventories.jsx');
	
	  __REACT_HOT_LOADER__.register(renderRedesignRadiosRowTwo, 'renderRedesignRadiosRowTwo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventories.jsx');
	
	  __REACT_HOT_LOADER__.register(renderRedesignDateRadiosOne, 'renderRedesignDateRadiosOne', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventories.jsx');
	
	  __REACT_HOT_LOADER__.register(renderRedesignDateRadiosTwo, 'renderRedesignDateRadiosTwo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventories.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventories.jsx');
	}();

	;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _datePicker = __webpack_require__(27);
	
	var _datePicker2 = _interopRequireDefault(_datePicker);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style'
	
	var InventoryAdjustmentForm = function (_Component) {
	    _inherits(InventoryAdjustmentForm, _Component);
	
	    function InventoryAdjustmentForm() {
	        _classCallCheck(this, InventoryAdjustmentForm);
	
	        var _this = _possibleConstructorReturn(this, (InventoryAdjustmentForm.__proto__ || Object.getPrototypeOf(InventoryAdjustmentForm)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	            adjustment_id: 0,
	
	            inventories: {
	                rows: [],
	                selectedRows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            adjustedInventories: {
	                rows: [],
	                selectedRows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            }
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        return _this;
	    }
	
	    _createClass(InventoryAdjustmentForm, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            window.addEventListener('resize', this.handleResize);
	            var currentInventoryAdjustment = this.props.currentInventoryAdjustment;
	
	            if (currentInventoryAdjustment) {
	                this.props.fetchInventoryAdjustmentDetail(currentInventoryAdjustment.WarehouseAdjustment_id).then(function () {
	                    _this2.props.fetchInventories();
	                });
	            }
	            this.props.fetchInventories();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once inventories are ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.currentInventoryAdjustmentDetail && nextProps.currentInventoryAdjustmentDetail != this.props.currentInventoryAdjustmentDetail) {
	                var adjustment_id = 0;
	                var warehouse_Adjustment_Line = nextProps.currentInventoryAdjustmentDetail.Warehouse_Adjustment_Line;
	                warehouse_Adjustment_Line.map(function (adjustmentLine) {
	                    adjustmentLine["adjustment_id"] = adjustment_id;
	                    adjustment_id = adjustment_id + 1;
	                    adjustmentLine.ZoneName = adjustmentLine.WarehouseZone_id.Name;
	                    adjustmentLine.BinName = adjustmentLine.WarehouseBin_id.Name;
	                });
	                var adjustedInventories = _extends({}, this.state.adjustedInventories, { rows: warehouse_Adjustment_Line });
	
	                this.setState({ adjustedInventories: adjustedInventories, adjustment_id: adjustment_id });
	            }
	            if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
	                var newInventories = [];
	                newInventories = nextProps.inventories;
	                var inventories = _extends({}, this.state.inventories, { rows: newInventories });
	                this.setState({
	                    inventories: inventories
	                });
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	        }
	    }, {
	        key: 'setInventoryToAdjust',
	        value: function setInventoryToAdjust(e) {
	            e.preventDefault();
	            var _state = this.state,
	                inventories = _state.inventories,
	                adjustedInventories = _state.adjustedInventories;
	
	            var adjustment_id = this.state.adjustment_id;
	            var inventoryToLocate = _extends({}, inventories.selectedRows[0], {
	                ToZone: this.props.toZoneValue,
	                ToBin: this.props.toBinValue,
	                Quantity: this.props.quantityValue,
	                adjustment_id: adjustment_id,
	                isSelected: false
	                // newQuantity: inventories.selectedRows[0].Quantity + this.props.quantityValue
	                // NewQuantity: this.props.quantityValue
	            });
	            adjustment_id = adjustment_id + 1;
	            var newAdjustedInventories = _extends({}, adjustedInventories);
	            var newInventories = _extends({}, inventories);
	            newAdjustedInventories.rows.push(inventoryToLocate);
	
	            // const index = _.findIndex(inventories.rows, { 'Vendor_id': inventories.selectedRows[0].Vendor_id });
	            // if (index > -1) {
	            //     newInventories.rows.splice(index, 1);
	            // }
	            // newInventories.selectedRows = [];
	            this.setState({
	                adjustedInventories: newAdjustedInventories,
	                adjustment_id: adjustment_id
	            });
	        }
	    }, {
	        key: 'cancelInventoryAdjustment',
	        value: function cancelInventoryAdjustment(e) {
	            e.preventDefault();
	            var _state2 = this.state,
	                inventories = _state2.inventories,
	                adjustedInventories = _state2.adjustedInventories;
	            // const inventoryToCancel = { ...adjustedInventories.selectedRows[0] };
	
	            var newAdjustedInventoriesRows = [].concat(_toConsumableArray(adjustedInventories.rows));
	            // const newInventories = { ...inventories };
	            // newInventories.rows.push(inventoryToCancel)
	
	            newAdjustedInventoriesRows = newAdjustedInventoriesRows.filter(function (obj) {
	                return obj.isSelected == false || obj.isSelected == null;
	            });
	
	            var newAdjustedInventories = _extends({}, adjustedInventories, { rows: newAdjustedInventoriesRows });
	            // newAdjustedInventories.selectedRows = [];
	            this.setState({
	                adjustedInventories: newAdjustedInventories
	            });
	        }
	    }, {
	        key: 'createAdjustment',
	        value: function createAdjustment(e) {
	            e.preventDefault();
	            if (this.props.currentInventoryAdjustmentDetail) {
	                if (!this.checkPermission("change_warehouse_adjustment")) this.props.editInventoryAdjustment(this.props.currentInventoryAdjustmentDetail.WarehouseAdjustment_id, 1, this.props.postingDate, this.props.note, _reactDataGridAddons.Data.Selectors.getRows(this.state.adjustedInventories));else alert("You have no permission!");
	            } else this.props.createInventoryAdjustment(1, this.props.postingDate, this.props.note, _reactDataGridAddons.Data.Selectors.getRows(this.state.adjustedInventories));
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this3 = this;
	
	            if (this.props.vendorIsLoading && !this.props.vendorError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.vendorError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    this.props.vendorError
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.inventories);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var inventories = _extends({}, _this3.state.inventories, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this3.setState({ inventories: inventories });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this3.state.inventories.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var inventories = _extends({}, _this3.state.inventories, { filters: newFilters });
	                    _this3.setState({ inventories: inventories });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var inventories = _extends({}, _this3.state.inventories, { selectedRows: rows });
	                    _this3.setState({ inventories: inventories });
	                };
	
	                //Custom Formatter component
	
	                var NameFormatter = _react2.default.createClass({
	                    displayName: 'NameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'ProductDescription',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'ProductUnitOfMeasure',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_of_measure' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'Pallet',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'BinAmount',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin_amount' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'ZoneName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_name' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'BinName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin_name' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'Batch_PONum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'ExpiredDate',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'expired_date' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    formatter: DateFormatter
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'InventoryAdjustmentForm-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'id',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: 200,
	                                enableRowSelect: 'single',
	                                onRowUpdated: this.handleRowUpdated,
	                                onRowSelect: onRowSelect })
	                        )
	                    )
	                );
	            }
	        }
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderAdjustedTable',
	        value: function renderAdjustedTable() {
	            var _this4 = this;
	
	            if (this.props.vendorIsLoading && !this.props.vendorError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.vendorError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    this.props.vendorError
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.adjustedInventories);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var adjustedInventories = _extends({}, _this4.state.adjustedInventories, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this4.setState({ adjustedInventories: adjustedInventories });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this4.state.adjustedInventories.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var adjustedInventories = _extends({}, _this4.state.adjustedInventories, { filters: newFilters });
	                    _this4.setState({ adjustedInventories: adjustedInventories });
	                };
	
	                // Handle the Dragable cell function
	
	                var handleCellDrag = function handleCellDrag(e) {
	                    var adjustedInventories = _this4.state.adjustedInventories;
	
	                    var rows = adjustedInventories.rows.slice(0);
	                    for (var i = e.fromRow; i <= e.toRow; i++) {
	                        var rowToUpdate = rows[i];
	                        rowToUpdate[e.cellKey] = e.value;
	                    }
	                    var newAdjustedInventories = _extends({}, adjustedInventories, { rows: rows });
	                    _this4.setState({
	                        adjustedInventories: newAdjustedInventories
	                    });
	                };
	
	                // Handle the editable function
	
	                var handleRowUpdated = function handleRowUpdated(e) {
	                    // merge updated row with current row and rerender by setting state
	                    var adjustedInventories = _this4.state.adjustedInventories;
	
	                    var rows = getRows();
	                    Object.assign(rows[e.rowIdx], e.updated);
	                    var newAdjustedInventories = _extends({}, adjustedInventories, { rows: rows });
	                    _this4.setState({
	                        adjustedInventories: newAdjustedInventories
	                    });
	                };
	
	                // Handle the row select function
	
	                // const onRowSelect = rows => {
	                //     const adjustedInventories = {...this.state.adjustedInventories, selectedRows: rows };
	                //     this.setState({ adjustedInventories: adjustedInventories });
	                // }
	
	                var onRowsSelected = function onRowsSelected(rows) {
	                    var newRows = _this4.state.adjustedInventories.rows;
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = true;
	                    });
	                    var adjustedInventories = _extends({}, _this4.state.adjustedInventories, { rows: newRows });
	                    _this4.setState({ adjustedInventories: adjustedInventories });
	                };
	
	                var onRowsDeselected = function onRowsDeselected(rows) {
	                    var newRows = _this4.state.adjustedInventories.rows;
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = false;
	                    });
	                    // var rowIndexes = rows.map(r => r.rowIdx);
	                    var adjustedInventories = _extends({}, _this4.state.adjustedInventories, { rows: newRows });
	                    _this4.setState({ adjustedInventories: adjustedInventories });
	                };
	
	                //Custom Formatter component
	
	                var NameFormatter = _react2.default.createClass({
	                    displayName: 'NameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'Quantity',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'adjustment_quantity' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    editable: true
	                }, {
	                    key: 'ZoneName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_name' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    editable: true
	                }, {
	                    key: 'BinName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin_name' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    editable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'InventoryAdjustmentForm-dataGrid2' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'adjustment_id',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: 200,
	                                enableRowSelect: 'single',
	                                onCellsDragged: handleCellDrag,
	                                enableCellSelect: true,
	                                onRowUpdated: handleRowUpdated,
	                                rowSelection: {
	                                    showCheckbox: true,
	                                    enableShiftSelect: true,
	                                    onRowsSelected: onRowsSelected,
	                                    onRowsDeselected: onRowsDeselected,
	                                    selectBy: {
	                                        isSelectedKey: 'isSelected'
	                                    }
	                                }
	
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'checkPermission',
	        value: function checkPermission(permission) {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            var inventoryAdjustmentWarehouseLocation = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_adjust_warehouse_loc' });
	            var inventoryAdjustmentSheetWarehouseLoc = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_adjust_sheet_warehouse_loc' });
	            var _state3 = this.state,
	                inventories = _state3.inventories,
	                adjustedInventories = _state3.adjustedInventories;
	
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content-heading' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_adjustment' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/inventories/adjustment', className: 'btn btn-green buttonStyle' },
	                            _react2.default.createElement('em', { className: 'fa fa-mail-reply' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'pull-right' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: 'btn btn-primary buttonStyle',
	                                    onClick: function onClick(e) {
	                                        return _this5.createAdjustment(e);
	                                    } },
	                                _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'marginTopStyle' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { header: inventoryAdjustmentWarehouseLocation },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_inventory' })
	                            ),
	                            _react2.default.createElement('hr', null),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_select_an_inventory_to_adjust' })
	                            ),
	                            this.renderTable(),
	                            _react2.default.createElement(
	                                'h4',
	                                { className: 'marginTopStyleLarge' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'adjustment' })
	                            ),
	                            _react2.default.createElement('hr', null),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'adjust_some_or_all_of_the_selected_inventory' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 6 },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            inventories.selectedRows[0] ? inventories.selectedRows[0].ProductNum : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_inventory' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            inventories.selectedRows[0] ? inventories.selectedRows[0].ProductName : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_inventory' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_type' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            inventories.selectedRows[0] ? inventories.selectedRows[0].ProductUnitOfMeasure : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_inventory' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	                                                ' (',
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' }),
	                                                ')'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            inventories.selectedRows[0] ? inventories.selectedRows[0].Batch_PONum : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_inventory' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_zone' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            inventories.selectedRows[0] ? inventories.selectedRows[0].ZoneName : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_inventory' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_bin' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            inventories.selectedRows[0] ? inventories.selectedRows[0].BinName : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_inventory' })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 6 },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 12 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'adjustment_quantity' })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 12 },
	                                            _react2.default.createElement(_reduxForm.Field, { component: _inputField2.default, name: 'Quantity' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 12 },
	                                            inventories.selectedRows[0] && parseInt(this.props.quantityValue) > parseInt(inventories.selectedRows[0].CreditStatus) && _react2.default.createElement(
	                                                'p',
	                                                { className: 'parsley-error-message' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_relocation_qty_cannot_exceed_current_qty' })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            className: 'btn btn-primary pull-right',
	                                            onClick: function onClick(e) {
	                                                return _this5.setInventoryToAdjust(e);
	                                            },
	                                            disabled: !inventories.selectedRows[0] },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { header: inventoryAdjustmentSheetWarehouseLoc },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_adjustment_sheet' })
	                            ),
	                            _react2.default.createElement('hr', null),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'list_of_adjustment_lines' })
	                            ),
	                            this.renderAdjustedTable(),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: 'btn btn-warning pull-right marginTopStyle',
	                                    onClick: function onClick(e) {
	                                        return _this5.cancelInventoryAdjustment(e);
	                                    }
	                                },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 7 },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'adjustment_date' }),
	                            ': '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6, className: 'marginBottomStyle' },
	                            _react2.default.createElement(_reduxForm.Field, { component: _datePicker2.default, name: 'PostingDate' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'modifier' }),
	                            ': '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(_reduxForm.Field, { component: _inputField2.default, name: 'Modify_Username' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	                            ': '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'Note', component: 'Textarea', className: 'form-control', style: { minHeight: '100px' } })
	                        )
	                    )
	                ),
	                _react2.default.createElement('br', null)
	            );
	        }
	    }]);
	
	    return InventoryAdjustmentForm;
	}(_react.Component);
	
	InventoryAdjustmentForm.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = InventoryAdjustmentForm;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(InventoryAdjustmentForm, 'InventoryAdjustmentForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryAdjustmentForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryAdjustmentForm.jsx');
	}();

	;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle} from '../Common/style'
	
	var InventoryAdjustments = function (_Component) {
	    _inherits(InventoryAdjustments, _Component);
	
	    function InventoryAdjustments() {
	        _classCallCheck(this, InventoryAdjustments);
	
	        var _this = _possibleConstructorReturn(this, (InventoryAdjustments.__proto__ || Object.getPrototypeOf(InventoryAdjustments)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	            rows: [],
	            selectedRows: null,
	            editedRows: [],
	            filters: {},
	            sortColumn: null,
	            sortDirection: null,
	
	            adjustmentDetail: {
	                rows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            },
	            gourpOpen: false
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        return _this;
	    }
	
	    _createClass(InventoryAdjustments, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchInventoryAdjustments();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once inventoryAdjustments is ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var PT = nextProps.inventoryAdjustments;
	            if (nextProps.inventoryAdjustments && nextProps.inventoryAdjustments != this.props.inventoryAdjustments) {
	                this.setState({
	                    rows: nextProps.inventoryAdjustments
	                });
	            }
	            if (nextProps.adjustmentDetail && nextProps.adjustmentDetail != this.props.adjustmentDetail) {
	                var _adjustmentDetail = _extends({}, this.state.adjustmentDetail, { rows: nextProps.adjustmentDetail.Warehouse_Adjustment_Line });
	                this.setState({ adjustmentDetail: _adjustmentDetail });
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	        }
	
	        // Set inventoryAdjustments being selected to be currentInventoryAdjustment and navigate user to the edit page
	
	    }, {
	        key: 'setCurrentInventoryAdjustment',
	        value: function setCurrentInventoryAdjustment(e) {
	            e.preventDefault();
	            var currentInventoryAdjustment = this.state.selectedRows[0];
	            this.props.resetCurrentInventoryConvert();
	            this.props.selectInventoryAdjustment(currentInventoryAdjustment);
	            this.context.router.push('/inventories/adjustment/' + currentInventoryAdjustment.WarehouseAdjustment_id);
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            this.props.resetCurrentInventoryAdjustment();
	            this.props.resetCurrentInventoryConvert();
	            this.context.router.push('/inventories/adjustment/new');
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this2 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this2.setState(state);
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this2.state.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    _this2.setState({ filters: newFilters });
	                };
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var onRowsSelected = function onRowsSelected(rows) {
	                    var newRows = getRows();
	                    var selectedRows = [newRows[rows[0].rowIdx]];
	                    newRows.map(function (r) {
	                        r.isSelected = false;
	                    });
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = true;
	                    });
	                    _this2.setState({ rows: newRows, selectedRows: selectedRows });
	                };
	                var onRowsDeselected = function onRowsDeselected(rows) {
	                    var rowIndexes = rows.map(function (r) {
	                        return r.rowIdx;
	                    });
	                    var newRows = [].concat(_toConsumableArray(_this2.state.salesOrders.rows));
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = false;
	                    });
	                    _this2.setState({ rows: newRows, selectedRows: selectedRows });
	                };
	
	                var onRowClick = function onRowClick(rowIdx, row) {
	                    if (rowIdx != -1) {
	                        var rows = getRows();
	                        rows.map(function (row) {
	                            row.isSelected = false;
	                        });
	
	                        rows[rowIdx].isSelected = true;
	                        _this2.setState({ rows: rows, selectedRows: [rows[rowIdx]] });
	                        _this2.props.fetchInventoryAdjustmentsDetail(rows[rowIdx].WarehouseAdjustment_id);
	                    }
	                };
	
	                var onCellSelected = function onCellSelected(coordinates) {
	                    var newRows = getRows();
	                    var selectedRows = [newRows[coordinates.rowIdx]];
	                    newRows.map(function (r) {
	                        r.isSelected = false;
	                    });
	                    newRows[coordinates.rowIdx].isSelected = true;
	                    _this2.setState({ rows: newRows, selectedRows: selectedRows });
	                };
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'Modify_Username',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'user' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    width: 100
	                }, {
	                    key: 'PostingDate',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'posting_date' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    formatter: DateFormatter,
	                    width: 120
	                }, {
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    width: 100
	                }, {
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    width: 200
	                }, {
	                    key: 'ProductDescription',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    width: 200
	                }, {
	                    key: 'From',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'from' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    width: 80
	                }, {
	                    key: 'To',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'to' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    width: 80
	                }, {
	                    key: 'WarehouseName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    width: 155
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '100%' }, id: 'InventoryAdjustments-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowHeight: 25,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: 380,
	                                enableRowSelect: 'single',
	                                rowSelection: {
	                                    showCheckbox: true,
	                                    onRowsSelected: onRowsSelected,
	                                    onRowsDeselected: onRowsDeselected,
	                                    selectBy: {
	                                        isSelectedKey: 'isSelected'
	                                    }
	                                },
	                                onRowClick: onRowClick,
	                                onCellSelected: onCellSelected
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderDetailTable',
	        value: function renderDetailTable() {
	            var _this3 = this;
	
	            if (this.props.adjustmentDetailIsLoading && !this.props.adjustmentDetailError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.adjustmentDetailError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.adjustmentDetailError)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.adjustmentDetail);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this3.state.adjustmentDetail, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this3.setState({ adjustmentDetail: adjustmentDetail });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this3.state.adjustmentDetail.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var adjustmentDetail = _extends({}, _this3.state.adjustmentDetail, { filters: newFilters });
	                    _this3.setState({ adjustmentDetail: adjustmentDetail });
	                };
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'Batch_PONum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    width: 100
	                }, {
	                    key: 'From',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'from' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    width: 100
	                }, {
	                    key: 'To',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'to' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    width: 100
	                }, {
	                    key: 'WarehouseZone_Name',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    width: 140
	                }, {
	                    key: 'WarehouseBin_Name',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    width: 100
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '100%' }, id: 'InventoryAdjustments-dataGrid2' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                onGridSort: handleGridSort,
	                                columns: columns,
	                                rowHeight: 25,
	                                minHeight: 250,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize()
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'checkPermission',
	        value: function checkPermission(permission) {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Breadcrumb,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb.Item,
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_management' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb.Item,
	                        { active: 'true' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_adjustments' })
	                    )
	                ),
	                ' ',
	                _react2.default.createElement(
	                    _reactBootstrap.Grid,
	                    { fluid: 'true', id: 'inventory-adjustments' },
	                    _react2.default.createElement(_reactBootstrap.ButtonToolbar, { className: 'table-buttons' }),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        { id: 'inventory-adjustment-full-table' },
	                        this.renderTable()
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        { id: 'inventory-adjustment-details' },
	                        this.renderDetailTable()
	                    )
	                )
	            );
	        }
	    }]);
	
	    return InventoryAdjustments;
	}(_react.Component);
	
	InventoryAdjustments.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = InventoryAdjustments;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(InventoryAdjustments, 'InventoryAdjustments', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryAdjustments.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryAdjustments.jsx');
	}();

	;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _moment3 = __webpack_require__(41);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	__webpack_require__(69);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _datePicker = __webpack_require__(27);
	
	var _datePicker2 = _interopRequireDefault(_datePicker);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style'
	
	(0, _moment4.default)(_moment2.default);
	
	var InventoryConvertForm = function (_Component) {
	    _inherits(InventoryConvertForm, _Component);
	
	    function InventoryConvertForm() {
	        _classCallCheck(this, InventoryConvertForm);
	
	        var _this = _possibleConstructorReturn(this, (InventoryConvertForm.__proto__ || Object.getPrototypeOf(InventoryConvertForm)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	            orderNum: 0,
	
	            inventories: {
	                rows: [],
	                selectedRows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            targetInventories: {
	                rows: [],
	                selectedRows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            convertedInventories: {
	                rows: [],
	                selectedRows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            }
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        return _this;
	    }
	
	    _createClass(InventoryConvertForm, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            window.addEventListener('resize', this.handleResize);
	            var currentInventoryConvert = this.props.currentInventoryConvert;
	
	            if (currentInventoryConvert) {
	                this.props.fetchInventoryConvertDetail(currentInventoryConvert.WarehouseConvert_id).then(function () {
	                    _this2.props.fetchInventories();
	                });
	            } else {
	                this.props.fetchInventories();
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once inventories are ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.currentInventoryConvertDetail && nextProps.currentInventoryConvertDetail != this.props.currentInventoryConvertDetail) {
	                var orderNum = 0;
	                var warehouse_Convert_Line = nextProps.currentInventoryConvertDetail.Warehouse_Convert_Line;
	                warehouse_Convert_Line.map(function (convert) {
	                    orderNum = Math.max(orderNum, convert.Pairid);
	                });
	                orderNum = orderNum + 1;
	                var convertedInventories = _extends({}, this.state.convertedInventories, { rows: nextProps.currentInventoryConvertDetail.Warehouse_Convert_Line });
	                this.setState({ convertedInventories: convertedInventories, orderNum: orderNum });
	            }
	            if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
	                var newInventories = [];
	                newInventories = nextProps.inventories;
	                var inventories = _extends({}, this.state.inventories, { rows: nextProps.inventories });
	                var targetInventories = _extends({}, this.state.targetInventories, { rows: nextProps.inventories });
	                this.setState({
	                    inventories: inventories,
	                    targetInventories: targetInventories
	                });
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	        }
	    }, {
	        key: 'setInventoryToConvert',
	        value: function setInventoryToConvert(e) {
	            e.preventDefault();
	            var _state = this.state,
	                inventories = _state.inventories,
	                targetInventories = _state.targetInventories,
	                convertedInventories = _state.convertedInventories,
	                orderNum = _state.orderNum;
	
	            var inventoryToLocate = _extends({}, inventories.selectedRows[0], {
	                Pairid: orderNum,
	                Quantity: "-" + this.props.quantityValue
	            });
	
	            var inventoryConverted = _extends({}, targetInventories.selectedRows[0], {
	                Pairid: orderNum,
	                Quantity: "+" + this.props.convertedQuantityValue
	            });
	
	            var newConvertedInventoriesRows = [].concat(_toConsumableArray(convertedInventories.rows));
	            var newInventoriesRows = [].concat(_toConsumableArray(inventories.rows));
	            var newTargetInventoriesRows = [].concat(_toConsumableArray(targetInventories.rows));
	
	            newConvertedInventoriesRows.push(inventoryToLocate, inventoryConverted);
	
	            // const index = _.findIndex(newInventoriesRows, { 'id': inventories.selectedRows[0].id });
	            // if (index > -1) {
	            //     newInventoriesRows.splice(index, 1);
	            // }
	            //
	            // const targetIndex = _.findIndex(newTargetInventoriesRows, { 'id': targetInventories.selectedRows[0].id });
	            // if (targetIndex > -1) {
	            //     newTargetInventoriesRows.splice(targetIndex, 1);
	            // }
	
	            var newConvertedInventories = _extends({}, convertedInventories, { rows: newConvertedInventoriesRows });
	            var newInventories = _extends({}, inventories, { rows: newInventoriesRows });
	            var newTargetInventories = _extends({}, targetInventories, { rows: newTargetInventoriesRows });
	
	            // newInventories.selectedRows = [];
	            // newTargetInventories.selectedRows = [];
	
	            this.setState({
	                convertedInventories: newConvertedInventories,
	                inventories: newInventories,
	                targetInventories: newTargetInventories,
	                orderNum: orderNum + 1
	            });
	        }
	    }, {
	        key: 'cancelInventoryConvert',
	        value: function cancelInventoryConvert(e) {
	            e.preventDefault();
	            var _state2 = this.state,
	                inventories = _state2.inventories,
	                targetInventories = _state2.targetInventories,
	                convertedInventories = _state2.convertedInventories;
	
	            var OrderID = convertedInventories.selectedRows[0].Pairid;
	
	            var newConvertedInventoriesRows = [].concat(_toConsumableArray(convertedInventories.rows));
	            // let newInventoriesRows = [ ...inventories.rows ];
	            // let newTargetInventoriesRows = [ ...targetInventories.rows ];
	
	            var index = _lodash2.default.findIndex(newConvertedInventoriesRows, { 'Pairid': OrderID });
	            if (index > -1 && parseInt(newConvertedInventoriesRows[index].Quantity) > 0) {
	                // newTargetInventoriesRows.push({...newConvertedInventoriesRows[index]})
	                newConvertedInventoriesRows.splice(index, 1);
	                index = _lodash2.default.findIndex(newConvertedInventoriesRows, { 'Pairid': OrderID });
	                // newInventoriesRows.push({...newConvertedInventoriesRows[index]})
	                newConvertedInventoriesRows.splice(index, 1);
	            } else if (index > -1) {
	                // newInventoriesRows.push({...newConvertedInventoriesRows[index]})
	                newConvertedInventoriesRows.splice(index, 1);
	                index = _lodash2.default.findIndex(newConvertedInventoriesRows, { 'Pairid': OrderID });
	                // newTargetInventoriesRows.push({...newConvertedInventoriesRows[index]})
	                newConvertedInventoriesRows.splice(index, 1);
	            }
	
	            var newConvertedInventories = _extends({}, convertedInventories, { rows: newConvertedInventoriesRows });
	            // let newInventories = { ...inventories, rows: newInventoriesRows };
	            // let newTargetInventories = { ...targetInventories, rows: newTargetInventoriesRows };
	
	            newConvertedInventories.selectedRows = [];
	
	            this.setState({
	                convertedInventories: newConvertedInventories
	            });
	        }
	    }, {
	        key: 'createConvert',
	        value: function createConvert(e) {
	            e.preventDefault();
	            if (this.props.currentInventoryConvertDetail) {
	                if (!this.checkPermission("change_warehouse_convert")) this.props.editInventoryConvert(this.props.currentInventoryConvertDetail.WarehouseConvert_id, 1, this.props.postingDate, this.props.note, this.props.processingFee, _reactDataGridAddons.Data.Selectors.getRows(this.state.convertedInventories));else alert("You have no permission!");
	            } else this.props.createInventoryConvert(1, this.props.postingDate, this.props.note, this.props.processingFee, _reactDataGridAddons.Data.Selectors.getRows(this.state.convertedInventories));
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this3 = this;
	
	            if (this.props.vendorIsLoading && !this.props.vendorError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.vendorError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    this.props.vendorError
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.inventories);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var inventories = _extends({}, _this3.state.inventories, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this3.setState({ inventories: inventories });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this3.state.inventories.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var inventories = _extends({}, _this3.state.inventories, { filters: newFilters });
	                    _this3.setState({ inventories: inventories });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var inventories = _extends({}, _this3.state.inventories, { selectedRows: rows });
	                    _this3.setState({ inventories: inventories });
	                };
	
	                //Custom Formatter component
	
	                var NameFormatter = _react2.default.createClass({
	                    displayName: 'NameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 90,
	                    filterable: true
	                }, {
	                    key: 'ProductDescription',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200,
	                    filterable: true
	                }, {
	                    key: 'Batch_PONum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 90,
	                    filterable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'InventoryConvertForm-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'id',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: 200,
	                                enableRowSelect: 'single',
	                                onRowUpdated: this.handleRowUpdated,
	                                onRowSelect: onRowSelect })
	                        )
	                    )
	                );
	            }
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTargetTable',
	        value: function renderTargetTable() {
	            var _this4 = this;
	
	            if (this.props.vendorIsLoading && !this.props.vendorError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.vendorError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    this.props.vendorError
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.targetInventories);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var targetInventories = _extends({}, _this4.state.targetInventories, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this4.setState({ targetInventories: targetInventories });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this4.state.targetInventories.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var targetInventories = _extends({}, _this4.state.targetInventories, { filters: newFilters });
	                    _this4.setState({ targetInventories: targetInventories });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var targetInventories = _extends({}, _this4.state.targetInventories, { selectedRows: rows });
	                    _this4.setState({ targetInventories: targetInventories });
	                };
	
	                //Custom Formatter component
	
	                var NameFormatter = _react2.default.createClass({
	                    displayName: 'NameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 90,
	                    filterable: true
	                }, {
	                    key: 'ProductDescription',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200,
	                    filterable: true
	                }, {
	                    key: 'Batch_PONum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 90,
	                    filterable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'InventoryConvertForm-dataGrid2' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'id',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: 200,
	                                enableRowSelect: 'single',
	                                onRowUpdated: this.handleRowUpdated,
	                                onRowSelect: onRowSelect })
	                        )
	                    )
	                );
	            }
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderConvertedTable',
	        value: function renderConvertedTable() {
	            var _this5 = this;
	
	            if (this.props.vendorIsLoading && !this.props.vendorError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.vendorError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    this.props.vendorError
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this5.state.convertedInventories);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var convertedInventories = _extends({}, _this5.state.convertedInventories, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this5.setState({ convertedInventories: convertedInventories });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this5.state.convertedInventories.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var convertedInventories = _extends({}, _this5.state.convertedInventories, { filters: newFilters });
	                    _this5.setState({ convertedInventories: convertedInventories });
	                };
	
	                // Handle the Dragable cell function
	
	                var handleCellDrag = function handleCellDrag(e) {
	                    var convertedInventories = _this5.state.convertedInventories;
	
	                    var rows = convertedInventories.rows.slice(0);
	                    for (var i = e.fromRow; i <= e.toRow; i++) {
	                        var rowToUpdate = rows[i];
	                        rowToUpdate[e.cellKey] = e.value;
	                    }
	                    var newConvertedInventories = _extends({}, convertedInventories, { rows: rows });
	                    _this5.setState({
	                        convertedInventories: newConvertedInventories
	                    });
	                };
	
	                // Handle the editable function
	
	                var handleRowUpdated = function handleRowUpdated(e) {
	                    // merge updated row with current row and rerender by setting state
	                    var convertedInventories = _this5.state.convertedInventories;
	
	                    var rows = getRows(); //convertedInventories.rows.slice(0);
	                    Object.assign(rows[e.rowIdx], e.updated);
	                    var newConvertedInventories = _extends({}, convertedInventories, { rows: rows });
	                    _this5.setState({
	                        convertedInventories: newConvertedInventories
	                    });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var convertedInventories = _extends({}, _this5.state.convertedInventories, { selectedRows: rows });
	                    _this5.setState({ convertedInventories: convertedInventories });
	                };
	
	                //Custom Formatter component
	
	                var NameFormatter = _react2.default.createClass({
	                    displayName: 'NameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120,
	                    filterable: true
	                }, {
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 90,
	                    filterable: true
	                }, {
	                    key: 'Quantity',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'convert_quantity' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200,
	                    filterable: true,
	                    editable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'InventoryConvertForm-dataGrid3' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'Pairid',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: 200,
	                                enableRowSelect: 'single',
	                                onCellsDragged: handleCellDrag,
	                                enableCellSelect: true,
	                                onRowUpdated: handleRowUpdated,
	                                onRowSelect: onRowSelect })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'checkPermission',
	        value: function checkPermission(permission) {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            var inventoryConvertWarehouseLoc = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_convert_warehouse_location' });
	            var inventoryConvertSheetWarehouseloc = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_convert_sheet_warehouse_location' });
	            var generalProductConvert = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_product_convert' });
	            var _state3 = this.state,
	                inventories = _state3.inventories,
	                targetInventories = _state3.targetInventories,
	                convertedInventories = _state3.convertedInventories;
	            var invalid = this.props.invalid;
	
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content-heading' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_convert' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/inventories/convert', className: 'btn btn-green buttonStyle' },
	                            _react2.default.createElement('em', { className: 'fa fa-mail-reply' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'pull-right' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: 'btn btn-primary buttonStyle',
	                                    onClick: function onClick(e) {
	                                        return _this6.createConvert(e);
	                                    } },
	                                _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'marginTopStyle' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 7 },
	                        _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { header: inventoryConvertWarehouseLoc },
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_inventory' })
	                                ),
	                                _react2.default.createElement('hr', null),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 8 },
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_select_an_inventory_to_convert' })
	                                    ),
	                                    this.renderTable()
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 4 },
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'details_and_convert' })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            inventories.selectedRows[0] ? inventories.selectedRows[0].ProductNum : "Please select an inventory"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            inventories.selectedRows[0] ? inventories.selectedRows[0].ProductName : "Please select an inventory"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_type' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            inventories.selectedRows[0] ? inventories.selectedRows[0].ProductUnitOfMeasure : "Please select an inventory"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_no_po_no' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            inventories.selectedRows[0] ? inventories.selectedRows[0].Batch_PONum : "Please select an inventory"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_zone' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            inventories.selectedRows[0] ? inventories.selectedRows[0].ZoneName : "Please select an inventory"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_bin' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            inventories.selectedRows[0] ? inventories.selectedRows[0].BinName : "Please select an inventory"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_quantity' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            inventories.selectedRows[0] ? inventories.selectedRows[0].BinAmount : "Please select an inventory"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'convert_quantity' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(_reduxForm.Field, { component: _inputField2.default, name: 'Quantity' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 12 },
	                                            inventories.selectedRows[0] && parseInt(this.props.quantityValue) > parseInt(inventories.selectedRows[0].CreditStatus) && _react2.default.createElement(
	                                                'p',
	                                                { className: 'parsley-error-message' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_convert_qty_cannot_exceed_current_qty' })
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_target_inventory' })
	                                ),
	                                _react2.default.createElement('hr', null),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 8 },
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_select_an_inventory_as_target' })
	                                    ),
	                                    this.renderTargetTable()
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 4 },
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'details_&_convert' })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].ProductNum : "Please select an inventory"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].ProductName : "Please select an inventory"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_type' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].ProductUnitOfMeasure : "Please select an inventory"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_no_po_no' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].Batch_PONum : "Please select an inventory"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_zone' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].ZoneName : "Please select an inventory"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_bin' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].BinName : "Please select an inventory"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_quantity' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].BinAmount : "Please select an inventory"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'convert_target_quantity' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(_reduxForm.Field, { component: _inputField2.default, name: 'ConvertedQuantity' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(_reduxForm.Field, { component: _inputField2.default, name: 'Weight' })
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 12 },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            className: 'btn btn-primary pull-right marginTopStyle',
	                                            onClick: function onClick(e) {
	                                                return _this6.setInventoryToConvert(e);
	                                            },
	                                            disabled: !inventories.selectedRows[0] || !targetInventories.selectedRows[0] || invalid || parseInt(this.props.quantityValue) > parseInt(inventories.selectedRows[0].CreditStatus) },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 5 },
	                        _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { header: inventoryConvertSheetWarehouseloc },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_convert_sheet' })
	                            ),
	                            _react2.default.createElement('hr', null),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'list_of_inventory_convert_lines' })
	                            ),
	                            this.renderConvertedTable(),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 12 },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            className: 'btn btn-warning pull-right marginTopStyle',
	                                            onClick: function onClick(e) {
	                                                return _this6.cancelInventoryConvert(e);
	                                            },
	                                            disabled: !convertedInventories.selectedRows[0] },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { header: generalProductConvert },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general' })
	                            ),
	                            _react2.default.createElement('hr', null),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 7 },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'convert_date' }),
	                                        ': '
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6, className: 'marginBottomStyle' },
	                                        _react2.default.createElement(_reduxForm.Field, { component: _datePicker2.default, name: 'PostingDate' })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'processing_fee' }),
	                                        ': '
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _react2.default.createElement(_reduxForm.Field, { component: _inputField2.default, name: 'ProcessingFee' })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 3 },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	                                        ': '
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 9 },
	                                        _react2.default.createElement(_reduxForm.Field, { name: 'Note', component: 'Textarea', className: 'form-control', style: { minHeight: '100px' } })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement('br', null)
	            );
	        }
	    }]);
	
	    return InventoryConvertForm;
	}(_react.Component);
	
	InventoryConvertForm.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = InventoryConvertForm;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(InventoryConvertForm, 'InventoryConvertForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryConvertForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryConvertForm.jsx');
	}();

	;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle} from '../Common/style'
	
	var InventoryConverts = function (_Component) {
	    _inherits(InventoryConverts, _Component);
	
	    function InventoryConverts() {
	        _classCallCheck(this, InventoryConverts);
	
	        var _this = _possibleConstructorReturn(this, (InventoryConverts.__proto__ || Object.getPrototypeOf(InventoryConverts)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	            rows: [],
	            selectedRows: null,
	            editedRows: [],
	            filters: {},
	            sortColumn: null,
	            sortDirection: null,
	            gourpOpen: false
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        return _this;
	    }
	
	    _createClass(InventoryConverts, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchInventoryConverts();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once inventoryConverts is ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var PT = nextProps.inventoryConverts;
	            if (nextProps.inventoryConverts && nextProps.inventoryConverts != this.props.inventoryConverts) {
	                this.setState({
	                    rows: nextProps.inventoryConverts
	                });
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	        }
	
	        // Set inventoryConverts being selected to be currentInventoryConvert and navigate user to the edit page
	
	    }, {
	        key: 'setCurrentInventoryConvert',
	        value: function setCurrentInventoryConvert(e) {
	            e.preventDefault();
	            var currentInventoryConvert = this.state.selectedRows[0];
	            this.props.resetCurrentInventoryConvert();
	            this.props.selectInventoryConvert(currentInventoryConvert);
	            this.context.router.push('/inventories/convert/' + currentInventoryConvert.WarehouseConvert_id);
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            this.props.resetCurrentInventoryConvert();
	            this.context.router.push('/inventories/convert/new');
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this2 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this2.setState(state);
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this2.state.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    _this2.setState({ filters: newFilters });
	                };
	
	                // Handle the editable function
	
	                var handleRowUpdated = function handleRowUpdated(e) {
	                    // merge updated row with current row and rerender by setting state
	                    var rows = _this2.state.rows.slice(0);
	                    var editedRows = _this2.state.editedRows.slice(0);
	                    Object.assign(rows[e.rowIdx], e.updated);
	                    // if the element is already edited, remove the old one.
	                    editedRows.forEach(function (element, index) {
	                        if (element.Inventory_id === rows[e.rowIdx].Inventory_id) editedRows.splice(index, 1);
	                    }, _this2);
	                    // push the row into the editedRows array
	                    editedRows.push(rows[e.rowIdx]);
	                    _this2.setState({
	                        rows: rows,
	                        editedRows: editedRows
	                    });
	                };
	
	                //Custom Formatter component
	                var IsEnabledFormatter = _react2.default.createClass({
	                    displayName: 'IsEnabledFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-success' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disable' })
	                        );
	                    }
	                });
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var onRowSelect = function onRowSelect(rows) {
	                    _this2.setState({ selectedRows: rows });
	                };
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'WarehouseConvertNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'record_convert_no' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    locked: true
	                }, {
	                    key: 'CreateTime',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_date' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    formatter: DateFormatter
	                }, {
	                    key: 'PostingDate',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'convert_date' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    formatter: DateFormatter
	                }, {
	                    key: 'Modify_Username',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'convert_user' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'Note',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'Completed',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'completed' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'InventoryConverts-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'WarehouseConvert_id',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                rowHeight: 25,
	                                minHeight: this.state.tableHeight,
	                                enableRowSelect: 'single',
	                                onRowUpdated: handleRowUpdated,
	                                onRowSelect: onRowSelect
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'checkPermission',
	        value: function checkPermission(permission) {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Breadcrumb,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb.Item,
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_management' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb.Item,
	                        { active: 'true' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_convert' })
	                    )
	                ),
	                ' ',
	                _react2.default.createElement(
	                    _reactBootstrap.Grid,
	                    { id: 'inventory-convert' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/inventories', className: 'btn btn-green marginLeftStyle' },
	                                _react2.default.createElement('em', { className: 'fa fa-mail-reply' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { className: 'btn btn-primary marginLeftStyle', onClick: function onClick(e) {
	                                        return _this3.clickNew(e);
	                                    }, disabled: this.checkPermission("add_warehouse_convert") },
	                                _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_inventory_convert_sheet' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'pull-right' },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    { className: 'btn btn-primary marginLeftStyle' },
	                                    _react2.default.createElement('em', { className: 'fa fa-print marginRightStyle' }),
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    { className: 'btn btn-primary marginLeftStyle' },
	                                    _react2.default.createElement('em', { className: 'fa fa-trash marginRightStyle' }),
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        className: 'btn btn-primary marginLeftStyle',
	                                        onClick: function onClick(event) {
	                                            _this3.setCurrentInventoryConvert(event);
	                                        } },
	                                    _react2.default.createElement('em', { className: 'fa fa-pencil marginRightStyle' }),
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('br', null),
	                    this.renderTable()
	                )
	            );
	        }
	    }]);
	
	    return InventoryConverts;
	}(_react.Component);
	
	InventoryConverts.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = InventoryConverts;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(InventoryConverts, 'InventoryConverts', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryConverts.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryConverts.jsx');
	}();

	;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _constants = __webpack_require__(11);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reduxForm = __webpack_require__(3);
	
	var _afterAddonField = __webpack_require__(93);
	
	var _inputField = __webpack_require__(16);
	
	var _selection = __webpack_require__(21);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _priceFormatter = __webpack_require__(56);
	
	var _priceFormatter2 = _interopRequireDefault(_priceFormatter);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// class RowRenderer extends Component {
	//     setScrollLeft(scrollBy) {
	//         // To freeze couple columns
	//         this.refs.row.setScrollLeft(scrollBy);
	//     }
	//
	//     getRowStyle() {
	//         return {
	//             color: this.getRowBackground()
	//         }
	//     }
	//
	//
	//     getRowBackground() {
	//       return this.props.row.Description;
	//     }
	//     render() {
	//         //here we are just changing the style
	//         //but we could replace this with anything we liked, cards, images, etc
	//         //usually though it will just be a matter of wrapping a div, and then calling back through to the grid
	//         return (<div style={this.getRowStyle() }><ReactDataGrid.Row ref="row" {...this.props} /></div>)
	//     }
	// }
	var RowRenderer = function (_Component) {
	  _inherits(RowRenderer, _Component);
	
	  function RowRenderer() {
	    _classCallCheck(this, RowRenderer);
	
	    return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(RowRenderer, [{
	    key: 'getRowStyle',
	    value: function getRowStyle() {
	      return {
	        color: this.getRowBackground()
	      };
	    }
	  }, {
	    key: 'getRowBackground',
	    value: function getRowBackground() {
	      if (this.props.row.orderStatus === 'open') {}
	      return this.props.row.orderStatus === 'open' ? 'red' : 'black';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      //here we are just changing the style
	      //but we could replace this with anything we liked, cards, images, etc
	      //usually though it will just be a matter of wrapping a div, and then calling back through to the grid
	      return _react2.default.createElement(
	        'div',
	        {
	          style: this.getRowStyle()
	          // onDoubleClick={() => { this.props.onDoubleClick(this.props.row); }}
	        },
	        _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	      );
	    }
	  }]);
	
	  return RowRenderer;
	}(_react.Component);
	
	function generateTodaysDate() {
	  return new Date();
	}
	
	var InventoryDetail = function (_Component2) {
	  _inherits(InventoryDetail, _Component2);
	
	  function InventoryDetail() {
	    _classCallCheck(this, InventoryDetail);
	
	    var _this2 = _possibleConstructorReturn(this, (InventoryDetail.__proto__ || Object.getPrototypeOf(InventoryDetail)).call(this));
	
	    _this2.handleZoneOnChange = function () {
	      var zoneID = _this2.props.zoneID;
	
	      if (zoneID) {
	        zoneID = (typeof zoneID === 'undefined' ? 'undefined' : _typeof(zoneID)) === 'object' ? zoneID.value : zoneID;
	        _this2.props.fetchBins(zoneID);
	      }
	    };
	
	    _this2.generateDropdownSelections = function (filterTypeOptions, handleClick, title) {
	      return (
	        //   <DropdownButton
	        //   bsStyle={'default'}
	        //   title={'transaction type'}
	        //   onSelect={onSelect}
	        // >
	        //     {filterTypeOptions.map(el => {
	        //       return (
	        //         <MenuItem eventKey="1" active={this.state.activeTransactionType} onClick={handleClick}>Action</MenuItem>
	
	        //       )
	        //     })}
	        //     <MenuItem eventKey="1">Action</MenuItem>
	        //     <MenuItem eventKey="2">Another action</MenuItem>
	        //     <MenuItem eventKey="3" active={this.state.activeTransactionType}>
	        //       Active Item
	        //     </MenuItem>
	        //   </DropdownButton>
	        _react2.default.createElement(
	          _reactBootstrap.Dropdown,
	          { id: 'dropdown-custom-1' },
	          _react2.default.createElement(
	            _reactBootstrap.Dropdown.Toggle,
	            null,
	            title
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Dropdown.Menu,
	            { className: 'super-colors' },
	            filterTypeOptions.map(function (el) {
	              return _react2.default.createElement(
	                _reactBootstrap.MenuItem,
	                { onClick: function onClick() {
	                    return handleClick(el);
	                  } },
	                el.label
	              );
	            })
	          )
	        )
	      );
	    };
	
	    _this2.generateDaysDropdownSelection = function (daysSelection, currentSelected, handleDaysClick) {
	      return _react2.default.createElement(
	        _reactBootstrap.Dropdown,
	        { id: 'dropdown-custom-1' },
	        _react2.default.createElement(
	          _reactBootstrap.Dropdown.Toggle,
	          null,
	          currentSelected.label
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Dropdown.Menu,
	          { className: 'super-colors' },
	          daysSelection.map(function (el) {
	            return _react2.default.createElement(
	              _reactBootstrap.MenuItem,
	              { onClick: function onClick() {
	                  return handleDaysClick(el);
	                } },
	              el.label
	            );
	          })
	        )
	      );
	    };
	
	    _this2.calculateSalesMargin = function (totalWorth, totalPrice) {
	      return (100 * (totalPrice / totalWorth)).toFixed(2);
	    };
	
	    _this2.renderToolbarFilter = function () {
	
	      var filterTypeOptions = [{
	        label: 'All Transactions',
	        value: 'all'
	      }, {
	        label: 'Received',
	        value: 'received'
	      }, {
	        label: 'Sales',
	        value: 'sales'
	      }, {
	        label: 'Converted',
	        value: 'converted'
	      }, {
	        label: 'Adjustments',
	        value: 'adjustment'
	      }];
	
	      var daysSelection = [{
	        label: '7 Days',
	        value: '7'
	      }, {
	        label: '30 Days',
	        value: '30'
	      }, {
	        label: '90 Days',
	        value: '90'
	      }];
	
	      var handleClick = function handleClick(el) {
	        _this2.setState({
	          activeTransactionType: el.value,
	          activeTransactionTypeInTitle: el.label
	        }, function () {
	          _this2.props.updateFilter({ transaction: _this2.state.activeTransactionType });
	        });
	      };
	
	      var handleDaysClick = function handleDaysClick(el) {
	        _this2.setState({
	          days: el
	        }, function () {
	          console.log('el', el);
	        });
	        var date = new Date();
	        var last = new Date(date.getTime() - el.value * 24 * 60 * 60 * 1000);
	        var newDate = {
	          end_date: date,
	          start_date: last
	        };
	        _this2.setState({
	          FromDate: last,
	          ToDate: date
	        });
	        _this2.props.updateFilter(_extends({}, newDate));
	      };
	
	      var handleOnSelect = function handleOnSelect() {
	        _this2.props.updateFilter({ transaction: _this2.state.activeTransactionType });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: { width: '100%' } },
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          { className: 'table-buttons' },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _this2.generateDaysDropdownSelection(daysSelection, _this2.state.days, handleDaysClick)
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 3 },
	            _react2.default.createElement(_DateTimePicker2.default, {
	              id: 'from-datepicker',
	              format: 'MM-DD-YY',
	              onChange: function onChange(e) {
	                if (_this2.state.ToDate && e > _this2.state.ToDate) {
	                  return;
	                }
	                _this2.setState({ FromDate: e }, function () {
	                  _this2.props.updateFilter({ start_date: _this2.state.FromDate });
	                });
	              }
	              // max={this.state.ToDate}
	              , time: false,
	              placeholder: 'Start',
	              value: _this2.state.FromDate
	            })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(_DateTimePicker2.default, {
	              id: 'to-datepicker',
	              format: 'MM-DD-YY',
	              onChange: function onChange(e) {
	                if (e < _this2.state.FromDate) {
	                  return;
	                }
	                _this2.setState({ ToDate: e }, function () {
	                  _this2.props.updateFilter({ end_date: _this2.state.ToDate });
	                });
	              },
	              min: _this2.state.FromDate,
	              time: false,
	              placeholder: 'End',
	              value: _this2.state.ToDate
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { style: { float: 'right', color: 'red', display: 'inline-block', marginLeft: '20px' } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_sales_worth' }),
	          ':  $',
	          _this2.state.total_price
	        ),
	        _react2.default.createElement(
	          'p',
	          { style: { float: 'right', color: 'red', display: 'inline-block' } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_inventory_value' }),
	          ':',
	          _this2.calculateSalesMargin(_this2.state.total_worth, _this2.state.total_price),
	          '%'
	        )
	      );
	    };
	
	    _this2.state = {
	      tableHeight: 200,
	
	      productNum: null,
	      productType: null,
	      refNum: null,
	      instock: null,
	      purchased: null,
	      sold: null,
	
	      p1Percentage: 0,
	      p2Percentage: 0,
	      p3Percentage: 0,
	      p4Percentage: 0,
	      p5Percentage: 0,
	      priceLv1: 0,
	      priceLv2: 0,
	      priceLv3: 0,
	      priceLv4: 0,
	      priceLv5: 0,
	
	      rows: [],
	      editedRows: [],
	      selectedRows: [],
	      filters: {},
	      sortColumn: null,
	      sortDirection: null,
	
	      history: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      inventoryAdjustment: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      adjustmentOpen: false,
	      enableAdjustment: false,
	      ReceiveFromDate: new Date(generateTodaysDate().getTime() - 7 * 24 * 60 * 60 * 1000),
	      ReceiveToDate: generateTodaysDate(),
	      FromDate: new Date(generateTodaysDate().getTime() - 7 * 24 * 60 * 60 * 1000),
	      ToDate: generateTodaysDate(),
	      days: {
	        label: '7 Days',
	        value: '7'
	      },
	      receiveDays: {
	        label: '7 Days',
	        value: '7'
	      },
	      total_price: null,
	      total_worth: null
	      // activeTransactionType: 'all',
	      // activeTransactionTypeInTitle: 'All Transaction',
	    };
	
	    _this2.handleResize = _this2.handleResize.bind(_this2);
	    _this2.openAdjustment = _this2.openAdjustment.bind(_this2);
	    _this2.closeAdjustment = _this2.closeAdjustment.bind(_this2);
	    _this2.enableAdjustment = _this2.enableAdjustment.bind(_this2);
	    _this2.handlePercentageChange = _this2.handlePercentageChange.bind(_this2);
	    _this2.handlePriceChange = _this2.handlePriceChange.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(InventoryDetail, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.resetQuickInventoryAdjustments();
	      // this.setState({ FromDate: new Date(moment().subtract('3', 'months').format('MM-DD-YY')), ToDate: new Date(moment().format('MM-DD-YY')) });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var currentInventory = this.props.currentInventory;
	
	      window.addEventListener('resize', this.handleResize);
	      this.props.fetchCRVValues();
	      this.props.fetchZones();
	      // this.props.fetchInventoriesDetails();
	      this.props.handleInventoryClick(this.props.params.id);
	      this.props.fetchReceiveHistoryFilterInitial();
	      if (currentInventory) {
	        this.props.fetchInventoryDetail(currentInventory.ProductNum);
	        this.props.fetchProductDetail(currentInventory.Product_id);
	        this.props.fetchInventoryHistory(currentInventory.Product_id, this.state.FromDate, this.state.ToDate);
	      } else if (this.props.params.id) {
	        this.props.fetchInventoryDetail(this.props.params.id);
	        this.props.fetchProductDetail(this.props.params.id);
	        this.props.fetchInventoryHistory(this.props.params.id, this.state.FromDate, this.state.ToDate);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      /* if (nextProps.routeParams.id) {
	        this.props.fetchProductDetail(nextProps.routeParams.id);
	        this.props.fetchInventoryDetail(nextProps.currentProductDetail.ProductNum);
	        this.props.fetchInventoryHistory(nextProps.currentProductDetail.Product_id, this.state.FromDate, this.state.ToDate);
	      } */
	      if (nextProps.ConvertType && nextProps.ConvertType != this.props.ConvertType) {
	        var convertNum = null;
	        if (this.props.currentProductDetail) {
	          if (nextProps.ConvertType == 'weight') {
	            convertNum = this.props.currentProductDetail.NetWeight;
	          } else if (nextProps.ConvertType == 'unit') {
	            convertNum = this.props.currentProductDetail.PackageSize_1;
	          }
	          if (nextProps.currentProductDetail.Default_WarehouseZone_id) {
	            this.props.fetchBins(nextProps.currentProductDetail.Default_WarehouseZone_id);
	          }
	        }
	        this.props.setValue('inventoryDetail', 'ConvertNum', convertNum);
	      }
	      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess != this.props.checkPasswordSuccess) {
	        this.closeAdjustment();
	        this.setState({ enableAdjustment: true });
	      }
	      if (nextProps.checkPasswordFailure && nextProps.checkPasswordFailure != this.props.checkPasswordFailure) {
	        this.setState({ enableAdjustment: false });
	      }
	      if (nextProps.currentInventoryDetail != null) {
	        var productNum = nextProps.currentInventoryDetail.ProductNum;
	        var productType = nextProps.currentInventoryDetail.ProductType;
	        var refNum = nextProps.currentInventoryDetail.RefNum;
	        var inStock = nextProps.currentInventoryDetail.InStock;
	        var purchased = nextProps.currentInventoryDetail.Purchased;
	        var sold = nextProps.currentInventoryDetail.PreSale;
	        var rows = nextProps.currentInventoryDetail.Products;
	        // rows.map(row => {
	        //   row['ZoneName'] = row.WarehouseZone_id.Name;
	        //   // row['BinName'] = row.WarehouseBin_id.Name;
	        //   // row['Description'] = row.WarehouseBin_id.Description;
	        // })
	        this.setState({
	          productNum: productNum,
	          productType: productType,
	          refNum: refNum,
	          inStock: inStock,
	          purchased: purchased,
	          sold: sold,
	          rows: rows
	        });
	      }
	      if (nextProps.currentProductDetail && nextProps.currentProductDetail != this.props.currentProductDetail) {
	        this.setState({
	          p1Percentage: nextProps.currentProductDetail.P1Percentage,
	          p2Percentage: nextProps.currentProductDetail.P2Percentage,
	          p3Percentage: nextProps.currentProductDetail.P3Percentage,
	          p4Percentage: nextProps.currentProductDetail.P4Percentage,
	          p5Percentage: nextProps.currentProductDetail.P5Percentage,
	          priceLv1: nextProps.currentProductDetail.PriceLv1,
	          priceLv2: nextProps.currentProductDetail.PriceLv2,
	          priceLv3: nextProps.currentProductDetail.PriceLv3,
	          priceLv4: nextProps.currentProductDetail.PriceLv4,
	          priceLv5: nextProps.currentProductDetail.PriceLv5
	        });
	      }
	      // if (nextProps.inventoryHistory && nextProps.inventoryHistory != this.props.inventoryHistory) {
	      //   const history = { ...this.state.history, rows: nextProps.inventoryHistory };
	      //   this.setState({ history });
	      // }
	      if (nextProps.inventoryBatchLogDetail) {
	        this.setState({
	          inventoryAdjustment: {
	            rows: nextProps.inventoryBatchLogDetail.sales_data
	          },
	          total_price: nextProps.inventoryBatchLogDetail.total_price
	        });
	      }
	      if (nextProps.filterUpdated) {
	        //fetch new info with filter
	        // console.log()
	        this.props.fetchInventoriesDetails(nextProps.params.id);
	      }
	
	      if (nextProps.receiveTableFilterUpdated) {
	        this.props.fetchReceiveHistory(nextProps.params.id);
	      }
	
	      if (nextProps.productReceiveHistory) {
	        this.setState({
	          history: {
	            rows: nextProps.productReceiveHistory.purchase_data
	          },
	          total_worth: nextProps.productReceiveHistory.total_worth
	        }, function () {
	          console.log('productReceiveHistory', _this3.state);
	        });
	      }
	
	      // if(nextProps.)
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      // console.log("window height", window.innerHeight - UI_HEIGHT.inventoryDetailPage)
	      // this.setState({tableHeight: (window.innerHeight > UI_HEIGHT.inventoryDetailPage) ? window.innerHeight - UI_HEIGHT.inventoryDetailPage : window.innerHeight - UI_HEIGHT.heightLess490 });
	    }
	  }, {
	    key: 'handleKeyPress',
	    value: function handleKeyPress(value, event) {
	      if (event.charCode == 13) {
	        event.preventDefault();
	        ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	      }
	    }
	  }, {
	    key: 'handleOnFocus',
	    value: function handleOnFocus(event) {
	      event.target.select();
	    }
	  }, {
	    key: 'openAdjustment',
	    value: function openAdjustment() {
	      this.props.clearCheckPassword();
	      this.setState({ adjustmentOpen: true });
	    }
	  }, {
	    key: 'closeAdjustment',
	    value: function closeAdjustment() {
	      this.setState({ adjustmentOpen: false });
	    }
	  }, {
	    key: 'enableAdjustment',
	    value: function enableAdjustment(password) {
	      this.props.checkPassword(password);
	    }
	  }, {
	    key: 'calculatePriceLevel',
	    value: function calculatePriceLevel(pricePer, refPrice) {
	      var price = (((parseFloat(pricePer) || 0) + 100) * (parseFloat(refPrice) || 0) * 0.01).toFixed(2);
	      var val = parseInt(price * 100);
	      val = (val / 100).toFixed(2);
	      val = price - val > 0 ? parseFloat(val) + 0.01 : val;
	      val = parseFloat(val).toFixed(2);
	      return val;
	    }
	  }, {
	    key: 'calculatePricePercentage',
	    value: function calculatePricePercentage(price, refPrice) {
	      return ((parseFloat(price) || 0) / (parseFloat(refPrice) || 0) * 100 - 100).toFixed(2);
	    }
	  }, {
	    key: 'handlePercentageChange',
	    value: function handlePercentageChange(level, event) {
	      var price = this.calculatePriceLevel(event.target.value, this.props.RefPriceValue);
	      switch (level) {
	        case 'p1Percentage':
	          this.setState({ p1Percentage: event.target.value, priceLv1: price });
	          break;
	        case 'p2Percentage':
	          this.setState({ p2Percentage: event.target.value, priceLv2: price });
	          break;
	        case 'p3Percentage':
	          this.setState({ p3Percentage: event.target.value, priceLv3: price });
	          break;
	        case 'p4Percentage':
	          this.setState({ p4Percentage: event.target.value, priceLv4: price });
	          break;
	        case 'p5Percentage':
	          this.setState({ p5Percentage: event.target.value, priceLv5: price });
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'handlePriceChange',
	    value: function handlePriceChange(level, event) {
	      var percentage = this.calculatePricePercentage(event.target.value, this.props.RefPriceValue);
	      switch (level) {
	        case 'priceLv1':
	          this.setState({ priceLv1: event.target.value, p1Percentage: percentage });
	          break;
	        case 'priceLv2':
	          this.setState({ priceLv2: event.target.value, p2Percentage: percentage });
	          break;
	        case 'priceLv3':
	          this.setState({ priceLv3: event.target.value, p3Percentage: percentage });
	          break;
	        case 'priceLv4':
	          this.setState({ priceLv4: event.target.value, p4Percentage: percentage });
	          break;
	        case 'priceLv5':
	          this.setState({ priceLv5: event.target.value, p5Percentage: percentage });
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'roundUp',
	    value: function roundUp(price) {
	      price = parseFloat(price);
	      var val = parseInt(price * 10);
	      val /= 10;
	      var left = (price - val).toFixed(8);
	      var rounded = 0;
	      if (left == 0) {
	        rounded = 0;
	      } else if (left > 0 && left <= 0.05) {
	        rounded = 0.05;
	      } else if (left > 0.05 && left <= 0.09) {
	        rounded = 0.09;
	      } else {
	        rounded = 0.1;
	      }
	      rounded += val;
	      rounded = rounded.toFixed(2);
	      return rounded;
	    }
	  }, {
	    key: 'getZoneOptions',
	    value: function getZoneOptions() {
	      var zoneOptions = [];
	      this.props.zones.map(function (zone) {
	        zoneOptions.push({ value: zone.WarehouseZone_id, label: zone.Name });
	      });
	      return zoneOptions;
	    }
	  }, {
	    key: 'getBinOptions',
	    value: function getBinOptions() {
	      var binOptions = [];
	      this.props.bins.map(function (bin) {
	        binOptions.push({ value: bin.WarehouseBin_id, label: bin.Name });
	      });
	      return binOptions;
	    }
	  }, {
	    key: 'renderAvgCost',
	    value: function renderAvgCost() {
	      var _this4 = this;
	
	      // if(this.props.currentProductDetail) {
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 6, className: 'avg-and-inv-cost' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-6' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'avg_cost' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-6' },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'InStockPrice',
	              withRef: true,
	              ref: 'InStockPrice',
	              component: _inputField.InputField,
	              onFocus: this.handleOnFocus,
	              onKeyPress: function onKeyPress(event) {
	                _this4.handleKeyPress('ProductCost', event);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-6' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_cost' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-6' },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'ProductCost',
	              withRef: true,
	              ref: 'ProductCost',
	              component: _inputField.InputField,
	              onFocus: this.handleOnFocus,
	              onKeyPress: function onKeyPress(event) {
	                _this4.handleKeyPress('RefPrice', event);
	              }
	            })
	          )
	        )
	      );
	      // }
	      // else {
	      //   return (
	      //     <div>
	      //       <div className="form-group">
	      //           <label className="col-xs-6"><Translate value="inv_cost" /></label>
	      //           <div className="col-xs-6">
	      //             <Field name="NetCost" component={ InputField } onFocus={this.handleOnFocus} withRef={true} ref="NetCost" onKeyPress={(event) => {
	      //                 this.handleKeyPress('ProductCost', event)
	      //             }}/>
	      //         </div>
	      //       </div>
	      //       <div className="form-group">
	      //           <label className="col-xs-6"><Translate value="prod_cost" /></label>
	      //           <div className="col-xs-6">
	      //             <Field name="ProductCost" component={ InputField } onFocus={this.handleOnFocus} withRef={true} ref="ProductCost" onKeyPress={(event) => {
	      //                 this.handleKeyPress('RefPrice', event)
	      //             }}/>
	      //         </div>
	      //       </div>
	      //     </div>
	      //   )
	      // }
	    }
	  }, {
	    key: 'renderCRV',
	    value: function renderCRV() {
	      var _this5 = this;
	
	      var CRVOptions = this.getCRVOptions();
	      return _react2.default.createElement(_reduxForm.Field, {
	        name: 'CRV_id',
	        component: _selection.Selection,
	        withRef: true,
	        ref: 'CRVOptions',
	        options: CRVOptions,
	        onKeyPress: function onKeyPress(event) {
	          if (event.keyCode == 13) {
	            ReactDOM.findDOMNode(_this5.refs.ProductBarcode.getRenderedComponent().myInput.refs.input).focus();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'getCRVOptions',
	    value: function getCRVOptions() {
	      var CRVOptions = [];
	      this.props.CRVs.map(function (CRV) {
	        CRVOptions.push({ value: CRV.Product_id, label: CRV.Name });
	      });
	      return CRVOptions;
	    }
	
	    // renderDefaultBinRange() {
	    //   return (
	    //       <FieldArray name="BinRangeList" component={renderBinRangeList} />
	    //   )
	    // }
	
	  }, {
	    key: 'renderConvertDetails',
	    value: function renderConvertDetails() {
	      return _react2.default.createElement(_reduxForm.FieldArray, { name: 'Related_Products', component: renderConvertDetailsList });
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      this.props.editProduct(formProps, this.state, true);
	      this.props.quickAdjustment(this.props.currentInventoryDetail, this.state.editedRows);
	    }
	  }, {
	    key: 'renderZone',
	    value: function renderZone() {
	      if (this.props.zoneIsLoading) return _react2.default.createElement(_spinner2.default, null); // If group is loading, show a spinner.
	
	      var zoneOptions = this.getZoneOptions();
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(_reduxForm.Field, {
	          name: 'Default_WarehouseZone_id',
	          component: _selection.SelectionWithProps,
	          options: zoneOptions,
	          onChange: this.handleZoneOnChange
	        })
	      );
	    }
	  }, {
	    key: 'renderDefaultBinRange',
	    value: function renderDefaultBinRange() {
	      if (this.props.binIsLoading) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } // If group is loading, show a spinner.
	      var binOptions = this.getBinOptions();
	      var levelOptions = [{ value: 'FL', label: 'FL' }, { value: 'A', label: 'A' }, { value: 'B', label: 'B' }, { value: 'C', label: 'C' }];
	      return _react2.default.createElement(_reduxForm.FieldArray, {
	        name: 'BinRangeList',
	        component: renderBinRangeList,
	        binOptions: binOptions,
	        levelOptions: levelOptions
	      });
	    }
	  }, {
	    key: 'renderTableFilter',
	    value: function renderTableFilter() {
	      var _this6 = this;
	
	      var daysSelection = [{
	        label: '7 Days',
	        value: '7'
	      }, {
	        label: '30 Days',
	        value: '30'
	      }, {
	        label: '90 Days',
	        value: '90'
	      }];
	
	      var handleClick = function handleClick(el) {
	        _this6.setState({
	          activeTransactionType: el.value,
	          activeTransactionTypeInTitle: el.label
	        }, function () {
	          _this6.props.updateReceiveTableFilter({ transaction: _this6.state.activeTransactionType });
	        });
	      };
	
	      var handleDaysClick = function handleDaysClick(el) {
	        _this6.setState({
	          receiveDays: el
	        });
	        var date = new Date();
	        var last = new Date(date.getTime() - el.value * 24 * 60 * 60 * 1000);
	        var newDate = {
	          start_date: last,
	          end_date: date
	        };
	        _this6.setState({
	          ReceiveFromDate: last,
	          ReceiveToDate: date
	        });
	        _this6.props.updateReceiveTableFilter(_extends({}, newDate));
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: { width: '100%' } },
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          { className: 'table-buttons', style: { marginLeft: '8px' } },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            this.generateDaysDropdownSelection(daysSelection, this.state.receiveDays, handleDaysClick)
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(_DateTimePicker2.default, {
	              id: 'from-datepicker',
	              format: 'MM-DD-YY',
	              onChange: function onChange(e) {
	                if (_this6.state.ReceiveToDate && e > _this6.state.ReceiveToDate) {
	                  return;
	                }
	                _this6.setState({ ReceiveFromDate: e }, function () {
	                  _this6.props.updateReceiveTableFilter({ start_date: _this6.state.ReceiveFromDate });
	                });
	              }
	              // max={this.state.ToDate}
	              , time: false,
	              placeholder: 'Start',
	              value: this.state.ReceiveFromDate
	            })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(_DateTimePicker2.default, {
	              id: 'to-datepicker',
	              format: 'MM-DD-YY',
	              onChange: function onChange(e) {
	                if (e < _this6.state.ReceiveFromDate) {
	                  return;
	                }
	                _this6.setState({ ReceiveToDate: e }, function () {
	                  _this6.props.updateReceiveTableFilter({ end_date: _this6.state.ReceiveToDate });
	                });
	              },
	              min: this.state.ReceiveFromDate,
	              time: false,
	              placeholder: 'End',
	              value: this.state.ReceiveToDate
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { style: { float: 'right', display: 'inline-block', color: 'red' } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_inventory_worth' }),
	          ':  $',
	          this.state.total_worth
	        )
	      );
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this7 = this;
	
	      var that = this;
	      if (this.props.detailIsLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          this.props.error
	        )
	      );
	
	      // Parameters of the react-data-grid
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this7.state.history);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return Object.assign({}, rows[rowIdx]);
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        // var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	        // this.setState(state);
	        var comparer = function comparer(a, b) {
	          if (sortDirection === 'ASC') {
	            return a[sortColumn] > b[sortColumn] ? 1 : -1;
	          } else if (sortDirection === 'DESC') {
	            return a[sortColumn] < b[sortColumn] ? 1 : -1;
	          }
	        };
	        var comparerBin = function comparerBin(a, b) {
	          if (sortDirection === 'ASC') {
	            return a[sortColumn].Name > b[sortColumn].Name ? 1 : -1;
	          } else if (sortDirection === 'DESC') {
	            return a[sortColumn].Name < b[sortColumn].Name ? 1 : -1;
	          }
	        };
	
	        if (sortColumn == 'WarehouseBin_id') {
	          var rows = sortDirection === 'NONE' ? _this7.state.rows : _this7.state.rows.sort(comparerBin);
	        } else {
	          var rows = sortDirection === 'NONE' ? _this7.state.rows : _this7.state.rows.sort(comparer);
	        }
	        _this7.setState({ rows: rows });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        var history = _extends({}, _this7.state.history, { filters: {} });
	        _this7.setState({ history: history });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this7.state.history.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        _this7.setState({ history: _extends({}, _this7.state.history, {
	            filters: newFilters
	          }) });
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        var rows = getRows();
	        // let rows = this.state.rows;
	        Object.assign(rows[e.rowIdx], e.updated);
	        var editedRows = _this7.state.editedRows.slice(0);
	        // if the element is already edited, remove the old one.
	        editedRows.forEach(function (element, index) {
	          if (element.id === rows[e.rowIdx].id) {
	            editedRows.splice(index, 1);
	          }
	        }, _this7);
	        // push the row into the editedRows array
	        editedRows.push(rows[e.rowIdx]);
	        _this7.setState({
	          rows: rows,
	          editedRows: editedRows
	        });
	      };
	
	      var BinFormatter = _react2.default.createClass({
	        displayName: 'BinFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            { style: { color: this.props.value.Description } },
	            this.props.value.Name
	          );
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var batchFormatter = _react2.default.createClass({
	        displayName: 'batchFormatter',
	        render: function render() {
	          return _react2.default.createElement(
	            'span',
	            null,
	            this.props.dependentValues
	          );
	        }
	      });
	
	      var batchQuantityFormatter = _react2.default.createClass({
	        displayName: 'batchQuantityFormatter',
	        render: function render() {
	          return _react2.default.createElement(
	            'span',
	            { style: { color: 'red' } },
	            this.props.dependentValues
	          );
	        }
	      });
	      var UTCtimeFormatter = _react2.default.createClass({
	        displayName: 'UTCtimeFormatter',
	        render: function render() {
	          var d = new Date(this.props.value);
	          return _react2.default.createElement(
	            'span',
	            null,
	            d.toString().split('GMT')[0]
	          );
	        }
	      });
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	            var date = new Date(this.props.value);
	            var index = dateMap.indexOf(date.toString().slice(4, 3));
	            var localDate = index + date.toString().slice(8, 6);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var WeightFormatter = _react2.default.createClass({
	        displayName: 'WeightFormatter',
	        render: function render() {
	          if (that.state.productType && that.state.productType !== 'Fixed') {
	            return _react2.default.createElement(
	              'span',
	              null,
	              this.props.value
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      // Column difinition
	
	      var columns = [{
	        key: 'PONum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: 'batch_num',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        formatter: batchFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.batch ? row.batch.batch_num : '';
	        }
	      }, {
	        key: 'orderQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_quantity' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        // editable: this.state.enableAdjustment,
	        width: 100
	      }, {
	        key: 'quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_quantity' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        // formatter: WeightFormatter,
	        // editable: this.state.enableAdjustment,
	        width: 100
	      }, {
	        key: 'batch_quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_quantity' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: batchQuantityFormatter,
	        // editable: this.state.enableAdjustment,
	        width: 100,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.batch ? row.batch.quantity : '';
	        }
	      },
	      // {
	      //   key: 'Weights',
	      //   name: <Translate value="total_wt" />,
	      //   resizable: true,
	      //   sortable: true,
	      //   filterable: true,
	      //   formatter: WeightFormatter,
	      //   editable: this.state.enableAdjustment,
	      //   width: 90,
	      // },
	      {
	        key: 'unit_price',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: batchFormatter,
	        width: 100,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.batch ? row.batch.unit_price : '';
	        }
	      }, {
	        key: 'weight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: batchFormatter,
	        width: 80,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.batch ? row.batch.weight : '';
	        }
	      }, {
	        key: 'vendorName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 180
	      }, {
	        key: 'receiveDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receiveDate' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: UTCtimeFormatter,
	        // editable: this.state.enableAdjustment,
	        width: 170
	      }, {
	        key: 'expire_datetime',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'expire_datetime' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: batchFormatter,
	        width: 170,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.batch ? row.batch.expire_datetime : '';
	        }
	      }];
	
	      return (
	        // React Table Product Order History
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { style: { marginTop: '40px' } },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { id: 'InventoryDetail-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'id',
	                rowRenderer: _react2.default.createElement(RowRenderer, null),
	                onGridSort: handleGridSort
	                // toolbar={<Toolbar enableFilter />}
	                , onAddFilter: handleFilterChange,
	                onClearFilters: onClearFilters,
	                columns: columns,
	                headerRowHeight: 45,
	                rowHeight: 25,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                enableCellSelect: true,
	                onRowUpdated: handleRowUpdated,
	                minHeight: 250
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderProductsTable',
	    value: function renderProductsTable() {
	      var _this8 = this;
	
	      var that = this;
	
	      // Parameters of the react-data-grid
	
	      var tableHeight = window.innerHeight < 930 ? 250 : 250;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this8.state.inventoryAdjustment);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this8.state.history, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this8.setState({ history: state });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        var history = _extends({}, _this8.state.history, { filters: {} });
	        _this8.setState({ history: history });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this8.state.history.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var history = _extends({}, _this8.state.history, { filters: newFilters });
	        _this8.setState({ history: history });
	      };
	
	      // Handle the row select function
	
	      var onRowSelect = function onRowSelect(rows) {
	        var history = _extends({}, _this8.state.history, { selectedRows: rows });
	        _this8.setState({ history: history });
	      };
	
	      // Custom Formatter component
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	            var date = new Date(this.props.value);
	            var index = dateMap.indexOf(date.toString().slice(4, 3));
	            var localDate = index + date.toString().slice(8, 6);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var WeightFormatter = _react2.default.createClass({
	        displayName: 'WeightFormatter',
	        render: function render() {
	          if (that.state.productType !== 'Fixed') {
	            return _react2.default.createElement(
	              'span',
	              null,
	              this.props.value
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var nestedDataFormatter = _react2.default.createClass({
	        displayName: 'nestedDataFormatter',
	        render: function render() {
	          return _react2.default.createElement(
	            'span',
	            null,
	            this.props.dependentValues
	          );
	        }
	      });
	
	      var UTCtimeFormatter = _react2.default.createClass({
	        displayName: 'UTCtimeFormatter',
	        render: function render() {
	          var d = new Date(this.props.dependentValues);
	          return _react2.default.createElement(
	            'span',
	            null,
	            d.toString().split('GMT')[0]
	          );
	        }
	      });
	      // Column definition
	
	      // const columns = [
	      //   {
	      //     key: 'Num',
	      //     name: <Translate value="num" />,
	      //     resizable: true,
	      //     sortable: true,
	      //     filterable: true,
	      //     width: 105,
	      //   },
	      //   {
	      //     key: 'Date',
	      //     name: <Translate value="date" />,
	      //     resizable: true,
	      //     sortable: true,
	      //     filterable: true,
	      //     formatter: DateFormatter,
	      //     width: 100,
	      //   },
	      //   {
	      //     key: 'Type',
	      //     name: <Translate value="type" />,
	      //     resizable: true,
	      //     sortable: true,
	      //     filterable: true,
	      //     width: 130,
	      //   },
	      //   {
	      //     key: 'Operator',
	      //     name: <Translate value="operator" />,
	      //     resizable: true,
	      //     sortable: true,
	      //     width: 100,
	      //   },
	      //   {
	      //     key: 'Vendor',
	      //     name: <Translate value="vendor_name" />,
	      //     resizable: true,
	      //     sortable: true,
	      //     filterable: true,
	      //     width: 135,
	      //   },
	      //   {
	      //     key: 'Quantity',
	      //     name: <Translate value="qty" />,
	      //     resizable: true,
	      //     width: 40,
	      //     sortable: true,
	      //   },
	      //   {
	      //     key: 'TotalNetWeight',
	      //     name: <Translate value="total_wt" />,
	      //     resizable: true,
	      //     sortable: true,
	      //     filterable: true,
	      //     formatter: WeightFormatter,
	      //     width: 90,
	      //   },
	      //   {
	      //     key: 'UnitPrice',
	      //     name: <Translate value="unit_dollarsign" />,
	      //     resizable: true,
	      //     sortable: true,
	      //     filterable: true,
	      //     formatter: CashFormatter,
	      //     width: 85,
	      //   },
	      // ];
	      var columns = [{
	        key: 'SONumber',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_number' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 150,
	        formatter: nestedDataFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.SalesOrder ? row.SalesOrder.SONum : '';
	        }
	      }, {
	        key: 'orderDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_date' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 165,
	        formatter: UTCtimeFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.SalesOrder ? row.SalesOrder.OrderDate : '';
	        }
	      }, {
	        key: 'invoice_number',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_number' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        formatter: nestedDataFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.SalesInvoice ? row.SalesInvoice.InvoiceNum : '';
	        }
	      }, {
	        key: 'product_name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 150,
	        filterable: true,
	        formatter: nestedDataFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.Product ? row.Product.Name : '';
	        }
	      }, {
	        key: 'product_number',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_number' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        formatter: nestedDataFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.Product ? row.Product.ProductNum : '';
	        }
	      }, {
	        key: 'customer_name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' }),
	        resizable: true,
	        width: 100,
	        sortable: true,
	        filterable: true,
	        formatter: nestedDataFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.DeliverCustomer ? row.DeliverCustomer.Name : '';
	        }
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Unit_price' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        // formatter: WeightFormatter,
	        width: 90
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        // formatter: CashFormatter,
	        width: 85
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_price' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        // formatter: CashFormatter,
	        width: 85
	      }, {
	        key: 'CostPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        // formatter: CashFormatter,
	        width: 85
	      }];
	
	      // React Table Purchase Order Details
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        { style: { marginTop: '40px' } },
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { className: 'recat-customizer', id: 'InventoryDetail-dataGrid2' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'id',
	              onGridSort: handleGridSort
	              // toolbar={<Toolbar enableFilter />}
	              , onAddFilter: handleFilterChange,
	              onClearFilters: onClearFilters,
	              columns: columns,
	              headerRowHeight: 45,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              rowHeight: 25,
	              minHeight: tableHeight,
	              onRowUpdated: this.handleRowUpdated
	              // onRowSelect={onRowSelect}
	              // enableCellSelect
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var costsDetailsPanelHeader = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'costs_details' })
	      );
	      var saleDetailsPanelHeader = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sale_details' })
	      );
	      var inventoryDetailsPanelHeader = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_details' })
	      );
	      var priceLevelPanelHeader = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price_levels' })
	      );
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          invalid = _props.invalid,
	          submitting = _props.submitting,
	          pristine = _props.pristine;
	
	      var imageFile = this.props.currentProductDetail && this.props.currentProductDetail.Thumbnail;
	      var createDialogStyle = {
	        width: '550px',
	        height: '300px',
	        marginLeft: '-15%'
	      };
	      if (this.props.inventoryIsLoading && !this.props.inventoryError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.inventoryError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          this.props.inventoryError.message
	        )
	      );
	
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'form',
	            { className: 'form-horizontal', method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Breadcrumb.Item,
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_management' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Breadcrumb.Item,
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Breadcrumb.Item,
	                { active: 'true' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_detail' })
	              )
	            ),
	            ' ',
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  type: 'reset',
	                  onClick: _reactRouter.browserHistory.goBack
	                },
	                _react2.default.createElement('em', { className: 'fa fa-close' }),
	                ' ',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	              )
	            ),
	            ' ',
	            _react2.default.createElement(
	              _reactBootstrap.Grid,
	              { id: 'inventory-details-page' },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 12 },
	                  _react2.default.createElement(
	                    'h1',
	                    null,
	                    this.props.currentProductDetail && this.props.currentProductDetail.Name,
	                    ' ',
	                    this.props.currentProductDetail && this.props.currentProductDetail.Description
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 12 },
	                      _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        { id: 'product-info-panel' },
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          null,
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 2 },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                { className: 'col-xs-4' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'colon' },
	                                  ':'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-8' },
	                                _react2.default.createElement(_reduxForm.Field, { component: _inputField.DisabledInputField, placeholder: this.state.productNum })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 2 },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                { className: 'col-xs-4' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'colon' },
	                                  ':'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-8' },
	                                _react2.default.createElement(_reduxForm.Field, { component: _inputField.DisabledInputField, placeholder: this.state.refNum })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 2 },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                { className: 'col-xs-4' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'instock' }),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'colon' },
	                                  ':'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-8' },
	                                _react2.default.createElement(_reduxForm.Field, { component: _inputField.DisabledInputField, placeholder: this.state.inStock })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 2 },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                { className: 'col-xs-4' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sold' }),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'colon' },
	                                  ':'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-8' },
	                                _react2.default.createElement(_reduxForm.Field, { component: _inputField.DisabledInputField, placeholder: this.state.sold })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 2 },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                { className: 'col-xs-3' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchased' }),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'colon' },
	                                  ':'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-8 col-xs-offset-1' },
	                                _react2.default.createElement(_reduxForm.Field, { component: _inputField.DisabledInputField, placeholder: this.state.purchased })
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  ' ',
	                  ' ',
	                  _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Purchase History'
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 12 },
	                      _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        { id: 'product-order-history' },
	                        this.renderTableFilter(),
	                        this.renderTable()
	                      )
	                    )
	                  ),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Sales History'
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 12 },
	                      _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        { id: 'inventory-order-history', className: 'position-relative table-collapse-fix' },
	                        this.renderToolbarFilter(),
	                        this.renderProductsTable()
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    this.props.quickInventoryAdjustmentIsEditing && _react2.default.createElement(
	                      'div',
	                      { className: 'alert alert-info' },
	                      _react2.default.createElement(_spinner2.default, null),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'uploading' })
	                    ),
	                    this.props.quickInventoryAdjustmentEdited && _react2.default.createElement(
	                      'div',
	                      { className: 'alert alert-success' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saved' })
	                    ),
	                    this.props.quickInventoryAdjustmentEditError && _react2.default.createElement(
	                      'div',
	                      { className: 'alert alert-danger marginTopStyle' },
	                      this.props.quickInventoryAdjustmentEditError
	                    )
	                  ),
	                  ' '
	                )
	              ),
	              ' '
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            { dialogStyles: createDialogStyle, isVisible: this.state.adjustmentOpen, onCloseClicked: this.closeAdjustment },
	            _react2.default.createElement(_confirmActionModal2.default, { 'case': 'confirmPassword', closeC: this.enableAdjustment, checkPasswordFailure: this.props.checkPasswordFailure })
	          )
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return InventoryDetail;
	}(_react.Component);
	
	InventoryDetail.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = InventoryDetail;
	exports.default = _default;
	
	
	var renderSaleRadios = function renderSaleRadios(props) {
	  var titleClass = (0, _classnames2.default)('col-xs-4');
	  return _react2.default.createElement(
	    'div',
	    { id: 'stopSale', className: 'form-group' },
	    _react2.default.createElement(
	      'label',
	      { className: titleClass },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'OnSale',
	        checked: props.input.value === 'OnSale'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'on_sale' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-4' },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'StopSale',
	        checked: props.input.value === 'StopSale'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'stop_sale' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-3 pull-right' },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'OnHold',
	        checked: props.input.value === 'OnHold'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'on_hold' })
	    )
	  );
	};
	
	var renderRadios = function renderRadios(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group' },
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-4' },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: '' + props.labelName })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-2 ' },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'true',
	        checked: props.input.value === true || props.input.value === 'true' || props.input.name === 'IsOverSaleable' && props.input.value !== false && props.input.value !== 'false'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'false',
	        checked: props.input.value === false || props.input.value === 'false'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	    )
	  );
	};
	
	var convertNumRadios = function convertNumRadios(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group' },
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-4' },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'convert_type' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-3 text-nowrap' },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'weight',
	        checked: props.input.value === 'weight'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_weight' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-3 text-nowrap' },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'unit',
	        checked: props.input.value === 'unit'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_unit' })
	    )
	  );
	};
	
	var renderConvertDetailsList = function renderConvertDetailsList(props) {
	  var fields = props.fields;
	
	  return _react2.default.createElement(
	    _reactBootstrap.Row,
	    null,
	    _react2.default.createElement(
	      _reactBootstrap.Col,
	      { xs: 12 },
	      _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          fields.map(function (Product, index) {
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { key: index, className: 'prod-qty-adjuster' },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 12 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6, className: 'prod-no-related' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-xs-5' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-xs-7' },
	                          _react2.default.createElement(_reduxForm.Field, { name: Product + '.ProductNum', className: 'control-label', component: _inputField.DisabledInputField })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 4, className: 'convert-qty col-xs-offset-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-xs-3' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-xs-4' },
	                          _react2.default.createElement(_reduxForm.Field, { name: Product + '.ConvertNum', className: 'control-label', component: _inputField.DisabledInputField })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	var renderBinRangeList = function renderBinRangeList(props) {
	  var fields = props.fields,
	      binOptions = props.binOptions,
	      levelOptions = props.levelOptions;
	
	  return _react2.default.createElement(
	    _reactBootstrap.Row,
	    null,
	    _react2.default.createElement(
	      _reactBootstrap.Col,
	      { xs: 12, className: 'add-bin-range-section' },
	      _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'primary',
	              type: 'button',
	              onClick: function onClick() {
	                fields.push({}); // pushes empty child field onto the end of the array
	              }
	            },
	            ' ',
	            _react2.default.createElement('em', { className: 'fa fa-plus' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          !fields.length && _react2.default.createElement(
	            'div',
	            { className: 'marginTopStyle' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' }),
	            ' ',
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin_range' })
	          ),
	          fields.map(function (Bin, index) {
	            return _react2.default.createElement(
	              _reactBootstrap.Row,
	              { key: index, className: 'additional-bin-range' },
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin_range' }),
	                  ' ',
	                  '#' + (index + 1)
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 5 },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-3' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-9' },
	                        _react2.default.createElement(_reduxForm.Field, { name: Bin + '.DefaultBin', component: _selection.Selection, options: binOptions })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 5 },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-3' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'level' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-9' },
	                        _react2.default.createElement(_reduxForm.Field, { name: Bin + '.Default_Level', component: _selection.Selection, options: levelOptions })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'danger',
	                        className: 'remove-btn',
	                        type: 'button',
	                        onClick: function onClick() {
	                          fields.remove(index); // remove from index
	                        }
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-trash' })
	                    )
	                  )
	                )
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(generateTodaysDate, 'generateTodaysDate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(InventoryDetail, 'InventoryDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(renderSaleRadios, 'renderSaleRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(renderRadios, 'renderRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(convertNumRadios, 'convertNumRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(renderConvertDetailsList, 'renderConvertDetailsList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(renderBinRangeList, 'renderBinRangeList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryDetail.jsx');
	}();

	;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle} from '../Common/style'
	
	var RowRenderer = function (_Component) {
	    _inherits(RowRenderer, _Component);
	
	    function RowRenderer() {
	        _classCallCheck(this, RowRenderer);
	
	        return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	    }
	
	    _createClass(RowRenderer, [{
	        key: 'setScrollLeft',
	        value: function setScrollLeft(scrollBy) {
	            // To freeze couple columns
	            this.refs.row.setScrollLeft(scrollBy);
	        }
	    }, {
	        key: 'getRowStyle',
	        value: function getRowStyle() {
	            return {
	                color: this.getRowBackground()
	            };
	        }
	    }, {
	        key: 'getRowBackground',
	        value: function getRowBackground() {
	            return this.props.row.InStock > 0 ? _constants.BACKGROUND_COLOR.blue : _constants.BACKGROUND_COLOR.red;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            //here we are just changing the style
	            //but we could replace this with anything we liked, cards, images, etc
	            //usually though it will just be a matter of wrapping a div, and then calling back through to the grid
	            return _react2.default.createElement(
	                'div',
	                { style: this.getRowStyle() },
	                _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	            );
	        }
	    }]);
	
	    return RowRenderer;
	}(_react.Component);
	
	var InventoryExpired = function (_Component2) {
	    _inherits(InventoryExpired, _Component2);
	
	    function InventoryExpired() {
	        _classCallCheck(this, InventoryExpired);
	
	        var _this2 = _possibleConstructorReturn(this, (InventoryExpired.__proto__ || Object.getPrototypeOf(InventoryExpired)).call(this));
	
	        _this2.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton,
	
	            rows: [],
	            selectedRows: null,
	            editedRows: [],
	            filters: {},
	            sortColumn: null,
	            sortDirection: null,
	            gourpOpen: false
	        };
	
	        _this2.handleResize = _this2.handleResize.bind(_this2);
	        return _this2;
	    }
	
	    _createClass(InventoryExpired, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchExpiredInventories();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once inventories is ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var PT = nextProps.inventories;
	            if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
	                var newInventories = [].concat(_toConsumableArray(nextProps.inventories));
	                newInventories.map(function (inventory) {
	                    inventory["ProductName"] = inventory["ProductNum"].Name;
	                    inventory["Description"] = inventory["ProductNum"].Description;
	                    inventory["PackageSize"] = inventory["ProductNum"].PackageSize;
	                    inventory["LowestAmount"] = inventory["ProductNum"].MinStockRange;
	                    inventory["ProductNum"] = inventory["ProductNum"].ProductNum;
	                    inventory["Warehouse"] = inventory["Warehouse_id"].Name;
	                });
	                this.setState({
	                    rows: newInventories
	                });
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton });
	        }
	
	        // Set inventories being selected to be currentInventory and navigate user to the edit page
	        // test
	
	    }, {
	        key: 'setCurrentInventory',
	        value: function setCurrentInventory(e) {
	            e.preventDefault();
	            var currentInventory = this.state.selectedRows[0];
	            this.props.selectInventory(currentInventory);
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            this.props.resetCurrentInventory();
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this3 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this3.state);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    _this3.setState.apply(_this3, _toConsumableArray(_this3.state).concat([{ selectedRows: rows }]));
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this3.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this3.setState(state);
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this3.state.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    _this3.setState({ filters: newFilters });
	                };
	
	                // Handle the editable function
	
	                var handleRowUpdated = function handleRowUpdated(e) {
	                    // merge updated row with current row and rerender by setting state
	                    var rows = _this3.state.rows.slice(0);
	                    var editedRows = _this3.state.editedRows.slice(0);
	                    Object.assign(rows[e.rowIdx], e.updated);
	                    // if the element is already edited, remove the old one.
	                    editedRows.forEach(function (element, index) {
	                        if (element.Product_id === rows[e.rowIdx].Product_id) editedRows.splice(index, 1);
	                    }, _this3);
	                    // push the row into the editedRows array
	                    editedRows.push(rows[e.rowIdx]);
	                    _this3.setState({
	                        rows: rows,
	                        editedRows: editedRows
	                    });
	                };
	
	                //Custom Formatter component
	                var IsEnabledFormatter = _react2.default.createClass({
	                    displayName: 'IsEnabledFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-success' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disable' })
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120,
	                    filterable: true
	                }, {
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'Warehouse',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200,
	                    filterable: true
	                }, {
	                    key: 'PackageSize',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 150,
	                    filterable: true
	                }, {
	                    key: 'Description',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 150,
	                    filterable: true
	                }, {
	                    key: 'RefPurchasingPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'refer_purchasing_price' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 150,
	                    filterable: true
	                }, {
	                    key: 'Batch_PONum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'ExpiredDate',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'expired_date' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'TotalStorageDay',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_storage_day' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'LowestAmount',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lowest_amount' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 150,
	                    filterable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'InventoryExpired-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowRenderer: RowRenderer,
	                                rowKey: 'id',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: this.state.tableHeight,
	                                onRowUpdated: handleRowUpdated,
	                                enableRowSelect: 'single',
	                                onRowSelect: onRowSelect
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content-heading' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'expired_inventories' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/inventories', className: 'btn btn-green marginLeftStyle' },
	                            _react2.default.createElement('em', { className: 'fa fa-mail-reply' })
	                        ),
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/inventories/relocation', type: 'button', className: 'btn btn-primary marginLeftStyle' },
	                            _react2.default.createElement('em', { className: 'icon-hourglass marginRightStyle' }),
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_relocation' })
	                        ),
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/inventories/adjustment', type: 'button', className: 'btn btn-primary marginLeftStyle' },
	                            _react2.default.createElement('em', { className: 'icon-envelope-letter marginRightStyle' }),
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_adjustment' })
	                        )
	                    )
	                ),
	                _react2.default.createElement('br', null),
	                this.renderTable(),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 2 },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement('div', { className: 'iconblue' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'on_stock' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 2 },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement('div', { className: 'iconred' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'off_stock' })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return InventoryExpired;
	}(_react.Component);
	
	InventoryExpired.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = InventoryExpired;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryExpired.jsx');
	
	    __REACT_HOT_LOADER__.register(InventoryExpired, 'InventoryExpired', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryExpired.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryExpired.jsx');
	}();

	;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle} from '../Common/style'
	
	var RowRenderer = function (_Component) {
	    _inherits(RowRenderer, _Component);
	
	    function RowRenderer() {
	        _classCallCheck(this, RowRenderer);
	
	        return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	    }
	
	    _createClass(RowRenderer, [{
	        key: 'setScrollLeft',
	        value: function setScrollLeft(scrollBy) {
	            // To freeze couple columns
	            this.refs.row.setScrollLeft(scrollBy);
	        }
	    }, {
	        key: 'getRowStyle',
	        value: function getRowStyle() {
	            return {
	                color: this.getRowBackground()
	            };
	        }
	    }, {
	        key: 'getRowBackground',
	        value: function getRowBackground() {
	            return this.props.row.InStock > 0 ? _constants.BACKGROUND_COLOR.blue : _constants.BACKGROUND_COLOR.red;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            //here we are just changing the style
	            //but we could replace this with anything we liked, cards, images, etc
	            //usually though it will just be a matter of wrapping a div, and then calling back through to the grid
	            return _react2.default.createElement(
	                'div',
	                { style: this.getRowStyle() },
	                _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	            );
	        }
	    }]);
	
	    return RowRenderer;
	}(_react.Component);
	
	var InventoryLowStock = function (_Component2) {
	    _inherits(InventoryLowStock, _Component2);
	
	    function InventoryLowStock() {
	        _classCallCheck(this, InventoryLowStock);
	
	        var _this2 = _possibleConstructorReturn(this, (InventoryLowStock.__proto__ || Object.getPrototypeOf(InventoryLowStock)).call(this));
	
	        _this2.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton,
	
	            rows: [],
	            selectedRows: null,
	            editedRows: [],
	            filters: {},
	            sortColumn: null,
	            sortDirection: null,
	            gourpOpen: false
	        };
	
	        _this2.handleResize = _this2.handleResize.bind(_this2);
	        _this2.zoneLevel = _this2.zoneLevel.bind(_this2);
	        return _this2;
	    }
	
	    _createClass(InventoryLowStock, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchLowStockInventoryInventories();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once inventories is ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var PT = nextProps.inventories;
	            if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
	                var newInventories = [].concat(_toConsumableArray(nextProps.inventories));
	                newInventories.map(function (inventory) {
	                    inventory["ProductName"] = inventory["ProductNum"].Name;
	                    inventory["Description"] = inventory["ProductNum"].Description;
	                    inventory["PackageSize"] = inventory["ProductNum"].PackageSize;
	                    inventory["LowestAmount"] = inventory["ProductNum"].MinStockRange;
	                    inventory["ProductNum"] = inventory["ProductNum"].ProductNum;
	                    // inventory["Warehouse"] = inventory["Warehouse_id"].Name;
	                });
	                this.setState({
	                    rows: newInventories
	                });
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton });
	        }
	
	        // Set inventories being selected to be currentInventory and navigate user to the edit page
	        // test
	
	    }, {
	        key: 'setCurrentInventory',
	        value: function setCurrentInventory(e) {
	            e.preventDefault();
	            var currentInventory = this.state.selectedRows[0];
	            this.props.selectInventory(currentInventory);
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            this.props.resetCurrentInventory();
	        }
	    }, {
	        key: 'zoneLevel',
	        value: function zoneLevel(e) {
	            e.preventDefault();
	            var currentInventory = this.state.selectedRows[0];
	            this.props.resetCurrentInventory();
	            this.props.selectInventory(currentInventory);
	            this.context.router.push('/inventories/detail/');
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this3 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this3.state);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    _this3.setState.apply(_this3, _toConsumableArray(_this3.state).concat([{ selectedRows: rows }]));
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this3.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this3.setState(state);
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this3.state.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    _this3.setState({ filters: newFilters });
	                };
	
	                // Handle the editable function
	
	                var handleRowUpdated = function handleRowUpdated(e) {
	                    // merge updated row with current row and rerender by setting state
	                    var rows = _this3.state.rows.slice(0);
	                    var editedRows = _this3.state.editedRows.slice(0);
	                    Object.assign(rows[e.rowIdx], e.updated);
	                    // if the element is already edited, remove the old one.
	                    editedRows.forEach(function (element, index) {
	                        if (element.Product_id === rows[e.rowIdx].Product_id) editedRows.splice(index, 1);
	                    }, _this3);
	                    // push the row into the editedRows array
	                    editedRows.push(rows[e.rowIdx]);
	                    _this3.setState({
	                        rows: rows,
	                        editedRows: editedRows
	                    });
	                };
	
	                //Custom Formatter component
	                var IsEnabledFormatter = _react2.default.createClass({
	                    displayName: 'IsEnabledFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-success' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disable' })
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120,
	                    filterable: true
	                }, {
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'PackageSize',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 150,
	                    filterable: true
	                }, {
	                    key: 'Description',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 150,
	                    filterable: true
	                }, {
	                    key: 'RefPurchasingPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'refer_purchasing_price' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 150,
	                    filterable: true
	                }, {
	                    key: 'InStockPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'avg_in_stock_dollarsign' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 150,
	                    filterable: true
	                }, {
	                    key: 'InStock',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'instock' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 90,
	                    filterable: true
	                }, {
	                    key: 'PreSale',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'presale' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 70,
	                    filterable: true
	                }, {
	                    key: 'Purchased',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchased' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 90,
	                    filterable: true
	                }, {
	                    key: 'LowestAmount',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lowest_amount' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 150,
	                    filterable: true
	                }, {
	                    key: 'Warehouse',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200,
	                    filterable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'InventoryLowStock-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowRenderer: RowRenderer,
	                                rowKey: 'id',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: this.state.tableHeight,
	                                onRowUpdated: handleRowUpdated,
	                                enableRowSelect: 'single',
	                                onRowSelect: onRowSelect
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content-heading' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'low_stock_inventories' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/inventories', className: 'btn btn-green marginLeftStyle' },
	                            _react2.default.createElement('em', { className: 'fa fa-mail-reply' })
	                        ),
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/inventories/relocation', type: 'button', className: 'btn btn-primary marginLeftStyle' },
	                            _react2.default.createElement('em', { className: 'icon-hourglass marginRightStyle' }),
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_relocation' })
	                        ),
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/inventories/adjustment', type: 'button', className: 'btn btn-primary marginLeftStyle' },
	                            _react2.default.createElement('em', { className: 'icon-envelope-letter marginRightStyle' }),
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_adjustment' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            { className: 'btn btn-primary marginLeftStyle',
	                                disabled: !this.state.selectedRows || this.state.selectedRows.length != 1,
	                                onClick: this.zoneLevel },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_level' })
	                        )
	                    )
	                ),
	                _react2.default.createElement('br', null),
	                this.renderTable(),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 2 },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement('div', { className: 'iconblue' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'on_stock' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 2 },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement('div', { className: 'iconred' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'off_stock' })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return InventoryLowStock;
	}(_react.Component);
	
	InventoryLowStock.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = InventoryLowStock;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryLowStock.jsx');
	
	    __REACT_HOT_LOADER__.register(InventoryLowStock, 'InventoryLowStock', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryLowStock.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryLowStock.jsx');
	}();

	;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _datePicker = __webpack_require__(27);
	
	var _datePicker2 = _interopRequireDefault(_datePicker);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style'
	
	var InventoryRelocationForm = function (_Component) {
	    _inherits(InventoryRelocationForm, _Component);
	
	    function InventoryRelocationForm() {
	        _classCallCheck(this, InventoryRelocationForm);
	
	        var _this = _possibleConstructorReturn(this, (InventoryRelocationForm.__proto__ || Object.getPrototypeOf(InventoryRelocationForm)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	            orderNum: 0,
	
	            inventories: {
	                rows: [],
	                selectedRows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            relocatedInventories: {
	                rows: [],
	                selectedRows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            }
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        return _this;
	    }
	
	    _createClass(InventoryRelocationForm, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            window.addEventListener('resize', this.handleResize);
	            var currentInventoryRelocation = this.props.currentInventoryRelocation;
	
	            this.props.fetchWarehouses();
	            this.props.fetchWarehouseDetail(1);
	            if (currentInventoryRelocation) {
	                this.props.fetchInventoryRelocationDetail(currentInventoryRelocation.WarehouseRelocation_id).then(function () {
	                    _this2.props.fetchInventories();
	                });
	            } else this.props.fetchInventories();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once inventories are ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.Default_Warehouse_id && nextProps.Default_Warehouse_id != this.props.Default_Warehouse_id) {
	                if (nextProps.Default_Warehouse_id.value) this.props.fetchWarehouseDetail(nextProps.Default_Warehouse_id.value);
	            }
	            if (nextProps.currentInventoryRelocationDetail && nextProps.currentInventoryRelocationDetail != this.props.currentInventoryRelocationDetail) {
	                var orderNum = 0;
	                var warehouse_Relocation_Line = [].concat(_toConsumableArray(nextProps.currentInventoryRelocationDetail.Warehouse_Relocation_Line));
	                warehouse_Relocation_Line.map(function (relocation) {
	                    orderNum = Math.max(orderNum, relocation.Pairid);
	                    relocation.ZoneName = relocation.WarehouseZone_id.Name;
	                    relocation.BinName = relocation.WarehouseBin_id.Name;
	                });
	                orderNum = orderNum + 1;
	                var relocatedInventories = _extends({}, this.state.relocatedInventories, { rows: warehouse_Relocation_Line });
	                this.setState({ relocatedInventories: relocatedInventories, orderNum: orderNum });
	            }
	            if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
	                var inventories = [];
	                inventories = [].concat(_toConsumableArray(nextProps.inventories));
	                inventories = inventories.filter(function (obj) {
	                    return obj.BinAmount > 0;
	                });
	                var newInventories = _extends({}, this.state.inventories, { rows: inventories });
	                this.setState({
	                    inventories: newInventories
	                });
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	        }
	    }, {
	        key: 'setInventoryToRelocate',
	        value: function setInventoryToRelocate(e) {
	            e.preventDefault();
	            var _state = this.state,
	                inventories = _state.inventories,
	                relocatedInventories = _state.relocatedInventories,
	                orderNum = _state.orderNum;
	
	            var inventoryToLocate = _extends({}, inventories.selectedRows[0], {
	                Pairid: orderNum,
	                Quantity: "-" + this.props.quantityValue
	            });
	
	            var inventoryRelocated = _extends({}, inventories.selectedRows[0], {
	                Pairid: orderNum,
	                ZoneName: this.props.toZoneValue.value,
	                BinName: this.props.toBinValue,
	                Quantity: '+' + this.props.quantityValue
	            });
	
	            var newRelocatedInventories = _extends({}, relocatedInventories);
	            var newInventories = _extends({}, inventories);
	            newRelocatedInventories.rows.push(inventoryToLocate);
	            newRelocatedInventories.rows.push(inventoryRelocated);
	
	            // const index = _.findIndex(inventories.rows, { 'Vendor_id': inventories.selectedRows[0].Vendor_id });
	            // if (index > -1) {
	            //     newInventories.rows.splice(index, 1);
	            // }
	            // newInventories.selectedRows = [];
	            this.setState({
	                relocatedInventories: newRelocatedInventories,
	                inventories: newInventories,
	                orderNum: orderNum + 1
	            });
	        }
	    }, {
	        key: 'cancelInventoryRelocation',
	        value: function cancelInventoryRelocation(e) {
	            e.preventDefault();
	            var _state2 = this.state,
	                inventories = _state2.inventories,
	                relocatedInventories = _state2.relocatedInventories;
	
	            var inventoryToCancel = _extends({}, relocatedInventories.selectedRows[0]);
	            var OrderID = relocatedInventories.selectedRows[0].Pairid;
	
	            // const newRelocatedInventories = { ...relocatedInventories };
	
	            var newRelocatedInventoriesRows = [].concat(_toConsumableArray(relocatedInventories.rows));
	            // let newInventoriesRows = [ ...inventories.rows ];
	            // let newTargetInventoriesRows = [ ...targetInventories.rows ];
	
	            var index = _lodash2.default.findIndex(newRelocatedInventoriesRows, { 'Pairid': OrderID });
	            if (index > -1 && parseInt(newRelocatedInventoriesRows[index].Quantity) > 0) {
	                newRelocatedInventoriesRows.splice(index, 1);
	                index = _lodash2.default.findIndex(newRelocatedInventoriesRows, { 'Pairid': OrderID });
	                newRelocatedInventoriesRows.splice(index, 1);
	            } else if (index > -1) {
	                newRelocatedInventoriesRows.splice(index, 1);
	                index = _lodash2.default.findIndex(newRelocatedInventoriesRows, { 'Pairid': OrderID });
	                newRelocatedInventoriesRows.splice(index, 1);
	            }
	
	            var newRelocatedInventories = _extends({}, relocatedInventories, { rows: newRelocatedInventoriesRows });
	
	            newRelocatedInventories.selectedRows = [];
	            this.setState({
	                relocatedInventories: newRelocatedInventories
	            });
	        }
	    }, {
	        key: 'createRelocation',
	        value: function createRelocation(e) {
	            e.preventDefault();
	            if (this.props.currentInventoryRelocationDetail) {
	                if (!this.checkPermission("change_warehouse_relocation")) this.props.editInventoryRelocation(this.props.currentInventoryRelocationDetail.WarehouseRelocation_id, 1, this.props.postingDate, this.props.note, _reactDataGridAddons.Data.Selectors.getRows(this.state.relocatedInventories));else alert("You have no permission!");
	            } else this.props.createInventoryRelocation(1, this.props.postingDate, this.props.note, _reactDataGridAddons.Data.Selectors.getRows(this.state.relocatedInventories));
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this3 = this;
	
	            if (this.props.vendorIsLoading && !this.props.vendorError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.vendorError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    this.props.vendorError
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.inventories);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var inventories = _extends({}, _this3.state.inventories, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this3.setState({ inventories: inventories });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this3.state.inventories.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var inventories = _extends({}, _this3.state.inventories, { filters: newFilters });
	                    _this3.setState({ inventories: inventories });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var inventories = _extends({}, _this3.state.inventories, { selectedRows: rows });
	                    _this3.setState({ inventories: inventories });
	                };
	
	                //Custom Formatter component
	
	                var NameFormatter = _react2.default.createClass({
	                    displayName: 'NameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'ProductDescription',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'ProductUnitOfMeasure',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_of_measure' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'BinAmount',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin_amount' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'ZoneName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_name' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'BinName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin_name' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'Batch_PONum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'ExpiredDate',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'expired_date' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    formatter: DateFormatter
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'InventoryRelocationForm-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'id',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: 200,
	                                enableRowSelect: 'single',
	                                onRowUpdated: this.handleRowUpdated,
	                                onRowSelect: onRowSelect })
	                        )
	                    )
	                );
	            }
	        }
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderRelocatedTable',
	        value: function renderRelocatedTable() {
	            var _this4 = this;
	
	            if (this.props.vendorIsLoading && !this.props.vendorError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.vendorError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    this.props.vendorError
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.relocatedInventories);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var relocatedInventories = _extends({}, _this4.state.relocatedInventories, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this4.setState({ relocatedInventories: relocatedInventories });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this4.state.relocatedInventories.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var relocatedInventories = _extends({}, _this4.state.relocatedInventories, { filters: newFilters });
	                    _this4.setState({ relocatedInventories: relocatedInventories });
	                };
	
	                // Handle the Dragable cell function
	
	                var handleCellDrag = function handleCellDrag(e) {
	                    var relocatedInventories = _this4.state.relocatedInventories;
	
	                    var rows = relocatedInventories.rows.slice(0);
	                    for (var i = e.fromRow; i <= e.toRow; i++) {
	                        var rowToUpdate = rows[i];
	                        rowToUpdate[e.cellKey] = e.value;
	                    }
	                    var newRelocatedInventories = _extends({}, relocatedInventories, { rows: rows });
	                    _this4.setState({
	                        relocatedInventories: newRelocatedInventories
	                    });
	                };
	
	                // Handle the editable function
	
	                var handleRowUpdated = function handleRowUpdated(e) {
	                    // merge updated row with current row and rerender by setting state
	                    var relocatedInventories = _this4.state.relocatedInventories;
	
	                    var rows = getRows(); //relocatedInventories.rows.slice(0);
	                    Object.assign(rows[e.rowIdx], e.updated);
	                    var newRelocatedInventories = _extends({}, relocatedInventories, { rows: rows });
	                    _this4.setState({
	                        relocatedInventories: newRelocatedInventories
	                    });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var relocatedInventories = _extends({}, _this4.state.relocatedInventories, { selectedRows: rows });
	                    _this4.setState({ relocatedInventories: relocatedInventories });
	                };
	
	                //Custom Formatter component
	
	                var NameFormatter = _react2.default.createClass({
	                    displayName: 'NameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120,
	                    filterable: true
	                }, {
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 90,
	                    filterable: true
	                }, {
	                    key: 'Quantity',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'relocate_quantity' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200,
	                    filterable: true,
	                    editable: true
	                }, {
	                    key: 'ZoneName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200,
	                    filterable: true,
	                    editable: true
	                }, {
	                    key: 'BinName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin_name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200,
	                    filterable: true,
	                    editable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'InventoryRelocationForm-dataGrid2' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'Pairid',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: 200,
	                                enableRowSelect: 'single',
	                                onCellsDragged: handleCellDrag,
	                                enableCellSelect: true,
	                                onRowUpdated: handleRowUpdated,
	                                onRowSelect: onRowSelect })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderProducts',
	        value: function renderProducts(bin) {
	            var products = bin.Product;
	            if (products) {
	                return products.map(function (product) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'marginTopStyle' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            ' ',
	                            product.Name,
	                            ' '
	                        )
	                    );
	                });
	            }
	        }
	    }, {
	        key: 'renderBins',
	        value: function renderBins() {
	            var _this5 = this;
	
	            var _props = this.props,
	                currentZoneDetail = _props.currentZoneDetail,
	                bins = _props.bins,
	                detailError = _props.detailError,
	                detailIsLoading = _props.detailIsLoading;
	
	            if (detailIsLoading && !detailError) return _react2.default.createElement(_spinner2.default, { className: 'marginTopStyle' });else if (detailError) return _react2.default.createElement(
	                'div',
	                { className: 'alert alert-danger' },
	                JSON.stringify(this.props.detailError)
	            );
	            if (bins) {
	                return bins.map(function (bin) {
	                    var Name = bin.Name,
	                        Description = bin.Description,
	                        WarehouseBin_id = bin.WarehouseBin_id;
	
	                    return _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 12 },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 12 },
	                                            _react2.default.createElement('em', { className: 'fa fa-institution marginRightStyle' }),
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin' }),
	                                                ' ',
	                                                Name || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 12 },
	                                            _react2.default.createElement('em', { className: 'fa fa-institution marginRightStyle' }),
	                                            _react2.default.createElement(
	                                                'b',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'id' }),
	                                                ' ',
	                                                WarehouseBin_id || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehousebin_id' })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 12 },
	                                            _react2.default.createElement('em', { className: 'fa fa-building marginLeftStyle marginRightStyle' }),
	                                            currentZoneDetail && currentZoneDetail.Name || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_name' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Products:'
	                                        )
	                                    ),
	                                    _this5.renderProducts(bin)
	                                )
	                            )
	                        )
	                    );
	                });
	            }
	        }
	    }, {
	        key: 'getWarehouseOptions',
	        value: function getWarehouseOptions() {
	            var warehouseOptions = [];
	            this.props.warehouses.map(function (warehouse) {
	                warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name });
	            });
	            return warehouseOptions;
	        }
	    }, {
	        key: 'getZoneOptions',
	        value: function getZoneOptions() {
	            var zoneOptions = [];
	            if (this.props.currentWarehouseDetail) {
	                this.props.currentWarehouseDetail.Warehouse_Zone.map(function (zone) {
	                    zoneOptions.push({ value: zone.Name, label: zone.Name });
	                });
	            }
	            return zoneOptions;
	        }
	    }, {
	        key: 'getZoneOptionsByID',
	        value: function getZoneOptionsByID() {
	            var zoneOptions = [];
	            if (this.props.currentWarehouseDetail) {
	                this.props.currentWarehouseDetail.Warehouse_Zone.map(function (zone) {
	                    zoneOptions.push({ value: zone.WarehouseZone_id, label: zone.Name });
	                });
	            }
	            return zoneOptions;
	        }
	    }, {
	        key: 'zoneDetail',
	        value: function zoneDetail(e) {
	            e.preventDefault();
	            this.props.fetchZoneDetail(this.props.Default_WarehouseZone_id.value);
	        }
	    }, {
	        key: 'checkPermission',
	        value: function checkPermission(permission) {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            var inventoryRelocationWarehouseLoc = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_relocation_warehouse_location' });
	            var inventoryRelocationSheetWarehouseLoc = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_relocation_sheet_warehouse_location' });
	            var _state3 = this.state,
	                inventories = _state3.inventories,
	                relocatedInventories = _state3.relocatedInventories;
	
	            var warehouseOptions = this.getWarehouseOptions();
	            var zoneOptions = this.getZoneOptions();
	            var zoneOptionsById = this.getZoneOptionsByID();
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content-heading' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_relocation' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/inventories/relocation', className: 'btn btn-green buttonStyle' },
	                            _react2.default.createElement('em', { className: 'fa fa-mail-reply' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'pull-right' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: 'btn btn-primary buttonStyle',
	                                    onClick: function onClick(e) {
	                                        return _this6.createRelocation(e);
	                                    } },
	                                _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 9 },
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'marginTopStyle' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                _reactBootstrap.Panel,
	                                { header: inventoryRelocationWarehouseLoc },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_inventory' })
	                                ),
	                                _react2.default.createElement('hr', null),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_select_an_inventory_to_relocate' })
	                                ),
	                                this.renderTable(),
	                                _react2.default.createElement(
	                                    'h4',
	                                    { className: 'marginTopStyleLarge' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'relocation' })
	                                ),
	                                _react2.default.createElement('hr', null),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'relocate_some_or_all_of_the_selected_inventory' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                inventories.selectedRows[0] ? inventories.selectedRows[0].ProductNum : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_an_inventory' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                inventories.selectedRows[0] ? inventories.selectedRows[0].ProductName : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_an_inventory' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_type' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                inventories.selectedRows[0] ? inventories.selectedRows[0].ProductUnitOfMeasure : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_an_inventory' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	                                                    ' (',
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' }),
	                                                    ')'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                inventories.selectedRows[0] ? inventories.selectedRows[0].Batch_PONum : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_an_inventory' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_zone' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                inventories.selectedRows[0] ? inventories.selectedRows[0].ZoneName : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_an_inventory' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_bin' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                inventories.selectedRows[0] ? inventories.selectedRows[0].BinName : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_an_inventory' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_quantity' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                inventories.selectedRows[0] ? inventories.selectedRows[0].BinAmount : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_an_inventory' })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 12 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'relocation_quantity' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 12 },
	                                                _react2.default.createElement(_reduxForm.Field, { component: _inputField2.default, name: 'Quantity' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 12 },
	                                                inventories.selectedRows[0] && parseInt(this.props.quantityValue) > parseInt(inventories.selectedRows[0].CreditStatus) && _react2.default.createElement(
	                                                    'p',
	                                                    { className: 'parsley-error-message' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_relocation_qty_cannot_exceed_current_qty' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 12 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'relocation_destination' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_select_warehouse' })
	                                                ),
	                                                _react2.default.createElement(_reduxForm.Field, { name: 'Default_Warehouse_id', component: _selection2.default, options: warehouseOptions })
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_select_warehouse_zone' })
	                                                ),
	                                                _react2.default.createElement(_reduxForm.Field, { name: 'ToZone', component: _selection2.default, options: zoneOptions })
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_select_warehouse_bin' })
	                                                ),
	                                                _react2.default.createElement(_reduxForm.Field, { component: _inputField2.default, name: 'ToBin' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'button',
	                                            {
	                                                className: 'btn btn-primary pull-right',
	                                                onClick: function onClick(e) {
	                                                    return _this6.setInventoryToRelocate(e);
	                                                },
	                                                disabled: !inventories.selectedRows[0] || parseInt(this.props.quantityValue) > parseInt(inventories.selectedRows[0].CreditStatus) },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Panel,
	                                { header: inventoryRelocationSheetWarehouseLoc },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_relocation_sheet' })
	                                ),
	                                _react2.default.createElement('hr', null),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'list_of_inventory_relocation_lines' })
	                                ),
	                                this.renderRelocatedTable(),
	                                _react2.default.createElement(
	                                    'button',
	                                    {
	                                        className: 'btn btn-warning pull-right marginTopStyle',
	                                        onClick: function onClick(e) {
	                                            return _this6.cancelInventoryRelocation(e);
	                                        },
	                                        disabled: !relocatedInventories.selectedRows[0] },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 7 },
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'relocation_date' }),
	                                ': '
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6, className: 'marginBottomStyle' },
	                                _react2.default.createElement(_reduxForm.Field, { selected: new Date(), component: _datePicker.DisabledDatePicker, name: 'PostingDate' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'modifier' }),
	                                ': '
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(_reduxForm.Field, { component: _inputField2.default, name: 'Modify_Username' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 3 },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	                                ': '
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 9 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Note', component: 'Textarea', className: 'form-control', style: { minHeight: '100px' } })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 3 },
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_select_warehouse' })
	                            ),
	                            _react2.default.createElement(_reduxForm.Field, { name: 'Default_Warehouse_id', component: _selection2.default, options: warehouseOptions })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_select_warehouse_zone' })
	                            ),
	                            _react2.default.createElement(_reduxForm.Field, { name: 'Default_WarehouseZone_id', component: _selection2.default, options: zoneOptionsById })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    className: 'btn btn-primary marginLeftStyle',
	                                    onClick: function onClick(e) {
	                                        return _this6.zoneDetail(e);
	                                    } },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_detail' })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'marginTopStyle' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { style: { overflow: "hidden" } },
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { style: { overflowY: "scroll", maxHeight: 3 * this.state.tableHeight } },
	                                this.renderBins()
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement('br', null)
	            );
	        }
	    }]);
	
	    return InventoryRelocationForm;
	}(_react.Component);
	
	InventoryRelocationForm.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = InventoryRelocationForm;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(InventoryRelocationForm, 'InventoryRelocationForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryRelocationForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryRelocationForm.jsx');
	}();

	;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _datePicker = __webpack_require__(27);
	
	var _datePicker2 = _interopRequireDefault(_datePicker);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style'
	
	var InventoryRelocationFromInbound = function (_Component) {
	    _inherits(InventoryRelocationFromInbound, _Component);
	
	    function InventoryRelocationFromInbound() {
	        _classCallCheck(this, InventoryRelocationFromInbound);
	
	        var _this = _possibleConstructorReturn(this, (InventoryRelocationFromInbound.__proto__ || Object.getPrototypeOf(InventoryRelocationFromInbound)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	            orderNum: 0,
	
	            inventories: {
	                rows: [],
	                selectedRows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            relocatedInventories: {
	                rows: [],
	                selectedRows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            }
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        return _this;
	    }
	
	    _createClass(InventoryRelocationFromInbound, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            console.log("7");
	            window.addEventListener('resize', this.handleResize);
	            var currentInventoryRelocation = this.props.currentInventoryRelocation;
	
	            if (currentInventoryRelocation) {
	                this.props.fetchInventoryRelocationDetail(currentInventoryRelocation.WarehouseRelocation_id).then(function () {
	                    _this2.props.fetchInventories();
	                });
	            } else this.props.fetchInventories();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once inventories are ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.currentWarehouseReceive) {
	                console.log("61");
	                console.log(nextProps.currentWarehouseReceive);
	            }
	            if (nextProps.currentInventoryRelocationDetail && nextProps.currentInventoryRelocationDetail != this.props.currentInventoryRelocationDetail) {
	                var orderNum = 0;
	                var warehouse_Relocation_Line = nextProps.currentInventoryRelocationDetail.Warehouse_Relocation_Line;
	                warehouse_Relocation_Line.map(function (relocation) {
	                    orderNum = Math.max(orderNum, relocation.Pairid);
	                });
	                orderNum = orderNum + 1;
	                var relocatedInventories = _extends({}, this.state.relocatedInventories, { rows: nextProps.currentInventoryRelocationDetail.Warehouse_Relocation_Line });
	                this.setState({ relocatedInventories: relocatedInventories, orderNum: orderNum });
	            }
	            if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
	                var inventories = _extends({}, this.state.inventories, { rows: nextProps.inventories });
	                this.setState({
	                    inventories: inventories
	                });
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	        }
	
	        // setInventoryToRelocate(e) {
	        //     e.preventDefault();
	        //     const { inventories, relocatedInventories, orderNum } = this.state;
	        //     const inventoryToLocate = { ...inventories.selectedRows[0],
	        //         Pairid: orderNum,
	        //         WarehouseZone_id: inventories.selectedRows[0].WarehouseZone_id,
	        //         WarehouseBin_id: inventories.selectedRows[0].WarehouseBin_id,
	        //         Quantity: "-" + this.props.quantityValue
	        //     };
	        //
	        //     const inventoryRelocated = { ...inventories.selectedRows[0],
	        //         Pairid: orderNum,
	        //         WarehouseZone_id: this.props.toZoneValue,
	        //         WarehouseBin_id: this.props.toBinValue,
	        //         Quantity: '+' + this.props.quantityValue
	        //     }
	        //
	        //     const newRelocatedInventories = { ...relocatedInventories };
	        //     const newInventories = { ...inventories };
	        //     newRelocatedInventories.rows.push(inventoryToLocate)
	        //     newRelocatedInventories.rows.push(inventoryRelocated)
	        //
	        //     // const index = _.findIndex(inventories.rows, { 'Vendor_id': inventories.selectedRows[0].Vendor_id });
	        //     // if (index > -1) {
	        //     //     newInventories.rows.splice(index, 1);
	        //     // }
	        //     // newInventories.selectedRows = [];
	        //     this.setState({
	        //         relocatedInventories: newRelocatedInventories,
	        //         inventories: newInventories,
	        //         orderNum: orderNum+1
	        //     })
	        // }
	
	    }, {
	        key: 'cancelInventoryRelocation',
	        value: function cancelInventoryRelocation(e) {
	            e.preventDefault();
	            var _state = this.state,
	                inventories = _state.inventories,
	                relocatedInventories = _state.relocatedInventories;
	
	            var inventoryToCancel = _extends({}, relocatedInventories.selectedRows[0]);
	            var OrderID = relocatedInventories.selectedRows[0].Pairid;
	
	            // const newRelocatedInventories = { ...relocatedInventories };
	
	            var newRelocatedInventoriesRows = [].concat(_toConsumableArray(relocatedInventories.rows));
	            // let newInventoriesRows = [ ...inventories.rows ];
	            // let newTargetInventoriesRows = [ ...targetInventories.rows ];
	
	            var index = _lodash2.default.findIndex(newRelocatedInventoriesRows, { 'Pairid': OrderID });
	            if (index > -1 && parseInt(newRelocatedInventoriesRows[index].Quantity) > 0) {
	                newRelocatedInventoriesRows.splice(index, 1);
	                index = _lodash2.default.findIndex(newRelocatedInventoriesRows, { 'Pairid': OrderID });
	                newRelocatedInventoriesRows.splice(index, 1);
	            } else if (index > -1) {
	                newRelocatedInventoriesRows.splice(index, 1);
	                index = _lodash2.default.findIndex(newRelocatedInventoriesRows, { 'Pairid': OrderID });
	                newRelocatedInventoriesRows.splice(index, 1);
	            }
	
	            var newRelocatedInventories = _extends({}, relocatedInventories, { rows: newRelocatedInventoriesRows });
	
	            newRelocatedInventories.selectedRows = [];
	            this.setState({
	                relocatedInventories: newRelocatedInventories
	            });
	        }
	    }, {
	        key: 'createRelocation',
	        value: function createRelocation(e) {
	            e.preventDefault();
	            if (this.props.currentInventoryRelocationDetail) {
	                this.props.editInventoryRelocation(this.props.currentInventoryRelocationDetail.WarehouseRelocation_id, 1, this.props.postingDate, this.props.note, _reactDataGridAddons.Data.Selectors.getRows(this.state.relocatedInventories));
	            } else this.props.createInventoryRelocation(1, this.props.postingDate, this.props.note, _reactDataGridAddons.Data.Selectors.getRows(this.state.relocatedInventories));
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	        // renderTable() {
	        //     if (this.props.vendorIsLoading && !this.props.vendorError) return <Spinner/>
	        //     else if (this.props.vendorError) return <ContentWrapper><div className="alert alert-danger">{this.props.vendorError}</div></ContentWrapper>
	        //     else {
	        //         // Parameters of the react-data-grid
	        //
	        //         const getRows = () => {
	        //             return Data.Selectors.getRows(this.state.inventories);
	        //         }
	        //
	        //         const getSize = () => {
	        //             return getRows().length;
	        //         }
	        //
	        //         const rowGetter = rowIdx => {
	        //             var rows = getRows();
	        //             return rows[rowIdx];
	        //         }
	        //
	        //         // Handle the sortable function
	        //
	        //         const handleGridSort = (sortColumn, sortDirection) => {
	        //             var inventories = {...this.state.inventories, sortColumn: sortColumn, sortDirection: sortDirection };
	        //             this.setState({ inventories });
	        //         }
	        //
	        //         const handleFilterChange = filter => {
	        //             let newFilters = Object.assign({}, this.state.inventories.filters);
	        //             if (filter.filterTerm) {
	        //                 newFilters[filter.column.key] = filter;
	        //             } else {
	        //                 delete newFilters[filter.column.key];
	        //             }
	        //             const inventories = {...this.state.inventories, filters: newFilters }
	        //             this.setState({ inventories });
	        //         }
	        //
	        //         // Handle the row select function
	        //
	        //         const onRowSelect = rows => {
	        //             const inventories = {...this.state.inventories, selectedRows: rows }
	        //             this.setState({ inventories });
	        //         }
	        //
	        //         //Custom Formatter component
	        //
	        //         const NameFormatter = React.createClass({
	        //             render() {
	        //                 if (this.props.value) return <span>{this.props.value.Name}</span>;
	        //                 else return <span className="label label-danger">-</span>;
	        //             }
	        //         });
	        //
	        //         // Column difinition
	        //
	        //         const columns = [
	        //             {
	        //                 key: 'ProductName',
	        //                 name: 'Name',
	        //                 resizable: true,
	        //                 sortable: true,
	        //                 filterable: true
	        //             },
	        //             {
	        //                 key: 'ProductNum',
	        //                 name: 'No.',
	        //                 resizable: true,
	        //                 sortable: true,
	        //                 filterable: true
	        //             },
	        //             {
	        //                 key: 'ProductDescription',
	        //                 name: 'Description',
	        //                 resizable: true,
	        //                 sortable: true,
	        //                 filterable: true
	        //             },
	        //             {
	        //                 key: 'ProductUnitOfMeasure',
	        //                 name: 'Unit Of Measure',
	        //                 resizable: true,
	        //                 sortable: true,
	        //                 filterable: true
	        //             },
	        //             {
	        //                 key: 'Pallet',
	        //                 name: 'Pallet',
	        //                 resizable: true,
	        //                 sortable: true,
	        //                 filterable: true
	        //             },
	        //             {
	        //                 key: 'BinAmount',
	        //                 name: 'Bin Amount',
	        //                 resizable: true,
	        //                 sortable: true,
	        //                 filterable: true
	        //             },
	        //             {
	        //                 key: 'WarehouseZone_id',
	        //                 name: 'Warehouse Zone id',
	        //                 resizable: true,
	        //                 sortable: true,
	        //                 filterable: true
	        //             },
	        //             {
	        //                 key: 'WarehouseBin_id',
	        //                 name: 'Warehouse Bin id',
	        //                 resizable: true,
	        //                 sortable: true,
	        //                 filterable: true
	        //             },
	        //             {
	        //                 key: 'Batch_PONum',
	        //                 name: 'Batch PONum',
	        //                 resizable: true,
	        //                 sortable: true,
	        //                 filterable: true
	        //             },
	        //             {
	        //                 key: 'ExpiredDate',
	        //                 name: 'Expired Date',
	        //                 resizable: true,
	        //                 sortable: true,
	        //                 filterable: true
	        //             }
	        //         ]
	        //
	        //         return (
	        //             <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }}>
	        //                 <ReactDataGrid
	        //                     rowKey='id'
	        //                     onGridSort={handleGridSort}
	        //                     toolbar={<Toolbar enableFilter={true}/>}
	        //                     onAddFilter={handleFilterChange}
	        //                     columns={columns}
	        //                     rowGetter={rowGetter}
	        //                     rowsCount={getSize() }
	        //                     minHeight={200}
	        //                     enableRowSelect='single'
	        //                     onRowUpdated={this.handleRowUpdated}
	        //                     onRowSelect={onRowSelect} />
	        //             </div></Col></Row>
	        //         )
	        //     }
	        // }
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderRelocatedTable',
	        value: function renderRelocatedTable() {
	            var _this3 = this;
	
	            if (this.props.vendorIsLoading && !this.props.vendorError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.vendorError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    this.props.vendorError
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.relocatedInventories);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var relocatedInventories = _extends({}, _this3.state.relocatedInventories, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this3.setState({ relocatedInventories: relocatedInventories });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this3.state.relocatedInventories.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var relocatedInventories = _extends({}, _this3.state.relocatedInventories, { filters: newFilters });
	                    _this3.setState({ relocatedInventories: relocatedInventories });
	                };
	
	                // Handle the Dragable cell function
	
	                var handleCellDrag = function handleCellDrag(e) {
	                    var relocatedInventories = _this3.state.relocatedInventories;
	
	                    var rows = relocatedInventories.rows.slice(0);
	                    for (var i = e.fromRow; i <= e.toRow; i++) {
	                        var rowToUpdate = rows[i];
	                        rowToUpdate[e.cellKey] = e.value;
	                    }
	                    var newRelocatedInventories = _extends({}, relocatedInventories, { rows: rows });
	                    _this3.setState({
	                        relocatedInventories: newRelocatedInventories
	                    });
	                };
	
	                // Handle the editable function
	
	                var handleRowUpdated = function handleRowUpdated(e) {
	                    // merge updated row with current row and rerender by setting state
	                    var relocatedInventories = _this3.state.relocatedInventories;
	
	                    var rows = getRows(); //relocatedInventories.rows.slice(0);
	                    Object.assign(rows[e.rowIdx], e.updated);
	                    var newRelocatedInventories = _extends({}, relocatedInventories, { rows: rows });
	                    _this3.setState({
	                        relocatedInventories: newRelocatedInventories
	                    });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var relocatedInventories = _extends({}, _this3.state.relocatedInventories, { selectedRows: rows });
	                    _this3.setState({ relocatedInventories: relocatedInventories });
	                };
	
	                //Custom Formatter component
	
	                var NameFormatter = _react2.default.createClass({
	                    displayName: 'NameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120,
	                    filterable: true
	                }, {
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 90,
	                    filterable: true
	                }, {
	                    key: 'Quantity',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'relocate_quantity' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200,
	                    filterable: true,
	                    editable: true
	                }, {
	                    key: 'WarehouseZone_id',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200,
	                    filterable: true,
	                    editable: true
	                }, {
	                    key: 'WarehouseBin_id',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200,
	                    filterable: true,
	                    editable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'InventoryRelocationFromInbound-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'Pairid',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: 200,
	                                enableRowSelect: 'single',
	                                onCellsDragged: handleCellDrag,
	                                enableCellSelect: true,
	                                onRowUpdated: handleRowUpdated,
	                                onRowSelect: onRowSelect })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _state2 = this.state,
	                inventories = _state2.inventories,
	                relocatedInventories = _state2.relocatedInventories;
	
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content-heading' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_relocation' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/inventories/relocation', className: 'btn btn-green buttonStyle' },
	                            _react2.default.createElement('em', { className: 'fa fa-mail-reply' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'pull-right' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: 'btn btn-primary buttonStyle',
	                                    onClick: function onClick(e) {
	                                        return _this4.createRelocation(e);
	                                    } },
	                                _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'marginTopStyle' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { header: 'Inventory Relocation Sheet | Warehouse Location' },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_relocation_sheet' })
	                            ),
	                            _react2.default.createElement('hr', null),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'list_of_inventory_relocation_lines' })
	                            ),
	                            this.renderRelocatedTable(),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: 'btn btn-warning pull-right marginTopStyle',
	                                    onClick: function onClick(e) {
	                                        return _this4.cancelInventoryRelocation(e);
	                                    },
	                                    disabled: !relocatedInventories.selectedRows[0] },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 7 },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'relocation_date' }),
	                            ': '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6, className: 'marginBottomStyle' },
	                            _react2.default.createElement(_reduxForm.Field, { component: _datePicker2.default, name: 'PostingDate' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'modifier' }),
	                            ': '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(_reduxForm.Field, { component: _inputField2.default, name: 'Modify_Username' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	                            ': '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'Note', component: 'Textarea', className: 'form-control', style: { minHeight: '100px' } })
	                        )
	                    )
	                ),
	                _react2.default.createElement('br', null)
	            );
	        }
	    }]);
	
	    return InventoryRelocationFromInbound;
	}(_react.Component);
	
	InventoryRelocationFromInbound.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = InventoryRelocationFromInbound;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(InventoryRelocationFromInbound, 'InventoryRelocationFromInbound', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryRelocationFromInbound.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryRelocationFromInbound.jsx');
	}();

	;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle} from '../Common/style'
	
	var InventoryRelocations = function (_Component) {
	    _inherits(InventoryRelocations, _Component);
	
	    function InventoryRelocations() {
	        _classCallCheck(this, InventoryRelocations);
	
	        var _this = _possibleConstructorReturn(this, (InventoryRelocations.__proto__ || Object.getPrototypeOf(InventoryRelocations)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	            rows: [],
	            selectedRows: null,
	            editedRows: [],
	            filters: {},
	            sortColumn: null,
	            sortDirection: null,
	            gourpOpen: false
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        return _this;
	    }
	
	    _createClass(InventoryRelocations, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchInventoryRelocations();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once inventoryRelocations is ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var PT = nextProps.inventoryRelocations;
	            if (nextProps.inventoryRelocations && nextProps.inventoryRelocations != this.props.inventoryRelocations) {
	                this.setState({
	                    rows: nextProps.inventoryRelocations
	                });
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	        }
	
	        // Set inventoryRelocations being selected to be currentInventoryRelocation and navigate user to the edit page
	
	    }, {
	        key: 'setCurrentInventoryRelocation',
	        value: function setCurrentInventoryRelocation(e) {
	            e.preventDefault();
	            var currentInventoryRelocation = this.state.selectedRows[0];
	            this.props.resetCurrentInventoryConvert();
	            this.props.selectInventoryRelocation(currentInventoryRelocation);
	            this.context.router.push('/inventories/relocation/' + currentInventoryRelocation.WarehouseRelocation_id);
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            this.props.resetCurrentInventoryRelocation();
	            this.props.resetCurrentInventoryConvert();
	            this.context.router.push('/inventories/relocation/new');
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this2 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this2.setState(state);
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this2.state.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    _this2.setState({ filters: newFilters });
	                };
	
	                // Handle the editable function
	
	                var handleRowUpdated = function handleRowUpdated(e) {
	                    // merge updated row with current row and rerender by setting state
	                    var rows = _this2.state.rows.slice(0);
	                    var editedRows = _this2.state.editedRows.slice(0);
	                    Object.assign(rows[e.rowIdx], e.updated);
	                    // if the element is already edited, remove the old one.
	                    editedRows.forEach(function (element, index) {
	                        if (element.Product_id === rows[e.rowIdx].Product_id) editedRows.splice(index, 1);
	                    }, _this2);
	                    // push the row into the editedRows array
	                    editedRows.push(rows[e.rowIdx]);
	                    _this2.setState({
	                        rows: rows,
	                        editedRows: editedRows
	                    });
	                };
	
	                //Custom Formatter component
	                var IsEnabledFormatter = _react2.default.createClass({
	                    displayName: 'IsEnabledFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-success' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disable' })
	                        );
	                    }
	                });
	
	                var onRowSelect = function onRowSelect(rows) {
	                    _this2.setState({ selectedRows: rows });
	                };
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'WarehouseRelocationNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'record_relocation_no' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    locked: true
	                }, {
	                    key: 'CreateTime',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_date' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'PostingDate',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'relocation_date' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'Modify_Username',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'relocate_user' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    locked: true
	                }, {
	                    key: 'Note',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'InventoryRelocations-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'WarehouseRelocation_id',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: this.state.tableHeight,
	                                onRowUpdated: handleRowUpdated,
	                                enableRowSelect: 'single',
	                                onRowSelect: onRowSelect
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'checkPermission',
	        value: function checkPermission(permission) {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content-heading' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_relocations' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/inventories', className: 'btn btn-green marginLeftStyle' },
	                            _react2.default.createElement('em', { className: 'fa fa-mail-reply' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            { className: 'btn btn-primary marginLeftStyle', onClick: function onClick(e) {
	                                    return _this3.clickNew(e);
	                                }, disabled: this.checkPermission("add_warehouse_relocation") },
	                            _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_inventory_relocation_sheet' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'pull-right' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { className: 'btn btn-primary marginLeftStyle' },
	                                _react2.default.createElement('em', { className: 'fa fa-print marginRightStyle' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { className: 'btn btn-primary marginLeftStyle' },
	                                _react2.default.createElement('em', { className: 'fa fa-trash marginRightStyle' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    className: 'btn btn-primary marginLeftStyle',
	                                    onClick: function onClick(event) {
	                                        _this3.setCurrentInventoryRelocation(event);
	                                    } },
	                                _react2.default.createElement('em', { className: 'fa fa-pencil marginRightStyle' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement('br', null),
	                this.renderTable()
	            );
	        }
	    }]);
	
	    return InventoryRelocations;
	}(_react.Component);
	
	InventoryRelocations.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = InventoryRelocations;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(InventoryRelocations, 'InventoryRelocations', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryRelocations.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryRelocations.jsx');
	}();

	;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _moment3 = __webpack_require__(41);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	__webpack_require__(69);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _datePicker = __webpack_require__(27);
	
	var _datePicker2 = _interopRequireDefault(_datePicker);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style'
	
	(0, _moment4.default)(_moment2.default);
	
	var InventoryRepackageForm = function (_Component) {
	    _inherits(InventoryRepackageForm, _Component);
	
	    function InventoryRepackageForm() {
	        _classCallCheck(this, InventoryRepackageForm);
	
	        var _this = _possibleConstructorReturn(this, (InventoryRepackageForm.__proto__ || Object.getPrototypeOf(InventoryRepackageForm)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	            orderNum: 0,
	
	            inventories: {
	                rows: [],
	                selectedRows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            targetInventories: {
	                rows: [],
	                selectedRows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            repackagedInventories: {
	                rows: [],
	                selectedRows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            }
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        return _this;
	    }
	
	    _createClass(InventoryRepackageForm, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            window.addEventListener('resize', this.handleResize);
	            var currentInventoryRepackage = this.props.currentInventoryRepackage;
	
	            if (currentInventoryRepackage) {
	                this.props.fetchInventoryRepackageDetail(currentInventoryRepackage.WarehouseRepackage_id).then(function () {
	                    _this2.props.fetchInventories();
	                });
	            } else this.props.fetchInventories();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once inventories are ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.currentInventoryRepackageDetail && nextProps.currentInventoryRepackageDetail != this.props.currentInventoryRepackageDetail) {
	                var orderNum = 0;
	                var warehouse_Repackage_Line = nextProps.currentInventoryRepackageDetail.Warehouse_Repackage_Line;
	                warehouse_Repackage_Line.map(function (repackage) {
	                    orderNum = Math.max(orderNum, repackage.Pairid);
	                });
	                orderNum = orderNum + 1;
	                var repackagedInventories = _extends({}, this.state.repackagedInventories, { rows: nextProps.currentInventoryRepackageDetail.Warehouse_Repackage_Line });
	                this.setState({ repackagedInventories: repackagedInventories, orderNum: orderNum });
	            }
	            if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
	                var inventories = _extends({}, this.state.inventories, { rows: nextProps.inventories });
	                var targetInventories = _extends({}, this.state.targetInventories, { rows: nextProps.inventories });
	                this.setState({
	                    inventories: inventories,
	                    targetInventories: targetInventories
	                });
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	        }
	    }, {
	        key: 'setInventoryToRepackage',
	        value: function setInventoryToRepackage(e) {
	            e.preventDefault();
	            var _state = this.state,
	                inventories = _state.inventories,
	                targetInventories = _state.targetInventories,
	                repackagedInventories = _state.repackagedInventories,
	                orderNum = _state.orderNum;
	
	            var inventoryToLocate = _extends({}, inventories.selectedRows[0], {
	                Pairid: orderNum,
	                // Zone: "Hello",
	                // Bin: "Hi",
	                Quantity: "-" + this.props.quantityValue
	            });
	
	            var inventoryRepackaged = _extends({}, targetInventories.selectedRows[0], {
	                Pairid: orderNum,
	                // Zone: this.props.toZoneValue,
	                // Bin: this.props.toBinValue,
	                Quantity: "+" + this.props.repackagedQuantityValue
	            });
	
	            var newRepackagedInventoriesRows = [].concat(_toConsumableArray(repackagedInventories.rows));
	            var newInventoriesRows = [].concat(_toConsumableArray(inventories.rows));
	            var newTargetInventoriesRows = [].concat(_toConsumableArray(targetInventories.rows));
	
	            newRepackagedInventoriesRows.push(inventoryToLocate, inventoryRepackaged);
	
	            // const index = _.findIndex(newInventoriesRows, { 'Vendor_id': inventories.selectedRows[0].Vendor_id });
	            // if (index > -1) {
	            //     newInventoriesRows.splice(index, 1);
	            // }
	            //
	            // const targetIndex = _.findIndex(newTargetInventoriesRows, { 'Vendor_id': targetInventories.selectedRows[0].Vendor_id });
	            // if (targetIndex > -1) {
	            //     newTargetInventoriesRows.splice(targetIndex, 1);
	            // }
	
	            var newRepackagedInventories = _extends({}, repackagedInventories, { rows: newRepackagedInventoriesRows });
	            var newInventories = _extends({}, inventories, { rows: newInventoriesRows });
	            var newTargetInventories = _extends({}, targetInventories, { rows: newTargetInventoriesRows });
	
	            // newInventories.selectedRows = [];
	            // newTargetInventories.selectedRows = [];
	
	            this.setState({
	                repackagedInventories: newRepackagedInventories,
	                inventories: newInventories,
	                targetInventories: newTargetInventories,
	                orderNum: orderNum + 1
	            });
	        }
	    }, {
	        key: 'cancelInventoryRepackage',
	        value: function cancelInventoryRepackage(e) {
	            e.preventDefault();
	            var _state2 = this.state,
	                inventories = _state2.inventories,
	                targetInventories = _state2.targetInventories,
	                repackagedInventories = _state2.repackagedInventories;
	
	            var OrderID = repackagedInventories.selectedRows[0].Pairid;
	
	            var newRepackagedInventoriesRows = [].concat(_toConsumableArray(repackagedInventories.rows));
	            // let newInventoriesRows = [ ...inventories.rows ];
	            // let newTargetInventoriesRows = [ ...targetInventories.rows ];
	
	            var index = _lodash2.default.findIndex(newRepackagedInventoriesRows, { 'Pairid': OrderID });
	            if (index > -1 && parseInt(newRepackagedInventoriesRows[index].Quantity) > 0) {
	                // newTargetInventoriesRows.push({...newRepackagedInventoriesRows[index]})
	                newRepackagedInventoriesRows.splice(index, 1);
	                index = _lodash2.default.findIndex(newRepackagedInventoriesRows, { 'Pairid': OrderID });
	                // newInventoriesRows.push({...newRepackagedInventoriesRows[index]})
	                newRepackagedInventoriesRows.splice(index, 1);
	            } else if (index > -1) {
	                // newInventoriesRows.push({...newRepackagedInventoriesRows[index]})
	                newRepackagedInventoriesRows.splice(index, 1);
	                index = _lodash2.default.findIndex(newRepackagedInventoriesRows, { 'Pairid': OrderID });
	                // newTargetInventoriesRows.push({...newRepackagedInventoriesRows[index]})
	                newRepackagedInventoriesRows.splice(index, 1);
	            }
	
	            var newRepackagedInventories = _extends({}, repackagedInventories, { rows: newRepackagedInventoriesRows });
	            // let newInventories = { ...inventories, rows: newInventoriesRows };
	            // let newTargetInventories = { ...targetInventories, rows: newTargetInventoriesRows };
	
	            newRepackagedInventories.selectedRows = [];
	
	            this.setState({
	                repackagedInventories: newRepackagedInventories
	            });
	        }
	    }, {
	        key: 'createRepackage',
	        value: function createRepackage(e) {
	            e.preventDefault();
	            if (this.props.currentInventoryRepackageDetail) {
	                if (!this.checkPermission("change_warehouse_repackage")) this.props.editInventoryRepackage(this.props.currentInventoryRepackageDetail.WarehouseRepackage_id, 1, this.props.postingDate, this.props.note, _reactDataGridAddons.Data.Selectors.getRows(this.state.repackagedInventories));else alert("You have no permission!");
	            } else this.props.createInventoryRepackage(1, this.props.postingDate, this.props.note, _reactDataGridAddons.Data.Selectors.getRows(this.state.repackagedInventories));
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this3 = this;
	
	            if (this.props.vendorIsLoading && !this.props.vendorError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.vendorError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    this.props.vendorError
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.inventories);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var inventories = _extends({}, _this3.state.inventories, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this3.setState({ inventories: inventories });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this3.state.inventories.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var inventories = _extends({}, _this3.state.inventories, { filters: newFilters });
	                    _this3.setState({ inventories: inventories });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var inventories = _extends({}, _this3.state.inventories, { selectedRows: rows });
	                    _this3.setState({ inventories: inventories });
	                };
	
	                //Custom Formatter component
	
	                var NameFormatter = _react2.default.createClass({
	                    displayName: 'NameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 90,
	                    filterable: true
	                }, {
	                    key: 'ProductDescription',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200,
	                    filterable: true
	                }, {
	                    key: 'Batch_PONum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 90,
	                    filterable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'InventoryRepackageForm-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'id',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: 200,
	                                enableRowSelect: 'single',
	                                onRowUpdated: this.handleRowUpdated,
	                                onRowSelect: onRowSelect })
	                        )
	                    )
	                );
	            }
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTargetTable',
	        value: function renderTargetTable() {
	            var _this4 = this;
	
	            if (this.props.vendorIsLoading && !this.props.vendorError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.vendorError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    this.props.vendorError
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.targetInventories);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var targetInventories = _extends({}, _this4.state.targetInventories, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this4.setState({ targetInventories: targetInventories });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this4.state.targetInventories.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var targetInventories = _extends({}, _this4.state.targetInventories, { filters: newFilters });
	                    _this4.setState({ targetInventories: targetInventories });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var targetInventories = _extends({}, _this4.state.targetInventories, { selectedRows: rows });
	                    _this4.setState({ targetInventories: targetInventories });
	                };
	
	                //Custom Formatter component
	
	                var NameFormatter = _react2.default.createClass({
	                    displayName: 'NameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 90,
	                    filterable: true
	                }, {
	                    key: 'ProductDescription',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200,
	                    filterable: true
	                }, {
	                    key: 'Batch_PONum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 90,
	                    filterable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'InventoryRepackageForm-dataGrid2' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'id',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: 200,
	                                enableRowSelect: 'single',
	                                onRowUpdated: this.handleRowUpdated,
	                                onRowSelect: onRowSelect })
	                        )
	                    )
	                );
	            }
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderRepackagedTable',
	        value: function renderRepackagedTable() {
	            var _this5 = this;
	
	            if (this.props.vendorIsLoading && !this.props.vendorError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.vendorError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    this.props.vendorError
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this5.state.repackagedInventories);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var repackagedInventories = _extends({}, _this5.state.repackagedInventories, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this5.setState({ repackagedInventories: repackagedInventories });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this5.state.repackagedInventories.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var repackagedInventories = _extends({}, _this5.state.repackagedInventories, { filters: newFilters });
	                    _this5.setState({ repackagedInventories: repackagedInventories });
	                };
	
	                // Handle the Dragable cell function
	
	                var handleCellDrag = function handleCellDrag(e) {
	                    var repackagedInventories = _this5.state.repackagedInventories;
	
	                    var rows = repackagedInventories.rows.slice(0);
	                    for (var i = e.fromRow; i <= e.toRow; i++) {
	                        var rowToUpdate = rows[i];
	                        rowToUpdate[e.cellKey] = e.value;
	                    }
	                    var newRepackagedInventories = _extends({}, repackagedInventories, { rows: rows });
	                    _this5.setState({
	                        repackagedInventories: newRepackagedInventories
	                    });
	                };
	
	                // Handle the editable function
	
	                var handleRowUpdated = function handleRowUpdated(e) {
	                    // merge updated row with current row and rerender by setting state
	                    var repackagedInventories = _this5.state.repackagedInventories;
	
	                    var rows = getRows(); //repackagedInventories.rows.slice(0);
	                    Object.assign(rows[e.rowIdx], e.updated);
	                    var newRepackagedInventories = _extends({}, repackagedInventories, { rows: rows });
	                    _this5.setState({
	                        repackagedInventories: newRepackagedInventories
	                    });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var repackagedInventories = _extends({}, _this5.state.repackagedInventories, { selectedRows: rows });
	                    _this5.setState({ repackagedInventories: repackagedInventories });
	                };
	
	                //Custom Formatter component
	
	                var NameFormatter = _react2.default.createClass({
	                    displayName: 'NameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120,
	                    filterable: true
	                }, {
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 90,
	                    filterable: true
	                }, {
	                    key: 'Quantity',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'convert_quantity' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200,
	                    filterable: true,
	                    editable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'InventoryRepackageForm-dataGrid3' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'Pairid',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: 200,
	                                enableRowSelect: 'single',
	                                onCellsDragged: handleCellDrag,
	                                enableCellSelect: true,
	                                onRowUpdated: handleRowUpdated,
	                                onRowSelect: onRowSelect })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'checkPermission',
	        value: function checkPermission(permission) {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            var inventoryRepackageWarehouseLocation = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_repackage_warehouse_loc' });
	            var productRepackage = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_repackage_sheet_product_repackage' });
	            var generalProductRepackage = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_product_repackage' });
	            var _state3 = this.state,
	                inventories = _state3.inventories,
	                targetInventories = _state3.targetInventories,
	                repackagedInventories = _state3.repackagedInventories;
	            var invalid = this.props.invalid;
	
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content-heading' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_repackage' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/inventories/repackage', className: 'btn btn-green buttonStyle' },
	                            _react2.default.createElement('em', { className: 'fa fa-mail-reply' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'pull-right' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: 'btn btn-primary buttonStyle',
	                                    onClick: function onClick(e) {
	                                        return _this6.createRepackage(e);
	                                    } },
	                                _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'marginTopStyle' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 7 },
	                        _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { header: inventoryRepackageWarehouseLocation },
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_inventory' })
	                                ),
	                                _react2.default.createElement('hr', null),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 8 },
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_select_an_inventory_to_repackage' })
	                                    ),
	                                    this.renderTable()
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 4 },
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'details_and_repackage' })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            inventories.selectedRows[0] ? inventories.selectedRows[0].ProductNum : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_inventory' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            inventories.selectedRows[0] ? inventories.selectedRows[0].ProductName : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_inventory' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_type' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            inventories.selectedRows[0] ? inventories.selectedRows[0].ProductUnitOfMeasure : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_inventory' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	                                                ' (',
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' }),
	                                                ') '
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            inventories.selectedRows[0] ? inventories.selectedRows[0].Batch_PONum : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_inventory' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_zone' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            inventories.selectedRows[0] ? inventories.selectedRows[0].ZoneName : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_inventory' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_bin' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            inventories.selectedRows[0] ? inventories.selectedRows[0].BinName : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_inventory' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_quantity' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            inventories.selectedRows[0] ? inventories.selectedRows[0].BinAmount : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_inventory' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'repackage_quantity' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(_reduxForm.Field, { component: _inputField2.default, name: 'Quantity' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 12 },
	                                            inventories.selectedRows[0] && parseInt(this.props.quantityValue) > parseInt(inventories.selectedRows[0].CreditStatus) && _react2.default.createElement(
	                                                'p',
	                                                { className: 'parsley-error-message' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_repackage_qty_cannot_exceed_current_qty' })
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_target_inventory' })
	                                ),
	                                _react2.default.createElement('hr', null),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 8 },
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_select_an_inventory_as_target' })
	                                    ),
	                                    this.renderTargetTable()
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 4 },
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'details_&_repackage' })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].ProductNum : "Please select an inventory"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].ProductName : "Please select an inventory"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_type' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].ProductUnitOfMeasure : "Please select an inventory"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	                                                '(',
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' }),
	                                                ') '
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].Batch_PONum : "Please select an inventory"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_zone' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].ZoneName : "Please select an inventory"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_bin' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].BinName : "Please select an inventory"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_quantity' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].BinAmount : "Please select an inventory"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'repackage_target_quantity' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(_reduxForm.Field, { component: _inputField2.default, name: 'RepackagedQuantity' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'target_weight' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(_reduxForm.Field, { component: _inputField2.default, name: 'Weight' })
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 12 },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            className: 'btn btn-primary pull-right',
	                                            onClick: function onClick(e) {
	                                                return _this6.setInventoryToRepackage(e);
	                                            },
	                                            disabled: !inventories.selectedRows[0] || !targetInventories.selectedRows[0] || invalid || parseInt(this.props.quantityValue) > parseInt(inventories.selectedRows[0].CreditStatus) },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 5 },
	                        _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { header: productRepackage },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_repackage_sheet' })
	                            ),
	                            _react2.default.createElement('hr', null),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'list_of_inventory_repackage_lines' })
	                            ),
	                            this.renderRepackagedTable(),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 12 },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            className: 'btn btn-warning pull-right marginTopStyle',
	                                            onClick: function onClick(e) {
	                                                return _this6.cancelInventoryRepackage(e);
	                                            },
	                                            disabled: !repackagedInventories.selectedRows[0] },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { header: generalProductRepackage },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general' })
	                            ),
	                            _react2.default.createElement('hr', null),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 7 },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'repackage_date' }),
	                                        ': '
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6, className: 'marginBottomStyle' },
	                                        _react2.default.createElement(_reduxForm.Field, { component: _datePicker2.default, name: 'PostingDate' })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'repackage_user' }),
	                                        ': '
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _react2.default.createElement(_reduxForm.Field, { component: _inputField2.default, name: 'Modify_Username' })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 3 },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	                                        ': '
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 9 },
	                                        _react2.default.createElement(_reduxForm.Field, { name: 'Note', component: 'Textarea', className: 'form-control', style: { minHeight: '100px' } })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement('br', null)
	            );
	        }
	    }]);
	
	    return InventoryRepackageForm;
	}(_react.Component);
	
	InventoryRepackageForm.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = InventoryRepackageForm;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(InventoryRepackageForm, 'InventoryRepackageForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryRepackageForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryRepackageForm.jsx');
	}();

	;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle} from '../Common/style'
	
	var InventoryRepackages = function (_Component) {
	    _inherits(InventoryRepackages, _Component);
	
	    function InventoryRepackages() {
	        _classCallCheck(this, InventoryRepackages);
	
	        var _this = _possibleConstructorReturn(this, (InventoryRepackages.__proto__ || Object.getPrototypeOf(InventoryRepackages)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	            rows: [],
	            selectedRows: null,
	            editedRows: [],
	            filters: {},
	            sortColumn: null,
	            sortDirection: null,
	            gourpOpen: false
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        return _this;
	    }
	
	    _createClass(InventoryRepackages, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchInventoryRepackages();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once inventoryRepackages is ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var PT = nextProps.inventoryRepackages;
	            if (nextProps.inventoryRepackages && nextProps.inventoryRepackages != this.props.inventoryRepackages) {
	                this.setState({
	                    rows: nextProps.inventoryRepackages
	                });
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	        }
	
	        // Set inventoryRepackages being selected to be currentInventoryRepackage and navigate user to the edit page
	
	    }, {
	        key: 'setCurrentInventoryRepackage',
	        value: function setCurrentInventoryRepackage(e) {
	            e.preventDefault();
	            var currentInventoryRepackage = this.state.selectedRows[0];
	            this.props.resetCurrentInventoryRepackage();
	            this.props.resetCurrentInventoryConvert();
	            this.props.selectInventoryRepackage(currentInventoryRepackage);
	            this.context.router.push('/inventories/repackage/' + currentInventoryRepackage.WarehouseRepackage_id);
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            this.props.resetCurrentInventoryRepackage();
	            this.props.resetCurrentInventoryConvert();
	            this.context.router.push('/inventories/repackage/new');
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this2 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this2.setState(state);
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this2.state.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    _this2.setState({ filters: newFilters });
	                };
	
	                // Handle the editable function
	
	                var handleRowUpdated = function handleRowUpdated(e) {
	                    // merge updated row with current row and rerender by setting state
	                    var rows = _this2.state.rows.slice(0);
	                    var editedRows = _this2.state.editedRows.slice(0);
	                    Object.assign(rows[e.rowIdx], e.updated);
	                    // if the element is already edited, remove the old one.
	                    editedRows.forEach(function (element, index) {
	                        if (element.Inventory_id === rows[e.rowIdx].Inventory_id) editedRows.splice(index, 1);
	                    }, _this2);
	                    // push the row into the editedRows array
	                    editedRows.push(rows[e.rowIdx]);
	                    _this2.setState({
	                        rows: rows,
	                        editedRows: editedRows
	                    });
	                };
	
	                //Custom Formatter component
	                var IsEnabledFormatter = _react2.default.createClass({
	                    displayName: 'IsEnabledFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-success' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disable' })
	                        );
	                    }
	                });
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var onRowSelect = function onRowSelect(rows) {
	                    _this2.setState({ selectedRows: rows });
	                };
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'WarehouseRepackageNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'record_repackage_no' }),
	                    resizable: true,
	                    width: 220,
	                    sortable: true,
	                    filterable: true,
	                    locked: true
	                }, {
	                    key: 'CreateTime',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_date' }),
	                    resizable: true,
	                    width: 90,
	                    sortable: true,
	                    filterable: true,
	                    formatter: DateFormatter
	                }, {
	                    key: 'PostingDate',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'repackage_date' }),
	                    resizable: true,
	                    width: 100,
	                    sortable: true,
	                    filterable: true,
	                    formatter: DateFormatter
	                }, {
	                    key: 'Modify_Username',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'repackage_user' }),
	                    resizable: true,
	                    width: 150,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'Note',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	                    resizable: true,
	                    width: 200,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'Completed',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'completed' }),
	                    resizable: true,
	                    width: 100,
	                    sortable: true,
	                    filterable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'InventoryRepackages-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'WarehouseRepackageNum',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                rowHeight: 25,
	                                headerRowHeight: 45,
	                                minHeight: 685,
	                                onRowUpdated: handleRowUpdated,
	                                enableRowSelect: 'single',
	                                onRowSelect: onRowSelect
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Breadcrumb,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb.Item,
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_management' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb.Item,
	                        { active: 'true' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_repackage' })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Grid,
	                    { id: 'inventory-repackage' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        { className: 'position-relative table-collapse-fix' },
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { href: '/inventories', bsStyle: 'btn btn-green marginLeftStyle' },
	                                _react2.default.createElement('em', { className: 'fa fa-mail-reply' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { bsStyle: 'primary', onClick: function onClick(e) {
	                                        return _this3.clickNew(e);
	                                    }, disabled: !(0, _permissions2.default)("add_warehouse_repackage") },
	                                _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_inventory_repackage_sheet' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { bsStyle: 'primary' },
	                                _react2.default.createElement('em', { className: 'fa fa-print marginRightStyle' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { bsStyle: 'primary', disabled: !(0, _permissions2.default)("delete_warehouse_relocation") },
	                                _react2.default.createElement('em', { className: 'fa fa-trash marginRightStyle' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'primary',
	                                    onClick: function onClick(event) {
	                                        _this3.setCurrentInventoryRepackage(event);
	                                    },
	                                    disabled: !(0, _permissions2.default)("change_warehouse_relocation")
	                                },
	                                _react2.default.createElement('em', { className: 'fa fa-pencil marginRightStyle' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	                            )
	                        ),
	                        this.renderTable()
	                    )
	                )
	            );
	        }
	    }]);
	
	    return InventoryRepackages;
	}(_react.Component);
	
	InventoryRepackages.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = InventoryRepackages;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(InventoryRepackages, 'InventoryRepackages', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryRepackages.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/inventoryRepackages.jsx');
	}();

	;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _datePicker = __webpack_require__(27);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _filterByStart = __webpack_require__(68);
	
	var _filterByStart2 = _interopRequireDefault(_filterByStart);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _rowRenderer = __webpack_require__(64);
	
	var _inventories_actions = __webpack_require__(38);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var renderProductRadios = function renderProductRadios(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group' },
	    _react2.default.createElement(
	      'label',
	      { className: 'col-md-3 filter-title' },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product' }),
	      ':'
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-md-3' },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'Piece',
	        checked: props.input.value === 'Piece'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'piece' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-md-3' },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'Package',
	        checked: props.input.value === 'Package'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-md-3' },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'All',
	        checked: props.input.value === 'All'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' })
	    )
	  );
	};
	
	var renderInventoryRadios = function renderInventoryRadios(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group' },
	    _react2.default.createElement(
	      'label',
	      { className: 'col-md-3 filter-title' },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory' }),
	      ':'
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-md-4' },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'Low',
	        checked: props.input.value === 'Low'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'low_stock' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-md-4' },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'Negative',
	        checked: props.input.value === 'Negative'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'negative' })
	    )
	  );
	};
	
	var ProductConvertReport = function (_Component) {
	  _inherits(ProductConvertReport, _Component);
	
	  function ProductConvertReport() {
	    _classCallCheck(this, ProductConvertReport);
	
	    var _this = _possibleConstructorReturn(this, (ProductConvertReport.__proto__ || Object.getPrototypeOf(ProductConvertReport)).call(this));
	
	    _this.openCheckAuthorize = function () {
	      _this.props.clearCheckPassword();
	      _this.setState({ checkAuthorizeOpen: true });
	    };
	
	    _this.closeCheckAuthorize = function () {
	      _this.setState({ checkAuthorizeOpen: false });
	    };
	
	    _this.checkAuthorize = function (password) {
	      _this.props.checkPassword(password);
	    };
	
	    _this.handleVoidWorkingOrder = function () {
	      var effectDate = _this.state.effectDate;
	      var selectedRows = _this.state.workingOrder.selectedRows;
	
	      var handleSuccess = function handleSuccess() {
	        _this.setState({ isLoadingVoid: false }, function () {
	          _this.props.fetchLowInventories('Piece', 'Low');
	        });
	      };
	
	      var handleFailure = function handleFailure(err) {
	        _this.setState({ isLoadingVoid: false });
	        alert(JSON.stringify(err.data));
	      };
	
	      if (selectedRows && selectedRows.length === 1) {
	        _this.setState({ isLoadingVoid: true }, function () {
	          (0, _inventories_actions.voidWorkingOrder)(selectedRows[0], handleSuccess, handleFailure);
	        });
	      }
	    };
	
	    _this.state = {
	      product: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      workingOrder: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null,
	        selectedRows: []
	      },
	      checkAuthorizeOpen: false,
	      effectDate: undefined,
	      isLoadingVoid: false
	    };
	    _this.fetchRelatedProducts = _this.fetchRelatedProducts.bind(_this);
	    _this.fetchLowInventories = _this.fetchLowInventories.bind(_this);
	    return _this;
	  }
	
	  _createClass(ProductConvertReport, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.fetchLowInventories('Piece', 'Low');
	      this.props.setDefaultOfForm('PackageSize', 'Piece', 'productConvertReport');
	      this.props.setDefaultOfForm('Stock', 'Low', 'productConvertReport');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
	        this.closeCheckAuthorize();
	        this.handleVoidWorkingOrder();
	      }
	
	      if (nextProps.lowInventories && nextProps.lowInventories !== this.props.lowInventories) {
	        var product = _extends({}, this.state.product, { rows: nextProps.lowInventories.ProductList });
	        var workingOrder = _extends({}, this.state.workingOrder, { rows: nextProps.lowInventories.WorkingOrder });
	        this.setState({ product: product, workingOrder: workingOrder });
	      }
	
	      if (nextProps.EffectDate && nextProps.EffectDate !== this.props.EffectDate) {
	        var date = new Date(nextProps.EffectDate);
	        var year = date.getFullYear();
	        var month = date.getMonth() + 1;
	        var day = date.getDate();
	        if (month < 10) {
	          month = '0' + month;
	        }
	        if (day < 10) {
	          day = '0' + day;
	        }
	        this.setState({ effectDate: year + '-' + month + '-' + day }, function () {
	          _this2.props.fetchWorkingOrders(_this2.state.effectDate);
	        });
	      }
	
	      if (nextProps.workingOrders && nextProps.workingOrders !== this.props.workingOrders) {
	        var _workingOrder = _extends({}, this.state.workingOrder, { rows: nextProps.workingOrders.WorkingOrder });
	        this.setState({ workingOrder: _workingOrder });
	      }
	    }
	  }, {
	    key: 'shouldVoidDisable',
	    value: function shouldVoidDisable() {
	      var isLoadingVoid = this.state.isLoadingVoid;
	      var selectedRows = this.state.workingOrder.selectedRows;
	
	      return isLoadingVoid || selectedRows && (selectedRows.length === 0 || selectedRows.length > 1);
	    }
	  }, {
	    key: 'fetchLowInventories',
	    value: function fetchLowInventories() {
	      this.props.fetchLowInventories(this.props.PackageSize, this.props.Stock);
	    }
	  }, {
	    key: 'fetchRelatedProducts',
	    value: function fetchRelatedProducts(row) {
	      this.props.fetchRelatedProducts(row.ProductNum);
	      this.context.router.push('/productConvertReport/new');
	    }
	  }, {
	    key: 'renderProductTable',
	    value: function renderProductTable() {
	      var _this3 = this;
	
	      if (this.props.lowInventoriesIsLoading && !this.props.lowInventoriesError) {
	        return _react2.default.createElement(
	          'div',
	          { id: 'spinner' },
	          _react2.default.createElement(_spinner2.default, null)
	        );
	      } else if (this.props.lowInventoriesError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.lowInventoriesError)
	          )
	        );
	      }
	
	      // Parameters of the react-data-grid
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.product);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return Object.assign({ Idx: rowIdx }, rows[rowIdx]);
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var product = Object.assign({}, _this3.state.product, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this3.setState({ product: product });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this3.state.product.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var product = _extends({}, _this3.state.product, { filters: newFilters });
	        _this3.setState({ product: product });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        var product = _extends({}, _this3.state.product, { filters: {} });
	        _this3.setState({ product: product });
	      };
	
	      var columns = [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        filterRenderer: _filterByStart2.default
	      }, {
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        filterRenderer: _filterByStart2.default
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 250,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: 'MinStockRange',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'min_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true
	      }, {
	        key: 'InStock',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { id: 'ProductConvert-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowRenderer: _react2.default.createElement(_rowRenderer.RowRenderer, { onDoubleClick: this.fetchRelatedProducts }),
	              enableCellSelect: true,
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              onClearFilters: onClearFilters,
	              columns: columns,
	              rowHeight: 25,
	              headerRowHeight: 45,
	              minHeight: 610,
	              rowGetter: rowGetter,
	              rowsCount: getSize()
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderWorkingOrderTable',
	    value: function renderWorkingOrderTable() {
	      var _this4 = this;
	
	      if (this.props.lowInventoriesIsLoading && !this.props.lowInventoriesError) {
	        return _react2.default.createElement(
	          'div',
	          { id: 'spinner' },
	          _react2.default.createElement(_spinner2.default, null)
	        );
	      } else if (this.props.lowInventoriesError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.lowInventoriesIsLoading)
	          )
	        );
	      }
	
	      // Parameters of the react-data-grid
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.workingOrder);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return Object.assign({ Idx: rowIdx }, rows[rowIdx]);
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var workingOrder = Object.assign({}, _this4.state.workingOrder, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this4.setState({ workingOrder: workingOrder });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var selectedRows = [].concat(_toConsumableArray(_this4.state.workingOrder.selectedRows));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	          selectedRows.push(r.row.WarehouseConvert_id);
	        });
	        var workingOrder = _extends({}, _this4.state.workingOrder, { rows: newRows, selectedRows: selectedRows });
	        _this4.setState({ workingOrder: workingOrder });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = getRows();
	        var selectedRows = [];
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        newRows.map(function (r) {
	          if (r.isSelected) {
	            selectedRows.push(r.WarehouseConvert_id);
	          }
	        });
	        var workingOrder = _extends({}, _this4.state.workingOrder, { rows: newRows, selectedRows: selectedRows });
	        _this4.setState({ workingOrder: workingOrder });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this4.state.workingOrder.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var workingOrder = _extends({}, _this4.state.workingOrder, { filters: newFilters });
	        _this4.setState({ workingOrder: workingOrder });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        var workingOrder = _extends({}, _this4.state.workingOrder, { filters: {} });
	        _this4.setState({ workingOrder: workingOrder });
	      };
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var date = new Date(this.props.value);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      // Column difinition
	
	      var columns = [{
	        key: 'order_num',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 110
	      }, {
	        key: 'CreateTime',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'effect_date' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        formatter: DateFormatter
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 85
	      },
	      // {
	      //   key: 'From',
	      //   name: <Translate value="from" />,
	      //   resizable: true,
	      //   sortable: true,
	      //   width: 55,
	      // },
	      {
	        key: 'To',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	        resizable: true,
	        sortable: true,
	        width: 55
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { id: 'ProductConvert-dataGrid2' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowRenderer: _react2.default.createElement(_rowRenderer.RowRenderer, { onDoubleClick: this.fetchRelatedProducts }),
	              enableCellSelect: true,
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              onClearFilters: onClearFilters,
	              columns: columns,
	              rowHeight: 25,
	              minHeight: 610,
	              headerRowHeight: 45,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              }
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var createDialogStyle = {
	        width: '550px',
	        height: '300px',
	        marginLeft: '-15%'
	      };
	      var workingOrders = this.state.workingOrder.selectedRows;
	
	
	      var printWorkingOrderUrl = _root_url.ROOT_URL + 'v1/warehouse/workingorder/print?';
	      workingOrders.forEach(function (r) {
	        printWorkingOrderUrl = printWorkingOrderUrl + 'pk=' + r + '&';
	      });
	      printWorkingOrderUrl = printWorkingOrderUrl + 'Bearer=' + localStorage.getItem('token');
	      var printLowInventoryUrl = _root_url.ROOT_URL + 'v1/warehouse/lowinventory/print?Bearer=' + localStorage.getItem('token');
	      var excelLowInventoryUrl = _root_url.ROOT_URL + 'v1/warehouse/lowinventory/excel?Bearer=' + localStorage.getItem('token');
	
	      var shouldPrintWorkingOrderDisable = workingOrders.length < 1;
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_management' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_convert' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsStyle: 'primary', href: printLowInventoryUrl },
	            _react2.default.createElement('em', { className: 'fa fa-print' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsStyle: 'success', href: excelLowInventoryUrl },
	            _react2.default.createElement('em', { className: 'fa fa-download' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'product-convert' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { md: 8 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { md: 12 },
	                  _react2.default.createElement(
	                    'h2',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_list' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { id: 'product-list' },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { id: 'product-and-inventory-filters' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { md: 5 },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'PackageSize', component: renderProductRadios })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                      bsStyle: 'primary',
	                      className: 'mr-md pull-right',
	                      onClick: this.fetchLowInventories,
	                      disabled: !(0, _permissions2.default)('add_product_convert')
	                    },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	                  )
	                ),
	                this.renderProductTable()
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { md: 4 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { md: 12 },
	                  _react2.default.createElement(
	                    'h2',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'working_order' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { id: 'working-order' },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { className: 'print-button' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { md: 4 },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'EffectDate', component: _datePicker.DatePicker })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { md: 8 },
	                    _react2.default.createElement(
	                      _reactBootstrap.ButtonToolbar,
	                      { className: 'mr-md' },
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: 'danger',
	                          disabled: this.shouldVoidDisable(),
	                          onClick: function onClick() {
	                            return _this5.openCheckAuthorize();
	                          }
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-trash' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'void' })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: 'primary',
	                          href: printWorkingOrderUrl,
	                          disabled: shouldPrintWorkingOrderDisable
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-print' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	                      )
	                    )
	                  )
	                ),
	                this.renderWorkingOrderTable()
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogStyle,
	            isVisible: this.state.checkAuthorizeOpen,
	            onCloseClicked: this.closeCheckAuthorize
	          },
	          _react2.default.createElement(_confirmActionModal2.default, {
	            'case': 'confirmPassword',
	            closeC: this.checkAuthorize,
	            checkPasswordFailure: this.props.checkPasswordFailure
	          })
	        )
	      );
	    }
	  }]);
	
	  return ProductConvertReport;
	}(_react.Component);
	
	ProductConvertReport.contextTypes = contextTypes;
	
	var _default = ProductConvertReport;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(contextTypes, 'contextTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/productConvert.jsx');
	
	  __REACT_HOT_LOADER__.register(renderProductRadios, 'renderProductRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/productConvert.jsx');
	
	  __REACT_HOT_LOADER__.register(renderInventoryRadios, 'renderInventoryRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/productConvert.jsx');
	
	  __REACT_HOT_LOADER__.register(ProductConvertReport, 'ProductConvertReport', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/productConvert.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/productConvert.jsx');
	}();

	;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRangeslider = __webpack_require__(822);
	
	var _reactRangeslider2 = _interopRequireDefault(_reactRangeslider);
	
	__webpack_require__(803);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _inputField = __webpack_require__(16);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConvertSlider = function ConvertSlider(props) {
	  var input = props.input;
	  // console.log("input props", input)
	
	  return _react2.default.createElement(_reactRangeslider2.default, _extends({}, input, {
	    min: 0,
	    max: props.steps,
	    step: 1
	  }));
	};
	
	var ProductConvertDetail = function (_Component) {
	  _inherits(ProductConvertDetail, _Component);
	
	  function ProductConvertDetail() {
	    _classCallCheck(this, ProductConvertDetail);
	
	    var _this = _possibleConstructorReturn(this, (ProductConvertDetail.__proto__ || Object.getPrototypeOf(ProductConvertDetail)).call(this));
	
	    _this.state = {
	      product1: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null,
	        selectedRow: null
	      },
	      product2: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null,
	        selectedRow: null
	      },
	      prod2Qty: null,
	      numSteps: 10,
	
	      // Value of conversion from product1
	      conversionFrom1: null,
	      // Value of conversion to product2
	      conversionTo2: null
	    };
	    _this.handleProd2QtyChange = _this.handleProd2QtyChange.bind(_this);
	    _this.closeConfirm = _this.closeConfirm.bind(_this);
	    return _this;
	  }
	
	  _createClass(ProductConvertDetail, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.relatedProductsFetched && nextProps.relatedProductsFetched != this.props.relatedProductsFetched) {
	        var rows1 = nextProps.relatedProductsFetched.Products.map(function (r) {
	          return Object.assign({}, r);
	        });
	        var rows2 = nextProps.relatedProductsFetched.Products.map(function (r) {
	          return Object.assign({}, r);
	        });
	
	        rows1 = rows1.filter(function (obj) {
	          return obj.ConvertNum && obj.InStock != null;
	        });
	        rows2 = rows2.filter(function (obj) {
	          return obj.ConvertNum && obj.InStock != null;
	        });
	
	        var product1 = _extends({}, this.state.product1, { rows: rows1 });
	        var product2 = _extends({}, this.state.product2, { rows: rows2 });
	        this.setState({ product1: product1, product2: product2 });
	      }
	      if (nextProps.Convert && nextProps.Convert != this.props.Convert || nextProps.Convert == 0) {
	        // let prod2Qty = this.state.product2.selectedRow && this.state.product2.selectedRow.InStock;
	        // let prod2ConvertNum = this.state.product2.selectedRow && this.state.product2.selectedRow.ConvertNum;
	        // prod2Qty = (prod2Qty || 0) + (nextProps.Convert || 0)*(prod2ConvertNum);
	        // this.setState({prod2Qty})
	
	
	        if (this.state.product1.selectedRow && this.state.product2.selectedRow) {
	          this.props.setField("Prod1Qty", this.state.product1.selectedRow.InStock - this.state.conversionFrom1 * nextProps.Convert);
	          this.props.setField("Prod2Qty", this.state.product2.selectedRow.InStock + this.state.conversionTo2 * nextProps.Convert);
	        }
	      }
	    }
	  }, {
	    key: 'closeConfirm',
	    value: function closeConfirm() {
	      this.setState({ confirmOpen: false });
	    }
	  }, {
	    key: 'handleProd2QtyChange',
	    value: function handleProd2QtyChange(event) {
	      this.setState({ prod2Qty: event.target.value });
	    }
	  }, {
	    key: 'submitConversion',
	    value: function submitConversion() {
	      var itemConversion = {
	        RelatedProductNum: this.state.product1.selectedRow.ProductNum,
	        ProductNum: this.state.product2.selectedRow.ProductNum,
	        RelatedQuantity: this.props.Prod1Qty - this.state.product1.selectedRow.InStock, //left
	        Quantity: this.props.Prod2Qty - this.state.product2.selectedRow.InStock //right
	
	        // console.log("Conversion object", itemConversion);
	      };this.props.createNewConvert(itemConversion);
	    }
	  }, {
	    key: 'shouldDisableSaveButton',
	    value: function shouldDisableSaveButton(convertNum) {
	      var selectedRow1 = this.state.product1.selectedRow;
	      var selectedRow2 = this.state.product2.selectedRow;
	      if (selectedRow1 && selectedRow2 && convertNum !== 0 && !this.props.inventoryConvertIsCreating) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'renderProduct1',
	    value: function renderProduct1() {
	      var _this2 = this;
	
	      if (this.props.lowInventoriesIsLoading && !this.props.lowInventoriesError) return _react2.default.createElement(
	        'div',
	        { id: 'spinner' },
	        _react2.default.createElement(Spinner, null)
	      );else if (this.props.lowInventoriesError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.lowInventoriesError)
	        )
	      );else {
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.product1);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return Object.assign({ Idx: rowIdx }, rows[rowIdx]);
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var product1 = Object.assign({}, _this2.state.product1, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this2.setState({ product1: product1 });
	        };
	
	        var handleRowUpdated = function handleRowUpdated(e) {
	          var rows = getRows();
	          Object.assign(rows[e.rowIdx], e.updated);
	        };
	
	        var onRowsSelected = function onRowsSelected(rows) {
	          var newRows = getRows();
	          newRows.map(function (r) {
	            if (r.ProductNum == rows[0].row.ProductNum) r.isSelected = true;else r.isSelected = false;
	          });
	          var product1 = _extends({}, _this2.state.product1, { rows: newRows, selectedRow: rows[0].row });
	          _this2.setState({ product1: product1 });
	          _this2.props.setField('Convert', 0);
	          _this2.props.setField('Prod1Qty', rows[0].row.InStock);
	          if (_this2.state.product2.selectedRow) {
	            _this2.props.setField('Prod2Qty', _this2.state.product2.selectedRow.InStock);
	          }
	
	          var prod2 = _extends({}, _this2.state.product2.selectedRow);
	          var prod1 = _extends({}, rows[0].row);
	
	          // Is this greater or lesser than 1?
	          if (prod2) {
	            // console.log("Prod1", prod1, "prod2", prod2)
	            if (prod1.ProductNum == prod2.ProductNum) {
	              _this2.setState({ numSteps: 0 });
	              return;
	            }
	            if (prod2.ConvertNum > prod1.ConvertNum) {
	              // Product1 convertNum < Product2 convertNum
	
	              // Check if prod1 evenly divides into Prod2
	              //  if (prod2.ConvertNum % prod1.ConvertNum == 0) {
	
	              // Check for max number of conversions
	              if (prod1.InStock == 0 || prod1.InStock / (prod2.ConvertNum / prod1.ConvertNum) < 1) {
	                _this2.setState({ conversionFrom1: roundTo(prod2.ConvertNum / prod1.ConvertNum).toFixed(2), conversionTo2: 1, numSteps: 0 });
	              } else {
	                _this2.setState({ conversionFrom1: roundTo(prod2.ConvertNum / prod1.ConvertNum).toFixed(2), conversionTo2: 1, numSteps: prod1.InStock / (prod2.ConvertNum / prod1.ConvertNum) });
	              }
	
	              if (prod2.ConvertNum % prod1.ConvertNum != 0) {
	                _this2.setState({ confirmOpen: true });
	              }
	              //  } else {
	              //    // Does not convert evenly!!
	              //    this.setState({ numSteps: 0 })
	              //  }
	            } else if (prod2.ConvertNum < prod1.ConvertNum) {
	              // Product2 convertNum < Product1 convertNum
	
	              // Check if prod1 evenly divides into Prod2
	              //  if (prod1.ConvertNum % prod2.ConvertNum == 0) {
	              _this2.setState({ conversionFrom1: 1, conversionTo2: roundTo(prod1.ConvertNum / prod2.ConvertNum).toFixed(2), numSteps: prod1.InStock });
	              //  } else {
	              //    // Does not convert evenly!!
	              //    this.setState({ numSteps: 0 })
	              //  }
	              if (prod1.ConvertNum % prod2.ConvertNum != 0) {
	                _this2.setState({ confirmOpen: true });
	              }
	            } else {
	              // Product1 convertNum == Product2 convertNum
	              _this2.setState({ conversionFrom1: 1, conversionTo2: 1, numSteps: prod1.InStock });
	            }
	          }
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          // console.log("here", rows)
	          var newRows = getRows();
	          newRows.map(function (r) {
	            r.isSelected = false;
	          });
	          var product1 = _extends({}, _this2.state.product1, { rows: newRows, selectedRow: null });
	          _this2.setState({ product1: product1 });
	        };
	
	        // Column difinition
	
	        var columns = [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          sortable: true,
	          width: 100
	        }, {
	          key: 'PackageType',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_type' }),
	          resizable: true,
	          sortable: true,
	          width: 220
	        }, {
	          key: 'PackageSize',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	          resizable: true,
	          sortable: true,
	          width: 220
	        }, {
	          key: 'InStock',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	          resizable: true,
	          sortable: true,
	          width: 80
	        }, {
	          key: 'NetWeight',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' }),
	          resizable: true,
	          sortable: true,
	          width: 65
	        }];
	
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { id: 'ProductConvertDetail-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                enableCellSelect: true,
	                onGridSort: handleGridSort,
	                columns: columns,
	                rowHeight: 25,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                rowSelection: {
	                  showCheckbox: true,
	                  onRowsSelected: onRowsSelected,
	                  onRowsDeselected: onRowsDeselected,
	                  selectBy: {
	                    isSelectedKey: 'isSelected'
	                  }
	                }
	              })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderProduct2',
	    value: function renderProduct2() {
	      var _this3 = this;
	
	      if (this.props.lowInventoriesIsLoading && !this.props.lowInventoriesError) return _react2.default.createElement(
	        'div',
	        { id: 'spinner' },
	        _react2.default.createElement(Spinner, null)
	      );else if (this.props.lowInventoriesError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.lowInventoriesError)
	        )
	      );else {
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.product2);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return Object.assign({ Idx: rowIdx }, rows[rowIdx]);
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var product2 = Object.assign({}, _this3.state.product2, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this3.setState({ product2: product2 });
	        };
	
	        var handleRowUpdated = function handleRowUpdated(e) {
	          var rows = getRows();
	          Object.assign(rows[e.rowIdx], e.updated);
	        };
	
	        var onRowsSelected = function onRowsSelected(rows) {
	          var newRows = getRows();
	          newRows.map(function (r) {
	            if (r.ProductNum == rows[0].row.ProductNum) r.isSelected = true;else r.isSelected = false;
	          });
	          var product2 = _extends({}, _this3.state.product2, { rows: newRows, selectedRow: rows[0].row });
	          _this3.setState({ product2: product2 });
	          _this3.props.setField('Convert', 0);
	          _this3.props.setField('Prod2Qty', rows[0].row.InStock);
	          if (_this3.state.product1.selectedRow) {
	            _this3.props.setField('Prod1Qty', _this3.state.product1.selectedRow.InStock);
	          }
	          var prod1 = _extends({}, _this3.state.product1.selectedRow);
	          var prod2 = _extends({}, rows[0].row);
	
	          // Is this greater or lesser than 1?
	          if (prod1) {
	            if (prod1.ProductNum == prod2.ProductNum) {
	              _this3.setState({ numSteps: 0 });
	              return;
	            }
	            if (prod2.ConvertNum > prod1.ConvertNum) {
	              // Product1 convertNum < Product2 convertNum
	
	              // Check if prod1 evenly divides into Prod2
	              //  if (prod2.ConvertNum % prod1.ConvertNum == 0) {
	
	              // Check for max number of conversions
	              if (prod1.InStock == 0 || prod1.InStock / (prod2.ConvertNum / prod1.ConvertNum) < 1) {
	                _this3.setState({ conversionFrom1: roundTo(prod2.ConvertNum / prod1.ConvertNum).toFixed(2), conversionTo2: 1, numSteps: 0 });
	              } else {
	                // console.log("calculating", prod1.InStock, prod2.ConvertNum, prod1.ConvertNum, (prod1.InStock / (prod2.ConvertNum / prod1.ConvertNum)));
	                _this3.setState({ conversionFrom1: roundTo(prod2.ConvertNum / prod1.ConvertNum).toFixed(2), conversionTo2: 1, numSteps: prod1.InStock / (prod2.ConvertNum / prod1.ConvertNum) });
	              }
	
	              if (prod2.ConvertNum % prod1.ConvertNum != 0) {
	                _this3.setState({ confirmOpen: true });
	              }
	              //  } else {
	              //    // Does not convert evenly!!
	              //    this.setState({ numSteps: 0 })
	              //  }
	            } else if (prod2.ConvertNum < prod1.ConvertNum) {
	              // Product2 convertNum < Product1 convertNum
	
	              // Check if prod1 evenly divides into Prod2
	              //  if (prod1.ConvertNum % prod2.ConvertNum == 0) {
	              _this3.setState({ conversionFrom1: 1, conversionTo2: roundTo(prod1.ConvertNum / prod2.ConvertNum).toFixed(2), numSteps: prod1.InStock });
	              //  } else {
	              //    // Does not convert evenly!!
	              //    this.setState({ conversionFrom1: 1, conversionTo2: (prod1.ConvertNum / prod2.ConvertNum), numSteps: prod1.InStock });
	              //  }
	              if (prod1.ConvertNum % prod2.ConvertNum != 0) {
	                _this3.setState({ confirmOpen: true });
	              }
	            } else {
	              // Product1 convertNum == Product2 convertNum
	              _this3.setState({ conversionFrom1: 1, conversionTo2: 1, numSteps: prod1.InStock });
	            }
	          }
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          var newRows = getRows();
	          newRows.map(function (r) {
	            r.isSelected = false;
	          });
	          var product2 = _extends({}, _this3.state.product2, { rows: newRows, selectedRow: null });
	          _this3.setState({ product2: product2 });
	        };
	
	        // Column difinition
	
	        var columns = [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          sortable: true,
	          width: 100
	        }, {
	          key: 'PackageType',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_type' }),
	          resizable: true,
	          sortable: true,
	          width: 220
	        }, {
	          key: 'PackageSize',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	          resizable: true,
	          sortable: true,
	          width: 220
	        }, {
	          key: 'InStock',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	          resizable: true,
	          sortable: true,
	          width: 80
	        }, {
	          key: 'NetWeight',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' }),
	          resizable: true,
	          sortable: true,
	          width: 65
	        }];
	
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { id: 'ProductConvertDetail-dataGrid2' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                enableCellSelect: true,
	                onGridSort: handleGridSort,
	                columns: columns,
	                rowHeight: 25,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                rowSelection: {
	                  showCheckbox: true,
	                  onRowsSelected: onRowsSelected,
	                  onRowsDeselected: onRowsDeselected,
	                  selectBy: {
	                    isSelectedKey: 'isSelected'
	                  }
	                }
	              })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var createDialogStyle = {
	        width: '500px',
	        marginLeft: '-15%'
	      };
	      var prod1 = this.state.product1.selectedRow;
	      var prod2 = this.state.product2.selectedRow;
	      var confirmAction = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm_action' });
	      var prod1Qty = this.state.product1.selectedRow && this.state.product1.selectedRow.InStock;
	      var prod1ConvertNum = this.state.product1.selectedRow && this.state.product1.selectedRow.ConvertNum;
	      // prod1Qty = (prod1Qty || 0) - (this.props.Convert || 0)*(prod1ConvertNum || 0);
	      var convert = 0;
	      if (this.state.product1.selectedRow) {
	        convert = parseFloat(this.state.product1.selectedRow.InStock) - parseFloat(this.props.Prod1Qty);
	      }
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { fluid: 'true', id: 'product-convert-detail' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              null,
	              _react2.default.createElement(_SpinnerButton2.default, {
	                bsStyle: 'success',
	                onClick: function onClick() {
	                  _this4.submitConversion();
	                },
	                loading: this.props.inventoryConvertIsCreating,
	                icon: 'fa-save',
	                translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' }),
	                disabled: this.shouldDisableSaveButton(convert)
	              }),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'danger', onClick: function onClick() {
	                    _this4.context.router.push('/productConvertReport');
	                  } },
	                _react2.default.createElement('em', { className: 'fa fa-close' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	              ' ',
	              this.props.relatedProductsFetched.ProductNum
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              this.props.relatedProductsFetched.Description
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              this.props.relatedProductsFetched.Name
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { md: 6 },
	              this.renderProduct1()
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { md: 6 },
	              this.renderProduct2()
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(_reactBootstrap.Col, { md: 3 }),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { md: 1, className: 'Convert' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'convert' }),
	                ' : ',
	                convert
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { md: 4 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { md: 3, className: 'Product' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    prod1 && prod1.ProductNum
	                  ),
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Prod1Qty', component: _inputField.DisabledInputField })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { md: 6 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'pull-left ml-xl' },
	                      '(',
	                      prod1 && prod1.ConvertNum,
	                      ')'
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'pull-right mr-xl' },
	                      '(',
	                      prod2 && prod2.ConvertNum,
	                      ')'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(_reduxForm.Field, { name: 'Convert', steps: this.state.numSteps, component: ConvertSlider })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { md: 3, className: 'Product' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    prod2 && prod2.ProductNum
	                  ),
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Prod2Qty', component: _inputField.InputField })
	                )
	              )
	            ),
	            _react2.default.createElement(_reactBootstrap.Col, { md: 4 })
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          { dialogStyles: createDialogStyle, isVisible: this.state.confirmOpen, onCloseClicked: function onCloseClicked() {
	              _this4.closeConfirm();
	            }, title: confirmAction },
	          _react2.default.createElement(_confirmActionModal2.default, {
	            'case': "convertUneven",
	            closeC: this.closeConfirm })
	        )
	      );
	    }
	  }]);
	
	  return ProductConvertDetail;
	}(_react.Component);
	
	ProductConvertDetail.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = ProductConvertDetail;
	exports.default = _default;
	
	
	function roundTo(n, digits) {
	  if (digits === undefined) {
	    digits = 0;
	  }
	
	  var multiplicator = Math.pow(10, digits);
	  n = parseFloat((n * multiplicator).toFixed(11));
	  var test = Math.round(n) / multiplicator;
	  return +test.toFixed(2);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(roundTo, 'roundTo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/productConvertDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(ConvertSlider, 'ConvertSlider', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/productConvertDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(ProductConvertDetail, 'ProductConvertDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/productConvertDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/productConvertDetail.jsx');
	}();

	;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle} from '../Common/style'
	
	var PutAway = function (_Component) {
	    _inherits(PutAway, _Component);
	
	    function PutAway() {
	        _classCallCheck(this, PutAway);
	
	        var _this = _possibleConstructorReturn(this, (PutAway.__proto__ || Object.getPrototypeOf(PutAway)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	            rows: [],
	            selectedRows: null,
	            editedRows: [],
	            filters: {},
	            sortColumn: null,
	            sortDirection: null,
	            gourpOpen: false
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        return _this;
	    }
	
	    _createClass(PutAway, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchPutAway();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once scrapRecords is ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var PT = nextProps.putAway;
	            if (nextProps.putAway && nextProps.putAway != this.props.putAway) {
	                this.setState({
	                    rows: nextProps.putAway
	                });
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	        }
	
	        // Set scrapRecords being selected to be currentScrapRecord and navigate user to the edit page
	
	    }, {
	        key: 'setCurrentPutAway',
	        value: function setCurrentPutAway(e) {
	            e.preventDefault();
	            var currentPutAway = this.state.selectedRows[0];
	            this.props.selectPutAway(currentPutAway);
	            this.context.router.push('/putAway/' + currentPutAway.WarehousePutAway_id);
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            this.props.resetCurrentPutAway();
	            this.context.router.push('/putAway/new');
	        }
	    }, {
	        key: 'clickInbound',
	        value: function clickInbound(e) {
	            e.preventDefault();
	            this.props.resetCurrentPutAway();
	            this.context.router.push('/putAway/inbound');
	        }
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this2 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this2.setState(state);
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this2.state.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    _this2.setState({ filters: newFilters });
	                };
	
	                var onRowSelect = function onRowSelect(rows) {
	                    _this2.setState({ selectedRows: rows });
	                };
	
	                // Handle the editable function
	
	                var handleRowUpdated = function handleRowUpdated(e) {
	                    // merge updated row with current row and rerender by setting state
	                    var rows = _this2.state.rows.slice(0);
	                    var editedRows = _this2.state.editedRows.slice(0);
	                    Object.assign(rows[e.rowIdx], e.updated);
	                    // if the element is already edited, remove the old one.
	                    editedRows.forEach(function (element, index) {
	                        if (element.Product_id === rows[e.rowIdx].Product_id) editedRows.splice(index, 1);
	                    }, _this2);
	                    // push the row into the editedRows array
	                    editedRows.push(rows[e.rowIdx]);
	                    _this2.setState({
	                        rows: rows,
	                        editedRows: editedRows
	                    });
	                };
	
	                //Custom Formatter component
	                var IsEnabledFormatter = _react2.default.createClass({
	                    displayName: 'IsEnabledFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-success' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disable' })
	                        );
	                    }
	                });
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var columns = [{
	                    key: 'PutAwayNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'put_away_num' }),
	                    resizable: true,
	                    width: 130,
	                    sortable: true,
	                    filterable: true,
	                    locked: true
	                }, {
	                    key: 'CreateTime',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_time' }),
	                    resizable: true,
	                    width: 110,
	                    sortable: true,
	                    filterable: true,
	                    formatter: DateFormatter
	                }, {
	                    key: 'Modify_Username',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'user' }),
	                    resizable: true,
	                    width: 80,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'Note',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	                    resizable: true,
	                    width: 190,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'IsPutAway',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'completed' }),
	                    resizable: true,
	                    width: 100,
	                    sortable: true,
	                    filterable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '100%' }, id: 'PutAway-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'WarehousePutAway_id',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                rowHeight: 25,
	                                minHeight: 685,
	                                onRowUpdated: handleRowUpdated,
	                                enableRowSelect: 'single',
	                                onRowSelect: onRowSelect
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'checkPermission',
	        value: function checkPermission(permission) {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return (
	                //---------------
	                // Begin HTML: Create New/Edit Put Away
	                //---------------
	                _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_management' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            { active: 'true' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'put_away_list' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Grid,
	                        { id: 'put-away-list' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { className: 'position-relative table-collapse-fix' },
	                            _react2.default.createElement(
	                                _reactBootstrap.ButtonToolbar,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    { bsStyle: 'primary', onClick: function onClick(e) {
	                                            return _this3.clickNew(e);
	                                        }, disabled: this.checkPermission("add_put_away") },
	                                    _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_put_away' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    { bsStyle: 'primary', onClick: function onClick(e) {
	                                            return _this3.setCurrentPutAway(e);
	                                        }, disabled: !this.state.selectedRows || this.state.selectedRows.length != 1 },
	                                    _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_put_away' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    { bsStyle: 'primary', onClick: function onClick(e) {
	                                            return _this3.clickInbound(e);
	                                        }, disabled: this.checkPermission("add_put_away") },
	                                    _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inbound' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    { bsStyle: 'primary' },
	                                    _react2.default.createElement('em', { className: 'fa fa-print marginRightStyle' }),
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    { bsStyle: 'primary' },
	                                    _react2.default.createElement('em', { className: 'fa fa-trash marginRightStyle' }),
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                                )
	                            ),
	                            this.renderTable()
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PutAway;
	}(_react.Component);
	
	PutAway.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = PutAway;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(PutAway, 'PutAway', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/putAway.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/putAway.jsx');
	}();

	;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _datePicker = __webpack_require__(27);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(13);
	
	var _inputField = __webpack_require__(16);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _zoneInformation = __webpack_require__(177);
	
	var _zoneInformation2 = _interopRequireDefault(_zoneInformation);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle} from '../Common/style'
	
	var renderDatePicker = function renderDatePicker(props) {
	    return _react2.default.createElement(_DateTimePicker2.default, {
	        format: 'YYYY-MM-DD',
	        defaultValue: null,
	        time: false,
	        onChange: function onChange(name) {
	            return props.input.onChange(name);
	        },
	        value: props.input.value || null });
	};
	
	var PutAwayForm = function (_Component) {
	    _inherits(PutAwayForm, _Component);
	
	    function PutAwayForm() {
	        _classCallCheck(this, PutAwayForm);
	
	        var _this = _possibleConstructorReturn(this, (PutAwayForm.__proto__ || Object.getPrototypeOf(PutAwayForm)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton,
	
	            dirty: false,
	
	            receiveHistories: {
	                rows: [],
	                selectedRows: null,
	                editedRows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null,
	                gourpOpen: false
	            },
	
	            receiveHistory: {
	                rows: [],
	                selectedRows: null,
	                editedRows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null,
	                gourpOpen: false
	            },
	
	            newPutAway: {
	                rows: [],
	                selectedRows: null,
	                editedRows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null,
	                gourpOpen: false
	            },
	
	            showZonesOpen: false
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        _this.openShowZones = _this.openShowZones.bind(_this);
	        _this.closeShowZones = _this.closeShowZones.bind(_this);
	        return _this;
	    }
	
	    _createClass(PutAwayForm, [{
	        key: 'openShowZones',
	        value: function openShowZones() {
	            this.setState({ showZonesOpen: true });
	        }
	    }, {
	        key: 'closeShowZones',
	        value: function closeShowZones() {
	            this.setState({ showZonesOpen: false });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchReceiveHistory("Arrived");
	            this.props.fetchWarehouses();
	            this.props.fetchWarehouseDetail(1);
	            if (this.props.currentPutAway) {
	                this.props.fetchPutAwayDetail(this.props.currentPutAway.WarehousePutAway_id);
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once scrapRecords is ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            if (nextProps.Default_Warehouse_id && nextProps.Default_Warehouse_id != this.props.Default_Warehouse_id) {
	                if (nextProps.Default_Warehouse_id.value) this.props.fetchWarehouseDetail(nextProps.Default_Warehouse_id.value);
	            }
	            if (nextProps.Default_WarehouseZone_id && nextProps.Default_WarehouseZone_id != this.props.Default_WarehouseZone_id) {
	                this.zoneDetail(nextProps.Default_WarehouseZone_id.value);
	            }
	            if (nextProps.binList && nextProps.binList != this.props.binList) {
	                if (nextProps.binList.error) {
	                    // var r = confirm(<Translate value="space_not_enough_create_bins" />);
	                    // if(r == true){
	                    //   this.props.createBins(nextProps.binList.Product_id, this.state.receiveHistory.selectedRows[0].WarehouseReceiveLine_id, nextProps.binList.error, nextProps.binList.BinList);
	                    // }
	                    // else {
	                    var r1 = confirm(_react2.default.createElement(_reactReduxI18n.Translate, { value: 'space_not_enough_relocate' }));
	                    if (r1 == true) {
	                        this.props.resetCurrentWarehouseReceive();
	                        this.props.selectWarehouseReceive(nextProps.binList.Product_id, this.state.receiveHistory.selectedRows[0].WarehouseReceiveLine_id, nextProps.binList.error, nextProps.binList.BinList);
	                        this.openShowZones();
	                    }
	                    // }
	                } else {
	                    var receiveHistory = this.state.newPutAway.rows;
	                    var selected = Object.assign({}, this.state.receiveHistory.selectedRows[0]);
	                    var binList = nextProps.binList.BinList;
	                    var oldBinList = nextProps.binList.OldBinList;
	                    var totalNum = selected.Quantity;
	                    var unitPerPallet = selected.UnitPerPallet;
	                    if (!unitPerPallet) unitPerPallet = 0;
	                    if (binList.length > 0) {
	                        binList.map(function (bin) {
	                            bin["isSelected"] = false;
	                            bin["ProductName"] = selected.ProductName;
	                            bin["ProductDescription"] = selected.ProductDescription;
	                            bin["ProductNum"] = nextProps.binList.ProductNum;
	                            bin["Product_id"] = nextProps.binList.Product_id;
	                            bin["RcvQuantity"] = nextProps.binList.RcvQuantity;
	                            bin["BinName"] = bin.Name;
	                            bin["ZoneName"] = bin.WarehouseZone_id.Name;
	                            bin["WarehouseZone_id"] = bin.WarehouseZone_id.WarehouseZone_id;
	                            if (Number(totalNum) < Number(unitPerPallet)) {
	                                bin["PutAwayQuantity"] = totalNum < 0 ? 0 : totalNum;
	                            } else {
	                                bin["PutAwayQuantity"] = unitPerPallet;
	                            }
	                            bin["Pallet"] = 1;
	                            bin["Quantity"] = selected.Quantity;
	                            totalNum = Number(totalNum) - Number(unitPerPallet);
	                            if (_this2.props.currentPutAway) bin["WarehouseReceiveNum"] = _this2.props.currentPutAway.WarehouseReceiveNum || _this2.props.currentPutAway.WarehouseReceive.WarehouseReceiveNum;
	                        });
	                    } else {
	                        selected["isSelected"] = false;
	                        binList.push(selected);
	                    }
	                    var newBinList = binList.concat(receiveHistory);
	                    if (oldBinList) {
	                        oldBinList.map(function (bin) {
	                            bin["isSelected"] = false;
	                            bin["ProductName"] = selected.ProductName;
	                            bin["ProductDescription"] = selected.ProductDescription;
	                            bin["ProductNum"] = nextProps.binList.ProductNum;
	                            bin["Product_id"] = nextProps.binList.Product_id;
	                            bin["RcvQuantity"] = nextProps.binList.RcvQuantity;
	                            bin["BinName"] = bin.Name;
	                            bin["ZoneName"] = bin.WarehouseZone_id.Name;
	                            bin["WarehouseZone_id"] = bin.WarehouseZone_id.WarehouseZone_id;
	                            if (Number(totalNum) < Number(unitPerPallet)) {
	                                bin["PutAwayQuantity"] = totalNum < 0 ? 0 : totalNum;
	                            } else {
	                                bin["PutAwayQuantity"] = unitPerPallet;
	                            }
	                            bin["Pallet"] = 1;
	                            bin["Quantity"] = selected.Quantity;
	                            totalNum = Number(totalNum) - Number(unitPerPallet);
	                            if (_this2.props.currentPutAway) bin["WarehouseReceiveNum"] = _this2.props.currentPutAway.WarehouseReceiveNum || _this2.props.currentPutAway.WarehouseReceive.WarehouseReceiveNum;
	                        });
	                        newBinList = newBinList.concat(oldBinList);
	                    }
	                    var newPutAway = _extends({}, this.state.newPutAway, { rows: newBinList });
	                    this.setState({ newPutAway: newPutAway });
	                    // this.props.fetchZoneDetail(newBinList[0].WarehouseZone_id);
	                }
	            }
	            if (nextProps.currentPutAwayDetail && nextProps.currentPutAwayDetail != this.props.currentPutAwayDetail) {
	                var warehouse_PutAway_Line = nextProps.currentPutAwayDetail.Warehouse_PutAway_Line;
	                warehouse_PutAway_Line.map(function (line) {
	                    line['ZoneName'] = line.WarehouseZone_id.Name;
	                    line['BinName'] = line.WarehouseBin_id.Name;
	                    line['WarehouseZone_id'] = line.WarehouseZone_id.WarehouseZone_id;
	                    line['WarehouseBin_id'] = line.WarehouseBin_id.Warehouse_id;
	                });
	                var _newPutAway = _extends({}, this.state.newPutAway, { rows: warehouse_PutAway_Line });
	                this.setState({ newPutAway: _newPutAway });
	            }
	            if (nextProps.receiveHistoryDetail && nextProps.receiveHistoryDetail != this.props.receiveHistoryDetail) {
	                var _receiveHistory = Object.assign({}, this.state.receiveHistory);
	                if (nextProps.receiveHistoryDetail.Warehouse_Receive_Line) {
	                    var warehouse_Receive_Line = nextProps.receiveHistoryDetail.Warehouse_Receive_Line;
	                    _receiveHistory = _extends({}, _receiveHistory, { rows: warehouse_Receive_Line });
	                } else {
	                    _receiveHistory = _extends({}, _receiveHistory, { rows: nextProps.receiveHistoryDetail });
	                }
	                this.setState({ receiveHistory: _receiveHistory });
	            }
	            if (nextProps.receiveHistory && nextProps.receiveHistory != this.props.receiveHistory) {
	                var receiveHistories = nextProps.receiveHistory;
	                receiveHistories.map(function (receiveHistory) {
	                    receiveHistory["Vendor"] = receiveHistory.Purchase.Vendor.Name;
	                    receiveHistory["Purchaser"] = receiveHistory.Purchase.Purchaser.username;
	                    receiveHistory["FinalPrice"] = receiveHistory.Purchase.FinalPrice;
	                });
	                var newReceiveHistories = _extends({}, this.state.receiveHistories, { rows: receiveHistories });
	                this.setState({
	                    receiveHistories: newReceiveHistories
	                });
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton });
	        }
	
	        // Set scrapRecords being selected to be currentScrapRecord and navigate user to the edit page
	
	    }, {
	        key: 'setCurrentPutAway',
	        value: function setCurrentPutAway(e) {
	            e.preventDefault();
	            var currentScrapRecord = this.state.selectedRows[0];
	            this.props.selectScrapRecord(currentScrapRecord);
	            this.context.router.push('/scrapRecords/' + currentScrapRecord.WarehouseScrapNum);
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            this.props.fetchReceiveHistoryDetail(this.state.receiveHistories.selectedRows[0].WarehouseReceive_id);
	        }
	    }, {
	        key: 'fetchAllReceiveHistories',
	        value: function fetchAllReceiveHistories(e) {
	            e.preventDefault();
	            this.props.fetchAllReceiveHistoryDetail();
	        }
	    }, {
	        key: 'clickNewPutAway',
	        value: function clickNewPutAway(e) {
	            e.preventDefault();
	            this.props.fetchBinList(this.state.receiveHistory.selectedRows[0].WarehouseReceiveLine_id);
	        }
	        // editedRows.push(rows[e.rowIdx]);
	        //   let receiveHistory = this.state.newPutAway.rows;
	        //
	        //   let selected = Object.assign({}, this.state.receiveHistory.selectedRows[0]);
	        //   let binList = this.props.binList.BinList;
	        //   let totalNum = selected.RcvQuantity;
	        //   let unitPerPallet = selected.UnitPerPallet;
	        //   if(!unitPerPallet)
	        //     unitPerPallet = totalNum;
	        //   if(binList.length > 0 && unitPerPallet){
	        //     binList.map(bin => {
	        //       bin["isSelected"] = false;
	        //       bin["ProductName"] = selectedBinList.Name;
	        //       bin["ProductNum"] = this.props.binList.ProductNum;
	        //       bin["ProductDescription"] = selectedBinList.Description;
	        //       bin["RcvQuantity"] = this.props.binList.RcvQuantity;
	        //       bin["RcvTotalPrice"] = this.props.binList.RcvTotalPrice;
	        //       if(totalNum > unitPerPallet)
	        //         bin["PutAwayQuantity"] = unitPerPallet;
	        //       else
	        //         bin["PutAwayQuantity"] = totalNum;
	        //       totalNum = totalNum - unitPerPallet;
	        //       if(this.props.currentPutAway)
	        //         selectedBinList["WarehouseReceiveNum"] = this.props.currentPutAway.WarehouseReceiveNum;
	        //     })
	        //   }
	        //   else{
	        //     binList = selected;
	        //   }
	        //   // selected["isSelected"] = false;
	        //
	        //   receiveHistory.push(binList);
	        //   const newPutAway = {...this.state.newPutAway, rows: receiveHistory};
	        //   this.setState({newPutAway: newPutAway });
	        // }
	        //
	
	    }, {
	        key: 'zoneDetail',
	        value: function zoneDetail(zone) {
	            this.props.fetchZoneDetail(zone);
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this3 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.receiveHistories);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var receiveHistories = Object.assign({}, _this3.state.receiveHistories, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this3.setState({ receiveHistories: receiveHistories });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this3.state.receiveHistories.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var receiveHistories = _extends({}, _this3.state.receiveHistories, { filters: newFilters });
	                    _this3.setState({ receiveHistories: receiveHistories });
	                };
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var receiveHistories = _extends({}, _this3.state.receiveHistories, { selectedRows: rows });
	                    _this3.setState({ receiveHistories: receiveHistories });
	                };
	
	                // Handle the editable function
	
	                // const handleRowUpdated = e => {
	                //     // merge updated row with current row and rerender by setting state
	                //     let rows = this.state.rows.slice(0);
	                //     let editedRows = this.state.editedRows.slice(0);
	                //     Object.assign(rows[e.rowIdx], e.updated);
	                //     // if the element is already edited, remove the old one.
	                //     editedRows.forEach((element, index) => {
	                //         if (element.Product_id === rows[e.rowIdx].Product_id)
	                //             editedRows.splice(index, 1)
	                //     }, this);
	                //     // push the row into the editedRows array
	                //     editedRows.push(rows[e.rowIdx]);
	                //     this.setState({
	                //         rows: rows,
	                //         editedRows: editedRows
	                //     });
	                // }
	
	                //Custom Formatter component
	                var IsEnabledFormatter = _react2.default.createClass({
	                    displayName: 'IsEnabledFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-success' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disable' })
	                        );
	                    }
	                });
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var columns = [{
	                    key: 'WarehouseReceiveNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_num' }),
	                    resizable: true,
	                    width: 125,
	                    sortable: true,
	                    filterable: true,
	                    locked: true
	                }, {
	                    key: 'CreateTime',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_time' }),
	                    resizable: true,
	                    width: 110,
	                    sortable: true,
	                    filterable: true,
	                    formatter: DateFormatter
	                }, {
	                    key: 'Vendor',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor' }),
	                    resizable: true,
	                    width: 180,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'Purchaser',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchaser' }),
	                    resizable: true,
	                    width: 115,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'FinalPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	                    resizable: true,
	                    width: 90,
	                    sortable: true,
	                    filterable: true
	                }];
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '100%' }, id: 'PutAwayForm-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'WarehouseReceive_id',
	                                onGridSort: handleGridSort,
	                                columns: columns,
	                                rowHeight: 25,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: 170,
	                                enableRowSelect: 'single',
	                                onRowSelect: onRowSelect
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderReceiveHistory',
	        value: function renderReceiveHistory() {
	            var _this4 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.receiveHistory);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var receiveHistory = Object.assign({}, _this4.state.receiveHistory, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this4.setState({ receiveHistory: receiveHistory });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this4.state.receiveHistory.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var receiveHistory = _extends({}, _this4.state.receiveHistory, { filters: newFilters });
	                    _this4.setState({ receiveHistory: receiveHistory });
	                };
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var receiveHistory = _extends({}, _this4.state.receiveHistory, { selectedRows: rows });
	                    _this4.setState({ receiveHistory: receiveHistory });
	                };
	
	                // Handle the editable function
	
	                // const handleRowUpdated = e => {
	                //     // merge updated row with current row and rerender by setting state
	                //     let rows = this.state.rows.slice(0);
	                //     let editedRows = this.state.editedRows.slice(0);
	                //     Object.assign(rows[e.rowIdx], e.updated);
	                //     // if the element is already edited, remove the old one.
	                //     editedRows.forEach((element, index) => {
	                //         if (element.Product_id === rows[e.rowIdx].Product_id)
	                //             editedRows.splice(index, 1)
	                //     }, this);
	                //     // push the row into the editedRows array
	                //     editedRows.push(rows[e.rowIdx]);
	                //     this.setState({
	                //         rows: rows,
	                //         editedRows: editedRows
	                //     });
	                // }
	
	                //Custom Formatter component
	                var IsEnabledFormatter = _react2.default.createClass({
	                    displayName: 'IsEnabledFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-success' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disable' })
	                        );
	                    }
	                });
	
	                var columns = [{
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                    resizable: true,
	                    width: 220,
	                    sortable: true,
	                    filterable: true,
	                    locked: true
	                }, {
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	                    resizable: true,
	                    width: 100,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'ProductDescription',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                    resizable: true,
	                    width: 200,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'Quantity',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	                    resizable: true,
	                    width: 80,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'RcvTotalPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_total_dollarsign' }),
	                    resizable: true,
	                    width: 120,
	                    sortable: true,
	                    filterable: true
	                }];
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '100%' }, id: 'PutAwayForm-dataGrid2' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'WarehouseReceiveLine_id',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowHeight: 25,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: 170,
	                                enableRowSelect: 'single',
	                                onRowSelect: onRowSelect
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderNewPutAway',
	        value: function renderNewPutAway() {
	            var _this5 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this5.state.newPutAway);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var newPutAway = Object.assign({}, _this5.state.newPutAway, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this5.setState({ newPutAway: newPutAway });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this5.state.newPutAway.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var newPutAway = _extends({}, _this5.state.newPutAway, { filters: newFilters });
	                    _this5.setState({ newPutAway: newPutAway });
	                };
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var newPutAway = _extends({}, _this5.state.newPutAway, { selectedRows: rows });
	                    _this5.setState({ newPutAway: newPutAway });
	                };
	
	                var onRowsSelected = function onRowsSelected(rows) {
	                    var newRows = _this5.state.newPutAway.rows;
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = true;
	                    });
	                    var newPutAway = _extends({}, _this5.state.newPutAway, { rows: newRows });
	                    _this5.setState({ newPutAway: newPutAway });
	                };
	
	                var onRowsDeselected = function onRowsDeselected(rows) {
	                    var newRows = _this5.state.newPutAway.rows;
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = false;
	                    });
	                    // var rowIndexes = rows.map(r => r.rowIdx);
	                    var newPutAway = _extends({}, _this5.state.newPutAway, { rows: newRows });
	                    _this5.setState({ newPutAway: newPutAway });
	                };
	
	                // Handle the editable function
	
	                var handleRowUpdated = function handleRowUpdated(e) {
	                    // merge updated row with current row and rerender by setting state
	                    var rows = _this5.state.newPutAway.rows.slice(0);
	                    var editedRows = _this5.state.newPutAway.editedRows.slice(0);
	                    Object.assign(rows[e.rowIdx], e.updated);
	                    // if the element is already edited, remove the old one.
	                    editedRows.forEach(function (element, index) {
	                        if (element.Product_id === rows[e.rowIdx].Product_id) editedRows.splice(index, 1);
	                    }, _this5);
	                    // push the row into the editedRows array
	                    editedRows.push(rows[e.rowIdx]);
	                    var newPutAway = _extends({}, _this5.state.newPutAway, { rows: rows, editedRows: editedRows });
	                    _this5.setState({ newPutAway: newPutAway });
	                };
	
	                //Custom Formatter component
	                var IsEnabledFormatter = _react2.default.createClass({
	                    displayName: 'IsEnabledFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-success' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disable' })
	                        );
	                    }
	                });
	
	                var columns = [{
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                    resizable: true,
	                    width: 220,
	                    sortable: true,
	                    filterable: true,
	                    locked: true
	                }, {
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	                    resizable: true,
	                    width: 100,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'ProductDescription',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                    resizable: true,
	                    width: 200,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'Quantity',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	                    resizable: true,
	                    width: 80,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'ZoneName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_name' }),
	                    resizable: true,
	                    width: 100,
	                    sortable: true,
	                    editable: true,
	                    filterable: true
	                }, {
	                    key: 'BinName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin_name' }),
	                    resizable: true,
	                    width: 100,
	                    sortable: true,
	                    editable: true,
	                    filterable: true
	                }, {
	                    key: 'PutAwayQuantity',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'putaway_qty' }),
	                    resizable: true,
	                    width: 120,
	                    sortable: true,
	                    editable: true,
	                    filterable: true
	                }];
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '100%' }, id: 'PutAwayForm-dataGrid3' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'WarehouseReceiveLine_id',
	                                enableCellSelect: true,
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowHeight: 25,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: 170,
	                                enableRowSelect: 'single',
	                                onRowUpdated: handleRowUpdated,
	                                rowSelection: {
	                                    showCheckbox: true,
	                                    enableShiftSelect: true,
	                                    onRowsSelected: onRowsSelected,
	                                    onRowsDeselected: onRowsDeselected,
	                                    selectBy: {
	                                        isSelectedKey: 'isSelected'
	                                    }
	                                }
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderProducts',
	        value: function renderProducts(bin) {
	            var products = bin.Product;
	            if (products) {
	                return products.map(function (product) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'marginTopStyle' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            ' ',
	                            product.Name,
	                            ' '
	                        )
	                    );
	                });
	            }
	        }
	    }, {
	        key: 'renderBins',
	        value: function renderBins() {
	            var _this6 = this;
	
	            var _props = this.props,
	                currentZoneDetail = _props.currentZoneDetail,
	                bins = _props.bins,
	                detailError = _props.detailError,
	                detailIsLoading = _props.detailIsLoading;
	
	            if (detailIsLoading && !detailError) return _react2.default.createElement(_spinner2.default, { className: 'marginTopStyle' });else if (detailError) return _react2.default.createElement(
	                'div',
	                { className: 'alert alert-danger' },
	                JSON.stringify(this.props.detailError)
	            );
	            if (bins) {
	                return bins.map(function (bin) {
	                    var Name = bin.Name,
	                        Description = bin.Description,
	                        WarehouseBin_id = bin.WarehouseBin_id;
	
	                    return _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { className: 'bin-panel' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 12 },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { xs: 4 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { xs: 8 },
	                                            Name || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { xs: 4 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ID' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { xs: 8 },
	                                            WarehouseBin_id || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehousebin_id' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { xs: 4 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'products' })
	                                            )
	                                        )
	                                    ),
	                                    _this6.renderProducts(bin)
	                                )
	                            )
	                        )
	                    );
	                });
	            }
	        }
	
	        // handleFormSave(e) {
	        //   // nextProps.receiveHistoryDetail
	        //   e.preventDefault();
	        //   if(this.props.currentPutAwayDetail){
	        //     let warehousePutAway_id = this.props.currentPutAwayDetail.WarehousePutAway_id
	        //     this.props.editPutAway(this.props.currentPutAwayDetail, this.state.newPutAway.rows, warehousePutAway_id);
	        //   }
	        //   else
	        //     this.props.createPutAway(this.props.receiveHistoryDetail, this.state.newPutAway.rows);
	        //   // this.props.fetchReceiveHistoryDetail(this.state.receiveHistories.selectedRows[0].WarehouseReceive_id);
	        // }
	
	    }, {
	        key: 'handleFormSubmit',
	        value: function handleFormSubmit(formProps) {
	            this.setState({ dirty: false });
	            if (this.props.currentPutAwayDetail) {
	                if (!this.checkPermission("change_put_away")) {
	                    var warehousePutAway_id = this.props.currentPutAwayDetail.WarehousePutAway_id;
	                    this.props.editPutAway(formProps, this.props.currentPutAwayDetail, this.state.newPutAway.rows, warehousePutAway_id);
	                } else alert("You have no permission!");
	            } else this.props.createPutAway(formProps, this.props.receiveHistoryDetail, this.state.newPutAway.rows);
	            // if (!this.props.currentPurchaseTemplate) this.props.createPurchaseTemplate(formProps, Data.Selectors.getRows(this.state));
	            // else this.props.editPurchaseTemplate(formProps, Data.Selectors.getRows(this.state));
	        }
	    }, {
	        key: 'deletePutAway',
	        value: function deletePutAway(e) {
	            e.preventDefault();
	            var newPutAway = this.state.newPutAway;
	
	            var newPutAwayRows = [].concat(_toConsumableArray(newPutAway.rows));
	
	            newPutAwayRows = newPutAwayRows.filter(function (obj) {
	                return obj.isSelected == false || obj.isSelected == null;
	            });
	
	            var newNewPutAway = _extends({}, newPutAway, { rows: newPutAwayRows });
	            this.setState({
	                newPutAway: newNewPutAway
	            });
	        }
	    }, {
	        key: 'getWarehouseOptions',
	        value: function getWarehouseOptions() {
	            var warehouseOptions = [];
	            this.props.warehouses.map(function (warehouse) {
	                warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name });
	            });
	            return warehouseOptions;
	        }
	    }, {
	        key: 'getZoneOptions',
	        value: function getZoneOptions() {
	            var zoneOptions = [];
	            if (this.props.currentWarehouseDetail) {
	                this.props.currentWarehouseDetail.Warehouse_Zone.map(function (zone) {
	                    zoneOptions.push({ value: zone.WarehouseZone_id, label: zone.Name });
	                });
	            }
	            return zoneOptions;
	        }
	    }, {
	        key: 'header',
	        value: function header() {
	            return _react2.default.createElement(
	                'h2',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_put_away_inventory' })
	            );
	        }
	    }, {
	        key: 'putawayDetailHeader',
	        value: function putawayDetailHeader() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h4',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'put_away_details' })
	                )
	            );
	        }
	    }, {
	        key: 'zoneDetailHeader',
	        value: function zoneDetailHeader() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h4',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_details' })
	                )
	            );
	        }
	    }, {
	        key: 'checkPermission',
	        value: function checkPermission(permission) {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this7 = this;
	
	            var _props2 = this.props,
	                handleSubmit = _props2.handleSubmit,
	                submitting = _props2.submitting,
	                pristine = _props2.pristine;
	
	            var titleClass = (0, _classnames2.default)('control-label', 'col-sm-4');
	            var createDialogStyle = {
	                height: '700px',
	                width: '600px',
	                marginLeft: '-10%'
	            };
	            var warehouseOptions = this.getWarehouseOptions();
	            var zoneOptions = this.getZoneOptions();
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'form',
	                    { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_management' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'put_away' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            { active: 'true' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_put_away' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'success',
	                                type: 'submit' },
	                            _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Grid,
	                        { fluid: 'true', id: 'edit-put-away' },
	                        this.header(),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            _react2.default.createElement(
	                                _reactBootstrap.Panel,
	                                { id: 'receive-history-table' },
	                                this.renderTable()
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Panel,
	                                { id: 'receive-history-detail-table' },
	                                _react2.default.createElement(
	                                    _reactBootstrap.ButtonToolbar,
	                                    { className: 'table-button-relative' },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        {
	                                            className: 'btn btn-primary marginLeftStyle',
	                                            onClick: function onClick(e) {
	                                                console.log("61");_this7.clickNew(e);
	                                            } },
	                                        _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_receive_history' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    this.renderReceiveHistory()
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Panel,
	                                { id: 'put-away-table' },
	                                _react2.default.createElement(
	                                    _reactBootstrap.ButtonToolbar,
	                                    { className: 'table-button-relative' },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        {
	                                            className: 'btn btn-primary marginLeftStyle',
	                                            onClick: function onClick(e) {
	                                                return _this7.clickNewPutAway(e);
	                                            } },
	                                        _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_put_away' })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        {
	                                            bsStyle: 'danger',
	                                            onClick: function onClick(e) {
	                                                return _this7.deletePutAway(e);
	                                            }
	                                        },
	                                        _react2.default.createElement('em', { className: 'fa fa-trash' }),
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                                    )
	                                ),
	                                this.renderNewPutAway()
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement(
	                                _reactBootstrap.Panel,
	                                { id: 'put-away-details' },
	                                this.putawayDetailHeader(),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'created' }),
	                                            ':',
	                                            _react2.default.createElement(
	                                                'span',
	                                                { style: { color: "red" } },
	                                                '*'
	                                            )
	                                        ),
	                                        _react2.default.createElement(_reduxForm.Field, { selected: new Date(), component: _datePicker.DisabledDatePicker, name: 'CreateTime' })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'updated' }),
	                                            _react2.default.createElement(
	                                                'span',
	                                                { style: { color: "red" } },
	                                                '*'
	                                            )
	                                        ),
	                                        _react2.default.createElement(_reduxForm.Field, { selected: new Date(), component: _datePicker.DisabledDatePicker, name: 'UpdateTime' })
	                                    )
	                                ),
	                                this.zoneDetailHeader(),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 12 },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_select_warehouse' })
	                                        ),
	                                        _react2.default.createElement(_reduxForm.Field, { name: 'Default_Warehouse_id', component: _selection2.default, options: warehouseOptions })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 12 },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_select_warehouse_zone' })
	                                        ),
	                                        _react2.default.createElement(_reduxForm.Field, { name: 'Default_WarehouseZone_id', component: _selection2.default, options: zoneOptions })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    { style: { overflowY: "scroll", height: "466px", marginTop: "10px" } },
	                                    this.renderBins()
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactSkylight.SkyLightStateless,
	                    { dialogStyles: createDialogStyle, isVisible: this.state.showZonesOpen, onCloseClicked: function onCloseClicked() {
	                            _this7.closeShowZones();
	                        }, title: 'Choose a Zone to relocate' },
	                    _react2.default.createElement(_zoneInformation2.default, null)
	                )
	            );
	        }
	    }]);
	
	    return PutAwayForm;
	}(_react.Component);
	
	PutAwayForm.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = PutAwayForm;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(renderDatePicker, 'renderDatePicker', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/putAwayForm.jsx');
	
	    __REACT_HOT_LOADER__.register(PutAwayForm, 'PutAwayForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/putAwayForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/putAwayForm.jsx');
	}();

	;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(69);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _GenericProductSuggest = __webpack_require__(51);
	
	var _GenericProductSuggest2 = _interopRequireDefault(_GenericProductSuggest);
	
	var _TypeRadios = __webpack_require__(57);
	
	var _TypeRadios2 = _interopRequireDefault(_TypeRadios);
	
	var _datePicker = __webpack_require__(27);
	
	var _inputField = __webpack_require__(16);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _setReceiveWeightModal = __webpack_require__(174);
	
	var _setReceiveWeightModal2 = _interopRequireDefault(_setReceiveWeightModal);
	
	var _selection = __webpack_require__(21);
	
	var _warehouseDropdown = __webpack_require__(163);
	
	var _warehouseDropdown2 = _interopRequireDefault(_warehouseDropdown);
	
	var _cleanDates = __webpack_require__(22);
	
	var _numberWithCommas = __webpack_require__(35);
	
	var _root_url = __webpack_require__(9);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _warehouseManagement = __webpack_require__(312);
	
	var _warehouseManagement2 = _interopRequireDefault(_warehouseManagement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LocationSelectModal = _warehouseManagement2.default.LocationSelectModal;
	
	var isEcity = _root_url.ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === "https://dev-scm.truckxi.com/api/";
	var isHMM = _root_url.ROOT_API_URL === 'https://hmm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://hmm-scm.truckxi.com/api/';
	var isMmDavis = _root_url.ROOT_API_URL === 'https://mmdavis-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://mmdavis-scm.truckxi.com/api/';
	var isTN = _root_url.ROOT_API_URL === "https://tn-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://tn-scm.truckxi.com/api/";
	var isUSPride = _root_url.ROOT_API_URL === "https://uspride-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://uspride-scm.truckxi.com/api/";
	var isOCM = _root_url.ROOT_API_URL === 'https://ocm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ocm-scm.truckxi.com/api/';
	var isATL = _root_url.ROOT_API_URL === 'https://alton-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://alton-scm.truckxi.com/api/';
	var isRS = _root_url.ROOT_API_URL === 'https://redstone-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://redstone-scm.truckxi.com/api/';
	var isLO = _root_url.ROOT_API_URL === 'https://lonni-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://lonni-scm.truckxi.com/api/';
	
	// import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style'
	
	var renderInputField = function renderInputField(props) {
	  var inputClass = (0, _classnames2.default)({ 'parsley-error': props.meta.touched && props.meta.error }, 'form-control');
	  return _react2.default.createElement(
	    'div',
	    null,
	    props.meta.touched && props.meta.error && _react2.default.createElement(
	      'span',
	      { className: 'parsley-error-message' },
	      props.meta.error
	    ),
	    _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { className: inputClass, type: 'text', placeholder: props.placeholder }))
	  );
	};
	
	var inputStyle = {
	  display: 'block',
	  width: '100%',
	  height: '24px',
	  padding: '2px 2px',
	  fontSize: '12px',
	  lineHeight: '1.52857',
	  color: '#000',
	  backgroundColor: '#fff',
	  backgroundImage: 'none',
	  border: '1px solid #555555',
	  borderRadius: '3px',
	  boxShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.075)',
	  transition: 'border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s'
	};
	
	var renderDatePicker = function renderDatePicker(props) {
	  return _react2.default.createElement(_DateTimePicker2.default, {
	    format: 'YYYY-MM-DD',
	    defaultValue: null,
	    time: false,
	    onChange: function onChange(name) {
	      return props.input.onChange(name);
	    },
	    value: props.input.value || null
	  });
	};
	
	var Checkbox = function Checkbox(props) {
	  return _react2.default.createElement('input', _extends({}, props.input, {
	    type: 'checkbox',
	    value: !props.input.value ? "true" : "false",
	    checked: props.input.value === true || props.input.value === "true",
	    disabled: props.disabled
	  }));
	};
	
	var sortByLineID = function sortByLineID(a, b) {
	  return parseFloat(a.PurchaseOrderLine_id) - parseFloat(b.PurchaseOrderLine_id);
	};
	
	var RowRenderer = function (_Component) {
	  _inherits(RowRenderer, _Component);
	
	  function RowRenderer() {
	    _classCallCheck(this, RowRenderer);
	
	    return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(RowRenderer, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { onDoubleClick: function onDoubleClick() {
	            _this2.props.onDoubleClick(_this2.props.row);
	          } },
	        _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	      );
	    }
	  }]);
	
	  return RowRenderer;
	}(_react.Component);
	
	var ReceiveForm = function (_Component2) {
	  _inherits(ReceiveForm, _Component2);
	
	  function ReceiveForm() {
	    _classCallCheck(this, ReceiveForm);
	
	    var _this3 = _possibleConstructorReturn(this, (ReceiveForm.__proto__ || Object.getPrototypeOf(ReceiveForm)).call(this));
	
	    _this3.focus = function () {
	      _this3.textInput.current.focus();
	    };
	
	    _this3.handleNewReceiveDetails = function (nextProps, newInventory) {
	      var inventories = newInventory ? _this3.state.inventories.rows : [].concat(_toConsumableArray(nextProps.currentReceiveDetail.Purchase_Order_Line));
	      inventories.map(function (inventory, index) {
	        inventory.ProductName = inventory.Product_id.Name;
	        inventory.ProductNum = inventory.Product_id.ProductNum;
	        inventory.ProductDescription = inventory.Product_id.Description;
	        if (isHMM && inventory.package_size.split('SFT').length > 1) {
	          inventory.RcvUnitPrice = inventory.FOBUnitPrice * Number(inventory.package_size.split('SFT')[0]);
	        } else {
	          inventory.RcvUnitPrice = inventory.FOBUnitPrice;
	        }
	        inventory.RcvUnitPrice2 = inventory.FOBUnitPrice;
	        inventory.RcvQuantity = 0;
	        inventory.WarehouseZone_id = inventory.Product_id.Default_WarehouseZone_id;
	        inventory.Default_WarehouseFromBin_id = inventory.Product_id.Default_WarehouseFromBin_id;
	        inventory.Default_WarehouseToBin_id = inventory.Product_id.Default_WarehouseToBin_id;
	        inventory.StorageRate = 0;
	        inventory.subWeights = [];
	        inventory.RtnQuantity = 0;
	        inventory.RefNum = inventory.Product_id.RefNum;
	        inventory.uniqID = index;
	        if (inventory.Product_id.UnitPerPallet) {
	          var n = parseInt(inventory.Quantity / inventory.Product_id.UnitPerPallet);
	          if (inventory.Quantity % inventory.Product_id.UnitPerPallet) {
	            inventory.Pallet = n + 1;
	          } else {
	            inventory.Pallet = n;
	          }
	          if (!inventory.Pallet) {
	            inventory.Pallet = 0;
	          }
	        } else {
	          inventory.Pallet = 0;
	        }
	      });
	
	      var receivedInventories = [].concat(_toConsumableArray(nextProps.currentReceiveDetail.Warehouse_Receive_Line));
	      receivedInventories.map(function (inventory, index) {
	        inventory.ProductName = inventory.Product_id.Name;
	        inventory.ProductNum = inventory.Product_id.ProductNum;
	        inventory.ProductDescription = inventory.Product_id.Description;
	        if (isHMM && inventory.package_size.split('SFT').length > 1) {
	          inventory.RcvUnitPrice = inventory.FOBUnitPrice * Number(inventory.package_size.split('SFT')[0]);
	        } else {
	          inventory.RcvUnitPrice = inventory.FOBUnitPrice;
	        }
	        inventory.RcvUnitPrice2 = inventory.FOBUnitPrice;
	        inventory.RcvQuantity = 0;
	        inventory.WarehouseZone_id = inventory.Product_id.Default_WarehouseZone_id;
	        inventory.Default_WarehouseFromBin_id = inventory.Product_id.Default_WarehouseFromBin_id;
	        inventory.Default_WarehouseToBin_id = inventory.Product_id.Default_WarehouseToBin_id;
	        inventory.StorageRate = 0;
	        inventory.subWeights = [];
	        inventory.RtnQuantity = 0;
	        inventory.RcvTotalWeight = 0;
	        inventory.RefNum = inventory.Product_id.RefNum;
	        inventory.uniqID = index;
	        if (inventory.Product_id.UnitPerPallet) {
	          var n = parseInt(inventory.Quantity / inventory.Product_id.UnitPerPallet);
	          if (inventory.Quantity % inventory.Product_id.UnitPerPallet) {
	            inventory.Pallet = n + 1;
	          } else {
	            inventory.Pallet = n;
	          }
	          if (!inventory.Pallet) {
	            inventory.Pallet = 0;
	          }
	        } else {
	          inventory.Pallet = 0;
	        }
	      });
	      var newInventories = _extends({}, _this3.state.inventories, { rows: inventories.sort(sortByLineID) });
	      var newReceivedInventories = _extends({}, _this3.state.receivedInventories, { rows: receivedInventories.sort(sortByLineID) });
	
	      if (nextProps.currentReceive) {
	        var curReceive = nextProps.currentReceive;
	        // this.receiptNum = ;
	        var warehouseName = curReceive.WarehouseName;
	        // this.receiver = ;
	        var PONum = curReceive.PONum;
	        var purchaser = curReceive.Purchaser;
	
	        var vendorNum = curReceive.VendorNum;
	        var vendorName = curReceive.vendorName;
	        var vendorDescription = curReceive.VendorDescription;
	        // this.vendorAdd = ;
	        // this.vendorContact = ;
	        var orderDate = curReceive.OrderDate;
	        var ETADate = curReceive.ETADate;
	
	        _this3.setState({
	          warehouseName: warehouseName,
	          PONum: PONum,
	          purchaser: purchaser,
	          vendorNum: vendorNum,
	          vendorName: vendorName,
	          vendorDescription: vendorDescription,
	          orderDate: orderDate,
	          ETADate: ETADate
	        });
	      }
	
	      _this3.setState({
	        inventories: newInventories,
	        receivedInventories: newReceivedInventories
	      });
	
	      if (nextProps.createTime) {
	        _this3.setState({ createTime: nextProps.createTime });
	      }
	    };
	
	    _this3.autoLoad = function () {
	      var inventories = _extends({}, _this3.state.inventories);
	      var receivedInventories = _extends({}, _this3.state.receivedInventories);
	
	      inventories.rows = inventories.rows.map(function (r) {
	        r.isSelected = false;
	        if (isTN) {
	          r.location = 'DZ';
	        }
	        if (r.Product_id.ProductType === 'Fixed' || r.Product_id.ProductType === 'Non-Product') {
	          r.RcvQuantity = r.Quantity;
	          // r.RcvTotalWeight = ((parseFloat(r.RcvQuantity) || 0)*(parseFloat(r.Product_id.NetWeight) || 0)).toFixed(2)
	          r.RcvTotalPrice = +((parseFloat(r.RcvQuantity) || 0) * (parseFloat(r.RcvUnitPrice) || 0)).toFixed(2);
	          r.RcvTotalWeight = +((parseFloat(r.RcvQuantity) || 0) * (parseFloat(r.Product_id.NetWeight) || 0)).toFixed(2);
	          receivedInventories.rows.push(r);
	          return null;
	        } else if (r.Product_id.ProductType === 'Per-Pound') {
	          r.RcvQuantity = r.Quantity;
	
	          // r.RcvTotalWeight = ((parseFloat(r.RcvQuantity) || 0)*(parseFloat(r.Product_id.NetWeight) || 0)).toFixed(2)
	          r.RcvTotalPrice = +((parseFloat(r.RcvQuantity) || 0) * (parseFloat(r.Product_id.NetWeight) || 0) * (parseFloat(r.RcvUnitPrice) || 0)).toFixed(2);
	          r.RcvTotalWeight = +((parseFloat(r.RcvQuantity) || 0) * (parseFloat(r.Product_id.NetWeight) || 0)).toFixed(2);
	          receivedInventories.rows.push(r);
	          return null;
	        }
	        return r;
	      });
	
	      inventories.rows = inventories.rows.filter(function (obj) {
	        return obj !== null;
	      });
	      var totalPrice = 0;
	      receivedInventories.rows.map(function (r) {
	        totalPrice += parseFloat(Math.round((parseFloat(r.RcvTotalPrice) || 0) * 100) / 100);
	      });
	      // totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	      totalPrice = +parseFloat(totalPrice).toFixed(2);
	      receivedInventories.rows.sort(sortByLineID);
	      _this3.setState({ receivedInventories: receivedInventories, inventories: inventories, totalPrice: totalPrice });
	    };
	
	    _this3.manualLoad = function () {
	      var inventories = _extends({}, _this3.state.inventories);
	      var receivedInventories = _extends({}, _this3.state.receivedInventories);
	
	      var receivedInventoriesRows = [].concat(_toConsumableArray(receivedInventories.rows));
	      var selectedInventoriesRows = [].concat(_toConsumableArray(inventories.selectedRows));
	      var inventoriesRows = [].concat(_toConsumableArray(inventories.rows));
	
	      selectedInventoriesRows.map(function (row, i) {
	        row.isSelected = false;
	        if (isTN) {
	          row.location = 'DZ';
	        }
	        if (row.Product_id.ProductType === 'Fixed' || row.Product_id.ProductType === 'Non-Product') {
	          row.RcvTotalPrice = ((parseFloat(row.RcvQuantity) || 0) * (parseFloat(row.RcvUnitPrice) || 0)).toFixed(2);
	          receivedInventoriesRows.push(row);
	          var index = _lodash2.default.findIndex(inventoriesRows, { ProductNum: row.ProductNum });
	          if (index > -1) {
	            inventoriesRows.splice(index, 1);
	          }
	        } else if (row.Product_id.ProductType === 'Per-Pound') {
	          row.RcvTotalPrice = ((parseFloat(row.RcvQuantity) || 0) * (parseFloat(row.Product_id.NetWeight) || 0) * (parseFloat(row.RcvUnitPrice) || 0)).toFixed(2);
	          receivedInventoriesRows.push(row);
	          var _index = _lodash2.default.findIndex(inventoriesRows, { ProductNum: row.ProductNum });
	          if (_index > -1) {
	            inventoriesRows.splice(_index, 1);
	          }
	        }
	      });
	
	      receivedInventories = _extends({}, receivedInventories, { rows: receivedInventoriesRows.sort(sortByLineID) });
	      inventories = _extends({}, inventories, { rows: inventoriesRows, selectedRows: [] });
	
	      var totalPrice = 0;
	      receivedInventories.rows.map(function (r) {
	        totalPrice += parseFloat(Math.round((parseFloat(r.RcvTotalPrice) || 0) * 100) / 100);
	      });
	      // totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	      totalPrice = parseFloat(totalPrice).toFixed(2);
	      _this3.setState({ receivedInventories: receivedInventories, inventories: inventories, totalPrice: totalPrice });
	    };
	
	    _this3.selectInventoryInfo = function (selectedInventoryRow) {
	      _this3.setState({ ProductNum: selectedInventoryRow });
	    };
	
	    _this3.handleOptionChange = function (changeEvent) {
	      _this3.setState({ productSearchType: changeEvent.target.value });
	    };
	
	    _this3.handleProductSelect = function (product, suggestion, e) {
	      var Product_id = {
	        CRV: suggestion.CRV,
	        Description: suggestion.Description,
	        IsTaxable: suggestion.IsTaxable,
	        Name: suggestion.Name,
	        NetWeight: suggestion.NetWeight,
	        ProductNum: suggestion.ProductNum,
	        ProductType: suggestion.ProductType,
	        Product_id: suggestion.Product_id,
	        RefNum: suggestion.RefNum,
	        WeightRange: { MaxWeigh: 0, MinWight: 0 }
	      };
	      suggestion.Product_id = Product_id;
	      _this3.setState({
	        selectedProduct: _extends({}, _this3.state.selectedProduct, {
	          product: suggestion,
	          UnitPrice: suggestion.RefPrice
	        })
	      }, function () {
	        var tabindex = $(e).attr("tabindex") || 0;
	        tabindex = Number(tabindex);
	        tabindex += 1;
	        var elem = $("[tabindex=" + tabindex + "]");
	        if (elem[0]) {
	          elem.focus();
	        }
	      });
	    };
	
	    _this3.autoTab = function (e) {
	      var tabindex = $(e.target).attr("tabindex") || 0;
	      tabindex = Number(tabindex);
	      if (e.key === 'Enter') {
	        tabindex += 1;
	      }
	      var elem = $("[tabindex=" + tabindex + "]");
	      if (elem[0]) {
	        elem.focus();
	      }
	    };
	
	    _this3.configureQuantity = function (e) {
	      _this3.setState({
	        selectedProduct: _extends({}, _this3.state.selectedProduct, {
	          Quantity: e.target.value
	        }) });
	    };
	
	    _this3.configureUnitPrice = function (e) {
	      _this3.setState({
	        selectedProduct: _extends({}, _this3.state.selectedProduct, {
	          UnitPrice: e.target.value
	        })
	      });
	    };
	
	    _this3.addProductCB = function () {
	      var array = _this3.state.inventories.rows.concat(_this3.state.selectedProduct.product);
	      _this3.setState({
	        inventories: _extends({}, _this3.state.inventories, {
	          rows: array
	        })
	      }, function () {
	        _this3.handleNewReceiveDetails(_this3.props, true);
	      });
	    };
	
	    _this3.addProduct = function (e) {
	      if (e.key === 'Enter') {
	        _this3.setState({
	          selectedProduct: _extends({}, _this3.state.selectedProduct, {
	            newProductAdded: true,
	            product: _extends({}, _this3.state.selectedProduct.product, {
	              Quantity: _this3.state.selectedProduct.Quantity,
	              FOBUnitPrice: _this3.state.selectedProduct.UnitPrice
	            })
	          })
	        }, function () {
	          _this3.addProductCB();
	        });
	      }
	    };
	
	    _this3.setLocationSelectModalVisibility = function () {
	      var isLocationSelectModalVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this3.setState({ isLocationSelectModalVisible: isLocationSelectModalVisible });
	    };
	
	    _this3.handleLocationSelect = function (location) {
	      var newLine = _extends({}, _this3.state.editingLine, location);
	      var rows = [].concat(_toConsumableArray(_this3.state.receivedInventories.rows));
	
	      rows[newLine.uniqID] = newLine;
	      _this3.setState({
	        receivedInventories: _extends({}, _this3.state.receivedInventories, {
	          rows: rows
	        })
	      });
	      _this3.setLocationSelectModalVisibility();
	    };
	
	    _this3.debouncedCreateReceive = _lodash2.default.debounce(function (PostingDate, InvoiceDate, HandlingCost, MiscCost, ShippingCost, priceAdjustment, ShareCost, PONum, Note, Warehouse_id, VendorPicklistNum, Vendor_id, ReceivingPrice, InvoiceFinalPrice, Warehouse_Receive_Line, formProps, completeReceive) {
	      _this3.props.createReceive(PostingDate, InvoiceDate, HandlingCost, MiscCost, ShippingCost, priceAdjustment, ShareCost, PONum, Note, Warehouse_id, VendorPicklistNum, Vendor_id, ReceivingPrice, InvoiceFinalPrice, Warehouse_Receive_Line, formProps, completeReceive);
	    }, 500, { maxWait: 1500 });
	
	    _this3.IFrameIsLoaded = function () {
	      if (!_this3.state.PdfFrameLoaded) {
	        var pdfFrame = window.frames.Pdf;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this3.setState({ PdfFrameLoaded: true });
	      }
	    };
	
	    _this3.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton - 50,
	
	      confirmOpen: false,
	      saveConfirmOpen: false,
	      setWeightOpen: false,
	      totalLoaded: null,
	      rowChosen: -1,
	      tableChosen: null,
	      formProps: null,
	
	      inventories: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      receivedInventories: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      receiptNum: null,
	      warehouseName: null,
	      receiver: null,
	      PONum: null,
	      purchaser: null,
	      vendorNum: null,
	      vendorName: null,
	      vendorDescription: null,
	      vendorAdd: null,
	      vendorContact: null,
	      orderDate: null,
	      ETADate: null,
	      createTime: null,
	      totalPrice: null,
	      caseAction: null,
	      MiscCost: 0,
	      HandlingCost: 0,
	      ShippingCost: 0,
	      priceAdjustment: 0,
	      ShareCost: false,
	      InvoiceFinalPrice: 0,
	      warehouseReceivePdf: true,
	      filteredByItem: false,
	      suggestValue: '',
	      productSearchType: 'ProductNum',
	      ProductNum: 0,
	      selectedProduct: {
	        product: {},
	        Quantity: 1,
	        UnitPrice: 0,
	        productNote: '',
	        newProductAdded: false
	      },
	      isLocationSelectModalVisible: false
	    };
	
	    _this3.handleResize = _this3.handleResize.bind(_this3);
	    _this3.openConfirm = _this3.openConfirm.bind(_this3);
	    _this3.closeConfirm = _this3.closeConfirm.bind(_this3);
	    _this3.openSetWeight = _this3.openSetWeight.bind(_this3);
	    _this3.closeSetWeight = _this3.closeSetWeight.bind(_this3);
	    _this3.completePurchaseOrder = _this3.completePurchaseOrder.bind(_this3);
	    _this3.createReceive = _this3.createReceive.bind(_this3);
	    _this3.setRows = _this3.setRows.bind(_this3);
	    _this3.moveOff = _this3.moveOff.bind(_this3);
	    _this3.moveTo = _this3.moveTo.bind(_this3);
	    _this3.handleFormSubmit = _this3.handleFormSubmit.bind(_this3);
	    _this3.showSaveConfirm = _this3.showSaveConfirm.bind(_this3);
	    _this3.closeSaveConfirm = _this3.closeSaveConfirm.bind(_this3);
	
	    _this3.setTextInputRef = function (element) {
	      _this3.textInput = element;
	    };
	
	    return _this3;
	  }
	
	  _createClass(ReceiveForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this4 = this;
	
	      window.addEventListener('resize', this.handleResize);
	      var currentReceive = this.props.currentReceive;
	
	      if (currentReceive) {
	        this.props.fetchReceiveDetail(currentReceive.PONum).then(function () {
	          _this4.props.setPostingDate(new Date(), 'receiveForm');
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	      this.props.resetCreateReceive();
	    }
	
	    // Once inventories are ready, reset state.
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (parseFloat(nextProps.MiscCost) !== this.props.MiscCost) {
	        this.setState({ MiscCost: parseFloat(nextProps.MiscCost) });
	      }
	      if (parseFloat(nextProps.HandlingCost) !== this.props.HandlingCost) {
	        this.setState({ HandlingCost: parseFloat(nextProps.HandlingCost) });
	      }
	      if (parseFloat(nextProps.ShippingCost) !== this.props.ShippingCost) {
	        this.setState({ ShippingCost: parseFloat(nextProps.ShippingCost) });
	      }
	      if (parseFloat(nextProps.priceAdjustment) !== this.props.priceAdjustment) {
	        this.setState({ priceAdjustment: parseFloat(nextProps.priceAdjustment) });
	      }
	      if (nextProps.ShareCost !== this.props.ShareCost) {
	        this.setState({ ShareCost: nextProps.ShareCost });
	      }
	
	      if (parseFloat(nextProps.InvoiceFinalPrice) !== this.props.InvoiceFinalPrice) {
	        this.setState({ InvoiceFinalPrice: parseFloat(nextProps.InvoiceFinalPrice) });
	      }
	      if (parseFloat(nextProps.TaxRate) !== this.props.TaxRate) {
	        this.setState({ TaxRate: parseFloat(nextProps.TaxRate) });
	      }
	      if (parseFloat(nextProps.TotalCRV) !== this.props.TotalCRV) {
	        this.setState({ TotalCRV: parseFloat(nextProps.TotalCRV) });
	      }
	
	      if (nextProps.currentReceiveDetail && nextProps.currentReceiveDetail != this.props.currentReceiveDetail) {
	        this.handleNewReceiveDetails(nextProps, false);
	      }
	
	      if (nextProps.warehouseReceivePdf && nextProps.warehouseReceivePdf !== this.props.warehouseReceivePdf) {
	        this.setState({ PdfFrameLoaded: false });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState.PdfFrameLoaded !== this.state.PdfFrameLoaded && this.state.PdfFrameLoaded == false) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton - 50 });
	    }
	  }, {
	    key: 'openConfirm',
	    value: function openConfirm() {
	      this.setState({ confirmOpen: true });
	    }
	  }, {
	    key: 'closeConfirm',
	    value: function closeConfirm() {
	      this.setState({ confirmOpen: false });
	    }
	  }, {
	    key: 'closeSetWeight',
	    value: function closeSetWeight() {
	      this.setState({ setWeightOpen: false });
	    }
	  }, {
	    key: 'openSetWeight',
	    value: function openSetWeight() {
	      this.setState({ setWeightOpen: true });
	    }
	  }, {
	    key: 'showSaveConfirm',
	    value: function showSaveConfirm() {
	      this.setState({
	        saveConfirmOpen: true
	      });
	    }
	  }, {
	    key: 'closeSaveConfirm',
	    value: function closeSaveConfirm() {
	      this.setState({
	        saveConfirmOpen: false
	      });
	    }
	
	    // setInventoryToReceive(e) {
	    //     e.preventDefault();
	    //     const { inventories, receivedInventories } = this.state;
	    //     const inventoryToReceive = { ...inventories.selectedRows[0],
	    //         ToZone: this.props.toZoneValue,
	    //         ToBin: this.props.toBinValue,
	    //         RcvQuantity: this.props.rcvQuantityValue,
	    //         RcvUnitPrice: this.props.rcvUnitPriceValue,
	    //         RcvTotalPrice: this.props.rcvTotalPriceValue,
	    //         Pallet: this.props.palletValue,
	    //         StorageRate: this.props.storageRateValue,
	    //         RtnQuantity: this.props.rtnQuantityValue
	    //     };
	    //
	    //     const newReceivedInventories = { ...receivedInventories };
	    //     const newInventories = { ...inventories };
	    //     newReceivedInventories.rows.push(inventoryToReceive)
	    //
	    //     const index = _.findIndex(inventories.rows, { 'Product_id': inventories.selectedRows[0].PurchaseOrderLine_id });
	    //     if (index > -1) {
	    //         newInventories.rows.splice(index, 1);
	    //     }
	    //     newInventories.selectedRows = [];
	    //     this.setState({
	    //         receivedInventories: newReceivedInventories,
	    //         inventories: newInventories
	    //     })
	    // }
	    //
	    // cancelReceive(e) {
	    //     e.preventDefault();
	    //     const { inventories, receivedInventories } = this.state;
	    //     const inventoryToCancel = { ...receivedInventories.selectedRows[0] };
	    //
	    //     const newReceivedInventories = { ...receivedInventories };
	    //     const newInventories = { ...inventories };
	    //     newInventories.rows.push(inventoryToCancel)
	    //
	    //     const index = _.findIndex(receivedInventories.rows, { 'Product_id': receivedInventories.selectedRows[0].PurchaseOrderLine_id });
	    //     if (index > -1) {
	    //         newReceivedInventories.rows.splice(index, 1);
	    //     }
	    //     newReceivedInventories.selectedRows = [];
	    //     this.setState({
	    //         receivedInventories: newReceivedInventories,
	    //         inventories: newInventories
	    //     })
	    // }
	
	  }, {
	    key: 'unload',
	    value: function unload(type) {
	      var inventories = this.state.inventories;
	      var receivedInventories = this.state.receivedInventories;
	      // left and right table rows
	
	      var inventoriesRows = inventories.rows;
	      var receivedInventoriesRows = receivedInventories.rows;
	      // right table selected rows
	      var pushbackRows = [];
	      if (type === 'selection') {
	        pushbackRows = receivedInventories.selectedRows;
	      } else if (type === 'all') {
	        pushbackRows = receivedInventories.rows;
	      }
	      // products have not been received should reset back to the inventories table
	      // reset selected rows values
	      receivedInventoriesRows.map(function (row) {
	        row.isSelected = false;
	        _lodash2.default.filter(pushbackRows, function (r) {
	          if (r.Product_id.Product_id === row.Product_id.Product_id) {
	            row.RcvQuantity = 0;
	            row.RcvTotalWeight = 0;
	            row.subWeights = [];
	          }
	          return true;
	        });
	      });
	
	      // reset pushback rows values and filter out products that have not previously received
	      pushbackRows = pushbackRows.filter(function (row) {
	        row.RcvQuantity = 0;
	        row.RcvTotalWeight = 0;
	        row.subWeights = [];
	        return row.ReceivedQuantity === 0;
	      });
	
	      // delete pushback rows from received inventories rows
	      pushbackRows.map(function (row) {
	        receivedInventoriesRows = _lodash2.default.filter(receivedInventoriesRows, function (r) {
	          return r.Product_id.Product_id !== row.Product_id.Product_id;
	        });
	      });
	
	      inventoriesRows.map(function (row) {
	        row.isSelected = false;
	        row.RcvQuantity = 0;
	        row.RcvTotalWeight = 0;
	        row.subWeights = [];
	      });
	
	      this.setState({
	        receivedInventories: _extends({}, inventories, {
	          rows: receivedInventoriesRows,
	          selectedRows: []
	        }),
	        inventories: _extends({}, receivedInventories, {
	          rows: [].concat(_toConsumableArray(inventoriesRows), _toConsumableArray(pushbackRows)).sort(sortByLineID),
	          selectedRows: []
	        })
	      });
	    }
	  }, {
	    key: 'renderAutoSuggest',
	    value: function renderAutoSuggest() {
	      var _this5 = this;
	
	      if (!this.state.filteredByItem) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'control-dropdown' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(_GenericProductSuggest2.default, {
	                value: this.state.suggestValue,
	                onChange: function onChange(e, _ref) {
	                  var newValue = _ref.newValue;
	                  _this5.setState({ suggestValue: newValue });
	                },
	                SearchType: this.state.productSearchType,
	                fetchOrdersByProduct: this.handleProductSelect,
	                setProductNum: this.selectInventoryInfo,
	                tabIndex: 0
	              })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 2 },
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 6 },
	                'Unit Price:'
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 6 },
	                _react2.default.createElement('input', {
	                  tabIndex: 1,
	                  value: this.state.selectedProduct.UnitPrice,
	                  onKeyPress: function onKeyPress(e) {
	                    return _this5.autoTab(e);
	                  },
	                  onChange: function onChange(e) {
	                    return _this5.configureUnitPrice(e);
	                  },
	                  type: 'text',
	                  style: inputStyle,
	                  placeholder: 'Quantity'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 2 },
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 6 },
	                'Quantity:'
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 6 },
	                _react2.default.createElement('input', {
	                  tabIndex: 2,
	                  value: this.state.selectedProduct.Quantity,
	                  onKeyPress: function onKeyPress(e) {
	                    return _this5.addProduct(e);
	                  },
	                  onChange: function onChange(e) {
	                    return _this5.configureQuantity(e);
	                  },
	                  type: 'text',
	                  style: inputStyle,
	                  placeholder: 'Quantity'
	                })
	              )
	            )
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { id: 'suggestion-box' },
	        this.state.suggestValue,
	        _react2.default.createElement('em', {
	          className: 'fa fa-times pull-right',
	          onClick: function onClick() {
	            _this5.setState({
	              filteredByItem: false,
	              suggestValue: ''
	            });
	          }
	        }),
	        _react2.default.createElement('input', { style: { paddingLeft: '700px' }, type: 'text', placeholder: 'wtf2' })
	      );
	    }
	
	    // LocationSelectionModal
	
	  }, {
	    key: 'renderTable',
	
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	    value: function renderTable() {
	      var _this6 = this;
	
	      if (this.props.inventoriesIsLoading && !this.props.vendorError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.inventoriesError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          this.props.inventoriesError
	        )
	      );
	
	      var productNameHash = {};
	      var productNumHash = {};
	
	      // Parameters of the react-data-grid
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this6.state.inventories);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return Object.assign({}, rows[rowIdx]);
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var inventories = _extends({}, _this6.state.inventories, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this6.setState({ inventories: inventories });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this6.state.inventories.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var inventories = _extends({}, _this6.state.inventories, { filters: newFilters });
	        _this6.setState({ inventories: inventories });
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        // merge updated row with current row and rerender by setting state
	        var inventories = _this6.state.inventories;
	
	        var rows = inventories.rows.slice(0);
	        if (e.updated.RcvQuantity != null) {
	          if (rows[e.rowIdx].Product_id.ProductType === 'Non-Fixed') {
	            Object.assign(rows[e.rowIdx], e.updated);
	            _this6.setState({ totalLoaded: rows[e.rowIdx].RcvQuantity, rowChosen: e.rowIdx, tableChosen: 'inventories' });
	            // if (!isEcity) {
	            _this6.openSetWeight();
	            // }
	          } else if (rows[e.rowIdx].Product_id.ProductType === 'Fixed' || rows[e.rowIdx].Product_id.ProductType === 'Non-Product') {
	            Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvQuantity) || 0) * (parseFloat(rows[e.rowIdx].RcvUnitPrice) || 0), 2).toFixed(2) });
	            Object.assign(rows[e.rowIdx], e.updated);
	          } else {
	            Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvQuantity) || 0) * (parseFloat(rows[e.rowIdx].Product_id.NetWeight) || 0) * (parseFloat(rows[e.rowIdx].RcvUnitPrice) || 0), 2).toFixed(2) });
	            Object.assign(rows[e.rowIdx], e.updated);
	          }
	        } else if (e.updated.RcvUnitPrice != null) {
	          if (rows[e.rowIdx].Product_id.ProductType == 'Non-Fixed' || rows[e.rowIdx].Product_id.ProductType === 'Per-Pound') {
	            Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvUnitPrice) || 0) * (parseFloat(rows[e.rowIdx].RcvTotalWeight) || 0), 2).toFixed(2) });
	          } else {
	            Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvUnitPrice) || 0) * (parseFloat(rows[e.rowIdx].RcvQuantity) || 0), 2).toFixed(2) });
	          }
	          Object.assign(rows[e.rowIdx], e.updated);
	        }
	
	        // if(e.cellKey == 'RcvQuantity') {
	        //   Object.assign(rows[e.rowIdx], e.updated);
	        //   // totalLoaded: null,
	        //   // rowChosen: null,
	        // }
	        else if (e.updated.RcvTotalWeight != null) {
	            if (rows[e.rowIdx].Product_id.ProductType === 'Non-Fixed' || rows[e.rowIdx].Product_id.ProductType === 'Per-Pound') {
	              Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvTotalWeight) || 0) * (parseFloat(rows[e.rowIdx].RcvUnitPrice) || 0), 2).toFixed(2) });
	              Object.assign(rows[e.rowIdx], e.updated);
	            }
	          } else {
	            Object.assign(rows[e.rowIdx], e.updated);
	          }
	        var totalPrice = 0;
	        rows.map(function (r) {
	          totalPrice += parseFloat(Math.round((parseFloat(r.RcvTotalPrice) || 0) * 100) / 100);
	        });
	        // totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	        totalPrice = parseFloat(totalPrice).toFixed(2);
	
	        /* update selectedRows if there's anything changed on the rows */
	        var selectedRows = inventories.selectedRows;
	
	        selectedRows.map(function (row) {
	          _lodash2.default.filter(rows, function (r) {
	            if (r.PurchaseOrderLine_id === row.PurchaseOrderLine_id) {
	              var index = _lodash2.default.findIndex(selectedRows, { PurchaseOrderLine_id: row.PurchaseOrderLine_id });
	              selectedRows.splice(index, 1, r);
	            }
	            return true;
	          });
	        });
	        /* End of update selectedRows */
	
	        var newInventories = _extends({}, inventories, { rows: rows, selectedRows: selectedRows });
	        _this6.setState({
	          inventories: newInventories,
	          totalPrice: totalPrice
	        });
	
	        /*
	          the following lines handle on quantity change to move to the right table,
	          this solution does not update RcvTotalPrice,
	          so disable it for now.
	        */
	        // if (rows[e.rowIdx].Product_id.ProductType !== 'Non-Fixed' && rows[e.rowIdx].Product_id.ProductType !== 'Per-Pound') {
	        //   this.setRows(e.rowIdx, 'inventories', []);
	        // }
	      };
	
	      // Handle the row select function
	
	      var onRowSelect = function onRowSelect(rows) {
	        var inventories = _extends({}, _this6.state.inventories, { selectedRows: rows });
	        _this6.setState({ inventories: inventories });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var selectedRows = [].concat(_toConsumableArray(_this6.state.inventories.selectedRows));
	
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	          selectedRows.push(r.row);
	        });
	        var inventories = _extends({}, _this6.state.inventories, {
	          rows: newRows,
	          selectedRows: selectedRows
	        });
	        _this6.setState({ inventories: inventories });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = [].concat(_toConsumableArray(_this6.state.inventories.rows));
	        var selectedRows = [].concat(_toConsumableArray(_this6.state.inventories.selectedRows));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	          selectedRows = _lodash2.default.filter(selectedRows, function (row) {
	            return r.row.PurchaseOrderLine_id !== row.PurchaseOrderLine_id;
	          });
	          // const rowIndex = selectedRows.indexOf(r.row);
	          // selectedRows.splice(rowIndex, 1);
	        });
	        var inventories = _extends({}, _this6.state.inventories, { rows: newRows, selectedRows: selectedRows });
	        _this6.setState({ inventories: inventories });
	      };
	
	      // Custom Formatter component
	
	      var NameFormatter = _react2.default.createClass({
	        displayName: 'NameFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            null,
	            this.props.value.Name
	          );
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var IsVariableFormatter = _react2.default.createClass({
	        displayName: 'IsVariableFormatter',
	        render: function render() {
	          var _props = this.props,
	              dependentValues = _props.dependentValues,
	              value = _props.value;
	
	          var quantity = void 0;
	          if (dependentValues.ReceivedQuantity) {
	            quantity = dependentValues.ReceivedQuantity + '/' + value;
	          } else {
	            quantity = '0/' + value;
	          }
	          var type = '';
	          if (dependentValues.Product_id.ProductType === 'Non-Fixed') {
	            type = _react2.default.createElement(
	              'label',
	              { className: 'label label-success' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'non_fixed' })
	            );
	          } else if (dependentValues.Product_id.ProductType === 'Per-Pound') {
	            type = _react2.default.createElement(
	              'label',
	              { className: 'label label-primary' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'per_pound' })
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            quantity,
	            ' ',
	            type
	          );
	        }
	      });
	
	      var EditableFormatter = _react2.default.createClass({
	        displayName: 'EditableFormatter',
	        render: function render() {
	          return _react2.default.createElement(
	            'div',
	            { id: 'editable-formatter' },
	            this.props.value
	          );
	        }
	      });
	      // Column difinition
	
	      var columns = [].concat(_toConsumableArray(!isLO ? [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 65,
	        filterable: true
	      }] : []), [{
	        key: 'ProductName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: isLO ? 160 : 80,
	        filterable: true
	      }, {
	        key: 'ProductDescription',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      },
	      // {
	      //     key: 'FOBUnitPrice',
	      //     name: <Translate value="unit_dollarsign" />,
	      //     resizable: true,
	      //     sortable: true,
	      //     width: 60,
	      //     filterable: true
	      // },
	      {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: _root_url.isJML ? "box" : "qty" }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'RcvQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: _root_url.isJML ? "rcv_box" : "rcv_qty" }),
	        resizable: true,
	        editable: true,
	        sortable: true,
	        width: 60,
	        filterable: true,
	        formatter: EditableFormatter
	      }, {
	        key: 'RcvTotalWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_total_wt' }),
	        resizable: true,
	        editable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      },
	      // {
	      //     key: 'RcvUnitPrice',
	      //     name: <Translate value="receive_unit_dollarsign" />,
	      //     resizable: true,
	      //     editable: true,
	      //     sortable: true,
	      //     width: 80,
	      //     filterable: true
	      // },
	      // {
	      //     key: 'RcvTotalPrice',
	      //     name: <Translate value="receive_total_dollarsign" />,
	      //     resizable: true,
	      //     sortable: true,
	      //     width: 80,
	      //     filterable: true
	      // },
	      // {
	      //     key: 'RtnQuantity',
	      //     name: <Translate value="return_qty" />,
	      //     resizable: true,
	      //     editable: true,
	      //     sortable: true,
	      //     width: 80,
	      //     filterable: true
	      // },
	      // {
	      //     key: 'InStock',
	      //     name: <Translate value="instock" />,
	      //     resizable: true,
	      //     sortable: true,
	      //     width: 80,
	      //     filterable: true
	      // },
	      {
	        key: 'Remark',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'remark' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      },
	      // {
	      //     key: 'StorageRate',
	      //     name: <Translate value="storage_rate" />,
	      //     resizable: true,
	      //     editable: true,
	      //     sortable: true,
	      //     width: 100,
	      //     filterable: true
	      // },
	      {
	        key: 'Pallet',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: isTN ? 'num_pallets' : 'pallet' }),
	        resizable: true,
	        editable: true,
	        sortable: true,
	        width: 60,
	        filterable: true
	      }], _toConsumableArray(isLO ? [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 65,
	        filterable: true
	      }] : []));
	
	      if (isUSPride || isATL || isRS) {
	        var index1 = _lodash2.default.findIndex(columns, { key: "RcvTotalWeight" });
	        columns.splice(index1, 1);
	      }
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '100%' }, id: 'ReceiveForm-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'ProductNum',
	              rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: this.moveTo }),
	              enableCellSelect: true,
	              onGridSort: handleGridSort,
	              columns: columns,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              rowHeight: 25,
	              headerRowHeight: 45,
	              minHeight: this.state.tableHeight,
	              onRowUpdated: handleRowUpdated,
	              enableRowSelect: 'multi',
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              }
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderReceivingTable',
	    value: function renderReceivingTable() {
	      var _this7 = this;
	
	      if (this.props.inventoriesIsLoading && !this.props.vendorError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.inventoriesError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          this.props.inventoriesError
	        )
	      );
	
	      var productNameHash = {};
	      var productNumHash = {};
	
	      // Parameters of the react-data-grid
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this7.state.receivedInventories);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return Object.assign({}, rows[rowIdx]);
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var receivedInventories = _extends({}, _this7.state.receivedInventories, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this7.setState({ receivedInventories: receivedInventories });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this7.state.receivedInventories.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var receivedInventories = _extends({}, _this7.state.receivedInventories, { filters: newFilters });
	        _this7.setState({ receivedInventories: receivedInventories });
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        // merge updated row with current row and rerender by setting state
	        var receivedInventories = _this7.state.receivedInventories;
	
	        var rows = receivedInventories.rows.slice(0);
	        if (e.updated.RcvQuantity != null) {
	          if (rows[e.rowIdx].Product_id.ProductType === 'Non-Fixed' || rows[e.rowIdx].Product_id.ProductType === 'Per-Pound') {
	            Object.assign(rows[e.rowIdx], e.updated);
	            _this7.setState({ totalLoaded: rows[e.rowIdx].RcvQuantity, rowChosen: e.rowIdx, tableChosen: 'receivedInventories' });
	            // if (!isEcity) {
	            _this7.openSetWeight();
	            // }
	          } else {
	            Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvQuantity) || 0) * (parseFloat(rows[e.rowIdx].RcvUnitPrice) || 0), 2).toFixed(2) });
	            Object.assign(rows[e.rowIdx], e.updated);
	          }
	        } else if (e.updated.RcvUnitPrice != null) {
	          if (rows[e.rowIdx].Product_id.ProductType == 'Non-Fixed' || rows[e.rowIdx].Product_id.ProductType === 'Per-Pound') {
	            Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvUnitPrice) || 0) * (parseFloat(rows[e.rowIdx].RcvTotalWeight) || 0), 2).toFixed(2) });
	          } else {
	            Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvUnitPrice) || 0) * (parseFloat(rows[e.rowIdx].RcvQuantity) || 0), 2).toFixed(2) });
	          }
	          Object.assign(rows[e.rowIdx], e.updated);
	        }
	
	        // if(e.cellKey == 'RcvQuantity') {
	        //   Object.assign(rows[e.rowIdx], e.updated);
	        //   // totalLoaded: null,
	        //   // rowChosen: null,
	        // }
	        else if (e.updated.RcvTotalWeight != null) {
	            if (rows[e.rowIdx].Product_id.ProductType === 'Non-Fixed' || rows[e.rowIdx].Product_id.ProductType === 'Per-Pound') {
	              Object.assign(rows[e.rowIdx], { RcvTotalPrice: +roundTo((parseFloat(e.updated.RcvTotalWeight) || 0) * (parseFloat(rows[e.rowIdx].RcvUnitPrice) || 0), 2).toFixed(2) });
	              Object.assign(rows[e.rowIdx], e.updated);
	            }
	          } else {
	            Object.assign(rows[e.rowIdx], e.updated);
	          }
	        var totalPrice = 0;
	        rows.map(function (r) {
	          totalPrice += parseFloat(Math.round((parseFloat(r.RcvTotalPrice) || 0) * 100) / 100);
	        });
	        // totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	        totalPrice = +parseFloat(totalPrice).toFixed(2);
	        var newInventories = _extends({}, receivedInventories, { rows: rows });
	        _this7.setState({
	          receivedInventories: newInventories,
	          totalPrice: totalPrice
	        });
	      };
	
	      // Handle the row select function
	
	      var onRowSelect = function onRowSelect(rows) {
	        var receivedInventories = _extends({}, _this7.state.receivedInventories, { selectedRows: rows });
	        _this7.setState({ receivedInventories: receivedInventories });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var selectedRows = [].concat(_toConsumableArray(_this7.state.receivedInventories.selectedRows));
	
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	          selectedRows.push(r.row);
	        });
	        var receivedInventories = _extends({}, _this7.state.receivedInventories, {
	          rows: newRows,
	          selectedRows: selectedRows
	        });
	        _this7.setState({ receivedInventories: receivedInventories });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = [].concat(_toConsumableArray(_this7.state.receivedInventories.rows));
	        var selectedRows = [].concat(_toConsumableArray(_this7.state.receivedInventories.selectedRows));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	          selectedRows = _lodash2.default.filter(selectedRows, function (row) {
	            return r.row.PurchaseOrderLine_id !== row.PurchaseOrderLine_id;
	          });
	          /* code below removes incorrect row */
	          // const rowIndex = selectedRows.indexOf(r.row);
	          // selectedRows.splice(rowIndex, 1);
	        });
	        var receivedInventories = _extends({}, _this7.state.receivedInventories, { rows: newRows, selectedRows: selectedRows });
	        _this7.setState({ receivedInventories: receivedInventories });
	      };
	
	      // Custom Formatter component
	
	      var NameFormatter = _react2.default.createClass({
	        displayName: 'NameFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            null,
	            this.props.value.Name
	          );
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var IsVariableFormatter = _react2.default.createClass({
	        displayName: 'IsVariableFormatter',
	        render: function render() {
	          var _props2 = this.props,
	              dependentValues = _props2.dependentValues,
	              value = _props2.value;
	
	          var quantity = void 0;
	          if (dependentValues.ReceivedQuantity) {
	            quantity = dependentValues.ReceivedQuantity + '/' + value;
	          } else {
	            quantity = '0/' + value;
	          }
	          var type = '';
	          if (dependentValues.Product_id.ProductType === 'Non-Fixed') {
	            type = _react2.default.createElement(
	              'label',
	              { className: 'label label-success' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'non_fixed' })
	            );
	          } else if (dependentValues.Product_id.ProductType === 'Per-Pound') {
	            type = _react2.default.createElement(
	              'label',
	              { className: 'label label-primary' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'per_pound' })
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            quantity,
	            ' ',
	            type
	          );
	        }
	      });
	
	      var IsPalletFormatter = _react2.default.createClass({
	        displayName: 'IsPalletFormatter',
	        render: function render() {
	          var _props3 = this.props,
	              dependentValues = _props3.dependentValues,
	              value = _props3.value;
	
	          var CalcoDispatchCase = dependentValues.Product_id.CalcoDispatchCase;
	          var RcvQuantity = dependentValues.RcvQuantity;
	
	          var palletQty = void 0;
	          if (CalcoDispatchCase > 0 && RcvQuantity > 0) {
	            palletQty = Math.ceil(RcvQuantity / CalcoDispatchCase);
	          } else {
	            palletQty = '';
	          }
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            palletQty
	          );
	        }
	      });
	
	      //B:{dependentValues.Product_id.CalcoDispatchCase}
	
	      var RcvTotalWeightFormatter = _react2.default.createClass({
	        displayName: 'RcvTotalWeightFormatter',
	        render: function render() {
	          var _props4 = this.props,
	              dependentValues = _props4.dependentValues,
	              value = _props4.value;
	
	          if (dependentValues.Product_id && dependentValues.Product_id.ProductType !== 'Per-Pound') {
	            return _react2.default.createElement(
	              'span',
	              null,
	              value
	            );
	          }
	          var totalNetWeight = (parseInt(dependentValues.RcvQuantity, 10) || 0) * dependentValues.Product_id.NetWeight;
	          return _react2.default.createElement(
	            'span',
	            null,
	            totalNetWeight
	          );
	        }
	      });
	
	      // Column difinition
	
	      var columns = [].concat(_toConsumableArray(!isLO ? [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 65,
	        filterable: true
	      }] : []), [{
	        key: 'ProductName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: isLO ? 160 : 80,
	        filterable: true
	      }, {
	        key: 'ProductDescription',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      },
	      // {
	      //     key: 'FOBUnitPrice',
	      //     name: <Translate value="unit_dollarsign" />,
	      //     resizable: true,
	      //     sortable: true,
	      //     width: 60,
	      //     filterable: true
	      // },
	      {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: _root_url.isJML ? "box" : "qty" }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'RcvQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: _root_url.isJML ? "rcv_box" : "rcv_qty" }),
	        resizable: true,
	        editable: true,
	        sortable: true,
	        width: 60,
	        filterable: true
	      }, {
	        key: 'location',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' }),
	        resizable: true,
	        // editable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        },
	        formatter: function formatter(props, index) {
	          var dependentValues = props.dependentValues;
	
	          return _react2.default.createElement(
	            'div',
	            { style: { width: '100%', height: '20px' }, onDoubleClick: function onDoubleClick(e) {
	                e.preventDefault();
	                _this7.setState({
	                  editingLine: dependentValues
	                });
	                _this7.setLocationSelectModalVisibility(true);
	              } },
	            dependentValues.location
	          );
	        }
	      }, {
	        key: 'palletQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true,
	        formatter: IsPalletFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }], _toConsumableArray(isTN ? [{
	        key: 'pallet_barcode',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_barcode' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 150
	      }, {
	        key: 'box_qty',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ctn_plt' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }] : [{
	        key: 'RcvTotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_total_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'expire_datetime',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'expire_datetime' }),
	        resizable: true,
	        editable: true,
	        sortable: true,
	        width: 150,
	        filterable: true
	      }]), [{
	        key: 'RcvTotalWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_total_wt' }),
	        resizable: true,
	        editable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      },
	      // {
	      //     key: 'RcvUnitPrice',
	      //     name: <Translate value="receive_unit_dollarsign" />,
	      //     resizable: true,
	      //     editable: true,
	      //     sortable: true,
	      //     width: 80,
	      //     filterable: true
	      // },
	      // {
	      //     key: 'RtnQuantity',
	      //     name: <Translate value="return_qty" />,
	      //     resizable: true,
	      //     editable: true,
	      //     sortable: true,
	      //     width: 80,
	      //     filterable: true
	      // },
	      // {
	      //     key: 'InStock',
	      //     name: <Translate value="instock" />,
	      //     resizable: true,
	      //     sortable: true,
	      //     width: 80,
	      //     filterable: true
	      // },
	      {
	        key: 'Remark',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'remark' }),
	        resizable: true,
	        sortable: true,
	        editable: true,
	        width: 80,
	        filterable: true
	      }], _toConsumableArray(isLO ? [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 65,
	        filterable: true
	      }] : []));
	
	      if (isUSPride || isATL || isRS) {
	        var index1 = _lodash2.default.findIndex(columns, { key: "RcvTotalWeight" });
	        var temp1 = {
	          key: "unit_price",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_cost' }),
	          resizable: true,
	          width: 70,
	          sortable: true
	        };
	        columns.splice(index1, 1, temp1);
	
	        var index2 = _lodash2.default.findIndex(columns, { key: "expire_datetime" });
	        var temp2 = {
	          key: "PackageSize_1",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'volume_cft' }),
	          resizable: true,
	          width: 80,
	          sortable: true
	        };
	        columns.splice(index2, 1, temp2);
	      }
	
	      if (isUSPride) {
	        var locationIndex = _lodash2.default.findIndex(columns, { key: "location" });
	        var pcsbox = {
	          key: 'purchase_convert_unit',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pcs_box' }),
	          resizable: true,
	          width: 70,
	          sortable: true
	        };
	        var totalPcs = {
	          key: 'pcs_quantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_pcs' }),
	          resizable: true,
	          width: 70,
	          sortable: true
	        };
	        columns.splice(locationIndex, 0, pcsbox, totalPcs);
	      }
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '100%' }, id: 'ReceiveForm-dataGrid2' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'ProductNum',
	              enableCellSelect: true,
	              onGridSort: handleGridSort,
	              columns: columns,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              rowHeight: 25,
	              headerRowHeight: 45,
	              minHeight: this.state.tableHeight,
	              onRowUpdated: handleRowUpdated,
	              enableRowSelect: 'single',
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              }
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit() {
	      var formProps = {
	        InvoiceNum: this.props.InvoiceNum,
	        PackingNum: this.props.PackingNum,
	        PostingDate: this.props.PostingDate,
	        InvoiceDate: this.props.InvoiceDate,
	        container_num: this.props.container_num
	      };
	      // var receiveLines = this.state.receivedInventories.rows;
	      // var partialReceived = false;
	      // receiveLines.map(receiveLine => {
	      //   if(receiveLine.RcvQuantity < receiveLine.Quantity) {
	      //     partialReceived = true;
	      //   }
	      // })
	      // if(partialReceived){
	      //   this.setState({ case: 'completeSheet', caseAction: this.createReceive, formProps: formProps, confirmOpen: true })
	      //   // var r1 = confirm('sheet is not fully received!');
	      //   // if(r1 == false){
	      //   //   return;
	      //   // }
	      // }
	      // else {
	      this.createReceive(formProps, false);
	      // }
	    }
	  }, {
	    key: 'createReceive',
	    value: function createReceive(formProps, completeReceive) {
	      this.setState({ dirty: false });
	      var _props5 = this.props,
	          currentReceive = _props5.currentReceive,
	          currentReceiveDetail = _props5.currentReceiveDetail;
	      var selectedProduct = this.state.selectedProduct;
	
	      var rows = [].concat(_toConsumableArray(this.state.receivedInventories.rows));
	      var Warehouse_Receive_Line = void 0;
	
	      // filter out already received product with RcvQuantity and RcvTotalWeight = 0 unless new product added
	      // if (selectedProduct.newProductAdded ) {
	      //   Warehouse_Receive_Line = [...this.state.receivedInventories.rows];
	      // } else {
	      Warehouse_Receive_Line = rows.filter(function (row) {
	        return !(row.ReceivedQuantity > 0 && row.RcvQuantity == 0 && // Field may be string type
	        row.RcvTotalWeight == 0);
	      } // Field may be string type
	      );
	      // }
	      var validateRcvQuantity = Warehouse_Receive_Line.every(function (line) {
	        return line.RcvQuantity > 0;
	      });
	
	      var validateRcvTotalWeight = Warehouse_Receive_Line.every(function (line) {
	        return line.Product_id.ProductType !== 'Non-Fixed' && line.Product_id.ProductType !== 'Per-Pound' || line.RcvTotalWeight > 0;
	      });
	
	      var validExpireDateTime = Warehouse_Receive_Line.every(function (line) {
	        return moment(line.expire_datetime).isValid() || line.expire_datetime === "" || line.expire_datetime === null;
	      });
	
	      if (validateRcvQuantity && validateRcvTotalWeight && validExpireDateTime) {
	        this.debouncedCreateReceive(this.props.PostingDate, this.props.InvoiceDate, this.props.HandlingCost, this.props.MiscCost, this.props.ShippingCost, this.props.priceAdjustment, this.props.ShareCost, currentReceive.PONum, this.props.note, this.props.Warehouse && this.props.Warehouse.value || currentReceive.Warehouse_id || currentReceiveDetail.Deliver_Warehouse_id_id, this.props.currentReceiveDetail.VendorNum, this.props.currentReceiveDetail.Vendor_id, this.props.ReceivingPrice, parseFloat(this.props.InvoiceFinalPrice), Warehouse_Receive_Line, formProps, completeReceive);
	      } else if (!validateRcvQuantity) {
	        alert('Receive Quantity Should Be Larger Than Zero!');
	      } else if (!validateRcvTotalWeight) {
	        alert('For Non-Fixed Product, Receive Total Weight Should Be Larger Than Zero!');
	      } else if (!validExpireDateTime) {
	        alert('Please Enter a Valid Date! (MM-DD-YYYY)');
	      }
	    }
	  }, {
	    key: 'renderPOInformation',
	    value: function renderPOInformation() {
	      var currentReceiveDetail = this.props.currentReceiveDetail;
	
	      var defaultWarehouseID = { value: currentReceiveDetail && currentReceiveDetail.Deliver_Warehouse_id_id };
	      var Total = 0,
	          Final = 0,
	          HandlingCost = null,
	          MiscCost = null,
	          ShippingCost = null,
	          priceAdjustment = null,
	          ShareCost = false,
	          RCVTotal = 0,
	          RCVFinal = 0,
	          TaxableItems = 0,
	          InvoiceFinalPrice = 0,
	          TotalCRV = 0,
	          TaxRate = 0;
	      Total = currentReceiveDetail && currentReceiveDetail.TotalPrice;
	      Final = currentReceiveDetail && currentReceiveDetail.FinalPrice;
	      HandlingCost = this.state.HandlingCost || this.state.HandlingCost == 0 ? this.state.HandlingCost : currentReceiveDetail && currentReceiveDetail.HandlingCost;
	      MiscCost = this.state.MiscCost || this.state.MiscCost == 0 ? this.state.MiscCost : currentReceiveDetail && currentReceiveDetail.MiscCost;
	      ShippingCost = this.state.ShippingCost || this.state.ShippingCost == 0 ? this.state.ShippingCost : currentReceiveDetail && currentReceiveDetail.ShippingCost;
	      priceAdjustment = this.state.priceAdjustment || this.state.priceAdjustment === 0 ? this.state.priceAdjustment : currentReceiveDetail && currentReceiveDetail.PriceAdjustment;
	      ShareCost = this.state.ShareCost ? true : false;
	      InvoiceFinalPrice = this.state.InvoiceFinalPrice || this.state.InvoiceFinalPrice == 0 ? this.state.InvoiceFinalPrice : currentReceiveDetail && currentReceiveDetail.InvoiceFinalPrice;
	      TaxRate = this.state.TaxRate || this.state.TaxRate == 0 ? this.state.TaxRate : currentReceiveDetail && currentReceiveDetail.TaxRate;
	      TotalCRV = this.state.TotalCRV || this.state.TotalCRV == 0 ? this.state.TotalCRV : 0;
	
	      var details = this.state.receivedInventories.rows.length ? this.state.receivedInventories.rows : [];
	      for (var i = 0; i < details.length; i++) {
	        var RcvQuantity = details[i].RcvQuantity;
	        var FOBUnitPrice = details[i].FOBUnitPrice;
	        if (details[i].Product_id.ProductType === 'Fixed' || details[i].Product_id.ProductType === 'Non-Product') {
	          if (isHMM && details[i].package_size.split('SFT').length > 1) {
	            RCVTotal += roundTo(RcvQuantity * FOBUnitPrice * Number(details[i].package_size.split('SFT')[0]), 2);
	            if (details[i].Product_id.IsTaxable) {
	              TaxableItems += roundTo(RcvQuantity * FOBUnitPrice * Number(details[i].package_size.split('SFT')[0]), 2);
	            }
	            RCVFinal += roundTo(RcvQuantity * FOBUnitPrice * Number(details[i].package_size.split('SFT')[0]), 2);
	          } else {
	            RCVTotal += roundTo(RcvQuantity * FOBUnitPrice, 2);
	            if (details[i].Product_id.IsTaxable) {
	              TaxableItems += roundTo(RcvQuantity * FOBUnitPrice, 2);
	            }
	            RCVFinal += roundTo(RcvQuantity * FOBUnitPrice, 2);
	          }
	        } else {
	          var RcvTotalWeight = details[i].RcvTotalWeight;
	          RCVTotal += roundTo(FOBUnitPrice * RcvTotalWeight, 2);
	          if (details[i].Product_id.IsTaxable) {
	            TaxableItems += roundTo(FOBUnitPrice * RcvTotalWeight, 2);
	          }
	          RCVFinal += roundTo(FOBUnitPrice * RcvTotalWeight, 2);
	        }
	        TotalCRV += roundTo(details[i].Product_id.CRV * RcvQuantity, 2);
	      }
	      TaxableItems = roundTo(TaxableItems * (TaxRate / 100), 2);
	      RCVFinal += roundTo(parseFloat(ShippingCost), 2) + roundTo(parseFloat(HandlingCost), 2) + roundTo(parseFloat(priceAdjustment), 2) + roundTo(parseFloat(MiscCost), 2) + TotalCRV + TaxableItems;
	      if (RCVFinal) {
	        RCVTotal = +roundTo(RCVTotal, 2).toFixed(2);
	        RCVFinal = +roundTo(RCVFinal, 2).toFixed(2);
	      } else {
	        RCVTotal = currentReceiveDetail && currentReceiveDetail.TotalPrice;
	        RCVFinal = currentReceiveDetail && currentReceiveDetail.FinalPrice;
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Panel,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            { className: 'receive-form-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'details' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 12 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receipt_no' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-5 marginTopStyle po-information' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_inv' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 7 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'InvoiceNum', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-5 marginTopStyle po-information' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'packing_num' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 7 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'PackingNum', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-5 marginTopStyle po-information' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 7 },
	              _react2.default.createElement(_warehouseDropdown2.default, { defaultValue: defaultWarehouseID })
	            )
	          ),
	          isTN && _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-5 marginTopStyle po-information' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_no' }),
	              '.'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 7, style: { marginTop: '5px' } },
	              this.props.container_num
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            { className: 'receive-form-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_id' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              this.state.vendorNum
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              this.state.vendorName
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              this.state.vendorDescription
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            { className: 'receive-form-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dates' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_date' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              this.state.orderDate ? (0, _cleanDates.convertLocalDate)(this.state.orderDate, 'MM-DD-YY') : null
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'eta_date' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              this.state.ETADate ? (0, _cleanDates.convertLocalDate)(this.state.ETADate, 'MM-DD-YY') : null
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_date' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { component: _datePicker.DatePicker, name: 'PostingDate' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_inv_date' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { component: _datePicker.DatePicker, name: 'InvoiceDate' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            { className: 'receive-form-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_info' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              this.state.PONum
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchaser' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              this.state.purchaser
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_total' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              '$' + (0, _numberWithCommas.numberWithCommas)(Total)
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_final' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              '$' + (0, _numberWithCommas.numberWithCommas)(Final)
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-6 marginTopStyle' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'Note', component: _inputField.InputField, maxLength: 150, style: { minWidth: '205px', maxWidth: '205px' } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            { className: 'receive-form-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price_details' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_total' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'ReceiveTotal', component: _inputField.DisabledInputField, placeholder: (0, _numberWithCommas.numberWithCommas)(RCVTotal) })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_final' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'ReceiveFinal', component: _inputField.DisabledInputField, placeholder: (0, _numberWithCommas.numberWithCommas)(RCVFinal) })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'crv' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'TotalCRV', component: _inputField.DisabledInputField, placeholder: (0, _numberWithCommas.numberWithCommas)(TotalCRV) })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'TaxRate', component: _inputField.InputField })
	            )
	          ),
	          isOCM && _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'share_cost' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'ShareCost', component: Checkbox })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement('label', { className: 'receive-form-label' }),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'ShippingCost', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: isHMM || isUSPride || isATL || isRS ? 'tax_amount' : 'handling' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  isHMM ? '%' : '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'HandlingCost', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: isHMM || isUSPride || isATL || isRS ? 'over_head' : 'misc' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  isHMM ? '%' : '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'MiscCost', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'adjustments' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'PriceAdjustment', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_final' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'InvoiceFinalPrice', component: _inputField.InputField })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      var _this8 = this;
	
	      // var receiveLines = this.state.receivedInventories.rows;
	      // var partialReceived = false;
	      // receiveLines.map(receiveLine => {
	      //   if(receiveLine.RcvQuantity < receiveLine.Quantity) {
	      //     partialReceived = true;
	      //   }
	      // })
	      // if(partialReceived){
	      this.setState({ case: 'completeSheet', caseAction: function caseAction() {
	          _this8.completePurchaseOrder();_this8.closeConfirm();
	        }, confirmOpen: true });
	      // }
	      // else {
	      //   this.completePurchaseOrder();
	      // }
	      // var r = confirm(<Translate value="sheet_not_completed_warning" />);
	      // if(r == true)
	      //   this.props.completePurchaseOrder(this.props.currentReceive.PONum);  //provide po number here
	    }
	  }, {
	    key: 'completePurchaseOrder',
	    value: function completePurchaseOrder() {
	      this.setState({ dirty: false });
	      var formProps = {
	        InvoiceNum: this.props.InvoiceNum,
	        PackingNum: this.props.PackingNum,
	        PostingDate: this.props.PostingDate,
	        InvoiceDate: this.props.InvoiceDate,
	        container_num: this.props.container_num
	      };
	      // const { currentReceive } = this.props;
	      // const rows = [...this.state.receivedInventories.rows];
	      // const Warehouse_Receive_Line = rows.filter(
	      //   row => !((row.ReceivedQuantity > 0) &&
	      //           (row.RcvQuantity == 0) && // Field may be string type
	      //           (row.RcvTotalWeight == 0)) // Field may be string type
	      // );
	
	      // const completeReceive = true;
	      this.createReceive(formProps, true);
	
	      // this.props.createReceive(
	      //     this.props.HandlingCost,
	      //     this.props.MiscCost,
	      //     this.props.ShippingCost,
	      //     currentReceive.PONum,
	      //     this.props.note,
	      //     currentReceive.Warehouse_id,
	      //     this.props.currentReceiveDetail.VendorNum,
	      //     this.props.currentReceiveDetail.Vendor_id,
	      //     this.props.ReceivingPrice,
	      //     parseFloat(this.props.InvoiceFinalPrice),
	      //     Warehouse_Receive_Line,
	      //     formProps,
	      //     completeReceive
	      //   )
	    }
	  }, {
	    key: 'setRows',
	    value: function setRows(rowChosen, tableChosen, weights) {
	      var rows = [].concat(_toConsumableArray(this.state[tableChosen].rows));
	      rows[rowChosen].subWeights = weights;
	      var prevTotalPrice = parseFloat(rows[rowChosen].RcvTotalPrice) || 0;
	      var sumWeights = 0;
	      weights.map(function (w) {
	        sumWeights += parseFloat(w.Weight);
	      });
	      rows[rowChosen].RcvTotalWeight = parseFloat(sumWeights).toFixed(2);
	      rows[rowChosen].RcvTotalPrice = parseFloat(sumWeights * (parseFloat(rows[rowChosen].RcvUnitPrice) || 0)).toFixed(2);
	      var totalPrice = (parseFloat(this.state.totalPrice) || 0) + (parseFloat(rows[rowChosen].RcvTotalPrice) || 0) - prevTotalPrice;
	      totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	      if (tableChosen == 'inventories') {
	        var inventories = _extends({}, this.state.inventories, { rows: rows });
	        this.setState({ inventories: inventories, totalPrice: totalPrice });
	        this.moveTo(rows[rowChosen]);
	      } else {
	        var receivedInventories = _extends({}, this.state.receivedInventories, { rows: rows });
	        this.setState({ receivedInventories: receivedInventories, totalPrice: totalPrice });
	      }
	    }
	  }, {
	    key: 'moveOff',
	    value: function moveOff(row) {
	      var inventories = _extends({}, this.state.inventories);
	      inventories.rows.push(row);
	      var receivedInventories = _extends({}, this.state.receivedInventories);
	      var index = _lodash2.default.findIndex(receivedInventories.rows, { ProductNum: row.ProductNum });
	      if (index > -1) {
	        receivedInventories.rows.splice(index, 1);
	      }
	      this.setState({ receivedInventories: receivedInventories, inventories: inventories });
	    }
	  }, {
	    key: 'moveTo',
	    value: function moveTo(row) {
	      var receivedInventoriesRows = [].concat(_toConsumableArray(this.state.receivedInventories.rows));
	      var inventoriesRows = [].concat(_toConsumableArray(this.state.inventories.rows));
	
	      receivedInventoriesRows.push(row);
	      var index = _lodash2.default.findIndex(inventoriesRows, { ProductNum: row.ProductNum });
	      if (index > -1) {
	        inventoriesRows.splice(index, 1);
	      }
	
	      var receivedInventories = _extends({}, this.state.receivedInventories, { rows: receivedInventoriesRows.sort(sortByLineID) });
	      var inventories = _extends({}, this.state.inventories, { rows: inventoriesRows });
	      this.setState({ inventories: inventories, receivedInventories: receivedInventories });
	    }
	  }, {
	    key: 'header',
	    value: function header() {
	      return _react2.default.createElement(
	        'h2',
	        { className: 'mt0' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receiving_information' })
	      );
	    }
	  }, {
	    key: 'renderIFrame',
	    value: function renderIFrame() {
	      if (this.props.warehouseReceivePdf) {
	        var file = window.URL.createObjectURL(this.props.warehouseReceivePdf);
	        return _react2.default.createElement('iframe', { style: { display: 'none' }, onLoad: this.IFrameIsLoaded, id: 'Pdf', name: 'Pdf', src: file });
	      }
	    }
	  }, {
	    key: 'renderPrint',
	    value: function renderPrint() {
	      var _this9 = this;
	
	      var createdReceive = this.props.createdReceive;
	
	      var url = '';
	      if (createdReceive && createdReceive.WarehouseReceiveNum) {
	        url = _root_url.ROOT_URL + 'v1/warehouse/receive/print/' + createdReceive.WarehouseReceiveNum + '?Bearer=' + localStorage.getItem('token');
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          onClick: function onClick() {
	            _this9.props.printWarehouseReceive(createdReceive.WarehouseReceiveNum);
	          },
	          disabled: url === '' || !(0, _permissions2.default)('print_receive')
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this10 = this;
	
	      var _state = this.state,
	          inventories = _state.inventories,
	          receivedInventories = _state.receivedInventories;
	      var _props6 = this.props,
	          handleSubmit = _props6.handleSubmit,
	          isCreating = _props6.isCreating,
	          created = _props6.created,
	          receiveLoading = _props6.receiveLoading;
	
	
	      var createDialogStyle = {
	        width: '500px',
	        height: '550px',
	        marginLeft: '-15%'
	      };
	
	      var totalUnit = 0;
	      var totalUnitReceived = 0;
	      var totalNetWeight = 0;
	      var inventoriesRows = inventories.rows || [];
	      var confirmSaveTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm_save' });
	      var confirmActionTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm_action' });
	      var receivedInventoriesRows = receivedInventories.rows || [];
	      inventoriesRows.map(function (r) {
	        totalUnit += parseFloat(r.Quantity) || 0;
	      });
	      receivedInventoriesRows.map(function (r) {
	        totalUnitReceived += parseFloat(r.RcvQuantity) || 0;
	        totalNetWeight += parseFloat(r.RcvTotalWeight) || 0;
	      });
	
	      totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
	
	      // let subWeights = [];
	      // if(this.state.rowChosen && this.state.inventories.rows[this.state.rowChosen])
	      //   subWeights = [...this.state.inventories.rows[this.state.rowChosen].subWeights];
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'form',
	          { method: 'get', action: '#' },
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_receiving' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'success', disabled: created || !(0, _permissions2.default)('add_receive'), onClick: this.showSaveConfirm },
	              _react2.default.createElement('em', { className: 'fa fa-save' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'primary', disabled: created || !(0, _permissions2.default)('add_receive'), onClick: function onClick() {
	                  return _this10.complete();
	                } },
	              ' ',
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'complete_this_sheet' }),
	              '  '
	            ),
	            this.renderPrint(),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { onClick: function onClick() {
	                  _this10.context.router.push('/inventories/receive');
	                }, bsStyle: 'danger' },
	              _react2.default.createElement('em', { className: 'fa fa-close' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { fluid: 'true', id: 'create-inventory-receive' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              this.header(),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                this.props.isCreating || this.props.isEditing && _react2.default.createElement(_spinner2.default, null),
	                this.props.createError && _react2.default.createElement(
	                  'div',
	                  { className: 'alert alert-danger', style: { marginTop: '10px' } },
	                  JSON.stringify(this.props.createError)
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              this.renderPOInformation()
	            ),
	            isMmDavis && _react2.default.createElement(
	              _reactBootstrap.Row,
	              { style: { marginTop: '8px', paddingBottom: '20px' } },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { id: 'autosuggest-div' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { style: { height: '30px' } },
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 12 },
	                      _react2.default.createElement(_TypeRadios2.default, { value: this.state.productSearchType, handleOptionChange: this.handleOptionChange })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 12 },
	                      this.renderAutoSuggest()
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { style: { marginTop: '8px' } },
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 6, className: 'pl0' },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    { className: 'pull-right' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'primary',
	                        onClick: this.manualLoad,
	                        disabled: this.state.inventories.selectedRows.length === 0
	                      },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'load_fixed_manual' }),
	                      '\xA0',
	                      _react2.default.createElement('em', { className: 'fa fa-arrow-right' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'success',
	                        onClick: this.autoLoad
	                      },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'load_fixed_all' }),
	                      '\xA0',
	                      _react2.default.createElement('em', { className: 'fa fa-arrow-right' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(
	                        'h3',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'not_yet_received' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 4 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'marginRightLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_status' })
	                      ),
	                      this.props.currentReceive && this.props.currentReceive.PurchaseStatus
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'marginRightLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_prod' })
	                      ),
	                      this.state.inventories.rows.length
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'marginRightLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_unit' })
	                      ),
	                      totalUnit
	                    )
	                  ),
	                  this.renderTable()
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 6, className: 'pr0' },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    { className: 'pull-right' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'danger',
	                        onClick: this.unload.bind(this, 'selection'),
	                        disabled: this.state.receivedInventories.selectedRows.length === 0
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-times' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unload_selected' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'primary',
	                        onClick: this.unload.bind(this, 'all')
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-times' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reset_all' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(
	                        'h3',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'received' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 3 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'marginRightLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_prod' }),
	                        ' '
	                      ),
	                      this.state.receivedInventories.rows.length
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 3 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'marginRightLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_unit' }),
	                        ' '
	                      ),
	                      totalUnitReceived
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 3 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'marginRightLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_weight' })
	                      ),
	                      totalNetWeight
	                    )
	                  ),
	                  this.renderReceivingTable()
	                )
	              )
	            )
	          )
	        ),
	        this.renderIFrame(),
	        _react2.default.createElement(LocationSelectModal, {
	          setModalVisibility: this.setLocationSelectModalVisibility,
	          isVisible: this.state.isLocationSelectModalVisible,
	          onConfirm: this.handleLocationSelect,
	          editingLine: this.state.editingLine
	        }),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogStyle,
	            isVisible: this.state.confirmOpen,
	            onCloseClicked: this.closeConfirm,
	            title: confirmActionTitle
	          },
	          _react2.default.createElement(_confirmActionModal2.default, {
	            'case': this.state.case,
	            formProps: this.state.formProps,
	            caseAction: this.state.caseAction,
	            closeC: this.closeConfirm
	          })
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogStyle,
	            isVisible: this.state.saveConfirmOpen,
	            onCloseClicked: this.closeSaveConfirm,
	            title: confirmSaveTitle
	          },
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'centerStyle' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'are_you_sure_you_want_to_save_this_receiving' }),
	              '?'
	            )
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'centerStyle' },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                className: 'mr',
	                onClick: function onClick() {
	                  _this10.handleFormSubmit();_this10.closeSaveConfirm();
	                },
	                type: 'button'
	                // disabled={isCreating || created}
	                , disabled: receiveLoading || created
	              },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                onClick: function onClick() {
	                  _this10.closeSaveConfirm();
	                },
	                type: 'button'
	              },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: _extends({}, createDialogStyle, { height: '560px' }),
	            isVisible: this.state.setWeightOpen,
	            onCloseClicked: this.closeSetWeight,
	            title: 'Set Product Weights'
	          },
	          _react2.default.createElement(_setReceiveWeightModal2.default, {
	            closeC: this.closeSetWeight,
	            totalLoaded: this.state.totalLoaded,
	            rowChosen: this.state.rowChosen,
	            tableChosen: this.state.tableChosen,
	            rows: this.state.rowChosen > -1 && this.state[this.state.tableChosen].rows[this.state.rowChosen] && this.state[this.state.tableChosen].rows[this.state.rowChosen].subWeights && [].concat(_toConsumableArray(this.state[this.state.tableChosen].rows[this.state.rowChosen].subWeights)),
	            setRows: this.setRows,
	            state: this.state
	          })
	        )
	      );
	    }
	  }]);
	
	  return ReceiveForm;
	}(_react.Component);
	
	ReceiveForm.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = ReceiveForm;
	exports.default = _default;
	
	
	function roundTo(n, digits) {
	  if (digits === undefined) {
	    digits = 0;
	  }
	
	  var multiplicator = Math.pow(10, digits);
	  n = parseFloat((n * multiplicator).toFixed(11));
	  var test = Math.round(n) / multiplicator;
	  return +test.toFixed(2);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(roundTo, 'roundTo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveForm.jsx');
	
	  __REACT_HOT_LOADER__.register(LocationSelectModal, 'LocationSelectModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isHMM, 'isHMM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isMmDavis, 'isMmDavis', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isTN, 'isTN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isUSPride, 'isUSPride', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isOCM, 'isOCM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isATL, 'isATL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isRS, 'isRS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isLO, 'isLO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveForm.jsx');
	
	  __REACT_HOT_LOADER__.register(renderInputField, 'renderInputField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveForm.jsx');
	
	  __REACT_HOT_LOADER__.register(inputStyle, 'inputStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveForm.jsx');
	
	  __REACT_HOT_LOADER__.register(renderDatePicker, 'renderDatePicker', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveForm.jsx');
	
	  __REACT_HOT_LOADER__.register(Checkbox, 'Checkbox', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveForm.jsx');
	
	  __REACT_HOT_LOADER__.register(sortByLineID, 'sortByLineID', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveForm.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveForm.jsx');
	
	  __REACT_HOT_LOADER__.register(ReceiveForm, 'ReceiveForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveForm.jsx');
	}();

	;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _datePicker = __webpack_require__(27);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _inputField = __webpack_require__(16);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _setReceiveWeightModal = __webpack_require__(174);
	
	var _setReceiveWeightModal2 = _interopRequireDefault(_setReceiveWeightModal);
	
	var _warehouseDropdown = __webpack_require__(163);
	
	var _warehouseDropdown2 = _interopRequireDefault(_warehouseDropdown);
	
	var _setWeightModal = __webpack_require__(74);
	
	var _setWeightModal2 = _interopRequireDefault(_setWeightModal);
	
	var _boldDecimalTextFormatter = __webpack_require__(265);
	
	var _boldDecimalTextFormatter2 = _interopRequireDefault(_boldDecimalTextFormatter);
	
	var _PurchaseOrderAutoSuggest = __webpack_require__(150);
	
	var _PurchaseOrderAutoSuggest2 = _interopRequireDefault(_PurchaseOrderAutoSuggest);
	
	var _cleanDates = __webpack_require__(22);
	
	var _numberWithCommas = __webpack_require__(35);
	
	var _dateFormat = __webpack_require__(39);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isAFGRelated = _root_url.ROOT_URL === "https://afg-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://afgstage-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://mmdavis-scm.truckxi.com/api/";
	var isAFG = _root_url.ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afgstage-scm.truckxi.com/api/';
	var isMMD = _root_url.ROOT_API_URL === 'https://mmdavis-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://mmdavis-scm.truckxi.com/api/';
	var isTN = _root_url.ROOT_API_URL === "https://tn-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://tn-scm.truckxi.com/api/";
	var isUSPride = _root_url.ROOT_API_URL === 'https://uspride-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://uspride-scm.truckxi.com/api/';
	var isATL = _root_url.ROOT_API_URL === 'https://alton-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://alton-scm.truckxi.com/api/';
	var isRS = _root_url.ROOT_API_URL === 'https://redstone-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://redstone-scm.truckxi.com/api/';
	
	var isNumeric = function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	};
	
	var ReceiveHistoryDetail = function (_Component) {
	  _inherits(ReceiveHistoryDetail, _Component);
	
	  function ReceiveHistoryDetail() {
	    _classCallCheck(this, ReceiveHistoryDetail);
	
	    var _this = _possibleConstructorReturn(this, (ReceiveHistoryDetail.__proto__ || Object.getPrototypeOf(ReceiveHistoryDetail)).call(this));
	
	    _this.openConfirm = function () {
	      _this.setState({ confirmOpen: true });
	    };
	
	    _this.closeConfirm = function () {
	      _this.setState({ confirmOpen: false });
	    };
	
	    _this.handleKeyPress = function (value, event) {
	      if (event.charCode === 13) {
	        event.preventDefault();
	        if (value === 'unitPrice' || value === 'itemNotation') {
	          if ((!isNumeric(_this.props.quantityValue) || _this.props.quantityValue < 0) && value !== 'quantity') {
	            return;
	          }
	        }
	        // if (value === 'quantity' && this.state.selectedInventoryRow.InStock == null) {
	        //   return;
	        // }
	        _reactDom2.default.findDOMNode(_this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	      }
	    };
	
	    _this.setWeights = function (currentRow, currentWeights, editedRow) {
	      var index = 0;
	      var Weights = [];
	      var subWeights = [];
	      currentWeights.map(function (row) {
	        Weights.push(+roundTo(parseFloat(row.Weight), 2).toFixed(2));
	        subWeights.push({ Weight: +roundTo(parseFloat(row.Weight), 2).toFixed(2) });
	      });
	      var rows = [].concat(_toConsumableArray(_this.state.rows));
	      rows[currentRow].Weights = Weights;
	      rows[currentRow].subWeights = subWeights;
	      _this.setState({ rows: rows });
	    };
	
	    _this.keepLoaded = function (oldLoaded) {
	      var rows = [].concat(_toConsumableArray(_this.state.rows));
	      rows[_this.state.currentRow].RcvQuantity = oldLoaded;
	      _this.setState({ rows: rows });
	    };
	
	    _this.handleKeyPress = function (value, event) {
	      if (event.charCode == 13) {
	        event.preventDefault();
	        if (value == 'unitPrice' || value == 'notation') {
	          if ((!isNumeric(_this.props.quantityValue) || _this.props.quantityValue < 0) && value !== 'quantity') {
	            return;
	          }
	        }
	        _reactDom2.default.findDOMNode(_this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	      }
	    };
	
	    _this.handleFocusQty = function () {
	      _reactDom2.default.findDOMNode(_this.refs['allProd_Quantity'].getRenderedComponent().myInput.refs.input).focus();
	      _reactDom2.default.findDOMNode(_this.refs['allProd_Quantity'].getRenderedComponent().myInput.refs.input).select();
	    };
	
	    _this.moveToProductsList = function () {
	      console.log("This is trash", _this.state.selectedInventoryRow, _this.state.rows);
	      var remark = _this.props.remark;
	
	      var quantity = parseFloat(_this.props.quantityValue) || 0;
	      var newProduct = {};
	      var rows = _this.state.rows;
	      var selectedInventoryRow = _this.state.selectedInventoryRow;
	      var checkDuplicate = _lodash2.default.findIndex(rows, { 'Product_id': selectedInventoryRow.Product_id });
	      if (checkDuplicate > -1) {
	        alert('Product already exists!');
	        _this.props.setDefaultOfForm('Weight', '', 'receiveHistoryDetail');
	        _this.props.setDefaultOfForm('Quantity', '', 'receiveHistoryDetail');
	        _this.props.setDefaultOfForm('unitPrice', '', 'receiveHistoryDetail');
	        _this.props.setDefaultOfForm('itemNotation', '', 'receiveHistoryDetail');
	        _this.setState({ suggestValue: '' });
	        return;
	      }
	      if (!_this.checkisValid()) {
	        return;
	      }
	      // const index = _.findIndex(simplifiedProducts, { 'Product_id': selectedInventoryRow.Product_id });
	      // if (index > -1) {
	      // INCOMPLETE: change this to refPrice and fix other places where refPrice
	      var refPrice = parseFloat(_this.props.unitPrice) || 0;
	
	      newProduct["Product_id"] = _this.state.selectedInventoryRow.Product_id;
	      newProduct["IsTaxable"] = _this.state.selectedInventoryRow.IsTaxable;
	      newProduct["ProductNum"] = _this.state.selectedInventoryRow.ProductNum;
	      newProduct["ProductGeneralNum"] = _this.state.selectedInventoryRow.ProductNum;
	      newProduct["ProductName"] = _this.state.selectedInventoryRow.Name;
	      newProduct["ProductDescription"] = _this.state.selectedInventoryRow.Description;
	      newProduct["ProductType"] = _this.state.selectedInventoryRow.ProductType;
	      newProduct["FOBUnitPrice"] = refPrice; //products[index].RefPrice;
	      newProduct["CIFUnitPrice"] = refPrice; //products[index].RefPrice;
	      newProduct["RcvUnitPrice"] = refPrice; //products[index].RefPrice;
	      newProduct["ProductUnitOfMeasure"] = _this.state.selectedInventoryRow.PackageSize;
	      newProduct["ProductRefNum"] = _this.state.selectedInventoryRow.RefNum;
	      newProduct["RcvQuantity"] = quantity;
	      newProduct["RcvTotalWeight"] = _this.state.selectedInventoryRow.NetWeight * quantity;
	      newProduct["CRV"] = _this.state.selectedInventoryRow.CRV;
	      newProduct["RtnQuantity"] = 0;
	      newProduct["StorageRate"] = 0;
	      newProduct["UnitPerPallet"] = "";
	      newProduct["Pallet"] = 0;
	      var weightList = [];
	      var subWeightList = [];
	      if (_this.state.selectedInventoryRow.ProductType == "Non-Fixed" || _this.state.selectedInventoryRow.ProductType == "Per-Pound") {
	        for (var i = 0; i < quantity; i++) {
	          weightList.push(_this.state.selectedInventoryRow.NetWeight);
	          subWeightList.push({ Weight: _this.state.selectedInventoryRow.NetWeight });
	        }
	        newProduct["Weights"] = weightList;
	        newProduct["subWeights"] = subWeightList;
	      }
	
	      var weight = parseFloat(_this.state.selectedInventoryRow.NetWeight) || 0;
	      if (_this.state.selectedInventoryRow.ProductType == "Per-Pound") {
	        var _weight = parseFloat(_this.state.selectedInventoryRow.PackageSize) || 1;
	        newProduct["RcvTotalPrice"] = roundTo(quantity * refPrice * _weight, 2);
	      } else if (_this.state.selectedInventoryRow.ProductType == "Non-Fixed") {
	        newProduct["RcvTotalPrice"] = roundTo(quantity * refPrice * weight, 2);
	      } else {
	        newProduct["RcvTotalPrice"] = roundTo(quantity * refPrice, 2);
	      }
	
	      newProduct["Remark"] = remark;
	      var newRows = [].concat(_toConsumableArray(_this.state.rows));
	      newRows.unshift(newProduct);
	      _this.setState({
	        rows: newRows,
	        quantity: 0,
	        productType: null,
	        suggestValue: ''
	      });
	      _this.props.setDefaultOfForm('Weight', '', 'receiveHistoryDetail');
	      _this.props.setDefaultOfForm('Quantity', '', 'receiveHistoryDetail');
	      _this.props.setDefaultOfForm('unitPrice', '', 'receiveHistoryDetail');
	      _this.props.setDefaultOfForm('itemNotation', '', 'receiveHistoryDetail');
	    };
	
	    _this.moveOffFromProductsList = function (WarehouseReceiveLine_id) {
	      var newRows = [].concat(_toConsumableArray(_this.state.rows));
	      newRows = newRows.filter(function (obj) {
	        return obj.WarehouseReceiveLine_id !== WarehouseReceiveLine_id;
	      });
	      _this.setState({ rows: newRows });
	    };
	
	    _this.renderSubtotal = function () {
	      var subtotal = 0;
	      if (_this.state.selectedInventoryRow.ProductType == "Fixed") {
	        if (_this.props.quantityValue) {
	          subtotal = (parseFloat(_this.props.quantityValue) * roundTo(_this.props.unitPrice, 2)).toFixed(2);
	        }
	      } else {
	        if (_this.props.weight) {
	          subtotal = (roundTo(_this.props.unitPrice, 2) * _this.props.weight * parseFloat(_this.props.quantityValue)).toFixed(2);
	        }
	      }
	      if (isNaN(subtotal)) {
	        subtotal = 0;
	      }
	      return _react2.default.createElement(_reduxForm.Field, { name: 'Subtotal', component: _inputField.DisabledInputField, placeholder: subtotal });
	    };
	
	    _this.setAllProductQuantity = function (quantity) {
	      _this.props.setValue('receiveHistoryDetail', 'RcvQuantity', quantity);
	    };
	
	    _this.renderProductSearch = function () {
	      return _react2.default.createElement(
	        _reactBootstrap.Panel,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 6 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'searchType', component: renderTypeRadios }),
	            _this.renderAutoSuggest()
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 6, id: 'product-search-outputs' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 2, className: 'pr0' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: 'Quantity', withRef: true, ref: 'allProd_Quantity', component: _inputField.InputField, onFocus: _this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                  _this.handleKeyPress('unitPrice', event);
	                }, placeholder: 'must be > 0' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 2, className: 'pr0' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              ),
	              _react2.default.createElement(_reduxForm.Field, {
	                name: 'unitPrice',
	                ref: 'unitPrice',
	                withRef: true,
	                component: _inputField.InputField,
	                placeholder: "must be > 0",
	                onKeyPress: function onKeyPress(event) {
	                  if (event.charCode == 13) {
	                    if (!isNumeric(_this.props.quantityValue) || _this.props.quantityValue < 0 || !isNumeric(_this.props.unitPrice) || _this.props.unitPrice < 0) {
	                      return;
	                    }
	                    // this.handleFocusAutoSuggest();
	                    _this.setAllProductQuantity(0);
	                    _this.handleKeyPress('notation', event);
	                  }
	                },
	                onFocus: _this.handleOnFocus
	              })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 2 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, {
	                name: 'Weight',
	                withRef: true,
	                ref: 'weight',
	                component: _inputField.DisabledInputField,
	                onFocus: _this.handleOnFocus,
	                onKeyPress: function onKeyPress(event) {
	                  if (event.charCode == 13) {
	                    _this.handleFocusAutoSuggest();
	                    _this.moveToProductsList();
	                  }
	                }
	              })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 2 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 12 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'subtotal' })
	                  )
	                ),
	                _this.renderSubtotal()
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, {
	                name: 'itemNotation',
	                withRef: true,
	                ref: 'notation',
	                maxLength: 100,
	                component: _inputField.InputField,
	                onFocus: _this.handleOnFocus,
	                onKeyPress: function onKeyPress(event) {
	                  if (event.charCode == 13) {
	                    _this.handleFocusAutoSuggest();
	                    _this.moveToProductsList();
	                  }
	                }
	              })
	            )
	          )
	        )
	      );
	    };
	
	    _this.shouldSaveDisable = function () {
	      var _this$props = _this.props,
	          currentReceiveHistoryDetail = _this$props.currentReceiveHistoryDetail,
	          isEditingReveiveHistory = _this$props.isEditingReveiveHistory,
	          currentReceiveHistory = _this$props.currentReceiveHistory;
	
	      if (!currentReceiveHistoryDetail) {
	        return true;
	      }
	      if (currentReceiveHistory && currentReceiveHistory.ArrivalStatus === 'Received' && (isAFG || isMMD)) {
	        return true;
	      }
	      var PaymentStatus = currentReceiveHistoryDetail.PaymentStatus;
	
	      if (PaymentStatus !== 'Partially Paid' && PaymentStatus !== 'Paid') {
	        return isEditingReveiveHistory;
	      }
	      if (!_this.props.isEditingReveiveHistory) return false;
	      return true;
	    };
	
	    _this.IFrameIsLoaded = function () {
	      if (!_this.state.PdfFrameLoaded) {
	        var pdfFrame = window.frames["Pdf"];
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this.setState({ PdfFrameLoaded: true });
	      }
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton,
	
	      setWeightOpen: false,
	      totalLoaded: null,
	      rowChosen: -1,
	
	      productNum: null,
	      instock: null,
	      purchased: null,
	      sold: null,
	      totalPrice: null,
	
	      rows: [],
	      selectedInventoryRow: {},
	      editedRows: [],
	      selectedRows: [],
	      filters: {},
	      sortColumn: null,
	      sortDirection: null,
	      MiscCost: 0,
	      HandlingCost: 0,
	      ShippingCost: 0,
	      priceAdjustment: 0,
	      InvoiceFinalPrice: 0,
	      currentWeights: null,
	      suggestValue: '',
	      isSaving: false,
	      PdfFrameLoaded: true,
	      TaxRate: 0,
	      TotalCRV: 0,
	      confirmOpen: false,
	      status: ''
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.openSetWeight = _this.openSetWeight.bind(_this);
	    _this.closeSetWeight = _this.closeSetWeight.bind(_this);
	    _this.setRows = _this.setRows.bind(_this);
	    return _this;
	  }
	
	  _createClass(ReceiveHistoryDetail, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var currentReceiveHistory = this.props.currentReceiveHistory;
	
	      window.addEventListener('resize', this.handleResize);
	      if (currentReceiveHistory) {
	        this.setState({
	          status: currentReceiveHistory.ArrivalStatus
	        });
	        this.props.fetchReceiveHistoryDetailRecord(currentReceiveHistory.WarehouseReceive_id, currentReceiveHistory.Warehouse_ReceiveCompleted_id).then(function () {
	          _this2.props.setDefaultSearchType('RefNum', 'receiveHistoryDetail');
	        });
	      } else {
	        this.props.setDefaultSearchType('RefNum', 'receiveHistoryDetail');
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	      // this.props.resetEditReceiveHistory();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (parseFloat(nextProps.MiscCost) !== this.state.MiscCost) this.setState({ MiscCost: parseFloat(nextProps.MiscCost) });
	      if (parseFloat(nextProps.HandlingCost) !== this.state.HandlingCost) this.setState({ HandlingCost: parseFloat(nextProps.HandlingCost) });
	      if (parseFloat(nextProps.ShippingCost) !== this.state.ShippingCost) this.setState({ ShippingCost: parseFloat(nextProps.ShippingCost) });
	      if (parseFloat(nextProps.priceAdjustment) !== this.state.priceAdjustment) {
	        this.setState({ priceAdjustment: parseFloat(nextProps.priceAdjustment) });
	      }
	      if (parseFloat(nextProps.InvoiceFinalPrice) !== this.state.InvoiceFinalPrice) this.setState({ InvoiceFinalPrice: parseFloat(nextProps.InvoiceFinalPrice) });
	      if (parseFloat(nextProps.TaxRate) !== this.state.TaxRate) this.setState({ TaxRate: parseFloat(nextProps.TaxRate) });
	      if (parseFloat(nextProps.TotalCRV) !== this.state.TotalCRV) this.setState({ TotalCRV: parseFloat(nextProps.TotalCRV) });
	      if (nextProps.currentReceiveHistoryDetail != null && nextProps.currentReceiveHistoryDetail != this.props.currentReceiveHistoryDetail) {
	        if (nextProps.currentReceiveHistoryDetail.Warehouse_Receive_Line_Completed) {
	          var newRows = [].concat(_toConsumableArray(nextProps.currentReceiveHistoryDetail.Warehouse_Receive_Line_Completed));
	          newRows.map(function (newRow) {
	            newRow["RcvUnitPrice"] = newRow["RcvUnitPrice"] ? newRow["RcvUnitPrice"] : newRow["FOBUnitPrice"];
	            newRow["subWeights"] = [];
	            if (newRow.Weights) {
	              console.log("newRow.Weights", newRow.Weights);
	              newRow.Weights.map(function (w) {
	                newRow["subWeights"].push({ 'Weight': w });
	              });
	            }
	          });
	          this.setState({ rows: newRows });
	        } else {
	          var _newRows = nextProps.currentReceiveHistoryDetail.Warehouse_Receive_Line;
	          _newRows.map(function (newRow) {
	            newRow["subWeights"] = [];
	            if (newRow.Weights) {
	              console.log("newRow.Weights", newRow.Weights);
	              newRow.Weights.map(function (w) {
	                newRow["subWeights"].push({ 'Weight': w });
	              });
	            }
	          });
	          this.setState({ rows: _newRows });
	        }
	      }
	      if (nextProps.purchaseOrderProduct && nextProps.purchaseOrderProduct !== this.props.purchaseOrderProduct) {
	        this.selectInventoryInfo(nextProps.purchaseOrderProduct);
	        this.props.fetchProductInfo(nextProps.purchaseOrderProduct.Product_id);
	        this.props.setDefaultOfForm('Weight', nextProps.purchaseOrderProduct.NetWeight, 'receiveHistoryDetail');
	        this.props.setDefaultOfForm('unitPrice', nextProps.purchaseOrderProduct.ProductCost, 'receiveHistoryDetail');
	        this.props.setDefaultOfForm('itemNotation', '', 'receiveHistoryDetail');
	      }
	
	      if (nextProps.warehouseReceivePdf && nextProps.warehouseReceivePdf !== this.props.warehouseReceivePdf) {
	        this.setState({ PdfFrameLoaded: false });
	      }
	
	      if (nextProps.editedReceiveHistory && nextProps.editedReceiveHistory !== this.props.editedReceiveHistory) {
	        this.openConfirm();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState.PdfFrameLoaded !== this.state.PdfFrameLoaded && this.state.PdfFrameLoaded == false) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton });
	    }
	  }, {
	    key: 'closeSetWeight',
	    value: function closeSetWeight() {
	      this.setState({ setWeightOpen: false });
	    }
	  }, {
	    key: 'openSetWeight',
	    value: function openSetWeight() {
	      this.setState({ setWeightOpen: true });
	    }
	  }, {
	    key: 'renderAutoSuggest',
	    value: function renderAutoSuggest() {
	      var _this3 = this;
	
	      return _react2.default.createElement(_PurchaseOrderAutoSuggest2.default, {
	        value: this.state.suggestValue,
	        onChange: function onChange(e, _ref) {
	          var newValue = _ref.newValue;
	          _this3.setState({ suggestValue: newValue });
	        },
	        handleKeyPress: this.handleKeyPress,
	        handleFocusQty: this.handleFocusQty,
	        setAllProductQuantity: this.setAllProductQuantity,
	        SearchType: this.props.searchType
	      });
	    }
	  }, {
	    key: 'returnTotalWeight',
	    value: function returnTotalWeight(totalWeight) {
	      console.log('current Row', this.state.rows[this.state.currentRow]);
	      var rows = [].concat(_toConsumableArray(this.state.rows));
	      var _rows$state$currentRo = rows[this.state.currentRow],
	          RcvQuantity = _rows$state$currentRo.RcvQuantity,
	          RcvUnitPrice = _rows$state$currentRo.RcvUnitPrice;
	
	
	      rows[this.state.currentRow].RcvTotalWeight = roundTo(totalWeight, 4).toFixed(2);
	      if (rows[this.state.currentRow].ProductType === 'Fixed') {
	        rows[this.state.currentRow].RcvTotalPrice = roundTo(parseFloat(RcvQuantity) * RcvUnitPrice, 2).toFixed(2);
	      } else {
	        rows[this.state.currentRow].RcvTotalPrice = roundTo(totalWeight * RcvUnitPrice, 2).toFixed(2);
	      }
	      this.setState({ rows: rows });
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this4 = this;
	
	      var that = this;
	      if (this.props.detailIsLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          this.props.error
	        )
	      );else {
	        // Parameters of the react-data-grid
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this4.state);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return Object.assign({}, rows[rowIdx]);
	        };
	
	        var onRowSelect = function onRowSelect(rows) {
	          _this4.setState.apply(_this4, _toConsumableArray(_this4.state).concat([{ selectedRows: rows }]));
	        };
	
	        var onRowsSelected = function onRowsSelected(rows) {
	          var newRows = _this4.state.rows;
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = true;
	          });
	          _this4.setState({ rows: newRows });
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          var newRows = _this4.state.rows;
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = false;
	          });
	          _this4.setState({ rows: newRows });
	        };
	
	        // Handle the sortable function
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var state = Object.assign({}, _this4.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this4.setState(state);
	        };
	
	        var handleFilterChange = function handleFilterChange(filter) {
	          var newFilters = Object.assign({}, _this4.state.filters);
	          if (filter.filterTerm) {
	            newFilters[filter.column.key] = filter;
	          } else {
	            delete newFilters[filter.column.key];
	          }
	          _this4.setState({ filters: newFilters });
	        };
	
	        var onRowClick = function onRowClick(rowIdx, row) {
	          _this4.props.fetchSalesOrders();
	        };
	
	        // Handle the editable function
	        var handleRowUpdated = function handleRowUpdated(e) {
	          var rows = getRows();
	          // let totalPrice = this.state.totalPrice;
	          // totalPrice = totalPrice ? totalPrice:0;
	          // totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	          if (e.updated.RcvQuantity != null) {
	            if (rows[e.rowIdx].ProductType == "Non-Fixed") {
	              var updated = _extends({}, e.updated);
	              if (parseFloat(updated.RcvQuantity) < 0) updated.RcvQuantity = 0;
	              Object.assign(rows[e.rowIdx], updated);
	              _this4.setState({ currentRow: e.rowIdx, totalLoaded: parseFloat(rows[e.rowIdx].RcvQuantity), rowChosen: e.rowIdx, currentWeights: rows[e.rowIdx].Weights, editedRow: rows[e.rowIdx] });
	              _this4.openSetWeight();
	            } else {
	              // totalPrice = (parseFloat(totalPrice) || 0) + ((parseFloat(e.updated.RcvQuantity) || 0) - (parseFloat(rows[e.rowIdx].RcvQuantity) || 0))*(parseFloat(rows[e.rowIdx].RcvUnitPrice) || 0);
	              var newWeight = parseFloat(rows[e.rowIdx].RcvQuantity) ? rows[e.rowIdx].RcvTotalWeight / rows[e.rowIdx].RcvQuantity * parseFloat(e.updated.RcvQuantity) : 0;
	              newWeight = parseFloat(parseFloat(newWeight).toFixed(2));
	              Object.assign(rows[e.rowIdx], { RcvTotalWeight: newWeight });
	              Object.assign(rows[e.rowIdx], { RcvTotalPrice: roundTo(parseFloat(e.updated.RcvQuantity) * rows[e.rowIdx].RcvUnitPrice, 2).toFixed(2) });
	              Object.assign(rows[e.rowIdx], e.updated);
	            }
	          } else if (e.updated.RcvUnitPrice != null) {
	            if (rows[e.rowIdx].ProductType == "Non-Fixed" || rows[e.rowIdx].ProductType == "Per-Pound") {
	              // totalPrice = parseFloat(totalPrice) + (e.updated.RcvUnitPrice - rows[e.rowIdx].RcvUnitPrice)*rows[e.rowIdx].RcvTotalWeight;
	              Object.assign(rows[e.rowIdx], { RcvTotalPrice: roundTo(parseFloat(e.updated.RcvUnitPrice) * rows[e.rowIdx].RcvTotalWeight, 2).toFixed(2) });
	            } else {
	              // totalPrice = parseFloat(totalPrice) + (e.updated.RcvUnitPrice - rows[e.rowIdx].RcvUnitPrice)*rows[e.rowIdx].RcvQuantity;
	              Object.assign(rows[e.rowIdx], { RcvTotalPrice: roundTo(parseFloat(e.updated.RcvUnitPrice) * rows[e.rowIdx].RcvQuantity, 2).toFixed(2) });
	            }
	            Object.assign(rows[e.rowIdx], e.updated);
	            _this4.setState({ currentWeights: rows[e.rowIdx].Weights });
	          } else if (e.updated.RcvTotalWeight != null) {
	            if (rows[e.rowIdx].ProductType == "Non-Fixed" || rows[e.rowIdx].ProductType == "Per-Pound") {
	              // totalPrice = parseFloat(totalPrice) + (parseFloat(e.updated.RcvTotalWeight) - (parseFloat(rows[e.rowIdx].RcvTotalWeight) || 0))*rows[e.rowIdx].RcvUnitPrice;
	              Object.assign(rows[e.rowIdx], { RcvTotalPrice: roundTo(parseFloat(e.updated.RcvTotalWeight) * parseFloat(rows[e.rowIdx].RcvUnitPrice), 2).toFixed(2) });
	              Object.assign(rows[e.rowIdx], e.updated);
	            }
	          } else {
	            Object.assign(rows[e.rowIdx], e.updated);
	          }
	          // totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	          var totalPrice = 0;
	          rows.map(function (r) {
	            totalPrice += parseFloat(r.RcvTotalPrice);
	          });
	          _this4.setState({ rows: rows, totalPrice: totalPrice });
	        };
	
	        // Column difinition
	        var IsFixedFormatter = _react2.default.createClass({
	          displayName: 'IsFixedFormatter',
	          render: function render() {
	            if (this.props.dependentValues.ProductType === "Non-Fixed") {
	              return _react2.default.createElement(
	                'span',
	                { style: { 'font-weight': 'bold' } },
	                this.props.value,
	                ' ',
	                _react2.default.createElement(
	                  'label',
	                  { className: 'label label-success' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'non_fixed' })
	                )
	              );
	            } else {
	              return _react2.default.createElement(
	                'span',
	                { style: { 'font-weight': 'bold' } },
	                this.props.value
	              );
	            }
	          }
	        });
	
	        var IsVariableFormatter = _react2.default.createClass({
	          displayName: 'IsVariableFormatter',
	          render: function render() {
	            var _this5 = this;
	
	            return _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  className: 'textAlignStyle',
	                  style: { height: '23px', width: '39px', padding: '0px' },
	                  onClick: function onClick() {
	                    that.moveOffFromProductsList(_this5.props.dependentValues.WarehouseReceiveLine_id);
	                  }
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'X' })
	              )
	            );
	          }
	        });
	
	        var columns = [{
	          key: 'Delete',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	          formatter: IsVariableFormatter,
	          width: 50,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        }, {
	          key: 'ProductRefNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        }, {
	          key: 'ProductName',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	          resizable: true,
	          sortable: true,
	          width: 160,
	          filterable: true
	        }, {
	          key: 'ProductDescription',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	          resizable: true,
	          sortable: true,
	          width: 85,
	          filterable: true
	        }, {
	          key: 'OrderQuantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_qty' }),
	          resizable: true,
	          sortable: true,
	          width: 85,
	          filterable: true
	        }, {
	          key: 'RcvQuantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rcv_qty' }),
	          resizable: true,
	          editable: isAFGRelated ? (0, _permissions2.default)('change_receiving_history_quantity_price') || (0, _permissions2.default)('show_real_sales_margin') && this.state.status !== 'Received' : (0, _permissions2.default)('change_receiving_history_quantity_price') || (0, _permissions2.default)('show_real_sales_margin'),
	          sortable: true,
	          width: 80,
	          filterable: true,
	          formatter: IsFixedFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'RcvUnitPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_unit_dollarsign' }),
	          resizable: true,
	          editable: isAFGRelated ? (0, _permissions2.default)('change_receiving_history_quantity_price') && this.state.status !== 'Received' : (0, _permissions2.default)('change_receiving_history_quantity_price'),
	          sortable: true,
	          width: 80,
	          filterable: true,
	          formatter: _boldDecimalTextFormatter2.default
	        }, {
	          key: 'RcvTotalPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_total_dollarsign' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true,
	          formatter: _boldDecimalTextFormatter2.default
	        }, {
	          key: 'RcvTotalWeight',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rcv_tw' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        },
	        // {
	        //     key: 'RtnQuantity',
	        //     name: <Translate value="return_qty" />,
	        //     resizable: true,
	        //     editable: true,
	        //     sortable: true,
	        //     width: 80,
	        //     filterable: true
	        // },
	        // {
	        //     key: 'InStock',
	        //     name: <Translate value="in_stock" />,
	        //     resizable: true,
	        //     sortable: true,
	        //     width: 80,
	        //     filterable: true
	        // },
	        {
	          key: 'Batch_PONum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'location',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' }),
	          resizable: true,
	          sortable: true,
	          width: 130,
	          filterable: true
	        }, {
	          key: 'expire_datetime',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'expire_datetime' }),
	          resizable: true,
	          sortable: true,
	          editable: true,
	          width: 120,
	          filterable: true,
	          formatter: _dateFormat.DateFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'Remark',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'remark' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        }, {
	          key: 'StorageRate',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_rate' }),
	          resizable: true,
	          editable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        }, {
	          key: 'Pallet',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet' }),
	          resizable: true,
	          editable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        }];
	
	        if (isUSPride || isATL || isRS) {
	          var index1 = _lodash2.default.findIndex(columns, { key: "RcvTotalWeight" });
	          columns.splice(index1, 1);
	          var index2 = _lodash2.default.findIndex(columns, { key: "expire_datetime" });
	          var temp1 = {
	            key: "PackageSize_1",
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'volume_cft' }),
	            resizable: true,
	            width: 80,
	            sortable: true
	          };
	          columns.splice(index2, 1, temp1);
	        }
	
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { style: { maxWidth: '100%' }, id: 'ReceiveHistoryDetail-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'BatchNum',
	                enableCellSelect: true,
	                onGridSort: handleGridSort,
	                onAddFilter: handleFilterChange,
	                columns: columns,
	                rowGetter: rowGetter,
	                headerRowHeight: 45,
	                rowHeight: 25,
	                rowsCount: getSize()
	                // enableRowSelect='single'
	                , onRowUpdated: handleRowUpdated
	                //   rowSelection={{
	                //     showCheckbox: true,
	                //     enableShiftSelect: true,
	                //     onRowsSelected: onRowsSelected,
	                //     onRowsDeselected: onRowsDeselected,
	                //     selectBy: {
	                //      isSelectedKey: 'isSelected'
	                //     }
	                //  }}
	                , minHeight: 485 })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'dateStringFormat',
	    value: function dateStringFormat(date) {
	      var month = date.getMonth() + 1;
	      if (month < 10) month = "0" + month;
	      var day = date.getDate();
	      if (day < 10) day = "0" + day;
	      var year = date.getFullYear();
	      return month + '/' + day + '/' + year;
	    }
	  }, {
	    key: 'renderPOInformation',
	    value: function renderPOInformation() {
	      var PONum = null;
	      var POTotal = null;
	      var POFinal = null;
	      var warehouseName = null;
	      var purchaser = null;
	      var vendorNum = null;
	      var vendorName = null;
	      var HandlingCost = null;
	      var MiscCost = null;
	      var ShippingCost = null;
	      var priceAdjustment = null;
	      var CRV = 0;
	      var TaxRate = 0;
	      var TotalCRV = 0;
	      var RCVTotal = 0;
	      var RCVFinal = 0;
	      var InvoiceFinalPrice = 0;
	      var TaxableItems = 0;
	      var vendorDescription = null,
	          OrderDate = null,
	          ETADate = null,
	          CreateDate = null,
	          totalPrice = this.state.totalPrice,
	          finalPrice = 0;
	      PONum = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.PONum;
	      POTotal = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.PO_Total_Price;
	      POFinal = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.PO_Final_Price;
	      vendorNum = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.VendorPicklistNum;
	      vendorName = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.VendorName;
	      vendorDescription = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.VendorDescription;
	      HandlingCost = this.state.HandlingCost || this.state.HandlingCost == 0 ? this.state.HandlingCost : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.HandlingCost;
	      MiscCost = this.state.MiscCost || this.state.MiscCost == 0 ? this.state.MiscCost : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.MiscCost;
	      ShippingCost = this.state.ShippingCost || this.state.ShippingCost == 0 ? this.state.ShippingCost : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.ShippingCost;
	      priceAdjustment = this.state.priceAdjustment || this.state.priceAdjustment === 0 ? this.state.priceAdjustment : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.PriceAdjustment;
	      InvoiceFinalPrice = this.state.InvoiceFinalPrice || this.state.InvoiceFinalPrice == 0 ? this.state.InvoiceFinalPrice : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.InvoiceFinalPrice;
	      TaxRate = this.state.TaxRate || this.state.TaxRate == 0 ? this.state.TaxRate : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.TaxRate;
	      //CRV = (this.state.CRV || this.state.CRV == 0) ? this.state.CRV : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.CRV;
	      TotalCRV = this.state.TotalCRV || this.state.TotalCRV == 0 ? this.state.TotalCRV : 0;
	      totalPrice = (parseFloat(totalPrice) || 0) + (parseFloat(this.props.HandlingCost) || 0) + (parseFloat(this.props.MiscCost) || 0) + (parseFloat(this.props.ShippingCost) || 0) + (parseFloat(this.props.priceAdjustment) || 0);
	      totalPrice = roundTo(totalPrice, 2).toFixed(2);
	
	      OrderDate = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.OrderDate;
	      OrderDate = new Date(OrderDate);
	
	      ETADate = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.ETADate;
	      ETADate = new Date(ETADate);
	
	      CreateDate = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.PostingDate;
	      CreateDate = new Date(CreateDate);
	
	      OrderDate = this.dateStringFormat(OrderDate);
	      ETADate = this.dateStringFormat(ETADate);
	      CreateDate = this.dateStringFormat(CreateDate);
	      if (this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.Warehouse_Receive_Line) {
	        var details = this.state.rows.length || this.state.rows.length === 0 ? this.state.rows : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.Warehouse_Receive_Line;
	        for (var i = 0; i < details.length; i++) {
	          var RcvQuantity = details[i].RcvQuantity;
	          var RcvUnitPrice = details[i].RcvUnitPrice;
	          if (details[i].ProductType === "Fixed" || details[i].ProductType === "Service" || details[i].ProductType === "Non-Product") {
	            RCVTotal += roundTo(RcvQuantity * RcvUnitPrice, 2);
	            if (details[i].IsTaxable) TaxableItems += roundTo(RcvQuantity * RcvUnitPrice, 2);
	            RCVFinal += roundTo(RcvQuantity * RcvUnitPrice, 2);
	          } else {
	            var RcvTotalWeight = details[i].RcvTotalWeight;
	            RCVTotal += roundTo(RcvUnitPrice * RcvTotalWeight, 2);
	            if (details[i].IsTaxable) TaxableItems += roundTo(RcvUnitPrice * RcvTotalWeight, 2);
	            RCVFinal += roundTo(RcvUnitPrice * RcvTotalWeight, 2);
	          }
	          TotalCRV += roundTo(details[i].CRV * RcvQuantity, 2);
	        }
	      }
	      TaxableItems = roundTo(TaxableItems * (TaxRate / 100), 2);
	      RCVFinal += roundTo(parseFloat(ShippingCost), 2) + roundTo(parseFloat(HandlingCost), 2) + roundTo(parseFloat(priceAdjustment), 2) + roundTo(parseFloat(MiscCost), 2) + TotalCRV + TaxableItems;
	      RCVTotal = roundTo(RCVTotal, 2).toFixed(2);
	      RCVFinal = roundTo(RCVFinal, 2).toFixed(2);
	      var currentReceiveHistoryDetail = this.props.currentReceiveHistoryDetail;
	
	      var defaultWarehouseID = { value: currentReceiveHistoryDetail && currentReceiveHistoryDetail.Warehouse_id };
	      return _react2.default.createElement(
	        _reactBootstrap.Panel,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            { className: 'receive-form-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'details' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-5 marginTopStyle po-information' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receipt_no' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 7 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'WarehouseReceiveNum', component: _inputField.DisabledInputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-5 marginTopStyle po-information' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_inv' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 7 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'InvoiceNum', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-5 marginTopStyle po-information' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'packing_num' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 7 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'PackingNum', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-5 marginTopStyle po-information' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 7 },
	              _react2.default.createElement(_warehouseDropdown2.default, { defaultValue: defaultWarehouseID })
	            )
	          ),
	          isTN && _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-5 marginTopStyle po-information' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_no' }),
	              '.'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 7, style: { marginTop: '5px' } },
	              currentReceiveHistoryDetail && currentReceiveHistoryDetail.container_num
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            { className: 'receive-form-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_id' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              vendorNum
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              vendorName
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              vendorDescription
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            { className: 'receive-form-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dates' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_date' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              OrderDate ? (0, _cleanDates.convertLocalDate)(OrderDate, 'MM-DD-YY') : null
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'eta_date' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              ETADate ? (0, _cleanDates.convertLocalDate)(ETADate, 'MM-DD-YY') : null
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_date' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { component: _datePicker.DatePicker, name: 'PostingDate' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_inv_date' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { component: _datePicker.DatePicker, name: 'InvoiceDate' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            { className: 'receive-form-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_info' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              PONum
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchaser' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              purchaser
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_total' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              '$' + (0, _numberWithCommas.numberWithCommas)(POTotal)
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_final' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              '$' + (0, _numberWithCommas.numberWithCommas)(POFinal)
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-6 marginTopStyle' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'Note', component: _inputField.InputField, maxLength: 150, style: { minWidth: '205px', maxWidth: '205px' } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            { className: 'receive-form-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price_details' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_total' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'ReceiveTotal', component: _inputField.DisabledInputField, placeholder: RCVTotal })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_final' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'ReceiveFinal', component: _inputField.DisabledInputField, placeholder: RCVFinal })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'crv' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'TotalCRV', component: _inputField.DisabledInputField, placeholder: TotalCRV })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'TaxRate', component: _inputField.InputField })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement('label', { className: 'receive-form-label' }),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'ShippingCost', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'handling' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'HandlingCost', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'misc' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'MiscCost', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'adjustments' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'PriceAdjustment', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_final' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'InvoiceFinalPrice', component: _inputField.InputField })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'handleFocusAutoSuggest',
	    value: function handleFocusAutoSuggest() {
	      var autoSuggestField = document.getElementById('purchase-auto-suggest');
	      autoSuggestField.focus();
	      autoSuggestField.select();
	    }
	  }, {
	    key: 'handleOnFocus',
	    value: function handleOnFocus(event) {
	      event.target.select();
	    }
	  }, {
	    key: 'selectInventoryInfo',
	    value: function selectInventoryInfo(selectedInventoryRow) {
	      this.setState({ selectedInventoryRow: selectedInventoryRow });
	      var index = _lodash2.default.findIndex(this.props.simplifiedProducts, { 'Product_id': selectedInventoryRow.Product_id });
	      if (index > -1) {
	        this.props.fetchProductInfo(this.props.simplifiedProducts[index].Product_id);
	        this.props.setPriceValues(this.props.simplifiedProducts[index].ProductCost, this.props.simplifiedProducts[index].LowestSalePrice, 'purchaseOrderForm');
	        if ((this.props.simplifiedProducts[index].ProductType == "Non-Fixed" || this.props.simplifiedProducts[index].ProductType == "Per-Pound") && !this.props.simplifiedProducts[index].NetWeight) {
	          alert("Net Weight Cannot Be 0! Change Net Weight in Product Page!");
	        }
	        this.props.setDefaultOfForm('Weight', this.props.simplifiedProducts[index].NetWeight, 'purchaseOrderForm');
	      }
	    }
	  }, {
	    key: 'checkisValid',
	    value: function checkisValid() {
	      if (!isNumeric(this.props.quantityValue) || this.props.quantityValue < 0 || !isNumeric(this.props.unitPrice) || this.props.unitPrice < 0) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'setRows',
	    value: function setRows(rowChosen, weights) {
	      var rows = [].concat(_toConsumableArray(this.state.rows));
	      rows[rowChosen].subWeights = weights;
	      var prevTotalPrice = parseFloat(rows[rowChosen].RcvTotalPrice) || 0;
	      var sumWeights = 0;
	      weights.map(function (w) {
	        sumWeights = sumWeights + parseFloat(w.Weight);
	      });
	      rows[rowChosen].RcvTotalWeight = sumWeights;
	      rows[rowChosen].RcvTotalPrice = sumWeights * rows[rowChosen].RcvUnitPrice;
	      var totalPrice = (parseFloat(this.state.totalPrice) || 0) + rows[rowChosen].RcvTotalPrice - prevTotalPrice;
	      this.setState({ rows: rows, totalPrice: totalPrice });
	    }
	  }, {
	    key: 'header',
	    value: function header() {
	      return _react2.default.createElement(
	        'h2',
	        { className: 'mt0' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receiving_list' })
	      );
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      this.setState({ dirty: false });
	      var WarehouseReceiveCompleted_id = this.props.currentReceiveHistoryDetail.WarehouseReceiveCompleted_id;
	      var WarehouseReceive_id = this.props.currentReceiveHistoryDetail.WarehouseReceive_id;
	      var RCVTotal = 0,
	          RCVFinal = 0;
	      var HandlingCost = this.state.HandlingCost || this.state.HandlingCost == 0 ? this.state.HandlingCost : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.HandlingCost;
	      var MiscCost = this.state.MiscCost || this.state.MiscCost == 0 ? this.state.MiscCost : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.MiscCost;
	      var ShippingCost = this.state.ShippingCost || this.state.ShippingCost == 0 ? this.state.ShippingCost : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.ShippingCost;
	      var priceAdjustment = this.state.priceAdjustment || this.state.priceAdjustment === 0 ? this.state.priceAdjustment : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.PriceAdjustment;
	      var InvoiceFinalPrice = this.state.InvoiceFinalPrice || this.state.InvoiceFinalPrice == 0 ? this.state.InvoiceFinalPrice : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.InvoiceFinalPrice;
	      var TaxRate = this.state.TaxRate || this.state.TaxRate == 0 ? this.state.TaxRate : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.TaxRate;
	      var TotalCRV = this.state.TotalCRV || this.state.TotalCRV == 0 ? this.state.TotalCRV : 0;
	      var details = this.state.rows.length || this.state.rows.length === 0 ? this.state.rows : this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.Warehouse_Receive_Line;
	      var TaxableItems = 0;
	      for (var i = 0; i < details.length; i++) {
	        var RcvQuantity = details[i].RcvQuantity;
	        var RcvUnitPrice = details[i].RcvUnitPrice;
	        if (details[i].ProductType === "Fixed" || details[i].ProductType === "Service" || details[i].ProductType === "Non-Product") {
	          RCVTotal += roundTo(RcvQuantity * RcvUnitPrice, 2);
	          if (details[i].IsTaxable) TaxableItems += roundTo(RcvQuantity * RcvUnitPrice, 2);
	          RCVFinal += roundTo(RcvQuantity * RcvUnitPrice, 2);
	        } else {
	          var RcvTotalWeight = details[i].RcvTotalWeight;
	          RCVTotal += roundTo(RcvUnitPrice * RcvTotalWeight, 2);
	          if (details[i].IsTaxable) TaxableItems += roundTo(RcvUnitPrice * RcvTotalWeight, 2);
	          RCVFinal += roundTo(RcvUnitPrice * RcvTotalWeight, 2);
	        }
	        TotalCRV += roundTo(details[i].CRV * RcvQuantity, 2);
	      }
	      TaxableItems = roundTo(TaxableItems * (TaxRate / 100), 2);
	      RCVFinal += roundTo(parseFloat(ShippingCost), 2) + roundTo(parseFloat(HandlingCost), 2) + roundTo(parseFloat(priceAdjustment), 2) + roundTo(parseFloat(MiscCost), 2) + TotalCRV + TaxableItems;
	      RCVTotal = parseFloat(roundTo(RCVTotal, 2).toFixed(2));
	      RCVFinal = parseFloat(roundTo(RCVFinal, 2).toFixed(2));
	      this.props.editReceiveHistory(formProps, _reactDataGridAddons.Data.Selectors.getRows(this.state), null, RCVTotal, RCVFinal);
	    }
	  }, {
	    key: 'renderIFrame',
	    value: function renderIFrame() {
	      if (this.props.warehouseReceivePdf) {
	        var file = window.URL.createObjectURL(this.props.warehouseReceivePdf);
	        return _react2.default.createElement('iframe', { style: { display: 'none' }, onLoad: this.IFrameIsLoaded, id: 'Pdf', name: 'Pdf', src: file });
	      }
	    }
	  }, {
	    key: 'renderPrint',
	    value: function renderPrint() {
	      var _this6 = this;
	
	      var _props = this.props,
	          currentReceiveHistoryDetail = _props.currentReceiveHistoryDetail,
	          isEditingReveiveHistory = _props.isEditingReveiveHistory,
	          requestingWarehouseReceivePdf = _props.requestingWarehouseReceivePdf;
	
	      var url = '';
	      if (currentReceiveHistoryDetail && currentReceiveHistoryDetail.WarehouseReceiveNum) {
	        url = _root_url.ROOT_URL + 'v1/warehouse/receive/print/' + currentReceiveHistoryDetail.WarehouseReceiveNum + '?Bearer=' + localStorage.getItem('token');
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          disabled: url === '' || isEditingReveiveHistory || requestingWarehouseReceivePdf,
	          onClick: function onClick() {
	            _this6.props.printWarehouseReceive(currentReceiveHistoryDetail.WarehouseReceiveNum);
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var _props2 = this.props,
	          handleSubmit = _props2.handleSubmit,
	          submitting = _props2.submitting,
	          pristine = _props2.pristine;
	
	      var createDialogStyle = {
	        width: '500px',
	        height: '550px',
	        marginLeft: '-15%'
	      };
	      if (this.props.detailIsLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          this.props.error.message
	        )
	      );else {
	        var isEditingReveiveHistory = this.props.isEditingReveiveHistory;
	
	        var buttonIcon = void 0;
	        if (isEditingReveiveHistory) {
	          buttonIcon = 'fa-spinner fa-spin';
	        } else {
	          buttonIcon = 'fa-save';
	        }
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'form',
	            { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Breadcrumb.Item,
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_management' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Breadcrumb.Item,
	                { active: 'true' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_receiving' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  disabled: this.shouldSaveDisable(),
	                  type: 'button',
	                  onClick: handleSubmit(this.handleFormSubmit.bind(this))
	                },
	                _react2.default.createElement('em', { className: 'fa ' + buttonIcon }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	              ),
	              this.renderPrint(),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  onClick: function onClick() {
	                    _this7.context.router.push("/inventories/receiveHistory");
	                  },
	                  bsStyle: 'danger',
	                  type: 'button'
	                },
	                _react2.default.createElement('em', { className: 'fa fa-close' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Grid,
	              { fluid: 'true', id: 'create-inventory-receive' },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                this.header()
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                this.renderPOInformation()
	              ),
	              this.renderProductSearch(),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { style: { marginTop: "8px" } },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'table-collapse-fix' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_history_detail' })
	                  ),
	                  _react2.default.createElement('hr', null),
	                  this.renderTable(),
	                  _react2.default.createElement('hr', null)
	                )
	              )
	            )
	          ),
	          this.renderIFrame(),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogStyle,
	              isVisible: this.state.setWeightOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this7.closeSetWeight();
	              },
	              title: 'Set Product Weights' },
	            _react2.default.createElement(_setWeightModal2.default, { invoice: true, setWeights: this.setWeights, keepLoaded: this.keepLoaded, currentWeights: this.state.currentWeights, closeC: this.closeSetWeight, totalLoaded: this.state.totalLoaded, rowChosen: this.state.rowChosen, returnTotalWeight: this.returnTotalWeight.bind(this), editedRow: this.state.editedRow })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'remove-close-skylight' },
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                dialogStyles: createDialogStyle,
	                isVisible: this.state.confirmOpen,
	                onCloseClicked: this.closeConfirm,
	                title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'your_receiving_has_been_saved' })
	              },
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle' },
	                this.props.editedReceiveHistory && this.props.editedReceiveHistory && _react2.default.createElement(
	                  'h4',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_num' }),
	                  ': ',
	                  this.props.editedReceiveHistory.WarehouseReceiveNum
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle' },
	                this.props.editedReceiveHistory && this.props.editedReceiveHistory && _react2.default.createElement(
	                  'h4',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	                  ': ',
	                  this.props.editedReceiveHistory.InvoiceNum
	                )
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_ask_if_stay_on_current_page' }),
	                  '?'
	                )
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                { className: 'button-toolbar-center' },
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  { bsStyle: 'success', onClick: this.closeConfirm, type: 'button' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  { bsStyle: 'danger', onClick: function onClick() {
	                      _this7.context.router.push('/inventories/receiveHistory');
	                    }, type: 'button' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	                ),
	                this.renderPrint()
	              )
	            )
	          )
	        );
	      }
	    }
	  }]);
	
	  return ReceiveHistoryDetail;
	}(_react.Component);
	
	ReceiveHistoryDetail.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var _default = (0, _reactRouter.withRouter)(ReceiveHistoryDetail);
	
	exports.default = _default;
	
	
	function roundTo(n, digits) {
	  if (digits === undefined) {
	    digits = 0;
	  }
	
	  var multiplicator = Math.pow(10, digits);
	  n = parseFloat((n * multiplicator).toFixed(11));
	  var test = Math.round(n) / multiplicator;
	  return +test.toFixed(2);
	}
	
	var renderTypeRadios = function renderTypeRadios(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group', id: 'search-product-by', style: { paddingBottom: '10px' } },
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-4 search-by-max-width' },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'search_by' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'ProductNum',
	        checked: props.input.value === "ProductNum" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'RefNum',
	        checked: props.input.value === "RefNum" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'Name',
	        checked: props.input.value === "Name" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'Description',
	        checked: props.input.value === "Description" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	    )
	  );
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(roundTo, 'roundTo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveHistoryDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(isAFGRelated, 'isAFGRelated', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveHistoryDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(isAFG, 'isAFG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveHistoryDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(isMMD, 'isMMD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveHistoryDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(isTN, 'isTN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveHistoryDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(isUSPride, 'isUSPride', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveHistoryDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(isATL, 'isATL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveHistoryDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(isRS, 'isRS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveHistoryDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(isNumeric, 'isNumeric', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveHistoryDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(ReceiveHistoryDetail, 'ReceiveHistoryDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveHistoryDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(renderTypeRadios, 'renderTypeRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveHistoryDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveHistoryDetail.jsx');
	}();

	;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _GenericDatePicker = __webpack_require__(48);
	
	var _GenericDatePicker2 = _interopRequireDefault(_GenericDatePicker);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _cleanDates = __webpack_require__(22);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _root_url = __webpack_require__(9);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _dateFilterRadios = __webpack_require__(49);
	
	var _dateFilterRadios2 = _interopRequireDefault(_dateFilterRadios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isTN = _root_url.ROOT_API_URL === 'https://tn-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://tn-scm.truckxi.com/api/';
	var isUSPride = _root_url.ROOT_API_URL === 'https://uspride-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://uspride-scm.truckxi.com/api/';
	var isOCM = _root_url.ROOT_API_URL === 'https://ocm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ocm-scm.truckxi.com/api/';
	var isATL = _root_url.ROOT_API_URL === 'https://alton-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://alton-scm.truckxi.com/api/';
	var isRS = _root_url.ROOT_API_URL === 'https://redstone-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://redstone-scm.truckxi.com/api/';
	var isLO = _root_url.ROOT_API_URL === 'https://lonni-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://lonni-scm.truckxi.com/api/';
	var isAFG = _root_url.ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afgstage-scm.truckxi.com/api/';
	
	var ReceiveHistoryList = function (_Component) {
	  _inherits(ReceiveHistoryList, _Component);
	
	  function ReceiveHistoryList() {
	    _classCallCheck(this, ReceiveHistoryList);
	
	    var _this = _possibleConstructorReturn(this, (ReceiveHistoryList.__proto__ || Object.getPrototypeOf(ReceiveHistoryList)).call(this));
	
	    _this.openStatusModal = function () {
	      _this.setState({ case: 'voidStatus', statusOpen: true });
	    };
	
	    _this.closeStatusModal = function () {
	      _this.props.resetDeleteStatus();
	      _this.setState({ statusOpen: false }, _this.fetchReceiveHistoryByDetails(_this.props.Days));
	    };
	
	    _this.openEditRecPermission = function () {
	      _this.setState({ case: 'editRecPermission', editRecPermissionOpen: true });
	    };
	
	    _this.closeEditRecPermission = function () {
	      _this.setState({ editRecPermissionOpen: false });
	    };
	
	    _this.receiveDetailRedirect = function () {
	      var currentReceiveHistory = _this.state.selectedRows[0];
	      _this.props.resetCurrentReceiveHistory();
	      _this.props.selectReceiveHistory(currentReceiveHistory);
	      _this.context.router.push('/inventories/receiveHistory/' + currentReceiveHistory.PONum);
	    };
	
	    _this.fetchReceiveHistoryByDetails = function (days) {
	      if (days !== '-1') {
	        _this.setState({ FromDate: undefined, ToDate: undefined, Days: days }, function () {
	          _this.props.fetchReceiveHistoryByDate(_this.state.FromDate, _this.state.ToDate, _this.state.Days);
	        });
	      } else {
	        _this.setState({ Days: '-1' }, function () {
	          _this.props.fetchReceiveHistoryByDate(_this.state.FromDate, _this.state.ToDate, _this.state.Days);
	        });
	      }
	    };
	
	    _this.IFrameIsLoaded = function () {
	      if (!_this.state.PdfFrameLoaded) {
	        var pdfFrame = window.frames.Pdf;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this.setState({ PdfFrameLoaded: true });
	      }
	    };
	
	    _this.handleDownloadLabelClick = function (WarehouseReceiveLine_id) {
	      var WarehouseReceive_id = _this.state.WarehouseReceive_id;
	
	      _this.props.fetchLineLabel(WarehouseReceive_id, WarehouseReceiveLine_id);
	    };
	
	    _this.handleSelectDetailAll = function () {
	
	      var newRows = [].concat(_toConsumableArray(_this.state.receiveHistoryLine.rows));
	      var selectedRows = [];
	      var index = 0;
	      newRows.map(function (r) {
	        r.isSelected = true;
	        selectedRows.push(r);
	        index++;
	      });
	      var receiveHistoryLine = _extends({}, _this.state.receiveHistoryLine, { rows: newRows, selectedRows: selectedRows });
	      _this.setState({ receiveHistoryLine: receiveHistoryLine });
	    };
	
	    _this.handleDeselectDetailAll = function () {
	      var newRows = [].concat(_toConsumableArray(_this.state.receiveHistoryLine.rows));
	      var selectedRows = null;
	      var index = 0;
	      newRows.map(function (r) {
	        r.isSelected = false;
	      });
	      var receiveHistoryLine = _extends({}, _this.state.receiveHistoryLine, { rows: newRows, selectedRows: selectedRows });
	      _this.setState({ receiveHistoryLine: receiveHistoryLine });
	    };
	
	    _this.setToRangeSearch = function () {
	      _this.setState({ Days: '-1' });
	    };
	
	    _this.setFromDate = function (e) {
	      if (e > _this.state.ToDate) {
	        return;
	      }
	      _this.setState({ FromDate: e });
	    };
	
	    _this.setToDate = function (e) {
	      if (e < _this.state.FromDate) {
	        return;
	      }
	      _this.setState({ ToDate: e });
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.fourLineButton,
	
	      createOpen: false,
	      editRecPermissionOpen: false,
	      statusOpen: false,
	      case: null,
	
	      fromDate: new Date(),
	
	      rows: [],
	      selectedRows: [],
	      editedRows: [],
	      filters: {},
	      sortColumn: null,
	      sortDirection: null,
	      gourpOpen: false,
	
	      receiveHistoryLine: {
	        rows: [],
	        selectedRows: null,
	        editedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null,
	        gourpOpen: false
	      },
	
	      PdfFrameLoaded: true,
	      Days: '7',
	      FromDate: undefined,
	      ToDate: undefined,
	
	      WarehouseReceive_id: null
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	
	    _this.openCreate = _this.openCreate.bind(_this);
	    _this.closeCreate = _this.closeCreate.bind(_this);
	    _this.receiveDetail = _this.receiveDetail.bind(_this);
	    _this.autoPutaway = _this.autoPutaway.bind(_this);
	    return _this;
	  }
	
	  _createClass(ReceiveHistoryList, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.setDefaultOfForm('Days', '7', 'receiveHistoryList');
	      // this.props.fetchReceiveHistoryByDate(0, 0, '7');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      window.addEventListener('resize', this.handleResize);
	      this.props.fetchReceiveHistoryByDate(0, 0, '7');
	    }
	
	    // Once purchaseOrders is ready, reset state.
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.passcodeVerified && !this.props.passcodeVerified) {
	        this.props.setPasscodeVerificationStatus();
	        this.receiveDetailRedirect();
	      }
	      if (nextProps.FromDate && nextProps.FromDate !== this.props.FromDate) {
	        this.setState({ fromDate: nextProps.FromDate }, this.fetchReceiveHistoryByDetails);
	      }
	      if (nextProps.ToDate && nextProps.ToDate !== this.props.ToDate) {
	        this.setState({ toDate: nextProps.ToDate }, this.fetchReceiveHistoryByDetails);
	      }
	      if (nextProps.currentReceiveHistoryDetail && nextProps.currentReceiveHistoryDetail != this.props.currentReceiveHistoryDetail) {
	        if (nextProps.currentReceiveHistoryDetail.Warehouse_Receive_Line_Completed) {
	          var newRows = [].concat(_toConsumableArray(nextProps.currentReceiveHistoryDetail.Warehouse_Receive_Line_Completed));
	          newRows.map(function (newRow) {
	            newRow.RcvUnitPrice = newRow.RcvUnitPrice ? newRow.RcvUnitPrice : newRow.FOBUnitPrice;
	          });
	          var receiveHistoryLine = _extends({}, this.state.receiveHistoryLine, { rows: newRows });
	          this.setState({ receiveHistoryLine: receiveHistoryLine });
	        } else {
	          var _receiveHistoryLine = _extends({}, this.state.receiveHistoryLine, { rows: nextProps.currentReceiveHistoryDetail.Warehouse_Receive_Line });
	          this.setState({ receiveHistoryLine: _receiveHistoryLine });
	        }
	      }
	      if (nextProps.checkPermissionSuccess && nextProps.checkPermissionSuccess !== this.props.checkPermissionSuccess) {
	        if (nextProps.checkPermissionSuccess.manager) {
	          this.closeEditRecPermission();
	          this.setState({ editRecPermission: true });
	          this.props.voidReceiving(this.state.selectedRows[0].WarehouseReceive_id);
	        }
	      }
	
	      if (nextProps.voidStatus) {
	        this.openStatusModal();
	      }
	
	      if (nextProps.currentReceiveHistory && nextProps.currentReceiveHistory !== this.props.currentReceiveHistory) {
	        var receives = nextProps.currentReceiveHistory.Invoices;
	
	        // filter out purchase returns from warehouse receiving list
	        receives = _lodash2.default.filter(receives, function (receive) {
	          return receive.PurchaseReturn_id === undefined;
	        });
	        //
	        // receives.map((receive) => {
	        //   receive.VendorName = receive.Purchase.Vendor.Name;
	        //   receive.FinalPrice = receive.Purchase.FinalPrice;
	        //   receive.TotalPrice = receive.Purchase.TotalPrice;
	        // });
	        this.setState({
	          rows: receives
	        });
	      }
	
	      if (nextProps.warehouseReceivePdf && nextProps.warehouseReceivePdf !== this.props.warehouseReceivePdf) {
	        this.setState({ PdfFrameLoaded: false });
	      }
	      if (nextProps.Days && nextProps.Days !== this.props.Days) {
	        if (nextProps.Days !== '-1') {
	          this.props.setDefaultOfForm('FromDate', null, 'receiveHistoryList');
	          this.props.setDefaultOfForm('ToDate', null, 'receiveHistoryList');
	        }
	      }
	
	      if (typeof this.props.FromDate !== 'undefined' && typeof this.props.ToDate !== 'undefined' && (nextProps.FromDate !== this.props.FromDate || nextProps.ToDate !== this.props.ToDate)) {
	        var dateRange = -1;
	        var FromDate = '1900-01-01';
	        var ToDate = '3000-01-01';
	        if (nextProps.FromDate != null) {
	          FromDate = this.formatDate(nextProps.FromDate);
	        }
	
	        if (nextProps.ToDate != null) {
	          ToDate = this.formatDate(nextProps.ToDate);
	        }
	
	        if (this.props.Days != null) {
	          dateRange = this.props.Days;
	        }
	        if (this.props.voidStatus) {
	          this.props.resetDeleteStatus();
	        }
	        this.props.fetchReceiveHistoryByDate(FromDate, ToDate, dateRange);
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState.PdfFrameLoaded !== this.state.PdfFrameLoaded && this.state.PdfFrameLoaded == false) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	
	    // Set purchaseOrders being selected to be currentReceive and navigate user to the edit page
	
	  }, {
	    key: 'setCurrentReceive',
	    value: function setCurrentReceive(e) {
	      e.preventDefault();
	      var currentReceive = this.state.selectedRows[0];
	      this.props.selectReceive(currentReceive);
	    }
	  }, {
	    key: 'openCreate',
	    value: function openCreate() {
	      this.setState({ createOpen: true });
	    }
	  }, {
	    key: 'closeCreate',
	    value: function closeCreate() {
	      this.setState({ createOpen: false });
	    }
	  }, {
	    key: 'receiveDetail',
	    value: function receiveDetail(e) {
	      e.preventDefault();
	      if (_root_url.isRivera) {
	        this.props.setConfirmPasscodeModalVisibility(true);
	        return;
	      }
	      this.receiveDetailRedirect();
	    }
	  }, {
	    key: 'autoPutaway',
	    value: function autoPutaway(e) {
	      e.preventDefault();
	      var currentReceiveHistory = this.state.selectedRows;
	      var receiveHistory = currentReceiveHistory.map(function (history) {
	        return history.WarehouseReceive_id;
	      });
	      this.props.autoPutaway(receiveHistory);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.fourLineButton });
	    }
	  }, {
	    key: 'clickNew',
	    value: function clickNew(e) {
	      e.preventDefault();
	      // this.props.resetCurrentReceive();
	      this.context.router.push('/inventories/receive/new');
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      return (0, _cleanDates.dateFormat)('YYYY-MM-DD', date);
	      /*
	        let formattedDate = date.getFullYear() + '-';
	         formattedDate += date.getMonth()+1 + '-';
	        if (date.getDate() < 10) {
	          formattedDate += '0' + date.getDate();
	        } else {
	          formattedDate += date.getDate();
	        }
	         return formattedDate;
	      */
	    }
	  }, {
	    key: 'renderTable',
	
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	    value: function renderTable() {
	      var _this2 = this;
	
	      if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.error)
	        )
	      );
	
	      // Parameters of the react-data-grid
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the row select function
	      var onRowSelect = function onRowSelect(rows) {
	        var newRows = getRows();
	        var selectedRows = [].concat(_toConsumableArray(_this2.state.selectedRows));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	          selectedRows.push(r.row);
	        });
	        _this2.setState({ rows: newRows, selectedRows: selectedRows });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = getRows();
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        var selectedRows = [];
	        newRows.forEach(function (row) {
	          row.isSelected && selectedRows.push(row);
	        });
	        _this2.setState({
	          rows: newRows,
	          selectedRows: selectedRows
	        });
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this2.setState(state);
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this2.state.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        _this2.setState({ filters: newFilters });
	      };
	
	      // Handle the editable function
	      var handleRowUpdated = function handleRowUpdated(e) {
	        // merge updated row with current row and rerender by setting state
	        var rows = _this2.state.rows.slice(0);
	        var editedRows = _this2.state.editedRows.slice(0);
	        Object.assign(rows[e.rowIdx], e.updated);
	        // if the element is already edited, remove the old one.
	        editedRows.forEach(function (element, index) {
	          if (element.Product_id === rows[e.rowIdx].Product_id) {
	            editedRows.splice(index, 1);
	          }
	        }, _this2);
	        // push the row into the editedRows array
	        editedRows.push(rows[e.rowIdx]);
	        _this2.setState({
	          rows: rows,
	          editedRows: editedRows
	        });
	      };
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var date = new Date(this.props.value);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var onRowClick = function onRowClick(rowIdx, row) {
	        var newRows = getRows();
	        var selectedRows = [row];
	        newRows.forEach(function (row) {
	          row.isSelected = false;
	        });
	        newRows[rowIdx].isSelected = true;
	        // const onRowSelect = (rows) => {
	        //   this.setState(...this.state, { selectedRows: rows });
	        // };
	        _this2.setState({
	          newRows: newRows,
	          selectedRows: selectedRows
	        });
	
	        if (row) {
	          _this2.setState({
	            WarehouseReceive_id: row.WarehouseReceive_id
	          });
	          _this2.props.fetchReceiveHistoryDetailRecord(row.WarehouseReceive_id, row.Warehouse_ReceiveCompleted_id);
	        }
	      };
	
	      // Column difinition
	      var columns = [{
	        key: 'PONum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }].concat(_toConsumableArray(isUSPride || isATL || isRS ? [{
	        key: 'container_num',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 110
	      }] : []), [{
	        key: 'WarehouseReceiveNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 110
	      }, {
	        key: 'InvoiceNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_vendor' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true
	      }, {
	        key: 'VendorName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 200
	      }, {
	        key: 'PurchaseFinalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'FinalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'InvoiceFinalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'ArrivalStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'arrival_status' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: 'PaymentStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_status' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: 'PostingDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_date' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: DateFormatter,
	        width: 90
	      }, {
	        key: 'Create_Username',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'created_by' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'Modify_Username',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'modify' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }], _toConsumableArray(isUSPride || isATL || isRS ? [] : [{
	        key: 'container_num',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 120
	      }]), [{
	        key: 'Owner',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'owner' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: 'Note',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }]);
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '99%' }, id: 'ReceiveHistoryList-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'WarehouseReceive_id',
	              enableCellSelect: true,
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              columns: columns,
	              rowHeight: 25,
	              headerRowHeight: 45,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: 270,
	              enableRowSelect: 'multi',
	              onRowUpdated: handleRowUpdated,
	              onRowClick: onRowClick
	              // onRowSelect={onRowSelect}
	              , rowSelection: {
	                showCheckbox: true,
	                enableShiftSelect: true,
	                onRowsSelected: onRowSelect,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              }
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDetailTable',
	    value: function renderDetailTable() {
	      var _this3 = this;
	
	      if (this.props.detailIsLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          this.props.error
	        )
	      );
	
	      // Parameters of the react-data-grid
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.receiveHistoryLine);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return Object.assign({}, rows[rowIdx]);
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this3.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this3.setState(state);
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this3.state.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        _this3.setState({ filters: newFilters });
	      };
	
	      // Column difinition
	      var IsFixedFormatter = _react2.default.createClass({
	        displayName: 'IsFixedFormatter',
	        render: function render() {
	          if (this.props.dependentValues.ProductType === 'Non-Fixed') {
	            return _react2.default.createElement(
	              'span',
	              null,
	              this.props.value,
	              ' ',
	              _react2.default.createElement(
	                'label',
	                { className: 'label label-success' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'non_fixed' })
	              )
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            this.props.value
	          );
	        }
	      });
	
	      var columns = [].concat(_toConsumableArray(!isLO ? [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }] : []), _toConsumableArray(isOCM ? [{
	        key: 'WarehouseReceiveLine_id',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'label' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        formatter: function formatter(_ref) {
	          var value = _ref.value;
	
	          return _react2.default.createElement(
	            'span',
	            { style: { cursor: 'pointer' }, onClick: function onClick() {
	                return _this3.handleDownloadLabelClick(value);
	              } },
	            'download'
	          );
	        }
	      }] : []), [{
	        key: 'ProductRefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: isLO ? 160 : 70
	      }, {
	        key: 'ProductName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 250
	      }, {
	        key: 'ProductDescription',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 200
	      }, {
	        key: 'PurchaseLine_Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 60
	      }, {
	        key: 'RcvQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rcv_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        formatter: IsFixedFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'RcvTotalWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_total_wt' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: 'RcvUnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_unit_price' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'RcvTotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_total_price' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 120,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'Pallet',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 60
	      }, {
	        key: 'description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quality' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 150
	      }, {
	        key: 'Remark',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 150
	      }], _toConsumableArray(isLO ? [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }] : []));
	
	      if (isUSPride || isATL || isRS) {
	        var index1 = _lodash2.default.findIndex(columns, { key: "RcvTotalWeight" });
	        columns.splice(index1, 1);
	        var index2 = _lodash2.default.findIndex(columns, { key: "Pallet" });
	        var temp1 = {
	          key: "PackageSize_1",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'volume_cft' }),
	          resizable: true,
	          width: 80,
	          sortable: true
	        };
	        columns.splice(index2, 0, temp1);
	      }
	
	      if (isTN) {
	        columns = [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 100
	        }, {
	          key: 'ProductRefNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 100
	        }, {
	          key: 'ProductName',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 250
	        }, {
	          key: 'ProductDescription',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 200
	        }, {
	          key: 'pallet_barcode',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_barcode' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 150
	        }, {
	          key: 'container_num',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_no' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 120
	        }, {
	          key: 'cpo_num',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cpo_num' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 70
	        }, {
	          key: 'pc_per_box',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pcs_ctn' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 80
	        }, {
	          key: 'box_qty',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ctn_plt' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 80
	        }, {
	          key: 'RcvQuantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_pcs' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 80
	        }];
	      }
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '99%' }, id: 'ReceiveHistoryList-dataGrid2' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'WarehouseReceiveLine_id',
	              enableCellSelect: true,
	              onGridSort: handleGridSort,
	              onAddFilter: handleFilterChange,
	              columns: columns,
	              rowHeight: 25,
	              headerRowHeight: 45,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: this.state.tableHeight / 2
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderIFrame',
	    value: function renderIFrame() {
	      if (this.props.warehouseReceivePdf) {
	        var file = window.URL.createObjectURL(this.props.warehouseReceivePdf);
	        return _react2.default.createElement('iframe', { style: { display: 'none' }, onLoad: this.IFrameIsLoaded, id: 'Pdf', name: 'Pdf', src: file });
	      }
	    }
	  }, {
	    key: 'setDailyDate',
	    value: function setDailyDate(e) {
	      this.setState({ fromDate: e });
	    }
	  }, {
	    key: 'renderDailyReport',
	    value: function renderDailyReport() {
	      var fromDate = this.state.fromDate;
	
	      var outDate = moment(fromDate).format('YYYY-MM-DD');
	      var token = localStorage.getItem('token');
	
	      var url = _root_url.ROOT_URL + 'v1/product/daily_product_report?date=' + outDate + '&query_type=receive&Bearer=' + token;
	      // https://afg-scm.truckxi.com/api/v1/product/daily_product_report?date=2024-12-05&query_type=
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          style: { marginLeft: '20px' },
	          href: url
	          // onClick={() => {
	          //   console.log("test", outDate);
	          // }}
	          , disabled: !this.state.fromDate
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'daily_product_report' })
	      );
	    }
	  }, {
	    key: 'renderPrint',
	    value: function renderPrint() {
	      var _this4 = this;
	
	      // default case where nothing is selected, causing button to be disabled
	      var warehouseReceiveNums = null;
	
	      // case where something is selected
	      if (this.state.selectedRows) {
	        if (this.state.selectedRows.length === 1) {
	          warehouseReceiveNums = this.state.selectedRows[0].WarehouseReceiveNum;
	        } else {
	          var receivingNums = [];
	          this.state.selectedRows.map(function (row) {
	            receivingNums.push(row.WarehouseReceiveNum);
	          });
	          warehouseReceiveNums = receivingNums.join(',');
	        }
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          onClick: function onClick() {
	            _this4.props.printWarehouseReceive(warehouseReceiveNums);
	          },
	          disabled: !warehouseReceiveNums
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	      );
	    }
	  }, {
	    key: 'renderExportButton',
	    value: function renderExportButton() {
	      var days = this.state.Days;
	      var _state = this.state,
	          f = _state.FromDate,
	          t = _state.ToDate;
	
	      days = days || 7;
	
	      var _toFromDates = (0, _cleanDates.toFromDates)(days, f, t),
	          fromDate = _toFromDates.fromDate,
	          toDate = _toFromDates.toDate;
	
	      var params = 'PostingDate__gte=' + fromDate + '&PostingDate__lte=' + toDate;
	      var token = localStorage.getItem('token');
	      var url = _root_url.ROOT_URL + 'v1/warehouse/search/excel?' + params + '&Bearer=' + token;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          href: url
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	      );
	    }
	  }, {
	    key: 'renderExportLinesButton',
	    value: function renderExportLinesButton() {
	      var token = localStorage.getItem('token');
	      var warehouseIds = [];
	      var selectedRows = this.state.selectedRows;
	
	      if (selectedRows && selectedRows.length > 0) {
	        selectedRows.map(function (row) {
	          warehouseIds.push(row.WarehouseReceive_id);
	        });
	      }
	      var url = _root_url.ROOT_URL + 'v1/warehouse/receive-lines-export/' + warehouseIds.join(",") + '?Bearer=' + token;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          href: url,
	          disabled: !warehouseIds || warehouseIds.length < 1
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel_lines' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var createDialogStyle = {
	        width: '600px',
	        marginLeft: '-15%'
	      };
	      var createStatueStyle = {
	        width: '400px',
	        marginLeft: '-15%'
	      };
	      var warehouseReceive_id = this.state.selectedRows && this.state.selectedRows[0] && this.state.selectedRows[0].WarehouseReceive_id;
	      warehouseReceive_id = warehouseReceive_id || '';
	
	      var editRecPermission = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'permission_for_deleting_a_receiving' });
	      var statusModal = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' });
	      var voidStatus = this.props.voidStatus || '';
	      var voidStatusEnd = '';
	      var apNum = 0;
	      if (voidStatus.includes('AP records existed for this warehouse receive (APNum: ')) {
	        apNum = voidStatus.match(/\[(.*?)\]/)[0];
	        var voidStatusAP = 'ap_records_existed_for_this_warehouse_receive_(apnum:_';
	        voidStatusEnd = ')__action_denied_';
	        voidStatus = voidStatusAP;
	      }
	      if (voidStatus && !apNum) {
	        voidStatus = voidStatus.toLowerCase().replace(/\s/g, '_');
	        voidStatus = voidStatus.replace(/\./g, '_');
	        voidStatus = voidStatus.replace(/\'/g, '');
	      }
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receiving' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            null,
	            this.renderExportButton(),
	            isTN && this.renderExportLinesButton()
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'receive-history-list' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { id: 'date-range-picker', className: 'form-horizontal' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 1 },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'filter-title text-nowrap' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_date' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'colon' },
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 11 },
	                      (0, _dateFilterRadios2.default)({
	                        handleOnClick: this.fetchReceiveHistoryByDetails,
	                        setFromDate: this.setFromDate,
	                        setToDate: this.setToDate,
	                        setToRangeSearch: this.setToRangeSearch,
	                        FromDate: this.state.FromDate,
	                        ToDate: this.state.ToDate,
	                        Days: this.state.Days
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'position-relative table-collapse-fix' },
	                  _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    { className: 'table-buttons' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'warning',
	                        type: 'button',
	                        disabled: !this.state.selectedRows || this.state.selectedRows.length !== 1 || !(0, _permissions2.default)('change_receive'),
	                        onClick: this.receiveDetail
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'danger',
	                        type: 'button',
	                        onClick: this.openEditRecPermission,
	                        disabled: !this.state.selectedRows || this.state.selectedRows.length !== 1 || !(0, _permissions2.default)('delete_receive')
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-trash' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'void' })
	                    ),
	                    this.renderPrint(),
	                    isAFG && (0, _GenericDatePicker2.default)({
	                      setDate: this.setDailyDate,
	                      selectedDate: this.state.fromDate,
	                      onChange: function onChange(e) {
	                        _this5.setDailyDate(e);
	                      }
	                    }),
	                    isAFG && this.renderDailyReport()
	                  ),
	                  this.renderTable()
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_details' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'mb0' },
	                  this.renderDetailTable()
	                )
	              )
	            )
	          ),
	          this.renderIFrame(),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            { dialogStyles: createDialogStyle, isVisible: this.state.editRecPermissionOpen, onCloseClicked: function onCloseClicked() {
	                _this5.closeEditRecPermission();
	              }, title: editRecPermission },
	            _react2.default.createElement(_confirmActionModal2.default, {
	              'case': this.state.case,
	              checkPermission: this.props.checkPermission,
	              checkPermissionSuccess: this.props.checkPermissionSuccess
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            { dialogStyles: createStatueStyle, isVisible: this.state.statusOpen, onCloseClicked: function onCloseClicked() {
	                _this5.closeStatusModal();
	              }, title: statusModal },
	            _react2.default.createElement(_confirmActionModal2.default, {
	              'case': this.state.case,
	              voidStatus: voidStatus,
	              voidStatusEnd: voidStatusEnd,
	              apNum: apNum
	            })
	          )
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return ReceiveHistoryList;
	}(_react.Component);
	
	ReceiveHistoryList.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = ReceiveHistoryList;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isTN, 'isTN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveHistoryList.jsx');
	
	  __REACT_HOT_LOADER__.register(isUSPride, 'isUSPride', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveHistoryList.jsx');
	
	  __REACT_HOT_LOADER__.register(isOCM, 'isOCM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveHistoryList.jsx');
	
	  __REACT_HOT_LOADER__.register(isATL, 'isATL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveHistoryList.jsx');
	
	  __REACT_HOT_LOADER__.register(isRS, 'isRS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveHistoryList.jsx');
	
	  __REACT_HOT_LOADER__.register(isLO, 'isLO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveHistoryList.jsx');
	
	  __REACT_HOT_LOADER__.register(isAFG, 'isAFG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveHistoryList.jsx');
	
	  __REACT_HOT_LOADER__.register(ReceiveHistoryList, 'ReceiveHistoryList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveHistoryList.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveHistoryList.jsx');
	}();

	;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _receiveModal = __webpack_require__(595);
	
	var _receiveModal2 = _interopRequireDefault(_receiveModal);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _root_url = __webpack_require__(9);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle} from '../Common/style'
	
	var isTN = _root_url.ROOT_API_URL === "https://tn-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://tn-scm.truckxi.com/api/";
	var isUSPride = _root_url.ROOT_API_URL === "https://uspride-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://uspride-scm.truckxi.com/api/";
	var isATL = _root_url.ROOT_API_URL === 'https://alton-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://alton-scm.truckxi.com/api/';
	var isRS = _root_url.ROOT_API_URL === 'https://redstone-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://redstone-scm.truckxi.com/api/';
	
	var ReceiveList = function (_Component) {
	    _inherits(ReceiveList, _Component);
	
	    function ReceiveList() {
	        _classCallCheck(this, ReceiveList);
	
	        var _this = _possibleConstructorReturn(this, (ReceiveList.__proto__ || Object.getPrototypeOf(ReceiveList)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	            createOpen: false,
	
	            rows: [],
	            selectedRows: [],
	            editedRows: [],
	            filters: {},
	            sortColumn: null,
	            sortDirection: null,
	            gourpOpen: false
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	
	        _this.openCreate = _this.openCreate.bind(_this);
	        _this.closeCreate = _this.closeCreate.bind(_this);
	        _this.receiving = _this.receiving.bind(_this);
	        return _this;
	    }
	
	    _createClass(ReceiveList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            document.title = _root_url.companyCodeTitle;
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchReceives();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once purchaseOrders is ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            if (nextProps.receives && nextProps.receives != this.props.receives) {
	                var receives = nextProps.receives;
	                var newRows = [];
	                if (nextProps.currentReceive) {
	                    this.setState({
	                        selectedRows: nextProps.receives.filter(function (receive) {
	                            return receive.id === _this2.props.currentReceive.id;
	                        }).map(function (receive) {
	                            return _extends({}, receive, { isSelected: true });
	                        })
	                    });
	                }
	                var currentReceiveId = this.props.currentReceive ? this.props.currentReceive.id : null;
	                receives.map(function (receive) {
	                    var newReceive = {};
	
	                    if (receive.Vendor) {
	                        newReceive["VendorNum"] = receive.Vendor.VendorNum;
	                        newReceive["vendorName"] = receive.Vendor.Name;
	                        newReceive["VendorDescription"] = receive.Vendor.Description;
	                    }
	                    if (receive.Purchaser) {
	                        newReceive["Purchaser"] = receive.Purchaser;
	                    }
	                    if (receive.DeliverWarehouse) {
	                        newReceive["WarehouseName"] = receive.DeliverWarehouse.Name;
	                        newReceive["Warehouse_id"] = receive.DeliverWarehouse.Warehouse_id;
	                    }
	                    newReceive['id'] = receive.id;
	                    newReceive["PONum"] = receive.PONum;
	                    newReceive["PurchaseStatus"] = receive.PurchaseStatus;
	                    newReceive["ShippingCost"] = receive.ShippingCost;
	                    newReceive["MiscCost"] = receive.MiscCost;
	                    newReceive["FinalPrice"] = receive.FinalPrice;
	                    newReceive["OrderDate"] = receive.OrderDate;
	                    newReceive["ETADate"] = receive.ETADate;
	                    newReceive["container_num"] = receive.container_num;
	                    newReceive["isSelected"] = receive.id === currentReceiveId;
	                    newReceive["InvoiceNum"] = receive.InvoiceNum;
	                    newReceive["PostingDate"] = receive.PostingDate;
	                    newRows = [].concat(_toConsumableArray(newRows), [newReceive]);
	                });
	                this.setState({
	                    rows: newRows
	                });
	            }
	        }
	    }, {
	        key: 'openCreate',
	        value: function openCreate() {
	            this.setState({ createOpen: true });
	        }
	    }, {
	        key: 'closeCreate',
	        value: function closeCreate() {
	            this.setState({ createOpen: false });
	        }
	    }, {
	        key: 'receiving',
	        value: function receiving(e) {
	            e.preventDefault();
	            var currentReceive = this.state.selectedRows[0];
	            this.props.resetCurrentReceive();
	            this.props.selectReceive(currentReceive);
	            this.context.router.push('/inventories/receive/' + currentReceive.PONum);
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	        }
	
	        // Set purchaseOrders being selected to be currentReceive and navigate user to the edit page
	
	    }, {
	        key: 'setCurrentReceive',
	        value: function setCurrentReceive(e) {
	            e.preventDefault();
	            var currentReceive = this.state.selectedRows[0];
	            this.props.selectReceive(currentReceive);
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            // this.props.resetCurrentReceive();
	            this.context.router.push('/inventories/receive/new');
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this3 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                var _ref, _ref2;
	
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this3.state);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    _this3.setState.apply(_this3, _toConsumableArray(_this3.state).concat([{ selectedRows: rows }]));
	                };
	
	                var onRowsSelected = function onRowsSelected(rows) {
	                    var newRows = [].concat(_toConsumableArray(_this3.state.rows));
	                    var selectedRows = _this3.state.selectedRows;
	
	                    newRows.map(function (r) {
	                        r.isSelected = false;
	                    });
	
	                    rows.map(function (row) {
	                        var index = _lodash2.default.findIndex(_this3.state.rows, { 'id': row.row.id });
	                        newRows[index].isSelected = true;
	                        selectedRows.push(row.row);
	                    });
	
	                    _this3.setState({ rows: newRows, selectedRows: selectedRows, selectedRowsIdx: rows[0].rowIdx });
	                };
	
	                var onRowsDeselected = function onRowsDeselected(rows) {
	                    var newRows = [].concat(_toConsumableArray(_this3.state.rows));
	                    rows.map(function (row) {
	                        var index = _lodash2.default.findIndex(_this3.state.rows, { 'id': row.row.id });
	                        newRows[index].isSelected = false;
	                    });
	                    var selectedRows = [];
	                    newRows.map(function (r) {
	                        if (r.isSelected) {
	                            selectedRows.push(r);
	                        }
	                    });
	                    _this3.setState({ rows: newRows, selectedRows: selectedRows });
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this3.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this3.setState(state);
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this3.state.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    _this3.setState({ filters: newFilters });
	                };
	
	                // Handle the editable function
	
	                var handleRowUpdated = function handleRowUpdated(e) {
	                    // merge updated row with current row and rerender by setting state
	                    var rows = _this3.state.rows.slice(0);
	                    var editedRows = _this3.state.editedRows.slice(0);
	                    Object.assign(rows[e.rowIdx], e.updated);
	                    // if the element is already edited, remove the old one.
	                    editedRows.forEach(function (element, index) {
	                        if (element.Product_id === rows[e.rowIdx].Product_id) editedRows.splice(index, 1);
	                    }, _this3);
	                    // push the row into the editedRows array
	                    editedRows.push(rows[e.rowIdx]);
	                    _this3.setState({
	                        rows: rows,
	                        editedRows: editedRows
	                    });
	                };
	
	                //Custom Formatter component
	                var IsEnabledFormatter = _react2.default.createClass({
	                    displayName: 'IsEnabledFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-success' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disable' })
	                        );
	                    }
	                });
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'VendorNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_no' }),
	                    resizable: true,
	                    width: 95,
	                    sortable: true,
	                    filterable: true
	                }, (_ref = {
	                    key: 'vendorName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                    resizable: true,
	                    width: 180,
	                    sortable: true
	                }, _defineProperty(_ref, 'width', 180), _defineProperty(_ref, 'filterable', true), _ref), {
	                    key: 'VendorDescription',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	                    resizable: true,
	                    width: 95,
	                    sortable: true,
	                    filterable: true
	                }].concat(_toConsumableArray(isUSPride || isATL || isRS ? [{
	                    key: 'container_num',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_no' }),
	                    resizable: true,
	                    width: 95,
	                    sortable: true,
	                    filterable: true
	                }] : []), [{
	                    key: 'PONum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' }),
	                    resizable: true,
	                    width: 95,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'PurchaseStatus',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_status' }),
	                    resizable: true,
	                    width: 95,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'Purchaser',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchaser' }),
	                    resizable: true,
	                    width: 95,
	                    sortable: true,
	                    filterable: false
	                }, {
	                    key: 'WarehouseName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_to' }),
	                    resizable: true,
	                    width: 95,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'ShippingCost',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_dollarsign' }),
	                    resizable: true,
	                    width: 95,
	                    sortable: true,
	                    filterable: true,
	                    formatter: _cashFormatter2.default
	                }, {
	                    key: 'MiscCost',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'misc_dollarsign' }),
	                    resizable: true,
	                    width: 80,
	                    sortable: true,
	                    filterable: true,
	                    formatter: _cashFormatter2.default
	                }, {
	                    key: 'FinalPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	                    resizable: true,
	                    width: 80,
	                    sortable: true,
	                    filterable: true,
	                    formatter: _cashFormatter2.default
	                }, {
	                    key: 'OrderDate',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_date' }),
	                    resizable: true,
	                    width: 100,
	                    sortable: true,
	                    filterable: true,
	                    formatter: DateFormatter
	                }, {
	                    key: 'ETADate',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_date' }),
	                    resizable: true,
	                    width: 100,
	                    sortable: true,
	                    filterable: true,
	                    formatter: DateFormatter
	                }]);
	
	                if (_root_url.isLO) {
	                    columns.push({
	                        key: 'InvoiceNum',
	                        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_invoice_no' }),
	                        resizable: true,
	                        width: 100,
	                        sortable: true,
	                        filterable: true
	                    }, {
	                        key: 'PostingDate',
	                        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_date' }),
	                        resizable: true,
	                        width: 100,
	                        sortable: true,
	                        filterable: true,
	                        formatter: DateFormatter
	                    });
	                }
	
	                var columnsTN = [{
	                    key: 'VendorNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_no' }),
	                    resizable: true,
	                    width: 95,
	                    sortable: true,
	                    filterable: true
	                }, (_ref2 = {
	                    key: 'vendorName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                    resizable: true,
	                    width: 180,
	                    sortable: true
	                }, _defineProperty(_ref2, 'width', 180), _defineProperty(_ref2, 'filterable', true), _ref2), {
	                    key: 'VendorDescription',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	                    resizable: true,
	                    width: 95,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'PONum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' }),
	                    resizable: true,
	                    width: 95,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'container_num',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_no' }),
	                    resizable: true,
	                    width: 120,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'PurchaseStatus',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_status' }),
	                    resizable: true,
	                    width: 95,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'Purchaser',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchaser' }),
	                    resizable: true,
	                    width: 95,
	                    sortable: true,
	                    filterable: false
	                }, {
	                    key: 'WarehouseName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_to' }),
	                    resizable: true,
	                    width: 95,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'ShippingCost',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_dollarsign' }),
	                    resizable: true,
	                    width: 95,
	                    sortable: true,
	                    filterable: true,
	                    formatter: _cashFormatter2.default
	                }, {
	                    key: 'MiscCost',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'misc_dollarsign' }),
	                    resizable: true,
	                    width: 80,
	                    sortable: true,
	                    filterable: true,
	                    formatter: _cashFormatter2.default
	                }, {
	                    key: 'FinalPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	                    resizable: true,
	                    width: 80,
	                    sortable: true,
	                    filterable: true,
	                    formatter: _cashFormatter2.default
	                }, {
	                    key: 'OrderDate',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_date' }),
	                    resizable: true,
	                    width: 100,
	                    sortable: true,
	                    filterable: true,
	                    formatter: DateFormatter
	                }, {
	                    key: 'ETADate',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_date' }),
	                    resizable: true,
	                    width: 100,
	                    sortable: true,
	                    filterable: true,
	                    formatter: DateFormatter
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '100%' }, id: 'ReceiveList-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'PONum',
	                                enableCellSelect: true,
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: isTN ? columnsTN : columns,
	                                headerRowHeight: 45,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                rowHeight: 25,
	                                minHeight: 685,
	                                enableRowSelect: 'single',
	                                onRowUpdated: handleRowUpdated,
	                                onRowSelect: onRowSelect,
	                                rowSelection: {
	                                    showCheckbox: true,
	                                    onRowsSelected: onRowsSelected,
	                                    onRowsDeselected: onRowsDeselected,
	                                    selectBy: {
	                                        isSelectedKey: 'isSelected'
	                                    }
	                                }
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var createDialogStyle = {
	                width: '400px',
	                marginLeft: '-10%'
	            };
	            return (
	                //---------------
	                // Begin HTML
	                //---------------
	                _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_management' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            { active: 'true' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_receiving' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Grid,
	                        { id: 'receive-list' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { className: 'position-relative table-collapse-fix' },
	                            _react2.default.createElement(
	                                _reactBootstrap.ButtonToolbar,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        bsStyle: 'success',
	                                        disabled: !this.state.selectedRows || this.state.selectedRows.length != 1 || !(0, _permissions2.default)("add_receive"),
	                                        onClick: this.receiving },
	                                    _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_receiving' })
	                                )
	                            ),
	                            this.renderTable()
	                        )
	                    )
	                )
	                //---------------
	                // End HTML
	                //---------------
	
	            );
	        }
	    }]);
	
	    return ReceiveList;
	}(_react.Component);
	
	ReceiveList.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = ReceiveList;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(isTN, 'isTN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveList.jsx');
	
	    __REACT_HOT_LOADER__.register(isUSPride, 'isUSPride', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveList.jsx');
	
	    __REACT_HOT_LOADER__.register(isATL, 'isATL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveList.jsx');
	
	    __REACT_HOT_LOADER__.register(isRS, 'isRS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveList.jsx');
	
	    __REACT_HOT_LOADER__.register(ReceiveList, 'ReceiveList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveList.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveList.jsx');
	}();

	;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style'
	
	var renderInputField = function renderInputField(props) {
	    var inputClass = (0, _classnames2.default)({ 'parsley-error': props.meta.touched && props.meta.error }, 'form-control');
	    return _react2.default.createElement(
	        'div',
	        null,
	        props.meta.touched && props.meta.error && _react2.default.createElement(
	            'span',
	            { className: 'parsley-error-message' },
	            props.meta.error
	        ),
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { className: inputClass, type: 'text' }))
	    );
	};
	
	var ReceiveModal = function (_Component) {
	    _inherits(ReceiveModal, _Component);
	
	    function ReceiveModal() {
	        _classCallCheck(this, ReceiveModal);
	
	        return _possibleConstructorReturn(this, (ReceiveModal.__proto__ || Object.getPrototypeOf(ReceiveModal)).apply(this, arguments));
	    }
	
	    _createClass(ReceiveModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.fetchPurchaseOrders();
	        }
	    }, {
	        key: 'handleFormSubmit',
	        value: function handleFormSubmit(formProps) {
	            this.setPurchaseOrder(formProps.PurchaseOrder_id.value);
	        }
	    }, {
	        key: 'setPurchaseOrder',
	        value: function setPurchaseOrder(id) {
	            var _props = this.props,
	                resetCurrentPurchaseOrder = _props.resetCurrentPurchaseOrder,
	                purchaseOrders = _props.purchaseOrders,
	                selectPurchaseOrder = _props.selectPurchaseOrder;
	
	            resetCurrentPurchaseOrder();
	            if (id) {
	                var index = _lodash2.default.findIndex(purchaseOrders, { 'PurchaseOrder_id': id });
	                selectPurchaseOrder(purchaseOrders[index]);
	                // this.context.router.push('/purchaseReturn/'+purchaseOrders[index].PurchaseOrder_id);
	            }
	            this.context.router.push('/inventories/receive/new');
	        }
	    }, {
	        key: 'renderPurchaseOrders',
	        value: function renderPurchaseOrders() {
	            if (this.props.isLoading) return _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 12, className: 'marginTopStyle' },
	                _react2.default.createElement(_spinner2.default, null)
	            ); // If group is loading, show a spinner.
	            else {
	                    var purchaseOrderOptions = this.getPurchaseOrderOptions();
	                    return _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12, className: 'marginTopStyle' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'centerStyle' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_a_purchase_order' })
	                        ),
	                        _react2.default.createElement(_reduxForm.Field, { name: 'PurchaseOrder_id', component: _selection2.default, options: purchaseOrderOptions })
	                    );
	                }
	        }
	    }, {
	        key: 'getPurchaseOrderOptions',
	        value: function getPurchaseOrderOptions() {
	            var purchaseOrderOptions = [];
	            this.props.purchaseOrders.map(function (purchaseOrder) {
	                purchaseOrderOptions.push({ value: purchaseOrder.PurchaseOrder_id, label: purchaseOrder.PONum });
	            });
	            return purchaseOrderOptions;
	        }
	
	        // Once User choose a Order, show him some detail
	
	    }, {
	        key: 'renderOrderDetail',
	        value: function renderOrderDetail(id) {
	            var purchaseOrders = this.props.purchaseOrders;
	
	            var index = _lodash2.default.findIndex(purchaseOrders, { 'PurchaseOrder_id': id });
	            if (index > -1) {
	                var vendorName = purchaseOrders[index].Vendor_id.Name;
	                var updateTime = purchaseOrders[index].UpdateTime;
	                var PONum = purchaseOrders[index].PONum;
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_order_no' }),
	                            ': ',
	                            PONum
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_name' }),
	                            ': ',
	                            vendorName
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'update_time' }),
	                            ': ',
	                            updateTime
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                handleSubmit = _props2.handleSubmit,
	                closeC = _props2.closeC,
	                submitting = _props2.submitting,
	                pristine = _props2.pristine,
	                purchaseOrderValue = _props2.purchaseOrderValue;
	
	            return _react2.default.createElement(
	                'form',
	                { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    this.renderPurchaseOrders()
	                ),
	                purchaseOrderValue && this.renderOrderDetail(purchaseOrderValue.value),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { action: 'submit', className: 'btn btn-primary col-sm-11 buttonStyle', disabled: submitting },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_a_purchase_order' })
	                    )
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-danger col-sm-11 buttonStyle', onClick: function onClick(event) {
	                                event.preventDefault();closeC();
	                            } },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReceiveModal;
	}(_react.Component);
	
	ReceiveModal.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = ReceiveModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(renderInputField, 'renderInputField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveModal.jsx');
	
	    __REACT_HOT_LOADER__.register(ReceiveModal, 'ReceiveModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/receiveModal.jsx');
	}();

	;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _inputField = __webpack_require__(16);
	
	var _selection = __webpack_require__(21);
	
	var _datePicker = __webpack_require__(27);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style'
	
	
	var ScrapRecordForm = function (_Component) {
	    _inherits(ScrapRecordForm, _Component);
	
	    function ScrapRecordForm() {
	        _classCallCheck(this, ScrapRecordForm);
	
	        var _this = _possibleConstructorReturn(this, (ScrapRecordForm.__proto__ || Object.getPrototypeOf(ScrapRecordForm)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	            inventories: {
	                rows: [],
	                selectedRows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            scrappedInventories: {
	                rows: [],
	                selectedRows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            }
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        return _this;
	    }
	
	    _createClass(ScrapRecordForm, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchProducts();
	            if (this.props.currentScrapRecord) {
	                this.props.fetchScrapRecordDetail(this.props.currentScrapRecord.WarehouseScrap_id);
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once inventories are ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.currentScrapRecordDetail && nextProps.currentScrapRecordDetail != this.props.currentScrapRecordDetail) {
	                var newScrappedInventories = nextProps.currentScrapRecordDetail.Warehouse_Scrap_Line;
	                newScrappedInventories.map(function (newScrappedInventory) {
	                    var Batch_PONum = newScrappedInventory.Batch_PONum;
	                    var ProductNum = newScrappedInventory.ProductNum;
	                    var WarehouseZone_id = newScrappedInventory.WarehouseZone_id.WarehouseZone_id;
	                    var WarehouseBin_id = newScrappedInventory.WarehouseBin_id.WarehouseBin_id;
	                    var id = Batch_PONum + ProductNum + WarehouseZone_id + WarehouseBin_id;
	                    newScrappedInventory["Inventory_id"] = id;
	                    newScrappedInventory["ZoneName"] = newScrappedInventory.WarehouseZone_id.Name;
	                    newScrappedInventory["BinName"] = newScrappedInventory.WarehouseBin_id.Name;
	                    newScrappedInventory["WarehouseZone_id"] = WarehouseZone_id;
	                    newScrappedInventory["WarehouseBin_id"] = WarehouseBin_id;
	                });
	                var scrappedInventories = _extends({}, this.state.scrappedInventories, {
	                    rows: newScrappedInventories });
	                this.setState({
	                    scrappedInventories: scrappedInventories
	                });
	            }
	            if (nextProps.scrapRecordsInventories && nextProps.scrapRecordsInventories != this.props.scrapRecordsInventories) {
	                var newInventories = nextProps.scrapRecordsInventories;
	                newInventories.map(function (newInventory) {
	                    var Batch_PONum = newInventory.Batch_PONum;
	                    var ProductNum = newInventory.ProductNum;
	                    var WarehouseZone_id = newInventory.WarehouseZone_id.WarehouseZone_id;
	                    var WarehouseBin_id = newInventory.WarehouseBin_id.WarehouseBin_id;
	                    var id = Batch_PONum + ProductNum + WarehouseZone_id + WarehouseBin_id;
	                    newInventory["Inventory_id"] = id;
	                    newInventory["ZoneName"] = newInventory.WarehouseZone_id.Name;
	                    newInventory["BinName"] = newInventory.WarehouseBin_id.Name;
	                    newInventory["WarehouseZone_id"] = WarehouseZone_id;
	                    newInventory["WarehouseBin_id"] = WarehouseBin_id;
	                });
	                var inventories = _extends({}, this.state.inventories, { rows: newInventories });
	                this.setState({
	                    inventories: inventories
	                });
	            }
	            if (nextProps.productValue != this.props.productValue) {
	                this.props.fetchInventoryScrap(nextProps.productValue.value || nextProps.productValue);
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	        }
	    }, {
	        key: 'renderHeader',
	        value: function renderHeader() {
	            var header = this.props.currentScrapRecordDetail ? "edit_scrap_record" : "new_scrap_record";
	            return _react2.default.createElement(
	                _reactBootstrap.Breadcrumb,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Breadcrumb.Item,
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_management' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Breadcrumb.Item,
	                    { active: 'true' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: header })
	                )
	            );
	        }
	    }, {
	        key: 'setInventoryToScrap',
	        value: function setInventoryToScrap(e) {
	            e.preventDefault();
	            var _state = this.state,
	                inventories = _state.inventories,
	                scrappedInventories = _state.scrappedInventories;
	
	            var inventoryToLocate = _extends({}, inventories.selectedRows[0], {
	                // ToZone: this.props.toZoneValue,
	                // ToBin: this.props.toBinValue,
	                Quantity: this.props.quantityValue
	                // newQuantity: inventories.selectedRows[0].Quantity + this.props.quantityValue
	                // NewQuantity: this.props.quantityValue,
	                // Product_id:
	            });
	
	            var newScrappedInventories = _extends({}, scrappedInventories);
	            // const newInventories = { ...inventories };
	            newScrappedInventories.rows.push(inventoryToLocate);
	
	            // const index = _.findIndex(inventories.rows, { 'Inventory_id': inventories.selectedRows[0].Inventory_id });
	            // if (index > -1) {
	            //     newInventories.rows.splice(index, 1);
	            // }
	            // newInventories.selectedRows = [];
	            this.setState({
	                scrappedInventories: newScrappedInventories
	            });
	        }
	    }, {
	        key: 'cancelScrapRecord',
	        value: function cancelScrapRecord(e) {
	            e.preventDefault();
	            var _state2 = this.state,
	                inventories = _state2.inventories,
	                scrappedInventories = _state2.scrappedInventories;
	
	            var inventoryToCancel = _extends({}, scrappedInventories.selectedRows[0]);
	
	            var newScrappedInventories = _extends({}, scrappedInventories);
	            // const newInventories = { ...inventories };
	            // newInventories.rows.push(inventoryToCancel)
	
	            var index = _lodash2.default.findIndex(scrappedInventories.rows, { 'Inventory_id': scrappedInventories.selectedRows[0].Inventory_id });
	            if (index > -1) {
	                newScrappedInventories.rows.splice(index, 1);
	            }
	            newScrappedInventories.selectedRows = [];
	            this.setState({
	                scrappedInventories: newScrappedInventories
	            });
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this2 = this;
	
	            if (this.props.vendorIsLoading && !this.props.vendorError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.vendorError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    this.props.vendorError
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.inventories);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var inventories = _extends({}, _this2.state.inventories, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this2.setState({ inventories: inventories });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this2.state.inventories.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var inventories = _extends({}, _this2.state.inventories, { filters: newFilters });
	                    _this2.setState({ inventories: inventories });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var inventories = _extends({}, _this2.state.inventories, { selectedRows: rows });
	                    _this2.setState({ inventories: inventories });
	                };
	
	                //Custom Formatter component
	
	                var NameFormatter = _react2.default.createClass({
	                    displayName: 'NameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [
	                // {
	                //     key: 'ProductNum',
	                //     name: 'No.',
	                //     resizable: true,
	                //     sortable: true,
	                //     filterable: true
	                // },
	                {
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 130,
	                    filterable: true
	                }, {
	                    key: 'ProductDescription',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120,
	                    filterable: true
	                }, {
	                    key: 'ProductUnitOfMeasure',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mm_unit' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 225,
	                    filterable: true
	                }, {
	                    key: 'ExpiredDate',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'expired_date' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 140,
	                    filterable: true,
	                    formatter: DateFormatter
	                }, {
	                    key: 'Pallet',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 70,
	                    filterable: true
	                }, {
	                    key: 'ZoneName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_name' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'BinName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin_name' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'BinAmount',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin_amount' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'Batch_PONum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '100%' }, id: 'ScrapRecordForm-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'Inventory_id',
	                                onGridSort: handleGridSort,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                rowHeight: 25,
	                                minHeight: 300,
	                                enableRowSelect: 'single',
	                                onRowUpdated: this.handleRowUpdated,
	                                onRowSelect: onRowSelect })
	                        )
	                    )
	                );
	            }
	        }
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderScrappedTable',
	        value: function renderScrappedTable() {
	            var _this3 = this;
	
	            if (this.props.vendorIsLoading && !this.props.vendorError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.vendorError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    this.props.vendorError
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.scrappedInventories);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var scrappedInventories = _extends({}, _this3.state.scrappedInventories, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this3.setState({ scrappedInventories: scrappedInventories });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this3.state.scrappedInventories.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var scrappedInventories = _extends({}, _this3.state.scrappedInventories, { filters: newFilters });
	                    _this3.setState({ scrappedInventories: scrappedInventories });
	                };
	
	                // Handle the Dragable cell function
	
	                var handleCellDrag = function handleCellDrag(e) {
	                    var scrappedInventories = _this3.state.scrappedInventories;
	
	                    var rows = scrappedInventories.rows.slice(0);
	                    for (var i = e.fromRow; i <= e.toRow; i++) {
	                        var rowToUpdate = rows[i];
	                        rowToUpdate[e.cellKey] = e.value;
	                    }
	                    var newScrappedInventories = _extends({}, scrappedInventories, { rows: rows });
	                    _this3.setState({
	                        scrappedInventories: newScrappedInventories
	                    });
	                };
	
	                // Handle the editable function
	
	                var handleRowUpdated = function handleRowUpdated(e) {
	                    // merge updated row with current row and rerender by setting state
	                    var scrappedInventories = _this3.state.scrappedInventories;
	
	                    var rows = scrappedInventories.rows.slice(0);
	                    Object.assign(rows[e.rowIdx], e.updated);
	                    var newScrappedInventories = _extends({}, scrappedInventories, { rows: rows });
	                    _this3.setState({
	                        scrappedInventories: newScrappedInventories
	                    });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var scrappedInventories = _extends({}, _this3.state.scrappedInventories, { selectedRows: rows });
	                    _this3.setState({ scrappedInventories: scrappedInventories });
	                };
	
	                //Custom Formatter component
	
	                var NameFormatter = _react2.default.createClass({
	                    displayName: 'NameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                    resizable: true,
	                    width: 230,
	                    filterable: true
	                }, {
	                    key: 'Quantity',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'scrap_qty' }),
	                    resizable: true,
	                    width: 100,
	                    filterable: true,
	                    editable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '100%' }, id: 'ScrapRecordForm-dataGrid2' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'Inventory_id',
	                                onGridSort: handleGridSort,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                rowHeight: 25,
	                                minHeight: 200,
	                                enableRowSelect: 'single',
	                                onCellsDragged: handleCellDrag,
	                                enableCellSelect: true,
	                                onRowUpdated: handleRowUpdated,
	                                onRowSelect: onRowSelect })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'getProductNumOptions',
	        value: function getProductNumOptions() {
	            var productNumOptions = [];
	            this.props.products.map(function (product) {
	                productNumOptions.push({ value: product.ProductNum, label: product.Name });
	            });
	            return productNumOptions;
	        }
	    }, {
	        key: 'handleFormSubmit',
	        value: function handleFormSubmit(formProps) {
	            if (this.props.currentScrapRecord) {
	                if (!(0, _permissions2.default)("change_warehouse_scrap")) this.props.editScrapRecord(this.props.currentScrapRecord.WarehouseScrap_id, formProps, 1, _reactDataGridAddons.Data.Selectors.getRows(this.state.scrappedInventories));else alert("You have no permission!");
	            } else this.props.createScrapRecord(formProps, 1, _reactDataGridAddons.Data.Selectors.getRows(this.state.scrappedInventories));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var inventoryScrapWarehouseLoc = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_scrap_warehouse_location' });
	            var inventoryScrapSheetWarehouseloc = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_scrap_sheet_warehouse_location' });
	            var _state3 = this.state,
	                inventories = _state3.inventories,
	                scrappedInventories = _state3.scrappedInventories;
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                submitting = _props.submitting,
	                pristine = _props.pristine;
	
	            var productNumOptions = this.getProductNumOptions();
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                this.renderHeader(),
	                _react2.default.createElement(
	                    _reactBootstrap.Grid,
	                    { id: 'inventory-scrap-form' },
	                    _react2.default.createElement(
	                        'form',
	                        { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            { id: 'breadcrumbButtonGroup' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { onClick: function onClick() {
	                                        _this4.context.router.push('/scrapRecords');
	                                    }, bsStyle: 'danger' },
	                                _react2.default.createElement('em', { className: 'fa fa-close' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { bsStyle: 'success', type: 'submit' },
	                                _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'marginTopStyle' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Panel,
	                                { id: 'scrap-select-product' },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-6' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-sm-4 inlineLabel' },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_a_product_to_scrap' }),
	                                            ' ',
	                                            _react2.default.createElement(
	                                                'span',
	                                                { style: { color: 'red' } },
	                                                '*'
	                                            ),
	                                            ' '
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(_reduxForm.Field, { name: 'ProductNum', component: _selection.Selection, options: productNumOptions })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-offset-3 col-sm-3' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-sm-6 inlineLabel' },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'scrap_date' }),
	                                            ' ',
	                                            _react2.default.createElement(
	                                                'span',
	                                                { style: { color: 'red' } },
	                                                '*'
	                                            ),
	                                            ' '
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(_reduxForm.Field, { name: 'PostingDate', selected: new Date(), component: _datePicker.DisabledDatePicker })
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'marginTopStyle' },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_inventory_to_scrap' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Panel,
	                                { id: 'scrap-select-inventory' },
	                                this.renderTable()
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6, className: 'pl0' },
	                                _react2.default.createElement(
	                                    'h2',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'scrap_product_details' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { id: 'scrap-product-details' },
	                                    _react2.default.createElement(
	                                        'h4',
	                                        null,
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'scrapping' })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            'p',
	                                            null,
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_enter_scrap_amount_and_inventory_will_be_updated' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-sm-7 mb' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                _react2.default.createElement(_reduxForm.Field, { component: _inputField.DisabledInputField, placeholder: inventories.selectedRows[0] && inventories.selectedRows[0].ProductName })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-sm-offset-1 col-sm-3 mb' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'scrap_amount' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                _react2.default.createElement(_reduxForm.Field, { component: _inputField.InputField, name: 'Quantity' })
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                inventories.selectedRows[0] && parseInt(this.props.quantityValue) > parseInt(inventories.selectedRows[0].BinAmount) && _react2.default.createElement(
	                                                    'p',
	                                                    { className: 'parsley-error-message' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_scrap_qty_cannot_exceed_current_qty' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-sm-1 scrap-amount mb' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Button,
	                                                {
	                                                    bsStyle: 'primary',
	                                                    onClick: function onClick(e) {
	                                                        return _this4.setInventoryToScrap(e);
	                                                    },
	                                                    disabled: !inventories.selectedRows[0] },
	                                                _react2.default.createElement('em', { className: 'fa fa-share' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-sm-4 mb' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	                                                    ' (',
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' }),
	                                                    ')'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                inventories.selectedRows[0] ? inventories.selectedRows[0].Batch_PONum : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_inventory' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-sm-4 mb' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'in_stock' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                inventories.selectedRows[0] ? inventories.selectedRows[0].BinAmount : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_inventory' })
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6, className: 'pr0' },
	                                _react2.default.createElement(
	                                    'h2',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'scrap_record' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { id: 'scrap-record' },
	                                    this.renderScrappedTable(),
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            className: 'btn btn-warning pull-right marginTopStyle',
	                                            onClick: function onClick(e) {
	                                                return _this4.cancelScrapRecord(e);
	                                            },
	                                            disabled: !scrappedInventories.selectedRows[0] },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ScrapRecordForm;
	}(_react.Component);
	
	ScrapRecordForm.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = ScrapRecordForm;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(ScrapRecordForm, 'ScrapRecordForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/scrapRecordForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/scrapRecordForm.jsx');
	}();

	;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle} from '../Common/style'
	
	var ScrapRecords = function (_Component) {
	    _inherits(ScrapRecords, _Component);
	
	    function ScrapRecords() {
	        _classCallCheck(this, ScrapRecords);
	
	        var _this = _possibleConstructorReturn(this, (ScrapRecords.__proto__ || Object.getPrototypeOf(ScrapRecords)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	            rows: [],
	            selectedRows: null,
	            editedRows: [],
	            filters: {},
	            sortColumn: null,
	            sortDirection: null,
	            gourpOpen: false
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        return _this;
	    }
	
	    _createClass(ScrapRecords, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchScrapRecords();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once scrapRecords is ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var PT = nextProps.scrapRecords;
	            if (nextProps.scrapRecords && nextProps.scrapRecords != this.props.scrapRecords) {
	                this.setState({
	                    rows: nextProps.scrapRecords
	                });
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	        }
	
	        // Set scrapRecords being selected to be currentScrapRecord and navigate user to the edit page
	
	    }, {
	        key: 'setCurrentScrapRecord',
	        value: function setCurrentScrapRecord(e) {
	            e.preventDefault();
	            var currentScrapRecord = this.state.selectedRows[0];
	            this.props.selectScrapRecord(currentScrapRecord);
	            this.context.router.push('/scrapRecords/' + currentScrapRecord.WarehouseScrapNum);
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            this.props.resetCurrentScrapRecord();
	            this.context.router.push('/scrapRecords/new');
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this2 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this2.setState(state);
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this2.state.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    _this2.setState({ filters: newFilters });
	                };
	
	                var onRowSelect = function onRowSelect(rows) {
	                    _this2.setState({ selectedRows: rows });
	                };
	
	                // Handle the editable function
	
	                var handleRowUpdated = function handleRowUpdated(e) {
	                    // merge updated row with current row and rerender by setting state
	                    var rows = _this2.state.rows.slice(0);
	                    var editedRows = _this2.state.editedRows.slice(0);
	                    Object.assign(rows[e.rowIdx], e.updated);
	                    // if the element is already edited, remove the old one.
	                    editedRows.forEach(function (element, index) {
	                        if (element.Product_id === rows[e.rowIdx].Product_id) editedRows.splice(index, 1);
	                    }, _this2);
	                    // push the row into the editedRows array
	                    editedRows.push(rows[e.rowIdx]);
	                    _this2.setState({
	                        rows: rows,
	                        editedRows: editedRows
	                    });
	                };
	
	                //Custom Formatter component
	                var IsEnabledFormatter = _react2.default.createClass({
	                    displayName: 'IsEnabledFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-success' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disable' })
	                        );
	                    }
	                });
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var columns = [{
	                    key: 'WarehouseScrapNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'record_scrap_no' }),
	                    resizable: true,
	                    width: 155,
	                    sortable: true,
	                    filterable: true,
	                    locked: true
	                }, {
	                    key: 'CreateTime',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_time' }),
	                    resizable: true,
	                    width: 110,
	                    sortable: true,
	                    filterable: true,
	                    formatter: DateFormatter
	                }, {
	                    key: 'PostingDate',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'adjustment_date' }),
	                    resizable: true,
	                    width: 150,
	                    sortable: true,
	                    filterable: true,
	                    formatter: DateFormatter
	                }, {
	                    key: 'Modify_Username',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'modifier' }),
	                    resizable: true,
	                    width: 110,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'Note',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	                    resizable: true,
	                    width: 120,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'Completed',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'completed' }),
	                    resizable: true,
	                    width: 110,
	                    sortable: true,
	                    filterable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'ScrapRecords-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'WarehouseScrapNum',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowHeight: 25,
	                                minHeight: 685,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                onRowUpdated: handleRowUpdated,
	                                enableRowSelect: 'single',
	                                onRowSelect: onRowSelect
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Breadcrumb,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb.Item,
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_management' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb.Item,
	                        { active: 'true' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_scrap' })
	                    )
	                ),
	                ' ',
	                _react2.default.createElement(
	                    _reactBootstrap.Grid,
	                    { fluid: 'true', id: 'inventory-scrap' },
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        { className: 'table-buttons' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            { bsStyle: 'success', onClick: function onClick(e) {
	                                    return _this3.clickNew(e);
	                                }, disabled: !(0, _permissions2.default)("add_warehouse_scrap") },
	                            _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            { bsStyle: 'warning', disabled: !this.state.selectedRows || this.state.selectedRows.length != 1 || !(0, _permissions2.default)("change_warehouse_scrap"), onClick: function onClick(e) {
	                                    return _this3.setCurrentScrapRecord(e);
	                                } },
	                            _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        { id: 'inventory-scrap-full-table' },
	                        this.renderTable()
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ScrapRecords;
	}(_react.Component);
	
	ScrapRecords.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = ScrapRecords;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(ScrapRecords, 'ScrapRecords', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/scrapRecords.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/scrapRecords.jsx');
	}();

	;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _inputField = __webpack_require__(16);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _constants = __webpack_require__(11);
	
	var _confirmModal = __webpack_require__(170);
	
	var _confirmModal2 = _interopRequireDefault(_confirmModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SetWeightModal = function (_Component) {
	  _inherits(SetWeightModal, _Component);
	
	  function SetWeightModal() {
	    _classCallCheck(this, SetWeightModal);
	
	    var _this = _possibleConstructorReturn(this, (SetWeightModal.__proto__ || Object.getPrototypeOf(SetWeightModal)).call(this));
	
	    _this.handleImportOnClick = function () {
	      var _this$props = _this.props,
	          importLine = _this$props.importLine,
	          rows = _this$props.rows;
	
	      var weights = [];
	      if (importLine.match(/^[0-9]*\.?[0-9]+( [0-9]*\.?[0-9]+)*$/)) {
	        var tempWeights = importLine.split(' ');
	        tempWeights.map(function (weight) {
	          weights.push({ Weight: parseFloat(weight).toFixed(2) });
	        });
	      }
	      if (rows && rows.length !== weights.length) {
	        alert('Import quantity does not match with receiving quantity, please check your import.');
	      } else {
	        _this.setState({
	          weights: {
	            rows: weights
	          }
	        });
	      }
	    };
	
	    _this.handleKeyPress = function (event) {
	      if (event.charCode == 13 && _this.state.selectedWeight) {
	        event.preventDefault();
	        //ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	        var weights = _extends({}, _this.state.weights);
	
	        if (_this.state.selectedWeightIdx === _this.state.weights.rows.length) {
	          weights.rows[_this.state.selectedWeightIdx - 1].Weight = _this.state.selectedWeight;
	          _this.setState({ selectedWeight: '', selectedWeightIdx: 0, weights: weights });
	        } else if (_this.state.selectedWeightIdx) {
	          weights.rows[_this.state.selectedWeightIdx - 1].Weight = _this.state.selectedWeight;
	          _this.setState({ selectedWeight: '', selectedWeightIdx: _this.state.selectedWeightIdx + 1, weights: weights });
	        } else {
	          _this.setState({ selectedWeight: '', selectedWeightIdx: _this.state.selectedWeightIdx + 1 }, function () {
	            _this.props.setRows(_this.props.rowChosen, _this.props.tableChosen, _this.state.weights.rows);_this.props.closeC();
	          });
	        }
	      } else if (event.charCode == 13 && _this.state.selectedWeightIdx === 0) {
	        _this.setState({ selectedWeight: '', selectedWeightIdx: _this.state.selectedWeightIdx + 1 }, function () {
	          _this.props.setRows(_this.props.rowChosen, _this.props.tableChosen, _this.state.weights.rows);_this.props.closeC();
	        });
	      }
	    };
	
	    _this.handleChange = function (event) {
	      _this.setState({ selectedWeight: event.target.value });
	    };
	
	    _this.renderWeightsSubmit = function () {
	      var confirmWeights = _this.state.selectedWeightIdx === 0 ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'press_enter_to_confirm_weights' }) : '';
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { style: _defineProperty({ paddingLeft: '50px' }, 'paddingLeft', '50px') },
	          _react2.default.createElement(
	            'h3',
	            { style: { paddingLeft: '18px' } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'set_weights' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 1 },
	            _react2.default.createElement(
	              'label',
	              { style: { paddingTop: '3px' } },
	              _this.state.selectedWeightIdx || ''
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(_reactBootstrap.Input, { type: 'number', name: 'selectedWeight', autoFocus: true, value: _this.state.selectedWeight, onChange: _this.handleChange, disabled: _this.state.needsDelete, onKeyPress: function onKeyPress(event) {
	                _this.handleKeyPress(event);
	              } })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          null,
	          _react2.default.createElement(
	            'span',
	            { style: { color: 'green', paddingLeft: '28px' } },
	            confirmWeights
	          )
	        )
	      );
	    };
	
	    _this.checkIfEnteredWeightInWeightRange = function (range, weights) {
	      var inRange = true;
	      weights.map(function (el) {
	        if (el.Weight > range.MaxWeigh || el.Weight < range.MinWight) {
	          inRange = false;
	        }
	      });
	      return inRange;
	    };
	
	    _this.proceeToSetWeight = function () {
	      _this.props.setRows(_this.props.rowChosen, _this.props.tableChosen, _this.state.weights.rows);_this.props.closeC();
	    };
	
	    _this.handleSaveWeightClick = function () {
	      var inRange = _this.checkIfEnteredWeightInWeightRange(_this.props.state[_this.props.tableChosen].rows[_this.props.rowChosen].Product_id.WeightRange, _this.state.weights.rows);
	      if (!inRange) {
	        _this.openConfirmModal();
	      } else {
	        _this.proceeToSetWeight();
	      }
	    };
	
	    _this.handleModalConfirmClick = function () {
	      _this.proceeToSetWeight();
	    };
	
	    _this.handleModalCancelClick = function () {
	      _this.closeConfirmModal();
	    };
	
	    _this.openConfirmModal = function () {
	      _this.setState({
	        confirmModalOpen: true
	      });
	    };
	
	    _this.closeConfirmModal = function () {
	      _this.setState({
	        confirmModalOpen: false
	      });
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton,
	
	      weights: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	      selectedWeightIdx: 1,
	      selectedWeight: '',
	      confirmModalOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(SetWeightModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // this.props.setRows(-1);
	      var tempWeights = this.props.rows;
	      if (!tempWeights) tempWeights = [];
	
	      if (tempWeights.length >= this.props.totalLoaded) {
	        var newWeights = tempWeights.splice(0, parseInt(this.props.totalLoaded));
	        newWeights.map(function (newWeight) {
	          newWeight = { 'Weight': newWeight.Weight || newWeight };
	        });
	        var weights = _extends({}, this.state.weights, { rows: newWeights });
	        this.setState({ weights: weights });
	      } else {
	        var temp = tempWeights.length;
	        for (var i = 0; i < this.props.totalLoaded - temp; i++) {
	          tempWeights.push({ 'Weight': 0 });
	        }
	        var _weights = _extends({}, this.state.weights, { rows: tempWeights });
	        this.setState({ weights: _weights });
	      }
	
	      // this.setState({weights});
	      // this.props.fetchReceiveLineWeights(this.props.rowChosen);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.totalWeight !== this.props.totalWeight) {
	        var rows = this.state.weights.rows;
	
	        var length = rows.length;
	        var avgWeight = parseFloat(nextProps.totalWeight || 0) / (parseFloat(length) || 1);
	        avgWeight = (Math.floor(avgWeight * 100) / 100).toFixed(2);
	        var diff = parseFloat(nextProps.totalWeight || 0) - avgWeight * length;
	        rows.map(function (r) {
	          r.Weight = avgWeight;
	        });
	        if (length > 0) {
	          rows[length - 1].Weight = (parseFloat(rows[length - 1].Weight || 0) + diff || 0).toFixed(2);
	        }
	        this.setState({ weights: { rows: rows } });
	      }
	      if (nextProps.salesOrderLineWeights && nextProps.salesOrderLineWeights != this.props.salesOrderLineWeights) {
	        var tempWeights = [];
	
	        nextProps.salesOrderLineWeights.map(function (weight) {
	          tempWeights.push({ Weight: weight });
	        });
	
	        if (nextProps.salesOrderLineWeights.length >= this.props.totalLoaded) {
	          var newWeights = tempWeights.splice(0, parseInt(this.props.totalLoaded));
	          var weights = _extends({}, this.state.weights, { rows: newWeights });
	          this.setState({ weights: weights });
	        } else {
	          var temp = tempWeights.length;
	          for (var i = 0; i < this.props.totalLoaded - temp; i++) {
	            tempWeights.push({ 'Weight': 0 });
	          }
	          var _weights2 = _extends({}, this.state.weights, { rows: tempWeights });
	          this.setState({ weights: _weights2 });
	        }
	      }
	    }
	  }, {
	    key: 'fillWithLastValue',
	    value: function fillWithLastValue() {
	      var index = 0;
	      var newWeights = _extends({}, this.state.weights);
	
	      for (var i = 0; i < this.state.weights.rows.length; i++) {
	        if (this.state.weights.rows[i].Weight == 0) {
	          index = i;
	          break;
	        }
	      }
	
	      if (index > 0) {
	        var fillValue = this.state.weights.rows[index - 1].Weight;
	
	        for (var i = index; i < this.state.weights.rows.length; i++) {
	          newWeights.rows[i].Weight = fillValue;
	        }
	        this.setState({ weights: newWeights });
	      }
	    }
	  }, {
	    key: 'clearAllValues',
	    value: function clearAllValues() {
	      var newWeights = [].concat(_toConsumableArray(this.state.weights.rows));
	      newWeights.map(function (row) {
	        row.Weight = 0;
	      });
	
	      var weights = _extends({}, this.state.weights, { rows: newWeights });
	      this.setState({ weights: weights });
	    }
	  }, {
	    key: 'renderWeightInputs',
	    value: function renderWeightInputs() {
	      var _this2 = this;
	
	      var _props = this.props,
	          salesOrderLineWeightsIsLoading = _props.salesOrderLineWeightsIsLoading,
	          salesOrderLineWeightsError = _props.salesOrderLineWeightsError;
	
	      if (salesOrderLineWeightsIsLoading && !salesOrderLineWeightsError) return _react2.default.createElement(_spinner2.default, { className: 'marginTopStyle' });else if (salesOrderLineWeightsError) return _react2.default.createElement(
	        'div',
	        { className: 'alert alert-danger' },
	        JSON.stringify(salesOrderLineWeightsError)
	      );else {
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.weights);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return Object.assign({ Idx: rowIdx + 1 }, rows[rowIdx]);
	        };
	
	        // Handle the row select function
	
	        var onRowSelect = function onRowSelect(rows) {
	          var weights = _extends({}, _this2.state.weights, { rows: rows });
	          _this2.setState({ weights: weights });
	        };
	
	        var onRowClick = function onRowClick(rowIdx, row) {
	          _this2.setState({ selectedWeight: row.Weight, selectedWeightIdx: row.Idx });
	        };
	
	        var handleRowUpdated = function handleRowUpdated(e) {
	          var rows = _this2.state.weights.rows.slice(0);
	          Object.assign(rows[e.rowIdx], e.updated);
	          var weights = _extends({}, _this2.state.weights, { rows: rows });
	          _this2.setState({ weights: weights });
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var weights = Object.assign({}, _this2.state.weights, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this2.setState({ weights: weights });
	        };
	
	        //Custom Formatter component
	
	        var DateFormatter = _react2.default.createClass({
	          displayName: 'DateFormatter',
	          render: function render() {
	            if (this.props.value) {
	              var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	              var date = new Date(this.props.value);
	              var index = dateMap.indexOf(date.toString().slice(4, 3));
	              var localDate = index + date.toString().slice(8, 6);
	              return _react2.default.createElement(
	                'span',
	                null,
	                date.toString().slice(4, 15)
	              );;
	            } else return _react2.default.createElement(
	              'span',
	              { className: 'label label-danger' },
	              '-'
	            );
	          }
	        });
	
	        // Column difinition
	
	        var columns = [{
	          key: 'Idx',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	          width: 30,
	          resizable: true,
	          filterable: true
	        }, {
	          key: 'Weight',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight' }),
	          resizable: true,
	          filterable: true,
	          editable: true
	        }];
	
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              'div',
	              { style: { maxWidth: '99%' }, id: 'SetReceiveWeightModal-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                style: { height: '10%' },
	                onGridSort: handleGridSort,
	                columns: columns,
	                enableCellSelect: true,
	                rowHeight: 25,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                minHeight: 275,
	                onRowUpdated: handleRowUpdated,
	                onRowClick: onRowClick
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary col-sm-11 buttonStyle', onClick: function onClick() {
	                  _this2.fillWithLastValue();
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fill_with_latest_value' })
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-danger col-sm-11 buttonStyle', onClick: function onClick() {
	                  _this2.clearAllValues();
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'clear_all_values' })
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            this.renderWeightsSubmit()
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          closeC = _props2.closeC,
	          valid = _props2.valid,
	          importLine = _props2.importLine;
	
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement('hr', null),
	        this.renderWeightInputs(),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_weight' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'TotalWeight', component: _inputField.InputField })
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'import_line' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 7 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'importLine', component: _inputField.InputField })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 1 },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                disabled: !valid || !importLine,
	                onClick: this.handleImportOnClick
	              },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'import' })
	            )
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary col-sm-11 buttonStyle',
	              disabled: !valid,
	              onClick: this.handleSaveWeightClick
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save_weights' })
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-danger col-sm-11 buttonStyle', onClick: function onClick() {
	                _this3.props.closeC();
	              } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discard_changes' })
	          )
	        ),
	        _react2.default.createElement(_confirmModal2.default, {
	          title: 'Confirm Modal',
	          content: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight_not_in_range' }),
	          isVisible: this.state.confirmModalOpen,
	          onConfirm: this.handleModalConfirmClick,
	          onCancel: this.handleModalCancelClick
	        })
	      );
	    }
	  }]);
	
	  return SetWeightModal;
	}(_react.Component);
	
	SetWeightModal.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = SetWeightModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SetWeightModal, 'SetWeightModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/setReceiveWeightModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/setReceiveWeightModal.jsx');
	}();

	;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _filterByStart = __webpack_require__(68);
	
	var _filterByStart2 = _interopRequireDefault(_filterByStart);
	
	var _filterMultiKeyword = __webpack_require__(95);
	
	var _filterMultiKeyword2 = _interopRequireDefault(_filterMultiKeyword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ESCAPE_KEY = 27;
	var ENTER_KEY = 13;
	
	var RowRenderer = function (_Component) {
	  _inherits(RowRenderer, _Component);
	
	  function RowRenderer() {
	    _classCallCheck(this, RowRenderer);
	
	    return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(RowRenderer, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { onDoubleClick: function onDoubleClick() {
	            _this2.props.onDoubleClick(_this2.props.row);
	          } },
	        _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	      );
	    }
	  }]);
	
	  return RowRenderer;
	}(_react.Component);
	
	var VendorBatches = function (_Component2) {
	  _inherits(VendorBatches, _Component2);
	
	  function VendorBatches() {
	    _classCallCheck(this, VendorBatches);
	
	    var _this3 = _possibleConstructorReturn(this, (VendorBatches.__proto__ || Object.getPrototypeOf(VendorBatches)).call(this));
	
	    _this3.state = {
	      rows: [],
	      filters: {},
	      selectedRows: [],
	      sortColumn: null,
	      sortDirection: null,
	      clickedCell: { row: 0, column: -1 }
	    };
	    _this3.onCellSelected = _this3.onCellSelected.bind(_this3);
	    _this3.selectProduct = _this3.selectProduct.bind(_this3);
	    _this3.handleKeyDown = _this3.handleKeyDown.bind(_this3);
	    _this3.onKeyDown = _this3.onKeyDown.bind(_this3);
	    _this3.selectVendorBatches = _this3.selectVendorBatches.bind(_this3);
	    return _this3;
	  }
	
	  _createClass(VendorBatches, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      document.addEventListener('keydown', this.handleKeyDown);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.refs["inventoryInfo"]) {
	        _reactDom2.default.findDOMNode(this.refs["inventoryInfo"].refs.base.refs.viewPortContainer).focus();
	      }
	      // this.props.fetchSimplifiedProducts(this.props.searchType, this.props.searchValue);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.vendorBatches && nextProps.vendorBatches !== this.props.vendorBatches) {
	        var rows = [].concat(_toConsumableArray(nextProps.vendorBatches));
	        this.setState({ rows: rows });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevProps.vendorBatches && prevProps.vendorBatches.length !== 0 && prevProps.vendorBatches !== this.props.vendorBatches) {
	        _reactDom2.default.findDOMNode(this.refs["inventoryInfo"].refs.base.refs.viewPortContainer).focus();
	      }
	      // if( (!(prevProps.vendorBatches) || (prevProps.vendorBatches.length==0)) && this.props.vendorBatches && this.props.vendorBatches.length != 0) {
	      //   ReactDOM.findDOMNode(this.refs["inventoryInfo"].refs.base.refs.viewPortContainer).focus();
	      // }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('keydown', this.handleKeyDown);
	    }
	
	    // handleFormSubmit(formProps) {
	    // }
	
	  }, {
	    key: 'onCellSelected',
	    value: function onCellSelected(coordinates) {
	      var clickedCell = {
	        row: coordinates.rowIdx,
	        column: coordinates.idx - 1 // because there is a checkbox column makes this 1 indexed, convert it to 0 indexed here
	      };
	      this.setState({ clickedCell: clickedCell });
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(e) {
	      if (e.keyCode === ENTER_KEY) {
	        e.preventDefault();
	        var rows = this.state.rows;
	        var row = rows[this.state.clickedCell.row];
	        this.selectProduct(row);
	        // this.props.selectInventoryInfo(row);
	        // this.props.setAllProducts(`${row.ProductNum} | ${row.Name} | ${row.Description} | ${row.MeasureUnit}`, 'purchaseOrderForm');
	        // this.props.closeShowInventory('allProd_Quantity');
	      }
	    }
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(event) {
	      switch (event.keyCode) {
	        case ESCAPE_KEY:
	          this.props.closeShowVendorBatches('allProducts');
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'selectVendorBatches',
	    value: function selectVendorBatches() {
	      this.props.moveToProductsListFromVendor(this.state.selectedRows);
	      this.props.closeShowVendorBatches();
	    }
	  }, {
	    key: 'selectProduct',
	    value: function selectProduct(product) {
	      this.props.selectInventoryInfo(product);
	      this.props.setAllProducts(product.ProductNum + ' | ' + product.Name + ' | ' + product.Description + ' | ' + product.MeasureUnit, this.props.form);
	      this.props.closeShowInventory('allProd_Quantity');
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this4 = this;
	
	      if (this.props.vendorBatchesIsLoading && !this.props.vendorBatchesError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.vendorBatchesError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.vendorBatchesError)
	        )
	      );
	
	      // Parameters of the react-data-grid
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this4.state);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this4.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this4.setState(state);
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this4.state.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        _this4.setState({ filters: newFilters });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = getRows();
	        var selectedRows = [];
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        newRows.map(function (r) {
	          if (r.isSelected === true) {
	            selectedRows.push(r);
	          }
	        });
	        _this4.setState({ rows: newRows, selectedRows: selectedRows });
	      };
	
	      // Handle the row select function
	      var onRowsSelected = function onRowsSelected(rows) {
	        // const selectedRows = [];
	        // const newRows = this.state.rows;
	        var newRows = getRows();
	        var selectedRows = [].concat(_toConsumableArray(_this4.state.selectedRows));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	          selectedRows.push(r.row);
	        });
	        // newRows.map((r) => {
	        //   if (r.isSelected === true) {
	        //     selectedRows.push(r);
	        //   }
	        // });
	        _this4.setState(_extends({}, _this4.state, { rows: newRows, selectedRows: selectedRows }));
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        _this4.setState({ filters: {} });
	      };
	
	      // Column difinition
	      var columns = [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 70,
	        filterRenderer: _filterByStart2.default
	      }, {
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 70,
	        filterRenderer: _filterByStart2.default
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 200,
	        filterRenderer: _filterMultiKeyword2.default
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	        resizable: true,
	        filterable: true,
	        sortable: true,
	        filterRenderer: _filterMultiKeyword2.default
	      }, {
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        filterRenderer: _filterMultiKeyword2.default
	      }, {
	        key: 'Batch_PONum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        filterRenderer: _filterMultiKeyword2.default
	      }, {
	        key: 'BinName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 70,
	        filterRenderer: _filterMultiKeyword2.default
	      }, {
	        key: 'BinAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin_amount' }),
	        resizable: true,
	        sortable: true,
	        width: 80
	      }, {
	        key: 'NetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 50
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        { style: { marginTop: '-5px' } },
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { id: 'VendorBatches-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              ref: 'inventoryInfo',
	              rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: this.selectProduct }),
	              rowKey: 'Product_id',
	              rowHeight: 25,
	              minHeight: 580,
	              onGridSort: handleGridSort,
	              columns: columns,
	              headerRowHeight: 45,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              enableCellSelect: true,
	              onGridKeyDown: this.onKeyDown,
	              onCellSelected: this.onCellSelected,
	              enableRowSelect: 'multi',
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              onClearFilters: onClearFilters,
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              }
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { onClick: function onClick() {
	              _this5.selectVendorBatches();
	            } },
	          _react2.default.createElement('em', { className: 'fa fa-plus' })
	        ),
	        this.renderTable()
	      );
	    }
	  }]);
	
	  return VendorBatches;
	}(_react.Component);
	
	var _default = VendorBatches;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ESCAPE_KEY, 'ESCAPE_KEY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/vendorBatches.jsx');
	
	  __REACT_HOT_LOADER__.register(ENTER_KEY, 'ENTER_KEY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/vendorBatches.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/vendorBatches.jsx');
	
	  __REACT_HOT_LOADER__.register(VendorBatches, 'VendorBatches', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/vendorBatches.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/vendorBatches.jsx');
	}();

	;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDropzone = __webpack_require__(45);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _zoneForm = __webpack_require__(176);
	
	var _zoneForm2 = _interopRequireDefault(_zoneForm);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEcity = _root_url.ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === "https://dev-scm.truckxi.com/api/";
	var isABCFF = _root_url.ROOT_API_URL === 'https://abcff-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://abcff-scm.truckxi.com/api/';
	
	var renderSearchField = function renderSearchField(props) {
	  return _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { standalone: true, type: 'text', placeholder: 'Search Zone...' }));
	};
	
	var WarehouseForm = function (_Component) {
	  _inherits(WarehouseForm, _Component);
	
	  function WarehouseForm() {
	    _classCallCheck(this, WarehouseForm);
	
	    var _this = _possibleConstructorReturn(this, (WarehouseForm.__proto__ || Object.getPrototypeOf(WarehouseForm)).call(this));
	
	    _this.editLevel = function (e) {
	      e.preventDefault();
	      _this.props.resetCurrentZone();
	      var selectedLevelRows = _this.state.selectedLevelRows;
	
	      var currentLevel = { Name: selectedLevelRows[0].bin_num, description: selectedLevelRows[0].description };
	      _this.props.selectLevel(currentLevel);
	      _this.props.selectZone(currentLevel);
	      _this.setState({ title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_level' }) });
	      _this.levelOpenSave();
	    };
	
	    _this.getLevels = function (id) {
	      _this.props.getLevelsByBin(id).then(function () {
	        _this.setState({
	          levels: _this.props.levels
	        });
	        _this.levelCloseSave();
	      });
	    };
	
	    _this.getBins = function (id) {
	      _this.props.getBinsByZone(id).then(function () {
	        _this.setState({
	          bins: _this.props.bins
	        });
	        _this.binCloseSave();
	      });
	    };
	
	    _this.renderBarcode = function () {
	      var _this$state = _this.state,
	          currentZone = _this$state.currentZone,
	          currentBin = _this$state.currentBin,
	          currentLevel = _this$state.currentLevel;
	      var currentWarehouse = _this.props.currentWarehouse;
	
	      var barcodeUrl = void 0;
	      if (currentWarehouse && !isABCFF) {
	        if (currentLevel) {
	          barcodeUrl = _root_url.ROOT_URL + 'v1/warehouse/printzonebinlevelbarcode/' + currentWarehouse.warehouse_num + '-' + currentZone + '-' + currentBin + '-' + currentLevel + '?Bearer=' + localStorage.getItem('token');
	        } else if (currentBin) {
	          barcodeUrl = _root_url.ROOT_URL + 'v1/warehouse/printzonebinlevelbarcode/' + currentWarehouse.warehouse_num + '-' + currentZone + '-' + currentBin + '?Bearer=' + localStorage.getItem('token');
	        } else if (currentZone) {
	          barcodeUrl = _root_url.ROOT_URL + 'v1/warehouse/printzonebinlevelbarcode/' + currentWarehouse.warehouse_num + '-' + currentZone + '?Bearer=' + localStorage.getItem('token');
	        } else {
	          barcodeUrl = _root_url.ROOT_URL + 'v1/warehouse/printzonebinlevelbarcode/' + currentWarehouse.warehouse_num + '?Bearer=' + localStorage.getItem('token');
	        }
	      } else if (currentWarehouse && isABCFF) {
	        if (currentLevel) {
	          barcodeUrl = _root_url.ROOT_URL + 'v1/warehouse/printzonebinlevelbarcode/' + currentZone + '-' + currentBin + '-' + currentLevel + '?Bearer=' + localStorage.getItem('token');
	        } else if (currentBin) {
	          barcodeUrl = _root_url.ROOT_URL + 'v1/warehouse/printzonebinlevelbarcode/' + currentZone + '-' + currentBin + '?Bearer=' + localStorage.getItem('token');
	        } else if (currentZone) {
	          barcodeUrl = _root_url.ROOT_URL + 'v1/warehouse/printzonebinlevelbarcode/' + currentZone + '?Bearer=' + localStorage.getItem('token');
	        } else {
	          barcodeUrl = _root_url.ROOT_URL + 'v1/warehouse/printzonebinlevelbarcode/' + currentWarehouse.warehouse_num + '?Bearer=' + localStorage.getItem('token');
	        }
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          style: { margin: 5 },
	          bsStyle: 'danger',
	          type: 'button',
	          disabled: !_this.state.currentZone,
	          href: barcodeUrl
	        },
	        _react2.default.createElement('em', { className: 'fa fa-barcode' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'generate_barcode' })
	      );
	    };
	
	    _this.renderAllBarcode = function () {
	      var barcodeUrl = void 0;
	      barcodeUrl = _root_url.ROOT_URL + 'v1/warehouse/printzonebinlevelbarcodeall/?Bearer=' + localStorage.getItem('token');
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          style: { margin: 5 },
	          bsStyle: 'danger',
	          type: 'button',
	          href: barcodeUrl
	        },
	        _react2.default.createElement('em', { className: 'fa fa-barcode' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'generate_all_barcode' })
	      );
	    };
	
	    _this.renderAllZoneBarcode = function () {
	      var barcodeUrl = void 0;
	      barcodeUrl = _root_url.ROOT_URL + 'v1/warehouse/printzonebarcodeall/?Bearer=' + localStorage.getItem('token');
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'danger',
	          type: 'button',
	          href: barcodeUrl
	        },
	        _react2.default.createElement('em', { className: 'fa fa-barcode' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'generate_all_zone_barcode' })
	      );
	    };
	
	    _this.onDrop = function (file) {
	      if (file) {
	        alert("Please stay on the current page while the file uploads.");
	      }
	      _this.props.attachZoneBinLevel(file[0], _this.props.currentWarehouse.id);
	      _this.setState({
	        file: file
	      });
	    };
	
	    _this.importZoneBinLevel = function () {
	      var csvUrl = _root_url.ROOT_URL + 'v1/warehouse/zonebinlevel/export/?Bearer=' + localStorage.getItem('token');
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          style: { margin: 5 },
	          bsStyle: 'success',
	          type: 'button',
	          href: csvUrl
	        },
	        _react2.default.createElement('em', { className: 'fa fa-arrow-circle-o-down' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'download_file' })
	      );
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.fourLineButton,
	      allRows: [],
	      rows: [],
	      selectedRows: [],
	      selectedBinRows: [],
	      selectedLevelRows: [],
	      zone: null,
	      bin: null,
	      level: null,
	      bins: [],
	      levels: [],
	      filters: {},
	      zoneOpen: false,
	      title: '',
	      binSelected: false,
	      levelSelected: false,
	      currentZone: null,
	      currentBin: null,
	      currentLevel: null,
	      levelRows: null,
	      binRows: null,
	      modalOpen: false,
	      binOpen: false,
	      binSaveOpen: false,
	      hierarchy: null,
	      levelSaveOpen: false,
	      file: null,
	      binRow: null
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.searchZones = _this.searchZones.bind(_this);
	    _this.openZone = _this.openZone.bind(_this);
	    _this.closeZone = _this.closeZone.bind(_this);
	    _this.closeModal = _this.closeModal.bind(_this);
	    _this.openModal = _this.openModal.bind(_this);
	    _this.deleteBin = _this.deleteBin.bind(_this);
	    _this.createBin = _this.createBin.bind(_this);
	    _this.createLevel = _this.createLevel.bind(_this);
	    _this.openBin = _this.openBin.bind(_this);
	    _this.closeBin = _this.closeBin.bind(_this);
	    _this.openLevel = _this.openLevel.bind(_this);
	    _this.closeLevel = _this.closeLevel.bind(_this);
	    _this.binCloseSave = _this.binCloseSave.bind(_this);
	    _this.binOpenSave = _this.binOpenSave.bind(_this);
	    _this.levelOpenSave = _this.levelOpenSave.bind(_this);
	    _this.levelCloseSave = _this.levelCloseSave.bind(_this);
	    _this.deleteLevel = _this.deleteLevel.bind(_this);
	    return _this;
	  }
	
	  _createClass(WarehouseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      window.addEventListener('resize', this.handleResize);
	      if (!this.props.currentWarehouse) this.context.router.push('/warehouses');else {
	        // this.props.fetchWarehouseDetail(this.props.currentWarehouse);
	        this.props.fetchWarehouseBins(this.props.currentWarehouse.Warehouse_id);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	
	      // if(nextProps.zones && nextProps.zones != this.props.zones && this.props.warehouseBinsDetail){
	      //   let newRows = nextProps.zones;
	      //
	      //   newRows.map(zone => {
	      //     const index = _.findIndex(this.props.warehouseBinsDetail.Warehouse_Zone, {'WarehouseZone_id': zone['WarehouseZone_id']});
	      //     if(index != -1){
	      //       zone['AvailableBin'] = this.props.warehouseBinsDetail.Warehouse_Zone[index].AvailableBin;
	      //       zone['TotalBin'] = this.props.warehouseBinsDetail.Warehouse_Zone[index].TotalBin;
	      //       zone['UsedBin'] = this.props.warehouseBinsDetail.Warehouse_Zone[index].TotalBin - this.props.warehouseBinsDetail.Warehouse_Zone[index].AvailableBin;
	      //
	      //     }
	      //   });
	      //   this.setState({rows: newRows});
	      // }
	      if (nextProps.warehouseBinsDetail && nextProps.warehouseBinsDetail !== this.props.warehouseBinsDetail && this.props.zones) {
	        var newRows = nextProps.warehouseBinsDetail.Warehouse_Zone;
	        newRows.map(function (zone) {
	          zone['UsedBin'] = zone['TotalBin'] - zone['AvailableBin'];
	        });
	        this.setState({ rows: newRows, allRows: newRows });
	      }
	
	      if (this.props.nameValue && !nextProps.nameValue) {
	        var rows = this.state.allRows;
	        this.setState({ rows: rows });
	      }
	
	      if (nextProps.deleteZoneSuccess && nextProps.deleteZoneSuccess != this.props.deleteZoneSuccess) {
	        this.props.fetchWarehouseBins(this.props.currentWarehouse.Warehouse_id);
	      }
	      // handle errors
	      if (nextProps.deleteZoneFailureError && !this.props.deleteZoneFailureError) {
	        alert(nextProps.deleteZoneFailureError);
	      }
	      if (nextProps.deleteBinSuccess && nextProps.deleteBinSuccess !== this.props.deleteBinSuccess) {
	        this.getBins(this.state.zone.WarehouseZone_id);
	      }
	      if (nextProps.deleteLevelSuccess && nextProps.deleteLevelSuccess !== this.props.deleteLevelSuccess) {
	        this.getLevels(this.state.binRow.id);
	      }
	      if (nextProps.createBinSuccess && nextProps.createBinSuccess !== this.props.createBinSuccess) {
	        this.getBins(this.state.zone.WarehouseZone_id);
	      }
	      if (nextProps.createLevelSuccess && nextProps.createLevelSuccess !== this.props.createLevelSuccess) {
	        this.getLevels(this.state.binRow.id);
	      }
	      if (nextProps.createError && !this.props.createError) {
	        alert(nextProps.createError);
	      }
	      if (nextProps.levelCreateError && !this.props.levelCreateError) {
	        alert(nextProps.levelCreateError);
	      }
	      if (nextProps.binCreateError && !this.props.binCreateError) {
	        alert(nextProps.binCreateError);
	      }
	      if (nextProps.attachDocumentSuccess && this.props.attachDocumentSuccess !== nextProps.attachDocumentSuccess) {
	        this.props.fetchWarehouseBins(this.props.currentWarehouse.Warehouse_id);
	      }
	      if (nextProps.updatedLevel && this.props.updatedLevel !== nextProps.updatedLevel) {
	        this.getLevels(this.state.binRow.id);
	        this.setState({
	          selectedLevelRows: []
	        });
	      }
	      if (nextProps.updatedBin && this.props.updatedBin !== nextProps.updatedBin) {
	        this.getBins(this.state.zone.WarehouseZone_id);
	        this.setState({
	          selectedBinRows: []
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.fourLineButton });
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal() {
	      this.setState({ modalOpen: true });
	    }
	  }, {
	    key: 'openZone',
	    value: function openZone() {
	      this.setState({ zoneOpen: true });
	    }
	  }, {
	    key: 'openBin',
	    value: function openBin() {
	      this.setState({ binOpen: true });
	    }
	  }, {
	    key: 'closeBin',
	    value: function closeBin() {
	      this.setState({ binOpen: false });
	    }
	  }, {
	    key: 'openLevel',
	    value: function openLevel() {
	      this.setState({ levelOpen: true });
	    }
	  }, {
	    key: 'closeLevel',
	    value: function closeLevel() {
	      this.setState({ levelOpen: false });
	    }
	  }, {
	    key: 'closeZone',
	    value: function closeZone() {
	      this.setState({ zoneOpen: false });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.setState({ modalOpen: false });
	    }
	  }, {
	    key: 'binOpenSave',
	    value: function binOpenSave() {
	      this.setState({ binSaveOpen: true });
	    }
	  }, {
	    key: 'binCloseSave',
	    value: function binCloseSave() {
	      this.setState({ binSaveOpen: false });
	    }
	  }, {
	    key: 'levelCloseSave',
	    value: function levelCloseSave() {
	      this.setState({ levelSaveOpen: false });
	    }
	  }, {
	    key: 'levelOpenSave',
	    value: function levelOpenSave() {
	      this.setState({ levelSaveOpen: true });
	    }
	  }, {
	    key: 'deleteZone',
	    value: function deleteZone(e) {
	      e.preventDefault();
	      var currentZone = this.state.selectedRows[0];
	      this.props.deleteZone(currentZone.WarehouseZone_id);
	      this.closeModal();
	    }
	  }, {
	    key: 'deleteBin',
	    value: function deleteBin(e) {
	      e.preventDefault();
	      var currentBin = this.state.selectedBinRows[0].id;
	      this.props.deleteBinsBD(currentBin);
	      this.closeBin();
	    }
	  }, {
	    key: 'deleteLevel',
	    value: function deleteLevel(e) {
	      e.preventDefault();
	      var currentLevel = this.state.selectedLevelRows[0].id;
	      this.props.deleteBin(currentLevel);
	      this.closeLevel();
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      if (this.props.currentWarehouse) this.props.editWarehouse(formProps);else this.props.createWarehouse(formProps);
	    }
	  }, {
	    key: 'viewZone',
	    value: function viewZone(id) {
	      this.props.resetCurrentZone();
	      this.props.selectZone(id);
	      this.context.router.push("/zoneDetail");
	    }
	  }, {
	    key: 'editZone',
	    value: function editZone(e) {
	      e.preventDefault();
	      this.props.resetCurrentZone();
	      var currentZone = this.state.selectedRows[0];
	      this.props.selectZone(currentZone);
	      this.setState({ title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_zone' }) });
	      this.openZone();
	    }
	  }, {
	    key: 'editBin',
	    value: function editBin(e) {
	      e.preventDefault();
	      this.props.resetCurrentZone();
	      var selectedBinRows = this.state.selectedBinRows;
	
	      var currentBin = { Name: selectedBinRows[0].section_num, description: selectedBinRows[0].description };
	      this.props.selectBin(currentBin);
	      this.props.selectZone(currentBin);
	      this.setState({ title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_bin' }) });
	      this.binOpenSave();
	    }
	  }, {
	    key: 'createZone',
	    value: function createZone(e) {
	      e.preventDefault();
	      this.props.resetCurrentZone();
	      this.setState({ title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_a_new_zone' }) });
	      this.openZone();
	    }
	  }, {
	    key: 'createBin',
	    value: function createBin(e) {
	      e.preventDefault();
	      this.props.resetCurrentZone();
	      this.setState({ title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_a_new_bin' }) });
	      this.binOpenSave();
	    }
	  }, {
	    key: 'createLevel',
	    value: function createLevel(e) {
	      e.preventDefault();
	      this.props.resetCurrentZone();
	      this.setState({ title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_a_new_level' }) });
	      this.levelOpenSave();
	    }
	  }, {
	    key: 'searchZones',
	    value: function searchZones() {
	      var _props = this.props,
	          fetchWarehouseDetail = _props.fetchWarehouseDetail,
	          searchZones = _props.searchZones,
	          nameValue = _props.nameValue,
	          currentWarehouse = _props.currentWarehouse;
	
	      if (!nameValue) fetchWarehouseBins(currentWarehouse.Warehouse_id);else {
	        var allrows = this.state.allRows;
	        var rows = [];
	        rows = allrows.filter(function (r) {
	          return r.Name == nameValue;
	        });
	        this.setState({ rows: rows });
	      }
	    }
	  }, {
	    key: 'renderWarehouseDetail',
	    value: function renderWarehouseDetail() {
	      var _props2 = this.props,
	          detailError = _props2.detailError,
	          detailIsLoading = _props2.detailIsLoading,
	          currentWarehouse = _props2.currentWarehouse;
	
	      if (detailIsLoading && !detailError) return _react2.default.createElement(_spinner2.default, { className: 'marginTopStyle' });else if (detailError) return _react2.default.createElement(
	        'div',
	        { className: 'alert alert-danger' },
	        JSON.stringify(detailError)
	      );else if (currentWarehouse) {
	        // let Total_size = Math.floor(Math.random() * (100000 - 50000 + 1)) + 50000;
	        var Name = currentWarehouse.Name,
	            Street = currentWarehouse.Street,
	            City = currentWarehouse.City,
	            State = currentWarehouse.State,
	            FirstName = currentWarehouse.FirstName,
	            LastName = currentWarehouse.LastName,
	            Email = currentWarehouse.Email,
	            Telephone = currentWarehouse.Telephone,
	            Fax = currentWarehouse.Fax,
	            Warehouse_id = currentWarehouse.Warehouse_id;
	
	        var Address = Street + ", " + City + ", " + State;
	        var Contact = FirstName + " " + LastName;
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 12 },
	              _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_name' }),
	                ': ',
	                Name || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 12 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_id' }),
	              ': ',
	              Warehouse_id
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'marginTopStyle' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 12 },
	              _react2.default.createElement('em', { className: 'fa fa-building-o marginRightStyle' }),
	              Address || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'marginTopStyle' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 12 },
	              _react2.default.createElement('em', { className: 'fa fa-user marginRightStyle' }),
	              Contact || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'contact_person' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'marginTopStyle' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 12 },
	              _react2.default.createElement('em', { className: 'fa fa-envelope marginRightStyle' }),
	              Email || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'marginTopStyle' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 12 },
	              _react2.default.createElement('em', { className: 'fa fa-phone marginRightStyle' }),
	              Telephone || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'marginTopStyle' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 12 },
	              _react2.default.createElement('em', { className: 'fa fa-fax marginRightStyle' }),
	              Fax || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fax' })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderZones',
	    value: function renderZones() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          currentWarehouseDetail = _props3.currentWarehouseDetail,
	          zones = _props3.zones,
	          detailError = _props3.detailError,
	          detailIsLoading = _props3.detailIsLoading;
	
	      if (detailIsLoading && !detailError) return _react2.default.createElement(_spinner2.default, { className: 'marginTopStyle' });else if (detailError) return _react2.default.createElement(
	        'div',
	        { className: 'alert alert-danger' },
	        JSON.stringify(this.props.detailError)
	      );
	      return zones.map(function (zone) {
	        var Name = zone.Name,
	            WarehouseName = zone.WarehouseName,
	            Description = zone.Description,
	            Bin = zone.Bin,
	            WarehouseZone_id = zone.WarehouseZone_id;
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'pull-right' },
	              _react2.default.createElement('em', { className: 'fa fa-trash buttonStyle' }),
	              _react2.default.createElement('em', { className: 'fa fa-pencil buttonStyle', onClick: function onClick() {
	                  return _this2.editZone(WarehouseZone_id);
	                } })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    _react2.default.createElement(
	                      'a',
	                      { onClick: function onClick() {
	                          return _this2.viewZone(WarehouseZone_id);
	                        }, style: { cursor: "pointer" } },
	                      _react2.default.createElement('em', { className: 'fa fa-institution marginRightStyle' }),
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone' }),
	                        ' ',
	                        Name || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 112 },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_zone_id' }),
	                    ': ',
	                    WarehouseZone_id
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    _react2.default.createElement('em', { className: 'fa fa-building marginLeftStyle marginRightStyle' }),
	                    currentWarehouseDetail.Name || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_name' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12, className: 'descriptionStyle' },
	                    Description || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin' }),
	                    ': '
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    JSON.stringify(Bin)
	                  )
	                )
	              )
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: 'renderZonesForm',
	    value: function renderZonesForm() {
	      var _this3 = this;
	
	      var _props4 = this.props,
	          currentWarehouseDetail = _props4.currentWarehouseDetail,
	          zones = _props4.zones,
	          detailError = _props4.detailError,
	          detailIsLoading = _props4.detailIsLoading;
	
	      if (detailIsLoading && !detailError) return _react2.default.createElement(_spinner2.default, { className: 'marginTopStyle' });else if (detailError) return _react2.default.createElement(
	        'div',
	        { className: 'alert alert-danger' },
	        JSON.stringify(this.props.detailError)
	      );else {
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this3.state);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        var onRowClick = function onRowClick(rowIdx, row) {
	          var grabBins = _getBins(row.id, row);
	          var id = row.id;
	          _this3.setState(function () {
	            return {
	              binSelected: false,
	              levels: [],
	              currentLevel: null,
	              selectedLevelRows: [],
	              levelSelected: false,
	              zone: row };
	          }, function () {
	            grabBins();
	          });
	        };
	
	        var _getBins = function _getBins(id, row) {
	          console.log("inside get bins", id, row);
	          _this3.props.getBinsByZone(id).then(function () {
	            if (_this3.props.bins && _this3.props.bins !== []) {
	              _this3.setState({
	                selectedBinRows: [],
	                binSelected: true,
	                bins: _this3.props.bins
	              });
	            }
	          });
	        };
	
	        // Handle the row select function
	        var onRowSelect = function onRowSelect(rows) {
	          _this3.setState.apply(_this3, _toConsumableArray(_this3.state).concat([{ selectedRows: rows }]));
	        };
	
	        var onRowsSelected = function onRowsSelected(rows) {
	          var newRows = getRows();
	          var selectedRows = [newRows[rows[0].rowIdx]];
	          var zoneId = rows[0].row.WarehouseZone_id;
	          newRows.map(function (r) {
	            r.isSelected = false;
	          });
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = true;
	          });
	          _this3.setState(function (state, props) {
	            return {
	              selectedLevelRows: [],
	              levels: [],
	              zone: selectedRows[0],
	              rows: newRows,
	              currentZone: selectedRows[0].zone_num,
	              currentLevel: null,
	              selectedRows: selectedRows };
	          }, function () {
	            _getBins(zoneId, rows[0].row);
	          });
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          var rowIndexes = rows.map(function (r) {
	            return r.rowIdx;
	          });
	          var newRows = [].concat(_toConsumableArray(_this3.state.rows));
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = false;
	          });
	          _this3.setState({ rows: newRows, selectedRows: [] });
	        };
	
	        // Handle the sortable function
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var state = Object.assign({}, _this3.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this3.setState(state);
	        };
	
	        var handleFilterChange = function handleFilterChange(filter) {
	          var newFilters = Object.assign({}, _this3.state.filters);
	          if (filter.filterTerm) {
	            newFilters[filter.column.key] = filter;
	          } else {
	            delete newFilters[filter.column.key];
	          }
	          _this3.setState({ filters: newFilters });
	        };
	
	        //Custom Formatter component
	        var DateFormatter = _react2.default.createClass({
	          displayName: 'DateFormatter',
	          render: function render() {
	            if (this.props.value) {
	              var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	              var date = new Date(this.props.value);
	              var index = dateMap.indexOf(date.toString().slice(4, 3));
	              var localDate = index + date.toString().slice(8, 6);
	              return _react2.default.createElement(
	                'span',
	                null,
	                date.toString().slice(4, 15)
	              );;
	            } else return _react2.default.createElement(
	              'span',
	              { className: 'label label-danger' },
	              '-'
	            );
	          }
	        });
	        // Column difinition
	        var columns = [{
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 140
	        }, {
	          key: 'description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Description' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 170
	        }];
	
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 4 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '99%', marginTop: '20px' } },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'WarehouseZone_id',
	              enableCellSelect: true,
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              columns: columns,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              enableRowSelect: 'single',
	              minHeight: this.state.tableHeight - 70,
	              rowHeight: 25,
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              },
	              onRowClick: onRowClick
	            })
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderBinsForm',
	    value: function renderBinsForm() {
	      var _this4 = this;
	
	      if (this.state.binSelected && this.state.bins.length) {
	        var _props5 = this.props,
	            currentWarehouseDetail = _props5.currentWarehouseDetail,
	            zones = _props5.zones,
	            detailError = _props5.detailError,
	            detailIsLoading = _props5.detailIsLoading;
	
	        if (detailIsLoading && !detailError) return _react2.default.createElement(_spinner2.default, { className: 'marginTopStyle' });else if (detailError) return _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.detailError)
	        );else {
	          var getRows = function getRows() {
	            return _this4.state.bins;
	          };
	
	          var getSize = function getSize() {
	            return getRows().length;
	          };
	
	          var rowGetter = function rowGetter(rowIdx) {
	            var rows = getRows();
	            return rows[rowIdx];
	          };
	
	          var onRowClick = function onRowClick(rowIdx, row) {
	            var grabLevels = _getLevels(row.id, row);
	            var rowId = row.id;
	            _this4.setState(function (props, state) {
	              return {
	                currentBin: null,
	                levelSelected: false,
	                currentLevel: null,
	                levels: [],
	                bin: rowId
	              }, function () {
	                grabLevels();
	              };
	            });
	          };
	
	          var _getLevels = function _getLevels(id, row) {
	            _this4.props.getLevelsByBin(id).then(function () {
	              if (_this4.props.levels) {
	                _this4.setState(function () {
	                  return {
	                    selectedLevelRows: [],
	                    levelSelected: true,
	                    levels: _this4.props.levels,
	                    bin: row.id,
	                    binRow: row,
	                    currentBin: row.section_num
	                  };
	                });
	              }
	            });
	          };
	
	          // Handle the row select function
	          var onRowSelect = function onRowSelect(rows) {
	            _this4.setState.apply(_this4, _toConsumableArray(_this4.state).concat([{ selectedRows: rows }]));
	          };
	
	          var onRowsSelected = function onRowsSelected(rows) {
	            var newRows = getRows();
	            var selectedRows = [newRows[rows[0].rowIdx]];
	            var binId = rows[0].row.id;
	            newRows.map(function (r) {
	              r.isSelected = false;
	            });
	            rows.map(function (r) {
	              newRows[r.rowIdx].isSelected = true;
	            });
	            _this4.setState(function (props, state) {
	              return {
	                binRows: newRows,
	                currentLevel: null,
	                currentBin: selectedRows[0].section_num,
	                selectedBinRows: selectedRows };
	            }, function () {
	              _getLevels(binId, rows[0].row);
	            });
	          };
	
	          var onRowsDeselected = function onRowsDeselected(rows) {
	            var rowIndexes = rows.map(function (r) {
	              return r.rowIdx;
	            });
	            var newRows = [].concat(_toConsumableArray(_this4.state.binRows));
	            rows.map(function (r) {
	              newRows[r.rowIdx].isSelected = false;
	            });
	            _this4.setState(function () {
	              return {
	                binRows: newRows,
	                selectedBinRows: [],
	                currentBin: null,
	                currentLevel: null
	              };
	            });
	          };
	
	          var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	            var comparer = function comparer(a, b) {
	              if (sortDirection === 'ASC') {
	                return a[sortColumn] > b[sortColumn] ? 1 : -1;
	              } else if (sortDirection === 'DESC') {
	                return a[sortColumn] < b[sortColumn] ? 1 : -1;
	              }
	            };
	            var bins = sortDirection === 'NONE' ? _this4.state.bins.slice(0) : _this4.state.bins.sort(comparer);
	            _this4.setState({ bins: bins });
	          };
	
	          var handleFilterChange = function handleFilterChange(filter) {
	            var newFilters = Object.assign({}, _this4.state.binFilters);
	            if (filter.filterTerm) {
	              newFilters[filter.column.key] = filter;
	            } else {
	              delete newFilters[filter.column.key];
	            }
	            _this4.setState({ binFilters: newFilters });
	          };
	
	          //Custom Formatter component
	          var DateFormatter = _react2.default.createClass({
	            displayName: 'DateFormatter',
	            render: function render() {
	              if (this.props.value) {
	                var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                var date = new Date(this.props.value);
	                var index = dateMap.indexOf(date.toString().slice(4, 3));
	                var localDate = index + date.toString().slice(8, 6);
	                return _react2.default.createElement(
	                  'span',
	                  null,
	                  date.toString().slice(4, 15)
	                );;
	              } else return _react2.default.createElement(
	                'span',
	                { className: 'label label-danger' },
	                '-'
	              );
	            }
	          });
	
	          // Column difinition
	          var columns = [{
	            key: 'section_num',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Bin' }),
	            resizable: true,
	            sortable: true,
	            filterable: true,
	            width: 140
	          }, {
	            key: 'description',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Description' }),
	            resizable: true,
	            sortable: true,
	            filterable: true,
	            width: 170
	          }];
	
	          return _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { className: 'table-buttons' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { disabled: !this.state.currentBin, onClick: function onClick(event) {
	                    return _this4.createLevel(event);
	                  } },
	                _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_level' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'warning',
	                  type: 'button',
	                  onClick: function onClick(event) {
	                    _this4.editBin(event);
	                  },
	                  disabled: !this.state.currentBin || !this.state.selectedBinRows.length },
	                _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  type: 'reset',
	                  onClick: function onClick(event) {
	                    _this4.openBin(event);
	                  },
	                  disabled: this.state.levels.length || !this.state.selectedBinRows || !this.state.currentBin },
	                _react2.default.createElement('em', { className: 'fa fa-trash-o' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { maxWidth: '99%' }, id: 'bins datagrid' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'zone_id_id',
	                enableCellSelect: true,
	                onGridSort: handleGridSort,
	                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                onAddFilter: handleFilterChange,
	                columns: columns,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                enableRowSelect: 'single',
	                minHeight: this.state.tableHeight - 70,
	                rowHeight: 25,
	                rowSelection: {
	                  showCheckbox: true,
	                  onRowsSelected: onRowsSelected,
	                  onRowsDeselected: onRowsDeselected,
	                  selectBy: {
	                    isSelectedKey: 'isSelected'
	                  }
	                },
	                onRowClick: onRowClick
	              })
	            )
	          );
	        }
	      } else {
	        return _react2.default.createElement('div', null);
	      }
	    }
	  }, {
	    key: 'renderLevelsForm',
	    value: function renderLevelsForm() {
	      var _this5 = this;
	
	      if (this.state.levelSelected && this.state.levels.length && this.state.bins) {
	        var _props6 = this.props,
	            detailError = _props6.detailError,
	            detailIsLoading = _props6.detailIsLoading;
	
	        if (detailIsLoading && !detailError) return _react2.default.createElement(_spinner2.default, { className: 'marginTopStyle' });else if (detailError) return _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.detailError)
	        );else {
	          var getRows = function getRows() {
	            return _this5.state.levels;
	          };
	
	          var getSize = function getSize() {
	            return getRows().length;
	          };
	
	          var rowGetter = function rowGetter(rowIdx) {
	            var rows = getRows();
	            return rows[rowIdx];
	          };
	
	          // Handle the row select function
	          var onRowSelect = function onRowSelect(rows) {
	            _this5.setState.apply(_this5, _toConsumableArray(_this5.state).concat([{ selectedLevelRows: rows }]));
	          };
	
	          var onRowsSelected = function onRowsSelected(rows) {
	            var newRows = getRows();
	            var selectedRows = [newRows[rows[0].rowIdx]];
	            newRows.map(function (r) {
	              r.isSelected = false;
	            });
	            rows.map(function (r) {
	              newRows[r.rowIdx].isSelected = true;
	            });
	            _this5.setState({ levelRows: newRows, selectedLevelRows: selectedRows, currentLevel: selectedRows[0].bin_num });
	          };
	
	          var onRowsDeselected = function onRowsDeselected(rows) {
	            var rowIndexes = rows.map(function (r) {
	              return r.rowIdx;
	            });
	            var newRows = [].concat(_toConsumableArray(_this5.state.rows));
	            rows.map(function (r) {
	              newRows[r.rowIdx].isSelected = false;
	            });
	            _this5.setState({ levelRows: newRows, selectedLevelRows: [], currentLevel: null });
	          };
	
	          var onRowClick = function onRowClick(rowIdx, row) {}
	          //  console.log("level:", row);
	
	          // Handle the sortable function
	          ;var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	            var comparer = function comparer(a, b) {
	              if (sortDirection === 'ASC') {
	                return a[sortColumn] > b[sortColumn] ? 1 : -1;
	              } else if (sortDirection === 'DESC') {
	                return a[sortColumn] < b[sortColumn] ? 1 : -1;
	              }
	            };
	            var levels = sortDirection === 'NONE' ? _this5.state.levels.slice(0) : _this5.state.levels.sort(comparer);
	            _this5.setState({ levels: levels });
	          };
	
	          var handleFilterChange = function handleFilterChange(filter) {
	            var newFilters = Object.assign({}, _this5.state.levelFilters);
	            if (filter.filterTerm) {
	              newFilters[filter.column.key] = filter;
	            } else {
	              delete newFilters[filter.column.key];
	            }
	            _this5.setState({ levelFilters: newFilters });
	          };
	
	          //Custom Formatter component
	          var DateFormatter = _react2.default.createClass({
	            displayName: 'DateFormatter',
	            render: function render() {
	              if (this.props.value) {
	                var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                var date = new Date(this.props.value);
	                var index = dateMap.indexOf(date.toString().slice(4, 3));
	                var localDate = index + date.toString().slice(8, 6);
	                return _react2.default.createElement(
	                  'span',
	                  null,
	                  date.toString().slice(4, 15)
	                );;
	              } else return _react2.default.createElement(
	                'span',
	                { className: 'label label-danger' },
	                '-'
	              );
	            }
	          });
	
	          // Column difinition
	          var columns = [{
	            key: 'bin_num',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Level' }),
	            resizable: true,
	            sortable: true,
	            filterable: true,
	            width: 140
	          }, {
	            key: 'description',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Description' }),
	            resizable: true,
	            sortable: true,
	            filterable: true,
	            width: 170
	          }];
	
	          return _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { className: 'table-buttons' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'warning',
	                  type: 'button',
	                  onClick: function onClick(event) {
	                    _this5.editLevel(event);
	                  },
	                  disabled: !this.state.currentLevel || !this.state.selectedLevelRows.length },
	                _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  type: 'reset',
	                  onClick: function onClick(event) {
	                    _this5.openLevel(event);
	                  },
	                  disabled: !this.state.currentLevel || !this.state.selectedLevelRows.length },
	                _react2.default.createElement('em', { className: 'fa fa-trash-o' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { maxWidth: '99%' }, id: 'levels datagrid' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'section_id_id',
	                enableCellSelect: true,
	                onGridSort: handleGridSort,
	                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                onAddFilter: handleFilterChange,
	                columns: columns,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                enableRowSelect: 'single',
	                minHeight: this.state.tableHeight - 70,
	                rowHeight: 25,
	                onRowClick: onRowClick,
	                rowSelection: {
	                  showCheckbox: true,
	                  onRowsSelected: onRowsSelected,
	                  onRowsDeselected: onRowsDeselected,
	                  selectBy: {
	                    isSelectedKey: 'isSelected'
	                  }
	                }
	              })
	            )
	          );
	        }
	      } else {
	        return _react2.default.createElement('div', null);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _props7 = this.props,
	          handleSubmit = _props7.handleSubmit,
	          closeG = _props7.closeG,
	          submitting = _props7.submitting,
	          pristine = _props7.pristine,
	          valid = _props7.valid;
	
	      var height = (this.state.tableHeight + 30).toString();
	      var tableCollapseFix = { height: height };
	      var createDialogStyle = {
	        width: '650px',
	        marginLeft: '-15%'
	      };
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_management' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_detail_view' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { fluid: 'true' },
	          _react2.default.createElement(
	            'form',
	            { method: 'get', action: '#', onSubmit: handleSubmit(this.searchZones.bind(this)) },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/warehouses', className: 'btn btn-green buttonStyle' },
	                    _react2.default.createElement('em', { className: 'fa fa-mail-reply' })
	                  )
	                ),
	                _react2.default.createElement(_reactBootstrap.Col, { sm: 5 }),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 3 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'ZoneName', component: renderSearchField })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(
	                    'button',
	                    { action: 'submit', className: 'btn btn-primary buttonStyle', disabled: submitting || pristine || !valid },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            { className: 'marginTopStyle' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 12 },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_detail_view' }),
	                ' | ',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse' })
	              )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 12 },
	                this.renderWarehouseDetail()
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    style: { margin: 5 },
	                    onClick: function onClick(event) {
	                      return _this6.createZone(event);
	                    } },
	                  _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_zone' })
	                ),
	                this.renderBarcode(),
	                this.renderAllBarcode(),
	                _react2.default.createElement(
	                  _reactDropzone2.default,
	                  {
	                    onDrop: this.onDrop.bind(this),
	                    className: 'upload-button'
	                  },
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                      style: { margin: 5 },
	                      bsStyle: 'warning',
	                      type: 'button',
	                      onClick: this.exportZoneBinLevel
	                    },
	                    _react2.default.createElement('em', { className: 'fa fa-arrow-circle-o-up' }),
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'upload_file' })
	                  )
	                ),
	                this.importZoneBinLevel()
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            { style: tableCollapseFix },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { sm: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 5 },
	                _react2.default.createElement(
	                  _reactBootstrap.ButtonToolbar,
	                  { className: 'table-buttons' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { style: { marginBottom: '5px', marginLeft: '5px' } },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        style: { marginRight: '5px' },
	                        bsStyle: 'warning',
	                        type: 'button',
	                        onClick: function onClick(event) {
	                          _this6.editZone(event);
	                        },
	                        disabled: !this.state.currentZone },
	                      _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        style: { marginRight: '5px' },
	                        bsStyle: 'danger',
	                        type: 'reset',
	                        onClick: this.openModal,
	                        disabled: !this.state.currentZone || this.props.bins.length },
	                      _react2.default.createElement('em', { className: 'fa fa-trash-o' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      { style: { marginRight: '5px' }, onClick: function onClick(event) {
	                          return _this6.createBin(event);
	                        } },
	                      _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_bin' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { style: { marginLeft: '5px' } },
	                    isEcity && this.renderAllZoneBarcode()
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { sm: 12 },
	              this.renderZonesForm(),
	              this.renderBinsForm(),
	              this.renderLevelsForm()
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              isVisible: this.state.zoneOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this6.closeZone();
	              },
	              title: this.state.title },
	            _react2.default.createElement(_zoneForm2.default, {
	              closeG: this.closeZone,
	              hierarchy: 'zone',
	              value: this.state.zone ? this.state.zone : null })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              isVisible: this.state.binSaveOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this6.binCloseSave();
	              },
	              title: this.state.title },
	            _react2.default.createElement(_zoneForm2.default, {
	              closeG: this.binCloseSave,
	              hierarchy: 'bin',
	              value: this.state.zone ? this.state.zone.WarehouseZone_id : null,
	              selectedBin: this.state.selectedBinRows ? this.state.selectedBinRows[0] : null
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              isVisible: this.state.levelSaveOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this6.levelCloseSave();
	              },
	              title: this.state.title
	            },
	            _react2.default.createElement(_zoneForm2.default, {
	              closeG: this.levelCloseSave,
	              hierarchy: 'level',
	              value: this.state.bin ? this.state.bin : null,
	              selectedLevel: this.state.selectedLevelRows ? this.state.selectedLevelRows[0] : null
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogStyle,
	              isVisible: this.state.modalOpen,
	              onCloseClicked: this.closeModal,
	              title: 'Delete Zone?' },
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'centerStyle' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' }),
	                ': ',
	                this.state.currentZone ? this.state.currentZone : null,
	                '?'
	              )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'text-center' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { onClick: function onClick(e) {
	                    return _this6.deleteZone(e);
	                  }, className: 'text-center', bsStyle: 'primary', type: 'button' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { onClick: this.closeModal, className: 'text-center', bsStyle: 'danger', type: 'button' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogStyle,
	              isVisible: this.state.binOpen,
	              onCloseClicked: this.closeBin,
	              title: 'Delete Bin?' },
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'centerStyle' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' }),
	                ': ',
	                this.state.currentBin ? this.state.currentBin : null,
	                '?'
	              )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'text-center' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { onClick: function onClick(e) {
	                    return _this6.deleteBin(e);
	                  }, className: 'text-center', bsStyle: 'primary', type: 'button' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { onClick: this.closeBin, className: 'text-center', bsStyle: 'danger', type: 'button' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogStyle,
	              isVisible: this.state.levelOpen,
	              onCloseClicked: this.closeLevel,
	              title: 'Delete Level?' },
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'centerStyle' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' }),
	                ': ',
	                this.state.currentLevel ? this.state.currentLevel : null,
	                '?'
	              )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'text-center' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { onClick: function onClick(e) {
	                    return _this6.deleteLevel(e);
	                  }, className: 'text-center', bsStyle: 'primary', type: 'button' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { onClick: this.closeLevel, className: 'text-center', bsStyle: 'danger', type: 'button' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return WarehouseForm;
	}(_react.Component);
	
	WarehouseForm.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = WarehouseForm;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/warehouseDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(isABCFF, 'isABCFF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/warehouseDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(renderSearchField, 'renderSearchField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/warehouseDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(WarehouseForm, 'WarehouseForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/warehouseDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/warehouseDetail.jsx');
	}();

	;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactRouter = __webpack_require__(13);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style'
	
	
	var WarehouseForm = function (_Component) {
	    _inherits(WarehouseForm, _Component);
	
	    function WarehouseForm() {
	        _classCallCheck(this, WarehouseForm);
	
	        return _possibleConstructorReturn(this, (WarehouseForm.__proto__ || Object.getPrototypeOf(WarehouseForm)).apply(this, arguments));
	    }
	
	    _createClass(WarehouseForm, [{
	        key: 'handleFormSubmit',
	
	        // static contextTypes = {
	        //     router: React.PropTypes.object
	        // };
	        //
	        // constructor() {
	        //     super();
	        //     this.state = {
	        //         dirty: false
	        //     };
	        // }
	
	        // componentDidMount() {
	        //     // making a leaving hook to confirm leaving
	        //     this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
	        //
	        //     if (this.props.currentWarehouse) this.props.fetchWarehouseDetail(this.props.currentWarehouse);
	        // }
	
	        value: function handleFormSubmit(formProps) {
	            // this.setState({ dirty: false });
	            if (this.props.currentWarehouse) this.props.editWarehouse(formProps);else this.props.createWarehouse(formProps);
	        }
	
	        // componentWillReceiveProps(nextProps) {
	        //     if (nextProps.dirty != this.props.dirty) {
	        //         this.setState({
	        //             dirty: nextProps.dirty
	        //         });
	        //     }
	        // }
	
	        // routerWillLeave(nextLocation) {
	        //     if (this.state.dirty) return <Translate value="work_not_saved_warning" />
	        // }
	
	        // title() {
	        //     if (this.props.currentWarehouse) return <Translate value="warehouse_detail_view" />| <Translate value="edit_warehouse" />;
	        //     else return <Translate value="warehouse_detail_view" /> | <Translate value="create_warehouse" />;
	        // }
	
	    }, {
	        key: 'renderForm',
	        value: function renderForm() {
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(_reactBootstrap.Col, { sm: 2 }),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 4 },
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_name' }),
	                                ' (*) '
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'Name', component: _inputField2.default })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' }),
	                                ' (*) '
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'Street', component: _inputField2.default, placeholder: 'Street' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'City', component: _inputField2.default, placeholder: 'City' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'State', component: _inputField2.default, placeholder: 'State' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'Zip', component: _inputField2.default, placeholder: 'Zip' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'contact_person' })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'FirstName', component: _inputField2.default, placeholder: 'First Name' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'LastName', component: _inputField2.default, placeholder: 'LastName' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'Email', component: _inputField2.default, placeholder: 'example@abc.com' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 12 },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 12 },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Telephone', component: _inputField2.default, placeholder: '123-456-7890' })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 12 },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mobile' })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 12 },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Cellphone', component: _inputField2.default, placeholder: '123-456-7890' })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fax' })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'Fax', component: _inputField2.default, placeholder: '123-456-7890' })
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                closeG = _props.closeG,
	                submitting = _props.submitting,
	                pristine = _props.pristine,
	                valid = _props.valid;
	
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'form',
	                    { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pull-right' },
	                        this.props.isCreating || this.props.isEditing && _react2.default.createElement(_spinner2.default, null),
	                        this.props.createError && _react2.default.createElement(
	                            'div',
	                            { className: 'alert alert-danger marginTopStyle' },
	                            JSON.stringify(this.props.createError)
	                        ),
	                        this.props.editError && _react2.default.createElement(
	                            'div',
	                            { className: 'alert alert-danger marginTopStyle' },
	                            JSON.stringify(this.props.editError)
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { action: 'submit', className: 'btn btn-primary buttonStyle', disabled: submitting || pristine || !valid || !(0, _permissions2.default)("change_warehouse") },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-danger buttonStyle', onClick: function onClick(event) {
	                                    event.preventDefault();closeG();
	                                } },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	                        )
	                    ),
	                    this.renderForm()
	                )
	            );
	        }
	    }]);
	
	    return WarehouseForm;
	}(_react.Component);
	
	var _default = (0, _reactRouter.withRouter)(WarehouseForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(WarehouseForm, 'WarehouseForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/warehouseForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/warehouseForm.jsx');
	}();

	;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _googleMapContainer = __webpack_require__(344);
	
	var _googleMapContainer2 = _interopRequireDefault(_googleMapContainer);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _warehouseForm = __webpack_require__(175);
	
	var _warehouseForm2 = _interopRequireDefault(_warehouseForm);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import {buttonStyle, borderStyle} from '../Common/style'
	
	// Dummy data
	
	// const warehouses = [
	//     {
	//         id: '1',
	//         Name: "RongCheng",
	//         Address: "895 Dove Street, Irvine",
	//         Contact: "Nat",
	//         Email: "nat1988@gmail.com",
	//         Phone: "192-583-4859",
	//         Fax: "483-183-4582",
	//         lng: "-117.8442962",
	//         lat: "33.6404952"
	//     },
	//     {
	//         id: '2',
	//         Name: "Truckxi",
	//         Address: "516 Veneto, Irvine",
	//         Contact: "Mars",
	//         Email: "asdf284@gmail.com",
	//         Phone: "486-293-4931",
	//         Fax: "867-103-5849",
	//         lng: "-118.3533783",
	//         lat: "34.1381168"
	//     }
	// ]
	
	var renderSearchField = function renderSearchField(props) {
	    return _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { standalone: true, type: 'text', placeholder: 'Warehouse Name' }));
	};
	
	var Warehouse = function (_Component) {
	    _inherits(Warehouse, _Component);
	
	    function Warehouse() {
	        _classCallCheck(this, Warehouse);
	
	        var _this = _possibleConstructorReturn(this, (Warehouse.__proto__ || Object.getPrototypeOf(Warehouse)).call(this));
	
	        _this.state = {
	            currentWarehouse: {},
	
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.noButton,
	            warehouseOpen: false
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        _this.searchWarehouses = _this.searchWarehouses.bind(_this);
	        _this.openWarehouse = _this.openWarehouse.bind(_this);
	        _this.closeWarehouse = _this.closeWarehouse.bind(_this);
	        return _this;
	    }
	
	    _createClass(Warehouse, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            document.title = _root_url.companyCodeTitle;
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchWarehouses();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.updated) {
	                this.props.fetchWarehouses();
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.noButton });
	        }
	    }, {
	        key: 'viewWarehouse',
	        value: function viewWarehouse(id) {
	            this.props.resetCurrentWarehouse();
	            this.props.selectWarehouse(id);
	            this.context.router.push('/warehouses/detail');
	        }
	    }, {
	        key: 'editWarehouse',
	        value: function editWarehouse(id) {
	            this.props.resetCurrentWarehouse();
	            this.props.selectWarehouse(id);
	            this.openWarehouse();
	            // this.context.router.push('/warehouses/form');
	        }
	    }, {
	        key: 'searchWarehouses',
	        value: function searchWarehouses() {
	            var _props = this.props,
	                fetchWarehouses = _props.fetchWarehouses,
	                searchWarehouses = _props.searchWarehouses,
	                nameValue = _props.nameValue;
	
	            if (!nameValue) fetchWarehouses();else searchWarehouses(nameValue);
	        }
	    }, {
	        key: 'openWarehouse',
	        value: function openWarehouse() {
	            this.setState({ warehouseOpen: true });
	        }
	    }, {
	        key: 'closeWarehouse',
	        value: function closeWarehouse() {
	            this.setState({ warehouseOpen: false });
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            this.props.resetCurrentWarehouse();
	            this.openWarehouse();
	        }
	    }, {
	        key: 'deleteZone',
	        value: function deleteZone(id) {
	            this.props.resetCurrentWarehouse();
	            this.props.deleteZone(id);
	        }
	    }, {
	        key: 'renderWarehousesDropdown',
	        value: function renderWarehousesDropdown() {
	            var _this2 = this;
	
	            var wList = [];
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    this.props.error.message
	                )
	            );else {
	                var warehouses = this.props.warehouses;
	                if (warehouses) {
	                    var _loop = function _loop(k) {
	                        var Name = warehouses[k].Name;
	                        var Warehouse_id = warehouses[k].Warehouse_id;
	                        wList.push(_react2.default.createElement(
	                            _reactBootstrap.MenuItem,
	                            { eventKey: k, style: { width: '100%' } },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    onClick: function onClick() {
	                                        _this2.props.editWarehouseDefault(Warehouse_id, true);
	                                    },
	                                    style: { width: '100%' },
	                                    disabled: !(0, _permissions2.default)('change_warehouse')
	                                },
	                                Name + " ID: " + Warehouse_id
	                            )
	                        ));
	                    };
	
	                    for (var k = 0; k < warehouses.length; k++) {
	                        _loop(k);
	                    }
	                }
	            }
	            return wList;
	        }
	    }, {
	        key: 'renderWarehouses',
	        value: function renderWarehouses() {
	            var _this3 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    this.props.error.message
	                )
	            );else {
	                var warehouses = this.props.warehouses;
	                if (warehouses) {
	                    return warehouses.map(function (warehouse) {
	                        var Name = warehouse.Name,
	                            Street = warehouse.Street,
	                            City = warehouse.City,
	                            State = warehouse.State,
	                            FirstName = warehouse.FirstName,
	                            LastName = warehouse.LastName,
	                            Email = warehouse.Email,
	                            Telephone = warehouse.Telephone,
	                            Fax = warehouse.Fax,
	                            Longitude = warehouse.Longitude,
	                            Latitude = warehouse.Latitude,
	                            Warehouse_id = warehouse.Warehouse_id,
	                            IsDefault = warehouse.IsDefault;
	
	                        var Total_size = Math.floor(Math.random() * (100000 - 50000 + 1)) + 50000;
	                        var coordinate = { lng: Longitude, lat: Latitude };
	                        var Address = Street + ", " + City + ", " + State;
	                        var Contact = FirstName + " " + LastName;
	                        var WarehouseTitle = "Warehouse: " + Name;
	                        var currentWarehouse = { WarehouseTitle: WarehouseTitle, Contact: Contact, Address: Address, coordinate: coordinate };
	                        // const warehousePanelHeader = ( <Row><Col xs={12}><h4>{Name}</h4></Col> </Row> );
	                        return _react2.default.createElement(
	                            'div',
	                            { key: Warehouse_id },
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                _reactBootstrap.Panel,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { xs: 12 },
	                                        _react2.default.createElement(
	                                            'h4',
	                                            null,
	                                            Name
	                                        )
	                                    ),
	                                    ' '
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    { className: 'pull-right' },
	                                    _react2.default.createElement('em', { className: 'fa fa-pencil buttonStyle', onClick: function onClick() {
	                                            return _this3.editWarehouse(warehouse);
	                                        } })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    IsDefault ? _react2.default.createElement(
	                                        'span',
	                                        { style: { 'padding-left': '8px' } },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'label label-success' },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'default' })
	                                        )
	                                    ) : ''
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 12 },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_id' }),
	                                        ' ',
	                                        Warehouse_id
	                                    ),
	                                    ' '
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 12 },
	                                        _react2.default.createElement('em', { className: 'fa fa-building-o marginRightStyle' }),
	                                        Address || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 12 },
	                                        _react2.default.createElement('em', { className: 'fa fa-user marginRightStyle' }),
	                                        Contact || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'contact_person' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 12 },
	                                        _react2.default.createElement('em', { className: 'fa fa-envelope marginRightStyle' }),
	                                        Email || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 12 },
	                                        _react2.default.createElement('em', { className: 'fa fa-phone marginRightStyle' }),
	                                        Telephone || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 12 },
	                                        _react2.default.createElement('em', { className: 'fa fa-fax marginRightStyle' }),
	                                        Fax || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fax' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 12 },
	                                        _react2.default.createElement(
	                                            'a',
	                                            { onClick: function onClick() {
	                                                    return _this3.viewWarehouse(warehouse);
	                                                }, style: { cursor: "pointer" } },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'detail' })
	                                        )
	                                    )
	                                )
	                            )
	                        );
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'formTitle',
	        value: function formTitle() {
	            if (this.props.currentWarehouse) return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_warehouse' });else return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_a_new_warehouse' });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _props2 = this.props,
	                isLoading = _props2.isLoading,
	                error = _props2.error,
	                handleSubmit = _props2.handleSubmit;
	
	            var height = (this.state.tableHeight + 30).toString();
	            var mapCollapseFix = { height: height };
	            // let detailsTableHeight = (this.state.tableHeight-25).toString();
	            // let detailsTableCollapseFix = {height: detailsTableHeight};
	            var searchBarHeight = ((this.state.tableHeight + 30) / 5).toString();
	            var searchBarCollapseFix = { height: searchBarHeight };
	            return (
	                //---------------
	                // Begin HTML: Create New/Edit Warehouse
	                //---------------
	                _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_management' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            { active: 'true' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Grid,
	                        { fluid: 'true', id: 'warehouse-list' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 3, style: { overflowY: "scroll", maxHeight: height } },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 12 },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Panel,
	                                        null,
	                                        _react2.default.createElement(
	                                            'form',
	                                            { onSubmit: handleSubmit(this.searchWarehouses) },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 7 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'WarehouseName', component: renderSearchField })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 2 },
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Button,
	                                                        { type: 'submit' },
	                                                        _react2.default.createElement('em', { className: 'fa fa-search' })
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 3 },
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Button,
	                                                        {
	                                                            bsStyle: 'primary',
	                                                            onClick: function onClick(event) {
	                                                                _this4.clickNew(event);
	                                                            },
	                                                            disabled: !(0, _permissions2.default)('add_warehouse')
	                                                        },
	                                                        _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add' })
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Panel,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.ButtonGroup,
	                                            { className: 'warehouse_dropdown_group', style: { 'width': '100%' } },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.DropdownButton,
	                                                { title: 'Change Default Warehouse', disabled: !(0, _permissions2.default)('change_warehouse'), className: 'warehouse_dropdown', type: 'submit', bsStyle: 'success', style: { 'width': '100%' } },
	                                                this.renderWarehousesDropdown()
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 12 },
	                                    this.renderWarehouses(),
	                                    _react2.default.createElement(
	                                        _reactSkylight.SkyLightStateless,
	                                        { isVisible: this.state.warehouseOpen, onCloseClicked: function onCloseClicked() {
	                                                _this4.closeWarehouse();
	                                            }, title: this.formTitle() },
	                                        _react2.default.createElement(_warehouseForm2.default, { closeG: this.closeWarehouse })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 9 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { style: mapCollapseFix },
	                                    _react2.default.createElement(_googleMapContainer2.default, { currentWarehouse: this.state.currentWarehouse, responsive: true })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Warehouse;
	}(_react.Component);
	
	Warehouse.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = Warehouse;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(renderSearchField, 'renderSearchField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/warehouses.jsx');
	
	    __REACT_HOT_LOADER__.register(Warehouse, 'Warehouse', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/warehouses.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/warehouses.jsx');
	}();

	;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _binForm = __webpack_require__(173);
	
	var _binForm2 = _interopRequireDefault(_binForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle, marginTopStyle, centerStyle, descriptionStyle} from '../Common/style'
	
	var renderSearchField = function renderSearchField(props) {
	  return _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { standalone: true, type: 'text', placeholder: 'Search Bin...' }));
	};
	
	var ZoneDetail = function (_Component) {
	  _inherits(ZoneDetail, _Component);
	
	  function ZoneDetail() {
	    _classCallCheck(this, ZoneDetail);
	
	    var _this = _possibleConstructorReturn(this, (ZoneDetail.__proto__ || Object.getPrototypeOf(ZoneDetail)).call(this));
	
	    _this.openConfirm = function (binID) {
	      _this.setState({
	        confirmOpen: true,
	        selectedBin: binID
	      });
	    };
	
	    _this.closeConfirm = function () {
	      _this.setState({
	        confirmOpen: false,
	        selectedBin: null
	      });
	    };
	
	    _this.handleConfirmDelete = function () {
	      if (_this.state.selectedBin) {
	        _this.props.deleteBin(_this.state.selectedBin).then(function () {
	          if (!_this.props.currentZone) {
	            _this.context.router.push('/warehouses');
	          } else {
	            _this.props.fetchZoneDetail(_this.props.currentZone);
	          }
	        });
	      }
	      _this.closeConfirm();
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.fourLineButton,
	      zoneOpen: false,
	      binOpen: false,
	      confirmOpen: false,
	      selectedBin: null
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.searchBins = _this.searchBins.bind(_this);
	    _this.openZone = _this.openZone.bind(_this);
	    _this.closeZone = _this.closeZone.bind(_this);
	    _this.openBin = _this.openBin.bind(_this);
	    _this.closeBin = _this.closeBin.bind(_this);
	    return _this;
	  }
	
	  _createClass(ZoneDetail, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.handleResize);
	
	      if (!this.props.currentZone) this.context.router.push('/warehouses');else this.props.fetchZoneDetail(this.props.currentZone);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.fourLineButton });
	    }
	  }, {
	    key: 'openZone',
	    value: function openZone() {
	      this.setState({ zoneOpen: true });
	    }
	  }, {
	    key: 'closeZone',
	    value: function closeZone() {
	      this.setState({ zoneOpen: false });
	    }
	  }, {
	    key: 'openBin',
	    value: function openBin() {
	      this.setState({ binOpen: true });
	    }
	  }, {
	    key: 'closeBin',
	    value: function closeBin() {
	      this.setState({ binOpen: false });
	    }
	  }, {
	    key: 'viewBin',
	    value: function viewBin(id) {
	      this.props.resetCurrentBin();
	      this.props.selectBin(id);
	      this.openBin();
	    }
	  }, {
	    key: 'editBin',
	    value: function editBin(id) {
	      this.props.resetCurrentBin();
	      this.props.selectBin(id);
	      this.openBin();
	    }
	  }, {
	    key: 'createBin',
	    value: function createBin(e) {
	      e.preventDefault();
	      this.props.resetCurrentBin();
	      this.openBin();
	    }
	  }, {
	    key: 'searchBins',
	    value: function searchBins() {
	      var _props = this.props,
	          fetchZoneDetail = _props.fetchZoneDetail,
	          searchBins = _props.searchBins,
	          nameValue = _props.nameValue,
	          currentZone = _props.currentZone;
	
	      if (!nameValue) fetchZoneDetail(currentZone);else searchBins(nameValue);
	    }
	  }, {
	    key: 'deleteBin',
	    value: function deleteBin(id) {
	      this.props.resetCurrentBin();
	      this.openConfirm(id);
	      // this.setState({ selectedBin: id });
	    }
	  }, {
	    key: 'renderZoneDetail',
	    value: function renderZoneDetail() {
	      var _props2 = this.props,
	          detailError = _props2.detailError,
	          detailIsLoading = _props2.detailIsLoading,
	          currentZoneDetail = _props2.currentZoneDetail;
	
	      if (detailIsLoading && !detailError) {
	        return _react2.default.createElement(_spinner2.default, { className: 'marginTopStyle' });
	      } else if (detailError) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(detailError)
	        );
	      } else if (currentZoneDetail) {
	        var Name = currentZoneDetail.Name,
	            Description = currentZoneDetail.Description,
	            warehouseZoneId = currentZoneDetail.WarehouseZone_id;
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 12 },
	              _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone' }),
	                ': ',
	                Name || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 12 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_zone_id' }),
	              ': ',
	              warehouseZoneId
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'marginTopStyle' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 12 },
	              _react2.default.createElement('em', { className: 'fa fa-building-o marginRightStyle' }),
	              Description || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	            )
	          )
	        );
	      }
	      return undefined;
	    }
	  }, {
	    key: 'renderProducts',
	    value: function renderProducts(bin) {
	      var products = bin.Product;
	      if (products) {
	        return products.map(function (product) {
	          return _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'marginTopStyle' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 12, style: { color: 'blue' } },
	              ' ',
	              product.Name,
	              ' '
	            )
	          );
	        });
	      }
	      return undefined;
	    }
	  }, {
	    key: 'renderBins',
	    value: function renderBins() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          bins = _props3.bins,
	          detailError = _props3.detailError,
	          detailIsLoading = _props3.detailIsLoading;
	
	      if (detailIsLoading && !detailError) {
	        return _react2.default.createElement(_spinner2.default, { className: 'marginTopStyle' });
	      } else if (detailError) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.detailError)
	        );
	      }
	      if (bins) {
	        return bins.map(function (bin) {
	          var Name = bin.Name,
	              Description = bin.Description,
	              warehouseBinId = bin.WarehouseBin_id;
	
	          return _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { style: { overflowY: 'scroll', height: _this2.state.tableHeight / 2 } },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _this2.props.deleteBinFailureError && _this2.state.selectedBin === warehouseBinId && _react2.default.createElement(
	                  'div',
	                  { className: 'alert alert-danger' },
	                  _this2.props.deleteBinFailureError
	                ),
	                _this2.props.deleteBinSuccess && _this2.state.selectedBin === warehouseBinId && _react2.default.createElement(
	                  'div',
	                  { className: 'alert alert-success' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deleted' })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 12 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 9 },
	                      _react2.default.createElement(
	                        'a',
	                        { onClick: function onClick() {
	                            return _this2.viewBin(bin);
	                          }, style: { cursor: 'pointer' } },
	                        _react2.default.createElement('em', { className: 'fa fa-institution marginRightStyle' }),
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin' }),
	                          ' ',
	                          Name || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 3 },
	                      _react2.default.createElement('em', {
	                        className: 'fa fa-trash buttonStyle',
	                        onClick: function onClick() {
	                          return _this2.deleteBin(warehouseBinId);
	                        }
	                      }),
	                      _react2.default.createElement('em', {
	                        className: 'fa fa-pencil buttonStyle',
	                        onClick: function onClick() {
	                          return _this2.editBin(bin);
	                        }
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 12 },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                        ': '
	                      ),
	                      _react2.default.createElement('em', { className: 'fa fa-building marginLeftStyle marginRightStyle' }),
	                      Description || '-'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 12 },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'products' }),
	                        ':'
	                      )
	                    )
	                  ),
	                  _this2.renderProducts(bin)
	                )
	              )
	            )
	          );
	        });
	      }
	    }
	  }, {
	    key: 'renderFormTitle',
	    value: function renderFormTitle() {
	      if (this.props.currentBin) {
	        return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_bin' });
	      }
	      return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_a_new_bin' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var handleSubmit = this.props.handleSubmit;
	
	      var height = (this.state.tableHeight + 50).toString();
	      var tableCollapseFix = { height: height };
	      var createDialogStyle = {
	        width: '600px',
	        marginLeft: '-15%'
	      };
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_management' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_detail_view' }),
	            ' ',
	            '|',
	            ' ',
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { fluid: 'true', id: 'zone-detail' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              null,
	              _react2.default.createElement(
	                'form',
	                { method: 'get', action: '#', onSubmit: handleSubmit(this.searchBins.bind(this)) },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      {
	                        to: '/warehouses/detail',
	                        className: 'btn btn-green buttonStyle'
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-mail-reply' })
	                    )
	                  )
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    this.renderZoneDetail()
	                  )
	                ),
	                _react2.default.createElement('hr', { className: 'marginRightStyle' }),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                          'h4',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all_bins' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          null,
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'BinName', component: renderSearchField })
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 2 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Button,
	                              { type: 'submit' },
	                              _react2.default.createElement('em', { className: 'fa fa-search' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 7 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Button,
	                              {
	                                onClick: function onClick(event) {
	                                  return _this3.createBin(event);
	                                },
	                                className: 'btn btn-primary pull-right'
	                              },
	                              _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_new_bin' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          null,
	                          _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { style: tableCollapseFix },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              { style: { overflowY: 'scroll', maxHeight: this.state.tableHeight } },
	                              this.renderBins()
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { isVisible: this.state.binOpen, onCloseClicked: this.closeBin, title: this.renderFormTitle() },
	              _react2.default.createElement(_binForm2.default, { closeG: this.closeBin })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                dialogStyles: createDialogStyle,
	                isVisible: this.state.confirmOpen,
	                onCloseClicked: this.closeConfirm,
	                title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete_bin' })
	              },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_confirm_delete' })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle' },
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'primary',
	                    className: 'mt mr',
	                    onClick: this.handleConfirmDelete
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-check' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Confirm' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'danger',
	                    className: 'mt mr',
	                    onClick: this.closeConfirm
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-close' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Cancel' })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ZoneDetail;
	}(_react.Component);
	
	ZoneDetail.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = ZoneDetail;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(renderSearchField, 'renderSearchField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/zoneDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(ZoneDetail, 'ZoneDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/zoneDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/zoneDetail.jsx');
	}();

	;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style';
	
	var ZoneForm = function (_Component) {
	  _inherits(ZoneForm, _Component);
	
	  function ZoneForm() {
	    _classCallCheck(this, ZoneForm);
	
	    return _possibleConstructorReturn(this, (ZoneForm.__proto__ || Object.getPrototypeOf(ZoneForm)).apply(this, arguments));
	  }
	
	  _createClass(ZoneForm, [{
	    key: 'handleZoneFormSubmit',
	    value: function handleZoneFormSubmit(formProps) {
	      var props = _extends({}, formProps, { zone_num: formProps.Name, Description: formProps.Description || '' });
	      if (this.props.currentZone) {
	        this.props.editZone(props);
	      } else {
	        this.props.createZone(props, this.props.currentWarehouse.Warehouse_id);
	      }
	    }
	  }, {
	    key: 'handleBinFormSubmit',
	    value: function handleBinFormSubmit(formProps) {
	      var selectedBin = this.props.selectedBin;
	
	      var props = { section_num: formProps.Name, description: formProps.description || '', zone_id: this.props.value || selectedBin.zone_id_id };
	      if (this.props.currentBin && selectedBin) {
	        this.props.editBins(props, selectedBin.id);
	      } else {
	        this.props.generateBin(props);
	      }
	    }
	  }, {
	    key: 'handleLevelFormSubmit',
	    value: function handleLevelFormSubmit(formProps) {
	      var selectedLevel = this.props.selectedLevel;
	
	      var props = { bin_num: formProps.Name, description: formProps.description || '', section_id: this.props.value || selectedLevel.section_id_id };
	      if (this.props.currentLevel && selectedLevel) {
	        this.props.editLevels(props, selectedLevel.id);
	      } else {
	        this.props.createBin(props);
	      }
	    }
	  }, {
	    key: 'renderZoneForm',
	    value: function renderZoneForm() {
	      var _props = this.props,
	          detailError = _props.detailError,
	          detailIsLoading = _props.detailIsLoading,
	          handleSubmit = _props.handleSubmit,
	          submitting = _props.submitting,
	          pristine = _props.pristine,
	          valid = _props.valid,
	          closeG = _props.closeG;
	
	      if (detailIsLoading && !detailError) return _react2.default.createElement(_spinner2.default, { className: 'marginTopStyle' });else if (detailError) return _react2.default.createElement(
	        'div',
	        { className: 'alert alert-danger' },
	        JSON.stringify(this.props.detailError)
	      );
	      if (this.props.hierarchy === 'zone') {
	        return _react2.default.createElement(
	          'form',
	          { method: 'get', action: '#', onSubmit: handleSubmit(this.handleZoneFormSubmit.bind(this)) },
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-right' },
	            this.props.isCreating || this.props.isEditing && _react2.default.createElement(_spinner2.default, null),
	            _react2.default.createElement(
	              'button',
	              { action: 'submit', className: 'btn btn-primary buttonStyle', disabled: submitting || pristine || !valid },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-danger buttonStyle', onClick: function onClick(event) {
	                  event.preventDefault();closeG();
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(_reactBootstrap.Col, { sm: 1 }),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 4 },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement('em', { className: 'fa fa-building-o marginRightStyle' }),
	                    '| ',
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_name' }),
	                    ' (*) '
	                  ),
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Name', component: _inputField2.default, placeholder: 'Zone Name' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(_reactBootstrap.Col, { sm: 1 }),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 4 },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement('em', { className: 'fa fa-building-o marginRightStyle' }),
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Description' }),
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 12 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'description', component: 'Textarea', className: 'form-control', style: { minHeight: '150px' } })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement('div', null);
	      }
	    }
	  }, {
	    key: 'renderBinForm',
	    value: function renderBinForm() {
	      var _props2 = this.props,
	          detailError = _props2.detailError,
	          detailIsLoading = _props2.detailIsLoading,
	          handleSubmit = _props2.handleSubmit,
	          submitting = _props2.submitting,
	          pristine = _props2.pristine,
	          valid = _props2.valid,
	          closeG = _props2.closeG;
	
	      if (detailIsLoading && !detailError) return _react2.default.createElement(_spinner2.default, { className: 'marginTopStyle' });else if (detailError) return _react2.default.createElement(
	        'div',
	        { className: 'alert alert-danger' },
	        JSON.stringify(this.props.detailError)
	      );
	      if (this.props.hierarchy === 'bin') {
	        return _react2.default.createElement(
	          'form',
	          { method: 'get', action: '#', onSubmit: handleSubmit(this.handleBinFormSubmit.bind(this)) },
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-right' },
	            this.props.isCreating || this.props.isEditing && _react2.default.createElement(_spinner2.default, null),
	            _react2.default.createElement(
	              'button',
	              { action: 'submit', className: 'btn btn-primary buttonStyle', disabled: submitting || pristine || !valid },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-danger buttonStyle', onClick: function onClick(event) {
	                  event.preventDefault();closeG();
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(_reactBootstrap.Col, { sm: 1 }),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 4 },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement('em', { className: 'fa fa-building-o marginRightStyle' }),
	                    '| ',
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin_name' }),
	                    ' (*) '
	                  ),
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Name', component: _inputField2.default })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(_reactBootstrap.Col, { sm: 1 }),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 4 },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement('em', { className: 'fa fa-building-o marginRightStyle' }),
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Description' }),
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 12 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'description', placeholder: this.props.currentBin ? this.props.currentBin.description : "Description",
	                        component: 'Textarea', className: 'form-control', style: { minHeight: '150px' } })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement('div', null);
	      }
	    }
	  }, {
	    key: 'renderLevelForm',
	    value: function renderLevelForm() {
	      var _props3 = this.props,
	          detailError = _props3.detailError,
	          detailIsLoading = _props3.detailIsLoading,
	          handleSubmit = _props3.handleSubmit,
	          submitting = _props3.submitting,
	          pristine = _props3.pristine,
	          valid = _props3.valid,
	          closeG = _props3.closeG;
	
	      if (detailIsLoading && !detailError) return _react2.default.createElement(_spinner2.default, { className: 'marginTopStyle' });else if (detailError) return _react2.default.createElement(
	        'div',
	        { className: 'alert alert-danger' },
	        JSON.stringify(this.props.detailError)
	      );
	      if (this.props.hierarchy === 'level') {
	        return _react2.default.createElement(
	          'form',
	          { method: 'get', action: '#', onSubmit: handleSubmit(this.handleLevelFormSubmit.bind(this)) },
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-right' },
	            this.props.isCreating || this.props.isEditing && _react2.default.createElement(_spinner2.default, null),
	            _react2.default.createElement(
	              'button',
	              { action: 'submit', className: 'btn btn-primary buttonStyle', disabled: submitting || pristine || !valid },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-danger buttonStyle', onClick: function onClick(event) {
	                  event.preventDefault();closeG();
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(_reactBootstrap.Col, { sm: 1 }),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 4 },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement('em', { className: 'fa fa-building-o marginRightStyle' }),
	                    '| ',
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'level' }),
	                    ' (*) '
	                  ),
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Name', ref: "bin_num", component: _inputField2.default })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(_reactBootstrap.Col, { sm: 1 }),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 4 },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement('em', { className: 'fa fa-building-o marginRightStyle' }),
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Description' }),
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 12 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'description',
	                        component: 'Textarea', className: 'form-control', style: { minHeight: '150px' } })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement('div', null);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        this.renderZoneForm(),
	        this.renderBinForm(),
	        this.renderLevelForm()
	      );
	    }
	  }]);
	
	  return ZoneForm;
	}(_react.Component);
	
	var _default = (0, _reactRouter.withRouter)(ZoneForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ZoneForm, 'ZoneForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/zoneForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/zoneForm.jsx');
	}();

	;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reactChartjs = __webpack_require__(86);
	
	var _time = __webpack_require__(83);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _purchaseQuoteModal = __webpack_require__(76);
	
	var _purchaseQuoteModal2 = _interopRequireDefault(_purchaseQuoteModal);
	
	var _favoriteModal = __webpack_require__(75);
	
	var _favoriteModal2 = _interopRequireDefault(_favoriteModal);
	
	var _datePicker = __webpack_require__(27);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ZoneInformation = function (_Component) {
	    _inherits(ZoneInformation, _Component);
	
	    function ZoneInformation() {
	        _classCallCheck(this, ZoneInformation);
	
	        var _this = _possibleConstructorReturn(this, (ZoneInformation.__proto__ || Object.getPrototypeOf(ZoneInformation)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.fourLineButton,
	
	            createReturnOpen: false,
	            createQuoteOpen: false,
	            createFavoriteOpen: false,
	            availableBins: 0,
	            totalBins: 0,
	
	            zones: {
	                rows: [],
	                allRows: [],
	                sortColumn: null,
	                sortDirection: null
	            }
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(ZoneInformation, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchWarehouses();
	            this.props.fetchWarehouseBins(1);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once products are ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	
	            if (nextProps.warehouseChosen && nextProps.warehouseChosen != this.props.warehouseChosen) {
	                this.props.fetchWarehouseBins(nextProps.warehouseChosen.value);
	            }
	
	            if (nextProps.warehouseBinsDetail && nextProps.warehouseBinsDetail != this.props.warehouseBinsDetail) {
	                var totalAvailable = 0;
	                var totalWarehouseBins = 0;
	                nextProps.warehouseBinsDetail.Warehouse_Zone.map(function (zone) {
	                    totalAvailable += zone.AvailableBin;
	                    totalWarehouseBins += zone.TotalBin;
	                });
	
	                var zones = _extends({}, this.state.zones, { rows: nextProps.warehouseBinsDetail.Warehouse_Zone });
	                this.setState({ zones: zones, availableBins: totalAvailable, totalBins: totalWarehouseBins });
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.fourLineButton });
	        }
	    }, {
	        key: 'renderZonesTable',
	        value: function renderZonesTable() {
	            var _this2 = this;
	
	            if (this.props.SOIsLoading && !this.props.SOError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.SOError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.SOError)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.zones);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var zones = _extends({}, _this2.state.zones, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this2.setState({ zones: zones });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var zones = _extends({}, _this2.state.zones, { selectedRows: rows });
	                    _this2.setState({ zones: zones });
	                };
	
	                //Custom Formatter component
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNameFormatter = _react2.default.createClass({
	                    displayName: 'VendorNameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNumFormatter = _react2.default.createClass({
	                    displayName: 'VendorNumFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.VendorNum
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'Name',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'AvailableBin',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bins_available' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'TotalBin',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_bins' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'ZoneInformation-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'WarehouseZone_id',
	                                onGridSort: handleGridSort,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: this.state.tableHeight / 2,
	                                rowHeight: 32,
	                                enableRowSelect: 'single',
	                                onRowSelect: onRowSelect })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'getWarehouseOptions',
	        value: function getWarehouseOptions() {
	            var warehouseOptions = [];
	            this.props.warehouses.map(function (warehouse) {
	                warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name });
	            });
	            return warehouseOptions;
	        }
	    }, {
	        key: 'selectZone',
	        value: function selectZone(e) {
	            e.preventDefault();
	            this.props.fetchBinListFromZone(this.state.zones.selectedRows[0].WarehouseZone_id, this.props.currentWarehouseReceive);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                numPurchaseQuotes = _props.numPurchaseQuotes;
	
	
	            var warehouseOptions = this.getWarehouseOptions();
	
	            var data = [{ color: "#97ddf0", label: "test1", value: 2 }, { color: "#fafafa", label: "test2", value: 1 }];
	
	            var options = {
	                animateRotate: true
	            };
	
	            var createDialogStyle = {
	                width: '600px',
	                marginLeft: '-10%'
	            };
	
	            var panelHeader = _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_bins' })
	                    )
	                )
	            );
	
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Warehouse', component: _selection2.default, options: warehouseOptions })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12, className: 'text-center' },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { header: panelHeader },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        this.state.availableBins,
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'available' }),
	                                        ' / ',
	                                        this.state.totalBins,
	                                        ' ',
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_bins' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    null,
	                                    this.renderZonesTable()
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-primary col-sm-11 buttonStyle', onClick: function onClick(e) {
	                                return _this3.selectZone(e);
	                            } },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_zone' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ZoneInformation;
	}(_react.Component);
	
	ZoneInformation.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = ZoneInformation;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(ZoneInformation, 'ZoneInformation', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/zoneInformation.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Inventories/zoneInformation.jsx');
	}();

	;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(199);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _Header = __webpack_require__(165);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Sidebar = __webpack_require__(391);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Offsidebar = __webpack_require__(167);
	
	var _Offsidebar2 = _interopRequireDefault(_Offsidebar);
	
	var _Footer = __webpack_require__(164);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Base = function (_Component) {
	    _inherits(Base, _Component);
	
	    function Base() {
	        _classCallCheck(this, Base);
	
	        return _possibleConstructorReturn(this, (Base.__proto__ || Object.getPrototypeOf(Base)).apply(this, arguments));
	    }
	
	    _createClass(Base, [{
	        key: 'render',
	        value: function render() {
	
	            // Animations supported
	            //      'rag-fadeIn'
	            //      'rag-fadeInUp'
	            //      'rag-fadeInDown'
	            //      'rag-fadeInRight'
	            //      'rag-fadeInLeft'
	            //      'rag-fadeInUpBig'
	            //      'rag-fadeInDownBig'
	            //      'rag-fadeInRightBig'
	            //      'rag-fadeInLeftBig'
	            //      'rag-zoomBackDown'
	
	            var animationName = 'rag-fadeIn';
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'wrapper' },
	                _react2.default.createElement(_Header2.default, null),
	                _react2.default.createElement(_Sidebar2.default, null),
	                _react2.default.createElement(_Offsidebar2.default, null),
	                _react2.default.createElement(
	                    _reactAddonsCssTransitionGroup2.default,
	                    {
	                        component: 'section',
	                        transitionName: animationName,
	                        transitionEnterTimeout: 500,
	                        transitionLeaveTimeout: 500
	                    },
	                    _react2.default.cloneElement(this.props.children, {
	                        key: Math.random()
	                    })
	                ),
	                _react2.default.createElement(_Footer2.default, null)
	            );
	        }
	    }]);
	
	    return Base;
	}(_react.Component);
	
	var _default = Base;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(Base, 'Base', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Base.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Base.jsx');
	}();

	;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(199);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _HeaderHorizontal = __webpack_require__(389);
	
	var _HeaderHorizontal2 = _interopRequireDefault(_HeaderHorizontal);
	
	var _Offsidebar = __webpack_require__(167);
	
	var _Offsidebar2 = _interopRequireDefault(_Offsidebar);
	
	var _Footer = __webpack_require__(164);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Base = function (_Component) {
	    _inherits(Base, _Component);
	
	    function Base() {
	        _classCallCheck(this, Base);
	
	        return _possibleConstructorReturn(this, (Base.__proto__ || Object.getPrototypeOf(Base)).apply(this, arguments));
	    }
	
	    _createClass(Base, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            $('body').addClass('layout-h');
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            // Only necessary for demo to restore classic layout
	            $('body').removeClass('layout-h');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            // Animations supported
	            //      'rag-fadeIn'
	            //      'rag-fadeInUp'
	            //      'rag-fadeInDown'
	            //      'rag-fadeInRight'
	            //      'rag-fadeInLeft'
	            //      'rag-fadeInUpBig'
	            //      'rag-fadeInDownBig'
	            //      'rag-fadeInRightBig'
	            //      'rag-fadeInLeftBig'
	            //      'rag-zoomBackDown'
	
	            var animationName = 'rag-fadeIn';
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'wrapper' },
	                _react2.default.createElement(_HeaderHorizontal2.default, null),
	                _react2.default.createElement(_Offsidebar2.default, null),
	                _react2.default.createElement(
	                    _reactAddonsCssTransitionGroup2.default,
	                    {
	                        component: 'section',
	                        transitionName: animationName,
	                        transitionEnterTimeout: 500,
	                        transitionLeaveTimeout: 500
	                    },
	                    _react2.default.cloneElement(this.props.children, {
	                        key: Math.random()
	                    })
	                ),
	                _react2.default.createElement(_Footer2.default, null)
	            );
	        }
	    }]);
	
	    return Base;
	}(_react.Component);
	
	var _default = Base;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(Base, 'Base', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/BaseHorizontal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/BaseHorizontal.jsx');
	}();

	;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BasePage = function (_Component) {
	    _inherits(BasePage, _Component);
	
	    function BasePage() {
	        _classCallCheck(this, BasePage);
	
	        return _possibleConstructorReturn(this, (BasePage.__proto__ || Object.getPrototypeOf(BasePage)).apply(this, arguments));
	    }
	
	    _createClass(BasePage, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "wrapper" },
	                this.props.children
	            );
	        }
	    }]);
	
	    return BasePage;
	}(_react.Component);
	
	var _default = BasePage;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(BasePage, "BasePage", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/BasePage.jsx");
	
	    __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/BasePage.jsx");
	}();

	;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pubsubJs = __webpack_require__(130);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _Header = __webpack_require__(166);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reactRouterBootstrap = __webpack_require__(823);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeaderHorizontal = function (_Component) {
	    _inherits(HeaderHorizontal, _Component);
	
	    function HeaderHorizontal() {
	        _classCallCheck(this, HeaderHorizontal);
	
	        return _possibleConstructorReturn(this, (HeaderHorizontal.__proto__ || Object.getPrototypeOf(HeaderHorizontal)).apply(this, arguments));
	    }
	
	    _createClass(HeaderHorizontal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            (0, _Header2.default)();
	        }
	    }, {
	        key: 'toggleUserblock',
	        value: function toggleUserblock(e) {
	            e.preventDefault();
	            _pubsubJs2.default.publish('toggleUserblock');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var ddAlertTitle = _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement('em', { className: 'icon-bell' }),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'label label-danger' },
	                    '11'
	                )
	            );
	
	            return _react2.default.createElement(
	                'header',
	                { className: 'topnavbar-wrapper' },
	                _react2.default.createElement(
	                    'nav',
	                    { role: 'navigation', className: 'navbar topnavbar' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'navbar-header' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#/', className: 'navbar-brand' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'brand-logo' },
	                                _react2.default.createElement('img', { src: 'img/logo.png', alt: 'App Logo', className: 'img-responsive' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'brand-logo-collapsed' },
	                                _react2.default.createElement('img', { src: 'img/logo-single.png', alt: 'App Logo', className: 'img-responsive' })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'navbar-collapse collapse' },
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'nav navbar-nav' },
	                            _react2.default.createElement(
	                                _reactBootstrap.NavDropdown,
	                                { noCaret: true, eventKey: 3, title: 'Dashboard', id: 'dashboard-nav-dropdown' },
	                                _react2.default.createElement(
	                                    _reactRouterBootstrap.LinkContainer,
	                                    { to: 'dashboardv1h' },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.MenuItem,
	                                        { className: 'animated fadeIn', eventKey: 3.1 },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dashboard_v1' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactRouterBootstrap.LinkContainer,
	                                    { to: 'dashboardv2h' },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.MenuItem,
	                                        { className: 'animated fadeIn', eventKey: 3.2 },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dashboard_v2' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactRouterBootstrap.LinkContainer,
	                                    { to: 'dashboardv3h' },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.MenuItem,
	                                        { className: 'animated fadeIn', eventKey: 3.3 },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dashboard_v3' })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactRouterBootstrap.LinkContainer,
	                                { to: 'widgetsh' },
	                                _react2.default.createElement(
	                                    _reactBootstrap.NavItem,
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'widgets' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactRouterBootstrap.LinkContainer,
	                                { to: 'dashboard' },
	                                _react2.default.createElement(
	                                    _reactBootstrap.NavItem,
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'back' })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'nav navbar-nav navbar-right' },
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '#', 'data-search-open': '' },
	                                    _react2.default.createElement('em', { className: 'icon-magnifier' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { className: 'visible-lg' },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '#', 'data-toggle-fullscreen': '' },
	                                    _react2.default.createElement('em', { className: 'fa fa-expand' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.NavDropdown,
	                                { noCaret: true, eventKey: 3, title: ddAlertTitle, id: 'basic-nav-dropdown' },
	                                _react2.default.createElement(
	                                    _reactBootstrap.MenuItem,
	                                    { className: 'animated flipInX', eventKey: 3.1 },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'login' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.MenuItem,
	                                    { className: 'animated flipInX', eventKey: 3.2 },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'profile' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.MenuItem,
	                                    { className: 'animated flipInX', eventKey: 3.3 },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dashboard' })
	                                ),
	                                _react2.default.createElement(_reactBootstrap.MenuItem, { divider: true }),
	                                _react2.default.createElement(
	                                    _reactBootstrap.MenuItem,
	                                    { className: 'animated flipInX', eventKey: 3.3 },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'logout' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '#', 'data-toggle-state': 'offsidebar-open', 'data-no-persist': 'true' },
	                                    _react2.default.createElement('em', { className: 'icon-notebook' })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'form',
	                        { role: 'search', action: 'search.html', className: 'navbar-form' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-group has-feedback' },
	                            _react2.default.createElement('input', { type: 'text', placeholder: 'Type and hit enter ...', className: 'form-control' }),
	                            _react2.default.createElement('div', { 'data-search-dismiss': '', className: 'fa fa-times form-control-feedback' })
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'hidden btn btn-default' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return HeaderHorizontal;
	}(_react.Component);
	
	var _default = HeaderHorizontal;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(HeaderHorizontal, 'HeaderHorizontal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/HeaderHorizontal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/HeaderHorizontal.jsx');
	}();

	;

/***/ }),
/* 390 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _default = function _default() {
	
	    var $body = $('body');
	
	    // enable settings toggle
	    $('#chk-fixed').prop('checked', $body.hasClass('layout-fixed'));
	    $('#chk-collapsed').prop('checked', $body.hasClass('aside-collapsed'));
	    $('#chk-boxed').prop('checked', $body.hasClass('layout-boxed'));
	    $('#chk-float').prop('checked', $body.hasClass('aside-float'));
	    $('#chk-hover').prop('checked', $body.hasClass('aside-hover'));
	
	    // When ready display the offsidebar
	    $('.offsidebar.hide').removeClass('hide');
	};
	
	exports.default = _default;
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }

	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Offsidebar.run.js');
	}();

	;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(13);
	
	var _pubsubJs = __webpack_require__(130);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _Sidebar = __webpack_require__(392);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isGV = _root_url.ROOT_API_URL === 'https://gvyummy-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://gvyummy-scm.truckxi.com/api/';
	var isAFM = _root_url.ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afm-scm.truckxi.com/api/';
	var isDSQ = _root_url.ROOT_API_URL === 'https://dsq-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://dsq-scm.truckxi.com/api/';
	var isWIZ = _root_url.ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
	var isFJ = _root_url.ROOT_API_URL === 'https://fj-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://fj-scm.truckxi.com/api/';
	var isGA = _root_url.ROOT_URL === 'https://gastage-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ga-scm.truckxi.com/api/';
	var isJTB = _root_url.ROOT_API_URL === 'https://jtb-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://jtb-scm.truckxi.com/api/';
	var isNBT = _root_url.ROOT_API_URL === 'https://nbtstage-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://nbtstage-scm.truckxi.com/api/';
	var isKM = _root_url.ROOT_API_URL === 'https://kingmax-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://kingmax-scm.truckxi.com/api/';
	var isABC = _root_url.ROOT_API_URL === 'https://abc-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://abc-scm.truckxi.com/api/';
	var isMAG = _root_url.ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://magna-scm.truckxi.com/api/';
	var isTN = _root_url.ROOT_API_URL === 'https://tn-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://tn-scm.truckxi.com/api/';
	var isJML = _root_url.ROOT_API_URL === 'https://jml-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://jml-scm.truckxi.com/api/';
	var isKDW = _root_url.ROOT_API_URL === 'https://kdw-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://kdw-scm.truckxi.com/api/';
	var isABCFF = _root_url.ROOT_API_URL === 'https://abcff-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://abcff-scm.truckxi.com/api/';
	var isYI = _root_url.ROOT_API_URL === 'https://ying-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ying-scm.truckxi.com/api/';
	var isFBD = _root_url.ROOT_API_URL === 'https://fbd-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://fbd-scm.truckxi.com/api/';
	
	var Sidebar = function (_Component) {
	    _inherits(Sidebar, _Component);
	
	    function Sidebar(props, context) {
	        _classCallCheck(this, Sidebar);
	
	        var _this = _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call(this, props, context));
	
	        _this.user = localStorage.getItem('userType');
	
	        _this.state = {
	            userBlockCollapse: false,
	            collapse: {
	                users: _this.routeActive(['']),
	                generalInformation: _this.routeActive(['products', 'products/new', 'customers', 'products/groups', 'products/categories', 'agents', 'vendors', 'paymentTerms', 'priceLevel', 'mobileManagement', 'presidentDashboard', 'contentManagement']),
	                purchaseManagement: _this.routeActive([/*'purchaseQuote', 'purchaseTemplate', 'purchaseSchedule', */'purchaseReturn', 'purchaseOrder', 'purchasingPerformanceReport', 'priceAdjustmentReport', /*'purchasePivotChart', */'purchaseReferenceReport', 'newPurchaseOrder']),
	                salesManagement: _this.routeActive(['salesOrders', 'mobileSalesOrders', 'newSalesOrder', 'sopacking', 'salesInvoice', 'salesPerformanceReport', 'promotions', 'favoriteList', 'groupList', 'merchantReport', 'multilevelMarketing', 'gvRewards', 'groupBuy', 'groupWholesale', 'shipToOrders', 'preOrders', 'shipFromOrders', 'otherService']),
	                warehouseManagement: _this.routeActive(['storageInventory', 'inventoriesnews', 'warehouses', 'inventories/repackage', 'inventories/convert', 'productConvertReport', 'inventories/receive', 'inventories/receiveHistory', 'putAway', 'inventories/adjustment', 'scrapRecords', "adjustmentInventory", "inventoryTransfer"]),
	                dispatch: _this.routeActive(['magRouting', 'drivers', 'shipping', 'routing', 'editRoutes', 'autoRouting']),
	                setting: _this.routeActive(['userManagement', 'groupManagement', 'taxManagement', 'currencyManagement', 'actionLog']),
	                rma: _this.routeActive(['customerRMA', 'dispatchRMA', 'rmaForm']),
	                returns: _this.routeActive(['returns', 'customerReturn', 'inventoryReturn']),
	                ARAP: _this.routeActive(['AR', 'AP', 'paymentSummary', 'purchasePayment', 'arSalesInvoice', 'salesInvoicePayment', 'generalReport', 'customerStatementMain', 'vendorStatementMain', 'mobileCustomerStatement', 'cityReport', 'customerStatement', 'vendorStatement']),
	                posManagement: _this.routeActive(['POS', 'POSReport']),
	                report: _this.routeActive(['priceAdjustment', 'productConvert', 'purchasePivot', 'purchaseReference', 'purchasePerformance', 'salesPerformance'])
	            }
	        };
	        _this.pubsub_token = _pubsubJs2.default.subscribe('toggleUserblock', function () {
	            _this.setState({
	                userBlockCollapse: !_this.state.userBlockCollapse
	            });
	        });
	        return _this;
	    }
	
	    _createClass(Sidebar, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            (0, _Sidebar2.default)();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            // React removed me from the DOM, I have to unsubscribe from the pubsub using my token
	            _pubsubJs2.default.unsubscribe(this.pubsub_token);
	        }
	    }, {
	        key: 'routeActive',
	        value: function routeActive(paths) {
	            paths = Array.isArray(paths) ? paths : [paths];
	            for (var p in paths) {
	                if (this.context.router.isActive(paths[p]) === true) return true;
	            }
	            return false;
	        }
	    }, {
	        key: 'toggleItemCollapse',
	        value: function toggleItemCollapse(stateName) {
	            var newCollapseState = {};
	            for (var c in this.state.collapse) {
	                if (this.state.collapse[c] === true && c !== stateName) this.state.collapse[c] = false;
	            }
	            this.setState({
	                collapse: _defineProperty({}, stateName, !this.state.collapse[stateName])
	            });
	        }
	    }, {
	        key: 'getInventoryAdjustmentPermission',
	        value: function getInventoryAdjustmentPermission() {
	            if (_root_url.isLO) return 'inventory_adjustment';
	            return 'view_warehouse';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'aside',
	                { className: 'aside' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'aside-inner' },
	                    _react2.default.createElement(
	                        'nav',
	                        { 'data-sidebar-anyclick-close': '', className: 'sidebar' },
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'nav' },
	                            _react2.default.createElement(
	                                'li',
	                                { className: 'has-user-block' },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Collapse,
	                                    { id: 'user-block', 'in': this.state.userBlockCollapse },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'item user-block' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'user-block-picture' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'user-block-status' },
	                                                _react2.default.createElement('img', { src: '/img/user/02.jpg', alt: 'Avatar', width: '60', height: '60', className: 'img-thumbnail img-circle' }),
	                                                _react2.default.createElement('div', { className: 'circle circle-success circle-lg' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'user-block-info' },
	                                            _react2.default.createElement(
	                                                'span',
	                                                { className: 'user-block-name' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'user_name' })
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                { className: 'user-block-role' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'user_role' })
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { className: this.routeActive(['dashboard']) ? 'active' : '' },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { className: 'nav-item', to: '/dashboard', title: 'Dashboard' },
	                                    _react2.default.createElement('em', { className: 'icon-speedometer', 'aria-hidden': 'true' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { 'data-localize': 'sidebar.nav.SINGLEVIEW' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dashboard' })
	                                    )
	                                )
	                            ),
	                            !(isWIZ || isMAG || isYI) && _react2.default.createElement(
	                                'li',
	                                { className: this.routeActive([/*'purchaseQuote', 'purchaseTemplate', 'purchaseSchedule', */'purchaseReturn', 'newPurchaseOrder', 'purchaseOrder', 'purchasingPerformanceReport', 'priceAdjustmentReport', /*'purchasePivotChart', */'purchaseReferenceReport']) ? 'active' : '' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'nav-item', onClick: this.toggleItemCollapse.bind(this, 'purchaseManagement') },
	                                    _react2.default.createElement('em', { className: 'icon-basket' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { 'data-localize': 'sidebar.nav.MENU' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_management' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Collapse,
	                                    { 'in': this.state.collapse.purchaseManagement, timeout: 100 },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { id: 'quote', className: 'nav sidebar-subnav' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: 'sidebar-subnav-header' },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_management' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('newPurchaseOrder') ? 'active' : '') + ((0, _permissions2.default)('add_purchase_order') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/purchaseOrder/new', title: 'New Purchase Order' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.ORDER' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_purchase_order' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('purchaseOrder') ? 'active' : '') + ((0, _permissions2.default)('view_purchase_order') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/purchaseOrder', title: 'Purchase Order' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.ORDER' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_order' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('purchaseReturn') ? 'active' : '') + ((0, _permissions2.default)('view_purchase_return') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/purchaseReturn', title: 'Purchase Return' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.RETURN' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_return' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('purchasingPerformanceReport') ? 'active' : '') + ((0, _permissions2.default)('view_purchase_performance') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/purchasingPerformanceReport', title: 'Purchase Performance' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PERFORMANCE' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_performance' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('priceAdjustmentReport') ? 'active' : '') + ((0, _permissions2.default)('view_price_reference') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/priceAdjustmentReport', title: 'Price Reference' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PERFORMANCE' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price_reference' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('purchaseReferencereport') ? 'active' : '') + ((0, _permissions2.default)('view_purchase_reference') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/purchaseReferencereport', title: 'Purchase Reference' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PERFORMANCE' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_reference' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { className: this.routeActive(['salesOrders', 'mobileSalesOrders', 'salesInvoice', 'so_packing', 'bolinventory', 'favoriteList', 'groupList', 'wholesale', 'promotions', 'salesPerformanceReport', 'newSalesOrder', 'salesPopularity', 'purchaseStatistics', 'merchantSummary', 'merchantReport', 'multilevelMarketing', 'gvRewards', 'groupBuy', 'groupWholesale', 'shipToOrders', 'preOrders', 'shipFromOrders', 'otherService']) ? 'active' : '' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'nav-item', onClick: this.toggleItemCollapse.bind(this, 'salesManagement') },
	                                    _react2.default.createElement('em', { className: 'fa fa-bar-chart' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { 'data-localize': 'sidebar.nav.MENU' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: isYI ? "sales_management2" : "sales_management" })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Collapse,
	                                    { 'in': this.state.collapse.salesManagement, timeout: 100 },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { id: 'quote', className: 'nav sidebar-subnav' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: 'sidebar-subnav-header' },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_management' })
	                                        ),
	                                        !_root_url.isWUFS && _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('newSalesOrder') ? 'active' : '') + ((0, _permissions2.default)('add_sales_order') ? '' : 'disabled-sidebar') },
	                                            isGA ? _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/salesOrders/new', title: 'New Sales Order' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.ORDER' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB ? "new_inbound_order" : "new_sales_order" })
	                                                )
	                                            ) : _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/salesOrders/new', title: 'New Sales Order' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.ORDER' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB ? "new_inbound_order" : "new_sales_order" })
	                                                )
	                                            )
	                                        ),
	                                        !_root_url.isWUFS && _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('salesOrders') ? 'active' : '') + ((0, _permissions2.default)('view_sales_order') ? '' : 'disabled-sidebar') },
	                                            isGA ? _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/salesOrders', title: 'Sales Order' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.SALESORDERS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB ? "inbound_order" : "sales_order" })
	                                                )
	                                            ) : _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/salesOrders', title: 'Sales Order' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.SALESORDERS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB ? "inbound_order" : "sales_order" })
	                                                )
	                                            )
	                                        ),
	                                        _root_url.isWUFS && _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('shipToOrders') ? 'active' : '') + ((0, _permissions2.default)('view_sales_order') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/shipToOrders', title: 'Ship To Orders' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.SHIPTOORDER' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_to_orders' })
	                                                )
	                                            )
	                                        ),
	                                        _root_url.isWUFS && _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('preOrders') ? 'active' : '') + ((0, _permissions2.default)('view_sales_order') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/preOrders', title: 'Pre Orders' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PREORDER' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pre_order' })
	                                                )
	                                            )
	                                        ),
	                                        _root_url.isWUFS && _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('shipFromOrders') ? 'active' : '') + ((0, _permissions2.default)('view_sales_order') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/shipFromOrders', title: 'Ship From Orders' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.SHIPFROMORDER' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_from_orders' })
	                                                )
	                                            )
	                                        ),
	                                        _root_url.isWUFS && _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('otherService') ? 'active' : '') + ((0, _permissions2.default)('view_sales_order') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/otherService', title: 'Other Service' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.OTHERSERVICE' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'other_service' })
	                                                )
	                                            )
	                                        ),
	                                        isABC && _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('inboundOrdersABC') ? 'active' : '') + ((0, _permissions2.default)('view_sales_order') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/inboundOrdersABC', title: 'Inbound Order' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.INBOUNDORDER' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inbound_order' })
	                                                )
	                                            )
	                                        ),
	                                        isABC && _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('outboundOrdersABC') ? 'active' : '') + ((0, _permissions2.default)('view_sales_order') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/outboundOrdersABC', title: 'Outbound Order' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.OUTBOUNDORDER' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'outbound_order' })
	                                                )
	                                            )
	                                        ),
	                                        isGA && _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('this_dont_matter') ? 'active' : '') + ((0, _permissions2.default)('add_sales_order') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/exportOrder/new', title: 'New Export Order' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.NEWEXPORTORDER' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_export_order' })
	                                                )
	                                            )
	                                        ),
	                                        isGA && _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('this_dont_matter') ? 'active' : '') + ((0, _permissions2.default)('add_sales_order') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/exportOrder', title: 'Export Orders' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.EXPORTORDERS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'export_order' })
	                                                )
	                                            )
	                                        ),
	                                        (isDSQ || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) && _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('newOutboundOrder') ? 'active' : '') + ((0, _permissions2.default)('add_sales_order') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/outboundOrders/new', title: 'New Sales Order' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.NEWOUTBOUNDORDER' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_outbound_order' })
	                                                )
	                                            )
	                                        ),
	                                        (isDSQ || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) && _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('outboundOrders') ? 'active' : '') + ((0, _permissions2.default)('view_sales_order') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/outboundOrders', title: 'Outbound Order' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.OUTBOUNDORDER' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: isYI ? "outbound_order2" : "outbound_order" })
	                                                )
	                                            )
	                                        ),
	                                        !(isDSQ || isKDW || isFJ || isJTB) && _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('mobileSalesOrders') ? 'active' : '') + ((0, _permissions2.default)('view_mobile_order') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/mobileSalesOrders', title: 'Mobile Sales Order' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.MOBILESALESORDERS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mobile_sales_order' })
	                                                )
	                                            )
	                                        ),
	                                        isABC && _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('storageOrders') ? 'active' : '') + ((0, _permissions2.default)('view_sales_invoice') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/storageOrders', title: 'Storage Orders' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.STORAGEORDERS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_orders' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('salesInvoice') ? 'active' : '') + ((0, _permissions2.default)('view_sales_invoice') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/salesInvoice', title: 'Sales Invoice' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.SALESINVOICE' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_invoice' })
	                                                )
	                                            )
	                                        ),
	                                        isGA && _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('quotes') ? 'active' : '') + ((0, _permissions2.default)('view_sales_invoice') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/quotes', title: 'Quotes' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.QUOTES' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quotes' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('so_packing') ? 'active' : '') + ((0, _permissions2.default)('view_so_packing') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/sopacking', title: 'SO Packing' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.SOPACKING' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_packing' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('bolinventory') ? 'active' : '') + ((0, _permissions2.default)('view_bol_inventory') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/bolinventory', title: 'BOL Inventory' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.SALESINVOICE' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bol_inventory' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('promotions') ? 'active' : '') + ((0, _permissions2.default)('view_promotions') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/promotions', title: 'Promotion' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PROMOTION' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'promotion' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('favoriteList') ? 'active' : '') + ((0, _permissions2.default)('view_sales_favorites') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/favoriteList', title: 'Favorite List' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.FAVORITELIST' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'favorites_list' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('groupList') ? 'active' : '') + ((0, _permissions2.default)('view_group_list') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/groupList', title: 'Group List' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.GROUPLIST' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'group_list' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('salesPerformanceReport') ? 'active' : '') + ((0, _permissions2.default)('view_sales_performance') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/salesPerformanceReport', title: 'Sales Performance' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PERFORMANCE' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_performance' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('salesPopularity') ? 'active' : '') + ((0, _permissions2.default)('view_sales_popularity') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/salesPopularity', title: 'Sales Popularity' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.POPULARITY' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_popularity' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('purchaseStatistics') ? 'active' : '') + ((0, _permissions2.default)('view_purchase_statistics') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/purchaseStatistics', title: 'Purchase Statistics' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PURCHASESTATISTICS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_statistics' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('merchantSummary') ? 'active' : '') + ((0, _permissions2.default)('view_merchant_summary') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/merchantSummary', title: 'Merchant Summary' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.MERCHANTSUMMARY' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'merchant_summary' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('merchantReport') ? 'active' : '') + ((0, _permissions2.default)('view_merchant_report') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/merchantReport', title: 'Merchant Report' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.MERCHANTREPORT' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'merchant_report' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('multilevelMarketing') ? 'active' : '') + ((0, _permissions2.default)('view_multilevel_marketing') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/multilevelMarketing', title: 'Multilevel Marketing' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.MULTILEVELMARKETING' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'multilevel_marketing' })
	                                                )
	                                            )
	                                        ),
	                                        isGV && _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('gvRewards') ? 'active' : '') + ((0, _permissions2.default)('view_gv_rewards') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/gvRewards', title: 'GV Rewards' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.GVREWARDS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'gv_rewards' })
	                                                )
	                                            )
	                                        ),
	                                        (isNBT || isKM) && _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('gvRewards') ? 'active' : '') + ((0, _permissions2.default)('view_gv_rewards') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/gvRewards', title: 'NBT Rewards' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.NBTREWARDS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'nbt_rewards' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('groupBuy') ? 'active' : '') + ((0, _permissions2.default)('view_group_buy') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/groupBuy', title: 'Group Buy' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.GROUPBUY' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'group_buy' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('groupWholesale') ? 'active' : '') + ((0, _permissions2.default)('view_group_wholesale') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/groupWholesale', title: 'Group Wholesale' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.GROUPWHOLESALE' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'group_wholesale' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            !isMAG && _react2.default.createElement(
	                                'li',
	                                { className: this.routeActive(['storageInventory', 'inventoriesnew', 'warehouses', 'inventories/repackage', 'inventories/convert', 'inventories/relocation', 'inventories/adjustment', 'scrapRecords', 'putAway', 'inventories/receive', 'inventories/receiveHistory', 'productConvertReport', 'adjustmentInventory', 'shelfLifeStatistics', 'inventoryTransfer']) ? 'active' : '' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'nav-item', onClick: this.toggleItemCollapse.bind(this, 'warehouseManagement') },
	                                    _react2.default.createElement('em', { className: 'fa fa-building' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { 'data-localize': 'sidebar.nav.MENU' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_management' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Collapse,
	                                    { 'in': this.state.collapse.warehouseManagement, timeout: 100 },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { id: 'quote', className: 'nav sidebar-subnav' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: 'sidebar-subnav-header' },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_management' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('inventoriesnew') ? 'active' : '') + ((0, _permissions2.default)('view_inventory') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/inventoriesnew', title: 'Inventory' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.INVENTORY' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory' })
	                                                )
	                                            )
	                                        ),
	                                        (isTN || isJML || _root_url.isRivera) && _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('inventoryHistory') ? 'active' : '') + ((0, _permissions2.default)('view_inventory') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/inventoryHistory', title: 'inventoryHistory' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.INVENTORY' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_history' })
	                                                )
	                                            )
	                                        ),
	                                        (isWIZ || isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isFJ || isJTB) && _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('storageInventory') ? 'active' : '') + ((0, _permissions2.default)('view_inventory') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/storageInventory', title: 'Storage Inventory' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.STORAGEINVENTORY' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_inventory' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('inventoryTransfer') ? 'active' : '') + ((0, _permissions2.default)('view_inventory_transfer') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/inventoryTransfer', title: 'Inventory Transfer' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.INVENTORYTRANSFER' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventoryTransfer' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('inventories/receive') ? 'active' : '') + ((0, _permissions2.default)('view_receive') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/inventories/receive', title: 'New Receiving' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.RECEIVE' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_receiving' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('inventories/receiveHistory') ? 'active' : '') + ((0, _permissions2.default)('view_receive_history') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/inventories/receiveHistory', title: 'Receive History' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.RECEIVE_HISTORY' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_history' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('warehouses') ? 'active' : '') + ((0, _permissions2.default)('view_warehouse') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/warehouses', title: 'Warehouse' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.WAREHOUSE' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('workingOrders') ? 'active' : '') + ((0, _permissions2.default)('view_warehouse') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/workingOrders', title: 'Working Orders' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.WORKING_ORDERS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'working_orders' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('newWorkingOrders') ? 'active' : '') + ((0, _permissions2.default)('view_warehouse') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/inventoryConvert', title: 'New Working Orders' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.NEW_WORKING_ORDERS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_working_orders' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('adjustmentInventory') ? 'active' : '') + ((0, _permissions2.default)(this.getInventoryAdjustmentPermission()) ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/adjustmentInventory', title: 'Inventory Adjustment' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.INVENTORY_ADJUSTMENT' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_adjustment' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('shelfLifeStatistics') ? 'active' : '') + ((0, _permissions2.default)('view_shelf_life_statistics') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/shelfLifeStatistics', title: 'Shelf Life Statistics' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.SHELFLIFESTATISTICS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shelf_life_statistics' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            !(isWIZ || isYI) && _react2.default.createElement(
	                                'li',
	                                { className: this.routeActive(['magRouting', 'drivers', 'shipping', 'editRoutes', 'routing', 'autoRouting']) ? 'active' : '' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'nav-item', onClick: this.toggleItemCollapse.bind(this, 'dispatch') },
	                                    _react2.default.createElement('em', { className: 'fa fa-truck' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { 'data-localize': 'sidebar.nav.MENU' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Collapse,
	                                    { 'in': this.state.collapse.dispatch, timeout: 100 },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { id: 'quote', className: 'nav sidebar-subnav' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: 'sidebar-subnav-header' },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch' })
	                                        ),
	                                        !(isMAG || isKDW) && _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('routing') ? 'active' : '') + ((0, _permissions2.default)('view_routing') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/routing', title: 'Routing' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.SALESORDERS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'routing' })
	                                                )
	                                            )
	                                        ),
	                                        (isMAG || isKDW) && _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('routing') ? 'active' : '') + ((0, _permissions2.default)('view_routing') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/magRouting', title: 'Mag Routing' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.MAGROUTING' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'routing' })
	                                                )
	                                            )
	                                        ),
	                                        (isMAG || isKDW) && _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('dispatchInvoice') ? 'active' : '') + ((0, _permissions2.default)('view_routing') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/dispatchInvoice', title: 'Dispatch Invoice' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.DISPATCHINVOICE' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch_invoice' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('autoRouting') ? 'active' : '') + ((0, _permissions2.default)('view_routing') && isAFM ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/autoRouting', title: 'Auto Routing' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.SALESORDERS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'autoRouting' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('editRoutes') ? 'active' : '') + ((0, _permissions2.default)('view_edit_route') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/editRoutes', title: 'Edit Route' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.SALESORDERS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_route' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('shipping') ? 'active' : '') + ((0, _permissions2.default)('view_shipping') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/shipping', title: 'Shipping' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.SALESORDERS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('drivers') ? 'active' : '') + ((0, _permissions2.default)('view_routing') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/drivers', title: 'Drivers' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.SALESORDERS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'drivers' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { className: this.routeActive(['AR', 'AP', 'paymentSummary', 'purchasePayment', 'arSalesInvoice', 'salesInvoicePayment', 'generalReport', 'customerStatementMain', 'vendorStatementMain', 'customerStatement', 'vendorStatement', 'mobileCustomerStatement', 'cityReport']) ? 'active' : '' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'nav-item', onClick: this.toggleItemCollapse.bind(this, 'ARAP') },
	                                    _react2.default.createElement('em', { className: 'fa fa-credit-card' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { 'data-localize': 'sidebar.nav.MENU' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_slashsign_ap' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Collapse,
	                                    { 'in': this.state.collapse.ARAP, timeout: 100 },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { id: 'quote', className: 'nav sidebar-subnav' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: 'sidebar-subnav-header' },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'AR' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('AR') ? 'active' : '') + ((0, _permissions2.default)('view_account_receivable') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/AR', title: 'Accounts Receivable' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.AR' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account_receivable' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('AP') ? 'active' : '') + ((0, _permissions2.default)('view_account_payable') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/AP', title: 'Accounts Payable' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.AP' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account_payable' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('/paymentSummary') ? 'active' : '') + ((0, _permissions2.default)('view_payment_summary') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/paymentSummary', title: 'Payment Summary' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.AP' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_summary' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('purchasePayment') ? 'active' : '') + ((0, _permissions2.default)('view_purchase_payment') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/purchasePayment', title: 'Purchase Report' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PAYMENT' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_report' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('arSalesInvoice') ? 'active' : '') + ((0, _permissions2.default)('view_sales_invoice') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/arSalesInvoice', title: 'Sales Invoice' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PAYMENT' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_invoice' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('salesInvoicePayment') ? 'active' : '') + ((0, _permissions2.default)('view_sales_report') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/salesInvoicePayment', title: 'Sales Report' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PAYMENT' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_report' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('generalReport') ? 'active' : '') + ((0, _permissions2.default)('view_general_report') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/generalReport', title: 'General Report' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PERFORMANCE' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_report' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('customerStatementMain') ? 'active' : '') + ((0, _permissions2.default)('view_customer_statement') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/customerStatementMain', title: 'AR Aged Report' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PERFORMANCE' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_aged_report' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('vendorStatementMain') ? 'active' : '') + ((0, _permissions2.default)('view_vendor_statement') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/vendorStatementMain', title: 'AP Aged Report' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PERFORMANCE' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ap_aged_report' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('customerStatement') ? 'active' : '') + ((0, _permissions2.default)('view_customer_statement') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/customerStatement', title: 'Customer Statement' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PERFORMANCE' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_statement' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('vendorStatement') ? 'active' : '') + ((0, _permissions2.default)('view_vendor_statement') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/vendorStatement', title: 'Vendor Statement' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PERFORMANCE' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_statement' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('cityReport') ? 'active' : '') + ((0, _permissions2.default)('view_city_report') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/cityReport', title: 'City Report' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PERFORMANCE' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city_report' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('mobileCustomerStatement') ? 'active' : '') + ((0, _permissions2.default)('view_customer_statement') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/mobileCustomerStatement', title: 'Mobile Customer Statement' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PERFORMANCE' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mobile_customer_statement' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            !(isWIZ || isYI) && _react2.default.createElement(
	                                'li',
	                                { className: this.routeActive(['customerReturn', 'inventoryReturn']) ? 'active' : '' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'nav-item', onClick: this.toggleItemCollapse.bind(this, 'returns') },
	                                    _react2.default.createElement('em', { className: 'fa fa-backward' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { 'data-localize': 'sidebar.nav.MENU' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'returns' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Collapse,
	                                    { 'in': this.state.collapse.returns, timeout: 100 },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { id: 'quote', className: 'nav sidebar-subnav' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: 'sidebar-subnav-header' },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'returns' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('customerReturn') ? 'active' : '') + ((0, _permissions2.default)('view_sales_return') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/customerReturn', title: 'New Sales Return' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_sales_return' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('inventoryReturn') ? 'active' : '') + ((0, _permissions2.default)('view_sales_return') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/inventoryReturn', title: 'Sales Return' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_return' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            !(isWIZ || isMAG || isYI) && _react2.default.createElement(
	                                'li',
	                                { className: this.routeActive(['POS', 'POSReport', 'POSOrders', 'POSCredits', 'POSHold']) ? 'active' : '' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'nav-item', onClick: this.toggleItemCollapse.bind(this, 'posManagement') },
	                                    _react2.default.createElement('em', { className: 'fa fa-bar-chart' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { 'data-localize': 'sidebar.nav.MENU' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pos_management' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Collapse,
	                                    { 'in': this.state.collapse.posManagement, timeout: 100 },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { id: 'quote', className: 'nav sidebar-subnav' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: 'sidebar-subnav-header' },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pos_management' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('POS') ? 'active' : '') + ((0, _permissions2.default)('view_pos') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/pos', title: 'POS' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pos' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('POSReport') ? 'active' : '') + ((0, _permissions2.default)('view_pos') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/posReport', title: 'POS Report' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pos_report' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('POSOrders') ? 'active' : '') + ((0, _permissions2.default)('view_pos') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/posOrders', title: 'POS Orders' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.POSORDERS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pos_order' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('POSCredits') ? 'active' : '') + ((0, _permissions2.default)('view_pos') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/posCredits', title: 'POS Credits' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.CREDITS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pos_credit' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: this.routeActive('POSHold') ? 'active' : '' },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/posHolds', title: 'POS Holds' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.HOLDS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pos_holds' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { className: this.routeActive(['products', 'products/new', 'customers', 'contentManagement', 'products/groups', 'products/categories', 'agents', 'vendors', 'paymentTerms', 'priceLevel', 'mobileManagement', 'presidentDashboard']) ? 'active' : '' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'nav-item', onClick: this.toggleItemCollapse.bind(this, 'generalInformation') },
	                                    _react2.default.createElement('em', { className: 'icon-book-open' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { 'data-localize': 'sidebar.nav.MENU' },
	                                        _react2.default.createElement(
	                                            'large',
	                                            null,
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: isYI ? "general_management2" : "general_management" })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Collapse,
	                                    { 'in': this.state.collapse.generalInformation, timeout: 100 },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { id: 'products', className: 'nav sidebar-subnav' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: 'sidebar-subnav-header' },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_information' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('products') ? 'active' : '') + ((0, _permissions2.default)('view_product') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/products', title: 'Product' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PRODUCTS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('customers') ? 'active' : '') + ((0, _permissions2.default)('view_customer') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/customers', title: 'Customers' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.SINGLEVIEW' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: isYI ? "customers2" : "customers" })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('vendors') ? 'active' : '') + ((0, _permissions2.default)('view_vendor') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/vendors', title: 'Vendor' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PRODUCTS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('agents') ? 'active' : '') + ((0, _permissions2.default)('view_agent') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/agentManagement', title: 'Agents' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PRODUCTS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'agents' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('paymentTerms') ? 'active' : '') + ((0, _permissions2.default)('view_payment_term') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/paymentTerms', title: 'Payment Term' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PRODUCTS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('contentManagement') ? 'active' : '') + ((0, _permissions2.default)('view_content_management') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/contentManagement', title: 'Content Management' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PRODUCTS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'content_management' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('fbaAddressManagement') ? 'active' : '') + ((0, _permissions2.default)('view_content_management') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { href: '/fbaAddressManagement', title: 'FBA Address Management' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.SALESINVOICE' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fbaAddressManagement' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('products/groups') ? 'active' : '') + ((0, _permissions2.default)('view_product_group') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/products/groups', title: 'Product Group' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PRODUCTS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: isJTB ? "customer_groups" : "groups_management" })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('priceLevel') ? 'active' : '') + ((0, _permissions2.default)('view_price_level') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/priceLevel', title: 'Price Level' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PRODUCTS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price_level' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('mobileManagement') ? 'active' : '') + ((0, _permissions2.default)('view_product_group') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/mobileManagement', title: 'Mobile Management' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PRODUCTS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mobile_management' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('categoryAnalysis') ? 'active' : '') + ((0, _permissions2.default)('view_category_analysis') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/categoryAnalysis', title: 'Category Analysis' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PRODUCTS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category_analysis' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('presidentDashboard') ? 'active' : '') + ((0, _permissions2.default)('view_dashboard_president') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/presidentDashboard', title: 'President Dashboard' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.PRODUCTS' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'president_dashboard' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            !(isMAG || isYI) && _react2.default.createElement(
	                                'li',
	                                { className: this.routeActive(['customerRMA', 'dispatchRMA', 'rmaForm']) ? 'active' : '' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'nav-item', onClick: this.toggleItemCollapse.bind(this, 'rma') },
	                                    _react2.default.createElement('em', { className: 'fa fa-recycle' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { 'data-localize': 'sidebar.nav.MENU' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rma' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Collapse,
	                                    { 'in': this.state.collapse.rma, timeout: 100 },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { id: 'quote', className: 'nav sidebar-subnav' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: 'sidebar-subnav-header' },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'setting' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('customerRMA') ? 'active' : '') + ((0, _permissions2.default)('view_rma_customer') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/customerRMA', title: 'RMA Form' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.RMAFORM' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_rma' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('dispatchRMA') ? 'active' : '') + ((0, _permissions2.default)('view_bd_rma') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/dispatchRMA', title: 'Dispatch RMA' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.DISPATCHRMA' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch_rma' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { className: this.routeActive(['userManagement', 'groupManagement', 'taxManagement', 'actionLog']) ? 'active' : '' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'nav-item', onClick: this.toggleItemCollapse.bind(this, 'setting') },
	                                    _react2.default.createElement('em', { className: 'fa fa-cog' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { 'data-localize': 'sidebar.nav.MENU' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'admin_tools' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Collapse,
	                                    { 'in': this.state.collapse.setting, timeout: 100 },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { id: 'quote', className: 'nav sidebar-subnav' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: 'sidebar-subnav-header' },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'setting' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('userManagement') ? 'active' : '') + ((0, _permissions2.default)('view_baseuser') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/userManagement', title: 'User Management' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.USERMANAGEMENT' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'user_management' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('groupManagement') ? 'active' : '') + ((0, _permissions2.default)('view_group') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/groupManagement', title: 'Role Management' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.ROLEMANAGEMENT' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'role_management' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('taxManagement') ? 'active' : '') + ((0, _permissions2.default)('view_tax_area') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/taxManagement', title: 'Tax Management' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.ROLEMANAGEMENT' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax_management' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('currencyManagement') ? 'active' : '') + ((0, _permissions2.default)('view_currency') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/currencyManagement', title: 'Currency Management' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.ROLEMANAGEMENT' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'currency_management' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            { className: (this.routeActive('actionLog') ? 'active' : '') + ((0, _permissions2.default)('view_baseuser') ? '' : 'disabled-sidebar') },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/actionLog', title: 'Action Log' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { 'data-localize': 'sidebar.nav.ROLEMANAGEMENT' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'action_log' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            !(isMAG || isYI) && _react2.default.createElement(
	                                'li',
	                                { className: this.routeActive('mmdriver') ? 'active' : '' },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/mmdriver', title: 'MMdriver' },
	                                    _react2.default.createElement('em', { className: 'fa fa-truck' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { 'data-localize': 'sidebar.nav.RMAFORM' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'MMdriver' })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Sidebar;
	}(_react.Component);
	
	Sidebar.contextTypes = {
	    router: _react2.default.PropTypes.func.isRequired
	};
	var _default = Sidebar;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(isGV, 'isGV', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Sidebar.jsx');
	
	    __REACT_HOT_LOADER__.register(isAFM, 'isAFM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Sidebar.jsx');
	
	    __REACT_HOT_LOADER__.register(isDSQ, 'isDSQ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Sidebar.jsx');
	
	    __REACT_HOT_LOADER__.register(isWIZ, 'isWIZ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Sidebar.jsx');
	
	    __REACT_HOT_LOADER__.register(isFJ, 'isFJ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Sidebar.jsx');
	
	    __REACT_HOT_LOADER__.register(isGA, 'isGA', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Sidebar.jsx');
	
	    __REACT_HOT_LOADER__.register(isJTB, 'isJTB', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Sidebar.jsx');
	
	    __REACT_HOT_LOADER__.register(isNBT, 'isNBT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Sidebar.jsx');
	
	    __REACT_HOT_LOADER__.register(isKM, 'isKM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Sidebar.jsx');
	
	    __REACT_HOT_LOADER__.register(isABC, 'isABC', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Sidebar.jsx');
	
	    __REACT_HOT_LOADER__.register(isMAG, 'isMAG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Sidebar.jsx');
	
	    __REACT_HOT_LOADER__.register(isTN, 'isTN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Sidebar.jsx');
	
	    __REACT_HOT_LOADER__.register(isJML, 'isJML', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Sidebar.jsx');
	
	    __REACT_HOT_LOADER__.register(isKDW, 'isKDW', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Sidebar.jsx');
	
	    __REACT_HOT_LOADER__.register(isABCFF, 'isABCFF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Sidebar.jsx');
	
	    __REACT_HOT_LOADER__.register(isYI, 'isYI', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Sidebar.jsx');
	
	    __REACT_HOT_LOADER__.register(isFBD, 'isFBD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Sidebar.jsx');
	
	    __REACT_HOT_LOADER__.register(Sidebar, 'Sidebar', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Sidebar.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Sidebar.jsx');
	}();

	;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(11);
	
	var CONST = _interopRequireWildcard(_constants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _default = function _default() {
	
	  var $win = $(window);
	  var $html = $('html');
	  var $body = $('body');
	  var $sidebar = $('.sidebar');
	  var mq = CONST.APP_MEDIAQUERY;
	
	  // AUTOCOLLAPSE ITEMS
	  // -----------------------------------
	
	  var sidebarCollapse = $sidebar.find('.collapse');
	  sidebarCollapse.on('show.bs.collapse', function (event) {
	
	    event.stopPropagation();
	    if ($(this).parents('.collapse').length === 0) sidebarCollapse.filter('.in').collapse('hide');
	  });
	
	  // SIDEBAR ACTIVE STATE
	  // -----------------------------------
	
	  // // Find current active item
	  // var currentItem = $('.sidebar .active').parents('li');
	
	  // // hover mode don't try to expand active collapse
	  // if ( ! useAsideHover() )
	  //   currentItem
	  //     .addClass('active')     // activate the parent
	  //     .children('.collapse')  // find the collapse
	  //     .collapse('show');      // and show it
	
	  // // remove this if you use only collapsible sidebar items
	  // $sidebar.find('li > a + ul').on('show.bs.collapse', function (e) {
	  //   if( useAsideHover() ) e.preventDefault();
	  // });
	
	  // SIDEBAR COLLAPSED ITEM HANDLER
	  // -----------------------------------
	
	
	  var eventName = isTouch() ? 'click' : 'mouseenter';
	  var subNav = $();
	  $sidebar.on(eventName, '.nav > li', function () {
	
	    if (isSidebarCollapsed() || useAsideHover()) {
	
	      subNav.trigger('mouseleave');
	      subNav = toggleMenuItem($(this));
	
	      // Used to detect click and touch events outside the sidebar
	      sidebarAddBackdrop();
	    }
	  });
	
	  var sidebarAnyclickClose = $sidebar.data('sidebarAnyclickClose');
	
	  // Allows to close
	  if (typeof sidebarAnyclickClose !== 'undefined') {
	
	    $('.wrapper').on('click.sidebar', function (e) {
	      // don't check if sidebar not visible
	      if (!$body.hasClass('aside-toggled')) return;
	
	      var $target = $(e.target);
	      if (!$target.parents('.aside').length && // if not child of sidebar
	      !$target.parents('.topnavbar-wrapper').length && // if not child of header
	      !$target.is('#user-block-toggle') && // user block toggle anchor
	      !$target.parent().is('#user-block-toggle') // user block toggle icon
	      ) {
	          $body.removeClass('aside-toggled');
	        }
	    });
	  }
	
	  function sidebarAddBackdrop() {
	    var $backdrop = $('<div/>', { 'class': 'dropdown-backdrop' });
	    $backdrop.insertAfter('.aside').on("click mouseenter", function () {
	      removeFloatingNav();
	    });
	  }
	
	  // Open the collapse sidebar submenu items when on touch devices
	  // - desktop only opens on hover
	  function toggleTouchItem($element) {
	    $element.siblings('li').removeClass('open').end().toggleClass('open');
	  }
	
	  // Handles hover to open items under collapsed menu
	  // -----------------------------------
	  function toggleMenuItem($listItem) {
	
	    removeFloatingNav();
	
	    var ul = $listItem.children('ul');
	
	    if (!ul.length) return $();
	    if ($listItem.hasClass('open')) {
	      toggleTouchItem($listItem);
	      return $();
	    }
	
	    var $aside = $('.aside');
	    var $asideInner = $('.aside-inner'); // for top offset calculation
	    // float aside uses extra padding on aside
	    var mar = parseInt($asideInner.css('padding-top'), 0) + parseInt($aside.css('padding-top'), 0);
	
	    var subNav = ul.clone().appendTo($aside);
	
	    toggleTouchItem($listItem);
	
	    var itemTop = $listItem.position().top + mar - $sidebar.scrollTop();
	    var vwHeight = $win.height();
	
	    subNav.addClass('nav-floating').css({
	      position: isFixed() ? 'fixed' : 'absolute',
	      top: itemTop,
	      bottom: subNav.outerHeight(true) + itemTop > vwHeight ? 0 : 'auto'
	    });
	
	    subNav.on('mouseleave', function () {
	      toggleTouchItem($listItem);
	      subNav.remove();
	    });
	
	    return subNav;
	  }
	
	  function removeFloatingNav() {
	    $('.sidebar-subnav.nav-floating').remove();
	    $('.dropdown-backdrop').remove();
	    $('.sidebar li.open').removeClass('open');
	  }
	
	  function isTouch() {
	    return $html.hasClass('touch');
	  }
	  function isSidebarCollapsed() {
	    return $body.hasClass('aside-collapsed');
	  }
	  function isSidebarToggled() {
	    return $body.hasClass('aside-toggled');
	  }
	  function isMobile() {
	    return $win.width() < mq.tablet;
	  }
	  function isFixed() {
	    return $body.hasClass('layout-fixed');
	  }
	  function useAsideHover() {
	    return $body.hasClass('aside-hover');
	  }
	};
	
	exports.default = _default; // rendered
	
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/Sidebar.run.js');
	}();

	;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _baseModal_actions = __webpack_require__(80);
	
	var _VerifyPasscodeModal = __webpack_require__(115);
	
	var _VerifyPasscodeModal2 = _interopRequireDefault(_VerifyPasscodeModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  visibility: _propTypes2.default.bool.isRequired,
	  setConfirmPasscodeModalVisibility: _propTypes2.default.func.isRequired,
	  handleVerifyPasscodeResult: _propTypes2.default.func.isRequired
	};
	
	var defaultProps = {
	  // visibility: false,
	  // setConfirmPasscodeModalVisibility: () => { },
	  // handleVerifyPasscode: () => { },
	};
	
	var BaseModals = function (_Component) {
	  _inherits(BaseModals, _Component);
	
	  function BaseModals() {
	    _classCallCheck(this, BaseModals);
	
	    var _this = _possibleConstructorReturn(this, (BaseModals.__proto__ || Object.getPrototypeOf(BaseModals)).call(this));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(BaseModals, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: {},
	            isVisible: this.props.visibility,
	            onCloseClicked: this.props.setConfirmPasscodeModalVisibility
	          },
	          _react2.default.createElement(_VerifyPasscodeModal2.default, {
	            closeConfirm: this.props.handleVerifyPasscodeResult,
	            text: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'passcode_confirm_text' })
	          })
	        )
	      );
	    }
	  }]);
	
	  return BaseModals;
	}(_react.Component);
	
	function mapState(state) {
	  return {
	    visibility: state.baseModals.confirmPasscodeModal.visibility
	  };
	}
	
	var mapActions = {
	  setConfirmPasscodeModalVisibility: _baseModal_actions.setConfirmPasscodeModalVisibility,
	  handleVerifyPasscodeResult: _baseModal_actions.handleVerifyPasscodeResult
	};
	
	BaseModals.propTypes = propTypes;
	BaseModals.defaultProps = defaultProps;
	
	var _default = (0, _reactRedux.connect)(mapState, mapActions)(BaseModals);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapState, 'mapState', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/baseModals.jsx');
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/baseModals.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/baseModals.jsx');
	
	  __REACT_HOT_LOADER__.register(BaseModals, 'BaseModals', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/baseModals.jsx');
	
	  __REACT_HOT_LOADER__.register(mapActions, 'mapActions', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/baseModals.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Layout/baseModals.jsx');
	}();

	;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _genericRadioFilter = __webpack_require__(50);
	
	var _genericRadioFilter2 = _interopRequireDefault(_genericRadioFilter);
	
	var _dateFilterRadios = __webpack_require__(49);
	
	var _dateFilterRadios2 = _interopRequireDefault(_dateFilterRadios);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MMdriver = function (_Component) {
	    _inherits(MMdriver, _Component);
	
	    function MMdriver(props) {
	        _classCallCheck(this, MMdriver);
	
	        var _this = _possibleConstructorReturn(this, (MMdriver.__proto__ || Object.getPrototypeOf(MMdriver)).call(this, props));
	
	        _this.handleStatusFilterChange = function (status) {
	            console.log('handleStatusFilterChange run,', status);
	            _this.setState({
	                value: status
	            });
	        };
	
	        _this.setFromDate = function (date) {
	            console.log('tyou are settin g thr from date', date);
	            _this.setState({
	                FromDate: date
	            });
	        };
	
	        _this.setToDate = function (date) {
	            console.log('setting to date', date);
	            _this.setState({
	                ToDate: date
	            });
	        };
	
	        _this.fetchDriverApplication = function (days) {
	            console.log('trying to seearch', days, _this.state);
	            var FromDate = '1900-01-01';
	            var ToDate = '3000-01-01';
	            if (_this.state.FromDate != null) {
	                FromDate = _this.formatDate(_this.state.FromDate);
	            }
	            if (_this.state.ToDate != null) {
	                ToDate = _this.formatDate(_this.state.ToDate);
	            }
	            if (days === '-1' || days === -1) {
	                _this.setState({ days: days }, function () {
	                    _this.props.fetchMMDriversByTime(FromDate, ToDate);
	                });
	            } else {
	                _this.setState({ days: days, FromDate: null, ToDate: null }, function () {
	                    var fromDate = new Date(new Date().getTime() - days * 24 * 60 * 60 * 1000);
	                    _this.props.fetchMMDriversByTime(_this.formatDate(fromDate), ToDate);
	                });
	            }
	            _this.setState({ selectedRows: [{}], days: days });
	        };
	
	        _this.handleDriverEditClick = function (e) {
	            console.log('edit button clicked', _this.state.selectedRows);
	            _this.setState({
	                show: true
	            });
	        };
	
	        _this.renderModal = function () {
	            var handleHide = function handleHide() {
	                _this.setState({ show: false });
	            };
	
	            var handleSelectionChange = function handleSelectionChange(e) {
	                console.log('this is hte state', _this.state);
	                console.log('you change the selection', e.target.value);
	                _this.setState({
	                    is_process: e.target.value
	                });
	            };
	
	            var handleDriverInfoChange = function handleDriverInfoChange() {
	                console.log('now all modifying infos are here', _this.state);
	                var bol = _this.state.is_process.toLowerCase();
	                var data = _extends({}, _this.state.selectedRows[0], {
	                    is_process: bol === "no" ? false : true
	                });
	                _this.props.editDriverInfomation(data);
	                // this.forceUpdate();
	            };
	            // const value = this.state.selectedRows[0] ? this.state.selectedRows[0].is_process : 'no'
	            // console.log('renderModal run', value);
	            return _react2.default.createElement(
	                'div',
	                { className: 'modal-container-shayne' },
	                _react2.default.createElement(
	                    _reactBootstrap.Modal,
	                    {
	                        show: _this.state.show
	                        // onHide={handleHide}
	                        , container: _this,
	                        'aria-labelledby': 'contained-modal-title'
	                    },
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Header,
	                        { closeButton: true },
	                        _react2.default.createElement(
	                            _reactBootstrap.Modal.Title,
	                            { id: 'contained-modal-title' },
	                            'MyuMyu Driver Application'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Body,
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                'Processed:'
	                            ),
	                            _react2.default.createElement(
	                                'select',
	                                { value: _this.state.is_process, onChange: function onChange(e) {
	                                        return handleSelectionChange(e);
	                                    } },
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: 'Yes' },
	                                    'Yes'
	                                ),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: 'No' },
	                                    'No'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Footer,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            { onClick: handleHide },
	                            'Close'
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            { onClick: handleDriverInfoChange },
	                            'Confirm'
	                        )
	                    )
	                )
	            );
	        };
	
	        _this.state = {
	            path: "MMdriver",
	            value: 'all',
	            FromDate: undefined,
	            ToDate: undefined,
	            days: '7',
	            search: '',
	            drivers: [],
	            filters: {},
	            rows: [],
	            selectedRows: [],
	            show: false,
	            is_process: 'no'
	        };
	        return _this;
	    }
	
	    _createClass(MMdriver, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.fetchDriverApplication(7);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            var modifiedDrivers = newProps.drivers.map(function (driver) {
	                console.log('this is each driver', driver);
	                return _extends({}, driver, {
	                    is_process: driver.is_process ? 'Yes' : 'No'
	                });
	            });
	            this.setState({
	                rows: modifiedDrivers
	            });
	        }
	    }, {
	        key: 'formatDate',
	        value: function formatDate(date) {
	            var formattedDate = date.getFullYear() + '-';
	            formattedDate += date.getMonth() + 1 + '-';
	            if (date.getDate() < 10) {
	                formattedDate += '0' + date.getDate();
	            } else {
	                formattedDate += date.getDate();
	            }
	            return formattedDate;
	        }
	    }, {
	        key: 'renderDriversTable',
	        value: function renderDriversTable() {
	            var _this2 = this;
	
	            var booleanFormatter = function booleanFormatter(_ref) {
	                var value = _ref.value;
	
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    value ? 'yes' : 'no'
	                );
	            };
	            var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                _this2.setState(state);
	            };
	
	            var handleFilterChange = function handleFilterChange(filter) {
	                // const { rows } = this.state;
	                // this.setState({ rows });
	                var newFilters = Object.assign({}, _this2.state.filters);
	                if (filter.filterTerm) {
	                    newFilters[filter.column.key] = filter;
	                } else {
	                    delete newFilters[filter.column.key];
	                }
	                _this2.setState({ filters: newFilters });
	            };
	
	            var getRows = function getRows() {
	                return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	            };
	            var getSize = function getSize() {
	                return getRows().length;
	            };
	
	            var rowGetter = function rowGetter(rowIdx) {
	                var rows = getRows();
	                console.log('this is all rows', rows);
	                return rows[rowIdx];
	            };
	
	            var onRowClick = function onRowClick(rowIdx, row) {
	                if (rowIdx !== -1) {
	                    var rows = getRows();
	                    rows.map(function (r) {
	                        r.isSelected = false;
	                    });
	                    rows[rowIdx].isSelected = true;
	                    _this2.setState({ rows: rows, selectedRows: [rows[rowIdx]] });
	                }
	            };
	
	            var onCellSelected = function onCellSelected(coordinates) {
	                var rows = getRows();
	                rows.map(function (r) {
	                    r.isSelected = false;
	                });
	                rows[coordinates.rowIdx].isSelected = true;
	                _this2.setState({ rows: rows, selectedRows: [rows[coordinates.rowIdx]] });
	            };
	
	            var onClearFilters = function onClearFilters() {
	                _this2.setState({ filters: {} });
	            };
	            var onRowsSelected = function onRowsSelected(rows) {
	                console.log('onRowsSelected this is the rows', rows);
	                var newRows = getRows();
	                var selectedRows = [newRows[rows[0].rowIdx]];
	                newRows.map(function (r) {
	                    r.isSelected = false;
	                });
	                rows.map(function (r) {
	                    newRows[r.rowIdx].isSelected = true;
	                });
	                _this2.setState({ rows: newRows, selectedRows: selectedRows, is_process: rows[0]['row']['is_process'] }, function () {
	                    console.log('you just selected an row', _this2.state);
	                });
	            };
	            var onRowsDeselected = function onRowsDeselected(rows) {
	                var newRows = [].concat(_toConsumableArray(_this2.state.rows));
	                rows.map(function (r) {
	                    newRows[r.rowIdx].isSelected = false;
	                });
	                _this2.setState({ rows: newRows, selectedRows: [] });
	            };
	
	            var columns = [{
	                key: 'first_name',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'first_name' }),
	                resizable: true,
	                sortable: true,
	                width: 80,
	                filterable: true
	            }, {
	                key: 'last_name',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_name' }),
	                resizable: true,
	                sortable: true,
	                width: 120,
	                filterable: true
	            }, {
	                key: 'is_process',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'processed' }),
	                // formatter: booleanFormatter,
	                resizable: true,
	                sortable: true,
	                width: 90,
	                filterable: true
	            }, {
	                key: 'email',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' }),
	                resizable: true,
	                sortable: true,
	                width: 100,
	                filterable: true
	            }, {
	                key: 'phone_number',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone_number' }),
	                resizable: true,
	                sortable: true,
	                filterable: true,
	                width: 160
	            }];
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    null,
	                    _react2.default.createElement(_reactDataGrid2.default
	                    // rowKey="RMA_num"
	                    , { enableCellSelect: true,
	                        onClearFilters: onClearFilters,
	                        onGridSort: handleGridSort,
	                        toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                        onAddFilter: handleFilterChange,
	                        columns: columns,
	                        rowHeight: 25,
	                        headerRowHeight: 45,
	                        rowGetter: rowGetter,
	                        rowsCount: getSize(),
	                        minHeight: 270,
	                        enableRowSelect: 'single'
	                        // onRowUpdated={this.handleRowUpdated}
	                        , rowSelection: {
	                            showCheckbox: true,
	                            onRowsSelected: onRowsSelected,
	                            onRowsDeselected: onRowsDeselected,
	                            selectBy: {
	                                isSelectedKey: 'isSelected'
	                            }
	                        },
	                        onRowClick: onRowClick,
	                        onCellSelected: onCellSelected
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Breadcrumb,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb.Item,
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rma' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb.Item,
	                        { active: 'true' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: this.state.path === 'MMdriver' ? "MMdriver" : "MMdriver" })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Grid,
	                    { id: 'purchase-order-list' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        { id: 'date-range-picker', className: 'form-horizontal' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3 },
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'filter-title' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'application_date' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: 'colon' },
	                                        ':'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 9 },
	                                (0, _dateFilterRadios2.default)({
	                                    handleOnClick: this.fetchDriverApplication,
	                                    setToRangeSearch: function setToRangeSearch() {
	                                        return _this3.setState({ days: '-1' });
	                                    },
	                                    setFromDate: function setFromDate(date) {
	                                        return _this3.setFromDate(date);
	                                    },
	                                    setToDate: function setToDate(date) {
	                                        return _this3.setToDate(date);
	                                    },
	                                    FromDate: this.state.FromDate,
	                                    ToDate: this.state.ToDate,
	                                    Days: this.state.days
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        { className: 'position-relative table-collapse-fix' },
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            { className: 'table-buttons' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'warning',
	                                    type: 'button',
	                                    onClick: function onClick(e) {
	                                        return _this3.handleDriverEditClick(e);
	                                    },
	                                    disabled: this.state.selectedRows.length === 0
	                                },
	                                _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	                            )
	                        ),
	                        this.renderDriversTable()
	                    )
	                ),
	                this.renderModal()
	            );
	        }
	    }]);
	
	    return MMdriver;
	}(_react.Component);
	
	var _default = MMdriver;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(MMdriver, 'MMdriver', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/MMdriver/index.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/MMdriver/index.jsx');
	}();

	;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _constants = __webpack_require__(11);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _paymentTermForm = __webpack_require__(172);
	
	var _paymentTermForm2 = _interopRequireDefault(_paymentTermForm);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentTerms = function (_Component) {
	  _inherits(PaymentTerms, _Component);
	
	  function PaymentTerms() {
	    _classCallCheck(this, PaymentTerms);
	
	    var _this = _possibleConstructorReturn(this, (PaymentTerms.__proto__ || Object.getPrototypeOf(PaymentTerms)).call(this));
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.customersPage,
	      rows: [],
	      selectedRows: null,
	      filters: {},
	      sortColumn: null,
	      sortDirection: null,
	      paymentTermOpen: false
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.openPaymentTerm = _this.openPaymentTerm.bind(_this);
	    _this.closePaymentTerm = _this.closePaymentTerm.bind(_this);
	    return _this;
	  }
	
	  _createClass(PaymentTerms, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      window.addEventListener('resize', this.handleResize);
	      this.props.fetchPaymentTerms();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	
	    // Once paymentTerm is ready, reset state.
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var PT = nextProps.paymentTerms;
	      if (nextProps.paymentTerms && nextProps.paymentTerms != this.props.paymentTerms) {
	        this.setState({ rows: nextProps.paymentTerms });
	      }
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.customersPage });
	    }
	  }, {
	    key: 'openPaymentTerm',
	    value: function openPaymentTerm() {
	      this.setState({ paymentTermOpen: true });
	    }
	  }, {
	    key: 'closePaymentTerm',
	    value: function closePaymentTerm() {
	      this.setState({ paymentTermOpen: false });
	    }
	
	    // Helper function to render an icon for the stock statues of paymentTerm.
	
	  }, {
	    key: 'renderIsEnabled',
	    value: function renderIsEnabled(IsEnabled) {
	      if (IsEnabled) return _react2.default.createElement(
	        'span',
	        { className: 'label label-success' },
	        'Enabled'
	      );else return _react2.default.createElement(
	        'span',
	        { className: 'label label-danger' },
	        'Disabled'
	      );
	    }
	
	    // Set paymentTerm being selected to be currentPaymentTerm and navigate user to the edit page
	
	  }, {
	    key: 'setCurrentPaymentTerm',
	    value: function setCurrentPaymentTerm(e) {
	      e.preventDefault();
	      var currentPaymentTerm = this.state.selectedRows[0];
	      this.props.selectPaymentTerm(currentPaymentTerm);
	      this.openPaymentTerm();
	    }
	  }, {
	    key: 'clickNew',
	    value: function clickNew(e) {
	      e.preventDefault();
	      this.props.resetCurrentPaymentTerm();
	      this.openPaymentTerm();
	    }
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this2 = this;
	
	      if (this.props.isLoading && !this.props.error) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.error) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.error)
	          )
	        );
	      } else {
	        // Parameters of the react-data-grid
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Column difinition
	        var columns = [{
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 150
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 150
	        }, {
	          key: 'TermDays',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'term_days' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 50
	        }, {
	          key: 'Termtype',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'term_type' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 100
	        }];
	
	        // Handle the sortable function
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this2.setState(state);
	        };
	
	        var handleFilterChange = function handleFilterChange(filter) {
	          var newFilters = Object.assign({}, _this2.state.filters);
	          if (filter.filterTerm) {
	            newFilters[filter.column.key] = filter;
	          } else {
	            delete newFilters[filter.column.key];
	          }
	          _this2.setState({ filters: newFilters });
	        };
	
	        // Handle the editable function
	        var handleRowUpdated = function handleRowUpdated(e) {
	          // merge updated row with current row and rerender by setting state
	          var rows = getRows();
	          Object.assign(rows[e.rowIdx], e.updated);
	          _this2.setState({ rows: rows });
	        };
	
	        // Handle the Dragable cell function
	        var handleCellDrag = function handleCellDrag(e) {
	          var rows = _this2.state.rows.slice(0);
	          for (var i = e.fromRow; i <= e.toRow; i++) {
	            var rowToUpdate = rows[i];
	            rowToUpdate[e.cellKey] = e.value;
	          }
	          _this2.setState({ rows: rows });
	        };
	
	        var handleDragHandleDoubleClick = function handleDragHandleDoubleClick(e) {
	          var rows = _this2.state.rows.map(function (r) {
	            return Object.assign({}, r);
	          });
	          var column = columns[e.idx - 1];
	          for (var i = e.rowIdx; i <= rows.length - 1; i++) {
	            var rowToUpdate = rows[i];
	            rowToUpdate[column.key] = e.rowData[column.key];
	          }
	          _this2.setState({ rows: rows });
	        };
	
	        var onRowSelect = function onRowSelect(rows) {
	          _this2.setState({ selectedRows: rows });
	        };
	
	        return (
	          // React Table Payment Terms List
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 12 },
	              _react2.default.createElement(
	                'div',
	                { id: 'PaymentTerms-dataGrid1' },
	                _react2.default.createElement(_reactDataGrid2.default, {
	                  rowKey: 'PaymentTerm_id',
	                  enableCellSelect: true,
	                  onGridSort: handleGridSort,
	                  toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                  onAddFilter: handleFilterChange,
	                  columns: columns,
	                  rowHeight: 25,
	                  headerRowHeight: 45,
	                  rowGetter: rowGetter,
	                  rowsCount: getSize(),
	                  minHeight: this.state.tableHeight,
	                  enableRowSelect: 'single',
	                  onRowUpdated: handleRowUpdated,
	                  onDragHandleDoubleClick: handleDragHandleDoubleClick,
	                  onCellsDragged: handleCellDrag,
	                  onRowSelect: onRowSelect })
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'formTitle',
	    value: function formTitle() {
	      if (this.props.currentPaymentTerm) return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_paymentTerm' });else return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_payment_term' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var createDialogStyle = {
	        height: '300px',
	        width: '600px',
	        marginLeft: '-10%'
	      };
	      var height = (this.state.tableHeight + 70).toString();
	      var tableCollapseFix = { height: height };
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term' })
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { fluid: 'true', id: 'payment-terms' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'position-relative', style: tableCollapseFix },
	                  _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    { className: 'table-buttons' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'success',
	                        type: 'submit',
	                        onClick: function onClick(event) {
	                          _this3.clickNew(event);
	                        },
	                        disabled: !(0, _permissions2.default)("add_payment_term") },
	                      _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'warning',
	                        type: 'button',
	                        onClick: function onClick(event) {
	                          _this3.setCurrentPaymentTerm(event);
	                        },
	                        disabled: !this.state.selectedRows || this.state.selectedRows.length != 1 || !(0, _permissions2.default)("change_payment_term") },
	                      _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	                    )
	                  ),
	                  this.renderTable()
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            { dialogStyles: createDialogStyle, isVisible: this.state.paymentTermOpen, onCloseClicked: function onCloseClicked() {
	                _this3.closePaymentTerm();
	              }, title: this.formTitle() },
	            _react2.default.createElement(_paymentTermForm2.default, { closePT: this.closePaymentTerm })
	          )
	        )
	        //---------------
	        //End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return PaymentTerms;
	}(_react.Component);
	
	PaymentTerms.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = PaymentTerms;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PaymentTerms, 'PaymentTerms', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/PaymentTerms/paymentTerms.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/PaymentTerms/paymentTerms.jsx');
	}();

	;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TypeRadios = __webpack_require__(57);
	
	var _TypeRadios2 = _interopRequireDefault(_TypeRadios);
	
	var _GenericProductSuggest = __webpack_require__(51);
	
	var _GenericProductSuggest2 = _interopRequireDefault(_GenericProductSuggest);
	
	var _products_actions = __webpack_require__(30);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(5),
	    _require$Draggable = _require.Draggable,
	    DraggableContainer = _require$Draggable.Container,
	    RowActionsCell = _require$Draggable.RowActionsCell,
	    DropTargetRowContainer = _require$Draggable.DropTargetRowContainer,
	    Selectors = _require.Data.Selectors;
	
	var RowRenderer = DropTargetRowContainer(_reactDataGrid2.default.Row);
	
	var propTypes = {
	  category2Products: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  category2ProductsIsLoading: _propTypes2.default.bool.isRequired,
	  category2Id: _propTypes2.default.number,
	  dependentValues: _propTypes2.default.shape({
	    ProductNum: _propTypes2.default.string
	  }),
	  rowKey: _propTypes2.default.string
	};
	
	var defaultProps = {
	  category2Products: [],
	  dependentValues: {},
	  category2Id: null,
	  rowKey: 'Index'
	};
	
	var Category2B2BDetail = function (_Component) {
	  _inherits(Category2B2BDetail, _Component);
	
	  function Category2B2BDetail(props) {
	    _classCallCheck(this, Category2B2BDetail);
	
	    var _this = _possibleConstructorReturn(this, (Category2B2BDetail.__proto__ || Object.getPrototypeOf(Category2B2BDetail)).call(this, props));
	
	    _this.onSuggestionSelected = function (productNum, suggestions) {
	      _this.setState({ selectedProduct: suggestions }, _this.addProductToTable);
	    };
	
	    _this.addProductToTable = function () {
	      console.log("here", _this.props);
	      if (!_this.props.category2Id) {
	        alert('Please select a category.');
	        return;
	      }
	      _this.setState(function (prevState) {
	        var rows = prevState.rows,
	            selectedProduct = prevState.selectedProduct;
	
	        var index = _lodash2.default.findIndex(rows, { Product_id: selectedProduct.Product_id });
	        if (index === -1) {
	          rows.push(selectedProduct);
	        } else {
	          alert('Product is already in the list');
	        }
	        return { rows: rows, selectedProduct: null, suggestValue: '' };
	      });
	    };
	
	    _this.handleOptionChange = function (changeEvent) {
	      _this.setState({ productSearchType: changeEvent.target.value });
	    };
	
	    _this.removeRow = function (ProductNum) {
	      var rows = [].concat(_toConsumableArray(_this.state.rows));
	      rows = rows.filter(function (obj) {
	        var match = String(obj.ProductNum) !== ProductNum;
	        return match;
	      });
	      _this.setState({ rows: rows });
	    };
	
	    _this.handleCategory2ProductsSave = function () {
	      var category2Id = _this.props.category2Id;
	      var rows = _this.state.rows;
	
	      var products = _lodash2.default.map(rows, 'Product_id');
	      var handleSuccess = function handleSuccess() {
	        _this.setState({ isLoadingSave: false });
	      };
	
	      var handleFailure = function handleFailure(error) {
	        _this.setState({ isLoadingSave: false });
	        alert(JSON.stringify(error));
	      };
	
	      _this.setState({ isLoadingSave: true }, function () {
	        (0, _products_actions.saveCategory2ProductsB2B)(products, category2Id, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.state = {
	      sortColumn: null,
	      sortDirection: null,
	      filters: {},
	      rows: [],
	      selectedRows: [],
	      editedRows: [],
	
	      suggestValue: '',
	      productSearchType: 'ProductNum',
	      selectedProduct: null,
	
	      isLoadingSave: false
	    };
	    return _this;
	  }
	
	  _createClass(Category2B2BDetail, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.category2Products && nextProps.category2Products !== this.props.category2Products) {
	        this.setState({ rows: nextProps.category2Products });
	      }
	    }
	  }, {
	    key: 'renderAutoSuggest',
	    value: function renderAutoSuggest() {
	      var _this2 = this;
	
	      return _react2.default.createElement(_GenericProductSuggest2.default, {
	        value: this.state.suggestValue,
	        onChange: function onChange(e, _ref) {
	          var newValue = _ref.newValue;
	          _this2.setState({ suggestValue: newValue });
	        },
	        SearchType: this.state.productSearchType,
	        fetchOrdersByProduct: this.onSuggestionSelected
	      });
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this3 = this;
	
	      var that = this;
	      if (this.props.category2ProductsIsLoading) {
	        return _react2.default.createElement(_spinner2.default, null);
	      }
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this3.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this3.setState(state);
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this3.state.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var state = _extends({}, _this3.state, { filters: newFilters });
	        _this3.setState(state);
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        var state = _extends({}, _this3.state, { filters: {} });
	        _this3.setState(state);
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        // merge updated row with current row and rerender by setting state
	        _this3.setState({ sortColumn: null, sortDirection: null });
	        var rows = getRows();
	        var editedRows = _this3.state.editedRows.slice(0);
	        Object.assign(rows[e.rowIdx], e.updated);
	        // if the element is already edited, remove the old one.
	        editedRows.forEach(function (element, index) {
	          if (element.Idx === rows[e.rowIdx].Idx) {
	            editedRows.splice(index, 1);
	          }
	        }, _this3);
	        // push the row into the editedRows array
	        editedRows.push(rows[e.rowIdx]);
	        _this3.setState({ rows: rows, editedRows: editedRows });
	      };
	
	      var isDraggedRowSelected = function isDraggedRowSelected(selectedRows, rowDragSource) {
	        if (selectedRows && selectedRows.length > 0) {
	          var key = _this3.props.rowKey;
	          return selectedRows.filter(function (r) {
	            return r[key] === rowDragSource.data[key];
	          }).length > 0;
	        }
	        return false;
	      };
	
	      var reorderRows = function reorderRows(e) {
	        var selectedRows = Selectors.getSelectedRowsByKey({ rowKey: _this3.props.rowKey, selectedKeys: [], rows: _this3.state.rows });
	        var draggedRows = isDraggedRowSelected(selectedRows, e.rowSource) ? selectedRows : [e.rowSource.data];
	        var undraggedRows = _this3.state.rows.filter(function (r) {
	          return draggedRows.indexOf(r) === -1;
	        });
	        var args = [e.rowTarget.idx, 0].concat(draggedRows);
	        Array.prototype.splice.apply(undraggedRows, args);
	        undraggedRows.map(function (row, index) {
	          row.Index = index;
	        });
	        _this3.setState({ rows: undraggedRows });
	      };
	
	      var IsVariableFormatter = _react2.default.createClass({
	        displayName: 'IsVariableFormatter',
	        render: function render() {
	          var _this4 = this;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                className: 'textAlignStyle',
	                style: { height: '23px', width: '39px', padding: '0px' },
	                onClick: function onClick() {
	                  var ProductNum = _this4.props.dependentValues.ProductNum;
	
	                  that.removeRow(ProductNum);
	                }
	              },
	              'X'
	            )
	          );
	        }
	      });
	
	      var columns = [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 150
	      }, {
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	        resizable: true,
	        sortable: false,
	        filterable: true,
	        width: 250
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: false,
	        filterable: true,
	        width: 250
	      }];
	
	      // if (this.state.rows && this.state.rows.length > 0) {
	      //   this.state.rows.map((r) => {
	      //     r.RefNum = Number(r.RefNum);
	      //   });
	      // }
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '99%' }, id: 'Category2Detail-dataGrid1' },
	            _react2.default.createElement(
	              DraggableContainer,
	              null,
	              _react2.default.createElement(_reactDataGrid2.default, {
	                onGridSort: handleGridSort,
	                columns: columns,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                onAddFilter: handleFilterChange,
	                onClearFilters: onClearFilters,
	                minHeight: 570,
	                rowHeight: 25,
	                enableRowSelect: 'single',
	                rowActionsCell: RowActionsCell,
	                rowRenderer: _react2.default.createElement(RowRenderer, { onRowDrop: reorderRows }),
	                onRowUpdated: handleRowUpdated
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactBootstrap.Panel,
	        { id: 'category2-detail' },
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category_2_B2B_product_list' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            { id: 'search-panel' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12, className: 'search-panel-left text-nowrap' },
	              _react2.default.createElement(
	                'div',
	                { id: 'autosuggest-div' },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { style: { height: '30px' } },
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    _react2.default.createElement(_TypeRadios2.default, {
	                      value: this.state.productSearchType,
	                      handleOptionChange: this.handleOptionChange
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    this.renderAutoSuggest()
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            { style: { position: 'absolute', zIndex: 3 } },
	            _react2.default.createElement(_SpinnerButton2.default, {
	              bsStyle: 'success',
	              onClick: this.handleCategory2ProductsSave,
	              disabled: this.state.isLoadingSave,
	              loading: this.state.isLoadingSave,
	              icon: 'fa-save',
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	            })
	          ),
	          this.renderTable()
	        )
	      );
	    }
	  }]);
	
	  return Category2B2BDetail;
	}(_react.Component);
	
	Category2B2BDetail.propTypes = propTypes;
	Category2B2BDetail.defaultProps = defaultProps;
	
	var _default = Category2B2BDetail;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/Category2B2BDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/Category2B2BDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/Category2B2BDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(Category2B2BDetail, 'Category2B2BDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/Category2B2BDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/Category2B2BDetail.jsx');
	}();

	;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TypeRadios = __webpack_require__(57);
	
	var _TypeRadios2 = _interopRequireDefault(_TypeRadios);
	
	var _GenericProductSuggest = __webpack_require__(51);
	
	var _GenericProductSuggest2 = _interopRequireDefault(_GenericProductSuggest);
	
	var _products_actions = __webpack_require__(30);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEcity = _root_url.ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/';
	var isAFM = _root_url.ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afm-scm.truckxi.com/api/';
	
	var _require = __webpack_require__(5),
	    _require$Draggable = _require.Draggable,
	    DraggableContainer = _require$Draggable.Container,
	    RowActionsCell = _require$Draggable.RowActionsCell,
	    DropTargetRowContainer = _require$Draggable.DropTargetRowContainer,
	    Selectors = _require.Data.Selectors;
	
	var RowRenderer = DropTargetRowContainer(_reactDataGrid2.default.Row);
	
	var propTypes = {
	  category2Products: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  category2ProductsIsLoading: _propTypes2.default.bool.isRequired,
	  category2Id: _propTypes2.default.number,
	  dependentValues: _propTypes2.default.shape({
	    ProductNum: _propTypes2.default.string
	  }),
	  rowKey: _propTypes2.default.string
	};
	
	var defaultProps = {
	  category2Products: [],
	  dependentValues: {},
	  category2Id: null,
	  rowKey: 'Index'
	};
	
	var Category2Detail = function (_Component) {
	  _inherits(Category2Detail, _Component);
	
	  function Category2Detail(props) {
	    _classCallCheck(this, Category2Detail);
	
	    var _this = _possibleConstructorReturn(this, (Category2Detail.__proto__ || Object.getPrototypeOf(Category2Detail)).call(this, props));
	
	    _this.onSuggestionSelected = function (productNum, suggestions) {
	      _this.setState({ selectedProduct: suggestions }, _this.addProductToTable);
	    };
	
	    _this.addProductToTable = function () {
	      if (!_this.props.category2Id) {
	        alert('Please select a category.');
	        return;
	      }
	      _this.setState(function (prevState) {
	        var rows = prevState.rows,
	            selectedProduct = prevState.selectedProduct;
	
	        var index = _lodash2.default.findIndex(rows, { Product_id: selectedProduct.Product_id });
	        if (index === -1) {
	          if (isEcity) {
	            rows.unshift(selectedProduct);
	          } else {
	            rows.push(selectedProduct);
	          }
	        } else {
	          alert('Product is already in the list');
	        }
	        return { rows: rows, selectedProduct: null, suggestValue: '' };
	      });
	    };
	
	    _this.handleOptionChange = function (changeEvent) {
	      _this.setState({ productSearchType: changeEvent.target.value });
	    };
	
	    _this.removeRow = function (ProductNum) {
	      var rows = [].concat(_toConsumableArray(_this.state.rows));
	      rows = rows.filter(function (obj) {
	        var match = String(obj.ProductNum) !== ProductNum;
	        return match;
	      });
	      _this.setState({ rows: rows });
	    };
	
	    _this.handleCategory2ProductsSave = function () {
	      var category2Id = _this.props.category2Id;
	      var rows = _this.state.rows;
	
	      var products = _lodash2.default.map(rows, 'Product_id');
	
	      var handleSuccess = function handleSuccess() {
	        _this.setState({ isLoadingSave: false });
	      };
	
	      var handleFailure = function handleFailure(error) {
	        _this.setState({ isLoadingSave: false });
	        alert(JSON.stringify(error));
	      };
	
	      _this.setState({ isLoadingSave: true }, function () {
	        (0, _products_actions.saveCategory2Products)(products, category2Id, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.state = {
	      sortColumn: null,
	      sortDirection: null,
	      filters: {},
	      rows: [],
	      selectedRows: [],
	      editedRows: [],
	
	      suggestValue: '',
	      productSearchType: 'ProductNum',
	      selectedProduct: null,
	
	      isLoadingSave: false
	    };
	    return _this;
	  }
	
	  _createClass(Category2Detail, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.category2Products && nextProps.category2Products !== this.props.category2Products) {
	        this.setState({ rows: nextProps.category2Products });
	      }
	    }
	  }, {
	    key: 'renderAutoSuggest',
	    value: function renderAutoSuggest() {
	      var _this2 = this;
	
	      return _react2.default.createElement(_GenericProductSuggest2.default, {
	        value: this.state.suggestValue,
	        onChange: function onChange(e, _ref) {
	          var newValue = _ref.newValue;
	          _this2.setState({ suggestValue: newValue });
	        },
	        SearchType: this.state.productSearchType,
	        fetchOrdersByProduct: this.onSuggestionSelected
	      });
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this3 = this;
	
	      var that = this;
	      if (this.props.category2ProductsIsLoading) {
	        return _react2.default.createElement(_spinner2.default, null);
	      }
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this3.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this3.setState(state);
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this3.state.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var state = _extends({}, _this3.state, { filters: newFilters });
	        _this3.setState(state);
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        var state = _extends({}, _this3.state, { filters: {} });
	        _this3.setState(state);
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        // merge updated row with current row and rerender by setting state
	        _this3.setState({ sortColumn: null, sortDirection: null });
	        var rows = getRows();
	        var editedRows = _this3.state.editedRows.slice(0);
	        Object.assign(rows[e.rowIdx], e.updated);
	        // if the element is already edited, remove the old one.
	        editedRows.forEach(function (element, index) {
	          if (element.Idx === rows[e.rowIdx].Idx) {
	            editedRows.splice(index, 1);
	          }
	        }, _this3);
	        // push the row into the editedRows array
	        editedRows.push(rows[e.rowIdx]);
	        _this3.setState({ rows: rows, editedRows: editedRows });
	      };
	
	      var isDraggedRowSelected = function isDraggedRowSelected(selectedRows, rowDragSource) {
	        if (selectedRows && selectedRows.length > 0) {
	          var key = _this3.props.rowKey;
	          return selectedRows.filter(function (r) {
	            return r[key] === rowDragSource.data[key];
	          }).length > 0;
	        }
	        return false;
	      };
	
	      var reorderRows = function reorderRows(e) {
	        var selectedRows = Selectors.getSelectedRowsByKey({ rowKey: _this3.props.rowKey, selectedKeys: [], rows: _this3.state.rows });
	        var draggedRows = isDraggedRowSelected(selectedRows, e.rowSource) ? selectedRows : [e.rowSource.data];
	        var undraggedRows = _this3.state.rows.filter(function (r) {
	          return draggedRows.indexOf(r) === -1;
	        });
	        var args = [e.rowTarget.idx, 0].concat(draggedRows);
	        Array.prototype.splice.apply(undraggedRows, args);
	        undraggedRows.map(function (row, index) {
	          row.Index = index;
	        });
	        _this3.setState({ rows: undraggedRows });
	      };
	
	      var IsVariableFormatter = _react2.default.createClass({
	        displayName: 'IsVariableFormatter',
	        render: function render() {
	          var _this4 = this;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                className: 'textAlignStyle',
	                style: { height: '23px', width: '39px', padding: '0px' },
	                onClick: function onClick() {
	                  var ProductNum = _this4.props.dependentValues.ProductNum;
	
	                  that.removeRow(ProductNum);
	                }
	              },
	              'X'
	            )
	          );
	        }
	      });
	
	      var columns = [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 120
	      }].concat(_toConsumableArray(isAFM ? [{
	        key: 'Brand',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'brand' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 150
	      }] : []), [{
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: 'in_stock',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	        resizable: true,
	        sortable: false,
	        filterable: true,
	        width: 250
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: false,
	        filterable: true,
	        width: 250
	      }]);
	
	      // if (this.state.rows && this.state.rows.length > 0) {
	      //   this.state.rows.map((r) => {
	      //     r.RefNum = Number(r.RefNum);
	      //   });
	      // }
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '99%' }, id: 'Category2Detail-dataGrid1' },
	            _react2.default.createElement(
	              DraggableContainer,
	              null,
	              _react2.default.createElement(_reactDataGrid2.default, {
	                onGridSort: handleGridSort,
	                columns: columns,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                onAddFilter: handleFilterChange,
	                onClearFilters: onClearFilters,
	                minHeight: 570,
	                rowHeight: 25,
	                enableRowSelect: 'single',
	                rowActionsCell: RowActionsCell,
	                rowRenderer: _react2.default.createElement(RowRenderer, { onRowDrop: reorderRows }),
	                onRowUpdated: handleRowUpdated
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactBootstrap.Panel,
	        { id: 'category2-detail' },
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category_2_product_list' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            { id: 'search-panel' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12, className: 'search-panel-left text-nowrap' },
	              _react2.default.createElement(
	                'div',
	                { id: 'autosuggest-div' },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { style: { height: '30px' } },
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    _react2.default.createElement(_TypeRadios2.default, {
	                      value: this.state.productSearchType,
	                      handleOptionChange: this.handleOptionChange
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    this.renderAutoSuggest()
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            { style: { position: 'absolute', zIndex: 3 } },
	            _react2.default.createElement(_SpinnerButton2.default, {
	              bsStyle: 'success',
	              onClick: this.handleCategory2ProductsSave,
	              disabled: this.state.isLoadingSave,
	              loading: this.state.isLoadingSave,
	              icon: 'fa-save',
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	            })
	          ),
	          this.renderTable()
	        )
	      );
	    }
	  }]);
	
	  return Category2Detail;
	}(_react.Component);
	
	Category2Detail.propTypes = propTypes;
	Category2Detail.defaultProps = defaultProps;
	
	var _default = Category2Detail;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/Category2Detail.jsx');
	
	  __REACT_HOT_LOADER__.register(isAFM, 'isAFM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/Category2Detail.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/Category2Detail.jsx');
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/Category2Detail.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/Category2Detail.jsx');
	
	  __REACT_HOT_LOADER__.register(Category2Detail, 'Category2Detail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/Category2Detail.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/Category2Detail.jsx');
	}();

	;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  dependentValues: _propTypes2.default.shape({
	    IsListView: _propTypes2.default.bool,
	    IsButton: _propTypes2.default.bool,
	    ListViewType: _propTypes2.default.string
	  }),
	  handleCheckBoxClick: _propTypes2.default.func,
	  handleViewTypeSelect: _propTypes2.default.func
	};
	
	var defaultProps = {
	  dependentValues: {},
	  handleCheckBoxClick: function handleCheckBoxClick() {},
	  handleViewTypeSelect: function handleViewTypeSelect() {}
	};
	
	var Category2DisplayOptionsFormatter = _react2.default.createClass({
	  displayName: 'Category2DisplayOptionsFormatter',
	  getInitialState: function getInitialState() {
	    return {
	      isListView: true,
	      isButton: false,
	      listViewType: ''
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    var _props$dependentValue = this.props.dependentValues,
	        IsListView = _props$dependentValue.IsListView,
	        IsButton = _props$dependentValue.IsButton,
	        ListViewType = _props$dependentValue.ListViewType;
	
	    var isListView = typeof IsListView === 'boolean' ? IsListView : true;
	    var isButton = typeof IsButton === 'boolean' ? IsButton : false;
	    var listViewType = ListViewType || 'horizontal-1';
	    this.setState({ isListView: isListView, isButton: isButton, listViewType: listViewType });
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.dependentValues && nextProps.dependentValues !== this.props.dependentValues) {
	      var _nextProps$dependentV = nextProps.dependentValues,
	          IsListView = _nextProps$dependentV.IsListView,
	          IsButton = _nextProps$dependentV.IsButton,
	          ListViewType = _nextProps$dependentV.ListViewType;
	
	      var isListView = typeof IsListView === 'boolean' ? IsListView : true;
	      var isButton = typeof IsButton === 'boolean' ? IsButton : false;
	      var listViewType = ListViewType || 'horizontal-1';
	      this.setState({ isListView: isListView, isButton: isButton, listViewType: listViewType });
	    }
	  },
	  render: function render() {
	    var _this = this;
	
	    var viewOptions = [{ value: 'horizontal-1', label: 'Horizontal (1 Row)' }, { value: 'horizontal-2', label: 'Horizontal (2 Rows)' }, { value: 'vertical', label: 'Vertical' }, { value: 'middle-image', label: 'Middle Image' }];
	    var _state = this.state,
	        isListView = _state.isListView,
	        isButton = _state.isButton,
	        listViewType = _state.listViewType;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'category2-display-options' },
	      _react2.default.createElement(
	        'div',
	        { className: 'category2-view-type-b2c' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'sectioned-list-option' },
	          _react2.default.createElement('input', {
	            type: 'checkbox',
	            name: 'sectioned-list-option',
	            checked: isListView,
	            onClick: function onClick() {
	              _this.props.handleCheckBoxClick(_this.props, 'IsListView');
	              _this.setState({ isListView: !isListView });
	            }
	          }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sectioned_list' })
	        ),
	        _react2.default.createElement(_GenericSelection2.default, {
	          options: viewOptions,
	          value: listViewType,
	          setSelected: function setSelected(e) {
	            _this.props.handleViewTypeSelect(e, _this.props.dependentValues);
	            _this.setState({ listViewType: e.value });
	          },
	          disabled: !isListView
	        })
	      ),
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'button-option' },
	        _react2.default.createElement('input', {
	          type: 'checkbox',
	          name: 'button-option',
	          checked: isButton,
	          onClick: function onClick() {
	            _this.props.handleCheckBoxClick(_this.props, 'IsButton');
	            _this.setState({ isButton: !isButton });
	          }
	        }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'button' })
	      )
	    );
	  }
	});
	
	Category2DisplayOptionsFormatter.propTypes = propTypes;
	Category2DisplayOptionsFormatter.defaultProps = defaultProps;
	
	var _default = Category2DisplayOptionsFormatter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/Category2DisplayOptionsFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/Category2DisplayOptionsFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(Category2DisplayOptionsFormatter, 'Category2DisplayOptionsFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/Category2DisplayOptionsFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/Category2DisplayOptionsFormatter.jsx');
	}();

	;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  dependentValues: _propTypes2.default.shape({
	    IsListView: _propTypes2.default.bool,
	    IsButton: _propTypes2.default.bool,
	    IsAFGChoice: _propTypes2.default.bool,
	    ListViewType: _propTypes2.default.string
	  }),
	  handleCheckBoxClick: _propTypes2.default.func,
	  handleViewTypeSelect: _propTypes2.default.func
	};
	
	var defaultProps = {
	  dependentValues: {},
	  handleCheckBoxClick: function handleCheckBoxClick() {},
	  handleViewTypeSelect: function handleViewTypeSelect() {}
	};
	
	var Category2DisplayOptionsFormatterB2B = _react2.default.createClass({
	  displayName: 'Category2DisplayOptionsFormatterB2B',
	  getInitialState: function getInitialState() {
	    return {
	      isListView: true,
	      isButton: false,
	      isAFGChoice: false,
	      listViewType: ''
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    var _props$dependentValue = this.props.dependentValues,
	        IsListView = _props$dependentValue.IsListView,
	        IsButton = _props$dependentValue.IsButton,
	        ListViewType = _props$dependentValue.ListViewType,
	        IsAFGChoice = _props$dependentValue.IsAFGChoice;
	
	    var isListView = typeof IsListView === 'boolean' ? IsListView : true;
	    var isButton = typeof IsButton === 'boolean' ? IsButton : false;
	    var isAFGChoice = typeof IsAFGChoice === 'boolean' ? IsAFGChoice : false;
	    var listViewType = ListViewType || 'horizontal-1';
	    this.setState({ isListView: isListView, isButton: isButton, listViewType: listViewType, isAFGChoice: isAFGChoice });
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.dependentValues && nextProps.dependentValues !== this.props.dependentValues) {
	      var _nextProps$dependentV = nextProps.dependentValues,
	          IsListView = _nextProps$dependentV.IsListView,
	          IsButton = _nextProps$dependentV.IsButton,
	          ListViewType = _nextProps$dependentV.ListViewType,
	          IsAFGChoice = _nextProps$dependentV.IsAFGChoice;
	
	      var isListView = typeof IsListView === 'boolean' ? IsListView : true;
	      var isButton = typeof IsButton === 'boolean' ? IsButton : false;
	      var isAFGChoice = typeof IsAFGChoice === 'boolean' ? IsAFGChoice : false;
	      var listViewType = ListViewType || 'horizontal-1';
	      this.setState({ isListView: isListView, isButton: isButton, listViewType: listViewType, isAFGChoice: isAFGChoice });
	    }
	  },
	  render: function render() {
	    var _this = this;
	
	    var viewOptions = [{ value: 'horizontal-1', label: 'Horizontal (1 Row)' }, { value: 'horizontal-2', label: 'Horizontal (2 Rows)' }, { value: 'vertical', label: 'Vertical' }, { value: 'middle-image', label: 'Middle Image' }];
	    var _state = this.state,
	        isListView = _state.isListView,
	        isButton = _state.isButton,
	        listViewType = _state.listViewType,
	        isAFGChoice = _state.isAFGChoice;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'category2-display-options' },
	      _react2.default.createElement(
	        'div',
	        { className: 'category2-view-type' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'sectioned-list-option' },
	          _react2.default.createElement('input', {
	            type: 'checkbox',
	            name: 'sectioned-list-option',
	            checked: isListView,
	            onClick: function onClick() {
	              _this.props.handleCheckBoxClick(_this.props, 'IsListView');
	              _this.setState({ isListView: !isListView });
	            }
	          }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sectioned_list' })
	        ),
	        _react2.default.createElement(_GenericSelection2.default, {
	          options: viewOptions,
	          value: listViewType,
	          setSelected: function setSelected(e) {
	            _this.props.handleViewTypeSelect(e, _this.props.dependentValues);
	            _this.setState({ listViewType: e.value });
	          },
	          disabled: !isListView
	        })
	      ),
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'button-option' },
	        _react2.default.createElement('input', {
	          type: 'checkbox',
	          name: 'button-option',
	          checked: isButton,
	          onClick: function onClick() {
	            _this.props.handleCheckBoxClick(_this.props, 'IsButton');
	            _this.setState({ isButton: !isButton });
	          }
	        }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'button' })
	      ),
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'button-option' },
	        _react2.default.createElement('input', {
	          type: 'checkbox',
	          name: 'button-option',
	          checked: isAFGChoice,
	          onClick: function onClick() {
	            _this.props.handleCheckBoxClick(_this.props, 'IsAFGChoice');
	            _this.setState({ isAFGChoice: !isAFGChoice });
	          }
	        }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'afg_choice' })
	      )
	    );
	  }
	});
	
	Category2DisplayOptionsFormatterB2B.propTypes = propTypes;
	Category2DisplayOptionsFormatterB2B.defaultProps = defaultProps;
	
	var _default = Category2DisplayOptionsFormatterB2B;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/Category2DisplayOptionsFormatterB2B.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/Category2DisplayOptionsFormatterB2B.jsx');
	
	  __REACT_HOT_LOADER__.register(Category2DisplayOptionsFormatterB2B, 'Category2DisplayOptionsFormatterB2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/Category2DisplayOptionsFormatterB2B.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/Category2DisplayOptionsFormatterB2B.jsx');
	}();

	;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _categoryForm = __webpack_require__(179);
	
	var _categoryForm2 = _interopRequireDefault(_categoryForm);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _categoryInfoModal = __webpack_require__(410);
	
	var _categoryInfoModal2 = _interopRequireDefault(_categoryInfoModal);
	
	var _ImageFormatter = __webpack_require__(73);
	
	var _ImageFormatter2 = _interopRequireDefault(_ImageFormatter);
	
	var _root_url = __webpack_require__(9);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import {buttonStyle} from '../Common/style'
	
	
	var isEcity = _root_url.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://ctstage-scm.truckxi.com/api/';
	
	var DraggableContainer = _reactDataGridAddons.Draggable.Container,
	    RowActionsCell = _reactDataGridAddons.Draggable.RowActionsCell,
	    DropTargetRowContainer = _reactDataGridAddons.Draggable.DropTargetRowContainer;
	var Selectors = _reactDataGridAddons.Data.Selectors;
	
	var RowRenderer = DropTargetRowContainer(_reactDataGrid2.default.Row);
	var styles = {
	  modal: {
	    height: '250px'
	  }
	};
	
	var Categories = function (_Component) {
	  _inherits(Categories, _Component);
	
	  function Categories() {
	    _classCallCheck(this, Categories);
	
	    var _this = _possibleConstructorReturn(this, (Categories.__proto__ || Object.getPrototypeOf(Categories)).call(this));
	
	    _this.handleEditButtonClick = function (event) {
	      event.preventDefault();
	      _this.setCategorieInfoModalVisibility(true);
	    };
	
	    _this.setCategorieInfoModalVisibility = function (isVisible) {
	      _this.setState({
	        categorieInfoModalVisibility: isVisible
	      });
	    };
	
	    _this.handleCategoryInfoEditConfirm = function (category) {
	      var newCategories = [].concat(_toConsumableArray(_this.state.rows));
	      newCategories[category.Idx] = category;
	      _this.setState({
	        rows: newCategories
	      }, function () {
	        _this.setCategorieInfoModalVisibility(false);
	      });
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton,
	
	      rows: [],
	      selectedRows: null,
	      editedRows: [],
	      filters: {},
	      sortColumn: null,
	      sortDirection: null,
	      gourpOpen: false,
	      categorieInfoModalVisibility: false
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.openCategory = _this.openCategory.bind(_this);
	    _this.closeCategory = _this.closeCategory.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.renderImage = _this.renderImage.bind(_this);
	    return _this;
	  }
	
	  _createClass(Categories, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.handleResize);
	      // this.props.fetchCategories();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	      this.props.clearDeleteCategoryStatus();
	    }
	
	    // Once categories is ready, reset state.
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var PT = nextProps.categories;
	      if (nextProps.categories && nextProps.categories != this.props.categories) {
	        var categories = nextProps.categories;
	        var index = 0;
	        categories.map(function (category) {
	          category.Idx = index++;
	          category.Index = category.Idx;
	        });
	        this.setState({
	          rows: categories,
	          selectedRows: null,
	          editedRows: []
	        });
	      }
	      if (nextProps.multiEdited && nextProps.multiEdited != this.props.multiEdited) {
	        this.props.fetchGroupCategories(this.props.currentGroup);
	        this.setState({ selectedRows: null, editedRows: [] });
	      }
	      if (nextProps.deleteCategorySuccess && nextProps.deleteCategorySuccess != this.props.deleteCategorySuccess) {
	        this.props.fetchGroupCategories(this.props.currentGroup);
	        this.setState({ selectedRows: null, editedRows: [] });
	      }
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton });
	    }
	  }, {
	    key: 'updateRows',
	    value: function updateRows(e) {
	      var _this2 = this;
	
	      var computedRows = this.state.rows.map(function (row) {
	        var editedRow = _this2.state.editedRows.find(function (_ref) {
	          var ProductCategory_id = _ref.ProductCategory_id;
	          return ProductCategory_id === row.ProductCategory_id;
	        });
	        if (editedRow !== undefined) {
	          return editedRow;
	        }
	        return row;
	      });
	      e.preventDefault();
	      this.props.editMultiCategories(computedRows);
	    }
	  }, {
	    key: 'deleteCategory',
	    value: function deleteCategory(e) {
	      e.preventDefault();
	      var productCategory_id = this.state.selectedRows[0].ProductCategory_id;
	      if (productCategory_id) {
	        this.props.deleteCategory(productCategory_id);
	      } else {
	        var rows = [].concat(_toConsumableArray(this.state.rows));
	        var editedRows = [].concat(_toConsumableArray(this.state.editedRows));
	        var index = _.findIndex(rows, { Idx: this.state.selectedRows[0].Idx });
	        rows.splice(index, 1);
	        index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx });
	        editedRows.splice(index, 1);
	        this.setState({ rows: rows, editedRows: editedRows, selectedRows: [] });
	      }
	    }
	  }, {
	    key: 'openCategory',
	    value: function openCategory() {
	      this.setState({ gourpOpen: true });
	    }
	  }, {
	    key: 'closeCategory',
	    value: function closeCategory() {
	      this.props.fetchCategories();
	      this.setState({ gourpOpen: false });
	    }
	
	    // Helper function to render an icon for the stock statues of product.
	
	
	  }, {
	    key: 'renderIsEnabled',
	    value: function renderIsEnabled(IsEnabled) {
	      if (IsEnabled) return _react2.default.createElement(
	        'span',
	        { className: 'label label-success' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	      );else return _react2.default.createElement(
	        'span',
	        { className: 'label label-danger' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disabled' })
	      );
	    }
	
	    // Set categories being selected to be currentCategory and navigate user to the edit page
	
	  }, {
	    key: 'setCurrentCategory',
	    value: function setCurrentCategory(e) {
	      e.preventDefault();
	      var currentCategory = this.state.selectedRows[0];
	      this.props.selectCategory(currentCategory);
	      this.openCategory();
	    }
	  }, {
	    key: 'clickNew',
	    value: function clickNew(e) {
	      e.preventDefault();
	      // this.props.resetCurrentCategory();
	      // this.openCategory();
	      var rows = Selectors.getRows(this.state);
	      var index = rows.length;
	      var newRow = { Name: null, Description: null, IsEnabled: false, Idx: index, ProductGroup_id: this.props.currentGroup };
	      rows.push(newRow);
	      var editedRows = [].concat(_toConsumableArray(this.state.editedRows));
	      editedRows.push(newRow);
	      this.setState({ rows: rows, editedRows: editedRows });
	    }
	  }, {
	    key: 'renderImage',
	    value: function renderImage(index) {
	      var imageFile = '/img/dummy.png';
	      if (index || index === 0) {
	        imageFile = this.state.rows[index].Image_Category || '/img/dummy.png';
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'group-img-view' },
	        _react2.default.createElement('img', {
	          src: imageFile,
	          alt: 'Upload'
	        })
	      );
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(row, files) {
	      var _this3 = this;
	
	      if (!files) {
	        return;
	      }
	      var reader = new FileReader();
	      reader.onload = function () {
	        var index = row.props.rowIdx;
	        var newRows = [].concat(_toConsumableArray(_this3.state.rows));
	        var editedRows = [].concat(_toConsumableArray(_this3.state.editedRows));
	        newRows[index].Image = reader.result;
	        var editedRowIndex = _.findIndex(editedRows, function (r) {
	          return r.Index === row.props.dependentValues.Index;
	        });
	        if (editedRowIndex === -1) {
	          editedRows.push(newRows[index]);
	        } else {
	          editedRows.splice(editedRowIndex, 1);
	          editedRows.push(newRows[index]);
	        }
	        _this3.setState({ rows: newRows, editedRows: editedRows });
	      };
	      // get the first file and convert to blob object (Blob.slice([start [, end [, contentType]]))
	      var blob = files[0].slice(0, files[0].size, files[0].type);
	      reader.readAsDataURL(blob);
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(row, files) {
	      var _this4 = this;
	
	      if (!files) {
	        return;
	      }
	      var reader = new FileReader();
	      reader.onload = function () {
	        var index = row.props.rowIdx;
	        var newRows = [].concat(_toConsumableArray(_this4.state.rows));
	        var editedRows = [].concat(_toConsumableArray(_this4.state.editedRows));
	        newRows[index].Image_Category = reader.result;
	        var editedRowIndex = _.findIndex(editedRows, function (r) {
	          return r.Index === row.props.dependentValues.Index;
	        });
	        if (editedRowIndex === -1) {
	          editedRows.push(newRows[index]);
	        } else {
	          editedRows.splice(editedRowIndex, 1);
	          editedRows.push(newRows[index]);
	        }
	        _this4.setState({ rows: newRows, editedRows: editedRows });
	      };
	      // get the first file and convert to blob object (Blob.slice([start [, end [, contentType]]))
	      var blob = files[0].slice(0, files[0].size, files[0].type);
	      reader.readAsDataURL(blob);
	    }
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this5 = this;
	
	      if (this.props.categoryIsLoading && !this.props.categoryError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.categoryError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          this.props.categoryError.message
	        )
	      );else {
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return Selectors.getRows(_this5.state);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var isDraggedRowSelected = function isDraggedRowSelected(selectedRows, rowDragSource) {
	          if (selectedRows && selectedRows.length > 0) {
	            var key = _this5.props.rowKey;
	            return selectedRows.filter(function (r) {
	              return r[key] === rowDragSource.data[key];
	            }).length > 0;
	          }
	          return false;
	        };
	
	        var reorderRows = function reorderRows(e) {
	          var selectedRows = Selectors.getSelectedRowsByKey({ rowKey: _this5.props.rowKey, selectedKeys: [], rows: _this5.state.rows });
	          var draggedRows = isDraggedRowSelected(selectedRows, e.rowSource) ? selectedRows : [e.rowSource.data];
	          var undraggedRows = _this5.state.rows.filter(function (r) {
	            return draggedRows.indexOf(r) === -1;
	          });
	          var args = [e.rowTarget.idx, 0].concat(draggedRows);
	          Array.prototype.splice.apply(undraggedRows, args);
	          undraggedRows.map(function (row, index) {
	            row.Index = index;
	          });
	          console.log(undraggedRows);
	          _this5.setState({ rows: undraggedRows });
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var state = Object.assign({}, _this5.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this5.setState(state);
	        };
	
	        var handleFilterChange = function handleFilterChange(filter) {
	          var newFilters = Object.assign({}, _this5.state.filters);
	          if (filter.filterTerm) {
	            newFilters[filter.column.key] = filter;
	          } else {
	            delete newFilters[filter.column.key];
	          }
	          _this5.setState({ filters: newFilters });
	        };
	
	        // Handle the editable function
	
	        var handleRowUpdated = function handleRowUpdated(e) {
	          // merge updated row with current row and rerender by setting state
	          _this5.setState({ sortColumn: null, sortDirection: null });
	          var rows = getRows();
	          var editedRows = _this5.state.editedRows.slice(0);
	          Object.assign(rows[e.rowIdx], e.updated);
	          // if the element is already edited, remove the old one.
	          editedRows.forEach(function (element, index) {
	            if (element.Idx === rows[e.rowIdx].Idx) editedRows.splice(index, 1);
	          }, _this5);
	          // push the row into the editedRows array
	          editedRows.push(rows[e.rowIdx]);
	          _this5.setState({
	            rows: rows,
	            editedRows: editedRows
	          });
	        };
	
	        // Handle the Dragable cell function
	
	        var handleCellDrag = function handleCellDrag(e) {
	          var rows = _this5.state.rows.slice(0);
	          var editedRows = _this5.state.editedRows.slice(0);
	
	          var _loop = function _loop(i) {
	            var rowToUpdate = rows[i];
	            rowToUpdate[e.cellKey] = e.value;
	            // if the element is already edited, remove the old one.
	            editedRows.forEach(function (element, index) {
	              if (element.ProductCategory_id === rowToUpdate.ProductCategory_id) editedRows.splice(index, 1);
	            }, _this5);
	            // push the row into the editedRows array
	            editedRows.push(rowToUpdate);
	          };
	
	          for (var i = e.fromRow; i <= e.toRow; i++) {
	            _loop(i);
	          }
	          _this5.setState({
	            rows: rows,
	            editedRows: editedRows
	          });
	        };
	
	        var handleDragHandleDoubleClick = function handleDragHandleDoubleClick(e) {
	          var rows = _this5.state.rows.map(function (r) {
	            return Object.assign({}, r);
	          });
	          var editedRows = _this5.state.editedRows.slice(0);
	          var column = _columns[e.idx - 1];
	          for (var i = e.rowIdx; i <= rows.length - 1; i++) {
	            var rowToUpdate = rows[i];
	            rowToUpdate[column.key] = e.rowData[column.key];
	            // if the element is already edited, remove the old one.
	            editedRows.forEach(function (element, index) {
	              if (element.ProductCategory_id === rowToUpdate.ProductCategory_id) editedRows.splice(index, 1);
	            }, _this5);
	            // push the row into the editedRows array
	            editedRows.push(rowToUpdate);
	          }
	          _this5.setState({ rows: rows });
	        };
	
	        //Custom Formatter component
	        var IsEnabledFormatter = _react2.default.createClass({
	          displayName: 'IsEnabledFormatter',
	          render: function render() {
	            var _this6 = this;
	
	            return _react2.default.createElement('input', { type: 'checkbox', value: 'true', checked: this.props.value == true || this.props.value == "true", onClick: function onClick() {
	                _handleIsEnabledClick(_this6.props);
	              } });
	          }
	        });
	
	        var _handleIsEnabledClick = function _handleIsEnabledClick(isEnabled) {
	          var rows = getRows();
	          var index = _.findIndex(rows, { Idx: isEnabled.dependentValues.Idx });
	          rows[index].IsEnabled = !rows[index].IsEnabled;
	          var editedRows = [].concat(_toConsumableArray(_this5.state.editedRows));
	          editedRows.map(function (row, idx) {
	            if (row.Idx === rows[index].Idx) editedRows.splice(idx, 1);
	          });
	          editedRows.push(rows[index]);
	          _this5.setState({ rows: rows, editedRows: editedRows });
	        };
	
	        var handlePackShowParentColClick = function handlePackShowParentColClick(props) {
	          var rows = getRows();
	          var key = props.column.key;
	
	          rows[props.rowIdx][key] = !rows[props.rowIdx][key];
	          var editedRows = [].concat(_toConsumableArray(_this5.state.editedRows));
	          editedRows.map(function (row, idx) {
	            if (row.Index === rows[props.rowIdx].Index) editedRows.splice(idx, 1);
	          });
	          editedRows.push(rows[props.rowIdx]);
	          _this5.setState({ rows: rows, editedRows: editedRows });
	        };
	
	        var PackShowParentFormatter = _react2.default.createClass({
	          displayName: 'PackShowParentFormatter',
	          render: function render() {
	            var _this7 = this;
	
	            return _react2.default.createElement('input', {
	              id: 'product-group-cate-enable-pack-show-parent-a-gg-lol',
	              type: 'checkbox',
	              value: 'true',
	              checked: this.props.value == true || this.props.value == "true",
	              onClick: function onClick() {
	                handlePackShowParentColClick(_this7.props);
	              },
	              style: { marginLeft: '25px' }
	            });
	          }
	        });
	
	        // Handle the row select function
	
	        // const onRowSelect = rows => {
	        //     this.setState({ selectedRows: rows });
	        // }
	
	        var onRowsSelected = function onRowsSelected(rows) {
	          var newRows = getRows();
	          newRows.map(function (r) {
	            r.isSelected = false;
	          });
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = true;
	          });
	          _this5.setState({ rows: newRows, selectedRows: [rows[0].row] });
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          var newRows = getRows();
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = false;
	          });
	          _this5.setState({ rows: newRows, selectedRows: [] });
	        };
	
	        // Column difinition
	
	        var _columns = [{
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	          resizable: true,
	          sortable: true,
	          editable: true,
	          filterable: true,
	          width: 250
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true,
	          editable: true,
	          filterable: true,
	          width: 200
	        }, {
	          key: 'IsEnabled',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          formatter: IsEnabledFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          },
	          width: 80
	        }];
	
	        if (isEcity) {
	          var imageColumn = {
	            key: 'Image_Category',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'image' }),
	            resizable: true,
	            sortable: false,
	            editable: false,
	            filterable: false,
	            width: 220,
	            formatter: _react2.default.createElement(_ImageFormatter2.default, {
	              renderImage: this.renderImage,
	              onDrop: this.onDrop,
	              showImageOnly: true
	            }),
	            getRowMetaData: function getRowMetaData(row) {
	              return row;
	            }
	          };
	          _columns.splice(0, 0, imageColumn);
	        }
	
	        if (_root_url.isUSPride) {
	          var PackShowParentCol = {
	            key: 'PackShowParent',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pack_show_parent' }),
	            resizable: true,
	            // sortable: true,
	            // filterable: true,
	            formatter: _react2.default.createElement(PackShowParentFormatter, null),
	            getRowMetaData: function getRowMetaData(row) {
	              return row;
	            },
	            width: 80
	          };
	          var enableIdx = _.findIndex(_columns, { key: "IsEnabled" });
	          _columns.splice(enableIdx, 0, PackShowParentCol);
	        }
	
	        var rowHeight = isEcity ? 120 : 25;
	
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { style: { maxWidth: '99%' }, id: 'Categories-dataGrid1' },
	              _react2.default.createElement(
	                DraggableContainer,
	                null,
	                _react2.default.createElement(_reactDataGrid2.default, {
	                  enableCellSelect: true,
	                  onGridSort: handleGridSort,
	                  onAddFilter: handleFilterChange,
	                  columns: _columns,
	                  rowGetter: rowGetter,
	                  rowsCount: getSize(),
	                  minHeight: 620,
	                  rowHeight: rowHeight,
	                  headerRowHeight: 25,
	                  enableRowSelect: 'single',
	                  onDragHandleDoubleClick: handleDragHandleDoubleClick,
	                  onCellsDragged: handleCellDrag,
	                  onRowUpdated: handleRowUpdated
	                  // onRowSelect={onRowSelect}
	                  , rowSelection: {
	                    showCheckbox: true,
	                    onRowsSelected: onRowsSelected,
	                    onRowsDeselected: onRowsDeselected,
	                    selectBy: {
	                      isSelectedKey: 'isSelected'
	                    }
	                  },
	                  rowRenderer: _react2.default.createElement(RowRenderer, { onRowDrop: reorderRows }),
	                  rowActionsCell: RowActionsCell
	                })
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'formTitle',
	    value: function formTitle() {
	      if (this.props.currentCategory) return "Edit Category";else return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_a_new_category' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var createDialogStyle = {
	        width: '950px',
	        height: '500px',
	        marginLeft: '-15%'
	      };
	      var categoryInfoTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category_info_edit' });
	      return (
	        //---------------
	        // Begin HTML: Create New/Edit product_categories
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            { className: 'group-management-table-buttons' },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                className: 'marginLeftStyle',
	                onClick: function onClick(event) {
	                  _this8.clickNew(event);
	                },
	                disabled: !(0, _permissions2.default)("add_product_category")
	              },
	              _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'success',
	                className: 'buttonStyle',
	                onClick: function onClick(event) {
	                  _this8.updateRows(event);
	                },
	                disabled: !this.state.editedRows || !(0, _permissions2.default)("change_product_category") },
	              _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'success',
	                className: 'buttonStyle',
	                onClick: function onClick(event) {
	                  _this8.handleEditButtonClick(event);
	                },
	                disabled: !this.state.selectedRows || this.state.selectedRows.length != 1 || !(0, _permissions2.default)("delete_product_category")
	              },
	              _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                className: 'buttonStyle',
	                onClick: function onClick(event) {
	                  _this8.deleteCategory(event);
	                },
	                disabled: !this.state.selectedRows || this.state.selectedRows.length != 1 || !(0, _permissions2.default)("delete_product_category")
	              },
	              _react2.default.createElement('em', { className: 'fa fa-trash marginRightStyle' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	            )
	          ),
	          this.renderTable(),
	          _react2.default.createElement('br', null),
	          this.props.multiIsEditing && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-info categories-saving-info' },
	            _react2.default.createElement(
	              'span',
	              { className: '' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saving' })
	            )
	          ),
	          this.props.multiEdited && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-success categories-saving-info' },
	            _react2.default.createElement(
	              'span',
	              { className: '' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saved' })
	            )
	          ),
	          this.props.deletingCategory && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-info categories-saving-info' },
	            _react2.default.createElement(
	              'span',
	              { className: '' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deleting' })
	            )
	          ),
	          this.props.deleteCategorySuccess && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-success categories-saving-info' },
	            _react2.default.createElement(
	              'span',
	              { className: '' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deleted' })
	            )
	          ),
	          this.props.deleteCategoryError && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger categories-saving-info' },
	            _react2.default.createElement(
	              'span',
	              { className: '' },
	              this.props.deleteCategoryError
	            )
	          ),
	          this.props.multiError && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger categories-saving-info' },
	            _react2.default.createElement(
	              'span',
	              { className: '' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Name_and_Description_fields_are_required' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            { title: categoryInfoTitle, dialogStyles: createDialogStyle, isVisible: this.state.categorieInfoModalVisibility, onCloseClicked: function onCloseClicked() {
	                _this8.setCategorieInfoModalVisibility(false);
	              } },
	            _react2.default.createElement(_categoryInfoModal2.default, { selectedRows: this.state.selectedRows, handleConfirmClick: this.handleCategoryInfoEditConfirm })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Categories;
	}(_react.Component);
	
	Categories.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = Categories;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/categories.jsx');
	
	  __REACT_HOT_LOADER__.register(DraggableContainer, 'DraggableContainer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/categories.jsx');
	
	  __REACT_HOT_LOADER__.register(RowActionsCell, 'RowActionsCell', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/categories.jsx');
	
	  __REACT_HOT_LOADER__.register(DropTargetRowContainer, 'DropTargetRowContainer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/categories.jsx');
	
	  __REACT_HOT_LOADER__.register(Selectors, 'Selectors', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/categories.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/categories.jsx');
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/categories.jsx');
	
	  __REACT_HOT_LOADER__.register(Categories, 'Categories', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/categories.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/categories.jsx');
	}();

	;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _selection = __webpack_require__(21);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _isEnabled = __webpack_require__(157);
	
	var _isEnabled2 = _interopRequireDefault(_isEnabled);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CategoryForm = function (_Component) {
	  _inherits(CategoryForm, _Component);
	
	  function CategoryForm() {
	    _classCallCheck(this, CategoryForm);
	
	    return _possibleConstructorReturn(this, (CategoryForm.__proto__ || Object.getPrototypeOf(CategoryForm)).apply(this, arguments));
	  }
	
	  _createClass(CategoryForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.fetchGroups();
	      this.props.resetCategory();
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      if (this.props.currentCategory) {
	        if (!this.checkPermission("change_product_category")) this.props.editCategory(formProps);else alert("You have no permission!");
	      } else this.props.createCategory(formProps, this.props.type);
	    }
	  }, {
	    key: 'checkPermission',
	    value: function checkPermission(permission) {
	      return false;
	    }
	  }, {
	    key: 'getGroupOptions',
	    value: function getGroupOptions() {
	      var groupOptions = [];
	      if (this.props.groups) {
	        this.props.groups.map(function (group) {
	          groupOptions.push({ value: group.ProductGroup_id, label: group.Name });
	        });
	      }
	      return groupOptions;
	    }
	  }, {
	    key: 'renderGroups',
	    value: function renderGroups() {
	      var _props = this.props,
	          groups = _props.groups,
	          groupIsLoading = _props.groupIsLoading,
	          groupError = _props.groupError;
	
	      var groupOptions = this.getGroupOptions();
	      if (groupIsLoading && !groupError) return _react2.default.createElement(_spinner2.default, null);
	      if (groupError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(groupError)
	        )
	      );
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'group' })
	            ),
	            _react2.default.createElement(_reduxForm.Field, { name: 'ProductGroup_id', component: _selection.Selection, options: groupOptions })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          handleSubmit = _props2.handleSubmit,
	          closeC = _props2.closeC,
	          submitting = _props2.submitting,
	          pristine = _props2.pristine,
	          valid = _props2.valid;
	
	      return _react2.default.createElement(
	        'form',
	        { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category_name' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: 'Name', component: _inputField2.default })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: 'Description', component: _inputField2.default })
	            )
	          )
	        ),
	        this.renderGroups(),
	        _react2.default.createElement(_reduxForm.Field, { name: 'IsEnabled', component: _isEnabled2.default }),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'button',
	          { action: 'submit', className: 'btn btn-primary buttonStyle', disabled: submitting || pristine || !valid },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-danger buttonStyle', onClick: function onClick(event) {
	              event.preventDefault();closeC();
	            } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          this.props.isCreating || this.props.isEditing && _react2.default.createElement(_spinner2.default, null),
	          this.props.created && _react2.default.createElement(
	            _ContentWrapper2.default,
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'alert alert-success' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saved' })
	            )
	          ),
	          this.props.createError && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger marginTopStyle' },
	            JSON.stringify(this.props.createError)
	          ),
	          this.props.editError && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger marginTopStyle' },
	            JSON.stringify(this.props.editError)
	          )
	        )
	      );
	    }
	  }]);
	
	  return CategoryForm;
	}(_react.Component);
	
	var _default = CategoryForm;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CategoryForm, 'CategoryForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/categoryForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/categoryForm.jsx');
	}();

	;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _ImageFormatter = __webpack_require__(73);
	
	var _ImageFormatter2 = _interopRequireDefault(_ImageFormatter);
	
	var _Category2DisplayOptionsFormatter = __webpack_require__(398);
	
	var _Category2DisplayOptionsFormatter2 = _interopRequireDefault(_Category2DisplayOptionsFormatter);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isAFG = _root_url.ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afg-scm.truckxi.com/api/';
	var isEcity = _root_url.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ctstage-scm.truckxi.com/api/';
	var isAFM = _root_url.ROOT_API_URL === "https://afm-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://afm-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://afmstage-scm.truckxi.com/api/";
	
	var _require = __webpack_require__(5),
	    _require$Draggable = _require.Draggable,
	    DraggableContainer = _require$Draggable.Container,
	    RowActionsCell = _require$Draggable.RowActionsCell,
	    DropTargetRowContainer = _require$Draggable.DropTargetRowContainer,
	    Selectors = _require.Data.Selectors;
	
	var RowRenderer = DropTargetRowContainer(_reactDataGrid2.default.Row);
	
	var propTypes = {
	  categories: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    Name: _propTypes2.default.string,
	    Description: _propTypes2.default.string,
	    Image: _propTypes2.default.string,
	    Index: _propTypes2.default.number,
	    IsButton: _propTypes2.default.bool,
	    IsEnabled: _propTypes2.default.bool,
	    IsListView: _propTypes2.default.bool,
	    IsMobile: _propTypes2.default.bool,
	    ListViewType: _propTypes2.default.string,
	    ProductCategory2_id: _propTypes2.default.number
	  })),
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  multiEdited: _propTypes2.default.bool,
	  deleteCategorySuccess: _propTypes2.default.bool,
	  currentGroup: _propTypes2.default.number,
	  categoryIsLoading: _propTypes2.default.bool,
	  multiIsEditing: _propTypes2.default.bool,
	  savingCategory2Image: _propTypes2.default.bool,
	  category2ImageAttached: _propTypes2.default.bool,
	  deletingCategory: _propTypes2.default.bool,
	  categoryError: _propTypes2.default.string,
	  message: _propTypes2.default.string,
	  rowKey: _propTypes2.default.string,
	  handleCheckBoxClick: _propTypes2.default.func,
	  fetchCategories2: _propTypes2.default.func,
	  clearCategory2Status: _propTypes2.default.func,
	  deleteCategory2: _propTypes2.default.func,
	  editMultiCategories2: _propTypes2.default.func,
	  fetchCategory2Products: _propTypes2.default.func
	};
	
	var defaultProps = {
	  categories: [],
	  multiEdited: false,
	  deleteCategorySuccess: false,
	  currentGroup: null,
	  categoryIsLoading: false,
	  multiIsEditing: false,
	  savingCategory2Image: false,
	  category2ImageAttached: false,
	  deletingCategory: false,
	  categoryError: '',
	  message: '',
	  rowKey: 'Index',
	  value: false,
	  handleCheckBoxClick: function handleCheckBoxClick() {},
	  fetchCategories2: function fetchCategories2() {},
	  clearCategory2Status: function clearCategory2Status() {},
	  deleteCategory2: function deleteCategory2() {},
	  editMultiCategories2: function editMultiCategories2() {},
	  fetchCategory2Products: function fetchCategory2Products() {}
	};
	
	var contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var Category_2 = function (_Component) {
	  _inherits(Category_2, _Component);
	
	  function Category_2() {
	    _classCallCheck(this, Category_2);
	
	    var _this = _possibleConstructorReturn(this, (Category_2.__proto__ || Object.getPrototypeOf(Category_2)).call(this));
	
	    _this.onRowValueChange = function (event, rowValues, type) {
	      // merge updated row with current row and rerender by setting state
	      _this.setState({ sortColumn: null, sortDirection: null });
	      var rows = JSON.parse(JSON.stringify(_this.state.rows));
	      var editedRows = _this.state.editedRows.slice(0);
	      rows[rowValues.Index][type] = event.target.value;
	      editedRows.forEach(function (element, idx) {
	        if (element.Index === rows[rowValues.Index].Index) {
	          editedRows.splice(idx, 1);
	        }
	      }, _this);
	      // push the row into the editedRows array
	      editedRows.push(rows[rowValues.Index]);
	      _this.setState({
	        rows: rows,
	        editedRows: editedRows
	      });
	    };
	
	    _this.handleCheckBoxClick = function (props, type) {
	      var rows = JSON.parse(JSON.stringify(_this.state.rows));
	      var index = _lodash2.default.findIndex(rows, { Index: props.dependentValues.Index });
	      rows[index][type] = !rows[index][type];
	      var editedRows = JSON.parse(JSON.stringify(_this.state.editedRows));
	      editedRows.map(function (row, idx) {
	        if (row.Index === rows[index].Index) {
	          editedRows.splice(idx, 1);
	        }
	      });
	      editedRows.push(rows[index]);
	      _this.setState({ rows: rows, editedRows: editedRows });
	    };
	
	    _this.handleViewTypeSelect = function (e, rowValues) {
	      var rows = JSON.parse(JSON.stringify(_this.state.rows));
	      var index = _lodash2.default.findIndex(rows, { Index: rowValues.Index });
	      rows[index].ListViewType = e.value;
	      var editedRows = JSON.parse(JSON.stringify(_this.state.editedRows));
	      editedRows.map(function (row, idx) {
	        if (row.Index === rows[index].Index) {
	          editedRows.splice(idx, 1);
	        }
	      });
	      editedRows.push(rows[index]);
	      _this.setState({ rows: rows, editedRows: editedRows });
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton,
	      rows: [],
	      selectedRows: null,
	      editedRows: [],
	      filters: {},
	      sortColumn: null,
	      sortDirection: null
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.renderImage = _this.renderImage.bind(_this);
	    return _this;
	  }
	
	  _createClass(Category_2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.handleResize);
	      this.props.fetchCategories2();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.categories && nextProps.categories !== this.props.categories) {
	        var categories = nextProps.categories;
	
	        categories.map(function (category, index) {
	          category.Index = index;
	        });
	        this.setState({
	          rows: categories,
	          selectedRows: null,
	          editedRows: []
	        });
	      }
	      if (nextProps.multiEdited && nextProps.multiEdited !== this.props.multiEdited) {
	        this.props.fetchCategories2();
	        this.setState({ selectedRows: null, editedRows: [] });
	      }
	      if (nextProps.deleteCategorySuccess && nextProps.deleteCategorySuccess !== this.props.deleteCategorySuccess) {
	        this.props.fetchCategories2();
	        this.setState({ selectedRows: null, editedRows: [] });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	      this.props.clearCategory2Status();
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(row, files) {
	      var _this2 = this;
	
	      if (!files) {
	        return;
	      }
	      var reader = new FileReader();
	      reader.onload = function () {
	        var index = row.props.rowIdx;
	        var newRows = [].concat(_toConsumableArray(_this2.state.rows));
	        var editedRows = [].concat(_toConsumableArray(_this2.state.editedRows));
	        newRows[index].Image = reader.result;
	        var editedRowIndex = _lodash2.default.findIndex(editedRows, function (r) {
	          return r.Index === row.props.dependentValues.Index;
	        });
	        if (editedRowIndex === -1) {
	          editedRows.push(newRows[index]);
	        } else {
	          editedRows.splice(editedRowIndex, 1);
	          editedRows.push(newRows[index]);
	        }
	        _this2.setState({ rows: newRows, editedRows: editedRows });
	      };
	      // get the first file and convert to blob object (Blob.slice([start [, end [, contentType]]))
	      var blob = files[0].slice(0, files[0].size, files[0].type);
	      reader.readAsDataURL(blob);
	    }
	  }, {
	    key: 'deleteCategory',
	    value: function deleteCategory(e) {
	      e.preventDefault();
	      var ProductCategory2_id = this.state.selectedRows[0].ProductCategory2_id;
	
	      if (ProductCategory2_id) {
	        this.props.deleteCategory2(ProductCategory2_id);
	      } else {
	        var rows = JSON.parse(JSON.stringify(this.state.rows));
	        var editedRows = JSON.parse(JSON.stringify(this.state.editedRows));
	        var index = _lodash2.default.findIndex(rows, { Index: this.state.selectedRows[0].Index });
	        rows.splice(index, 1);
	        index = _lodash2.default.findIndex(editedRows, { Index: this.state.selectedRows[0].Index });
	        editedRows.splice(index, 1);
	        rows.map(function (row, idx) {
	          row.Index = idx;
	        });
	        this.setState({ rows: rows, editedRows: editedRows, selectedRows: [] });
	      }
	    }
	  }, {
	    key: 'updateRows',
	    value: function updateRows(e) {
	      e.preventDefault();
	      var outputRows = [];
	      if (this.state.rows && this.state.rows.length > 0) {
	        this.state.rows.map(function (r) {
	          if (!r.Name) {
	            r.Name = "Banner" + r.Order;
	          }
	          if (!r.Description) {
	            r.Description = "Banner" + r.Order;
	          }
	          r.Order = Number(r.Order);
	          outputRows.push(r);
	        });
	      }
	      outputRows.sort(function (a, b) {
	        if (a.Order > b.Order) {
	          return 1;
	        }
	        if (a.Order < b.Order) {
	          return -1;
	        }
	        return 0;
	      });
	      this.props.editMultiCategories2(outputRows);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton });
	    }
	  }, {
	    key: 'clickNew',
	    value: function clickNew(e) {
	      e.preventDefault();
	      var rows = _reactDataGridAddons.Data.Selectors.getRows(this.state);
	      var index = rows.length;
	      var newRow = {
	        Name: null,
	        Description: null,
	        IsEnabled: false,
	        IsListView: true,
	        IsButton: false,
	        IsMobile: false,
	        ListViewType: 'horizontal-1',
	        Index: index,
	        ProductGroup_id: this.props.currentGroup
	      };
	      rows.push(newRow);
	      var editedRows = [].concat(_toConsumableArray(this.state.editedRows));
	      editedRows.push(newRow);
	      this.setState({ rows: rows, editedRows: editedRows });
	    }
	  }, {
	    key: 'renderImage',
	    value: function renderImage(index) {
	      var imageFile = this.state.rows[index].Image || '/img/dummy.png';
	      return _react2.default.createElement(
	        'div',
	        { className: 'product-img-view' },
	        _react2.default.createElement('img', {
	          src: imageFile,
	          alt: 'Upload',
	          className: 'category2-default-image'
	        })
	      );
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this3 = this;
	
	      if (this.props.categoryIsLoading && !this.props.categoryError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.categoryError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            this.props.categoryError.message
	          )
	        );
	      }
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this3.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this3.setState(state);
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this3.state.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        _this3.setState({ filters: newFilters });
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        // merge updated row with current row and rerender by setting state
	        _this3.setState({ sortColumn: null, sortDirection: null });
	        var rows = getRows();
	        var editedRows = _this3.state.editedRows.slice(0);
	        Object.assign(rows[e.rowIdx], e.updated);
	        // if the element is already edited, remove the old one.
	        editedRows.forEach(function (element, index) {
	          if (element.Idx === rows[e.rowIdx].Index) {
	            editedRows.splice(index, 1);
	          }
	        }, _this3);
	        // push the row into the editedRows array
	        editedRows.push(rows[e.rowIdx]);
	        _this3.setState({
	          rows: rows,
	          editedRows: editedRows
	        });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        _this3.setState({
	          rows: newRows, selectedRows: [rows[0].row]
	        }, function () {
	          var category2Id = _this3.state.selectedRows[0].ProductCategory2_id;
	
	          var warehouse = localStorage.getItem('warehouseLocation');
	          if ((warehouse === null || warehouse === '') && isAFM) {
	            warehouse = 'all';
	          }
	          if (category2Id) {
	            _this3.props.fetchCategory2Products(category2Id, warehouse);
	          }
	        });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = getRows();
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        _this3.setState({ rows: newRows, selectedRows: [] });
	      };
	
	      var isDraggedRowSelected = function isDraggedRowSelected(selectedRows, rowDragSource) {
	        if (selectedRows && selectedRows.length > 0) {
	          var key = _this3.props.rowKey;
	          return selectedRows.filter(function (r) {
	            return r[key] === rowDragSource.data[key];
	          }).length > 0;
	        }
	        return false;
	      };
	
	      var reorderRows = function reorderRows(e) {
	        var selectedRows = Selectors.getSelectedRowsByKey({ rowKey: _this3.props.rowKey, selectedKeys: [], rows: _this3.state.rows });
	        var draggedRows = isDraggedRowSelected(selectedRows, e.rowSource) ? selectedRows : [e.rowSource.data];
	        var undraggedRows = _this3.state.rows.filter(function (r) {
	          return draggedRows.indexOf(r) === -1;
	        });
	        var args = [e.rowTarget.idx, 0].concat(draggedRows);
	        Array.prototype.splice.apply(undraggedRows, args);
	        undraggedRows.map(function (row, index) {
	          row.Index = index;
	        });
	        _this3.setState({ rows: undraggedRows, editedRows: undraggedRows });
	      };
	
	      var handleIsEnabledClick = function handleIsEnabledClick(props) {
	        var rows = getRows();
	        var index = _lodash2.default.findIndex(rows, { Index: props.dependentValues.Index });
	        rows[index].IsEnabled = !rows[index].IsEnabled;
	        var editedRows = [].concat(_toConsumableArray(_this3.state.editedRows));
	        editedRows.map(function (row, idx) {
	          if (row.Index === rows[index].Index) {
	            editedRows.splice(idx, 1);
	          }
	        });
	        editedRows.push(rows[index]);
	        _this3.setState({ rows: rows, editedRows: editedRows });
	      };
	
	      var IsEnabledFormatter = _react2.default.createClass({
	        displayName: 'IsEnabledFormatter',
	        render: function render() {
	          var _this4 = this;
	
	          return _react2.default.createElement('input', {
	            id: 'product-group-enable',
	            type: 'checkbox',
	            value: 'true',
	            checked: this.props.value === true || this.props.value === 'true',
	            onClick: function onClick() {
	              handleIsEnabledClick(_this4.props);
	            }
	          });
	        }
	      });
	
	      var handleIsMobileClick = function handleIsMobileClick(props) {
	        var rows = getRows();
	        var index = _lodash2.default.findIndex(rows, { Index: props.dependentValues.Index });
	        rows[index].IsMobile = !rows[index].IsMobile;
	        var editedRows = [].concat(_toConsumableArray(_this3.state.editedRows));
	        editedRows.map(function (row, idx) {
	          if (row.Index === rows[index].Index) {
	            editedRows.splice(idx, 1);
	          }
	        });
	        editedRows.push(rows[index]);
	        _this3.setState({ rows: rows, editedRows: editedRows });
	      };
	
	      var IsMobileFormatter = _react2.default.createClass({
	        displayName: 'IsMobileFormatter',
	        render: function render() {
	          var _this5 = this;
	
	          return _react2.default.createElement('input', {
	            id: 'product-group-enable',
	            type: 'checkbox',
	            value: 'true',
	            checked: this.props.value === true || this.props.value === 'true',
	            onClick: function onClick() {
	              handleIsMobileClick(_this5.props);
	            }
	          });
	        }
	      });
	
	      var IdxFormatter = _react2.default.createClass({
	        displayName: 'IdxFormatter',
	        render: function render() {
	          return _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'center' } },
	            Number(this.props.dependentValues.Order)
	          );
	        }
	      });
	
	      var handleEnableLaguangeChange = function handleEnableLaguangeChange(newVal, dependentValues) {
	        var currentRows = [].concat(_toConsumableArray(_this3.state.rows));
	        currentRows[dependentValues.Index].ViewableLanguages = newVal;
	        _this3.setState({
	          rows: currentRows
	        });
	      };
	
	      var EnabledLanguageFormatter = _react2.default.createClass({
	        displayName: 'EnabledLanguageFormatter',
	        render: function render() {
	          var _props = this.props,
	              value = _props.value,
	              options = _props.options,
	              dependentValues = _props.dependentValues;
	
	
	          var backupOptions = [{
	            label: 'English - EN',
	            value: 'EN'
	          }, {
	            label: 'Chinese - ZH',
	            value: 'ZH'
	          }];
	          return _react2.default.createElement(
	            'div',
	            { id: 'zInd', style: { position: 'relative', height: '82px' } },
	            _react2.default.createElement(_reactSelect2.default, {
	              matchPos: "start",
	              matchProp: 'label',
	              menuPortalTarget: document.body,
	              styles: {
	                // Fixes the overlapping problem of the component
	                menu: function menu(provided) {
	                  return _extends({}, provided, { zIndex: 9999 });
	                }
	              },
	              options: options || backupOptions,
	              value: value,
	              onChange: function onChange(newVal) {
	                return handleEnableLaguangeChange(newVal, dependentValues);
	              },
	              multi: true,
	              removeSelected: true,
	              simpleValue: true,
	              closeOnSelect: false
	            })
	          );
	        }
	      });
	
	      var columns = [{
	        key: 'Order',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	        resizeable: true,
	        width: 50,
	        sortable: true,
	        editable: true,
	        filterable: true,
	        formatter: IdxFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'Category',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category' }),
	        resizeable: true,
	        width: 220,
	        sortable: false,
	        editable: false,
	        filterable: false,
	        formatter: _react2.default.createElement(_ImageFormatter2.default, {
	          renderImage: this.renderImage,
	          onDrop: this.onDrop,
	          onRowValueChange: this.onRowValueChange,
	          showImageOnly: false
	        }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'DisplayOptions',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'show_as' }),
	        resizeable: true,
	        width: 220,
	        sortable: false,
	        editable: false,
	        filterable: false,
	        formatter: _react2.default.createElement(_Category2DisplayOptionsFormatter2.default, {
	          handleCheckBoxClick: this.handleCheckBoxClick,
	          handleViewTypeSelect: this.handleViewTypeSelect
	        }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'IsEnabled',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' }),
	        resizable: true,
	        width: 80,
	        sortable: false,
	        filterable: false,
	        formatter: IsEnabledFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }].concat(_toConsumableArray(isEcity ? [{
	        key: 'ViewableLanguages',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enable_for_languages' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: EnabledLanguageFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        },
	        width: 280
	      }] : {}), _toConsumableArray(isAFM ? [{
	        key: 'IsMobile',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mobile' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        formatter: IsMobileFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'ViewableLanguages',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enable_for_languages' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: EnabledLanguageFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        },
	        width: 280
	      }] : {}));
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '100%' }, id: 'Category_2-dataGrid1' },
	            _react2.default.createElement(
	              DraggableContainer,
	              null,
	              _react2.default.createElement(_reactDataGrid2.default, {
	                enableCellSelect: true,
	                onGridSort: handleGridSort,
	                onAddFilter: handleFilterChange,
	                columns: columns,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                minHeight: 680,
	                rowHeight: 200,
	                headerRowHeight: 25,
	                enableRowSelect: 'single'
	                // rowActionsCell={RowActionsCell}
	                // rowRenderer={<RowRenderer onRowDrop={reorderRows} />}
	                , onRowUpdated: handleRowUpdated,
	                rowSelection: {
	                  showCheckbox: true,
	                  onRowsSelected: onRowsSelected,
	                  onRowsDeselected: onRowsDeselected,
	                  selectBy: {
	                    isSelectedKey: 'isSelected'
	                  }
	                }
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          { className: 'group-management-table-buttons' },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'primary',
	              className: 'marginLeftStyle',
	              onClick: function onClick(event) {
	                _this6.clickNew(event);
	              },
	              disabled: !(0, _permissions2.default)('add_product_category')
	            },
	            _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'success',
	              className: 'buttonStyle',
	              onClick: function onClick(event) {
	                _this6.updateRows(event);
	              },
	              disabled: !this.state.editedRows || !(0, _permissions2.default)('change_product_category')
	            },
	            _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'danger',
	              className: 'buttonStyle',
	              onClick: function onClick(event) {
	                _this6.deleteCategory(event);
	              },
	              disabled: !this.state.selectedRows || this.state.selectedRows.length !== 1 || !(0, _permissions2.default)('delete_product_category')
	            },
	            _react2.default.createElement('em', { className: 'fa fa-trash marginRightStyle' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	          )
	        ),
	        this.renderTable(),
	        _react2.default.createElement('br', null),
	        (this.props.multiIsEditing || this.props.savingCategory2Image) && _react2.default.createElement(
	          'div',
	          { className: 'alert alert-info categories-saving-info' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saving' })
	        ),
	        (this.props.multiEdited || this.props.category2ImageAttached) && _react2.default.createElement(
	          'div',
	          { className: 'alert alert-success categories-saving-info' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saved' })
	        ),
	        this.props.deletingCategory && _react2.default.createElement(
	          'div',
	          { className: 'alert alert-info categories-saving-info' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deleting' })
	        ),
	        this.props.deleteCategorySuccess && _react2.default.createElement(
	          'div',
	          { className: 'alert alert-success categories-saving-info' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deleted' })
	        )
	      );
	    }
	  }]);
	
	  return Category_2;
	}(_react.Component);
	
	Category_2.propTypes = propTypes;
	Category_2.defaultProps = defaultProps;
	Category_2.contextTypes = contextTypes;
	
	var _default = Category_2;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isAFG, 'isAFG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/category_2.jsx');
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/category_2.jsx');
	
	  __REACT_HOT_LOADER__.register(isAFM, 'isAFM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/category_2.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/category_2.jsx');
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/category_2.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/category_2.jsx');
	
	  __REACT_HOT_LOADER__.register(contextTypes, 'contextTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/category_2.jsx');
	
	  __REACT_HOT_LOADER__.register(Category_2, 'Category_2', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/category_2.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/category_2.jsx');
	}();

	;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _ImageFormatter = __webpack_require__(73);
	
	var _ImageFormatter2 = _interopRequireDefault(_ImageFormatter);
	
	var _ImageFormatterB2B = __webpack_require__(253);
	
	var _ImageFormatterB2B2 = _interopRequireDefault(_ImageFormatterB2B);
	
	var _Category2DisplayOptionsFormatterB2B = __webpack_require__(399);
	
	var _Category2DisplayOptionsFormatterB2B2 = _interopRequireDefault(_Category2DisplayOptionsFormatterB2B);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(5),
	    _require$Draggable = _require.Draggable,
	    DraggableContainer = _require$Draggable.Container,
	    RowActionsCell = _require$Draggable.RowActionsCell,
	    DropTargetRowContainer = _require$Draggable.DropTargetRowContainer,
	    Selectors = _require.Data.Selectors;
	
	var RowRenderer = DropTargetRowContainer(_reactDataGrid2.default.Row);
	
	var propTypes = {
	  categories: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    Name: _propTypes2.default.string,
	    Description: _propTypes2.default.string,
	    Image: _propTypes2.default.string,
	    Image2: _propTypes2.default.string,
	    Index: _propTypes2.default.number,
	    IsButton: _propTypes2.default.bool,
	    IsEnabled: _propTypes2.default.bool,
	    IsAFGChoice: _propTypes2.default.bool,
	    IsListView: _propTypes2.default.bool,
	    ListViewType: _propTypes2.default.string,
	    ProductCategory2_id: _propTypes2.default.number
	  })),
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  multiEdited: _propTypes2.default.bool,
	  deleteCategorySuccess: _propTypes2.default.bool,
	  currentGroup: _propTypes2.default.number,
	  categoryIsLoading: _propTypes2.default.bool,
	  multiIsEditing: _propTypes2.default.bool,
	  savingCategory2Image: _propTypes2.default.bool,
	  category2ImageAttached: _propTypes2.default.bool,
	  deletingCategory: _propTypes2.default.bool,
	  categoryError: _propTypes2.default.string,
	  message: _propTypes2.default.string,
	  rowKey: _propTypes2.default.string,
	  handleCheckBoxClick: _propTypes2.default.func,
	  fetchCategories2B2B: _propTypes2.default.func,
	  clearCategory2StatusB2B: _propTypes2.default.func,
	  deleteCategory2B2B: _propTypes2.default.func,
	  editMultiCategories2B2B: _propTypes2.default.func,
	  fetchCategory2ProductsB2B: _propTypes2.default.func
	};
	
	var defaultProps = {
	  categories: [],
	  multiEdited: false,
	  deleteCategorySuccess: false,
	  currentGroup: null,
	  categoryIsLoading: false,
	  multiIsEditing: false,
	  savingCategory2Image: false,
	  category2ImageAttached: false,
	  deletingCategory: false,
	  categoryError: '',
	  message: '',
	  rowKey: 'Index',
	  value: false,
	  handleCheckBoxClick: function handleCheckBoxClick() {},
	  fetchCategories2B2B: function fetchCategories2B2B() {},
	  clearCategory2StatusB2B: function clearCategory2StatusB2B() {},
	  deleteCategory2B2B: function deleteCategory2B2B() {},
	  editMultiCategories2B2B: function editMultiCategories2B2B() {},
	  fetchCategory2ProductsB2B: function fetchCategory2ProductsB2B() {}
	};
	
	var contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var Category_2_B2B = function (_Component) {
	  _inherits(Category_2_B2B, _Component);
	
	  function Category_2_B2B() {
	    _classCallCheck(this, Category_2_B2B);
	
	    var _this = _possibleConstructorReturn(this, (Category_2_B2B.__proto__ || Object.getPrototypeOf(Category_2_B2B)).call(this));
	
	    _this.onRowValueChange = function (event, rowValues, type) {
	      // merge updated row with current row and rerender by setting state
	      _this.setState({ sortColumn: null, sortDirection: null });
	      var rows = JSON.parse(JSON.stringify(_this.state.rows));
	      var editedRows = _this.state.editedRows.slice(0);
	      rows[rowValues.Index][type] = event.target.value;
	      editedRows.forEach(function (element, idx) {
	        if (element.Index === rows[rowValues.Index].Index) {
	          editedRows.splice(idx, 1);
	        }
	      }, _this);
	      // push the row into the editedRows array
	      editedRows.push(rows[rowValues.Index]);
	      _this.setState({
	        rows: rows,
	        editedRows: editedRows
	      });
	    };
	
	    _this.handleCheckBoxClick = function (props, type) {
	      var rows = JSON.parse(JSON.stringify(_this.state.rows));
	      var index = _lodash2.default.findIndex(rows, { Index: props.dependentValues.Index });
	      rows[index][type] = !rows[index][type];
	      var editedRows = JSON.parse(JSON.stringify(_this.state.editedRows));
	      editedRows.map(function (row, idx) {
	        if (row.Index === rows[index].Index) {
	          editedRows.splice(idx, 1);
	        }
	      });
	      editedRows.push(rows[index]);
	      _this.setState({ rows: rows, editedRows: editedRows });
	    };
	
	    _this.handleViewTypeSelect = function (e, rowValues) {
	      var rows = JSON.parse(JSON.stringify(_this.state.rows));
	      var index = _lodash2.default.findIndex(rows, { Index: rowValues.Index });
	      rows[index].ListViewType = e.value;
	      var editedRows = JSON.parse(JSON.stringify(_this.state.editedRows));
	      editedRows.map(function (row, idx) {
	        if (row.Index === rows[index].Index) {
	          editedRows.splice(idx, 1);
	        }
	      });
	      editedRows.push(rows[index]);
	      _this.setState({ rows: rows, editedRows: editedRows });
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton,
	      rows: [],
	      selectedRows: null,
	      editedRows: [],
	      filters: {},
	      sortColumn: null,
	      sortDirection: null
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.onDrop2 = _this.onDrop2.bind(_this);
	    _this.renderImage = _this.renderImage.bind(_this);
	    _this.renderImage2 = _this.renderImage2.bind(_this);
	    return _this;
	  }
	
	  _createClass(Category_2_B2B, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.handleResize);
	      this.props.fetchCategories2B2B();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.categories && nextProps.categories !== this.props.categories) {
	        var categories = nextProps.categories;
	
	        categories.map(function (category, index) {
	          category.Index = index;
	        });
	        this.setState({
	          rows: categories,
	          selectedRows: null,
	          editedRows: []
	        });
	      }
	      if (nextProps.multiEdited && nextProps.multiEdited !== this.props.multiEdited) {
	        this.props.fetchCategories2B2B();
	        this.setState({ selectedRows: null, editedRows: [] });
	      }
	      if (nextProps.deleteCategorySuccess && nextProps.deleteCategorySuccess !== this.props.deleteCategorySuccess) {
	        this.props.fetchCategories2B2B();
	        this.setState({ selectedRows: null, editedRows: [] });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	      this.props.clearCategory2StatusB2B();
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(row, files) {
	      var _this2 = this;
	
	      if (!files) {
	        return;
	      }
	      var reader = new FileReader();
	      reader.onload = function () {
	        var index = row.props.rowIdx;
	        var newRows = [].concat(_toConsumableArray(_this2.state.rows));
	        var editedRows = [].concat(_toConsumableArray(_this2.state.editedRows));
	        newRows[index].Image = reader.result;
	        var editedRowIndex = _lodash2.default.findIndex(editedRows, function (r) {
	          return r.Index === row.props.dependentValues.Index;
	        });
	        if (editedRowIndex === -1) {
	          editedRows.push(newRows[index]);
	        } else {
	          editedRows.splice(editedRowIndex, 1);
	          editedRows.push(newRows[index]);
	        }
	        _this2.setState({ rows: newRows, editedRows: editedRows });
	      };
	      // get the first file and convert to blob object (Blob.slice([start [, end [, contentType]]))
	      var blob = files[0].slice(0, files[0].size, files[0].type);
	      reader.readAsDataURL(blob);
	    }
	  }, {
	    key: 'onDrop2',
	    value: function onDrop2(row, files) {
	      var _this3 = this;
	
	      if (!files) {
	        return;
	      }
	      var reader = new FileReader();
	      reader.onload = function () {
	        var index = row.props.rowIdx;
	        var newRows = [].concat(_toConsumableArray(_this3.state.rows));
	        var editedRows = [].concat(_toConsumableArray(_this3.state.editedRows));
	        newRows[index].Image2 = reader.result;
	        var editedRowIndex = _lodash2.default.findIndex(editedRows, function (r) {
	          return r.Index === row.props.dependentValues.Index;
	        });
	        if (editedRowIndex === -1) {
	          editedRows.push(newRows[index]);
	        } else {
	          editedRows.splice(editedRowIndex, 1);
	          editedRows.push(newRows[index]);
	        }
	        _this3.setState({ rows: newRows, editedRows: editedRows });
	      };
	      // get the first file and convert to blob object (Blob.slice([start [, end [, contentType]]))
	      var blob = files[0].slice(0, files[0].size, files[0].type);
	      reader.readAsDataURL(blob);
	    }
	  }, {
	    key: 'deleteCategory',
	    value: function deleteCategory(e) {
	      e.preventDefault();
	      var ProductCategory2_id = this.state.selectedRows[0].ProductCategory2_id;
	
	      if (ProductCategory2_id) {
	        this.props.deleteCategory2B2B(ProductCategory2_id);
	      } else {
	        var rows = JSON.parse(JSON.stringify(this.state.rows));
	        var editedRows = JSON.parse(JSON.stringify(this.state.editedRows));
	        var index = _lodash2.default.findIndex(rows, { Index: this.state.selectedRows[0].Index });
	        rows.splice(index, 1);
	        index = _lodash2.default.findIndex(editedRows, { Index: this.state.selectedRows[0].Index });
	        editedRows.splice(index, 1);
	        rows.map(function (row, idx) {
	          row.Index = idx;
	        });
	        this.setState({ rows: rows, editedRows: editedRows, selectedRows: [] });
	      }
	    }
	  }, {
	    key: 'updateRows',
	    value: function updateRows(e) {
	      e.preventDefault();
	      var outputRows = [];
	      if (this.state.rows && this.state.rows.length > 0) {
	        this.state.rows.map(function (r) {
	          if (!r.Name) {
	            r.Name = "Banner" + r.Order;
	          }
	          if (!r.Description) {
	            r.Description = "Banner" + r.Order;
	          }
	          r.Order = Number(r.Order);
	          outputRows.push(r);
	        });
	      }
	      outputRows.sort(function (a, b) {
	        if (a.Order > b.Order) {
	          return 1;
	        }
	        if (a.Order < b.Order) {
	          return -1;
	        }
	        return 0;
	      });
	      this.props.editMultiCategories2B2B(outputRows);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton });
	    }
	  }, {
	    key: 'clickNew',
	    value: function clickNew(e) {
	      e.preventDefault();
	      var rows = _reactDataGridAddons.Data.Selectors.getRows(this.state);
	      var index = rows.length;
	      var newRow = {
	        Name: null,
	        Description: null,
	        IsEnabled: false,
	        IsAFGChoice: false,
	        IsListView: true,
	        IsButton: false,
	        ListViewType: 'horizontal-1',
	        Index: index,
	        ProductGroup_id: this.props.currentGroup
	      };
	      rows.push(newRow);
	      var editedRows = [].concat(_toConsumableArray(this.state.editedRows));
	      editedRows.push(newRow);
	      this.setState({ rows: rows, editedRows: editedRows });
	    }
	  }, {
	    key: 'renderImage',
	    value: function renderImage(index) {
	      var imageFile = this.state.rows[index].Image || '/img/dummy.png';
	      return _react2.default.createElement(
	        'div',
	        { className: 'product-img-view' },
	        _react2.default.createElement('img', {
	          src: imageFile,
	          alt: 'Upload',
	          className: 'category2-default-image'
	        })
	      );
	    }
	  }, {
	    key: 'renderImage2',
	    value: function renderImage2(index) {
	      var imageFile2 = this.state.rows[index].Image2 || '/img/dummy.png';
	      return _react2.default.createElement(
	        'div',
	        { className: 'product-img-view' },
	        _react2.default.createElement('img', {
	          src: imageFile2,
	          alt: 'Upload',
	          className: 'category2-default-image'
	        })
	      );
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this4 = this;
	
	      if (this.props.categoryIsLoading && !this.props.categoryError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.categoryError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            this.props.categoryError.message
	          )
	        );
	      }
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this4.state);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this4.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this4.setState(state);
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this4.state.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        _this4.setState({ filters: newFilters });
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        // merge updated row with current row and rerender by setting state
	        _this4.setState({ sortColumn: null, sortDirection: null });
	        var rows = getRows();
	        var editedRows = _this4.state.editedRows.slice(0);
	        Object.assign(rows[e.rowIdx], e.updated);
	        // if the element is already edited, remove the old one.
	        editedRows.forEach(function (element, index) {
	          if (element.Idx === rows[e.rowIdx].Index) {
	            editedRows.splice(index, 1);
	          }
	        }, _this4);
	        // push the row into the editedRows array
	        editedRows.push(rows[e.rowIdx]);
	        _this4.setState({
	          rows: rows,
	          editedRows: editedRows
	        });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        _this4.setState({
	          rows: newRows, selectedRows: [rows[0].row]
	        }, function () {
	          var category2Id = _this4.state.selectedRows[0].ProductCategory2_id;
	          if (category2Id) {
	            _this4.props.fetchCategory2ProductsB2B(category2Id);
	          }
	        });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = getRows();
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        _this4.setState({ rows: newRows, selectedRows: [] });
	      };
	
	      var isDraggedRowSelected = function isDraggedRowSelected(selectedRows, rowDragSource) {
	        if (selectedRows && selectedRows.length > 0) {
	          var key = _this4.props.rowKey;
	          return selectedRows.filter(function (r) {
	            return r[key] === rowDragSource.data[key];
	          }).length > 0;
	        }
	        return false;
	      };
	
	      var reorderRows = function reorderRows(e) {
	        var selectedRows = Selectors.getSelectedRowsByKey({ rowKey: _this4.props.rowKey, selectedKeys: [], rows: _this4.state.rows });
	        var draggedRows = isDraggedRowSelected(selectedRows, e.rowSource) ? selectedRows : [e.rowSource.data];
	        var undraggedRows = _this4.state.rows.filter(function (r) {
	          return draggedRows.indexOf(r) === -1;
	        });
	        var args = [e.rowTarget.idx, 0].concat(draggedRows);
	        Array.prototype.splice.apply(undraggedRows, args);
	        undraggedRows.map(function (row, index) {
	          row.Index = index;
	        });
	        _this4.setState({ rows: undraggedRows, editedRows: undraggedRows });
	      };
	
	      var handleIsEnabledClick = function handleIsEnabledClick(props) {
	        var rows = getRows();
	        var index = _lodash2.default.findIndex(rows, { Index: props.dependentValues.Index });
	        rows[index].IsEnabled = !rows[index].IsEnabled;
	        var editedRows = [].concat(_toConsumableArray(_this4.state.editedRows));
	        editedRows.map(function (row, idx) {
	          if (row.Index === rows[index].Index) {
	            editedRows.splice(idx, 1);
	          }
	        });
	        editedRows.push(rows[index]);
	        _this4.setState({ rows: rows, editedRows: editedRows });
	      };
	
	      var IsEnabledFormatter = _react2.default.createClass({
	        displayName: 'IsEnabledFormatter',
	        render: function render() {
	          var _this5 = this;
	
	          return _react2.default.createElement('input', {
	            id: 'product-group-enable',
	            type: 'checkbox',
	            value: 'true',
	            checked: this.props.value === true || this.props.value === 'true',
	            onClick: function onClick() {
	              handleIsEnabledClick(_this5.props);
	            }
	          });
	        }
	      });
	
	      var IdxFormatter = _react2.default.createClass({
	        displayName: 'IdxFormatter',
	        render: function render() {
	          return _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'center' } },
	            Number(this.props.dependentValues.Order)
	          );
	        }
	      });
	
	      var columns = [{
	        key: 'Order',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	        resizeable: true,
	        width: 50,
	        sortable: true,
	        editable: true,
	        filterable: true,
	        formatter: IdxFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'Category',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'logo' }),
	        resizeable: true,
	        width: 220,
	        sortable: false,
	        editable: false,
	        filterable: false,
	        formatter: _react2.default.createElement(_ImageFormatter2.default, {
	          renderImage: this.renderImage,
	          onDrop: this.onDrop,
	          onRowValueChange: this.onRowValueChange,
	          showImageOnly: false
	        }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'Image2',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'image' }),
	        resizeable: true,
	        width: 220,
	        sortable: false,
	        editable: false,
	        filterable: false,
	        formatter: _react2.default.createElement(_ImageFormatterB2B2.default, {
	          renderImage: this.renderImage2,
	          onDrop: this.onDrop2,
	          onRowValueChange: this.onRowValueChange,
	          showImageOnly: true
	        }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'DisplayOptions',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'show_as' }),
	        resizeable: true,
	        width: 220,
	        sortable: false,
	        editable: false,
	        filterable: false,
	        formatter: _react2.default.createElement(_Category2DisplayOptionsFormatterB2B2.default, {
	          handleCheckBoxClick: this.handleCheckBoxClick,
	          handleViewTypeSelect: this.handleViewTypeSelect
	        }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'IsEnabled',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' }),
	        resizable: true,
	        width: 80,
	        sortable: false,
	        filterable: false,
	        formatter: IsEnabledFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '100%' }, id: 'Category_2-dataGrid1' },
	            _react2.default.createElement(
	              DraggableContainer,
	              null,
	              _react2.default.createElement(_reactDataGrid2.default, {
	                enableCellSelect: true,
	                onGridSort: handleGridSort,
	                onAddFilter: handleFilterChange,
	                columns: columns,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                minHeight: 680,
	                rowHeight: 200,
	                headerRowHeight: 25,
	                enableRowSelect: 'single'
	                // rowActionsCell={RowActionsCell}
	                // rowRenderer={<RowRenderer onRowDrop={reorderRows} />}
	                , onRowUpdated: handleRowUpdated,
	                rowSelection: {
	                  showCheckbox: true,
	                  onRowsSelected: onRowsSelected,
	                  onRowsDeselected: onRowsDeselected,
	                  selectBy: {
	                    isSelectedKey: 'isSelected'
	                  }
	                }
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          { className: 'group-management-table-buttons' },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'primary',
	              className: 'marginLeftStyle',
	              onClick: function onClick(event) {
	                _this6.clickNew(event);
	              },
	              disabled: !(0, _permissions2.default)('add_product_category')
	            },
	            _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'success',
	              className: 'buttonStyle',
	              onClick: function onClick(event) {
	                _this6.updateRows(event);
	              },
	              disabled: !this.state.editedRows || !(0, _permissions2.default)('change_product_category')
	            },
	            _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'danger',
	              className: 'buttonStyle',
	              onClick: function onClick(event) {
	                _this6.deleteCategory(event);
	              },
	              disabled: !this.state.selectedRows || this.state.selectedRows.length !== 1 || !(0, _permissions2.default)('delete_product_category')
	            },
	            _react2.default.createElement('em', { className: 'fa fa-trash marginRightStyle' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	          )
	        ),
	        this.renderTable(),
	        _react2.default.createElement('br', null),
	        (this.props.multiIsEditing || this.props.savingCategory2Image) && _react2.default.createElement(
	          'div',
	          { className: 'alert alert-info categories-saving-info' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saving' })
	        ),
	        (this.props.multiEdited || this.props.category2ImageAttached) && _react2.default.createElement(
	          'div',
	          { className: 'alert alert-success categories-saving-info' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saved' })
	        ),
	        this.props.deletingCategory && _react2.default.createElement(
	          'div',
	          { className: 'alert alert-info categories-saving-info' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deleting' })
	        ),
	        this.props.deleteCategorySuccess && _react2.default.createElement(
	          'div',
	          { className: 'alert alert-success categories-saving-info' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deleted' })
	        )
	      );
	    }
	  }]);
	
	  return Category_2_B2B;
	}(_react.Component);
	
	Category_2_B2B.propTypes = propTypes;
	Category_2_B2B.defaultProps = defaultProps;
	Category_2_B2B.contextTypes = contextTypes;
	
	var _default = Category_2_B2B;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/category_2_b2b.jsx');
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/category_2_b2b.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/category_2_b2b.jsx');
	
	  __REACT_HOT_LOADER__.register(contextTypes, 'contextTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/category_2_b2b.jsx');
	
	  __REACT_HOT_LOADER__.register(Category_2_B2B, 'Category_2_B2B', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/category_2_b2b.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/category_2_b2b.jsx');
	}();

	;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ESLModal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ESLModal = exports.ESLModal = function (_Component) {
	    _inherits(ESLModal, _Component);
	
	    function ESLModal(props) {
	        _classCallCheck(this, ESLModal);
	
	        var _this = _possibleConstructorReturn(this, (ESLModal.__proto__ || Object.getPrototypeOf(ESLModal)).call(this, props));
	
	        _this.handleTemplateChange = function (el) {
	            _this.setState({
	                templateOptionsDisplay: el.label,
	                TemplateId: el.value,
	                TemplateName: el.label
	            });
	        };
	
	        _this.handleCodeChange = function (value) {
	            _this.setState({ ESLCode: value });
	        };
	
	        _this.state = {
	            ESLCode: '',
	            TemplateId: '',
	            TemplateName: '',
	
	            templateOptions: [],
	            templateOptionsDisplay: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select' })
	        };
	        _this.handleConfirmClick = _this.handleConfirmClick.bind(_this);
	        return _this;
	    }
	
	    _createClass(ESLModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var templateOptions = [];
	            this.props.fetchESLTemplate().then(function (response) {
	                response.data.template_list.map(function (templates) {
	                    templateOptions.push({ value: templates.template_id, label: templates.template_name });
	                });
	                _this2.setState({ templateOptions: templateOptions });
	            }, function (err) {
	                alert("ESL Error: " + err.data);
	            });
	
	            this.props.handleFetchESL(); // fetch data
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.eslFetchData) {
	                this.setState({
	                    ESLCode: nextProps.eslFetchData.ESLCode,
	                    TemplateId: nextProps.eslFetchData.TemplateId,
	                    TemplateName: nextProps.eslFetchData.TemplateName
	                });
	            }
	        }
	    }, {
	        key: 'handleConfirmClick',
	        value: function handleConfirmClick() {
	            if (!this.state.TemplateId) {
	                alert("Please choose an ESL template");
	            } else if (!this.state.ESLCode) {
	                alert("Please enter an ESL Code");
	            } else {
	                this.props.handleSaveESL(this.state.ESLCode, this.state.TemplateId, this.state.TemplateName);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var templateOptions = this.state.templateOptions;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12, className: 'centerStyle' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'esl_template' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12, className: 'centerStyle', style: { marginTop: '5px', marginBottom: '10px' } },
	                        _react2.default.createElement(
	                            _reactBootstrap.Dropdown,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Dropdown.Toggle,
	                                { style: { width: '300px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' } },
	                                this.state.templateOptionsDisplay
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Dropdown.Menu,
	                                { className: 'super-colors' },
	                                templateOptions.map(function (el) {
	                                    return _react2.default.createElement(
	                                        _reactBootstrap.MenuItem,
	                                        { onClick: function onClick() {
	                                                return _this3.handleTemplateChange(el);
	                                            } },
	                                        el.label
	                                    );
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12, className: 'centerStyle' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'esl_code' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12, className: 'centerStyle', style: { marginTop: '5px', marginBottom: '10px' } },
	                        _react2.default.createElement(_reactBootstrap.Input, {
	                            type: 'text',
	                            style: { width: '250px' },
	                            value: this.state.ESLCode,
	                            onChange: function onChange(e) {
	                                return _this3.handleCodeChange(e.target.value);
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12, className: 'centerStyle' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'success',
	                                onClick: this.handleConfirmClick
	                            },
	                            _react2.default.createElement('em', { className: 'fa fa-check' }),
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm' })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ESLModal;
	}(_react.Component);
	
	var _default = ESLModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(ESLModal, 'ESLModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/ESLModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/ESLModal.jsx');
	}();

	;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDropzone = __webpack_require__(45);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  imagesList: {
	    display: 'flex',
	    flexDirection: 'row',
	    flexWrap: 'wrap',
	    overflow: 'auto'
	  },
	  imageWrapper: {
	    position: 'relative',
	    width: '100px',
	    height: '100px',
	    marginRight: '5px',
	    marginBottom: '5px'
	  },
	  image: {
	    width: '100px',
	    height: '100px'
	  },
	  removeBtn: {
	    position: 'absolute',
	    right: '5px',
	    top: '0px',
	    color: 'red',
	    fontWeight: '500',
	    fontSize: '18px'
	  },
	  dropzone: {
	    width: '100px',
	    height: '100px',
	    border: '1px solid #BBBBBB',
	    fontSize: '20px',
	    color: '#BBBBBB',
	    textAlign: 'center',
	    lineHeight: '100px'
	  }
	};
	
	var GroupImageManageModal = function (_Component) {
	  _inherits(GroupImageManageModal, _Component);
	
	  function GroupImageManageModal(props) {
	    _classCallCheck(this, GroupImageManageModal);
	
	    var _this = _possibleConstructorReturn(this, (GroupImageManageModal.__proto__ || Object.getPrototypeOf(GroupImageManageModal)).call(this));
	
	    _this.handleDelete = function (index) {
	      _this.state.row.GroupImage.splice(index, 1);
	      _this.setState({
	        row: _extends({}, _this.state.row, { GroupImage: _this.state.row.GroupImage })
	      });
	    };
	
	    _this.handleDrop = function (files) {
	      var _loop = function _loop(i) {
	        var reader = new FileReader();
	        reader.onload = function () {
	          _this.state.row.GroupImage.push(reader.result);
	          _this.setState({
	            row: _extends({}, _this.state.row, { GroupImage: _this.state.row.GroupImage })
	          });
	        };
	        var blob = files[i].slice(0, files[i].size, files[i].type);
	        reader.readAsDataURL(blob);
	      };
	
	      for (var i = 0; i < files.length; i++) {
	        _loop(i);
	      }
	    };
	
	    _this.handleSaveButtonClick = function () {
	      _this.props.onConfirm(_this.state.row);
	    };
	
	    _this.state = {
	      row: props.row
	    };
	    return _this;
	  }
	
	  _createClass(GroupImageManageModal, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      console.log(nextProps, 'nextProps');
	      if (nextProps.row) {
	        this.setState({
	          row: nextProps.row
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { style: { height: '85%' } },
	        _react2.default.createElement(
	          _reactBootstrap.Panel,
	          { style: { height: '90%' } },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'div',
	                { style: styles.imagesList },
	                this.state.row.GroupImage.map(function (Image, index) {
	                  return _react2.default.createElement(
	                    'div',
	                    { style: _extends({}, styles.imageWrapper, { marginLeft: '0px', marginTop: '0px' }), key: index },
	                    _react2.default.createElement(
	                      'div',
	                      { style: styles.removeBtn, onClick: function onClick() {
	                          return _this2.handleDelete(index);
	                        } },
	                      _react2.default.createElement('em', { className: 'fa fa-close' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { style: styles.image },
	                      _react2.default.createElement('img', { style: styles.image, src: Image, alt: '' })
	                    )
	                  );
	                }),
	                _react2.default.createElement(
	                  _reactDropzone2.default,
	                  {
	                    onDrop: this.handleDrop,
	                    className: 'image-dropzone',
	                    accept: 'image/*'
	                  },
	                  _react2.default.createElement(
	                    'div',
	                    { style: styles.dropzone },
	                    _react2.default.createElement('em', { className: 'fa fa-plus' })
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            className: 'buttonStyle',
	            onClick: this.handleSaveButtonClick,
	            style: { float: 'right' }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm' })
	        )
	      );
	    }
	  }]);
	
	  return GroupImageManageModal;
	}(_react.Component);
	
	var _default = GroupImageManageModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/GroupImageManageModal.jsx');
	
	  __REACT_HOT_LOADER__.register(GroupImageManageModal, 'GroupImageManageModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/GroupImageManageModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/GroupImageManageModal.jsx');
	}();

	;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _filter = __webpack_require__(84);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _forEach = __webpack_require__(126);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _map = __webpack_require__(55);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _rowRenderer = __webpack_require__(64);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isWIZ = _root_url.ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
	
	var propTypes = {
	  products: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  previouslySelectedProducts: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  dependentValues: _propTypes2.default.shape({
	    Selected: _propTypes2.default.bool
	  }),
	  modifyConvertableProductList: _propTypes2.default.func
	};
	
	var defaultProps = {
	  products: [],
	  previouslySelectedProducts: [],
	  dependentValues: {},
	  modifyConvertableProductList: function modifyConvertableProductList() {}
	};
	
	var LinkProductsModal = function (_Component) {
	  _inherits(LinkProductsModal, _Component);
	
	  function LinkProductsModal(props) {
	    _classCallCheck(this, LinkProductsModal);
	
	    var _this = _possibleConstructorReturn(this, (LinkProductsModal.__proto__ || Object.getPrototypeOf(LinkProductsModal)).call(this, props));
	
	    _this.selectExistingProduct = function (product) {
	      var rows = JSON.parse(JSON.stringify(_this.state.rows));
	      (0, _map2.default)(rows, function (row) {
	        if (row.ProductNum === product.ProductNum) {
	          if (!row.Selected) {
	            row.Selected = true;
	          } else {
	            row.Selected = false;
	          }
	        }
	      });
	      _this.setState({ rows: rows });
	      _this.props.modifyConvertableProductList(product);
	    };
	
	    _this.state = {
	      rows: [],
	      filters: null,
	      sortColumn: null,
	      sortDirection: null
	    };
	    return _this;
	  }
	
	  _createClass(LinkProductsModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          products = _props.products,
	          previouslySelectedProducts = _props.previouslySelectedProducts;
	
	      if (products.length > 0) {
	        var rows = products;
	        if (previouslySelectedProducts.length > 0) {
	          rows = (0, _filter2.default)(rows, function (row) {
	            return row.ProductNum !== previouslySelectedProducts[0].ProductNum;
	          });
	          (0, _forEach2.default)(previouslySelectedProducts, function (prodToSelect) {
	            (0, _map2.default)(rows, function (row) {
	              if (row.ProductNum === prodToSelect.ProductNum) {
	                row.Selected = true;
	              }
	            });
	          });
	        }
	        this.setState({ rows: rows });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this2.setState(state);
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this2.state.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        _this2.setState({ filters: newFilters });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        _this2.setState({ filters: {} });
	      };
	
	      var CheckFormatter = _react2.default.createClass({
	        displayName: 'CheckFormatter',
	        render: function render() {
	          var Selected = this.props.dependentValues.Selected;
	
	          if (Selected) {
	            return _react2.default.createElement('em', { className: 'fa fa-check' });
	          }
	          return _react2.default.createElement('div', null);
	        }
	      });
	
	      var columns = [{
	        key: 'Selected',
	        name: '',
	        resizable: true,
	        sortable: true,
	        width: 25,
	        filterable: true,
	        formatter: _react2.default.createElement(CheckFormatter, null),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'RefNum',
	        name: isWIZ ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 200
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 140
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '100%', marginTop: '5px' }, id: 'linkProductsModal-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowRenderer: _react2.default.createElement(_rowRenderer.RowRenderer, { onDoubleClick: this.selectExistingProduct }),
	              rowKey: 'ProductNum',
	              rowHeight: 25,
	              minHeight: 340,
	              onGridSort: handleGridSort,
	              onAddFilter: handleFilterChange,
	              onClearFilters: onClearFilters,
	              columns: columns,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              enableCellSelect: true
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return LinkProductsModal;
	}(_react.Component);
	
	LinkProductsModal.propTypes = propTypes;
	LinkProductsModal.defaultProps = defaultProps;
	
	var _default = LinkProductsModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isWIZ, 'isWIZ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/LinkProductsModal.jsx');
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/LinkProductsModal.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/LinkProductsModal.jsx');
	
	  __REACT_HOT_LOADER__.register(LinkProductsModal, 'LinkProductsModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/LinkProductsModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/LinkProductsModal.jsx');
	}();

	;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactDropzone = __webpack_require__(45);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _products_actions = __webpack_require__(30);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(5),
	    _require$Draggable = _require.Draggable,
	    DraggableContainer = _require$Draggable.Container,
	    RowActionsCell = _require$Draggable.RowActionsCell,
	    DropTargetRowContainer = _require$Draggable.DropTargetRowContainer,
	    Selectors = _require.Data.Selectors;
	
	var RowRenderer = DropTargetRowContainer(_reactDataGrid2.default.Row);
	
	var ThumbnailFormatter = _react2.default.createClass({
	  displayName: 'ThumbnailFormatter',
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { id: 'product-image-container' },
	      _react2.default.createElement(
	        _reactDropzone2.default,
	        {
	          onDrop: this.props.onDrop.bind(this.props.dependentValues.Index, this),
	          className: 'product-image-dropzone',
	          accept: 'image/*'
	        },
	        this.props.renderImage(this.props.dependentValues.Index),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            id: 'dropzone-button',
	            bsStyle: 'primary',
	            type: 'button'
	          },
	          _react2.default.createElement('em', { className: 'fa fa-plus' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'default-placeholder' },
	        this.props.dependentValues.Index === 0 && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'default' })
	        )
	      )
	    );
	  }
	});
	
	var propTypes = {
	  rowKey: _propTypes2.default.string,
	  productId: _propTypes2.default.number,
	  handleImageUpdated: _propTypes2.default.func
	};
	
	var defaultProps = {
	  rowKey: 'Index',
	  productId: undefined,
	  handleImageUpdated: function handleImageUpdated() {}
	};
	
	var ProductImagesTable = function (_Component) {
	  _inherits(ProductImagesTable, _Component);
	
	  function ProductImagesTable(props) {
	    _classCallCheck(this, ProductImagesTable);
	
	    var _this = _possibleConstructorReturn(this, (ProductImagesTable.__proto__ || Object.getPrototypeOf(ProductImagesTable)).call(this, props));
	
	    _this.onDrop = function (row, files) {
	      if (!files) {
	        return;
	      }
	      var reader = new FileReader();
	      reader.onload = function () {
	        var index = row.props.rowIdx;
	        var newRows = [].concat(_toConsumableArray(_this.state.rows));
	        newRows[index].ImageString = reader.result;
	        _this.setState({ rows: newRows });
	      };
	      // get the first file and convert to blob object (Blob.slice([start [, end [, contentType]]))
	      var blob = files[0].slice(0, files[0].size, files[0].type);
	      reader.readAsDataURL(blob);
	    };
	
	    _this.handleSaveImages = function () {
	      var rows = _this.state.rows.filter(function (row) {
	        var match = !(row.ImageString === undefined && row.ProductImage_id === undefined);
	        return match;
	      });
	      rows.map(function (row, index) {
	        row.IsDefault = index === 0; // Mark first image default
	        row.Order = index;
	      });
	      _this.setState({ rows: rows }, function () {
	        _this.saveImages(function () {
	          var defaultImage = _lodash2.default.find(rows, { IsDefault: true });
	          var updatedImage = defaultImage && (defaultImage.ImageString || defaultImage.MediumImage);
	          _this.props.handleImageUpdated(updatedImage);
	          _this.fetchImages();
	        });
	      });
	    };
	
	    _this.addMultiNewImages = function () {
	      var rows = _reactDataGridAddons.Data.Selectors.getRows(_this.state);
	      var newRows = [].concat(_toConsumableArray(_this.state.rows));
	
	      var inputElement = document.getElementById('imgFile');
	      if (inputElement == null) {
	        inputElement = document.createElement('input');
	      }
	      inputElement.id = 'imgFile';
	      inputElement.type = 'file';
	      inputElement.style.opacity = 0;
	      inputElement.multiple = true;
	      inputElement.onchange = function (event) {
	        event.preventDefault();
	        var files = event.target.files;
	        if (files.length == 0) {
	          return;
	        }
	        var index = rows.length;
	        var k = 0;
	        var max = 20;
	        if (index + files.length < 20) {
	          max = index + files.length;
	        }
	
	        var _loop = function _loop(i) {
	          var file = files[k];
	          k++;
	          var reader = new FileReader();
	          reader.onload = function () {
	            var row = { Index: i, ImageString: reader.result };
	            newRows.push(row);
	            _this.setState({ rows: newRows });
	          };
	          var blob = file.slice(0, file.size, file.type);
	          reader.readAsDataURL(blob);
	        };
	
	        for (var i = index; i < max; i++) {
	          _loop(i);
	        }
	      };
	      var divElement = document.getElementById('product-images-modal');
	      divElement.appendChild(inputElement);
	      inputElement.click();
	    };
	
	    _this.addNewImageRow = function (e) {
	      e.preventDefault();
	
	      var rows = _reactDataGridAddons.Data.Selectors.getRows(_this.state);
	      var maxCount = 4;
	      if (_root_url.isSY) {
	        maxCount = 12;
	      }
	      if (_root_url.isJML) {
	        maxCount = 20;
	      }
	      if (rows.length === maxCount) {
	        alert('Max of ' + maxCount + ' images!');
	        return;
	      }
	      if (_root_url.isJML) {
	        _this.addMultiNewImages();
	        return;
	      }
	      var index = rows.length;
	      var newRow = {
	        Index: index
	      };
	      rows.push(newRow);
	      _this.setState({ rows: rows });
	    };
	
	    _this.deleteRow = function () {
	      var selectedRows = _this.state.selectedRows;
	
	      if (!selectedRows || selectedRows.length === 0) {
	        alert('Select a row to delete!');
	        return;
	      }
	      var id = selectedRows[0].ProductImage_id;
	
	      if (id) {
	        _this.deleteImage(id, function () {
	          return _this.fetchImages();
	        });
	      } else {
	        var rows = [].concat(_toConsumableArray(_this.state.rows));
	        var index = _lodash2.default.findIndex(rows, { Index: selectedRows[0].Index });
	        rows.map(function (row, rowIndex) {
	          row.Index = rowIndex;
	        });
	        rows.splice(index, 1);
	        _this.setState({ rows: rows, selectedRows: [] });
	      }
	    };
	
	    _this.fetchImages = function () {
	      var handleSuccess = function handleSuccess(response) {
	        var rows = response.Images;
	        rows.map(function (row, index) {
	          row.Index = index;
	        });
	        _this.setState({
	          rows: rows,
	          isLoadingImages: false
	        });
	      };
	      var handleFailure = function handleFailure(error) {
	        alert(error);
	        _this.setState({
	          // rows: [],
	          isLoadingImages: false
	        });
	      };
	      _this.setState({
	        isLoadingImages: true
	      }, function () {
	        return (0, _products_actions.getProductImages)(_this.props.productId, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.saveImages = function (successCallback) {
	      var handleSuccess = function handleSuccess(response) {
	        _this.setState({
	          isSavingImages: false
	        }, successCallback);
	      };
	      var handleFailure = function handleFailure(error) {
	        var msg = "Error: ";
	        // if (JSON.stringify(error).length > 250) {
	        //   msg += JSON.stringify(error).substring(0, 250);
	        // } else {
	        msg += JSON.stringify(error);
	        // }
	        alert(msg);
	        _this.setState({
	          isSavingImages: false
	        });
	      };
	      _this.setState({
	        isSavingImages: true
	      }, function () {
	        return (0, _products_actions.updateProductImages)(_this.props.productId, _this.state.rows, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.deleteImage = function (imageId, successCallback) {
	      var handleSuccess = function handleSuccess(response) {
	        _this.setState({
	          isDeletingImage: false
	        }, successCallback);
	      };
	      var handleFailure = function handleFailure(error) {
	        alert(error);
	        _this.setState({
	          isDeletingImage: false
	        });
	      };
	      _this.setState({
	        isDeletingImage: true
	      }, function () {
	        return (0, _products_actions.deleteProductImages)(imageId, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.renderImage = function (index) {
	      var imageFile = _this.state.rows[index].ImageString || _this.state.rows[index].LargeImage || '/img/dummy.png';
	      return _react2.default.createElement(
	        'div',
	        { className: 'img-view' },
	        _react2.default.createElement('img', {
	          src: imageFile,
	          alt: 'Upload',
	          className: 'default-image'
	        })
	      );
	    };
	
	    _this.state = {
	      rows: [],
	      selectedRows: null,
	      sortColumn: null,
	      sortDirection: null,
	
	      isLoadingImages: false,
	      isSavingImages: false,
	      isDeletingImage: false
	    };
	    _this.addMultiNewImages = _this.addMultiNewImages.bind(_this);
	    return _this;
	  }
	
	  _createClass(ProductImagesTable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchImages();
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this2 = this;
	
	      if (this.state.isLoadingImages) {
	        return _react2.default.createElement(_spinner2.default, null);
	      }
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        // merge updated row with current row and rerender by setting state
	        var rows = getRows();
	        Object.assign(rows[e.rowIdx], e.updated);
	        _this2.setState({ rows: rows });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        _this2.setState({
	          rows: newRows, selectedRows: [rows[0].row]
	        });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = getRows();
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        _this2.setState({ rows: newRows, selectedRows: [] });
	      };
	
	      var isDraggedRowSelected = function isDraggedRowSelected(selectedRows, rowDragSource) {
	        if (selectedRows && selectedRows.length > 0) {
	          var key = _this2.props.rowKey;
	          return selectedRows.filter(function (r) {
	            return r[key] === rowDragSource.data[key];
	          }).length > 0;
	        }
	        return false;
	      };
	
	      var reorderRows = function reorderRows(e) {
	        var selectedRows = Selectors.getSelectedRowsByKey({ rowKey: _this2.props.rowKey, selectedKeys: [], rows: _this2.state.rows });
	        var draggedRows = isDraggedRowSelected(selectedRows, e.rowSource) ? selectedRows : [e.rowSource.data];
	        var undraggedRows = _this2.state.rows.filter(function (r) {
	          return draggedRows.indexOf(r) === -1;
	        });
	        var args = [e.rowTarget.idx, 0].concat(draggedRows);
	        Array.prototype.splice.apply(undraggedRows, args);
	        undraggedRows.map(function (row, index) {
	          row.Index = index;
	        });
	        _this2.setState({ rows: undraggedRows });
	      };
	
	      var columns = [{
	        key: 'Thumbnail',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'thumbnail' }),
	        resizeable: true,
	        width: 500,
	        sortable: false,
	        editable: false,
	        filterable: false,
	        formatter: _react2.default.createElement(ThumbnailFormatter, { renderImage: this.renderImage, onDrop: this.onDrop }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }];
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'images-modal', key: Math.random() },
	        _react2.default.createElement(
	          DraggableContainer,
	          null,
	          _react2.default.createElement(_reactDataGrid2.default, {
	            columns: columns,
	            enableCellSelect: true,
	            minHeight: 550,
	            rowHeight: 180,
	            headerRowHeight: 25,
	            enableRowSelect: 'single',
	            onRowUpdated: handleRowUpdated,
	            rowGetter: rowGetter,
	            rowsCount: getSize(),
	            rowActionsCell: RowActionsCell,
	            rowRenderer: _react2.default.createElement(RowRenderer, { onRowDrop: reorderRows }),
	            rowSelection: {
	              showCheckbox: true,
	              onRowsSelected: onRowsSelected,
	              onRowsDeselected: onRowsDeselected,
	              selectBy: {
	                isSelectedKey: 'isSelected'
	              }
	            }
	          })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isSavingImages = _state.isSavingImages,
	          isDeletingImage = _state.isDeletingImage;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { id: 'product-images-modal' },
	          _react2.default.createElement(
	            'div',
	            { className: 'toolbar-row' },
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              null,
	              _react2.default.createElement(_SpinnerButton2.default, {
	                bsStyle: 'success',
	                disabled: isSavingImages,
	                onClick: this.handleSaveImages,
	                loading: isSavingImages,
	                icon: 'fa-save',
	                translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	              }),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'primary',
	                  onClick: this.addNewImageRow
	                },
	                _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	              ),
	              _react2.default.createElement(_SpinnerButton2.default, {
	                bsStyle: 'danger',
	                disabled: isDeletingImage,
	                onClick: this.deleteRow,
	                loading: isDeletingImage,
	                icon: 'fa-trash',
	                translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'toolbar-desc' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_product_image_modal_desc' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: '3px', marginBottom: '3px' } },
	            _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'image_size_limit' })
	            )
	          ),
	          this.renderTable()
	        )
	      );
	    }
	  }]);
	
	  return ProductImagesTable;
	}(_react.Component);
	
	ProductImagesTable.propTypes = propTypes;
	ProductImagesTable.defaultProps = defaultProps;
	
	var _default = ProductImagesTable;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/ProductImagesTable.jsx');
	
	  __REACT_HOT_LOADER__.register(ThumbnailFormatter, 'ThumbnailFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/ProductImagesTable.jsx');
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/ProductImagesTable.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/ProductImagesTable.jsx');
	
	  __REACT_HOT_LOADER__.register(ProductImagesTable, 'ProductImagesTable', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/ProductImagesTable.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/ProductImagesTable.jsx');
	}();

	;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ProductMetaInfoModal = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	    label: {
	        float: 'right'
	    },
	    input: {
	        width: '100%'
	    },
	    row: {
	        marginBottom: '10px'
	    }
	};
	
	var ProductMetaInfoModal = exports.ProductMetaInfoModal = function (_Component) {
	    _inherits(ProductMetaInfoModal, _Component);
	
	    function ProductMetaInfoModal(props) {
	        _classCallCheck(this, ProductMetaInfoModal);
	
	        var _this = _possibleConstructorReturn(this, (ProductMetaInfoModal.__proto__ || Object.getPrototypeOf(ProductMetaInfoModal)).call(this, props));
	
	        _this.handleFieldValueChange = function (e, fieldName) {
	            e.preventDefault();
	            _this.setState(_defineProperty({}, fieldName, e.target.value));
	        };
	
	        _this.handleSaveButtonClick = function (e) {
	            e.preventDefault();
	            _this.props.handleProductMetaInfoSave(_this.state);
	        };
	
	        _this.state = _extends({}, props.meta_info);
	        return _this;
	    }
	
	    _createClass(ProductMetaInfoModal, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { style: styles.row },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 2 },
	                            _react2.default.createElement(
	                                'label',
	                                { style: styles.label },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'meta_title' }),
	                                ':'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement('input', { maxLength: '100', style: styles.input, type: 'text', value: this.state.meta_title, onChange: function onChange(e) {
	                                    return _this2.handleFieldValueChange(e, 'meta_title');
	                                } })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { style: styles.row },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 2 },
	                            _react2.default.createElement(
	                                'label',
	                                { style: styles.label },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'meta_keywords' }),
	                                ':'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 9 },
	                            _react2.default.createElement('input', { maxLength: '100', style: styles.input, type: 'text', value: this.state.meta_keywords, onChange: function onChange(e) {
	                                    return _this2.handleFieldValueChange(e, 'meta_keywords');
	                                } })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 2 },
	                            _react2.default.createElement(
	                                'label',
	                                { style: styles.label },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'meta_description' }),
	                                ':'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 9 },
	                            _react2.default.createElement('textarea', { rows: 3, maxLength: '500', style: styles.input, type: 'text', value: this.state.meta_description, onChange: function onChange(e) {
	                                    return _this2.handleFieldValueChange(e, 'meta_description');
	                                } })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                        bsStyle: 'success',
	                        className: 'buttonStyle',
	                        onClick: function onClick(event) {
	                            _this2.handleSaveButtonClick(event);
	                        },
	                        style: { float: 'right' }
	                    },
	                    _react2.default.createElement('em', { className: 'fa fa-check' }),
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm' })
	                )
	            );
	        }
	    }]);
	
	    return ProductMetaInfoModal;
	}(_react.Component);
	
	var _default = ProductMetaInfoModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(ProductMetaInfoModal, 'ProductMetaInfoModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/ProductMetaInfoModal.jsx');
	
	    __REACT_HOT_LOADER__.register(styles, 'styles', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/ProductMetaInfoModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/ProductMetaInfoModal.jsx');
	}();

	;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _filter = __webpack_require__(84);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _forEach = __webpack_require__(126);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _map = __webpack_require__(55);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _rowRenderer = __webpack_require__(64);
	
	var _root_url = __webpack_require__(9);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isJML = _root_url.ROOT_API_URL === "https://jml-scm.truckxi.com/api/";
	var isUSPride = _root_url.ROOT_API_URL === 'https://uspride-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://uspride-scm.truckxi.com/api/';
	
	var propTypes = {};
	
	var defaultProps = {};
	
	var SkusTableModal = function (_Component) {
	  _inherits(SkusTableModal, _Component);
	
	  function SkusTableModal(props) {
	    _classCallCheck(this, SkusTableModal);
	
	    var _this = _possibleConstructorReturn(this, (SkusTableModal.__proto__ || Object.getPrototypeOf(SkusTableModal)).call(this, props));
	
	    _this.refreshTable = function () {
	      var Product_id = _this.props.Product_id;
	
	      var usTemp = [];
	      if (isUSPride) {
	        _axios2.default.get(_root_url.ROOT_URL + 'v2/product/sku/?product_id=' + Product_id, { headers: { Authorization: 'Bearer ' + localStorage.getItem("token") } }).then(function (res) {
	          res.data.map(function (r) {
	            usTemp.push(r);
	          });
	          console.log("uspride", usTemp);
	          _this.setState({ rows: usTemp });
	        }, function (err) {
	          if (err.data) {
	            alert(err.data);
	          } else {
	            alert("Server issue detected, please contact admin.");
	          }
	        });
	      }
	    };
	
	    _this.uspDel = function (data) {
	      _axios2.default.delete(_root_url.ROOT_URL + 'v2/product/sku/' + data.id, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (res) {
	        // alert("SKU Deleted");
	        _this.refreshTable();
	      }, function (err) {
	        if (err.data) {
	          alert(err.data);
	        } else {
	          alert("Server issue detected, please contact admin.");
	        }
	      });
	    };
	
	    _this.addSKU = function () {
	      var Product_id = _this.props.Product_id;
	      var rows = _this.state.rows;
	
	      var newRow = {
	        name: '',
	        sku: '',
	        product: Product_id,
	        idx: Number(rows.length) + 1
	      };
	      _this.setState({
	        rows: [].concat(_toConsumableArray(_this.state.rows), [newRow])
	      });
	    };
	
	    _this.delSKU = function (idx) {
	      var rows = _this.state.rows;
	
	      rows = rows.filter(function (obj) {
	        var match = obj.idx !== idx;
	        return match;
	      });
	      rows.map(function (r, i) {
	        rows[i].idx = i + 1;
	      });
	      _this.setState({
	        rows: rows
	      });
	    };
	
	    _this.saveSKU = function () {
	      var rows = _this.state.rows;
	
	      var tempRows = [];
	      rows.map(function (r, i) {
	        if (r.name || r.sku) {
	          tempRows.push({ name: r.name, sku: r.sku });
	        }
	      });
	      var str = JSON.stringify(tempRows);
	      _this.props.updateSKU(str);
	    };
	
	    _this.state = {
	      rows: [],
	      filters: null,
	      sortColumn: null,
	      sortDirection: null
	    };
	    return _this;
	  }
	
	  _createClass(SkusTableModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var rows = JSON.parse(this.props.skus);
	      rows.map(function (r, i) {
	        rows[i].idx = i + 1;
	      });
	      this.setState({ rows: rows });
	
	      if (isUSPride) {
	        this.refreshTable();
	      }
	      // this.setState({
	      //   rows: JSON.parse(this.props.skus)
	      // })
	    }
	  }, {
	    key: 'renderExcel',
	    value: function renderExcel() {
	      var Product_id = this.props.Product_id;
	
	      var disabled = false;
	      if (!Product_id) {
	        disabled = true;
	      }
	      var exportUrl = _root_url.ROOT_URL + 'v1/product/sku_export/' + this.props.Product_id + '?Bearer=' + localStorage.getItem("token");
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          href: exportUrl,
	          disabled: disabled
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this2.setState(state);
	      };
	
	      var onClearFilters = function onClearFilters() {
	        _this2.setState({ filters: {} });
	      };
	
	      var handleRowUpdated = function handleRowUpdated(row) {
	        var newRow = _this2.state.rows;
	
	        var rows = _this2.state.rows;
	
	        var uspTemp = null;
	        if (isUSPride) {
	          if (rows && rows[row.rowIdx] && rows[row.rowIdx].id && rows[row.rowIdx].sku && rows[row.rowIdx].product) {
	            uspTemp = { name: rows[row.rowIdx].name, sku: rows[row.rowIdx].sku, product: rows[row.rowIdx].product };
	
	            setTimeout(function () {
	              _axios2.default.put(_root_url.ROOT_URL + 'v2/product/sku/' + rows[row.rowIdx].id, uspTemp, {
	                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	              }).then(function (response) {
	                setTimeout(function () {
	                  _this2.refreshTable();
	                }, 300);
	                // alert("SKU Saved");
	              }, function (err) {
	                if (err.status === 500 || err.status === 404) {
	                  err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	                }
	                alert(JSON.stringify(err.data));
	                _this2.refreshTable();
	                // row.updated = {sku: ''};
	                // newRow[row.rowIdx] = {
	                //     ...newRow[row.rowIdx],
	                //     ...row.updated,
	                //   }
	                //   this.setState({
	                //     rows: newRow,
	                //   });
	              });
	            }, 200);
	          } else if (rows && rows[row.rowIdx] && !rows[row.rowIdx].id && rows[row.rowIdx].sku && rows[row.rowIdx].product) {
	            uspTemp = { name: rows[row.rowIdx].name, sku: rows[row.rowIdx].sku, product: rows[row.rowIdx].product };
	            setTimeout(function () {
	              _axios2.default.post(_root_url.ROOT_URL + 'v2/product/sku/', uspTemp, {
	                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	              }).then(function (response) {
	                setTimeout(function () {
	                  _this2.refreshTable();
	                }, 300);
	                // alert("SKU Saved");
	              }, function (err) {
	                if (err.status === 500 || err.status === 404) {
	                  err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	                }
	                alert(JSON.stringify(err.data));
	                _this2.refreshTable();
	                // row.updated = {sku: ''};
	                // newRow[row.rowIdx] = {
	                //   ...newRow[row.rowIdx],
	                //   ...row.updated,
	                // }
	                // this.setState({
	                //   rows: newRow,
	                // });
	              });
	            }, 200);
	          } else {}
	        }
	
	        newRow[row.rowIdx] = _extends({}, newRow[row.rowIdx], row.updated);
	        _this2.setState({
	          rows: newRow
	        });
	      };
	
	      var columns = [{
	        key: 'name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	        resizable: true,
	        editable: true,
	        width: 180,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'sku',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }),
	        resizable: true,
	        editable: true,
	        width: 180,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'idx',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'operation' }),
	        resizable: true,
	        width: 90,
	        formatter: function formatter(_ref) {
	          var value = _ref.value,
	              dependentValues = _ref.dependentValues;
	          return _react2.default.createElement(
	            'div',
	            {
	              style: { width: '100%', height: '100%' }
	              // onDoubleClick={() => {
	              //   this.delSKU(value);
	              // }}
	            },
	            (dependentValues.id || !isUSPride) && _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                className: 'textAlignStyle',
	                style: { height: '23px', width: '39px', padding: '0px' },
	                onClick: function onClick() {
	                  if (isUSPride) {
	                    _this2.uspDel(dependentValues);
	                  } else {
	                    _this2.delSKU(value);
	                  }
	                }
	              },
	              'X'
	            )
	          );
	        },
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                type: 'button',
	                bsStyle: 'primary',
	                onClick: this.addSKU
	              },
	              _react2.default.createElement('em', { className: 'fa fa-plus' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add' })
	            ),
	            !isUSPride && _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                type: 'button',
	                bsStyle: 'primary',
	                onClick: this.saveSKU
	              },
	              _react2.default.createElement('em', { className: 'fa fa-save' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	            ),
	            isJML && this.renderExcel()
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '100%', marginTop: '5px' }, id: 'linkProductsModal-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'skus_table',
	              enableCellSelect: true,
	              onRowUpdated: handleRowUpdated,
	              rowHeight: 25,
	              minHeight: 250,
	              columns: columns,
	              rowGetter: rowGetter,
	              rowsCount: getSize()
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SkusTableModal;
	}(_react.Component);
	
	SkusTableModal.propTypes = propTypes;
	SkusTableModal.defaultProps = defaultProps;
	
	var _default = SkusTableModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isJML, 'isJML', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/SkusModal.jsx');
	
	  __REACT_HOT_LOADER__.register(isUSPride, 'isUSPride', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/SkusModal.jsx');
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/SkusModal.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/SkusModal.jsx');
	
	  __REACT_HOT_LOADER__.register(SkusTableModal, 'SkusTableModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/SkusModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/SkusModal.jsx');
	}();

	;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  label: {
	    // width: '100%',
	    // float: 'right',
	  },
	  input: {
	    width: '100%'
	  },
	  row: {
	    marginBottom: '10px'
	  },
	  col: {
	    padding: 0,
	    paddingRight: '0px',
	    paddingLeft: '0px'
	  }
	};
	
	var CategoryInfoModal = function (_Component) {
	  _inherits(CategoryInfoModal, _Component);
	
	  function CategoryInfoModal(props) {
	    _classCallCheck(this, CategoryInfoModal);
	
	    var _this = _possibleConstructorReturn(this, (CategoryInfoModal.__proto__ || Object.getPrototypeOf(CategoryInfoModal)).call(this, props));
	
	    _this.handleFieldValueChange = function (e, fieldName) {
	      e.preventDefault();
	      _this.setState(_defineProperty({}, fieldName, e.target.value));
	    };
	
	    _this.handleSaveButtonClick = function (e) {
	      e.preventDefault();
	      _this.props.handleConfirmClick(_this.state);
	    };
	
	    _this.state = _extends({}, props.selectedRows[0]);
	    return _this;
	  }
	
	  _createClass(CategoryInfoModal, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Panel,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'h1',
	                { style: { fontSize: '15px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category_display_info' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { style: styles.row },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 1 },
	              _react2.default.createElement(
	                'label',
	                { style: styles.label },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 5 },
	              _react2.default.createElement('input', { maxLength: '100', style: styles.input, type: 'text', value: this.state.Name, onChange: function onChange(e) {
	                  return _this2.handleFieldValueChange(e, 'Name');
	                } })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 1 },
	              _react2.default.createElement(
	                'label',
	                { style: styles.label },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'translation' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 5 },
	              _react2.default.createElement('input', { maxLength: '100', style: styles.input, type: 'text', value: this.state.Description, onChange: function onChange(e) {
	                  return _this2.handleFieldValueChange(e, 'Description');
	                } })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { style: styles.row },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 1 },
	              _react2.default.createElement(
	                'label',
	                { style: styles.label },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'key' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 5 },
	              _react2.default.createElement('input', { disabled: true, style: styles.input, type: 'text', value: this.state.Key, onChange: function onChange(e) {
	                  return _this2.handleFieldValueChange(e, 'Key');
	                } })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 1 },
	              _react2.default.createElement(
	                'label',
	                { style: styles.label },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category_description' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 11 },
	              _react2.default.createElement('textarea', { rows: 5, maxLength: '1500', style: styles.input, value: this.state.CategoryDescription, onChange: function onChange(e) {
	                  return _this2.handleFieldValueChange(e, 'CategoryDescription');
	                } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Panel,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'h1',
	                { style: { fontSize: '15px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category_meta_info' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { style: styles.row },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 1 },
	              _react2.default.createElement(
	                'label',
	                { style: styles.label },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'meta_title' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 11 },
	              _react2.default.createElement('input', { maxLength: '100', style: styles.input, type: 'text', value: this.state.MetaTitle, onChange: function onChange(e) {
	                  return _this2.handleFieldValueChange(e, 'MetaTitle');
	                } })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { style: styles.row },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 1 },
	              _react2.default.createElement(
	                'label',
	                { style: styles.label },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'meta_keywords' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 11 },
	              _react2.default.createElement('input', { maxLength: '500', style: styles.input, type: 'text', value: this.state.MetaKeywords, onChange: function onChange(e) {
	                  return _this2.handleFieldValueChange(e, 'MetaKeywords');
	                } })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 1 },
	              _react2.default.createElement(
	                'label',
	                { style: styles.label },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'meta_description' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 11 },
	              _react2.default.createElement('textarea', { rows: 3, maxLength: '500', style: styles.input, type: 'text', value: this.state.MetaDescription, onChange: function onChange(e) {
	                  return _this2.handleFieldValueChange(e, 'MetaDescription');
	                } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            className: 'buttonStyle',
	            onClick: function onClick(event) {
	              _this2.handleSaveButtonClick(event);
	            },
	            style: { float: 'right' }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm' })
	        )
	      );
	    }
	  }]);
	
	  return CategoryInfoModal;
	}(_react.Component);
	
	var _default = CategoryInfoModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/categoryInfoModal.jsx');
	
	  __REACT_HOT_LOADER__.register(CategoryInfoModal, 'CategoryInfoModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/categoryInfoModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/components/categoryInfoModal.jsx');
	}();

	;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DrayageList = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _url = __webpack_require__(20);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isKDW = _root_url.ROOT_API_URL === 'https://kdw-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://kdw-scm.truckxi.com/api/';
	
	var RowRenderer = function (_Component) {
	  _inherits(RowRenderer, _Component);
	
	  function RowRenderer() {
	    _classCallCheck(this, RowRenderer);
	
	    return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(RowRenderer, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { onDoubleClick: function onDoubleClick() {
	            _this2.props.onDoubleClick(_this2.props.row, _this2.props.field);
	          } },
	        _react2.default.createElement(_reactDataGrid2.default
	        // rowRenderer={<RowRenderer field={this.props.field}/>}
	        .Row, _extends({ ref: 'row' }, this.props))
	      );
	    }
	  }]);
	
	  return RowRenderer;
	}(_react.Component);
	
	var DrayageList = exports.DrayageList = function (_Component2) {
	  _inherits(DrayageList, _Component2);
	
	  function DrayageList() {
	    _classCallCheck(this, DrayageList);
	
	    var _this3 = _possibleConstructorReturn(this, (DrayageList.__proto__ || Object.getPrototypeOf(DrayageList)).call(this));
	
	    _this3.state = {
	      measurementUnit: {
	        rows: [],
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null
	      }
	    };
	    _this3.addDrayageList = _this3.addDrayageList.bind(_this3);
	    _this3.editDrayageList = _this3.editDrayageList.bind(_this3);
	    _this3.deleteDrayageList = _this3.deleteDrayageList.bind(_this3);
	    return _this3;
	  }
	
	  _createClass(DrayageList, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this4 = this;
	
	      var measurementUnit = this.state.measurementUnit;
	
	      measurementUnit = {
	        rows: [],
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null
	      };
	
	      _axios2.default.get(_url.MAG_DRAYAGE_LIST,
	      // this.state.magSalesOrderDetail,
	      {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        // console.log("DRAYAGELIST", response);
	        measurementUnit.rows = response.data;
	
	        measurementUnit.rows.map(function (r, index) {
	          r.Idx = index++;
	        });
	        _this4.setState({ measurementUnit: measurementUnit });
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {}
	  }, {
	    key: 'getDrayageAgain',
	    value: function getDrayageAgain() {
	      var _this5 = this;
	
	      var measurementUnit = this.state.measurementUnit;
	
	      measurementUnit = {
	        rows: [],
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null
	      };
	
	      _axios2.default.get(_url.MAG_DRAYAGE_LIST,
	      // this.state.magSalesOrderDetail,
	      {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        // console.log("DRAYAGELIST", response);
	        measurementUnit.rows = response.data;
	
	        measurementUnit.rows.map(function (r, index) {
	          r.Idx = index++;
	        });
	
	        _this5.setState({ measurementUnit: measurementUnit });
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	      });
	    }
	  }, {
	    key: 'addDrayageList',
	    value: function addDrayageList() {
	      var rows = [].concat(_toConsumableArray(this.state.measurementUnit.rows));
	      if (isKDW) {
	        rows.push({ id: 0, name: "", address: "", drayage_code: "NA", Idx: rows.length });
	      } else {
	        rows.push({ id: 0, name: "", address: "", drayage_code: "", Idx: rows.length });
	      }
	      var measurementUnit = _extends({}, this.state.measurementUnit, { rows: rows });
	      this.setState({ measurementUnit: measurementUnit });
	    }
	  }, {
	    key: 'editDrayageList',
	    value: function editDrayageList() {
	      var _this6 = this;
	
	      _axios2.default.post(_url.MAG_DRAYAGE_LIST, this.state.measurementUnit.rows, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        _this6.getDrayageAgain();
	        alert("List Saved");
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	      });
	    }
	  }, {
	    key: 'deleteDrayageList',
	    value: function deleteDrayageList(event) {
	      var _this7 = this;
	
	      event.preventDefault();
	      var drayage_id = this.state.measurementUnit.selectedRows[0].id;
	      if (drayage_id != 0) {
	        _axios2.default.delete('' + _url.MAG_DRAYAGE_LIST + drayage_id, {
	          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function () {
	          alert("Address Deleted");
	          _this7.getDrayageAgain();
	        }, function (err) {
	          if (err.status === 500 || err.status === 404) {
	            err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	          }
	          alert(JSON.stringify(err.data));
	        });
	
	        var measurementUnit = _extends({}, this.state.measurementUnit, { selectedRows: [] });
	        this.setState({ measurementUnit: measurementUnit });
	      } else {
	        var rows = [].concat(_toConsumableArray(this.state.measurementUnit.rows));
	        var index = _.findIndex(rows, { Idx: this.state.measurementUnit.selectedRows[0].Idx });
	        rows.splice(index, 1);
	        var _measurementUnit = _extends({}, this.state.measurementUnit, { rows: rows, selectedRows: [] });
	        this.setState({ measurementUnit: _measurementUnit });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      // Parameters of the react-data-grid
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this8.state.measurementUnit);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var measurementUnit = Object.assign({}, _this8.state.measurementUnit, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this8.setState({ measurementUnit: measurementUnit });
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        var rows = getRows();
	        Object.assign(rows[e.rowIdx], e.updated);
	        var measurementUnit = _extends({}, _this8.state.measurementUnit, { rows: rows });
	        _this8.setState({ measurementUnit: measurementUnit });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        var measurementUnit = _extends({}, _this8.state.measurementUnit, { rows: newRows, selectedRows: [rows[0].row] });
	        _this8.setState({ measurementUnit: measurementUnit });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = getRows();
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        var measurementUnit = _extends({}, _this8.state.measurementUnit, { rows: newRows, selectedRows: [] });
	        _this8.setState({ measurementUnit: measurementUnit });
	      };
	      // Column difinition
	
	      var columns = [{
	        key: 'name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	        resizable: true,
	        sortable: true,
	        width: 150,
	        editable: true
	        // filterRenderer: FilterByStart,
	      }, {
	        key: 'address',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' }),
	        resizable: true,
	        sortable: true,
	        width: 250,
	        editable: true
	        // filterRenderer: FilterByStart,
	      }, {
	        key: 'drayage_code',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'drayage' }),
	        resizable: true,
	        sortable: true,
	        width: 130,
	        editable: true
	      }];
	
	      if (isKDW) {
	        columns = [{
	          key: 'name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	          resizable: true,
	          sortable: true,
	          width: 200,
	          editable: true
	          // filterRenderer: FilterByStart,
	        }, {
	          key: 'address',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' }),
	          resizable: true,
	          sortable: true,
	          width: 300,
	          editable: true
	          // filterRenderer: FilterByStart,
	        }];
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { onClick: this.addDrayageList, disabled: !(0, _permissions2.default)('add_product_group') },
	            _react2.default.createElement('em', { className: 'fa fa-plus' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'success',
	              onClick: this.editDrayageList,
	              disabled: !(0, _permissions2.default)('change_product_group')
	            },
	            _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'danger',
	              className: 'buttonStyle',
	              onClick: function onClick(event) {
	                _this8.deleteDrayageList(event);
	              },
	              disabled: !this.state.measurementUnit.selectedRows || this.state.measurementUnit.selectedRows.length != 1 || !(0, _permissions2.default)('delete_product_group')
	            },
	            _react2.default.createElement('em', { className: 'fa fa-trash marginRightStyle' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { style: { maxWidth: '100%' }, id: 'MeasurementUnit-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, { rowKey: 'MeasurementUnit_id',
	                rowHeight: 25,
	                minHeight: 620,
	                onGridSort: handleGridSort,
	                enableRowSelect: 'single',
	                columns: columns,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                enableCellSelect: true,
	                onRowUpdated: handleRowUpdated,
	                rowSelection: {
	                  showCheckbox: true,
	                  onRowsSelected: onRowsSelected,
	                  onRowsDeselected: onRowsDeselected,
	                  selectBy: {
	                    isSelectedKey: 'isSelected'
	                  }
	                }
	              })
	            )
	          )
	        ),
	        _react2.default.createElement('br', null)
	      );
	    }
	  }]);
	
	  return DrayageList;
	}(_react.Component);
	
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(DrayageList, 'DrayageList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/drayageList.jsx');
	
	  __REACT_HOT_LOADER__.register(isKDW, 'isKDW', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/drayageList.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/drayageList.jsx');
	}();

	;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EditGroupForm = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _selection = __webpack_require__(21);
	
	var _inputField = __webpack_require__(16);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _packageTypes = __webpack_require__(98);
	
	var _packageTypes2 = _interopRequireDefault(_packageTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var createPackageTypesDialogStyle = {
	  width: '650px',
	  marginLeft: '-15%'
	};
	
	var RowRenderer = function (_Component) {
	  _inherits(RowRenderer, _Component);
	
	  function RowRenderer() {
	    _classCallCheck(this, RowRenderer);
	
	    return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(RowRenderer, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { onDoubleClick: function onDoubleClick() {
	            _this2.props.onDoubleClick(_this2.props.row, _this2.props.field);
	          } },
	        _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	      );
	    }
	  }]);
	
	  return RowRenderer;
	}(_react.Component);
	
	var sizeRadios = function sizeRadios(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-6 text-nowrap' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'true',
	        checked: props.input.value === true || props.input.value === "true" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_large_prod' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-6 text-nowrap' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'false',
	        checked: props.input.value === false || props.input.value === "false" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_small_prod' })
	    )
	  );
	};
	
	var EditGroupForm = exports.EditGroupForm = function (_Component2) {
	  _inherits(EditGroupForm, _Component2);
	
	  function EditGroupForm() {
	    _classCallCheck(this, EditGroupForm);
	
	    var _this3 = _possibleConstructorReturn(this, (EditGroupForm.__proto__ || Object.getPrototypeOf(EditGroupForm)).call(this));
	
	    _this3.handleSaveOnClick = function (event) {
	      var GroupNum = _this3.state.group.GroupNum;
	      var CategoryNum = _this3.state.category.CategoryNum;
	      var suggestedProdNum = _this3.state.suggestedProdNum;
	      var LastDigit = _typeof(_this3.props.LastDigit) === 'object' ? _this3.props.LastDigit.value : _this3.props.LastDigit;
	      var productId = _this3.props.productId;
	      Promise.resolve(_this3.props.saveAction(productId, '' + GroupNum + CategoryNum + suggestedProdNum + LastDigit)).then(function () {
	        Promise.resolve(_this3.props.saveCallback(productId)).then(function () {
	          _this3.props.closeG();
	        });
	      });
	    };
	
	    _this3.state = {
	      group: null,
	      category: null,
	      suggestedProdNum: null,
	      isLinked: false,
	      linkProdOpen: false,
	      products: {
	        rows: [],
	        filters: {},
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	      initial: false
	    };
	    _this3.openLinkProd = _this3.openLinkProd.bind(_this3);
	    _this3.closeLinkProd = _this3.closeLinkProd.bind(_this3);
	    _this3.selectExistingProd = _this3.selectExistingProd.bind(_this3);
	    _this3.clearFields = _this3.clearFields.bind(_this3);
	    return _this3;
	  }
	
	  _createClass(EditGroupForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.formContent) {
	        this.props.setValue('editGroupForm', 'Category', this.props.formContent.ProductCategory1_id);
	        this.props.setValue('editGroupForm', 'Group', this.props.formContent.ProductGroup_id);
	        this.props.setValue('editGroupForm', 'Name', this.props.formContent.Name);
	        this.props.setValue('editGroupForm', 'Description', this.props.formContent.Description);
	        this.props.setValue('editGroupForm', 'IsLarge', this.props.formContent.IsLarge === "false" ? false : this.props.formContent.IsLarge);
	        this.props.setValue('editGroupForm', 'LastDigit', parseInt(this.props.formContent.LastDigit));
	        this.props.setValue('editGroupForm', 'isMadePrev', this.props.formContent.isMadePrev);
	        this.props.fetchSuggestDigit(this.props.formContent.ProductNum);
	        var suggestedProdNum = this.props.formContent.suggestedProdNum;
	        var isLinked = this.props.formContent.isLinked;
	        this.setState({ suggestedProdNum: suggestedProdNum, isLinked: isLinked });
	      }
	      if (this.props.formContent && this.props.formContent.suggestedProdNum) {
	        this.setState({ initial: true });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.Group && nextProps.Group != this.props.Group) {
	        this.props.fetchGroupCategories(nextProps.Group.value || nextProps.Group);
	        var index = _lodash2.default.findIndex(this.props.groups, { ProductGroup_id: nextProps.Group.value || nextProps.Group });
	        if (index > -1) {
	          var group = _extends({}, this.props.groups[index]);
	          if (group.GroupNum.length < 2) {
	            group.GroupNum = "0" + group.GroupNum;
	          }
	          this.setState({ group: group });
	        }
	        if (this.props.Group) {
	          this.props.setValue('editGroupForm', 'Category', null);
	          this.props.setValue('editGroupForm', 'IsLarge', null);
	          this.props.setValue('editGroupForm', 'LastDigit', null);
	          this.setState({ category: null, suggestedProdNum: null, isLinked: false });
	        }
	      }
	      if (nextProps.Category && nextProps.Category != this.props.Category) {
	        var _index = _lodash2.default.findIndex(this.props.groupCategories, { ProductCategory_id: nextProps.Category.value || nextProps.Category });
	        if (_index > -1) {
	          this.setState({ category: this.props.groupCategories[_index] });
	        }
	        this.props.fetchSuggestedProdNum(this.props.groupCategories[_index].ProductCategory_id);
	        if (this.props.Category) {
	          this.props.setValue('editGroupForm', 'IsLarge', null);
	          this.props.setValue('editGroupForm', 'LastDigit', null);
	        }
	      }
	      if (nextProps.suggestedProdNumFetched !== null && nextProps.suggestedProdNumFetched != this.props.suggestedProdNumFetched) {
	        if (this.state.initial) {
	          this.setState({ initial: false });
	        } else {
	          this.setState({ suggestedProdNum: nextProps.suggestedProdNumFetched, isLinked: false });
	          this.props.setValue('editGroupForm', 'IsLarge', null);
	          this.props.setValue('editGroupForm', 'LastDigit', null);
	        }
	      }
	      if (nextProps.existingProd && nextProps.existingProd != this.props.existingProd) {
	        var products = _extends({}, this.state.products, { rows: nextProps.existingProd });
	        this.setState({ products: products });
	      }
	      if (nextProps.IsLarge && nextProps.IsLarge != this.props.IsLarge) {
	        if (nextProps.IsLarge == "false" || nextProps.IsLarge == false) {
	          this.props.setValue('editGroupForm', 'LastDigit', 1);
	          this.props.clearSuggestDigit();
	        } else {
	          if (this.state.group && this.state.category && this.state.suggestedProdNum) {
	            var prodNum = '' + this.state.group.GroupNum + this.state.category.CategoryNum + this.state.suggestedProdNum;
	            this.props.fetchSuggestDigit(prodNum);
	          }
	          if (this.props.IsLarge !== undefined) {
	            this.props.setValue('editGroupForm', 'LastDigit', null);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'clearFields',
	    value: function clearFields() {
	      this.props.setValue('editGroupForm', 'Category', null);
	      this.props.setValue('editGroupForm', 'Group', null);
	      this.props.setValue('editGroupForm', 'Name', null);
	      this.props.setValue('editGroupForm', 'Description', null);
	      this.props.setValue('editGroupForm', 'IsLarge', null);
	      this.props.setValue('editGroupForm', 'LastDigit', null);
	      this.setState({ group: null, category: null, suggestedProdNum: null, isLinked: false });
	    }
	  }, {
	    key: 'selectExistingProd',
	    value: function selectExistingProd(prod) {
	      var suggestedProdNum = prod.ProductNum.slice(4, 7);
	      this.setState({ suggestedProdNum: suggestedProdNum, isLinked: true, linkProdOpen: false });
	      this.props.setValue('editGroupForm', 'IsLarge', null);
	      this.props.setValue('editGroupForm', 'LastDigit', null);
	    }
	  }, {
	    key: 'getGroupOptions',
	    value: function getGroupOptions() {
	      var productGroupOptions = [];
	      if (this.props.groups) {
	        this.props.groups.map(function (group) {
	          productGroupOptions.push({ value: group.ProductGroup_id, label: group.Name });
	        });
	      }
	      return productGroupOptions;
	    }
	  }, {
	    key: 'getCategoryOptions',
	    value: function getCategoryOptions() {
	      var categoryOptions = [];
	      this.props.groupCategories.map(function (category) {
	        categoryOptions.push({ value: category.ProductCategory_id, label: category.Name });
	      });
	      return categoryOptions;
	    }
	  }, {
	    key: 'getLastDigitOptions',
	    value: function getLastDigitOptions() {
	      var lastDigitOptions = [{ value: 1, label: 1 }];
	      if (this.props.IsLarge && this.props.suggestDigitFetched) {
	        lastDigitOptions = [];
	        this.props.suggestDigitFetched.map(function (digit) {
	          lastDigitOptions.push({ value: digit, label: digit });
	        });
	        if (this.props.isMadePrev && this.props.LastDigit) {
	          lastDigitOptions.push({
	            value: parseInt(this.props.LastDigit),
	            label: parseInt(this.props.LastDigit)
	          });
	          lastDigitOptions.sort(function (a, b) {
	            return a.label > b.label;
	          });
	        }
	      }
	      return lastDigitOptions;
	    }
	  }, {
	    key: 'openLinkProd',
	    value: function openLinkProd() {
	      this.state.products.filters = {};
	      this.setState({ linkProdOpen: true });
	    }
	  }, {
	    key: 'closeLinkProd',
	    value: function closeLinkProd() {
	      this.setState({ linkProdOpen: false });
	    }
	  }, {
	    key: 'renderExistingProd',
	    value: function renderExistingProd() {
	      var _this4 = this;
	
	      if (this.props.existingProdIsLoading && !this.props.existingProdError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.existingProdError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.existingProdError)
	        )
	      );else {
	        // Parameters of the react-data-grid
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.products);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var products = Object.assign({}, _this4.state.products, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this4.setState({ products: products });
	        };
	
	        var handleFilterChange = function handleFilterChange(filter) {
	          var newFilters = Object.assign({}, _this4.state.products.filters);
	          if (filter.filterTerm) {
	            newFilters[filter.column.key] = filter;
	          } else {
	            delete newFilters[filter.column.key];
	          }
	          var products = _extends({}, _this4.state.products, { filters: newFilters });
	          _this4.setState({ products: products });
	        };
	
	        var onClearFilters = function onClearFilters() {
	          // all filters removed
	          var products = _extends({}, _this4.state.products, { filters: {} });
	          _this4.setState({ products: products });
	        };
	
	        // Column difinition
	        var columns = [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          filterable: true,
	          resizable: true,
	          sortable: true,
	          width: 100
	          // filterRenderer: FilterByStart,
	        }, {
	          key: 'RefNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	          filterable: true,
	          resizable: true,
	          sortable: true,
	          width: 90
	          // filterRenderer: FilterByStart,
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	          filterable: true,
	          resizable: true,
	          sortable: true,
	          width: 300
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          filterable: true,
	          resizable: true,
	          sortable: true
	        }];
	
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { style: { maxWidth: '100%', marginTop: '10px' } },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                enableCellSelect: true,
	                rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: this.selectExistingProd }),
	                rowKey: 'Product_id',
	                rowHeight: 25,
	                headerRowHeight: 45,
	                minHeight: 350,
	                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                onAddFilter: handleFilterChange,
	                onClearFilters: onClearFilters,
	                onGridSort: handleGridSort,
	                columns: columns,
	                rowGetter: rowGetter,
	                rowsCount: getSize()
	              })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var groupOptions = this.getGroupOptions();
	      var categoryOptions = this.getCategoryOptions();
	      var lastDigitOptions = this.getLastDigitOptions();
	
	      var createDialogStyle = {
	        width: '800px',
	        height: '500px',
	        marginLeft: '-15%'
	      };
	      var isLinkable = this.state.category && this.state.category.ProductCategory_id ? true : false;
	      var LastDigit = this.props.LastDigit;
	      if (_typeof(this.props.LastDigit) === 'object' && this.props.LastDigit !== null) {
	        LastDigit = this.props.LastDigit.value;
	      }
	      var ProductNum = '' + (this.state.group && this.state.group.GroupNum) + (this.state.category && this.state.category.CategoryNum) + (this.state.suggestedProdNum && this.state.suggestedProdNum) + LastDigit;
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'create-a-new-product-form', id: 'manage-products' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'product-num-header' },
	            _react2.default.createElement(
	              'label',
	              { className: 'mr-md' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' })
	            ),
	            this.state.group && _react2.default.createElement(
	              'label',
	              { className: 'prod-num-border' },
	              this.state.group.GroupNum
	            ),
	            this.state.category && _react2.default.createElement(
	              'label',
	              { className: 'prod-num-border' },
	              this.state.category.CategoryNum
	            ),
	            this.state.suggestedProdNum && _react2.default.createElement(
	              'label',
	              { className: 'prod-num-border' },
	              this.state.suggestedProdNum
	            ),
	            (LastDigit || LastDigit === 0) && _react2.default.createElement(
	              'label',
	              { className: 'prod-num-border' },
	              LastDigit
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            { className: 'product-form-navigation-1' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5' },
	                ' ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'primary' },
	                  '01'
	                ),
	                ' ',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_group' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'asteriksReq' },
	                  '*'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 1 },
	                this.state.group && this.state.group.GroupNum
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 6 },
	                _react2.default.createElement(_reduxForm.Field, { name: 'Group', component: _selection.Selection, options: groupOptions })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5' },
	                ' ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'primary' },
	                  '02'
	                ),
	                ' ',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_category' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'asteriksReq' },
	                  '*'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 1 },
	                this.state.category && this.state.category.CategoryNum
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 6 },
	                _react2.default.createElement(_reduxForm.Field, { name: 'Category', component: _selection.Selection, options: categoryOptions })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5' },
	                ' ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'primary' },
	                  '03'
	                ),
	                ' ',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_series_no' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'asteriksReq' },
	                  '*'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(_reduxForm.Field, { name: 'SeriesNum', component: _inputField.DisabledInputField, placeholder: this.state.suggestedProdNum })
	              ),
	              _react2.default.createElement(_reactBootstrap.Col, { xs: 1 }),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  { bsStyle: 'primary', disabled: !isLinkable, onClick: function onClick() {
	                      _this5.props.fetchProductsByCategory(_this5.state.category.ProductCategory_id);_this5.openLinkProd();
	                    } },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'link_existing_prod' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-1' },
	                ' ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'primary' },
	                  '04'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 7, className: 'sizeRadios' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'IsLarge', component: sizeRadios })
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'asteriksReq pAbs' },
	                '*'
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 4 },
	                _react2.default.createElement(_reduxForm.Field, { name: 'LastDigit', component: _selection.Selection, options: lastDigitOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { onClick: this.clearFields },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'clear' })
	            ),
	            _react2.default.createElement(_SpinnerButton2.default, {
	              bsStyle: 'success',
	              onClick: this.handleSaveOnClick,
	              loading: this.props.updateProductIsLoading,
	              icon: 'fa-save',
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' }),
	              disabled: !this.props.Category || !this.props.Group || !this.state.suggestedProdNum || !LastDigit && LastDigit != 0
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          { dialogStyles: createDialogStyle, isVisible: this.state.linkProdOpen, onCloseClicked: function onCloseClicked() {
	              _this5.closeLinkProd();
	            } },
	          this.renderExistingProd()
	        )
	      );
	    }
	  }]);
	
	  return EditGroupForm;
	}(_react.Component);
	
	var _default = EditGroupForm;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(EditGroupForm, 'EditGroupForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/editGroupForm.jsx');
	
	  __REACT_HOT_LOADER__.register(createPackageTypesDialogStyle, 'createPackageTypesDialogStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/editGroupForm.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/editGroupForm.jsx');
	
	  __REACT_HOT_LOADER__.register(sizeRadios, 'sizeRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/editGroupForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/editGroupForm.jsx');
	}();

	;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _isEnabled = __webpack_require__(157);
	
	var _isEnabled2 = _interopRequireDefault(_isEnabled);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupForm = function (_Component) {
	  _inherits(GroupForm, _Component);
	
	  function GroupForm() {
	    _classCallCheck(this, GroupForm);
	
	    return _possibleConstructorReturn(this, (GroupForm.__proto__ || Object.getPrototypeOf(GroupForm)).apply(this, arguments));
	  }
	
	  _createClass(GroupForm, [{
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      if (this.props.currentGroup) {
	        if (!(0, _permissions2.default)("change_product_group")) this.props.editGroup(formProps);else alert("You have no permission!");
	      } else this.props.createGroup(formProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          closeG = _props.closeG,
	          submitting = _props.submitting,
	          pristine = _props.pristine,
	          valid = _props.valid;
	
	      return _react2.default.createElement(
	        'form',
	        { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'group_name' }),
	                ' (*) '
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: 'Name', component: _inputField2.default })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: 'Description', component: _inputField2.default })
	            )
	          )
	        ),
	        _react2.default.createElement(_reduxForm.Field, { component: _isEnabled2.default, name: 'IsEnabled' }),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'button',
	          { action: 'submit', className: 'btn btn-primary buttonStyle', disabled: submitting || pristine || !valid || !(0, _permissions2.default)("add_product_group") },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-danger buttonStyle', onClick: function onClick(event) {
	              event.preventDefault();closeG();
	            } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	        ),
	        this.props.isCreating || this.props.isEditing && _react2.default.createElement(_spinner2.default, null),
	        this.props.createError && _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger marginTopStyle' },
	          JSON.stringify(this.props.createError)
	        ),
	        this.props.editError && _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger marginTopStyle' },
	          JSON.stringify(this.props.editError)
	        )
	      );
	    }
	  }]);
	
	  return GroupForm;
	}(_react.Component);
	
	var _default = GroupForm;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(GroupForm, 'GroupForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/groupForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/groupForm.jsx');
	}();

	;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(11);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _groupForm = __webpack_require__(180);
	
	var _groupForm2 = _interopRequireDefault(_groupForm);
	
	var _categories = __webpack_require__(178);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	var _category_ = __webpack_require__(606);
	
	var _category_2 = _interopRequireDefault(_category_);
	
	var _category_2_b2b = __webpack_require__(607);
	
	var _category_2_b2b2 = _interopRequireDefault(_category_2_b2b);
	
	var _packageTypes = __webpack_require__(98);
	
	var _packageTypes2 = _interopRequireDefault(_packageTypes);
	
	var _measurementUnit = __webpack_require__(611);
	
	var _measurementUnit2 = _interopRequireDefault(_measurementUnit);
	
	var _drayageList = __webpack_require__(608);
	
	var _drayageList2 = _interopRequireDefault(_drayageList);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _Category2Detail = __webpack_require__(605);
	
	var _Category2Detail2 = _interopRequireDefault(_Category2Detail);
	
	var _Category2B2BDetail = __webpack_require__(604);
	
	var _Category2B2BDetail2 = _interopRequireDefault(_Category2B2BDetail);
	
	var _ImageFormatter = __webpack_require__(73);
	
	var _ImageFormatter2 = _interopRequireDefault(_ImageFormatter);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _root_url = __webpack_require__(9);
	
	var _GroupImageManageModal = __webpack_require__(405);
	
	var _GroupImageManageModal2 = _interopRequireDefault(_GroupImageManageModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isAFG = _root_url.ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afg-scm.truckxi.com/api/';
	var isEcity = _root_url.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ctstage-scm.truckxi.com/api/';
	var isHF = _root_url.ROOT_API_URL === 'https://hfstage-erp.truckxi.com/api/' || _root_url.ROOT_URL === 'https://hfstage-erp.truckxi.com/api/';
	var isJTB = _root_url.ROOT_API_URL === 'https://jtb-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://jtb-scm.truckxi.com/api/';
	var isMAG = _root_url.ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://magna-scm.truckxi.com/api/';
	var isKDW = _root_url.ROOT_API_URL === 'https://kdw-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://kdw-scm.truckxi.com/api/';
	var isAPO = _root_url.ROOT_API_URL === 'https://admin.apoodr.com/api/' || _root_url.ROOT_URL === 'https://admin.apoodr.com/api/';
	
	var DraggableContainer = _reactDataGridAddons.Draggable.Container,
	    RowActionsCell = _reactDataGridAddons.Draggable.RowActionsCell,
	    DropTargetRowContainer = _reactDataGridAddons.Draggable.DropTargetRowContainer;
	var Selectors = _reactDataGridAddons.Data.Selectors;
	
	var RowRenderer = DropTargetRowContainer(_reactDataGrid2.default.Row);
	
	var Groups = function (_Component) {
	  _inherits(Groups, _Component);
	
	  function Groups() {
	    _classCallCheck(this, Groups);
	
	    var _this = _possibleConstructorReturn(this, (Groups.__proto__ || Object.getPrototypeOf(Groups)).call(this));
	
	    _this.handleImageManagement = function (index) {
	      _this.setState({
	        imageManagementModalVisibility: true,
	        imageManageIndex: index,
	        imageManageRow: _this.state.rows[index]
	      });
	    };
	
	    _this.closeImageManagementModal = function () {
	      _this.setState({
	        imageManagementModalVisibility: false,
	        imageManageIndex: null,
	        imageManageRow: null
	      });
	    };
	
	    _this.handleImageManageConfirm = function (data) {
	      _this.state.rows[_this.state.imageManageIndex] = data;
	      _this.setState({
	        rows: [].concat(_toConsumableArray(_this.state.rows))
	      });
	      _this.closeImageManagementModal();
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton,
	      renderCategories: true,
	      tabKey: 1,
	
	      rows: [],
	      selectedRows: null,
	      editedRows: [],
	      filters: {},
	      sortColumn: null,
	      sortDirection: null,
	      groupOpen: false,
	      imageManagementModalVisibility: false,
	      imageManageIndex: null,
	      imageManageRow: null
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.openGroup = _this.openGroup.bind(_this);
	    _this.closeGroup = _this.closeGroup.bind(_this);
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.renderImage = _this.renderImage.bind(_this);
	    return _this;
	  }
	
	  _createClass(Groups, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      window.addEventListener('resize', this.handleResize);
	      if (_root_url.isElegant) {
	        this.props.fetchGroupsElegant();
	      } else {
	        this.props.fetchGroups();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.groups && nextProps.groups != this.props.groups) {
	        var groups = nextProps.groups;
	
	        var index = 0;
	        groups.map(function (group) {
	          group.Index = index++;
	        });
	        this.setState({
	          rows: groups
	        });
	      }
	      // if successfully edited, refresh table
	      if (nextProps.multiEdited && nextProps.multiEdited != this.props.multiEdited) {
	        if (_root_url.isElegant) {
	          this.props.fetchGroupsElegant();
	        } else {
	          this.props.fetchGroups();
	        }
	        this.setState({
	          selectedRows: null,
	          editedRows: []
	        });
	      }
	      // //display success messages
	      // if (nextProps.deleteGroupSuccess) {
	      //   alert('deleted');
	      // }
	      // if (nextProps.multiEdited) {
	      //   alert('saved');
	      // }
	
	      // display error messages
	      if (nextProps.multiError && !this.props.multiError) {
	        alert(nextProps.multiError);
	      }
	      if (nextProps.deleteGroupError && !this.props.deleteGroupError) {
	        alert(nextProps.deleteGroupError);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	      this.props.clearDeleteGroupStatus();
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(row, files) {
	      var _this2 = this;
	
	      if (!files) {
	        return;
	      }
	      var reader = new FileReader();
	      reader.onload = function () {
	        var index = row.props.rowIdx;
	        var newRows = [].concat(_toConsumableArray(_this2.state.rows));
	        var editedRows = [].concat(_toConsumableArray(_this2.state.editedRows));
	        newRows[index].Image = reader.result;
	        var editedRowIndex = _lodash2.default.findIndex(editedRows, function (r) {
	          return r.Index === row.props.dependentValues.Index;
	        });
	        if (editedRowIndex === -1) {
	          editedRows.push(newRows[index]);
	        } else {
	          editedRows.splice(editedRowIndex, 1);
	          editedRows.push(newRows[index]);
	        }
	        _this2.setState({ rows: newRows, editedRows: editedRows });
	      };
	      // get the first file and convert to blob object (Blob.slice([start [, end [, contentType]]))
	      var blob = files[0].slice(0, files[0].size, files[0].type);
	      reader.readAsDataURL(blob);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({
	        tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton
	      });
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(tabKey) {
	      this.setState({ tabKey: tabKey });
	    }
	  }, {
	    key: 'updateRows',
	    value: function updateRows(e) {
	      e.preventDefault();
	      if (_root_url.isElegant) {
	        this.props.editMultiGroupsElegant(this.state.rows);
	      } else {
	        this.props.editMultiGroups(this.state.rows);
	      }
	    }
	  }, {
	    key: 'deleteGroup',
	    value: function deleteGroup(e) {
	      e.preventDefault();
	      var productGroupId = this.state.selectedRows[0].ProductGroup_id;
	      if (productGroupId) {
	        this.props.deleteGroup(productGroupId);
	      } else {
	        var rows = [].concat(_toConsumableArray(this.state.rows));
	        var editedRows = [].concat(_toConsumableArray(this.state.editedRows));
	        var index = _lodash2.default.findIndex(rows, { Index: this.state.selectedRows[0].Index });
	        rows.splice(index, 1);
	        index = _lodash2.default.findIndex(editedRows, { Index: this.state.selectedRows[0].Index });
	        editedRows.splice(index, 1);
	        this.setState({ rows: rows, editedRows: editedRows, selectedRows: [] });
	      }
	    }
	  }, {
	    key: 'openGroup',
	    value: function openGroup() {
	      this.setState({ groupOpen: true });
	    }
	  }, {
	    key: 'closeGroup',
	    value: function closeGroup() {
	      this.setState({ groupOpen: false });
	    }
	
	    // Helper function to render an icon for the stock statues of product.
	
	  }, {
	    key: 'renderIsEnabled',
	    value: function renderIsEnabled(IsEnabled) {
	      if (IsEnabled) return _react2.default.createElement(
	        'span',
	        { className: 'label label-success' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'is_enabled' })
	      );
	      return _react2.default.createElement(
	        'span',
	        { className: 'label label-danger' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disabled' })
	      );
	    }
	
	    // Set the group being selected to be currentGroup and navigate user to the edit page
	
	    // setCurrentGroup(e) {
	    //     e.preventDefault();
	    //     const currentGroup = this.state.selectedRows[0];
	    //     this.props.selectGroup(currentGroup);
	    //     this.openGroup();
	    // }
	
	  }, {
	    key: 'clickNew',
	    value: function clickNew(e) {
	      e.preventDefault();
	      this.setState({ sortColumn: null, sortDirection: null });
	      // this.props.resetCurrentGroup();
	      // this.openGroup();
	      var rows = Selectors.getRows(this.state);
	      var index = rows.length;
	      var newRow = { Name: null, Description: null, IsEnabled: true, Index: index };
	      rows.push(newRow);
	      var editedRows = [].concat(_toConsumableArray(this.state.editedRows));
	      editedRows.push(newRow);
	      this.setState({ rows: rows, editedRows: editedRows });
	    }
	  }, {
	    key: 'renderImage',
	    value: function renderImage(index) {
	      var imageFile = this.state.rows[index].Image || '/img/dummy.png';
	      return _react2.default.createElement(
	        'div',
	        { className: 'group-img-view' },
	        _react2.default.createElement('img', {
	          src: imageFile,
	          alt: 'Upload'
	        })
	      );
	    }
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this3 = this;
	
	      if (this.props.groupIsLoading && !this.props.groupError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.groupError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          this.props.groupError.message
	        )
	      );else {
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return Selectors.getRows(_this3.state);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var state = Object.assign({}, _this3.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this3.setState(state);
	        };
	
	        var handleFilterChange = function handleFilterChange(filter) {
	          var newFilters = Object.assign({}, _this3.state.filters);
	          if (filter.filterTerm) {
	            newFilters[filter.column.key] = filter;
	          } else {
	            delete newFilters[filter.column.key];
	          }
	          _this3.setState({ filters: newFilters });
	        };
	
	        // Handle the editable function
	
	        var handleRowUpdated = function handleRowUpdated(e) {
	          // merge updated row with current row and rerender by setting state
	          _this3.setState({ sortColumn: null, sortDirection: null });
	          var rows = getRows();
	          var editedRows = _this3.state.editedRows.slice(0);
	          Object.assign(rows[e.rowIdx], e.updated);
	          // if the element is already edited, remove the old one.
	          editedRows.forEach(function (element, index) {
	            if (element.Idx === rows[e.rowIdx].Index) editedRows.splice(index, 1);
	          }, _this3);
	          // push the row into the editedRows array
	          editedRows.push(rows[e.rowIdx]);
	          _this3.setState({
	            rows: rows,
	            editedRows: editedRows
	          });
	        };
	
	        // Handle the Dragable cell function
	
	        var handleCellDrag = function handleCellDrag(e) {
	          var rows = _this3.state.rows.slice(0);
	          var editedRows = _this3.state.editedRows.slice(0);
	
	          var _loop = function _loop(i) {
	            var rowToUpdate = rows[i];
	            rowToUpdate[e.cellKey] = e.value;
	            // if the element is already edited, remove the old one.
	            editedRows.forEach(function (element, index) {
	              if (element.ProductGroup_id === rowToUpdate.ProductGroup_id) editedRows.splice(index, 1);
	            }, _this3);
	            // push the row into the editedRows array
	            editedRows.push(rowToUpdate);
	          };
	
	          for (var i = e.fromRow; i <= e.toRow; i++) {
	            _loop(i);
	          }
	          _this3.setState({
	            rows: rows,
	            editedRows: editedRows
	          });
	        };
	
	        var handleDragHandleDoubleClick = function handleDragHandleDoubleClick(e) {
	          var rows = _this3.state.rows.map(function (r) {
	            return Object.assign({}, r);
	          });
	          var editedRows = _this3.state.editedRows.slice(0);
	          var column = _columns[e.Index - 1];
	          for (var i = e.rowIdx; i <= rows.length - 1; i++) {
	            var rowToUpdate = rows[i];
	            rowToUpdate[column.key] = e.rowData[column.key];
	            // if the element is already edited, remove the old one.
	            editedRows.forEach(function (element, index) {
	              if (element.ProductGroup_id === rowToUpdate.ProductGroup_id) editedRows.splice(index, 1);
	            }, _this3);
	            // push the row into the editedRows array
	            editedRows.push(rowToUpdate);
	          }
	          _this3.setState({ rows: rows });
	        };
	
	        //Custom Formatter component
	        var IsEnabledFormatter = _react2.default.createClass({
	          displayName: 'IsEnabledFormatter',
	          render: function render() {
	            var _this4 = this;
	
	            return _react2.default.createElement('input', {
	              id: 'product-group-enable',
	              type: 'checkbox',
	              value: 'true',
	              checked: this.props.value == true || this.props.value == "true",
	              onClick: function onClick() {
	                _handleIsEnabledClick(_this4.props);
	              } });
	          }
	        });
	
	        var handlePackShowParentColClick = function handlePackShowParentColClick(props) {
	          var rows = getRows();
	          var key = props.column.key;
	
	          rows[props.rowIdx][key] = !rows[props.rowIdx][key];
	          var editedRows = [].concat(_toConsumableArray(_this3.state.editedRows));
	          editedRows.map(function (row, idx) {
	            if (row.Index === rows[props.rowIdx].Index) editedRows.splice(idx, 1);
	          });
	          editedRows.push(rows[props.rowIdx]);
	          _this3.setState({ rows: rows, editedRows: editedRows });
	        };
	
	        var PackShowParentFormatter = _react2.default.createClass({
	          displayName: 'PackShowParentFormatter',
	          render: function render() {
	            var _this5 = this;
	
	            return _react2.default.createElement('input', {
	              id: 'product-group-enable-pack-show-parent',
	              type: 'checkbox',
	              value: 'true',
	              checked: this.props.value == true || this.props.value == "true",
	              onClick: function onClick() {
	                handlePackShowParentColClick(_this5.props);
	              },
	              style: { marginLeft: '25px' }
	            });
	          }
	        });
	
	        var handleEnableLaguangeChange = function handleEnableLaguangeChange(newVal, dependentValues) {
	          var currentRows = [].concat(_toConsumableArray(_this3.state.rows));
	          currentRows[dependentValues.Index].ViewableLanguages = newVal;
	          _this3.setState({
	            rows: currentRows
	          });
	        };
	
	        var EnabledLanguageFormatter = _react2.default.createClass({
	          displayName: 'EnabledLanguageFormatter',
	          render: function render() {
	            var _props = this.props,
	                value = _props.value,
	                options = _props.options,
	                dependentValues = _props.dependentValues;
	
	
	            var backupOptions = [{
	              label: 'English - EN',
	              value: 'EN'
	            }, {
	              label: 'Chinese - ZH',
	              value: 'ZH'
	            }];
	            return _react2.default.createElement(
	              'div',
	              { id: 'zInd', style: { position: 'relative', height: '82px' } },
	              _react2.default.createElement(_reactSelect2.default, {
	                matchPos: "start",
	                matchProp: 'label',
	                menuPortalTarget: document.body,
	                styles: {
	                  // Fixes the overlapping problem of the component
	                  menu: function menu(provided) {
	                    return _extends({}, provided, { zIndex: 9999 });
	                  }
	                },
	                options: options || backupOptions,
	                value: value,
	                onChange: function onChange(newVal) {
	                  return handleEnableLaguangeChange(newVal, dependentValues);
	                },
	                multi: true,
	                removeSelected: true,
	                simpleValue: true,
	                closeOnSelect: false
	              })
	            );
	          }
	        });
	
	        // const enabledLanguageFormatter = React.create
	
	        var _handleIsEnabledClick = function _handleIsEnabledClick(isEnabled) {
	          var rows = getRows();
	          var index = _lodash2.default.findIndex(rows, { Index: isEnabled.dependentValues.Index });
	          rows[index].IsEnabled = !rows[index].IsEnabled;
	          var editedRows = [].concat(_toConsumableArray(_this3.state.editedRows));
	          editedRows.map(function (row, idx) {
	            if (row.Index === rows[index].Index) editedRows.splice(idx, 1);
	          });
	          editedRows.push(rows[index]);
	          _this3.setState({ rows: rows, editedRows: editedRows });
	        };
	
	        // Handle the row select function
	
	        // const onRowSelect = rows => {
	        //     this.setState({ selectedRows: rows });
	        // }
	
	        var onRowsSelected = function onRowsSelected(rows, calledFromOtherFunction) {
	          !calledFromOtherFunction && _onRowClick(rows[0].rowIdx, rows[0].row, true);
	          var newRows = getRows();
	          newRows.map(function (r) {
	            r.isSelected = false;
	          });
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = true;
	          });
	          _this3.setState({ rows: newRows, selectedRows: [rows[0].row] });
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          var newRows = getRows();
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = false;
	          });
	          _this3.setState({ rows: newRows, selectedRows: [] });
	        };
	
	        var _onRowClick = function _onRowClick(rowIdx, row, calledFromOtherFunction) {
	          !calledFromOtherFunction && onRowsSelected([{ rowIdx: rowIdx, row: row }], true);
	          if (rowIdx > -1 && row.ProductGroup_id) {
	            _this3.props.selectGroup(row.ProductGroup_id);
	            _this3.props.fetchGroupCategories(row.ProductGroup_id);
	          }
	        };
	
	        var isDraggedRowSelected = function isDraggedRowSelected(selectedRows, rowDragSource) {
	          if (selectedRows && selectedRows.length > 0) {
	            var key = _this3.props.rowKey;
	            return selectedRows.filter(function (r) {
	              return r[key] === rowDragSource.data[key];
	            }).length > 0;
	          }
	          return false;
	        };
	
	        var reorderRows = function reorderRows(e) {
	          var selectedRows = Selectors.getSelectedRowsByKey({ rowKey: _this3.props.rowKey, selectedKeys: [], rows: _this3.state.rows });
	          var draggedRows = isDraggedRowSelected(selectedRows, e.rowSource) ? selectedRows : [e.rowSource.data];
	          var undraggedRows = _this3.state.rows.filter(function (r) {
	            return draggedRows.indexOf(r) === -1;
	          });
	          var args = [e.rowTarget.idx, 0].concat(draggedRows);
	          Array.prototype.splice.apply(undraggedRows, args);
	          undraggedRows.map(function (row, index) {
	            row.Index = index;
	          });
	          console.log(undraggedRows);
	          _this3.setState({ rows: undraggedRows });
	        };
	
	        // Column difinition
	
	        var _columns = [{
	          key: 'Group Image',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: isJTB ? "img" : "group" }),
	          resizable: true,
	          sortable: false,
	          editable: false,
	          filterable: false,
	          width: 220,
	          formatter: _react2.default.createElement(_ImageFormatter2.default, {
	            renderImage: this.renderImage,
	            onDrop: this.onDrop,
	            showImageOnly: true,
	            onImageManagement: this.handleImageManagement
	          }),
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	          resizable: true,
	          sortable: true,
	          editable: true,
	          filterable: true,
	          width: 160
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true,
	          editable: true,
	          filterable: true,
	          width: 160
	        }, {
	          key: 'IsEnabled',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          formatter: IsEnabledFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          },
	          width: 80
	        }].concat(_toConsumableArray(isEcity ? [{
	          key: 'ViewableLanguages',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enable_for_languages' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          formatter: EnabledLanguageFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          },
	          width: 280
	        }] : {}));
	
	        // if (isUSPride) {
	        //   const PackShowParentCol = {
	        //     key: 'PackShowParent',
	        //     name: <Translate value="pack_show_parent" />,
	        //     resizable: true,
	        //     sortable: true,
	        //     filterable: true,
	        //     formatter: <PackShowParentFormatter />,
	        //     getRowMetaData: (row) => row,
	        //     width: 80,
	        //   };
	        //   const enableIdx = _.findIndex(columns, { key: "IsEnabled"});
	        //   columns.splice(enableIdx, 0, PackShowParentCol);
	        // }
	
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { style: { maxWidth: '100%' }, id: 'Groups-dataGrid1' },
	              _react2.default.createElement(
	                DraggableContainer,
	                null,
	                _react2.default.createElement(_reactDataGrid2.default, {
	                  enableCellSelect: true,
	                  onGridSort: handleGridSort,
	                  onAddFilter: handleFilterChange,
	                  columns: _columns,
	                  rowGetter: rowGetter,
	                  rowsCount: getSize(),
	                  minHeight: 620,
	                  rowHeight: 120,
	                  headerRowHeight: 25,
	                  enableRowSelect: 'single',
	                  onDragHandleDoubleClick: handleDragHandleDoubleClick,
	                  onCellsDragged: handleCellDrag,
	                  onRowUpdated: handleRowUpdated,
	                  rowSelection: {
	                    showCheckbox: true,
	                    onRowsSelected: onRowsSelected,
	                    onRowsDeselected: onRowsDeselected,
	                    selectBy: {
	                      isSelectedKey: 'isSelected'
	                    }
	                  }
	                  // onRowClick={onRowClick}
	                  , rowRenderer: _react2.default.createElement(RowRenderer, { onRowDrop: reorderRows }),
	                  rowActionsCell: RowActionsCell
	                })
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'formTitle',
	    value: function formTitle() {
	      if (this.props.currentGroup) return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_group' });else return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_a_new_group' });
	    }
	  }, {
	    key: 'categoryHeader',
	    value: function categoryHeader() {
	      return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category' });
	    }
	  }, {
	    key: 'renderDetail',
	    value: function renderDetail() {
	      if (this.state.tabKey === 1) {
	        return _react2.default.createElement(
	          _reactBootstrap.Panel,
	          { header: this.categoryHeader(), className: 'category-panel' },
	          _react2.default.createElement(_reduxForm.Field, { component: _categories2.default })
	        );
	      } else if (this.state.tabKey === 2) {
	        this.props.resetCategory2Id();
	        return _react2.default.createElement(_Category2Detail2.default, null);
	      } else if (this.state.tabKey === 5) {
	        this.props.resetCategory2Id();
	        return _react2.default.createElement(_Category2B2BDetail2.default, null);
	      }
	      return _react2.default.createElement('div', null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      return (
	        //---------------
	        // Begin HTML: Create New/Edit product_groups
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: isJTB ? "customer_groups" : "product_group" })
	            )
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                _reactBootstrap.Tabs,
	                { activeKey: this.state.tabKey, justified: true, onSelect: this.handleSelect },
	                _react2.default.createElement(
	                  _reactBootstrap.Tab,
	                  { eventKey: 1, title: _react2.default.createElement(_reactReduxI18n.Translate, { value: isJTB ? "customers" : "group" }), className: 'group-tab' },
	                  _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    { className: 'group-management-table-buttons' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'primary',
	                        className: 'buttonStyle',
	                        onClick: function onClick(event) {
	                          _this6.clickNew(event);
	                        },
	                        disabled: !(0, _permissions2.default)("add_product_group")
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'success',
	                        className: 'buttonStyle',
	                        onClick: function onClick(event) {
	                          _this6.updateRows(event);
	                        },
	                        disabled: !this.state.editedRows || !(0, _permissions2.default)("change_product_group") },
	                      _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'danger',
	                        className: 'buttonStyle',
	                        onClick: function onClick(event) {
	                          _this6.deleteGroup(event);
	                        },
	                        disabled: !this.state.selectedRows || this.state.selectedRows.length != 1 || !(0, _permissions2.default)("delete_product_group")
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-trash marginRightStyle' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                    )
	                  ),
	                  this.renderTable(),
	                  _react2.default.createElement(
	                    _reactSkylight.SkyLightStateless,
	                    { isVisible: this.state.imageManagementModalVisibility, onCloseClicked: this.closeImageManagementModal, title: 'Group Images' },
	                    _react2.default.createElement(_GroupImageManageModal2.default, { row: this.state.imageManageRow, onConfirm: this.handleImageManageConfirm })
	                  ),
	                  _react2.default.createElement(
	                    _reactSkylight.SkyLightStateless,
	                    { isVisible: this.state.groupOpen, onCloseClicked: function onCloseClicked() {
	                        _this6.closeGroup();
	                      }, title: this.formTitle() },
	                    _react2.default.createElement(_groupForm2.default, { closeG: this.closeGroup })
	                  ),
	                  _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Tab,
	                  { eventKey: 2, title: isAFG || isAPO || isHF ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category_2_b2c' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category_2' }), className: 'category-2-tab' },
	                  _react2.default.createElement(_reduxForm.Field, { component: _category_2.default })
	                ),
	                (isAFG || isAPO || isHF) && _react2.default.createElement(
	                  _reactBootstrap.Tab,
	                  { eventKey: 5, title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category_2_b2b' }), className: 'category-2-b2b-tab' },
	                  _react2.default.createElement(_reduxForm.Field, { component: _category_2_b2b2.default })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Tab,
	                  { eventKey: 3, title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_size_1' }), className: 'package-type-tab' },
	                  _react2.default.createElement(_reduxForm.Field, { component: _packageTypes2.default })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Tab,
	                  { eventKey: 4, title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_size_2' }), className: 'measurement-unit-tab' },
	                  _react2.default.createElement(_reduxForm.Field, { component: _measurementUnit2.default })
	                ),
	                (isMAG || isKDW) && _react2.default.createElement(
	                  _reactBootstrap.Tab,
	                  { eventKey: 6, title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address_list' }), className: 'drayage-tab' },
	                  _react2.default.createElement(_reduxForm.Field, { component: _drayageList2.default })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              this.renderDetail()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Groups;
	}(_react.Component);
	
	Groups.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = Groups;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isAFG, 'isAFG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/groups.jsx');
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/groups.jsx');
	
	  __REACT_HOT_LOADER__.register(isHF, 'isHF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/groups.jsx');
	
	  __REACT_HOT_LOADER__.register(isJTB, 'isJTB', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/groups.jsx');
	
	  __REACT_HOT_LOADER__.register(isMAG, 'isMAG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/groups.jsx');
	
	  __REACT_HOT_LOADER__.register(isKDW, 'isKDW', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/groups.jsx');
	
	  __REACT_HOT_LOADER__.register(isAPO, 'isAPO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/groups.jsx');
	
	  __REACT_HOT_LOADER__.register(DraggableContainer, 'DraggableContainer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/groups.jsx');
	
	  __REACT_HOT_LOADER__.register(RowActionsCell, 'RowActionsCell', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/groups.jsx');
	
	  __REACT_HOT_LOADER__.register(DropTargetRowContainer, 'DropTargetRowContainer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/groups.jsx');
	
	  __REACT_HOT_LOADER__.register(Selectors, 'Selectors', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/groups.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/groups.jsx');
	
	  __REACT_HOT_LOADER__.register(Groups, 'Groups', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/groups.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/groups.jsx');
	}();

	;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MeasurementUnit = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RowRenderer = function (_Component) {
	  _inherits(RowRenderer, _Component);
	
	  function RowRenderer() {
	    _classCallCheck(this, RowRenderer);
	
	    return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(RowRenderer, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { onDoubleClick: function onDoubleClick() {
	            _this2.props.onDoubleClick(_this2.props.row, _this2.props.field);
	          } },
	        _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	      );
	    }
	  }]);
	
	  return RowRenderer;
	}(_react.Component);
	
	var MeasurementUnit = exports.MeasurementUnit = function (_Component2) {
	  _inherits(MeasurementUnit, _Component2);
	
	  function MeasurementUnit() {
	    _classCallCheck(this, MeasurementUnit);
	
	    var _this3 = _possibleConstructorReturn(this, (MeasurementUnit.__proto__ || Object.getPrototypeOf(MeasurementUnit)).call(this));
	
	    _this3.state = {
	      measurementUnit: {
	        rows: [],
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null
	      }
	    };
	    _this3.addMeasurementUnit = _this3.addMeasurementUnit.bind(_this3);
	    _this3.editMeasurementUnit = _this3.editMeasurementUnit.bind(_this3);
	    _this3.deleteMeasurementUnit = _this3.deleteMeasurementUnit.bind(_this3);
	    return _this3;
	  }
	
	  _createClass(MeasurementUnit, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.fetchMeasurementUnit();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.clearMeasurementUnitEdited();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.measurementUnitFetched && nextProps.measurementUnitFetched != this.props.measurementUnitFetched) {
	        console.log("fetched!");
	        var measurementUnitFetched = nextProps.measurementUnitFetched;
	        var index = 0;
	        measurementUnitFetched.map(function (mmUnit) {
	          mmUnit.Idx = index++;
	        });
	        var measurementUnit = _extends({}, this.state.measurementUnit, { rows: measurementUnitFetched });
	        this.setState({ measurementUnit: measurementUnit });
	      }
	      if (nextProps.measurementUnitEdited && nextProps.measurementUnitEdited != this.props.measurementUnitEdited) {
	        this.props.fetchMeasurementUnit();
	        var _measurementUnit = _extends({}, this.state.measurementUnit, { selectedRows: null });
	        this.setState({ measurementUnit: _measurementUnit });
	      }
	    }
	  }, {
	    key: 'addMeasurementUnit',
	    value: function addMeasurementUnit() {
	      var rows = [].concat(_toConsumableArray(this.state.measurementUnit.rows));
	      rows.push({ MeasureUnit_id: 0, Name: "", Description: "", Simple: "", Idx: rows.length });
	      var measurementUnit = _extends({}, this.state.measurementUnit, { rows: rows });
	      this.setState({ measurementUnit: measurementUnit });
	    }
	  }, {
	    key: 'editMeasurementUnit',
	    value: function editMeasurementUnit() {
	      this.props.editMeasurementUnit(this.state.measurementUnit.rows);
	    }
	  }, {
	    key: 'deleteMeasurementUnit',
	    value: function deleteMeasurementUnit(event) {
	      event.preventDefault();
	      var measureUnit_id = this.state.measurementUnit.selectedRows[0].MeasureUnit_id;
	      if (measureUnit_id != 0) {
	        this.props.deleteMeasurementUnit(measureUnit_id);
	        var measurementUnit = _extends({}, this.state.measurementUnit, { selectedRows: [] });
	        this.setState({ measurementUnit: measurementUnit });
	      } else {
	        var rows = [].concat(_toConsumableArray(this.state.measurementUnit.rows));
	        var index = _.findIndex(rows, { Idx: this.state.measurementUnit.selectedRows[0].Idx });
	        rows.splice(index, 1);
	        var _measurementUnit2 = _extends({}, this.state.measurementUnit, { rows: rows, selectedRows: [] });
	        this.setState({ measurementUnit: _measurementUnit2 });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      if (this.props.fetchingMeasurementUnit && !this.props.measurementUnitFetchError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.measurementUnitFetchError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.measurementUnitFetchError)
	        )
	      );else {
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.measurementUnit);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var measurementUnit = Object.assign({}, _this4.state.measurementUnit, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this4.setState({ measurementUnit: measurementUnit });
	        };
	
	        var handleRowUpdated = function handleRowUpdated(e) {
	          var rows = getRows();
	          Object.assign(rows[e.rowIdx], e.updated);
	          var measurementUnit = _extends({}, _this4.state.measurementUnit, { rows: rows });
	          _this4.setState({ measurementUnit: measurementUnit });
	          _this4.props.clearMeasurementUnitEdited();
	        };
	
	        var onRowsSelected = function onRowsSelected(rows) {
	          var newRows = getRows();
	          newRows.map(function (r) {
	            r.isSelected = false;
	          });
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = true;
	          });
	          var measurementUnit = _extends({}, _this4.state.measurementUnit, { rows: newRows, selectedRows: [rows[0].row] });
	          _this4.setState({ measurementUnit: measurementUnit });
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          var newRows = getRows();
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = false;
	          });
	          var measurementUnit = _extends({}, _this4.state.measurementUnit, { rows: newRows, selectedRows: [] });
	          _this4.setState({ measurementUnit: measurementUnit });
	        };
	        // Column difinition
	
	        var columns = [{
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          editable: true
	          // filterRenderer: FilterByStart,
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          editable: true
	          // filterRenderer: FilterByStart,
	        }, {
	          key: 'Simple',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'simple' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          editable: true
	        }];
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { onClick: this.addMeasurementUnit, disabled: !(0, _permissions2.default)('add_product_group') },
	              _react2.default.createElement('em', { className: 'fa fa-plus' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'success',
	                onClick: this.editMeasurementUnit,
	                disabled: !(0, _permissions2.default)('change_product_group')
	              },
	              _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                className: 'buttonStyle',
	                onClick: function onClick(event) {
	                  _this4.deleteMeasurementUnit(event);
	                },
	                disabled: !this.state.measurementUnit.selectedRows || this.state.measurementUnit.selectedRows.length != 1 || !(0, _permissions2.default)('delete_product_group')
	              },
	              _react2.default.createElement('em', { className: 'fa fa-trash marginRightStyle' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 12 },
	              _react2.default.createElement(
	                'div',
	                { style: { maxWidth: '100%' }, id: 'MeasurementUnit-dataGrid1' },
	                _react2.default.createElement(_reactDataGrid2.default, {
	                  rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: this.props.selectMeasurementUnit, field: this.props.field }),
	                  rowKey: 'MeasurementUnit_id',
	                  rowHeight: 25,
	                  minHeight: 620,
	                  onGridSort: handleGridSort,
	                  enableRowSelect: 'single',
	                  columns: columns,
	                  rowGetter: rowGetter,
	                  rowsCount: getSize(),
	                  enableCellSelect: true,
	                  onRowUpdated: handleRowUpdated,
	                  rowSelection: {
	                    showCheckbox: true,
	                    onRowsSelected: onRowsSelected,
	                    onRowsDeselected: onRowsDeselected,
	                    selectBy: {
	                      isSelectedKey: 'isSelected'
	                    }
	                  }
	                })
	              )
	            )
	          ),
	          _react2.default.createElement('br', null),
	          this.props.editingMeasurementUnit && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-info measure-unit-saving-info' },
	            _react2.default.createElement(
	              'span',
	              { className: '' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saving' })
	            )
	          ),
	          this.props.measurementUnitEdited && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-success measure-unit-saving-info' },
	            _react2.default.createElement(
	              'span',
	              { className: '' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saved' })
	            )
	          ),
	          this.props.measurementUnitEditError && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger measure-unit-saving-info' },
	            _react2.default.createElement(
	              'span',
	              { className: '' },
	              this.props.measurementUnitEditError
	            )
	          ),
	          this.props.deletingMeasurementUnit && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-info measure-unit-saving-info' },
	            _react2.default.createElement(
	              'span',
	              { className: '' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deleting' })
	            )
	          ),
	          this.props.deleteMeasurementUnitSuccess && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-success measure-unit-saving-info' },
	            _react2.default.createElement(
	              'span',
	              { className: '' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deleted' })
	            )
	          ),
	          this.props.deleteMeasurementUnitError && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger measure-unit-saving-info' },
	            _react2.default.createElement(
	              'span',
	              { className: '' },
	              this.props.deleteMeasurementUnitError
	            )
	          )
	        );
	      }
	    }
	  }]);
	
	  return MeasurementUnit;
	}(_react.Component);
	
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(MeasurementUnit, 'MeasurementUnit', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/measurementUnit.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/measurementUnit.jsx');
	}();

	;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PackageTypes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RowRenderer = function (_Component) {
	  _inherits(RowRenderer, _Component);
	
	  function RowRenderer() {
	    _classCallCheck(this, RowRenderer);
	
	    return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(RowRenderer, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { onDoubleClick: function onDoubleClick() {
	            _this2.props.onDoubleClick(_this2.props.row, _this2.props.field);
	          } },
	        _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	      );
	    }
	  }]);
	
	  return RowRenderer;
	}(_react.Component);
	
	var PackageTypes = exports.PackageTypes = function (_Component2) {
	  _inherits(PackageTypes, _Component2);
	
	  function PackageTypes() {
	    _classCallCheck(this, PackageTypes);
	
	    var _this3 = _possibleConstructorReturn(this, (PackageTypes.__proto__ || Object.getPrototypeOf(PackageTypes)).call(this));
	
	    _this3.state = {
	      packageTypes: {
	        rows: [],
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null
	      }
	    };
	    _this3.addPackageType = _this3.addPackageType.bind(_this3);
	    _this3.editPackageType = _this3.editPackageType.bind(_this3);
	    _this3.deletePackageType = _this3.deletePackageType.bind(_this3);
	    return _this3;
	  }
	
	  _createClass(PackageTypes, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.fetchPackageTypes();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.clearPackageTypeEdited();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.packageTypesFetched && nextProps.packageTypesFetched !== this.props.packageTypesFetched) {
	        var packageTypesFetched = nextProps.packageTypesFetched;
	
	        var index = 0;
	        packageTypesFetched.map(function (packageType) {
	          packageType.Idx = index++;
	        });
	        var packageTypes = _extends({}, this.state.packageTypes, { rows: packageTypesFetched });
	        this.setState({ packageTypes: packageTypes });
	      }
	      if (nextProps.packageTypesEdited && nextProps.packageTypesEdited !== this.props.packageTypesEdited) {
	        this.props.fetchPackageTypes();
	        var _packageTypes = _extends({}, this.state.packageTypes, { selectedRows: null });
	        this.setState({ packageTypes: _packageTypes });
	      }
	      // alert errors
	      if (nextProps.deletePackageTypesError && !this.props.deletePackageTypesError) {
	        alert(nextProps.deletePackageTypesError);
	      }
	      if (nextProps.packageTypeEditError && !this.props.packageTypeEditError) {
	        alert(nextProps.packageTypeEditError);
	      }
	    }
	  }, {
	    key: 'addPackageType',
	    value: function addPackageType() {
	      var rows = [].concat(_toConsumableArray(this.state.packageTypes.rows));
	      rows.push({ PackageType_id: 0, Name: "", Description: "", Simple: "", Idx: rows.length });
	      var packageTypes = _extends({}, this.state.packageTypes, { rows: rows });
	      this.setState({ packageTypes: packageTypes });
	    }
	  }, {
	    key: 'editPackageType',
	    value: function editPackageType() {
	      this.props.editPackageType(this.state.packageTypes.rows);
	    }
	  }, {
	    key: 'deletePackageType',
	    value: function deletePackageType(event) {
	      event.preventDefault();
	      var packageType_id = this.state.packageTypes.selectedRows[0].PackageType_id;
	      if (packageType_id != 0) {
	        this.props.deletePackageType(packageType_id);
	        var packageTypes = _extends({}, this.state.packageTypes, { selectedRows: [] });
	        this.setState({ packageTypes: packageTypes });
	      } else {
	        var rows = [].concat(_toConsumableArray(this.state.packageTypes.rows));
	        var index = _.findIndex(rows, { Idx: this.state.packageTypes.selectedRows[0].Idx });
	        rows.splice(index, 1);
	        var _packageTypes2 = _extends({}, this.state.packageTypes, { rows: rows, selectedRows: [] });
	        this.setState({ packageTypes: _packageTypes2 });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      if (this.props.fetchingPackageTypes && !this.props.packageTypeFetchError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.packageTypeFetchError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.packageTypeFetchError)
	        )
	      );else {
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.packageTypes);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var packageTypes = Object.assign({}, _this4.state.packageTypes, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this4.setState({ packageTypes: packageTypes });
	        };
	
	        var handleRowUpdated = function handleRowUpdated(e) {
	          var rows = getRows();
	          Object.assign(rows[e.rowIdx], e.updated);
	          var packageTypes = _extends({}, _this4.state.packageTypes, { rows: rows });
	          _this4.setState({ packageTypes: packageTypes });
	          _this4.props.clearPackageTypeEdited();
	        };
	
	        var onRowsSelected = function onRowsSelected(rows) {
	          var newRows = getRows();
	          newRows.map(function (r) {
	            r.isSelected = false;
	          });
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = true;
	          });
	          var packageTypes = _extends({}, _this4.state.packageTypes, { rows: newRows, selectedRows: [rows[0].row] });
	          _this4.setState({ packageTypes: packageTypes });
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          var newRows = getRows();
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = false;
	          });
	          var packageTypes = _extends({}, _this4.state.packageTypes, { rows: newRows, selectedRows: [] });
	          _this4.setState({ packageTypes: packageTypes });
	        };
	        // Column difinition
	
	        var columns = [{
	          key: 'Name',
	          name: _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'asteriksReq' },
	              '*'
	            )
	          ),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          editable: true
	          // filterRenderer: FilterByStart,
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          editable: true
	          // filterRenderer: FilterByStart,
	        }, {
	          key: 'Simple',
	          name: _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'simple' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'asteriksReq' },
	              '*'
	            )
	          ),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          editable: true
	        }];
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            { className: 'group-management-table-buttons' },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { onClick: this.addPackageType, disabled: !(0, _permissions2.default)('add_product_group') },
	              _react2.default.createElement('em', { className: 'fa fa-plus' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'success',
	                onClick: this.editPackageType,
	                disabled: !(0, _permissions2.default)('change_product_group')
	              },
	              _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                className: 'buttonStyle',
	                onClick: function onClick(event) {
	                  _this4.deletePackageType(event);
	                },
	                disabled: !this.state.packageTypes.selectedRows || this.state.packageTypes.selectedRows.length != 1 || !(0, _permissions2.default)('delete_product_group')
	              },
	              _react2.default.createElement('em', { className: 'fa fa-trash marginRightStyle' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 12 },
	              _react2.default.createElement(
	                'div',
	                { style: { maxWidth: '100%' }, id: 'PackageTypes-dataGrid1' },
	                _react2.default.createElement(_reactDataGrid2.default, {
	                  rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: this.props.selectPackageType, field: this.props.field }),
	                  rowKey: 'PackageType_id',
	                  rowHeight: 25,
	                  minHeight: 620,
	                  enableRowSelect: 'single',
	                  onGridSort: handleGridSort,
	                  columns: columns,
	                  rowGetter: rowGetter,
	                  rowsCount: getSize(),
	                  enableCellSelect: true,
	                  onRowUpdated: handleRowUpdated,
	                  rowSelection: {
	                    showCheckbox: true,
	                    onRowsSelected: onRowsSelected,
	                    onRowsDeselected: onRowsDeselected,
	                    selectBy: {
	                      isSelectedKey: 'isSelected'
	                    }
	                  }
	                })
	              )
	            )
	          ),
	          _react2.default.createElement('br', null)
	        );
	      }
	    }
	  }]);
	
	  return PackageTypes;
	}(_react.Component);
	
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PackageTypes, 'PackageTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/packageTypes.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/packageTypes.jsx');
	}();

	;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _forEach = __webpack_require__(126);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _NumberUtil = __webpack_require__(67);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _filterByStart = __webpack_require__(68);
	
	var _filterByStart2 = _interopRequireDefault(_filterByStart);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _root_url = __webpack_require__(9);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _ProdNumFormatter = __webpack_require__(259);
	
	var _ProdNumFormatter2 = _interopRequireDefault(_ProdNumFormatter);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PriceLevel = function (_Component) {
	  _inherits(PriceLevel, _Component);
	
	  function PriceLevel() {
	    _classCallCheck(this, PriceLevel);
	
	    var _this = _possibleConstructorReturn(this, (PriceLevel.__proto__ || Object.getPrototypeOf(PriceLevel)).call(this));
	
	    _this.handleProductLineDoubleClick = function (product) {
	      Promise.resolve(_this.props.selectProduct(product)).then(function () {
	        _this.context.router.push('/products/' + product.Product_id);
	      });
	    };
	
	    _this.handleSelectionChange = function (value, fieldName) {
	      _this.setState(_defineProperty({}, fieldName, value));
	    };
	
	    _this.handleSaveCalculationTypeClick = function () {
	      var handleSuccess = function handleSuccess() {
	        _this.setState({ isSavingCalculationType: false }, function () {
	          _this.closeCalculationSelectionModal();
	        });
	      };
	
	      var handleFailure = function handleFailure(error) {
	        _this.setState({ isSavingCalculationType: false }, function () {
	          alert(error);
	        });
	      };
	
	      _this.setState({ isSavingCalculationType: true }, function () {
	        _this.setState({ isSavingCalculationType: false });
	        // this.saveCalculationType(type, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.openCalculationSelectionModal = function () {
	      _this.setState({ isCalculationSelectionModalOpen: true });
	    };
	
	    _this.closeCalculationSelectionModal = function () {
	      _this.setState({ isCalculationSelectionModalOpen: false });
	    };
	
	    _this.renderCalculationSelectionModal = function () {
	      var calculationTypeOptions = [{ label: 'Cost Profit', value: 'Cost Profit' }, { label: 'Sales Profit', value: 'Sales Profit' }];
	      return _react2.default.createElement(
	        'div',
	        { className: 'price-level-calculation-type-modal' },
	        _react2.default.createElement(_GenericSelection2.default, {
	          setSelected: function setSelected(_ref) {
	            var value = _ref.value;
	            return _this.handleSelectionChange(value, 'calculationTypeSelected');
	          },
	          value: _this.state.calculationTypeSelected,
	          options: calculationTypeOptions
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'price-level-calculation-display' },
	          _react2.default.createElement(
	            'div',
	            { className: 'price-level-equation' },
	            'Price level % =',
	            _react2.default.createElement(
	              'div',
	              { className: 'price-level-equation-right-side' },
	              'Price Level $ - Ref Cost',
	              _react2.default.createElement('hr', { className: 'horizontal-division-divider' }),
	              _this.state.calculationTypeSelected === 'Cost Profit' ? _react2.default.createElement(
	                'span',
	                null,
	                'Ref Cost $'
	              ) : _react2.default.createElement(
	                'span',
	                null,
	                'Price Level $'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            className: 'calculation-type-save-button',
	            onClick: function onClick() {
	              return _this.handleSaveCalculationTypeClick();
	            },
	            disabled: _this.state.isSavingCalculationType
	          },
	          _react2.default.createElement('em', { className: 'fa fa-save' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	        )
	      );
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	      rows: [],
	      selectedRows: null,
	      editedRows: [],
	      filters: {},
	      sortColumn: null,
	      sortDirection: null,
	      currentGroup: null,
	      currentCategory: null,
	      groupExpanded: false,
	      isCalculationSelectionModalOpen: false,
	      calculationTypeSelected: 'Cost Profit',
	      isSavingCalculationType: false
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    return _this;
	  }
	
	  _createClass(PriceLevel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.resetGroupAndCategory();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      window.addEventListener('resize', this.handleResize);
	      this.props.fetchGroups();
	      // this.props.fetchPriceLevels();
	    }
	
	    // Once priceLevels are ready, reset state.
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.groups && nextProps.groups.length !== 0 && nextProps.groups !== this.props.groups) {
	        var productGroup_id = nextProps.groups[0].ProductGroup_id;
	        this.props.fetchPriceLevels('ProductGroup_id', productGroup_id);
	        this.setState({ currentGroup: productGroup_id });
	      }
	      if (nextProps.priceLevels && nextProps.priceLevels !== this.props.priceLevels) {
	        this.setState({
	          rows: nextProps.priceLevels, editedRows: []
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var productGroup_id = this.state.currentGroup;
	      var productCategory_id = this.state.currentCategory;
	      var groups = document.getElementsByName('group');
	      var i = 0;
	      for (; i < groups.length; i++) {
	        if (groups[i].id != 'g' + productGroup_id) {
	          groups[i].style.backgroundColor = null;
	        } else {
	          groups[i].style.backgroundColor = _constants.APP_COLORS['active-category-background-nav'];
	        }
	      }
	      var categories = document.getElementsByName('category');
	      // console.log('categories', categories);
	      i = 0;
	      if (categories) {
	        for (; i < categories.length; i++) {
	          if (categories[i].id !== 'c' + productCategory_id) {
	            categories[i].style.backgroundColor = null;
	          } else {
	            categories[i].style.backgroundColor = _constants.APP_COLORS['active-category-background-nav'];
	          }
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.setOriginPage('priceLevel');
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({
	        tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton
	      });
	    }
	  }, {
	    key: 'updateRows',
	    value: function updateRows(e) {
	      e.preventDefault();
	      this.props.editMultiPriceLevels(this.state.editedRows);
	    }
	  }, {
	    key: 'handleClickCategory',
	    value: function handleClickCategory(id) {
	      this.props.fetchPriceLevels('ProductCategory1_id', id);
	      this.setState({
	        currentCategory: id
	      });
	    }
	  }, {
	    key: 'handleClickGroup',
	    value: function handleClickGroup(group) {
	      var groupExpanded = this.state.groupExpanded;
	
	      if (group && this.state.currentGroup === group.ProductGroup_id) {
	        this.setState({
	          groupExpanded: !groupExpanded
	        });
	        if (!groupExpanded) {
	          this.setState({
	            currentCategory: -1
	          });
	          this.props.fetchPriceLevels('ProductGroup_id', group.ProductGroup_id);
	          this.props.fetchGroupCategories(group.ProductGroup_id);
	        }
	      } else if (group) {
	        this.setState({
	          currentGroup: group.ProductGroup_id,
	          groupExpanded: true,
	          currentCategory: -1
	        });
	        this.props.fetchPriceLevels('ProductGroup_id', group.ProductGroup_id);
	        this.props.fetchGroupCategories(group.ProductGroup_id);
	      } else {
	        this.setState({
	          currentGroup: -1,
	          currentCategory: -1
	        });
	        this.props.fetchPriceLevels('All', -1);
	      }
	    }
	  }, {
	    key: 'renderTable',
	
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    value: function renderTable() {
	      var _this2 = this;
	
	      if (this.props.isLoading && !this.props.error) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_spinner2.default, null)
	        );
	      } else if (this.props.error) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger', id: 'price-level-error' },
	            JSON.stringify(this.props.error)
	          )
	        );
	      }
	      // Parameters of the react-data-grid
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this2.setState(state);
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this2.state.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        _this2.setState({ filters: newFilters });
	      };
	
	      // Handle the editable function
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        // let rows = this.state.rows.slice(0);
	        var rows = getRows();
	        Object.assign(rows[e.rowIdx], e.updated);
	        var updatedRow = e.updated,
	            currentCellKey = e.cellKey;
	
	        var currentRow = rows[e.rowIdx];
	
	        switch (currentCellKey) {
	          case 'RefPrice':
	            (0, _forEach2.default)(_NumberUtil.priceLevelFieldsMap, function (pricePercentage, priceLevel) {
	              currentRow[priceLevel] = (0, _NumberUtil.calculatePriceLevel)(currentRow.PriceType)(currentRow[pricePercentage], updatedRow.RefPrice);
	            });
	            break;
	
	          /* currentCellKey price levels */
	          case 'PriceLv1':
	          case 'PriceLv2':
	          case 'PriceLv3':
	          case 'PriceLv4':
	          case 'PriceLv5':
	            // set updated price level
	            currentRow[currentCellKey] = +(0, _NumberUtil.getRoundingFunc)(currentRow.PriceType)(updatedRow[currentCellKey], 2);
	            // set updated price level percentage
	            currentRow[_NumberUtil.priceLevelFieldsMap[currentCellKey]] = (0, _NumberUtil.calculatePricePercentage)(currentRow[currentCellKey], currentRow.RefPrice);
	            break;
	
	          /* currentCellKey percentages */
	          case 'P1Percentage':
	          case 'P2Percentage':
	          case 'P3Percentage':
	          case 'P4Percentage':
	          case 'P5Percentage':
	            // set updated price level
	            currentRow[currentCellKey] = +(0, _NumberUtil.roundTo)(updatedRow[currentCellKey], 2);
	            // set updated price level percentage
	            currentRow[_NumberUtil.priceLevelPercentageFieldsMap[currentCellKey]] = (0, _NumberUtil.calculatePriceLevel)(currentRow.PriceType)(currentRow[currentCellKey], currentRow.RefPrice);
	            break;
	          default:
	            break;
	        }
	        // merge updated row with current row and rerender by setting state
	        var editedRows = _this2.state.editedRows.slice(0);
	        // if the element is already edited, remove the old one.
	        editedRows.forEach(function (element, index) {
	          if (element.Product_id === currentRow.Product_id) {
	            editedRows.splice(index, 1);
	          }
	        }, _this2);
	        // push the row into the editedRows array
	        editedRows.push(currentRow);
	        _this2.setState({
	          rows: rows,
	          editedRows: editedRows
	        });
	      };
	
	      // Handle the Dragable cell function
	
	      var handleCellDrag = function handleCellDrag(e) {
	        var rows = _this2.state.rows.slice(0);
	        var editedRows = _this2.state.editedRows.slice(0);
	
	        var _loop = function _loop(i) {
	          var rowToUpdate = rows[i];
	          rowToUpdate[e.cellKey] = e.value;
	          // if the element is already edited, remove the old one.
	          editedRows.forEach(function (element, index) {
	            if (element.Product_id === rowToUpdate.Product_id) {
	              editedRows.splice(index, 1);
	            }
	          }, _this2);
	          // push the row into the editedRows array
	          editedRows.push(rowToUpdate);
	        };
	
	        for (var i = e.fromRow; i <= e.toRow; i++) {
	          _loop(i);
	        }
	        _this2.setState({
	          rows: rows,
	          editedRows: editedRows
	        });
	      };
	
	      var handleDragHandleDoubleClick = function handleDragHandleDoubleClick(e) {
	        var rows = _this2.state.rows.map(function (r) {
	          return Object.assign({}, r);
	        });
	        var editedRows = _this2.state.editedRows.slice(0);
	        var column = columns[e.idx - 1];
	        for (var i = e.rowIdx; i <= rows.length - 1; i++) {
	          var rowToUpdate = rows[i];
	          rowToUpdate[column.key] = e.rowData[column.key];
	          // if the element is already edited, remove the old one.
	          editedRows.forEach(function (element, index) {
	            if (element.Product_id === rowToUpdate.Product_id) {
	              editedRows.splice(index, 1);
	            }
	          }, _this2);
	          // push the row into the editedRows array
	          editedRows.push(rowToUpdate);
	        }
	        _this2.setState({ rows: rows });
	      };
	
	      // Custom Formatter component
	      var IsEnabledFormatter = _react2.default.createClass({
	        displayName: 'IsEnabledFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            { className: 'label label-success' },
	            'Enabled'
	          );
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            'Disable'
	          );
	        }
	      });
	
	      // Handle the row select function
	
	      var onRowSelect = function onRowSelect(rows) {
	        _this2.setState({ selectedRows: rows });
	      };
	
	      // Column difinition
	
	      var columns = [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        filterRenderer: _filterByStart2.default,
	        width: 70,
	        formatter: _react2.default.createElement(_ProdNumFormatter2.default, { onDoubleClick: this.handleProductLineDoubleClick }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        filterRenderer: _filterByStart2.default
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 180
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 120
	      }, {
	        key: 'ProductCost',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_cost' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 60,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'InStockPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'avg_cost' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 60,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'LowestSalePrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lowest_sale_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        editable: true,
	        filterable: true,
	        width: 65,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'RefPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        editable: true,
	        filterable: true,
	        width: 60,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        },
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'Difference',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'difference' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 60,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'P1Percentage',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_1_%' }),
	        resizable: true,
	        sortable: true,
	        editable: true,
	        width: 60
	      }, {
	        key: 'PriceLv1',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_1' }),
	        resizable: true,
	        sortable: true,
	        editable: true,
	        filterable: true,
	        width: 60,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'P2Percentage',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_2_%' }),
	        resizable: true,
	        sortable: true,
	        editable: true,
	        filterable: true,
	        width: 60
	      }, {
	        key: 'PriceLv2',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_2' }),
	        resizable: true,
	        sortable: true,
	        editable: true,
	        filterable: true,
	        width: 60,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'P3Percentage',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_3_%' }),
	        resizable: true,
	        sortable: true,
	        editable: true,
	        filterable: true,
	        width: 60
	      }, {
	        key: 'PriceLv3',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_3' }),
	        resizable: true,
	        sortable: true,
	        editable: true,
	        filterable: true,
	        width: 60,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'P4Percentage',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_4_%' }),
	        resizable: true,
	        sortable: true,
	        editable: true,
	        filterable: true,
	        width: 60
	      }, {
	        key: 'PriceLv4',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_4' }),
	        resizable: true,
	        sortable: true,
	        editable: true,
	        filterable: true,
	        width: 60,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'P5Percentage',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_5_%' }),
	        resizable: true,
	        sortable: true,
	        editable: true,
	        filterable: true,
	        width: 60
	      }, {
	        key: 'PriceLv5',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_5' }),
	        resizable: true,
	        sortable: true,
	        editable: true,
	        filterable: true,
	        width: 60,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'Profit',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'profit_pl' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 60
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '99%' }, id: 'PriceLevel-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'Product_id',
	              rowRenderer: _react2.default.createElement(RowRenderer, null),
	              enableCellSelect: true,
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              columns: columns,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              rowHeight: 25,
	              headerRowHeight: 45,
	              minHeight: 600,
	              onDragHandleDoubleClick: handleDragHandleDoubleClick,
	              onCellsDragged: handleCellDrag,
	              onRowUpdated: handleRowUpdated,
	              onRowSelect: onRowSelect
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderCategories',
	    value: function renderCategories(group_id) {
	      var _this3 = this;
	
	      if (!this.props.groupCategories) return;
	      var groupCategories = this.props.groupCategories;
	      var description = void 0;
	      if (localStorage.getItem('lang') == 'ch') {
	        description = 'Description';
	      } else if (localStorage.getItem('lang') == 'en') {
	        description = 'Name';
	      }
	      if (this.state.currentGroup == group_id && this.state.groupExpanded) {
	        return groupCategories.map(function (category) {
	          return _react2.default.createElement(
	            'li',
	            { className: 'clickListLi', style: { color: _constants.APP_COLORS['sub-category-nav'], fontFamily: 'Arial' }, name: 'category', id: 'c' + category.ProductCategory_id, onClick: _this3.handleClickCategory.bind(_this3, category.ProductCategory_id) },
	            _react2.default.createElement(
	              'label',
	              { style: { fontWeight: 'bold' } },
	              category.CategoryNum
	            ),
	            ' ' + category[description]
	          );
	        });
	      }
	    }
	  }, {
	    key: 'renderGroups',
	    value: function renderGroups() {
	      var _this4 = this;
	
	      if (!this.props.groups) return;
	      var groups = this.props.groups;
	      return groups.map(function (group) {
	        var GroupNum = parseInt(group.GroupNum);
	        if (GroupNum < 10) GroupNum = '0' + GroupNum;
	        var description = void 0;
	        if (localStorage.getItem('lang') == 'ch') {
	          description = 'Description';
	        } else if (localStorage.getItem('lang') == 'en') {
	          description = 'Name';
	        }
	        return _react2.default.createElement(
	          _reactBootstrap.Panel,
	          { className: 'panelStyle' },
	          _react2.default.createElement(
	            'div',
	            { style: { color: _constants.APP_COLORS['category-nav'], fontFamily: 'Arial Black', cursor: 'pointer' }, name: 'group', id: 'g' + group.ProductGroup_id, onClick: _this4.handleClickGroup.bind(_this4, group, 'g' + group.ProductGroup_id) },
	            _react2.default.createElement(
	              'label',
	              { style: { fontWeight: 'bold' } },
	              GroupNum
	            ),
	            ' ',
	            ' ' + group[description]
	          ),
	          _this4.renderCategories(group.ProductGroup_id)
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var createDialogStyle = {
	        width: '650px',
	        marginLeft: '-15%'
	      };
	      var calculationSelectionModalTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price_level_calculation_type' });
	      var exportUrl = '';
	      if (this.state.currentGroup && this.state.currentGroup > -1 && this.state.currentCategory == -1) {
	        exportUrl = _root_url.ROOT_URL + 'v1/product/pricelevel/excel?ProductGroup_id=' + this.state.currentGroup + '&Bearer=' + localStorage.getItem('token');
	      } else if (this.state.currentCategory && this.state.currentCategory > -1) {
	        exportUrl = _root_url.ROOT_URL + 'v1/product/pricelevel/excel?ProductCategory1_id=' + this.state.currentCategory + '&Bearer=' + localStorage.getItem('token');
	      } else {
	        exportUrl = _root_url.ROOT_URL + 'v1/product/pricelevel/excel?&Bearer=' + localStorage.getItem('token');
	      }
	      return (
	        //---------------
	        // Begin HTML: Create New/Edit Sales Invoice
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price_level' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            { id: 'breadcrumbButtonGroup' },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'success',
	                className: 'buttonStyle',
	                onClick: function onClick(event) {
	                  _this5.updateRows(event);
	                },
	                disabled: !this.state.editedRows || !(0, _permissions2.default)('change_price_level')
	              },
	              _react2.default.createElement('em', { className: 'fa fa-save' }),
	              ' ',
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { fluid: 'true', id: 'price-management-page' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 2 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { id: 'category-nav', className: 'panelStyle', style: { overflowY: 'scroll', width: '100%' } },
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { className: 'panelStyle' },
	                    _react2.default.createElement(
	                      'div',
	                      { style: { color: _constants.APP_COLORS['category-nav'], fontWeight: 'bold', cursor: 'pointer' }, name: 'group', id: 'g-1', onClick: this.handleClickGroup.bind(this, null, '-1') },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' })
	                    )
	                  ),
	                  this.renderGroups()
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 10 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { id: 'products', className: 'position-relative' },
	                  _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    { className: 'table-buttons' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'success',
	                        className: 'export-to-excel',
	                        href: exportUrl
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-download' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'export' })
	                    )
	                  ),
	                  this.renderTable(),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 2 },
	                      this.props.multiIsEditing && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_spinner2.default, null),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'uploading' })
	                      ),
	                      this.props.multiEdited && _react2.default.createElement(
	                        'div',
	                        { className: 'alert alert-success' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saved' })
	                      ),
	                      this.props.multiError && _react2.default.createElement(
	                        'div',
	                        { className: 'alert alert-danger marginTopStyle' },
	                        this.props.multiError.detail
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                dialogStyles: createDialogStyle,
	                isVisible: this.state.isCalculationSelectionModalOpen,
	                onCloseClicked: function onCloseClicked() {
	                  _this5.closeCalculationSelectionModal();
	                },
	                title: calculationSelectionModalTitle
	              },
	              this.renderCalculationSelectionModal()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PriceLevel;
	}(_react.Component);
	
	PriceLevel.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = PriceLevel;
	exports.default = _default;
	
	var RowRenderer = function (_Component2) {
	  _inherits(RowRenderer, _Component2);
	
	  function RowRenderer() {
	    _classCallCheck(this, RowRenderer);
	
	    return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(RowRenderer, [{
	    key: 'getRowStyle',
	    value: function getRowStyle() {
	      return {
	        color: this.getRowBackground()
	      };
	    }
	  }, {
	    key: 'getRowBackground',
	    value: function getRowBackground() {
	      return this.props.row.RefPrice < this.props.row.ProductCost ? _constants.BACKGROUND_COLOR.red : 'black';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // here we are just changing the style
	      // but we could replace this with anything we liked, cards, images, etc
	      // usually though it will just be a matter of wrapping a div, and then calling back through to the grid
	      return _react2.default.createElement(
	        'div',
	        { style: this.getRowStyle() },
	        _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	      );
	    }
	  }]);
	
	  return RowRenderer;
	}(_react.Component);
	
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PriceLevel, 'PriceLevel', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/priceLevel.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/priceLevel.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/priceLevel.jsx');
	}();

	;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _map = __webpack_require__(55);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _filter = __webpack_require__(84);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _find = __webpack_require__(789);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _upperFirst = __webpack_require__(797);
	
	var _upperFirst2 = _interopRequireDefault(_upperFirst);
	
	var _lowerFirst = __webpack_require__(792);
	
	var _lowerFirst2 = _interopRequireDefault(_lowerFirst);
	
	var _reactTooltip = __webpack_require__(105);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _confirmModal = __webpack_require__(170);
	
	var _confirmModal2 = _interopRequireDefault(_confirmModal);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _MixProductAutoSuggest = __webpack_require__(254);
	
	var _MixProductAutoSuggest2 = _interopRequireDefault(_MixProductAutoSuggest);
	
	var _MixProductTypeRadios = __webpack_require__(255);
	
	var _MixProductTypeRadios2 = _interopRequireDefault(_MixProductTypeRadios);
	
	var _selection = __webpack_require__(21);
	
	var _inputField = __webpack_require__(16);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _vendorForm = __webpack_require__(99);
	
	var _vendorForm2 = _interopRequireDefault(_vendorForm);
	
	var _groupForm = __webpack_require__(180);
	
	var _groupForm2 = _interopRequireDefault(_groupForm);
	
	var _editGroupForm = __webpack_require__(609);
	
	var _editGroupForm2 = _interopRequireDefault(_editGroupForm);
	
	var _categoryForm = __webpack_require__(179);
	
	var _categoryForm2 = _interopRequireDefault(_categoryForm);
	
	var _productFormNavigation = __webpack_require__(614);
	
	var _productFormNavigation2 = _interopRequireDefault(_productFormNavigation);
	
	var _Editor = __webpack_require__(252);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _packageTypes = __webpack_require__(98);
	
	var _packageTypes2 = _interopRequireDefault(_packageTypes);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _RichTextEditor = __webpack_require__(151);
	
	var _RichTextEditor2 = _interopRequireDefault(_RichTextEditor);
	
	var _TuiEditor = __webpack_require__(262);
	
	var _TuiEditor2 = _interopRequireDefault(_TuiEditor);
	
	var _LinkProductsModal = __webpack_require__(406);
	
	var _LinkProductsModal2 = _interopRequireDefault(_LinkProductsModal);
	
	var _ProductImagesTable = __webpack_require__(407);
	
	var _ProductImagesTable2 = _interopRequireDefault(_ProductImagesTable);
	
	var _products_actions = __webpack_require__(30);
	
	var _promotions_actions = __webpack_require__(71);
	
	var _root_url = __webpack_require__(9);
	
	var _SkusModal = __webpack_require__(409);
	
	var _SkusModal2 = _interopRequireDefault(_SkusModal);
	
	var _displayCategoryModal = __webpack_require__(271);
	
	var _ProductMetaInfoModal = __webpack_require__(408);
	
	var _ProductMetaInfoModal2 = _interopRequireDefault(_ProductMetaInfoModal);
	
	var _ESLModal = __webpack_require__(404);
	
	var _ESLModal2 = _interopRequireDefault(_ESLModal);
	
	var _NumberUtil = __webpack_require__(67);
	
	var _utils = __webpack_require__(121);
	
	var _components = __webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isMyuMyu = _root_url.ROOT_API_URL === "https://mmstage-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === "https://myumyu-scm.truckxi.com/api/";
	var isEcity = _root_url.ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === "https://dev-scm.truckxi.com/api/";
	var isJML = _root_url.ROOT_API_URL === "https://jml-scm.truckxi.com/api/";
	var isHMM = _root_url.ROOT_API_URL === "https://hmm-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://hmm-scm.truckxi.com/api/";
	var isAFG = _root_url.ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afg-scm.truckxi.com/api/';
	var isWecom = _root_url.ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/';
	var isCalco = _root_url.ROOT_API_URL === 'https://calco-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://calco-stage.truckxi.com/api/';
	var isMMD = _root_url.ROOT_API_URL === 'https://mmdavis-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://mmdavis-scm.truckxi.com/api/';
	var isPTS = _root_url.ROOT_API_URL === 'https://phantoscope-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://phantoscope-scm.truckxi.com/api/';
	var isAFM = _root_url.ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afm-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://afmstage-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afmstage-scm.truckxi.com/api/';
	var isPS = _root_url.ROOT_API_URL === 'https://premiumstella-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://premiumstella-scm.truckxi.com/api/';
	var isTN = _root_url.ROOT_API_URL === "https://tn-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://tn-scm.truckxi.com/api/";
	var isAN = _root_url.ROOT_API_URL === 'https://asian-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://asian-scm.truckxi.com/api/';
	var isChinaTown = _root_url.ROOT_API_URL === 'https://erp.chinatown-supermarket.com/api/' || _root_url.ROOT_URL === 'https://erp.chinatown-supermarket.com/api/';
	var isUSPride = _root_url.ROOT_API_URL === 'https://uspride-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://uspride-scm.truckxi.com/api/';
	var isWIZ = _root_url.ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
	var isJTB = _root_url.ROOT_API_URL === 'https://jtb-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://jtb-scm.truckxi.com/api/';
	var isHF = _root_url.ROOT_API_URL === 'https://hfstage-erp.truckxi.com/api/' || _root_url.ROOT_URL === 'https://hfstage-erp.truckxi.com/api/';
	var isTQ = _root_url.ROOT_API_URL === 'https://topquality-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://topquality-scm.truckxi.com/api/';
	var isFACEX = _root_url.ROOT_API_URL === "https://facex-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://facex-scm.truckxi.com/api/";
	var isOCM = _root_url.ROOT_API_URL === 'https://ocm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ocm-scm.truckxi.com/api/';
	var isATL = _root_url.ROOT_API_URL === 'https://alton-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://alton-scm.truckxi.com/api/';
	var isRS = _root_url.ROOT_API_URL === 'https://redstone-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://redstone-scm.truckxi.com/api/';
	var isFBD = _root_url.ROOT_API_URL === 'https://fbd-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://fbd-scm.truckxi.com/api/';
	var isSW = _root_url.ROOT_API_URL === 'https://snapwise-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://snapwise-scm.truckxi.com/api/';
	var isABCFF = _root_url.ROOT_API_URL === 'https://abcff-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://abcff-scm.truckxi.com/api/';
	var isCS = _root_url.ROOT_API_URL === 'https://coastsequoia-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://coastsequoia-scm.truckxi.com/api/';
	var isLO = _root_url.ROOT_API_URL === 'https://lonni-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://lonni-scm.truckxi.com/api/';
	var isAmzey = _root_url.ROOT_API_URL === 'https://amzey-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://amzey-scm.truckxi.com/api/';
	var isAPO = _root_url.ROOT_API_URL === 'https://admin.apoodr.com/api/' || _root_url.ROOT_URL === 'https://admin.apoodr.com/api/';
	var isGS = _root_url.ROOT_API_URL === 'https://grantstone-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://grantstone-scm.truckxi.com/api/';
	
	var customizedInputStyle = { width: "100%", borderRadius: '2px', border: '1px solid black', backgroundColor: 'rgb(207,216,220)', padding: '0 6px' };
	
	var renderInputField = function renderInputField(props) {
	  var inputClass = (0, _classnames2.default)({ 'parsley-error': props.meta.touched && props.meta.error }, 'form-control');
	  return _react2.default.createElement(
	    'div',
	    null,
	    props.meta.touched && props.meta.error && _react2.default.createElement(
	      'span',
	      { className: 'parsley-error-message' },
	      props.meta.error
	    ),
	    _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { className: inputClass, type: 'text' }))
	  );
	};
	
	var renderRadios = function renderRadios(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group' },
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-4' },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: '' + props.labelName })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'true',
	        checked: props.input.value === true || props.input.value === "true" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'false',
	        checked: props.input.value === false || props.input.value === "false" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	    )
	  );
	};
	
	var Checkbox = function Checkbox(props) {
	  return _react2.default.createElement('input', _extends({}, props.input, {
	    type: 'checkbox',
	    value: !props.input.value ? "true" : "false",
	    checked: props.input.value === true || props.input.value === "true",
	    disabled: props.disabled
	  }));
	};
	
	var renderPriceTypeRadio = function renderPriceTypeRadio(props) {
	  return _react2.default.createElement(
	    _reactBootstrap.Row,
	    { style: { position: "relative", top: "1px" } },
	    _react2.default.createElement(
	      _reactBootstrap.Col,
	      { xs: 5, style: { padding: 0 } },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'weight',
	        checked: props.input.value === 'weight',
	        disabled: props.disabled
	      })),
	      _react2.default.createElement(
	        'label',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price_style_1' })
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Col,
	      { xs: 7, style: { padding: 0 } },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'unit',
	        checked: props.input.value === 'unit',
	        disabled: props.disabled
	      })),
	      _react2.default.createElement(
	        'label',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price_style_2' }),
	        ' '
	      )
	    )
	  );
	};
	
	var ConvertProductTypeRadios = function ConvertProductTypeRadios(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group' },
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_type' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-3 text-nowrap' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'Fixed',
	        checked: props.input.value === "Fixed" || props.input.value.value === "Fixed" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'per-unit' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-3 text-nowrap' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'Per-Pound',
	        checked: props.input.value === "Per-Pound" || props.input.value.value === "Per-Pound" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'per-weight' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-3 text-nowrap' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'Non-Fixed',
	        checked: props.input.value === "Non-Fixed" || props.input.value.value === "Non-Fixed" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Non-Fixed' })
	    )
	  );
	};
	
	var relatedRadios = function relatedRadios(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group' },
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-4' },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'related' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-3' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'true',
	        checked: props.input.value === true || props.input.value === "true",
	        disabled: !props.disableIsRelated
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-3' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'false',
	        checked: props.input.value === false || props.input.value == "false",
	        disabled: !props.disableIsRelated
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	    )
	  );
	};
	
	var sizeRadios = function sizeRadios(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group' },
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-4' },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'size' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-3' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'true',
	        checked: props.input.value === true || props.input.value === "true",
	        disabled: !props.disableIsLarge
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lg' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-3' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'false',
	        checked: props.input.value === false || props.input.value === "false",
	        disabled: !props.disableIsLarge
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sm' })
	    )
	  );
	};
	
	var convertNumRadios = function convertNumRadios(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group' },
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-4' },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'convert_type' }),
	      _react2.default.createElement(
	        'span',
	        { className: 'asteriksReq' },
	        '*'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-3 text-nowrap' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'weight',
	        checked: props.input.value === "weight" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_weight' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-3 text-nowrap' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'unit',
	        checked: props.input.value === "unit" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_unit' })
	    )
	  );
	};
	
	var renderSaleRadios = function renderSaleRadios(props) {
	  var titleClass = (0, _classnames2.default)('col-xs-4');
	  return _react2.default.createElement(
	    'div',
	    { id: 'stopSale', className: 'form-group' },
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-4' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'OnSale',
	        checked: props.input.value === "OnSale" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'on_sale' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-4' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'StopSale',
	        checked: props.input.value === "StopSale" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'stop_sale' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-3 pull-right' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'OnHold',
	        checked: props.input.value === "OnHold" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'on_hold' })
	    )
	  );
	};
	
	var renderConvertDetailsList = function renderConvertDetailsList(props) {
	  var fields = props.fields;
	
	  return _react2.default.createElement(
	    _reactBootstrap.Row,
	    null,
	    _react2.default.createElement(
	      _reactBootstrap.Col,
	      { xs: 12 },
	      _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          fields.map(function (Product, index) {
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { key: index, className: 'prod-qty-adjuster' },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 12 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'col-xs-2' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 3, className: 'prod-no-related' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-xs-12' },
	                          _react2.default.createElement(_reduxForm.Field, { name: Product + '.ProductNum', className: 'control-label', component: _inputField.DisabledInputField })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 4, className: 'convert-qty' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-xs-12' },
	                          _react2.default.createElement(_reduxForm.Field, { name: Product + '.PackageSize', className: 'control-label', component: _inputField.DisabledInputField })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 3, className: 'convert-qty' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-xs-12' },
	                          _react2.default.createElement(_reduxForm.Field, { name: Product + '.ProductType', className: 'control-label', component: _inputField.DisabledInputField })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	// Mix Products field array with multiple products
	var renderMixProductArrays = function renderMixProductArrays(props) {
	  var fields = props.fields,
	      suggestProduct = props.suggestProduct,
	      packageTypeOptions = props.packageTypeOptions;
	
	  return _react2.default.createElement(
	    _reactBootstrap.Row,
	    null,
	    _react2.default.createElement(
	      _reactBootstrap.Col,
	      { xs: 12 },
	      _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12, style: { textAlign: 'right', height: '25px' } },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              style: { marginBottom: '10px' },
	              bsStyle: 'primary',
	              type: 'button',
	              disabled: !suggestProduct,
	              onClick: function onClick() {
	                fields.push({ ProductName: suggestProduct.Name, ProductNum: suggestProduct.ProductNum, ProductSKU: suggestProduct.RefNum });
	              }
	            },
	            _react2.default.createElement('em', { className: 'fa fa-plus' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          !fields.length && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no_mix_product' }),
	            ' '
	          ),
	          fields.map(function (MixProduct, index) {
	            return _react2.default.createElement(
	              _reactBootstrap.Row,
	              { key: index },
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { className: 'nonbold-label-description textAlignStyle' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 4 },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: '(ref_no)' })
	                  ),
	                  _react2.default.createElement(_reactBootstrap.Col, { sm: 1 }),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 2 },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: '(num)' })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 3 },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: '(pkg_size)' })
	                  ),
	                  _react2.default.createElement(_reactBootstrap.Col, { sm: 1 })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 4 },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_reduxForm.Field, { name: MixProduct + '.ProductSKU', component: _inputField.InputField })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 1, className: 'textAlignStyle' },
	                    _react2.default.createElement('em', { className: 'fa fa-times times-sign' })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_reduxForm.Field, { name: MixProduct + '.Quantity', component: _inputField.InputField })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 3 },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 select-menu-drop-up' },
	                        _react2.default.createElement(_reduxForm.Field, { style: { textAlign: 'left' }, name: MixProduct + '.MixedUnit', component: _selection.Selection, options: packageTypeOptions })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 1, style: { position: "relative" } },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'danger',
	                        type: 'reset',
	                        onClick: function onClick() {
	                          fields.remove(index);
	                        } // remove from index
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-trash' })
	                    )
	                  )
	                )
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	// Vendors should be a field array with multiple vendors.
	var renderVendorArrays = function renderVendorArrays(props) {
	  var fields = props.fields,
	      vendorNameOptions = props.vendorNameOptions,
	      vendorNumOptions = props.vendorNumOptions;
	
	  return _react2.default.createElement(
	    _reactBootstrap.Row,
	    null,
	    _react2.default.createElement(
	      _reactBootstrap.Col,
	      { xs: 12 },
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          onClick: function onClick() {
	            fields.push({});
	          } // pushes empty child field onto the end of the array
	        },
	        _react2.default.createElement('em', { className: 'fa fa-plus' })
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          !fields.length && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no_vendor' }),
	            ' '
	          ),
	          fields.map(function (Vendor, index) {
	            return _react2.default.createElement(
	              _reactBootstrap.Row,
	              { key: index },
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'barcode_poundsign' }),
	                  ' ',
	                  index + 1
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 6 },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-3' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-9' },
	                        _react2.default.createElement(_reduxForm.Field, { name: Vendor + '.Vendor_id', component: _selection.Selection, options: vendorNameOptions })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 5 },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'col-xs-3' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'num' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-xs-9' },
	                      _react2.default.createElement(_reduxForm.Field, { name: Vendor + '.Vendor_id', component: _selection.Selection, options: vendorNumOptions })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 1, style: { position: "relative", left: "-13px" } },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'danger',
	                        type: 'reset',
	                        onClick: function onClick() {
	                          fields.remove(index);
	                        } // remove from index
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-trash' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-3' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'barcode' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-9' },
	                        _react2.default.createElement(_reduxForm.Field, { name: Vendor + '.Code', component: _inputField.InputField })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-3' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'VPN' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-9' },
	                        _react2.default.createElement(_reduxForm.Field, { name: Vendor + '.Vendor_product_num', component: _inputField.InputField })
	                      )
	                    )
	                  )
	                )
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	var submitTrue = false;
	
	var languages = [{
	  label: 'English - EN',
	  value: 'EN'
	}, {
	  label: 'Chinese - ZH',
	  value: 'ZH'
	}];
	var isSoleStage = function isSoleStage() {
	  return _root_url.ROOT_URL === "https://ss-stage.truckxi.com/api/" || _root_url.ROOT_URL === "https://solestage-scm.truckxi.com/api/";
	};
	var isBD = function isBD() {
	  return _root_url.ROOT_URL === "https://bd-stage.truckxi.com/api/" || _root_url.ROOT_URL === "https://bd-scm.truckxi.com/api/";
	};
	
	var ProductForm = function (_Component) {
	  _inherits(ProductForm, _Component);
	
	  function ProductForm() {
	    _classCallCheck(this, ProductForm);
	
	    var _this = _possibleConstructorReturn(this, (ProductForm.__proto__ || Object.getPrototypeOf(ProductForm)).call(this));
	
	    _this.ESLCheckbox = function (props) {
	      return _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'checkbox',
	        value: !props.input.value ? "true" : "false",
	        checked: props.input.value === true || props.input.value === "true",
	        disabled: props.disabled,
	        onClick: function onClick(e) {
	          return _this.handleESLCheckbox(e);
	        }
	      }));
	    };
	
	    _this.getDisplayCategories = function (id) {
	      _this.props.fetchDisplayCategories(id).then(function () {
	        if (_this.props.display_categories) {
	          // this.state.displayCategories = this.props.display_categories;
	          _this.setState({ displayCategories: _this.props.display_categories });
	        }
	      });
	    };
	
	    _this.handleOptionChange = function (changeEvent) {
	      _this.setState({ productSearchType: changeEvent.target.value });
	    };
	
	    _this.updateSKU = function (newSkus) {
	      _this.setState({
	        ProductSKU: newSkus
	      });
	      _this.closeSkusModal();
	    };
	
	    _this.openMobileDescBox = function () {
	      _this.setState({ mobileDescBoxOpen: true });
	    };
	
	    _this.openDisplayCategoryBox = function () {
	      _this.setState({ displayCategoryBoxOpen: true });
	    };
	
	    _this.openSkusModal = function () {
	      _this.setState({ skusModal: true });
	    };
	
	    _this.closeSkusModal = function () {
	      _this.setState({ skusModal: false });
	    };
	
	    _this.closeMobileDescBox = function () {
	      _this.setState({ mobileDescBoxOpen: false });
	    };
	
	    _this.closeDisplayCategoryBox = function () {
	      _this.setState({ displayCategoryBoxOpen: false });
	    };
	
	    _this.openAddConvertProducts = function () {
	      _this.setState({ addConvertProductsOpen: true });
	    };
	
	    _this.closeAddConvertProducts = function () {
	      _this.setState({ addConvertProductsOpen: false });
	    };
	
	    _this.openImageModal = function () {
	      _this.setState({ imagesModalOpen: true });
	    };
	
	    _this.closeImageModal = function () {
	      _this.setState({ imagesModalOpen: false });
	    };
	
	    _this.openProductGroupEdit = function () {
	      _this.setState({ editProductGroup: true });
	    };
	
	    _this.closeProductGroupEdit = function () {
	      _this.setState({ editProductGroup: false });
	    };
	
	    _this.openESLModal = function () {
	      _this.setState({ eslModalVisibility: true });
	    };
	
	    _this.closeESLModal = function () {
	      _this.setState({ eslModalVisibility: false });
	    };
	
	    _this.openEditRecPermission = function () /* for moving products to other groups */{
	      var editGroupFormAction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'changeGroup';
	
	      _this.setState({
	        case: 'editRecPermission',
	        editRecPermissionOpen: true,
	        editGroupFormAction: editGroupFormAction
	      });
	    };
	
	    _this.checkAuthorize = function (password) {
	      _this.props.checkPassword(password);
	    };
	
	    _this.openCheckAuthorize = function (editGroupFormAction) {
	      _this.props.clearCheckPassword();
	      _this.setState({
	        checkAuthorizeOpen: true,
	        editGroupFormAction: editGroupFormAction
	      });
	    };
	
	    _this.closeCheckAuthorize = function () {
	      _this.setState({
	        checkAuthorizeOpen: false
	      });
	    };
	
	    _this.closeEditRecPermission = function () {
	      _this.setState({ editRecPermissionOpen: false });
	    };
	
	    _this.handleFetchPromotionDetails = function (productId) {
	      var handleSuccess = function handleSuccess(response) {
	        var promotionDetails = _extends({}, _this.state.promotionDetails, { rows: response.data.promotions });
	        _this.setState({
	          promotionDetailsIsLoading: false,
	          promotionDetails: promotionDetails
	        });
	      };
	
	      var handleFailure = function handleFailure(error) {
	        _this.setState({ promotionDetailsIsLoading: false }, function () {
	          alert(JSON.stringify(error));
	        });
	      };
	
	      _this.setState({ promotionDetailsIsLoading: true }, function () {
	        (0, _promotions_actions.fetchPromoDetailsByProduct)(productId, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.handleMobileDescBoxClick = function () {
	      var handleSuccess = function handleSuccess(response) {
	        _this.setState({
	          isLoadingMobileDescBoxText: false,
	          mobileDescriptionHTML: response.data.rich_text_description
	        }, function () {
	          _this.openMobileDescBox();
	        });
	      };
	      var handleFailure = function handleFailure(err) {
	        _this.setState({ isLoadingMobileDescBoxText: false }, function () {
	          alert(JSON.stringify(err));
	        });
	      };
	      _this.setState({ isLoadingMobileDescBoxText: true }, function () {
	        (0, _products_actions.fetchMobileDescriptionBoxText)(_this.props.currentProductDetail.Product_id, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.handleDisplayCategoryBoxClick = function () {
	      _this.openDisplayCategoryBox();
	    };
	
	    _this.handleSkusClick = function () {
	      _this.openSkusModal();
	    };
	
	    _this.handleAutoConvertClick = function (product) {
	      var relatedProducts = JSON.parse(JSON.stringify(_this.state.relatedProducts));
	      (0, _map2.default)(relatedProducts, function (relatedProduct) {
	        relatedProduct.auto_convert = false;
	      });
	      relatedProducts[product.index].auto_convert = !_this.state.relatedProducts[product.index].auto_convert;
	      _this.setState({ relatedProducts: relatedProducts });
	    };
	
	    _this.handleConvertInput = function (product, e) {
	      var relatedProducts = JSON.parse(JSON.stringify(_this.state.relatedProducts));
	      relatedProducts[product.index].ConvertNum = e;
	      _this.setState({ relatedProducts: relatedProducts });
	    };
	
	    _this.handleRelatedProductDelete = function (productToRemove) {
	      var relatedProducts = JSON.parse(JSON.stringify(_this.state.relatedProducts));
	      relatedProducts = (0, _filter2.default)(relatedProducts, function (product) {
	        return product.index !== productToRemove.index;
	      });
	      (0, _map2.default)(relatedProducts, function (product, index) {
	        product.index = index;
	      });
	      _this.setState({ relatedProducts: relatedProducts });
	    };
	
	    _this.handleAddConvertProductClick = function () {
	      var handleSuccess = function handleSuccess(response) {
	        _this.setState({
	          isLoadingCategoryProducts: false,
	          categoryProducts: response.data
	        }, _this.openAddConvertProducts);
	      };
	
	      var handleFailure = function handleFailure(error) {
	        _this.setState({ isLoadingCategoryProducts: false });
	        alert(JSON.stringify(error));
	      };
	
	      var currentProductDetail = _this.props.currentProductDetail;
	      var productNavigation_1 = _this.state.productNavigation_1;
	
	      if (currentProductDetail && currentProductDetail.ProductCategory1_id || productNavigation_1 && productNavigation_1.ProductCategory1_id.value) {
	        _this.setState({ isLoadingCategoryProducts: true }, function () {
	          var productCategoryId = currentProductDetail ? currentProductDetail.ProductCategory1_id : productNavigation_1.ProductCategory1_id.value;
	          _this.props.fetchProductsByCategory(productCategoryId, handleSuccess, handleFailure, true);
	        });
	      }
	    };
	
	    _this.modifyConvertableProductList = function (product) {
	      var relatedProducts = JSON.parse(JSON.stringify(_this.state.relatedProducts));
	      var existingProduct = (0, _find2.default)(_this.state.relatedProducts, function (relatedProduct) {
	        return relatedProduct.ProductNum === product.ProductNum;
	      });
	      if (existingProduct) {
	        relatedProducts = (0, _filter2.default)(relatedProducts, function (relatedProduct) {
	          return relatedProduct.ProductNum !== existingProduct.ProductNum;
	        });
	      } else {
	        var newProduct = isATL || isCS || isAmzey || isAPO || isUSPride ? {
	          PackageSize: product.PackageSize,
	          ProductType: product.ProductType,
	          ProductNum: product.ProductNum,
	          RefNum: product.RefNum,
	          Product_id: product.Product_id,
	          auto_convert: false,
	          ConvertNum: 1,
	          index: relatedProducts.length
	        } : {
	          PackageSize: product.PackageSize,
	          ProductType: product.ProductType,
	          ProductNum: product.ProductNum,
	          Product_id: product.Product_id,
	          auto_convert: false,
	          index: relatedProducts.length
	        };
	        relatedProducts.push(newProduct);
	      }
	      _this.setState({ relatedProducts: relatedProducts });
	    };
	
	    _this.getCustomerOptions = function () {
	      var customerList = _this.state.customerList;
	
	      var customerOptions = [{ value: 'All', label: 'All' }];
	      (0, _map2.default)(customerList, function (customer) {
	        var option = { value: customer.Name, label: customer.Name };
	        customerOptions.push(option);
	      });
	      return customerOptions;
	    };
	
	    _this.setStartDate = function (e) {
	      if (_this.state.endDateSelected && e > _this.state.endDateSelected) {
	        alert(_reactReduxI18n.I18n.t('please_select_an_end_date_that_is_after_the_start_date'));
	        return;
	      }
	      _this.setState({ startDateSelected: e });
	    };
	
	    _this.setEndDate = function (e) {
	      if (_this.state.startDateSelected && e < _this.state.startDateSelected) {
	        alert(_reactReduxI18n.I18n.t('please_select_a_start_date_that_is_before_the_end_date'));
	        return;
	      }
	      _this.setState({ endDateSelected: e });
	    };
	
	    _this.openDeletePromotion = function (promotionToDeleteId) {
	      _this.setState({ deletePromotionOpen: true, promotionToDeleteId: promotionToDeleteId });
	    };
	
	    _this.closeDeletePromotion = function () {
	      _this.setState({ deletePromotionOpen: false });
	    };
	
	    _this.openEditPromotion = function () {
	      _this.setState({ editPromotionOpen: true });
	    };
	
	    _this.closeEditPromotion = function (refresh) {
	      _this.setState({ editPromotionOpen: false }, function () {
	        if (refresh) {
	          _this.handleFetchPromotionDetails(_this.state.Product_id);
	        }
	      });
	    };
	
	    _this.handleSelectionChange = function (value, fieldName) {
	      _this.setState(_defineProperty({}, fieldName, value));
	    };
	
	    _this.handleTextInputChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    };
	
	    _this.handleDiscountButtonClick = function (discountType) {
	      _this.setState({ discountType: discountType });
	    };
	
	    _this.handleTabSelect = function (key) {
	      if (_this.state.isLoadingSavePromotion) {
	        return;
	      }
	      var rows = (0, _filter2.default)(_this.state.promotions, function (row) {
	        return row.Method === key;
	      });
	      var promotionsTableData = _extends({}, _this.state.promotionsTableData, { rows: rows });
	      _this.setState({ tabsKey: key, promotionsTableData: promotionsTableData });
	    };
	
	    _this.handleSavePromotion = function () {
	      var handleSuccess = function handleSuccess() {
	        _this.setState({
	          isLoadingSavePromotion: false,
	          startDateSelected: undefined,
	          endDateSelected: undefined,
	          customerGroupSelected: '',
	          paymentTypeSelected: ''
	        }, function () {
	          var state = (0, _utils.clearForm)(_this.state);
	          _this.handleFetchPromotionDetails(_this.state.Product_id);
	          _this.setState(state);
	          _this.setState({
	            selectedProduct: {
	              currentPackageSize: _this.props.currentProductDetail.PackageSize,
	              currentProdId: _this.props.currentProductDetail.Product_id,
	              currentProdName: _this.props.currentProductDetail.Name,
	              currentProdNum: _this.props.currentProductDetail.ProductNum,
	              currentProductCRV: _this.props.currentProductDetail.CRV,
	              currentProductDescription: _this.props.currentProductDetail.Description,
	              currentProductWeight: _this.props.currentProductDetail.NetWeight,
	              currentRefNum: _this.props.currentProductDetail.RefNum,
	              currentRefPrice: _this.props.currentProductDetail.RefPrice,
	              netWeight: _this.props.currentProductDetail.NetWeight
	            }
	          });
	        });
	      };
	      var handleFailure = function handleFailure(error) {
	        _this.setState({ isLoadingSavePromotion: false });
	        alert(JSON.stringify(error));
	      };
	      var promotionLine = void 0;
	      switch (_this.state.tabsKey) {
	        case 'ByQuantity':
	          promotionLine = (0, _utils.desiredShapeByQuantity)(_this.state);
	          break;
	        case 'BuyAGetB':
	          promotionLine = (0, _utils.desiredShapeBuyAGetB)(_this.state);
	          break;
	        case 'ByTotalPriceProduct':
	          promotionLine = (0, _utils.desiredShapeByTotalPriceProduct)(_this.state);
	          break;
	        case 'ByTotalPriceDiscount':
	          promotionLine = (0, _utils.desiredShapeByTotalPriceDiscount)(_this.state);
	          break;
	        default:
	          break;
	      }
	      _this.setState({ isLoadingSavePromotion: true }, function () {
	        (0, _promotions_actions.savePromotion)(promotionLine, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.handleDeletePromotion = function () {
	      var handleSuccess = function handleSuccess() {
	        _this.handleFetchPromotionDetails(_this.state.Product_id);
	      };
	
	      var handleFailure = function handleFailure(error) {
	        alert(JSON.stringify(error));
	      };
	
	      var promotionToDeleteId = _this.state.promotionToDeleteId;
	
	      (0, _promotions_actions.deletePromotion)(promotionToDeleteId, handleSuccess, handleFailure);
	    };
	
	    _this.handleOpenEditPromotion = function (promotionLineId) {
	      var handleSuccess = function handleSuccess(response) {
	        _this.setState({
	          isLoadingPromoDetails: false,
	          promotionToEdit: response.data
	        });
	      };
	
	      var handleFailure = function handleFailure(error) {
	        _this.setState({ isLoadingPromoDetails: false });
	        alert(JSON.stringify(error));
	      };
	
	      _this.setState({ isLoadingPromoDetails: true }, function () {
	        _this.openEditPromotion();
	        (0, _promotions_actions.fetchPromoDetails)(promotionLineId, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.renderByQuantityTab = function () {
	      var byQuantityTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_quantity' });
	      return _react2.default.createElement(
	        _reactBootstrap.Tab,
	        { eventKey: 'ByQuantity', title: byQuantityTitle },
	        _react2.default.createElement(
	          'div',
	          { className: 'by-quantity-tab' },
	          _this.renderByQuantityPromoDetails()
	        )
	      );
	    };
	
	    _this.renderBuyAGetBTab = function () {
	      var buyAGetBTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_quantity_product' });
	      return _react2.default.createElement(
	        _reactBootstrap.Tab,
	        { eventKey: 'BuyAGetB', title: buyAGetBTitle },
	        _react2.default.createElement(
	          'div',
	          { className: 'buy-a-get-b-tab' },
	          _this.renderBuyAGetBPromoDetails()
	        )
	      );
	    };
	
	    _this.renderByTotalPriceProductTab = function () {
	      var byTotalPriceProductTitle = _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_total_price' }),
	        ' (',
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product' }),
	        ')'
	      );
	      return _react2.default.createElement(
	        _reactBootstrap.Tab,
	        { eventKey: 'ByTotalPriceProduct', title: byTotalPriceProductTitle },
	        _react2.default.createElement(
	          'div',
	          { className: 'by-total-price-product-tab' },
	          _this.renderByTotalPriceProductPromoDetails()
	        )
	      );
	    };
	
	    _this.renderByTotalPriceDiscountTab = function () {
	      var byTotalPriceDiscountTitle = _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_total_price' }),
	        ' (',
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount' }),
	        ')'
	      );
	      return _react2.default.createElement(
	        _reactBootstrap.Tab,
	        { eventKey: 'ByTotalPriceDiscount', title: byTotalPriceDiscountTitle },
	        _react2.default.createElement('div', { className: 'by-total-price-discount-tab' })
	      );
	    };
	
	    _this.renderByQuantityPromoDetails = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'promo-section', style: { width: '100%' } },
	        _react2.default.createElement(_components.PromotionSetup, {
	          setStartDate: _this.setStartDate,
	          startDateSelected: _this.state.startDateSelected,
	          setEndDate: _this.setEndDate,
	          endDateSelected: _this.state.endDateSelected,
	          handleSelectionChange: _this.handleSelectionChange,
	          customerGroupSelected: _this.state.customerGroupSelected,
	          paymentTypeSelected: _this.state.paymentTypeSelected,
	          customerOptions: _this.getCustomerOptions()
	        }),
	        _react2.default.createElement(_components.ByQuantityFields, {
	          paymentTypeSelected: _this.state.paymentTypeSelected,
	          methodSelected: _this.state.methodSelected,
	          quantityFrom: _this.state.quantityFrom,
	          quantityTo: _this.state.quantityTo,
	          discountValue: _this.state.discountValue,
	          discountType: _this.state.discountType,
	          handleSelectionChange: _this.handleSelectionChange,
	          handleTextInputChange: _this.handleTextInputChange,
	          handleDiscountButtonClick: _this.handleDiscountButtonClick
	        }),
	        _react2.default.createElement(_SpinnerButton2.default, {
	          bsStyle: 'success',
	          className: 'save-button',
	          onClick: _this.handleSavePromotion,
	          disabled: _this.state.isLoadingSavePromotion || (0, _utils.isIncompleteForm)(_this.state, 'ByQuantity'),
	          loading: _this.state.isLoadingSavePromotion,
	          icon: 'fa-save',
	          translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	        })
	      );
	    };
	
	    _this.renderBuyAGetBPromoDetails = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'promo-section', style: { width: '100%' } },
	        _react2.default.createElement(_components.PromotionSetup, {
	          setStartDate: _this.setStartDate,
	          startDateSelected: _this.state.startDateSelected,
	          setEndDate: _this.setEndDate,
	          endDateSelected: _this.state.endDateSelected,
	          handleSelectionChange: _this.handleSelectionChange,
	          customerGroupSelected: _this.state.customerGroupSelected,
	          paymentTypeSelected: _this.state.paymentTypeSelected,
	          customerOptions: _this.getCustomerOptions()
	        }),
	        _react2.default.createElement(_components.BuyAGetBFields, {
	          methodSelected: _this.state.methodSelected,
	          productQuantityA: _this.state.productQuantityA,
	          productQuantityB: _this.state.productQuantityB,
	          discountValue: _this.state.discountValue,
	          discountType: _this.state.discountType,
	          handleSelectionChange: _this.handleSelectionChange,
	          handleDiscountButtonClick: _this.handleDiscountButtonClick,
	          handleTextInputChange: _this.handleTextInputChange
	        }),
	        _react2.default.createElement(_SpinnerButton2.default, {
	          bsStyle: 'success',
	          className: 'save-button',
	          onClick: _this.handleSavePromotion
	          // onClick={this.handleSavePromotionConfirm}
	          , disabled: _this.state.isLoadingSavePromotion || (0, _utils.isIncompleteForm)(_this.state, 'BuyAGetB'),
	          loading: _this.state.isLoadingSavePromotion,
	          icon: 'fa-save',
	          translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	        })
	      );
	    };
	
	    _this.renderByTotalPriceProductPromoDetails = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'promo-section', style: { width: '100%' } },
	        _react2.default.createElement(_components.PromotionSetup, {
	          setStartDate: _this.setStartDate,
	          startDateSelected: _this.state.startDateSelected,
	          setEndDate: _this.setEndDate,
	          endDateSelected: _this.state.endDateSelected,
	          handleSelectionChange: _this.handleSelectionChange,
	          customerGroupSelected: _this.state.customerGroupSelected,
	          paymentTypeSelected: _this.state.paymentTypeSelected,
	          customerOptions: _this.getCustomerOptions()
	        }),
	        _react2.default.createElement(_components.ByTotalPriceProductFields, {
	          minPurchasePrice: _this.state.minPurchasePrice,
	          handleTextInputChange: _this.handleTextInputChange
	        }),
	        _react2.default.createElement(_SpinnerButton2.default, {
	          bsStyle: 'success',
	          className: 'save-button',
	          onClick: _this.handleSavePromotion,
	          disabled: _this.state.isLoadingSavePromotion || (0, _utils.isIncompleteForm)(_this.state, 'ByTotalPriceProduct'),
	          loading: _this.state.isLoadingSavePromotion,
	          icon: 'fa-save',
	          translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	        })
	      );
	    };
	
	    _this.renderBrandInformation = function () {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(_reactBootstrap.Col, { xs: 4 }),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(
	              'label',
	              null,
	              'English'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(
	              'label',
	              null,
	              '\u7E41\u9AD4'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "Brand" })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'English_Details_Brand', withRef: true, ref: 'English_Details_Brand', component: _inputField.InputField, placeholder: 'EN' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'Chinese_Details_Brand', withRef: true, ref: 'Chinese_Details_Brand', component: _inputField.InputField, placeholder: 'CH' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "Brand Origin" })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'English_Brand_Origin', withRef: true, ref: 'English_Brand_Origin', component: _inputField.InputField, placeholder: 'EN' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'Chinese_Brand_Origin', withRef: true, ref: 'Chinese_Brand_Origin', component: _inputField.InputField, placeholder: 'CH' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "Net Content" })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'English_Details_NetContent', withRef: true, ref: 'English_Details_NetContent', component: _inputField.InputField, placeholder: 'EN' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'Chinese_Details_NetContent', withRef: true, ref: 'Chinese_Details_NetContent', component: _inputField.InputField, placeholder: 'CH' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "Made In" })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'English_Details_Made_In', withRef: true, ref: 'English_Details_Made_In', component: _inputField.InputField, placeholder: 'EN' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'Chinese_Details_Made_In', withRef: true, ref: 'Chinese_Details_Made_In', component: _inputField.InputField, placeholder: 'CH' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "Ingredients" })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'English_Details_Ingredients', withRef: true, ref: 'English_Details_Ingredients', component: _inputField.InputField, placeholder: 'EN' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'Chinese_Details_Ingredients', withRef: true, ref: 'Chinese_Details_Ingredients', component: _inputField.InputField, placeholder: 'CH' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "Organic" })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'English_Details_Organic', withRef: true, ref: 'English_Details_Organic', component: _inputField.InputField, placeholder: 'EN' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'Chinese_Details_Organic', withRef: true, ref: 'Chinese_Details_Organic', component: _inputField.InputField, placeholder: 'CH' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "Contains Sugar" })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'English_Details_Contains_Sugar', withRef: true, ref: 'English_Details_Contains_Sugar', component: _inputField.InputField, placeholder: 'EN' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'Chinese_Details_Contains_Sugar', withRef: true, ref: 'Chinese_Details_Contains_Sugar', component: _inputField.InputField, placeholder: 'CH' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: "Flavor" })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'English_Details_Flavor', withRef: true, ref: 'English_Details_Flavor', component: _inputField.InputField, placeholder: 'EN' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'Chinese_Details_Flavor', withRef: true, ref: 'Chinese_Details_Flavor', component: _inputField.InputField, placeholder: 'CH' })
	          )
	        )
	      );
	    };
	
	    _this.getBinOptions = function () {
	      var binOptions = [];
	      if (_this.props.bins) {
	        _this.props.bins.map(function (bin) {
	          binOptions.push({ value: bin.section_num, label: bin.section_num });
	        });
	      }
	      binOptions.sort(function (a, b) {
	        if (a.value > b.value) {
	          return 1;
	        }
	        if (a.value < b.value) {
	          return -1;
	        }
	        return 0;
	      });
	      return binOptions;
	    };
	
	    _this.getBin2Options = function () {
	      var binOptions = [];
	      if (_this.props.bins2) {
	        _this.props.bins2.map(function (bin) {
	          binOptions.push({ value: bin.section_num, label: bin.section_num });
	        });
	      }
	      binOptions.sort(function (a, b) {
	        if (a.value > b.value) {
	          return 1;
	        }
	        if (a.value < b.value) {
	          return -1;
	        }
	        return 0;
	      });
	      return binOptions;
	    };
	
	    _this.getBin3Options = function () {
	      var binOptions = [];
	      if (_this.props.bins3) {
	        _this.props.bins3.map(function (bin) {
	          binOptions.push({ value: bin.section_num, label: bin.section_num });
	        });
	      }
	      binOptions.sort(function (a, b) {
	        if (a.value > b.value) {
	          return 1;
	        }
	        if (a.value < b.value) {
	          return -1;
	        }
	        return 0;
	      });
	      return binOptions;
	    };
	
	    _this.getLevelOptions = function () {
	      var levelOptions = [];
	      if (_this.props.levels) {
	        _this.props.levels.map(function (level) {
	          levelOptions.push({ value: level.bin_num, label: level.bin_num });
	        });
	      }
	      levelOptions.sort(function (a, b) {
	        if (a.value > b.value) {
	          return 1;
	        }
	        if (a.value < b.value) {
	          return -1;
	        }
	        return 0;
	      });
	      return levelOptions;
	    };
	
	    _this.getLevel2Options = function () {
	      var levelOptions = [];
	      if (_this.props.levels2) {
	        _this.props.levels2.map(function (level) {
	          levelOptions.push({ value: level.bin_num, label: level.bin_num });
	        });
	      }
	      levelOptions.sort(function (a, b) {
	        if (a.value > b.value) {
	          return 1;
	        }
	        if (a.value < b.value) {
	          return -1;
	        }
	        return 0;
	      });
	      return levelOptions;
	    };
	
	    _this.getLevel3Options = function () {
	      var levelOptions = [];
	      if (_this.props.levels3) {
	        _this.props.levels3.map(function (level) {
	          levelOptions.push({ value: level.bin_num, label: level.bin_num });
	        });
	      }
	      levelOptions.sort(function (a, b) {
	        if (a.value > b.value) {
	          return 1;
	        }
	        if (a.value < b.value) {
	          return -1;
	        }
	        return 0;
	      });
	      return levelOptions;
	    };
	
	    _this.VPNCheck = function () {
	      var vendors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      var allVPNHasVendorId = true;
	      vendors.forEach(function (elem) {
	        if (elem.Vendor_product_num && !elem.Vendor_id) {
	          allVPNHasVendorId = false;
	        }
	      });
	      return allVPNHasVendorId;
	    };
	
	    _this.BarcodeCheck = function () {
	      var vendors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      var barcodeNotEmpty = true;
	      vendors.forEach(function (elem) {
	        if (!elem.Code && elem.Vendor_id) {
	          barcodeNotEmpty = false;
	        }
	      });
	      // console.log('BarcodeCheck result', barcodeNotEmpty, vendors);
	      return barcodeNotEmpty;
	    };
	
	    _this.submitForm = function (formProps) {
	      // Temp VPN and barcode validation
	      var temp = [];
	      if (!_this.VPNCheck(formProps.Vendors)) {
	        alert('Each VPN must has a vendor id. please check the barcode panel');
	        return;
	      };
	      if (!_this.BarcodeCheck(formProps.Vendors)) {
	        if (!isAFG && !isMyuMyu && !isWecom && !isMMD) {
	          alert('Barcode can not be empty');
	          return;
	        } else {
	          formProps.Vendors.map(function (v) {
	            if (!v.Code) {
	              v.Code = "";
	            }
	            temp.push(v);
	          });
	          formProps.Vendors = temp;
	        }
	      };
	      _this.setState({ dirty: false });
	      if (_this.props.params.id) {
	        if (!_this.checkPermission("change_product")) {
	          _this.props.editProduct(formProps, _this.state);
	        } else {
	          alert("You have no permission!");
	        }
	      } else _this.props.createProduct(formProps, _this.state, _this.state.productNavigation_1.ProductNum);
	      if (isAFG || isMyuMyu) {
	        setTimeout(function () {
	          window.history.back();
	        }, 500);
	      }
	    };
	
	    _this.viewPromotion = function () {
	      _this.setState({ viewPromotion: true }, function () {
	        _this.handleFetchPromotionDetails(_this.state.Product_id);
	      });
	    };
	
	    _this.closeViewPromotion = function () {
	      var state = (0, _utils.clearForm)(_this.state);
	      _this.setState(state);
	      _this.setState({
	        viewPromotion: false,
	        startDateSelected: undefined,
	        endDateSelected: undefined,
	        customerGroupSelected: '',
	        paymentTypeSelected: '',
	        selectedProduct: {
	          currentPackageSize: _this.props.currentProductDetail.PackageSize,
	          currentProdId: _this.props.currentProductDetail.Product_id,
	          currentProdName: _this.props.currentProductDetail.Name,
	          currentProdNum: _this.props.currentProductDetail.ProductNum,
	          currentProductCRV: _this.props.currentProductDetail.CRV,
	          currentProductDescription: _this.props.currentProductDetail.Description,
	          currentProductWeight: _this.props.currentProductDetail.NetWeight,
	          currentRefNum: _this.props.currentProductDetail.RefNum,
	          currentRefPrice: _this.props.currentProductDetail.RefPrice,
	          netWeight: _this.props.currentProductDetail.NetWeight
	        }
	      });
	    };
	
	    _this.handleImageUpdated = function (updatedImage) {
	      _this.setState({ updatedImage: updatedImage });
	    };
	
	    _this.generateRefNo = function () {
	      var rNo = void 0;
	      var _this$props = _this.props,
	          PackageType_2 = _this$props.PackageType_2,
	          MeasureUnit_2 = _this$props.MeasureUnit_2;
	
	      if (!PackageType_2 && !MeasureUnit_2) {
	        alert('Please fill out Pkg Size 1 and Pkg Size 2 to generate Reference Number.');
	      } else if (isBD()) {
	        if (!_this.props.currentProductDetail) {
	          var groupTag = _this.props.ProductGroup_id.label;
	          var catTag = _this.state.productNavigation_1.ProductCategory1_id.label;
	          rNo = groupTag + '-' + catTag + '-' + _this.props.PackageType_2.label + '-' + _this.props.MeasureUnit_2.label;
	        } else {
	          var matchedProductId = _this.props.ProductGroup_id;
	          var matchedCategoryId = _this.props.currentProductDetail.ProductCategory1_id;
	          var _groupTag = _this.props.groups.find(function (value) {
	            if (value.ProductGroup_id === matchedProductId) {
	              return value;
	            }
	          });
	          var _catTag = _this.props.groupCategories.find(function (value) {
	            if (value.ProductCategory_id === matchedCategoryId) {
	              return value;
	            }
	          });
	          rNo = _groupTag.Name + '-' + _catTag.Name + '-' + _this.props.PackageType_2 + '-' + _this.props.MeasureUnit_2;
	        }
	      } else if (isSoleStage()) {
	        if (!_this.props.currentProductDetail) {
	          var _catTag2 = _this.state.productNavigation_1.ProductCategory1_id.label;
	          rNo = _catTag2 + '-' + _this.props.PackageType_2.label + '/' + _this.props.MeasureUnit_2.label;
	        } else {
	          var _matchedCategoryId = _this.props.currentProductDetail.ProductCategory1_id;
	          var _catTag3 = _this.props.groupCategories.find(function (value) {
	            if (value.ProductCategory_id === _matchedCategoryId) {
	              return value;
	            }
	          });
	          rNo = _catTag3.Name + '-' + (_this.props.PackageType_2.value ? _this.props.PackageType_2.value : _this.props.PackageType_2) + '/' + (_this.props.MeasureUnit_2.value ? _this.props.MeasureUnit_2.value : _this.props.MeasureUnit_2);
	        }
	      }
	      _this.props.change('RefNum', rNo);
	    };
	
	    _this.renderGenerateReferenceNumber = function () {
	      if (isBD()) {
	        return _react2.default.createElement(
	          'div',
	          { style: { marginBottom: 8 } },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'primary',
	              type: 'button',
	              onClick: _this.generateRefNo
	            },
	            _react2.default.createElement('em', { className: 'fa fa-save' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Generate Ref No' })
	          )
	        );
	      }
	    };
	
	    _this.renderLotNum = function () {
	      if (_root_url.isCNT) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-4' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lot_number' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-8' },
	            _react2.default.createElement(_reduxForm.Field, { name: 'LotNum', withRef: true, ref: 'CustomerNum', component: _inputField.InputField, onFocus: _this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                _this.handleKeyPress('Name', event);
	              } })
	          )
	        );
	      }
	    };
	
	    _this.handleFocusQty = function (suggestProduct) {
	      _this.state.suggestProduct = suggestProduct;
	    };
	
	    _this.checkPasscode = function (e) {
	      e.preventDefault();
	      _this.props.setConfirmPasscodeModalVisibility(true);
	    };
	
	    _this.setProductMetaInfoVisibility = function (isVisible) {
	      _this.setState({
	        productMetaInfoVisibility: isVisible
	      });
	    };
	
	    _this.handleProductMetaInfoSave = function (info) {
	      _this.setState({
	        meta_info: info
	      }, function () {
	        _this.setProductMetaInfoVisibility(false);
	      });
	    };
	
	    _this.handleFetchESL = function () {
	      var productId = _this.props.currentProductDetail.Product_id;
	      _this.props.fetchESL(productId).then(function (response) {
	        _this.setState({ eslFetchData: response.data });
	      }, function (err) {
	        alert("ESL Error: " + err.data);
	      });
	    };
	
	    _this.handleSaveESL = function (ESLCode, TemplateId, TemplateName) {
	      var productId = _this.props.currentProductDetail.Product_id;
	      _this.props.saveESL(productId, ESLCode, TemplateId, TemplateName).then(function (response) {
	        alert("ESL Bind Successful");
	        _this.setState({ eslModalVisibility: false });
	      }, function (err) {
	        alert("ESL Error: " + err.data);
	      });
	    };
	
	    _this.state = {
	      eslEnabled: false,
	      eslModalVisibility: false,
	      eslFetchData: null,
	      formProps: {},
	      confirmModalVisibility: false,
	      suggestValue: '',
	      productSearchType: 'Name',
	      suggestProduct: null,
	      MixedProductBaseUnit: null,
	      MixedProduct: {
	        Unit: null,
	        MixedUnit: null,
	        ProductName: null,
	        ProductNum: null,
	        ProductSKU: null,
	        Quantity: null
	      },
	      skusModal: false,
	      vendorOpen: false,
	      groupOpen: false,
	      categoryOpen: false,
	      packageTypeOpen: false,
	      mobileDescBoxOpen: false,
	      displayCategoryBoxOpen: false,
	      addConvertProductsOpen: false,
	      checkAuthorizeOpen: false,
	      editProductGroup: false,
	      vendorValue: null,
	      dirty: false,
	      p1Percentage: 0,
	      p2Percentage: 0,
	      p3Percentage: 0,
	      p4Percentage: 0,
	      p5Percentage: 0,
	      priceLv1: 0,
	      priceLv2: 0,
	      priceLv3: 0,
	      priceLv4: 0,
	      priceLv5: 0,
	      changePrice: true,
	      editableProductNum: true,
	      crumbStyle: {},
	      files: null,
	      Product_id: 0,
	      showProductCreatedOpen: false,
	      productNavigationOpen: [false, false],
	      productNavigation_1: {
	        ProductCategory1_id: null,
	        ProductGroup_id: null,
	        ProductNum: null,
	        RefNum: null,
	        suggestedProdNum: null,
	        isLinked: false,
	        Name: null,
	        Description: null,
	        IsLarge: null,
	        LastDigit: null,
	        isMadePrev: null
	      },
	      productNavigation_2: {
	        ProdType: null,
	        PackageType: null,
	        PackageSize_1: null,
	        PackageType_2: null,
	        PackageSize_2: null,
	        MeasureUnit_2: null,
	        NetWeight_1: null,
	        NetWeight_2: null,
	        RefPrice: null,
	        LowestSalePrice: null
	      },
	      productNavigation_3: {
	        ConvertNum: null,
	        SmallProdType: null,
	        SmallPackageType: null,
	        ConvertType: null
	      },
	      // promo
	      customerList: [],
	      warehouseOptions: [],
	      startDateSelected: null,
	      endDateSelected: null,
	      customerGroupSelected: '',
	      paymentTypeSelected: '',
	      tabsKey: 'ByQuantity',
	      selectedProduct: {},
	      promotionToEdit: {},
	      methodSelected: '',
	      discountValue: '',
	      discountType: 'Dollar',
	      quantityFrom: '',
	      quantityTo: '',
	      minPurchasePrice: '',
	      promotionDetails: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      isLoadingPromotions: false,
	      isLoadingSavePromotion: false,
	      isLoadingPromoDetails: false,
	      promotionDetailsIsLoading: false,
	      viewPromotion: false,
	      deletePromotionOpen: false,
	      editPromotionOpen: false,
	      promotionToDeleteId: undefined,
	
	      editRecPermissionOpen: false,
	      case: null,
	
	      isLoadingMobileDescBoxText: false,
	      mobileDescriptionHTML: '',
	      imagesModalOpen: false,
	      updatedImage: undefined,
	      relatedProducts: [],
	
	      isLoadingCategoryProducts: false,
	      isLoadingDisplayCategory: false,
	      categoryProducts: [],
	      deleteModalOpen: false,
	      ProductSKU: '',
	
	      displayCategories: null,
	      permissionChecked: false,
	
	      productMetaInfoVisibility: false,
	      meta_info: {
	        meta_title: '',
	        meta_keywords: '',
	        meta_description: ''
	      },
	
	      customerAltOptions: [],
	
	      PackageTypeC: '',
	      productInventoryQty: 0
	    };
	    _this.openVendor = _this.openVendor.bind(_this);
	    _this.closeVendor = _this.closeVendor.bind(_this);
	    _this.openGroup = _this.openGroup.bind(_this);
	    _this.closeGroup = _this.closeGroup.bind(_this);
	    _this.openCategory = _this.openCategory.bind(_this);
	    _this.closeCategory = _this.closeCategory.bind(_this);
	    _this.handlePercentageChange = _this.handlePercentageChange.bind(_this);
	    _this.handlePriceChange = _this.handlePriceChange.bind(_this);
	    _this.openShowProductCreated = _this.openShowProductCreated.bind(_this);
	    _this.closeShowProductCreated = _this.closeShowProductCreated.bind(_this);
	    _this.openPackageType = _this.openPackageType.bind(_this);
	    _this.closePackageType = _this.closePackageType.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.navigate = _this.navigate.bind(_this);
	    _this.saveCurrentModal = _this.saveCurrentModal.bind(_this);
	    _this.handleClickNext_1 = _this.handleClickNext_1.bind(_this);
	    _this.handleClickPrev_2 = _this.handleClickPrev_2.bind(_this);
	    _this.handleClickNext_2 = _this.handleClickNext_2.bind(_this);
	    _this.handleClickPrev_3 = _this.handleClickPrev_3.bind(_this);
	    _this.closeNavigation = _this.closeNavigation.bind(_this);
	    _this.saveProductFormNavigation_3 = _this.saveProductFormNavigation_3.bind(_this);
	    _this.handleClickFinish = _this.handleClickFinish.bind(_this);
	    _this.selectPackageType = _this.selectPackageType.bind(_this);
	    _this.openDeleteModal = _this.openDeleteModal.bind(_this);
	    _this.closeDeleteModal = _this.closeDeleteModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(ProductForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var currentProduct = this.props.currentProduct;
	
	      if (!currentProduct && !this.props.params) {
	        this.context.router.push('/products/new');
	      }
	      if (!currentProduct && this.props.params.id) {}
	      // this.props.fetchProductDetail(this.props.params.id);
	      // alert('no current product');
	
	      // if (currentProduct) {
	      // if (this.props.params.id) {
	      //   const id = this.props.params.id;
	      //   this.props.fetchCategories2();
	      //   this.getDisplayCategories(id);
	      //   this.props.fetchVendors();
	      //   this.props.fetchGroups();
	      //   // for facex
	      //   this.props.fetchProductInventoryBatches(id)
	      //     .then(() => {
	      //       this.setState({
	      //         productInventoryQty: this.props.productInventory.total_quantity,
	      //       });
	      //     });
	      //   this.props.fetchZones()
	      //     .then(() => {
	      //       this.props.fetchProductDetail(id)
	      //         .then(() => {
	      //           this.props.zones.map(zone => {
	      //             if (zone.zone_num === this.props.Zone) {
	      //               let foundZone = zone;
	      //               this.props.setValue("productForm", "Zone", foundZone.zone_num);
	      //               this.props.getBinsByZone(foundZone.id, 1);
	      //             }
	      //             if (zone.zone_num === this.props.Zone2) {
	      //               let foundZone2 = zone;
	      //               this.props.setValue("productForm", "Zone2", foundZone2.zone_num);
	      //               this.props.getBinsByZone(foundZone2.id, 2);
	      //             }
	      //             if (zone.zone_num === this.props.Zone3) {
	      //               let foundZone3 = zone;
	      //               this.props.setValue("productForm", "Zone3", foundZone3.zone_num);
	      //               this.props.getBinsByZone(foundZone3.id, 3);
	      //             }
	      //           });
	      //         });
	      //       });
	      //       // if you open one product and then on the same page open another product (go back or go next) the zone sticks around from product to product
	      //       // if customer changes price or unrelated item and then saves they save the old ZBL data.
	      //       // general product/warehouse inventory search/
	      //       this.setState({ editableProductNum: false });
	      // } else {
	      this.props.fetchCategories2();
	      this.props.fetchVendors();
	      this.props.fetchGroups();
	      this.props.fetchZones();
	      this.props.setDefaultOfForm("PriceType", "weight", "productForm");
	      if (isAFG || isMyuMyu || isWecom) {
	        this.props.setDefaultOfForm("IsStopSale", "true", "productForm");
	        this.props.setDefaultOfForm("IsOverSaleable", "false", "productForm");
	      } else {
	        this.props.setDefaultOfForm("IsStopSale", "false", "productForm");
	        this.props.setDefaultOfForm("IsOverSaleable", "true", "productForm");
	      }
	      this.props.setDefaultOfForm("IsDiscontinued", "false", "productForm");
	      this.props.setDefaultOfForm("IsWholesaleOnly", "false", "productForm");
	      this.props.setDefaultOfForm("IsMobile", "false", "productForm");
	      if (isEcity) {
	        this.props.setDefaultOfForm("IsTaxable", "true", "productForm");
	      } else {
	        this.props.setDefaultOfForm("IsTaxable", false, "productForm");
	      }
	      this.props.setDefaultOfForm("IsAllTaxable", "false", "productForm");
	      this.props.setDefaultOfForm("IsNonFood", "false", "productForm");
	      this.props.setDefaultOfForm("IsSoldNationwide", "false", "productForm");
	      this.props.setDefaultOfForm("IsGreatDeal", "false", "productForm");
	      this.props.setDefaultOfForm("IsNewArrival", "false", "productForm");
	      this.props.setDefaultOfForm("IsProposition65", "false", "productForm");
	      this.props.setDefaultOfForm("IsSyncToScales", "false", "productForm");
	      this.props.setDefaultOfForm("IsSyncToESL", "false", "productForm");
	      this.props.setDefaultOfForm("IsAFGChioce", "false", "productForm");
	      this.props.setDefaultOfForm("IsAlcohol", "false", "productForm");
	      this.props.setDefaultOfForm("IsB2B", "false", "productForm");
	      this.props.setDefaultOfForm("IsB2C", "true", "productForm");
	      // }
	      if (this.props.location.pathname === "/products/new") {
	        this.setState({ productNavigationOpen: [true, false] });
	      }
	      this.props.fetchCRVValues();
	      this.props.fetchDefaultBuyers();
	      this.props.clearAttachedProductImage();
	      this.props.fetchPackageTypes();
	      this.props.fetchMeasurementUnit();
	      // making a leaving hook to confirm leaving
	      this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      document.title = _root_url.companyCodeTitle;
	      if (this.props.params.id) {
	        setTimeout(function () {
	          _this2.props.fetchProductDetail(_this2.props.params.id, _this2.props.selectedCompany, _this2.props.selectedWarehouse);
	        }, 1000);
	      }
	
	      if (isFBD) {
	        this.props.fetchCustomers(true);
	      } else {
	        this.props.fetchCustomers();
	      }
	
	      var customerAltOptions = this.state.customerAltOptions;
	
	      if (isABCFF) {
	        _axios2.default.get(_root_url.ROOT_URL + 'v1/customer/?Customer_id__IsActive=1', { headers: { Authorization: 'Bearer ' + localStorage.getItem("token") } }).then(function (res) {
	          res.data.map(function (r) {
	            customerAltOptions.push({ label: r.Name, value: r.Customer_id });
	          });
	          console.log("customers ABCFF", customerAltOptions);
	          _this2.setState({ customerAltOptions: customerAltOptions });
	        }, function (err) {
	          if (err.data) {
	            alert(err.data);
	          } else {
	            alert("Server issue detected, please contact admin.");
	          }
	        });
	      }
	
	      var warehouseOptions = this.state.warehouseOptions;
	
	      if (isUSPride) {
	        _axios2.default.get(_root_url.ROOT_URL + 'v1/warehouse/', { headers: { Authorization: 'Bearer ' + localStorage.getItem("token") } }).then(function (res) {
	          res.data.map(function (r) {
	            warehouseOptions.push({ label: r.Name, value: r.Warehouse_id });
	          });
	          console.log("warehouses", warehouseOptions);
	          _this2.setState({ warehouseOptions: warehouseOptions });
	        }, function (err) {
	          if (err.data) {
	            alert(err.data);
	          } else {
	            alert("Server issue detected, please contact admin.");
	          }
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      // reset('productForm');
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      if (this.props.currentProductDetail) {
	        this.setState({ Product_id: this.props.currentProductDetail.Product_id }, function () {
	          _this3.props.setCurrentProduct(_this3.props.currentProductDetail.Product_id);
	        });
	        // this.props.clearSmallProdStatus();
	      }
	      // this.props.resetZone();
	      this.props.resetBins();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this4 = this;
	
	      // error messages
	      if (nextProps.createError && !this.props.createError) {
	        var msg = "Error: ";
	        if (JSON.stringify(nextProps.createError).length > 250) {
	          msg += JSON.stringify(nextProps.createError).substring(0, 250);
	        } else {
	          msg += JSON.stringify(nextProps.createError);
	        }
	        alert(msg);
	      }
	
	      if (nextProps.editError && !this.props.editError) {
	        var _msg = "Error: ";
	        // if (JSON.stringify(nextProps.editError).length > 250) {
	        //   msg += JSON.stringify(nextProps.editError).substring(0, 250);
	        // } else {
	        _msg += JSON.stringify(nextProps.editError);
	        // }
	        alert(_msg);
	      }
	
	      if (nextProps.continueOrDiscontinueProductError && !this.props.continueOrDiscontinueProductError) {
	        alert(JSON.stringify(nextProps.continueOrDiscontinueProductError));
	      }
	
	      if (nextProps.continueOrDiscontinueProductSuccess && !this.props.continueOrDiscontinueProductSuccess) {
	        this.props.fetchProductDetail(nextProps.currentProductDetail.Product_id);
	      }
	      if ((this.props.currentProductDetail && this.props.currentProductDetail.Product_id) === (nextProps.currentProductDetail && nextProps.currentProductDetail.Product_id)) {
	
	        if (nextProps.ConvertType && nextProps.ConvertType !== this.props.ConvertType) {
	          var convertNum = null;
	          if (nextProps.ConvertType === 'weight') {
	            convertNum = nextProps.NetWeight;
	          } else if (nextProps.ConvertType === 'unit') {
	            convertNum = nextProps.PackageSize_1;
	          }
	          this.props.setValue('productForm', 'ConvertNum', convertNum);
	        }
	        if (!isHF) {
	          if (nextProps.PackageSize_1 !== this.props.PackageSize_1) {
	            var packageType_2 = '';
	            if (nextProps.PackageType_2) {
	              packageType_2 = nextProps.PackageType_2.value ? nextProps.PackageType_2.value : nextProps.PackageType_2;
	            }
	            var measureUnit_2 = '';
	            if (nextProps.MeasureUnit_2) {
	              measureUnit_2 = nextProps.MeasureUnit_2.value ? nextProps.MeasureUnit_2.value : nextProps.MeasureUnit_2;
	            }
	            var packageSize = '' + (nextProps.PackageSize_1 || '') + packageType_2 + '*' + (nextProps.PackageSize_2 || this.props.PackageSize_2 || '') + measureUnit_2;
	            if (packageSize[0] === '*') {
	              packageSize = packageSize.slice(1);
	            }
	
	            this.props.setValue('productForm', 'PackageSize', packageSize);
	            if (nextProps.ConvertType === 'unit') {
	              this.props.setValue('productForm', 'ConvertNum', nextProps.PackageSize_1);
	            }
	          }
	
	          if (nextProps.NetWeight !== this.props.NetWeight) {
	            if (nextProps.ConvertType === 'weight') {
	              this.props.setValue('productForm', 'ConvertNum', nextProps.NetWeight);
	            }
	          }
	
	          if (nextProps.PackageType_2 !== this.props.PackageType_2) {
	            var _packageType_ = '';
	            if (nextProps.PackageType_2) {
	              _packageType_ = nextProps.PackageType_2.value ? nextProps.PackageType_2.value : nextProps.PackageType_2;
	            }
	            var _measureUnit_ = '';
	            if (nextProps.MeasureUnit_2) {
	              _measureUnit_ = nextProps.MeasureUnit_2.value ? nextProps.MeasureUnit_2.value : nextProps.MeasureUnit_2;
	            }
	
	            var _packageSize = '' + (nextProps.PackageSize_1 || this.props.PackageSize_1 || '') + _packageType_ + '*' + (nextProps.PackageSize_2 && (nextProps.PackageSize_2.value || nextProps.PackageSize_2) || this.props.PackageSize_2 || '') + _measureUnit_;
	            if (_packageSize[0] === '*') {
	              _packageSize = _packageSize.slice(1);
	            }
	            this.props.setValue('productForm', 'PackageSize', _packageSize);
	          }
	
	          if (nextProps.PackageSize_2 !== this.props.PackageSize_2) {
	            var _packageType_2 = '';
	            if (nextProps.PackageType_2) {
	              _packageType_2 = nextProps.PackageType_2.value ? nextProps.PackageType_2.value : nextProps.PackageType_2;
	            }
	            var _measureUnit_2 = '';
	            if (nextProps.MeasureUnit_2) {
	              _measureUnit_2 = nextProps.MeasureUnit_2.value ? nextProps.MeasureUnit_2.value : nextProps.MeasureUnit_2;
	            }
	            var _packageSize2 = '' + (nextProps.PackageSize_1 || this.props.PackageSize_1 || '') + _packageType_2 + '*' + (nextProps.PackageSize_2 || '') + _measureUnit_2;
	            if (_packageSize2[0] === '*') {
	              _packageSize2 = _packageSize2.slice(1);
	            }
	
	            this.props.setValue('productForm', 'PackageSize', _packageSize2);
	          }
	
	          if (nextProps.MeasureUnit_2 !== this.props.MeasureUnit_2) {
	            var _packageType_3 = '';
	            if (nextProps.PackageType_2) {
	              _packageType_3 = nextProps.PackageType_2.value ? nextProps.PackageType_2.value : nextProps.PackageType_2;
	            }
	            var _measureUnit_3 = '';
	            if (nextProps.MeasureUnit_2) {
	              _measureUnit_3 = nextProps.MeasureUnit_2.value ? nextProps.MeasureUnit_2.value : nextProps.MeasureUnit_2;
	            }
	            var _packageSize3 = '' + (nextProps.PackageSize_1 || this.props.PackageSize_1 || '') + _packageType_3 + '*' + (nextProps.PackageSize_2 || this.props.PackageSize_2 || '') + _measureUnit_3;
	            if (_packageSize3[0] === '*') {
	              _packageSize3 = _packageSize3.slice(1);
	            }
	
	            this.props.setValue('productForm', 'PackageSize', _packageSize3);
	          }
	        }
	
	        // Used to have these for Zone-Bin-Level functionality until recently. Leaving them here in case something goes wrong and we have revert to original.
	        // if (nextProps.Zone && nextProps.Zone !== this.props.Zone && this.props.Zone !== undefined) {
	        //   console.log("old ZOne UNDEFINED:", this.props.Zone)
	        //   console.log("new zone UNDEFINED:", nextProps.Zone)
	        //   this.props.setValue('productForm', 'Bin', null);
	        //   this.props.setValue('productForm', 'Level', null);
	        //   this.props.zones.map( zone => {
	        //     if (zone.zone_num === nextProps.Zone) {
	        //       this.props.getBinsByZone(zone.id, 1);
	        //     }
	        //   });
	        //   this.props.setValue('productForm', 'Zone', nextProps.Zone.label);
	        // }
	        // if (nextProps.Zone2 && nextProps.Zone2 !== this.props.Zone2 && this.props.Zone2 !== undefined) {
	        //   console.log("old ZOne2:", this.props.Zone)
	        //   console.log("new zone2:", nextProps.Zone)
	        //   this.props.setValue('productForm', 'Bin2', null);
	        //   this.props.setValue('productForm', 'Level2', null);
	        //   this.props.zones.map( zone => {
	        //     if (zone.zone_num === nextProps.Zone2) {
	        //       this.props.getBinsByZone(zone.id, 2);
	        //     }
	        //   });
	        //   this.props.setValue('productForm', 'Zone2', nextProps.Zone2.label);
	        // }
	        // if (nextProps.Zone3 && nextProps.Zone3 !== this.props.Zone3 && this.props.Zone3 !== undefined) {
	        //   console.log("old ZOne3:", this.props.Zone)
	        //   console.log("new zone3:", nextProps.Zone)
	        //   this.props.setValue('productForm', 'Bin3', null);
	        //   this.props.setValue('productForm', 'Level3', null);
	        //   this.props.zones.map( zone => {
	        //     if (zone.zone_num === nextProps.Zone3) {
	        //       this.props.getBinsByZone(zone.id, 3);
	        //     }
	        //   });
	        //   this.props.setValue('productForm', 'Zone3', nextProps.Zone3.label);
	        // }
	
	        if (nextProps.Zone && nextProps.Zone !== this.props.Zone && _typeof(nextProps.Zone) === 'object') {
	          this.props.setValue('productForm', 'Bin', null);
	          this.props.setValue('productForm', 'Level', null);
	          this.props.zones.map(function (zone) {
	            if (zone.zone_num === nextProps.Zone.label) {
	              _this4.props.getBinsByZone(zone.id, 1);
	            }
	          });
	          this.props.setValue('productForm', 'Zone', nextProps.Zone.label);
	        }
	        if (nextProps.Zone2 && nextProps.Zone2 !== this.props.Zone2 && _typeof(nextProps.Zone2) === 'object') {
	          this.props.setValue('productForm', 'Bin2', null);
	          this.props.setValue('productForm', 'Level2', null);
	          this.props.zones.map(function (zone) {
	            if (zone.zone_num === nextProps.Zone2.label) {
	              _this4.props.getBinsByZone(zone.id, 2);
	            }
	          });
	          this.props.setValue('productForm', 'Zone2', nextProps.Zone2.label);
	        }
	        if (nextProps.Zone3 && nextProps.Zone3 !== this.props.Zone3 && _typeof(nextProps.Zone3) === 'object') {
	          this.props.setValue('productForm', 'Bin3', null);
	          this.props.setValue('productForm', 'Level3', null);
	          this.props.zones.map(function (zone) {
	            if (zone.zone_num === nextProps.Zone3.label) {
	              _this4.props.getBinsByZone(zone.id, 3);
	            }
	          });
	          this.props.setValue('productForm', 'Zone3', nextProps.Zone3.label);
	        }
	        // e
	
	        // s
	        if (nextProps.bins && nextProps.bins !== this.props.bins) {
	          nextProps.bins.map(function (bin) {
	            if (bin.section_num === _this4.props.Bin) {
	              var foundBin = bin;
	              _this4.props.setValue("productForm", "Bin", foundBin.section_num);
	              _this4.props.getLevelsByBin(foundBin.id, 1);
	            }
	          });
	        }
	        if (nextProps.bins2 && nextProps.bins2 !== this.props.bins2) {
	          nextProps.bins2.map(function (bin) {
	            if (bin.section_num === _this4.props.Bin2) {
	              var foundBin2 = bin;
	              _this4.props.setValue("productForm", "Bin2", foundBin2.section_num);
	              _this4.props.getLevelsByBin(foundBin2.id, 2);
	            }
	          });
	        }
	        if (nextProps.bins3 && nextProps.bins3 !== this.props.bins3) {
	          nextProps.bins3.map(function (bin) {
	            if (bin.section_num === _this4.props.Bin3) {
	              var foundBin3 = bin;
	              _this4.props.setValue("productForm", "Bin3", foundBin3.section_num);
	              _this4.props.getLevelsByBin(foundBin3.id, 3);
	            }
	          });
	        }
	        // e
	
	        // s
	        if (nextProps.levels && nextProps.levels !== this.props.levels) {
	          nextProps.levels.map(function (level) {
	            if (level.bin_num === _this4.props.Level) {
	              _this4.props.setValue("productForm", "Level", level.bin_num);
	            }
	          });
	        }
	        if (nextProps.levels2 && nextProps.levels2 !== this.props.levels2) {
	          nextProps.levels2.map(function (level) {
	            if (level.bin_num === _this4.props.Level2) {
	              _this4.props.setValue("productForm", "Level2", level.bin_num);
	            }
	          });
	        }
	        if (nextProps.levels3 && nextProps.levels3 !== this.props.levels3) {
	          nextProps.levels3.map(function (level) {
	            if (level.bin_num === _this4.props.Level3) {
	              _this4.props.setValue("productForm", "Level3", level.bin_num);
	            }
	          });
	        }
	        // e
	
	        // s
	        if (nextProps.Bin && nextProps.Bin !== this.props.Bin) {
	          this.props.bins.map(function (bin) {
	            if (bin.section_num === nextProps.Bin) {
	              _this4.props.getLevelsByBin(bin.id, 1);
	            }
	          });
	          this.props.setValue('productForm', 'Bin', nextProps.Bin.label);
	        }
	        if (nextProps.Bin2 && nextProps.Bin2 !== this.props.Bin2) {
	          this.props.bins2.map(function (bin) {
	            if (bin.section_num === nextProps.Bin2) {
	              _this4.props.getLevelsByBin(bin.id, 2);
	            }
	          });
	          this.props.setValue('productForm', 'Bin2', nextProps.Bin2.label);
	        }
	        if (nextProps.Bin3 && nextProps.Bin3 !== this.props.Bin3) {
	          this.props.bins3.map(function (bin) {
	            if (bin.section_num === nextProps.Bin3) {
	              _this4.props.getLevelsByBin(bin.id, 3);
	            }
	          });
	          this.props.setValue('productForm', 'Bin3', nextProps.Bin3.label);
	        }
	        // e
	
	        // s
	        if (nextProps.Level && nextProps.Level !== this.props.Level) {
	          this.props.setValue('productForm', 'Level', nextProps.Level.label);
	        }
	        if (nextProps.Level2 && nextProps.Level2 !== this.props.Level2) {
	          this.props.setValue('productForm', 'Level2', nextProps.Level2.label);
	        }
	        if (nextProps.Level3 && nextProps.Level3 !== this.props.Level3) {
	          this.props.setValue('productForm', 'Level3', nextProps.Level3.label);
	        }
	        // e
	
	        if (nextProps.RefPriceValue && nextProps.RefPriceValue !== this.props.RefPriceValue) {
	          if (!isEcity) {
	            // console.log('nextProps.RefPriceValue, this.props.RefPriceValue)', nextProps.RefPriceValue, this.props.RefPriceValue);
	            // const priceLv1 = calculatePriceLevelNormal(this.state.p1Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
	            // const priceLv2 = calculatePriceLevelNormal(this.state.p2Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
	            // const priceLv3 = calculatePriceLevelNormal(this.state.p3Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
	            // const priceLv4 = calculatePriceLevelNormal(this.state.p4Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
	            // const priceLv5 = calculatePriceLevelNormal(this.state.p5Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
	            // this.setState({
	            //   priceLv1,
	            //   priceLv2,
	            //   priceLv3,
	            //   priceLv4,
	            //   priceLv5,
	            // });
	          }
	        }
	      }
	
	      if (nextProps.convertableProductsFetched && nextProps.convertableProductsFetched !== this.props.convertableProductsFetched && nextProps.convertableProductsFetched.relations.length > 0) {
	        var relations = nextProps.convertableProductsFetched.relations;
	
	        this.setState({ relatedProducts: relations.map(function (product) {
	            return _extends({}, product, { ConvertNum: product.ConvertNum || product.convert_number || null });
	          }) });
	        this.props.setValue('productForm', 'Related_Products', relations);
	      }
	      if (nextProps.ProductNum && nextProps.ProductNum !== this.props.ProductNum) {
	        this.props.fetchConvertableProducts(nextProps.ProductNum);
	      }
	      if (nextProps.currentProductDetail && nextProps.currentProductDetail !== this.props.currentProductDetail) {
	        var _selectedProduct;
	
	        this.props.zones.map(function (zone) {
	          if (zone.zone_num === nextProps.currentProductDetail.Zone) {
	            var foundZone = zone;
	            _this4.props.setValue("productForm", "Zone", foundZone.zone_num);
	            _this4.props.getBinsByZone(foundZone.id, 1);
	          }
	          if (zone.zone_num === _this4.props.Zone2) {
	            var foundZone2 = zone;
	            _this4.props.setValue("productForm", "Zone2", foundZone2.zone_num);
	            _this4.props.getBinsByZone(foundZone2.id, 2);
	          }
	          if (zone.zone_num === _this4.props.Zone3) {
	            var foundZone3 = zone;
	            _this4.props.setValue("productForm", "Zone3", foundZone3.zone_num);
	            _this4.props.getBinsByZone(foundZone3.id, 3);
	          }
	        });
	        var productNavigation_1 = {
	          ProductCategory1_id: nextProps.currentProductDetail.ProductCategory1_id,
	          ProductGroup_id: nextProps.currentProductDetail.ProductGroup_id,
	          ProductNum: nextProps.currentProductDetail.ProductNum,
	          RefNum: nextProps.currentProductDetail.RefNum,
	          suggestedProdNum: nextProps.currentProductDetail.ProductNum.substring(4, 7),
	          isLinked: false,
	          Name: nextProps.currentProductDetail.Name,
	          Description: nextProps.currentProductDetail.Description,
	          IsLarge: nextProps.currentProductDetail.IsLarge,
	          LastDigit: nextProps.currentProductDetail.ProductNum.substring(7, 8),
	          isMadePrev: true
	        };
	        var _nextProps$currentPro = nextProps.currentProductDetail,
	            p1Percentage = _nextProps$currentPro.P1Percentage,
	            p2Percentage = _nextProps$currentPro.P2Percentage,
	            p3Percentage = _nextProps$currentPro.P3Percentage,
	            p4Percentage = _nextProps$currentPro.P4Percentage,
	            p5Percentage = _nextProps$currentPro.P5Percentage,
	            PriceLv1 = _nextProps$currentPro.PriceLv1,
	            PriceLv2 = _nextProps$currentPro.PriceLv2,
	            PriceLv3 = _nextProps$currentPro.PriceLv3,
	            PriceLv4 = _nextProps$currentPro.PriceLv4,
	            PriceLv5 = _nextProps$currentPro.PriceLv5;
	        // console.log('nextProps.currentProductDetail', nextProps.currentProductDetail);
	        // const priceLv1 = isEcity ? PriceLv1 : calculatePriceLevelNormal(p1Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
	        // const priceLv2 = isEcity ? PriceLv2 : calculatePriceLevelNormal(p2Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
	        // const priceLv3 = isEcity ? PriceLv3 : calculatePriceLevelNormal(p3Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
	        // const priceLv4 = calculatePriceLevelNormal(p4Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
	        // const priceLv5 = calculatePriceLevelNormal(p5Percentage, nextProps.RefPriceValue, nextProps.ArrivalPrice);
	
	        var priceLv1 = PriceLv1;
	        var priceLv2 = PriceLv2;
	        var priceLv3 = PriceLv3;
	        var priceLv4 = PriceLv4;
	        var priceLv5 = PriceLv5;
	        this.setState({
	          p1Percentage: isEcity ? (0, _NumberUtil.calculatePricePercentage)(PriceLv1, null, nextProps.ArrivalPrice) : p1Percentage,
	          p2Percentage: isEcity ? (0, _NumberUtil.calculatePricePercentage)(PriceLv2, null, nextProps.ArrivalPrice) : p2Percentage,
	          p3Percentage: isEcity ? (0, _NumberUtil.calculatePricePercentage)(PriceLv3, null, nextProps.ArrivalPrice) : p3Percentage,
	          p4Percentage: p4Percentage,
	          p5Percentage: p5Percentage,
	          priceLv1: priceLv1,
	          priceLv2: priceLv2,
	          priceLv3: priceLv3,
	          priceLv4: priceLv4,
	          priceLv5: priceLv5,
	          Product_id: nextProps.currentProductDetail.Product_id,
	          productNavigation_1: productNavigation_1,
	          selectedProduct: (_selectedProduct = {
	            currentPackageSize: nextProps.currentProductDetail.PackageSize,
	            currentProdId: nextProps.currentProductDetail.Product_id,
	            currentProdName: nextProps.currentProductDetail.Name,
	            currentProdNum: nextProps.currentProductDetail.ProductNum,
	            currentRefNum: nextProps.currentProductDetail.RefNum,
	            currentProductCRV: nextProps.currentProductDetail.CRV,
	            currentProductDescription: nextProps.currentProductDetail.Description,
	            currentProductWeight: nextProps.currentProductDetail.NetWeight
	          }, _defineProperty(_selectedProduct, 'currentRefNum', nextProps.currentProductDetail.RefNum), _defineProperty(_selectedProduct, 'currentRefPrice', nextProps.currentProductDetail.RefPrice), _defineProperty(_selectedProduct, 'netWeight', nextProps.currentProductDetail.NetWeight), _selectedProduct),
	          ProductSKU: nextProps.currentProductDetail.ProductSKU,
	          MixedProduct: nextProps.currentProductDetail.MixedProducts,
	          permissionChecked: false
	        });
	        if (!nextProps.currentProductDetail.PriceType) {
	          switch (nextProps.currentProductDetail.ProductType) {
	            case 'Fixed':
	              this.props.setValue('productForm', 'PriceType', 'unit');
	              break;
	            default:
	              this.props.setValue('productForm', 'PriceType', 'weight');
	          }
	        }
	        if (nextProps.currentProductDetail.MixedProducts) {
	          //temporary fix for backend
	          if (nextProps.currentProductDetail.MixedProducts.length > 0) {
	            var mixedProductBaseUnit = {
	              value: nextProps.currentProductDetail.MixedProducts[0].Unit,
	              label: nextProps.currentProductDetail.MixedProducts[0].Unit
	            };
	            this.setState({
	              MixedProductBaseUnit: mixedProductBaseUnit
	            });
	            this.props.setValue('productForm', 'MixedProductBaseUnit', nextProps.currentProductDetail.MixedProducts[0].Unit);
	            this.props.setValue('productForm', 'MixedProduct', nextProps.currentProductDetail.MixedProducts);
	          }
	        }
	        if (nextProps.currentProductDetail.Product_id) {
	          this.getDisplayCategories(nextProps.currentProductDetail.Product_id);
	        }
	      }
	
	      if (nextProps.Default_Warehouse_id && nextProps.Default_Warehouse_id !== this.props.Default_Warehouse_id) {
	        if (nextProps.Default_Warehouse_id.value) {
	          console.log("Default_Warehouse_id", nextProps.Default_Warehouse_id.value);
	          this.props.fetchWarehouseDetail(nextProps.Default_Warehouse_id.value);
	          this.props.setValue('productForm', 'Zone', null);
	          this.props.setValue('productForm', 'Bin', null);
	          this.props.setValue('productForm', 'Level', null);
	        }
	      }
	      if (nextProps.dirty != this.props.dirty) {
	        this.setState({
	          dirty: nextProps.dirty
	        });
	      }
	      if (nextProps.ProductGroup_id && nextProps.ProductGroup_id !== this.props.ProductGroup_id) {
	        this.props.fetchGroupCategories(nextProps.ProductGroup_id.value || nextProps.ProductGroup_id);
	      }
	      if (nextProps.initialValues && nextProps.initialValues !== this.props.initialValues) {
	        this.props.setValue('productForm', 'GeneralNumber', nextProps.initialValues.GeneralNum);
	        this.props.setValue('productForm', 'ProductNumber', nextProps.initialValues.ProductNum);
	      }
	
	      // if(!nextProps.currentProduct && nextProps.currentProduct != this.props.currentProduct) {
	      //   this.forceUpdate();
	      // }
	
	      if (nextProps.smallProductDetail && nextProps.smallProductDetail !== this.props.smallProductDetail) {
	        this.props.setValue('productForm', 'SmallNetWeight', nextProps.smallProductDetail.NetWeight);
	        // this.props.setValue('productForm', 'SmallFixedWeight', nextProps.smallProductDetail);
	        // this.props.setValue('productForm', 'SmallCatchWeight', nextProps.smallProductDetail);
	      }
	
	      if (nextProps.productSaved && nextProps.productSaved !== this.props.productSaved) {
	        this.setState({
	          priceLv1: null
	        }, function () {
	          _this4.openShowProductCreated();
	        });
	      }
	
	      // if (nextProps.promotionDetails && nextProps.promotionDetails !== this.props.promotionDetails) {
	      //   let detailRows = (nextProps.promotionDetails) ? [...nextProps.promotionDetails.Promotion_Line] : [];
	      //   let promotionDetails = {...this.state.promotionDetails, rows: detailRows};
	      //   this.setState({promotionDetails})
	      // }
	      if (nextProps.checkPermissionSuccess && nextProps.checkPermissionSuccess !== this.props.checkPermissionSuccess) {
	        if (nextProps.checkPermissionSuccess.manager) {
	          this.closeEditRecPermission();
	          this.openProductGroupEdit();
	        }
	      }
	
	      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
	        if (this.state.deleteModalOpen === true) {
	          this.closeDeleteModal();
	          this.props.deleteProduct(this.props.currentProductDetail.Product_id);
	        } else {
	          this.closeCheckAuthorize();
	          this.openProductGroupEdit();
	        }
	      }
	
	      if (this.props.currentProductDetail && !nextProps.Default_Warehouse_id) {
	        this.props.fetchWarehouseDetail(this.props.currentProductDetail.Default_Warehouse_id);
	        this.setState({ PackageTypeC: this.props.currentProductDetail.PackageType });
	      }
	
	      if (nextProps.ProductCost !== this.props.ProductCost) {
	        // let arrivalPrice = Number(nextProps.ProductCost) + ( nextProps.currentProductDetail ? Number(nextProps.currentProductDetail.ShippingFeeUnitPrice) + Number(nextProps.currentProductDetail.MiscUnitPrice) : 0 );
	        if (isEcity && !this.state.priceLv1 && nextProps.currentProductDetail) {
	
	          // const p1Percentage = calculatePricePercentage(this.priceLv1.PriceLv1, this.props.RefPriceValue, basePrice)
	          // const p2Percentage = calculatePricePercentage(this.priceLv1.PriceLv2, this.props.RefPriceValue, basePrice)
	          // const p3Percentage = calculatePricePercentage(this.priceLv1.PriceLv3, this.props.RefPriceValue, basePrice)
	          // const priceLv1 = calculatePriceLevelNormal(this.state.p1Percentage, nextProps.RefPriceValue, arrivalPrice);
	          // const priceLv2 = calculatePriceLevelNormal(this.state.p2Percentage, nextProps.RefPriceValue, arrivalPrice);
	          // const priceLv3 = calculatePriceLevelNormal(this.state.p3Percentage, nextProps.RefPriceValue, arrivalPrice);
	          // const priceLv4 = calculatePriceLevelNormal(this.state.p4Percentage, nextProps.RefPriceValue, arrivalPrice);
	          // const priceLv5 = calculatePriceLevelNormal(this.state.p5Percentage, nextProps.RefPriceValue, arrivalPrice);
	          var _priceLv = nextProps.currentProductDetail.PriceLv1;
	          var _priceLv2 = nextProps.currentProductDetail.PriceLv2;
	          var _priceLv3 = nextProps.currentProductDetail.PriceLv3;
	          // const priceLv4 = nextProps.currentProduct.PriceLv4;
	          // const priceLv5 = nextProps.currentProduct.PriceLv5;
	          this.setState({
	            priceLv1: _priceLv,
	            priceLv2: _priceLv2,
	            priceLv3: _priceLv3
	            // priceLv4,
	            // priceLv5,
	          });
	        }
	      }
	      if (nextProps.ArrivalPrice !== this.props.ArrivalPrice && this.state.priceLv1 && isEcity) {
	        var _p1Percentage = (0, _NumberUtil.calculatePricePercentage)(this.state.priceLv1, this.props.RefPriceValue, nextProps.ArrivalPrice);
	        var _p2Percentage = (0, _NumberUtil.calculatePricePercentage)(this.state.priceLv2, this.props.RefPriceValue, nextProps.ArrivalPrice);
	        var _p3Percentage = (0, _NumberUtil.calculatePricePercentage)(this.state.priceLv3, this.props.RefPriceValue, nextProps.ArrivalPrice);
	        this.setState({
	          p1Percentage: _p1Percentage,
	          p2Percentage: _p2Percentage,
	          p3Percentage: _p3Percentage
	        });
	      }
	
	      if (nextProps.confirmPasscodeModal.verified) {
	        this.setState({
	          permissionChecked: true
	        }, function () {
	          _this4.props.setPasscodeVerificationStatus(false);
	        });
	      }
	
	      if (nextProps.currentProductDetail) {
	        var meta_info = {
	          meta_title: nextProps.currentProductDetail.meta_title,
	          meta_keywords: nextProps.currentProductDetail.meta_keywords,
	          meta_description: nextProps.currentProductDetail.meta_description
	        };
	        this.setState({ meta_info: meta_info });
	
	        if (nextProps.currentProductDetail.IsSyncToESL) {
	          this.setState({ eslEnabled: true });
	        } else {
	          this.setState({ eslEnabled: false });
	        }
	      }
	
	      if (nextProps.CalcoDispatchCase) {
	        this.props.setValue('productForm', 'SmallNetWeight', nextProps.CalcoDispatchCase);
	      }
	      if (nextProps.CalcoDispatchBag) {
	        this.props.setValue('productForm', 'SmallNetWeight', nextProps.CalcoDispatchBa);
	      }
	
	      if (nextProps && (nextProps.IsAllTaxable === true || nextProps.IsAllTaxable === 'true')) {
	        this.props.setDefaultOfForm("IsTaxable", "true", "productForm");
	      }
	      // if (!nextProps.DimensionUnit) {
	      //   this.props.setValue('productForm', 'DimensionUnit', 'inch');
	      // }
	    }
	  }, {
	    key: 'handleESLCheckbox',
	    value: function handleESLCheckbox(e) {
	      var _this5 = this;
	
	      var productId = this.props.currentProductDetail.Product_id;
	      if (e.target.value === 'true' || e.target.value === true) {
	        this.props.initializeESL(productId).then(function (response) {
	          _this5.setState({ eslEnabled: true });
	        }, function (err) {
	          alert("ESL Error: " + err.data);
	          _this5.props.setValue('productForm', 'IsSyncToESL', 'false');
	        });
	      }
	      if (e.target.value === 'false' || e.target.value === false) {
	        this.props.deleteESL(productId).then(function (response) {
	          _this5.setState({ eslEnabled: false });
	        }, function (err) {
	          alert("ESL Error: " + err.data);
	          _this5.props.setValue('productForm', 'IsSyncToESL', 'true');
	        });
	      }
	    }
	
	    //Get Display Categories
	
	
	    //Mix Product Search
	
	  }, {
	    key: 'closeDeleteModal',
	
	
	    // Helper function of popups
	    value: function closeDeleteModal() {
	      this.setState({ deleteModalOpen: false });
	    }
	  }, {
	    key: 'openDeleteModal',
	    value: function openDeleteModal() {
	      this.setState({ deleteModalOpen: true });
	      this.props.clearCheckPassword();
	    }
	  }, {
	    key: 'openVendor',
	    value: function openVendor() {
	      this.setState({ vendorOpen: true });
	    }
	  }, {
	    key: 'closeVendor',
	    value: function closeVendor() {
	      this.setState({ vendorOpen: false });
	    }
	  }, {
	    key: 'openGroup',
	    value: function openGroup() {
	      this.setState({ groupOpen: true });
	    }
	  }, {
	    key: 'closeGroup',
	    value: function closeGroup() {
	      this.setState({ groupOpen: false });
	    }
	  }, {
	    key: 'openCategory',
	    value: function openCategory() {
	      this.setState({ categoryOpen: true });
	    }
	  }, {
	    key: 'closeCategory',
	    value: function closeCategory() {
	      this.setState({ categoryOpen: false });
	    }
	  }, {
	    key: 'openShowProductCreated',
	    value: function openShowProductCreated() {
	      this.setState({ showProductCreatedOpen: true });
	    }
	  }, {
	    key: 'closeShowProductCreated',
	    value: function closeShowProductCreated() {
	      this.setState({ showProductCreatedOpen: false });
	    }
	  }, {
	    key: 'closeNavigation',
	    value: function closeNavigation() {
	      this.setState({ productNavigationOpen: [] });
	    }
	  }, {
	    key: 'openPackageType',
	    value: function openPackageType() {
	      this.setState({ packageTypeOpen: true });
	    }
	  }, {
	    key: 'closePackageType',
	    value: function closePackageType() {
	      this.setState({ packageTypeOpen: false });
	    }
	  }, {
	    key: 'selectPackageType',
	    value: function selectPackageType(row) {
	      this.props.setValue("productForm", 'PackageType_2', row.Simple);
	      this.closePackageType();
	    }
	  }, {
	    key: 'handleClickFinish',
	    value: function handleClickFinish(productNavigation_3) {
	      var packageSize = (this.state.productNavigation_2.PackageSize_1 || "") + '\n      ' + (this.state.productNavigation_2.PackageType_2 && this.state.productNavigation_2.PackageType_2.value || "") + '\n      *' + (this.state.productNavigation_2.PackageSize_2 || "") + '\n      ' + (this.state.productNavigation_2.MeasureUnit_2 && this.state.productNavigation_2.MeasureUnit_2.value || "");
	      if (packageSize[0] == '*') {
	        packageSize = packageSize.slice(1);
	      }
	      var netWeightUnit = this.state.productNavigation_2.NetWeight_2 && this.state.productNavigation_2.NetWeight_2.value;
	      var netWeight = parseFloat(this.state.productNavigation_2.NetWeight_1) || 0;
	      if (netWeightUnit == "kg") {
	        netWeight = 2.20462 * netWeight;
	      }
	      var diffWeight = 0;
	      if (this.state.productNavigation_2.ProdType && this.state.productNavigation_2.ProdType.value == "Non-Fixed") {
	        if (netWeight > 10) {
	          diffWeight = 10;
	        } else if (netWeight > 0) {
	          diffWeight = 5;
	        }
	      }
	
	      var convertNum = null;
	      if (productNavigation_3.ConvertType === "weight") {
	        convertNum = netWeight;
	      } else if (productNavigation_3.ConvertType === "unit") {
	        convertNum = this.state.productNavigation_2.PackageSize_1;
	      }
	
	      this.props.setValue('productForm', 'ProductGroup_id', this.state.productNavigation_1.ProductGroup_id);
	      this.props.setValue('productForm', 'ProductCategory1_id', this.state.productNavigation_1.ProductCategory1_id);
	      this.props.setValue('productForm', 'Name', this.state.productNavigation_1.Name);
	      if (isWIZ) {
	        this.props.setValue('productForm', 'RefNum', this.state.productNavigation_1.Name);
	      }
	      this.props.setValue('productForm', 'Description', this.state.productNavigation_1.Description);
	      this.props.setValue('productForm', 'ProductNum', this.state.productNavigation_1.ProductNum);
	      this.props.setValue('productForm', 'IsRelated', this.state.productNavigation_1.isLinked.toString());
	      this.props.setValue('productForm', 'IsLarge', this.state.productNavigation_1.IsLarge);
	
	      this.props.setValue('productForm', 'ProductType', this.state.productNavigation_2.ProdType);
	      this.props.setValue('productForm', 'PackageType', this.state.productNavigation_2.PackageType);
	      this.props.setValue('productForm', 'PackageSize', packageSize);
	      this.props.setValue('productForm', 'PackageSize_1', this.state.productNavigation_2.PackageSize_1);
	      this.props.setValue('productForm', 'PackageType_2', this.state.productNavigation_2.PackageType_2);
	      this.props.setValue('productForm', 'PackageSize_2', this.state.productNavigation_2.PackageSize_2);
	      this.props.setValue('productForm', 'MeasureUnit_2', this.state.productNavigation_2.MeasureUnit_2);
	      this.props.setValue('productForm', 'MeasureUnit', this.state.productNavigation_2.NetWeight_2);
	      this.props.setValue('productForm', 'NetWeight', netWeight);
	      this.props.setValue('productForm', 'ShippingWeight', netWeight);
	
	      this.props.setValue('productForm', 'MinWeightRange', Math.max(0, netWeight - diffWeight));
	      this.props.setValue('productForm', 'MaxWeightRange', netWeight + diffWeight);
	      this.props.setValue('productForm', 'RefPrice', this.state.productNavigation_2.RefPrice);
	      this.props.setValue('productForm', 'LowestSalePrice', this.state.productNavigation_2.LowestSalePrice);
	
	      this.props.setValue('productForm', 'ConvertNum', convertNum);
	      this.props.setValue('productForm', 'SmallProdType', productNavigation_3.SmallProdType);
	      this.props.setValue('productForm', 'SmallPackageType', productNavigation_3.SmallPackageType);
	      this.props.setValue('productForm', 'ConvertType', productNavigation_3.ConvertType);
	      // break points
	      var priceLv1 = (0, _NumberUtil.calculatePriceLevelNormal)(this.state.p1Percentage || 0, this.state.productNavigation_2.RefPrice, this.props.ArrivalPrice);
	      var priceLv2 = (0, _NumberUtil.calculatePriceLevelNormal)(this.state.p2Percentage || 0, this.state.productNavigation_2.RefPrice, this.props.ArrivalPrice);
	      var priceLv3 = (0, _NumberUtil.calculatePriceLevelNormal)(this.state.p3Percentage || 0, this.state.productNavigation_2.RefPrice, this.props.ArrivalPrice);
	      var priceLv4 = (0, _NumberUtil.calculatePriceLevelNormal)(this.state.p4Percentage || 0, this.state.productNavigation_2.RefPrice, this.props.ArrivalPrice);
	      var priceLv5 = (0, _NumberUtil.calculatePriceLevelNormal)(this.state.p5Percentage || 0, this.state.productNavigation_2.RefPrice, this.props.ArrivalPrice);
	
	      this.setState({
	        priceLv1: priceLv1,
	        priceLv2: priceLv2,
	        priceLv3: priceLv3,
	        priceLv4: priceLv4,
	        priceLv5: priceLv5
	      });
	    }
	  }, {
	    key: 'handleOnFocus',
	    value: function handleOnFocus(event) {
	      event.target.select();
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(files) {
	      // this.props.attachProductImage(this.props.currentProduct.Product_id, files);
	      this.setState({
	        files: files
	      });
	    }
	  }, {
	    key: 'onOpenClick',
	    value: function onOpenClick() {
	      this.props.clearAttachedProductImage();
	      // this.refs.dropzone.open();
	    }
	  }, {
	    key: 'title',
	    value: function title() {
	      if (!this.props.params.id) {
	        return _react2.default.createElement(
	          'h3',
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_a_new_product' })
	        );
	      }
	      return _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_product' }),
	        this.props.currentProduct.Name
	      );
	    }
	  }, {
	    key: 'navigate',
	    value: function navigate(page) {
	      var productNavigationOpen = [].concat(_toConsumableArray(this.state.productNavigationOpen));
	      productNavigationOpen = productNavigationOpen.map(function (r) {
	        return false;
	      });
	      productNavigationOpen[page] = true;
	      this.setState({ productNavigationOpen: productNavigationOpen });
	    }
	  }, {
	    key: 'saveCurrentModal',
	    value: function saveCurrentModal(ProductCategory1_id, ProductGroup_id, suggestedProdNum, isLinked, Name, Description, IsLarge, LastDigit, ProductNum) {
	      var productNavigation_1 = _extends({}, this.state.productNavigation_1, { ProductCategory1_id: ProductCategory1_id, ProductGroup_id: ProductGroup_id, suggestedProdNum: suggestedProdNum, isLinked: isLinked, Name: Name, Description: Description, IsLarge: IsLarge, LastDigit: LastDigit, ProductNum: ProductNum });
	      this.setState({ productNavigation_1: productNavigation_1 });
	    }
	  }, {
	    key: 'handleClickNext_1',
	    value: function handleClickNext_1(ProductCategory1_id, ProductGroup_id, suggestedProdNum, isLinked, Name, Description, IsLarge, LastDigit, ProductNum) {
	      this.saveCurrentModal(ProductCategory1_id, ProductGroup_id, suggestedProdNum, isLinked, Name, Description, IsLarge, LastDigit, ProductNum);
	      this.navigate(1);
	    }
	  }, {
	    key: 'handleClickPrev_2',
	    value: function handleClickPrev_2(ProdType, PackageType, PackageSize_1, PackageType_2, PackageSize_2, MeasureUnit_2, NetWeight_1, NetWeight_2, RefPrice, LowestSalePrice) {
	      var productNavigation_2 = _extends({}, this.state.productNavigation_2, {
	        ProdType: ProdType,
	        PackageType: PackageType,
	        PackageSize_1: PackageSize_1,
	        PackageType_2: PackageType_2,
	        PackageSize_2: PackageSize_2,
	        MeasureUnit_2: MeasureUnit_2,
	        NetWeight_1: NetWeight_1,
	        NetWeight_2: NetWeight_2,
	        RefPrice: RefPrice,
	        LowestSalePrice: LowestSalePrice
	      });
	      this.setState({ productNavigation_2: productNavigation_2 });
	      this.navigate(0);
	    }
	  }, {
	    key: 'handleClickNext_2',
	    value: function handleClickNext_2(ProdType, PackageType, PackageSize_1, PackageType_2, PackageSize_2, MeasureUnit_2, NetWeight_1, NetWeight_2, RefPrice, LowestSalePrice) {
	      var _this6 = this;
	
	      var productNavigation_2 = _extends({}, this.state.productNavigation_2, {
	        ProdType: ProdType,
	        PackageType: PackageType,
	        PackageSize_1: PackageSize_1,
	        PackageType_2: PackageType_2,
	        PackageSize_2: PackageSize_2,
	        MeasureUnit_2: MeasureUnit_2,
	        NetWeight_1: NetWeight_1,
	        NetWeight_2: NetWeight_2,
	        RefPrice: RefPrice,
	        LowestSalePrice: LowestSalePrice
	        // this.setState({ productNavigation_2 });
	      });this.setState({ productNavigation_2: productNavigation_2 }, function () {
	        if (!isHMM) {
	          _this6.navigate(2);
	        } else {
	          _this6.saveProductFormNavigation_3(1, null, null, "unit");
	          _this6.closeNavigation();
	        }
	      });
	    }
	  }, {
	    key: 'handleClickPrev_3',
	    value: function handleClickPrev_3(ConvertNum, SmallProdType, SmallPackageType, ConvertType) {
	      this.saveProductFormNavigation_3(ConvertNum, SmallProdType, SmallPackageType, ConvertType);
	      this.navigate(1);
	    }
	  }, {
	    key: 'saveProductFormNavigation_3',
	    value: function saveProductFormNavigation_3(ConvertNum, SmallProdType, SmallPackageType, ConvertType) {
	      var productNavigation_3 = _extends({}, this.state.productNavigation_3, {
	        ConvertNum: ConvertNum,
	        SmallProdType: SmallProdType,
	        SmallPackageType: SmallPackageType,
	        ConvertType: ConvertType
	      });
	      this.setState({ productNavigation_3: productNavigation_3 });
	      this.handleClickFinish(productNavigation_3);
	    }
	  }, {
	    key: 'saveRichText',
	    value: function saveRichText(htmlText) {
	      var Product_id = this.props.currentProductDetail.Product_id;
	
	      this.props.saveMobileDescriptionBoxText(Product_id, htmlText);
	    }
	  }, {
	    key: 'handleKeyPress',
	    value: function handleKeyPress(value, event) {
	      if (event.charCode == 13) {
	        event.preventDefault();
	        _reactDom2.default.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	      }
	    }
	  }, {
	    key: 'renderMixedProduct',
	
	
	    // Mix Products Render
	    value: function renderMixedProduct() {
	      var packageTypeOptions = this.getPackageTypeOptions();
	      return _react2.default.createElement(_reduxForm.FieldArray, { name: 'MixedProduct', component: renderMixProductArrays, suggestProduct: this.state.suggestProduct, packageTypeOptions: packageTypeOptions });
	    }
	
	    // Render the vendor, group and category options dynamically with the information
	    // on the server.
	
	  }, {
	    key: 'renderVendors',
	    value: function renderVendors() {
	      if (this.props.vendorIsLoading) return _react2.default.createElement(_spinner2.default, null); // If vendor is loading, show a spinner.
	      var vendorNameOptions = this.getVendorNameOptions(); // Return a JSON in the format of React-Select's options
	      var vendorNumOptions = this.getVendorNumOptions();
	      return _react2.default.createElement(_reduxForm.FieldArray, { name: 'Vendors', component: renderVendorArrays, openVendor: this.openVendor, vendorNumOptions: vendorNumOptions, vendorNameOptions: vendorNameOptions });
	    }
	  }, {
	    key: 'renderConvertDetails',
	    value: function renderConvertDetails() {
	      var _this7 = this;
	
	      if (this.state.productNavigationOpen[2] === true) {
	        return _react2.default.createElement('div', null);
	      }
	      var _state = this.state,
	          relatedProducts = _state.relatedProducts,
	          productNavigation_1 = _state.productNavigation_1,
	          productNavigation_2 = _state.productNavigation_2;
	
	      var currentProductNum = void 0;
	      var currentRefNum = void 0;
	      var currentPackageSize = void 0;
	      var currentProductType = void 0;
	      var isCreate = !this.props.params.id;
	      if (isCreate) {
	        if (!productNavigation_1.ProductNum || !productNavigation_2.PackageSize_1 || !productNavigation_2.PackageSize_2 || !productNavigation_2.PackageType_2 || !productNavigation_2.MeasureUnit_2) {
	          return _react2.default.createElement('div', null);
	        }
	        currentProductNum = productNavigation_1.ProductNum;
	        currentRefNum = productNavigation_1.RefNum;
	        currentPackageSize = '' + productNavigation_2.PackageSize_1 + productNavigation_2.PackageType_2.value + '*' + productNavigation_2.PackageSize_2 + productNavigation_2.MeasureUnit_2.value;
	        currentProductType = productNavigation_2.ProdType.value;
	      } else if (relatedProducts.length > 0) {
	        currentProductNum = relatedProducts[0].ProductNum;
	        currentRefNum = relatedProducts[0].RefNum;
	        currentPackageSize = relatedProducts[0].PackageSize;
	        currentProductType = relatedProducts[0].ProductType;
	      }
	      if (this.props.fetchingConvertableProducts && !this.props.convertableProductsFetchError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      }
	      return relatedProducts.length > 0 && _react2.default.createElement(
	        'div',
	        null,
	        (0, _map2.default)(relatedProducts, function (product, index) {
	          return index === 0 ? _react2.default.createElement(
	            'div',
	            { key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'related-products-heading1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'related-products-current' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  isUSPride ? currentRefNum : currentProductNum
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  currentPackageSize
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'related-products-heading2' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  currentProductType
	                ),
	                _react2.default.createElement(_SpinnerButton2.default, {
	                  className: 'related-products-link-product',
	                  bsStyle: 'primary',
	                  icon: 'fa-plus',
	                  onClick: _this7.handleAddConvertProductClick,
	                  disabled: _this7.state.isLoadingCategoryProducts,
	                  loading: _this7.state.isLoadingCategoryProducts
	                })
	              )
	            ),
	            _react2.default.createElement('hr', { style: { borderTopColor: '#000' } })
	          ) : _react2.default.createElement(
	            'div',
	            { key: index, className: 'related-products' },
	            _react2.default.createElement(
	              'div',
	              { style: { fontSize: '12px' } },
	              isUSPride ? product.RefNum : product.ProductNum
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { width: '80px', fontSize: '12px' } },
	              product.PackageSize
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'related-products-auto-convert' },
	              (isATL || isCS || isAmzey || isAPO || isUSPride) && _react2.default.createElement('input', {
	                type: 'text',
	                style: { border: '1px solid black', width: '30px', marginRight: '12px', paddingLeft: '5px' },
	                name: 'link-product',
	                value: product.ConvertNum,
	                onChange: function onChange(e) {
	                  _this7.handleConvertInput(product, e.target.value);
	                }
	              }),
	              _react2.default.createElement(
	                'span',
	                null,
	                product.ProductType
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'auto-convert-block' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'link-product',
	                  checked: product.auto_convert,
	                  onClick: function onClick() {
	                    return _this7.handleAutoConvertClick(product);
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'auto' })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  className: 'related-products-link-product',
	                  bsStyle: 'danger',
	                  onClick: function onClick() {
	                    return _this7.handleRelatedProductDelete(product);
	                  }
	                },
	                _react2.default.createElement('em', { className: 'fa fa-trash' })
	              )
	            )
	          );
	        })
	      );
	      // return (
	      //     <FieldArray name="Related_Products" component={renderConvertDetailsList} />
	      // )
	    }
	  }, {
	    key: 'renderSearchStatus',
	    value: function renderSearchStatus() {
	      if (this.props.smallProductDetailIsLoading) return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 2 },
	        _react2.default.createElement(_spinner2.default, null)
	      );else if (this.props.smallProductDetailError || this.props.smallProductDetail && this.props.smallProductDetail.length == 0) {
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement('i', { className: 'fa fa-times alert alert-danger' })
	        );
	      } else if (this.props.smallProductDetail) {
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement('i', { className: 'fa fa-check alert alert-success' })
	        );
	      } else {
	        return;
	      }
	    }
	
	    // Push vendor name and number in to 2 JSON arrays.
	
	  }, {
	    key: 'getVendorNameOptions',
	    value: function getVendorNameOptions() {
	      var vendorNameOptions = [];
	      this.props.vendors.map(function (vendor) {
	        vendorNameOptions.push({ value: vendor.Vendor_id, label: vendor.Name });
	      });
	      return vendorNameOptions;
	    }
	  }, {
	    key: 'getVendorNumOptions',
	    value: function getVendorNumOptions() {
	      var vendorNumOptions = [];
	      this.props.vendors.map(function (vendor) {
	        vendorNumOptions.push({ value: vendor.Vendor_id, label: vendor.VendorNum });
	      });
	      return vendorNumOptions;
	    }
	
	    // promotion function
	
	  }, {
	    key: 'renderPromoDetails',
	    value: function renderPromoDetails() {
	      var _this8 = this;
	
	      var that = this;
	      if (this.state.promotionDetailsIsLoading) return _react2.default.createElement(_spinner2.default, null);
	      // else if (this.props.promotionDetailsError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.promotionDetailsError)}</div></ContentWrapper>
	      // Parameters of the react-data-grid
	      var tableHeight = window.innerHeight < 900 ? 200 : 200;
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this8.state.promotionDetails);
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var promotionDetails = Object.assign({}, _this8.state.promotionDetails, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this8.setState({ promotionDetails: promotionDetails });
	      };
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this8.state.promotionDetails.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var promotionDetails = _extends({}, _this8.state.promotionDetails, { filters: newFilters });
	        _this8.setState({ promotionDetails: promotionDetails });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = _this8.state.promotionDetails.rows;
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        var promotionDetails = _extends({}, _this8.state.promotionDetails, { rows: newRows });
	        _this8.setState({ promotionDetails: promotionDetails });
	      };
	
	      var onRowClick = function onRowClick(rowIdx, row) {
	        _this8.openEditPromotion();
	        _this8.props.resetCurrentPromotions();
	        _this8.handleFetchPromotionDetails(row.Promotion_id);
	      };
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	            var date = new Date(this.props.value);
	            var index = dateMap.indexOf(date.toString().slice(4, 3));
	            var localDate = index + date.toString().slice(8, 6);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var DeleteButtonFormatter = _react2.default.createClass({
	        displayName: 'DeleteButtonFormatter',
	        render: function render() {
	          var _this9 = this;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                className: 'textAlignStyle',
	                style: { height: '23px', width: '39px', padding: '0px' },
	                onClick: function onClick() {
	                  var dependentValues = _this9.props.dependentValues;
	
	                  that.openDeletePromotion(dependentValues.PromotionLine_id);
	                }
	              },
	              'X'
	            )
	          );
	        }
	      });
	
	      var EditButtonFormatter = _react2.default.createClass({
	        displayName: 'EditButtonFormatter',
	        render: function render() {
	          var _this10 = this;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'warning',
	                className: 'textAlignStyle',
	                style: { height: '23px', width: '45px', padding: '0px' },
	                onClick: function onClick() {
	                  var dependentValues = _this10.props.dependentValues;
	
	                  that.handleOpenEditPromotion(dependentValues.PromotionLine_id);
	                }
	              },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	            )
	          );
	        }
	      });
	
	      // Column difinition
	      var columns = [{
	        key: 'Delete',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: DeleteButtonFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'Edit',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' }),
	        width: 55,
	        formatter: EditButtonFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'DiscountDescription',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount_description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 260
	      }, {
	        key: 'StartDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'start_date' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: 'EndDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'end_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { id: 'ProductForm-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'Promotion_id',
	              onGridSort: handleGridSort,
	              columns: columns,
	              rowGetter: rowGetter,
	              rowHeight: 25,
	              headerRowHeight: 30,
	              minHeight: tableHeight,
	              rowsCount: getSize()
	              // onRowClick={onRowClick}
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderGroups',
	    value: function renderGroups() {
	      var _this11 = this;
	
	      var productGroupOptions = this.getProductGroupOptions();
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        { className: 'formRow' },
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 3 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: isSoleStage() ? "brand" : "group" })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 9 },
	          !this.props.currentProduct && !this.props.params.id ? _react2.default.createElement(_reduxForm.Field, {
	            name: 'ProductGroup_id',
	            component: _selection.Selection,
	            withRef: true,
	            ref: 'ProductGroup',
	            options: productGroupOptions,
	            onKeyPress: function onKeyPress(event) {
	              if (event.keyCode == 13) {
	                _this11.refs["ProductCat1"].getRenderedComponent().refs.select.focus();
	              }
	            }
	          }) : _react2.default.createElement(_reduxForm.Field, { name: 'ProductGroup_id', component: _selection.DisabledSelection, options: productGroupOptions })
	        )
	      );
	    }
	  }, {
	    key: 'getProductGroupOptions',
	    value: function getProductGroupOptions() {
	      var productGroupOptions = [];
	      if (this.props.groups) {
	        this.props.groups.map(function (group) {
	          productGroupOptions.push({ value: group.ProductGroup_id, label: group.Name });
	        });
	      }
	      return productGroupOptions;
	    }
	  }, {
	    key: 'CRV',
	    value: function CRV() {
	      var _this12 = this;
	
	      var CRVOptions = this.getCRVOptions();
	      return _react2.default.createElement(_reduxForm.Field, { name: 'CRV_id', component: _selection.Selection, withRef: true, ref: 'CRVOptions', options: CRVOptions, onKeyPress: function onKeyPress(event) {
	          if (event.keyCode == 13) _reactDom2.default.findDOMNode(_this12.refs["MeasureUnit"].getRenderedComponent().myInput.refs.input).focus();
	        } });
	    }
	  }, {
	    key: 'getCRVOptions',
	    value: function getCRVOptions() {
	      var CRVOptions = [];
	      this.props.CRVs.map(function (CRV) {
	        CRVOptions.push({ value: CRV.Product_id, label: CRV.Name });
	      });
	      return CRVOptions;
	    }
	  }, {
	    key: 'renderDefaultBuyers',
	    value: function renderDefaultBuyers() {
	      var _this13 = this;
	
	      var defaultBuyerOptions = this.getDefaultBuyerOptions();
	      return _react2.default.createElement(_reduxForm.Field, { name: 'Purchaser_User_id', withRef: true, ref: 'defaultBuyerOptions', component: _selection.Selection, options: defaultBuyerOptions, onKeyPress: function onKeyPress(event) {
	          if (event.keyCode == 13) _reactDom2.default.findDOMNode(_this13.refs["MeasureUnit"].getRenderedComponent().myInput.refs.input).focus();
	        } });
	    }
	  }, {
	    key: 'defaultSales',
	    value: function defaultSales() {
	      var defaultBuyerOptions = this.getDefaultBuyerOptions();
	      return _react2.default.createElement(_reduxForm.Field, { name: 'Sales_User_id', component: _selection.Selection, options: defaultBuyerOptions });
	    }
	  }, {
	    key: 'getDefaultBuyerOptions',
	    value: function getDefaultBuyerOptions() {
	      return this.props.defaultBuyers.map(function (defaultBuyer) {
	        return {
	          value: defaultBuyer.BaseUser_id,
	          label: defaultBuyer.username
	        };
	      });
	    }
	  }, {
	    key: 'renderCategories',
	    value: function renderCategories() {
	      var _this14 = this;
	
	      var productCategoryOptions = this.getProductCategoryOptions();
	      var productCategory2Options = this.getProductCategory2Options();
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'formRow' },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 3 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: isSoleStage() ? "style" : "category_1" })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 9 },
	            !this.props.currentProduct && !this.props.params.id ? _react2.default.createElement(_reduxForm.Field, { name: 'ProductCategory1_id', className: 'control-label', component: _selection.Selection, withRef: true, ref: 'ProductCat1', options: productCategoryOptions, onKeyPress: function onKeyPress(event) {
	                if (event.keyCode == 13) {
	                  _this14.refs["ProductCat2"].getRenderedComponent().refs.select.focus();
	                }
	              } }) : _react2.default.createElement(_reduxForm.Field, { name: 'ProductCategory1_id', className: 'control-label', component: _selection.DisabledSelection, options: productCategoryOptions })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDisplayCategories',
	    value: function renderDisplayCategories() {
	      if (this.props.params.id) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'display' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 9 },
	              _react2.default.createElement(_SpinnerButton2.default, {
	                bsStyle: 'primary',
	                icon: 'fa-pencil',
	                onClick: this.handleDisplayCategoryBoxClick,
	                disabled: this.state.isLoadingDisplayCategory,
	                loading: this.props.editCategoryLoading,
	                translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_display_category' })
	              })
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'display' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 9 },
	              _react2.default.createElement(
	                'span',
	                { style: { color: 'red' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_display_category_warning' })
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'getProductCategoryOptions',
	    value: function getProductCategoryOptions() {
	      var productCategoryOptions = [];
	      this.props.groupCategories.map(function (category) {
	        productCategoryOptions.push({ value: category.ProductCategory_id, label: category.Name });
	      });
	      return productCategoryOptions;
	    }
	  }, {
	    key: 'getProductCategory2Options',
	    value: function getProductCategory2Options() {
	      var productCategory2Options = [];
	      if (this.props.categories2) {
	        this.props.categories2.map(function (category2) {
	          productCategory2Options.push({ value: category2.ProductCategory2_id, label: category2.Name });
	        });
	      }
	      return productCategory2Options;
	    }
	  }, {
	    key: 'getZoneOptions',
	    value: function getZoneOptions() {
	      var zoneOptions = [];
	      this.props.zones.map(function (zone) {
	        zoneOptions.push({ value: zone.zone_num, label: zone.zone_num });
	      });
	      zoneOptions.sort(function (a, b) {
	        if (a.value > b.value) {
	          return 1;
	        }
	        if (a.value < b.value) {
	          return -1;
	        }
	        return 0;
	      });
	      return zoneOptions;
	    }
	  }, {
	    key: 'renderVolumeDimension',
	    value: function renderVolumeDimension() {
	      var _this15 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          'label',
	          { className: 'col-xs-3' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dimension' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-2' },
	          _react2.default.createElement(_reduxForm.Field, {
	            name: 'DimensionHeight',
	            className: 'control-label',
	            component: _inputField.InputField,
	            withRef: true,
	            ref: 'ProductType',
	            onKeyPress: function onKeyPress(event) {
	              if (event.key === 'Enter') {
	                _this15.refs["DimensionLength"].getRenderedComponent().refs.select.focus();
	              }
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-1' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'x'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-2' },
	          _react2.default.createElement(_reduxForm.Field, {
	            name: 'DimensionLength',
	            className: 'control-label',
	            component: _inputField.InputField,
	            withRef: true,
	            ref: 'ProductType',
	            onKeyPress: function onKeyPress(event) {
	              if (event.key === 'Enter') {
	                _this15.refs["DimensionWidth"].getRenderedComponent().refs.select.focus();
	              }
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-1' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'x'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-2' },
	          _react2.default.createElement(_reduxForm.Field, {
	            name: 'DimensionWidth',
	            className: 'control-label',
	            component: _inputField.InputField,
	            withRef: true,
	            ref: 'ProductType',
	            onKeyPress: function onKeyPress(event) {
	              if (event.key === 'Enter') {
	                _this15.refs["DimensionHeight"].getRenderedComponent().refs.select.focus();
	              }
	            }
	          })
	        ),
	        !isPS && !isHMM && !isWIZ && !isJTB && !isTN && !isABCFF && !isAPO && !_root_url.isElegant && _react2.default.createElement(
	          'div',
	          { className: 'nonbold-label-description textAlignStyle' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: '(ft)' })
	        ),
	        _root_url.isElegant && _react2.default.createElement(
	          'div',
	          { className: 'nonbold-label-description textAlignStyle' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: '(inch)' })
	        ),
	        (isPS || isWIZ || isTN || isABCFF || isAPO) && _react2.default.createElement(
	          'div',
	          { className: 'nonbold-label-description textAlignStyle' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: '(in)' })
	        )
	      );
	    }
	  }, {
	    key: 'renderTotalVolume',
	    value: function renderTotalVolume() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          'label',
	          { className: 'col-xs-4' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_volume' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-3' },
	          _react2.default.createElement(_reduxForm.Field, {
	            name: 'Volume',
	            className: 'control-label',
	            component: _inputField.InputField,
	            withRef: true,
	            ref: 'ProductType'
	            // onKeyPress={(event) => {
	            //   if (event.key === 'Enter') {
	            //     this.refs["DimensionLength"].getRenderedComponent().refs.select.focus();
	            //   }
	            // }}
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderCBM',
	    value: function renderCBM() {
	      var _props = this.props,
	          DimensionUnit = _props.DimensionUnit,
	          DimensionHeight = _props.DimensionHeight,
	          DimensionLength = _props.DimensionLength,
	          DimensionWidth = _props.DimensionWidth;
	
	
	      var cbm = 0;
	      if (DimensionUnit) {
	        if (DimensionUnit === 'cm' || DimensionUnit.value === 'cm') {
	          cbm = DimensionHeight / 100 * (DimensionLength / 100) * (DimensionWidth / 100);
	          // cbm = cbm.toFixed(15);
	          cbm = Math.round(cbm * 1000000000000) / 1000000000000;
	        }
	        if (DimensionUnit === 'inch' || DimensionUnit.value === 'inch') {
	          cbm = DimensionHeight * 0.0254 * (DimensionLength * 0.0254) * (DimensionWidth * 0.0254);
	          cbm = Math.round(cbm * 1000000000000) / 1000000000000;
	        }
	      } else {
	        cbm = 'N/A';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          'label',
	          { className: 'col-xs-3' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'CBM' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-5' },
	          _react2.default.createElement('input', { value: cbm, disabled: true, style: customizedInputStyle })
	        )
	      );
	    }
	  }, {
	    key: 'renderCBMUnit',
	    value: function renderCBMUnit() {
	      var _this16 = this;
	
	      var dimensionUnitOption = [{ value: "inch", label: "inch" }, { value: "cm", label: "cm" }];
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          'label',
	          { className: 'col-xs-4' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dimension_unit' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-4' },
	          _react2.default.createElement(_reduxForm.Field, { name: 'DimensionUnit', component: _selection.Selection, options: dimensionUnitOption,
	            onKeyPress: function onKeyPress(event) {
	              setTimeout(function () {
	                _this16.props.setValue('productForm', 'DimensionUnit', event.target.value);
	              }, 200);
	              //   event.stopPropagation();
	              // if (event.keyCode == 13) {
	              //   this.refs["PackageType"].getRenderedComponent().refs.select.focus();
	              // }
	            }
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderProductType',
	    value: function renderProductType() {
	      var _this17 = this;
	
	      var typeOptions = [{
	        value: 'Fixed',
	        label: 'Fixed'
	      }, {
	        value: 'Non-Fixed',
	        label: 'Non-Fixed'
	      }, {
	        value: 'Service',
	        label: 'Service'
	      }, {
	        value: 'Non-Product',
	        label: 'Non-Product'
	      }, {
	        value: 'Per-Pound',
	        label: 'Per-Pound'
	      }];
	      var colorOptions = [{
	        value: 'Black',
	        label: 'Black'
	      }, {
	        value: 'White',
	        label: 'White'
	      }, {
	        value: 'Red',
	        label: 'Red'
	      }, {
	        value: 'Gery',
	        label: 'Gery'
	      }, {
	        value: 'Blue',
	        label: 'Blue'
	      }, {
	        value: 'Pink',
	        label: 'Pink'
	      }];
	      return isSoleStage(_root_url.ROOT_URL) ? _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 6 },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-4' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_type' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'asteriksReq' },
	                '*'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-8' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'ProductType', className: 'control-label', component: _selection.Selection, withRef: true, ref: 'ProductType', options: typeOptions, onKeyPress: function onKeyPress(event) {
	                  if (event.keyCode === 13) {
	                    _this17.refs["ProductColor"].getRenderedComponent().refs.select.focus();
	                  }
	                } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 6 },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'color' }),
	              _react2.default.createElement('span', { className: 'asteriksReq' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-9' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'ProductColor', className: 'control-label', component: _selection.Selection, withRef: true, ref: 'ProductColor', options: colorOptions, onKeyPress: function onKeyPress(event) {
	                  if (event.keyCode === 13) {
	                    _this17.refs["MeasureUnit"].getRenderedComponent().refs.select.focus();
	                  }
	                } })
	            )
	          )
	        )
	      ) : _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          'label',
	          { className: 'col-xs-4' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_type' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'asteriksReq' },
	            '*'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-8' },
	          _react2.default.createElement(_reduxForm.Field, { name: 'ProductType', className: 'control-label', component: _selection.Selection, withRef: true, ref: 'ProductType', options: typeOptions, onKeyPress: function onKeyPress(event) {
	              if (event.keyCode === 13) {
	                _this17.refs["MeasureUnit"].getRenderedComponent().refs.select.focus();
	              }
	            } })
	        )
	      );
	    }
	
	    // renderRelatedProduct() {
	    //     if (this.props.productIsLoading) return <Spinner/> // If group is loading, show a spinner.
	    //     else {
	    //         let productOptions = this.getProductOptions();
	    //         return (
	    //             <Row>
	    //                 <Col xs={ 12 }>
	    //                     <div className="form-group">
	    //                       <label className="col-xs-4"><Translate value="related_product"/></label>
	    //                       <div className="col-xs-8">
	    //                         <Field name="Related_Product_id" className="control-label" component={Selection} withRef={true} ref="RelatedProduct" options={productOptions} onKeyPress={(event) => {
	    //                           if (event.keyCode == 13) {
	    //                             this.refs["MeasureUnit"].getRenderedComponent().refs.select.focus();
	    //                           }
	    //                         }}/>
	    //                       </div>
	    //                     </div>
	    //                 </Col>
	    //             </Row>
	    //         )
	    //     }
	    // }
	
	    // getProductOptions() {
	    //     var productOptions = [];
	    //     this.props.products.map(product => {
	    //         productOptions.push({ value: product.Product_id, label: product.Name })
	    //     });
	    //     return productOptions;
	    // }
	
	  }, {
	    key: 'renderWarehouse',
	    value: function renderWarehouse() {
	      if (this.props.warehouseIsLoading) return _react2.default.createElement(_spinner2.default, null); // If group is loading, show a spinner.
	      else {
	          var warehouseOptions = this.getWarehouseOptions();
	          return _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 6 },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'default_warehouse' })
	                ),
	                _react2.default.createElement(_reduxForm.Field, { name: 'Default_Warehouse_id', component: _selection.Selection, options: warehouseOptions })
	              )
	            )
	          );
	        }
	    }
	  }, {
	    key: 'getWarehouseOptions',
	    value: function getWarehouseOptions() {
	      var warehouseOptions = [];
	      this.props.warehouses.map(function (warehouse) {
	        warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name });
	      });
	      return warehouseOptions;
	    }
	  }, {
	    key: 'getMeasureUnitOptions',
	    value: function getMeasureUnitOptions() {
	      var measureUnitOptions = [];
	      if (this.props.measurementUnitFetched) {
	        this.props.measurementUnitFetched.map(function (measureUnit) {
	          measureUnitOptions.push({ value: measureUnit.Simple, label: measureUnit.Simple });
	        });
	      }
	      return measureUnitOptions;
	    }
	  }, {
	    key: 'getPackageTypeOptions',
	    value: function getPackageTypeOptions() {
	      var packageTypeOptions = [];
	      if (this.props.packageTypesFetched) {
	        this.props.packageTypesFetched.map(function (packageType) {
	          packageTypeOptions.push({ value: packageType.Simple, label: packageType.Simple });
	        });
	      }
	      return packageTypeOptions;
	    }
	  }, {
	    key: 'routerWillLeave',
	    value: function routerWillLeave(nextLocation) {
	      if (this.state.dirty) return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'work_not_saved_warning' });
	      this.props.clearSmallProdStatus();
	    }
	
	    // renderTypes() {
	    //     let productTypeOptions = [
	    //         { value: "Fixed", label: "Fixed" },
	    //         { value: "Non-Fixed", label: "Non-Fixed" },
	    //         { value: "Service", label: "Service" },
	    //         { value: "Non-Product", label: "Non-Product" },
	    //         { value: "Per-Pound", label: "Per-Pound" },
	    //         { value: "Other", label: "Other" }
	    //     ];
	    //     return (
	    //         <Col xs={ 6 }>
	    //             <div className="form-group">
	    //               <label><Translate value="product_type"/></label>
	    //                 <Field name="ProductType" component={Selection} options={productTypeOptions}/>
	    //             </div>
	    //         </Col>
	    //     )
	    // }
	
	  }, {
	    key: 'renderPackageInfo',
	    value: function renderPackageInfo() {
	      var _this18 = this;
	
	      var packageTypeOptions = this.getPackageTypeOptions();
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          'label',
	          { className: 'col-xs-6' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_type' }),
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'asteriksReq' },
	            '*'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-6' },
	          _react2.default.createElement(_reduxForm.Field, { name: 'PackageType', className: 'control-label', component: _selection.Selection, withRef: true, ref: 'PackageType', options: packageTypeOptions, onKeyPress: function onKeyPress(event) {
	              if (event.keyCode === 13) {
	                _reactDom2.default.findDOMNode(_this18.refs["NetWeight"].getRenderedComponent().myInput.refs.input).focus();
	              }
	            }
	          })
	        )
	      );
	    }
	
	    // If the user was directed to the page with a parameter,
	    // then this page is edit page. Otherwise this is a create
	    // page.
	
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      if (formProps.ShippingWeight < formProps.NetWeight) {
	        this.setState({
	          confirmModalVisibility: true,
	          formProps: formProps
	        });
	        return;
	      }
	      this.submitForm(formProps);
	    }
	  }, {
	    key: 'refreshPage',
	    value: function refreshPage(event) {
	      event.preventDefault();
	      this.setState({ showProductCreatedOpen: false, editProductGroup: false });
	      var productSaved = this.props.productSaved;
	
	      this.props.resetCurrentProduct();
	      this.props.selectProduct(productSaved);
	      this.context.router.push('/products/' + productSaved.Product_id);
	    }
	  }, {
	    key: 'checkPermission',
	    value: function checkPermission(permission) {
	      return false;
	    }
	  }, {
	    key: 'handlePercentageChange',
	    value: function handlePercentageChange(priceLevelPercentage, event) {
	      var _setState;
	
	      var price = (0, _NumberUtil.calculatePriceLevelNormal)(event.target.value, this.props.RefPriceValue, this.props.ArrivalPrice);
	      var priceLevel = (0, _lowerFirst2.default)(_NumberUtil.priceLevelPercentageFieldsMap[(0, _upperFirst2.default)(priceLevelPercentage)]);
	      this.setState((_setState = {}, _defineProperty(_setState, priceLevel, price), _defineProperty(_setState, priceLevelPercentage, event.target.value), _setState));
	    }
	  }, {
	    key: 'handlePriceChange',
	    value: function handlePriceChange(priceLevel, event) {
	      var _setState2;
	
	      var basePrice = isEcity || isHMM || isUSPride || isATL || isRS ? this.props.ArrivalPrice : null;
	      var percentage = (0, _NumberUtil.calculatePricePercentage)(event.target.value, this.props.RefPriceValue, basePrice);
	      var priceLevelPercentage = (0, _lowerFirst2.default)(_NumberUtil.priceLevelFieldsMap[(0, _upperFirst2.default)(priceLevel)]);
	      this.setState((_setState2 = {}, _defineProperty(_setState2, priceLevel, event.target.value), _defineProperty(_setState2, priceLevelPercentage, percentage), _setState2));
	    }
	  }, {
	    key: 'pushInventoryDetail',
	    value: function pushInventoryDetail() {
	      this.props.selectInventory(this.props.currentProductDetail);
	      this.context.router.push('/inventories/detail/' + this.props.currentProductDetail.Product_id);
	    }
	  }, {
	    key: 'renderProductNum',
	    value: function renderProductNum() {
	      var _this19 = this;
	
	      var p = this.props.currentProductDetail && this.props.currentProductDetail.ProductNum;
	      var isDisabled = true;
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          'label',
	          { className: 'col-xs-4' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-8' },
	          _react2.default.createElement(_reduxForm.Field, { name: 'ProductNum', className: 'control-label', isDisabled: isDisabled, component: _inputField.ControllabledStateInputField, placeholder: p, onKeyPress: function onKeyPress(event) {
	              _this19.handleKeyPress('GeneralNum', event);
	            } })
	        )
	      );
	    }
	  }, {
	    key: 'renderRefNumLabel',
	    value: function renderRefNumLabel() {
	      if (isJML || isTN || isWIZ) {
	        return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' });
	      }
	      if (isLO) {
	        return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'item_num' });
	      }
	      return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' });
	    }
	  }, {
	    key: 'renderAutoSuggest',
	    value: function renderAutoSuggest() {
	      var _this20 = this;
	
	      return _react2.default.createElement(_MixProductAutoSuggest2.default, {
	        value: this.state.suggestValue,
	        onChange: function onChange(e, _ref) {
	          var newValue = _ref.newValue;
	          _this20.setState({ suggestValue: newValue });
	        },
	        handleKeyPress: this.handleKeyPress,
	        handleFocusQty: this.handleFocusQty,
	        SearchType: this.state.productSearchType
	      });
	    }
	  }, {
	    key: 'renderAvgCost',
	    value: function renderAvgCost() {
	      var _this21 = this;
	
	      var showProductCost = function showProductCost() {
	        if ((isJML || isChinaTown || _root_url.isRivera || isHMM) && (0, _permissions2.default)('no_show_product_cost')) {
	          return false;
	        }
	        return true;
	      };
	      if (this.props.currentProductDetail) {
	        var currentProductDetail = this.props.currentProductDetail;
	        var netCost = currentProductDetail.NetCost;
	        var productCost = currentProductDetail.ProductCost;
	        var message = 'FOB: ' + this.props.currentProductDetail.FOBUnitPrice + '  <br>  CIF: ' + this.props.currentProductDetail.CIFUnitPrice + ' ';
	        if (isEcity) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group mb0' },
	              _react2.default.createElement('p', { ref: function ref(_ref2) {
	                  return _this21.fooRef = _ref2;
	                }, 'data-tip': message, style: { position: 'absolute', marginLeft: '40px' } }),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-6' },
	                ' ',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Shipping_fee' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-6' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'ShippingFeeUnitPrice', disabled: !(0, _permissions2.default)('change_shipping_misc'), className: 'control-label', withRef: true, ref: 'ProductCost', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                    _this21.handleKeyPress('RefPrice', event);
	                  } })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group mb0' },
	              _react2.default.createElement('p', { ref: function ref(_ref3) {
	                  return _this21.fooRef = _ref3;
	                }, 'data-tip': message, style: { position: 'absolute', marginLeft: '40px' } }),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-6' },
	                ' ',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Misc_fee' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-6' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'MiscUnitPrice', disabled: !(0, _permissions2.default)('change_shipping_misc'), className: 'control-label', withRef: true, ref: 'ProductCost', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                    _this21.handleKeyPress('RefPrice', event);
	                  } })
	              )
	            ),
	            showProductCost() && _react2.default.createElement(
	              'div',
	              { className: 'form-group mb0' },
	              _react2.default.createElement('p', { ref: function ref(_ref4) {
	                  return _this21.fooRef = _ref4;
	                }, 'data-tip': message, style: { position: 'absolute', marginLeft: '40px' } }),
	              _react2.default.createElement(
	                'label',
	                { onMouseEnter: function onMouseEnter() {
	                    _reactTooltip2.default.show(_this21.fooRef);
	                  }, onMouseLeave: function onMouseLeave() {
	                    _reactTooltip2.default.hide(_this21.fooRef);
	                  }, className: 'col-xs-6' },
	                ' ',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_cost' })
	              ),
	              _react2.default.createElement(_reactTooltip2.default, { multiline: true }),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-6' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'ProductCost', className: 'control-label', withRef: true, ref: 'ProductCost', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                    _this21.handleKeyPress('RefPrice', event);
	                  } })
	              )
	            )
	          );
	        } else if (isHMM || isUSPride || isATL || isRS) {
	          if ((0, _permissions2.default)('hmm_view_arrival') || isUSPride || isATL || isRS) {
	            return _react2.default.createElement(
	              'div',
	              null,
	              showProductCost() && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group mb0' },
	                  _react2.default.createElement('p', { ref: function ref(_ref5) {
	                      return _this21.fooRef = _ref5;
	                    }, 'data-tip': message, style: { position: 'absolute', marginLeft: '40px' } }),
	                  _react2.default.createElement(
	                    'label',
	                    { onMouseEnter: function onMouseEnter() {
	                        _reactTooltip2.default.show(_this21.fooRef);
	                      }, onMouseLeave: function onMouseLeave() {
	                        _reactTooltip2.default.hide(_this21.fooRef);
	                      }, className: 'col-xs-6' },
	                    ' ',
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_cost' })
	                  ),
	                  _react2.default.createElement(_reactTooltip2.default, { multiline: true }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-6' },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'ProductCost', className: 'control-label', withRef: true, ref: 'ProductCost', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                        _this21.handleKeyPress('Shipping', event);
	                      } })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group mb0' },
	                  _react2.default.createElement('p', { ref: function ref(_ref6) {
	                      return _this21.fooRef = _ref6;
	                    }, 'data-tip': message, style: { position: 'absolute', marginLeft: '40px' } }),
	                  _react2.default.createElement(
	                    'label',
	                    { onMouseEnter: function onMouseEnter() {
	                        _reactTooltip2.default.show(_this21.fooRef);
	                      }, onMouseLeave: function onMouseLeave() {
	                        _reactTooltip2.default.hide(_this21.fooRef);
	                      }, className: 'col-xs-6' },
	                    ' ',
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Shipping_fee' })
	                  ),
	                  _react2.default.createElement(_reactTooltip2.default, { multiline: true }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-6' },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'ShippingFeeUnitPrice', className: 'control-label', withRef: true, ref: 'Shipping', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                        _this21.handleKeyPress('TaxAmount', event);
	                      } })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group mb0' },
	                  _react2.default.createElement('p', { ref: function ref(_ref7) {
	                      return _this21.fooRef = _ref7;
	                    }, 'data-tip': message, style: { position: 'absolute', marginLeft: '40px' } }),
	                  _react2.default.createElement(
	                    'label',
	                    { onMouseEnter: function onMouseEnter() {
	                        _reactTooltip2.default.show(_this21.fooRef);
	                      }, onMouseLeave: function onMouseLeave() {
	                        _reactTooltip2.default.hide(_this21.fooRef);
	                      }, className: 'col-xs-6' },
	                    ' ',
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax_amount' })
	                  ),
	                  _react2.default.createElement(_reactTooltip2.default, { multiline: true }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-6' },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'TaxAmount', className: 'control-label', withRef: true, ref: 'TaxAmount', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                        _this21.handleKeyPress('Overhead', event);
	                      } })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group mb0' },
	                  _react2.default.createElement('p', { ref: function ref(_ref8) {
	                      return _this21.fooRef = _ref8;
	                    }, 'data-tip': message, style: { position: 'absolute', marginLeft: '40px' } }),
	                  _react2.default.createElement(
	                    'label',
	                    { onMouseEnter: function onMouseEnter() {
	                        _reactTooltip2.default.show(_this21.fooRef);
	                      }, onMouseLeave: function onMouseLeave() {
	                        _reactTooltip2.default.hide(_this21.fooRef);
	                      }, className: 'col-xs-6' },
	                    ' ',
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'over_head' })
	                  ),
	                  _react2.default.createElement(_reactTooltip2.default, { multiline: true }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-6' },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'MiscUnitPrice', className: 'control-label', withRef: true, ref: 'Overhead', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                        _this21.handleKeyPress('RefPrice', event);
	                      } })
	                  )
	                )
	              )
	            );
	          } else {
	            _react2.default.createElement('div', null);
	          }
	        } else {
	          return _react2.default.createElement(
	            'div',
	            null,
	            showProductCost() && _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-6' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'avg_cost' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-6' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'InStockPrice', className: 'control-label', withRef: true, ref: 'InStockPrice', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                    _this21.handleKeyPress('ProductCost', event);
	                  } })
	              )
	            ),
	            showProductCost() && _react2.default.createElement(
	              'div',
	              { className: 'form-group mb0' },
	              _react2.default.createElement('p', { ref: function ref(_ref9) {
	                  return _this21.fooRef = _ref9;
	                }, 'data-tip': message, style: { position: 'absolute', marginLeft: '40px' } }),
	              _react2.default.createElement(
	                'label',
	                { onMouseEnter: function onMouseEnter() {
	                    _reactTooltip2.default.show(_this21.fooRef);
	                  }, onMouseLeave: function onMouseLeave() {
	                    _reactTooltip2.default.hide(_this21.fooRef);
	                  }, className: 'col-xs-6' },
	                ' ',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_cost' })
	              ),
	              _react2.default.createElement(_reactTooltip2.default, { multiline: true }),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-6' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'ProductCost', className: 'control-label', withRef: true, ref: 'ProductCost', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                    _this21.handleKeyPress('RefPrice', event);
	                  } })
	              )
	            )
	          );
	        }
	      } else {
	        return _react2.default.createElement(
	          'div',
	          null,
	          showProductCost() && _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-6' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inv_cost' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-6' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'NetCost', component: _inputField.InputField, onFocus: this.handleOnFocus, withRef: true, ref: 'NetCost', onKeyPress: function onKeyPress(event) {
	                  _this21.handleKeyPress('ProductCost', event);
	                } })
	            )
	          ),
	          showProductCost() && _react2.default.createElement(
	            'div',
	            { className: 'form-group mb0' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-6' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_cost' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-6' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'ProductCost', component: _inputField.InputField, onFocus: this.handleOnFocus, withRef: true, ref: 'ProductCost', onKeyPress: function onKeyPress(event) {
	                  _this21.handleKeyPress('RefPrice', event);
	                } })
	            )
	          )
	        );
	      }
	    }
	
	    // renderCancelLink() {
	    //   let originPage = this.props.originPage || "products";
	    //   let link = `/${originPage}`
	    //   return (
	    //     <Link to={link} className="btn btn-danger buttonStyle"><Translate value="exit"/></Link>
	    //   )
	    // }
	
	  }, {
	    key: 'renderCloseButton',
	    value: function renderCloseButton() {
	      var _this22 = this;
	
	      if (this.props.originPage === 'products') {
	        return _react2.default.createElement(
	          _reactBootstrap.Button,
	          _defineProperty({ bsStyle: 'danger', type: 'button', onClick: function onClick() {
	              _this22.setState({ showProductCreatedOpen: false });_this22.context.router.push('/' + _this22.props.originPage);
	            } }, 'type', 'button'),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	        );
	      }
	      if (!this.props.originPage || this.props.originPage === 'inventories') {
	        return _react2.default.createElement(
	          _reactBootstrap.Button,
	          _defineProperty({ bsStyle: 'danger', type: 'button', onClick: function onClick() {
	              _this22.setState({ showProductCreatedOpen: false });window.history.back();
	            } }, 'type', 'button'),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	        );
	      }
	    }
	  }, {
	    key: 'renderImage',
	    value: function renderImage() {
	      var newImageFile = this.state.files && this.state.files[0].preview;
	      var ImageFile = this.state.updatedImage || this.props.currentProductDetail && this.props.currentProductDetail.Thumbnail || '/img/dummy.png';
	      if (newImageFile) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'product-img-editor' },
	          _react2.default.createElement(_Editor2.default, {
	            image: newImageFile,
	            upload: this.props.attachProductImage,
	            Product_id: this.props.currentProductDetail && this.props.currentProductDetail.Product_id,
	            clearAttachedProductImage: this.props.clearAttachedProductImage,
	            width: 100,
	            height: 100
	          })
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'product-img-view' },
	        _react2.default.createElement('img', { src: ImageFile, alt: 'Upload image', className: 'img-thumbnail' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this23 = this;
	
	      var productDetailsPanelHeader = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'basic_info' })
	      );
	      var packageDetailsPanelHeader = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'packaging' })
	      );
	      var zonePricePanelHeader = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_price_levels' })
	      );
	      var mixProductPanelHeader = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mix_product' })
	      );
	      var costsDetailsPanelHeader = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cost' })
	      );
	      var saleDetailsPanelHeader = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sale' })
	      );
	      var buyerDetailsPanelHeader = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase' })
	      );
	      var convertDetailsPanelHeader = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'convert' })
	      );
	      var inventoryDetailsPanelHeader = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory' })
	      );
	      var vendorPanelHeader = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'barcode' })
	      );
	      var productInformation = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_information' });
	      var inventoryInformation = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_information' });
	      var productCostAndPrice = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost_and_price' });
	      var packageAndWeight = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_slashsign_weight' });
	      var bardcodeTranslation = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'barcode' });
	      var productGroupAndCategory = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_group_and_category' });
	      var productDetail = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_detail' });
	      var productDetailsHeader = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_details' })
	      );
	      var viewPromotionHeader = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'view_promotions' });
	      var editRecPermissionChange = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'permission_for_changing_product_number' });
	      var editRecPermissionDuplicate = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'permission_for_duplicating_product' });
	      var editGroupFormChangeGroupTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_group' });
	      var editGroupFormDuplicateProdTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'duplicate_product' });
	      var mobileDescBoxTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mobile_description_box' });
	      var displayCategoryBoxTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_display_category' });
	      var imagesModalTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'upload_images' });
	      var addConvertProductsTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'products' });
	      var deleteProduct = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete_product' });
	      var editPromotionTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_promotion' });
	      var skusModalTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'skus' });
	      var productMetaInfoTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_product_meta' });
	      var eslTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_esl' });
	      var productGroupPanelHeader = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'packaging' }),
	        this.props.currentProduct ? _react2.default.createElement(
	          _reactBootstrap.Button,
	          { bsStyle: 'warning', className: 'edit-product-group-button', onClick: this.openEditRecPermission },
	          _react2.default.createElement('em', { className: 'fa fa-pencil' })
	        ) : _react2.default.createElement('span', null)
	      );
	      var _props2 = this.props,
	          handleSubmit = _props2.handleSubmit,
	          invalid = _props2.invalid,
	          submitting = _props2.submitting,
	          pristine = _props2.pristine;
	
	
	      var createDialogStyle = {
	        width: '650px',
	        marginLeft: '-15%'
	      };
	      var createLargeDialogStyle = {
	        width: '850px',
	        height: '530px',
	        marginLeft: '-25%'
	      };
	      var createDisplayCategoryDialogStyle = {
	        width: '700px',
	        height: '500px',
	        marginLeft: '-15%'
	      };
	      var promotionsStyle = {
	        width: '800px',
	        height: '480',
	        marginLeft: '-15%'
	      };
	      var deletePromotionDialogStyle = {
	        width: '550px',
	        height: '300px',
	        marginLeft: '-10%',
	        marginTop: '-100px'
	      };
	      var editPromotionDialog = {
	        width: '550px',
	        height: '300px',
	        marginLeft: '-10%',
	        marginTop: '-100px'
	      };
	      var imagesModalStyle = {
	        width: '700px',
	        height: '700px',
	        top: '30%',
	        marginLeft: '-15%'
	      };
	      var convertProductListStyle = {
	        width: '800px',
	        height: '470px',
	        marginLeft: '-20%'
	      };
	      var createProductMetaStyle = {
	        width: '700px',
	        height: '280px',
	        marginLeft: '-15%'
	      };
	      var createESLStyle = {
	        width: '550px',
	        height: '300px',
	        marginLeft: '-15%'
	      };
	
	      var renderRichTextEditor = function renderRichTextEditor() {
	        if (_root_url.isSY) {
	          return _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createLargeDialogStyle,
	              isVisible: _this23.state.mobileDescBoxOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this23.closeMobileDescBox();
	              },
	              title: mobileDescBoxTitle
	            },
	            _react2.default.createElement(_TuiEditor2.default, {
	              htmlString: _this23.state.mobileDescriptionHTML,
	              placeholder: 'Enter the product description.',
	              saveHtml: function saveHtml(htmlText) {
	                _this23.saveRichText(htmlText);
	              },
	              isLoadingSave: _this23.props.isLoadingDescriptionBoxSave,
	              saveSuccess: _this23.props.saveMobileDescriptionTextSuccess
	            })
	          );
	        }
	        return _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogStyle,
	            isVisible: _this23.state.mobileDescBoxOpen,
	            onCloseClicked: function onCloseClicked() {
	              _this23.closeMobileDescBox();
	            },
	            title: mobileDescBoxTitle
	          },
	          _react2.default.createElement(_RichTextEditor2.default, {
	            htmlString: _this23.state.mobileDescriptionHTML,
	            placeholder: 'Enter the product description.',
	            saveHtml: function saveHtml(htmlText) {
	              _this23.saveRichText(htmlText);
	            },
	            isLoadingSave: _this23.props.isLoadingDescriptionBoxSave,
	            saveSuccess: _this23.props.saveMobileDescriptionTextSuccess
	          })
	        );
	      };
	      if (this.props.detailIsLoading && !this.props.detailError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement('br', null),
	        '...reading data'
	      );else {
	        var _React$createElement3, _React$createElement4;
	
	        var measureUnitOptions = this.getMeasureUnitOptions();
	        var getZoneOptions = this.getZoneOptions();
	        var getBinOptions = this.getBinOptions();
	        var getLevelOptions = this.getLevelOptions();
	        // let getZone2Options = this.getZone2Options();
	        var getBin2Options = this.getBin2Options();
	        var getLevel2Options = this.getLevel2Options();
	        // let getZone3Options = this.getZone3Options();
	        var getBin3Options = this.getBin3Options();
	        var getLevel3Options = this.getLevel3Options();
	        var packageTypeOptions = this.getPackageTypeOptions();
	        var url = this.props.ProductNumber && _root_url.ROOT_URL + 'v1/warehouse/printbarcode/' + this.props.ProductNumber + '?Bearer=' + localStorage.getItem('token');
	        var urlForLabel = this.props.ProductNumber && _root_url.ROOT_URL + 'v1/warehouse/printbarcode2/' + this.props.ProductNumber + '?Bearer=' + localStorage.getItem('token');
	        var urlForLargeLabelWin = this.props.ProductNumber && _root_url.ROOT_URL + 'v1/warehouse/printbarcode_large/' + this.props.ProductNumber + '?Bearer=' + localStorage.getItem('token');
	        var urlForLargeLabelMac = this.props.ProductNumber && _root_url.ROOT_URL + 'v1/warehouse/printbarcode_large_mac/' + this.props.ProductNumber + '?Bearer=' + localStorage.getItem('token');
	        var urlForSmallLabelWin = this.props.ProductNumber && _root_url.ROOT_URL + 'v1/warehouse/printbarcode_small/' + this.props.ProductNumber + '?Bearer=' + localStorage.getItem('token');
	        var urlForSmallLabelMac = this.props.ProductNumber && _root_url.ROOT_URL + 'v1/warehouse/printbarcode_small_mac/' + this.props.ProductNumber + '?Bearer=' + localStorage.getItem('token');
	        var editGroupFormSaveAction = void 0;
	        var editGroupFormSaveActionCallback = void 0;
	        var editRecPermission = void 0;
	        var editGroupFormTitle = void 0;
	        if (this.state.editGroupFormAction === 'duplicate') {
	          editGroupFormSaveAction = this.props.duplicateProduct;
	          editGroupFormSaveActionCallback = function editGroupFormSaveActionCallback() {};
	          editRecPermission = editRecPermissionDuplicate;
	          editGroupFormTitle = editGroupFormDuplicateProdTitle;
	        } else if (this.state.editGroupFormAction === 'changeGroup') {
	          editGroupFormSaveAction = this.props.updateProductGroup;
	          editGroupFormSaveActionCallback = this.props.fetchProductDetail;
	          editRecPermission = editRecPermissionChange;
	          editGroupFormTitle = editGroupFormChangeGroupTitle;
	        }
	
	        return (
	          //---------------
	          // Begin HTML: Create New/Edit Purchase Order
	          //---------------
	          _react2.default.createElement(
	            _ContentWrapper2.default,
	            null,
	            _react2.default.createElement(
	              'form',
	              { className: 'form-horizontal', method: 'get', action: '#', onSubmit: function onSubmit() {
	                  console.log('attempting to submit');
	                } },
	              _react2.default.createElement(
	                _reactBootstrap.Breadcrumb,
	                { style: this.state.crumbStyle },
	                _react2.default.createElement(
	                  _reactBootstrap.Breadcrumb.Item,
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_management' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Breadcrumb.Item,
	                  null,
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/products' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'products' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Breadcrumb.Item,
	                  { active: 'true' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_product' })
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { style: { color: 'red', display: 'inline', 'padding-left': '30px' } },
	                  this.props.detailError ? 'Product does not exist' : ''
	                )
	              ),
	              ' ',
	              _react2.default.createElement(
	                'div',
	                { id: 'search-product-header-nav' },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { style: { marginRight: isEcity ? "770px" : "45%" } },
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 1 },
	                    _react2.default.createElement('span', { style: { display: "inline" }, className: 'fa fa-arrow-circle-left btn-lg prev-arrow', onClick: function onClick() {
	                        if (_this23.props.currentProductDetail && (0, _permissions2.default)('change_product')) {
	                          _this23.setState({ updatedImage: undefined });
	                          if (isHMM) {
	                            _this23.props.fetchPreviousProductWithGeno(_this23.props.currentProductDetail.GeneralNum);
	                            return;
	                          }
	                          _this23.props.fetchPreviousProduct(_this23.props.currentProductDetail.ProductNum);
	                        }
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 4, className: 'centerStyle', style: { 'width': '37%' } },
	                    _react2.default.createElement(_reduxForm.Field, {
	                      style: { display: "inline", 'max-width': "100%" },
	                      name: isHMM ? "GeneralNumber" : "ProductNumber",
	                      component: _inputField.InputField,
	                      disabled: !(0, _permissions2.default)('change_product'),
	                      onKeyPress: function onKeyPress(event) {
	                        if (event.charCode == 13) {
	                          event.preventDefault();
	
	                          // if (this.props.ProductNumber === this.props.ProductNum) {
	                          //   alert('please search using different product number')
	                          //   return;
	                          // }
	                          _this23.setState({ updatedImage: undefined });
	                          _this23.props.fetchProductByNum(_this23.props.ProductNumber, { isHMM: isHMM, GeneralNumber: _this23.props.GeneralNumber });
	                        }
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 1 },
	                    _react2.default.createElement('span', { style: { display: "inline" }, className: 'fa fa-arrow-circle-right btn-lg next-arrow', onClick: function onClick() {
	                        if (_this23.props.currentProductDetail && (0, _permissions2.default)('change_product')) {
	                          _this23.setState({ updatedImage: undefined });
	                          if (isHMM) {
	                            _this23.props.fetchNextProductWithGeno(_this23.props.currentProductDetail.GeneralNum);
	                            return;
	                          }
	                          _this23.props.fetchNextProduct(_this23.props.currentProductDetail.ProductNum);
	                        }
	                      } })
	                  )
	                )
	              ),
	              ' ',
	              _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                { id: 'breadcrumbButtonGroup' },
	                (!isEcity || (0, _permissions2.default)('delete_product')) && _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                      type: 'button',
	                      bsStyle: 'danger',
	                      onClick: this.openDeleteModal
	                    },
	                    _react2.default.createElement('em', { className: 'fa' }),
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                      type: 'button',
	                      bsStyle: 'warning',
	                      onClick: function onClick() {
	                        if (_this23.props.currentProductDetail) {
	                          if (_this23.props.currentProductDetail.IsDiscontinued) {
	                            _this23.props.continueProduct(_this23.props.currentProductDetail.Product_id);
	                          } else {
	                            _this23.props.discontinueProduct(_this23.props.currentProductDetail.Product_id);
	                          }
	                        }
	                      }
	                    },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: this.props.currentProductDetail && this.props.currentProductDetail.IsDiscontinued ? 'continue_product' : 'discontinue' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    type: 'button',
	                    bsStyle: 'primary',
	                    onClick: this.viewPromotion,
	                    disabled: !this.state.Product_id
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-eye' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'promo' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    type: 'button',
	                    bsStyle: 'primary',
	                    className: 'textAlignStyle',
	                    href: url,
	                    disabled: !this.props.currentProduct && !this.props.params.id
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-print' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'barcode' })
	                ),
	                !isEcity && _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    type: 'button',
	                    bsStyle: 'primary',
	                    className: 'textAlignStyle',
	                    href: urlForLabel,
	                    disabled: !this.props.currentProduct && !this.props.params.id
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-print' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'label' })
	                ),
	                isEcity && _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    type: 'button',
	                    bsStyle: 'primary',
	                    className: 'textAlignStyle',
	                    href: urlForSmallLabelWin,
	                    disabled: !this.props.currentProduct && !this.props.params.id
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-print' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'small_label_win' })
	                ),
	                isEcity && _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    type: 'button',
	                    bsStyle: 'primary',
	                    className: 'textAlignStyle',
	                    href: urlForSmallLabelMac,
	                    disabled: !this.props.currentProduct && !this.props.params.id
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-print' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'small_label_mac' })
	                ),
	                isEcity && _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    type: 'button',
	                    bsStyle: 'primary',
	                    className: 'textAlignStyle',
	                    href: urlForLargeLabelWin,
	                    disabled: !this.props.currentProduct && !this.props.params.id
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-print' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'large_label_win' })
	                ),
	                isEcity && _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    type: 'button',
	                    bsStyle: 'primary',
	                    className: 'textAlignStyle',
	                    href: urlForLargeLabelMac,
	                    disabled: !this.props.currentProduct && !this.props.params.id
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-print' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'large_label_mac' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    type: 'button',
	                    bsStyle: 'primary',
	                    onClick: this.pushInventoryDetail.bind(this) },
	                  _react2.default.createElement('em', { className: 'fa fa-eye' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inv' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    type: 'button',
	                    action: 'submit',
	                    bsStyle: 'success',
	                    onClick: handleSubmit(this.handleFormSubmit.bind(this)),
	                    disabled: invalid || submitting || pristine
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-save' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    type: 'button',
	                    bsStyle: 'danger',
	                    onClick: function onClick() {
	                      return window.history.back();
	                    }
	                    //onClick={(event) => { this.context.router.push(`/${this.props.originPage || "products"}`) }}
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-close' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	                )
	              ),
	              ' ',
	              _react2.default.createElement(
	                'div',
	                { className: 'formContainer' },
	                this.props.currentProductDetail && this.props.currentProductDetail.IsDiscontinued && _react2.default.createElement('div', { className: 'overlay' }),
	                _react2.default.createElement(
	                  _reactBootstrap.Grid,
	                  { id: 'manage-products' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'row-wrapper' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 4 },
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { id: 'product-details', header: productDetailsPanelHeader },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 7, className: 'pr0 ' },
	                                this.renderProductNum(),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-4' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: isMyuMyu || isAFG ? "index_no" : "general_no" })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-8' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'GeneralNum', withRef: true, ref: 'GeneralNum', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                                        _this23.handleKeyPress('RefNum', event);
	                                      } })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-4' },
	                                    this.renderRefNumLabel()
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-8' },
	                                    _react2.default.createElement(_reduxForm.Field, { style: { marginBottom: 8 }, name: 'RefNum', withRef: true, ref: 'RefNum', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                                        _this23.handleKeyPress('CustomerNum', event);
	                                      } })
	                                  ),
	                                  this.renderGenerateReferenceNumber()
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-4' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_no' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-8' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'VendorProdNo', withRef: true, ref: 'CustomerNum', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                                        if (isAFM) {
	                                          _this23.handleKeyPress('Brand', event);
	                                          return;
	                                        }
	                                        _this23.handleKeyPress('Name', event);
	                                      } })
	                                  )
	                                ),
	                                this.renderLotNum(),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-4' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'brand' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-8' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Brand', withRef: true, ref: 'Brand', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                                        _this23.handleKeyPress('Name', event);
	                                      } })
	                                  )
	                                ),
	                                isSW && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-4' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'color' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-8' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Color', withRef: true, ref: 'Color', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                                        _this23.handleKeyPress('Name', event);
	                                      } })
	                                  )
	                                ),
	                                isSW && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-4' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'size' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-8' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Size', withRef: true, ref: 'Size', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                                        _this23.handleKeyPress('Name', event);
	                                      } })
	                                  )
	                                ),
	                                isPTS && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mfr_no' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'MFRNum', withRef: true, ref: 'MFRNum', disabled: true, component: _inputField.InputField
	                                    })
	                                  )
	                                )
	                              ),
	                              ' ',
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'img-container' },
	                                  this.renderImage(),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'product-img-uploader' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: 'well dropzone' },
	                                      _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                          _reactBootstrap.Col,
	                                          { xs: 12 },
	                                          _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            {
	                                              bsStyle: 'primary',
	                                              type: 'button',
	                                              className: 'pull-right',
	                                              onClick: function onClick() {
	                                                return _this23.openImageModal();
	                                              }
	                                            },
	                                            _react2.default.createElement('em', { className: 'fa ' + (this.state.isLoadingImages ? 'fa-spinner fa-spin' : 'fa-plus') })
	                                          )
	                                        )
	                                      )
	                                    )
	                                  ),
	                                  this.props.attachingProductImage && _react2.default.createElement(
	                                    'div',
	                                    { className: 'alert alert-info' },
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saving' })
	                                    )
	                                  ),
	                                  this.props.productImageAttached && _react2.default.createElement(
	                                    'div',
	                                    { className: 'alert alert-success' },
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saved' })
	                                    )
	                                  )
	                                )
	                              ),
	                              ' ',
	                              isFBD && _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group prod-name-input' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer' }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      { className: 'asteriksReq' },
	                                      '*'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'customerId', component: _selection.Selection, options: this.props.customerOptions })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group prod-name-input' },
	                                  !isWecom && _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      { className: 'asteriksReq' },
	                                      '*'
	                                    )
	                                  ),
	                                  isWecom && _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'eng_name' }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      { className: 'asteriksReq' },
	                                      '*'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Name', withRef: true, ref: 'Name', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                                        _this23.handleKeyPress('Description', event);
	                                      } })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group prod-name-input' },
	                                  !isWecom && _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	                                  ),
	                                  isWecom && _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'chi_name' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Description', withRef: true, ref: 'Description', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                                        if (event.charCode == 13) {
	                                          event.preventDefault();
	                                          _this23.refs["ProductGroup"].getRenderedComponent().refs.select.focus();
	                                        }
	                                      } })
	                                  )
	                                )
	                              ),
	                              isABCFF && _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group prod-name-input' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Customer', component: _selection.Selection, options: this.props.customerOptions })
	                                  )
	                                )
	                              ),
	                              isABCFF && _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group prod-name-input' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_style' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'VendorStyleNum', withRef: true, ref: 'VendorStyleNum', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {} })
	                                  )
	                                )
	                              ),
	                              isABCFF && _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group prod-name-input' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    'TJX Style'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'TJXStyleNum', withRef: true, ref: 'TJXStyleNum', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {} })
	                                  )
	                                )
	                              ),
	                              isABCFF && _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group prod-name-input' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'upc' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'UPC', withRef: true, ref: 'UPC', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {} })
	                                  )
	                                )
	                              ),
	                              isABCFF && _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group prod-name-input' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'gtin' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'GTIN', withRef: true, ref: 'GTIN', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {} })
	                                  )
	                                )
	                              ),
	                              isABCFF && _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group prod-name-input' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'color' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Color', withRef: true, ref: 'Color', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {} })
	                                  )
	                                )
	                              ),
	                              isABCFF && _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group prod-name-input' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    'Size/Ratio'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Size', withRef: true, ref: 'Size', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {} })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'mobile-description-box-button' },
	                                  _react2.default.createElement(_SpinnerButton2.default, {
	                                    bsStyle: 'primary',
	                                    icon: 'fa-pencil',
	                                    onClick: this.handleMobileDescBoxClick,
	                                    disabled: this.state.isLoadingMobileDescBoxText,
	                                    loading: this.state.isLoadingMobileDescBoxText,
	                                    translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mobile_description_box' })
	                                  }),
	                                  _react2.default.createElement(_SpinnerButton2.default, {
	                                    style: { marginLeft: '10px' },
	                                    bsStyle: 'primary',
	                                    icon: 'fa-pencil',
	                                    onClick: this.handleSkusClick,
	                                    disabled: this.state.skusModal,
	                                    loading: this.state.skusModal,
	                                    translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'skus' })
	                                  }),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                      style: { marginLeft: '10px' },
	                                      bsStyle: 'primary',
	                                      onClick: function onClick() {
	                                        _this23.setProductMetaInfoVisibility(true);
	                                      }
	                                    },
	                                    _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'meta_info' })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'formSubHeaderContainer' },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Col,
	                                      { xs: 6 },
	                                      _react2.default.createElement(
	                                        'p',
	                                        { className: 'formSubHeader' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'group' }),
	                                        ' / ',
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category' })
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Col,
	                                      { xs: 1, xsOffset: 3 },
	                                      (this.props.currentProduct || this.props.params.id) && _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        {
	                                          bsStyle: 'primary',
	                                          className: 'edit-product-group-button',
	                                          onClick: function onClick() {
	                                            return _this23.openCheckAuthorize('duplicate');
	                                          },
	                                          style: { position: "relative", left: "10px", zIndex: 5 }
	                                        },
	                                        _react2.default.createElement('em', { className: 'fa fa-copy' })
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Col,
	                                      { xs: 1 },
	                                      (this.props.currentProduct || this.props.params.id) && _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        {
	                                          bsStyle: 'warning',
	                                          className: 'edit-product-group-button',
	                                          onClick: function onClick() {
	                                            return _this23.openEditRecPermission('changeGroup');
	                                          },
	                                          style: { position: "relative", left: "18px" }
	                                        },
	                                        _react2.default.createElement('em', { className: 'fa fa-pencil' })
	                                      )
	                                    )
	                                  )
	                                ),
	                                this.renderGroups(),
	                                this.renderCategories(),
	                                (isAFG || isWecom || isHF) && this.renderDisplayCategories()
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                isAFM && this.renderBrandInformation()
	                              )
	                            )
	                          ),
	                          ' '
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { id: 'package-details', header: packageDetailsPanelHeader, style: { height: '400px' } },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                this.renderProductType()
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6 },
	                                this.renderPackageInfo()
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-6' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'measure_unit' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-6' },
	                                    _react2.default.createElement(_reduxForm.Field, { disabled: isAFG && !isHF || isMyuMyu || isWecom, name: 'MeasureUnit', className: 'control-label', component: _selection.Selection, withRef: true, ref: 'MeasureUnit', options: measureUnitOptions, onKeyPress: function onKeyPress(event) {
	                                        event.stopPropagation();
	                                        if (event.keyCode == 13) {
	                                          _this23.refs["PackageType"].getRenderedComponent().refs.select.focus();
	                                        }
	                                      } })
	                                  )
	                                )
	                              )
	                            ),
	                            !isHMM && _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'row' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-4' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-4', style: { paddingRight: 0 } },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'NetWeight', className: 'control-label', withRef: true, ref: 'NetWeight', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                                        _this23.handleKeyPress('ShippingWeight', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-4', style: { marginLeft: 0, paddingLeft: 0 } },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'MeasureUnit', className: 'control-label', component: _selection.DisabledSelection, options: measureUnitOptions })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-4' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_weight' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-4', style: { paddingRight: 0 } },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ShippingWeight', className: 'control-label', withRef: true, ref: 'ShippingWeight', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                                        _this23.handleKeyPress('MinWeightRange', event);
	                                      } })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-4', style: { marginLeft: 0, paddingLeft: 0 } },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'MeasureUnit', className: 'control-label', component: _selection.DisabledSelection, options: measureUnitOptions })
	                                  )
	                                )
	                              )
	                            ),
	                            !isHMM && !isHF && _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              { className: 'formRow' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight_range' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  _reactBootstrap.Row,
	                                  null,
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 3 },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'min' })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 9 },
	                                    _react2.default.createElement(_reduxForm.Field, (_React$createElement3 = { name: 'MinWeightRange', className: 'control-label', component: _inputField.InputField, onFocus: this.handleOnFocus, withRef: true, ref: 'MinWeightRange', standalone: true, type: 'text' }, _defineProperty(_React$createElement3, 'standalone', true), _defineProperty(_React$createElement3, 'addonAfter', '.00'), _defineProperty(_React$createElement3, 'onKeyPress', function onKeyPress(event) {
	                                      _this23.handleKeyPress('MaxWeightRange', event);
	                                    }), _React$createElement3))
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 1, style: { textAlign: 'center' } },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: '~' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  _reactBootstrap.Row,
	                                  null,
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 3 },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'max' })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 9 },
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'MaxWeightRange',
	                                      className: 'control-label',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      standalone: true,
	                                      type: 'text',
	                                      addonAfter: '.00',
	                                      withRef: true,
	                                      ref: 'MaxWeightRange',
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this23.props.currentProductDetail) {
	                                          _this23.handleKeyPress('NetCost', event);
	                                        } else {
	                                          _this23.handleKeyPress('RefPrice', event);
	                                        }
	                                      }
	                                    })
	                                  )
	                                )
	                              )
	                            ),
	                            isHF && _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              { className: 'formRow' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight_range' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  _reactBootstrap.Row,
	                                  null,
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 3 },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'min' })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 5 },
	                                    _react2.default.createElement(_reduxForm.Field, (_React$createElement4 = { name: 'MinWeightRange', className: 'control-label', component: _inputField.InputField, onFocus: this.handleOnFocus, withRef: true, ref: 'MinWeightRange', standalone: true, type: 'text' }, _defineProperty(_React$createElement4, 'standalone', true), _defineProperty(_React$createElement4, 'addonAfter', '.00'), _defineProperty(_React$createElement4, 'onKeyPress', function onKeyPress(event) {
	                                      _this23.handleKeyPress('MaxWeightRange', event);
	                                    }), _React$createElement4))
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 3 },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lbs' })
	                                    )
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 1, style: { textAlign: 'center' } },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: '~' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  _reactBootstrap.Row,
	                                  null,
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 3 },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'max' })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 5 },
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'MaxWeightRange',
	                                      className: 'control-label',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      standalone: true,
	                                      type: 'text',
	                                      addonAfter: '.00',
	                                      withRef: true,
	                                      ref: 'MaxWeightRange',
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this23.props.currentProductDetail) {
	                                          _this23.handleKeyPress('NetCost', event);
	                                        } else {
	                                          _this23.handleKeyPress('RefPrice', event);
	                                        }
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 3 },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lbs' })
	                                    )
	                                  )
	                                )
	                              )
	                            ),
	                            isJTB && _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              { style: { marginBottom: '-10' } },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                this.renderCBMUnit()
	                              )
	                            ),
	                            isHF && _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              { className: 'formRow' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'temperature' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  _reactBootstrap.Row,
	                                  null,
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 9 },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Temperature', className: 'control-label', component: _inputField.InputField })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, style: { textAlign: 'left' } },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: '\xB0F' })
	                                    )
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              { style: { marginBottom: '-10' } },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                this.renderVolumeDimension()
	                              )
	                            ),
	                            isJTB && _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              { style: { marginBottom: '-10' } },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                this.renderCBM()
	                              )
	                            ),
	                            isWIZ && _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              { style: { marginBottom: '-10' } },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                this.renderTotalVolume()
	                              )
	                            ),
	                            !isHF && _react2.default.createElement(
	                              'div',
	                              { className: 'formSubHeaderContainer' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 3 },
	                                  _react2.default.createElement(
	                                    'p',
	                                    { className: 'formSubHeader' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 9 },
	                                  _react2.default.createElement(_reduxForm.Field, {
	                                    name: 'PackageSize',
	                                    className: 'control-label',
	                                    withRef: true,
	                                    ref: 'PackageSize',
	                                    component: _inputField.DisabledInputField,
	                                    onFocus: this.handleOnFocus,
	                                    onKeyPress: function onKeyPress(event) {
	                                      _this23.handleKeyPress('NetWeight', event);
	                                    }
	                                  })
	                                )
	                              )
	                            ),
	                            isHF && _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-3' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'packageSize' })
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 9 },
	                                  _react2.default.createElement(_reduxForm.Field, {
	                                    name: 'PackageSize',
	                                    component: _inputField.InputField
	                                  })
	                                )
	                              )
	                            ),
	                            !isHF && _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { style: { marginTop: '-6' } },
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { sm: 2 },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'PackageSize_1', component: _inputField.InputField })
	                                ),
	                                !isEcity && _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { sm: 3, className: 'select-menu-drop-up' },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'PackageType_2', component: _selection.Selection, options: packageTypeOptions })
	                                ),
	                                isEcity && _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { sm: 3 },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'PackageType_2', component: _inputField.InputField, placeholder: 'Type' })
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { sm: 2, className: 'textAlignStyle' },
	                                  _react2.default.createElement('em', { className: 'fa fa-times times-sign' })
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { sm: 2 },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'PackageSize_2', component: _inputField.InputField })
	                                ),
	                                !isEcity && _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { sm: 3, className: 'select-menu-drop-up' },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'MeasureUnit_2', component: _selection.Selection, options: measureUnitOptions })
	                                ),
	                                isEcity && _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { sm: 3 },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'MeasureUnit_2', component: _inputField.InputField, placeholder: 'Unit' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: 'nonbold-label-description textAlignStyle' },
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { sm: 2 },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: '(num)' })
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { sm: 3 },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: isSoleStage() ? "us_size" : "(pkg_size_1)" })
	                                ),
	                                _react2.default.createElement(_reactBootstrap.Col, { sm: 2 }),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { sm: 2 },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: '(num)' })
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { sm: 3 },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: isSoleStage() ? "eu_size" : "(pkg_size_2)" })
	                                )
	                              )
	                            ),
	                            (isCalco || isOCM) && _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { style: { marginTop: '10' } },
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 2, style: { textAlign: 'center', fontSize: '15px' } },
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    '1'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 1, style: { textAlign: 'center', fontSize: '15px' } },
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'x'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 2, style: { textAlign: 'center', fontSize: '15px' } },
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'Pallet'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 2, style: { textAlign: 'center', fontSize: '16px' } },
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    '='
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { sm: 2 },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'CalcoDispatchCase', component: _inputField.InputField })
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 1, style: { textAlign: 'center', fontSize: '15px' } },
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'x'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 2, style: { textAlign: 'center', fontSize: '15px' } },
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'Case'
	                                  )
	                                )
	                              )
	                            ),
	                            isCalco && _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { style: { marginTop: '5' } },
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 2, style: { textAlign: 'center', fontSize: '15px' } },
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    '1'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 1, style: { textAlign: 'center', fontSize: '15px' } },
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'x'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 2, style: { textAlign: 'center', fontSize: '15px' } },
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'Case'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 2, style: { textAlign: 'center', fontSize: '16px' } },
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    '='
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { sm: 2 },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'CalcoDispatchBag', component: _inputField.InputField })
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 1, style: { textAlign: 'center', fontSize: '15px' } },
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'x'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 2, style: { textAlign: 'center', fontSize: '15px' } },
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'Bag'
	                                  )
	                                )
	                              )
	                            )
	                          ),
	                          ' '
	                        )
	                      ),
	                      isFBD && this.props.currentProductDetail && this.props.currentProductDetail.ProductCategory1_id === 32 && _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { id: 'package-details', header: zonePricePanelHeader, style: { height: '330px' } },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              { className: 'formRow' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_lv2' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'dollar-sign' },
	                                    '$'
	                                  ),
	                                  ':'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'ZoneLevel2', className: 'control-label', component: _inputField.InputField, onFocus: this.handleOnFocus, withRef: true, ref: 'ZoneLevel2', standalone: true, type: 'text', onKeyPress: function onKeyPress(event) {
	                                    _this23.handleKeyPress('ZoneLevel2', event);
	                                  } })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              { className: 'formRow' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_lv3' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'dollar-sign' },
	                                    '$'
	                                  ),
	                                  ':'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'ZoneLevel3', className: 'control-label', component: _inputField.InputField, onFocus: this.handleOnFocus, withRef: true, ref: 'ZoneLevel3', standalone: true, type: 'text', onKeyPress: function onKeyPress(event) {
	                                    _this23.handleKeyPress('ZoneLevel3', event);
	                                  } })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              { className: 'formRow' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_lv4' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'dollar-sign' },
	                                    '$'
	                                  ),
	                                  ':'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'ZoneLevel4', className: 'control-label', component: _inputField.InputField, onFocus: this.handleOnFocus, withRef: true, ref: 'ZoneLevel4', standalone: true, type: 'text', onKeyPress: function onKeyPress(event) {
	                                    _this23.handleKeyPress('ZoneLevel4', event);
	                                  } })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              { className: 'formRow' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_lv5' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'dollar-sign' },
	                                    '$'
	                                  ),
	                                  ':'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'ZoneLevel5', className: 'control-label', component: _inputField.InputField, onFocus: this.handleOnFocus, withRef: true, ref: 'ZoneLevel5', standalone: true, type: 'text', onKeyPress: function onKeyPress(event) {
	                                    _this23.handleKeyPress('ZoneLevel5', event);
	                                  } })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              { className: 'formRow' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_lv6' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'dollar-sign' },
	                                    '$'
	                                  ),
	                                  ':'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'ZoneLevel6', className: 'control-label', component: _inputField.InputField, onFocus: this.handleOnFocus, withRef: true, ref: 'ZoneLevel6', standalone: true, type: 'text', onKeyPress: function onKeyPress(event) {
	                                    _this23.handleKeyPress('ZoneLevel6', event);
	                                  } })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              { className: 'formRow' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_lv7' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'dollar-sign' },
	                                    '$'
	                                  ),
	                                  ':'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'ZoneLevel7', className: 'control-label', component: _inputField.InputField, onFocus: this.handleOnFocus, withRef: true, ref: 'ZoneLevel7', standalone: true, type: 'text', onKeyPress: function onKeyPress(event) {
	                                    _this23.handleKeyPress('ZoneLevel7', event);
	                                  } })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              { className: 'formRow' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_lv8' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'dollar-sign' },
	                                    '$'
	                                  ),
	                                  ':'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'ZoneLevel8', className: 'control-label', component: _inputField.InputField, onFocus: this.handleOnFocus, withRef: true, ref: 'ZoneLevel8', standalone: true, type: 'text', onKeyPress: function onKeyPress(event) {
	                                    _this23.handleKeyPress('ZoneLevel8', event);
	                                  } })
	                              )
	                            )
	                          ),
	                          ' '
	                        )
	                      ),
	                      isJML && _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { id: 'mix-product', header: mixProductPanelHeader },
	                            _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 12 },
	                                  _react2.default.createElement(_MixProductTypeRadios2.default, { value: this.state.productSearchType, handleOptionChange: this.handleOptionChange })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 4 },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { style: { paddingLeft: '0px' }, className: 'col-xs-4 search-by-max-width' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'search_prod' })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 6 },
	                                  this.renderAutoSuggest()
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'formSubHeaderContainer', style: { marginTop: '20px' } },
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 3 },
	                                  _react2.default.createElement(
	                                    'p',
	                                    { className: 'formSubHeader' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mix_setting' })
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { sm: 2 },
	                                  _react2.default.createElement('input', { value: '1', disabled: true, style: customizedInputStyle })
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { sm: 3, className: 'select-menu-drop-up' },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'MixedProductBaseUnit', component: _selection.Selection, options: packageTypeOptions })
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { sm: 1, className: 'textAlignStyle', style: { fontWeight: 'bold', fontSize: '15px' } },
	                                  '='
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: 'nonbold-label-description textAlignStyle' },
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { sm: 2 },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: '(num)' })
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { sm: 3 },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: '(pkg_size)' })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 12 },
	                                  this.renderMixedProduct()
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    ' ',
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 4 },
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { id: 'cost-details', style: { height: isHMM && !(0, _permissions2.default)('view_price_level') ? '300px' : '500px' }, header: costsDetailsPanelHeader },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6, className: 'avg-and-inv-cost' },
	                                this.renderAvgCost()
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-6' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_price' }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      { className: 'asteriksReq' },
	                                      '*'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-6' },
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'RefPrice',
	                                      value: this.props.RefPriceValue,
	                                      withRef: true,
	                                      ref: 'RefPrice',
	                                      component: _inputField.InputField,
	                                      disabled: isJML && !(0, _permissions2.default)('change_price_reference'),
	                                      normalize: _NumberUtil.normalizeFourDecimals,
	                                      onFocus: this.handleOnFocus,
	                                      onChange: function onChange(event, newValue, previousValue, name) {
	                                        _this23.props.setValue('productForm', 'RefPrice', event.target.value);
	                                        if (!isEcity) {
	                                          var priceLv1 = (0, _NumberUtil.calculatePriceLevelNormal)(_this23.state.p1Percentage, event.target.value, _this23.props.ArrivalPrice);
	                                          var priceLv2 = (0, _NumberUtil.calculatePriceLevelNormal)(_this23.state.p2Percentage, event.target.value, _this23.props.ArrivalPrice);
	                                          var priceLv3 = (0, _NumberUtil.calculatePriceLevelNormal)(_this23.state.p3Percentage, event.target.value, _this23.props.ArrivalPrice);
	                                          var priceLv4 = (0, _NumberUtil.calculatePriceLevelNormal)(_this23.state.p4Percentage, event.target.value, _this23.props.ArrivalPrice);
	                                          var priceLv5 = (0, _NumberUtil.calculatePriceLevelNormal)(_this23.state.p5Percentage, event.target.value, _this23.props.ArrivalPrice);
	                                          _this23.setState({
	                                            priceLv1: priceLv1,
	                                            priceLv2: priceLv2,
	                                            priceLv3: priceLv3,
	                                            priceLv4: priceLv4,
	                                            priceLv5: priceLv5
	                                          });
	                                        }
	                                      },
	                                      onKeyPress: function onKeyPress(event) {
	                                        _this23.handleKeyPress('LowestSalePrice', event);
	                                      }
	                                    })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group mb0' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-6' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lowest_sale' }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      { className: 'asteriksReq' },
	                                      '*'
	                                    ),
	                                    ' ',
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dollarsign' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-6' },
	                                    isHMM ? (0, _permissions2.default)('hmm_view_arrival') || this.state.permissionChecked ? _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'LowestSalePrice',
	                                      withRef: true,
	                                      ref: 'LowestSalePrice',
	                                      component: _inputField.InputField,
	                                      normalize: _NumberUtil.normalizeFourDecimals,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        _this23.handleKeyPress('LV1', event);
	                                      }
	                                    }) : _react2.default.createElement(
	                                      'div',
	                                      { onClick: function onClick(e) {
	                                          return _this23.checkPasscode(e);
	                                        } },
	                                      _react2.default.createElement('input', {
	                                        disabled: true,
	                                        type: 'text',
	                                        placeholder: 'Click to view',
	                                        style: { borderRadius: '2px', width: '100%', border: '1px solid black', paddingLeft: '2px' }
	                                      })
	                                    ) : _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'LowestSalePrice',
	                                      withRef: true,
	                                      ref: 'LowestSalePrice',
	                                      component: _inputField.InputField,
	                                      normalize: _NumberUtil.normalizeFourDecimals,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        _this23.handleKeyPress('LV1', event);
	                                      }
	                                    })
	                                  )
	                                ),
	                                isEcity && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group mb0' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-6' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'arrival_price' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-6' },
	                                    _react2.default.createElement('input', { value: this.props.ArrivalPrice, disabled: true, style: customizedInputStyle })
	                                  )
	                                ),
	                                (isHMM && (0, _permissions2.default)('hmm_view_arrival') && !(0, _permissions2.default)('no_show_product_cost') || isUSPride || isATL || isRS) && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group mb0' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-6' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'arrival_price' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-6' },
	                                    _react2.default.createElement('input', { value: this.props.ArrivalPrice, disabled: true, style: customizedInputStyle })
	                                  )
	                                )
	                              )
	                            ),
	                            (!isHMM || (0, _permissions2.default)('view_price_level')) && _react2.default.createElement(
	                              'div',
	                              { className: 'formSubHeaderContainer' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 5, style: { padding: 0 } },
	                                  _react2.default.createElement(
	                                    'p',
	                                    { className: 'formSubHeader' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_price_levels' })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 7, style: { padding: 0 } },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'PriceType', component: renderPriceTypeRadio, disabled: isJML && !(0, _permissions2.default)('change_price_level') })
	                                )
	                              )
	                            ),
	                            (!isHMM || (0, _permissions2.default)('view_price_level')) && _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 12, className: 'centerStyle price-level-setup' },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Col,
	                                      { xs: 4 },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(
	                                          'label',
	                                          { className: 'col-xs-4' },
	                                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_1' }),
	                                          '%'
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'col-xs-7' },
	                                          _react2.default.createElement(_reduxForm.Field, {
	                                            name: 'P1Percentage',
	                                            className: 'control-label',
	                                            component: _inputField.ControlledInputField,
	                                            onFocus: this.handleOnFocus,
	                                            withRef: true,
	                                            ref: 'LV1',
	                                            placeholder: this.state.p1Percentage,
	                                            onChange: function onChange(event) {
	                                              _this23.handlePercentageChange("p1Percentage", event);
	                                            },
	                                            onKeyPress: function onKeyPress(event) {
	                                              _this23.handleKeyPress('LV2', event);
	                                            },
	                                            disabled: isJML && !(0, _permissions2.default)('change_price_level')
	                                          })
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'equal-sign' },
	                                        '='
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Col,
	                                      { xs: 4 },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(
	                                          'label',
	                                          { className: 'col-xs-4' },
	                                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_1' }),
	                                          _react2.default.createElement(
	                                            'span',
	                                            { className: 'dollar-sign' },
	                                            '$'
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'col-xs-7' },
	                                          _react2.default.createElement(_reduxForm.Field, { name: 'PriceLv1', className: 'control-label', component: _inputField.ControlledInputField, onFocus: this.handleOnFocus, withRef: true, ref: 'LV1_2', placeholder: this.state.priceLv1, onChange: function onChange(event) {
	                                              _this23.handlePriceChange("priceLv1", event);
	                                            }, onKeyPress: function onKeyPress(event) {
	                                              _this23.handleKeyPress('LV2_2', event);
	                                            }, disabled: isJML && !(0, _permissions2.default)('change_price_level') })
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Col,
	                                      { xs: 4, className: 'pull-right' },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(
	                                          'label',
	                                          { className: 'col-xs-4' },
	                                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_1' }),
	                                          _react2.default.createElement(
	                                            'span',
	                                            { className: 'dollar-sign' },
	                                            '$'
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'col-xs-8' },
	                                          _react2.default.createElement(_reduxForm.Field, { name: 'PriceLv1Rounded', className: 'control-label', component: _inputField.DisabledInputField, placeholder: (0, _NumberUtil.roundUp)(this.state.priceLv1) })
	                                        )
	                                      )
	                                    )
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 12, className: 'centerStyle' },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Col,
	                                      { xs: 4 },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(
	                                          'label',
	                                          { className: 'col-xs-4' },
	                                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_2' }),
	                                          ' %'
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'col-xs-7' },
	                                          _react2.default.createElement(_reduxForm.Field, { name: 'P2Percentage', className: 'control-label', component: _inputField.ControlledInputField, onFocus: this.handleOnFocus, withRef: true, ref: 'LV2', placeholder: this.state.p2Percentage, onChange: function onChange(event) {
	                                              _this23.handlePercentageChange("p2Percentage", event);
	                                            }, onKeyPress: function onKeyPress(event) {
	                                              _this23.handleKeyPress('LV3', event);
	                                            }, disabled: isJML && !(0, _permissions2.default)('change_price_level') })
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'equal-sign' },
	                                        '='
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Col,
	                                      { xs: 4 },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(
	                                          'label',
	                                          { className: 'col-xs-4' },
	                                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_2' }),
	                                          _react2.default.createElement(
	                                            'span',
	                                            { className: 'dollar-sign' },
	                                            '$'
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'col-xs-7' },
	                                          _react2.default.createElement(_reduxForm.Field, { name: 'PriceLv2', className: 'control-label', component: _inputField.ControlledInputField, onFocus: this.handleOnFocus, withRef: true, ref: 'LV2_2', placeholder: this.state.priceLv2, onChange: function onChange(event) {
	                                              _this23.handlePriceChange("priceLv2", event);
	                                            }, onKeyPress: function onKeyPress(event) {
	                                              _this23.handleKeyPress('LV3_2', event);
	                                            }, disabled: isJML && !(0, _permissions2.default)('change_price_level') })
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Col,
	                                      { xs: 4 },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(
	                                          'label',
	                                          { className: 'col-md-4' },
	                                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_2' }),
	                                          _react2.default.createElement(
	                                            'span',
	                                            { className: 'dollar-sign' },
	                                            '$'
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'col-md-8' },
	                                          _react2.default.createElement(_reduxForm.Field, { name: 'PriceLv1Rounded', className: 'control-label', component: _inputField.DisabledInputField, placeholder: (0, _NumberUtil.roundUp)(this.state.priceLv2) })
	                                        )
	                                      )
	                                    )
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 12, className: 'centerStyle' },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Col,
	                                      { xs: 4, className: 'level-col-percentages' },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(
	                                          'label',
	                                          { className: 'col-xs-4' },
	                                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_3' }),
	                                          ' %'
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'col-xs-7' },
	                                          _react2.default.createElement(_reduxForm.Field, { name: 'P3Percentage', className: 'control-label', component: _inputField.ControlledInputField, onFocus: this.handleOnFocus, withRef: true, ref: 'LV3', placeholder: this.state.p3Percentage, onChange: function onChange(event) {
	                                              _this23.handlePercentageChange("p3Percentage", event);
	                                            }, onKeyPress: function onKeyPress(event) {
	                                              _this23.handleKeyPress('LV4', event);
	                                            }, disabled: isJML && !(0, _permissions2.default)('change_price_level') })
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'equal-sign' },
	                                        '='
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Col,
	                                      { xs: 4, className: 'level-col-dollar' },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(
	                                          'label',
	                                          { className: 'col-xs-4' },
	                                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_3' }),
	                                          _react2.default.createElement(
	                                            'span',
	                                            { className: 'dollar-sign' },
	                                            '$'
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'col-xs-7' },
	                                          _react2.default.createElement(_reduxForm.Field, { name: 'PriceLv3', className: 'control-label', component: _inputField.ControlledInputField, onFocus: this.handleOnFocus, withRef: true, ref: 'LV3_2', placeholder: this.state.priceLv3, onChange: function onChange(event) {
	                                              _this23.handlePriceChange("priceLv3", event);
	                                            }, onKeyPress: function onKeyPress(event) {
	                                              _this23.handleKeyPress('LV4_2', event);
	                                            }, disabled: isJML && !(0, _permissions2.default)('change_price_level') })
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Col,
	                                      { xs: 4 },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(
	                                          'label',
	                                          { className: 'col-md-4' },
	                                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_3' }),
	                                          _react2.default.createElement(
	                                            'span',
	                                            { className: 'dollar-sign' },
	                                            '$'
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'col-md-8' },
	                                          _react2.default.createElement(_reduxForm.Field, { name: 'PriceLv1Rounded', className: 'control-label', component: _inputField.DisabledInputField, placeholder: (0, _NumberUtil.roundUp)(this.state.priceLv3) })
	                                        )
	                                      )
	                                    )
	                                  )
	                                )
	                              ),
	                              !isEcity && _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Row,
	                                  null,
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 12, className: 'centerStyle' },
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Row,
	                                      null,
	                                      _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { xs: 4 },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'form-group' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-xs-4' },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_4' }),
	                                            ' %'
	                                          ),
	                                          _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-xs-7' },
	                                            _react2.default.createElement(_reduxForm.Field, { name: 'P4Percentage', className: 'control-label', component: _inputField.ControlledInputField, onFocus: this.handleOnFocus, withRef: true, ref: 'LV4', placeholder: this.state.p4Percentage, onChange: function onChange(event) {
	                                                _this23.handlePercentageChange("p4Percentage", event);
	                                              }, onKeyPress: function onKeyPress(event) {
	                                                _this23.handleKeyPress('LV5', event);
	                                              }, disabled: isJML && !(0, _permissions2.default)('change_price_level') })
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'span',
	                                          { className: 'equal-sign' },
	                                          '='
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { xs: 4 },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'form-group' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-xs-4' },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_4' }),
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'dollar-sign' },
	                                              '$'
	                                            )
	                                          ),
	                                          _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-xs-7' },
	                                            _react2.default.createElement(_reduxForm.Field, { name: 'PriceLv4', className: 'control-label', component: _inputField.ControlledInputField, onFocus: this.handleOnFocus, withRef: true, ref: 'LV4_2', placeholder: this.state.priceLv4, onChange: function onChange(event) {
	                                                _this23.handlePriceChange("priceLv4", event);
	                                              }, onKeyPress: function onKeyPress(event) {
	                                                _this23.handleKeyPress('LV5_2', event);
	                                              }, disabled: isJML && !(0, _permissions2.default)('change_price_level') })
	                                          )
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { xs: 4 },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'form-group' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-4' },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_4' }),
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'dollar-sign' },
	                                              '$'
	                                            )
	                                          ),
	                                          _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-8' },
	                                            _react2.default.createElement(_reduxForm.Field, { name: 'PriceLv1Rounded', className: 'control-label', component: _inputField.DisabledInputField, placeholder: (0, _NumberUtil.roundUp)(this.state.priceLv4) })
	                                          )
	                                        )
	                                      )
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Row,
	                                  null,
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 12, className: 'centerStyle' },
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Row,
	                                      null,
	                                      _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { xs: 4 },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'form-group' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-xs-4' },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_5' }),
	                                            ' %'
	                                          ),
	                                          _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-xs-7' },
	                                            _react2.default.createElement(_reduxForm.Field, { name: 'P5Percentage', className: 'control-label', component: _inputField.ControlledInputField, onFocus: this.handleOnFocus, withRef: true, ref: 'LV5', placeholder: this.state.p5Percentage, onChange: function onChange(event) {
	                                                _this23.handlePercentageChange("p5Percentage", event);
	                                              }, onKeyPress: function onKeyPress(event) {
	                                                _this23.handleKeyPress('LV1_2', event);
	                                              }, disabled: isJML && !(0, _permissions2.default)('change_price_level') })
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'span',
	                                          { className: 'equal-sign' },
	                                          '='
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { xs: 4 },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'form-group' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-xs-4' },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_5' }),
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'dollar-sign' },
	                                              '$'
	                                            )
	                                          ),
	                                          _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-xs-7' },
	                                            _react2.default.createElement(_reduxForm.Field, {
	                                              name: 'PriceLv5',
	                                              className: 'control-label',
	                                              component: _inputField.ControlledInputField,
	                                              onFocus: this.handleOnFocus,
	                                              withRef: true,
	                                              ref: 'LV5_2',
	                                              placeholder: this.state.priceLv5,
	                                              onChange: function onChange(event) {
	                                                _this23.handlePriceChange("priceLv5", event);
	                                              },
	                                              onKeyPress: function onKeyPress(event) {
	                                                if (event.charCode === 13) {
	                                                  event.preventDefault();
	                                                  _this23.refs["CRVOptions"].getRenderedComponent().refs.select.focus();
	                                                }
	                                              },
	                                              disabled: isJML && !(0, _permissions2.default)('change_price_level')
	                                            })
	                                          )
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { xs: 4 },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: 'form-group' },
	                                          _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-md-4' },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lv_5' }),
	                                            _react2.default.createElement(
	                                              'span',
	                                              { className: 'dollar-sign' },
	                                              '$'
	                                            )
	                                          ),
	                                          _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-8' },
	                                            _react2.default.createElement(_reduxForm.Field, { name: 'PriceLv1Rounded', className: 'control-label', component: _inputField.DisabledInputField, placeholder: (0, _NumberUtil.roundUp)(this.state.priceLv5) })
	                                          )
	                                        )
	                                      )
	                                    )
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement('div', { className: 'formDivider' })
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              { className: 'formRow' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'taxable' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3 },
	                                _react2.default.createElement(_reduxForm.Field, {
	                                  name: 'IsTaxable'
	                                  // disabled={(isAN && this.props.IsAllTaxable)}
	                                  , component: Checkbox
	                                })
	                              ),
	                              isAN && _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 3 },
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all_taxable' })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 3 },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'IsAllTaxable', component: Checkbox })
	                                )
	                              ),
	                              (isEcity || isGS) && _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 3 },
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'non_food' })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 3 },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'IsNonFood', component: Checkbox })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              { className: 'formRow' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'CRV' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 9 },
	                                this.CRV()
	                              )
	                            )
	                          ),
	                          ' '
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        { id: 'sale-details', header: saleDetailsPanelHeader },
	                        ' ',
	                        isEcity && _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          null,
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Button,
	                              {
	                                bsStyle: 'primary',
	                                style: { position: 'absolute', top: '-50px', right: '0px' },
	                                type: 'button',
	                                onClick: function onClick() {
	                                  _this23.openESLModal();
	                                },
	                                disabled: !this.props.currentProduct && !this.props.params.id || !this.state.eslEnabled
	                              },
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ESL' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          { className: 'formRow' },
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 7 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'stop_sale' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'IsStopSale', component: Checkbox })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 7 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'oversaleable' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'IsOverSaleable', component: Checkbox, disabled: this.props.IsStopSale })
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          { className: 'formRow' },
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 7 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'wholesale_only' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'IsWholesaleOnly', component: Checkbox, disabled: this.props.IsStopSale })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 7 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mobile_sale' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'IsMobile', component: Checkbox, disabled: this.props.IsStopSale })
	                              )
	                            )
	                          )
	                        ),
	                        isAFM && _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          { className: 'formRow' },
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 7 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'top_deal' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'IsGreatDeal', component: Checkbox, disabled: this.props.IsStopSale })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 7 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_arrival' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'IsNewArrival', component: Checkbox, disabled: this.props.IsStopSale })
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          { className: 'formRow' },
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 7 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'nationwide' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'IsSoldNationwide', component: Checkbox, disabled: this.props.IsStopSale })
	                              )
	                            )
	                          ),
	                          (isAFG || isMyuMyu || isWecom) && _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 7 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Proposition65' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'IsProposition65', component: Checkbox, disabled: this.props.IsStopSale })
	                              )
	                            )
	                          )
	                        ),
	                        isHF && _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          { className: 'formRow' },
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 7 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsB2B' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'IsB2B', component: Checkbox, disabled: this.props.IsB2B })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 7 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsB2C' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'IsB2C', component: Checkbox, disabled: this.props.IsB2C })
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          { className: 'formRow' },
	                          (isEcity || isGS) && _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 7 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sync_scale' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'IsSyncToScales', component: Checkbox, disabled: this.props.IsStopSale })
	                              )
	                            )
	                          ),
	                          isGS && _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 7 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tare' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Tare', withRef: true, ref: 'Tare', component: _inputField.InputField, onKeyPress: function onKeyPress(event) {} })
	                              )
	                            )
	                          ),
	                          isEcity && _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 7 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sync_esl' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'IsSyncToESL', component: this.ESLCheckbox, disabled: this.props.IsStopSale || !this.props.currentProduct && !this.props.params.id })
	                              )
	                            )
	                          ),
	                          isAFG && _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 7 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'afg_choice' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'IsAFGChioce', component: Checkbox, disabled: this.props.IsStopSale })
	                              )
	                            )
	                          ),
	                          isAFG && _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 7 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'alcohol' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'IsAlcohol', component: Checkbox, disabled: this.props.IsStopSale })
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          { className: 'formRow' },
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 8 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'limit_qty_order' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(_reduxForm.Field, { placeholder: '0', name: 'LimitQuantityPerOrder', component: _inputField.InputField })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 8 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'limit_qty_order_desc' })
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement('div', { className: 'formDivider' }),
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          { className: 'formRow' },
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 3 },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'default_sales' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 9 },
	                            this.defaultSales()
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          { className: 'formRow' },
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enable_for_languages' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(_reduxForm.Field, {
	                              multi: true,
	                              removeSelected: true,
	                              simpleValue: true,
	                              closeOnSelect: false,
	                              name: 'ViewableLanguages',
	                              component: _selection.SelectionWithProps,
	                              options: languages,
	                              placeholder: _reactReduxI18n.I18n.t('enable_for_language')
	                            })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        { id: 'buyer-details', header: buyerDetailsPanelHeader },
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          { className: 'formRow' },
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'stop_purchase' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 8 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'IsStopPurchase', component: Checkbox })
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement('div', { className: 'formDivider' }),
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          { className: 'formRow' },
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'default_purchaser' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 8 },
	                                this.renderDefaultBuyers()
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      ' '
	                    ),
	                    ' ',
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 4 },
	
	                      // !isHMM &&
	                      true && _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { id: 'convert-details', header: convertDetailsPanelHeader },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                  _reactBootstrap.Row,
	                                  null,
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 12 },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ConvertType', component: convertNumRadios })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Row,
	                                  null,
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 12 },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: 'form-group' },
	                                      !isTN && _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-xs-5' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'convert_prod_qty' })
	                                      ),
	                                      isTN && _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-xs-5' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_convert_unit' })
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-7 convert-prod-qty' },
	                                        _react2.default.createElement(_reduxForm.Field, { name: 'ConvertNum', component: _inputField.DisabledInputField })
	                                      )
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Row,
	                                  null,
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 12 },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: 'form-group' },
	                                      !isTN && _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-xs-5' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_convert_unit' })
	                                      ),
	                                      isTN && _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-xs-5' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_convert_unit' })
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-7 convert-prod-qty' },
	                                        _react2.default.createElement(_reduxForm.Field, { name: 'PurchaseConvertUnit', component: _inputField.InputField })
	                                      )
	                                    )
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              this.renderConvertDetails()
	                            )
	                          ),
	                          ' '
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        { id: 'inventory-details-panel', header: inventoryDetailsPanelHeader },
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          null,
	                          isTQ && _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'hmart_code' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 7 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'InternalBarcode', withRef: true, ref: 'InternalBarcode', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                                    _this23.handleKeyPress('UnitPerPallet', event);
	                                  } })
	                              )
	                            )
	                          ),
	                          isUSPride && _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 7 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Default_Warehouse_id', component: _selection.Selection, options: this.state.warehouseOptions })
	                              )
	                            )
	                          ),
	                          !isTQ && _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'internal_barcode' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 7 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'InternalBarcode', withRef: true, ref: 'InternalBarcode', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                                    _this23.handleKeyPress('UnitPerPallet', event);
	                                  } })
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          null,
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'per_pallet' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 7 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'UnitPerPallet', className: 'control-label', component: _inputField.InputField, onFocus: this.handleOnFocus, withRef: true, ref: 'UnitPerPallet', onKeyPress: function onKeyPress(event) {
	                                    _this23.handleKeyPress('MinStockRange', event);
	                                  }
	                                })
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          null,
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 5 },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'stock_range' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 3 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'min' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 8 },
	                                _react2.default.createElement(_reduxForm.Field, {
	                                  name: 'MinStockRange',
	                                  withRef: true,
	                                  ref: 'MinStockRange',
	                                  component: _inputField.InputField,
	                                  onFocus: this.handleOnFocus,
	                                  onKeyPress: function onKeyPress(event) {
	                                    _this23.handleKeyPress('MaxStockRange', event);
	                                  }
	                                })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 1, style: { textAlign: 'center' } },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: '~' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 3 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'max' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 8 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'MaxStockRange', withRef: true, ref: 'MaxStockRange', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                                    _this23.handleKeyPress('Zone', event);
	                                  } })
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'h3',
	                          { style: { marginBottom: '10px' } },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' })
	                        ),
	                        isEcity && _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 8 },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone' })
	                            ),
	                            _react2.default.createElement(_reduxForm.Field, { name: 'Zone', component: _inputField.InputField })
	                          )
	                        ),
	                        !isEcity && !isAFM && _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            _defineProperty({ sm: 4, style: { width: 120 }, className: 'select-menu-drop-up' }, 'style', { width: 120 }),
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone' })
	                            ),
	                            _react2.default.createElement(_reduxForm.Field, { name: 'Zone', component: _selection.Selection, options: getZoneOptions, disabled: !this.props.zones })
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            _defineProperty({ sm: 4, style: { width: 120 }, className: 'select-menu-drop-up' }, 'style', { width: 120 }),
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin' })
	                            ),
	                            _react2.default.createElement(_reduxForm.Field, {
	                              name: 'Bin',
	                              component: _selection.Selection,
	                              options: getBinOptions,
	                              disabled: !this.props.Zone
	                            })
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            _defineProperty({ sm: 4, style: { width: 120 }, className: 'select-menu-drop-up' }, 'style', { width: 120 }),
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'level' })
	                            ),
	                            _react2.default.createElement(_reduxForm.Field, {
	                              name: 'Level',
	                              component: _selection.Selection,
	                              options: getLevelOptions,
	                              disabled: !this.props.Bin
	                            })
	                          )
	                        ),
	                        isAFM && _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12, style: { marginTop: '5px' } },
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              _defineProperty({ sm: 4, style: { width: 120 }, className: 'select-menu-drop-up' }, 'style', { width: 120 }),
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Bellevue'
	                              ),
	                              _react2.default.createElement(_reduxForm.Field, { name: 'Zone', component: _selection.Selection, options: getZoneOptions, disabled: !this.props.zones })
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              _defineProperty({ sm: 4, style: { width: 120 }, className: 'select-menu-drop-up' }, 'style', { width: 120 }),
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin' })
	                              ),
	                              _react2.default.createElement(_reduxForm.Field, {
	                                name: 'Bin',
	                                component: _selection.Selection,
	                                options: getBinOptions,
	                                disabled: !this.props.Zone
	                              })
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              _defineProperty({ sm: 4, style: { width: 120 }, className: 'select-menu-drop-up' }, 'style', { width: 120 }),
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'level' })
	                              ),
	                              _react2.default.createElement(_reduxForm.Field, {
	                                name: 'Level',
	                                component: _selection.Selection,
	                                options: getLevelOptions,
	                                disabled: !this.props.Bin
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12, style: { marginTop: '5px' } },
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              _defineProperty({ sm: 4, style: { width: 120 }, className: 'select-menu-drop-up' }, 'style', { width: 120 }),
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Beaverton'
	                              ),
	                              _react2.default.createElement(_reduxForm.Field, { name: 'Zone2', component: _selection.Selection, options: getZoneOptions, disabled: !this.props.zones })
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              _defineProperty({ sm: 4, style: { width: 120 }, className: 'select-menu-drop-up' }, 'style', { width: 120 }),
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin' })
	                              ),
	                              _react2.default.createElement(_reduxForm.Field, {
	                                name: 'Bin2',
	                                component: _selection.Selection,
	                                options: getBin2Options,
	                                disabled: !this.props.Zone2
	                              })
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              _defineProperty({ sm: 4, style: { width: 120 }, className: 'select-menu-drop-up' }, 'style', { width: 120 }),
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'level' })
	                              ),
	                              _react2.default.createElement(_reduxForm.Field, {
	                                name: 'Level2',
	                                component: _selection.Selection,
	                                options: getLevel2Options,
	                                disabled: !this.props.Bin2
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12, style: { marginTop: '5px' } },
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              _defineProperty({ sm: 4, style: { width: 120 }, className: 'select-menu-drop-up' }, 'style', { width: 120 }),
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Seattle'
	                              ),
	                              _react2.default.createElement(_reduxForm.Field, { name: 'Zone3', component: _selection.Selection, options: getZoneOptions, disabled: !this.props.zones })
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              _defineProperty({ sm: 4, style: { width: 120 }, className: 'select-menu-drop-up' }, 'style', { width: 120 }),
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin' })
	                              ),
	                              _react2.default.createElement(_reduxForm.Field, {
	                                name: 'Bin3',
	                                component: _selection.Selection,
	                                options: getBin3Options,
	                                disabled: !this.props.Zone3
	                              })
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              _defineProperty({ sm: 4, style: { width: 120 }, className: 'select-menu-drop-up' }, 'style', { width: 120 }),
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'level' })
	                              ),
	                              _react2.default.createElement(_reduxForm.Field, {
	                                name: 'Level3',
	                                component: _selection.Selection,
	                                options: getLevel3Options,
	                                disabled: !this.props.Bin3
	                              })
	                            )
	                          )
	                        ),
	                        isMMD && _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12, style: { position: 'relative', marginTop: 20 } },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 3 },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Auto PO'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 1 },
	                              _react2.default.createElement(_reduxForm.Field, { name: 'AutoPO', component: Checkbox })
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 4 },
	                              _react2.default.createElement(
	                                'p',
	                                { style: { fontWeight: "bold", position: "relative" } },
	                                'Auto PO Qty'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 2, style: { paddingLeft: 10 } },
	                              _react2.default.createElement(_reduxForm.Field, {
	                                name: 'default_po_quantity',
	                                component: _inputField.InputField
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12, style: { position: 'relative', marginTop: 20 } },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 2, style: { paddingRight: 0 } },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shelf_life' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 2, style: { paddingLeft: 10 } },
	                              _react2.default.createElement(_reduxForm.Field, {
	                                name: 'ShiftLife',
	                                withRef: true,
	                                ref: 'ShelfLife',
	                                component: _inputField.InputField,
	                                onFocus: this.handleOnFocus,
	                                onKeyPress: function onKeyPress(event) {
	                                  if (event.charCode === 13) event.preventDefault();
	                                }
	                              })
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 1 },
	                              _react2.default.createElement(
	                                'p',
	                                { style: { fontWeight: "bold", position: "relative", left: "-10px" } },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	                              )
	                            ),
	                            _react2.default.createElement(_reactBootstrap.Col, { xs: 1 }),
	                            isEcity && _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3, style: { paddingRight: 0 } },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'expire_date' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3, style: { paddingLeft: 0 } },
	                                _react2.default.createElement(_reduxForm.Field, {
	                                  disabled: true,
	                                  name: 'ShiftLifeTime',
	                                  withRef: true,
	                                  ref: 'ShelfLife',
	                                  component: _inputField.InputField
	                                })
	                              )
	                            )
	                          )
	                        ),
	                        isFACEX && _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12, style: { position: 'relative', marginTop: 20 } },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 4 },
	                              _react2.default.createElement(
	                                'p',
	                                { style: { fontWeight: "bold", position: "relative" } },
	                                'Inventory QTY: '
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 3, style: { paddingLeft: 10 } },
	                              _react2.default.createElement(_reactBootstrap.Input, {
	                                type: 'text',
	                                name: 'qty',
	                                value: this.state.productInventoryQty,
	                                onFocus: this.handleOnFocus,
	                                onChange: function onChange(e) {
	                                  _this23.setState({ productInventoryQty: e.target.value });
	                                }
	                              })
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 3, style: { paddingLeft: 10 } },
	                              _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                  bsStyle: 'primary',
	                                  type: 'button',
	                                  onClick: function onClick() {
	                                    return _this23.props.postProductInventoryBatches(_this23.props.params.id, _this23.state.productInventoryQty);
	                                  }
	                                },
	                                _react2.default.createElement('em', { className: 'fa fa-save' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'modify_inventory' })
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      ' ',
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { id: 'vendor-details', header: vendorPanelHeader },
	                            this.renderVendors()
	                          ),
	                          ' '
	                        )
	                      ),
	                      ' '
	                    ),
	                    ' '
	                  ),
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                dialogStyles: createDialogStyle,
	                isVisible: this.state.deleteModalOpen,
	                onCloseClicked: this.closeDeleteModal,
	                title: deleteProduct
	              },
	              _react2.default.createElement(_confirmActionModal2.default, {
	                'case': 'confirmPassword',
	                closeC: this.checkAuthorize,
	                checkPasswordFailure: this.props.checkPasswordFailure
	              })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { isVisible: this.state.vendorOpen, onCloseClicked: function onCloseClicked() {
	                  _this23.closeVendor();
	                }, title: 'Add A New Vendor' },
	              _react2.default.createElement(_vendorForm2.default, { closeV: this.closeVendor })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { isVisible: this.state.groupOpen, onCloseClicked: function onCloseClicked() {
	                  _this23.closeGroup();
	                }, title: 'Add A New Group' },
	              _react2.default.createElement(_groupForm2.default, { closeG: this.closeGroup })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: createDialogStyle, isVisible: this.state.editProductGroup, onCloseClicked: function onCloseClicked() {
	                  _this23.closeProductGroupEdit();
	                }, title: editGroupFormTitle },
	              _react2.default.createElement(_editGroupForm2.default, {
	                closeG: this.closeProductGroupEdit,
	                groups: this.props.groups,
	                formContent: this.state.editGroupFormAction === 'changeGroup' && this.state.productNavigation_1,
	                productId: this.props.currentProductDetail && this.props.currentProductDetail.Product_id,
	                saveAction: editGroupFormSaveAction,
	                saveCallback: editGroupFormSaveActionCallback
	              })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { isVisible: this.state.categoryOpen, onCloseClicked: function onCloseClicked() {
	                  _this23.closeCategory();
	                }, title: 'Create a new category' },
	              _react2.default.createElement(_categoryForm2.default, { closeC: this.closeCategory, type: 'productForm' })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                dialogStyles: createDialogStyle,
	                isVisible: this.state.showProductCreatedOpen,
	                onCloseClicked: this.closeShowProductCreated.bind(this)
	              },
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_saved' })
	                )
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_ask_if_stay_on_current_page' }),
	                  '?'
	                )
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle' },
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  { bsStyle: 'primary', onClick: function onClick(event) {
	                      _this23.refreshPage(event);
	                    }, type: 'button' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	                ),
	                this.renderCloseButton()
	              )
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: createDialogStyle, isVisible: this.state.productNavigationOpen[0], onCloseClicked: function onCloseClicked() {
	                  _this23.closeNavigation();
	                } },
	              _react2.default.createElement(_productFormNavigation2.default, {
	                groups: this.props.groups,
	                handleClickNext: this.handleClickNext_1,
	                formContent: this.state.productNavigation_1
	              })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: createDialogStyle, isVisible: this.state.productNavigationOpen[1], onCloseClicked: function onCloseClicked() {
	                  _this23.closeNavigation();
	                } },
	              _react2.default.createElement(_productFormNavigation.productFormNavigation_2, { handleClickPrev: this.handleClickPrev_2, handleClickNext: this.handleClickNext_2, formContent: this.state.productNavigation_2 })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: createDialogStyle, isVisible: this.state.productNavigationOpen[2], onCloseClicked: function onCloseClicked() {
	                  _this23.closeNavigation();
	                } },
	              _react2.default.createElement(_productFormNavigation.productFormNavigation_3, {
	                handleClickPrev: this.handleClickPrev_3,
	                closeNavigation: this.closeNavigation,
	                saveProductFormNavigation_3: this.saveProductFormNavigation_3,
	                formContent: this.state.productNavigation_3,
	                ProductNum: this.state.productNavigation_1.ProductNum,
	                ProductGroup_id: this.state.productNavigation_1.ProductGroup_id,
	                ProductCategory1_id: this.state.productNavigation_1.ProductCategory1_id,
	                suggestedProdNum: this.state.productNavigation_1.suggestedProdNum,
	                LastDigit: this.state.productNavigation_1.LastDigit
	              })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: createDialogStyle, isVisible: this.state.packageTypeOpen, onCloseClicked: function onCloseClicked() {
	                  _this23.closePackageType();
	                } },
	              _react2.default.createElement(_packageTypes2.default, { selectPackageType: this.selectPackageType })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                dialogStyles: promotionsStyle || this.state.isLoadingSavePromotion,
	                isVisible: this.state.viewPromotion,
	                onCloseClicked: this.closeViewPromotion,
	                title: viewPromotionHeader
	              },
	              _react2.default.createElement(
	                'div',
	                { id: 'promotions-page', className: 'centerStyle' },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Tabs,
	                    { activeKey: this.state.tabsKey, justified: true, onSelect: this.handleTabSelect },
	                    this.renderByQuantityTab(),
	                    this.renderByTotalPriceProductTab()
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  this.renderPromoDetails()
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                dialogStyles: createDialogStyle,
	                isVisible: this.state.editRecPermissionOpen,
	                onCloseClicked: function onCloseClicked() {
	                  _this23.closeEditRecPermission();
	                },
	                title: editRecPermission
	              },
	              _react2.default.createElement(_confirmActionModal2.default, {
	                'case': this.state.case,
	                checkPermission: this.props.checkPermission,
	                checkPermissionSuccess: this.props.checkPermissionSuccess
	              })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                dialogStyles: deletePromotionDialogStyle,
	                isVisible: this.state.deletePromotionOpen,
	                onCloseClicked: this.closeDeletePromotion
	              },
	              _react2.default.createElement(_confirmActionModal2.default, {
	                'case': 'removeItem',
	                closeC: this.closeDeletePromotion,
	                caseAction: this.handleDeletePromotion
	              })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                dialogStyles: editPromotionDialog,
	                isVisible: this.state.editPromotionOpen,
	                onCloseClicked: function onCloseClicked() {
	                  return _this23.closeEditPromotion();
	                },
	                title: editPromotionTitle
	              },
	              _react2.default.createElement(_components.EditPromotionModal, {
	                promotion: this.state.promotionToEdit,
	                customerList: this.state.customerList,
	                closeEditPromotion: this.closeEditPromotion,
	                isLoadingPromoDetails: this.state.isLoadingPromoDetails,
	                searchProduct: false
	              })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                dialogStyles: createDialogStyle,
	                isVisible: this.state.checkAuthorizeOpen,
	                onCloseClicked: this.closeCheckAuthorize
	              },
	              _react2.default.createElement(_confirmActionModal2.default, {
	                'case': 'confirmPassword',
	                closeC: this.checkAuthorize,
	                checkPasswordFailure: this.props.checkPasswordFailure
	              })
	            ),
	            renderRichTextEditor(),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                dialogStyles: createDisplayCategoryDialogStyle,
	                isVisible: this.state.displayCategoryBoxOpen,
	                onCloseClicked: function onCloseClicked() {
	                  _this23.closeDisplayCategoryBox();
	                },
	                title: displayCategoryBoxTitle
	              },
	              _react2.default.createElement(_displayCategoryModal.DisplayCategoryModal, { displayCategories: this.state.displayCategories, productId: this.props.params.id, editDisplayCategories: this.props.editDisplayCategories, closeModal: this.closeDisplayCategoryBox, getDisplayCategories: this.getDisplayCategories })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                dialogStyles: createDialogStyle,
	                isVisible: this.state.skusModal,
	                onCloseClicked: function onCloseClicked() {
	                  _this23.closeSkusModal();
	                },
	                title: skusModalTitle
	              },
	              _react2.default.createElement(_SkusModal2.default, {
	                close: this.closeSkusModal,
	                skus: this.state.ProductSKU,
	                updateSKU: this.updateSKU,
	                Product_id: this.state.Product_id
	              })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                dialogStyles: imagesModalStyle,
	                isVisible: this.state.imagesModalOpen,
	                onCloseClicked: this.closeImageModal,
	                title: imagesModalTitle
	              },
	              _react2.default.createElement(_ProductImagesTable2.default, {
	                productId: this.props.currentProductDetail && this.props.currentProductDetail.Product_id,
	                handleImageUpdated: function handleImageUpdated(image) {
	                  return _this23.handleImageUpdated(image);
	                }
	              })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                dialogStyles: convertProductListStyle,
	                isVisible: this.state.addConvertProductsOpen,
	                onCloseClicked: function onCloseClicked() {
	                  return _this23.closeAddConvertProducts();
	                },
	                title: addConvertProductsTitle
	              },
	              _react2.default.createElement(_LinkProductsModal2.default, {
	                products: this.state.categoryProducts,
	                previouslySelectedProducts: this.state.relatedProducts,
	                modifyConvertableProductList: this.modifyConvertableProductList
	              })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { title: productMetaInfoTitle, dialogStyles: createProductMetaStyle, isVisible: this.state.productMetaInfoVisibility, onCloseClicked: function onCloseClicked() {
	                  _this23.setProductMetaInfoVisibility(false);
	                } },
	              _react2.default.createElement(_ProductMetaInfoModal2.default, { meta_info: this.state.meta_info, handleProductMetaInfoSave: this.handleProductMetaInfoSave })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { title: eslTitle, dialogStyles: createESLStyle, isVisible: this.state.eslModalVisibility, onCloseClicked: function onCloseClicked() {
	                  _this23.closeESLModal();
	                } },
	              _react2.default.createElement(_ESLModal2.default, { eslFetchData: this.state.eslFetchData, fetchESLTemplate: this.props.fetchESLTemplate, handleSaveESL: this.handleSaveESL, handleFetchESL: this.handleFetchESL })
	            ),
	            _react2.default.createElement(_confirmModal2.default, {
	              title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Action Confirmation' }),
	              content: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Warning: Shipping Weight is lower then Net Weight' }),
	              onConfirm: function onConfirm() {
	                _this23.setState({ confirmModalVisibility: false });
	                _this23.submitForm(_this23.state.formProps);
	              },
	              onCancel: function onCancel() {
	                _this23.setState({ confirmModalVisibility: false });
	              },
	              isVisible: this.state.confirmModalVisibility
	            })
	          )
	          //---------------
	          // End HTML
	          //---------------
	
	        );
	      }
	    }
	  }]);
	
	  return ProductForm;
	}(_react.Component);
	
	ProductForm.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var _default = (0, _reactRouter.withRouter)(ProductForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(submitTrue, 'submitTrue', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isMyuMyu, 'isMyuMyu', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isJML, 'isJML', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isHMM, 'isHMM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isAFG, 'isAFG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isWecom, 'isWecom', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isCalco, 'isCalco', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isMMD, 'isMMD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isPTS, 'isPTS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isAFM, 'isAFM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isPS, 'isPS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isTN, 'isTN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isAN, 'isAN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isChinaTown, 'isChinaTown', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isUSPride, 'isUSPride', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isWIZ, 'isWIZ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isJTB, 'isJTB', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isHF, 'isHF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isTQ, 'isTQ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isFACEX, 'isFACEX', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isOCM, 'isOCM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isATL, 'isATL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isRS, 'isRS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isFBD, 'isFBD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isSW, 'isSW', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isABCFF, 'isABCFF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isCS, 'isCS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isLO, 'isLO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isAmzey, 'isAmzey', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isAPO, 'isAPO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isGS, 'isGS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(customizedInputStyle, 'customizedInputStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(renderInputField, 'renderInputField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(renderRadios, 'renderRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(Checkbox, 'Checkbox', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(renderPriceTypeRadio, 'renderPriceTypeRadio', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(ConvertProductTypeRadios, 'ConvertProductTypeRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(relatedRadios, 'relatedRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(sizeRadios, 'sizeRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(convertNumRadios, 'convertNumRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(renderSaleRadios, 'renderSaleRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(renderConvertDetailsList, 'renderConvertDetailsList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(renderMixProductArrays, 'renderMixProductArrays', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(renderVendorArrays, 'renderVendorArrays', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(languages, 'languages', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isSoleStage, 'isSoleStage', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isBD, 'isBD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(ProductForm, 'ProductForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productForm.jsx');
	}();

	;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProductFormNavigation_3 = exports.ProductFormNavigation_2 = exports.ProductFormNavigation_1 = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _selection = __webpack_require__(21);
	
	var _inputField = __webpack_require__(16);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _packageTypes = __webpack_require__(98);
	
	var _packageTypes2 = _interopRequireDefault(_packageTypes);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEcity = _root_url.ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === "https://dev-scm.truckxi.com/api/";
	var isHMM = _root_url.ROOT_API_URL === "https://hmm-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://hmm-scm.truckxi.com/api/";
	var isJTB = _root_url.ROOT_API_URL === 'https://jtb-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://jtb-scm.truckxi.com/api/';
	
	var createPackageTypesDialogStyle = {
	  width: '650px',
	  marginLeft: '-15%'
	};
	
	var RowRenderer = function (_Component) {
	  _inherits(RowRenderer, _Component);
	
	  function RowRenderer() {
	    _classCallCheck(this, RowRenderer);
	
	    return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(RowRenderer, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { onDoubleClick: function onDoubleClick() {
	            _this2.props.onDoubleClick(_this2.props.row, _this2.props.field);
	          } },
	        _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	      );
	    }
	  }]);
	
	  return RowRenderer;
	}(_react.Component);
	
	var sizeRadios = function sizeRadios(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-6 text-nowrap' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'true',
	        checked: props.input.value === true || props.input.value === "true" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_large_prod' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-6 text-nowrap' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'false',
	        checked: props.input.value === false || props.input.value === "false" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_small_prod' })
	    )
	  );
	};
	
	var convertNumRadios = function convertNumRadios(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-sm-5 text-nowrap' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'weight',
	        checked: props.input.value === "weight" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_weight' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-sm-5 text-nowrap' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'unit',
	        checked: props.input.value === "unit" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_unit' })
	    )
	  );
	};
	
	var ProductFormNavigation_1 = exports.ProductFormNavigation_1 = function (_Component2) {
	  _inherits(ProductFormNavigation_1, _Component2);
	
	  function ProductFormNavigation_1() {
	    _classCallCheck(this, ProductFormNavigation_1);
	
	    var _this3 = _possibleConstructorReturn(this, (ProductFormNavigation_1.__proto__ || Object.getPrototypeOf(ProductFormNavigation_1)).call(this));
	
	    _this3.state = {
	      group: null,
	      category: null,
	      suggestedProdNum: null,
	      isLinked: false,
	      linkProdOpen: false,
	      products: {
	        rows: [],
	        filters: {},
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	      initial: false
	    };
	    _this3.openLinkProd = _this3.openLinkProd.bind(_this3);
	    _this3.closeLinkProd = _this3.closeLinkProd.bind(_this3);
	    _this3.selectExistingProd = _this3.selectExistingProd.bind(_this3);
	    _this3.clearFields = _this3.clearFields.bind(_this3);
	    return _this3;
	  }
	
	  _createClass(ProductFormNavigation_1, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.formContent) {
	        this.props.setValue('productFormNavigation_1', 'Category', this.props.formContent.ProductCategory1_id);
	        this.props.setValue('productFormNavigation_1', 'Group', this.props.formContent.ProductGroup_id);
	        this.props.setValue('productFormNavigation_1', 'Name', this.props.formContent.Name);
	        this.props.setValue('productFormNavigation_1', 'Description', this.props.formContent.Description);
	        this.props.setValue('productFormNavigation_1', 'IsLarge', this.props.formContent.IsLarge);
	        this.props.setValue('productFormNavigation_1', 'LastDigit', this.props.formContent.LastDigit);
	        var suggestedProdNum = this.props.formContent.suggestedProdNum;
	        var isLinked = this.props.formContent.isLinked;
	        this.setState({ suggestedProdNum: suggestedProdNum, isLinked: isLinked });
	      }
	      if (this.props.formContent.suggestedProdNum) {
	        this.setState({ initial: true });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.Group && nextProps.Group != this.props.Group) {
	        this.props.fetchGroupCategories(nextProps.Group.value || nextProps.Group);
	        var index = _lodash2.default.findIndex(this.props.groups, { ProductGroup_id: nextProps.Group.value || nextProps.Group });
	        if (index > -1) {
	          var group = _extends({}, this.props.groups[index]);
	          if (group.GroupNum.length < 2) {
	            group.GroupNum = "0" + group.GroupNum;
	          }
	          this.setState({ group: group });
	        }
	        if (this.props.Group) {
	          this.props.setValue('productFormNavigation_1', 'Category', null);
	          this.props.setValue('productFormNavigation_1', 'IsLarge', null);
	          this.props.setValue('productFormNavigation_1', 'LastDigit', null);
	          this.setState({ category: null, suggestedProdNum: null, isLinked: false });
	        }
	      }
	      if (nextProps.Category && nextProps.Category != this.props.Category) {
	        var _index = _lodash2.default.findIndex(this.props.groupCategories, { ProductCategory_id: nextProps.Category.value || nextProps.Category });
	        if (_index > -1) {
	          this.setState({ category: this.props.groupCategories[_index] });
	        }
	        this.props.fetchSuggestedProdNum(this.props.groupCategories[_index].ProductCategory_id);
	        if (this.props.Category) {
	          this.props.setValue('productFormNavigation_1', 'IsLarge', null);
	          this.props.setValue('productFormNavigation_1', 'LastDigit', null);
	        }
	      }
	      if (nextProps.suggestedProdNumFetched !== null && nextProps.suggestedProdNumFetched != this.props.suggestedProdNumFetched) {
	        if (this.state.initial) {
	          this.setState({ initial: false });
	        } else {
	          this.setState({ suggestedProdNum: nextProps.suggestedProdNumFetched, isLinked: false });
	          this.props.setValue('productFormNavigation_1', 'IsLarge', null);
	          this.props.setValue('productFormNavigation_1', 'LastDigit', null);
	        }
	      }
	      if (nextProps.existingProd && nextProps.existingProd != this.props.existingProd) {
	        var products = _extends({}, this.state.products, { rows: nextProps.existingProd });
	        this.setState({ products: products });
	      }
	      if (nextProps.IsLarge && nextProps.IsLarge != this.props.IsLarge) {
	        if (nextProps.IsLarge == "false" || nextProps.IsLarge == false) {
	          this.props.setValue('productFormNavigation_1', 'LastDigit', "1");
	          this.props.clearSuggestDigit();
	        } else {
	          if (this.state.group && this.state.category && this.state.suggestedProdNum) {
	            var prodNum = '' + this.state.group.GroupNum + this.state.category.CategoryNum + this.state.suggestedProdNum;
	            this.props.fetchSuggestDigit(prodNum);
	          }
	          if (this.props.IsLarge !== undefined) {
	            this.props.setValue('productFormNavigation_1', 'LastDigit', null);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'clearFields',
	    value: function clearFields() {
	      this.props.setValue('productFormNavigation_1', 'Category', null);
	      this.props.setValue('productFormNavigation_1', 'Group', null);
	      this.props.setValue('productFormNavigation_1', 'Name', null);
	      this.props.setValue('productFormNavigation_1', 'Description', null);
	      this.props.setValue('productFormNavigation_1', 'IsLarge', null);
	      this.props.setValue('productFormNavigation_1', 'LastDigit', null);
	      this.setState({ group: null, category: null, suggestedProdNum: null, isLinked: false });
	    }
	  }, {
	    key: 'selectExistingProd',
	    value: function selectExistingProd(prod) {
	      var suggestedProdNum = prod.ProductNum.slice(4, 7);
	      this.setState({ suggestedProdNum: suggestedProdNum, isLinked: true, linkProdOpen: false });
	      this.props.setValue('productFormNavigation_1', 'IsLarge', null);
	      this.props.setValue('productFormNavigation_1', 'LastDigit', null);
	    }
	  }, {
	    key: 'getGroupOptions',
	    value: function getGroupOptions() {
	      var productGroupOptions = [];
	      if (this.props.groups) {
	        this.props.groups.map(function (group) {
	          productGroupOptions.push({ value: group.ProductGroup_id, label: group.Name });
	        });
	      }
	      return productGroupOptions;
	    }
	  }, {
	    key: 'getCategoryOptions',
	    value: function getCategoryOptions() {
	      var categoryOptions = [];
	      this.props.groupCategories.map(function (category) {
	        categoryOptions.push({ value: category.ProductCategory_id, label: category.Name });
	      });
	      return categoryOptions;
	    }
	  }, {
	    key: 'getLastDigitOptions',
	    value: function getLastDigitOptions() {
	      var lastDigitOptions = [{ value: "1", label: "1" }];
	      if (this.props.IsLarge && this.props.suggestDigitFetched) {
	        lastDigitOptions = [];
	        this.props.suggestDigitFetched.map(function (digit) {
	          lastDigitOptions.push({ value: digit, label: digit });
	        });
	      }
	      return lastDigitOptions;
	    }
	  }, {
	    key: 'openLinkProd',
	    value: function openLinkProd() {
	      this.state.products.filters = {};
	      this.setState({ linkProdOpen: true });
	    }
	  }, {
	    key: 'closeLinkProd',
	    value: function closeLinkProd() {
	      this.setState({ linkProdOpen: false });
	    }
	  }, {
	    key: 'renderExistingProd',
	    value: function renderExistingProd() {
	      var _this4 = this;
	
	      if (this.props.existingProdIsLoading && !this.props.existingProdError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.existingProdError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.existingProdError)
	        )
	      );else {
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.products);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var products = Object.assign({}, _this4.state.products, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this4.setState({ products: products });
	        };
	
	        var handleFilterChange = function handleFilterChange(filter) {
	          var newFilters = Object.assign({}, _this4.state.products.filters);
	          if (filter.filterTerm) {
	            newFilters[filter.column.key] = filter;
	          } else {
	            delete newFilters[filter.column.key];
	          }
	          var products = _extends({}, _this4.state.products, { filters: newFilters });
	          _this4.setState({ products: products });
	        };
	
	        var onClearFilters = function onClearFilters() {
	          // all filters removed
	          var products = _extends({}, _this4.state.products, { filters: {} });
	          _this4.setState({ products: products });
	        };
	
	        // Column difinition
	
	        var columns = [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          filterable: true,
	          resizable: true,
	          sortable: true,
	          width: 100
	          // filterRenderer: FilterByStart,
	        }, {
	          key: 'RefNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	          filterable: true,
	          resizable: true,
	          sortable: true,
	          width: 90
	          // filterRenderer: FilterByStart,
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	          filterable: true,
	          resizable: true,
	          sortable: true,
	          width: 300
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          filterable: true,
	          resizable: true,
	          sortable: true
	        }];
	
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { style: { maxWidth: '100%', marginTop: '10px' }, id: 'ProductFormNavigation-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                enableCellSelect: true,
	                rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: this.selectExistingProd }),
	                rowKey: 'Product_id',
	                rowHeight: 25,
	                headerRowHeight: 45,
	                minHeight: 350,
	                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                onAddFilter: handleFilterChange,
	                onClearFilters: onClearFilters,
	                onGridSort: handleGridSort,
	                columns: columns,
	                rowGetter: rowGetter,
	                rowsCount: getSize()
	              })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var groupOptions = this.getGroupOptions();
	      var categoryOptions = this.getCategoryOptions();
	      var lastDigitOptions = this.getLastDigitOptions();
	
	      var createDialogStyle = {
	        width: '800px',
	        height: '500px',
	        marginLeft: '-15%'
	      };
	
	      var lastDigit = this.props.LastDigit && (this.props.LastDigit.value || this.props.LastDigit);
	      if (lastDigit && (typeof lastDigit === 'undefined' ? 'undefined' : _typeof(lastDigit)) == "object") {
	        lastDigit = 0;
	      }
	      var ProductNum = '' + (this.state.group && this.state.group.GroupNum) + (this.state.category && this.state.category.CategoryNum) + (this.state.suggestedProdNum && this.state.suggestedProdNum) + lastDigit;
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'create-a-new-product-form', id: 'manage-products' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'product-num-header' },
	            _react2.default.createElement(
	              'label',
	              { className: 'mr-md' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' })
	            ),
	            this.state.group && _react2.default.createElement(
	              'label',
	              { className: 'prod-num-border' },
	              this.state.group.GroupNum
	            ),
	            this.state.category && _react2.default.createElement(
	              'label',
	              { className: 'prod-num-border' },
	              this.state.category.CategoryNum
	            ),
	            this.state.suggestedProdNum && _react2.default.createElement(
	              'label',
	              { className: 'prod-num-border' },
	              this.state.suggestedProdNum
	            ),
	            this.props.LastDigit && _react2.default.createElement(
	              'label',
	              { className: 'prod-num-border' },
	              lastDigit
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            { className: 'product-form-navigation-1' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5' },
	                ' ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'primary' },
	                  '01'
	                ),
	                ' ',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: isJTB ? "please_select_customer_group" : "please_select_group" }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'asteriksReq' },
	                  '*'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 1 },
	                this.state.group && this.state.group.GroupNum
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 6 },
	                _react2.default.createElement(_reduxForm.Field, { name: 'Group', component: _selection.Selection, options: groupOptions })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5' },
	                ' ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'primary' },
	                  '02'
	                ),
	                ' ',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_category' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'asteriksReq' },
	                  '*'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 1 },
	                this.state.category && this.state.category.CategoryNum
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 6 },
	                _react2.default.createElement(_reduxForm.Field, { name: 'Category', component: _selection.Selection, options: categoryOptions })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5' },
	                ' ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'primary' },
	                  '03'
	                ),
	                ' ',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_series_no' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'asteriksReq' },
	                  '*'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(_reduxForm.Field, { name: 'SeriesNum', component: _inputField.DisabledInputField, placeholder: this.state.suggestedProdNum })
	              ),
	              _react2.default.createElement(_reactBootstrap.Col, { xs: 1 }),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  { bsStyle: 'primary', onClick: function onClick() {
	                      _this5.props.fetchProductsByCategory(_this5.state.category.ProductCategory_id);_this5.openLinkProd();
	                    } },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'link_existing_prod' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-1' },
	                ' ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'primary' },
	                  '04'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 7, className: 'sizeRadios' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'IsLarge', component: sizeRadios })
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'asteriksReq pAbs' },
	                '*'
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 4 },
	                _react2.default.createElement(_reduxForm.Field, { name: 'LastDigit', component: _selection.Selection, options: lastDigitOptions })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'product-form-navigation-1' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-5 product-name' },
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'primary' },
	                '05'
	              ),
	              ' ',
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 7 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'Name', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'product-form-navigation-1 mb0' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-5 product-name' },
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'primary' },
	                '06'
	              ),
	              ' ',
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 7 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'Description', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'mb0' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-5 nonbold-label-description' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: '(chinese)' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { onClick: this.clearFields },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'clear' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                disabled: !this.props.Category || !this.props.Group || !this.state.suggestedProdNum || !lastDigit && lastDigit != 0,
	                onClick: function onClick() {
	                  _this5.props.handleClickNext(_this5.props.Category, _this5.props.Group, _this5.state.suggestedProdNum, _this5.state.isLinked, _this5.props.Name, _this5.props.Description, _this5.props.IsLarge, _this5.props.LastDigit, ProductNum);
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'next' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          { dialogStyles: createDialogStyle, isVisible: this.state.linkProdOpen, onCloseClicked: function onCloseClicked() {
	              _this5.closeLinkProd();
	            } },
	          this.renderExistingProd()
	        )
	      );
	    }
	  }]);
	
	  return ProductFormNavigation_1;
	}(_react.Component);
	
	var ProductFormNavigation_2 = exports.ProductFormNavigation_2 = function (_Component3) {
	  _inherits(ProductFormNavigation_2, _Component3);
	
	  function ProductFormNavigation_2() {
	    _classCallCheck(this, ProductFormNavigation_2);
	
	    var _this6 = _possibleConstructorReturn(this, (ProductFormNavigation_2.__proto__ || Object.getPrototypeOf(ProductFormNavigation_2)).call(this));
	
	    _this6.state = {
	      packageTypeOpen: false,
	      packageTypes: {
	        rows: [],
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null
	      }
	    };
	    _this6.openPackageType = _this6.openPackageType.bind(_this6);
	    _this6.closePackageType = _this6.closePackageType.bind(_this6);
	    _this6.selectPackageType = _this6.selectPackageType.bind(_this6);
	    _this6.clearFields = _this6.clearFields.bind(_this6);
	    return _this6;
	  }
	
	  _createClass(ProductFormNavigation_2, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.fetchPackageTypes();
	      this.props.fetchMeasurementUnit();
	      if (this.props.formContent) {
	        this.props.setValue('productFormNavigation_2', 'ProdType', this.props.formContent.ProdType);
	        this.props.setValue('productFormNavigation_2', 'PackageType', this.props.formContent.PackageType);
	        this.props.setValue('productFormNavigation_2', 'PackageSize_1', this.props.formContent.PackageSize_1);
	        this.props.setValue('productFormNavigation_2', 'PackageType_2', this.props.formContent.PackageType_2);
	        this.props.setValue('productFormNavigation_2', 'PackageSize_2', this.props.formContent.PackageSize_2);
	        this.props.setValue('productFormNavigation_2', 'MeasureUnit_2', this.props.formContent.MeasureUnit_2);
	        this.props.setValue('productFormNavigation_2', 'NetWeight_1', this.props.formContent.NetWeight_1);
	        this.props.setValue('productFormNavigation_2', 'NetWeight_2', this.props.formContent.NetWeight_2);
	        this.props.setValue('productFormNavigation_2', 'RefPrice', this.props.formContent.RefPrice);
	        this.props.setValue('productFormNavigation_2', 'LowestSalePrice', this.props.formContent.LowestSalePrice);
	
	        if (!this.props.formContent.MeasureUnit_2) {
	          this.props.setValue('productFormNavigation_2', 'MeasureUnit_2', 'LB');
	        }
	        if (!this.props.formContent.NetWeight_2) {
	          this.props.setValue('productFormNavigation_2', 'NetWeight_2', 'LB');
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.packageTypesFetched && nextProps.packageTypesFetched != this.props.packageTypesFetched) {
	        var packageTypes = _extends({}, this.state.packageTypes, { rows: nextProps.packageTypesFetched });
	        this.setState({ packageTypes: packageTypes });
	      }
	    }
	  }, {
	    key: 'getProdTypeOptions',
	    value: function getProdTypeOptions() {
	      var prodTypeOptions = [{ value: "Fixed", label: "Fixed" }, { value: "Non-Fixed", label: "Non-Fixed" }, { value: "Service", label: "Service" }, { value: "Non-Product", label: "Non-Product" }, { value: "Per-Pound", label: "Per-Pound" }, { value: "Other", label: "Other" }];
	      return prodTypeOptions;
	    }
	  }, {
	    key: 'getMeasureUnitOptions',
	    value: function getMeasureUnitOptions() {
	      var measureUnitOptions = [];
	      if (this.props.measurementUnitFetched) {
	        this.props.measurementUnitFetched.map(function (measureUnit) {
	          measureUnitOptions.push({ value: measureUnit.Simple, label: measureUnit.Simple });
	        });
	      }
	      return measureUnitOptions;
	    }
	  }, {
	    key: 'getPackageTypeOptions',
	    value: function getPackageTypeOptions() {
	      var packageTypeOptions = [];
	      if (this.props.packageTypesFetched) {
	        this.props.packageTypesFetched.map(function (packageType) {
	          packageTypeOptions.push({ value: packageType.Simple, label: packageType.Simple });
	        });
	      }
	      return packageTypeOptions;
	    }
	  }, {
	    key: 'openPackageType',
	    value: function openPackageType() {
	      this.setState({ packageTypeOpen: true });
	    }
	  }, {
	    key: 'closePackageType',
	    value: function closePackageType() {
	      this.setState({ packageTypeOpen: false });
	    }
	  }, {
	    key: 'selectPackageType',
	    value: function selectPackageType(row, field) {
	      this.props.setValue("productFormNavigation_2", field, row.Simple);
	      this.closePackageType();
	    }
	  }, {
	    key: 'clearFields',
	    value: function clearFields() {
	      this.props.setValue('productFormNavigation_2', 'ProdType', null);
	      this.props.setValue('productFormNavigation_2', 'PackageType', null);
	      this.props.setValue('productFormNavigation_2', 'PackageSize_1', null);
	      this.props.setValue('productFormNavigation_2', 'PackageType_2', null);
	      this.props.setValue('productFormNavigation_2', 'PackageSize_2', null);
	      this.props.setValue('productFormNavigation_2', 'MeasureUnit_2', null);
	      this.props.setValue('productFormNavigation_2', 'NetWeight_1', null);
	      this.props.setValue('productFormNavigation_2', 'NetWeight_2', null);
	      this.props.setValue('productFormNavigation_2', 'RefPrice', null);
	      this.props.setValue('productFormNavigation_2', 'LowestSalePrice', null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var prodTypeOptions = this.getProdTypeOptions();
	      var measureUnitOptions = this.getMeasureUnitOptions();
	      var weightOptions = [{
	        value: "lb",
	        label: "lb"
	      }, {
	        value: "kg",
	        label: "kg"
	      }];
	      var packageTypeOptions = this.getPackageTypeOptions();
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'create-a-new-product-form', id: 'manage-products' },
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-3' },
	                ' ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'primary' },
	                  '07'
	                ),
	                ' ',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_type' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 4 },
	                _react2.default.createElement(_reduxForm.Field, { name: 'ProdType', component: _selection.Selection, options: prodTypeOptions })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-3' },
	                ' ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'primary' },
	                  '08'
	                ),
	                ' ',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_type' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 4 },
	                _react2.default.createElement(_reduxForm.Field, { name: 'PackageType', component: _selection.Selection, options: packageTypeOptions })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-3' },
	                ' ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'primary' },
	                  '09'
	                ),
	                ' ',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 2 },
	                _react2.default.createElement(_reduxForm.Field, { name: 'PackageSize_1', component: _inputField.InputField })
	              ),
	              !isEcity && _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 2 },
	                _react2.default.createElement(_reduxForm.Field, { name: 'PackageType_2', component: _selection.Selection, options: packageTypeOptions })
	              ),
	              isEcity && _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 2 },
	                _react2.default.createElement(_reduxForm.Field, { name: 'PackageType_2', component: _inputField.InputField, placeholder: 'Type' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 1, className: 'textAlignStyle' },
	                _react2.default.createElement('em', { className: 'fa fa-times times-sign' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 2 },
	                _react2.default.createElement(_reduxForm.Field, { name: 'PackageSize_2', component: _inputField.InputField })
	              ),
	              !isEcity && _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 2 },
	                _react2.default.createElement(_reduxForm.Field, { name: 'MeasureUnit_2', component: _selection.Selection, options: measureUnitOptions })
	              ),
	              isEcity && _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 2 },
	                _react2.default.createElement(_reduxForm.Field, { name: 'MeasureUnit_2', component: _inputField.InputField, placeholder: 'Unit' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-3' },
	                ' ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'primary' },
	                  '10'
	                ),
	                ' ',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_weight' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 2 },
	                _react2.default.createElement(_reduxForm.Field, { name: 'NetWeight_1', component: _inputField.InputField })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 2 },
	                _react2.default.createElement(_reduxForm.Field, { name: 'NetWeight_2', component: _selection.Selection, options: measureUnitOptions })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5' },
	                ' ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'primary' },
	                  '11'
	                ),
	                ' ',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_cost_price' })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'new-product-form-dollar-sign' },
	                '$'
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 4 },
	                _react2.default.createElement(_reduxForm.Field, { name: 'RefPrice', component: _inputField.InputField })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5 nonbold-label' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: '(all_markup_percentsign_will_base_on_this_price)' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5' },
	                ' ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'primary' },
	                  '12'
	                ),
	                ' ',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lowest_sale_dollarsign' })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'new-product-form-dollar-sign' },
	                '$'
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 4 },
	                _react2.default.createElement(_reduxForm.Field, { name: 'LowestSalePrice', component: _inputField.InputField })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5 nonbold-label' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: '(no_sale_will_be_allowed_lower_than_this_price)' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { onClick: this.clearFields },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'clear' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { onClick: function onClick() {
	                  _this7.props.handleClickPrev(_this7.props.ProdType, _this7.props.PackageType, _this7.props.PackageSize_1, _this7.props.PackageType_2, _this7.props.PackageSize_2, _this7.props.MeasureUnit_2, _this7.props.NetWeight_1, _this7.props.NetWeight_2, _this7.props.RefPrice, _this7.props.LowestSalePrice);
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'previous' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { onClick: function onClick() {
	                  _this7.props.handleClickNext(_this7.props.ProdType, _this7.props.PackageType, _this7.props.PackageSize_1, _this7.props.PackageType_2, _this7.props.PackageSize_2, _this7.props.MeasureUnit_2, _this7.props.NetWeight_1, _this7.props.NetWeight_2, _this7.props.RefPrice, _this7.props.LowestSalePrice);
	                } },
	              isHMM && _react2.default.createElement(_reactReduxI18n.Translate, { value: 'finish' }),
	              !isHMM && _react2.default.createElement(_reactReduxI18n.Translate, { value: 'next' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          { dialogStyles: createPackageTypesDialogStyle, isVisible: this.state.packageTypeOpen, onCloseClicked: function onCloseClicked() {
	              _this7.closePackageType();
	            } },
	          _react2.default.createElement(_packageTypes2.default, { selectPackageType: this.selectPackageType, field: this.state.field })
	        )
	      );
	    }
	  }]);
	
	  return ProductFormNavigation_2;
	}(_react.Component);
	
	var ProductFormNavigation_3 = exports.ProductFormNavigation_3 = function (_Component4) {
	  _inherits(ProductFormNavigation_3, _Component4);
	
	  function ProductFormNavigation_3() {
	    _classCallCheck(this, ProductFormNavigation_3);
	
	    var _this8 = _possibleConstructorReturn(this, (ProductFormNavigation_3.__proto__ || Object.getPrototypeOf(ProductFormNavigation_3)).call(this));
	
	    _this8.state = {
	      packageTypeOpen: false,
	      packageTypes: {
	        rows: [],
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null
	      }
	    };
	    _this8.openPackageType = _this8.openPackageType.bind(_this8);
	    _this8.closePackageType = _this8.closePackageType.bind(_this8);
	    _this8.selectPackageType = _this8.selectPackageType.bind(_this8);
	    _this8.handleClickFinish = _this8.handleClickFinish.bind(_this8);
	    _this8.clearFields = _this8.clearFields.bind(_this8);
	    return _this8;
	  }
	
	  _createClass(ProductFormNavigation_3, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.fetchPackageTypes();
	      console.log("ProductNum", this.props.ProductNum);
	      this.props.fetchConvertableProducts(this.props.ProductNum, 'create');
	      this.props.setValue('productFormNavigation_3', 'ConvertNum', this.props.formContent.ConvertNum);
	      this.props.setValue('productFormNavigation_3', 'SmallProdType', this.props.formContent.SmallProdType);
	      this.props.setValue('productFormNavigation_3', 'SmallPackageType', this.props.formContent.SmallPackageType);
	      this.props.setValue('productFormNavigation_3', 'ConvertType', this.props.formContent.ConvertType);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.packageTypesFetched && nextProps.packageTypesFetched != this.props.packageTypesFetched) {
	        var packageTypes = _extends({}, this.state.packageTypes, { rows: nextProps.packageTypesFetched });
	        this.setState({ packageTypes: packageTypes });
	      }
	      if (nextProps.convertableProductsFetchError && nextProps.convertableProductsFetchError != this.props.convertableProductsFetchError) {
	        console.log("61", nextProps.convertableProductsFetchError);
	      }
	    }
	  }, {
	    key: 'openPackageType',
	    value: function openPackageType() {
	      this.setState({ packageTypeOpen: true });
	    }
	  }, {
	    key: 'closePackageType',
	    value: function closePackageType() {
	      this.setState({ packageTypeOpen: false });
	    }
	  }, {
	    key: 'selectPackageType',
	    value: function selectPackageType(row) {
	      this.props.setValue("productFormNavigation_3", "SmallPackageType", row.Simple);
	      this.closePackageType();
	    }
	  }, {
	    key: 'handleClickFinish',
	    value: function handleClickFinish() {
	      this.props.saveProductFormNavigation_3(this.props.ConvertNum, this.props.SmallProdType, this.props.SmallPackageType, this.props.ConvertType);
	      this.props.closeNavigation();
	      //  this.props.handleClickFinish()
	    }
	  }, {
	    key: 'clearFields',
	    value: function clearFields() {
	      this.props.setValue('productFormNavigation_3', 'ConvertNum', null);
	      this.props.setValue('productFormNavigation_3', 'SmallProdType', null);
	      this.props.setValue('productFormNavigation_3', 'SmallPackageType', null);
	      this.props.setValue('productFormNavigation_3', 'ConvertType', null);
	    }
	  }, {
	    key: 'renderConvertableProducts',
	    value: function renderConvertableProducts() {
	      if (this.props.fetchingConvertableProducts && !this.props.convertableProductsFetchError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      }
	      if (this.props.convertableProductsFetched && this.props.convertableProductsFetched && this.props.convertableProductsFetched.relations.length > 0) {
	        var index = 1;
	        var twoDigits = function twoDigits(index) {
	          return ('0' + index).toString().slice(-2);
	        };
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12, className: 'convertable-products' },
	          this.props.convertableProductsFetched.relations.map(function (prod) {
	            return _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 1 },
	                twoDigits(index++)
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 3 },
	                prod.ProductNum
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 3 },
	                prod.PackageSize
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 3 },
	                prod.ProductType
	              )
	            );
	          })
	        );
	      }
	      return;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      console.log("finish...", this.props);
	      var test = [{ value: "1", label: "21" }, { value: "2", label: "2" }];
	      var SmallProdTypeOptions = [{
	        value: "Fixed", label: "Per-Unit"
	      }, {
	        value: "Per-Pound", label: "Per-Weight"
	      }];
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'create-a-new-product-form', id: 'manage-products' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-5' },
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'primary' },
	                '13'
	              ),
	              ' ',
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'convert' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 7 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'ConvertType', component: convertNumRadios })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-5' },
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'primary' },
	                '14'
	              ),
	              ' ',
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'convertable_product' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            { id: 'panel-scroll-bar' },
	            this.renderConvertableProducts()
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { onClick: this.clearFields },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'clear' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { onClick: function onClick() {
	                  _this9.props.handleClickPrev(_this9.props.ConvertNum, _this9.props.SmallProdType, _this9.props.SmallPackageType, _this9.props.ConvertType);
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'previous' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                onClick: function onClick() {
	                  _this9.handleClickFinish();
	                },
	                disabled: !this.props.ProductGroup_id || !this.props.ProductCategory1_id || !this.props.suggestedProdNum || !this.props.LastDigit
	              },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'finish' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          { dialogStyles: createPackageTypesDialogStyle, isVisible: this.state.packageTypeOpen, onCloseClicked: function onCloseClicked() {
	              _this9.closePackageType();
	            } },
	          _react2.default.createElement(_packageTypes2.default, { selectPackageType: this.selectPackageType })
	        )
	      );
	    }
	  }]);
	
	  return ProductFormNavigation_3;
	}(_react.Component);
	
	var _default = ProductFormNavigation_1;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ProductFormNavigation_1, 'ProductFormNavigation_1', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productFormNavigation.jsx');
	
	  __REACT_HOT_LOADER__.register(ProductFormNavigation_2, 'ProductFormNavigation_2', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productFormNavigation.jsx');
	
	  __REACT_HOT_LOADER__.register(ProductFormNavigation_3, 'ProductFormNavigation_3', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productFormNavigation.jsx');
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productFormNavigation.jsx');
	
	  __REACT_HOT_LOADER__.register(isHMM, 'isHMM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productFormNavigation.jsx');
	
	  __REACT_HOT_LOADER__.register(isJTB, 'isJTB', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productFormNavigation.jsx');
	
	  __REACT_HOT_LOADER__.register(createPackageTypesDialogStyle, 'createPackageTypesDialogStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productFormNavigation.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productFormNavigation.jsx');
	
	  __REACT_HOT_LOADER__.register(sizeRadios, 'sizeRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productFormNavigation.jsx');
	
	  __REACT_HOT_LOADER__.register(convertNumRadios, 'convertNumRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productFormNavigation.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/productFormNavigation.jsx');
	}();

	;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(11);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _filterByStart = __webpack_require__(68);
	
	var _filterByStart2 = _interopRequireDefault(_filterByStart);
	
	var _filterMultiKeyword = __webpack_require__(95);
	
	var _filterMultiKeyword2 = _interopRequireDefault(_filterMultiKeyword);
	
	var _root_url = __webpack_require__(9);
	
	var _products_actions = __webpack_require__(30);
	
	var _url = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isMyuMyu = _root_url.ROOT_API_URL === 'https://mmstage-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://myumyu-scm.truckxi.com/api/';
	var isAFG = _root_url.ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afg-scm.truckxi.com/api/';
	var isWecom = _root_url.ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/';
	var isTN = _root_url.ROOT_API_URL === "https://tn-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://tn-scm.truckxi.com/api/";
	var isWIZ = _root_url.ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
	var isSW = _root_url.ROOT_API_URL === 'https://snapwise-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://snapwise-scm.truckxi.com/api/';
	var isABCFF = _root_url.ROOT_API_URL === 'https://abcff-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://abcff-scm.truckxi.com/api/';
	var isSY = _root_url.ROOT_API_URL === "https://admin.apoodr.com/api/";
	var isJML = _root_url.ROOT_API_URL === "https://jml-scm.truckxi.com/api/";
	var isFBD = _root_url.ROOT_API_URL === 'https://fbd-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://fbd-scm.truckxi.com/api/';
	var isLO = _root_url.ROOT_API_URL === 'https://lonni-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://lonni-scm.truckxi.com/api/';
	
	var RowRenderer = function (_Component) {
	  _inherits(RowRenderer, _Component);
	
	  function RowRenderer() {
	    _classCallCheck(this, RowRenderer);
	
	    return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(RowRenderer, [{
	    key: 'getRowStyle',
	    value: function getRowStyle() {
	      return {
	        color: this.getRowBackground()
	      };
	    }
	  }, {
	    key: 'getRowBackground',
	    value: function getRowBackground() {
	      if (isAFG) {
	        if (this.props.row.IsStopSale === 'yes') {
	          return _constants.BACKGROUND_COLOR.red;
	        } else if (this.props.row.IsMobile !== 'yes' && this.props.row.IsStopSale !== 'yes') {
	          return '#BFA600';
	        } else {
	          return 'black';
	        }
	      } else {
	        return this.props.row.IsStopSale === 'yes' ? _constants.BACKGROUND_COLOR.red : 'black';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // here we are just changing the style
	      // but we could replace this with anything we liked, cards, images, etc
	      // usually though it will just be a matter of wrapping a div, and then calling back through to the grid
	      return _react2.default.createElement(
	        'div',
	        {
	          style: this.getRowStyle(),
	          onDoubleClick: function onDoubleClick() {
	            _this2.props.onDoubleClick(_this2.props.row);
	          }
	        },
	        _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	      );
	    }
	  }]);
	
	  return RowRenderer;
	}(_react.Component);
	
	RowRenderer.PropTypes = {
	  onDoubleClick: _react2.default.PropTypes.func
	};
	
	var Products = function (_Component2) {
	  _inherits(Products, _Component2);
	
	  function Products() {
	    _classCallCheck(this, Products);
	
	    var _this3 = _possibleConstructorReturn(this, (Products.__proto__ || Object.getPrototypeOf(Products)).call(this));
	
	    _this3.clickNew = function (e) {
	      _this3.props.setGroupCategory({
	        currentGroup: _this3.state.currentGroup,
	        currentCategory: _this3.state.currentCategory,
	        filters: _this3.state.filters,
	        selectedRows: []
	      });
	      e.preventDefault();
	      _this3.setState({ clear: false });
	      _this3.props.resetCurrentProduct();
	      // this.props.setGroupCategory(null);
	      _this3.context.router.push('/products/new');
	    };
	
	    _this3.renderTNProductExport = function () {
	      var _this3$state = _this3.state,
	          currentCategory = _this3$state.currentCategory,
	          currentGroup = _this3$state.currentGroup;
	
	      var Bearer = localStorage.getItem('token');
	      var params = '?Bearer=' + Bearer + '&export=csv';
	      if (currentCategory > 0) {
	        params += '&ProductCategory1_id=' + currentCategory;
	      } else if (currentGroup > 0) {
	        params += '&ProductGroup_id=' + currentGroup;
	      }
	
	      var url = _url.PRODUCTS_URL + 'search/' + params;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'print-btn',
	          type: 'button',
	          href: url
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'export_produt' })
	      );
	    };
	
	    _this3.renderZipcodeExport = function () {
	      var _this3$state2 = _this3.state,
	          currentCategory = _this3$state2.currentCategory,
	          currentGroup = _this3$state2.currentGroup;
	
	
	      var exportUrl = _root_url.ROOT_URL + 'v1/product/zipcodes/?Bearer=' + localStorage.getItem("token");
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'print-btn',
	          type: 'button',
	          href: exportUrl
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'export_zipcodes' })
	      );
	    };
	
	    _this3.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	      // React Data Grid states
	      rows: [],
	      selectedRows: [],
	      filters: {},
	      sortColumn: null,
	      sortDirection: null,
	      currentGroup: null,
	      currentCategory: -1,
	      groupExpanded: false,
	      clear: true,
	      files: null,
	      selectedRowsIdx: null,
	      quickEntryProductNum: '',
	      quickEntryShowError: false
	    };
	
	    _this3.handleResize = _this3.handleResize.bind(_this3);
	    _this3.checkDetail = _this3.checkDetail.bind(_this3);
	    return _this3;
	  }
	
	  _createClass(Products, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.resetGroupAndCategory();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      window.addEventListener('resize', this.handleResize);
	      this.props.fetchGroups();
	      var currentCategoryGroup = this.props.currentCategoryGroup;
	      if (currentCategoryGroup && currentCategoryGroup.currentGroup) {
	        if (currentCategoryGroup.currentGroup != -1) {
	          this.props.fetchGroupCategories(currentCategoryGroup.currentGroup);
	        }
	        var selectedRows = currentCategoryGroup.selectedRows;
	        this.setState({
	          currentGroup: currentCategoryGroup.currentGroup,
	          currentCategory: currentCategoryGroup.currentCategory,
	          groupExpanded: true,
	          // rows: currentCategoryGroup.currentRows,
	          selectedRows: selectedRows,
	          selectedRowsIdx: currentCategoryGroup.selectedRowsIdx
	        });
	      }
	
	      // if(currentCategoryGroup && currentCategoryGroup.filters) {
	      //   console.log("filters", currentCategoryGroup.filters)
	      //   this.setState({filters: currentCategoryGroup.filters})
	      // }
	      // this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
	      if (_root_url.isUSPride && this.props.filters !== this.state.filters) {
	        this.setState({ filters: this.props.filters });
	        if (Object.keys(this.props.filters).length > 0) {
	          this.tableGrid && this.tableGrid.onToggleFilter();
	        }
	      }
	    }
	
	    // Once products are ready, reset state.
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this4 = this;
	
	      if (nextProps.product && nextProps.product !== this.props.product) {
	        var index = _.findIndex(this.state.rows, { Product_id: nextProps.product });
	        this.state.rows.map(function (r) {
	          return r.isSelected = false;
	        });
	        if (index > -1) {
	          this.state.rows[index].isSelected = true;
	          this.setState({ selectedRows: [this.state.rows[index]] });
	        } else {
	          this.setState({ selectedRows: [] });
	        }
	      }
	      if (nextProps.groups && nextProps.groups.length !== 0 && nextProps.groups !== this.props.groups && !isSY) {
	        var productGroup_id = nextProps.groups[0].ProductGroup_id;
	        if (this.state.currentCategory && this.state.currentCategory !== -1) {
	          this.props.fetchProductsByCategory(this.state.currentCategory);
	          // this.handleClickCategory(this.state.currentCategory);
	        } else if (this.state.currentGroup) {
	          this.props.fetchProductsByGroup(this.state.currentGroup);
	        } else {
	          this.props.fetchProductsByGroup(productGroup_id);
	          this.setState({ currentGroup: productGroup_id });
	        }
	      }
	      if (nextProps.products && nextProps.products !== this.props.products) {
	        var products = nextProps.products;
	        if (this.props.currentCategoryGroup) {
	          if (this.state.selectedRows.length) {
	            var selectedRows = this.state.selectedRows;
	            var selectedRowProductNumber = selectedRows[0].row.ProductNum;
	            var selectedRowIdx = void 0;
	            var rows = nextProps.products.map(function (product, idx) {
	              if (product.ProductNum === selectedRowProductNumber) {
	                selectedRowIdx = idx;
	                return _extends({}, product, {
	                  IsStopSale: product.IsStopSale ? 'yes' : 'no',
	                  IsMobile: product.IsMobile ? 'yes' : 'no',
	                  isSelected: true
	                });
	              }
	              return _extends({}, product, {
	                IsStopSale: product.IsStopSale ? 'yes' : 'no',
	                IsMobile: product.IsMobile ? 'yes' : 'no'
	              });
	            });
	            this.setState({ rows: rows, selectedRows: selectedRows });
	            // this.props.setGroupCategory(null);
	            setTimeout(function () {
	              if (_this4.tableGrid) {
	                var top = 25 * selectedRowIdx;
	                var gridCanvas = _this4.tableGrid.getDataGridDOMNode().querySelector('.react-grid-Canvas');
	                gridCanvas.scrollTop = top;
	              }
	            }, 100);
	          } else {
	            var _rows = nextProps.products.map(function (product, idx) {
	              return _extends({}, product, {
	                IsStopSale: product.IsStopSale ? 'yes' : 'no',
	                IsMobile: product.IsMobile ? 'yes' : 'no'
	              });
	            });
	            this.setState({ rows: _rows, selectedRows: [] });
	          }
	        } else {
	          var _rows2 = nextProps.products.map(function (product) {
	            return _extends({}, product, {
	              IsStopSale: product.IsStopSale ? 'yes' : 'no',
	              IsMobile: product.IsMobile ? 'yes' : 'no'
	            });
	          });
	          this.setState({ rows: _rows2, selectedRows: [] });
	          this.props.setGroupCategory(null);
	        }
	      }
	      if (_root_url.isUSPride && nextProps.filters && nextProps.filters !== this.props.filters) {
	        this.setState({ filters: nextProps.filters });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var productGroup_id = this.state.currentGroup;
	      var productCategory_id = this.state.currentCategory;
	      var groups = document.getElementsByName('group');
	      var i = 0;
	      for (; i < groups.length; i++) {
	        if (groups[i].id != 'g' + productGroup_id) {
	          groups[i].style.backgroundColor = null;
	        } else {
	          groups[i].style.backgroundColor = _constants.APP_COLORS['active-category-background-nav'];
	        }
	      }
	      var categories = document.getElementsByName('category');
	      i = 0;
	      if (categories) {
	        for (; i < categories.length; i++) {
	          if (categories[i].id != 'c' + productCategory_id) {
	            categories[i].style.backgroundColor = null;
	          } else {
	            categories[i].style.backgroundColor = _constants.APP_COLORS['active-category-background-nav'];
	          }
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.clear) {
	        this.props.setGroupCategory(null);
	      }
	      this.props.setOriginPage('products');
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	    }
	
	    // Quick Entry Product Number
	
	  }, {
	    key: 'onChangeQuickEntry',
	    value: function onChangeQuickEntry(e) {
	      this.setState({ quickEntryProductNum: e.target.value });
	    }
	  }, {
	    key: 'onKeyPressQuickEntry',
	    value: function onKeyPressQuickEntry(e) {
	      var _this5 = this;
	
	      var handleSuccess = function handleSuccess(response) {
	        if ((0, _permissions2.default)('change_product')) {
	          var resData0 = response.data[0];
	          var newRowsItem = _extends({}, resData0, {
	            isSelected: true,
	            IsStopSale: resData0.IsStopSale ? 'yes' : 'no',
	            IsMobile: resData0.IsMobile ? 'yes' : 'no'
	          });
	          if (_this5.state.currentGroup !== -1) {
	            _this5.state.currentGroup = resData0.ProductGroup_id || -1;
	          }
	          var newRows = [].concat(_toConsumableArray(_this5.state.rows));
	          newRows.map(function (r) {
	            r.isSelected = false;
	          });
	          var idx = newRows.findIndex(function (item) {
	            return item.Product_id === newRowsItem.Product_id;
	          });
	          if (idx > -1) {
	            newRowsItem = newRows[idx];
	            newRowsItem.isSelected = true;
	          }
	          var selectedRows = [{
	            row: newRowsItem,
	            rowIdx: idx
	          }];
	          _this5.setState({ rows: newRows, selectedRows: selectedRows, selectedRowsIdx: idx });
	          _this5.checkDetail(newRowsItem);
	        } else {
	          alert(_reactReduxI18n.I18n.t('msg_no_permission'));
	        }
	      };
	      var handleFailure = function handleFailure(error) {
	        _this5.setState({ quickEntryShowError: true });
	      };
	      if (e.charCode === 13) {
	        this.props.fetchQuickAccess(this.state.quickEntryProductNum, handleSuccess, handleFailure);
	      }
	    }
	
	    // Set product being selected to be currentProduct and navigate user to the edit page
	
	  }, {
	    key: 'setCurrentProduct',
	    value: function setCurrentProduct(e) {
	      e.preventDefault();
	      this.setState({ clear: false });
	      var currentProduct = this.state.selectedRows[0].row || this.state.selectedRows[0];
	      var currentRows = _reactDataGridAddons.Data.Selectors.getRows(this.state);
	      this.props.resetCurrentProduct();
	      this.props.selectProduct(currentProduct);
	      this.props.setGroupCategory({
	        currentGroup: this.state.currentGroup,
	        currentCategory: this.state.currentCategory,
	        currentProduct_id: currentProduct.Product_id,
	        filters: this.state.filters,
	        currentRows: currentRows,
	        selectedRowsIdx: this.state.selectedRowsIdx,
	        selectedRows: this.state.selectedRows
	      });
	      this.context.router.push('/products/' + currentProduct.Product_id);
	    }
	  }, {
	    key: 'checkDetail',
	    value: function checkDetail(data) {
	      this.setState({ clear: false });
	      var currentProduct = arguments[0];
	      var currentRows = _reactDataGridAddons.Data.Selectors.getRows(this.state);
	      this.props.resetCurrentProduct();
	      this.props.selectProduct(currentProduct);
	      this.props.setGroupCategory({
	        currentGroup: this.state.currentGroup,
	        currentCategory: this.state.currentCategory,
	        currentProduct_id: currentProduct.Product_id,
	        filters: this.state.filters,
	        currentRows: currentRows,
	        selectedRowsIdx: this.state.selectedRowsIdx,
	        selectedRows: [{ row: data }]
	      });
	      this.context.router.push('/products/' + currentProduct.Product_id);
	    }
	  }, {
	    key: 'handleClickCategory',
	    value: function handleClickCategory(id) {
	      this.setState({ currentCategory: id });
	      this.props.fetchProductsByCategory(id);
	    }
	  }, {
	    key: 'renderCategories',
	    value: function renderCategories(group_id) {
	      var _this6 = this;
	
	      if (!this.props.groupCategories) return;
	      var groupCategories = this.props.groupCategories;
	      var description = void 0;
	      if (localStorage.getItem('lang') === 'ch') {
	        description = 'Description';
	      } else if (localStorage.getItem('lang') === 'en') {
	        description = 'Name';
	      }
	      if (this.state.currentGroup === group_id && this.state.groupExpanded) {
	        return groupCategories.map(function (category) {
	          return _react2.default.createElement(
	            'li',
	            { className: 'clickListLi', style: { color: _constants.APP_COLORS['sub-category-nav'], fontFamily: 'Arial' }, name: 'category', id: 'c' + category.ProductCategory_id, onClick: _this6.handleClickCategory.bind(_this6, category.ProductCategory_id) },
	            _react2.default.createElement(
	              'label',
	              { style: { fontWeight: 'bold' } },
	              category.CategoryNum
	            ),
	            " " + category[description]
	          );
	        });
	      }
	      return;
	    }
	  }, {
	    key: 'handleClickGroup',
	    value: function handleClickGroup(group, id) {
	      var groupExpanded = this.state.groupExpanded;
	      // for(; i < groups.length; i++) {
	      //   if(groups[i].id != id){
	      //     groups[i].style.color = APP_COLORS["category-nav"];
	      //   }
	      //   else {
	      //     groups[i].style.color = APP_COLORS["active-category-nav"];
	      //   }
	      // }
	      if (group && this.state.currentGroup === group.ProductGroup_id) {
	        this.setState({ groupExpanded: !groupExpanded });
	        if (!groupExpanded || isJML) {
	          this.setState({ currentCategory: -1 });
	          this.props.fetchProductsByGroup(group.ProductGroup_id);
	          this.props.fetchGroupCategories(group.ProductGroup_id);
	        }
	      } else if (group) {
	        this.setState({ currentGroup: group.ProductGroup_id, groupExpanded: true, currentCategory: -1 });
	        this.props.fetchProductsByGroup(group.ProductGroup_id);
	        this.props.fetchGroupCategories(group.ProductGroup_id);
	      } else {
	        this.setState({ currentGroup: -1, currentCategory: -1 });
	        this.props.fetchProductsByGroup(-1);
	      }
	    }
	  }, {
	    key: 'renderGroups',
	    value: function renderGroups() {
	      var _this7 = this;
	
	      if (!this.props.groups) return;
	      var groups = this.props.groups;
	
	      var syGroups = [];
	      var syPermissionString = "";
	      if (isSY) {
	        groups.map(function (g) {
	          syPermissionString = "view_group_" + g.GroupNum;
	          if ((0, _permissions2.default)(syPermissionString) || (0, _permissions2.default)("view_group_all")) {
	            syGroups.push(g);
	          }
	        });
	        groups = syGroups;
	      }
	
	      return groups.map(function (group) {
	        var GroupNum = parseInt(group.GroupNum);
	        if (GroupNum < 10) GroupNum = '0' + GroupNum;
	        var description = void 0;
	        if (localStorage.getItem('lang') === 'ch') {
	          description = 'Description';
	        } else if (localStorage.getItem('lang') === 'en') {
	          description = 'Name';
	        }
	        return _react2.default.createElement(
	          _reactBootstrap.Panel,
	          { className: 'panelStyle' },
	          _react2.default.createElement(
	            'div',
	            { style: { color: _constants.APP_COLORS['category-nav'], fontFamily: 'Arial Black', cursor: 'pointer' }, name: 'group', id: 'g' + group.ProductGroup_id, onClick: _this7.handleClickGroup.bind(_this7, group, 'g' + group.ProductGroup_id) },
	            _react2.default.createElement(
	              'label',
	              { style: { fontWeight: 'bold' } },
	              GroupNum
	            ),
	            ' ',
	            ' ',
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: group[description] })
	          ),
	          _this7.renderCategories(group.ProductGroup_id)
	        );
	      });
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(files) {
	      this.props.attachDocument(files);
	      this.setState({ files: files });
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this8 = this,
	          _extends2;
	
	      // if (this.props.isLoading && !this.props.error) {
	      //   return <Spinner />
	      // } else if (this.props.error) {
	      //   return (
	      //     <ContentWrapper>
	      //       <div id="product-error-wrapper">
	      //         <div className="alert alert-danger">{JSON.stringify(this.props.error)}</div>
	      //       </div>
	      //     </ContentWrapper>
	      //   );
	      // }
	
	      // Parameters of the react-data-grid
	      var tableHeight = window.innerHeight < 930 ? 680 : 739;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this8.state);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this8.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	        // var state = { ...this.state, sortColumn, sortDirection };
	        _this8.setState(state);
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this8.state.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        if (_root_url.isUSPride && !filter.rawValue) {
	          delete newFilters[filter.column.key];
	        }
	        if (_root_url.isUSPride) {
	          _this8.props.setRowsFilters(newFilters);
	        } else {
	          _this8.setState({
	            filters: newFilters
	          });
	        }
	        _this8.setState({
	          rows: _this8.props.products.map(function (product) {
	            return _extends({}, product, {
	              IsStopSale: product.IsStopSale ? 'yes' : 'no',
	              IsMobile: product.IsMobile ? 'yes' : 'no'
	            });
	          })
	        });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        if (_root_url.isUSPride) {
	          _this8.props.setRowsFilters({});
	        } else {
	          _this8.setState({
	            filters: {}
	          });
	        }
	        _this8.setState({
	          rows: _this8.props.products.map(function (product) {
	            return _extends({}, product, {
	              IsStopSale: product.IsStopSale ? 'yes' : 'no',
	              IsMobile: product.IsMobile ? 'yes' : 'no'
	            });
	          })
	        });
	      };
	
	      var getValidFilterValues = function getValidFilterValues(columnKey) {
	        var filters = _this8.state.filters;
	
	        return filters[columnKey] ? filters[columnKey].rawValue : '';
	      };
	
	      // Handle the row select function
	
	      var onRowSelect = function onRowSelect(rows) {
	        _this8.setState({ selectedRows: rows });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = [].concat(_toConsumableArray(_this8.state.rows));
	        var selectedRows = _this8.state.selectedRows;
	
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	
	        selectedRows = [];
	        rows.map(function (row) {
	          var index = _.findIndex(_this8.state.rows, { 'ProductNum': row.row.ProductNum });
	          newRows[index].isSelected = true;
	          selectedRows.push(row);
	        });
	
	        _this8.setState({ rows: newRows, selectedRows: selectedRows, selectedRowsIdx: rows[0].rowIdx });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = [].concat(_toConsumableArray(_this8.state.rows));
	        rows.map(function (row) {
	          var index = _.findIndex(_this8.state.rows, { 'ProductNum': row.row.ProductNum });
	          newRows[index].isSelected = false;
	        });
	        var selectedRows = [];
	        newRows.map(function (r) {
	          if (r.isSelected) {
	            selectedRows.push(r);
	          }
	        });
	        _this8.setState({ rows: newRows, selectedRows: selectedRows });
	      };
	
	      // Custom Formatter component
	      var NameFormatter = _react2.default.createClass({
	        displayName: 'NameFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            null,
	            this.props.value.Name
	          );
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      // Discontinued Product Background Color Formatter
	      var DiscontinuedProductCellBackGroundFormatter = function DiscontinuedProductCellBackGroundFormatter(props) {
	        var rowBackground = props.dependentValues.IsDiscontinued ? _constants.BACKGROUND_COLOR.lightGray : '';
	        return _react2.default.createElement(
	          'div',
	          { style: { backgroundColor: rowBackground } },
	          _react2.default.createElement(
	            'span',
	            null,
	            props.value
	          )
	        );
	      };
	
	      // formatter for IsStopSale
	      var IsStopSaleFormatter = _react2.default.createClass({
	        displayName: 'IsStopSaleFormatter',
	        render: function render() {
	          if (this.props.value === 'no') return _react2.default.createElement(
	            'span',
	            { className: 'label label-success' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	          );
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	          );
	        }
	      });
	
	      // Column difinition
	      var columns = [].concat(_toConsumableArray(!isLO ? [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true,
	        filterRenderer: _filterByStart2.default,
	        formatter: DiscontinuedProductCellBackGroundFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }] : []), _toConsumableArray(!isLO ? [{
	        key: 'GeneralNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: isMyuMyu || isAFG ? 'index_no' : 'general_no' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        filterRenderer: _filterByStart2.default,
	        formatter: DiscontinuedProductCellBackGroundFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }] : []), [{
	        key: 'RefNum',
	        name: isTN || isWIZ ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: isLO ? 160 : 80,
	        filterable: true,
	        filterRenderer: _filterMultiKeyword2.default,
	        formatter: DiscontinuedProductCellBackGroundFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'item_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true,
	        filterRenderer: _filterMultiKeyword2.default,
	        formatter: DiscontinuedProductCellBackGroundFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true,
	        formatter: DiscontinuedProductCellBackGroundFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'RefPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'MeasureUnit',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mm_unit' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true
	      }, {
	        key: 'ProductGroup_id__Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_group' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'ProductCategory1_id__Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category_1' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'ProductCategory2_id__Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category_2' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'IsStopSale',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'is_stop_sale' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: IsStopSaleFormatter
	      }, {
	        key: 'IsMobile',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'is_mobile_sale' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: IsStopSaleFormatter
	      }]);
	
	      if (isABCFF) {
	        columns = [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          sortable: true,
	          width: 70,
	          filterable: true,
	          filterRenderer: _filterByStart2.default,
	          formatter: DiscontinuedProductCellBackGroundFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'GeneralNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: isMyuMyu || isAFG ? 'index_no' : 'general_no' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true,
	          filterRenderer: _filterByStart2.default,
	          formatter: DiscontinuedProductCellBackGroundFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'RefNum',
	          name: isTN || isWIZ ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true,
	          filterRenderer: _filterMultiKeyword2.default,
	          formatter: DiscontinuedProductCellBackGroundFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'item_name' }),
	          resizable: true,
	          sortable: true,
	          width: 200,
	          filterable: true,
	          filterRenderer: _filterMultiKeyword2.default,
	          formatter: DiscontinuedProductCellBackGroundFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true,
	          width: 120,
	          filterable: true,
	          formatter: DiscontinuedProductCellBackGroundFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'CustomerName',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer' }),
	          resizable: true,
	          sortable: true,
	          width: 120,
	          filterable: true
	        }, {
	          key: 'VendorStyleNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_style' }),
	          resizable: true,
	          sortable: true,
	          width: 120,
	          filterable: true
	        }, {
	          key: 'TJXStyleNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tjx_style' }),
	          resizable: true,
	          sortable: true,
	          width: 120,
	          filterable: true
	        }, {
	          key: 'UPC',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'upc' }),
	          resizable: true,
	          sortable: true,
	          width: 120,
	          filterable: true
	        }, {
	          key: 'Color',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'color' }),
	          resizable: true,
	          sortable: true,
	          width: 120,
	          filterable: true
	        }, {
	          key: 'Size',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'size/ratio' }),
	          resizable: true,
	          sortable: true,
	          width: 120,
	          filterable: true
	        }, {
	          key: 'RefPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        }, {
	          key: 'PackageType',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        }, {
	          key: 'PackageSize',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'MeasureUnit',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mm_unit' }),
	          resizable: true,
	          sortable: true,
	          width: 70,
	          filterable: true
	        }, {
	          key: 'ProductGroup_id__Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_group' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'ProductCategory1_id__Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category_1' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'ProductCategory2_id__Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category_2' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'IsStopSale',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'is_stop_sale' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true,
	          formatter: IsStopSaleFormatter
	        }, {
	          key: 'IsMobile',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'is_mobile_sale' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true,
	          formatter: IsStopSaleFormatter
	        }];
	      }
	
	      if (isSW) {
	        columns = [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          sortable: true,
	          width: 70,
	          filterable: true,
	          filterRenderer: _filterByStart2.default,
	          formatter: DiscontinuedProductCellBackGroundFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'GeneralNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: isMyuMyu || isAFG ? 'index_no' : 'general_no' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true,
	          filterRenderer: _filterByStart2.default,
	          formatter: DiscontinuedProductCellBackGroundFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'RefNum',
	          name: isTN || isWIZ ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	          resizable: true,
	          sortable: true,
	          width: 165,
	          filterable: true,
	          filterRenderer: _filterMultiKeyword2.default,
	          formatter: DiscontinuedProductCellBackGroundFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'item_name' }),
	          resizable: true,
	          sortable: true,
	          width: 250,
	          filterable: true,
	          filterRenderer: _filterMultiKeyword2.default,
	          formatter: DiscontinuedProductCellBackGroundFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true,
	          width: 120,
	          filterable: true,
	          formatter: DiscontinuedProductCellBackGroundFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'RefPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        }, {
	          key: 'PackageType',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        }, {
	          key: 'PackageSize',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'MeasureUnit',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mm_unit' }),
	          resizable: true,
	          sortable: true,
	          width: 70,
	          filterable: true
	        }, {
	          key: 'ProductGroup_id__Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_group' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'ProductCategory1_id__Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category_1' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'ProductCategory2_id__Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category_2' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'Brand',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'brand' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'Color',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'color' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'Size',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'size' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'IsStopSale',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'is_stop_sale' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true,
	          formatter: IsStopSaleFormatter
	        }, {
	          key: 'IsMobile',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'is_mobile_sale' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true,
	          formatter: IsStopSaleFormatter
	        }];
	      }
	
	      if (isAFG || isMyuMyu || isWecom) {
	        var indexGeneralNum = _.findIndex(columns, { key: 'GeneralNum' });
	        var generalColumn = {
	          key: 'GeneralNumDisplay',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: isMyuMyu || isAFG || isWecom ? 'index_no' : 'general_no' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true,
	          // filterRenderer: FilterByStart,
	          formatter: DiscontinuedProductCellBackGroundFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        };
	        columns.splice(indexGeneralNum, 1, generalColumn);
	        if (this.state.rows.length > 0) {
	          this.state.rows.map(function (row) {
	            if (row.GeneralNum) {
	              row.GeneralNumDisplay = Number(row.GeneralNum);
	            } else {
	              row.GeneralNumDisplay = null;
	            }
	          });
	        }
	      }
	
	      if (isLO) {
	        var refNumIndex = columns.findIndex(function (column) {
	          return column.key === 'RefNum';
	        });
	        if (refNumIndex !== -1) {
	          columns[refNumIndex].name = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'item_num' });
	        }
	        var itemNameIndex = columns.findIndex(function (column) {
	          return column.key === 'Name';
	        });
	        if (itemNameIndex !== -1) {
	          columns[itemNameIndex].name = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'item_description' });
	          columns[itemNameIndex].width = 300;
	        }
	        var descriptionIndex = columns.findIndex(function (column) {
	          return column.key === 'Description';
	        });
	        if (descriptionIndex !== -1) {
	          columns.splice(descriptionIndex, 1);
	        }
	      }
	
	      var reactDataGridOtherProps = {};
	      if (_root_url.isUSPride) {
	        reactDataGridOtherProps = {
	          getValidFilterValues: getValidFilterValues
	        };
	      }
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '99%' }, id: 'Products-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, _extends((_extends2 = {
	              ref: 'testingstuff',
	              rowRenderer: _react2.default.createElement(RowRenderer, {
	                onDoubleClick: function onDoubleClick(data) {
	                  if ((0, _permissions2.default)('change_product')) {
	                    _this8.checkDetail(data);
	                  } else {
	                    alert(_reactReduxI18n.I18n.t('msg_no_permission'));
	                  }
	                }
	              }),
	              rowKey: 'Product_id'
	            }, _defineProperty(_extends2, 'ref', function ref(g) {
	              return _this8.tableGrid = g;
	            }), _defineProperty(_extends2, 'onGridSort', handleGridSort), _defineProperty(_extends2, 'enableCellSelect', true), _defineProperty(_extends2, 'toolbar', _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true })), _defineProperty(_extends2, 'onAddFilter', handleFilterChange), _defineProperty(_extends2, 'onClearFilters', onClearFilters), _defineProperty(_extends2, 'columns', columns), _defineProperty(_extends2, 'rowGetter', rowGetter), _defineProperty(_extends2, 'rowsCount', getSize()), _defineProperty(_extends2, 'rowHeight', 25), _defineProperty(_extends2, 'headerRowHeight', 45), _defineProperty(_extends2, 'minHeight', 623), _defineProperty(_extends2, 'enableRowSelect', 'single'), _defineProperty(_extends2, 'onRowUpdated', this.handleRowUpdated), _defineProperty(_extends2, 'onRowSelect', onRowSelect), _defineProperty(_extends2, 'rowSelection', {
	              showCheckbox: true,
	              onRowsSelected: onRowsSelected,
	              onRowsDeselected: onRowsDeselected,
	              selectBy: {
	                isSelectedKey: 'isSelected'
	              }
	            }), _extends2), reactDataGridOtherProps))
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderTNProductButton',
	    value: function renderTNProductButton() {
	      var _this9 = this;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'print-btn',
	          type: 'button',
	          onClick: function onClick() {
	            _this9.refs.importProduct.click();
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-upload' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product' })
	      );
	    }
	  }, {
	    key: 'renderImportZipcodeButton',
	    value: function renderImportZipcodeButton() {
	      var _this10 = this;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'print-btn',
	          type: 'button',
	          onClick: function onClick() {
	            _this10.refs.importZipcode.click();
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-upload' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'import_zipcodes' }),
	        ' (xlsx)'
	      );
	    }
	  }, {
	    key: 'renderTNBarcodeButton',
	    value: function renderTNBarcodeButton() {
	      var _this11 = this;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'print-btn',
	          type: 'button',
	          onClick: function onClick() {
	            _this11.refs.importBarcode.click();
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-upload' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'barcode' })
	      );
	    }
	  }, {
	    key: 'renderTNTemplatButton',
	    value: function renderTNTemplatButton() {
	      var templateUrl = _root_url.ROOT_URL + 'v2/product/import-template?Bearer=' + localStorage.getItem("token");
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'print-btn',
	          type: 'button',
	          href: templateUrl
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_template' })
	      );
	    }
	  }, {
	    key: 'renderTNBarcodeTemplatButton',
	    value: function renderTNBarcodeTemplatButton() {
	      var templateUrl = 'https://scmteambucket.s3.us-west-1.amazonaws.com/TN_Barcode_Templete.xlsx';
	      // const templateUrl = `${ROOT_URL}v2/product/barcode-template?Bearer=${localStorage.getItem("token")}`;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'print-btn',
	          type: 'button',
	          href: templateUrl
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'barcode_template' })
	      );
	    }
	  }, {
	    key: 'renderImportProductButton',
	    value: function renderImportProductButton() {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'print-btn',
	          type: 'button',
	          onClick: function onClick() {
	            document.getElementById("myInputTest").click();
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-upload' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'upload_product' }),
	        _react2.default.createElement('input', {
	          id: 'myInputTest',
	          type: 'file',
	          accept: '.xls',
	          style: { display: "none" },
	          onClick: function onClick(e) {
	            e.target.value = null;
	          },
	          onChange: function onChange(e) {
	            var data = new FormData();
	            data.append("file", e.target.files[0]);
	            if (e.target.files[0]) {
	              _axios2.default.post(_root_url.ROOT_URL + 'v1/product/import-jml-product', data, {
	                headers: {
	                  Authorization: 'Bearer ' + localStorage.getItem("token")
	                }
	              }).then(function (res) {
	                if (res.status === 200) {
	                  alert("success");
	                }
	              }, function (err) {
	                if (err.data) {
	                  alert(err.data);
	                } else {
	                  alert("Server issue detected, please contact admin.");
	                }
	              });
	            }
	          }
	        })
	      );
	    }
	  }, {
	    key: 'renderProductTemplatButton',
	    value: function renderProductTemplatButton() {
	      var templateUrl = 'https://truckxi-public-bucket.s3.us-west-1.amazonaws.com/storage/jml_product_template.xls';
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'print-btn',
	          type: 'button',
	          href: templateUrl
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_template' })
	      );
	    }
	  }, {
	    key: 'renderExcel',
	    value: function renderExcel() {
	      var _state = this.state,
	          currentCategory = _state.currentCategory,
	          currentGroup = _state.currentGroup;
	
	
	      var exportUrl = '';
	      var text = "Excel SKU (All)";
	
	      if (currentCategory !== -1) {
	        exportUrl = _root_url.ROOT_URL + 'v1/product/sku_export/?ProductCategory1_id=' + currentCategory + '&Bearer=' + localStorage.getItem("token");
	        text = "Excel SKU (Category)";
	      } else if (currentGroup !== -1) {
	        exportUrl = _root_url.ROOT_URL + 'v1/product/sku_export/?ProductGroup_id=' + currentGroup + '&Bearer=' + localStorage.getItem("token");
	        text = "Excel SKU (Group)";
	      } else {
	        exportUrl = _root_url.ROOT_URL + 'v1/product/sku_export/?Bearer=' + localStorage.getItem("token");
	        text = "Excel SKU (All)";
	      }
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          href: exportUrl
	          // onClick={() => { console.log("id",currentGroup,currentCategory) }}
	          , disabled: false
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        '\xA0',
	        text
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this12 = this;
	
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product' })
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'products-inventory-page' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 2 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { id: 'category-nav', className: 'panelStyle', style: { overflowY: 'scroll', width: '100%' } },
	                  (!isSY || (0, _permissions2.default)('view_group_all')) && _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { className: 'panelStyle' },
	                    _react2.default.createElement(
	                      'div',
	                      { style: { color: _constants.APP_COLORS['category-nav'], fontWeight: 'bold', cursor: 'pointer' }, name: 'group', id: 'g-1', onClick: this.handleClickGroup.bind(this, null, '-1') },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' })
	                    )
	                  ),
	                  this.renderGroups()
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 10 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'position-relative mb0', id: 'products' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.ButtonToolbar,
	                      { className: 'table-buttons' },
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: 'primary',
	                          type: 'button',
	                          onClick: function onClick(event) {
	                            _this12.clickNew(event);
	                          },
	                          disabled: !(0, _permissions2.default)('add_product')
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_product' })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: 'warning',
	                          type: 'button',
	                          onClick: function onClick(event) {
	                            _this12.setCurrentProduct(event);
	                          },
	                          disabled: !this.state.selectedRows || this.state.selectedRows.length !== 1 || !(0, _permissions2.default)('change_product')
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_product' })
	                      ),
	                      isJML && this.renderExcel(),
	                      isFBD && this.renderZipcodeExport(),
	                      isFBD && this.renderImportZipcodeButton(),
	                      _react2.default.createElement('input', {
	                        type: 'file',
	                        style: { display: "none" },
	                        onClick: function onClick(e) {
	                          e.target.value = null;
	                        },
	                        onChange: function onChange(e) {
	                          var URL = _root_url.ROOT_URL + 'v1/product/zipcodes/';
	                          var formData = new FormData();
	                          formData.append("file", e.target.files[0]);
	                          if (e.target.files[0]) {
	                            _axios2.default.post(URL, formData, {
	                              headers: {
	                                Authorization: 'Bearer ' + localStorage.getItem("token")
	                              }
	                            }).then(function (res) {
	                              alert("Zipcodes uploaded successfully");
	                              // this.fetchSalesOrdersByDetails(
	                              //   this.state.days
	                              // );
	                            }, function (err) {
	                              if (err.data) {
	                                alert(err.data);
	                              } else {
	                                alert("Server issue detected, please contact admin.");
	                              }
	                            });
	                          }
	                        },
	                        ref: 'importZipcode'
	                      }),
	                      _react2.default.createElement('input', {
	                        type: 'file',
	                        ref: 'importProduct',
	                        onChange: function onChange(e) {
	                          var file = e.target.files[0];
	                          var formData = new FormData();
	                          formData.append('file', file);
	                          var succes = function succes() {
	                            alert("Product Import Successful");
	                            _this12.props.resetGroupAndCategory();
	                          };
	                          (0, _products_actions.productUpload)(formData, succes);
	                        },
	                        style: { display: 'none' }
	                      }),
	                      _react2.default.createElement('input', {
	                        type: 'file',
	                        style: { display: "none" },
	                        onClick: function onClick(e) {
	                          e.target.value = null;
	                        },
	                        onChange: function onChange(e) {
	                          var URL = _root_url.ROOT_URL + 'v2/product/import-barcode';
	                          var formData = new FormData();
	                          formData.append("file", e.target.files[0]);
	                          if (e.target.files[0]) {
	                            _axios2.default.post(URL, formData, {
	                              headers: {
	                                Authorization: 'Bearer ' + localStorage.getItem("token")
	                              }
	                            }).then(function (res) {
	                              alert("barcodes uploaded successfully");
	                              // this.fetchSalesOrdersByDetails(
	                              //   this.state.days
	                              // );
	                            }, function (err) {
	                              if (err.data) {
	                                alert(err.data);
	                              } else {
	                                alert("Server issue detected, please contact admin.");
	                              }
	                            });
	                          }
	                        },
	                        ref: 'importBarcode'
	                      }),
	                      isTN && this.renderTNProductButton(),
	                      isTN && this.renderTNTemplatButton(),
	                      isTN && this.renderTNBarcodeButton(),
	                      isTN && this.renderTNBarcodeTemplatButton(),
	                      _react2.default.createElement('input', {
	                        style: { width: '150px', marginLeft: '5px', borderRadius: '5px', padding: '2px', border: '1px solid black' },
	                        type: 'text',
	                        onChange: function onChange(e) {
	                          _this12.onChangeQuickEntry(e);
	                        },
	                        onKeyPress: function onKeyPress(e) {
	                          _this12.onKeyPressQuickEntry(e);
	                        },
	                        value: this.state.quickEntryProductNum,
	                        placeholder: _reactReduxI18n.I18n.t('product_num_ref_num')
	                      }),
	                      isJML && this.renderImportProductButton(),
	                      isJML && this.renderProductTemplatButton(),
	                      this.state.quickEntryShowError && _react2.default.createElement(
	                        'span',
	                        { style: { marginLeft: '3px', color: 'red' } },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_not_found' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.ButtonToolbar,
	                      { style: { position: 'relative', marginTop: '30px', marginLeft: '2px' } },
	                      isTN && this.renderTNProductExport()
	                    )
	                  ),
	                  this.renderTable()
	                )
	              ),
	              ' '
	            )
	          )
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return Products;
	}(_react.Component);
	
	Products.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = Products;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isMyuMyu, 'isMyuMyu', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/products.jsx');
	
	  __REACT_HOT_LOADER__.register(isAFG, 'isAFG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/products.jsx');
	
	  __REACT_HOT_LOADER__.register(isWecom, 'isWecom', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/products.jsx');
	
	  __REACT_HOT_LOADER__.register(isTN, 'isTN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/products.jsx');
	
	  __REACT_HOT_LOADER__.register(isWIZ, 'isWIZ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/products.jsx');
	
	  __REACT_HOT_LOADER__.register(isSW, 'isSW', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/products.jsx');
	
	  __REACT_HOT_LOADER__.register(isABCFF, 'isABCFF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/products.jsx');
	
	  __REACT_HOT_LOADER__.register(isSY, 'isSY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/products.jsx');
	
	  __REACT_HOT_LOADER__.register(isJML, 'isJML', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/products.jsx');
	
	  __REACT_HOT_LOADER__.register(isFBD, 'isFBD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/products.jsx');
	
	  __REACT_HOT_LOADER__.register(isLO, 'isLO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/products.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/products.jsx');
	
	  __REACT_HOT_LOADER__.register(Products, 'Products', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/products.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/products.jsx');
	}();

	;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VendorForm = function (_Component) {
	  _inherits(VendorForm, _Component);
	
	  function VendorForm() {
	    _classCallCheck(this, VendorForm);
	
	    return _possibleConstructorReturn(this, (VendorForm.__proto__ || Object.getPrototypeOf(VendorForm)).apply(this, arguments));
	  }
	
	  _createClass(VendorForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          closeV = _props.closeV;
	
	      return _react2.default.createElement(
	        'form',
	        { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: 'Name', component: 'Input', type: 'text', className: 'form-control' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_no' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: 'TermDays', component: 'Input', type: 'text', className: 'form-control' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: 'Description', component: 'Input', className: 'form-control' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { action: 'submit', className: 'btn btn-primary buttonStyle' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-danger buttonStyle', onClick: function onClick(event) {
	              event.preventDefault();closeV();
	            } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	        )
	      );
	    }
	  }]);
	
	  return VendorForm;
	}(_react.Component);
	
	var _default = VendorForm;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(VendorForm, 'VendorForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/vendorForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Products/vendorForm.jsx');
	}();

	;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _constants = __webpack_require__(11);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChartModal = function (_Component) {
	  _inherits(ChartModal, _Component);
	
	  function ChartModal() {
	    _classCallCheck(this, ChartModal);
	
	    var _this = _possibleConstructorReturn(this, (ChartModal.__proto__ || Object.getPrototypeOf(ChartModal)).call(this));
	
	    _this.state = {
	      charts: {
	        rows: [],
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	      isToday: true
	    };
	    return _this;
	  }
	
	  _createClass(ChartModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var changeDateFormat = function changeDateFormat(day) {
	        var y = day.getFullYear().toString();
	        var m = day.getMonth() + 1;
	        if (m < 10) {
	          m = '0' + m;
	        } else {
	          m = m.toString();
	        }
	        var d = day.getDate();
	        if (d < 10) {
	          d = '0' + d;
	        } else {
	          d = d.toString();
	        }
	        d = y + m + d;
	        return d;
	      };
	      var date = changeDateFormat(new Date());
	      var isToday = false;
	      if (date == this.props.date) isToday = true;
	      this.setState({ isToday: isToday });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.purchasePivotCharts && nextProps.purchasePivotCharts != this.props.purchasePivotCharts) {
	        var charts = _extends({}, this.state.charts, { rows: nextProps.purchasePivotCharts });
	        this.setState({ charts: charts });
	      }
	    }
	  }, {
	    key: 'renderChartTable',
	    value: function renderChartTable() {
	      var _this2 = this;
	
	      if (this.props.purchasePivotChartOrdersIsLoading && !this.props.purchasePivotChartOrdersError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.purchasePivotChartOrdersError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.purchasePivotChartOrdersError)
	        )
	      );else {
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.charts);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return Object.assign({}, rows[rowIdx]);
	        };
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var state = Object.assign({}, _this2.state.charts, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this2.setState({ charts: state });
	        };
	
	        var onRowsSelected = function onRowsSelected(rows) {
	          var newRows = getRows();
	          var selectedRows = [newRows[rows[0].rowIdx]];
	          newRows.map(function (r) {
	            r.isSelected = false;
	          });
	          newRows[rows[0].rowIdx].isSelected = true;
	          var charts = _extends({}, _this2.state.charts, { rows: newRows, selectedRows: selectedRows });
	          _this2.setState({ charts: charts });
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          var newRows = getRows();
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = false;
	          });
	          var charts = _extends({}, _this2.state.charts, { rows: newRows, selectedRows: [] });
	          _this2.setState({ charts: charts });
	        };
	        var columns = [{
	          key: 'id',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	          resizable: true,
	          sortable: true,
	          filterable: true
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true,
	          filterable: true
	        }];
	        return _react2.default.createElement(
	          'div',
	          { className: 'react-table-customizer', id: 'ChartModal-dataGrid1' },
	          _react2.default.createElement(_reactDataGrid2.default, {
	            rowKey: 'Product_id',
	            enableCellSelect: true,
	            onGridSort: handleGridSort,
	            columns: columns,
	            rowHeight: 25,
	            minHeight: 480,
	            rowGetter: rowGetter,
	            rowsCount: getSize(),
	            rowSelection: {
	              showCheckbox: true,
	              onRowsSelected: onRowsSelected,
	              onRowsDeselected: onRowsDeselected,
	              selectBy: {
	                isSelectedKey: 'isSelected'
	              }
	            }
	          })
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'chart-modal' },
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'success',
	                type: 'submit',
	                disabled: !this.state.isToday,
	                onClick: function onClick() {
	                  _this3.props.setPurchasePivotChart(null);_this3.context.router.push('/purchasePivotChart/new');
	                } },
	              _react2.default.createElement('em', { className: 'fa fa-plus' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'warning',
	                type: 'button',
	                onClick: function onClick() {
	                  _this3.props.setPurchasePivotChart(_this3.state.charts.selectedRows[0].PurchasePivot_id);_this3.context.router.push('/purchasePivotChart/' + _this3.state.charts.selectedRows[0].PurchasePivot_id);
	                },
	                disabled: !this.state.charts.selectedRows || this.state.charts.selectedRows.length != 1 },
	              _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'success',
	                type: 'button',
	                disabled: this.state.isToday || !this.state.charts.selectedRows || this.state.charts.selectedRows.length != 1,
	                onClick: function onClick() {
	                  _this3.props.duplicatePivotChart(_this3.state.charts.selectedRows[0].PurchasePivot_id);
	                } },
	              _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'duplicate' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'width' },
	            this.renderChartTable()
	          ),
	          this.props.isDuplicatingPurchasePivotChart && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_spinner2.default, null)
	          ),
	          this.props.duplicatedPurchasePivotChart && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-success' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saved' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChartModal;
	}(_react.Component);
	
	ChartModal.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = ChartModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ChartModal, 'ChartModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/chartModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/chartModal.jsx');
	}();

	;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactDropzone = __webpack_require__(45);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _ImageFormatter = __webpack_require__(73);
	
	var _ImageFormatter2 = _interopRequireDefault(_ImageFormatter);
	
	var _purchaseOrderList_actions = __webpack_require__(111);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(5),
	    _require$Draggable = _require.Draggable,
	    DraggableContainer = _require$Draggable.Container,
	    RowActionsCell = _require$Draggable.RowActionsCell,
	    DropTargetRowContainer = _require$Draggable.DropTargetRowContainer,
	    Selectors = _require.Data.Selectors;
	
	var propTypes = {
	  rowKey: _propTypes2.default.string,
	  poid: _propTypes2.default.number,
	  handleImageClosed: _propTypes2.default.func
	};
	
	var defaultProps = {
	  rowKey: 'Index',
	  poid: undefined,
	  handleImageClosed: function handleImageClosed() {}
	};
	
	var BolImagesTablePO = function (_Component) {
	  _inherits(BolImagesTablePO, _Component);
	
	  function BolImagesTablePO(props) {
	    _classCallCheck(this, BolImagesTablePO);
	
	    var _this = _possibleConstructorReturn(this, (BolImagesTablePO.__proto__ || Object.getPrototypeOf(BolImagesTablePO)).call(this, props));
	
	    _this.onDrop = function (row, files) {
	      if (!files) {
	        return;
	      }
	      var reader = new FileReader();
	      reader.onload = function () {
	        var index = row.props.rowIdx;
	
	        var newRows = [].concat(_toConsumableArray(_this.state.newImage.rows));
	        newRows[index].imageString = reader.result;
	        newRows[index].file = files;
	
	        var newImage = _extends({}, _this.state.newImage, {
	          rows: newRows
	        });
	        _this.setState({ newImage: newImage });
	      };
	
	      // get the first file and convert to blob object (Blob.slice([start [, end [, contentType]]))
	      var blob = files[0].slice(0, files[0].size, files[0].type);
	      reader.readAsDataURL(blob);
	    };
	
	    _this.handleSaveImages = function () {
	      console.log('handleSaveImages');
	      var rows = _this.state.newImage.rows.filter(function (row) {
	        var match = !(row.imageString === undefined);
	        return match;
	      });
	      var newImage = _extends({}, _this.state.newImage, {
	        rows: rows
	      });
	      _this.setState({ newImage: newImage }, function () {
	        _this.saveImages(function () {
	          _this.fetchImages();
	        });
	      });
	    };
	
	    _this.addNewImageRow = function (e) {
	      e.preventDefault();
	      var rows = _reactDataGridAddons.Data.Selectors.getRows(_this.state.newImage);
	      var index = rows.length;
	      var newRow = {
	        Index: index
	      };
	      rows.push(newRow);
	      var newImage = _extends({}, _this.state.newImage, {
	        rows: rows
	      });
	      _this.setState({ newImage: newImage });
	    };
	
	    _this.deleteOldRow = function () {
	      var selectedRows = _this.state.oldImage.selectedRows;
	
	      if (!selectedRows || selectedRows.length === 0) {
	        alert('Select a row to delete!');
	        return;
	      }
	      var id = selectedRows[0].Image_id;
	
	      _this.deleteImage(id, function () {
	        return _this.fetchImages();
	      });
	    };
	
	    _this.deleteImage = function (imageId, successCallback) {
	      var handleSuccess = function handleSuccess(response) {
	        _this.setState({
	          isDeletingImage: false
	        }, successCallback);
	      };
	      var handleFailure = function handleFailure(error) {
	        alert(error);
	        _this.setState({
	          isDeletingImage: false
	        });
	      };
	      _this.setState({
	        isDeletingImage: true
	      }, function () {
	        (0, _purchaseOrderList_actions.deletePOImage)(imageId, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.deleteNewRow = function () {
	      var selectedRows = _this.state.newImage.selectedRows;
	
	      if (!selectedRows || selectedRows.length === 0) {
	        alert('Select a row to delete!');
	        return;
	      }
	      var rows = [].concat(_toConsumableArray(_this.state.newImage.rows));
	      var index = _lodash2.default.findIndex(rows, { Index: selectedRows[0].Index });
	      rows.map(function (row, rowIndex) {
	        row.Index = rowIndex;
	      });
	      rows.splice(index, 1);
	      var newImage = _extends({}, _this.state.newImage, {
	        rows: rows
	      });
	      _this.setState({ newImage: newImage });
	    };
	
	    _this.fetchImages = function () {
	      var handleSuccess = function handleSuccess(response) {
	        console.log('response', response);
	        var rows = response.data.images || [];
	        rows.map(function (row, index) {
	          row.Index = index;
	        });
	        var oldImage = _extends({}, _this.state.oldImage, {
	          rows: rows
	        });
	        _this.setState({
	          oldImage: oldImage,
	          isLoadingImages: false
	        });
	      };
	      var handleFailure = function handleFailure(error) {
	        alert(error);
	        var oldImage = _extends({}, _this.state.oldImage, {
	          rows: rows
	        });
	        _this.setState({
	          oldImage: oldImage,
	          isLoadingImages: false
	        });
	      };
	      _this.setState({
	        isLoadingImages: true
	      }, function () {
	        return (0, _purchaseOrderList_actions.fetchPOImages)(_this.props.poid, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.saveImages = function (successCallback) {
	      var handleSuccess = function handleSuccess(response) {
	        alert('Image is submit! ');
	        _this.setState({
	          isSavingImages: false
	        }, successCallback);
	        _this.props.handleImageClosed();
	      };
	      var handleFailure = function handleFailure(error) {
	        var msg = "Error: ";
	        msg += JSON.stringify(error);
	        alert(msg);
	        _this.setState({
	          isSavingImages: false
	        });
	      };
	      console.log('calling api');
	      _this.setState({
	        isSavingImages: true
	      }, function () {
	        (0, _purchaseOrderList_actions.savePOImages)(_this.props.poid, _this.state.newImage.rows, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.renderNewImage = function (index) {
	      var imageFile = _this.state.newImage.rows[index].imageString || '/img/dummy.png';
	      return _react2.default.createElement(
	        'div',
	        { className: 'img-view' },
	        _react2.default.createElement('img', {
	          src: imageFile,
	          alt: 'Upload',
	          className: 'default-image'
	        })
	      );
	    };
	
	    _this.state = {
	      oldImage: {
	        rows: [],
	        selectedRows: null
	      },
	      newImage: {
	        rows: [],
	        selectedRows: null
	      },
	
	      isLoadingImages: false,
	      isSavingImages: false,
	      isDeletingImage: false
	    };
	    return _this;
	  }
	
	  _createClass(BolImagesTablePO, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchImages();
	    }
	  }, {
	    key: 'renderImageTable',
	    value: function renderImageTable() {
	      var _this2 = this;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.oldImage);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        // merge updated row with current row and rerender by setting state
	        var rows = getRows();
	        Object.assign(rows[e.rowIdx], e.updated);
	        var oldImage = _extends({}, _this2.state.oldImage, {
	          rows: rows
	        });
	        _this2.setState({ oldImage: oldImage });
	
	        // // merge updated row with current row and rerender by setting state
	        // const rows = getRows();
	        // const editedRows = this.state.editedRows.slice(0);
	        // Object.assign(rows[e.rowIdx], e.updated);
	        // // if the element is already edited, remove the old one.
	        // editedRows.forEach((element, index) => {
	        //   if (element.Idx === rows[e.rowIdx].Index) {
	        //     editedRows.splice(index, 1);
	        //   }
	        // }, this);
	        // // push the row into the editedRows array
	        // editedRows.push(rows[e.rowIdx]);
	        // this.setState({
	        //   rows,
	        //   editedRows,
	        // });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        var oldImage = _extends({}, _this2.state.oldImage, {
	          rows: newRows,
	          selectedRows: [rows[0].row]
	        });
	        _this2.setState({
	          oldImage: oldImage
	        });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = getRows();
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        var oldImage = _extends({}, _this2.state.oldImage, {
	          rows: newRows,
	          selectedRows: []
	        });
	        _this2.setState({ oldImage: oldImage });
	      };
	
	      var columns = [{
	        key: "ImageURL",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'image' }),
	        resizeable: true,
	        width: 220,
	        sortable: false,
	        editable: false,
	        filterable: false,
	        formatter: function formatter(_ref) {
	          var value = _ref.value;
	          return _react2.default.createElement(
	            'div',
	            { className: 'group-thumbnail-cell' },
	            _react2.default.createElement(
	              'div',
	              { id: 'image-container' },
	              _react2.default.createElement('img', { style: { width: "120px", height: "120px", border: "1px solid #333333" }, src: value })
	            )
	          );
	        },
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: "100%" }, id: 'Category_2-dataGrid1' },
	            _react2.default.createElement(
	              DraggableContainer,
	              null,
	              _react2.default.createElement(_reactDataGrid2.default, {
	                columns: columns,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                minHeight: 500,
	                rowHeight: 200,
	                headerRowHeight: 25,
	                enableRowSelect: 'single',
	                onRowUpdated: handleRowUpdated,
	                rowSelection: {
	                  showCheckbox: true,
	                  onRowsSelected: onRowsSelected,
	                  onRowsDeselected: onRowsDeselected,
	                  selectBy: {
	                    isSelectedKey: 'isSelected'
	                  }
	                }
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderNewImageTable',
	    value: function renderNewImageTable() {
	      var _this3 = this;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.newImage);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        // merge updated row with current row and rerender by setting state
	        var rows = getRows();
	        Object.assign(rows[e.rowIdx], e.updated);
	        var newImage = _extends({}, _this3.state.newImage, {
	          rows: rows
	        });
	        _this3.setState({ newImage: newImage });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        var newImage = _extends({}, _this3.state.newImage, {
	          rows: newRows,
	          selectedRows: [rows[0].row]
	        });
	        _this3.setState({ newImage: newImage });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = getRows();
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        var newImage = _extends({}, _this3.state.newImage, {
	          rows: newRows,
	          selectedRows: []
	        });
	        _this3.setState({ newImage: newImage });
	      };
	
	      var columns = [{
	        key: "Image",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'image' }),
	        resizeable: true,
	        width: 220,
	        sortable: false,
	        editable: false,
	        filterable: false,
	        formatter: _react2.default.createElement(_ImageFormatter2.default, {
	          renderImage: this.renderNewImage,
	          onDrop: this.onDrop,
	          showImageOnly: true,
	          onRowValueChange: this.onRowValueChange
	        }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: "100%" }, id: 'Category_2-dataGrid1' },
	            _react2.default.createElement(
	              DraggableContainer,
	              null,
	              _react2.default.createElement(_reactDataGrid2.default, {
	                columns: columns,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                minHeight: 500,
	                rowHeight: 200,
	                headerRowHeight: 25,
	                enableRowSelect: 'single',
	                onRowUpdated: handleRowUpdated,
	                rowSelection: {
	                  showCheckbox: true,
	                  onRowsSelected: onRowsSelected,
	                  onRowsDeselected: onRowsDeselected,
	                  selectBy: {
	                    isSelectedKey: 'isSelected'
	                  }
	                }
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isSavingImages = _state.isSavingImages,
	          isDeletingImage = _state.isDeletingImage;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { id: 'product-images-modal' },
	          _react2.default.createElement(
	            'div',
	            { style: { width: "50%", float: 'left' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'toolbar-row' },
	              _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                null,
	                _react2.default.createElement(_SpinnerButton2.default, {
	                  bsStyle: 'danger',
	                  disabled: isDeletingImage,
	                  onClick: this.deleteOldRow,
	                  loading: isDeletingImage,
	                  icon: 'fa-trash',
	                  translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                })
	              )
	            ),
	            this.renderImageTable()
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { width: "50%", float: 'left' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'toolbar-row' },
	              _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'primary',
	                    onClick: this.addNewImageRow
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	                ),
	                _react2.default.createElement(_SpinnerButton2.default, {
	                  bsStyle: 'success',
	                  disabled: isSavingImages,
	                  onClick: this.handleSaveImages,
	                  loading: isSavingImages,
	                  icon: 'fa-save',
	                  translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                }),
	                _react2.default.createElement(_SpinnerButton2.default, {
	                  bsStyle: 'danger',
	                  onClick: this.deleteNewRow,
	                  icon: 'fa-trash',
	                  translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                })
	              )
	            ),
	            this.renderNewImageTable()
	          )
	        )
	      );
	    }
	  }]);
	
	  return BolImagesTablePO;
	}(_react.Component);
	
	BolImagesTablePO.propTypes = propTypes;
	BolImagesTablePO.defaultProps = defaultProps;
	
	var _default = BolImagesTablePO;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/components/BolImagesTablePO.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/components/BolImagesTablePO.jsx');
	
	  __REACT_HOT_LOADER__.register(BolImagesTablePO, 'BolImagesTablePO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/components/BolImagesTablePO.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/components/BolImagesTablePO.jsx');
	}();

	;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxForm = __webpack_require__(3);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomerInfo = function (_Component) {
	  _inherits(CustomerInfo, _Component);
	
	  function CustomerInfo() {
	    _classCallCheck(this, CustomerInfo);
	
	    return _possibleConstructorReturn(this, (CustomerInfo.__proto__ || Object.getPrototypeOf(CustomerInfo)).apply(this, arguments));
	  }
	
	  _createClass(CustomerInfo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.fetchCustomers();
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      if (!this.checkPermission("add_purchase_order")) {
	        var Deliver_Customer_id = formProps.Deliver_Customer_id.value;
	        var Deliver_CustomerDetail_id = formProps.CustomerDetail_id.value,
	            PaymentTerm_id = -1;
	        var index = _lodash2.default.findIndex(this.props.customers, { 'Customer_id': Deliver_Customer_id });
	        if (index > -1 && this.props.customers[index]) {
	          PaymentTerm_id = this.props.customers[index].PaymentTerm_id;
	        }
	        this.props.createDropship(Deliver_Customer_id, Deliver_CustomerDetail_id, PaymentTerm_id, this.props.orderInfo, this.props.orderLineInfo, this.props.totalNetWeight, this.props.totalShippingWeight, this.props.totalPrice, this.props.finalPrice);
	      } else alert("You have no permission!");
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.deliver_Customer_id && nextProps.deliver_Customer_id != this.props.deliver_Customer_id) {
	        this.props.fetchCustomerDetail(nextProps.deliver_Customer_id.value);
	      }
	    }
	  }, {
	    key: 'renderCustomers',
	    value: function renderCustomers() {
	      if (this.props.customersIsLoading) return _react2.default.createElement(_spinner2.default, null); // If payment term is loading, show a spinner.
	      else {
	          var customerNameOptions = this.getCustomerNameOptions();
	          var customerNumOptions = this.getCustomerNumOptions();
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'mb-lg' },
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 12 },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-3' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 4 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Deliver_Customer_id', component: _selection2.default, options: customerNameOptions })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'mb-lg' },
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 12 },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-3' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_no' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 4 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Deliver_Customer_id', component: _selection2.default, options: customerNumOptions })
	                )
	              )
	            )
	          );
	        }
	    }
	  }, {
	    key: 'renderCustomerShippingAddress',
	    value: function renderCustomerShippingAddress() {
	      if (this.props.detailIsLoading) return _react2.default.createElement(_spinner2.default, null); // If payment term is loading, show a spinner.
	      else {
	          var customerShippingAddressOptions = this.getCustomerShippingAddressOptions();
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'mb-lg' },
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 12 },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-3' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_address' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 9 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'CustomerDetail_id', component: _selection2.default, options: customerShippingAddressOptions })
	                )
	              )
	            )
	          );
	        }
	    }
	  }, {
	    key: 'getCustomerNameOptions',
	    value: function getCustomerNameOptions() {
	      var customerOptions = [];
	      this.props.customers.map(function (customer) {
	        customerOptions.push({ value: customer.Customer_id, label: customer.Name });
	      });
	      return customerOptions;
	    }
	  }, {
	    key: 'getCustomerNumOptions',
	    value: function getCustomerNumOptions() {
	      var customerOptions = [];
	      this.props.customers.map(function (customer) {
	        customerOptions.push({ value: customer.Customer_id, label: customer.CustomerNum });
	      });
	      return customerOptions;
	    }
	  }, {
	    key: 'getCustomerShippingAddressOptions',
	    value: function getCustomerShippingAddressOptions() {
	      var customerShippingAddressOptions = [];
	      if (this.props.currentCustomerDetail && this.props.currentCustomerDetail.Shipping) {
	        this.props.currentCustomerDetail.Shipping.map(function (shipping) {
	          var address = void 0;
	          address = shipping.Street + " " + shipping.City + " " + shipping.State + " " + shipping.Zip;
	          customerShippingAddressOptions.push({ value: shipping.CustomerDetail_id, label: address });
	        });
	      }
	      return customerShippingAddressOptions;
	    }
	  }, {
	    key: 'checkPermission',
	    value: function checkPermission(permission) {
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          closeShowCustomer = _props.closeShowCustomer,
	          submitting = _props.submitting,
	          pristine = _props.pristine,
	          valid = _props.valid;
	
	      return _react2.default.createElement(
	        'form',
	        { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            this.renderCustomers()
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            this.renderCustomerShippingAddress()
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          { className: 'mt-xl' },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsStyle: 'success', type: 'submit', disabled: submitting || pristine },
	            _react2.default.createElement('em', { className: 'fa fa-save' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsStyle: 'danger', type: 'cancel', onClick: function onClick(event) {
	                event.preventDefault();closeShowCustomer();
	              } },
	            _react2.default.createElement('em', { className: 'fa fa-close' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	          )
	        ),
	        this.props.isCreating || this.props.isEditing && _react2.default.createElement(_spinner2.default, null),
	        this.props.createError && _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger marginTopStyle' },
	          JSON.stringify(this.props.createError)
	        ),
	        this.props.editError && _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger marginTopStyle' },
	          JSON.stringify(this.props.editError)
	        )
	      );
	    }
	  }]);
	
	  return CustomerInfo;
	}(_react.Component);
	
	var _default = CustomerInfo;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CustomerInfo, 'CustomerInfo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/customerInfo.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/customerInfo.jsx');
	}();

	;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxForm = __webpack_require__(3);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _filterByStart = __webpack_require__(68);
	
	var _filterByStart2 = _interopRequireDefault(_filterByStart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ESCAPE_KEY = 27;
	var ENTER_KEY = 13;
	
	var RowRenderer = function (_Component) {
	    _inherits(RowRenderer, _Component);
	
	    function RowRenderer() {
	        _classCallCheck(this, RowRenderer);
	
	        return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	    }
	
	    _createClass(RowRenderer, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { onDoubleClick: function onDoubleClick() {
	                        _this2.props.onDoubleClick(_this2.props.row);
	                    } },
	                _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	            );
	        }
	    }]);
	
	    return RowRenderer;
	}(_react.Component);
	
	var InventoryInfo = function (_Component2) {
	    _inherits(InventoryInfo, _Component2);
	
	    function InventoryInfo() {
	        _classCallCheck(this, InventoryInfo);
	
	        var _this3 = _possibleConstructorReturn(this, (InventoryInfo.__proto__ || Object.getPrototypeOf(InventoryInfo)).call(this));
	
	        _this3.state = {
	            rows: [],
	            sortColumn: null,
	            sortDirection: null,
	            clickedCell: { row: 0, column: -1 }
	        };
	        _this3.onCellSelected = _this3.onCellSelected.bind(_this3);
	        _this3.selectProduct = _this3.selectProduct.bind(_this3);
	        _this3.handleKeyDown = _this3.handleKeyDown.bind(_this3);
	        _this3.onKeyDown = _this3.onKeyDown.bind(_this3);
	        return _this3;
	    }
	
	    _createClass(InventoryInfo, [{
	        key: 'handleKeyDown',
	        value: function handleKeyDown(event) {
	            switch (event.keyCode) {
	                case ESCAPE_KEY:
	                    this.props.closeShowInventory('allProducts');
	                    break;
	                default:
	                    break;
	            }
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            document.addEventListener("keydown", this.handleKeyDown);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener("keydown", this.handleKeyDown);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.setAllProductQuantity(1);
	            if (this.props.searchForBatch) {
	                this.props.fetchReturnBatch(this.props.searchType, this.props.searchValue);
	            } else {
	                this.props.fetchSimplifiedProducts(this.props.searchType, this.props.searchValue);
	            }
	            _reactDom2.default.findDOMNode(this.refs["inventoryInfo"].refs.base.refs.viewPortContainer).focus();
	        }
	    }, {
	        key: 'handleFormSubmit',
	        value: function handleFormSubmit(formProps) {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.simplifiedProducts && nextProps.simplifiedProducts != this.props.simplifiedProducts) {
	                var rows = [].concat(_toConsumableArray(nextProps.simplifiedProducts));
	                this.setState({ rows: rows });
	            }
	        }
	
	        // componentDidUpdate(prevProps, prevState) {
	        //   if(prevProps.simplifiedProducts && prevProps.simplifiedProducts.length != 0 && prevProps.simplifiedProducts != this.props.simplifiedProducts) {
	        //     console.log(this.refs["inventoryInfo"], "2", prevProps.simplifiedProducts, this.props.simplifiedProducts )
	        //     ReactDOM.findDOMNode(this.refs["inventoryInfo"].refs.base.refs.viewPortContainer).focus();
	        //   }
	        //   // if( (!(prevProps.simplifiedProducts) || (prevProps.simplifiedProducts.length==0)) && this.props.simplifiedProducts && this.props.simplifiedProducts.length != 0) {
	        //   //   ReactDOM.findDOMNode(this.refs["inventoryInfo"].refs.base.refs.viewPortContainer).focus();
	        //   // }
	        // }
	
	    }, {
	        key: 'onCellSelected',
	        value: function onCellSelected(coordinates) {
	            var clickedCell = {
	                row: coordinates.rowIdx,
	                column: coordinates.idx - 1
	                // because there is a checkbox column makes this 1 indexed, convert it to 0 indexed here
	            };
	            this.setState({ clickedCell: clickedCell });
	        }
	    }, {
	        key: 'onKeyDown',
	        value: function onKeyDown(e) {
	            if (e.keyCode === ENTER_KEY) {
	                e.preventDefault();
	                var rows = this.state.rows;
	                var row = rows[this.state.clickedCell.row];
	                this.selectProduct(row);
	                // this.props.selectInventoryInfo(row);
	                // this.props.setAllProducts(`${row.ProductNum} | ${row.Name} | ${row.Description} | ${row.MeasureUnit}`, 'purchaseOrderForm');
	                // this.props.closeShowInventory('allProd_Quantity');
	            }
	        }
	    }, {
	        key: 'selectProduct',
	        value: function selectProduct(product) {
	            this.props.selectInventoryInfo(product);
	            this.props.setAllProducts(product.ProductNum + ' | ' + product.Name + ' | ' + product.Description + ' | ' + product.MeasureUnit, this.props.form);
	            this.props.closeShowInventory('allProd_Quantity');
	        }
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this4 = this;
	
	            if (this.props.simplifiedProductsIsLoading && !this.props.simplifiedProductsError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.simplifiedProductsError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.simplifiedProductsError)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this4.state);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this4.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this4.setState(state);
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    _this4.setState({ selectedRows: rows });
	                };
	
	                // const onKeyDown = (e) => {
	                //    if (e.keyCode === ENTER_KEY) {
	                //       e.preventDefault();
	                //       var rows = this.state.rows;
	                //       var row = rows[this.state.clickedCell.row];
	                //       this.selectProduct(row)
	                //       // this.props.selectInventoryInfo(row);
	                //       // this.props.setAllProducts(`${row.ProductNum} | ${row.Name} | ${row.Description} | ${row.MeasureUnit}`, 'purchaseOrderForm');
	                //       // this.props.closeShowInventory('allProd_Quantity');
	                //     }
	                // }
	
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80,
	                    filterRenderer: _filterByStart2.default
	                }, {
	                    key: 'RefNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 70,
	                    filterRenderer: _filterByStart2.default
	                }, {
	                    key: 'Name',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200
	                }, {
	                    key: 'Description',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	                    resizable: true,
	                    sortable: true
	                }, {
	                    key: 'ProductCost',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 70
	                }, {
	                    key: 'MeasureUnit',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true
	                }, {
	                    key: 'PackageType',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 70
	                }, {
	                    key: 'InStock',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'instock' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80
	                }, {
	                    key: 'Purchased',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchased' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100
	                }, {
	                    key: 'PreSale',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'presale' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'InventoryInfo-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                ref: 'inventoryInfo',
	                                rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: this.selectProduct }),
	                                rowKey: 'Product_id',
	                                rowHeight: 25,
	                                minHeight: 600,
	                                onGridSort: handleGridSort,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                enableCellSelect: true,
	                                onGridKeyDown: this.onKeyDown,
	                                onCellSelected: this.onCellSelected
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                this.renderTable()
	            );
	        }
	    }]);
	
	    return InventoryInfo;
	}(_react.Component);
	
	var _default = InventoryInfo;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(ESCAPE_KEY, 'ESCAPE_KEY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/inventoryInfo.jsx');
	
	    __REACT_HOT_LOADER__.register(ENTER_KEY, 'ENTER_KEY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/inventoryInfo.jsx');
	
	    __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/inventoryInfo.jsx');
	
	    __REACT_HOT_LOADER__.register(InventoryInfo, 'InventoryInfo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/inventoryInfo.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/inventoryInfo.jsx');
	}();

	;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactChartjs = __webpack_require__(102);
	
	var _reduxForm = __webpack_require__(3);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _inputField = __webpack_require__(16);
	
	var _DisplayDataGrid = __webpack_require__(251);
	
	var _DisplayDataGrid2 = _interopRequireDefault(_DisplayDataGrid);
	
	var _priceFormatter = __webpack_require__(56);
	
	var _priceFormatter2 = _interopRequireDefault(_priceFormatter);
	
	var _root_url = __webpack_require__(9);
	
	var _numberWithCommas = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEcity = _root_url.ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/';
	
	var RowRenderer = function (_Component) {
	  _inherits(RowRenderer, _Component);
	
	  function RowRenderer() {
	    _classCallCheck(this, RowRenderer);
	
	    return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(RowRenderer, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // here we are just changing the style
	      // but we could replace this with anything we liked, cards, images, etc
	      // usually though it will just be a matter of wrapping a div, and then calling back through to the grid
	      return _react2.default.createElement(
	        'div',
	        { onDoubleClick: function onDoubleClick() {
	            _this2.props.onDoubleClick(_this2.props.row);
	          } },
	        _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	      );
	    }
	  }]);
	
	  return RowRenderer;
	}(_react.Component);
	
	RowRenderer.PropTypes = {
	  onDoubleClick: _react2.default.PropTypes.func
	};
	
	var PresidentDashboard = function (_Component2) {
	  _inherits(PresidentDashboard, _Component2);
	
	  function PresidentDashboard() {
	    _classCallCheck(this, PresidentDashboard);
	
	    var _this3 = _possibleConstructorReturn(this, (PresidentDashboard.__proto__ || Object.getPrototypeOf(PresidentDashboard)).call(this));
	
	    _this3.renderPresidentSalesInfo = function () {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'sales-order-data-grid' },
	          _react2.default.createElement(_DisplayDataGrid2.default, {
	            columns: SalesOrderColumns,
	            rows: _this3.state.salesOrderRows,
	            minHeight: 76,
	            rowHeight: 25
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'mobile-sales-order-data-grid' },
	          _react2.default.createElement(_DisplayDataGrid2.default, {
	            columns: MobileSalesOrderColumns,
	            rows: _this3.state.mobileSalesOrderRows,
	            minHeight: 76,
	            rowHeight: 25
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pos-sales-order-data-grid' },
	          _react2.default.createElement(_DisplayDataGrid2.default, {
	            columns: POSOrderColumns,
	            rows: _this3.state.posOrderRows,
	            minHeight: 76,
	            rowHeight: 25
	          })
	        )
	      );
	    };
	
	    _this3.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.presidentDashboard,
	
	      customers: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      // Data input for OverallPerformance
	      overallPerformance: {},
	
	      // Data input for PurchasePerformance
	      salesPerformance: {},
	
	      purchaseOrderRows: [],
	      salesOrderRows: [],
	      mobileSalesOrderRows: [],
	      posOrderRows: [],
	      apReportRows: [],
	      arReportRows: [],
	      consolodatedStatisticsDate: new Date(),
	      fromStatisticsDate: new Date(),
	      toStatisticsDate: new Date()
	    };
	
	    _this3.handleResize = _this3.handleResize.bind(_this3);
	    return _this3;
	  }
	
	  _createClass(PresidentDashboard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this4 = this;
	
	      document.title = _root_url.companyCodeTitle;
	      window.addEventListener('resize', this.handleResize);
	      this.props.fetchCustomersStatus();
	      // this.props.fetchPurchaseTotals('user', 'daily');
	      this.props.fetchSalesTotals('weekly');
	      this.props.fetchPresidentDashInfo();
	      this.props.fetchConsolidatedStatistics(new Date());
	      this.props.fetchCustomerStatementList('Active', _moment2.default.utc().toISOString());
	      this.props.fetchVendorStatementList('Active', (0, _moment2.default)().format('YYYY-MM-DD'));
	      this.props.fetchOverallPurchasePerformance('weekly').then(function () {
	        _this4.props.fetchOverallSalesPerformance('weekly');
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this5 = this;
	
	      if (nextProps.customersStatuses && nextProps.customersStatuses != this.props.customersStatuses) {
	        var customers = _extends({}, this.state.customers, { rows: nextProps.customersStatuses });
	        this.setState({ customers: customers });
	      }
	
	      if (nextProps.OverallPeriod && nextProps.OverallPeriod != this.props.OverallPeriod) {
	        if (nextProps.OverallPeriod == 'monthly') {
	          this.props.fetchOverallPurchasePerformance('monthly').then(function () {
	            _this5.props.fetchOverallSalesPerformance('monthly');
	          });
	        } else {
	          this.props.fetchOverallPurchasePerformance('weekly').then(function () {
	            _this5.props.fetchOverallSalesPerformance('weekly');
	          });
	        }
	      }
	
	      if (nextProps.SalesPeriod && nextProps.SalesPeriod != this.props.SalesPeriod) {
	        if (nextProps.SalesPeriod == 'week') {
	          this.props.fetchSalesTotals('weekly');
	        } else {
	          this.props.fetchSalesTotals('monthly');
	        }
	      }
	
	      if (nextProps.salesTotals && nextProps.salesTotals != this.props.salesTotals) {
	        var months = [0, 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	        var salesTotals = new Sales();
	        nextProps.salesTotals.forEach(function (record) {
	          if (_this5.props.SalesPeriod == 'month') {
	            salesTotals.labels.push(months[record.Month]);
	          } else {
	            salesTotals.labels.push(record.Day);
	          }
	
	          salesTotals.datasets[0].data.push(record.TotalCost);
	          salesTotals.datasets[1].data.push(record.TotalSales);
	          // salesTotals.datasets[2].data.push(record.POS);
	        });
	        this.setState({ salesPerformance: salesTotals });
	      }
	
	      if (nextProps.overallPurchases && nextProps.overallPurchases != this.props.overallPurchases) {
	        var overallPerformance = new Performance();
	        var _months = [0, 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	        nextProps.overallPurchases.forEach(function (record) {
	          if (_this5.props.OverallPeriod == 'monthly') {
	            overallPerformance.labels.push(_months[record.Month]);
	          } else {
	            overallPerformance.labels.push(record.Day);
	          }
	          if (record.TotalPurchases == null) {
	            overallPerformance.datasets[0].data.push(0);
	          } else {
	            overallPerformance.datasets[0].data.push(record.TotalPurchases);
	          }
	        });
	        this.setState({ overallPerformanceTemp: overallPerformance });
	      }
	
	      if (nextProps.overallSales && nextProps.overallSales != this.props.overallSales && nextProps.overallSales.length !== 0) {
	        var _overallPerformance = _extends({}, this.state.overallPerformanceTemp);
	        nextProps.overallSales.forEach(function (record) {
	          if (record.TotalSales == null) {
	            _overallPerformance.datasets[1].data.push(0);
	          } else {
	            _overallPerformance.datasets[1].data.push(record.TotalSales);
	          }
	        });
	        this.setState({ overallPerformance: _overallPerformance });
	      }
	
	      // if (nextProps.presidentInfo && nextProps.presidentInfo != this.props.presidentInfo) {
	      //     let presidentInfo =
	      // }
	
	      if (nextProps.consolodatedStatistics && nextProps.consolodatedStatistics !== this.props.consolodatedStatistics) {
	        this.setState({
	          purchaseOrderRows: nextProps.consolodatedStatistics.Purchase_Order,
	          salesOrderRows: nextProps.consolodatedStatistics.Sales_Order,
	          mobileSalesOrderRows: nextProps.consolodatedStatistics.Mobile_Sales_Order,
	          posOrderRows: nextProps.consolodatedStatistics.POS_Order,
	          totalPurchasePrice: nextProps.consolodatedStatistics.Purchase_Total_Final_Price,
	          totalSalesPrice: nextProps.consolodatedStatistics.Sales_Total_Final_Price
	        });
	      }
	
	      if (nextProps.customerStatementList && nextProps.customerStatementList !== this.props.customerStatementList) {
	        var _nextProps$customerSt = nextProps.customerStatementList,
	            statement_lines = _nextProps$customerSt.statement_lines,
	            amount00_07 = _nextProps$customerSt.amount00_07,
	            amount08_30 = _nextProps$customerSt.amount08_30,
	            amount00_30 = _nextProps$customerSt.amount00_30,
	            amount31_60 = _nextProps$customerSt.amount31_60,
	            amount61_90 = _nextProps$customerSt.amount61_90,
	            amount_91 = _nextProps$customerSt.amount_91,
	            current = _nextProps$customerSt.current,
	            grand_amount = _nextProps$customerSt.grand_amount;
	
	
	        this.setState({
	          arReportRows: statement_lines,
	          amount00_07: parseFloat(amount00_07 || 0).toFixed(2),
	          amount08_30: parseFloat(amount08_30 || 0).toFixed(2),
	          amount00_30: parseFloat(amount00_30 || 0).toFixed(2),
	          amount31_60: parseFloat(amount31_60 || 0).toFixed(2),
	          amount61_90: parseFloat(amount61_90 || 0).toFixed(2),
	          amount_91: parseFloat(amount_91 || 0).toFixed(2),
	          current: parseFloat(current || 0).toFixed(2),
	          grand_amount: parseFloat(grand_amount || 0).toFixed(2)
	        });
	      }
	
	      if (nextProps.vendorStatementList && nextProps.vendorStatementList !== this.props.vendorStatementList) {
	        var _nextProps$vendorStat = nextProps.vendorStatementList,
	            _statement_lines = _nextProps$vendorStat.statement_lines,
	            _amount00_ = _nextProps$vendorStat.amount00_30,
	            _amount31_ = _nextProps$vendorStat.amount31_60,
	            _amount61_ = _nextProps$vendorStat.amount61_90,
	            _amount_ = _nextProps$vendorStat.amount_91,
	            _current = _nextProps$vendorStat.current,
	            _grand_amount = _nextProps$vendorStat.grand_amount;
	
	
	        this.setState({
	          apReportRows: _statement_lines,
	          apAmount00_30: parseFloat(_amount00_).toFixed(2) || 0,
	          apAmount31_60: parseFloat(_amount31_).toFixed(2) || 0,
	          apAmount61_90: parseFloat(_amount61_).toFixed(2) || 0,
	          apAmount_91: parseFloat(_amount_).toFixed(2) || 0,
	          apCurrent: parseFloat(_current).toFixed(2) || 0,
	          apGrand_amount: parseFloat(_grand_amount).toFixed(2) || 0
	        });
	      }
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.presidentDashboard });
	    }
	  }, {
	    key: 'renderPresidentPurchasingInfo',
	    value: function renderPresidentPurchasingInfo() {
	      if (this.props.presidentInfoIsLoading && !this.props.presidentInfoError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.presidentInfoError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.presidentInfoError)
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'purchasingDataGrid' },
	          _react2.default.createElement(_DisplayDataGrid2.default, {
	            id: 'testing-if-id-actually-works',
	            className: '123123',
	            columns: PurchaseOrderColumns,
	            rows: this.state.purchaseOrderRows,
	            minHeight: 76,
	            rowHeight: 25
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this6 = this;
	
	      if (this.props.customerStatementListIsLoading && !this.props.customerStatementListError) {
	        return _react2.default.createElement(
	          'div',
	          { id: 'spinner' },
	          _react2.default.createElement(_spinner2.default, null)
	        );
	      } else if (this.props.customerStatementListError) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'something_unexpected_happened' })
	        );
	      }
	
	      // Parameters of the react-data-grid
	
	      var tableHeight = window.innerHeight < 930 ? 510 : 510;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this6.state);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var lines = Object.assign({}, _this6.state.statementLines, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this6.setState({ statementLines: lines });
	      };
	
	      // Custom Formatter component
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	            var date = new Date(this.props.value);
	            var index = dateMap.indexOf(date.toString().slice(4, 3));
	            var localDate = index + date.toString().slice(8, 6);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      // Column difinition
	
	      var columns = [{
	        key: 'CustomerNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_num' }),
	        resizable: true,
	        sortable: true,
	        width: 120
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 110
	      },
	      // {
	      //     key: 'current',
	      //     name: <Translate value="current" />,
	      //     resizable: true,
	      //     sortable: true,
	      //     width: 80,
	      //     formatter: PriceFormatter,
	      // },
	      {
	        key: 'amount00_30',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '00_dashsign_30_days' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        formatter: _priceFormatter2.default
	      }, {
	        key: 'amount31_60',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '31_dashsign_60_days' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        formatter: _priceFormatter2.default
	      }, {
	        key: 'amount61_90',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '61_dashsign_90_days' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        formatter: _priceFormatter2.default
	      }, {
	        key: 'amount_91',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '91_plussign_days' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        formatter: _priceFormatter2.default
	      }, {
	        key: 'total_amount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_amount' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: _priceFormatter2.default
	      }];
	
	      if (isEcity) {
	        var arPeriod = _.findIndex(columns, { key: 'amount00_30' });
	        var estColum1 = {
	          key: 'amount00_07',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '00_dashsign_07_days' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          formatter: _priceFormatter2.default
	        };
	        var estColum2 = {
	          key: 'amount08_30',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '08_dashsign_30_days' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          formatter: _priceFormatter2.default
	        };
	        columns.splice(arPeriod, 1, estColum1);
	        columns.splice(arPeriod + 1, 0, estColum2);
	      }
	
	      // React Table Purchase Order Full Table
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        !isEcity && _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 4 },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-6 text-align-right' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: '00_dashsign_30_days' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 6 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'amount00_30', component: _inputField.DisabledInputField, placeholder: !isNaN(this.state.amount00_30) && '$' + (0, _numberWithCommas.numberWithCommas)(this.state.amount00_30) })
	          )
	        ),
	        isEcity && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-6 text-align-right' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: '00_dashsign_07_days' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'amount00_07', component: _inputField.DisabledInputField, placeholder: !isNaN(this.state.amount00_07) && '$' + (0, _numberWithCommas.numberWithCommas)(this.state.amount00_07) })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-6 text-align-right' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: '08_dashsign_30_days' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'amount08_30', component: _inputField.DisabledInputField, placeholder: !isNaN(this.state.amount08_30) && '$' + (0, _numberWithCommas.numberWithCommas)(this.state.amount08_30) })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 4 },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-6 text-align-right' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: '31_dashsign_60_days' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 6 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'amount31_60', component: _inputField.DisabledInputField, placeholder: !isNaN(this.state.amount31_60) && '$' + (0, _numberWithCommas.numberWithCommas)(this.state.amount31_60) })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 4 },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-6 text-align-right' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: '61_dashsign_90_days' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 6 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'amount61_90', component: _inputField.DisabledInputField, placeholder: !isNaN(this.state.amount61_90) && '$' + (0, _numberWithCommas.numberWithCommas)(this.state.amount61_90) })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 4 },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-6 text-align-right' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: '91_plussign_days' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 6 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'amount_91', component: _inputField.DisabledInputField, placeholder: !isNaN(this.state.amount_91) && '$' + (0, _numberWithCommas.numberWithCommas)(this.state.amount_91) })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 4 },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-6 text-align-right' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'grand_total' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 6 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'grand_amount', component: _inputField.DisabledInputField, placeholder: !isNaN(this.state.grand_amount) && '$' + (0, _numberWithCommas.numberWithCommas)(this.state.grand_amount) })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12, style: { paddingTop: '6px' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'react-table-ar-ap-customer-list-statement', id: 'PresidentDashboard-dataGrid1' },
	            _react2.default.createElement(_DisplayDataGrid2.default, {
	              columns: columns,
	              rows: this.state.arReportRows,
	              rowHeight: 25,
	              headerRowHeight: 45,
	              minHeight: 420
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderExportButton',
	    value: function renderExportButton() {
	      var exportUrl = _root_url.ROOT_URL + 'v1/dashboard/agingdetails/export/?Bearer=' + localStorage.getItem('token');
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 2, smOffset: 10, className: 'export-to-excel' },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'success',
	              className: 'pull-right',
	              href: exportUrl
	            },
	            _react2.default.createElement('em', { className: 'fa fa-download' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderIncomeExpenseGraph',
	    value: function renderIncomeExpenseGraph() {
	      return _react2.default.createElement(_reactChartjs.Bar, { data: this.state.overallPerformance, height: 200, width: 300, options: {
	          maintainAspectRatio: false,
	          scales: {
	            yAxes: [{
	              ticks: {
	                beginAtZero: true
	              }
	            }]
	          }
	        } });
	    }
	  }, {
	    key: 'renderSalesPerformanceGraph',
	    value: function renderSalesPerformanceGraph() {
	      return _react2.default.createElement(_reactChartjs.Bar, { data: this.state.salesPerformance, height: 200, width: 300, options: {
	          maintainAspectRatio: false,
	          scales: {
	            yAxes: [{
	              ticks: {
	                beginAtZero: true
	              }
	            }]
	          }
	        } });
	    }
	  }, {
	    key: 'handleStatisticsDateRange',
	    value: function handleStatisticsDateRange(fromDate, toDate) {
	      var _state = this.state,
	          fromStatisticsDate = _state.fromStatisticsDate,
	          toStatisticsDate = _state.toStatisticsDate;
	
	      if (fromDate) {
	        if (toStatisticsDate && Date.parse(fromDate) <= Date.parse(toStatisticsDate)) {
	          this.setState({ fromStatisticsDate: fromDate });
	          this.props.fetchConsolidatedStatistics(fromDate, toStatisticsDate);
	        } else {
	          this.setState({ fromStatisticsDate: fromDate, toStatisticsDate: null });
	        }
	      }
	      if (toDate) {
	        if (fromStatisticsDate && Date.parse(toDate) >= Date.parse(fromStatisticsDate)) {
	          this.setState({ toStatisticsDate: toDate });
	          this.props.fetchConsolidatedStatistics(fromStatisticsDate, toDate);
	        } else {
	          this.setState({ toStatisticsDate: toDate, fromStatisticsDate: null });
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var header = _react2.default.createElement(
	        'h1',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'finance_performance' })
	      );
	
	      var height = (this.state.tableHeight / 2 + 10).toString();
	      var tableCollapseFix = { height: 550 };
	      var tableCollapseFixFirstRow = { height: 300 };
	      var lineData = {
	        labels: ['January', 'February', 'March', 'April'],
	        datasets: [{
	          label: 'My First dataset',
	          backgroundColor: ['rgba(255, 99, 132, 0.2)', 'rgba(54, 162, 235, 0.2)', 'rgba(255, 206, 86, 0.2)', 'rgba(75, 192, 192, 0.2)'],
	          borderColor: ['rgba(255,99,132,1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgba(75, 192, 192, 1)'],
	          data: [65, 59, 80, 81]
	        }, {
	          label: 'My Second dataset',
	          backgroundColor: ['rgba(255, 99, 132, 0.2)', 'rgba(54, 162, 235, 0.2)', 'rgba(255, 206, 86, 0.2)', 'rgba(75, 192, 192, 0.2)'],
	          borderColor: ['rgba(255,99,132,1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgba(75, 192, 192, 1)'],
	          data: [28, 48, 40, 19]
	        }]
	      };
	
	      var data = {
	        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
	        datasets: [{
	          label: 'Cost',
	          backgroundColor: 'rgba(255,99,132,0.2)',
	          borderColor: 'rgba(255,99,132,1)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgba(255,99,132,0.4)',
	          hoverBorderColor: 'rgba(255,99,132,1)',
	          data: [65, 59, 80, 81, 56, 55, 40]
	        }, {
	          label: 'Sale',
	          backgroundColor: 'rgba(151,187,205,0.2)',
	          borderColor: 'rgba(151,187,205,1)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgba(151,187,205,0.4)',
	          hoverBorderColor: 'rgba(151,187,205,1)',
	          data: [12, 34, 65, 72, 28, 31, 30]
	        }]
	      };
	
	      var stackedOptions = {
	        maintainAspectRatio: false,
	        scales: {
	          xAxes: [{
	            stacked: true
	          }],
	          yAxes: [{
	            stacked: true
	          }]
	        }
	      };
	
	      var options = {
	        scales: {
	          xAxes: [{
	            stacked: false
	          }],
	          yAxes: [{
	            stacked: false
	          }]
	        }
	      };
	
	      var incomeExpensePanelHeader = _react2.default.createElement(
	        'h4',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_sales' })
	      );
	      var salesPerformancePanelHeader = _react2.default.createElement(
	        'h4',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoiced_cost' })
	      );
	      var arStatisticsHeader = _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'h4',
	            { className: 'statistics-header' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_statistics' })
	          )
	        )
	      );
	      var apStatisticsHeader = _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'h4',
	            { className: 'statistics-header' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ap_statistics' })
	          )
	        )
	      );
	      var infoPurchaseSalesPanelHeader = _react2.default.createElement(
	        _reactBootstrap.Row,
	        { style: { margin: '0' } },
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 6, style: { paddingRight: '0px' } },
	          _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_count_overview' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 3, style: { paddingLeft: '0px', paddingRight: '2px' } },
	          _react2.default.createElement(_DateTimePicker2.default, {
	            id: 'fromStatisticsDate',
	            format: 'MM-DD-YY',
	            time: false,
	            onChange: function onChange(e) {
	              _this7.handleStatisticsDateRange(e, null);
	            },
	            value: this.state.fromStatisticsDate
	          })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 3, style: { paddingRight: '0px', paddingLeft: '2px' } },
	          _react2.default.createElement(_DateTimePicker2.default, {
	            id: 'toStatisticsDate',
	            format: 'MM-DD-YY',
	            time: false,
	            onChange: function onChange(e) {
	              _this7.handleStatisticsDateRange(null, e);
	            },
	            value: this.state.toStatisticsDate
	          })
	        )
	      );
	      var infoPurchasePanelHeader = _react2.default.createElement(
	        _reactBootstrap.Row,
	        { style: { margin: '0' } },
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 3 },
	          _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchasing' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 9 },
	          _react2.default.createElement(
	            'h2',
	            { className: 'totals pull-right' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_receive_price' }),
	            ' ',
	            _react2.default.createElement(
	              'span',
	              { className: 'total-price-label' },
	              '$',
	              !isNaN(this.state.totalPurchasePrice) && (0, _numberWithCommas.numberWithCommas)(this.state.totalPurchasePrice)
	            )
	          )
	        )
	      );
	
	      var infoSalesPanelHeader = _react2.default.createElement(
	        _reactBootstrap.Row,
	        { style: { margin: '0' } },
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 6 },
	          _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 6 },
	          _react2.default.createElement(
	            'h2',
	            { className: 'totals pull-right' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_sales_price' }),
	            ' ',
	            _react2.default.createElement(
	              'span',
	              { className: 'total-sales-label' },
	              '$',
	              !isNaN(this.state.totalSalesPrice) && (0, _numberWithCommas.numberWithCommas)(this.state.totalSalesPrice)
	            )
	          )
	        )
	      );
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'president_dashboard' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'president-dashboard', fluid: 'true' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6, className: '' },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { header: incomeExpensePanelHeader, className: 'income-expense-chart', style: tableCollapseFixFirstRow },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 4, smOffset: 4 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'OverallPeriod', component: renderRadiosLongPeriod })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    null,
	                    this.renderIncomeExpenseGraph()
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6, className: '' },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { header: salesPerformancePanelHeader, className: 'income-expense-chart', style: tableCollapseFixFirstRow },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 4, smOffset: 4 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'SalesPeriod', component: renderRadiosShortPeriod })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    null,
	                    this.renderSalesPerformanceGraph()
	                  )
	                )
	              )
	            ),
	            ' ',
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(
	                  _reactBootstrap.Tabs,
	                  { defaultActiveKey: 1, justified: true, className: 'report-tabs' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Tab,
	                    { eventKey: 1, title: arStatisticsHeader, id: 'ar-tab' },
	                    this.renderTable()
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Tab,
	                    { eventKey: 2, title: apStatisticsHeader, id: 'ar-tab' },
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 4 },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'col-xs-6 text-align-right' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: '00_dashsign_30_days' })
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'apAmount00_30', component: _inputField.DisabledInputField, placeholder: !isNaN(this.state.apAmount00_30) && '$' + (0, _numberWithCommas.numberWithCommas)(this.state.apAmount00_30) })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 4 },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'col-xs-6 text-align-right' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: '31_dashsign_60_days' })
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'apAmount31_60', component: _inputField.DisabledInputField, placeholder: !isNaN(this.state.apAmount31_60) && '$' + (0, _numberWithCommas.numberWithCommas)(this.state.apAmount31_60) })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 4 },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'col-xs-6 text-align-right' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: '61_dashsign_90_days' })
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'apAmount61_90', component: _inputField.DisabledInputField, placeholder: !isNaN(this.state.apAmount61_90) && '$' + (0, _numberWithCommas.numberWithCommas)(this.state.apAmount61_90) })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 4 },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'col-xs-6 text-align-right' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: '91_plussign_days' })
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'apAmount_91', component: _inputField.DisabledInputField, placeholder: !isNaN(this.state.apAmount_91) && '$' + (0, _numberWithCommas.numberWithCommas)(this.state.apAmount_91) })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 4 },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'col-xs-6 text-align-right' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'grand_total' })
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'apGrand_amount', component: _inputField.DisabledInputField, placeholder: !isNaN(this.state.apGrand_amount) && '$' + (0, _numberWithCommas.numberWithCommas)(this.state.apGrand_amount) })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12, style: { paddingTop: '6px' } },
	                          _react2.default.createElement(_DisplayDataGrid2.default, {
	                            columns: APReportColumns,
	                            rows: this.state.apReportRows,
	                            rowHeight: 25,
	                            headerRowHeight: 45,
	                            minHeight: 420
	                          })
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { header: infoPurchaseSalesPanelHeader, className: 'president-purchase-info' },
	                  infoPurchasePanelHeader,
	                  this.renderPresidentPurchasingInfo(),
	                  infoSalesPanelHeader,
	                  this.renderPresidentSalesInfo(),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { lineHeight: '.8em' } },
	                    _react2.default.createElement(
	                      'span',
	                      { style: { fontSize: "9pt", display: 'inline-block' } },
	                      '* Total Final Price = Total Sales + Store Credit - Voided'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                      'span',
	                      { style: { fontSize: "9pt", display: 'inline-block' } },
	                      '* Total Sales Price = Sales Order + Mobile Sales Order + POS Order'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                      'span',
	                      { style: { fontSize: "9pt", display: 'inline-block' } },
	                      '* Total Invoiced = SO Invoiced + MSO Invoiced + POS Receipt'
	                    )
	                  )
	                )
	              )
	            ),
	            ' '
	          )
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return PresidentDashboard;
	}(_react.Component);
	
	PresidentDashboard.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = PresidentDashboard;
	exports.default = _default;
	
	
	var renderRadiosLongPeriod = function renderRadiosLongPeriod(props) {
	  var titleClass = (0, _classnames2.default)({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'control-label', 'col-sm-3', 'centerStyle');
	  return _react2.default.createElement(
	    'div',
	    { className: 'optionStyle' },
	    _react2.default.createElement(
	      _reactBootstrap.Row,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 6 },
	        _react2.default.createElement(
	          'label',
	          { className: 'radio-inline' },
	          _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { type: 'radio', value: 'weekly', checked: props.input.value == 'weekly' || props.input.value == '' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Weekly' })
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 6 },
	        _react2.default.createElement(
	          'label',
	          { className: 'radio-inline' },
	          _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { type: 'radio', value: 'monthly', checked: props.input.value == 'monthly' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Monthly' })
	        )
	      )
	    )
	  );
	};
	
	var renderRadiosShortPeriod = function renderRadiosShortPeriod(props) {
	  var titleClass = (0, _classnames2.default)({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'control-label', 'col-sm-3', 'centerStyle');
	  return _react2.default.createElement(
	    'div',
	    { className: 'optionStyle' },
	    _react2.default.createElement(
	      _reactBootstrap.Row,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 6 },
	        _react2.default.createElement(
	          'label',
	          { className: 'radio-inline' },
	          _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { type: 'radio', value: 'week', checked: props.input.value == 'week' || props.input.value == '' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Weekly' })
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 6 },
	        _react2.default.createElement(
	          'label',
	          { className: 'radio-inline' },
	          _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { type: 'radio', value: 'month', checked: props.input.value == 'month' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Monthly' })
	        )
	      )
	    )
	  );
	};
	
	// INCOMPLETE: HERE LIES CODE FOR SALES PERFORMANCE IMPLEMENTATION
	
	// <div>
	//   <Translate value="sales_performance" /><Field name="SalesPeriod" component={ renderRadiosShortPeriod } />
	//   <Bar data={data} height={175} options={{ maintainAspectRatio: false }}/>
	// </div>
	
	function Sales() {
	  this.labels = [], this.datasets = [
	  // {
	  //   label: 'MSO',
	  //   backgroundColor: 'rgba(33, 150, 243, 0.4)',
	  //   borderColor: 'rgba(33, 150, 243, 1)',
	  //   borderWidth: 1,
	  //   hoverBackgroundColor: 'rgba(33, 150, 243, 0.4)',
	  //   hoverBorderColor: 'rgba(33, 150, 243, 1)',
	  //   data: [],
	  // },
	  {
	    label: 'Total Cost',
	    backgroundColor: 'rgba(255,99,132,0.6)',
	    borderColor: 'rgba(255,99,133,1)',
	    borderWidth: 1,
	    hoverBackgroundColor: 'rgba(255,99,133,0.8)',
	    hoverBorderColor: 'rgba(255,99,133,1)',
	    data: []
	  }, {
	    label: 'Total Invoiced',
	    backgroundColor: 'rgba(20, 92, 169, 0.4)',
	    borderColor: 'rgba(20, 92, 169, 1)',
	    borderWidth: 1,
	    hoverBackgroundColor: 'rgba(20, 92, 169, 0.6)',
	    hoverBorderColor: 'rgba(20, 92, 169, 1)',
	    data: []
	  }];
	}
	
	function Performance() {
	  this.labels = [], this.datasets = [{
	    label: 'Total Received',
	    backgroundColor: 'rgba(255,99,132,0.6)',
	    borderColor: 'rgba(255,99,133,1)',
	    borderWidth: 1,
	    hoverBackgroundColor: 'rgba(255,99,133,0.8)',
	    hoverBorderColor: 'rgba(255,99,133,1)',
	    data: []
	  }, {
	    label: 'Total Invoiced',
	    backgroundColor: 'rgba(20, 92, 169, 0.4)',
	    borderColor: 'rgba(20, 92, 169, 1)',
	    borderWidth: 1,
	    hoverBackgroundColor: 'rgba(20, 92, 169, 0.6)',
	    hoverBorderColor: 'rgba(20, 92, 169, 1)',
	    data: []
	  }];
	}
	
	var NameFormatter = _react2.default.createClass({
	  displayName: 'NameFormatter',
	  render: function render() {
	    if (this.props.value) return _react2.default.createElement(_reactReduxI18n.Translate, { value: '' + this.props.value });
	    return _react2.default.createElement(
	      'span',
	      { className: 'label label-danger' },
	      '-'
	    );
	  }
	});
	
	var PurchaseOrderColumns = [{
	  key: 'Name',
	  name: 'PO',
	  resizable: false,
	  width: 120,
	  formatter: NameFormatter
	}, {
	  key: 'Total',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order' }),
	  resizable: true
	}, {
	  key: 'Placed',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'placed' }),
	  resizable: true
	}, {
	  key: 'Received',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'received' }),
	  resizable: true
	}, {
	  key: 'Cancelled',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'void' }),
	  resizable: true
	}];
	
	var SalesOrderColumns = [{
	  key: 'Name',
	  name: 'SO',
	  resizable: false,
	  formatter: NameFormatter,
	  width: 120
	}, {
	  key: 'Total',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order' }),
	  resizable: true
	}, {
	  key: 'Open',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'open' }),
	  resizable: true
	}, {
	  key: 'Packing',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'packing' }),
	  resizable: true
	}, {
	  key: 'Released',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoiced' }),
	  resizable: true
	}, {
	  key: 'Finalized',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'margin' }),
	  resizable: true
	}, {
	  key: 'Cancelled',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'void' }),
	  resizable: true,
	  width: 90
	}];
	
	var MobileSalesOrderColumns = [{
	  key: 'Name',
	  name: 'MSO',
	  resizable: false,
	  width: 120,
	  formatter: NameFormatter
	}, {
	  key: 'Total',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order' }),
	  resizable: true
	}, {
	  key: 'Open',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'open' }),
	  resizable: true
	}, {
	  key: 'Packing',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'packing' }),
	  resizable: true
	}, {
	  key: 'Released',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoiced' }),
	  resizable: true
	}, {
	  key: 'Finalized',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'margin' }),
	  resizable: true
	}, {
	  key: 'Cancelled',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'void' }),
	  resizable: true,
	  width: 90
	}];
	
	var POSOrderColumns = [{
	  key: 'Name',
	  name: 'POS',
	  resizable: false,
	  width: 120,
	  formatter: NameFormatter
	}, {
	  key: 'Total',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order' }),
	  resizable: true
	}, {
	  key: 'Receipt',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receipt' }),
	  resizable: true
	}, {
	  key: 'Hold',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'hold' }),
	  resizable: true
	}, {
	  key: "Margin",
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'margin' }),
	  resizable: true
	}, {
	  key: 'Void',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'void' }),
	  resizable: true
	}];
	
	var APReportColumns = [{
	  key: 'VendorNum',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_num' }),
	  resizable: true,
	  sortable: true,
	  width: 120
	}, {
	  key: 'Name',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_name' }),
	  resizable: true,
	  sortable: true,
	  width: 200
	}, {
	  key: 'Description',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	  resizable: true,
	  sortable: true,
	  width: 110
	},
	/*{
	    key: 'current',
	    name: <Translate value="current" />,
	    resizable: true,
	    sortable: true,
	    width: 80,
	    formatter: PriceFormatter,
	}, */
	{
	  key: 'amount00_30',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '00_dashsign_30_days' }),
	  resizable: true,
	  sortable: true,
	  width: 80,
	  formatter: _priceFormatter2.default
	}, {
	  key: 'amount31_60',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '31_dashsign_60_days' }),
	  resizable: true,
	  sortable: true,
	  width: 80,
	  formatter: _priceFormatter2.default
	}, {
	  key: 'amount61_90',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '61_dashsign_90_days' }),
	  resizable: true,
	  sortable: true,
	  width: 80,
	  formatter: _priceFormatter2.default
	}, {
	  key: 'amount_91',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '91_plussign_days' }),
	  resizable: true,
	  sortable: true,
	  width: 80,
	  formatter: _priceFormatter2.default
	}, {
	  key: 'total_amount',
	  name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_amount' }),
	  resizable: true,
	  sortable: true,
	  width: 100,
	  formatter: _priceFormatter2.default
	}];
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(renderRadiosLongPeriod, 'renderRadiosLongPeriod', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/presidentDashboard.jsx');
	
	  __REACT_HOT_LOADER__.register(renderRadiosShortPeriod, 'renderRadiosShortPeriod', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/presidentDashboard.jsx');
	
	  __REACT_HOT_LOADER__.register(Sales, 'Sales', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/presidentDashboard.jsx');
	
	  __REACT_HOT_LOADER__.register(Performance, 'Performance', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/presidentDashboard.jsx');
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/presidentDashboard.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/presidentDashboard.jsx');
	
	  __REACT_HOT_LOADER__.register(PresidentDashboard, 'PresidentDashboard', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/presidentDashboard.jsx');
	
	  __REACT_HOT_LOADER__.register(NameFormatter, 'NameFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/presidentDashboard.jsx');
	
	  __REACT_HOT_LOADER__.register(PurchaseOrderColumns, 'PurchaseOrderColumns', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/presidentDashboard.jsx');
	
	  __REACT_HOT_LOADER__.register(SalesOrderColumns, 'SalesOrderColumns', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/presidentDashboard.jsx');
	
	  __REACT_HOT_LOADER__.register(MobileSalesOrderColumns, 'MobileSalesOrderColumns', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/presidentDashboard.jsx');
	
	  __REACT_HOT_LOADER__.register(POSOrderColumns, 'POSOrderColumns', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/presidentDashboard.jsx');
	
	  __REACT_HOT_LOADER__.register(APReportColumns, 'APReportColumns', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/presidentDashboard.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/presidentDashboard.jsx');
	}();

	;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _calendar = __webpack_require__(155);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _vitCalendar = __webpack_require__(319);
	
	var _vitCalendar2 = _interopRequireDefault(_vitCalendar);
	
	var _cleanDates = __webpack_require__(22);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PriceAdjustmentReport = function (_Component) {
	  _inherits(PriceAdjustmentReport, _Component);
	
	  function PriceAdjustmentReport() {
	    _classCallCheck(this, PriceAdjustmentReport);
	
	    var _this = _possibleConstructorReturn(this, (PriceAdjustmentReport.__proto__ || Object.getPrototypeOf(PriceAdjustmentReport)).call(this));
	
	    _this.state = {
	      priceAdjustment: null
	    };
	    return _this;
	  }
	
	  _createClass(PriceAdjustmentReport, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      var dates = (0, _cleanDates.getFromToDates)(new Date(), 'month');
	      this.props.fetchPriceAdjustment('month', dates);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.priceAdjustment && nextProps.priceAdjustment != this.props.priceAdjustment) {
	        console.log("priceAdjustment", nextProps.priceAdjustment);
	        this.setState({ priceAdjustment: nextProps.priceAdjustment });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price_reference' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vitCalendar' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                type: 'button' },
	              _react2.default.createElement('em', { className: 'fa fa-print' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'success',
	                type: 'button' },
	              _react2.default.createElement('em', { className: 'fa fa-download' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'export' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'price-adjustment' },
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { className: 'position-relative' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price_reference_chart' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: 'Calendar', component: _calendar2.default, data: this.state.priceAdjustment, fetchInfo: this.props.fetchPriceAdjustment, type: 'priceAdjustment', url: '/priceAdjustmentDetail' })
	            )
	          )
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return PriceAdjustmentReport;
	}(_react.Component);
	
	var _default = PriceAdjustmentReport;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PriceAdjustmentReport, 'PriceAdjustmentReport', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/priceAdjustment.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/priceAdjustment.jsx');
	}();

	;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _root_url = __webpack_require__(9);
	
	var _NumberUtil = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PriceAdjustmentDetail = function (_Component) {
	  _inherits(PriceAdjustmentDetail, _Component);
	
	  function PriceAdjustmentDetail() {
	    _classCallCheck(this, PriceAdjustmentDetail);
	
	    var _this = _possibleConstructorReturn(this, (PriceAdjustmentDetail.__proto__ || Object.getPrototypeOf(PriceAdjustmentDetail)).call(this));
	
	    _this.state = {
	      purchase: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      print: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      isToday: true
	    };
	    _this.deleteLine = _this.deleteLine.bind(_this);
	    return _this;
	  }
	
	  /*componentWillMount() {
	  }
	  componentWillReceiveProps(nextProps) {
	    if(nextProps.priceAdjustment && nextProps.priceAdjustment != this.props.priceAdjustment) {
	      let purchase = {...this.state.purchase, rows: nextProps.priceAdjustment.Line}
	      let lines = nextProps.priceAdjustment.Line;
	      if(lines) {
	        lines.map((r) => {
	          if(r.UpdatePrice) {
	            r.show = true;
	          }
	          else {
	            r.show = false;
	          }
	        })
	        let print = {...this.state.print, rows: lines}
	        let date = nextProps.priceAdjustment.Date;
	          let today = new Date();
	        let y = today.getFullYear().toString();
	        let m = today.getMonth()+1;
	        //let m = today.getDay()+1;
	        if(m < 10) {
	          m = '0'+m;
	        }
	        else {
	          m = m.toString();
	        }
	        let d = today.getDate();
	        if(d < 10) {
	          d = '0'+d;
	        }
	        else {
	          d = d.toString();
	        }
	        d = y + m + d;
	         let isToday = true;
	        if(date < d) {
	          isToday = false;
	        }
	        this.setState({purchase, print, isToday})
	      }
	    }
	  }*/
	
	  _createClass(PriceAdjustmentDetail, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function (_componentWillReceiveProps) {
	      function componentWillReceiveProps(_x) {
	        return _componentWillReceiveProps.apply(this, arguments);
	      }
	
	      componentWillReceiveProps.toString = function () {
	        return _componentWillReceiveProps.toString();
	      };
	
	      return componentWillReceiveProps;
	    }(function (nextProps) {
	      if (nextProps.priceAdjustment && nextProps.priceAdjustment != this.props.priceAdjustment) {
	        var purchase = _extends({}, this.state.purchase, { rows: nextProps.priceAdjustment });
	        var lines = nextProps.priceAdjustment;
	        if (lines) {
	          lines.map(function (r) {
	            if (r.UpdatePrice) {
	              r.show = true;
	            } else {
	              r.show = false;
	            }
	          });
	          var print = _extends({}, this.state.print, { rows: lines });
	
	          var today = new Date();
	          var y = today.getFullYear().toString();
	          var m = today.getMonth() + 1;
	          //let m = today.getDay()+1;
	          if (m < 10) {
	            m = '0' + m;
	          } else {
	            m = m.toString();
	          }
	          var d = today.getDate();
	          if (d < 10) {
	            d = '0' + d;
	          } else {
	            d = d.toString();
	          }
	          d = y + m + d;
	
	          var isToday = true;
	
	          this.setState({ purchase: purchase, print: print, isToday: isToday });
	        }
	      } else {
	        componentWillReceiveProps(nextProps);
	        if (nextProps.priceAdjustment && nextProps.priceAdjustment != this.props.priceAdjustment) {
	          var _purchase = _extends({}, this.state.purchase, { rows: nextProps.priceAdjustment.Line });
	          var _lines = nextProps.priceAdjustment.Line;
	          if (_lines) {
	            _lines.map(function (r) {
	              if (r.UpdatePrice) {
	                r.show = true;
	              } else {
	                r.show = false;
	              }
	            });
	            var _print = _extends({}, this.state.print, { rows: _lines });
	            var date = nextProps.priceAdjustment.Date;
	
	            var _today = new Date();
	            var _y = _today.getFullYear().toString();
	            var _m = _today.getMonth() + 1;
	            //let m = today.getDay()+1;
	            if (_m < 10) {
	              _m = '0' + _m;
	            } else {
	              _m = _m.toString();
	            }
	            var _d = _today.getDate();
	            if (_d < 10) {
	              _d = '0' + _d;
	            } else {
	              _d = _d.toString();
	            }
	            _d = _y + _m + _d;
	
	            var _isToday = true;
	            if (date < _d) {
	              _isToday = false;
	            }
	            this.setState({ purchase: _purchase, print: _print, isToday: _isToday });
	          }
	        }
	      }
	    })
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit() {
	      this.props.createPriceAdjustment(this.state.purchase.rows);
	    }
	  }, {
	    key: 'deleteLine',
	    value: function deleteLine(WarehouseReceiveLine_id) {
	      var print = _extends({}, this.state.print);
	      print.rows.map(function (r) {
	        if (r.WarehouseReceiveLine_id == WarehouseReceiveLine_id) {
	          r.show = false;
	        }
	      });
	      this.setState({ print: print });
	    }
	  }, {
	    key: 'renderPurchaseTable',
	    value: function renderPurchaseTable() {
	      var _this2 = this;
	
	      if (this.props.purchasingPerformanceIsLoading && !this.props.purchasingPerformanceError) return _react2.default.createElement(
	        'div',
	        { id: 'spinner' },
	        _react2.default.createElement(Spinner, null)
	      );else if (this.props.purchasingPerformanceError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.purchasingPerformanceError)
	        )
	      );else {
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.purchase);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return Object.assign({ Idx: rowIdx }, rows[rowIdx]);
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var purchase = Object.assign({}, _this2.state.purchase, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this2.setState({ purchase: purchase });
	        };
	
	        var handleRowUpdated = function handleRowUpdated(e) {
	          var rows = getRows();
	          Object.assign(rows[e.rowIdx], e.updated);
	          // let print = {...this.state.print, rows: rows};
	          // print.rows.map(r => {
	          //   if(r.WarehouseReceiveLine_id == rows[e.rowIdx].WarehouseReceiveLine_id) {
	          //     r.show = true;
	          //     r.Action = null;
	          //   }
	          // })
	
	          if (e.cellKey === 'UpdatePrice') {
	            rows[e.rowIdx].UpdatePrice = +parseFloat((0, _NumberUtil.roundTo)(rows[e.rowIdx].UpdatePrice, 2)).toFixed(2);
	          }
	          var purchase = _extends({}, _this2.state.purchase, { rows: rows });
	          _this2.setState({ purchase: purchase });
	        };
	
	        //Custom Formatter component
	
	        var DateFormatter = _react2.default.createClass({
	          displayName: 'DateFormatter',
	          render: function render() {
	            if (this.props.value) {
	              var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	              var date = new Date(this.props.value);
	              var index = dateMap.indexOf(date.toString().slice(4, 3));
	              var localDate = index + date.toString().slice(8, 6);
	              return _react2.default.createElement(
	                'span',
	                null,
	                date.toString().slice(4, 15)
	              );;
	            } else return _react2.default.createElement(
	              'span',
	              { className: 'label label-danger' },
	              '-'
	            );
	          }
	        });
	
	        var ReceivePriceFormatter = _react2.default.createClass({
	          displayName: 'ReceivePriceFormatter',
	          render: function render() {
	            if (this.props.dependentValues.LastPrice < this.props.value) return _react2.default.createElement(
	              'span',
	              { style: { color: "red" } },
	              this.props.value
	            );else return _react2.default.createElement(
	              'span',
	              null,
	              this.props.value
	            );
	          }
	        });
	
	        var handleActionClick = function handleActionClick(action, type) {
	          var purchase = _extends({}, _this2.state.purchase);
	          purchase.rows[action.dependentValues.Idx].Action = type;
	          if (type == "Match") {
	            purchase.rows[action.dependentValues.Idx].UpdatePrice = purchase.rows[action.dependentValues.Idx].RcvUnitPrice;
	          } else {
	            purchase.rows[action.dependentValues.Idx].UpdatePrice = null;
	          }
	          var print = _extends({}, _this2.state.print, { rows: purchase.rows });
	          if (type === "Match" || type === 'Update') {
	            print.rows.map(function (r) {
	              if (r.WarehouseReceiveLine_id == purchase.rows[action.dependentValues.Idx].WarehouseReceiveLine_id) {
	                r.show = true;
	              }
	              // else {
	              //   r.show = false;
	              // }
	            });
	          } else {
	            print.rows.map(function (r) {
	              if (r.WarehouseReceiveLine_id == purchase.rows[action.dependentValues.Idx].WarehouseReceiveLine_id) {
	                r.show = false;
	              }
	              // else {
	              //   r.show = false;
	              // }
	            });
	          }
	          purchase.rows[action.dependentValues.Idx].EffectNow = false;
	          _this2.setState({ purchase: purchase, print: print });
	        };
	
	        var handleEffectNowClick = function handleEffectNowClick(effectNow) {
	          var purchase = _extends({}, _this2.state.purchase);
	          purchase.rows[effectNow.dependentValues.Idx].EffectNow = !purchase.rows[effectNow.dependentValues.Idx].EffectNow;
	          _this2.setState({ purchase: purchase });
	        };
	
	        var ActionFormatter = _react2.default.createClass({
	          displayName: 'ActionFormatter',
	          render: function render() {
	            var _this3 = this;
	
	            var Status = this.props.dependentValues.Status;
	
	            var shouldDisable = Status === 'Done' || Status === 'Void';
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement('input', { type: 'radio', value: 'Pass',
	                  checked: this.props.value === "Pass",
	                  onClick: function onClick() {
	                    handleActionClick(_this3.props, "Pass");
	                  },
	                  disabled: shouldDisable
	                }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pass' })
	              ),
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement('input', { type: 'radio', value: 'Match',
	                  checked: this.props.value === "Match",
	                  onClick: function onClick() {
	                    handleActionClick(_this3.props, "Match");
	                  },
	                  disabled: shouldDisable
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'match' })
	                )
	              ),
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement('input', { type: 'radio', value: 'Update',
	                  checked: this.props.value === "Update",
	                  onClick: function onClick() {
	                    handleActionClick(_this3.props, "Update");
	                  },
	                  disabled: shouldDisable
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'update' })
	                )
	              )
	            );
	          }
	        });
	
	        var EffectNowFormatter = _react2.default.createClass({
	          displayName: 'EffectNowFormatter',
	          render: function render() {
	            var _this4 = this;
	
	            var _props$dependentValue = this.props.dependentValues,
	                Action = _props$dependentValue.Action,
	                Status = _props$dependentValue.Status;
	
	            var value = this.props.value ? "Now" : "Tomorrow";
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('input', {
	                type: 'checkbox',
	                value: 'true',
	                checked: this.props.value == true || this.props.value == "true",
	                onClick: function onClick() {
	                  handleEffectNowClick(_this4.props);
	                },
	                disabled: Action !== 'Update' && Action !== 'Match' || Status === 'Done' || Status === 'Void'
	              }),
	              _react2.default.createElement(
	                'span',
	                null,
	                value
	              )
	            );
	          }
	        });
	        var VitDateFormatter = _react2.default.createClass({
	          displayName: 'VitDateFormatter',
	          render: function render() {
	            if (this.props.value) {
	              var Vitdate = this.props.value.split("_")[0] + "  " + (this.props.value.split("_")[1] + ":00");
	              return _react2.default.createElement(
	                'span',
	                null,
	                Vitdate
	              );
	            }
	          }
	        });
	
	        var AppointmentFormatter = _react2.default.createClass({
	          displayName: 'AppointmentFormatter',
	          render: function render() {
	            if (this.props.value.online = '0') return _react2.default.createElement(
	              'span',
	              null,
	              online
	            );else return _react2.default.createElement(
	              'span',
	              null,
	              Onsite
	            );
	          }
	        });
	
	        var printLineFormatter = _react2.default.createClass({
	          displayName: 'printLineFormatter',
	          render: function render() {
	            var url = this.props.dependentValues && _root_url.ROOT_URL + 'v1/warehouse/printbarcode/' + this.props.dependentValues.ProductNum + "?Bearer=" + localStorage.getItem('token');
	            return _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'primary',
	                  className: 'textAlignStyle',
	                  style: { height: '23px', width: '39px', padding: '0px' },
	                  href: url
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	              )
	            );
	          }
	        });
	        // Column difinition
	
	        var columns = [{
	          key: 'ReceiveDate',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_date' }),
	          resizable: true,
	          sortable: true,
	          width: 85
	          //formatter: DateFormatter
	        }, {
	          key: 'WarehouseReceiveNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_num' }),
	          resizable: true,
	          sortable: true,
	          width: 105
	        }, {
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          sortable: true,
	          width: 75
	        }, {
	          key: 'ProductName',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	          resizable: true,
	          sortable: true,
	          width: 220
	        }, {
	          key: 'ProductDescription',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	          resizable: true,
	          sortable: true,
	          width: 110
	        }, {
	          key: 'LastPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_dollarsign' }),
	          resizable: true,
	          sortable: true,
	          width: 65
	        }, {
	          key: 'ProductRefPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_dollarsign' }),
	          resizable: true,
	          sortable: true,
	          width: 65
	        }, {
	          key: 'RcvUnitPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_dollarsign' }),
	          resizable: true,
	          sortable: true,
	          width: 75,
	          formatter: ReceivePriceFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'Status',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	          resizable: true,
	          width: 70
	        }, {
	          key: 'Action',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'action' }),
	          resizable: true,
	          width: 210,
	          formatter: ActionFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'UpdatePrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'update_dollarsign' }),
	          resizable: true,
	          sortable: true,
	          width: 75,
	          editable: function editable(row) {
	            return row.Action === 'Update' && row.Status !== 'Done' && row.Status !== 'Void';
	          },
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'EffectNow',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'effect' }),
	          resizable: true,
	          sortable: true,
	          width: 90,
	          formatter: EffectNowFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'Print',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_label' }),
	          formatter: printLineFormatter,
	          resizable: true,
	          sortable: true,
	          width: 60,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'Modifier_User_Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'modifier' }),
	          resizable: true,
	          sortable: true,
	          width: 100
	        }];
	
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { className: 'react-table-price-adjustment-purchase', id: 'PriceAdjustmentDetail-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                enableCellSelect: true,
	                onGridSort: handleGridSort,
	                columns: columns,
	                headerRowHeight: 45,
	                minHeight: 650,
	                rowHeight: 25,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                onRowUpdated: handleRowUpdated
	              })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderPrintTable',
	    value: function renderPrintTable() {
	      var _this5 = this;
	
	      var deleteLine = this.deleteLine;
	      if (this.props.purchasingPerformanceIsLoading && !this.props.purchasingPerformanceError) return _react2.default.createElement(
	        'div',
	        { id: 'spinner' },
	        _react2.default.createElement(Spinner, null)
	      );else if (this.props.purchasingPerformanceError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.purchasingPerformanceError)
	        )
	      );else {
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          var print = _this5.state.print;
	          print.rows = print.rows.filter(function (r) {
	            return r.show;
	          });
	          return _reactDataGridAddons.Data.Selectors.getRows(_this5.state.print);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var print = Object.assign({}, _this5.state.print, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this5.setState({ print: print });
	        };
	
	        //Custom Formatter component
	
	        var DateFormatter = _react2.default.createClass({
	          displayName: 'DateFormatter',
	          render: function render() {
	            if (this.props.value) {
	              var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	              var date = new Date(this.props.value);
	              var index = dateMap.indexOf(date.toString().slice(4, 3));
	              var localDate = index + date.toString().slice(8, 6);
	              return _react2.default.createElement(
	                'span',
	                null,
	                date.toString().slice(4, 15)
	              );;
	            } else return _react2.default.createElement(
	              'span',
	              { className: 'label label-danger' },
	              '-'
	            );
	          }
	        });
	
	        var IsVariableFormatter = _react2.default.createClass({
	          displayName: 'IsVariableFormatter',
	          render: function render() {
	            var _this6 = this;
	
	            return _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  className: 'textAlignStyle',
	                  style: { height: '23px', width: '39px', padding: '0px' },
	                  onClick: function onClick() {
	                    deleteLine(_this6.props.dependentValues.WarehouseReceiveLine_id);
	                  }
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'X' })
	              )
	            );
	          }
	        });
	
	        var printLineFormatter = _react2.default.createClass({
	          displayName: 'printLineFormatter',
	          render: function render() {
	            var url = this.props.dependentValues && _root_url.ROOT_URL + 'v1/warehouse/printbarcode/' + this.props.dependentValues.ProductNum + "?Bearer=" + localStorage.getItem('token');
	            return _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'primary',
	                  className: 'textAlignStyle',
	                  style: { height: '23px', width: '39px', padding: '0px' },
	                  href: url
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	              )
	            );
	          }
	        });
	
	        var EffectFormatter = _react2.default.createClass({
	          displayName: 'EffectFormatter',
	          render: function render() {
	            var value = this.props.value ? "Now" : "Tomorrow";
	            return _react2.default.createElement(
	              'span',
	              null,
	              value
	            );
	          }
	        });
	
	        // Column difinition
	
	        var columns = [{
	          key: 'Delete',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	          formatter: IsVariableFormatter,
	          width: 50,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          sortable: true,
	          width: 90
	        }, {
	          key: 'Print',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' }),
	          formatter: printLineFormatter,
	          resizable: true,
	          sortable: true,
	          width: 50,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'EffectNow',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'effect' }),
	          resizable: true,
	          sortable: true,
	          width: 90,
	          formatter: EffectFormatter
	        }];
	
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { className: 'react-table-price-adjustment-print', id: 'PriceAdjustmentDetail-dataGrid2' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                enableCellSelect: true,
	                onGridSort: handleGridSort,
	                columns: columns,
	                minHeight: 650,
	                rowHeight: 25,
	                rowGetter: rowGetter,
	                rowsCount: getSize()
	              })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var handleSubmit = this.props.handleSubmit;
	      // let print_url = null;
	      // let excel_url = null;
	      // if(this.props.priceAdjustment) {
	      //   print_url = ROOT_URL + 'v1/warehouse/receiveprice/print/' + this.props.priceAdjustment.Date + "?Bearer=" + localStorage.getItem('token');
	      //   excel_url = ROOT_URL + 'v1/warehouse/receiveprice/excel/' + this.props.priceAdjustment.Date + "?Bearer=" + localStorage.getItem('token');
	      // }
	
	      var date = this.props.priceAdjustment && this.props.priceAdjustment.Date;
	      date = date && date.slice(4, 6) + ' / ' + date.slice(6) + ' / ' + date.slice(0, 4);
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'success',
	              type: 'button',
	              disabled: !this.state.isToday,
	              onClick: this.handleFormSubmit.bind(this)
	            },
	            _react2.default.createElement('em', { className: 'fa fa-save' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsStyle: 'danger', onClick: function onClick() {
	                _this7.context.router.push('/priceAdjustmentReport');
	              } },
	            _react2.default.createElement('em', { className: 'fa fa-close' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { fluid: 'true', id: 'price-adjustment-page' },
	          _react2.default.createElement(
	            'form',
	            { autoComplete: 'off', method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	            _react2.default.createElement(
	              'h3',
	              null,
	              date
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { md: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'position-relative table-collapse-fix' },
	                  this.renderPurchaseTable()
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PriceAdjustmentDetail;
	}(_react.Component);
	
	PriceAdjustmentDetail.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = PriceAdjustmentDetail;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PriceAdjustmentDetail, 'PriceAdjustmentDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/priceAdjustmentDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/priceAdjustmentDetail.jsx');
	}();

	;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(13);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxForm = __webpack_require__(3);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _afterAddonField = __webpack_require__(93);
	
	var _afterAddonField2 = _interopRequireDefault(_afterAddonField);
	
	var _weightField = __webpack_require__(161);
	
	var _weightField2 = _interopRequireDefault(_weightField);
	
	var _priceField = __webpack_require__(119);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductArrays = function (_Component) {
	    _inherits(ProductArrays, _Component);
	
	    function ProductArrays() {
	        _classCallCheck(this, ProductArrays);
	
	        var _this = _possibleConstructorReturn(this, (ProductArrays.__proto__ || Object.getPrototypeOf(ProductArrays)).call(this));
	
	        _this.state = {
	            // Only show the current Product
	            currentProduct: -1
	        };
	        return _this;
	    }
	
	    _createClass(ProductArrays, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {}
	    }, {
	        key: 'getNetWeight',
	        value: function getNetWeight(id) {
	            var products = this.props.products;
	
	            var index = _lodash2.default.findIndex(products, { 'Product_id': id });
	            return parseFloat(products[index].NetWeight);
	        }
	    }, {
	        key: 'getShippingWeight',
	        value: function getShippingWeight(id) {
	            var products = this.props.products;
	
	            var index = _lodash2.default.findIndex(products, { 'Product_id': id });
	            return parseFloat(products[index].ShippingWeight);
	        }
	
	        // If the priceType is selected to be CIF, calculate the CIF Price.
	
	    }, {
	        key: 'getCIFPrice',
	        value: function getCIFPrice(index) {
	            var _props = this.props,
	                priceType = _props.priceType,
	                productsValue = _props.productsValue,
	                totalPrice = _props.totalPrice;
	
	            if (priceType == 'CIF' && productsValue[index].TotalPrice && totalPrice != '0.0000') {
	                var CIFPrice = parseFloat(this.props.totalCost || 0) * parseFloat(productsValue[index].TotalPrice || 0) / parseFloat(totalPrice);
	                CIFPrice = CIFPrice / parseFloat(productsValue[index].Quantity || 0) + parseFloat(productsValue[index].FOBUnitPrice || 0);
	                CIFPrice = CIFPrice.toFixed(2);
	                return CIFPrice;
	            } else return 0;
	        }
	    }, {
	        key: 'productHeader',
	        value: function productHeader(index) {
	            var _this2 = this;
	
	            var currentProduct = this.state.currentProduct;
	            var _props2 = this.props,
	                calculatedProducts = _props2.calculatedProducts,
	                productsValue = _props2.productsValue;
	
	            var descriptionClass = (0, _classnames2.default)({ 'hidden': index == currentProduct }, 'pull-right');
	            return _react2.default.createElement(
	                'div',
	                { onClick: function onClick(e) {
	                        e.preventDefault();
	                        if (index != currentProduct) _this2.setState({ currentProduct: index });else _this2.setState({ currentProduct: -1 });
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    index == currentProduct && _react2.default.createElement(
	                        'label',
	                        { style: { cursor: "pointer" } },
	                        'Product Information'
	                    ),
	                    index != currentProduct && calculatedProducts[index] && _react2.default.createElement(
	                        'label',
	                        { style: { cursor: "pointer" } },
	                        calculatedProducts[index].Title
	                    ),
	                    index != currentProduct && productsValue && _react2.default.createElement(
	                        'div',
	                        { className: 'pull-right' },
	                        ' ',
	                        productsValue[index].Quantity,
	                        ' '
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props3 = this.props,
	                fields = _props3.fields,
	                productNumOptions = _props3.productNumOptions,
	                productNameOptions = _props3.productNameOptions,
	                refNumOptions = _props3.refNumOptions,
	                productsValue = _props3.productsValue,
	                products = _props3.products,
	                calculatedProducts = _props3.calculatedProducts;
	
	            console.log(calculatedProducts);
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            fields.map(function (Product, index) {
	                                return _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { header: _this3.productHeader(index), key: index,
	                                        collapsible: true, expanded: index == _this3.state.currentProduct },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 12 },
	                                            _react2.default.createElement(
	                                                'h4',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_information' })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement('hr', null),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 5 },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 12 },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' })
	                                                        ),
	                                                        _react2.default.createElement(_reduxForm.Field, { name: Product + '.Product_id', component: _selection2.default, options: productNumOptions })
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 12 },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' })
	                                                        ),
	                                                        _react2.default.createElement(_reduxForm.Field, { name: Product + '.Product_id', component: _selection2.default, options: productNameOptions })
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 7 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	                                            ),
	                                            _react2.default.createElement(_reduxForm.Field, { name: 'PickupWarehouse', component: 'Textarea', className: 'form-control', style: { minHeight: '130px' } })
	                                        )
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                        'h4',
	                                        null,
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_unit_weight_price' })
	                                    ),
	                                    _react2.default.createElement('hr', null),
	                                    calculatedProducts[index] && !calculatedProducts[index].Product_id && _react2.default.createElement(
	                                        'h4',
	                                        { className: 'centerStyle' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_a_product' })
	                                    ),
	                                    calculatedProducts[index] && calculatedProducts[index].Product_id && _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3 centerStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'convert_item_price' }),
	                                                ': '
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: Product + '.CIFUnitPrice', component: _priceField.DisabledPriceField, V: _this3.getCIFPrice(index) })
	                                            ),
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3 centerStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price' }),
	                                                ': '
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: Product + '.FOBUnitPrice', component: _priceField.PriceField })
	                                            )
	                                        ),
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3 centerStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' }),
	                                                ': '
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: Product + '.Quantity', component: _afterAddonField2.default })
	                                            ),
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3 centerStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_of_measure' }),
	                                                ': '
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3, className: 'centerStyle' },
	                                                calculatedProducts[index].UnitOfMeasure
	                                            )
	                                        ),
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3 centerStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_price' }),
	                                                ': '
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 9 },
	                                                calculatedProducts[index] && _react2.default.createElement(
	                                                    'div',
	                                                    null,
	                                                    _react2.default.createElement(_reduxForm.Field, { name: Product + '.TotalPrice',
	                                                        component: _priceField.DisabledPriceField,
	                                                        V: calculatedProducts[index].TotalPrice })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3 centerStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_net_weight' }),
	                                                ': '
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 9 },
	                                                calculatedProducts[index] && _react2.default.createElement(
	                                                    'div',
	                                                    null,
	                                                    _react2.default.createElement(_reduxForm.Field, { name: Product + '.TotalNetWeight',
	                                                        component: _weightField2.default,
	                                                        V: calculatedProducts[index].TotalNetWeight })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3 centerStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_shipping_weight' }),
	                                                ': '
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 9 },
	                                                calculatedProducts[index] && _react2.default.createElement(
	                                                    'div',
	                                                    null,
	                                                    _react2.default.createElement(_reduxForm.Field, { name: Product + '.TotalShippingWeight',
	                                                        component: _weightField2.default,
	                                                        V: calculatedProducts[index].TotalShippingWeight })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3 centerStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_sale_price' }),
	                                                ': '
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 9 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: Product + '.EstSalePrice', component: _priceField.PriceField })
	                                            )
	                                        ),
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3 centerStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_est_sale_price' }),
	                                                ': '
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 9 },
	                                                calculatedProducts[index] && _react2.default.createElement(
	                                                    'div',
	                                                    null,
	                                                    _react2.default.createElement(_reduxForm.Field, { name: Product + '.EstSaleTotal',
	                                                        component: _priceField.DisabledPriceField,
	                                                        V: calculatedProducts[index].EstSaleTotal })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(_reactBootstrap.Col, { sm: 1 }),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Button,
	                                                { className: 'col-sm-10 btn btn-danger', type: 'button', onClick: function onClick() {
	                                                        fields.remove(index); // remove from index
	                                                    } },
	                                                _react2.default.createElement('i', null),
	                                                ' ',
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'remove_this_product' }),
	                                                '.'
	                                            )
	                                        )
	                                    )
	                                );
	                            }),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    { type: 'button',
	                                        className: 'btn btn-info col-sm-12',
	                                        onClick: function onClick() {
	                                            fields.push({});
	                                            _this3.setState({ currentProduct: fields.length });
	                                        } },
	                                    _react2.default.createElement('i', null),
	                                    ' ',
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_another_product' })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ProductArrays;
	}(_react.Component);
	
	var _default = ProductArrays;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(ProductArrays, 'ProductArrays', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/productArray.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/productArray.jsx');
	}();

	;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(13);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxForm = __webpack_require__(3);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _selection = __webpack_require__(21);
	
	var _priceField = __webpack_require__(119);
	
	var _priceField2 = _interopRequireDefault(_priceField);
	
	var _afterAddonField = __webpack_require__(93);
	
	var _afterAddonField2 = _interopRequireDefault(_afterAddonField);
	
	var _weightField = __webpack_require__(161);
	
	var _weightField2 = _interopRequireDefault(_weightField);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductArrayDisabled = function (_Component) {
	    _inherits(ProductArrayDisabled, _Component);
	
	    function ProductArrayDisabled() {
	        _classCallCheck(this, ProductArrayDisabled);
	
	        var _this = _possibleConstructorReturn(this, (ProductArrayDisabled.__proto__ || Object.getPrototypeOf(ProductArrayDisabled)).call(this));
	
	        _this.state = {
	            // Only show the current Product
	            currentProduct: -1
	        };
	        return _this;
	    }
	
	    _createClass(ProductArrayDisabled, [{
	        key: 'componentWillMout',
	        value: function componentWillMout() {}
	    }, {
	        key: 'getNetWeight',
	        value: function getNetWeight(id) {
	            var products = this.props.products;
	
	            var index = _lodash2.default.findIndex(products, { 'Product_id': id });
	            return parseFloat(products[index].NetWeight);
	        }
	    }, {
	        key: 'getShippingWeight',
	        value: function getShippingWeight(id) {
	            var products = this.props.products;
	
	            var index = _lodash2.default.findIndex(products, { 'Product_id': id });
	            return parseFloat(products[index].ShippingWeight);
	        }
	
	        // If the priceType is selected to be CIF, calculate the CIF Price.
	
	    }, {
	        key: 'getCIFPrice',
	        value: function getCIFPrice(index) {
	            var _props = this.props,
	                priceType = _props.priceType,
	                productsValue = _props.productsValue,
	                totalPrice = _props.totalPrice;
	
	            if (priceType == 'CIF' && productsValue[index].TotalPrice && totalPrice != '0.0000') {
	                var CIFPrice = parseFloat(this.props.totalCost || 0) * parseFloat(productsValue[index].TotalPrice || 0) / parseFloat(totalPrice);
	                CIFPrice = CIFPrice / parseFloat(productsValue[index].Quantity || 0) + parseFloat(productsValue[index].FOBUnitPrice || 0);
	                CIFPrice = CIFPrice.toFixed(2);
	                return CIFPrice;
	            } else return 0;
	        }
	    }, {
	        key: 'productHeader',
	        value: function productHeader(index) {
	            var _this2 = this;
	
	            var currentProduct = this.state.currentProduct;
	            var _props2 = this.props,
	                calculatedProducts = _props2.calculatedProducts,
	                productsValue = _props2.productsValue;
	
	            var descriptionClass = (0, _classnames2.default)({ 'hidden': index == currentProduct }, 'pull-right');
	            return _react2.default.createElement(
	                'div',
	                { onClick: function onClick(e) {
	                        e.preventDefault();
	                        if (index != currentProduct) _this2.setState({ currentProduct: index });else _this2.setState({ currentProduct: -1 });
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    index == currentProduct && _react2.default.createElement(
	                        'label',
	                        { style: { cursor: "pointer" } },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_information' })
	                    ),
	                    index != currentProduct && calculatedProducts[index] && _react2.default.createElement(
	                        'label',
	                        { style: { cursor: "pointer" } },
	                        calculatedProducts[index].Title
	                    ),
	                    index != currentProduct && productsValue && _react2.default.createElement(
	                        'div',
	                        { className: 'pull-right' },
	                        ' ',
	                        productsValue[index].Quantity,
	                        ' '
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props3 = this.props,
	                fields = _props3.fields,
	                productNumOptions = _props3.productNumOptions,
	                productNameOptions = _props3.productNameOptions,
	                refNumOptions = _props3.refNumOptions,
	                productsValue = _props3.productsValue,
	                products = _props3.products,
	                calculatedProducts = _props3.calculatedProducts;
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            fields.map(function (Product, index) {
	                                return _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { header: _this3.productHeader(index), key: index,
	                                        collapsible: true, expanded: index == _this3.state.currentProduct },
	                                    _react2.default.createElement(
	                                        'h4',
	                                        null,
	                                        'Production Information'
	                                    ),
	                                    _react2.default.createElement('hr', null),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 5 },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 12 },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' })
	                                                        ),
	                                                        _react2.default.createElement(_reduxForm.Field, { name: Product + '.Product_id', component: _selection.DisabledSelection, options: productNumOptions })
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 12 },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'form-group' },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            null,
	                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' })
	                                                        ),
	                                                        _react2.default.createElement(_reduxForm.Field, { name: Product + '.Product_id', component: _selection.DisabledSelection, options: productNameOptions })
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 7 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	                                            ),
	                                            _react2.default.createElement(_reduxForm.Field, { name: 'PickupWarehouse', component: 'Textarea', className: 'form-control', style: { minHeight: '130px' } })
	                                        )
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                        'h4',
	                                        null,
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_unit_weight_price' })
	                                    ),
	                                    _react2.default.createElement('hr', null),
	                                    calculatedProducts[index] && !calculatedProducts[index].Product_id && _react2.default.createElement(
	                                        'h4',
	                                        { className: 'centerStyle' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_a_product' })
	                                    ),
	                                    calculatedProducts[index] && calculatedProducts[index].Product_id && _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3 centerStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price' }),
	                                                ':'
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 9 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: Product + '.UnitPrice', component: _priceField2.default })
	                                            )
	                                        ),
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3 centerStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'convert_item_price' }),
	                                                ':'
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 9 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: Product + '.ConvertItemPrice', component: _priceField2.default, V: _this3.getCIFPrice(index) })
	                                            )
	                                        ),
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3 centerStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' }),
	                                                ':'
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 9 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: Product + '.Quantity', component: _afterAddonField2.default })
	                                            )
	                                        ),
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3 centerStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit' }),
	                                                ':'
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 9 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: Product + '.Unit', component: _afterAddonField2.default })
	                                            )
	                                        ),
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3 centerStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_price' }),
	                                                ':'
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 9 },
	                                                calculatedProducts[index] && _react2.default.createElement(
	                                                    'div',
	                                                    null,
	                                                    _react2.default.createElement(_reduxForm.Field, { name: Product + '.TotalPrice',
	                                                        component: _priceField2.default,
	                                                        V: calculatedProducts[index].TotalPrice })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3 centerStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_net_weight' }),
	                                                ':'
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 9 },
	                                                calculatedProducts[index] && _react2.default.createElement(
	                                                    'div',
	                                                    null,
	                                                    _react2.default.createElement(_reduxForm.Field, { name: Product + '.TotalNetWeight',
	                                                        component: _weightField2.default,
	                                                        V: calculatedProducts[index].TotalNetWeight })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3 centerStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_shipping_weight' }),
	                                                ':'
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 9 },
	                                                calculatedProducts[index] && _react2.default.createElement(
	                                                    'div',
	                                                    null,
	                                                    _react2.default.createElement(_reduxForm.Field, { name: Product + '.TotalShippingWeight',
	                                                        component: _weightField2.default,
	                                                        V: calculatedProducts[index].TotalShippingWeight })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3 centerStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'et_sale_price' }),
	                                                ':'
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 9 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: Product + '.EstSalePrice', component: _priceField2.default })
	                                            )
	                                        )
	                                    )
	                                );
	                            }),
	                            _react2.default.createElement(_reactBootstrap.Row, null)
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ProductArrayDisabled;
	}(_react.Component);
	
	var _default = ProductArrayDisabled;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(ProductArrayDisabled, 'ProductArrayDisabled', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/productArrayDisabled.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/productArrayDisabled.jsx');
	}();

	;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reactChartjs = __webpack_require__(86);
	
	var _time = __webpack_require__(83);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _purchaseQuoteModal = __webpack_require__(76);
	
	var _purchaseQuoteModal2 = _interopRequireDefault(_purchaseQuoteModal);
	
	var _favoriteModal = __webpack_require__(75);
	
	var _favoriteModal2 = _interopRequireDefault(_favoriteModal);
	
	var _datePicker = __webpack_require__(27);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PurchaseDashboard = function (_Component) {
	    _inherits(PurchaseDashboard, _Component);
	
	    function PurchaseDashboard() {
	        _classCallCheck(this, PurchaseDashboard);
	
	        var _this = _possibleConstructorReturn(this, (PurchaseDashboard.__proto__ || Object.getPrototypeOf(PurchaseDashboard)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.fourLineButton,
	
	            createReturnOpen: false,
	            createQuoteOpen: false,
	            createFavoriteOpen: false,
	
	            POs: {
	                rows: [],
	                allRows: [],
	                setDate: null,
	                selectedRows: null,
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            inventories: {
	                rows: [],
	                selectedRows: null,
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            favorites: {
	                rows: [],
	                selectedRows: null,
	                sortColumn: null,
	                sortDirection: null
	            }
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	
	        _this.openReturnCreate = _this.openReturnCreate.bind(_this);
	        _this.closeReturnCreate = _this.closeReturnCreate.bind(_this);
	        _this.openQuoteCreate = _this.openQuoteCreate.bind(_this);
	        _this.closeQuoteCreate = _this.closeQuoteCreate.bind(_this);
	        _this.openFavoriteCreate = _this.openFavoriteCreate.bind(_this);
	        _this.closeFavoriteCreate = _this.closeFavoriteCreate.bind(_this);
	        _this.addFavorite = _this.addFavorite.bind(_this);
	        return _this;
	    }
	
	    _createClass(PurchaseDashboard, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchPurchaseOrders();
	            this.props.fetchInventories();
	            this.props.fetchFavorites();
	            this.props.fetchNumPurchaseQuotes();
	            this.props.fetchPurchaseOrdersNotReceived();
	            this.props.fetchTotalPurchases();
	            this.props.fetchPurchasePaymentNotPaid();
	            this.props.fetchTodaysIncomingOrders();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once products are ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.todaysIncomingOrders && nextProps.todaysIncomingOrders != this.props.todaysIncomingOrders) {
	                var newPurchaseOrders = [].concat(_toConsumableArray(nextProps.todaysIncomingOrders));
	                if (newPurchaseOrders.length > 0) {
	                    newPurchaseOrders.map(function (index) {
	                        index.Warehouse = index.Deliver_Warehouse_id.Name;
	                        index.Vendor = index.Vendor_id.Name;
	                    });
	                }
	
	                var POs = _extends({}, this.state.POs, { rows: newPurchaseOrders });
	                this.setState({ POs: POs });
	            }
	
	            if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
	                var inventories = _extends({}, this.state.inventories, { rows: nextProps.inventories });
	                this.setState({ inventories: inventories });
	            }
	
	            if (nextProps.favorites && nextProps.favorites != this.props.favorites) {
	                var favorites = _extends({}, this.state.favorites, { rows: nextProps.favorites });
	                this.setState({ favorites: favorites });
	            }
	
	            if (nextProps.dateChosen && nextProps.dateChosen != this.props.dateChosen) {
	                this.props.fetchIncomingOrdersByDate(this.formatDate(nextProps.dateChosen));
	            }
	        }
	    }, {
	        key: 'formatDate',
	        value: function formatDate(date) {
	            var monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	
	            if (date) {
	                var month = String(date).slice(4, 7);
	                var day = String(date).slice(8, 10);
	                var year = String(date).slice(11, 15);
	
	                var chosenDateFormatted = '';
	                if (parseInt(monthShortNames.indexOf(month) + 1) < 10) {
	                    chosenDateFormatted = chosenDateFormatted + '0' + (monthShortNames.indexOf(month) + 1) + day;
	                } else {
	                    chosenDateFormatted = chosenDateFormatted + (monthShortNames.indexOf(month) + 1) + day;
	                }
	                chosenDateFormatted = chosenDateFormatted + year;
	                console.log(chosenDateFormatted);
	                return chosenDateFormatted;
	            }
	            return null;
	        }
	    }, {
	        key: 'openQuoteCreate',
	        value: function openQuoteCreate() {
	            this.setState({ createQuoteOpen: true });
	        }
	    }, {
	        key: 'openFavoriteCreate',
	        value: function openFavoriteCreate() {
	            this.setState({ createFavoriteOpen: true });
	        }
	    }, {
	        key: 'closeQuoteCreate',
	        value: function closeQuoteCreate() {
	            this.setState({ createQuoteOpen: false });
	        }
	    }, {
	        key: 'closeFavoriteCreate',
	        value: function closeFavoriteCreate() {
	            this.setState({ createFavoriteOpen: false });
	        }
	    }, {
	        key: 'openReturnCreate',
	        value: function openReturnCreate() {
	            this.setState({ createReturnOpen: true });
	        }
	    }, {
	        key: 'closeReturnCreate',
	        value: function closeReturnCreate() {
	            this.setState({ createReturnOpen: false });
	        }
	    }, {
	        key: 'addFavorite',
	        value: function addFavorite(newFavorite) {
	            console.log("newFavorite", newFavorite);
	            var newRow = {
	                Product_id: newFavorite.Product_id,
	                ProductNum: newFavorite.ProductNum,
	                RefNum: newFavorite.ProductNum,
	                PreSale: newFavorite.PreSale,
	                InStock: newFavorite.InStock,
	                Ordered: newFavorite.Purchased,
	                Price: newFavorite.RefPurchasingPrice,
	                ProductName: newFavorite.Name
	            };
	            if (newFavorite.Product) {
	                newRow.ProductName = newFavorite.Product["Name"];
	            }
	
	            var preRows = this.state.favorites.rows;
	            preRows.push(newRow);
	            var favorites = _extends({}, this.state.favorites, { rows: preRows });
	            this.setState({ favorites: favorites });
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.fourLineButton });
	        }
	
	        // Set product being selected to be currentProduct and navigate user to the edit page
	
	    }, {
	        key: 'setCurrentPurchaseOrder',
	        value: function setCurrentPurchaseOrder(e) {
	            e.preventDefault();
	            var currentPurchaseOrder = this.state.selectedRows[0];
	            this.props.resetCurrentPurchaseOrder();
	            this.props.selectPurchaseOrder(currentPurchaseOrder);
	            this.context.router.push('/purchaseOrder/' + currentPurchaseOrder.PurchaseOrder_id);
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            this.props.resetCurrentPurchaseOrder();
	            this.context.router.push('/purchaseOrder/new');
	        }
	    }, {
	        key: 'createPurchaseReturn',
	        value: function createPurchaseReturn(e) {
	            e.preventDefault();
	            this.props.resetCurrentPurchaseReturn();
	            this.context.router.push('/purchaseReturn/new');
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable table.
	
	    }, {
	        key: 'renderPurchaseOrderTable',
	        value: function renderPurchaseOrderTable() {
	            var _this2 = this;
	
	            if (this.props.todaysIncomingOrdersIsLoading && !this.props.todaysIncomingOrdersError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.todaysIncomingOrdersError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.todaysIncomingOrdersError)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.POs);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var POs = _extends({}, _this2.state.POs, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this2.setState({ POs: POs });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var POs = _extends({}, _this2.state.POs, { selectedRows: rows });
	                    _this2.setState({ POs: POs });
	                };
	
	                //Custom Formatter component
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNameFormatter = _react2.default.createClass({
	                    displayName: 'VendorNameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNumFormatter = _react2.default.createClass({
	                    displayName: 'VendorNumFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.VendorNum
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'PONum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 90
	                }, {
	                    key: 'Vendor',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor' }),
	                    resizable: true,
	                    sortable: true
	                }, {
	                    key: 'TotalPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 75
	                }, {
	                    key: 'Warehouse',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipto' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 70
	                }, {
	                    key: 'CreateTime',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 90,
	                    formatter: DateFormatter
	                }, {
	                    key: 'PurchaseStatus',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80
	                }];
	
	                return (
	                    //React Table Purchase Order Table
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                'div',
	                                { id: 'PurchaseDashboard-dataGrid1' },
	                                _react2.default.createElement(_reactDataGrid2.default, {
	                                    rowKey: 'PurchaseOrder_id',
	                                    onGridSort: handleGridSort,
	                                    columns: columns,
	                                    rowGetter: rowGetter,
	                                    rowsCount: getSize(),
	                                    minHeight: this.state.tableHeight,
	                                    rowHeight: 25,
	                                    onRowSelect: onRowSelect })
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderInventoryTable',
	        value: function renderInventoryTable() {
	            var _this3 = this;
	
	            if (this.props.favoritesAreLoading && !this.props.favoritesError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.favoritesError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.favoritesError)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                // const getRows = () => {
	                //     return Data.Selectors.getRows(this.state.inventories);
	                // }
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.favorites);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                // const handleGridSort = (sortColumn, sortDirection) => {
	                //     var inventories = {...this.state.inventories, sortColumn, sortDirection};
	                //     this.setState({inventories});
	                // }
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var favorites = _extends({}, _this3.state.favorites, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this3.setState({ favorites: favorites });
	                };
	
	                // Handle the row select function
	
	                // const onRowSelect = rows => {
	                //     var inventories = {...this.state.inventories, selectedRows: rows};
	                //     this.setState({inventories});
	                // }
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var favorites = _extends({}, _this3.state.favorites, { selectedRows: rows });
	                    _this3.setState({ favorites: favorites });
	                };
	
	                //Custom Formatter component
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNameFormatter = _react2.default.createClass({
	                    displayName: 'VendorNameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNumFormatter = _react2.default.createClass({
	                    displayName: 'VendorNumFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.VendorNum
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'PreSale',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'presale' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true
	                }, {
	                    key: 'InStock',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'stock' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80
	                }, {
	                    key: 'Ordered',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 90
	                }, {
	                    key: 'Price',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cost' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80
	                }];
	
	                return (
	                    //React Table Inventory Table
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                'div',
	                                { id: 'PurchaseDashboard-dataGrid2' },
	                                _react2.default.createElement(_reactDataGrid2.default, {
	                                    rowKey: 'Product_id',
	                                    onGridSort: handleGridSort,
	                                    columns: columns,
	                                    rowGetter: rowGetter,
	                                    rowsCount: getSize(),
	                                    minHeight: this.state.tableHeight,
	                                    rowHeight: 25,
	                                    enableRowSelect: 'multi',
	                                    onRowSelect: onRowSelect })
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderDatePicker',
	        value: function renderDatePicker(handleSubmit) {
	            return _react2.default.createElement(
	                'form',
	                { onSubmit: handleSubmit },
	                _react2.default.createElement(_reduxForm.Field, { name: 'SelectedDate', component: _datePicker.DatePicker })
	            );
	        }
	    }, {
	        key: 'renderNumPurchaseQuotes',
	        value: function renderNumPurchaseQuotes() {
	            if (this.props.numPurchaseQuotesLoading && !this.props.numPurchaseQuotesError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.numPurchaseQuotesError) {
	                return _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'alert alert-danger' },
	                        JSON.stringify(this.props.numPurchaseQuotesError)
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'dash-number' },
	                    this.props.numPurchaseQuotes
	                );
	            }
	        }
	    }, {
	        key: 'renderNumPurchaseOrdersNotReceived',
	        value: function renderNumPurchaseOrdersNotReceived() {
	            if (this.props.numPurchaseOrdersNotReceivedLoading && !this.props.numPurchaseOrdersNotReceivedError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.numPurchaseOrdersNotReceivedError) {
	                return _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'alert alert-danger' },
	                        JSON.stringify(this.props.numPurchaseOrdersNotReceivedError)
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'dash-number' },
	                    this.props.numPurchaseOrdersNotReceived
	                );
	            }
	        }
	    }, {
	        key: 'renderNumPurchaseOrdersNotPaid',
	        value: function renderNumPurchaseOrdersNotPaid() {
	            console.log("1", this.props.numPurchaseOrdersNotPaid);
	            if (this.props.numPurchaseOrdersNotPaidLoading && !this.props.numPurchaseOrdersNotPaidError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.numPurchaseOrdersNotPaidError) {
	                return _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'alert alert-danger' },
	                        JSON.stringify(this.props.numPurchaseOrdersNotPaidError)
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'dash-number' },
	                    this.props.numPurchaseOrdersNotPaid
	                );
	            }
	        }
	    }, {
	        key: 'renderTotalPurchases',
	        value: function renderTotalPurchases() {
	            if (this.props.numTotalPurchasesLoading && !this.props.numTotalPurchasesError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.numTotalPurchasesError) {
	                return _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'alert alert-danger' },
	                        JSON.stringify(this.props.numTotalPurchasesError)
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'dash-number' },
	                    this.props.numTotalPurchases
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                numPurchaseQuotes = _props.numPurchaseQuotes;
	
	            var height = (this.state.tableHeight + 85).toString();
	            var tableCollapseFix = { height: height };
	            // Dummie Data
	            var lineData = {
	                labels: ["January", "February", "March", "April"],
	                datasets: [{
	                    label: "My First dataset",
	                    fillColor: "rgba(220,220,220,0.2)",
	                    strokeColor: "rgba(220,220,220,1)",
	                    pointColor: "rgba(220,220,220,1)",
	                    pointStrokeColor: "#fff",
	                    pointHighlightFill: "#fff",
	                    pointHighlightStroke: "rgba(220,220,220,1)",
	                    data: [65, 59, 80, 81]
	                }, {
	                    label: "My Second dataset",
	                    fillColor: "rgba(151,187,205,0.2)",
	                    strokeColor: "rgba(151,187,205,1)",
	                    pointColor: "rgba(151,187,205,1)",
	                    pointStrokeColor: "#fff",
	                    pointHighlightFill: "#fff",
	                    pointHighlightStroke: "rgba(151,187,205,1)",
	                    data: [28, 48, 40, 19]
	                }]
	            };
	
	            var data = [{ color: "#97ddf0", label: "test1", value: 2 }, { color: "#fafafa", label: "test2", value: 1 }];
	
	            var options = {
	                animateRotate: true
	            };
	
	            var createDialogStyle = {
	                width: '600px',
	                marginLeft: '-10%'
	            };
	
	            var purchaseOrderTablePanelHeader = _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 8 },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_order_arrivals' })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 4 },
	                    this.renderDatePicker(handleSubmit)
	                )
	            );
	
	            var inventoryPanelHeader = _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 8 },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventories' })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 4 },
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        { className: 'pull-right' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'small',
	                                type: 'button',
	                                onClick: this.openFavoriteCreate },
	                            _react2.default.createElement('em', { className: 'fa fa-plus' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'danger',
	                                bsSize: 'small',
	                                type: 'button',
	                                onClick: function onClick(event) {
	                                    var newArray = _this4.state.favorites.rows;
	                                    _this4.state.favorites.selectedRows.map(function (row) {
	                                        _this4.props.deleteFavorite(row.Product_id);
	                                        newArray = newArray.filter(function (obj) {
	                                            return obj.Product_id !== row.Product_id;
	                                        });
	                                        var favorites = _extends({}, _this4.state.favorites, { rows: newArray });
	                                        _this4.setState({ favorites: favorites });
	                                    });
	                                } },
	                            _react2.default.createElement('em', { className: 'fa fa-close' })
	                        )
	                    )
	                )
	            );
	
	            var ordersCreatedHeader = _react2.default.createElement(
	                'h3',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'orders_created_header' })
	            );
	            var poReceiveDate = _react2.default.createElement(
	                'h3',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_order_receive_rate' })
	            );
	
	            return (
	                //---------------
	                // Begin HTML
	                //---------------
	                _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            { active: 'true' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_dashboard' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Grid,
	                        { id: 'purchase-dashboard', fluid: 'true' },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_dashboard' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(_time2.default, null),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5ths' },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/purchaseQuote' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel widget' },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'row-table' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 5, className: 'bg-blue' },
	                                                this.renderNumPurchaseQuotes()
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 7 },
	                                                _react2.default.createElement(
	                                                    'h3',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_quotes' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5ths' },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/purchaseOrder' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel widget' },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'row-table' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 5, className: 'bg-red' },
	                                                this.renderNumPurchaseOrdersNotReceived()
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 7 },
	                                                _react2.default.createElement(
	                                                    'h3',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_orders_not_received' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5ths' },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/purchasePayment' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel widget' },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'row-table' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 5, className: 'bg-yellow' },
	                                                this.renderNumPurchaseOrdersNotPaid()
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 7 },
	                                                _react2.default.createElement(
	                                                    'h3',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_payment' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5ths' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'panel widget' },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        { className: 'row-table' },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 5, className: 'bg-green' },
	                                            this.renderTotalPurchases()
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 7 },
	                                            _react2.default.createElement(
	                                                'h3',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_purchases' })
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        ' ',
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quick_actions' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'success',
	                                    type: 'button',
	                                    onClick: function onClick(event) {
	                                        _this4.clickNew(event);
	                                    } },
	                                _react2.default.createElement('em', { className: 'fa fa-cart-plus' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_new_purchase_order' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'primary',
	                                    type: 'button',
	                                    onClick: this.openQuoteCreate },
	                                _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_purchase_quote' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'warning',
	                                    type: 'button',
	                                    onClick: function onClick(event) {
	                                        _this4.createPurchaseReturn(event);
	                                    } },
	                                _react2.default.createElement('em', { className: 'fa fa-backward' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'process_purchase_return' })
	                            )
	                        ),
	                        ' ',
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { header: purchaseOrderTablePanelHeader, style: tableCollapseFix },
	                                    this.renderPurchaseOrderTable()
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { header: inventoryPanelHeader, style: tableCollapseFix },
	                                    this.renderInventoryTable()
	                                )
	                            )
	                        ),
	                        ' '
	                    ),
	                    _react2.default.createElement(
	                        _reactSkylight.SkyLightStateless,
	                        { dialogStyles: createDialogStyle, isVisible: this.state.createQuoteOpen, onCloseClicked: function onCloseClicked() {
	                                _this4.closeQuoteCreate();
	                            }, title: 'Create a Purchase Quote' },
	                        _react2.default.createElement(_purchaseQuoteModal2.default, { closeC: this.closeQuoteCreate })
	                    ),
	                    _react2.default.createElement(
	                        _reactSkylight.SkyLightStateless,
	                        { dialogStyles: createDialogStyle, isVisible: this.state.createFavoriteOpen, onCloseClicked: function onCloseClicked() {
	                                _this4.closeFavoriteCreate();
	                            }, title: 'Create a new Favorite' },
	                        _react2.default.createElement(_favoriteModal2.default, { closeC: this.closeFavoriteCreate, currentList: this.state.favorites, closeA: this.addFavorite })
	                    )
	                )
	                //---------------
	                // End HTML
	                //---------------
	
	            );
	        }
	    }]);
	
	    return PurchaseDashboard;
	}(_react.Component);
	
	PurchaseDashboard.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = PurchaseDashboard;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(PurchaseDashboard, 'PurchaseDashboard', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseDashboard.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseDashboard.jsx');
	}();

	;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reactChartjs = __webpack_require__(86);
	
	var _reactChartjs2 = __webpack_require__(102);
	
	var _time = __webpack_require__(83);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _purchaseQuoteModal = __webpack_require__(76);
	
	var _purchaseQuoteModal2 = _interopRequireDefault(_purchaseQuoteModal);
	
	var _favoriteModal = __webpack_require__(75);
	
	var _favoriteModal2 = _interopRequireDefault(_favoriteModal);
	
	var _datePicker = __webpack_require__(27);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _reduxForm = __webpack_require__(3);
	
	var _root_url = __webpack_require__(9);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PurchaseManagerDashboard = function (_Component) {
	    _inherits(PurchaseManagerDashboard, _Component);
	
	    function PurchaseManagerDashboard() {
	        _classCallCheck(this, PurchaseManagerDashboard);
	
	        var _this = _possibleConstructorReturn(this, (PurchaseManagerDashboard.__proto__ || Object.getPrototypeOf(PurchaseManagerDashboard)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	            createReturnOpen: false,
	            createQuoteOpen: false,
	            createFavoriteOpen: false,
	
	            // Data for last 30 days performance
	            monthData: {
	                labels: [],
	                datasets: [{
	                    label: "30 Day Performance",
	                    fill: false,
	                    lineTension: 0.1,
	                    backgroundColor: "rgba(75,192,192,0.4)",
	                    borderColor: "rgba(75,192,192,1)",
	                    borderCapStyle: 'butt',
	                    borderDash: [],
	                    borderDashOffset: 0.0,
	                    borderJoinStyle: 'miter',
	                    pointBorderColor: "rgba(75,192,192,1)",
	                    pointBackgroundColor: "#fff",
	                    pointBorderWidth: 1,
	                    pointHoverRadius: 5,
	                    pointHoverBackgroundColor: "rgba(75,192,192,1)",
	                    pointHoverBorderColor: "rgba(220,220,220,1)",
	                    pointHoverBorderWidth: 2,
	                    pointRadius: 1,
	                    pointHitRadius: 10,
	                    data: [],
	                    spanGaps: false
	                }]
	            },
	
	            // Array of purchasers performance in the last month
	            purchasersPerformance: [],
	
	            // Data for records table
	            records: {
	                rows: [],
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            reports: {
	                rows: [],
	                sortColumn: null,
	                sortDirection: null
	            }
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        return _this;
	    }
	
	    _createClass(PurchaseManagerDashboard, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchPurchasersPerformance();
	            this.props.fetchVendorRecords();
	            this.props.fetchMonthPerformance();
	            // this.props.fetchPurchaseOrderPerformance();
	            this.props.fetchPurchaseManagerInfo();
	            this.props.fetchIncidentReport();
	            // this.props.fetchPurchaseOrders();
	            // this.props.fetchInventories();
	            // this.props.fetchFavorites();
	            // this.props.fetchNumPurchaseQuotes();
	            // this.props.fetchPurchaseOrdersNotReceived();
	            // this.props.fetchTotalPurchases();
	            //
	            // this.props.fetchTodaysIncomingOrders();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once products are ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.vendorRecords && nextProps.vendorRecords != this.props.vendorRecords) {
	                var records = _extends({}, this.state.records, { rows: nextProps.vendorRecords });
	                this.setState({ records: records });
	            }
	
	            // if (nextProps.purchaseOrderPerformance && nextProps.purchaseOrderPerformance != this.props.purchaseOrderPerformance) {
	            //     console.log("HERE THEY ARE!", nextProps.purchaseOrderPerformance);
	            //     let labelData = JSON.parse(JSON.stringify(nextProps.purchaseOrderPerformance));
	            //
	            //     for (var property in labelData) {
	            //         if (labelData.hasOwnProperty(property)) {
	            //             console.log(property)
	            //             console.log(property.substring(1,4))
	            //         }
	            //     }
	            // }
	
	            if (nextProps.lastMonth && nextProps.lastMonth != this.props.lastMonth) {
	                console.log("last month!", nextProps.lastMonth);
	                var lastMonth = _extends({}, this.state.monthData);
	
	                nextProps.lastMonth.forEach(function (day) {
	                    if (parseInt(day.Day) % 2 == 1) lastMonth.labels.push(day.Day);else lastMonth.labels.push('');
	                    lastMonth.datasets[0].data.push(day.Orders);
	                });
	                console.log("results", lastMonth);
	                this.setState({ monthData: lastMonth });
	            }
	
	            if (nextProps.purchasersPerformance && nextProps.purchasersPerformance != this.props.purchasersPerformance) {
	                console.log("Here they are!", nextProps.purchasersPerformance);
	                var purchasersPerformance = [];
	
	                nextProps.purchasersPerformance.forEach(function (record) {
	                    var lastMonth = new PurchaserRecord();
	                    console.log("new instance", lastMonth);
	                    lastMonth.datasets[0].label = record.User;
	                    record.Orders.forEach(function (day) {
	                        if (parseInt(day.Day) % 2 == 1) lastMonth.labels.push(day.Day);else lastMonth.labels.push('');
	                        lastMonth.datasets[0].data.push(day.Orders);
	                    });
	
	                    purchasersPerformance.push(lastMonth);
	                });
	                console.log("purchasersPerformance", purchasersPerformance);
	                this.setState({ purchasersPerformance: purchasersPerformance });
	            }
	
	            if (nextProps.incidentReport && nextProps.incidentReport != this.props.incidentReport) {
	                var incidents = [].concat(_toConsumableArray(nextProps.incidentReport));
	                console.log("Records", incidents);
	                var reports = _extends({}, this.state.reports, { rows: incidents });
	                this.setState({ reports: reports });
	            }
	        }
	    }, {
	        key: 'formatDate',
	        value: function formatDate(date) {
	            var monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	
	            if (date) {
	                var month = String(date).slice(4, 7);
	                var day = String(date).slice(8, 10);
	                var year = String(date).slice(11, 15);
	
	                var chosenDateFormatted = '';
	                if (parseInt(monthShortNames.indexOf(month) + 1) < 10) {
	                    chosenDateFormatted = chosenDateFormatted + '0' + (monthShortNames.indexOf(month) + 1) + day;
	                } else {
	                    chosenDateFormatted = chosenDateFormatted + (monthShortNames.indexOf(month) + 1) + day;
	                }
	                chosenDateFormatted = chosenDateFormatted + year;
	                console.log(chosenDateFormatted);
	                return chosenDateFormatted;
	            }
	            return null;
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.fourLineButton });
	        }
	
	        // Set product being selected to be currentProduct and navigate user to the edit page
	
	    }, {
	        key: 'setCurrentPurchaseOrder',
	        value: function setCurrentPurchaseOrder(e) {
	            e.preventDefault();
	            var currentPurchaseOrder = this.state.selectedRows[0];
	            this.props.resetCurrentPurchaseOrder();
	            this.props.selectPurchaseOrder(currentPurchaseOrder);
	            this.context.router.push('/purchaseOrder/' + currentPurchaseOrder.PurchaseOrder_id);
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            this.props.resetCurrentPurchaseOrder();
	            this.context.router.push('/purchaseOrder/new');
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable table.
	
	    }, {
	        key: 'renderMyNotificationReport',
	        value: function renderMyNotificationReport() {
	            var _this2 = this;
	
	            if (this.props.incidentReportIsLoading && !this.props.incidentReportError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.incidentReportError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.incidentReportError)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var tableHeight = window.innerHeight < 900 ? 540 : 540;
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.reports);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var reports = _extends({}, _this2.state.reports, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this2.setState({ reports: reports });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var reports = _extends({}, _this2.state.reports, { selectedRows: rows });
	                    _this2.setState({ reports: reports });
	                };
	
	                //Custom Formatter component
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNameFormatter = _react2.default.createClass({
	                    displayName: 'VendorNameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNumFormatter = _react2.default.createClass({
	                    displayName: 'VendorNumFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.VendorNum
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'Note_for_Change',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'action' }),
	                    resizable: true,
	                    sortable: true
	                }, {
	                    key: 'Modifier_Username',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'user' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80
	                }, {
	                    key: 'TotalPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80
	                }];
	
	                return (
	                    //React Table Notifications
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                'div',
	                                { id: 'PurchaseManagerDashboard-dataGrid1' },
	                                _react2.default.createElement(_reactDataGrid2.default, {
	                                    rowKey: 'log_version_id',
	                                    onGridSort: handleGridSort,
	                                    columns: columns,
	                                    rowGetter: rowGetter,
	                                    rowsCount: getSize(),
	                                    minHeight: tableHeight,
	                                    rowHeight: 25,
	                                    onRowSelect: onRowSelect })
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderMyVendors',
	        value: function renderMyVendors() {
	            var _this3 = this;
	
	            if (this.props.vendorRecordsIsLoading && !this.props.vendorRecordsError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.vendorRecordsError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.vendorRecordsError)
	                )
	            );else {
	                // Parameters of the react-data-grid
	                var tableHeight = window.innerHeight < 900 ? 540 : 540;
	                // const getRows = () => {
	                //     return Data.Selectors.getRows(this.state.inventories);
	                // }
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.records);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var records = _extends({}, _this3.state.records, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this3.setState({ records: records });
	                };
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var records = _extends({}, _this3.state.records, { selectedRows: rows });
	                    _this3.setState({ records: records });
	                };
	
	                //Custom Formatter component
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNameFormatter = _react2.default.createClass({
	                    displayName: 'VendorNameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNumFormatter = _react2.default.createClass({
	                    displayName: 'VendorNumFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.VendorNum
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var OutstandingFormatter = _react2.default.createClass({
	                    displayName: 'OutstandingFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'div',
	                            { style: { marginTop: '20px' } },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'label label-danger' },
	                                '$',
	                                this.props.value
	                            )
	                        );else return _react2.default.createElement(
	                            'span',
	                            null,
	                            '-'
	                        );
	                    }
	                });
	
	                var OrderAmountFormatter = _react2.default.createClass({
	                    displayName: 'OrderAmountFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-primary' },
	                            '$',
	                            this.props.value
	                        );else return _react2.default.createElement(
	                            'span',
	                            null,
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'Name',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'OrderAmount',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_amount' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    formatter: OrderAmountFormatter,
	                    width: 125
	                }, {
	                    key: 'OutstandingInvoices',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice' }),
	                    resizable: true,
	                    sortable: true,
	                    formatter: OutstandingFormatter,
	                    width: 100
	                }];
	
	                return (
	                    //React Table Vendors
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                'div',
	                                { id: 'PurchaseManagerDashboard-dataGrid2' },
	                                _react2.default.createElement(_reactDataGrid2.default, {
	                                    rowKey: 'Vendor_id',
	                                    onGridSort: handleGridSort,
	                                    columns: columns,
	                                    rowGetter: rowGetter,
	                                    rowsCount: getSize(),
	                                    minHeight: tableHeight,
	                                    rowHeight: 25,
	                                    onRowSelect: onRowSelect })
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderDatePicker',
	        value: function renderDatePicker(handleSubmit) {
	            return _react2.default.createElement(
	                'form',
	                { onSubmit: handleSubmit },
	                _react2.default.createElement(_reduxForm.Field, { name: 'SelectedDate', component: _datePicker.DatePicker })
	            );
	        }
	    }, {
	        key: 'renderUndoPriceAdjust',
	        value: function renderUndoPriceAdjust() {
	            if (this.props.purchaseManagerInfoIsLoading && !this.props.purchaseManagerInfoError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.purchaseManagerInfoError) {
	                return _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'alert alert-danger' },
	                        JSON.stringify(this.props.purchaseManagerInfoError)
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'dash-number' },
	                    this.props.purchaseManagerInfo.Undo
	                );
	            }
	        }
	    }, {
	        key: 'renderPurchaseWarning',
	        value: function renderPurchaseWarning() {
	            if (this.props.purchaseManagerInfoIsLoading && !this.props.purchaseManagerInfoError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.purchaseManagerInfoError) {
	                return _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'alert alert-danger' },
	                        JSON.stringify(this.props.purchaseManagerInfoError)
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'dash-number' },
	                    this.props.purchaseManagerInfo.Warning
	                );
	            }
	        }
	    }, {
	        key: 'renderMonthPerformance',
	        value: function renderMonthPerformance() {
	            if (this.props.lastMonthIsLoading && !this.props.lastMonthError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.lastMonthError) {
	                return _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'alert alert-danger' },
	                        JSON.stringify(this.props.lastMonthError)
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactChartjs2.Line, { data: this.state.monthData, height: 260, options: { maintainAspectRatio: false } })
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                numPurchaseQuotes = _props.numPurchaseQuotes;
	
	            var height = (this.state.tableHeight + 90).toString();
	            var tableCollapseFix = { height: height };
	            var graphCollapseFix = { height: ((this.state.tableHeight + 85) / 2).toString()
	                // Dummie Data
	
	            };var data = {
	                labels: ["January", "February", "March", "April", "May", "June", "July"],
	                datasets: [{
	                    label: "My First dataset",
	                    fill: false,
	                    lineTension: 0.1,
	                    backgroundColor: "rgba(75,192,192,0.4)",
	                    borderColor: "rgba(75,192,192,1)",
	                    borderCapStyle: 'butt',
	                    borderDash: [],
	                    borderDashOffset: 0.0,
	                    borderJoinStyle: 'miter',
	                    pointBorderColor: "rgba(75,192,192,1)",
	                    pointBackgroundColor: "#fff",
	                    pointBorderWidth: 1,
	                    pointHoverRadius: 5,
	                    pointHoverBackgroundColor: "rgba(75,192,192,1)",
	                    pointHoverBorderColor: "rgba(220,220,220,1)",
	                    pointHoverBorderWidth: 2,
	                    pointRadius: 1,
	                    pointHitRadius: 10,
	                    data: [65, 59, 80, 81, 56, 55, 40],
	                    spanGaps: false
	                }]
	            };
	
	            var options = {
	                maintainAspectRatio: false,
	                scales: {
	                    xAxes: [{
	                        ticks: {
	                            fixedStepSize: 2
	                        }
	                    }]
	                }
	            };
	
	            var notificationTablePanelHeader = _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'illegal_operations_report' })
	            );
	            var panelHeader = _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'my_vendors' })
	            );
	            var purchaseReceiveDate = _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_order_receive_rate' })
	            );
	            var overallPurchaseReceiveRate = _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'overall_purchase_receive_rate' })
	            );
	            return (
	                //---------------
	                // Begin HTML
	                //---------------
	                _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            { active: 'true' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_manager_dashboard' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Grid,
	                        { id: 'purchase-manager-dashboard', fluid: 'true' },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_manager_dashboard' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(_time2.default, null),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5ths' },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/priceAdjustmentReport' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel widget' },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'row-table' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 5, className: 'bg-blue' },
	                                                this.renderUndoPriceAdjust()
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 7 },
	                                                _react2.default.createElement(
	                                                    'h3',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price_adjustment' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5ths' },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/purchaseReferencereport' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel widget' },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'row-table' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 5, className: 'bg-red' },
	                                                this.renderPurchaseWarning()
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 7 },
	                                                _react2.default.createElement(
	                                                    'h3',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_reference' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5ths' },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/purchasingPerformanceReport' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel widget' },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'row-table' },
	                                            _react2.default.createElement(_reactBootstrap.Col, { sm: 5, className: 'bg-yellow' }),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 7 },
	                                                _react2.default.createElement(
	                                                    'h3',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_performance' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5ths' },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/purchasePivotChart' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel widget' },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'row-table' },
	                                            _react2.default.createElement(_reactBootstrap.Col, { sm: 5, className: 'bg-green' }),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 7 },
	                                                _react2.default.createElement(
	                                                    'h3',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_pivot_chart' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        ' ',
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 4 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { header: notificationTablePanelHeader, className: 'table-collapse-fix purchase-manager-headings' },
	                                    this.renderMyNotificationReport()
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 4 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { header: panelHeader, className: 'table-collapse-fix purchase-manager-headings' },
	                                    this.renderMyVendors()
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 4 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { header: overallPurchaseReceiveRate, className: 'purchase-receive-date-chart' },
	                                    this.renderMonthPerformance()
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { header: purchaseReceiveDate, className: 'purchase-receive-date-chart' },
	                                    this.state.purchasersPerformance.map(function (item) {
	                                        return _react2.default.createElement(
	                                            'div',
	                                            null,
	                                            _react2.default.createElement(_reactChartjs2.Line, { data: item, height: 260, options: options })
	                                        );
	                                    })
	                                )
	                            )
	                        ),
	                        ' '
	                    )
	                )
	                //---------------
	                // End HTML
	                //---------------
	
	            );
	        }
	    }]);
	
	    return PurchaseManagerDashboard;
	}(_react.Component);
	
	PurchaseManagerDashboard.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = PurchaseManagerDashboard;
	exports.default = _default;
	
	
	function PurchaserRecord() {
	    this.labels = [], this.datasets = [{
	        label: "30 Day Performance",
	        fill: false,
	        lineTension: 0.1,
	        backgroundColor: "rgba(75,192,192,0.4)",
	        borderColor: "rgba(75,192,192,1)",
	        borderCapStyle: 'butt',
	        borderDash: [],
	        borderDashOffset: 0.0,
	        borderJoinStyle: 'miter',
	        pointBorderColor: "rgba(75,192,192,1)",
	        pointBackgroundColor: "#fff",
	        pointBorderWidth: 1,
	        pointHoverRadius: 5,
	        pointHoverBackgroundColor: "rgba(75,192,192,1)",
	        pointHoverBorderColor: "rgba(220,220,220,1)",
	        pointHoverBorderWidth: 2,
	        pointRadius: 1,
	        pointHitRadius: 10,
	        data: [],
	        spanGaps: false
	    }];
	}
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(PurchaserRecord, 'PurchaserRecord', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseManagerDashboard.jsx');
	
	    __REACT_HOT_LOADER__.register(PurchaseManagerDashboard, 'PurchaseManagerDashboard', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseManagerDashboard.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseManagerDashboard.jsx');
	}();

	;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDropzone = __webpack_require__(45);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _moment3 = __webpack_require__(41);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	__webpack_require__(69);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _selection = __webpack_require__(21);
	
	var _detailedSelection = __webpack_require__(82);
	
	var _inputField = __webpack_require__(16);
	
	var _convertItemPrice = __webpack_require__(116);
	
	var _convertItemPrice2 = _interopRequireDefault(_convertItemPrice);
	
	var _datePicker = __webpack_require__(27);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _customerInfo = __webpack_require__(617);
	
	var _customerInfo2 = _interopRequireDefault(_customerInfo);
	
	var _inventoryInfo = __webpack_require__(181);
	
	var _inventoryInfo2 = _interopRequireDefault(_inventoryInfo);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _taxSelectionModal = __webpack_require__(160);
	
	var _taxSelectionModal2 = _interopRequireDefault(_taxSelectionModal);
	
	var _PurchaseOrderAutoSuggest = __webpack_require__(150);
	
	var _PurchaseOrderAutoSuggest2 = _interopRequireDefault(_PurchaseOrderAutoSuggest);
	
	var _cleanDates = __webpack_require__(22);
	
	var _boldCashFormatter = __webpack_require__(153);
	
	var _boldCashFormatter2 = _interopRequireDefault(_boldCashFormatter);
	
	var _boldTextFormatter = __webpack_require__(154);
	
	var _boldTextFormatter2 = _interopRequireDefault(_boldTextFormatter);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _moment4.default)(_moment2.default);
	
	function isNumber(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	var renderRadios = function renderRadios(props) {
	  var titleClass = (0, _classnames2.default)({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'control-label', 'col-xs-3', 'centerStyle');
	  return _react2.default.createElement(
	    _reactBootstrap.Col,
	    { xs: 12 },
	    _react2.default.createElement(
	      _reactBootstrap.Row,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 12 },
	        props.meta.active && props.meta.error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          props.meta.error
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 5 },
	        _react2.default.createElement(
	          'label',
	          { className: 'inlineLabel' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropship' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'asteriksReq' },
	            '*'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 1 },
	        _react2.default.createElement(
	          'label',
	          { className: 'inlineLabel radioMargin' },
	          _react2.default.createElement(_reactBootstrap.Input, _extends({ className: 'inlineLabel' }, props.input, { type: 'radio', value: 'true',
	            checked: props.input.value === true || props.input.value === "true" }))
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 2, className: 'custom-col-width' },
	        _react2.default.createElement(
	          'label',
	          { className: 'inlineLabel radioMargin' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 1 },
	        _react2.default.createElement(
	          'label',
	          { className: 'inlineLabel radioMargin' },
	          _react2.default.createElement(_reactBootstrap.Input, _extends({ className: 'inlineLabel' }, props.input, { type: 'radio', value: 'false',
	            checked: props.input.value === false || props.input.value === "false" }))
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 2 },
	        _react2.default.createElement(
	          'label',
	          { className: 'inlineLabel radioMargin' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	        )
	      )
	    )
	  );
	};
	
	var renderTypeRadios = function renderTypeRadios(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group', id: 'search-product-by' },
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-4 search-by-max-width' },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'search_by' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'ProductNum',
	        checked: props.input.value === "ProductNum" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2 pl' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'RefNum',
	        checked: props.input.value === "RefNum" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'Name',
	        checked: props.input.value === "Name" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2 ml-lg' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'Description',
	        checked: props.input.value === "Description" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	    )
	  );
	};
	
	var PurchaseOrderForm = function (_Component) {
	  _inherits(PurchaseOrderForm, _Component);
	
	  function PurchaseOrderForm() {
	    _classCallCheck(this, PurchaseOrderForm);
	
	    var _this = _possibleConstructorReturn(this, (PurchaseOrderForm.__proto__ || Object.getPrototypeOf(PurchaseOrderForm)).call(this));
	
	    _this.setAllProductQuantity = function (quantity) {
	      _this.props.setDefaultOfForm('AllProd_Quantity', quantity, 'purchaseOrderForm');
	    };
	
	    _this.clearInventoryInfo = function () {
	      _this.setState({
	        selectedInventoryRow: {},
	        productInfo: {}
	      });
	    };
	
	    _this.handleKeyPress = function (value, event) {
	      if (event.charCode === 13) {
	        event.preventDefault();
	        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	          if (_this.state.selectedInventoryRow && _this.state.selectedInventoryRow.ProductType == 'Non-Fixed') _reactDom2.default.findDOMNode(_this.refs[value[1]].getRenderedComponent().myInput.refs.input).focus();else _reactDom2.default.findDOMNode(_this.refs[value[0]].getRenderedComponent().myInput.refs.input).focus();
	        } else {
	          if (value === 'miscNote' && isNaN(event.target.value)) {
	            _this.props.validate(event.target.value);
	            return;
	          }
	          if ((!isNumber(event.target.value) || event.target.value < 0) && value !== 'allProd_Quantity' && value !== 'miscNote') {
	            _this.props.validate(event.target.value);
	            return;
	          }
	          _reactDom2.default.findDOMNode(_this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	        }
	      }
	    };
	
	    _this.handleFocusQty = function () {
	      _reactDom2.default.findDOMNode(_this.refs['allProd_Quantity'].getRenderedComponent().myInput.refs.input).focus();
	      _reactDom2.default.findDOMNode(_this.refs['allProd_Quantity'].getRenderedComponent().myInput.refs.input).select();
	    };
	
	    _this.IFrameIsLoaded = function () {
	      if (!_this.state.PdfFrameLoaded) {
	        var pdfFrame = window.frames["Pdf"];
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this.setState({ PdfFrameLoaded: true });
	      }
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.fourLineButton,
	      files: null,
	
	      firstRender: false,
	      firstFocus: true,
	
	      productInfo: {},
	      totalNetWeight: 0,
	      totalShippingWeight: 0,
	      totalPrice: 0,
	      totalPriceForTax: 0,
	      totalPriceForAllLines: 0,
	
	      taxRate: 0,
	      discountValue: 0,
	      priceType: 'FOB',
	      finalPrice: 0,
	      miscCostValue: 0,
	      handlingCostValue: 0,
	      shippingCostValue: 0,
	      adjustmentValue: 0,
	
	      created_by: null,
	      modified_by: null,
	      updateTime: null,
	
	      quantity: 0,
	      CRV: 0,
	
	      calculatedProducts: [],
	
	      vendorInformationOpen: true,
	      oneTimeScheduleOpen: true,
	      purchaseInformationOpen: true,
	      orderHistoryOpen: true,
	      inventoryOpen: true,
	      showCustomerOpen: false,
	      showInventoryOpen: false,
	      showPOCreatedOpen: false,
	      confirmOpen: false,
	      changeTaxOpen: false,
	
	      dirty: false,
	      type: 'purchaseOrder',
	      orderInfo: null,
	
	      vendorProducts: {
	        rows: [],
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null,
	        selectedIndexes: []
	      },
	
	      productInfos: {
	        rows: [],
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null,
	        selectedIndexes: []
	      },
	
	      rows: [],
	      selectedRows: [],
	      filters: {},
	      sortColumn: null,
	      sortDirection: null,
	      selectedInventoryRow: {},
	
	      case: null,
	      quantityZero: [],
	      yourOrderTableHeight: window.innerHeight < 930 ? 350 : 350,
	      yourOrderKey: 2,
	      suggestValue: '',
	      PdfFrameLoaded: true
	    };
	    _this.handleMiscCostChange = _this.handleMiscCostChange.bind(_this);
	    _this.handleShippingCostChange = _this.handleShippingCostChange.bind(_this);
	    _this.handleHandlingCostChange = _this.handleHandlingCostChange.bind(_this);
	    _this.handleDiscountChange = _this.handleDiscountChange.bind(_this);
	    _this.handleAdjustmentChange = _this.handleAdjustmentChange.bind(_this);
	    // this.handleTaxChange = this.handleTaxChange.bind(this);
	    _this.handleLowestSalePriceChange = _this.handleLowestSalePriceChange.bind(_this);
	    _this.handleQuantityChange = _this.handleQuantityChange.bind(_this);
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.openShowInventory = _this.openShowInventory.bind(_this);
	    _this.closeShowInventory = _this.closeShowInventory.bind(_this);
	    _this.openShowPOCreated = _this.openShowPOCreated.bind(_this);
	    _this.closeShowPOCreated = _this.closeShowPOCreated.bind(_this);
	    _this.openConfirm = _this.openConfirm.bind(_this);
	    _this.closeConfirm = _this.closeConfirm.bind(_this);
	    _this.openChangeTax = _this.openChangeTax.bind(_this);
	    _this.closeChangeTax = _this.closeChangeTax.bind(_this);
	    _this.selectInventoryInfo = _this.selectInventoryInfo.bind(_this);
	    _this.handleOnFocus = _this.handleOnFocus.bind(_this);
	    _this.moveOffFromProductsList = _this.moveOffFromProductsList.bind(_this);
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    _this.closeShowCustomer = _this.closeShowCustomer.bind(_this);
	    _this.isDropship = _this.isDropship.bind(_this);
	    _this.isPurchaseOrder = _this.isPurchaseOrder.bind(_this);
	    _this.isPurchaseQuote = _this.isPurchaseQuote.bind(_this);
	    _this.placeNewOrder = _this.placeNewOrder.bind(_this);
	    _this.isPurchaseTemplate = _this.isPurchaseTemplate.bind(_this);
	    // this.handleKeyPressTargetSelection = this.handleKeyPressTargetSelection.bind(this);
	    // this.handleKeyPressTargetInput = this.handleKeyPressTargetInput.bind(this);
	    // this.handleKeyPress = this.handleKeyPress.bind(this);
	    // this.handleKeyPressMove = this.handleKeyPressMove.bind(this);
	    // this.handleKeyPressMoveVendor = this.handleKeyPressMoveVendor.bind(this);
	    _this.redirect = _this.redirect.bind(_this);
	    _this.setAllProductQuantity = _this.setAllProductQuantity.bind(_this);
	    return _this;
	  }
	
	  _createClass(PurchaseOrderForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      if (this.context.router.routes[1].path == "purchaseOrder/new") {
	        this.props.resetCurrentPurchaseOrder();
	        this.props.resetCurrentPurchaseQuote();
	        this.props.resetCurrentPurchaseTemplate();
	        this.props.fetchActiveVendors();
	        this.props.fetchPaymentTerms();
	        this.props.fetchWarehouses();
	        this.props.fetchTaxRates();
	        // this.props.setDefaultSearchType('RefNum', 'purchaseOrderForm');
	        this.props.initializedPurchaseOrderForm('RefNum', 'purchaseOrderForm');
	        this.props.setDefaultIsDropship('false', 'purchaseOrderForm');
	        this.props.setDefaultConvertItemPrice('FOB', 'purchaseOrderForm');
	      } else if (this.context.router.routes[1].path == "purchaseOrder/:id") {
	        this.props.resetCurrentPurchaseQuote();
	        this.props.resetCurrentPurchaseTemplate();
	        this.props.fetchTaxRates();
	        var _props = this.props,
	            currentPurchaseOrder = _props.currentPurchaseOrder,
	            currentPurchaseQuote = _props.currentPurchaseQuote,
	            currentPurchaseTemplate = _props.currentPurchaseTemplate;
	
	        this.props.fetchWarehouses().then(function () {
	          return _this2.props.fetchVendors();
	        }).then(function () {
	          return _this2.props.fetchPaymentTerms();
	        }).then(function () {
	          // this.props.setDefaultSearchType('RefNum', 'purchaseOrderForm')
	          _this2.props.initializedPurchaseOrderForm('RefNum', 'purchaseOrderForm');
	          return _this2.props.fetchPurchaseOrderDetail(currentPurchaseOrder.PurchaseOrder_id);
	        }).then(function () {
	          _this2.props.fetchVendorDetail(_this2.props.currentPurchaseOrderDetail && _this2.props.currentPurchaseOrderDetail.Vendor_id);
	          _this2.props.fetchProductsByVendor(_this2.props.currentPurchaseOrderDetail && _this2.props.currentPurchaseOrderDetail.Vendor_id);
	        });
	      } else if (this.context.router.routes[1].path == "purchaseQuote/new") {
	        this.props.resetCurrentPurchaseOrder();
	        this.props.resetCurrentPurchaseQuote();
	        if (this.props.currentPurchaseTemplate) {
	          this.props.convertTemplateToQuote(this.props.currentPurchaseTemplate.PurchaseTemplate_id);
	        }
	        this.props.resetCurrentPurchaseTemplate();
	        this.props.fetchVendors();
	        this.props.fetchPaymentTerms();
	        this.props.fetchWarehouses();
	        this.props.fetchTaxRates();
	        // this.props.setDefaultSearchType('RefNum', 'purchaseOrderForm');
	        this.props.initializedPurchaseOrderForm('RefNum', 'purchaseOrderForm');
	        this.props.setDefaultIsDropship('false', 'purchaseOrderForm');
	        this.props.setDefaultConvertItemPrice('FOB', 'purchaseOrderForm');
	      } else if (this.context.router.routes[1].path == "purchaseQuote/:id") {
	        this.props.resetCurrentPurchaseOrder();
	        this.props.resetCurrentPurchaseTemplate();
	        this.props.fetchTaxRates();
	        var _props2 = this.props,
	            _currentPurchaseOrder = _props2.currentPurchaseOrder,
	            _currentPurchaseQuote = _props2.currentPurchaseQuote,
	            _currentPurchaseTemplate = _props2.currentPurchaseTemplate;
	
	        this.props.fetchWarehouses().then(function () {
	          return _this2.props.fetchVendors();
	        }).then(function () {
	          return _this2.props.fetchPaymentTerms();
	        }).then(function () {
	          // this.props.setDefaultSearchType('RefNum', 'purchaseOrderForm');
	          _this2.props.initializedPurchaseOrderForm('RefNum', 'purchaseOrderForm');
	          return _this2.props.fetchPurchaseQuoteDetail(_currentPurchaseQuote.PurchaseOrder_id);
	        }).then(function () {
	          _this2.props.fetchVendorDetail(_this2.props.currentPurchaseQuoteDetail && _this2.props.currentPurchaseQuoteDetail.Vendor_id);
	          _this2.props.fetchProductsByVendor(_this2.props.currentPurchaseQuoteDetail && _this2.props.currentPurchaseQuoteDetail.Vendor_id);
	        });
	      } else if (this.context.router.routes[1].path == "purchaseTemplate/new") {
	        this.props.resetCurrentPurchaseOrder();
	        this.props.resetCurrentPurchaseQuote();
	        this.props.resetCurrentPurchaseTemplate();
	        this.props.fetchVendors();
	        this.props.fetchPaymentTerms();
	        this.props.fetchWarehouses();
	        this.props.fetchTaxRates();
	        // this.props.setDefaultSearchType('RefNum', 'purchaseOrderForm');
	        this.props.initializedPurchaseOrderForm('RefNum', 'purchaseOrderForm');
	        this.props.setDefaultIsDropship('false', 'purchaseOrderForm');
	        this.props.setDefaultConvertItemPrice('FOB', 'purchaseOrderForm');
	      } else if (this.context.router.routes[1].path == "purchaseTemplate/:id") {
	        this.props.resetCurrentPurchaseQuote();
	        this.props.resetCurrentPurchaseOrder();
	        this.props.fetchTaxRates();
	        var _props3 = this.props,
	            _currentPurchaseOrder2 = _props3.currentPurchaseOrder,
	            _currentPurchaseQuote2 = _props3.currentPurchaseQuote,
	            _currentPurchaseTemplate2 = _props3.currentPurchaseTemplate;
	
	        this.props.fetchWarehouses().then(function () {
	          return _this2.props.fetchVendors();
	        }).then(function () {
	          return _this2.props.fetchPaymentTerms();
	        }).then(function () {
	          // this.props.setDefaultSearchType('RefNum', 'purchaseOrderForm')
	          _this2.props.initializedPurchaseOrderForm('RefNum', 'purchaseOrderForm');
	          return _this2.props.fetchPurchaseTemplateDetail(_currentPurchaseTemplate2.PurchaseTemplate_id);
	        }).then(function () {
	          _this2.props.fetchVendorDetail(_this2.props.currentPurchaseTemplateDetail && _this2.props.currentPurchaseTemplateDetail.Vendor_id);
	          _this2.props.fetchProductsByVendor(_this2.props.currentPurchaseTemplateDetail && _this2.props.currentPurchaseTemplateDetail.Vendor_id);
	        });
	      } else {
	        this.props.fetchVendors();
	        this.props.fetchPaymentTerms();
	        this.props.fetchWarehouses();
	        this.props.fetchTaxRates();
	        // this.props.setDefaultSearchType('RefNum', 'purchaseOrderForm');
	        this.props.initializedPurchaseOrderForm('RefNum', 'purchaseOrderForm');
	        this.props.setDefaultIsDropship('false', 'purchaseOrderForm');
	        this.props.setDefaultConvertItemPrice('FOB', 'purchaseOrderForm');
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (!this.props.searchType) {
	        this.props.setDefaultSearchType('RefNum', 'purchaseOrderForm');
	      }
	      if (!this.props.isDropship) {
	        this.props.setDefaultIsDropship('false', 'purchaseOrderForm');
	      }
	      if (!this.props.priceTypeValue) {
	        this.props.setDefaultConvertItemPrice('FOB', 'purchaseOrderForm');
	      }
	      if (this.refs["vendor_name"] && this.state.firstFocus) {
	        this.refs["vendor_name"].getRenderedComponent().refs.select.focus();
	        this.setState({ firstFocus: false });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.taxRate && nextProps.taxRate != this.props.taxRate) {
	        var totalPriceForTax = parseFloat(this.state.totalPriceForTax) || 0;
	        var taxRate = nextProps.taxRate.value >= 0 ? nextProps.taxRate.value : nextProps.taxRate;
	        var taxValue = parseFloat(taxRate) * totalPriceForTax / 100.0;
	        taxValue = Math.round(0.0001 + taxValue * 100) / 100;
	        this.props.setDefaultOfForm("TaxValue", taxValue, "purchaseOrderForm");
	        this.setState({ taxRate: nextProps.taxRate.value });
	      }
	      if (nextProps.products && nextProps.products != this.props.products) {
	        var _vendorProducts = _extends({}, this.state.vendorProducts, { rows: nextProps.products });
	        this.setState({ vendorProducts: _vendorProducts });
	      }
	      if (nextProps.purchaseOrderCreated && nextProps.purchaseOrderCreated != this.props.purchaseOrderCreated) {
	        this.openShowPOCreated();
	      }
	      if (nextProps.purchaseOrderEdited && nextProps.purchaseOrderEdited != this.props.purchaseOrderEdited) {
	        this.openShowPOCreated();
	      }
	      if (nextProps.purchaseOrderPlaced && nextProps.purchaseOrderPlaced != this.props.purchaseOrderPlaced) {
	        this.openShowPOCreated();
	      }
	      if (nextProps.purchaseQuoteCreated && nextProps.purchaseQuoteCreated != this.props.purchaseQuoteCreated) {
	        this.openShowPOCreated();
	      }
	      if (nextProps.purchaseQuoteEdited && nextProps.purchaseQuoteEdited != this.props.purchaseQuoteEdited) {
	        this.openShowPOCreated();
	      }
	      if (nextProps.purchaseTemplateCreated && nextProps.purchaseTemplateCreated != this.props.purchaseTemplateCreated) {
	        this.openShowPOCreated();
	      }
	      if (nextProps.purchaseTemplateEdited && nextProps.purchaseTemplateEdited != this.props.purchaseTemplateEdited) {
	        this.openShowPOCreated();
	      }
	      if (nextProps.taxRates && nextProps.taxRates != this.props.taxRates) {
	        if (nextProps.taxRates && nextProps.taxRates.length != 0) this.setState({ taxRate: 0 });
	      }
	      if (nextProps.currentVendorDetail && nextProps.currentVendorDetail != this.props.currentVendorDetail) {
	        var currentVendorDetail = nextProps.currentVendorDetail;
	        this.props.setValue('purchaseOrderForm', 'PaymentTerm_id', this.props.currentPurchaseOrderDetail && this.props.currentPurchaseOrderDetail.PaymentTerm_id || this.props.currentPurchaseQuoteDetail && this.props.currentPurchaseQuoteDetail.PaymentTerm_id || this.props.currentPurchaseTemplateDetail && this.props.currentPurchaseTemplateDetail.PaymentTerm_id || nextProps.currentVendorDetail.PaymentTerm_id);
	      }
	      if (nextProps.productInformation && nextProps.productInformation != this.props.productInformation) {
	        var products = this.props.products;
	        var productInformation = nextProps.productInformation;
	        var index = _lodash2.default.findIndex(products, { 'Product_id': productInformation.value || productInformation });
	        if (products[index]) {
	          this.props.fetchProductInfo(products[index].Product_id);
	          this.props.setDefaultOfForm('FOBUnitPrice', products[index].ProductCost, 'purchaseOrderForm');
	          this.props.setDefaultOfForm('Weight', products[index].NetWeight, 'purchaseOrderForm');
	          this.setState({ ProductType: products[index].ProductType });
	        }
	      }
	      if (nextProps.allProducts && nextProps.allProducts != this.props.allProducts) {
	        var _index = _lodash2.default.findIndex(this.props.simplifiedProducts, { 'Product_id': nextProps.allProducts.value });
	        if (_index > -1) {
	          this.props.fetchProductInfo(this.props.simplifiedProducts[_index].Product_id);
	          this.props.setPriceValues(this.props.simplifiedProducts[_index].ProductCost, this.props.simplifiedProducts[_index].LowestSalePrice, 'purchaseOrderForm');
	        }
	      }
	      if (nextProps.productInfo && nextProps.productInfo != this.props.productInfo) {
	        var productInfo = nextProps.productInfo;
	        var productInfos = _extends({}, this.state.productInfos, { rows: productInfo.Purchase_Order_History });
	        this.props.setValue('purchaseOrderForm', 'RefSalePrice', nextProps.productInfo.ProductNum.PriceLv5);
	        this.setState({ productInfo: productInfo, productInfos: productInfos });
	      }
	      if (nextProps.miscCostValue && nextProps.miscCostValue != this.props.miscCostValue) {
	        this.setState({ miscCostValue: nextProps.miscCostValue });
	      }
	      if (nextProps.handlingCostValue && nextProps.handlingCostValue != this.props.handlingCostValue) {
	        this.setState({ handlingCostValue: nextProps.handlingCostValue });
	      }
	      if (nextProps.shippingCostValue && nextProps.shippingCostValue != this.props.shippingCostValue) {
	        this.setState({ shippingCostValue: nextProps.shippingCostValue });
	      }
	      if (nextProps.dirty != this.props.dirty) {
	        this.setState({
	          dirty: nextProps.dirty
	        });
	      }
	
	      // Once user select a vendor, load its address and contacts.
	      if (nextProps.vendorsValue && nextProps.vendorsValue != this.props.vendorsValue) {
	        if (this.refs.Products && !this.state.firstRender) {
	          this.refs.Products.getRenderedComponent().props.fields.removeAll();
	        }
	        if (nextProps.vendorsValue.value) {
	          this.props.fetchVendorDetail(nextProps.vendorsValue.value);
	          this.props.fetchProductsByVendor(nextProps.vendorsValue.value);
	        }
	        if (this.state.firstRender) this.state.firstRender = false;
	      }
	
	      // Also, if vendor has been chosen in the template user'll work on, load related products.
	      if (nextProps.currentPurchaseOrderDetail != this.props.currentPurchaseOrderDetail && nextProps.currentPurchaseOrderDetail) {
	        var currentPurchaseOrderDetail = nextProps.currentPurchaseOrderDetail;
	        if (currentPurchaseOrderDetail.Purchase_Order_Line != null) {
	          var newRows = [];
	          var _totalPriceForTax = 0;
	          var totalPriceForAllLines = 0;
	          currentPurchaseOrderDetail.Purchase_Order_Line.map(function (line) {
	            var newProduct = {};
	            newProduct["Product_id"] = line.Product_id.Product_id;
	            newProduct["Name"] = line.Product_id.Name;
	            newProduct["EstSalePrice"] = line.EstSalePrice; //products[index].LowestSalePrice;
	            newProduct["Quantity"] = line.Quantity;
	            newProduct["CRV"] = line.Product_id.CRV;
	            newProduct["ProductNum"] = line.Product_id.ProductNum;
	            newProduct["Description"] = line.Product_id.Description;
	            newProduct["MeasureUnit"] = line.Product_id.MeasureUnit;
	            newProduct["FOBUnitPrice"] = line.FOBUnitPrice; //products[index].RefPrice;
	            newProduct["ShippingWeight"] = line.Product_id.ShippingWeight;
	            newProduct["NetWeight"] = line.Product_id.NetWeight;
	            newProduct["TotalNetWeight"] = roundTo(parseFloat(line.Product_id.NetWeight * line.Quantity), 2).toFixed(2);
	            newProduct["TotalShippingWeight"] = roundTo(parseFloat(line.Product_id.ShippingWeight * line.Quantity), 2).toFixed(2);
	            newProduct["RefNum"] = line.Product_id.RefNum;
	            newProduct["TotalPrice"] = (Math.round(parseFloat(line.TotalPrice) * 10000) / 10000).toFixed(2);
	            newProduct["IsTaxable"] = line.Product_id.IsTaxable;
	            newProduct["Remark"] = line.Remark;
	            newProduct["ProductType"] = line.Product_id.ProductType;
	            newProduct["PackageSize"] = line.Product_id.PackageSize;
	            newProduct["PackageType"] = line.Product_id.PackageType;
	
	            newRows = [].concat(_toConsumableArray(newRows), [newProduct]);
	            if (line.Product_id.IsTaxable) {
	              _totalPriceForTax += line.TotalPrice;
	            }
	            totalPriceForAllLines += line.TotalPrice;
	          });
	          var newTotalShippingWeight = currentPurchaseOrderDetail.FinalShippingWeight;
	          var newTotalNetWeight = currentPurchaseOrderDetail.FinalNetWeight;
	          // let newTotalPrice = parseFloat(currentPurchaseOrderDetail.TotalPrice).toFixed(2);
	          // let finalPrice = parseFloat(currentPurchaseOrderDetail.FinalPrice).toFixed(2);
	
	          var _taxRate = currentPurchaseOrderDetail.TaxRate || 0;
	          var discountValue = currentPurchaseOrderDetail.Discount || 0;
	          var miscCostValue = currentPurchaseOrderDetail.MiscCost || 0;
	          var handlingCostValue = currentPurchaseOrderDetail.HandlingCost || 0;
	          var shippingCostValue = currentPurchaseOrderDetail.ShippingCost || 0;
	          var adjustmentValue = currentPurchaseOrderDetail.PriceAdjustment || 0;
	          var CRV = currentPurchaseOrderDetail.CRV;
	          var _taxValue = parseFloat(_taxRate || 0) * _totalPriceForTax / 100.0;
	          _taxValue = Math.round(0.0001 + _taxValue * 100) / 100;
	
	          var totalPrice = 0;
	          _totalPriceForTax = 0;
	          totalPriceForAllLines = 0;
	          var NewCRV = 0;
	          var totalShippingWeight = 0;
	          var totalNetWeight = 0;
	          newRows.map(function (row) {
	            totalPrice += parseFloat(row["TotalPrice"]);
	            totalPriceForAllLines += parseFloat(row["TotalPrice"]);
	            if (row["IsTaxable"]) {
	              _totalPriceForTax += parseFloat(row["TotalPrice"]);
	            }
	            console.log("This is the new CRV", NewCRV);
	            NewCRV += (Math.round(parseFloat(row["CRV"]) * 100) / 100 || 0) * (parseFloat(row["Quantity"]) || 0);
	            console.log("This is the new CRV2", NewCRV);
	            totalShippingWeight += (parseFloat(row["Quantity"]) || 0) * (parseFloat(row["ShippingWeight"]) || 0);
	            totalNetWeight += (parseFloat(row["Quantity"]) || 0) * (parseFloat(row["NetWeight"]) || 0);
	          });
	          totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	          _totalPriceForTax = parseFloat(_totalPriceForTax);
	          totalPriceForAllLines = parseFloat(Math.round(totalPriceForAllLines * 100) / 100).toFixed(2);
	
	          var finalPrice = NewCRV + Math.round(miscCostValue * 100) / 100 + Math.round(adjustmentValue * 100) / 100 + Math.round(handlingCostValue * 100) / 100 + Math.round(shippingCostValue * 100) / 100 + totalPriceForAllLines * (1 - discountValue / 100.0) + Math.round(_totalPriceForTax * _taxRate / 100.0 * 100) / 100;
	          finalPrice = (Math.round(finalPrice * 100) / 100).toFixed(2);
	
	          this.props.setDefaultOfForm("TaxValue", _taxValue, "purchaseOrderForm");
	          this.setState({ rows: newRows,
	            totalShippingWeight: currentPurchaseOrderDetail.FinalShippingWeight,
	            totalNetWeight: newTotalNetWeight,
	            totalPrice: totalPrice,
	            totalPriceForTax: _totalPriceForTax,
	            totalPriceForAllLines: totalPriceForAllLines,
	            finalPrice: finalPrice,
	            taxRate: _taxRate,
	            discountValue: discountValue,
	            miscCostValue: miscCostValue,
	            handlingCostValue: handlingCostValue,
	            shippingCostValue: shippingCostValue,
	            adjustmentValue: adjustmentValue,
	            CRV: CRV
	          });
	        }
	        var updateTime = new Date(currentPurchaseOrderDetail.UpdateTime);
	        updateTime = (0, _cleanDates.convertLocalDate)(updateTime, 'MM-DD-YY');
	        this.setState({
	          modified_by: currentPurchaseOrderDetail.Modifier_User_Name,
	          updateTime: updateTime,
	          created_by: currentPurchaseOrderDetail.Purchaser_User_Name,
	          firstRender: true
	        });
	        this.props.initializeForm(currentPurchaseOrderDetail, [], "purchaseOrderForm");
	        this.props.setDefaultSearchType('RefNum', 'purchaseOrderForm');
	      }
	
	      if (!nextProps.vendorsValue) {
	        this.props.resetCurrentVendor();
	      }
	
	      if (nextProps.priceTypeValue != this.props.priceTypeValue) {
	        this.setState({ priceType: nextProps.priceTypeValue });
	      }
	
	      // Calculate the sum of the price and weight for products.
	
	      if (nextProps.products[0] && nextProps.productsValue) {
	        var round = function round(value, decimals) {
	          return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
	        };
	
	        var _products = nextProps.products;
	
	
	        var calculatedProducts = nextProps.productsValue;
	
	        this.setState({
	          calculatedProducts: calculatedProducts
	        });
	      }
	
	      if (nextProps.warehouses && nextProps.warehouses != this.props.warehouses) {
	        if (nextProps.warehouses[0]) this.props.setDefaults('purchaseOrderForm', nextProps.warehouses[0].Warehouse_id);
	      }
	
	      if (nextProps.currentPurchaseQuoteDetail != this.props.currentPurchaseQuoteDetail && nextProps.currentPurchaseQuoteDetail) {
	        var currentPurchaseQuoteDetail = nextProps.currentPurchaseQuoteDetail;
	        if (currentPurchaseQuoteDetail.Purchase_Order_Line != null) {
	          var _newRows = [];
	          var _totalPriceForTax2 = 0;
	          var _totalPriceForAllLines = 0;
	          currentPurchaseQuoteDetail.Purchase_Order_Line.map(function (line) {
	            var newProduct = {};
	            newProduct["Product_id"] = line.Product_id.Product_id;
	            newProduct["Name"] = line.Product_id.Name;
	            newProduct["EstSalePrice"] = line.EstSalePrice; //products[index].LowestSalePrice;
	            newProduct["Quantity"] = line.Quantity;
	
	            newProduct["ProductNum"] = line.Product_id.ProductNum;
	            newProduct["Description"] = line.Product_id.Description;
	            newProduct["MeasureUnit"] = line.Product_id.MeasureUnit;
	            newProduct["FOBUnitPrice"] = line.FOBUnitPrice; //products[index].RefPrice;
	            newProduct["ShippingWeight"] = line.Product_id.ShippingWeight;
	            newProduct["NetWeight"] = line.Product_id.NetWeight;
	            newProduct["TotalNetWeight"] = roundTo(parseFloat(line.Product_id.NetWeight * line.Quantity), 2).toFixed(2);
	            newProduct["TotalShippingWeight"] = roundTo(parseFloat(line.Product_id.ShippingWeight * line.Quantity), 2).toFixed(2);
	            newProduct["RefNum"] = line.Product_id.RefNum;
	            newProduct["TotalPrice"] = (Math.round(parseFloat(line.TotalPrice) * 10000) / 10000).toFixed(2);
	            newProduct["IsTaxable"] = line.Product_id.IsTaxable;
	            newProduct["Remark"] = line.Remark;
	            newProduct["ProductType"] = line.Product_id.ProductType;
	            newProduct["PackageSize"] = line.Product_id.PackageSize;
	            newProduct["PackageType"] = line.Product_id.PackageType;
	
	            _newRows = [].concat(_toConsumableArray(_newRows), [newProduct]);
	            if (line.Product_id.IsTaxable) {
	              _totalPriceForTax2 += line.TotalPrice;
	            }
	            _totalPriceForAllLines += line.TotalPrice;
	          });
	          var _newTotalShippingWeight = currentPurchaseQuoteDetail.FinalShippingWeight;
	          var _newTotalNetWeight = currentPurchaseQuoteDetail.FinalNetWeight;
	          var newTotalPrice = parseFloat(currentPurchaseQuoteDetail.TotalPrice).toFixed(2);
	          var _finalPrice = parseFloat(currentPurchaseQuoteDetail.FinalPrice).toFixed(2);
	          var _taxRate2 = currentPurchaseQuoteDetail.TaxRate || 0;
	          var _discountValue = currentPurchaseQuoteDetail.Discount || 0;
	          var _miscCostValue = currentPurchaseQuoteDetail.MiscCost || 0;
	          var _handlingCostValue = currentPurchaseQuoteDetail.HandlingCost || 0;
	          var _shippingCostValue = currentPurchaseQuoteDetail.ShippingCost || 0;
	          var _adjustmentValue = currentPurchaseQuoteDetail.PriceAdjustment || 0;
	          var _CRV = currentPurchaseQuoteDetail.CRV;
	          var _taxValue2 = parseFloat(_taxRate2 || 0) * _totalPriceForTax2 / 100.0;
	          _taxValue2 = Math.round(0.0001 + _taxValue2 * 100) / 100;
	          this.props.setDefaultOfForm("TaxValue", _taxValue2, "purchaseOrderForm");
	          this.setState({ rows: _newRows,
	            totalShippingWeight: currentPurchaseQuoteDetail.FinalShippingWeight,
	            totalNetWeight: _newTotalNetWeight,
	            totalPrice: newTotalPrice,
	            totalPriceForTax: _totalPriceForTax2,
	            totalPriceForAllLines: _totalPriceForAllLines,
	            finalPrice: _finalPrice,
	            taxRate: _taxRate2,
	            discountValue: _discountValue,
	            miscCostValue: _miscCostValue,
	            handlingCostValue: _handlingCostValue,
	            shippingCostValue: _shippingCostValue,
	            adjustmentValue: _adjustmentValue,
	            CRV: _CRV
	          });
	        }
	        var _updateTime = new Date(currentPurchaseQuoteDetail.UpdateTime);
	        _updateTime = (0, _cleanDates.convertLocalDate)(_updateTime, 'MM-DD-YY');
	        this.setState({
	          modified_by: currentPurchaseQuoteDetail.Modifier_User_Name,
	          updateTime: _updateTime,
	          created_by: currentPurchaseQuoteDetail.Purchaser_User_Name,
	          firstRender: true
	        });
	        this.props.initializeForm(currentPurchaseQuoteDetail, [], "purchaseOrderForm");
	        this.props.setDefaultSearchType('RefNum', 'purchaseOrderForm');
	      }
	
	      if (nextProps.currentPurchaseTemplateDetail != this.props.currentPurchaseTemplateDetail && nextProps.currentPurchaseTemplateDetail) {
	        var currentPurchaseTemplateDetail = nextProps.currentPurchaseTemplateDetail;
	        if (currentPurchaseTemplateDetail.Purchase_Template_Line != null) {
	          var _newRows2 = [];
	          var _totalPriceForTax3 = 0;
	          var _totalPriceForAllLines2 = 0;
	          currentPurchaseTemplateDetail.Purchase_Template_Line.map(function (line) {
	            var newProduct = {};
	            newProduct["Product_id"] = line.Product_id.Product_id;
	            newProduct["Name"] = line.Product_id.Name;
	            newProduct["EstSalePrice"] = line.EstSalePrice; //products[index].LowestSalePrice;
	            newProduct["Quantity"] = line.Quantity;
	
	            newProduct["ProductNum"] = line.Product_id.ProductNum;
	            newProduct["Description"] = line.Product_id.Description;
	            newProduct["MeasureUnit"] = line.Product_id.MeasureUnit;
	            newProduct["FOBUnitPrice"] = line.FOBUnitPrice; //products[index].RefPrice;
	            newProduct["ShippingWeight"] = line.Product_id.ShippingWeight;
	            newProduct["NetWeight"] = line.Product_id.NetWeight;
	            newProduct["TotalNetWeight"] = line.Product_id.NetWeight * line.Quantity;
	            newProduct["TotalShippingWeight"] = line.Product_id.ShippingWeight * line.Quantity;
	            newProduct["RefNum"] = line.Product_id.RefNum;
	            newProduct["TotalPrice"] = (Math.round(parseFloat(line.TotalPrice) * 10000) / 10000).toFixed(2);
	            newProduct["IsTaxable"] = line.Product_id.IsTaxable;
	            newProduct["Remark"] = line.Remark;
	            newProduct["ProductType"] = line.Product_id.ProductType;
	            newProduct["PackageSize"] = line.Product_id.PackageSize;
	            newProduct["PackageType"] = line.Product_id.PackageType;
	
	            _newRows2 = [].concat(_toConsumableArray(_newRows2), [newProduct]);
	            if (line.Product_id.IsTaxable) {
	              _totalPriceForTax3 += line.TotalPrice;
	            }
	            _totalPriceForAllLines2 += line.TotalPrice;
	          });
	          var _newTotalShippingWeight2 = currentPurchaseTemplateDetail.FinalShippingWeight;
	          var _newTotalNetWeight2 = currentPurchaseTemplateDetail.FinalNetWeight;
	          var _newTotalPrice = parseFloat(currentPurchaseTemplateDetail.TotalPrice).toFixed(2);
	          var _finalPrice2 = parseFloat(currentPurchaseTemplateDetail.FinalPrice).toFixed(2);
	          var _taxRate3 = currentPurchaseTemplateDetail.TaxRate || 0;
	          var _discountValue2 = currentPurchaseTemplateDetail.Discount || 0;
	          var _miscCostValue2 = currentPurchaseTemplateDetail.MiscCost || 0;
	          var _handlingCostValue2 = currentPurchaseTemplateDetail.HandlingCost || 0;
	          var _shippingCostValue2 = currentPurchaseTemplateDetail.ShippingCost || 0;
	          var _adjustmentValue2 = currentPurchaseTemplateDetail.PriceAdjustment || 0;
	          var _CRV2 = currentPurchaseTemplateDetail.CRV;
	          var _taxValue3 = parseFloat(_taxRate3 || 0) * _totalPriceForTax3 / 100.0;
	          _taxValue3 = Math.round(0.0001 + _taxValue3 * 100) / 100;
	          this.props.setDefaultOfForm("TaxValue", _taxValue3, "purchaseOrderForm");
	          this.setState({ rows: _newRows2,
	            totalShippingWeight: currentPurchaseTemplateDetail.FinalShippingWeight,
	            totalNetWeight: _newTotalNetWeight2,
	            totalPrice: _newTotalPrice,
	            totalPriceForTax: _totalPriceForTax3,
	            totalPriceForAllLines: _totalPriceForAllLines2,
	            finalPrice: _finalPrice2,
	            taxRate: _taxRate3,
	            discountValue: _discountValue2,
	            miscCostValue: _miscCostValue2,
	            handlingCostValue: _handlingCostValue2,
	            shippingCostValue: _shippingCostValue2,
	            adjustmentValue: _adjustmentValue2,
	            CRV: _CRV2
	          });
	        }
	        var _updateTime2 = new Date(currentPurchaseTemplateDetail.UpdateTime);
	        _updateTime2 = (0, _cleanDates.convertLocalDate)(_updateTime2, 'MM-DD-YY');
	        this.setState({
	          modified_by: currentPurchaseTemplateDetail.Modifier_User_Name,
	          updateTime: _updateTime2,
	          created_by: currentPurchaseTemplateDetail.Purchaser_User_Name,
	          firstRender: true
	        });
	        this.props.initializeForm(currentPurchaseTemplateDetail, [], "purchaseOrderForm");
	        this.props.setDefaultSearchType('RefNum', 'purchaseOrderForm');
	      }
	
	      if (nextProps.purchaseOrderProduct && nextProps.purchaseOrderProduct !== this.props.purchaseOrderProduct) {
	        this.selectInventoryInfo(nextProps.purchaseOrderProduct);
	        console.log("nextProps", nextProps.purchaseOrderProduct);
	        this.props.fetchProductInfo(nextProps.purchaseOrderProduct.Product_id);
	        this.props.setPriceValues(nextProps.purchaseOrderProduct.ProductCost, nextProps.purchaseOrderProduct.LowestSalePrice, 'purchaseOrderForm');
	        this.props.setDefaultOfForm('Weight', nextProps.purchaseOrderProduct.NetWeight, 'purchaseOrderForm');
	        this.props.setValue('purchaseOrderForm', 'RefSalePrice', nextProps.purchaseOrderProduct.PriceLv5);
	      }
	
	      if (nextProps.purchaseOrderPdf && nextProps.purchaseOrderPdf !== this.props.purchaseOrderPdf) {
	        this.setState({ PdfFrameLoaded: false });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState.PdfFrameLoaded !== this.state.PdfFrameLoaded && this.state.PdfFrameLoaded == false) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      if (window.innerHeight < 930) {
	        this.setState({ yourOrderTableHeight: this.state.yourOrderKey == 1 ? 198 : 350 });
	      } else {
	        this.setState({ yourOrderTableHeight: this.state.yourOrderKey == 1 ? 198 : 350 });
	      }
	    }
	
	    // If the form is dirty, ask for confirmation.
	
	  }, {
	    key: 'routerWillLeave',
	    value: function routerWillLeave(nextLocation) {
	      if (this.props.pristine == false) {
	        alert("you will leave this page");
	      }
	    }
	  }, {
	    key: 'handleOnFocus',
	    value: function handleOnFocus(event) {
	      event.target.select();
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(yourOrderKey) {
	      switch (yourOrderKey) {
	        case 1:
	          this.setState({ yourOrderTableHeight: window.innerHeight < 930 ? 198 : 198, yourOrderKey: yourOrderKey });
	          break;
	        default:
	          this.setState({ yourOrderTableHeight: window.innerHeight < 930 ? 350 : 350, yourOrderKey: yourOrderKey });
	      }
	    }
	  }, {
	    key: 'openShowCustomer',
	    value: function openShowCustomer() {
	      this.setState({ showCustomerOpen: true });
	    }
	  }, {
	    key: 'closeShowCustomer',
	    value: function closeShowCustomer() {
	      this.setState({ showCustomerOpen: false });
	    }
	  }, {
	    key: 'openShowInventory',
	    value: function openShowInventory(event) {
	      if (!this.props.allProducts || this.props.allProducts == "") {
	        return;
	      }
	      switch (event.charCode) {
	        case 13:
	          // ENTER
	          event.preventDefault();
	          this.setState({ showInventoryOpen: true });
	          break;
	      }
	    }
	  }, {
	    key: 'closeShowInventory',
	    value: function closeShowInventory(value) {
	      this.setState({ showInventoryOpen: false });
	      if (value) _reactDom2.default.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	    }
	  }, {
	    key: 'openShowPOCreated',
	    value: function openShowPOCreated() {
	      this.setState({ showPOCreatedOpen: true });
	    }
	  }, {
	    key: 'closeShowPOCreated',
	    value: function closeShowPOCreated() {
	      this.setState({ showPOCreatedOpen: false });
	    }
	  }, {
	    key: 'openConfirm',
	    value: function openConfirm() {
	      this.setState({ confirmOpen: true });
	    }
	  }, {
	    key: 'closeConfirm',
	    value: function closeConfirm() {
	      this.setState({ confirmOpen: false });
	    }
	  }, {
	    key: 'openChangeTax',
	    value: function openChangeTax() {
	      this.setState({ changeTaxOpen: true });
	    }
	  }, {
	    key: 'closeChangeTax',
	    value: function closeChangeTax() {
	      this.setState({ changeTaxOpen: false });
	      var _state = this.state,
	          CRV = _state.CRV,
	          totalPriceForAllLines = _state.totalPriceForAllLines,
	          discountValue = _state.discountValue,
	          totalPriceForTax = _state.totalPriceForTax,
	          taxRate = _state.taxRate;
	
	      var miscCostValue = parseFloat(this.state.miscCostValue) || 0;
	      var handlingCostValue = parseFloat(this.state.handlingCostValue) || 0;
	      var shippingCostValue = parseFloat(this.state.shippingCostValue) || 0;
	      var adjustmentValue = parseFloat(this.state.adjustmentValue) || 0;
	      var finalPrice = CRV + Math.round(miscCostValue * 100) / 100 + Math.round(adjustmentValue * 100) / 100 + Math.round(handlingCostValue * 100) / 100 + Math.round(shippingCostValue * 100) / 100 + totalPriceForAllLines * (1 - discountValue / 100.0) + Math.round(totalPriceForTax * taxRate / 100.0 * 100) / 100;
	      finalPrice = parseFloat(Math.round(finalPrice * 100) / 100).toFixed(2);
	      this.setState({
	        finalPrice: finalPrice
	      });
	    }
	  }, {
	    key: 'redirect',
	    value: function redirect() {
	      if (this.props.purchaseQuoteCreated || this.props.purchaseQuoteEdited) {
	        this.context.router.push('/purchaseQuote');
	      } else if (this.props.purchaseTemplateCreated || this.props.purchaseTemplateEdited) {
	        this.context.router.push('/purchaseTemplate');
	      } else {
	        this.context.router.push('/purchaseOrder');
	      }
	    }
	  }, {
	    key: 'updateTimeformatDate',
	    value: function updateTimeformatDate(date) {
	      var formattedDate = date.getFullYear() + '-';
	      var month = date.getMonth() + 1;
	      if (month < 10) formattedDate += '0' + month + '-';else formattedDate += month + '-';
	      if (date.getDate() < 10) {
	        formattedDate += '0' + date.getDate();
	      } else {
	        formattedDate += date.getDate();
	      }
	      return formattedDate;
	    }
	  }, {
	    key: 'selectInventoryInfo',
	    value: function selectInventoryInfo(selectedInventoryRow) {
	      this.setState({ selectedInventoryRow: selectedInventoryRow });
	      var index = _lodash2.default.findIndex(this.props.simplifiedProducts, { 'Product_id': selectedInventoryRow.Product_id });
	      if (index > -1) {
	        this.props.fetchProductInfo(this.props.simplifiedProducts[index].Product_id);
	        this.props.setPriceValues(this.props.simplifiedProducts[index].ProductCost, this.props.simplifiedProducts[index].LowestSalePrice, 'purchaseOrderForm');
	        if ((this.props.simplifiedProducts[index].ProductType == "Non-Fixed" || this.props.simplifiedProducts[index].ProductType == "Per-Pound") && !this.props.simplifiedProducts[index].NetWeight) {
	          alert("Net Weight Cannot Be 0! Change Net Weight in Product Page!");
	        }
	        this.props.setDefaultOfForm('Weight', this.props.simplifiedProducts[index].NetWeight, 'purchaseOrderForm');
	      }
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      var formattedDate = date.getFullYear() + '-';
	
	      formattedDate += date.getMonth() + 1 + '-';
	      if (date.getDate() < 10) {
	        formattedDate += '0' + date.getDate() + 'T';
	      } else {
	        formattedDate += date.getDate() + 'T';
	      }
	
	      if (date.getHours() < 10) {
	        formattedDate += '0' + date.getHours() + ':';
	      } else {
	        formattedDate += date.getHours() + ':';
	      }
	
	      if (date.getMinutes() < 10) {
	        formattedDate += '0' + date.getMinutes() + ':';
	      } else {
	        formattedDate += date.getMinutes() + ':';
	      }
	
	      if (date.getSeconds < 10) {
	        formattedDate += '0' + date.getSeconds();
	      } else {
	        formattedDate += date.getSeconds();
	      }
	      return formattedDate;
	    }
	
	    // Selection -> Selection
	
	  }, {
	    key: 'handleKeyPressTargetSelection',
	    value: function handleKeyPressTargetSelection(value, event) {
	      if (event.keyCode == 13) {
	        if (value == "") {
	          event.preventDefault();
	          return;
	        }
	        this.refs[value].getRenderedComponent().refs.select.focus();
	        // ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	      }
	    }
	
	    // Selection -> Input
	
	  }, {
	    key: 'handleKeyPressTargetInput',
	    value: function handleKeyPressTargetInput(value, event) {
	      if (event.keyCode == 13) {
	        _reactDom2.default.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	      }
	    }
	
	    // Input -> Input
	
	  }, {
	    key: 'handleKeyPressMove',
	    value: function handleKeyPressMove(event) {
	      if (event.charCode == 13) {
	        event.preventDefault();
	        this.moveToProductsListFromAll();
	      }
	    }
	  }, {
	    key: 'handleKeyPressMoveVendor',
	    value: function handleKeyPressMoveVendor(event) {
	      if (event.charCode == 13) {
	        event.preventDefault();
	        this.moveToProductsList();
	      }
	    }
	  }, {
	    key: 'renderVendorsDetail',
	
	
	    // Render Select options dynamically with the information on the server.
	
	    value: function renderVendorsDetail() {
	      var vendorNameOptions = []; // Return a JSON in the format of React-Select's options
	      var vendorNumOptions = [];
	      var vendorTelOptions = [];
	      if (this.props.vendorIsLoading && !this.props.vendorError) {
	        vendorNameOptions = [{ value: "Loading", label: "Loading" }]; // Return a JSON in the format of React-Select's options
	        vendorNumOptions = [{ value: "Loading", label: "Loading" }];
	        vendorTelOptions = [{ value: "Loading", label: "Loading" }];
	      } // If vendor is loading, show a spinner.
	      var SelectionForVendor = this.props.currentPurchaseOrder || this.props.currentPurchaseQuote || this.props.currentPurchaseTemplate ? _selection.DisabledSelection : _selection.Selection;
	      if (this.props.vendorError) return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'error' })
	      ); // If vendor is loading, show a spinner.
	      else {
	          vendorNameOptions = this.getVendorNameOptions(); // Return a JSON in the format of React-Select's options
	          vendorNumOptions = this.getVendorNumOptions();
	          vendorTelOptions = this.getVendorTelOptions();
	          return _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4, id: 'vendor-info' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_information' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-3' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'asteriksReq' },
	                  '*'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-8' },
	                _react2.default.createElement(_reduxForm.Field, {
	                  name: 'Vendor_id',
	                  ref: 'vendor_name',
	                  withRef: true,
	                  component: SelectionForVendor,
	                  options: vendorNameOptions,
	                  onKeyPress: function onKeyPress(event) {
	                    if (event.keyCode == 13) {
	                      var myField = document.getElementById('purchase-auto-suggest');
	                      if (myField) {
	                        myField.select();
	                      }
	                    }
	                  },
	                  matchPos: 'any'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-3' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_no' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-8' },
	                _react2.default.createElement(_reduxForm.Field, {
	                  name: 'Vendor_id',
	                  ref: 'vendor_no',
	                  withRef: true,
	                  component: SelectionForVendor,
	                  options: vendorNumOptions,
	                  onKeyPress: function onKeyPress(event) {
	                    if (event.keyCode == 13) {
	                      var myField = document.getElementById('purchase-auto-suggest');
	                      if (myField) {
	                        myField.select();
	                      }
	                    }
	                  },
	                  matchPos: 'any'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-3' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-8' },
	                _react2.default.createElement(_reduxForm.Field, {
	                  name: 'Vendor_id',
	                  ref: 'vendor_no',
	                  withRef: true,
	                  component: SelectionForVendor,
	                  options: vendorTelOptions,
	                  onKeyPress: function onKeyPress(event) {
	                    if (event.keyCode == 13) {
	                      var myField = document.getElementById('purchase-auto-suggest');
	                      if (myField) {
	                        myField.select();
	                      }
	                    }
	                  },
	                  matchPos: 'any'
	                })
	              )
	            )
	          );
	        }
	    }
	
	    // Push vendor name and number in to 2 JSON arrays.
	
	  }, {
	    key: 'getVendorNameOptions',
	    value: function getVendorNameOptions() {
	      var vendorNameOptions = [];
	      this.props.vendors.map(function (vendor) {
	        vendorNameOptions.push({ value: vendor.Vendor_id, label: vendor.Name });
	      });
	      return vendorNameOptions;
	    }
	  }, {
	    key: 'getVendorNumOptions',
	    value: function getVendorNumOptions() {
	      var vendorNumOptions = [];
	      this.props.vendors.map(function (vendor) {
	        vendorNumOptions.push({ value: vendor.Vendor_id, label: vendor.VendorNum });
	      });
	      return vendorNumOptions;
	    }
	  }, {
	    key: 'getVendorTelOptions',
	    value: function getVendorTelOptions() {
	      var vendorNumOptions = [];
	      this.props.vendors.map(function (vendor) {
	        vendorNumOptions.push({ value: vendor.Vendor_id, label: vendor.Telephone });
	      });
	      return vendorNumOptions;
	    }
	  }, {
	    key: 'getTaxRateOptions',
	    value: function getTaxRateOptions() {
	      var taxRateOptions = [];
	      if (this.props.taxRates) {
	        this.props.taxRates.map(function (taxRate) {
	          taxRateOptions.push({ value: taxRate.Rate, label: taxRate.Rate });
	        });
	      }
	      return taxRateOptions;
	    }
	  }, {
	    key: 'renderBillingAddress1',
	    value: function renderBillingAddress1() {
	      var _props4 = this.props,
	          vendorsValue = _props4.vendorsValue,
	          currentVendorDetail = _props4.currentVendorDetail;
	
	      if (currentVendorDetail && currentVendorDetail.Billing) {
	        var Address1 = currentVendorDetail.Billing.Street;
	        return Address1;
	      }
	    }
	  }, {
	    key: 'renderBillingAddress2',
	    value: function renderBillingAddress2() {
	      var _props5 = this.props,
	          vendorsValue = _props5.vendorsValue,
	          currentVendorDetail = _props5.currentVendorDetail;
	
	      if (currentVendorDetail && currentVendorDetail.Billing) {
	        var Address2 = currentVendorDetail.Billing.City + " " + currentVendorDetail.Billing.State + currentVendorDetail.Billing.Zip;
	        return Address2;
	      }
	    }
	
	    // Once a vendor is chosen, render its shipping address and contacts
	
	  }, {
	    key: 'renderVendorAddress',
	    value: function renderVendorAddress() {
	      var currentVendorDetail = this.props.currentVendorDetail;
	
	      if (this.props.currentVendorDetail) {
	        var vendorAddressOptions = this.getVendorAddressOptions();
	        var vendorContactOptions = this.getVendorContactOptions();
	        if (!this.props.shippingMethod) return;else if (this.props.shippingMethod == "Pickup" || this.props.shippingMethod.value == "Pickup") {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_vendor_address' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: 'Pickup_VendorDetail_id', component: _selection.Selection, ref: 'pickup_VendorDetail_id', withRef: true,
	                options: vendorAddressOptions, defaultValue: vendorAddressOptions[0] })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_contact' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: 'Pickup_VendorDetail_id', component: _selection.Selection, ref: 'pickup_VendorDetail_id', withRef: true,
	                options: vendorContactOptions, defaultValue: vendorContactOptions[0] })
	            )
	          );
	        } else return;
	      }
	    }
	  }, {
	    key: 'getVendorAddressOptions',
	    value: function getVendorAddressOptions() {
	      var vendorAddressOptions = [];
	      if (this.props.currentVendorDetail && this.props.currentVendorDetail.Shipping) {
	        this.props.currentVendorDetail.Shipping.map(function (address) {
	          vendorAddressOptions.push({ value: address.VendorDetail_id, label: address.AddressName + ', ' + address.City });
	        });
	      }
	      return vendorAddressOptions;
	    }
	  }, {
	    key: 'getVendorContactOptions',
	    value: function getVendorContactOptions() {
	      var vendorContactOptions = [];
	      if (this.props.currentVendorDetail && this.props.currentVendorDetail.Shipping) {
	        this.props.currentVendorDetail.Shipping.map(function (contact) {
	          vendorContactOptions.push({ value: contact.VendorDetail_id, label: contact.FirstName + ' ' + contact.LastName });
	        });
	      }
	      return vendorContactOptions;
	    }
	  }, {
	    key: 'renderVendorContactInformation',
	    value: function renderVendorContactInformation() {
	      var _props6 = this.props,
	          currentVendorDetail = _props6.currentVendorDetail,
	          vendorsValue = _props6.vendorsValue,
	          vendorContactValue = _props6.vendorContactValue;
	
	      if (vendorContactValue && currentVendorDetail) {
	        var index = _lodash2.default.findIndex(currentVendorDetail.Shipping, { 'VendorDetail_id': vendorContactValue });
	        if (index != -1) return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 9 },
	              currentVendorDetail.Shipping[index].FirstName + ' ' + currentVendorDetail.Shipping[index].LastName
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 9 },
	              currentVendorDetail.Shipping[index].Email
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 9 },
	              currentVendorDetail.Shipping[index].Telephone
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'checkisValid',
	    value: function checkisValid() {
	      if (!isNumber(this.props.allProdQuantity) || this.props.allProdQuantity < 0 || !isNumber(this.props.allProdFOBUnitPrice) || this.props.allProdFOBUnitPrice < 0) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'moveToProductsListFromAll',
	    value: function moveToProductsListFromAll() {
	      if (this.state.selectedInventoryRow.Product_id == null) {
	        this.setState({ confirmOpen: true, case: 'chooseProduct' });
	        return;
	      }
	      var _props7 = this.props,
	          simplifiedProducts = _props7.simplifiedProducts,
	          productInformation = _props7.productInformation,
	          allProdRemark = _props7.allProdRemark;
	
	      console.log("check?2");
	      var quantity = this.props.allProdQuantity || 0;
	      var newProduct = {};
	      var rows = this.state.rows;
	      var selectedInventoryRow = this.state.selectedInventoryRow;
	      var checkDuplicate = _lodash2.default.findIndex(rows, { 'Product_id': selectedInventoryRow.Product_id });
	      if (checkDuplicate > -1) {
	        alert("Product already exists!");
	        this.props.resetAllProducts('purchaseOrderForm');
	        this.setState({ suggestValue: '' });
	        return;
	      }
	      if (!this.checkisValid()) {
	        return;
	      }
	      // const index = _.findIndex(simplifiedProducts, { 'Product_id': selectedInventoryRow.Product_id });
	      // if (index > -1) {
	      // INCOMPLETE: change this to refPrice and fix other places where refPrice
	      var refPrice = this.props.allProdFOBUnitPrice || 0;
	
	      newProduct["Product_id"] = this.state.selectedInventoryRow.Product_id;
	      newProduct["IsTaxable"] = this.state.selectedInventoryRow.IsTaxable;
	      newProduct["ProductNum"] = this.state.selectedInventoryRow.ProductNum;
	      newProduct["Name"] = this.state.selectedInventoryRow.Name;
	      newProduct["Description"] = this.state.selectedInventoryRow.Description;
	      newProduct["MeasureUnit"] = this.state.selectedInventoryRow.MeasureUnit;
	      newProduct["ProductType"] = this.state.selectedInventoryRow.ProductType;
	      newProduct["PackageSize"] = this.state.selectedInventoryRow.PackageSize;
	      newProduct["FOBUnitPrice"] = refPrice; //products[index].RefPrice;
	      newProduct["ShippingWeight"] = this.state.selectedInventoryRow.ShippingWeight;
	      newProduct["NetWeight"] = this.state.selectedInventoryRow.NetWeight;
	      newProduct["TotalShippingWeight"] = this.state.selectedInventoryRow.ShippingWeight * quantity;
	      newProduct["TotalNetWeight"] = this.state.selectedInventoryRow.NetWeight * quantity;
	      newProduct["RefNum"] = this.state.selectedInventoryRow.RefNum;
	      newProduct["Quantity"] = quantity;
	      newProduct["NetWeight"] = this.state.selectedInventoryRow.NetWeight;
	      newProduct["CRV"] = this.state.selectedInventoryRow.CRV;
	      var weight = parseFloat(newProduct["NetWeight"]) || 0;
	      if (this.state.selectedInventoryRow.ProductType == "Per-Pound") {
	        newProduct["TotalPrice"] = parseFloat(Math.round(parseFloat(quantity * refPrice * weight) * 100) / 100).toFixed(2);
	      } else if (this.state.selectedInventoryRow.ProductType == "Non-Fixed") {
	        newProduct["TotalPrice"] = parseFloat(Math.round(parseFloat(quantity * refPrice * weight) * 100) / 100).toFixed(2);
	      } else {
	        newProduct["TotalPrice"] = parseFloat(Math.round(parseFloat(quantity * refPrice) * 100) / 100).toFixed(2);
	      }
	
	      newProduct["Remark"] = allProdRemark;
	      var newRows = [].concat(_toConsumableArray(this.state.rows));
	      newRows.unshift(newProduct);
	      var totalShippingWeight = 0;
	      var totalNetWeight = 0;
	      totalNetWeight = parseFloat(this.state.totalNetWeight) + (parseFloat(quantity) || 0) * (parseFloat(newProduct["NetWeight"]) || 0);
	      totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
	      totalShippingWeight = parseFloat(this.state.totalShippingWeight) + (parseFloat(quantity) || 0) * (parseFloat(newProduct["ShippingWeight"]) || 0);
	      totalShippingWeight = parseFloat(Math.round(totalShippingWeight * 100) / 100).toFixed(2);
	      var totalPrice = parseFloat(this.state.totalPrice) + parseFloat(newProduct["TotalPrice"]);
	      totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	
	      var totalPriceForTax = parseFloat(this.state.totalPriceForTax);
	      var totalPriceForAllLines = parseFloat(this.state.totalPriceForAllLines);
	
	      if (this.state.selectedInventoryRow.IsTaxable) {
	        totalPriceForTax = totalPriceForTax + parseFloat(newProduct["TotalPrice"]);
	      }
	      totalPriceForAllLines = totalPriceForAllLines + parseFloat(newProduct["TotalPrice"]);
	      totalPriceForAllLines = parseFloat(Math.round(totalPriceForAllLines * 100) / 100).toFixed(2);
	
	      var discountValue = parseFloat(this.state.discountValue) || 0;
	      var taxRate = parseFloat(this.state.taxRate) || 0;
	      var miscCostValue = parseFloat(this.state.miscCostValue) || 0;
	      var handlingCostValue = parseFloat(this.state.handlingCostValue) || 0;
	      var shippingCostValue = parseFloat(this.state.shippingCostValue) || 0;
	      var adjustmentValue = parseFloat(this.state.adjustmentValue) || 0;
	
	      var CRV = +roundTo(this.state.CRV + newProduct["CRV"] * (parseFloat(quantity) || 0), 2).toFixed(2);
	
	      var finalPrice = Math.round(CRV * 100) / 100 + Math.round(miscCostValue * 100) / 100 + Math.round(adjustmentValue * 100) / 100 + Math.round(handlingCostValue * 100) / 100 + Math.round(shippingCostValue * 100) / 100 + totalPriceForAllLines * (1 - discountValue / 100.0) + Math.round(totalPriceForTax * taxRate / 100.0 * 100) / 100;
	      finalPrice = (Math.round(finalPrice * 100) / 100).toFixed(2);
	      var taxValue = parseFloat(taxRate || 0) * totalPriceForTax / 100.0;
	      taxValue = Math.round(0.0001 + taxValue * 100) / 100;
	      this.props.setDefaultOfForm("TaxValue", taxValue, "purchaseOrderForm");
	      this.setState({
	        rows: newRows,
	        totalShippingWeight: totalShippingWeight || 0,
	        totalNetWeight: totalNetWeight || 0,
	        totalPrice: totalPrice || 0,
	        totalPriceForTax: totalPriceForTax || 0,
	        totalPriceForAllLines: totalPriceForAllLines || 0,
	        CRV: CRV,
	        finalPrice: finalPrice || 0,
	        quantity: 0,
	        productType: null,
	        suggestValue: ''
	      });
	      // }
	      // ReactDOM.findDOMNode(this.refs["allProducts"].getRenderedComponent().myInput.refs.input).focus();
	      this.props.resetAllProducts('purchaseOrderForm');
	    }
	  }, {
	    key: 'moveToProductsList',
	    value: function moveToProductsList() {
	      var _this3 = this;
	
	      var _props8 = this.props,
	          products = _props8.products,
	          productInformation = _props8.productInformation,
	          remark = _props8.remark;
	
	      var quantity = 0;
	      var rows = this.state.rows;
	      var vendorProducts = [].concat(_toConsumableArray(this.state.vendorProducts.selectedIndexes));
	      var newRows = [].concat(_toConsumableArray(this.state.rows));
	      var checkDuplicate = -1;
	      var index = -1;
	      vendorProducts.map(function (productInformation) {
	        checkDuplicate = _lodash2.default.findIndex(rows, { 'Product_id': _this3.state.vendorProducts.rows[productInformation].Product_id });
	        if (checkDuplicate > -1) {
	          alert("Product already exists!");
	        } else {
	          var newProduct = {};
	          index = _lodash2.default.findIndex(products, { 'Product_id': _this3.state.vendorProducts.rows[productInformation].Product_id });
	          newProduct = _extends({}, products[index]);
	          newProduct["FOBUnitPrice"] = products[index].ProductCost; //products[index].RefPrice;
	          newProduct["TotalShippingWeight"] = products[index].ShippingWeight * quantity;
	          newProduct["TotalNetWeight"] = products[index].NetWeight * quantity;
	          newProduct["Quantity"] = 0;
	          newProduct["TotalPrice"] = parseFloat("0").toFixed(2);
	          newRows.unshift(newProduct);
	        }
	      });
	      this.setState({
	        rows: newRows,
	        quantity: 0
	      });
	      this.props.resetAllProducts('purchaseOrderForm');
	      // this.refs["productInformation"].getRenderedComponent().refs.select.focus();
	    }
	  }, {
	    key: 'moveOffFromProductsList',
	    value: function moveOffFromProductsList(Product_id) {
	      var newRows = this.state.rows;
	      var totalShippingWeight = 0;
	      var totalNetWeight = 0;
	      var totalPrice = 0;
	      var discountValue = parseFloat(this.state.discountValue) || 0;
	      var taxRate = parseFloat(this.state.taxRate) || 0;
	      newRows = newRows.filter(function (obj) {
	        return obj.Product_id != Product_id;
	      });
	      var totalPriceForTax = 0;
	      var totalPriceForAllLines = 0;
	      var CRV = 0;
	      newRows.map(function (newRow) {
	        CRV = Math.round(CRV + (parseFloat(newRow["CRV"]) || 0) * (parseFloat(newRow["Quantity"]) || 0) * 100) / 100;
	        totalShippingWeight = parseFloat(totalShippingWeight) + parseFloat(newRow["Quantity"]) * parseFloat(newRow["ShippingWeight"]);
	        totalNetWeight = parseFloat(totalNetWeight) + parseFloat(newRow["Quantity"]) * parseFloat(newRow["NetWeight"]);
	        totalPrice = (parseFloat(totalPrice) || 0) + (parseFloat(newRow["TotalPrice"]) || 0);
	        if (newRow["IsTaxable"]) {
	          totalPriceForTax = (parseFloat(totalPriceForTax) || 0) + (parseFloat(newRow["TotalPrice"]) || 0);
	        }
	        totalPriceForAllLines = (parseFloat(totalPriceForAllLines) || 0) + (parseFloat(newRow["TotalPrice"]) || 0);
	      });
	      totalShippingWeight = parseFloat(Math.round(totalShippingWeight * 100) / 100).toFixed(2) || 0;
	      totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2) || 0;
	      totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	      var miscCostValue = parseFloat(this.state.miscCostValue) || 0;
	      var handlingCostValue = parseFloat(this.state.handlingCostValue) || 0;
	      var shippingCostValue = parseFloat(this.state.shippingCostValue) || 0;
	      var adjustmentValue = parseFloat(this.state.adjustmentValue) || 0;
	      var finalPrice = CRV + Math.round(miscCostValue * 100) / 100 + Math.round(adjustmentValue * 100) / 100 + Math.round(handlingCostValue * 100) / 100 + Math.round(shippingCostValue * 100) / 100 + totalPriceForAllLines * (1 - discountValue / 100.0) + Math.round(totalPriceForTax * taxRate / 100.0 * 100) / 100;
	      finalPrice = (Math.round(finalPrice * 100) / 100).toFixed(2);
	      var taxValue = parseFloat(taxRate || 0) * totalPriceForTax / 100.0;
	      taxValue = Math.round(0.0001 + taxValue * 100) / 100;
	      this.props.setDefaultOfForm("TaxValue", taxValue, "purchaseOrderForm");
	      this.setState({ rows: newRows,
	        selectedRows: null,
	        totalShippingWeight: totalShippingWeight,
	        totalNetWeight: totalNetWeight,
	        totalPrice: totalPrice,
	        totalPriceForTax: totalPriceForTax,
	        totalPriceForAllLines: totalPriceForAllLines,
	        finalPrice: finalPrice,
	        CRV: CRV });
	    }
	  }, {
	    key: 'handleLowestSalePriceChange',
	    value: function handleLowestSalePriceChange(event) {
	      this.setState({ lowestSalePrice: event.target.value });
	    }
	  }, {
	    key: 'handleQuantityChange',
	    value: function handleQuantityChange(event) {
	      this.setState({ quantity: event.target.value });
	    }
	  }, {
	    key: 'renderProducts',
	    value: function renderProducts() {
	      var _this4 = this;
	
	      var moveOffFromProductsList = this.moveOffFromProductsList;
	      if (this.props.detailIsLoading && !this.props.detailError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.detailError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.detailError)
	        )
	      );else {
	        var productNumOptions = this.getProductNumOptions();
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this4.state);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return Object.assign({ Idx: rowIdx + 1 }, rows[rowIdx]);
	        };
	
	        // Handle the row select function
	
	        var onRowSelect = function onRowSelect(rows) {
	          _this4.setState.apply(_this4, _toConsumableArray(_this4.state).concat([{ selectedRows: rows }]));
	        };
	
	        var onRowsSelected = function onRowsSelected(rows) {
	          var newRows = getRows();
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = true;
	          });
	          _this4.setState({ rows: newRows });
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          var newRows = getRows();
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = false;
	          });
	          _this4.setState({ rows: newRows });
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var state = Object.assign({}, _this4.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this4.setState(state);
	        };
	
	        var handleFilterChange = function handleFilterChange(filter) {
	          var newFilters = Object.assign({}, _this4.state.filters);
	          if (filter.filterTerm) {
	            newFilters[filter.column.key] = filter;
	          } else {
	            delete newFilters[filter.column.key];
	          }
	          _this4.setState({ filters: newFilters });
	        };
	
	        var onRowClick = function onRowClick(rowIdx, row) {
	          // this.props.fetchSalesOrders();
	          if (rowIdx > -1) {
	            _this4.props.fetchProductInfo(row.Product_id);
	          }
	        };
	
	        // Handle the editable function
	
	        var handleRowUpdated = function handleRowUpdated(e) {
	          var rows = getRows();
	          var discountValue = parseFloat(_this4.state.discountValue) || 0;
	          var taxRate = parseFloat(_this4.state.taxRate) || 0;
	          var weight = parseFloat(rows[e.rowIdx].NetWeight) || 0;
	          var price = parseFloat(rows[e.rowIdx].TotalPrice) || 0;
	          if (e.updated.Quantity != null && isNumber(e.updated.Quantity) && e.updated.Quantity > 0) {
	            var quantity = rows[e.rowIdx].Quantity;
	            Object.assign(rows[e.rowIdx], e.updated);
	            if (rows[e.rowIdx].ProductType == "Per-Pound") {
	              Object.assign(rows[e.rowIdx], { TotalPrice: roundTo(parseFloat(e.updated.Quantity * rows[e.rowIdx].FOBUnitPrice * weight), 2).toFixed(2) });
	            } else if (rows[e.rowIdx].ProductType == "Non-Fixed") {
	              Object.assign(rows[e.rowIdx], { TotalPrice: roundTo(parseFloat(e.updated.Quantity * rows[e.rowIdx].FOBUnitPrice * weight), 2).toFixed(2) });
	            } else {
	              var t = e.updated.Quantity * rows[e.rowIdx].FOBUnitPrice;
	              Object.assign(rows[e.rowIdx], { TotalPrice: roundTo(parseFloat(e.updated.Quantity * rows[e.rowIdx].FOBUnitPrice), 2).toFixed(2) });
	            }
	            Object.assign(rows[e.rowIdx], { TotalShippingWeight: roundTo(parseFloat(e.updated.Quantity * rows[e.rowIdx].ShippingWeight), 2).toFixed(2), TotalNetWeight: roundTo(parseFloat(e.updated.Quantity * rows[e.rowIdx].NetWeight), 2).toFixed(2) });
	          } else if (e.updated.FOBUnitPrice != null && isNumber(e.updated.FOBUnitPrice) && e.updated.FOBUnitPrice > 0) {
	            var FOBUnitPrice = rows[e.rowIdx].FOBUnitPrice;
	            Object.assign(rows[e.rowIdx], e.updated);
	            if (rows[e.rowIdx].ProductType == "Per-Pound") {
	              Object.assign(rows[e.rowIdx], { TotalPrice: roundTo(parseFloat(e.updated.FOBUnitPrice * (parseFloat(rows[e.rowIdx].Quantity) || 0) * weight), 2).toFixed(2) });
	            } else if (rows[e.rowIdx].ProductType == "Non-Fixed") {
	              Object.assign(rows[e.rowIdx], { TotalPrice: roundTo(parseFloat(e.updated.FOBUnitPrice * (parseFloat(rows[e.rowIdx].Quantity) || 0) * weight), 2).toFixed(2) });
	            } else {
	              Object.assign(rows[e.rowIdx], { TotalPrice: roundTo(parseFloat(e.updated.FOBUnitPrice * (parseFloat(rows[e.rowIdx].Quantity) || 0)), 2).toFixed(2) });
	            }
	          } else if (e.updated.FOBUnitPrice < 0) {
	            alert("Unit Price is not allowed to be negative");
	          } else if (e.updated.Quantity < 0) {
	            alert("Quantity is not allowed to be negative");
	          } else if (e.updated.Remark != null) {
	            Object.assign(rows[e.rowIdx], e.updated);
	          }
	
	          var miscCostValue = parseFloat(_this4.state.miscCostValue) || 0;
	          var handlingCostValue = parseFloat(_this4.state.handlingCostValue) || 0;
	          var shippingCostValue = parseFloat(_this4.state.shippingCostValue) || 0;
	          var adjustmentValue = parseFloat(_this4.state.adjustmentValue) || 0;
	          var totalPrice = 0;
	          var totalPriceForTax = 0;
	          var totalPriceForAllLines = 0;
	          var CRV = 0;
	          var totalShippingWeight = 0;
	          var totalNetWeight = 0;
	          rows.map(function (row) {
	            totalPrice += parseFloat(row["TotalPrice"]);
	            totalPriceForAllLines += parseFloat(row["TotalPrice"]);
	            if (row["IsTaxable"]) {
	              totalPriceForTax += parseFloat(row["TotalPrice"]);
	            }
	            CRV += Math.round((parseFloat(row["CRV"]) || 0) * (parseFloat(row["Quantity"]) || 0) * 100) / 100;
	            totalShippingWeight += (parseFloat(row["Quantity"]) || 0) * (parseFloat(row["ShippingWeight"]) || 0);
	            totalNetWeight += (parseFloat(row["Quantity"]) || 0) * (parseFloat(row["NetWeight"]) || 0);
	          });
	          totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	          totalPriceForTax = parseFloat(totalPriceForTax);
	          totalPriceForAllLines = parseFloat(Math.round(totalPriceForAllLines * 100) / 100).toFixed(2);
	
	          var finalPrice = CRV + Math.round(miscCostValue * 100) / 100 + Math.round(adjustmentValue * 100) / 100 + Math.round(handlingCostValue * 100) / 100 + Math.round(shippingCostValue * 100) / 100 + totalPriceForAllLines * (1 - discountValue / 100.0) + Math.round(totalPriceForTax * taxRate / 100.0 * 100) / 100;
	          finalPrice = (Math.round(finalPrice * 100) / 100).toFixed(2);
	
	          totalShippingWeight = parseFloat(Math.round(totalShippingWeight * 100) / 100).toFixed(2);
	          totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
	          var taxValue = parseFloat(taxRate || 0) * totalPriceForTax / 100.0;
	          taxValue = Math.round(0.0001 + taxValue * 100) / 100;
	          _this4.props.setDefaultOfForm("TaxValue", taxValue, "purchaseOrderForm");
	
	          _this4.setState({ rows: rows,
	            totalShippingWeight: totalShippingWeight,
	            totalNetWeight: totalNetWeight,
	            totalPrice: totalPrice,
	            totalPriceForTax: totalPriceForTax,
	            totalPriceForAllLines: totalPriceForAllLines,
	            finalPrice: finalPrice,
	            CRV: CRV
	          });
	        };
	
	        //Custom Formatter component
	
	        var DateFormatter = _react2.default.createClass({
	          displayName: 'DateFormatter',
	          render: function render() {
	            if (this.props.value) {
	              var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	              var date = new Date(this.props.value);
	              var index = dateMap.indexOf(date.toString().slice(4, 3));
	              var localDate = index + date.toString().slice(8, 6);
	              return _react2.default.createElement(
	                'span',
	                null,
	                date.toString().slice(4, 15)
	              );;
	            } else return _react2.default.createElement(
	              'span',
	              { className: 'label label-danger' },
	              '-'
	            );
	          }
	        });
	
	        var VendorNameFormatter = _react2.default.createClass({
	          displayName: 'VendorNameFormatter',
	          render: function render() {
	            if (this.props.value) return _react2.default.createElement(
	              'span',
	              null,
	              this.props.value.Name
	            );else return _react2.default.createElement(
	              'span',
	              { className: 'label label-danger' },
	              '-'
	            );
	          }
	        });
	
	        var VendorNumFormatter = _react2.default.createClass({
	          displayName: 'VendorNumFormatter',
	          render: function render() {
	            if (this.props.value) return _react2.default.createElement(
	              'span',
	              null,
	              this.props.value.VendorNum
	            );else return _react2.default.createElement(
	              'span',
	              { className: 'label label-danger' },
	              '-'
	            );
	          }
	        });
	
	        var IsVariableFormatter = _react2.default.createClass({
	          displayName: 'IsVariableFormatter',
	          render: function render() {
	            var _this5 = this;
	
	            return _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  className: 'textAlignStyle',
	                  style: { height: '23px', width: '39px', padding: '0px' },
	                  onClick: function onClick() {
	                    moveOffFromProductsList(_this5.props.dependentValues.Product_id);
	                  }
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'X' })
	              )
	            );
	          }
	        });
	
	        // React Table Your Purchase Order
	
	        var columns = [{
	          key: 'Delete',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	          formatter: IsVariableFormatter,
	          width: 50,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'Idx',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	          width: 35,
	          resizable: false
	        }, {
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          sortable: true,
	          width: 70,
	          filterable: true
	        }, {
	          key: 'RefNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	          resizable: true,
	          sortable: true,
	          width: 70,
	          filterable: true
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	          resizable: true,
	          sortable: true,
	          width: 200,
	          filterable: true
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	          resizable: true,
	          sortable: true,
	          width: 95,
	          filterable: true
	        }, {
	          key: 'Quantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	          resizable: true,
	          editable: true,
	          sortable: true,
	          width: 60,
	          filterable: true,
	          formatter: _boldTextFormatter2.default
	        }, {
	          key: 'FOBUnitPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }), //fix applied
	          resizable: true,
	          editable: true,
	          sortable: true,
	          width: 60,
	          filterable: true,
	          formatter: _boldCashFormatter2.default
	        }, {
	          key: 'TotalPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	          resizable: true,
	          sortable: true,
	          width: 75,
	          filterable: true,
	          formatter: _boldCashFormatter2.default
	        }, {
	          key: 'NetWeight',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' }),
	          resizable: true,
	          editable: false,
	          sortable: true,
	          width: 60,
	          filterable: true
	        }, {
	          key: 'TotalNetWeight',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	          resizable: true,
	          sortable: true,
	          width: 70,
	          filterable: true
	        }, {
	          key: 'PackageType',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	          resizable: true,
	          sortable: true,
	          width: 70,
	          filterable: true
	        }, {
	          key: 'PackageSize',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        }, {
	          key: 'Remark',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	          resizable: true,
	          width: 120,
	          editable: true
	        }];
	        // this.props.products = this.props.products.bind(this);
	
	        // Your Purchase Order React Table
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { className: 'react-table-customizer', id: 'PurchaseOrderForm-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'Product_id',
	                enableCellSelect: true,
	                onGridSort: handleGridSort,
	                columns: columns,
	                rowHeight: 25,
	                headerRowHeight: 45,
	                minHeight: this.state.yourOrderTableHeight,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                onRowClick: onRowClick,
	                onRowUpdated: handleRowUpdated
	              })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'getAllProductNumOptions',
	    value: function getAllProductNumOptions() {
	      var productNumOptions = [{ value: '', label: "No.       |  Name           |  Description                                           |  MeasureUnit" }];
	      this.props.simplifiedProducts.map(function (product) {
	        var text = "                                                                  ";
	        var output = [product.ProductNum.slice(0, 8), text].join('');
	        output = [output.slice(0, 8), '  |  ', product.Name.slice(0, 12), text].join('');
	        if (product.Description) output = [output.slice(0, 26), '  |  ', product.Description.slice(0, 50), text].join('');else output = [output.slice(0, 26), '  |  ', '                                                  ', text].join('');
	        if (product.MeasureUnit) output = [output.slice(0, 83), '  |  ', product.MeasureUnit.slice(0, 10), text].join('');else output = [output.slice(0, 83), '  |  ', '          ', text].join('');
	        output = output.slice(0, 99);
	        productNumOptions.push({ value: product.Product_id, label: output });
	      });
	      return productNumOptions;
	    }
	  }, {
	    key: 'getProductNumOptions',
	    value: function getProductNumOptions() {
	      var productNumOptions = [{ value: '', label: "No.       |  Name           |  Description                                           |  MeasureUnit" }];
	      this.props.products.map(function (product) {
	        var text = "                                                                  ";
	        var output = [product.ProductNum.slice(0, 8), text].join('');
	        output = [output.slice(0, 8), '  |  ', product.Name.slice(0, 12), text].join('');
	        if (product.Description) output = [output.slice(0, 26), '  |  ', product.Description.slice(0, 50), text].join('');else output = [output.slice(0, 26), '  |  ', '                                                  ', text].join('');
	        if (product.MeasureUnit) output = [output.slice(0, 83), '  |  ', product.MeasureUnit.slice(0, 10), text].join('');else output = [output.slice(0, 83), '  |  ', '          ', text].join('');
	        output = output.slice(0, 99);
	        productNumOptions.push({ value: product.Product_id, label: output });
	      });
	      return productNumOptions;
	    }
	
	    // Dropdown list for payment status
	
	  }, {
	    key: 'renderPaymentStatus',
	    value: function renderPaymentStatus() {
	      var paymentStatusOptions = [{ value: 'Not Paid', label: 'Not Paid' }, { value: 'Partially Paid', label: 'Partially Paid' }, { value: 'Paid', label: 'Paid' }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 6 },
	        _react2.default.createElement(
	          'label',
	          { className: 'col-xs-6 inlineLabel' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_status' }),
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { style: { color: 'red' } },
	            '*'
	          ),
	          ' '
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 6 },
	          _react2.default.createElement(_reduxForm.Field, { name: 'PaymentStatus', component: _selection.Selection, options: paymentStatusOptions })
	        )
	      );
	    }
	  }, {
	    key: 'getProductNameOptions',
	    value: function getProductNameOptions() {
	      var productNameOptions = [];
	      this.props.products.map(function (product) {
	        productNameOptions.push({ value: product.Product_id, label: product.Name });
	      });
	      return productNameOptions;
	    }
	  }, {
	    key: 'renderCarryTypeShippingMethod',
	    value: function renderCarryTypeShippingMethod() {
	      var carryTypeOptions = [{ value: "Dry", label: "Dry" }, { value: "Refrigerated", label: "Refrigerated" }];
	      var shippingMethodOptions = [{ value: "Pickup", label: "Pickup" }, { value: "Delivery", label: "Delivery" }];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12, id: 'shipping-method-field' },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_method' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'asteriksReq' },
	              '*'
	            )
	          ),
	          _react2.default.createElement(_reduxForm.Field, { name: 'ShippingMethod', component: _selection.Selection, ref: 'shippingMethod', withRef: true,
	            options: shippingMethodOptions })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carry_type' })
	          ),
	          _react2.default.createElement(_reduxForm.Field, { name: 'CarryType', component: _selection.Selection, ref: 'carryType', withRef: true,
	            options: carryTypeOptions })
	        )
	      );
	    }
	
	    // Render the Paymentterms select.
	
	  }, {
	    key: 'renderPaymentTerms',
	    value: function renderPaymentTerms() {
	      var paymentTermOptions = [];
	      if (this.props.paymentTermsIsLoading) {
	        paymentTermOptions = [{ value: 'loading', label: 'loading' }];
	      } // If group is loading, show a spinner.
	      else {
	          paymentTermOptions = this.getPaymentTermOptions();
	        }
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-6' },
	          _react2.default.createElement(_reactBootstrap.Row, null),
	          _react2.default.createElement(
	            'label',
	            { className: 'set-line-height' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-6 mt-lg' },
	          _react2.default.createElement(_reduxForm.Field, { name: 'PaymentTerm_id', component: _selection.DisabledSelection, options: paymentTermOptions })
	        )
	      );
	    }
	  }, {
	    key: 'getPaymentTermOptions',
	    value: function getPaymentTermOptions() {
	      var paymentTermOptions = [];
	      this.props.paymentTerms.map(function (paymentTerm) {
	        paymentTermOptions.push({ value: paymentTerm.PaymentTerm_id, label: paymentTerm.Name });
	      });
	      return paymentTermOptions;
	    }
	
	    // Implement the Headers which enable the function of collapsible
	
	  }, {
	    key: 'productHeader',
	    value: function productHeader() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_information' })
	        )
	      );
	    }
	  }, {
	    key: 'orderHeader',
	    value: function orderHeader() {
	      var _props9 = this.props,
	          currentPurchaseOrder = _props9.currentPurchaseOrder,
	          currentPurchaseQuote = _props9.currentPurchaseQuote,
	          currentPurchaseTemplate = _props9.currentPurchaseTemplate;
	
	      var tableheader = "";
	      if (this.context.router.routes[1].path == "purchaseOrder/new" || currentPurchaseOrder) {
	        tableheader = "your_purchase_order";
	      } else if (this.context.router.routes[1].path == "purchaseQuote/new" || currentPurchaseQuote) {
	        tableheader = "your_purchase_quote";
	      } else {
	        tableheader = "your_purchase_template";
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: tableheader })
	        )
	      );
	    }
	  }, {
	    key: 'checkoutHeader',
	    value: function checkoutHeader() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'more_info' })
	        )
	      );
	    }
	  }, {
	    key: 'orderDetailHeader',
	    value: function orderDetailHeader() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h4',
	          { style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'PO_details' })
	        )
	      );
	    }
	  }, {
	    key: 'pickupHeader',
	    value: function pickupHeader() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'label',
	          { style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup' })
	        )
	      );
	    }
	  }, {
	    key: 'deliverHeader',
	    value: function deliverHeader() {
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          'label',
	          { style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver_warehouse' })
	        )
	      );
	    }
	  }, {
	    key: 'carryHeader',
	    value: function carryHeader() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'label',
	          { style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carry_type_shipping_method' })
	        )
	      );
	    }
	  }, {
	    key: 'accountHeader',
	    value: function accountHeader() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'label',
	          { style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account_payment_term' })
	        )
	      );
	    }
	  }, {
	    key: 'attachmentHeader',
	    value: function attachmentHeader() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'label',
	          { style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'attachment_upload' })
	        )
	      );
	    }
	  }, {
	    key: 'vendorHeader',
	    value: function vendorHeader() {
	      return _react2.default.createElement(
	        'h2',
	        { className: 'mt0' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_information' })
	      )
	      // <div onClick={ ()=> this.setState({ vendorInformationOpen: !this.state.vendorInformationOpen })} >
	      //     <h2 style={{ cursor: "pointer" }} ><Translate value="vendor_information" /></h2>
	      // </div>
	      ;
	    }
	  }, {
	    key: 'oneTimeScheduleHeader',
	    value: function oneTimeScheduleHeader() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { onClick: function onClick() {
	            return _this6.setState({ oneTimeScheduleOpen: !_this6.state.oneTimeScheduleOpen });
	          } },
	        _react2.default.createElement(
	          'label',
	          { style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'one_time_schedule' })
	        )
	      );
	    }
	  }, {
	    key: 'purchaseInformationHeader',
	    value: function purchaseInformationHeader() {
	      var _this7 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { onClick: function onClick() {
	            return _this7.setState({ purchaseInformationOpen: !_this7.state.purchaseInformationOpen });
	          } },
	        _react2.default.createElement(
	          'label',
	          { style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_information' })
	        )
	      );
	    }
	  }, {
	    key: 'orderHistoryHeader',
	    value: function orderHistoryHeader() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h4',
	          { className: 'marginHeader', style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_history' })
	        )
	      );
	    }
	  }, {
	    key: 'inventoryHeader',
	    value: function inventoryHeader() {
	      var _this8 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { onClick: function onClick() {
	            return _this8.setState({ inventoryOpen: !_this8.state.inventoryOpen });
	          } },
	        _react2.default.createElement(
	          'label',
	          { style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory' })
	        )
	      );
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(files) {
	      this.setState({
	        files: files
	      });
	    }
	  }, {
	    key: 'onOpenClick',
	    value: function onOpenClick() {
	      this.refs.dropzone.open();
	    }
	  }, {
	    key: 'renderPreview',
	    value: function renderPreview() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'preview' })
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(_reactBootstrap.Image, { src: this.state.files[0].preview, thumbnail: true })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderWarehouse',
	    value: function renderWarehouse() {
	      if (!this.props.warehouseIsLoading && !this.props.warehouseError) {
	        var warehouseOptions = this.getWarehouseOptions();
	        if (!this.props.shippingMethod) return;else if (this.props.shippingMethod == "Delivery" || this.props.shippingMethod.value == "Delivery") {
	          return _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver_warehouse' }),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'asteriksReq' },
	                '*'
	              ),
	              ' '
	            ),
	            _react2.default.createElement(_reduxForm.Field, { name: 'Deliver_Warehouse_id', component: _selection.Selection, ref: 'deliver_Warehouse_id', withRef: true,
	              options: warehouseOptions })
	          );
	        } else return;
	      }
	    }
	  }, {
	    key: 'getWarehouseOptions',
	    value: function getWarehouseOptions() {
	      var warehouseOptions = [];
	      this.props.warehouses.map(function (warehouse) {
	        warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name });
	      });
	      return warehouseOptions;
	    }
	
	    // If the user was directed to the page with a parameter,
	    // then this page is edit page. Otherwise this is a create
	    // page.
	
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit() {
	      var formProps = arguments[1];
	      this.setState({ dirty: false });
	
	      var quantityZero = this.state.rows.filter(function (obj) {
	        return obj.Quantity == 0;
	      });
	      if (quantityZero.length > 0) {
	        this.setState({ case: "zeroQuantity", confirmOpen: true, quantityZero: quantityZero });
	        return;
	      }
	      if (this.state.totalPrice == 0) {
	        this.setState({ case: "zerototalPrice", confirmOpen: true });
	        return;
	      }
	
	      if (arguments[0] == "dropship") {
	        this.setState({ orderInfo: formProps });
	        this.openShowCustomer();
	        // this.props.createDropship(formProps, Data.Selectors.getRows(this.state));
	      } else if (arguments[0] == 'purchaseQuote') {
	        if (!this.props.currentPurchaseQuote) this.props.createPurchaseQuote(formProps, this.state.rows, this.state.taxRate, this.state.CRV, this.state.totalNetWeight, this.state.totalShippingWeight, this.state.totalPrice, this.state.finalPrice);else {
	          console.log("rows check3", _reactDataGridAddons.Data.Selectors.getRows(this.state));
	          if (!this.checkPermission("change_purchase_order")) this.props.editPurchaseQuote(formProps, _reactDataGridAddons.Data.Selectors.getRows(this.state), this.state.taxRate, this.state.CRV, this.state.totalNetWeight, this.state.totalShippingWeight, this.state.totalPrice, this.state.finalPrice);else alert("You have no permission!");
	        }
	      } else if (arguments[0] == 'convert') {
	        this.props.purchaseQuotePlace(formProps, _reactDataGridAddons.Data.Selectors.getRows(this.state), this.state.taxRate, this.state.CRV, this.state.totalNetWeight, this.state.totalShippingWeight, this.state.totalPrice, this.state.finalPrice);
	      } else if (arguments[0] == 'purchaseTemplate') {
	        if (!this.props.currentPurchaseTemplate) this.props.createPurchaseTemplate(formProps, this.state.rows, this.state.taxRate, this.state.CRV, this.state.totalNetWeight, this.state.totalShippingWeight, this.state.totalPrice, this.state.finalPrice);else {
	          console.log("rows check2", _reactDataGridAddons.Data.Selectors.getRows(this.state));
	          if (!this.checkPermission("change_purchase_template")) {
	            var rows = _reactDataGridAddons.Data.Selectors.getRows(this.state);
	            this.props.editPurchaseTemplate(formProps, rows, this.state.taxRate, this.state.CRV, this.state.totalNetWeight, this.state.totalShippingWeight, this.state.totalPrice, this.state.finalPrice);
	          } else alert("You have no permission!");
	        }
	      } else if (formProps.ShippingMethod === "Delivery" && !formProps.Deliver_Warehouse_id) {
	        alert("Please select a warehouse if your shipping method is delivery.");
	      } else {
	        if (!this.props.currentPurchaseOrder) this.props.createPurchaseOrder(formProps, this.state.rows, this.state.files, this.state.taxRate, this.state.CRV, this.state.totalNetWeight, this.state.totalShippingWeight, this.state.totalPrice, this.state.finalPrice);else {
	          console.log("rows check", _reactDataGridAddons.Data.Selectors.getRows(this.state), this.state.rows);
	          if (!this.checkPermission("change_purchase_order")) {
	            var _rows = _reactDataGridAddons.Data.Selectors.getRows(this.state);
	            this.props.editPurchaseOrder(formProps, _rows, this.state.files, this.state.taxRate, this.state.CRV, this.state.totalNetWeight, this.state.totalShippingWeight, this.state.totalPrice, this.state.finalPrice);
	          } else alert("You have no permission!");
	        }
	      }
	    }
	  }, {
	    key: 'handleMiscCostChange',
	    value: function handleMiscCostChange(event) {
	      var discountValue = parseFloat(this.state.discountValue) || 0;
	      var taxRate = parseFloat(this.state.taxRate) || 0;
	
	      var miscCostValue = event.target.value;
	      var handlingCostValue = parseFloat(this.state.handlingCostValue) || 0;
	      var shippingCostValue = parseFloat(this.state.shippingCostValue) || 0;
	      var adjustmentValue = parseFloat(this.state.adjustmentValue) || 0;
	
	      var totalPriceForTax = parseFloat(this.state.totalPriceForTax) || 0;
	      var totalPriceForAllLines = parseFloat(this.state.totalPriceForAllLines) || 0;
	      var CRV = this.state.CRV;
	      var totalPrice = totalPriceForAllLines;
	      totalPrice = (Math.round(totalPrice * 100) / 100).toFixed(2);
	      var finalPrice = (parseFloat(CRV) || 0) + (parseFloat(miscCostValue) || 0) + adjustmentValue + handlingCostValue + shippingCostValue + totalPriceForAllLines * (1 - discountValue / 100.0) + totalPriceForTax * taxRate / 100.0;
	      finalPrice = (Math.round(finalPrice * 100) / 100).toFixed(2);
	      this.setState({ miscCostValue: miscCostValue, totalPrice: totalPrice, finalPrice: finalPrice });
	    }
	  }, {
	    key: 'handleHandlingCostChange',
	    value: function handleHandlingCostChange(event) {
	      var discountValue = parseFloat(this.state.discountValue) || 0;
	      var taxRate = parseFloat(this.state.taxRate) || 0;
	
	      var miscCostValue = parseFloat(this.state.miscCostValue) || 0;
	      var handlingCostValue = event.target.value;
	      var shippingCostValue = parseFloat(this.state.shippingCostValue) || 0;
	      var adjustmentValue = parseFloat(this.state.adjustmentValue) || 0;
	
	      var totalPriceForTax = parseFloat(this.state.totalPriceForTax) || 0;
	      var totalPriceForAllLines = parseFloat(this.state.totalPriceForAllLines) || 0;
	      var CRV = this.state.CRV;
	      var totalPrice = totalPriceForAllLines;
	      totalPrice = (Math.round(totalPrice * 100) / 100).toFixed(2);
	      var finalPrice = (parseFloat(CRV) || 0) + adjustmentValue + miscCostValue + Math.round((parseFloat(handlingCostValue) || 0) * 100) / 100 + shippingCostValue + totalPriceForAllLines * (1 - discountValue / 100.0) + totalPriceForTax * taxRate / 100.0;
	      finalPrice = (Math.round(finalPrice * 100) / 100).toFixed(2);
	      this.setState({ handlingCostValue: handlingCostValue, totalPrice: totalPrice, finalPrice: finalPrice });
	    }
	  }, {
	    key: 'handleShippingCostChange',
	    value: function handleShippingCostChange(event) {
	      var discountValue = parseFloat(this.state.discountValue) || 0;
	      var taxRate = parseFloat(this.state.taxRate) || 0;
	
	      var miscCostValue = parseFloat(this.state.miscCostValue) || 0;
	      var handlingCostValue = parseFloat(this.state.handlingCostValue) || 0;
	      var shippingCostValue = event.target.value;
	      var adjustmentValue = parseFloat(this.state.adjustmentValue) || 0;
	
	      var totalPriceForTax = parseFloat(this.state.totalPriceForTax) || 0;
	      var totalPriceForAllLines = parseFloat(this.state.totalPriceForAllLines) || 0;
	      var CRV = this.state.CRV;
	      var totalPrice = totalPriceForAllLines;
	      totalPrice = (Math.round(totalPrice * 100) / 100).toFixed(2);
	      var finalPrice = (parseFloat(CRV) || 0) + adjustmentValue + miscCostValue + handlingCostValue + Math.round((parseFloat(shippingCostValue) || 0) * 100) / 100 + totalPriceForAllLines * (1 - discountValue / 100.0) + totalPriceForTax * taxRate / 100.0;
	      finalPrice = (Math.round(finalPrice * 100) / 100).toFixed(2);
	      this.setState({ shippingCostValue: shippingCostValue, totalPrice: totalPrice, finalPrice: finalPrice });
	    }
	  }, {
	    key: 'handleAdjustmentChange',
	    value: function handleAdjustmentChange(event) {
	      var discountValue = parseFloat(this.state.discountValue) || 0;
	      var taxRate = parseFloat(this.state.taxRate) || 0;
	
	      var miscCostValue = parseFloat(this.state.miscCostValue) || 0;
	      var handlingCostValue = parseFloat(this.state.handlingCostValue) || 0;
	      var shippingCostValue = parseFloat(this.state.shippingCostValue) || 0;
	      var adjustmentValue = event.target.value;
	
	      var totalPriceForTax = parseFloat(this.state.totalPriceForTax) || 0;
	      var totalPriceForAllLines = parseFloat(this.state.totalPriceForAllLines) || 0;
	      var CRV = this.state.CRV;
	      var totalPrice = totalPriceForAllLines;
	      totalPrice = (Math.round(totalPrice * 100) / 100).toFixed(2);
	      var finalPrice = (parseFloat(CRV) || 0) + (parseFloat(adjustmentValue) || 0) + miscCostValue + handlingCostValue + shippingCostValue + totalPriceForAllLines * (1 - discountValue / 100.0) + totalPriceForTax * taxRate / 100.0;
	      finalPrice = (Math.round(finalPrice * 100) / 100).toFixed(2);
	      this.setState({ adjustmentValue: adjustmentValue, totalPrice: totalPrice, finalPrice: finalPrice });
	    }
	  }, {
	    key: 'handleDiscountChange',
	    value: function handleDiscountChange(event) {
	      var discountValue = event.target.value;
	
	      if (parseFloat(discountValue) < 0 || parseFloat(discountValue) > 100 || isNaN(discountValue)) {
	        return;
	      }
	
	      var totalPrice = parseFloat(this.state.totalPrice) || 0;
	
	      var taxRate = parseFloat(this.state.taxRate) || 0;
	
	      var miscCostValue = parseFloat(this.state.miscCostValue) || 0;
	      var handlingCostValue = parseFloat(this.state.handlingCostValue) || 0;
	      var shippingCostValue = parseFloat(this.state.shippingCostValue) || 0;
	      var adjustmentValue = parseFloat(this.state.adjustmentValue) || 0;
	
	      var totalPriceForTax = parseFloat(this.state.totalPriceForTax) || 0;
	      var totalPriceForAllLines = parseFloat(this.state.totalPriceForAllLines) || 0;
	      var CRV = this.state.CRV;
	      var finalPrice = (parseFloat(CRV) || 0) + adjustmentValue + miscCostValue + handlingCostValue + shippingCostValue + totalPriceForAllLines * (1 - Math.round((parseFloat(discountValue) || 0) / 100.0) * 100 / 100) + totalPriceForTax * taxRate / 100.0;
	      finalPrice = (Math.round(finalPrice * 100) / 100).toFixed(2);
	      this.setState({ discountValue: discountValue, finalPrice: finalPrice });
	    }
	  }, {
	    key: 'handleFocusAutoSuggest',
	    value: function handleFocusAutoSuggest() {
	      var autoSuggestField = document.getElementById('purchase-auto-suggest');
	      autoSuggestField.focus();
	      autoSuggestField.select();
	    }
	
	    // handleTaxChange(event) {
	    //   let totalPrice = parseFloat(this.state.totalPrice) || 0;
	    //
	    //   let discountValue = parseFloat(this.state.discountValue) || 0;
	    //   let taxRate = event.target.value;
	    //
	    //   let miscCostValue = parseFloat(this.state.miscCostValue) || 0;
	    //   let handlingCostValue = parseFloat(this.state.handlingCostValue) || 0;
	    //   let shippingCostValue = parseFloat(this.state.shippingCostValue) || 0;
	    //
	    //   let totalPriceForTax = parseFloat(this.state.totalPriceForTax) || 0;
	    //   let totalPriceForAllLines = parseFloat(this.state.totalPriceForAllLines) || 0;
	    //   let CRV = this.state.CRV;
	    //   let finalPrice = ((parseFloat(CRV) || 0) + miscCostValue + handlingCostValue + shippingCostValue + totalPriceForAllLines*(1-discountValue/100.0) + totalPriceForTax*(parseFloat(taxRate)||0)/100.0);
	    //   finalPrice = (Math.round(finalPrice*100)/100).toFixed(2);
	    //   this.setState({taxRate, finalPrice});
	    // }
	
	  }, {
	    key: 'isDropship',
	    value: function isDropship() {
	      this.setState({ type: "dropship", dirty: false });
	    }
	  }, {
	    key: 'isPurchaseOrder',
	    value: function isPurchaseOrder() {
	      this.setState({ type: "purchaseOrder", dirty: false });
	    }
	  }, {
	    key: 'isPurchaseQuote',
	    value: function isPurchaseQuote() {
	      this.setState({ type: "purchaseQuote", dirty: false });
	    }
	  }, {
	    key: 'placeNewOrder',
	    value: function placeNewOrder() {
	      this.setState({ type: "convert", dirty: false });
	    }
	  }, {
	    key: 'isPurchaseTemplate',
	    value: function isPurchaseTemplate() {
	      this.setState({ type: "purchaseTemplate", dirty: false });
	    }
	  }, {
	    key: 'checkPermission',
	    value: function checkPermission(permission) {
	      return false;
	    }
	  }, {
	    key: 'refreshPage',
	    value: function refreshPage(event) {
	      var _this9 = this;
	
	      event.preventDefault();
	      if (this.props.purchaseOrderCreated || this.props.currentPurchaseOrder || this.props.purchaseOrderPlaced) {
	        var currentPurchaseOrder = this.props.purchaseOrderCreated || this.props.currentPurchaseOrder || this.props.currentPurchaseQuote;
	        this.closeShowPOCreated();
	        this.props.fetchPurchaseOrderDetail(currentPurchaseOrder.PurchaseOrder_id).then(function () {
	          _this9.props.selectPurchaseOrder(currentPurchaseOrder);
	          _this9.context.router.push('/purchaseOrder/' + currentPurchaseOrder.PurchaseOrder_id);
	        });
	      } else if (this.props.purchaseQuoteCreated || this.props.currentPurchaseQuote) {
	        var currentPurchaseQuote = this.props.purchaseQuoteCreated || this.props.currentPurchaseQuote;
	        this.closeShowPOCreated();
	        this.props.fetchPurchaseQuoteDetail(currentPurchaseQuote.PurchaseOrder_id).then(function () {
	          _this9.props.selectPurchaseQuote(currentPurchaseQuote);
	          _this9.context.router.push('/purchaseQuote/' + currentPurchaseQuote.PurchaseOrder_id);
	        });
	      } else if (this.props.purchaseTemplateCreated || this.props.currentPurchaseTemplate) {
	        var currentPurchaseTemplate = this.props.purchaseTemplateCreated || this.props.currentPurchaseTemplate;
	        this.closeShowPOCreated();
	        this.props.selectPurchaseTemplate(currentPurchaseTemplate);
	        this.context.router.push('/purchaseTemplate/' + currentPurchaseTemplate.PurchaseTemplate_id);
	      }
	    }
	  }, {
	    key: 'renderIFrame',
	    value: function renderIFrame() {
	      if (this.props.purchaseOrderPdf) {
	        var file = window.URL.createObjectURL(this.props.purchaseOrderPdf);
	        return _react2.default.createElement('iframe', { style: { display: 'none' }, onLoad: this.IFrameIsLoaded, id: 'Pdf', name: 'Pdf', src: file });
	      }
	    }
	  }, {
	    key: 'renderPrint',
	    value: function renderPrint() {
	      var _this10 = this;
	
	      var currentPurchaseOrder = this.props.currentPurchaseOrder;
	      if (!currentPurchaseOrder) return;
	      var url = _root_url.ROOT_URL + 'v1/purchase/order/print/' + currentPurchaseOrder.PurchaseOrder_id + "?Bearer=" + localStorage.getItem('token');
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          onClick: function onClick() {
	            _this10.props.printPurchaseOrder(currentPurchaseOrder.PurchaseOrder_id);
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_po' })
	      );
	    }
	  }, {
	    key: 'renderPrintPickingList',
	    value: function renderPrintPickingList() {
	      var _this11 = this;
	
	      var currentPurchaseOrder = this.props.currentPurchaseOrder;
	      if (!currentPurchaseOrder) return;
	      var url = _root_url.ROOT_URL + 'v1/purchase/order/pickupprint/' + currentPurchaseOrder.PurchaseOrder_id + "?Bearer=" + localStorage.getItem('token');
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          onClick: function onClick() {
	            _this11.props.printPickup(currentPurchaseOrder.PurchaseOrder_id);
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_pickup_list' })
	      );
	    }
	  }, {
	    key: 'renderReset',
	    value: function renderReset() {
	      var _this12 = this;
	
	      var _props10 = this.props,
	          currentPurchaseOrder = _props10.currentPurchaseOrder,
	          currentPurchaseQuote = _props10.currentPurchaseQuote,
	          currentPurchaseTemplate = _props10.currentPurchaseTemplate;
	
	      if (this.context.router.routes[1].path == "purchaseOrder/new" || currentPurchaseOrder) {
	        return _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'danger',
	            type: 'reset',
	            onClick: function onClick() {
	              _this12.context.router.push('/purchaseOrder');
	            } },
	          _react2.default.createElement('em', { className: 'fa fa-close' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	        );
	      } else if (this.context.router.routes[1].path == "purchaseQuote/new" || currentPurchaseQuote) {
	        return _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'danger',
	            type: 'reset',
	            onClick: function onClick() {
	              _this12.context.router.push('/purchaseQuote');
	            } },
	          _react2.default.createElement('em', { className: 'fa fa-close' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	        );
	      } else {
	        return _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'danger',
	            type: 'reset',
	            onClick: function onClick() {
	              _this12.context.router.push('/purchaseTemplate');
	            } },
	          _react2.default.createElement('em', { className: 'fa fa-close' })
	        );
	      }
	    }
	  }, {
	    key: 'renderDropShipButton',
	    value: function renderDropShipButton(handleSubmit) {
	      var _this13 = this;
	
	      var _props11 = this.props,
	          currentPurchaseOrder = _props11.currentPurchaseOrder,
	          currentPurchaseQuote = _props11.currentPurchaseQuote,
	          currentPurchaseTemplate = _props11.currentPurchaseTemplate;
	
	      var buttonOnClick = function buttonOnClick(type) {
	        return _lodash2.default.throttle(handleSubmit(function (data) {
	          _this13.handleFormSubmit(type, data);
	        }), 5000, { trailing: false });
	      };
	      if (this.context.router.routes[1].path == "purchaseOrder/new" || currentPurchaseOrder) {
	        return _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'warning',
	            type: 'button',
	            disabled: this.state.rows == 0,
	            onClick: buttonOnClick('dropship') },
	          _react2.default.createElement('em', { className: 'fa fa-truck' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropship' })
	        );
	      } else if (currentPurchaseQuote) {
	        return _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'warning',
	            type: 'button',
	            onClick: buttonOnClick('convert') },
	          _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ConvertPO' })
	        );
	      }
	      return;
	    }
	  }, {
	    key: 'renderSave',
	    value: function renderSave() {
	      var _this14 = this;
	
	      var _props12 = this.props,
	          currentPurchaseOrder = _props12.currentPurchaseOrder,
	          currentPurchaseQuote = _props12.currentPurchaseQuote,
	          currentPurchaseTemplate = _props12.currentPurchaseTemplate,
	          handleSubmit = _props12.handleSubmit,
	          isCreating = _props12.isCreating,
	          isEditing = _props12.isEditing;
	
	      var formType = void 0;
	      if (this.context.router.routes[1].path == "purchaseOrder/new" || currentPurchaseOrder) {
	        formType = 'purchaseOrder';
	      } else if (this.context.router.routes[1].path == "purchaseQuote/new" || currentPurchaseQuote) {
	        formType = 'purchaseQuote';
	      } else {
	        formType = 'purchaseTemplate';
	      }
	      var buttonOnClick = _lodash2.default.throttle(handleSubmit(function (data) {
	        _this14.handleFormSubmit(formType, data);
	      }), 5000, { trailing: false });
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          disabled: this.state.rows == 0 || isCreating || isEditing,
	          onClick: buttonOnClick
	        },
	        _react2.default.createElement('em', { className: 'fa fa-save' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	      );
	    }
	  }, {
	    key: 'renderSubtotal',
	    value: function renderSubtotal() {
	      var subtotal = 0;
	      if (this.state.selectedInventoryRow.ProductType == "Fixed") {
	        if (this.props.allProdQuantity) {
	          subtotal = (Math.round(this.props.allProdQuantity * this.props.allProdFOBUnitPrice * 10000) / 10000).toFixed(2);
	          // return(
	          //   <Col xs={ 12 }>${(Math.round(this.props.allProdQuantity * this.props.allProdFOBUnitPrice *10000)/10000).toFixed(2)}</Col>
	          // )
	        }
	      } else {
	        if (this.props.weight) {
	          subtotal = (Math.round(this.props.allProdFOBUnitPrice * this.props.weight * this.props.allProdQuantity * 10000) / 10000).toFixed(2);
	          // return (
	          //   <Col xs={ 12 }>${(Math.round(this.props.allProdFOBUnitPrice * this.props.weight * this.props.allProdQuantity * 10000)/10000).toFixed(2)}</Col>
	          // )
	        }
	      }
	      // this.props.setValue('purchaseOrderForm', 'Subtotal', subtotal);
	      return _react2.default.createElement(_reduxForm.Field, { name: 'Subtotal', component: _inputField.DisabledInputField, placeholder: subtotal });
	    }
	  }, {
	    key: 'renderVendorProducts',
	    value: function renderVendorProducts() {
	      var _this15 = this;
	
	      if (this.props.productIsLoading && !this.props.productError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.productError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.productError)
	        )
	      );else {
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this15.state.vendorProducts);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        var onRowsSelected = function onRowsSelected(rows) {
	          var newRows = getRows();
	          var selectedIndexes = _this15.state.vendorProducts.selectedIndexes.concat(rows.map(function (r) {
	            return r.rowIdx;
	          }));
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = true;
	          });
	          var vendorProducts = _extends({}, _this15.state.vendorProducts, { rows: newRows, selectedIndexes: selectedIndexes });
	          _this15.setState({ vendorProducts: vendorProducts });
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          var rowIndexes = rows.map(function (r) {
	            return r.rowIdx;
	          });
	          var newRows = getRows();
	          var selectedIndexes = _this15.state.vendorProducts.selectedIndexes.filter(function (i) {
	            return rowIndexes.indexOf(i) === -1;
	          });
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = false;
	          });
	          var vendorProducts = _extends({}, _this15.state.vendorProducts, { rows: newRows, selectedIndexes: selectedIndexes });
	          _this15.setState({ vendorProducts: vendorProducts });
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var vendorProducts = _extends({}, _this15.state.vendorProducts, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this15.setState({ vendorProducts: vendorProducts });
	        };
	
	        var onRowSelect = function onRowSelect(rows) {
	          var previousOrderes = _extends({}, _this15.state.vendorProducts, { selectedRows: rows });
	          _this15.setState({ vendorProducts: vendorProducts });
	        };
	
	        var onRowClick = function onRowClick(rowIdx, row) {
	          if (rowIdx > -1) {
	            _this15.props.fetchProductInfo(row.Product_id);
	          }
	        };
	
	        //Custom Formatter component
	        var IsEnabledFormatter = _react2.default.createClass({
	          displayName: 'IsEnabledFormatter',
	          render: function render() {
	            if (this.props.value) return _react2.default.createElement(
	              'span',
	              { className: 'label label-success' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	            );else return _react2.default.createElement(
	              'span',
	              { className: 'label label-danger' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disable' })
	            );
	          }
	        });
	
	        // Vendor Products Columns
	
	        var columns = [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'RefNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	          resizable: true,
	          sortable: true,
	          width: 70,
	          filterable: true
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	          resizable: true,
	          sortable: true,
	          width: 300,
	          filterable: true
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true,
	          width: 200,
	          filterable: true
	        }, {
	          key: 'ProductCost',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	          resizable: true,
	          editable: true,
	          sortable: true,
	          width: 70,
	          filterable: true,
	          formatter: _boldCashFormatter2.default
	        }, {
	          key: 'MeasureUnit',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'measure_unit' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        }, {
	          key: 'PackageType',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	          resizable: true,
	          sortable: true,
	          width: 80
	        }, {
	          key: 'NetWeight',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' }),
	          resizable: true,
	          editable: true,
	          sortable: true,
	          width: 65,
	          filterable: true
	        }];
	        // Vendor Products React Table
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { className: 'react-table-customizer', id: 'PurchaseOrderForm-dataGrid2' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'Product_id',
	                onGridSort: handleGridSort,
	                columns: columns,
	                rowHeight: 25,
	                headerRowHeight: 45,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                enableRowSelect: 'multi',
	                minHeight: 205,
	                onRowUpdated: this.handleRowUpdated,
	                onRowSelect: onRowSelect,
	                onRowClick: onRowClick,
	                rowSelection: {
	                  showCheckbox: true,
	                  onRowsSelected: onRowsSelected,
	                  onRowsDeselected: onRowsDeselected,
	                  selectBy: {
	                    isSelectedKey: 'isSelected'
	                  }
	                } })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderOrderHistory',
	    value: function renderOrderHistory() {
	      var _this16 = this;
	
	      // Parameters of the react-data-grid
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this16.state.productInfos);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	            var date = new Date(this.props.value);
	            var index = dateMap.indexOf(date.toString().slice(4, 3));
	            var localDate = index + date.toString().slice(8, 6);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );;
	          } else return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      // Column difinition
	
	      var columns = [{
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	        resizable: true,
	        sortable: true,
	        width: 40
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 50,
	        formatter: _boldCashFormatter2.default
	      }, {
	        key: 'OrderDate',
	        name: 'DOP',
	        resizable: true,
	        sortable: true,
	        width: 80,
	        formatter: DateFormatter
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '100%' }, id: 'PurchaseOrderForm-dataGrid3' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'Product_id',
	              columns: columns,
	              rowHeight: 25,
	              headerRowHeight: 45,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: 150
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderOrderDatePiece',
	    value: function renderOrderDatePiece() {
	      var _props13 = this.props,
	          currentPurchaseOrder = _props13.currentPurchaseOrder,
	          currentPurchaseQuote = _props13.currentPurchaseQuote,
	          currentPurchaseTemplate = _props13.currentPurchaseTemplate;
	
	      if (this.context.router.routes[1].path == "purchaseTemplate/new" || currentPurchaseTemplate && this.context.router.routes[1].path != "purchaseQuote/new") {
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 3, id: 'purchase-template_name' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_template_info' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-4' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_date' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-8' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'CreateTime', selected: new Date(), component: _datePicker.DisabledDatePicker })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-4' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_update' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-8' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'UpdateTime', selected: new Date(), component: _datePicker.DisabledDatePicker })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-4 line-height' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'asteriksReq' },
	                '*'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-8' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'Name', className: 'set-height', component: _inputField.InputField, placeholder: 'Template Name' })
	            )
	          )
	        );
	      } else {
	        var minDate = new Date();
	        if (this.props.orderDate) {
	          minDate = new Date(this.props.orderDate);
	        }
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 3, id: 'purchase-order-dates' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_order_dates' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-4' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-8' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'OrderDate', selected: new Date(), component: _datePicker.DatePicker })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-4' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'eta_date' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-8' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'ETADate', selected: new Date(), minDate: minDate, component: _datePicker.DatePicker })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-4' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'received' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-8' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'ReceivedDate', component: _datePicker.DatePicker })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderAutoSuggest',
	    value: function renderAutoSuggest() {
	      var _this17 = this;
	
	      return _react2.default.createElement(_PurchaseOrderAutoSuggest2.default, {
	        value: this.state.suggestValue,
	        onChange: function onChange(e, _ref) {
	          var newValue = _ref.newValue;
	          _this17.clearInventoryInfo();_this17.props.resetAllProducts('purchaseOrderForm');_this17.setState({ suggestValue: newValue });
	        },
	        handleKeyPress: this.handleKeyPress,
	        handleFocusQty: this.handleFocusQty,
	        setAllProductQuantity: this.setAllProductQuantity,
	        SearchType: this.props.searchType
	      });
	    }
	  }, {
	    key: 'formTitle',
	    value: function formTitle() {
	      if (this.props.purchaseOrderCreated || this.props.purchaseOrderPlaced || this.props.purchaseOrderEdited) return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_purchase_order_saved' });else if (this.props.purchaseOrderEdited && this.props.currentPurchaseOrder) return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_purchase_order_saved' });else if (this.props.purchaseQuoteCreated || this.props.purchaseQuoteEdited) return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_purchase_quote_saved' });else if (this.props.purchaseTemplateCreated || this.props.purchaseTemplateEdited) return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_purchase_template_saved' });else return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_operation_saved' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this18 = this;
	
	      var productNumOptions = this.getProductNumOptions();
	      var allProductNumOptions = this.getAllProductNumOptions();
	      var createDialogStyle = {
	        height: '600px',
	        marginTop: '-20%',
	        width: '680px',
	        marginLeft: '-10%',
	        left: '45%'
	      };
	
	      var createDialogInventoryStyle = {
	        height: '700px',
	        width: '1000px',
	        marginLeft: '-28%',
	        marginTop: '-20%'
	      };
	      var _props14 = this.props,
	          handleSubmit = _props14.handleSubmit,
	          submitting = _props14.submitting,
	          pristine = _props14.pristine,
	          currentPurchaseOrder = _props14.currentPurchaseOrder,
	          currentPurchaseQuote = _props14.currentPurchaseQuote,
	          currentPurchaseTemplate = _props14.currentPurchaseTemplate,
	          error = _props14.error;
	
	      var renderVendorProducts = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_products' });
	      var renderAllProducts = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all_products' });
	      var confirmAction = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm_action' });
	      var PODetails = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_details' });
	      var CheckoutInfo = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'more_info' });
	      var changeTax = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'choose_tax_rate' });
	      var convertItemPriceTranslation = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'type' });
	      var activeBreadcrumb = "";
	      if (this.context.router.routes[1].path == "purchaseOrder/new") {
	        activeBreadcrumb = "new_purchase_order";
	      } else if (currentPurchaseOrder) {
	        activeBreadcrumb = "edit_purchase_order";
	      } else if (currentPurchaseQuote) {
	        activeBreadcrumb = "edit_purchase_quote";
	      } else if (this.context.router.routes[1].path == "purchaseQuote/new") {
	        activeBreadcrumb = "new_purchase_quote";
	      } else if (currentPurchaseTemplate) {
	        activeBreadcrumb = "edit_purchase_template";
	      } else {
	        activeBreadcrumb = "new_purchase_template";
	      }
	      var minDate = new Date();
	      if (this.props.orderDate) {
	        minDate = new Date(this.props.orderDate);
	      }
	      // if (this.props.detailIsLoading || this.props.vendorIsLoading || this.props.paymentTermsIsLoading) return <ContentWrapper><h5>...<Translate value="reading_data" /></h5></ContentWrapper>
	      if (this.props.detailError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          this.props.detailError
	        )
	      );else {
	        var productInfo = this.state.productInfo;
	        var PONum = null,
	            PurchaseStatus = null;
	        if (this.props.currentPurchaseOrder) {
	          PONum = this.props.currentPurchaseOrder.PONum;
	          PurchaseStatus = this.props.currentPurchaseOrder.PurchaseStatus;
	        }
	        var ProductType = this.state.ProductType;
	        var CRV = this.state.CRV;
	        var currentVendorDetail = this.props.currentVendorDetail;
	        var contact = null;
	        var phone = null;
	        if (currentVendorDetail && currentVendorDetail.Billing) {
	          contact = currentVendorDetail.Billing.FirstName + " " + currentVendorDetail.Billing.LastName;
	          phone = currentVendorDetail.Billing.Telephone;
	        }
	
	        return (
	          //---------------
	          // Begin HTML
	          //---------------
	          _react2.default.createElement(
	            _ContentWrapper2.default,
	            null,
	            _react2.default.createElement(
	              'form',
	              { className: 'form-horizontal', method: 'get', action: '#', autoComplete: 'off' },
	              _react2.default.createElement(
	                _reactBootstrap.Breadcrumb,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Breadcrumb.Item,
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_management' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Breadcrumb.Item,
	                  { active: 'true' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: activeBreadcrumb })
	                )
	              ),
	              ' ',
	              _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                null,
	                this.renderSave(),
	                this.renderPrint(),
	                this.renderPrintPickingList(),
	                ' ',
	                this.renderReset()
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Grid,
	                { id: 'create-new-purchase-order' },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 6 },
	                    error && _react2.default.createElement(
	                      'div',
	                      { className: 'alert alert-danger marginTopStyle' },
	                      error
	                    ),
	                    (this.props.isCreating || this.props.isEditing || this.props.isPlacing) && _react2.default.createElement(_spinner2.default, null),
	                    this.props.createError && _react2.default.createElement(
	                      'div',
	                      { className: 'alert alert-danger marginTopStyle' },
	                      JSON.stringify(this.props.createError)
	                    ),
	                    this.props.editError && _react2.default.createElement(
	                      'div',
	                      { className: 'alert alert-danger marginTopStyle' },
	                      JSON.stringify(this.props.editError)
	                    ),
	                    this.props.placeError && _react2.default.createElement(
	                      'div',
	                      { className: 'alert alert-danger marginTopStyle' },
	                      JSON.stringify(this.props.placeError)
	                    )
	                  ),
	                  ' ',
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 10 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      this.vendorHeader(),
	                      _react2.default.createElement(
	                        'fieldset',
	                        { className: 'form-horizontal' },
	                        _react2.default.createElement(
	                          _reactBootstrap.Panel,
	                          { id: 'purchase-order-vendor-info' },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            this.renderVendorsDetail(),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 3, id: 'billing-info' },
	                              _react2.default.createElement(
	                                'h4',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'billing_information' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-3' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'contact' }),
	                                  ':'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-xs-9' },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    !this.props.currentVendorDetail && _react2.default.createElement(
	                                      'div',
	                                      { className: 'col-xs-9' },
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_please_select_a_vendor' })
	                                    ),
	                                    this.props.currentVendorDetail && contact
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-3' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' }),
	                                  ':'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-xs-9' },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    !this.props.currentVendorDetail && _react2.default.createElement(
	                                      'div',
	                                      { className: 'col-xs-9' },
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: '' })
	                                    ),
	                                    this.props.currentVendorDetail && phone
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group mb0' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-3' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' }),
	                                  ':'
	                                ),
	                                this.props.currentVendorDetail && _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-xs-9' },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    this.renderBillingAddress1()
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    this.renderBillingAddress2()
	                                  )
	                                )
	                              )
	                            ),
	                            ' ',
	                            this.renderOrderDatePiece(),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 2 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 12 },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    { className: 'form-group', style: { marginLeft: '0', marginBottom: '14px', paddingTop: '26px' } },
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Col,
	                                      { xs: 6 },
	                                      _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'created' }),
	                                        ':  '
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Col,
	                                      { xs: 6 },
	                                      this.state.created_by
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 12 },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    { className: 'form-group', style: { marginLeft: '0', marginBottom: '10px' } },
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Col,
	                                      { xs: 6 },
	                                      _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'modified' }),
	                                        ': '
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Col,
	                                      { xs: 6 },
	                                      this.state.modified_by
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 12 },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    { className: 'form-group', style: { marginLeft: '0' } },
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Col,
	                                      { xs: 6 },
	                                      _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'modified_on' }),
	                                        ': '
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Col,
	                                      { xs: 6 },
	                                      this.state.updateTime
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    ' ',
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      this.productHeader(),
	                      _react2.default.createElement(
	                        _reactBootstrap.Tabs,
	                        { activeKey: this.state.yourOrderKey, justified: true, onSelect: this.handleSelect },
	                        _react2.default.createElement(
	                          _reactBootstrap.Tab,
	                          { eventKey: 1, title: renderVendorProducts },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'tab-products-table' },
	                            _react2.default.createElement(
	                              _reactBootstrap.Button,
	                              {
	                                bsStyle: 'primary',
	                                className: 'position-btn',
	                                type: 'button',
	                                onClick: function onClick() {
	                                  _this18.moveToProductsList();
	                                } },
	                              _react2.default.createElement('em', { className: 'fa fa-plus' })
	                            ),
	                            this.renderVendorProducts()
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { id: 'inventory-details' },
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'inventory-label' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'colon' },
	                                    ':'
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-6 inlineLabel' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'in_stock' }),
	                                  ':'
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'col-xs-6 inventory-highlight' },
	                                  productInfo ? productInfo.InStock : null
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-6 inlineLabel' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'presale' }),
	                                  ':'
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'col-xs-6 inventory-highlight' },
	                                  productInfo ? productInfo.PreSale : null
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-6 inlineLabel' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchased' }),
	                                  ':'
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'col-xs-6 inventory-highlight' },
	                                  productInfo ? productInfo.Purchased : null
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-6 inlineLabel' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'min_limit' }),
	                                  ':'
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'col-xs-6 inventory-highlight' },
	                                  productInfo && productInfo.ProductNum ? productInfo.ProductNum.MinStockRange : null
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-6 inlineLabel' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'max_limit' }),
	                                  ':'
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'col-xs-6 inventory-highlight' },
	                                  productInfo && productInfo.ProductNum ? productInfo.ProductNum.MaxStockRange : null
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Tab,
	                          { eventKey: 2, title: renderAllProducts },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6, className: 'p0' },
	                              _react2.default.createElement(_reduxForm.Field, { name: 'searchType', component: renderTypeRadios }),
	                              this.renderAutoSuggest()
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6, id: 'product-search-outputs' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 2 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' })
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'AllProd_Quantity', ref: 'allProd_Quantity', withRef: true, component: _inputField.InputField, placeholder: 0, onKeyPress: function onKeyPress(event) {
	                                    _this18.handleKeyPress("allProd_FOBUnitPrice", event);
	                                  }, onFocus: this.handleOnFocus })
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 2, className: 'pl' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'dollar-sign' },
	                                    '$$'
	                                  )
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, {
	                                  name: 'AllProd_FOBUnitPrice',
	                                  ref: 'allProd_FOBUnitPrice',
	                                  withRef: true,
	                                  component: _inputField.InputField,
	                                  placeholder: "must be > 0",
	                                  onKeyPress: function onKeyPress(event) {
	                                    if (event.charCode == 13) {
	                                      if (!isNumber(_this18.props.allProdQuantity) || _this18.props.allProdQuantity < 0 || !isNumber(_this18.props.allProdFOBUnitPrice) || _this18.props.allProdFOBUnitPrice < 0) {
	                                        return;
	                                      }
	                                      _this18.handleFocusAutoSuggest();
	                                      _this18.setAllProductQuantity(0);
	                                      _this18.moveToProductsListFromAll();
	                                    }
	                                  },
	                                  onFocus: this.handleOnFocus
	                                })
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 2 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sale' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'dollar-sign' },
	                                    '$$'
	                                  )
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'RefSalePrice', component: _inputField.DisabledInputField })
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 2 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' })
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Weight', component: _inputField.DisabledInputField })
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 2 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'subtotal' })
	                                ),
	                                this.renderSubtotal()
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 2 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' })
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, {
	                                  name: 'AllProd_Remark',
	                                  ref: 'allProd_Remark',
	                                  withRef: true,
	                                  component: _inputField.InputField,
	                                  onKeyPress: function onKeyPress(event) {
	                                    if (event.charCode == 13) {
	                                      if (!isNumber(_this18.props.allProdQuantity) || _this18.props.allProdQuantity < 0 || !isNumber(_this18.props.allProdFOBUnitPrice) || _this18.props.allProdFOBUnitPrice < 0) {
	                                        return;
	                                      }
	                                      _this18.handleFocusAutoSuggest();
	                                      _this18.setAllProductQuantity(0);
	                                      _this18.moveToProductsListFromAll();
	                                    }
	                                  },
	                                  onFocus: this.handleOnFocus
	                                })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { id: 'inventory-details' },
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'inventory-label' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'colon' },
	                                    ':'
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-6 inlineLabel' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'in_stock' }),
	                                  ':'
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'col-xs-6 inventory-highlight' },
	                                  productInfo ? productInfo.InStock : null
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-6 inlineLabel' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'presale' }),
	                                  ':'
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'col-xs-6 inventory-highlight' },
	                                  productInfo ? productInfo.PreSale : null
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-6 inlineLabel' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchased' }),
	                                  ':'
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'col-xs-6 inventory-highlight' },
	                                  productInfo ? productInfo.Purchased : null
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-6 inlineLabel' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'min_limit' }),
	                                  ':'
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'col-xs-6 inventory-highlight' },
	                                  productInfo && productInfo.ProductNum ? productInfo.ProductNum.MinStockRange : null
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-6 inlineLabel' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'max_limit' }),
	                                  ':'
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'col-xs-6 inventory-highlight' },
	                                  productInfo && productInfo.ProductNum ? productInfo.ProductNum.MaxStockRange : null
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    ' ',
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      this.orderHeader(),
	                      _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        null,
	                        this.renderProducts()
	                      )
	                    ),
	                    ' '
	                  ),
	                  ' ',
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2, className: 'po-details-pane' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Tabs,
	                      { defaultActiveKey: 1, justified: true, className: 'tab-width-fix' },
	                      _react2.default.createElement(
	                        _reactBootstrap.Tab,
	                        { eventKey: 1, title: PODetails, className: 'po-details-tab' },
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          null,
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4, className: 'po-no-line-height' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 8 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'PONum', component: _inputField.DisabledInputField, placeholder: PONum })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          null,
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4, className: 'status-line-height' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 8 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'PurchaseStatus', component: _inputField.DisabledInputField, placeholder: PurchaseStatus })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          null,
	                          this.renderCarryTypeShippingMethod(),
	                          this.renderVendorAddress(),
	                          this.renderWarehouse(),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping' }),
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'dollar-sign' },
	                                '$$'
	                              )
	                            ),
	                            _react2.default.createElement(_reduxForm.Field, { name: 'ShippingCost', ref: 'shippingCost', withRef: true, component: _inputField.ControlledInputField, placeholder: this.state.shippingCostValue,
	                              onChange: this.handleShippingCostChange, onKeyPress: function onKeyPress(event) {
	                                _this18.handleKeyPress("handlingCost", event);
	                              }, onFocus: this.handleOnFocus })
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'handling' }),
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'dollar-sign' },
	                                '$$'
	                              )
	                            ),
	                            _react2.default.createElement(_reduxForm.Field, { name: 'HandlingCost', ref: 'handlingCost', withRef: true, component: _inputField.ControlledInputField, placeholder: this.state.handlingCostValue,
	                              onChange: this.handleHandlingCostChange, onKeyPress: function onKeyPress(event) {
	                                _this18.handleKeyPress("miscCost", event);
	                              }, onFocus: this.handleOnFocus })
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'misc' }),
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'dollar-sign' },
	                                '$$'
	                              )
	                            ),
	                            _react2.default.createElement(_reduxForm.Field, { name: 'MiscCost', ref: 'miscCost', withRef: true, component: _inputField.ControlledInputField, placeholder: this.state.miscCostValue,
	                              onChange: this.handleMiscCostChange, onKeyPress: function onKeyPress(event) {
	                                _this18.handleKeyPress("priceAdjustment", event);
	                              }, onFocus: this.handleOnFocus })
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'adjustments' }),
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'dollar-sign' },
	                                '$$'
	                              )
	                            ),
	                            _react2.default.createElement(_reduxForm.Field, {
	                              name: 'PriceAdjustment',
	                              ref: 'priceAdjustment',
	                              withRef: true,
	                              component: _inputField.ControlledInputField,
	                              placeholder: this.state.adjustmentValue,
	                              onChange: this.handleAdjustmentChange,
	                              onKeyPress: function onKeyPress(event) {
	                                _this18.handleKeyPress("miscNote", event);
	                              },
	                              onFocus: this.handleOnFocus
	                            })
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'misc_detail' })
	                            ),
	                            _react2.default.createElement(_reduxForm.Field, { name: 'MiscNote', ref: 'miscNote', withRef: true, component: _inputField.InputField, onKeyPress: function onKeyPress(event) {
	                                _this18.handleKeyPress("discount", event);
	                              }, onFocus: this.handleOnFocus })
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4, style: { "visibility": "hidden" } },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disc' }),
	                              '%'
	                            ),
	                            _react2.default.createElement(_reduxForm.Field, { name: 'Discount', ref: 'discount', withRef: true, component: _inputField.ControlledInputField, placeholder: this.state.discountValue,
	                              onChange: this.handleDiscountChange, onKeyPress: function onKeyPress(event) {
	                                _this18.handleKeyPress("taxValue", event);
	                              }, onFocus: this.handleOnFocus })
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4 },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'dollar-sign' },
	                                '$'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'span',
	                              { onDoubleClick: function onDoubleClick() {
	                                  _this18.openChangeTax();
	                                } },
	                              _react2.default.createElement(_reduxForm.Field, { name: 'TaxValue', ref: 'taxValue', withRef: true, component: _inputField.DisabledInputField })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4 },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'crv' }),
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'dollar-sign' },
	                                '$'
	                              )
	                            ),
	                            _react2.default.createElement(_reduxForm.Field, { name: 'CRV', component: _inputField.DisabledInputField, placeholder: CRV })
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            this.renderPaymentTerms()
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          { className: 'sale-details-output' },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'IsDropship', component: renderRadios }),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(_reduxForm.Field, { name: 'ConvertItemPrice', component: _convertItemPrice2.default, labelName: convertItemPriceTranslation })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_net_wt' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  this.state.totalNetWeight,
	                                  ' lb'
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_ship_wt' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  this.state.totalShippingWeight,
	                                  ' lb'
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              { className: 'pricing-highlight' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'dollar-sign' },
	                                    '$$'
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'dollar-sign' },
	                                    '$'
	                                  ),
	                                  ' ',
	                                  this.state.totalPrice
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              { className: 'pricing-highlight' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'dollar-sign' },
	                                    '$$'
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6 },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'dollar-sign' },
	                                    '$'
	                                  ),
	                                  ' ',
	                                  this.state.finalPrice
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'fieldset',
	                          null,
	                          this.orderHistoryHeader(),
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            this.renderOrderHistory()
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  ' '
	                ),
	                ' '
	              ),
	              this.renderIFrame(),
	              _react2.default.createElement(
	                _reactSkylight.SkyLightStateless,
	                { dialogStyles: createDialogStyle, isVisible: this.state.showCustomerOpen, onCloseClicked: this.closeShowCustomer, title: 'select customer information' },
	                _react2.default.createElement(_customerInfo2.default, { orderLineInfo: _reactDataGridAddons.Data.Selectors.getRows(this.state), orderInfo: this.state.orderInfo, totalNetWeight: this.state.totalNetWeight,
	                  totalShippingWeight: this.state.totalShippingWeight, totalPrice: this.state.totalPrice, finalPrice: this.state.finalPrice, closeShowCustomer: this.closeShowCustomer })
	              ),
	              ' ',
	              _react2.default.createElement(
	                _reactSkylight.SkyLightStateless,
	                { dialogStyles: createDialogInventoryStyle, isVisible: this.state.showInventoryOpen, onCloseClicked: this.closeShowInventory, title: 'Select Inventory' },
	                _react2.default.createElement(_inventoryInfo2.default, { searchValue: this.props.allProducts, searchType: this.props.searchType, form: 'purchaseOrderForm',
	                  closeShowInventory: this.closeShowInventory, selectInventoryInfo: this.selectInventoryInfo, setAllProducts: this.props.setAllProducts, setAllProductQuantity: this.setAllProductQuantity, formName: 'purchaseOrderForm' })
	              ),
	              ' ',
	              _react2.default.createElement(
	                'div',
	                { className: 'remove-close-skylight' },
	                _react2.default.createElement(
	                  _reactSkylight.SkyLightStateless,
	                  { dialogStyles: createDialogStyle, isVisible: this.state.showPOCreatedOpen, onCloseClicked: this.closeShowPOCreated, title: this.formTitle() },
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'centerStyle' },
	                    this.props.purchaseOrderCreated && _react2.default.createElement(
	                      'h4',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_purchase_order_num_is' }),
	                      ': ',
	                      this.props.purchaseOrderCreated.PONum
	                    ),
	                    this.props.purchaseOrderEdited && this.props.currentPurchaseOrder && _react2.default.createElement(
	                      'h4',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_purchase_order_num_is' }),
	                      ': ',
	                      this.props.currentPurchaseOrder.PONum
	                    ),
	                    this.props.purchaseOrderPlaced && this.props.currentPurchaseQuote && _react2.default.createElement(
	                      'h4',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_purchase_order_num_is' }),
	                      ': ',
	                      this.props.currentPurchaseQuote.PONum
	                    )
	                  ),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'centerStyle' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_ask_if_stay_on_current_page' }),
	                      '?'
	                    )
	                  ),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'centerStyle' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      { bsStyle: 'primary', onClick: function onClick(event) {
	                          _this18.refreshPage(event);
	                        }, type: 'button' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      { bsStyle: 'danger', onClick: this.redirect, type: 'button' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactSkylight.SkyLightStateless,
	                { dialogStyles: createDialogStyle, isVisible: this.state.confirmOpen, onCloseClicked: function onCloseClicked() {
	                    _this18.closeConfirm();
	                  }, title: confirmAction },
	                _react2.default.createElement(_confirmActionModal2.default, { 'case': this.state.case, closeC: this.closeConfirm, zeroArray: this.state.quantityZero })
	              ),
	              _react2.default.createElement(
	                _reactSkylight.SkyLightStateless,
	                { dialogStyles: createDialogStyle, isVisible: this.state.changeTaxOpen, onCloseClicked: function onCloseClicked() {
	                    _this18.closeChangeTax();
	                  }, title: changeTax },
	                _react2.default.createElement(_taxSelectionModal2.default, { taxRateOptions: this.getTaxRateOptions() })
	              )
	            ),
	            ' '
	          )
	          //---------------
	          // End HTML
	          //---------------
	
	        );
	      }
	    }
	  }]);
	
	  return PurchaseOrderForm;
	}(_react.Component);
	
	PurchaseOrderForm.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var _default = (0, _reactRouter.withRouter)(PurchaseOrderForm);
	
	exports.default = _default;
	
	
	function roundTo(n, digits) {
	  if (digits === undefined) {
	    digits = 0;
	  }
	
	  var multiplicator = Math.pow(10, digits);
	  n = parseFloat((n * multiplicator).toFixed(11));
	  var test = Math.round(n) / multiplicator;
	  return +test.toFixed(2);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isNumber, 'isNumber', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(roundTo, 'roundTo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(renderRadios, 'renderRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(renderTypeRadios, 'renderTypeRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(PurchaseOrderForm, 'PurchaseOrderForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseOrderForm.jsx');
	}();

	;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _dateFormat = __webpack_require__(39);
	
	var _selection = __webpack_require__(21);
	
	var _TypeRadios = __webpack_require__(57);
	
	var _TypeRadios2 = _interopRequireDefault(_TypeRadios);
	
	var _GenericProductSuggest = __webpack_require__(51);
	
	var _GenericProductSuggest2 = _interopRequireDefault(_GenericProductSuggest);
	
	var _root_url = __webpack_require__(9);
	
	var _url = __webpack_require__(20);
	
	var _cleanDates = __webpack_require__(22);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _genericRadioFilter = __webpack_require__(50);
	
	var _genericRadioFilter2 = _interopRequireDefault(_genericRadioFilter);
	
	var _dateFilterRadios = __webpack_require__(49);
	
	var _dateFilterRadios2 = _interopRequireDefault(_dateFilterRadios);
	
	var _trackingNoteModal = __webpack_require__(641);
	
	var _trackingNoteModal2 = _interopRequireDefault(_trackingNoteModal);
	
	var _reactDropzone = __webpack_require__(45);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _BolImagesTablePO = __webpack_require__(423);
	
	var _BolImagesTablePO2 = _interopRequireDefault(_BolImagesTablePO);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isJML = _root_url.ROOT_API_URL === "https://jml-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://jml-scm.truckxi.com/api/";
	var isAFGRelated = _root_url.ROOT_URL === "https://afg-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://afgstage-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://mmdavis-scm.truckxi.com/api/";
	var isAFG = _root_url.ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afgstage-scm.truckxi.com/api/';
	var isMMD = _root_url.ROOT_API_URL === 'https://mmdavis-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://mmdavis-scm.truckxi.com/api/';
	var isMyuMyu = _root_url.ROOT_API_URL === 'https://mmstage-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://myumyu-scm.truckxi.com/api/';
	var isTN = _root_url.ROOT_API_URL === 'https://tn-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://tn-scm.truckxi.com/api/';
	var isPS = _root_url.ROOT_API_URL === 'https://premiumstella-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://premiumstella-scm.truckxi.com/api/';
	var isUSPride = _root_url.ROOT_API_URL === 'https://uspride-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://uspride-scm.truckxi.com/api/';
	var isATL = _root_url.ROOT_API_URL === 'https://alton-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://alton-scm.truckxi.com/api/';
	var isOCM = _root_url.ROOT_API_URL === 'https://ocm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ocm-scm.truckxi.com/api/';
	var isRS = _root_url.ROOT_API_URL === 'https://redstone-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://redstone-scm.truckxi.com/api/';
	var isEcity = _root_url.ROOT_API_URL === "https://ct-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/";
	var isLO = _root_url.ROOT_API_URL === 'https://lonni-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://lonni-scm.truckxi.com/api/';
	
	var propTypes = {
	  setDefaultDays: _propTypes2.default.func.isRequired,
	  setDefaultOfForm: _propTypes2.default.func.isRequired,
	  setValue: _propTypes2.default.func.isRequired,
	  resetCurrentPurchaseOrder: _propTypes2.default.func.isRequired,
	  selectPurchaseOrder: _propTypes2.default.func.isRequired,
	  clearCheckPassword: _propTypes2.default.func.isRequired,
	  checkPassword: _propTypes2.default.func.isRequired,
	  deletePurchaseOrder: _propTypes2.default.func.isRequired,
	  checkPasswordFailure: _propTypes2.default.func.isRequired,
	  fetchPurchaseOrdersByFilter: _propTypes2.default.func.isRequired,
	  fetchBaseUsers: _propTypes2.default.func.isRequired,
	  printPurchaseOrder: _propTypes2.default.func.isRequired,
	  setPurchaseOrdersFilter: _propTypes2.default.func.isRequired,
	  fetchPurchaseOrderList: _propTypes2.default.func.isRequired,
	
	  purchaseOrdersFilter: _propTypes2.default.object.isRequired,
	  checkPasswordSuccess: _propTypes2.default.bool.isRequired,
	  purchaseOrders: _propTypes2.default.array.isRequired,
	  ProductNum: _propTypes2.default.string.isRequired,
	  FromDate: _propTypes2.default.string.isRequired,
	  ToDate: _propTypes2.default.string.isRequired,
	  requestingPurchaseOrderPdf: _propTypes2.default.bool.isRequired,
	  purchaseOrderListIsLoading: _propTypes2.default.bool.isRequired,
	  purchaseOrderListError: _propTypes2.default.bool.isRequired,
	  isLoading: _propTypes2.default.bool.isRequired,
	  error: _propTypes2.default.bool.isRequired,
	  users: _propTypes2.default.array.isRequired,
	  usersIsLoading: _propTypes2.default.bool.isRequired,
	  Status: _propTypes2.default.string.isRequired,
	  Purchaser: _propTypes2.default.object.isRequired,
	  Days: _propTypes2.default.string.isRequired,
	  purchaseOrderPdf: _propTypes2.default.object.isRequired,
	  purchaseOrderList: _propTypes2.default.array.isRequired
	};
	
	var PurchaseOrderList = function (_Component) {
	  _inherits(PurchaseOrderList, _Component);
	
	  function PurchaseOrderList() {
	    _classCallCheck(this, PurchaseOrderList);
	
	    var _this = _possibleConstructorReturn(this, (PurchaseOrderList.__proto__ || Object.getPrototypeOf(PurchaseOrderList)).call(this));
	
	    _this.setToDate = function (e) {
	      if (e < _this.state.FromDate) {
	        return;
	      }
	      _this.setState({ ToDate: e });
	    };
	
	    _this.setFromDate = function (e) {
	      if (e > _this.state.ToDate) {
	        return;
	      }
	      _this.setState({ FromDate: e });
	    };
	
	    _this.setToRangeSearch = function () {
	      _this.setState({ days: '-1' });
	    };
	
	    _this.handleOptionChange = function (changeEvent) {
	      _this.setState({ productSearchType: changeEvent.target.value });
	    };
	
	    _this.handleStatusFilterChange = function (status) {
	      var purchaseOrdersFilter = _this.props.purchaseOrdersFilter;
	
	      if (!purchaseOrdersFilter) {
	        var purchaser = _this.props.Purchaser;
	        if (_this.props.Purchaser) {
	          purchaser = _this.props.Purchaser.value;
	        }
	        var fromDate = _this.state.FromDate ? _this.formatDate(_this.state.FromDate) : '1900-01-01';
	        var toDate = _this.state.ToDate ? _this.formatDate(_this.state.ToDate) : '3000-01-01';
	        var days = _this.state.days;
	
	        if (days == null) {
	          days = 7;
	        }
	        var productNum = _this.props.ProductNum;
	        _this.setState({ Status: status }, function () {
	          _this.props.fetchPurchaseOrdersByFilter(fromDate, toDate, days, _this.state.Status, purchaser, productNum);
	        });
	      } else {
	        _this.setState({ Status: status });
	      }
	    };
	
	    _this.fetchPurchaseOrdersByProduct = function (productID) {
	      var dateRange = -1;
	      var FromDate = '1900-01-01';
	      var ToDate = '3000-01-01';
	      var purchaser = _this.props.Purchaser;
	      var productNum = productID;
	      if (_this.state.FromDate != null) {
	        FromDate = _this.formatDate(_this.state.FromDate);
	      }
	
	      if (_this.state.ToDate != null) {
	        ToDate = _this.formatDate(_this.state.ToDate);
	      }
	
	      if (_this.state.days != null && typeof _this.state.days !== 'undefined') {
	        dateRange = _this.state.days;
	      }
	
	      if (_this.props.Purchaser) {
	        purchaser = _this.props.Purchaser.value;
	      }
	      _this.setState({ filteredByItem: true, selectedRows: [{}], filterProductID: productID });
	      _this.props.fetchPurchaseOrdersByFilter(FromDate, ToDate, dateRange, _this.state.Status, purchaser, productNum);
	    };
	
	    _this.handleSelectDetailAll = function () {
	      var newRows = [].concat(_toConsumableArray(_this.state.purchaseOrderDetail.rows));
	      var selectedRows = [];
	      var index = 0;
	      newRows.map(function (r) {
	        r.isSelected = true;
	        selectedRows.push(r);
	        index++;
	      });
	      var purchaseOrderDetail = _extends({}, _this.state.purchaseOrderDetail, { rows: newRows, selectedRows: selectedRows });
	      _this.setState({ purchaseOrderDetail: purchaseOrderDetail });
	    };
	
	    _this.handleDeselectDetailAll = function () {
	      var newRows = [].concat(_toConsumableArray(_this.state.purchaseOrderDetail.rows));
	      var selectedRows = null;
	      var index = 0;
	      newRows.map(function (r) {
	        r.isSelected = false;
	      });
	      var purchaseOrderDetail = _extends({}, _this.state.purchaseOrderDetail, { rows: newRows, selectedRows: selectedRows });
	      _this.setState({ purchaseOrderDetail: purchaseOrderDetail });
	    };
	
	    _this.IFrameIsLoaded = function () {
	      if (!_this.state.PdfFrameLoaded) {
	        var pdfFrame = window.frames.purchaseOrderPdf;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this.setState({ PdfFrameLoaded: true });
	      }
	    };
	
	    _this.IFrameIsLoadedNs = function () {
	      if (!_this.state.PdfFrameLoadedNs) {
	        var pdfFrame = window.frames.purchaseOrderPdfNs;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this.setState({ PdfFrameLoadedNs: true });
	      }
	    };
	
	    _this.openDownloadModal = function (ids, url) {
	      var data = { pk: ids };
	      _this.setState({ openDownloadModalLoading: true });
	      _axios2.default.post(url, data, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        if (response.data) {
	          _this.setState({ openDownloadModalUrl: response.data.url, openDownloadModalVisibility: true, openDownloadModalLoading: false });
	        }
	      }, function (err) {
	        // this.setState({openDownloadModalUrl: 'https://www.google.com/search?q=google&oq=google&aqs=chrome..69i57j46i131i199i433i465i512j0i433i512l2j69i60l4.687j0j7&sourceid=chrome&ie=UTF-8', openDownloadModalVisibility: true});
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	        _this.setState({ openDownloadModalLoading: false });
	      });
	      // this.setState({openDownloadModalVisibility: true});
	    };
	
	    _this.closeDownloadModal = function () {
	      _this.setState({ openDownloadModalVisibility: false, openDownloadModalUrl: null });
	    };
	
	    _this.mergeAndRedirect = function () {
	      var orderIds = _this.state.orderIds;
	
	      _this.props.mergePurchaseOrders(orderIds);
	    };
	
	    _this.openMergeRequest = function () {
	      _this.setState({
	        mergeModalOpen: true
	      });
	    };
	
	    _this.cancelMergeRequest = function () {
	      _this.setState({
	        mergeModalOpen: false
	      });
	    };
	
	    _this.mergePurchaseRows = function () {
	      var selectedRows = _this.state.selectedRows;
	
	      var validMerge = true;
	      var orderIds = [];
	      if (selectedRows && selectedRows.length) {
	        selectedRows.map(function (row) {
	          var r = row;
	          // if (r.PurchaseStatus === 'Pending' || r.PurchaseStatus === 'Open') {
	          if (r.PurchaseStatus !== 'Placed') {
	            validMerge = false;
	          } else {
	            orderIds.push(r.PurchaseOrder_id);
	          }
	        });
	        _this.setState({
	          orderIds: orderIds,
	          validMerge: validMerge
	        });
	      }
	    };
	
	    _this.openTrackingNoteModal = function () {
	      _this.setState({ showTrackingNoteModal: true });
	    };
	
	    _this.closeTrackingNoteModal = function () {
	      _this.setState({ showTrackingNoteModal: false });
	    };
	
	    _this.renderSendEmailButton = function () {
	      var selectedRows = _this.state.selectedRows;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'print-btn',
	          disabled: selectedRows.length !== 1,
	          type: 'button',
	          onClick: function onClick() {
	            _this.props.emailPO(selectedRows[0].PurchaseOrder_id);
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-email' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email_po' })
	      );
	    };
	
	    _this.onDropImage = function (files) {
	      var formData = new FormData();
	      formData.append('FILE', files[0]);
	      var success = function success() {
	        alert('success');
	        _this.refreshSOList();
	      };
	      var failed = function failed() {
	        alert('failed');
	      };
	      _this.props.uploadPOImage(formData, success, failed);
	    };
	
	    _this.onDropPOD = function (files) {
	      var selectedRows = _this.state.selectedRows;
	      // return;
	
	      var formData = new FormData();
	      formData.append('PODFile', files[0]);
	      var success = function success() {
	        alert('success');
	        _this.refreshList();
	      };
	      var failed = function failed() {
	        alert('failed');
	      };
	      _this.props.uploadPOPOD(selectedRows[0].PurchaseOrder_id, formData, success, failed);
	    };
	
	    _this.state = {
	      clear: true,
	
	      showTrackingNoteModal: false,
	
	      openDownloadModalLoading: false,
	      openDownloadModalVisibility: false,
	
	      rows: [],
	      selectedRows: [],
	      filters: {},
	      sortColumn: null,
	      sortDirection: null,
	
	      purchaseOrderDetail: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null,
	        selectedRows: null
	      },
	
	      suggestValue: '',
	      productSearchType: 'ProductNum',
	      days: '7',
	      filteredByItem: false,
	      currencyCode: '',
	      checkAuthorizeOpen: false,
	      action: null,
	
	      // for generic radiofilter and datePicker
	      FromDate: undefined,
	      ToDate: undefined,
	      Status: isEcity ? 'Placed' : 'all',
	      filterProductID: 0,
	      PdfFrameLoaded: true,
	      PdfFrameLoadedNs: true,
	      orderIds: [],
	      validMerge: true,
	      mergeModalOpen: false,
	      submitImageOpen: false
	    };
	
	    _this.fetchPurchaseOrdersByDetails = _this.fetchPurchaseOrdersByDetails.bind(_this);
	    _this.checkAuthorize = _this.checkAuthorize.bind(_this);
	    _this.openCheckAuthorize = _this.openCheckAuthorize.bind(_this);
	    _this.closeCheckAuthorize = _this.closeCheckAuthorize.bind(_this);
	    return _this;
	  }
	
	  _createClass(PurchaseOrderList, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.setDefaultDays('purchaseOrderList');
	      if (isEcity) {
	        this.props.setDefaultOfForm('Status', 'Placed', 'purchaseOrderList');
	      } else {
	        this.props.setDefaultOfForm('Status', 'all', 'purchaseOrderList');
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      var purchaseOrdersFilter = this.props.purchaseOrdersFilter;
	
	      if (purchaseOrdersFilter) {
	        var selectedRows = purchaseOrdersFilter.currentRows.filter(function (r) {
	          return r.isSelected;
	        });
	        this.setState({ rows: purchaseOrdersFilter.currentRows, selectedRows: selectedRows, filters: {} });
	        this.props.setValue('purchaseOrderList', 'Days', purchaseOrdersFilter.Days);
	        this.props.setValue('purchaseOrderList', 'FromDate', purchaseOrdersFilter.FromDate);
	        this.props.setValue('purchaseOrderList', 'ToDate', purchaseOrdersFilter.ToDate);
	        this.props.setValue('purchaseOrderList', 'Purchaser', purchaseOrdersFilter.Purchaser);
	        this.props.setValue('purchaseOrderList', 'Status', purchaseOrdersFilter.Status);
	        this.props.setValue('purchaseOrderList', 'ProductNum', purchaseOrdersFilter.ProductNum);
	        var fromDate = '1900-01-01';
	        if (purchaseOrdersFilter.FromDate) {
	          fromDate = this.formatDate(purchaseOrdersFilter.FromDate);
	        }
	        var toDate = '3000-01-01';
	        if (purchaseOrdersFilter.ToDate) {
	          toDate = this.formatDate(purchaseOrdersFilter.ToDate);
	        }
	        var purchaser = purchaseOrdersFilter.Purchaser;
	        if (purchaseOrdersFilter.Purchaser) {
	          purchaser = purchaseOrdersFilter.Purchaser.value;
	        }
	        this.props.fetchPurchaseOrdersByFilter(fromDate, toDate, purchaseOrdersFilter.Days, purchaseOrdersFilter.Status, purchaser, purchaseOrdersFilter.ProductNum);
	        this.props.fetchBaseUsers();
	      } else {
	        var _fromDate = '1900-01-01';
	        var _toDate = '3000-01-01';
	        var days = 7;
	        var status = isEcity ? 'Placed' : 'all';
	        this.props.setDefaultDays('purchaseOrderList');
	        if (isEcity) {
	          this.props.setDefaultOfForm('Status', 'Placed', 'purchaseOrderList');
	        } else {
	          this.props.setDefaultOfForm('Status', 'all', 'purchaseOrderList');
	        }
	        this.props.fetchPurchaseOrdersByFilter(_fromDate, _toDate, days, status, null, null);
	        this.props.fetchBaseUsers();
	      }
	    }
	
	    // Once products are ready, reset state.
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
	        this.closeCheckAuthorize();
	        if (this.state.action === 'void') {
	          this.deletePurchaseOrder();
	        }
	      }
	      if (nextProps.purchaseOrders && nextProps.purchaseOrders !== this.props.purchaseOrders) {
	        if (this.props.purchaseOrdersFilter && this.props.purchaseOrdersFilter.currentRows) {
	          var purchaseOrders = nextProps.purchaseOrders;
	
	          var rows = [].concat(_toConsumableArray(this.state.rows));
	          rows = rows.map(function (r) {
	            var index = _.findIndex(purchaseOrders, { PurchaseOrder_id: r.PurchaseOrder_id });
	            if (index > -1) {
	              r.ETADate = purchaseOrders[index].ETADate;
	            } else {
	              r = null;
	            }
	            return r;
	          });
	          rows = rows.filter(function (r) {
	            return r !== null;
	          });
	          var purchaseOrderDetail = _extends({}, this.state.purchaseOrderDetail, { rows: this.props.purchaseOrderList });
	          this.setState({ rows: rows, purchaseOrderDetail: purchaseOrderDetail });
	          this.props.setPurchaseOrdersFilter(null);
	        } else {
	          var _rows = nextProps.purchaseOrders;
	          if (_rows && _rows.length !== 0) {
	            _rows.map(function (row) {
	              row.Dropship = row.IsDropship ? 'yes' : 'no';
	            });
	          }
	          var _purchaseOrderDetail = _extends({}, this.state.purchaseOrderDetail, { rows: [] });
	          this.setState({ rows: _rows, purchaseOrderDetail: _purchaseOrderDetail });
	          this.props.setPurchaseOrdersFilter(null);
	        }
	      }
	
	      if (nextProps.purchaseOrderList && nextProps.purchaseOrderList !== this.props.purchaseOrderList) {
	        var _purchaseOrderDetail2 = _extends({}, this.state.purchaseOrderDetail, { rows: nextProps.purchaseOrderList });
	        this.setState({ purchaseOrderDetail: _purchaseOrderDetail2 });
	      }
	
	      if (nextProps.Status && nextProps.Status !== this.props.Status) {
	        var purchaseOrdersFilter = this.props.purchaseOrdersFilter;
	
	        if (!purchaseOrdersFilter) {
	          var purchaser = this.props.Purchaser;
	          if (this.props.Purchaser) {
	            purchaser = this.props.Purchaser.value;
	          }
	          var fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
	          var toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
	          var days = this.state.days;
	
	          if (days == null) {
	            days = 7;
	          }
	          var productNum = this.props.ProductNum;
	          if (isEcity) {} else {
	            this.props.fetchPurchaseOrdersByFilter(fromDate, toDate, days, nextProps.Status, purchaser, productNum);
	          }
	        }
	      }
	
	      if (nextProps.Purchaser && nextProps.Purchaser !== this.props.Purchaser) {
	        var _purchaseOrdersFilter = this.props.purchaseOrdersFilter;
	
	        if (!_purchaseOrdersFilter) {
	          var _purchaser = nextProps.Purchaser;
	          if (nextProps.Purchaser) {
	            _purchaser = nextProps.Purchaser.value;
	          }
	          var _fromDate2 = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
	          var _toDate2 = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
	          var _days = this.state.days;
	
	          var _productNum = this.props.ProductNum;
	          this.props.fetchPurchaseOrdersByFilter(_fromDate2, _toDate2, _days, this.state.Status, _purchaser, _productNum);
	        }
	      }
	
	      if (this.props.Purchaser && nextProps.Purchaser == null) {
	        var _purchaser2 = nextProps.Purchaser;
	        var _fromDate3 = this.props.FromDate ? this.formatDate(this.props.FromDate) : '1900-01-01';
	        var _toDate3 = this.props.ToDate ? this.formatDate(this.props.ToDate) : '3000-01-01';
	        var _days2 = this.props.Days;
	        var status = this.props.Status;
	        if (isEcity && this.state.days) {
	          _days2 = this.state.days;
	        }
	        if (isEcity && this.state.Status) {
	          status = this.state.Status;
	        }
	        if (isEcity && this.state.FromDate) {
	          _fromDate3 = this.formatDate(this.state.FromDate);
	        }
	        if (isEcity && this.state.ToDate) {
	          _toDate3 = this.formatDate(this.state.ToDate);
	        }
	        var _productNum2 = this.props.ProductNum;
	        this.props.fetchPurchaseOrdersByFilter(_fromDate3, _toDate3, _days2, status, _purchaser2, _productNum2);
	      }
	
	      if (nextProps.Days && nextProps.Days !== this.props.Days) {
	        if (nextProps.Days !== -1) {
	          this.props.setDefaultOfForm('FromDate', null, 'purchaseOrderList');
	          this.props.setDefaultOfForm('ToDate', null, 'purchaseOrderList');
	        }
	        this.setState({ days: nextProps.Days });
	      }
	
	      if (nextProps.purchaseOrderPdf && nextProps.purchaseOrderPdf !== this.props.purchaseOrderPdf) {
	        this.setState({ PdfFrameLoaded: false });
	      }
	
	      if (nextProps.purchaseOrderPdfNs && nextProps.purchaseOrderPdfNs !== this.props.purchaseOrderPdfNs) {
	        this.setState({ PdfFrameLoadedNs: false });
	      }
	
	      if (typeof this.props.FromDate !== 'undefined' && typeof this.props.ToDate !== 'undefined' && (nextProps.FromDate !== this.props.FromDate || nextProps.ToDate !== this.props.ToDate)) {
	        var FromDate = void 0;
	        var ToDate = void 0;
	        var _purchaser3 = this.props.Purchaser;
	        if (nextProps.FromDate != null) {
	          FromDate = this.formatDate(nextProps.FromDate);
	        }
	        if (nextProps.ToDate != null) {
	          ToDate = this.formatDate(nextProps.ToDate);
	        }
	        if (this.props.Purchaser) {
	          _purchaser3 = this.props.Purchaser.value;
	        }
	        this.props.fetchPurchaseOrdersByFilter(FromDate, ToDate, -1, this.props.Status, _purchaser3, this.state.filterProductID);
	      }
	
	      if (nextProps.mergePurchaseOrderSuccess && nextProps.mergePurchaseOrderSuccess !== this.props.mergePurchaseOrderSuccess) {
	        this.cancelMergeRequest();
	        var _fromDate4 = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
	        var _toDate4 = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
	        var _days3 = this.state.days;
	
	        if (_days3 == null) {
	          _days3 = 7;
	        }
	        var _purchaser4 = this.props.Purchaser;
	        if (this.props.Purchaser) {
	          _purchaser4 = this.props.Purchaser.value;
	        }
	        var _productNum3 = this.props.ProductNum;
	        this.props.fetchPurchaseOrdersByFilter(_fromDate4, _toDate4, _days3, nextProps.Status, _purchaser4, _productNum3);
	      }
	
	      if (nextProps.mergePurchaseOrderError && nextProps.mergePurchaseOrderError !== this.props.mergePurchaseOrderError) {
	        this.cancelMergeRequest();
	        alert(nextProps.mergePurchaseOrderError);
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState.PdfFrameLoaded !== this.state.PdfFrameLoaded && !this.state.PdfFrameLoaded) {
	        return false;
	      }
	      if (nextState.PdfFrameLoadedNs !== this.state.PdfFrameLoadedNs && !this.state.PdfFrameLoadedNs) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.clear) {
	        this.props.setPurchaseOrdersFilter(null);
	      }
	    }
	
	    // Used for new generic datePicker//////////////////////////////
	
	  }, {
	    key: 'checkAuthorize',
	    value: function checkAuthorize(password) {
	      this.props.checkPassword(password);
	    }
	  }, {
	    key: 'openCheckAuthorize',
	    value: function openCheckAuthorize(action) {
	      this.props.clearCheckPassword();
	      this.setState({ checkAuthorizeOpen: true, action: action });
	    }
	  }, {
	    key: 'closeCheckAuthorize',
	    value: function closeCheckAuthorize() {
	      this.setState({ checkAuthorizeOpen: false });
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      var formattedDate = date.getFullYear() + '-';
	
	      formattedDate += date.getMonth() + 1 + '-';
	      if (date.getDate() < 10) {
	        formattedDate += '0' + date.getDate();
	      } else {
	        formattedDate += date.getDate();
	      }
	
	      return formattedDate;
	    }
	
	    // Set product being selected to be currentProduct and navigate user to the edit page
	
	  }, {
	    key: 'setCurrentPurchaseOrder',
	    value: function setCurrentPurchaseOrder(e) {
	      e.preventDefault();
	      this.setState({ clear: false });
	      var currentPurchaseOrder = this.state.selectedRows[0];
	      var FromDate = this.props.FromDate;
	      var ToDate = this.props.ToDate;
	
	      this.props.resetCurrentPurchaseOrder();
	      this.props.selectPurchaseOrder(currentPurchaseOrder);
	      var currentRows = _reactDataGridAddons.Data.Selectors.getRows(this.state);
	      this.props.setPurchaseOrdersFilter({
	        Days: this.props.Days,
	        FromDate: FromDate,
	        ToDate: ToDate,
	        Status: this.props.Status,
	        Purchaser: this.props.Purchaser,
	        ProductNum: this.props.ProductNum,
	        currentRows: currentRows
	      });
	      this.context.router('/purchaseOrder/' + currentPurchaseOrder.PurchaseOrder_id);
	    }
	  }, {
	    key: 'printPurchaseOrder',
	    value: function printPurchaseOrder(e) {
	      e.preventDefault();
	      var currentPurchaseOrder = this.state.selectedRows[0];
	      this.props.printPurchaseOrder(currentPurchaseOrder.PurchaseOrder_id);
	    }
	  }, {
	    key: 'deletePurchaseOrder',
	    value: function deletePurchaseOrder() {
	      // e.preventDefault();
	      var currentPurchaseOrder = this.state.selectedRows[0];
	      this.props.deletePurchaseOrder(currentPurchaseOrder.PurchaseOrder_id);
	    }
	  }, {
	    key: 'shouldVoidButtonDisable',
	    value: function shouldVoidButtonDisable() {
	      var selectedRows = this.state.selectedRows;
	
	      // Always disable void if selected more than 1 row
	
	      if (selectedRows === null || selectedRows.length !== 1) {
	        return true;
	      }
	
	      var status = selectedRows[0] ? selectedRows[0].PurchaseStatus : 'disable';
	      var disabled = status !== 'Placed' || status === 'disable';
	      if ((isMMD || isAFG) && (status === 'Pending' || status === 'Merged')) {
	        disabled = false;
	      }
	      return disabled;
	    }
	  }, {
	    key: 'submitApprovePO',
	    value: function submitApprovePO(selectedRows) {
	      var _this2 = this;
	
	      var output = [];
	      selectedRows.map(function (r) {
	        output.push(r.id);
	      });
	      this.props.approvePendingPO(output).then(function (response) {
	        alert('PO Approved');
	        _this2.refreshList();
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = DEFAULT_ERROR;
	        }
	        alert('Error: ' + err.data);
	      });
	    }
	  }, {
	    key: 'refreshList',
	    value: function refreshList() {
	      var _this3 = this;
	
	      // const { purchaseOrdersFilter } = this.props;
	      var selectedRows = this.state.selectedRows;
	
	      var newRows = this.state.rows;
	      var fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
	      var toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
	      var days = this.state.days;
	
	      if (days == null) {
	        days = 7;
	      }
	      var purchaser = this.props.Purchaser;
	      if (this.props.Purchaser) {
	        purchaser = this.props.Purchaser.value;
	      }
	      var productNum = this.props.ProductNum;
	      this.props.fetchPurchaseOrdersByFilter(fromDate, toDate, days, this.state.Status, purchaser, productNum);
	
	      setTimeout(function () {
	        newRows = _this3.state.rows;
	        if (newRows) {
	          newRows.map(function (r, i) {
	            selectedRows.map(function (s, j) {
	              if (r.id === s.id) {
	                selectedRows[j] = r;
	                newRows[i].isSelected = true;
	              }
	            });
	          });
	        }
	        _this3.setState(_extends({}, _this3.state, { selectedRows: selectedRows, rows: newRows }));
	      }, 1000);
	    }
	  }, {
	    key: 'clickNew',
	    value: function clickNew(e) {
	      e.preventDefault();
	      this.props.resetCurrentPurchaseOrder();
	      this.context.router.push('/purchaseOrder/new');
	    }
	  }, {
	    key: 'renderUsers',
	    value: function renderUsers() {
	      if (this.props.usersIsLoading) return _react2.default.createElement(_spinner2.default, null); // If group is loading, show a spinner.
	
	      var Users = this.getUsers();
	      return _react2.default.createElement(
	        'div',
	        { className: 'control-dropdown' },
	        _react2.default.createElement(_reduxForm.Field, { name: 'Purchaser', component: _selection.Selection, options: Users })
	      );
	    }
	  }, {
	    key: 'getUsers',
	    value: function getUsers() {
	      var Users = [];
	      this.props.users.map(function (user) {
	        Users.push({ value: user.user_id, label: user.username });
	      });
	      return Users;
	    }
	  }, {
	    key: 'fetchPurchaseOrdersByDetails',
	    value: function fetchPurchaseOrdersByDetails(days) {
	      var _this4 = this;
	
	      if (this.state.filteredByItem) {
	        this.setState({ days: days }, function () {
	          _this4.fetchPurchaseOrdersByProduct(_this4.state.filterProductID);
	        });
	        return;
	      }
	      var FromDate = '1900-01-01';
	      var ToDate = '3000-01-01';
	      var purchaser = this.props.Purchaser;
	      var productNum = this.props.ProductNum;
	      if (this.state.FromDate != null) {
	        FromDate = this.formatDate(this.state.FromDate);
	      }
	      if (this.state.ToDate != null) {
	        ToDate = this.formatDate(this.state.ToDate);
	      }
	
	      if (this.props.Purchaser) {
	        purchaser = this.props.Purchaser.value;
	      }
	
	      if (days === '-1' || days === -1) {
	        this.setState({ days: days }, function () {
	          _this4.props.fetchPurchaseOrdersByFilter(FromDate, ToDate, days, _this4.state.Status, purchaser, productNum);
	        });
	      } else {
	        this.setState({ days: days, FromDate: undefined, ToDate: undefined }, function () {
	          _this4.props.fetchPurchaseOrdersByFilter(FromDate, ToDate, days, _this4.state.Status, purchaser, productNum);
	        });
	      }
	      this.setState({ selectedRows: [{}], days: days });
	    }
	  }, {
	    key: 'renderTable',
	
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    value: function renderTable() {
	      var _this5 = this;
	
	      if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.error)
	          )
	        );
	      }
	
	      // Parameters of the react-data-grid
	
	      var tableHeight = window.innerHeight < 930 ? 270 : 270;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this5.state);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var onRowClick = function onRowClick(rowIdx, row) {
	        if (rowIdx !== -1) {
	          var rows = getRows();
	          rows.map(function (r) {
	            r.isSelected = false;
	          });
	          rows[rowIdx].isSelected = true;
	          _this5.setState({ rows: rows, selectedRows: [rows[rowIdx]], currencyCode: row.CurrencyCode });
	          _this5.props.fetchPurchaseOrderList(row.PurchaseOrder_id);
	        }
	      };
	
	      var onCellSelected = function onCellSelected(coordinates) {
	        var rows = getRows();
	        rows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows[coordinates.rowIdx].isSelected = true;
	        _this5.setState({ rows: rows, selectedRows: [rows[coordinates.rowIdx]] });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        _this5.setState({ filters: {} });
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this5.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this5.setState(state);
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var rows = _this5.state.rows;
	
	        if (rows && rows.length !== 0) {
	          rows.map(function (row) {
	            row.Dropship = row.IsDropship ? 'yes' : 'no';
	          });
	        }
	        _this5.setState({ rows: rows });
	        var newFilters = Object.assign({}, _this5.state.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        _this5.setState({ filters: newFilters });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var selectedRows = [];
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	
	        newRows.map(function (r) {
	          if (r.isSelected === true) {
	            selectedRows.push(r);
	          }
	        });
	        _this5.setState(_extends({}, _this5.state, { selectedRows: selectedRows, rows: newRows }), function () {
	          _this5.mergePurchaseRows();
	        });
	      };
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = [].concat(_toConsumableArray(_this5.state.rows));
	        var selectedRows = [].concat(_toConsumableArray(_this5.state.selectedRows));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	          var rowIndex = selectedRows.indexOf(r.row);
	          selectedRows.splice(rowIndex, 1);
	        });
	        _this5.setState({ rows: newRows, selectedRows: selectedRows });
	      };
	
	      var StatusFormatter = _react2.default.createClass({
	        displayName: 'StatusFormatter',
	        getStatus: function getStatus() {
	          var _props = this.props,
	              dependentValues = _props.dependentValues,
	              value = _props.value;
	
	          if (value === 'Placed' && dependentValues.container_num) {
	            return 'In Transit';
	          };
	          return value;
	        },
	        render: function render() {
	          return _react2.default.createElement(
	            'span',
	            null,
	            this.getStatus()
	          );
	        }
	      });
	
	      var columns = [{
	        key: 'PONum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'VendorID',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_no' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'VendorName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 200
	      }, {
	        key: 'container_num',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: 'FinalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 75,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'OrderDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'ETADate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'eta_date' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }].concat(_toConsumableArray(isATL ? [{
	        key: 'ETD_Date',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'etd_date' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }] : []), _toConsumableArray(isATL ? [{
	        key: 'Port_Date',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port_date' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }] : []), [{
	        key: 'ShipTo',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipto' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }], _toConsumableArray(isUSPride || isATL || isRS ? [{
	        key: 'PurchaseStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: StatusFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }] : [{
	        key: 'PurchaseStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true
	      }]), [{
	        key: 'ReceivedDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_date' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'Dropship',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ds' }),
	        resizable: true,
	        sortable: true,
	        width: 40,
	        filterable: true
	      }, {
	        key: 'Purchaser_User_Name',
	        name: isEcity ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'creator' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchaser' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }], _toConsumableArray(isEcity ? [{
	        key: 'DefaultPurchaserUserName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchaser' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }] : []), [{
	        key: 'ShippingCost',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 65,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'MiscCost',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'misc_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 65,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }]);
	
	      if (isTN) {
	        columns = [{
	          key: 'PONum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: "container_num",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_no' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'VendorID',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_no' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'VendorName',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_name' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 200
	        }, {
	          key: "customer_name",
	          name: "Client.Cust",
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        },
	        // {
	        //   key: 'FinalPrice',
	        //   name: <Translate value="final_dollarsign" />,
	        //   resizable: true,
	        //   sortable: true,
	        //   width: 75,
	        //   filterable: true,
	        //   formatter: CashFormatter,
	        // },
	        {
	          key: 'OrderDate',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	          resizable: true,
	          sortable: true,
	          width: 90,
	          filterable: true,
	          formatter: _dateFormat.DateFormatter
	        }, {
	          key: 'ETADate',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'eta_date' }),
	          resizable: true,
	          sortable: true,
	          width: 90,
	          filterable: true,
	          formatter: _dateFormat.DateFormatter
	        }, {
	          key: "order_type",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_type' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: "refnum1",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref#1' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: "refnum2",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref#2' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'POD_URL',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pod' }),
	          resizable: true,
	          sortable: true,
	          width: 60,
	          filterable: true,
	          // getRowMetaData: row => row,
	          formatter: function formatter(_ref) {
	            var value = _ref.value;
	
	            if (!value) return _react2.default.createElement('span', null);
	            return _react2.default.createElement(
	              'a',
	              { href: value },
	              'Check'
	            );
	          }
	        }, {
	          key: 'ShipTo',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipto' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'PurchaseStatus',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	          resizable: true,
	          sortable: true,
	          width: 110,
	          filterable: true
	        }, {
	          key: 'ReceivedDate',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_date' }),
	          resizable: true,
	          sortable: true,
	          width: 90,
	          filterable: true,
	          formatter: _dateFormat.DateFormatter
	        }, {
	          key: 'Dropship',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ds' }),
	          resizable: true,
	          sortable: true,
	          width: 40,
	          filterable: true
	        }, {
	          key: 'Purchaser_User_Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchaser' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }];
	      }
	
	      // React Table Purchase Order Full Table
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { id: 'PurchaseOrderList-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'PurchaseOrder_id',
	              enableCellSelect: true,
	              onClearFilters: onClearFilters,
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              columns: columns,
	              rowHeight: 25,
	              headerRowHeight: 45,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: tableHeight,
	              enableRowSelect: 'multi',
	              onRowUpdated: this.handleRowUpdated,
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              },
	              onRowClick: onRowClick,
	              onCellSelected: onCellSelected
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderPrintLabel',
	    value: function renderPrintLabel() {
	      var token = localStorage.getItem('token');
	      var poReceiveLineId = [];
	      var selectedRows = this.state.purchaseOrderDetail.selectedRows;
	
	      if (selectedRows && selectedRows.length > 0) {
	        selectedRows.map(function (row) {
	          poReceiveLineId.push(row.PurchaseOrderLine_id);
	        });
	      }
	      var url = '' + _url.PO_RECEIVE_LINE_PRINT_LABEL_URL + poReceiveLineId.join(",") + '?Bearer=' + token;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          href: url,
	          disabled: !selectedRows
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'label' })
	      );
	    }
	  }, {
	    key: 'renderProductsTable',
	    value: function renderProductsTable() {
	      var _this6 = this;
	
	      if (this.props.purchaseOrderListIsLoading && !this.props.purchaseOrderListError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.purchaseOrderListError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.purchaseOrderListError)
	          )
	        );
	      }
	
	      // Parameters of the react-data-grid
	
	      var tableHeight = window.innerHeight < 930 ? 185 : 185;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this6.state.purchaseOrderDetail);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this6.state.purchaseOrderDetail, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this6.setState({ purchaseOrderDetail: state });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        var purchaseOrderDetail = _extends({}, _this6.state.purchaseOrderDetail, { filters: {} });
	        _this6.setState({ purchaseOrderDetail: purchaseOrderDetail });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this6.state.purchaseOrderDetail.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var purchaseOrderDetail = _extends({}, _this6.state.purchaseOrderDetail, { filters: newFilters });
	        _this6.setState({ purchaseOrderDetail: purchaseOrderDetail });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var selectedRows = [];
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	
	        newRows.map(function (r) {
	          if (r.isSelected === true) {
	            selectedRows.push(r);
	          }
	        });
	        var purchaseOrderDetail = _extends({}, _this6.state.purchaseOrderDetail, { selectedRows: selectedRows, rows: newRows });
	
	        _this6.setState({ purchaseOrderDetail: purchaseOrderDetail });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = [].concat(_toConsumableArray(_this6.state.purchaseOrderDetail.rows));
	        var selectedRows = [].concat(_toConsumableArray(_this6.state.purchaseOrderDetail.selectedRows));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	          var rowIndex = selectedRows.indexOf(r.row);
	          selectedRows.splice(rowIndex, 1);
	        });
	        var purchaseOrderDetail = _extends({}, _this6.state.purchaseOrderDetail, { selectedRows: selectedRows, rows: newRows });
	        _this6.setState({ purchaseOrderDetail: purchaseOrderDetail });
	      };
	
	      var onRowSelect = function onRowSelect(rows) {
	        var purchaseOrderDetail = _extends({}, _this6.state.purchaseOrderDetail, { selectedRows: rows });
	        _this6.setState({ purchaseOrderDetail: purchaseOrderDetail });
	      };
	
	      // Column definition
	
	      var columns = !this.state.currencyCode || this.state.currencyCode === 'USD' ? [].concat(_toConsumableArray(!isLO ? [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }] : []), [{
	        key: 'RefNum',
	        name: isLO ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'item_num' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: isLO ? 160 : 70
	      }], _toConsumableArray(!isLO ? [{
	        key: 'VendorProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_product_number' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }] : []), [{
	        key: 'Name',
	        name: isLO ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 250
	      }], _toConsumableArray(isLO ? [] : [{
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 200
	      }]), _toConsumableArray(isATL ? [{
	        key: 'etd_date1',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'etd_date_1' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }] : []), [{
	        key: 'expire_date',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'expire_date' }),
	        resizable: true,
	        sortable: true,
	        width: 80
	      }, {
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        width: 50,
	        sortable: true
	      }, {
	        key: 'OrderQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_qty' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: 'OrderTotalNetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_wt' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: 'OrderUnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_unit_dollarsign' }),
	        resizable: true,
	        width: 110,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'OrderTotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_total_dollarsign' }),
	        resizable: true,
	        width: 110,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: isPS ? 'dimension' : 'dimension_shipping',
	        name: isPS ? 'DIM (in)' : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_dimension_shipping' }),
	        resizable: true,
	        width: 95,
	        sortable: true
	      }, {
	        key: 'weight_shipping',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_weight_shipping' }),
	        resizable: true,
	        width: 95,
	        sortable: true
	      }, {
	        key: 'ReceiveQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_qty' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: 'ReceiveTotalWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_wt' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: 'ReceiveUnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_unit_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'ReceiveTotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_total_dollarsign' }),
	        resizable: true,
	        width: 80,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }], _toConsumableArray(isLO ? [{
	        key: 'VendorProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_product_number' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }] : [])) : [].concat(_toConsumableArray(!isLO ? [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }] : []), [{
	        key: 'RefNum',
	        name: isLO ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'item_num' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: isLO ? 160 : 70
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 250
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 200
	      }, {
	        key: 'expire_date',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'expire_date' }),
	        resizable: true,
	        sortable: true,
	        width: 80
	      }, {
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        width: 50,
	        sortable: true
	      }, {
	        key: 'OrderQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_qty' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: 'OrderTotalNetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_wt' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: 'OrderUnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_unit_dollarsign' }),
	        resizable: true,
	        width: 100,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'currency_unit',
	        name: _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_unit' }),
	          ' (',
	          this.state.currencyCode,
	          ')'
	        ),
	        resizable: true,
	        width: 100,
	        sortable: true
	      }, {
	        key: 'OrderTotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_total_dollarsign' }),
	        resizable: true,
	        width: 100,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'currency_subtotal',
	        name: _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_total' }),
	          ' (',
	          this.state.currencyCode,
	          ')'
	        ),
	        resizable: true,
	        width: 100,
	        sortable: true
	      }, {
	        key: isPS ? 'dimension' : 'dimension_shipping',
	        name: isPS ? 'DIM (in)' : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_dimension_shipping' }),
	        resizable: true,
	        width: 95,
	        sortable: true
	      }, {
	        key: 'weight_shipping',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_weight_shipping' }),
	        resizable: true,
	        width: 95,
	        sortable: true
	      }, {
	        key: 'ReceiveQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_qty' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: 'ReceiveTotalWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_wt' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: 'ReceiveUnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_unit_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'ReceiveTotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_total_dollarsign' }),
	        resizable: true,
	        width: 80,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }]);
	
	      if (isTN) {
	        columns = !this.state.currencyCode || this.state.currencyCode === 'USD' ? [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	          resizable: true,
	          sortable: true,
	          width: 100
	        }, {
	          key: 'RefNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }),
	          resizable: true,
	          sortable: true,
	          width: 70
	        }, {
	          key: 'VendorProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_product_number' }),
	          resizable: true,
	          sortable: true,
	          width: 150
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	          resizable: true,
	          sortable: true,
	          width: 250
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true,
	          width: 200
	        }, {
	          key: 'pallet_barcode',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_barcode' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 150
	        }, {
	          key: 'container_num',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_no' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 120
	        }, {
	          key: 'expire_date',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'expire_date' }),
	          resizable: true,
	          sortable: true,
	          width: 80
	        }, {
	          key: 'PackageType',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	          resizable: true,
	          width: 50,
	          sortable: true
	        }, {
	          key: 'OrderQuantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_qty' }),
	          resizable: true,
	          width: 70,
	          sortable: true
	        }, {
	          key: "total_box",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_box' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: "pc_box",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pc_box' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: "ctn_per_pallet",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ctn_plt' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: "num_pallets",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_qty' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: "pack",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pack' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        }, {
	          key: 'OrderTotalNetWeight',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_wt' }),
	          resizable: true,
	          width: 70,
	          sortable: true
	        }, {
	          key: isPS ? 'dimension' : 'dimension_shipping',
	          name: isPS ? 'DIM (in)' : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_dimension_shipping' }),
	          resizable: true,
	          width: 95,
	          sortable: true
	        }, {
	          key: 'weight_shipping',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_weight_shipping' }),
	          resizable: true,
	          width: 95,
	          sortable: true
	        }, {
	          key: 'ReceiveQuantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_qty' }),
	          resizable: true,
	          width: 70,
	          sortable: true
	        }, {
	          key: 'ReceiveTotalWeight',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_wt' }),
	          resizable: true,
	          width: 70,
	          sortable: true
	        }] : [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	          resizable: true,
	          sortable: true,
	          width: 100
	        }, {
	          key: 'RefNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }),
	          resizable: true,
	          sortable: true,
	          width: 70
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	          resizable: true,
	          sortable: true,
	          width: 250
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true,
	          width: 200
	        }, {
	          key: 'pallet_barcode',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_barcode' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 150
	        }, {
	          key: 'container_num',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_no' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 120
	        }, {
	          key: 'expire_date',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'expire_date' }),
	          resizable: true,
	          sortable: true,
	          width: 80
	        }, {
	          key: 'PackageType',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	          resizable: true,
	          width: 50,
	          sortable: true
	        }, {
	          key: 'OrderQuantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_qty' }),
	          resizable: true,
	          width: 70,
	          sortable: true
	        }, {
	          key: "total_box",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_box' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: "pc_box",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pc_box' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: "pack",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pack' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        }, {
	          key: 'OrderTotalNetWeight',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_wt' }),
	          resizable: true,
	          width: 70,
	          sortable: true
	        }, {
	          key: 'currency_unit',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_unit_dollarsign' }),
	          resizable: true,
	          width: 100,
	          sortable: true
	        }, {
	          key: 'currency_subtotal',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_total_dollarsign' }),
	          resizable: true,
	          width: 100,
	          sortable: true
	        }, {
	          key: isPS ? 'dimension' : 'dimension_shipping',
	          name: isPS ? 'DIM (in)' : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_dimension_shipping' }),
	          resizable: true,
	          width: 95,
	          sortable: true
	        }, {
	          key: 'weight_shipping',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_weight_shipping' }),
	          resizable: true,
	          width: 95,
	          sortable: true
	        }, {
	          key: 'ReceiveQuantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_qty' }),
	          resizable: true,
	          width: 70,
	          sortable: true
	        }, {
	          key: 'ReceiveTotalWeight',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_wt' }),
	          resizable: true,
	          width: 70,
	          sortable: true
	        }];
	      }
	
	      if (isPS) {
	        var indexWT = _.findIndex(columns, { key: "weight_shipping" });
	        var cmCol = {
	          key: "dimension_cm",
	          name: "DIM (cm)",
	          resizable: true,
	          width: 95,
	          sortable: true
	        };
	        var mmCol = {
	          key: "dimension_mm",
	          name: "DIM (mm)",
	          resizable: true,
	          width: 95,
	          sortable: true
	        };
	        columns.splice(indexWT, 0, cmCol, mmCol);
	      }
	
	      if (isUSPride) {
	        var OrderUnitPriceIndex = _.findIndex(columns, { key: "OrderUnitPrice" });
	        var expiredIndex = _.findIndex(columns, { key: 'expire_date' });
	        var pcsbox = {
	          key: 'purchase_convert_unit',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pcs_box' }),
	          resizable: true,
	          width: 70,
	          sortable: true
	        };
	        var totalPcs = {
	          key: 'pcs_quantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_pcs' }),
	          resizable: true,
	          width: 70,
	          sortable: true
	        };
	        columns.splice(expiredIndex, 1);
	        columns.splice(OrderUnitPriceIndex, 0, pcsbox, totalPcs);
	      }
	
	      // React Table Purchase Order Details
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { className: 'recat-customizer', id: 'PurchaseOrderList-dataGrid2' },
	            isTN ? _react2.default.createElement(_reactDataGrid2.default, {
	              headerRowHeight: 45,
	              onGridSort: handleGridSort,
	              onAddFilter: handleFilterChange,
	              onClearFilters: onClearFilters,
	              columns: columns,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              rowHeight: 25,
	              minHeight: tableHeight,
	              onRowUpdated: this.handleRowUpdated,
	              enableRowSelect: 'single',
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              }
	            }) : _react2.default.createElement(_reactDataGrid2.default, {
	              headerRowHeight: 45,
	              onGridSort: handleGridSort,
	              onAddFilter: handleFilterChange,
	              onClearFilters: onClearFilters,
	              columns: columns,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              rowHeight: 25,
	              minHeight: tableHeight,
	              onRowUpdated: this.handleRowUpdated,
	              onRowSelect: onRowSelect
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderIFrame',
	    value: function renderIFrame() {
	      if (this.props.purchaseOrderPdf) {
	        var file = window.URL.createObjectURL(this.props.purchaseOrderPdf);
	        return _react2.default.createElement('iframe', { style: { display: 'none' }, onLoad: this.IFrameIsLoaded, id: 'purchaseOrderPdf', name: 'purchaseOrderPdf', src: file });
	      }
	      return null;
	    }
	  }, {
	    key: 'renderIFrameNs',
	    value: function renderIFrameNs() {
	      if (this.props.purchaseOrderPdfNs) {
	        var file = window.URL.createObjectURL(this.props.purchaseOrderPdfNs);
	        return _react2.default.createElement('iframe', { style: { display: 'none' }, onLoad: this.IFrameIsLoadedNs, id: 'purchaseOrderPdfNs', name: 'purchaseOrderPdfNs', src: file });
	      }
	      return null;
	    }
	  }, {
	    key: 'renderPrint',
	    value: function renderPrint() {
	      var _this7 = this;
	
	      var purchaseOrder_id = this.state.selectedRows && this.state.selectedRows.length === 1 && this.state.selectedRows[0].PurchaseOrder_id;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          className: 'btn btn-primary marginLeftStyle',
	          disabled: this.props.requestingPurchaseOrderPdf || !purchaseOrder_id || !(0, _permissions2.default)('print_purchase_order'),
	          type: 'button',
	          onClick: function onClick() {
	            _this7.props.printPurchaseOrder(purchaseOrder_id);
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_po' })
	      );
	    }
	  }, {
	    key: 'renderPrintNs',
	    value: function renderPrintNs() {
	      var _this8 = this;
	
	      if (isPS) return;
	      var purchaseOrder_id = this.state.selectedRows && this.state.selectedRows.length === 1 && this.state.selectedRows[0].PurchaseOrder_id;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          className: ' btn btn-primary marginLeftStyle',
	          disabled: this.props.requestingPurchaseOrderPdfNs || !purchaseOrder_id || !(0, _permissions2.default)('print_purchase_order'),
	          onClick: function onClick() {
	            _this8.props.printPurchaseOrderNoSubtotals(purchaseOrder_id);
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_ns' })
	      );
	    }
	  }, {
	    key: 'renderDuplicate',
	    value: function renderDuplicate() {
	      var _this9 = this;
	
	      // const purchaseOrder_id = this.state.selectedRows && this.state.selectedRows.length === 1 && this.state.selectedRows[0].PurchaseOrder_id;
	      var purchaseOrder_num = this.state.selectedRows && this.state.selectedRows.length === 1 && this.state.selectedRows[0].PONum;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: ' btn btn-primary marginLeftStyle',
	          disabled: !purchaseOrder_num,
	          onClick: function onClick() {
	            _axios2.default.post(_root_url.ROOT_URL + 'v1/purchase/copy_po/' + purchaseOrder_num, null, {
	              headers: {
	                Authorization: 'Bearer ' + localStorage.getItem("token")
	              }
	            }).then(function (res) {
	              alert("Duplicate PO Successful");
	              _this9.refreshList();
	            }, function (err) {
	              // this.refreshList();
	              if (err.data) {
	                alert(err.data);
	              } else {
	                alert("Server issue detected, please contact admin.");
	              }
	            });
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-plus' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'duplicate' })
	      );
	    }
	  }, {
	    key: 'renderExportButton',
	    value: function renderExportButton() {
	      var _state = this.state,
	          FromDate = _state.FromDate,
	          ToDate = _state.ToDate;
	
	      var Days = this.state.days;
	      var status = this.state.Status === 'all' ? '' : '&PurchaseStatus=' + this.state.Status;
	      var dateRange = Days || -1;
	
	      var _toFromDates = (0, _cleanDates.toFromDates)(dateRange, FromDate, ToDate),
	          fromDate = _toFromDates.fromDate,
	          toDate = _toFromDates.toDate;
	
	      var exportUrl = _root_url.ROOT_URL + 'v1/purchase/search/export/?OrderDate__gte=' + fromDate + '&OrderDate__lte=' + toDate + status + '&Bearer=' + localStorage.getItem('token');
	
	      // const buttonShouldDisable =
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: 'success', className: 'export-to-excel', href: exportUrl, disabled: !(0, _permissions2.default)('print_purchase_order') },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	      );
	    }
	  }, {
	    key: 'renderOrderExportButtonATL',
	    value: function renderOrderExportButtonATL() {
	      var _this10 = this;
	
	      var selectedRows = this.state.selectedRows;
	
	      var salesOrderIds = null;
	      if (selectedRows && selectedRows.length === 1) {
	        salesOrderIds = selectedRows[0].PurchaseOrder_id;
	        // selectedRows.map((row) => {
	        //   salesOrderIds.push(row.PurchaseOrder_id);
	        // });
	      }
	
	      // const exportUrl = `${ROOT_URL}v1/sale/sales_mobile_order/search/orderdetailexport/${salesOrderIds.join(",")}?Bearer=${localStorage.getItem("token")}`
	      var exportUrl2 = _root_url.ROOT_URL + 'v1/purchase/search/purchase_export';
	
	      return _react2.default.createElement(
	        _SpinnerButton2.default,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          style: { marginBottom: '5px' }
	          // href={exportUrl}
	          , onClick: function onClick() {
	            // this.props.printPickingList(salesOrderIds.join(','));
	            _this10.openDownloadModal(salesOrderIds, exportUrl2);
	          },
	          loading: this.state.openDownloadModalLoading,
	          disabled: !salesOrderIds || this.state.openDownloadModalLoading,
	          icon: 'fa-download',
	          translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel_export' })
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel_export' })
	      );
	    }
	  }, {
	    key: 'renderExportSelectedButton',
	    value: function renderExportSelectedButton() {
	      var purchaseOrderIds = [];
	      var selectedRows = this.state.selectedRows;
	
	      if (selectedRows && selectedRows.length > 0) {
	        selectedRows.map(function (row) {
	          purchaseOrderIds.push(row.PurchaseOrder_id);
	        });
	      }
	      var exportUrl = _root_url.ROOT_URL + 'v2/po-line-export/' + purchaseOrderIds.join(",") + '?Bearer=' + localStorage.getItem("token");
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: 'success', className: 'export-to-excel', href: exportUrl, disabled: !purchaseOrderIds || purchaseOrderIds.length < 1 },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel_lines' })
	      );
	    }
	  }, {
	    key: 'renderConvertButton',
	    value: function renderConvertButton() {
	      var _this11 = this;
	
	      var purchaseOrderIds = [];
	      var selectedRows = this.state.selectedRows;
	
	      if (selectedRows && selectedRows.length > 0) {
	        selectedRows.map(function (row) {
	          purchaseOrderIds.push(row.PurchaseOrder_id);
	        });
	      }
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          className: ' btn btn-primary marginLeftStyle',
	          disabled: selectedRows.length !== 1,
	          onClick: function onClick() {
	            _axios2.default.post(_root_url.ROOT_URL + 'v1/purchase/order/convert_line/' + purchaseOrderIds, null, {
	              headers: {
	                Authorization: 'Bearer ' + localStorage.getItem("token")
	              }
	            }).then(function (res) {
	              alert("Convert PO Successful");
	              _this11.refreshList();
	            }, function (err) {
	              // this.refreshList();
	              if (err.data) {
	                alert(err.data);
	              } else {
	                alert("Server issue detected, please contact admin.");
	              }
	            });
	          } },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'convert_po' })
	      );
	    }
	  }, {
	    key: 'renderMergeButton',
	    value: function renderMergeButton() {
	      var _state2 = this.state,
	          validMerge = _state2.validMerge,
	          orderIds = _state2.orderIds,
	          selectedRows = _state2.selectedRows;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          disabled: !validMerge || orderIds.length === 0 || selectedRows.length < 2,
	          onClick: this.openMergeRequest
	        },
	        _react2.default.createElement('em', { 'class': 'fa fa-compress' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'merge' })
	      );
	    }
	  }, {
	    key: 'checkTrackingNoteDisable',
	    value: function checkTrackingNoteDisable() {
	      var selectedRows = this.state.selectedRows;
	
	      if (selectedRows === null || selectedRows.length !== 1) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'renderTrackingNote',
	    value: function renderTrackingNote() {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          disabled: this.checkTrackingNoteDisable(),
	          onClick: this.openTrackingNoteModal
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tracking_note' })
	      );
	    }
	  }, {
	    key: 'renderApprovePO',
	    value: function renderApprovePO() {
	      var _this12 = this;
	
	      var selectedRows = this.state.selectedRows;
	
	      var onlyPending = true;
	      if (selectedRows) {
	        selectedRows.map(function (r) {
	          if (r.PurchaseStatus !== 'Pending') {
	            onlyPending = false;
	          }
	        });
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          disabled: !selectedRows || selectedRows.length < 1 || onlyPending === false,
	          onClick: function onClick() {
	            _this12.submitApprovePO(selectedRows);
	          }
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'approve' })
	      );
	    }
	  }, {
	    key: 'renderAutoSuggest',
	    value: function renderAutoSuggest() {
	      var _this13 = this;
	
	      if (!this.state.filteredByItem) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'control-dropdown' },
	          _react2.default.createElement(_GenericProductSuggest2.default, {
	            value: this.state.suggestValue,
	            onChange: function onChange(e, _ref2) {
	              var newValue = _ref2.newValue;
	
	              _this13.setState({ suggestValue: newValue });
	            },
	            SearchType: this.state.productSearchType,
	            fetchOrdersByProduct: this.fetchPurchaseOrdersByProduct
	          })
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'control-dropdown', id: 'suggestion-box' },
	        this.state.suggestValue,
	        _react2.default.createElement('em', {
	          className: 'fa fa-times pull-right',
	          onClick: function onClick() {
	            _this13.setState({ filteredByItem: false, suggestValue: '', filterProductID: null }, function () {
	              _this13.fetchPurchaseOrdersByDetails(_this13.state.days);
	            });
	          }
	        })
	      );
	    }
	  }, {
	    key: 'openSubmitImage',
	    value: function openSubmitImage() {
	      this.setState({ submitImageOpen: true });
	    }
	  }, {
	    key: 'closeSubmitImage',
	    value: function closeSubmitImage() {
	      this.setState({ submitImageOpen: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this14 = this;
	
	      var createDialogStyle = {
	        width: '550px',
	        height: '300px',
	        marginLeft: '-15%'
	      };
	      var dlMODAL = {
	        width: "550px",
	        height: "300px",
	        marginLeft: "-15%"
	      };
	      var createTrackingNoteStyle = {
	        width: '1000px',
	        height: '500px'
	        // marginLeft: '-15%',
	      };
	      var bolImageDialogue = {
	        width: "700px",
	        height: "600px",
	        marginLeft: "-15%"
	      };
	      var trackingNoteTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tracking_note' });
	      var selectedRows = this.state.selectedRows;
	
	      var purchaseOrder_id = this.state.selectedRows && this.state.selectedRows[0] && this.state.selectedRows[0].PurchaseOrder_id;
	      purchaseOrder_id = purchaseOrder_id || '';
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_order' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'purchase-order-list' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { id: 'date-range-picker', className: 'form-horizontal' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'filter-title' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_status' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'colon' },
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 10 },
	                      _react2.default.createElement(
	                        'div',
	                        { id: 'statusFilterRadios', className: 'form-horizontal' },
	                        (0, _genericRadioFilter2.default)({
	                          content: [{
	                            option: 'all',
	                            id: 'all-radio-filter',
	                            name: 'statusFilterRadios',
	                            labelName: 'all'
	                          }, {
	                            option: 'Placed',
	                            id: 'placed-radio-filter',
	                            name: 'statusFilterRadios',
	                            labelName: 'placed'
	                          }, {
	                            option: 'Received',
	                            id: 'received-radio-filter',
	                            name: 'statusFilterRadios',
	                            labelName: 'received'
	                          }].concat(_toConsumableArray(isTN ? [] : [{
	                            option: 'Partially Received',
	                            id: 'partial-received-radio-filter',
	                            name: 'statusFilterRadios',
	                            labelName: 'partial'
	                          }]), [{
	                            option: 'Canceled',
	                            id: 'canceled-received-radio-filter',
	                            name: 'statusFilterRadios',
	                            labelName: 'canceled'
	                          }]),
	                          value: this.state.Status,
	                          handleOnClick: this.handleStatusFilterChange,
	                          type: 'buttons'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'filter-title' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_date' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'colon' },
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 10 },
	                      (0, _dateFilterRadios2.default)({
	                        handleOnClick: this.fetchPurchaseOrdersByDetails,
	                        setToRangeSearch: this.setToRangeSearch,
	                        setFromDate: this.setFromDate,
	                        setToDate: this.setToDate,
	                        FromDate: this.state.FromDate,
	                        ToDate: this.state.ToDate,
	                        Days: this.state.days
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'position-relative table-collapse-fix', style: { height: isTN ? '400px' : '370px' } },
	                  _react2.default.createElement(
	                    'div',
	                    { style: { position: 'relative', height: isTN ? '55px' : '25' } },
	                    _react2.default.createElement(
	                      _reactBootstrap.ButtonToolbar,
	                      { className: 'table-buttons' },
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: 'success',
	                          type: 'submit',
	                          href: '/purchaseOrder/new'
	                          // onClick={(event) => { this.clickNew(event); }}
	                          , disabled: !(0, _permissions2.default)('add_purchase_order')
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	                      ),
	                      isTN && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: 'success'
	                          // type="submit"
	                          // href="/purchaseOrder/new"
	                          , onClick: function onClick(event) {
	                            _this14.refs.excelFileInputRef.click();
	                          },
	                          disabled: !(0, _permissions2.default)('add_purchase_order')
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_with_excel' })
	                      ),
	                      isTN && _react2.default.createElement('input', {
	                        type: 'file',
	                        onChange: function onChange(e) {
	                          var formData = new FormData();
	                          formData.append('FILE', e.target.files[0]);
	                          if (e.target.files[0]) {
	                            _axios2.default.post(_root_url.ROOT_URL + 'v2/po-xls/', formData, {
	                              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	                            }).then(function (res) {
	                              // this.fetchPurchaseOrdersByDetails(this.state.days)
	                              alert("PO Imported Successfully");
	                              _this14.refreshList();
	                            }, function (err) {
	                              if (err.data) {
	                                alert(err.data);
	                              } else {
	                                alert("Server issue detected, please contact admin.");
	                              }
	                            });
	                          }
	                        },
	                        ref: 'excelFileInputRef',
	                        name: '',
	                        id: '',
	                        style: { display: 'none' }
	                      }),
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: 'warning',
	                          type: 'button',
	                          href: '/purchaseOrder/' + purchaseOrder_id
	                          // onClick={(event) => { this.setCurrentPurchaseOrder(event); }}
	                          , disabled: !this.state.selectedRows || this.state.selectedRows.length !== 1 || !(0, _permissions2.default)('change_purchase_order')
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: 'danger',
	                          type: 'reset',
	                          onClick: function onClick() {
	                            _this14.openCheckAuthorize('void');
	                          },
	                          disabled: this.shouldVoidButtonDisable() || !(0, _permissions2.default)('delete_purchase_order')
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-trash-o' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'void' })
	                      ),
	                      this.renderPrint(),
	                      this.renderPrintNs(),
	                      isMMD && this.renderDuplicate()
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'table-filters', style: { zIndex: 1 } },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_purchaser' })
	                      ),
	                      this.renderUsers(),
	                      _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        { className: 'table-buttons' },
	                        this.renderExportButton(),
	                        isATL && this.renderOrderExportButtonATL(),
	                        (isTN || isAFG || isMMD) && this.renderExportSelectedButton(),
	                        isAFGRelated && this.renderMergeButton(),
	                        this.renderTrackingNote(),
	                        isTN && this.renderConvertButton(),
	                        (isAFG || isMyuMyu || isMMD) && this.renderApprovePO(),
	                        isOCM && this.renderSendEmailButton()
	                      )
	                    ),
	                    isTN && _react2.default.createElement(
	                      'div',
	                      { className: 'table-filters-thirdrow', style: { zIndex: 1 } },
	                      _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        { style: { position: 'relative', display: 'flex', flexDirection: 'row' } },
	                        _react2.default.createElement(
	                          _reactBootstrap.Button,
	                          {
	                            bsStyle: 'success',
	                            type: 'submit',
	                            disabled: this.state.selectedRows.length !== 1,
	                            onClick: function onClick() {
	                              return _this14.openSubmitImage();
	                            }
	                          },
	                          _react2.default.createElement('em', { className: 'fa fa-upload' }),
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'upload_image' })
	                        ),
	                        _react2.default.createElement(
	                          _reactDropzone2.default,
	                          { onDrop: this.onDropPOD, style: { 'padding-left': '5px' }, className: 'upload-button' },
	                          _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                              bsStyle: 'success',
	                              type: 'submit',
	                              disabled: this.state.selectedRows.length !== 1
	                            },
	                            _react2.default.createElement('em', { className: 'fa fa-upload' }),
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'upload_pod' })
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'autosuggest-div' },
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { style: { height: '30px' } },
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(_TypeRadios2.default, { value: this.state.productSearchType, handleOptionChange: this.handleOptionChange })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 12 },
	                              this.renderAutoSuggest()
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  this.renderTable()
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_order_details' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'details-table-collapse-fix' },
	                  isTN && _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    { className: 'table-buttons' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        style: { marginLeft: '5px' },
	                        onClick: this.handleSelectDetailAll
	                      },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_all' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        bsStyle: 'danger',
	                        style: { marginLeft: '5px' },
	                        onClick: this.handleDeselectDetailAll
	                      },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deselect_all' })
	                    ),
	                    this.renderPrintLabel()
	                  ),
	                  this.renderProductsTable()
	                )
	              )
	            ),
	            this.renderIFrame(),
	            this.renderIFrameNs()
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            { dialogStyles: createDialogStyle, isVisible: this.state.checkAuthorizeOpen, onCloseClicked: this.closeCheckAuthorize },
	            _react2.default.createElement(_confirmActionModal2.default, { 'case': 'confirmPassword', closeC: this.checkAuthorize, checkPasswordFailure: this.props.checkPasswordFailure })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: dlMODAL,
	              isVisible: this.state.openDownloadModalVisibility,
	              onCloseClicked: function onCloseClicked() {
	                _this14.closeDownloadModal();
	              },
	              title: "File Ready"
	            },
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'centerStyle' },
	              _react2.default.createElement(
	                'h4',
	                { style: { paddingLeft: '15px', paddingRight: '15px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'file_is_ready_to_download' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { className: 'button-toolbar-center' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  href: this.state.openDownloadModalUrl,
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'download' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  onClick: function onClick() {
	                    return _this14.closeDownloadModal();
	                  },
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createTrackingNoteStyle,
	              isVisible: this.state.showTrackingNoteModal,
	              onCloseClicked: this.closeTrackingNoteModal,
	              onOverlayClicked: this.closeTrackingNoteModal,
	              title: trackingNoteTitle
	            },
	            _react2.default.createElement(_trackingNoteModal2.default, {
	              selectedOrder: selectedRows
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogStyle,
	              onCloseClicked: this.cancelMergeRequest,
	              onOverlayClicked: this.cancelMergeRequest,
	              isVisible: this.state.mergeModalOpen
	            },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'centerStyle' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_confirm_merge_pos' })
	              )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'centerStyle' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'primary', className: 'mr', onClick: this.mergeAndRedirect, type: 'button' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'danger', className: 'mr', onClick: this.cancelMergeRequest, type: 'button' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: bolImageDialogue,
	              isVisible: this.state.submitImageOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this14.closeSubmitImage();
	              },
	              title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit_image' })
	            },
	            _react2.default.createElement(_BolImagesTablePO2.default, {
	              poid: this.state.selectedRows.length === 1 && this.state.selectedRows[0].PurchaseOrder_id,
	              handleImageClosed: function handleImageClosed() {
	                _this14.closeSubmitImage();
	              }
	            })
	          )
	        )
	        //---------------
	        // End HTML: Purchase Order List
	        //---------------
	
	      );
	    }
	  }]);
	
	  return PurchaseOrderList;
	}(_react.Component);
	
	PurchaseOrderList.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	PurchaseOrderList.propTypes = propTypes;
	var _default = PurchaseOrderList;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isJML, 'isJML', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseOrderList.jsx');
	
	  __REACT_HOT_LOADER__.register(isAFGRelated, 'isAFGRelated', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseOrderList.jsx');
	
	  __REACT_HOT_LOADER__.register(isAFG, 'isAFG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseOrderList.jsx');
	
	  __REACT_HOT_LOADER__.register(isMMD, 'isMMD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseOrderList.jsx');
	
	  __REACT_HOT_LOADER__.register(isMyuMyu, 'isMyuMyu', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseOrderList.jsx');
	
	  __REACT_HOT_LOADER__.register(isTN, 'isTN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseOrderList.jsx');
	
	  __REACT_HOT_LOADER__.register(isPS, 'isPS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseOrderList.jsx');
	
	  __REACT_HOT_LOADER__.register(isUSPride, 'isUSPride', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseOrderList.jsx');
	
	  __REACT_HOT_LOADER__.register(isATL, 'isATL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseOrderList.jsx');
	
	  __REACT_HOT_LOADER__.register(isOCM, 'isOCM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseOrderList.jsx');
	
	  __REACT_HOT_LOADER__.register(isRS, 'isRS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseOrderList.jsx');
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseOrderList.jsx');
	
	  __REACT_HOT_LOADER__.register(isLO, 'isLO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseOrderList.jsx');
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseOrderList.jsx');
	
	  __REACT_HOT_LOADER__.register(PurchaseOrderList, 'PurchaseOrderList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseOrderList.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseOrderList.jsx');
	}();

	;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _inputField = __webpack_require__(16);
	
	var _selection = __webpack_require__(21);
	
	var _reactDropzone = __webpack_require__(45);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _numberWithCommas = __webpack_require__(35);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PurchasePaymentDetail = function (_Component) {
	  _inherits(PurchasePaymentDetail, _Component);
	
	  function PurchasePaymentDetail() {
	    _classCallCheck(this, PurchasePaymentDetail);
	
	    var _this = _possibleConstructorReturn(this, (PurchasePaymentDetail.__proto__ || Object.getPrototypeOf(PurchasePaymentDetail)).call(this));
	
	    _this.state = {
	      files: null,
	
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton,
	      productNum: null,
	      instock: null,
	      purchased: null,
	      sold: null,
	
	      rows: [],
	      selectedRows: [],
	      filters: {},
	      sortColumn: null,
	      sortDirection: null
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.deleteFile = _this.deleteFile.bind(_this);
	    return _this;
	  }
	
	  _createClass(PurchasePaymentDetail, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var currentReceiveHistory = this.props.currentReceiveHistory;
	
	      window.addEventListener('resize', this.handleResize);
	      this.props.resetAttachedFile();
	      if (currentReceiveHistory) {
	        this.props.fetchReceiveHistoryDetailRecord(currentReceiveHistory.WarehouseReceive_id, currentReceiveHistory.Warehouse_ReceiveCompleted_id);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.currentReceiveHistoryDetail != null && nextProps.currentReceiveHistoryDetail != this.props.currentReceiveHistoryDetail) {
	        var WarehouseReceiveNum = nextProps.currentReceiveHistoryDetail.WarehouseReceiveNum;
	        var Name = nextProps.currentReceiveHistoryDetail.Attachments && nextProps.currentReceiveHistoryDetail.Attachments[0];
	        var currentReceiveHistoryDetail = nextProps.currentReceiveHistoryDetail;
	        if (currentReceiveHistoryDetail.Warehouse_Receive_Line_Completed) {
	          this.setState({ rows: currentReceiveHistoryDetail.Warehouse_Receive_Line_Completed });
	        } else {
	          this.setState({ rows: currentReceiveHistoryDetail.Warehouse_Receive_Line });
	        }
	        if (Name) this.props.fetchAttachedFile(WarehouseReceiveNum, Name);
	      }
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton });
	    }
	  }, {
	    key: 'attachmentHeader',
	    value: function attachmentHeader() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'label',
	          { style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'attachment_upload' })
	        )
	      );
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this2 = this;
	
	      if (this.props.detailIsLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          this.props.error
	        )
	      );else {
	
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	
	          var rows = getRows();
	          return Object.assign({}, rows[rowIdx]);
	        };
	
	        var onRowSelect = function onRowSelect(rows) {
	          _this2.setState.apply(_this2, _toConsumableArray(_this2.state).concat([{ selectedRows: rows }]));
	        };
	
	        var onRowsSelected = function onRowsSelected(rows) {
	          var newRows = _this2.state.rows;
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = true;
	          });
	          _this2.setState({ rows: newRows });
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          var newRows = _this2.state.rows;
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = false;
	          });
	          _this2.setState({ rows: newRows });
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this2.setState(state);
	        };
	
	        var handleFilterChange = function handleFilterChange(filter) {
	          var newFilters = Object.assign({}, _this2.state.filters);
	          if (filter.filterTerm) {
	            newFilters[filter.column.key] = filter;
	          } else {
	            delete newFilters[filter.column.key];
	          }
	          _this2.setState({ filters: newFilters });
	        };
	
	        var onRowClick = function onRowClick(rowIdx, row) {
	          _this2.props.fetchSalesOrders();
	        };
	
	        // Handle the editable function
	
	        var handleRowUpdated = function handleRowUpdated(e) {
	          var rows = [].concat(_toConsumableArray(_this2.state.rows));
	          Object.assign(rows[e.rowIdx], e.updated);
	          _this2.setState({ rows: rows });
	        };
	
	        // Column difinition
	
	        var columns = [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          sortable: true,
	          width: 70,
	          filterable: true
	        }, {
	          key: 'ProductName',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	          resizable: true,
	          sortable: true,
	          width: 160,
	          filterable: true
	        }, {
	          key: 'ProductDescription',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true,
	          width: 120,
	          filterable: true
	        }, {
	          key: 'FOBUnitPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	          resizable: true,
	          sortable: true,
	          width: 60,
	          filterable: true,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'RcvQuantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_qty' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        }, {
	          key: 'RcvTotalWeight',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_total_wt' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'RcvUnitPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_unit_dollarsign' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'RcvTotalPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_total_dollarsign' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'RtnQuantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_qty' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        }, {
	          key: 'InStock',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'in_stock' }),
	          resizable: true,
	          sortable: true,
	          width: 60,
	          filterable: true
	        }, {
	          key: 'Batch_PONum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'Remark',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'remark' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'StorageRate',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_rate' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        }, {
	          key: 'Pallet',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet' }),
	          resizable: true,
	          sortable: true,
	          width: 60,
	          filterable: true
	        }];
	
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { style: { maxWidth: '100%' }, id: 'PurchasePaymentDetail-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'BatchNum',
	                enableCellSelect: true,
	                onGridSort: handleGridSort,
	                columns: columns,
	                rowGetter: rowGetter,
	                rowHeight: 25,
	                headerRowHeight: 45,
	                rowsCount: getSize(),
	                enableRowSelect: 'single',
	                rowSelection: {
	                  showCheckbox: true,
	                  enableShiftSelect: true,
	                  onRowsSelected: onRowsSelected,
	                  onRowsDeselected: onRowsDeselected,
	                  selectBy: {
	                    isSelectedKey: 'isSelected'
	                  }
	                },
	                minHeight: 485 })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(files) {
	      if (this.checkPermission("change_purchase_payment")) {
	        alert("You have no permission!");
	        return;
	      } else {
	        this.props.attachFile(this.props.currentReceiveHistoryDetail.WarehouseReceiveNum, files);
	        this.setState({
	          files: files
	        });
	      }
	    }
	  }, {
	    key: 'onOpenClick',
	    value: function onOpenClick() {
	      this.refs.dropzone.open();
	    }
	  }, {
	    key: 'deleteFile',
	    value: function deleteFile() {
	      var WarehouseReceiveNum = this.props.currentReceiveHistoryDetail.WarehouseReceiveNum;
	      var Name = this.props.currentReceiveHistoryDetail.Attachments && this.props.currentReceiveHistoryDetail.Attachments[0];
	      this.props.deleteAttachedFile(WarehouseReceiveNum, Name);
	    }
	  }, {
	    key: 'renderPreview',
	    value: function renderPreview() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'preview' })
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement('iframe', { src: this.state.files[0].preview, thumbnail: true })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'dateStringFormat',
	    value: function dateStringFormat(date) {
	      var month = date.getMonth() + 1;
	      if (month < 10) month = "0" + month;
	      var day = date.getDate();
	      if (day < 10) day = "0" + day;
	      var year = date.getFullYear();
	      return month + '/' + day + '/' + year;
	    }
	  }, {
	    key: 'renderPOInformation',
	    value: function renderPOInformation() {
	      var PONum = null,
	          warehouseName = null,
	          purchaser = null,
	          vendorNum = null,
	          vendorName = null,
	          HandlingCost = null,
	          MiscCost = null,
	          ShippingCost = null;
	      var vendorDescription = null,
	          OrderDate = null,
	          ETADate = null,
	          CreateDate = null,
	          totalPrice = null,
	          finalPrice = 0;
	      PONum = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.PONum;
	      vendorNum = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.VendorPicklistNum;
	      vendorName = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.VendorName;
	      vendorDescription = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.VendorDescription;
	      HandlingCost = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.HandlingCost;
	      MiscCost = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.MiscCost;
	      ShippingCost = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.ShippingCost;
	      totalPrice = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.TotalPrice;
	      finalPrice = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.FinalPrice;
	
	      OrderDate = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.OrderDate;
	      OrderDate = new Date(OrderDate);
	
	      ETADate = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.ETADate;
	      ETADate = new Date(ETADate);
	
	      CreateDate = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.PostingDate;
	      CreateDate = new Date(CreateDate);
	
	      OrderDate = this.dateStringFormat(OrderDate);
	      ETADate = this.dateStringFormat(ETADate);
	      CreateDate = this.dateStringFormat(CreateDate);
	      purchaser = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.Purchaser;
	      var POPrice = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.PO_Final_Price;
	      var ReceivingPrice = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.InvoiceFinalPrice;
	      return _react2.default.createElement(
	        _reactBootstrap.Panel,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            { className: 'receive-form-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'details' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-5 marginTopStyle po-information' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receipt_no' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 7 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'WarehouseReceiveNum', component: _inputField.DisabledInputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-5 marginTopStyle po-information' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 7 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'InvoiceNum', component: _inputField.DisabledInputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-5 marginTopStyle po-information' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'packing_num' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 7 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'PackingNum', component: _inputField.DisabledInputField })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            { className: 'receive-form-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              PONum
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchaser' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              purchaser
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-6 marginTopStyle' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'Note', component: 'Textarea', className: 'form-control', style: { minHeight: '55px', maxHeight: '55px' } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            { className: 'receive-form-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_id' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              vendorNum
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              vendorName
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              vendorDescription
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            { className: 'receive-form-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dates' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_date' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              OrderDate
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'eta_date' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              ETADate
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_date' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              CreateDate
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            { className: 'receive-form-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_cost' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'handling' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'HandlingCost', component: _inputField.DisabledInputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'misc' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'MiscCost', component: _inputField.DisabledInputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'ShippingCost', component: _inputField.DisabledInputField })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            { className: 'receive-form-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receiving_details' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              (0, _numberWithCommas.numberWithCommas)(POPrice)
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receiving' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              (0, _numberWithCommas.numberWithCommas)(ReceivingPrice)
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              (0, _numberWithCommas.numberWithCommas)(totalPrice)
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dollar-sign' },
	                  '$$'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              (0, _numberWithCommas.numberWithCommas)(finalPrice)
	            )
	          ),
	          this.renderPaymentStatus()
	        )
	      );
	    }
	  }, {
	    key: 'header',
	    value: function header() {
	      return _react2.default.createElement(
	        'h2',
	        { className: 'mt0' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_record' })
	      );
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      this.setState({ dirty: false });
	      if (!this.checkPermission("change_purchase_payment")) {
	        // var WarehouseReceiveCompleted_id = this.props.currentReceiveHistoryDetail.WarehouseReceiveCompleted_id;
	        // var WarehouseReceive_id = this.props.currentReceiveHistoryDetail.WarehouseReceive_id;
	        // if(this.state.files) {
	        //   this.props.attachFile(formProps.PONum, this.state.files);
	        // }
	        var currentReceiveHistoryDetail = this.props.currentReceiveHistoryDetail;
	
	        var _ref = currentReceiveHistoryDetail || {},
	            TotalPrice = _ref.TotalPrice,
	            FinalPrice = _ref.FinalPrice;
	
	        this.props.editReceiveHistory(formProps, _reactDataGridAddons.Data.Selectors.getRows(this.state), "isPayment", TotalPrice, FinalPrice);
	      } else alert("You have no permission!");
	    }
	  }, {
	    key: 'checkPermission',
	    value: function checkPermission(permission) {
	      return false;
	    }
	  }, {
	    key: 'renderPaymentStatus',
	    value: function renderPaymentStatus() {
	      var paymentStatusOptions = [{ value: 'Not Paid', label: 'Not Paid' }, { value: 'Partially Paid', label: 'Partially Paid' }, { value: 'Paid', label: 'Paid' }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 6 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_status' }),
	            ' ',
	            _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              '*'
	            ),
	            ' '
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 6 },
	          _react2.default.createElement(_reduxForm.Field, { name: 'PaymentStatus', component: _selection.Selection, options: paymentStatusOptions })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          submitting = _props.submitting,
	          pristine = _props.pristine;
	
	      var imageURL = this.props.fetchedAttachedFiles && this.props.fetchedAttachedFiles.file;
	      imageURL = imageURL || "";
	      var tabTitle1 = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_record_details' });
	      var tabTitle2 = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'attach_file' });
	      if (this.props.detailIsLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          this.props.error.message
	        )
	      );else {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'form',
	            { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Breadcrumb.Item,
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_slashsign_ap' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Breadcrumb.Item,
	                { active: 'true' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_record_details' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { onClick: function onClick() {
	                    _this3.context.router.push("/purchasePayment");
	                  }, bsStyle: 'danger' },
	                _react2.default.createElement('em', { className: 'fa fa-close' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  className: 'btn btn-primary',
	                  style: { marginRight: "20px" },
	                  type: 'submit',
	                  disabled: !(0, _permissions2.default)('change_purchase_payment')
	                },
	                _react2.default.createElement('em', { className: 'fa fa-save', style: { marginRight: "10px" } }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Grid,
	              { fluid: 'true', id: 'purchase-payment-detail' },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                this.header(),
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.WarehouseName
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                this.renderPOInformation()
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Tabs,
	                { defaultActiveKey: 1, justified: true },
	                _react2.default.createElement(
	                  _reactBootstrap.Tab,
	                  { eventKey: 1, title: tabTitle1, className: 'table-collapse-fix' },
	                  this.renderTable()
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Tab,
	                  { eventKey: 2, title: tabTitle2, className: 'table-collapse-fix' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 3 },
	                      _react2.default.createElement(
	                        _reactDropzone2.default,
	                        { onDrop: this.onDrop.bind(this), className: 'well dropzone' },
	                        _react2.default.createElement(
	                          _reactBootstrap.Button,
	                          {
	                            bsStyle: 'primary',
	                            className: 'pull-right',
	                            onClick: this.onOpenClick,
	                            disabled: this.checkPermission("change_purchase_payment") },
	                          _react2.default.createElement('em', { className: 'fa fa-file-text' }),
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'upload' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'dz-default dz-message' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_drop_upload_files' })
	                        )
	                      ),
	                      this.state.files && this.renderPreview(),
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: 'danger',
	                          className: 'pull-right',
	                          onClick: this.deleteFile,
	                          disabled: this.checkPermission("change_purchase_payment") },
	                        _react2.default.createElement('em', { className: 'fa fa-trash-o' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 9 },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'imgDiv' },
	                        _react2.default.createElement('iframe', { src: imageURL,
	                          alt: 'Attached File' })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        );
	      }
	    }
	  }]);
	
	  return PurchasePaymentDetail;
	}(_react.Component);
	
	PurchasePaymentDetail.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = PurchasePaymentDetail;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PurchasePaymentDetail, 'PurchasePaymentDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasePaymentDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasePaymentDetail.jsx');
	}();

	;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(3);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _moment3 = __webpack_require__(41);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _datePicker = __webpack_require__(27);
	
	var _inputField = __webpack_require__(16);
	
	var _priceFormatter = __webpack_require__(56);
	
	var _priceFormatter2 = _interopRequireDefault(_priceFormatter);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _numberWithCommas = __webpack_require__(35);
	
	var _dateFormat = __webpack_require__(39);
	
	var _dateFormat2 = _interopRequireDefault(_dateFormat);
	
	var _cleanDates = __webpack_require__(22);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _moment4.default)(_moment2.default);
	
	var getBsStyle = function getBsStyle(input, value) {
	  return input === value ? 'success' : 'primary';
	};
	
	var renderRadios = function renderRadios(props) {
	  var titleClass = (0, _classnames2.default)({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'col-xs-2');
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '1') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'today-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'today-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '1', onClick: function onClick() {
	              props.fetchReceiveHistoryByDetails(1);
	            }, checked: props.input.value === '1' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'today' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '7') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'sevenDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'sevenDay-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '7', onClick: function onClick() {
	              props.fetchReceiveHistoryByDetails(7);
	            }, checked: props.input.value === '7' })),
	          '7 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '30') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'thirtyDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'thirtyDay-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '30', onClick: function onClick() {
	              props.fetchReceiveHistoryByDetails(30);
	            }, checked: props.input.value === '30' })),
	          '30 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '90') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'ninetyDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'ninetyDay-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '90', onClick: function onClick() {
	              props.fetchReceiveHistoryByDetails(90);
	            }, checked: props.input.value === '90' })),
	          '90 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '-1') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'dateRange-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'dateRange-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '-1', checked: props.input.value === '-1' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date_range' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: 'primary' },
	      _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', placeholder: 'Start', component: props.input.value === '-1' ? _datePicker.DatePicker : _datePicker.DisabledDatePicker })
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: 'primary' },
	      _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', placeholder: 'End', component: props.input.value === '-1' ? _datePicker.DatePicker : _datePicker.DisabledDatePicker })
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      {
	        bsStyle: 'primary',
	        type: 'submit',
	        onClick: function onClick() {
	          props.fetchReceiveHistoryByDetails();
	        } },
	      _react2.default.createElement('em', { className: 'fa fa-search' })
	    )
	  );
	};
	
	var PurchasePaymentList = function (_Component) {
	  _inherits(PurchasePaymentList, _Component);
	
	  function PurchasePaymentList() {
	    _classCallCheck(this, PurchasePaymentList);
	
	    var _this = _possibleConstructorReturn(this, (PurchasePaymentList.__proto__ || Object.getPrototypeOf(PurchasePaymentList)).call(this));
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.editSalesInvPage,
	
	      createOpen: false,
	
	      tableData: {
	        rows: [],
	        selectedRows: null,
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      gourpOpen: false,
	      total: 0,
	      balance: 0,
	      rowsCount: 0
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	
	    _this.openCreate = _this.openCreate.bind(_this);
	    _this.closeCreate = _this.closeCreate.bind(_this);
	    _this.receiveDetail = _this.receiveDetail.bind(_this);
	    return _this;
	  }
	
	  _createClass(PurchasePaymentList, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.setDefaultDays('purchasePaymentList');
	      this.props.fetchReceiveHistoryByDate('1900-01-01', '3000-01-01', '7', true);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      window.addEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.tableData !== this.state.tableData) {
	        this.setState({ rowsCount: _reactDataGridAddons.Data.Selectors.getRows(this.state.tableData).length });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	
	    // Once purchaseOrders is ready, reset state.
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!nextProps.Days) {
	        this.props.setDefaultDays('purchasePaymentList');
	      }
	      if (nextProps.currentReceiveHistory && nextProps.currentReceiveHistory != this.props.currentReceiveHistory) {
	        var receives = nextProps.currentReceiveHistory.Invoices;
	        var total = nextProps.currentReceiveHistory.TotalFinalPrice;
	        var balance = nextProps.currentReceiveHistory.TotalBalance;
	        // receives.map(
	        //   receive => {
	        //       receive['VendorName'] = receive.Purchase.Vendor.Name;
	        //   }
	        // )
	        var tableData = _extends({}, this.state.tableData, { rows: receives });
	        this.setState({
	          tableData: tableData,
	          total: total,
	          balance: balance
	        });
	      }
	    }
	  }, {
	    key: 'openCreate',
	    value: function openCreate() {
	      this.setState({ createOpen: true });
	    }
	  }, {
	    key: 'closeCreate',
	    value: function closeCreate() {
	      this.setState({ createOpen: false });
	    }
	  }, {
	    key: 'receiveDetail',
	    value: function receiveDetail(e) {
	      e.preventDefault();
	      var currentReceiveHistory = this.state.tableData.selectedRows[0];
	      this.props.resetCurrentReceiveHistory();
	      this.props.selectReceiveHistory(currentReceiveHistory);
	      this.context.router.push('/purchasePayment/' + currentReceiveHistory.PONum);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.editSalesInvPage });
	    }
	
	    // Set purchaseOrders being selected to be currentReceive and navigate user to the edit page
	
	  }, {
	    key: 'setCurrentReceive',
	    value: function setCurrentReceive(e) {
	      e.preventDefault();
	      var currentReceive = this.state.tableData.selectedRows[0];
	      this.props.selectReceiveHistory(currentReceive);
	    }
	  }, {
	    key: 'clickNew',
	    value: function clickNew(e) {
	      e.preventDefault();
	      // this.props.resetCurrentReceive();
	      this.context.router.push('/inventories/receive/new');
	    }
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this2 = this;
	
	      if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.error)
	        )
	      );else {
	        // Parameters of the react-data-grid
	
	        var tableHeight = window.innerHeight < 930 ? 460 : 460;
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.tableData);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the row select function
	
	        var onRowSelect = function onRowSelect(rows) {
	          var tableData = _extends({}, _this2.state.tableData, { selectedRows: rows });
	          _this2.setState({ tableData: tableData });
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var state = Object.assign({}, _this2.state.tableData, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this2.setState({ tableData: state });
	        };
	
	        var handleFilterChange = function handleFilterChange(filter) {
	          var newFilters = Object.assign({}, _this2.state.tableData.filters);
	          if (filter.filterTerm) {
	            newFilters[filter.column.key] = filter;
	          } else {
	            delete newFilters[filter.column.key];
	          }
	          var tableData = _extends({}, _this2.state.tableData, { filters: newFilters });
	          _this2.setState({ tableData: tableData });
	        };
	
	        //Custom Formatter component
	        var IsEnabledFormatter = _react2.default.createClass({
	          displayName: 'IsEnabledFormatter',
	          render: function render() {
	            if (this.props.value) return _react2.default.createElement(
	              'span',
	              { className: 'label label-success' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	            );else return _react2.default.createElement(
	              'span',
	              { className: 'label label-danger' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disable' })
	            );
	          }
	        });
	
	        var onRowClick = function onRowClick(rowIdx, row) {
	          if (rowIdx < 0) return;
	          _this2.props.resetCurrentReceiveHistory();
	          _this2.props.selectReceiveHistory(row);
	          // this.context.router.push('/inventories/receive/new')
	        };
	
	        // Column difinition
	
	        var columns = [{
	          key: 'PONum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' }),
	          resizable: true,
	          sortable: true,
	          width: 90,
	          filterable: true
	        }, {
	          key: 'WarehouseReceiveNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_num' }),
	          resizable: true,
	          sortable: true,
	          width: 105,
	          filterable: true
	        }, {
	          key: 'CreateTime',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_date' }),
	          resizable: true,
	          sortable: true,
	          width: 90,
	          filterable: true,
	          formatter: _dateFormat2.default
	        }, {
	          key: 'PostingDate',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'posting_date' }),
	          resizable: true,
	          sortable: true,
	          width: 130,
	          filterable: true,
	          formatter: _dateFormat2.default
	        }, {
	          key: 'InvoiceNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	          resizable: true,
	          sortable: true,
	          width: 110,
	          filterable: true
	        }, {
	          key: 'VendorName',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_name' }),
	          resizable: true,
	          sortable: true,
	          width: 190,
	          filterable: true
	        }, {
	          key: 'FinalPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	          resizable: true,
	          sortable: true,
	          width: 75,
	          filterable: true,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'UnpaidAmount',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' }),
	          resizable: true,
	          sortable: true,
	          width: 75,
	          filterable: true,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'Create_Username',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchaser' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'ArrivalStatus',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        }, {
	          key: 'PaymentStatus',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pmt_status' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'CheckNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check_num' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        }, {
	          key: 'Note',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	          resizable: true,
	          sortable: true,
	          width: 95,
	          filterable: true
	        }, {
	          key: 'Owner',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'owner' }),
	          resizable: true,
	          sortable: true,
	          width: 95,
	          filterable: true
	        }];
	
	        return (
	          //React Table Purchase Payment List
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  'div',
	                  { id: 'PurchasePaymentList-dataGrid1' },
	                  _react2.default.createElement(_reactDataGrid2.default, {
	                    rowKey: 'WarehouseReceive_id',
	                    onGridSort: handleGridSort,
	                    toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                    onAddFilter: handleFilterChange,
	                    columns: columns,
	                    headerRowHeight: 45,
	                    rowGetter: rowGetter,
	                    rowsCount: getSize(),
	                    rowHeight: 25,
	                    minHeight: tableHeight,
	                    enableRowSelect: 'single',
	                    onRowClick: onRowClick,
	                    onRowSelect: onRowSelect
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 3 },
	                    _react2.default.createElement(
	                      'label',
	                      { style: { 'display': 'inline-flex', 'margin-top': '15px' } },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rows' }),
	                      ':\xA0',
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'font-color-orange' },
	                        this.state.rowsCount
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 4 },
	                    _react2.default.createElement(
	                      'label',
	                      { style: { 'display': 'inline-flex', 'margin-top': '15px', 'margin-left': '10px' } },
	                      _react2.default.createElement(
	                        'span',
	                        { style: { 'margin-top': '3px' } },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_total' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'dollar-sign' },
	                          ' $$'
	                        ),
	                        ':\xA0'
	                      ),
	                      _react2.default.createElement(_reduxForm.Field, { component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.total) || 0 })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 4 },
	                    _react2.default.createElement(
	                      'label',
	                      { style: { 'display': 'inline-flex', 'margin-top': '15px', 'margin-left': '10px' } },
	                      _react2.default.createElement(
	                        'span',
	                        { style: { 'margin-top': '3px' } },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance_total' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'dollar-sign' },
	                          ' $$'
	                        ),
	                        ':\xA0'
	                      ),
	                      _react2.default.createElement(_reduxForm.Field, { component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.balance) || 0 })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderDatePickers',
	    value: function renderDatePickers() {
	      if (this.props.Days == -1) return _react2.default.createElement(
	        'div',
	        { className: 'form-group date-picker-positioner' },
	        _react2.default.createElement(
	          'label',
	          { className: 'col-xs-2 from-label col-xs-offset-5' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'from' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-2 control-date-picker' },
	          _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', component: _datePicker.DatePicker, disabled: this.props.Days !== '-1' })
	        ),
	        _react2.default.createElement(
	          'label',
	          { className: 'col-xs-1 to-label' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'to' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-2 control-date-picker' },
	          _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', component: _datePicker.DatePicker, disabled: this.props.Days !== '-1' })
	        )
	      );
	      // else return(
	      //   <Row>
	      //     <Col xs={ 10 }></Col>
	      //     <Col xs={ 2 }>
	      //       <Button
	      //         bsStyle='primary'
	      //         onClick={() =>{ this.fetchReceiveHistoryByDetails(); }}><Translate value="submit" />
	      //       </Button>
	      //     </Col>
	      //   </Row>
	      // )
	    }
	  }, {
	    key: 'fetchReceiveHistoryByDetails',
	    value: function fetchReceiveHistoryByDetails(days) {
	      var dateRange = -1;
	      var FromDate = '1900-01-01';
	      var ToDate = '3000-01-01';
	
	      if (this.props.FromDate != null) FromDate = this.formatDate(this.props.FromDate);
	
	      if (this.props.ToDate != null) ToDate = this.formatDate(this.props.ToDate);
	      // console.log(dateRange);
	      if (days != null) {
	        dateRange = days;
	      }
	      this.props.fetchReceiveHistoryByDate(FromDate, ToDate, dateRange, true);
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      var formattedDate = date.getFullYear() + '-';
	
	      formattedDate += date.getMonth() + 1 + '-';
	      if (date.getDate() < 10) {
	        formattedDate += '0' + date.getDate();
	      } else {
	        formattedDate += date.getDate();
	      }
	
	      return formattedDate;
	    }
	  }, {
	    key: 'renderPrint',
	    value: function renderPrint() {
	      var warehouseReceiveNum = this.state.tableData.selectedRows && this.state.tableData.selectedRows.length == 1 && this.state.tableData.selectedRows[0].WarehouseReceiveNum;
	      var warehouseReceiveID = this.state.tableData.selectedRows && this.state.tableData.selectedRows[0] && this.state.tableData.selectedRows[0].WarehouseReceive_id;
	      if (!warehouseReceiveNum || !warehouseReceiveID) {
	        return;
	      }
	      var url = _root_url.ROOT_URL + 'v1/warehouse/receive/print/' + warehouseReceiveNum + '?Bearer=' + localStorage.getItem('token');
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          href: url },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	      );
	    }
	  }, {
	    key: 'getDateFromFilter',
	    value: function getDateFromFilter() {
	      var _props = this.props,
	          FromDate = _props.FromDate,
	          ToDate = _props.ToDate,
	          Days = _props.Days;
	      // let fromDate = FromDate ? moment(FromDate).format('YYYY-MM-DD') : moment().subtract(7, 'days').format('YYYY-MM-DD');
	      // let toDate = ToDate ? moment(ToDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
	
	      var fromDate = void 0;
	      var toDate = void 0;
	      if (Days !== '-1') {
	        fromDate = (0, _moment2.default)().subtract(parseInt(Days, 10), 'days').format('YYYY-MM-DD');
	        toDate = (0, _moment2.default)().format('YYYY-MM-DD');
	      } else {
	        fromDate = FromDate ? (0, _moment2.default)(FromDate).format('YYYY-MM-DD') : (0, _moment2.default)().subtract(7, 'days').format('YYYY-MM-DD');
	        toDate = ToDate ? (0, _moment2.default)(ToDate).format('YYYY-MM-DD') : (0, _moment2.default)().format('YYYY-MM-DD');
	      }
	      return { fromDate: fromDate, toDate: toDate };
	    }
	  }, {
	    key: 'renderExportButton',
	    value: function renderExportButton() {
	      var _props2 = this.props,
	          FromDate = _props2.FromDate,
	          ToDate = _props2.ToDate,
	          Days = _props2.Days;
	
	      var dates = (0, _cleanDates.toFromDates)(Days, FromDate, ToDate);
	      var fromDate = 'startdate=' + dates.fromDate;
	      var toDate = 'enddate=' + dates.toDate;
	      var token = 'Bearer=' + localStorage.getItem('token');
	      var url = _root_url.ROOT_URL + 'v1/dashboard/purchasecsv/?' + fromDate + '&' + toDate + '&' + token;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          href: url
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'export' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var createDialogStyle = {
	        width: '400px',
	        marginLeft: '-10%'
	      };
	      var warehouseReceive_id = this.state.tableData.selectedRows && this.state.tableData.selectedRows[0] && this.state.tableData.selectedRows[0].WarehouseReceive_id;
	      warehouseReceive_id = warehouseReceive_id || '';
	      var url = _root_url.ROOT_URL + 'v1/warehouse/receive/print/' + warehouseReceive_id + '?Bearer=' + localStorage.getItem('token');
	      var height = (this.state.tableHeight + 70).toString();
	      var tableCollapseFix = { height: height };
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_slashsign_ap' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_report' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            null,
	            this.renderExportButton()
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'purchase-payment' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { id: 'date-range-picker', className: 'form-horizontal' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 1 },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'filter-title text-nowrap' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'posting_date' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'colon' },
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 11 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'Days', component: renderRadios, fetchReceiveHistoryByDetails: this.fetchReceiveHistoryByDetails.bind(this) })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'position-relative table-collapse-fix' },
	                  _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    { className: 'table-buttons' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'primary',
	                        disabled: !this.state.tableData.selectedRows || this.state.tableData.selectedRows.length != 1 || !warehouseReceive_id,
	                        onClick: this.receiveDetail },
	                      _react2.default.createElement('em', { className: 'fa fa-file-text' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'detail' })
	                    ),
	                    this.renderPrint()
	                  ),
	                  this.renderTable()
	                )
	              )
	            )
	          )
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return PurchasePaymentList;
	}(_react.Component);
	
	PurchasePaymentList.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = PurchasePaymentList;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getBsStyle, 'getBsStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasePaymentList.jsx');
	
	  __REACT_HOT_LOADER__.register(renderRadios, 'renderRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasePaymentList.jsx');
	
	  __REACT_HOT_LOADER__.register(PurchasePaymentList, 'PurchasePaymentList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasePaymentList.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasePaymentList.jsx');
	}();

	;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _calendar = __webpack_require__(155);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _chartModal = __webpack_require__(616);
	
	var _chartModal2 = _interopRequireDefault(_chartModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var purchasePivotChart = function (_Component) {
	  _inherits(purchasePivotChart, _Component);
	
	  function purchasePivotChart() {
	    _classCallCheck(this, purchasePivotChart);
	
	    var _this = _possibleConstructorReturn(this, (purchasePivotChart.__proto__ || Object.getPrototypeOf(purchasePivotChart)).call(this));
	
	    _this.state = {
	      purchasePivotChartOrders: null,
	      chartModalOpen: false,
	      date: null
	    };
	    _this.openChartModal = _this.openChartModal.bind(_this);
	    _this.closeChartModal = _this.closeChartModal.bind(_this);
	    _this.selectDate = _this.selectDate.bind(_this);
	    return _this;
	  }
	
	  _createClass(purchasePivotChart, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var date = new Date();
	      var month = date.getMonth() + 1;
	      if (month < 10) month = "0" + month;
	      var year = date.getFullYear();
	      month = month.toString();
	      year = year.toString();
	      this.props.fetchPurchasePivotChartOrders(month + year);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.purchasePivotChartOrders && nextProps.purchasePivotChartOrders != this.props.purchasePivotChartOrders) {
	        this.setState({ purchasePivotChartOrders: nextProps.purchasePivotChartOrders });
	      }
	    }
	  }, {
	    key: 'openChartModal',
	    value: function openChartModal() {
	      this.setState({ chartModalOpen: true });
	    }
	  }, {
	    key: 'closeChartModal',
	    value: function closeChartModal() {
	      this.setState({ chartModalOpen: false });
	    }
	  }, {
	    key: 'selectDate',
	    value: function selectDate(date) {
	      this.setState({ date: date });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var createDialogStyle = {
	        height: '600px',
	        width: '600px',
	        marginLeft: '-10%',
	        top: '40%'
	      };
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quote_reference' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                type: 'button' },
	              _react2.default.createElement('em', { className: 'fa fa-print' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'success',
	                type: 'button' },
	              _react2.default.createElement('em', { className: 'fa fa-download' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'export' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'purchase-pivot-chart' },
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { className: 'position-relative' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quote_reference_chart' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, {
	                name: 'Calendar',
	                component: _calendar2.default,
	                data: this.state.purchasePivotChartOrders,
	                openChartModal: this.openChartModal,
	                fetchInfo: this.props.fetchPurchasePivotChartOrders,
	                fetchPurchasePivotCharts: this.props.fetchPurchasePivotCharts,
	                selectDate: this.selectDate,
	                type: 'purchasePivotChart'
	              })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                title: 'view details',
	                dialogStyles: createDialogStyle,
	                isVisible: this.state.chartModalOpen,
	                onCloseClicked: function onCloseClicked() {
	                  _this2.closeChartModal();_this2.props.clearDuplicatedPurchasePivotChart();
	                }
	              },
	              _react2.default.createElement(_chartModal2.default, { date: this.state.date })
	            )
	          )
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return purchasePivotChart;
	}(_react.Component);
	
	var _default = purchasePivotChart;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(purchasePivotChart, 'purchasePivotChart', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasePivotChart.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasePivotChart.jsx');
	}();

	;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _selection = __webpack_require__(21);
	
	var _inputField = __webpack_require__(16);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _purchasePivotChartSearchProd = __webpack_require__(629);
	
	var _purchasePivotChartSearchProd2 = _interopRequireDefault(_purchasePivotChartSearchProd);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IsVariableFormatter = _react2.default.createClass({
	  displayName: 'IsVariableFormatter',
	  render: function render() {
	    var _this = this;
	
	    return _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'danger',
	          className: 'textAlignStyle',
	          style: { height: '23px', width: '39px', padding: '0px' },
	          onClick: function onClick() {
	            _this.props.deletePurchaseLine(_this.props.dependentValues.Product_id);
	          }
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'X' })
	      )
	    );
	  }
	});
	
	var EffectNowFormatter = _react2.default.createClass({
	  displayName: 'EffectNowFormatter',
	  render: function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement('input', { type: 'checkbox', value: 'true', checked: this.props.value == true || this.props.value == "true", onClick: function onClick() {
	        _this2.props.handleEffectNowClick(_this2.props);
	      } });
	  }
	});
	
	var PurchasePivotChartDetail = function (_Component) {
	  _inherits(PurchasePivotChartDetail, _Component);
	
	  function PurchasePivotChartDetail() {
	    _classCallCheck(this, PurchasePivotChartDetail);
	
	    var _this3 = _possibleConstructorReturn(this, (PurchasePivotChartDetail.__proto__ || Object.getPrototypeOf(PurchasePivotChartDetail)).call(this));
	
	    _this3.state = {
	      purchase: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null,
	        columns: [{
	          key: 'Delete',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' }),
	          formatter: _react2.default.createElement(IsVariableFormatter, { deletePurchaseLine: _this3.deletePurchaseLine.bind(_this3) }),
	          width: 50,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          sortable: true,
	          width: 90
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	          resizable: true,
	          sortable: true,
	          width: 100
	        }]
	      },
	      quote: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null,
	        columns: [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          sortable: true,
	          width: 90
	        }]
	      },
	      isToday: true,
	      vendors: [],
	      addRowsOpen: false,
	      curVendor: null
	      // this.deleteLine = this.deleteLine.bind(this);
	    };_this3.closeAddRows = _this3.closeAddRows.bind(_this3);
	    _this3.openAddRows = _this3.openAddRows.bind(_this3);
	    _this3.addCols = _this3.addCols.bind(_this3);
	    _this3.selectProduct = _this3.selectProduct.bind(_this3);
	    _this3.handleCellSelected = _this3.handleCellSelected.bind(_this3);
	    _this3.generateQuote = _this3.generateQuote.bind(_this3);
	    _this3.handleEffectNowClick = _this3.handleEffectNowClick.bind(_this3);
	    return _this3;
	  }
	
	  _createClass(PurchasePivotChartDetail, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.fetchVendors();
	      this.props.resetCurrentPurchaseQuote();
	      if (this.props.purchasePivot_id) this.props.fetchPurchasePivotChartsDetail(this.props.purchasePivot_id);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.resetPurchasePivotCharts();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this4 = this;
	
	      if (nextProps.purchasePivotChartsDetail && nextProps.purchasePivotChartsDetail != this.props.purchasePivotChartsDetail) {
	        var date = new Date(nextProps.purchasePivotChartsDetail.PostingDate);
	        var today = new Date();
	        date = this.changeDateFormat(date);
	        today = this.changeDateFormat(today);
	        var isToday = true;
	        if (date < today) {
	          isToday = false;
	        }
	
	        var columns = [].concat(_toConsumableArray(this.state.purchase.columns));
	        var vendors = nextProps.purchasePivotChartsDetail.Vendors;
	        var rows = [].concat(_toConsumableArray(nextProps.purchasePivotChartsDetail.Purchase_Pivot_Line));
	        vendors.map(function (vendor) {
	          columns = columns.concat([{
	            key: vendor + '_Quantity',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: vendor + '_qty' }),
	            resizable: true,
	            editable: true,
	            sortable: true,
	            width: 80
	          }, {
	            key: vendor + '_FOBUnitPrice',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: vendor + '_$$' }),
	            resizable: true,
	            editable: true,
	            sortable: true,
	            width: 80
	          }, {
	            key: vendor + '_IsCheck',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: vendor + '_enable' }),
	            resizable: true,
	            editable: true,
	            sortable: true,
	            width: 80,
	            formatter: _react2.default.createElement(EffectNowFormatter, { Col: vendor + '_IsCheck', handleEffectNowClick: _this4.handleEffectNowClick }),
	            getRowMetaData: function getRowMetaData(row) {
	              return row;
	            }
	          }]);
	          rows.map(function (row) {
	            var index = _lodash2.default.findIndex(row.Purchase_Pivot_Company_line, { VendorNum: vendor });
	            if (index > -1) {
	              row[vendor + '_Quantity'] = row.Purchase_Pivot_Company_line[index].Quantity;
	              row[vendor + '_FOBUnitPrice'] = row.Purchase_Pivot_Company_line[index].FOBUnitPrice;
	              row[vendor + '_IsCheck'] = row.Purchase_Pivot_Company_line[index].IsCheck;
	              row[vendor + '_OrderQuantity'] = row.Purchase_Pivot_Company_line[index].OrderQuantity;
	            }
	          });
	        });
	        var purchase = _extends({}, this.state.purchase, { rows: rows, columns: columns });
	        this.setState({ purchase: purchase, vendors: vendors, isToday: isToday });
	      }
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      this.props.createPurchasePivotChart(formProps, this.state.vendors, _reactDataGridAddons.Data.Selectors.getRows(this.state.purchase));
	    }
	  }, {
	    key: 'generateQuote',
	    value: function generateQuote() {
	      this.props.createPurchaseQuote({ VendorNum: this.state.curVendor }, this.state.quote.rows);
	    }
	  }, {
	    key: 'closeAddRows',
	    value: function closeAddRows() {
	      this.setState({ addRowsOpen: false });
	    }
	  }, {
	    key: 'openAddRows',
	    value: function openAddRows() {
	      this.setState({ addRowsOpen: true });
	    }
	  }, {
	    key: 'addCols',
	    value: function addCols(vendor) {
	      var vendors = [].concat(_toConsumableArray(this.state.vendors));
	      if (vendors.indexOf(vendor) > -1) {
	        return;
	      }
	      vendors.push(vendor);
	      var columns = [].concat(_toConsumableArray(this.state.purchase.columns));
	      columns = columns.concat([{
	        key: vendor + '_Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: vendor + '_qty' }),
	        resizable: true,
	        editable: true,
	        sortable: true,
	        width: 80
	      }, {
	        key: vendor + '_FOBUnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: vendor + '_$$' }),
	        resizable: true,
	        editable: true,
	        sortable: true,
	        width: 80
	      }, {
	        key: vendor + '_IsCheck',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: vendor + '_enable' }),
	        resizable: true,
	        editable: true,
	        sortable: true,
	        width: 80,
	        formatter: _react2.default.createElement(EffectNowFormatter, { Col: vendor + '_IsCheck', handleEffectNowClick: this.handleEffectNowClick }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }]);
	      var purchase = _extends({}, this.state.purchase, { columns: columns });
	      this.setState({ purchase: purchase, vendors: vendors });
	    }
	  }, {
	    key: 'addRows',
	    value: function addRows() {
	      var purchase = _extends({}, this.state.purchase);
	      this.setState({ purchase: purchase });
	    }
	
	    // deleteLine(WarehouseReceiveLine_id) {
	    //   let quote = {...this.state.quote};
	    //   quote.rows.map(r => {
	    //     if(r.WarehouseReceiveLine_id == WarehouseReceiveLine_id) {
	    //       r.show = false;
	    //     }
	    //   })
	    //   this.setState({quote});
	    // }
	
	  }, {
	    key: 'deletePurchaseLine',
	    value: function deletePurchaseLine(Product_id) {
	      var purchase = _extends({}, this.state.purchase);
	      purchase.rows = purchase.rows.filter(function (r) {
	        return r.Product_id != Product_id;
	      });
	      this.setState({ purchase: purchase });
	    }
	  }, {
	    key: 'handleEffectNowClick',
	    value: function handleEffectNowClick(isCheck) {
	      var purchase = _extends({}, this.state.purchase);
	      var col = isCheck.Col;
	      purchase.rows[isCheck.dependentValues.Idx][col] = !purchase.rows[isCheck.dependentValues.Idx][col];
	      this.setState({ purchase: purchase });
	    }
	  }, {
	    key: 'getVendorNumOptions',
	    value: function getVendorNumOptions() {
	      var vendorNumOptions = [];
	      this.props.vendors.map(function (vendor) {
	        vendorNumOptions.push({ value: vendor.VendorNum, label: vendor.VendorNum });
	      });
	      return vendorNumOptions;
	    }
	  }, {
	    key: 'changeDateFormat',
	    value: function changeDateFormat(day) {
	      var y = day.getFullYear().toString();
	      var m = day.getMonth() + 1;
	      if (m < 10) {
	        m = '0' + m;
	      } else {
	        m = m.toString();
	      }
	      var d = day.getDate();
	      if (d < 10) {
	        d = '0' + d;
	      } else {
	        d = d.toString();
	      }
	      d = y + m + d;
	      return d;
	    }
	  }, {
	    key: 'selectProduct',
	    value: function selectProduct(prod) {
	      var purchase = _extends({}, this.state.purchase);
	      var index = _lodash2.default.findIndex(purchase.rows, { ProductNum: prod.ProductNum });
	      if (index == -1) {
	        purchase.rows.push(prod);
	        this.setState({ purchase: purchase });
	      }
	    }
	  }, {
	    key: 'handleCellSelected',
	    value: function handleCellSelected(coordinates) {
	      var idx = parseInt(coordinates.idx / 3);
	      if (idx) {
	        idx = idx * 3 + 2;
	      }
	      var cols = [].concat(_toConsumableArray(this.state.purchase.columns));
	      var key = cols[idx].key;
	      var rows = [].concat(_toConsumableArray(this.state.purchase.rows));
	      var quoteRows = [];
	      rows.map(function (row) {
	        if (row[key] === "true" || row[key] === true) {
	          quoteRows.push(row);
	        }
	      });
	      var l = key.length - 8;
	      var vendor = key.slice(0, key.length - 8);
	      var columns = [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: vendor + '_FOBUnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price' }),
	        width: 50
	      }, {
	        key: vendor + '_OrderQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	        resizable: true,
	        editable: true,
	        sortable: true,
	        width: 50
	      }, {
	        key: vendor + '_IsCheck',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '' + vendor }),
	        resizable: true,
	        editable: true,
	        sortable: true,
	        width: 100,
	        formatter: _react2.default.createElement(EffectNowFormatter, { Col: vendor + '_IsCheck', handleEffectNowClick: this.handleEffectNowClick }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }];
	      var quote = _extends({}, this.state.quote, { rows: quoteRows, columns: columns });
	      this.setState({ quote: quote, curVendor: vendor });
	    }
	  }, {
	    key: 'renderPurchaseTable',
	    value: function renderPurchaseTable() {
	      var _this5 = this;
	
	      if (this.props.purchasingPerformanceIsLoading && !this.props.purchasingPerformanceError) return _react2.default.createElement(
	        'div',
	        { id: 'spinner' },
	        _react2.default.createElement(Spinner, null)
	      );else if (this.props.purchasingPerformanceError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.purchasingPerformanceError)
	        )
	      );else {
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this5.state.purchase);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return Object.assign({ Idx: rowIdx }, rows[rowIdx]);
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var purchase = Object.assign({}, _this5.state.purchase, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this5.setState({ purchase: purchase });
	        };
	
	        var handleRowUpdated = function handleRowUpdated(e) {
	          var rows = getRows();
	          Object.assign(rows[e.rowIdx], e.updated);
	        };
	
	        //React Table Purchase Order Full Table
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { style: { maxWidth: '100%' }, id: 'PurchasePivotChartDetail-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                enableCellSelect: true,
	                onCellSelected: this.handleCellSelected,
	                onGridSort: handleGridSort,
	                columns: this.state.purchase.columns,
	                rowHeight: 25,
	                minHeight: 630,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                onRowUpdated: handleRowUpdated
	              })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderPrintTable',
	    value: function renderPrintTable() {
	      var _this6 = this;
	
	      // const deleteLine = this.deleteLine;
	      // if (this.props.purchasingPerformanceIsLoading && !this.props.purchasingPerformanceError) return (
	      //   <div id="spinner">
	      //     <Spinner/>
	      //   </div>
	      // )
	      // else if (this.props.purchasingPerformanceError) return (
	      //  <ContentWrapper>
	      //    <div className="alert alert-danger">{JSON.stringify(this.props.purchasingPerformanceError)}</div>
	      //  </ContentWrapper>
	      // )
	      // else {
	      // Parameters of the react-data-grid
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this6.state.quote);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var quote = Object.assign({}, _this6.state.quote, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this6.setState({ quote: quote });
	      };
	
	      //Custom Formatter component
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	            var date = new Date(this.props.value);
	            var index = dateMap.indexOf(date.toString().slice(4, 3));
	            var localDate = index + date.toString().slice(8, 6);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );;
	          } else return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        var rows = getRows();
	        Object.assign(rows[e.rowIdx], e.updated);
	      };
	
	      // Column difinition
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { className: 'react-table-price-adjustment-print', id: 'PurchasePivotChartDetail-dataGrid2' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              enableCellSelect: true,
	              onRowUpdated: handleRowUpdated,
	              onGridSort: handleGridSort,
	              columns: this.state.quote.columns,
	              rowHeight: 25,
	              minHeight: 630,
	              rowGetter: rowGetter,
	              rowsCount: getSize()
	            })
	          )
	        )
	      );
	      // }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var handleSubmit = this.props.handleSubmit;
	
	      var print_url = null;
	      var excel_url = null;
	      if (this.props.purchasePivotChartsDetail) {
	        print_url = _root_url.ROOT_URL + 'v1/purchase/pivotexport/print/' + this.props.purchasePivotChartsDetail.PurchasePivot_id + "?Bearer=" + localStorage.getItem('token');
	        excel_url = _root_url.ROOT_URL + 'v1/purchase/pivotexport/excel/' + this.props.purchasePivotChartsDetail.PurchasePivot_id + "?Bearer=" + localStorage.getItem('token');
	      }
	      var vendorNumOptions = this.getVendorNumOptions();
	      var date = this.props.purchasePivotChartsDetail && this.props.purchasePivotChartsDetail.PostingDate;
	      if (date) date = new Date(date);else date = new Date();
	      date = this.changeDateFormat(date);
	      date = date && date.slice(4, 6) + ' / ' + date.slice(6) + ' / ' + date.slice(0, 4);
	      var createDialogStyle = {
	        height: '600px',
	        width: '600px',
	        marginLeft: '-10%'
	      };
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { fluid: 'true', id: 'purchase-pivot-chart-detail' },
	          _react2.default.createElement(
	            'form',
	            { autoComplete: 'off', method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	            _react2.default.createElement(
	              'h1',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quote_reference_chart_detail' }),
	              ' ',
	              date
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'danger', onClick: function onClick() {
	                    _this7.context.router.push('/purchasePivotChart');
	                  } },
	                _react2.default.createElement('em', { className: 'fa fa-close' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'primary', href: print_url },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'primary', href: excel_url },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'success', type: 'submit', disabled: !this.state.isToday },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	              ),
	              this.props.purchaseQuoteCreated && _react2.default.createElement(
	                'div',
	                { className: 'generate-quote alert alert-success' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_purchase_quote_generated' })
	                )
	              ),
	              this.props.purchaseQuoteIsCreating && _react2.default.createElement(
	                'div',
	                { className: 'generate-quote' },
	                _react2.default.createElement(Spinner, null)
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { md: 9 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'purchase-panel' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-12 vendor' },
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { md: 12 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { md: 7 },
	                            _react2.default.createElement(
	                              'label',
	                              { className: 'col-md-2' },
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'asteriksReq' },
	                                '*'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { md: 3 },
	                              _react2.default.createElement(_reduxForm.Field, { name: 'Name', component: _inputField.InputField })
	                            ),
	                            _react2.default.createElement(
	                              'label',
	                              { className: 'col-md-offset-1 col-md-2' },
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { md: 3 },
	                              _react2.default.createElement(_reduxForm.Field, { name: 'Description', component: _inputField.InputField })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { md: 5 },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-md-8' },
	                              _react2.default.createElement(_reduxForm.Field, { name: 'Vendor', component: _selection.Selection, options: vendorNumOptions })
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Button,
	                              { className: 'pull-right', bsStyle: 'primary', onClick: function onClick() {
	                                  _this7.addCols(_this7.props.vendor.value);
	                                } },
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_vendor' })
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 12 },
	                      this.renderPurchaseTable()
	                    )
	                  ),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 12 },
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { onClick: this.openAddRows },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_product' })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { md: 3 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'quote-panel' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'vendor' },
	                    this.state.curVendor && _react2.default.createElement(
	                      'span',
	                      { className: 'alert alert-warning', id: 'vendor-span' },
	                      this.state.curVendor
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      { className: 'pull-right', bsStyle: 'primary', onClick: function onClick() {
	                          _this7.generateQuote();
	                        } },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'generate_quote' })
	                    )
	                  ),
	                  this.renderPrintTable()
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: createDialogStyle, isVisible: this.state.addRowsOpen, onCloseClicked: function onCloseClicked() {
	                  _this7.closeAddRows();
	                }, title: 'Choose Product' },
	              _react2.default.createElement(_purchasePivotChartSearchProd2.default, { selectProduct: this.selectProduct })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PurchasePivotChartDetail;
	}(_react.Component);
	
	PurchasePivotChartDetail.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = PurchasePivotChartDetail;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(IsVariableFormatter, 'IsVariableFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasePivotChartDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(EffectNowFormatter, 'EffectNowFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasePivotChartDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(PurchasePivotChartDetail, 'PurchasePivotChartDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasePivotChartDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasePivotChartDetail.jsx');
	}();

	;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _inputField = __webpack_require__(16);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _filterByStart = __webpack_require__(68);
	
	var _filterByStart2 = _interopRequireDefault(_filterByStart);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RowRenderer = function (_Component) {
	  _inherits(RowRenderer, _Component);
	
	  function RowRenderer() {
	    _classCallCheck(this, RowRenderer);
	
	    return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(RowRenderer, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { onDoubleClick: function onDoubleClick() {
	            _this2.props.onDoubleClick(_this2.props.row);
	          } },
	        _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	      );
	    }
	  }]);
	
	  return RowRenderer;
	}(_react.Component);
	
	var renderTypeRadios = function renderTypeRadios(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group', id: 'search-product-by' },
	    _react2.default.createElement(
	      'label',
	      { className: 'col-sm-3 search-by-max-width' },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'search_by' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-sm-2' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'ProductNum',
	        checked: props.input.value === "ProductNum" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-sm-2 pl' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'RefNum',
	        checked: props.input.value === "RefNum" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-sm-2' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'Name',
	        checked: props.input.value === "Name" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-sm-3' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'Description',
	        checked: props.input.value === "Description" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	    )
	  );
	};
	
	var PurchasePivotChartSearchProd = function (_Component2) {
	  _inherits(PurchasePivotChartSearchProd, _Component2);
	
	  function PurchasePivotChartSearchProd() {
	    _classCallCheck(this, PurchasePivotChartSearchProd);
	
	    var _this3 = _possibleConstructorReturn(this, (PurchasePivotChartSearchProd.__proto__ || Object.getPrototypeOf(PurchasePivotChartSearchProd)).call(this));
	
	    _this3.state = {
	      products: {
	        rows: [],
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null
	      }
	    };
	    _this3.showProducts = _this3.showProducts.bind(_this3);
	    return _this3;
	  }
	
	  _createClass(PurchasePivotChartSearchProd, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.setDefaultOfForm("SearchType", "RefNum", "purchasePivotChartSearchProd");
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.simplifiedProducts && nextProps.simplifiedProducts != this.props.simplifiedProducts) {
	        var products = _extends({}, this.state.products, { rows: nextProps.simplifiedProducts });
	        this.setState({ products: products });
	      }
	    }
	  }, {
	    key: 'showProducts',
	    value: function showProducts(event) {
	      if (!this.props.searchType || !this.props.searchValue || this.props.searchValue == "") return;
	      switch (event.charCode) {
	        case 13:
	          // ENTER
	          event.preventDefault();
	          this.props.fetchSimplifiedProducts(this.props.searchType, this.props.searchValue);
	          break;
	      }
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this4 = this;
	
	      if (this.props.simplifiedProductsIsLoading && !this.props.simplifiedProductsError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.simplifiedProductsError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.simplifiedProductsError)
	        )
	      );else {
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.products);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var products = Object.assign({}, _this4.state.products, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this4.setState({ products: products });
	        };
	
	        // Column difinition
	
	        var columns = [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterRenderer: _filterByStart2.default
	        }, {
	          key: 'RefNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	          resizable: true,
	          sortable: true,
	          width: 70,
	          filterRenderer: _filterByStart2.default
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	          resizable: true,
	          sortable: true,
	          width: 200
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true
	        }];
	
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { style: { maxWidth: '100%' }, id: 'PurchasePivotChartSearchProd-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: this.props.selectProduct }),
	                rowKey: 'Product_id',
	                rowHeight: 25,
	                minHeight: 400,
	                onGridSort: handleGridSort,
	                columns: columns,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                enableCellSelect: true
	              })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(_reduxForm.Field, { name: 'SearchType', component: renderTypeRadios })
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { md: 4 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'SearchValue', component: _inputField.InputField, onKeyPress: function onKeyPress(event) {
	                _this5.showProducts(event);
	              }, onFocus: this.handleOnFocus, placeholder: 'search' })
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          this.renderTable()
	        )
	      );
	    }
	  }]);
	
	  return PurchasePivotChartSearchProd;
	}(_react.Component);
	
	var _default = PurchasePivotChartSearchProd;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasePivotChartSearchProd.jsx');
	
	  __REACT_HOT_LOADER__.register(renderTypeRadios, 'renderTypeRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasePivotChartSearchProd.jsx');
	
	  __REACT_HOT_LOADER__.register(PurchasePivotChartSearchProd, 'PurchasePivotChartSearchProd', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasePivotChartSearchProd.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasePivotChartSearchProd.jsx');
	}();

	;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDropzone = __webpack_require__(45);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _moment3 = __webpack_require__(41);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	__webpack_require__(69);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _constants = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _selection = __webpack_require__(21);
	
	var _detailedSelection = __webpack_require__(82);
	
	var _inputField = __webpack_require__(16);
	
	var _datePicker = __webpack_require__(27);
	
	var _convertItemPrice = __webpack_require__(116);
	
	var _convertItemPrice2 = _interopRequireDefault(_convertItemPrice);
	
	var _hiddenInputField = __webpack_require__(117);
	
	var _hiddenInputField2 = _interopRequireDefault(_hiddenInputField);
	
	var _priceField = __webpack_require__(119);
	
	var _priceField2 = _interopRequireDefault(_priceField);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _productArray = __webpack_require__(429);
	
	var _productArray2 = _interopRequireDefault(_productArray);
	
	var _vendorForm = __webpack_require__(99);
	
	var _vendorForm2 = _interopRequireDefault(_vendorForm);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _moment4.default)(_moment2.default);
	
	var renderInvoice = function renderInvoice(_ref) {
	    var fields = _ref.fields;
	    return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { type: 'button', className: 'btn btn-green btn-green-default', onClick: function onClick() {
	                                fields.push({}); // pushes empty child field onto the end of the array
	                            } },
	                        _react2.default.createElement('i', null),
	                        ' ',
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_invoice' })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    !fields.length && _react2.default.createElement(
	                        'div',
	                        { className: 'marginTopStyle' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no_invoice' })
	                    ),
	                    fields.map(function (Invoice, index) {
	                        return _react2.default.createElement(
	                            'div',
	                            { key: index },
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: 'marginTopStyle marginBottomStyle' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	                                    index + 1
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    { className: 'col-sm-3 btn btn-warning', type: 'button', onClick: function onClick() {
	                                            fields.remove(index); // remove from index
	                                        } },
	                                    _react2.default.createElement('i', null),
	                                    ' ',
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'remove' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: 'marginBottomStyle' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-3 marginTopStyle' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_invoice_no' }),
	                                    ': '
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 8 },
	                                    _react2.default.createElement(_reduxForm.Field, { name: Invoice + '.VendorInvoiceNum', component: _inputField.InputField })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: 'marginBottomStyle' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-3 marginTopStyle' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_total' }),
	                                    ': '
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 8 },
	                                    _react2.default.createElement(_reduxForm.Field, { name: Invoice + '.InvoiceTotal', component: _priceField2.default })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: 'marginBottomStyle' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-3 marginTopStyle' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_date' }),
	                                    ': '
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 8 },
	                                    _react2.default.createElement(_reduxForm.Field, { name: Invoice + '.InvoiceDate', component: _datePicker.DatePicker })
	                                )
	                            )
	                        );
	                    })
	                )
	            )
	        )
	    );
	};
	
	var PurchaseQuoteForm = function (_Component) {
	    _inherits(PurchaseQuoteForm, _Component);
	
	    function PurchaseQuoteForm() {
	        _classCallCheck(this, PurchaseQuoteForm);
	
	        var _this = _possibleConstructorReturn(this, (PurchaseQuoteForm.__proto__ || Object.getPrototypeOf(PurchaseQuoteForm)).call(this));
	
	        _this.state = {
	            files: null,
	
	            leftBarHeight: window.innerHeight - _constants.UI_HEIGHT.leftBar,
	            rightBarHeight: window.innerHeight - _constants.UI_HEIGHT.rightBar,
	
	            productInfo: null,
	            totalNetWeight: 0,
	            totalShippingWeight: 0,
	            totalPrice: 0,
	
	            taxValue: 0,
	            discountValue: 0,
	
	            defaultRefPrice: 0,
	            refPrice: 0,
	            defaultLowestSalePrice: 0,
	            lowestSalePrice: 0,
	            quantity: 0,
	
	            firstRender: false,
	
	            priceType: 'FOB',
	            finalPrice: 0,
	            miscCostValue: 0,
	            handlingCostValue: 0,
	            shippingCostValue: 0,
	
	            calculatedProducts: [],
	
	            vendorInformationOpen: true,
	            oneTimeScheduleOpen: true,
	            purchaseInformationOpen: true,
	            orderHistoryOpen: true,
	            inventoryOpen: true,
	
	            dirty: false,
	
	            rows: [],
	            selectedRows: [],
	            filters: {},
	            sortColumn: null,
	            sortDirection: null
	        };
	        _this.placeNewOrder = _this.placeNewOrder.bind(_this);
	        _this.handleResize = _this.handleResize.bind(_this);
	        _this.handleMiscCostChange = _this.handleMiscCostChange.bind(_this);
	        _this.handleShippingCostChange = _this.handleShippingCostChange.bind(_this);
	        _this.handleHandlingCostChange = _this.handleHandlingCostChange.bind(_this);
	        _this.handleDiscountChange = _this.handleDiscountChange.bind(_this);
	        _this.handleTaxChange = _this.handleTaxChange.bind(_this);
	        _this.handleUnitPriceChange = _this.handleUnitPriceChange.bind(_this);
	        _this.handleLowestSalePriceChange = _this.handleLowestSalePriceChange.bind(_this);
	        _this.handleQuantityChange = _this.handleQuantityChange.bind(_this);
	        return _this;
	    }
	
	    _createClass(PurchaseQuoteForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.fetchSimplifiedProducts();
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var _props = this.props,
	                currentPurchaseQuote = _props.currentPurchaseQuote,
	                currentPurchaseQuoteDetail = _props.currentPurchaseQuoteDetail,
	                currentPurchaseTemplate = _props.currentPurchaseTemplate,
	                currentPurchaseTemplateDetail = _props.currentPurchaseTemplateDetail;
	
	            // If user is editing Purchase Quote, load the detail information of
	            // selected purchase quote.
	
	            if (currentPurchaseQuote) {
	                this.props.fetchPurchaseQuoteDetail(currentPurchaseQuote.PurchaseOrder_id).then(function () {
	                    _this2.props.fetchVendors();
	                    _this2.props.fetchPaymentTerms();
	                    _this2.props.fetchWarehouses();
	                });
	            } else if (currentPurchaseTemplate) {
	                this.props.convertTemplateToQuote(currentPurchaseTemplate.PurchaseTemplate_id).then(function () {
	                    _this2.props.fetchVendors();
	                    _this2.props.fetchPaymentTerms();
	                    _this2.props.fetchWarehouses();
	                });
	            } else {
	                this.props.fetchVendors();
	                this.props.fetchPaymentTerms();
	                this.props.fetchWarehouses();
	            }
	
	            window.addEventListener('resize', this.handleResize);
	            // making a leaving hook to confirm leaving
	            this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.productInformation && nextProps.productInformation != this.props.productInformation) {
	                var products = this.props.products;
	                var productInformation = nextProps.productInformation;
	                var index = _lodash2.default.findIndex(products, { 'Product_id': productInformation.value || productInformation });
	                if (products[index]) this.props.fetchProductInfo(products[index].Product_id);
	            }
	            if (nextProps.productInfo && nextProps.productInfo != this.props.productInfo) {
	                this.setState({ productInfo: nextProps.productInfo });
	            }
	            if (nextProps.miscCostValue && nextProps.miscCostValue != this.props.miscCostValue) {
	                this.setState({ miscCostValue: nextProps.miscCostValue });
	            }
	            if (nextProps.handlingCostValue && nextProps.handlingCostValue != this.props.handlingCostValue) {
	                this.setState({ handlingCostValue: nextProps.handlingCostValue });
	            }
	            if (nextProps.shippingCostValue && nextProps.shippingCostValue != this.props.shippingCostValue) {
	                this.setState({ shippingCostValue: nextProps.shippingCostValue });
	            }
	            if (nextProps.dirty != this.props.dirty) {
	                this.setState({
	                    dirty: nextProps.dirty
	                });
	            }
	
	            // Once user select a vendor, load its address and contacts.
	            if (nextProps.vendorsValue != this.props.vendorsValue) {
	                // When first render the page, vendorsValue doesn't exist.
	                if (this.refs.Products && this.props.vendorsValue && !this.state.firstRender) {
	                    this.refs.Products.getRenderedComponent().props.fields.removeAll();
	                }
	                if (nextProps.vendorsValue != null) {
	                    this.props.fetchVendorDetail(nextProps.vendorsValue.value || nextProps.vendorsValue);
	                    this.props.fetchProductsByVendor(nextProps.vendorsValue.value || nextProps.vendorsValue);
	                }
	                if (this.state.firstRender) this.state.firstRender = false;
	            }
	
	            // Also, if vendor has been chosen in the quote or template user'll work on, load related products.
	            if (nextProps.currentPurchaseQuoteDetail != this.props.currentPurchaseQuoteDetail && nextProps.currentPurchaseQuoteDetail) {
	                var currentPurchaseQuoteDetail = nextProps.currentPurchaseQuoteDetail;
	                if (currentPurchaseQuoteDetail.Purchase_Order_Line != null) {
	                    var newRows = [];
	                    currentPurchaseQuoteDetail.Purchase_Order_Line.map(function (line) {
	                        var newProduct = {};
	                        newProduct["Product_id"] = line.Product_id.Product_id;
	                        newProduct["Name"] = line.Product_id.Name;
	                        newProduct["EstSalePrice"] = line.EstSalePrice; //products[index].LowestSalePrice;
	                        newProduct["Quantity"] = line.Quantity;
	                        newProduct["EstSaleTotal"] = line.EstSaleTotal;
	
	                        newProduct["ProductNum"] = line.Product_id.ProductNum;
	                        newProduct["Description"] = line.Product_id.Description;
	                        newProduct["MeasureUnit"] = line.Product_id.MeasureUnit;
	                        newProduct["FOBUnitPrice"] = line.FOBUnitPrice; //products[index].RefPrice;
	                        newProduct["ShippingWeight"] = line.Product_id.ShippingWeight;
	                        newProduct["NetWeight"] = line.Product_id.NetWeight;
	                        newProduct["TotalNetWeight"] = line.Product_id.NetWeight * line.Quantity;
	                        newProduct["TotalShippingWeight"] = line.Product_id.ShippingWeight * line.Quantity;
	                        newProduct["RefNum"] = line.Product_id.RefNum;
	                        newProduct["TotalPrice"] = line.TotalPrice;
	
	                        newRows = [].concat(_toConsumableArray(newRows), [newProduct]);
	                    });
	                    var newTotalShippingWeight = currentPurchaseQuoteDetail.FinalShippingWeight;
	                    var newTotalNetWeight = currentPurchaseQuoteDetail.FinalNetWeight;
	                    var newTotalPrice = currentPurchaseQuoteDetail.TotalPrice;
	                    var finalPrice = currentPurchaseQuoteDetail.FinalPrice;
	                    var taxValue = currentPurchaseQuoteDetail.TaxRate;
	                    var discountValue = currentPurchaseQuoteDetail.Discount;
	
	                    this.setState({ rows: newRows,
	                        totalShippingWeight: newTotalShippingWeight,
	                        totalNetWeight: newTotalNetWeight,
	                        totalPrice: newTotalPrice,
	                        finalPrice: finalPrice,
	                        taxValue: taxValue,
	                        discountValue: discountValue
	                    });
	                }
	                this.setState({ firstRender: true });
	            }
	
	            if (!nextProps.vendorsValue) {
	                this.props.resetCurrentVendor();
	            }
	
	            if (nextProps.priceTypeValue != this.props.priceTypeValue) {
	                this.setState({ priceType: nextProps.priceTypeValue });
	            }
	
	            // Calculate the sum of the price and weight for products.
	
	            if (nextProps.products[0] && nextProps.productsValue) {
	                var round = function round(value, decimals) {
	                    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
	                };
	
	                // calculatedProducts.map(
	                //     product => {
	                //         if (product.Product_id) {
	                //             const index = _.findIndex(products, { 'Product_id': product.Product_id.value || product.Product_id });
	                //             if (index > -1) {
	                //                 product['Title'] = products[index].Name + ' No. ' + products[index].ProductNum;
	                //                 product['TotalNetWeight'] = ((parseFloat(products[index].NetWeight) || 0) * (parseFloat(product.Quantity) || 0)).toFixed(2);
	                //                 product['TotalShippingWeight'] = ((parseFloat(products[index].ShippingWeight) || 0) * (parseFloat(product.Quantity) || 0)).toFixed(2);
	                //                 product['TotalPrice'] = ((parseFloat(product.FOBUnitPrice) || 0) * (parseFloat(product.Quantity) || 0)).toFixed(2);
	                //                 product['EstSaleTotal'] = ((parseFloat(product.EstSalePrice) || 0) * (parseFloat(product.Quantity) || 0)).toFixed(2);
	                //                 // Generate the unit of measure field
	                //                 product['UnitOfMeasure'] = products[index].PackageSize + '/' + products[index].PackageType;
	                //             }
	                //         } else {
	                //             product['Title'] = "Please Choose a Product";
	                //             product['TotalNetWeight'] = 0;
	                //             product['TotalShippingWeight'] = 0;
	                //             product['TotalPrice'] = 0;
	                //             product['EstSaleTotal'] = 0;
	                //         }
	                //         createPurchaseQuote = (parseFloat(totalPrice) + (parseFloat(product.TotalPrice) || 0)).toFixed(2);
	                //         totalShippingWeight = (parseFloat(totalShippingWeight || 0) + parseFloat(product.TotalShippingWeight || 0)).toFixed(2);
	                //         totalNetWeight = (parseFloat(totalNetWeight || 0) + parseFloat(product.TotalNetWeight || 0)).toFixed(2);
	                //         // Calculating the Final Price
	                //         finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
	                //     }
	                // )
	
	                var _products = nextProps.products,
	                    _productInformation = nextProps.productInformation,
	                    quantity = nextProps.quantity,
	                    shippingCostValue = nextProps.shippingCostValue,
	                    handlingCostValue = nextProps.handlingCostValue,
	                    miscCostValue = nextProps.miscCostValue,
	                    _discountValue = nextProps.discountValue,
	                    _taxValue = nextProps.taxValue;
	
	
	                var createPurchaseQuote = 0;
	                var totalShippingWeight = 0;
	
	                var calculatedProducts = nextProps.productsValue;
	
	                this.setState({
	                    calculatedProducts: calculatedProducts
	                    // totalPrice: totalPrice,
	                    // totalShippingWeight: totalShippingWeight,
	                    // totalNetWeight: totalNetWeight
	                });
	            }
	
	            if (nextProps.allProducts && nextProps.allProducts != this.props.allProducts) {
	                console.log("next product", nextProps.allProducts);
	                var _index = _lodash2.default.findIndex(this.props.simplifiedProducts, { 'Product_id': nextProps.allProducts.value });
	                console.log(_index);
	                if (_index > -1) {
	                    this.props.setPriceValues(this.props.simplifiedProducts[_index].ProductCost, this.props.simplifiedProducts[_index].LowestSalePrice, 'purchaseQuoteForm');
	                }
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({
	                leftBarHeight: window.innerHeight - _constants.UI_HEIGHT.leftBar,
	                rightBarHeight: window.innerHeight - _constants.UI_HEIGHT.rightBar
	            });
	        }
	
	        // If the form is dirty, ask for confirmation.
	
	    }, {
	        key: 'routerWillLeave',
	        value: function routerWillLeave(nextLocation) {
	            if (this.state.dirty) return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'work_not_saved_warning' });
	        }
	    }, {
	        key: 'title',
	        value: function title() {
	            if (!this.props.params.id) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'content-heading' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_a_new_purchase_quote' })
	                );
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: 'content-heading' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_purchase_quote' }),
	                ' ',
	                this.props.currentPurchaseQuote.PONum
	            );
	        }
	    }, {
	        key: 'placeButtons',
	        value: function placeButtons() {
	            var _this3 = this;
	
	            var _props2 = this.props,
	                submitting = _props2.submitting,
	                pristine = _props2.pristine,
	                isCreating = _props2.isCreating,
	                isEditing = _props2.isEditing;
	
	            if (!this.props.params.id) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { className: 'btn btn-primary pull-right', disabled: isCreating || isEditing || pristine, type: 'submit' },
	                    _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                );
	            }
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { className: 'btn btn-primary pull-right', disabled: isCreating || isEditing || pristine, type: 'submit' },
	                    _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { className: 'btn btn-primary pull-right', disabled: isCreating || isEditing, onClick: function onClick(e) {
	                            return _this3.placeNewOrder(e);
	                        } },
	                    _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'place_new_order' })
	                )
	            );
	        }
	        // Render Select options dynamically with the information on the server.
	
	    }, {
	        key: 'renderVendors',
	        value: function renderVendors() {
	            if (this.props.vendorIsLoading) return _react2.default.createElement(_spinner2.default, null); // If vendor is loading, show a spinner.
	            else {
	                    var vendorNameOptions = this.getVendorNameOptions(); // Return a JSON in the format of React-Select's options
	                    var vendorNumOptions = this.getVendorNumOptions();
	                    return _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'marginBottomStyle' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 9 },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_no' })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 8 },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Vendor_id', component: _selection.Selection, options: vendorNumOptions })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement('br', null)
	                    );
	                }
	        }
	    }, {
	        key: 'renderVendorsDetail',
	        value: function renderVendorsDetail() {
	            if (this.props.vendorIsLoading && !this.props.vendorError) return _react2.default.createElement(_spinner2.default, null); // If vendor is loading, show a spinner.
	            else if (this.props.vendorError) return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'error' })
	                ); // If vendor is loading, show a spinner.
	                else {
	                        var vendorNameOptions = this.getVendorNameOptions(); // Return a JSON in the format of React-Select's options
	                        var vendorNumOptions = this.getVendorNumOptions();
	                        return _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: 'marginBottomStyle' },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 6 },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-6 inlineLabel' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_name' }),
	                                        ' ',
	                                        _react2.default.createElement(
	                                            'span',
	                                            { style: { color: 'red' } },
	                                            '*'
	                                        ),
	                                        ' '
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _react2.default.createElement(_reduxForm.Field, { name: 'Vendor_id', component: _selection.Selection, options: vendorNameOptions })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 6 },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-6 inlineLabel' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_no' }),
	                                        ' ',
	                                        _react2.default.createElement(
	                                            'span',
	                                            { style: { color: 'red' } },
	                                            '*'
	                                        ),
	                                        ' '
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _react2.default.createElement(_reduxForm.Field, { name: 'Vendor_id', component: _selection.Selection, options: vendorNumOptions })
	                                    )
	                                ),
	                                _react2.default.createElement('br', null)
	                            )
	                        );
	                    }
	        }
	
	        // Push vendor name and number in to 2 JSON arrays.
	
	    }, {
	        key: 'getVendorNameOptions',
	        value: function getVendorNameOptions() {
	            var vendorNameOptions = [];
	            this.props.vendors.map(function (vendor) {
	                vendorNameOptions.push({ value: vendor.Vendor_id, label: vendor.Name });
	            });
	            return vendorNameOptions;
	        }
	    }, {
	        key: 'getVendorNumOptions',
	        value: function getVendorNumOptions() {
	            var vendorNumOptions = [];
	            this.props.vendors.map(function (vendor) {
	                vendorNumOptions.push({ value: vendor.Vendor_id, label: vendor.VendorNum });
	            });
	            return vendorNumOptions;
	        }
	    }, {
	        key: 'renderBillingAddress',
	        value: function renderBillingAddress() {
	            var _props3 = this.props,
	                vendorsValue = _props3.vendorsValue,
	                currentVendorDetail = _props3.currentVendorDetail;
	
	            if (currentVendorDetail) {
	                var BillingAddress = currentVendorDetail.BillingAddress.Name + ', ' + currentVendorDetail.BillingAddress.Street + ', ' + currentVendorDetail.BillingAddress.City;
	                return BillingAddress;
	            }
	        }
	
	        // Once a vendor is chosen, render its shipping address and contacts
	
	    }, {
	        key: 'renderVendorAddress',
	        value: function renderVendorAddress() {
	            if (this.props.vendorDetailIsLoading && !this.props.vendorDetailError) return _react2.default.createElement(_spinner2.default, null); // If vendor is loading, show a spinner.
	            else if (this.props.vendorDetailError) return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'error' })
	                ); // If vendor is loading, show a spinner.
	                else if (this.props.currentVendorDetail) {
	                        var vendorAddressOptions = this.getVendorAddressOptions();
	                        var vendorContactOptions = this.getVendorContactOptions();
	                        return _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-5 inlineLabel' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_vendor_address' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 6 },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Pickup_VendorAddress_id', component: _selection.Selection, options: vendorAddressOptions })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-5 inlineLabel' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_contact' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 6 },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Pickup_VendorContact_id', component: _selection.Selection, options: vendorContactOptions })
	                                ),
	                                _react2.default.createElement('br', null),
	                                this.renderVendorContactInformation()
	                            )
	                        );
	                    } else return _react2.default.createElement(
	                        'h4',
	                        { className: 'centerStyle' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_please_select_a_vendor' })
	                    );
	        }
	    }, {
	        key: 'getVendorAddressOptions',
	        value: function getVendorAddressOptions() {
	            var vendorAddressOptions = [];
	            this.props.currentVendorDetail.ShippingAddress.map(function (address) {
	                vendorAddressOptions.push({ value: address.VendorAddress_id, label: address.Name + ', ' + address.City });
	            });
	            return vendorAddressOptions;
	        }
	    }, {
	        key: 'getVendorContactOptions',
	        value: function getVendorContactOptions() {
	            var vendorContactOptions = [];
	            this.props.currentVendorDetail.ShippingContact.map(function (contact) {
	                // Including phone and email in the option
	                vendorContactOptions.push({ value: contact.VendorContact_id, label: contact.FirstName + ' ' + contact.LastName + ' Phone: ' + contact.Cellphone + ' Email: ' + contact.Email });
	            });
	            return vendorContactOptions;
	        }
	    }, {
	        key: 'renderVendorContactInformation',
	        value: function renderVendorContactInformation() {
	            var _props4 = this.props,
	                currentVendorDetail = _props4.currentVendorDetail,
	                vendorsValue = _props4.vendorsValue,
	                vendorContactValue = _props4.vendorContactValue;
	
	            if (vendorContactValue && currentVendorDetail) {
	                var index = _lodash2.default.findIndex(currentVendorDetail.ShippingContact, { 'VendorContact_id': vendorContactValue });
	                if (index != -1) return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                                ': '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            currentVendorDetail.ShippingContact[index].FirstName + ' ' + currentVendorDetail.ShippingContact[index].LastName
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' }),
	                                ': '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            currentVendorDetail.ShippingContact[index].Email
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' }),
	                                ': '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            currentVendorDetail.ShippingContact[index].Telephone
	                        )
	                    )
	                );
	            }
	        }
	
	        // Render the Array of products.
	
	        // renderProducts() {
	        //     if (!this.props.vendorsValue &&
	        //         (!this.props.initialValues || (this.props.initialValues && !this.props.initialValues.Vendor_id)))
	        //         return <h4>Please Select a Vendor</h4>
	        //     if (this.props.productIsLoading) return <Spinner/> // If group is loading, show a spinner.
	        //     else {
	        //         const { miscCostValue, handlingCostValue, shippingCostValue } = this.props;
	        //         let productNumOptions = this.getProductNumOptions();
	        //         let productNameOptions = this.getProductNameOptions();
	        //         let totalCost = (parseFloat(shippingCostValue || 0) + parseFloat(miscCostValue || 0) + parseFloat(handlingCostValue || 0)).toFixed(2)
	        //         return (
	        //             <FieldArray name="Purchase_Order_Line"
	        //                 ref="Products"
	        //                 component={ProductArray}
	        //                 productNameOptions={productNameOptions}
	        //                 productNumOptions={productNumOptions}
	        //                 calculatedProducts={this.state.calculatedProducts}
	        //                 productsValue={this.props.productsValue}
	        //                 products={this.props.products}
	        //                 priceType={this.state.priceType }
	        //                 totalPrice={this.state.totalPrice}
	        //                 totalCost={totalCost}
	        //                 withRef />
	        //         )
	        //     }
	        // }
	
	    }, {
	        key: 'moveToProductsList',
	        value: function moveToProductsList() {
	            var _props5 = this.props,
	                products = _props5.products,
	                productInformation = _props5.productInformation;
	
	            var quantity = this.state.quantity;
	            var newProduct = {};
	            var index = _lodash2.default.findIndex(products, { 'Product_id': productInformation.value || productInformation });
	            var refPrice = this.state.refPrice || this.state.defaultRefPrice || products[index].FOBUnitPrice || 0;
	            var lowestSalePrice = this.state.lowestSalePrice || this.state.defaultLowestSalePrice || products[index].LowestSalePrice || 0;
	            newProduct["Product_id"] = products[index].Product_id;
	            newProduct["ProductNum"] = products[index].ProductNum;
	            newProduct["Name"] = products[index].Name;
	            newProduct["Description"] = products[index].Description;
	            newProduct["MeasureUnit"] = products[index].MeasureUnit;
	            newProduct["EstSalePrice"] = lowestSalePrice; //products[index].LowestSalePrice;
	            newProduct["FOBUnitPrice"] = refPrice; //products[index].RefPrice;
	            newProduct["ShippingWeight"] = products[index].ShippingWeight;
	            newProduct["NetWeight"] = products[index].NetWeight;
	            newProduct["TotalShippingWeight"] = products[index].ShippingWeight * quantity;
	            newProduct["TotalNetWeight"] = products[index].NetWeight * quantity;
	            newProduct["RefNum"] = products[index].RefNum;
	            newProduct["Quantity"] = quantity;
	            newProduct["TotalPrice"] = parseFloat(quantity * refPrice).toFixed(2);
	            newProduct["EstSaleTotal"] = parseFloat(quantity * lowestSalePrice).toFixed(2);
	            var newRows = [].concat(_toConsumableArray(this.state.rows), [newProduct]);
	            var totalShippingWeight = parseFloat(this.state.totalShippingWeight) + quantity * parseFloat(newProduct["ShippingWeight"]);
	            totalShippingWeight = parseFloat(Math.round(totalShippingWeight * 100) / 100).toFixed(2);
	            var totalNetWeight = parseFloat(this.state.totalNetWeight) + quantity * parseFloat(newProduct["NetWeight"]);
	            totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
	            var totalPrice = parseFloat(this.state.totalPrice) + quantity * parseFloat(newProduct["FOBUnitPrice"]);
	            totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	            var discountValue = this.state.discountValue;
	            var taxValue = this.state.taxValue;
	            var finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
	            this.setState.apply(this, _toConsumableArray(this.state).concat([{ rows: newRows,
	                totalShippingWeight: totalShippingWeight,
	                totalNetWeight: totalNetWeight,
	                totalPrice: totalPrice,
	                finalPrice: finalPrice,
	                defaultRefPrice: 0,
	                refPrice: 0,
	                defaultLowestSalePrice: 0,
	                lowestSalePrice: 0,
	                quantity: 0
	            }]));
	        }
	    }, {
	        key: 'moveOffFromProductsList',
	        value: function moveOffFromProductsList() {
	            var newRows = this.state.rows;
	            var totalShippingWeight = 0;
	            var totalNetWeight = 0;
	            var totalPrice = 0;
	            var discountValue = this.state.discountValue;
	            var taxValue = this.state.taxValue;
	            newRows = newRows.filter(function (obj) {
	                return obj.isSelected == false || obj.isSelected == null;
	            });
	
	            newRows.map(function (newRow) {
	                totalShippingWeight = parseFloat(totalShippingWeight) + parseFloat(newRow["Quantity"]) * parseFloat(newRow["ShippingWeight"]);
	                totalNetWeight = parseFloat(totalNetWeight) + parseFloat(newRow["Quantity"]) * parseFloat(newRow["NetWeight"]);
	                totalPrice = parseFloat(totalPrice) + parseFloat(newRow["TotalPrice"]);
	            });
	            totalShippingWeight = parseFloat(Math.round(totalShippingWeight * 100) / 100).toFixed(2);
	            totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
	            totalPrice = (parseFloat(Math.round(totalPrice * 100) / 100) + parseFloat(this.state.miscCostValue) + parseFloat(this.state.handlingCostValue) + parseFloat(this.state.shippingCostValue)).toFixed(2);
	            var finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
	            this.setState({ rows: newRows, selectedRows: [], totalShippingWeight: totalShippingWeight, totalNetWeight: totalNetWeight, totalPrice: totalPrice, finalPrice: finalPrice });
	        }
	    }, {
	        key: 'setDefault',
	        value: function setDefault() {
	            var productInformation = this.props.productInformation;
	
	            if (productInformation) {
	                var products = this.props.products;
	                var index = _lodash2.default.findIndex(products, { 'Product_id': productInformation.value || productInformation });
	                if (products[index] != null) {
	                    if (this.state.defaultRefPrice != products[index].RefPrice) this.setState({ defaultRefPrice: products[index].RefPrice });
	                    if (this.state.defaultLowestSalePrice != products[index].LowestSalePrice) this.setState({ defaultLowestSalePrice: products[index].LowestSalePrice });
	                }
	            }
	        }
	    }, {
	        key: 'handleUnitPriceChange',
	        value: function handleUnitPriceChange(event) {
	            this.setState({ refPrice: event.target.value });
	        }
	    }, {
	        key: 'handleLowestSalePriceChange',
	        value: function handleLowestSalePriceChange(event) {
	            this.setState({ lowestSalePrice: event.target.value });
	        }
	    }, {
	        key: 'handleQuantityChange',
	        value: function handleQuantityChange(event) {
	            this.setState({ quantity: event.target.value });
	        }
	    }, {
	        key: 'renderProducts',
	        value: function renderProducts() {
	            var _this4 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                var productNumOptions = this.getProductNumOptions();
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this4.state);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    _this4.setState.apply(_this4, _toConsumableArray(_this4.state).concat([{ selectedRows: rows }]));
	                };
	
	                var onRowsSelected = function onRowsSelected(rows) {
	                    var newRows = _this4.state.rows;
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = true;
	                    });
	                    _this4.setState({ rows: newRows });
	                };
	
	                var onRowsDeselected = function onRowsDeselected(rows) {
	                    var newRows = _this4.state.rows;
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = false;
	                    });
	                    _this4.setState({ rows: newRows });
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this4.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this4.setState(state);
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this4.state.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    _this4.setState({ filters: newFilters });
	                };
	
	                var onRowClick = function onRowClick(rowIdx, row) {
	                    _this4.props.fetchSalesOrders();
	                };
	
	                // Handle the editable function
	
	                var handleRowUpdated = function handleRowUpdated(e) {
	
	                    var rows = getRows();
	                    var totalShippingWeight = _this4.state.totalShippingWeight;
	                    var totalNetWeight = _this4.state.totalNetWeight;
	                    var totalPrice = _this4.state.totalPrice;
	                    var discountValue = _this4.state.discountValue;
	                    var taxValue = _this4.state.taxValue;
	                    if (e.updated.Quantity != null) {
	                        var quantity = rows[e.rowIdx].Quantity;
	                        Object.assign(rows[e.rowIdx], e.updated);
	                        Object.assign(rows[e.rowIdx], { TotalPrice: parseFloat(e.updated.Quantity * rows[e.rowIdx].FOBUnitPrice).toFixed(2) });
	                        Object.assign(rows[e.rowIdx], { EstSaleTotal: parseFloat(e.updated.Quantity * rows[e.rowIdx].EstSalePrice).toFixed(2) });
	                        totalShippingWeight = parseFloat(_this4.state.totalShippingWeight) + (e.updated.Quantity - quantity) * parseFloat(rows[e.rowIdx].ShippingWeight);
	                        totalShippingWeight = parseFloat(Math.round(totalShippingWeight * 100) / 100).toFixed(2);
	                        totalNetWeight = parseFloat(_this4.state.totalNetWeight) + (e.updated.Quantity - quantity) * parseFloat(rows[e.rowIdx].NetWeight);
	                        totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
	                        totalPrice = parseFloat(_this4.state.totalPrice) + (e.updated.Quantity - quantity) * parseFloat(rows[e.rowIdx].FOBUnitPrice);
	                        totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	                    } else if (e.updated.FOBUnitPrice != null) {
	                        var FOBUnitPrice = rows[e.rowIdx].FOBUnitPrice;
	                        Object.assign(rows[e.rowIdx], e.updated);
	                        Object.assign(rows[e.rowIdx], { TotalPrice: parseFloat(e.updated.FOBUnitPrice * rows[e.rowIdx].Quantity).toFixed(2) });
	                        totalPrice = parseFloat(_this4.state.totalPrice) + rows[e.rowIdx].Quantity * (parseFloat(e.updated.FOBUnitPrice) - parseFloat(FOBUnitPrice));
	                        totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	                    } else if (e.updated.EstSalePrice != null) {
	                        var _quantity = rows[e.rowIdx].Quantity;
	                        var lowestSalePrice = rows[e.rowIdx].EstSalePrice;
	                        Object.assign(rows[e.rowIdx], e.updated);
	                        Object.assign(rows[e.rowIdx], { EstSaleTotal: parseFloat(e.updated.EstSalePrice * rows[e.rowIdx].Quantity).toFixed(2) });
	                    }
	
	                    var finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
	                    _this4.setState({ rows: rows, totalShippingWeight: totalShippingWeight, totalNetWeight: totalNetWeight, totalPrice: totalPrice, finalPrice: finalPrice });
	
	                    // // merge updated row with current row and rerender by setting state
	                    // let rows = this.state.rows.slice(0);
	                    // let editedRows = this.state.editedRows.slice(0);
	                    // Object.assign(rows[e.rowIdx], e.updated);
	                    // // if the element is already edited, remove the old one.
	                    //
	                    // editedRows.forEach((element, index) => {
	                    //     if (element.ProductNum === rows[e.rowIdx].ProductNum)
	                    //         editedRows.splice(index, 1)
	                    // }, this);
	                    // // push the row into the editedRows array
	                    // editedRows.push(rows[e.rowIdx]);
	                    // this.setState({
	                    //     rows: rows,
	                    //     editedRows: editedRows
	                    // });
	                };
	
	                //Custom Formatter component
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNameFormatter = _react2.default.createClass({
	                    displayName: 'VendorNameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNumFormatter = _react2.default.createClass({
	                    displayName: 'VendorNumFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.VendorNum
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true
	                }, {
	                    key: 'Name',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'Description',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200,
	                    filterable: true
	                }, {
	                    key: 'MeasureUnit',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'measure_unit' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true
	                }, {
	                    key: 'ShippingWeight',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true
	                }, {
	                    key: 'Quantity',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' }),
	                    resizable: true,
	                    editable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true
	                }, {
	                    key: 'FOBUnitPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price' }),
	                    resizable: true,
	                    editable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'TotalPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_price' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'EstSalePrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lowest_sale_dollarsign' }),
	                    resizable: true,
	                    editable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'EstSaleTotal',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'et_sale_total' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'RefNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true
	                }];
	                // this.props.products = this.props.products.bind(this);
	
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                'div',
	                                { style: { maxWidth: '99%' }, id: 'PurchaseQuoteForm-dataGrid1' },
	                                _react2.default.createElement(_reactDataGrid2.default, {
	                                    rowKey: 'Product_id',
	                                    enableCellSelect: true,
	                                    onGridSort: handleGridSort,
	                                    toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                    onAddFilter: handleFilterChange,
	                                    columns: columns,
	                                    rowGetter: rowGetter,
	                                    rowsCount: getSize(),
	                                    enableRowSelect: 'multi',
	                                    onRowUpdated: handleRowUpdated,
	                                    rowSelection: {
	                                        showCheckbox: true,
	                                        enableShiftSelect: true,
	                                        onRowsSelected: onRowsSelected,
	                                        onRowsDeselected: onRowsDeselected,
	                                        selectBy: {
	                                            isSelectedKey: 'isSelected'
	                                        }
	                                    }
	                                })
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'getAllProductNumOptions',
	        value: function getAllProductNumOptions() {
	            var productNumOptions = [{ value: '', label: "No.       |  Name           |  Description                                           |  MeasureUnit" }];
	            this.props.simplifiedProducts.map(function (product) {
	                var text = "                                                                  ";
	                var output = [product.ProductNum.slice(0, 8), text].join('');
	                output = [output.slice(0, 8), '  |  ', product.Name.slice(0, 12), text].join('');
	                if (product.Description) output = [output.slice(0, 26), '  |  ', product.Description.slice(0, 50), text].join('');else output = [output.slice(0, 26), '  |  ', '                                                  ', text].join('');
	                if (product.MeasureUnit) output = [output.slice(0, 83), '  |  ', product.MeasureUnit.slice(0, 10), text].join('');else output = [output.slice(0, 83), '  |  ', '          ', text].join('');
	                output = output.slice(0, 99);
	                productNumOptions.push({ value: product.Product_id, label: output });
	            });
	            return productNumOptions;
	        }
	    }, {
	        key: 'getProductNumOptions',
	        value: function getProductNumOptions() {
	            var productNumOptions = [{ value: '', label: "No.       |  Name           |  Description                                           |  MeasureUnit" }];
	            this.props.products.map(function (product) {
	                var text = "                                                                  ";
	                var output = [product.ProductNum.slice(0, 8), text].join('');
	                output = [output.slice(0, 8), '  |  ', product.Name.slice(0, 12), text].join('');
	                if (product.Description) output = [output.slice(0, 26), '  |  ', product.Description.slice(0, 50), text].join('');else output = [output.slice(0, 26), '  |  ', '                                                  ', text].join('');
	                if (product.MeasureUnit) output = [output.slice(0, 83), '  |  ', product.MeasureUnit.slice(0, 10), text].join('');else output = [output.slice(0, 83), '  |  ', '          ', text].join('');
	                output = output.slice(0, 99);
	                productNumOptions.push({ value: product.Product_id, label: output });
	            });
	            return productNumOptions;
	        }
	    }, {
	        key: 'getProductNameOptions',
	        value: function getProductNameOptions() {
	            var productNameOptions = [];
	            this.props.products.map(function (product) {
	                productNameOptions.push({ value: product.Product_id, label: product.Name });
	            });
	            return productNameOptions;
	        }
	    }, {
	        key: 'renderCarryTypeShippingMethod',
	        value: function renderCarryTypeShippingMethod() {
	            var carryTypeOptions = [{ value: "Dry", label: "Dry" }, { value: "Refrigerated", label: "Refrigerated" }];
	            var shippingMethodOptions = [{ value: "Truckxi", label: "Truckxi" }, { value: "Own Logistic", label: "Own Logistic" }];
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 6 },
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'col-sm-5 inlineLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carry_type' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'CarryType', component: _selection.Selection, options: carryTypeOptions, defaultValue: { value: "Dry", label: "Dry" } })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 6 },
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'col-sm-5 inlineLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_method' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'ShippingMethod', component: _selection.Selection, options: shippingMethodOptions, defaultValue: { value: "Own Logistic", label: "Own Logistic" } })
	                    )
	                )
	            );
	        }
	
	        // Render the Paymentterms select.
	
	    }, {
	        key: 'renderPaymentTerms',
	        value: function renderPaymentTerms() {
	            if (this.props.paymentTermsIsLoading) return _react2.default.createElement(_spinner2.default, null); // If group is loading, show a spinner.
	            else {
	                    var paymentTermOptions = this.getPaymentTermOptions();
	                    return _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-5 inlineLabel' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'PaymentTerm_id', component: _selection.Selection, options: paymentTermOptions })
	                            )
	                        )
	                    );
	                }
	        }
	    }, {
	        key: 'getPaymentTermOptions',
	        value: function getPaymentTermOptions() {
	            var paymentTermOptions = [];
	            this.props.paymentTerms.map(function (paymentTerm) {
	                paymentTermOptions.push({ value: paymentTerm.PaymentTerm_id, label: paymentTerm.Name });
	            });
	            return paymentTermOptions;
	        }
	
	        // Dropdown list for payment status
	
	    }, {
	        key: 'renderPaymentStatus',
	        value: function renderPaymentStatus() {
	            var paymentStatusOptions = [{ value: 'Not Paid', label: 'Not Paid' }, { value: 'Partially Paid', label: 'Partially Paid' }, { value: 'Paid', label: 'Paid' }];
	
	            return _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(
	                    'label',
	                    { className: 'col-sm-6 inlineLabel' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_status' }),
	                    ' ',
	                    _react2.default.createElement(
	                        'span',
	                        { style: { color: 'red' } },
	                        '*'
	                    ),
	                    ' '
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 6 },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'PaymentStatus', component: _selection.Selection, options: paymentStatusOptions })
	                )
	            );
	        }
	    }, {
	        key: 'renderWarehouse',
	        value: function renderWarehouse() {
	            if (this.props.warehouseIsLoading) return _react2.default.createElement(_spinner2.default, null); // If group is loading, show a spinner.
	            else {
	                    var warehouseOptions = this.getWarehouseOptions();
	                    return _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-5 inlineLabel' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver_warehouse' }),
	                                ' ',
	                                _react2.default.createElement(
	                                    'span',
	                                    { style: { color: 'red' } },
	                                    '*'
	                                ),
	                                ' '
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Deliver_Warehouse_id', component: _selection.Selection, options: warehouseOptions })
	                            )
	                        )
	                    );
	                }
	        }
	    }, {
	        key: 'getWarehouseOptions',
	        value: function getWarehouseOptions() {
	            var warehouseOptions = [];
	            this.props.warehouses.map(function (warehouse) {
	                warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name });
	            });
	            return warehouseOptions;
	        }
	
	        // Implement the Headers which enable the function of collapsible
	
	    }, {
	        key: 'productHeader',
	        value: function productHeader() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_information' })
	                )
	            );
	        }
	    }, {
	        key: 'pickupHeader',
	        value: function pickupHeader() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup' })
	                )
	            );
	        }
	    }, {
	        key: 'deliverHeader',
	        value: function deliverHeader() {
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver_warehouse' })
	                )
	            );
	        }
	    }, {
	        key: 'carryHeader',
	        value: function carryHeader() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carry_type_shipping_method' })
	                )
	            );
	        }
	    }, {
	        key: 'accountHeader',
	        value: function accountHeader() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account_payment_term' })
	                )
	            );
	        }
	    }, {
	        key: 'attachmentHeader',
	        value: function attachmentHeader() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'attachment_upload' })
	                )
	            );
	        }
	    }, {
	        key: 'vendorHeader',
	        value: function vendorHeader() {
	            var _this5 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { onClick: function onClick() {
	                        return _this5.setState({ vendorInformationOpen: !_this5.state.vendorInformationOpen });
	                    } },
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_information' })
	                )
	            );
	        }
	    }, {
	        key: 'oneTimeScheduleHeader',
	        value: function oneTimeScheduleHeader() {
	            var _this6 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { onClick: function onClick() {
	                        return _this6.setState({ oneTimeScheduleOpen: !_this6.state.oneTimeScheduleOpen });
	                    } },
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'one_time_schedule' })
	                )
	            );
	        }
	    }, {
	        key: 'purchaseInformationHeader',
	        value: function purchaseInformationHeader() {
	            var _this7 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { onClick: function onClick() {
	                        return _this7.setState({ purchaseInformationOpen: !_this7.state.purchaseInformationOpen });
	                    } },
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_information' })
	                )
	            );
	        }
	    }, {
	        key: 'orderHistoryHeader',
	        value: function orderHistoryHeader() {
	            var _this8 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { onClick: function onClick() {
	                        return _this8.setState({ orderHistoryOpen: !_this8.state.orderHistoryOpen });
	                    } },
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_history' })
	                )
	            );
	        }
	    }, {
	        key: 'inventoryHeader',
	        value: function inventoryHeader() {
	            var _this9 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { onClick: function onClick() {
	                        return _this9.setState({ inventoryOpen: !_this9.state.inventoryOpen });
	                    } },
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory' })
	                )
	            );
	        }
	    }, {
	        key: 'onDrop',
	        value: function onDrop(files) {
	            this.setState({
	                files: files
	            });
	        }
	    }, {
	        key: 'onOpenClick',
	        value: function onOpenClick() {
	            this.refs.dropzone.open();
	        }
	    }, {
	        key: 'renderPreview',
	        value: function renderPreview() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'preview' })
	                ),
	                _react2.default.createElement('hr', null),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(_reactBootstrap.Image, { src: this.state.files[0].preview, thumbnail: true })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'placeNewOrder',
	        value: function placeNewOrder(e) {
	            e.preventDefault();
	            this.setState({ dirty: false });
	            this.props.purchaseQuotePlace(this.props.formProps, _reactDataGridAddons.Data.Selectors.getRows(this.state), this.props.currentPurchaseQuote.PurchaseOrder_id);
	        }
	
	        // If the user was directed to the page with a parameter,
	        // then this page is edit page. Otherwise this is a create
	        // page.
	
	    }, {
	        key: 'handleFormSubmit',
	        value: function handleFormSubmit(formProps) {
	            this.setState({ dirty: false });
	
	            if (this.props.currentPurchaseQuote) {
	                if (!this.checkPermission("edit_purchase_quote")) this.props.editPurchaseQuote(formProps, _reactDataGridAddons.Data.Selectors.getRows(this.state));else alert("You have no permission!");
	            } else this.props.createPurchaseQuote(formProps, _reactDataGridAddons.Data.Selectors.getRows(this.state));
	        }
	    }, {
	        key: 'handleMiscCostChange',
	        value: function handleMiscCostChange(event) {
	            var totalPrice = parseFloat(this.state.totalPrice);
	            totalPrice = parseFloat(totalPrice || 0) - parseFloat(this.state.miscCostValue || 0) + parseFloat(event.target.value || 0);
	            var discountValue = parseFloat(this.state.discountValue);
	            var taxValue = parseFloat(this.state.taxValue);
	            var finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
	            this.setState({ miscCostValue: event.target.value, totalPrice: totalPrice, finalPrice: finalPrice });
	        }
	    }, {
	        key: 'handleHandlingCostChange',
	        value: function handleHandlingCostChange(event) {
	            var totalPrice = parseFloat(this.state.totalPrice);
	            totalPrice = parseFloat(totalPrice || 0) - parseFloat(this.state.handlingCostValue || 0) + parseFloat(event.target.value || 0);
	            var discountValue = parseFloat(this.state.discountValue);
	            var taxValue = parseFloat(this.state.taxValue);
	            var finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
	            this.setState({ handlingCostValue: event.target.value, totalPrice: totalPrice, finalPrice: finalPrice });
	        }
	    }, {
	        key: 'handleShippingCostChange',
	        value: function handleShippingCostChange(event) {
	            var totalPrice = parseFloat(this.state.totalPrice);
	            totalPrice = parseFloat(totalPrice || 0) - parseFloat(this.state.shippingCostValue || 0) + parseFloat(event.target.value || 0);
	            var discountValue = parseFloat(this.state.discountValue);
	            var taxValue = parseFloat(this.state.taxValue);
	            var finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
	            this.setState({ shippingCostValue: event.target.value, totalPrice: totalPrice, finalPrice: finalPrice });
	        }
	    }, {
	        key: 'handleDiscountChange',
	        value: function handleDiscountChange(event) {
	            var totalPrice = parseFloat(this.state.totalPrice);
	            var taxValue = parseFloat(this.state.taxValue);
	            var finalPrice = (totalPrice * (1 - parseFloat(event.target.value || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
	            // let finalPrice = (totalPrice / (1 - parseFloat(discountValue || 0) / 100.00) * (1 - parseFloat(event.target.value || 0) / 100.00)).toFixed(2);
	            this.setState({ discountValue: event.target.value, finalPrice: finalPrice });
	        }
	    }, {
	        key: 'handleTaxChange',
	        value: function handleTaxChange(event) {
	            var totalPrice = parseFloat(this.state.totalPrice);
	            var discountValue = parseFloat(this.state.discountValue);
	            var finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(event.target.value || 0) / 100.0)).toFixed(2);
	            // let finalPrice = (totalPrice / (1 + parseFloat(taxValue || 0) / 100.00) * (1 + parseFloat(event.target.value || 0) / 100.00)).toFixed(2);
	            this.setState({ taxValue: event.target.value, finalPrice: finalPrice });
	        }
	    }, {
	        key: 'checkPermission',
	        value: function checkPermission(permission) {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this10 = this;
	
	            var vendorProducts = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_products' });
	            var allProducts = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all_products' });
	            var convertItemPriceTranslation = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'convert_item_price' });
	            var productNumOptions = this.getProductNumOptions();
	            var allProductNumOptions = this.getAllProductNumOptions();
	            var _props6 = this.props,
	                handleSubmit = _props6.handleSubmit,
	                submitting = _props6.submitting,
	                pristine = _props6.pristine,
	                isCreating = _props6.isCreating,
	                isEditing = _props6.isEditing;
	
	            if (this.props.detailIsLoading && !this.props.detailError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement('br', null),
	                '...',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reading_data' })
	            );else if (this.props.detailError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    this.props.error
	                )
	            );else {
	                var productInfo = this.state.productInfo;
	                return _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    this.title(),
	                    _react2.default.createElement(
	                        'form',
	                        { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 4 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { className: 'panelStyle', header: this.vendorHeader(), collapsible: true, expanded: this.state.vendorInformationOpen },
	                                    _react2.default.createElement(
	                                        'fieldset',
	                                        null,
	                                        this.renderVendorsDetail(),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'billing_address' })
	                                            ),
	                                            !this.props.currentVendorDetail && _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-9' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_please_select_a_vendor' }),
	                                                ' '
	                                            ),
	                                            this.props.currentVendorDetail && _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-9' },
	                                                this.renderBillingAddress()
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'outstanding_order' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 6 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'Outsanding', component: _inputField.InputField })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'outstanding_invoice' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 6 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'OutstandingInvoice', component: _inputField.InputField })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 3 },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_order_amount' })
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 9 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'CurrentOrderAmount', component: _inputField.InputField })
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'fieldset',
	                                        null,
	                                        !this.props.vendorContactValue && _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-sm-9' },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_a_contact' })
	                                        ),
	                                        this.props.vendorContactValue && this.renderVendorContactInformation()
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { className: 'panelStyle', header: this.oneTimeScheduleHeader(), collapsible: true, expanded: this.state.oneTimeScheduleOpen },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        { className: 'marginBottomStyle' },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 4 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_date' }),
	                                                ' ',
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { style: { color: 'red' } },
	                                                    '*'
	                                                ),
	                                                ' '
	                                            ),
	                                            _react2.default.createElement(_reduxForm.Field, { name: 'OrderDate', component: _datePicker.DatePicker })
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 4 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'eta_date' })
	                                            ),
	                                            _react2.default.createElement(_reduxForm.Field, { name: 'ETADate', component: _datePicker.DatePicker })
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 4 },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_date' })
	                                            ),
	                                            _react2.default.createElement(_reduxForm.Field, { name: 'ReceiveDate', component: _datePicker.DisabledDatePicker })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { className: 'panelStyle', header: this.purchaseInformationHeader(), collapsible: true, expanded: this.state.purchaseInformationOpen },
	                                    _react2.default.createElement(
	                                        'fieldset',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 3 },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        { className: 'col-sm-12 inlineLabel' },
	                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' })
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 9 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'PONum', component: _inputField.DisabledInputField })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_status' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 6 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'PurchaseStatus', component: _inputField.DisabledInputField })
	                                                )
	                                            ),
	                                            this.renderPaymentStatus()
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'fieldset',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchased_by' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 6 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'Purchaser_User_id', component: _inputField.DisabledInputField })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_modified_by' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 6 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'Modifier_User_id', component: _inputField.DisabledInputField })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 3 },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        { className: 'col-sm-12 inlineLabel' },
	                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' })
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 9 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'NoteToVendor', component: 'Textarea', className: 'form-control', style: { minHeight: '50px' } })
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'fieldset',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_net_weight' })
	                                                ),
	                                                _react2.default.createElement(_reduxForm.Field, { name: 'FinalNetWeight', component: _hiddenInputField2.default, V: this.state.totalNetWeight }),
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 inlineLabel', style: { paddingLeft: '8px' } },
	                                                    this.state.totalNetWeight,
	                                                    ' lb'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_shipping_weight' })
	                                                ),
	                                                _react2.default.createElement(_reduxForm.Field, { name: 'FinalShippingWeight', component: _hiddenInputField2.default, V: this.state.totalShippingWeight }),
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 inlineLabel', style: { paddingLeft: '8px' } },
	                                                    this.state.totalShippingWeight,
	                                                    ' lb'
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'fieldset',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_cost' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 6 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'ShippingCost', component: _inputField.ControlledInputField, placeholder: this.state.shippingCostValue, onChange: this.handleShippingCostChange })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'handling_cost' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 6 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'HandlingCost', component: _inputField.ControlledInputField, placeholder: this.state.handlingCostValue, onChange: this.handleHandlingCostChange })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'misc_cost' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 6 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'MiscCost', component: _inputField.ControlledInputField, placeholder: this.state.miscCostValue, onChange: this.handleMiscCostChange })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 3 },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'misc_cost_detail' })
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 9, style: { float: "left" } },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'MiscNote', component: _inputField.InputField })
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'fieldset',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3 marginTopStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_price' })
	                                            ),
	                                            _react2.default.createElement(_reduxForm.Field, { name: 'TotalPrice', component: _hiddenInputField2.default, V: this.state.totalPrice }),
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-9' },
	                                                '$ ',
	                                                this.state.totalPrice
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 6 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'Discount', component: _inputField.ControlledInputField, placeholder: this.state.discountValue, onChange: this.handleDiscountChange })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 6 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'TaxRate', component: _inputField.ControlledInputField, placeholder: this.state.taxValue, onChange: this.handleTaxChange })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3 marginTopStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' })
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 7 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: 'FinalPrice', component: _hiddenInputField2.default, V: this.state.finalPrice })
	                                            ),
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-9' },
	                                                '$ ',
	                                                this.state.finalPrice
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'fieldset',
	                                        null,
	                                        _react2.default.createElement(_reduxForm.Field, { name: 'ConvertItemPrice', component: _convertItemPrice2.default, labelName: convertItemPriceTranslation })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { className: 'panelStyle', header: this.orderHistoryHeader(), collapsible: true, expanded: this.state.orderHistoryOpen },
	                                    _react2.default.createElement(
	                                        'fieldset',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-12 inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                productInfo ? productInfo.PONum : null
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-12 inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity_colonsign' }),
	                                                    ' '
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                productInfo ? productInfo.Quantity : null
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-12 inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price_colonsign' }),
	                                                    ' '
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                productInfo ? productInfo.UnitPrice : null
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-12 inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_date_colonsign' }),
	                                                    ' '
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                productInfo && productInfo.OrderDate ? productInfo.OrderDate.slice(0, 10) : null
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { className: 'panelStyle', header: this.inventoryHeader(), collapsible: true, expanded: this.state.inventoryOpen },
	                                    _react2.default.createElement(
	                                        'fieldset',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity_colonsign' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                productInfo ? productInfo.Quantity : null
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'in_stock_colonsign' }),
	                                                    ' '
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                productInfo ? productInfo.InStock : null
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'presale_colonsign' }),
	                                                    ' '
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                productInfo ? productInfo.PreSale : null
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchased_colonsign' }),
	                                                    ' '
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                productInfo ? productInfo.Purchased : null
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'min_limit_colonsign' }),
	                                                    ' '
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                productInfo ? productInfo.ProductNum.MinStockRange : null
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'max_limit_colonsign' }),
	                                                    ' '
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                productInfo ? productInfo.ProductNum.MaxStockRange : null
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 3 },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        { className: 'col-sm-12 inlineLabel' },
	                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'default_location_colonsign' }),
	                                                        ' '
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 9 },
	                                                    productInfo && productInfo.Warehouse_id && productInfo.Warehouse_id.Name
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 8 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 12 },
	                                        _react2.default.createElement(
	                                            _reactRouter.Link,
	                                            { to: '/purchaseQuote', className: 'btn btn-default' },
	                                            _react2.default.createElement('em', { className: 'fa fa-close' })
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            { className: 'btn btn-default', disabled: submitting || pristine },
	                                            _react2.default.createElement('em', { className: 'fa fa-trash' })
	                                        ),
	                                        (isCreating || isEditing) && _react2.default.createElement(_spinner2.default, null),
	                                        this.props.createError && _react2.default.createElement(
	                                            'div',
	                                            { className: 'alert alert-danger marginTopStyle' },
	                                            JSON.stringify(this.props.createError)
	                                        ),
	                                        this.props.editError && _react2.default.createElement(
	                                            'div',
	                                            { className: 'alert alert-danger marginTopStyle' },
	                                            JSON.stringify(this.props.editError)
	                                        ),
	                                        this.placeButtons()
	                                    )
	                                ),
	                                _react2.default.createElement('hr', null),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Panel,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Row,
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Col,
	                                                        { sm: 12 },
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Row,
	                                                            null,
	                                                            _react2.default.createElement(
	                                                                _reactBootstrap.Col,
	                                                                { sm: 12 },
	                                                                this.productHeader(),
	                                                                _react2.default.createElement(
	                                                                    _reactBootstrap.Tabs,
	                                                                    { defaultActiveKey: 1, justified: true },
	                                                                    _react2.default.createElement(
	                                                                        _reactBootstrap.Tab,
	                                                                        { eventKey: 1, title: vendorProducts },
	                                                                        _react2.default.createElement(
	                                                                            _reactBootstrap.Row,
	                                                                            null,
	                                                                            _react2.default.createElement(
	                                                                                _reactBootstrap.Col,
	                                                                                { sm: 12 },
	                                                                                _react2.default.createElement(
	                                                                                    _reactBootstrap.Row,
	                                                                                    null,
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 12 },
	                                                                                        _react2.default.createElement(
	                                                                                            _reactBootstrap.Col,
	                                                                                            { sm: 2 },
	                                                                                            _react2.default.createElement(
	                                                                                                'label',
	                                                                                                null,
	                                                                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' })
	                                                                                            )
	                                                                                        ),
	                                                                                        _react2.default.createElement(
	                                                                                            _reactBootstrap.Col,
	                                                                                            { sm: 10 },
	                                                                                            _react2.default.createElement(_reduxForm.Field, { name: 'ProductInformation', component: _detailedSelection.DetailedSelection, options: productNumOptions, onChange: this.setDefault() })
	                                                                                        )
	                                                                                    )
	                                                                                ),
	                                                                                _react2.default.createElement(
	                                                                                    _reactBootstrap.Row,
	                                                                                    null,
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 4 },
	                                                                                        _react2.default.createElement(
	                                                                                            _reactBootstrap.Col,
	                                                                                            { sm: 6 },
	                                                                                            _react2.default.createElement(
	                                                                                                'label',
	                                                                                                { className: 'col-sm-12 inlineLabel' },
	                                                                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' })
	                                                                                            )
	                                                                                        ),
	                                                                                        _react2.default.createElement(
	                                                                                            _reactBootstrap.Col,
	                                                                                            { sm: 6 },
	                                                                                            _react2.default.createElement(_reduxForm.Field, { name: 'Quantity', component: _inputField.ControlledInputField, placeholder: this.state.quantity, onChange: this.handleQuantityChange })
	                                                                                        )
	                                                                                    ),
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 4 },
	                                                                                        _react2.default.createElement(
	                                                                                            _reactBootstrap.Col,
	                                                                                            { sm: 6 },
	                                                                                            _react2.default.createElement(
	                                                                                                'label',
	                                                                                                { className: 'col-sm-12 inlineLabel' },
	                                                                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price' })
	                                                                                            )
	                                                                                        ),
	                                                                                        _react2.default.createElement(
	                                                                                            _reactBootstrap.Col,
	                                                                                            { sm: 6 },
	                                                                                            _react2.default.createElement(_reduxForm.Field, { name: 'FOBUnitPrice', component: _inputField.ControlledInputField, placeholder: this.state.refPrice || this.state.defaultRefPrice, onChange: this.handleUnitPriceChange })
	                                                                                        )
	                                                                                    ),
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 4 },
	                                                                                        _react2.default.createElement(
	                                                                                            _reactBootstrap.Col,
	                                                                                            { sm: 6 },
	                                                                                            _react2.default.createElement(
	                                                                                                'label',
	                                                                                                { className: 'col-sm-12 inlineLabel' },
	                                                                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lowest_sale_dollarsign' })
	                                                                                            )
	                                                                                        ),
	                                                                                        _react2.default.createElement(
	                                                                                            _reactBootstrap.Col,
	                                                                                            { sm: 6 },
	                                                                                            _react2.default.createElement(_reduxForm.Field, { name: 'EstSalePrice', component: _inputField.ControlledInputField, placeholder: this.state.lowestSalePrice || this.state.defaultLowestSalePrice, onChange: this.handleLowestSalePriceChange })
	                                                                                        )
	                                                                                    )
	                                                                                )
	                                                                            )
	                                                                        ),
	                                                                        _react2.default.createElement('br', null),
	                                                                        _react2.default.createElement(
	                                                                            _reactBootstrap.Row,
	                                                                            null,
	                                                                            _react2.default.createElement(
	                                                                                _reactBootstrap.Col,
	                                                                                null,
	                                                                                _react2.default.createElement(
	                                                                                    _reactBootstrap.Button,
	                                                                                    { className: 'btn btn-primary pull-right', onClick: function onClick() {
	                                                                                            return _this10.moveToProductsList();
	                                                                                        } },
	                                                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'move_to_product_list' })
	                                                                                )
	                                                                            ),
	                                                                            _react2.default.createElement(
	                                                                                _reactBootstrap.Col,
	                                                                                null,
	                                                                                _react2.default.createElement(
	                                                                                    _reactBootstrap.Button,
	                                                                                    { className: 'btn btn-primary pull-right', onClick: function onClick() {
	                                                                                            return _this10.moveOffFromProductsList();
	                                                                                        } },
	                                                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'move_off_from_products_list' })
	                                                                                )
	                                                                            )
	                                                                        )
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        _reactBootstrap.Tab,
	                                                                        { eventKey: 2, title: allProducts },
	                                                                        _react2.default.createElement(
	                                                                            _reactBootstrap.Row,
	                                                                            null,
	                                                                            _react2.default.createElement(
	                                                                                _reactBootstrap.Col,
	                                                                                { sm: 12 },
	                                                                                _react2.default.createElement(
	                                                                                    _reactBootstrap.Row,
	                                                                                    null,
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 12 },
	                                                                                        _react2.default.createElement(
	                                                                                            _reactBootstrap.Col,
	                                                                                            { sm: 2 },
	                                                                                            _react2.default.createElement(
	                                                                                                'label',
	                                                                                                null,
	                                                                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' })
	                                                                                            )
	                                                                                        ),
	                                                                                        _react2.default.createElement(
	                                                                                            _reactBootstrap.Col,
	                                                                                            { sm: 10 },
	                                                                                            _react2.default.createElement(_reduxForm.Field, { name: 'AllProducts', component: _detailedSelection.VirtualizedDetailedSelection, options: allProductNumOptions })
	                                                                                        )
	                                                                                    )
	                                                                                ),
	                                                                                _react2.default.createElement(
	                                                                                    _reactBootstrap.Row,
	                                                                                    null,
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 4 },
	                                                                                        _react2.default.createElement(
	                                                                                            _reactBootstrap.Col,
	                                                                                            { sm: 6 },
	                                                                                            _react2.default.createElement(
	                                                                                                'label',
	                                                                                                { className: 'col-sm-12 inlineLabel' },
	                                                                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' })
	                                                                                            )
	                                                                                        ),
	                                                                                        _react2.default.createElement(
	                                                                                            _reactBootstrap.Col,
	                                                                                            { sm: 6 },
	                                                                                            _react2.default.createElement(_reduxForm.Field, { name: 'AllProd_Quantity', component: _inputField.InputField, placeholder: 0 })
	                                                                                        )
	                                                                                    ),
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 4 },
	                                                                                        _react2.default.createElement(
	                                                                                            _reactBootstrap.Col,
	                                                                                            { sm: 6 },
	                                                                                            _react2.default.createElement(
	                                                                                                'label',
	                                                                                                { className: 'col-sm-12 inlineLabel' },
	                                                                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price' })
	                                                                                            )
	                                                                                        ),
	                                                                                        _react2.default.createElement(
	                                                                                            _reactBootstrap.Col,
	                                                                                            { sm: 6 },
	                                                                                            _react2.default.createElement(_reduxForm.Field, { name: 'AllProd_FOBUnitPrice', component: _inputField.InputField, placeholder: 0 })
	                                                                                        )
	                                                                                    ),
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 4 },
	                                                                                        _react2.default.createElement(
	                                                                                            _reactBootstrap.Col,
	                                                                                            { sm: 6 },
	                                                                                            _react2.default.createElement(
	                                                                                                'label',
	                                                                                                { className: 'col-sm-12 inlineLabel' },
	                                                                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lowest_sale_dollarsign' })
	                                                                                            )
	                                                                                        ),
	                                                                                        _react2.default.createElement(
	                                                                                            _reactBootstrap.Col,
	                                                                                            { sm: 6 },
	                                                                                            _react2.default.createElement(_reduxForm.Field, { name: 'AllProd_EstSalePrice', component: _inputField.InputField, placeholder: 0 })
	                                                                                        )
	                                                                                    )
	                                                                                )
	                                                                            )
	                                                                        ),
	                                                                        _react2.default.createElement('br', null),
	                                                                        _react2.default.createElement(
	                                                                            _reactBootstrap.Row,
	                                                                            null,
	                                                                            _react2.default.createElement(
	                                                                                _reactBootstrap.Col,
	                                                                                null,
	                                                                                _react2.default.createElement(
	                                                                                    _reactBootstrap.Button,
	                                                                                    { className: 'btn btn-primary pull-right', onClick: function onClick() {
	                                                                                            return _this10.moveToProductsListFromAll();
	                                                                                        } },
	                                                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'move_to_product_list' })
	                                                                                )
	                                                                            ),
	                                                                            _react2.default.createElement(
	                                                                                _reactBootstrap.Col,
	                                                                                null,
	                                                                                _react2.default.createElement(
	                                                                                    _reactBootstrap.Button,
	                                                                                    { className: 'btn btn-primary pull-right', onClick: function onClick() {
	                                                                                            return _this10.moveOffFromProductsList();
	                                                                                        } },
	                                                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'move_off_from_products_list' })
	                                                                                )
	                                                                            )
	                                                                        )
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(_reactBootstrap.Row, null)
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                this.renderProducts()
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Panel,
	                                                    { header: this.pickupHeader(), className: 'panelStyle' },
	                                                    this.renderVendorAddress()
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Panel,
	                                                    { header: this.deliverHeader(), className: 'panelStyle' },
	                                                    this.renderWarehouse()
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Panel,
	                                                    { header: this.carryHeader(), className: 'panelStyle' },
	                                                    this.renderCarryTypeShippingMethod()
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Panel,
	                                                    { header: this.accountHeader(), className: 'panelStyle' },
	                                                    this.renderPaymentTerms(),
	                                                    _react2.default.createElement('br', null),
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Col,
	                                                        { sm: 6 },
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { className: 'col-sm-5 inlineLabel' },
	                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice' })
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 6 },
	                                                            _react2.default.createElement(_reduxForm.FieldArray, { name: 'Invoices', component: renderInvoice })
	                                                        )
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Panel,
	                                                    { header: this.attachmentHeader(), className: 'panelStyle' },
	                                                    _react2.default.createElement(
	                                                        _reactDropzone2.default,
	                                                        { onDrop: this.onDrop.bind(this), className: 'well dropzone' },
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Button,
	                                                            { className: 'pull-right btn btn-default btn-primary', onClick: this.onOpenClick },
	                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'upload_file' })
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'dz-default dz-message' },
	                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_drag_drop_attachment' })
	                                                        )
	                                                    ),
	                                                    this.state.files && this.renderPreview()
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_reactBootstrap.Row, null)
	                    )
	                );
	            }
	        }
	    }]);
	
	    return PurchaseQuoteForm;
	}(_react.Component);
	
	PurchaseQuoteForm.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	
	var _default = (0, _reactRouter.withRouter)(PurchaseQuoteForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(renderInvoice, 'renderInvoice', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseQuoteForm.jsx');
	
	    __REACT_HOT_LOADER__.register(PurchaseQuoteForm, 'PurchaseQuoteForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseQuoteForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseQuoteForm.jsx');
	}();

	;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _purchaseQuoteModal = __webpack_require__(76);
	
	var _purchaseQuoteModal2 = _interopRequireDefault(_purchaseQuoteModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PurchaseQuoteList = function (_Component) {
	    _inherits(PurchaseQuoteList, _Component);
	
	    function PurchaseQuoteList() {
	        _classCallCheck(this, PurchaseQuoteList);
	
	        var _this = _possibleConstructorReturn(this, (PurchaseQuoteList.__proto__ || Object.getPrototypeOf(PurchaseQuoteList)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton,
	
	            createOpen: false,
	
	            rows: [],
	            selectedRows: null,
	            filters: {},
	            sortColumn: null,
	            sortDirection: null,
	            purchaseQuoteDetail: {
	                rows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            }
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        _this.openCreate = _this.openCreate.bind(_this);
	        _this.closeCreate = _this.closeCreate.bind(_this);
	        return _this;
	    }
	
	    _createClass(PurchaseQuoteList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchPurchaseQuotes();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once products are ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.purchaseQuotes[0] && nextProps.purchaseQuotes != this.props.purchaseQuotes) {
	                var newRows = [].concat(_toConsumableArray(nextProps.purchaseQuotes));
	                this.setState({
	                    rows: newRows
	                });
	            }
	
	            if (nextProps.purchaseOrderList && nextProps.purchaseOrderList != this.props.purchaseOrderList) {
	                var purchaseQuoteDetail = _extends({}, this.state.purchaseQuoteDetail, { rows: nextProps.purchaseOrderList });
	                this.setState({ purchaseQuoteDetail: purchaseQuoteDetail });
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton });
	        }
	    }, {
	        key: 'openCreate',
	        value: function openCreate() {
	            this.setState({ createOpen: true });
	        }
	    }, {
	        key: 'closeCreate',
	        value: function closeCreate() {
	            this.setState({ createOpen: false });
	        }
	
	        // Set product being selected to be currentProduct and navigate user to the edit page
	
	    }, {
	        key: 'setCurrentPurchaseQuote',
	        value: function setCurrentPurchaseQuote(e) {
	            e.preventDefault();
	            var currentPurchaseQuote = this.state.selectedRows[0];
	            this.props.resetCurrentPurchaseQuote();
	            this.props.selectPurchaseQuote(currentPurchaseQuote);
	            this.context.router.push('/purchaseQuote/' + currentPurchaseQuote.PurchaseOrder_id);
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            this.props.resetCurrentPurchaseQuote();
	            this.context.router.push('/purchaseQuote/new');
	        }
	    }, {
	        key: 'deletePurchaseQuote',
	        value: function deletePurchaseQuote(e) {
	            e.preventDefault();
	            var currentPurchaseQuote = this.state.selectedRows[0];
	            this.props.deletePurchaseQuote(currentPurchaseQuote.PurchaseOrder_id);
	        }
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this2 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var tableHeight = window.innerHeight < 900 ? 345 : 345;
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                var onRowClick = function onRowClick(rowIdx, row) {
	                    if (rowIdx != -1) {
	                        var rows = getRows();
	                        rows.map(function (row) {
	                            row.isSelected = false;
	                        });
	                        rows[rowIdx].isSelected = true;
	                        _this2.setState({ rows: rows, selectedRows: [rows[rowIdx]] });
	                        _this2.props.fetchPurchaseOrderList(row.PurchaseOrder_id);
	                    }
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this2.setState(state);
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this2.state.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    _this2.setState({ filters: newFilters });
	                };
	
	                var onClearFilters = function onClearFilters() {
	                    //all filters removed
	                    _this2.setState({ filters: {} });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    _this2.setState({ selectedRows: rows });
	                };
	
	                //Custom Formatter component
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNameFormatter = _react2.default.createClass({
	                    displayName: 'VendorNameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNumFormatter = _react2.default.createClass({
	                    displayName: 'VendorNumFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.VendorNum
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var onRowsSelected = function onRowsSelected(rows) {
	                    var newRows = getRows();
	                    var selectedRows = [newRows[rows[0].rowIdx]];
	                    newRows.map(function (r) {
	                        r.isSelected = false;
	                    });
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = true;
	                    });
	                    _this2.setState({ rows: newRows, selectedRows: selectedRows });
	                };
	                var onRowsDeselected = function onRowsDeselected(rows) {
	                    var rowIndexes = rows.map(function (r) {
	                        return r.rowIdx;
	                    });
	                    var newRows = [].concat(_toConsumableArray(_this2.state.rows));
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = false;
	                    });
	                    _this2.setState({ rows: newRows, selectedRows: [] });
	                };
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'PONum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'VendorNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_no' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'VendorName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_name' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'FinalPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'OrderDate',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_date' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120,
	                    filterable: true,
	                    formatter: DateFormatter
	                }, {
	                    key: 'ETADate',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'eta_date' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120,
	                    filterable: true,
	                    formatter: DateFormatter
	                }, {
	                    key: 'ShippingCost',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_cost' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120,
	                    filterable: true
	                }, {
	                    key: 'MiscCost',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'misc_cost' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'ShipTo',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipto' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 75,
	                    filterable: true
	                }, {
	                    key: 'PurchaseStatus',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 65,
	                    filterable: true
	                }, {
	                    key: 'UpdateTime',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'update_time' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120,
	                    filterable: true,
	                    formatter: DateFormatter
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'PurchaseQuoteList-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'PurchaseOrder_id',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                onClearFilters: onClearFilters,
	                                columns: columns,
	                                rowHeight: 25,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: tableHeight,
	                                enableRowSelect: 'single',
	                                onRowUpdated: this.handleRowUpdated,
	                                rowSelection: {
	                                    showCheckbox: true,
	                                    onRowsSelected: onRowsSelected,
	                                    onRowsDeselected: onRowsDeselected,
	                                    selectBy: {
	                                        isSelectedKey: 'isSelected'
	                                    }
	                                },
	                                onRowClick: onRowClick
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderProductsTable',
	        value: function renderProductsTable() {
	            var _this3 = this;
	
	            if (this.props.purchaseOrderListIsLoading && !this.props.purchaseOrderListError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.purchaseOrderListError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.purchaseOrderListError)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var tableHeight = window.innerHeight < 900 ? 225 : 225;
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.purchaseQuoteDetail);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this3.state.purchaseQuoteDetail, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this3.setState({ purchaseQuoteDetail: state });
	                };
	
	                var onClearFilters = function onClearFilters() {
	                    //all filters removed
	                    var purchaseQuoteDetail = _extends({}, _this3.state.purchaseQuoteDetail, { filters: {} });
	                    _this3.setState({ purchaseQuoteDetail: purchaseQuoteDetail });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this3.state.purchaseQuoteDetail.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var purchaseQuoteDetail = _extends({}, _this3.state.purchaseQuoteDetail, { filters: newFilters });
	                    _this3.setState({ purchaseQuoteDetail: purchaseQuoteDetail });
	                };
	
	                //Custom Formatter component
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNameFormatter = _react2.default.createClass({
	                    displayName: 'VendorNameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNumFormatter = _react2.default.createClass({
	                    displayName: 'VendorNumFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.VendorNum
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column definition
	
	                var columns = [{
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100
	                }, {
	                    key: 'Name',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                    resizable: true,
	                    sortable: true
	                }, {
	                    key: 'Description',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                    resizable: true,
	                    sortable: true
	                }, {
	                    key: 'Quantity',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	                    resizable: true,
	                    width: 40,
	                    sortable: true
	                }, {
	                    key: 'PackageType',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	                    resizable: true,
	                    width: 80,
	                    sortable: true
	                }, {
	                    key: 'FOBUnitPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	                    resizable: true,
	                    width: 70,
	                    sortable: true
	                }, {
	                    key: 'TotalPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	                    resizable: true,
	                    width: 80,
	                    sortable: true
	                }];
	
	                // React Table Purchase Quote Table
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'recat-customizer', id: 'PurchaseQuoteList-dataGrid2' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'SalesOrder_id' //Should be PO ID???
	                                , onGridSort: handleGridSort,
	                                onAddFilter: handleFilterChange,
	                                onClearFilters: onClearFilters,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                rowHeight: 25,
	                                minHeight: tableHeight,
	                                onRowUpdated: this.handleRowUpdated
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'checkPermission',
	        value: function checkPermission(permission) {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var createAPurchaseQuote = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_a_purchase_quote' });
	            var createDialogStyle = {
	                width: '400px',
	                marginLeft: '-10%'
	            };
	            var height = (this.state.tableHeight * 2 / 3 + 70).toString();
	            var tableCollapseFix = { height: height };
	            var detailsTableHeight = (this.state.tableHeight / 2.5 + 45).toString();
	            var detailsTableCollapseFix = { height: detailsTableHeight };
	            return (
	                //---------------
	                // Begin HTML
	                //---------------
	                _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_management' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            { active: 'true' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_quote' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Grid,
	                        { id: 'purchase-quote-list' },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_quote_full_table' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { className: 'position-relative table-collapse-fix' },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.ButtonToolbar,
	                                        { className: 'table-buttons' },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            {
	                                                bsStyle: 'success',
	                                                type: 'submit',
	                                                onClick: this.openCreate,
	                                                disabled: this.checkPermission("add_purchase_order") },
	                                            _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            {
	                                                bsStyle: 'warning',
	                                                type: 'button',
	                                                onClick: function onClick(event) {
	                                                    _this4.setCurrentPurchaseQuote(event);
	                                                },
	                                                disabled: !this.state.selectedRows || this.state.selectedRows.length != 1 },
	                                            _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            {
	                                                bsStyle: 'danger',
	                                                type: 'reset',
	                                                onClick: function onClick(event) {
	                                                    _this4.deletePurchaseQuote(event);
	                                                },
	                                                disabled: !this.state.selectedRows || this.state.selectedRows.length != 1 },
	                                            _react2.default.createElement('em', { className: 'fa fa-trash-o' }),
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                                        )
	                                    ),
	                                    this.renderTable()
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                    'h2',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_quote_details' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { className: 'details-table-collapse-fix' },
	                                    this.renderProductsTable()
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactSkylight.SkyLightStateless,
	                        { dialogStyles: createDialogStyle, isVisible: this.state.createOpen, onCloseClicked: function onCloseClicked() {
	                                _this4.closeCreate();
	                            }, title: createAPurchaseQuote },
	                        _react2.default.createElement(_purchaseQuoteModal2.default, { closeC: this.closeCreate })
	                    )
	                )
	                //---------------
	                // End HTML
	                //---------------
	
	            );
	        }
	    }]);
	
	    return PurchaseQuoteList;
	}(_react.Component);
	
	PurchaseQuoteList.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = PurchaseQuoteList;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(PurchaseQuoteList, 'PurchaseQuoteList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseQuoteList.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseQuoteList.jsx');
	}();

	;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PurchaseQuoteModal = function (_Component) {
	    _inherits(PurchaseQuoteModal, _Component);
	
	    function PurchaseQuoteModal() {
	        _classCallCheck(this, PurchaseQuoteModal);
	
	        return _possibleConstructorReturn(this, (PurchaseQuoteModal.__proto__ || Object.getPrototypeOf(PurchaseQuoteModal)).apply(this, arguments));
	    }
	
	    _createClass(PurchaseQuoteModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.fetchPurchaseTemplates();
	        }
	    }, {
	        key: 'handleFormSubmit',
	        value: function handleFormSubmit(formProps) {
	            if (formProps.PurchaseTemplate_id) {
	                this.setPurchaseTemplate(formProps.PurchaseTemplate_id.value);
	            } else {
	                this.props.resetCurrentPurchaseTemplate();
	                this.props.resetCurrentPurchaseQuote();
	                this.context.router.push('purchaseQuote/new');
	            }
	        }
	    }, {
	        key: 'setPurchaseTemplate',
	        value: function setPurchaseTemplate(id) {
	            var _props = this.props,
	                resetCurrentPurchaseTemplate = _props.resetCurrentPurchaseTemplate,
	                resetCurrentPurchaseQuote = _props.resetCurrentPurchaseQuote,
	                purchaseTemplates = _props.purchaseTemplates,
	                selectPurchaseTemplate = _props.selectPurchaseTemplate;
	
	            resetCurrentPurchaseTemplate();
	            resetCurrentPurchaseQuote();
	            if (id) {
	                var index = _lodash2.default.findIndex(purchaseTemplates, { 'PurchaseTemplate_id': id });
	                selectPurchaseTemplate(purchaseTemplates[index]);
	                // this.context.router.push('/purchaseQuote/'+purchaseTemplates[index].PurchaseTemplate_id);
	            }
	            this.context.router.push('/purchaseQuote/new');
	        }
	    }, {
	        key: 'renderPurchaseTemplates',
	        value: function renderPurchaseTemplates() {
	            if (this.props.isLoading) return _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 12, className: 'marginTopStyle' },
	                _react2.default.createElement(_spinner2.default, null)
	            ); // If group is loading, show a spinner.
	            else {
	                    var purchaseTemplateOptions = this.getPurchaseTemplateOptions();
	                    return _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12, className: 'marginTopStyle' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'centerStyle' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_select_a_purchase_template' })
	                        ),
	                        _react2.default.createElement(_reduxForm.Field, { name: 'PurchaseTemplate_id', component: _selection2.default, options: purchaseTemplateOptions })
	                    );
	                }
	        }
	    }, {
	        key: 'getPurchaseTemplateOptions',
	        value: function getPurchaseTemplateOptions() {
	            var purchaseTemplateOptions = [{ value: '', label: "Start With Scratch" }];
	            this.props.purchaseTemplates.map(function (purchaseTemplate) {
	                purchaseTemplateOptions.push({ value: purchaseTemplate.PurchaseTemplate_id, label: purchaseTemplate.Name });
	            });
	            return purchaseTemplateOptions;
	        }
	
	        // Once User choose a Template, show him some detail
	
	    }, {
	        key: 'renderTemplateDetail',
	        value: function renderTemplateDetail(id) {
	            var purchaseTemplates = this.props.purchaseTemplates;
	
	            var index = _lodash2.default.findIndex(purchaseTemplates, { 'PurchaseTemplate_id': id });
	            if (index > -1) {
	                var name = purchaseTemplates[index].Name;
	                var vendorName = purchaseTemplates[index].Vendor_id__Name;
	                var updateTime = purchaseTemplates[index].updateTime;
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_template_no' }),
	                            ': ',
	                            name
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_name' }),
	                            ': ',
	                            vendorName
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'update_time' }),
	                            ': ',
	                            updateTime
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                handleSubmit = _props2.handleSubmit,
	                closeC = _props2.closeC,
	                submitting = _props2.submitting,
	                pristine = _props2.pristine,
	                purchaseTemplateValue = _props2.purchaseTemplateValue;
	
	            return _react2.default.createElement(
	                'form',
	                { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    this.renderPurchaseTemplates()
	                ),
	                purchaseTemplateValue && this.renderTemplateDetail(purchaseTemplateValue.value),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { action: 'submit', className: 'btn btn-primary col-sm-11 buttonStyle', disabled: submitting },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_purchase_template' })
	                    )
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-danger col-sm-11 buttonStyle', onClick: function onClick(event) {
	                                event.preventDefault();closeC();
	                            } },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PurchaseQuoteModal;
	}(_react.Component);
	
	PurchaseQuoteModal.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = PurchaseQuoteModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(PurchaseQuoteModal, 'PurchaseQuoteModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseQuoteModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseQuoteModal.jsx');
	}();

	;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reduxForm = __webpack_require__(3);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _PrintIframe = __webpack_require__(63);
	
	var _PrintIframe2 = _interopRequireDefault(_PrintIframe);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _root_url = __webpack_require__(9);
	
	var _cleanDates = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import {buttonStyle} from '../Common/style'
	var BackgroundColorFormatter = _react2.default.createClass({
	  displayName: 'BackgroundColorFormatter',
	  render: function render() {
	    if (this.props.value <= 0) {
	      console.log(this.props.value);
	      return _react2.default.createElement(
	        'div',
	        { style: { backgroundColor: '#2196F3' } },
	        this.props.value
	      );
	    } else if (this.props.value < 1) return _react2.default.createElement(
	      'div',
	      { style: { backgroundColor: '#F44336' } },
	      this.props.value
	    );else if (this.props.value < 3) return _react2.default.createElement(
	      'div',
	      { style: { backgroundColor: '#FFC107' } },
	      this.props.value
	    );else if (this.props.value > 7) return _react2.default.createElement(
	      'div',
	      { style: { backgroundColor: '#4CAF50' } },
	      this.props.value
	    );else if (this.props.value == 'Check') return _react2.default.createElement(
	      'div',
	      { style: { backgroundColor: '#1976D2' } },
	      this.props.value
	    );
	    return _react2.default.createElement(
	      'div',
	      { className: 'react-grid-Cell' },
	      this.props.value
	    );
	  }
	});
	
	var LeftWeeksFormatter = _react2.default.createClass({
	  displayName: 'LeftWeeksFormatter',
	  render: function render() {
	    if (this.props.value < 0) return _react2.default.createElement(
	      'div',
	      { style: { backgroundColor: '#F44336' } },
	      this.props.value
	    );
	    return _react2.default.createElement(
	      'div',
	      null,
	      this.props.value
	    );
	  }
	});
	
	var PurchaseReferenceReport = function (_Component) {
	  _inherits(PurchaseReferenceReport, _Component);
	
	  function PurchaseReferenceReport() {
	    _classCallCheck(this, PurchaseReferenceReport);
	
	    var _this = _possibleConstructorReturn(this, (PurchaseReferenceReport.__proto__ || Object.getPrototypeOf(PurchaseReferenceReport)).call(this));
	
	    _this.handlePrintFrameOnLoad = function () {
	      _this.setState({ referencePdfFrameLoaded: true });
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.customersPage,
	
	      purchaseReference: {
	        allrows: [],
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null,
	        columns: [{}]
	      },
	      currentGroup: null,
	      currentCategory: null,
	      clear: true,
	      groupExpanded: false,
	      currentButton: null,
	      referencePdfFrameLoaded: true
	    };
	    _this.handleResize = _this.handleResize.bind(_this);
	    return _this;
	  }
	
	  _createClass(PurchaseReferenceReport, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.setDefaultOfForm('typeRadios', 'week', 'purchaseReferenceReport');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.handleResize);
	      this.props.fetchGroups();
	      // this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.purchaseReferenceReport && nextProps.purchaseReferenceReport != this.props.purchaseReferenceReport) {
	        var product_lines = [].concat(_toConsumableArray(nextProps.purchaseReferenceReport.Product_Lines));
	        var date1 = nextProps.purchaseReferenceReport.Date1;
	        var date2 = nextProps.purchaseReferenceReport.Date2;
	        var date3 = nextProps.purchaseReferenceReport.Date3;
	        var column = void 0;
	        product_lines.map(function (line) {
	          line.LeftWeeks = line.AverageSale ? ((line.Inventory__InStock - line.AverageSale) / line.AverageSale).toFixed(2) : 0;
	        });
	        if (this.props.typeRadios == 'week') {
	          column = [{
	            key: 'ProductNum',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	            resizable: true,
	            sortable: true,
	            width: 70,
	            filterable: true
	          }, {
	            key: 'RefNum',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	            resizable: true,
	            sortable: true,
	            width: 70,
	            filterable: true
	          }, {
	            key: 'Name',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	            resizable: true,
	            sortable: true,
	            width: 250,
	            filterable: true
	          }, {
	            key: 'Description',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	            resizable: true,
	            sortable: true,
	            width: 150,
	            filterable: true
	          }, {
	            key: 'FourWeeksSale',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: '4_wks_sale' }),
	            resizable: true,
	            sortable: true,
	            width: 70,
	            filterable: true
	          }, {
	            key: 'Inventory__InStock',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'in_stock' }),
	            resizable: true,
	            sortable: true,
	            width: 60,
	            filterable: true
	          }, {
	            key: 'WeeklySale',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'wk_sale' }),
	            resizable: true,
	            sortable: true,
	            width: 60,
	            filterable: true
	          }, {
	            key: 'StockLeftAfterOneWeek',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'stock_left_after_1_week' }),
	            resizable: true,
	            sortable: true,
	            width: 100,
	            filterable: true,
	            formatter: LeftWeeksFormatter
	          }, {
	            key: 'WeeksLeftAfterOneWeek',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weeks_left_after_1_week' }),
	            resizable: true,
	            sortable: true,
	            width: 100,
	            filterable: true,
	            formatter: LeftWeeksFormatter
	          }, {
	            key: 'Inventory__Purchased',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchased' }),
	            resizable: true,
	            sortable: true,
	            width: 100,
	            filterable: true
	          }];
	        } else {
	          column = [{
	            key: 'ProductNum',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	            resizable: true,
	            sortable: true,
	            width: 70,
	            filterable: true
	          }, {
	            key: 'RefNum',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	            resizable: true,
	            sortable: true,
	            width: 70,
	            filterable: true
	          }, {
	            key: 'Name',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	            resizable: true,
	            sortable: true,
	            width: 200,
	            filterable: true
	          }, {
	            key: 'Description',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	            resizable: true,
	            sortable: true,
	            width: 130,
	            filterable: true
	          }, {
	            key: 'ThreeDaysSale',
	            // name: <Translate value="daily_sale" />,
	            name: '3 Days Sale',
	            resizable: true,
	            sortable: true,
	            width: 60,
	            filterable: true
	          }, {
	            key: 'Inventory__InStock',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'in_stock' }),
	            resizable: true,
	            sortable: true,
	            width: 60,
	            filterable: true
	          }, {
	            key: 'DailySale',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'daily_sale' }),
	            resizable: true,
	            sortable: true,
	            width: 60,
	            filterable: true
	          }, {
	            key: 'Day1',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: date1 }),
	            resizable: true,
	            sortable: true,
	            width: 60,
	            filterable: true
	          }, {
	            key: 'Day2',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: date2 }),
	            resizable: true,
	            sortable: true,
	            width: 60,
	            filterable: true
	          }, {
	            key: 'Day3',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: date3 }),
	            resizable: true,
	            sortable: true,
	            width: 60,
	            filterable: true
	          }, {
	            key: 'StockLeftAfterOneDay',
	            // name: <Translate value="week_left" />,
	            name: 'Stock Left After 1 Day',
	            resizable: true,
	            sortable: true,
	            width: 100,
	            filterable: true,
	            formatter: LeftWeeksFormatter
	          }, {
	            key: 'DaysLeftAfterOneDay',
	            // name: <Translate value="week_left" />,
	            name: 'Days Left After 1 Day',
	            resizable: true,
	            sortable: true,
	            width: 100,
	            filterable: true,
	            formatter: LeftWeeksFormatter
	          }, {
	            key: 'Inventory__Purchased',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchased' }),
	            resizable: true,
	            sortable: true,
	            width: 100,
	            filterable: true
	          }];
	        }
	        var purchaseReference = _extends({}, this.state.purchaseReference, { rows: product_lines, allrows: product_lines, columns: column
	        });
	        this.setState({ purchaseReference: purchaseReference });
	      }
	
	      if (nextProps.typeRadios && nextProps.typeRadios != this.props.typeRadios) {
	        var group = this.state.currentGroup;
	        var category = this.state.currentCategory;
	
	        if (group == -1 && category == -1) {
	          group = null;
	          category = null;
	        } else if (category == -1) {
	          category = null;
	        } else if (category) {
	          group = null;
	        }
	        this.props.fetchPurchasingReference('show', nextProps.typeRadios, group, category);
	      }
	
	      if (nextProps.groups && nextProps.groups != this.props.groups) {
	        var productGroup_id = nextProps.groups[0].ProductGroup_id;
	        this.setState({ currentGroup: productGroup_id });
	        this.props.fetchPurchasingReference('show', this.props.typeRadios, productGroup_id, null);
	      }
	
	      if (nextProps.purchaseReferencePdf && nextProps.purchaseReferencePdf !== this.props.purchaseReferencePdf) {
	        this.setState({ referencePdfFrameLoaded: false });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var productGroup_id = this.state.currentGroup;
	      var productCategory_id = this.state.currentCategory;
	      var groups = document.getElementsByName('group');
	      var i = 0;
	      for (; i < groups.length; i++) {
	        if (groups[i].id != 'g' + productGroup_id) {
	          groups[i].style.backgroundColor = null;
	        } else {
	          groups[i].style.backgroundColor = _constants.APP_COLORS['active-category-background-nav'];
	        }
	      }
	      var categories = document.getElementsByName('category');
	      i = 0;
	      if (categories) {
	        for (; i < categories.length; i++) {
	          if (categories[i].id != 'c' + productCategory_id) {
	            categories[i].style.backgroundColor = null;
	          } else {
	            categories[i].style.backgroundColor = _constants.APP_COLORS['active-category-background-nav'];
	          }
	        }
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState.referencePdfFrameLoaded !== this.state.referencePdfFrameLoaded && this.state.referencePdfFrameLoaded === false) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.customersPage });
	    }
	  }, {
	    key: 'fetchPurchasingReference',
	    value: function fetchPurchasingReference() {
	      var group = this.state.currentGroup;
	      var category = this.state.currentCategory;
	      if (group == -1 && category == -1) {
	        group = null;
	        category = null;
	      } else if (category == -1) {
	        category = null;
	      } else if (category) {
	        group = null;
	      }
	      this.props.fetchPurchasingReference('show', this.props.typeRadios, group, category);
	    }
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this2 = this;
	
	      if (this.props.purchaseReferenceReportIsLoading && !this.props.purchaseReferenceReportError) {
	        return _react2.default.createElement(
	          'div',
	          { id: 'spinner' },
	          _react2.default.createElement(_spinner2.default, null)
	        );
	      } else if (this.props.purchaseReferenceReportError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.purchaseReferenceReportError)
	          )
	        );
	      }
	
	      // Parameters of the react-data-grid
	
	      var tableHeight = window.innerHeight < 930 ? 645 : 645;
	
	      var getRows = function getRows() {
	        return (
	          // console.log(this.state)
	          _reactDataGridAddons.Data.Selectors.getRows(_this2.state.purchaseReference)
	        );
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var purchaseReference = Object.assign({}, _this2.state.purchaseReference, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this2.setState({ purchaseReference: purchaseReference });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this2.state.purchaseReference.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var purchaseReference = _extends({}, _this2.state.purchaseReference, { filters: newFilters });
	
	        _this2.setState({ purchaseReference: purchaseReference });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        var purchaseReference = _extends({}, _this2.state.purchaseReference, { filters: {}, rows: _this2.props.purchaseReferenceReport.purchaseReference });
	        _this2.setState({ purchaseReference: purchaseReference });
	      };
	
	      // Custom Formatter component
	      // const BackgroundColorFormatter = React.createClass({
	      //       render() {
	      //             if (this.props.value <= 0) {
	      //                console.log(this.props.value)
	      //                return (<div style={{backgroundColor:"#2196F3"}}>{this.props.value}</div>)
	      //              }
	      //             else if (this.props.value < 1) return <div style={{backgroundColor:"#F44336"}}>{this.props.value}</div>;
	      //             else if (this.props.value < 3 ) return <div style={{backgroundColor:"#FFC107"}}>{this.props.value}</div>;
	      //             else if (this.props.value > 7 ) return <div style={{backgroundColor:"#4CAF50"}}>{this.props.value}</div>;
	      //             else if (this.props.value == 'Check' ) return <div style={{backgroundColor:"#1976D2"}}>{this.props.value}</div>;
	      //             else return <div className="react-grid-Cell">{this.props.value}</div>;
	      //           }
	      //     });
	
	      // Column difinition
	
	      return (
	        // React Table Inventory List
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { className: 'react-table-purchasing-reference', id: 'purchaseReference-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                enableCellSelect: true,
	                rowHeight: 25,
	                headerRowHeight: 65,
	                onGridSort: handleGridSort,
	                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                onAddFilter: handleFilterChange,
	                onClearFilters: onClearFilters,
	                columns: this.state.purchaseReference.columns,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                minHeight: tableHeight
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'handleClickButton',
	    value: function handleClickButton(value) {
	      var currentButton = this.state.currentButton;
	      var allrows = [].concat(_toConsumableArray(this.state.purchaseReference.allrows));
	      var rows = [];
	      if (currentButton && currentButton == value) {
	        rows = allrows;
	      } else {
	        rows = allrows.filter(function (r) {
	          return r.StockLevel == value;
	        });
	        currentButton = value;
	      }
	      var purchaseReference = _extends({}, this.state.purchaseReference, { rows: rows });
	      this.setState({ purchaseReference: purchaseReference, currentButton: currentButton });
	    }
	  }, {
	    key: 'handleClickCategory',
	    value: function handleClickCategory(id) {
	      this.props.fetchPurchasingReference('show', this.props.typeRadios, null, id);
	      this.setState({ currentCategory: id });
	    }
	  }, {
	    key: 'renderCategories',
	    value: function renderCategories(group_id) {
	      var _this3 = this;
	
	      if (!this.props.groupCategories) {
	        return;
	      }
	      var groupCategories = this.props.groupCategories;
	      var description = void 0;
	      if (localStorage.getItem('lang') == 'ch') {
	        description = 'Description';
	      } else if (localStorage.getItem('lang') == 'en') {
	        description = 'Name';
	      }
	      if (this.state.currentGroup == group_id && this.state.groupExpanded) {
	        return groupCategories.map(function (category) {
	          return _react2.default.createElement(
	            'li',
	            { className: 'clickListLi', style: { color: _constants.APP_COLORS['sub-category-nav'], fontFamily: 'Arial' }, name: 'category', id: 'c' + category.ProductCategory_id, onClick: _this3.handleClickCategory.bind(_this3, category.ProductCategory_id) },
	            _react2.default.createElement(
	              'label',
	              { style: { fontWeight: 'bold' } },
	              category.CategoryNum
	            ),
	            ' ' + category[description]
	          );
	        });
	      }
	    }
	  }, {
	    key: 'handleClickGroup',
	    value: function handleClickGroup(group, id) {
	      var groupExpanded = this.state.groupExpanded;
	      if (group && this.state.currentGroup == group.ProductGroup_id) {
	        this.setState({ groupExpanded: !groupExpanded });
	        if (!groupExpanded) {
	          this.setState({ currentCategory: -1 });
	          this.props.fetchPurchasingReference('show', this.props.typeRadios, this.state.currentGroup, null);
	          this.props.fetchGroupCategories(group.ProductGroup_id);
	        }
	      } else if (group) {
	        this.setState({ currentGroup: group.ProductGroup_id, groupExpanded: true, currentCategory: -1 });
	        this.props.fetchPurchasingReference('show', this.props.typeRadios, group.ProductGroup_id, null);
	        this.props.fetchGroupCategories(group.ProductGroup_id);
	      } else {
	        this.setState({ currentGroup: -1, currentCategory: -1 });
	        this.props.fetchPurchasingReference('show', this.props.typeRadios, null, null);
	      }
	    }
	  }, {
	    key: 'renderGroups',
	    value: function renderGroups() {
	      var _this4 = this;
	
	      if (!this.props.groups) return;
	      var groups = this.props.groups;
	      return groups.map(function (group) {
	        var GroupNum = parseInt(group.GroupNum);
	        if (GroupNum < 10) GroupNum = '0' + GroupNum;
	        var description = void 0;
	        if (localStorage.getItem('lang') == 'ch') {
	          description = 'Description';
	        } else if (localStorage.getItem('lang') == 'en') {
	          description = 'Name';
	        }
	        return _react2.default.createElement(
	          _reactBootstrap.Panel,
	          { className: 'panelStyle' },
	          _react2.default.createElement(
	            'div',
	            { className: 'category-nav-item', name: 'group', id: 'g' + group.ProductGroup_id, onClick: _this4.handleClickGroup.bind(_this4, group, 'g' + group.ProductGroup_id) },
	            _react2.default.createElement(
	              'label',
	              null,
	              GroupNum
	            ),
	            ' ',
	            ' ' + group[description]
	          ),
	          _this4.renderCategories(group.ProductGroup_id)
	        );
	      });
	    }
	  }, {
	    key: 'renderPrintIframe',
	    value: function renderPrintIframe() {
	      var referencePdfFrameLoaded = this.state.referencePdfFrameLoaded;
	      var purchaseReferencePdf = this.props.purchaseReferencePdf;
	
	      return _react2.default.createElement(_PrintIframe2.default, {
	        id: 'referencePDF',
	        loaded: referencePdfFrameLoaded,
	        name: 'referencePDF',
	        onLoad: this.handlePrintFrameOnLoad,
	        pdf: purchaseReferencePdf,
	        title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_purchase_reference' })
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var typeradio = this.props.typeRadios;
	      var group = this.state.currentGroup;
	      var category = this.state.currentCategory;
	      var height = (this.state.tableHeight + 70).toString();
	      var tableCollapseFix = { height: height };
	      if (group == -1 && category == -1) {
	        group = null;
	        category = null;
	      } else if (category == -1) {
	        category = null;
	      } else if (category) {
	        group = null;
	      }
	
	      var _getFromToDates = (0, _cleanDates.getFromToDates)((0, _moment2.default)()),
	          endTime = _getFromToDates.toDate;
	      // if (group) {
	      //   group = `ProductGroup_id=${group}`;
	      // } else {
	      //   group = '';
	      // }
	      // if (category) {
	      //   category = `ProductCategory1_id=${category}`;
	      // } else {
	      //   category = '';
	      // }
	      // const print_url = `${ROOT_URL}v1/purchase/referenceguide/print/${
	      //   typeradio}/?${group}${category
	      // }&Bearer=${localStorage.getItem('token')}`;
	
	
	      var excel_url = _root_url.ROOT_URL + 'v1/purchase/referenceguide/excel/' + typeradio + '/?' + (group ? 'ProductGroup_id=' + group : '') + (category ? 'ProductCategory1_id=' + category : '') + '&end_time=' + endTime + '&Bearer=' + localStorage.getItem('token');
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_reference' })
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            null,
	            _react2.default.createElement(_SpinnerButton2.default, {
	              bsStyle: 'primary',
	              disabled: this.props.requestingPurchaseReferencePdf || !(0, _permissions2.default)('print_purchase_reference'),
	              icon: 'fa-print',
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' }),
	              loading: this.props.requestingPurchaseReferencePdf,
	              onClick: function onClick() {
	                _this5.props.printPurchaseReference({ typeradio: typeradio, group: group, category: category, endTime: endTime });
	              }
	            }),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'success',
	                href: excel_url,
	                disabled: !(0, _permissions2.default)('print_purchase_reference')
	              },
	              _react2.default.createElement('em', { className: 'fa fa-download' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'purchase-reference-page' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 2 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { id: 'category-nav', className: 'panelStyle' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { className: 'panelStyle' },
	                    _react2.default.createElement(
	                      'div',
	                      { style: { color: _constants.APP_COLORS['category-nav'], fontWeight: 'bold', cursor: 'pointer' }, name: 'group', id: 'g-1', onClick: this.handleClickGroup.bind(this, null, '-1') },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' })
	                    )
	                  ),
	                  this.renderGroups()
	                )
	              ),
	              ' ',
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 10 },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Panel,
	                      { className: 'position-relative table-collapse-fix mb0' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'table-filters' },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'typeRadios', component: renderTypeRadios })
	                      ),
	                      this.renderTable()
	                    )
	                  )
	                )
	              ),
	              ' '
	            )
	          ),
	          this.renderPrintIframe()
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return PurchaseReferenceReport;
	}(_react.Component);
	
	var renderTypeRadios = function renderTypeRadios(props) {
	  var titleClass = (0, _classnames2.default)({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'col-xs-4');
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group' },
	    _react2.default.createElement(
	      'label',
	      { className: titleClass },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'week',
	        checked: props.input.value === 'week'
	      })),
	      _react2.default.createElement(
	        'span',
	        { style: { 'font-size': '20px' } },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_week' })
	      )
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: titleClass },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'day',
	        checked: props.input.value === 'day'
	      })),
	      _react2.default.createElement(
	        'span',
	        { style: { 'font-size': '20px' } },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_3_days' })
	      )
	    )
	  );
	};
	
	var _default = PurchaseReferenceReport;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(BackgroundColorFormatter, 'BackgroundColorFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseReference.jsx');
	
	  __REACT_HOT_LOADER__.register(LeftWeeksFormatter, 'LeftWeeksFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseReference.jsx');
	
	  __REACT_HOT_LOADER__.register(PurchaseReferenceReport, 'PurchaseReferenceReport', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseReference.jsx');
	
	  __REACT_HOT_LOADER__.register(renderTypeRadios, 'renderTypeRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseReference.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseReference.jsx');
	}();

	;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _moment3 = __webpack_require__(41);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	__webpack_require__(69);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _selection = __webpack_require__(21);
	
	var _inputField = __webpack_require__(16);
	
	var _datePicker = __webpack_require__(27);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _vendorBatches = __webpack_require__(598);
	
	var _vendorBatches2 = _interopRequireDefault(_vendorBatches);
	
	var _setWeightModal = __webpack_require__(74);
	
	var _setWeightModal2 = _interopRequireDefault(_setWeightModal);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _PrintIframe = __webpack_require__(63);
	
	var _PrintIframe2 = _interopRequireDefault(_PrintIframe);
	
	var _GenericProductSuggest = __webpack_require__(51);
	
	var _GenericProductSuggest2 = _interopRequireDefault(_GenericProductSuggest);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isLO = _root_url.ROOT_API_URL === 'https://lonni-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://lonni-scm.truckxi.com/api/';
	
	(0, _moment4.default)(_moment2.default);
	
	function roundTo(n, digits) {
	  if (digits === undefined) {
	    digits = 0;
	  }
	
	  var multiplicator = Math.pow(10, digits);
	  n = parseFloat((n * multiplicator).toFixed(11));
	  var test = Math.round(n) / multiplicator;
	  return +test.toFixed(2);
	}
	
	var PurchaseReturnForm = function (_Component) {
	  _inherits(PurchaseReturnForm, _Component);
	
	  function PurchaseReturnForm() {
	    _classCallCheck(this, PurchaseReturnForm);
	
	    var _this = _possibleConstructorReturn(this, (PurchaseReturnForm.__proto__ || Object.getPrototypeOf(PurchaseReturnForm)).call(this));
	
	    _this.handleOptionChange = function (changeEvent) {
	      _this.setState({ productSearchType: changeEvent.target.value });
	    };
	
	    _this.closeSetWeight = function () {
	      _this.setState({ setWeightOpen: false });
	    };
	
	    _this.openSetWeight = function () {
	      _this.setState({ setWeightOpen: true });
	    };
	
	    _this.setWeights = function (currentRow, currentWeights) {
	      var Weights = [];
	      currentWeights.map(function (row) {
	        Weights.push(+roundTo(parseFloat(row.Weight), 2).toFixed(2));
	      });
	      var rows = [].concat(_toConsumableArray(_this.state.rows));
	      rows[currentRow].Weights = Weights;
	      _this.setState({ rows: rows });
	    };
	
	    _this.keepLoaded = function (oldLoaded) {
	      var rows = [].concat(_toConsumableArray(_this.state.rows));
	      rows[_this.state.currentRow].Rtn_Quantity = oldLoaded;
	      _this.setState({ rows: rows });
	    };
	
	    _this.handlePrintFrameOnLoad = function () {
	      _this.setState({ returnPDFFrameLoaded: true });
	    };
	
	    _this.handleFormSubmit = function (formProps) {
	      _this.setState({ dirty: false });
	      // creating new
	      if (!_this.props.currentPurchaseReturn) {
	        _this.props.createPurchaseReturn(formProps, _reactDataGridAddons.Data.Selectors.getRows(_this.state), _this.state.isPurchaseCreditMode);
	      }
	
	      // editing existing
	      else {
	          if (!_this.checkPermission("change_purchase_return")) _this.props.editPurchaseReturn(formProps, _reactDataGridAddons.Data.Selectors.getRows(_this.state));else alert("You have no permission!");
	        }
	    };
	
	    _this.completePurchaseReturn = function () {
	      _this.props.completePurchaseReturn(_this.props.currentPurchaseReturnDetail.PurchaseReturn_id);
	    };
	
	    _this.handleSearchTypeChange = function (e) {
	      _this.props.setDefaultOfForm(e.target.name, e.target.value, _this.props.form);
	      _this.setState({ productSearchType: e.target.value });
	    };
	
	    _this.renderTypeRadios = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-group', id: 'search-product-by' },
	        _react2.default.createElement(
	          'label',
	          { className: 'col-xs-3 search-by-max-width' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'search_by' })
	        ),
	        _react2.default.createElement(
	          'label',
	          { className: 'col-xs-2' },
	          _react2.default.createElement('input', { type: 'radio', value: 'ProductNum', name: 'SearchType', onClick: _this.handleSearchTypeChange,
	            checked: _this.props.searchType === 'ProductNum'
	          }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' })
	        ),
	        _react2.default.createElement(
	          'label',
	          { className: 'col-xs-2 pl' },
	          _react2.default.createElement('input', { type: 'radio', value: 'RefNum', name: 'SearchType', onClick: _this.handleSearchTypeChange,
	            checked: _this.props.searchType === 'RefNum'
	          }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' })
	        ),
	        _react2.default.createElement(
	          'label',
	          { className: 'col-xs-2' },
	          _react2.default.createElement('input', { type: 'radio', value: 'Name', name: 'SearchType', onClick: _this.handleSearchTypeChange,
	            checked: _this.props.searchType === 'Name'
	          }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	        ),
	        _react2.default.createElement(
	          'label',
	          { className: 'col-xs-2' },
	          _react2.default.createElement('input', { type: 'radio', value: 'Description', name: 'SearchType', onClick: _this.handleSearchTypeChange,
	            checked: _this.props.searchType === 'Description'
	          }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	        )
	      );
	    };
	
	    _this.state = {
	      isPurchaseCreditMode: false,
	
	      files: null,
	
	      firstRender: false,
	      isCompleted: false,
	
	      totalNetWeight: 0,
	      totalPrice: 0,
	
	      taxValue: 0,
	      discountValue: 0,
	      priceType: 'FOB',
	      finalPrice: 0,
	      miscCostValue: 0,
	      handlingCostValue: 0,
	      shippingCostValue: 0,
	      adjustmentCostValue: 0,
	      // BinAmount: 0,
	      simplifiedProducts: null,
	
	      // defaultRefPrice: 0,
	      // refPrice: 0,
	      // quantity: 0,
	
	      calculatedProducts: [],
	
	      // vendorInformationOpen: true,
	      oneTimeScheduleOpen: true,
	      purchaseInformationOpen: true,
	      showInventoryOpen: false,
	      showVendorBatchesOpen: false,
	
	      dirty: false,
	
	      rows: [],
	      selectedRows: [],
	      filters: {},
	      sortColumn: null,
	      sortDirection: null,
	      selectedInventoryRow: [],
	
	      // Set weights modal
	      setWeightOpen: false,
	      totalLoaded: null,
	      rowChosen: -1,
	      currentWeights: null,
	
	      // Print
	      returnPDFFrameLoaded: true,
	
	      // suggest
	      suggestValue: '',
	      productSearchType: 'RefNum',
	      filteredByItem: false
	    };
	
	    _this.handleMiscCostChange = _this.handleMiscCostChange.bind(_this);
	    _this.handleShippingCostChange = _this.handleShippingCostChange.bind(_this);
	    _this.handleHandlingCostChange = _this.handleHandlingCostChange.bind(_this);
	    _this.handleAdjustmentCostChange = _this.handleAdjustmentCostChange.bind(_this);
	    _this.handleDiscountChange = _this.handleDiscountChange.bind(_this);
	    _this.handleTaxChange = _this.handleTaxChange.bind(_this);
	    _this.handleUnitPriceChange = _this.handleUnitPriceChange.bind(_this);
	    _this.handleQuantityChange = _this.handleQuantityChange.bind(_this);
	    _this.openShowInventory = _this.openShowInventory.bind(_this);
	    _this.closeShowInventory = _this.closeShowInventory.bind(_this);
	    _this.closeShowVendorBatches = _this.closeShowVendorBatches.bind(_this);
	    _this.openShowVendorBatches = _this.openShowVendorBatches.bind(_this);
	    _this.selectInventoryInfo = _this.selectInventoryInfo.bind(_this);
	    _this.handleKeyPressTargetSelection = _this.handleKeyPressTargetSelection.bind(_this);
	    _this.handleKeyPressTargetInput = _this.handleKeyPressTargetInput.bind(_this);
	    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
	    _this.handleKeyPressMove = _this.handleKeyPressMove.bind(_this);
	    _this.handleOnFocus = _this.handleOnFocus.bind(_this);
	    _this.moveOffFromProductsList = _this.moveOffFromProductsList.bind(_this);
	    _this.moveToProductsListFromVendor = _this.moveToProductsListFromVendor.bind(_this);
	    _this.fetchPurchaseOrdersByProduct = _this.fetchPurchaseOrdersByProduct.bind(_this);
	    return _this;
	  }
	
	  _createClass(PurchaseReturnForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // is purchase credit mode
	      if (this.context.router.routes[1].path === 'purchaseReturn/newCredit') {
	        this.setState({
	          isPurchaseCreditMode: true
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // purchase return mode
	      var currentPurchaseReturn = this.props.currentPurchaseReturn;
	
	      if (currentPurchaseReturn) {
	        this.props.fetchPurchaseReturnDetail(currentPurchaseReturn.PurchaseReturn_id, currentPurchaseReturn.Return_PurchaseCompleted_id).then(function () {
	          _this2.props.fetchActiveVendors();
	          _this2.props.fetchPaymentTerms();
	          _this2.props.fetchWarehouses();
	          _this2.props.setDefaultOfForm('SearchType', 'RefNum', 'purchaseReturnForm');
	        });
	      } else {
	        this.props.fetchTaxRates();
	        this.props.fetchActiveVendors();
	        this.props.fetchPaymentTerms();
	        this.props.fetchWarehouses();
	        this.props.setDefaultOfForm('SearchType', 'RefNum', 'purchaseReturnForm');
	        this.props.setDefaultOfForm('PostingDate', new Date(), 'purchaseReturnForm');
	        this.props.setDefaultOfForm('ConvertItemPrice', 'FOB', 'purchaseReturnForm');
	      }
	
	      // making a leaving hook to confirm leaving
	      this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.taxRates && nextProps.taxRates != this.props.taxRates) {
	        this.props.setDefaultOfForm('TaxRate', 0, 'purchaseReturnForm');
	      }
	      if (nextProps.miscCostValue != this.props.miscCostValue) {
	        this.calculatePricesChange(nextProps.miscCostValue || 0, nextProps.handlingCostValue, nextProps.shippingCostValue, nextProps.discount, nextProps.adjustmentCostValue);
	      }
	      if (nextProps.handlingCostValue != this.props.handlingCostValue) {
	        this.calculatePricesChange(nextProps.miscCostValue, nextProps.handlingCostValue || 0, nextProps.shippingCostValue, nextProps.discount, nextProps.adjustmentCostValue);
	      }
	      if (nextProps.adjustmentCostValue != this.props.adjustmentCostValue) {
	        this.calculatePricesChange(nextProps.miscCostValue, nextProps.handlingCostValue, nextProps.shippingCostValue, nextProps.discount, nextProps.adjustmentCostValue || 0);
	      }
	      if (nextProps.shippingCostValue != this.props.shippingCostValue) {
	        this.calculatePricesChange(nextProps.miscCostValue, nextProps.handlingCostValue, nextProps.shippingCostValue || 0, nextProps.discount, nextProps.adjustmentCostValue);
	      }
	      if (nextProps.discount != this.props.discount) {
	        this.calculatePricesChange(nextProps.miscCostValue, nextProps.handlingCostValue, nextProps.shippingCostValue, nextProps.discount || 0, nextProps.adjustmentCostValue);
	      }
	      if (nextProps.dirty != this.props.dirty) {
	        this.setState({
	          dirty: nextProps.dirty
	        });
	      }
	
	      // Once user select a vendor, load its address and contacts.
	      if (nextProps.vendorsValue && nextProps.vendorsValue != this.props.vendorsValue) {
	        if (this.refs.Products && !this.state.firstRender) {
	          this.refs.Products.getRenderedComponent().props.fields.removeAll();
	        }
	        if (nextProps.vendorsValue != null) {
	          this.props.fetchVendorDetail(nextProps.vendorsValue.value || nextProps.vendorsValue);
	          // this.props.fetchVendorInventoryDetail(nextProps.vendorsValue.value || nextProps.vendorsValue);
	        }
	        if (this.state.firstRender) this.state.firstRender = false;
	        if (!this.props.currentPurchaseReturnDetail) {
	          var index = _lodash2.default.findIndex(this.props.vendors, { Vendor_id: nextProps.vendorsValue.value || nextProps.vendorsValue });
	          if (index > -1) {
	            var paymentTerm_id = this.props.vendors[index].PaymentTerm_id;
	            this.props.setDefaultOfForm('PaymentTerm_id', paymentTerm_id, 'purchaseReturnForm');
	          }
	        }
	      }
	
	      // Also, if vendor has been chosen in the template user'll work on, load related products.
	      if (nextProps.currentPurchaseReturnDetail != this.props.currentPurchaseReturnDetail && nextProps.currentPurchaseReturnDetail) {
	        var currentPurchaseReturnDetail = nextProps.currentPurchaseReturnDetail;
	        var newTotalNetWeight = 0;
	        if (currentPurchaseReturnDetail.Purchase_Return_Line != null) {
	          currentPurchaseReturnDetail.Purchase_Return_Line.map(function (line) {
	            line["Name"] = line.Product_id.Name;
	            line["ProductNum"] = line.Product_id.ProductNum;
	            line["Description"] = line.Product_id.Description;
	            line["MeasureUnit"] = line.Product_id.MeasureUnit;
	            line["NetWeight"] = line.Product_id.NetWeight;
	            line['PackageType'] = line.Product_id.PackageType;
	            line['PackageSize'] = line.Product_id.PackageSize;
	            line["TotalNetWeight"] = line.TotalNetWeight;
	            line["RefNum"] = line.Product_id.RefNum;
	            line["ProductUnitOfMeasure"] = line.Product_id.MeasureUnit;
	            line["CRV"] = line.Product_id.CRV;
	            line["WarehouseZone"] = line.ZoneName;
	            line["WarehouseBin"] = line.BinName;
	            line['ProductType'] = line.Product_id.ProductType;
	            line["Product_id"] = line.Product_id.Product_id;
	            newTotalNetWeight += line.TotalNetWeight;
	          });
	          var newTotalPrice = currentPurchaseReturnDetail.TotalPrice;
	          var finalPrice = currentPurchaseReturnDetail.FinalPrice;
	          var taxValue = currentPurchaseReturnDetail.TaxRate;
	          var discountValue = currentPurchaseReturnDetail.Discount;
	          this.setState({
	            rows: currentPurchaseReturnDetail.Purchase_Return_Line,
	            totalNetWeight: newTotalNetWeight,
	            totalPrice: newTotalPrice,
	            finalPrice: finalPrice,
	            taxValue: taxValue,
	            discountValue: discountValue
	          });
	        } else if (currentPurchaseReturnDetail.Purchase_Return_Line_Completed != null) {
	          currentPurchaseReturnDetail.Purchase_Return_Line_Completed.map(function (line) {
	            line["Name"] = line.ProductName;
	            line["Description"] = line.ProductDescription;
	            // line["MeasureUnit"] = line.ProductUnitOfMeasure;
	            // line["NetWeight"] = line.Product_id.NetWeight;
	            // line["TotalNetWeight"] = (line.Product_id.NetWeight)*(line.Rtn_Quantity);
	            line["RefNum"] = line.ProductRefNum;
	            line["CRV"] = line.Product_id.CRV;
	            // line["Product_id"] = line.Product_id.Product_id;
	            // line["WarehouseZone"] = line.WarehouseZone_id.Name;
	            // line["WarehouseBin"] = line.WarehouseBin_id.Name;
	            newTotalNetWeight += line.TotalNetWeight;
	          });
	          var _newTotalPrice = currentPurchaseReturnDetail.TotalPrice;
	          var _finalPrice = currentPurchaseReturnDetail.FinalPrice;
	          var _taxValue = currentPurchaseReturnDetail.TaxRate;
	          var _discountValue = currentPurchaseReturnDetail.Discount;
	          this.setState({ rows: currentPurchaseReturnDetail.Purchase_Return_Line_Completed,
	            totalNetWeight: newTotalNetWeight,
	            totalPrice: _newTotalPrice,
	            finalPrice: _finalPrice,
	            taxValue: _taxValue,
	            discountValue: _discountValue,
	            isCompleted: true
	          });
	        }
	        this.setState({ firstRender: true });
	      }
	
	      if (!nextProps.vendorsValue) {
	        this.props.resetCurrentVendor();
	      }
	
	      if (nextProps.priceTypeValue != this.props.priceTypeValue) {
	        this.setState({ priceType: nextProps.priceTypeValue });
	      }
	
	      if (nextProps.purchaseReturnPdf && nextProps.purchaseReturnPdf !== this.props.purchaseReturnPdf) {
	        this.setState({ returnPDFFrameLoaded: false });
	      }
	
	      // Calculate the sum of the price and weight for products.
	
	      // if (nextProps.products[0] && nextProps.productsValue) {
	      //
	      //     let { products } = nextProps;
	      //
	      //     let calculatedProducts = nextProps.productsValue;
	      //
	      //     function round(value, decimals) {
	      //         return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
	      //     }
	      //
	      //     // calculatedProducts.map(
	      //     //     product => {
	      //     //         if(product.Product_id) {
	      //     //             const index = _.findIndex(products, { 'Product_id': product.Product_id.value || product.Product_id });
	      //     //             if(index > -1){
	      //     //                 product['Title'] = products[index].Name+' No. '+ products[index].ProductNum;
	      //     //                 product['TotalNetWeight'] = ((parseFloat(products[index].NetWeight) || 0) * (parseFloat(product.Quantity) || 0)).toFixed(2);
	      //     //                 product['TotalShippingWeight'] = ((parseFloat(products[index].ShippingWeight) || 0) * (parseFloat(product.Quantity) || 0)).toFixed(2);
	      //     //                 product['TotalPrice'] = ((parseFloat(product.FOBUnitPrice) || 0) * (parseFloat(product.Quantity) || 0)).toFixed(2);
	      //     //             }
	      //     //         } else {
	      //     //             product['Title'] = "Please Choose a Product";
	      //     //             product['TotalNetWeight'] = 0;
	      //     //             product['TotalShippingWeight'] = 0;
	      //     //             product['TotalPrice'] = 0;
	      //     //         }
	      //     //         totalPrice = ( parseFloat(totalPrice) + ( parseFloat(product.TotalPrice) || 0 )).toFixed(2);
	      //     //         totalShippingWeight = ( parseFloat(totalShippingWeight) + ( parseFloat(product.TotalShippingWeight) || 0 )).toFixed(2);
	      //     //         totalNetWeight = ( parseFloat(totalNetWeight) + ( parseFloat(product.TotalNetWeight) || 0 )).toFixed(2);
	      //     //     }
	      //     // )
	      //
	      //     this.setState({
	      //         calculatedProducts: calculatedProducts,
	      //         // totalPrice: totalPrice,
	      //         // totalShippingWeight: totalShippingWeight,
	      //         // totalNetWeight: totalNetWeight
	      //     })
	      // }
	      if (!this.props.searchType) {
	        this.props.setDefaultOfForm('SearchType', 'RefNum', 'purchaseReturnForm');
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState.returnPDFFrameLoaded !== this.state.returnPDFFrameLoaded && this.state.returnPDFFrameLoaded == false) {
	        return false;
	      }
	      return true;
	    }
	
	    // If the form is dirty, ask for confirmation.
	
	  }, {
	    key: 'routerWillLeave',
	    value: function routerWillLeave(nextLocation) {
	      if (this.state.dirty) return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'work_not_saved_warning' });
	    }
	  }, {
	    key: 'returnTotalWeight',
	    value: function returnTotalWeight(totalWeight) {
	      var rows = [].concat(_toConsumableArray(this.state.rows));
	      var _rows$state$currentRo = rows[this.state.currentRow],
	          Rtn_Quantity = _rows$state$currentRo.Rtn_Quantity,
	          FOBUnitPrice = _rows$state$currentRo.FOBUnitPrice;
	
	
	      rows[this.state.currentRow].TotalNetWeight = +roundTo(totalWeight, 4).toFixed(2);
	      if (rows[this.state.currentRow].ProductType === 'Fixed') {
	        rows[this.state.currentRow].TotalPrice = +roundTo(parseFloat(Rtn_Quantity) * FOBUnitPrice, 2).toFixed(2);
	      } else {
	        rows[this.state.currentRow].TotalPrice = +roundTo(totalWeight * FOBUnitPrice, 2).toFixed(2);
	      }
	      this.setState({ rows: rows });
	    }
	  }, {
	    key: 'title',
	    value: function title() {
	      if (!this.props.params.id) {
	        return _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_management' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_purchase_return' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Breadcrumb,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb.Item,
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_management' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb.Item,
	          { active: 'true' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_purchase_return' })
	        )
	      );
	    }
	  }, {
	    key: 'orderHeader',
	    value: function orderHeader() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'your_return_order' })
	        )
	      );
	    }
	  }, {
	    key: 'getVendorBatches',
	    value: function getVendorBatches() {
	      this.openShowVendorBatches();
	      this.props.getVendorBatches(this.props.vendorsValue.value || this.props.vendorsValue);
	    }
	
	    // Render Select options dynamically with the information on the server.
	
	  }, {
	    key: 'renderVendors',
	    value: function renderVendors() {
	      if (this.props.vendorIsLoading) return _react2.default.createElement(_spinner2.default, null); // If vendor is loading, show a spinner.
	      else {
	          var vendorNameOptions = this.getVendorNameOptions(); // Return a JSON in the format of React-Select's options
	          var vendorNumOptions = this.getVendorNumOptions();
	          return _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'marginBottomStyle' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 9 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_no' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 8 },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Vendor_id', component: _selection.Selection, matchPos: 'any', options: vendorNumOptions })
	                )
	              )
	            ),
	            _react2.default.createElement('br', null)
	          );
	        }
	    }
	  }, {
	    key: 'renderVendorInfo',
	    value: function renderVendorInfo(isCompleted) {
	      var _this3 = this;
	
	      var vendorNameOptions = []; // Return a JSON in the format of React-Select's options
	      var vendorNumOptions = [];
	      var vendorTelOptions = [];
	      if (this.props.vendorIsLoading && !this.props.vendorError) {
	        vendorNameOptions = [{ value: "Loading", label: "Loading" }]; // Return a JSON in the format of React-Select's options
	        vendorNumOptions = [{ value: "Loading", label: "Loading" }];
	        vendorTelOptions = [{ value: "Loading", label: "Loading" }];
	      } // If vendor is loading, show a spinner.
	      else if (this.props.vendorError) return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'error' })
	        ); // If vendor is loading, show a spinner.
	        else {
	            vendorNameOptions = this.getVendorNameOptions(); // Return a JSON in the format of React-Select's options
	            vendorNumOptions = this.getVendorNumOptions();
	            vendorTelOptions = this.getVendorTelOptions();
	            return _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 5, id: 'vendor-info' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_information' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-xs-3' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                  ' ',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'asteriksReq' },
	                    '*'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-8' },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Vendor_id', component: _selection.Selection, matchPos: 'any', options: vendorNameOptions, disabled: isCompleted })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-xs-3' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_no' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-8' },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'Vendor_id', component: _selection.Selection, matchPos: 'any', options: vendorNumOptions, disabled: isCompleted })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5' },
	                  !this.state.isPurchaseCreditMode && _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { bsStyle: 'primary', type: 'button', disabled: !this.props.vendorsValue, onClick: function onClick() {
	                        _this3.getVendorBatches();
	                      } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'search_vendor_batches' }),
	                    _react2.default.createElement('em', { className: 'fa fa-search', style: { 'margin-left': '10px' } })
	                  )
	                )
	              )
	            );
	          }
	    }
	  }, {
	    key: 'renderBillingInfo',
	    value: function renderBillingInfo() {
	      var currentVendorDetail = this.props.currentVendorDetail;
	      var contact = null;
	      var phone = null;
	      if (currentVendorDetail && currentVendorDetail.Billing) {
	        contact = currentVendorDetail.Billing.FirstName + " " + currentVendorDetail.Billing.LastName;
	        phone = currentVendorDetail.Billing.Telephone;
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 4, id: 'billing-info' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'billing_information' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-3' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'contact' }),
	            ':'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-9' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              this.props.currentVendorDetail && contact
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-3' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' }),
	            ':'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-9' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              !this.props.currentVendorDetail && _react2.default.createElement(
	                'div',
	                { className: 'col-xs-9' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: '' })
	              ),
	              this.props.currentVendorDetail && phone
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group mb0' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-3' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' }),
	            ':'
	          ),
	          this.props.currentVendorDetail && _react2.default.createElement(
	            'div',
	            { className: 'col-xs-9' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              this.renderBillingAddress1()
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              this.renderBillingAddress2()
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderReturnOrderInfo',
	    value: function renderReturnOrderInfo() {
	      var returnReasonOptions = [{ value: "Damaged", label: "Damaged" }, { value: "Defective", label: "Defective" }, { value: "No Need", label: "No Need" }, { value: "Repair", label: "Repair" }, { value: "Wrong Item", label: "Wrong Item" }, { value: "Missing", label: "Missing" }, { value: "Other", label: "Other" }, { value: "Out", label: "Out" }, { value: "Short", label: "Short" }];
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 3, id: 'purchase-return-dates' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_order_info' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-6' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_date' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'asteriksReq' },
	              '*'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-6' },
	            _react2.default.createElement(_reduxForm.Field, { name: 'PostingDate', component: _datePicker.StartOfThisMonthDatePicker, disabled: this.state.isCompleted })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-6' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_reason' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'asteriksReq' },
	              '*'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-6' },
	            _react2.default.createElement(_reduxForm.Field, { name: 'ReturnReason', component: _selection.Selection, matchPos: 'any', options: returnReasonOptions, disabled: this.state.isCompleted })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-6' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'memo_no' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-6' },
	            _react2.default.createElement(_reduxForm.Field, { name: 'MemoNum', component: _inputField.InputField, matchPos: 'any', disabled: this.state.isCompleted })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderPrintIframe',
	    value: function renderPrintIframe() {
	      var returnPDFFrameLoaded = this.state.returnPDFFrameLoaded;
	      var purchaseReturnPdf = this.props.purchaseReturnPdf;
	
	      return _react2.default.createElement(_PrintIframe2.default, {
	        id: 'returnPDF',
	        loaded: returnPDFFrameLoaded,
	        name: 'returnPDF',
	        onLoad: this.handlePrintFrameOnLoad,
	        pdf: purchaseReturnPdf,
	        title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_purchase_return' })
	      });
	    }
	  }, {
	    key: 'renderBillingAddress1',
	    value: function renderBillingAddress1() {
	      var currentVendorDetail = this.props.currentVendorDetail;
	
	      if (currentVendorDetail && currentVendorDetail.Billing) {
	        var Address1 = currentVendorDetail.Billing.Street;
	        return Address1;
	      }
	    }
	  }, {
	    key: 'renderBillingAddress2',
	    value: function renderBillingAddress2() {
	      var currentVendorDetail = this.props.currentVendorDetail;
	
	      if (currentVendorDetail) {
	        var Address2 = currentVendorDetail.Billing.City + " " + currentVendorDetail.Billing.State + currentVendorDetail.Billing.Zip;
	        return Address2;
	      }
	    }
	
	    // Push vendor name and number in to 2 JSON arrays.
	
	  }, {
	    key: 'getVendorNameOptions',
	    value: function getVendorNameOptions() {
	      var vendorNameOptions = [];
	      this.props.vendors.map(function (vendor) {
	        vendorNameOptions.push({ value: vendor.Vendor_id, label: vendor.Name });
	      });
	      return vendorNameOptions;
	    }
	  }, {
	    key: 'getVendorNumOptions',
	    value: function getVendorNumOptions() {
	      var vendorNumOptions = [];
	      this.props.vendors.map(function (vendor) {
	        vendorNumOptions.push({ value: vendor.Vendor_id, label: vendor.VendorNum });
	      });
	      return vendorNumOptions;
	    }
	  }, {
	    key: 'getVendorTelOptions',
	    value: function getVendorTelOptions() {
	      var vendorNumOptions = [];
	      this.props.vendors.map(function (vendor) {
	        vendorNumOptions.push({ value: vendor.Vendor_id, label: vendor.Telephone });
	      });
	      return vendorNumOptions;
	    }
	  }, {
	    key: 'renderBillingAddress',
	    value: function renderBillingAddress() {
	      var _props = this.props,
	          vendorsValue = _props.vendorsValue,
	          currentVendorDetail = _props.currentVendorDetail;
	
	      if (currentVendorDetail) {
	        var BillingAddress = currentVendorDetail.Billing.Name + ', ' + currentVendorDetail.Billing.Street + ', ' + currentVendorDetail.Billing.City;
	        return BillingAddress;
	      }
	    }
	
	    // Once a vendor is chosen, render its shipping address and contacts
	
	  }, {
	    key: 'renderVendorAddress',
	    value: function renderVendorAddress() {
	      if (this.props.vendorDetailIsLoading && !this.props.vendorDetailError) return _react2.default.createElement(_spinner2.default, null); // If vendor is loading, show a spinner.
	      else if (this.props.vendorDetailError) return _react2.default.createElement(
	          'div',
	          null,
	          'Error'
	        ); // If vendor is loading, show a spinner.
	        else if (this.props.currentVendorDetail) {
	            var vendorAddressOptions = this.getVendorAddressOptions();
	            var vendorContactOptions = this.getVendorContactOptions();
	            return _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_vendor_address' })
	                    ),
	                    _react2.default.createElement(_reduxForm.Field, { name: 'Deliver_VendorDetail_id', component: _selection.Selection, matchPos: 'any', options: vendorAddressOptions })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_contact' })
	                    ),
	                    _react2.default.createElement(_reduxForm.Field, { name: 'Deliver_VendorDetail_id', component: _selection.Selection, matchPos: 'any', options: vendorContactOptions })
	                  )
	                ),
	                _react2.default.createElement('br', null),
	                this.renderVendorContactInformation()
	              )
	            );
	          } else return _react2.default.createElement(
	            'h4',
	            { className: 'centerStyle' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_please_select_a_vendor' })
	          );
	    }
	  }, {
	    key: 'getVendorAddressOptions',
	    value: function getVendorAddressOptions() {
	      var vendorAddressOptions = [];
	      this.props.currentVendorDetail.Shipping.map(function (address) {
	        vendorAddressOptions.push({ value: address.VendorDetail_id, label: address.AddressName + ', ' + address.City });
	      });
	      return vendorAddressOptions;
	    }
	  }, {
	    key: 'getVendorContactOptions',
	    value: function getVendorContactOptions() {
	      var vendorContactOptions = [];
	      this.props.currentVendorDetail.Shipping.map(function (contact) {
	        vendorContactOptions.push({ value: contact.VendorDetail_id, label: contact.FirstName + ' ' + contact.LastName });
	      });
	      return vendorContactOptions;
	    }
	  }, {
	    key: 'renderVendorContactInformation',
	    value: function renderVendorContactInformation() {
	      var _props2 = this.props,
	          currentVendorDetail = _props2.currentVendorDetail,
	          vendorsValue = _props2.vendorsValue,
	          vendorContactValue = _props2.vendorContactValue;
	
	      if (vendorContactValue && currentVendorDetail) {
	        var index = _lodash2.default.findIndex(currentVendorDetail.Shipping, { 'VendorDetail_id': vendorContactValue });
	        if (index != -1) return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 3 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 9 },
	              currentVendorDetail.Shipping[index].FirstName + ' ' + currentVendorDetail.Shipping[index].LastName
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 3 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 9 },
	              currentVendorDetail.Shipping[index].Email
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 3 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 9 },
	              currentVendorDetail.Shipping[index].Telephone
	            )
	          )
	        );
	      }
	    }
	
	    // Render the Array of products.
	
	    // renderProducts() {
	    //     if (!this.props.vendorsValue &&
	    //         (!this.props.initialValues || (this.props.initialValues && !this.props.initialValues.Vendor_id)))
	    //         return <h4>Please Select a Vendor</h4>
	    //     if (this.props.productIsLoading) return <Spinner/> // If group is loading, show a spinner.
	    //     else {
	    //         const { miscCostValue, handlingCostValue, shippingCostValue } = this.props;
	    //         let productNumOptions = this.getProductNumOptions();
	    //         let productNameOptions = this.getProductNameOptions();
	    //         let totalCost = (parseFloat(shippingCostValue || 0) + parseFloat(miscCostValue || 0) + parseFloat(handlingCostValue || 0)).toFixed(2)
	    //         return (
	    //             <FieldArray name="Purchase_Order_Line"
	    //                 ref="Products"
	    //                 component={ProductArrayOrder}
	    //                 productNameOptions={productNameOptions}
	    //                 productNumOptions={productNumOptions}
	    //                 calculatedProducts={this.state.calculatedProducts}
	    //                 productsValue={this.props.productsValue}
	    //                 products={this.props.products}
	    //                 priceType={this.state.priceType }
	    //                 totalPrice={this.state.totalPrice}
	    //                 totalCost={totalCost}
	    //                 withRef />
	    //         )
	    //     }
	    // }
	
	  }, {
	    key: 'fetchPurchaseOrdersByProduct',
	    value: function fetchPurchaseOrdersByProduct(productID, product) {
	      this.setState({
	        suggestValue: ''
	      });
	      this.moveToProductsListFromVendor([product]);
	    }
	  }, {
	    key: 'moveToProductsListFromAll',
	    value: function moveToProductsListFromAll() {
	      // delete productInformation, use selectedInventoryRow instead,
	      var simplifiedProducts = this.props.simplifiedProducts;
	
	      var selectedInventoryRow = this.state.selectedInventoryRow;
	      var quantity = parseFloat(this.props.allProd_Quantity || 0);
	      var index = _lodash2.default.findIndex(simplifiedProducts, { 'Product_id': selectedInventoryRow.Product_id });
	      var refPrice = this.props.allProd_FOBUnitPrice || 0;
	      var newProduct = _extends({}, simplifiedProducts[index]);
	      newProduct["FOBUnitPrice"] = refPrice; //products[index].RefPrice;
	      newProduct["TotalNetWeight"] = simplifiedProducts[index].NetWeight * quantity;
	      newProduct["Rtn_Quantity"] = quantity;
	      newProduct["TotalPrice"] = parseFloat(quantity * refPrice).toFixed(2);
	      newProduct["WarehouseZone"] = simplifiedProducts[index].ZoneName;
	      newProduct["WarehouseBin"] = simplifiedProducts[index].BinName;
	      if (newProduct.ProductType === 'Non-Fixed') {
	        newProduct.Weights = [];
	        newProduct.TotalNetWeight = 0;
	        newProduct.TotalPrice = 0;
	      }
	      var newRows = [].concat(_toConsumableArray(this.state.rows), [newProduct]);
	      // let totalNetWeight = parseFloat(this.state.totalNetWeight) + quantity*parseFloat(newProduct["NetWeight"]);
	      // totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
	      this.calculatePrices(newRows);
	      _reactDom2.default.findDOMNode(this.refs["allProducts"].getRenderedComponent().myInput.refs.input).focus();
	      this.props.resetAllProducts('purchaseReturnForm');
	    }
	  }, {
	    key: 'moveToProductsListFromVendor',
	    value: function moveToProductsListFromVendor(products) {
	      products.map(function (product) {
	        product.Rtn_Quantity = product.BinAmount;
	        product.TotalPrice = product.Rtn_Quantity * product.FOBUnitPrice;
	        if (!product.FOBUnitPrice) {
	          product.FOBUnitPrice = product.ProductCost;
	        }
	
	        if (product.ProductType === 'Non-Fixed') {
	          product.Weights = [];
	          product.TotalNetWeight = 0;
	          product.TotalPrice = 0;
	        }
	      });
	      var newRows = [].concat(_toConsumableArray(this.state.rows), _toConsumableArray(products));
	      // let totalNetWeight = parseFloat(this.state.totalNetWeight) + quantity*parseFloat(newProduct["NetWeight"]);
	      // totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
	      this.calculatePrices(newRows);
	      _reactDom2.default.findDOMNode(this.refs["allProducts"].getRenderedComponent().myInput.refs.input).focus();
	    }
	
	    // moveToProductsList(){
	    //   const { products, productInformation } = this.props;
	    //   const quantity = this.state.quantity;
	    //   const index = _.findIndex(products, { 'Product_id': productInformation.value || productInformation });
	    //   let refPrice = this.state.refPrice || this.state.defaultRefPrice || products[index].FOBUnitPrice || 0;
	    //   let newProduct = {...products[index]};
	    //   newProduct["Name"] = products[index].ProductName;
	    //   newProduct["Description"] = products[index].ProductDescription;
	    //   newProduct["FOBUnitPrice"] = refPrice; //products[index].RefPrice;
	    //   newProduct["TotalNetWeight"] = (products[index].NetWeight)*(quantity);
	    //   newProduct["Rtn_Quantity"] = quantity;
	    //   newProduct["TotalPrice"] = parseFloat(quantity*refPrice).toFixed(2);
	    //   newProduct["WarehouseZone"] = products[index].ZoneName;
	    //   newProduct["WarehouseBin"] = products[index].BinName;
	    //   const newRows = [...this.state.rows, newProduct];
	    //   let totalNetWeight = parseFloat(this.state.totalNetWeight) + quantity*parseFloat(newProduct["NetWeight"]);
	    //   totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
	    //   let totalPrice = parseFloat(this.state.totalPrice) + quantity*parseFloat(newProduct["FOBUnitPrice"]);
	    //   totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	    //   let discountValue = this.state.discountValue;
	    //   let taxValue = this.state.taxValue;
	    //   let finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
	    //   this.setState({rows: newRows,
	    //     totalNetWeight: totalNetWeight,
	    //     totalPrice: totalPrice,
	    //     finalPrice: finalPrice,
	    //     defaultRefPrice: 0,
	    //     refPrice: 0,
	    //     BinAmount: 0,
	    //     quantity: 0
	    //   });
	    // }
	
	  }, {
	    key: 'moveOffFromProductsList',
	    value: function moveOffFromProductsList(Product_id) {
	      var newRows = this.state.rows;
	      newRows = newRows.filter(function (obj) {
	        return obj.Product_id != Product_id;
	      });
	
	      this.calculatePrices(newRows);
	    }
	  }, {
	    key: 'calculatePrices',
	    value: function calculatePrices(newRows) {
	      var totalPrice = 0,
	          totalPriceForTax = 0,
	          CRV = 0;
	      newRows.map(function (r) {
	        totalPrice += parseFloat(r.TotalPrice);
	        if (r.IsTaxable) {
	          totalPriceForTax += parseFloat(r.TotalPrice);
	        }
	        CRV += parseFloat(r.CRV || 0) * parseFloat(r.Rtn_Quantity);
	      });
	      totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	      var taxRate = this.props.taxRate;
	      var miscCostValue = parseFloat(this.props.miscCostValue) || 0;
	      var handlingCostValue = parseFloat(this.props.handlingCostValue) || 0;
	      var adjustmentCostValue = parseFloat(this.props.adjustmentCostValue) || 0;
	      var shippingCostValue = parseFloat(this.props.shippingCostValue) || 0;
	      console.log("calculate price", this.props.discount, taxRate, CRV, totalPrice);
	      var finalPrice = (totalPrice * (1 - parseFloat(this.props.discount || 0) / 100.0) + parseFloat(totalPriceForTax) * parseFloat(taxRate || 0) / 100.0 + CRV + miscCostValue + handlingCostValue + adjustmentCostValue + shippingCostValue).toFixed(2);
	      this.setState({
	        rows: newRows,
	        totalPriceForTax: totalPriceForTax,
	        totalPrice: totalPrice,
	        finalPrice: finalPrice,
	        CRV: CRV
	      });
	    }
	  }, {
	    key: 'calculatePricesChange',
	    value: function calculatePricesChange(miscCostValue, handlingCostValue, shippingCostValue, discount, adjustmentCostValue) {
	      var totalPrice = 0,
	          totalPriceForTax = 0,
	          CRV = 0;
	      this.state.rows.map(function (r) {
	        totalPrice += parseFloat(r.TotalPrice);
	        if (r.IsTaxable) {
	          totalPriceForTax += parseFloat(r.TotalPrice);
	        }
	        CRV += parseFloat(r.CRV || 0) * parseFloat(r.Rtn_Quantity || 0);
	      });
	      totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	      var taxRate = this.props.taxRate;
	      if (miscCostValue != 0) miscCostValue = parseFloat(miscCostValue) || parseFloat(this.props.miscCostValue) || 0;
	      if (handlingCostValue != 0) handlingCostValue = parseFloat(handlingCostValue) || parseFloat(this.props.handlingCostValue) || 0;
	      if (adjustmentCostValue != 0) adjustmentCostValue = parseFloat(adjustmentCostValue) || parseFloat(this.props.adjustmentCostValue) || 0;
	      if (shippingCostValue != 0) shippingCostValue = parseFloat(shippingCostValue) || parseFloat(this.props.shippingCostValue) || 0;
	      if (discount != 0) discount = parseFloat(discount) || parseFloat(this.props.discount) || 0;
	      var finalPrice = parseFloat(totalPrice * (1 - parseFloat(discount || 0) / 100.0) + parseFloat(totalPriceForTax || 0) * parseFloat(taxRate || 0) / 100.0 + CRV + miscCostValue + handlingCostValue + adjustmentCostValue + shippingCostValue).toFixed(2);
	      this.setState({
	        totalPriceForTax: totalPriceForTax,
	        totalPrice: totalPrice,
	        finalPrice: finalPrice,
	        CRV: CRV
	      });
	    }
	
	    // setDefault() {
	    //   const { productInformation } = this.props;
	    //   if(productInformation){
	    //     const products = this.props.products;
	    //     const index = _.findIndex(products, { 'Product_id': productInformation.value || productInformation });
	    //     if(products[index] != null){
	    //       if(this.state.defaultRefPrice != products[index].UnitPrice)
	    //         this.setState({defaultRefPrice: products[index].UnitPrice});
	    //       if(this.state.BinAmount != products[index].BinAmount)
	    //         this.setState({BinAmount: products[index].BinAmount});
	    //     }
	    //   }
	    // }
	
	  }, {
	    key: 'handleUnitPriceChange',
	    value: function handleUnitPriceChange(event) {
	      this.setState({ refPrice: event.target.value });
	    }
	  }, {
	    key: 'handleQuantityChange',
	    value: function handleQuantityChange(event) {
	      this.setState({ quantity: event.target.value });
	    }
	  }, {
	    key: 'renderProducts',
	    value: function renderProducts() {
	      var _this4 = this;
	
	      if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.error)
	        )
	      );else {
	        var productNumOptions = this.getProductNumOptions();
	        var moveOffFromProductsList = this.moveOffFromProductsList;
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this4.state);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the row select function
	
	        var onRowSelect = function onRowSelect(rows) {
	          _this4.setState.apply(_this4, _toConsumableArray(_this4.state).concat([{ selectedRows: rows }]));
	        };
	
	        var onRowsSelected = function onRowsSelected(rows) {
	          var newRows = _this4.state.rows;
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = true;
	          });
	          _this4.setState({ rows: newRows });
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          var newRows = _this4.state.rows;
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = false;
	          });
	          _this4.setState({ rows: newRows });
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var state = Object.assign({}, _this4.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this4.setState(state);
	        };
	
	        var handleFilterChange = function handleFilterChange(filter) {
	          var newFilters = Object.assign({}, _this4.state.filters);
	          if (filter.filterTerm) {
	            newFilters[filter.column.key] = filter;
	          } else {
	            delete newFilters[filter.column.key];
	          }
	          _this4.setState({ filters: newFilters });
	        };
	
	        var onRowClick = function onRowClick(rowIdx, row) {
	          _this4.props.fetchSalesOrders();
	        };
	
	        // Handle the editable function
	
	        var handleRowUpdated = function handleRowUpdated(e) {
	          var rows = getRows();
	          // let totalPrice = this.state.totalPrice;
	          // let discountValue = this.state.discountValue;
	          // let taxValue = this.state.taxValue;
	
	          if (e.updated.Remark != null) {
	            var sourceObj = {
	              Remark: e.updated.Remark
	            };
	            Object.assign(rows[e.rowIdx], sourceObj);
	          }
	          if (e.updated.Rtn_Quantity != null) {
	            // let quantity = rows[e.rowIdx].Rtn_Quantity;
	            // Object.assign(rows[e.rowIdx], e.updated);
	            // Object.assign(rows[e.rowIdx], { TotalPrice: parseFloat(e.updated.Rtn_Quantity*rows[e.rowIdx].FOBUnitPrice).toFixed(2) });
	            // Object.assign(rows[e.rowIdx], {EstSaleTotal: parseFloat(e.updated.Rtn_Quantity*rows[e.rowIdx].EstSalePrice).toFixed(2)});
	            // Object.assign(rows[e.rowIdx], {TotalNetWeight: parseFloat(e.updated.Rtn_Quantity*rows[e.rowIdx].NetWeight).toFixed(2)});
	            // totalNetWeight = parseFloat(this.state.totalNetWeight) + (e.updated.Rtn_Quantity-quantity)*parseFloat(rows[e.rowIdx].NetWeight);
	            // totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
	            // totalPrice = parseFloat(this.state.totalPrice) + (e.updated.Rtn_Quantity-quantity)*parseFloat(rows[e.rowIdx].FOBUnitPrice);
	            // totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	            if (rows[e.rowIdx].ProductType === 'Non-Fixed') {
	              var updated = _extends({}, e.updated);
	              if (parseFloat(updated.Rtn_Quantity) < 0) {
	                updated.Rtn_Quantity = 0;
	              }
	              Object.assign(rows[e.rowIdx], updated);
	              _this4.setState({
	                currentRow: e.rowIdx,
	                totalLoaded: parseFloat(rows[e.rowIdx].Rtn_Quantity),
	                rowChosen: e.rowIdx,
	                currentWeights: rows[e.rowIdx].Weights,
	                editedRow: rows[e.rowIdx]
	              });
	              _this4.openSetWeight();
	            } else {
	              var newWeight = parseFloat(rows[e.rowIdx].NetWeight) * parseFloat(e.updated.Rtn_Quantity);
	              newWeight = parseFloat(parseFloat(newWeight).toFixed(2));
	              Object.assign(rows[e.rowIdx], { TotalNetWeight: newWeight });
	              Object.assign(rows[e.rowIdx], { TotalPrice: +roundTo(parseFloat(e.updated.Rtn_Quantity) * rows[e.rowIdx].FOBUnitPrice, 2).toFixed(2) });
	              Object.assign(rows[e.rowIdx], e.updated);
	            }
	          } else if (e.updated.FOBUnitPrice != null) {
	            // let FOBUnitPrice = rows[e.rowIdx].FOBUnitPrice;
	            // Object.assign(rows[e.rowIdx], e.updated);
	            // Object.assign(rows[e.rowIdx], {TotalPrice: parseFloat(e.updated.FOBUnitPrice*rows[e.rowIdx].Rtn_Quantity).toFixed(2)});
	            // totalPrice = parseFloat(this.state.totalPrice) + rows[e.rowIdx].Rtn_Quantity*(parseFloat(e.updated.FOBUnitPrice)-parseFloat(FOBUnitPrice));
	            // totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	            if (rows[e.rowIdx].ProductType === 'Non-Fixed' || rows[e.rowIdx].ProductType === 'Per-Pound') {
	              Object.assign(rows[e.rowIdx], { TotalPrice: +roundTo(parseFloat(e.updated.FOBUnitPrice) * rows[e.rowIdx].TotalNetWeight, 2).toFixed(2) });
	            } else {
	              Object.assign(rows[e.rowIdx], { TotalPrice: +roundTo(parseFloat(e.updated.FOBUnitPrice) * rows[e.rowIdx].Rtn_Quantity, 2).toFixed(2) });
	            }
	            Object.assign(rows[e.rowIdx], e.updated);
	            _this4.setState({ currentWeights: rows[e.rowIdx].Weights });
	          }
	          // else if(e.updated.EstSalePrice != null){
	          //   let quantity = rows[e.rowIdx].Rtn_Quantity;
	          //   Object.assign(rows[e.rowIdx], e.updated);
	          // Object.assign(rows[e.rowIdx], {EstSaleTotal: parseFloat(e.updated.EstSalePrice*rows[e.rowIdx].Rtn_Quantity).toFixed(2)});
	          // }
	
	          _this4.calculatePrices(rows);
	          // // merge updated row with current row and rerender by setting state
	          // let rows = this.state.rows.slice(0);
	          // let editedRows = this.state.editedRows.slice(0);
	          // Object.assign(rows[e.rowIdx], e.updated);
	          // // if the element is already edited, remove the old one.
	          //
	          // editedRows.forEach((element, index) => {
	          //     if (element.ProductNum === rows[e.rowIdx].ProductNum)
	          //         editedRows.splice(index, 1)
	          // }, this);
	          // // push the row into the editedRows array
	          // editedRows.push(rows[e.rowIdx]);
	          // this.setState({
	          //     rows: rows,
	          //     editedRows: editedRows
	          // });
	        };
	
	        //Custom Formatter component
	
	        var DateFormatter = _react2.default.createClass({
	          displayName: 'DateFormatter',
	          render: function render() {
	            if (this.props.value) {
	              var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	              var date = new Date(this.props.value);
	              var index = dateMap.indexOf(date.toString().slice(4, 3));
	              var localDate = index + date.toString().slice(8, 6);
	              return _react2.default.createElement(
	                'span',
	                null,
	                date.toString().slice(4, 15)
	              );;
	            } else return _react2.default.createElement(
	              'span',
	              { className: 'label label-danger' },
	              '-'
	            );
	          }
	        });
	
	        var VendorNameFormatter = _react2.default.createClass({
	          displayName: 'VendorNameFormatter',
	          render: function render() {
	            if (this.props.value) return _react2.default.createElement(
	              'span',
	              null,
	              this.props.value.Name
	            );else return _react2.default.createElement(
	              'span',
	              { className: 'label label-danger' },
	              '-'
	            );
	          }
	        });
	
	        var VendorNumFormatter = _react2.default.createClass({
	          displayName: 'VendorNumFormatter',
	          render: function render() {
	            if (this.props.value) return _react2.default.createElement(
	              'span',
	              null,
	              this.props.value.VendorNum
	            );else return _react2.default.createElement(
	              'span',
	              { className: 'label label-danger' },
	              '-'
	            );
	          }
	        });
	
	        var IsVariableFormatter = _react2.default.createClass({
	          displayName: 'IsVariableFormatter',
	          render: function render() {
	            var _this5 = this;
	
	            return _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  className: 'textAlignStyle',
	                  type: 'button',
	                  style: { height: '23px', width: '39px', padding: '0px' },
	                  onClick: function onClick() {
	                    moveOffFromProductsList(_this5.props.dependentValues.Product_id);
	                  }
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'X' })
	              )
	            );
	          }
	        });
	
	        // Column difinition
	
	        var columns = [{
	          key: 'Delete',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	          formatter: IsVariableFormatter,
	          width: 50,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }].concat(_toConsumableArray(!isLO ? [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          width: 80,
	          sortable: true,
	          filterable: true
	        }] : []), [{
	          key: 'RefNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	          resizable: true,
	          sortable: true,
	          width: isLO ? 160 : 70,
	          filterable: true
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	          resizable: true,
	          sortable: true,
	          width: 200,
	          filterable: true
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	          resizable: true,
	          width: 120,
	          sortable: true,
	          filterable: true
	        }, {
	          key: 'Batch_PONum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	          resizable: true,
	          width: 100,
	          sortable: true,
	          filterable: true
	        }, {
	          key: 'Rtn_Quantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_qty' }),
	          resizable: true,
	          width: 80,
	          editable: true,
	          sortable: true,
	          filterable: true
	        }, {
	          key: 'FOBUnitPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	          resizable: true,
	          width: 80,
	          editable: true,
	          sortable: true,
	          filterable: true,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'TotalPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	          resizable: true,
	          sortable: true,
	          width: 75,
	          filterable: true,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'TotalNetWeight',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	          resizable: true,
	          sortable: true,
	          width: 75,
	          filterable: true
	        }, {
	          key: 'PackageType',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        }, {
	          key: 'PackageSize',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	          resizable: true,
	          sortable: true,
	          width: 90,
	          filterable: true
	        }, {
	          key: 'Remark',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	          resizable: true,
	          width: 100,
	          editable: true
	        }], _toConsumableArray(isLO ? [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          width: 80,
	          sortable: true,
	          filterable: true
	        }] : []));
	        if (this.state.isPurchaseCreditMode) {
	          columns.splice(5, 1);
	        }
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 12 },
	              _react2.default.createElement(
	                'div',
	                { style: { maxWidth: '100%' }, id: 'PurchaseReturnForm-dataGrid1' },
	                _react2.default.createElement(_reactDataGrid2.default, {
	                  rowKey: 'Product_id',
	                  enableCellSelect: true,
	                  onGridSort: handleGridSort,
	                  columns: columns,
	                  rowHeight: 25,
	                  headerRowHeight: 45,
	                  minHeight: 375,
	                  rowGetter: rowGetter,
	                  rowsCount: getSize(),
	                  onRowUpdated: handleRowUpdated
	                })
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'getProductNumOptions',
	    value: function getProductNumOptions() {
	      var productNumOptions = [{ value: '', label: "No.       |  Name           |  Description                         |  Batch_PONum    | Zone      | Bin" }];
	      if (this.props.products) {
	        this.props.products.map(function (product) {
	          var text = "                                                                                                                                                             ";
	          var output = [product.ProductNum.slice(0, 8), text].join('');
	          output = [output.slice(0, 8), '  |  ', product.ProductName.slice(0, 12), text].join('');
	          if (product.Description) output = [output.slice(0, 26), '  |  ', product.Description.slice(0, 50), text].join('');else output = [output.slice(0, 26), '  |  ', '                                                  ', text].join('');
	          output = [output.slice(0, 62), '  |  ', product.Batch_PONum.slice(0, 10), text].join('');
	          output = [output.slice(0, 80), '  |  ', product.ZoneName.slice(0, 50), text].join('');
	          output = [output.slice(0, 92), '  |  ', product.BinName.slice(0, 50), text].join('');
	          output = output.slice(0, 145);
	          productNumOptions.push({ value: product.Product_id, label: output });
	        });
	      }
	      return productNumOptions;
	    }
	
	    // Dropdown list for payment status
	
	  }, {
	    key: 'renderPaymentStatus',
	    value: function renderPaymentStatus() {
	      var paymentStatusOptions = [{ value: 'Not Paid', label: 'Not Paid' }, { value: 'Partially Paid', label: 'Partially Paid' }, { value: 'Paid', label: 'Paid' }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 6 },
	        _react2.default.createElement(
	          'label',
	          { className: 'col-sm-6 inlineLabel' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_status' }),
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { style: { color: 'red' } },
	            '*'
	          ),
	          ' '
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 6 },
	          _react2.default.createElement(_reduxForm.Field, { name: 'PaymentStatus', component: _selection.Selection, matchPos: 'any', options: paymentStatusOptions })
	        )
	      );
	    }
	  }, {
	    key: 'renderCarryTypeShippingMethod',
	    value: function renderCarryTypeShippingMethod(isCompleted) {
	      var carryTypeOptions = [{ value: "Dry", label: "Dry" }, { value: "Refrigerated", label: "Refrigerated" }];
	      var shippingMethodOptions = [{ value: "Pickup", label: "Pickup" }, { value: "Delivery", label: "Delivery" }];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12, id: 'shipping-method-field' },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_method' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'asteriksReq' },
	              '*'
	            )
	          ),
	          _react2.default.createElement(_reduxForm.Field, {
	            name: 'ShippingMethod',
	            matchPos: 'any',
	            component: _selection.Selection,
	            options: shippingMethodOptions,
	            defaultValue: { value: "Own Logistic", label: "Own Logistic" },
	            disabled: isCompleted
	          })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carry_type' })
	          ),
	          _react2.default.createElement(_reduxForm.Field, {
	            name: 'CarryType',
	            matchPos: 'any',
	            component: _selection.Selection,
	            options: carryTypeOptions,
	            defaultValue: { value: "Dry", label: "Dry" },
	            disabled: isCompleted
	          })
	        )
	      );
	    }
	
	    // Render the Paymentterms select.
	
	  }, {
	    key: 'renderPaymentTerms',
	    value: function renderPaymentTerms(isCompleted) {
	      if (this.props.paymentTermsIsLoading) return _react2.default.createElement(_spinner2.default, null); // If group is loading, show a spinner.
	      else {
	          var paymentTermOptions = this.getPaymentTermOptions();
	          return _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term' })
	            ),
	            _react2.default.createElement(_reduxForm.Field, { name: 'PaymentTerm_id', component: _selection.Selection, matchPos: 'any', options: paymentTermOptions, disabled: isCompleted })
	          );
	        }
	    }
	  }, {
	    key: 'getPaymentTermOptions',
	    value: function getPaymentTermOptions() {
	      var paymentTermOptions = [];
	      this.props.paymentTerms.map(function (paymentTerm) {
	        paymentTermOptions.push({ value: paymentTerm.PaymentTerm_id, label: paymentTerm.Name });
	      });
	      return paymentTermOptions;
	    }
	
	    // Implement the Headers which enable the function of collapsible
	
	  }, {
	    key: 'productHeader',
	    value: function productHeader() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'label',
	          { style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_information' })
	        )
	      );
	    }
	  }, {
	    key: 'returnHeader',
	    value: function returnHeader() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'label',
	          { style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return' })
	        )
	      );
	    }
	  }, {
	    key: 'deliverHeader',
	    value: function deliverHeader() {
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          'label',
	          { style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_warehouse' })
	        )
	      );
	    }
	  }, {
	    key: 'carryHeader',
	    value: function carryHeader() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'label',
	          { style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carry_type_shipping_method' })
	        )
	      );
	    }
	  }, {
	    key: 'accountHeader',
	    value: function accountHeader() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'label',
	          { style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account_payment_term' })
	        )
	      );
	    }
	  }, {
	    key: 'attachmentHeader',
	    value: function attachmentHeader() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'label',
	          { style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'attachment_upload' })
	        )
	      );
	    }
	
	    // vendorHeader() {
	    //     return (
	    //         <div onClick={ ()=> this.setState({ vendorInformationOpen: !this.state.vendorInformationOpen })} >
	    //             <label style={{ cursor: "pointer" }} ><Translate value="vendor_information" /></label>
	    //         </div>
	    //     )
	    // }
	
	  }, {
	    key: 'oneTimeScheduleHeader',
	    value: function oneTimeScheduleHeader() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { onClick: function onClick() {
	            return _this6.setState({ oneTimeScheduleOpen: !_this6.state.oneTimeScheduleOpen });
	          } },
	        _react2.default.createElement(
	          'label',
	          { style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'one_time_schedule' })
	        )
	      );
	    }
	  }, {
	    key: 'purchaseInformationHeader',
	    value: function purchaseInformationHeader() {
	      var _this7 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { onClick: function onClick() {
	            return _this7.setState({ purchaseInformationOpen: !_this7.state.purchaseInformationOpen });
	          } },
	        _react2.default.createElement(
	          'label',
	          { style: { cursor: "pointer" } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_information' })
	        )
	      );
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(files) {
	      this.setState({
	        files: files
	      });
	    }
	  }, {
	    key: 'onOpenClick',
	    value: function onOpenClick() {
	      this.refs.dropzone.open();
	    }
	  }, {
	    key: 'openShowInventory',
	    value: function openShowInventory(event) {
	      if (!this.props.allProducts || this.props.allProducts == "") {
	        return;
	      }
	      switch (event.charCode) {
	        case 13:
	          // ENTER
	          event.preventDefault();
	          this.props.fetchReturnBatch(this.props.searchType, this.props.allProducts);
	          this.setState({ showInventoryOpen: true });
	          break;
	      }
	    }
	  }, {
	    key: 'renderAutoSuggest',
	    value: function renderAutoSuggest() {
	      var _this8 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'control-dropdown' },
	        _react2.default.createElement(_GenericProductSuggest2.default, {
	          value: this.state.suggestValue,
	          onChange: function onChange(e, _ref) {
	            var newValue = _ref.newValue;
	            _this8.setState({ suggestValue: newValue });
	          },
	          SearchType: this.state.productSearchType,
	          fetchOrdersByProduct: this.fetchPurchaseOrdersByProduct
	        })
	      );
	    }
	  }, {
	    key: 'closeShowInventory',
	    value: function closeShowInventory(value) {
	      this.setState({ showInventoryOpen: false });
	      if (value) {
	        _reactDom2.default.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	      }
	    }
	  }, {
	    key: 'openShowVendorBatches',
	    value: function openShowVendorBatches() {
	      this.setState({ showVendorBatchesOpen: true });
	    }
	  }, {
	    key: 'closeShowVendorBatches',
	    value: function closeShowVendorBatches() {
	      this.setState({ showVendorBatchesOpen: false });
	    }
	
	    // setAllProducts(product) {
	    //   this.props.setDefaultOfForm('Products', product, 'purchaseReturnForm')
	    // }
	
	  }, {
	    key: 'selectInventoryInfo',
	    value: function selectInventoryInfo(selectedInventoryRow) {
	      this.setState({ selectedInventoryRow: selectedInventoryRow });
	      var index = _lodash2.default.findIndex(this.props.simplifiedProducts, { 'Product_id': selectedInventoryRow.Product_id });
	      if (index > -1) {
	        this.props.fetchProductInfo(this.props.simplifiedProducts[index].Product_id);
	        this.props.setPriceValues(this.props.simplifiedProducts[index].ProductCost, this.props.simplifiedProducts[index].LowestSalePrice, 'purchaseReturnForm');
	        if ((this.props.simplifiedProducts[index].ProductType == "Non-Fixed" || this.props.simplifiedProducts[index].ProductType == "Per-Pound") && !this.props.simplifiedProducts[index].NetWeight) {
	          alert("Net Weight Cannot Be 0! Change Net Weight in Product Page!");
	        }
	        this.props.setDefaultOfForm('Weight', this.props.simplifiedProducts[index].NetWeight, 'purchaseOrderForm');
	      }
	    }
	
	    // Selection -> Selection
	
	  }, {
	    key: 'handleKeyPressTargetSelection',
	    value: function handleKeyPressTargetSelection(value, event) {
	      if (event.keyCode == 13) {
	        if (value == "") {
	          event.preventDefault();
	          return;
	        }
	        this.refs[value].getRenderedComponent().refs.select.focus();
	        // ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	      }
	    }
	
	    // Selection -> Input
	
	  }, {
	    key: 'handleKeyPressTargetInput',
	    value: function handleKeyPressTargetInput(value, event) {
	      if (event.keyCode == 13) {
	        _reactDom2.default.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	      }
	    }
	
	    // Input -> Input
	
	  }, {
	    key: 'handleKeyPress',
	    value: function handleKeyPress(value, event) {
	      if (event.charCode == 13) {
	        event.preventDefault();
	        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	          if (this.state.selectedInventoryRow.ProductType == 'Non-Fixed') _reactDom2.default.findDOMNode(this.refs[value[1]].getRenderedComponent().myInput.refs.input).focus();else _reactDom2.default.findDOMNode(this.refs[value[0]].getRenderedComponent().myInput.refs.input).focus();
	        } else _reactDom2.default.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	      }
	    }
	  }, {
	    key: 'handleKeyPressMove',
	    value: function handleKeyPressMove(event) {
	      if (event.charCode == 13) {
	        event.preventDefault();
	        this.moveToProductsListFromAll();
	      }
	    }
	
	    // handleKeyPressMoveVendor(event) {
	    //   if(event.charCode == 13){
	    //     event.preventDefault();
	    //     this.moveToProductsList();
	    //   }
	    // }
	
	  }, {
	    key: 'handleOnFocus',
	    value: function handleOnFocus(event) {
	      event.target.select();
	    }
	  }, {
	    key: 'renderPreview',
	    value: function renderPreview() {
	      return _react2.default.createElement(
	        'div',
	        { id: 'preview' },
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(_reactBootstrap.Image, { src: this.state.files[0].preview, thumbnail: true })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderWarehouse',
	    value: function renderWarehouse() {
	      if (this.props.warehouseIsLoading) return _react2.default.createElement(_spinner2.default, null); // If group is loading, show a spinner.
	      else {
	          var warehouseOptions = this.getWarehouseOptions();
	          return _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_warehouse' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'asteriksReq' },
	                '*'
	              )
	            ),
	            _react2.default.createElement(_reduxForm.Field, { name: 'Pickup_Warehouse_id', component: _selection.Selection, matchPos: 'any', options: warehouseOptions, disabled: this.state.isCompleted })
	          );
	        }
	    }
	  }, {
	    key: 'getWarehouseOptions',
	    value: function getWarehouseOptions() {
	      var warehouseOptions = [];
	      this.props.warehouses.map(function (warehouse) {
	        warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name });
	      });
	      return warehouseOptions;
	    }
	
	    // If the user was directed to the page with a parameter,
	    // then this page is edit page. Otherwise this is a create
	    // page.
	
	  }, {
	    key: 'handleMiscCostChange',
	    value: function handleMiscCostChange(event) {
	      var totalPrice = parseFloat(this.state.totalPrice);
	      totalPrice = parseFloat(totalPrice || 0) - parseFloat(this.state.miscCostValue || 0) + parseFloat(event.target.value || 0);
	      var discountValue = parseFloat(this.state.discountValue);
	      var taxValue = parseFloat(this.state.taxValue);
	      var finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
	      this.setState({ miscCostValue: event.target.value, totalPrice: totalPrice, finalPrice: finalPrice });
	    }
	  }, {
	    key: 'handleHandlingCostChange',
	    value: function handleHandlingCostChange(event) {
	      var totalPrice = parseFloat(this.state.totalPrice);
	      totalPrice = parseFloat(totalPrice || 0) - parseFloat(this.state.handlingCostValue || 0) + parseFloat(event.target.value || 0);
	      var discountValue = parseFloat(this.state.discountValue);
	      var taxValue = parseFloat(this.state.taxValue);
	      var finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
	      this.setState({ handlingCostValue: event.target.value, totalPrice: totalPrice, finalPrice: finalPrice });
	    }
	  }, {
	    key: 'handleAdjustmentCostChange',
	    value: function handleAdjustmentCostChange(event) {
	      var totalPrice = parseFloat(this.state.totalPrice);
	      totalPrice = parseFloat(totalPrice || 0) - parseFloat(this.state.adjustmentCostValue || 0) + parseFloat(event.target.value || 0);
	      var discountValue = parseFloat(this.state.discountValue);
	      var taxValue = parseFloat(this.state.taxValue);
	      var finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
	      this.setState({ adjustmentCostValue: event.target.value, totalPrice: totalPrice, finalPrice: finalPrice });
	    }
	  }, {
	    key: 'handleShippingCostChange',
	    value: function handleShippingCostChange(event) {
	      var totalPrice = parseFloat(this.state.totalPrice);
	      totalPrice = parseFloat(totalPrice || 0) - parseFloat(this.state.shippingCostValue || 0) + parseFloat(event.target.value || 0);
	      var discountValue = parseFloat(this.state.discountValue);
	      var taxValue = parseFloat(this.state.taxValue);
	      var finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
	      this.setState({ shippingCostValue: event.target.value, totalPrice: totalPrice, finalPrice: finalPrice });
	    }
	  }, {
	    key: 'handleDiscountChange',
	    value: function handleDiscountChange(event) {
	      var totalPrice = parseFloat(this.state.totalPrice);
	      var taxValue = parseFloat(this.state.taxValue);
	      var finalPrice = (totalPrice * (1 - parseFloat(event.target.value || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
	      // let finalPrice = (totalPrice / (1 - parseFloat(discountValue || 0) / 100.00) * (1 - parseFloat(event.target.value || 0) / 100.00)).toFixed(2);
	      this.setState({ discountValue: event.target.value, finalPrice: finalPrice });
	    }
	  }, {
	    key: 'handleTaxChange',
	    value: function handleTaxChange(event) {
	      var totalPrice = parseFloat(this.state.totalPrice);
	      var discountValue = parseFloat(this.state.discountValue);
	      var finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(event.target.value || 0) / 100.0)).toFixed(2);
	      // let finalPrice = (totalPrice / (1 + parseFloat(taxValue || 0) / 100.00) * (1 + parseFloat(event.target.value || 0) / 100.00)).toFixed(2);
	      this.setState({ taxValue: event.target.value, finalPrice: finalPrice });
	    }
	  }, {
	    key: 'checkPermission',
	    value: function checkPermission(permission) {
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      var _props3 = this.props,
	          handleSubmit = _props3.handleSubmit,
	          submitting = _props3.submitting,
	          pristine = _props3.pristine;
	
	      var productInfo = this.state.productInfo;
	      var convertItemPriceTranslation = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'type' });
	      var renderPurchaseReturnHeader = _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_return_details' })
	      );
	      var createDialogInventoryStyle = {
	        height: '750px',
	        width: '1000px',
	        marginLeft: '-28%',
	        marginTop: '-20%',
	        top: '50%'
	      };
	      var createDialogStyle = {
	        width: '500px',
	        height: '550px',
	        marginLeft: '-15%'
	      };
	      if (this.props.detailIsLoading && !this.props.detailError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement('br', null),
	        '...',
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reading_data' })
	      );else if (this.props.detailError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          this.props.error
	        )
	      );else {
	        var PONum = null;
	        if (this.props.currentPurchaseOrder) {
	          PONum = this.props.currentPurchaseOrder.PONum;
	        }
	        // let isCompleted = {isCompleted: this.state.isCompleted};
	        // const printUrl = `${ROOT_URL}v1/purchase/return/print/${this.props.params.id}/?Bearer=${localStorage.getItem('token')}`;
	
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'form',
	            { className: 'form-horizontal', autoComplete: 'off', method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit) },
	            this.title(),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { id: 'purchase-return-form-button' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  type: 'button',
	                  disabled: submitting || pristine,
	                  onClick: handleSubmit(this.handleFormSubmit)
	                },
	                _react2.default.createElement('em', { className: 'fa fa-save' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	              ),
	              _react2.default.createElement(_SpinnerButton2.default, {
	                bsStyle: 'primary',
	                disabled: !this.props.params.id || this.props.requestingPurchaseReturnPdf,
	                icon: 'fa-print',
	                translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' }),
	                loading: this.props.requestingPurchaseReturnPdf,
	                onClick: function onClick() {
	                  _this9.props.printPurchaseReturn(_this9.props.params.id);
	                }
	              }),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { href: '/purchaseReturn', bsStyle: 'danger' },
	                _react2.default.createElement('em', { className: 'fa fa-close' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	              )
	            ),
	            (this.props.isCreating || this.props.isEditing) && _react2.default.createElement(_spinner2.default, null),
	            this.props.createError && _react2.default.createElement(
	              'div',
	              { className: 'alert alert-danger marginTopStyle' },
	              JSON.stringify(this.props.createError)
	            ),
	            this.props.editError && _react2.default.createElement(
	              'div',
	              { className: 'alert alert-danger marginTopStyle' },
	              JSON.stringify(this.props.editError)
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Grid,
	              { id: 'purchase-return-form' },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 10 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { className: 'purchase-return-vendor-info' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      this.renderVendorInfo(this.state.isCompleted),
	                      this.renderBillingInfo(),
	                      this.renderReturnOrderInfo()
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { style: { height: 85 } },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 6, className: 'p0' },
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          this.renderTypeRadios()
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          this.state.isPurchaseCreditMode ? this.renderAutoSuggest() : _react2.default.createElement(_reduxForm.Field, { name: 'AllProducts', ref: 'allProducts', withRef: true, component: _inputField.InputField, onKeyPress: function onKeyPress(event) {
	                              _this9.openShowInventory(event);
	                            }, onFocus: this.handleOnFocus })
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    this.orderHeader(),
	                    _react2.default.createElement(
	                      _reactBootstrap.Panel,
	                      { className: 'your-return-order' },
	                      this.renderProducts()
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { className: 'purchase-return-details', header: renderPurchaseReturnHeader },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 4, className: 'pr-no-line-height' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pr_no' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 8 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'PRNum', component: _inputField.DisabledInputField })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 4, className: 'status-line-height' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 8 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'ReturnStatus', component: _inputField.DisabledInputField })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 4, className: 'status-line-height' },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'modifier' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 8 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'Modifier_Username', component: _inputField.DisabledInputField })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      this.renderCarryTypeShippingMethod(this.state.isCompleted)
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      this.renderWarehouse()
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      this.renderPaymentTerms(this.state.isCompleted)
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4, className: 'p0' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping' })
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { sm: 12 },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'ShippingCost', component: _inputField.InputField })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4, className: 'p0' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'handling' })
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { sm: 12 },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'HandlingCost', component: _inputField.InputField })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4, className: 'p0' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'misc' })
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { sm: 12 },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'MiscCost', component: _inputField.InputField })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4, className: 'p0' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'adjust' })
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { sm: 12 },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Adjustment', component: _inputField.InputField })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4, className: 'p0' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disc' }),
	                          '%'
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { sm: 12 },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Discount', component: _inputField.InputField })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4, className: 'p0' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	                          '%'
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { sm: 12 },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'TaxRate', component: _inputField.DisabledInputField })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4, className: 'p0' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'crv' })
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { sm: 12 },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'CRV', component: _inputField.DisabledInputField, placeholder: this.state.CRV })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, className: 'p0' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total' }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            '$$'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { sm: 12 },
	                          this.state.totalPrice
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, className: 'p0' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final' }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            '$$'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { sm: 12 },
	                          this.state.finalPrice
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(_reactBootstrap.Row, null)
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                dialogStyles: createDialogInventoryStyle,
	                isVisible: this.state.showInventoryOpen,
	                onCloseClicked: this.closeShowInventory,
	                title: 'Select Inventory'
	              },
	              _react2.default.createElement(_vendorBatches2.default, {
	                moveToProductsListFromVendor: this.moveToProductsListFromVendor,
	                closeShowVendorBatches: this.closeShowInventory,
	                form: 'purchaseReturnForm'
	              })
	            ),
	            ' ',
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                dialogStyles: createDialogInventoryStyle,
	                isVisible: this.state.showVendorBatchesOpen,
	                onCloseClicked: this.closeShowVendorBatches,
	                title: 'Vendor Batches'
	              },
	              _react2.default.createElement(_vendorBatches2.default, {
	                moveToProductsListFromVendor: this.moveToProductsListFromVendor,
	                closeShowVendorBatches: this.closeShowVendorBatches,
	                form: 'purchaseReturnForm'
	              })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                dialogStyles: createDialogStyle,
	                isVisible: this.state.setWeightOpen,
	                onCloseClicked: this.closeSetWeight,
	                title: 'Set Product Weights'
	              },
	              _react2.default.createElement(_setWeightModal2.default, {
	                invoice: true,
	                setWeights: this.setWeights,
	                keepLoaded: this.keepLoaded,
	                currentWeights: this.state.currentWeights,
	                closeC: this.closeSetWeight,
	                totalLoaded: this.state.totalLoaded,
	                rowChosen: this.state.rowChosen,
	                returnTotalWeight: this.returnTotalWeight.bind(this),
	                editedRow: this.state.editedRow
	              })
	            )
	          ),
	          this.renderPrintIframe()
	        );
	      }
	    }
	  }]);
	
	  return PurchaseReturnForm;
	}(_react.Component);
	
	PurchaseReturnForm.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var _default = (0, _reactRouter.withRouter)(PurchaseReturnForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(roundTo, 'roundTo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseReturnForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isLO, 'isLO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseReturnForm.jsx');
	
	  __REACT_HOT_LOADER__.register(PurchaseReturnForm, 'PurchaseReturnForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseReturnForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseReturnForm.jsx');
	}();

	;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _constants = __webpack_require__(11);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _dateFormat = __webpack_require__(39);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _PrintIframe = __webpack_require__(63);
	
	var _PrintIframe2 = _interopRequireDefault(_PrintIframe);
	
	var _genericRadioFilter = __webpack_require__(50);
	
	var _genericRadioFilter2 = _interopRequireDefault(_genericRadioFilter);
	
	var _dateFilterRadios = __webpack_require__(49);
	
	var _dateFilterRadios2 = _interopRequireDefault(_dateFilterRadios);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _cleanDates = __webpack_require__(22);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PurchaseReturnList = function (_Component) {
	  _inherits(PurchaseReturnList, _Component);
	
	  function PurchaseReturnList() {
	    _classCallCheck(this, PurchaseReturnList);
	
	    var _this = _possibleConstructorReturn(this, (PurchaseReturnList.__proto__ || Object.getPrototypeOf(PurchaseReturnList)).call(this));
	
	    _this.handlePrintFrameOnLoad = function () {
	      _this.setState({ returnPDFFrameLoaded: true });
	    };
	
	    _this.handlePrintFrameNsOnLoad = function () {
	      _this.setState({ returnPdfFrameLoadedNs: true });
	    };
	
	    _this.setToDate = function (e) {
	      if (e < _this.state.fromDate) {
	        return;
	      }
	      _this.setState({ toDate: e });
	    };
	
	    _this.setFromDate = function (e) {
	      if (e > _this.state.toDate) {
	        return;
	      }
	      _this.setState({ fromDate: e });
	    };
	
	    _this.setToRangeSearch = function (e) {
	      _this.setState({ days: '-1' });
	    };
	
	    _this.handleStatusFilterChange = function (status) {
	      var route = _this.context.router.routes[1].path;
	      var _this$state = _this.state,
	          days = _this$state.days,
	          fromDate = _this$state.fromDate,
	          toDate = _this$state.toDate;
	
	      _this.setState({ status: status }, function () {
	        _this.props.fetchPurchaseReturns(fromDate, toDate, days, status);
	      });
	    };
	
	    _this.handleDaysFilterChange = function (days) {
	      var route = _this.context.router.routes[1].path;
	      var _this$state2 = _this.state,
	          fromDate = _this$state2.fromDate,
	          toDate = _this$state2.toDate,
	          status = _this$state2.status;
	
	      _this.setState({ days: days }, function () {
	        _this.props.fetchPurchaseReturns(fromDate, toDate, days, status);
	      });
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.editSalesInvPage,
	
	      createOpen: false,
	
	      rows: [],
	      selectedRows: null,
	      filters: {},
	      sortColumn: null,
	      sortDirection: null,
	
	      returnPDFFrameLoaded: true,
	
	      checkAuthorizeOpen: false,
	      action: null,
	
	      days: '7',
	      fromDate: undefined,
	      toDate: undefined,
	      filteredByItem: false,
	      status: 'all',
	      returnPdfFrameLoadedNs: true
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.openCreate = _this.openCreate.bind(_this);
	    _this.closeCreate = _this.closeCreate.bind(_this);
	    _this.checkAuthorize = _this.checkAuthorize.bind(_this);
	    _this.openCheckAuthorize = _this.openCheckAuthorize.bind(_this);
	    _this.closeCheckAuthorize = _this.closeCheckAuthorize.bind(_this);
	    return _this;
	  }
	
	  _createClass(PurchaseReturnList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      window.addEventListener('resize', this.handleResize);
	      this.props.fetchPurchaseReturns(this.state.fromDate, this.state.toDate, this.state.days, this.state.status);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.editSalesInvPage });
	    }
	
	    // Once products are ready, reset state..
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
	        this.closeCheckAuthorize();
	        if (this.state.action === 'void') {
	          this.voidPurchaseReturn();
	        }
	      }
	      if (nextProps.purchaseReturns && nextProps.purchaseReturns != this.props.purchaseReturns) {
	        var purchaseReturns = nextProps.purchaseReturns;
	        purchaseReturns.map(function (purchaseReturn) {
	          purchaseReturn['Name'] = purchaseReturn.Vendor_id.Name;
	        });
	        this.setState({
	          rows: purchaseReturns
	        });
	      }
	
	      if (nextProps.purchaseReturnPdf && nextProps.purchaseReturnPdf !== this.props.purchaseReturnPdf) {
	        this.setState({ returnPDFFrameLoaded: false });
	      }
	
	      if (nextProps.purchaseReturnPdfNs && nextProps.purchaseReturnPdfNs !== this.props.purchaseReturnPdfNs) {
	        this.setState({ returnPdfFrameLoadedNs: false });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState.returnPDFFrameLoaded !== this.state.returnPDFFrameLoaded && this.state.returnPDFFrameLoaded == false) {
	        return false;
	      }
	      if (nextState.returnPdfFrameLoadedNs !== this.state.returnPdfFrameLoadedNs && this.state.returnPdfFrameLoadedNs == false) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'openCreate',
	    value: function openCreate() {
	      this.setState({ createOpen: true });
	    }
	  }, {
	    key: 'closeCreate',
	    value: function closeCreate() {
	      this.setState({ createOpen: false });
	    }
	  }, {
	    key: 'checkAuthorize',
	    value: function checkAuthorize(password) {
	      this.props.checkPassword(password);
	    }
	  }, {
	    key: 'openCheckAuthorize',
	    value: function openCheckAuthorize(action) {
	      this.props.clearCheckPassword();
	      this.setState({ checkAuthorizeOpen: true, action: action });
	    }
	  }, {
	    key: 'closeCheckAuthorize',
	    value: function closeCheckAuthorize() {
	      this.setState({ checkAuthorizeOpen: false });
	    }
	  }, {
	    key: 'voidPurchaseReturn',
	    value: function voidPurchaseReturn() {
	      var _this2 = this;
	
	      var purchaseReturnID = this.state.selectedRows && this.state.selectedRows[0].PurchaseReturn_id;
	      this.props.voidPurchaseReturn(purchaseReturnID).then(function () {
	        _this2.props.fetchPurchaseReturns(_this2.state.fromDate, _this2.state.toDate, _this2.state.days, _this2.state.status);
	      });
	    }
	
	    // Set product being selected to be currentProduct and navigate user to the edit page
	
	  }, {
	    key: 'setCurrentPurchaseReturn',
	    value: function setCurrentPurchaseReturn(e) {
	      e.preventDefault();
	      var currentPurchaseReturn = this.state.selectedRows[0];
	      this.props.resetCurrentPurchaseReturn();
	      this.props.selectPurchaseReturn(currentPurchaseReturn);
	      this.context.router.push('/purchaseReturn/' + currentPurchaseReturn.PurchaseReturn_id);
	    }
	  }, {
	    key: 'createPurchaseReturn',
	    value: function createPurchaseReturn(e) {
	      e.preventDefault();
	      this.props.resetCurrentPurchaseReturn();
	      this.context.router.push('/purchaseReturn/new');
	    }
	  }, {
	    key: 'createPurchaseCredit',
	    value: function createPurchaseCredit(e) {
	      e.preventDefault();
	      this.props.resetCurrentPurchaseReturn();
	      this.context.router.push('/purchaseReturn/newCredit');
	    }
	  }, {
	    key: 'clickNew',
	    value: function clickNew(e) {
	      e.preventDefault();
	      this.props.resetCurrentPurchaseReturn();
	      this.context.router.push('/purchaseReturn/new');
	    }
	  }, {
	    key: 'renderTable',
	
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    value: function renderTable() {
	      var _this3 = this;
	
	      if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.error)
	        )
	      );else {
	        // Parameters of the react-data-grid
	
	        var tableHeight = window.innerHeight < 900 ? 560 : 560;
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this3.state);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var state = Object.assign({}, _this3.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this3.setState(state);
	        };
	
	        var handleFilterChange = function handleFilterChange(filter) {
	          var newFilters = Object.assign({}, _this3.state.filters);
	          if (filter.filterTerm) {
	            newFilters[filter.column.key] = filter;
	          } else {
	            delete newFilters[filter.column.key];
	          }
	          _this3.setState({ filters: newFilters });
	        };
	
	        // Handle the row select function
	
	        var onRowSelect = function onRowSelect(rows) {
	          _this3.setState({ selectedRows: rows });
	        };
	
	        var VendorNameFormatter = _react2.default.createClass({
	          displayName: 'VendorNameFormatter',
	          render: function render() {
	            if (this.props.value) return _react2.default.createElement(
	              'span',
	              null,
	              this.props.value.Name
	            );else return _react2.default.createElement(
	              'span',
	              { className: 'label label-danger' },
	              '-'
	            );
	          }
	        });
	
	        var VendorNumFormatter = _react2.default.createClass({
	          displayName: 'VendorNumFormatter',
	          render: function render() {
	            if (this.props.value) return _react2.default.createElement(
	              'span',
	              null,
	              this.props.value.VendorNum
	            );else return _react2.default.createElement(
	              'span',
	              { className: 'label label-danger' },
	              '-'
	            );
	          }
	        });
	
	        // Column difinition
	
	        var columns = [{
	          key: 'PRNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_no' }),
	          resizable: true,
	          sortable: true,
	          width: 105,
	          filterable: true
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_name' }),
	          resizable: true,
	          sortable: true,
	          width: 200,
	          filterable: true
	        }, {
	          key: 'ReturnReason',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_reason' }),
	          resizable: true,
	          sortable: true,
	          width: 150,
	          filterable: true
	        }, {
	          key: 'ReturnStatus',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_status' }),
	          resizable: true,
	          sortable: true,
	          width: 150,
	          filterable: true
	        }, {
	          key: 'FinalPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	          resizable: true,
	          sortable: true,
	          width: 105,
	          filterable: true,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'MemoNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'memo_poundsign' }),
	          resizable: true,
	          sortable: true,
	          width: 150,
	          filterable: true
	        }, {
	          key: 'CreateTime',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'created' }),
	          resizable: true,
	          sortable: true,
	          width: 90,
	          filterable: true,
	          formatter: _dateFormat.DateFormatter
	        }];
	
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { style: { maxWidth: '100%' }, id: 'PurchaseReturnList-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'PurchaseReturn_id',
	                onGridSort: handleGridSort,
	                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                onAddFilter: handleFilterChange,
	                columns: columns,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                rowHeight: 25,
	                minHeight: tableHeight,
	                enableRowSelect: 'single',
	                onRowUpdated: this.handleRowUpdated,
	                onRowSelect: onRowSelect })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderPrintIframe',
	    value: function renderPrintIframe() {
	      var returnPDFFrameLoaded = this.state.returnPDFFrameLoaded;
	      var purchaseReturnPdf = this.props.purchaseReturnPdf;
	
	      return _react2.default.createElement(_PrintIframe2.default, {
	        id: 'returnPDF',
	        loaded: returnPDFFrameLoaded,
	        name: 'returnPDF',
	        onLoad: this.handlePrintFrameOnLoad,
	        pdf: purchaseReturnPdf,
	        title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_purchase_return' })
	      });
	    }
	  }, {
	    key: 'renderPrintNsIFrame',
	    value: function renderPrintNsIFrame() {
	      var returnPdfFrameLoadedNs = this.state.returnPdfFrameLoadedNs;
	      var purchaseReturnPdfNs = this.props.purchaseReturnPdfNs;
	
	      return _react2.default.createElement(_PrintIframe2.default, {
	        id: 'returnNsPdf',
	        loaded: returnPdfFrameLoadedNs,
	        name: 'returnNsPDF',
	        onLoad: this.handlePrintFrameNsOnLoad,
	        pdf: purchaseReturnPdfNs,
	        title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_purchase_return_no_$' })
	      });
	    }
	  }, {
	    key: 'checkPermission',
	    value: function checkPermission(permission) {
	      return false;
	    }
	  }, {
	    key: 'getExcelUrl',
	    value: function getExcelUrl() {
	      var fromDate = '1900-01-01';
	      var toDate = '3000-01-01';
	      var returnStatusString = 'ReturnStatus=' + this.state.status;
	      if (this.state.fromDate) {
	        fromDate = (0, _cleanDates.dateFormat)('YYYY-MM-DD', this.state.fromDate);
	      }
	      if (this.state.toDate) {
	        toDate = (0, _cleanDates.dateFormat)('YYYY-MM-DD', this.state.toDate);
	      }
	      var dates = (0, _cleanDates.toFromDates)(this.state.days, fromDate, toDate);
	      // if "all" status is selected, dont pass a ReturnStatus
	      if (this.state.status === 'all') {
	        returnStatusString = '';
	      }
	      return _root_url.ROOT_URL + 'v1/purchase/return/excel/?PostingDate__gte=' + dates.fromDate + '&PostingDate__lte=' + dates.toDate + '&' + returnStatusString + '&Bearer=' + localStorage.getItem('token');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var createDialogStyle = {
	        width: '550px',
	        height: '300px',
	        marginLeft: '-15%'
	      };
	      var height = (this.state.tableHeight + 140).toString();
	      var tableCollapseFix = { height: height };
	      var purchaseReturnID = this.state.selectedRows && this.state.selectedRows[0].PurchaseReturn_id;
	      var voidButtonShouldDisable = !this.state.selectedRows || this.state.selectedRows.length !== 1 || this.props.purchaseReturnIsVoiding || this.state.selectedRows[0].ReturnStatus !== 'Open';
	      // const printUrl = `${ROOT_URL}v1/purchase/return/print/${PurchaseReturn_id}/?Bearer=${localStorage.getItem('token')}`;
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_return' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'purchase-return-list' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { id: 'date-range-picker', className: 'form-horizontal' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'filter-title' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_status' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'colon' },
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 10 },
	                      _react2.default.createElement(
	                        'div',
	                        { id: 'statusFilterRadios', className: 'form-horizontal' },
	                        (0, _genericRadioFilter2.default)({
	                          content: [{
	                            option: 'all',
	                            id: 'all-radio-filter',
	                            name: 'statusFilterRadios',
	                            labelName: 'all'
	                          }, {
	                            option: 'Open',
	                            id: 'open-radio-filter',
	                            name: 'statusFilterRadios',
	                            labelName: 'open'
	                          }, {
	                            option: 'Void',
	                            id: 'void-radio-filter',
	                            name: 'statusFilterRadios',
	                            labelName: 'void'
	                          }, {
	                            option: 'Completed',
	                            id: 'completed-radio-filter',
	                            name: 'statusFilterRadios',
	                            labelName: 'completed'
	                          }],
	                          value: this.state.status,
	                          handleOnClick: this.handleStatusFilterChange,
	                          type: 'buttons'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'filter-title' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_date' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'colon' },
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 10 },
	                      (0, _dateFilterRadios2.default)({
	                        handleOnClick: this.handleDaysFilterChange,
	                        setFromDate: this.setFromDate,
	                        setToDate: this.setToDate,
	                        setToRangeSearch: this.setToRangeSearch,
	                        fromDate: this.state.fromDate,
	                        toDate: this.state.toDate,
	                        Days: this.state.days
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            ' ',
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'position-relative table-collapse-fix' },
	                  _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    { className: 'table-buttons' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'success',
	                        type: 'submit',
	                        onClick: function onClick(event) {
	                          _this4.createPurchaseReturn(event);
	                        },
	                        disabled: !(0, _permissions2.default)('add_purchase_return')
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_purchase_return' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'success',
	                        type: 'submit',
	                        onClick: function onClick(event) {
	                          _this4.createPurchaseCredit(event);
	                        },
	                        disabled: !(0, _permissions2.default)('add_purchase_return')
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_credit' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'warning',
	                        type: 'button',
	                        onClick: function onClick(event) {
	                          _this4.setCurrentPurchaseReturn(event);
	                        },
	                        disabled: !this.state.selectedRows || this.state.selectedRows.length !== 1 || !(0, _permissions2.default)('change_purchase_return')
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	                    ),
	                    _react2.default.createElement(_SpinnerButton2.default, {
	                      bsStyle: 'danger',
	                      disabled: voidButtonShouldDisable || !(0, _permissions2.default)('delete_purchase_return'),
	                      icon: 'fa-trash',
	                      translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'void' }),
	                      loading: this.props.purchaseReturnIsVoiding,
	                      onClick: function onClick() {
	                        _this4.openCheckAuthorize('void');
	                      }
	                    }),
	                    _react2.default.createElement(_SpinnerButton2.default, {
	                      bsStyle: 'primary',
	                      disabled: !this.state.selectedRows || this.state.selectedRows.length !== 1 || this.props.requestingPurchaseReturnPdf || !(0, _permissions2.default)('print_purchase_return'),
	                      icon: 'fa-print',
	                      translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' }),
	                      loading: this.props.requestingPurchaseReturnPdf,
	                      onClick: function onClick() {
	                        _this4.props.printPurchaseReturn(purchaseReturnID);
	                      }
	                    }),
	                    _react2.default.createElement(_SpinnerButton2.default, {
	                      bsStyle: 'primary',
	                      disabled: !this.state.selectedRows || this.state.selectedRows.length !== 1 || this.props.requestingPurchaseReturnPdf || !(0, _permissions2.default)('print_purchase_return'),
	                      icon: 'fa-print',
	                      translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_no_$' }),
	                      loading: this.props.requestingPurchaseReturnPdf,
	                      onClick: function onClick() {
	                        _this4.props.printPurchaseReturnNoSubtotals(purchaseReturnID);
	                      }
	                    }),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'success',
	                        href: this.getExcelUrl(),
	                        disabled: !this.state.rows.length || !(0, _permissions2.default)('print_purchase_return')
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-download' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	                    )
	                  ),
	                  this.renderTable()
	                )
	              )
	            )
	          ),
	          this.renderPrintIframe(),
	          this.renderPrintNsIFrame(),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogStyle,
	              isVisible: this.state.checkAuthorizeOpen,
	              onCloseClicked: this.closeCheckAuthorize
	            },
	            _react2.default.createElement(_confirmActionModal2.default, {
	              'case': 'confirmPassword',
	              closeC: this.checkAuthorize,
	              checkPasswordFailure: this.props.checkPasswordFailure
	            })
	          )
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return PurchaseReturnList;
	}(_react.Component);
	
	// <Row>
	//                     <Button
	//                         bsStyle="primary"
	//                         style={{ marginLeft: '20px' }}
	//                         onClick={this.openCreate}>
	//                         <em className="fa fa-plus" style={{marginRight: "10px"}}/>Add Purchase Return
	//                     </Button>
	//                     <Button
	//                         bsStyle="primary"
	//                         style={{ marginLeft: '20px' }}
	//                         onClick={(event) => { this.setCurrentPurchaseReturn(event) } }
	//                         disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}>
	//                         <em className="fa fa-pencil" style={{marginRight: "10px"}}/>Edit Purchase Return
	//                     </Button>
	//                 </Row>
	//                 <br/>
	//                 {this.renderTable() }
	
	
	PurchaseReturnList.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = PurchaseReturnList;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PurchaseReturnList, 'PurchaseReturnList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseReturnList.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseReturnList.jsx');
	}();

	;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDropzone = __webpack_require__(45);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _moment3 = __webpack_require__(41);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	__webpack_require__(69);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _inputField = __webpack_require__(16);
	
	var _hiddenInputField = __webpack_require__(117);
	
	var _hiddenInputField2 = _interopRequireDefault(_hiddenInputField);
	
	var _isActive = __webpack_require__(96);
	
	var _isActive2 = _interopRequireDefault(_isActive);
	
	var _convertItemPrice = __webpack_require__(116);
	
	var _convertItemPrice2 = _interopRequireDefault(_convertItemPrice);
	
	var _datePicker = __webpack_require__(27);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _productArrayDisabled = __webpack_require__(430);
	
	var _productArrayDisabled2 = _interopRequireDefault(_productArrayDisabled);
	
	var _vendorForm = __webpack_require__(99);
	
	var _vendorForm2 = _interopRequireDefault(_vendorForm);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _moment4.default)(_moment2.default);
	
	var renderPriceField = function renderPriceField(props) {
	    return _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { standalone: true, type: 'text', addonBefore: '$', addonAfter: '.0000' }));
	};
	
	var renderInvoice = function renderInvoice(_ref) {
	    var fields = _ref.fields;
	    return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { type: 'button', className: 'btn btn-green btn-green-default', onClick: function onClick() {
	                                fields.push({}); // pushes empty child field onto the end of the array
	                            } },
	                        _react2.default.createElement('i', null),
	                        ' ',
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_invoice' })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    !fields.length && _react2.default.createElement(
	                        'div',
	                        { className: 'marginTopStyle' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no_invoice' })
	                    ),
	                    fields.map(function (Invoice, index) {
	                        return _react2.default.createElement(
	                            'div',
	                            { key: index },
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: 'marginTopStyle marginBottomStyle' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	                                    index + 1
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    { className: 'col-sm-3 btn btn-warning', type: 'button', onClick: function onClick() {
	                                            fields.remove(index); // remove from index
	                                        } },
	                                    _react2.default.createElement('i', null),
	                                    ' ',
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'remove' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: 'marginBottomStyle' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-3 marginTopStyle' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_invoice_no' }),
	                                    ':'
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 8 },
	                                    _react2.default.createElement(_reduxForm.Field, { name: Invoice + '.VendorInvoiceNum', component: _inputField.DisabledInputField })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: 'marginBottomStyle' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-3 marginTopStyle' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_total' }),
	                                    ':'
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 8 },
	                                    _react2.default.createElement(_reduxForm.Field, { name: Invoice + '.InvoiceTotal', component: renderPriceField })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: 'marginBottomStyle' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-3 marginTopStyle' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_date' }),
	                                    ':'
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 8 },
	                                    _react2.default.createElement(_reduxForm.Field, { name: Invoice + '.InvoiceDate', component: _datePicker.DisabledDatePicker })
	                                )
	                            )
	                        );
	                    })
	                )
	            )
	        )
	    );
	};
	
	var PurchaseScheduleForm = function (_Component) {
	    _inherits(PurchaseScheduleForm, _Component);
	
	    function PurchaseScheduleForm() {
	        _classCallCheck(this, PurchaseScheduleForm);
	
	        var _this = _possibleConstructorReturn(this, (PurchaseScheduleForm.__proto__ || Object.getPrototypeOf(PurchaseScheduleForm)).call(this));
	
	        _this.state = {
	            files: null,
	
	            totalNetWeight: 0,
	            totalShippingWeight: 0,
	            totalPrice: 0,
	
	            priceType: 'FOB',
	
	            calculatedProducts: [],
	
	            vendorInformationOpen: true,
	            oneTimeScheduleOpen: true,
	            purchaseInformationOpen: true,
	            orderHistoryOpen: true,
	            inventoryOpen: true,
	
	            vendorAddress_id: null,
	            vendorContact_id: null,
	            carryType: null,
	            deliverWarehouse_id: null,
	            shippingCost: null,
	            handlingCost: null,
	            miscCost: null,
	            miscCostDetail: null,
	            discount: null,
	            tax: null,
	            finalPrice: null,
	            noteToVendor: null,
	
	            dirty: false,
	
	            rows: [],
	            selectedRows: [],
	            filters: {},
	            sortColumn: null,
	            sortDirection: null
	        };
	        return _this;
	    }
	
	    _createClass(PurchaseScheduleForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {}
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var _props = this.props,
	                currentPurchaseSchedule = _props.currentPurchaseSchedule,
	                currentPurchaseTemplate = _props.currentPurchaseTemplate;
	
	            if (currentPurchaseSchedule) {
	                this.props.fetchPurchaseScheduleDetail(currentPurchaseSchedule.PurchaseSchedule_id).then(function () {
	                    _this2.props.fetchVendors();
	                    _this2.props.fetchProducts();
	                    _this2.props.fetchPaymentTerms();
	                    _this2.props.fetchWarehouses();
	                });
	            } else if (currentPurchaseTemplate) {
	                this.props.convertTemplateToSchedule(currentPurchaseTemplate.PurchaseTemplate_id).then(function () {
	                    _this2.props.fetchVendors();
	                    _this2.props.fetchProducts();
	                    _this2.props.fetchPaymentTerms();
	                    _this2.props.fetchWarehouses();
	                });
	            } else {
	                this.props.fetchVendors();
	                this.props.fetchProducts();
	                this.props.fetchPaymentTerms();
	                this.props.fetchWarehouses();
	            }
	
	            // making a leaving hook to confirm leaving
	            this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.dirty != this.props.dirty) {
	                this.setState({
	                    dirty: nextProps.dirty
	                });
	            }
	
	            // Once user select a vendor, load its address and contacts.
	            if (nextProps.vendorsValue != this.props.vendorsValue && nextProps.vendorsValue != null) {
	                this.props.fetchVendorDetail(nextProps.vendorsValue.value || nextProps.vendorsValue);
	            }
	
	            if (!nextProps.vendorsValue) {
	                this.props.resetCurrentVendor();
	            }
	
	            if (nextProps.currentPurchaseScheduleDetail != this.props.currentPurchaseScheduleDetail && nextProps.currentPurchaseScheduleDetail) {
	                this.props.resetCurrentPurchaseTemplate();
	                this.props.selectPurchaseTemplate(nextProps.currentPurchaseScheduleDetail.PurchaseTemplate);
	                this.setState({ vendorAddress_id: nextProps.currentPurchaseScheduleDetail.PurchaseTemplate.Pickup_VendorAddress_id });
	                var purchaseTemplate = nextProps.currentPurchaseScheduleDetail.PurchaseTemplate;
	                this.setState({ vendorContact_id: purchaseTemplate.Pickup_VendorContact_id,
	                    carryType: purchaseTemplate.CarryType,
	                    deliverWarehouse_id: purchaseTemplate.Deliver_Warehouse_id,
	                    shippingCost: purchaseTemplate.ShippingCost,
	                    handlingCost: purchaseTemplate.HandlingCost,
	                    miscCost: purchaseTemplate.MiscCost,
	                    miscCostDetail: purchaseTemplate.MiscNote,
	                    discount: purchaseTemplate.Discount,
	                    tax: purchaseTemplate.TaxRate,
	                    finalPrice: purchaseTemplate.FinalPrice,
	                    noteToVendor: purchaseTemplate.NoteToVendor,
	                    totalNetWeight: purchaseTemplate.FinalNetWeight,
	                    totalShippingWeight: purchaseTemplate.FinalShippingWeight,
	                    totalPrice: purchaseTemplate.TotalPrice
	                });
	            }
	            if (nextProps.priceTypeValue != this.props.priceTypeValue) {
	                this.setState({ priceType: nextProps.priceTypeValue });
	            }
	
	            // Calculate the sum of the price and weight for products.
	            if (nextProps.products[0] && nextProps.productsValue) {
	                var round = function round(value, decimals) {
	                    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
	                };
	
	                var products = nextProps.products;
	
	
	                var totalPrice = 0;
	                var totalShippingWeight = 0;
	                var totalNetWeight = 0;
	
	                var calculatedProducts = nextProps.productsValue;
	
	                var newRows = [];
	                calculatedProducts.map(function (line) {
	                    var product = {};
	                    if (line.Product_id) {
	                        var index = _lodash2.default.findIndex(products, { 'Product_id': line.Product_id.value || line.Product_id });
	                        if (index > -1) {
	                            product["Product_id"] = products[index].Product_id;
	                            product["Name"] = products[index].Name;
	                            product["ProductNum"] = products[index].ProductNum;
	                            product["Description"] = products[index].Description;
	                            product["EstSalePrice"] = line.EstSalePrice; //products[index].LowestSalePrice;
	                            product["Quantity"] = line.Quantity;
	                            product["EstSaleTotal"] = line.EstSaleTotal;
	                            product["FOBUnitPrice"] = line.FOBUnitPrice; //products[index].RefPrice;
	                            product["ShippingWeight"] = line.TotalShippingWeight;
	                            product["TotalPrice"] = line.TotalPrice;
	                            // product["MeasureUnit"] = line.Product_id.MeasureUnit;
	                            // product["RefNum"] = line.Product_id.RefNum;
	                            newRows = [].concat(_toConsumableArray(newRows), [product]);
	                        }
	                    }
	                    // totalPrice = (parseFloat(totalPrice) + (parseFloat(product.TotalPrice) || 0)).toFixed(2);
	                    // totalShippingWeight = (parseFloat(totalShippingWeight) + (parseFloat(product.TotalShippingWeight) || 0)).toFixed(2);
	                    // totalNetWeight = (parseFloat(totalNetWeight) + (parseFloat(product.TotalNetWeight) || 0)).toFixed(2);
	                });
	                this.setState({ rows: newRows });
	            }
	        }
	
	        // If the form is dirty, ask for confirmation.
	
	    }, {
	        key: 'routerWillLeave',
	        value: function routerWillLeave(nextLocation) {
	            if (this.state.dirty) return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'work_not_saved_warning' });
	        }
	    }, {
	        key: 'title',
	        value: function title() {
	            if (!this.props.params.id) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'content-heading' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_a_new_purchase_schedule' })
	                );
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: 'content-heading' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_purchase_schedule' }),
	                ' ',
	                this.props.currentPurchaseSchedule.PONum
	            );
	        }
	
	        // Render Select options dynamically with the information on the server.
	
	    }, {
	        key: 'renderVendors',
	        value: function renderVendors() {
	            if (this.props.vendorIsLoading) return _react2.default.createElement(_spinner2.default, null); // If vendor is loading, show a spinner.
	            else {
	                    var vendorNameOptions = this.getVendorNameOptions(); // Return a JSON in the format of React-Select's options
	                    var vendorNumOptions = this.getVendorNumOptions();
	                    return _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'marginBottomStyle' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 9 },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_no' })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 8 },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'PurchaseTemplate.Vendor_id', component: _selection.DisabledSelection, options: vendorNumOptions })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement('br', null)
	                    );
	                }
	        }
	    }, {
	        key: 'renderVendorsDetail',
	        value: function renderVendorsDetail() {
	            // if (this.props.vendorIsLoading && !this.props.vendorError) return <Spinner/> // If vendor is loading, show a spinner.
	            if (this.props.vendorError) return _react2.default.createElement(
	                'div',
	                null,
	                'Error'
	            ); // If vendor is loading, show a spinner.
	            else {
	                    var vendorNameOptions = this.getVendorNameOptions(); // Return a JSON in the format of React-Select's options
	                    var vendorNumOptions = this.getVendorNumOptions();
	                    var vendorTelOptions = this.getVendorTelOptions();
	                    return _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 6, id: 'vendor-info' },
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_information' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-xs-4' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-6' },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'PurchaseTemplate.Vendor_id', component: _selection.DisabledSelection, options: vendorNameOptions })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-xs-4' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_no' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-6' },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'PurchaseTemplate.Vendor_id', component: _selection.DisabledSelection, options: vendorNumOptions })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-xs-4' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-6' },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'PurchaseTemplate.Vendor_id', component: _selection.DisabledSelection, options: vendorTelOptions })
	                            )
	                        )
	                    );
	                }
	        }
	
	        // Push vendor name and number in to 2 JSON arrays.
	
	    }, {
	        key: 'getVendorNameOptions',
	        value: function getVendorNameOptions() {
	            var vendorNameOptions = [];
	            this.props.vendors.map(function (vendor) {
	                vendorNameOptions.push({ value: vendor.Vendor_id, label: vendor.Name });
	            });
	            return vendorNameOptions;
	        }
	    }, {
	        key: 'getVendorNumOptions',
	        value: function getVendorNumOptions() {
	            var vendorNumOptions = [];
	            this.props.vendors.map(function (vendor) {
	                vendorNumOptions.push({ value: vendor.Vendor_id, label: vendor.VendorNum });
	            });
	            return vendorNumOptions;
	        }
	    }, {
	        key: 'getVendorTelOptions',
	        value: function getVendorTelOptions() {
	            var vendorNTelOptions = [];
	            this.props.vendors.map(function (vendor) {
	                vendorNTelOptions.push({ value: vendor.Vendor_id, label: vendor.Telephone });
	            });
	            return vendorNTelOptions;
	        }
	    }, {
	        key: 'renderBillingAddress',
	        value: function renderBillingAddress() {
	            var currentVendorDetail = this.props.currentVendorDetail;
	
	            var contact = void 0,
	                phone = void 0,
	                address1 = void 0,
	                address2 = void 0;
	            if (currentVendorDetail) {
	                if (currentVendorDetail.BillingContact) {
	                    contact = currentVendorDetail.BillingContact.FirstName + " " + currentVendorDetail.BillingContact.LastName;
	                    phone = currentVendorDetail.BillingContact.Telephone;
	                }
	                if (currentVendorDetail.BillingAddress) {
	                    address1 = currentVendorDetail.BillingAddress.Street;
	                    address2 = currentVendorDetail.BillingAddress.City + " " + currentVendorDetail.BillingAddress.State + currentVendorDetail.BillingAddress.Zip;
	                }
	            }
	            return _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 6, id: 'billing-info' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'billing_information' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-4' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'contact' }),
	                        ':'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-8' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            contact
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-4' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' }),
	                        ':'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-8' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            phone
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-4' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' }),
	                        ':'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-8' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            address1
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            address2
	                        )
	                    )
	                )
	            );
	        }
	
	        // Once a vendor is chosen, render its shipping address and contacts
	
	    }, {
	        key: 'renderVendorAddress',
	        value: function renderVendorAddress() {
	            if (this.props.vendorDetailIsLoading && !this.props.vendorDetailError) return _react2.default.createElement(_spinner2.default, null); // If vendor is loading, show a spinner.
	            // else if ( this.props.vendorDetailError ) return <div>Error</div> // If vendor is loading, show a spinner.
	            else if (this.props.currentVendorDetail) {
	                    var vendorAddressOptions = this.getVendorAddressOptions();
	                    var vendorContactOptions = this.getVendorContactOptions();
	                    var vendorAddress = this.getDefaultVendorAddress(this.state.vendorAddress_id);
	                    var vendorContact = this.getDefaultVendorContact(this.state.vendorContact_id);
	                    return _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-5 inlineLabel' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_vendor_address' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'PurchaseTemplate.VendorAddress',
	                                    component: _inputField.DisabledInputField,
	                                    placeholder: vendorAddress })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-5 inlineLabel' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_contact' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'PurchaseTemplate.VendorContact',
	                                    component: _inputField.DisabledInputField,
	                                    placeholder: vendorContact })
	                            ),
	                            _react2.default.createElement('br', null),
	                            this.renderVendorContactInformation()
	                        )
	                    );
	                } else return _react2.default.createElement(
	                    'h4',
	                    { className: 'centerStyle' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_please_select_a_vendor' })
	                );
	        }
	    }, {
	        key: 'getVendorAddressOptions',
	        value: function getVendorAddressOptions() {
	            var vendorAddressOptions = [];
	            this.props.currentVendorDetail.ShippingAddress.map(function (address) {
	                vendorAddressOptions.push({ value: address.VendorAddress_id, label: address.Name + ', ' + address.City });
	            });
	            return vendorAddressOptions;
	        }
	    }, {
	        key: 'getDefaultVendorAddress',
	        value: function getDefaultVendorAddress(id) {
	            var address = this.props.currentVendorDetail.ShippingAddress;
	            var index = _lodash2.default.findIndex(address, { 'VendorAddress_id': id });
	            if (index > -1) {
	                var label = address[index].Name + ', ' + address[index].City;
	                return label;
	            }
	            return null;
	        }
	    }, {
	        key: 'getVendorContactOptions',
	        value: function getVendorContactOptions() {
	            var vendorContactOptions = [];
	            this.props.currentVendorDetail.ShippingContact.map(function (contact) {
	                vendorContactOptions.push({ value: contact.VendorContact_id, label: contact.FirstName + ' ' + contact.LastName });
	            });
	            return vendorContactOptions;
	        }
	    }, {
	        key: 'getDefaultVendorContact',
	        value: function getDefaultVendorContact(id) {
	            var contact = this.props.currentVendorDetail.ShippingContact;
	            var index = _lodash2.default.findIndex(contact, { 'VendorContact_id': id });
	            if (index > -1) {
	                var label = contact[index].FirstName + ' ' + contact[index].LastName;
	                return label;
	            }
	            return null;
	        }
	    }, {
	        key: 'renderVendorContactInformation',
	        value: function renderVendorContactInformation() {
	            var _props2 = this.props,
	                currentVendorDetail = _props2.currentVendorDetail,
	                vendorsValue = _props2.vendorsValue,
	                vendorContactValue = _props2.vendorContactValue;
	
	            if (vendorContactValue && currentVendorDetail) {
	                var index = _lodash2.default.findIndex(currentVendorDetail.ShippingContact, { 'VendorContact_id': vendorContactValue });
	                if (index != -1) return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                                ':'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            currentVendorDetail.ShippingContact[index].FirstName + ' ' + currentVendorDetail.ShippingContact[index].LastName
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' }),
	                                ':'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            currentVendorDetail.ShippingContact[index].Email
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' }),
	                                ':'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            currentVendorDetail.ShippingContact[index].Telephone
	                        )
	                    )
	                );
	            }
	        }
	
	        // Render the Array of products.
	
	    }, {
	        key: 'renderProducts',
	        value: function renderProducts() {
	            var _this3 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this3.state);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this3.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this3.setState(state);
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this3.state.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    _this3.setState({ filters: newFilters });
	                };
	                var columns = [{
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true
	                }, {
	                    key: 'RefNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 70,
	                    filterable: true
	                }, {
	                    key: 'Name',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200,
	                    filterable: true
	                }, {
	                    key: 'Description',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 85,
	                    filterable: true
	                }, {
	                    key: 'Quantity',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 45,
	                    filterable: true
	                }, {
	                    key: 'FOBUnitPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }), //fix applied
	                    resizable: true,
	                    sortable: true,
	                    width: 65,
	                    filterable: true
	                }, {
	                    key: 'NetWeight',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 65,
	                    filterable: true
	                }, {
	                    key: 'TotalPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 75,
	                    filterable: true
	                }, {
	                    key: 'TotalNetWeight',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true
	                }, {
	                    key: 'MeasureUnit',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true
	                }, {
	                    key: 'PackageSize',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 70,
	                    filterable: true
	                }, {
	                    key: 'Remark',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	                    resizable: true,
	                    width: 200
	                }];
	                var productNumOptions = this.getProductNumOptions();
	                var productNameOptions = this.getProductNameOptions();
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'react-table-customizer', id: 'PurchaseScheduleForm-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'Product_id',
	                                onGridSort: handleGridSort,
	                                columns: columns,
	                                rowHeight: 25,
	                                minHeight: 215,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize() })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'getProductNumOptions',
	        value: function getProductNumOptions() {
	            var productNumOptions = [];
	            this.props.products.map(function (product) {
	                productNumOptions.push({ value: product.Product_id, label: product.ProductNum });
	            });
	            return productNumOptions;
	        }
	    }, {
	        key: 'getProductNameOptions',
	        value: function getProductNameOptions() {
	            var productNameOptions = [];
	            this.props.products.map(function (product) {
	                productNameOptions.push({ value: product.Product_id, label: product.Name });
	            });
	            return productNameOptions;
	        }
	    }, {
	        key: 'renderCarryTypeShippingMethod',
	        value: function renderCarryTypeShippingMethod() {
	            var carryTypeOptions = [{ value: "Dry", label: "Dry" }, { value: "Refrigerated", label: "Refrigerated" }];
	            var shippingMethodOptions = [{ value: "Truckxi", label: "Truckxi" }, { value: "Own Logistic", label: "Own Logistic" }];
	            var carryType = this.state.carryType;
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 6 },
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'col-sm-5 inlineLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carry_type' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'CarryType',
	                            component: _inputField.DisabledInputField,
	                            placeholder: carryType })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 6 },
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'col-sm-5 inlineLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_method' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'ShippingMethod', component: _selection.DisabledSelection, options: shippingMethodOptions })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderRepeatFrequency',
	        value: function renderRepeatFrequency() {
	            var repeatFreqOptions = [{ value: "Daily", label: "Day" }, { value: "Weekly", label: "Week" }, { value: "Monthly", label: "Month" }];
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    'label',
	                    { className: 'col-xs-4' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'repeat_frequency' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 4 },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'RepeatFrequency', component: _selection2.default, options: repeatFreqOptions })
	                )
	            );
	        }
	    }, {
	        key: 'getDefaultWarehouse',
	        value: function getDefaultWarehouse(id) {
	            var warehouse = this.props.warehouses;
	            var index = _lodash2.default.findIndex(warehouse, { 'Warehouse_id': id });
	            if (index > -1) {
	                var label = warehouse[index].Name;
	                return label;
	            }
	            return null;
	        }
	    }, {
	        key: 'renderWarehouse',
	        value: function renderWarehouse() {
	            if (this.props.warehouseIsLoading) return _react2.default.createElement(_spinner2.default, null); // If group is loading, show a spinner.
	            else {
	                    var warehouseOptions = this.getWarehouseOptions();
	                    var warehouse = this.getDefaultWarehouse(this.state.deliverWarehouse_id);
	                    return _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-5 inlineLabel' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver_warehouse' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Deliver_Warehouse_id',
	                                    component: _inputField.DisabledInputField,
	                                    placeholder: warehouse })
	                            )
	                        )
	                    );
	                }
	        }
	    }, {
	        key: 'getWarehouseOptions',
	        value: function getWarehouseOptions() {
	            var warehouseOptions = [];
	            this.props.warehouses.map(function (warehouse) {
	                warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name });
	            });
	            return warehouseOptions;
	        }
	    }, {
	        key: 'renderRepeatOn',
	        value: function renderRepeatOn(repeatFreq) {
	            if (repeatFreq) repeatFreq = repeatFreq.value || repeatFreq;
	            var dayOptions = [];
	            for (var i = 1; i < 61; i++) {
	                var dayOption = {};
	                dayOption['value'] = i;
	                dayOption['label'] = i;
	                dayOptions.push(dayOption);
	            }
	            var monthOptions = [];
	            for (var _i = 1; _i < 32; _i++) {
	                var monthOption = {};
	                monthOption['value'] = _i;
	                monthOption['label'] = _i;
	                monthOptions.push(monthOption);
	            }
	            var weekOptions = [{ value: 0, label: "Monday" }, { value: 1, label: "Tuesday" }, { value: 2, label: "Wednesday" }, { value: 3, label: "Thursday" }, { value: 4, label: "Friday" }, { value: 5, label: "Saturday" }, { value: 6, label: "Sunday" }];
	
	            var repeatOnOptions = [];
	
	            if (repeatFreq == "Daily") repeatOnOptions = dayOptions;else if (repeatFreq == "Weekly") repeatOnOptions = weekOptions;else if (repeatFreq == "Monthly") repeatOnOptions = monthOptions;
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    'label',
	                    { className: 'col-xs-4' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'repeat_on' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 4 },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'RepeatInterval', component: _selection2.default, options: repeatOnOptions })
	                )
	            );
	        }
	
	        // Render the Paymentterms select.
	
	    }, {
	        key: 'renderPaymentTerms',
	        value: function renderPaymentTerms() {
	            if (this.props.paymentTermsIsLoading) return _react2.default.createElement(_spinner2.default, null); // If group is loading, show a spinner.
	            else {
	                    var paymentTermOptions = this.getPaymentTermOptions();
	                    return _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 10 },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term' })
	                            ),
	                            _react2.default.createElement(_reduxForm.Field, { name: 'PaymentTerm_id', component: _selection.DisabledSelection, options: paymentTermOptions })
	                        )
	                    );
	                }
	        }
	    }, {
	        key: 'getPaymentTermOptions',
	        value: function getPaymentTermOptions() {
	            var paymentTermOptions = [];
	            this.props.paymentTerms.map(function (paymentTerm) {
	                paymentTermOptions.push({ value: paymentTerm.PaymentTerm_id, label: paymentTerm.Name });
	            });
	            return paymentTermOptions;
	        }
	
	        // Implement the Headers which enable the function of collapsible
	
	    }, {
	        key: 'purchaseInformationHeader',
	        value: function purchaseInformationHeader() {
	            var _this4 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { onClick: function onClick() {
	                        return _this4.setState({ purchaseInformationOpen: !_this4.state.purchaseInformationOpen });
	                    } },
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_information' })
	                )
	            );
	        }
	    }, {
	        key: 'orderHistoryHeader',
	        value: function orderHistoryHeader() {
	            var _this5 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { onClick: function onClick() {
	                        return _this5.setState({ orderHistoryOpen: !_this5.state.orderHistoryOpen });
	                    } },
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_history' })
	                )
	            );
	        }
	    }, {
	        key: 'inventoryHeader',
	        value: function inventoryHeader() {
	            var _this6 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { onClick: function onClick() {
	                        return _this6.setState({ inventoryOpen: !_this6.state.inventoryOpen });
	                    } },
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory' })
	                )
	            );
	        }
	    }, {
	        key: 'onDrop',
	        value: function onDrop(files) {
	            this.setState({
	                files: files
	            });
	        }
	    }, {
	        key: 'onOpenClick',
	        value: function onOpenClick() {
	            this.refs.dropzone.open();
	        }
	    }, {
	        key: 'renderPreview',
	        value: function renderPreview() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'preview' })
	                ),
	                _react2.default.createElement('hr', null),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(_reactBootstrap.Image, { src: this.state.files[0].preview, thumbnail: true })
	                    )
	                )
	            );
	        }
	
	        // If the user was directed to the page with a parameter,
	        // then this page is edit page. Otherwise this is a create
	        // page.
	
	    }, {
	        key: 'handleFormSubmit',
	        value: function handleFormSubmit(formProps) {
	            this.setState({ dirty: false });
	            if (!this.props.currentPurchaseSchedule) this.props.createPurchaseSchedule(formProps);else {
	                if (!this.checkPermission("change_purchase_schedule")) this.props.editPurchaseSchedule(formProps);else alert("You have no permission!");
	            }
	        }
	    }, {
	        key: 'checkPermission',
	        value: function checkPermission(permission) {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this7 = this;
	
	            var activeSchedule = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'active_schedule' });
	            var convertItemPrice = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'convert_item_price' });
	            var _props3 = this.props,
	                handleSubmit = _props3.handleSubmit,
	                submitting = _props3.submitting,
	                pristine = _props3.pristine;
	
	            var activeBreadcrumb = this.props.currentPurchaseScheduleDetail ? "edit_purchase_schedule" : "new_purchase_schedule";
	            if (this.props.detailIsLoading && !this.props.detailError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement('br', null),
	                '...',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reading_data' })
	            );else if (this.props.detailError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    this.props.error
	                )
	            );else {
	                return _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb,
	                            { style: this.state.crumbStyle },
	                            _react2.default.createElement(
	                                _reactBootstrap.Breadcrumb.Item,
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_management' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Breadcrumb.Item,
	                                { active: 'true' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: activeBreadcrumb })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { onClick: function onClick() {
	                                        _this7.context.router.push("/purchaseSchedule");
	                                    }, bsStyle: 'danger' },
	                                _react2.default.createElement('em', { className: 'fa fa-close' })
	                            ),
	                            (this.props.isCreating || this.props.isEditing) && _react2.default.createElement(_spinner2.default, null),
	                            this.props.createError && _react2.default.createElement(
	                                'div',
	                                { className: 'alert alert-danger marginTopStyle' },
	                                JSON.stringify(this.props.createError)
	                            ),
	                            this.props.editError && _react2.default.createElement(
	                                'div',
	                                { className: 'alert alert-danger marginTopStyle' },
	                                JSON.stringify(this.props.editError)
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { bsStyle: 'success', disabled: submitting || pristine, type: 'submit' },
	                                _react2.default.createElement('em', { className: 'fa fa-check marginRightStyle' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'set_schedule' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Grid,
	                            { id: 'purchase-schedule-form' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 3 },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Name', component: _inputField.InputField, placeholder: 'Schedule Name' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    'h2',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'scheduled_template' }),
	                                    ' : ',
	                                    this.props.currentPurchaseScheduleDetail ? this.props.currentPurchaseScheduleDetail.PurchaseTemplate.Name : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_template_unavailable' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { id: 'purchase-schedule' },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { xs: 6 },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-xs-4' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'start_date' })
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { xs: 4 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: 'StartDate', component: _datePicker.DatePicker })
	                                            )
	                                        ),
	                                        this.renderRepeatFrequency(),
	                                        this.renderRepeatOn(this.props.repeatFreqValue),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { id: 'is' },
	                                            _react2.default.createElement(_reduxForm.Field, { name: 'IsEnabled', labelName: activeSchedule, component: _isActive2.default })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { xs: 6 },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-xs-2' },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { xs: 8 },
	                                            _react2.default.createElement(_reduxForm.Field, { name: 'Description', component: 'Textarea', className: 'form-control', style: { minHeight: '100px' } })
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    'h2',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_information' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { id: 'vendor-and-billing-information' },
	                                    this.renderVendorsDetail(),
	                                    this.renderBillingAddress()
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    'h2',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_information' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { id: 'purchase-template-table' },
	                                    this.renderProducts()
	                                )
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }]);
	
	    return PurchaseScheduleForm;
	}(_react.Component);
	
	PurchaseScheduleForm.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	
	var _default = (0, _reactRouter.withRouter)(PurchaseScheduleForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(renderPriceField, 'renderPriceField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseScheduleForm.jsx');
	
	    __REACT_HOT_LOADER__.register(renderInvoice, 'renderInvoice', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseScheduleForm.jsx');
	
	    __REACT_HOT_LOADER__.register(PurchaseScheduleForm, 'PurchaseScheduleForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseScheduleForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseScheduleForm.jsx');
	}();

	;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _purchaseScheduleModal = __webpack_require__(637);
	
	var _purchaseScheduleModal2 = _interopRequireDefault(_purchaseScheduleModal);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PurchaseScheduleList = function (_Component) {
	    _inherits(PurchaseScheduleList, _Component);
	
	    function PurchaseScheduleList() {
	        _classCallCheck(this, PurchaseScheduleList);
	
	        var _this = _possibleConstructorReturn(this, (PurchaseScheduleList.__proto__ || Object.getPrototypeOf(PurchaseScheduleList)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	            createOpen: false,
	
	            rows: [],
	            selectedRows: null,
	            filters: {},
	            sortColumn: null,
	            sortDirection: null
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        _this.openCreate = _this.openCreate.bind(_this);
	        _this.closeCreate = _this.closeCreate.bind(_this);
	        return _this;
	    }
	
	    _createClass(PurchaseScheduleList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchPurchaseSchedules();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once products are ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.purchaseSchedules && nextProps.purchaseSchedules != this.props.purchaseSchedules) {
	                console.log("next purchase schedules...");
	                console.log(nextProps.purchaseSchedules);
	                var purchaseSchedules = nextProps.purchaseSchedules;
	                purchaseSchedules.map(function (purchaseSchedule) {
	                    if (purchaseSchedule.RepeatFrequency == "Weekly") {
	                        switch (purchaseSchedule.RepeatInterval) {
	                            case 0:
	                                purchaseSchedule.RepeatInterval = 'Monday';
	                                break;
	                            case 1:
	                                purchaseSchedule.RepeatInterval = 'Tuesday';
	                                break;
	                            case 2:
	                                purchaseSchedule.RepeatInterval = 'Wednesday';
	                                break;
	                            case 3:
	                                purchaseSchedule.RepeatInterval = 'Thursday';
	                                break;
	                            case 4:
	                                purchaseSchedule.RepeatInterval = 'Friday';
	                                break;
	                            case 5:
	                                purchaseSchedule.RepeatInterval = 'Saturday';
	                                break;
	                            case 6:
	                                purchaseSchedule.RepeatInterval = 'Sunday';
	                                break;
	
	                        }
	                    }
	                });
	                console.log(purchaseSchedules);
	                this.setState({
	                    rows: purchaseSchedules
	                });
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	        }
	    }, {
	        key: 'openCreate',
	        value: function openCreate() {
	            this.setState({ createOpen: true });
	        }
	    }, {
	        key: 'closeCreate',
	        value: function closeCreate() {
	            this.setState({ createOpen: false });
	        }
	
	        // Set product being selected to be currentProduct and navigate user to the edit page
	
	    }, {
	        key: 'setCurrentPurchaseSchedule',
	        value: function setCurrentPurchaseSchedule(e) {
	            e.preventDefault();
	            var currentPurchaseSchedule = this.state.selectedRows[0];
	            this.props.resetCurrentPurchaseSchedule();
	            this.props.selectPurchaseSchedule(currentPurchaseSchedule);
	            this.context.router.push('/purchaseSchedule/' + currentPurchaseSchedule.PurchaseSchedule_id);
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            this.props.resetCurrentPurchaseSchedule();
	            this.context.router.push('/purchaseSchedule/new');
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this2 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var tableHeight = window.innerHeight < 900 ? 650 : 650;
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this2.setState(state);
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this2.state.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    _this2.setState({ filters: newFilters });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    _this2.setState({ selectedRows: rows });
	                };
	
	                //Custom Formatter component
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'Name',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'Description',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200,
	                    filterable: true
	                }, {
	                    key: 'RepeatFrequency',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'repeat_frequency' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200,
	                    filterable: true
	                }, {
	                    key: 'RepeatInterval',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'repeat_interval' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 180,
	                    filterable: true
	                }, {
	                    key: 'StartDate',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'start_date' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120,
	                    filterable: true,
	                    formatter: DateFormatter
	                }, {
	                    key: 'NextExecuteDate',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'next_execute_date' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 160,
	                    filterable: true,
	                    formatter: DateFormatter
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '100%' }, id: 'PurchaseScheduleList-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'PurchaseSchedule_id',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                rowHeight: 25,
	                                minHeight: tableHeight,
	                                enableRowSelect: 'single',
	                                onRowUpdated: this.handleRowUpdated,
	                                onRowSelect: onRowSelect })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'checkPermission',
	        value: function checkPermission(permission) {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var createANewPurchaseSchedule = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_a_purchase_schedule' });
	            var createDialogStyle = {
	                width: '520px',
	                marginLeft: '-12%'
	            };
	            return (
	                //---------------
	                // Begin HTML
	                //---------------
	                _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_management' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            { active: 'true' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_schedule' })
	                        )
	                    ),
	                    ' ',
	                    _react2.default.createElement(
	                        _reactBootstrap.Grid,
	                        { id: 'purchase-schedule-list' },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_schedule' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { className: 'position-relative table-collapse-fix' },
	                            _react2.default.createElement(
	                                _reactBootstrap.ButtonToolbar,
	                                { className: 'table-buttons' },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        bsStyle: 'success',
	                                        type: 'button',
	                                        onClick: this.openCreate,
	                                        disabled: this.checkPermission("add_purchase_schedule") },
	                                    _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        bsStyle: 'warning',
	                                        type: 'button',
	                                        onClick: function onClick(event) {
	                                            _this3.setCurrentPurchaseSchedule(event);
	                                        },
	                                        disabled: !this.state.selectedRows || this.state.selectedRows.length != 1 },
	                                    _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	                                )
	                            ),
	                            this.renderTable()
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactSkylight.SkyLightStateless,
	                        { dialogStyles: createDialogStyle, isVisible: this.state.createOpen, onCloseClicked: function onCloseClicked() {
	                                _this3.closeCreate();
	                            }, title: createANewPurchaseSchedule },
	                        _react2.default.createElement(_purchaseScheduleModal2.default, { closeC: this.closeCreate })
	                    )
	                )
	                //---------------
	                // End HTML
	                //---------------
	
	            );
	        }
	    }]);
	
	    return PurchaseScheduleList;
	}(_react.Component);
	
	PurchaseScheduleList.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = PurchaseScheduleList;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(PurchaseScheduleList, 'PurchaseScheduleList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseScheduleList.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseScheduleList.jsx');
	}();

	;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PurchaseScheduleModal = function (_Component) {
	    _inherits(PurchaseScheduleModal, _Component);
	
	    function PurchaseScheduleModal() {
	        _classCallCheck(this, PurchaseScheduleModal);
	
	        return _possibleConstructorReturn(this, (PurchaseScheduleModal.__proto__ || Object.getPrototypeOf(PurchaseScheduleModal)).apply(this, arguments));
	    }
	
	    _createClass(PurchaseScheduleModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.fetchPurchaseTemplates();
	        }
	    }, {
	        key: 'handleFormSubmit',
	        value: function handleFormSubmit(formProps) {
	            if (formProps.PurchaseTemplate_id) this.setPurchaseTemplate(formProps.PurchaseTemplate_id.value);else this.context.router.push('purchaseSchedule/new');
	        }
	    }, {
	        key: 'setPurchaseTemplate',
	        value: function setPurchaseTemplate(id) {
	            var _props = this.props,
	                resetCurrentPurchaseTemplate = _props.resetCurrentPurchaseTemplate,
	                resetCurrentPurchaseSchedule = _props.resetCurrentPurchaseSchedule,
	                purchaseTemplates = _props.purchaseTemplates,
	                selectPurchaseTemplate = _props.selectPurchaseTemplate;
	
	            resetCurrentPurchaseTemplate();
	            resetCurrentPurchaseSchedule();
	            if (id) {
	                var index = _lodash2.default.findIndex(purchaseTemplates, { 'PurchaseTemplate_id': id });
	                selectPurchaseTemplate(purchaseTemplates[index]);
	                // this.context.router.push('/purchaseQuote/'+purchaseTemplates[index].PurchaseTemplate_id);
	            }
	            this.context.router.push('/purchaseSchedule/new');
	        }
	    }, {
	        key: 'renderPurchaseTemplates',
	        value: function renderPurchaseTemplates() {
	            if (this.props.isLoading) return _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 12, className: 'marginTopStyle' },
	                _react2.default.createElement(_spinner2.default, null)
	            ); // If group is loading, show a spinner.
	            else {
	                    var purchaseTemplateOptions = this.getPurchaseTemplateOptions();
	                    return _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12, className: 'marginTopStyle' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'centerStyle' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_select_a_purchase_template' })
	                        ),
	                        _react2.default.createElement(_reduxForm.Field, { name: 'PurchaseTemplate_id', component: _selection2.default, options: purchaseTemplateOptions })
	                    );
	                }
	        }
	    }, {
	        key: 'getPurchaseTemplateOptions',
	        value: function getPurchaseTemplateOptions() {
	            var purchaseTemplateOptions = [];
	            this.props.purchaseTemplates.map(function (purchaseTemplate) {
	                purchaseTemplateOptions.push({ value: purchaseTemplate.PurchaseTemplate_id, label: purchaseTemplate.Name });
	            });
	            return purchaseTemplateOptions;
	        }
	
	        // Once User choose a Template, show him some detail
	
	    }, {
	        key: 'renderTemplateDetail',
	        value: function renderTemplateDetail(id) {
	            var purchaseTemplates = this.props.purchaseTemplates;
	
	            var index = _lodash2.default.findIndex(purchaseTemplates, { 'PurchaseTemplate_id': id });
	            var vendorName = purchaseTemplates[index].Vendor_id__Name;
	            var updateTime = purchaseTemplates[index].UpdateTime;
	            var PONum = purchaseTemplates[index].PONum;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_template_no' }),
	                        ': ',
	                        PONum
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_name' }),
	                        ': ',
	                        vendorName
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'update_time' }),
	                        ': ',
	                        updateTime
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                handleSubmit = _props2.handleSubmit,
	                closeC = _props2.closeC,
	                submitting = _props2.submitting,
	                pristine = _props2.pristine,
	                purchaseTemplateValue = _props2.purchaseTemplateValue;
	
	            return _react2.default.createElement(
	                'form',
	                { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    this.renderPurchaseTemplates()
	                ),
	                purchaseTemplateValue && this.renderTemplateDetail(purchaseTemplateValue.value),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { action: 'submit', className: 'btn btn-primary col-sm-11 buttonStyle', disabled: submitting },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_select_a_purchase_template' })
	                    )
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-danger col-sm-11 buttonStyle', onClick: function onClick(event) {
	                                event.preventDefault();closeC();
	                            } },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PurchaseScheduleModal;
	}(_react.Component);
	
	PurchaseScheduleModal.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = PurchaseScheduleModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(PurchaseScheduleModal, 'PurchaseScheduleModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseScheduleModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseScheduleModal.jsx');
	}();

	;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactDropzone = __webpack_require__(45);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _moment3 = __webpack_require__(41);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	__webpack_require__(69);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _selection = __webpack_require__(21);
	
	var _detailedSelection = __webpack_require__(82);
	
	var _inputField = __webpack_require__(16);
	
	var _hiddenInputField = __webpack_require__(117);
	
	var _hiddenInputField2 = _interopRequireDefault(_hiddenInputField);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _vendorForm = __webpack_require__(99);
	
	var _vendorForm2 = _interopRequireDefault(_vendorForm);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _moment4.default)(_moment2.default);
	
	var renderPriceField = function renderPriceField(props) {
	    return _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { standalone: true, type: 'text', addonBefore: '$', addonAfter: '.0000' }));
	};
	
	var renderNameField = function (_Component) {
	    _inherits(renderNameField, _Component);
	
	    function renderNameField() {
	        _classCallCheck(this, renderNameField);
	
	        return _possibleConstructorReturn(this, (renderNameField.__proto__ || Object.getPrototypeOf(renderNameField)).apply(this, arguments));
	    }
	
	    _createClass(renderNameField, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var formClass = (0, _classnames2.default)({ 'hidden': !this.props.input.nameOnEdit });
	            return _react2.default.createElement(_reactBootstrap.Input, _extends({}, this.props.input, {
	                className: formClass,
	                standalone: true,
	                type: 'text',
	                onBlur: function onBlur() {
	                    _this2.props.input.showName();
	                    _this2.props.input.onBlur();
	                } }));
	        }
	    }]);
	
	    return renderNameField;
	}(_react.Component);
	
	var renderConvertItemPrice = function renderConvertItemPrice(props) {
	    var titleClass = (0, _classnames2.default)({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'control-label', 'col-sm-4');
	    return _react2.default.createElement(
	        'div',
	        { className: 'optionStyle' },
	        _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 12 },
	                props.meta.touched && props.meta.error && _react2.default.createElement(
	                    'span',
	                    { className: 'parsley-error-message' },
	                    props.meta.error
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	                'label',
	                _defineProperty({ className: 'centerStyle' }, 'className', titleClass),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'convert_item_price' }),
	                ' (*) '
	            ),
	            _react2.default.createElement(_reactBootstrap.Col, { sm: 3 }),
	            _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 2 },
	                _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { type: 'radio', value: 'FOB', checked: props.input.value != "CIF" })),
	                    ' ',
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fob' })
	                )
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 2 },
	                _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { type: 'radio', value: 'CIF', checked: props.input.value == "CIF" })),
	                    ' ',
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cif' })
	                )
	            )
	        )
	    );
	};
	
	var renderDatePicker = function renderDatePicker(props) {
	    return _react2.default.createElement(_DateTimePicker2.default, {
	        format: 'YYYY-MM-DD',
	        defaultValue: null,
	        time: false,
	        onChange: function onChange(name) {
	            return props.input.onChange(name);
	        },
	        value: props.input.value || null });
	};
	
	var renderInvoice = function renderInvoice(_ref) {
	    var fields = _ref.fields;
	    return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { type: 'button', className: 'btn btn-green btn-green-default', onClick: function onClick() {
	                                fields.push({}); // pushes empty child field onto the end of the array
	                            } },
	                        _react2.default.createElement('i', null),
	                        ' ',
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_invoice' })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    !fields.length && _react2.default.createElement(
	                        'div',
	                        { className: 'marginTopStyle' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no_invoice' })
	                    ),
	                    fields.map(function (Invoice, index) {
	                        return _react2.default.createElement(
	                            'div',
	                            { key: index },
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: 'marginTopStyle marginBottomStyle' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	                                    index + 1
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    { className: 'col-sm-3 btn btn-warning', type: 'button', onClick: function onClick() {
	                                            fields.remove(index); // remove from index
	                                        } },
	                                    _react2.default.createElement('i', null),
	                                    ' Remove'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: 'marginBottomStyle' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-3 marginTopStyle' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_invoice_no' }),
	                                    ':'
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 8 },
	                                    _react2.default.createElement(_reduxForm.Field, { name: Invoice + '.VendorInvoiceNum', component: _inputField.InputField })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: 'marginBottomStyle' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-3 marginTopStyle' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_total' }),
	                                    ':'
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 8 },
	                                    _react2.default.createElement(_reduxForm.Field, { name: Invoice + '.InvoiceTotal', component: renderPriceField })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: 'marginBottomStyle' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-3 marginTopStyle' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_date' }),
	                                    ':'
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 8 },
	                                    _react2.default.createElement(_reduxForm.Field, { name: Invoice + '.InvoiceDate', component: renderDatePicker })
	                                )
	                            )
	                        );
	                    })
	                )
	            )
	        )
	    );
	};
	
	var PurchaseTemplateForm = function (_Component2) {
	    _inherits(PurchaseTemplateForm, _Component2);
	
	    function PurchaseTemplateForm() {
	        _classCallCheck(this, PurchaseTemplateForm);
	
	        var _this3 = _possibleConstructorReturn(this, (PurchaseTemplateForm.__proto__ || Object.getPrototypeOf(PurchaseTemplateForm)).call(this));
	
	        _this3.state = {
	            files: null,
	
	            firstRender: false,
	
	            productInfo: null,
	            totalNetWeight: 0,
	            totalShippingWeight: 0,
	            totalPrice: 0,
	
	            taxValue: 0,
	            discountValue: 0,
	            priceType: 'FOB',
	            finalPrice: 0,
	            miscCostValue: 0,
	            handlingCostValue: 0,
	            shippingCostValue: 0,
	
	            defaultRefPrice: 0,
	            refPrice: 0,
	            defaultLowestSalePrice: 0,
	            lowestSalePrice: 0,
	            quantity: 0,
	
	            calculatedProducts: [],
	
	            nameOnEdit: false,
	            vendorInformationOpen: true,
	            oneTimeScheduleOpen: true,
	            purchaseInformationOpen: true,
	            orderHistoryOpen: true,
	            inventoryOpen: true,
	
	            dirty: false,
	
	            rows: [],
	            selectedRows: [],
	            filters: {},
	            sortColumn: null,
	            sortDirection: null
	        };
	        _this3.showName = _this3.showName.bind(_this3);
	        _this3.handleMiscCostChange = _this3.handleMiscCostChange.bind(_this3);
	        _this3.handleShippingCostChange = _this3.handleShippingCostChange.bind(_this3);
	        _this3.handleHandlingCostChange = _this3.handleHandlingCostChange.bind(_this3);
	        _this3.handleDiscountChange = _this3.handleDiscountChange.bind(_this3);
	        _this3.handleTaxChange = _this3.handleTaxChange.bind(_this3);
	        _this3.handleUnitPriceChange = _this3.handleUnitPriceChange.bind(_this3);
	        _this3.handleLowestSalePriceChange = _this3.handleLowestSalePriceChange.bind(_this3);
	        _this3.handleQuantityChange = _this3.handleQuantityChange.bind(_this3);
	        return _this3;
	    }
	
	    _createClass(PurchaseTemplateForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.fetchSimplifiedProducts();
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this4 = this;
	
	            var currentPurchaseTemplate = this.props.currentPurchaseTemplate;
	
	            if (currentPurchaseTemplate) {
	                this.props.fetchPurchaseTemplateDetail(currentPurchaseTemplate.PurchaseTemplate_id).then(function () {
	                    _this4.props.fetchVendors();
	                    _this4.props.fetchPaymentTerms();
	                    _this4.props.fetchWarehouses();
	                });
	            } else {
	                this.props.fetchVendors();
	                this.props.fetchPaymentTerms();
	                this.props.fetchWarehouses();
	            }
	
	            // making a leaving hook to confirm leaving
	            this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.productInformation && nextProps.productInformation != this.props.productInformation) {
	                var products = this.props.products;
	                var productInformation = nextProps.productInformation;
	                var index = _lodash2.default.findIndex(products, { 'Product_id': productInformation.value || productInformation });
	                if (products[index]) this.props.fetchProductInfo(products[index].Product_id);
	            }
	            if (nextProps.productInfo && nextProps.productInfo != this.props.productInfo) {
	                this.setState({ productInfo: nextProps.productInfo });
	            }
	            if (nextProps.miscCostValue && nextProps.miscCostValue != this.props.miscCostValue) {
	                this.setState({ miscCostValue: nextProps.miscCostValue });
	            }
	            if (nextProps.handlingCostValue && nextProps.handlingCostValue != this.props.handlingCostValue) {
	                this.setState({ handlingCostValue: nextProps.handlingCostValue });
	            }
	            if (nextProps.shippingCostValue && nextProps.shippingCostValue != this.props.shippingCostValue) {
	                this.setState({ shippingCostValue: nextProps.shippingCostValue });
	            }
	            if (nextProps.dirty != this.props.dirty) {
	                this.setState({
	                    dirty: nextProps.dirty
	                });
	            }
	
	            // Once user select a vendor, load its address and contacts.
	            if (nextProps.vendorsValue != this.props.vendorsValue) {
	                if (this.refs.Products && !this.state.firstRender) {
	                    this.refs.Products.getRenderedComponent().props.fields.removeAll();
	                }
	                if (nextProps.vendorsValue != null) {
	                    this.props.fetchVendorDetail(nextProps.vendorsValue.value || nextProps.vendorsValue);
	                    this.props.fetchProductsByVendor(nextProps.vendorsValue.value || nextProps.vendorsValue);
	                }
	                if (this.state.firstRender) this.state.firstRender = false;
	            }
	
	            // Also, if vendor has been chosen in the template user'll work on, load related products.
	            if (nextProps.currentPurchaseTemplateDetail != this.props.currentPurchaseTemplateDetail && nextProps.currentPurchaseTemplateDetail) {
	                var currentPurchaseTemplateDetail = nextProps.currentPurchaseTemplateDetail;
	                if (currentPurchaseTemplateDetail.Purchase_Template_Line != null) {
	                    var newRows = [];
	                    currentPurchaseTemplateDetail.Purchase_Template_Line.map(function (line) {
	                        var newProduct = {};
	                        newProduct["Product_id"] = line.Product_id.Product_id;
	                        newProduct["Name"] = line.Product_id.Name;
	                        newProduct["EstSalePrice"] = line.EstSalePrice; //products[index].LowestSalePrice;
	                        newProduct["Quantity"] = line.Quantity;
	                        newProduct["EstSaleTotal"] = line.EstSalePrice * line.Quantity;
	
	                        newProduct["ProductNum"] = line.Product_id.ProductNum;
	                        newProduct["Description"] = line.Product_id.Description;
	                        newProduct["MeasureUnit"] = line.Product_id.MeasureUnit;
	                        newProduct["FOBUnitPrice"] = line.FOBUnitPrice; //products[index].RefPrice;
	                        newProduct["ShippingWeight"] = line.Product_id.ShippingWeight;
	                        newProduct["NetWeight"] = line.Product_id.NetWeight;
	                        newProduct["TotalNetWeight"] = line.Product_id.NetWeight * line.Quantity;
	                        newProduct["TotalShippingWeight"] = line.Product_id.ShippingWeight * line.Quantity;
	                        newProduct["RefNum"] = line.Product_id.RefNum;
	                        newProduct["TotalPrice"] = line.Quantity * line.FOBUnitPrice;
	
	                        newRows = [].concat(_toConsumableArray(newRows), [newProduct]);
	                    });
	                    var newTotalShippingWeight = currentPurchaseTemplateDetail.FinalShippingWeight;
	                    var newTotalNetWeight = currentPurchaseTemplateDetail.FinalNetWeight;
	                    var newTotalPrice = currentPurchaseTemplateDetail.TotalPrice;
	                    var finalPrice = currentPurchaseTemplateDetail.FinalPrice;
	                    var taxValue = currentPurchaseTemplateDetail.TaxRate;
	                    var discountValue = currentPurchaseTemplateDetail.Discount;
	                    this.setState({ rows: newRows,
	                        totalShippingWeight: newTotalShippingWeight,
	                        totalNetWeight: newTotalNetWeight,
	                        totalPrice: newTotalPrice,
	                        finalPrice: finalPrice,
	                        taxValue: taxValue,
	                        discountValue: discountValue
	                    });
	                }
	
	                this.setState({ firstRender: true });
	            }
	
	            if (!nextProps.vendorsValue) {
	                this.props.resetCurrentVendor();
	            }
	
	            if (nextProps.priceTypeValue != this.props.priceTypeValue) {
	                this.setState({ priceType: nextProps.priceTypeValue });
	            }
	
	            // Calculate the sum of the price and weight for products.
	
	            if (nextProps.products[0] && nextProps.productsValue) {
	                var round = function round(value, decimals) {
	                    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
	                };
	
	                // calculatedProducts.map(
	                //     product => {
	                //         if(product.Product_id) {
	                //             const index = _.findIndex(products, { 'Product_id': product.Product_id.value || product.Product_id });
	                //             if (index > -1) {
	                //                 product['Title'] = products[index].Name+' No. '+ products[index].ProductNum;
	                //                 product['TotalNetWeight'] = ((parseFloat(products[index].NetWeight) || 0) * (parseFloat(product.Quantity) || 0)).toFixed(2);
	                //                 product['TotalShippingWeight'] = ((parseFloat(products[index].ShippingWeight) || 0) * (parseFloat(product.Quantity) || 0)).toFixed(2);
	                //                 product['TotalPrice'] = ((parseFloat(product.FOBUnitPrice) || 0) * (parseFloat(product.Quantity) || 0)).toFixed(2);
	                //                 product['EstSaleTotal'] = ((parseFloat(product.EstSalePrice) || 0) * (parseFloat(product.Quantity) || 0)).toFixed(2);
	                //
	                //             }
	                //         } else {
	                //             product['Title'] = "Please Choose a Product";
	                //             product['TotalNetWeight'] = 0;
	                //             product['TotalShippingWeight'] = 0;
	                //             product['TotalPrice'] = 0;
	                //         }
	                //         totalPrice = ( parseFloat(totalPrice) + ( parseFloat(product.TotalPrice) || 0 )).toFixed(2);
	                //         totalShippingWeight = ( parseFloat(totalShippingWeight) + ( parseFloat(product.TotalShippingWeight) || 0 )).toFixed(2);
	                //         totalNetWeight = ( parseFloat(totalNetWeight) + ( parseFloat(product.TotalNetWeight) || 0 )).toFixed(2);
	                //     }
	                // )
	
	                // let { products } = nextProps;
	                var _products = nextProps.products,
	                    _productInformation = nextProps.productInformation,
	                    quantity = nextProps.quantity;
	
	
	                var totalPrice = 0;
	                var _finalPrice = 0;
	                var totalShippingWeight = 0;
	                var totalNetWeight = 0;
	
	                var calculatedProducts = nextProps.productsValue;
	
	                this.setState({
	                    calculatedProducts: calculatedProducts
	                });
	            }
	
	            if (nextProps.allProducts && nextProps.allProducts != this.props.allProducts) {
	                console.log("next product", nextProps.allProducts);
	                var _index = _lodash2.default.findIndex(this.props.simplifiedProducts, { 'Product_id': nextProps.allProducts.value });
	                console.log(_index);
	                if (_index > -1) {
	                    this.props.setPriceValues(this.props.simplifiedProducts[_index].ProductCost, this.props.simplifiedProducts[_index].LowestSalePrice, 'purchaseTemplateForm');
	                }
	            }
	        }
	
	        // If the form is dirty, ask for confirmation.
	
	    }, {
	        key: 'routerWillLeave',
	        value: function routerWillLeave(nextLocation) {
	            if (this.state.dirty) return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'work_not_saved_warning' });
	        }
	    }, {
	        key: 'title',
	        value: function title() {
	            if (!this.props.params.id) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'content-heading' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_a_new_purchase_template' })
	                );
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: 'content-heading' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_purchase_template' }),
	                ' ',
	                this.props.currentPurchaseTemplate.PONum
	            );
	        }
	    }, {
	        key: 'editName',
	        value: function editName() {
	            this.setState({ nameOnEdit: true });
	        }
	    }, {
	        key: 'showName',
	        value: function showName() {
	            this.setState({ nameOnEdit: false });
	        }
	    }, {
	        key: 'renderName',
	        value: function renderName() {
	            // const { templateNameValue } = this.props;
	            // const { nameOnEdit } = this.state;
	            // const textClass = classNames({ 'hidden': nameOnEdit } )
	            // return (
	            //     <div  style={centerStyle} >
	            //         <h4 className={textClass} onClick={() => this.editName() } style={{ cursor: "pointer"}}>{ templateNameValue || "Click Here To Insert a Name." }</h4>
	            //         <Field name="Name"
	            //                component={renderNameField}
	            //                showName={this.showName}
	            //                nameOnEdit={nameOnEdit}
	            //                placeholder="Template Name" ref="NameField"
	            //                withRef />
	            //     </div>
	            // )
	            return _react2.default.createElement(
	                _reactBootstrap.Col,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'inlineLabel' },
	                        ' ',
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'template_name' }),
	                        ' ',
	                        _react2.default.createElement(
	                            'span',
	                            { style: { color: 'red' } },
	                            '*'
	                        ),
	                        ' '
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 9 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'Name', component: _inputField.InputField, placeholder: 'Template Name' })
	                    )
	                )
	            );
	        }
	
	        // Render Select options dynamically with the information on the server.
	
	    }, {
	        key: 'renderVendors',
	        value: function renderVendors() {
	            if (this.props.vendorIsLoading) return _react2.default.createElement(_spinner2.default, null); // If vendor is loading, show a spinner.
	            else {
	                    var vendorNameOptions = this.getVendorNameOptions(); // Return a JSON in the format of React-Select's options
	                    var vendorNumOptions = this.getVendorNumOptions();
	                    return _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'marginBottomStyle' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 9 },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_no' })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 8 },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Vendor_id', component: _selection.Selection, options: vendorNumOptions })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement('br', null)
	                    );
	                }
	        }
	    }, {
	        key: 'renderVendorsDetail',
	        value: function renderVendorsDetail() {
	            if (this.props.vendorIsLoading && !this.props.vendorError) return _react2.default.createElement(_spinner2.default, null); // If vendor is loading, show a spinner.
	            else if (this.props.vendorError) return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'error' })
	                ); // If vendor is loading, show a spinner.
	                else {
	                        var vendorNameOptions = this.getVendorNameOptions(); // Return a JSON in the format of React-Select's options
	                        var vendorNumOptions = this.getVendorNumOptions();
	                        return _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { className: 'marginBottomStyle' },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 6 },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-6 inlineLabel' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_name' }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            { style: { color: 'red' } },
	                                            '*'
	                                        ),
	                                        ' '
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _react2.default.createElement(_reduxForm.Field, { name: 'Vendor_id', component: _selection.Selection, options: vendorNameOptions })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 6 },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-sm-6 inlineLabel' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_no' }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            { style: { color: 'red' } },
	                                            '*'
	                                        ),
	                                        ' '
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _react2.default.createElement(_reduxForm.Field, { name: 'Vendor_id', component: _selection.Selection, options: vendorNumOptions })
	                                    )
	                                ),
	                                _react2.default.createElement('br', null)
	                            )
	                        );
	                    }
	        }
	
	        // Push vendor name and number in to 2 JSON arrays.
	
	    }, {
	        key: 'getVendorNameOptions',
	        value: function getVendorNameOptions() {
	            var vendorNameOptions = [];
	            this.props.vendors.map(function (vendor) {
	                vendorNameOptions.push({ value: vendor.Vendor_id, label: vendor.Name });
	            });
	            return vendorNameOptions;
	        }
	    }, {
	        key: 'getVendorNumOptions',
	        value: function getVendorNumOptions() {
	            var vendorNumOptions = [];
	            this.props.vendors.map(function (vendor) {
	                vendorNumOptions.push({ value: vendor.Vendor_id, label: vendor.VendorNum });
	            });
	            return vendorNumOptions;
	        }
	    }, {
	        key: 'renderBillingAddress',
	        value: function renderBillingAddress() {
	            var _props = this.props,
	                vendorsValue = _props.vendorsValue,
	                currentVendorDetail = _props.currentVendorDetail;
	
	            if (currentVendorDetail) {
	                var BillingAddress = currentVendorDetail.BillingAddress.Name + ', ' + currentVendorDetail.BillingAddress.Street + ', ' + currentVendorDetail.BillingAddress.City;
	                return BillingAddress;
	            }
	        }
	
	        // Once a vendor is chosen, render its shipping address and contacts
	
	    }, {
	        key: 'renderVendorAddress',
	        value: function renderVendorAddress() {
	            if (this.props.vendorDetailIsLoading && !this.props.vendorDetailError) return _react2.default.createElement(_spinner2.default, null); // If vendor is loading, show a spinner.
	            else if (this.props.vendorDetailError) return _react2.default.createElement(
	                    'div',
	                    null,
	                    'Error'
	                ); // If vendor is loading, show a spinner.
	                else if (this.props.currentVendorDetail) {
	                        var vendorAddressOptions = this.getVendorAddressOptions();
	                        var vendorContactOptions = this.getVendorContactOptions();
	                        return _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-5 inlineLabel' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_vendor_address' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 6 },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Pickup_VendorAddress_id', component: _selection.Selection, options: vendorAddressOptions })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-5 inlineLabel' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_contact' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 6 },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Pickup_VendorContact_id', component: _selection.Selection, options: vendorContactOptions })
	                                ),
	                                _react2.default.createElement('br', null),
	                                this.renderVendorContactInformation()
	                            )
	                        );
	                    } else return _react2.default.createElement(
	                        'h4',
	                        { className: 'centerStyle' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_please_select_a_vendor' })
	                    );
	        }
	    }, {
	        key: 'getVendorAddressOptions',
	        value: function getVendorAddressOptions() {
	            var vendorAddressOptions = [];
	            this.props.currentVendorDetail.ShippingAddress.map(function (address) {
	                vendorAddressOptions.push({ value: address.VendorAddress_id, label: address.Name + ', ' + address.City });
	            });
	            return vendorAddressOptions;
	        }
	    }, {
	        key: 'getVendorContactOptions',
	        value: function getVendorContactOptions() {
	            var vendorContactOptions = [];
	            this.props.currentVendorDetail.ShippingContact.map(function (contact) {
	                vendorContactOptions.push({ value: contact.VendorContact_id, label: contact.FirstName + ' ' + contact.LastName });
	            });
	            return vendorContactOptions;
	        }
	    }, {
	        key: 'renderVendorContactInformation',
	        value: function renderVendorContactInformation() {
	            var _props2 = this.props,
	                currentVendorDetail = _props2.currentVendorDetail,
	                vendorsValue = _props2.vendorsValue,
	                vendorContactValue = _props2.vendorContactValue;
	
	            if (vendorContactValue && currentVendorDetail) {
	                var index = _lodash2.default.findIndex(currentVendorDetail.ShippingContact, { 'VendorContact_id': vendorContactValue });
	                if (index != -1) return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'Name:'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            currentVendorDetail.ShippingContact[index].FirstName + ' ' + currentVendorDetail.ShippingContact[index].LastName
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'Email:'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            currentVendorDetail.ShippingContact[index].Email
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'Phone:'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            currentVendorDetail.ShippingContact[index].Telephone
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderPaymentStatus',
	        value: function renderPaymentStatus() {
	            var paymentStatusOptions = [{ value: 'Not Paid', label: 'Not Paid' }, { value: 'Partially Paid', label: 'Partially Paid' }, { value: 'Paid', label: 'Paid' }];
	
	            return _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(
	                    'label',
	                    { className: 'col-sm-6 inlineLabel' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_status' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 6 },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'PaymentStatus', component: _selection.Selection, options: paymentStatusOptions })
	                )
	            );
	        }
	    }, {
	        key: 'renderWarehouse',
	        value: function renderWarehouse() {
	            if (this.props.warehouseIsLoading) return _react2.default.createElement(_spinner2.default, null); // If group is loading, show a spinner.
	            else {
	                    var warehouseOptions = this.getWarehouseOptions();
	                    return _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-5 inlineLabel' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver_warehouse' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Deliver_Warehouse_id', component: _selection.Selection, options: warehouseOptions })
	                            )
	                        )
	                    );
	                }
	        }
	    }, {
	        key: 'getWarehouseOptions',
	        value: function getWarehouseOptions() {
	            var warehouseOptions = [];
	            this.props.warehouses.map(function (warehouse) {
	                warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name });
	            });
	            return warehouseOptions;
	        }
	
	        // Render the Array of products.
	
	        // renderProducts() {
	        //     if (!this.props.vendorsValue &&
	        //         (!this.props.initialValues || (this.props.initialValues && !this.props.initialValues.Vendor_id)))
	        //         return <h4>Please Select a Vendor</h4>
	        //     if (this.props.productIsLoading) return <Spinner/> // If group is loading, show a spinner.
	        //     else {
	        //         const { miscCostValue, handlingCostValue, shippingCostValue } = this.props;
	        //         let productNumOptions = this.getProductNumOptions();
	        //         let productNameOptions = this.getProductNameOptions();
	        //         let totalCost = (parseFloat(shippingCostValue || 0) + parseFloat(miscCostValue || 0) + parseFloat(handlingCostValue || 0)).toFixed(2)
	        //         return (
	        //             // <FieldArray name="Purchase_Template_Line"
	        //             //     ref="Products"
	        //             //     component={ProductArray}
	        //             //     productNameOptions={productNameOptions}
	        //             //     productNumOptions={productNumOptions}
	        //             //     calculatedProducts={this.state.calculatedProducts}
	        //             //     productsValue={this.props.productsValue}
	        //             //     products={this.props.products}
	        //             //     priceType={this.state.priceType }
	        //             //     totalPrice={this.state.totalPrice}
	        //             //     totalCost={totalCost}
	        //             //     withRef />
	        //         )
	        //     }
	        // }
	
	    }, {
	        key: 'moveToProductsList',
	        value: function moveToProductsList() {
	            var _props3 = this.props,
	                products = _props3.products,
	                productInformation = _props3.productInformation;
	
	            var quantity = this.state.quantity;
	            var newProduct = {};
	            var index = _lodash2.default.findIndex(products, { 'Product_id': productInformation.value || productInformation });
	            var refPrice = this.state.refPrice || this.state.defaultRefPrice || products[index].FOBUnitPrice || 0;
	            var lowestSalePrice = this.state.lowestSalePrice || this.state.defaultLowestSalePrice || products[index].LowestSalePrice || 0;
	            newProduct["Product_id"] = products[index].Product_id;
	            newProduct["ProductNum"] = products[index].ProductNum;
	            newProduct["Name"] = products[index].Name;
	            newProduct["Description"] = products[index].Description;
	            newProduct["MeasureUnit"] = products[index].MeasureUnit;
	            newProduct["EstSalePrice"] = lowestSalePrice; //products[index].LowestSalePrice;
	            newProduct["FOBUnitPrice"] = refPrice; //products[index].RefPrice;
	            newProduct["ShippingWeight"] = products[index].ShippingWeight;
	            newProduct["NetWeight"] = products[index].NetWeight;
	            newProduct["TotalShippingWeight"] = products[index].ShippingWeight * quantity;
	            newProduct["TotalNetWeight"] = products[index].NetWeight * quantity;
	            newProduct["RefNum"] = products[index].RefNum;
	            newProduct["Quantity"] = quantity;
	            if (products[index].ProductType == "Non-Fixed") newProduct["TotalPrice"] = parseFloat(quantity * refPrice * newProduct.NetWeight).toFixed(2);else newProduct["TotalPrice"] = parseFloat(quantity * refPrice).toFixed(2);
	            newProduct["EstSaleTotal"] = parseFloat(quantity * lowestSalePrice).toFixed(2);
	            var newRows = [].concat(_toConsumableArray(this.state.rows), [newProduct]);
	            var totalShippingWeight = parseFloat(this.state.totalShippingWeight) + quantity * parseFloat(newProduct["ShippingWeight"]);
	            totalShippingWeight = parseFloat(Math.round(totalShippingWeight * 100) / 100).toFixed(2);
	            var totalNetWeight = parseFloat(this.state.totalNetWeight) + quantity * parseFloat(newProduct["NetWeight"]);
	            totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
	            var totalPrice = parseFloat(this.state.totalPrice) + quantity * parseFloat(newProduct["FOBUnitPrice"]);
	            totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	            var discountValue = this.state.discountValue;
	            var taxValue = this.state.taxValue;
	            var finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
	            this.setState.apply(this, _toConsumableArray(this.state).concat([{ rows: newRows,
	                totalShippingWeight: totalShippingWeight,
	                totalNetWeight: totalNetWeight,
	                totalPrice: totalPrice,
	                finalPrice: finalPrice,
	                defaultRefPrice: 0,
	                refPrice: 0,
	                defaultLowestSalePrice: 0,
	                lowestSalePrice: 0,
	                quantity: 0
	            }]));
	        }
	    }, {
	        key: 'moveOffFromProductsList',
	        value: function moveOffFromProductsList() {
	            var newRows = this.state.rows;
	            var totalShippingWeight = 0;
	            var totalNetWeight = 0;
	            var totalPrice = 0;
	            var discountValue = this.state.discountValue;
	            var taxValue = this.state.taxValue;
	
	            newRows = newRows.filter(function (obj) {
	                return obj.isSelected == false || obj.isSelected == null;
	            });
	
	            newRows.map(function (newRow) {
	                totalShippingWeight = parseFloat(totalShippingWeight) + parseFloat(newRow["Quantity"]) * parseFloat(newRow["ShippingWeight"]);
	                totalNetWeight = parseFloat(totalNetWeight) + parseFloat(newRow["Quantity"]) * parseFloat(newRow["NetWeight"]);
	                totalPrice = parseFloat(totalPrice) + parseFloat(newRow["TotalPrice"]);
	            });
	            totalShippingWeight = parseFloat(Math.round(totalShippingWeight * 100) / 100).toFixed(2);
	            totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
	            totalPrice = (parseFloat(Math.round(totalPrice * 100) / 100) + parseFloat(this.state.miscCostValue) + parseFloat(this.state.handlingCostValue) + parseFloat(this.state.shippingCostValue)).toFixed(2);
	            var finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
	            this.setState({ rows: newRows, selectedRows: null, totalShippingWeight: totalShippingWeight, totalNetWeight: totalNetWeight, totalPrice: totalPrice, finalPrice: finalPrice });
	        }
	    }, {
	        key: 'setDefault',
	        value: function setDefault() {
	            var productInformation = this.props.productInformation;
	
	            if (productInformation) {
	                var products = this.props.products;
	                var index = _lodash2.default.findIndex(products, { 'Product_id': productInformation.value || productInformation });
	                if (products[index] != null) {
	                    if (this.state.defaultRefPrice != products[index].RefPrice) this.setState({ defaultRefPrice: products[index].RefPrice });
	                    if (this.state.defaultLowestSalePrice != products[index].LowestSalePrice) this.setState({ defaultLowestSalePrice: products[index].LowestSalePrice });
	                }
	            }
	        }
	    }, {
	        key: 'handleUnitPriceChange',
	        value: function handleUnitPriceChange(event) {
	            this.setState({ refPrice: event.target.value });
	        }
	    }, {
	        key: 'handleLowestSalePriceChange',
	        value: function handleLowestSalePriceChange(event) {
	            this.setState({ lowestSalePrice: event.target.value });
	        }
	    }, {
	        key: 'handleQuantityChange',
	        value: function handleQuantityChange(event) {
	            this.setState({ quantity: event.target.value });
	        }
	    }, {
	        key: 'renderProducts',
	        value: function renderProducts() {
	            var _this5 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this5.state);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    _this5.setState.apply(_this5, _toConsumableArray(_this5.state).concat([{ selectedRows: rows }]));
	                };
	
	                var onRowsSelected = function onRowsSelected(rows) {
	                    var newRows = _this5.state.rows;
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = true;
	                    });
	                    _this5.setState({ rows: newRows });
	                };
	
	                var onRowsDeselected = function onRowsDeselected(rows) {
	                    var newRows = _this5.state.rows;
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = false;
	                    });
	                    _this5.setState({ rows: newRows });
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this5.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this5.setState(state);
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this5.state.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    _this5.setState({ filters: newFilters });
	                };
	
	                var onRowClick = function onRowClick(rowIdx, row) {
	                    _this5.props.fetchSalesOrders();
	                };
	
	                // Handle the editable function
	
	                var handleRowUpdated = function handleRowUpdated(e) {
	
	                    var rows = getRows();
	                    var totalShippingWeight = _this5.state.totalShippingWeight;
	                    var totalNetWeight = _this5.state.totalNetWeight;
	                    var totalPrice = _this5.state.totalPrice;
	                    var discountValue = _this5.state.discountValue;
	                    var taxValue = _this5.state.taxValue;
	                    if (e.updated.Quantity != null) {
	                        var quantity = rows[e.rowIdx].Quantity;
	                        Object.assign(rows[e.rowIdx], e.updated);
	                        Object.assign(rows[e.rowIdx], { TotalPrice: parseFloat(e.updated.Quantity * rows[e.rowIdx].FOBUnitPrice).toFixed(2) });
	                        Object.assign(rows[e.rowIdx], { EstSaleTotal: parseFloat(e.updated.Quantity * rows[e.rowIdx].EstSalePrice).toFixed(2) });
	                        Object.assign(rows[e.rowIdx], { TotalShippingWeight: e.updated.Quantity * rows[e.rowIdx].ShippingWeight });
	                        totalShippingWeight = parseFloat(_this5.state.totalShippingWeight) + (e.updated.Quantity - quantity) * parseFloat(rows[e.rowIdx].ShippingWeight);
	                        totalShippingWeight = parseFloat(Math.round(totalShippingWeight * 100) / 100).toFixed(2);
	                        totalNetWeight = parseFloat(_this5.state.totalNetWeight) + (e.updated.Quantity - quantity) * parseFloat(rows[e.rowIdx].NetWeight);
	                        totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
	                        totalPrice = parseFloat(_this5.state.totalPrice) + (e.updated.Quantity - quantity) * parseFloat(rows[e.rowIdx].FOBUnitPrice);
	                        totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	                    } else if (e.updated.FOBUnitPrice != null) {
	                        var FOBUnitPrice = parseFloat(rows[e.rowIdx].FOBUnitPrice);
	                        Object.assign(rows[e.rowIdx], e.updated);
	                        Object.assign(rows[e.rowIdx], { TotalPrice: parseFloat(e.updated.FOBUnitPrice * rows[e.rowIdx].Quantity).toFixed(2) });
	                        totalPrice = parseFloat(_this5.state.totalPrice) + rows[e.rowIdx].Quantity * (parseFloat(e.updated.FOBUnitPrice) - FOBUnitPrice);
	                        totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	                    } else if (e.updated.EstSalePrice != null) {
	                        var _quantity = rows[e.rowIdx].Quantity;
	                        var lowestSalePrice = rows[e.rowIdx].EstSalePrice;
	                        Object.assign(rows[e.rowIdx], e.updated);
	                        Object.assign(rows[e.rowIdx], { EstSaleTotal: parseFloat(e.updated.EstSalePrice * rows[e.rowIdx].Quantity).toFixed(2) });
	                    }
	
	                    var finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
	                    _this5.setState({ rows: rows, totalShippingWeight: totalShippingWeight, totalNetWeight: totalNetWeight, totalPrice: totalPrice, finalPrice: finalPrice });
	
	                    // // merge updated row with current row and rerender by setting state
	                    // let rows = this.state.rows.slice(0);
	                    // let editedRows = this.state.editedRows.slice(0);
	                    // Object.assign(rows[e.rowIdx], e.updated);
	                    // // if the element is already edited, remove the old one.
	                    //
	                    // editedRows.forEach((element, index) => {
	                    //     if (element.ProductNum === rows[e.rowIdx].ProductNum)
	                    //         editedRows.splice(index, 1)
	                    // }, this);
	                    // // push the row into the editedRows array
	                    // editedRows.push(rows[e.rowIdx]);
	                    // this.setState({
	                    //     rows: rows,
	                    //     editedRows: editedRows
	                    // });
	                };
	
	                //Custom Formatter component
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNameFormatter = _react2.default.createClass({
	                    displayName: 'VendorNameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNumFormatter = _react2.default.createClass({
	                    displayName: 'VendorNumFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.VendorNum
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true
	                }, {
	                    key: 'Name',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'Description',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200,
	                    filterable: true
	                }, {
	                    key: 'MeasureUnit',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'measure_unit' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true
	                }, {
	                    key: 'NetWeight',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_weight' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true
	                }, {
	                    key: 'Quantity',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' }),
	                    resizable: true,
	                    editable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true
	                }, {
	                    key: 'FOBUnitPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price' }),
	                    resizable: true,
	                    editable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true
	                }, {
	                    key: 'TotalPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_price' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'EstSalePrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lowest_sale_dollarsign' }),
	                    resizable: true,
	                    editable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'EstSaleTotal',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'et_sale_total' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'RefNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true
	                }];
	                // this.props.products = this.props.products.bind(this);
	
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                'div',
	                                { style: { maxWidth: '99%' }, id: 'PurchaseTemplateForm-dataGrid1' },
	                                _react2.default.createElement(_reactDataGrid2.default, {
	                                    rowKey: 'Product_id',
	                                    enableCellSelect: true,
	                                    onGridSort: handleGridSort,
	                                    toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                    onAddFilter: handleFilterChange,
	                                    columns: columns,
	                                    rowGetter: rowGetter,
	                                    rowsCount: getSize(),
	                                    enableRowSelect: 'multi',
	                                    onRowUpdated: handleRowUpdated,
	                                    rowSelection: {
	                                        showCheckbox: true,
	                                        enableShiftSelect: true,
	                                        onRowsSelected: onRowsSelected,
	                                        onRowsDeselected: onRowsDeselected,
	                                        selectBy: {
	                                            isSelectedKey: 'isSelected'
	                                        }
	                                    }
	                                })
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'getAllProductNumOptions',
	        value: function getAllProductNumOptions() {
	            var productNumOptions = [{ value: '', label: "No.       |  Name           |  Description                                           |  MeasureUnit" }];
	            this.props.simplifiedProducts.map(function (product) {
	                var text = "                                                                  ";
	                var output = [product.ProductNum.slice(0, 8), text].join('');
	                output = [output.slice(0, 8), '  |  ', product.Name.slice(0, 12), text].join('');
	                if (product.Description) output = [output.slice(0, 26), '  |  ', product.Description.slice(0, 50), text].join('');else output = [output.slice(0, 26), '  |  ', '                                                  ', text].join('');
	                if (product.MeasureUnit) output = [output.slice(0, 83), '  |  ', product.MeasureUnit.slice(0, 10), text].join('');else output = [output.slice(0, 83), '  |  ', '          ', text].join('');
	                output = output.slice(0, 99);
	                productNumOptions.push({ value: product.Product_id, label: output });
	            });
	            return productNumOptions;
	        }
	    }, {
	        key: 'getProductNumOptions',
	        value: function getProductNumOptions() {
	            var productNumOptions = [{ value: '', label: "No.       |  Name           |  Description                                           |  MeasureUnit" }];
	            this.props.products.map(function (product) {
	                var text = "                                                                                                                      ";
	                var output = [product.ProductNum.slice(0, 8), text].join('');
	                output = [output.slice(0, 8), '  |  ', product.Name.slice(0, 12), text].join('');
	                if (product.Description) output = [output.slice(0, 26), '  |  ', product.Description.slice(0, 50), text].join('');else output = [output.slice(0, 26), '  |  ', '                                                  ', text].join('');
	                if (product.MeasureUnit) output = [output.slice(0, 83), '  |  ', product.MeasureUnit.slice(0, 10), text].join('');else output = [output.slice(0, 83), '  |  ', '          ', text].join('');
	                output = output.slice(0, 99);
	                productNumOptions.push({ value: product.Product_id, label: output });
	
	                // productNumOptions.push(
	                //   { value: product.Product_id,
	                //     label: `NO.: ${product.ProductNum}
	                //     NAME: ${product.Name},
	                //     DESCRIPTION: ${product.Description},
	                //     MEASUREUNIT: ${product.MeasureUnit}` })
	            });
	            return productNumOptions;
	        }
	    }, {
	        key: 'getProductNameOptions',
	        value: function getProductNameOptions() {
	            var productNameOptions = [];
	            this.props.products.map(function (product) {
	                productNameOptions.push({ value: product.Product_id, label: product.Name });
	            });
	            return productNameOptions;
	        }
	    }, {
	        key: 'renderCarryTypeShippingMethod',
	        value: function renderCarryTypeShippingMethod() {
	            var carryTypeOptions = [{ value: "Dry", label: "Dry" }, { value: "Refrigerated", label: "Refrigerated" }];
	            var shippingMethodOptions = [{ value: "Truckxi", label: "Truckxi" }, { value: "Own Logistic", label: "Own Logistic" }];
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 6 },
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'col-sm-5 inlineLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carry_type' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'CarryType', component: _selection.Selection, options: carryTypeOptions, defaultValue: { value: "Dry", label: "Dry" } })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 6 },
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'col-sm-5 inlineLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_method' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'ShippingMethod', component: _selection.Selection, options: shippingMethodOptions, defaultValue: { value: "Own Logistic", label: "Own Logistic" } })
	                    )
	                )
	            );
	        }
	
	        // Render the Paymentterms select.
	
	    }, {
	        key: 'renderPaymentTerms',
	        value: function renderPaymentTerms() {
	            if (this.props.paymentTermsIsLoading) return _react2.default.createElement(_spinner2.default, null); // If group is loading, show a spinner.
	            else {
	                    var paymentTermOptions = this.getPaymentTermOptions();
	                    return _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 10 },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term' })
	                            ),
	                            _react2.default.createElement(_reduxForm.Field, { name: 'PaymentTerm_id', component: _selection.Selection, options: paymentTermOptions })
	                        )
	                    );
	                }
	        }
	    }, {
	        key: 'getPaymentTermOptions',
	        value: function getPaymentTermOptions() {
	            var paymentTermOptions = [];
	            this.props.paymentTerms.map(function (paymentTerm) {
	                paymentTermOptions.push({ value: paymentTerm.PaymentTerm_id, label: paymentTerm.Name });
	            });
	            return paymentTermOptions;
	        }
	    }, {
	        key: 'productHeader',
	        value: function productHeader() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_information' })
	                )
	            );
	        }
	    }, {
	        key: 'pickupHeader',
	        value: function pickupHeader() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup' })
	                )
	            );
	        }
	    }, {
	        key: 'deliverHeader',
	        value: function deliverHeader() {
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver_warehouse' })
	                )
	            );
	        }
	    }, {
	        key: 'carryHeader',
	        value: function carryHeader() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carry_type_shipping_method' })
	                )
	            );
	        }
	    }, {
	        key: 'attachmentHeader',
	        value: function attachmentHeader() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'attachment_upload' })
	                )
	            );
	        }
	
	        // Implement the Headers which enable the function of collapsible
	
	    }, {
	        key: 'vendorHeader',
	        value: function vendorHeader() {
	            var _this6 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { onClick: function onClick() {
	                        return _this6.setState({ vendorInformationOpen: !_this6.state.vendorInformationOpen });
	                    } },
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_information' })
	                )
	            );
	        }
	    }, {
	        key: 'oneTimeScheduleHeader',
	        value: function oneTimeScheduleHeader() {
	            var _this7 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { onClick: function onClick() {
	                        return _this7.setState({ oneTimeScheduleOpen: !_this7.state.oneTimeScheduleOpen });
	                    } },
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'one_time_schedule' })
	                )
	            );
	        }
	    }, {
	        key: 'purchaseInformationHeader',
	        value: function purchaseInformationHeader() {
	            var _this8 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { onClick: function onClick() {
	                        return _this8.setState({ purchaseInformationOpen: !_this8.state.purchaseInformationOpen });
	                    } },
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_information' })
	                )
	            );
	        }
	    }, {
	        key: 'orderHistoryHeader',
	        value: function orderHistoryHeader() {
	            var _this9 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { onClick: function onClick() {
	                        return _this9.setState({ orderHistoryOpen: !_this9.state.orderHistoryOpen });
	                    } },
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_history' })
	                )
	            );
	        }
	    }, {
	        key: 'inventoryHeader',
	        value: function inventoryHeader() {
	            var _this10 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { onClick: function onClick() {
	                        return _this10.setState({ inventoryOpen: !_this10.state.inventoryOpen });
	                    } },
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory' })
	                )
	            );
	        }
	    }, {
	        key: 'onDrop',
	        value: function onDrop(files) {
	            this.setState({
	                files: files
	            });
	        }
	    }, {
	        key: 'onOpenClick',
	        value: function onOpenClick() {
	            this.refs.dropzone.open();
	        }
	    }, {
	        key: 'renderPreview',
	        value: function renderPreview() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Preview'
	                ),
	                _react2.default.createElement('hr', null),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(_reactBootstrap.Image, { src: this.state.files[0].preview, thumbnail: true })
	                    )
	                )
	            );
	        }
	
	        // If the user was directed to the page with a parameter,
	        // then this page is edit page. Otherwise this is a create
	        // page.
	
	    }, {
	        key: 'handleFormSubmit',
	        value: function handleFormSubmit(formProps) {
	            this.setState({ dirty: false });
	            if (!this.props.currentPurchaseTemplate) this.props.createPurchaseTemplate(formProps, _reactDataGridAddons.Data.Selectors.getRows(this.state));else {
	                if (!this.checkPermission("change_purchase_template")) this.props.editPurchaseTemplate(formProps, _reactDataGridAddons.Data.Selectors.getRows(this.state));else alert("You have no permission!");
	            }
	        }
	    }, {
	        key: 'handleMiscCostChange',
	        value: function handleMiscCostChange(event) {
	            var totalPrice = parseFloat(this.state.totalPrice);
	            totalPrice = parseFloat(totalPrice || 0) - parseFloat(this.state.miscCostValue || 0) + parseFloat(event.target.value || 0);
	            var discountValue = parseFloat(this.state.discountValue);
	            var taxValue = parseFloat(this.state.taxValue);
	            var finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
	            this.setState({ miscCostValue: event.target.value, totalPrice: totalPrice, finalPrice: finalPrice });
	        }
	    }, {
	        key: 'handleHandlingCostChange',
	        value: function handleHandlingCostChange(event) {
	            var totalPrice = parseFloat(this.state.totalPrice);
	            totalPrice = parseFloat(totalPrice || 0) - parseFloat(this.state.handlingCostValue || 0) + parseFloat(event.target.value || 0);
	            var discountValue = parseFloat(this.state.discountValue);
	            var taxValue = parseFloat(this.state.taxValue);
	            var finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
	            this.setState({ handlingCostValue: event.target.value, totalPrice: totalPrice, finalPrice: finalPrice });
	        }
	    }, {
	        key: 'handleShippingCostChange',
	        value: function handleShippingCostChange(event) {
	            var totalPrice = parseFloat(this.state.totalPrice);
	            totalPrice = parseFloat(totalPrice || 0) - parseFloat(this.state.shippingCostValue || 0) + parseFloat(event.target.value || 0);
	            var discountValue = parseFloat(this.state.discountValue);
	            var taxValue = parseFloat(this.state.taxValue);
	            var finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
	            this.setState({ shippingCostValue: event.target.value, totalPrice: totalPrice, finalPrice: finalPrice });
	        }
	    }, {
	        key: 'handleDiscountChange',
	        value: function handleDiscountChange(event) {
	            var totalPrice = parseFloat(this.state.totalPrice);
	            var taxValue = parseFloat(this.state.taxValue);
	            var finalPrice = (totalPrice * (1 - parseFloat(event.target.value || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
	            // let finalPrice = (totalPrice / (1 - parseFloat(discountValue || 0) / 100.00) * (1 - parseFloat(event.target.value || 0) / 100.00)).toFixed(2);
	            this.setState({ discountValue: event.target.value, finalPrice: finalPrice });
	        }
	    }, {
	        key: 'handleTaxChange',
	        value: function handleTaxChange(event) {
	            var totalPrice = parseFloat(this.state.totalPrice);
	            var discountValue = parseFloat(this.state.discountValue);
	            var finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(event.target.value || 0) / 100.0)).toFixed(2);
	            // let finalPrice = (totalPrice / (1 + parseFloat(taxValue || 0) / 100.00) * (1 + parseFloat(event.target.value || 0) / 100.00)).toFixed(2);
	            this.setState({ taxValue: event.target.value, finalPrice: finalPrice });
	        }
	    }, {
	        key: 'checkPermission',
	        value: function checkPermission(permission) {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this11 = this;
	
	            var productNumOptions = this.getProductNumOptions();
	            var allProductNumOptions = this.getAllProductNumOptions();
	            var _props4 = this.props,
	                handleSubmit = _props4.handleSubmit,
	                submitting = _props4.submitting,
	                pristine = _props4.pristine;
	
	            if (this.props.detailIsLoading && !this.props.detailError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement('br', null),
	                '...',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reading_data' })
	            );else if (this.props.detailError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    this.props.error
	                )
	            );else {
	                var productInfo = this.state.productInfo;
	                return _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    this.title(),
	                    _react2.default.createElement(
	                        'form',
	                        { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 4 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { className: 'panelStyle', header: this.vendorHeader(), collapsible: true, expanded: this.state.vendorInformationOpen },
	                                    _react2.default.createElement(
	                                        'fieldset',
	                                        null,
	                                        this.renderVendorsDetail(),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'billing_address' })
	                                            ),
	                                            !this.props.currentVendorDetail && _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-9' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_please_select_a_vendor' }),
	                                                ' '
	                                            ),
	                                            this.props.currentVendorDetail && _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-9' },
	                                                this.renderBillingAddress()
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { className: 'panelStyle', header: this.purchaseInformationHeader(), collapsible: true, expanded: this.state.purchaseInformationOpen },
	                                    _react2.default.createElement(
	                                        'fieldset',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 3 },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        { className: 'col-sm-12 inlineLabel' },
	                                                        'PO No.'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 9 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'PONum', component: _inputField.DisabledInputField })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_status' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 6 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'PurchaseStatus', component: _inputField.DisabledInputField })
	                                                )
	                                            ),
	                                            this.renderPaymentStatus()
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'fieldset',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchased_by' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 6 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'Purchaser_User_id', component: _inputField.InputField })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_modified_by' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 6 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'Modifier_User_id', component: _inputField.InputField })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 3 },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        { className: 'col-sm-12 inlineLabel' },
	                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' })
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 9 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'NoteToVendor', component: 'Textarea', className: 'form-control', style: { minHeight: '50px' } })
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'fieldset',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_net_weight' })
	                                                ),
	                                                _react2.default.createElement(_reduxForm.Field, { name: 'FinalNetWeight', component: _hiddenInputField2.default, V: this.state.totalNetWeight }),
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 inlineLabel', style: { paddingLeft: '8px' } },
	                                                    this.state.totalNetWeight,
	                                                    ' lb'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_shipping_weight' })
	                                                ),
	                                                _react2.default.createElement(_reduxForm.Field, { name: 'FinalShippingWeight', component: _hiddenInputField2.default, V: this.state.totalShippingWeight }),
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 inlineLabel', style: { paddingLeft: '8px' } },
	                                                    this.state.totalShippingWeight,
	                                                    ' lb'
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'fieldset',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_cost' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 6 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'ShippingCost', component: _inputField.ControlledInputField, placeholder: this.state.shippingCostValue, onChange: this.handleShippingCostChange })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'handling_cost' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 6 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'HandlingCost', component: _inputField.ControlledInputField, placeholder: this.state.handlingCostValue, onChange: this.handleHandlingCostChange })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'misc_cost' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 6 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'MiscCost', component: _inputField.ControlledInputField, placeholder: this.state.miscCostValue, onChange: this.handleMiscCostChange })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 3 },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'misc_cost_detail' })
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 9, style: { float: "left" } },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'MiscNote', component: _inputField.InputField })
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'fieldset',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3 marginTopStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_price' })
	                                            ),
	                                            _react2.default.createElement(_reduxForm.Field, { name: 'TotalPrice', component: _hiddenInputField2.default, V: this.state.totalPrice }),
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-9' },
	                                                '$ ',
	                                                this.state.totalPrice
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 6 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'Discount', component: _inputField.ControlledInputField, placeholder: this.state.discountValue, onChange: this.handleDiscountChange })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 6 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' })
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 6 },
	                                                    _react2.default.createElement(_reduxForm.Field, { name: 'TaxRate', component: _inputField.ControlledInputField, placeholder: this.state.taxValue, onChange: this.handleTaxChange })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-3 marginTopStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' })
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 7 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: 'FinalPrice', component: _hiddenInputField2.default, V: this.state.finalPrice })
	                                            ),
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-9' },
	                                                '$ ',
	                                                this.state.finalPrice
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'fieldset',
	                                        null,
	                                        _react2.default.createElement(_reduxForm.Field, { name: 'ConvertItemPrice', component: renderConvertItemPrice })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { className: 'panelStyle', header: this.inventoryHeader(), collapsible: true, expanded: this.state.inventoryOpen },
	                                    _react2.default.createElement(
	                                        'fieldset',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity_colonsign' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                productInfo ? productInfo.Quantity : 0
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'in_stock_colonsign' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                productInfo ? productInfo.InStock : 0
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'presale' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                productInfo ? productInfo.PreSale : 0
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchased' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                productInfo ? productInfo.Purchased : 0
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'min_limit' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                productInfo ? productInfo.ProductNum.MinStockRange : 0
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    { className: 'col-sm-6 marginTopStyle inlineLabel' },
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'max_limit' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 3 },
	                                                productInfo ? productInfo.ProductNum.MaxStockRange : 0
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'marginBottomStyle' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 3 },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        { className: 'col-sm-12 inlineLabel' },
	                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'default_location' })
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 9 },
	                                                    productInfo && productInfo.Warehouse_id && productInfo.Warehouse_id.Name
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 8 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 12 },
	                                        _react2.default.createElement(
	                                            _reactRouter.Link,
	                                            { to: '/purchaseTemplate', className: 'btn btn-default' },
	                                            _react2.default.createElement('em', { className: 'fa fa-close' })
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            { className: 'btn btn-default', disabled: submitting || pristine },
	                                            _react2.default.createElement('em', { className: 'fa fa-trash' })
	                                        ),
	                                        (this.props.isCreating || this.props.isEditing) && _react2.default.createElement(_spinner2.default, null),
	                                        this.props.createError && _react2.default.createElement(
	                                            'div',
	                                            { className: 'alert alert-danger marginTopStyle' },
	                                            JSON.stringify(this.props.createError)
	                                        ),
	                                        this.props.editError && _react2.default.createElement(
	                                            'div',
	                                            { className: 'alert alert-danger marginTopStyle' },
	                                            JSON.stringify(this.props.editError)
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            { className: 'btn btn-primary pull-right', disabled: submitting || pristine, type: 'submit' },
	                                            _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement('hr', null),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 12 },
	                                        this.renderName()
	                                    )
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Row,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Col,
	                                                    { sm: 12 },
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Row,
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 12 },
	                                                            this.productHeader(),
	                                                            _react2.default.createElement(
	                                                                _reactBootstrap.Tabs,
	                                                                { defaultActiveKey: 1, justified: true },
	                                                                _react2.default.createElement(
	                                                                    _reactBootstrap.Tab,
	                                                                    { eventKey: 1, title: 'Vendor Products' },
	                                                                    _react2.default.createElement(
	                                                                        _reactBootstrap.Row,
	                                                                        null,
	                                                                        _react2.default.createElement(
	                                                                            _reactBootstrap.Col,
	                                                                            { sm: 12 },
	                                                                            _react2.default.createElement(
	                                                                                _reactBootstrap.Row,
	                                                                                null,
	                                                                                _react2.default.createElement(
	                                                                                    _reactBootstrap.Col,
	                                                                                    { sm: 12 },
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 2 },
	                                                                                        _react2.default.createElement(
	                                                                                            'label',
	                                                                                            null,
	                                                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' })
	                                                                                        )
	                                                                                    ),
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 10 },
	                                                                                        _react2.default.createElement(_reduxForm.Field, { name: 'ProductInformation', component: _detailedSelection.DetailedSelection, options: productNumOptions, onChange: this.setDefault() })
	                                                                                    )
	                                                                                )
	                                                                            ),
	                                                                            _react2.default.createElement(
	                                                                                _reactBootstrap.Row,
	                                                                                null,
	                                                                                _react2.default.createElement(
	                                                                                    _reactBootstrap.Col,
	                                                                                    { sm: 4 },
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 6 },
	                                                                                        _react2.default.createElement(
	                                                                                            'label',
	                                                                                            { className: 'col-sm-12 inlineLabel' },
	                                                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' })
	                                                                                        )
	                                                                                    ),
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 6 },
	                                                                                        _react2.default.createElement(_reduxForm.Field, { name: 'Quantity', component: _inputField.ControlledInputField, placeholder: this.state.quantity, onChange: this.handleQuantityChange })
	                                                                                    )
	                                                                                ),
	                                                                                _react2.default.createElement(
	                                                                                    _reactBootstrap.Col,
	                                                                                    { sm: 4 },
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 6 },
	                                                                                        _react2.default.createElement(
	                                                                                            'label',
	                                                                                            { className: 'col-sm-12 inlineLabel' },
	                                                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price' })
	                                                                                        )
	                                                                                    ),
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 6 },
	                                                                                        _react2.default.createElement(_reduxForm.Field, { name: 'FOBUnitPrice', component: _inputField.ControlledInputField, placeholder: this.state.refPrice || this.state.defaultRefPrice, onChange: this.handleUnitPriceChange })
	                                                                                    )
	                                                                                ),
	                                                                                _react2.default.createElement(
	                                                                                    _reactBootstrap.Col,
	                                                                                    { sm: 4 },
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 6 },
	                                                                                        _react2.default.createElement(
	                                                                                            'label',
	                                                                                            { className: 'col-sm-12 inlineLabel' },
	                                                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lowest_sale_dollarsign' })
	                                                                                        )
	                                                                                    ),
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 6 },
	                                                                                        _react2.default.createElement(_reduxForm.Field, { name: 'EstSalePrice', component: _inputField.ControlledInputField, placeholder: this.state.lowestSalePrice || this.state.defaultLowestSalePrice, onChange: this.handleLowestSalePriceChange })
	                                                                                    )
	                                                                                )
	                                                                            )
	                                                                        )
	                                                                    ),
	                                                                    _react2.default.createElement('br', null),
	                                                                    _react2.default.createElement(
	                                                                        _reactBootstrap.Row,
	                                                                        null,
	                                                                        _react2.default.createElement(
	                                                                            _reactBootstrap.Col,
	                                                                            null,
	                                                                            _react2.default.createElement(
	                                                                                _reactBootstrap.Button,
	                                                                                { className: 'btn btn-primary pull-right', onClick: function onClick() {
	                                                                                        return _this11.moveToProductsList();
	                                                                                    } },
	                                                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'move_to_product_list' })
	                                                                            )
	                                                                        ),
	                                                                        _react2.default.createElement(
	                                                                            _reactBootstrap.Col,
	                                                                            null,
	                                                                            _react2.default.createElement(
	                                                                                _reactBootstrap.Button,
	                                                                                { className: 'btn btn-primary pull-right', onClick: function onClick() {
	                                                                                        return _this11.moveOffFromProductsList();
	                                                                                    } },
	                                                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'move_off_from_products_list' })
	                                                                            )
	                                                                        )
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    _reactBootstrap.Tab,
	                                                                    { eventKey: 2, title: 'All Products' },
	                                                                    _react2.default.createElement(
	                                                                        _reactBootstrap.Row,
	                                                                        null,
	                                                                        _react2.default.createElement(
	                                                                            _reactBootstrap.Col,
	                                                                            { sm: 12 },
	                                                                            _react2.default.createElement(
	                                                                                _reactBootstrap.Row,
	                                                                                null,
	                                                                                _react2.default.createElement(
	                                                                                    _reactBootstrap.Col,
	                                                                                    { sm: 12 },
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 2 },
	                                                                                        _react2.default.createElement(
	                                                                                            'label',
	                                                                                            null,
	                                                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' })
	                                                                                        )
	                                                                                    ),
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 10 },
	                                                                                        _react2.default.createElement(_reduxForm.Field, { name: 'AllProducts', component: _detailedSelection.VirtualizedDetailedSelection, options: allProductNumOptions })
	                                                                                    )
	                                                                                )
	                                                                            ),
	                                                                            _react2.default.createElement(
	                                                                                _reactBootstrap.Row,
	                                                                                null,
	                                                                                _react2.default.createElement(
	                                                                                    _reactBootstrap.Col,
	                                                                                    { sm: 4 },
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 6 },
	                                                                                        _react2.default.createElement(
	                                                                                            'label',
	                                                                                            { className: 'col-sm-12 inlineLabel' },
	                                                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' })
	                                                                                        )
	                                                                                    ),
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 6 },
	                                                                                        _react2.default.createElement(_reduxForm.Field, { name: 'AllProd_Quantity', component: _inputField.InputField, placeholder: 0 })
	                                                                                    )
	                                                                                ),
	                                                                                _react2.default.createElement(
	                                                                                    _reactBootstrap.Col,
	                                                                                    { sm: 4 },
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 6 },
	                                                                                        _react2.default.createElement(
	                                                                                            'label',
	                                                                                            { className: 'col-sm-12 inlineLabel' },
	                                                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price' })
	                                                                                        )
	                                                                                    ),
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 6 },
	                                                                                        _react2.default.createElement(_reduxForm.Field, { name: 'AllProd_FOBUnitPrice', component: _inputField.InputField, placeholder: 0 })
	                                                                                    )
	                                                                                ),
	                                                                                _react2.default.createElement(
	                                                                                    _reactBootstrap.Col,
	                                                                                    { sm: 4 },
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 6 },
	                                                                                        _react2.default.createElement(
	                                                                                            'label',
	                                                                                            { className: 'col-sm-12 inlineLabel' },
	                                                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lowest_sale_dollarsign' })
	                                                                                        )
	                                                                                    ),
	                                                                                    _react2.default.createElement(
	                                                                                        _reactBootstrap.Col,
	                                                                                        { sm: 6 },
	                                                                                        _react2.default.createElement(_reduxForm.Field, { name: 'AllProd_EstSalePrice', component: _inputField.InputField, placeholder: 0 })
	                                                                                    )
	                                                                                )
	                                                                            )
	                                                                        )
	                                                                    ),
	                                                                    _react2.default.createElement('br', null),
	                                                                    _react2.default.createElement(
	                                                                        _reactBootstrap.Row,
	                                                                        null,
	                                                                        _react2.default.createElement(
	                                                                            _reactBootstrap.Col,
	                                                                            null,
	                                                                            _react2.default.createElement(
	                                                                                _reactBootstrap.Button,
	                                                                                { className: 'btn btn-primary pull-right', onClick: function onClick() {
	                                                                                        return _this11.moveToProductsListFromAll();
	                                                                                    } },
	                                                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'move_to_product_list' })
	                                                                            )
	                                                                        ),
	                                                                        _react2.default.createElement(
	                                                                            _reactBootstrap.Col,
	                                                                            null,
	                                                                            _react2.default.createElement(
	                                                                                _reactBootstrap.Button,
	                                                                                { className: 'btn btn-primary pull-right', onClick: function onClick() {
	                                                                                        return _this11.moveOffFromProductsList();
	                                                                                    } },
	                                                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'move_off_from_products_list' })
	                                                                            )
	                                                                        )
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(_reactBootstrap.Row, null)
	                                                        )
	                                                    )
	                                                )
	                                            ),
	                                            this.renderProducts()
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Panel,
	                                                    { header: this.pickupHeader(), className: 'panelStyle' },
	                                                    this.renderVendorAddress()
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Panel,
	                                                    { header: this.deliverHeader(), className: 'panelStyle' },
	                                                    this.renderWarehouse()
	                                                ),
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Panel,
	                                                    { header: this.carryHeader(), className: 'panelStyle' },
	                                                    this.renderCarryTypeShippingMethod()
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Panel,
	                                                    { header: this.attachmentHeader(), className: 'panelStyle' },
	                                                    _react2.default.createElement(
	                                                        _reactDropzone2.default,
	                                                        { onDrop: this.onDrop.bind(this), className: 'well dropzone' },
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Button,
	                                                            { className: 'pull-right btn btn-default btn-primary', onClick: this.onOpenClick },
	                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'upload_file' })
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'dz-default dz-message' },
	                                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_drag_drop_attachment' })
	                                                        )
	                                                    ),
	                                                    this.state.files && this.renderPreview()
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_reactBootstrap.Row, null)
	                    )
	                );
	            }
	        }
	    }]);
	
	    return PurchaseTemplateForm;
	}(_react.Component);
	
	PurchaseTemplateForm.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	
	var _default = (0, _reactRouter.withRouter)(PurchaseTemplateForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(renderPriceField, 'renderPriceField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseTemplateForm.jsx');
	
	    __REACT_HOT_LOADER__.register(renderNameField, 'renderNameField', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseTemplateForm.jsx');
	
	    __REACT_HOT_LOADER__.register(renderConvertItemPrice, 'renderConvertItemPrice', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseTemplateForm.jsx');
	
	    __REACT_HOT_LOADER__.register(renderDatePicker, 'renderDatePicker', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseTemplateForm.jsx');
	
	    __REACT_HOT_LOADER__.register(renderInvoice, 'renderInvoice', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseTemplateForm.jsx');
	
	    __REACT_HOT_LOADER__.register(PurchaseTemplateForm, 'PurchaseTemplateForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseTemplateForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseTemplateForm.jsx');
	}();

	;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _constants = __webpack_require__(11);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PurchaseTemplateList = function (_Component) {
	    _inherits(PurchaseTemplateList, _Component);
	
	    function PurchaseTemplateList() {
	        _classCallCheck(this, PurchaseTemplateList);
	
	        var _this = _possibleConstructorReturn(this, (PurchaseTemplateList.__proto__ || Object.getPrototypeOf(PurchaseTemplateList)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton,
	
	            rows: [],
	            selectedRows: null,
	            filters: {},
	            sortColumn: null,
	            sortDirection: null,
	            purchaseTemplateDetail: {
	                rows: [],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            }
	        };
	        _this.handleResize = _this.handleResize.bind(_this);
	        return _this;
	    }
	
	    _createClass(PurchaseTemplateList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchPurchaseTemplates();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once products are ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.purchaseTemplates && nextProps.purchaseTemplates != this.props.purchaseTemplates) {
	                this.setState({
	                    rows: nextProps.purchaseTemplates
	                });
	            }
	
	            if (nextProps.purchaseTemplateList && nextProps.purchaseTemplateList != this.props.purchaseTemplateList) {
	                var purchaseTemplateDetail = _extends({}, this.state.purchaseTemplateDetail, { rows: nextProps.purchaseTemplateList });
	                this.setState({ purchaseTemplateDetail: purchaseTemplateDetail });
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	        }
	
	        // Set product being selected to be currentProduct and navigate user to the edit page
	
	    }, {
	        key: 'setCurrentPurchaseTemplate',
	        value: function setCurrentPurchaseTemplate(e) {
	            e.preventDefault();
	            var currentPurchaseTemplate = this.state.selectedRows[0];
	            this.props.resetCurrentPurchaseTemplate();
	            this.props.selectPurchaseTemplate(currentPurchaseTemplate);
	            this.context.router.push('/purchaseTemplate/' + currentPurchaseTemplate.PurchaseTemplate_id);
	        }
	    }, {
	        key: 'deleteCurrentPurchaseTemplate',
	        value: function deleteCurrentPurchaseTemplate(e) {
	            e.preventDefault();
	            var currentPurchaseTemplate = this.state.selectedRows[0];
	            this.props.resetCurrentPurchaseTemplate();
	            this.props.selectPurchaseTemplate(currentPurchaseTemplate);
	            this.props.deletePurchaseTemplate(currentPurchaseTemplate.PurchaseTemplate_id);
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            this.props.resetCurrentPurchaseTemplate();
	            this.context.router.push('/purchaseTemplate/new');
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this2 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var tableHeight = window.innerHeight < 900 ? 345 : 345;
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                var onRowClick = function onRowClick(rowIdx, row) {
	                    if (rowIdx != -1) {
	                        var rows = getRows();
	                        rows.map(function (row) {
	                            row.isSelected = false;
	                        });
	                        rows[rowIdx].isSelected = true;
	                        _this2.setState({ rows: rows, selectedRows: [rows[rowIdx]] });
	                        _this2.props.fetchPurchaseTemplateList(row.PurchaseTemplate_id);
	                    }
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this2.setState(state);
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this2.state.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    _this2.setState({ filters: newFilters });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    _this2.setState({ selectedRows: rows });
	                };
	
	                //Custom Formatter component
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNameFormatter = _react2.default.createClass({
	                    displayName: 'VendorNameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNumFormatter = _react2.default.createClass({
	                    displayName: 'VendorNumFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.VendorNum
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var onRowsSelected = function onRowsSelected(rows) {
	                    var newRows = getRows();
	                    var selectedRows = [newRows[rows[0].rowIdx]];
	                    newRows.map(function (r) {
	                        r.isSelected = false;
	                    });
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = true;
	                    });
	                    _this2.setState({ rows: newRows, selectedRows: selectedRows });
	                };
	                var onRowsDeselected = function onRowsDeselected(rows) {
	                    var rowIndexes = rows.map(function (r) {
	                        return r.rowIdx;
	                    });
	                    var newRows = [].concat(_toConsumableArray(_this2.state.rows));
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = false;
	                    });
	                    _this2.setState({ rows: newRows, selectedRows: [] });
	                };
	
	                var onClearFilters = function onClearFilters() {
	                    //all filters removed
	                    _this2.setState({ filters: {} });
	                };
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'Name',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'Vendor_id__Name',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_name' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    formatter: VendorNameFormatter
	                }, {
	                    key: 'CreateTime',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'created_time' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    formatter: DateFormatter
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'PurchaseTemplateList-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'PurchaseTemplate_id',
	                                onGridSort: handleGridSort,
	                                onClearFilters: onClearFilters,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowHeight: 25,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: tableHeight,
	                                enableRowSelect: 'single',
	                                onRowUpdated: this.handleRowUpdated,
	                                rowSelection: {
	                                    showCheckbox: true,
	                                    onRowsSelected: onRowsSelected,
	                                    onRowsDeselected: onRowsDeselected,
	                                    selectBy: {
	                                        isSelectedKey: 'isSelected'
	                                    }
	                                },
	                                onRowClick: onRowClick
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderProductsTable',
	        value: function renderProductsTable() {
	            var _this3 = this;
	
	            if (this.props.purchaseTemplateListIsLoading && !this.props.purchaseTemplateListError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.purchaseTemplateListError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.purchaseTemplateListError)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var tableHeight = window.innerHeight < 900 ? 225 : 225;
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.purchaseTemplateDetail);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this3.state.purchaseTemplateDetail, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this3.setState({ purchaseTemplateDetail: state });
	                };
	
	                var onClearFilters = function onClearFilters() {
	                    //all filters removed
	                    var purchaseTemplateDetail = _extends({}, _this3.state.purchaseTemplateDetail, { filters: {} });
	                    _this3.setState({ purchaseTemplateDetail: purchaseTemplateDetail });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this3.state.purchaseTemplateDetail.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var purchaseTemplateDetail = _extends({}, _this3.state.purchaseTemplateDetail, { filters: newFilters });
	                    _this3.setState({ purchaseTemplateDetail: purchaseTemplateDetail });
	                };
	
	                //Custom Formatter component
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNameFormatter = _react2.default.createClass({
	                    displayName: 'VendorNameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNumFormatter = _react2.default.createClass({
	                    displayName: 'VendorNumFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.VendorNum
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column definition
	
	                var columns = [{
	                    key: 'Product_id__ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100
	                }, {
	                    key: 'Product_id__Name',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                    resizable: true,
	                    sortable: true
	                }, {
	                    key: 'Product_id__Description',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                    resizable: true,
	                    sortable: true
	                }, {
	                    key: 'Quantity',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	                    resizable: true,
	                    width: 40,
	                    sortable: true
	                }, {
	                    key: 'PackageType',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	                    resizable: true,
	                    width: 80,
	                    sortable: true
	                }, {
	                    key: 'FOBUnitPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	                    resizable: true,
	                    width: 70,
	                    sortable: true
	                }, {
	                    key: 'TotalPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	                    resizable: true,
	                    width: 80,
	                    sortable: true
	                }];
	
	                // React Table Purchase Order Details
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'recat-customizer', id: 'PurchaseTemplateList-dataGrid2' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'SalesOrder_id' //Should be PO ID???
	                                , onGridSort: handleGridSort,
	                                onAddFilter: handleFilterChange,
	                                onClearFilters: onClearFilters,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                rowHeight: 25,
	                                minHeight: tableHeight,
	                                onRowUpdated: this.handleRowUpdated
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'checkPermission',
	        value: function checkPermission(permission) {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var height = (this.state.tableHeight * 2 / 3 + 70).toString();
	            var tableCollapseFix = { height: height };
	            var detailsTableHeight = (this.state.tableHeight / 2.5 + 45).toString();
	            var detailsTableCollapseFix = { height: detailsTableHeight };
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Breadcrumb,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb.Item,
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_management' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb.Item,
	                        { active: 'true' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_template' })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Grid,
	                    { id: 'purchase-template-list' },
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_template_full_table' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(
	                                _reactBootstrap.Panel,
	                                { className: 'position-relative table-collapse-fix' },
	                                _react2.default.createElement(
	                                    _reactBootstrap.ButtonToolbar,
	                                    { className: 'table-buttons' },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        {
	                                            bsStyle: 'success',
	                                            type: 'submit',
	                                            onClick: function onClick(event) {
	                                                _this4.clickNew(event);
	                                            },
	                                            disabled: this.checkPermission("add_purchase_template") },
	                                        _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        {
	                                            bsStyle: 'warning',
	                                            type: 'button',
	                                            onClick: function onClick(event) {
	                                                _this4.setCurrentPurchaseTemplate(event);
	                                            },
	                                            disabled: !this.state.selectedRows || this.state.selectedRows.length != 1 },
	                                        _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        {
	                                            bsStyle: 'danger',
	                                            type: 'reset',
	                                            onClick: function onClick(event) {
	                                                _this4.deleteCurrentPurchaseTemplate(event);
	                                            },
	                                            disabled: !this.state.selectedRows || this.state.selectedRows.length != 1 },
	                                        _react2.default.createElement('em', { className: 'fa fa-trash-o' }),
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                                    )
	                                ),
	                                this.renderTable()
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_template_details' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Panel,
	                                { className: 'details-table-collapse-fix' },
	                                this.renderProductsTable()
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PurchaseTemplateList;
	}(_react.Component);
	
	PurchaseTemplateList.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = PurchaseTemplateList;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(PurchaseTemplateList, 'PurchaseTemplateList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseTemplateList.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchaseTemplateList.jsx');
	}();

	;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _datePicker = __webpack_require__(27);
	
	var _selection = __webpack_require__(21);
	
	var _inputField = __webpack_require__(16);
	
	var _inventoryInfo = __webpack_require__(181);
	
	var _inventoryInfo2 = _interopRequireDefault(_inventoryInfo);
	
	var _cleanDates = __webpack_require__(22);
	
	var _dateFormat = __webpack_require__(39);
	
	var _dateFormat2 = _interopRequireDefault(_dateFormat);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _GenericProductSuggest = __webpack_require__(51);
	
	var _GenericProductSuggest2 = _interopRequireDefault(_GenericProductSuggest);
	
	var _TypeRadios = __webpack_require__(57);
	
	var _TypeRadios2 = _interopRequireDefault(_TypeRadios);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _genericRadioFilter = __webpack_require__(50);
	
	var _genericRadioFilter2 = _interopRequireDefault(_genericRadioFilter);
	
	var _dateFilterRadios = __webpack_require__(49);
	
	var _dateFilterRadios2 = _interopRequireDefault(_dateFilterRadios);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isLO = _root_url.ROOT_API_URL === 'https://lonni-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://lonni-scm.truckxi.com/api/';
	
	var getBsStyle = function getBsStyle(input, value) {
	  return input == value ? 'success' : 'primary';
	};
	
	var renderRadios = function renderRadios(props) {
	  var titleClass = (0, _classnames2.default)({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'col-xs-2');
	
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '1') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'today-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'today-radio-filter', type: 'radio', disabled: props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading, name: 'dateFilterRadios', value: '1', onClick: function onClick() {
	              return props.fetchPurchasingPerformance(1);
	            }, checked: props.input.value === '1' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'today' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '7') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'sevenDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'sevenDay-radio-filter', type: 'radio', disabled: props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading, name: 'dateFilterRadios', value: '7', onClick: function onClick() {
	              return props.fetchPurchasingPerformance(7);
	            }, checked: props.input.value === '7' })),
	          '7 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '30') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'thirtyDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'thirtyDay-radio-filter', type: 'radio', disabled: props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading, name: 'dateFilterRadios', value: '30', onClick: function onClick() {
	              return props.fetchPurchasingPerformance(30);
	            }, checked: props.input.value === '30' })),
	          '30 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '90') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'ninetyDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'ninetyDay-radio-filter', type: 'radio', disabled: props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading, name: 'dateFilterRadios', value: '90', onClick: function onClick() {
	              return props.fetchPurchasingPerformance(90);
	            }, checked: props.input.value === '90' })),
	          '90 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '-1') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'dateRange-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'dateRange-radio-filter', type: 'radio', disabled: props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading, name: 'dateFilterRadios', value: '-1', checked: props.input.value === '-1' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date_range' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: 'primary' },
	      _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', disabled: props.input.value !== '-1' || props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading, component: _datePicker.DatePicker, placeholder: 'Start' })
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: 'primary' },
	      _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', disabled: props.input.value !== '-1' || props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading, component: _datePicker.DatePicker, placeholder: 'End' })
	    )
	  );
	};
	
	var renderPORadios = function renderPORadios(props) {
	  var titleClass = (0, _classnames2.default)({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'col-xs-4');
	  //  console.log('Check this render', props, props.purchasingPerformanceIsLoading, props.purchasingPerformanceIsLoading);
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'All') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'all-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'all-radio-filter',
	            type: 'radio',
	            name: 'statusFilterRadios',
	            disabled: props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading,
	            value: 'All',
	            checked: props.input.value === 'All',
	            onClick: function onClick() {
	              /*
	                - Intended to not pass handleOnClick as a function to onClick
	                - handleOnClick needs an undefined value for @param days
	                - this rule should apply to all the buttons here inside renderPORadios
	              */
	              props.handleOnClick("All");
	            }
	          })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'Placed') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'placed-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'placed-radio-filter',
	            type: 'radio',
	            name: 'statusFilterRadios',
	            disabled: props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading,
	            value: 'Placed',
	            checked: props.input.value === 'Placed',
	            onClick: function onClick() {
	              props.handleOnClick("Placed");
	            }
	          })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'placed' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'Received') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'received-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, {
	            id: 'received-radio-filter',
	            type: 'radio',
	            name: 'statusFilterRadios',
	            disabled: props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading,
	            value: 'Received',
	            checked: props.input.value === 'Received',
	            onClick: function onClick() {
	              props.handleOnClick("Received");
	            }
	          })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'received' })
	        )
	      )
	    )
	  );
	};
	
	var renderProductTypeRadios = function renderProductTypeRadios(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group', id: 'search-product-by' },
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-3 search-by-max-width' },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'search_by' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'ProductNum',
	        checked: props.input.value === 'ProductNum'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2 pl' },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'RefNum',
	        checked: props.input.value === 'RefNum'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'Name',
	        checked: props.input.value === 'Name'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'ml-lg' },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'Description',
	        checked: props.input.value === 'Description'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	    )
	  );
	};
	
	var PurchasingPerformance = function (_Component) {
	  _inherits(PurchasingPerformance, _Component);
	
	  function PurchasingPerformance() {
	    _classCallCheck(this, PurchasingPerformance);
	
	    var _this = _possibleConstructorReturn(this, (PurchasingPerformance.__proto__ || Object.getPrototypeOf(PurchasingPerformance)).call(this));
	
	    _this.handleOptionChange = function (changeEvent) {
	      _this.setState({ productSearchType: changeEvent.target.value });
	    };
	
	    _this.setToDate = function (e) {
	      if (e < _this.state.fromDate) {
	        return;
	      }
	      _this.setState({ toDate: e });
	    };
	
	    _this.setFromDate = function (e) {
	      if (e > _this.state.toDate) {
	        return;
	      }
	      _this.setState({ fromDate: e });
	    };
	
	    _this.setToRangeSearch = function (e) {
	      _this.setState({ days: '-1' });
	    };
	
	    _this.handleFetchPurchasingPerformanceByProduct = function (ProductNum) {
	      // console.log(1)
	      var fromDate = '1900-01-01';
	      var toDate = '3000-01-01';
	      if (_this.state.fromDate) {
	        fromDate = _this.formatDate(_this.state.fromDate);
	      }
	      if (_this.state.toDate) {
	        toDate = _this.formatDate(_this.state.toDate);
	      }
	      // console.log('productInfo', ProductNum);
	
	      _this.props.fetchPurchasePerformanceByFilter(_this.props.Days, fromDate, toDate, 'show', _this.state.POStatus, null, ProductNum);
	      _this.setState({ filteredByItem: true, filterProductID: ProductNum });
	    };
	
	    _this.getDateByDays = function (days, fromDate, toDate) {
	      var dateRange = -1;
	      if (days != null) {
	        dateRange = days;
	      }
	      var date = {
	        fromDate: '',
	        toDate: ''
	      };
	      var postingDateGT = fromDate || '1900-01-01';
	      var postingDateLT = toDate || '3000-01-01';
	      if (dateRange != -1) {
	        postingDateLT = (0, _moment2.default)().format('YYYY-MM-DD');
	        if (dateRange === '1') {
	          postingDateGT = postingDateLT;
	        } else if (dateRange === '7') {
	          postingDateGT = (0, _moment2.default)().subtract('7', 'days').format('YYYY-MM-DD');
	        } else if (dateRange == '30') {
	          postingDateGT = (0, _moment2.default)().subtract('30', 'days').format('YYYY-MM-DD');
	        } else if (dateRange == '90') {
	          postingDateGT = (0, _moment2.default)().subtract('90', 'days').format('YYYY-MM-DD');
	        }
	      }
	      date.fromDate = postingDateGT;
	      date.toDate = postingDateLT;
	      return date;
	    };
	
	    _this.state = {
	      purchasingPerformance: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      purchaseOrderDetail: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      purchasingPerformanceByProducts: {
	        rows: [],
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null,
	        selectedIndexes: []
	      },
	      SumPO: 0,
	      activeKey: 1,
	      showInventoryOpen: false,
	      selectedInventoryRow: [],
	      ProductNum: 0,
	      days: '7',
	      fromDate: undefined,
	      toDate: undefined,
	      suggestValue: '',
	      productSearchType: 'ProductNum',
	      totalPriceByPO: 0,
	      finalPriceByPO: 0,
	      totalPriceByProd: 0,
	      receiveTotalPriceByProd: 0,
	
	      //for generic radio filter
	      POStatus: 'All'
	
	    };
	    _this.fetchPurchasingPerformanceByDays = _this.fetchPurchasingPerformanceByDays.bind(_this);
	    _this.fetchPurchasingPerformanceByStatus = _this.fetchPurchasingPerformanceByStatus.bind(_this);
	    _this.openShowInventory = _this.openShowInventory.bind(_this);
	    _this.closeShowInventory = _this.closeShowInventory.bind(_this);
	    _this.selectInventoryInfo = _this.selectInventoryInfo.bind(_this);
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    _this.setUnitPrice = _this.setUnitPrice.bind(_this);
	    _this.setAllProductQuantity = _this.setAllProductQuantity.bind(_this);
	    return _this;
	  }
	
	  _createClass(PurchasingPerformance, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.setDefaultOfForm('Days', '7', 'purchasingPerformance');
	      this.props.setDefaultOfForm('POStatus', 'All', 'purchasingPerformance');
	      this.props.setDefaultSearchType('RefNum', 'purchasingPerformance');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      this.props.fetchVendors();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.purchasingPerformance && nextProps.purchasingPerformance != this.props.purchasingPerformance) {
	        var purchasingPerformance = _extends({}, this.state.purchasingPerformance, { rows: nextProps.purchasingPerformance.Data });
	        var SumPO = nextProps.purchasingPerformance.sum;
	        var totalPriceByPO = nextProps.purchasingPerformance.Sum_Total_Price;
	        var finalPriceByPO = nextProps.purchasingPerformance.Sum_Final_Price;
	        var totalPriceByProd = nextProps.purchasingPerformance.Sum_Total_Price;
	        var receiveTotalPriceByProd = nextProps.purchasingPerformance.Sum_Receive_Total_Price;
	        if (this.state.activeKey === 1) {
	          this.setState({ purchasingPerformance: purchasingPerformance, totalPriceByPO: totalPriceByPO, finalPriceByPO: finalPriceByPO, SumPO: SumPO });
	        } else {
	          this.setState({ purchasingPerformanceByProducts: purchasingPerformance, totalPriceByProd: totalPriceByProd, receiveTotalPriceByProd: receiveTotalPriceByProd, SumPO: SumPO });
	        }
	      }
	
	      if (nextProps.purchaseOrderPerformanceByProduct && nextProps.purchaseOrderPerformanceByProduct != this.props.purchaseOrderPerformanceByProduct) {
	        var purchasingPerformanceByProducts = _extends({}, this.state.purchasingPerformanceByProducts, { rows: nextProps.purchaseOrderPerformanceByProduct.Data });
	        var _SumPO = nextProps.purchaseOrderPerformanceByProduct.sum;
	        this.setState({ purchasingPerformanceByProducts: purchasingPerformanceByProducts, SumPO: _SumPO });
	      }
	
	      if (nextProps.purchaseOrderList && nextProps.purchaseOrderList != this.props.purchaseOrderList) {
	        var purchaseOrderDetail = _extends({}, this.state.purchaseOrderDetail, { rows: nextProps.purchaseOrderList });
	        this.setState({ purchaseOrderDetail: purchaseOrderDetail });
	      }
	      if (nextProps.Days && nextProps.Days != this.props.Days) {
	        if (nextProps.Days !== '-1') {
	          this.resetDateRange();
	        }
	        this.setState({ days: nextProps.Days });
	      }
	      if (nextProps.FromDate && nextProps.FromDate !== this.props.FromDate) {
	        // pass async callback for fetching with new filter
	        this.setState({ fromDate: nextProps.FromDate }, this.fetchPurchasingPerformanceByDays);
	      }
	      if (nextProps.ToDate && nextProps.ToDate !== this.props.ToDate) {
	        // pass async callback for fetching with new filter
	        this.setState({ toDate: nextProps.ToDate }, this.fetchPurchasingPerformanceByDays);
	      }
	      // if (nextProps.POStatus && nextProps.POStatus != this.props.POStatus) {
	      //   let fromDate = '1900-01-01';
	      //   let toDate = '3000-01-01';
	      //   const productinfo = this.state.filterProductID;
	      //   if (this.state.fromDate) {
	      //     fromDate = this.formatDate(this.state.fromDate);
	      //   }
	      //   if (this.state.toDate) {
	      //     toDate = this.formatDate(this.state.toDate);
	      //   }
	      //   if (this.state.activeKey == '1' && this.props.Vendor_id) {
	      //     this.props.fetchPurchasePerformanceByFilter(this.state.days || 1, fromDate, toDate, 'show', nextProps.POStatus, this.props.Vendor_id);
	      //   } else if (productinfo) {
	      //     // this.props.fetchPurchasingPerformanceByProduct(this.state.days, fromDate, toDate, 'show', nextProps.POStatus, productinfo);
	      //     this.props.fetchPurchasePerformanceByFilter(this.state.days, fromDate, toDate, 'show', this.props.POStatus, null, productinfo);
	      //   }
	      // }
	      if (nextProps.Vendor_id != this.props.Vendor_id) {
	        var fromDate = '1900-01-01';
	        var toDate = '3000-01-01';
	        if (this.state.fromDate) {
	          fromDate = this.formatDate(this.state.fromDate);
	        }
	        if (this.state.toDate) {
	          toDate = this.formatDate(this.state.toDate);
	        }
	        if (!nextProps.Vendor_id && this.state.activeKey == '1') {
	          this.resetByPurchaseOrderData();
	        } else {
	          this.props.fetchPurchasePerformanceByFilter(this.state.days, fromDate, toDate, 'show', this.state.POStatus, nextProps.Vendor_id);
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (!this.props.searchType) {
	        this.props.setDefaultSearchType('RefNum', 'purchasingPerformance');
	      }
	    }
	  }, {
	    key: 'renderDatePickers',
	    value: function renderDatePickers() {
	      if (this.state.days == -1) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'form-group date-picker-positioner' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-2 from-label col-xs-offset-5' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'from' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-2 control-date-picker' },
	            _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', component: _datePicker.DatePicker, maxDate: this.state.toDate || new Date() })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-1 to-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'to' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-2 control-date-picker' },
	            _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', component: _datePicker.DatePicker, minDate: this.state.fromDate || new Date('2016-01-01') })
	          )
	        );
	      }
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(activeKey) {
	      switch (activeKey) {
	        case 1:
	          this.setState({ activeKey: activeKey });
	          break;
	        default:
	          this.setState({ activeKey: activeKey });
	      }
	    }
	
	    // Used for new generic datePicker//////////////////////////////
	
	  }, {
	    key: 'formatDate',
	
	
	    // ////////////////////////////
	
	
	    value: function formatDate(date) {
	      return (0, _cleanDates.dateFormat)('YYYY-MM-DD', date);
	    }
	  }, {
	    key: 'getVendorOptions',
	    value: function getVendorOptions() {
	      var vendorOptions = [];
	      this.props.vendors.map(function (vendor) {
	        vendorOptions.push({ value: vendor.Vendor_id, label: vendor.Name });
	      });
	      return vendorOptions;
	    }
	  }, {
	    key: 'resetDateRange',
	    value: function resetDateRange() {
	      this.props.setDefaultOfForm('FromDate', null, 'purchasingPerformance');
	      this.props.setDefaultOfForm('ToDate', null, 'purchasingPerformance');
	    }
	  }, {
	    key: 'resetByPurchaseOrderData',
	    value: function resetByPurchaseOrderData(callback) {
	      this.setState(function (prevState) {
	        return _extends({}, prevState, {
	          purchasingPerformance: {
	            rows: [],
	            filters: {},
	            sortColumn: null,
	            sortDirection: null
	          },
	          purchaseOrderDetail: {
	            rows: [],
	            filters: {},
	            sortColumn: null,
	            sortDirection: null
	          },
	          totalPriceByPO: 0,
	          finalPriceByPO: 0
	        });
	      }, callback);
	    }
	  }, {
	    key: 'fetchPurchasingPerformanceByDays',
	    value: function fetchPurchasingPerformanceByDays(days) {
	      var _this2 = this;
	
	      var fromDate = '1900-01-01';
	      var toDate = '3000-01-01';
	      var productinfo = this.state.filterProductID;
	      if (this.state.fromDate) {
	        fromDate = this.formatDate(this.state.fromDate);
	      }
	      if (this.state.toDate) {
	        toDate = this.formatDate(this.state.toDate);
	      }
	      // console.log('entering the if', this.state.activeKey, this.props.Vendor_id, productinfo)
	      if (this.state.activeKey === 1 && this.props.Vendor_id) {
	        if (days === '-1' || days === -1) {
	          this.setState({ days: days }, function () {
	            _this2.props.fetchPurchasePerformanceByFilter(days, fromDate, toDate, 'show', _this2.state.POStatus, _this2.props.Vendor_id);
	          });
	        } else {
	          this.setState({ days: days, fromDate: undefined, toDate: undefined }, function () {
	            _this2.props.fetchPurchasePerformanceByFilter(days, fromDate, toDate, 'show', _this2.state.POStatus, _this2.props.Vendor_id);
	          });
	        }
	      } else if (this.state.activeKey === 1 && !this.props.Vendor_id) {
	        alert('Please Select a Vendor Before you search');
	      } else if (this.state.activeKey === 2 && productinfo) {
	        if (days === '-1' || days === -1) {
	          this.setState({ days: days }, function () {
	            _this2.props.fetchPurchasePerformanceByFilter(days, fromDate, toDate, 'show', _this2.state.POStatus, null, productinfo);
	          });
	        } else {
	          this.setState({ days: days, fromDate: undefined, toDate: undefined }, function () {
	            _this2.props.fetchPurchasePerformanceByFilter(days, fromDate, toDate, 'show', _this2.state.POStatus, null, productinfo);
	          });
	        }
	      }
	    }
	  }, {
	    key: 'fetchPurchasingPerformanceByStatus',
	    value: function fetchPurchasingPerformanceByStatus(poStatus) {
	      var _this3 = this;
	
	      var fromDate = '1900-01-01';
	      var toDate = '3000-01-01';
	      var productinfo = this.state.filterProductID;
	      if (this.state.fromDate) {
	        fromDate = this.formatDate(this.state.fromDate);
	      }
	      if (this.state.toDate) {
	        toDate = this.formatDate(this.state.toDate);
	      }
	      // console.log('entering the if', this.state.activeKey, this.props.Vendor_id, productinfo)
	      if (this.state.activeKey === 1 && this.props.Vendor_id) {
	        this.setState({ POStatus: poStatus }, function () {
	          _this3.props.fetchPurchasePerformanceByFilter(_this3.state.days, fromDate, toDate, 'show', poStatus, _this3.props.Vendor_id);
	        });
	      } else if (this.state.activeKey === 1 && !this.props.Vendor_id) {
	        alert('Please Select a Vendor Before you search');
	      } else if (this.state.activeKey === 2 && productinfo) {
	        this.setState({ POStatus: poStatus }, function () {
	          _this3.props.fetchPurchasePerformanceByFilter(_this3.state.days, fromDate, toDate, 'show', poStatus, null, productinfo);
	        });
	      }
	    }
	  }, {
	    key: 'openShowInventory',
	    value: function openShowInventory(event) {
	      if (!this.props.allProducts || this.props.allProducts == '') {
	        return;
	      }
	      switch (event.charCode) {
	        case 13:
	          // ENTER
	          event.preventDefault();
	          this.setState({ showInventoryOpen: true });
	          break;
	      }
	    }
	  }, {
	    key: 'closeShowInventory',
	    value: function closeShowInventory(value) {
	      this.setState({ showInventoryOpen: false });
	    }
	  }, {
	    key: 'selectInventoryInfo',
	    value: function selectInventoryInfo(selectedInventoryRow) {
	      this.setState({ ProductNum: selectedInventoryRow });
	    }
	  }, {
	    key: 'setUnitPrice',
	    value: function setUnitPrice(unitPrice) {}
	  }, {
	    key: 'setAllProductQuantity',
	    value: function setAllProductQuantity(quantity) {}
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this4 = this;
	
	      var tableHeight = window.innerHeight < 930 ? 300 : 300;
	
	      if (this.props.purchasingPerformanceIsLoading && !this.props.purchasingPerformanceError) {
	        return _react2.default.createElement(
	          'div',
	          { id: 'spinner', style: { minHeight: tableHeight } },
	          _react2.default.createElement(_spinner2.default, null)
	        );
	      } else if (this.props.purchasingPerformanceError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.purchasingPerformanceError)
	          )
	        );
	      }
	
	      // Parameters of the react-data-grid
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.purchasingPerformance);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var purchasingPerformance = Object.assign({}, _this4.state.purchasingPerformance, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this4.setState({ purchasingPerformance: purchasingPerformance });
	      };
	
	      var onRowClick = function onRowClick(rowIdx, row) {
	        if (rowIdx != -1) {
	          var rows = getRows();
	          _this4.setState({ rows: rows, selectedRows: [rows[rowIdx]] });
	          _this4.props.fetchPurchaseOrderList(row.PurchaseOrder_id);
	        }
	      };
	
	      // Column difinition
	
	      var columns = [{
	        key: 'PONum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'OrderDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_date' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: _dateFormat2.default
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_total' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'FinalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_final' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'ReceiveDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rcv_date' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: _dateFormat2.default
	      }, {
	        key: 'ReceiveTotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rcv_total' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'ReceiveFinalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rcv_final' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'PurchaseStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 110
	      }, {
	        key: 'Purchaser',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchaser' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }];
	
	      // React Table Purchase Order Full Table
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 12 },
	        getSize() === 0 && _react2.default.createElement(
	          'span',
	          { className: 'alert-danger' },
	          'No data found'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'react-table-purchasing-performance', id: 'PurchasingPerformance-dataGrid1' },
	          _react2.default.createElement(_reactDataGrid2.default, {
	            enableCellSelect: true,
	            onGridSort: handleGridSort,
	            columns: columns,
	            rowHeight: 25,
	            headerRowHeight: 45,
	            onRowClick: onRowClick,
	            rowGetter: rowGetter,
	            rowsCount: getSize(),
	            minHeight: tableHeight
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderProductsTableList',
	    value: function renderProductsTableList() {
	      var _this5 = this;
	
	      if (this.props.purchaseOrderListIsLoading && !this.props.purchaseOrderListError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.purchaseOrderListError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.purchaseOrderListError)
	          )
	        );
	      }
	
	      // Parameters of the react-data-grid
	
	      var tableHeight = window.innerHeight < 930 ? 185 : 185;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this5.state.purchaseOrderDetail);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this5.state.purchaseOrderDetail, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this5.setState({ purchaseOrderDetail: state });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        var purchaseOrderDetail = _extends({}, _this5.state.purchaseOrderDetail, { filters: {} });
	        _this5.setState({ purchaseOrderDetail: purchaseOrderDetail });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this5.state.purchaseOrderDetail.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var purchaseOrderDetail = _extends({}, _this5.state.purchaseOrderDetail, { filters: newFilters });
	        _this5.setState({ purchaseOrderDetail: purchaseOrderDetail });
	      };
	
	      // Handle the row select function
	
	      var onRowSelect = function onRowSelect(rows) {
	        var purchaseOrderDetail = _extends({}, _this5.state.purchaseOrderDetail, { selectedRows: rows });
	        _this5.setState({ purchaseOrderDetail: purchaseOrderDetail });
	      };
	
	      var VendorNameFormatter = _react2.default.createClass({
	        displayName: 'VendorNameFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            null,
	            this.props.value.Name
	          );
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var VendorNumFormatter = _react2.default.createClass({
	        displayName: 'VendorNumFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            null,
	            this.props.value.VendorNum
	          );
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      // Column definition
	
	      var columns = [].concat(_toConsumableArray(!isLO ? [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }] : []), [{
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: isLO ? 160 : 70
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 250
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 200
	      }, {
	        key: 'expire_date',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'expire_date' }),
	        resizable: true,
	        sortable: true,
	        width: 80
	      }, {
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: 'OrderQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_qty' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: 'OrderTotalNetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_wt' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: 'OrderUnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_unit_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'OrderTotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_total_dollarsign' }),
	        resizable: true,
	        width: 80,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'ReceiveQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_qty' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: 'ReceiveTotalWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_wt' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: 'ReceiveUnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_unit_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'ReceiveTotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_total_dollarsign' }),
	        resizable: true,
	        width: 80,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }], _toConsumableArray(isLO ? [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }] : []));
	
	      // React Table Purchase Order Details
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 12 },
	        _react2.default.createElement(
	          'div',
	          { className: 'recat-customizer', id: 'PurchasingPerformance-dataGrid2' },
	          _react2.default.createElement(_reactDataGrid2.default, {
	            onGridSort: handleGridSort,
	            onAddFilter: handleFilterChange,
	            onClearFilters: onClearFilters,
	            columns: columns,
	            rowGetter: rowGetter,
	            rowsCount: getSize(),
	            rowHeight: 25,
	            headerRowHeight: 45,
	            minHeight: tableHeight,
	            onRowSelect: onRowSelect
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderByProductTable',
	    value: function renderByProductTable() {
	      var _this6 = this;
	
	      var tableHeight = window.innerHeight < 930 ? 470 : 470;
	
	      if (this.props.purchasingPerformanceIsLoading && !this.props.purchasingPerformanceError) {
	        return _react2.default.createElement(
	          'div',
	          { id: 'spinner', style: { minHeight: tableHeight } },
	          _react2.default.createElement(_spinner2.default, null)
	        );
	      } else if (this.props.purchasingPerformanceError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.purchasingPerformanceError)
	          )
	        );
	      }
	
	      // Parameters of the react-data-grid
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this6.state.purchasingPerformanceByProducts);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var purchasingPerformanceByProducts = Object.assign({}, _this6.state.purchasingPerformanceByProducts, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this6.setState({ purchasingPerformanceByProducts: purchasingPerformanceByProducts });
	      };
	
	      // Column difinition
	
	      var columns = [{
	        key: 'PONum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'OrderDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_date' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: _dateFormat2.default
	      }, {
	        key: 'VendorNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_no' }),
	        resizable: true,
	        sortable: true,
	        width: 130
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 60
	      }, {
	        key: 'TotalNetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 60
	      }, {
	        key: 'FOBUnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_total' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'ReceiveDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rcv_date' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: _dateFormat2.default
	      }, {
	        key: 'ReceiveQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rcv_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 80
	      }, {
	        key: 'ReceiveUnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 130,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'ReceiveTotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rcv_total' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'Purchaser',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchaser' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }];
	
	      // React Table Purchase Order Full Table
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          getSize() === 0 && _react2.default.createElement(
	            'span',
	            { className: 'alert-danger' },
	            'No data found'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'react-table-purchasing-performance-by-product', id: 'PurchasingPerformance-dataGrid3' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              enableCellSelect: true,
	              onGridSort: handleGridSort,
	              columns: columns,
	              rowHeight: 25,
	              headerRowHeight: 45,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: tableHeight
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderAutoSuggest',
	    value: function renderAutoSuggest() {
	      var _this7 = this;
	
	      if (!this.state.filteredByItem) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'control-dropdown' },
	          _react2.default.createElement(_GenericProductSuggest2.default, {
	            value: this.state.suggestValue,
	            onChange: function onChange(e, _ref) {
	              var newValue = _ref.newValue;
	              _this7.setState({ suggestValue: newValue });
	            },
	            SearchType: this.state.productSearchType,
	            fetchOrdersByProduct: this.handleFetchPurchasingPerformanceByProduct,
	            setProductNum: this.selectInventoryInfo
	          })
	        );
	      }
	      //  console.log(this.state.suggestValue);
	      return _react2.default.createElement(
	        'div',
	        { id: 'suggestion-box' },
	        this.state.suggestValue,
	        _react2.default.createElement('em', {
	          className: 'fa fa-times pull-right',
	          onClick: function onClick() {
	            var purchasingPerformanceByProducts = _extends({}, _this7.state.purchasingPerformanceByProducts, { rows: [], selectedInventoryRow: [], sortColumn: null, sortDirection: null, selectedIndexes: [] });
	            _this7.setState({
	              filteredByItem: false,
	              suggestValue: '',
	              filterProductID: null,
	              totalPriceByProd: 0,
	              receiveTotalPriceByProd: 0,
	              purchasingPerformanceByProducts: purchasingPerformanceByProducts
	            });
	          }
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      //console.log("this is the satte", this.state);
	      var createDialogInventoryStyle = {
	        height: '700px',
	        width: '1000px',
	        marginLeft: '-28%',
	        marginTop: '-20%'
	      };
	      var renderByProduct = _react2.default.createElement(
	        'span',
	        { className: 'tab-title-medium' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_product' })
	      );
	      var renderByPO = _react2.default.createElement(
	        'span',
	        { className: 'tab-title-medium' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_po' })
	      );
	      var vendorOptions = this.getVendorOptions();
	      var POStatus = this.state.POStatus;
	      var days = this.state.days;
	      var product_info = this.state.ProductNum;
	      var fromDate = '1900-01-01';
	      var toDate = '3000-01-01';
	      var print_url = '';
	      var excel_url = '';
	      if (this.state.fromDate) {
	        fromDate = this.formatDate(this.state.fromDate);
	      }
	      if (this.state.toDate) {
	        toDate = this.formatDate(this.state.toDate);
	      }
	      var dates = (0, _cleanDates.toFromDates)(days, fromDate, toDate);
	      fromDate = dates.fromDate;
	      toDate = dates.toDate;
	      var Vendor_id = this.props.Vendor_id;
	      if (Vendor_id) {
	        Vendor_id = Vendor_id.value || Vendor_id;
	        Vendor_id = Vendor_id + '/';
	      } else {
	        Vendor_id = '';
	      }
	      if (POStatus) {
	        POStatus = POStatus.value || POStatus;
	        POStatus = '&PurchaseStatus=' + POStatus;
	      } else {
	        POStatus = '&PurchaseStatus=All';
	      }
	      if (product_info) {
	        product_info = product_info.value || product_info;
	        product_info = product_info + '/';
	      } else {
	        product_info = '';
	      }
	      if (this.state.activeKey == 1) {
	        fromDate = 'OrderDate__gte=' + fromDate;
	        toDate = 'OrderDate__lte=' + toDate;
	        print_url = _root_url.ROOT_URL + 'v1/purchase/performance/Vendor_id/' + Vendor_id + 'print/?' + fromDate + '&' + toDate + POStatus + '&Bearer=' + localStorage.getItem('token');
	        excel_url = _root_url.ROOT_URL + 'v1/purchase/performance/Vendor_id/' + Vendor_id + 'export/?' + fromDate + '&' + toDate + POStatus + '&Bearer=' + localStorage.getItem('token');
	      } else {
	        fromDate = 'OrderDate__gte=' + fromDate;
	        toDate = 'OrderDate__lte=' + toDate;
	        print_url = _root_url.ROOT_URL + 'v1/purchase/performance/ProductNum/' + product_info + 'print/?' + fromDate + '&' + toDate + POStatus + '&Bearer=' + localStorage.getItem('token');
	        excel_url = _root_url.ROOT_URL + 'v1/purchase/performance/ProductNum/' + product_info + 'export/?' + fromDate + '&' + toDate + POStatus + '&Bearer=' + localStorage.getItem('token');
	      }
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_management' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_performance' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'purchasing-performance' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { id: 'date-range-picker', className: 'form-horizontal' },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      'h3',
	                      { className: 'filter-title' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_status' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'colon' },
	                        ':'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 10 },
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'statusFilterRadios', className: 'form-horizontal' },
	                      (0, _genericRadioFilter2.default)({
	                        content: [{
	                          option: 'All',
	                          id: 'all-radio-filter',
	                          name: 'statusFilterRadios',
	                          labelName: 'all'
	                        }, {
	                          option: 'Placed',
	                          id: 'placed-radio-filter',
	                          name: 'statusFilterRadios',
	                          labelName: 'placed'
	                        }, {
	                          option: 'Received',
	                          id: 'received-radio-filter',
	                          name: 'statusFilterRadios',
	                          labelName: 'received'
	                        }],
	                        value: this.state.POStatus,
	                        handleOnClick: this.fetchPurchasingPerformanceByStatus,
	                        type: 'buttons'
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      'h3',
	                      { className: 'filter-title' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_date' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'colon' },
	                        ':'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 10 },
	                    (0, _dateFilterRadios2.default)({
	                      handleOnClick: this.fetchPurchasingPerformanceByDays,
	                      setFromDate: this.setFromDate,
	                      setToDate: this.setToDate,
	                      setToRangeSearch: this.setToRangeSearch,
	                      FromDate: this.state.fromDate,
	                      ToDate: this.state.toDate,
	                      Days: this.state.days
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Tabs,
	            { activeKey: this.state.activeKey, justified: true, onSelect: this.handleSelect },
	            _react2.default.createElement(
	              _reactBootstrap.Tab,
	              { eventKey: 1, title: renderByPO, style: { height: '350px' } },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'table-filters-purchasing-performance' },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 3 },
	                  _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      { bsStyle: 'primary', href: print_url, disabled: !Vendor_id || !this.state.purchasingPerformance.rows.length || !(0, _permissions2.default)('print_purchase_performance') },
	                      _react2.default.createElement('em', { className: 'fa fa-print' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      { bsStyle: 'success', href: excel_url, disabled: !Vendor_id || !this.state.purchasingPerformance.rows.length || !(0, _permissions2.default)('print_purchase_performance') },
	                      _react2.default.createElement('em', { className: 'fa fa-download' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-xs-4' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor' })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 8 },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'Vendor_id', component: _selection.Selection, options: vendorOptions })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 3 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-xs-4' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_price' })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 5 },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'SumPO', component: _inputField.DisabledInputField, placeholder: this.state.totalPriceByPO })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 3 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-xs-4' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 5 },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'SumPOFinal', component: _inputField.DisabledInputField, placeholder: this.state.finalPriceByPO })
	                  )
	                )
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                this.renderTable()
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                this.renderProductsTableList()
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Tab,
	              { eventKey: 2, title: renderByProduct },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'table-filters-purchasing-performance', style: { display: 'flex' } },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 2 },
	                  _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      { bsStyle: 'primary', href: print_url, disabled: !this.state.purchasingPerformanceByProducts.rows.length },
	                      _react2.default.createElement('em', { className: 'fa fa-print' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      { bsStyle: 'success', href: excel_url, disabled: !this.state.purchasingPerformanceByProducts.rows.length },
	                      _react2.default.createElement('em', { className: 'fa fa-download' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 6, className: 'p0' },
	                  _react2.default.createElement(
	                    'div',
	                    { id: 'autosuggest-div' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      { style: { height: '30px' } },
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(_TypeRadios2.default, { value: this.state.productSearchType, handleOptionChange: this.handleOptionChange })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        this.renderAutoSuggest()
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 3 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-xs-4' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_price' })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 5 },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'SumPO', component: _inputField.DisabledInputField, placeholder: this.state.totalPriceByProd })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 3 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-xs-4' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rcv_total' })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 5 },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'SumPOFinal', component: _inputField.DisabledInputField, placeholder: this.state.receiveTotalPriceByProd })
	                  )
	                )
	              ),
	              _react2.default.createElement('br', null),
	              this.renderByProductTable()
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogInventoryStyle,
	            isVisible: this.state.showInventoryOpen,
	            onCloseClicked: this.closeShowInventory,
	            title: 'Select Inventory'
	          },
	          _react2.default.createElement(_inventoryInfo2.default, {
	            searchValue: this.props.allProducts,
	            searchType: this.props.searchType,
	            closeShowInventory: this.closeShowInventory,
	            selectInventoryInfo: this.selectInventoryInfo,
	            setAllProducts: this.props.setAllProducts,
	            setUnitPrice: this.setUnitPrice,
	            setAllProductQuantity: this.setAllProductQuantity,
	            form: 'purchasingPerformance'
	          })
	        )
	      );
	    }
	  }]);
	
	  return PurchasingPerformance;
	}(_react.Component);
	
	var _default = PurchasingPerformance;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isLO, 'isLO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasingPerformance.jsx');
	
	  __REACT_HOT_LOADER__.register(getBsStyle, 'getBsStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasingPerformance.jsx');
	
	  __REACT_HOT_LOADER__.register(renderRadios, 'renderRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasingPerformance.jsx');
	
	  __REACT_HOT_LOADER__.register(renderPORadios, 'renderPORadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasingPerformance.jsx');
	
	  __REACT_HOT_LOADER__.register(renderProductTypeRadios, 'renderProductTypeRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasingPerformance.jsx');
	
	  __REACT_HOT_LOADER__.register(PurchasingPerformance, 'PurchasingPerformance', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasingPerformance.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/purchasingPerformance.jsx');
	}();

	;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _notifyModal = __webpack_require__(534);
	
	var _notifyModal2 = _interopRequireDefault(_notifyModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Selectors = _reactDataGridAddons.Data.Selectors;
	
	var TrackingNoteModal = function (_Component) {
	  _inherits(TrackingNoteModal, _Component);
	
	  function TrackingNoteModal() {
	    _classCallCheck(this, TrackingNoteModal);
	
	    var _this = _possibleConstructorReturn(this, (TrackingNoteModal.__proto__ || Object.getPrototypeOf(TrackingNoteModal)).call(this));
	
	    _this.openNotifyModal = function () {
	      _this.setState({
	        notifyModalOpen: true
	      });
	    };
	
	    _this.closeNotifyModal = function () {
	      _this.setState({
	        notifyModalOpen: false
	      });
	    };
	
	    _this.state = {
	      selectedOrder: {
	        order_num: null,
	        id: null
	      },
	
	      rows: [],
	      selectedRows: null,
	      editedRows: [],
	      filters: {},
	      sortColumn: null,
	      sortDirection: null,
	
	      notifyModalOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(TrackingNoteModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var selectedOrder = this.props.selectedOrder;
	
	      if (selectedOrder.length === 1) {
	        this.setState({
	          selectedOrder: this.props.selectedOrder[0]
	        });
	        this.props.fetchTrackingNote(selectedOrder[0].id);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var PT = nextProps.notes;
	      if (nextProps.notes && nextProps.notes != this.props.notes) {
	        var notes = nextProps.notes;
	        var index = 0;
	        notes.map(function (note) {
	          note.Idx = index++;
	        });
	        this.setState({
	          rows: notes,
	          selectedRows: null,
	          editedRows: []
	        });
	      }
	    }
	
	    // componentWillUnmount() { 
	    //   }
	
	  }, {
	    key: 'clickNew',
	    value: function clickNew(e) {
	      e.preventDefault();
	      var rows = Selectors.getRows(this.state);
	      var index = rows.length;
	      var newRow = { Product_SKU: null, Product_Name: null, Post_Date: null, Est_Delivery_Date: null, Quantity: null, Note: null, Idx: index };
	      rows.push(newRow);
	      var editedRows = [].concat(_toConsumableArray(this.state.editedRows));
	      editedRows.push(newRow);
	      this.setState({ rows: rows, editedRows: editedRows });
	    }
	  }, {
	    key: 'deleteCategory',
	    value: function deleteCategory(e) {
	      e.preventDefault();
	      // let productSKU = this.state.selectedRows[0].productSKU;
	      // if (productSKU) {
	      //   this.props.deleteCategory(productSKU);
	      // }
	      // else {
	      var rows = [].concat(_toConsumableArray(this.state.rows));
	      var editedRows = [].concat(_toConsumableArray(this.state.editedRows));
	      var index = _.findIndex(rows, { Idx: this.state.selectedRows[0].Idx });
	      rows.splice(index, 1);
	      index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx });
	      editedRows.splice(index, 1);
	      this.setState({ rows: rows, editedRows: editedRows, selectedRows: [] });
	      // }
	    }
	  }, {
	    key: 'updateRows',
	    value: function updateRows(e) {
	      var selectedOrder = this.props.selectedOrder;
	      // const computedRows = this.state.rows.map((row) => {
	      //   const editedRow = this.state.editedRows.find(({ productSKU }) => productSKU === row.productSKU);
	      //   if (editedRow !== undefined) {
	      //     return editedRow;
	      //   }
	      //   return row;
	      // });
	
	      var computedRows = this.state.rows;
	      e.preventDefault();
	      this.props.editTrackingNote(selectedOrder[0].id, computedRows);
	      this.openNotifyModal();
	    }
	  }, {
	    key: 'renderTrackingNoteTable',
	    value: function renderTrackingNoteTable() {
	      var _this2 = this;
	
	      var getRows = function getRows() {
	        return Selectors.getRows(_this2.state);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this2.setState(state);
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this2.state.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        _this2.setState({ filters: newFilters });
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        _this2.setState({ sortColumn: null, sortDirection: null });
	        var rows = getRows();
	        var editedRows = _this2.state.editedRows.slice(0);
	        Object.assign(rows[e.rowIdx], e.updated);
	        editedRows.forEach(function (element, index) {
	          if (element.Idx === rows[e.rowIdx].Idx) editedRows.splice(index, 1);
	        }, _this2);
	        editedRows.push(rows[e.rowIdx]);
	        _this2.setState({
	          rows: rows,
	          editedRows: editedRows
	        });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        _this2.setState({ rows: newRows, selectedRows: [rows[0].row] });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = getRows();
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        _this2.setState({ rows: newRows, selectedRows: [] });
	      };
	
	      var columns = [{
	        key: 'Product_SKU',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_sku' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        editable: true,
	        width: 150
	      }, {
	        key: 'Product_Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        editable: true,
	        width: 150
	      }, {
	        key: 'Post_Date',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'posting_date' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        editable: true,
	        width: 150
	      }, {
	        key: 'Est_Delivery_Date',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_delivery' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        editable: true,
	        width: 150
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        editable: true,
	        width: 100
	      }, {
	        key: 'NotShippedQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'not_shipped_quantity' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: 'Note',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        editable: true,
	        width: 200
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '95%', marginLeft: '25px' }, id: 'trackingNoteModal-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              enableCellSelect: true,
	              onGridSort: handleGridSort,
	              onAddFilter: handleFilterChange,
	              columns: columns,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: 250,
	              rowHeight: 25,
	              enableRowSelect: 'single',
	              onRowUpdated: handleRowUpdated,
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              }
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var selectedOrder = this.state.selectedOrder;
	
	      var purchaseOrderNumberStyle = {
	        marginLeft: '20px',
	        fontSize: '15px'
	      };
	      var buttonToolbar = {
	        marginLeft: '8px',
	        marginBottom: '10px'
	      };
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { style: { marginBottom: '5px' } },
	            _react2.default.createElement(
	              'span',
	              { style: purchaseOrderNumberStyle },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_order_number' }),
	              selectedOrder.order_num
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          { style: buttonToolbar },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'primary',
	              onClick: function onClick(event) {
	                _this3.clickNew(event);
	              }
	            },
	            _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'success',
	              onClick: function onClick(event) {
	                _this3.updateRows(event);
	              }
	            },
	            _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'danger',
	              onClick: function onClick(event) {
	                _this3.deleteCategory(event);
	              },
	              disabled: !this.state.selectedRows || this.state.selectedRows.length != 1
	            },
	            _react2.default.createElement('em', { className: 'fa fa-trash marginRightStyle' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { className: 'text-center' },
	            _react2.default.createElement(
	              'span',
	              null,
	              this.renderTrackingNoteTable()
	            )
	          )
	        ),
	        _react2.default.createElement(_notifyModal2.default, {
	          title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'success' }),
	          content: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saved_tracking_note' }),
	          isVisible: this.state.notifyModalOpen,
	          onConfirm: this.closeNotifyModal,
	          onCancel: this.closeNotifyModal
	        })
	      );
	    }
	  }]);
	
	  return TrackingNoteModal;
	}(_react.Component);
	
	var _default = TrackingNoteModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Selectors, 'Selectors', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/trackingNoteModal.jsx');
	
	  __REACT_HOT_LOADER__.register(TrackingNoteModal, 'TrackingNoteModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/trackingNoteModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/trackingNoteModal.jsx');
	}();

	;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reactChartjs = __webpack_require__(86);
	
	var _time = __webpack_require__(83);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _purchaseQuoteModal = __webpack_require__(76);
	
	var _purchaseQuoteModal2 = _interopRequireDefault(_purchaseQuoteModal);
	
	var _favoriteModal = __webpack_require__(75);
	
	var _favoriteModal2 = _interopRequireDefault(_favoriteModal);
	
	var _datePicker = __webpack_require__(27);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarehouseDashboard = function (_Component) {
	    _inherits(WarehouseDashboard, _Component);
	
	    function WarehouseDashboard() {
	        _classCallCheck(this, WarehouseDashboard);
	
	        var _this = _possibleConstructorReturn(this, (WarehouseDashboard.__proto__ || Object.getPrototypeOf(WarehouseDashboard)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.fourLineButton,
	
	            createReturnOpen: false,
	            createQuoteOpen: false,
	            createFavoriteOpen: false,
	            availableBins: 0,
	            totalBins: 0,
	            totalPO: 0,
	            totalSO: 0,
	            totalConvert: 0,
	            totalAdjust: 0,
	
	            POs: {
	                rows: [],
	                allRows: [],
	                setDate: null,
	                selectedRows: null,
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            SOs: {
	                rows: [],
	                allRows: [],
	                setDate: null,
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            zones: {
	                rows: [],
	                allRows: [],
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            inventories: {
	                rows: [],
	                selectedRows: null,
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            favorites: {
	                rows: [],
	                selectedRows: null,
	                sortColumn: null,
	                sortDirection: null
	            }
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	
	        _this.openReturnCreate = _this.openReturnCreate.bind(_this);
	        _this.closeReturnCreate = _this.closeReturnCreate.bind(_this);
	        _this.openQuoteCreate = _this.openQuoteCreate.bind(_this);
	        _this.closeQuoteCreate = _this.closeQuoteCreate.bind(_this);
	        _this.openFavoriteCreate = _this.openFavoriteCreate.bind(_this);
	        _this.closeFavoriteCreate = _this.closeFavoriteCreate.bind(_this);
	        _this.addFavorite = _this.addFavorite.bind(_this);
	        return _this;
	    }
	
	    _createClass(WarehouseDashboard, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchInventories();
	            this.props.fetchFavorites();
	            // this.props.fetchWarehouseSalesOrders(1);
	            this.props.fetchWarehousePurchaseOrders(1);
	            this.props.fetchWarehouses();
	            this.props.fetchWarehouseBins(1);
	
	            this.props.fetchTodaysIncomingOrders();
	            this.props.fetchTodaysOutgoingOrders();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once products are ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.todaysIncomingOrders && nextProps.todaysIncomingOrders != this.props.todaysIncomingOrders) {
	                var purchaseOrders = [].concat(_toConsumableArray(nextProps.todaysIncomingOrders));
	
	                purchaseOrders.map(function (purchaseOrder) {
	                    console.log(purchaseOrder);
	                    if (purchaseOrder["Deliver_Warehouse_id"]) {
	                        purchaseOrder["Warehouse"] = purchaseOrder["Deliver_Warehouse_id"].Name;
	                    }
	                    if (purchaseOrder["Vendor_id"]) {
	                        purchaseOrder["Vendor"] = purchaseOrder["Vendor_id"].Name;
	                    }
	                    if (purchaseOrder["ReceivedDate"]) {
	                        purchaseOrder["ReceivedDateFormatted"] = purchaseOrder["ReceivedDate"].slice(0, 10);
	                    }
	                });
	                console.log(purchaseOrders);
	                var newPurchaseOrders = _extends({}, this.state.POs, { rows: purchaseOrders });
	                this.setState({ POs: newPurchaseOrders });
	            }
	
	            if (nextProps.todaysOutgoingOrders && nextProps.todaysOutgoingOrders != this.props.todaysOutgoingOrders) {
	                var salesOrders = [].concat(_toConsumableArray(nextProps.todaysOutgoingOrders));
	
	                salesOrders.map(function (salesOrder) {
	                    if (salesOrder["Deliver_Warehouse_id"]) {
	                        salesOrder["Warehouse"] = salesOrder["Deliver_Warehouse_id"].Name;
	                    }
	                    if (salesOrder["Vendor_id"]) {
	                        salesOrder["Vendor"] = salesOrder["Vendor_id"].Name;
	                    }
	                    if (salesOrder["ReceivedDate"]) {
	                        salesOrder["ReceivedDateFormatted"] = salesOrder["ReceivedDate"].slice(0, 10);
	                    }
	                });
	
	                var newSalesOrders = _extends({}, this.state.SOs, { rows: salesOrders });
	                this.setState({ SOs: newSalesOrders });
	            }
	
	            if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
	                var inventories = _extends({}, this.state.inventories, { rows: nextProps.inventories });
	                this.setState({ inventories: inventories });
	            }
	
	            if (nextProps.favorites && nextProps.favorites != this.props.favorites) {
	                var favorites = _extends({}, this.state.favorites, { rows: nextProps.favorites });
	                this.setState({ favorites: favorites });
	            }
	
	            if (nextProps.warehouseChosen && nextProps.warehouseChosen != this.props.warehouseChosen) {
	                if (this.props.purchaseDate == null) {
	                    this.props.fetchIncomingOrdersByDate(nextProps.warehouseChosen.value);
	                } else {
	                    this.props.fetchIncomingOrdersByDate(nextProps.warehouseChosen.value + '/' + this.formatDate(this.props.purchaseDate));
	                }
	
	                if (this.props.salesDate == null) {
	                    this.props.fetchOutgoingOrdersByDate(nextProps.warehouseChosen.value);
	                } else {
	                    this.props.fetchOutgoingOrdersByDate(nextProps.warehouseChosen.value + '/' + this.formatDate(this.props.salesDate));
	                }
	
	                this.props.fetchWarehousePurchaseOrders(nextProps.warehouseChosen.value);
	                this.props.fetchWarehouseSalesOrders(nextProps.warehouseChosen.value);
	                this.props.fetchWarehouseBins(nextProps.warehouseChosen.value);
	            }
	
	            if (nextProps.salesDate && nextProps.salesDate != this.props.salesDate) {
	                console.log(this.props.warehouseChosen);
	                if (this.props.warehouseChosen == null) {
	                    this.props.fetchOutgoingOrdersByDate(this.formatDate(nextProps.salesDate));
	                } else {
	                    console.log("shouldnt be here");
	                    this.props.fetchOutgoingOrdersByDate(this.props.warehouseChosen.value + '/' + this.formatDate(nextProps.salesDate));
	                }
	            }
	
	            if (nextProps.purchaseDate && nextProps.purchaseDate != this.props.purchaseDate) {
	                console.log(this.props.warehouseChosen);
	                if (this.props.warehouseChosen == null) {
	                    this.props.fetchIncomingOrdersByDate(this.formatDate(nextProps.purchaseDate));
	                } else {
	                    this.props.fetchIncomingOrdersByDate(this.props.warehouseChosen.value + '/' + this.formatDate(nextProps.purchaseDate));
	                }
	            }
	
	            if (nextProps.warehouseBinsDetail && nextProps.warehouseBinsDetail != this.props.warehouseBinsDetail) {
	                var totalAvailable = 0;
	                var totalWarehouseBins = 0;
	                var PONotArrive = 0;
	                var SONotShip = 0;
	                var numConvert = 0;
	                var numAdjust = 0;
	                nextProps.warehouseBinsDetail.Warehouse_Zone.map(function (zone) {
	                    zone.AvailableSpace = Math.floor(Math.random() * (50000 - 0 + 1)) + 0;
	                    zone.TotalSpace = Math.floor(Math.random() * (100000 - 50000 + 1)) + 50000;
	                    totalAvailable += zone.AvailableBin;
	                    totalWarehouseBins += zone.TotalBin;
	                });
	                PONotArrive = nextProps.warehouseBinsDetail.PONotArrive;
	                SONotShip = nextProps.warehouseBinsDetail.SONotShip;
	                numConvert = nextProps.warehouseBinsDetail.Converts;
	                numAdjust = nextProps.warehouseBinsDetail.Adjusts;
	
	                var zones = _extends({}, this.state.zones, { rows: nextProps.warehouseBinsDetail.Warehouse_Zone });
	                this.setState({ zones: zones, availableBins: totalAvailable, totalBins: totalWarehouseBins, totalPO: PONotArrive, totalSO: SONotShip, totalConvert: numConvert, totalAdjust: numAdjust });
	            }
	        }
	    }, {
	        key: 'formatDate',
	        value: function formatDate(date) {
	            var monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	
	            if (date) {
	                var month = String(date).slice(4, 7);
	                var day = String(date).slice(8, 10);
	                var year = String(date).slice(11, 15);
	
	                var chosenDateFormatted = '';
	                if (parseInt(monthShortNames.indexOf(month) + 1) < 10) {
	                    chosenDateFormatted = chosenDateFormatted + '0' + (monthShortNames.indexOf(month) + 1) + day;
	                } else {
	                    chosenDateFormatted = chosenDateFormatted + (monthShortNames.indexOf(month) + 1) + day;
	                }
	                chosenDateFormatted = chosenDateFormatted + year;
	                console.log(chosenDateFormatted);
	                return chosenDateFormatted;
	            }
	            return null;
	        }
	    }, {
	        key: 'dateUpdated',
	        value: function dateUpdated(updatedDate, whichDate) {
	            console.log(updatedDate, whichDate);
	            var monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	
	            var chosenDateFormatted = '';
	
	            if (updatedDate) {
	                var month = String(updatedDate).slice(4, 7);
	                var day = String(updatedDate).slice(8, 10);
	                var year = String(updatedDate).slice(11, 15);
	
	                chosenDateFormatted = year + '-';
	                if (parseInt(monthShortNames.indexOf(month) + 1) < 10) {
	                    chosenDateFormatted = chosenDateFormatted + '0' + (monthShortNames.indexOf(month) + 1) + '-' + day;
	                } else {
	                    chosenDateFormatted = chosenDateFormatted + (monthShortNames.indexOf(month) + 1) + '-' + day;
	                }
	            }
	            console.log(chosenDateFormatted);
	            if (whichDate == "purchase") {
	                var selectedDateOrders = this.state.POs.allRows.filter(function (obj) {
	                    return String(obj.ETADate).slice(0, 10) == chosenDateFormatted;
	                });
	
	                var newDatePurchaseOrders = _extends({}, this.state.POs, { rows: selectedDateOrders, setDate: chosenDateFormatted });
	                this.setState({ POs: newDatePurchaseOrders });
	            } else {
	                console.log(this.state.SOs.allRows);
	                var _selectedDateOrders = this.state.SOs.allRows.filter(function (obj) {
	                    return String(obj.DispatchDate).slice(0, 10) == chosenDateFormatted;
	                });
	                console.log(_selectedDateOrders);
	                var newDateSalesOrders = _extends({}, this.state.SOs, { rows: _selectedDateOrders, setDate: chosenDateFormatted });
	                this.setState({ SOs: newDateSalesOrders });
	            }
	        }
	    }, {
	        key: 'openQuoteCreate',
	        value: function openQuoteCreate() {
	            this.setState({ createQuoteOpen: true });
	        }
	    }, {
	        key: 'openFavoriteCreate',
	        value: function openFavoriteCreate() {
	            this.setState({ createFavoriteOpen: true });
	        }
	    }, {
	        key: 'closeQuoteCreate',
	        value: function closeQuoteCreate() {
	            this.setState({ createQuoteOpen: false });
	        }
	    }, {
	        key: 'closeFavoriteCreate',
	        value: function closeFavoriteCreate() {
	            this.setState({ createFavoriteOpen: false });
	        }
	    }, {
	        key: 'openReturnCreate',
	        value: function openReturnCreate() {
	            this.setState({ createReturnOpen: true });
	        }
	    }, {
	        key: 'closeReturnCreate',
	        value: function closeReturnCreate() {
	            this.setState({ createReturnOpen: false });
	        }
	    }, {
	        key: 'addFavorite',
	        value: function addFavorite(newFavorite) {
	            var newRow = {
	                Product_id: newFavorite.id,
	                ProductNum: newFavorite.ProductNum,
	                RefNum: newFavorite.ProductNum,
	                PreSale: newFavorite.PreSale,
	                InStock: newFavorite.InStock,
	                Ordered: newFavorite.Purchased,
	                Price: newFavorite.RefPurchasingPrice,
	                ProductName: newFavorite.ProductNum.Name
	            };
	            if (newFavorite.Product) {
	                newRow.ProductName = newFavorite.Product["Name"];
	            }
	
	            var preRows = this.state.favorites.rows;
	            preRows.push(newRow);
	            var favorites = _extends({}, this.state.favorites, { rows: preRows });
	            this.setState({ favorites: favorites });
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.fourLineButton });
	        }
	
	        // Set product being selected to be currentProduct and navigate user to the edit page
	
	    }, {
	        key: 'setCurrentPurchaseOrder',
	        value: function setCurrentPurchaseOrder(e) {
	            e.preventDefault();
	            var currentPurchaseOrder = this.state.selectedRows[0];
	            this.props.resetCurrentPurchaseOrder();
	            this.props.selectPurchaseOrder(currentPurchaseOrder);
	            this.context.router.push('/purchaseOrder/' + currentPurchaseOrder.PurchaseOrder_id);
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            this.props.resetCurrentPurchaseOrder();
	            this.context.router.push('/purchaseOrder/new');
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable table.
	
	    }, {
	        key: 'renderPurchaseOrderTable',
	        value: function renderPurchaseOrderTable() {
	            var _this2 = this;
	
	            if (this.props.todaysIncomingOrdersIsLoading && !this.props.todaysIncomingOrdersError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.todaysIncomingOrdersError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.todaysIncomingOrdersError)
	                )
	            );else {
	                var _React$createElement;
	
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.POs);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var POs = _extends({}, _this2.state.POs, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this2.setState({ POs: POs });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var POs = _extends({}, _this2.state.POs, { selectedRows: rows });
	                    _this2.setState({ POs: POs });
	                };
	
	                //Custom Formatter component
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNameFormatter = _react2.default.createClass({
	                    displayName: 'VendorNameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNumFormatter = _react2.default.createClass({
	                    displayName: 'VendorNumFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.VendorNum
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'PONum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 90
	                }, {
	                    key: 'Vendor',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 155
	                }, {
	                    key: 'TotalPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80
	                }, {
	                    key: 'Warehouse',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipto' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120
	                }, {
	                    key: 'CreateTime',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 90,
	                    formatter: DateFormatter
	                }, {
	                    key: 'PurchaseStatus',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80
	                }];
	
	                return (
	                    // React Table Purchase Orders Scheduled to Arrive
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                'div',
	                                { id: 'WarehouseDashboard-dataGrid1' },
	                                _react2.default.createElement(_reactDataGrid2.default, (_React$createElement = {
	                                    rowKey: 'PurchaseOrder_id',
	                                    onGridSort: handleGridSort,
	                                    columns: columns,
	                                    rowHeight: 25,
	                                    rowGetter: rowGetter,
	                                    rowsCount: getSize(),
	                                    minHeight: this.state.tableHeight
	                                }, _defineProperty(_React$createElement, 'rowHeight', 25), _defineProperty(_React$createElement, 'onRowSelect', onRowSelect), _React$createElement))
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderSalesOrderTable',
	        value: function renderSalesOrderTable() {
	            var _this3 = this;
	
	            if (this.props.todaysOutgoingOrdersIsLoading && !this.props.todaysOutgoingOrdersError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.todaysOutgoingOrdersError) {
	                return _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'alert alert-danger' },
	                        JSON.stringify(this.props.todaysOutgoingOrdersError)
	                    )
	                );
	            } else {
	                var _React$createElement2;
	
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.SOs);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var POs = _extends({}, _this3.state.POs, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this3.setState({ POs: POs });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var POs = _extends({}, _this3.state.POs, { selectedRows: rows });
	                    _this3.setState({ POs: POs });
	                };
	
	                //Custom Formatter component
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNameFormatter = _react2.default.createClass({
	                    displayName: 'VendorNameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNumFormatter = _react2.default.createClass({
	                    displayName: 'VendorNumFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.VendorNum
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'SONum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_no' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 90,
	                    filterable: true
	                }, {
	                    key: 'Deliver_Customer_num',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_id' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 70,
	                    filterable: true
	                }, {
	                    key: 'Deliver_CustomerName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120,
	                    filterable: true
	                }, {
	                    key: 'Description',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120,
	                    filterable: true
	                }, {
	                    key: 'TotalPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 75,
	                    filterable: true
	                }, {
	                    key: 'Sales_User_id',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true
	                }, {
	                    key: 'SaleStatus',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true
	                }, {
	                    key: 'OrderDate',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true,
	                    formatter: DateFormatter
	                }, {
	                    key: 'DispatchDate',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'scheduled_to_ship' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120,
	                    filterable: true,
	                    formatter: DateFormatter
	                }, {
	                    key: 'ShipmentDate',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120,
	                    filterable: true,
	                    formatter: DateFormatter
	                }];
	
	                return (
	                    // React Table Sales Order Shipped
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                'div',
	                                { id: 'WarehouseDashboard-dataGrid2' },
	                                _react2.default.createElement(_reactDataGrid2.default, (_React$createElement2 = {
	                                    rowKey: 'PurchaseOrder_id',
	                                    onGridSort: handleGridSort,
	                                    columns: columns,
	                                    rowHeight: 25,
	                                    rowGetter: rowGetter,
	                                    rowsCount: getSize(),
	                                    minHeight: this.state.tableHeight
	                                }, _defineProperty(_React$createElement2, 'rowHeight', 25), _defineProperty(_React$createElement2, 'onRowSelect', onRowSelect), _React$createElement2))
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderZonesTable',
	        value: function renderZonesTable() {
	            var _this4 = this;
	
	            if (this.props.SOIsLoading && !this.props.SOError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.SOError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.SOError)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.zones);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var zones = _extends({}, _this4.state.zones, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this4.setState({ zones: zones });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var zones = _extends({}, _this4.state.zones, { selectedRows: rows });
	                    _this4.setState({ zones: zones });
	                };
	
	                //Custom Formatter component
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNameFormatter = _react2.default.createClass({
	                    displayName: 'VendorNameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNumFormatter = _react2.default.createClass({
	                    displayName: 'VendorNumFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.VendorNum
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'WarehouseZone_id',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone_id' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'AvailableBin',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'available_bins' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'TotalBin',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_bins' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'AvailableSpace',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'available_space' }),
	                    resizable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'TotalSpace',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_space' }),
	                    resizable: true,
	                    width: 100,
	                    filterable: true
	                }];
	
	                return (
	                    // React Table Zone Table
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                'div',
	                                { id: 'WarehouseDashboard-dataGrid3' },
	                                _react2.default.createElement(_reactDataGrid2.default, {
	                                    rowKey: 'WarehouseZone_id',
	                                    onGridSort: handleGridSort,
	                                    columns: columns,
	                                    rowGetter: rowGetter,
	                                    rowsCount: getSize(),
	                                    minHeight: this.state.tableHeight,
	                                    rowHeight: 25,
	                                    onRowSelect: onRowSelect })
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderSalesDatePicker',
	        value: function renderSalesDatePicker(handleSubmit) {
	            return _react2.default.createElement(
	                'form',
	                { onSubmit: handleSubmit },
	                _react2.default.createElement(_reduxForm.Field, { name: 'SalesDate', component: _datePicker.DatePicker })
	            );
	        }
	    }, {
	        key: 'renderPurchaseDatePicker',
	        value: function renderPurchaseDatePicker(handleSubmit) {
	            return _react2.default.createElement(
	                'form',
	                { onSubmit: handleSubmit },
	                _react2.default.createElement(_reduxForm.Field, { name: 'PurchaseDate', component: _datePicker.DatePicker })
	            );
	        }
	    }, {
	        key: 'renderNumPONotArrive',
	        value: function renderNumPONotArrive() {
	            if (this.props.warehouseBinsDetailIsLoading && !this.props.warehouseBinsDetailError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.warehouseBinsDetailError) {
	                return _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'alert alert-danger' },
	                        JSON.stringify(this.props.warehouseBinsDetailError)
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'dash-number' },
	                    this.state.totalPO
	                );
	            }
	        }
	    }, {
	        key: 'renderNumSONotShip',
	        value: function renderNumSONotShip() {
	            if (this.props.warehouseBinsDetailIsLoading && !this.props.warehouseBinsDetailError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.warehouseBinsDetailError) {
	                return _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'alert alert-danger' },
	                        JSON.stringify(this.props.warehouseBinsDetailError)
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'dash-number' },
	                    this.state.totalSO
	                );
	            }
	        }
	    }, {
	        key: 'renderTotalConvert',
	        value: function renderTotalConvert() {
	            if (this.props.warehouseBinsDetailIsLoading && !this.props.warehouseBinsDetailError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.warehouseBinsDetailError) {
	                return _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'alert alert-danger' },
	                        JSON.stringify(this.props.warehouseBinsDetailError)
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'dash-number' },
	                    this.state.totalConvert
	                );
	            }
	        }
	    }, {
	        key: 'renderTotalAdjust',
	        value: function renderTotalAdjust() {
	            if (this.props.warehouseBinsDetailIsLoading && !this.props.warehouseBinsDetailError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.warehouseBinsDetailError) {
	                return _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'alert alert-danger' },
	                        JSON.stringify(this.props.warehouseBinsDetailError)
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'dash-number' },
	                    this.state.totalAdjust
	                );
	            }
	        }
	    }, {
	        key: 'getWarehouseOptions',
	        value: function getWarehouseOptions() {
	            var warehouseOptions = [];
	            this.props.warehouses.map(function (warehouse) {
	                warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name });
	            });
	            return warehouseOptions;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                numPurchaseQuotes = _props.numPurchaseQuotes;
	
	            var height = (this.state.tableHeight + 85).toString();
	            var tableCollapseFix = { height: height };
	            var warehouseOptions = this.getWarehouseOptions();
	
	            var data = [{ color: "#97ddf0", label: "test1", value: 2 }, { color: "#fafafa", label: "test2", value: 1 }];
	
	            var options = {
	                animateRotate: true
	            };
	
	            var createDialogStyle = {
	                width: '600px',
	                marginLeft: '-10%'
	            };
	
	            var purchaseOrderPanelHeader = _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 8 },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_order_arrivals' })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 4 },
	                    this.renderPurchaseDatePicker(handleSubmit)
	                )
	            );
	
	            var salesOrdersShippedPanelHeader = _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 8 },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sale_orders_to_ship' })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 4 },
	                    this.renderSalesDatePicker(handleSubmit)
	                )
	            );
	
	            var warehouseBinsPanelHeader = _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_bins' })
	            );
	
	            return (
	                //---------------
	                // Begin HTML
	                //---------------
	                _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            { active: 'true' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_dashboard' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Grid,
	                        { id: 'warehouse-dashboard', fluid: 'true' },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_dashboard' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(_time2.default, null),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5ths' },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/inventories/receiveHistory' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel widget' },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'row-table' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 5, className: 'bg-blue' },
	                                                this.renderNumPONotArrive()
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 7 },
	                                                _react2.default.createElement(
	                                                    'h3',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_orders_not_arrived' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5ths' },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/shipping' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel widget' },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'row-table' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 5, className: 'bg-red' },
	                                                this.renderNumSONotShip()
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 7 },
	                                                _react2.default.createElement(
	                                                    'h3',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_orders_not_shipped' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5ths' },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/productConvertReport' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel widget' },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'row-table' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 5, className: 'bg-yellow' },
	                                                this.renderTotalConvert()
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 7 },
	                                                _react2.default.createElement(
	                                                    'h3',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'products_converted' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5ths' },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/inventories' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel widget' },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'row-table' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 5, className: 'bg-green' },
	                                                this.renderTotalAdjust()
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 7 },
	                                                _react2.default.createElement(
	                                                    'h3',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'products_adjusted' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        ' ',
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(
	                                    'h2',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchase_overview' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { header: purchaseOrderPanelHeader, style: tableCollapseFix },
	                                    this.renderPurchaseOrderTable()
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(
	                                    'h2',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sale_overview' })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { header: salesOrdersShippedPanelHeader, style: tableCollapseFix },
	                                    this.renderSalesOrderTable()
	                                )
	                            )
	                        ),
	                        ' '
	                    ),
	                    _react2.default.createElement(
	                        _reactSkylight.SkyLightStateless,
	                        { dialogStyles: createDialogStyle, isVisible: this.state.createQuoteOpen, onCloseClicked: function onCloseClicked() {
	                                _this5.closeQuoteCreate();
	                            }, title: 'Create a Purchase Quote' },
	                        _react2.default.createElement(_purchaseQuoteModal2.default, { closeC: this.closeQuoteCreate })
	                    ),
	                    _react2.default.createElement(
	                        _reactSkylight.SkyLightStateless,
	                        { dialogStyles: createDialogStyle, isVisible: this.state.createFavoriteOpen, onCloseClicked: function onCloseClicked() {
	                                _this5.closeFavoriteCreate();
	                            }, title: 'Create a new Favorite' },
	                        _react2.default.createElement(_favoriteModal2.default, { closeC: this.closeFavoriteCreate, closeA: this.addFavorite })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return WarehouseDashboard;
	}(_react.Component);
	
	WarehouseDashboard.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = WarehouseDashboard;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(WarehouseDashboard, 'WarehouseDashboard', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/warehouseDashboard.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Purchase/warehouseDashboard.jsx');
	}();

	;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAutosuggest = __webpack_require__(85);
	
	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
	
	var _root_url = __webpack_require__(9);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactIsolatedScroll = __webpack_require__(87);
	
	var _reactIsolatedScroll2 = _interopRequireDefault(_reactIsolatedScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var fetchProductDetail = function fetchProductDetail(customerId, searchType, value, success, failed) {
	  var url = _root_url.ROOT_URL + 'v1/inventory/sales_order/search/simplified/' + customerId + '/?' + searchType + '=' + value;
	  if (!customerId) {
	    failed();
	    return;
	  }
	  console.log('fetchProductDetail', url);
	  (0, _axios2.default)({
	    method: "GET",
	    url: url,
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    success(res.data);
	  }).catch(function (err) {
	    console.log('err', err);
	  });
	};
	// Imagine you have a list of languages that you'd like to autosuggest.
	var languages = [{
	  name: 'C',
	  year: 1972
	}, {
	  name: 'Elm',
	  year: 2012
	}];
	
	// Teach Autosuggest how to calculate suggestions for any given input value.
	var getSuggestions = function getSuggestions(value) {
	  var inputValue = value.trim().toLowerCase();
	  var inputLength = inputValue.length;
	
	  return inputLength === 0 ? [] : languages.filter(function (lang) {
	    return lang.name.toLowerCase().slice(0, inputLength) === inputValue;
	  });
	};
	
	// When suggestion is clicked, Autosuggest needs to populate the input
	// based on the clicked suggestion. Teach Autosuggest how to calculate the
	// input value for every given suggestion.
	// const getSuggestionValue = suggestion => {
	//   console.log('getSuggestionValue', suggestion);
	//   return suggestion.name
	// };
	
	// Use your imagination to render suggestions.
	var renderSuggestion = function renderSuggestion(suggestion) {
	  var _React$createElement;
	
	  return _react2.default.createElement(
	    _reactBootstrap.Row,
	    (_React$createElement = {
	      className: 'suggestion',
	      id: 'suggestion-render'
	    }, _defineProperty(_React$createElement, 'className', 'sales-auto-suggest-suggestions'), _defineProperty(_React$createElement, 'style', { fontSize: '15px' }), _React$createElement),
	    _react2.default.createElement(
	      _reactBootstrap.Col,
	      { xs: 3 },
	      suggestion.Name
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Col,
	      { xs: 3 },
	      suggestion.Description
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Col,
	      { xs: 3 },
	      suggestion.ProductNum
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Col,
	      { xs: 3 },
	      suggestion.InStock
	    )
	  );
	};
	
	var RMAAutoSuggest = function (_React$Component) {
	  _inherits(RMAAutoSuggest, _React$Component);
	
	  function RMAAutoSuggest() {
	    _classCallCheck(this, RMAAutoSuggest);
	
	    // Autosuggest is a controlled component.
	    // This means that you need to provide an input value
	    // and an onChange handler that updates this value (see below).
	    // Suggestions also need to be provided to the Autosuggest,
	    // and they are initially empty because the Autosuggest is closed.
	    var _this = _possibleConstructorReturn(this, (RMAAutoSuggest.__proto__ || Object.getPrototypeOf(RMAAutoSuggest)).call(this));
	
	    _this.onChange = function (event, _ref) {
	      var newValue = _ref.newValue;
	
	      _this.setState({
	        value: newValue
	      });
	    };
	
	    _this.shapeData = function (data) {
	      return data.splice(0, 5);
	    };
	
	    _this.onSuggestionsFetchRequested = function (_ref2) {
	      var value = _ref2.value;
	      var _this$props = _this.props,
	          customerId = _this$props.customerId,
	          _this$props$searchTyp = _this$props.searchType,
	          searchType = _this$props$searchTyp === undefined ? 'ProductNum' : _this$props$searchTyp;
	
	      var success = function success(data) {
	        _this.setState({
	          suggestions: _this.shapeData(data)
	        });
	      };
	      var failed = function failed(res) {
	        _this.setState({
	          suggestions: []
	        });
	      };
	      fetchProductDetail(customerId, searchType, value, success, failed);
	    };
	
	    _this.onSuggestionSelected = function (event, _ref3) {
	      var suggestion = _ref3.suggestion,
	          suggestionValue = _ref3.suggestionValue,
	          suggestionIndex = _ref3.suggestionIndex,
	          sectionIndex = _ref3.sectionIndex,
	          method = _ref3.method;
	
	      event.stopPropagation();
	      event.preventDefault();
	      _this.props.handleProductSelect(suggestion);
	    };
	
	    _this.onSuggestionsClearRequested = function () {
	      _this.setState({
	        suggestions: []
	      });
	    };
	
	    _this.renderSuggestionsContainer = function (_ref4) {
	      var containerProps = _ref4.containerProps,
	          children = _ref4.children;
	
	      var ref = containerProps.ref,
	          restContainerProps = _objectWithoutProperties(containerProps, ['ref']);
	
	      var callRef = function callRef(scrollingDiv) {
	        if (scrollingDiv !== null) {
	          ref(scrollingDiv.component);
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, restContainerProps, { style: { maxWidth: '100%' } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'container', style: { width: '100%' } },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { style: { padding: '10px 5px', margin: '0px' }, className: 'sales-auto-suggest-suggestions', id: 'sales-auto-suggest-header' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_desc' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_no' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'instock' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactIsolatedScroll2.default,
	          { id: 'suggestions-customer-container', ref: callRef },
	          children
	        )
	      );
	    };
	
	    _this.getSuggestionValue = function (suggestion) {
	      // console.log('getSuggestionValue', suggestion);
	      // return `${suggestion.Name} | ${suggestion.Description}`;
	      return '';
	    };
	
	    _this.state = {
	      value: '',
	      suggestions: []
	    };
	    return _this;
	  }
	
	  // Autosuggest will call this function every time you need to update suggestions.
	  // You already implemented this logic above, so just use it.
	
	
	  // Autosuggest will call this function every time you need to clear suggestions.
	
	
	  _createClass(RMAAutoSuggest, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          value = _state.value,
	          suggestions = _state.suggestions;
	      // Autosuggest will pass through all these props to the input.
	
	      var inputProps = {
	        placeholder: 'search',
	        value: value,
	        onChange: this.onChange
	      };
	
	      // Finally, render it!
	      return _react2.default.createElement(_reactAutosuggest2.default, {
	        suggestions: suggestions,
	        onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
	        onSuggestionsClearRequested: this.onSuggestionsClearRequested,
	        renderSuggestionsContainer: this.renderSuggestionsContainer,
	        getSuggestionValue: this.getSuggestionValue,
	        onSuggestionSelected: this.onSuggestionSelected,
	        renderSuggestion: renderSuggestion,
	        inputProps: inputProps
	      });
	    }
	  }]);
	
	  return RMAAutoSuggest;
	}(_react2.default.Component);
	
	var _default = RMAAutoSuggest;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchProductDetail, 'fetchProductDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/RMAAutoSuggest.jsx');
	
	  __REACT_HOT_LOADER__.register(languages, 'languages', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/RMAAutoSuggest.jsx');
	
	  __REACT_HOT_LOADER__.register(getSuggestions, 'getSuggestions', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/RMAAutoSuggest.jsx');
	
	  __REACT_HOT_LOADER__.register(renderSuggestion, 'renderSuggestion', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/RMAAutoSuggest.jsx');
	
	  __REACT_HOT_LOADER__.register(RMAAutoSuggest, 'RMAAutoSuggest', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/RMAAutoSuggest.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/RMAAutoSuggest.jsx');
	}();

	;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StringFormatter = function StringFormatter(_ref) {
	    var value = _ref.value;
	
	    return _react2.default.createElement(
	        "span",
	        null,
	        value.toString()
	    );
	};
	
	var _default = StringFormatter;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(StringFormatter, "StringFormatter", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/booleanFormatter.jsx");
	
	    __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/booleanFormatter.jsx");
	}();

	;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _genericRadioFilter = __webpack_require__(50);
	
	var _genericRadioFilter2 = _interopRequireDefault(_genericRadioFilter);
	
	var _dateFilterRadios = __webpack_require__(49);
	
	var _dateFilterRadios2 = _interopRequireDefault(_dateFilterRadios);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _booleanFormatter = __webpack_require__(455);
	
	var _booleanFormatter2 = _interopRequireDefault(_booleanFormatter);
	
	var _GenericProductSuggest = __webpack_require__(51);
	
	var _GenericProductSuggest2 = _interopRequireDefault(_GenericProductSuggest);
	
	var _cleanDates = __webpack_require__(22);
	
	var _rmaDateFormatter = __webpack_require__(457);
	
	var _reactPaginate = __webpack_require__(104);
	
	var _reactPaginate2 = _interopRequireDefault(_reactPaginate);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _rma = __webpack_require__(283);
	
	var _rma2 = _interopRequireDefault(_rma);
	
	var _url = __webpack_require__(20);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	;
	
	var NumericFilter = _reactDataGridAddons.Filters.NumericFilter,
	    AutoCompleteFilter = _reactDataGridAddons.Filters.AutoCompleteFilter,
	    MultiSelectFilter = _reactDataGridAddons.Filters.MultiSelectFilter,
	    SingleSelectFilter = _reactDataGridAddons.Filters.SingleSelectFilter;
	
	
	var processStatus = [{
	  label: 'Unreceived',
	  value: 'unreceived'
	}, {
	  label: 'Received',
	  value: 'received'
	}, {
	  label: 'Checking',
	  value: 'checking'
	}, {
	  label: 'Repairing',
	  value: 'repairing'
	}, {
	  label: 'Complete',
	  value: 'complete'
	}];
	
	var fixingStatus = [{ label: 'UNRECEIVED', value: 'UNRECEIVED' }, { label: 'RECEIVED', value: 'RECEIVED' }, { label: 'REPAIRING', value: 'REPAIRING' }, { label: 'REPAIRED', value: 'REPAIRED' }, { label: 'DISPATCHED', value: 'DISPATCHED' }];
	
	var requestTypeOptions = [{ value: 'relaunch', label: 'Relaunch' }, { value: 'repair', label: 'Repair' }];
	
	var isFBD = _root_url.ROOT_API_URL === 'https://fbd-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://fbd-scm.truckxi.com/api/';
	
	var deleteRMA = function deleteRMA(rmaId, success, failed) {
	  (0, _axios2.default)({
	    url: _root_url.ROOT_URL + "v1/bd_rma/void/" + rmaId,
	    method: 'POST',
	    data: {},
	    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	  }).then(function (res) {
	    console.log('res', res);
	    success();
	  }).catch(function (err) {
	    console.log('err', err);
	    failed();
	  });
	};
	var Confirmation = _rma2.default.Confirmation;
	
	var RowRenderer = function (_Component) {
	  _inherits(RowRenderer, _Component);
	
	  function RowRenderer() {
	    _classCallCheck(this, RowRenderer);
	
	    return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(RowRenderer, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      // here we are just changing the style
	      // but we could replace this with anything we liked, cards, images, etc
	      // usually though it will just be a matter of wrapping a div, and then calling back through to the grid
	      return _react2.default.createElement(
	        "div",
	        {
	          onDoubleClick: function onDoubleClick() {
	            _this2.props.onDoubleClick(_this2.props.row);
	          }
	        },
	        _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: "row" }, this.props))
	      );
	    }
	  }]);
	
	  return RowRenderer;
	}(_react.Component);
	
	RowRenderer.PropTypes = {
	  onDoubleClick: _react2.default.PropTypes.func
	};
	
	var OptionsFilterRenderer = function (_Component2) {
	  _inherits(OptionsFilterRenderer, _Component2);
	
	  function OptionsFilterRenderer() {
	    var _ref;
	
	    var _temp, _this3, _ret;
	
	    _classCallCheck(this, OptionsFilterRenderer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_ref = OptionsFilterRenderer.__proto__ || Object.getPrototypeOf(OptionsFilterRenderer)).call.apply(_ref, [this].concat(args))), _this3), _this3.state = {
	      selected: null
	    }, _this3.handleChange = function (selected) {
	      var _this3$props = _this3.props,
	          onChange = _this3$props.onChange,
	          column = _this3$props.column;
	
	      _this3.setState({
	        selected: selected
	      });
	      onChange({
	        filterTerm: selected ? selected.value : selected,
	        column: column
	      });
	    }, _this3.renderSelection = function () {
	      var _this3$props2 = _this3.props,
	          onChange = _this3$props2.onChange,
	          column = _this3$props2.column;
	
	      if (column.filterable === false) {
	        return _react2.default.createElement("span", null);
	      }
	      return _react2.default.createElement(_reactSelect2.default, {
	        clearable: true,
	        value: _this3.state.selected,
	        options: _this3.props.options,
	        onChange: function onChange(selected) {
	          _this3.handleChange(selected);
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this3, _ret);
	  }
	
	  _createClass(OptionsFilterRenderer, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "form-group" },
	        this.renderSelection()
	      );
	    }
	  }]);
	
	  return OptionsFilterRenderer;
	}(_react.Component);
	
	var generateFilterOptions = function generateFilterOptions(options) {
	  return function (props) {
	    return _react2.default.createElement(OptionsFilterRenderer, _extends({}, props, {
	      options: options
	    }));
	  };
	};
	
	var Rma = function (_Component3) {
	  _inherits(Rma, _Component3);
	
	  function Rma() {
	    _classCallCheck(this, Rma);
	
	    var _this4 = _possibleConstructorReturn(this, (Rma.__proto__ || Object.getPrototypeOf(Rma)).call(this));
	
	    _this4.refreshList = function (nextProps) {
	      var path = _this4.state.path;
	
	      var fromDate = _this4.state.FromDate ? _this4.formatDate(_this4.state.FromDate) : '1900-01-01';
	      var toDate = _this4.state.ToDate ? _this4.formatDate(_this4.state.ToDate) : '3000-01-01';
	      var days = _this4.state.days;
	
	      if (days == null) {
	        days = 7;
	      }
	      if (path === 'customerRMA') {
	        _this4.props.fetchCustomerReturnsByFilter(fromDate, toDate, days, nextProps.Status, _this4.state.currentPage + 1, _this4.state.currentCustomer, _this4.state.search);
	      } else if (path === 'dispatchRMA') {
	        _this4.props.fetchDispatchReturns(fromDate, toDate, days, nextProps.status, _this4.state.search);
	      }
	      _this4.setState({
	        selectedRows: []
	      });
	    };
	
	    _this4.redirect = function (e) {
	      e.preventDefault();
	      var Id = void 0;
	      if (_this4.state.selectedRows) {
	        Id = _this4.state.selectedRows[0].Id;
	      } else {
	        return;
	      }
	      _this4.context.router.push("/" + _this4.state.path + "/" + Id);
	    };
	
	    _this4.handleRMADelete = function (e) {
	      e.preventDefault();
	      _this4.setDeleteConfirmationModalVisibility(true);
	      // console.log('this.state.selectedRows', this.state.selectedRows, checkPermissionLocal('void_rma'));
	      // this.state.selectedRows.length !== 1 || !checkPermissionLocal('void_rma')
	    };
	
	    _this4.setDeleteConfirmationModalVisibility = function (isDeleteConfirmationVisible) {
	      return _this4.setState({ isDeleteConfirmationVisible: isDeleteConfirmationVisible });
	    };
	
	    _this4.onDeleteConfirm = function () {
	      var selectedRows = _this4.state.selectedRows;
	
	      var Id = selectedRows.map(function (row) {
	        return row.Id;
	      }).join(',');
	      deleteRMA(Id, function () {
	        _this4.refreshList(_this4.props);
	        _this4.setDeleteConfirmationModalVisibility(false);
	      }, function () {
	        var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'UNKNOWN';
	
	        alert(err);
	        _this4.setDeleteConfirmationModalVisibility(false);
	      });
	    };
	
	    _this4.createNew = function (e) {
	      e.preventDefault();
	      _this4.props.resetCurrentForm();
	      _this4.context.router.push("/" + _this4.state.path + "/new");
	    };
	
	    _this4.setToDate = function (e) {
	      if (e < _this4.state.FromDate) {
	        return;
	      }
	      _this4.setState({ ToDate: e });
	    };
	
	    _this4.setFromDate = function (e) {
	      if (e > _this4.state.ToDate) {
	        return;
	      }
	      _this4.setState({ FromDate: e });
	    };
	
	    _this4.setToRangeSearch = function () {
	      _this4.setState({ days: '-1' });
	    };
	
	    _this4.handleStatusFilterChange = function (status) {
	      var returnsFilter = _this4.props.returnsFilter;
	      var path = _this4.state.path;
	
	      if (!returnsFilter) {
	        var fromDate = _this4.state.FromDate ? _this4.formatDate(_this4.state.FromDate) : '1900-01-01';
	        var toDate = _this4.state.ToDate ? _this4.formatDate(_this4.state.ToDate) : '3000-01-01';
	        var days = _this4.state.days;
	
	        if (!_this4.state.days) {
	          days = 7;
	        }
	        _this4.setState({ status: status }, function () {
	          if (path === 'customerRMA') {
	            _this4.props.fetchCustomerReturnsByFilter(fromDate, toDate, days, status, _this4.state.currentPage + 1, _this4.state.currentCustomer, _this4.state.search);
	          } else if (path === 'dispatchRMA') {
	            _this4.props.fetchDispatchReturns(fromDate, toDate, days, status, _this4.state.search);
	          }
	        });
	      } else {
	        _this4.setState({ status: status }, function () {});
	      }
	    };
	
	    _this4.exportData = function () {
	      var _this4$state = _this4.state,
	          path = _this4$state.path,
	          search = _this4$state.search,
	          status = _this4$state.status;
	
	      var rmaURL = void 0;
	      var fromDate = _this4.state.FromDate ? _this4.formatDate(_this4.state.FromDate) : '1900-01-01';
	      var toDate = _this4.state.ToDate ? _this4.formatDate(_this4.state.ToDate) : '3000-01-01';
	      var days = _this4.state.days;
	
	      if (!_this4.state.days) {
	        days = 7;
	      }
	      var dates = (0, _cleanDates.toFromDates)(days, fromDate, toDate);
	      if (path === "dispatchRMA") {
	        rmaURL = _url.BD_RMA_URL + "fix/search/export/?Bearer=" + localStorage.getItem('token');
	      } else if (path === "customerRMA") {
	        rmaURL = _url.BD_RMA_URL + "/search/export/?Bearer=" + localStorage.getItem('token');
	      }
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            style: { marginLeft: 15 },
	            bsStyle: "success",
	            disabled: !_this4.state.rows,
	            href: rmaURL },
	          _react2.default.createElement("em", { className: "fa fa-arrow-circle-o-down" }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: "excel" })
	        )
	      );
	    };
	
	    _this4.fetchReturnsByDetails = function (days) {
	      var path = _this4.state.path;
	
	      var FromDate = '1900-01-01';
	      var ToDate = '3000-01-01';
	      if (_this4.state.FromDate != null) {
	        FromDate = _this4.formatDate(_this4.state.FromDate);
	      }
	      if (_this4.state.ToDate != null) {
	        ToDate = _this4.formatDate(_this4.state.ToDate);
	      }
	      if (days === '-1' || days === -1) {
	        _this4.setState({ days: days }, function () {
	          if (path === 'customerRMA') {
	            _this4.props.fetchCustomerReturnsByFilter(FromDate, ToDate, days, _this4.state.status, _this4.state.currentPage + 1, _this4.state.currentCustomer, _this4.state.search);
	          } else if (path === 'dispatchRMA') {
	            _this4.props.fetchDispatchReturns(FromDate, ToDate, days, _this4.state.status, _this4.state.search);
	          }
	        });
	      } else {
	        _this4.setState({ days: days, FromDate: null, ToDate: null }, function () {
	          if (path === 'customerRMA') {
	            _this4.props.fetchCustomerReturnsByFilter(FromDate, ToDate, days, _this4.state.status, _this4.state.currentPage + 1, _this4.state.currentCustomer, _this4.state.search);
	          } else if (path === 'dispatchRMA') {
	            _this4.props.fetchDispatchReturns(FromDate, ToDate, days, status, _this4.state.search);
	          }
	        });
	      }
	      _this4.setState({ selectedRows: [], days: days });
	    };
	
	    _this4.onEnter = function (e) {
	      console.log('e', e);
	      if (e.charCode === 13) {
	        _this4.fetchSearchReturns();
	      } else {
	        return false;
	      }
	    };
	
	    _this4.fetchSearchReturns = function () {
	      var _this4$state2 = _this4.state,
	          path = _this4$state2.path,
	          status = _this4$state2.status,
	          days = _this4$state2.days;
	
	      var FromDate = '1900-01-01';
	      var ToDate = '3000-01-01';
	      if (_this4.state.FromDate != null) {
	        FromDate = _this4.formatDate(_this4.state.FromDate);
	      }
	      if (_this4.state.ToDate != null) {
	        ToDate = _this4.formatDate(_this4.state.ToDate);
	      }
	      if (path === 'customerRMA') {
	        _this4.props.fetchCustomerReturnsByFilter(FromDate, ToDate, _this4.state.days, status, _this4.state.currentPage + 1, _this4.state.currentCustomer, _this4.state.search);
	      } else if (path === 'dispatchRMA') {
	        // this.props.fetchDispatchReturns(FromDate, ToDate, days, status, this.state.search)
	      }
	    };
	
	    _this4.renderSearch = function (e) {
	      // let { days } = this.state;
	      // if (!this.state.days) {
	      //   days = 7;
	      // }
	      // let { status } = this.state;
	      // const { path } = this.state;
	      // const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
	      // const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
	      return _react2.default.createElement(
	        "div",
	        { className: "control-dropdown-rma" },
	        _react2.default.createElement(_GenericProductSuggest2.default, {
	          value: _this4.state.search,
	          onChange: function onChange(e, _ref2) {
	            var newValue = _ref2.newValue;
	
	            _this4.setState({ search: newValue });
	          },
	          onKeyPress: function onKeyPress(e) {
	            return _this4.onEnter(e);
	          }
	        })
	      );
	      // if (!this.state.filteredByItem) {
	      //   return (
	      //     <div className="control-dropdown-rma">
	      //       <GenericProductSuggest
	      //         value={this.state.search}
	      //         onChange={(e, { newValue }) => {
	      //           this.setState({ search: newValue });
	      //         }}
	      //         onKeyPress={(e) => this.onEnter(e)}
	      //       />
	      //     </div>
	      //   )
	      // }
	      // return (
	      //   <div className="control-dropdown-rma" id="suggestion-box">
	      //     {this.state.search}
	      //     <em
	      //       className="fa fa-times pull-right"
	      //       onClick={() => {
	      //         this.setState({ filteredByItem: false, search: '' }, () => {
	      //           this.props.fetchCustomerReturnsByFilter(fromDate, toDate, days, status, this.state.currentPage, this.state.currentCustomer);
	      //         });
	      //       }}
	      //     />
	      //   </div>
	      // )
	    };
	
	    _this4.changeRMAStatus = function (status) {
	      var selectedRows = _this4.state.selectedRows;
	      // const { Id } = selectedRows[0];
	
	      var Ids = [];
	      selectedRows.forEach(function (row) {
	        Ids.push(row.Id);
	      });
	      var success = function success() {
	        alert('success');
	        _this4.setState({
	          selectedRows: []
	        });
	        _this4.fetchSearchReturns();
	      };
	      var failed = function failed() {
	        alert('failed');
	      };
	      _this4.props.changeRMAStatus(Ids.join(','), status, success, failed);
	    };
	
	    _this4.renderPagination = function () {
	      var handleOnPageChange = function handleOnPageChange(_ref3) {
	        var selected = _ref3.selected;
	
	        _this4.setState({
	          currentPage: selected
	        }, function () {
	          return [_this4.fetchSearchReturns()];
	        });
	      };
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { md: 12 },
	          _react2.default.createElement(
	            "div",
	            { style: { width: '630px' }, id: "react-pagination" },
	            _react2.default.createElement(_reactPaginate2.default, {
	              previousLabel: _react2.default.createElement(_reactReduxI18n.Translate, { value: "prev_page" }),
	              nextLabel: _react2.default.createElement(_reactReduxI18n.Translate, { value: "next_page" }),
	              containerClassName: 'pagination',
	              activeClassName: 'active',
	              marginPagesDisplayed: 2,
	              pageRangeDisplayed: 5,
	              pageCount: _this4.props.pages,
	              onPageChange: handleOnPageChange,
	              forcePage: _this4.state.currentPage
	            })
	          )
	        )
	      );
	    };
	
	    _this4.generateExportURL = function () {
	      var _this4$state3 = _this4.state,
	          fromDate = _this4$state3.fromDate,
	          toDate = _this4$state3.toDate,
	          days = _this4$state3.days,
	          currentCustomer = _this4$state3.currentCustomer,
	          selectedRows = _this4$state3.selectedRows;
	
	      var dates = (0, _cleanDates.toFromDates)(days, fromDate, toDate);
	      var ids = [];
	      selectedRows.forEach(function (row) {
	        ids.push(row.Id);
	      });
	      var url = _root_url.ROOT_URL + "v1/bd_rma/export?Bearer=" + localStorage.getItem('token');
	      if (ids.length) {
	        url = url + "&rma_ids=" + ids.join(',');
	      } else {
	        if (currentCustomer) {
	          url = url + "&customer_id=" + currentCustomer.value;
	        }
	        url = url + "&start__date=" + dates.fromDate + "&end_date=" + dates.toDate;
	      }
	      return url;
	    };
	
	    _this4.state = {
	      status: 'all',
	      FromDate: undefined,
	      ToDate: undefined,
	      days: '1',
	      search: '',
	      productSearchType: 'ProductNum',
	      rows: [],
	      selectedRows: [],
	      filters: {},
	      sortColumn: null,
	      sortDirection: null,
	      path: null,
	      filteredByItem: false,
	      currentPage: 0,
	      isDeleteConfirmationVisible: false
	    };
	    return _this4;
	  }
	
	  _createClass(Rma, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (isFBD) {
	        this.props.fetchCustomers(true);
	      } else {
	        this.props.fetchCustomers();
	      }
	      var fromDate = '1900-01-01';
	      var toDate = '3000-01-01';
	      var days = 1;
	      var status = 'all';
	      this.props.setDefaultDays('rma');
	      this.props.setDefaultOfForm('status', 'all', 'rma');
	      if (this.props.location.pathname === '/dispatchRMA') {
	        this.props.fetchDispatchReturns(fromDate, toDate, days, status, this.state.currentPage + 1);
	        this.setState({ path: 'dispatchRMA' });
	      } else if (this.props.location.pathname === '/customerRMA') {
	        this.props.fetchCustomerReturnsByFilter(fromDate, toDate, days, status, this.state.currentPage + 1, this.state.currentCustomer, this.state.search);
	        this.setState({ path: 'customerRMA' });
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.customerReturns !== nextProps.customerReturns) {
	        ;
	        this.setState({ rows: nextProps.customerReturns });
	      }
	
	      // if (nextProps.dispatchReturns.bd_rmas && this.props.dispatchReturns.bd_rmas !== nextProps.dispatchReturns.bd_rmas) {
	      //   let rows = nextProps.dispatchReturns.bd_rmas;
	      //   rows = rows.filter(r => r !== null);
	      //   this.setState({ rows: rows })
	      // }
	
	      // if (nextProps.Days && nextProps.Days !== this.props.Days) {
	      //   if (nextProps.Days !== -1) {
	      //     this.props.setDefaultOfForm('FromDate', null, 'rma');
	      //     this.props.setDefaultOfForm('ToDate', null, 'rma');
	      //   }
	      //   this.setState({ days: nextProps.Days });
	      // }
	
	      if (nextProps.Status && nextProps.Status !== this.props.Status) {
	        this.refreshList(nextProps);
	      }
	    }
	  }, {
	    key: "formatDate",
	    value: function formatDate(date) {
	      var formattedDate = date.getFullYear() + "-";
	      formattedDate += date.getMonth() + 1 + "-";
	      if (date.getDate() < 10) {
	        formattedDate += "0" + date.getDate();
	      } else {
	        formattedDate += date.getDate();
	      }
	      return formattedDate;
	    }
	  }, {
	    key: "renderTable",
	    value: function renderTable() {
	      var _this5 = this;
	
	      if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: "alert alert-danger" },
	            JSON.stringify(this.props.error)
	          )
	        );
	      }
	
	      // Parameters of the react-data-grid
	
	      var tableHeight = window.innerHeight < 930 ? 570 : 570;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this5.state);
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var onRowClick = function onRowClick(rowIdx, row) {
	        if (rowIdx !== -1) {
	          var rows = getRows();
	          rows.map(function (r) {
	            r.isSelected = false;
	          });
	          rows[rowIdx].isSelected = true;
	          _this5.setState({ rows: rows, selectedRows: [rows[rowIdx]] });
	        }
	      };
	
	      var onCellSelected = function onCellSelected(coordinates) {
	        // console.log('coordinates', coordinates);
	        // const rows = getRows();
	        // rows.map((r) => {
	        // r.isSelected = false;
	        // });
	        // rows[coordinates.rowIdx].isSelected = true;
	        // this.setState({ rows, selectedRows: [...this.state.selectedRows, rows[coordinates.rowIdx]] });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        _this5.setState({ filters: {} });
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this5.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this5.setState(state);
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var rows = _this5.state.rows;
	
	        if (rows && rows.length !== 0) {
	          rows.map(function (row) {
	            row.Dropship = row.IsDropship ? 'yes' : 'no';
	          });
	        }
	        _this5.setState({ rows: rows });
	        var newFilters = Object.assign({}, _this5.state.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        _this5.setState({ filters: newFilters });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var selectedRows = [].concat(_toConsumableArray(_this5.state.selectedRows), _toConsumableArray(rows.map(function (r) {
	          return r.row;
	        })));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        _this5.setState({ rows: newRows, selectedRows: selectedRows });
	      };
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = [].concat(_toConsumableArray(_this5.state.rows));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        var selectedRows = [];
	        newRows.forEach(function (row) {
	          if (row.isSelected) {
	            selectedRows.push(row);
	          }
	        });
	
	        _this5.setState({ rows: newRows, selectedRows: selectedRows });
	      };
	
	      var columns = [{
	        key: 'RMANum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: "rma_num" }),
	        resizable: true,
	        sortable: true,
	        width: 180,
	        filterable: true
	      }, {
	        key: 'CustomerName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: "customer_name" }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: 'SKU',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: "sku" }),
	        resizable: true,
	        sortable: true,
	        width: 130,
	        filterable: true
	      }, {
	        key: 'SNNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: "sn_num" }),
	        resizable: true,
	        sortable: true,
	        width: 130,
	        filterable: true
	      }, {
	        key: 'RequestType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: "request_type" }),
	        resizable: true,
	        sortable: true,
	        width: 130,
	        filterable: true,
	        filterRenderer: generateFilterOptions(requestTypeOptions)
	      }, {
	        key: 'ReturnTracking',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: "return_tracking" }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: 'ProcessStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: "proccess_status" }),
	        // formatter: StringFormatter,
	        resizable: true,
	        sortable: true,
	        width: 130,
	        filterable: true,
	        filterRenderer: generateFilterOptions(processStatus)
	      }, {
	        key: 'Status',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: "status" }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: "total_price" }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 120
	      }, {
	        key: 'CreateTime',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: "create_date" }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true,
	        formatter: _rmaDateFormatter.RMADateFormatter
	      }];
	
	      // React Table Purchase Order Full Table
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            "div",
	            { id: "PurchaseOrderList-dataGrid1" },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowRenderer: _react2.default.createElement(RowRenderer, {
	                onDoubleClick: function onDoubleClick(_ref4) {
	                  var Id = _ref4.Id;
	
	                  _this5.context.router.push("/" + _this5.state.path + "/" + Id);
	                }
	              }),
	              rowKey: "RMA_num",
	              enableCellSelect: true,
	              onClearFilters: onClearFilters,
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              columns: columns,
	              rowHeight: 25,
	              headerRowHeight: 45,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: tableHeight,
	              enableRowSelect: "multi",
	              onRowUpdated: this.handleRowUpdated,
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              },
	              onRowClick: onRowClick,
	              onCellSelected: onCellSelected
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "rma" })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: "true" },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: this.state.path === 'dispatchRMA' ? "dispatch_rma" : "customer_rma" })
	          )
	        ),
	        " ",
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: "purchase-order-list" },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { id: "date-range-picker", className: "form-horizontal" },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      "h3",
	                      { className: "filter-title" },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: "order_date" }),
	                      _react2.default.createElement(
	                        "span",
	                        { className: "colon" },
	                        ":"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 10 },
	                    (0, _dateFilterRadios2.default)({
	                      handleOnClick: this.fetchReturnsByDetails,
	                      setToRangeSearch: this.setToRangeSearch,
	                      setFromDate: this.setFromDate,
	                      setToDate: this.setToDate,
	                      FromDate: this.state.FromDate,
	                      ToDate: this.state.ToDate,
	                      Days: this.state.days
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { className: "position-relative table-collapse-fix", style: { height: '740px' } },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    _react2.default.createElement(
	                      _reactBootstrap.ButtonToolbar,
	                      { className: "table-buttons-rma" },
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: "success",
	                          type: "submit",
	                          onClick: function onClick(e) {
	                            return _this6.createNew(e);
	                          }
	                        },
	                        _react2.default.createElement("em", { className: "fa fa-plus" }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: "create" })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: "warning",
	                          type: "button",
	                          onClick: function onClick(e) {
	                            return _this6.redirect(e);
	                          },
	                          disabled: this.state.selectedRows.length !== 1
	                        },
	                        _react2.default.createElement("em", { className: "fa fa-pencil" }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: "edit" })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: "danger",
	                          type: "button",
	                          onClick: function onClick(e) {
	                            return _this6.handleRMADelete(e);
	                          },
	                          disabled: !this.state.selectedRows.length || !(0, _permissions2.default)('void_rma')
	                        },
	                        _react2.default.createElement("em", { className: "fa fa-trash" }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: "void" })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: "warning",
	                          type: "button"
	                          // onClick={e => this.h(e)}
	                          , href: this.generateExportURL()
	                          // disabled={this.state.selectedRows.length !== 1}
	                        },
	                        _react2.default.createElement("em", { className: "fa fa-download" }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: "export" })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: "primary",
	                          type: "button",
	                          href: "https://truckxi-public-bucket.s3.us-west-1.amazonaws.com/storage/49032580-16d4-4232-8ed0-1c9d76ae8045.csv"
	                        },
	                        _react2.default.createElement("em", { className: "fa fa-download" }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: "tempalte_download" })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: "primary",
	                          type: "button",
	                          onClick: function onClick() {
	                            _this6.refs.rmaUploadRef.click();
	                          }
	                        },
	                        _react2.default.createElement("em", { className: "fa fa-download" }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: "import" })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: "primary",
	                          type: "submit"
	                          // disabled={!this.state.search}
	                          , onClick: function onClick(e) {
	                            return _this6.fetchSearchReturns(e);
	                          } },
	                        _react2.default.createElement("em", { className: "fa fa-plus" }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: "search" })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 4 },
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          null,
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 5 },
	                            this.renderSearch()
	                          ),
	                          _react2.default.createElement(_reactBootstrap.Col, { xs: 1 }),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                "Customer: "
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 8 },
	                                _react2.default.createElement(_reactSelect2.default, {
	                                  clearable: true,
	                                  value: this.state.currentCustomer,
	                                  options: this.props.customerOptions,
	                                  onChange: function onChange(currentCustomer) {
	                                    _this6.setState({
	                                      currentCustomer: currentCustomer
	                                    }, function () {
	                                      _this6.fetchSearchReturns();
	                                    });
	                                  }
	                                })
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { style: { marginTop: '8px' } },
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 10 },
	                    _react2.default.createElement(
	                      _reactBootstrap.ButtonToolbar,
	                      { className: "table-buttons" },
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: "primary",
	                          type: "submit",
	                          disabled: !this.state.selectedRows.length,
	                          onClick: function onClick(e) {
	                            return _this6.changeRMAStatus('received');
	                          } },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: "received" })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: "primary",
	                          type: "submit",
	                          disabled: !this.state.selectedRows.length,
	                          onClick: function onClick(e) {
	                            return _this6.changeRMAStatus('checking');
	                          } },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: "checking" })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: "primary",
	                          type: "submit",
	                          disabled: !this.state.selectedRows.length,
	                          onClick: function onClick(e) {
	                            return _this6.changeRMAStatus('repairing');
	                          } },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: "repairing" })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: "primary",
	                          type: "submit",
	                          disabled: !this.state.selectedRows.length,
	                          onClick: function onClick(e) {
	                            return _this6.changeRMAStatus('complete');
	                          } },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: "complete" })
	                      )
	                    )
	                  )
	                ),
	                this.renderTable(),
	                this.renderPagination()
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(Confirmation, {
	          setModalVisibility: this.setDeleteConfirmationModalVisibility,
	          isVisible: this.state.isDeleteConfirmationVisible,
	          onConfirm: this.onDeleteConfirm
	        }),
	        _react2.default.createElement("input", {
	          type: "file",
	          ref: "rmaUploadRef",
	          style: { display: 'none' },
	          accept: ".csv",
	          onChange: function onChange(e) {
	            var formData = new FormData();
	            formData.append("rma_file", e.target.files[0]);
	            _this6.props.uploadRMA(formData, _this6.refreshList);
	          }
	        })
	      );
	    }
	  }]);
	
	  return Rma;
	}(_react.Component);
	
	Rma.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = Rma;
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(NumericFilter, "NumericFilter", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rma.jsx");
	
	  __REACT_HOT_LOADER__.register(AutoCompleteFilter, "AutoCompleteFilter", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rma.jsx");
	
	  __REACT_HOT_LOADER__.register(MultiSelectFilter, "MultiSelectFilter", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rma.jsx");
	
	  __REACT_HOT_LOADER__.register(SingleSelectFilter, "SingleSelectFilter", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rma.jsx");
	
	  __REACT_HOT_LOADER__.register(processStatus, "processStatus", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rma.jsx");
	
	  __REACT_HOT_LOADER__.register(fixingStatus, "fixingStatus", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rma.jsx");
	
	  __REACT_HOT_LOADER__.register(requestTypeOptions, "requestTypeOptions", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rma.jsx");
	
	  __REACT_HOT_LOADER__.register(isFBD, "isFBD", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rma.jsx");
	
	  __REACT_HOT_LOADER__.register(deleteRMA, "deleteRMA", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rma.jsx");
	
	  __REACT_HOT_LOADER__.register(Confirmation, "Confirmation", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rma.jsx");
	
	  __REACT_HOT_LOADER__.register(RowRenderer, "RowRenderer", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rma.jsx");
	
	  __REACT_HOT_LOADER__.register(OptionsFilterRenderer, "OptionsFilterRenderer", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rma.jsx");
	
	  __REACT_HOT_LOADER__.register(generateFilterOptions, "generateFilterOptions", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rma.jsx");
	
	  __REACT_HOT_LOADER__.register(Rma, "Rma", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rma.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rma.jsx");
	}();

	;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RMADateFormatter = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cleanDates = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RMADateFormatter = exports.RMADateFormatter = _react2.default.createClass({
	  displayName: 'RMADateFormatter',
	  render: function render() {
	    return this.props.value ? _react2.default.createElement(
	      'span',
	      null,
	      (0, _cleanDates.convertLocalDate)(this.props.value, 'MMM DD YYYY')
	    ) : null;
	  }
	});
	
	var _default = RMADateFormatter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(RMADateFormatter, 'RMADateFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rmaDateFormatter.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rmaDateFormatter.jsx');
	}();

	;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _selection = __webpack_require__(21);
	
	var _cleanDates = __webpack_require__(22);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _inputField = __webpack_require__(16);
	
	var _RMAAutoSuggest = __webpack_require__(454);
	
	var _RMAAutoSuggest2 = _interopRequireDefault(_RMAAutoSuggest);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isFBD = _root_url.ROOT_API_URL === 'https://fbd-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://fbd-scm.truckxi.com/api/';
	
	var getOptionValue = function getOptionValue(option) {
	  if ((typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
	    return option.value;
	  }
	  return option;
	};
	
	var getOptionLabel = function getOptionLabel(customer, customerOptions) {
	  if ((typeof customer === 'undefined' ? 'undefined' : _typeof(customer)) === 'object') {
	    return customer.label;
	  }
	  var label = '';
	  _lodash2.default.forEach(customerOptions, function (c) {
	    if (c.value === customer) {
	      label = c.label;
	    }
	  });
	  return label;
	};
	
	var fixingStatus = [{ label: 'UNRECEIVED', value: 'UNRECEIVED' }, { label: 'RECEIVED', value: 'RECEIVED' }, { label: 'REPAIRING', value: 'REPAIRING' }, { label: 'REPAIRED', value: 'REPAIRED' }, { label: 'DISPATCHED', value: 'DISPATCHED' }];
	
	var processStatus = [{
	  label: 'Unreceived',
	  value: 'unreceived'
	}, {
	  label: 'Received',
	  value: 'received'
	}, {
	  label: 'Checking',
	  value: 'checking'
	}, {
	  label: 'Repairing',
	  value: 'repairing'
	}, {
	  label: 'Complete',
	  value: 'complete'
	}];
	
	var solutionOptions = [{
	  label: '电池-内部短路-报废-L.40mins-R.0$-Lv0',
	  value: '电池-内部短路-报废-L.40mins-R.0$-Lv0'
	}, {
	  label: '电池-充电口坏-换充电口-L.40mins-R.45$-Lv4',
	  value: '电池-充电口坏-换充电口-L.40mins-R.45$-Lv4'
	}, {
	  label: '电池-电池上盖坏-换电池上盖-L.40mins-R.45$-Lv4',
	  value: '电池-电池上盖坏-换电池上盖-L.40mins-R.45$-Lv4'
	}, {
	  label: '电池-电量显示灯坏-换电量显示灯-L.40mins-R.45$-Lv4',
	  value: '电池-电量显示灯坏-换电量显示灯-L.40mins-R.45$-Lv4'
	}, {
	  label: '后拔链器脱落或卡进轮子里-仅拔链器坏-换拔链器-L.30mins-R.35$-Lv3',
	  value: '后拔链器脱落或卡进轮子里-仅拔链器坏-换拔链器-L.30mins-R.35$-Lv3'
	}, {
	  label: '后拔链器脱落或卡进轮子里-车架吊耳坏-换吊耳-L.10mins-R.15$-Lv1',
	  value: '后拔链器脱落或卡进轮子里-车架吊耳坏-换吊耳-L.10mins-R.15$-Lv1'
	}, {
	  label: '后拔链器脱落或卡进轮子里-链条坏-换链条-L.30mins-R.35$-Lv3',
	  value: '后拔链器脱落或卡进轮子里-链条坏-换链条-L.30mins-R.35$-Lv3'
	}, {
	  label: '后拔链器脱落或卡进轮子里-飞轮卡坏-换飞轮-L.15mins-R.25$-Lv2',
	  value: '后拔链器脱落或卡进轮子里-飞轮卡坏-换飞轮-L.15mins-R.25$-Lv2'
	}, {
	  label: '脚踩无助力-助力传感器坏-换飞轮-L.15mins-R.25$-Lv2',
	  value: '脚踩无助力-助力传感器坏-换飞轮-L.15mins-R.25$-Lv2'
	}, {
	  label: '刹车太松或失灵-机械碟刹-调紧刹车线-L.5mins-R.15$-Lv1',
	  value: '刹车太松或失灵-机械碟刹-调紧刹车线-L.5mins-R.15$-Lv1'
	}, {
	  label: '刹车太松或失灵-油压碟刹漏油-加矿物油-L.5mins-R.15$-Lv1',
	  value: '刹车太松或失灵-油压碟刹漏油-加矿物油-L.5mins-R.15$-Lv1'
	}, {
	  label: '刹车太松或失灵-油压碟刹进气-排气-L.5mins-R.15$-Lv1',
	  value: '刹车太松或失灵-油压碟刹进气-排气-L.5mins-R.15$-Lv1'
	}, {
	  label: '刹车异响-刹车钳磨碟刹盘-调整刹车钳位置-L.15mins-R.25$-Lv2',
	  value: '刹车异响-刹车钳磨碟刹盘-调整刹车钳位置-L.15mins-R.25$-Lv2'
	}, {
	  label: '刹车异响-刹车摩擦片问题-换刹车摩擦片-L.15mins-R.25$-Lv2',
	  value: '刹车异响-刹车摩擦片问题-换刹车摩擦片-L.15mins-R.25$-Lv2'
	}, {
	  label: '电机不启动-刹把断电了-恢复刹把或换断电线-L.30mins-R.35$-Lv3',
	  value: '电机不启动-刹把断电了-恢复刹把或换断电线-L.30mins-R.35$-Lv3'
	}, {
	  label: '电机不启动-电机坏-换电机-L.30mins-R.35$-Lv3',
	  value: '电机不启动-电机坏-换电机-L.30mins-R.35$-Lv3'
	}, {
	  label: '电机不启动-控制器坏-换控制器-L.30mins-R.35$-Lv3',
	  value: '电机不启动-控制器坏-换控制器-L.30mins-R.35$-Lv3'
	}, {
	  label: '电机不启动-主线束坏-换主线束-L.30mins-R.35$-Lv3',
	  value: '电机不启动-主线束坏-换主线束-L.30mins-R.35$-Lv3'
	}, {
	  label: '后轮摇摆-辐条松-校正辐条-L.无法操作-R.0$-UNABLE',
	  value: '后轮摇摆-辐条松-校正辐条-L.无法操作-R.0$-UNABLE'
	}, {
	  label: '后轮摇摆-轮胎线不均匀-放气调整轮胎线-L.5mins-R.15$-Lv1',
	  value: '后轮摇摆-轮胎线不均匀-放气调整轮胎线-L.5mins-R.15$-Lv1'
	}, {
	  label: '前大灯无法关闭-灯和控制器灯模块坏-换灯和控制器-L.5mins-R.15$-Lv1',
	  value: '前大灯无法关闭-灯和控制器灯模块坏-换灯和控制器-L.5mins-R.15$-Lv1'
	}, {
	  label: '仪表显示故障/屏幕坏-换仪表-L.5mins-R.15$-Lv1',
	  value: '仪表显示故障/屏幕坏-换仪表-L.5mins-R.15$-Lv1'
	}, {
	  label: '前叉漏油-换前叉-换仪表-L.30mins-R.35$-Lv3',
	  value: '前叉漏油-换前叉-换仪表-L.30mins-R.35$-Lv3'
	}, {
	  label: '曲柄坏-换曲柄-L.30mins-R.35$-Lv3',
	  value: '曲柄坏-换曲柄-L.30mins-R.35$-Lv3'
	}, {
	  label: '链盘坏-换链盘-L.30mins-R.35$-Lv3',
	  value: '链盘坏-换链盘-L.30mins-R.35$-Lv3'
	}, {
	  label: '内胎/衬带坏-换内胎/衬带-L.15-30mins-R.35$-Lv3',
	  value: '内胎/衬带坏-换内胎/衬带-L.15-30mins-R.35$-Lv3'
	}];
	
	var customerNoteShortcuts = {
	  2: [{
	    label: '质检',
	    value: '质检'
	  }, {
	    label: 'L0全产品,刷固件/校准/清洁/外观总成或更换维修',
	    value: 'L0全产品,刷固件/校准/清洁/外观总成或更换维修'
	  }, {
	    label: 'L1-单个PD前面板,MPPT板,主板,内部结构件等更换维修',
	    value: 'L1-单个PD前面板,MPPT板,主板,内部结构件等更换维修'
	  }, {
	    label: 'L2-两个及以上PD前面板,MPPT板,主板,内部结构件等更换维修',
	    value: 'L2-两个及以上PD前面板,MPPT板,主板,内部结构件等更换维修'
	  }, {
	    label: 'F1翻新(主机完好,更换外观件,调试,校准,升级固件,包装封膜等)',
	    value: 'F1翻新(主机完好,更换外观件,调试,校准,升级固件,包装封膜等)'
	  }, {
	    label: 'F2翻新(整机维修翻新,更换包装等)',
	    value: 'F2翻新(整机维修翻新,更换包装等)'
	  }],
	  3: [{
	    label: '质检',
	    value: '质检'
	  }, {
	    label: 'L0- 功能异常机器检测,需拆解机器,对电池包和BMS各输入输出端检测',
	    value: 'L0- 功能异常机器检测,需拆解机器,对电池包和BMS各输入输出端检测'
	  }, {
	    label: 'L1- 功能正常,外观件损坏更换 (上盖更换, 下盖更换, 钥匙丢失更换锁芯)',
	    value: 'L1- 功能正常,外观件损坏更换 (上盖更换, 下盖更换, 钥匙丢失更换锁芯)'
	  }, {
	    label: 'L2- 功能异常,拆解维修更换 (电池包, BMS, 控制板)',
	    value: 'L2- 功能异常,拆解维修更换 (电池包, BMS, 控制板)'
	  }, {
	    label: 'F1- 无故障类机器翻新,检测清洁和包装',
	    value: 'F1- 无故障类机器翻新,检测清洁和包装'
	  }, {
	    label: 'F2- 故障类机器翻新,维修完成后检测清洁和包装 ',
	    value: 'F2- 故障类机器翻新,维修完成后检测清洁和包装 '
	  }, {
	    label: '報廢',
	    value: '報廢'
	  }],
	  4: [{
	    label: '电池 -内部短路-报废',
	    value: '电池 -内部短路-报废'
	  }, {
	    label: '电池 -充电口坏-换充电口-L4',
	    value: '电池 -充电口坏-换充电口-L4'
	  }, {
	    label: '电池 -电池上盖坏-换电池上盖-L4',
	    value: '电池 -电池上盖坏-换电池上盖-L4'
	  }, {
	    label: '电池 -电量显示灯坏-换电量显示灯-L4',
	    value: '电池 -电量显示灯坏-换电量显示灯-L4'
	  }, {
	    label: '后拨链器掉落或卡进轮子里-仅拨链器坏-换拨链器-L3',
	    value: '后拨链器掉落或卡进轮子里-仅拨链器坏-换拨链器-L3'
	  }, {
	    label: '后拨链器掉落或卡进轮子里-车架吊耳坏-换吊耳-L1',
	    value: '后拨链器掉落或卡进轮子里-车架吊耳坏-换吊耳-L1'
	  }, {
	    label: '后拨链器掉落或卡进轮子里-链条坏-换链条-L3',
	    value: '后拨链器掉落或卡进轮子里-链条坏-换链条-L3'
	  }, {
	    label: '后拨链器掉落或卡进轮子里-飞轮卡坏-换飞轮-L2',
	    value: '后拨链器掉落或卡进轮子里-飞轮卡坏-换飞轮-L2'
	  }, {
	    label: '脚踩无助力-助力传感器坏-换助力传感器-L2',
	    value: '脚踩无助力-助力传感器坏-换助力传感器-L2'
	  }, {
	    label: '刹车太松或失灵-机械碟刹-调紧刹车线-L1',
	    value: '刹车太松或失灵-机械碟刹-调紧刹车线-L1'
	  }, {
	    label: '刹车太松或失灵-油压碟刹漏油-加矿物油-L1',
	    value: '刹车太松或失灵-油压碟刹漏油-加矿物油-L1'
	  }, {
	    label: '刹车太松或失灵-油压碟刹进气-排气-L1',
	    value: '刹车太松或失灵-油压碟刹进气-排气-L1'
	  }, {
	    label: '刹车异响-刹车钳磨碟刹盘-调整刹车钳位置-L2',
	    value: '刹车异响-刹车钳磨碟刹盘-调整刹车钳位置-L2'
	  }, {
	    label: '刹车异响-刹车摩擦片问题-换刹车摩擦片-L2',
	    value: '刹车异响-刹车摩擦片问题-换刹车摩擦片-L2'
	  }, {
	    label: '电机不启动-刹把断电了-恢复刹把或换断电线-L3',
	    value: '电机不启动-刹把断电了-恢复刹把或换断电线-L3'
	  }, {
	    label: '电机不启动-电机坏-换电机-L3',
	    value: '电机不启动-电机坏-换电机-L3'
	  }, {
	    label: '电机不启动-控制器坏-换控制器-L3',
	    value: '电机不启动-控制器坏-换控制器-L3'
	  }, {
	    label: '电机不启动-主线束坏-换主线束-L3',
	    value: '电机不启动-主线束坏-换主线束-L3'
	  }, {
	    label: '后轮摇摆-辐条松-校正辐条-UNABLE',
	    value: '后轮摇摆-辐条松-校正辐条-UNABLE'
	  }, {
	    label: '后轮摇摆-轮胎线不均匀-放气调整轮胎线-L1',
	    value: '后轮摇摆-轮胎线不均匀-放气调整轮胎线-L1'
	  }, {
	    label: '前大灯无法关闭-灯和控制器灯模块坏-换灯和控制器-L1',
	    value: '前大灯无法关闭-灯和控制器灯模块坏-换灯和控制器-L1'
	  }, {
	    label: '仪表显示故障/屏幕坏--换仪表-L1',
	    value: '仪表显示故障/屏幕坏--换仪表-L1'
	  }, {
	    label: '前叉漏油--换前叉-L3',
	    value: '前叉漏油--换前叉-L3'
	  }, {
	    label: '曲柄坏--换曲柄-L3',
	    value: '曲柄坏--换曲柄-L3'
	  }, {
	    label: '链盘坏--换链盘-L3',
	    value: '链盘坏--换链盘-L3'
	  }, {
	    label: '内胎/衬带坏--换内胎/衬带-L3',
	    value: '内胎/衬带坏--换内胎/衬带-L3'
	  }]
	};
	
	var getNoteShortcutOptions = function getNoteShortcutOptions(customer) {
	  var shortCuts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : customerNoteShortcuts;
	
	  var value = getOptionValue(customer);
	  return shortCuts[value];
	};
	
	var requestTypeOptions = [{ value: 'relaunch', label: 'Relaunch' }, { value: 'repair', label: 'Repair' }];
	
	var RMAForm = function (_Component) {
	  _inherits(RMAForm, _Component);
	
	  function RMAForm() {
	    _classCallCheck(this, RMAForm);
	
	    var _this = _possibleConstructorReturn(this, (RMAForm.__proto__ || Object.getPrototypeOf(RMAForm)).call(this));
	
	    _this.initialData = function (currentReturnDetail) {
	      var Lines = currentReturnDetail.Lines,
	          Reason = currentReturnDetail.Reason,
	          RequestDetails = currentReturnDetail.RequestDetails;
	
	      var inTableRow = Lines.filter(function (line) {
	        return line.DetailType === 'in';
	      });
	      var outTableRow = Lines.filter(function (line) {
	        return line.DetailType === 'out';
	      });
	      _this.setState({
	        inTable: _extends({}, _this.state.inTable, {
	          rows: inTableRow.map(function (row, idx) {
	            return _extends({}, row, { Index: idx, RefNum: row.SKUNumber });
	          })
	        }),
	        outTable: _extends({}, _this.state.outTable, {
	          rows: outTableRow.map(function (row, idx) {
	            return _extends({}, row, { Index: idx });
	          })
	        }),
	        Submit_Description1: Reason,
	        Submit_Description2: RequestDetails
	      });
	    };
	
	    _this.replaceTableTotalAmountCalculate = function () {
	      var rows = [].concat(_toConsumableArray(_this.state.outTable.rows));
	      var amount = 0;
	      _lodash2.default.forEach(rows, function (row) {
	        amount += parseFloat(row.UnitPrice) * row.Quantity;
	      });
	      return amount;
	    };
	
	    _this.breadcrumb = function () {
	      return _react2.default.createElement(
	        _reactBootstrap.Breadcrumb,
	        { style: _this.state.crumbStyle },
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb.Item,
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rma' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb.Item,
	          { active: 'true' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Return_Form' })
	        )
	      );
	    };
	
	    _this.breadCrumbButton = function () {
	      return _react2.default.createElement(
	        _reactBootstrap.ButtonToolbar,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'submit',
	            action: 'submit'
	          },
	          _react2.default.createElement('em', { className: 'fa fa-save' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'danger',
	            type: 'reset',
	            href: _this.state.onCustomerEditPage ? '/customerRMA' : '/dispatchRMA'
	          },
	          _react2.default.createElement('em', { className: 'fa fa-close' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	        )
	      );
	    };
	
	    _this.handleTextareaChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.generateRMALines = function () {
	      var lines = [].concat(_toConsumableArray(_this.state.inTable.rows), _toConsumableArray(_this.state.outTable.rows));
	      var newLines = _lodash2.default.map(lines, function (line) {
	        return {
	          UnitPrice: line.UnitPrice,
	          Quantity: line.Quantity,
	          DetailType: line.DetailType,
	          Product: line.Product_id,
	          TotalPrice: line.UnitPrice * line.Quantity,
	          ProductNum: line.ProductNum,
	          Name: line.Name,
	          Id: line.Id || null,
	          RMA: line.RMA || null,
	          SKUNumber: line.RefNum
	        };
	      });
	      return newLines;
	    };
	
	    _this.generateSKUs = function () {
	      var skus = [];
	      var lines = [].concat(_toConsumableArray(_this.state.inTable.rows));
	      _lodash2.default.forEach(lines, function (line) {
	        line.RefNum && skus.push(line.RefNum);
	      });
	      return skus.join(',');
	    };
	
	    _this.handleFormSubmit = function (formValues) {
	      var Customer = formValues.Customer,
	          ProcessStatus = formValues.ProcessStatus,
	          ReturnTracking = formValues.ReturnTracking,
	          Resolution = formValues.Resolution,
	          SNNum = formValues.SNNum,
	          RequestType = formValues.RequestType,
	          RequestDetails = formValues.RequestDetails;
	      var _this$state = _this.state,
	          Submit_Description1 = _this$state.Submit_Description1,
	          Submit_Description2 = _this$state.Submit_Description2;
	      var customerOptions = _this.props.customerOptions;
	
	      var payload = {
	        Customer: getOptionValue(Customer),
	        CustomerName: getOptionLabel(Customer, customerOptions),
	        RequestType: getOptionValue(RequestType),
	        SNNum: SNNum,
	        ReturnTracking: ReturnTracking,
	        SKU: _this.generateSKUs(),
	        Resolution: Resolution,
	        Reason: Submit_Description1,
	        RequestDetails: Submit_Description2,
	        ProcessStatus: getOptionValue(ProcessStatus),
	        rma_line: _this.generateRMALines(),
	        TotalPrice: _this.state.amount
	      };
	      var success = function success() {
	        alert('success redirecting to RMA list page');
	        _this.props.router.push('/customerRMA');
	      };
	      var failed = function failed(err) {
	        alert(JSON.stringify(err));
	      };
	
	      if (_this.props.routeParams.id) {
	        _this.props.editRMAOrder(payload, _this.props.routeParams.id, success, failed);
	      } else {
	        _this.props.createRMAOrder(payload, success, failed);
	      }
	    };
	
	    _this.handleSearchTypeChange1 = function (_ref) {
	      var target = _ref.target;
	
	      _this.setState({
	        searchType1: target.value
	      });
	    };
	
	    _this.handleSearchTypeChange2 = function (_ref2) {
	      var target = _ref2.target;
	
	      _this.setState({
	        searchType2: target.value
	      });
	    };
	
	    _this.renderTypeRadio1 = function () {
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 2 },
	          _react2.default.createElement(
	            'span',
	            { style: { fontSize: '15px', fontWeight: 'bold' } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'search_by' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 2 },
	          _react2.default.createElement('input', {
	            name: 'searchType1',
	            type: 'radio',
	            value: 'ProductNum',
	            checked: _this.state.searchType1 === "ProductNum",
	            onChange: _this.handleSearchTypeChange1
	          }),
	          _react2.default.createElement(
	            'span',
	            { style: { fontSize: '13px', fontWeight: 'bold' } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 2 },
	          _react2.default.createElement('input', {
	            name: 'searchType1',
	            type: 'radio',
	            value: 'RefNum',
	            checked: _this.state.searchType1 === "RefNum",
	            onChange: _this.handleSearchTypeChange1
	          }),
	          _react2.default.createElement(
	            'span',
	            { style: { fontSize: '13px', fontWeight: 'bold' } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku_num' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 2 },
	          _react2.default.createElement('input', {
	            name: 'searchType1',
	            type: 'radio',
	            value: 'Name',
	            checked: _this.state.searchType1 === "Name",
	            onChange: _this.handleSearchTypeChange1
	          }),
	          _react2.default.createElement(
	            'span',
	            { style: { fontSize: '13px', fontWeight: 'bold' } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 2 },
	          _react2.default.createElement('input', {
	            name: 'searchType1',
	            type: 'radio',
	            value: 'Barcode',
	            checked: _this.state.searchType1 === "Barcode",
	            onChange: _this.handleSearchTypeChange1
	          }),
	          _react2.default.createElement(
	            'span',
	            { style: { fontSize: '13px', fontWeight: 'bold' } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'barcode' })
	          )
	        )
	      );
	    };
	
	    _this.renderTypeRadio2 = function () {
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 2 },
	          _react2.default.createElement(
	            'span',
	            { style: { fontSize: '13px', fontWeight: 'bold' } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'search_by' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 2 },
	          _react2.default.createElement('input', {
	            name: 'searchType2',
	            type: 'radio',
	            value: 'ProductNum',
	            checked: _this.state.searchType2 === "ProductNum",
	            onChange: _this.handleSearchTypeChange2
	          }),
	          _react2.default.createElement(
	            'span',
	            { style: { fontSize: '13px', fontWeight: 'bold' } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 2 },
	          _react2.default.createElement('input', {
	            name: 'searchType2',
	            type: 'radio',
	            value: 'RefNum',
	            checked: _this.state.searchType2 === "RefNum",
	            onChange: _this.handleSearchTypeChange2
	          }),
	          _react2.default.createElement(
	            'span',
	            { style: { fontSize: '13px', fontWeight: 'bold' } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku_num' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 2 },
	          _react2.default.createElement('input', {
	            name: 'searchType2',
	            type: 'radio',
	            value: 'Name',
	            checked: _this.state.searchType2 === "Name",
	            onChange: _this.handleSearchTypeChange2
	          }),
	          _react2.default.createElement(
	            'span',
	            { style: { fontSize: '13px', fontWeight: 'bold' } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 2 },
	          _react2.default.createElement('input', {
	            name: 'searchType2',
	            type: 'radio',
	            value: 'Barcode',
	            checked: _this.state.searchType2 === "Barcode",
	            onChange: _this.handleSearchTypeChange2
	          }),
	          _react2.default.createElement(
	            'span',
	            { style: { fontSize: '13px', fontWeight: 'bold' } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'barcode' })
	          )
	        )
	      );
	    };
	
	    _this.renderInTable = function () {
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this.state.inTable);
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	      var that = _this;
	      var handleRowDelete = function handleRowDelete(index) {
	        var rows = [].concat(_toConsumableArray(_this.state.inTable.rows));
	        rows.splice(index, 1);
	        _this.setState({
	          inTable: _extends({}, _this.state.inTable, {
	            rows: rows
	          })
	        });
	      };
	      var deleteButton = _react2.default.createClass({
	        displayName: 'deleteButton',
	        render: function render() {
	          var _this2 = this;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                className: 'textAlignStyle',
	                style: { height: '23px', width: '39px', padding: '0px' },
	                onClick: function onClick(props) {
	                  var Index = _this2.props.dependentValues.Index;
	                  handleRowDelete(Index);
	                }
	              },
	              'X'
	            )
	          );
	        }
	      });
	
	      var productCol = [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: deleteButton,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }, {
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true,
	        editable: true
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price' }),
	        resizable: true,
	        sortable: true,
	        width: 50,
	        filterable: true,
	        editable: true
	      }];
	
	      var handleRowUpdated = function handleRowUpdated(_ref3) {
	        var rowIdx = _ref3.rowIdx,
	            updated = _ref3.updated;
	
	        var inTable = _extends({}, _this.state.inTable);
	        inTable.rows[rowIdx] = _extends({}, inTable.rows[rowIdx], updated);
	        _this.setState({
	          inTable: inTable
	        });
	      };
	
	      return _react2.default.createElement(_reactDataGrid2.default
	      // rowKey="Product_id"
	      // onGridSort={handleGridSort}
	      , {
	        rowKey: 'ProductNum'
	        // onGridSort={handleGridSort}
	        , columns: productCol,
	        rowHeight: 25,
	        headerRowHeight: 45,
	        rowGetter: rowGetter,
	        rowsCount: getSize(),
	        enableCellSelect: true
	        // enableRowSelect="multi"
	        // toolbar={<Toolbar enableFilter />}
	        // onAddFilter={handleFilterChange}
	        // onClearFilters={onClearFilters}
	        , minHeight: 220,
	        onRowUpdated: handleRowUpdated
	        // onRowClick={onRowClick}
	        // rowSelection={{
	        //   showCheckbox: true,
	        //   onRowsSelected,
	        //   onRowsDeselected,
	        //   selectBy: {
	        //     isSelectedKey: 'isSelected',
	        //   },
	        // }}
	      });
	    };
	
	    _this.renderOutTable = function () {
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this.state.outTable);
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleRowUpdated = function handleRowUpdated(_ref4) {
	        var rowIdx = _ref4.rowIdx,
	            updated = _ref4.updated;
	
	        var outTable = _extends({}, _this.state.outTable);
	        outTable.rows[rowIdx] = _extends({}, outTable.rows[rowIdx], updated);
	        _this.setState({
	          outTable: outTable
	        });
	      };
	
	      var that = _this;
	      var handleRowDelete = function handleRowDelete(index) {
	        var rows = [].concat(_toConsumableArray(_this.state.outTable.rows));
	        rows.splice(index, 1);
	        _this.setState({
	          outTable: _extends({}, _this.state.inTable, {
	            rows: rows
	          })
	        });
	      };
	      var deleteButton = _react2.default.createClass({
	        displayName: 'deleteButton',
	        render: function render() {
	          var _this3 = this;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                className: 'textAlignStyle',
	                style: { height: '23px', width: '39px', padding: '0px' },
	                onClick: function onClick(props) {
	                  var Index = _this3.props.dependentValues.Index;
	                  handleRowDelete(Index);
	                }
	              },
	              'X'
	            )
	          );
	        }
	      });
	
	      var productCol = [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: deleteButton,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }, {
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true,
	        editable: true
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price' }),
	        resizable: true,
	        sortable: true,
	        width: 50,
	        filterable: true,
	        editable: true
	      }];
	
	      return _react2.default.createElement(_reactDataGrid2.default, { columns: productCol,
	        rowHeight: 25,
	        headerRowHeight: 45,
	        rowGetter: rowGetter,
	        rowsCount: getSize(),
	        enableCellSelect: true
	        // enableRowSelect="multi"
	        // toolbar={<Toolbar enableFilter />}
	        // onAddFilter={handleFilterChange}
	        // onClearFilters={onClearFilters}
	        , minHeight: 220,
	        onRowUpdated: handleRowUpdated
	        // onRowClick={onRowClick}
	        // rowSelection={{
	        //   showCheckbox: true,
	        //   onRowsSelected,
	        //   onRowsDeselected,
	        //   selectBy: {
	        //     isSelectedKey: 'isSelected',
	        //   },
	        // }}
	      });
	    };
	
	    _this.handleProductSelect1 = function (product) {
	      if (!product) return;
	      _this.setState({
	        inTable: _extends({}, _this.state.inTable, {
	          rows: [].concat(_toConsumableArray(_this.state.inTable.rows), [_extends({}, product, {
	            Quantity: '1',
	            DetailType: 'in',
	            UnitPrice: product.Price
	          })]).map(function (line, idx) {
	            return _extends({}, line, {
	              Index: idx
	            });
	          })
	        })
	      });
	    };
	
	    _this.handleProductSelect2 = function (product) {
	      if (!product) return;
	      _this.setState({
	        outTable: _extends({}, _this.state.outTable, {
	          rows: [].concat(_toConsumableArray(_this.state.outTable.rows), [_extends({}, product, {
	            Quantity: '1',
	            DetailType: 'out',
	            UnitPrice: product.Price
	          })]).map(function (line, idx) {
	            return _extends({}, line, {
	              Index: idx
	            });
	          })
	        })
	      });
	    };
	
	    _this.renderForm = function () {
	      var returnDetail = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_details' })
	      );
	      var _this$props = _this.props,
	          customerOptions = _this$props.customerOptions,
	          Customer = _this$props.Customer;
	      var searchType = _this.state.searchType;
	
	      var customerId = Customer && (Customer.value || Customer);
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 12 },
	        _react2.default.createElement(
	          _reactBootstrap.Panel,
	          { header: returnDetail, style: { height: '800px' } },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'form-horizontal' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-sm-4' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Customer_Name' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'asteriksReq' },
	                      '*'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-7' },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'Customer', component: _selection.Selection, options: customerOptions })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'form-horizontal' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-sm-4' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'request_type' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'asteriksReq' },
	                      '*'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-7' },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'RequestType', component: _selection.Selection, options: requestTypeOptions })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'form-horizontal' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-sm-4' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-7' },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'ProcessStatus', component: _selection.Selection, options: processStatus })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'form-horizontal' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-sm-4' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_tracking' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-7' },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'ReturnTracking', component: _inputField.InputField })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'form-horizontal' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-sm-4' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sn_num' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-7' },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'SNNum', component: _inputField.InputField })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'form-horizontal' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-sm-4' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'resolution' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-7' },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'Resolution', component: _inputField.InputField })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'form-horizontal' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-sm-4' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_amount' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-7' },
	                    _this.state.amount,
	                    _react2.default.createElement(
	                      'span',
	                      { style: { paddingLeft: '5px' } },
	                      '$'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'form-horizontal' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-sm-4' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notes_shortcut' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-7' },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'notesShortcut', component: _selection.Selection, options: getNoteShortcutOptions(Customer) })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-sm-2', htmlFor: 'textarea1' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notes' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-9' },
	                    _react2.default.createElement('textarea', { onChange: _this.handleTextareaChange, value: _this.state.Submit_Description1, name: 'Submit_Description1', className: 'form-control', id: 'textarea1', style: { width: '100%', height: '200px' } })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-sm-2', htmlFor: 'textarea2' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'request_details' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-9' },
	                    _react2.default.createElement('textarea', { disabled: true, onChange: _this.handleTextareaChange, value: _this.state.Submit_Description2, name: 'Submit_Description2', className: 'form-control', id: 'textarea2', style: { width: '100%', height: '100px' } })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { style: { marginBottom: '20px' } },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 11 },
	                  _react2.default.createElement(
	                    'div',
	                    { style: { color: 'brown', fontWeight: 'bold', fontSize: '22px', display: 'inline-blick', height: '30px' } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'products_repaired' })
	                  ),
	                  _this.renderTypeRadio1(),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { style: { height: '40px' } },
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      null,
	                      _react2.default.createElement(_RMAAutoSuggest2.default, {
	                        customerId: customerId,
	                        searchType: _this.state.searchType1,
	                        handleProductSelect: _this.handleProductSelect1
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      null,
	                      _this.renderInTable()
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 11 },
	                  _react2.default.createElement(
	                    'div',
	                    { style: { color: 'brown', fontWeight: 'bold', fontSize: '22px', display: 'inline-blick', height: '30px' } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'products_cost' })
	                  ),
	                  _this.renderTypeRadio2(),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { style: { height: '40px' } },
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      null,
	                      _react2.default.createElement(_RMAAutoSuggest2.default, {
	                        customerId: customerId,
	                        searchType: _this.state.searchType2,
	                        handleProductSelect: _this.handleProductSelect2
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      null,
	                      _this.renderOutTable()
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      Submit_Description1: '',
	      Submit_Description2: '',
	      onCustomerEditPage: undefined,
	      searchType1: 'Name',
	      searchType2: 'Name',
	      inTable: {
	        rows: []
	      },
	      outTable: {
	        rows: []
	      },
	      amount: '0'
	    };
	
	    return _this;
	  }
	
	  _createClass(RMAForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.route.path === 'customerRMA/:id' || this.props.route.path === 'customerRMA/new') {
	        if (isFBD) {
	          this.props.fetchCustomers(true);
	        } else {
	          this.props.fetchCustomers();
	        }
	        this.setState({
	          onCustomerEditPage: true
	        });
	      } else {
	        this.setState({
	          onCustomerEditPage: false
	        });
	      }
	      this.props.routeParams.id && this.props.fetchCustomerReturn(this.props.routeParams.id); //If the route contains id search return by id
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.currentReturnDetail !== this.props.currentReturnDetail) {
	        this.initialData(nextProps.currentReturnDetail);
	      }
	      // if (nextProps.Submit_Description1 !== this.props.Submit_Description1) {
	      //   this.setState({
	      //     Submit_Description1: nextProps.Submit_Description1,
	      //   })
	      // }
	      // if (nextProps.Submit_Description2 !== this.props.Submit_Description2) {
	      //   this.setState({
	      //     Submit_Description2: nextProps.Submit_Description2,
	      //   })
	      // }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevProps.notesShortcut !== this.props.notesShortcut && this.props.notesShortcut) {
	        var notes = this.props.notesShortcut.value + '\n';
	        this.setState({
	          Submit_Description1: '' + this.state.Submit_Description1 + notes
	        });
	      }
	      if (this.state.amount !== this.replaceTableTotalAmountCalculate()) {
	        this.setState({
	          amount: this.replaceTableTotalAmountCalculate()
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var returnDetail = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_details' })
	      );
	      var repairDetail = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'repair_detail' })
	      );
	      var shippingDetail = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_detail' })
	      );
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          submitting = _props.submitting,
	          pristine = _props.pristine,
	          Fix_Status = _props.Fix_Status;
	
	      var FixStatusIsUnreceived = Fix_Status === "UNRECEIVED" || !Fix_Status;
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'form',
	          { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	          this.breadcrumb(),
	          ' ',
	          this.breadCrumbButton(),
	          ' ',
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'vendor-form' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              this.renderForm()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RMAForm;
	}(_react.Component);
	
	RMAForm.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = RMAForm;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isFBD, 'isFBD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rmaForm.jsx');
	
	  __REACT_HOT_LOADER__.register(getOptionValue, 'getOptionValue', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rmaForm.jsx');
	
	  __REACT_HOT_LOADER__.register(getOptionLabel, 'getOptionLabel', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rmaForm.jsx');
	
	  __REACT_HOT_LOADER__.register(fixingStatus, 'fixingStatus', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rmaForm.jsx');
	
	  __REACT_HOT_LOADER__.register(processStatus, 'processStatus', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rmaForm.jsx');
	
	  __REACT_HOT_LOADER__.register(solutionOptions, 'solutionOptions', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rmaForm.jsx');
	
	  __REACT_HOT_LOADER__.register(customerNoteShortcuts, 'customerNoteShortcuts', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rmaForm.jsx');
	
	  __REACT_HOT_LOADER__.register(getNoteShortcutOptions, 'getNoteShortcutOptions', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rmaForm.jsx');
	
	  __REACT_HOT_LOADER__.register(requestTypeOptions, 'requestTypeOptions', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rmaForm.jsx');
	
	  __REACT_HOT_LOADER__.register(RMAForm, 'RMAForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rmaForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/RMA/rmaForm.jsx');
	}();

	;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.POSPicture = exports.SalesPerformance = exports.PurchasePerformance = exports.PurchaseReference = exports.PurchasePivot = exports.ProductConvert = exports.PriceAdjustment = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PriceAdjustment = function (_Component) {
	  _inherits(PriceAdjustment, _Component);
	
	  function PriceAdjustment() {
	    _classCallCheck(this, PriceAdjustment);
	
	    var _this = _possibleConstructorReturn(this, (PriceAdjustment.__proto__ || Object.getPrototypeOf(PriceAdjustment)).call(this));
	
	    _this.state = {
	      URL: ['/img/report/Price_Adjustment_Page_1.png', '/img/report/Price_Adjustment_Page_2.png', '/img/report/Price_Adjustment_Page_3.png'],
	      index: 0
	    };
	    return _this;
	  }
	
	  _createClass(PriceAdjustment, [{
	    key: 'prev',
	    value: function prev() {
	      var index = this.state.index;
	      index = index > 0 ? index - 1 : index;
	      this.setState({ index: index });
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      var index = this.state.index;
	      index = index < this.state.URL.length - 1 ? index + 1 : index;
	      this.setState({ index: index });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { onClick: function onClick() {
	                _this2.prev();
	              } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'previous' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { onClick: function onClick() {
	                _this2.next();
	              } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'next' })
	          )
	        ),
	        _react2.default.createElement('img', { src: this.state.URL[this.state.index], thumbnail: true })
	      );
	    }
	  }]);
	
	  return PriceAdjustment;
	}(_react.Component);
	
	var ProductConvert = function (_Component2) {
	  _inherits(ProductConvert, _Component2);
	
	  function ProductConvert() {
	    _classCallCheck(this, ProductConvert);
	
	    var _this3 = _possibleConstructorReturn(this, (ProductConvert.__proto__ || Object.getPrototypeOf(ProductConvert)).call(this));
	
	    _this3.state = {
	      URL: ['/img/report/Product_Convert_Page_1.png', '/img/report/Product_Convert_Page_2.png', '/img/report/Product_Convert_Page_3.png'],
	      index: 0
	    };
	    return _this3;
	  }
	
	  _createClass(ProductConvert, [{
	    key: 'prev',
	    value: function prev() {
	      var index = this.state.index;
	      index = index > 0 ? index - 1 : index;
	      this.setState({ index: index });
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      var index = this.state.index;
	      index = index < this.state.URL.length - 1 ? index + 1 : index;
	      this.setState({ index: index });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { onClick: function onClick() {
	                _this4.prev();
	              } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'previous' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { onClick: function onClick() {
	                _this4.next();
	              } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'next' })
	          )
	        ),
	        _react2.default.createElement('img', { src: this.state.URL[this.state.index] })
	      );
	    }
	  }]);
	
	  return ProductConvert;
	}(_react.Component);
	
	var PurchasePivot = function (_Component3) {
	  _inherits(PurchasePivot, _Component3);
	
	  function PurchasePivot() {
	    _classCallCheck(this, PurchasePivot);
	
	    var _this5 = _possibleConstructorReturn(this, (PurchasePivot.__proto__ || Object.getPrototypeOf(PurchasePivot)).call(this));
	
	    _this5.state = {
	      URL: ['/img/report/Purchase_Pivot_Chart_1.png', '/img/report/Purchase_Pivot_Chart_2.png'],
	      index: 0
	    };
	    return _this5;
	  }
	
	  _createClass(PurchasePivot, [{
	    key: 'prev',
	    value: function prev() {
	      var index = this.state.index;
	      index = index > 0 ? index - 1 : index;
	      this.setState({ index: index });
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      var index = this.state.index;
	      index = index < this.state.URL.length - 1 ? index + 1 : index;
	      this.setState({ index: index });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { onClick: function onClick() {
	                _this6.prev();
	              } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'previous' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { onClick: function onClick() {
	                _this6.next();
	              } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'next' })
	          )
	        ),
	        _react2.default.createElement('img', { src: this.state.URL[this.state.index], thumbnail: true })
	      );
	    }
	  }]);
	
	  return PurchasePivot;
	}(_react.Component);
	
	var PurchaseReference = function (_Component4) {
	  _inherits(PurchaseReference, _Component4);
	
	  function PurchaseReference() {
	    _classCallCheck(this, PurchaseReference);
	
	    var _this7 = _possibleConstructorReturn(this, (PurchaseReference.__proto__ || Object.getPrototypeOf(PurchaseReference)).call(this));
	
	    _this7.state = {
	      URL: ['/img/report/Purchase_Reference_Guide_1.png', '/img/report/Purchase_Reference_Guide_2.png'],
	      index: 0
	    };
	    return _this7;
	  }
	
	  _createClass(PurchaseReference, [{
	    key: 'prev',
	    value: function prev() {
	      var index = this.state.index;
	      index = index > 0 ? index - 1 : index;
	      this.setState({ index: index });
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      var index = this.state.index;
	      index = index < this.state.URL.length - 1 ? index + 1 : index;
	      this.setState({ index: index });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { onClick: function onClick() {
	                _this8.prev();
	              } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'previous' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { onClick: function onClick() {
	                _this8.next();
	              } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'next' })
	          )
	        ),
	        _react2.default.createElement('img', { src: this.state.URL[this.state.index], thumbnail: true })
	      );
	    }
	  }]);
	
	  return PurchaseReference;
	}(_react.Component);
	
	var PurchasePerformance = function (_Component5) {
	  _inherits(PurchasePerformance, _Component5);
	
	  function PurchasePerformance() {
	    _classCallCheck(this, PurchasePerformance);
	
	    var _this9 = _possibleConstructorReturn(this, (PurchasePerformance.__proto__ || Object.getPrototypeOf(PurchasePerformance)).call(this));
	
	    _this9.state = {
	      URL: ['/img/report/Purchasing _Performance_1.png', '/img/report/Purchasing _Performance_2.png'],
	      index: 0
	    };
	    return _this9;
	  }
	
	  _createClass(PurchasePerformance, [{
	    key: 'prev',
	    value: function prev() {
	      var index = this.state.index;
	      index = index > 0 ? index - 1 : index;
	      this.setState({ index: index });
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      var index = this.state.index;
	      index = index < this.state.URL.length - 1 ? index + 1 : index;
	      this.setState({ index: index });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this10 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { onClick: function onClick() {
	                _this10.prev();
	              } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'previous' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { onClick: function onClick() {
	                _this10.next();
	              } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'next' })
	          )
	        ),
	        _react2.default.createElement('img', { src: this.state.URL[this.state.index], thumbnail: true })
	      );
	    }
	  }]);
	
	  return PurchasePerformance;
	}(_react.Component);
	
	var SalesPerformance = function (_Component6) {
	  _inherits(SalesPerformance, _Component6);
	
	  function SalesPerformance() {
	    _classCallCheck(this, SalesPerformance);
	
	    var _this11 = _possibleConstructorReturn(this, (SalesPerformance.__proto__ || Object.getPrototypeOf(SalesPerformance)).call(this));
	
	    _this11.state = {
	      URL: ['/img/report/Sales_Performance.png'],
	      index: 0
	    };
	    return _this11;
	  }
	
	  _createClass(SalesPerformance, [{
	    key: 'prev',
	    value: function prev() {
	      var index = this.state.index;
	      index = index > 0 ? index - 1 : index;
	      this.setState({ index: index });
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      var index = this.state.index;
	      index = index < this.state.URL.length - 1 ? index + 1 : index;
	      this.setState({ index: index });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this12 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { onClick: function onClick() {
	                _this12.prev();
	              } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'previous' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { onClick: function onClick() {
	                _this12.next();
	              } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'next' })
	          )
	        ),
	        _react2.default.createElement('img', { src: this.state.URL[this.state.index], thumbnail: true })
	      );
	    }
	  }]);
	
	  return SalesPerformance;
	}(_react.Component);
	
	var POSPicture = function (_Component7) {
	  _inherits(POSPicture, _Component7);
	
	  function POSPicture() {
	    _classCallCheck(this, POSPicture);
	
	    var _this13 = _possibleConstructorReturn(this, (POSPicture.__proto__ || Object.getPrototypeOf(POSPicture)).call(this));
	
	    _this13.state = {
	      URL: ['/img/report/POSv2.png'],
	      index: 0
	    };
	    return _this13;
	  }
	
	  _createClass(POSPicture, [{
	    key: 'prev',
	    value: function prev() {
	      var index = this.state.index;
	      index = index > 0 ? index - 1 : index;
	      this.setState({ index: index });
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      var index = this.state.index;
	      index = index < this.state.URL.length - 1 ? index + 1 : index;
	      this.setState({ index: index });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this14 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { onClick: function onClick() {
	                _this14.prev();
	              } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'previous' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { onClick: function onClick() {
	                _this14.next();
	              } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'next' })
	          )
	        ),
	        _react2.default.createElement('img', { src: this.state.URL[this.state.index], height: '665', width: '1020', thumbnail: true })
	      );
	    }
	  }]);
	
	  return POSPicture;
	}(_react.Component);
	
	exports.PriceAdjustment = PriceAdjustment;
	exports.ProductConvert = ProductConvert;
	exports.PurchasePivot = PurchasePivot;
	exports.PurchaseReference = PurchaseReference;
	exports.PurchasePerformance = PurchasePerformance;
	exports.SalesPerformance = SalesPerformance;
	exports.POSPicture = POSPicture;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PriceAdjustment, 'PriceAdjustment', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Report/report.jsx');
	
	  __REACT_HOT_LOADER__.register(ProductConvert, 'ProductConvert', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Report/report.jsx');
	
	  __REACT_HOT_LOADER__.register(PurchasePivot, 'PurchasePivot', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Report/report.jsx');
	
	  __REACT_HOT_LOADER__.register(PurchaseReference, 'PurchaseReference', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Report/report.jsx');
	
	  __REACT_HOT_LOADER__.register(PurchasePerformance, 'PurchasePerformance', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Report/report.jsx');
	
	  __REACT_HOT_LOADER__.register(SalesPerformance, 'SalesPerformance', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Report/report.jsx');
	
	  __REACT_HOT_LOADER__.register(POSPicture, 'POSPicture', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Report/report.jsx');
	}();

	;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reduxForm = __webpack_require__(3);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _inputField = __webpack_require__(16);
	
	var _datePicker = __webpack_require__(27);
	
	var _customerItems = __webpack_require__(647);
	
	var _customerItems2 = _interopRequireDefault(_customerItems);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DropDownEditor = _reactDataGridAddons.Editors.DropDownEditor;
	
	var CreditForm = function (_Component) {
	  _inherits(CreditForm, _Component);
	
	  function CreditForm() {
	    _classCallCheck(this, CreditForm);
	
	    var _this = _possibleConstructorReturn(this, (CreditForm.__proto__ || Object.getPrototypeOf(CreditForm)).call(this));
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	      invoice: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      totalPrice: 0,
	      chooseItemOpen: false
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    return _this;
	  }
	
	  _createClass(CreditForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      console.log("did", this.props.currentCustomer);
	      window.addEventListener('resize', this.handleResize);
	      var currentSalesInvoice = this.props.currentSalesInvoice;
	
	      if (!currentSalesInvoice) {
	        this.props.fetchCustomerItem(this.props.currentCustomer.value);
	      } else if ((typeof currentSalesInvoice === 'undefined' ? 'undefined' : _typeof(currentSalesInvoice)) == "object" && currentSalesInvoice.SalesReturn_id != null) {
	        this.props.fetchSalesReturnDetail(currentSalesInvoice.SalesReturn_id);
	      } else if ((typeof currentSalesInvoice === 'undefined' ? 'undefined' : _typeof(currentSalesInvoice)) == "object") this.props.fetchSalesInvoiceCompletedDetail(currentSalesInvoice.SalesInvoiceCompleted_id);else this.props.fetchSalesInvoiceCompletedDetail(currentSalesInvoice, "InvoiceNum");
	      // this.props.fetchSalesInvoice("1900-01-01", "3000-01-01", null, 7);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.customerItem && nextProps.customerItem != this.props.customerItem) {
	        console.log("n", nextProps.customerItem);
	      }
	      if (nextProps.salesInvoiceDetail && nextProps.salesInvoiceDetail != this.props.salesInvoiceDetail) {
	        var newRows = nextProps.salesInvoiceDetail.Sales_Invoice_Line_Complete;
	        var invoice = _extends({}, this.state.invoice, { rows: newRows });
	        this.setState({ invoice: invoice });
	      }
	      if (nextProps.salesReturnDetail && nextProps.salesReturnDetail != this.props.salesReturnDetail) {
	        console.log("salesReturnDetail", nextProps.salesReturnDetail);
	        var _invoice = _extends({}, this.state.invoice, { rows: nextProps.salesReturnDetail.Sales_Return_Line });
	        this.setState({ invoice: _invoice, totalPrice: nextProps.salesReturnDetail && nextProps.salesReturnDetail.TotalPrice });
	      }
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      var formattedDate = date.getFullYear() + '-';
	
	      formattedDate += date.getMonth() + 1 + '-';
	      if (date.getDate() < 10) {
	        formattedDate += '0' + date.getDate();
	      } else {
	        formattedDate += date.getDate();
	      }
	      return formattedDate;
	    }
	  }, {
	    key: 'renderInvoice',
	    value: function renderInvoice() {
	      var _this2 = this;
	
	      if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.error)
	        )
	      );else {
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.invoice);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var invoice = _extends({}, _this2.state.invoice, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this2.setState({ invoice: invoice });
	        };
	
	        // const onRowSelect = rows => {
	        //     var POs = {...this.state.previousOrders, selectedRows: rows};
	        //     this.setState({previousOrders});
	        // }
	
	        var handleRowUpdated = function handleRowUpdated(e) {
	          var rows = getRows();
	          var returnTotalPrice = parseFloat(rows[e.rowIdx].ReturnTotalPrice) || 0;
	          Object.assign(rows[e.rowIdx], e.updated);
	          if (e.cellKey == "ReturnTotalPrice") {
	            var percentOff = rows[e.rowIdx].UnitPrice ? 100 + (parseFloat(e.updated.ReturnTotalPrice) || 0) / (parseFloat(rows[e.rowIdx].UnitPrice) || 0) / (parseFloat(rows[e.rowIdx].ReturnQuantity) || 0) * 100 : 0;
	            Object.assign(rows[e.rowIdx], { PercentOff: percentOff });
	            var totalPrice = (parseFloat(_this2.state.totalPrice) || 0) + (parseFloat(e.updated.ReturnTotalPrice) || 0) - returnTotalPrice;
	            totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	            _this2.setState({ totalPrice: totalPrice });
	          }
	          if (e.cellKey == "ReturnQuantity") {
	            var newReturnTotalPrice = -(parseFloat(e.updated.ReturnQuantity) || 0) * (parseFloat(rows[e.rowIdx].UnitPrice) || 0);
	            Object.assign(rows[e.rowIdx], { PercentOff: 0, ReturnTotalPrice: newReturnTotalPrice });
	            var _totalPrice = (parseFloat(_this2.state.totalPrice) || 0) + (parseFloat(rows[e.rowIdx].ReturnTotalPrice) || 0) - returnTotalPrice;
	            _totalPrice = parseFloat(Math.round(_totalPrice * 100) / 100).toFixed(2);
	            _this2.setState({ totalPrice: _totalPrice });
	          }
	        };
	
	        var onRowsSelected = function onRowsSelected(rows) {
	          var newRows = _this2.state.invoice.rows;
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = true;
	          });
	          //  this.setState({rows: newRows});
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          var newRows = _this2.state.invoice.rows;
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = false;
	          });
	          //  this.setState({rows: newRows});
	        };
	
	        var creditReasonOptions = ['Product Damaged', 'Item Defective', 'Missing Parts', 'Shortage', 'Missing', 'Others', 'Out', 'Short'];
	
	        // Column difinition
	
	        var columns = [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	          resizable: true,
	          sortable: true,
	          width: 160,
	          filterable: true
	        }, {
	          key: 'ProductName',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	          resizable: true,
	          sortable: true,
	          width: 160,
	          filterable: true
	        }, {
	          key: 'ProductDescription',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true,
	          width: 160,
	          filterable: true
	        }, {
	          key: 'Quantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'UnitPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'ReturnQuantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_quantity' }),
	          resizable: true,
	          sortable: true,
	          editable: true,
	          width: 150,
	          filterable: true
	        }, {
	          key: 'PercentOff',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'percentsign_off' }),
	          resizable: true,
	          sortable: true,
	          width: 150,
	          filterable: true
	        }, {
	          key: 'ReturnTotalPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_price' }),
	          editable: true,
	          resizable: true,
	          sortable: true,
	          width: 150,
	          filterable: true
	        }, {
	          key: 'ReturnReason',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit_reason' }),
	          resizable: true,
	          sortable: true,
	          editable: true,
	          editor: _react2.default.createElement(DropDownEditor, { options: creditReasonOptions }),
	          width: 150,
	          filterable: true
	        }];
	
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { style: { maxWidth: '99%' }, id: 'CreditForm-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'Product_id',
	                onGridSort: handleGridSort,
	                columns: columns,
	                rowHeight: 25,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                enableCellSelect: true,
	                onRowUpdated: handleRowUpdated,
	                minHeight: this.state.tableHeight,
	                enableRowSelect: 'multi',
	                rowSelection: {
	                  showCheckbox: true,
	                  enableShiftSelect: true,
	                  onRowsSelected: onRowsSelected,
	                  onRowsDeselected: onRowsDeselected,
	                  selectBy: {
	                    isSelectedKey: 'isSelected'
	                  }
	                }
	              })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      if (this.props.salesReturnDetail) {
	        if (!this.checkPermission("change_sales_return")) this.props.editSalesReturn(formProps, this.props.salesReturnDetail, this.state.totalPrice, this.state.invoice.rows);else alert("You have no permission!");
	      } else {
	        var salesInvoiceDetail = {};
	        this.props.createSalesReturn(formProps, this.props.salesInvoiceDetail || salesInvoiceDetail, this.state.totalPrice, this.state.invoice.rows, this.props.currentCustomer, "Credit");
	      }
	    }
	  }, {
	    key: 'addNonProduct',
	    value: function addNonProduct() {
	      var invoice = _extends({}, this.state.invoice);
	      var r = { ProductNum: "N/A", ProductName: "Non-Product" };
	      invoice.rows.push(r);
	      this.setState({ invoice: invoice });
	    }
	  }, {
	    key: 'closeChooseItem',
	    value: function closeChooseItem() {
	      this.setState({ chooseItemOpen: false });
	    }
	  }, {
	    key: 'openChooseItem',
	    value: function openChooseItem() {
	      this.setState({ chooseItemOpen: true });
	    }
	  }, {
	    key: 'addItem',
	    value: function addItem(r) {
	      var newRows = [].concat(_toConsumableArray(this.state.invoice.rows));
	      newRows = newRows.concat(r);
	      var invoice = _extends({}, this.state.invoice, { rows: newRows });
	      this.setState({ invoice: invoice });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var salesInvoiceDetail = this.props.salesInvoiceDetail;
	      var handleSubmit = this.props.handleSubmit;
	
	      var finalPrice = 0;
	      var createDialogStyle = {
	        height: '600px',
	        width: '600px',
	        marginLeft: '-10%'
	      };
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'content-heading' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_credit' })
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'form',
	          { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/customerReturn', className: 'btn btn-default pull-right' },
	              _react2.default.createElement('em', { className: 'fa fa-close' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 4 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_num_colonsign' })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name_colonsign' })
	                ),
	                ' ',
	                salesInvoiceDetail && salesInvoiceDetail.Customer_Name,
	                ' '
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_colonsign' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 4 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no_colonsign' })
	                ),
	                ' ',
	                salesInvoiceDetail && salesInvoiceDetail.InvoiceNum,
	                ' '
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_date_colonsign' })
	                ),
	                ' ',
	                salesInvoiceDetail && salesInvoiceDetail.PostingDate.slice(0, 10),
	                ' '
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_price_colonsign' })
	                ),
	                ' ',
	                salesInvoiceDetail && salesInvoiceDetail.TotalPrice,
	                ' '
	              )
	            ),
	            _react2.default.createElement(_reactBootstrap.Col, { sm: 4 })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { className: 'btn btn-primary pull-right', onClick: this.addNonProduct.bind(this) },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_non_product' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { className: 'btn btn-primary', onClick: this.openChooseItem.bind(this), style: { float: "right" } },
	                _react2.default.createElement('i', null),
	                ' ',
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_select_an_item' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            this.renderInvoice()
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 8 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-sm-5 marginTopStyle' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' })
	                ),
	                _react2.default.createElement(_reduxForm.Field, { name: 'Note', component: 'Textarea', className: 'form-control', style: { minHeight: '100px' } })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 4 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	                  ':'
	                ),
	                ' ',
	                this.state.totalPrice
	              )
	            )
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { className: 'btn btn-primary pull-left', type: 'submit' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'issue_credit' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          { dialogStyles: createDialogStyle, isVisible: this.state.chooseItemOpen, onCloseClicked: this.closeChooseItem.bind(this), title: 'choose an item' },
	          _react2.default.createElement(_customerItems2.default, { items: this.props.customerItem, addItem: this.addItem.bind(this) })
	        )
	      );
	    }
	  }]);
	
	  return CreditForm;
	}(_react.Component);
	
	CreditForm.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = CreditForm;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(DropDownEditor, 'DropDownEditor', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/creditForm.jsx');
	
	  __REACT_HOT_LOADER__.register(CreditForm, 'CreditForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/creditForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/creditForm.jsx');
	}();

	;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _constants = __webpack_require__(11);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _inputField = __webpack_require__(16);
	
	var _datePicker = __webpack_require__(27);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _salesInventoryInfo = __webpack_require__(77);
	
	var _salesInventoryInfo2 = _interopRequireDefault(_salesInventoryInfo);
	
	var _returnModal = __webpack_require__(122);
	
	var _returnModal2 = _interopRequireDefault(_returnModal);
	
	var _setWeightModal = __webpack_require__(74);
	
	var _setWeightModal2 = _interopRequireDefault(_setWeightModal);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AutoCompleteEditor = _reactDataGridAddons.Editors.AutoComplete;
	
	function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	var CustomerIssueCredit = function (_Component) {
	  _inherits(CustomerIssueCredit, _Component);
	
	  function CustomerIssueCredit() {
	    _classCallCheck(this, CustomerIssueCredit);
	
	    var _this = _possibleConstructorReturn(this, (CustomerIssueCredit.__proto__ || Object.getPrototypeOf(CustomerIssueCredit)).call(this));
	
	    _this.handleOnFocus = function (event) {
	      event.target.select();
	    };
	
	    _this.setAllProductQuantity = function (quantity) {
	      _this.props.setValue('salesOrderForm', 'Quantity', quantity);
	    };
	
	    _this.selectInventoryInfo = function (selectedInventoryRow) {
	      _this.setState({
	        selectedInventoryRow: selectedInventoryRow,
	        inStock: selectedInventoryRow.InStock,
	        purchased: selectedInventoryRow.Purchased,
	        presale: selectedInventoryRow.PreSale,
	        net_weight: selectedInventoryRow.NetWeight,
	        ship_weight: selectedInventoryRow.NetWeight,
	        product_type: selectedInventoryRow.ProductType });
	    };
	
	    _this.closeShowInventory = function (value) {
	      _this.handleAfterShowInventoryClose(value);
	      _this.setState({ showInventoryOpen: false });
	    };
	
	    _this.moveToIssueForm = function () {
	      var invoice = _this.state.invoice;
	      var _this$state$selectedI = _this.state.selectedInventoryRow,
	          CRV = _this$state$selectedI.CRV,
	          ProductNum = _this$state$selectedI.ProductNum,
	          Name = _this$state$selectedI.Name,
	          Description = _this$state$selectedI.Description,
	          IsTaxable = _this$state$selectedI.IsTaxable,
	          MeasureUnit = _this$state$selectedI.MeasureUnit,
	          NetWeight = _this$state$selectedI.NetWeight,
	          PackageSize = _this$state$selectedI.PackageSize,
	          PackageType = _this$state$selectedI.PackageType,
	          ProductType = _this$state$selectedI.ProductType,
	          Product_id = _this$state$selectedI.Product_id,
	          RefNum = _this$state$selectedI.RefNum,
	          RefPrice = _this$state$selectedI.RefPrice;
	      var _this$props = _this.props,
	          UnitPrice = _this$props.UnitPrice,
	          Quantity = _this$props.Quantity,
	          Weight = _this$props.Weight;
	
	
	      var Total = 0;
	      if (ProductType == "Fixed" || ProductType == "Non-Product") {
	        if (Quantity) {
	          Total = +roundTo(Quantity * UnitPrice, 2).toFixed(2);
	        }
	      } else {
	        if (Weight) {
	          Total = +roundTo(Quantity * UnitPrice * Weight, 2).toFixed(2);
	        }
	      }
	      if (isNaN(Total)) {
	        Total = 0;
	      }
	      var newWeightsList = [];
	      for (var i = 0; i < Quantity && ProductType !== "Fixed"; i++) {
	        newWeightsList.push(parseFloat(Weight));
	      }var newEntry = {
	        Idx: invoice.rows.length ? invoice.rows[invoice.rows.length - 1].Idx + 1 : 0,
	        CRV: CRV,
	        ProductNum: ProductNum,
	        Name: Name,
	        Description: Description,
	        IsTaxable: IsTaxable,
	        MeasureUnit: MeasureUnit,
	        NetWeight: NetWeight,
	        PackageSize: PackageSize,
	        PackageType: PackageType,
	        ProductType: ProductType,
	        Product_id: Product_id,
	        RefNum: RefNum,
	        RefPrice: RefPrice,
	        UnitPrice: UnitPrice,
	        ReturnableWeightsList: newWeightsList,
	        Weights: newWeightsList,
	        LoadedQuantity: parseFloat(Quantity),
	        TotalNetWeight: parseFloat(Weight) * parseFloat(Quantity),
	        ReturnQuantity: parseFloat(Quantity),
	        ReturnWeight: parseFloat(Weight) * parseFloat(Quantity),
	        ReturnTotalPrice: Total,
	        ReturnReason: "",
	        IsProductReturned: false
	      };
	      invoice.rows.push(newEntry);
	      _this.setState({ invoice: invoice });
	      _this.props.resetIssueInputs();
	    };
	
	    _this.closeReturnModal = function () {
	      _this.setState({ ReturnModalOpen: false, IsWeight: false });
	    };
	
	    _this.openWeightModule = function () {
	      _this.setState({ ReturnModalOpen: true, IsWeight: true });
	    };
	
	    _this.openQuantityModule = function () {
	      _this.setState({ ReturnModalOpen: true, IsWeight: false });
	    };
	
	    _this.setWeights = function (currentRow, currentWeights, editedRow) {
	      var index = 0;
	      var Weights = [];
	      var ReturnWeight = 0;
	      currentWeights.map(function (row) {
	        Weights.push(parseFloat(roundTo(parseFloat(row.Weight), 2).toFixed(2)));
	        ReturnWeight += roundTo(parseFloat(row.Weight), 2);
	      });
	      var rows = [].concat(_toConsumableArray(_this.state.invoice.rows));
	      rows[currentRow].Weights = Weights;
	      rows[currentRow].ReturnableWeightsList = Weights;
	      rows[currentRow].ReturnWeight = ReturnWeight;
	      rows[currentRow].ReturnTotalPrice = parseFloat(roundTo(parseFloat(ReturnWeight) * rows[currentRow].UnitPrice, 2)).toFixed(2);
	      var invoice = _extends({}, _this.state.invoice, { rows: rows });
	      _this.setState({ invoice: invoice });
	    };
	
	    _this.keepLoaded = function (oldLoaded) {
	      var invoice = _extends({}, _this.state.invoice);
	      invoice.rows[_this.state.currentRow].ReturnQuantity = oldLoaded;
	      _this.setState({ invoice: invoice });
	    };
	
	    _this.checkValues = function (selected) {
	      for (var i = 0; i < selected.length; i++) {
	        if (!selected[i].ReturnQuantity || selected[i].ReturnQuantity === null || selected[i].ReturnQuantity === 0) {
	          alert("Quantity cannot be zero or blank, if you want to remove a row please deselect it");
	          return false;
	        }
	      }
	      return true;
	    };
	
	    _this.handleIssue = function (TotalPrice, TaxRate, Tax, CRV, RestockingFee, FinalPrice, Notation) {
	      var ReturnStatus = false;
	      for (var i = 0; i < _this.state.invoice.rows.length; i++) {
	        if (!_this.state.invoice.rows[i].ReturnReason) {
	          ReturnStatus = true;
	          i = _this.state.invoice.rows.length;
	        }
	      }
	      if (!ReturnStatus) {
	        _this.props.createCreditIssue(_this.props.currentCustomer.id, TotalPrice, TaxRate, Tax, CRV, RestockingFee, FinalPrice, Notation, _this.state.invoice, _this.props.PostingDate);
	      } else {
	        alert('Please specify a Return Reason(s) for issuing credit');
	      }
	    };
	
	    _this.handleProductChange = function (row) {
	      var invoice = _extends({}, _this.state.invoice);
	      for (var i = 0; i < invoice.rows.length; i++) {
	        if (invoice.rows[i].Idx === row.Idx) {
	          invoice.rows[i].IsProductReturned = !invoice.rows[i].IsProductReturned;
	        }
	      }
	      _this.setState({ invoice: invoice });
	    };
	
	    _this.handleRestock = function (e) {
	      if (typeof parseFloat(e.target.value, 10) !== 'NaN' && e.target.value !== '') {
	        var curRestock = e.target.value;
	        var invoice = _extends({}, _this.state.invoice);
	        _this.setState({ curRestock: curRestock, invoice: invoice });
	      } else if (e.target.value === '') {
	        _this.setState({ curRestock: '' });
	      }
	    };
	
	    _this.handleNotation = function (e) {
	      _this.setState({ curNotation: e.target.value });
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton - 150,
	      invoice: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      totalPrice: 0,
	      showInventoryOpen: false,
	      currentCustomer_id: null,
	      selectedInventoryRow: {},
	      curRow: '',
	      curTotal: 0,
	      curCRV: 0,
	      curTax: 0,
	      curRestock: 0,
	      curNotation: '',
	      curFinal: 0,
	      totalLoaded: null,
	      ReturnFormatter: false,
	      IsWeight: false,
	      rowChosen: null,
	      currentWeights: null,
	      backLogWeights: []
	    };
	    _this.handleResize = _this.handleResize.bind(_this);
	    return _this;
	  }
	
	  _createClass(CustomerIssueCredit, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.currentCustomer) {
	        this.context.router.push('/customerReturn/');
	      } else {
	        this.setState({ currentCustomer_id: this.props.currentCustomer.id });
	      }
	      this.props.setDefaultSearchType('RefNum', 'customerIssueCredit');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.handleResize);
	      var currentSalesInvoice = this.props.currentSalesInvoice;
	
	
	      if (this.props.currentCustomer) {
	        this.props.fetchCustomerDetail(this.props.currentCustomer.id);
	        this.props.fetchTaxRates();
	      }
	      // else if(typeof currentSalesInvoice == "object" && currentSalesInvoice && currentSalesInvoice.SalesReturn_id != null){
	      //   this.props.fetchSalesReturnDetail(currentSalesInvoice.SalesReturn_id);
	      // }
	      // else if(typeof currentSalesInvoice == "object" && currentSalesInvoice)
	      //   this.props.fetchSalesInvoiceCompletedDetail(currentSalesInvoice.SalesInvoice_id);
	      // else if(currentSalesInvoice)
	      //   this.props.fetchSalesInvoiceCompletedDetail(currentSalesInvoice, "InvoiceNum");
	      // this.props.fetchSalesInvoice("1900-01-01", "3000-01-01", null, 7);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.salesInvoiceDetail && nextProps.salesInvoiceDetail != this.props.salesInvoiceDetail) {
	        var invoice = _extends({}, this.state.invoice, { rows: nextProps.salesInvoiceDetail.Sales_Invoice_Lines || [] });
	        this.setState({ invoice: invoice });
	      }
	      if (nextProps.taxRates && nextProps.taxRates != this.props.taxRates) {
	        var _invoice = _extends({}, this.state.invoice, { TaxRate: nextProps.taxRates[0].Rate || 0 });
	        this.setState({ invoice: _invoice });
	      }
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton - 150 });
	    }
	  }, {
	    key: 'openShowInventory',
	    value: function openShowInventory(event) {
	      if (!this.props.searchValue || this.props.searchValue === '') {
	        return;
	      }
	      switch (event.charCode) {
	        case 13:
	          // ENTER
	          event.preventDefault();
	          if (this.props.currentCustomer) {
	            this.setState({ showInventoryOpen: true });
	            break;
	          } else {
	            this.setState({ case: 'noCustomerChosen', confirmOpen: true });
	            break;
	          }
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'handleAfterShowInventoryClose',
	    value: function handleAfterShowInventoryClose(value) {
	      _reactDom2.default.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	    }
	  }, {
	    key: 'handleKeyPress',
	    value: function handleKeyPress(value, event) {
	      if (event.charCode == 13) {
	        event.preventDefault();
	        if (value == 'unitPrice' || value == 'notation') {
	          if (!isNumeric(this.props.Quantity) || this.props.Quantity < 0) {
	            return;
	          }
	        }
	        _reactDom2.default.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	      }
	    }
	  }, {
	    key: 'renderSubtotal',
	    value: function renderSubtotal() {
	      var subtotal = 0;
	      if (this.state.selectedInventoryRow.ProductType == "Fixed" || this.state.selectedInventoryRow.ProductType == "Non-Product") {
	        if (this.props.Quantity) {
	          subtotal = (this.props.Quantity * this.props.UnitPrice).toFixed(2);
	        }
	      } else {
	        if (this.props.Weight) {
	          subtotal = (this.props.UnitPrice * this.props.Weight).toFixed(2);
	        }
	      }
	      if (isNaN(subtotal)) {
	        subtotal = 0;
	      }
	      return _react2.default.createElement(_reduxForm.Field, { name: 'Subtotal', component: _inputField.DisabledInputField, placeholder: subtotal });
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      var formattedDate = date.getFullYear() + '-';
	
	      formattedDate += date.getMonth() + 1 + '-';
	      if (date.getDate() < 10) {
	        formattedDate += '0' + date.getDate();
	      } else {
	        formattedDate += date.getDate();
	      }
	      return formattedDate;
	    }
	  }, {
	    key: 'calculateFinalTotal',
	    value: function calculateFinalTotal(nextProps) {
	      var Tax = nextProps.Tax;
	      var Promo = nextProps.Promo;
	      var RestockingFee = nextProps.RestockingFee;
	
	      if (isNumeric(Tax)) {
	        Tax = parseFloat(Tax);
	      } else {
	        Tax = 0;
	      }
	      if (isNumeric(Promo)) {
	        Promo = parseFloat(Promo);
	      } else {
	        Promo = 0;
	      }
	      if (isNumeric(RestockingFee)) {
	        RestockingFee = parseFloat(RestockingFee);
	      } else {
	        RestockingFee = 0;
	      }
	
	      return Tax + Promo - RestockingFee;
	    }
	  }, {
	    key: 'returnTotalWeight',
	    value: function returnTotalWeight(totalWeight) {
	      console.log("this is the return weight", totalWeight);
	    }
	  }, {
	    key: 'renderInvoice',
	    value: function renderInvoice() {
	      var _this2 = this;
	
	      var that = this;
	      if (this.props.isLoading && !this.props.error) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.error) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.error)
	          )
	        );
	      } else {
	        // Parameters of the react-data-grid
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.invoice);
	        };
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	        // Handle the sortable function
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var invoice = _extends({}, _this2.state.invoice, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this2.setState({ invoice: invoice });
	        };
	        var handleRowUpdated = function handleRowUpdated(e) {
	          var rows = getRows(); //this.state.invoice.rows;
	          var returnQuantity = parseFloat(rows[e.rowIdx].ReturnQuantity) || 0;
	          Object.assign(rows[e.rowIdx], e.updated);
	          if (e.cellKey === "ReturnQuantity" && (_this2.state.invoice.rows[e.rowIdx].ProductType === 'Fixed' || _this2.state.invoice.rows[e.rowIdx].ProductType === 'Per-Pound' || _this2.state.invoice.rows[e.rowIdx].ProductType === 'Non-Product')) {
	            var invoice = _extends({}, _this2.state.invoice);
	            if (invoice.rows[e.rowIdx].LoadedQuantity) {
	              invoice.rows[e.rowIdx].ReturnQuantity = parseFloat(e.updated.ReturnQuantity);
	            }
	            if (parseFloat(e.updated.ReturnQuantity) < 0) {
	              invoice.rows[e.rowIdx].ReturnQuantity = 0;
	            }
	            invoice.rows[e.rowIdx].ReturnQuantity = _root_url.isAN ? parseFloat(e.updated.ReturnQuantity) : Math.trunc(invoice.rows[e.rowIdx].ReturnQuantity);
	            invoice.rows[e.rowIdx].ReturnWeight = invoice.rows[e.rowIdx].LoadedQuantity ? invoice.rows[e.rowIdx].TotalNetWeight / invoice.rows[e.rowIdx].LoadedQuantity * invoice.rows[e.rowIdx].ReturnQuantity : invoice.rows[e.rowIdx].InvoiceWeight / invoice.rows[e.rowIdx].InvoiceQuantity * invoice.rows[e.rowIdx].ReturnQuantity;
	            invoice.rows[e.rowIdx].ReturnWeight = +roundTo(invoice.rows[e.rowIdx].ReturnWeight, 2).toFixed(2);
	            if (_this2.state.invoice.rows[e.rowIdx].ProductType === 'Fixed') {
	              invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnQuantity * invoice.rows[e.rowIdx].UnitPrice, 2)).toFixed(2);
	            } else {
	              invoice.rows[e.rowIdx].ReturnTotalPrice = invoice.rows[e.rowIdx].ReturnWeight * invoice.rows[e.rowIdx].UnitPrice;
	            }
	            invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnTotalPrice, 2)).toFixed(2);
	            invoice.rows[e.rowIdx].ReturnCRV = parseFloat(roundTo(invoice.rows[e.rowIdx].CRV / invoice.rows[e.rowIdx].LoadedQuantity * parseFloat(e.updated.ReturnQuantity), 2)).toFixed(2);
	            _this2.setState({ invoice: invoice, totalLoaded: invoice.rows[e.rowIdx].LoadedQuantity });
	          } else if (e.cellKey == "ReturnQuantity" && _this2.state.invoice.rows[e.rowIdx].ProductType === 'Non-Fixed') {
	            var updated = _extends({}, e.updated);
	            if (parseFloat(updated.ReturnQuantity) < 0) updated.ReturnQuantity = 0;
	            Object.assign(rows[e.rowIdx], updated);
	            _this2.setState({ currentRow: e.rowIdx, totalLoaded: parseFloat(rows[e.rowIdx].ReturnQuantity), rowChosen: e.rowIdx, currentWeights: rows[e.rowIdx].Weights, editedRow: rows[e.rowIdx] });
	            _this2.openWeightModule();
	          }
	          if (e.cellKey === 'UnitPrice') {
	            var _invoice2 = _extends({}, _this2.state.invoice);
	            // Update Return Total Price
	            _invoice2.rows[e.rowIdx].UnitPrice = +parseFloat(roundTo(rows[e.rowIdx].UnitPrice, 2)).toFixed(2);
	            if (_this2.state.invoice.rows[e.rowIdx].ProductType === 'Fixed' || _this2.state.invoice.rows[e.rowIdx].ProductType === 'Non-Product') {
	              _invoice2.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(_invoice2.rows[e.rowIdx].ReturnQuantity * _invoice2.rows[e.rowIdx].UnitPrice, 2)).toFixed(2);
	            } else {
	              _invoice2.rows[e.rowIdx].ReturnTotalPrice = _invoice2.rows[e.rowIdx].ReturnWeight * _invoice2.rows[e.rowIdx].UnitPrice;
	            }
	            _this2.setState({ invoice: _invoice2 });
	          }
	          if (e.cellKey == "ReturnReason") {
	            var _invoice3 = _extends({}, _this2.state.invoice);
	            _invoice3.rows[e.rowIdx].ReturnReason = e.updated.ReturnReason;
	            _this2.setState({ invoice: _invoice3 });
	          }
	        };
	
	        var returnReasonOptions = [{ id: 0, title: 'Damaged' }, { id: 1, title: 'Defective' }, { id: 2, title: 'Not Needed' }, { id: 3, title: 'Repair' }, { id: 4, title: 'Wrong Item' }, { id: 5, title: 'Other' }, { id: 6, title: 'Missing' }, { id: 7, title: 'Out' }, { id: 8, title: 'Short' }];
	
	        var ReasonEditor = _react2.default.createElement(AutoCompleteEditor, { options: returnReasonOptions });
	
	        var deleteFormatter = _react2.default.createClass({
	          displayName: 'deleteFormatter',
	          render: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  className: 'textAlignStyle',
	                  onClick: function onClick() {
	                    var invoice = _extends({}, that.state.invoice);
	                    var index = 0;
	                    for (var i = 0; i < invoice.rows.length; i++) {
	                      if (_this3.props.dependentValues.Idx === invoice.rows[i].Idx) {
	                        index = i;
	                      }
	                    }
	                    invoice.rows.splice(index, 1);
	                    that.setState({ invoice: invoice });
	                  } },
	                'X'
	              )
	            );
	          }
	        });
	
	        var onRowsSelected = function onRowsSelected(rows) {
	          var newRows = _this2.state.invoice.rows;
	          // for (let i = 0; i < newRows.length; i++) {
	          //    newRows[i].isSelected = false;
	          // }
	          var curRow = false;
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = true;
	            if (!newRows[r.rowIdx].Restock) newRows[r.rowIdx].Restock = 0;
	          });
	          var selectedRows = [].concat(_toConsumableArray(_this2.state.invoice.selectedRows));
	          selectedRows = selectedRows.concat(rows.map(function (r) {
	            return r.row;
	          }));
	          var invoice = _extends({}, _this2.state.invoice, { rows: newRows, selectedRows: selectedRows });
	          _this2.setState({ invoice: invoice });
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          var newRows = _this2.state.invoice.rows;
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = false;
	          });
	          var selectedRows = [].concat(_toConsumableArray(_this2.state.invoice.selectedRows));
	          selectedRows = selectedRows.filter(function (obj) {
	            return obj.isSelected == true;
	          });
	          var invoice = _extends({}, _this2.state.invoice, { rows: newRows, selectedRows: selectedRows });
	          _this2.setState({
	            invoice: invoice
	          });
	        };
	        // let reasonEditor = <DropDownEditor options={returnReasonOptions} />;
	        // let reasonFormattor = <DropDownFormatter options={returnReasonOptions} value='bug' />;
	
	        var IsFixedFormatter = _react2.default.createClass({
	          displayName: 'IsFixedFormatter',
	          render: function render() {
	            if (this.props.dependentValues.ProductType === "Non-Fixed") {
	              return _react2.default.createElement(
	                'span',
	                null,
	                this.props.value,
	                ' ',
	                _react2.default.createElement(
	                  'label',
	                  { className: 'label label-success' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'non_fixed' })
	                )
	              );
	            } else if (this.props.dependentValues.ProductType === "Per-Pound") {
	              return _react2.default.createElement(
	                'span',
	                null,
	                this.props.value,
	                ' ',
	                _react2.default.createElement(
	                  'label',
	                  { className: 'label label-primary' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'per_pound' })
	                )
	              );
	            } else {
	              return _react2.default.createElement(
	                'span',
	                null,
	                this.props.value
	              );
	            }
	          }
	        });
	
	        var ReturnWeightFormatter = _react2.default.createClass({
	          displayName: 'ReturnWeightFormatter',
	          render: function render() {
	            return _react2.default.createElement(
	              'span',
	              null,
	              this.props.dependentValues.ReturnWeight || this.props.dependentValues.ReturnWeight === 0 ? this.props.dependentValues.ReturnWeight : ''
	            );
	          }
	        });
	
	        var StatusFormatter = _react2.default.createClass({
	          displayName: 'StatusFormatter',
	          render: function render() {
	            var _this4 = this;
	
	            return _react2.default.createElement(
	              'span',
	              { style: { width: "100%" } },
	              _react2.default.createElement('input', { type: 'checkbox', checked: this.props.dependentValues.IsProductReturned, onClick: function onClick() {
	                  that.handleProductChange(_this4.props.dependentValues);
	                } })
	            );
	          }
	        });
	
	        var ReturnFormatter = _react2.default.createClass({
	          displayName: 'ReturnFormatter',
	          render: function render() {
	            var _this5 = this;
	
	            if (this.props.dependentValues) return this.props.dependentValues.ProductType === 'Fixed' ? _react2.default.createElement(
	              'span',
	              { style: { 'padding-right': '5px' } },
	              this.props.dependentValues.ReturnQuantity,
	              ' ',
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'warning',
	                  className: 'textAlignStyle', style: { height: '20px', width: '60px', padding: '0px' },
	                  disabled: !this.props.dependentValues.isSelected,
	                  onClick: function onClick() {
	                    /*var ProductNum = this.props.dependentValues.ProductNum;
	                    that.removeRow(ProductNum);*/
	                    var currentWeights = {};
	                    currentWeights.Weights = [].concat(_toConsumableArray(_this5.props.dependentValues.ReturnWeightsList), _toConsumableArray(_this5.props.dependentValues.ReturnableWeightsList));
	                    that.setState({ rowChosen: _this5.props.dependentValues.SalesInvoiceLine_id, currentWeights: currentWeights });
	                    that.openWeightModule(_this5.props.dependentValues);
	                    console.log("check dependentValues", _this5.props.dependentValues);
	                  } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'change' })
	              )
	            ) : _react2.default.createElement(
	              'span',
	              null,
	              this.props.dependentValues.ReturnQuantity || this.props.dependentValues.ReturnQuantity === 0 ? this.props.dependentValues.ReturnQuantity : ''
	            );
	          }
	        });
	
	        var TotalPriceFormatter = _react2.default.createClass({
	          displayName: 'TotalPriceFormatter',
	          render: function render() {
	            return that.props.params.id ? _react2.default.createElement(
	              'span',
	              null,
	              this.props.dependentValues.ProductType === 'Fixed' ? parseFloat(roundTo(this.props.dependentValues.ReturnQuantity * this.props.dependentValues.UnitPrice, 2)).toFixed(2) : parseFloat(roundTo(this.props.dependentValues.ReturnWeight * this.props.dependentValues.UnitPrice, 2)).toFixed(2)
	            ) : _react2.default.createElement(
	              'span',
	              null,
	              this.props.dependentValues.TotalPrice
	            );
	          }
	        });
	
	        var columns = [{
	          key: 'Delete',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	          width: 40,
	          formatter: deleteFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	          resizable: true,
	          sortable: true,
	          width: 140,
	          filterable: true
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	          resizable: true,
	          sortable: true,
	          width: 140,
	          filterable: true
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true,
	          width: 160,
	          filterable: true
	        }, {
	          key: 'UnitPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	          editable: true,
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'ReturnQuantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_qty' }),
	          resizable: true,
	          sortable: true,
	          editable: true,
	          width: 130,
	          filterable: true,
	          formatter: IsFixedFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'ReturnWeight',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rtn_wt' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true,
	          formatter: ReturnWeightFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'ReturnTotalPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'ReturnReason',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_reason' }),
	          resizable: true,
	          sortable: true,
	          editor: ReasonEditor
	        }, {
	          key: 'IsProductReturned',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'is_prod_rtnd' }),
	          resizable: true,
	          sortable: true,
	          formatter: StatusFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }];
	
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { id: 'CustomerIssueCredit-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'Product_id',
	                onGridSort: handleGridSort,
	                columns: columns,
	                rowHeight: 25,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                onRowUpdated: handleRowUpdated,
	                minHeight: this.state.tableHeight,
	                onGridRowsUpdate: function onGridRowsUpdate() {
	                  console.log("grid row updating");
	                }
	                //enableRowSelect={true}
	                , enableCellSelect: true
	                // rowSelection={{
	                //   showCheckbox: true,
	                //   onRowsSelected: onRowsSelected,
	                //   onRowsDeselected: onRowsDeselected,
	                //   selectBy: {
	                //     isSelectedKey: 'isSelected'
	                //   }
	                // }}
	              })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var createDialogInventoryStyle = {
	        height: '700px',
	        width: '1000px',
	        marginLeft: '-28%',
	        marginTop: '-20%'
	      };
	      var createDialogStyleWeight = {
	        width: '500px',
	        height: '600px',
	        top: '45%',
	        marginLeft: '-10%'
	      };
	      var selectInventoryInformation = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_inventory_information' });
	      var salesInvoiceDetail = !this.props.params.id ? this.props.salesInvoiceDetail : this.props.salesReturnDetail;
	      if (this.props.salesReturnDetail && this.props.salesReturnDetail.SRNum) salesInvoiceDetail.InvoiceNum = this.props.params.id ? this.props.salesReturnDetail.SRNum.slice(0, -1) : salesInvoiceDetail.InvoiceNum;
	      var handleSubmit = this.props.handleSubmit;
	
	      var Customer_Name = '';
	      if (salesInvoiceDetail) {
	        Customer_Name = salesInvoiceDetail.Name ? salesInvoiceDetail.Name : salesInvoiceDetail.Deliver_Customer_Name;
	      }
	      var taxRate = 0;
	      var tax = 0;
	      var total = 0;
	      var CRV = 0;
	      var finalPrice = 0;
	      taxRate = parseFloat(this.state.invoice.TaxRate) || 0;
	      for (var i = 0; i < this.state.invoice.rows.length; i++) {
	        total += this.state.invoice.rows[i].ReturnTotalPrice ? roundTo(parseFloat(this.state.invoice.rows[i].ReturnTotalPrice), 2) : 0;
	        if (this.state.invoice.rows[i].IsTaxable && this.state.invoice.rows[i].ReturnTotalPrice) tax += this.state.invoice.rows[i].ReturnTotalPrice ? roundTo(parseFloat(this.state.invoice.rows[i].ReturnTotalPrice), 2) : 0;
	        CRV += +roundTo(parseFloat(this.state.invoice.rows[i].CRV || 0) * (parseFloat(this.state.invoice.rows[i].ReturnQuantity) || 0), 2).toFixed(2);
	      }
	      tax = tax * (parseFloat(taxRate || 0) / 100.0);
	      tax = parseFloat(roundTo(tax, 2)).toFixed(2);
	      total = parseFloat(roundTo(total, 2)).toFixed(2);
	      CRV = parseFloat(roundTo(CRV, 2)).toFixed(2);
	      finalPrice = parseFloat(roundTo((parseFloat(total) || 0) + (parseFloat(CRV) || 0) + (parseFloat(tax) || 0) - (parseFloat(this.state.curRestock) || 0), 2)).toFixed(2);
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'returns' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'issue_credit' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          { id: 'breadcrumbButtonGroup' },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'success',
	              disabled: this.state.invoice.rows.length === 0,
	              onClick: function onClick() {
	                _this6.handleIssue(total, taxRate, tax, CRV, _this6.state.curRestock, finalPrice, _this6.state.curNotation);
	              } },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement('em', { className: 'fa fa-check' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'issue_credit' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'danger',
	              type: 'button',
	              onClick: function onClick() {
	                _this6.context.router.push('/customerReturn');
	              } },
	            _react2.default.createElement('em', { className: 'fa fa-close' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'exit' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'sales_issue_credit-form' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'h1',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'issue_credit' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 8 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 3 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'h3',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 6 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                          ':'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 6 },
	                        Customer_Name
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 6 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'h3',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 2 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' }),
	                          ':'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7 },
	                        salesInvoiceDetail && salesInvoiceDetail.InvoiceNum
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 2 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	                          ':'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7 },
	                        salesInvoiceDetail && salesInvoiceDetail.Sales_User_Name
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 3 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'h3',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 5 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' }),
	                          ':'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7 },
	                        salesInvoiceDetail && salesInvoiceDetail.InvoiceNum
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 5 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_date' }),
	                          ':'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'PostingDate', selected: (0, _moment2.default)().format("MM-DD-YY"), component: _datePicker.DatePicker })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 5 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'user' }),
	                          ':'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7 },
	                        salesInvoiceDetail && salesInvoiceDetail.Modifier_User_Name /*right?*/
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_details' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'label',
	                          { style: { 'display': 'inline-flex' } },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total' }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            ' $$'
	                          ),
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'ReturnTotal', component: _inputField.DisabledInputField, placeholder: total })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'crv' }),
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'CRV', component: _inputField.DisabledInputField, placeholder: CRV })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'Tax', component: _inputField.DisabledInputField, placeholder: tax })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 4 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'restocking_fee' }),
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(_reactBootstrap.Input, { name: 'curRestock', type: 'number', onChange: this.handleRestock, value: this.state.curRestock })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'label',
	                          { style: { 'display': 'inline-flex' } },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final' }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            ' $$'
	                          ),
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'FinalTotal', component: _inputField.DisabledInputField, placeholder: finalPrice })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 8 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(_reactBootstrap.Input, { name: 'curNotation', type: 'text', onChange: this.handleNotation, value: this.state.curNotation })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'h2',
	              { style: { 'marginTop': '0' } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_information' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 6 },
	                    _react2.default.createElement(_reduxForm.Field, { name: 'searchType', component: renderTypeRadios }),
	                    _react2.default.createElement('div', { style: { 'padding-bottom': '9px' } }),
	                    _react2.default.createElement(_reduxForm.Field, { name: 'ProductInformation', component: _inputField.InputField, ref: 'productSearch', withRef: true, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                        _this6.openShowInventory(event);
	                      } })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 6, id: 'product-search-outputs' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2, className: 'pr0' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' })
	                      ),
	                      _react2.default.createElement(_reduxForm.Field, { name: 'Quantity', withRef: true, ref: 'quantity', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                          _this6.handleKeyPress('unitPrice', event);
	                        }, placeholder: 'must be > 0' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2, className: 'pr0' },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'dollar-sign' },
	                          '$$'
	                        )
	                      ),
	                      _react2.default.createElement(_reduxForm.Field, { name: 'UnitPrice', withRef: true, ref: 'unitPrice', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                          if (event.charCode == 13) {
	                            if (!isNumeric(_this6.props.Quantity) || _this6.props.Quantity < 0 || !isNumeric(_this6.props.UnitPrice) || _this6.props.UnitPrice < 0) {
	                              return;
	                            }
	                            _this6.handleKeyPress('productSearch', event);
	                            _this6.moveToIssueForm();
	                          }
	                        } })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' })
	                      ),
	                      _react2.default.createElement(_reduxForm.Field, {
	                        name: 'Weight',
	                        withRef: true,
	                        ref: 'weight',
	                        component: _inputField.DisabledInputField,
	                        onFocus: this.handleOnFocus,
	                        onKeyPress: function onKeyPress(event) {
	                          if (event.charCode == 13) {
	                            _this6.handleKeyPress('productSearch', event);
	                            _this6.moveToIssueForm();
	                          }
	                        }
	                      })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'subtotal' })
	                          )
	                        ),
	                        this.renderSubtotal()
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                null,
	                this.renderInvoice()
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          { dialogStyles: createDialogStyleWeight, isVisible: this.state.ReturnModalOpen, onCloseClicked: function onCloseClicked() {
	              _this6.closeReturnModal();
	            }, title: 'Return Products' },
	          _react2.default.createElement(_setWeightModal2.default, {
	            invoice: true,
	            setWeights: this.setWeights,
	            keepLoaded: this.keepLoaded,
	            currentWeights: this.state.currentWeights,
	            closeC: this.closeReturnModal,
	            totalLoaded: this.state.totalLoaded,
	            rowChosen: this.state.rowChosen,
	            returnTotalWeight: this.returnTotalWeight.bind(this),
	            editedRow: this.state.editedRow })
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogInventoryStyle,
	            isVisible: this.state.showInventoryOpen,
	            onCloseClicked: function onCloseClicked() {
	              _this6.closeShowInventory('productSearch');
	            },
	            title: selectInventoryInformation },
	          _react2.default.createElement(_salesInventoryInfo2.default, {
	            Customer_id: this.state.currentCustomer_id,
	            SearchType: this.props.searchType,
	            SearchValue: this.props.searchValue,
	            closeShowInventory: this.closeShowInventory,
	            selectInventoryInfo: this.selectInventoryInfo,
	            setSaleRowValue: this.props.setSaleRowValue,
	            setAllProductQuantity: this.setAllProductQuantity,
	            formName: 'customerIssueCredit'
	          })
	        )
	      );
	    }
	  }]);
	
	  return CustomerIssueCredit;
	}(_react.Component);
	
	CustomerIssueCredit.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	var renderTypeRadios = function renderTypeRadios(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group', id: 'search-product-by' },
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-4 search-by-max-width' },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'search_by' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'ProductNum',
	        checked: props.input.value === "ProductNum" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'RefNum',
	        checked: props.input.value === "RefNum" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'Name',
	        checked: props.input.value === "Name" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'Description',
	        checked: props.input.value === "Description" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	    )
	  );
	};
	
	var _default = CustomerIssueCredit;
	exports.default = _default;
	
	
	function roundTo(n, digits) {
	  if (digits === undefined) {
	    digits = 0;
	  }
	
	  var multiplicator = Math.pow(10, digits);
	  n = parseFloat((n * multiplicator).toFixed(11));
	  var test = Math.round(n) / multiplicator;
	  return +test.toFixed(2);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isNumeric, 'isNumeric', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerIssueCredit.jsx');
	
	  __REACT_HOT_LOADER__.register(roundTo, 'roundTo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerIssueCredit.jsx');
	
	  __REACT_HOT_LOADER__.register(AutoCompleteEditor, 'AutoCompleteEditor', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerIssueCredit.jsx');
	
	  __REACT_HOT_LOADER__.register(CustomerIssueCredit, 'CustomerIssueCredit', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerIssueCredit.jsx');
	
	  __REACT_HOT_LOADER__.register(renderTypeRadios, 'renderTypeRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerIssueCredit.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerIssueCredit.jsx');
	}();

	;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _constants = __webpack_require__(11);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomerItems = function (_Component) {
	    _inherits(CustomerItems, _Component);
	
	    function CustomerItems() {
	        _classCallCheck(this, CustomerItems);
	
	        var _this = _possibleConstructorReturn(this, (CustomerItems.__proto__ || Object.getPrototypeOf(CustomerItems)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	            rows: [],
	            selectedRows: [],
	            filters: {},
	            sortColumn: null,
	            sortDirection: null
	        };
	        _this.handleResize = _this.handleResize.bind(_this);
	        return _this;
	    }
	
	    _createClass(CustomerItems, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setState({ rows: this.props.items });
	            window.addEventListener('resize', this.handleResize);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once products are ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            this.props.resetCurrentPurchaseTemplate();
	            this.context.router.push('/purchaseTemplate/new');
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this2 = this;
	
	            var getRows = function getRows() {
	                return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	            };
	
	            var getSize = function getSize() {
	                return getRows().length;
	            };
	
	            var rowGetter = function rowGetter(rowIdx) {
	                var rows = getRows();
	                return rows[rowIdx];
	            };
	
	            // Handle the sortable function
	
	            var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                _this2.setState(state);
	            };
	
	            var handleFilterChange = function handleFilterChange(filter) {
	                var newFilters = Object.assign({}, _this2.state.filters);
	                if (filter.filterTerm) {
	                    newFilters[filter.column.key] = filter;
	                } else {
	                    delete newFilters[filter.column.key];
	                }
	                _this2.setState({ filters: newFilters });
	            };
	
	            // Handle the row select function
	
	            var onRowsSelected = function onRowsSelected(rows) {
	                var newRows = _this2.state.rows;
	                rows.map(function (r) {
	                    newRows[r.rowIdx].isSelected = true;
	                });
	                var selectedRows = [].concat(_toConsumableArray(_this2.state.selectedRows));
	                selectedRows = selectedRows.concat(rows.map(function (r) {
	                    return r.row;
	                }));
	                _this2.setState({ selectedRows: selectedRows });
	            };
	
	            var onRowsDeselected = function onRowsDeselected(rows) {
	                var newRows = _this2.state.rows;
	                rows.map(function (r) {
	                    newRows[r.rowIdx].isSelected = false;
	                });
	                var selectedRows = [].concat(_toConsumableArray(_this2.state.selectedRows));
	                selectedRows = selectedRows.filter(function (obj) {
	                    return obj.isSelected == true;
	                });
	                _this2.setState({ selectedRows: selectedRows });
	            };
	
	            // Column difinition
	
	            var columns = [{
	                key: 'ProductNum',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	                resizable: true,
	                sortable: true,
	                filterable: true
	            }, {
	                key: 'ProductName',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                resizable: true,
	                sortable: true,
	                filterable: true
	            }, {
	                key: 'ProductDescription',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_description' }),
	                resizable: true,
	                sortable: true,
	                filterable: true
	            }, {
	                key: 'UnitPrice',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price' }),
	                resizable: true,
	                sortable: true,
	                filterable: true
	            }, {
	                key: 'TotalPrice',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_price' }),
	                resizable: true,
	                sortable: true,
	                filterable: true
	            }];
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { maxWidth: '99%' }, id: 'CustomerItems-dataGrid1' },
	                        _react2.default.createElement(_reactDataGrid2.default, {
	                            rowKey: 'ProductNum',
	                            onGridSort: handleGridSort,
	                            toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                            onAddFilter: handleFilterChange,
	                            columns: columns,
	                            rowGetter: rowGetter,
	                            rowsCount: getSize(),
	                            minHeight: 300,
	                            enableRowSelect: 'multi',
	                            rowSelection: {
	                                showCheckbox: true,
	                                enableShiftSelect: true,
	                                onRowsSelected: onRowsSelected,
	                                onRowsDeselected: onRowsDeselected,
	                                selectBy: {
	                                    isSelectedKey: 'isSelected'
	                                }
	                            }
	                        })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'checkPermission',
	        value: function checkPermission(permission) {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                this.renderTable(),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'primary',
	                            className: 'marginLeftStyle',
	                            onClick: function onClick() {
	                                _this3.props.addItem(_this3.state.selectedRows);
	                            }
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_selected_items' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CustomerItems;
	}(_react.Component);
	
	CustomerItems.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = CustomerItems;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(CustomerItems, 'CustomerItems', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerItems.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerItems.jsx');
	}();

	;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(3);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _selection = __webpack_require__(21);
	
	var _inputField = __webpack_require__(16);
	
	var _datePicker = __webpack_require__(27);
	
	var _cleanDates = __webpack_require__(22);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getBsStyle = function getBsStyle(input, value) {
	  return input === value ? 'success' : 'primary';
	};
	
	var renderRadios = function renderRadios(props) {
	  var titleClass = (0, _classnames2.default)({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'control-label', 'col-sm-3', 'centerStyle');
	  var renderStartDatePicker = function renderStartDatePicker(days) {
	    if (days === '-1') {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: 'primary' },
	        _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', placeholder: 'Start', component: _datePicker.DatePicker })
	      );
	    }
	    return _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: 'primary' },
	      _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', placeholder: 'Start', component: _datePicker.DisabledDatePicker })
	    );
	  };
	  var renderEndDatePicker = function renderEndDatePicker(days) {
	    if (days === '-1') {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: 'primary' },
	        _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', placeholder: 'End', component: _datePicker.DatePicker })
	      );
	    }
	    return _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: 'primary' },
	      _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', placeholder: 'End', component: _datePicker.DisabledDatePicker })
	    );
	  };
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '1') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'today-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'today-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '1', checked: props.input.value === '1' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'today' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '7') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'sevenDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'sevenDay-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '7', checked: props.input.value === '7' })),
	          '7 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '30') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'thirtyDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'thirtyDay-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '30', checked: props.input.value === '30' })),
	          '30 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '90') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'ninetyDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'ninetyDay-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '90', checked: props.input.value === '90' })),
	          '90 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '-1') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'dateRange-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'dateRange-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '-1', checked: props.input.value === '-1' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date_range' })
	        )
	      )
	    ),
	    renderStartDatePicker(props.Days),
	    renderEndDatePicker(props.Days)
	  );
	};
	
	var renderStatusRadios = function renderStatusRadios(props) {
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'all') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'all-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'all-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'all', checked: props.input.value === 'all' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'Return') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'released-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'released-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'Return', checked: props.input.value === 'Return' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'Credit') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'released-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'released-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'Credit', checked: props.input.value === 'Credit' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit' })
	        )
	      )
	    )
	  );
	};
	
	var renderFormTypes = function renderFormTypes(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'optionStyle' },
	    _react2.default.createElement(
	      _reactBootstrap.Col,
	      { sm: 3 },
	      _react2.default.createElement(
	        'label',
	        null,
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { type: 'radio', value: 'invoice' })),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice' })
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Col,
	      { sm: 3 },
	      _react2.default.createElement(
	        'label',
	        null,
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { type: 'radio', value: 'return' })),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return' })
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Col,
	      { sm: 3 },
	      _react2.default.createElement(
	        'label',
	        null,
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { type: 'radio', value: 'credit' })),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit' })
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Col,
	      { sm: 3 },
	      _react2.default.createElement(
	        'label',
	        null,
	        _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { type: 'radio', value: 'all' })),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' })
	      )
	    )
	  );
	};
	
	var CustomerReturn = function (_Component) {
	  _inherits(CustomerReturn, _Component);
	
	  function CustomerReturn() {
	    _classCallCheck(this, CustomerReturn);
	
	    var _this = _possibleConstructorReturn(this, (CustomerReturn.__proto__ || Object.getPrototypeOf(CustomerReturn)).call(this));
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	      invoices: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      isSelected: false,
	      curRow: false,
	      fromDate: null,
	      toDate: null
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.fetchSalesOrdersByDetails = _this.fetchSalesOrdersByDetails.bind(_this);
	    _this.fetchSalesOrdersByCustomerNum = _this.fetchSalesOrdersByCustomerNum.bind(_this);
	    return _this;
	  }
	
	  _createClass(CustomerReturn, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.setDefaultDays('customerReturn');
	      this.props.setValue('customerReturn', 'Status', 'all');
	      this.props.fetchCustomers();
	      this.fetchSalesOrdersByCustomerNum(null);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      window.addEventListener('resize', this.handleResize);
	      this.props.setDefaultDays('customerReturn');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var customerId = nextProps.Customers ? nextProps.Customers.id : null;
	
	      if (nextProps.FromDate && nextProps.FromDate !== this.props.FromDate) {
	        this.setState({
	          fromDate: nextProps.FromDate
	        }, function () {
	          _this2.fetchSalesOrdersByCustomerNum(customerId, nextProps.Days);
	        });
	      }
	      if (nextProps.ToDate && nextProps.ToDate !== this.props.ToDate) {
	        this.setState({
	          toDate: nextProps.ToDate
	        }, function () {
	          _this2.fetchSalesOrdersByCustomerNum(customerId, nextProps.Days);
	        });
	      }
	
	      // let selectedChecker = false;
	      // if(nextProps.salesInvoice ){
	      //   console.log("CHECK");
	      //   if(nextProps.salesInvoice.length){
	      //     let selectedChecker = false;
	      //     for (let i = 0; i < nextProps.salesInvoices.length; i++){
	      //       if (nextProps.salesInvoices[i].isSelected)
	      //         selectedChecker = true;
	      //     }
	      //   }
	      // }
	      // if (this.state.isSelected !== selectedChecker)
	      //   this.setState({ isSelected: selectedChecker });
	
	      if (nextProps.salesInvoice && nextProps.salesInvoice != this.props.salesInvoice) {
	        var invoices = _extends({}, this.state.invoices, { rows: nextProps.salesInvoice, selectedRows: [] });
	        // let selectedChecker = false;
	        // let curRow = false;
	        // if (this.state.curRow) {
	        //     for (let i = 0; i < nextProps.salesInvoice.length; i++){
	        //       if (nextProps.salesInvoices[i] == this.state.curRow)
	        //         selectedChecker = true;
	        //     }
	        //     if (selectedChecker)
	        //       curRow = this.state.curRow;
	        // }
	        this.setState({ invoices: invoices });
	      }
	
	      // If the Days field changes, update the sales invoices table and filters
	      if (nextProps.Days && nextProps.Days !== this.props.Days) {
	        if (nextProps.Days !== '-1') {
	          this.props.setValue('customerReturn', 'FromDate', null);
	          this.props.setValue('customerReturn', 'ToDate', null);
	        }
	        this.props.setValue('customerReturn', 'Days', nextProps.Days);
	        this.fetchSalesOrdersByCustomerNum(customerId, nextProps.Days);
	      }
	      if (nextProps.Days === undefined) {
	        this.props.setDefaultDays('customerReturn');
	      }
	
	      if (nextProps.Status && nextProps.Status !== this.props.Status) {
	        if (nextProps.Customers) {
	          // this.props.fetchSalesInvoicesCompleted(nextProps.Customers.id);
	          this.fetchSalesOrdersByCustomerNum(nextProps.Customers.id, nextProps.Days);
	        }
	      }
	
	      if (nextProps.Customers && nextProps.Customers !== this.props.Customers) {
	        // this.props.fetchSalesInvoicesCompleted(nextProps.Customers.id);
	        this.fetchSalesOrdersByCustomerNum(nextProps.Customers.id, nextProps.Days);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      return (0, _cleanDates.dateFormat)('YYYY-MM-DD', date);
	    }
	  }, {
	    key: 'renderCustomers',
	    value: function renderCustomers() {
	      // If payment term is loading, show a spinner.
	      if (this.props.customersIsLoading) return _react2.default.createElement(_spinner2.default, null);
	      var customerNameOptions = this.getCustomerNameOptions();
	      return _react2.default.createElement(
	        'div',
	        { className: 'control-dropdown', style: { width: '200px', marginRight: '15px' } },
	        _react2.default.createElement(_reduxForm.Field, { name: 'Customers', component: _selection.Selection, matchPos: 'any', options: customerNameOptions })
	      );
	    }
	  }, {
	    key: 'renderCustomersNum',
	    value: function renderCustomersNum() {
	      // If payment term is loading, show a spinner.
	      if (this.props.customersIsLoading) return _react2.default.createElement(_spinner2.default, null);
	      var customerNameOptions = this.getCustomerNumOptions();
	      return _react2.default.createElement(
	        'div',
	        { className: 'control-dropdown', style: { width: '150px', marginRight: '15px' } },
	        _react2.default.createElement(_reduxForm.Field, { name: 'Customers', component: _selection.Selection, matchPos: 'any', options: customerNameOptions })
	      );
	    }
	
	    // clickNew(event) {
	    //     event.preventDefault();
	    //     const currentInvoice = this.state.invoices.selectedRows[0];
	    //     this.props.resetCurrentSalesInvoice();
	    //     this.props.selectSalesInvoice(currentInvoice);
	    //     this.context.router.push('/customerReturn/new');
	    // }
	
	  }, {
	    key: 'handleKeyPress',
	    value: function handleKeyPress(e) {
	      if (e.charCode === 13) {
	        var currentInvoice = this.props.Invoice_num;
	        this.props.resetCurrentSalesInvoice();
	        this.props.selectSalesInvoice(currentInvoice);
	        this.context.router.push('/customerReturn/new');
	      }
	    }
	  }, {
	    key: 'renderInvoiceNumInput',
	    value: function renderInvoiceNumInput() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 2 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice' }),
	              ' #: '
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 2 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'Invoice_num', component: _inputField.InputField, onKeyPress: function onKeyPress(e) {
	                return _this3.handleKeyPress(e);
	              } })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDatePickers',
	    value: function renderDatePickers() {
	      var _this4 = this;
	
	      if (this.props.Days === -1) {
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 1 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'from' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', component: _datePicker.DatePicker })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 1 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'to' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', component: _datePicker.DatePicker })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 2 },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { className: 'btn btn-primary', onClick: function onClick() {
	                  console.log('got Props', _this4.props);_this4.fetchSalesOrdersByDetails();
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	            )
	          )
	        );
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(_reactBootstrap.Col, { sm: 10 }),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 2 },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { className: 'btn btn-primary', onClick: function onClick() {
	                console.log('got Props2', _this4.props);_this4.fetchSalesOrdersByDetails();
	              } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'fetchSalesOrdersByDetails',
	    value: function fetchSalesOrdersByDetails() {
	      var dateRange = -1;
	      var FromDate = '1900-01-01';
	      var ToDate = '3000-01-01';
	      // let CustomerNum = this.props.Customers && this.props.Customers.id;
	      var InvoiceNum = this.props.InvoiceNum;
	      // if(!CustomerNum) {
	      //   confirm("choose a customer");
	      //   return;
	      // }
	      if (this.state.fromDate != null) {
	        FromDate = this.formatDate(this.state.fromDate);
	      }
	      if (this.state.toDate != null) {
	        ToDate = this.formatDate(this.state.toDate);
	      }
	      if (this.props.Days != null) {
	        dateRange = this.props.Days;
	      }
	      if (dateRange !== -1) {
	        ToDate = (0, _moment2.default)().format('YYYY-MM-DD');
	        if (dateRange === '1') {
	          FromDate = ToDate;
	        } else if (dateRange === '7') {
	          FromDate = (0, _moment2.default)().subtract('7', 'days').format('YYYY-MM-DD');
	        } else if (dateRange === '30') {
	          FromDate = (0, _moment2.default)().subtract('30', 'days').format('YYYY-MM-DD');
	        } else if (dateRange === '90') {
	          FromDate = (0, _moment2.default)().subtract('90', 'days').format('YYYY-MM-DD');
	        }
	      }
	      // this.props.fetchSalesInvoicesCompleted(FromDate, ToDate, CustomerNum, dateRange, InvoiceNum);
	      var customer = this.props.Customers;
	      this.props.fetchSalesInvoicesByNum(FromDate, ToDate, InvoiceNum, customer ? customer.id : null);
	    }
	  }, {
	    key: 'fetchSalesOrdersByCustomerNum',
	    value: function fetchSalesOrdersByCustomerNum(CustomerNum) {
	      var dateRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	
	      var ToDate = (0, _moment2.default)().format('YYYY-MM-DD');
	      var FromDate = (0, _moment2.default)().subtract('7', 'days').format('YYYY-MM-DD');
	      // if (!CustomerNum) {
	      //   confirm('Please Select a Customer');
	      //   return;
	      // }
	
	      if (this.state.fromDate != null) FromDate = this.formatDate(this.state.fromDate);
	
	      if (this.state.toDate != null) ToDate = this.formatDate(this.state.toDate);
	
	      // if (this.props.Days != null) dateRange = this.props.Days;
	
	      if (dateRange !== -1) {
	        ToDate = (0, _moment2.default)().format('YYYY-MM-DD');
	        if (dateRange === '1') {
	          FromDate = ToDate;
	        } else if (dateRange === '7') {
	          FromDate = (0, _moment2.default)().subtract('7', 'days').format('YYYY-MM-DD');
	        } else if (dateRange === '30') {
	          FromDate = (0, _moment2.default)().subtract('30', 'days').format('YYYY-MM-DD');
	        } else if (dateRange === '90') {
	          FromDate = (0, _moment2.default)().subtract('90', 'days').format('YYYY-MM-DD');
	        }
	      }
	    }
	  }, {
	    key: 'getCustomerNameOptions',
	    value: function getCustomerNameOptions() {
	      var customerOptions = [];
	      this.props.customers.map(function (customer) {
	        customerOptions.push({ value: customer.CustomerNum, label: customer.Name, id: customer.Customer_id });
	      });
	      return customerOptions;
	    }
	  }, {
	    key: 'getCustomerNumOptions',
	    value: function getCustomerNumOptions() {
	      var customerOptions = [];
	      this.props.customers.map(function (customer) {
	        customerOptions.push({ value: customer.CustomerNum, label: customer.CustomerNum, id: customer.Customer_id });
	      });
	      return customerOptions;
	    }
	  }, {
	    key: 'renderInvoices',
	    value: function renderInvoices() {
	      var _this5 = this;
	
	      if (this.props.isLoading && !this.props.error) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.error) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.error)
	          )
	        );
	      }
	
	      var tableHeight = window.innerHeight < 900 ? 545 : 545;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this5.state.invoices);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        var invoices = _extends({}, _this5.state.invoices, { filters: {} });
	        _this5.setState({ invoices: invoices });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this5.state.invoices.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	
	        var invoices = _extends({}, _this5.state.invoices, { filters: newFilters });
	        _this5.setState({ invoices: invoices });
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var invoices = _extends({}, _this5.state.invoices, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this5.setState({ invoices: invoices });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var selectedRows = [];
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	          selectedRows.push(r.row);
	        });
	        var invoices = _extends({}, _this5.state.invoices, { rows: newRows, selectedRows: selectedRows });
	        _this5.setState({ invoices: invoices });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = _this5.state.invoices.rows;
	        var curRow = false;
	        rows.map(function (r) {
	          curRow = newRows[r.rowIdx];
	          newRows[r.rowIdx].isSelected = false;
	        });
	        _this5.setState({ isSelected: false, curRow: curRow });
	        var selectedRows = [].concat(_toConsumableArray(_this5.state.invoices.selectedRows));
	        selectedRows = selectedRows.filter(function (obj) {
	          return obj.isSelected == true;
	        });
	        var invoices = _extends({}, _this5.state.invoices, { rows: newRows, selectedRows: selectedRows });
	        _this5.setState({ invoices: invoices });
	      };
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var date = new Date(this.props.value);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      // Column difinition
	
	      var columns = [{
	        key: 'InvoiceNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        width: 160,
	        filterable: true
	      }, {
	        key: 'SONum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'linked_so_no' }),
	        resizable: true,
	        sortable: true,
	        width: 160,
	        filterable: true
	      }, {
	        key: 'Deliver_CustomerName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' }),
	        resizable: true,
	        sortable: true,
	        width: 160,
	        filterable: true
	      }, {
	        key: 'PostingDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_date' }),
	        resizeable: true,
	        sortable: true,
	        width: 120,
	        formatter: DateFormatter,
	        filterable: true
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_amount' }),
	        resizable: true,
	        sortable: true,
	        width: 150,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'FinalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total' }),
	        resizable: true,
	        sortable: true,
	        width: 140,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'SaleStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_type' }),
	        resizable: true,
	        sortable: true,
	        width: 150,
	        filterable: true
	      }, {
	        key: 'Pickup_Warehouse_id',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse' }),
	        resizable: true,
	        sortable: true,
	        width: 150,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { id: 'CustomerReturn-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'InvoiceNum',
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              onClearFilters: onClearFilters,
	              columns: columns,
	              rowHeight: 25,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: tableHeight,
	              enableRowSelect: 'single',
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              }
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'clickNew',
	    value: function clickNew(event) {
	      var _this6 = this;
	
	      event.preventDefault();
	      var currentInvoice = this.state.invoices.selectedRows[0];
	      var customerToSelect = void 0;
	      if (!this.props.Customers) {
	        customerToSelect = {
	          id: currentInvoice.Deliver_Customer_id
	        };
	      } else {
	        customerToSelect = this.props.Customers;
	      }
	      this.props.resetCurrentSalesInvoicePromise().then(function () {
	        _this6.props.selectSalesInvoice(currentInvoice);
	        _this6.props.selectCustomer(customerToSelect);
	        _this6.context.router.push('/customerReturn/new');
	      });
	    }
	  }, {
	    key: 'issueCredit',
	    value: function issueCredit(event) {
	      event.preventDefault();
	      // const currentInvoice = this.state.invoices.selectedRows[0];
	      this.props.resetCurrentSalesInvoice();
	      // this.props.selectSalesInvoice(currentInvoice);
	      this.props.selectCustomer(this.props.Customers);
	      this.context.router.push('/customerIssueCredit');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var CustomerId = 0;
	      if (this.props.Customers) {
	        CustomerId = this.props.Customers.id;
	      }
	      return (
	        //---------------
	        // Begin HTML: Create New/Edit return
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'returns' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_sales_return' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'returns-customer-return' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { id: 'date-range-picker', className: 'form-horizontal' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 1 },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'filter-title text-nowrap' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_date' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'colon' },
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 11 },
	                      _react2.default.createElement(
	                        'div',
	                        { id: 'statusFilterRadios', className: 'form-horizontal' },
	                        _react2.default.createElement(_reduxForm.Field, {
	                          name: 'Days',
	                          component: renderRadios,
	                          CustomerId: CustomerId,
	                          Days: this.props.Days,
	                          fetchSalesOrdersByCustomerNum: this.fetchSalesOrdersByCustomerNum
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { className: 'position-relative table-collapse-fix', style: { height: '620px' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'table-filters', style: { width: '650px', zIndex: 1, left: '20px', 'border-right': '1px solid #D3D3D3' } },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'control-label', style: { whiteSpace: 'nowrap', width: '100px' } },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' })
	                ),
	                this.renderCustomers(),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'control-label', style: { whiteSpace: 'nowrap', width: '60px', marginRight: '5px' } },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'number' })
	                ),
	                this.renderCustomersNum(),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'control-dropdown', style: { 'border-left': '1px solid #D3D3D3', 'padding-left': '10px', marginRight: '10px' } },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'InvoiceNum', component: _inputField.InputField, placeholder: 'Invoice No.' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.ButtonToolbar,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { bsStyle: 'primary', onClick: function onClick() {
	                        _this7.fetchSalesOrdersByDetails();
	                      } },
	                    _react2.default.createElement('em', { className: 'fa fa-search' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                { className: 'table-buttons', style: { left: '730px' } },
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    onClick: function onClick(event) {
	                      _this7.clickNew(event);
	                    },
	                    bsStyle: 'success',
	                    disabled: !(0, _permissions2.default)('add_sales_return') || !this.state.invoices.selectedRows.length
	                  },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_sales_return' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    onClick: function onClick(event) {
	                      _this7.issueCredit(event);
	                    },
	                    disabled: !(0, _permissions2.default)('add_sales_return') || this.props.Customers == null
	                  },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'issue_credit' })
	                )
	              ),
	              this.renderInvoices()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CustomerReturn;
	}(_react.Component);
	
	CustomerReturn.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = CustomerReturn;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getBsStyle, 'getBsStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerReturn.jsx');
	
	  __REACT_HOT_LOADER__.register(renderRadios, 'renderRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerReturn.jsx');
	
	  __REACT_HOT_LOADER__.register(renderStatusRadios, 'renderStatusRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerReturn.jsx');
	
	  __REACT_HOT_LOADER__.register(renderFormTypes, 'renderFormTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerReturn.jsx');
	
	  __REACT_HOT_LOADER__.register(CustomerReturn, 'CustomerReturn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerReturn.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerReturn.jsx');
	}();

	;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(11);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reduxForm = __webpack_require__(3);
	
	var _selection = __webpack_require__(21);
	
	var _inputField = __webpack_require__(16);
	
	var _datePicker = __webpack_require__(27);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _salesInventoryInfo = __webpack_require__(77);
	
	var _salesInventoryInfo2 = _interopRequireDefault(_salesInventoryInfo);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _returnModal = __webpack_require__(122);
	
	var _returnModal2 = _interopRequireDefault(_returnModal);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isHMM = _root_url.ROOT_API_URL === 'https://hmm-scm.truckxi.com/api/';
	var isLO = _root_url.ROOT_API_URL === 'https://lonni-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://lonni-scm.truckxi.com/api/';
	var isAN = _root_url.ROOT_API_URL === 'https://asian-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://asian-scm.truckxi.com/api/';
	
	var DropDownEditor = _reactDataGridAddons.Editors.DropDownEditor;
	
	function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	var CustomerReturnForm = function (_Component) {
	  _inherits(CustomerReturnForm, _Component);
	
	  function CustomerReturnForm() {
	    _classCallCheck(this, CustomerReturnForm);
	
	    var _this = _possibleConstructorReturn(this, (CustomerReturnForm.__proto__ || Object.getPrototypeOf(CustomerReturnForm)).call(this));
	
	    _this.closeReturnModal = function () {
	      _this.setState({ ReturnModalOpen: false, IsWeight: false });
	    };
	
	    _this.openWeightModule = function () {
	      _this.setState({ ReturnModalOpen: true, IsWeight: true });
	    };
	
	    _this.openQuantityModule = function () {
	      _this.setState({ ReturnModalOpen: true, IsWeight: false });
	    };
	
	    _this.findIntersect = function (arry1, arry2) {
	      var arry3 = [];
	      if (arry1) arry1.sort();
	      if (arry2) arry2.sort();
	      var k = 0;
	      for (var i = 0; i < arry1.length; i++) {
	        if (k < arry2.length && arry1[i] === arry2[k]) {
	          k++;
	        } else {
	          arry3.push(arry1[i]);
	        }
	      }
	      return arry3;
	    };
	
	    _this.setWeights = function (currentRow, currentWeights, currentTotalWeight) {
	      // let backLogWeights = [...this.state.backLogWeights];
	      // let newEntry = { currentRow, currentWeights };
	      // backLogWeights.push(newEntry);
	      // this.setState({backLogWeights});
	      var invoice = _extends({}, _this.state.invoice);
	      var ReturnWeightsList = [];
	      var selectedIndexes = [];
	      for (var k = 0; k < currentWeights.length; k++) {
	        if (currentWeights[k].isSelected) {
	          ReturnWeightsList.push(parseFloat(roundTo(parseFloat(currentWeights[k].Weight), 2).toFixed(2)));
	        }
	      }
	      for (var i = 0; i < _this.state.invoice.rows.length; i++) {
	        if (currentRow === _this.state.invoice.rows[i].SalesOrderLine_id || currentRow === _this.state.invoice.rows[i].SalesInvoiceLine_id) {
	          invoice.rows[i].ReturnTotalPrice = parseFloat(roundTo(parseFloat(currentTotalWeight) * invoice.rows[i].UnitPrice, 2)).toFixed(2);
	          invoice.rows[i].ReturnWeight = parseFloat(currentTotalWeight);
	          invoice.rows[i].ReturnWeightsList = [].concat(ReturnWeightsList);
	          invoice.rows[i].ReturnQuantity = ReturnWeightsList.length;
	          if (_this.props.params.id) {
	            invoice.rows[i].ReturnCRV = parseFloat(roundTo(invoice.rows[i].CRV * ReturnWeightsList.length), 2).toFixed(2) || invoice.rows[i].ReturnCRV || 0;
	          } else {
	            invoice.rows[i].ReturnCRV = parseFloat(roundTo(invoice.rows[i].CRV * ReturnWeightsList.length), 2).toFixed(2) || invoice.rows[i].ReturnCRV || 0;
	          }
	          // invoice.rows[i].TotalPrice = parseFloat(ReturnTotalPrice);
	        }
	      }
	      _this.setState({ invoice: invoice });
	    };
	
	    _this.checkValues = function (selected) {
	      for (var i = 0; i < selected.length; i++) {
	        if (!selected[i].ReturnQuantity || selected[i].ReturnQuantity === null || selected[i].ReturnQuantity === 0) {
	          alert('Quantity cannot be zero or blank, if you want to remove a row please deselect it');
	          return false;
	        }
	      }
	      return true;
	    };
	
	    _this.handleComplete = function (TotalPrice, Tax, CRV, RestockingFee, FinalPrice, Note, Redeliver, ReturnedSavings) {
	      var ReturnStatus = false;
	      for (var i = 0; i < _this.state.invoice.selectedRows.length; i++) {
	        if (!_this.state.invoice.selectedRows[i].ReturnReason) {
	          ReturnStatus = true;
	          i = _this.state.invoice.selectedRows.length;
	        }
	      }
	      if (!ReturnStatus) {
	        if (!_this.props.params.id) {
	          if (_this.checkValues(_this.state.invoice.selectedRows)) {
	            _this.props.createSalesReturn(_this.props.salesInvoiceDetail.InvoiceNum, TotalPrice, Tax, CRV, RestockingFee, FinalPrice, Note, _this.state.invoice, _this.props.salesInvoiceDetail.SalesInvoice_id, _this.props.CreditInvoiceNum ? _this.props.CreditInvoiceNum.value : '', _this.props.PostingDate, Redeliver, ReturnedSavings);
	          }
	        } else if (_this.checkValues(_this.state.invoice.selectedRows)) {
	          _this.props.editSalesReturn(_this.props.salesReturnDetail.SRNum, TotalPrice, Tax, CRV, RestockingFee, FinalPrice, Note, _this.state.invoice, _this.props.params.id, _this.props.CreditInvoiceNum ? _this.props.CreditInvoiceNum.value : '', _this.props.PostingDate, ReturnedSavings);
	        }
	      } else {
	        alert('Please specify a Return Reason(s) for issuing credit');
	      }
	    };
	
	    _this.handleRestock = function (e) {
	      if (typeof parseFloat(e.target.value, 10) !== 'NaN' && e.target.value !== '') {
	        var curRestock = e.target.value;
	        var invoice = _extends({}, _this.state.invoice);
	        _this.setState({ curRestock: curRestock, invoice: invoice });
	      } else if (e.target.value === '') {
	        _this.setState({ curRestock: '' });
	      }
	    };
	
	    _this.handleNotation = function (e) {
	      _this.setState({ curNotation: e.target.value });
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	      invoice: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      totalPrice: 0,
	      showInventoryOpen: false,
	      currentCustomer_id: null,
	      selectedInventoryRow: {},
	      curRow: '',
	      curTotal: 0,
	      curCRV: 0,
	      curTax: 0,
	      curRestock: 0,
	      curNotation: '',
	      curFinal: 0,
	      ReturnFormatter: false,
	      IsWeight: false,
	      rowChosen: null,
	      currentWeights: null,
	      backLogWeights: []
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    return _this;
	  }
	
	  _createClass(CustomerReturnForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.params.id) {
	        if (!this.props.currentCustomer) {
	          this.context.router.push('/customerReturn/');
	        } else {
	          this.setState({ currentCustomer_id: this.props.currentCustomer.id });
	        }
	      } else {
	        this.props.fetchSalesReturnDetail(this.props.params.id);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.handleResize);
	      var currentSalesInvoice = this.props.currentSalesInvoice;
	
	
	      if (!currentSalesInvoice && this.props.currentCustomer) {
	        if (this.props.currentCustomer.value) {
	          this.props.fetchCustomerItem(this.props.currentCustomer.value);
	        }
	      } else if ((typeof currentSalesInvoice === 'undefined' ? 'undefined' : _typeof(currentSalesInvoice)) === 'object' && currentSalesInvoice && currentSalesInvoice.SalesReturn_id != null) {
	        this.props.fetchSalesReturnDetail(currentSalesInvoice.SalesReturn_id);
	      } else if ((typeof currentSalesInvoice === 'undefined' ? 'undefined' : _typeof(currentSalesInvoice)) === 'object' && currentSalesInvoice) {
	        this.props.fetchSalesInvoiceCompletedDetail(currentSalesInvoice.SalesInvoice_id);
	      } else if (currentSalesInvoice) {
	        this.props.fetchSalesInvoiceCompletedDetail(currentSalesInvoice, 'InvoiceNum');
	      }
	      // this.props.fetchSalesInvoice("1900-01-01", "3000-01-01", null, 7);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.resetCurrentSalesInvoice();
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.salesInvoiceDetail && !this.props.params.id && nextProps.salesInvoiceDetail != this.props.salesInvoiceDetail) {
	        var invoice = _extends({}, this.state.invoice, { rows: nextProps.salesInvoiceDetail.Sales_Invoice_Lines, TaxRate: nextProps.salesInvoiceDetail.TaxRate, Savings: nextProps.salesInvoiceDetail.Savings, TotalPrice: nextProps.salesInvoiceDetail.TotalPrice });
	        //this.props.setValue('customerReturnForm', 'InvoiceNum', { value: nextProps.salesInvoiceDetail.InvoiceNum, label: nextProps.salesInvoiceDetail.InvoiceNum });
	        this.props.fetchUnpaidInvoices(nextProps.salesInvoiceDetail.Deliver_Customer_id);
	        this.setState({ invoice: invoice });
	      }
	      if (nextProps.salesReturnDetail && this.props.params.id && nextProps.salesReturnDetail != this.props.salesReturnDetail) {
	        this.props.fetchUnpaidInvoices(nextProps.salesReturnDetail.Deliver_Customer_id);
	        var selectedRows = [].concat(_toConsumableArray(nextProps.salesReturnDetail.Sales_Return_Line));
	        for (var i = 0; i < selectedRows.length; i++) {
	          selectedRows[i].isSelected = true;
	          selectedRows[i].ReturnedQuantity = selectedRows[i].ReturnedQuantity - selectedRows[i].ReturnQuantity;
	        }
	
	        var _invoice = _extends({}, this.state.invoice, { rows: selectedRows, selectedRows: selectedRows, TaxRate: nextProps.salesReturnDetail.TaxRate, Savings: nextProps.salesReturnDetail.Savings, TotalPrice: nextProps.salesReturnDetail.OriginalTotalPrice
	        });
	        //returnedSavings: nextProps.salesReturnDetail.ReturnedSavings,
	        this.setState({ invoice: _invoice, curRestock: nextProps.salesReturnDetail.RestockingFee, curNotation: nextProps.salesReturnDetail.Note });
	      }
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      var formattedDate = date.getFullYear() + '-';
	
	      formattedDate += date.getMonth() + 1 + '-';
	      if (date.getDate() < 10) {
	        formattedDate += '0' + date.getDate();
	      } else {
	        formattedDate += date.getDate();
	      }
	      return formattedDate;
	    }
	  }, {
	    key: 'calculateFinalTotal',
	    value: function calculateFinalTotal(nextProps) {
	      var Tax = nextProps.Tax;
	      var Promo = nextProps.Promo;
	      var RestockingFee = nextProps.RestockingFee;
	
	      if (isNumeric(Tax)) {
	        Tax = parseFloat(Tax);
	      } else {
	        Tax = 0;
	      }
	      if (isNumeric(Promo)) {
	        Promo = parseFloat(Promo);
	      } else {
	        Promo = 0;
	      }
	      if (isNumeric(RestockingFee)) {
	        RestockingFee = parseFloat(RestockingFee);
	      } else {
	        RestockingFee = 0;
	      }
	
	      return Tax + Promo - RestockingFee;
	    }
	
	    // remove the set of values from arry1 with the values of arry2
	
	  }, {
	    key: 'returnTotalWeight',
	    value: function returnTotalWeight(totalWeight) {
	      console.log('this is the return weight', totalWeight);
	    }
	  }, {
	    key: 'renderCreditInvoice',
	    value: function renderCreditInvoice(unpaidInvoices) {
	      var invoiceOptions = [];
	      if (unpaidInvoices) {
	        unpaidInvoices.map(function (invoice) {
	          invoiceOptions.push({ value: invoice.InvoiceNum, label: invoice.InvoiceNum });
	        });
	      }
	      return _react2.default.createElement(_reduxForm.Field, { name: 'CreditInvoiceNum', component: _selection.Selection, disabled: this.props.params.id, matchPos: 'any', options: invoiceOptions });
	    }
	  }, {
	    key: 'renderInvoice',
	    value: function renderInvoice() {
	      var _this2 = this;
	
	      var that = this;
	      if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.error)
	        )
	      );
	
	      // Parameters of the react-data-grid
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.invoice);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var invoice = Object.assign({}, _this2.state.invoice, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this2.setState({ invoice: invoice });
	      };
	
	      var handleRowUpdated = function handleRowUpdated(event) {
	        var e = _extends({}, event);
	        var rows = getRows(); // this.state.invoice.rows;
	        var returnQuantity = parseFloat(rows[e.rowIdx].ReturnQuantity) || 0;
	        if (_root_url.isJML && e.cellKey === 'ReturnBox') {
	          var ReturnQuantity = e.updated.ReturnBox ? e.updated.ReturnBox * rows[e.rowIdx].jmlPackageSize1 : '';
	          Object.assign(rows[e.rowIdx], _extends({}, e.updated, { ReturnQuantity: ReturnQuantity }));
	          e.cellKey = 'ReturnQuantity';
	          e.updated.ReturnQuantity = ReturnQuantity;
	        } else {
	          Object.assign(rows[e.rowIdx], e.updated);
	        }
	        if (e.cellKey === 'ReturnQuantity' && (_this2.state.invoice.rows[e.rowIdx].ProductType === 'Fixed' || _this2.state.invoice.rows[e.rowIdx].ProductType === 'Non-Product')) {
	          var invoice = _extends({}, _this2.state.invoice);
	          if (invoice.rows[e.rowIdx].LoadedQuantity && invoice.rows[e.rowIdx].LoadedQuantity - invoice.rows[e.rowIdx].ReturnedQuantity < parseFloat(e.updated.ReturnQuantity)) {
	            invoice.rows[e.rowIdx].ReturnQuantity = invoice.rows[e.rowIdx].LoadedQuantity - invoice.rows[e.rowIdx].ReturnedQuantity;
	          } else if (invoice.rows[e.rowIdx].LoadedQuantity) {
	            invoice.rows[e.rowIdx].ReturnQuantity = parseFloat(e.updated.ReturnQuantity);
	          }
	          if (invoice.rows[e.rowIdx].InvoiceQuantity && invoice.rows[e.rowIdx].InvoiceQuantity - invoice.rows[e.rowIdx].ReturnedQuantity < parseFloat(e.updated.ReturnQuantity)) {
	            invoice.rows[e.rowIdx].ReturnQuantity = invoice.rows[e.rowIdx].InvoiceQuantity - invoice.rows[e.rowIdx].ReturnedQuantity;
	          } else if (invoice.rows[e.rowIdx].InvoiceQuantity) {
	            invoice.rows[e.rowIdx].ReturnQuantity = parseFloat(e.updated.ReturnQuantity);
	          }
	          if (parseFloat(e.updated.ReturnQuantity) < 0) {
	            invoice.rows[e.rowIdx].ReturnQuantity = 0;
	          }
	          invoice.rows[e.rowIdx].ReturnQuantity = isAN ? parseFloat(e.updated.ReturnQuantity) : Math.trunc(invoice.rows[e.rowIdx].ReturnQuantity);
	          invoice.rows[e.rowIdx].ReturnWeight = invoice.rows[e.rowIdx].LoadedQuantity ? invoice.rows[e.rowIdx].TotalNetWeight / invoice.rows[e.rowIdx].LoadedQuantity * invoice.rows[e.rowIdx].ReturnQuantity : invoice.rows[e.rowIdx].InvoiceWeight / invoice.rows[e.rowIdx].InvoiceQuantity * invoice.rows[e.rowIdx].ReturnQuantity;
	
	          invoice.rows[e.rowIdx].ReturnWeight = +roundTo(invoice.rows[e.rowIdx].ReturnWeight, 2).toFixed(2);
	          // console.log('invoice weight', {
	          //   check: invoice.rows[e.rowIdx].ReturnWeight, totalWeight: invoice.rows[e.rowIdx].TotalNetWeight, quantity: (invoice.rows[e.rowIdx].LoadedQuantity) ? invoice.rows[e.rowIdx].LoadedQuantity : invoice.rows[e.rowIdx].InvoiceQuantity, ReturnQuantity: invoice.rows[e.rowIdx].ReturnQuantity,
	          // });
	          if (isHMM && invoice.rows[e.rowIdx].MeasureUnit === 'SFT') {
	            invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnQuantity * invoice.rows[e.rowIdx].UnitPrice * Number(invoice.rows[e.rowIdx].PackageSize_1), 2)).toFixed(2);
	          } else {
	            invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnQuantity * invoice.rows[e.rowIdx].UnitPrice, 2)).toFixed(2);
	          }
	          if (_this2.props.params.id) {
	            invoice.rows[e.rowIdx].ReturnCRV = parseFloat(roundTo(invoice.rows[e.rowIdx].CRV * parseFloat(e.updated.ReturnQuantity), 2)).toFixed(2) || invoice.rows[e.rowIdx].ReturnCRV || 0;
	          } else {
	            invoice.rows[e.rowIdx].ReturnCRV = parseFloat(roundTo(invoice.rows[e.rowIdx].CRV * parseFloat(e.updated.ReturnQuantity), 2)).toFixed(2) || invoice.rows[e.rowIdx].ReturnCRV || 0;
	          }
	          _this2.setState({ invoice: invoice });
	        } else if (e.cellKey === 'ReturnQuantity' && _this2.state.invoice.rows[e.rowIdx].ProductType === 'Per-Pound') {
	          var _invoice2 = _extends({}, _this2.state.invoice);
	          if (_invoice2.rows[e.rowIdx].LoadedQuantity && _invoice2.rows[e.rowIdx].LoadedQuantity - _invoice2.rows[e.rowIdx].ReturnedQuantity < parseFloat(e.updated.ReturnQuantity)) {
	            _invoice2.rows[e.rowIdx].ReturnQuantity = _invoice2.rows[e.rowIdx].LoadedQuantity - _invoice2.rows[e.rowIdx].ReturnedQuantity;
	          } else if (_invoice2.rows[e.rowIdx].LoadedQuantity) {
	            _invoice2.rows[e.rowIdx].ReturnQuantity = parseFloat(e.updated.ReturnQuantity);
	          }
	          if (_invoice2.rows[e.rowIdx].InvoiceQuantity && _invoice2.rows[e.rowIdx].InvoiceQuantity - _invoice2.rows[e.rowIdx].ReturnedQuantity < parseFloat(e.updated.ReturnQuantity)) {
	            _invoice2.rows[e.rowIdx].ReturnQuantity = _invoice2.rows[e.rowIdx].InvoiceQuantity - _invoice2.rows[e.rowIdx].ReturnedQuantity;
	          } else if (_invoice2.rows[e.rowIdx].InvoiceQuantity) {
	            _invoice2.rows[e.rowIdx].ReturnQuantity = parseFloat(e.updated.ReturnQuantity);
	          }
	          if (parseFloat(e.updated.ReturnQuantity) < 0) {
	            _invoice2.rows[e.rowIdx].ReturnQuantity = 0;
	          }
	          _invoice2.rows[e.rowIdx].ReturnQuantity = Math.trunc(_invoice2.rows[e.rowIdx].ReturnQuantity);
	          _invoice2.rows[e.rowIdx].ReturnWeight = _invoice2.rows[e.rowIdx].LoadedQuantity ? _invoice2.rows[e.rowIdx].TotalNetWeight / _invoice2.rows[e.rowIdx].LoadedQuantity * _invoice2.rows[e.rowIdx].ReturnQuantity : _invoice2.rows[e.rowIdx].InvoiceWeight / _invoice2.rows[e.rowIdx].InvoiceQuantity * _invoice2.rows[e.rowIdx].ReturnQuantity;
	
	          _invoice2.rows[e.rowIdx].ReturnWeight = +roundTo(_invoice2.rows[e.rowIdx].ReturnWeight, 2).toFixed(2);
	          // console.log('invoice weight', {
	          //   check: invoice.rows[e.rowIdx].ReturnWeight, totalWeight: invoice.rows[e.rowIdx].TotalNetWeight, quantity: (invoice.rows[e.rowIdx].LoadedQuantity) ? invoice.rows[e.rowIdx].LoadedQuantity : invoice.rows[e.rowIdx].InvoiceQuantity, ReturnQuantity: invoice.rows[e.rowIdx].ReturnQuantity,
	          // });
	          _invoice2.rows[e.rowIdx].ReturnTotalPrice = _invoice2.rows[e.rowIdx].ReturnWeight * _invoice2.rows[e.rowIdx].UnitPrice;
	          _invoice2.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(_invoice2.rows[e.rowIdx].ReturnTotalPrice, 2)).toFixed(2);
	          if (_this2.props.params.id) {
	            _invoice2.rows[e.rowIdx].ReturnCRV = parseFloat(roundTo(_invoice2.rows[e.rowIdx].CRV * parseFloat(e.updated.ReturnQuantity), 2)).toFixed(2) || _invoice2.rows[e.rowIdx].ReturnCRV || 0;
	          } else {
	            _invoice2.rows[e.rowIdx].ReturnCRV = parseFloat(roundTo(_invoice2.rows[e.rowIdx].CRV * parseFloat(e.updated.ReturnQuantity), 2)).toFixed(2) || _invoice2.rows[e.rowIdx].ReturnCRV || 0;
	          }
	          _this2.setState({ invoice: _invoice2 });
	        }
	        if (e.cellKey === 'UnitPrice') {
	          var _invoice3 = _extends({}, _this2.state.invoice);
	          // Update Return Total Price
	          _invoice3.rows[e.rowIdx].UnitPrice = +parseFloat(roundTo(rows[e.rowIdx].UnitPrice, 2)).toFixed(2);
	          if (_this2.state.invoice.rows[e.rowIdx].ProductType === 'Fixed' || _this2.state.invoice.rows[e.rowIdx].ProductType === 'Non-Product') {
	            if (isHMM && _invoice3.rows[e.rowIdx].MeasureUnit === 'SFT') {
	              _invoice3.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(_invoice3.rows[e.rowIdx].ReturnQuantity * _invoice3.rows[e.rowIdx].UnitPrice * Number(_invoice3.rows[e.rowIdx].PackageSize_1), 2)).toFixed(2);
	            } else {
	              _invoice3.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(_invoice3.rows[e.rowIdx].ReturnQuantity * _invoice3.rows[e.rowIdx].UnitPrice, 2)).toFixed(2);
	            }
	          } else {
	            _invoice3.rows[e.rowIdx].ReturnTotalPrice = _invoice3.rows[e.rowIdx].ReturnWeight * _invoice3.rows[e.rowIdx].UnitPrice;
	          }
	          _this2.setState({ invoice: _invoice3 });
	        }
	        if (e.cellKey === 'ReturnReason') {
	          var _invoice4 = _extends({}, _this2.state.invoice);
	          _invoice4.rows[e.rowIdx].ReturnReason = e.updated.ReturnReason;
	          _this2.setState({ invoice: _invoice4 });
	        }
	      };
	
	      // const returnReasonOptions = [
	      //   { id: 0, title: 'Damaged' },
	      //   { id: 1, title: 'Defective' },
	      //   { id: 2, title: 'Not Needed' },
	      //   { id: 3, title: 'Repair' },
	      //   { id: 4, title: 'Wrong Item' },
	      //   { id: 5, title: 'Other' },
	      //   { id: 6, title: 'Missing' },
	      // ];
	
	      var returnReasonOptions = ['Damaged', 'Defective', 'Not Needed', 'Repair', 'Wrong Item', 'Other', 'Missing', 'Out', 'Short'];
	
	      var IsVariableFormatter = _react2.default.createClass({
	        displayName: 'IsVariableFormatter',
	        render: function render() {
	          var _this3 = this;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                className: 'textAlignStyle',
	                style: { height: '23px', width: '39px', padding: '0px' },
	                onClick: function onClick() {
	                  var ProductNum = _this3.props.dependentValues.ProductNum;
	                  that.removeRow(ProductNum);
	                }
	              },
	              'X'
	            )
	          );
	        }
	      });
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var selectedRows = [].concat(_toConsumableArray(_this2.state.invoice.selectedRows));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	          if (!newRows[r.rowIdx].Restock) {
	            newRows[r.rowIdx].Restock = 0;
	          }
	          selectedRows.push(r.row);
	        });
	        var invoice = _extends({}, _this2.state.invoice, { rows: newRows, selectedRows: selectedRows });
	        _this2.setState({ invoice: invoice });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = [].concat(_toConsumableArray(_this2.state.invoice.rows));
	        var selectedRows = [].concat(_toConsumableArray(_this2.state.invoice.selectedRows));
	        selectedRows.map(function (r, index) {
	          if (r.Product_id === rows[0].row.Product_id) {
	            selectedRows.splice(index, 1);
	          }
	        });
	        newRows.map(function (r, index) {
	          if (r.Product_id === rows[0].row.Product_id) {
	            newRows[index].isSelected = false;
	          }
	        });
	        var invoice = _extends({}, _this2.state.invoice, { rows: newRows, selectedRows: selectedRows });
	        _this2.setState({ invoice: invoice });
	      };
	      // let reasonEditor = <DropDownEditor options={returnReasonOptions} />;
	      // let reasonFormattor = <DropDownFormatter options={returnReasonOptions} value='bug' />;
	
	      var IsFixedFormatter = _react2.default.createClass({
	        displayName: 'IsFixedFormatter',
	        render: function render() {
	          if (this.props.dependentValues.ProductType === 'Non-Fixed') {
	            return _react2.default.createElement(
	              'span',
	              null,
	              this.props.value,
	              ' ',
	              _react2.default.createElement(
	                'label',
	                { className: 'label label-success' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'non_fixed' })
	              )
	            );
	          } else if (this.props.dependentValues.ProductType === 'Per-Pound') {
	            return _react2.default.createElement(
	              'span',
	              null,
	              this.props.value,
	              ' ',
	              _react2.default.createElement(
	                'label',
	                { className: 'label label-primary' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'per_pound' })
	              )
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            this.props.value
	          );
	        }
	      });
	
	      var ReturnWeightFormatter = _react2.default.createClass({
	        displayName: 'ReturnWeightFormatter',
	        render: function render() {
	          // if (this.props.dependentValues.ReturnQuantity)
	          //   return (
	          //       (this.props.dependentValues.ProductType === "Non-Fixed") ?
	          //         <span>{(this.props.dependentValues.ReturnWeight ||  this.props.dependentValues.ReturnWeight === 0) ? this.props.dependentValues.ReturnWeight : ''}</span> :
	          //         <span>{
	          //           (this.props.dependentValues.LoadedQuantity) ?
	          //           ((this.props.dependentValues.TotalNetWeight/this.props.dependentValues.LoadedQuantity) * this.props.dependentValues.ReturnQuantity) :
	          //           ((this.props.dependentValues.TotalNetWeight/this.props.dependentValues.InvoiceQuantity) * this.props.dependentValues.ReturnQuantity)
	          //         }</span>
	          //   );
	          // else {
	          return _react2.default.createElement(
	            'span',
	            null,
	            this.props.dependentValues.ReturnWeight || this.props.dependentValues.ReturnWeight === 0 ? this.props.dependentValues.ReturnWeight : ''
	          );
	          // }
	        }
	      });
	
	      var ReturnFormatter = _react2.default.createClass({
	        displayName: 'ReturnFormatter',
	        render: function render() {
	          var _this4 = this;
	
	          if (this.props.dependentValues) {
	            if (!this.props.dependentValues.ReturnQuantity && this.props.dependentValues.ProductType === 'Non-Fixed') {
	              return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'primary',
	                    className: 'textAlignStyle',
	                    style: { height: '20px', width: '120px', padding: '0px' },
	                    disabled: !this.props.dependentValues.isSelected,
	                    onClick: function onClick() {
	                      var currentWeights = _extends({}, _this4.props.dependentValues);
	                      currentWeights.Weights = [].concat(_toConsumableArray(_this4.props.dependentValues.ReturnableWeightsList));
	                      that.setState({ rowChosen: _this4.props.dependentValues.SalesInvoiceLine_id, currentWeights: currentWeights });
	                      that.openWeightModule(_this4.props.dependentValues);
	                    }
	                  },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'process' })
	                )
	              );
	            } else if (this.props.dependentValues.ProductType === 'Fixed' || this.props.dependentValues.ProductType === 'Non-Product' || this.props.dependentValues.ProductType === 'Per-Pound') {
	              return _react2.default.createElement(
	                'span',
	                null,
	                this.props.dependentValues.ReturnQuantity || this.props.dependentValues.ReturnQuantity === 0 ? this.props.dependentValues.ReturnQuantity : ''
	              );
	            }
	            return _react2.default.createElement(
	              'span',
	              null,
	              this.props.dependentValues.ReturnQuantity,
	              ' ',
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'warning',
	                  className: 'textAlignStyle',
	                  style: { height: '20px', width: '60px', padding: '0px' },
	                  disabled: !this.props.dependentValues.isSelected,
	                  onClick: function onClick() {
	                    var currentWeights = _extends({}, _this4.props.dependentValues);
	                    currentWeights.Weights = [].concat(_toConsumableArray(_this4.props.dependentValues.ReturnableWeightsList));
	                    that.setState({ rowChosen: _this4.props.dependentValues.SalesInvoiceLine_id, currentWeights: currentWeights });
	                    that.openWeightModule(_this4.props.dependentValues);
	                  }
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'change' })
	              )
	            );
	          }
	        }
	      });
	      var ReturnBoxFormatter = _react2.default.createClass({
	        displayName: 'ReturnBoxFormatter',
	        render: function render() {
	          if (this.props.dependentValues) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              this.props.dependentValues.ReturnBox || this.props.dependentValues.ReturnBox === 0 ? this.props.dependentValues.ReturnBox : ''
	            );
	          }
	        }
	      });
	
	      var ReturnFormatter2 = _react2.default.createClass({
	        displayName: 'ReturnFormatter2',
	        render: function render() {
	          var _this5 = this;
	
	          if (this.props.dependentValues) {
	            return this.props.dependentValues.ProductType === 'Non-Fixed' ? _react2.default.createElement(
	              'span',
	              { style: { 'padding-right': '5px' } },
	              this.props.dependentValues.ReturnQuantity,
	              ' ',
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'warning',
	                  className: 'textAlignStyle',
	                  style: { height: '20px', width: '60px', padding: '0px' },
	                  disabled: !this.props.dependentValues.isSelected,
	                  onClick: function onClick() {
	                    /* var ProductNum = this.props.dependentValues.ProductNum;
	                    that.removeRow(ProductNum); */
	                    var currentWeights = {};
	                    currentWeights.Weights = [].concat(_toConsumableArray(_this5.props.dependentValues.InvoiceWeightsList));
	                    that.setState({ rowChosen: _this5.props.dependentValues.SalesInvoiceLine_id, currentWeights: currentWeights });
	                    that.openWeightModule(_this5.props.dependentValues);
	                  }
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'change' })
	              )
	            ) : _react2.default.createElement(
	              'span',
	              null,
	              this.props.dependentValues.ReturnQuantity || this.props.dependentValues.ReturnQuantity === 0 ? this.props.dependentValues.ReturnQuantity : ''
	            );
	          }
	        }
	      });
	
	      var TotalPriceFormatter = _react2.default.createClass({
	        displayName: 'TotalPriceFormatter',
	        render: function render() {
	          return that.props.params.id ? _react2.default.createElement(
	            'span',
	            null,
	            this.props.dependentValues.ProductType === 'Fixed' ? parseFloat(roundTo(this.props.dependentValues.ReturnQuantity * this.props.dependentValues.UnitPrice, 2)).toFixed(2) : parseFloat(roundTo(this.props.dependentValues.ReturnWeight * this.props.dependentValues.UnitPrice, 2)).toFixed(2)
	          ) : _react2.default.createElement(
	            'span',
	            null,
	            this.props.dependentValues.TotalPrice
	          );
	        }
	      });
	
	      var columns = !this.props.params.id ? [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 140
	        // filterable: true,
	      }, {
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	        // filterable: true,
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	        resizable: true,
	        sortable: true,
	        width: 140
	        // filterable: true,
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 160
	        // filterable: true,
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price' }),
	        resizable: true,
	        sortable: true,
	        editable: function editable(row) {
	          return (row.SalesInvoiceLine_id === null || row.SalesInvoiceLine_id === undefined) && row.isSelected;
	        },
	        width: 80,
	        // filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'LoadedQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inv_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        // filterable: true,
	        formatter: IsFixedFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'TotalNetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inv_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 80
	        // filterable: true,
	      }, {
	        key: 'ReturnedQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rtned_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 80
	        // filterable: true,
	      }].concat(_toConsumableArray(_root_url.isJML ? [{
	        key: 'jmlBox',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box' }),
	        resizable: true,
	        sortable: true,
	        width: 110
	      }, {
	        key: 'jmlPackageSize1',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pcs/box' }),
	        resizable: true,
	        sortable: true,
	        width: 110
	      }, {
	        key: 'ReturnBox',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_box' }),
	        resizable: true,
	        sortable: true,
	        editable: function editable(row) {
	          return row.ProductType !== 'Non-Fixed' && row.isSelected;
	        },
	        width: 130,
	        // filterable: true,
	        formatter: ReturnBoxFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }] : []), [{
	        key: 'ReturnQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_qty' }),
	        resizable: true,
	        sortable: true,
	        editable: function editable(row) {
	          return row.ProductType !== 'Non-Fixed' && row.isSelected && !_root_url.isJML;
	        },
	        width: 130,
	        // filterable: true,
	        formatter: ReturnFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'ReturnWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rtn_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        // filterable: true,
	        formatter: ReturnWeightFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'ReturnTotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_price' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        // filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'ReturnReason',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_reason' }),
	        resizable: true,
	        sortable: true,
	        editor: _react2.default.createElement(DropDownEditor, { options: returnReasonOptions })
	      }]) : [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 110
	        // filterable: true,
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	        resizable: true,
	        sortable: true,
	        width: 140
	        // filterable: true,
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	        // filterable: true,
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price' }),
	        resizable: true,
	        sortable: true,
	        editable: function editable(row) {
	          return (row.SalesInvoiceLine_id === null || row.SalesInvoiceLine_id === undefined) && row.isSelected;
	        },
	        width: 120,
	        // filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'InvoiceQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inv_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        // filterable: true,
	        formatter: IsFixedFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'InvoiceWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inv_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 80
	        // filterable: true,
	      }, {
	        key: 'ReturnedQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rtned_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 110
	        // filterable: true,
	      }].concat(_toConsumableArray(_root_url.isJML ? [{
	        key: 'jmlBox',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box' }),
	        resizable: true,
	        sortable: true,
	        width: 110
	      }, {
	        key: 'jmlPackageSize1',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pcs/box' }),
	        resizable: true,
	        sortable: true,
	        width: 110
	      }, {
	        key: 'ReturnBox',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_box' }),
	        resizable: true,
	        sortable: true,
	        editable: function editable(row) {
	          return row.ProductType !== 'Non-Fixed' && row.isSelected;
	        },
	        width: 130,
	        // filterable: true,
	        formatter: ReturnBoxFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }] : []), [{
	        key: 'ReturnQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_qty' }),
	        resizable: true,
	        sortable: true,
	        editable: function editable(row) {
	          return row.ProductType !== 'Non-Fixed' && row.isSelected;
	        },
	        width: 100,
	        // filterable: true,
	        formatter: ReturnFormatter2,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'ReturnWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rtn_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        // filterable: true,
	        formatter: ReturnWeightFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'ReturnTotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_price' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        // filterable: true,
	        formatter: _cashFormatter2.default
	        // formatter:  TotalPriceFormatter,
	        // getRowMetaData: (row) => row,
	      }, {
	        key: 'ReturnReason',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_reason' }),
	        resizable: true,
	        sortable: true,
	        editor: _react2.default.createElement(DropDownEditor, { options: returnReasonOptions })
	      }]);
	
	      if (isLO) {
	        var refIndex = columns.findIndex(function (column) {
	          return column.key === 'RefNum';
	        });
	        if (refIndex !== -1) {
	          columns[refIndex].name = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'item_num' });
	        }
	        var nameIndex = columns.findIndex(function (column) {
	          return column.key === 'Name';
	        });
	        if (nameIndex !== -1) {
	          columns[nameIndex].name = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' });
	        }
	        var productNumIndex = columns.findIndex(function (column) {
	          return column.key === 'ProductNum';
	        });
	        if (productNumIndex !== -1) {
	          columns.splice(productNumIndex, 1);
	        }
	        var descriptionIndex = columns.findIndex(function (column) {
	          return column.key === 'Description';
	        });
	        if (descriptionIndex !== -1) {
	          columns.splice(descriptionIndex, 1);
	        }
	      }
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { id: 'CustomerReturnForm-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'Product_id',
	              onGridSort: handleGridSort,
	              columns: columns,
	              headerRowHeight: 45,
	              rowHeight: 35,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              onRowUpdated: handleRowUpdated,
	              minHeight: this.state.tableHeight
	              // onGridRowsUpdate={() => { console.log('grid row updating'); }}
	              , enableRowSelect: 'single',
	              enableCellSelect: true,
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              }
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var createDialogInventoryStyle = {
	        height: '700px',
	        width: '1000px',
	        marginLeft: '-28%',
	        marginTop: '-20%'
	      };
	      var createDialogStyleWeight = {
	        width: '500px',
	        height: '600px',
	        top: '45%',
	        marginLeft: '-10%'
	      };
	      var selectInventoryInformation = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_inventory_information' });
	      var salesInvoiceDetail = !this.props.params.id ? this.props.salesInvoiceDetail : this.props.salesReturnDetail;
	      if (this.props.salesReturnDetail && this.props.salesReturnDetail.SRNum) {
	        salesInvoiceDetail.InvoiceNum = this.props.params.id ? this.props.salesReturnDetail.SRNum.slice(0, -1) : salesInvoiceDetail.InvoiceNum;
	      }
	      var handleSubmit = this.props.handleSubmit;
	
	      var Customer_Name = '';
	      if (salesInvoiceDetail) {
	        Customer_Name = salesInvoiceDetail.Customer_Name ? salesInvoiceDetail.Customer_Name : salesInvoiceDetail.Deliver_Customer_Name;
	      }
	      var tax = 0;
	      var total = 0;
	      var CRV = 0;
	      var finalPrice = 0;
	      for (var i = 0; i < this.state.invoice.selectedRows.length; i++) {
	        total += this.state.invoice.selectedRows[i].ReturnTotalPrice ? roundTo(parseFloat(this.state.invoice.selectedRows[i].ReturnTotalPrice), 2) : 0;
	        if (this.state.invoice.selectedRows[i].IsTaxable && this.state.invoice.selectedRows[i].ReturnTotalPrice) {
	          tax += this.state.invoice.selectedRows[i].ReturnTotalPrice ? roundTo(parseFloat(this.state.invoice.selectedRows[i].ReturnTotalPrice), 2) : 0;
	        }
	        CRV += +roundTo(parseFloat(this.state.invoice.selectedRows[i].CRV || 0) * (parseFloat(this.state.invoice.selectedRows[i].ReturnQuantity) || 0), 2).toFixed(2);
	      }
	      total = parseFloat(roundTo(total, 2)).toFixed(2);
	      CRV = parseFloat(roundTo(CRV, 2)).toFixed(2);
	
	      var discountSpread = 0;
	      var returnedSavings = 0;
	      discountSpread = this.state.invoice.Savings && this.state.invoice.TotalPrice ? this.state.invoice.Savings / this.state.invoice.TotalPrice : 0;
	      returnedSavings = parseFloat(roundTo(total * discountSpread, 2)).toFixed(2);
	
	      if (tax > 0 && tax - returnedSavings >= 0) {
	        tax = tax - returnedSavings;
	      } else {
	        tax = 0;
	      }
	      var taxr = this.state.invoice.TaxRate;
	      if (isAN && salesInvoiceDetail && salesInvoiceDetail.Reseller) {
	        taxr = 0;
	      }
	      tax *= parseFloat(taxr || 0) / 100.0;
	      tax = parseFloat(roundTo(tax, 2)).toFixed(2);
	
	      finalPrice = parseFloat(roundTo((parseFloat(total) || 0) + (parseFloat(CRV) || 0) + (parseFloat(tax) || 0) - (parseFloat(this.state.curRestock) || 0) - (parseFloat(returnedSavings) || 0), 2)).toFixed(2);
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'returns' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_return' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            !this.props.params.id ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_sales_return' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_sales_return' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          { id: 'breadcrumbButtonGroup' },
	          !this.props.params.id && _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'success',
	              disabled: this.state.invoice.selectedRows.length === 0 || this.props.salesReturnIsCreating,
	              onClick: function onClick() {
	                _this6.handleComplete(total, tax, CRV, _this6.state.curRestock, finalPrice, _this6.state.curNotation, true, returnedSavings);
	              }
	            },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement('em', { className: 'fa fa-check' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'redeliver' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'success',
	              disabled: this.state.invoice.selectedRows.length === 0 || this.props.salesReturnIsCreating,
	              onClick: function onClick() {
	                _this6.handleComplete(total, tax, CRV, _this6.state.curRestock, finalPrice, _this6.state.curNotation, false, returnedSavings);
	              }
	            },
	            !this.props.params.id ? _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement('em', { className: 'fa fa-check' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'complete_return' })
	            ) : _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement('em', { className: 'fa fa-save' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'danger',
	              type: 'button',
	              onClick: function onClick() {
	                _this6.props.params.id ? _this6.context.router.push('/inventoryReturn') : _this6.context.router.push('/customerReturn');
	              }
	            },
	            _react2.default.createElement('em', { className: 'fa fa-close' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'sales-customer-return-form' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 8 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 3 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'h3',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 6 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                          ':'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 6 },
	                        Customer_Name
	                      )
	                    )
	                  ),
	                  salesInvoiceDetail && salesInvoiceDetail.SalesInvoice_id ? _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 3 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'h3',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 2 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' }),
	                          ':'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7 },
	                        salesInvoiceDetail && salesInvoiceDetail.InvoiceNum
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 2 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	                          ':'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7 },
	                        salesInvoiceDetail && salesInvoiceDetail.Sales_User_Name
	                      )
	                    )
	                  ) : _react2.default.createElement(_reactBootstrap.Col, { xs: 3 }),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 3 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'h3',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit_invoice' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 4 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' }),
	                          ':'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 8 },
	                        this.renderCreditInvoice(this.props.unpaidInvoices)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 3 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'h3',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 5 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' }),
	                          ':'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7 },
	                        salesInvoiceDetail && salesInvoiceDetail.SRNum ? salesInvoiceDetail && salesInvoiceDetail.SRNum : salesInvoiceDetail && salesInvoiceDetail.InvoiceNum + 'R'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 5 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_date' }),
	                          ':'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'PostingDate', selected: (0, _moment2.default)().format('MM-DD-YY'), component: _datePicker.StartOfThisMonthDatePicker })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 5 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'user' }),
	                          ':'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7 },
	                        salesInvoiceDetail && salesInvoiceDetail.Modifier_User_Name /* right? */
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_details' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'label',
	                          { style: { display: 'inline-flex' } },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total' }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            ' $$'
	                          ),
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'ReturnTotal', component: _inputField.DisabledInputField, placeholder: total })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'crv' }),
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'CRV', component: _inputField.DisabledInputField, placeholder: CRV })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'Tax', component: _inputField.DisabledInputField, placeholder: tax })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 3 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount' }),
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'Savings', component: _inputField.DisabledInputField, placeholder: '-' + returnedSavings })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'label',
	                          { style: { display: 'inline-flex' } },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final' }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            ' $$'
	                          ),
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'FinalTotal', component: _inputField.DisabledInputField, placeholder: finalPrice })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { style: { marginTop: '10px' } },
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 4 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'restocking_fee' }),
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(_reactBootstrap.Input, { name: 'curRestock', type: 'number', onChange: this.handleRestock, value: this.state.curRestock })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 7 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(_reactBootstrap.Input, { name: 'curNotation', type: 'text', onChange: this.handleNotation, value: this.state.curNotation })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                null,
	                this.renderInvoice()
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogStyleWeight,
	            isVisible: this.state.ReturnModalOpen,
	            onCloseClicked: function onCloseClicked() {
	              _this6.closeReturnModal();
	            },
	            title: 'Return Products'
	          },
	          _react2.default.createElement(_returnModal2.default, {
	            invoice: true,
	            setWeights: this.setWeights,
	            keepLoaded: function keepLoaded() {},
	            currentWeights: this.state.currentWeights,
	            allWeights: this.state.invoiceWeightsList,
	            closeC: this.closeReturnModal,
	            rowChosen: this.state.rowChosen,
	            returnTotalWeight: this.returnTotalWeight.bind(this) })
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogInventoryStyle,
	            isVisible: this.state.showInventoryOpen,
	            onCloseClicked: function onCloseClicked() {
	              _this6.closeShowInventory('productSearch');
	            },
	            title: selectInventoryInformation
	          },
	          _react2.default.createElement(_salesInventoryInfo2.default, {
	            Customer_id: this.state.currentCustomer_id,
	            SearchType: this.props.searchType,
	            SearchValue: this.props.searchValue,
	            closeShowInventory: this.closeShowInventory,
	            selectInventoryInfo: this.selectInventoryInfo,
	            setSaleRowValue: this.props.setSaleRowValue,
	            setAllProductQuantity: this.setAllProductQuantity,
	            formName: 'customerReturnForm'
	          })
	        )
	      );
	    }
	  }]);
	
	  return CustomerReturnForm;
	}(_react.Component);
	
	CustomerReturnForm.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	var renderTypeRadios = function renderTypeRadios(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group', id: 'search-product-by' },
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-3 search-by-max-width' },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'search_by' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'ProductNum',
	        checked: props.input.value === 'ProductNum'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'RefNum',
	        checked: props.input.value === 'RefNum'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'Name',
	        checked: props.input.value === 'Name'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'Description',
	        checked: props.input.value === 'Description'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	    )
	  );
	};
	
	var _default = CustomerReturnForm;
	exports.default = _default;
	
	
	function roundTo(n, digits) {
	  if (digits === undefined) {
	    digits = 0;
	  }
	
	  var multiplicator = Math.pow(10, digits);
	  n = parseFloat((n * multiplicator).toFixed(11));
	  var test = Math.round(n) / multiplicator;
	  return +test.toFixed(2);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(DropDownEditor, 'DropDownEditor', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerReturnForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isNumeric, 'isNumeric', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerReturnForm.jsx');
	
	  __REACT_HOT_LOADER__.register(roundTo, 'roundTo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerReturnForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isHMM, 'isHMM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerReturnForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isLO, 'isLO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerReturnForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isAN, 'isAN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerReturnForm.jsx');
	
	  __REACT_HOT_LOADER__.register(CustomerReturnForm, 'CustomerReturnForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerReturnForm.jsx');
	
	  __REACT_HOT_LOADER__.register(renderTypeRadios, 'renderTypeRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerReturnForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/customerReturnForm.jsx');
	}();

	;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _constants = __webpack_require__(11);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _dateFormat = __webpack_require__(39);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _root_url = __webpack_require__(9);
	
	var _dateFilterRadios = __webpack_require__(49);
	
	var _dateFilterRadios2 = _interopRequireDefault(_dateFilterRadios);
	
	var _cleanDates = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InventoryReturn = function (_Component) {
	  _inherits(InventoryReturn, _Component);
	
	  function InventoryReturn() {
	    _classCallCheck(this, InventoryReturn);
	
	    var _this = _possibleConstructorReturn(this, (InventoryReturn.__proto__ || Object.getPrototypeOf(InventoryReturn)).call(this));
	
	    _this.setToRangeSearch = function () {
	      _this.setState({ days: '-1' });
	    };
	
	    _this.renderExportButton = function () {
	      var _this$state = _this.state,
	          fromDate = _this$state.fromDate,
	          toDate = _this$state.toDate;
	
	
	      var dates = (0, _cleanDates.toFromDates)(_this.state.days, fromDate, toDate);
	      var token = 'Bearer=' + localStorage.getItem('token');
	      var url = _root_url.ROOT_URL + 'v1/sale/sales_return/?PostingDate__gte=' + dates.fromDate + '&PostingDate__lte=' + dates.toDate + '&format=csv&' + token;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          href: url,
	          disabled: false
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'export' })
	      );
	    };
	
	    _this.renderExportLineButton = function () {
	      var _this$state2 = _this.state,
	          fromDate = _this$state2.fromDate,
	          toDate = _this$state2.toDate;
	
	
	      var dates = (0, _cleanDates.toFromDates)(_this.state.days, fromDate, toDate);
	      var token = 'Bearer=' + localStorage.getItem('token');
	      var url = _root_url.ROOT_URL + 'v1/sale/sales_return/export_line/?PostingDate__gte=' + dates.fromDate + '&PostingDate__lte=' + dates.toDate + '&format=csv&' + token;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          href: url,
	          disabled: false
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'export_line' })
	      );
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	      invoice: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      details: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      selectedRows: null,
	      editedRows: [],
	      filters: {},
	      sortColumn: null,
	      sortDirection: null,
	
	      days: '7',
	      fromDate: undefined,
	      toDate: undefined
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.checkAuthorize = _this.checkAuthorize.bind(_this);
	    _this.openCheckAuthorize = _this.openCheckAuthorize.bind(_this);
	    _this.closeCheckAuthorize = _this.closeCheckAuthorize.bind(_this);
	    _this.setToDate = _this.setToDate.bind(_this);
	    _this.setFromDate = _this.setFromDate.bind(_this);
	    _this.handleDaysFilterChange = _this.handleDaysFilterChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(InventoryReturn, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      window.addEventListener('resize', this.handleResize);
	      var _state = this.state,
	          fromDate = _state.fromDate,
	          toDate = _state.toDate,
	          days = _state.days;
	      // this.props.setDefaultDays("inventoryReturn");
	
	      this.props.fetchInventoryReturns(fromDate, toDate, days);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
	        this.closeCheckAuthorize();
	        if (this.state.action === 'void') {
	          this.voidReturn();
	        }
	      }
	      if (nextProps.inventoryReturn && nextProps.inventoryReturn !== this.props.inventoryReturn) {
	        var invoice = _extends({}, this.state.invoice, { rows: nextProps.inventoryReturn });
	        this.setState({ invoice: invoice });
	      }
	      if (nextProps.inventoryReturnDetails && nextProps.inventoryReturnDetails !== this.props.inventoryReturnDetails) {
	        var details = _extends({}, this.state.details, { rows: nextProps.inventoryReturnDetails.Sales_Return_Line });
	        this.setState({ details: details });
	      }
	      if (nextProps.updated) {
	        this.context.router.push('/inventoryReturn/');
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'setToDate',
	    value: function setToDate(e) {
	      if (e < this.state.fromDate) {
	        return;
	      }
	      this.setState({ toDate: e });
	    }
	  }, {
	    key: 'setFromDate',
	    value: function setFromDate(e) {
	      if (e > this.state.toDate) {
	        return;
	      }
	      this.setState({ fromDate: e });
	    }
	  }, {
	    key: 'handleDaysFilterChange',
	    value: function handleDaysFilterChange(Days) {
	      var _this2 = this;
	
	      var _state2 = this.state,
	          fromDate = _state2.fromDate,
	          toDate = _state2.toDate;
	
	      this.setState({ days: Days }, function () {
	        _this2.props.fetchInventoryReturns(fromDate, toDate, Days);
	      });
	    }
	  }, {
	    key: 'checkAuthorize',
	    value: function checkAuthorize(password) {
	      this.props.checkPassword(password);
	    }
	  }, {
	    key: 'openCheckAuthorize',
	    value: function openCheckAuthorize(action) {
	      this.props.clearCheckPassword();
	      this.setState({ checkAuthorizeOpen: true, action: action });
	    }
	  }, {
	    key: 'closeCheckAuthorize',
	    value: function closeCheckAuthorize() {
	      this.setState({ checkAuthorizeOpen: false });
	    }
	  }, {
	    key: 'voidReturn',
	    value: function voidReturn() {
	      this.props.voidReturn(this.state.invoice.selectedRows[0].SalesReturn_id);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	    }
	  }, {
	    key: 'shouldDisableVoidButton',
	    value: function shouldDisableVoidButton() {
	      var selectedRows = this.state.invoice.selectedRows;
	
	      if (selectedRows.length > 0 && selectedRows[0].ReturnStatus === 'Released' && (selectedRows[0].CreditStatus === 'Credit' || selectedRows[0].CreditStatus === 'N/A') || !(0, _permissions2.default)('delete_sales_return')) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'shouldDisableEditButton',
	    value: function shouldDisableEditButton() {
	      var selectedRows = this.state.invoice.selectedRows;
	
	      if (selectedRows.length > 0 && selectedRows[0].ReturnStatus === 'Released' && (selectedRows[0].CreditStatus === 'Credit' || selectedRows[0].CreditStatus === 'N/A') || !(0, _permissions2.default)('change_sales_return')) {
	        return false;
	      }
	      return true;
	    }
	
	    // Once priceLevels are ready, reset state.
	
	  }, {
	    key: 'updateRows',
	    value: function updateRows(e) {
	      e.preventDefault();
	      this.props.editInventoryReturns(this.state.editedRows);
	    }
	
	    // formatDate(date) {
	    //   if (!date) {
	    //     return;
	    //   }
	    //   let formattedDate = `${date.getFullYear()}-`;
	    //   formattedDate += `${date.getMonth() + 1}-`;
	    //   if (date.getDate() < 10) {
	    //     formattedDate += `0${date.getDate()}`;
	    //   } else {
	    //     formattedDate += date.getDate();
	    //   }
	    //   return formattedDate;
	    // }
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this3 = this;
	
	      if (this.props.inventoryReturnIsLoading && !this.props.inventoryReturnError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } // else if (this.props.inventoryReturnError) {
	      //   return (
	      //     <ContentWrapper>
	      //       <div className="alert alert-danger">
	      //         {JSON.stringify(this.props.inventoryReturnError)}
	      //       </div>
	      //     </ContentWrapper>
	      //   );
	      // }
	      // else {
	      // Parameters of the react-data-grid
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.invoice);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var invoice = Object.assign({}, _this3.state.invoice, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this3.setState({
	          invoice: invoice
	        });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this3.state.invoice.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var invoice = _extends({}, _this3.state.invoice, { filters: newFilters });
	        _this3.setState({ invoice: invoice });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var allRows = _this3.state.invoice.rows;
	        var newRows = getRows();
	        allRows.map(function (r) {
	          if (r === rows) {
	            r.isSelected = true;
	          }
	          r.isSelected = false;
	        });
	        var curRow = {};
	        rows.map(function (r) {
	          curRow = newRows[r.rowIdx];
	          newRows[r.rowIdx].isSelected = true;
	        });
	        var selectedRows = [];
	        selectedRows = selectedRows.concat(rows.map(function (r) {
	          return r.row;
	        }));
	        var invoice = _extends({}, _this3.state.invoice, { rows: allRows, selectedRows: selectedRows });
	        _this3.setState({ invoice: invoice });
	        _this3.props.fetchInventoryReturnsDetails(curRow.SalesReturn_id);
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = _this3.state.invoice.rows;
	        var curRow = false;
	        rows.map(function (r) {
	          curRow = newRows[r.rowIdx];
	          newRows[r.rowIdx].isSelected = false;
	        });
	        _this3.setState({ isSelected: false, curRow: curRow });
	        var selectedRows = [];
	        var invoice = _extends({}, _this3.state.invoice, { rows: newRows, selectedRows: selectedRows });
	        _this3.setState({ invoice: invoice });
	      };
	
	      var columns = [{
	        key: 'SRNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rtn_no' }),
	        resizable: true,
	        width: 150,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'Deliver_Customer_Num',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	        resizable: true,
	        width: 130,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'Deliver_Customer_Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_name' }),
	        resizable: true,
	        width: 180,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'PostingDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_date' }),
	        resizable: true,
	        width: 126,
	        sortable: true,
	        filterable: true,
	        formatter: _dateFormat.DateFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'ReturnStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_status' }),
	        resizable: true,
	        width: 140,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'RestockStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'restock_status' }),
	        resizable: true,
	        width: 150,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'CreditStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit_status' }),
	        resizable: true,
	        width: 135,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'FinalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final' }),
	        resizable: true,
	        width: 80,
	        sortable: true,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'UnusedCredit',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' }),
	        resizable: true,
	        width: 100,
	        sortable: true,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'Note',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        width: 200,
	        sortable: true,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '100%', height: '300px' }, id: 'InventoryReturn-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'SalesReturnLine_id',
	              enableCellSelect: true,
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              columns: columns,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: 250,
	              rowHeight: 25,
	              enableRowSelect: 'single',
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              }
	            })
	          )
	        )
	      );
	      // }
	    }
	  }, {
	    key: 'renderDetails',
	    value: function renderDetails() {
	      var _this4 = this;
	
	      if (this.props.inventoryReturnDetailsIsLoading && !this.props.inventoryReturnDetailsError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } // else if (this.props.inventoryReturnDetailsError) {
	      //   return (
	      //     <ContentWrapper>
	      //       <div className="alert alert-danger">
	      //         {JSON.stringify(this.props.inventoryReturnDetailsError)}
	      //       </div>
	      //     </ContentWrapper>
	      //   );
	      // }
	      // Parameters of the react-data-grid
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.details);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var details = Object.assign({}, _this4.state.details, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this4.setState({
	          details: details
	        });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this4.state.details.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var details = _extends({}, _this4.state.details, { filters: newFilters });
	        _this4.setState({ details: details });
	      };
	
	      var IsFixedFormatter = _react2.default.createClass({
	        displayName: 'IsFixedFormatter',
	        render: function render() {
	          if (this.props.dependentValues.ProductType === 'Non-Fixed') {
	            return _react2.default.createElement(
	              'span',
	              null,
	              this.props.value,
	              _react2.default.createElement(
	                'label',
	                { className: 'label label-success' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'non_fixed' })
	              )
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            this.props.value
	          );
	        }
	      });
	
	      // Column difinition
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _moment2.default.utc(this.props.dependentValues.CreateTime).local().format('YYYY-MM-DD')
	          );
	        }
	      });
	
	      var columns = [{
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	        resizable: true,
	        width: 280,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        width: 130,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_no' }),
	        resizable: true,
	        width: 100,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price' }),
	        resizable: true,
	        width: 80,
	        sortable: true,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'ReturnQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_qty' }),
	        resizable: true,
	        width: 80,
	        sortable: true,
	        filterable: true,
	        formatter: IsFixedFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'ReturnWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rtn_wt' }),
	        resizable: true,
	        width: 80,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'ReturnTotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total' }),
	        resizable: true,
	        width: 80,
	        sortable: true,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: 'ReturnReason',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_reason' }),
	        resizable: true,
	        width: 140,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'RestockQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'restock_qty' }),
	        resizable: true,
	        width: 120,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'RestockWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'restock_wt' }),
	        resizable: true,
	        width: 120,
	        sortable: true,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '100%', height: '300px' }, id: 'InventoryReturn-dataGrid2' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'SalesReturnLine_id',
	              enableCellSelect: true,
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              columns: columns,
	              headerRowHeight: 45,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: 250,
	              rowHeight: 25
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderPrintButton',
	    value: function renderPrintButton() {
	      var selectedRows = this.state.invoice.selectedRows;
	
	      var disabled = selectedRows && selectedRows.length !== 1;
	
	      var _ref = selectedRows && selectedRows.length === 1 && selectedRows[0],
	          salesReturnID = _ref.SalesReturn_id;
	
	      var token = 'Bearer=' + localStorage.getItem('token');
	      var url = _root_url.ROOT_URL + 'v1/sale/printreturn/' + salesReturnID + '?' + token;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          href: url,
	          disabled: disabled
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	      );
	    }
	  }, {
	    key: 'renderNoPriceButton',
	    value: function renderNoPriceButton() {
	      var selectedRows = this.state.invoice.selectedRows;
	
	      var disabled = selectedRows && selectedRows.length !== 1;
	
	      var _ref2 = selectedRows && selectedRows.length === 1 && selectedRows[0],
	          salesReturnID = _ref2.SalesReturn_id;
	
	      var token = 'Bearer=' + localStorage.getItem('token');
	      var url = _root_url.ROOT_URL + 'v1/sale/printreturn_no_price/' + salesReturnID + '?' + token;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          href: url,
	          disabled: disabled
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no_price' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var createDialogStyle = {
	        width: '550px',
	        height: '300px',
	        marginLeft: '-15%'
	      };
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'returns' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_return' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'inventory-return' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { id: 'date-range-picker', className: 'form-horizontal' },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 1 },
	                    _react2.default.createElement(
	                      'h3',
	                      { className: 'filter-title text-nowrap' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_date' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'colon' },
	                        ':'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 11 },
	                    (0, _dateFilterRadios2.default)({
	                      handleOnClick: this.handleDaysFilterChange,
	                      setFromDate: this.setFromDate,
	                      setToDate: this.setToDate,
	                      setToRangeSearch: this.setToRangeSearch,
	                      FromDate: this.state.fromDate,
	                      ToDate: this.state.toDate,
	                      Days: this.state.days
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { className: 'position-relative table-collapse-fix', style: { height: '350px' } },
	                _react2.default.createElement(
	                  _reactBootstrap.ButtonToolbar,
	                  { className: 'table-buttons' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                      bsStyle: 'warning',
	                      type: 'submit',
	                      onClick: function onClick() {
	                        _this5.context.router.push('/customerReturn/' + _this5.state.invoice.selectedRows[0].SalesReturn_id);
	                      },
	                      disabled: false
	                    },
	                    _react2.default.createElement('em', { className: 'fa fa-edit' }),
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                      bsStyle: 'primary',
	                      type: 'submit',
	                      onClick: function onClick() {
	                        // this.props.completeReturn(this.state.invoice.selectedRows[0].SalesReturn_id)
	                        _this5.context.router.push('/restockReturn/' + _this5.state.invoice.selectedRows[0].SalesReturn_id);
	                      },
	                      disabled: this.state.invoice.selectedRows.length === 0 || this.state.invoice.selectedRows[0].RestockStatus !== 'Restock' || !(0, _permissions2.default)('change_sales_return')
	                    },
	                    _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'restock' })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                      bsStyle: 'danger',
	                      type: 'submit',
	                      onClick: function onClick() {
	                        _this5.openCheckAuthorize('void');
	                      },
	                      disabled: this.shouldDisableVoidButton()
	                    },
	                    _react2.default.createElement('em', { className: 'fa fa-trash' }),
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'void' })
	                  ),
	                  this.renderPrintButton(),
	                  this.renderNoPriceButton(),
	                  this.renderExportButton(),
	                  _root_url.isElegant && this.renderExportLineButton()
	                ),
	                this.renderTable()
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { className: 'position-relative table-collapse-fix', style: { height: '360px' } },
	                this.renderDetails()
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 2 },
	              this.props.inventoryReturnIsEditing && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_spinner2.default, null),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'uploading' })
	              ),
	              this.props.inventoryReturnEdited && _react2.default.createElement(
	                'div',
	                { className: 'alert alert-success' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saved' })
	              ),
	              this.props.editInventoryReturnError && _react2.default.createElement(
	                'div',
	                { className: 'alert alert-danger marginTopStyle' },
	                this.props.editInventoryReturnError
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogStyle,
	            isVisible: this.state.checkAuthorizeOpen,
	            onCloseClicked: this.closeCheckAuthorize
	          },
	          _react2.default.createElement(_confirmActionModal2.default, {
	            'case': 'confirmPassword',
	            closeC: this.checkAuthorize,
	            checkPasswordFailure: this.props.checkPasswordFailure
	          })
	        )
	      );
	    }
	  }]);
	
	  return InventoryReturn;
	}(_react.Component);
	
	InventoryReturn.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = InventoryReturn;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(InventoryReturn, 'InventoryReturn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/inventoryReturn.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/inventoryReturn.jsx');
	}();

	;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reduxForm = __webpack_require__(3);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _inputField = __webpack_require__(16);
	
	var _datePicker = __webpack_require__(27);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _salesInventoryInfo = __webpack_require__(77);
	
	var _salesInventoryInfo2 = _interopRequireDefault(_salesInventoryInfo);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _returnModal = __webpack_require__(122);
	
	var _returnModal2 = _interopRequireDefault(_returnModal);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AutoCompleteEditor = _reactDataGridAddons.Editors.AutoComplete;
	
	function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	var RestockReturnForm = function (_Component) {
	  _inherits(RestockReturnForm, _Component);
	
	  function RestockReturnForm() {
	    _classCallCheck(this, RestockReturnForm);
	
	    var _this = _possibleConstructorReturn(this, (RestockReturnForm.__proto__ || Object.getPrototypeOf(RestockReturnForm)).call(this));
	
	    _this.closeReturnModal = function () {
	      _this.setState({ ReturnModalOpen: false, IsWeight: false });
	    };
	
	    _this.openWeightModule = function () {
	      _this.setState({ ReturnModalOpen: true, IsWeight: true });
	    };
	
	    _this.openQuantityModule = function () {
	      _this.setState({ ReturnModalOpen: true, IsWeight: false });
	    };
	
	    _this.setWeights = function (currentRow, currentWeights, currentTotalWeight) {
	      // let backLogWeights = [...this.state.backLogWeights];
	      // let newEntry = { currentRow, currentWeights };
	      // backLogWeights.push(newEntry);
	      // this.setState({backLogWeights});
	      // console.log("ready to save", currentRow, currentWeights, currentTotalWeight);
	      var invoice = _extends({}, _this.state.invoice);
	      var RestockWeightsList = [];
	      for (var k = 0; k < currentWeights.length; k++) {
	        if (currentWeights[k].isSelected) RestockWeightsList.push(currentWeights[k].Weight);
	      }
	      for (var i = 0; i < _this.state.invoice.rows.length; i++) {
	        if (currentRow === _this.state.invoice.rows[i].SalesOrderLine_id || currentRow === _this.state.invoice.rows[i].SalesInvoiceLine_id) {
	          invoice.rows[i].RestockWeight = parseFloat(currentTotalWeight);
	          invoice.rows[i].RestockQuantity = RestockWeightsList.length;
	          invoice.rows[i].RestockWeightsList = [].concat(RestockWeightsList);
	        }
	      }
	      _this.setState({ invoice: invoice });
	    };
	
	    _this.handleComplete = function () {
	      _this.props.completeReturn(_this.props.params.id, _this.state.invoice.selectedRows);
	    };
	
	    _this.handleRestock = function (e) {
	      if (typeof parseFloat(e.target.value, 10) !== 'NaN' && e.target.value !== '') {
	        var curRestock = e.target.value;
	        var invoice = _extends({}, _this.state.invoice);
	        _this.setState({ curRestock: curRestock, invoice: invoice });
	      } else if (e.target.value === '') {
	        _this.setState({ curRestock: '' });
	      }
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	      invoice: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      totalPrice: 0,
	
	      showInventoryOpen: false,
	      currentCustomer_id: null,
	      selectedInventoryRow: {},
	      curRow: '',
	      curTotal: 0,
	      curCRV: 0,
	      curTax: 0,
	      curRestock: 0,
	      curFinal: 0,
	      ReturnFormatter: false,
	      IsWeight: false,
	      rowChosen: null,
	      currentWeights: null,
	      backLogWeights: []
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    return _this;
	  }
	
	  _createClass(RestockReturnForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // console.log("props", this.props);
	      if (!this.props.params.id) {
	        if (!this.props.currentCustomer) {
	          this.context.router.push('/customerReturn/');
	        } else {
	          this.setState({ currentCustomer_id: this.props.currentCustomer.id });
	        }
	      } else {
	        this.props.fetchSalesReturnDetail(this.props.params.id);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.handleResize);
	      var currentSalesInvoice = this.props.currentSalesInvoice;
	
	
	      if (!currentSalesInvoice && this.props.currentCustomer) {
	        this.props.fetchCustomerItem(this.props.currentCustomer.value);
	      } else if ((typeof currentSalesInvoice === 'undefined' ? 'undefined' : _typeof(currentSalesInvoice)) == "object" && currentSalesInvoice && currentSalesInvoice.SalesReturn_id != null) {
	        this.props.fetchSalesReturnDetail(currentSalesInvoice.SalesReturn_id);
	      } else if ((typeof currentSalesInvoice === 'undefined' ? 'undefined' : _typeof(currentSalesInvoice)) == "object" && currentSalesInvoice) this.props.fetchSalesInvoiceCompletedDetail(currentSalesInvoice.SalesInvoice_id);else if (currentSalesInvoice) this.props.fetchSalesInvoiceCompletedDetail(currentSalesInvoice, "InvoiceNum");
	      // this.props.fetchSalesInvoice("1900-01-01", "3000-01-01", null, 7);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.salesReturnDetail && this.props.params.id && nextProps.salesReturnDetail != this.props.salesReturnDetail) {
	        var selectedRows = [].concat(_toConsumableArray(nextProps.salesReturnDetail.Sales_Return_Line));
	        for (var i = 0; i < selectedRows.length; i++) {
	          selectedRows[i].isSelected = true;
	        }
	        var invoice = _extends({}, this.state.invoice, { rows: selectedRows, selectedRows: selectedRows, TaxRate: nextProps.salesReturnDetail.TaxRate });
	        this.setState({ invoice: invoice, curRestock: nextProps.salesReturnDetail.RestockingFee });
	      }
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      var formattedDate = date.getFullYear() + '-';
	
	      formattedDate += date.getMonth() + 1 + '-';
	      if (date.getDate() < 10) {
	        formattedDate += '0' + date.getDate();
	      } else {
	        formattedDate += date.getDate();
	      }
	      return formattedDate;
	    }
	  }, {
	    key: 'returnTotalWeight',
	    value: function returnTotalWeight(totalWeight) {
	      // console.log("this is the return weight", totalWeight);
	    }
	  }, {
	    key: 'renderInvoice',
	    value: function renderInvoice() {
	      var _this2 = this;
	
	      var that = this;
	      if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.error)
	        )
	      );else {
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.invoice);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var invoice = _extends({}, _this2.state.invoice, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this2.setState({ invoice: invoice });
	        };
	
	        var handleRowUpdated = function handleRowUpdated(e) {
	          // console.log("checking out rowUpdateS", e);
	          var rows = getRows(); //this.state.invoice.rows;
	          var returnQuantity = parseFloat(rows[e.rowIdx].ReturnQuantity) || 0;
	          if (_root_url.isJML && e.cellKey === 'RestockBox') {
	            var RestockQuantity = e.updated.RestockBox ? e.updated.RestockBox * rows[e.rowIdx].jmlPackageSize1 : '';
	            var RestockBox = e.updated.RestockBox;
	            if (Number(e.updated.RestockBox || 0) > Number(rows[e.rowIdx].ReturnBox)) {
	              RestockBox = Number(rows[e.rowIdx].ReturnBox);
	              RestockQuantity = Number(rows[e.rowIdx].ReturnBox) * rows[e.rowIdx].jmlPackageSize1;
	            }
	            Object.assign(rows[e.rowIdx], _extends({}, e.updated, { RestockQuantity: RestockQuantity, RestockBox: RestockBox }));
	            e.cellKey = 'RestockQuantity';
	            e.updated.RestockQuantity = RestockQuantity;
	          } else {
	            Object.assign(rows[e.rowIdx], e.updated);
	          }
	          if (e.cellKey == "ReturnQuantity" && _this2.state.invoice.rows[e.rowIdx].ProductType === 'Fixed') {
	            var invoice = _extends({}, _this2.state.invoice);
	            if (invoice.rows[e.rowIdx].Quantity < e.updated.ReturnQuantity) invoice.rows[e.rowIdx].ReturnQuantity = invoice.rows[e.rowIdx].Quantity;else invoice.rows[e.rowIdx].ReturnQuantity = e.updated.ReturnQuantity;
	            if (invoice.rows[e.rowIdx].InvoiceQuantity < e.updated.ReturnQuantity) invoice.rows[e.rowIdx].ReturnQuantity = invoice.rows[e.rowIdx].InvoiceQuantity;else invoice.rows[e.rowIdx].ReturnQuantity = e.updated.ReturnQuantity;
	            if (e.updated.ReturnQuantity < 0) invoice.rows[e.rowIdx].ReturnQuantity = 0;
	            invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(e.updated.ReturnQuantity * invoice.rows[e.rowIdx].UnitPrice, 2)).toFixed(2);
	            if (_this2.props.params.id) invoice.rows[e.rowIdx].ReturnCRV = parseFloat(roundTo(invoice.rows[e.rowIdx].CRV / invoice.rows[e.rowIdx].InvoiceQuantity * e.updated.ReturnQuantity, 2)).toFixed(2);else invoice.rows[e.rowIdx].ReturnCRV = parseFloat(roundTo(invoice.rows[e.rowIdx].CRV / invoice.rows[e.rowIdx].Quantity * e.updated.ReturnQuantity, 2)).toFixed(2);
	            _this2.setState({ invoice: invoice });
	          } else if (e.cellKey == "ReturnQuantity" && _this2.props.params.id) {
	            var _invoice = _extends({}, _this2.state.invoice);
	            var currentWeights = {};
	            currentWeights.Weights = _invoice.rows[e.rowIdx].InvoiceWeightsList;
	            that.setState({ rowChosen: _invoice.rows[e.rowIdx].SalesOrderLine_id, currentWeights: currentWeights });
	            that.openWeightModule(_invoice.rows[e.rowIdx]);
	          }
	          if (e.cellKey == "RestockQuantity" && _this2.state.invoice.rows[e.rowIdx].ProductType === 'Fixed') {
	            var _invoice2 = _extends({}, _this2.state.invoice);
	            if (_invoice2.rows[e.rowIdx].ReturnQuantity < e.updated.RestockQuantity) _invoice2.rows[e.rowIdx].RestockQuantity = _invoice2.rows[e.rowIdx].ReturnQuantity;else _invoice2.rows[e.rowIdx].RestockQuantity = e.updated.RestockQuantity;
	            if (parseFloat(e.updated.RestockQuantity) < 0) _invoice2.rows[e.rowIdx].RestockQuantity = 0;
	            _invoice2.rows[e.rowIdx].RestockQuantity = _root_url.isAN ? parseFloat(e.updated.RestockQuantity) : Math.trunc(_invoice2.rows[e.rowIdx].RestockQuantity);
	            _invoice2.rows[e.rowIdx].RestockWeight = _invoice2.rows[e.rowIdx].ReturnWeight / _invoice2.rows[e.rowIdx].ReturnQuantity * _invoice2.rows[e.rowIdx].RestockQuantity;
	            // console.log("invoice weight", { check: invoice.rows[e.rowIdx].RestockWeight, totalWeight: invoice.rows[e.rowIdx].ReturnWeight, ReturnQuantity: invoice.rows[e.rowIdx].ReturnQuantity});
	            _this2.setState({ invoice: _invoice2 });
	          }
	          if (e.cellKey == "ReturnReason") {
	            var _invoice3 = _extends({}, _this2.state.invoice);
	            _invoice3.rows[e.rowIdx].ReturnReason = e.updated.ReturnReason;
	            _this2.setState({ invoice: _invoice3 });
	          }
	        };
	
	        var returnReasonOptions = [{ id: 0, title: 'Damaged' }, { id: 1, title: 'Defective' }, { id: 2, title: 'Not Needed' }, { id: 3, title: 'Repair' }, { id: 4, title: 'Wrong Item' }, { id: 5, title: 'Other' }, { id: 6, title: 'Missing' }, { id: 7, title: 'Out' }, { id: 8, title: 'Short' }];
	
	        var ReasonEditor = _react2.default.createElement(AutoCompleteEditor, { options: returnReasonOptions });
	
	        var IsVariableFormatter = _react2.default.createClass({
	          displayName: 'IsVariableFormatter',
	          render: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  className: 'textAlignStyle', style: { height: '23px', width: '39px', padding: '0px' },
	                  onClick: function onClick() {
	                    var ProductNum = _this3.props.dependentValues.ProductNum;
	                    that.removeRow(ProductNum);
	                  } },
	                'X'
	              )
	            );
	          }
	        });
	
	        var onRowsSelected = function onRowsSelected(rows) {
	          // console.log("Row Seleced", this.state, rows);
	          var newRows = _this2.state.invoice.rows;
	          // for (let i = 0; i < newRows.length; i++) {
	          //    newRows[i].isSelected = false;
	          // }
	          var curRow = false;
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = true;
	            if (!newRows[r.rowIdx].Restock) newRows[r.rowIdx].Restock = 0;
	          });
	          var selectedRows = [].concat(_toConsumableArray(_this2.state.invoice.selectedRows));
	          selectedRows = selectedRows.concat(rows.map(function (r) {
	            return r.row;
	          }));
	          var invoice = _extends({}, _this2.state.invoice, { rows: newRows, selectedRows: selectedRows });
	          _this2.setState({
	            invoice: invoice
	          });
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          var newRows = _this2.state.invoice.rows;
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = false;
	          });
	          var selectedRows = [].concat(_toConsumableArray(_this2.state.invoice.selectedRows));
	          selectedRows = selectedRows.filter(function (obj) {
	            return obj.isSelected == true;
	          });
	          var invoice = _extends({}, _this2.state.invoice, { rows: newRows, selectedRows: selectedRows });
	          _this2.setState({
	            invoice: invoice
	          });
	        };
	        // let reasonEditor = <DropDownEditor options={returnReasonOptions} />;
	        // let reasonFormattor = <DropDownFormatter options={returnReasonOptions} value='bug' />;
	
	        var IsFixedFormatter = _react2.default.createClass({
	          displayName: 'IsFixedFormatter',
	          render: function render() {
	            // console.log("Hello moto",this.props)
	            if (this.props.dependentValues.ProductType === "Non-Fixed") {
	              return _react2.default.createElement(
	                'span',
	                null,
	                this.props.value,
	                ' ',
	                _react2.default.createElement(
	                  'label',
	                  { className: 'label label-success' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'non_fixed' })
	                )
	              );
	            } else {
	              return _react2.default.createElement(
	                'span',
	                null,
	                this.props.value
	              );
	            }
	          }
	        });
	
	        var ReturnWeightFormatter = _react2.default.createClass({
	          displayName: 'ReturnWeightFormatter',
	          render: function render() {
	            // return (
	            //   (this.props.dependentValues.ProductType === 'Non-Fixed') ?
	            //     <span>{(this.props.dependentValues.ReturnWeight ||  this.props.dependentValues.ReturnWeight === 0) ? this.props.dependentValues.ReturnWeight : ''}</span> :
	            //     <span style={{color: 'gray'}}>N/A</span>
	            // );
	            return _react2.default.createElement(
	              'span',
	              null,
	              this.props.dependentValues.ReturnWeight || this.props.dependentValues.ReturnWeight === 0 ? this.props.dependentValues.ReturnWeight : ''
	            );
	          }
	        });
	
	        var RestockWeightFormatter = _react2.default.createClass({
	          displayName: 'RestockWeightFormatter',
	          render: function render() {
	            return _react2.default.createElement(
	              'span',
	              null,
	              this.props.dependentValues.RestockWeight || this.props.dependentValues.RestockWeight === 0 ? this.props.dependentValues.RestockWeight : ''
	            );
	          }
	        });
	
	        var RestockFormatter = _react2.default.createClass({
	          displayName: 'RestockFormatter',
	          render: function render() {
	            var _this4 = this;
	
	            // console.log("props in process button", this.props);
	            // if(this.props.dependentValues)
	            //   return(this.props.dependentValues.ProductType !== 'Fixed' && !this.props.dependentValues.RestockQuantity) ?
	            //     <span><Button
	            //     bsStyle="primary"
	            //     className="textAlignStyle" style={{ height: '20px', width: '120px', padding: '0px' }}
	            //     disabled={!this.props.dependentValues.isSelected}
	            //     onClick={() => {
	            //       let currentWeights = {};
	            //       currentWeights.Weights = this.props.dependentValues.ReturnWeightsList;
	            //       that.setState({ rowChosen: this.props.dependentValues.SalesInvoiceLine_id, currentWeights})
	            //       that.openWeightModule(this.props.dependentValues);
	            //       console.log("check dependentValues", this.props.dependentValues);
	            //     }}><Translate value="process" /></Button></span> :
	            //     <span>{(this.props.dependentValues.RestockQuantity) ? this.props.dependentValues.RestockQuantity : ''}</span>;
	            // }
	            if (this.props.dependentValues) {
	              if (!this.props.dependentValues.RestockQuantity && this.props.dependentValues.ProductType !== 'Fixed') {
	                return _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                      bsStyle: 'primary',
	                      className: 'textAlignStyle', style: { height: '20px', width: '120px', padding: '0px' },
	                      disabled: !this.props.dependentValues.isSelected,
	                      onClick: function onClick() {
	                        var currentWeights = {};
	                        currentWeights.Weights = _this4.props.dependentValues.ReturnWeightsList;
	                        that.setState({ rowChosen: _this4.props.dependentValues.SalesInvoiceLine_id, currentWeights: currentWeights });
	                        that.openWeightModule(_this4.props.dependentValues);
	                        // console.log("check dependentValues", this.props.dependentValues);
	                      } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'process' })
	                  )
	                );
	              } else if (this.props.dependentValues.ProductType === 'Fixed') {
	                return _react2.default.createElement(
	                  'span',
	                  null,
	                  this.props.dependentValues.RestockQuantity || this.props.dependentValues.RestockQuantity === 0 ? this.props.dependentValues.RestockQuantity : ''
	                );
	              } else {
	                return _react2.default.createElement(
	                  'span',
	                  null,
	                  this.props.dependentValues.RestockQuantity,
	                  ' ',
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                      bsStyle: 'warning',
	                      className: 'textAlignStyle', style: { height: '20px', width: '60px', padding: '0px' },
	                      disabled: !this.props.dependentValues.isSelected,
	                      onClick: function onClick() {
	                        var currentWeights = {};
	                        currentWeights.Weights = _this4.props.dependentValues.ReturnWeightsList;
	                        that.setState({ rowChosen: _this4.props.dependentValues.SalesInvoiceLine_id, currentWeights: currentWeights });
	                        that.openWeightModule(_this4.props.dependentValues);
	                        // console.log("check dependentValues", this.props.dependentValues);
	                      } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'change' })
	                  )
	                );
	              }
	            }
	          }
	        });
	
	        var RestockBoxFormatter = _react2.default.createClass({
	          displayName: 'RestockBoxFormatter',
	          render: function render() {
	            if (this.props.dependentValues) {
	              return _react2.default.createElement(
	                'span',
	                null,
	                this.props.dependentValues.RestockBox || this.props.dependentValues.RestockBox === 0 ? this.props.dependentValues.RestockBox : ''
	              );
	            }
	          }
	        });
	
	        var columns = [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	          resizable: true,
	          sortable: true,
	          width: 140,
	          filterable: true
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	          resizable: true,
	          sortable: true,
	          width: 140,
	          filterable: true
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true,
	          width: 160,
	          filterable: true
	        }, {
	          key: 'UnitPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        }, {
	          key: 'ReturnQuantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_qty' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true,
	          formatter: IsFixedFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'ReturnWeight',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rtn_wt' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true,
	          formatter: ReturnWeightFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }].concat(_toConsumableArray(_root_url.isJML ? [{
	          key: 'ReturnBox',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box' }),
	          resizable: true,
	          sortable: true
	        }, {
	          key: 'jmlPackageSize1',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pcs/box' }),
	          resizable: true,
	          sortable: true,
	          width: 110
	        }, {
	          key: 'RestockBox',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'restock_box' }),
	          resizable: true,
	          sortable: true,
	          editable: function editable(row) {
	            return row.ProductType !== 'Non-Fixed' && row.isSelected;
	          },
	          width: 130,
	          // filterable: true,
	          formatter: RestockBoxFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }] : []), [{
	          key: 'RestockQuantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'restock_qty' }),
	          resizable: true,
	          sortable: true,
	          editable: function editable(row) {
	            return row.ProductType === 'Fixed' && row.isSelected && !_root_url.isJML;
	          },
	          width: 130,
	          filterable: true,
	          formatter: RestockFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'RestockWeight',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'restock_wt' }),
	          resizable: true,
	          sortable: true,
	          width: 130,
	          filterable: true,
	          formatter: RestockWeightFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }]);
	
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { id: 'RestockReturnForm-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'Product_id',
	                onGridSort: handleGridSort,
	                columns: columns,
	                rowHeight: _root_url.isJML ? 35 : 25,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                onRowUpdated: handleRowUpdated,
	                minHeight: this.state.tableHeight,
	                onGridRowsUpdate: function onGridRowsUpdate() {
	                  console.log("grid row updating");
	                }
	                // enableRowSelect='single'
	                , enableCellSelect: true
	                // rowSelection={{
	                //   showCheckbox: true,
	                //   onRowsSelected: onRowsSelected,
	                //   onRowsDeselected: onRowsDeselected,
	                //   selectBy: {
	                //     isSelectedKey: 'isSelected'
	                //   }
	                // }}
	              })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      // console.log("HELLO", this.props);
	      var createDialogInventoryStyle = {
	        height: '700px',
	        width: '1000px',
	        marginLeft: '-28%',
	        marginTop: '-20%'
	      };
	      var createDialogStyleWeight = {
	        width: '500px',
	        height: '600px',
	        top: '45%',
	        marginLeft: '-10%'
	      };
	      var selectInventoryInformation = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_inventory_information' });
	      var salesInvoiceDetail = !this.props.params.id ? this.props.salesInvoiceDetail : this.props.salesReturnDetail;
	      if (this.props.salesReturnDetail && this.props.salesReturnDetail.SRNum) salesInvoiceDetail.InvoiceNum = this.props.params.id ? this.props.salesReturnDetail.SRNum.slice(0, -1) : salesInvoiceDetail.InvoiceNum;
	      var handleSubmit = this.props.handleSubmit;
	
	      var Customer_Name = '';
	      if (salesInvoiceDetail) {
	        Customer_Name = salesInvoiceDetail.Customer_Name ? salesInvoiceDetail.Customer_Name : salesInvoiceDetail.Deliver_Customer_Name;
	      }
	      var tax = 0;
	      var total = 0;
	      var CRV = 0;
	      var finalPrice = 0;
	      for (var i = 0; i < this.state.invoice.selectedRows.length; i++) {
	        total += this.state.invoice.selectedRows[i].ReturnTotalPrice ? parseFloat(this.state.invoice.selectedRows[i].ReturnTotalPrice) : 0;
	        if (this.state.invoice.selectedRows[i].IsTaxable && this.state.invoice.selectedRows[i].ReturnTotalPrice) tax += parseFloat(this.state.invoice.TaxRate) / 100.0 * parseFloat(this.state.invoice.selectedRows[i].ReturnTotalPrice);
	        CRV += parseFloat(this.state.invoice.selectedRows[i].CRV);
	      }
	      tax = parseFloat(roundTo(tax, 2)).toFixed(2);
	      total = parseFloat(roundTo(total, 2)).toFixed(2);
	      CRV = parseFloat(roundTo(CRV, 2)).toFixed(2);
	      finalPrice = parseFloat(roundTo((parseFloat(total) || 0) + (parseFloat(CRV) || 0) + (parseFloat(tax) || 0) + (parseFloat(this.state.curRestock) || 0), 2)).toFixed(2);
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'returns' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_return' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'restock_sales_return' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          { id: 'breadcrumbButtonGroup' },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'success',
	              disabled: this.state.invoice.selectedRows.length === 0 || this.props.inventoryReturnIsLoading,
	              onClick: function onClick() {
	                _this5.handleComplete();
	              } },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement('em', { className: 'fa fa-save' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'danger',
	              type: 'button',
	              onClick: function onClick() {
	                _this5.context.router.push('/inventoryReturn');
	              } },
	            _react2.default.createElement('em', { className: 'fa fa-close' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'sales-customer-return-form' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'h1',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'restock_sales_return' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 8 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 3 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'h3',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 6 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                          ':'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 6 },
	                        Customer_Name
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 6 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'h3',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 2 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' }),
	                          ':'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7 },
	                        salesInvoiceDetail && salesInvoiceDetail.InvoiceNum
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 2 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	                          ':'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 7 },
	                        salesInvoiceDetail && salesInvoiceDetail.Sales_User_Name
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 3 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'h3',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 4 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' }),
	                          ':'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 8 },
	                        salesInvoiceDetail && salesInvoiceDetail.InvoiceNum,
	                        'R'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 4 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	                          ':'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 8 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'OrderDate', selected: (0, _moment2.default)().format("MM-DD-YY"), component: _datePicker.DisabledDatePicker })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 4 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'user' }),
	                          ':'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 8 },
	                        salesInvoiceDetail && salesInvoiceDetail.Modifier_User_Name /*right?*/
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_details' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'label',
	                          { style: { 'display': 'inline-flex' } },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total' }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            ' $$'
	                          ),
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'ReturnTotal', component: _inputField.DisabledInputField, placeholder: total })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'crv' }),
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'CRV', component: _inputField.DisabledInputField, placeholder: CRV })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'Tax', component: _inputField.DisabledInputField, placeholder: tax })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 4 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'label',
	                          null,
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'restocking_fee' }),
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'curRestock', component: _inputField.DisabledInputField, placeholder: this.state.curRestock })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          'label',
	                          { style: { 'display': 'inline-flex' } },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final' }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            ' $$'
	                          ),
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'FinalTotal', component: _inputField.DisabledInputField, placeholder: finalPrice })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                null,
	                this.renderInvoice()
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          { dialogStyles: createDialogStyleWeight, isVisible: this.state.ReturnModalOpen, onCloseClicked: function onCloseClicked() {
	              _this5.closeReturnModal();
	            }, title: 'Return Products' },
	          _react2.default.createElement(_returnModal2.default, { invoice: true, setWeights: this.setWeights, keepLoaded: function keepLoaded() {}, currentWeights: this.state.currentWeights, closeC: this.closeReturnModal, totalLoaded: 2, rowChosen: this.state.rowChosen, returnTotalWeight: this.returnTotalWeight.bind(this) })
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          { dialogStyles: createDialogInventoryStyle, isVisible: this.state.showInventoryOpen, onCloseClicked: function onCloseClicked() {
	              _this5.closeShowInventory('productSearch');
	            }, title: selectInventoryInformation },
	          _react2.default.createElement(_salesInventoryInfo2.default, {
	            Customer_id: this.state.currentCustomer_id,
	            SearchType: this.props.searchType,
	            SearchValue: this.props.searchValue,
	            closeShowInventory: this.closeShowInventory,
	            selectInventoryInfo: this.selectInventoryInfo,
	            setSaleRowValue: this.props.setSaleRowValue,
	            setAllProductQuantity: this.setAllProductQuantity,
	            formName: 'restockReturnForm'
	          })
	        )
	      );
	    }
	  }]);
	
	  return RestockReturnForm;
	}(_react.Component);
	
	RestockReturnForm.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	var renderTypeRadios = function renderTypeRadios(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group', id: 'search-product-by' },
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-3 search-by-max-width' },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'search_by' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'ProductNum',
	        checked: props.input.value === "ProductNum" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'RefNum',
	        checked: props.input.value === "RefNum" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'Name',
	        checked: props.input.value === "Name" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'Description',
	        checked: props.input.value === "Description" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	    )
	  );
	};
	
	var _default = RestockReturnForm;
	exports.default = _default;
	
	
	function roundTo(n, digits) {
	  if (digits === undefined) {
	    digits = 0;
	  }
	
	  var multiplicator = Math.pow(10, digits);
	  n = parseFloat((n * multiplicator).toFixed(11));
	  var test = Math.round(n) / multiplicator;
	  return +test.toFixed(2);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isNumeric, 'isNumeric', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/restockReturnForm.jsx');
	
	  __REACT_HOT_LOADER__.register(roundTo, 'roundTo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/restockReturnForm.jsx');
	
	  __REACT_HOT_LOADER__.register(AutoCompleteEditor, 'AutoCompleteEditor', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/restockReturnForm.jsx');
	
	  __REACT_HOT_LOADER__.register(RestockReturnForm, 'RestockReturnForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/restockReturnForm.jsx');
	
	  __REACT_HOT_LOADER__.register(renderTypeRadios, 'renderTypeRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/restockReturnForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/restockReturnForm.jsx');
	}();

	;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReturnModal = function (_Component) {
	  _inherits(ReturnModal, _Component);
	
	  function ReturnModal() {
	    _classCallCheck(this, ReturnModal);
	
	    var _this = _possibleConstructorReturn(this, (ReturnModal.__proto__ || Object.getPrototypeOf(ReturnModal)).call(this));
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton,
	      needsDelete: false,
	      rowsToDelete: 0,
	      finished: false,
	      oldLoaded: 0,
	      changed: false,
	      weights: {
	        rows: [],
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	      changeStyle: false
	    };
	    return _this;
	  }
	
	  _createClass(ReturnModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var newRows = [].concat(_toConsumableArray(this.props.currentWeights.Weights));
	      for (var i = 0; i < newRows.length; i += 1) {
	        newRows[i] = { Weight: newRows[i] };
	      }
	      var newWeights = _extends({}, this.state.weights, { rows: newRows });
	      this.setState({ weights: newWeights });
	    }
	
	    // componentWillReceiveProps(nextProps) {
	    //   console.log('COMPONENT WILL RECEIVE PROPS');
	    //   if (!this.state.oldLoaded) {
	    //     this.setState({ oldLoaded: nextProps.salesOrderLineWeights.length });
	    //   }
	    //   if ((parseFloat(nextProps.totalLoaded) < nextProps.salesOrderLineWeights.length) && !this.state.finished) {
	    //     const rowsToDelete = nextProps.salesOrderLineWeights.length - nextProps.totalLoaded;
	    //     this.setState({ needsDelete: true, rowsToDelete });
	    //   } else {
	    //     this.setState({ needsDelete: false });
	    //   }
	    //   if (nextProps.totalWeight !== this.props.totalWeight) {
	    //     let avgWeight = (parseFloat(nextProps.totalWeight) || 0) / (parseFloat(this.state.weights.rows.length) || 1);
	    //     avgWeight = avgWeight.toFixed(2);
	    //     this.state.weights.rows.map(r => {
	    //       r.Weight = avgWeight;
	    //     })
	    //   }
	    //   if (nextProps.salesOrderLineWeights && nextProps.salesOrderLineWeights !== this.props.salesOrderLineWeights) {
	    //     let tempWeights = [];
	    //
	    //     nextProps.salesOrderLineWeights.map(weight => {
	    //       tempWeights.push({ Weight: weight });
	    //     });
	    //
	    //     if (nextProps.salesOrderLineWeights.length >= this.props.totalLoaded) {
	    //       const newWeights = tempWeights; // .splice(0, parseInt(this.props.totalLoaded));
	    //       const weights = { ...this.state.weights, rows: newWeights };
	    //       this.setState({ weights });
	    //     } else {
	    //       const temp = tempWeights.length;
	    //       for (let i = 0; i < (this.props.totalLoaded - temp); i += 1) {
	    //         tempWeights.push({ Weight: 0 });
	    //       }
	    //       const weights = { ...this.state.weights, rows: tempWeights };
	    //       this.setState({ weights });
	    //     }
	    //   }
	    // }
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!this.state.changed) {
	        this.props.keepLoaded(this.state.oldLoaded);
	      }
	      this.props.clearSalesOrderLineWeights();
	    }
	  }, {
	    key: 'fillWithLastValue',
	    value: function fillWithLastValue() {
	      var index = 0;
	      var newWeights = _extends({}, this.state.weights);
	
	      for (var i = 0; i < this.state.weights.rows.length; i += 1) {
	        if (this.state.weights.rows[i].Weight === 0) {
	          index = i;
	          break;
	        }
	      }
	      if (index > 0) {
	        var fillValue = this.state.weights.rows[index - 1].Weight;
	
	        for (var _i = index; _i < this.state.weights.rows.length; _i += 1) {
	          newWeights.rows[_i].Weight = fillValue;
	        }
	        this.setState({ weights: newWeights });
	      }
	    }
	  }, {
	    key: 'clearAllValues',
	    value: function clearAllValues() {
	      var newWeights = [].concat(_toConsumableArray(this.state.weights.rows));
	      newWeights.map(function (row) {
	        row.Weight = 0;
	      });
	
	      var weights = _extends({}, this.state.weights, { rows: newWeights });
	      this.setState({ weights: weights });
	    }
	  }, {
	    key: 'renderWeightInputs',
	    value: function renderWeightInputs() {
	      var _this2 = this;
	
	      var _props = this.props,
	          salesOrderLineWeightsIsLoading = _props.salesOrderLineWeightsIsLoading,
	          salesOrderLineWeightsError = _props.salesOrderLineWeightsError;
	
	      if (salesOrderLineWeightsIsLoading && !salesOrderLineWeightsError) {
	        return _react2.default.createElement(_spinner2.default, { className: 'marginTopStyle' });
	      } else if (salesOrderLineWeightsError) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(salesOrderLineWeightsError)
	        );
	      }
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.weights);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return Object.assign({ Idx: rowIdx + 1 }, rows[rowIdx]);
	      };
	
	      // Handle the row select function
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var selectedRows = [];
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        newRows.map(function (r) {
	          if (r.isSelected == true) {
	            selectedRows.push(r);
	          }
	        });
	        _this2.setState({ rows: newRows, selectedRows: selectedRows });
	      };
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = getRows();
	        var selectedRows = [];
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        newRows.map(function (r) {
	          if (r.isSelected == true) {
	            selectedRows.push(r);
	          }
	        });
	        _this2.setState({ rows: newRows, selectedRows: selectedRows });
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        console.log("this is a check", _this2.state, e);
	        var rows = _this2.state.weights.rows.slice(0);
	        Object.assign(rows[e.rowIdx], e.updated);
	        var weights = _extends({}, _this2.state.weights, { rows: rows });
	        _this2.setState({ weights: weights });
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var weights = Object.assign({}, _this2.state.weights, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this2.setState({ weights: weights });
	      };
	
	      //Custom Formatter component
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	            var date = new Date(this.props.value);
	            var index = dateMap.indexOf(date.toString().slice(4, 3));
	            var localDate = index + date.toString().slice(8, 6);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );;
	          } else return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var that = this;
	
	      var deleteFormatter = _react2.default.createClass({
	        displayName: 'deleteFormatter',
	        render: function render() {
	          var _this3 = this;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                className: 'textAlignStyle',
	                onClick: function onClick() {
	                  /*var ProductNum = this.props.dependentValues.ProductNum;
	                  that.removeRow(ProductNum);*/
	                  var weights = that.state.weights;
	                  weights.rows.splice(_this3.props.dependentValues.Idx - 1, 1);
	                  var rowsToDelete = that.state.rowsToDelete - 1;
	                  if (rowsToDelete === 0) {
	                    that.setState({ needsDelete: false, rowsToDelete: rowsToDelete, weights: weights, finished: true });
	                  } else {
	                    that.setState({ rowsToDelete: rowsToDelete, weights: weights });
	                  }
	                } },
	              'X'
	            )
	          );
	        }
	      });
	
	      // Column difinition
	
	      var columns = [{
	        key: 'Idx',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	        width: 40,
	        resizable: false,
	        filterable: true
	      }, {
	        key: 'Weight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight' }),
	        width: 100,
	        resizable: true,
	        filterable: true
	      }];
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 11 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '99%' }, id: 'ReturnModal-dataGrid1' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Please choose what you want to return'
	            ),
	            _react2.default.createElement(_reactDataGrid2.default, {
	              style: { height: '10%' },
	              onGridSort: handleGridSort,
	              columns: columns,
	              enableCellSelect: true,
	              rowHeight: 25,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: 275,
	              onRowUpdated: handleRowUpdated,
	              enableRowSelect: 'multi',
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              },
	              disable: true
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var closeC = this.props.closeC;
	
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement('hr', null),
	        this.props.invoice ? this.renderWeightInputs() : "",
	        _react2.default.createElement('br', null),
	        !this.props.invoice ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary col-sm-11 buttonStyle', disabled: this.state.needsDelete, onClick: function onClick() {
	                  _this4.props.setOrderLineWeights(_this4.props.rowChosen, _this4.state.weights.rows);
	                  _this4.setState({ changed: true });
	                  var totalWeight = 0;
	                  _this4.state.weights.rows.map(function (row) {
	                    if (row.Weight) totalWeight += parseFloat(row.Weight);
	                  });
	                  _this4.props.returnTotalWeight(totalWeight.toFixed(2));
	                  // this.props.closeC();
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save_weights' })
	            )
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-danger col-sm-11 buttonStyle', disabled: this.state.needsDelete, onClick: function onClick() {
	                  _this4.props.closeC();
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discard_changes' })
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'button',
	              { className: this.state.changeStyle ? "btn btn-success col-sm-11 buttonStyle" : "btn btn-primary col-sm-11 buttonStyle", disabled: this.state.needsDelete, onClick: function onClick() {
	                  _this4.setState({ changeStyle: true, changed: true });
	                  var totalWeight = 0;
	                  _this4.state.weights.rows.map(function (row) {
	                    if (row.Weight && row.isSelected) totalWeight += parseFloat(row.Weight);
	                  });
	                  _this4.props.setWeights(_this4.props.rowChosen, _this4.state.weights.rows, totalWeight.toFixed(4));
	                  _this4.props.closeC();
	                  // this.props.closeC();
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save_returns' })
	            )
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-danger col-sm-11 buttonStyle', onClick: function onClick() {
	                  _this4.props.closeC();
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'close' })
	            )
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          this.props.editSalesOrderLineWeightsError && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            this.props.editSalesOrderLineWeightsError
	          ),
	          !this.props.invoice ? _react2.default.createElement(
	            'div',
	            null,
	            this.props.salesOrderLineWeightsIsEditing && _react2.default.createElement(
	              'div',
	              { className: 'alert alert-info' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'uploading' })
	            ),
	            this.props.editSalesOrderLineWeightsSuccess && _react2.default.createElement(
	              'div',
	              { className: 'alert alert-success' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saved' })
	            )
	          ) : _react2.default.createElement('span', null)
	        )
	      );
	    }
	  }]);
	
	  return ReturnModal;
	}(_react.Component);
	
	ReturnModal.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = ReturnModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ReturnModal, 'ReturnModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/returnModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Returns/returnModal.jsx');
	}();

	;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Usage example
	  <DeliveryMethodModal
	    info={this.state.shipping}
	  />
	*/
	
	var DeliveryMethodModal = function DeliveryMethodModal(props) {
	  if (props.info.ShippingMethod === 'Delivery') {
	    return _react2.default.createElement(
	      'div',
	      { id: 'delivery-method-modal' },
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'time_slot' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'colon' },
	          ':'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'info' },
	        'N/a'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'colon' },
	          ':'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'info' },
	        props.info.FirstName + ' ' + props.info.LastName
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'colon' },
	          ':'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'info' },
	        props.info.Street + ' ' + props.info.City + ', ' + props.info.State + ' ' + props.info.Zip
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'colon' },
	          ':'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'info' },
	        props.info.Telephone
	      )
	    );
	  } // Else props.info.ShippingMethod === 'PickUp'
	  return _react2.default.createElement(
	    'div',
	    { id: 'delivery-method-modal' },
	    _react2.default.createElement(
	      'h3',
	      null,
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'time_slot' }),
	      _react2.default.createElement(
	        'span',
	        { className: 'colon' },
	        ':'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { id: 'info' },
	      props.info.TimeSlot ? props.info.TimeSlot : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'none_selected' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_name' }),
	      _react2.default.createElement(
	        'span',
	        { className: 'colon' },
	        ':'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { id: 'info' },
	      props.info.Name
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_address' }),
	      _react2.default.createElement(
	        'span',
	        { className: 'colon' },
	        ':'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { id: 'info' },
	      props.info.Street + ' ' + props.info.City + ', ' + props.info.State + ' ' + props.info.Zip
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' }),
	      _react2.default.createElement(
	        'span',
	        { className: 'colon' },
	        ':'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { id: 'info' },
	      props.info.Telephone
	    )
	  );
	};
	
	DeliveryMethodModal.defaultProps = {
	  info: {}
	};
	
	DeliveryMethodModal.propTypes = {
	  info: _propTypes2.default.object
	};
	
	var _default = DeliveryMethodModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(DeliveryMethodModal, 'DeliveryMethodModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/DeliveryMethodModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/DeliveryMethodModal.jsx');
	}();

	;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	var _url = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  salesOrderId: _propTypes2.default.string.isRequired,
	  vendors: _propTypes2.default.array,
	  visible: _propTypes2.default.bool.isRequired,
	  onClose: _propTypes2.default.func.isRequired
	};
	
	var defaultProps = {
	  vendors: []
	};
	
	var styles = {
	  modal: {
	    width: '300px',
	    height: '200px',
	    marginLeft: '-15%'
	  },
	  container: {
	    display: 'flex',
	    alignItems: 'center',
	    flexDirection: 'column',
	    justifyContent: 'space-between'
	  }
	};
	
	var DropshipModal = function (_React$Component) {
	  _inherits(DropshipModal, _React$Component);
	
	  function DropshipModal() {
	    _classCallCheck(this, DropshipModal);
	
	    var _this = _possibleConstructorReturn(this, (DropshipModal.__proto__ || Object.getPrototypeOf(DropshipModal)).call(this));
	
	    _this.state = {
	      selectedVendorId: undefined,
	      loading: false
	    };
	    _this.handleSelectVendor = _this.handleSelectVendor.bind(_this);
	    _this.createPo = _this.createPo.bind(_this);
	    return _this;
	  }
	
	  _createClass(DropshipModal, [{
	    key: 'handleSelectVendor',
	    value: function handleSelectVendor(_ref) {
	      var vendorId = _ref.value;
	
	      this.setState({ selectedVendorId: vendorId });
	    }
	  }, {
	    key: 'createPo',
	    value: function createPo() {
	      var selectedVendorId = this.state.selectedVendorId;
	      var salesOrderId = this.props.salesOrderId;
	
	      if (!selectedVendorId) {
	        alert('Please enter a vendor.');
	        return;
	      }
	      this.setState({
	        loading: true
	      });
	      _axios2.default.post('' + _url.SALES_ORDER_DROPDHIP_URL + salesOrderId, {
	        vendor_id: selectedVendorId
	      }, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        var purchase_order_id = response.data.purchase_order_id;
	
	        window.location.pathname = '/purchaseOrder/' + purchase_order_id;
	      }).catch(function () {
	        alert('Internal Server Error. Please try again.');
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          vendors = _props.vendors,
	          visible = _props.visible,
	          onClose = _props.onClose;
	
	      var customerOptions = vendors.map(function (_ref2) {
	        var Name = _ref2.Name,
	            Vendor_id = _ref2.Vendor_id;
	        return {
	          label: Name,
	          value: Vendor_id
	        };
	      });
	      return _react2.default.createElement(
	        _reactSkylight.SkyLightStateless,
	        {
	          dialogStyles: styles.modal,
	          isVisible: visible,
	          onCloseClicked: onClose
	        },
	        _react2.default.createElement(
	          'div',
	          { style: styles.container, className: 'salesOrder-dropship' },
	          _react2.default.createElement(_GenericSelection2.default, {
	            translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor' }),
	            setSelected: this.handleSelectVendor,
	            value: this.state.selectedVendorId,
	            options: customerOptions,
	            colon: true
	          }),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: 50 } },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                onClick: this.createPo,
	                disabled: this.state.loading
	              },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_po' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DropshipModal;
	}(_react2.default.Component);
	
	DropshipModal.propTypes = propTypes;
	DropshipModal.defaultProps = defaultProps;
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    vendors: state.vendors.all
	  };
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(DropshipModal);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/DropshipModal.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/DropshipModal.jsx');
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/DropshipModal.jsx');
	
	  __REACT_HOT_LOADER__.register(DropshipModal, 'DropshipModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/DropshipModal.jsx');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/DropshipModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/DropshipModal.jsx');
	}();

	;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditCustomerModal = function (_Component) {
	  _inherits(EditCustomerModal, _Component);
	
	  function EditCustomerModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EditCustomerModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditCustomerModal.__proto__ || Object.getPrototypeOf(EditCustomerModal)).call.apply(_ref, [this].concat(args))), _this), _this.handleFormSubmit = function (formProps) {
	      if (!_this.checkPermission('add_purchase_order')) {
	        var Deliver_Customer_id = formProps.Deliver_Customer_id.value;
	        var Deliver_CustomerDetail_id = formProps.CustomerDetail_id && formProps.CustomerDetail_id.value;
	        _this.props.editSICustomer(_this.props.invoiceID, { Deliver_Customer_id: Deliver_Customer_id, Deliver_CustomerDetail_id: Deliver_CustomerDetail_id });
	      } else {
	        alert('You have no permission!');
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EditCustomerModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.fetchCustomers();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.deliverCustomerId && nextProps.deliverCustomerId != this.props.deliverCustomerId) {
	        this.props.fetchCustomerDetail(nextProps.deliverCustomerId.value);
	      }
	      if (nextProps.siCustomerEdited !== this.props.siCustomerEdited && nextProps.siCustomerEdited === true) {
	        this.props.confirmAction();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.resetEditSICustomer();
	    }
	  }, {
	    key: 'getCustomerNameOptions',
	    value: function getCustomerNameOptions() {
	      var customerOptions = [];
	      this.props.customers.map(function (customer) {
	        customerOptions.push({ value: customer.Customer_id, label: customer.Name });
	      });
	      return customerOptions;
	    }
	  }, {
	    key: 'getCustomerNumOptions',
	    value: function getCustomerNumOptions() {
	      var customerOptions = [];
	      this.props.customers.map(function (customer) {
	        customerOptions.push({ value: customer.Customer_id, label: customer.CustomerNum });
	      });
	      return customerOptions;
	    }
	  }, {
	    key: 'getCustomerShippingAddressOptions',
	    value: function getCustomerShippingAddressOptions() {
	      var customerShippingAddressOptions = [];
	      if (this.props.currentCustomerDetail && this.props.currentCustomerDetail.Shipping) {
	        this.props.currentCustomerDetail.Shipping.map(function (shipping) {
	          var address = shipping.Street + ' ' + shipping.City + ' ' + shipping.State + ' ' + shipping.Zip;
	          customerShippingAddressOptions.push({ value: shipping.CustomerDetail_id, label: address });
	        });
	      }
	      return customerShippingAddressOptions;
	    }
	  }, {
	    key: 'checkPermission',
	    value: function checkPermission(permission) {
	      return false;
	    }
	  }, {
	    key: 'renderCustomers',
	    value: function renderCustomers() {
	      if (this.props.customersIsLoading) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } // If payment term is loading, show a spinner.
	
	      var customerNameOptions = this.getCustomerNameOptions();
	      var customerNumOptions = this.getCustomerNumOptions();
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'mb-lg' },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'Deliver_Customer_id', className: 'col-sm-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' }),
	              ':'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 4 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'Deliver_Customer_id', component: _selection2.default, options: customerNameOptions })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'mb-lg' },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'Deliver_Customer_id', className: 'col-sm-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_no' }),
	              ':'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 4 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'Deliver_Customer_id', component: _selection2.default, options: customerNumOptions })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderCustomerShippingAddress',
	    value: function renderCustomerShippingAddress() {
	      if (this.props.detailIsLoading) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } // If payment term is loading, show a spinner.
	
	      var customerShippingAddressOptions = this.getCustomerShippingAddressOptions();
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'mb-lg' },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'CustomerDetail_id', className: 'col-sm-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_address' }),
	              ':'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 9 },
	              _react2.default.createElement(_reduxForm.Field, { name: 'CustomerDetail_id', component: _selection2.default, options: customerShippingAddressOptions })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          submitting = _props.submitting,
	          pristine = _props.pristine,
	          siCustomerIsEditing = _props.siCustomerIsEditing,
	          siCustomerEdited = _props.siCustomerEdited;
	
	      return _react2.default.createElement(
	        'form',
	        null,
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              this.renderCustomers()
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              this.renderCustomerShippingAddress()
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'centerStyle' },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                className: 'mr',
	                bsStyle: 'success',
	                type: 'button',
	                disabled: submitting || pristine || siCustomerIsEditing || siCustomerEdited,
	                onClick: handleSubmit(this.handleFormSubmit)
	              },
	              _react2.default.createElement('em', { className: 'fa ' + (siCustomerIsEditing ? 'fa-spinner fa-spin' : 'fa-save') }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                type: 'button',
	                onClick: this.props.onCloseClicked
	              },
	              _react2.default.createElement('em', { className: 'fa fa-close' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditCustomerModal;
	}(_react.Component);
	
	var _default = EditCustomerModal;
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(EditCustomerModal, 'EditCustomerModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/EditCustomerModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/EditCustomerModal.jsx');
	}();

	;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _NumberUtil = __webpack_require__(67);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	var EditPosPaymentModal = function (_Component) {
	  _inherits(EditPosPaymentModal, _Component);
	
	  function EditPosPaymentModal() {
	    _classCallCheck(this, EditPosPaymentModal);
	
	    var _this = _possibleConstructorReturn(this, (EditPosPaymentModal.__proto__ || Object.getPrototypeOf(EditPosPaymentModal)).call(this));
	
	    _this.handleSaveOnClick = function () {
	      var _this$props = _this.props,
	          posID = _this$props.posID,
	          editPosPayment = _this$props.editPosPayment;
	      var _this$state = _this.state,
	          cashAmount = _this$state.cashAmount,
	          cardAmount = _this$state.cardAmount,
	          checkAmount = _this$state.checkAmount,
	          cardNum = _this$state.cardNum,
	          checkNum = _this$state.checkNum,
	          change = _this$state.change,
	          creditAmount = _this$state.creditAmount,
	          netDue = _this$state.netDue,
	          mobileAmount = _this$state.mobileAmount;
	
	      if (parseFloat(netDue) !== 0) {
	        alert('Balance Net Due is not 0, please check the numbers');
	        return;
	      }
	      if (parseFloat(cardAmount) !== 0 && (!cardNum || cardNum.length !== 4)) {
	        alert('If paying by card, please enter the last 4 digits of the credit card number');
	        return;
	      }
	      if (parseFloat(checkAmount) !== 0 && !checkNum) {
	        alert('If paying by check, please enter the check number');
	        return;
	      }
	      editPosPayment(posID, {
	        CashAmount: cashAmount,
	        Change: change,
	        CreditCardAmount: cardAmount,
	        CreditCardNumber: cardNum !== '' ? cardNum : null,
	        CheckAmount: checkAmount,
	        CheckNum: checkNum !== '' ? checkNum : null,
	        StoreCreditAmount: creditAmount,
	        MobileAmount: mobileAmount
	      });
	    };
	
	    _this.handleOnFocus = function (event) {
	      // Auto-select input content
	      event.target.select();
	    };
	
	    _this.handleCashAmountChange = function (cashAmount) {
	      if (isNaN(cashAmount) && cashAmount !== '-' && cashAmount !== '-.') {
	        return;
	      }
	      var paymentTotal = cashAmount;
	      if (paymentTotal === '' || paymentTotal === '-' || paymentTotal === '-.') {
	        paymentTotal = 0;
	      }
	      if (!isNaN(parseFloat(paymentTotal))) {
	        var checkAmount = 0;
	        var cardAmount = 0;
	        var creditAmount = 0;
	        var mobileAmount = 0;
	        if (!isNaN(parseFloat(_this.state.checkAmount)) && isFinite(_this.state.checkAmount)) {
	          checkAmount = parseFloat(_this.state.checkAmount);
	        }
	        if (!isNaN(parseFloat(_this.state.cardAmount)) && isFinite(_this.state.cardAmount)) {
	          cardAmount = parseFloat(_this.state.cardAmount);
	        }
	        if (!isNaN(parseFloat(_this.state.creditAmount)) && isFinite(_this.state.creditAmount)) {
	          creditAmount = parseFloat(_this.state.creditAmount);
	        }
	        if (!isNaN(parseFloat(_this.state.mobileAmount)) && isFinite(_this.state.mobileAmount)) {
	          mobileAmount = parseFloat(_this.state.mobileAmount);
	        }
	        var totalAmount = cardAmount + checkAmount + creditAmount + mobileAmount + parseFloat(paymentTotal);
	        if (parseFloat(_this.state.finalPrice) < 0) {
	          if (paymentTotal > 0) {
	            _this.setState({
	              cashAmount: cashAmount || 0,
	              netDue: (0, _NumberUtil.roundTo)(parseFloat(_this.state.finalPrice) - totalAmount, 2).toFixed(2),
	              change: -(0, _NumberUtil.roundTo)(parseFloat(_this.state.finalPrice) - totalAmount, 2).toFixed(2)
	            });
	            return;
	          }
	          _this.setState({
	            cashAmount: cashAmount || 0,
	            netDue: (0, _NumberUtil.roundTo)(parseFloat(_this.state.finalPrice) - totalAmount, 2).toFixed(2),
	            change: -paymentTotal
	          });
	          return;
	        }
	
	        if (parseFloat(_this.state.finalPrice) > totalAmount) {
	          _this.setState({
	            cashAmount: cashAmount || 0,
	            netDue: (0, _NumberUtil.roundTo)(parseFloat(_this.state.finalPrice) - totalAmount, 2).toFixed(2),
	            change: 0
	          });
	        } else {
	          _this.setState({
	            cashAmount: cashAmount || 0,
	            netDue: 0,
	            change: (0, _NumberUtil.roundTo)(totalAmount - parseFloat(_this.state.finalPrice), 2).toFixed(2)
	          });
	        }
	      }
	    };
	
	    _this.handleCardAmountChange = function (cardAmount) {
	      if (isNaN(cardAmount) && cardAmount !== '-' && cardAmount !== '-.') {
	        return;
	      }
	      var cardPaymentTotal = cardAmount;
	      if (cardPaymentTotal === '' || cardPaymentTotal === '-' || cardPaymentTotal === '-.') {
	        cardPaymentTotal = 0;
	      }
	      if (!isNaN(parseFloat(cardPaymentTotal))) {
	        var checkPaymentTotal = 0;
	        var cashPaymentTotal = 0;
	        var creditPaymentTotal = 0;
	        var mobilePaymentTotal = 0;
	        var _this$state2 = _this.state,
	            cashAmount = _this$state2.cashAmount,
	            checkAmount = _this$state2.checkAmount,
	            creditAmount = _this$state2.creditAmount,
	            mobileAmount = _this$state2.mobileAmount,
	            finalPrice = _this$state2.finalPrice;
	
	        if (!isNaN(parseFloat(checkAmount)) && isFinite(checkAmount)) {
	          checkPaymentTotal = parseFloat(checkAmount);
	        }
	        if (!isNaN(parseFloat(cashAmount) && isFinite(cashAmount))) {
	          cashPaymentTotal = parseFloat(cashAmount);
	        }
	        if (!isNaN(parseFloat(creditAmount)) && isFinite(creditAmount)) {
	          creditPaymentTotal = parseFloat(creditAmount);
	        }
	        if (!isNaN(parseFloat(mobileAmount) && isFinite(mobileAmount))) {
	          mobilePaymentTotal = parseFloat(mobileAmount);
	        }
	        var totalAmount = parseFloat(cardPaymentTotal) + checkPaymentTotal + cashPaymentTotal + creditPaymentTotal + mobilePaymentTotal;
	        if (parseFloat(finalPrice) > totalAmount || parseFloat(finalPrice) < 0) {
	          _this.setState({
	            cardAmount: cardAmount || 0,
	            netDue: (0, _NumberUtil.roundTo)(parseFloat(finalPrice) - totalAmount, 2).toFixed(2),
	            change: 0
	          });
	        } else {
	          _this.setState({
	            cardAmount: cardAmount || 0,
	            netDue: 0,
	            change: (0, _NumberUtil.roundTo)(totalAmount - parseFloat(finalPrice), 2).toFixed(2)
	          });
	        }
	      }
	    };
	
	    _this.handleCheckAmountChange = function (checkAmount) {
	      if (isNaN(checkAmount) && checkAmount !== '-' && checkAmount !== '-.') {
	        return;
	      }
	      var checkPaymentTotal = checkAmount;
	      if (checkPaymentTotal === '' || checkPaymentTotal === '-' || checkPaymentTotal === '-.') {
	        checkPaymentTotal = 0;
	      }
	      if (!isNaN(parseFloat(checkPaymentTotal))) {
	        var cashPaymentTotal = 0;
	        var cardPaymentTotal = 0;
	        var creditPaymentTotal = 0;
	        var mobilePaymentTotal = 0;
	        var _this$state3 = _this.state,
	            cashAmount = _this$state3.cashAmount,
	            cardAmount = _this$state3.cardAmount,
	            creditAmount = _this$state3.creditAmount,
	            mobileAmount = _this$state3.mobileAmount,
	            finalPrice = _this$state3.finalPrice;
	
	
	        if (!isNaN(parseFloat(cashAmount)) && isFinite(cashAmount)) {
	          cashPaymentTotal = parseFloat(cashAmount);
	        }
	        if (!isNaN(parseFloat(cardAmount)) && isFinite(cardAmount)) {
	          cardPaymentTotal = parseFloat(cardAmount);
	        }
	        if (!isNaN(parseFloat(creditAmount)) && isFinite(creditAmount)) {
	          creditPaymentTotal = parseFloat(creditAmount);
	        }
	        if (!isNaN(parseFloat(mobileAmount) && isFinite(mobileAmount))) {
	          mobilePaymentTotal = parseFloat(mobileAmount);
	        }
	
	        var totalAmount = cardPaymentTotal + parseFloat(checkPaymentTotal) + cashPaymentTotal + creditPaymentTotal + mobilePaymentTotal;
	        if (parseFloat(finalPrice) > totalAmount || parseFloat(finalPrice) < 0) {
	          _this.setState({
	            checkAmount: checkAmount || 0,
	            netDue: (0, _NumberUtil.roundTo)(parseFloat(finalPrice) - totalAmount, 2).toFixed(2),
	            change: 0
	          });
	        } else {
	          _this.setState({
	            checkAmount: checkAmount || 0,
	            netDue: 0,
	            change: (0, _NumberUtil.roundTo)(totalAmount - parseFloat(finalPrice), 2).toFixed(2)
	          });
	        }
	      }
	    };
	
	    _this.handleCreditAmountChange = function (creditAmount) {
	      if (isNaN(creditAmount) && creditAmount !== '-' && creditAmount !== '-.') {
	        return;
	      }
	      var creditPaymentTotal = creditAmount;
	      if (creditPaymentTotal === '' || creditPaymentTotal === '-' || creditPaymentTotal === '-.') {
	        creditPaymentTotal = 0;
	      }
	      if (!isNaN(parseFloat(creditPaymentTotal))) {
	        var cashPaymentTotal = 0;
	        var cardPaymentTotal = 0;
	        var checkPaymentTotal = 0;
	        var mobilePaymentTotal = 0;
	        var _this$state4 = _this.state,
	            cashAmount = _this$state4.cashAmount,
	            cardAmount = _this$state4.cardAmount,
	            checkAmount = _this$state4.checkAmount,
	            mobileAmount = _this$state4.mobileAmount,
	            finalPrice = _this$state4.finalPrice;
	
	
	        if (!isNaN(parseFloat(cashAmount)) && isFinite(cashAmount)) {
	          cashPaymentTotal = parseFloat(cashAmount);
	        }
	        if (!isNaN(parseFloat(cardAmount)) && isFinite(cardAmount)) {
	          cardPaymentTotal = parseFloat(cardAmount);
	        }
	        if (!isNaN(parseFloat(checkAmount)) && isFinite(checkAmount)) {
	          checkPaymentTotal = parseFloat(checkAmount);
	        }
	        if (!isNaN(parseFloat(mobileAmount) && isFinite(mobileAmount))) {
	          mobilePaymentTotal = parseFloat(mobileAmount);
	        }
	
	        var totalAmount = cardPaymentTotal + checkPaymentTotal + cashPaymentTotal + parseFloat(creditPaymentTotal) + mobilePaymentTotal;
	        if (parseFloat(finalPrice) > totalAmount || parseFloat(finalPrice) < 0) {
	          _this.setState({
	            creditAmount: creditAmount || 0,
	            netDue: (0, _NumberUtil.roundTo)(parseFloat(finalPrice) - totalAmount, 2).toFixed(2),
	            change: 0
	          });
	        } else {
	          _this.setState({
	            creditAmount: creditAmount || 0,
	            netDue: 0,
	            change: (0, _NumberUtil.roundTo)(totalAmount - parseFloat(finalPrice), 2).toFixed(2)
	          });
	        }
	      }
	    };
	
	    _this.handleMobileAmountChange = function (mobileAmount) {
	      if (isNaN(mobileAmount) && mobileAmount !== '-' && mobileAmount !== '-.') {
	        return;
	      }
	      var mobilePaymentTotal = mobileAmount;
	      if (mobilePaymentTotal === '' || mobilePaymentTotal === '-' || mobilePaymentTotal === '-.') {
	        mobilePaymentTotal = 0;
	      }
	      if (!isNaN(parseFloat(mobilePaymentTotal))) {
	        var cashPaymentTotal = 0;
	        var cardPaymentTotal = 0;
	        var checkPaymentTotal = 0;
	        var creditPaymentTotal = 0;
	        var _this$state5 = _this.state,
	            cashAmount = _this$state5.cashAmount,
	            cardAmount = _this$state5.cardAmount,
	            checkAmount = _this$state5.checkAmount,
	            creditAmount = _this$state5.creditAmount,
	            finalPrice = _this$state5.finalPrice;
	
	
	        if (!isNaN(parseFloat(cashAmount)) && isFinite(cashAmount)) {
	          cashPaymentTotal = parseFloat(cashAmount);
	        }
	        if (!isNaN(parseFloat(cardAmount)) && isFinite(cardAmount)) {
	          cardPaymentTotal = parseFloat(cardAmount);
	        }
	        if (!isNaN(parseFloat(checkAmount)) && isFinite(checkAmount)) {
	          checkPaymentTotal = parseFloat(checkAmount);
	        }
	        if (!isNaN(parseFloat(creditAmount) && isFinite(creditAmount))) {
	          creditPaymentTotal = parseFloat(creditAmount);
	        }
	
	        var totalAmount = cardPaymentTotal + checkPaymentTotal + cashPaymentTotal + creditPaymentTotal + parseFloat(mobilePaymentTotal);
	        if (parseFloat(finalPrice) > totalAmount || parseFloat(finalPrice) < 0) {
	          _this.setState({
	            mobileAmount: mobileAmount || 0,
	            netDue: (0, _NumberUtil.roundTo)(parseFloat(finalPrice) - totalAmount, 2).toFixed(2),
	            change: 0
	          });
	        } else {
	          _this.setState({
	            mobileAmount: mobileAmount || 0,
	            netDue: 0,
	            change: (0, _NumberUtil.roundTo)(totalAmount - parseFloat(finalPrice), 2).toFixed(2)
	          });
	        }
	      }
	    };
	
	    _this.state = {
	      cardAmount: 0,
	      cardNum: '',
	      cashAmount: 0,
	      change: '',
	      checkAmount: 0,
	      checkNum: '',
	      creditAmount: 0,
	      finalPrice: 0,
	      mobileAmount: 0,
	      netDue: 0
	    };
	    return _this;
	  }
	
	  _createClass(EditPosPaymentModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var paymentInfo = this.props.paymentInfo;
	
	      this.setState(_extends({}, paymentInfo));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.editedPosPayment !== nextProps.editedPosPayment && nextProps.editedPosPayment === true) {
	        this.props.onCloseClicked();
	      }
	    }
	
	    /**
	     * @Input: New 'Cash' amount value
	     * @Updates:
	     *  - change
	     *  - CashPayment
	     *  - netDue
	     */
	
	
	    /**
	     * @Input: New 'Card' amount value
	     * @Updates:
	     *  - CardPayment
	     *  - change
	     *  - netDue
	     */
	
	
	    /**
	     * @Input: New 'Check' amount value
	     * @Updates:
	     *  - checkAmount
	     *  - change
	     *  - netDue
	     */
	
	
	    /**
	     * @Input: New 'Credit' amount value
	     * @Updates:
	     *  - change
	     *  - StoreCreditPayment
	     *  - netDue
	     */
	
	
	    /**
	    * @Input: New 'Mobile' amount value
	    * @Updates:
	    *  - change
	    *  - MobilePayment
	    *  - netDue
	    */
	
	  }, {
	    key: 'render',
	
	
	    // WIP: Create generic function for handling payment input change
	    // /**
	    //  * @Input: New 'Card' and 'Check' amount value
	    //  * @Updates:
	    //  *  - 'cardAmount' or 'checkAmount'
	    //  *  - change
	    //  *  - netDue
	    //  */
	    // handlePaymentTotalChange = (value, field) => {
	    //   if (!value || !field) {
	    //     console.error(`handlePaymentTotalChange invalid params, value: ${value}, field: ${field}`);
	    //     return;
	    //   }
	    //   if (isNaN(value) && value !== '-' && value !== '-.') {
	    //     return;
	    //   }
	    //   let checkPaymentTotal = value;
	    //   if (checkPaymentTotal === '' || checkPaymentTotal === '-' || checkPaymentTotal === '-.') {
	    //     checkPaymentTotal = 0;
	    //   }
	    //   if (!isNaN(parseFloat(checkPaymentTotal))) {
	    //     let paymentTotal = 0;
	    //     let cardPaymentTotal = 0;
	    //     const { cashAmount, cardAmount, finalPrice } = this.state;
	    //     if (!isNaN(parseFloat(cashAmount)) && isFinite(cashAmount)) {
	    //       paymentTotal = parseFloat(cashAmount);
	    //     }
	    //     if (!isNaN(parseFloat(cardAmount)) && isFinite(cardAmount)) {
	    //       cardPaymentTotal = parseFloat(cardAmount);
	    //     }
	    //
	    //     if ((parseFloat(finalPrice) > cardPaymentTotal + parseFloat(checkPaymentTotal) + paymentTotal)
	    //       || parseFloat(finalPrice) < 0) {
	    //       this.setState({
	    //         [field]: value,
	    //         netDue: roundTo(parseFloat(finalPrice) - cardPaymentTotal - parseFloat(checkPaymentTotal) - paymentTotal, 2).toFixed(2),
	    //         change: '0.00'
	    //       });
	    //     } else {
	    //       this.setState({
	    //         [field]: value,
	    //         netDue: '0.00',
	    //         change: roundTo((cardPaymentTotal + parseFloat(checkPaymentTotal) + paymentTotal) - parseFloat(finalPrice), 2).toFixed(2)
	    //       });
	    //     }
	    //   }
	    // }
	
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          cashAmount = _state.cashAmount,
	          cardAmount = _state.cardAmount,
	          checkAmount = _state.checkAmount,
	          creditAmount = _state.creditAmount,
	          mobileAmount = _state.mobileAmount,
	          netDue = _state.netDue,
	          finalPrice = _state.finalPrice,
	          cardNum = _state.cardNum,
	          checkNum = _state.checkNum,
	          change = _state.change;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { fluid: 'true', id: 'edit-pos-payment-modal' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4, xsOffset: 1 },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cash' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3, xsOffset: 3 },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                addonBefore: '$',
	                onChange: function onChange(e) {
	                  if ((0, _NumberUtil.decimalPlaces)(e.target.value) > 2) {
	                    return;
	                  }
	                  _this2.handleCashAmountChange(e.target.value);
	                },
	                onFocus: this.handleOnFocus,
	                value: cashAmount
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4, xsOffset: 1 },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'card' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                addonBefore: '#',
	                placeholder: 'last 4 digits',
	                onChange: function onChange(e) {
	                  if (e.target.value.length > 4) {
	                    return;
	                  }
	                  _this2.setState({ cardNum: e.target.value });
	                },
	                onFocus: this.handleOnFocus,
	                value: cardNum
	              })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                addonBefore: '$',
	                name: 'cardAmount',
	                onChange: function onChange(e) {
	                  if ((0, _NumberUtil.decimalPlaces)(e.target.value) > 2) {
	                    return;
	                  }
	                  _this2.handleCardAmountChange(e.target.value);
	                },
	                onFocus: this.handleOnFocus,
	                value: cardAmount
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4, xsOffset: 1 },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                addonBefore: '#',
	                placeholder: 'check #',
	                onChange: function onChange(e) {
	                  if (isNaN(e.target.value)) {
	                    return;
	                  }
	                  _this2.setState({ checkNum: e.target.value });
	                },
	                onFocus: this.handleOnFocus,
	                value: checkNum
	              })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                addonBefore: '$',
	                name: 'checkAmount',
	                onChange: function onChange(e) {
	                  if ((0, _NumberUtil.decimalPlaces)(e.target.value) > 2) {
	                    return;
	                  }
	                  _this2.handleCheckAmountChange(e.target.value);
	                },
	                onFocus: this.handleOnFocus,
	                value: checkAmount
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4, xsOffset: 1 },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3, xsOffset: 3 },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                addonBefore: '$',
	                onChange: function onChange(e) {
	                  if ((0, _NumberUtil.decimalPlaces)(e.target.value) > 2) {
	                    return;
	                  }
	                  _this2.handleCreditAmountChange(e.target.value);
	                },
	                onFocus: this.handleOnFocus,
	                value: creditAmount
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4, xsOffset: 1 },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mobile' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3, xsOffset: 3 },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                addonBefore: '$',
	                onChange: function onChange(e) {
	                  if ((0, _NumberUtil.decimalPlaces)(e.target.value) > 2) {
	                    return;
	                  }
	                  _this2.handleMobileAmountChange(e.target.value);
	                },
	                onFocus: this.handleOnFocus,
	                value: mobileAmount
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4, xsOffset: 1 },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3, xsOffset: 3 },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                addonBefore: '$',
	                disabled: true,
	                value: (0, _NumberUtil.roundTo)(finalPrice, 2).toFixed(2)
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4, xsOffset: 1 },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_due' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3, xsOffset: 3 },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                addonBefore: '$',
	                disabled: true,
	                value: (0, _NumberUtil.roundTo)(netDue, 2).toFixed(2)
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4, xsOffset: 1 },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'change' }),
	                ':'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3, xsOffset: 3 },
	              _react2.default.createElement(_reactBootstrap.Input, {
	                type: 'text',
	                addonBefore: '$',
	                disabled: true,
	                value: (0, _NumberUtil.roundTo)(change, 2).toFixed(2)
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'centerStyle' },
	            _react2.default.createElement(_SpinnerButton2.default, {
	              className: 'mr',
	              bsStyle: 'success',
	              type: 'button',
	              icon: 'fa-save',
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' }),
	              disabled: this.props.editingPosPayment,
	              loading: this.props.editingPosPayment,
	              onClick: this.handleSaveOnClick
	            }),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                type: 'button',
	                onClick: this.props.onCloseClicked
	              },
	              _react2.default.createElement('em', { className: 'fa fa-close' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditPosPaymentModal;
	}(_react.Component);
	
	EditPosPaymentModal.propTypes = {
	  onCloseClicked: _propTypes2.default.func.isRequired,
	  editPosPayment: _propTypes2.default.func.isRequired,
	  editingPosPayment: _propTypes2.default.bool.isRequired,
	  editedPosPayment: _propTypes2.default.bool.isRequired,
	  posID: _propTypes2.default.number.isRequired,
	  paymentInfo: _propTypes2.default.shape({
	    cardAmount: _propTypes2.default.number,
	    cardNum: _propTypes2.default.string,
	    cashAmount: _propTypes2.default.number,
	    change: _propTypes2.default.number,
	    checkAmount: _propTypes2.default.number,
	    checkNum: _propTypes2.default.string
	  }).isRequired
	};
	
	var _default = EditPosPaymentModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(EditPosPaymentModal, 'EditPosPaymentModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/EditPosPaymentModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/EditPosPaymentModal.jsx');
	}();

	;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactSelect = __webpack_require__(29);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CARD_TYPE = {
	  VISA: 'Visa',
	  MASTER: 'Master',
	  AMEX: 'American Express',
	  DISCOVER: 'Discover'
	};
	
	var MSOPaymentInfo = function (_Component) {
	  _inherits(MSOPaymentInfo, _Component);
	
	  function MSOPaymentInfo(args) {
	    _classCallCheck(this, MSOPaymentInfo);
	
	    var _this = _possibleConstructorReturn(this, (MSOPaymentInfo.__proto__ || Object.getPrototypeOf(MSOPaymentInfo)).call(this, args));
	
	    _this.state = {
	      error: null,
	      info: {
	        captured: false,
	        amount: 0.00,
	        amountRefunded: 0.00,
	        amountInvoice: 0.00,
	        amountDelivery: 0.00,
	        amountTip: 0.00,
	        amountCharged: 0.00,
	        net: 0.00,
	        fee: 0.00,
	        name: null,
	        date: null,
	        last4: null,
	        paypalEmail: null,
	        currency: 'usd',
	        brand: null,
	        cardType: null,
	        address: {
	          line1: null,
	          line2: null,
	          city: null,
	          state: null,
	          zip: null
	        },
	        refunded: false,
	        refunds: []
	      },
	      refundReason: '',
	      refundOption: 'full',
	      refundAmount: 0.00,
	      refundAmountIllegal: false
	    };
	    return _this;
	  }
	
	  _createClass(MSOPaymentInfo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var info = this.props.info;
	
	      this.setStateWithProps(info);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.info !== nextProps.info) {
	        this.setStateWithProps(nextProps.info);
	      }
	    }
	  }, {
	    key: 'setStateWithProps',
	    value: function setStateWithProps(info) {
	      var date = info.Created ? new Date(info.Created * 1000) : null;
	      if (date) {
	        date = date.setDate(date.getDate() + 7);
	      }
	      if (info) {
	        this.setState({
	          info: {
	            amount: info.Amount ? info.Amount : 0.00,
	            amountRefunded: info.Amount_Refunded ? info.Amount_Refunded : 0.00,
	            amountInvoice: info.Amount_Invoice ? info.Amount_Invoice : 0.00,
	            amountDelivery: info.Amount_Delivery ? info.Amount_Delivery : 0.00,
	            amountTip: info.Amount_Tip ? info.Amount_Tip : 0.00,
	            amountCharged: info.Amount_Charged ? info.Amount_Charged : 0.00,
	            net: info.Net_Receive ? info.Net_Receive : 0.00,
	            fee: info.Fee ? info.Fee : 0.00,
	            date: date,
	            last4: info.Last_Four ? info.Last_Four : null,
	            paypalEmail: info.PaypalEmail ? info.PaypalEmail : null,
	            currency: info.Currency ? info.Currency : 'usd',
	            brand: info.Brand ? info.Brand : null,
	            cardType: info.Card_Type ? info.Card_Type : null,
	            captured: info.Captured ? info.Captured : false,
	            name: info.Name ? info.Name : this.props.Billing.FirstName + ' ' + this.props.Billing.LastName,
	            address: {
	              line1: info.Address_Line1,
	              line2: info.Address_Line2,
	              city: info.Address_City,
	              state: info.Address_State,
	              zip: info.Address_Zip
	            },
	            refunded: info.Refunded,
	            refunds: info.Refunds,
	            method: info.Method,
	            isYuansfer: info.IsYuansfer
	          },
	          refundAmount: info.Amount_Charged.toFixed(2),
	          error: info.Error ? info.error : null
	        });
	      }
	    }
	  }, {
	    key: 'getBrand',
	    value: function getBrand(brand) {
	      if (brand === CARD_TYPE.VISA) {
	        return 'fa-cc-visa';
	      } else if (brand === CARD_TYPE.MASTER) {
	        return 'fa-cc-mastercard';
	      } else if (brand === CARD_TYPE.AMEX) {
	        return 'fa-cc-amex';
	      } else if (brand === CARD_TYPE.DISCOVER) {
	        return 'fa-cc-discover';
	      }
	    }
	
	    /*
	      button status :
	        0: initial state
	        200: success
	        400: failure
	    */
	
	  }, {
	    key: 'buttonStatus',
	    value: function buttonStatus(captured, status) {
	      var error = this.state.error;
	
	      if (error) {
	        return 'danger';
	      }
	      if (captured && status === 0) {
	        return 'warning';
	      }
	      if (this.props.info.Method) {
	        if (this.props.info.Method === 'alipay' || this.props.info.Method === 'wechatpay') {
	          return 'warning';
	        }
	      }
	      if (status === 200) {
	        return 'success';
	      } else if (status === 400) {
	        return 'danger';
	      }
	      return '';
	    }
	  }, {
	    key: 'buttonText',
	    value: function buttonText(captured, status) {
	      var error = this.props.refund.error;
	      // const { captured } = this.props.info;
	
	      if (error) {
	        return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'error' });
	      }
	      if (captured && status === 0) {
	        return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'refund' });
	      }
	      if (this.props.info.Method) {
	        if (this.props.info.Method === 'alipay' || this.props.info.Method === 'wechatpay') {
	          return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'refund' });
	        }
	      }
	      if (status === 200) {
	        return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'refund_successful' });
	      }
	      return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'release' });
	    }
	  }, {
	    key: 'handlePaymentButtonClick',
	    value: function handlePaymentButtonClick(event) {
	      event.preventDefault();
	      var _state = this.state,
	          refundAmount = _state.refundAmount,
	          refundReason = _state.refundReason;
	
	      this.props.openConfirmRefund({ refundAmount: refundAmount, refundReason: refundReason });
	    }
	  }, {
	    key: 'handleRefundOptionChange',
	    value: function handleRefundOptionChange(event) {
	      var refundOption = event.target.value;
	      this.setState({
	        refundOption: refundOption
	      });
	
	      var amountCharged = this.state.info.amountCharged;
	
	      if (refundOption === 'full') {
	        this.setState({
	          refundAmountIllegal: false,
	          refundAmount: amountCharged.toFixed(2)
	        });
	      }
	    }
	  }, {
	    key: 'handleRefundAmountChange',
	    value: function handleRefundAmountChange(event) {
	      var refundAmount = event.target.value;
	      var illegal = !(/^\d+\.\d(\d?)$/.test(refundAmount) || /^\d+$/.test(refundAmount));
	      if (illegal) {
	        this.setState({
	          refundAmountIllegal: true,
	          refundAmount: event.target.value
	        });
	        return;
	      }
	      this.setState({
	        refundAmountIllegal: false,
	        refundAmount: event.target.value
	      });
	    }
	  }, {
	    key: 'handleRefundAmountKeyPress',
	    value: function handleRefundAmountKeyPress(event) {
	      var keyCode = event.keyCode || event.which;
	      var keyValue = String.fromCharCode(keyCode);
	
	      // only allows numbers and '.'
	      if (!/\d|\./.test(keyValue)) {
	        event.preventDefault();
	      }
	    }
	  }, {
	    key: 'handleRefundReasonChange',
	    value: function handleRefundReasonChange(selection) {
	      this.setState({
	        refundReason: selection ? selection.value : ''
	      });
	    }
	  }, {
	    key: 'buttonShouldDisable',
	    value: function buttonShouldDisable(props) {
	      var loading = props.loading,
	          status = props.status,
	          refunded = props.refunded,
	          refundAmountIllegal = props.refundAmountIllegal;
	
	      if (loading || refunded) {
	        return true;
	      }
	      if (status !== 0) {
	        return true;
	      }
	      if (refundAmountIllegal) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'renderAddress',
	    value: function renderAddress() {
	      var address = this.state.info.address;
	
	      var seperator = address.city && address.state ? ',' : '';
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'justify-content-start' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'billing_address' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'justify-content-center' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'label',
	                null,
	                address.line1
	              )
	            ),
	            address.line2 ? _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'label',
	                null,
	                address.line2
	              )
	            ) : null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'label',
	                null,
	                address.city,
	                seperator,
	                '\xA0',
	                address.state,
	                '\xA0',
	                address.zip
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderRefundButton',
	    value: function renderRefundButton() {
	      var _props$refund = this.props.refund,
	          loading = _props$refund.loading,
	          status = _props$refund.status;
	      var _state2 = this.state,
	          _state2$info = _state2.info,
	          captured = _state2$info.captured,
	          refunded = _state2$info.refunded,
	          refundAmountIllegal = _state2.refundAmountIllegal;
	
	      var buttonIcon = void 0;
	      if (loading) {
	        buttonIcon = 'fa-spinner fa-spin';
	      } else if (status === 200) {
	        buttonIcon = 'fa-check-circle-o fa-lg';
	      } else {
	        buttonIcon = 'fa-undo';
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          block: true,
	          bsStyle: this.buttonStatus(captured, status),
	          onClick: this.handlePaymentButtonClick.bind(this),
	          disabled: this.buttonShouldDisable({ loading: loading, status: status, refunded: refunded, refundAmountIllegal: refundAmountIllegal })
	        },
	        _react2.default.createElement('i', { className: 'fa ' + buttonIcon, 'aria-hidden': 'true' }),
	        '\xA0',
	        this.buttonText(captured, status)
	      );
	    }
	  }, {
	    key: 'renderPrint',
	    value: function renderPrint() {
	      var _this2 = this;
	
	      var orderID = this.props.orderID;
	      var refunds = this.state.info.refunds;
	      var _props$refund2 = this.props.refund,
	          error = _props$refund2.error,
	          status = _props$refund2.status;
	
	      var buttonShouldEnable = status === 200 || Array.isArray(refunds) && refunds.length > 0;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          block: true,
	          bsStyle: 'primary',
	          type: 'button',
	          onClick: function onClick() {
	            _this2.props.printMSORefundPDF(orderID);
	          },
	          disabled: !buttonShouldEnable
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'refund_summary' })
	      );
	    }
	  }, {
	    key: 'renderRefundOptions',
	    value: function renderRefundOptions() {
	      var _state3 = this.state,
	          refundOption = _state3.refundOption,
	          refundAmount = _state3.refundAmount,
	          refundAmountIllegal = _state3.refundAmountIllegal;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'refund_type' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              'fieldset',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 6, className: 'refund-options-group' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    value: 'full',
	                    checked: refundOption === 'full',
	                    onChange: this.handleRefundOptionChange.bind(this)
	                  }),
	                  'Full'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 6, className: 'refund-options-group' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    value: 'partial',
	                    checked: refundOption === 'partial',
	                    onChange: this.handleRefundOptionChange.bind(this)
	                  }),
	                  'Partial'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12, className: 'refund-options-group' },
	                _react2.default.createElement(_reactBootstrap.Input, {
	                  className: refundAmountIllegal ? 'error' : '',
	                  name: 'refund-amount',
	                  type: 'text',
	                  placeholder: 'refund amount xxx.xx',
	                  disabled: refundOption === 'partial' ? false : 'disabled',
	                  value: refundAmount,
	                  onChange: this.handleRefundAmountChange.bind(this),
	                  onKeyPress: this.handleRefundAmountKeyPress
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderRefundReasons',
	    value: function renderRefundReasons() {
	      var refundReason = this.state.refundReason;
	
	      var returnReasonOptions = [{ value: 'damaged', label: 'Damaged' }, { value: 'defective', label: 'Defective' }, { value: 'no_need', label: 'No Need' }, { value: 'repair', label: 'Repair' }, { value: 'wrong_item', label: 'Wrong Item' }, { value: "missing", label: "Missing" }, { value: 'other', label: 'Other' }, { value: 'out', label: 'Out' }, { value: 'short', label: 'Short' }];
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'refund_reason' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(_reactSelect2.default, {
	            className: 'testSelect',
	            value: refundReason,
	            options: returnReasonOptions,
	            onChange: this.handleRefundReasonChange.bind(this)
	          })
	        )
	      );
	    }
	
	    // renderAmountRefunded() {
	    //   const { refunded, amountRefunded } = this.state.info;
	    //   if (refunded) {
	    //     return (
	    //       <Col xs={12}>
	    //         <label><Translate value="refund" /></label>
	    //         <label className='pull-right'><span className='dollar-sign'>$</span>{ amountRefunded.toFixed(2) }</label>
	    //       </Col>
	    //     );
	    //   }
	    //   return <ContentWrapper />;
	    // }
	
	  }, {
	    key: 'renderPaymentDetails',
	    value: function renderPaymentDetails() {
	      var _state$info = this.state.info,
	          amount = _state$info.amount,
	          fee = _state$info.fee,
	          date = _state$info.date,
	          last4 = _state$info.last4,
	          brand = _state$info.brand,
	          name = _state$info.name,
	          captured = _state$info.captured,
	          amountInvoice = _state$info.amountInvoice,
	          amountCharged = _state$info.amountCharged,
	          amountRefunded = _state$info.amountRefunded,
	          amountDelivery = _state$info.amountDelivery,
	          amountTip = _state$info.amountTip,
	          net = _state$info.net,
	          method = _state$info.method,
	          isYuansfer = _state$info.isYuansfer,
	          paypalEmail = _state$info.paypalEmail,
	          cardType = _state$info.cardType;
	
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_details' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'pull-right' },
	            name
	          )
	        ),
	        isYuansfer && _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'method' })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'pull-right' },
	            method
	          )
	        ),
	        !isYuansfer && !paypalEmail && _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          cardType === "ACH" && _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bank_account' })
	          ),
	          cardType !== "ACH" && _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit_card' })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'pull-right' },
	            _react2.default.createElement('i', { className: 'fa ' + this.getBrand(brand) + ' fa-lg' }),
	            '\xA0',
	            last4
	          )
	        ),
	        !isYuansfer && paypalEmail && _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'paypal' })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'pull-right' },
	            _react2.default.createElement('i', { className: 'fa ' + this.getBrand(brand) + ' fa-lg' }),
	            '\xA0',
	            paypalEmail
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order' })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'pull-right' },
	            _react2.default.createElement(
	              'span',
	              { className: 'dollar-sign' },
	              '$'
	            ),
	            this.props.totalPrice.toFixed(2)
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delivery' })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'pull-right' },
	            _react2.default.createElement(
	              'span',
	              { className: 'dollar-sign' },
	              '$'
	            ),
	            amountDelivery.toFixed(2)
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit' })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'pull-right' },
	            _react2.default.createElement(
	              'span',
	              { className: 'dollar-sign' },
	              '-$'
	            ),
	            this.props.credit.toFixed(2)
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tip' })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'pull-right' },
	            _react2.default.createElement(
	              'span',
	              { className: 'dollar-sign' },
	              '$'
	            ),
	            amountTip.toFixed(2)
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'transaction_fee' })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'pull-right' },
	            _react2.default.createElement(
	              'span',
	              { className: 'dollar-sign' },
	              '$'
	            ),
	            fee.toFixed(2)
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'charged' })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'pull-right' },
	            _react2.default.createElement(
	              'span',
	              { className: 'dollar-sign' },
	              '$'
	            ),
	            amountCharged.toFixed(2)
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'refund' })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'pull-right' },
	            _react2.default.createElement(
	              'span',
	              { className: 'dollar-sign' },
	              '$'
	            ),
	            amountRefunded.toFixed(2)
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net' })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'pull-right' },
	            _react2.default.createElement(
	              'span',
	              { className: 'dollar-sign' },
	              '$'
	            ),
	            net.toFixed(2)
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cc_hold_until' })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'pull-right' },
	            date ? Intl.DateTimeFormat().format(date) : ''
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderRefundError',
	    value: function renderRefundError() {
	      var error = this.props.refund.error;
	
	
	      if (error) {
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'label',
	            { className: 'error-message' },
	            error.error
	          )
	        );
	      }
	      return _react2.default.createElement(_ContentWrapper2.default, null);
	    }
	
	    /* Refund Section */
	
	  }, {
	    key: 'renderRefund',
	    value: function renderRefund() {
	      var _state$info2 = this.state.info,
	          captured = _state$info2.captured,
	          refunded = _state$info2.refunded;
	
	      if (this.state.info.method && !captured) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'refund' })
	              )
	            ),
	            refunded ? '' : this.renderRefundOptions(),
	            refunded ? '' : this.renderRefundReasons()
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              this.renderRefundButton(),
	              this.renderPrint()
	            ),
	            this.renderRefundError()
	          )
	        );
	      } else if (captured && !this.state.info.method) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'refund' })
	              )
	            ),
	            refunded ? '' : this.renderRefundOptions(),
	            refunded ? '' : this.renderRefundReasons()
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              this.renderRefundButton(),
	              this.renderPrint()
	            ),
	            this.renderRefundError()
	          )
	        );
	      } else {
	        return _react2.default.createElement(_ContentWrapper2.default, null);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        this.renderPaymentDetails(),
	        this.renderAddress(),
	        this.renderRefund()
	      );
	    }
	  }]);
	
	  return MSOPaymentInfo;
	}(_react.Component);
	
	var _default = MSOPaymentInfo;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CARD_TYPE, 'CARD_TYPE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/MSOPaymentInfo.jsx');
	
	  __REACT_HOT_LOADER__.register(MSOPaymentInfo, 'MSOPaymentInfo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/MSOPaymentInfo.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/MSOPaymentInfo.jsx');
	}();

	;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _map = __webpack_require__(55);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _filter = __webpack_require__(84);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _utils = __webpack_require__(121);
	
	var _components = __webpack_require__(120);
	
	var _promotions_actions = __webpack_require__(71);
	
	var _groupList_actions = __webpack_require__(90);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import PropTypes from 'prop-types';
	
	
	var isAFM = _root_url.ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afm-scm.truckxi.com/api/';
	
	// const propTypes = {
	// };
	
	// const defaultProps = {
	// };
	
	var PromotionsPage = function (_Component) {
	  _inherits(PromotionsPage, _Component);
	
	  function PromotionsPage(props) {
	    _classCallCheck(this, PromotionsPage);
	
	    var _this = _possibleConstructorReturn(this, (PromotionsPage.__proto__ || Object.getPrototypeOf(PromotionsPage)).call(this, props));
	
	    _this.getCustomerOptions = function () {
	      var customerList = _this.state.customerList;
	
	      var customerOptions = [{ value: 'All', label: 'All' }];
	      (0, _map2.default)(customerList, function (customer) {
	        var option = { value: customer.Name, label: customer.Name };
	        customerOptions.push(option);
	      });
	      return customerOptions;
	    };
	
	    _this.getGroupOptions = function () {
	      var groupList = _this.state.groupList;
	      // const groupOptions = [{ value: 'All', label: 'All' }];
	
	      var groupOptions = [];
	      (0, _map2.default)(groupList, function (group) {
	        var option = { value: group.ProductGroup_id, label: group.Name };
	        groupOptions.push(option);
	      });
	      return groupOptions;
	    };
	
	    _this.getCategoryOptions = function () {
	      var categoryList = _this.state.categoryList;
	
	      var categoryOptions = [{ value: null, label: 'All' }];
	
	      (0, _map2.default)(categoryList, function (category) {
	        var option = { value: category.ProductCategory_id, label: category.Name };
	        categoryOptions.push(option);
	      });
	      return categoryOptions;
	    };
	
	    _this.setStartDate = function (e) {
	      if (_this.state.endDateSelected && e > _this.state.endDateSelected) {
	        alert(_reactReduxI18n.I18n.t('please_select_a_start_date_that_is_before_the_end_date'));
	        return;
	      }
	      _this.setState({ startDateSelected: e });
	    };
	
	    _this.setEndDate = function (e) {
	      if (_this.state.startDateSelected && e < _this.state.startDateSelected) {
	        alert(_reactReduxI18n.I18n.t('please_select_an_end_date_that_is_after_the_start_date'));
	        return;
	      }
	      _this.setState({ endDateSelected: e });
	    };
	
	    _this.openEditPromotion = function () {
	      _this.setState({ editPromotionOpen: true });
	    };
	
	    _this.closeEditPromotion = function (refresh) {
	      _this.setState({ editPromotionOpen: false }, function () {
	        if (refresh) {
	          _this.handleFetchPromotions();
	        }
	      });
	    };
	
	    _this.openDeletePromotion = function (promotionToDeleteId) {
	      _this.setState({ deletePromotionOpen: true, promotionToDeleteId: promotionToDeleteId });
	    };
	
	    _this.closeDeletePromotion = function () {
	      _this.setState({ deletePromotionOpen: false });
	    };
	
	    _this.handleFetchCustomerGroups = function () {
	      var handleSuccess = function handleSuccess(response) {
	        _this.setState({ customerList: response.data });
	      };
	
	      var handleFailure = function handleFailure(error) {
	        alert(JSON.stringify(error));
	      };
	
	      (0, _groupList_actions.fetchCustomerGroups)(handleSuccess, handleFailure);
	    };
	
	    _this.handleFetchPromotions = function () {
	      var handleSuccess = function handleSuccess(response) {
	        var promotions = response.data.promotions;
	
	        var rows = (0, _filter2.default)(promotions, function (promotion) {
	          return promotion.Method === _this.state.tabsKey;
	        });
	        var promotionsTableData = _extends({}, _this.state.promotionsTableData, { rows: rows });
	        _this.setState({
	          isLoadingPromotions: false,
	          promotions: promotions,
	          promotionsTableData: promotionsTableData
	        });
	      };
	
	      var handleFailure = function handleFailure(error) {
	        _this.setState({ isLoadingPromotions: false });
	        alert(JSON.stringify(error));
	      };
	      _this.setState({ isLoadingPromotions: true }, function () {
	        (0, _promotions_actions.fetchPromotions)(handleSuccess, handleFailure);
	      });
	    };
	
	    _this.handleFetchGroups = function () {
	      var handleSuccess = function handleSuccess(groups) {
	        _this.setState({
	          isLoadingPromotions: false,
	          groupList: groups,
	          categoryList: [],
	          selectedGroup: '',
	          selectedCategory: ''
	        });
	      };
	
	      var handleFailure = function handleFailure(error) {
	        _this.setState({ isLoadingPromotions: false });
	        alert(JSON.stringify(error));
	      };
	      _this.setState({ isLoadingPromotions: true }, function () {
	        (0, _promotions_actions.fetchGroups)(handleSuccess, handleFailure);
	      });
	    };
	
	    _this.handleFetchGroupCategories = function (group_id) {
	      var handleSuccess = function handleSuccess(categories) {
	        _this.setState({
	          isLoadingPromotions: false,
	          categoryList: categories,
	          selectedCategory: ''
	        });
	      };
	
	      var handleFailure = function handleFailure(error) {
	        _this.setState({ isLoadingPromotions: false });
	        alert(JSON.stringify(error));
	      };
	      _this.setState({ isLoadingPromotions: true }, function () {
	        (0, _promotions_actions.fetchGroupCategories)(group_id, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.openConfirmProductRepeat = function () {
	      _this.setState({ confirmProductRepeatOpen: true });
	    };
	
	    _this.closeConfirmProductRepeat = function () {
	      _this.setState({ confirmProductRepeatOpen: false });
	    };
	
	    _this.handleSavePromotionConfirm = function () {
	      var promotionLine = void 0;
	      var noDupes = true;
	      switch (_this.state.tabsKey) {
	        case 'ByQuantity':
	          promotionLine = (0, _utils.desiredShapeByQuantity)(_this.state);
	          break;
	        case 'BuyAGetB':
	          promotionLine = (0, _utils.desiredShapeBuyAGetB)(_this.state);
	          break;
	        case 'ByTotalPriceProduct':
	          promotionLine = (0, _utils.desiredShapeByTotalPriceProduct)(_this.state);
	          break;
	        case 'ByTotalPriceDiscount':
	          promotionLine = (0, _utils.desiredShapeByTotalPriceDiscount)(_this.state);
	          break;
	        default:
	          break;
	      }
	      if (_this.state.promotions && _this.state.promotions.length > 0) {
	        _this.state.promotions.map(function (r) {
	          if (r.Product_id === promotionLine.Product_id) {
	            noDupes = false;
	            _this.openConfirmProductRepeat();
	          }
	        });
	      }
	      if (noDupes === true) {
	        _this.handleSavePromotion();
	      }
	    };
	
	    _this.handleSavePromotion = function () {
	      var handleSuccess = function handleSuccess() {
	        _this.setState({ isLoadingSavePromotion: false }, function () {
	          var state = (0, _utils.clearForm)(_this.state);
	          _this.handleFetchPromotions();
	          _this.setState(state);
	        });
	      };
	
	      var handleFailure = function handleFailure(error) {
	        _this.setState({ isLoadingSavePromotion: false });
	        alert(JSON.stringify(error));
	      };
	      var promotionLine = void 0;
	      switch (_this.state.tabsKey) {
	        case 'ByQuantity':
	          promotionLine = (0, _utils.desiredShapeByQuantity)(_this.state);
	          break;
	        case 'BuyAGetB':
	          promotionLine = (0, _utils.desiredShapeBuyAGetB)(_this.state);
	          break;
	        case 'ByTotalPriceProduct':
	          promotionLine = (0, _utils.desiredShapeByTotalPriceProduct)(_this.state);
	          break;
	        case 'ByTotalPriceDiscount':
	          promotionLine = (0, _utils.desiredShapeByTotalPriceDiscount)(_this.state);
	          break;
	        default:
	          break;
	      }
	      _this.setState({ isLoadingSavePromotion: true }, function () {
	        (0, _promotions_actions.savePromotion)(promotionLine, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.handleOpenEditPromotion = function (promotionLineId) {
	      var handleSuccess = function handleSuccess(response) {
	        _this.setState({
	          isLoadingPromoDetails: false,
	          promotionToEdit: response.data
	        });
	      };
	
	      var handleFailure = function handleFailure(error) {
	        _this.setState({ isLoadingPromoDetails: false });
	        alert(JSON.stringify(error));
	      };
	
	      _this.setState({ isLoadingPromoDetails: true }, function () {
	        _this.openEditPromotion();
	        (0, _promotions_actions.fetchPromoDetails)(promotionLineId, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.handleDeletePromotion = function () {
	      var handleSuccess = function handleSuccess() {
	        _this.handleFetchPromotions();
	      };
	
	      var handleFailure = function handleFailure(error) {
	        alert(JSON.stringify(error));
	      };
	
	      var promotionToDeleteId = _this.state.promotionToDeleteId;
	
	      (0, _promotions_actions.deletePromotion)(promotionToDeleteId, handleSuccess, handleFailure);
	    };
	
	    _this.handleTabSelect = function (key) {
	      if (_this.state.isLoadingSavePromotion) {
	        return;
	      }
	      var rows = (0, _filter2.default)(_this.state.promotions, function (row) {
	        return row.Method === key;
	      });
	      var promotionsTableData = _extends({}, _this.state.promotionsTableData, { rows: rows });
	      _this.setState({ tabsKey: key, promotionsTableData: promotionsTableData });
	    };
	
	    _this.handleSelectionChange = function (value, fieldName) {
	      _this.setState(_defineProperty({}, fieldName, value));
	    };
	
	    _this.handlePriceLevelChange = function (fieldName) {
	      if (_this.state[[fieldName]] === true) {
	        _this.setState(_defineProperty({}, fieldName, false));
	      } else {
	        _this.setState(_defineProperty({}, fieldName, true));
	      }
	    };
	
	    _this.handleOptionChange = function (changeEvent, productSearchType) {
	      _this.setState(_defineProperty({}, productSearchType, changeEvent.target.value));
	    };
	
	    _this.handleDiscountButtonClick = function (discountType) {
	      _this.setState({ discountType: discountType });
	    };
	
	    _this.handleProductSuggestChange = function (e, newValue, fieldName) {
	      _this.setState(_defineProperty({}, fieldName, newValue));
	    };
	
	    _this.handleClearButtonClick = function (selectedProductName, suggestValueName) {
	      var _this$setState6;
	
	      _this.setState((_this$setState6 = {}, _defineProperty(_this$setState6, selectedProductName, {}), _defineProperty(_this$setState6, suggestValueName, ''), _this$setState6));
	    };
	
	    _this.handleDuplicateProductAClick = function () {
	      var selectedProductA = _this.state.selectedProductA;
	
	      _this.setState({ selectedProductB: selectedProductA });
	    };
	
	    _this.handleTextInputChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    };
	
	    _this.handleCheckBoxChange = function (event) {
	      if (event.target.name === 'IsOneTime' && _this.state[event.target.name] === false) {
	        _this.setState({ autoApply: false });
	      }
	      _this.setState(_defineProperty({}, event.target.name, !_this.state[event.target.name]));
	    };
	
	    _this.handleGridSort = function (sortColumn, sortDirection) {
	      var promotionsTableData = Object.assign({}, _this.state.promotionsTableData, { sortColumn: sortColumn, sortDirection: sortDirection });
	      _this.setState({ promotionsTableData: promotionsTableData });
	    };
	
	    _this.handleFilterChange = function (filter) {
	      var newFilters = Object.assign({}, _this.state.promotionsTableData.filters);
	      if (filter.filterTerm) {
	        newFilters[filter.column.key] = filter;
	      } else {
	        delete newFilters[filter.column.key];
	      }
	      var promotionsTableData = _extends({}, _this.state.promotionsTableData, { filters: newFilters });
	      _this.setState({ promotionsTableData: promotionsTableData });
	    };
	
	    _this.handleClearFilters = function () {
	      var promotionsTableData = _extends({}, _this.state.promotionsTableData, { filters: {} });
	      _this.setState({ promotionsTableData: promotionsTableData });
	    };
	
	    _this.selectInventoryInfo = function (productNum, selectedInventoryRow, selectedProduct) {
	      var _this$setState9;
	
	      var product = (0, _utils.cleanProduct)(selectedInventoryRow);
	      _this.setState((_this$setState9 = {}, _defineProperty(_this$setState9, selectedProduct, product), _defineProperty(_this$setState9, 'suggestValue', ''), _this$setState9));
	    };
	
	    _this.handleGroupChange = function (group) {
	      _this.handleFetchGroupCategories(group);
	      _this.handleSelectionChange(group, 'selectedGroup');
	    };
	
	    _this.renderByQuantityPromoDetails = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'promo-section' },
	        _react2.default.createElement(_components.PromotionSetup, {
	          setStartDate: _this.setStartDate,
	          startDateSelected: _this.state.startDateSelected,
	          setEndDate: _this.setEndDate,
	          endDateSelected: _this.state.endDateSelected,
	          handleSelectionChange: _this.handleSelectionChange,
	          customerGroupSelected: _this.state.customerGroupSelected,
	          paymentTypeSelected: _this.state.paymentTypeSelected,
	          customerOptions: _this.getCustomerOptions()
	        }),
	        _react2.default.createElement(_components.ByQuantityFields, {
	          paymentTypeSelected: _this.state.paymentTypeSelected,
	          methodSelected: _this.state.methodSelected,
	          quantityFrom: _this.state.quantityFrom,
	          quantityTo: _this.state.quantityTo,
	          discountValue: _this.state.discountValue,
	          discountType: _this.state.discountType,
	          applyLv1: _this.state.applyLv1,
	          applyLv2: _this.state.applyLv2,
	          applyLv3: _this.state.applyLv3,
	          applyLv4: _this.state.applyLv4,
	          applyLv5: _this.state.applyLv5,
	          handlePriceLevelChange: _this.handlePriceLevelChange,
	          handleSelectionChange: _this.handleSelectionChange,
	          handleTextInputChange: _this.handleTextInputChange,
	          handleDiscountButtonClick: _this.handleDiscountButtonClick
	        }),
	        _react2.default.createElement(_SpinnerButton2.default, {
	          bsStyle: 'success',
	          className: 'save-button'
	          // onClick={this.handleSavePromotion}
	          , onClick: _this.handleSavePromotionConfirm,
	          disabled: _this.state.isLoadingSavePromotion || (0, _utils.isIncompleteForm)(_this.state, 'ByQuantity'),
	          loading: _this.state.isLoadingSavePromotion,
	          icon: 'fa-save',
	          translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	        })
	      );
	    };
	
	    _this.renderBuyAGetBPromoDetails = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'promo-section' },
	        _react2.default.createElement(_components.PromotionSetup, {
	          setStartDate: _this.setStartDate,
	          startDateSelected: _this.state.startDateSelected,
	          setEndDate: _this.setEndDate,
	          endDateSelected: _this.state.endDateSelected,
	          handleSelectionChange: _this.handleSelectionChange,
	          customerGroupSelected: _this.state.customerGroupSelected,
	          paymentTypeSelected: _this.state.paymentTypeSelected,
	          customerOptions: _this.getCustomerOptions()
	        }),
	        _react2.default.createElement(_components.BuyAGetBFields, {
	          methodSelected: _this.state.methodSelected,
	          productQuantityA: _this.state.productQuantityA,
	          productQuantityB: _this.state.productQuantityB,
	          discountValue: _this.state.discountValue,
	          discountType: _this.state.discountType,
	          handleSelectionChange: _this.handleSelectionChange,
	          handleDiscountButtonClick: _this.handleDiscountButtonClick,
	          handleTextInputChange: _this.handleTextInputChange
	        }),
	        _react2.default.createElement(_SpinnerButton2.default, {
	          bsStyle: 'success',
	          className: 'save-button'
	          // onClick={this.handleSavePromotion}
	          , onClick: _this.handleSavePromotionConfirm,
	          disabled: _this.state.isLoadingSavePromotion || (0, _utils.isIncompleteForm)(_this.state, 'BuyAGetB'),
	          loading: _this.state.isLoadingSavePromotion,
	          icon: 'fa-save',
	          translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	        })
	      );
	    };
	
	    _this.renderByTotalPriceProductPromoDetails = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'promo-section' },
	        _react2.default.createElement(_components.PromotionSetup, {
	          setStartDate: _this.setStartDate,
	          startDateSelected: _this.state.startDateSelected,
	          setEndDate: _this.setEndDate,
	          endDateSelected: _this.state.endDateSelected,
	          handleSelectionChange: _this.handleSelectionChange,
	          customerGroupSelected: _this.state.customerGroupSelected,
	          paymentTypeSelected: _this.state.paymentTypeSelected,
	          customerOptions: _this.getCustomerOptions()
	        }),
	        _react2.default.createElement(_components.ByTotalPriceProductFields, {
	          editing: false,
	          minPurchasePrice: _this.state.minPurchasePrice,
	          productQuantityB: _this.state.productQuantityB,
	          SalesType: _this.state.SalesType,
	          handleTextInputChange: _this.handleTextInputChange,
	          handleSelectionChange: _this.handleSelectionChange
	        }),
	        _react2.default.createElement(_SpinnerButton2.default, {
	          bsStyle: 'success',
	          className: 'save-button'
	          // onClick={this.handleSavePromotion}
	          , onClick: _this.handleSavePromotionConfirm,
	          disabled: _this.state.isLoadingSavePromotion || (0, _utils.isIncompleteForm)(_this.state, 'ByTotalPriceProduct'),
	          loading: _this.state.isLoadingSavePromotion,
	          icon: 'fa-save',
	          translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	        })
	      );
	    };
	
	    _this.renderByTotalPriceDiscountPromoDetails = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'promo-section' },
	        _react2.default.createElement(_components.PromotionSetup, {
	          setStartDate: _this.setStartDate,
	          startDateSelected: _this.state.startDateSelected,
	          setEndDate: _this.setEndDate,
	          endDateSelected: _this.state.endDateSelected,
	          handleSelectionChange: _this.handleSelectionChange,
	          customerGroupSelected: _this.state.customerGroupSelected,
	          paymentTypeSelected: _this.state.paymentTypeSelected,
	          customerOptions: _this.getCustomerOptions()
	        }),
	        _react2.default.createElement(_components.ByTotalPriceDiscountFields, {
	          minPurchasePrice: _this.state.minPurchasePrice,
	          discountValue: _this.state.discountValue,
	          discountType: _this.state.discountType,
	          SalesType: _this.state.SalesType,
	          handleDiscountButtonClick: _this.handleDiscountButtonClick,
	          handleTextInputChange: _this.handleTextInputChange,
	          handleSelectionChange: _this.handleSelectionChange
	        }),
	        _react2.default.createElement(_SpinnerButton2.default, {
	          bsStyle: 'success',
	          className: 'save-button'
	          // onClick={this.handleSavePromotion}
	          , onClick: _this.handleSavePromotionConfirm,
	          disabled: _this.state.isLoadingSavePromotion || (0, _utils.isIncompleteForm)(_this.state, 'ByTotalPriceDiscount'),
	          loading: _this.state.isLoadingSavePromotion,
	          icon: 'fa-save',
	          translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	        })
	      );
	    };
	
	    _this.renderByQuantityTab = function () {
	      var byQuantityTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_quantity_discount' });
	      return _react2.default.createElement(
	        _reactBootstrap.Tab,
	        { eventKey: 'ByQuantity', title: byQuantityTitle },
	        _react2.default.createElement(
	          'div',
	          { className: 'by-quantity-tab' },
	          _react2.default.createElement(_components.PromotionsProductSearch, {
	            productSearchType: _this.state.productSearchType,
	            suggestValue: _this.state.suggestValue,
	            selectedProduct: _this.state.selectedProduct,
	            handleOptionChange: _this.handleOptionChange,
	            handleProductSuggestChange: _this.handleProductSuggestChange,
	            selectInventoryInfo: _this.selectInventoryInfo,
	
	            groupSearch: true,
	            handleSelectionChange: _this.handleSelectionChange,
	            handleGroupChange: _this.handleGroupChange,
	            groupOptions: _this.getGroupOptions(),
	            categoryOptions: _this.getCategoryOptions(),
	            selectedGroup: _this.state.selectedGroup,
	            selectedCategory: _this.state.selectedCategory
	          }),
	          _react2.default.createElement('div', { className: 'divider' }),
	          _this.renderByQuantityPromoDetails()
	        )
	      );
	    };
	
	    _this.renderBuyAGetBTab = function () {
	      // const buyAGetBTitle = (<Translate value="buy_a_get_b" />);
	      var buyAGetBTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_quantity_product' });
	      return _react2.default.createElement(
	        _reactBootstrap.Tab,
	        { eventKey: 'BuyAGetB', title: buyAGetBTitle },
	        _react2.default.createElement(
	          'div',
	          { className: 'buy-a-get-b-tab' },
	          _react2.default.createElement(_components.BuyAGetBProductSearches, {
	            productSearchTypeA: _this.state.productSearchTypeA,
	            suggestValueA: _this.state.suggestValueA,
	            selectedProductA: _this.state.selectedProductA,
	            productSearchTypeB: _this.state.productSearchTypeB,
	            suggestValueB: _this.state.suggestValueB,
	            selectedProductB: _this.state.selectedProductB,
	            handleOptionChange: _this.handleOptionChange,
	            handleProductSuggestChange: _this.handleProductSuggestChange,
	            selectInventoryInfo: _this.selectInventoryInfo,
	            handleClearButtonClick: _this.handleClearButtonClick,
	            handleDuplicateProductAClick: _this.handleDuplicateProductAClick,
	
	            handleSelectionChange: _this.handleSelectionChange,
	            handleGroupChange: _this.handleGroupChange,
	            groupOptions: _this.getGroupOptions(),
	            categoryOptions: _this.getCategoryOptions(),
	            selectedGroup: _this.state.selectedGroup,
	            selectedCategory: _this.state.selectedCategory
	          }),
	          _react2.default.createElement('div', { className: 'divider' }),
	          _this.renderBuyAGetBPromoDetails()
	        )
	      );
	    };
	
	    _this.renderByTotalPriceProductTab = function () {
	      var byTotalPriceProductTitle = _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_total_price' }),
	        ' (',
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product' }),
	        ')'
	      );
	      return _react2.default.createElement(
	        _reactBootstrap.Tab,
	        { eventKey: 'ByTotalPriceProduct', title: byTotalPriceProductTitle },
	        _react2.default.createElement(
	          'div',
	          { className: 'by-total-price-product-tab' },
	          _react2.default.createElement(
	            'div',
	            { className: 'promo-code-section-product' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'promo-code', className: 'promo-code-label' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'promo_code' }),
	              ':'
	            ),
	            _react2.default.createElement('input', {
	              id: 'promo-code-text-input-product',
	              name: 'promoCode',
	              className: 'text-input-field',
	              type: 'text',
	              value: _this.state.promoCode,
	              onChange: _this.handleTextInputChange
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'auto-apply-wrapper' },
	              _react2.default.createElement('input', {
	                id: 'auto-apply-checkbox',
	                name: 'autoApply',
	                type: 'checkbox',
	                disabled: _this.state.IsOneTime,
	                checked: _this.state.autoApply,
	                onChange: _this.handleCheckBoxChange
	              }),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'auto-apply', className: 'auto-apply-label' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'auto_apply' })
	              )
	            ),
	            _root_url.isElegant && _react2.default.createElement(
	              'div',
	              { className: 'auto-apply-wrapper' },
	              _react2.default.createElement('input', {
	                id: 'one-time-checkbox',
	                name: 'IsOneTime',
	                type: 'checkbox',
	                checked: _this.state.IsOneTime,
	                onChange: _this.handleCheckBoxChange
	              }),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'one-time', className: 'one-time-label' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'one_time_use' })
	              )
	            ),
	            isAFM && _react2.default.createElement(
	              'div',
	              { className: 'auto-apply-wrapper' },
	              _react2.default.createElement('input', {
	                id: 'is-public-checkbox',
	                name: 'IsPublic',
	                type: 'checkbox',
	                checked: _this.state.IsPublic,
	                onChange: _this.handleCheckBoxChange
	              }),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'is-public', className: 'is-public-label' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'is_public' })
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'divider', style: { marginRight: '10px' } }),
	          _react2.default.createElement(_components.PromotionsProductSearch, {
	            productSearchType: _this.state.productSearchType,
	            suggestValue: _this.state.suggestValue,
	            selectedProduct: _this.state.selectedProduct,
	            handleOptionChange: _this.handleOptionChange,
	            handleProductSuggestChange: _this.handleProductSuggestChange,
	            selectInventoryInfo: _this.selectInventoryInfo,
	
	            groupSearch: false,
	            handleSelectionChange: _this.handleSelectionChange,
	            handleGroupChange: _this.handleGroupChange,
	            groupOptions: _this.getGroupOptions(),
	            categoryOptions: _this.getCategoryOptions(),
	            selectedGroup: _this.state.selectedGroup,
	            selectedCategory: _this.state.selectedCategory
	          }),
	          _react2.default.createElement('div', { className: 'divider' }),
	          _this.renderByTotalPriceProductPromoDetails()
	        )
	      );
	    };
	
	    _this.renderByTotalPriceDiscountTab = function () {
	      var byTotalPriceDiscountTitle = _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_total_price' }),
	        ' (',
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount' }),
	        ')'
	      );
	      return _react2.default.createElement(
	        _reactBootstrap.Tab,
	        { eventKey: 'ByTotalPriceDiscount', title: byTotalPriceDiscountTitle },
	        _react2.default.createElement(
	          'div',
	          { className: 'by-total-price-discount-tab' },
	          _react2.default.createElement(
	            'div',
	            { className: 'promo-code-section' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'promo-code', className: 'promo-code-label' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'promo_code' }),
	              ':'
	            ),
	            _react2.default.createElement('input', {
	              id: 'promo-code-text-input',
	              name: 'promoCode',
	              className: 'text-input-field',
	              type: 'text',
	              value: _this.state.promoCode,
	              onChange: _this.handleTextInputChange
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'auto-apply-wrapper' },
	              _react2.default.createElement('input', {
	                id: 'auto-apply-checkbox',
	                name: 'autoApply',
	                type: 'checkbox',
	                disabled: _this.state.IsOneTime,
	                checked: _this.state.autoApply,
	                onChange: _this.handleCheckBoxChange
	              }),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'auto-apply', className: 'auto-apply-label' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'auto_apply' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'auto-apply-wrapper' },
	              _react2.default.createElement('input', {
	                id: 'one-time-checkbox',
	                name: 'IsOneTime',
	                type: 'checkbox',
	                checked: _this.state.IsOneTime,
	                onChange: _this.handleCheckBoxChange
	              }),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'one-time', className: 'one-time-label' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'one_time_use' })
	              )
	            ),
	            isAFM && _react2.default.createElement(
	              'div',
	              { className: 'auto-apply-wrapper' },
	              _react2.default.createElement('input', {
	                id: 'is-public-checkbox',
	                name: 'IsPublic',
	                type: 'checkbox',
	                checked: _this.state.IsPublic,
	                onChange: _this.handleCheckBoxChange
	              }),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'is-public', className: 'is-public-label' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'is_public' })
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'divider' }),
	          _this.renderByTotalPriceDiscountPromoDetails()
	        )
	      );
	    };
	
	    _this.state = {
	      customerList: [],
	      promotions: [],
	      promotionsTableData: {
	        rows: [],
	        selectedRows: null,
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      isLoadingPromotions: false,
	      isLoadingSavePromotion: false,
	      isLoadingPromoDetails: false,
	
	      startDateSelected: null,
	      endDateSelected: null,
	
	      customerGroupSelected: '',
	      paymentTypeSelected: '',
	
	      tabsKey: 'ByQuantity',
	      suggestValue: '',
	      productSearchType: 'ProductNum',
	      selectedProduct: {},
	
	      groupList: [],
	      categoryList: [],
	      selectedGroup: '',
	      selectedCategory: '',
	
	      methodSelected: '',
	      discountValue: '',
	      discountType: 'Dollar',
	      quantityFrom: '',
	      quantityTo: '',
	
	      applyLv1: true,
	      applyLv2: true,
	      applyLv3: true,
	      applyLv4: true,
	      applyLv5: true,
	
	      minPurchasePrice: '',
	
	      productQuantityA: '',
	      productQuantityB: '',
	
	      promoCode: '',
	      autoApply: true,
	      IsOneTime: false,
	      IsPublic: true,
	
	      suggestValueA: '',
	      productSearchTypeA: 'ProductNum',
	      selectedProductA: '',
	
	      suggestValueB: '',
	      productSearchTypeB: 'ProductNum',
	      selectedProductB: '',
	
	      editPromotionOpen: false,
	      deletePromotionOpen: false,
	      confirmProductRepeatOpen: false,
	      promotionToEdit: {},
	      promotionToDeleteId: undefined,
	
	      SalesType: 'all'
	    };
	    return _this;
	  }
	
	  _createClass(PromotionsPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      this.handleFetchCustomerGroups();
	      this.handleFetchPromotions();
	      this.handleFetchGroups();
	    }
	
	    // when click group, gtt category options
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var editPromotionDialog = {
	        width: '750px',
	        height: '500px',
	        marginLeft: '-20%',
	        top: '40%'
	      };
	      var deletePromotionDialogStyle = {
	        width: '550px',
	        height: '300px',
	        marginLeft: '-15%'
	      };
	      var confirmProductRepeatStyle = {
	        width: '550px',
	        height: '300px',
	        marginLeft: '-15%'
	      };
	      var confirmProductRepeatTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'duplicate_product' });
	      var editPromotionTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_promotion' });
	      var isLoadingPromotions = this.state.isLoadingPromotions;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_management' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'promotions' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'promotions-page' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Tabs,
	              { activeKey: this.state.tabsKey, justified: true, onSelect: this.handleTabSelect },
	              this.renderByQuantityTab(),
	              this.renderBuyAGetBTab(),
	              this.renderByTotalPriceProductTab(),
	              this.renderByTotalPriceDiscountTab()
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { className: 'promotions-table-panel' },
	              isLoadingPromotions && _react2.default.createElement(_spinner2.default, null),
	              _react2.default.createElement(_components.PromotionsTable, {
	                promotions: this.state.promotionsTableData,
	                tabsKey: this.state.tabsKey,
	                handleGridSort: this.handleGridSort,
	                handleFilterChange: this.handleFilterChange,
	                openDeletePromotion: this.openDeletePromotion,
	                handleOpenEditPromotion: this.handleOpenEditPromotion,
	                handleClearFilters: this.handleClearFilters
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: editPromotionDialog,
	            isVisible: this.state.editPromotionOpen,
	            onCloseClicked: function onCloseClicked() {
	              return _this2.closeEditPromotion();
	            },
	            title: editPromotionTitle
	          },
	          _react2.default.createElement(_components.EditPromotionModal, {
	            promotion: this.state.promotionToEdit,
	            customerList: this.state.customerList,
	            closeEditPromotion: this.closeEditPromotion,
	            isLoadingPromoDetails: this.state.isLoadingPromoDetails,
	            getGroupOptions: this.getGroupOptions,
	            getCategoryOptions: this.getCategoryOptions,
	            handleFetchGroupCategories: this.handleFetchGroupCategories
	          })
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: deletePromotionDialogStyle,
	            isVisible: this.state.deletePromotionOpen,
	            onCloseClicked: this.closeDeletePromotion
	          },
	          _react2.default.createElement(_confirmActionModal2.default, {
	            'case': 'removeItem',
	            closeC: this.closeDeletePromotion,
	            caseAction: this.handleDeletePromotion
	          })
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: confirmProductRepeatStyle,
	            isVisible: this.state.confirmProductRepeatOpen,
	            onCloseClicked: this.closeConfirmProductRepeat,
	            title: confirmProductRepeatTitle
	          },
	          _react2.default.createElement(_confirmActionModal2.default, {
	            'case': 'confirmProductRepeat',
	            closeC: this.closeConfirmProductRepeat,
	            caseAction: this.handleSavePromotion
	          })
	        )
	      );
	    }
	  }]);
	
	  return PromotionsPage;
	}(_react.Component);
	
	// PromotionsPage.propTypes = propTypes;
	// PromotionsPage.defaultProps = defaultProps;
	
	var _default = PromotionsPage;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isAFM, 'isAFM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/PromotionsPage.jsx');
	
	  __REACT_HOT_LOADER__.register(PromotionsPage, 'PromotionsPage', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/PromotionsPage.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/PromotionsPage.jsx');
	}();

	;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  methodSelected: _propTypes2.default.string,
	  productQuantityA: _propTypes2.default.string,
	  productQuantityB: _propTypes2.default.string,
	  discountValue: _propTypes2.default.string,
	  discountType: _propTypes2.default.string,
	  handleSelectionChange: _propTypes2.default.func,
	  handleDiscountButtonClick: _propTypes2.default.func,
	  handleTextInputChange: _propTypes2.default.func
	};
	
	var defaultProps = {
	  methodSelected: '',
	  productQuantityA: '',
	  productQuantityB: '',
	  discountValue: '',
	  discountType: '',
	  handleSelectionChange: function handleSelectionChange() {},
	  handleDiscountButtonClick: function handleDiscountButtonClick() {},
	  handleTextInputChange: function handleTextInputChange() {}
	};
	
	var methodOptions = [{ label: 'Every', value: 'Every' }, { label: 'Each', value: 'Each' }];
	
	var BuyAGetBFields = function BuyAGetBFields(_ref) {
	  var methodSelected = _ref.methodSelected,
	      productQuantityA = _ref.productQuantityA,
	      productQuantityB = _ref.productQuantityB,
	      discountValue = _ref.discountValue,
	      discountType = _ref.discountType,
	      handleSelectionChange = _ref.handleSelectionChange,
	      handleDiscountButtonClick = _ref.handleDiscountButtonClick,
	      handleTextInputChange = _ref.handleTextInputChange;
	  return _react2.default.createElement(
	    'div',
	    { className: 'promo-fields-b' },
	    _react2.default.createElement(
	      'div',
	      { className: 'method-selection' },
	      _react2.default.createElement(_GenericSelection2.default, {
	        translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'method' }),
	        setSelected: function setSelected(_ref2) {
	          var value = _ref2.value;
	          return handleSelectionChange(value, 'methodSelected');
	        },
	        value: methodSelected,
	        options: methodOptions,
	        colon: true
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-row' },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'qty-label', className: 'field-margin' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	        ':'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-row', id: 'buy-a-get-b-input' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'prod-qty-A', className: 'field-margin' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'buy' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'buy-a-get-b-input-format' },
	          _react2.default.createElement('input', {
	            id: 'qty-A-text-input',
	            name: 'productQuantityA',
	            className: 'text-input-field',
	            type: 'text',
	            value: productQuantityA,
	            onChange: handleTextInputChange
	          }),
	          _react2.default.createElement(
	            'span',
	            null,
	            '(A)'
	          )
	        ),
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'prod-qty-B', className: 'field-margin' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'get' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'buy-a-get-b-input-format' },
	          _react2.default.createElement('input', {
	            id: 'qty-B-text-input',
	            name: 'productQuantityB',
	            className: 'text-input-field',
	            type: 'text',
	            value: productQuantityB,
	            onChange: handleTextInputChange
	          }),
	          _react2.default.createElement(
	            'span',
	            null,
	            '(B)'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'discount-field' },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'discount', className: 'field-margin ' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount' }),
	        ' (B):'
	      ),
	      _react2.default.createElement('input', {
	        id: 'discount-text-input',
	        name: 'discountValue',
	        className: 'text-input-field',
	        type: 'text',
	        value: discountValue,
	        onChange: handleTextInputChange,
	        placeholder: 'free'
	      }),
	      _react2.default.createElement(
	        _reactBootstrap.ButtonToolbar,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: discountType === 'Dollar' ? 'success' : 'null',
	            onClick: function onClick() {
	              return handleDiscountButtonClick('Dollar');
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-usd' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: discountType === 'Percent' ? 'success' : 'null',
	            onClick: function onClick() {
	              return handleDiscountButtonClick('Percent');
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-percent' })
	        )
	      )
	    )
	  );
	};
	
	BuyAGetBFields.propTypes = propTypes;
	BuyAGetBFields.defaultProps = defaultProps;
	
	var _default = BuyAGetBFields;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/BuyAGetBFields.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/BuyAGetBFields.jsx');
	
	  __REACT_HOT_LOADER__.register(methodOptions, 'methodOptions', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/BuyAGetBFields.jsx');
	
	  __REACT_HOT_LOADER__.register(BuyAGetBFields, 'BuyAGetBFields', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/BuyAGetBFields.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/BuyAGetBFields.jsx');
	}();

	;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactTooltip = __webpack_require__(105);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _GenericProductSuggest = __webpack_require__(51);
	
	var _GenericProductSuggest2 = _interopRequireDefault(_GenericProductSuggest);
	
	var _TypeRadios = __webpack_require__(57);
	
	var _TypeRadios2 = _interopRequireDefault(_TypeRadios);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  methodSelected: _propTypes2.default.string,
	  productSearchTypeA: _propTypes2.default.string,
	  suggestValueA: _propTypes2.default.string,
	  selectedProductA: _propTypes2.default.shape({
	    inStock: _propTypes2.default.number,
	    purchased: _propTypes2.default.number,
	    presale: _propTypes2.default.number,
	    net_weight: _propTypes2.default.number,
	    ship_weight: _propTypes2.default.number,
	    PriceLv1: _propTypes2.default.number,
	    PriceLv2: _propTypes2.default.number,
	    PriceLv3: _propTypes2.default.number,
	    PriceLv4: _propTypes2.default.number,
	    PriceLv5: _propTypes2.default.number,
	    currentProdName: _propTypes2.default.string,
	    currentProdNum: _propTypes2.default.string,
	    currentProductDescription: _propTypes2.default.string,
	    currentRefNum: _propTypes2.default.string,
	    currentUnitType: _propTypes2.default.string,
	    currentPackageSize: _propTypes2.default.string,
	    currentProductWeight: _propTypes2.default.number,
	    currentProductCRV: _propTypes2.default.number,
	    currentProductTaxable: _propTypes2.default.string
	  }),
	  productSearchTypeB: _propTypes2.default.string,
	  suggestValueB: _propTypes2.default.string,
	  selectedProductB: _propTypes2.default.shape({/* same as A */}),
	  handleOptionChange: _propTypes2.default.func,
	  handleProductSuggestChange: _propTypes2.default.func,
	  selectInventoryInfo: _propTypes2.default.func,
	  handleClearButtonClick: _propTypes2.default.func,
	  handleDuplicateProductAClick: _propTypes2.default.func
	};
	
	var defaultProps = {
	  methodSelected: '',
	  productSearchTypeA: '',
	  suggestValueA: '',
	  selectedProductA: {},
	  productSearchTypeB: '',
	  suggestValueB: '',
	  selectedProductB: {},
	  handleOptionChange: function handleOptionChange() {},
	  handleProductSuggestChange: function handleProductSuggestChange() {},
	  selectInventoryInfo: function selectInventoryInfo() {},
	  handleClearButtonClick: function handleClearButtonClick() {},
	  handleDuplicateProductAClick: function handleDuplicateProductAClick() {}
	};
	
	var BuyAGetBProductSearches = function BuyAGetBProductSearches(_ref) {
	  var methodSelected = _ref.methodSelected,
	      productSearchTypeA = _ref.productSearchTypeA,
	      productSearchTypeB = _ref.productSearchTypeB,
	      selectedProductA = _ref.selectedProductA,
	      selectedProductB = _ref.selectedProductB,
	      suggestValueA = _ref.suggestValueA,
	      suggestValueB = _ref.suggestValueB,
	      _handleOptionChange = _ref.handleOptionChange,
	      handleProductSuggestChange = _ref.handleProductSuggestChange,
	      handleClearButtonClick = _ref.handleClearButtonClick,
	      selectInventoryInfo = _ref.selectInventoryInfo,
	      handleDuplicateProductAClick = _ref.handleDuplicateProductAClick;
	
	  var detailsStringA = selectedProductA.currentProdNum + ' | ' + selectedProductA.currentRefNum + ' | ' + selectedProductA.currentProdName + ' | ' + selectedProductA.currentProductDescription;
	  var detailsStringB = selectedProductB.currentProdNum + ' | ' + selectedProductB.currentRefNum + ' | ' + selectedProductB.currentProdName + ' | ' + selectedProductB.currentProductDescription;
	  return _react2.default.createElement(
	    'div',
	    { className: 'buy-a-get-b-product-section' },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'productSearchA' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_a' }),
	        ':'
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 12 },
	        _react2.default.createElement(_TypeRadios2.default, {
	          value: productSearchTypeA,
	          handleOptionChange: function handleOptionChange(event) {
	            _handleOptionChange(event, 'productSearchTypeA');
	          }
	        })
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 12, id: 'promotions-auto-suggest' },
	        !selectedProductA || !selectedProductA.currentProdNum ? _react2.default.createElement(
	          'div',
	          { className: 'control-dropdown' },
	          _react2.default.createElement(_GenericProductSuggest2.default, {
	            value: suggestValueA,
	            onChange: function onChange(e, _ref2) {
	              var newValue = _ref2.newValue;
	              return handleProductSuggestChange(e, newValue, 'suggestValueA');
	            },
	            SearchType: productSearchTypeA,
	            fetchOrdersByProduct: function fetchOrdersByProduct(productNum, selectedInventoryRow) {
	              selectInventoryInfo(productNum, selectedInventoryRow, 'selectedProductA');
	            }
	          })
	        ) : _react2.default.createElement(
	          'div',
	          { id: 'suggestion-box' },
	          _react2.default.createElement(
	            _reactTooltip2.default,
	            { id: 'product-a-tool-tip', place: 'top', type: 'dark', effect: 'solid' },
	            _react2.default.createElement(
	              'div',
	              { className: 'product-a-tool-tips' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'unit-type' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_type' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  selectedProductA.currentUnitType
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'package-size' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  selectedProductA.currentPackageSize
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'weight' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  selectedProductA.currentProductWeight
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'price' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_price' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  selectedProductA.currentRefPrice ? '$' + parseFloat(selectedProductA.currentRefPrice).toFixed(2) : ''
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            { 'data-tip': true, 'data-for': 'product-a-tool-tip', className: 'detail-string' },
	            detailsStringA
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'invisible-button pull-right',
	              onClick: function onClick() {
	                return handleClearButtonClick('selectedProductA', 'suggestValueA');
	              }
	            },
	            _react2.default.createElement('em', { className: 'fa fa-times' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'product-b-label' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'productSearchB' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_b' }),
	          ':'
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            className: 'auto-fill-button',
	            onClick: handleDuplicateProductAClick
	          },
	          _react2.default.createElement('em', { className: 'fa fa-edit' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'use_product_a' })
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 12 },
	        _react2.default.createElement(_TypeRadios2.default, {
	          value: productSearchTypeB,
	          handleOptionChange: function handleOptionChange(event) {
	            _handleOptionChange(event, 'productSearchTypeB');
	          }
	        })
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 12, id: 'promotions-auto-suggest' },
	        !selectedProductB || !selectedProductB.currentProdNum ? _react2.default.createElement(
	          'div',
	          { className: 'control-dropdown' },
	          _react2.default.createElement(_GenericProductSuggest2.default, {
	            value: suggestValueB,
	            onChange: function onChange(e, _ref3) {
	              var newValue = _ref3.newValue;
	              return handleProductSuggestChange(e, newValue, 'suggestValueB');
	            },
	            SearchType: productSearchTypeB,
	            fetchOrdersByProduct: function fetchOrdersByProduct(productNum, selectedInventoryRow) {
	              selectInventoryInfo(productNum, selectedInventoryRow, 'selectedProductB');
	            }
	          })
	        ) : _react2.default.createElement(
	          'div',
	          { id: 'suggestion-box' },
	          _react2.default.createElement(
	            _reactTooltip2.default,
	            { id: 'product-b-tool-tip', place: 'top', type: 'dark', effect: 'solid' },
	            _react2.default.createElement(
	              'div',
	              { className: 'product-b-tool-tips' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'unit-type' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_type' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  selectedProductB.currentUnitType
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'package-size' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  selectedProductB.currentPackageSize
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'weight' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  selectedProductB.currentProductWeight
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'price' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_price' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  selectedProductB.currentRefPrice ? '$' + parseFloat(selectedProductB.currentRefPrice).toFixed(2) : ''
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            { 'data-tip': true, 'data-for': 'product-b-tool-tip', className: 'detail-string' },
	            detailsStringB
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'invisible-button pull-right',
	              onClick: function onClick() {
	                return handleClearButtonClick('selectedProductB', 'suggestValueB');
	              }
	            },
	            _react2.default.createElement('em', { className: 'fa fa-times' })
	          )
	        )
	      )
	    )
	  );
	};
	
	BuyAGetBProductSearches.propTypes = propTypes;
	BuyAGetBProductSearches.defaultProps = defaultProps;
	
	var _default = BuyAGetBProductSearches;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/BuyAGetBProductSearches.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/BuyAGetBProductSearches.jsx');
	
	  __REACT_HOT_LOADER__.register(BuyAGetBProductSearches, 'BuyAGetBProductSearches', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/BuyAGetBProductSearches.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/BuyAGetBProductSearches.jsx');
	}();

	;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isHMM = _root_url.ROOT_API_URL === 'https://hmm-scm.truckxi.com/api/';
	
	var propTypes = {
	  paymentTypeSelected: _propTypes2.default.string,
	  methodSelected: _propTypes2.default.string,
	  quantityFrom: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  quantityTo: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  discountValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  discountType: _propTypes2.default.string,
	  applyLv1: _propTypes2.default.bool,
	  applyLv2: _propTypes2.default.bool,
	  applyLv3: _propTypes2.default.bool,
	  applyLv4: _propTypes2.default.bool,
	  applyLv5: _propTypes2.default.bool,
	  handlePriceLevelChange: _propTypes2.default.func,
	  handleSelectionChange: _propTypes2.default.func,
	  handleTextInputChange: _propTypes2.default.func,
	  handleDiscountButtonClick: _propTypes2.default.func
	};
	
	var defaultProps = {
	  paymentTypeSelected: '',
	  methodSelected: '',
	  quantityFrom: '',
	  quantityTo: '',
	  discountValue: '',
	  discountType: '',
	  applyLv1: true,
	  applyLv2: true,
	  applyLv3: true,
	  applyLv4: true,
	  applyLv5: true,
	  handlePriceLevelChange: function handlePriceLevelChange() {},
	  handleSelectionChange: function handleSelectionChange() {},
	  handleTextInputChange: function handleTextInputChange() {},
	  handleDiscountButtonClick: function handleDiscountButtonClick() {}
	};
	
	var ByQuantityFields = function ByQuantityFields(_ref) {
	  var paymentTypeSelected = _ref.paymentTypeSelected,
	      methodSelected = _ref.methodSelected,
	      quantityFrom = _ref.quantityFrom,
	      quantityTo = _ref.quantityTo,
	      discountValue = _ref.discountValue,
	      discountType = _ref.discountType,
	      applyLv1 = _ref.applyLv1,
	      applyLv2 = _ref.applyLv2,
	      applyLv3 = _ref.applyLv3,
	      applyLv4 = _ref.applyLv4,
	      applyLv5 = _ref.applyLv5,
	      handlePriceLevelChange = _ref.handlePriceLevelChange,
	      handleSelectionChange = _ref.handleSelectionChange,
	      handleTextInputChange = _ref.handleTextInputChange,
	      handleDiscountButtonClick = _ref.handleDiscountButtonClick;
	
	  var methodOptions = [{ label: 'Every', value: 'Every' }, { label: 'Each', value: 'Each' }];
	  if (_root_url.isElegant) {
	    var eachIndex = methodOptions.findIndex(function (item) {
	      return item.label === 'Each';
	    });
	    if (eachIndex !== -1) {
	      methodOptions.splice(eachIndex, 1);
	    }
	  }
	  var renderQtyField = function renderQtyField() {
	    if (_root_url.isElegant) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'quantity-field', style: { justifyContent: 'flex-start' } },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'quantity', className: 'field-margin' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	          ':'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'quantity-input', style: { marginLeft: '29px' } },
	          _react2.default.createElement('input', {
	            id: 'quantity-to-from',
	            name: 'quantityFrom',
	            className: 'text-input-field',
	            type: 'text',
	            value: quantityFrom,
	            onChange: handleTextInputChange
	            // disabled={paymentTypeSelected === 'Mobile'}
	          })
	        )
	      );
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: 'quantity-field' },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'quantity', className: 'field-margin' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	        ':'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'quantity-input' },
	        _react2.default.createElement('input', {
	          id: 'quantity-to-from',
	          name: 'quantityFrom',
	          className: 'text-input-field',
	          type: 'text',
	          value: quantityFrom,
	          onChange: handleTextInputChange
	          // disabled={paymentTypeSelected === 'Mobile'}
	        }),
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'to', className: 'to-label field-margin' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'to' })
	        ),
	        _react2.default.createElement('input', {
	          id: 'quantity-to-from',
	          name: 'quantityTo',
	          className: 'text-input-field',
	          type: 'text',
	          value: quantityTo,
	          onChange: handleTextInputChange
	          // disabled={paymentTypeSelected === 'Mobile'}
	        })
	      )
	    );
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: 'promo-fields' },
	    isHMM && _react2.default.createElement(
	      'div',
	      { className: 'levels-field' },
	      _react2.default.createElement(
	        'label',
	        { style: { marginRight: '10px' }, htmlFor: 'levels', className: 'field-margin ' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'levels' }),
	        ':'
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.ButtonToolbar,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: applyLv1 === true ? 'success' : 'null',
	            className: 'level-buttons',
	            onClick: function onClick() {
	              return handlePriceLevelChange('applyLv1');
	            }
	          },
	          '1'
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: applyLv2 === true ? 'success' : 'null',
	            className: 'level-buttons',
	            onClick: function onClick() {
	              return handlePriceLevelChange('applyLv2');
	            }
	          },
	          '2'
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: applyLv3 === true ? 'success' : 'null',
	            className: 'level-buttons',
	            onClick: function onClick() {
	              return handlePriceLevelChange('applyLv3');
	            }
	          },
	          '3'
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: applyLv4 === true ? 'success' : 'null',
	            className: 'level-buttons',
	            onClick: function onClick() {
	              return handlePriceLevelChange('applyLv4');
	            }
	          },
	          '4'
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: applyLv5 === true ? 'success' : 'null',
	            className: 'level-buttons',
	            onClick: function onClick() {
	              return handlePriceLevelChange('applyLv5');
	            }
	          },
	          '5'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'method-selection' },
	      _react2.default.createElement(_GenericSelection2.default, {
	        translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'method' }),
	        setSelected: function setSelected(_ref2) {
	          var value = _ref2.value;
	          return handleSelectionChange(value, 'methodSelected');
	        },
	        value: methodSelected,
	        options: methodOptions,
	        colon: true
	      })
	    ),
	    renderQtyField(),
	    _react2.default.createElement(
	      'div',
	      { className: 'discount-field' },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'discount', className: 'field-margin ' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount' }),
	        ':'
	      ),
	      _react2.default.createElement('input', {
	        id: 'discount-text-input',
	        name: 'discountValue',
	        className: 'text-input-field',
	        type: 'text',
	        value: discountValue,
	        onChange: handleTextInputChange
	      }),
	      _react2.default.createElement(
	        _reactBootstrap.ButtonToolbar,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: discountType === 'Dollar' ? 'success' : 'null',
	            onClick: function onClick() {
	              return handleDiscountButtonClick('Dollar');
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-usd' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: discountType === 'Percent' ? 'success' : 'null',
	            onClick: function onClick() {
	              return handleDiscountButtonClick('Percent');
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-percent' })
	        )
	      )
	    )
	  );
	};
	
	ByQuantityFields.propTypes = propTypes;
	ByQuantityFields.defaultProps = defaultProps;
	
	var _default = ByQuantityFields;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isHMM, 'isHMM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/ByQuantityFields.jsx');
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/ByQuantityFields.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/ByQuantityFields.jsx');
	
	  __REACT_HOT_LOADER__.register(ByQuantityFields, 'ByQuantityFields', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/ByQuantityFields.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/ByQuantityFields.jsx');
	}();

	;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  minPurchasePrice: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  discountValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  discountType: _propTypes2.default.string,
	  SalesType: _propTypes2.default.string,
	  handleDiscountButtonClick: _propTypes2.default.func,
	  handleTextInputChange: _propTypes2.default.func,
	  handleSelectionChange: _propTypes2.default.func
	};
	
	var defaultProps = {
	  minPurchasePrice: '',
	  discountValue: '',
	  discountType: '',
	  SalesType: 'all',
	  handleDiscountButtonClick: function handleDiscountButtonClick() {},
	  handleTextInputChange: function handleTextInputChange() {},
	  handleSelectionChange: function handleSelectionChange() {}
	};
	
	var ByTotalPriceDiscountFields = function ByTotalPriceDiscountFields(_ref) {
	  var minPurchasePrice = _ref.minPurchasePrice,
	      discountValue = _ref.discountValue,
	      discountType = _ref.discountType,
	      SalesType = _ref.SalesType,
	      handleDiscountButtonClick = _ref.handleDiscountButtonClick,
	      handleTextInputChange = _ref.handleTextInputChange,
	      handleSelectionChange = _ref.handleSelectionChange;
	
	  var salesTypeOptions = [{ label: 'All', value: 'all' }, { label: 'Wholesale', value: 'wholesale' }, { label: 'Retail', value: 'retail' }];
	  return _react2.default.createElement(
	    'div',
	    { className: 'promo-fields' },
	    _react2.default.createElement(
	      'div',
	      { className: 'method-selection' },
	      _react2.default.createElement(_GenericSelection2.default, {
	        translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_type' }),
	        setSelected: function setSelected(_ref2) {
	          var value = _ref2.value;
	          return handleSelectionChange(value, 'SalesType');
	        },
	        value: SalesType,
	        options: salesTypeOptions,
	        colon: true
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-row' },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'total-price-discount', className: 'field-margin' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'min_purchase_amount' }),
	        ':'
	      ),
	      _react2.default.createElement('input', {
	        id: 'min-purchase-text-input',
	        name: 'minPurchasePrice',
	        className: 'text-input-field',
	        type: 'text',
	        value: minPurchasePrice,
	        onChange: handleTextInputChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'discount-field' },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'discount', className: 'field-margin ' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount' }),
	        ':'
	      ),
	      _react2.default.createElement('input', {
	        id: 'discount-text-input',
	        name: 'discountValue',
	        className: 'text-input-field',
	        type: 'text',
	        value: discountValue,
	        onChange: handleTextInputChange
	      }),
	      _react2.default.createElement(
	        _reactBootstrap.ButtonToolbar,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: discountType === 'Dollar' ? 'success' : 'null',
	            onClick: function onClick() {
	              return handleDiscountButtonClick('Dollar');
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-usd' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: discountType === 'Percent' ? 'success' : 'null',
	            onClick: function onClick() {
	              return handleDiscountButtonClick('Percent');
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-percent' })
	        )
	      )
	    )
	  );
	};
	
	ByTotalPriceDiscountFields.propTypes = propTypes;
	ByTotalPriceDiscountFields.defaultProps = defaultProps;
	
	var _default = ByTotalPriceDiscountFields;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/ByTotalPriceDiscountFields.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/ByTotalPriceDiscountFields.jsx');
	
	  __REACT_HOT_LOADER__.register(ByTotalPriceDiscountFields, 'ByTotalPriceDiscountFields', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/ByTotalPriceDiscountFields.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/ByTotalPriceDiscountFields.jsx');
	}();

	;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  minPurchasePrice: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  promoCode: _propTypes2.default.string,
	  autoApply: _propTypes2.default.bool,
	  IsOneTime: _propTypes2.default.bool,
	  editing: _propTypes2.default.bool,
	  productQuantityB: _propTypes2.default.string,
	  SalesType: _propTypes2.default.string,
	  handleTextInputChange: _propTypes2.default.func,
	  handleCheckBoxChange: _propTypes2.default.func
	};
	
	var defaultProps = {
	  minPurchasePrice: '',
	  productQuantityB: '',
	  promoCode: '',
	  autoApply: true,
	  IsOneTime: false,
	  editing: false,
	  SalesType: 'all',
	  handleTextInputChange: function handleTextInputChange() {},
	  handleCheckBoxChange: function handleCheckBoxChange() {},
	  handleSelectionChange: function handleSelectionChange() {}
	};
	
	var ByTotalPriceProductFields = function ByTotalPriceProductFields(_ref) {
	  var minPurchasePrice = _ref.minPurchasePrice,
	      productQuantityB = _ref.productQuantityB,
	      promoCode = _ref.promoCode,
	      autoApply = _ref.autoApply,
	      IsOneTime = _ref.IsOneTime,
	      editing = _ref.editing,
	      SalesType = _ref.SalesType,
	      handleTextInputChange = _ref.handleTextInputChange,
	      handleCheckBoxChange = _ref.handleCheckBoxChange,
	      handleSelectionChange = _ref.handleSelectionChange;
	
	  var salesTypeOptions = [{ label: 'All', value: 'all' }, { label: 'Wholesale', value: 'wholesale' }, { label: 'Retail', value: 'retail' }];
	  return _react2.default.createElement(
	    'div',
	    { className: 'promo-fields' },
	    _react2.default.createElement(
	      'div',
	      { className: 'method-selection' },
	      _react2.default.createElement(_GenericSelection2.default, {
	        translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_type' }),
	        setSelected: function setSelected(_ref2) {
	          var value = _ref2.value;
	          return handleSelectionChange(value, 'SalesType');
	        },
	        value: SalesType,
	        options: salesTypeOptions,
	        colon: true
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-row' },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'total-price-product', className: 'field-margin' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'min_purchase_amount' }),
	        ':'
	      ),
	      _react2.default.createElement('input', {
	        id: 'min-purchase-text-input',
	        name: 'minPurchasePrice',
	        className: 'text-input-field',
	        type: 'text',
	        value: minPurchasePrice,
	        onChange: handleTextInputChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-row' },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'prod-qty-B', className: 'field-margin' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'gift_quantity' }),
	        ':'
	      ),
	      _react2.default.createElement('input', {
	        id: 'min-purchase-text-input',
	        name: 'productQuantityB',
	        className: 'text-input-field',
	        type: 'text',
	        value: productQuantityB,
	        onChange: handleTextInputChange
	      })
	    ),
	    editing && _react2.default.createElement(
	      'div',
	      { className: 'flex-row' },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'prod-qty-B', className: 'field-margin' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'promo_code' }),
	        ':'
	      ),
	      _react2.default.createElement('input', {
	        id: 'promo-code-text-input-edit',
	        name: 'promoCode',
	        className: 'text-input-field',
	        type: 'text',
	        value: promoCode,
	        onChange: handleTextInputChange
	      })
	    ),
	    editing && _react2.default.createElement(
	      'div',
	      { className: 'flex-row' },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'prod-qty-B', className: 'field-margin' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'auto_apply' }),
	        ':'
	      ),
	      _react2.default.createElement('input', {
	        id: 'auto-apply-checkbox-edit',
	        name: 'autoApply',
	        type: 'checkbox',
	        disabled: _root_url.isElegant && IsOneTime,
	        checked: autoApply,
	        onChange: handleCheckBoxChange
	      })
	    ),
	    _root_url.isElegant && editing && _react2.default.createElement(
	      'div',
	      { className: 'flex-row' },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'prod-qty-B', className: 'field-margin' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'one_time_use' }),
	        ':'
	      ),
	      _react2.default.createElement('input', {
	        id: 'one-time-checkbox-edit',
	        name: 'IsOneTime',
	        type: 'checkbox',
	        checked: IsOneTime,
	        onChange: handleCheckBoxChange
	      })
	    )
	  );
	};
	
	ByTotalPriceProductFields.propTypes = propTypes;
	ByTotalPriceProductFields.defaultProps = defaultProps;
	
	var _default = ByTotalPriceProductFields;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/ByTotalPriceProductFields.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/ByTotalPriceProductFields.jsx');
	
	  __REACT_HOT_LOADER__.register(ByTotalPriceProductFields, 'ByTotalPriceProductFields', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/ByTotalPriceProductFields.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/ByTotalPriceProductFields.jsx');
	}();

	;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _map = __webpack_require__(55);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _utils = __webpack_require__(121);
	
	var _components = __webpack_require__(120);
	
	var _promotions_actions = __webpack_require__(71);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isAFM = _root_url.ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afm-scm.truckxi.com/api/';
	
	var propTypes = {
	  promotion: _propTypes2.default.shape({
	    PromotionLine_id: _propTypes2.default.number,
	    Method: _propTypes2.default.string,
	    FromQty: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    ToQty: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    Off: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    IsPercent: _propTypes2.default.bool,
	    PaymentType: _propTypes2.default.string,
	    Group: _propTypes2.default.string,
	    Qualification: _propTypes2.default.string,
	    StartDate: _propTypes2.default.string,
	    EndDate: _propTypes2.default.string,
	    RelatedQuantity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    MinPurchase: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    PromoCode: _propTypes2.default.string,
	    ViewablePriceLevels: _propTypes2.default.string
	  }),
	  customerList: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.string,
	    label: _propTypes2.default.string
	  })),
	  isLoadingPromoDetails: _propTypes2.default.bool,
	  searchProduct: _propTypes2.default.bool,
	  closeEditPromotion: _propTypes2.default.func,
	  getGroupOptions: _propTypes2.default.func,
	  getCategoryOptions: _propTypes2.default.func
	};
	
	var defaultProps = {
	  promotion: {},
	  customerList: [],
	  isLoadingPromoDetails: false,
	  searchProduct: true,
	  closeEditPromotion: function closeEditPromotion() {}
	};
	
	var EditPromotionModal = function (_Component) {
	  _inherits(EditPromotionModal, _Component);
	
	  function EditPromotionModal(props) {
	    _classCallCheck(this, EditPromotionModal);
	
	    var _this = _possibleConstructorReturn(this, (EditPromotionModal.__proto__ || Object.getPrototypeOf(EditPromotionModal)).call(this, props));
	
	    _this.getCustomerOptions = function () {
	      var customerList = _this.state.customerList;
	
	      var customerOptions = [{ value: 'All', label: 'All' }];
	      (0, _map2.default)(customerList, function (customer) {
	        var option = { value: customer.Name, label: customer.Name };
	        customerOptions.push(option);
	      });
	      return customerOptions;
	    };
	
	    _this.setStartDate = function (e) {
	      if (_this.state.endDateSelected && e > _this.state.endDateSelected) {
	        alert(_reactReduxI18n.I18n.t('please_select_an_end_date_that_is_after_the_start_date'));
	        return;
	      }
	      _this.setState({ startDateSelected: e });
	    };
	
	    _this.setEndDate = function (e) {
	      if (_this.state.startDateSelected && e < _this.state.startDateSelected) {
	        alert(_reactReduxI18n.I18n.t('please_select_a_start_date_that_is_before_the_end_date'));
	        return;
	      }
	      _this.setState({ endDateSelected: e });
	    };
	
	    _this.handleSaveEdittedPromotion = function () {
	      var handleSuccess = function handleSuccess() {
	        _this.setState({ isLoadingSavePromotion: false }, function () {
	          _this.props.closeEditPromotion(true);
	        });
	      };
	
	      var handleFailure = function handleFailure(error) {
	        _this.setState({ isLoadingSavePromotion: false });
	        alert(JSON.stringify(error));
	      };
	
	      var promotionLineId = _this.props.promotion.PromotionLine_id;
	      var promotionLine = void 0;
	      switch (_this.props.promotion.Method) {
	        case 'ByQuantity':
	          promotionLine = (0, _utils.desiredShapeByQuantity)(_this.state);
	          break;
	        case 'BuyAGetB':
	          promotionLine = (0, _utils.desiredShapeBuyAGetB)(_this.state);
	          break;
	        case 'ByTotalPriceProduct':
	          promotionLine = (0, _utils.desiredShapeByTotalPriceProduct)(_this.state);
	          break;
	        case 'ByTotalPriceDiscount':
	          promotionLine = (0, _utils.desiredShapeByTotalPriceDiscount)(_this.state);
	          break;
	        default:
	          break;
	      }
	      _this.setState({ isLoadingSavePromotion: true }, function () {
	        (0, _promotions_actions.saveEdittedPromotion)(promotionLineId, promotionLine, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.handleSelectionChange = function (value, fieldName) {
	      _this.setState(_defineProperty({}, fieldName, value));
	    };
	
	    _this.handlePriceLevelChange = function (fieldName) {
	      if (_this.state[[fieldName]] === true) {
	        _this.setState(_defineProperty({}, fieldName, false));
	      } else {
	        _this.setState(_defineProperty({}, fieldName, true));
	      }
	    };
	
	    _this.handleOptionChange = function (changeEvent, productSearchType) {
	      _this.setState(_defineProperty({}, productSearchType, changeEvent.target.value));
	    };
	
	    _this.handleDiscountButtonClick = function (discountType) {
	      _this.setState({ discountType: discountType });
	    };
	
	    _this.handleProductSuggestChange = function (e, newValue, fieldName) {
	      _this.setState(_defineProperty({}, fieldName, newValue));
	    };
	
	    _this.handleClearButtonClick = function (selectedProductName, suggestValueName) {
	      var _this$setState6;
	
	      _this.setState((_this$setState6 = {}, _defineProperty(_this$setState6, selectedProductName, {}), _defineProperty(_this$setState6, suggestValueName, ''), _this$setState6));
	    };
	
	    _this.handleDuplicateProductAClick = function () {
	      var selectedProductA = _this.state.selectedProductA;
	
	      _this.setState({ selectedProductB: selectedProductA });
	    };
	
	    _this.handleTextInputChange = function (event) {
	      _this.setState(_defineProperty({}, event.target.name, event.target.value));
	    };
	
	    _this.handleCheckBoxChange = function (event) {
	      if (event.target.name === 'IsOneTime' && _this.state[event.target.name] === false) {
	        _this.setState({ autoApply: false });
	      }
	      _this.setState(_defineProperty({}, event.target.name, !_this.state[event.target.name]));
	    };
	
	    _this.selectInventoryInfo = function (productNum, selectedInventoryRow, selectedProduct) {
	      var _this$setState9;
	
	      var product = (0, _utils.cleanProduct)(selectedInventoryRow);
	      _this.setState((_this$setState9 = {}, _defineProperty(_this$setState9, selectedProduct, product), _defineProperty(_this$setState9, 'suggestValue', ''), _this$setState9));
	    };
	
	    _this.handleGroupChange = function (group) {
	      _this.props.handleFetchGroupCategories(group);
	      _this.handleSelectionChange(group, 'selectedGroup');
	    };
	
	    _this.renderByQuantityPromoDetails = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'promo-section', style: _this.props.searchProduct ? {} : { width: '500px' } },
	        _react2.default.createElement(_components.PromotionSetup, {
	          setStartDate: _this.setStartDate,
	          startDateSelected: _this.state.startDateSelected,
	          setEndDate: _this.setEndDate,
	          endDateSelected: _this.state.endDateSelected,
	          handleSelectionChange: _this.handleSelectionChange,
	          customerGroupSelected: _this.state.customerGroupSelected,
	          paymentTypeSelected: _this.state.paymentTypeSelected,
	          customerOptions: _this.getCustomerOptions()
	        }),
	        _react2.default.createElement(_components.ByQuantityFields, {
	          paymentTypeSelected: _this.state.paymentTypeSelected,
	          methodSelected: _this.state.methodSelected,
	          quantityFrom: _this.state.quantityFrom,
	          quantityTo: _this.state.quantityTo,
	          discountValue: _this.state.discountValue,
	          discountType: _this.state.discountType,
	          applyLv1: _this.state.applyLv1,
	          applyLv2: _this.state.applyLv2,
	          applyLv3: _this.state.applyLv3,
	          applyLv4: _this.state.applyLv4,
	          applyLv5: _this.state.applyLv5,
	          handlePriceLevelChange: _this.handlePriceLevelChange,
	          handleSelectionChange: _this.handleSelectionChange,
	          handleTextInputChange: _this.handleTextInputChange,
	          handleDiscountButtonClick: _this.handleDiscountButtonClick
	        })
	      );
	    };
	
	    _this.renderBuyAGetBPromoDetails = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'promo-section' },
	        _react2.default.createElement(_components.PromotionSetup, {
	          setStartDate: _this.setStartDate,
	          startDateSelected: _this.state.startDateSelected,
	          setEndDate: _this.setEndDate,
	          endDateSelected: _this.state.endDateSelected,
	          handleSelectionChange: _this.handleSelectionChange,
	          customerGroupSelected: _this.state.customerGroupSelected,
	          paymentTypeSelected: _this.state.paymentTypeSelected,
	          customerOptions: _this.getCustomerOptions()
	        }),
	        _react2.default.createElement(_components.BuyAGetBFields, {
	          methodSelected: _this.state.methodSelected,
	          productQuantityA: _this.state.productQuantityA,
	          productQuantityB: _this.state.productQuantityB,
	          discountValue: _this.state.discountValue,
	          discountType: _this.state.discountType,
	          handleSelectionChange: _this.handleSelectionChange,
	          handleDiscountButtonClick: _this.handleDiscountButtonClick,
	          handleTextInputChange: _this.handleTextInputChange
	        })
	      );
	    };
	
	    _this.renderByTotalPriceProductPromoDetails = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'promo-section', style: _this.props.searchProduct ? {} : { width: '500px' } },
	        _react2.default.createElement(_components.PromotionSetup, {
	          setStartDate: _this.setStartDate,
	          startDateSelected: _this.state.startDateSelected,
	          setEndDate: _this.setEndDate,
	          endDateSelected: _this.state.endDateSelected,
	          handleSelectionChange: _this.handleSelectionChange,
	          customerGroupSelected: _this.state.customerGroupSelected,
	          paymentTypeSelected: _this.state.paymentTypeSelected,
	          customerOptions: _this.getCustomerOptions()
	        }),
	        _react2.default.createElement(_components.ByTotalPriceProductFields, {
	          editing: true,
	          autoApply: _this.state.autoApply,
	          IsOneTime: _this.state.IsOneTime,
	          promoCode: _this.state.promoCode,
	          minPurchasePrice: _this.state.minPurchasePrice,
	          productQuantityB: _this.state.productQuantityB,
	          SalesType: _this.state.SalesType,
	          handleTextInputChange: _this.handleTextInputChange,
	          handleCheckBoxChange: _this.handleCheckBoxChange,
	          handleSelectionChange: _this.handleSelectionChange
	        })
	      );
	    };
	
	    _this.renderByTotalPriceDiscountPromoDetails = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'promo-section' },
	        _react2.default.createElement(_components.PromotionSetup, {
	          setStartDate: _this.setStartDate,
	          startDateSelected: _this.state.startDateSelected,
	          setEndDate: _this.setEndDate,
	          endDateSelected: _this.state.endDateSelected,
	          handleSelectionChange: _this.handleSelectionChange,
	          customerGroupSelected: _this.state.customerGroupSelected,
	          paymentTypeSelected: _this.state.paymentTypeSelected,
	          customerOptions: _this.getCustomerOptions()
	        }),
	        _react2.default.createElement(_components.ByTotalPriceDiscountFields, {
	          minPurchasePrice: _this.state.minPurchasePrice,
	          discountValue: _this.state.discountValue,
	          discountType: _this.state.discountType,
	          SalesType: _this.state.SalesType,
	          handleDiscountButtonClick: _this.handleDiscountButtonClick,
	          handleTextInputChange: _this.handleTextInputChange,
	          handleSelectionChange: _this.handleSelectionChange
	        })
	      );
	    };
	
	    _this.renderByQuantity = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'by-quantity-tab', style: _this.props.searchProduct ? {} : { height: '176px' } },
	        _this.props.searchProduct ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_components.PromotionsProductSearch, {
	            productSearchType: _this.state.productSearchType,
	            suggestValue: _this.state.suggestValue,
	            selectedProduct: _this.state.selectedProduct,
	            handleOptionChange: _this.handleOptionChange,
	            handleProductSuggestChange: _this.handleProductSuggestChange,
	            selectInventoryInfo: _this.selectInventoryInfo,
	            groupSearch: true,
	            groupOptions: _this.props.getGroupOptions(),
	            categoryOptions: _this.props.getCategoryOptions(),
	            handleGroupChange: _this.handleGroupChange,
	            selectedGroup: _this.state.selectedGroup,
	            selectedCategory: _this.state.selectedCategory,
	            handleSelectionChange: _this.handleSelectionChange
	          }),
	          _react2.default.createElement('hr', null)
	        ) : _react2.default.createElement('div', null),
	        _this.renderByQuantityPromoDetails()
	      );
	    };
	
	    _this.renderByTotalPriceProduct = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'by-total-price-product-tab', style: _this.props.searchProduct ? {} : { height: '176px' } },
	        _this.props.searchProduct && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_components.PromotionsProductSearch, {
	            productSearchType: _this.state.productSearchType,
	            suggestValue: _this.state.suggestValue,
	            selectedProduct: _this.state.selectedProduct,
	            handleOptionChange: _this.handleOptionChange,
	            handleProductSuggestChange: _this.handleProductSuggestChange,
	            selectInventoryInfo: _this.selectInventoryInfo
	          }),
	          _react2.default.createElement('hr', null)
	        ),
	        _this.renderByTotalPriceProductPromoDetails()
	      );
	    };
	
	    _this.renderBuyAGetB = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'buy-a-get-b-tab' },
	        _react2.default.createElement(_components.BuyAGetBProductSearches, {
	          methodSelected: _this.state.methodSelected,
	          productSearchTypeA: _this.state.productSearchTypeA,
	          suggestValueA: _this.state.suggestValueA,
	          selectedProductA: _this.state.selectedProductA,
	          productSearchTypeB: _this.state.productSearchTypeB,
	          suggestValueB: _this.state.suggestValueB,
	          selectedProductB: _this.state.selectedProductB,
	          handleOptionChange: _this.handleOptionChange,
	          handleProductSuggestChange: _this.handleProductSuggestChange,
	          selectInventoryInfo: _this.selectInventoryInfo,
	          handleClearButtonClick: _this.handleClearButtonClick,
	          handleDuplicateProductAClick: _this.handleDuplicateProductAClick
	        }),
	        _react2.default.createElement('hr', null),
	        _this.renderBuyAGetBPromoDetails()
	      );
	    };
	
	    _this.renderByTotalPriceDiscount = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'by-total-price-discount-tab' },
	        _react2.default.createElement(
	          'div',
	          { className: 'promo-code-section' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'promo-code', className: 'promo-code-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'promo_code' }),
	            ':'
	          ),
	          _react2.default.createElement('input', {
	            id: 'promo-code-text-input',
	            name: 'promoCode',
	            className: 'text-input-field',
	            type: 'text',
	            value: _this.state.promoCode,
	            onChange: _this.handleTextInputChange
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'auto-apply-wrapper' },
	            _react2.default.createElement('input', {
	              id: 'auto-apply-checkbox',
	              name: 'autoApply',
	              type: 'checkbox',
	              disabled: _this.state.IsOneTime,
	              checked: _this.state.autoApply,
	              onChange: _this.handleCheckBoxChange
	            }),
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'auto-apply', className: 'auto-apply-label' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'auto_apply' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'auto-apply-wrapper' },
	            _react2.default.createElement('input', {
	              id: 'one-time-checkbox',
	              name: 'IsOneTime',
	              type: 'checkbox',
	              checked: _this.state.IsOneTime,
	              onChange: _this.handleCheckBoxChange
	            }),
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'one-time', className: 'one-time-label' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'one_time_use' })
	            )
	          ),
	          isAFM && _react2.default.createElement(
	            'div',
	            { className: 'auto-apply-wrapper' },
	            _react2.default.createElement('input', {
	              id: 'is-public-checkbox',
	              name: 'IsPublic',
	              type: 'checkbox',
	              checked: _this.state.IsPublic,
	              onChange: _this.handleCheckBoxChange
	            }),
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'is-public', className: 'is-public-label' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'is_public' })
	            )
	          )
	        ),
	        _react2.default.createElement('hr', null),
	        _this.renderByTotalPriceDiscountPromoDetails()
	      );
	    };
	
	    _this.state = {
	      isLoadingSavePromotion: false,
	
	      startDateSelected: null,
	      endDateSelected: null,
	      customerGroupSelected: '',
	      paymentTypeSelected: '',
	
	      suggestValue: '',
	      productSearchType: 'ProductNum',
	      selectedProduct: {},
	      selectedGroup: '',
	      selectedCategory: '',
	      methodSelected: '',
	      discountValue: '',
	      discountType: 'Dollar',
	      quantityFrom: '',
	      quantityTo: '',
	
	      ViewablePriceLevels: '',
	      applyLv1: true,
	      applyLv2: true,
	      applyLv3: true,
	      applyLv4: true,
	      applyLv5: true,
	
	      minPurchasePrice: '',
	
	      productQuantityA: '',
	      productQuantityB: '',
	
	      promoCode: '',
	      autoApply: false,
	      IsOneTime: false,
	      IsPublic: true,
	
	      suggestValueA: '',
	      productSearchTypeA: 'ProductNum',
	      selectedProductA: '',
	
	      suggestValueB: '',
	      productSearchTypeB: 'ProductNum',
	      selectedProductB: '',
	
	      SalesType: ''
	    };
	    return _this;
	  }
	
	  _createClass(EditPromotionModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.customerList) {
	        var customerList = this.props.customerList;
	
	        this.setState({ customerList: customerList });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.promotion && nextProps.promotion !== this.props.promotion) {
	        var state = (0, _utils.populateFields)(this.state, nextProps.promotion);
	        if (state.selectedGroup && state.selectedGroup !== this.state.selectedGroup) {
	          this.props.handleFetchGroupCategories(state.selectedGroup);
	        }
	        this.setState(state);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          isLoadingPromoDetails = _props.isLoadingPromoDetails,
	          searchProduct = _props.searchProduct;
	
	      var type = this.props.promotion.Method;
	      var promoTypeToRender = void 0;
	      switch (this.props.promotion.Method) {
	        case 'ByQuantity':
	          promoTypeToRender = this.renderByQuantity();
	          break;
	        case 'BuyAGetB':
	          promoTypeToRender = this.renderBuyAGetB();
	          break;
	        case 'ByTotalPriceProduct':
	          promoTypeToRender = this.renderByTotalPriceProduct();
	          break;
	        case 'ByTotalPriceDiscount':
	          promoTypeToRender = this.renderByTotalPriceDiscount();
	          break;
	        default:
	          break;
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Panel,
	        { id: 'edit-promotion-modal', style: searchProduct ? {} : { height: '180px' } },
	        isLoadingPromoDetails ? _react2.default.createElement(_spinner2.default, null) : _react2.default.createElement(
	          'div',
	          { className: 'promo-details' },
	          promoTypeToRender,
	          _react2.default.createElement(
	            'div',
	            { className: 'save-and-cancel-section' },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                onClick: function onClick() {
	                  return _this2.props.closeEditPromotion();
	                }
	              },
	              _react2.default.createElement('em', { className: 'fa fa-close' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	            ),
	            _react2.default.createElement(_SpinnerButton2.default, {
	              bsStyle: 'success',
	              className: 'save-button',
	              onClick: this.handleSaveEdittedPromotion,
	              disabled: this.state.isLoadingSavePromotion || (0, _utils.isIncompleteForm)(this.state, type),
	              loading: this.state.isLoadingSavePromotion,
	              icon: 'fa-save',
	              translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditPromotionModal;
	}(_react.Component);
	
	EditPromotionModal.propTypes = propTypes;
	EditPromotionModal.defaultProps = defaultProps;
	
	var _default = EditPromotionModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isAFM, 'isAFM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/EditPromotionModal.jsx');
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/EditPromotionModal.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/EditPromotionModal.jsx');
	
	  __REACT_HOT_LOADER__.register(EditPromotionModal, 'EditPromotionModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/EditPromotionModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/EditPromotionModal.jsx');
	}();

	;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _GenericDatePicker = __webpack_require__(48);
	
	var _GenericDatePicker2 = _interopRequireDefault(_GenericDatePicker);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  startDateSelected: _propTypes2.default.instanceOf(Date),
	  endDateSelected: _propTypes2.default.instanceOf(Date),
	  customerGroupSelected: _propTypes2.default.string,
	  paymentTypeSelected: _propTypes2.default.string,
	  customerOptions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.string,
	    label: _propTypes2.default.string
	  })),
	  setStartDate: _propTypes2.default.func,
	  setEndDate: _propTypes2.default.func,
	  handleSelectionChange: _propTypes2.default.func
	};
	
	var defaultProps = {
	  startDateSelected: undefined,
	  endDateSelected: undefined,
	  customerGroupSelected: '',
	  paymentTypeSelected: '',
	  customerOptions: [],
	  setStartDate: function setStartDate() {},
	  setEndDate: function setEndDate() {},
	  handleSelectionChange: function handleSelectionChange() {}
	};
	
	var PromotionSetup = function PromotionSetup(_ref) {
	  var setStartDate = _ref.setStartDate,
	      startDateSelected = _ref.startDateSelected,
	      setEndDate = _ref.setEndDate,
	      endDateSelected = _ref.endDateSelected,
	      handleSelectionChange = _ref.handleSelectionChange,
	      customerGroupSelected = _ref.customerGroupSelected,
	      paymentTypeSelected = _ref.paymentTypeSelected,
	      customerOptions = _ref.customerOptions;
	
	  var paymentOptions = [{ label: 'Mobile', value: 'Mobile' }, { label: 'POS', value: 'POS' }, { label: 'Cash', value: 'Cash' },
	  // { label: 'Card', value: 'Card' },
	  // { label: 'Check', value: 'Check' },
	  { label: 'All', value: 'All' }];
	  if (_root_url.isElegant) {
	    var posIndex = paymentOptions.findIndex(function (item) {
	      return item.label === 'POS';
	    });
	    if (posIndex !== -1) {
	      paymentOptions.splice(posIndex, 2);
	    }
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'promo-setup' },
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-row' },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'start-date-picker', className: 'start-date-label' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'start_date' }),
	        ':'
	      ),
	      _react2.default.createElement(_GenericDatePicker2.default, {
	        id: 'start-date-picker',
	        setDate: setStartDate,
	        selectedDate: startDateSelected,
	        onChange: setStartDate
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-row' },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'end-date-picker', className: 'end-date-label' },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'end_date' }),
	        ':'
	      ),
	      _react2.default.createElement(_GenericDatePicker2.default, {
	        id: 'end-date-picker',
	        setDate: setEndDate,
	        selectedDate: endDateSelected,
	        onChange: setEndDate
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'customer-group-selection' },
	      _react2.default.createElement(_GenericSelection2.default, {
	        translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customers' }),
	        setSelected: function setSelected(_ref2) {
	          var value = _ref2.value;
	          return handleSelectionChange(value, 'customerGroupSelected');
	        },
	        value: customerGroupSelected,
	        options: customerOptions,
	        colon: true
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'payment-type-selection' },
	      _react2.default.createElement(_GenericSelection2.default, {
	        translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	        setSelected: function setSelected(_ref3) {
	          var value = _ref3.value;
	          return handleSelectionChange(value, 'paymentTypeSelected');
	        },
	        value: paymentTypeSelected,
	        options: paymentOptions,
	        colon: true
	      })
	    )
	  );
	};
	
	PromotionSetup.propTypes = propTypes;
	PromotionSetup.defaultProps = defaultProps;
	
	var _default = PromotionSetup;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/PromotionSetup.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/PromotionSetup.jsx');
	
	  __REACT_HOT_LOADER__.register(PromotionSetup, 'PromotionSetup', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/PromotionSetup.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/PromotionSetup.jsx');
	}();

	;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _GenericProductSuggest = __webpack_require__(51);
	
	var _GenericProductSuggest2 = _interopRequireDefault(_GenericProductSuggest);
	
	var _TypeRadios = __webpack_require__(57);
	
	var _TypeRadios2 = _interopRequireDefault(_TypeRadios);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  productSearchType: _propTypes2.default.string,
	  suggestValue: _propTypes2.default.string,
	  selectedProduct: _propTypes2.default.shape({
	    inStock: _propTypes2.default.number,
	    purchased: _propTypes2.default.number,
	    presale: _propTypes2.default.number,
	    net_weight: _propTypes2.default.number,
	    ship_weight: _propTypes2.default.number,
	    PriceLv1: _propTypes2.default.number,
	    PriceLv2: _propTypes2.default.number,
	    PriceLv3: _propTypes2.default.number,
	    PriceLv4: _propTypes2.default.number,
	    PriceLv5: _propTypes2.default.number,
	    currentProdName: _propTypes2.default.string,
	    currentProdNum: _propTypes2.default.string,
	    currentProductDescription: _propTypes2.default.string,
	    currentRefNum: _propTypes2.default.string,
	    currentUnitType: _propTypes2.default.string,
	    currentPackageSize: _propTypes2.default.string,
	    currentProductWeight: _propTypes2.default.number,
	    currentProductCRV: _propTypes2.default.number,
	    currentProductTaxable: _propTypes2.default.string
	  }),
	  // group
	  groupSearch: _propTypes2.default.bool,
	  selectedGroup: _propTypes2.default.string,
	  groupList: [],
	  groupOptions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.string,
	    label: _propTypes2.default.string
	  })),
	  // catregory
	  selectedCategory: _propTypes2.default.string,
	  categoryList: [],
	  categoryOptions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.string,
	    label: _propTypes2.default.string
	  })),
	  handleOptionChange: _propTypes2.default.func,
	  handleProductSuggestChange: _propTypes2.default.func,
	  selectInventoryInfo: _propTypes2.default.func,
	  handleSelectionChange: _propTypes2.default.func,
	  handleGroupChange: _propTypes2.default.func
	};
	
	var defaultProps = {
	  productSearchType: '',
	  suggestValue: '',
	  selectedProduct: {},
	  groupSearch: false,
	  selectedGroup: '',
	  groupOptions: [],
	  selectedCategory: '',
	  categoryOptions: [],
	  handleOptionChange: function handleOptionChange() {},
	  handleProductSuggestChange: function handleProductSuggestChange() {},
	  selectInventoryInfo: function selectInventoryInfo() {},
	  handleSelectionChange: function handleSelectionChange() {},
	  handleGroupChange: function handleGroupChange() {}
	};
	
	var PromotionsProductSearch = function PromotionsProductSearch(_ref) {
	  var productSearchType = _ref.productSearchType,
	      _handleOptionChange = _ref.handleOptionChange,
	      suggestValue = _ref.suggestValue,
	      handleProductSuggestChange = _ref.handleProductSuggestChange,
	      selectInventoryInfo = _ref.selectInventoryInfo,
	      selectedProduct = _ref.selectedProduct,
	      groupSearch = _ref.groupSearch,
	      selectedGroup = _ref.selectedGroup,
	      groupOptions = _ref.groupOptions,
	      selectedCategory = _ref.selectedCategory,
	      categoryOptions = _ref.categoryOptions,
	      handleSelectionChange = _ref.handleSelectionChange,
	      handleGroupChange = _ref.handleGroupChange;
	  return _react2.default.createElement(
	    'div',
	    { className: 'product-section' },
	    _react2.default.createElement(
	      _reactBootstrap.Col,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(_TypeRadios2.default, {
	            value: productSearchType,
	            handleOptionChange: function handleOptionChange(event) {
	              _handleOptionChange(event, 'productSearchType');
	            },
	            groupSearch: groupSearch
	          })
	        ),
	        productSearchType !== 'Group' && _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12, id: 'promotions-auto-suggest' },
	          _react2.default.createElement(
	            'div',
	            { className: 'control-dropdown' },
	            _react2.default.createElement(_GenericProductSuggest2.default, {
	              value: suggestValue,
	              onChange: function onChange(e, _ref2) {
	                var newValue = _ref2.newValue;
	                return handleProductSuggestChange(e, newValue, 'suggestValue');
	              },
	              SearchType: productSearchType,
	              fetchOrdersByProduct: function fetchOrdersByProduct(productNum, selectedInventoryRow) {
	                selectInventoryInfo(productNum, selectedInventoryRow, 'selectedProduct');
	              }
	            })
	          )
	        ),
	        productSearchType !== 'Group' && _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { className: 'product-details' },
	            _react2.default.createElement(
	              'div',
	              { className: 'product-details-left' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'prod-num' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  selectedProduct.currentProdNum
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'ref-num' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  selectedProduct.currentRefNum
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'name', className: 'item-name-label' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                  ': '
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'item-name-span' },
	                  selectedProduct.currentProdName
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'description' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	                  ': '
	                ),
	                selectedProduct.currentProductDescription
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'product-details-right' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'unit-type' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_type' }),
	                  ':'
	                ),
	                selectedProduct.currentUnitType
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'package-size' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	                  ':'
	                ),
	                selectedProduct.currentPackageSize
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'weight' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight' }),
	                  ':'
	                ),
	                selectedProduct.currentProductWeight
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'price' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_price' }),
	                  ':'
	                ),
	                selectedProduct.currentRefPrice ? '$' + parseFloat(selectedProduct.currentRefPrice).toFixed(2) : ''
	              )
	            )
	          )
	        ),
	        productSearchType === 'Group' && _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { className: 'group-cat-picker' },
	            _react2.default.createElement(
	              'div',
	              { className: 'group-cat' },
	              _react2.default.createElement(
	                'div',
	                { className: 'customer-group-selection' },
	                _react2.default.createElement(_GenericSelection2.default, {
	                  translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'groups' }),
	                  setSelected: function setSelected(_ref3) {
	                    var value = _ref3.value;
	                    return handleGroupChange(value);
	                  },
	                  value: selectedGroup,
	                  options: groupOptions,
	                  colon: true
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'group-cat' },
	              _react2.default.createElement(
	                'div',
	                { className: 'customer-group-selection' },
	                _react2.default.createElement(_GenericSelection2.default, {
	                  translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category' }),
	                  setSelected: function setSelected(_ref4) {
	                    var value = _ref4.value;
	                    return handleSelectionChange(value, 'selectedCategory');
	                  },
	                  value: selectedCategory,
	                  options: categoryOptions,
	                  colon: true
	                })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	PromotionsProductSearch.propTypes = propTypes;
	PromotionsProductSearch.defaultProps = defaultProps;
	
	var _default = PromotionsProductSearch;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/PromotionsProductSearch.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/PromotionsProductSearch.jsx');
	
	  __REACT_HOT_LOADER__.register(PromotionsProductSearch, 'PromotionsProductSearch', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/PromotionsProductSearch.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/PromotionsProductSearch.jsx');
	}();

	;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _map = __webpack_require__(55);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactTooltip = __webpack_require__(105);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _dateFormat = __webpack_require__(39);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var isAFM = _root_url.ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afm-scm.truckxi.com/api/';
	
	var propTypes = {
	  promotions: _propTypes2.default.shape({
	    Description: _propTypes2.default.string,
	    Method: _propTypes2.default.string,
	    Name: _propTypes2.default.string,
	    ProductNum: _propTypes2.default.string,
	    Product_id: _propTypes2.default.number,
	    PromotionLine_id: _propTypes2.default.number,
	    RefNum: _propTypes2.default.string,
	    ProductGroupName: _propTypes2.default.string,
	    ProductCategoryName: _propTypes2.default.string
	  }),
	  tabsKey: _propTypes2.default.string,
	  handleGridSort: _propTypes2.default.func,
	  handleFilterChange: _propTypes2.default.func,
	  handleOpenEditPromotion: _propTypes2.default.func,
	  openDeletePromotion: _propTypes2.default.func,
	  handleClearFilters: _propTypes2.default.func
	};
	
	var defaultProps = {
	  promotions: {},
	  tabsKey: 'ByQuantity',
	  handleGridSort: function handleGridSort() {},
	  handleFilterChange: function handleFilterChange() {},
	  handleOpenEditPromotion: function handleOpenEditPromotion() {},
	  openDeletePromotion: function openDeletePromotion() {},
	  handleClearFilters: function handleClearFilters() {}
	};
	
	var PromotionsTable = function PromotionsTable(_ref) {
	  var promotions = _ref.promotions,
	      tabsKey = _ref.tabsKey,
	      handleGridSort = _ref.handleGridSort,
	      handleFilterChange = _ref.handleFilterChange,
	      openDeletePromotion = _ref.openDeletePromotion,
	      handleOpenEditPromotion = _ref.handleOpenEditPromotion,
	      handleClearFilters = _ref.handleClearFilters;
	
	  var getRows = function getRows() {
	    return _reactDataGridAddons.Data.Selectors.getRows(promotions);
	  };
	
	  var getSize = function getSize() {
	    return getRows().length;
	  };
	
	  var rowGetter = function rowGetter(rowIdx) {
	    var rows = getRows();
	    return rows[rowIdx];
	  };
	
	  var IsVariableFormatter = _react2.default.createClass({
	    displayName: 'IsVariableFormatter',
	    render: function render() {
	      var _this = this;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'danger',
	            className: 'textAlignStyle',
	            style: { height: '23px', width: '39px', padding: '0px' },
	            onClick: function onClick() {
	              var dependentValues = _this.props.dependentValues;
	
	              openDeletePromotion(dependentValues.PromotionLine_id);
	            }
	          },
	          'X'
	        )
	      );
	    }
	  });
	
	  var EditButtonFormatter = _react2.default.createClass({
	    displayName: 'EditButtonFormatter',
	    render: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'warning',
	            className: 'textAlignStyle',
	            style: { height: '23px', width: '39px', padding: '0px' },
	            onClick: function onClick() {
	              var dependentValues = _this2.props.dependentValues;
	
	              handleOpenEditPromotion(dependentValues.PromotionLine_id);
	            }
	          },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	        )
	      );
	    }
	  });
	
	  var ToolTipFormatter = _react2.default.createClass({
	    displayName: 'ToolTipFormatter',
	    render: function render() {
	      return _react2.default.createElement(
	        'span',
	        { 'data-tip': true, 'data-for': this.props.dependentValues.PromotionLine_id },
	        this.props.value
	      );
	    }
	  });
	
	  var AutoApplyFormatter = _react2.default.createClass({
	    displayName: 'AutoApplyFormatter',
	    render: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        this.props.value ? 'Yes' : 'No'
	      );
	    }
	  });
	
	  var OneTimeFormatter = _react2.default.createClass({
	    displayName: 'OneTimeFormatter',
	    render: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        this.props.value ? 'Yes' : 'No'
	      );
	    }
	  });
	
	  var productPromotionColumns = [{
	    key: 'Delete',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	    width: 50,
	    formatter: IsVariableFormatter,
	    getRowMetaData: function getRowMetaData(row) {
	      return row;
	    }
	  }, {
	    key: 'Edit',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' }),
	    width: 55,
	    formatter: EditButtonFormatter,
	    getRowMetaData: function getRowMetaData(row) {
	      return row;
	    }
	  }, {
	    key: 'ProductNum',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	    resizable: true,
	    sortable: true,
	    width: 100,
	    filterable: true
	  }, {
	    key: 'RefNum',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	    resizable: true,
	    sortable: true,
	    width: 90,
	    filterable: true
	  }, {
	    key: 'PromoCode',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'code' }),
	    resizable: true,
	    sortable: true,
	    width: 90,
	    filterable: true
	  }, {
	    key: 'SalesType',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_type' }),
	    resizable: true,
	    sortable: true,
	    width: 100,
	    filterable: true
	  }, {
	    key: 'AutoApply',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'auto' }),
	    resizable: true,
	    sortable: true,
	    width: 70,
	    filterable: true,
	    formatter: AutoApplyFormatter,
	    getRowMetaData: function getRowMetaData(row) {
	      return row;
	    }
	  }].concat(_toConsumableArray(_root_url.isElegant ? [{
	    key: 'IsOneTime',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'one_time' }),
	    resizable: true,
	    sortable: true,
	    width: 70,
	    filterable: true,
	    formatter: OneTimeFormatter,
	    getRowMetaData: function getRowMetaData(row) {
	      return row;
	    }
	  }] : []), [{
	    key: 'Name',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	    resizable: true,
	    sortable: true,
	    width: 200,
	    filterable: true
	  }, {
	    key: 'Description',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	    resizable: true,
	    sortable: true,
	    width: 150,
	    filterable: true
	  }, {
	    key: 'GroupName',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_group' }),
	    resizable: true,
	    sortable: true,
	    width: 150,
	    filterable: true
	  }, {
	    key: 'DiscountDescription',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount_description' }),
	    resizable: true,
	    sortable: true,
	    filterable: true,
	    width: 270,
	    formatter: ToolTipFormatter,
	    getRowMetaData: function getRowMetaData(row) {
	      return row;
	    }
	  }, {
	    key: 'RelatedQuantity',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'gift_quantity_column' }),
	    resizable: true,
	    sortable: true,
	    width: 70,
	    filterable: true
	  }, {
	    key: 'StartDate',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'start_date' }),
	    resizable: true,
	    sortable: true,
	    filterable: true,
	    width: 110,
	    formatter: _dateFormat.DateFormatter
	
	  }, {
	    key: 'EndDate',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'end_date' }),
	    resizable: true,
	    sortable: true,
	    filterable: true,
	    width: 100,
	    formatter: _dateFormat.DateFormatter
	  }]);
	
	  var byQuantityDiscountColumns = [{
	    key: 'Delete',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	    width: 50,
	    formatter: IsVariableFormatter,
	    getRowMetaData: function getRowMetaData(row) {
	      return row;
	    }
	  }, {
	    key: 'Edit',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' }),
	    width: 55,
	    formatter: EditButtonFormatter,
	    getRowMetaData: function getRowMetaData(row) {
	      return row;
	    }
	  }, {
	    key: 'ProductNum',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	    resizable: true,
	    sortable: true,
	    width: 100,
	    filterable: true
	  }, {
	    key: 'RefNum',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	    resizable: true,
	    sortable: true,
	    width: 90,
	    filterable: true
	  }, {
	    key: 'ProductGroupName',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'group' }),
	    resizable: true,
	    sortable: true,
	    width: 200,
	    filterable: true
	  }, {
	    key: 'ProductCategoryName',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'category' }),
	    resizable: true,
	    sortable: true,
	    width: 200,
	    filterable: true
	  }, {
	    key: 'Name',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	    resizable: true,
	    sortable: true,
	    width: 200,
	    filterable: true
	  }, {
	    key: 'Description',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	    resizable: true,
	    sortable: true,
	    width: 150,
	    filterable: true
	  }, {
	    key: 'GroupName',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_group' }),
	    resizable: true,
	    sortable: true,
	    width: 150,
	    filterable: true
	  }, {
	    key: 'DiscountDescription',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount_description' }),
	    resizable: true,
	    sortable: true,
	    filterable: true,
	    width: 270,
	    formatter: ToolTipFormatter,
	    getRowMetaData: function getRowMetaData(row) {
	      return row;
	    }
	  }, {
	    key: 'StartDate',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'start_date' }),
	    resizable: true,
	    sortable: true,
	    filterable: true,
	    width: 110,
	    formatter: _dateFormat.DateFormatter
	
	  }, {
	    key: 'EndDate',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'end_date' }),
	    resizable: true,
	    sortable: true,
	    filterable: true,
	    width: 100,
	    formatter: _dateFormat.DateFormatter
	  }];
	
	  var byQuantityProductColumns = [{
	    key: 'Delete',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	    width: 50,
	    formatter: IsVariableFormatter,
	    getRowMetaData: function getRowMetaData(row) {
	      return row;
	    }
	  }, {
	    key: 'Edit',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' }),
	    width: 55,
	    formatter: EditButtonFormatter,
	    getRowMetaData: function getRowMetaData(row) {
	      return row;
	    }
	  }, {
	    key: 'ProductNum',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	    resizable: true,
	    sortable: true,
	    width: 100,
	    filterable: true
	  }, {
	    key: 'RefNum',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	    resizable: true,
	    sortable: true,
	    width: 90,
	    filterable: true
	  }, {
	    key: 'Name',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	    resizable: true,
	    sortable: true,
	    width: 200,
	    filterable: true
	  }, {
	    key: 'Description',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	    resizable: true,
	    sortable: true,
	    width: 150,
	    filterable: true
	  }, {
	    key: 'GroupName',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_group' }),
	    resizable: true,
	    sortable: true,
	    width: 150,
	    filterable: true
	  }, {
	    key: 'DiscountDescription',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount_description' }),
	    resizable: true,
	    sortable: true,
	    filterable: true,
	    width: 270,
	    formatter: ToolTipFormatter,
	    getRowMetaData: function getRowMetaData(row) {
	      return row;
	    }
	  }, {
	    key: 'StartDate',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'start_date' }),
	    resizable: true,
	    sortable: true,
	    filterable: true,
	    width: 110,
	    formatter: _dateFormat.DateFormatter
	
	  }, {
	    key: 'EndDate',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'end_date' }),
	    resizable: true,
	    sortable: true,
	    filterable: true,
	    width: 100,
	    formatter: _dateFormat.DateFormatter
	  }];
	
	  var byTotalPriceDiscountColumns = [{
	    key: 'Delete',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	    width: 50,
	    formatter: IsVariableFormatter,
	    getRowMetaData: function getRowMetaData(row) {
	      return row;
	    }
	  }, {
	    key: 'Edit',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' }),
	    width: 55,
	    formatter: EditButtonFormatter,
	    getRowMetaData: function getRowMetaData(row) {
	      return row;
	    }
	  }, {
	    key: 'PromoCode',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'code' }),
	    resizable: true,
	    sortable: true,
	    width: 90,
	    filterable: true
	  }, {
	    key: 'AutoApply',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'auto' }),
	    resizable: true,
	    sortable: true,
	    width: 70,
	    filterable: true,
	    formatter: AutoApplyFormatter,
	    getRowMetaData: function getRowMetaData(row) {
	      return row;
	    }
	  }, {
	    key: 'IsOneTime',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'one_time' }),
	    resizable: true,
	    sortable: true,
	    width: 70,
	    filterable: true,
	    formatter: OneTimeFormatter,
	    getRowMetaData: function getRowMetaData(row) {
	      return row;
	    }
	  }].concat(_toConsumableArray(isAFM ? [{
	    key: 'IsPublic',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'public' }),
	    resizable: true,
	    sortable: true,
	    width: 70,
	    filterable: true,
	    formatter: OneTimeFormatter,
	    getRowMetaData: function getRowMetaData(row) {
	      return row;
	    }
	  }] : []), [{
	    key: 'SalesType',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_type' }),
	    resizable: true,
	    sortable: true,
	    width: 100,
	    filterable: true
	  }, {
	    key: 'GroupName',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_group' }),
	    resizable: true,
	    sortable: true,
	    width: 150,
	    filterable: true
	  }, {
	    key: 'PaymentType',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_method' }),
	    resizable: true,
	    sortable: true,
	    width: 200,
	    filterable: true
	  }, {
	    key: 'DiscountDescription',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount_description' }),
	    resizable: true,
	    sortable: true,
	    filterable: true,
	    width: 260
	  }, {
	    key: 'StartDate',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'start_date' }),
	    resizable: true,
	    sortable: true,
	    filterable: true,
	    width: 110,
	    formatter: _dateFormat.DateFormatter
	  }, {
	    key: 'EndDate',
	    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'end_date' }),
	    resizable: true,
	    sortable: true,
	    filterable: true,
	    width: 100,
	    formatter: _dateFormat.DateFormatter
	  }]);
	
	  var getColumns = function getColumns() {
	    if (tabsKey === 'ByTotalPriceDiscount') {
	      return byTotalPriceDiscountColumns;
	    }
	    if (tabsKey === 'ByTotalPriceProduct') {
	      return productPromotionColumns;
	    }
	    if (tabsKey === 'BuyAGetB') {
	      return byQuantityProductColumns;
	    }
	    return byQuantityDiscountColumns;
	  };
	
	  return _react2.default.createElement(
	    _reactBootstrap.Row,
	    null,
	    _react2.default.createElement(
	      _reactBootstrap.Col,
	      { xs: 12 },
	      tabsKey === 'BuyAGetB' && (0, _map2.default)(promotions.rows, function (row) {
	        return _react2.default.createElement(
	          _reactTooltip2.default,
	          { id: '' + row.PromotionLine_id, place: 'top', type: 'dark', effect: 'solid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'product-b-tool-tips' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'product-b' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_b' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-row' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'prod-num' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	                ':'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                row.RelatedProductNum
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-row' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'ref-num' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	                ':'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                row.RelatedRefNum
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-row' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'name', className: 'item-name-label' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'item-name-span' },
	                row.RelatedName
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-row' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'description' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                row.RelatedDescription
	              )
	            )
	          )
	        );
	      }),
	      _react2.default.createElement(
	        'div',
	        { id: 'Promotions-dataGrid1' },
	        _react2.default.createElement(_reactDataGrid2.default, {
	          rowKey: 'Promotion_id',
	          onGridSort: handleGridSort,
	          toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	          onAddFilter: handleFilterChange,
	          onClearFilters: handleClearFilters,
	          columns: getColumns(),
	          rowGetter: rowGetter,
	          rowHeight: 25,
	          headerRowHeight: 45,
	          minHeight: 450,
	          rowsCount: getSize()
	        })
	      )
	    )
	  );
	};
	
	PromotionsTable.propTypes = propTypes;
	PromotionsTable.defaultProps = defaultProps;
	
	var _default = PromotionsTable;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isAFM, 'isAFM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/PromotionsTable.jsx');
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/PromotionsTable.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/PromotionsTable.jsx');
	
	  __REACT_HOT_LOADER__.register(PromotionsTable, 'PromotionsTable', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/PromotionsTable.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/PromotionsPage/components/PromotionsTable.jsx');
	}();

	;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	var _url = __webpack_require__(20);
	
	var _sales_actions = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  modal: {
	    width: '50%',
	    height: '350px'
	    // marginLeft: '-15%',
	  },
	  container: {
	    display: 'flex',
	    // alignItems: 'center',
	    flexDirection: 'column'
	    // justifyContent: 'space-between',
	  },
	  input: {
	    border: '1px solid black',
	    marginLeft: '20px',
	    width: '190px',
	    padding: '2px',
	    borderRadius: '5px'
	  },
	  col: {
	    marginTop: '20px'
	  }
	};
	
	var DropshipModal = function (_React$Component) {
	  _inherits(DropshipModal, _React$Component);
	
	  function DropshipModal(props) {
	    _classCallCheck(this, DropshipModal);
	
	    var _this = _possibleConstructorReturn(this, (DropshipModal.__proto__ || Object.getPrototypeOf(DropshipModal)).call(this, props));
	
	    _this.saveShippingAddress = function () {
	      _this.setState({
	        loading: true
	      });
	      _axios2.default.put(_url.MOBILE_SALES_ORDER_SHIPPINGINFO_URL, _this.state.shippingInfo, { headers: { Authorization: 'Bearer ' + localStorage.getItem('token') } }).then(function (res) {
	        _this.props.updateMSOFormInitialValues(_this.state.shippingInfo);
	        _this.props.change('salesOrderForm', 'Shipping', _this.state.shippingInfo);
	        _this.setState({
	          loading: false,
	          errMsg: null
	        });
	        _this.props.onClose();
	      }).catch(function (err) {
	        _this.setState({
	          loading: false,
	          errMsg: 'Something wrong with the provided shipping information, please make sure all fields are filled and accurate'
	        });
	      });
	      // this.props.updateShippingAddress()
	
	      // const { selectedVendorId } = this.state;
	      // const { salesOrderId } = this.props;
	      // if (!selectedVendorId) {
	      //   alert('Please enter a vendor.');
	      //   return;
	      // }
	      // this.setState({
	      //   loading: true,
	      // });
	      // axios.post(`${SALES_ORDER_DROPDHIP_URL}${salesOrderId}`, {
	      //   vendor_id: selectedVendorId,
	      // }, {
	      //   headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
	      // }).then((response) => {
	      //   const { purchase_order_id } = response.data;
	      //   window.location.pathname = `/purchaseOrder/${purchase_order_id}`;
	      // }).catch(() => {
	      //   alert('Internal Server Error. Please try again.');
	      // });
	    };
	
	    _this.updateShippingInfo = function (evt, field) {
	      _this.setState({
	        errMsg: null,
	        shippingInfo: _extends({}, _this.state.shippingInfo, _defineProperty({}, field, evt.target.value))
	      });
	    };
	
	    _this.state = {
	      loading: false,
	      shippingInfo: props.initialValues ? props.initialValues.Shipping : {},
	      errMsg: null
	    };
	    return _this;
	  }
	  // { "CustomerDetail_id": 2, "AddressName": "", "Country": "United States", "State": "CA", "City": "Berkeley", "Street": "334 w garvey ave,undefined", "Zip": "94701", "lat": 34.062674, "lng": -118.127149, "FirstName": "tim", "LastName": "tim", "Telephone": "6263829999", "Cellphone": "", "Fax": "", "Email": "", "Note": "", "Type": "Shipping", "IsDefault": false, "IsDeleted": false, "Customer_id": 20, "Address": "333 w garvey ave" }
	
	
	  _createClass(DropshipModal, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          isVisible = _props.isVisible,
	          onClose = _props.onClose,
	          updateShippingAddress = _props.updateShippingAddress;
	
	      return _react2.default.createElement(
	        _reactSkylight.SkyLightStateless,
	        {
	          dialogStyles: styles.modal,
	          isVisible: isVisible,
	          onCloseClicked: onClose
	        },
	        _react2.default.createElement(
	          'div',
	          { style: styles.container },
	          _react2.default.createElement(
	            'div',
	            { style: { width: '100%' } },
	            _react2.default.createElement(
	              'h2',
	              { style: { margin: '0 auto' } },
	              'Shipping Information Edit'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 4, style: styles.col },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'first_name' })
	              ),
	              _react2.default.createElement('input', { type: 'text', style: styles.input, value: this.state.shippingInfo.FirstName, onChange: function onChange(e) {
	                  return _this2.updateShippingInfo(e, 'FirstName');
	                } })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 4, style: styles.col },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_name' })
	              ),
	              _react2.default.createElement('input', { type: 'text', style: styles.input, value: this.state.shippingInfo.LastName, onChange: function onChange(e) {
	                  return _this2.updateShippingInfo(e, 'LastName');
	                } })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 4, style: styles.col },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	              ),
	              _react2.default.createElement('input', { type: 'text', style: styles.input, value: this.state.shippingInfo.Telephone, onChange: function onChange(e) {
	                  return _this2.updateShippingInfo(e, 'Telephone');
	                } })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6, style: styles.col },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'street' })
	              ),
	              _react2.default.createElement('input', { type: 'text', style: styles.input, value: this.state.shippingInfo.Street, onChange: function onChange(e) {
	                  return _this2.updateShippingInfo(e, 'Street');
	                } })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6, style: styles.col },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city' })
	              ),
	              _react2.default.createElement('input', { type: 'text', style: styles.input, value: this.state.shippingInfo.City, onChange: function onChange(e) {
	                  return _this2.updateShippingInfo(e, 'City');
	                } })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6, style: styles.col },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'state' })
	              ),
	              _react2.default.createElement('input', { style: styles.input, type: 'text', value: this.state.shippingInfo.State, onChange: function onChange(e) {
	                  return _this2.updateShippingInfo(e, 'State');
	                } })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6, style: styles.col },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zip_code' })
	              ),
	              _react2.default.createElement('input', { type: 'text', style: styles.input, value: this.state.shippingInfo.Zip, onChange: function onChange(e) {
	                  return _this2.updateShippingInfo(e, 'Zip');
	                } })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: 50, width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' } },
	            _react2.default.createElement(
	              'p',
	              { style: { color: 'red' } },
	              this.state.errMsg
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                onClick: this.saveShippingAddress,
	                disabled: this.state.loading,
	                style: { float: 'right' }
	              },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DropshipModal;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    vendors: state.vendors.all
	  };
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { updateMSOFormInitialValues: _sales_actions.updateMSOFormInitialValues, change: _reduxForm.change })(DropshipModal);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/ShippingInfoFormModal.jsx');
	
	  __REACT_HOT_LOADER__.register(DropshipModal, 'DropshipModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/ShippingInfoFormModal.jsx');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/ShippingInfoFormModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/ShippingInfoFormModal.jsx');
	}();

	;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _inputField = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CashOutModal = function (_Component) {
	  _inherits(CashOutModal, _Component);
	
	  function CashOutModal() {
	    _classCallCheck(this, CashOutModal);
	
	    var _this = _possibleConstructorReturn(this, (CashOutModal.__proto__ || Object.getPrototypeOf(CashOutModal)).call(this));
	
	    _this.submitFields = function () {
	      console.log("CHEKC", _this.props.rowProps, _this.props.curRegisterId);
	      console.log(_this.props);
	      console.log("Changed to the state", _this.state);
	      var _this$state$moduleVal = _this.state.moduleValues,
	          CountedCash = _this$state$moduleVal.CountedCash,
	          CountedStoreCredit = _this$state$moduleVal.CountedStoreCredit,
	          CountedCard = _this$state$moduleVal.CountedCard,
	          CountedCheck = _this$state$moduleVal.CountedCheck,
	          TotalCounted = _this$state$moduleVal.TotalCounted,
	          Balance = _this$state$moduleVal.Balance,
	          NumCardTransaction = _this$state$moduleVal.NumCardTransaction,
	          NumCheck = _this$state$moduleVal.NumCheck;
	
	      var updatedField = {
	        CountedCash: CountedCash,
	        CountedStoreCredit: CountedStoreCredit,
	        CountedCard: CountedCard,
	        CountedCheck: CountedCheck,
	        TotalCounted: TotalCounted,
	        Balance: Balance,
	        NumCardTransaction: NumCardTransaction,
	        NumCheck: NumCheck
	      };
	      console.log("DDododood", updatedField);
	      _this.props.verifyRegisters(_this.props.rowProps.Session_id, updatedField);
	      _this.props.finishedSubmit();
	    };
	
	    _this.handleInputChange = function (e) {
	      var moduleValues = _extends({}, _this.state.moduleValues);
	      console.log("e value", e.target.value);
	      if (typeof parseFloat(e.target.value, 10) !== 'NaN') {
	        moduleValues[e.target.name] = parseFloat(e.target.value, 10);
	        moduleValues.TotalCounted = parseFloat(moduleValues.CountedCash, 10) + parseFloat(moduleValues.CountedStoreCredit, 10) + parseFloat(moduleValues.CountedCard, 10) + parseFloat(moduleValues.CountedCheck, 10);
	        moduleValues.Balance = moduleValues.TotalCounted - (parseFloat(moduleValues.TotalSale, 10) - parseFloat(moduleValues.TotalPaidOut, 10));
	        _this.setState({ moduleValues: moduleValues });
	      }
	    };
	
	    _this.state = {
	      moduleValues: {
	        TotalCashAmount: 0,
	        PaidOutByCash: 0,
	        StoreCredit: 0,
	        CreditCards: 0,
	        Checks: 0,
	        TotalSale: 0,
	        TotalPaidOut: 0,
	
	        CountedCash: 0,
	        CountedStoreCredit: 0,
	        CountedCard: 0,
	        CountedCheck: 0,
	        TotalCounted: 0,
	        Balance: 0,
	
	        NumCardTransaction: 0,
	        NumCheck: 0
	      }
	    };
	    return _this;
	  }
	
	  _createClass(CashOutModal, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      console.log("here");
	      console.log("props", this.props);
	      var _props$rowProps = this.props.rowProps,
	          TotalCashAmount = _props$rowProps.TotalCashAmount,
	          PaidOutByCash = _props$rowProps.PaidOutByCash,
	          StoreCredit = _props$rowProps.StoreCredit,
	          CreditCards = _props$rowProps.CreditCards,
	          Checks = _props$rowProps.Checks,
	          TotalSale = _props$rowProps.TotalSale,
	          TotalPaidOut = _props$rowProps.TotalPaidOut,
	          CountedCash = _props$rowProps.CountedCash,
	          CountedStoreCredit = _props$rowProps.CountedStoreCredit,
	          CountedCard = _props$rowProps.CountedCard,
	          CountedCheck = _props$rowProps.CountedCheck,
	          TotalCounted = _props$rowProps.TotalCounted,
	          Balance = _props$rowProps.Balance,
	          NumCardTransaction = _props$rowProps.NumCardTransaction,
	          NumCheck = _props$rowProps.NumCheck;
	
	      this.setState({
	        moduleValues: {
	          TotalCashAmount: parseFloat(TotalCashAmount, 10),
	          PaidOutByCash: parseFloat(PaidOutByCash, 10),
	          StoreCredit: parseFloat(StoreCredit, 10),
	          CreditCards: parseFloat(CreditCards, 10),
	          Checks: parseFloat(Checks, 10),
	          TotalSale: parseFloat(TotalSale, 10),
	          TotalPaidOut: parseFloat(TotalPaidOut, 10),
	
	          CountedCash: 0,
	          CountedStoreCredit: 0,
	          CountedCard: 0,
	          CountedCheck: 0,
	          TotalCounted: parseFloat(TotalCounted, 10),
	          Balance: parseFloat(Balance, 10),
	
	          NumCardTransaction: parseFloat(NumCardTransaction, 10),
	          NumCheck: parseFloat(NumCheck, 10)
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      console.log("..", nextProps);
	      var newValues = _extends({}, this.state);
	      var _state$moduleValues = this.state.moduleValues,
	          TotalSale = _state$moduleValues.TotalSale,
	          TotalPaidOut = _state$moduleValues.TotalPaidOut,
	          CountedCash = _state$moduleValues.CountedCash,
	          CountedStoreCredit = _state$moduleValues.CountedStoreCredit,
	          CountedCard = _state$moduleValues.CountedCard,
	          CountedCheck = _state$moduleValues.CountedCheck;
	
	      newValues.moduleValues.TotalCounted = parseFloat(CountedCash, 10) + parseFloat(CountedStoreCredit, 10) + parseFloat(CountedCard, 10) + parseFloat(CountedCheck, 10);
	      newValues.moduleValues.Balance = newValues.moduleValues.TotalCounted - (parseFloat(TotalSale, 10) - parseFloat(TotalPaidOut, 10));
	      this.setState({ newValues: newValues });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      console.log("RowProps", this.props.rowProps);
	      var _props$rowProps2 = this.props.rowProps,
	          TotalCashAmount = _props$rowProps2.TotalCashAmount,
	          PaidOutByCash = _props$rowProps2.PaidOutByCash,
	          StoreCredit = _props$rowProps2.StoreCredit,
	          CreditCards = _props$rowProps2.CreditCards,
	          Checks = _props$rowProps2.Checks,
	          TotalSale = _props$rowProps2.TotalSale,
	          TotalPaidOut = _props$rowProps2.TotalPaidOut,
	          CountedCash = _props$rowProps2.CountedCash,
	          CountedStoreCredit = _props$rowProps2.CountedStoreCredit,
	          CountedCard = _props$rowProps2.CountedCard,
	          CountedCheck = _props$rowProps2.CountedCheck,
	          TotalCounted = _props$rowProps2.TotalCounted,
	          Balance = _props$rowProps2.Balance,
	          NumCardTransaction = _props$rowProps2.NumCardTransaction,
	          NumCheck = _props$rowProps2.NumCheck;
	
	      console.log("HEY HEY HEY", this.props.curRegisterId);
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'cash-out-modal', fluid: true },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cash' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cash_total' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'TotalCashAmount', component: _inputField.DisabledInputField, placeholder: TotalCashAmount })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cash_paid_out' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'PaidOutByCash', component: _inputField.DisabledInputField, placeholder: PaidOutByCash })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'counted_cash' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'CountedCash', type: 'number', component: _inputField.InputField, onChange: this.handleInputChange })
	                    )
	                  )
	                ),
	                _react2.default.createElement('div', { className: 'col-xs-5ths' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'store_credits' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'store_credit' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'StoreCredit', component: _inputField.DisabledInputField, placeholder: StoreCredit })
	                    )
	                  )
	                ),
	                _react2.default.createElement('div', { className: 'col-xs-5ths' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'counted_store_credit' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'CountedStoreCredit', type: 'number', component: _inputField.InputField, onChange: this.handleInputChange })
	                    )
	                  )
	                ),
	                _react2.default.createElement('div', { className: 'col-xs-5ths' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cards' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'card_total' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'CreditCards', component: _inputField.DisabledInputField, placeholder: CreditCards })
	                    )
	                  )
	                ),
	                _react2.default.createElement('div', { className: 'col-xs-5ths' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'counted_card' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'CountedCard', type: 'number', component: _inputField.InputField, onChange: this.handleInputChange })
	                    )
	                  )
	                ),
	                _react2.default.createElement('div', { className: 'col-xs-5ths' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'checks' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check_total' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'Checks', component: _inputField.DisabledInputField, placeholder: Checks })
	                    )
	                  )
	                ),
	                _react2.default.createElement('div', { className: 'col-xs-5ths' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'counted_check' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'CountedCheck', type: 'number', component: _inputField.InputField, onChange: this.handleInputChange })
	                    )
	                  )
	                ),
	                _react2.default.createElement('div', { className: 'col-xs-5ths' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total' })
	                ),
	                _react2.default.createElement('div', { className: 'col-xs-5ths' }),
	                _react2.default.createElement('div', { className: 'col-xs-5ths' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_count' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'TotalCounted', component: _inputField.DisabledInputField, onChange: this.handleInputChange, placeholder: this.state.moduleValues.TotalCounted })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'Balance', component: _inputField.DisabledInputField, onChange: this.handleInputChange, placeholder: this.state.moduleValues.Balance })
	                    )
	                  )
	                ),
	                _react2.default.createElement('div', { className: 'col-xs-5ths' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_sale' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'TotalSale', component: _inputField.DisabledInputField, placeholder: TotalSale })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_paid_out' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'TotalPaidOut', component: _inputField.DisabledInputField, placeholder: TotalPaidOut })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement('div', { className: 'col-xs-5ths' }),
	                _react2.default.createElement('div', { className: 'col-xs-5ths' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'number_of_card_transactions' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'NumCardTransaction', type: 'number', component: _inputField.InputField, onChange: this.handleInputChange })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement('div', { className: 'col-xs-5ths' }),
	                _react2.default.createElement('div', { className: 'col-xs-5ths' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'number_of_checks' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-5ths' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 6 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'NumChecks', type: 'number', component: _inputField.InputField, onChange: this.handleInputChange })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(_reactBootstrap.Row, null),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(_reactBootstrap.Col, { xs: 6 }),
	                _react2.default.createElement(_reactBootstrap.Col, { xs: 6 }),
	                _react2.default.createElement(_reactBootstrap.Col, { xs: 6 }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-4ths' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { onClick: this.submitFields },
	                    'Submit'
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CashOutModal;
	}(_react.Component);
	
	var _default = CashOutModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CashOutModal, 'CashOutModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/cashOutModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/cashOutModal.jsx');
	}();

	;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactDropzone = __webpack_require__(45);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _ImageFormatter = __webpack_require__(73);
	
	var _ImageFormatter2 = _interopRequireDefault(_ImageFormatter);
	
	var _sales_actions = __webpack_require__(28);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(5),
	    _require$Draggable = _require.Draggable,
	    DraggableContainer = _require$Draggable.Container,
	    RowActionsCell = _require$Draggable.RowActionsCell,
	    DropTargetRowContainer = _require$Draggable.DropTargetRowContainer,
	    Selectors = _require.Data.Selectors;
	
	var propTypes = {
	  rowKey: _propTypes2.default.string,
	  salesOrder_id: _propTypes2.default.number,
	  handleImageClosed: _propTypes2.default.func
	};
	
	var defaultProps = {
	  rowKey: 'Index',
	  salesOrder_id: undefined,
	  handleImageClosed: function handleImageClosed() {}
	};
	
	var BolImagesTable = function (_Component) {
	  _inherits(BolImagesTable, _Component);
	
	  function BolImagesTable(props) {
	    _classCallCheck(this, BolImagesTable);
	
	    var _this = _possibleConstructorReturn(this, (BolImagesTable.__proto__ || Object.getPrototypeOf(BolImagesTable)).call(this, props));
	
	    _this.onDrop = function (row, files) {
	      if (!files) {
	        return;
	      }
	      var reader = new FileReader();
	      reader.onload = function () {
	        var index = row.props.rowIdx;
	
	        var newRows = [].concat(_toConsumableArray(_this.state.newImage.rows));
	        newRows[index].imageString = reader.result;
	        newRows[index].file = files;
	
	        var newImage = _extends({}, _this.state.newImage, {
	          rows: newRows
	        });
	        _this.setState({ newImage: newImage });
	      };
	
	      // get the first file and convert to blob object (Blob.slice([start [, end [, contentType]]))
	      var blob = files[0].slice(0, files[0].size, files[0].type);
	      reader.readAsDataURL(blob);
	    };
	
	    _this.handleSaveImages = function () {
	      var rows = _this.state.newImage.rows.filter(function (row) {
	        var match = !(row.imageString === undefined);
	        return match;
	      });
	      var newImage = _extends({}, _this.state.newImage, {
	        rows: rows
	      });
	      _this.setState({ newImage: newImage }, function () {
	        _this.saveImages(function () {
	          _this.fetchImages();
	        });
	      });
	    };
	
	    _this.addNewImageRow = function (e) {
	      e.preventDefault();
	      var rows = _reactDataGridAddons.Data.Selectors.getRows(_this.state.newImage);
	      var index = rows.length;
	      var newRow = {
	        Index: index
	      };
	      rows.push(newRow);
	      var newImage = _extends({}, _this.state.newImage, {
	        rows: rows
	      });
	      _this.setState({ newImage: newImage });
	    };
	
	    _this.deleteOldRow = function () {
	      var selectedRows = _this.state.oldImage.selectedRows;
	
	      if (!selectedRows || selectedRows.length === 0) {
	        alert('Select a row to delete!');
	        return;
	      }
	      var id = selectedRows[0].Image_id;
	
	      _this.deleteImage(id, function () {
	        return _this.fetchImages();
	      });
	    };
	
	    _this.deleteImage = function (imageId, successCallback) {
	      var handleSuccess = function handleSuccess(response) {
	        _this.setState({
	          isDeletingImage: false
	        }, successCallback);
	      };
	      var handleFailure = function handleFailure(error) {
	        alert(error);
	        _this.setState({
	          isDeletingImage: false
	        });
	      };
	      _this.setState({
	        isDeletingImage: true
	      }, function () {
	        if (_root_url.isTN) {
	          (0, _sales_actions.deleteBolImageSCM)(imageId, handleSuccess, handleFailure);
	        } else {
	          (0, _sales_actions.deleteBolImage)(imageId, handleSuccess, handleFailure);
	        }
	      });
	    };
	
	    _this.deleteNewRow = function () {
	      var selectedRows = _this.state.newImage.selectedRows;
	
	      if (!selectedRows || selectedRows.length === 0) {
	        alert('Select a row to delete!');
	        return;
	      }
	      var rows = [].concat(_toConsumableArray(_this.state.newImage.rows));
	      var index = _lodash2.default.findIndex(rows, { Index: selectedRows[0].Index });
	      rows.map(function (row, rowIndex) {
	        row.Index = rowIndex;
	      });
	      rows.splice(index, 1);
	      var newImage = _extends({}, _this.state.newImage, {
	        rows: rows
	      });
	      _this.setState({ newImage: newImage });
	    };
	
	    _this.fetchImages = function () {
	      var handleSuccess = function handleSuccess(response) {
	        var rows = response.OrderImages || [];
	        if (_root_url.isTN) {
	          rows = response.Images;
	        }
	        rows.map(function (row, index) {
	          row.Index = index;
	        });
	        var oldImage = _extends({}, _this.state.oldImage, {
	          rows: rows
	        });
	        _this.setState({
	          oldImage: oldImage,
	          isLoadingImages: false
	        });
	      };
	      var handleFailure = function handleFailure(error) {
	        alert(error);
	        var oldImage = _extends({}, _this.state.oldImage, {
	          rows: rows
	        });
	        _this.setState({
	          oldImage: oldImage,
	          isLoadingImages: false
	        });
	      };
	      _this.setState({
	        isLoadingImages: true
	      }, function () {
	        if (_root_url.isTN) {
	          (0, _sales_actions.fetchBolImageOCM)(_this.props.salesOrder_id, handleSuccess, handleFailure);
	        } else {
	          (0, _sales_actions.fetchBolImage)(_this.props.salesOrder_id, handleSuccess, handleFailure);
	        }
	      });
	    };
	
	    _this.saveImages = function (successCallback) {
	      var handleSuccess = function handleSuccess(response) {
	        alert('Image is submit! ');
	        _this.setState({
	          isSavingImages: false
	        }, successCallback);
	        _this.props.handleImageClosed();
	      };
	      var handleFailure = function handleFailure(error) {
	        var msg = "Error: ";
	        msg += JSON.stringify(error);
	        alert(msg);
	        _this.setState({
	          isSavingImages: false
	        });
	      };
	      _this.setState({
	        isSavingImages: true
	      }, function () {
	        if (_root_url.isTN) {
	          (0, _sales_actions.submitBolImageSCM)(_this.props.salesOrder_id, _this.state.newImage.rows, handleSuccess, handleFailure);
	        } else {
	          (0, _sales_actions.submitBolImage)(_this.props.salesOrder_id, _this.state.newImage.rows, handleSuccess, handleFailure);
	        }
	      });
	    };
	
	    _this.renderNewImage = function (index) {
	      var imageFile = _this.state.newImage.rows[index].imageString || '/img/dummy.png';
	      return _react2.default.createElement(
	        'div',
	        { className: 'img-view' },
	        _react2.default.createElement('img', {
	          src: imageFile,
	          alt: 'Upload',
	          className: 'default-image'
	        })
	      );
	    };
	
	    _this.state = {
	      oldImage: {
	        rows: [],
	        selectedRows: null
	      },
	      newImage: {
	        rows: [],
	        selectedRows: null
	      },
	
	      isLoadingImages: false,
	      isSavingImages: false,
	      isDeletingImage: false
	    };
	    return _this;
	  }
	
	  _createClass(BolImagesTable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchImages();
	    }
	  }, {
	    key: 'renderImageTable',
	    value: function renderImageTable() {
	      var _this2 = this;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.oldImage);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        // merge updated row with current row and rerender by setting state
	        var rows = getRows();
	        Object.assign(rows[e.rowIdx], e.updated);
	        var oldImage = _extends({}, _this2.state.oldImage, {
	          rows: rows
	        });
	        _this2.setState({ oldImage: oldImage });
	
	        // // merge updated row with current row and rerender by setting state
	        // const rows = getRows();
	        // const editedRows = this.state.editedRows.slice(0);
	        // Object.assign(rows[e.rowIdx], e.updated);
	        // // if the element is already edited, remove the old one.
	        // editedRows.forEach((element, index) => {
	        //   if (element.Idx === rows[e.rowIdx].Index) {
	        //     editedRows.splice(index, 1);
	        //   }
	        // }, this);
	        // // push the row into the editedRows array
	        // editedRows.push(rows[e.rowIdx]);
	        // this.setState({
	        //   rows,
	        //   editedRows,
	        // });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        var oldImage = _extends({}, _this2.state.oldImage, {
	          rows: newRows,
	          selectedRows: [rows[0].row]
	        });
	        _this2.setState({
	          oldImage: oldImage
	        });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = getRows();
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        var oldImage = _extends({}, _this2.state.oldImage, {
	          rows: newRows,
	          selectedRows: []
	        });
	        _this2.setState({ oldImage: oldImage });
	      };
	
	      var columns = [{
	        key: "ImageURL",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'image' }),
	        resizeable: true,
	        width: 220,
	        sortable: false,
	        editable: false,
	        filterable: false,
	        formatter: function formatter(_ref) {
	          var value = _ref.value;
	          return _react2.default.createElement(
	            'div',
	            { className: 'group-thumbnail-cell' },
	            _react2.default.createElement(
	              'div',
	              { id: 'image-container' },
	              _react2.default.createElement('img', { style: { width: "120px", height: "120px", border: "1px solid #333333" }, src: value })
	            )
	          );
	        },
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: "100%" }, id: 'Category_2-dataGrid1' },
	            _react2.default.createElement(
	              DraggableContainer,
	              null,
	              _react2.default.createElement(_reactDataGrid2.default, {
	                columns: columns,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                minHeight: 500,
	                rowHeight: 200,
	                headerRowHeight: 25,
	                enableRowSelect: 'single',
	                onRowUpdated: handleRowUpdated,
	                rowSelection: {
	                  showCheckbox: true,
	                  onRowsSelected: onRowsSelected,
	                  onRowsDeselected: onRowsDeselected,
	                  selectBy: {
	                    isSelectedKey: 'isSelected'
	                  }
	                }
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderNewImageTable',
	    value: function renderNewImageTable() {
	      var _this3 = this;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.newImage);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        // merge updated row with current row and rerender by setting state
	        var rows = getRows();
	        Object.assign(rows[e.rowIdx], e.updated);
	        var newImage = _extends({}, _this3.state.newImage, {
	          rows: rows
	        });
	        _this3.setState({ newImage: newImage });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        var newImage = _extends({}, _this3.state.newImage, {
	          rows: newRows,
	          selectedRows: [rows[0].row]
	        });
	        _this3.setState({ newImage: newImage });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = getRows();
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        var newImage = _extends({}, _this3.state.newImage, {
	          rows: newRows,
	          selectedRows: []
	        });
	        _this3.setState({ newImage: newImage });
	      };
	
	      var columns = [{
	        key: "Image",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'image' }),
	        resizeable: true,
	        width: 220,
	        sortable: false,
	        editable: false,
	        filterable: false,
	        formatter: _react2.default.createElement(_ImageFormatter2.default, {
	          renderImage: this.renderNewImage,
	          onDrop: this.onDrop,
	          showImageOnly: true,
	          onRowValueChange: this.onRowValueChange
	        }),
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: "100%" }, id: 'Category_2-dataGrid1' },
	            _react2.default.createElement(
	              DraggableContainer,
	              null,
	              _react2.default.createElement(_reactDataGrid2.default, {
	                columns: columns,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                minHeight: 500,
	                rowHeight: 200,
	                headerRowHeight: 25,
	                enableRowSelect: 'single',
	                onRowUpdated: handleRowUpdated,
	                rowSelection: {
	                  showCheckbox: true,
	                  onRowsSelected: onRowsSelected,
	                  onRowsDeselected: onRowsDeselected,
	                  selectBy: {
	                    isSelectedKey: 'isSelected'
	                  }
	                }
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isSavingImages = _state.isSavingImages,
	          isDeletingImage = _state.isDeletingImage;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { id: 'product-images-modal' },
	          _react2.default.createElement(
	            'div',
	            { style: { width: "50%", float: 'left' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'toolbar-row' },
	              _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                null,
	                _react2.default.createElement(_SpinnerButton2.default, {
	                  bsStyle: 'danger',
	                  disabled: isDeletingImage,
	                  onClick: this.deleteOldRow,
	                  loading: isDeletingImage,
	                  icon: 'fa-trash',
	                  translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                })
	              )
	            ),
	            this.renderImageTable()
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { width: "50%", float: 'left' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'toolbar-row' },
	              _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'primary',
	                    onClick: this.addNewImageRow
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	                ),
	                _react2.default.createElement(_SpinnerButton2.default, {
	                  bsStyle: 'success',
	                  disabled: isSavingImages,
	                  onClick: this.handleSaveImages,
	                  loading: isSavingImages,
	                  icon: 'fa-save',
	                  translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                }),
	                _react2.default.createElement(_SpinnerButton2.default, {
	                  bsStyle: 'danger',
	                  onClick: this.deleteNewRow,
	                  icon: 'fa-trash',
	                  translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                })
	              )
	            ),
	            this.renderNewImageTable()
	          )
	        )
	      );
	    }
	  }]);
	
	  return BolImagesTable;
	}(_react.Component);
	
	BolImagesTable.propTypes = propTypes;
	BolImagesTable.defaultProps = defaultProps;
	
	var _default = BolImagesTable;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/components/BolImagesTable.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/components/BolImagesTable.jsx');
	
	  __REACT_HOT_LOADER__.register(BolImagesTable, 'BolImagesTable', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/components/BolImagesTable.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/components/BolImagesTable.jsx');
	}();

	;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEKC = _root_url.ROOT_API_URL === 'https://365-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://365-scm.truckxi.com/api/';
	var isSV = _root_url.ROOT_API_URL === 'https://sunset-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://sunset-scm.truckxi.com/api/';
	
	var initialState = {
	  subject: '',
	  content: ''
	};
	
	var emailOptions = [{ label: "Welleastflooring@gmail.com", value: "Welleastflooring@gmail.com" }, { label: "Excellentflooring4400@gmail.com", value: "Excellentflooring4400@gmail.com" }];
	
	var emailOptionsSVPO = [{ label: "jenny@gmail.com", value: "jenny@gmail.com" }, { label: "lyn@gmail.com", value: "lyn@gmail.com" }];
	
	var EmailContentModal = function (_Component) {
	  _inherits(EmailContentModal, _Component);
	
	  function EmailContentModal() {
	    _classCallCheck(this, EmailContentModal);
	
	    var _this = _possibleConstructorReturn(this, (EmailContentModal.__proto__ || Object.getPrototypeOf(EmailContentModal)).call(this));
	
	    _this.handleSendClick = function () {
	      var _this$state = _this.state,
	          selectedEmail = _this$state.selectedEmail,
	          sendEmail = _this$state.sendEmail;
	
	      var email = null;
	      if (selectedEmail) {
	        email = selectedEmail.value;
	      }
	      _this.props.onConfirm(_this.state.subject, _this.state.content, email, _this.state.phone, _this.state.sendEmail, _this.props.source);
	    };
	
	    _this.handleInputChange = function (_ref) {
	      var target = _ref.target;
	
	      // preventDefault();
	      // console.log('target', target)
	      _this.setState(_defineProperty({}, target.name, target.value));
	    };
	
	    _this.handleDropdownChange = function (target) {
	      _this.setState({
	        selectedEmail: target
	      });
	    };
	
	    _this.state = _extends({}, initialState, {
	      selectedEmail: null,
	      phone: '',
	      vendorurl: '',
	      sendEmail: ''
	    });
	    // this.subjectRef = React.createRef();
	    return _this;
	  }
	
	  _createClass(EmailContentModal, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      if (this.props.visible && !prevProps.visible) {
	        this.setState(_extends({}, initialState, {
	          subject: this.props.subject,
	          content: this.props.content
	        }), function () {
	          // this.subjectRef.current.focus();
	        });
	      }
	      if (this.props.visible && !prevProps.visible) {
	        if (this.props.selectedRows && this.props.selectedRows.length) {
	          if (this.props.source === "PO") {
	            this.state.vendorurl = _root_url.ROOT_URL + 'v1/vendor/' + this.props.selectedRows[0].Vendor_id;
	            (0, _axios2.default)({
	              method: 'GET',
	              url: this.state.vendorurl,
	              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	            }).then(function (res) {
	              if (res.data && res.data.Billing && res.data.Billing.Telephone) {
	                _this2.setState({ phone: res.data.Billing.Telephone });
	              }
	              if (res.data && res.data.Billing && res.data.Billing.Email) {
	                _this2.setState({ sendEmail: res.data.Billing.Email });
	              }
	            }, function (err) {});
	          }
	
	          if (this.props.source === "SO" || this.props.source === "SQ" || this.props.source === "CS") {
	            this.state.vendorurl = _root_url.ROOT_URL + 'v1/sale/customer/' + this.props.selectedRows[0].Deliver_Customer_id;
	            (0, _axios2.default)({
	              method: 'GET',
	              url: this.state.vendorurl,
	              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	            }).then(function (res) {
	              if (res.data && res.data.Billing && res.data.Billing.Telephone) {
	                _this2.setState({ phone: res.data.Billing.Telephone });
	              }
	              if (res.data && res.data.Billing && res.data.Billing.Email) {
	                _this2.setState({ sendEmail: res.data.Billing.Email });
	              }
	            }, function (err) {});
	          }
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          visible = _props.visible,
	          onClose = _props.onClose;
	
	      return _react2.default.createElement(
	        _reactSkylight.SkyLightStateless,
	        {
	          dialogStyles: styles.modal,
	          isVisible: visible,
	          onCloseClicked: onClose,
	          title: 'Send Content'
	        },
	        _react2.default.createElement(
	          'div',
	          { style: styles.container },
	          _react2.default.createElement(
	            'div',
	            { className: 'panel panel-default', style: { overflowY: 'scroll', width: '100%', 'justifyContent': 'center', display: 'flex' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel-body', style: { width: "100%" } },
	              isEKC && _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2, alignContent: 'center' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-xs-3' },
	                    'from: '
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 9 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'email365' },
	                    _react2.default.createElement(_GenericSelection2.default, {
	                      options: emailOptions,
	                      value: this.state.selectedEmail,
	                      setSelected: function setSelected(e) {
	                        _this3.handleDropdownChange(e);
	                      }
	                    })
	                  )
	                )
	              ),
	              isSV && this.props.source === 'PO' && _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2, alignContent: 'center' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-xs-3' },
	                    'from: '
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 9 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'email365' },
	                    _react2.default.createElement(_GenericSelection2.default, {
	                      options: emailOptionsSVPO,
	                      value: this.state.selectedEmail,
	                      setSelected: function setSelected(e) {
	                        _this3.handleDropdownChange(e);
	                      }
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { style: styles.row },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2, alignContent: 'center' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-xs-3' },
	                    'Phone: '
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 9 },
	                  _react2.default.createElement('input', {
	                    name: 'phone',
	                    className: 'form-control',
	                    value: this.state.phone,
	                    onChange: function onChange(e) {
	                      return _this3.handleInputChange(e);
	                    },
	                    autoFocus: true
	                    // ref={subjectRef}
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { width: '100%', color: 'red' } },
	                    this.state.error
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { style: styles.row },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2, alignContent: 'center' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-xs-3' },
	                    'Email: '
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 9 },
	                  _react2.default.createElement('input', {
	                    name: 'sendEmail',
	                    className: 'form-control',
	                    value: this.state.sendEmail,
	                    onChange: function onChange(e) {
	                      return _this3.handleInputChange(e);
	                    },
	                    autoFocus: true
	                    // ref={subjectRef}
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { width: '100%', color: 'red' } },
	                    this.state.error
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { style: styles.row },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2, alignContent: 'center' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-xs-3' },
	                    'Subject: '
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 9 },
	                  _react2.default.createElement('input', {
	                    name: 'subject',
	                    className: 'form-control',
	                    value: this.state.subject,
	                    onChange: function onChange(e) {
	                      return _this3.handleInputChange(e);
	                    },
	                    autoFocus: true
	                    // ref={subjectRef}
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { width: '100%', color: 'red' } },
	                    this.state.error
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { style: styles.row },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 2, alignContent: 'center' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-xs-3' },
	                    'Content: '
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 9 },
	                  _react2.default.createElement('textarea', {
	                    // type="password"
	                    name: 'content',
	                    className: 'form-control',
	                    style: { width: '100%', height: '220px', outline: 'none', padding: '10px', maxWidth: '100%', position: 'relative' },
	                    value: this.state.content,
	                    onChange: function onChange(e) {
	                      return _this3.handleInputChange(e);
	                    }
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { width: '100%', color: 'red' } },
	                    this.state.error
	                  )
	                ),
	                _react2.default.createElement(_reactBootstrap.Col, { span: 3, alignContent: 'center' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: {
	                display: 'flex',
	                flexDirection: 'row'
	              } },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                classNames: 'btn-primary',
	                onClick: this.handleSendClick
	              },
	              _react2.default.createElement('i', { className: 'fa fa-envelope' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'send' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EmailContentModal;
	}(_react.Component);
	
	var styles = {
	  modal: {
	    width: '575px',
	    height: '480px',
	    marginLeft: '-9%'
	  },
	  container: {
	    display: 'flex',
	    alignItems: 'center',
	    flexDirection: 'column',
	    justifyContent: 'space-between'
	  },
	  sectionPadding: {
	    marginBottom: '20px',
	    display: 'flex',
	    flexDirection: 'column',
	    alignItems: 'center',
	    textAlign: 'center'
	  },
	  row: {
	    display: 'flex', flexDirection: 'row', marginBottom: '10px', alignItems: 'center'
	  }
	};
	
	var _default = EmailContentModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isEKC, 'isEKC', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/components/EmailContentModal.jsx');
	
	  __REACT_HOT_LOADER__.register(isSV, 'isSV', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/components/EmailContentModal.jsx');
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/components/EmailContentModal.jsx');
	
	  __REACT_HOT_LOADER__.register(emailOptions, 'emailOptions', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/components/EmailContentModal.jsx');
	
	  __REACT_HOT_LOADER__.register(emailOptionsSVPO, 'emailOptionsSVPO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/components/EmailContentModal.jsx');
	
	  __REACT_HOT_LOADER__.register(EmailContentModal, 'EmailContentModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/components/EmailContentModal.jsx');
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/components/EmailContentModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/components/EmailContentModal.jsx');
	}();

	;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreateGroupModal = function (_Component) {
	  _inherits(CreateGroupModal, _Component);
	
	  function CreateGroupModal() {
	    _classCallCheck(this, CreateGroupModal);
	
	    var _this = _possibleConstructorReturn(this, (CreateGroupModal.__proto__ || Object.getPrototypeOf(CreateGroupModal)).call(this));
	
	    _this.handleChange = function (e) {
	      var GroupName = e.target.value;
	      _this.setState({ GroupName: GroupName });
	    };
	
	    _this.state = {
	      GroupName: ""
	    };
	    return _this;
	  }
	
	  _createClass(CreateGroupModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {}
	  }, {
	    key: 'renderPrompt',
	    value: function renderPrompt() {
	      return _react2.default.createElement(
	        'label',
	        null,
	        _react2.default.createElement(_reactBootstrap.Input, {
	          type: 'text',
	          value: this.state.GroupName,
	          onChange: this.handleChange
	        }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'group_name' })
	      );
	    }
	  }, {
	    key: 'renderButtons',
	    value: function renderButtons() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { bsStyle: 'primary', className: 'mt mr', onClick: function onClick() {
	              _this2.props.caseAction(_this2.state.GroupName);_this2.props.closeC();
	            } },
	          _react2.default.createElement('em', { className: 'fa fa-check' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { bsStyle: 'danger', className: 'mt mr', onClick: function onClick() {
	              _this2.props.closeC();
	            } },
	          _react2.default.createElement('em', { className: 'fa fa-close' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12, className: 'text-center' },
	            this.renderPrompt()
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12, className: 'text-center' },
	            this.renderButtons()
	          )
	        )
	      );
	    }
	  }]);
	
	  return CreateGroupModal;
	}(_react.Component);
	
	CreateGroupModal.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = CreateGroupModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CreateGroupModal, 'CreateGroupModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/createGroupModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/createGroupModal.jsx');
	}();

	;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reduxForm = __webpack_require__(3);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _inputField = __webpack_require__(16);
	
	var _datePicker = __webpack_require__(27);
	
	var _detailedSelection = __webpack_require__(82);
	
	var _salesInventoryInfo = __webpack_require__(77);
	
	var _salesInventoryInfo2 = _interopRequireDefault(_salesInventoryInfo);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _setWeightModal = __webpack_require__(74);
	
	var _setWeightModal2 = _interopRequireDefault(_setWeightModal);
	
	var _EditCustomerModal = __webpack_require__(652);
	
	var _EditCustomerModal2 = _interopRequireDefault(_EditCustomerModal);
	
	var _SalesOrderAutoSuggest = __webpack_require__(152);
	
	var _SalesOrderAutoSuggest2 = _interopRequireDefault(_SalesOrderAutoSuggest);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _PrintIframe = __webpack_require__(63);
	
	var _PrintIframe2 = _interopRequireDefault(_PrintIframe);
	
	var _NumberUtil = __webpack_require__(67);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isTN = _root_url.ROOT_API_URL === "https://tn-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://tn-scm.truckxi.com/api/";
	
	// Renders Radio Filters for Search Field
	var renderTypeRadios = function renderTypeRadios(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group', id: 'search-product-by' },
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-3 search-by-max-width' },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'search_by' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'ProductNum',
	        checked: props.input.value === "ProductNum" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'RefNum',
	        checked: props.input.value === "RefNum" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'Name',
	        checked: props.input.value === "Name" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col-xs-2' },
	      _react2.default.createElement('input', _extends({}, props.input, { type: 'radio', value: 'Description',
	        checked: props.input.value === "Description" })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	    )
	  );
	};
	
	var isNumeric = function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	};
	
	var EditSalesInvoice = function (_Component) {
	  _inherits(EditSalesInvoice, _Component);
	
	  function EditSalesInvoice() {
	    _classCallCheck(this, EditSalesInvoice);
	
	    var _this = _possibleConstructorReturn(this, (EditSalesInvoice.__proto__ || Object.getPrototypeOf(EditSalesInvoice)).call(this));
	
	    _this.onChangeEmployeeNote = function (e) {
	      _this.setState({ employeeNoteText: e.target.value });
	    };
	
	    _this.handleChange = function (e) {
	      // let Notation = e.target.value;
	      // this.setState({ Notation });
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    };
	
	    _this.openShowEditCustomerConfirm = function () {
	      _this.setState({ showEditCustomerConfirmOpen: true });
	    };
	
	    _this.closeShowEditCustomerConfirm = function () {
	      _this.setState({ showEditCustomerConfirmOpen: false });
	    };
	
	    _this.openShowEditCustomer = function () {
	      _this.setState({ showEditCustomerOpen: true });
	    };
	
	    _this.closeShowEditCustomer = function (callback) {
	      _this.setState({ showEditCustomerOpen: false }, callback);
	    };
	
	    _this.openShowSICustomerUpdated = function () {
	      _this.closeShowEditCustomer(function () {
	        _this.setState({ showSIUpdatedOpen: true, isSICustomerUpdated: true });
	      });
	    };
	
	    _this.openShowSIUpdated = function () {
	      _this.setState({ showSIUpdatedOpen: true });
	    };
	
	    _this.closeShowSIUpdated = function () {
	      _this.setState({ showSIUpdatedOpen: false }, function () {
	        var currentSalesInvoice = _this.props.currentSalesInvoice;
	
	        if (_this.state.isSICustomerUpdated && currentSalesInvoice) {
	          _this.context.router.push({
	            pathname: '/salesInvoice/' + currentSalesInvoice.SalesInvoice_id,
	            state: { prevPath: _this.props.location.pathname }
	          });
	        }
	      });
	    };
	
	    _this.setWeights = function (currentRow, currentWeights, editedRow) {
	      // let backLogWeights = [...this.state.backLogWeights];
	      // let newEntry = { currentRow, currentWeights };
	      // backLogWeights.push(newEntry);
	      // this.setState({backLogWeights});
	      var index = 0;
	      var Weights = [];
	      var totalWeight = 0;
	      currentWeights.map(function (row) {
	        var curWeight = parseFloat(parseFloat(row.Weight).toFixed(4));
	        totalWeight += curWeight;
	        Weights.push(curWeight);
	      });
	      var rows = [].concat(_toConsumableArray(_this.state.salesInvoices.rows));
	      rows[editedRow.Index].Weights = Weights;
	      rows[editedRow.Index].TotalNetWeight = totalWeight;
	      var salesInvoices = _extends({}, _this.state.salesInvoices, { rows: rows });
	      _this.setState({ salesInvoices: salesInvoices });
	    };
	
	    _this.keepLoaded = function (oldLoaded) {
	      var salesInvoices = _extends({}, _this.state.salesInvoices);
	      salesInvoices.rows[_this.state.currentRow].LoadedQuantity = oldLoaded;
	      _this.setState({ salesInvoices: salesInvoices });
	    };
	
	    _this.handleEditCustomerOnClick = function () {
	      _this.openShowEditCustomerConfirm();
	    };
	
	    _this.handleCloseOnClick = function () {
	      var _ref = _this.props.location.state || {},
	          prevPath = _ref.prevPath;
	
	      if (prevPath) {
	        _this.context.router.go(-2);
	      } else {
	        _this.context.router.goBack();
	      }
	    };
	
	    _this.handleFocusQty = function () {
	      _reactDom2.default.findDOMNode(_this.refs.quantity.getRenderedComponent().myInput.refs.input).focus();
	      _reactDom2.default.findDOMNode(_this.refs.quantity.getRenderedComponent().myInput.refs.input).select();
	    };
	
	    _this.handlePrintFrameOnLoad = function () {
	      _this.setState({ salesInvoicePdfFrameLoaded: true });
	    };
	
	    _this.clearInventoryInfo = function () {
	      console.log('clearing everything');
	      _this.setState({
	        selectedInventoryRow: {},
	        inStock: '',
	        purchased: '',
	        presale: '',
	        net_weight: '',
	        ship_weight: '',
	        product_type: ''
	      });
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.editSalesInvPage,
	
	      docDate: null,
	      orderDate: null,
	      confirmOpen: false,
	      showEditCustomerConfirmOpen: false,
	      showEditCustomerOpen: false,
	      showInventoryOpen: false,
	      showSIUpdatedOpen: false,
	      isSICustomerUpdated: false,
	
	      // Track order information
	      totalPrice: 0,
	      totalTax: 0,
	      finalPrice: 0,
	      totalWeight: 0,
	      totalCRV: 0,
	      discount: 0,
	      savings: 0,
	
	      salesInvoices: {
	        rows: [],
	        filters: {},
	        selectedRows: [],
	        editedRows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      inventories: {
	        rows: []
	      },
	
	      editedRow: {},
	      selectedInventoryRow: {},
	      setWeightOpen: false,
	      currentRow: null,
	      rowChosen: null,
	      totalLoaded: null,
	      currentWeights: null,
	      backLogWeights: [],
	      Notation: '',
	      poNum: '',
	      payment: 0,
	      balance: 0,
	      suggestValue: '',
	      salesInvoicePdfFrameLoaded: true,
	      delivery: 0,
	
	      employeeNoteDisplay: '',
	      employeeNoteText: '',
	      changeEmployeeNoteOpen: false,
	      saveShouldDisable: false
	    };
	
	    _this.addRow = _this.addRow.bind(_this);
	    _this.removeRow = _this.removeRow.bind(_this);
	    _this.updateSalesInvoice = _this.updateSalesInvoice.bind(_this);
	    _this.handleOnFocus = _this.handleOnFocus.bind(_this);
	    _this.selectInventoryInfo = _this.selectInventoryInfo.bind(_this);
	    _this.closeShowInventory = _this.closeShowInventory.bind(_this);
	    _this.setAllProductQuantity = _this.setAllProductQuantity.bind(_this);
	    _this.closeConfirm = _this.closeConfirm.bind(_this);
	    _this.handleAfterShowInventoryClose = _this.handleAfterShowInventoryClose.bind(_this);
	    _this.openSetWeight = _this.openSetWeight.bind(_this);
	    _this.closeSetWeight = _this.closeSetWeight.bind(_this);
	    _this.openEmployeeNote = _this.openEmployeeNote.bind(_this);
	    _this.closeEmployeeNote = _this.closeEmployeeNote.bind(_this);
	    return _this;
	  }
	
	  _createClass(EditSalesInvoice, [{
	    key: 'closeSetWeight',
	    value: function closeSetWeight() {
	      this.setState({ setWeightOpen: false });
	    }
	  }, {
	    key: 'openSetWeight',
	    value: function openSetWeight() {
	      if (this.state.rowChosen) {
	        this.props.fetchSalesOrderLineWeights(this.state.rowChosen);
	      }
	    }
	  }, {
	    key: 'returnTotalWeight',
	    value: function returnTotalWeight(totalWeight) {
	      //console.log('current Row', this.state.salesInvoices.rows[this.state.currentRow])
	      var salesInvoices = _extends({}, this.state.salesInvoices);
	      var _salesInvoices$rows$s = salesInvoices.rows[this.state.currentRow],
	          LoadedQuantity = _salesInvoices$rows$s.LoadedQuantity,
	          UnitPrice = _salesInvoices$rows$s.UnitPrice,
	          ProductType = _salesInvoices$rows$s.ProductType;
	
	      salesInvoices.rows[this.state.currentRow].TotalNetWeight = +(0, _NumberUtil.roundTo)(totalWeight, 2).toFixed(4);
	      if (ProductType === 'Fixed') {
	        salesInvoices.rows[this.state.currentRow].TotalPrice = +(0, _NumberUtil.roundToDecimals)(LoadedQuantity * UnitPrice, 4).toFixed(4);
	        //salesInvoices.rows[this.state.currentRow].TotalPrice = salesInvoices.rows[this.state.currentRow].TotalPrice.toFixed(2);
	      } else {
	        salesInvoices.rows[this.state.currentRow].TotalPrice = +(0, _NumberUtil.roundToDecimals)(totalWeight * UnitPrice, 4).toFixed(4);
	        //salesInvoices.rows[this.state.currentRow].TotalPrice = salesInvoices.rows[this.state.currentRow].TotalPrice.toFixed(2);
	      }
	
	      var totalPrice = 0;
	      salesInvoices.rows.map(function (row) {
	        totalPrice += parseFloat(row.TotalPrice);
	      });
	
	      totalPrice = +(0, _NumberUtil.roundToDecimals)(totalPrice, 4).toFixed(4);
	      this.setState({ salesInvoices: salesInvoices, totalPrice: totalPrice, finalPrice: parseFloat(totalPrice) + +(0, _NumberUtil.roundTo)(parseFloat(this.state.totalCRV), 2).toFixed(2) + +(0, _NumberUtil.roundTo)(parseFloat(this.state.totalTax), 2).toFixed(2) });
	    }
	  }, {
	    key: 'openEmployeeNote',
	    value: function openEmployeeNote() {
	      this.setState({ changeEmployeeNoteOpen: true });
	    }
	  }, {
	    key: 'closeEmployeeNote',
	    value: function closeEmployeeNote() {
	      this.setState({ changeEmployeeNoteOpen: false });
	    }
	  }, {
	    key: 'onSubmitEmployeeNote',
	    value: function onSubmitEmployeeNote() {
	      var _this2 = this;
	
	      var currentSalesInvoice = this.props.currentSalesInvoice;
	
	      if (!currentSalesInvoice) {
	        alert("Please create invoice first before editing Employee Note");
	        return;
	      }
	      this.props.updateInvoiceEmployeeNote(currentSalesInvoice.SalesInvoice_id, this.state.employeeNoteText).then(function (response) {
	        _this2.setState({ employeeNoteDisplay: _this2.state.employeeNoteText });
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          alert("Patch Employee Note Failed");
	        }
	      });
	      this.setState({ changeEmployeeNoteOpen: false });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.handleResize);
	      var currentSalesInvoice = this.props.currentSalesInvoice;
	
	      console.log("this router", this.context.router);
	      var saveStatus = this.checkPermission("change_sales_invoice") || currentSalesInvoice && (currentSalesInvoice.SaleStatus == 'Finalized' || currentSalesInvoice.SaleStatus == 'Void') || this.props.siCustomerIsEditing || this.props.siCustomerEdited || this.props.salesInvoiceIsUpdating;
	      this.setState({ saveShouldDisable: saveStatus });
	      if (currentSalesInvoice) {
	        this.props.fetchSalesInvoiceDetail(currentSalesInvoice.SalesInvoice_id);
	        this.setState({
	          currentCustomer: currentSalesInvoice.Deliver_Customer_id,
	          Notation: currentSalesInvoice.Notation || '',
	          poNum: currentSalesInvoice.PONum || '',
	          payment: currentSalesInvoice.Payment !== undefined ? currentSalesInvoice.Payment : 0,
	          balance: currentSalesInvoice.UnpaidAmount !== undefined ? currentSalesInvoice.UnpaidAmount : 0,
	          delivery: currentSalesInvoice.Delivery || 0,
	          employeeNoteDisplay: currentSalesInvoice.Note || '',
	          employeeNoteText: currentSalesInvoice.Note || ''
	        });
	      } else {
	        this.context.router.push('/salesInvoice/');
	      }
	      this.setAllProductQuantity(1);
	      this.props.setValue('editSalesInvoice', 'searchType', 'RefNum');
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.salesInvoice && nextProps.salesInvoice != this.props.salesInvoice) {
	        var salesInvoices = _extends({}, this.state.salesInvoices, { rows: nextProps.salesInvoice });
	        this.setState({ salesInvoices: salesInvoices });
	      }
	      if (this.props.salesInvoiceIsUpdating && !nextProps.salesInvoiceIsUpdating && this.state.saveShouldDisable) {
	        this.setState({ saveShouldDisable: false });
	      }
	
	      if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
	        var inventoryItems = nextProps.inventories;
	        var salesInvoices = _extends({}, this.state.salesInvoices);
	        inventoryItems.map(function (item) {
	          item.ItemNum = item.ProductNum;
	        });
	
	        salesInvoices.rows.map(function (row) {
	          var index = _lodash2.default.findIndex(nextProps.inventories, { 'Product_id': row.Product_id });
	        });
	
	        var inventories = _extends({}, this.state.inventories, { rows: inventoryItems });
	        this.setState({ inventories: inventories });
	      }
	
	      if (nextProps.customerPrices && nextProps.customerPrices != this.props.customerPrices) {
	        // let rows = JSON.parse(JSON.stringify(this.state.inventories.rows));
	        var rows = [].concat(_toConsumableArray(this.state.inventories.rows));
	        var customerPrices = JSON.parse(JSON.stringify(nextProps.customerPrices));
	
	        // var mergedList = _.map(rows, customerPrices, "Product_id");
	        var mergedList = _lodash2.default.map(rows, function (i) {
	          return _lodash2.default.merge(i, _lodash2.default.find(customerPrices, { Product_id: i.Product_id }));
	        });
	
	        var _inventories = _extends({}, this.state.inventories, { rows: mergedList });
	        this.setState({ inventories: _inventories });
	      }
	
	      if (nextProps.salesInvoiceDetail && nextProps.salesInvoiceDetail != this.props.salesInvoiceDetail) {
	        var salesInvoices = _extends({}, this.state.salesInvoices, { rows: nextProps.salesInvoiceDetail.Sales_Invoice_Lines });
	        var Index = 0;
	        salesInvoices.rows.map(function (row) {
	          if (row.TotalNetWeight >= 0) {
	            row.Index = Index;
	            Index++;
	            row.NetWeight = +(0, _NumberUtil.roundTo)(parseFloat(row.NetWeight), 2).toFixed(2);
	          }
	        });
	        var totalPrice = 0;
	        var totalTax = 0;
	        var finalPrice = 0;
	        var totalWeight = 0;
	        var totalCRV = 0;
	
	        salesInvoices.rows.map(function (row) {
	          totalPrice += parseFloat(row.TotalPrice);
	          if (row.IsTaxable) {
	            row.TotalTax = parseFloat(row.TotalPrice) * parseFloat(nextProps.salesInvoiceDetail.TaxRate / 100);
	            totalTax += row.TotalTax;
	          }
	
	          totalWeight += parseFloat(row.TotalNetWeight);
	
	          if (row.CRV) row.TotalCRV = +(0, _NumberUtil.roundTo)(parseFloat(row.CRV) * parseFloat(row.LoadedQuantity), 2).toFixed(2);
	          if (row.TotalCRV) totalCRV += row.TotalCRV;
	        });
	        totalTax = +(0, _NumberUtil.roundTo)(totalTax, 2).toFixed(2);
	        finalPrice = parseFloat(totalPrice) + parseFloat(totalTax) + parseFloat(totalCRV);
	
	        totalWeight = (0, _NumberUtil.roundTo)(totalWeight, 2).toFixed(2);
	        totalPrice = (0, _NumberUtil.roundToDecimals)(totalPrice, 4).toFixed(4);
	        finalPrice = (0, _NumberUtil.roundTo)(finalPrice, 2).toFixed(2);
	        totalCRV = (0, _NumberUtil.roundTo)(totalCRV, 2).toFixed(2);
	        this.setState({
	          salesInvoices: salesInvoices,
	          docDate: this.props.currentSalesInvoice.CreateTime && this.props.currentSalesInvoice.CreateTime.slice(0, 10),
	          orderDate: this.props.currentSalesInvoice.OrderDate && this.props.currentSalesInvoice.OrderDate.slice(0, 10),
	          totalPrice: totalPrice, totalTax: totalTax, finalPrice: finalPrice, totalWeight: totalWeight, totalCRV: totalCRV, taxRate: nextProps.salesInvoiceDetail.TaxRate / 100,
	          savings: nextProps.salesInvoiceDetail.Savings,
	          discount: nextProps.salesInvoiceDetail.Discount
	        });
	      }
	
	      if (nextProps.salesOrderProduct && nextProps.salesOrderProduct !== this.props.salesOrderProduct) {
	        this.selectInventoryInfo(nextProps.salesOrderProduct);
	        this.props.setValue('editSalesInvoice', 'UnitPrice', (0, _NumberUtil.roundToDecimals)(nextProps.salesOrderProduct.Price, 4));
	        // this.props.setSaleOrderProductValues(roundTo(nextProps.salesOrderProduct.Price, 2).toFixed(2), 'salesOrderForm', nextProps.salesOrderProduct);
	        // ReactDOM.findDOMNode(this.refs['quantity'].getRenderedComponent().myInput.refs.input).focus();
	      }
	
	      if (nextProps.salesInvoicePdf && nextProps.salesInvoicePdf !== this.props.salesInvoicePdf) {
	        this.setState({ salesInvoicePdfFrameLoaded: false });
	      }
	
	      if (nextProps.salesInvoiceUpdated && nextProps.salesInvoiceUpdated !== this.props.salesInvoiceUpdated) {
	        this.openShowSIUpdated();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState.salesInvoicePdfFrameLoaded !== this.state.salesInvoicePdfFrameLoaded && this.state.salesInvoicePdfFrameLoaded === false) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'getItemNumbers',
	
	    // breadcrumbs() {
	    //   if (this.props.salesInvoiceUpdateError == null) {
	    //     return <Breadcrumb>
	    //       <Breadcrumb.Item>
	    //         <Translate value="sales_management" />
	    //       </Breadcrumb.Item>
	    //       <Breadcrumb.Item>
	    //         <Translate value="sales_invoice" />
	    //       </Breadcrumb.Item>
	    //       <Breadcrumb.Item active="true">
	    //         <Translate value="edit_sales_invoice" />
	    //       </Breadcrumb.Item>
	    //     </Breadcrumb>
	    //   } else {
	    //     return <ContentWrapper><div className="alert alert-danger">{this.props.salesInvoiceUpdateError}</div></ContentWrapper>
	    //   }
	    // }
	
	    value: function getItemNumbers() {
	      // var itemOptions= [];
	      // this.props.inventories.map(product => {
	      //     itemOptions.push({ value: product.ProductNum.ProductNum, label: product.ProductNum.ProductNum});
	      // });
	      // return itemOptions;
	
	      var inventoryItemOptions = [{ value: '', label: "No.       |  Name           |  Description" }];
	      if (this.props.inventories) {
	        this.props.inventories.map(function (inventoryItem) {
	          var text = "                                                              ";
	          var output = [inventoryItem.ProductNum.slice(0, 8), text].join('');
	
	          output = [output.slice(0, 8), '  |  ', inventoryItem.Name.slice(0, 12), text].join('');
	          output = [output.slice(0, 26), '  |  ', inventoryItem.Description.slice(0, 50), text].join('');
	          output = output.slice(0, 86);
	          inventoryItemOptions.push({ value: inventoryItem.ProductNum, label: output });
	        });
	        return inventoryItemOptions;
	      }
	    }
	  }, {
	    key: 'setAllProductQuantity',
	    value: function setAllProductQuantity(quantity) {
	      this.props.setValue('editSalesInvoice', 'Quantity', quantity);
	    }
	  }, {
	    key: 'handleKeyPress',
	    value: function handleKeyPress(value, event) {
	      console.log('value', value);
	      if (event.charCode == 13) {
	        if (value === 'productSearch') {
	          _reactDom2.default.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	        } else {
	          _reactDom2.default.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	        }
	      }
	    }
	  }, {
	    key: 'handleFocusAutoSuggest',
	    value: function handleFocusAutoSuggest() {
	      var autoSuggestField = document.getElementById('sales-auto-suggest');
	      autoSuggestField.focus();
	      autoSuggestField.select();
	    }
	  }, {
	    key: 'updateSalesInvoice',
	    value: function updateSalesInvoice() {
	      var update = {};
	      update.Sales_Invoice_Lines = this.state.salesInvoices.rows;
	      update.DocumentDate = new Date();
	      update.TotalPrice = this.state.totalPrice;
	      update.PONum = this.state.poNum;
	
	      if (this.props.invoiceNum != null) {
	        update.InvoiceNum = this.props.invoiceNum;
	      }
	      if (this.props.CreateTime !== null) {
	        update.CreateTime = this.props.CreateTime;
	      }
	      if (this.props.OrderDate != null) {
	        update.OrderDate = this.props.OrderDate;
	      }
	      if (this.props.postingDate !== null) {
	        update.PostingDate = this.props.postingDate;
	      } else {
	        alert('Posting date is required');
	        return;
	      }
	      update.InvoiceShipDate = this.props.InvoiceShipDate;
	      // for (let i = 0; i < this.state.backLogWeights.length; i++) {
	      //   console.log("califo",this.state.backLogWeights);
	      //   this.props.setOrderLineWeights(this.state.backLogWeights[i].currentRow, this.state.backLogWeights[i].currentWeights);
	      // }
	      this.setState({ saveShouldDisable: true });
	      this.props.updateSalesInvoice(update, this.props.currentSalesInvoice.SaleStatus.toLowerCase(), this.props.currentSalesInvoice.SalesInvoice_id, undefined, undefined, this.state.Notation);
	    }
	  }, {
	    key: 'checkAddRow',
	    value: function checkAddRow() {
	      var check = _lodash2.default.findIndex(this.state.salesInvoices.rows, { ProductNum: this.state.selectedInventoryRow.ProductNum });
	      if (check === -1) {
	        this.addRow();
	      } else {
	        this.setState({ case: 'addingDuplicate', confirmOpen: true });
	      }
	    }
	  }, {
	    key: 'addRow',
	    value: function addRow() {
	      var _this3 = this;
	
	      if (this.state.selectedInventoryRow.Name == null) {
	        return;
	      }
	      // const check = _.findIndex(this.state.salesInvoices.rows, {'ProductNum': this.state.selectedInventoryRow.ProductNum});
	      // if (check == -1) {
	      var newRows = [].concat(_toConsumableArray(this.state.salesInvoices.rows));
	
	      var newLine = _extends({}, this.state.selectedInventoryRow);
	      newLine.Index = newRows.length;
	      newLine.LoadedQuantity = this.props.Quantity;
	      newLine.UnitPrice = this.props.UnitPrice;
	      newLine.TotalPrice = +(0, _NumberUtil.roundToDecimals)(parseFloat(this.props.Quantity) * parseFloat(this.props.UnitPrice), 4).toFixed(4);
	      newLine.TotalCRV = +(0, _NumberUtil.roundTo)(parseFloat(newLine.LoadedQuantity) * parseFloat(newLine.CRV), 2).toFixed(2);
	      newLine.ItemNotation = this.props.ItemNotation;
	      newLine.TotalNetWeight = this.props.Quantity * newLine.NetWeight;
	      if (newLine.ProductType === 'Non-Fixed') {
	        newLine.Weights = [];
	        newLine.TotalNetWeight = 0;
	        newLine.TotalPrice = 0;
	      }
	      newRows.push(newLine);
	
	      var totalPrice = 0;
	      var totalTax = 0;
	      var finalPrice = 0;
	      var totalWeight = 0;
	      var totalCRV = 0;
	
	      newRows.map(function (row) {
	        totalPrice += parseFloat(row.TotalPrice);
	        if (row.IsTaxable) {
	          row.TotalTax = parseFloat(row.TotalPrice) * parseFloat(_this3.state.taxRate);
	          totalTax += row.TotalTax;
	        }
	
	        if (row.TotalNetWeight != null) {
	          totalWeight += parseFloat(row.TotalNetWeight);
	        } else {
	          totalWeight += parseFloat(row.LoadedQuantity) * parseFloat(row.NetWeight);
	        }
	        if (row.TotalWeight != null) {
	          totalWeight = parseFloat(totalWeight) + parseFloat(row.TotalWeight);
	        }
	        totalWeight = +(0, _NumberUtil.roundTo)(totalWeight, 2).toFixed(2);
	        totalCRV += +(0, _NumberUtil.roundTo)(parseFloat(row.CRV) * parseFloat(row.LoadedQuantity), 2).toFixed(2);
	      });
	      totalTax = +(0, _NumberUtil.roundTo)(totalTax, 2).toFixed(2);
	      totalCRV = +(0, _NumberUtil.roundTo)(totalCRV, 2).toFixed(2);
	      finalPrice = totalPrice + totalTax + totalCRV;
	
	      totalWeight = +(0, _NumberUtil.roundTo)(totalWeight, 2).toFixed(2);
	      totalPrice = +(0, _NumberUtil.roundToDecimals)(totalPrice, 4).toFixed(4);
	      finalPrice = +(0, _NumberUtil.roundTo)(finalPrice, 2).toFixed(2);
	
	      var salesInvoices = _extends({}, this.state, { rows: newRows });
	      this.setState({
	        salesInvoices: salesInvoices, totalPrice: totalPrice, totalTax: totalTax, finalPrice: finalPrice, totalWeight: totalWeight, suggestValue: '', totalCRV: totalCRV
	      });
	      // }
	      this.setAllProductQuantity(1);
	      this.props.resetFormInputs();
	    }
	  }, {
	    key: 'removeRow',
	    value: function removeRow(Index) {
	      var _this4 = this;
	
	      var rows = [].concat(_toConsumableArray(this.state.salesInvoices.rows));
	      var totalPrice = 0;
	      var finalWeight = 0;
	      var totalTax = 0;
	      var totalCRV = 0;
	      var discount = parseFloat(this.props.discount) || 0;
	      rows = rows.filter(function (obj) {
	        return obj.Index !== Index;
	      });
	
	      var index = 0;
	      rows.map(function (row) {
	        if (row.IsTaxable == true) {
	          totalTax += parseFloat(row.TotalPrice) * parseFloat(_this4.state.taxRate);
	        }
	        totalPrice = parseFloat(totalPrice) + parseFloat(row.TotalPrice);
	        if (row.Weight != null) finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalWeight);
	        totalCRV += +(0, _NumberUtil.roundTo)(parseFloat(row.CRV) * parseFloat(row.LoadedQuantity), 2).toFixed(2);
	        row.Index = index;
	        index++;
	      });
	      totalTax = +(0, _NumberUtil.roundTo)(totalTax, 2).toFixed(2);
	      var finalPrice = totalPrice * (1 - discount / 100) + totalTax + totalCRV;
	      var salesInvoices = _extends({}, this.state.salesInvoices, { rows: rows });
	      this.setState({ salesInvoices: salesInvoices, finalPrice: +(0, _NumberUtil.roundTo)(finalPrice, 2).toFixed(2), totalPrice: +(0, _NumberUtil.roundToDecimals)(totalPrice, 4).toFixed(4), totalTax: totalTax, finalWeight: +(0, _NumberUtil.roundTo)(finalWeight, 2).toFixed(2), totalCRV: totalCRV });
	    }
	  }, {
	    key: 'renderSaleDetail',
	    value: function renderSaleDetail() {
	      // let itemNumOptions = this.getItemNumbers();
	      if (this.props.inventoriesIsLoading && !this.props.inventoriesError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.inventoriesError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          this.props.inventoriesError
	        )
	      );else {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_order_list' })
	          ),
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'document_date' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: 'DocDate', selected: new Date(), component: _datePicker.DisabledDatePicker })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_date' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: 'OrderDate', component: _datePicker.DatePicker })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 6 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'item_no' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: 'NewItem', component: _detailedSelection.DetailedSelection, options: itemNumOptions }),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { className: 'btn btn-primary', disabled: this.props.NewItem == null, onClick: this.checkAddRow },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'add_product' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { className: 'btn btn-danger', disabled: this.state.salesInvoices.selectBy == 0, onClick: this.removeRow },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'remove_product' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: 'Quantity', ref: 'quantity', component: _inputField.InputField })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 3 },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: 'UnitPrice', component: _inputField.InputField })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderSaleInvoice',
	    value: function renderSaleInvoice() {
	      var _this5 = this;
	
	      var that = this;
	      if (this.props.detailIsLoading && !this.props.detailError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.detailError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.detailError)
	        )
	      );else {
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this5.state.salesInvoices);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        var onRowsSelected = function onRowsSelected(rows) {
	          var newRows = _this5.state.salesInvoices.rows;
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = true;
	          });
	          var salesInvoices = _extends({}, _this5.state.salesInvoices, { rows: newRows, selectedRows: _this5.state.salesInvoices.selectedRows.concat(rows.map(function (r) {
	              return r.rowIdx;
	            })) });
	          _this5.setState({ salesInvoices: salesInvoices });
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          var newRows = _this5.state.salesInvoices.rows;
	          var rowIndexes = rows.map(function (r) {
	            return r.rowIdx;
	          });
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = false;
	          });
	          var salesInvoices = _extends({}, _this5.state.salesInvoices, { rows: newRows, selectedRows: _this5.state.salesInvoices.selectedRows.filter(function (i) {
	              return rowIndexes.indexOf(i) === -1;
	            }) });
	          _this5.setState({ salesInvoices: salesInvoices });
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var salesInvoices = _extends({}, _this5.state.salesInvoices, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this5.setState({ salesInvoices: salesInvoices });
	        };
	
	        var onRowSelect = function onRowSelect(rows) {
	          var salesInvoices = _extends({}, _this5.state.salesInvoices, { selectedRows: rows });
	          _this5.setState({ salesInvoices: salesInvoices });
	        };
	
	        //Custom Formatter component
	        var IsEnabledFormatter = _react2.default.createClass({
	          displayName: 'IsEnabledFormatter',
	          render: function render() {
	            if (this.props.value) return _react2.default.createElement(
	              'span',
	              { className: 'label label-success' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	            );else return _react2.default.createElement(
	              'span',
	              { className: 'label label-danger' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disable' })
	            );
	          }
	        });
	
	        var handleRowUpdated = function handleRowUpdated(e) {
	          var rows = getRows();
	          Object.assign(rows[e.rowIdx], e.updated);
	
	          if (e.updated.LoadedQuantity != null) {
	            if (isNaN(e.updated.LoadedQuantity)) {
	              return;
	            }
	            if (!rows[e.rowIdx].IsOverSaleable && parseInt(e.updated.LoadedQuantity) > rows[e.rowIdx].InStock) {
	              return;
	            }
	            if (rows[e.rowIdx].ProductType === "Fixed") {
	              Object.assign(rows[e.rowIdx], { TotalPrice: +(0, _NumberUtil.roundToDecimals)(parseFloat(e.updated.LoadedQuantity) * parseFloat(rows[e.rowIdx].UnitPrice), 4).toFixed(4) });
	              Object.assign(rows[e.rowIdx], { TotalWeight: +(0, _NumberUtil.roundTo)(parseFloat(e.updated.LoadedQuantity) * parseFloat(rows[e.rowIdx].NetWeight), 2).toFixed(2) });
	              Object.assign(rows[e.rowIdx], { TotalNetWeight: +(0, _NumberUtil.roundTo)(parseFloat(e.updated.LoadedQuantity) * parseFloat(rows[e.rowIdx].NetWeight), 2).toFixed(2) });
	            } else if (rows[e.rowIdx].ProductType === "Per-Pound") {
	              Object.assign(rows[e.rowIdx], { TotalPrice: +(0, _NumberUtil.roundToDecimals)(parseFloat(e.updated.LoadedQuantity) * parseFloat(rows[e.rowIdx].UnitPrice) * parseFloat(rows[e.rowIdx].NetWeight), 4).toFixed(4) });
	              Object.assign(rows[e.rowIdx], { TotalWeight: +(0, _NumberUtil.roundTo)(parseFloat(e.updated.LoadedQuantity) * parseFloat(rows[e.rowIdx].NetWeight), 2).toFixed(2) });
	              Object.assign(rows[e.rowIdx], { TotalNetWeight: +(0, _NumberUtil.roundTo)(parseFloat(e.updated.LoadedQuantity) * parseFloat(rows[e.rowIdx].NetWeight), 2).toFixed(2) });
	            }
	            //   Object.assign(rows[e.rowIdx], {TotalPrice: parseFloat(e.updated.LoadedQuantity*rows[e.rowIdx].UnitPrice*rows[e.rowIdx].NetWeight).toFixed(2)});
	            if (rows[e.rowIdx].CRV > 0) {
	              Object.assign(rows[e.rowIdx], { TotalCRV: +(0, _NumberUtil.roundTo)(parseFloat(e.updated.LoadedQuantity) * parseFloat(rows[e.rowIdx].CRV), 2).toFixed(2) });
	            }
	
	            if (rows[e.rowIdx].IsTaxable) Object.assign(rows[e.rowIdx], { TotalTax: parseFloat(rows[e.rowIdx].TotalPrice) * parseFloat(_this5.state.taxRate) });
	            _this5.setState({ currentWeights: rows[e.rowIdx].Weights });
	          }
	          if (e.updated.UnitPrice != null) {
	            if (rows[e.rowIdx].ProductType == "Fixed" || rows[e.rowIdx].ProductType == "Non-Product") {
	              Object.assign(rows[e.rowIdx], { TotalPrice: +(0, _NumberUtil.roundToDecimals)(parseFloat(e.updated.UnitPrice * rows[e.rowIdx].LoadedQuantity), 4).toFixed(4) });
	            } else if (rows[e.rowIdx].ProductType === "Non-Fixed") {
	              Object.assign(rows[e.rowIdx], { TotalPrice: +(0, _NumberUtil.roundToDecimals)(parseFloat(e.updated.UnitPrice * rows[e.rowIdx].TotalNetWeight), 4).toFixed(4) });
	            } else {
	              Object.assign(rows[e.rowIdx], { TotalPrice: +(0, _NumberUtil.roundToDecimals)(parseFloat(e.updated.UnitPrice * rows[e.rowIdx].NetWeight * rows[e.rowIdx].LoadedQuantity), 4).toFixed(4) });
	            }
	
	            if (rows[e.rowIdx].IsTaxable) Object.assign(rows[e.rowIdx], { TotalTax: parseFloat(rows[e.rowIdx].TotalPrice) * parseFloat(_this5.state.taxRate) });
	          }
	
	          var totalPrice = 0;
	          var totalWeight = 0;
	          var finalPrice = 0;
	          var totalTax = 0;
	          var totalCRV = 0;
	
	          rows.map(function (row) {
	            totalPrice += parseFloat(row.TotalPrice);
	            totalWeight += parseFloat(row.NetWeight) * parseFloat(row.LoadedQuantity);
	            if (row.IsTaxable) {
	              totalTax += parseFloat(row.TotalTax);
	            }
	
	            if (row.TotalCRV) {
	              totalCRV += parseFloat(row.TotalCRV);
	            }
	          });
	          totalTax = +(0, _NumberUtil.roundTo)(totalTax, 2).toFixed(2);
	          finalPrice = parseFloat(totalPrice) + parseFloat(totalTax) + parseFloat(totalCRV);
	
	          totalWeight = +(0, _NumberUtil.roundTo)(totalWeight, 2).toFixed(2);
	          totalPrice = +(0, _NumberUtil.roundToDecimals)(totalPrice, 4).toFixed(4);
	          finalPrice = +(0, _NumberUtil.roundTo)(finalPrice, 2).toFixed(2);
	          totalCRV = +(0, _NumberUtil.roundTo)(totalCRV, 2).toFixed(2);
	
	          var salesInvoices = { rows: rows };
	          _this5.setState({ salesInvoices: salesInvoices, totalPrice: totalPrice, totalWeight: totalWeight, finalPrice: finalPrice, totalTax: totalTax, totalCRV: totalCRV });
	
	          if (e.updated.LoadedQuantity != null && _this5.state.salesInvoices.rows[e.rowIdx].ProductType === "Non-Fixed") {
	            if (!rows[e.rowIdx].Weights) {
	              rows[e.rowIdx].Weights = [];
	            }
	            //if (typeof (rows[e.rowIdx].Index) === 'undefined')
	            rows[e.rowIdx].Index = _lodash2.default.findIndex(rows, { 'Index': rows[e.rowIdx].Index });
	            console.log("index", rows[e.rowIdx].Index);
	            that.setState({ setWeightOpen: true, currentRow: e.rowIdx, rowChosen: rows[e.rowIdx].SalesOrderLine_id, totalLoaded: rows[e.rowIdx].LoadedQuantity, currentWeights: rows[e.rowIdx].Weights, editedRow: rows[e.rowIdx] });
	          }
	        };
	
	        var IsVariableFormatter = _react2.default.createClass({
	          displayName: 'IsVariableFormatter',
	          render: function render() {
	            var _this6 = this;
	
	            return _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  className: 'textAlignStyle', style: { height: '23px', width: '39px', padding: '0px' },
	                  onClick: function onClick() {
	                    // var ProductNum = this.props.dependentValues.ProductNum;
	                    var Index = _this6.props.dependentValues.Index;
	                    that.removeRow(Index);
	                  } },
	                'X'
	              )
	            );
	          }
	        });
	
	        var IsVariableFormatter2 = _react2.default.createClass({
	          displayName: 'IsVariableFormatter2',
	          render: function render() {
	            if (this.props.dependentValues.ProductType !== "Non-Fixed") {
	              return _react2.default.createElement(
	                'span',
	                null,
	                this.props.value,
	                ' '
	              );
	            } else {
	              return _react2.default.createElement(
	                'span',
	                null,
	                this.props.value,
	                ' ',
	                _react2.default.createElement(
	                  'label',
	                  { className: 'label label-success' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'non_fixed' })
	                )
	              );
	            }
	          }
	        });
	
	        // Column difinition
	
	        var columns = [{
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	          width: 50,
	          formatter: IsVariableFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          sortable: true,
	          width: 70
	        }, {
	          key: 'RefNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	          resizable: true,
	          sortable: true,
	          width: 80
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	          resizable: true,
	          sortable: true,
	          width: 200
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true,
	          width: 150
	        }, {
	          key: 'Quantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_qty' }),
	          resizable: true,
	          sortable: true,
	          width: 85
	        }, {
	          key: 'LoadedQuantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped_qty' }),
	          resizable: true,
	          sortable: true,
	          editable: true,
	          width: 85,
	          formatter: IsVariableFormatter2,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'NetWeight',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' }),
	          resizable: true,
	          sortable: true,
	          width: 65,
	          filterable: true
	        }, {
	          key: 'PackageType',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	          resizable: true,
	          sortable: true,
	          width: 85
	        }, {
	          key: 'UnitPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	          editable: true,
	          resizable: true,
	          sortable: true,
	          width: 75
	        }, {
	          key: 'TotalPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	          width: 80,
	          resizable: true,
	          sortable: true
	        }, {
	          key: 'TotalNetWeight',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	          width: 80,
	          resizable: true,
	          sortable: true,
	          filterable: true
	        }, {
	          key: 'ItemNotation',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	          editable: true,
	          resizable: true,
	          sortable: true,
	          width: 200,
	          filterable: true
	        }];
	
	        return (
	          //React Table Sales Invoice
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'div',
	                { id: 'EditSalesInvoice-dataGrid1' },
	                _react2.default.createElement(_reactDataGrid2.default, {
	                  rowKey: 'Product_id',
	                  enableCellSelect: true,
	                  onGridSort: handleGridSort,
	                  columns: columns,
	                  rowHeight: 25,
	                  headerRowHeight: 45,
	                  rowGetter: rowGetter,
	                  onRowSelect: onRowSelect,
	                  rowsCount: getSize(),
	                  minHeight: this.state.tableHeight,
	                  onRowUpdated: handleRowUpdated
	                })
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'checkPermission',
	    value: function checkPermission(permission) {
	      return false;
	    }
	
	    // Displays the values of the inventory fields;
	
	  }, {
	    key: 'selectInventoryInfo',
	    value: function selectInventoryInfo(selectedInventoryRow) {
	      this.setState({
	        selectedInventoryRow: selectedInventoryRow,
	        inStock: selectedInventoryRow.InStock,
	        purchased: selectedInventoryRow.Purchased,
	        presale: selectedInventoryRow.PreSale,
	        net_weight: selectedInventoryRow.NetWeight,
	        ship_weight: selectedInventoryRow.NetWeight,
	        product_type: selectedInventoryRow.ProductType });
	    }
	  }, {
	    key: 'handleOnFocus',
	    value: function handleOnFocus(event) {
	      event.target.select();
	    }
	  }, {
	    key: 'closeConfirm',
	    value: function closeConfirm() {
	      // this.props.resetFormInputs();
	      this.setState({ confirmOpen: false });
	      // ReactDOM.findDOMNode(this.refs['quantity'].getRenderedComponent().myInput.refs.input).focus();
	    }
	  }, {
	    key: 'openShowInventory',
	    value: function openShowInventory(event) {
	      if (!this.props.searchValue || this.props.searchValue == "") return;
	      switch (event.charCode) {
	        case 13:
	          // ENTER
	          event.preventDefault();
	          this.setState({ showInventoryOpen: true });
	      }
	    }
	  }, {
	    key: 'closeShowInventory',
	    value: function closeShowInventory(value) {
	      this.handleAfterShowInventoryClose(value);
	      this.setState({ showInventoryOpen: false });
	    }
	  }, {
	    key: 'handleAfterShowInventoryClose',
	    value: function handleAfterShowInventoryClose(value) {
	      _reactDom2.default.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	    }
	
	    //Product Search Reference;
	
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(event) {
	      switch (event.keyCode) {
	        case 27:
	          this.closeShowInventory('productSearch');
	          break;
	        default:
	          break;
	      }
	    }
	
	    // Renders Subtotal
	
	  }, {
	    key: 'renderSubtotal',
	    value: function renderSubtotal() {
	      var subtotal = 0;
	      if (this.state.selectedInventoryRow.ProductType == "Fixed") {
	        if (this.props.quantityValue) {
	          subtotal = +(0, _NumberUtil.roundTo)(parseFloat(this.props.quantityValue) * parseFloat(this.props.unitPrice), 2).toFixed(2);
	        }
	      } else {
	        if (this.props.weight) {
	          subtotal = +(0, _NumberUtil.roundTo)(parseFloat(this.props.unitPrice) * parseFloat(this.props.weight) * parseFloat(this.props.quantityValue), 2).toFixed(2);
	        }
	      }
	      if (isNaN(subtotal)) {
	        subtotal = 0;
	      }
	      return _react2.default.createElement(_reduxForm.Field, { name: 'Subtotal', component: _inputField.DisabledInputField, placeholder: subtotal });
	    }
	    //End Import Chunk
	
	
	    // handleKeyPress = (value, event) => {
	    //   if (event.charCode == 13) {
	    //     event.preventDefault();
	    //     if (value == 'unitPrice' || value == 'itemNotation') {
	    //       if ((!isNumeric(this.props.quantityValue) || this.props.quantityValue < 0) && value !== 'quantity') {
	    //         return;
	    //       }
	    //     }
	    //     ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	    //   }
	    // }
	
	  }, {
	    key: 'renderAutoSuggest',
	    value: function renderAutoSuggest() {
	      var _this7 = this;
	
	      return _react2.default.createElement(_SalesOrderAutoSuggest2.default, {
	        CustomerNumber: this.state.currentCustomer,
	        handleFocusQty: this.handleFocusQty,
	        handleKeyPress: this.handleKeyPress,
	        onChange: function onChange(e, _ref2) {
	          var newValue = _ref2.newValue;
	          _this7.clearInventoryInfo();_this7.setState({ suggestValue: newValue });
	        },
	        SearchType: this.props.searchType,
	        setAllProductQuantity: this.setAllProductQuantity,
	        value: this.state.suggestValue
	      });
	    }
	  }, {
	    key: 'renderPrint',
	    value: function renderPrint() {
	      var _this8 = this;
	
	      var currentSalesInvoice = this.props.currentSalesInvoice;
	
	      return _react2.default.createElement(_SpinnerButton2.default, {
	        bsStyle: 'primary',
	        disabled: !currentSalesInvoice || !currentSalesInvoice.SalesInvoice_id || this.props.printSalesInvoiceIsLoading,
	        icon: 'fa-print',
	        translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' }),
	        loading: this.props.printSalesInvoiceIsLoading,
	        onClick: function onClick() {
	          _this8.props.printSalesInvoice(currentSalesInvoice.SalesInvoice_id);
	        }
	      });
	    }
	  }, {
	    key: 'renderPrintIframe',
	    value: function renderPrintIframe() {
	      var salesInvoicePdfFrameLoaded = this.state.salesInvoicePdfFrameLoaded;
	      var salesInvoicePdf = this.props.salesInvoicePdf;
	
	      return _react2.default.createElement(_PrintIframe2.default, {
	        id: 'salesInvoicePDF',
	        loaded: salesInvoicePdfFrameLoaded,
	        name: 'salesInvoicePDF',
	        onLoad: this.handlePrintFrameOnLoad,
	        pdf: salesInvoicePdf,
	        title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_sales_invoice' })
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      var _state = this.state,
	          savings = _state.savings,
	          discount = _state.discount,
	          totalCRV = _state.totalCRV,
	          totalTax = _state.totalTax,
	          taxRate = _state.taxRate;
	      // Discount field is greater than 0 if the promo is a "percent off" type
	
	      var promotion = discount > 0 ? '(' + discount + '% Off)' : '($' + savings + ' Off)';
	      var lines = this.state.salesInvoices && this.state.salesInvoices.rows ? this.state.salesInvoices.rows : [];
	      var totalTaxWithPromotion = (0, _NumberUtil.calculateTax)(lines, discount, taxRate);
	      var finalPriceWithPromotion = (0, _NumberUtil.calculateSavings)(discount, savings, this.state.totalPrice, totalCRV, totalTaxWithPromotion, this.state.delivery);
	      var invoiceNum = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' })
	      );
	      var totalPrice = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' })
	      );
	      var tax = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' })
	      );
	      var crv = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'crv' })
	      );
	      var finalPrice = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' })
	      );
	      var customerNote = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_note' })
	      );
	      var employeeNoteTitle = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'employee_note' })
	      );
	      var modifierUserTitle = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'modifier_user' })
	      );
	      var paymentTitle = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' })
	      );
	      var balanceTitle = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' })
	      );
	      var deliveryTitle = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delivery' })
	      );
	      var selectInventoryInformation = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_inventory_information' });
	      var confirmAction = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm_action' });
	      var poNum = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' })
	      );
	      var ModalHeader = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'your_customer_change_has_been_saved' });
	      var changeEmployeeNoteTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'change_employee_note' });
	      // Create Dialog for Skylight
	      var createDialogInventoryStyle = {
	        height: '700px',
	        width: '1000px',
	        marginLeft: '-30%',
	        marginTop: '-20%'
	      };
	      var createDialogStyle = {
	        width: '500px',
	        marginLeft: '-15%'
	      };
	      var createDialogEditCustomerStyle = {
	        width: '550px',
	        marginLeft: '-15%'
	      };
	      var createDialogStyleWeight = {
	        width: '500px',
	        height: '600px',
	        top: '45%',
	        marginLeft: '-10%'
	      };
	      var createNoteDialogStyle = {
	        width: '500px',
	        height: '250px',
	        marginLeft: '-10%'
	      };
	
	      if (this.props.detailIsLoading && !this.props.detailError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement('br', null),
	        '...',
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reading_data' })
	      );else if (this.props.detailError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          this.props.error
	        )
	      );else {
	        var salesInvoiceDetail = this.props.salesInvoiceDetail;
	
	        var siNumTitle = salesInvoiceDetail && salesInvoiceDetail.InvoiceNum || '';
	        var modifierUser = salesInvoiceDetail && salesInvoiceDetail.Modifier_User_Name || '';
	
	        return (
	          //---------------
	          // Begin HTML
	          //---------------
	          _react2.default.createElement(
	            _ContentWrapper2.default,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Breadcrumb.Item,
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_management' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Breadcrumb.Item,
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_invoice' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Breadcrumb.Item,
	                { active: 'true' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_sales_invoice' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              null,
	              _react2.default.createElement(_SpinnerButton2.default, {
	                bsStyle: 'success',
	                disabled: this.state.saveShouldDisable,
	                icon: 'fa-save',
	                translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' }),
	                loading: this.props.salesInvoiceIsUpdating,
	                onClick: this.updateSalesInvoice
	              }),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'warning',
	                  disabled: !(0, _permissions2.default)('edit_customer_sales_invoice'),
	                  onClick: this.handleEditCustomerOnClick,
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_customer' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  type: 'reset',
	                  onClick: this.handleCloseOnClick },
	                _react2.default.createElement('em', { className: 'fa fa-close' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Grid,
	              { fluid: 'true', id: 'edit-sales-invoice' },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 9 },
	                  _react2.default.createElement(
	                    'h1',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_sales_invoice' }),
	                    ':\xA0',
	                    siNumTitle,
	                    this.props.currentSalesInvoice && this.props.currentSalesInvoice.Customer_Name ? " (" + this.props.currentSalesInvoice.Customer_Name + ")" : ""
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 3 },
	                  _react2.default.createElement(
	                    'h2',
	                    { className: 'pull-right' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'modifier_user' }),
	                    ':\xA0',
	                    modifierUser
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'row-wrapper' },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 10, className: 'mb0' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Panel,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 10, className: 'vertical-divider' },
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 6 },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'searchType', component: renderTypeRadios }),
	                                  this.renderAutoSuggest()
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 6, id: 'product-search-outputs' },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2 },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Quantity', component: _inputField.InputField, ref: 'quantity', withRef: true, onFocus: this.handleOnFocus, placeholder: 'must be > 0', onKeyPress: function onKeyPress(event) {
	                                        _this9.handleKeyPress('unitPrice', event);
	                                      } })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2 },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit' }),
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'dollar-sign' },
	                                        '$$'
	                                      )
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'UnitPrice', withRef: true, ref: 'unitPrice'
	                                      // normalize={normalizeFourDecimals} 
	                                      , component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                                        _this9.handleKeyPress('itemNotation', event);
	                                      } })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2 },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Weight', component: _inputField.DisabledInputField, onFocus: this.handleOnFocus })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2 },
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Row,
	                                      null,
	                                      _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { xs: 12 },
	                                        _react2.default.createElement(
	                                          'label',
	                                          null,
	                                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'subtotal' })
	                                        )
	                                      ),
	                                      this.renderSubtotal()
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 4 },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'itemNotation', withRef: true, ref: 'itemNotation', component: _inputField.InputField, onFocus: this.handleOnFocus, onKeyPress: function onKeyPress(event) {
	                                        if (event.charCode == 13 && _this9.state.selectedInventoryRow && _this9.state.selectedInventoryRow.ProductNum) {
	                                          _this9.handleFocusAutoSuggest();
	                                          // this.clearInventoryInfo();
	                                          _this9.checkAddRow();
	                                        }
	                                      } })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 1 },
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory' }),
	                                    ':'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 5 },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Col,
	                                      { xs: 4 },
	                                      _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-xs-6 inlineLabel' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'in_stock' })
	                                      ),
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'col-xs-6 inventory-highlight' },
	                                        this.state.inStock
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Col,
	                                      { xs: 4 },
	                                      _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-xs-6 inlineLabel' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchased' })
	                                      ),
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'col-xs-6 inventory-highlight' },
	                                        this.state.purchased
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Col,
	                                      { xs: 4 },
	                                      _react2.default.createElement(
	                                        'label',
	                                        { className: 'col-xs-6 inlineLabel' },
	                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'presale' })
	                                      ),
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'col-xs-6 inventory-highlight' },
	                                        this.state.presale
	                                      )
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 6 },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 4 },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: 'col-xs-6 inlineLabel' },
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' })
	                                    ),
	                                    _react2.default.createElement(
	                                      'span',
	                                      { className: 'col-xs-6 inventory-highlight' },
	                                      this.state.net_weight
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 4, style: { paddingRight: 0 } },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: 'col-xs-6 inlineLabel' },
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_wt' })
	                                    ),
	                                    _react2.default.createElement(
	                                      'span',
	                                      { className: 'col-xs-6 inventory-highlight' },
	                                      this.state.ship_weight
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 4 },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { className: 'col-xs-6 inlineLabel' },
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' })
	                                    ),
	                                    _react2.default.createElement(
	                                      'span',
	                                      { className: 'col-xs-6 inventory-highlight' },
	                                      this.state.total_weight
	                                    )
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 2 },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-4' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'created' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-xs-8' },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'CreateTime',
	                                    component: _datePicker.StartOfThisMonthDatePicker
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-4' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'posting_date' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'asteriksReq' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-xs-8' },
	                                  _react2.default.createElement(_reduxForm.Field, {
	                                    name: 'PostingDate',
	                                    component: _datePicker.StartOfThisMonthDatePicker
	                                  })
	                                )
	                              ),
	                              isTN && _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-4' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-xs-8' },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'InvoiceShipDate',
	                                    component: _datePicker.DatePicker
	                                  })
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  ' ',
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2, className: 'position-absolute' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Panel,
	                      { header: poNum, className: 'panel-po-num' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-control-static' },
	                        _react2.default.createElement(_reactBootstrap.Input, { onChange: this.handleChange, maxLength: 150, name: 'poNum', type: 'text', value: this.state.poNum })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 10, className: 'mb0' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Panel,
	                      null,
	                      this.renderSaleInvoice()
	                    )
	                  ),
	                  ' ',
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          _reactBootstrap.Panel,
	                          { header: invoiceNum },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-control-static edit-si-total-price-panel' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-control-static', style: { width: '100%' } },
	                              _react2.default.createElement(_reduxForm.Field, {
	                                name: 'InvoiceNum',
	                                component: this.props.currentSalesInvoice != null && this.props.currentSalesInvoice.SaleStatus === 'Released' ? _inputField.InputField : _inputField.DisabledInputField,
	                                placeholder: this.props.currentSalesInvoice && this.props.currentSalesInvoice.InvoiceNum
	                              })
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          _reactBootstrap.Panel,
	                          { header: totalPrice },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-control-static edit-si-total-price-panel' },
	                            _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'dollar-sign' },
	                                '$'
	                              ),
	                              (0, _NumberUtil.roundTo)(this.state.totalPrice, 2)
	                            ),
	                            savings > 0 && _react2.default.createElement(
	                              'span',
	                              { className: 'edit-si-promotion' },
	                              promotion
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 6 },
	                        _react2.default.createElement(
	                          _reactBootstrap.Panel,
	                          { header: tax },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-control-static' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'dollar-sign' },
	                              '$'
	                            ),
	                            totalTaxWithPromotion
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 6 },
	                        _react2.default.createElement(
	                          _reactBootstrap.Panel,
	                          { header: crv },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-control-static' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'dollar-sign' },
	                              '$'
	                            ),
	                            this.state.totalCRV
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 6 },
	                        _react2.default.createElement(
	                          _reactBootstrap.Panel,
	                          { header: finalPrice },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-control-static' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'dollar-sign' },
	                              '$'
	                            ),
	                            finalPriceWithPromotion
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 6 },
	                        _react2.default.createElement(
	                          _reactBootstrap.Panel,
	                          { header: deliveryTitle },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-control-static' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'dollar-sign' },
	                              '$'
	                            ),
	                            this.state.delivery
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          _reactBootstrap.Panel,
	                          { header: paymentTitle },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-control-static' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'dollar-sign' },
	                              '$'
	                            ),
	                            this.state.payment
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          _reactBootstrap.Panel,
	                          { header: balanceTitle },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-control-static' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'dollar-sign' },
	                              '$'
	                            ),
	                            this.state.balance
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          _reactBootstrap.Panel,
	                          { header: employeeNoteTitle, className: 'panel-customer-note' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-control-static' },
	                            _react2.default.createElement(
	                              'span',
	                              { onDoubleClick: function onDoubleClick() {
	                                  _this9.openEmployeeNote();
	                                } },
	                              _react2.default.createElement(_reactBootstrap.Input, { maxLength: 150, disabled: true, type: 'text', value: this.state.employeeNoteDisplay })
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          _reactBootstrap.Panel,
	                          { header: customerNote, className: 'panel-customer-note' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-control-static' },
	                            _react2.default.createElement(_reactBootstrap.Input, { onChange: this.handleChange, maxLength: 150, name: 'Notation', type: 'text', value: this.state.Notation })
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: createDialogStyleWeight, isVisible: this.state.setWeightOpen, onCloseClicked: function onCloseClicked() {
	                  _this9.closeSetWeight();
	                }, title: 'Set Product Weights' },
	              _react2.default.createElement(_setWeightModal2.default, { invoice: true, setWeights: this.setWeights, keepLoaded: this.keepLoaded, currentWeights: this.state.currentWeights, closeC: this.closeSetWeight, totalLoaded: this.state.totalLoaded, rowChosen: this.state.rowChosen, returnTotalWeight: this.returnTotalWeight.bind(this), editedRow: this.state.editedRow })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: createNoteDialogStyle, isVisible: this.state.changeEmployeeNoteOpen, onCloseClicked: function onCloseClicked() {
	                  _this9.closeEmployeeNote();
	                }, title: changeEmployeeNoteTitle },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { className: 'centerStyle' },
	                  _react2.default.createElement(
	                    'div',
	                    { style: { width: '80%' } },
	                    _react2.default.createElement(_reactBootstrap.Input, {
	                      type: 'textarea',
	                      rows: 5,
	                      onChange: this.onChangeEmployeeNote,
	                      value: this.state.employeeNoteText
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { className: 'centerStyle' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                      bsStyle: 'success',
	                      onClick: function onClick() {
	                        _this9.onSubmitEmployeeNote();
	                      }
	                    },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: createDialogInventoryStyle, isVisible: this.state.showInventoryOpen, onCloseClicked: function onCloseClicked() {
	                  _this9.closeShowInventory('productSearch');
	                }, title: selectInventoryInformation },
	              _react2.default.createElement(_salesInventoryInfo2.default, {
	                Customer_id: this.state.currentCustomer,
	                SearchType: this.props.searchType,
	                SearchValue: this.props.searchValue,
	                formName: 'editSalesInvoice',
	                closeShowInventory: this.closeShowInventory,
	                selectInventoryInfo: this.selectInventoryInfo,
	                setSaleRowValue: this.props.setSaleRowValue,
	                setAllProductQuantity: this.setAllProductQuantity })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: createDialogStyle, isVisible: this.state.confirmOpen, onCloseClicked: function onCloseClicked() {
	                  _this9.closeConfirm();
	                }, title: confirmAction },
	              _react2.default.createElement(_confirmActionModal2.default, {
	                'case': this.state.case,
	                closeC: this.closeConfirm,
	                caseAction: function caseAction() {
	                  _this9.addRow();
	                }
	              })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                dialogStyles: createDialogStyle,
	                isVisible: this.state.showEditCustomerConfirmOpen,
	                onCloseClicked: this.closeShowEditCustomerConfirm,
	                title: confirmAction
	              },
	              _react2.default.createElement(_confirmActionModal2.default, {
	                'case': _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_customer_confirm' }),
	                caseAction: this.openShowEditCustomer,
	                closeC: this.closeShowEditCustomerConfirm
	              })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                dialogStyles: createDialogEditCustomerStyle,
	                isVisible: this.state.showEditCustomerOpen,
	                onCloseClicked: this.closeShowEditCustomer,
	                title: 'select customer information'
	              },
	              _react2.default.createElement(_EditCustomerModal2.default, {
	                invoiceID: salesInvoiceDetail && salesInvoiceDetail.SalesInvoice_id,
	                onCloseClicked: this.closeShowEditCustomer,
	                confirmAction: this.openShowSICustomerUpdated
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'remove-close-skylight' },
	              _react2.default.createElement(
	                _reactSkylight.SkyLightStateless,
	                {
	                  dialogStyles: createDialogStyle,
	                  isVisible: this.state.showSIUpdatedOpen,
	                  onCloseClicked: this.closeShowSIUpdated,
	                  title: ModalHeader
	                },
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { className: 'centerStyle' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	                    ' : ',
	                    this.props.invoiceNum
	                  )
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { className: 'centerStyle' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_ask_if_stay_on_current_page' }),
	                    '?'
	                  )
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { className: 'button-toolbar-center' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { bsStyle: 'primary', className: 'mr', onClick: this.closeShowSIUpdated, type: 'button' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { bsStyle: 'danger', className: 'mr', onClick: function onClick() {
	                        _this9.context.router.goBack();
	                        _this9.closeShowSIUpdated();
	                        _this9.context.router.push('/salesInvoice/');
	                      }, type: 'button' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	                  ),
	                  this.renderPrint()
	                )
	              )
	            ),
	            this.renderPrintIframe()
	          )
	          //---------------
	          // End HTML
	          //---------------
	
	        );
	      }
	    }
	  }]);
	
	  return EditSalesInvoice;
	}(_react.Component);
	
	EditSalesInvoice.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var _default = (0, _reactRouter.withRouter)(EditSalesInvoice);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isTN, 'isTN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/editSalesInvoice.jsx');
	
	  __REACT_HOT_LOADER__.register(renderTypeRadios, 'renderTypeRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/editSalesInvoice.jsx');
	
	  __REACT_HOT_LOADER__.register(isNumeric, 'isNumeric', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/editSalesInvoice.jsx');
	
	  __REACT_HOT_LOADER__.register(EditSalesInvoice, 'EditSalesInvoice', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/editSalesInvoice.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/editSalesInvoice.jsx');
	}();

	;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactNotificationSystem = __webpack_require__(103);
	
	var _reactNotificationSystem2 = _interopRequireDefault(_reactNotificationSystem);
	
	var _constants = __webpack_require__(11);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _favoriteModal = __webpack_require__(75);
	
	var _favoriteModal2 = _interopRequireDefault(_favoriteModal);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _inputField = __webpack_require__(16);
	
	var _salesInventoryInfo = __webpack_require__(77);
	
	var _salesInventoryInfo2 = _interopRequireDefault(_salesInventoryInfo);
	
	var _TypeRadios = __webpack_require__(57);
	
	var _TypeRadios2 = _interopRequireDefault(_TypeRadios);
	
	var _GenericProductSuggest = __webpack_require__(51);
	
	var _GenericProductSuggest2 = _interopRequireDefault(_GenericProductSuggest);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FavoriteList = function (_Component) {
	  _inherits(FavoriteList, _Component);
	
	  function FavoriteList() {
	    _classCallCheck(this, FavoriteList);
	
	    var _this = _possibleConstructorReturn(this, (FavoriteList.__proto__ || Object.getPrototypeOf(FavoriteList)).call(this));
	
	    _this._notificationSystem = null;
	
	    _this.handleOptionChange = function (changeEvent) {
	      _this.setState({ productSearchType: changeEvent.target.value });
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton,
	
	      createFavoriteOpen: false,
	      showInventoryOpen: false,
	      currentCustomerID: null,
	      currentCustomerName: null,
	      SalesFavoriteList_id: null,
	
	      customers: {
	        rows: [],
	        filters: {},
	        selectedRows: null,
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      favorites: {
	        rows: [],
	        filters: {},
	        selectedRows: null,
	        selectedIndexes: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      suggestValue: '',
	      productSearchType: 'ProductNum'
	
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.openFavoriteCreate = _this.openFavoriteCreate.bind(_this);
	    _this.closeFavoriteCreate = _this.closeFavoriteCreate.bind(_this);
	    _this.addFavorite = _this.addFavorite.bind(_this);
	    _this.saveFavoriteList = _this.saveFavoriteList.bind(_this);
	    _this.selectInventoryInfo = _this.selectInventoryInfo.bind(_this);
	    _this.closeShowInventory = _this.closeShowInventory.bind(_this);
	    _this.handleOnFocus = _this.handleOnFocus.bind(_this);
	    _this.setAllProductQuantity = _this.setAllProductQuantity.bind(_this);
	    _this.handleAfterShowInventoryClose = _this.handleAfterShowInventoryClose.bind(_this);
	    _this.searchInventory = _this.searchInventory.bind(_this);
	    return _this;
	  }
	
	  _createClass(FavoriteList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      // window.addEventListener('resize', this.handleResize);
	      this.props.setValue('favoriteList', 'SearchType', 'RefNum');
	      // this.props.fetchCustomerFavorites();
	      this._notificationSystem = this.refs.notificationSystem;
	      this.props.fetchCustomersWithFavorites();
	      // this.props.fetchInventories();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.customers && nextProps.customers !== this.props.customers) {
	        var customers = _extends({}, this.state.customers, { rows: nextProps.customers });
	        this.setState({ customers: customers });
	      }
	
	      if (nextProps.customerFavoritesList && nextProps.customerFavoritesList !== this.props.customerFavoritesList) {
	        var favorites = _extends({}, this.state.favorites, { rows: nextProps.customerFavoritesList });
	        this.setState({ favorites: favorites });
	      }
	
	      if (nextProps.favoriteList && nextProps.favoriteList !== this.props.favoriteList) {
	        if (nextProps.favoriteList.Sales_FavoriteList_Lines) {
	          var rows = [].concat(_toConsumableArray(nextProps.favoriteList.Sales_FavoriteList_Lines));
	          var _favorites = _extends({}, this.state.favorites, { rows: rows });
	          this.setState({ favorites: _favorites });
	        }
	      }
	
	      if (nextProps.saveFavoriteListSuccess && nextProps.saveFavoriteListSuccess !== this.props.saveFavoriteListSuccess) {
	        this.handleAddNotification('save_successful', 'success');
	      }
	
	      if (nextProps.saveFavoriteListError && nextProps.saveFavoriteListError !== this.props.saveFavoriteListError) {
	        this.handleAddNotification('save_failed', 'error');
	      }
	    }
	  }, {
	    key: 'setAllProductQuantity',
	    value: function setAllProductQuantity() {
	      // this.props.setValue('favoriteList', 'Quantity', quantity);
	    }
	  }, {
	    key: 'closeFavoriteCreate',
	    value: function closeFavoriteCreate() {
	      this.setState({ createFavoriteOpen: false });
	    }
	  }, {
	    key: 'openFavoriteCreate',
	    value: function openFavoriteCreate() {
	      this.setState({ createFavoriteOpen: true });
	    }
	  }, {
	    key: 'selectInventoryInfo',
	    value: function selectInventoryInfo(productNum, selectedInventoryRow) {
	      var rows = [];
	      if (this.state.favorites.rows) {
	        rows = [].concat(_toConsumableArray(this.state.favorites.rows));
	      }
	      rows = rows.filter(function (obj) {
	        var match = String(obj.ProductNum) !== selectedInventoryRow.ProductNum;
	        return match;
	      });
	      var newRow = _extends({}, selectedInventoryRow);
	      newRow.Ordered = newRow.Purchased;
	      rows.unshift(_extends({}, newRow));
	      var favorites = _extends({}, this.state.favorites, { rows: rows });
	      this.setState({
	        selectedInventoryRow: selectedInventoryRow,
	        favorites: favorites,
	        suggestValue: ''
	      });
	    }
	  }, {
	    key: 'handleAddNotification',
	    value: function handleAddNotification(title, level) {
	      this._notificationSystem.addNotification({
	        title: _react2.default.createElement(_reactReduxI18n.Translate, { value: title }),
	        level: level
	      });
	    }
	  }, {
	    key: 'handleOnFocus',
	    value: function handleOnFocus(event) {
	      event.target.select();
	    }
	  }, {
	    key: 'addFavorite',
	    value: function addFavorite(newFavorite) {
	      // let index =  _.findIndex(this.state.favorites.rows, { 'Product_id': newFavorite.id });
	      // if (index == -1)
	      //   return;
	      var newRow = {
	        Product_id: newFavorite.Product_id,
	        ProductName: newFavorite.Name,
	        Description: newFavorite.Description,
	        RefNum: newFavorite.ProductNum,
	        ProductNum: newFavorite.ProductNum,
	        PreSale: newFavorite.PreSale,
	        InStock: newFavorite.InStock,
	        Ordered: newFavorite.Purchased,
	        RefPurchasingPrice: newFavorite.refPrice
	      };
	
	      var preRows = this.state.favorites.rows;
	      preRows.push(newRow);
	      var favorites = _extends({}, this.state.favorites, { rows: preRows });
	      this.setState({ favorites: favorites });
	    }
	  }, {
	    key: 'removeRow',
	    value: function removeRow(ProductNum) {
	      var rows = [].concat(_toConsumableArray(this.state.favorites.rows));
	
	      rows = rows.filter(function (obj) {
	        var match = String(obj.ProductNum) !== ProductNum;
	        return match;
	      });
	      var favorites = _extends({}, this.state.favorites, { rows: rows });
	      this.setState({ favorites: favorites });
	    }
	  }, {
	    key: 'saveFavoriteList',
	    value: function saveFavoriteList() {
	      // this.props.addNewCustomerFavorite(this.state.favorites.rows, this.state.currentCustomerID);
	      var id = this.state.currentCustomerID;
	      var rows = [].concat(_toConsumableArray(this.state.favorites.rows));
	      this.props.saveFavoriteList({ Customer_id: id, Sales_FavoriteList_Lines: rows });
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.twoLineButton });
	    }
	  }, {
	    key: 'openShowInventory',
	    value: function openShowInventory(event) {
	      if (!this.props.ProductInformation || this.props.ProductInformation === '') {
	        return;
	      }
	      switch (event.charCode) {
	        case 13:
	          // ENTER
	          event.preventDefault();
	          if (this.state.currentCustomerID) {
	            this.setState({ showInventoryOpen: true });
	            break;
	          } else {
	            this.setState({ case: 'noCustomerChosen', confirmOpen: true });
	          }
	          break;
	        default:
	          return;
	      }
	    }
	  }, {
	    key: 'searchInventory',
	    value: function searchInventory() {
	      if (!this.props.ProductInformation || this.props.ProductInformation === '') {
	        return;
	      }
	
	      if (this.state.currentCustomerID) {
	        this.setState({ showInventoryOpen: true });
	      } else {
	        this.setState({ case: 'noCustomerChosen', confirmOpen: true });
	      }
	    }
	  }, {
	    key: 'closeShowInventory',
	    value: function closeShowInventory() {
	      this.handleAfterShowInventoryClose('ProductSearch');
	      this.setState({ showInventoryOpen: false });
	    }
	  }, {
	    key: 'handleAfterShowInventoryClose',
	    value: function handleAfterShowInventoryClose(value) {
	      _reactDom2.default.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	    }
	  }, {
	    key: 'checkPermission',
	    value: function checkPermission(permission) {
	      return this.props.userPermissions.indexOf(permission) === -1;
	    }
	  }, {
	    key: 'renderCustomerList',
	    value: function renderCustomerList() {
	      var _this2 = this;
	
	      if (this.props.customersIsLoading && !this.props.customersError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.customersError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.customersError)
	          )
	        );
	      }
	      // Parameters of the react-data-grid
	      var getRows = function getRows() {
	        var Rows = _reactDataGridAddons.Data.Selectors.getRows(_this2.state.customers);
	        return Rows;
	      };
	
	      var getSize = function getSize() {
	        var RowLength = getRows().length;
	        return RowLength;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var customers = _extends({}, _this2.state.customers, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this2.setState({ customers: customers });
	      };
	
	      var onRowClick = function onRowClick(rowIdx, row) {
	        var favorites = _extends({}, _this2.state.favorites, { rows: row.Sales_FavoriteList_Lines });
	        _this2.props.fetchFavoriteList(row.Customer_id);
	        _this2.setState({
	          SalesFavoriteList_id: row.SalesFavoriteList_id,
	          currentCustomerID: row.Customer_id,
	          currentCustomerName: row.Name,
	          favorites: favorites });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this2.state.customers.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var customers = _extends({}, _this2.state.customers, { filters: newFilters });
	        _this2.setState({ customers: customers });
	      };
	      // Column difinition
	
	      var columns = [{
	        key: 'CustomerNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12, id: 'FavoriteList-dataGrid1' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'Customer_id',
	              onGridSort: handleGridSort,
	              columns: columns,
	              rowHeight: 25,
	              rowGetter: rowGetter,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              rowsCount: getSize(),
	              minHeight: 640,
	              onRowClick: onRowClick
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderFavoriteProductList',
	    value: function renderFavoriteProductList() {
	      var _this3 = this;
	
	      var that = this;
	      if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.error)
	          )
	        );
	      }
	      // Parameters of the react-data-grid
	      var getRows = function getRows() {
	        var Rows = _reactDataGridAddons.Data.Selectors.getRows(_this3.state.favorites);
	        return Rows;
	      };
	
	      var getSize = function getSize() {
	        var RowLength = getRows().length;
	        return RowLength;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var favorites = _extends({}, _this3.state.favorites, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this3.setState({ favorites: favorites });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var filteredRows = [].concat(_toConsumableArray(_this3.state.favorites.rows));
	        var newFilters = Object.assign({}, _this3.state.favorites.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        for (var property in newFilters) {
	          if (newFilters.hasOwnProperty(property)) {
	            filteredRows = filteredRows.filter(function (obj) {
	              if (obj[property]) {
	                return String(String(obj[property]).toUpperCase().includes(newFilters[property].filterTerm.toUpperCase()));
	              } else {
	                return false;
	              }
	            });
	          }
	        }
	
	        var favorites = _extends({}, _this3.state.favorites, { filters: newFilters, filteredRows: filteredRows });
	        _this3.setState({ favorites: favorites });
	      };
	      var onClearFilters = function onClearFilters() {
	        //all filters removed
	        _this3.setState({ filters: {} });
	      };
	
	      var IsVariableFormatter = _react2.default.createClass({
	        displayName: 'IsVariableFormatter',
	        render: function render() {
	          var _this4 = this;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                className: 'textAlignStyle',
	                style: { height: '23px', width: '39px', padding: '0px' },
	                onClick: function onClick() {
	                  var ProductNum = _this4.props.dependentValues.ProductNum;
	                  that.removeRow(ProductNum);
	                }
	              },
	              'X'
	            )
	          );
	        }
	      });
	      // Column difinition
	
	      var columns = [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 85,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 200
	      }, {
	        key: 'Purchased',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchased' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'InStock',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'instock' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PreSale',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'presale' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { id: 'FavoriteList-dataGrid2' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'Product_id',
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              columns: columns,
	              headerRowHeight: 45,
	              onClearFilters: onClearFilters,
	              onAddFilter: handleFilterChange,
	              rowHeight: 25,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: 557
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderAutoSuggest',
	    value: function renderAutoSuggest() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'control-dropdown' },
	        _react2.default.createElement(_GenericProductSuggest2.default, {
	          value: this.state.suggestValue,
	          onChange: function onChange(e, _ref) {
	            var newValue = _ref.newValue;
	            _this5.setState({ suggestValue: newValue });
	          },
	          SearchType: this.state.productSearchType,
	          fetchOrdersByProduct: this.selectInventoryInfo
	        })
	      );
	    }
	  }, {
	    key: 'renderCurrentCustomer',
	    value: function renderCurrentCustomer() {
	      if (this.state.currentCustomerID == null) {
	        return _react2.default.createElement(
	          'h2',
	          { style: { margin: '5px' }, id: 'choose-customer' },
	          ' - ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'choose_a_customer' })
	        );
	      }
	      return _react2.default.createElement(
	        'h2',
	        { style: { margin: '5px' } },
	        ' - ',
	        this.state.currentCustomerName
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var style = {
	        NotificationItem: { // Override the notification item
	          DefaultStyle: { // Applied to every notification, regardless of the notification level
	            margin: '10px 5px 2px 1px'
	          },
	
	          success: { // Applied only to the success notification item
	            color: 'red'
	          }
	        }
	      };
	      var selectInventoryInformation = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_inventory_information' });
	      var createDialogInventoryStyle = {
	        height: '700px',
	        width: '1000px',
	        marginLeft: '-28%',
	        marginTop: '-20%'
	      };
	      var createDialogStyle = {
	        width: '600px',
	        marginLeft: '-10%'
	      };
	
	      var exportUrl = _root_url.ROOT_URL + "v1/sale/favorite/export/" + this.state.currentCustomerID + "?Bearer=" + localStorage.getItem('token');
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_management' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'favorites_list' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'sales-favorite-list' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 3 },
	              _react2.default.createElement(
	                'h1',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customers' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { className: 'table-collapse-fix' },
	                this.renderCustomerList()
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 9 },
	              _react2.default.createElement(
	                'h1',
	                { style: { float: 'left' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'favorite_list' })
	              ),
	              ' ',
	              this.renderCurrentCustomer(),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 12 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { id: 'favorite-list-panel' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      { style: { marginTop: 6 } },
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(_TypeRadios2.default, { value: this.state.productSearchType, handleOptionChange: this.handleOptionChange })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        this.renderAutoSuggest()
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { id: 'favorite-list', className: 'position-relative table-collapse-fix' },
	                _react2.default.createElement(
	                  _reactBootstrap.ButtonToolbar,
	                  { className: 'table-buttons' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                      bsStyle: 'success',
	                      className: 'pull-right',
	                      disabled: this.state.currentCustomerID == null || !(0, _permissions2.default)('change_sales_favorites'),
	                      onClick: this.saveFavoriteList
	                    },
	                    _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                      bsStyle: 'primary',
	                      className: 'pull-right',
	                      href: exportUrl,
	                      disabled: this.state.currentCustomerID == null || !(0, _permissions2.default)('print_sales_favorites')
	                    },
	                    _react2.default.createElement('em', { className: 'fa fa-print marginRightStyle' }),
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'export_to_excel' })
	                  )
	                ),
	                this.renderFavoriteProductList()
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotificationSystem2.default, { ref: 'notificationSystem', style: style }),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogStyle,
	              isVisible: this.state.createFavoriteOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this6.closeFavoriteCreate();
	              },
	              title: 'Create a new Favorite'
	            },
	            _react2.default.createElement(_favoriteModal2.default, {
	              closeC: this.closeFavoriteCreate,
	              closeA: this.addFavorite,
	              currentList: this.state.favorites,
	              SalesFavoriteList_id: this.state.SalesFavoriteList_id
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogInventoryStyle,
	              isVisible: this.state.showInventoryOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this6.closeShowInventory('ProductSearch');
	              },
	              title: selectInventoryInformation
	            },
	            _react2.default.createElement(_salesInventoryInfo2.default, {
	              Customer_id: this.state.currentCustomerID,
	              SearchType: this.props.SearchType,
	              SearchValue: this.props.ProductInformation,
	              closeShowInventory: this.closeShowInventory,
	              selectInventoryInfo: this.selectInventoryInfo,
	              setSaleRowValue: this.props.setSaleRowValue,
	              setAllProductQuantity: this.setAllProductQuantity,
	              formName: 'favoriteList'
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return FavoriteList;
	}(_react.Component);
	
	FavoriteList.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = FavoriteList;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(FavoriteList, 'FavoriteList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/favoriteList.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/favoriteList.jsx');
	}();

	;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _map = __webpack_require__(55);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _findIndex = __webpack_require__(125);
	
	var _findIndex2 = _interopRequireDefault(_findIndex);
	
	var _filter = __webpack_require__(84);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactNotificationSystem = __webpack_require__(103);
	
	var _reactNotificationSystem2 = _interopRequireDefault(_reactNotificationSystem);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _rowRenderer = __webpack_require__(64);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _createGroupModal = __webpack_require__(487);
	
	var _createGroupModal2 = _interopRequireDefault(_createGroupModal);
	
	var _groupList_actions = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { UI_HEIGHT } from '../Common/constants';
	
	
	var contextTypes = {
	  router: _react2.default.PropTypes.shape({})
	};
	
	var GroupList = function (_Component) {
	  _inherits(GroupList, _Component);
	
	  function GroupList() {
	    _classCallCheck(this, GroupList);
	
	    var _this = _possibleConstructorReturn(this, (GroupList.__proto__ || Object.getPrototypeOf(GroupList)).call(this));
	
	    _this._notificationSystem = null;
	
	    _this.handleFetchCustomers = function () {
	      var handleSuccess = function handleSuccess(response) {
	        var allCustomers = _extends({}, _this.state.allCustomers, { rows: response.data || [], filters: {} });
	        _this.setState({
	          isLoadingCustomers: false,
	          allCustomers: allCustomers,
	          allCustomerRowsOriginal: response.data || []
	        });
	      };
	
	      var handleFailure = function handleFailure(error) {
	        _this.setState({ isLoadingCustomers: false });
	        alert(JSON.stringify(error));
	      };
	
	      _this.setState({ isLoadingCustomers: true }, function () {
	        (0, _groupList_actions.fetchCustomers)(handleSuccess, handleFailure);
	      });
	    };
	
	    _this.handleFetchCustomerGroups = function () {
	      var handleSuccess = function handleSuccess(response) {
	        var selectedRows = _this.state.groups.selectedRows;
	
	        var rows = response.data;
	        if (selectedRows.length > 0) {
	          (0, _map2.default)(rows, function (row) {
	            if (row.CustomerGroup_id === selectedRows[0].CustomerGroup_id) {
	              row.isSelected = true;
	            }
	          });
	        }
	        var groups = _extends({}, _this.state.groups, { rows: rows, filters: {} });
	        _this.setState({
	          isLoadingGroups: false,
	          groups: groups
	        });
	      };
	
	      var handleFailure = function handleFailure(error) {
	        _this.setState({ isLoadingGroups: false });
	        alert(JSON.stringify(error));
	      };
	
	      _this.setState({ isLoadingGroups: true }, function () {
	        (0, _groupList_actions.fetchCustomerGroups)(handleSuccess, handleFailure);
	      });
	    };
	
	    _this.handleFetchCustomerGroupDetails = function () {
	      var handleSuccess = function handleSuccess(response) {
	        var rows = response.data.Customers || [];
	        var customers = _extends({}, _this.state.customers, { rows: rows, filters: {} });
	        _this.setState({
	          isLoadingGroupDetails: false,
	          customers: customers
	        });
	      };
	
	      var handleFailure = function handleFailure(error) {
	        _this.setState({ isLoadingGroupDetails: false });
	        alert(JSON.stringify(error));
	      };
	      var selectedRows = _this.state.groups.selectedRows;
	
	      if (selectedRows.length === 0) {
	        return;
	      }
	
	      _this.setState({ isLoadingGroupDetails: true }, function () {
	        (0, _groupList_actions.fetchCustomerGroupsDetail)(selectedRows[0].CustomerGroup_id, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.handleSaveCustomerList = function () {
	      var handleSuccess = function handleSuccess() {
	        _this.setState({ isLoadingSaveCustomerList: false }, function () {
	          _this.handleAddNotification('save_successful', 'success');
	          _this.handleFetchCustomerGroups();
	          _this.handleFetchCustomers();
	        });
	      };
	
	      var handleFailure = function handleFailure(error) {
	        _this.setState({ isLoadingSaveCustomerList: false }, function () {
	          alert(JSON.stringify(error));
	        });
	      };
	
	      var _this$state = _this.state,
	          customers = _this$state.customers,
	          currentGroupName = _this$state.currentGroupName,
	          currentGroupId = _this$state.currentGroupId;
	
	      var customerIds = (0, _map2.default)(customers.rows, 'Customer_id');
	      _this.setState({ isLoadingSaveCustomerList: true }, function () {
	        (0, _groupList_actions.saveCustomerList)(customerIds, currentGroupName, currentGroupId, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.handleDeleteGroup = function () {
	      var handleSuccess = function handleSuccess() {
	        _this.setState({ isLoadingDeleteGroup: false }, function () {
	          var selectedRows = _this.state.groups.selectedRows;
	          var groupToDeleteId = _this.state.groupToDeleteId;
	
	          if (selectedRows.length > 0 && selectedRows[0].CustomerGroup_id === groupToDeleteId) {
	            var customers = _extends({}, _this.state.customers, { rows: [], filters: {} });
	            _this.setState({ customers: customers, currentGroupId: '', currentGroupName: '' });
	          }
	          _this.handleAddNotification('delete_successful', 'success');
	          _this.handleFetchCustomerGroups();
	        });
	      };
	
	      var handleFailure = function handleFailure(error) {
	        _this.setState({ isLoadingDeleteGroup: false });
	        alert(JSON.stringify(error));
	      };
	
	      _this.setState({ isLoadingDeleteGroup: true }, function () {
	        (0, _groupList_actions.deleteGroup)(_this.state.groupToDeleteId, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.handleAddGroup = function (currentGroupName) {
	      var handleSuccess = function handleSuccess() {
	        _this.setState({ isLoadingCreateGroup: false }, function () {
	          _this.closeModalCreate();
	          _this.handleFetchCustomerGroups();
	        });
	      };
	
	      var handleFailure = function handleFailure(error) {
	        _this.setState({ isLoadingCreateGroup: false });
	        alert(JSON.stringify(error));
	      };
	
	      _this.setState({ isLoadingCreateGroup: true }, function () {
	        (0, _groupList_actions.createGroup)(currentGroupName, handleSuccess, handleFailure);
	      });
	    };
	
	    _this.handleCurrentGroupNameChange = function (event) {
	      _this.setState({ currentGroupName: event.target.value });
	    };
	
	    _this.handleOnFocus = function (event) {
	      event.target.select();
	    };
	
	    _this.openModalConfirm = function () {
	      _this.setState({ confirmModalOpen: true });
	    };
	
	    _this.closeModalConfirm = function () {
	      _this.setState({
	        confirmModalOpen: false,
	        case: '',
	        caseAction: null,
	        confirmTitle: ''
	      });
	    };
	
	    _this.openModalCreate = function () {
	      _this.setState({ createModalOpen: true });
	    };
	
	    _this.closeModalCreate = function () {
	      _this.setState({ createModalOpen: false });
	    };
	
	    _this.moveToCustomerGroup = function (event) {
	      if (!_this.state.currentGroupId) {
	        alert(_reactReduxI18n.I18n.t('please_select_group'));
	        return;
	      }
	      var invalid = (0, _findIndex2.default)(_this.state.customers.rows, function (row) {
	        return row.CustomerNum === event.CustomerNum;
	      });
	      if (invalid !== -1) {
	        alert(_reactReduxI18n.I18n.t('this_customer_is_already_in_the_group'));
	        return;
	      }
	      var customerRows = JSON.parse(JSON.stringify(_this.state.customers.rows));
	      var allCustomerRows = (0, _filter2.default)(_this.state.allCustomers.rows, function (customer) {
	        return customer.CustomerNum !== event.CustomerNum;
	      });
	      customerRows.push(event);
	      var customers = _extends({}, _this.state.customers, { rows: customerRows });
	      var allCustomers = _extends({}, _this.state.allCustomers, { rows: allCustomerRows });
	      _this.setState({ customers: customers, allCustomers: allCustomers });
	    };
	
	    _this.state = {
	      // tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton,
	
	      isLoadingCustomers: false,
	      isLoadingGroups: false,
	      isLoadingDeleteGroup: false,
	      isLoadingCreateGroup: false,
	      isLoadingGroupDetails: false,
	      isLoadingSaveCustomerList: false,
	
	      currentGroupId: '',
	      currentGroupName: '',
	      groupToDeleteId: '',
	      confirmModalOpen: false,
	      createModalOpen: false,
	      case: '',
	      caseAction: null,
	      confirmTitle: '',
	      groups: {
	        rows: [],
	        filters: {},
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      customers: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      allCustomers: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      allCustomerRowsOriginal: []
	    };
	    return _this;
	  }
	
	  _createClass(GroupList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // window.addEventListener('resize', this.handleResize);
	      this._notificationSystem = this.refs.notificationSystem;
	      this.handleFetchCustomerGroups();
	      this.handleFetchCustomers();
	    }
	  }, {
	    key: 'handleAddNotification',
	    value: function handleAddNotification(title, level) {
	      this._notificationSystem.addNotification({
	        title: _react2.default.createElement(_reactReduxI18n.Translate, { value: title }),
	        level: level
	      });
	    }
	  }, {
	    key: 'removeGroup',
	    value: function removeGroup(groupToDeleteId) {
	      var confirmTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm_delete' });
	      this.setState({
	        confirmModalOpen: true,
	        groupToDeleteId: groupToDeleteId,
	        case: 'deleteGroup',
	        caseAction: this.handleDeleteGroup,
	        confirmTitle: confirmTitle
	      });
	    }
	  }, {
	    key: 'removeCustomer',
	    value: function removeCustomer(customerId, customerNum) {
	      var customerToRemove = void 0;
	      var customerRows = (0, _filter2.default)(this.state.customers.rows, function (customer) {
	        if (customer.CustomerNum === customerNum) {
	          customerToRemove = customer;
	          return false;
	        }
	        return true;
	      });
	      var allCustomerRows = JSON.parse(JSON.stringify(this.state.allCustomers.rows));
	      var found = (0, _findIndex2.default)(allCustomerRows, function (row) {
	        return row.CustomerNum === customerNum;
	      });
	      if (found === -1) {
	        allCustomerRows.push(customerToRemove);
	      }
	      var customers = _extends({}, this.state.customers, { rows: customerRows });
	      var allCustomers = _extends({}, this.state.allCustomers, { rows: allCustomerRows });
	      this.setState({ customers: customers, allCustomers: allCustomers });
	    }
	
	    // handleResize = () => {
	    //   this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton });
	    // }
	
	  }, {
	    key: 'renderCustomerList',
	    value: function renderCustomerList() {
	      var _this2 = this;
	
	      var that = this;
	      if (this.state.isLoadingGroups || this.state.isLoadingDeleteGroup || this.state.isLoadingCreateGroup) {
	        return _react2.default.createElement(_spinner2.default, null);
	      }
	
	      var getRows = function getRows() {
	        var rows = _reactDataGridAddons.Data.Selectors.getRows(_this2.state.groups);
	        return rows;
	      };
	
	      var getSize = function getSize() {
	        var rowLength = getRows().length;
	        return rowLength;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var groups = _extends({}, _this2.state.groups, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this2.setState({ groups: groups });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        var groups = _extends({}, _this2.state.groups, {
	          rows: newRows,
	          selectedRows: [rows[0].row]
	        });
	        var allCustomers = _extends({}, _this2.state.allCustomers, { rows: _this2.state.allCustomerRowsOriginal, filters: {} });
	        var customers = _extends({}, _this2.state.customers, { filters: {} });
	        _this2.setState({
	          groups: groups,
	          customers: customers,
	          allCustomers: allCustomers,
	          currentGroupId: rows[0].row.CustomerGroup_id,
	          currentGroupName: rows[0].row.Name
	        }, function () {
	          _this2.handleFetchCustomerGroupDetails();
	        });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this2.state.groups.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var groups = _extends({}, _this2.state.groups, { filters: newFilters });
	        _this2.setState({ groups: groups });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        var groups = _extends({}, _this2.state.groups, { filters: {} });
	        _this2.setState({ groups: groups });
	      };
	
	      var IsVariableFormatter = _react2.default.createClass({
	        displayName: 'IsVariableFormatter',
	        render: function render() {
	          var _this3 = this;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                className: 'textAlignStyle',
	                style: { height: '23px', width: '39px', padding: '0px' },
	                onClick: function onClick() {
	                  var customerGroupId = _this3.props.dependentValues.CustomerGroup_id;
	                  that.removeGroup(customerGroupId);
	                }
	              },
	              'X'
	            )
	          );
	        }
	      });
	
	      var columns = [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'group_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }];
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'primary',
	              className: 'add-group-button',
	              onClick: that.openModalCreate
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: '+' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { id: 'GroupList-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'Customer_id',
	              onGridSort: handleGridSort,
	              columns: columns,
	              rowHeight: 25,
	              rowGetter: rowGetter,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onClearFilters: onClearFilters,
	              onAddFilter: handleFilterChange,
	              rowsCount: getSize(),
	              minHeight: 640,
	              enableRowSelect: 'single',
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              }
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderAllCustomersList',
	    value: function renderAllCustomersList() {
	      var _this4 = this;
	
	      if (this.state.isLoadingCustomers) {
	        return _react2.default.createElement(_spinner2.default, null);
	      }
	
	      var getRows = function getRows() {
	        var rows = _reactDataGridAddons.Data.Selectors.getRows(_this4.state.allCustomers);
	        return rows;
	      };
	
	      var getSize = function getSize() {
	        var rowLength = getRows().length;
	        return rowLength;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var allCustomers = _extends({}, _this4.state.allCustomers, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this4.setState({ allCustomers: allCustomers });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this4.state.allCustomers.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var allCustomers = _extends({}, _this4.state.allCustomers, { filters: newFilters });
	        _this4.setState({ allCustomers: allCustomers });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        var allCustomers = _extends({}, _this4.state.allCustomers, { filters: {} });
	        _this4.setState({ allCustomers: allCustomers });
	      };
	
	      var columns = [{
	        key: 'CustomerNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	        resizable: true,
	        sortable: true,
	        width: 140,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	        resizable: true,
	        sortable: true,
	        width: 250,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { id: 'GroupList-dataGrid2' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'Product_id',
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              columns: columns,
	              onClearFilters: onClearFilters,
	              onAddFilter: handleFilterChange,
	              rowHeight: 25,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: 640,
	              rowRenderer: _react2.default.createElement(_rowRenderer.RowRenderer, { onDoubleClick: this.moveToCustomerGroup })
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderCustomersInGroupsList',
	    value: function renderCustomersInGroupsList() {
	      var _this5 = this;
	
	      var that = this;
	      if (this.state.isLoadingGroupDetails) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'customer-list-spinner' },
	          _react2.default.createElement(_spinner2.default, null)
	        );
	      }
	
	      var getRows = function getRows() {
	        var rows = _reactDataGridAddons.Data.Selectors.getRows(_this5.state.customers);
	        return rows;
	      };
	
	      var getSize = function getSize() {
	        var rowLength = getRows().length;
	        return rowLength;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var customers = _extends({}, _this5.state.customers, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this5.setState({ customers: customers });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this5.state.customers.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var customers = _extends({}, _this5.state.customers, { filters: newFilters });
	        _this5.setState({ customers: customers });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        var customers = _extends({}, _this5.state.customers, { filters: {} });
	        _this5.setState({ customers: customers });
	      };
	
	      var IsVariableFormatter = _react2.default.createClass({
	        displayName: 'IsVariableFormatter',
	        render: function render() {
	          var _this6 = this;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                className: 'textAlignStyle',
	                style: { height: '23px', width: '39px', padding: '0px' },
	                onClick: function onClick() {
	                  var customerId = _this6.props.dependentValues.Customer_id;
	                  var customerNum = _this6.props.dependentValues.CustomerNum;
	                  that.removeCustomer(customerId, customerNum);
	                }
	              },
	              'X'
	            )
	          );
	        }
	      });
	
	      var columns = [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'CustomerNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	        resizable: true,
	        sortable: true,
	        width: 140,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	        resizable: true,
	        sortable: true,
	        width: 250,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { id: 'GroupList-dataGrid3' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'Product_id',
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              columns: columns,
	              onClearFilters: onClearFilters,
	              onAddFilter: handleFilterChange,
	              rowHeight: 25,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: 640
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderCurrentCustomer',
	    value: function renderCurrentCustomer() {
	      if (this.state.currentGroupId == null) {
	        return _react2.default.createElement(
	          'h2',
	          { style: { marginTop: '5px' }, id: 'choose-customer' },
	          ' - ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_select_a_group' })
	        );
	      }
	      return _react2.default.createElement(
	        'h2',
	        { style: { marginTop: '5px' } },
	        ' - ',
	        this.state.currentGroupName
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var style = {
	        NotificationItem: { // Override the notification item
	          DefaultStyle: { // Applied to every notification, regardless of the notification level
	            margin: '10px 5px 2px 1px'
	          },
	
	          success: { // Applied only to the success notification item
	            color: 'red'
	          }
	        }
	      };
	      var createDialogModal = {
	        height: '180px',
	        width: '480px',
	        left: '65%'
	      };
	      var createAction = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm_create' });
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_management' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'group_list' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'group-list' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 3 },
	              _react2.default.createElement(
	                'h1',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'groups' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { className: 'table-collapse-fix' },
	                this.renderCustomerList()
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 9 },
	              _react2.default.createElement(
	                'h1',
	                { style: { float: 'left' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_list' })
	              ),
	              ' ',
	              this.renderCurrentCustomer(),
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { className: 'customer-panel' },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 6 },
	                  this.renderAllCustomersList()
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 6 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'customer-list-top-bar' },
	                    _react2.default.createElement(_SpinnerButton2.default, {
	                      bsStyle: 'success',
	                      className: 'save-button',
	                      onClick: this.handleSaveCustomerList,
	                      disabled: !this.state.currentGroupId || this.state.isLoadingSaveCustomerList,
	                      loading: this.state.isLoadingSaveCustomerList,
	                      icon: 'fa-save',
	                      translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                    }),
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      className: 'current-group-name-input',
	                      value: this.state.currentGroupName,
	                      onChange: this.handleCurrentGroupNameChange,
	                      disabled: !this.state.currentGroupId
	                    })
	                  ),
	                  this.renderCustomersInGroupsList()
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_reactNotificationSystem2.default, { ref: 'notificationSystem', style: style })
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogModal,
	            isVisible: this.state.confirmModalOpen,
	            onCloseClicked: function onCloseClicked() {
	              _this7.closeModalConfirm();
	            },
	            title: this.state.confirmTitle
	          },
	          _react2.default.createElement(_confirmActionModal2.default, {
	            'case': this.state.case,
	            caseAction: this.state.caseAction,
	            groupName: this.state.currentGroupName,
	            closeC: this.closeModalConfirm
	          })
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: createDialogModal,
	            isVisible: this.state.createModalOpen,
	            onCloseClicked: function onCloseClicked() {
	              _this7.closeModalCreate();
	            },
	            title: createAction
	          },
	          _react2.default.createElement(_createGroupModal2.default, {
	            caseAction: this.handleAddGroup,
	            closeC: this.closeModalCreate
	          })
	        )
	      );
	    }
	  }]);
	
	  return GroupList;
	}(_react.Component);
	
	GroupList.contextTypes = contextTypes;
	
	var _default = GroupList;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(contextTypes, 'contextTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/groupList.jsx');
	
	  __REACT_HOT_LOADER__.register(GroupList, 'GroupList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/groupList.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/groupList.jsx');
	}();

	;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _inputField = __webpack_require__(16);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var logModal = function (_Component) {
	    _inherits(logModal, _Component);
	
	    function logModal() {
	        _classCallCheck(this, logModal);
	
	        var _this = _possibleConstructorReturn(this, (logModal.__proto__ || Object.getPrototypeOf(logModal)).call(this));
	
	        _this.state = {
	            report: {
	                rows: [{}],
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            }
	        };
	        return _this;
	    }
	
	    _createClass(logModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            console.log("??", this.props);
	            var sessionsProps = this.props.rowProps.SessionLogs;
	            for (var i = 0; i < sessionsProps.length; i++) {
	                var date = new Date(sessionsProps[i].LogInTime);
	                var formattedDate = date.getFullYear() + '-';
	                formattedDate += date.getMonth() + 1 + '-';
	                if (date.getDate() < 10) {
	                    formattedDate += '0' + date.getDate();
	                } else {
	                    formattedDate += date.getDate();
	                }
	                var LogInTime = '';
	                if (sessionsProps[i].LogInTime) {
	                    LogInTime = _moment2.default.utc(sessionsProps[i].LogInTime).local().format('LT');
	                    // LogInTime = sessionsProps[i].LogInTime;
	                    // LogInTime = LogInTime.substring(LogInTime.indexOf('T') + 1, LogInTime.indexOf('T') + 6);
	                }
	                var LogOutTime = '';
	                if (sessionsProps[i].LogOutTime) {
	                    LogOutTime = _moment2.default.utc(sessionsProps[i].LogOutTime).local().format('LT');
	                    // LogOutTime = sessionsProps[i].LogOutTime;
	                    // LogOutTime = LogOutTime.substring(LogOutTime.indexOf('T') + 1, LogOutTime.indexOf('T') + 6);
	                }
	                sessionsProps[i].Date = formattedDate;
	                sessionsProps[i].NewLogInTime = LogInTime;
	                sessionsProps[i].NewLogOutTime = LogOutTime;
	            }
	            this.setState({ report: { rows: sessionsProps } });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            console.log("?", nextProps);
	            var sessionsProps = nextProps.rowProps.SessionLogs;
	            for (var i = 0; i < sessionsProps.length; i++) {
	                var date = new Date(sessionsProps[i].LogInTime);
	                var formattedDate = date.getFullYear() + '-';
	                formattedDate += date.getMonth() + 1 + '-';
	                if (date.getDate() < 10) {
	                    formattedDate += '0' + date.getDate();
	                } else {
	                    formattedDate += date.getDate();
	                }
	                var LogInTime = sessionsProps[i].LogInTime;
	                LogInTime = LogInTime.substring(LogInTime.indexOf('T') + 1, LogInTime.indexOf('T') + 6);
	                var LogOutTime = sessionsProps[i].LogOutTime;
	                LogOutTime = LogOutTime.substring(LogOutTime.indexOf('T') + 1, LogOutTime.indexOf('T') + 6);
	                sessionsProps[i].Date = formattedDate;
	                sessionsProps[i].NewLogInTime = LogInTime;
	                sessionsProps[i].NewLogOutTime = LogOutTime;
	            }
	            this.setState({ report: { rows: sessionsProps } });
	        }
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this2 = this;
	
	            var tableHeight = window.innerHeight < 930 ? 300 : 330;
	
	            var getRows = function getRows() {
	                return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.report);
	            };
	
	            var getSize = function getSize() {
	                return getRows().length;
	            };
	
	            var rowGetter = function rowGetter(rowIdx) {
	                var rows = getRows();
	                return rows[rowIdx];
	            };
	
	            // Handle the sortable function
	
	            var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                var state = Object.assign({}, _this2.state.report, { sortColumn: sortColumn, sortDirection: sortDirection });
	                _this2.setState({ report: state });
	            };
	
	            var handleFilterChange = function handleFilterChange(filter) {
	                var newFilters = Object.assign({}, _this2.state.report.filters);
	                if (filter.filterTerm) {
	                    newFilters[filter.column.key] = filter;
	                } else {
	                    delete newFilters[filter.column.key];
	                }
	                var report = _extends({}, _this2.state.report, { filters: newFilters });
	                _this2.setState({ report: report });
	            };
	
	            var handleRowUpdated = function handleRowUpdated(e) {
	                var rows = getRows();
	                Object.assign(rows[e.rowIdx], e.updated);
	                var report = _extends({}, _this2.state.report, { rows: rows });
	                _this2.setState({ report: report });
	            };
	
	            // Handle the row select function
	
	            var onRowSelect = function onRowSelect(rows) {
	                var report = _extends({}, _this2.state.report, { selectedRows: rows });
	                _this2.setState({ report: report });
	            };
	            var columns = [{
	                key: 'SessionLog_id',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'id' }),
	                width: 25,
	                resizable: true,
	                sortable: true,
	                editable: true
	            }, {
	                key: 'User',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'user' }),
	                resizable: true,
	                sortable: true,
	                editable: true
	            }, {
	                key: 'Date',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	                resizable: true,
	                sortable: true,
	                editable: true
	            }, {
	                key: 'NewLogInTime',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'login' }),
	                width: 80,
	                resizable: true,
	                sortable: true,
	                editable: true
	            }, {
	                key: 'NewLogOutTime',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'logout' }),
	                width: 80,
	                resizable: true,
	                sortable: true,
	                editable: true
	            }, {
	                key: 'StartingCash',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cash_in' }),
	                resizable: true,
	                sortable: true,
	                editable: true
	            }, {
	                key: 'TotalCashAmount',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'end_cash' }),
	                resizable: true,
	                sortable: true,
	                editable: true
	            }, {
	                key: 'StoreCredit',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'store_credit' }),
	                resizable: true,
	                sortable: true,
	                editable: true
	            }, {
	                key: 'Checks',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check' }),
	                resizable: true,
	                sortable: true,
	                editable: true
	            }, {
	                key: 'CreditCards',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'card' }),
	                resizable: true,
	                sortable: true,
	                editable: true
	            }, {
	                key: 'TotalSale',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_sale' }),
	                resizable: true,
	                sortable: true,
	                editable: true
	            }, {
	                key: 'TotalPaidOut',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'paid_out' }),
	                resizable: true,
	                sortable: true,
	                editable: true
	            }];
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'LogModal-dataGrid1' },
	                        _react2.default.createElement(_reactDataGrid2.default, {
	                            onGridSort: handleGridSort,
	                            onAddFilter: handleFilterChange,
	                            columns: columns,
	                            rowGetter: rowGetter,
	                            rowsCount: getSize(),
	                            rowHeight: 25,
	                            headerRowHeight: 45,
	                            minHeight: tableHeight,
	                            onRowUpdated: handleRowUpdated,
	                            onRowSelect: onRowSelect })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            console.log("THis is the state", this.state);
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    this.renderTable()
	                )
	            );
	        }
	    }]);
	
	    return logModal;
	}(_react.Component);
	
	var _default = logModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(logModal, 'logModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/logModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/logModal.jsx');
	}();

	;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _lodash = __webpack_require__(19);
	
	var _root_url = __webpack_require__(9);
	
	var _constants = __webpack_require__(11);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _numberWithCommas = __webpack_require__(35);
	
	var _shipToOrders_actions = __webpack_require__(91);
	
	var _otherService_actions = __webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(5),
	    _require$Draggable = _require.Draggable,
	    DraggableContainer = _require$Draggable.Container,
	    RowActionsCell = _require$Draggable.RowActionsCell,
	    DropTargetRowContainer = _require$Draggable.DropTargetRowContainer,
	    Selectors = _require.Data.Selectors;
	
	var PreOrder = function (_Component) {
	  _inherits(PreOrder, _Component);
	
	  function PreOrder() {
	    _classCallCheck(this, PreOrder);
	
	    var _this = _possibleConstructorReturn(this, (PreOrder.__proto__ || Object.getPrototypeOf(PreOrder)).call(this));
	
	    _this.state = {
	      breadcrumbTitle: 'other_service',
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.fiveLineButton,
	      otherService: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      salesOrderDetail: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      rowsCount: 0,
	      total: 0,
	      canceledOrders: 0,
	      canceledTotal: 0
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    return _this;
	  }
	
	  _createClass(PreOrder, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.console.log('componentDidMount');
	      window.addEventListener('resize', this.handleResize);
	      document.title = _root_url.companyCodeTitle;
	      this.props.fetchOtherService();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.console.log('componentWillUnmount');
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      window.console.log('componentWillReceiveProps', nextProps);
	      if (nextProps.otherService && nextProps.otherService !== this.props.otherService) {
	        // Split Weight
	        if (this.state.otherService.selectedRows && this.state.otherService.selectedRows.length === 1) {
	          nextProps.otherService.Orders.map(function (orders) {
	            if (orders.Shiporder_id === _this2.state.otherService.selectedRows[0].Shiporder_id) {
	              _this2.state.otherService.selectedRows[0].FinalShippingWeight = orders.FinalShippingWeight;
	            }
	          });
	        }
	        this.setState({ total: nextProps.otherService.Rows });
	
	        var otherService = _extends({}, this.state.otherService, {
	          rows: nextProps.otherService.Orders,
	          filters: {}
	        });
	        var selectedRows0 = otherService.selectedRows[0];
	        if (selectedRows0) {
	          for (var i = 0; i < otherService.rows.length; i++) {
	            if (selectedRows0.Shiporder_id === otherService.rows[i].Shiporder_id) {
	              otherService.rows[i].isSelected = true;
	            }
	          }
	        }
	
	        var salesOrderDetail = _extends({}, this.state.salesOrderDetail, { rows: [] });
	        this.setState({ otherService: otherService, salesOrderDetail: salesOrderDetail });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      window.console.log('shouldComponentUpdate', nextProps, nextState);
	      return true;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      window.console.log('shouldComponentUpdate', prevProps, prevState);
	      if (prevState.otherService !== this.state.otherService) {
	        var canceledTotal = 0;
	        var canceledOrders = this.state.otherService.rows.filter(function (row) {
	          var match = row.SaleStatus === "Canceled";
	          if (match) {
	            canceledTotal += row.FinalPrice;
	          }
	          return match;
	        });
	        this.setState({
	          rowsCount: _reactDataGridAddons.Data.Selectors.getRows(this.state.otherService).length,
	          canceledOrders: canceledOrders.length,
	          canceledTotal: canceledTotal
	        });
	      }
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      this.setState({
	        tableHeight: window.innerHeight - _constants.UI_HEIGHT.fiveLineButton
	      });
	    }
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this3 = this;
	
	      var route = this.context.router.routes[1].path;
	      // Parameters of the react-data-grid
	      var tableHeight = window.innerHeight < 930 ? 270 : 270;
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.otherService);
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        _this3.state.total = 0;
	        for (var i = 0; i < rows.length; i++) {
	          _this3.state.total += rows[i].FinalPrice;
	        }
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this3.state.otherService, {
	          sortColumn: sortColumn,
	          sortDirection: sortDirection
	        });
	        if (state.sortColumn === 'OrderDateDisplay') {
	          state.sortColumn = 'OrderDate';
	        }
	
	        if (state.sortDirection === 'ASC') {
	          _this3.state.pullSheetSort = state.sortColumn;
	        } else if (state.sortDirection === 'DESC') {
	          _this3.state.pullSheetSort = '-' + state.sortColumn;
	        } else {
	          _this3.state.pullSheetSort = '';
	        }
	        _this3.setState({ otherService: state });
	      };
	
	      var handleFilterChange = (0, _lodash.debounce)(function (filter) {
	        _this3.state.total = 0;
	        _this3.state.otherService.rows = _this3.props.otherService.Orders;
	        _this3.state.otherService.selectedRows = [];
	        var newFilters = Object.assign({}, _this3.state.otherService.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var otherService = _extends({}, _this3.state.otherService, { filters: newFilters });
	        _this3.setState({ otherService: otherService });
	      }, 500, { maxWait: 800 });
	
	      // Handle the row select function
	      var onRowClick = function onRowClick(rowIdx, row) {
	        if (rowIdx !== -1) {
	          var rows = getRows();
	          /* Multi row select on row click
	            let selectedRows = [...this.state.otherService.selectedRows];
	             let id = rows[rowIdx].SalesOrder_id;
	            let idx = selectedRows.indexOf(id);
	            if (idx == -1) {
	              rows[rowIdx].isSelected = true;
	              selectedRows.push(id);
	            } else {
	              rows[rowIdx].isSelected = false;
	              selectedRows.splice(idx, 1);
	            }
	          */
	
	          /* Single row select on row click */
	          rows.map(function (r) {
	            r.isSelected = false;
	          });
	          var selectedRows = [rows[rowIdx]];
	          rows[rowIdx].isSelected = true;
	
	          var otherService = _extends({}, _this3.state.otherService, { rows: rows, selectedRows: selectedRows });
	          _this3.setState({ otherService: otherService });
	          // this.props.fetchSalesOrderDetail(row.SalesOrder_id, route);
	        }
	      };
	
	      // Custom Formatter component
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            // const dateMap = [
	            //   'Jan',
	            //   'Feb',
	            //   'Mar',
	            //   'Apr',
	            //   'May',
	            //   'Jun',
	            //   'Jul',
	            //   'Aug',
	            //   'Sep',
	            //   'Oct',
	            //   'Nov',
	            //   'Dec',
	            // ];
	            var date = new Date(this.props.value);
	            // const index = dateMap.indexOf(date.toString().slice(4, 3));
	            // const localDate = index + date.toString().slice(8, 6);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      // Column difinition
	      var columns = [{
	        key: 'Order_Num',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 113
	      }, {
	        key: 'Note',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 124
	      }, {
	        key: 'BusinessInsurance',
	        name: 'Business Insurance',
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true
	      }, {
	        key: 'Copyright',
	        name: 'Copyright',
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: 'FDA_Registration',
	        name: 'FDA Registration',
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true
	      }, {
	        key: 'Other',
	        name: 'Other',
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'USA_market_distribution',
	        name: 'USA Market Distribution',
	        resizable: true,
	        sortable: true,
	        width: 115,
	        filterable: true
	      }, {
	        key: 'TotalPrice',
	        name: 'Total Price',
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PaymentAmount',
	        name: 'Payment Amount',
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PaymentStatus',
	        name: 'Payment Status',
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'Product_Category',
	        name: 'Product Category',
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: 'Shipment_to_USA',
	        name: 'Shipment To USA',
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'OrderStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'create_time',
	        name: 'Create Time',
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true,
	        formatter: DateFormatter
	      }];
	
	      var generateColumns = function generateColumns() {
	        return columns;
	      };
	      return (
	        // React Table Sales Order History Table
	        _react2.default.createElement(
	          'div',
	          { id: 'TNMSOTable' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'div',
	                { id: 'otherService-dataGrid1' },
	                _react2.default.createElement(_reactDataGrid2.default, {
	                  rowKey: 'Shiporder_id',
	                  ref: function ref(g) {
	                    _this3.grid = g;
	                  },
	                  onGridSort: handleGridSort,
	                  toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                  onAddFilter: handleFilterChange,
	                  columns: generateColumns(),
	                  rowHeight: 25,
	                  headerRowHeight: 45,
	                  rowGetter: rowGetter,
	                  rowsCount: getSize(),
	                  minHeight: tableHeight,
	                  enableRowSelect: 'multi',
	                  rowSelection: {
	                    showCheckbox: true,
	                    enableShiftSelect: true,
	                    selectBy: {
	                      isSelectedKey: 'isSelected'
	                    }
	                  },
	                  onRowClick: onRowClick
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 2 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'row-count' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_orders' }),
	                    ':\xA0',
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'font-color-orange', id: 'row-count-equation' },
	                      this.state.rowsCount + ' - ' + this.state.canceledOrders + ' = ' + (this.state.rowsCount - this.state.canceledOrders)
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 6 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'grand-total' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'grand-total-label' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'grand_total' }),
	                      ':\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'font-color-grey', id: 'total-equation' },
	                      '$' + (0, _numberWithCommas.numberWithCommas)((this.state.total || 0).toFixed(2)) + ' - $' + (0, _numberWithCommas.numberWithCommas)((this.state.canceledTotal || 0).toFixed(2)) + ' = $' + (0, _numberWithCommas.numberWithCommas)((this.state.total - this.state.canceledTotal).toFixed(2))
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mso-footnotes' },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_total_orders_equation' })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_grand_total_equation' })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: this.state.breadcrumbTitle })
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'sales-orders-list' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  {
	                    className: 'position-relative table-collapse-fix',
	                    id: 'table-collapse-fix-450',
	                    style: { marginBottom: '0px' }
	                  },
	                  this.renderTable()
	                )
	              )
	            ),
	            ' ',
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_details' })
	                ),
	                _react2.default.createElement(_reactBootstrap.Panel, { className: 'details-table-collapse-fix' })
	              )
	            ),
	            ' '
	          )
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return PreOrder;
	}(_react.Component);
	
	PreOrder.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = PreOrder;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PreOrder, 'PreOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/otherService.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/otherService.jsx');
	}();

	;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _datePicker = __webpack_require__(27);
	
	var _percentFormatter = __webpack_require__(97);
	
	var _percentFormatter2 = _interopRequireDefault(_percentFormatter);
	
	var _selection = __webpack_require__(21);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _constants = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getBsStyle = function getBsStyle(input, value) {
	  return input === value ? 'success' : 'primary';
	};
	
	var renderRadios = function renderRadios(props) {
	  var renderStartDatePicker = function renderStartDatePicker(days) {
	    if (days === '-1') {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: 'primary' },
	        _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', placeholder: 'Start', component: _datePicker.DatePicker })
	      );
	    }
	    return _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: 'primary' },
	      _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', placeholder: 'Start', component: _datePicker.DisabledDatePicker })
	    );
	  };
	  var renderEndDatePicker = function renderEndDatePicker(days) {
	    if (days === '-1') {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: 'primary' },
	        _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', placeholder: 'End', component: _datePicker.DatePicker })
	      );
	    }
	    return _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: 'primary' },
	      _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', placeholder: 'End', component: _datePicker.DisabledDatePicker })
	    );
	  };
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '1') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'today-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'today-radio-filter', type: 'radio', onClick: function onClick() {
	              props.fetchPosCreditsByDetails("1");
	            }, name: 'dateFilterRadios', value: '1', checked: props.input.value === '1' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'today' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '7') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'sevenDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'sevenDay-radio-filter', type: 'radio', onClick: function onClick() {
	              props.fetchPosCreditsByDetails("7");
	            }, name: 'dateFilterRadios', value: '7', checked: props.input.value === '7' })),
	          _react2.default.createElement(
	            'span',
	            null,
	            '7 ',
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '30') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'thirtyDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'thirtyDay-radio-filter', type: 'radio', onClick: function onClick() {
	              props.fetchPosCreditsByDetails("30");
	            }, name: 'dateFilterRadios', value: '30', checked: props.input.value === '30' })),
	          '30 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '90') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'ninetyDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'ninetyDay-radio-filter', type: 'radio', onClick: function onClick() {
	              props.fetchPosCreditsByDetails("90");
	            }, name: 'dateFilterRadios', value: '90', checked: props.input.value === '90' })),
	          '90 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '-1') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'dateRange-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'dateRange-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '-1', checked: props.input.value === '-1' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date_range' })
	        )
	      )
	    ),
	    renderStartDatePicker(props.Days),
	    renderEndDatePicker(props.Days),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      {
	        bsStyle: 'primary',
	        className: 'search-btn',
	        type: 'submit',
	        onClick: function onClick() {
	          props.fetchPosCreditsByDetails();
	        }
	      },
	      _react2.default.createElement('em', { className: 'fa fa-search' })
	    )
	  );
	};
	
	var renderStatusRadios = function renderStatusRadios(props) {
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'all') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'all-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'all-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'all', checked: props.input.value === 'all' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'Void') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'void-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'void-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'Void', checked: props.input.value === 'Void' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'void' })
	        )
	      )
	    )
	  );
	};
	
	var PosCredits = function (_Component) {
	  _inherits(PosCredits, _Component);
	
	  function PosCredits() {
	    _classCallCheck(this, PosCredits);
	
	    var _this = _possibleConstructorReturn(this, (PosCredits.__proto__ || Object.getPrototypeOf(PosCredits)).call(this));
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.fiveLineButton,
	      clear: true,
	      posCredits: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      posCreditDetail: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      days: '1', // default on today
	      action: null
	    };
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.fetchPosCreditsByDetails = _this.fetchPosCreditsByDetails.bind(_this);
	    return _this;
	  }
	
	  _createClass(PosCredits, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.handleResize);
	      var posCreditsFilter = this.props.posCreditsFilter;
	      var route = 'posCredits'; // this.context.router.routes[1].path
	
	      if (posCreditsFilter) {
	        var selectedRows = posCreditsFilter.currentRows.filter(function (r) {
	          return r.isSelected === true;
	        });
	        var posCredits = _extends({}, this.state.posCredits, { rows: posCreditsFilter.currentRows, selectedRows: selectedRows, filters: {} });
	        this.setState({ posCredits: posCredits });
	        this.props.setValue('posCredits', 'Days', posCreditsFilter.Days);
	        this.props.setValue('posCredits', 'FromDate', posCreditsFilter.FromDate);
	        this.props.setValue('posCredits', 'ToDate', posCreditsFilter.ToDate);
	        this.props.setValue('posCredits', 'Seller', posCreditsFilter.Seller);
	        this.props.setValue('posCredits', 'Status', posCreditsFilter.Status);
	        var fromDate = '1900-01-01';
	        if (posCreditsFilter.FromDate) {
	          fromDate = this.formatDate(posCreditsFilter.FromDate);
	        }
	        var toDate = '3000-01-01';
	        if (posCreditsFilter.ToDate) {
	          toDate = this.formatDate(posCreditsFilter.ToDate);
	        }
	        this.props.fetchPosCreditsByFilter(fromDate, toDate, posCreditsFilter.Days, posCreditsFilter.Status);
	      } else {
	        var _fromDate = '1900-01-01';
	        var _toDate = '3000-01-01';
	        var days = '1';
	        var status = 'all';
	        this.props.setValue('posCredits', 'Days', days);
	        this.props.setDefaultOfForm('Status', 'all', 'posCredits');
	        // this.props.fetchPosOrdersByFilter(fromDate, toDate, days, status);
	      }
	      if (posCreditsFilter && route !== posCreditsFilter.currentPage) {
	        this.props.setSalesOrdersFilter(null);
	      }
	    }
	
	    // Once products are ready, reset state.
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var route = 'posCredits'; // this.context.router.routes[1].path;
	      if (nextProps.posCredits && nextProps.posCredits !== this.props.posCredits) {
	        if (this.props.posCreditsFilter && this.props.posCreditsFilter.currentRows && this.context.router.routes[1].path === this.props.posCreditsFilter.currentPage) {
	          var posCredits = nextProps.posCredits;
	          var rows = [].concat(_toConsumableArray(this.state.posCredits.rows));
	          rows = rows.map(function (r) {
	            var index = _lodash2.default.findIndex(posCredits, { Order_id: r.Order_id });
	            if (index > -1) {
	              r.OrderDate = posCredits[index].OrderDate;
	              r.DispatchDate = posCredits[index].DispatchDate;
	              r.SaleStatus = posCredits[index].SaleStatus;
	            } else {
	              r = null;
	            }
	            return r;
	          });
	          rows = rows.filter(function (r) {
	            return r !== null;
	          });
	          var newPosCredits = _extends({}, this.state.posCredits, { rows: rows });
	          if (this.props.posCreditDetail) {
	            var posCreditDetail = _extends({}, this.state.posCreditDetail, { rows: this.props.posCreditDetail });
	            this.setState({ posCreditDetail: posCreditDetail });
	          }
	          this.setState({ posCredits: newPosCredits });
	          // this.props.setSalesOrdersFilter(null);
	        } else {
	          var _posCredits = _extends({}, this.state.posCredits, { rows: nextProps.posCredits, filters: {} });
	          var _posCreditDetail = _extends({}, this.state.posCreditDetail, { rows: [] });
	
	          this.setState({ posCredits: _posCredits, posCreditDetail: _posCreditDetail });
	          // this.props.setSalesOrdersFilter(null);
	        }
	      }
	      if (nextProps.posCreditDetail && nextProps.posCreditDetail !== this.props.posCreditDetail) {
	        var _posCreditDetail2 = _extends({}, this.state.posCreditDetail, { rows: nextProps.posCreditDetail });
	        this.setState({ posCreditDetail: _posCreditDetail2 });
	      }
	
	      if (nextProps.Status && nextProps.Status !== this.props.Status) {
	        var posCreditsFilter = this.props.posCreditsFilter;
	        if (!posCreditsFilter) {
	          var seller = this.props.Seller;
	          if (this.props.Seller) {
	            seller = this.props.Seller.value;
	          }
	          var fromDate = this.props.FromDate ? this.formatDate(this.props.FromDate) : '1900-01-01';
	          var toDate = this.props.ToDate ? this.formatDate(this.props.ToDate) : '3000-01-01';
	          var days = this.props.Days;
	
	          if (days == null) {
	            days = 1;
	          }
	          var productNum = this.props.ProductNum;
	          this.props.fetchPosCreditsByFilter(fromDate, toDate, days, nextProps.Status, seller, productNum, route);
	        }
	      }
	
	      if (nextProps.Seller && nextProps.Seller !== this.props.Seller) {
	        var _posCreditsFilter = this.props.posCreditsFilter;
	        if (!_posCreditsFilter) {
	          var _seller = nextProps.Seller;
	          if (nextProps.Seller) {
	            _seller = nextProps.Seller.value;
	          }
	          var _fromDate2 = this.props.FromDate ? this.formatDate(this.props.FromDate) : '1900-01-01';
	          var _toDate2 = this.props.ToDate ? this.formatDate(this.props.ToDate) : '3000-01-01';
	          var _days = this.props.Days;
	          var _productNum = this.props.ProductNum;
	          this.props.fetchPosCreditsByFilter(_fromDate2, _toDate2, _days, this.props.Status, _seller, _productNum, route);
	        }
	      }
	
	      if (this.props.Seller && nextProps.Seller == null) {
	        var _seller2 = nextProps.Seller;
	        var _fromDate3 = this.props.FromDate ? this.formatDate(this.props.FromDate) : '1900-01-01';
	        var _toDate3 = this.props.ToDate ? this.formatDate(this.props.ToDate) : '3000-01-01';
	        var _days2 = this.props.Days;
	        var _productNum2 = this.props.ProductNum;
	        this.props.fetchPosCreditsByFilter(_fromDate3, _toDate3, _days2, this.props.Status, _seller2, _productNum2, route);
	      }
	
	      if (nextProps.Days && nextProps.Days !== this.props.Days) {
	        if (nextProps.Days !== -1) {
	          this.props.setDefaultOfForm('FromDate', null, 'posCredits');
	          this.props.setDefaultOfForm('ToDate', null, 'posCredits');
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.clear) {
	        this.props.setSalesOrdersFilter(null);
	      }
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'fetchPosCreditsByDetails',
	    value: function fetchPosCreditsByDetails(value) {
	      var dateRange = 7;
	      var FromDate = '1900-01-01';
	      var ToDate = '3000-01-01';
	      var seller = this.props.Seller;
	      var productNum = this.props.ProductNum;
	      var route = 'posCredits'; // this.context.router.routes[1].path;
	      if (this.props.FromDate !== null) {
	        FromDate = this.formatDate(this.props.FromDate);
	      }
	      if (this.props.ToDate !== null) {
	        ToDate = this.formatDate(this.props.ToDate);
	      }
	      if (this.props.Days !== null) {
	        dateRange = this.props.Days;
	      }
	      if (value) {
	        dateRange = value;
	      }
	      if (this.props.Seller) {
	        seller = this.props.Seller.value;
	      }
	
	      // this.props.fetchSalesOrdersByFilter(FromDate, ToDate, dateRange, this.props.Status, seller, productNum, route);
	      this.props.fetchPosCreditsByFilter(FromDate, ToDate, dateRange, this.props.Status, seller, productNum, route);
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      var formattedDate = date.getFullYear() + '-';
	      formattedDate += date.getMonth() + 1 + '-';
	      if (date.getDate() < 10) {
	        formattedDate += '0' + date.getDate();
	      } else {
	        formattedDate += date.getDate();
	      }
	      return formattedDate;
	    }
	  }, {
	    key: 'getUsers',
	    value: function getUsers() {
	      var Users = [];
	      this.props.users.map(function (user) {
	        Users.push({ value: user.user_id, label: user.username });
	      });
	      return Users;
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.fiveLineButton });
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this2 = this;
	
	      if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.error)
	        )
	      );
	
	      // Parameters of the react-data-grid
	      var tableHeight = window.innerHeight < 930 ? 270 : 270;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.posCredits);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        var posCredits = _extends({}, _this2.state.posCredits, { filters: {} });
	        _this2.setState({ posCredits: posCredits });
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this2.state.posCredits, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this2.setState({ posCredits: state });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        _this2.state.posCredits.rows = _this2.props.posCredits;
	        _this2.state.posCredits.selectedRows = [];
	        var newFilters = Object.assign({}, _this2.state.posCredits.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var posCredits = _extends({}, _this2.state.posCredits, { filters: newFilters });
	        _this2.setState({ posCredits: posCredits });
	      };
	
	      var onRowSelect = function onRowSelect(rows) {
	        var posCredits = _extends({}, _this2.state.posCredits, { selectedRows: rows });
	        _this2.setState({ posCredits: posCredits });
	      };
	
	      var onCellSelected = function onCellSelected(coordinates) {
	        var newRows = getRows();
	        _this2.props.fetchPosCreditDetail(newRows[coordinates.rowIdx].Order_Num);
	
	        /* Single row select on cell selected */
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        var selectedRows = [newRows[coordinates.rowIdx]];
	        newRows[coordinates.rowIdx].isSelected = true;
	        var posCredits = _extends({}, _this2.state.posCredits, { rows: newRows, selectedRows: selectedRows });
	        _this2.setState({ posCredits: posCredits });
	      };
	
	      // Custom Formatter component
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var date = new Date(this.props.value);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      // Column difinition
	      var columns = [{
	        key: 'Order_Num',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 135
	      }, {
	        key: 'Sales_User_Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: 'SaleStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 65,
	        filterable: true
	      }, {
	        key: 'Date',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: 'FinalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 75,
	        filterable: true
	      }, {
	        key: 'SalesMargin',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_margin_percentsign' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: _percentFormatter2.default
	      }, {
	        key: 'CreditCardAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit_card_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 75,
	        filterable: true
	      }, {
	        key: 'CheckAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 75,
	        filterable: true
	      }, {
	        key: 'CashAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cash_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 75,
	        filterable: true
	      }, {
	        key: 'StoreCreditAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'store_credit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'MobileAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mobile_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }];
	
	      return (
	        // React Table Sales Order History Table
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { id: 'PosOrders-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'PosOrder_id',
	                onGridSort: handleGridSort,
	                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                onAddFilter: handleFilterChange,
	                columns: columns,
	                rowHeight: 25,
	                headerRowHeight: 45,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                onClearFilters: onClearFilters,
	                minHeight: tableHeight,
	                enableRowSelect: 'single',
	                rowSelection: {
	                  showCheckbox: true,
	                  selectBy: {
	                    isSelectedKey: 'isSelected'
	                  }
	                },
	                onRowSelect: onRowSelect,
	                onCellSelected: onCellSelected
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDatePickers',
	    value: function renderDatePickers() {
	      if (this.props.Days === -1) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'form-group date-picker-positioner' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-2 from-label col-xs-offset-5' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'from' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-2 control-date-picker' },
	            _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', component: _datePicker.DatePicker })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-1 to-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'to' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-2 control-date-picker' },
	            _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', component: _datePicker.DatePicker })
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderUsers',
	    value: function renderUsers() {
	      // If group is loading, show a spinner.
	      if (this.props.usersIsLoading) return _react2.default.createElement(_spinner2.default, null);
	      var Users = this.getUsers();
	      return _react2.default.createElement(
	        'div',
	        { className: 'control-dropdown' },
	        _react2.default.createElement(_reduxForm.Field, { name: 'Seller', component: _selection.Selection, options: Users })
	      );
	    }
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	  }, {
	    key: 'renderCreditTable',
	    value: function renderCreditTable() {
	      var _this3 = this;
	
	      if (this.props.posCreditIsLoading && !this.props.posCreditError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.posCreditError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.posCreditError)
	          )
	        );
	      }
	
	      var tableHeight = window.innerHeight < 930 ? 185 : 185;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.posCreditDetail);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this3.state.posCreditDetail, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this3.setState({ posCreditDetail: state });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        var posCreditDetail = _extends({}, _this3.state.posCreditDetail, { filters: {} });
	        _this3.setState({ posCreditDetail: posCreditDetail });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this3.state.posCreditDetail.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var posCreditDetail = _extends({}, _this3.state.posCreditDetail, { filters: newFilters });
	        _this3.setState({ posCreditDetail: posCreditDetail });
	      };
	
	      // Handle the row select function
	      var onRowSelect = function onRowSelect(rows) {
	        var posCreditDetail = _extends({}, _this3.state.posCreditDetail, { selectedRows: rows });
	        _this3.setState({ posCreditDetail: posCreditDetail });
	      };
	
	      // Custom Formatter component
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var date = new Date(this.props.value);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      // Column definition
	      var columns = [{
	        key: 'UserName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: 'CreditInvoiceNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit_invoice_num' }),
	        resizable: true,
	        sortable: true,
	        width: 200
	      }, {
	        key: 'ApplyAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'apply_amount' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: 'RestAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rest_amount' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: 'SalesInvoiceNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_invoice_num' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: 'CreateDatetime',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	        resizable: true,
	        sortable: true,
	        formatter: DateFormatter,
	        width: 150
	      }];
	
	      return (
	        // Credit Invoice Details
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { id: 'PosOrders-dataGrid2' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'PosCredit_id',
	                onGridSort: handleGridSort,
	                onAddFilter: handleFilterChange,
	                onClearFilters: onClearFilters,
	                columns: columns,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                rowHeight: 25,
	                headerRowHeight: 45,
	                minHeight: tableHeight,
	                onRowUpdated: this.handleRowUpdated,
	                onRowSelect: onRowSelect
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var posCredit_id = this.state.posCredits && this.state.posCredits.selectedRows[0] && this.state.posCredits.selectedRows[0].Order_id;
	      posCredit_id = posCredit_id || '';
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pos_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pos_credits' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'sales-orders-list' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pos_credit_full_table' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { id: 'date-range-picker', className: 'form-horizontal' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 1 },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'filter-title' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_type' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'colon' },
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 11 },
	                      _react2.default.createElement(
	                        'div',
	                        { id: 'statusFilterRadios', className: 'form-horizontal' },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'Status', component: renderStatusRadios })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 1 },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'filter-title' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'colon' },
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 11 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'Days', component: renderRadios, fetchPosCreditsByDetails: this.fetchPosCreditsByDetails, Days: this.props.Days })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'position-relative table-collapse-fix' },
	                  this.renderTable()
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pos_order_credits' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'details-table-collapse-fix' },
	                  this.renderCreditTable()
	                )
	              )
	            )
	          )
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return PosCredits;
	}(_react.Component);
	
	PosCredits.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = PosCredits;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getBsStyle, 'getBsStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/posCredits.jsx');
	
	  __REACT_HOT_LOADER__.register(renderRadios, 'renderRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/posCredits.jsx');
	
	  __REACT_HOT_LOADER__.register(renderStatusRadios, 'renderStatusRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/posCredits.jsx');
	
	  __REACT_HOT_LOADER__.register(PosCredits, 'PosCredits', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/posCredits.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/posCredits.jsx');
	}();

	;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _dateFilterRadios = __webpack_require__(49);
	
	var _dateFilterRadios2 = _interopRequireDefault(_dateFilterRadios);
	
	var _cleanDates = __webpack_require__(22);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PosHolds = function (_Component) {
	  _inherits(PosHolds, _Component);
	
	  function PosHolds() {
	    _classCallCheck(this, PosHolds);
	
	    var _this = _possibleConstructorReturn(this, (PosHolds.__proto__ || Object.getPrototypeOf(PosHolds)).call(this));
	
	    _this.posHoldsIFrameIsLoaded = function () {
	      if (!_this.state.posHoldsPdfFrameLoaded) {
	        var pdfFrame = window.frames.posHoldsPdf;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this.setState({ posHoldsPdfFrameLoaded: true });
	      }
	    };
	
	    _this.setToDate = function (e) {
	      if (e < _this.state.FromDate) {
	        return;
	      }
	      _this.setState({
	        ToDate: e
	      });
	    };
	
	    _this.setFromDate = function (e) {
	      if (e < _this.state.ToDate) {
	        return;
	      }
	      _this.setState({ FromDate: e });
	    };
	
	    _this.setToRangeSearch = function () {
	      _this.setState({ days: '-1' });
	    };
	
	    _this.fetchPosHoldsByDetails = function (days) {
	      var FromDate = '1900-01-01';
	      var ToDate = '3000-01-01';
	      if (_this.state.FromDate != null) {
	        FromDate = _this.state.FromDate;
	      }
	
	      if (_this.state.ToDate != null) {
	        ToDate = _this.state.ToDate;
	      }
	      if (days === '-1' || days === -1) {
	        _this.setState({ days: days }, function () {
	          _this.props.fetchPosHoldsOrders(_this.state);
	        });
	      } else {
	        _this.setState({ days: days, FromDate: undefined, ToDate: undefined }, function () {
	          _this.props.fetchPosHoldsOrders(_this.state);
	        });
	      }
	    };
	
	    _this.renderTable = function () {
	      var tableHeight = window.innerHeight < 930 ? 285 : 285;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this.state.posHoldsTable);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        var posHoldsTable = _extends({}, _this.state.posHoldsTable, { filters: {} });
	        _this.setState({ posHoldsTable: posHoldsTable });
	      };
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var date = new Date(this.props.value);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this.state.posHoldsTable.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	
	        _this.setState({
	          posHoldsTable: _extends({}, _this.state.posHoldsTable, {
	            filters: newFilters
	          })
	        });
	      };
	
	      var onRowClick = function onRowClick(index) {
	        var rows = getRows();
	        _this.setState({
	          selectedRowIndex: index
	        }, function () {
	          _this.props.fetchPosHoldsOrdersDetail(rows[index].HoldInvoice_id);
	        });
	      };
	
	      var onRowSelect = function onRowSelect(rows) {
	        _this.setState({
	          selectedRows: rows
	        });
	      };
	
	      var columns = [{
	        key: 'Order_Num',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 135
	      }, {
	        key: 'Sales_User_Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: 'SaleStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 65,
	        filterable: true
	      }, {
	        key: 'Date',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: 'FinalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 75,
	        filterable: true
	      }, {
	        key: 'CreditCardAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit_card_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 75,
	        filterable: true
	      }, {
	        key: 'CheckAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 75,
	        filterable: true
	      }, {
	        key: 'CashAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cash_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 75,
	        filterable: true
	      }, {
	        key: 'StoreCreditAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'store_credit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'MobileAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mobile_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'Note',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }];
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var selectedRows = [].concat(_toConsumableArray(_this.state.posHoldsTable.selectedRows));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	          selectedRows.push(r.row);
	        });
	        var posHoldsTable = _extends({}, _this.state.posHoldsTable, { rows: newRows, selectedRows: selectedRows });
	        _this.setState({ posHoldsTable: posHoldsTable });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = getRows();
	        var selectedRows = [].concat(_toConsumableArray(_this.state.posHoldsTable.selectedRows));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	          var rowIndex = _lodash2.default.findIndex(selectedRows, { 'HoldInvoice_id': r.row.HoldInvoice_id });
	          selectedRows.splice(rowIndex, 1);
	        });
	        var posHoldsTable = _extends({}, _this.state.posHoldsTable, { rows: newRows, selectedRows: selectedRows });
	        _this.setState({ posHoldsTable: posHoldsTable });
	      };
	
	      return (
	        // Sales Invoice Details
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { id: 'PosOrders-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'HoldInvoice_id',
	                ref: function ref(g) {
	                  return _this.g = g;
	                },
	                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                columns: columns,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                rowHeight: 25,
	                headerRowHeight: 45,
	                minHeight: tableHeight,
	                onAddFilter: handleFilterChange,
	                onClearFilters: onClearFilters,
	                enableRowSelect: 'multi',
	                onRowClick: onRowClick
	                // onRowSelect={onRowSelect}
	                , rowSelection: {
	                  showCheckbox: true,
	                  enableShiftSelect: true,
	                  onRowsSelected: onRowsSelected,
	                  onRowsDeselected: onRowsDeselected,
	                  selectBy: {
	                    isSelectedKey: 'isSelected'
	                  }
	                }
	              })
	            )
	          )
	        )
	      );
	    };
	
	    _this.renderDetailTable = function () {
	      var tableHeight = window.innerHeight < 930 ? 285 : 285;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this.state.selectedRowTable);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var date = new Date(this.props.value);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var columns = [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: 'TotalNetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }];
	
	      return (
	        // Sales Invoice Details
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { id: 'salesOrders-dataGrid2' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'posHolds_id',
	                columns: columns,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                rowHeight: 25,
	                headerRowHeight: 45,
	                minHeight: tableHeight
	              })
	            )
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      status: 'all',
	      FromDate: undefined,
	      ToDate: undefined,
	      days: '7',
	      posHoldsTable: {
	        rows: [],
	        filters: {},
	        selectedRows: []
	      },
	      selectedRowIndex: null,
	      selectedRowTable: {
	        rows: []
	      },
	      // print
	      posHoldsPdfFrameLoaded: true
	    };
	    return _this;
	  }
	
	  _createClass(PosHolds, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      this.props.fetchPosHoldsOrders(this.state);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.posHolds) {
	        this.setState({
	          posHoldsTable: _extends({}, this.state.posHoldsTable, {
	            rows: nextProps.posHolds.map(function (elem) {
	              return _extends({}, elem, {
	                isSelected: false
	              });
	            })
	          })
	        });
	      }
	      if (nextProps.posHoldsOderDetail) {
	        this.setState({
	          selectedRowTable: {
	            rows: nextProps.posHoldsOderDetail.POS_Order_Lines
	          }
	        });
	      }
	      if (nextProps.confirmPasscodeVerified) {
	        this.props.setPasscodeVerificationStatus(false);
	        this.props.voidSelectedPosHoldsOrder(this.state.posHoldsTable.selectedRows[0].HoldInvoice_id, function () {
	          _this2.props.fetchPosHoldsOrders(_this2.state);
	          _this2.setState({
	            posHoldsTable: _extends({}, _this2.state.posHoldsTable, {
	              selectedRows: []
	            })
	          });
	        });
	      }
	      if (nextProps.posHoldsPDF && nextProps.posHoldsPDF !== this.props.posHoldsPDF) {
	        this.setState({
	          posHoldsPdfFrameLoaded: false,
	          posHoldsTable: _extends({}, this.state.posHoldsTable, {
	            selectedRows: []
	          })
	        });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState.posHoldsPdfFrameLoaded !== this.state.posHoldsPdfFrameLoaded && this.state.posHoldsPdfFrameLoaded === false) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'renderPosHoldsIFrame',
	    value: function renderPosHoldsIFrame() {
	      if (this.props.posHoldsPDF) {
	        var file = window.URL.createObjectURL(this.props.posHoldsPDF);
	        return _react2.default.createElement('iframe', {
	          style: { display: "none" },
	          onLoad: this.posHoldsIFrameIsLoaded,
	          id: 'posHoldsPdf',
	          name: 'posHoldsPdf',
	          src: file
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          FromDate = _state.FromDate,
	          ToDate = _state.ToDate,
	          days = _state.days;
	
	      var dates = (0, _cleanDates.toFromDates)(days, FromDate, ToDate);
	      var params = 'Date__gte=' + dates.fromDate + '&Date__lte=' + dates.toDate;
	      var excelUrl = _root_url.ROOT_URL + 'v1/pos/hold_orders/?Bearer=' + localStorage.getItem('token') + '&filename=holds&' + params;
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pos_management' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pos_holds' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'sales-orders-list' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pos_holds_full_table' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { id: 'date-range-picker', className: 'form-horizontal' },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      'h3',
	                      { className: 'filter-title' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_date' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'colon' },
	                        ':'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 10 },
	                    (0, _dateFilterRadios2.default)({
	                      handleOnClick: this.fetchPosHoldsByDetails,
	                      setFromDate: this.setFromDate,
	                      setToDate: this.setToDate,
	                      setToRangeSearch: this.setToRangeSearch,
	                      FromDate: this.state.FromDate,
	                      ToDate: this.state.ToDate,
	                      Days: this.state.days
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { id: 'date-range-picker', className: 'details-table-collapse-fix' },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    _react2.default.createElement(
	                      _reactBootstrap.ButtonToolbar,
	                      { className: 'table-buttons', style: { position: 'absolute', marginLeft: '7px' } },
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: 'success',
	                          type: 'button',
	                          href: excelUrl
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-download' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'export' })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: 'danger',
	                          type: 'button',
	                          disabled: this.state.posHoldsTable.selectedRows.length !== 1,
	                          onClick: function onClick() {
	                            _this3.props.setConfirmPasscodeModalVisibility(true);
	                          }
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-trash' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'void' })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: 'primary',
	                          className: 'btn btn-primary marginLeftStyle',
	                          disabled: this.state.posHoldsTable.selectedRows.length !== 1,
	                          type: 'button',
	                          onClick: function onClick() {
	                            _this3.props.printPosHolds(_this3.state.posHoldsTable.selectedRows[0].HoldInvoice_id);
	                          }
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-print' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	                      )
	                    ),
	                    this.renderPosHoldsIFrame(),
	                    this.renderTable()
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            { style: { marginTop: '30px' } },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { id: 'date-range-picker', className: 'form-horizontal' },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 12 },
	                    this.renderDetailTable()
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PosHolds;
	}(_react.Component);
	
	var _default = PosHolds;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PosHolds, 'PosHolds', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/posHolds.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/posHolds.jsx');
	}();

	;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _numberWithCommas = __webpack_require__(35);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _datePicker = __webpack_require__(27);
	
	var _cleanDates = __webpack_require__(22);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _percentFormatter = __webpack_require__(97);
	
	var _percentFormatter2 = _interopRequireDefault(_percentFormatter);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _selection = __webpack_require__(21);
	
	var _posGraphModal = __webpack_require__(313);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEcity = _root_url.ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/';
	var isMMD = _root_url.ROOT_API_URL === "https://mmdavis-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === 'https://mmdavis-scm.truckxi.com/api/';
	var getBsStyle = function getBsStyle(input, value) {
	  return input === value ? 'success' : 'primary';
	};
	var isTPRO = _root_url.ROOT_URL === "https://tpro-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === 'https://tpro-scm.truckxi.com/api/';
	
	var renderRadios = function renderRadios(props) {
	  var renderStartDatePicker = function renderStartDatePicker(days) {
	    if (days === '-1') {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: 'primary' },
	        _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', placeholder: 'Start', component: _datePicker.DatePicker })
	      );
	    }
	    return _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: 'primary' },
	      _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', placeholder: 'Start', component: _datePicker.DisabledDatePicker })
	    );
	  };
	  var renderEndDatePicker = function renderEndDatePicker(days) {
	    if (days === '-1') {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: 'primary' },
	        _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', placeholder: 'End', component: _datePicker.DatePicker })
	      );
	    }
	    return _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: 'primary' },
	      _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', placeholder: 'End', component: _datePicker.DisabledDatePicker })
	    );
	  };
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '1') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'today-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'today-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '1', onClick: function onClick() {
	              props.fetchPosOrdersByDetails('1');
	            }, checked: props.input.value === '1' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'today' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '7') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'sevenDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'sevenDay-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '7', onClick: function onClick() {
	              props.fetchPosOrdersByDetails('7');
	            }, checked: props.input.value === '7' })),
	          _react2.default.createElement(
	            'span',
	            null,
	            '7 ',
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '30') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'thirtyDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'thirtyDay-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '30', onClick: function onClick() {
	              props.fetchPosOrdersByDetails('30');
	            }, checked: props.input.value === '30' })),
	          '30 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '90') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'ninetyDay-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'ninetyDay-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '90', onClick: function onClick() {
	              props.fetchPosOrdersByDetails('90');
	            }, checked: props.input.value === '90' })),
	          '90 ',
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, '-1') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'dateRange-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'dateRange-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '-1', checked: props.input.value === '-1' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date_range' })
	        )
	      )
	    ),
	    renderStartDatePicker(props.Days),
	    renderEndDatePicker(props.Days),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      {
	        bsStyle: 'primary',
	        className: 'search-btn',
	        type: 'submit',
	        onClick: function onClick() {
	          props.fetchPosOrdersByDetails();
	        }
	      },
	      _react2.default.createElement('em', { className: 'fa fa-search' })
	    )
	  );
	};
	
	var renderStatusRadios = function renderStatusRadios(props) {
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'all') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'all-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'all-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'all', checked: props.input.value === 'all' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'Receipt') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'receipt-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'receipt-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'Receipt', checked: props.input.value === 'Receipt' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receipt' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'Void') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'void-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'void-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'Void', checked: props.input.value === 'Void' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'void' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'Draft') },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'draft-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'draft-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'Draft', checked: props.input.value === 'Draft' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'draft' })
	        )
	      )
	    )
	  );
	};
	
	var PosOrders = function (_Component) {
	  _inherits(PosOrders, _Component);
	
	  function PosOrders() {
	    _classCallCheck(this, PosOrders);
	
	    var _this = _possibleConstructorReturn(this, (PosOrders.__proto__ || Object.getPrototypeOf(PosOrders)).call(this));
	
	    _this.generateRestockExportUrl = function () {
	      var _this$props = _this.props,
	          FromDate = _this$props.FromDate,
	          ToDate = _this$props.ToDate,
	          Days = _this$props.Days,
	          Seller = _this$props.Seller;
	
	      var _toFromDates = (0, _cleanDates.toFromDates)(Days, FromDate, ToDate),
	          fromDate = _toFromDates.fromDate,
	          toDate = _toFromDates.toDate;
	
	      var tproRestockUrl = _root_url.ROOT_URL + 'v1/pos/replenishment_finished_record/?Date__gte=' + fromDate + '&Date__lte=' + toDate + (Seller ? '&Sales_User_id=' + Seller.value : '') + '&format=csv&Bearer=' + localStorage.getItem('token');
	      return tproRestockUrl;
	    };
	
	    _this.generateRestockListExportUrl = function () {
	      var _this$props2 = _this.props,
	          FromDate = _this$props2.FromDate,
	          ToDate = _this$props2.ToDate,
	          Days = _this$props2.Days,
	          Seller = _this$props2.Seller;
	
	      var _toFromDates2 = (0, _cleanDates.toFromDates)(Days, FromDate, ToDate),
	          fromDate = _toFromDates2.fromDate,
	          toDate = _toFromDates2.toDate;
	
	      var tproRestockUrl = _root_url.ROOT_URL + 'v1/pos/get_need_replenishment?Date__gte=' + fromDate + '&Date__lte=' + toDate + (Seller ? '&Sales_User_id=' + Seller.value : '') + '&Bearer=' + localStorage.getItem('token');
	      return tproRestockUrl;
	    };
	
	    _this.renderRestockExport = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'padLeft', style: { marginLeft: '400px', display: 'flex' } },
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            href: _this.generateRestockListExportUrl()
	          },
	          _react2.default.createElement('em', { className: 'fa fa-download' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'restock_list' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            href: _this.generateRestockExportUrl()
	          },
	          _react2.default.createElement('em', { className: 'fa fa-download' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'restock_history' })
	        ),
	        _this.renderUsers()
	      );
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.fiveLineButton,
	      clear: true,
	
	      posOrders: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      voidedRows: 0,
	      voidedfinalPrice: 0,
	      finalPrice: 0,
	      voidedTotal: 0,
	      retailSubtotal: 0,
	      wholesaleSubtotal: 0,
	      retailMargin: 0,
	      wholesalesMargin: 0,
	      retailQty: 0,
	      wholesalesQty: 0,
	      posOrderDetail: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      checkAuthorizeOpen: false,
	      graphVisibility: false,
	      action: null,
	      Customer: null,
	      Type: null
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.printForm = _this.printForm.bind(_this);
	    _this.loadsPost = _this.loadsPost.bind(_this);
	    _this.fetchPosOrdersByDetails = _this.fetchPosOrdersByDetails.bind(_this);
	    _this.checkAuthorize = _this.checkAuthorize.bind(_this);
	    _this.openCheckAuthorize = _this.openCheckAuthorize.bind(_this);
	    _this.closeCheckAuthorize = _this.closeCheckAuthorize.bind(_this);
	    _this.openGraph = _this.openGraph.bind(_this);
	    _this.closeGraph = _this.closeGraph.bind(_this);
	    return _this;
	  }
	
	  _createClass(PosOrders, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      window.addEventListener('resize', this.handleResize);
	      var posOrdersFilter = this.props.posOrdersFilter;
	      var route = 'posOrders'; // this.context.router.routes[1].path
	      this.props.fetchActiveCustomers();
	      this.props.fetchBaseUsers();
	      if (posOrdersFilter) {
	        var selectedRows = posOrdersFilter.currentRows.filter(function (r) {
	          return r.isSelected === true;
	        });
	        var posOrders = _extends({}, this.state.posOrders, { rows: posOrdersFilter.currentRows, selectedRows: selectedRows, filters: {} });
	        this.setState({ posOrders: posOrders });
	        this.props.setValue('posOrders', 'Days', posOrdersFilter.Days);
	        this.props.setValue('posOrders', 'FromDate', posOrdersFilter.FromDate);
	        this.props.setValue('posOrders', 'ToDate', posOrdersFilter.ToDate);
	        this.props.setValue('posOrders', 'Seller', posOrdersFilter.Seller);
	        this.props.setValue('posOrders', 'Status', posOrdersFilter.Status);
	        this.props.setValue('posOrders', 'Customer', posOrdersFilter.Customer);
	        this.props.setValue('posOrders', 'Type', posOrdersFilter.Type);
	
	        var fromDate = '1900-01-01';
	        if (posOrdersFilter.FromDate) {
	          fromDate = this.formatDate(posOrdersFilter.FromDate);
	        }
	        var toDate = '3000-01-01';
	        if (posOrdersFilter.ToDate) {
	          toDate = this.formatDate(posOrdersFilter.ToDate);
	        }
	        var customer = this.props.Customer;
	        if (this.props.Customer) {
	          customer = this.props.Customer.value;
	        }
	
	        var type = this.props.Type;
	        if (this.props.Type) {
	          type = this.props.Type.value;
	        }
	        this.props.fetchPosOrdersByFilter(fromDate, toDate, posOrdersFilter.Days, posOrdersFilter.Status, customer, type);
	      } else {
	        var days = '1';
	        this.props.setValue('posOrders', 'Days', days);
	        this.props.setDefaultOfForm('Status', 'all', 'posOrders');
	        this.props.setDefaultOfForm('Customer', null, 'posOrders');
	        this.props.setDefaultOfForm('Type', null, 'posOrders');
	        // this.props.fetchPosOrdersByFilter(fromDate, toDate, days, status);
	      }
	      if (posOrdersFilter && route !== posOrdersFilter.currentPage) {
	        this.props.setSalesOrdersFilter(null);
	      }
	    }
	
	    // Once products are ready, reset state.
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
	        this.closeCheckAuthorize();
	        if (this.state.action === 'void') {
	          this.voidOrder();
	        }
	      }
	      var route = 'posOrders'; // this.context.router.routes[1].path;
	
	      if (nextProps.posOrdersAll && nextProps.posOrdersAll !== this.props.posOrdersAll) {
	        if (isEcity) {
	          var retailMargin = nextProps.posOrdersAll.retailMargin;
	          var wholesalesMargin = nextProps.posOrdersAll.wholesalesMargin;
	          var retailQty = nextProps.posOrdersAll.retailQty;
	          var wholesalesQty = nextProps.posOrdersAll.wholesalesQty;
	          this.setState({ retailMargin: retailMargin, wholesalesMargin: wholesalesMargin, retailQty: retailQty, wholesalesQty: wholesalesQty });
	        }
	      }
	
	      if (nextProps.posOrders && nextProps.posOrders !== this.props.posOrders) {
	        if (this.props.posOrdersFilter && this.props.posOrdersFilter.currentRows && this.context.router.routes[1].path === this.props.posOrdersFilter.currentPage) {
	          var posOrders = nextProps.posOrders;
	          var rows = [].concat(_toConsumableArray(this.state.posOrders.rows));
	          rows = rows.map(function (r) {
	            var index = _lodash2.default.findIndex(posOrders, { Order_id: r.Order_id });
	            if (index > -1) {
	              r.OrderDate = posOrders[index].OrderDate;
	              r.DispatchDate = posOrders[index].DispatchDate;
	              r.SaleStatus = posOrders[index].SaleStatus;
	            } else {
	              r = null;
	            }
	            return r;
	          });
	          rows = rows.filter(function (r) {
	            return r !== null;
	          });
	          var newPosOrders = _extends({}, this.state.posOrders, { rows: rows });
	          if (this.props.posOrderDetail) {
	            var posOrderDetail = _extends({}, this.state.posOrderDetail, { rows: this.props.posOrderDetail.POS_Order_Lines });
	            this.setState({ posOrderDetail: posOrderDetail });
	          }
	          this.setState({ posOrders: newPosOrders });
	          // this.props.setSalesOrdersFilter(null);
	        } else {
	          var finalPrice = 0;
	          var voidedFinalPrice = 0;
	          var retailSubtotal = 0;
	          var wholesaleSubtotal = 0;
	
	          nextProps.posOrders.map(function (r) {
	            if (r.SaleStatus === 'Void') {
	              voidedFinalPrice += r.FinalPrice;
	            }
	            finalPrice += r.FinalPrice;
	            retailSubtotal += r.RetailSubtotal;
	            wholesaleSubtotal += r.WholesaleSubtotal;
	          });
	          var _posOrders = _extends({}, this.state.posOrders, { rows: nextProps.posOrders, filters: {} });
	          var _posOrderDetail = _extends({}, this.state.posOrderDetail, { rows: [] });
	          this.setState({
	            posOrders: _posOrders,
	            posOrderDetail: _posOrderDetail,
	            finalPrice: finalPrice,
	            voidedFinalPrice: voidedFinalPrice,
	            retailSubtotal: retailSubtotal,
	            wholesaleSubtotal: wholesaleSubtotal
	          });
	          // this.props.setSalesOrdersFilter(null);
	        }
	      }
	      if (nextProps.posOrderDetail && nextProps.posOrderDetail !== this.props.posOrderDetail) {
	        var _posOrderDetail2 = _extends({}, this.state.posOrderDetail, { rows: nextProps.posOrderDetail.POS_Order_Lines });
	        this.setState({ posOrderDetail: _posOrderDetail2 });
	      }
	
	      if (nextProps.Status && nextProps.Status !== this.props.Status) {
	        var posOrdersFilter = this.props.posOrdersFilter;
	        if (!posOrdersFilter) {
	          var seller = this.props.Seller;
	          if (this.props.Seller) {
	            seller = this.props.Seller.value;
	          }
	          var fromDate = this.props.FromDate ? this.formatDate(this.props.FromDate) : '1900-01-01';
	          var toDate = this.props.ToDate ? this.formatDate(this.props.ToDate) : '3000-01-01';
	          var days = this.props.Days;
	
	          if (days == null) {
	            days = 1;
	          }
	          var productNum = this.props.ProductNum;
	
	          var customer = this.props.Customer;
	          if (this.props.Customer) {
	            customer = this.props.Customer.value;
	          }
	
	          var type = this.props.Type;
	          if (this.props.Type) {
	            type = this.props.Type.value;
	          }
	          this.props.fetchPosOrdersByFilter(fromDate, toDate, days, nextProps.Status, customer, type);
	        }
	      }
	
	      if (nextProps.Customer && nextProps.Customer !== this.props.Customer) {
	        var _posOrdersFilter = this.props.posOrdersFilter;
	        if (!_posOrdersFilter) {
	          var _seller = this.props.Seller;
	          if (this.props.Seller) {
	            _seller = this.props.Seller.value;
	          }
	          var _fromDate = this.props.FromDate ? this.formatDate(this.props.FromDate) : '1900-01-01';
	          var _toDate = this.props.ToDate ? this.formatDate(this.props.ToDate) : '3000-01-01';
	          var _productNum = this.props.ProductNum;
	
	          var _customer = nextProps.Customer;
	          if (nextProps.Customer) {
	            _customer = nextProps.Customer.value;
	          }
	
	          var _type = this.props.Type;
	          if (this.props.Type) {
	            _type = this.props.Type.value;
	          }
	          this.props.fetchPosOrdersByFilter(_fromDate, _toDate, this.props.Days, this.props.Status, _customer, _type);
	        }
	      }
	
	      if (nextProps.Type && nextProps.Type !== this.props.Type) {
	        var _posOrdersFilter2 = this.props.posOrdersFilter;
	        if (!_posOrdersFilter2) {
	          var _seller2 = this.props.Seller;
	          if (this.props.Seller) {
	            _seller2 = this.props.Seller.value;
	          }
	          var _fromDate2 = this.props.FromDate ? this.formatDate(this.props.FromDate) : '1900-01-01';
	          var _toDate2 = this.props.ToDate ? this.formatDate(this.props.ToDate) : '3000-01-01';
	          var _productNum2 = this.props.ProductNum;
	
	          var _customer2 = this.props.Customer;
	          if (this.props.Customer) {
	            _customer2 = this.props.Customer.value;
	          }
	
	          var _type2 = nextProps.Type;
	          if (nextProps.Type) {
	            _type2 = nextProps.Type.value;
	          }
	          this.props.fetchPosOrdersByFilter(_fromDate2, _toDate2, this.props.Days, this.props.Status, _customer2, _type2);
	        }
	      }
	
	      if (nextProps.Seller && nextProps.Seller !== this.props.Seller) {
	        var _posOrdersFilter3 = this.props.posOrdersFilter;
	        if (!_posOrdersFilter3) {
	          var _seller3 = nextProps.Seller;
	          if (nextProps.Seller) {
	            _seller3 = nextProps.Seller.value;
	          }
	          var _fromDate3 = this.props.FromDate ? this.formatDate(this.props.FromDate) : '1900-01-01';
	          var _toDate3 = this.props.ToDate ? this.formatDate(this.props.ToDate) : '3000-01-01';
	          var _productNum3 = this.props.ProductNum;
	          var _customer3 = this.props.Customer;
	          if (this.props.Customer) {
	            _customer3 = this.props.Customer.value;
	          }
	          var _type3 = this.props.Type;
	          if (this.props.Type) {
	            _type3 = this.props.Type.value;
	          }
	          this.props.fetchPosOrdersByFilter(_fromDate3, _toDate3, this.props.Days, this.props.Status, _customer3, _type3);
	        }
	      }
	
	      if (this.props.Seller && nextProps.Seller === null) {
	        var _seller4 = nextProps.Seller;
	        var _fromDate4 = this.props.FromDate ? this.formatDate(this.props.FromDate) : '1900-01-01';
	        var _toDate4 = this.props.ToDate ? this.formatDate(this.props.ToDate) : '3000-01-01';
	        var _productNum4 = this.props.ProductNum;
	        var _customer4 = this.props.Customer;
	        if (this.props.Customer) {
	          _customer4 = this.props.Customer.value;
	        }
	        var _type4 = this.props.Type;
	        if (this.props.Type) {
	          _type4 = this.props.Type.value;
	        }
	        this.props.fetchPosOrdersByFilter(_fromDate4, _toDate4, this.props.Days, this.props.Status, _customer4, _type4);
	      }
	
	      if (nextProps.Days && nextProps.Days !== this.props.Days) {
	        if (nextProps.Days !== -1) {
	          this.props.setDefaultOfForm('FromDate', null, 'posOrders');
	          this.props.setDefaultOfForm('ToDate', null, 'posOrders');
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(nextProps, nextState) {
	      if (nextState.posOrders && nextState.posOrders.rows && nextState.posOrders.rows !== this.state.posOrders.rows) {
	        var voidedTotal = 0;
	        var canceledOrders = this.state.posOrders.rows.filter(function (row) {
	          var match = row.SaleStatus === 'Void';
	          var voidTotal = 0;
	          if (match) {
	            voidTotal += row.FinalPrice;
	          }
	          return match;
	        });
	        this.setState({
	          voidedRows: canceledOrders.length,
	          voidedTotal: voidedTotal
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.clear) {
	        this.props.setSalesOrdersFilter(null);
	      }
	      window.removeEventListener('resize', this.handleResize);
	    }
	
	    // Set product being selected to be currentProduct and navigate user to the edit page
	
	  }, {
	    key: 'setCurrentPosOrder',
	    value: function setCurrentPosOrder(e) {
	      e.preventDefault();
	      this.setState({ clear: false });
	      var currentPosOrderId = this.state.posOrders.selectedRows[0].Order_id;
	      var posOrders = this.state.posOrders.rows.filter(function (row) {
	        var match = row.PosOrder_id === currentPosOrderId;
	        return match;
	      });
	
	      var FromDate = this.props.FromDate;
	      var ToDate = this.props.ToDate;
	      // this.props.resetCurrentPosOrder();
	      // this.props.selectPosOrder(posOrders[0]);
	      var currentRows = _reactDataGridAddons.Data.Selectors.getRows(this.state.posOrders);
	      var route = 'posOrders'; // this.context.router.routes[1].path;
	      this.props.setSalesOrdersFilter({
	        Days: this.props.Days,
	        FromDate: FromDate,
	        ToDate: ToDate,
	        Status: this.props.Status,
	        Seller: this.props.Seller,
	        ProductNum: this.props.ProductNum,
	        currentRows: currentRows,
	        currentPage: route
	      });
	      // this.context.router.push('/posOrders/'+currentPosOrder.PosOrder_id);
	      this.context.router.push('/' + this.context.router.routes[1].path + '/' + currentPosOrderId);
	    }
	  }, {
	    key: 'checkAuthorize',
	    value: function checkAuthorize(password) {
	      this.props.checkPassword(password);
	    }
	  }, {
	    key: 'openCheckAuthorize',
	    value: function openCheckAuthorize(action) {
	      this.props.clearCheckPassword();
	      this.setState({ checkAuthorizeOpen: true, action: action });
	    }
	  }, {
	    key: 'closeCheckAuthorize',
	    value: function closeCheckAuthorize() {
	      this.setState({ checkAuthorizeOpen: false });
	    }
	  }, {
	    key: 'openGraph',
	    value: function openGraph() {
	      this.setState({ graphVisibility: true });
	    }
	  }, {
	    key: 'closeGraph',
	    value: function closeGraph() {
	      this.setState({ graphVisibility: false });
	    }
	  }, {
	    key: 'clickNew',
	    value: function clickNew(e) {
	      e.preventDefault();
	      this.props.resetCurrentPosOrder();
	      // this.context.router.push('/posOrders/new')
	      this.context.router.push('/' + this.context.router.routes[1].path + '/new');
	    }
	  }, {
	    key: 'voidOrder',
	    value: function voidOrder() {
	      var _this2 = this;
	
	      var rows = this.state.posOrders.rows;
	
	      this.state.posOrders.selectedRows.map(function (row) {
	        _this2.props.voidPosOrder(row.Order_id);
	        rows.map(function (origRow) {
	          if (origRow.Order_id === row.Order_id) {
	            origRow.SaleStatus = 'Void';
	          }
	        });
	        var posOrders = _extends({}, _this2.state.posOrders, { rows: rows });
	        _this2.setState({ posOrders: posOrders });
	      });
	    }
	  }, {
	    key: 'shouldVoidButtonDisable',
	    value: function shouldVoidButtonDisable() {
	      var selectedRows = this.state.posOrders.selectedRows;
	
	      // Always disable void if selected more than 1 row
	
	      if (selectedRows.length !== 1) {
	        return true;
	      }
	
	      var status = selectedRows[0] ? selectedRows[0].SaleStatus : 'disable';
	      var disabled = status === 'Void' || status === 'disable';
	      return disabled;
	    }
	  }, {
	    key: 'printForm',
	    value: function printForm(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: 'loadsPost',
	    value: function loadsPost() {
	      this.props.loadsPost(this.state.posOrders.selectedRows[0].PosOrder_id);
	    }
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this3 = this;
	
	      var route = 'posOrders'; // this.context.router.routes[1].path
	      if (this.props.isLoading && !this.props.error) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.error) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.error)
	          )
	        );
	      }
	      // Parameters of the react-data-grid
	      var tableHeight = window.innerHeight < 930 ? 270 : 270;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.posOrders);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        var posOrders = _extends({}, _this3.state.posOrders, { filters: {} });
	        _this3.setState({ posOrders: posOrders });
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this3.state.posOrders, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this3.setState({ posOrders: state });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        _this3.state.posOrders.rows = _this3.props.posOrders;
	        _this3.state.posOrders.selectedRows = [];
	        var newFilters = Object.assign({}, _this3.state.posOrders.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var posOrders = _extends({}, _this3.state.posOrders, { filters: newFilters });
	        _this3.setState({ posOrders: posOrders });
	      };
	
	      // Handle the row select function
	      var onRowClick = function onRowClick(rowIdx, row) {
	        if (rowIdx !== -1) {
	          var rows = getRows();
	
	          /* Single row select on row click */
	          rows.map(function (r) {
	            r.isSelected = false;
	          });
	          var selectedRows = [rows[rowIdx]];
	          rows[rowIdx].isSelected = true;
	
	          var posOrders = _extends({}, _this3.state.posOrders, { rows: rows, selectedRows: selectedRows });
	          _this3.setState({ posOrders: posOrders });
	          _this3.props.fetchPosOrderDetail(row.Order_id, route);
	        }
	      };
	
	      var onRowSelect = function onRowSelect(rows) {
	        var posOrders = _extends({}, _this3.state.posOrders, { selectedRows: rows });
	        _this3.setState({ posOrders: posOrders });
	      };
	
	      var onCellSelected = function onCellSelected(coordinates) {
	        var newRows = getRows();
	
	        /* Single row select on cell selected */
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        var selectedRows = [newRows[coordinates.rowIdx]];
	        newRows[coordinates.rowIdx].isSelected = true;
	        var posOrders = _extends({}, _this3.state.posOrders, { rows: newRows, selectedRows: selectedRows });
	        _this3.setState({ posOrders: posOrders });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var selectedRows = [].concat(_toConsumableArray(_this3.state.posOrders.selectedRows));
	
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	          selectedRows.push(r.row);
	        });
	        var posOrders = _extends({}, _this3.state.posOrders, { rows: newRows, selectedRows: selectedRows });
	        _this3.setState({ posOrders: posOrders });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = [].concat(_toConsumableArray(_this3.state.posOrders.rows));
	        var selectedRows = [].concat(_toConsumableArray(_this3.state.posOrders.selectedRows));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	          var rowIndex = selectedRows.indexOf(r.row);
	          selectedRows.splice(rowIndex, 1);
	        });
	        var posOrders = _extends({}, _this3.state.posOrders, { rows: newRows, selectedRows: selectedRows });
	        _this3.setState({ posOrders: posOrders });
	      };
	
	      // Custom Formatter component
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var date = new Date(this.props.value);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 24)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      // Column difinition
	      var columns = [{
	        key: 'Order_Num',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 135
	      }, {
	        key: 'Sales_User_Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: 'SaleStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 65,
	        filterable: true
	      }, {
	        key: 'Date',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	        resizable: true,
	        sortable: true,
	        width: 130,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: 'FinalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 75,
	        filterable: true
	      }, {
	        key: 'SalesMargin',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_margin_percentsign' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: _percentFormatter2.default
	      }, {
	        key: 'CreditCardAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit_card_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 75,
	        filterable: true
	      }, {
	        key: 'CheckAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 75,
	        filterable: true
	      }, {
	        key: 'CashAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cash_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 75,
	        filterable: true
	      }].concat(_toConsumableArray(isEcity ? [{
	        key: 'SavingRate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount_rate_%' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: _percentFormatter2.default
	      }] : [{
	        key: 'StoreCreditAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'store_credit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }]), _toConsumableArray(isEcity ? [{
	        key: 'Savings',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount_$' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }] : [{
	        key: 'MobileAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mobile_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }]), [{
	        key: 'Customer_Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Customer_Name' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	        // formatter: NameFormatter
	      }], _toConsumableArray(isEcity ? [{
	        key: 'RetailSubtotal',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Retail_Subtotal' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: 'WholesaleSubtotal',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Wholesale_Subtotal' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }] : []), [{
	        key: 'Customer_Num',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Customer_Num' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	        // formatter: NameFormatter
	      }, {
	        key: 'SalesTax',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'SalesTax' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }], _toConsumableArray(isMMD ? [{
	        key: 'Savings',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'savings' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }] : []), _toConsumableArray(isEcity ? [] : [{
	        key: 'OthersPaymentType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_type' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }]));
	
	      if (_root_url.isRivera) {
	        var salesTaxIndex = _lodash2.default.findIndex(columns, { key: 'SalesTax' });
	        var TransactionAmount = {
	          key: 'TransactionAmount',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'transaction_amount' }),
	          resizable: true,
	          sortable: true,
	          width: 120,
	          filterable: true,
	          formatter: function formatter(_ref) {
	            var value = _ref.value;
	
	            if (typeof value !== 'number') return null;
	            // if (!value) return null;
	            return _react2.default.createElement(
	              'span',
	              null,
	              '$',
	              value
	            );
	          }
	        };
	        columns.splice(salesTaxIndex + 1, 0, TransactionAmount);
	      }
	
	      return (
	        // React Table Sales Order History Table
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12, style: { marginTop: '-30px' } },
	              _react2.default.createElement(
	                'div',
	                { id: 'PosOrders-dataGrid1' },
	                _react2.default.createElement(_reactDataGrid2.default, {
	                  rowKey: 'PosOrder_id',
	                  onGridSort: handleGridSort,
	                  toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                  onAddFilter: handleFilterChange,
	                  columns: columns,
	                  rowHeight: 25,
	                  headerRowHeight: 45,
	                  rowGetter: rowGetter,
	                  rowsCount: getSize(),
	                  onClearFilters: onClearFilters,
	                  minHeight: tableHeight,
	                  enableRowSelect: 'multi',
	                  rowSelection: {
	                    showCheckbox: true,
	                    onRowsSelected: onRowsSelected,
	                    onRowsDeselected: onRowsDeselected,
	                    selectBy: {
	                      isSelectedKey: 'isSelected'
	                    }
	                  },
	                  onRowClick: onRowClick,
	                  onCellSelected: onCellSelected,
	                  onRowSelect: onRowSelect
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 2 },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'row-count' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_orders' }),
	                  ':\xA0',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'font-color-orange', id: 'row-count-equation' },
	                    getSize(),
	                    ' - ',
	                    this.state.voidedRows,
	                    ' = ',
	                    getSize() - this.state.voidedRows
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 6 },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'grand-total' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'grand-total-label' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'grand_total' }),
	                    ':\xA0'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'font-color-grey', id: 'total-equation' },
	                    '$' + (0, _numberWithCommas.numberWithCommas)((this.state.finalPrice || 0).toFixed(2)) + ' - $' + (0, _numberWithCommas.numberWithCommas)((this.state.voidedfinalPrice || 0).toFixed(2)) + ' = $' + (0, _numberWithCommas.numberWithCommas)((this.state.finalPrice - this.state.voidedfinalPrice).toFixed(2))
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 4 },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mso-footnotes' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_total_orders_equation' })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_grand_total_equation' })
	                  )
	                )
	              )
	            )
	          ),
	          isEcity && _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3, style: { paddingLeft: '0px' } },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'retail_quantity' }),
	                  ':\xA0',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'font-color-orange', id: 'row-count-equation' },
	                    this.state.retailQty
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'wholesale_quantity' }),
	                  ':\xA0',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'font-color-orange', id: 'row-count-equation' },
	                    this.state.wholesalesQty
	                  )
	                )
	              )
	            )
	          ),
	          isEcity && _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3, style: { paddingLeft: '0px' } },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'retail_subtotal' }),
	                  ':\xA0',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'font-color-grey', id: 'row-count-equation' },
	                    '$' + (0, _numberWithCommas.numberWithCommas)((this.state.retailSubtotal || 0).toFixed(2))
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'wholesale_subtotal' }),
	                  ':\xA0',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'font-color-grey', id: 'row-count-equation' },
	                    '$' + (0, _numberWithCommas.numberWithCommas)((this.state.wholesaleSubtotal || 0).toFixed(2))
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'retail_margin' }),
	                  ':\xA0',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'font-color-grey', id: 'row-count-equation' },
	                    (0, _numberWithCommas.numberWithCommas)((this.state.retailMargin * 100 || 0).toFixed(2)) + ' %'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'wholesale_margin' }),
	                  ':\xA0',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'font-color-grey', id: 'row-count-equation' },
	                    (0, _numberWithCommas.numberWithCommas)((this.state.wholesalesMargin * 100 || 0).toFixed(2)) + ' %'
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDatePickers',
	    value: function renderDatePickers() {
	      if (this.props.Days === -1) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'form-group date-picker-positioner' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-2 from-label col-xs-offset-5' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'from' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-2 control-date-picker' },
	            _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', component: _datePicker.DatePicker })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-1 to-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'to' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-2 control-date-picker' },
	            _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', component: _datePicker.DatePicker })
	          )
	        );
	      }
	    }
	
	    // customers
	
	  }, {
	    key: 'renderCustomers',
	    value: function renderCustomers() {
	      // If group is loading, show a spinner.
	      if (this.props.customersIsLoading) {
	        return _react2.default.createElement(_spinner2.default, null);
	      }
	      var Customers = this.getCustomers();
	      // name Customer__Customer_id
	      return _react2.default.createElement(
	        'div',
	        { className: 'control-dropdown' },
	        _react2.default.createElement(_reduxForm.Field, { name: 'Customer', component: _selection.Selection, options: Customers })
	      );
	    }
	  }, {
	    key: 'getCustomers',
	    value: function getCustomers() {
	      var Customers = [];
	      this.props.customers.map(function (customer) {
	        Customers.push({ value: customer.Customer_id, label: customer.Name });
	      });
	      return Customers;
	    }
	  }, {
	    key: 'renderTypes',
	    value: function renderTypes() {
	      var Types = [{ value: ' ', label: 'All' }, { value: '&RetailSubtotal__gt=0', label: 'Retail' }, { value: '&WholesaleSubtotal__gt=0', label: 'Wholesale' }];
	
	      // name Customer__Customer_id
	      return _react2.default.createElement(
	        'div',
	        { className: 'control-dropdown' },
	        _react2.default.createElement(_reduxForm.Field, { name: 'Type', component: _selection.Selection, options: Types })
	      );
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.fiveLineButton });
	    }
	  }, {
	    key: 'fetchPosOrdersByDetails',
	    value: function fetchPosOrdersByDetails(value) {
	      var dateRange = 7;
	      var FromDate = '1900-01-01';
	      var ToDate = '3000-01-01';
	      var seller = this.props.Seller;
	      var productNum = this.props.ProductNum;
	      var route = 'posOrders'; // this.context.router.routes[1].path;
	      if (this.props.FromDate !== null) {
	        FromDate = this.formatDate(this.props.FromDate);
	      }
	      if (this.props.ToDate !== null) {
	        ToDate = this.formatDate(this.props.ToDate);
	      }
	      if (this.props.Days !== null) {
	        dateRange = this.props.Days;
	      }
	      if (value) {
	        dateRange = value;
	      }
	      if (this.props.Seller) {
	        seller = this.props.Seller.value;
	      }
	
	      var customer = this.props.Customer;
	      if (this.props.Customer) {
	        customer = this.props.Customer.value;
	      }
	
	      var type = this.props.Type;
	      if (this.props.Type) {
	        type = this.props.Type.value;
	      }
	      this.props.fetchPosOrdersByFilter(FromDate, ToDate, dateRange, this.props.Status, customer, type);
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      var formattedDate = date.getFullYear() + '-';
	      formattedDate += date.getMonth() + 1 + '-';
	      if (date.getDate() < 10) {
	        formattedDate += '0' + date.getDate();
	      } else {
	        formattedDate += date.getDate();
	      }
	      return formattedDate;
	    }
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	  }, {
	    key: 'renderProductsTable',
	    value: function renderProductsTable() {
	      var _this4 = this;
	
	      if (this.props.posOrderIsLoading && !this.props.posOrderError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.posOrderError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.posOrderError)
	          )
	        );
	      }
	
	      // Parameters of the react-data-grid
	      var tableHeight = window.innerHeight < 930 ? 185 : 185;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.posOrderDetail);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this4.state.posOrderDetail, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this4.setState({ posOrderDetail: state });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        var posOrderDetail = _extends({}, _this4.state.posOrderDetail, { filters: {} });
	        _this4.setState({ posOrderDetail: posOrderDetail });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this4.state.posOrderDetail.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var posOrderDetail = _extends({}, _this4.state.posOrderDetail, { filters: newFilters });
	        _this4.setState({ posOrderDetail: posOrderDetail });
	      };
	
	      // Handle the row select function
	      var onRowSelect = function onRowSelect(rows) {
	        var posOrderDetail = _extends({}, _this4.state.posOrderDetail, { selectedRows: rows });
	        _this4.setState({ posOrderDetail: posOrderDetail });
	      };
	
	      // Custom Formatter component
	      var IsVariableFormatter = _react2.default.createClass({
	        displayName: 'IsVariableFormatter',
	        render: function render() {
	          if (this.props.dependentValues.ProductType !== 'Non-Fixed') {
	            return _react2.default.createElement(
	              'span',
	              null,
	              this.props.value,
	              ' '
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            this.props.value,
	            ' ',
	            _react2.default.createElement(
	              'label',
	              { className: 'label label-success' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'non_fixed' })
	            )
	          );
	        }
	      });
	
	      // Column definition
	      var columns = [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	        resizable: true,
	        width: 40,
	        sortable: true,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: 'TotalNetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }].concat(_toConsumableArray(isEcity ? [{
	        key: 'ProductMargin',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_margin_percentsign' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: _percentFormatter2.default
	      }] : []));
	
	      return (
	        // Sales Invoice Details
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { id: 'PosOrders-dataGrid2' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'PosOrder_id',
	                onGridSort: handleGridSort,
	                onAddFilter: handleFilterChange,
	                onClearFilters: onClearFilters,
	                columns: columns,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                rowHeight: 25,
	                headerRowHeight: 45,
	                minHeight: tableHeight,
	                onRowUpdated: this.handleRowUpdated,
	                onRowSelect: onRowSelect
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderExcel',
	    value: function renderExcel() {
	      if (this.state.posOrders.selectedRows.length) {
	        return;
	      }
	      var _props = this.props,
	          FromDate = _props.FromDate,
	          ToDate = _props.ToDate,
	          Days = _props.Days,
	          Status = _props.Status;
	
	      var _toFromDates3 = (0, _cleanDates.toFromDates)(Days, FromDate, ToDate),
	          fromDate = _toFromDates3.fromDate,
	          toDate = _toFromDates3.toDate;
	
	      var status = Status === 'all' ? '' : '&SaleStatus=' + Status;
	      var excelUrl = _root_url.ROOT_URL + 'v1/pos/orders/excel/?Date__gte=' + fromDate + '&Date__lte=' + toDate + status + '&Bearer=' + localStorage.getItem('token');
	      return _react2.default.createElement(
	        'div',
	        { className: 'padLeft' },
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            href: excelUrl
	          },
	          _react2.default.createElement('em', { className: 'fa fa-download' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	        )
	      );
	    }
	  }, {
	    key: 'renderPrintExcel',
	    value: function renderPrintExcel() {
	      var posOrder_id = this.state.posOrders.selectedRows.length == 1 && this.state.posOrders.selectedRows[0].Order_id;
	      if (!posOrder_id) {
	        return;
	      }
	      var printUrl = _root_url.ROOT_URL + 'v1/pos/orders/print/' + posOrder_id + '?Bearer=' + localStorage.getItem('token');
	      var excelUrl = _root_url.ROOT_URL + 'v1/pos/orders/excel/' + posOrder_id + '?Bearer=' + localStorage.getItem('token');
	      return _react2.default.createElement(
	        'div',
	        { className: 'padLeft' },
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            type: 'button',
	            href: printUrl
	          },
	          _react2.default.createElement('em', { className: 'fa fa-print' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            href: excelUrl
	          },
	          _react2.default.createElement('em', { className: 'fa fa-download' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	        )
	      );
	    }
	  }, {
	    key: 'renderUsers',
	    value: function renderUsers() {
	      // if (this.props.usersIsLoading) return <Spinner />; // If group is loading, show a spinner.
	      var Users = this.getUsers();
	      return _react2.default.createElement(
	        'div',
	        { style: { marginRight: "10px" }, className: 'control-dropdown' },
	        _react2.default.createElement(_reduxForm.Field, { name: 'Seller', component: _selection.Selection, options: Users })
	      );
	    }
	  }, {
	    key: 'getUsers',
	    value: function getUsers() {
	      var Users = [];
	      this.props.users.map(function (user) {
	        Users.push({ value: user.user_id, label: user.username });
	      });
	      return Users;
	    }
	  }, {
	    key: 'renderMultiSelectPrintExcel',
	    value: function renderMultiSelectPrintExcel() {
	      var posOrderIds = [];
	      var posOrders = this.state.posOrders;
	
	      if (posOrders && posOrders.selectedRows.length > 1) {
	        posOrders.selectedRows.map(function (row) {
	          posOrderIds.push(row.Order_id);
	        });
	      } else {
	        return;
	      }
	      var printUrl = _root_url.ROOT_URL + 'v1/pos/orders/print/' + posOrderIds.join(',') + '?Bearer=' + localStorage.getItem('token');
	      var excelUrl = _root_url.ROOT_URL + 'v1/pos/orders/excel/' + posOrderIds.join(',') + '?Bearer=' + localStorage.getItem('token');
	      return _react2.default.createElement(
	        'div',
	        { className: 'padLeft' },
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            type: 'button',
	            href: printUrl
	          },
	          _react2.default.createElement('em', { className: 'fa fa-print' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            href: excelUrl
	          },
	          _react2.default.createElement('em', { className: 'fa fa-download' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	        )
	      );
	    }
	  }, {
	    key: 'renderPrintReward',
	    value: function renderPrintReward() {
	      var printUrl = _root_url.ROOT_URL + 'v1/pos/print_rewards' + '?Bearer=' + localStorage.getItem('token');
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          href: printUrl
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rewards' })
	      );
	    }
	  }, {
	    key: 'renderExportButton',
	    value: function renderExportButton() {
	      var _props2 = this.props,
	          Status = _props2.Status,
	          FromDate = _props2.FromDate,
	          ToDate = _props2.ToDate,
	          Days = _props2.Days;
	
	      var status = Status === 'all' ? '' : '&SaleStatus=' + Status;
	      var dateRange = Days || -1;
	      var fromDate = FromDate ? this.formatDate(FromDate) : '1900-01-01';
	      var toDate = ToDate ? this.formatDate(ToDate) : '3000-01-01';
	
	      var route = 'posOrders'; // this.props.route.path;
	      var orderType = 'pos_order';
	
	      var exportUrl = _root_url.ROOT_URL + 'v1/sale/' + orderType + '/search/' + dateRange + '/export/?OrderDate__gte=' + fromDate + '&OrderDate__lte=' + toDate + status + '&Bearer=' + localStorage.getItem('token');
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'export-to-excel',
	          href: exportUrl
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'export' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var createDialogStyle = {
	        width: '550px',
	        height: '300px',
	        marginLeft: '-15%'
	      };
	      var graphDialogStyle = {
	        width: '1300px',
	        height: '630px',
	        marginLeft: '-35%',
	        marginTop: "-310px"
	      };
	      var posOrder_id = this.state.posOrders && this.state.posOrders.selectedRows[0] && this.state.posOrders.selectedRows[0].Order_id;
	      posOrder_id = posOrder_id || '';
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pos_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pos_orders' })
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'sales-orders-list' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pos_order_full_table' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { id: 'date-range-picker', className: 'form-horizontal' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 1 },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'filter-title' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_type' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'colon' },
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 11 },
	                      _react2.default.createElement(
	                        'div',
	                        { id: 'statusFilterRadios', className: 'form-horizontal' },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'Status', component: renderStatusRadios })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 1 },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'filter-title' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'colon' },
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 11 },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'Days', component: renderRadios, fetchPosOrdersByDetails: this.fetchPosOrdersByDetails, Days: this.props.Days })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'position-relative table-collapse-fix' },
	                  isEcity && _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex' } },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_customer' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      this.renderCustomers()
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'type' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      this.renderTypes()
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    { className: 'table-buttons' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'default',
	                        type: 'button',
	                        disabled: this.state.posOrders.selectedRows.length !== 1 || !(0, _permissions2.default)('view_pos'),
	                        onClick: function onClick(event) {
	                          _this5.setCurrentPosOrder(event);
	                        }
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-eye' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'view' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'danger',
	                        type: 'button',
	                        disabled: this.shouldVoidButtonDisable() || !(0, _permissions2.default)('add_void_order'),
	                        onClick: function onClick() {
	                          _this5.openCheckAuthorize('void');
	                        }
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-trash' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'void' })
	                    ),
	                    isMMD && _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'success',
	                        type: 'button',
	                        onClick: function onClick() {
	                          _this5.openGraph();
	                        }
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-eye' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'graphical_data' })
	                    ),
	                    isEcity && this.renderPrintReward(),
	                    this.renderExcel(),
	                    this.renderPrintExcel(),
	                    this.renderMultiSelectPrintExcel(),
	                    isTPRO && this.renderRestockExport()
	                  ),
	                  this.renderTable()
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pos_order_details' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'details-table-collapse-fix' },
	                  this.renderProductsTable()
	                )
	              )
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogStyle,
	              isVisible: this.state.checkAuthorizeOpen,
	              onCloseClicked: this.closeCheckAuthorize
	            },
	            _react2.default.createElement(_confirmActionModal2.default, {
	              'case': 'confirmPassword',
	              closeC: this.checkAuthorize,
	              checkPasswordFailure: this.props.checkPasswordFailure
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: graphDialogStyle,
	              isVisible: this.state.graphVisibility,
	              onCloseClicked: function onCloseClicked() {
	                _this5.closeGraph();
	              },
	              title: "POS Data"
	            },
	            _react2.default.createElement(_posGraphModal.POSGraphModal
	            // salesOrderId={singleSalesOrderId}
	            // salesOrderNum={singleSalesOrderNum}
	            // printSalesOrderLabelDSQ={this.props.printSalesOrderLabelDSQ}
	            // singleSalesOrderId={singleSalesOrderId}
	            , { closeGraph: this.closeGraph
	            })
	          )
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return PosOrders;
	}(_react.Component);
	
	PosOrders.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = PosOrders;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/posOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isMMD, 'isMMD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/posOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(getBsStyle, 'getBsStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/posOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isTPRO, 'isTPRO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/posOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(renderRadios, 'renderRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/posOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(renderStatusRadios, 'renderStatusRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/posOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(PosOrders, 'PosOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/posOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/posOrders.jsx');
	}();

	;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _cashOutModal = __webpack_require__(656);
	
	var _cashOutModal2 = _interopRequireDefault(_cashOutModal);
	
	var _logModal = __webpack_require__(660);
	
	var _logModal2 = _interopRequireDefault(_logModal);
	
	var _cleanDates = __webpack_require__(22);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PosReport = function (_Component) {
	  _inherits(PosReport, _Component);
	
	  function PosReport() {
	    _classCallCheck(this, PosReport);
	
	    var _this = _possibleConstructorReturn(this, (PosReport.__proto__ || Object.getPrototypeOf(PosReport)).call(this));
	
	    _this.renderHeader = function (Name, id) {
	      return _react2.default.createElement(
	        'label',
	        { style: _this.state.curRegisterId === id ? { cursor: 'pointer', 'background-color': 'rgb(255, 236, 179)' } : { cursor: 'pointer' } },
	        Name
	      );
	    };
	
	    _this.getSessions = function (id) {
	      var _this$props = _this.props,
	          fetchRegisterSessionsByDate = _this$props.fetchRegisterSessionsByDate,
	          fetchRegisterSessions = _this$props.fetchRegisterSessions;
	      var _this$state = _this.state,
	          FromDate = _this$state.FromDate,
	          ToDate = _this$state.ToDate;
	
	
	      if (id === '') {
	        _this.setState({ curRegisterId: 'All' });
	        if (FromDate && ToDate) {
	          _this.props.fetchAllRegisterSessions(FromDate, ToDate);
	        }
	        return;
	      } else {
	        _this.setState({ curRegisterId: id });
	      }
	
	      if (FromDate && ToDate) {
	        fetchRegisterSessionsByDate(id, FromDate, ToDate);
	      } else {
	        fetchRegisterSessions(id);
	      }
	    };
	
	    _this.handleInputChange = function (event) {
	      var state = _extends({}, _this.state);
	      state[event.target.name] = event.target.value;
	      _this.setState({ state: state });
	    };
	
	    _this.state = {
	      // Track size of window and update grid height
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton,
	
	      // Modal visibility
	      CashOutModalOpen: false,
	      LogModalOpen: false,
	
	      // Hold data to be displayed in report grid
	      report: {
	        filters: {},
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null,
	        startDate: '',
	        endDate: ''
	      },
	
	      // Division that we are searching for
	      division: '',
	
	      // ID if specified
	      divisionID: '',
	
	      type: 'all',
	      salesID: null,
	
	      // Collapse status of the panels
	      openStatus: [],
	
	      // Report totals
	      totalInvoice: 0,
	      totalReturn: 0,
	      totalCredit: 0,
	      grandTotal: 0,
	      rowProps: {},
	      errorState: {
	        message: '',
	        status: ''
	      },
	      curRegisterId: '',
	      session_id: null,
	
	      // Date to print for registers
	      RegistersDate: null,
	      FromDate: null,
	      ToDate: null
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.closeCashOutModal = _this.closeCashOutModal.bind(_this);
	    _this.openCashOutModal = _this.openCashOutModal.bind(_this);
	    _this.closeLogModal = _this.closeLogModal.bind(_this);
	    _this.openLogModal = _this.openLogModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(PosReport, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.fetchRegisters(this.formatDate(new Date()), this.formatDate(new Date()));
	      this.setState({ RegistersDate: new Date(), FromDate: new Date(), ToDate: new Date() });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.handleResize);
	      // this.props.setValue('posReport', 'Days', '1');
	      // this.props.setValue('posReport', 'Types', 'all');
	      // this.props.fetchPosReport(this.state.type, 1, '1900-01-01', this.formatDate(new Date()), this.state.division, this.state.divisionID, this.state.salesID);
	      // this.props.fetchGroups();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.sessions.constructor === Array) {
	        var newRows = [].concat(_toConsumableArray(nextProps.sessions));
	
	        for (var i = 0; i < newRows.length; i++) {
	          var date = new Date(newRows[i].CashInTime);
	          var formattedDate = date.getFullYear() + '-';
	          formattedDate += date.getMonth() + 1 + '-';
	          if (date.getDate() < 10) {
	            formattedDate += '0' + date.getDate();
	          } else {
	            formattedDate += date.getDate();
	          }
	          var CashInTime = '';
	          if (newRows[i].CashInTime) {
	            CashInTime = _moment2.default.utc(newRows[i].CashInTime).local().format('LT');
	            //CashInTime = newRows[i].CashInTime;
	            //CashInTime = CashInTime.substring(CashInTime.indexOf('T') + 1, CashInTime.indexOf('T') + 6);
	          }
	          var CashOutTime = '';
	          if (newRows[i].CashOutTime) {
	            CashOutTime = _moment2.default.utc(newRows[i].CashOutTime).local().format('LT');
	            //CashOutTime = newRows[i].CashOutTime;
	            //CashOutTime = CashOutTime.substring(CashOutTime.indexOf('T') + 1, CashOutTime.indexOf('T') + 6);
	          }
	          newRows[i].Date = formattedDate;
	          newRows[i].NewCashInTime = CashInTime;
	          newRows[i].NewCashOutTime = CashOutTime;
	          var CashInBy = ' ';
	          var CashOutBy = ' ';
	          for (var k = 0; k < newRows[i].SessionLogs.length; k++) {
	            if (newRows[i].SessionLogs[k].IsCashInOrCashOut) {
	              CashInBy = newRows[i].SessionLogs[k].User;
	            } else if (newRows[i].SessionLogs[k].IsCashInOrCashOut !== null) {
	              CashOutBy = newRows[i].SessionLogs[k].User;
	              if (newRows[i].SessionLogs.length === 1) {
	                CashInBy = newRows[i].SessionLogs[k].User;
	              }
	              newRows[i].NeedsVerification = true;
	            }
	            if (newRows[i].Verifier) {
	              newRows[i].NeedsVerification = false;
	            }
	          }
	          newRows[i].CashInBy = CashInBy;
	          newRows[i].CashOutBy = CashOutBy;
	        }
	        this.setState({
	          report: {
	            rows: newRows,
	            selectedRows: [],
	            sortColumn: null,
	            sortDirection: null,
	            startDate: '',
	            endDate: ''
	          }
	        });
	      }
	
	      if (nextProps.sessions.POS_Sessions) {
	        if (nextProps.sessions.POS_Sessions[0]) {
	          for (var _i = 0; _i < nextProps.sessions.POS_Sessions.length; _i++) {
	            // let date = nextProps.sessions.POS_Sessions[0].SessionLogs[i].LogInTime;
	            var _date = new Date(nextProps.sessions.POS_Sessions[_i].CashInTime);
	            var _formattedDate = _date.getFullYear() + '-';
	            _formattedDate += _date.getMonth() + 1 + '-';
	            if (_date.getDate() < 10) {
	              _formattedDate += '0' + _date.getDate();
	            } else {
	              _formattedDate += _date.getDate();
	            }
	            var _CashInTime = '';
	            if (nextProps.sessions.POS_Sessions[_i].CashInTime) {
	              _CashInTime = _moment2.default.utc(nextProps.sessions.POS_Sessions[_i].CashInTime).local().format('LT');
	              //CashInTime = nextProps.sessions.POS_Sessions[i].CashInTime;
	              //CashInTime = CashInTime.substring(CashInTime.indexOf('T') + 1, CashInTime.indexOf('T') + 6);
	            }
	            var _CashOutTime = '';
	            if (nextProps.sessions.POS_Sessions[_i].CashOutTime) {
	              _CashOutTime = _moment2.default.utc(nextProps.sessions.POS_Sessions[_i].CashOutTime).local().format('LT');
	              //CashOutTime = nextProps.sessions.POS_Sessions[i].CashOutTime;
	              //CashOutTime = CashOutTime.substring(CashOutTime.indexOf('T') + 1, CashOutTime.indexOf('T') + 6);
	            }
	            nextProps.sessions.POS_Sessions[_i].Date = _formattedDate;
	            nextProps.sessions.POS_Sessions[_i].NewCashInTime = _CashInTime;
	            nextProps.sessions.POS_Sessions[_i].NewCashOutTime = _CashOutTime;
	            var _CashInBy = ' ';
	            var _CashOutBy = ' ';
	            for (var _k = 0; _k < nextProps.sessions.POS_Sessions[_i].SessionLogs.length; _k++) {
	              if (nextProps.sessions.POS_Sessions[_i].SessionLogs[_k].IsCashInOrCashOut) {
	                _CashInBy = nextProps.sessions.POS_Sessions[_i].SessionLogs[_k].User;
	              } else if (nextProps.sessions.POS_Sessions[_i].SessionLogs[_k].IsCashInOrCashOut !== null) {
	                _CashOutBy = nextProps.sessions.POS_Sessions[_i].SessionLogs[_k].User;
	                if (nextProps.sessions.POS_Sessions[_i].SessionLogs.length === 1) {
	                  _CashInBy = nextProps.sessions.POS_Sessions[_i].SessionLogs[_k].User;
	                }
	                nextProps.sessions.POS_Sessions[_i].NeedsVerification = true;
	              }
	              if (nextProps.sessions.POS_Sessions[_i].Verifier) {
	                nextProps.sessions.POS_Sessions[_i].NeedsVerification = false;
	              }
	            }
	            nextProps.sessions.POS_Sessions[_i].CashInBy = _CashInBy;
	            nextProps.sessions.POS_Sessions[_i].CashOutBy = _CashOutBy;
	          }
	          this.setState({
	            report: {
	              rows: nextProps.sessions.POS_Sessions,
	              selectedRows: [],
	              sortColumn: null,
	              sortDirection: null,
	              startDate: '',
	              endDate: ''
	            }
	          });
	        } else {
	          this.setState({
	            report: {
	              rows: [],
	              selectedRows: [],
	              sortColumn: null,
	              sortDirection: null,
	              startDate: '',
	              endDate: ''
	            }
	          });
	        }
	      } else {
	        if (this.state.curRegisterId && this.state.FromDate && this.state.ToDate && !Array.isArray(nextProps.sessions)) {
	          this.props.fetchRegisterSessionsByDate(this.state.curRegisterId, this.state.FromDate, this.state.ToDate);
	        } else if (this.state.curRegisterId && !Array.isArray(nextProps.sessions)) {
	          this.props.fetchRegisterSessions(this.state.curRegisterId);
	        }
	      }
	      if (nextProps.posReport && nextProps.posReport !== this.props.posReport) {
	        var report = _extends({}, this.state.report, { rows: nextProps.posReport });
	        var grandTotal = 0;
	        var totalInvoice = 0;
	
	        report.rows.map(function (row) {
	          row.Date = row.FromDate.substring(0, 10) + ' to ' + row.EndDate.substring(0, 10);
	          grandTotal += row.GrandTotal;
	          totalInvoice += row.InvoiceAmount;
	          row.GrandTotal = _this2.format(row.GrandTotal.toFixed(2));
	          row.InvoiceAmount = _this2.format(row.InvoiceAmount.toFixed(2));
	          row.GrandTotal = "$" + row.GrandTotal;
	        });
	        this.setState({ report: report, grandTotal: grandTotal, totalInvoice: totalInvoice });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.oneLineButton });
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      if (date == null) {
	        date = new Date();
	      }
	      var formattedDate = date.getFullYear() + '-';
	
	      formattedDate += date.getMonth() + 1 + '-';
	      if (date.getDate() < 10) {
	        formattedDate += '0' + date.getDate();
	      } else {
	        formattedDate += date.getDate();
	      }
	
	      return formattedDate;
	    }
	  }, {
	    key: 'format',
	    value: function format(num) {
	      var n = num.toString();
	      var p = n.indexOf('.');
	      return n.replace(/\d(?=(?:\d{3})+(?:\.|$))/g, function ($0, i) {
	        return p < 0 || i < p ? $0 + ',' : $0;
	      });
	    }
	  }, {
	    key: 'getAmountSummary',
	    value: function getAmountSummary(props) {
	      if (props === null || props === []) {
	        return {};
	      }
	      var summary = {
	        transactions: props.Transactions,
	        totalCashAmount: props.TotalCashAmount,
	        creditCards: props.CreditCards,
	        checks: props.Checks,
	        storeCredit: props.StoreCredit,
	        totalPaidOut: props.TotalPaidOut,
	        totalNetSale: props.TotalNetSale,
	        salesTax: props.SalesTax,
	        totalSale: props.TotalSale
	      };
	      return summary;
	    }
	  }, {
	    key: 'closeCashOutModal',
	    value: function closeCashOutModal() {
	      this.setState({ CashOutModalOpen: false });
	    }
	  }, {
	    key: 'openCashOutModal',
	    value: function openCashOutModal(rowProps) {
	      this.setState({ CashOutModalOpen: true, rowProps: rowProps });
	    }
	  }, {
	    key: 'closeLogModal',
	    value: function closeLogModal() {
	      this.setState({ LogModalOpen: false });
	    }
	  }, {
	    key: 'openLogModal',
	    value: function openLogModal(rowProps) {
	      this.setState({ LogModalOpen: true, rowProps: rowProps });
	    }
	  }, {
	    key: 'renderReportTable',
	    value: function renderReportTable() {
	      var _this3 = this;
	
	      if (this.props.sessionsIsLoading && !this.props.sessionsError) {
	        return _react2.default.createElement(
	          'div',
	          { id: 'spinner' },
	          _react2.default.createElement(_spinner2.default, null)
	        );
	      } else if (this.props.sessionsError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.posReportError)
	          )
	        );
	      }
	
	      // Parameters of the react-data-grid
	      var tableHeight = window.innerHeight < 930 ? 572 : 572;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.report);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this3.state.report, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this3.setState({ report: state });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this3.state.report.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var report = _extends({}, _this3.state.report, { filters: newFilters });
	        _this3.setState({ report: report });
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        var rows = getRows();
	        Object.assign(rows[e.rowIdx], e.updated);
	        var report = _extends({}, _this3.state.report, { rows: rows });
	        _this3.setState({ report: report });
	      };
	
	      // Handle the row select function
	      var onRowSelect = function onRowSelect(rows) {
	        var report = _extends({}, _this3.state.report, { selectedRows: rows });
	        _this3.setState({ report: report });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = [].concat(_toConsumableArray(_this3.state.report.rows));
	        var selectedRows = _this3.state.report.selectedRows;
	
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	
	        selectedRows = [rows.row];
	        newRows[rows[0].rowIdx].isSelected = true;
	        var report = _extends({}, _this3.state.report, { rows: newRows, selectedRows: selectedRows });
	        _this3.setState({ report: report, session_id: rows[0].row.Session_id });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = [].concat(_toConsumableArray(_this3.state.report.rows));
	        newRows.map(function (row) {
	          row.isSelected = false;
	        });
	        var selectedRows = [];
	        var report = _extends({}, _this3.state.report, { rows: newRows, selectedRows: selectedRows });
	        _this3.setState({ report: report, session_id: null });
	      };
	
	      var that = this;
	
	      var verifyFormatter = _react2.default.createClass({
	        displayName: 'verifyFormatter',
	        render: function render() {
	          var _this4 = this;
	
	          return this.props.dependentValues.NeedsVerification ? _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                className: 'textAlignStyle',
	                style: { height: '23px', width: '39px', padding: '0px' },
	                onClick: function onClick() {
	                  /*
	                  var ProductNum = this.props.dependentValues.ProductNum;
	                  that.removeRow(ProductNum);
	                  */
	                  that.openCashOutModal(_this4.props.dependentValues);
	                }
	              },
	              'Verify'
	            )
	          ) : _react2.default.createElement(
	            'span',
	            null,
	            this.props.dependentValues.Verifier ? this.props.dependentValues.Verifier : ''
	          );
	        }
	      });
	
	      var logFormatter = _react2.default.createClass({
	        displayName: 'logFormatter',
	        render: function render() {
	          var _this5 = this;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                className: 'textAlignStyle',
	                style: { height: '23px', width: '39px', padding: '0px' },
	                onClick: function onClick() {
	                  that.openLogModal(_this5.props.dependentValues);
	                }
	              },
	              'View'
	            )
	          );
	        }
	      });
	
	      var showBalanceFormatter = _react2.default.createClass({
	        displayName: 'showBalanceFormatter',
	        render: function render() {
	          return _react2.default.createElement(
	            'span',
	            null,
	            this.props.dependentValues.Verifier ? this.props.dependentValues.Balance : ''
	          );
	        }
	      });
	
	      var showCountFormatter = _react2.default.createClass({
	        displayName: 'showCountFormatter',
	        render: function render() {
	          return _react2.default.createElement(
	            'span',
	            null,
	            this.props.dependentValues.Verifier ? this.props.dependentValues.Transactions : ''
	          );
	        }
	      });
	
	      var columns = [{
	        key: 'POSRegister_id',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reg' }),
	        width: 40,
	        resizable: true,
	        sortable: true
	      }, {
	        key: 'Session_id',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'id' }),
	        width: 25,
	        resizable: true,
	        sortable: true,
	        editable: true
	      }, {
	        key: 'Date',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        editable: true
	      }, {
	        key: 'NewCashInTime',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'in' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        editable: true
	      }, {
	        key: 'CashInBy',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'in_by' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        editable: true
	      }, {
	        key: 'NewCashOutTime',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'out' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        editable: true
	      }, {
	        key: 'CashOutBy',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'out_by' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        editable: true
	      }, {
	        key: 'StartingCash',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cash_in' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        editable: true
	      }, {
	        key: 'Transactions',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_count' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        editable: true,
	        formatter: showCountFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'TotalCashAmount',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_cash' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        editable: true
	      }, {
	        key: 'CreditCards',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_card' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        editable: true
	      }, {
	        key: 'Checks',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'by_check' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        editable: true
	      }, {
	        key: 'StoreCredit',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'store_credit' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        editable: true
	      }, {
	        key: 'TotalPaidOut',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'returns' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        editable: true
	      }, {
	        key: 'TotalNetSale',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_sale' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        editable: true
	      }, {
	        key: 'SalesTax',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_tax' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        editable: true
	      }, {
	        key: 'TotalSale',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_sale' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        editable: true
	      }, {
	        key: 'Balance',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'balance' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        editable: true,
	        formatter: showBalanceFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'Verifier',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'verifier' }),
	        width: 80,
	        resizable: true,
	        sortable: true,
	        editable: true,
	        formatter: verifyFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'ViewLogs',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'logs' }),
	        resizable: true,
	        sortable: true,
	        editable: true,
	        formatter: logFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { id: 'PosReport-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              onGridSort: handleGridSort,
	              onAddFilter: handleFilterChange,
	              enableRowSelect: 'single',
	              columns: columns,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              rowHeight: 25,
	              headerRowHeight: 45,
	              minHeight: tableHeight,
	              onRowUpdated: handleRowUpdated,
	              onRowSelect: onRowSelect,
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              }
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderRegisters',
	    value: function renderRegisters() {
	      var _this6 = this;
	
	      if (!this.props.registers) return;
	      var registers = this.props.registers;
	      var num = -1;
	      return registers.map(function (registers) {
	        num += 1;
	        var index = num;
	        return _react2.default.createElement(_reactBootstrap.Panel, { className: 'panelStyle', style: { cursor: 'pointer' }, key: index, onClick: function onClick() {
	            _this6.getSessions(_this6.props.registers[index].Register_id);
	          }, header: _this6.renderHeader(_this6.props.registers[index].Name, _this6.props.registers[index].Register_id) });
	      });
	    }
	  }, {
	    key: 'renderRegistersHeader',
	    value: function renderRegistersHeader() {
	      var _this7 = this;
	
	      var Today = new Date();
	      return _react2.default.createElement(_DateTimePicker2.default, {
	        id: 'all-register-datepicker',
	        format: 'MM-DD-YY',
	        max: Today,
	        onChange: function onChange(e) {
	          _this7.setState({ RegistersDate: e });
	        },
	        time: false,
	        value: this.state.RegistersDate
	      });
	    }
	  }, {
	    key: 'renderPrintAllReportsButton',
	    value: function renderPrintAllReportsButton() {
	      var _toFromDates = (0, _cleanDates.toFromDates)(-1, this.state.RegistersDate, this.state.RegistersDate),
	          fromDate = _toFromDates.fromDate,
	          toDate = _toFromDates.toDate;
	
	      var url = _root_url.ROOT_URL + 'v1/pos/print/register_daily_report/?CashInTime__gte=' + fromDate + '&CashInTime__lte=' + toDate + '&Bearer=' + localStorage.getItem('token');
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          style: { marginBottom: '10px', marginTop: '2px' },
	          disabled: this.state.RegistersDate === '' || this.state.RegistersDate === null,
	          href: url
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_daily_report' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var CashOutModalTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'counted_amount_report' });
	      var CashOutModalStyle = {
	        height: '500px',
	        width: '1000px',
	        marginLeft: '-28%',
	        marginTop: '-20%'
	      };
	      var LogModalTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'log_report' });
	      var LogModalStyle = {
	        height: '400px',
	        width: '1000px',
	        marginLeft: '-28%',
	        marginTop: '-20%'
	      };
	
	      var url = _root_url.ROOT_URL + '/v1/pos/print/activities_log/' + this.state.session_id + '?Bearer=' + localStorage.getItem('token');
	      var printTransactionsUrl = _root_url.ROOT_URL + '/v1/pos/print/transactions/' + this.state.session_id + '?Bearer=' + localStorage.getItem('token');
	
	      var summary = this.getAmountSummary(this.props.sessions);
	
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'POS_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pos_report' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'pos-report' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { id: 'date-range-picker' },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 2 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 4 },
	                    _react2.default.createElement(
	                      'h3',
	                      { className: 'filter-title' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'colon' },
	                        ':'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 8 },
	                    this.renderRegistersHeader()
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 1 },
	                  this.renderPrintAllReportsButton()
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 2, className: 'category-nav-panel' },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { id: 'category-nav', className: 'panelStyle', style: { overflow: 'visible' } },
	                  _react2.default.createElement(_reactBootstrap.Panel, {
	                    className: 'panelStyle',
	                    key: 0,
	                    onClick: function onClick() {
	                      _this8.getSessions('');
	                    },
	                    header: this.renderHeader('All', 'All')
	                  }),
	                  this.renderRegisters()
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 10 },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { id: 'reports-panel' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      { id: 'date-range-picker' },
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 2 },
	                        _react2.default.createElement(
	                          'h3',
	                          { className: 'filter-title' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cash_in_time' }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'colon' },
	                            ':'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 10 },
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          null,
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 3 },
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(_DateTimePicker2.default, {
	                                id: 'from-datepicker',
	                                format: 'MM-DD-YY',
	                                onChange: function onChange(e) {
	                                  if (e > _this8.state.ToDate) {
	                                    return;
	                                  }
	                                  _this8.setState({ FromDate: e }, function () {
	                                    if (_this8.state.curRegisterId === 'All') {
	                                      _this8.props.fetchAllRegisterSessions(_this8.state.FromDate, _this8.state.ToDate);
	                                      return;
	                                    }
	                                    _this8.getSessions(_this8.state.curRegisterId, _this8.state.FromDate, _this8.state.ToDate);
	                                  });
	                                },
	                                max: this.state.ToDate,
	                                time: false,
	                                value: this.state.FromDate
	                              })
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(_DateTimePicker2.default, {
	                                id: 'to-datepicker',
	                                format: 'MM-DD-YY',
	                                onChange: function onChange(e) {
	                                  if (e < _this8.state.FromDate) {
	                                    return;
	                                  }
	                                  _this8.setState({ ToDate: e }, function () {
	                                    if (_this8.state.curRegisterId === 'All') {
	                                      _this8.props.fetchAllRegisterSessions(_this8.state.FromDate, _this8.state.ToDate);
	                                      return;
	                                    }
	                                    _this8.getSessions(_this8.state.curRegisterId, _this8.state.FromDate, _this8.state.ToDate);
	                                  });
	                                },
	                                min: this.state.FromDate,
	                                time: false,
	                                value: this.state.ToDate
	                              })
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                          _reactBootstrap.Button,
	                          {
	                            bsStyle: 'primary',
	                            style: { marginBottom: '10px' },
	                            disabled: this.state.report.selectedRows.length === 0,
	                            href: url
	                          },
	                          _react2.default.createElement('em', { className: 'fa fa-print' }),
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_session_report' })
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Button,
	                          {
	                            bsStyle: 'primary',
	                            style: { marginBottom: '10px', marginLeft: '10px' },
	                            disabled: this.state.report.selectedRows.length === 0,
	                            href: printTransactionsUrl
	                          },
	                          _react2.default.createElement('em', { className: 'fa fa-print' }),
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_transactions' })
	                        )
	                      )
	                    ),
	                    this.renderReportTable()
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { className: 'form-horizontal' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2, className: 'vertical-divider' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_count' })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 8 },
	                        _react2.default.createElement(_reactBootstrap.Input, { type: 'text', disabled: true, value: summary.transactions })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 10 },
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 3 },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-xs-6' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cash' })
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(_reactBootstrap.Input, { type: 'text', disabled: true, value: summary.totalCashAmount })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 3 },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-xs-6' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'card' })
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(_reactBootstrap.Input, { type: 'text', disabled: true, value: summary.creditCards })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 3 },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-xs-6' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check' })
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(_reactBootstrap.Input, { type: 'text', disabled: true, value: summary.checks })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 3 },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-xs-6' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit' })
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(_reactBootstrap.Input, { type: 'text', disabled: true, value: summary.storeCredit })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 3 },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-xs-6' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'returns' })
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(_reactBootstrap.Input, { type: 'text', disabled: true, value: summary.totalPaidOut })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 3 },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-xs-6' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_sale' })
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(_reactBootstrap.Input, { type: 'text', disabled: true, value: summary.totalNetSale })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 3 },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-xs-6' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_tax' })
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(_reactBootstrap.Input, { type: 'text', disabled: true, value: summary.salesTax })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 3 },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-xs-6' },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_sale' })
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(_reactBootstrap.Input, { type: 'text', disabled: true, value: summary.totalSale })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: CashOutModalStyle,
	              isVisible: this.state.CashOutModalOpen,
	              title: CashOutModalTitle,
	              onCloseClicked: function onCloseClicked() {
	                _this8.closeCashOutModal();
	              }
	            },
	            _react2.default.createElement(_cashOutModal2.default, { rowProps: this.state.rowProps, finishedSubmit: this.closeCashOutModal, curRegisterId: this.state.curRegisterId })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: LogModalStyle,
	              isVisible: this.state.LogModalOpen,
	              title: LogModalTitle,
	              onCloseClicked: function onCloseClicked() {
	                _this8.closeLogModal();
	              }
	            },
	            _react2.default.createElement(_logModal2.default, { rowProps: this.state.rowProps })
	          )
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return PosReport;
	}(_react.Component);
	
	PosReport.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = PosReport;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PosReport, 'PosReport', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/posReport.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/posReport.jsx');
	}();

	;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _lodash = __webpack_require__(19);
	
	var _root_url = __webpack_require__(9);
	
	var _constants = __webpack_require__(11);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _numberWithCommas = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(5),
	    _require$Draggable = _require.Draggable,
	    DraggableContainer = _require$Draggable.Container,
	    RowActionsCell = _require$Draggable.RowActionsCell,
	    DropTargetRowContainer = _require$Draggable.DropTargetRowContainer,
	    Selectors = _require.Data.Selectors;
	
	var PreOrder = function (_Component) {
	  _inherits(PreOrder, _Component);
	
	  function PreOrder() {
	    _classCallCheck(this, PreOrder);
	
	    var _this = _possibleConstructorReturn(this, (PreOrder.__proto__ || Object.getPrototypeOf(PreOrder)).call(this));
	
	    _this.state = {
	      breadcrumbTitle: 'pre_order',
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.fiveLineButton,
	      preOrders: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      salesOrderDetail: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      rowsCount: 0,
	      total: 0,
	      canceledOrders: 0,
	      canceledTotal: 0
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    return _this;
	  }
	
	  _createClass(PreOrder, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.console.log('componentDidMount');
	      window.addEventListener('resize', this.handleResize);
	      document.title = _root_url.companyCodeTitle;
	      this.props.fetchPreOrders();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.console.log('componentWillUnmount');
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      window.console.log('componentWillReceiveProps', nextProps);
	      if (nextProps.preOrders && nextProps.preOrders !== this.props.preOrders) {
	        // Split Weight
	        if (this.state.preOrders.selectedRows && this.state.preOrders.selectedRows.length === 1) {
	          nextProps.preOrders.Orders.map(function (orders) {
	            if (orders.Shiporder_id === _this2.state.preOrders.selectedRows[0].Shiporder_id) {
	              _this2.state.preOrders.selectedRows[0].FinalShippingWeight = orders.FinalShippingWeight;
	            }
	          });
	        }
	        this.setState({ total: nextProps.preOrders.Rows });
	
	        var preOrders = _extends({}, this.state.preOrders, {
	          rows: nextProps.preOrders.Orders,
	          filters: {}
	        });
	        var selectedRows0 = preOrders.selectedRows[0];
	        if (selectedRows0) {
	          for (var i = 0; i < preOrders.rows.length; i++) {
	            if (selectedRows0.Shiporder_id === preOrders.rows[i].Shiporder_id) {
	              preOrders.rows[i].isSelected = true;
	            }
	          }
	        }
	
	        var salesOrderDetail = _extends({}, this.state.salesOrderDetail, { rows: [] });
	        this.setState({ preOrders: preOrders, salesOrderDetail: salesOrderDetail });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      window.console.log('shouldComponentUpdate', nextProps, nextState);
	      return true;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      window.console.log('shouldComponentUpdate', prevProps, prevState);
	      if (prevState.preOrders !== this.state.preOrders) {
	        var canceledTotal = 0;
	        var canceledOrders = this.state.preOrders.rows.filter(function (row) {
	          var match = row.SaleStatus === "Canceled";
	          if (match) {
	            canceledTotal += row.FinalPrice;
	          }
	          return match;
	        });
	        this.setState({
	          rowsCount: _reactDataGridAddons.Data.Selectors.getRows(this.state.preOrders).length,
	          canceledOrders: canceledOrders.length,
	          canceledTotal: canceledTotal
	        });
	      }
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      this.setState({
	        tableHeight: window.innerHeight - _constants.UI_HEIGHT.fiveLineButton
	      });
	    }
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this3 = this;
	
	      var route = this.context.router.routes[1].path;
	      // Parameters of the react-data-grid
	      var tableHeight = window.innerHeight < 930 ? 270 : 270;
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.preOrders);
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        _this3.state.total = 0;
	        for (var i = 0; i < rows.length; i++) {
	          _this3.state.total += rows[i].FinalPrice;
	        }
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this3.state.preOrders, {
	          sortColumn: sortColumn,
	          sortDirection: sortDirection
	        });
	        if (state.sortColumn === 'OrderDateDisplay') {
	          state.sortColumn = 'OrderDate';
	        }
	
	        if (state.sortDirection === 'ASC') {
	          _this3.state.pullSheetSort = state.sortColumn;
	        } else if (state.sortDirection === 'DESC') {
	          _this3.state.pullSheetSort = '-' + state.sortColumn;
	        } else {
	          _this3.state.pullSheetSort = '';
	        }
	        _this3.setState({ preOrders: state });
	      };
	
	      var handleFilterChange = (0, _lodash.debounce)(function (filter) {
	        _this3.state.total = 0;
	        _this3.state.preOrders.rows = _this3.props.preOrders.Orders;
	        _this3.state.preOrders.selectedRows = [];
	        var newFilters = Object.assign({}, _this3.state.preOrders.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var preOrders = _extends({}, _this3.state.preOrders, { filters: newFilters });
	        _this3.setState({ preOrders: preOrders });
	      }, 500, { maxWait: 800 });
	
	      // Handle the row select function
	      var onRowClick = function onRowClick(rowIdx, row) {
	        if (rowIdx !== -1) {
	          var rows = getRows();
	          /* Multi row select on row click
	            let selectedRows = [...this.state.preOrders.selectedRows];
	             let id = rows[rowIdx].SalesOrder_id;
	            let idx = selectedRows.indexOf(id);
	            if (idx == -1) {
	              rows[rowIdx].isSelected = true;
	              selectedRows.push(id);
	            } else {
	              rows[rowIdx].isSelected = false;
	              selectedRows.splice(idx, 1);
	            }
	          */
	
	          /* Single row select on row click */
	          rows.map(function (r) {
	            r.isSelected = false;
	          });
	          var selectedRows = [rows[rowIdx]];
	          rows[rowIdx].isSelected = true;
	
	          var preOrders = _extends({}, _this3.state.preOrders, { rows: rows, selectedRows: selectedRows });
	          _this3.setState({ preOrders: preOrders });
	          // this.props.fetchSalesOrderDetail(row.SalesOrder_id, route);
	        }
	      };
	
	      // Custom Formatter component
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            // const dateMap = [
	            //   'Jan',
	            //   'Feb',
	            //   'Mar',
	            //   'Apr',
	            //   'May',
	            //   'Jun',
	            //   'Jul',
	            //   'Aug',
	            //   'Sep',
	            //   'Oct',
	            //   'Nov',
	            //   'Dec',
	            // ];
	            var date = new Date(this.props.value);
	            // const index = dateMap.indexOf(date.toString().slice(4, 3));
	            // const localDate = index + date.toString().slice(8, 6);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      // Column difinition
	      var columns = [{
	        key: 'Order_Num',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 113
	      }, {
	        key: 'Note',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 124
	      }, {
	        key: 'PaaymentAmount',
	        name: 'Payment Amount',
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'TotalPrice',
	        name: 'Total Price',
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'Ref_file',
	        name: 'Ref File',
	        resizable: true,
	        sortable: true,
	        width: 160,
	        filterable: true
	      }, {
	        key: 'OrderStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PaymentStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_status' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: 'company_name_or_phone',
	        name: 'Company Name Or Phone',
	        resizable: true,
	        sortable: true,
	        width: 130,
	        filterable: true
	      }, {
	        key: 'tracking_number',
	        name: 'Tracking Number',
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: 'request_time',
	        name: 'Request Time',
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: 'create_time',
	        name: 'Create Time',
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true,
	        formatter: DateFormatter
	      }];
	
	      var generateColumns = function generateColumns() {
	        return columns;
	      };
	      return (
	        // React Table Sales Order History Table
	        _react2.default.createElement(
	          'div',
	          { id: 'TNMSOTable' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'div',
	                { id: 'preOrders-dataGrid1' },
	                _react2.default.createElement(_reactDataGrid2.default, {
	                  rowKey: 'Shiporder_id',
	                  ref: function ref(g) {
	                    _this3.grid = g;
	                  },
	                  onGridSort: handleGridSort,
	                  toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                  onAddFilter: handleFilterChange,
	                  columns: generateColumns(),
	                  rowHeight: 25,
	                  headerRowHeight: 45,
	                  rowGetter: rowGetter,
	                  rowsCount: getSize(),
	                  minHeight: tableHeight,
	                  enableRowSelect: 'multi',
	                  rowSelection: {
	                    showCheckbox: true,
	                    enableShiftSelect: true,
	                    selectBy: {
	                      isSelectedKey: 'isSelected'
	                    }
	                  },
	                  onRowClick: onRowClick
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 2 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'row-count' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_orders' }),
	                    ':\xA0',
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'font-color-orange', id: 'row-count-equation' },
	                      this.state.rowsCount + ' - ' + this.state.canceledOrders + ' = ' + (this.state.rowsCount - this.state.canceledOrders)
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 6 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'grand-total' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'grand-total-label' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'grand_total' }),
	                      ':\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'font-color-grey', id: 'total-equation' },
	                      '$' + (0, _numberWithCommas.numberWithCommas)((this.state.total || 0).toFixed(2)) + ' - $' + (0, _numberWithCommas.numberWithCommas)((this.state.canceledTotal || 0).toFixed(2)) + ' = $' + (0, _numberWithCommas.numberWithCommas)((this.state.total - this.state.canceledTotal).toFixed(2))
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mso-footnotes' },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_total_orders_equation' })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_grand_total_equation' })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: this.state.breadcrumbTitle })
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'sales-orders-list' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  {
	                    className: 'position-relative table-collapse-fix',
	                    id: 'table-collapse-fix-450',
	                    style: { marginBottom: '0px' }
	                  },
	                  this.renderTable()
	                )
	              )
	            ),
	            ' ',
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_details' })
	                ),
	                _react2.default.createElement(_reactBootstrap.Panel, { className: 'details-table-collapse-fix' })
	              )
	            ),
	            ' '
	          )
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return PreOrder;
	}(_react.Component);
	
	PreOrder.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = PreOrder;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PreOrder, 'PreOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/preOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/preOrders.jsx');
	}();

	;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reactChartjs = __webpack_require__(86);
	
	var _time = __webpack_require__(83);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _purchaseQuoteModal = __webpack_require__(76);
	
	var _purchaseQuoteModal2 = _interopRequireDefault(_purchaseQuoteModal);
	
	var _favoriteModal = __webpack_require__(75);
	
	var _favoriteModal2 = _interopRequireDefault(_favoriteModal);
	
	var _datePicker = __webpack_require__(27);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SalesDashboard = function (_Component) {
	    _inherits(SalesDashboard, _Component);
	
	    function SalesDashboard() {
	        _classCallCheck(this, SalesDashboard);
	
	        var _this = _possibleConstructorReturn(this, (SalesDashboard.__proto__ || Object.getPrototypeOf(SalesDashboard)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.fourLineButton,
	
	            createReturnOpen: false,
	            createQuoteOpen: false,
	            createFavoriteOpen: false,
	            availableBins: 0,
	            totalBins: 0,
	            totalInvoice: 0,
	            totalReturn: 0,
	            totalOpen: 0,
	            totalDelay: 0,
	
	            orderSchedules: {
	                rows: [],
	                allRows: [],
	                setDate: null,
	                selectedRows: null,
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            creditLines: {
	                rows: [],
	                allRows: [],
	                setDate: null,
	                selectedRows: null,
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            POs: {
	                rows: [],
	                allRows: [],
	                setDate: null,
	                selectedRows: null,
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            SOs: {
	                rows: [],
	                allRows: [],
	                setDate: null,
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            zones: {
	                rows: [],
	                allRows: [],
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            inventories: {
	                rows: [],
	                selectedRows: null,
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            favorites: {
	                rows: [],
	                selectedRows: null,
	                sortColumn: null,
	                sortDirection: null
	            }
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	
	        _this.openReturnCreate = _this.openReturnCreate.bind(_this);
	        _this.closeReturnCreate = _this.closeReturnCreate.bind(_this);
	        _this.openQuoteCreate = _this.openQuoteCreate.bind(_this);
	        _this.closeQuoteCreate = _this.closeQuoteCreate.bind(_this);
	        _this.openFavoriteCreate = _this.openFavoriteCreate.bind(_this);
	        _this.closeFavoriteCreate = _this.closeFavoriteCreate.bind(_this);
	        _this.addFavorite = _this.addFavorite.bind(_this);
	        return _this;
	    }
	
	    _createClass(SalesDashboard, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchSalesDashboardDetail();
	            this.props.fetchWarehouseSalesOrders(1);
	            this.props.fetchWarehousePurchaseOrders(1);
	            this.props.fetchWarehouseBins(1);
	
	            this.props.fetchCustomerCreditByDate('');
	            this.props.fetchCustomerOrderSchedules();
	            this.props.fetchSalesOrders();
	            // this.setState({totalReturn: nextProps.salesInvoices.length})
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once products are ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.customerCreditLines && nextProps.customerCreditLines != this.props.customerCreditLines) {
	                var newCreditLines = _extends({}, this.state.creditLines, { rows: nextProps.customerCreditLines });
	                this.setState({ creditLines: newCreditLines });
	            }
	
	            if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
	                var inventories = _extends({}, this.state.inventories, { rows: nextProps.inventories });
	                this.setState({ inventories: inventories });
	            }
	
	            if (nextProps.favorites && nextProps.favorites != this.props.favorites) {
	                var favorites = _extends({}, this.state.favorites, { rows: nextProps.favorites });
	                this.setState({ favorites: favorites });
	            }
	
	            if (nextProps.warehouseBinsDetail && nextProps.warehouseBinsDetail != this.props.warehouseBinsDetail) {
	                var totalAvailable = 0;
	                var totalWarehouseBins = 0;
	                nextProps.warehouseBinsDetail.Warehouse_Zone.map(function (zone) {
	                    totalAvailable += zone.AvailableBin;
	                    totalWarehouseBins += zone.TotalBin;
	                });
	
	                var zones = _extends({}, this.state.zones, { rows: nextProps.warehouseBinsDetail.Warehouse_Zone });
	                this.setState({ zones: zones, availableBins: totalAvailable, totalBins: totalWarehouseBins });
	            }
	
	            if (nextProps.customerOrderSchedules && nextProps.customerOrderSchedules != this.props.customerOrderSchedules) {
	                var orderSchedules = _extends({}, this.state.orderSchedules, { rows: nextProps.customerOrderSchedules });
	                this.setState({ orderSchedules: orderSchedules });
	            }
	
	            if (nextProps.orderScheduleDate && nextProps.orderScheduleDate != this.props.orderScheduleDate) {
	                console.log(nextProps.orderScheduleDate);
	                this.props.fetchCustomerOrderSchedulesByDate(this.formatDate(nextProps.orderScheduleDate));
	                this.props.fetchCustomerCreditByDate(this.formatDate(nextProps.orderScheduleDate));
	            }
	
	            if (nextProps.dashboardSalesDetail && nextProps.dashboardSalesDetail != this.props.dashboardSalesDetail) {
	                var totalInvoice = 0;
	                var totalReturn = 0;
	                var totalOpen = 0;
	                var totalDelay = 0;
	                totalInvoice = nextProps.dashboardSalesDetail.TotalReleased;
	                totalReturn = nextProps.dashboardSalesDetail.TotalReturn;
	                totalOpen = nextProps.dashboardSalesDetail.TotalOpen;
	                totalDelay = nextProps.dashboardSalesDetail.TotalDelay;
	
	                this.setState({ totalInvoice: totalInvoice, totalDelay: totalDelay, totalReturn: totalReturn, totalOpen: totalOpen });
	            }
	        }
	    }, {
	        key: 'formatDate',
	        value: function formatDate(date) {
	            var monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	
	            if (date) {
	                var month = String(date).slice(4, 7);
	                var day = String(date).slice(8, 10);
	                var year = String(date).slice(11, 15);
	
	                var chosenDateFormatted = '';
	                if (parseInt(monthShortNames.indexOf(month) + 1) < 10) {
	                    chosenDateFormatted = chosenDateFormatted + '0' + (monthShortNames.indexOf(month) + 1) + day;
	                } else {
	                    chosenDateFormatted = chosenDateFormatted + (monthShortNames.indexOf(month) + 1) + day;
	                }
	                chosenDateFormatted = chosenDateFormatted + year;
	                console.log(chosenDateFormatted);
	                return chosenDateFormatted;
	            }
	            return null;
	        }
	    }, {
	        key: 'openQuoteCreate',
	        value: function openQuoteCreate() {
	            this.setState({ createQuoteOpen: true });
	        }
	    }, {
	        key: 'openFavoriteCreate',
	        value: function openFavoriteCreate() {
	            this.setState({ createFavoriteOpen: true });
	        }
	    }, {
	        key: 'closeQuoteCreate',
	        value: function closeQuoteCreate() {
	            this.setState({ createQuoteOpen: false });
	        }
	    }, {
	        key: 'closeFavoriteCreate',
	        value: function closeFavoriteCreate() {
	            this.setState({ createFavoriteOpen: false });
	        }
	    }, {
	        key: 'openReturnCreate',
	        value: function openReturnCreate() {
	            this.setState({ createReturnOpen: true });
	        }
	    }, {
	        key: 'closeReturnCreate',
	        value: function closeReturnCreate() {
	            this.setState({ createReturnOpen: false });
	        }
	    }, {
	        key: 'addFavorite',
	        value: function addFavorite(newFavorite) {
	            var newRow = {
	                Product_id: newFavorite.id,
	                ProductNum: newFavorite.ProductNum,
	                RefNum: newFavorite.ProductNum,
	                PreSale: newFavorite.PreSale,
	                InStock: newFavorite.InStock,
	                Ordered: newFavorite.Purchased,
	                Price: newFavorite.RefPurchasingPrice,
	                ProductName: newFavorite.ProductNum.Name
	            };
	            if (newFavorite.Product) {
	                newRow.ProductName = newFavorite.Product["Name"];
	            }
	
	            var preRows = this.state.favorites.rows;
	            preRows.push(newRow);
	            var favorites = _extends({}, this.state.favorites, { rows: preRows });
	            this.setState({ favorites: favorites });
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.fourLineButton });
	        }
	
	        // Set product being selected to be currentProduct and navigate user to the edit page
	
	    }, {
	        key: 'setCurrentPurchaseOrder',
	        value: function setCurrentPurchaseOrder(e) {
	            e.preventDefault();
	            var currentPurchaseOrder = this.state.selectedRows[0];
	            this.props.resetCurrentPurchaseOrder();
	            this.props.selectPurchaseOrder(currentPurchaseOrder);
	            this.context.router.push('/purchaseOrder/' + currentPurchaseOrder.PurchaseOrder_id);
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            this.props.resetCurrentPurchaseOrder();
	            this.context.router.push('/purchaseOrder/new');
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable table.
	
	    }, {
	        key: 'renderCustomerOrderSchedule',
	        value: function renderCustomerOrderSchedule() {
	            var _this2 = this;
	
	            if (this.props.customerOrderSchedulesIsLoading && !this.props.customerOrderSchedulesError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.customerOrderSchedulesError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.customerOrderSchedulesError)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.orderSchedules);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var POs = _extends({}, _this2.state.POs, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this2.setState({ POs: POs });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var POs = _extends({}, _this2.state.POs, { selectedRows: rows });
	                    _this2.setState({ POs: POs });
	                };
	
	                //Custom Formatter component
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNameFormatter = _react2.default.createClass({
	                    displayName: 'VendorNameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNumFormatter = _react2.default.createClass({
	                    displayName: 'VendorNumFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.VendorNum
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'CustomerID',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_id' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 70
	                }, {
	                    key: 'Name',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120
	                }, {
	                    key: 'Description',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120
	                }, {
	                    key: 'Contact',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'contact' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80
	                }, {
	                    key: 'Phone',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' }),
	                    resizable: true,
	                    sortable: true,
	                    formatter: DateFormatter, //fixed
	                    width: 80
	                }, {
	                    key: 'OrderStatus',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_status' }),
	                    resizable: true,
	                    sortable: true
	                }];
	
	                return (
	                    //React Table Customer Order Schedule
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                'div',
	                                { id: 'SalesDashboard-dataGrid1' },
	                                _react2.default.createElement(_reactDataGrid2.default, {
	                                    rowKey: 'DispatchStop_id',
	                                    onGridSort: handleGridSort,
	                                    columns: columns,
	                                    rowGetter: rowGetter,
	                                    rowsCount: getSize(),
	                                    minHeight: this.state.tableHeight,
	                                    rowHeight: 25,
	                                    onRowSelect: onRowSelect })
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderCustomerReport',
	        value: function renderCustomerReport() {
	            var _this3 = this;
	
	            if (this.props.customerCreditLinesIsLoading && !this.props.customerCreditLinesError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.customerCreditLinesError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.customerCreditLinesError)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.creditLines);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var creditLines = _extends({}, _this3.state.creditLines, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this3.setState({ creditLines: creditLines });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var creditLines = _extends({}, _this3.state.creditLines, { selectedRows: rows });
	                    _this3.setState({ creditLines: creditLines });
	                };
	
	                //Custom Formatter component
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNameFormatter = _react2.default.createClass({
	                    displayName: 'VendorNameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNumFormatter = _react2.default.createClass({
	                    displayName: 'VendorNumFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.VendorNum
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'Customer_id',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_id' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true,
	                    width: 70
	                }, {
	                    key: 'CurrentAmount',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'PassedDue',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'passed_due' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }, {
	                    key: 'CreditLimit',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit_limit' }),
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }];
	
	                return (
	                    //React Table Customer Credit Report
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                'div',
	                                { id: 'SalesDashboard-dataGrid2' },
	                                _react2.default.createElement(_reactDataGrid2.default, {
	                                    rowKey: 'Customer_id',
	                                    onGridSort: handleGridSort,
	                                    columns: columns,
	                                    rowGetter: rowGetter,
	                                    rowsCount: getSize(),
	                                    minHeight: this.state.tableHeight,
	                                    rowHeight: 25,
	                                    onRowSelect: onRowSelect })
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderZonesTable',
	        value: function renderZonesTable() {
	            var _this4 = this;
	
	            if (this.props.SOIsLoading && !this.props.SOError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.SOError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.SOError)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.zones);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var zones = _extends({}, _this4.state.zones, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this4.setState({ zones: zones });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var zones = _extends({}, _this4.state.zones, { selectedRows: rows });
	                    _this4.setState({ zones: zones });
	                };
	
	                //Custom Formatter component
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNameFormatter = _react2.default.createClass({
	                    displayName: 'VendorNameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNumFormatter = _react2.default.createClass({
	                    displayName: 'VendorNumFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.VendorNum
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'WarehouseZone_id',
	                    name: 'Zone ID',
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'AvailableBin',
	                    name: 'Bins Available',
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'TotalBin',
	                    name: 'Total Bins',
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }];
	
	                return (
	                    //React Table
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                'div',
	                                { id: 'SalesDashboard-dataGrid3' },
	                                _react2.default.createElement(_reactDataGrid2.default, {
	                                    rowKey: 'WarehouseZone_id',
	                                    onGridSort: handleGridSort,
	                                    columns: columns,
	                                    rowGetter: rowGetter,
	                                    rowsCount: getSize(),
	                                    minHeight: this.state.tableHeight,
	                                    rowHeight: 25,
	                                    onRowSelect: onRowSelect })
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderInventoryTable',
	        value: function renderInventoryTable() {
	            var _this5 = this;
	
	            if (this.props.favoritesAreLoading && !this.props.favoritesError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.favoritesError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.favoritesError)
	                )
	            );else {
	                // Parameters of the react-data-grid
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this5.state.favorites);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var favorites = _extends({}, _this5.state.favorites, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this5.setState({ favorites: favorites });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var favorites = _extends({}, _this5.state.favorites, { selectedRows: rows });
	                    _this5.setState({ favorites: favorites });
	                };
	
	                //Custom Formatter component
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNameFormatter = _react2.default.createClass({
	                    displayName: 'VendorNameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNumFormatter = _react2.default.createClass({
	                    displayName: 'VendorNumFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.VendorNum
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120,
	                    filterable: true
	                }, {
	                    key: 'PreSale',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'presale' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true
	                }, {
	                    key: 'InStock',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'stock' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80
	                }, {
	                    key: 'Ordered',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80
	                }, {
	                    key: 'Price',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 75
	                }];
	
	                return (
	                    //React Table
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(
	                                'div',
	                                { id: 'SalesDashboard-dataGrid4' },
	                                _react2.default.createElement(_reactDataGrid2.default, {
	                                    rowKey: 'Product_id',
	                                    onGridSort: handleGridSort,
	                                    columns: columns,
	                                    rowGetter: rowGetter,
	                                    rowsCount: getSize(),
	                                    minHeight: this.state.tableHeight,
	                                    rowHeight: 25,
	                                    enableRowSelect: 'multi',
	                                    onRowSelect: onRowSelect })
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderOrderScheduleDatePicker',
	        value: function renderOrderScheduleDatePicker(handleSubmit) {
	            return _react2.default.createElement(
	                'form',
	                { onSubmit: handleSubmit },
	                _react2.default.createElement(_reduxForm.Field, { name: 'OrderScheduleDate', component: _datePicker.DatePicker })
	            );
	        }
	    }, {
	        key: 'renderNumSalesOrdersOpen',
	        value: function renderNumSalesOrdersOpen() {
	            if (this.props.dashboardSalesDetailIsLoading && !this.props.dashboardSalesDetailError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.dashboardSalesDetailError) {
	                return _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'alert alert-danger' },
	                        JSON.stringify(this.props.dashboardSalesDetailError)
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'dash-number' },
	                    this.state.totalOpen
	                );
	            }
	        }
	    }, {
	        key: 'renderNumInvoicesNotFinalized',
	        value: function renderNumInvoicesNotFinalized() {
	            if (this.props.dashboardSalesDetailIsLoading && !this.props.dashboardSalesDetailError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.dashboardSalesDetailError) {
	                return _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'alert alert-danger' },
	                        JSON.stringify(this.props.dashboardSalesDetailError)
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'dash-number' },
	                    this.state.totalInvoice
	                );
	            }
	        }
	    }, {
	        key: 'renderNumReturns',
	        value: function renderNumReturns() {
	            if (this.props.dashboardSalesDetailIsLoading && !this.props.dashboardSalesDetailError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.dashboardSalesDetailError) {
	                return _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'alert alert-danger' },
	                        JSON.stringify(this.props.dashboardSalesDetailError)
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'dash-number' },
	                    this.state.totalReturn
	                );
	            }
	        }
	    }, {
	        key: 'renderTotalDelay',
	        value: function renderTotalDelay() {
	            if (this.props.dashboardSalesDetailIsLoading && !this.props.dashboardSalesDetailError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.dashboardSalesDetailError) {
	                return _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'alert alert-danger' },
	                        JSON.stringify(this.props.dashboardSalesDetailError)
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'dash-number' },
	                    this.state.totalDelay
	                );
	            }
	        }
	    }, {
	        key: 'getWarehouseOptions',
	        value: function getWarehouseOptions() {
	            var warehouseOptions = [];
	            this.props.warehouses.map(function (warehouse) {
	                warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name });
	            });
	            return warehouseOptions;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                numPurchaseQuotes = _props.numPurchaseQuotes;
	
	            var height = (this.state.tableHeight + 85).toString();
	            var tableCollapseFix = { height: height };
	            var warehouseOptions = this.getWarehouseOptions();
	
	            var data = [{ color: "#97ddf0", label: "test1", value: 2 }, { color: "#fafafa", label: "test2", value: 1 }];
	
	            var options = {
	                animateRotate: true
	            };
	
	            var createDialogStyle = {
	                width: '600px',
	                marginLeft: '-10%'
	            };
	
	            var custOrderHeader = _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 8 },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_orders_scheduled' })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 4 },
	                    this.renderOrderScheduleDatePicker(handleSubmit)
	                )
	            );
	
	            var SalesOrderRateHeader = _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_order_rate' })
	            );
	            var panelHeader = _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_orders_today' })
	            );
	            var custCreditReport = _react2.default.createElement(
	                'h4',
	                { className: 'pb' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_credit_report' })
	            );
	
	            return (
	                //---------------
	                // Begin HTML
	                //---------------
	                _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            { active: 'true' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_dashboard' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Grid,
	                        { id: 'sales-dashboard', fluid: 'true' },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_dashboard' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(_time2.default, null),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5ths' },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/salesOrders' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel widget' },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'row-table' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 5, className: 'bg-blue' },
	                                                this.renderNumSalesOrdersOpen()
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 7 },
	                                                _react2.default.createElement(
	                                                    'h3',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'open_sales_orders' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5ths' },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/salesInvoice' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel widget' },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'row-table' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 5, className: 'bg-red' },
	                                                this.renderNumInvoicesNotFinalized()
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 7 },
	                                                _react2.default.createElement(
	                                                    'h3',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'none_finalized_invoices' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5ths' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'panel widget' },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        { className: 'row-table' },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 5, className: 'bg-yellow' },
	                                            this.renderTotalDelay()
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 7 },
	                                            _react2.default.createElement(
	                                                'h3',
	                                                null,
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delayed_sales_orders' })
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-5ths' },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/inventoryReturn' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel widget' },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            { className: 'row-table' },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 5, className: 'bg-green' },
	                                                this.renderNumReturns()
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 7 },
	                                                _react2.default.createElement(
	                                                    'h3',
	                                                    null,
	                                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'returned_sales_orders' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        ' ',
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'success',
	                                    type: 'button',
	                                    href: '/salesOrders/new' },
	                                _react2.default.createElement('em', { className: 'fa fa-money' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_new_sale_order' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'warning',
	                                    type: 'button',
	                                    href: '/customerReturn' },
	                                _react2.default.createElement('em', { className: 'fa fa-backward' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'process_sales_return' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'primary',
	                                    type: 'button',
	                                    onClick: function onClick(event) {
	                                        _this6.props.fetchSalesCSV(event);
	                                    } },
	                                _react2.default.createElement('em', { className: 'fa fa-edit' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'generate_sales_csv_file' })
	                            )
	                        ),
	                        ' ',
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { header: custOrderHeader, style: tableCollapseFix },
	                                    this.renderCustomerOrderSchedule()
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { header: custCreditReport, style: tableCollapseFix },
	                                    this.renderCustomerReport()
	                                )
	                            )
	                        ),
	                        ' '
	                    ),
	                    _react2.default.createElement(
	                        _reactSkylight.SkyLightStateless,
	                        { dialogStyles: createDialogStyle, isVisible: this.state.createQuoteOpen, onCloseClicked: function onCloseClicked() {
	                                _this6.closeQuoteCreate();
	                            }, title: 'Create a Purchase Quote' },
	                        _react2.default.createElement(_purchaseQuoteModal2.default, { closeC: this.closeQuoteCreate })
	                    ),
	                    _react2.default.createElement(
	                        _reactSkylight.SkyLightStateless,
	                        { dialogStyles: createDialogStyle, isVisible: this.state.createFavoriteOpen, onCloseClicked: function onCloseClicked() {
	                                _this6.closeFavoriteCreate();
	                            }, title: 'Create a new Favorite' },
	                        _react2.default.createElement(_favoriteModal2.default, { closeC: this.closeFavoriteCreate, closeA: this.addFavorite })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SalesDashboard;
	}(_react.Component);
	
	SalesDashboard.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = SalesDashboard;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(SalesDashboard, 'SalesDashboard', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesDashboard.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesDashboard.jsx');
	}();

	;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxForm = __webpack_require__(3);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _filterByStart = __webpack_require__(68);
	
	var _filterByStart2 = _interopRequireDefault(_filterByStart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ESCAPE_KEY = 27;
	var ENTER_KEY = 13;
	
	var SalesInventoryInfo = function (_Component) {
	  _inherits(SalesInventoryInfo, _Component);
	
	  function SalesInventoryInfo() {
	    _classCallCheck(this, SalesInventoryInfo);
	
	    var _this = _possibleConstructorReturn(this, (SalesInventoryInfo.__proto__ || Object.getPrototypeOf(SalesInventoryInfo)).call(this));
	
	    _this.state = {
	      rows: [],
	      sortColumn: null,
	      sortDirection: null,
	      clickedCell: { row: 0, column: -1 }
	    };
	    _this.onCellSelected = _this.onCellSelected.bind(_this);
	    return _this;
	  }
	
	  _createClass(SalesInventoryInfo, [{
	    key: 'handleKeyDown',
	    value: function handleKeyDown(event) {
	      switch (event.keyCode) {
	        case ESCAPE_KEY:
	          this.props.closeShowInventory('productSearch');
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      document.addEventListener("keydown", this.handleKeyDown.bind(this));
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener("keydown", this.handleKeyDown.bind(this));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.setAllProductQuantity(1);
	      console.log('this.props', this.props);
	      this.props.fetchSalesInventoryInfo(this.props.Customer_id, this.props.SearchType, this.props.SearchValue);
	      _reactDom2.default.findDOMNode(this.refs["inventoryInfo"].refs.base.refs.viewPortContainer).focus();
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.salesInventoryInfo && nextProps.salesInventoryInfo != this.props.salesInventoryInfo) {
	        var rows = [].concat(_toConsumableArray(nextProps.salesInventoryInfo));
	        this.setState({ rows: rows });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevProps.salesInventoryInfo && prevProps.salesInventoryInfo != 0 && prevProps.salesInventoryInfo != this.props.salesInventoryInfo) {
	        _reactDom2.default.findDOMNode(this.refs["inventoryInfo"].refs.base.refs.viewPortContainer).focus();
	      }
	    }
	  }, {
	    key: 'onCellSelected',
	    value: function onCellSelected(coordinates) {
	      var clickedCell = {
	        row: coordinates.rowIdx,
	        column: coordinates.idx - 1
	      };
	      this.setState({ clickedCell: clickedCell });
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this2 = this;
	
	      if (this.props.salesInventoryInfoIsLoading && !this.props.salesInventoryInfoError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.salesInventoryInfoError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.salesInventoryInfoError)
	        )
	      );else {
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        var onDoubleClick = function onDoubleClick(rowProps) {
	          if (_this2.props.inventoryItemTwo == true) {
	            _this2.props.selectInventoryInfo(rowProps);
	            _this2.props.closeShowInventory('quantity');
	            return;
	          }
	
	          if (_this2.props.formName) {
	            if (_this2.props.formName === 'favoriteList') {
	              _this2.props.selectInventoryInfo(rowProps);
	              _this2.props.closeShowInventory('quantity');
	              return;
	            }
	            _this2.props.selectInventoryInfo(rowProps);
	            // this.props.setSaleRowValue(`${rowProps.ProductNum} | ${rowProps.Name} | ${rowProps.Description}`, this.props.formName, rowProps);
	            _this2.props.setSaleRowValue(rowProps.ProductNum + ' | ' + rowProps.Name + ' | ' + rowProps.Description, _this2.props.formName, rowProps);
	            _this2.props.closeShowInventory('quantity');
	          } else if (_this2.props.Customer_id != 0) {
	            _this2.props.selectInventoryInfo(rowProps);
	            _this2.props.setSaleRowValue(rowProps.ProductNum + ' | ' + rowProps.Name + ' | ' + rowProps.Description, 'salesOrderForm', rowProps);
	            _this2.props.fetchItemSalesHistory(_this2.props.Customer_id, rowProps.Product_id);
	            _this2.props.closeShowInventory('quantity');
	          } else {
	            _this2.props.selectInventoryInfo(rowProps);
	            _this2.props.setPromoRowValue(rowProps.ProductNum + ' | ' + rowProps.Name + ' | ' + rowProps.Description, 'promotionForm');
	            _this2.props.closeShowInventory('quantity');
	          }
	        };
	
	        var RowRenderer = _react2.default.createClass({
	          displayName: 'RowRenderer',
	
	
	          PropTypes: {
	            onDoubleClick: _react2.default.PropTypes.func
	          },
	
	          render: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	              'div',
	              { onDoubleClick: function onDoubleClick() {
	                  _this3.props.onDoubleClick(_this3.props.row);
	                } },
	              _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	            );
	          }
	        });
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this2.setState(state);
	        };
	
	        // Handle the row select function
	
	        var onRowSelect = function onRowSelect(rows) {
	          _this2.setState({ selectedRows: rows });
	        };
	
	        var onKeyDown = function onKeyDown(e) {
	          if (e.keyCode === ENTER_KEY) {
	
	            e.preventDefault();
	            var rows = _this2.state.rows;
	            var row = rows[_this2.state.clickedCell.row];
	
	            if (_this2.props.inventoryItemTwo == true) {
	              _this2.props.selectInventoryInfo(row);
	              _this2.props.closeShowInventory('quantity');
	              return;
	            }
	
	            if (_this2.props.formName) {
	              if (_this2.props.formName === 'favoriteList') {
	                _this2.props.selectInventoryInfo(row);
	                _this2.props.closeShowInventory('quantity');
	                return;
	              }
	              _this2.props.selectInventoryInfo(row);
	              _this2.props.setSaleRowValue(row.ProductNum + ' | ' + row.Name + ' | ' + row.Description, _this2.props.formName, row);
	              // this.props.setSaleFavoriteRowValue(`${row.ProductNum} | ${row.Name} | ${row.Description}`, this.props.formName, row);
	              _this2.props.closeShowInventory('quantity');
	            } else if (_this2.props.Customer_id != 0) {
	              _this2.props.selectInventoryInfo(row);
	              _this2.props.setSaleRowValue(row.ProductNum + ' | ' + row.Name + ' | ' + row.Description, 'salesOrderForm', row);
	              _this2.props.fetchItemSalesHistory(_this2.props.Customer_id, row.Product_id);
	              _this2.props.closeShowInventory('quantity');
	            } else {
	              _this2.props.selectInventoryInfo(row);
	              _this2.props.setPromoRowValue(row.ProductNum + ' | ' + row.Name + ' | ' + row.Description, 'promotionForm', row);
	              _this2.props.closeShowInventory('quantity');
	            }
	          }
	          // else if (e.keyCode === 27) {
	          //   e.preventDefault();
	          //   this.props.closeShowInventory('productSearch');
	          // }
	        };
	
	        var columns = [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterRenderer: _filterByStart2.default
	        }, {
	          key: 'RefNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	          resizable: true,
	          sortable: true,
	          width: 70,
	          filterable: true,
	          filterRenderer: _filterByStart2.default
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	          resizable: true,
	          sortable: true
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	          resizable: true,
	          sortable: true
	        }, {
	          key: 'Price',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	          resizable: true,
	          sortable: true,
	          width: 70
	        }, {
	          key: 'MeasureUnit',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	          resizable: true,
	          sortable: true,
	          width: 80
	        }, {
	          key: 'InStock',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'instock' }),
	          resizable: true,
	          sortable: true,
	          width: 80
	        }, {
	          key: 'Purchased',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchased' }),
	          resizable: true,
	          sortable: true,
	          width: 100
	        }, {
	          key: 'PreSale',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'presale' }),
	          resizable: true,
	          sortable: true,
	          width: 80
	        }];
	
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              { id: 'SalesInventoryInfo-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                ref: 'inventoryInfo',
	                rowKey: 'Product_id',
	                rowHeight: 25,
	                minHeight: 600,
	                onGridSort: handleGridSort,
	                headerRowHeight: 45,
	                columns: columns,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                enableCellSelect: true,
	                rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: onDoubleClick }),
	                onGridKeyDown: onKeyDown,
	                onCellSelected: this.onCellSelected
	              })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        this.renderTable()
	      );
	    }
	  }]);
	
	  return SalesInventoryInfo;
	}(_react.Component);
	
	var _default = SalesInventoryInfo;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ESCAPE_KEY, 'ESCAPE_KEY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesInventoryInfo.jsx');
	
	  __REACT_HOT_LOADER__.register(ENTER_KEY, 'ENTER_KEY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesInventoryInfo.jsx');
	
	  __REACT_HOT_LOADER__.register(SalesInventoryInfo, 'SalesInventoryInfo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesInventoryInfo.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesInventoryInfo.jsx');
	}();

	;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactCsv = __webpack_require__(200);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ctRowRenderer = __webpack_require__(267);
	
	var _ctRowRenderer2 = _interopRequireDefault(_ctRowRenderer);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _datePicker = __webpack_require__(27);
	
	var _inputField = __webpack_require__(16);
	
	var _selection = __webpack_require__(21);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _percentFormatter = __webpack_require__(97);
	
	var _percentFormatter2 = _interopRequireDefault(_percentFormatter);
	
	var _numberWithCommas = __webpack_require__(35);
	
	var _salesInvoiceExport = __webpack_require__(501);
	
	var _cleanDates = __webpack_require__(22);
	
	var _GenericDatePicker = __webpack_require__(48);
	
	var _GenericDatePicker2 = _interopRequireDefault(_GenericDatePicker);
	
	var _genericRadioFilter = __webpack_require__(50);
	
	var _genericRadioFilter2 = _interopRequireDefault(_genericRadioFilter);
	
	var _TypeRadios = __webpack_require__(57);
	
	var _TypeRadios2 = _interopRequireDefault(_TypeRadios);
	
	var _root_url = __webpack_require__(9);
	
	var _GenericProductSuggest = __webpack_require__(51);
	
	var _GenericProductSuggest2 = _interopRequireDefault(_GenericProductSuggest);
	
	var _PrintIframe = __webpack_require__(63);
	
	var _PrintIframe2 = _interopRequireDefault(_PrintIframe);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _dateFilterRadios = __webpack_require__(49);
	
	var _dateFilterRadios2 = _interopRequireDefault(_dateFilterRadios);
	
	var _VerifyPasscodeModal = __webpack_require__(115);
	
	var _VerifyPasscodeModal2 = _interopRequireDefault(_VerifyPasscodeModal);
	
	var _PaymentMethodModal = __webpack_require__(168);
	
	var _PaymentMethodModal2 = _interopRequireDefault(_PaymentMethodModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isTN = _root_url.ROOT_API_URL === "https://tn-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://tn-scm.truckxi.com/api/";
	var isEcity = _root_url.ROOT_API_URL === 'https://dev-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/';
	var isHMM = _root_url.ROOT_API_URL === 'https://hmm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://hmm-scm.truckxi.com/api/';
	var getBsStyle = function getBsStyle(input, value) {
	  return input === value ? 'success' : 'primary';
	};
	
	var renderRadios = function renderRadios(props) {
	  var renderStartDatePicker = function renderStartDatePicker(days) {
	    if (days === -1) {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: 'primary', disabled: props.fetching },
	        _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', placeholder: 'Start', component: _datePicker.DatePicker })
	      );
	    }
	    return _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: 'primary', disabled: props.fetching },
	      _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', placeholder: 'Start', component: _datePicker.DisabledDatePicker })
	    );
	  };
	  var renderEndDatePicker = function renderEndDatePicker(days) {
	    if (days === -1) {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: 'primary', disabled: props.fetching },
	        _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', placeholder: 'End', component: _datePicker.DatePicker })
	      );
	    }
	    return _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: 'primary', disabled: props.fetching },
	      _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', placeholder: 'End', component: _datePicker.DisabledDatePicker })
	    );
	  };
	  if (props.page === 'salesInvoice') {
	    return _react2.default.createElement(
	      _reactBootstrap.ButtonToolbar,
	      { className: 'radio-filter-buttons' },
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: getBsStyle(props.input.value, '1'), disabled: props.fetching },
	        _react2.default.createElement(
	          'div',
	          { className: 'radio' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'today-radio-filter' },
	            _react2.default.createElement('input', _extends({}, props.input, { id: 'today-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '1', onClick: function onClick() {
	                props.fetchSalesInvoicesByDetails('1');
	              }, checked: props.input.value === '1' })),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'today' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: getBsStyle(props.input.value, '7'), disabled: props.fetching },
	        _react2.default.createElement(
	          'div',
	          { className: 'radio' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'sevenDay-radio-filter' },
	            _react2.default.createElement('input', _extends({}, props.input, { id: 'sevenDay-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '7', onClick: function onClick() {
	                props.fetchSalesInvoicesByDetails('7');
	              }, checked: props.input.value === '7' })),
	            '7 ',
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: getBsStyle(props.input.value, '30'), disabled: props.fetching },
	        _react2.default.createElement(
	          'div',
	          { className: 'radio' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'thirtyDay-radio-filter' },
	            _react2.default.createElement('input', _extends({}, props.input, { id: 'thirtyDay-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '30', onClick: function onClick() {
	                props.fetchSalesInvoicesByDetails('30');
	              }, checked: props.input.value === '30' })),
	            '30 ',
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: getBsStyle(props.input.value, '90'), disabled: props.fetching },
	        _react2.default.createElement(
	          'div',
	          { className: 'radio' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'ninetyDay-radio-filter' },
	            _react2.default.createElement('input', _extends({}, props.input, { id: 'ninetyDay-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '90', onClick: function onClick() {
	                props.fetchSalesInvoicesByDetails('90');
	              }, checked: props.input.value === '90' })),
	            '90 ',
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: getBsStyle(props.input.value, ' -1'), disabled: props.fetching },
	        _react2.default.createElement(
	          'div',
	          { className: 'radio' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'dateRange-radio-filter' },
	            _react2.default.createElement('input', _extends({}, props.input, { id: 'dateRange-radio-filter', type: 'radio', name: 'dateFilterRadios', value: '-1', checked: props.input.value === '-1' })),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date_range' })
	          )
	        )
	      ),
	      renderStartDatePicker(props.Days),
	      renderEndDatePicker(props.Days)
	    );
	  }
	  // return (
	  // <ButtonToolbar className="radio-filter-buttons">
	  //   {renderStartDatePicker(props.Days)}
	  //   {renderEndDatePicker(props.Days)}
	  //   <Button
	  //     bsStyle="primary"
	  //     className="search-btn"
	  //     type="submit"
	  //     onClick={() => { props.fetchSalesInvoicesByDetails(); }}
	  //     disabled={props.fetching}
	  //   >
	  //     <em className="fa fa-search" />
	  //   </Button>
	  // </ButtonToolbar>
	  // );
	};
	
	var renderTypeRadios = function renderTypeRadios(props) {
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'all'), disabled: props.fetching },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'all-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'all-radio-filter', type: 'radio', name: 'typeFilterRadios', value: 'all', checked: props.input.value === 'all' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'invoices'), disabled: props.fetching },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'invoices-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'invoices-radio-filter', type: 'radio', name: 'typeFilterRadios', value: 'invoices', checked: props.input.value === 'invoices' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'returns'), disabled: props.fetching },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'returns-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'returns-radio-filter', type: 'radio', name: 'typeFilterRadios', value: 'returns', checked: props.input.value === 'returns' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'returns' })
	        )
	      )
	    )
	  );
	};
	
	var renderStatusRadios = function renderStatusRadios(props) {
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'radio-filter-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'all'), disabled: props.fetching },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'all-status-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'all-status-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'all', checked: props.input.value === 'all' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'Released'), disabled: props.fetching },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'released-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'released-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'Released', checked: props.input.value === 'Released' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'released' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'Finalized'), disabled: props.fetching },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'finalized-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'finalized-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'Finalized', checked: props.input.value === 'Finalized' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'finalized' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: getBsStyle(props.input.value, 'Void'), disabled: props.fetching },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'void-radio-filter' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'void-radio-filter', type: 'radio', name: 'statusFilterRadios', value: 'Void', checked: props.input.value === 'Void' })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'void' })
	        )
	      )
	    )
	  );
	};
	
	var today = (0, _moment2.default)().format('YYYY-MM-DD');
	
	var SalesInvoice = function (_Component) {
	  _inherits(SalesInvoice, _Component);
	
	  _createClass(SalesInvoice, null, [{
	    key: 'getFromDate',
	    value: function getFromDate() {
	      var date = new Date();
	      date.setDate(date.getDate() - 7);
	      return date;
	    }
	  }]);
	
	  function SalesInvoice() {
	    _classCallCheck(this, SalesInvoice);
	
	    var _this = _possibleConstructorReturn(this, (SalesInvoice.__proto__ || Object.getPrototypeOf(SalesInvoice)).call(this));
	
	    _this.handleOptionChange = function (changeEvent) {
	      _this.setState({ productSearchType: changeEvent.target.value });
	    };
	
	    _this.handleVerifyPassocdeModalClose = function (confirmed) {
	      if (confirmed) {
	        _this.voidSalesInvoices();
	      }
	      _this.closeVerifyPasscode();
	    };
	
	    _this.handleSOPaymentMethodSaved = function (so_id, method) {
	      var salesOrderRows = [].concat(_toConsumableArray(_this.state.salesInvoices.rows));
	      var newRows = salesOrderRows.map(function (row) {
	        if (row.SalesOrder_id === so_id) {
	          return _extends({}, row, {
	            PaymentType: method
	          });
	        }
	        return row;
	      });
	      _this.setState({
	        salesInvoices: _extends({}, _this.state.salesInvoices, {
	          rows: newRows
	        })
	      });
	      _this.closePaymentMethodModal();
	    };
	
	    _this.openCheckAuthorize = function (action) {
	      if (isEcity) {
	        _this.openVerifyPasscode();
	        return;
	      }
	      _this.props.clearCheckPassword();
	      _this.setState({ checkAuthorizeOpen: true, action: action });
	    };
	
	    _this.closeCheckAuthorize = function () {
	      _this.setState({ checkAuthorizeOpen: false });
	    };
	
	    _this.checkAuthorize = function (password) {
	      _this.props.checkPassword(password);
	    };
	
	    _this.openVerifyPasscode = function () {
	      _this.setState({
	        verifyPasscodeOpen: true
	      });
	    };
	
	    _this.closeVerifyPasscode = function () {
	      _this.setState({
	        verifyPasscodeOpen: false
	      });
	    };
	
	    _this.shouldVoidButtonDisable = function () {
	      var selectedRows = _this.state.salesInvoices.selectedRows;
	
	      // Always disable void if selected more than 1 row
	
	      if (selectedRows.length !== 1) {
	        return true;
	      }
	
	      var status = selectedRows[0] ? selectedRows[0].SaleStatus : 'disable';
	      if (status === 'disable') {
	        return true;
	      }
	      var disabled = status !== 'Released' && status !== 'Open';
	      return disabled;
	    };
	
	    _this.setCurrentSalesInvoice = function (e) {
	      e.preventDefault();
	      if (_root_url.isRivera) {
	        _this.props.setConfirmPasscodeModalVisibility(true);
	        return;
	      }
	      _this.setCurrentSalesInvoiceAndRedirect();
	    };
	
	    _this.fetchSalesInvoicesByDatePickerSearch = function () {
	      var seller = _this.props.Seller ? _this.props.Seller.value : undefined;
	      var status = _this.state.statusRadios === 'all' ? null : _this.state.statusRadios;
	      _this.props.fetchSalesInvoices(_this.props.OrderFilter + '/', _this.state.fromDate, _this.state.toDate, null, -1, status, seller, _this.state.filterProductID);
	    };
	
	    _this.setToRangeSearch = function () {
	      _this.setState({ days: '-1' });
	    };
	
	    _this.fetchSalesInvoicesByDetails = function (days) {
	      if (_this.state.filteredByItem) {
	        _this.setState({ days: days }, function () {
	          _this.fetchSalesInvoicesByProduct(_this.state.filterProductID);
	        });
	        return;
	      }
	      var dateRange = -1;
	      var FromDate = '2016-01-01';
	      var ToDate = today;
	      var status = _this.props.StatusFilter;
	      var seller = void 0;
	      if (_this.props.Seller) {
	        seller = _this.props.Seller.value;
	      }
	      if (status === 'all') {
	        status = null;
	      }
	      if (_this.state.fromDate != null) {
	        FromDate = _this.formatDate(_this.state.fromDate);
	      }
	
	      if (_this.state.toDate != null) {
	        ToDate = _this.formatDate(_this.state.toDate);
	      }
	
	      if (days != null) {
	        dateRange = days;
	      }
	
	      if (days === '-1' || days === -1) {
	        _this.setState({ days: days }, function () {
	          _this.props.fetchSalesInvoices(_this.props.OrderFilter + "/", FromDate, ToDate, null, dateRange, status, seller);
	        });
	      } else {
	        _this.setState({ days: days, fromDate: undefined, toDate: undefined }, function () {
	          _this.props.fetchSalesInvoices(_this.props.OrderFilter + "/", FromDate, ToDate, null, dateRange, status, seller);
	        });
	      }
	    };
	
	    _this.fetchSalesInvoicesByProduct = function (productID) {
	      var dateRange = -1;
	      var FromDate = '1900-01-01';
	      var ToDate = today;
	      var route = _this.context.router.routes[1].path;
	      var status = _this.props.StatusFilter;
	      var productNum = productID;
	      var seller = void 0;
	      if (_this.props.Seller) {
	        seller = _this.props.Seller.value;
	      }
	      if (_this.state.fromDate != null) {
	        FromDate = _this.formatDate(_this.state.fromDate);
	      }
	      if (_this.state.toDate != null) {
	        ToDate = _this.formatDate(_this.state.toDate);
	      }
	      if (_this.state.days != null) {
	        dateRange = _this.state.days;
	      }
	      if (_this.props.Seller) {
	        seller = _this.props.Seller.value;
	      }
	      if (status === 'all') {
	        status = null;
	      }
	      _this.setState({ filteredByItem: true, selectedRows: [{}], filterProductID: productID });
	      _this.props.fetchSalesInvoices(_this.props.OrderFilter + "/", FromDate, ToDate, null, dateRange, status, seller, productID);
	    };
	
	    _this.voidSalesInvoices = function () {
	      // FromDate, ToDate, OrderFilter, and StatusFilter are needed for the two different Sales Invoices pages
	      var FromDate = _this.context.router.routes[1].path === 'salesInvoice' ? _this.state.fromDate : _this.state.fromDate;
	      var ToDate = _this.context.router.routes[1].path === 'salesInvoice' ? _this.state.toDate : _this.state.toDate;
	      var OrderFilter = _this.context.router.routes[1].path === 'salesInvoice' ? _this.props.OrderFilter : _this.state.typeRadios;
	      var StatusFilter = _this.context.router.routes[1].path === 'salesInvoice' ? _this.props.StatusFilter : _this.state.statusRadios;
	      if (StatusFilter === 'all') {
	        StatusFilter = null;
	      }
	      var seller = _this.props.Seller ? _this.props.Seller.value : undefined;
	      var pk = _this.state.salesInvoices.selectedRows && _this.state.salesInvoices.selectedRows.length === 1 && _this.state.salesInvoices.selectedRows[0].SalesInvoice_id;
	      var returnpk = _this.state.salesInvoices.selectedRows && _this.state.salesInvoices.selectedRows.length === 1 && _this.state.salesInvoices.selectedRows[0].SalesReturn_id;
	      if (pk) {
	        _this.state.salesInvoices.selectedRows.map(function (row) {
	          _this.props.voidInvoice(row.SalesInvoice_id).then(function () {
	            _this.props.fetchSalesInvoices(OrderFilter + '/', FromDate, ToDate, null, _this.props.Days, StatusFilter, seller, _this.state.filterProductID);
	          });
	        });
	      } else if (returnpk) {
	        _this.state.salesInvoices.selectedRows.map(function (row) {
	          _this.props.voidReturn(row.SalesReturn_id).then(function () {
	            _this.props.fetchSalesInvoices(OrderFilter + '/', FromDate, ToDate, null, _this.props.Days, StatusFilter, _this.props.Seller, _this.state.filterProductID);
	          });
	        });
	      }
	    };
	
	    _this.salesInvoiceIFrameIsLoaded = function () {
	      _this.setState({ PdfFrameLoaded: true });
	    };
	
	    _this.salesReturnIFrameIsLoaded = function () {
	      _this.setState({ PdfFrameLoadedReturns: true });
	    };
	
	    _this.salesInvoiceIFrameIsLoaded = function () {
	      if (!_this.state.PdfFrameLoaded) {
	        var pdfFrame = window.frames.salesInvoicePdf;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this.setState({ PdfFrameLoaded: true });
	      }
	    };
	
	    _this.salesInvoiceIFrameIsLoadedNs = function () {
	      if (!_this.state.PdfFrameLoadedNs) {
	        var pdfFrame = window.frames.salesorderPdfNs;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this.setState({ PdfFrameLoadedNs: true });
	      }
	    };
	
	    _this.renderSalesInvoiceIFrameIsLoadedNs = function () {
	      if (_this.props.salesorderPdfNs) {
	        var file = window.URL.createObjectURL(_this.props.salesorderPdfNs);
	        return _react2.default.createElement('iframe', { style: { display: 'none' }, onLoad: _this.salesInvoiceIFrameIsLoadedNs, id: 'salesorderPdfNs', name: 'salesorderPdfNs', src: file });
	      }
	    };
	
	    _this.salesReturnIFrameIsLoadedNs = function () {
	      if (!_this.state.pdfFrameLoadedReturnsNs) {
	        var pdfFrame = window.frames.salesInvoiceReturnPdfNs;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this.setState({ pdfFrameLoadedReturnsNs: true });
	      }
	    };
	
	    _this.renderSalesInvoiceIFrameReturnNs = function () {
	      if (_this.props.salesInvoiceReturnPdfNs) {
	        var file = window.URL.createObjectURL(_this.props.salesInvoiceReturnPdfNs);
	        return _react2.default.createElement('iframe', { style: { display: 'none' }, onLoad: _this.salesReturnIFrameIsLoadedNs, id: 'salesInvoiceReturnPdfNs', name: 'salesInvoiceReturnPdfNs', src: file });
	      }
	    };
	
	    _this.salesReturnIFrameIsLoaded = function () {
	      if (!_this.state.PdfFrameLoadedReturns) {
	        var pdfFrame = window.frames.salesInvoiceReturnPdf;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this.setState({ PdfFrameLoadedReturns: true });
	      }
	    };
	
	    _this.handlePrintOnClick = function () {
	      var pk = _this.state.salesInvoices.selectedRows && _this.state.salesInvoices.selectedRows.length === 1 && _this.state.salesInvoices.selectedRows[0].SalesInvoice_id;
	      var returnpk = _this.state.salesInvoices.selectedRows && _this.state.salesInvoices.selectedRows.length === 1 && _this.state.salesInvoices.selectedRows[0].SalesReturn_id;
	      if (pk) {
	        _this.props.printSalesInvoice(pk);
	      } else if (returnpk) {
	        _this.props.printSalesInvoiceReturn(returnpk);
	      }
	    };
	
	    _this.handleNSPrintonClick = function () {
	      var pk = _this.state.salesInvoices.selectedRows && _this.state.salesInvoices.selectedRows.length === 1 && _this.state.salesInvoices.selectedRows[0].SalesInvoice_id;
	      var returnpk = _this.state.salesInvoices.selectedRows && _this.state.salesInvoices.selectedRows.length === 1 && _this.state.salesInvoices.selectedRows[0].SalesReturn_id;
	      if (pk) {
	        _this.props.printSalesInvoiceNoSubtotals(pk);
	      } else if (returnpk) {
	        _this.props.printSalesInvoiceReturnsNoSubtotals(returnpk);
	      }
	    };
	
	    _this.handlePrintDisabled = function () {
	      var pk = _this.state.salesInvoices.selectedRows && _this.state.salesInvoices.selectedRows.length === 1 && _this.state.salesInvoices.selectedRows[0].SalesInvoice_id;
	      var returnpk = _this.state.salesInvoices.selectedRows && _this.state.salesInvoices.selectedRows.length === 1 && _this.state.salesInvoices.selectedRows[0].SalesReturn_id;
	      if (_this.props.requestingSalesInvoicePdf || _this.props.requestingSalesInvoiceReturnPdf) {
	        return true;
	      }
	      if (!pk && !returnpk) {
	        return true;
	      }
	      return false;
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.fiveLineButton,
	
	      showFinalized: null,
	      checkAuthorizeOpen: false,
	
	      salesInvoices: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      salesInvoiceDetail: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      total: 0,
	
	      suggestValue: '',
	      productSearchType: 'ProductNum',
	      days: '-1',
	      filteredByItem: false,
	      filterProductID: '',
	      rowsCount: 0,
	      PdfFrameLoaded: true,
	      PdfFrameLoadedReturns: true,
	
	      fromDate: SalesInvoice.getFromDate(),
	      toDate: new Date(),
	      typeRadios: 'all',
	      statusRadios: 'all',
	      PdfFrameLoadedNs: true,
	      pdfFrameLoadedReturnsNs: true,
	
	      paymentMethodModalVisibility: false
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.printForm = _this.printForm.bind(_this);
	    _this.fetchSalesInvoicesByDetails = _this.fetchSalesInvoicesByDetails.bind(_this);
	    _this.setFromDate = _this.setFromDate.bind(_this);
	    _this.setToDate = _this.setToDate.bind(_this);
	    _this.handleTypeFilterChange = _this.handleTypeFilterChange.bind(_this);
	    _this.handleStatusFilterChange = _this.handleStatusFilterChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(SalesInvoice, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.context.router.routes[1].path === 'salesInvoice') {
	        this.props.setField('Days', '7');
	      } else {
	        this.props.setField('Days', '-1');
	      }
	      this.props.setField('StatusFilter', 'all');
	      this.props.setField('OrderFilter', 'all');
	      this.props.fetchSalesInvoices('all/', today, today, null, '7');
	      if (this.context.router.routes[1].path === 'salesInvoice') {
	        this.setState({ days: '7', toDate: undefined, fromDate: undefined });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      var test = localStorage.getItem('userPermissions');
	      window.addEventListener('resize', this.handleResize);
	      this.props.fetchBaseUsers();
	      if (this.context.router.routes[1].path === 'salesInvoice') {
	        this.props.setField('Days', '7');
	      } else {
	        this.props.setField('Days', '-1');
	      }
	      this.props.setField('StatusFilter', 'all');
	      this.props.setField('OrderFilter', 'all');
	      this.props.setField('Seller', null);
	      this.props.fetchSalesInvoices('all/', today, today, null, '7');
	    }
	
	    // Once products are ready, reset state.
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.passcodeVerified && !this.props.passcodeVerified) {
	        this.props.setPasscodeVerificationStatus();
	        this.setCurrentSalesInvoiceAndRedirect();
	      }
	      if (nextProps.salesInvoice && nextProps.salesInvoice !== this.props.salesInvoice) {
	        var salesInvoices = _extends({}, this.state.salesInvoices, { rows: nextProps.salesInvoice.Invoices, selectedRows: [] });
	        this.setState({ salesInvoices: salesInvoices, total: nextProps.salesInvoice.TotalFinalPrice });
	      }
	
	      if (nextProps.salesInvoiceDetail && nextProps.salesInvoiceDetail !== this.props.salesInvoiceDetail) {
	        var salesInvoiceDetail = _extends({}, this.state.salesInvoiceDetail, { rows: nextProps.salesInvoiceDetail.Sales_Invoice_Lines });
	        this.setState({ salesInvoiceDetail: salesInvoiceDetail });
	      }
	
	      if (nextProps.salesReturnDetail && nextProps.salesReturnDetail !== this.props.salesReturnDetail) {
	        var _salesInvoiceDetail = _extends({}, this.state.salesInvoiceDetail, { rows: nextProps.salesReturnDetail.Sales_Return_Line });
	        this.setState({ salesInvoiceDetail: _salesInvoiceDetail });
	      }
	
	      if (nextProps.OrderFilter && nextProps.OrderFilter !== this.props.OrderFilter) {
	        var seller = this.props.Seller;
	        var status = nextProps.StatusFilter;
	        if (status === 'all') {
	          status = null;
	        }
	        if (this.props.Seller) {
	          seller = this.props.Seller.value;
	        }
	        var fromDate = this.state.fromDate ? this.formatDate(this.state.fromDate) : today;
	        var toDate = this.state.toDate ? this.formatDate(this.state.toDate) : today;
	        var days = this.props.Days;
	
	        if (days == null) {
	          days = 7;
	        }
	        var productNum = this.props.ProductNum;
	        this.props.fetchSalesInvoices(nextProps.OrderFilter + "/", fromDate, toDate, null, days, status, seller, this.state.filterProductID);
	      }
	
	      if (nextProps.StatusFilter && nextProps.StatusFilter !== this.props.StatusFilter) {
	        var _seller = this.props.Seller;
	        var _status = nextProps.StatusFilter;
	        if (_status === 'all') {
	          _status = null;
	        }
	        if (this.props.Seller) {
	          _seller = this.props.Seller.value;
	        }
	        var _fromDate = this.props.FromDate ? this.formatDate(this.props.FromDate) : today;
	        var _toDate = this.props.ToDate ? this.formatDate(this.props.ToDate) : today;
	        var _days = this.props.Days;
	
	        if (_days == null) {
	          _days = 7;
	        }
	        var _productNum = this.props.ProductNum;
	        this.props.fetchSalesInvoices(nextProps.OrderFilter + "/", _fromDate, _toDate, null, _days, _status, _seller, this.state.filterProductID);
	      }
	
	      if (nextProps.Days && nextProps.Days !== this.props.Days) {
	        if (nextProps.Days !== '-1') {
	          this.props.setField("FromDate", null);
	          this.props.setField("ToDate", null);
	        }
	      }
	
	      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
	        this.closeCheckAuthorize();
	        this.voidSalesInvoices();
	      }
	
	      if (nextProps.salesInvoicePdf && nextProps.salesInvoicePdf !== this.props.salesInvoicePdf) {
	        this.setState({ PdfFrameLoaded: false });
	      }
	
	      if (nextProps.salesInvoiceReturnPdf && nextProps.salesInvoiceReturnPdf !== this.props.salesInvoiceReturnPdf) {
	        this.setState({ PdfFrameLoadedReturns: false });
	      }
	
	      if (nextProps.salesorderPdfNs && nextProps.salesorderPdfNs !== this.props.salesorderPdfNs) {
	        this.setState({ PdfFrameLoadedNs: false });
	      }
	
	      if (nextProps.salesInvoiceReturnPdfNs && nextProps.salesInvoiceReturnPdfNs !== this.props.salesInvoiceReturnPdfNs) {
	        this.setState({ pdfFrameLoadedReturnsNs: false });
	      }
	
	      if (nextProps.Seller !== this.props.Seller) {
	        var _seller2 = void 0;
	        if (nextProps.Seller) {
	          _seller2 = nextProps.Seller.value;
	        }
	        var FromDate = this.context.router.routes[1].path === 'salesInvoice' && !isEcity ? this.props.FromDate : this.state.fromDate;
	        var ToDate = this.context.router.routes[1].path === 'salesInvoice' && !isEcity ? this.props.ToDate : this.state.toDate;
	        var OrderFilter = this.context.router.routes[1].path === 'salesInvoice' ? this.props.OrderFilter : this.state.typeRadios;
	        var StatusFilter = this.context.router.routes[1].path === 'salesInvoice' ? this.props.StatusFilter : this.state.statusRadios;
	        var _days2 = this.props.Days;
	        var _status2 = StatusFilter;
	        if (_status2 === 'all') {
	          _status2 = null;
	        }
	
	        if (_days2 == null) {
	          _days2 = 7;
	        }
	        if (isEcity && this.state.days) {
	          _days2 = this.state.days;
	        }
	        this.props.fetchSalesInvoices(OrderFilter + '/', FromDate, ToDate, null, _days2, _status2, _seller2, this.state.filterProductID);
	      }
	
	      if (typeof this.props.FromDate !== 'undefined' && typeof this.props.ToDate !== 'undefined' && (nextProps.FromDate !== this.props.FromDate || nextProps.ToDate !== this.props.ToDate)) {
	        var _FromDate = void 0;
	        var _ToDate = void 0;
	        var _seller3 = this.props.Seller;
	        var _status3 = this.props.StatusFilter;
	        if (_status3 === 'all') {
	          _status3 = null;
	        }
	        if (nextProps.FromDate != null) {
	          _FromDate = this.formatDate(nextProps.FromDate);
	        }
	        if (nextProps.ToDate != null) {
	          _ToDate = this.formatDate(nextProps.ToDate);
	        }
	        if (this.props.Seller) {
	          _seller3 = this.props.Seller.value;
	        }
	        this.props.fetchSalesInvoices(this.props.OrderFilter + "/", _FromDate, _ToDate, null, -1, _status3, _seller3, this.state.filterProductID);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.salesInvoices !== this.state.salesInvoices) {
	        this.setState({ rowsCount: _reactDataGridAddons.Data.Selectors.getRows(this.state.salesInvoices).length });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState.PdfFrameLoaded !== this.state.PdfFrameLoaded && this.state.PdfFrameLoaded === false) {
	        return false;
	      }
	      if (nextState.PdfFrameLoadedReturns !== this.state.PdfFrameLoadedReturns && this.state.PdfFrameLoadedReturns === false) {
	        return false;
	      }
	      if (nextState.PdfFrameLoadedNs !== this.state.PdfFrameLoadedNs && this.state.PdfFrameLoadedNs === false) {
	        return false;
	      }
	      if (nextState.pdfFrameLoadedReturnsNs !== this.state.pdfFrameLoadedReturnsNs && this.state.pdfFrameLoadedReturnsNs === false) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.fiveLineButton });
	    }
	  }, {
	    key: 'openChangePaymentMethodModal',
	    value: function openChangePaymentMethodModal() {
	      this.setState({
	        paymentMethodModalVisibility: true
	      });
	    }
	  }, {
	    key: 'closePaymentMethodModal',
	    value: function closePaymentMethodModal() {
	      this.setState({
	        paymentMethodModalVisibility: false
	      });
	    }
	
	    // Set product being selected to be currentProduct and navigate user to the edit page
	
	  }, {
	    key: 'setCurrentSalesInvoiceAndRedirect',
	    value: function setCurrentSalesInvoiceAndRedirect() {
	      var currentSalesInvoice = this.state.salesInvoices.selectedRows[0];
	      this.props.resetCurrentSalesInvoice();
	      this.props.selectSalesInvoice(currentSalesInvoice);
	      if (typeof currentSalesInvoice.SalesInvoice_id !== 'undefined' && currentSalesInvoice.SalesInvoice_id != null) {
	        this.context.router.push('/salesInvoice/' + currentSalesInvoice.SalesInvoice_id);
	      } else if (currentSalesInvoice.ReturnStatus === 'Open') {
	        this.context.router.push('/customerReturn/' + currentSalesInvoice.SalesReturn_id);
	      } else {
	        this.context.router.push('/customerCredit/' + currentSalesInvoice.SalesReturn_id);
	      }
	    }
	  }, {
	    key: 'clickNew',
	    value: function clickNew(e) {
	      e.preventDefault();
	      this.props.resetCurrentSalesInvoice();
	      this.context.router.push('/salesInvoice/new');
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      var formattedDate = date.getFullYear() + '-';
	
	      formattedDate += date.getMonth() + 1 + '-';
	      if (date.getDate() < 10) {
	        formattedDate += '0' + date.getDate();
	      } else {
	        formattedDate += date.getDate();
	      }
	      return formattedDate;
	    }
	  }, {
	    key: 'handleTypeFilterChange',
	    value: function handleTypeFilterChange(type) {
	      var _this2 = this;
	
	      var seller = this.props.Seller ? this.props.Seller.value : undefined;
	      var status = this.state.statusRadios === 'all' ? null : this.state.statusRadios;
	      this.setState({ typeRadios: type }, function () {
	        _this2.props.fetchSalesInvoices(_this2.state.typeRadios + '/', _this2.state.fromDate, _this2.state.toDate, null, -1, status, seller, _this2.state.filterProductID);
	      });
	    }
	  }, {
	    key: 'handleStatusFilterChange',
	    value: function handleStatusFilterChange(status) {
	      var _this3 = this;
	
	      var seller = this.props.Seller ? this.props.Seller.value : undefined;
	      if (status === 'all') {
	        // status is set to null because api requires no parameter to filter by 'all'
	        this.setState({ statusRadios: status }, function () {
	          _this3.props.fetchSalesInvoices(_this3.state.typeRadios + '/', _this3.state.fromDate, _this3.state.toDate, null, -1, null, seller, _this3.state.filterProductID);
	        });
	      } else {
	        this.setState({ statusRadios: status }, function () {
	          _this3.props.fetchSalesInvoices(_this3.state.typeRadios + '/', _this3.state.fromDate, _this3.state.toDate, null, -1, _this3.state.statusRadios, seller, _this3.state.filterProductID);
	        });
	      }
	    }
	  }, {
	    key: 'setToDate',
	    value: function setToDate(e) {
	      if (e < this.state.fromDate) {
	        return;
	      }
	      this.setState({ toDate: e });
	    }
	  }, {
	    key: 'setFromDate',
	    value: function setFromDate(e) {
	      if (e > this.state.toDate) {
	        return;
	      }
	      this.setState({ fromDate: e });
	    }
	  }, {
	    key: 'renderDatePickers',
	    value: function renderDatePickers() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 12 },
	        _react2.default.createElement(
	          'div',
	          { className: 'date-pickers' },
	          _react2.default.createElement(
	            'div',
	            { className: 'fromDate-picker' },
	            _react2.default.createElement(_GenericDatePicker2.default, { setDate: this.setFromDate, selectedDate: this.state.fromDate })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'toDate-picker' },
	            _react2.default.createElement(_GenericDatePicker2.default, { setDate: this.setToDate, selectedDate: this.state.toDate })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              className: 'search-button',
	              bsStyle: 'primary',
	              onClick: function onClick() {
	                _this4.fetchSalesInvoicesByDatePickerSearch();
	              }
	            },
	            _react2.default.createElement('em', { className: 'fa fa-search' })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderGenericTypeRadios',
	    value: function renderGenericTypeRadios() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        (0, _genericRadioFilter2.default)({
	          content: [{
	            option: 'all',
	            id: 'all-radio-filter',
	            name: 'typeFilterRadios',
	            labelName: 'all'
	          }, {
	            option: 'invoices',
	            id: 'invoices-radio-filter',
	            name: 'typeFilterRadios',
	            labelName: 'sales'
	          }, {
	            option: 'returns',
	            id: 'returns-radio-filter',
	            name: 'typeFilterRadios',
	            labelName: 'returns'
	          }],
	          value: this.state.typeRadios,
	          handleOnClick: this.handleTypeFilterChange,
	          type: 'buttons'
	        })
	      );
	    }
	  }, {
	    key: 'renderGenericStatusRadios',
	    value: function renderGenericStatusRadios() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        (0, _genericRadioFilter2.default)({
	          content: [{
	            option: 'all',
	            id: 'all-status-radio-filter',
	            name: 'statusFilterRadios',
	            labelName: 'all'
	          }, {
	            option: 'Released',
	            id: 'released-radio-filter',
	            name: 'statusFilterRadios',
	            labelName: 'released'
	          }, {
	            option: 'Finalized',
	            id: 'finalized-radio-filter',
	            name: 'statusFilterRadios',
	            labelName: 'finalized'
	          }, {
	            option: 'Void',
	            id: 'void-radio-filter',
	            name: 'statusFilterRadios',
	            labelName: 'void'
	          }],
	          value: this.state.statusRadios,
	          handleOnClick: this.handleStatusFilterChange,
	          type: 'buttons'
	        })
	      );
	    }
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this5 = this;
	
	      if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.error)
	          )
	        );
	      }
	
	      // Parameters of the react-data-grid
	      var tableHeight = window.innerHeight < 900 ? 270 : 270;
	      if (this.context.router.routes[1].path !== 'salesInvoice') {
	        tableHeight = 500;
	      }
	
	      var getRows = function getRows() {
	        // Doing this because i need unique id's for each row and the invoices i get from
	        // the backend dont all have a consistent field i can use. I used this new id for rowKey
	        var rows = _reactDataGridAddons.Data.Selectors.getRows(_this5.state.salesInvoices);
	        var rowsWithId = rows.map(function (row, i) {
	          return _extends({}, row, {
	            dataGridId: i
	          });
	        });
	        return rowsWithId;
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this5.state.salesInvoices, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this5.setState({ salesInvoices: state });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this5.state.salesInvoices.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var salesInvoices = _extends({}, _this5.state.salesInvoices, { filters: newFilters });
	        _this5.setState({ salesInvoices: salesInvoices });
	      };
	
	      // Handle the row select function
	      var onRowSelect = function onRowSelect(rows) {
	        var salesInvoices = _extends({}, _this5.state.salesInvoices, { selectedRows: rows });
	        _this5.setState({ salesInvoices: salesInvoices });
	      };
	
	      var onRowClick = function onRowClick(rowIdx, row) {
	        if (row) {
	          if (row.SalesInvoice_id !== null) {
	            _this5.props.fetchSalesInvoiceDetail(row.SalesInvoice_id);
	          } else {
	            _this5.props.fetchSalesReturnDetail(row.SalesReturn_id);
	          }
	        }
	        //   const invoiceRows = [...this.state.salesInvoices.rows];
	        //   invoiceRows.map((r) => {
	        //     r.isSelected = false;
	        //   });
	        //   const selectedRows = [invoiceRows[rowIdx]];
	        //   invoiceRows[rowIdx].isSelected = true;
	
	        //   const salesInvoices = { ...this.state.salesInvoices, rows: invoiceRows, selectedRows };
	        //   this.setState({ salesInvoices });
	        // };
	
	
	        // const onRowsSelected = (rows) => {
	        //   const newRows = getRows();
	        //   const selectedRows = [...this.state.salesInvoices.selectedRows];
	        //   rows.map((r) => {
	        //     newRows[r.rowIdx].isSelected = true;
	        //     selectedRows.push(r.row);
	        //   });
	        //   const salesInvoices = { ...this.state.salesInvoices, rows: newRows, selectedRows };
	        //   this.setState({ salesInvoices });
	        // };
	
	        // const onRowsDeselected = (rows) => {
	        //   const newRows = [...this.state.salesInvoices.rows];
	        //   const selectedRows = [...this.state.salesInvoices.selectedRows];
	        //   rows.map((r) => {
	        //     newRows[r.rowIdx].isSelected = false;
	        //     let rowIndex;
	        //     selectedRows.forEach((row, idx) => {
	        //       if (row.InvoiceNum === r.row.InvoiceNum) {
	        //         rowIndex = idx;
	        //       }
	        //     });
	        //     selectedRows.splice(rowIndex, 1);
	        //   });
	        //   const salesInvoices = { ...this.state.salesInvoices, rows: newRows, selectedRows };
	        //   this.setState({ salesInvoices });
	      };
	
	      var onCellSelected = function onCellSelected(coordinates) {
	        var newRows = getRows();
	        /* Multi row select on cell selected
	                  let selectedRows = [...this.state.salesOrders.selectedRows];
	                  newRows[coordinates.rowIdx].isSelected = true;
	                  let id = newRows[coordinates.rowIdx].SalesOrder_id;
	                  if (selectedRows.indexOf(id) == -1) {
	                      selectedRows.push(id);
	                  }
	                */
	        /* Single row select on cell selected */
	        var selectedRows = [].concat(_toConsumableArray(_this5.state.salesInvoices.selectedRows));
	        newRows[coordinates.rowIdx].isSelected = true;
	        var salesInvoices = _extends({}, _this5.state.salesInvoices, { rows: newRows, selectedRows: selectedRows });
	        _this5.setState({ salesInvoices: salesInvoices });
	      };
	
	      // Custom Formatter component
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var date = new Date(this.props.value);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      // Column difinition
	      var columns = [];
	      if (this.context.router.routes[1].path !== 'salesInvoice') {
	        columns = [{
	          key: 'InvoiceNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'SONum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'related_no' }),
	          resizable: true,
	          sortable: true,
	          width: 120,
	          filterable: true
	        }, {
	          key: 'CustomerNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_num' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'Customer_Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' }),
	          resizable: true,
	          sortable: true,
	          width: 250,
	          filterable: true
	        }, {
	          key: 'Customer_Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 110
	        }, {
	          key: 'PostingDate',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_date' }),
	          resizable: true,
	          sortable: true,
	          width: 125,
	          filterable: true,
	          formatter: DateFormatter
	        }, {
	          key: 'FinalPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	          resizable: true,
	          sortable: true,
	          width: 75,
	          filterable: true,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'City',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city' }),
	          resizable: true,
	          sortable: true,
	          width: 90,
	          filterable: true
	        }, {
	          key: 'Sales_Username',
	          name: isEcity ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_creator' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	          resizable: true,
	          sortable: true,
	          width: 75,
	          filterable: true
	        }].concat(_toConsumableArray(isEcity ? [{
	          key: 'Creater_Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'creator' }),
	          resizable: true,
	          sortable: true,
	          width: 75,
	          filterable: true
	        }, {
	          key: "SO_Sales_Username",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_creator' }),
	          resizable: true,
	          sortable: true,
	          width: 90,
	          filterable: true
	        }] : []), [{
	          key: 'SaleStatus',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	          resizable: true,
	          sortable: true,
	          width: 65,
	          filterable: true
	        }, {
	          key: 'PaymentType',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'SalesMargin',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_margin_percentsign' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true,
	          formatter: _percentFormatter2.default
	        }, {
	          key: 'PaymentStatusRecord',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pmt_status' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }]);
	      } else {
	        columns = [{
	          key: 'InvoiceNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'SONum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'related_no' }),
	          resizable: true,
	          sortable: true,
	          width: 120,
	          filterable: true
	        }, {
	          key: 'CustomerNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_num' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'Customer_Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' }),
	          resizable: true,
	          sortable: true,
	          width: 158,
	          filterable: true
	        }, {
	          key: 'Customer_Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 110
	        }, {
	          key: 'PostingDate',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_date' }),
	          resizable: true,
	          sortable: true,
	          width: 110,
	          filterable: true,
	          formatter: DateFormatter
	        }, {
	          key: isTN ? 'InvoiceShipDate' : 'DispatchDate',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped' }),
	          resizable: true,
	          sortable: true,
	          width: 120,
	          filterable: true,
	          formatter: DateFormatter
	        }, {
	          key: 'BillDueDate',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bill_date' }),
	          resizable: true,
	          sortable: true,
	          width: 110,
	          filterable: true,
	          formatter: DateFormatter
	        }, {
	          key: 'FinalPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	          resizable: true,
	          sortable: true,
	          width: 75,
	          filterable: true,
	          formatter: _cashFormatter2.default
	        }, {
	          key: 'City',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city' }),
	          resizable: true,
	          sortable: true,
	          width: 90,
	          filterable: true
	        }, {
	          key: 'Sales_Username',
	          name: isEcity ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_creator' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	          resizable: true,
	          sortable: true,
	          width: 75,
	          filterable: true
	        }].concat(_toConsumableArray(isEcity ? [{
	          key: 'Sales_User_Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	          resizable: true,
	          sortable: true,
	          width: 75,
	          filterable: true
	        }, {
	          key: "SO_Sales_Username",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_creator' }),
	          resizable: true,
	          sortable: true,
	          width: 90,
	          filterable: true
	        }] : []), [{
	          key: 'SaleStatus',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	          resizable: true,
	          sortable: true,
	          width: 65,
	          filterable: true
	        }, {
	          key: 'PaymentType',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        }, {
	          key: 'SalesMargin',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_margin_percentsign' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true,
	          formatter: _percentFormatter2.default
	        }]);
	      }
	
	      if (this.context.router.routes[1].path === 'salesInvoice') {
	        var indexBillDueDate = _lodash2.default.findIndex(columns, { key: 'BillDueDate' });
	        var indexDispatchDate = _lodash2.default.findIndex(columns, { key: 'DispatchDate' });
	        var indexPostingDate = _lodash2.default.findIndex(columns, { key: 'PostingDate' });
	        var billColumn = {
	          key: 'BillDueDateDisplay',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bill_date' }),
	          resizable: true,
	          sortable: true,
	          width: 110,
	          filterable: true
	        };
	        var dispatchColumn = {
	          key: 'DispatchDateDisplay',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch' }),
	          resizable: true,
	          sortable: true,
	          width: 120,
	          filterable: true
	        };
	        var postingColumn = {
	          key: 'PostingDateDisplay',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_date' }),
	          resizable: true,
	          sortable: true,
	          width: 110,
	          filterable: true
	        };
	        columns.splice(indexBillDueDate, 1, billColumn);
	        columns.splice(indexDispatchDate, 1, dispatchColumn);
	        columns.splice(indexPostingDate, 1, postingColumn);
	
	        if (this.state.salesInvoices.rows.length > 0) {
	          this.state.salesInvoices.rows.map(function (row) {
	            row.BillDueDateDisplay = (0, _moment2.default)(row.BillDueDate).format('MM-DD-YY HH:mm');
	            row.DispatchDateDisplay = (0, _moment2.default)(row.DispatchDate).format('MM-DD-YY HH:mm');
	            row.PostingDateDisplay = (0, _moment2.default)(row.PostingDate).format('MM-DD-YY HH:mm');
	          });
	        }
	
	        if (isEcity && (0, _permissions2.default)('show_real_sales_margin')) {
	          var indexSalesMargin = _lodash2.default.findIndex(columns, { key: 'SalesMargin' });
	          var salesMarginColumn = {
	            key: 'RealSalesMargin',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_margin_master_percentsign' }),
	            resizable: true,
	            sortable: true,
	            width: 100,
	            filterable: true,
	            formatter: _percentFormatter2.default
	          };
	          columns.splice(indexSalesMargin, 1, salesMarginColumn);
	        }
	      }
	
	      return (
	        // React Table Sales Invoice History
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { id: 'SalesInvoice-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowRenderer: _react2.default.createElement(_ctRowRenderer2.default, {
	                  permissionCheck: (0, _permissions2.default)('show_real_sales_margin'),
	                  isEcity: isEcity
	                }),
	                rowKey: 'dataGridId',
	                onGridSort: handleGridSort,
	                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                onAddFilter: handleFilterChange,
	                columns: columns,
	                headerRowHeight: 45,
	                rowHeight: 25,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                minHeight: tableHeight,
	                enableRowSelect: 'multi',
	                onRowSelect: onRowSelect,
	                onRowClick: onRowClick
	                // rowSelection={{
	                //   showCheckbox: true,
	                //   enableShiftSelect: true,
	                //   onRowsSelected,
	                //   onRowsDeselected,
	                //   selectBy: {
	                //     isSelectedKey: 'isSelected',
	                //   },
	                // }}
	                // onCellSelected={onCellSelected}
	              })
	            )
	          )
	        )
	      );
	    }
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	  }, {
	    key: 'renderSalesInvoiceDetailTable',
	    value: function renderSalesInvoiceDetailTable() {
	      var _this6 = this;
	
	      if (this.props.detailIsLoading && !this.props.detailError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.detailError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.detailError)
	          )
	        );
	      }
	
	      // Parameters of the react-data-grid
	      var tableHeight = window.innerHeight < 900 ? 185 : 185;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this6.state.salesInvoiceDetail);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this6.state.salesInvoiceDetail, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this6.setState({ salesInvoiceDetail: state });
	      };
	
	      // Handle the row select function
	      var onRowSelect = function onRowSelect(rows) {
	        _this6.setState({ selectedRows: rows });
	      };
	
	      // Column difinition
	      var columns = [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: 'RefNum',
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 200
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'LoadedQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        sortable: true,
	        width: 80
	      }, {
	        key: 'TotalNetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        height: 50
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 70
	      }];
	
	      if (isHMM) {
	        var temp1 = void 0,
	            temp2 = void 0;
	        temp1 = {
	          key: 'TotalPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_price' }),
	          resizable: true,
	          sortable: true,
	          width: 70
	        };
	        temp2 = {
	          key: 'PackageSize',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	          resizable: true,
	          sortable: true,
	          width: 100
	        }, columns.push(temp1);
	        columns.splice(4, 0, temp2);
	      }
	      if (isEcity || _root_url.isLucky88) {
	        var _temp = {
	          key: 'SalesMargin',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_margin' }),
	          resizable: true,
	          sortable: true,
	          width: 70
	        };
	        columns.push(_temp);
	      }
	      return (
	        // Detailed Information Table
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { id: 'SalesInvoice-dataGrid2' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                columns: columns,
	                headerRowHeight: 45,
	                minHeight: tableHeight,
	                onGridSort: handleGridSort,
	                onRowSelect: onRowSelect,
	                onRowUpdated: this.handleRowUpdated,
	                rowGetter: rowGetter,
	                rowHeight: 25,
	                rowKey: 'SalesInvoice_id',
	                rowsCount: getSize()
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderAutoSuggest',
	    value: function renderAutoSuggest() {
	      var _this7 = this;
	
	      if (!this.state.filteredByItem) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'control-dropdown' },
	          _react2.default.createElement(_GenericProductSuggest2.default, {
	            value: this.state.suggestValue,
	            onChange: function onChange(e, _ref) {
	              var newValue = _ref.newValue;
	              _this7.setState({ suggestValue: newValue });
	            },
	            SearchType: this.state.productSearchType,
	            fetchOrdersByProduct: this.fetchSalesInvoicesByProduct
	          })
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { id: 'suggestion-box' },
	        this.state.suggestValue,
	        _react2.default.createElement('em', { className: 'fa fa-times pull-right', onClick: function onClick() {
	            _this7.setState({ filteredByItem: false, suggestValue: '', filterProductID: null }, function () {
	              _this7.fetchSalesInvoicesByDetails(_this7.state.days);
	            });
	          } })
	      );
	    }
	  }, {
	    key: 'setButtonStatus',
	    value: function setButtonStatus(value) {
	      this.setState({ showFinalized: value });
	    }
	
	    /*
	     * sends api request to finalize selected Invoices. if successful, refreshes the invoice data grid.
	     * params: none
	     * returns: none
	     */
	
	  }, {
	    key: 'finalizeSalesOrders',
	    value: function finalizeSalesOrders() {
	      var _this8 = this;
	
	      // FromDate, ToDate, OrderFilter, and StatusFilter are needed for the two different Sales Invoices pages
	      var FromDate = this.context.router.routes[1].path === 'salesInvoice' ? this.state.fromDate : this.state.fromDate;
	      var ToDate = this.context.router.routes[1].path === 'salesInvoice' ? this.state.toDate : this.state.toDate;
	      var OrderFilter = this.context.router.routes[1].path === 'salesInvoice' ? this.props.OrderFilter : this.state.typeRadios;
	      var StatusFilter = this.context.router.routes[1].path === 'salesInvoice' ? this.props.StatusFilter : this.state.statusRadios;
	      if (StatusFilter === 'all') {
	        StatusFilter = null;
	      }
	      var seller = this.props.Seller ? this.props.Seller.value : undefined;
	
	      // Get the ids of selected invoices
	      var salesInvoiceIds = [];
	      this.state.salesInvoices.selectedRows.forEach(function (salesInvoice) {
	        salesInvoiceIds.push(salesInvoice.SalesInvoice_id);
	      });
	
	      // Make the api calls
	      this.props.finalizeInvoice(salesInvoiceIds).then(function () {
	        _this8.props.fetchSalesInvoices(OrderFilter + '/', FromDate, ToDate, null, _this8.props.Days, StatusFilter, seller, _this8.state.filterProductID);
	      });
	    }
	  }, {
	    key: 'deliverSalesOrders',
	    value: function deliverSalesOrders() {
	      var _this9 = this;
	
	      // FromDate, ToDate, OrderFilter, and StatusFilter are needed for the two different Sales Invoices pages
	      var FromDate = this.context.router.routes[1].path === 'salesInvoice' ? this.state.fromDate : this.state.fromDate;
	      var ToDate = this.context.router.routes[1].path === 'salesInvoice' ? this.state.toDate : this.state.toDate;
	      var OrderFilter = this.context.router.routes[1].path === 'salesInvoice' ? this.props.OrderFilter : this.state.typeRadios;
	      var StatusFilter = this.context.router.routes[1].path === 'salesInvoice' ? this.props.StatusFilter : this.state.statusRadios;
	      if (StatusFilter === 'all') {
	        StatusFilter = null;
	      }
	      var seller = this.props.Seller ? this.props.Seller.value : undefined;
	      var salesInvoiceIds = [];
	      this.state.salesInvoices.selectedRows.forEach(function (salesInvoice) {
	        salesInvoiceIds.push(salesInvoice.SalesInvoice_id);
	      });
	
	      this.props.deliverInvoice(salesInvoiceIds).then(function () {
	        _this9.props.fetchSalesInvoices(OrderFilter + '/', FromDate, ToDate, null, _this9.props.Days, StatusFilter, seller, _this9.state.filterProductID);
	      });
	    }
	  }, {
	    key: 'printForm',
	    value: function printForm() {
	      this.props.printInvoice(this.state.salesInvoices.selectedRows[0].SalesInvoice_id);
	    }
	  }, {
	    key: 'renderPrintSalesInvoiceIframe',
	    value: function renderPrintSalesInvoiceIframe() {
	      var pk = this.state.salesInvoices.selectedRows && this.state.salesInvoices.selectedRows.length === 1 && this.state.salesInvoices.selectedRows[0].SalesInvoice_id;
	      var returnpk = this.state.salesInvoices.selectedRows && this.state.salesInvoices.selectedRows.length === 1 && this.state.salesInvoices.selectedRows[0].SalesReturn_id;
	      var _state = this.state,
	          PdfFrameLoaded = _state.PdfFrameLoaded,
	          PdfFrameLoadedReturns = _state.PdfFrameLoadedReturns;
	      var _props = this.props,
	          salesInvoicePdf = _props.salesInvoicePdf,
	          salesInvoiceReturnPdf = _props.salesInvoiceReturnPdf;
	
	      var iframeProps = {};
	      if (pk) {
	        iframeProps = {
	          id: 'salesInvoicePDF',
	          loaded: PdfFrameLoaded,
	          name: 'Pdf',
	          onLoad: this.salesInvoiceIFrameIsLoaded,
	          pdf: salesInvoicePdf,
	          title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_sales_invoice' })
	        };
	      } else if (returnpk) {
	        iframeProps = {
	          id: 'salesInvoiceReturnPDF',
	          loaded: PdfFrameLoadedReturns,
	          name: 'Pdf',
	          onLoad: this.salesReturnIFrameIsLoaded,
	          pdf: salesInvoiceReturnPdf,
	          title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_sales_return' })
	        };
	      }
	      return _react2.default.createElement(_PrintIframe2.default, iframeProps);
	    }
	  }, {
	    key: 'renderSalesInvoiceIFrame',
	    value: function renderSalesInvoiceIFrame() {
	      if (this.props.salesInvoicePdf) {
	        var file = window.URL.createObjectURL(this.props.salesInvoicePdf);
	        return _react2.default.createElement('iframe', { style: { display: 'none' }, onLoad: this.salesInvoiceIFrameIsLoaded, id: 'salesInvoicePdf', name: 'salesInvoicePdf', src: file });
	      }
	    }
	  }, {
	    key: 'renderSalesReturnIFrame',
	    value: function renderSalesReturnIFrame() {
	      if (this.props.salesInvoiceReturnPdf) {
	        var file = window.URL.createObjectURL(this.props.salesInvoiceReturnPdf);
	        return _react2.default.createElement('iframe', { style: { display: 'none' }, onLoad: this.salesReturnIFrameIsLoaded, id: 'salesInvoiceReturnPdf', name: 'salesInvoiceReturnPdf', src: file });
	      }
	    }
	
	    // renderPrintSalesReturnIframe() {
	    //   const { PdfFrameLoadedReturns } = this.state;
	    //   const { salesInvoiceReturnPdf } = this.props;
	    //   return (
	    //     <PrintIframe
	    //       id="salesInvoiceReturnPDF"
	    //       loaded={PdfFrameLoadedReturns}
	    //       name="Pdf"
	    //       onLoad={this.salesReturnIFrameIsLoaded}
	    //       pdf={salesInvoiceReturnPdf}
	    //       title={<Translate value="print_sales_invoice" />}
	    //     />
	    //   );
	    // }
	
	    /* renderIFrame() {
	      const selectedRow = this.state.salesInvoices.selectedRows[0];
	      if (selectedRow) {
	        if (this.props.salesInvoicePdf && !selectedRow.SalesReturn_id) {
	          var file = window.URL.createObjectURL(this.props.salesInvoicePdf);
	          return (
	              <iframe style={{ display: 'none'}} onLoad={this.IFrameIsLoaded} id="Pdf" name="Pdf" src={file} />
	          );
	        }
	        if (this.props.salesInvoiceReturnPdf && !selectedRow.SalesInvoice_id) {
	          var file = window.URL.createObjectURL(this.props.salesInvoiceReturnPdf);
	          return (
	              <iframe style={{ display: 'none'}} onLoad={this.IFrameIsLoaded} id="Pdf" name="Pdf" src={file} />
	          );
	        }
	      }
	    } */
	
	  }, {
	    key: 'renderPaymentMethodChangeButton',
	    value: function renderPaymentMethodChangeButton() {
	      var _this10 = this;
	
	      var selectedRows = this.state.salesInvoices.selectedRows;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          disabled: selectedRows.length !== 1,
	          onClick: function onClick() {
	            _this10.openChangePaymentMethodModal();
	          }
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'change_payment_method' })
	      );
	    }
	  }, {
	    key: 'renderPrint',
	    value: function renderPrint() {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          className: 'btn btn-primary marginLeftStyle',
	          disabled: this.handlePrintDisabled() || !(0, _permissions2.default)('print_sales_invoice'),
	          type: 'button',
	          onClick: this.handlePrintOnClick
	        },
	        _react2.default.createElement('em', { className: this.renderPrintIcon() }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	      );
	    }
	  }, {
	    key: 'renderPrintNs',
	    value: function renderPrintNs() {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          className: 'btn btn-primary marginLeftStyle',
	          disabled: this.handlePrintDisabled() || !(0, _permissions2.default)('print_sales_invoice'),
	          type: 'button',
	          onClick: this.handleNSPrintonClick
	        },
	        _react2.default.createElement('em', { className: this.renderPrintIcon() }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_ns' })
	      );
	    }
	  }, {
	    key: 'renderPrintIcon',
	    value: function renderPrintIcon() {
	      if (this.props.printSalesInvoiceIsLoading && !this.props.salesInvoiceReturnPdfError && !this.props.salesInvoicePdfError) {
	        return 'fa fa-spinner fa-spin';
	      }
	      return 'fa fa-print';
	    }
	  }, {
	    key: 'renderUsers',
	    value: function renderUsers() {
	      if (this.props.usersIsLoading) return _react2.default.createElement(_spinner2.default, null); // If group is loading, show a spinner.
	
	      var Users = this.getUsers();
	      return _react2.default.createElement(
	        'div',
	        { className: 'control-dropdown' },
	        _react2.default.createElement(_reduxForm.Field, { name: 'Seller', component: _selection.Selection, options: Users })
	      );
	    }
	  }, {
	    key: 'getUsers',
	    value: function getUsers() {
	      var Users = [];
	      this.props.users.map(function (user) {
	        Users.push({ value: user.user_id, label: user.username });
	      });
	      return Users;
	    }
	
	    /*
	    * checks if finalize button should be greyed out or not.
	    * params: none
	    * returns: true if button should be disabled. false otherwise.
	    */
	
	  }, {
	    key: 'shouldDisableFinalizeButton',
	    value: function shouldDisableFinalizeButton() {
	      // Quick initial checks
	      if (!this.state.salesInvoices.selectedRows || this.state.salesInvoices.selectedRows.length <= 0 || this.props.finalizingSalesInvoice || this.props.deliveringSalesInvoice || this.props.isLoading || !(0, _permissions2.default)('edit_finalize_sales_invoice')) {
	        return true;
	      }
	
	      // Make sure every sales invoice selected is released and has an id
	      var selectedSalesInvoices = this.state.salesInvoices.selectedRows;
	      for (var i = 0; i < selectedSalesInvoices.length; i += 1) {
	        if (selectedSalesInvoices[i].SaleStatus !== 'Released' && selectedSalesInvoices[i].SaleStatus !== 'Delivered' || !selectedSalesInvoices[i].SalesInvoice_id) {
	          return true;
	        }
	      }
	
	      // Passes all checks, so allow user to finalize
	      return false;
	    }
	  }, {
	    key: 'renderFinalizeButton',
	    value: function renderFinalizeButton() {
	      var _this11 = this;
	
	      var selectedRows = this.state.salesInvoices.selectedRows;
	      // Finds the index of a selected row that is not a Mobile SI. Note: Sales Returns do not have IsMobile field
	
	      var notAllMobile = selectedRows.length > 0 ? _lodash2.default.findIndex(selectedRows, function (row) {
	        return row.IsMobile !== true;
	      }) : 1;
	      var isDelivered = selectedRows.length > 0 ? _lodash2.default.findIndex(selectedRows, function (row) {
	        return row.SaleStatus === 'Delivered';
	      }) : 1;
	      if (notAllMobile > -1 || isDelivered > -1) {
	        return _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'submit',
	            onClick: function onClick() {
	              _this11.finalizeSalesOrders();
	            },
	            disabled: this.shouldDisableFinalizeButton()
	          },
	          _react2.default.createElement('em', { className: 'fa fa-check' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'finalize' })
	        );
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.DropdownButton,
	        {
	          bsStyle: 'success',
	          title: _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('em', { className: 'fa fa-check' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver' })
	          ),
	          className: 'dropdownbutton',
	          disabled: this.shouldDisableFinalizeButton()
	        },
	        _react2.default.createElement(
	          _reactBootstrap.MenuItem,
	          { onSelect: function onSelect() {
	              _this11.deliverSalesOrders();
	            } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.MenuItem,
	          { onSelect: function onSelect() {
	              _this11.finalizeSalesOrders();
	            } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'finalize' })
	        )
	      );
	    }
	  }, {
	    key: 'renderButtons',
	    value: function renderButtons() {
	      var _this12 = this;
	
	      if (!this.state.showFinalized) {
	        return _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          { className: 'table-buttons' },
	          this.renderFinalizeButton(),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'warning',
	              type: 'button',
	              onClick: function onClick(event) {
	                _this12.setCurrentSalesInvoice(event);
	              },
	              disabled: !this.state.salesInvoices.selectedRows || this.state.salesInvoices.selectedRows.length !== 1 || !(0, _permissions2.default)('change_sales_invoice')
	            },
	            _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'danger',
	              type: 'reset',
	              onClick: function onClick() {
	                _this12.openCheckAuthorize('remove');
	              },
	              disabled: this.shouldVoidButtonDisable() || !(0, _permissions2.default)('delete_sales_invoice')
	            },
	            _react2.default.createElement('em', { className: 'fa fa-trash' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'void' })
	          ),
	          this.renderPrint(),
	          this.renderPrintNs()
	        );
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.ButtonToolbar,
	        { className: 'pull-right' },
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            onClick: function onClick() {
	              _this12.setButtonStatus(false);_this12.props.fetchSalesInvoicesByType('released');
	            }
	          },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'show_released_si' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'warning',
	            onClick: function onClick(event) {
	              _this12.setCurrentSalesInvoice(event);
	            },
	            disabled: !this.state.salesInvoices.selectedRows || this.state.salesInvoices.selectedRows.length !== 1
	          },
	          _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_released_si' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            disabled: this.state.salesInvoices.selectedRows.length !== 1 || !(0, _permissions2.default)('print_sales_invoice'),
	            onClick: function onClick() {
	              _this12.printForm();
	            }
	          },
	          _react2.default.createElement('em', { className: this.renderPrintIcon() }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_si' })
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'btn btn-primary', href: url },
	          ' ',
	          _react2.default.createElement('em', { className: 'fa fa-print marginRightStyle' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	        )
	      );
	    }
	  }, {
	    key: 'renderExportButton',
	    value: function renderExportButton() {
	      var FromDate = this.context.router.routes[1].path === 'salesInvoice' ? this.state.fromDate : this.state.fromDate;
	      var ToDate = this.context.router.routes[1].path === 'salesInvoice' ? this.state.toDate : this.state.toDate;
	      var OrderFilter = this.context.router.routes[1].path === 'salesInvoice' ? this.props.OrderFilter : this.state.typeRadios;
	      var StatusFilter = this.context.router.routes[1].path === 'salesInvoice' ? this.props.StatusFilter : this.state.statusRadios;
	      var Days = this.state.Days;
	
	      var dateRange = Days || -1;
	      var status = StatusFilter;
	      if (status === 'all') {
	        status = '';
	      } else {
	        status = '&SaleStatus=' + StatusFilter;
	      }
	
	      var _toFromDates = (0, _cleanDates.toFromDates)(dateRange, FromDate, ToDate),
	          fromDate = _toFromDates.fromDate,
	          toDate = _toFromDates.toDate;
	
	      var exportUrl = _root_url.ROOT_URL + 'v1/sale/sales_invoice/search/' + OrderFilter + '/export/?PostingDate__gte=' + fromDate + '&PostingDate__lte=' + toDate + status + '&Bearer=' + localStorage.getItem('token');
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'export-to-excel',
	          href: exportUrl,
	          disabled: !(0, _permissions2.default)('print_sales_invoice')
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	      );
	    }
	  }, {
	    key: 'renderExportSelectedButton',
	    value: function renderExportSelectedButton() {
	      var invoiceIds = [];
	      var selectedRows = this.state.salesInvoices.selectedRows;
	
	
	      if (selectedRows && selectedRows.length > 0) {
	        selectedRows.map(function (row) {
	          invoiceIds.push(row.SalesInvoice_id);
	        });
	      }
	
	      var exportUrl = _root_url.ROOT_URL + 'v2/invoice-line-export/' + invoiceIds.join(",") + '?Bearer=' + localStorage.getItem("token");
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          href: exportUrl,
	          disabled: !invoiceIds || invoiceIds.length < 1
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel_lines' })
	      );
	    }
	  }, {
	    key: 'renderTotal',
	    value: function renderTotal(page) {
	      if (page === 'salesInvoice') {
	        return _react2.default.createElement('span', null);
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Panel,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'grand-total' },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 5, style: { 'margin-top': '2px' } },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rows' }),
	              ':\xA0',
	              _react2.default.createElement(
	                'span',
	                { className: 'font-color-orange' },
	                this.state.rowsCount
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 6 },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { style: { 'margin-top': '2px' }, xs: 2, xsOffset: 2 },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { style: { display: 'inline-flex' } },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'grand_total' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'dollar-sign' },
	                    ' $$'
	                  ),
	                  ':'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 2 },
	              _react2.default.createElement(_reduxForm.Field, { component: _inputField.DisabledInputField, placeholder: '' + (0, _numberWithCommas.numberWithCommas)(this.state.total) || 0 })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this13 = this;
	
	      var height = (this.state.tableHeight / 3 * 2 + 70).toString();
	
	      var createDialogStyle = {
	        width: '550px',
	        height: '300px',
	        marginLeft: '-15%'
	      };
	      var createPaymentMethodDialogStyle = {
	        width: '600px',
	        height: '360px',
	        marginLeft: '-10%'
	      };
	
	      var data = _reactDataGridAddons.Data.Selectors.getRows(this.state.salesInvoices);
	      var fileName = 'si-filtered-' + (0, _moment2.default)().format('YYYYMMDD') + '.csv';
	      var salesInvoiceTable = this.context.router.routes[1].path === 'salesInvoice' ? ' position-relative table-collapse-fix' : 'position-relative ar-table-collapse-fix';
	      var changePaymentMethodTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_method_change' });
	      var printContainerTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_container_invoice' });
	
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              this.context.router.routes[1].path === 'salesInvoice' ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_management' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ar_slashsign_ap' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_invoice' })
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'sales-invoice' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { id: 'date-range-picker', className: 'form-horizontal' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 1 },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'filter-title', style: { whiteSpace: 'nowrap' } },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_type' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'colon' },
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 4 },
	                      _react2.default.createElement(
	                        'div',
	                        { id: 'statusFilterRadios' },
	                        this.context.router.routes[1].path === 'salesInvoice' ? _react2.default.createElement(_reduxForm.Field, {
	                          name: 'OrderFilter',
	                          component: renderTypeRadios,
	                          fetching: this.props.isLoading
	                        }) : this.renderGenericTypeRadios()
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 1, style: { left: '-70px' } },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'filter-title', style: { whiteSpace: 'nowrap', float: 'right' } },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'colon' },
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 5, style: { left: '-77px' } },
	                      _react2.default.createElement(
	                        'div',
	                        { id: 'statusFilterRadios' },
	                        this.context.router.routes[1].path === 'salesInvoice' ? _react2.default.createElement(_reduxForm.Field, {
	                          name: 'StatusFilter',
	                          component: renderStatusRadios,
	                          fetching: this.props.isLoading
	                        }) : this.renderGenericStatusRadios()
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 1 },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'filter-title text-nowrap' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_date' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'colon' },
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(_reactBootstrap.Col, { xs: 2 }),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 10 },
	                      this.context.router.routes[1].path === 'salesInvoice' ? (0, _dateFilterRadios2.default)({
	                        handleOnClick: this.fetchSalesInvoicesByDetails,
	                        setFromDate: this.setFromDate,
	                        setToDate: this.setToDate,
	                        setToRangeSearch: this.setToRangeSearch,
	                        FromDate: this.state.fromDate,
	                        ToDate: this.state.toDate,
	                        Days: this.state.days
	                      }) : this.renderDatePickers()
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: salesInvoiceTable },
	                  this.renderButtons(),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-filters', style: { zIndex: 1 } },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'control-label' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_seller' })
	                    ),
	                    this.renderUsers(),
	                    _react2.default.createElement(
	                      _reactBootstrap.ButtonToolbar,
	                      { style: { display: 'flex' } },
	                      this.renderExportButton(),
	                      isTN && this.renderExportSelectedButton(),
	                      _react2.default.createElement(
	                        _reactCsv.CSVLink,
	                        {
	                          data: (0, _salesInvoiceExport.formatExportData)(data),
	                          filename: fileName,
	                          className: 'btn btn-success export-to-excel',
	                          target: '_blank',
	                          disabled: this.state.salesInvoices && this.state.salesInvoices.filters && _lodash2.default.isEmpty(this.state.salesInvoices.filters) || !(0, _permissions2.default)('print_sales_invoice')
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-download' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'filtered_excel' })
	                      ),
	                      _root_url.isRivera && this.renderPaymentMethodChangeButton()
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { id: 'autosuggest-div' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      { style: { height: '30px' } },
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 6 },
	                        _react2.default.createElement(_TypeRadios2.default, { value: this.state.productSearchType, handleOptionChange: this.handleOptionChange })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 6 },
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          null,
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            this.renderAutoSuggest()
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  this.renderTable()
	                ),
	                this.renderTotal(this.context.router.routes[1].path)
	              )
	            ),
	            ' ',
	            this.context.router.routes[1].path === 'salesInvoice' ? _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sale_invoice_details' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'details-table-collapse-fix' },
	                  this.renderSalesInvoiceDetailTable()
	                )
	              )
	            ) : _react2.default.createElement('span', null),
	            this.renderSalesInvoiceIFrame(),
	            this.renderSalesReturnIFrame(),
	            this.renderSalesInvoiceIFrameIsLoadedNs(),
	            this.renderSalesInvoiceIFrameReturnNs()
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogStyle,
	              isVisible: this.state.checkAuthorizeOpen,
	              onCloseClicked: this.closeCheckAuthorize
	            },
	            _react2.default.createElement(_confirmActionModal2.default, {
	              'case': 'confirmPassword',
	              closeC: this.checkAuthorize,
	              checkPasswordFailure: this.props.checkPasswordFailure
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogStyle,
	              isVisible: this.state.verifyPasscodeOpen,
	              onCloseClicked: this.closeVerifyPasscode
	            },
	            _react2.default.createElement(_VerifyPasscodeModal2.default, {
	              closeConfirm: this.handleVerifyPassocdeModalClose
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            { dialogStyles: createPaymentMethodDialogStyle, isVisible: this.state.paymentMethodModalVisibility, onCloseClicked: function onCloseClicked() {
	                _this13.closePaymentMethodModal();
	              }, title: changePaymentMethodTitle },
	            _react2.default.createElement(_PaymentMethodModal2.default, {
	              salesOrder: this.state.salesInvoices.selectedRows,
	              successSaved: this.handleSOPaymentMethodSaved
	            })
	          )
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return SalesInvoice;
	}(_react.Component);
	
	SalesInvoice.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = SalesInvoice;
	exports.default = _default;
	
	// Show Finalized Invoices
	// <Button
	//     className="btn btn-primary"
	//     onClick={() => {this.setButtonStatus(true); this.props.fetchSalesInvoicesByType("finalized");}}><Translate value="show_finalized_si" />
	// </Button>
	
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isTN, 'isTN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesInvoice.jsx');
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesInvoice.jsx');
	
	  __REACT_HOT_LOADER__.register(isHMM, 'isHMM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesInvoice.jsx');
	
	  __REACT_HOT_LOADER__.register(getBsStyle, 'getBsStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesInvoice.jsx');
	
	  __REACT_HOT_LOADER__.register(renderRadios, 'renderRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesInvoice.jsx');
	
	  __REACT_HOT_LOADER__.register(renderTypeRadios, 'renderTypeRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesInvoice.jsx');
	
	  __REACT_HOT_LOADER__.register(renderStatusRadios, 'renderStatusRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesInvoice.jsx');
	
	  __REACT_HOT_LOADER__.register(today, 'today', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesInvoice.jsx');
	
	  __REACT_HOT_LOADER__.register(SalesInvoice, 'SalesInvoice', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesInvoice.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesInvoice.jsx');
	}();

	;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatExportData = undefined;
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _moment3 = __webpack_require__(41);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _moment4.default)(_moment2.default);
	
	var roundTo = function roundTo(n, digits) {
	  if (digits === undefined) {
	    digits = 0;
	  }
	
	  var multiplicator = Math.pow(10, digits);
	  n = parseFloat((n * multiplicator).toFixed(11));
	  var test = Math.round(n) / multiplicator;
	  return +test.toFixed(2);
	};
	
	var formatExportData = function formatExportData(data) {
	  var formatedData = [];
	  if (Array.isArray(data)) {
	    var headerRow = ['Invoice No.', 'Order No.', 'Customer #', 'Customer Name', 'Shipped', 'Final $$', 'Sale Status', 'Payment Status', 'Sales Margin', 'Sales Profit', 'Sales Person'];
	    formatedData.push(headerRow);
	    var total = 0;
	    var totalSale = 0;
	    var reversedData = _lodash2.default.map(data, _lodash2.default.clone);
	    reversedData.reverse();
	    reversedData.map(function (row) {
	      var rowData = {};
	      rowData.date = (0, _moment2.default)(row.DispatchDate).format('MMM DD YYYY');
	      // flip the sign for return/credit invoices
	      if (row.SONum === null) {
	        rowData.finalPrice = -row.FinalPrice;
	      } else {
	        rowData.finalPrice = row.FinalPrice;
	      }
	
	      if (row.SaleStatus !== 'Void' && row.SONum !== null) {
	        totalSale += rowData.finalPrice;
	      }
	      // calculate total (include sale and return and credit)
	      if (row.SaleStatus !== 'Void') {
	        total += rowData.finalPrice;
	        rowData.finalPrice = '$' + roundTo(rowData.finalPrice || 0, 2).toFixed(2);
	      } else {
	        rowData.finalPrice = '-';
	      }
	      formatedData.push([row.InvoiceNum || '', row.SONum || '', row.CustomerNum || '', row.Customer_Name || '', rowData.date || '', rowData.finalPrice || '-', row.SaleStatus || '', row.PaymentStatusRecord || '', row.SalesMargin ? row.SalesMargin + '%' : '', row.SalesProfit || '', row.Sales_Username || '']);
	    });
	    // formatedData.push(['TOTAL: ', '', '', '', `$${totalSale}`]);
	    formatedData.push(['TOTAL: ', '', '', '', '$' + roundTo(total, 2).toFixed(2)]);
	  }
	  return formatedData;
	};
	
	exports.formatExportData = formatExportData;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(roundTo, 'roundTo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesInvoiceExport.js');
	
	  __REACT_HOT_LOADER__.register(formatExportData, 'formatExportData', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesInvoiceExport.js');
	}();

	;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _selection = __webpack_require__(21);
	
	var _inputField = __webpack_require__(16);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _datePicker = __webpack_require__(27);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _salesInventoryInfo = __webpack_require__(77);
	
	var _salesInventoryInfo2 = _interopRequireDefault(_salesInventoryInfo);
	
	var _salesShippingModal = __webpack_require__(672);
	
	var _salesShippingModal2 = _interopRequireDefault(_salesShippingModal);
	
	var _taxSelectionModal = __webpack_require__(160);
	
	var _discountChangeModal = __webpack_require__(269);
	
	var _weightChangeModal = __webpack_require__(320);
	
	var _itemHistoryGrid = __webpack_require__(276);
	
	var _itemHistoryGrid2 = _interopRequireDefault(_itemHistoryGrid);
	
	var _MSOPaymentInfo = __webpack_require__(654);
	
	var _MSOPaymentInfo2 = _interopRequireDefault(_MSOPaymentInfo);
	
	var _boldTextFormatter = __webpack_require__(154);
	
	var _boldTextFormatter2 = _interopRequireDefault(_boldTextFormatter);
	
	var _boldCashFormatter = __webpack_require__(153);
	
	var _boldCashFormatter2 = _interopRequireDefault(_boldCashFormatter);
	
	var _SalesOrderAutoSuggest = __webpack_require__(152);
	
	var _SalesOrderAutoSuggest2 = _interopRequireDefault(_SalesOrderAutoSuggest);
	
	var _filterMultiKeyword = __webpack_require__(95);
	
	var _filterMultiKeyword2 = _interopRequireDefault(_filterMultiKeyword);
	
	var _cleanDates = __webpack_require__(22);
	
	var _PrintIframe = __webpack_require__(63);
	
	var _PrintIframe2 = _interopRequireDefault(_PrintIframe);
	
	var _DeliveryMethodModal = __webpack_require__(468);
	
	var _DeliveryMethodModal2 = _interopRequireDefault(_DeliveryMethodModal);
	
	var _NumberUtil = __webpack_require__(67);
	
	var _DropshipModal = __webpack_require__(469);
	
	var _DropshipModal2 = _interopRequireDefault(_DropshipModal);
	
	var _CheckboxFormatter = __webpack_require__(148);
	
	var _CheckboxFormatter2 = _interopRequireDefault(_CheckboxFormatter);
	
	var _VerifyPasscodeModal = __webpack_require__(115);
	
	var _VerifyPasscodeModal2 = _interopRequireDefault(_VerifyPasscodeModal);
	
	var _ShippingInfoFormModal = __webpack_require__(483);
	
	var _ShippingInfoFormModal2 = _interopRequireDefault(_ShippingInfoFormModal);
	
	var _salesOrder = __webpack_require__(158);
	
	var _salesOrder2 = _interopRequireDefault(_salesOrder);
	
	var _carrierInfoModal = __webpack_require__(266);
	
	var _shippingInfoEditModal = __webpack_require__(316);
	
	var _shippingInfoEditModal2 = _interopRequireDefault(_shippingInfoEditModal);
	
	var _fbaAddressEditModal = __webpack_require__(273);
	
	var _fbaAddressEditModal2 = _interopRequireDefault(_fbaAddressEditModal);
	
	var _ShippingInfoConfirmModal = __webpack_require__(260);
	
	var _ShippingInfoConfirmModal2 = _interopRequireDefault(_ShippingInfoConfirmModal);
	
	var _BatchesModal = __webpack_require__(250);
	
	var _BatchesModal2 = _interopRequireDefault(_BatchesModal);
	
	var _MultiBatchModal = __webpack_require__(256);
	
	var _MultiBatchModal2 = _interopRequireDefault(_MultiBatchModal);
	
	var _MultiBatchModal3 = __webpack_require__(257);
	
	var _MultiBatchModal4 = _interopRequireDefault(_MultiBatchModal3);
	
	var _GenericSelection = __webpack_require__(40);
	
	var _GenericSelection2 = _interopRequireDefault(_GenericSelection);
	
	var _root_url = __webpack_require__(9);
	
	var _url = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var input = _react2.default.DOM.input;
	var DriverListModal = _salesOrder2.default.DriverListModal,
	    ISAEditModal = _salesOrder2.default.ISAEditModal,
	    CTNEditModal = _salesOrder2.default.CTNEditModal,
	    ShippingStatusEditModal = _salesOrder2.default.ShippingStatusEditModal,
	    Notes = _salesOrder2.default.Notes,
	    BatchesModal = _salesOrder2.default.BatchesModal,
	    PromotionAddingModal = _salesOrder2.default.PromotionAddingModal;
	
	
	var isBobaLife = _root_url.ROOT_API_URL === 'https://premiumstella-scm.truckxi.com/api';
	var isMyumyu = _root_url.ROOT_API_URL === 'https://mmstage-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://myumyu-scm.truckxi.com/api/';
	var isHMM = _root_url.ROOT_API_URL === 'https://hmm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://hmm-scm.truckxi.com/api/';
	var isDHC = _root_url.ROOT_API_URL === 'https://dhc-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://dhc-scm.truckxi.com/api/';
	var isAFG = _root_url.ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afg-scm.truckxi.com/api/';
	var isWecom = _root_url.ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/';
	var isCO = _root_url.ROOT_API_URL === 'https://co-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://co-scm.truckxi.com/api/';
	var isAFM = _root_url.ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afm-scm.truckxi.com/api/';
	var isTN = _root_url.ROOT_API_URL === "https://tn-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://tn-scm.truckxi.com/api/";
	var isABC = _root_url.ROOT_API_URL === 'https://abc-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://abc-scm.truckxi.com/api/';
	var isAN = _root_url.ROOT_API_URL === 'https://asian-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://asian-scm.truckxi.com/api/';
	var isChinaTown = _root_url.ROOT_API_URL === 'https://erp.chinatown-supermarket.com/api/' || _root_url.ROOT_URL === 'https://erp.chinatown-supermarket.com/api/';
	var isJML = _root_url.ROOT_API_URL === 'https://jml-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://jml-scm.truckxi.com/api/';
	var isDSQ = _root_url.ROOT_API_URL === 'https://dsq-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://dsq-scm.truckxi.com/api/';
	var isWIZ = _root_url.ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
	var isFJ = _root_url.ROOT_API_URL === 'https://fj-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://fj-scm.truckxi.com/api/';
	var isJTB = _root_url.ROOT_API_URL === 'https://jtb-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://jtb-scm.truckxi.com/api/';
	var isFung = _root_url.ROOT_API_URL === 'https://fung-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://fung-scm.truckxi.com/api/';
	var isTQ = _root_url.ROOT_API_URL === 'https://topquality-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://topquality-scm.truckxi.com/api/';
	var isMAG = _root_url.ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://magna-scm.truckxi.com/api/';
	var isNBT = _root_url.ROOT_API_URL === 'https://nbt-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://nbt-scm.truckxi.com/api/';
	var isKM = _root_url.ROOT_API_URL === 'https://kingmax-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://kingmax-scm.truckxi.com/api/';
	var isOCM = _root_url.ROOT_API_URL === 'https://ocm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ocm-scm.truckxi.com/api/';
	var isATL = _root_url.ROOT_API_URL === 'https://alton-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://alton-scm.truckxi.com/api/';
	var isRS = _root_url.ROOT_API_URL === 'https://redstone-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://redstone-scm.truckxi.com/api/';
	var isKDW = _root_url.ROOT_API_URL === 'https://kdw-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://kdw-scm.truckxi.com/api/';
	var isABCFF = _root_url.ROOT_API_URL === 'https://abcff-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://abcff-scm.truckxi.com/api/';
	var isYI = _root_url.ROOT_API_URL === 'https://ying-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ying-scm.truckxi.com/api/';
	var isFBD = _root_url.ROOT_API_URL === 'https://fbd-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://fbd-scm.truckxi.com/api/';
	var isCalco = _root_url.ROOT_API_URL === 'https://calco-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://calco-stage.truckxi.com/api/';
	
	var DropDownEditor = _reactDataGridAddons.Editors.DropDownEditor;
	
	var DateFormatterChina = _react2.default.createClass({
	  displayName: 'DateFormatterChina',
	  render: function render() {
	    if (this.props.value) {
	      var year = this.props.value.split('/')[2];
	      if (year) {
	        year = year.substring(2);
	      }
	      var date = this.props.value.split('/')[0] + '/' + this.props.value.split('/')[1] + '/' + year;
	      return _react2.default.createElement(
	        'span',
	        null,
	        date
	      );
	    }
	    return _react2.default.createElement(
	      'span',
	      { className: 'label label-danger' },
	      '-'
	    );
	  }
	});
	
	var DateFormatter2 = _react2.default.createClass({
	  displayName: 'DateFormatter2',
	  render: function render() {
	    if (this.props.value) {
	      var date = moment(this.props.value).format("MM-DD-YY");
	      return _react2.default.createElement(
	        'span',
	        null,
	        date
	      );
	    }
	    return _react2.default.createElement(
	      'span',
	      { className: 'label label-danger' },
	      '-'
	    );
	  }
	});
	
	var isNumeric = function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	};
	
	var Checkbox = function Checkbox(props) {
	  return _react2.default.createElement('input', _extends({}, props.input, {
	    type: 'checkbox',
	    value: !props.input.value ? "true" : "false",
	    checked: props.input.value === true || props.input.value === "true",
	    disabled: props.disabled
	  }));
	};
	
	var PriceFormatter = function (_Component) {
	  _inherits(PriceFormatter, _Component);
	
	  function PriceFormatter() {
	    _classCallCheck(this, PriceFormatter);
	
	    return _possibleConstructorReturn(this, (PriceFormatter.__proto__ || Object.getPrototypeOf(PriceFormatter)).apply(this, arguments));
	  }
	
	  _createClass(PriceFormatter, [{
	    key: 'render',
	    value: function render() {
	      var dependentValues = this.props.dependentValues;
	
	      return _react2.default.createElement(
	        'span',
	        { style: { 'font-weight': 'bold' } },
	        dependentValues
	      );
	    }
	  }]);
	
	  return PriceFormatter;
	}(_react.Component);
	
	var HMMPriceFormatter = function (_Component2) {
	  _inherits(HMMPriceFormatter, _Component2);
	
	  function HMMPriceFormatter() {
	    _classCallCheck(this, HMMPriceFormatter);
	
	    return _possibleConstructorReturn(this, (HMMPriceFormatter.__proto__ || Object.getPrototypeOf(HMMPriceFormatter)).apply(this, arguments));
	  }
	
	  _createClass(HMMPriceFormatter, [{
	    key: 'render',
	    value: function render() {
	      var _props$dependentValue = this.props.dependentValues,
	          Quantity = _props$dependentValue.Quantity,
	          UnitPrice = _props$dependentValue.UnitPrice,
	          PackageSize_1 = _props$dependentValue.PackageSize_1;
	
	      return _react2.default.createElement(
	        'span',
	        { style: { 'font-weight': 'bold' } },
	        (Quantity * UnitPrice * PackageSize_1).toFixed(2)
	      );
	    }
	  }]);
	
	  return HMMPriceFormatter;
	}(_react.Component);
	
	var SalesOrderForm = function (_Component3) {
	  _inherits(SalesOrderForm, _Component3);
	
	  function SalesOrderForm() {
	    _classCallCheck(this, SalesOrderForm);
	
	    var _this3 = _possibleConstructorReturn(this, (SalesOrderForm.__proto__ || Object.getPrototypeOf(SalesOrderForm)).call(this));
	
	    _this3.clearInventoryInfo = function () {
	      _this3.setState({
	        selectedInventoryRow: {},
	        inStock: '',
	        purchased: '',
	        presale: '',
	        net_weight: '',
	        ship_weight: '',
	        product_type: ''
	      });
	    };
	
	    _this3.closeShowSOCreated = function () {
	      _this3.setState({ showSOCreatedOpen: false });
	    };
	
	    _this3.openVerifyPasscode = function () {
	      _this3.setState({ verifyPasscodeOpen: true });
	    };
	
	    _this3.closeVerifyPasscode = function () {
	      _this3.setState({ verifyPasscodeOpen: false });
	    };
	
	    _this3.openVerifyPasscodeDiscount = function () {
	      _this3.setState({ verifyPasscodeOpenDiscount: true });
	    };
	
	    _this3.closeVerifyPasscodeDiscount = function () {
	      _this3.setState({ verifyPasscodeOpenDiscount: false });
	    };
	
	    _this3.openShippingInfoEditModal = function () {
	      _this3.setState({ shippingInfoEditModalVisibility: true });
	    };
	
	    _this3.closeShippingInfoEditModal = function () {
	      _this3.setState({ shippingInfoEditModalVisibility: false });
	    };
	
	    _this3.openFBAEditModal = function () {
	      _this3.setState({ fbaEditModalVisibility: true });
	    };
	
	    _this3.closeFBAEditModal = function () {
	      _this3.setState({ fbaEditModalVisibility: false });
	    };
	
	    _this3.modalFetchFBA = function () {
	      var fbaAdressTemp1 = [];
	      var fbaAdressTemp2 = [];
	      _this3.props.fetchFBAAddressOptions().then(function (response) {
	        if (response.data) {
	          response.data.map(function (r) {
	            fbaAdressTemp1.push({ label: r.street + ", " + r.city + ", " + r.zipcode + ", " + r.state, value: r.id });
	            fbaAdressTemp2.push({ label: r.name, value: r.id });
	          });
	          _this3.setState({ FBAOptions: fbaAdressTemp1, FBAOptions2: fbaAdressTemp2 });
	        }
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          alert('error fetching FBA address');
	        }
	      });
	    };
	
	    _this3.setShippingStatsEditModalVisibility = function () {
	      var shippingStatusEditModalVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this3.setState({ shippingStatusEditModalVisible: shippingStatusEditModalVisible });
	    };
	
	    _this3.onDiscountSavingsConfirm = function (discount, savings) {
	      var totalTax = _this3.state.totalTax;
	
	      var finalPriceTemp = 0;
	      var tax = 0;
	      if (Number(discount) > 0) {
	        if (_root_url.isElegant) {
	          tax = _this3.state.totalTaxOriginal * (1 - Number(discount) / 100);
	          _this3.setState({
	            totalTax: tax || 0
	          });
	          finalPriceTemp = Number(_this3.state.totalPrice) - Number(_this3.state.totalPrice) * (Number(discount) / 100) + tax;
	        } else {
	          tax = totalTax - totalTax * (Number(discount) / 100);
	          finalPriceTemp = Number(_this3.state.totalPrice) - Number(_this3.state.totalPrice) * (Number(discount) / 100) + tax;
	        }
	      } else if (Number(discount) === 0 && Number(savings) > 0) {
	        if (_root_url.isElegant) {
	          tax = _this3.state.totalTaxOriginal * (1 - Number(savings) / _this3.state.totalPrice);
	          finalPriceTemp = Number(_this3.state.totalPrice) - Number(savings) + tax;
	          _this3.setState({
	            totalTax: tax || 0
	          });
	        } else {
	          tax = totalTax;
	          finalPriceTemp = Number(_this3.state.totalPrice) - Number(savings) + tax;
	        }
	      } else {
	        if (_root_url.isElegant) {
	          _this3.setState({
	            totalTax: _this3.state.totalTaxOriginal
	          });
	          finalPriceTemp = Number(_this3.state.totalPrice) + _this3.state.totalTaxOriginal1;
	        } else {
	          tax = totalTax;
	          finalPriceTemp = Number(_this3.state.totalPrice) + tax;
	        }
	      }
	      finalPriceTemp = finalPriceTemp.toFixed(2);
	      _this3.setState({ SODiscount: discount, SOSavings: savings, finalPriceWithPromotion: finalPriceTemp, changeDiscountOpen: false, discountModified: true });
	    };
	
	    _this3.onChangeNameOnAccount = function (e) {
	      _this3.setState({ NameOnAccount: e.target.value });
	    };
	
	    _this3.onChangeAccountNum = function (e) {
	      _this3.setState({ AccountNum: e.target.value });
	    };
	
	    _this3.onChangeRouting = function (e) {
	      _this3.setState({ Routing: e.target.value });
	    };
	
	    _this3.onChangeEmployeeNote = function (e) {
	      _this3.setState({ employeeNoteText: e.target.value });
	    };
	
	    _this3.onChangeDeliveryFee = function (e) {
	      e.preventDefault();
	      _this3.setState({ deliveryFeeEdit: e.target.value });
	    };
	
	    _this3.onShippingWeightChange = function (e) {
	      _this3.state.finalShippingWeight = e.target.value;
	    };
	
	    _this3.showShippingInfoConfirmModal = function () {
	      _this3.setState({
	        shippingInfoConfirmModalVisibility: true
	      });
	    };
	
	    _this3.closeShippinggInfoConfirmModal = function () {
	      _this3.setState({
	        shippingInfoConfirmModalVisibility: false
	      });
	    };
	
	    _this3.handleHMMFormSubmit = function (formProps) {
	      _this3.showShippingInfoConfirmModal();
	    };
	
	    _this3.setBatchesModalVisibility = function () {
	      var isBatchesModalVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this3.setState({ isBatchesModalVisible: isBatchesModalVisible });
	    };
	
	    _this3.setBatchesModal2Visibility = function () {
	      var isBatchesModal2Visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this3.setState({ isBatchesModal2Visible: isBatchesModal2Visible });
	    };
	
	    _this3.setMultiBatchModalVisibility = function () {
	      var isMultiBatchVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this3.setState({ isMultiBatchVisible: isMultiBatchVisible });
	    };
	
	    _this3.onSelectedBatch = function (Batch_id, BatchExpiredDate, pallet_barcode) {
	      _this3.setBatchesModalVisibility();
	      _this3.handleFocusAutoSuggest();
	      _this3.setState({
	        Batch_id: Batch_id,
	        BatchExpiredDate: BatchExpiredDate,
	        pallet_barcode: pallet_barcode
	      }, _this3.checkMoveToSo);
	    };
	
	    _this3.onSelectedMultiBatch = function (rows) {
	      var checkPass = false;
	      var time = 0;
	      rows.map(function (r, index) {
	        if (Number(r.quantity) > 0) {
	          setTimeout(function () {
	            _this3.setState({
	              Batch_id: r.batchId,
	              batchQty: r.quantity,
	              pallet_barcode: r.pallet_barcode
	            }, _this3.checkMoveToSo2);
	          }, time);
	          time = time + 50;
	          checkPass = true;
	        }
	      });
	      setTimeout(function () {
	        _this3.setState({
	          selectedInventoryRow: {},
	          inStock: '',
	          inStockWarehouse: '',
	          purchased: '',
	          presale: '',
	          net_weight: '',
	          ship_weight: '',
	          total_weight: '',
	          suggestValue: ''
	        });
	        _this3.setMultiBatchModalVisibility();
	        _this3.props.resetFormInputs();
	        _this3.setAllProductQuantity(1);
	        _this3.handleFocusAutoSuggest();
	      }, 1000);
	    };
	
	    _this3.onSelectedMultiBatch2 = function (selected, lines) {
	
	      // delete select line
	      var rows = _this3.state.rows;
	      if (isJML && lines.findIndex(function (r) {
	        return r.quantity > 0;
	      }) == -1) {
	        alert('Please select a batch!');
	        return;
	      }
	      var filter_rows = rows.filter(function (item) {
	        return item.Index !== selected.Index;
	      });
	      _this3.setState({ rows: filter_rows });
	
	      // add inventory
	      var checkPass = false;
	      var time = 0;
	      lines.map(function (r, index) {
	        if (r.quantity > 0) {
	          setTimeout(function () {
	            _this3.setState({
	              Batch_id: r.batchId,
	              BatchExpiredDate: r.expire_datetime,
	              batchQty: r.quantity,
	              batchPcs: r.pcs || 0,
	              pallet_barcode: r.pallet_barcode
	            }, _this3.checkMoveToSo2);
	          }, time);
	          time = time + 50;
	          checkPass = true;
	        }
	      });
	      setTimeout(function () {
	        _this3.setState({
	          selectedInventoryRow: {},
	          inStock: '',
	          inStockWarehouse: '',
	          purchased: '',
	          presale: '',
	          net_weight: '',
	          ship_weight: '',
	          total_weight: '',
	          suggestValue: '',
	          lineQty: 0,
	          lineBatchIdx: -1
	        });
	        _this3.setBatchesModal2Visibility();
	        _this3.props.resetFormInputs();
	        _this3.setAllProductQuantity(1);
	        _this3.handleFocusAutoSuggest();
	      }, 1000);
	    };
	
	    _this3.onEditBatch = function (rows) {
	      _this3.setState({ rows: rows });
	      _this3.setBatchesModal2Visibility();
	    };
	
	    _this3.handleFormSubmit = function (formProps, isQuote) {
	      if (!isDSQ && !_root_url.isWUFS && !isABCFF && !isKDW && !isYI && !isFBD && !isWIZ && !isFJ && !isJTB) {
	        if (!formProps.receivingCustomer && _this3.context.router.routes[1].path !== 'mobileSalesOrders/:id') {
	          alert('Please select a receiving customer first.');
	          return;
	        }
	      }
	      if (isJTB && formProps.OrderType && (formProps.OrderType === "Drop Shipping" || formProps.OrderType.value === "Drop Shipping")) {
	        if (!formProps.DropshipType || formProps.DropshipType === "") {
	          alert('Please select drop shipping type.');
	          _this3.setState({
	            dropShipWarning: true
	          });
	          return;
	        }
	      }
	      var newOrder = _extends({}, formProps);
	      var quantityZero = _this3.state.rows.filter(function (obj) {
	        var match = obj.Quantity === 0;
	        return match;
	      });
	      if (quantityZero.length > 0 && !isFung && !isWIZ && !isDSQ && !_root_url.isWUFS && !isABCFF && !isKDW && !isYI && !isFBD && !isJTB && !isFJ) {
	        _this3.setState({ case: 'zeroQuantity', confirmOpen: true, quantityZero: quantityZero });
	        return;
	      }
	      var _this3$props = _this3.props,
	          createSalesOrder = _this3$props.createSalesOrder,
	          createSalesQuote = _this3$props.createSalesQuote,
	          editSalesOrder = _this3$props.editSalesOrder,
	          orderDate = _this3$props.orderDate,
	          dispatchDate = _this3$props.dispatchDate,
	          dispatchStartTime = _this3$props.dispatchStartTime,
	          dispatchEndTime = _this3$props.dispatchEndTime,
	          salesCustomerDetails = _this3$props.salesCustomerDetails,
	          shipByDate = _this3$props.shipByDate;
	
	      if (!newOrder.Notation && salesCustomerDetails && salesCustomerDetails.Notation) {
	        newOrder.Notation = salesCustomerDetails.Notation;
	      }
	
	      var fieldName = _this3.context.router.routes[1].path === 'salesOrders/new' || _this3.context.router.routes[1].path === 'outboundOrders/new' ? 'CustomerDetail_id' : 'Deliver_CustomerDetail_id';
	      if (newOrder[fieldName] && newOrder[fieldName].value) {
	        newOrder.Deliver_CustomerDetail_id = newOrder[fieldName].value;
	      } else {
	        newOrder.Deliver_CustomerDetail_id = newOrder[fieldName];
	      }
	      if (!newOrder.Deliver_CustomerDetail_id && !_root_url.isRivera && !isHMM && !isABC && !isDSQ && !_root_url.isWUFS && !isABCFF && !isKDW && !isYI && !isFBD && !isJTB && !isWIZ && !isFJ) {
	        var customer_id = _this3.props.receivingCustomer;
	        if (_typeof(_this3.props.receivingCustomer.detail_id) !== 'object') {
	          for (var i = 0; i < _this3.props.customers.length; i++) {
	            if (_this3.props.customers[i].Customer_id === _this3.props.receivingCustomer) {
	              customer_id = _this3.props.customers[i].CustomerDetail_id;
	            }
	          }
	        }
	        newOrder.Deliver_CustomerDetail_id = customer_id.detail_id || customer_id;
	      }
	
	      newOrder.Sales_Order_Lines = _reactDataGridAddons.Data.Selectors.getRows(_this3.state).map(function (row) {
	        var CostPrice = row.ProductCost;
	        if (_root_url.isEcity || _root_url.isLucky88) {
	          CostPrice = row.ArrivalPrice;
	        }
	        return _extends({}, row, {
	          CostPrice: CostPrice
	        });
	      });
	
	      newOrder.IsWholesale = false;
	      newOrder.TotalPrice = _this3.state.totalPrice;
	      newOrder.FinalWeight = _this3.state.finalWeight;
	      newOrder.FinalPrice = _this3.state.finalPrice;
	      newOrder.TotalCRV = _this3.state.totalCRV;
	      newOrder.TaxRate = _this3.state.taxValue;
	      newOrder.TaxAmount = +(0, _NumberUtil.roundTo)(_this3.state.totalTax, 2).toFixed(2);
	      newOrder.IsNoReduce = _this3.state.IsNoReduce;
	      newOrder.IsFBAAddress = _this3.state.IsFBAAddress;
	
	      var magNoteTemp = [];
	      if (isMAG) {
	        if (_this3.state.magDryrun) {
	          magNoteTemp.push('DRYRUN');
	        }
	        if (_this3.state.magOffhire) {
	          magNoteTemp.push('OFFHIRE');
	        }
	        if (_this3.state.magPierpass) {
	          magNoteTemp.push('PIERPASS');
	        }
	        if (_this3.state.magAnFee) {
	          magNoteTemp.push('AN_FEE');
	        }
	        if (_this3.state.magOther) {
	          magNoteTemp.push('OTHER');
	        }
	        if (_this3.state.magHandling) {
	          magNoteTemp.push('HANDLING');
	        }
	        if (_this3.state.magExtraStop) {
	          magNoteTemp.push('EXTRA_STOP');
	        }
	        if (_this3.state.magExam) {
	          magNoteTemp.push('EXAM');
	        }
	        if (_this3.state.magExtraDelivery) {
	          magNoteTemp.push('EXTRA_DELIVERY');
	        }
	        if (_this3.state.magStorage) {
	          magNoteTemp.push('STORAGE');
	        }
	        if (_this3.state.magBobtailFee) {
	          magNoteTemp.push('BOBTAIL_FEE');
	        }
	        if (_this3.state.magChassisSplit) {
	          magNoteTemp.push('CHASSIS_SPLIT');
	        }
	        if (_this3.state.magCTF) {
	          magNoteTemp.push('CTF');
	        }
	        if (_this3.state.magFSC) {
	          magNoteTemp.push('FSC');
	        }
	        if (_this3.state.magPrepull) {
	          magNoteTemp.push('PREPULL');
	        }
	        if (_this3.state.magCongestion) {
	          magNoteTemp.push('CONGESTION');
	        }
	        if (_this3.state.magDropoff) {
	          magNoteTemp.push('DROPOFF');
	        }
	        if (_this3.state.magOverweight) {
	          magNoteTemp.push('OVERWEIGHT');
	        }
	        newOrder.mag_note = magNoteTemp.join(',');
	      }
	
	      var magHoldTemp = [];
	      if (isMAG) {
	        if (_this3.state.mag2FREIGHT_HOLD) {
	          magHoldTemp.push('FREIGHT_HOLD');
	        }
	        if (_this3.state.mag2CUSTOM_HOLD) {
	          magHoldTemp.push('CUSTOM_HOLD');
	        }
	        if (_this3.state.mag2PIERPASS_HOLD) {
	          magHoldTemp.push('PIERPASS_HOLD');
	        }
	        if (_this3.state.mag2EXAM) {
	          magHoldTemp.push('EXAM');
	        }
	        if (_this3.state.mag2CLOSED_AREA) {
	          magHoldTemp.push('CLOSED_AREA');
	        }
	        newOrder.DeliveryStatus = magHoldTemp.join(',');
	      }
	
	      if (_this3.state.delivery) {
	        newOrder.Delivery = _this3.state.delivery;
	      } else {
	        newOrder.Delivery = 0;
	      }
	      if (!newOrder.Sales_User_id) {
	        newOrder.Sales_User_id = null;
	      } else if (_this3.props.Sales_User_id.value) {
	        newOrder.Sales_User_id = _this3.props.Sales_User_id.value;
	      }
	      newOrder.Sales_User_id = _this3.state.created_by;
	      if (dispatchDate) {
	        newOrder.DispatchDate = dispatchDate;
	      } else {
	        newOrder.DispatchDate = _this3.state.prevEstDate;
	      }
	      if (isOCM) {
	        if (dispatchStartTime) {
	          newOrder.DispatchStartTime = dispatchStartTime.value;
	        } else {
	          newOrder.DispatchStartTime = null;
	        }
	        if (dispatchEndTime) {
	          newOrder.DispatchEndTime = dispatchEndTime.value;
	        } else {
	          newOrder.DispatchEndTime = null;
	        }
	      }
	
	      if (shipByDate) {
	        newOrder.ShipByDate = shipByDate;
	      } else {
	        newOrder.ShipByDate = _this3.state.prevEstDate;
	      }
	      if (_this3.context.router.routes[1].path === 'salesOrders/new' || _this3.context.router.routes[1].path === 'salesOrders/:id' || _this3.context.router.routes[1].path === 'outboundOrders/new' || _this3.context.router.routes[1].path === 'outboundOrders/:id') {
	        newOrder.Discount = Number(_this3.state.SODiscount);
	        newOrder.Savings = Number(_this3.state.SOSavings);
	        newOrder.FinalPrice = Number(_this3.state.finalPriceWithPromotion);
	      }
	      if ((isAFG || isMyumyu || isWecom || isAFM || _root_url.isEcity || _root_url.isElegant) && _this3.props.currentSalesOrder && _this3.props.currentSalesOrder.SONum && _this3.props.currentSalesOrder.SONum.charAt(0) !== 'M' && _this3.context.router.routes[1].path === 'mobileSalesOrders/:id') {
	        newOrder.FinalPrice = Number(_this3.state.finalPriceWithPromotion);
	      }
	
	      if (!_this3.props.currentSalesOrderDetail && isFJ) {
	        console.log("add dummy here?", newOrder);
	      }
	      if (isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
	        if (_this3.context.router.routes[1].path === 'outboundOrders/new' || _this3.context.router.routes[1].path === 'outboundOrders/:id') {
	          newOrder.IsOutbound = true;
	        } else {
	          newOrder.IsOutbound = false;
	        }
	      }
	      _this3.setState({ dirty: false, editing: false, shouldDiscountInit: true });
	      if (isFung) {
	        var success = function success() {
	          if (!_this3.props.currentSalesOrderDetail) {
	            isQuote ? createSalesQuote(newOrder) : createSalesOrder(newOrder);
	          } else {
	            editSalesOrder(newOrder, _this3.props.currentSalesOrderDetail.SalesOrder_id);
	          }
	        };
	        var failed = function failed() {
	          _this3.props.getQBAuth();
	        };
	        _this3.props.QBAuthStatusCheck(success, failed);
	      } else {
	        if (!_this3.props.currentSalesOrderDetail) {
	          isQuote ? createSalesQuote(newOrder) : createSalesOrder(newOrder);
	        } else {
	          editSalesOrder(newOrder, _this3.props.currentSalesOrderDetail.SalesOrder_id);
	        }
	      }
	    };
	
	    _this3.handleTaxValueChange = function (e) {
	      var taxValue = 0;
	      if (e == null) {
	        _this3.setState({ taxValue: 0 });
	      } else {
	        _this3.setState({ taxValue: e.value });
	        taxValue = e.value;
	      }
	      var totalPrice = 0;
	      var finalWeight = 0;
	      var finalPrice = 0;
	      var totalTax = 0;
	      var totalTaxOriginal = 0;
	      var totalCRV = 0;
	      // let taxRateIndex = this.state.taxRateIndex;
	      var discount = parseFloat(_this3.props.discount) || 0;
	      var rows = [].concat(_toConsumableArray(_this3.state.rows));
	
	      rows.map(function (row) {
	        if (isHMM) {
	          totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
	        } else {
	          totalPrice += parseFloat(row.TotalPrice);
	        }
	        finalWeight += parseFloat(row.NetWeight * row.Quantity);
	        if (row.IsTaxable === true || row.IsTaxable === 'True') {
	          if (isHMM) {
	            totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(taxValue / 100);
	          } else {
	            if (isAN || _root_url.isElegant) {
	              var taxable = !_this3.props.salesCustomerDetails.Reseller;
	              if (isAN) {
	                taxable = row.IsAllTaxable === true || !_this3.props.salesCustomerDetails.Reseller;
	              }
	              if (taxable) {
	                totalTax += parseFloat(row.TotalPrice) * parseFloat(taxValue / 100);
	              }
	            } else {
	              totalTax += parseFloat(row.TotalPrice) * parseFloat(taxValue / 100);
	            }
	          }
	        }
	        if (row.CRV) {
	          row.TotalCRV = +(0, _NumberUtil.roundTo)(parseFloat(row.CRV * row.Quantity), 2).toFixed(2);
	        }
	        if (row.TotalCRV) {
	          totalCRV += row.TotalCRV;
	        }
	      });
	      totalTaxOriginal = totalTax = +(0, _NumberUtil.roundTo)(totalTax, 2).toFixed(2);
	      if (_root_url.isElegant) {
	        discount = parseFloat(_this3.state.SODiscount) || parseFloat(_this3.state.SOSavings) / totalPrice * 100 || 0;
	        totalTax = +(0, _NumberUtil.roundTo)((1 - discount / 100) * totalTax, 2).toFixed(2);
	      }
	      finalPrice = parseFloat(totalPrice) * (1 - discount / 100) + (parseFloat(totalTax) + parseFloat(totalCRV));
	      finalWeight = +(0, _NumberUtil.roundTo)(finalWeight, 2).toFixed(2);
	      totalPrice = +(0, _NumberUtil.roundToDecimals)(totalPrice, 4).toFixed(4);
	      finalPrice = +(0, _NumberUtil.roundTo)(finalPrice, 2).toFixed(2);
	      _this3.setState({
	        rows: rows, totalPrice: totalPrice, finalWeight: finalWeight, finalPrice: finalPrice, totalTax: totalTax, totalCRV: totalCRV, totalTaxOriginal: totalTaxOriginal
	      });
	    };
	
	    _this3.getShippingNameOptions = function () {
	      var phoneOptions = [];
	      if (_this3.props.salesCustomerDetails && _this3.props.salesCustomerDetails.Shipping && _this3.props.salesCustomerDetails.CustomerNum !== 'EMP9999') {
	        if (!_this3.state.useDefaultCustomerAddress && _this3.props.salesShippingCustomerDetails && _this3.props.salesShippingCustomerDetails.Shipping) {
	          _this3.props.salesShippingCustomerDetails.Shipping.map(function (ShippingInfo) {
	            phoneOptions.push({ value: ShippingInfo.CustomerDetail_id, label: '' + ShippingInfo.AddressName });
	          });
	        } else {
	          _this3.props.salesCustomerDetails.Shipping.map(function (ShippingInfo) {
	            phoneOptions.push({ value: ShippingInfo.CustomerDetail_id, label: '' + ShippingInfo.AddressName });
	          });
	        }
	      } else if (_this3.props.salesCustomerDetails && _this3.props.allShipping && _this3.props.allShipping.length && _this3.props.salesCustomerDetails.CustomerNum === 'EMP9999') {
	        _this3.props.allShipping.map(function (ShippingInfo) {
	          phoneOptions.push({ value: ShippingInfo.CustomerDetail_id, id: ShippingInfo.Customer_id, label: '' + ShippingInfo.Telephone });
	        });
	      }
	      return phoneOptions;
	    };
	
	    _this3.handleShowAll = function () {
	      _this3.fetchPreviousOrdersFromALLSalesOrder();
	    };
	
	    _this3.handleSelectAll = function () {
	      var newRows = [].concat(_toConsumableArray(_this3.state.previousOrders.rows));
	      var selectedRows = [].concat(_toConsumableArray(_this3.state.previousOrders.selectedRows));
	      var selectedIndexes = [];
	      var index = 0;
	      newRows.map(function (r) {
	        r.isSelected = true;
	        selectedIndexes.push(index);
	        selectedRows.push(r);
	        index++;
	      });
	      var previousOrders = _extends({}, _this3.state.previousOrders, { rows: newRows, selectedIndexes: selectedIndexes, selectedRows: selectedRows });
	      _this3.setState({ previousOrders: previousOrders });
	    };
	
	    _this3.handleDeselectAll = function () {
	      var newRows = [].concat(_toConsumableArray(_this3.state.previousOrders.rows));
	      var selectedIndexes = [];
	      var selectedRows = [];
	      var index = 0;
	      newRows.map(function (r) {
	        r.isSelected = false;
	      });
	      var previousOrders = _extends({}, _this3.state.previousOrders, { rows: newRows, selectedIndexes: selectedIndexes, selectedRows: selectedRows });
	      _this3.setState({ previousOrders: previousOrders });
	    };
	
	    _this3.handleVerifyPasscodeClose = function (confirmed) {
	      _this3.closeVerifyPasscode();
	      if (!confirmed) {
	        return;
	      }
	      _this3.moveToSO('move', confirmed);
	    };
	
	    _this3.handleVerifyPasscodeCloseDiscount = function (confirmed) {
	      _this3.closeVerifyPasscodeDiscount();
	      if (!confirmed) {
	        return;
	      }
	      _this3.openDiscountModal();
	    };
	
	    _this3.handleKeyPress = function (value, event) {
	
	      if (event.charCode === 13) {
	        event.preventDefault();
	        if (value == 'unitPrice' || value == 'itemNotation') {
	          if ((!isNumeric(_this3.props.quantityValue) || _this3.props.quantityValue < 0) && value !== 'quantity') {
	            return;
	          }
	        }
	        // if (value === 'quantity' && this.state.selectedInventoryRow.InStock == null) {
	        //   return;
	        // }
	        _reactDom2.default.findDOMNode(_this3.refs[value].getRenderedComponent().myInput.refs.input).focus();
	      }
	    };
	
	    _this3.handleFocusQty = function () {
	      if (isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD) {
	        _reactDom2.default.findDOMNode(_this3.refs.unitPrice.getRenderedComponent().myInput.refs.input).focus();
	        _reactDom2.default.findDOMNode(_this3.refs.unitPrice.getRenderedComponent().myInput.refs.input).select();
	      } else if (isJML) {
	        _reactDom2.default.findDOMNode(_this3.refs.jmlBox.getRenderedComponent().myInput.refs.input).focus();
	        _reactDom2.default.findDOMNode(_this3.refs.jmlBox.getRenderedComponent().myInput.refs.input).select();
	      } else {
	        _reactDom2.default.findDOMNode(_this3.refs.quantity.getRenderedComponent().myInput.refs.input).focus();
	        _reactDom2.default.findDOMNode(_this3.refs.quantity.getRenderedComponent().myInput.refs.input).select();
	      }
	    };
	
	    _this3.openShippingInfoFormModal = function () {
	      _this3.setState({
	        shippingInfoModalVisibility: true
	      });
	    };
	
	    _this3.closeShippingInfoFormModal = function () {
	      _this3.setState({
	        shippingInfoModalVisibility: false
	      });
	    };
	
	    _this3.renderShippingStatsEdit = function () {
	      var currentSalesOrderDetail = _this3.props.currentSalesOrderDetail;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          onClick: function onClick() {
	            return _this3.setShippingStatsEditModalVisibility(true);
	          }
	          // disabled={!currentSalesOrderDetail || currentSalesOrderDetail.ShippingStatus === "Outbound"}
	        },
	        _react2.default.createElement('em', { className: 'fa fa-edit' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_status_edit' })
	      );
	    };
	
	    _this3.shippingIFrameIsLoaded = function () {
	      if (!_this3.state.shippingPdfFrameLoaded) {
	        var pdfFrame = window.frames.shippingPdf;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this3.setState({ shippingPdfFrameLoaded: true });
	      }
	    };
	
	    _this3.packingIFrameIsLoaded = function () {
	      if (!_this3.state.packingListPdfFrameLoaded) {
	        var pdfFrame = window.frames.packingPdf;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this3.setState({ packingListPdfFrameLoaded: true });
	      }
	    };
	
	    _this3.pickingIFrameIsLoaded = function () {
	      if (!_this3.state.pickingListPdfFrameLoaded) {
	        var pdfFrame = window.frames.pickingPdf;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this3.setState({ pickingListPdfFrameLoaded: true });
	      }
	    };
	
	    _this3.salesOrderIFrameIsLoaded = function () {
	      if (!_this3.state.salesOrderPdfFrameLoaded) {
	        var pdfFrame = window.frames.salesOrderPdf;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this3.setState({ salesOrderPdfFrameLoaded: true });
	      }
	    };
	
	    _this3.salesOrderSIIFrameIsLoaded = function () {
	      if (!_this3.state.salesOrderSIPdfFrameLoaded) {
	        var pdfFrame = window.frames.salesOrderSIPdf;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this3.setState({ salesOrderSIPdfFrameLoaded: true });
	      }
	    };
	
	    _this3.handlePrintFrameOnLoad = function () {
	      _this3.setState({ refundPDFFrameLoaded: true });
	    };
	
	    _this3.renderSales = function () {
	      if (_root_url.isLO) {
	        var Users = _this3.getUsers();
	        var currentSalesOrderDetail = _this3.props.currentSalesOrderDetail;
	
	        var selectionShouldDisable = !currentSalesOrderDetail ? false : _this3.state.Released || currentSalesOrderDetail.SaleStatus === 'Finalized' || currentSalesOrderDetail.SaleStatus === 'Refunded' || currentSalesOrderDetail.SaleStatus === 'Partially Refunded' || currentSalesOrderDetail.SaleStatus === 'Canceled' || _this3.state.editing;
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12, style: { display: 'flex' } },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	            ': '
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sales-order-sodetails-sales' },
	            _react2.default.createElement(_GenericSelection2.default, {
	              options: Users,
	              disabled: selectionShouldDisable,
	              value: _this3.state.created_by,
	              setSelected: function setSelected(e) {
	                _this3.setState({ created_by: e.value });
	              }
	            })
	          )
	        );
	      }
	    };
	
	    _this3.goToNewSales = function (newRoute) {
	      _this3.setState({
	        showSOCreatedOpen: false,
	        rows: [],
	        Billing: {
	          AddressName: '',
	          Cellphone: '',
	          City: '',
	          CustomerDetail: '',
	          Email: '',
	          Fax: '',
	          FirstName: '',
	          IsDefault: null,
	          IsDeleted: null,
	          LastName: '',
	          Note: '',
	          Position: '',
	          State: '',
	          Telephone: '',
	          Type: '',
	          Zip: '',
	          Notation: ''
	        }
	      }, function () {
	        if (_this3.props.dispatchDate && _this3.props.prevEstDate !== _this3.props.dispatchDate) {
	          _this3.props.keepEstDate({ date: _this3.props.dispatchDate }, newRoute);
	        } else {
	          _this3.props.keepEstDate({ date: _this3.state.prevEstDate }, newRoute);
	        }
	      });
	    };
	
	    _this3.printSI = function () {
	      _this3.props.printSalesOrderSI(_this3.props.salesOrderCreated.SalesOrder_id);
	    };
	
	    _this3.openVerifyPasscodeToCreaterSO = function () {
	      _this3.setState({
	        verifyPasscodeToCreateSOModalOpen: true
	      });
	    };
	
	    _this3.closeVerifyPasscodeToCreateSO = function () {
	      _this3.setState({
	        verifyPasscodeToCreateSOModalOpen: false
	      });
	    };
	
	    _this3.handleVerifypasscodeToCreateSOClose = function (confirmed) {
	      _this3.closeVerifyPasscodeToCreateSO();
	      if (confirmed) {
	        _this3.setState({
	          customerVerified: true
	        }, function () {
	          _this3.moveToSO('move', true, true);
	        });
	      }
	    };
	
	    _this3.reFetchSalesCustomers = function () {
	      _this3.closeShippingInfoEditModal();
	      var selectedSalesCustomer = _this3.props.receivingCustomer;
	      _this3.props.setValue('salesOrderForm', 'receivingCustomer', '');
	      _this3.props.fetchCustomers(function () {
	        _this3.props.setValue('salesOrderForm', 'receivingCustomer', selectedSalesCustomer);
	      });
	      var fieldName = _this3.context.router.routes[1].path === 'salesOrders/new' || _this3.context.router.routes[1].path === 'outboundOrders/new' ? 'CustomerDetail_id' : 'Deliver_CustomerDetail_id';
	      setTimeout(function () {
	        if (_this3.getShippingNameOptions() && _this3.getShippingNameOptions().length > 0) {
	          _this3.props.setValue('salesOrderForm', fieldName, _this3.getShippingNameOptions()[_this3.getShippingNameOptions().length - 1].value);
	        }
	      }, 1500);
	    };
	
	    _this3.reloadThePage = function () {
	      var currentSalesOrder = _this3.props.currentSalesOrder;
	
	      var route = '';
	      if (_this3.context.router.routes[1].path === 'salesOrders/new' || _this3.context.router.routes[1].path === 'salesOrders/:id' || _this3.context.router.routes[1].path === 'outboundOrders/new' || _this3.context.router.routes[1].path === 'outboundOrders/:id') {
	        route = 'salesOrders';
	      } else if (_this3.context.router.routes[1].path === 'mobileSalesOrders/new' || _this3.context.router.routes[1].path === 'mobileSalesOrders/:id') {
	        route = 'mobileSalesOrders';
	      }
	      _this3.setShippingStatsEditModalVisibility();
	      _this3.props.fetchSalesOrderDetail(currentSalesOrder.SalesOrder_id, route);
	    };
	
	    _this3.handleEditNotesButtonClick = function () {
	      _this3.setNotesModalVisibility(true);
	    };
	
	    _this3.setNotesModalVisibility = function () {
	      var isNotesModalVisibile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this3.setState({ isNotesModalVisibile: isNotesModalVisibile });
	    };
	
	    _this3.renderNotesEditButton = function () {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          onClick: _this3.handleEditNotesButtonClick
	        },
	        _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	        ' ',
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_notes' })
	      );
	    };
	
	    _this3.getPanelClassName = function () {
	      var prefix = 'sales-order-customer-info-extendedHeight';
	      if (isOCM) {
	        return prefix + '-lg';
	      }
	      if (isHMM) {
	        return prefix;
	      }
	      if (isTN || isTQ || isNBT || isKM) {
	        return prefix + '-md';
	      } else {
	        return '';
	      }
	    };
	
	    _this3.checkToAddPromotedProduct = function (productNum) {
	      var promotedProductQty = _this3.calculateQtyOfPromotedProduct(productNum);
	      if (promotedProductQty) {
	        _this3.setPromotionAddingAlertModalVisibility(true);
	      }
	    };
	
	    _this3.modifyExsitingPromotion = function (productNum) {
	      var productPromotions = _this3.props.productPromotions;
	
	
	      var filterdPromotion = productPromotions.filter(function (p) {
	        return p.Method === "BuyAGetB" && p.IsPercent && p.Off === 100;
	      });
	
	      var promotedProductonTable = _this3.state.rows.filter(function (row) {
	        return row.ProductNum === filterdPromotion[0].RelatedProductNum && row.UnitPrice == 0;
	      });
	      var promotedProductQty = _this3.calculateQtyOfPromotedProduct(productNum);
	      if (promotedProductonTable[0].Quantity != promotedProductQty) {
	        var rows = _lodash2.default.map(_this3.state.rows, function (row) {
	          if (row.ProductNum === filterdPromotion[0].RelatedProductNum && row.IsGift) {
	            return _extends({}, row, {
	              Quantity: promotedProductQty
	            });
	          }
	          return row;
	        });
	        _this3.setState({
	          rows: rows
	        });
	      }
	    };
	
	    _this3.setPromotionAddingAlertModalVisibility = function () {
	      var isPromotionAddingAlertModalVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this3.setState({ isPromotionAddingAlertModalVisible: isPromotionAddingAlertModalVisible });
	    };
	
	    _this3.checkForPromotions = function (productNum) {
	      // Check if the editing product is qualified for promotion
	      var productPromotions = _this3.props.productPromotions;
	
	
	      if (_root_url.isEcity) {
	        var filterdPromotion = productPromotions.filter(function (p) {
	          return p.Method === "BuyAGetB" && p.IsPercent && p.Off === 100;
	        });
	        if (!filterdPromotion || !filterdPromotion[0]) return;
	        var promotedProductonTable = _this3.state.rows.filter(function (row) {
	          return row.ProductNum === filterdPromotion[0].RelatedProductNum && (!row.UnitPrice || row.UnitPrice === '0' || row.UnitPrice === '0.00' || row.UnitPrice === '0.0');
	        });
	        if (!promotedProductonTable[0]) {
	          // check and add promoted product to the list
	          _this3.checkToAddPromotedProduct(productNum);
	        } else {
	          // if is already added, adjust promoted product qty
	          _this3.modifyExsitingPromotion(productNum);
	        }
	        return;
	      }
	    };
	
	    _this3.calculateQtyOfPromotedProduct = function (productNum) {
	      var productPromotions = _this3.props.productPromotions;
	
	      var productTotalQty = _lodash2.default.reduce(_this3.state.rows, function (acc, current) {
	        if (current.ProductNum === productNum && !current.IsGift) {
	          return acc + parseFloat(current.Quantity);
	        }
	        return acc;
	      }, 0);
	      var filterdPromotion = productPromotions.filter(function (p) {
	        return p.Method === "BuyAGetB" && p.IsPercent && p.Off === 100;
	      });
	      var temp = filterdPromotion.sort(function (a, b) {
	        return a.FromQty > b.FromQty ? -1 : 1;
	      });
	      var promotedProductQty = _lodash2.default.reduce(temp, function (acc, current) {
	        var qty = parseInt(productTotalQty / current.FromQty);
	        productTotalQty = productTotalQty - qty * current.FromQty;
	        return acc + qty * current.RelatedQuantity;
	      }, 0);
	      return promotedProductQty;
	    };
	
	    _this3.handlePromotionAddConfirmClick = function () {
	      var _this3$props2 = _this3.props,
	          productPromotions = _this3$props2.productPromotions,
	          Company_id = _this3$props2.Company_id,
	          Pickup_Warehouse_id = _this3$props2.Pickup_Warehouse_id;
	
	      var filterdPromotion = productPromotions.filter(function (p) {
	        return p.Method === "BuyAGetB" && p.IsPercent && p.Off === 100;
	      });
	      var promotedProductQty = _this3.calculateQtyOfPromotedProduct(filterdPromotion[0].ProductNum);
	      var customer = _this3.state.currentCustomer.value || _this3.state.currentCustomer;
	      var RelatedProduct_id = filterdPromotion[0].RelatedProduct_id;
	      var success = function success(productDetails) {
	        var rows = [].concat(_toConsumableArray(_this3.state.rows));
	        var gift = _extends({}, productDetails, {
	          Quantity: promotedProductQty,
	          UnitPrice: '0',
	          TotalPrice: '0',
	          IsGift: true
	        });
	        rows.push(gift);
	        _this3.setState({
	          rows: rows
	        });
	      };
	      _this3.props.fetchProductDetail(RelatedProduct_id, customer, Company_id, Pickup_Warehouse_id, success);
	    };
	
	    _this3.renderSalesOrderMargin = function () {
	      if (!_root_url.isEcity && !_root_url.isLucky88) return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 6 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_margin' }),
	            ':'
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 6 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _this3.props.currentSalesOrderDetail && _this3.props.currentSalesOrderDetail.SalesMargin + '%'
	          )
	        )
	      );
	    };
	
	    _this3.renderRollingGate = function () {
	      if (false) {
	        //className="tab-products-table sales-order-freq-products"
	        return _react2.default.createElement(
	          _reactBootstrap.Tab,
	          { eventKey: 5, title: 'Rolling Gate' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-xs-3' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dim_l_w' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-3' },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'gate_l', component: _inputField.InputField })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-1', style: { textAlign: 'center' } },
	                  'X'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-3' },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'gate_w', component: _inputField.InputField })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-1', style: { textAlign: 'center' } },
	                  '(ft)'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-xs-2' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'motor' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-4' },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'gate_motor', component: _selection.Selection, options: [{ label: 'Small', value: 'small' }, { label: 'Large', value: 'large' }] })
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-xs-1' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-4' },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'gate_quantity', component: _inputField.InputField })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-xs-3' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'roller_shutter' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-8' },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'gate_shutter', component: _selection.Selection, options: [{ label: '3 Inch', value: '3' }, { label: '4 Inch', value: '4' }] })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-xs-2' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lock' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-4' },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'gate_lock', component: _selection.Selection, options: [{ label: 'Yes', value: true }, { label: 'No', value: false }] })
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-xs-1' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-4' },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'gate_quantity_lock', component: _inputField.InputField, disabled: !_this3.props.gate_lock || !_this3.props.gate_lock.value })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-xs-3' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reel' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-8' },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'gate_reel', component: _selection.Selection, options: [{ label: 'Small', value: 'small' }, { label: 'Large', value: 'large' }] })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-xs-3' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'roller_chain' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-8' },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'gate_roller_chain', component: _selection.Selection, options: [{ label: 'Yes', value: true }, { label: 'No', value: false }] })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-xs-3' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'guide_track' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-8' },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'gate_guide_track', component: _selection.Selection, options: [{ label: 'Thin', value: 'thin' }, { label: 'Thick', value: 'thick' }] })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'col-xs-3' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bottom_beam' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-8' },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'gate_bottom_beam', component: _selection.Selection, options: [{ label: 'Yes', value: true }, { label: 'No', value: false }] })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'primary',
	                  type: 'button',
	                  onClick: _this3.props.handleSubmit(function (form) {
	                    console.log('form', form);
	                  }),
	                  style: { width: '100%' }
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	              )
	            )
	          )
	        );
	      }
	    };
	
	    _this3.state = {
	      dropShipWarning: false,
	      // resellerTemp: null,
	      containerSizeOptions: [{ label: "20", value: "20" }, { label: "40", value: "40" }, { label: "45", value: "45" }],
	      stateOptions: [{ label: "CA", value: "CA" }, { label: "PA", value: "PA" }],
	      paymentTermOptions: [],
	      yiWarehouseOptions: [],
	      FJAgentOptions: [],
	      FBAOptions: [],
	      FBAOptions2: [],
	      fjCarrierOptions: [],
	      SalesOrderTypeSyOptions: [{ label: "Retail", value: "Retail" }, { label: "Wholesale", value: "Wholesale" }],
	      magStatusOptions: [{ label: "NOT READY", value: "NOT_READY" }, { label: "NOT READY HOLD NEED RELEASE", value: "NOT_READY_HOLD_NEED_RELEASE" }, { label: 'DISCHARGE', value: "DISCHARGE" }, { label: 'DISCHARGE HOLD NEED RELEASE', value: "DISCHARGE_HOLD_NEED_RELEASE" }, { label: "LOAD READY FOR PICKUP", value: "LOAD_READY_FOR_PICKUP" }, { label: 'LOAD OUT ON AND READY FOR DELIVERY', value: "LOAD_OUT_ON_AND_READY_FOR_DELIVERY" }, { label: "LOAD DELIVERED ON", value: "LOAD_DELIVERED_ON" }, { label: "EMPTY READY FOR PICKUP", value: "EMPTY_READY_FOR_PICKUP" }, { label: 'EMPTY BACK TO', value: "EMPTY_BACK_TO" }, { label: "EMPTY RETURNED ON", value: "EMPTY_RETURNED_ON" }],
	      kdwStatusOptions: [{ label: "DISPATCHED", value: "DISPATCHED" }, { label: "ON THE WAY TO PORT", value: "ON_THE_WAY_TO_PORT" }, { label: 'ON THE WAY TO CUSTOMER', value: "ON_THE_WAY_TO_CUSTOMER" }, { label: 'ON THE WAY TO YARD', value: "ON_THE_WAY_TO_YARD" }, { label: "ON THE WAY TO KDW", value: "ON_THE_WAY_TO_KDW" }, { label: 'DELIVERED TO CUSTOMER', value: "DELIVERED_TO_CUSTOMER" }, { label: "DELIVERED TO KDW", value: "DELIVERED_TO_KDW" }, { label: "FULL IN YARD", value: "FULL_IN_YARD" }, { label: "DELIVERED TO EXAM SITE", value: "DELIVERED_TO_EXAM_SITE" }, { label: "EMPTY IN YARD", value: "EMPTY_IN_YARD" }],
	      magNoteOptions: [{ label: "DRYRUN", value: "DRYRUN" }, { label: "OVERWEIGHT", value: "OVERWEIGHT" }, { label: "UTL", value: "UTL" }, { label: "PORTWAITING", value: "PORTWAITING" }, { label: 'OFFHIRE', value: "OFFHIRE" }, { label: 'HANDLING', value: "HANDLING" }, { label: 'PIERPASS', value: "PIERPASS" }, { label: 'AN_FEE', value: "AN_FEE" }, { label: 'OTHER', value: "OTHER" }, { label: "EXTRA STOP", value: "EXTRA STOP" }, { label: "NO APPT FOR EMPTY RETURN", value: "NO APPT FOR EMPTY RETURN" }, { label: 'EXAM', value: "EXAM" }, { label: "REJECTED", value: "REJECTED" }, { label: "REDELIVERY", value: "REDELIVERY" }],
	      magTerminalOptions: [{ label: "EVERPORT", value: "EVERPORT" }, { label: "LBCT", value: "LBCT" }, { label: "SHIPPERS-CARSON", value: "SHIPPERS-CARSON" }, { label: "SHIPPERS-ALAMEDA", value: "SHIPPERS-ALAMEDA" }, { label: 'SHIPPERS-LONGBEACH', value: "SHIPPERS-LONGBEACH" }, { label: "TRAPAC", value: "TRAPAC" }, { label: "WBCT", value: "WBCT" }, { label: 'PCT', value: "PCT" }, { label: "ITS", value: "ITS" }, { label: "APM", value: "APM" }, { label: "C60-MATSON", value: "C60-MATSON" }, { label: "TTI", value: "TTI" }, { label: "YUSEN", value: "YUSEN" }, { label: "FMS", value: "FMS" }, { label: "PIER-A", value: "PIER-A" }, { label: "EXAM-SITE", value: "EXAM-SITE" }, { label: "OTHER", value: "OTHER" }],
	      magShippingLineOptions: [{ label: "EVERGREEN", value: "EVERGREEN" }, { label: "CMA", value: "CMA" }, { label: "MATSON", value: "MATSON" }, { label: "MSC", value: "MSC" }, { label: 'MAERSK', value: "MAERSK" }, { label: "CMA", value: "CMA" }, { label: "YANGMING", value: "YANGMING" }, { label: 'COSCO', value: "COSCO" }, { label: "SM LINE", value: "SM LINE" }, { label: "WANHAI", value: "WANHAI" }, { label: "HYUNDAI", value: "HYUNDAI" }, { label: "BAL", value: "BAL" }, { label: "HAPAG LLOYD", value: "HAPAG LLOYD" }, { label: "SUD ", value: "SUD " }, { label: "ONE ", value: "ONE " }, { label: "APL ", value: "APL " }, { label: "ZIM ", value: "ZIM " }, { label: "CU LINE", value: "CU LINE" }, { label: "TRANSFAR", value: "TRANSFAR" }, { label: "SJJ", value: "SJJ" }, { label: "LIHUA", value: "LIHUA" }, { label: "SEALEAD", value: "SEALEAD" }, { label: "OOLU", value: "OOLU" }],
	      magSizeOptions: [{ label: "40HC", value: "40HC" }, { label: "45ft", value: "45ft" }, { label: "40ST", value: "40ST" }, { label: "20ft", value: "20ft" }, { label: "40RF", value: "40RF" }],
	      creditAmount: 0,
	      shareCreditAmount: 0,
	
	      shippingInfoModalVisibility: false,
	      ShippingMethod: '',
	      cellSelectEnabled: true,
	      firstFocus: true,
	      useDefaultCustomerAddress: true,
	      // Customer payment term
	      paymentTerm: null,
	      salesOrderNumber: null,
	      customerPaymentTerm: null,
	      productHistoryLabel: '',
	      // Determine Modal visibility
	      openOrderOpen: false,
	      historyOpen: false,
	      customerOpen: false,
	      confirmOpen: false,
	      showInventoryOpen: false,
	      showShippingOpen: false,
	      changeTaxOpen: false,
	      changeDiscountOpen: false,
	      SODiscount: 0,
	      SOSavings: 0,
	      finalPriceWithPromotion: 0,
	      employeeNoteText: '',
	      employeeNoteDisplay: '',
	      changeEmployeeNoteOpen: false,
	      deliveryFeeEdit: null,
	      changeWeightOpen: false,
	      changeDeliveryFeeOpen: false,
	      editSOPermissionOpen: false,
	      confirmRefundOpen: false,
	      deliveryMethodModalOpen: false,
	      showCarrierButton: false,
	      carrierInfoModalOpen: false,
	
	      currentZBL: "",
	      ZBLRowIndex: null,
	      ZBLModalOpen: false,
	      zoneDisplay: "",
	      zoneSelected: null,
	      zoneOptions: [
	        // {label: "1", value: "1"},
	        // {label: "2z", value: "2"},
	      ],
	      binDisplay: "",
	      binSelected: null,
	      binOptions: [
	        // {label: "1b", value: "1"},
	        // {label: "2b", value: "2"},
	      ],
	      levelDisplay: "",
	      levelSelected: null,
	      levelOptions: [
	        // {label: "1lv", value: "1"},
	        // {label: "2lv", value: "2"},
	      ],
	
	      isDropshipOpen: false,
	      createBOLModalVisibility: false,
	      verifyPasscodeOpen: false,
	      verifyPasscodeOpenDiscount: false,
	      // Tracks what error to display
	      case: null,
	      dirty: false,
	      // Customer details
	      Amount00_30: 0,
	      Amount31_60: 0,
	      Amount61_90: 0,
	      Amount91: 0,
	      // Determine expand state of panels
	      favoriteItemsOpen: true,
	      previousOrdersOpen: false,
	      promotionsOpen: false,
	      // Tracks information on customer currently chosen
	      currentCustomer: null,
	      currentCustomerName: null,
	      // Variable used to determine which column to highlight prices
	      currentPriceLevel: null,
	      customersWithFavorites: [],
	      salesItemHistory: [],
	      // Keeps track of current item to be added to SO
	      selectedItemName: '',
	      selectedItemNumber: '',
	      refPrice: null,
	      defaultRefPrice: 0,
	      // Order details
	      totalPrice: 0,
	      finalWeight: 0,
	      finalNetWeight: 0,
	      finalShippingWeight: 0,
	      totalTax: 0,
	      finalPrice: 0,
	      totalCRV: 0,
	      // Tracks items in SO table
	      rows: [],
	      selectedRows: [],
	      filteredRows: [],
	      filters: {},
	      sortColumn: null,
	      sortDirection: null,
	      inventoryInput: null,
	      // Track tax rate to use
	      taxRate: null,
	      // Assorted objects holding items in respective tables
	      inventories: {
	        rows: [],
	        allRows: [],
	        currString: null,
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	      favorites: {
	        rows: [],
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null,
	        selectedIndexes: []
	      },
	      // Previous SOs, default time for 3 months
	      days: '90',
	      FromDate: undefined,
	      ToDate: undefined,
	      previousSOs: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      previousOrders: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null,
	        selectedIndexes: []
	      },
	      quickEntrySONum: '',
	      quickEntryShowError: false,
	      promotions: {
	        rows: [],
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	      itemHistory: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	      frequentItems: {
	        rows: [],
	        selectedRows: [],
	        sortColumn: null,
	        sortDirection: null,
	        selectedIndexes: [],
	        selectedPK: []
	      },
	      salesHistory: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null,
	        filters: {}
	      },
	      selectedInventoryRow: {},
	      modified_by: null,
	      updateTime: null,
	      created_by: null,
	      created_by_name: null,
	      quantityZero: [],
	
	      yourOrderTableHeight: window.innerHeight < 930 ? 345 : 345,
	      taxRateIndex: 0,
	      yourOrderKey: 1,
	      inboundInfoKey: 1,
	      fjInfoKey: 1,
	
	      NameOnAccount: null,
	      AccountNum: null,
	      Routing: null,
	
	      editSOPermission: true,
	      paymentInfo: null,
	      shouldPaymentInfoShow: false,
	      refundAmount: 0.00,
	      refundReason: '',
	      CompanyName: '',
	      Billing: {
	        AddressName: '',
	        Cellphone: '',
	        City: '',
	        CustomerDetail: '',
	        Email: '',
	        Fax: '',
	        FirstName: '',
	        IsDefault: null,
	        IsDeleted: null,
	        LastName: '',
	        Note: '',
	        Position: '',
	        State: '',
	        Telephone: '',
	        Type: '',
	        Zip: '',
	        Notation: ''
	      },
	      ShipTo: {
	        Address: '',
	        Telephone: '',
	        Name: ''
	      },
	      Shipping: {
	        AddressName: '',
	        Cellphone: '',
	        City: '',
	        CustomerDetail: '',
	        Email: '',
	        Fax: '',
	        FirstName: '',
	        IsDefault: null,
	        IsDeleted: null,
	        LastName: '',
	        Note: '',
	        Position: '',
	        State: '',
	        Telephone: '',
	        Type: '',
	        Zip: '',
	        TimeSlot: ''
	      },
	      prevEstDate: false,
	      Released: false,
	      editing: false,
	      suggestValue: '',
	
	      magDryrun: false,
	      magOffhire: false,
	      magHandling: false,
	      magPierpass: false,
	      magAnFee: false,
	      magOther: false,
	      magExtraStop: false,
	      magExam: false,
	      magExtraDelivery: false,
	      magStorage: false,
	      magBobtailFee: false,
	      magChassisSplit: false,
	      magCTF: false,
	      magFSC: false,
	      magPrepull: false,
	      magCongestion: false,
	      magDropoff: false,
	      magOverweight: false,
	
	      mag2FREIGHT_HOLD: false,
	      mag2CUSTOM_HOLD: false,
	      mag2PIERPASS_HOLD: false,
	      mag2EXAM: false,
	      mag2CLOSED_AREA: false,
	
	      shippingPdfFrameLoaded: true,
	      pickingListPdfFrameLoaded: true,
	      packingListPdfFrameLoaded: true,
	      salesOrderPdfFrameLoaded: true,
	      salesOrderSIPdfFrameLoaded: true,
	      refundPDFFrameLoaded: true,
	
	      // Default tax value
	      taxValue: 0,
	      // Specifically for the previous Order search
	      searchSalesOrderNum: '',
	      salesOrderIndexFromLast: 1,
	
	      // CheckboxFormatter
	      IsNoReduce: false,
	      IsFBAAddress: false,
	      Sales_User_id: undefined,
	
	      PaymentTermDesc: '',
	      CreditLimit: '',
	      delivery: 0,
	      verifyPasscodeToCreateSOModalOpen: false,
	      customerVerified: false,
	      fee: 0,
	
	      shippingInfoEditModalVisibility: false,
	      fbaEditModalVisibility: false,
	      shippingInfoConfirmModalVisibility: false,
	      discountModified: false,
	
	      shippingStatusEditModalVisible: false,
	      isNotesModalVisibile: false,
	
	      // TQ, OCM
	      companyOptions: null,
	      warehouseOptions: null,
	      // modal
	      isBatchesModalVisible: false,
	      isBatchesModal2Visible: false,
	      isMultiBatchVisible: false,
	      lineBatchId: null,
	      lineBatchIdx: null,
	      lineQty: 0,
	      lineBatchRows: [],
	      isPromotionAddingAlertModalVisible: null,
	      groupOptions: []
	    };
	    _this3.openCustomer = _this3.openCustomer.bind(_this3);
	    _this3.closeCustomer = _this3.closeCustomer.bind(_this3);
	    _this3.openHistory = _this3.openHistory.bind(_this3);
	    _this3.closeHistory = _this3.closeHistory.bind(_this3);
	    _this3.moveToSO = _this3.moveToSO.bind(_this3);
	    _this3.barcodeScan = _this3.barcodeScan.bind(_this3);
	    _this3.handleUnitPriceChange = _this3.handleUnitPriceChange.bind(_this3);
	    _this3.openConfirm = _this3.openConfirm.bind(_this3);
	    _this3.closeConfirm = _this3.closeConfirm.bind(_this3);
	    _this3.closeShowInventory = _this3.closeShowInventory.bind(_this3);
	    _this3.selectInventoryInfo = _this3.selectInventoryInfo.bind(_this3);
	    _this3.handleOnFocus = _this3.handleOnFocus.bind(_this3);
	    _this3.openShowSOCreated = _this3.openShowSOCreated.bind(_this3);
	    _this3.openEditSOPermission = _this3.openEditSOPermission.bind(_this3);
	    _this3.closeEditSOPermission = _this3.closeEditSOPermission.bind(_this3);
	    _this3.closeDropship = _this3.closeDropship.bind(_this3);
	    _this3.openDropship = _this3.openDropship.bind(_this3);
	    _this3.openShipping = _this3.openShipping.bind(_this3);
	    _this3.openCreateBOLModal = _this3.openCreateBOLModal.bind(_this3);
	    _this3.closeCreateBOLModal = _this3.closeCreateBOLModal.bind(_this3);
	    _this3.closeShipping = _this3.closeShipping.bind(_this3);
	    _this3.openChangeTax = _this3.openChangeTax.bind(_this3);
	    _this3.closeChangeTax = _this3.closeChangeTax.bind(_this3);
	    _this3.openEmployeeNote = _this3.openEmployeeNote.bind(_this3);
	    _this3.closeEmployeeNote = _this3.closeEmployeeNote.bind(_this3);
	
	    _this3.openAchEdit = _this3.openAchEdit.bind(_this3);
	    _this3.closeAchEdit = _this3.closeAchEdit.bind(_this3);
	
	    _this3.openDeliveryFee = _this3.openDeliveryFee.bind(_this3);
	    _this3.closeDeliveryFee = _this3.closeDeliveryFee.bind(_this3);
	    _this3.handleSelect = _this3.handleSelect.bind(_this3);
	    _this3.handleSelect2 = _this3.handleSelect2.bind(_this3);
	    _this3.handleSelect3 = _this3.handleSelect3.bind(_this3);
	    _this3.handleDiscountChange = _this3.handleDiscountChange.bind(_this3);
	    _this3.setAllProductQuantity = _this3.setAllProductQuantity.bind(_this3);
	    _this3.openDeliveryMethodModal = _this3.openDeliveryMethodModal.bind(_this3);
	    _this3.openCarrierInfoModal = _this3.openCarrierInfoModal.bind(_this3);
	    _this3.closeCarrierInfoModal = _this3.closeCarrierInfoModal.bind(_this3);
	    _this3.closeDeliveryMethodModal = _this3.closeDeliveryMethodModal.bind(_this3);
	
	    _this3.openZBLModal = _this3.openZBLModal.bind(_this3);
	    _this3.closeZBLModal = _this3.closeZBLModal.bind(_this3);
	
	    _this3.handleUpdatePrice = _this3.handleUpdatePrice.bind(_this3);
	    _this3.fetchPreviousSalesOrderByCustomer = _this3.fetchPreviousSalesOrderByCustomer.bind(_this3);
	    _this3.fetchPreviousOrdersFromALLSalesOrder = _this3.fetchPreviousOrdersFromALLSalesOrder.bind(_this3);
	    _this3.fetchPreviousOrderBySearch = _this3.fetchPreviousOrderBySearch.bind(_this3);
	    return _this3;
	  }
	
	  _createClass(SalesOrderForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this4 = this;
	
	      if (isAFG && this.props.currentSalesOrder && this.props.currentSalesOrder.SONum && this.props.currentSalesOrder.SONum.charAt(0) !== 'M') {
	        if (this.context.router.routes[1].path === 'mobileSalesOrders/:id' || this.context.router.routes[1].path === 'salesOrders/:id') {
	          this.state.showCarrierButton = true;
	        }
	      }
	      this.props.fetchBaseUsers();
	      this.props.setValue('salesOrderForm', 'Pickup_Warehouse_id', null);
	      this.props.setValue('salesOrderForm', 'Sales_User_id', null);
	      this.getCompanyOptions();
	      var route = null;
	      var currentSalesOrder = void 0;
	      this.props.fetchVendors();
	      // https://ct-scm.truckxi.com/api/v1/sale/sales_order/?pk=56774
	      if (this.props.currentSalesOrder) {
	        var Released = this.props.currentSalesOrder.SaleStatus === 'Released';
	        this.setState({ Released: Released });
	        this.props.setValue('salesOrderForm', 'CustomerDetail_id', this.props.currentSalesOrder.Deliver_CustomerDetail_id);
	      }
	      if (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
	        route = 'salesOrders';
	      } else if (this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id') {
	        route = 'mobileSalesOrders';
	      }
	      var _props = this.props,
	          pathname = _props.location.pathname,
	          id = _props.params.id;
	
	      if (!currentSalesOrder && !id) {
	        if (pathname.includes('mobileSalesOrders/new')) {
	          this.context.router.push('/mobileSalesOrders/');
	        }
	      }
	      if (this.context.router.routes[1].path !== 'salesOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'mobileSalesOrders/new') {
	        currentSalesOrder = this.props.currentSalesOrder;
	      }
	
	      this.props.fetchTaxRates().then(function () {
	        var taxRateOptions = _this4.getTaxRateOptions();
	        if ((isHMM || _root_url.isElegant) && taxRateOptions.length > 0) {
	          _this4.handleTaxValueChange({
	            value: taxRateOptions[0].value,
	            label: taxRateOptions[0].label,
	            index: 0
	          });
	        }
	        //  if (isAN) {
	        //   this.handleTaxValueChange({
	        //     value: 8.375,
	        //     label: 8.375,
	        //     index: 0
	        //   });
	        //  }
	      });
	
	      if (currentSalesOrder && this.context.router.routes[1].path !== 'salesOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'mobileSalesOrders/new') {
	        this.setState({ currentCustomer: currentSalesOrder.Deliver_Customer_id, salesOrderNumber: currentSalesOrder.SONum });
	        this.props.setValue('salesOrderForm', 'Deliver_Customer_id', currentSalesOrder.Deliver_Customer_id);
	        this.props.fetchCustomers().then(function () {
	          if (currentSalesOrder.Shipping_Customer) {
	            _this4.props.fetchSalesCustomerDetail(currentSalesOrder.Shipping_Customer, currentSalesOrder.SalesOrder_id, true);
	          } else {
	            _this4.props.fetchSalesCustomerDetail(currentSalesOrder.Deliver_Customer_id, _this4.props.currentSalesOrder && _this4.props.currentSalesOrder.SalesOrder_id);
	            var fjAgentTemp2 = [];
	            if (isFJ) {
	              _this4.props.fetchFJAgents(currentSalesOrder.Deliver_Customer_id).then(function (response) {
	                if (response.data) {
	                  response.data.map(function (r) {
	                    fjAgentTemp2.push({ label: r.name, value: r.id });
	                  });
	                  _this4.state.FJAgentOptions = fjAgentTemp2;
	                }
	              }, function (err) {
	                if (err.status === 500 || err.status === 404) {
	                  alert('error fetching agents');
	                }
	              });
	            }
	          }
	        })
	        // .then(() => {
	        //   this.props.fetchPromotions();
	        // })
	        .then(function () {
	          // this.props.fetchCustomersWithFavorites();
	          _this4.setState({ editSOPermission: false });
	          // this.props.setDefaultSearchType('RefNum', 'salesOrderForm');
	          _this4.props.initializeSalesOrderForm('RefNum', 'salesOrderForm');
	          _this4.props.fetchSalesOrderDetail(currentSalesOrder.SalesOrder_id, route);
	        });
	        // get 90 days sales order
	        this.props.fetchPreviousSalesOrderByCustomer(currentSalesOrder.Deliver_Customer_id || this.props.Deliver_CustomerDetail_id && this.props.Deliver_CustomerDetail_id.value || this.props.Deliver_CustomerDetail_id, this.state.fromDate, this.state.toDate);
	      } else {
	        this.props.resetCurrentSalesOrder();
	        this.props.fetchActiveCustomers();
	        // this.props.fetchPromotions();
	        this.props.fetchTaxRates();
	        // this.props.setDefaultSearchType('RefNum', 'salesOrderForm');
	        this.props.initializeSalesOrderForm('RefNum', 'salesOrderForm');
	        this.setState({ Released: false });
	      }
	      // making a leaving hook to confirm leaving
	      if (this.props.prevEstDate) {
	        this.setState({ prevEstDate: this.props.prevEstDate });
	      } else {
	        var currentDate = new Date();
	        _root_url.isEcity && currentDate.setDate(currentDate.getDate() + 1);
	        this.setState({ prevEstDate: currentDate });
	      }
	      if (this.props.prevEstDateIsNeeded) {
	        this.props.destroyEstDate();
	      }
	      this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
	
	      if (this.props.currentSalesOrder) {
	        if (!this.props.currentSalesOrder.FinalNetWeight) {
	          this.props.currentSalesOrder.FinalNetWeight = 0.00;
	        } else {
	          this.props.currentSalesOrder.FinalNetWeight = this.props.currentSalesOrder.FinalNetWeight;
	        }
	        if (!this.props.currentSalesOrder.FinalShippingWeight && this.props.currentSalesOrder.FinalNetWeight) {
	          this.props.currentSalesOrder.FinalShippingWeight = this.props.currentSalesOrder.FinalNetWeight;
	          this.state.finalShippingWeight = this.props.currentSalesOrder.FinalNetWeight;
	        } else {
	          this.state.finalShippingWeight = this.props.currentSalesOrder.FinalShippingWeight;
	        }
	      }
	      if (this.props && this.props.employeeNote) {
	        this.state.employeeNoteText = this.props.employeeNote;
	        this.state.employeeNoteDisplay = this.props.employeeNote;
	      }
	
	      var jmlTemp = [];
	      if (isJML) {
	        this.props.getPaymentTerms().then(function (response) {
	          if (response.data) {
	            response.data.map(function (r) {
	              jmlTemp.push({ label: r.Name, value: r.PaymentTerm_id });
	              // jmlTemp.push({label: r.Name, value: r.Name});
	            });
	            _this4.state.paymentTermOptions = jmlTemp;
	          }
	        }, function (err) {
	          if (err.status === 500 || err.status === 404) {
	            alert('error fetching payment terms');
	          }
	        });
	      }
	
	      if (isChinaTown) {
	        this.props.setDefaultOfForm("ShippingMethod", "Delivery", "salesOrderForm");
	      }
	
	      if (isWIZ || isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isFJ || isJTB) {
	        this.props.fetchInboundProducts();
	      }
	      if (isWIZ) {
	        var fbaAdressTemp1 = [];
	        var fbaAdressTemp2 = [];
	        this.props.fetchFBAAddressOptions().then(function (response) {
	          if (response.data) {
	            response.data.map(function (r) {
	              fbaAdressTemp1.push({ label: r.street + ", " + r.city + ", " + r.zipcode + ", " + r.state, value: r.id });
	              fbaAdressTemp2.push({ label: r.name, value: r.id });
	            });
	            _this4.state.FBAOptions = fbaAdressTemp1;
	            _this4.state.FBAOptions2 = fbaAdressTemp2;
	          }
	        }, function (err) {
	          if (err.status === 500 || err.status === 404) {
	            alert('error fetching FBA address');
	          }
	        });
	      }
	
	      if (isFJ) {
	        var fjCarrierTemp1 = [];
	        // let fbaAdressTemp2 = [];
	        this.props.fetchFJCarriers().then(function (response) {
	          if (response.data) {
	            response.data.map(function (r) {
	              fjCarrierTemp1.push({ label: r.name, value: r.id });
	              // fbaAdressTemp2.push({label: r.name,  value: r.id});
	            });
	            _this4.state.fjCarrierOptions = fjCarrierTemp1;
	            // this.state.FBAOptions2 = fbaAdressTemp2;
	          }
	        }, function (err) {
	          if (err.status === 500 || err.status === 404) {
	            alert('error fetching carriers');
	          }
	        });
	      }
	      // if (isTQ) {
	      //   this.props.setDefaultOfForm("Company_id", "Aibou Trading, Inc.", "salesOrderForm"); 
	      // }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this5 = this;
	
	      if (isJML && nextProps.PackageSize_1 !== this.props.PackageSize_1 && this.props.jmlBox) {
	        this.props.setValue('salesOrderForm', 'Quantity', nextProps.PackageSize_1 * this.props.jmlBox);
	      }
	      if (isJML && nextProps.jmlBox !== this.props.jmlBox) {
	        if (this.props.PackageSize_1) {
	          this.props.setValue('salesOrderForm', 'Quantity', nextProps.jmlBox * this.props.PackageSize_1);
	        }
	        this.setState({
	          lineQty: nextProps.jmlBox ? Number(nextProps.jmlBox) : 0
	        });
	      }
	
	      if (this.context.router.routes[1].path === 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/:id') {
	        if (!this.state.SODiscount && !this.state.SOSavings) {
	          this.setState({ SODiscount: nextProps.discount, SOSavings: nextProps.savings });
	        } else {
	          if (!this.state.discountModified) {
	            this.setState({ SODiscount: nextProps.discount, SOSavings: nextProps.savings });
	          }
	        }
	      }
	      if ((this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'outboundOrders/new') && !this.state.discountModified) {
	        this.setState({ SODiscount: 0, SOSavings: 0 });
	      }
	      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.FinalNetWeight && nextProps.currentSalesOrderDetail.FinalShippingWeight) {
	        // this.props.currentSalesOrder.FinalNetWeight = nextProps.currentSalesOrderDetail.FinalNetWeight;
	        // this.props.currentSalesOrder.FinalShippingWeight = nextProps.currentSalesOrderDetail.FinalShippingWeight;
	        // this.state.finalShippingWeight = this.props.currentSalesOrder.FinalShippingWeight;
	      }
	      if (nextProps.employeeNote) {
	        this.state.employeeNoteText = nextProps.employeeNote;
	        this.state.employeeNoteDisplay = nextProps.employeeNote;
	      }
	      if (nextProps.customerChosen !== this.props.customerChosen) {
	        this.setState({
	          customerVerified: false
	        });
	      }
	
	      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.SaleStatus && nextProps.currentSalesOrderDetail.SaleStatus === 'Released') {
	        this.setState({ Released: true });
	      }
	      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.ShippingMethod) {
	        this.setState({ ShippingMethod: nextProps.currentSalesOrderDetail.ShippingMethod });
	      }
	      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.Billing) {
	        this.setState({ Shipping: nextProps.currentSalesOrderDetail.Shipping, Billing: nextProps.currentSalesOrderDetail.Billing });
	      }
	      if (nextProps.salesCustomerDetails && nextProps.salesCustomerDetails.Billing) {
	        this.setState({ Shipping: nextProps.salesCustomerDetails.Shipping, Billing: nextProps.salesCustomerDetails.Billing });
	        if (nextProps.salesCustomerDetails.CustomerNum === 'EMP9999' && !nextProps.allShipping) {
	          this.props.fetchAllShipping();
	        }
	      }
	
	      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.ShipTo) {
	        this.setState({ ShipTo: nextProps.currentSalesOrderDetail.ShipTo });
	      }
	      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.CompanyName) {
	        this.setState({ CompanyName: nextProps.currentSalesOrderDetail.CompanyName });
	      }
	
	      if (nextProps.salesShippingCustomerDetails !== this.props.salesShippingCustomerDetails) {
	        this.setState({ Shipping: nextProps.salesShippingCustomerDetails.Shipping });
	        if (nextProps.salesShippingCustomerDetails.Shipping) {
	          var defaultFound = false;
	          var fieldName = this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'outboundOrders/new' ? 'CustomerDetail_id' : 'Deliver_CustomerDetail_id';
	          nextProps.salesShippingCustomerDetails.Shipping.map(function (ShippingInfo) {
	            if (ShippingInfo.IsDefault) {
	              defaultFound = true;
	              if (nextProps.Deliver_CustomerDetail_id) {
	                _this5.props.setValue('salesOrderForm', fieldName, nextProps.Deliver_CustomerDetail_id);
	              } else {
	                if (isHMM) {
	                  _this5.props.setValue('salesOrderForm', fieldName, null);
	                } else {
	                  _this5.props.setValue('salesOrderForm', fieldName, ShippingInfo.CustomerDetail_id);
	                }
	              }
	            }
	          });
	
	          if (defaultFound === false) {
	            if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.Deliver_CustomerDetail_id) {
	              this.props.setValue('salesOrderForm', 'Deliver_CustomerDetail_id', nextProps.currentSalesOrderDetail.Deliver_CustomerDetail_id);
	            } else {
	              this.props.setValue('salesOrderForm', fieldName, null);
	            }
	          }
	        }
	      }
	
	      if (nextProps.allShipping && nextProps.allShipping !== this.props.allShipping && nextProps.allShipping.length && nextProps.salesCustomerDetails && nextProps.salesCustomerDetails.CustomerNum === 'EMP9999') {
	        this.setState({ Shipping: nextProps.allShipping });
	      }
	      if (nextProps.dirty !== this.props.dirty) {
	        this.setState({
	          dirty: nextProps.dirty
	        });
	      }
	
	      if (nextProps.salesOrderCreated && nextProps.salesOrderCreated !== this.props.salesOrderCreated) {
	        this.openShowSOCreated();
	      }
	
	      if (nextProps.salesOrderEdited && nextProps.salesOrderEdited !== this.props.salesOrderEdited) {
	        this.openShowSOCreated();
	      }
	
	      if (nextProps.productInfo && nextProps.productInfo !== this.props.productInfo) {
	        var productInfo = nextProps.productInfo;
	        this.setState({
	          productInfo: productInfo,
	          inStock: nextProps.productInfo.InStock,
	          purchased: nextProps.productInfo.Purchased,
	          presale: nextProps.productInfo.PreSale,
	          net_weight: nextProps.productInfo.ProductNum.NetWeight,
	          ship_weight: nextProps.productInfo.ProductNum.ShipWeight,
	          total_weight: '',
	          RefPrice: nextProps.productInfo.RefPrice, //ctn
	          LowestSalePrice: nextProps.productInfo.LowestSalePrice,
	          PriceLv1: nextProps.productInfo.PriceLv1,
	          PriceLv2: nextProps.productInfo.PriceLv2,
	          PriceLv3: nextProps.productInfo.PriceLv3,
	          PriceLv4: nextProps.productInfo.PriceLv4,
	          PriceLv5: nextProps.productInfo.PriceLv5
	        });
	      }
	
	      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail !== this.props.currentSalesOrderDetail) {
	        var currentSalesOrderDetail = nextProps.currentSalesOrderDetail;
	        if (currentSalesOrderDetail.Sales_Order_Lines != null) {
	          var totalPrice = 0;
	          var totalTax = 0;
	          var totalTaxOriginal = 0;
	          var finalPrice = 0;
	          var finalWeight = 0;
	          var totalCRV = 0;
	          var delivery = 0;
	          // let deliveryFeeEdit = 0;
	          var index = currentSalesOrderDetail.Sales_Order_Lines.length;
	          var discount = currentSalesOrderDetail.Discount || 0;
	          currentSalesOrderDetail.Sales_Order_Lines.map(function (row) {
	            row.Index = index;
	            index--;
	            if (row.IsTaxable === true) {
	              if (isHMM) {
	                totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(nextProps.currentSalesOrderDetail.TaxRate / 100);
	              } else {
	                if (isAN || _root_url.isElegant) {
	                  var taxable = !_this5.props.salesCustomerDetails.Reseller;
	                  if (isAN) {
	                    taxable = row.IsAllTaxable === true || !_this5.props.salesCustomerDetails.Reseller;
	                  }
	                  if (taxable) {
	                    totalTax += parseFloat(row.TotalPrice) * parseFloat(nextProps.currentSalesOrderDetail.TaxRate / 100);
	                  }
	                } else {
	                  totalTax += parseFloat(row.TotalPrice) * parseFloat(nextProps.currentSalesOrderDetail.TaxRate / 100);
	                }
	              }
	            }
	            if (isHMM) {
	              totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
	            } else {
	              totalPrice += parseFloat(row.TotalPrice);
	            }
	            if (row.TotalNetWeight != null) {
	              finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight);
	            }
	            if (row.CRV) {
	              row.TotalCRV = +(0, _NumberUtil.roundTo)(parseFloat(row.CRV * row.Quantity), 2).toFixed(2);
	            }
	            if (row.TotalCRV) {
	              totalCRV += row.TotalCRV;
	            }
	          });
	          totalTaxOriginal = totalTax = +(0, _NumberUtil.roundTo)(totalTax, 2).toFixed(2);
	          if (_root_url.isElegant) {
	            discount = currentSalesOrderDetail.Discount || parseFloat(currentSalesOrderDetail.Savings) / totalPrice * 100 || 0;
	            totalTax = +(0, _NumberUtil.roundTo)((1 - discount / 100) * totalTax, 2).toFixed(2);
	          }
	          finalPrice = parseFloat(totalPrice) * (1 - discount / 100) + (parseFloat(totalTax) + parseFloat(totalCRV));
	          finalWeight = +(0, _NumberUtil.roundTo)(finalWeight, 2).toFixed(2);
	          totalPrice = +(0, _NumberUtil.roundToDecimals)(totalPrice, 4).toFixed(4);
	          finalPrice = +(0, _NumberUtil.roundTo)(finalPrice, 2).toFixed(2);
	          delivery = nextProps.currentSalesOrderDetail.Delivery;
	          // deliveryFeeEdit = nextProps.currentSalesOrderDetail.Delivery;
	          var updateTime = new Date(currentSalesOrderDetail.UpdateTime);
	          updateTime = this.updateTimeformatDate(updateTime).slice(0, 10);
	
	          var magTempSplit = [];
	          if (isMAG && currentSalesOrderDetail.mag_note) {
	            magTempSplit = currentSalesOrderDetail.mag_note.split(',');
	            magTempSplit.map(function (r) {
	              if (r === 'DRYRUN') {
	                _this5.state.magDryrun = true;
	              }
	              if (r === 'OFFHIRE') {
	                _this5.state.magOffhire = true;
	              }
	              if (r === 'PIERPASS') {
	                _this5.state.magPierpass = true;
	              }
	              if (r === 'AN_FEE') {
	                _this5.state.magAnFee = true;
	              }
	              if (r === 'OTHER') {
	                _this5.state.magOther = true;
	              }
	              if (r === 'HANDLING') {
	                _this5.state.magHandling = true;
	              }
	              if (r === 'EXTRA_STOP') {
	                _this5.state.magExtraStop = true;
	              }
	              if (r === 'EXAM') {
	                _this5.state.magExam = true;
	              }
	              if (r === 'EXTRA_DELIVERY') {
	                _this5.state.magExtraDelivery = true;
	              }
	              if (r === 'STORAGE') {
	                _this5.state.magStorage = true;
	              }
	              if (r === 'BOBTAIL_FEE') {
	                _this5.state.magBobtailFee = true;
	              }
	              if (r === 'CHASSIS_SPLIT') {
	                _this5.state.magChassisSplit = true;
	              }
	              if (r === 'CTF') {
	                _this5.state.magCTF = true;
	              }
	              if (r === 'FSC') {
	                _this5.state.magFSC = true;
	              }
	              if (r === 'PREPULL') {
	                _this5.state.magPrepull = true;
	              }
	              if (r === 'CONGESTION') {
	                _this5.state.magCongestion = true;
	              }
	              if (r === 'DROPOFF') {
	                _this5.state.magDropoff = true;
	              }
	              if (r === 'OVERWEIGHT') {
	                _this5.state.magOverweight = true;
	              }
	            });
	          }
	
	          var mag2TempSpit = [];
	          if (isMAG && currentSalesOrderDetail.DeliveryStatus) {
	            mag2TempSpit = currentSalesOrderDetail.DeliveryStatus.split(',');
	            mag2TempSpit.map(function (r) {
	              if (r === 'FREIGHT_HOLD') {
	                _this5.state.mag2FREIGHT_HOLD = true;
	              }
	              if (r === 'CUSTOM_HOLD') {
	                _this5.state.mag2CUSTOM_HOLD = true;
	              }
	              if (r === 'PIERPASS_HOLD') {
	                _this5.state.mag2PIERPASS_HOLD = true;
	              }
	              if (r === 'EXAM') {
	                _this5.state.mag2EXAM = true;
	              }
	              if (r === 'CLOSED_AREA') {
	                _this5.state.mag2CLOSED_AREA = true;
	              }
	            });
	          }
	
	          this.setState(_extends({}, this.state, {
	            finalPrice: finalPrice,
	            totalPrice: totalPrice,
	            totalTax: totalTax,
	            totalTaxOriginal: totalTaxOriginal,
	            finalWeight: finalWeight,
	            discount: discount,
	            totalCRV: totalCRV,
	            updateTime: updateTime,
	            delivery: delivery,
	            fee: currentSalesOrderDetail.Payment_Information ? currentSalesOrderDetail.Payment_Information.Fee : 0,
	            taxValue: currentSalesOrderDetail.TaxRate,
	            rows: currentSalesOrderDetail.Sales_Order_Lines,
	            modified_by: currentSalesOrderDetail.Modifier_User_Name,
	            created_by: currentSalesOrderDetail.Sales_User_id,
	            created_by_name: currentSalesOrderDetail.Sales_User_Name,
	            creator: currentSalesOrderDetail.Sales_User_Name,
	            currentCustomer: currentSalesOrderDetail.Deliver_Customer_id,
	            paymentInfo: currentSalesOrderDetail.Payment_Information,
	
	            // NameOnAccount: currentSalesOrderDetail.Payment_Information ? currentSalesOrderDetail.Payment_Information.NameOnAccount : null,
	            // AccountNum: currentSalesOrderDetail.Payment_Information ? currentSalesOrderDetail.Payment_Information.AccountNum : null,
	            // Routing: currentSalesOrderDetail.Payment_Information ? currentSalesOrderDetail.Payment_Information.Routing : null,
	
	            chargeID: currentSalesOrderDetail.Charge_id,
	            IsNoReduce: currentSalesOrderDetail.IsNoReduce,
	            IsFBAAddress: currentSalesOrderDetail.IsFBAAddress,
	            Sales_User_id: currentSalesOrderDetail.Sales_User_id,
	            paymentMethod: currentSalesOrderDetail.payment_method
	          }), function () {
	            _this5.handleDiscountChange(discount);
	          });
	        }
	
	        if (nextProps.currentSalesOrderDetail.Shipping_Customer) {
	          this.props.setValue('salesOrderForm', 'receivingCustomer', nextProps.currentSalesOrderDetail.Shipping_Customer);
	          this.props.fetchSalesCustomerDetail(nextProps.currentSalesOrderDetail.Shipping_Customer, null, true);
	          this.setState({ useDefaultCustomerAddress: false });
	        }
	        if (currentSalesOrderDetail.Shipping != null && currentSalesOrderDetail.CustomerNum !== 'EMP9999') {
	          this.setState({
	            shipping: currentSalesOrderDetail.Shipping
	          });
	        }
	        // this.props.setDefaultSearchType('RefNum', 'salesOrderForm');
	        this.props.initializeSalesOrderForm('RefNum', 'salesOrderForm');
	      }
	
	      if (nextProps.inventories && nextProps.inventories !== this.props.inventories) {
	        var inventoryItems = [].concat(_toConsumableArray(nextProps.inventories));
	        var tempVariable = [].concat(_toConsumableArray(nextProps.inventories));
	        inventoryItems.map(function (item) {
	          var check = _lodash2.default.findIndex(_this5.state.rows, { ProductNum: item.ProductNum.ProductNum });
	          if (check !== -1) {
	            item.inList = true;
	          }
	          item.PriceLv1 = item.ProductNum__PriceLv1;
	          item.PriceLv2 = item.ProductNum__PriceLv2;
	          item.PriceLv3 = item.ProductNum__PriceLv3;
	          item.PriceLv4 = item.ProductNum__PriceLv4;
	          item.PriceLv5 = item.ProductNum__PriceLv5;
	          item.Ordered = item.Purchased;
	        });
	        var inventories = _extends({}, this.state.inventories, { allRows: inventoryItems, rows: tempVariable });
	        this.setState({ inventories: inventories });
	      }
	
	      if (nextProps.inventoryIdValue && nextProps.inventoryIdValue !== this.props.inventoryIdValue) {
	        var filteredRows = this.state.inventories.allRows.filter(function (obj) {
	          var match = String(obj.ProductNum).includes(String(nextProps.inventoryIdValue));
	          return match;
	        });
	        var _inventories = _extends({}, this.state.inventories, { rows: filteredRows });
	        this.setState({ inventories: _inventories });
	        var _index = _lodash2.default.findIndex(filteredRows, { ProductNum: nextProps.inventoryIdValue });
	        if (_index > -1) {
	          this.setState({
	            selectedItemName: filteredRows[_index].Name,
	            selectedItemNumber: nextProps.inventoryIdValue
	          });
	        }
	      }
	
	      if (nextProps.customersWithFavorites && nextProps.customersWithFavorites !== this.props.customersWithFavorites) {
	        this.setState({ customersWithFavorites: nextProps.customersWithFavorites });
	      }
	
	      if (nextProps.previousSOs && nextProps.previousSOs !== this.props.previousSOs) {
	        var previousSOs = void 0;
	        if (nextProps.previousSOs.Orders) {
	          previousSOs = _extends({}, this.state.previousSOs, {
	            rows: nextProps.previousSOs.Orders,
	            selectedIndexes: [],
	            sortColumn: null,
	            sortDirection: null
	          });
	        } else {
	          previousSOs = _extends({}, this.state.previousSOs, { rows: [], selectedIndexes: [], sortCol: null, sortDirection: null
	          });
	        }
	        this.setState({ previousSOs: previousSOs });
	      }
	
	      if (nextProps.previousOrders && nextProps.previousOrders !== this.props.previousOrders) {
	        var _previousOrders = void 0;
	        if (nextProps.previousOrders.Sales_Order_Lines) {
	          _previousOrders = _extends({}, this.state.previousOrders, {
	            rows: nextProps.previousOrders.Sales_Order_Lines,
	            selectedIndexes: [],
	            sortColumn: null,
	            sortDirection: null
	          });
	        } else if (nextProps.previousOrders) {
	          // when select to show all product from all previous SOs
	          _previousOrders = _extends({}, this.state.previousOrders, {
	            rows: nextProps.previousOrders,
	            selectedIndexes: [],
	            sortColumn: null,
	            sortDirection: null
	          });
	        } else {
	          _previousOrders = _extends({}, this.state.previousOrders, { rows: [], selectedIndexes: [], sortCol: null, sortDirection: null
	          });
	        }
	        this.setState({ previousOrders: _previousOrders });
	      }
	      if (nextProps.salesOrderDetailByNum && nextProps.salesOrderDetailByNum !== this.props.salesOrderDetailByNum) {
	        var _previousOrders2 = void 0;
	        if (nextProps.salesOrderDetailByNum.Sales_Order_Lines) {
	          _previousOrders2 = _extends({}, this.state.previousOrders, {
	            rows: nextProps.salesOrderDetailByNum.Sales_Order_Lines,
	            selectedIndexes: [],
	            sortColumn: null,
	            sortDirection: null
	          });
	        } else {
	          _previousOrders2 = _extends({}, this.state.previousOrders, { rows: [], selectedIndexes: [], sortCol: null, sortDirection: null
	          });
	        }
	        this.setState({ previousOrders: _previousOrders2 });
	      }
	      // if (nextProps.promotions && nextProps.promotions !== this.props.promotions) {
	      //   const promotions = { ...this.state.promotions, rows: nextProps.promotions };
	      //   this.setState({ promotions });
	      // }
	
	      if (nextProps.customerChosen && nextProps.customerChosen.value && nextProps.customerChosen !== this.props.customerChosen) {
	        this.props.fetchSalesCustomerDetail(nextProps.customerChosen.value, this.props.currentSalesOrder && this.props.currentSalesOrder.SalesOrder_id);
	        if (!isDSQ && !_root_url.isWUFS && !isABCFF && !isKDW && !isYI && !isFBD && !isWIZ && !isFJ && !isJTB) {
	          this.props.fetchCustomerFrequent(nextProps.customerChosen.value);
	        }
	        var fjAgentTemp = [];
	        if (isFJ) {
	          this.props.fetchFJAgents(nextProps.customerChosen.value).then(function (response) {
	            if (response.data) {
	              response.data.map(function (r) {
	                fjAgentTemp.push({ label: r.name, value: r.id });
	              });
	              _this5.state.FJAgentOptions = fjAgentTemp;
	            }
	          }, function (err) {
	            if (err.status === 500 || err.status === 404) {
	              alert('error fetching agents');
	            }
	          });
	        }
	
	        this.props.fetchFavoriteList(nextProps.customerChosen.value);
	        this.setState({
	          currentCustomer: nextProps.customerChosen.value,
	          useDefaultCustomerAddress: true,
	          salesOrderIndexFromLast: 1,
	          currentCustomerName: nextProps.customerChosen.label,
	          previousOrders: {
	            rows: [],
	            selectedRows: [],
	            sortColumn: null,
	            sortDirection: null,
	            selectedIndexes: []
	          }
	        }, this.fetchPreviousSalesOrderByCustomer);
	        // ReactDOM.findDOMNode(this.refs.productSearch.getRenderedComponent().myInput.refs.input).focus();
	      }
	
	      if (nextProps.customerPrices && nextProps.customerPrices !== this.props.customerPrices) {
	        var rows = JSON.parse(JSON.stringify(this.state.inventories.allRows));
	        var customerPrices = JSON.parse(JSON.stringify(nextProps.customerPrices));
	        var mergedList = _lodash2.default.map(rows, function (i) {
	          var newList = _lodash2.default.merge(i, _lodash2.default.find(customerPrices, { Product_id: i.Product_id }));
	          return newList;
	        });
	        var _inventories2 = _extends({}, this.state.inventories, { rows: mergedList, allRows: mergedList });
	        this.setState({ inventories: _inventories2 });
	      }
	
	      if (isOCM && nextProps.Company_id && nextProps.Company_id !== this.props.Company_id) {
	        var warehouseOptions = [];
	        var id = nextProps.Company_id;
	        this.props.fetchWarehousesByCompany(id).then(function (response) {
	          response.data.map(function (warehousse) {
	            warehouseOptions.push({ label: warehousse.Name, value: warehousse.Warehouse_id });
	          });
	          _this5.props.setValue('salesOrderForm', 'Pickup_Warehouse_id', warehouseOptions[0].value);
	          _this5.setState({ warehouseOptions: warehouseOptions });
	        }, function (err) {
	          if (err.status === 500 || err.status === 404) {
	            alert('error fetching company names');
	          }
	        });
	      }
	
	      if (_root_url.isSY && nextProps.groups && nextProps.groups !== this.props.groups) {
	        var groupOptions = [];
	        nextProps.groups.map(function (group) {
	          groupOptions.push({ value: group.ProductGroup_id, label: group.Name });
	        });
	        this.setState({ groupOptions: groupOptions });
	      }
	
	      if (nextProps.previousOrderFromDate && nextProps.previousOrderToDate && (nextProps.previousOrderFromDate !== this.props.previousOrderFromDate || nextProps.previousOrderToDate !== this.props.previousOrderToDate)) {
	        var dates = (0, _cleanDates.toFromDates)(-1, nextProps.previousOrderFromDate, nextProps.previousOrderToDate);
	        if (this.state.currentCustomer) {
	          this.props.fetchPreviousOrders(this.state.currentCustomer, dates.fromDate, dates.toDate);
	        }
	      }
	
	      if (nextProps.salesCustomerDetails && nextProps.salesCustomerDetails !== this.props.salesCustomerDetails) {
	        // this.setState({resellerTemp: nextProps.salesCustomerDetails.Reseller});
	        if (!this.state.created_by) {
	          this.setState({
	            created_by: nextProps.salesCustomerDetails.Sales_User_id
	          });
	        }
	        if (!this.state.created_by_name) {
	          this.setState({
	            created_by_name: nextProps.salesCustomerDetails.Sales_User_Name
	          });
	        }
	        if (_root_url.isEcity && nextProps.salesCustomerDetails.open_orders) {
	          if (nextProps.salesCustomerDetails.open_orders.length > 0 && this.context.router.routes[1].path === 'salesOrders/new') {
	            // if it is ecity and has open orders -> popup show orders and can edit 
	            this.setState({ openOrderOpen: true });
	          }
	        }
	        if (isAN) {
	          this.handleTaxValueChange({
	            value: 8.375,
	            label: 8.375,
	            index: 0
	          });
	        }
	        var details = _extends({}, nextProps.salesCustomerDetails);
	        if (details.Amount00_30 == null) details.Amount00_30 = 0;
	        if (details.Amount61_90 == null) details.Amount61_90 = 0;
	        if (details.Amount31_60 == null) details.Amount31_60 = 0;
	        if (details.Amount91 == null) details.Amount91 = 0;
	
	        // Set to the default shipping
	        if (nextProps.salesCustomerDetails.Shipping) {
	          var _fieldName = this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'outboundOrders/new' ? 'CustomerDetail_id' : 'Deliver_CustomerDetail_id';
	          var _defaultFound = false;
	          nextProps.salesCustomerDetails.Shipping.map(function (ShippingInfo) {
	            if (ShippingInfo.IsDefault) {
	              _defaultFound = true;
	              if (isHMM) {
	                _this5.props.setValue('salesOrderForm', _fieldName, null);
	              } else {
	                _this5.props.setValue('salesOrderForm', _fieldName, ShippingInfo.CustomerDetail_id);
	              }
	            }
	            if (ShippingInfo.IsDefault && _this5.props.params) {
	              if (isHMM) {
	                _this5.props.setValue('salesOrderForm', _fieldName, null);
	              } else {
	                _this5.props.setValue('salesOrderForm', _fieldName, ShippingInfo.CustomerDetail_id);
	              }
	            }
	          });
	
	          if (_defaultFound === false) {
	            this.props.setValue('salesOrderForm', _fieldName, null);
	          }
	        }
	
	        this.props.setCredit(nextProps.salesCustomerDetails.CreditStatus);
	        this.setState({
	          Amount00_30: details.Amount00_30,
	          Amount31_60: details.Amount31_60,
	          Amount61_90: details.Amount61_90,
	          Amount91: details.Amount91,
	          customerPaymentTerm: nextProps.salesCustomerDetails.PaymentTerm,
	          customerPriceLevel: nextProps.salesCustomerDetails.PriceLevel,
	          PaymentTermDesc: nextProps.salesCustomerDetails.PaymentTermDesc,
	          CreditLimit: nextProps.salesCustomerDetails.CreditLimit
	        });
	        this.props.setValue('salesOrderForm', 'PaymentTerm_id', nextProps.salesCustomerDetails.PaymentTermId);
	      }
	
	      var total_weight = parseFloat(nextProps.quantityValue || 0) * parseFloat(this.state.selectedInventoryRow.NetWeight || 0);
	      // if statement for instances where there is text in the quantity field from user input
	      if (Number.isNaN(total_weight)) {
	        total_weight = 0.00;
	      }
	      total_weight = total_weight.toFixed(2);
	      this.setState({ total_weight: total_weight });
	
	      if (nextProps.unitPrice && nextProps.unitPrice !== this.props.unitPrice) {
	        // let subtotal = parseFloat(nextProps.unitPrice) * parseFloat(this.props.quantityValue);
	        // this.props.setSubtotal(subtotal);
	      }
	
	      if (nextProps.customerFrequent && nextProps.customerFrequent !== this.props.customerFrequent) {
	        var frequentItems = {};
	        if (isWIZ || isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isFJ || isJTB) {
	          frequentItems = _extends({}, this.state.frequentItems, { rows: nextProps.customerFrequent.record });
	        } else {
	          frequentItems = _extends({}, this.state.frequentItems, { rows: nextProps.customerFrequent.Frequents });
	        }
	        this.setState({ frequentItems: frequentItems });
	      }
	
	      if (nextProps.customerSalesHistory && nextProps.customerSalesHistory !== this.props.customerSalesHistory) {
	        var salesHistory = _extends({}, this.state.salesHistory, { rows: nextProps.customerSalesHistory });
	        this.setState({ salesHistory: salesHistory });
	      }
	
	      if (!nextProps.discount) {
	        this.props.setValue('salesOrderForm', 'Discount', 0);
	      }
	
	      if (nextProps.discount && nextProps.discount !== this.props.discount || nextProps.discount === '') {
	        var _discount = nextProps.discount;
	        if (_discount.toString().indexOf('-') !== -1) {
	          _discount = _discount.replace(/-/g, '');
	        }
	        this.setState({ discount: _discount });
	        // this.props.setValue('salesOrderForm', 'Discount', discount);
	        if (_discount === '') {
	          this.props.setValue('salesOrderForm', 'Discount', 0);
	          this.handleDiscountChange(0);
	        } else {
	          this.handleDiscountChange(_discount);
	          if (parseFloat(nextProps.discount) > 100 || isNaN(nextProps.discount)) {
	            this.setState({ discount: Math.abs(this.props.discount) });
	            this.props.setValue('salesOrderForm', 'Discount', this.props.discount);
	          }
	        }
	      }
	
	      if (nextProps.favoriteList && nextProps.favoriteList !== this.props.favoriteList) {
	        if (nextProps.favoriteList.Sales_FavoriteList_Lines) {
	          var _rows = [].concat(_toConsumableArray(nextProps.favoriteList.Sales_FavoriteList_Lines));
	          var favorites = _extends({}, this.state.favorites, { rows: _rows });
	          this.setState({ favorites: favorites });
	        }
	      }
	
	      if (nextProps.checkPermissionSuccess && nextProps.checkPermissionSuccess !== this.props.checkPermissionSuccess) {
	        if (nextProps.checkPermissionSuccess.manager) {
	          this.closeEditSOPermission();
	          this.setState({ editSOPermission: true });
	        }
	      }
	
	      if (nextProps.salesOrderProduct && nextProps.salesOrderProduct !== this.props.salesOrderProduct) {
	        this.selectInventoryInfo(nextProps.salesOrderProduct);
	        this.props.setSaleOrderProductValues((0, _NumberUtil.roundToDecimals)(nextProps.salesOrderProduct.Price, 4), 'salesOrderForm', isJML ? _extends({}, nextProps.salesOrderProduct, { jmlBox: 0 }) : nextProps.salesOrderProduct);
	        // ReactDOM.findDOMNode(this.refs['quantity'].getRenderedComponent().myInput.refs.input).focus();
	      }
	
	      if (nextProps.shipperChosen && nextProps.shipperChosen !== null && nextProps.shipperChosen !== this.props.shipperChosen) {
	        var shipping_id = _typeof(nextProps.shipperChosen) === 'object' ? nextProps.shipperChosen.value : nextProps.shipperChosen;
	        this.setState({ shipperChosen: shipping_id });
	        // this.props.setValue('salesOrderForm', 'CustomerDetail_id', shipping_id);
	      }
	
	      if (nextProps.shippingListPDF && nextProps.shippingListPDF !== this.props.shippingListPDF) {
	        this.setState({ shippingPdfFrameLoaded: false });
	      }
	
	      if (nextProps.pickingListPDF && nextProps.pickingListPDF !== this.props.pickingListPDF) {
	        this.setState({ pickingListPdfFrameLoaded: false });
	      }
	
	      if (nextProps.packingListPDF && nextProps.packingListPDF !== this.props.packingListPDF) {
	        this.setState({ packingListPdfFrameLoaded: false });
	      }
	
	      if (nextProps.salesOrderPDF && nextProps.salesOrderPDF !== this.props.salesOrderPDF) {
	        this.setState({ salesOrderPdfFrameLoaded: false });
	      }
	
	      if (nextProps.salesOrderSIPDF && nextProps.salesOrderSIPDF !== this.props.salesOrderSIPDF) {
	        this.setState({ salesOrderSIPdfFrameLoaded: false });
	      }
	
	      if (nextProps.refundPDF && nextProps.refundPDF !== this.props.refundPDF) {
	        this.setState({ refundPDFFrameLoaded: false });
	      }
	
	      if (nextProps.receivingCustomer && nextProps.receivingCustomer !== this.props.receivingCustomer) {
	        this.setState({ useDefaultCustomerAddress: false });
	        if (nextProps.receivingCustomer.value) {
	          this.props.fetchSalesCustomerDetail(nextProps.receivingCustomer.value, null, true);
	        } else {
	          this.props.fetchSalesCustomerDetail(nextProps.receivingCustomer, null, true);
	        }
	      }
	
	      if (nextProps.salesItemHistory) {
	        this.setState({
	          salesItemHistory: nextProps.salesItemHistory
	        });
	      }
	
	      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.CreditAmount) {
	        this.setState({
	          creditAmount: Number(nextProps.currentSalesOrderDetail.CreditAmount)
	        });
	      }
	      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.ShareCreditAmount) {
	        this.setState({
	          shareCreditAmount: Number(nextProps.currentSalesOrderDetail.ShareCreditAmount)
	        });
	      }
	
	      if (isWIZ && (nextProps.BoxPerPallet || this.props.BoxPerPallet) && (nextProps.quantityValue || this.props.quantityValue)) {
	        if (isNumeric(nextProps.quantityValue) && isNumeric(nextProps.BoxPerPallet)) {
	
	          if (!nextProps.PalletQuantity || Math.ceil(Number(nextProps.quantityValue) / Number(nextProps.BoxPerPallet)) >= nextProps.PalletQuantity) {
	            this.props.setValue('salesOrderForm', 'BillablePallets', Math.ceil(Number(nextProps.quantityValue) / Number(nextProps.BoxPerPallet)));
	          } else {
	            this.props.setValue('salesOrderForm', 'BillablePallets', nextProps.PalletQuantity);
	          }
	        }
	      } else if (isWIZ && nextProps.PalletQuantity) {
	        this.props.setValue('salesOrderForm', 'BillablePallets', nextProps.PalletQuantity);
	      }
	      if (isWIZ && !nextProps.BoxPerPallet && !nextProps.PalletQuantity) {
	        this.props.setValue('salesOrderForm', 'BillablePallets', 0);
	      } else if (isWIZ && !nextProps.BoxPerPallet && nextProps.PalletQuantity) {
	        this.props.setValue('salesOrderForm', 'BillablePallets', nextProps.PalletQuantity);
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState.shippingPdfFrameLoaded !== this.state.shippingPdfFrameLoaded && this.state.shippingPdfFrameLoaded == false) {
	        return false;
	      }
	      if (nextState.pickingListPdfFrameLoaded !== this.state.pickingListPdfFrameLoaded && this.state.pickingListPdfFrameLoaded == false) {
	        return false;
	      }
	      if (nextState.packingListPdfFrameLoaded !== this.state.packingListPdfFrameLoaded && this.state.packingListPdfFrameLoaded == false) {
	        return false;
	      }
	      if (nextState.salesOrderPdfFrameLoaded !== this.state.salesOrderPdfFrameLoaded && this.state.salesOrderPdfFrameLoaded == false) {
	        return false;
	      }
	      if (nextState.salesOrderSIPdfFrameLoaded !== this.state.salesOrderSIPdfFrameLoaded && this.state.salesOrderSIPdfFrameLoaded == false) {
	        return false;
	      }
	      if (nextState.refundPDFFrameLoaded !== this.state.refundPDFFrameLoaded && this.state.refundPDFFrameLoaded == false) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this6 = this;
	
	      document.title = _root_url.companyCodeTitle;
	      window.addEventListener('beforeunload', this.beforeunload.bind(this));
	
	      var yiWarehouseOptions = [];
	
	      if (_root_url.isSY) {
	        this.props.fetchGroups();
	      }
	      if (isYI) {
	        _axios2.default.get(_url.WAREHOUSES_URL, {
	          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	          if (response && response.data) {
	            response.data.map(function (r) {
	              yiWarehouseOptions.push({ label: r.name, value: r.Warehouse_id });
	            });
	          }
	          _this6.setState({ yiWarehouseOptions: yiWarehouseOptions });
	        }, function (err) {
	          if (err.status === 500 || err.status === 404) {
	            err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	          }
	          alert(JSON.stringify(err.data));
	        });
	      }
	
	      var zoneOptions = [];
	      if (isKDW || isABCFF) {
	        _axios2.default.get(_url.ZONES_URL, {
	          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	          // drayageListOptions = response.data;
	          if (response && response.data) {
	            response.data.map(function (r) {
	              zoneOptions.push({ label: r.zone_num, value: r.id });
	            });
	          }
	          // drayageListOptions.rows.map((r, index) => {
	          //   r.Idx = index++;
	          // })
	          _this6.setState({ zoneOptions: zoneOptions });
	        }, function (err) {
	          if (err.status === 500 || err.status === 404) {
	            err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	          }
	          alert(JSON.stringify(err.data));
	        });
	      }
	    }
	  }, {
	    key: 'beforeunload',
	    value: function beforeunload(e) {
	      e.preventDefault();
	      e.returnValue = true;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (!this.props.searchType) {
	        // this.props.setDefaultSearchType('RefNum', 'salesOrderForm');
	        this.props.initializeSalesOrderForm('RefNum', 'salesOrderForm');
	      }
	      if (this.refs.customer_name && this.state.firstFocus) {
	        // this.refs.customer_name.getRenderedComponent().refs.select.focus();
	        // this.setState({ firstFocus: false });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('beforeunload', this.beforeunload.bind(this));
	      // this.props.clearInventories();
	      document.removeEventListener('keydown', this.handleKeyDown.bind(this));
	      this.props.finishUnmount();
	      // this.props.clearSalesCustomerDetails();
	    }
	  }, {
	    key: 'updateTimeformatDate',
	    value: function updateTimeformatDate(date) {
	      var formattedDate = date.getFullYear() + '-';
	      var month = date.getMonth() + 1;
	      if (month < 10) {
	        formattedDate += '0' + month + '-';
	      } else {
	        formattedDate += month + '-';
	      }
	      if (date.getDate() < 10) {
	        formattedDate += '0' + date.getDate();
	      } else {
	        formattedDate += date.getDate();
	      }
	      return formattedDate;
	    }
	  }, {
	    key: 'formatSimpleDate',
	    value: function formatSimpleDate(date) {
	      var formattedDate = '';
	      if (date.getMonth() + 1 < 10) {
	        formattedDate += '0' + (date.getMonth() + 1);
	      } else {
	        formattedDate += (date.getMonth() + 1).toString();
	      }
	      if (date.getDate() < 10) {
	        formattedDate += '0' + date.getDate();
	      } else {
	        formattedDate += date.getDate().toString();
	      }
	      formattedDate += date.getFullYear().toString();
	      return formattedDate;
	    }
	  }, {
	    key: 'routerWillLeave',
	    value: function routerWillLeave() {
	      if (this.state.dirty) return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'work_not_saved_warning' });
	    }
	  }, {
	    key: 'printForm',
	    value: function printForm() {
	      this.props.fetchSalesOrderForm();
	    }
	  }, {
	    key: 'refreshPage',
	    value: function refreshPage(event) {
	      if (event) {
	        event.preventDefault();
	      }
	      var currentSalesOrder = this.props.salesOrderCreated || this.props.currentSalesOrder;
	      this.closeShowSOCreated();
	      if (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
	        this.props.fetchInboundProducts();
	      }
	      this.props.selectSalesOrder(currentSalesOrder);
	      if (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id') {
	        this.context.router.push('/salesOrders/' + currentSalesOrder.SalesOrder_id);
	      } else if (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
	        this.context.router.push('/outboundOrders/' + currentSalesOrder.SalesOrder_id);
	      } else if (this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id') {
	        this.context.router.push('/mobileSalesOrders/' + currentSalesOrder.SalesOrder_id);
	      }
	    }
	  }, {
	    key: 'selectInventoryInfo',
	    value: function selectInventoryInfo(selectedInventoryRow) {
	      var _this7 = this;
	
	      if (this.props.searchType === 'Barcode') {
	        this.setState({
	          selectedInventoryRow: selectedInventoryRow,
	          inStock: selectedInventoryRow.InStock,
	          purchased: selectedInventoryRow.Purchased,
	          presale: selectedInventoryRow.PreSale,
	          net_weight: selectedInventoryRow.NetWeight,
	          ship_weight: selectedInventoryRow.NetWeight,
	          product_type: selectedInventoryRow.ProductType,
	          RefPrice: selectedInventoryRow.RefPrice, //ctn
	          LowestSalePrice: selectedInventoryRow.LowestSalePrice,
	          PriceLv1: selectedInventoryRow.PriceLv1,
	          PriceLv2: selectedInventoryRow.PriceLv2,
	          PriceLv3: selectedInventoryRow.PriceLv3,
	          PriceLv4: selectedInventoryRow.PriceLv4,
	          PriceLv5: selectedInventoryRow.PriceLv5
	        }, function () {
	          _this7.barcodeScan();
	        });
	      } else {
	        this.setState({
	          selectedInventoryRow: selectedInventoryRow,
	          inStock: selectedInventoryRow.InStock,
	          purchased: selectedInventoryRow.Purchased,
	          presale: selectedInventoryRow.PreSale,
	          net_weight: selectedInventoryRow.NetWeight,
	          ship_weight: selectedInventoryRow.NetWeight,
	          product_type: selectedInventoryRow.ProductType,
	          RefPrice: selectedInventoryRow.RefPrice, //ctn
	          LowestSalePrice: selectedInventoryRow.LowestSalePrice,
	          PriceLv1: selectedInventoryRow.PriceLv1,
	          PriceLv2: selectedInventoryRow.PriceLv2,
	          PriceLv3: selectedInventoryRow.PriceLv3,
	          PriceLv4: selectedInventoryRow.PriceLv4,
	          PriceLv5: selectedInventoryRow.PriceLv5
	        });
	      }
	    }
	  }, {
	    key: 'openCustomer',
	
	
	    // Helper function to pop up the add payment term function
	    value: function openCustomer() {
	      this.setState({ customerOpen: true });
	    }
	  }, {
	    key: 'closeCustomer',
	    value: function closeCustomer() {
	      this.setState({ customerOpen: false });
	    }
	  }, {
	    key: 'openHistory',
	    value: function openHistory() {
	      this.props.fetchCustomerSalesHistory(this.state.currentCustomer);
	      this.setState({ historyOpen: true });
	    }
	  }, {
	    key: 'closeHistory',
	    value: function closeHistory() {
	      this.setState({ historyOpen: false });
	    }
	  }, {
	    key: 'openConfirm',
	    value: function openConfirm() {
	      this.setState({ confirmOpen: true });
	    }
	  }, {
	    key: 'openShowSOCreated',
	    value: function openShowSOCreated() {
	      this.setState({ showSOCreatedOpen: true });
	    }
	  }, {
	    key: 'openEditSOPermission',
	    value: function openEditSOPermission() {
	      this.setState({ case: 'editSOPermission', editSOPermissionOpen: true });
	    }
	  }, {
	    key: 'closeEditSOPermission',
	    value: function closeEditSOPermission() {
	      this.setState({ editSOPermissionOpen: false });
	    }
	  }, {
	    key: 'openConfirmRefund',
	    value: function openConfirmRefund(props) {
	      this.setState(_extends({ case: 'confirmRefund', confirmRefundOpen: true }, props));
	    }
	  }, {
	    key: 'closeConfirmRefund',
	    value: function closeConfirmRefund() {
	      this.setState({ confirmRefundOpen: false });
	    }
	  }, {
	    key: 'openDeliveryMethodModal',
	    value: function openDeliveryMethodModal() {
	      this.setState({ deliveryMethodModalOpen: true });
	    }
	  }, {
	    key: 'closeDeliveryMethodModal',
	    value: function closeDeliveryMethodModal() {
	      this.setState({ deliveryMethodModalOpen: false });
	    }
	  }, {
	    key: 'openCarrierInfoModal',
	    value: function openCarrierInfoModal() {
	      this.setState({ carrierInfoModalOpen: true });
	    }
	  }, {
	    key: 'closeCarrierInfoModal',
	    value: function closeCarrierInfoModal() {
	      this.setState({ carrierInfoModalOpen: false });
	    }
	  }, {
	    key: 'openDropship',
	    value: function openDropship() {
	      this.setState({ isDropshipOpen: true });
	    }
	  }, {
	    key: 'closeDropship',
	    value: function closeDropship() {
	      this.setState({ isDropshipOpen: false });
	    }
	  }, {
	    key: 'openCreateBOLModal',
	    value: function openCreateBOLModal() {
	      this.setState({ createBOLModalVisibility: true });
	    }
	  }, {
	    key: 'closeCreateBOLModal',
	    value: function closeCreateBOLModal() {
	      this.setState({ createBOLModalVisibility: false });
	    }
	  }, {
	    key: 'openShipping',
	    value: function openShipping() {
	      this.props.clearConvertingToInvoice();
	      this.props.clearUpdateSalesInvoice();
	      this.setState({ showShippingOpen: true });
	    }
	  }, {
	    key: 'closeShipping',
	    value: function closeShipping() {
	      this.props.clearConvertingToInvoice();
	      this.props.clearUpdateSalesInvoice();
	      this.setState({ showShippingOpen: false });
	      this.refreshPage();
	    }
	  }, {
	    key: 'closeConfirm',
	    value: function closeConfirm() {
	      // this.props.resetFormInputs();
	      this.setState({ case: null, confirmOpen: false });
	      // ReactDOM.findDOMNode(this.refs['quantity'].getRenderedComponent().myInput.refs.input).focus();
	    }
	  }, {
	    key: 'openChangeTax',
	    value: function openChangeTax() {
	      this.setState({ changeTaxOpen: true });
	    }
	  }, {
	    key: 'closeChangeTax',
	    value: function closeChangeTax() {
	      this.setState({ changeTaxOpen: false });
	    }
	  }, {
	    key: 'openDiscountModal',
	    value: function openDiscountModal() {
	      this.setState({ changeDiscountOpen: true });
	    }
	  }, {
	    key: 'closeDiscountModal',
	    value: function closeDiscountModal() {
	      this.setState({ changeDiscountOpen: false });
	    }
	  }, {
	    key: 'openZBLModal',
	    value: function openZBLModal(val, dep) {
	      var currentZBL = val;
	      var currentZBLDep = dep;
	
	      this.setState({
	        ZBLModalOpen: true,
	        currentZBL: currentZBL,
	        currentZBLDep: currentZBLDep
	      });
	    }
	  }, {
	    key: 'closeZBLModal',
	    value: function closeZBLModal() {
	      var currentZBL = "";
	      var currentZBLDep = null;
	      var zoneSelected = null;
	      var zoneDisplay = "";
	
	      var binSelected = null;
	      var binDisplay = "";
	      var binOptions = [];
	      var levelSelected = null;
	      var levelDisplay = "";
	      var levelOptions = [];
	
	      this.setState({
	        currentZBL: currentZBL,
	        currentZBLDep: currentZBLDep,
	        zoneSelected: zoneSelected,
	        zoneDisplay: zoneDisplay,
	        binSelected: binSelected,
	        binDisplay: binDisplay,
	        binOptions: binOptions,
	        levelSelected: levelSelected,
	        levelDisplay: levelDisplay,
	        levelOptions: levelOptions
	      });
	
	      this.setState({ ZBLModalOpen: false });
	    }
	  }, {
	    key: 'onSubmitZBLEdit',
	    value: function onSubmitZBLEdit() {
	      var _this8 = this;
	
	      var _state = this.state,
	          currentZBLDep = _state.currentZBLDep,
	          zoneDisplay = _state.zoneDisplay,
	          zoneSelected = _state.zoneSelected,
	          binDisplay = _state.binDisplay,
	          binSelected = _state.binSelected,
	          levelDisplay = _state.levelDisplay,
	          levelSelected = _state.levelSelected;
	
	      var rows = [].concat(_toConsumableArray(this.state.rows));
	
	      if (!(zoneSelected && binSelected && levelSelected)) {
	        alert("Please select a Zone/Bin/Level");
	        return;
	      }
	      rows.map(function (r, i) {
	        if (r.Index === currentZBLDep.Index) {
	          rows[i].Zone = zoneSelected;
	          rows[i].Section = binSelected;
	          rows[i].Bin = levelSelected;
	          rows[i].Location = zoneDisplay + '-' + binDisplay + '-' + levelDisplay;
	          _this8.setState({ rows: rows, ZBLModalOpen: false });
	        }
	      });
	
	      // let {paymentInfo} = this.state;
	      // let data = {name: this.state.NameOnAccount, account_num: this.state.AccountNum, routing: this.state.Routing};
	      // axios.put(
	      //   (ACH_EDIT_URL + paymentInfo.pk),
	      //   // (ACH_EDIT_URL + '1'),
	      //   data,
	      //   {
	      //     headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
	      //   },
	      // ).then((response) => {
	      //   alert("ACH Info Changed");
	      //   // this.fetchSalesOrdersByDetails(
	      //   //   this.state.days
	      //   // );
	      //   paymentInfo.NameOnAccount = this.state.NameOnAccount;
	      //   paymentInfo.AccountNum = this.state.AccountNum;
	      //   paymentInfo.Routing = this.state.Routing;
	      //   this.setState({paymentInfo, achEditOpen: false});
	      // }, (err) => {
	      //   if (err.status === 500 || err.status === 404) {
	      //     err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	      //   } 
	      //   alert(JSON.stringify(err.data));
	      // });
	    }
	  }, {
	    key: 'openAchEdit',
	    value: function openAchEdit() {
	      var paymentInfo = this.state.paymentInfo;
	
	
	      this.setState({ achEditOpen: true,
	        NameOnAccount: paymentInfo.NameOnAccount,
	        AccountNum: paymentInfo.AccountNum,
	        Routing: paymentInfo.Routing
	      });
	    }
	  }, {
	    key: 'closeAchEdit',
	    value: function closeAchEdit() {
	      this.setState({ achEditOpen: false });
	    }
	  }, {
	    key: 'onSubmitAchEdit',
	    value: function onSubmitAchEdit() {
	      var _this9 = this;
	
	      var paymentInfo = this.state.paymentInfo;
	
	      var data = { name: this.state.NameOnAccount, account_num: this.state.AccountNum, routing: this.state.Routing };
	      _axios2.default.put(_url.ACH_EDIT_URL + paymentInfo.pk,
	      // (ACH_EDIT_URL + '1'),
	      data, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        alert("ACH Info Changed");
	        // this.fetchSalesOrdersByDetails(
	        //   this.state.days
	        // );
	        paymentInfo.NameOnAccount = _this9.state.NameOnAccount;
	        paymentInfo.AccountNum = _this9.state.AccountNum;
	        paymentInfo.Routing = _this9.state.Routing;
	        _this9.setState({ paymentInfo: paymentInfo, achEditOpen: false });
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	      });
	    }
	  }, {
	    key: 'openEmployeeNote',
	    value: function openEmployeeNote() {
	      this.setState({ changeEmployeeNoteOpen: true });
	    }
	  }, {
	    key: 'closeEmployeeNote',
	    value: function closeEmployeeNote() {
	      this.setState({ changeEmployeeNoteOpen: false });
	    }
	  }, {
	    key: 'onSubmitEmployeeNote',
	    value: function onSubmitEmployeeNote() {
	      var _this10 = this;
	
	      var currentSalesOrder = this.props.currentSalesOrder;
	      if (!currentSalesOrder) {
	        alert("Please create order first before editing Employee Note");
	        return;
	      }
	      this.props.updateEmployeeNote(currentSalesOrder.SalesOrder_id, this.state.employeeNoteText).then(function (response) {
	        _this10.setState({ employeeNoteDisplay: _this10.state.employeeNoteText });
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          alert("Patch Employee Note Failed");
	        }
	      });
	      this.setState({ changeEmployeeNoteOpen: false });
	    }
	  }, {
	    key: 'openDeliveryFee',
	    value: function openDeliveryFee() {
	      if (this.props.currentSalesOrder && this.props.currentSalesOrder.SONum.charAt(0) !== 'M') {
	        this.setState({ changeDeliveryFeeOpen: true, deliveryFeeEdit: this.state.delivery });
	      }
	    }
	  }, {
	    key: 'closeDeliveryFee',
	    value: function closeDeliveryFee() {
	      this.setState({ changeDeliveryFeeOpen: false });
	    }
	  }, {
	    key: 'onConfirmDeliveryFee',
	    value: function onConfirmDeliveryFee() {
	      this.setState({ delivery: Number(this.state.deliveryFeeEdit) });
	      this.closeDeliveryFee();
	    }
	  }, {
	    key: 'openChangeWeight',
	    value: function openChangeWeight() {
	      this.setState({ changeWeightOpen: true });
	    }
	  }, {
	    key: 'closeChangeWeight',
	    value: function closeChangeWeight() {
	      this.setState({ changeWeightOpen: false });
	    }
	  }, {
	    key: 'onChangeWeightSubmit',
	    value: function onChangeWeightSubmit() {
	      if (this.state.finalShippingWeight < 0 || !this.state.finalShippingWeight) {
	        alert('Invalid Weight Value!');
	        return;
	      }
	      var currentSalesOrder = this.props.currentSalesOrder;
	      this.props.currentSalesOrder.FinalShippingWeight = this.state.finalShippingWeight;
	      this.props.updateShippingWeight(currentSalesOrder.SalesOrder_id, this.state.finalShippingWeight);
	      this.setState({ changeWeightOpen: false });
	    }
	  }, {
	    key: 'openShowInventory',
	    value: function openShowInventory(event) {
	      if (!this.props.searchValue || this.props.searchValue === '') {
	        return;
	      }
	      switch (event.charCode) {
	        case 13:
	          // ENTER
	          event.preventDefault();
	          if (this.props.customerChosen) {
	            this.setState({ showInventoryOpen: true });
	            break;
	          } else {
	            this.setState({ case: 'noCustomerChosen', confirmOpen: true });
	            break;
	          }
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'closeShowInventory',
	    value: function closeShowInventory(value) {
	      this.handleAfterShowInventoryClose(value);
	      this.setState({ showInventoryOpen: false });
	    }
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(event) {
	      switch (event.keyCode) {
	        case 27:
	          this.closeShowInventory('productSearch');
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'handleFocusAutoSuggest',
	    value: function handleFocusAutoSuggest() {
	      var autoSuggestField = document.getElementById('sales-auto-suggest');
	      autoSuggestField.focus();
	      autoSuggestField.select();
	    }
	  }, {
	    key: 'handleDiscountChange',
	    value: function handleDiscountChange(nextDiscount) {
	      var totalPrice = parseFloat(this.state.totalPrice) || 0;
	      var discount = parseFloat(nextDiscount) || 0;
	      var totalTax = parseFloat(this.state.totalTax) || 0;
	      var totalCRV = parseFloat(this.state.totalCRV) || 0;
	      var finalPrice = totalPrice * (1 - discount / 100) + totalTax + totalCRV;
	      finalPrice = +(0, _NumberUtil.roundTo)(finalPrice, 2).toFixed(2);
	      this.setState({ discount: discount, finalPrice: finalPrice });
	    }
	  }, {
	    key: 'handleAfterShowInventoryClose',
	    value: function handleAfterShowInventoryClose(value) {
	      _reactDom2.default.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	    }
	  }, {
	    key: 'handleUnitPriceChange',
	    value: function handleUnitPriceChange(event) {
	      this.setState({ refPrice: event.target.value });
	    }
	  }, {
	    key: 'handleSaveDisable',
	    value: function handleSaveDisable() {
	      if (isABC && this.state.rows.length > 0 && !this.state.Released) {
	        return false;
	      }
	      if (isFung) {
	        return false;
	      }
	      if (this.state.rows.length === 0 && !isMAG || this.state.Released || this.props.salesOrderIsCreating) {
	        return true;
	      } else if (_root_url.isRivera || _root_url.isEcity || this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
	        return false;
	      } else if ((this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id') && (isAFG || isMyumyu || isWecom || isCO || _root_url.isElegant) && this.props.currentSalesOrder && this.props.currentSalesOrder.SONum && this.props.currentSalesOrder.SONum.charAt(0) !== 'M') {
	        return false;
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'handleOnFocus',
	    value: function handleOnFocus(event) {
	      event.target.select();
	    }
	  }, {
	    key: 'handleUpdatePrice',
	    value: function handleUpdatePrice() {
	      var _this11 = this;
	
	      var rows = [].concat(_toConsumableArray(this.state.rows));
	
	      var rowToEdit = {};
	      var rowIndex = 0;
	      var counter = 0;
	      rows.map(function (row) {
	        if (row.Index === _this11.state.RowBeingEdited.Index) {
	          rowToEdit = _extends({}, row);
	          rowIndex = counter;
	        }
	        counter++;
	      });
	
	      rowToEdit.UnitPrice = parseFloat(this.state.newPrice);
	      if (rowToEdit.ProductType === 'Fixed') {
	        rowToEdit.TotalPrice = +(0, _NumberUtil.roundTo)(parseFloat(rowToEdit.UnitPrice * parseFloat(rowToEdit.Quantity)), 2).toFixed(2);
	      } else {
	        rowToEdit.TotalPrice = +(0, _NumberUtil.roundTo)(parseFloat(rowToEdit.UnitPrice * parseFloat(rowToEdit.Quantity) * parseFloat(rowToEdit.NetWeight)), 2).toFixed(2);
	      }
	      rows[rowIndex] = rowToEdit;
	
	      var totalPrice = 0;
	      var finalWeight = 0;
	      var finalPrice = 0;
	      var totalTax = 0;
	      var totalTaxOriginal = 0;
	      var totalCRV = 0;
	      var discount = parseFloat(this.props.discount) || 0;
	      // if (totalPrice == null)
	      //   totalPrice = 0;
	      // if (finalWeight ==null)
	      //   finalWeight = 0;
	      rows.map(function (row) {
	        if (isHMM) {
	          totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
	        } else {
	          totalPrice += parseFloat(row.TotalPrice);
	        }
	        finalWeight += parseFloat(row.NetWeight * row.Quantity);
	        if (row.IsTaxable === true || row.IsTaxable === 'True') {
	          if (isHMM) {
	            totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(_this11.state.taxValue / 100);
	          } else {
	            if (isAN || _root_url.isElegant) {
	              var taxable = !_this11.props.salesCustomerDetails.Reseller;
	              if (isAN) {
	                taxable = row.IsAllTaxable === true || !_this11.props.salesCustomerDetails.Reseller;
	              }
	              if (taxable) {
	                totalTax += parseFloat(row.TotalPrice) * parseFloat(_this11.state.taxValue / 100);
	              }
	            } else {
	              totalTax += parseFloat(row.TotalPrice) * parseFloat(_this11.state.taxValue / 100);
	            }
	          }
	        }
	        if (row.CRV) {
	          row.TotalCRV = +(0, _NumberUtil.roundTo)(parseFloat(row.CRV * row.Quantity), 2).toFixed(2);
	        }
	        if (row.TotalCRV) {
	          totalCRV += row.TotalCRV;
	        }
	      });
	      totalTaxOriginal = totalTax = +(0, _NumberUtil.roundTo)(totalTax, 2).toFixed(2);
	      if (_root_url.isElegant) {
	        discount = parseFloat(this.state.SODiscount) || parseFloat(this.state.SOSavings) / totalPrice * 100 || 0;
	        totalTax = +(0, _NumberUtil.roundTo)((1 - discount / 100) * totalTax, 2).toFixed(2);
	      }
	      finalPrice = parseFloat(totalPrice) * (1 - discount / 100) + parseFloat(totalTax) + parseFloat(totalCRV);
	      finalWeight = +(0, _NumberUtil.roundTo)(finalWeight, 2).toFixed(2);
	      totalPrice = +(0, _NumberUtil.roundToDecimals)(totalPrice, 4).toFixed(4);
	      finalPrice = +(0, _NumberUtil.roundTo)(finalPrice, 2).toFixed(2);
	      this.setState({
	        rows: rows, totalPrice: totalPrice, finalWeight: finalWeight, finalPrice: finalPrice, totalTax: totalTax, totalCRV: totalCRV, totalTaxOriginal: totalTaxOriginal
	      });
	    }
	  }, {
	    key: 'removeRow',
	    value: function removeRow(Index) {
	      var _this12 = this;
	
	      var rows = [].concat(_toConsumableArray(this.state.rows));
	      var totalPrice = 0;
	      var finalWeight = 0;
	      var totalTax = 0;
	      var totalTaxOriginal = 0;
	      var totalCRV = 0;
	      var index = 0;
	      var discount = parseFloat(this.props.discount) || 0;
	
	      rows = rows.filter(function (obj) {
	        var match = obj.Index !== Index;
	        return match;
	      });
	      index = rows.length;
	
	      rows.map(function (row) {
	        row.Index = index;
	        index--;
	        if (row.IsTaxable === true || row.IsTaxable === 'true') {
	          if (isHMM) {
	            totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(_this12.state.taxValue / 100);
	          } else {
	            if (isAN || _root_url.isElegant) {
	              var taxable = !_this12.props.salesCustomerDetails.Reseller;
	              if (isAN) {
	                taxable = row.IsAllTaxable === true || !_this12.props.salesCustomerDetails.Reseller;
	              }
	              if (taxable) {
	                totalTax += parseFloat(row.TotalPrice) * parseFloat(_this12.state.taxValue / 100);
	              }
	            } else {
	              totalTax += parseFloat(row.TotalPrice) * parseFloat(_this12.state.taxValue / 100);
	            }
	          }
	        }
	        if (isHMM) {
	          totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
	        } else {
	          totalPrice += parseFloat(row.TotalPrice);
	        }
	        if (row.Weight != null) {
	          finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight);
	        }
	        totalCRV += +(0, _NumberUtil.roundTo)(parseFloat(row.CRV * row.Quantity), 2).toFixed(2);
	      });
	      totalTaxOriginal = totalTax = +(0, _NumberUtil.roundTo)(totalTax, 2).toFixed(2);
	      if (_root_url.isElegant) {
	        discount = parseFloat(this.state.SODiscount) || parseFloat(this.state.SOSavings) / totalPrice * 100 || 0;
	        totalTax = +(0, _NumberUtil.roundTo)((1 - discount / 100) * totalTax, 2).toFixed(2);
	      }
	      totalPrice = +(0, _NumberUtil.roundToDecimals)(totalPrice, 4).toFixed(4);
	      var finalPrice = +(0, _NumberUtil.roundTo)(totalPrice * (1 - discount / 100) + totalTax + totalCRV, 2).toFixed(2);
	
	      this.setState({
	        rows: rows, finalPrice: finalPrice, totalPrice: totalPrice, totalTax: totalTax, finalWeight: finalWeight, totalCRV: totalCRV, totalTaxOriginal: totalTaxOriginal
	      });
	    }
	  }, {
	    key: 'title',
	    value: function title() {
	      if (!this.props.currentSalesOrder) {
	        return _react2.default.createElement(
	          'h3',
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_a_new_sales_order' })
	        );
	      }
	      return _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_sales_order' }),
	        ' ',
	        this.props.currentSalesOrder.SONum
	      );
	    }
	  }, {
	    key: 'setAllProductQuantity',
	    value: function setAllProductQuantity(quantity) {
	      this.props.setValue('salesOrderForm', 'Quantity', quantity);
	    }
	  }, {
	    key: 'getCustomerNameOptions',
	    value: function getCustomerNameOptions() {
	      var customerOptions = [];
	      this.props.customers.map(function (customer) {
	        customerOptions.push({ value: customer.Customer_id, label: customer.Name, detail_id: customer.CustomerDetail_id });
	      });
	      return customerOptions;
	    }
	  }, {
	    key: 'getCustomerNumOptions',
	    value: function getCustomerNumOptions() {
	      var customerOptions = [];
	      this.props.customers.map(function (customer) {
	        customerOptions.push({ value: customer.Customer_id, label: customer.CustomerNum });
	      });
	      return customerOptions;
	    }
	  }, {
	    key: 'getCustomerPhoneOptions',
	    value: function getCustomerPhoneOptions() {
	      var customerOptions = [];
	      this.props.customers.map(function (customer) {
	        customerOptions.push({ value: customer.Customer_id, label: customer.Telephone });
	      });
	      return customerOptions;
	    }
	  }, {
	    key: 'getShippingContactOptions',
	    value: function getShippingContactOptions() {
	      var contactOption = [];
	      if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Shipping && this.props.salesCustomerDetails.CustomerNum !== 'EMP9999') {
	        this.props.salesCustomerDetails.Shipping.map(function (ShippingInfo) {
	          contactOption.push({ value: ShippingInfo.CustomerDetail_id, label: ShippingInfo.FirstName + ' ' + ShippingInfo.LastName });
	        });
	      } else if (this.props.salesCustomerDetails && this.props.allShipping && this.props.allShipping.length && this.props.salesCustomerDetails.CustomerNum === 'EMP9999') {
	        this.props.allShipping.map(function (ShippingInfo) {
	          contactOption.push({ value: ShippingInfo.CustomerDetail_id, id: ShippingInfo.Customer_id, label: '' + ShippingInfo.CustomerName });
	        });
	      }
	      return contactOption;
	    }
	  }, {
	    key: 'getShippingPhoneOptions',
	    value: function getShippingPhoneOptions() {
	      var phoneOptions = [];
	      if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Shipping && this.props.salesCustomerDetails.CustomerNum !== 'EMP9999') {
	        if (!this.state.useDefaultCustomerAddress && this.props.salesShippingCustomerDetails && this.props.salesShippingCustomerDetails.Shipping) {
	          this.props.salesShippingCustomerDetails.Shipping.map(function (ShippingInfo) {
	            phoneOptions.push({ value: ShippingInfo.CustomerDetail_id, label: '' + ShippingInfo.Telephone });
	          });
	        } else {
	          this.props.salesCustomerDetails.Shipping.map(function (ShippingInfo) {
	            phoneOptions.push({ value: ShippingInfo.CustomerDetail_id, label: '' + ShippingInfo.Telephone });
	          });
	        }
	      } else if (this.props.salesCustomerDetails && this.props.allShipping && this.props.allShipping.length && this.props.salesCustomerDetails.CustomerNum === 'EMP9999') {
	        this.props.allShipping.map(function (ShippingInfo) {
	          phoneOptions.push({ value: ShippingInfo.CustomerDetail_id, id: ShippingInfo.Customer_id, label: '' + ShippingInfo.Telephone });
	        });
	      }
	      return phoneOptions;
	    }
	  }, {
	    key: 'getAddressOptions',
	    value: function getAddressOptions() {
	      var addressOptions = [];
	      if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Shipping && this.props.salesCustomerDetails.CustomerNum !== 'EMP9999') {
	        if (!this.state.useDefaultCustomerAddress && this.props.salesShippingCustomerDetails && this.props.salesShippingCustomerDetails.Shipping) {
	          this.props.salesShippingCustomerDetails.Shipping.map(function (ShippingInfo) {
	            if (isMAG) {
	              addressOptions.push({ value: ShippingInfo.CustomerDetail_id, label: ShippingInfo.AddressName + ': ' + ShippingInfo.Street + ' ' + ShippingInfo.City + ', ' + ShippingInfo.State });
	            } else {
	              addressOptions.push({ value: ShippingInfo.CustomerDetail_id, label: ShippingInfo.Street + ' ' + ShippingInfo.City + ', ' + ShippingInfo.State });
	            }
	          });
	        } else {
	          this.props.salesCustomerDetails.Shipping.map(function (ShippingInfo) {
	            addressOptions.push({ value: ShippingInfo.CustomerDetail_id, label: ShippingInfo.Street + ' ' + ShippingInfo.City + ', ' + ShippingInfo.State });
	          });
	        }
	      } else if (this.props.salesCustomerDetails && this.props.allShipping && this.props.allShipping.length && this.props.salesCustomerDetails.CustomerNum === 'EMP9999') {
	        this.props.allShipping.map(function (ShippingInfo) {
	          addressOptions.push({ value: ShippingInfo.CustomerDetail_id, id: ShippingInfo.Customer_id, label: ShippingInfo.Street + ' ' + ShippingInfo.City + ', ' + ShippingInfo.State });
	        });
	      }
	      return addressOptions;
	    }
	  }, {
	    key: 'getTaxRateOptions',
	    value: function getTaxRateOptions() {
	      var taxRateOptions = [];
	      if (this.props.taxRates) {
	        var index = 0;
	        this.props.taxRates.map(function (taxRate) {
	          taxRateOptions.push({ value: taxRate.Rate, label: taxRate.Rate, index: index });
	          index++;
	        });
	      }
	      return taxRateOptions;
	    }
	    // for OCM only
	
	  }, {
	    key: 'getCompanyOptions',
	    value: function getCompanyOptions() {
	      var _this13 = this;
	
	      var companyOptions = [];
	      this.props.fetchCompany().then(function (response) {
	        response.data.map(function (company) {
	          // ocm company filter by permission
	          if (isOCM) {
	            if (company.permission_name === 'view_company_ocm_la') {
	              if ((0, _permissions2.default)('view_company_ocm_la')) {
	                companyOptions.push({ label: company.Name, value: company.id });
	              }
	            }
	            if ((0, _permissions2.default)('view_company_ocm_nj')) {
	              if (company.permission_name === 'view_company_ocm_nj') {
	                companyOptions.push({ label: company.Name, value: company.id });
	              }
	            }
	          } else {
	            companyOptions.push({ label: company.Name, value: company.id });
	          }
	        });
	        if (isOCM) {
	          _this13.props.setValue('salesOrderForm', 'Company_id', companyOptions[0].value);
	        }
	        _this13.setState({ companyOptions: companyOptions });
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          alert('error fetching company names');
	        }
	      });
	    }
	  }, {
	    key: 'favoriteItemsHeader',
	    value: function favoriteItemsHeader() {
	      var _this14 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { onClick: function onClick() {
	            return _this14.setState({ favoriteItemsOpen: !_this14.state.favoriteItemsOpen });
	          } },
	        _react2.default.createElement(
	          'label',
	          { style: { cursor: 'pointer' } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'favorite_items' })
	        )
	      );
	    }
	  }, {
	    key: 'previousOrdersHeader',
	    value: function previousOrdersHeader() {
	      var _this15 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 6 },
	            _react2.default.createElement(
	              'label',
	              {
	                style: { cursor: 'pointer' },
	                onClick: function onClick() {
	                  return _this15.setState({ previousOrdersOpen: !_this15.state.previousOrdersOpen, promotionsOpen: false });
	                }
	              },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'previous_order' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 6 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'PreviousOrderDate', component: _datePicker.DatePicker })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'promotionsHeader',
	    value: function promotionsHeader() {
	      var _this16 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { onClick: function onClick() {
	            return _this16.setState({ promotionsOpen: !_this16.state.promotionsOpen, previousOrdersOpen: false });
	          } },
	        _react2.default.createElement(
	          'label',
	          { style: { cursor: 'pointer' } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'promotions' })
	        )
	      );
	    }
	  }, {
	    key: 'renderInboundProducts',
	    value: function renderInboundProducts() {
	      var _this17 = this;
	
	      if (this.props.customerFrequentIsLoading && !this.props.customerFrequentError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.customerFrequentError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.customerFrequentError)
	        )
	      );
	
	      // Parameters of the react-data-grid
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this17.state.frequentItems);
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var selectedIndexes = _this17.state.frequentItems.selectedIndexes.concat(rows.map(function (r) {
	          return r.rowIdx;
	        }));
	        var selectedPK = [];
	        if (isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
	          selectedPK = _this17.state.frequentItems.selectedPK.concat(rows.map(function (r) {
	            return r.row.pk;
	          }));
	        }
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        var frequentItems = _extends({}, _this17.state.frequentItems, { rows: newRows, selectedIndexes: selectedIndexes, selectedPK: selectedPK });
	        _this17.setState({ frequentItems: frequentItems });
	      };
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var rowIndexes = rows.map(function (r) {
	          return r.rowIdx;
	        });
	        _this17.state.frequentItems.rows = _this17.props.customerFrequent.record;
	        var newRows = [].concat(_toConsumableArray(_this17.state.frequentItems.rows));
	        var selectedIndexes = _this17.state.frequentItems.selectedIndexes.filter(function (i) {
	          return rowIndexes.indexOf(i) === -1;
	        });
	
	        var rowPKs = [];
	        var selectedPK = _this17.state.frequentItems.selectedPK;
	        if (isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
	          rowPKs = rows.map(function (r) {
	            return r.row.pk;
	          });
	          rowPKs.map(function (r) {
	            selectedPK.map(function (j, index) {
	              if (r === j) {
	                selectedPK.splice(index, 1);
	              }
	            });
	          });
	        }
	
	        if (isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
	          newRows.map(function (r, index) {
	            if (selectedPK && selectedPK.length > 0) {
	              selectedPK.map(function (j) {
	                if (r.pk === j) {
	                  newRows[index].isSelected = true;
	                } else {
	                  newRows[index].isSelected = false;
	                }
	              });
	            } else {
	              newRows[index].isSelected = false;
	            }
	          });
	        } else {
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = false;
	          });
	        }
	
	        var frequentItems = _extends({}, _this17.state.frequentItems, { rows: newRows, selectedIndexes: selectedIndexes, selectedPK: selectedPK });
	        _this17.setState({ frequentItems: frequentItems });
	      };
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var frequentItems = _extends({}, _this17.state.frequentItems, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this17.setState({ frequentItems: frequentItems });
	      };
	      var handleFilterChange = function handleFilterChange(filter) {
	        _this17.state.frequentItems.rows = _this17.props.customerFrequent.record;
	        var newFilters = Object.assign({}, _this17.state.frequentItems.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var frequentItems = _extends({}, _this17.state.frequentItems, { filters: newFilters });
	        _this17.setState({ frequentItems: frequentItems });
	      };
	
	      // all filters removed
	      var onClearFilters = function onClearFilters() {
	        var frequentItems = _extends({}, _this17.state.frequentItems, { filters: {} });
	        _this17.setState({ frequentItems: frequentItems });
	      };
	      // const onRowSelect = rows => {
	      //     var previousOrderes = {...this.state.frequentItems, selectedRows: rows};
	      //     this.setState({frequentItems});
	      // }
	      var onRowClick = function onRowClick(rowIdx, row) {
	        if (rowIdx > -1) {
	          if (_this17.context.router.routes[1].path !== 'outboundOrders/new' && _this17.context.router.routes[1].path !== 'outboundOrders/:id') {
	            _this17.props.fetchItemSalesHistory(_this17.state.currentCustomer, row.Product_id);
	          }
	          _this17.selectInventoryInfo(row);
	          // this.props.fetchProductInfo(row.Product_id);
	        }
	      };
	      // Custom Formatter component
	      var IsEnabledFormatter = _react2.default.createClass({
	        displayName: 'IsEnabledFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            { className: 'label label-success' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	          );
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disable' })
	          );
	        }
	      });
	
	      var showProductCost = function showProductCost() {
	        if ((isJML || isChinaTown || _root_url.isRivera) && (0, _permissions2.default)('no_show_product_cost')) {
	          return false;
	        }
	        return true;
	      };
	      // Column definition
	      var columns = [{
	        key: 'ContainerNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'RefNum',
	        name: isWIZ ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: 'DispatchType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch' }),
	        resizable: true,
	        sortable: true,
	        width: 80
	      }, {
	        key: 'AvailableQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'available' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'FulfilledQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fulfilled' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        // key: 'Quantity',
	        key: 'InboundTotalQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'PickupDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_date' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: DateFormatter2
	      }, {
	        key: 'DropoffDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_date' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: DateFormatter2
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: 'CostPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }] : []), [{
	        key: 'NetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_weight' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }]);
	
	      var wizFreqColumns = [{
	        key: 'ContainerNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'RefNum',
	        name: isWIZ ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: 'DispatchType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch' }),
	        resizable: true,
	        sortable: true,
	        width: 80
	      }, {
	        key: 'AvailableQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'available' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'FulfilledQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fulfilled' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        // key: 'Quantity',
	        key: 'InboundTotalQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'Location',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' }),
	        resizable: true,
	        sortable: true,
	        width: 80
	      }, {
	        key: 'InboundCustomer',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'PickupDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_date' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: DateFormatter2
	      }, {
	        key: 'DropoffDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_date' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: DateFormatter2
	      }, {
	        key: 'InboundDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inbound_date' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: DateFormatter2
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: 'CostPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }] : []), [{
	        key: 'NetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_weight' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }]);
	
	      var kdwFreqColumns = [{
	        key: 'ContainerNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: 'FBARoute',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_route' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'ShipmentID',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipment_id' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'ServiceType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'service_type' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'ISANum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'isa_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'DispatchType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch' }),
	        resizable: true,
	        sortable: true,
	        width: 80
	      }, {
	        key: 'AvailableQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'available_box' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'FulfilledQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fulfilled_box' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        // key: 'Quantity',
	        key: 'InboundTotalQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_qty_box' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'FulfilledPallets',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ob_plt_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'InboundTotalPallets',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ib_plt_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'Location',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'PickupDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_date' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: DateFormatter2
	      }, {
	        key: 'DropoffDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_date' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: DateFormatter2
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: 'CostPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }] : []), [{
	        key: 'NetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_weight' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }]);
	
	      var abcffFreqColumns = [{
	        key: 'ContainerNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: 'Remark',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: 'Location',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'TrackingNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tracking_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'FBARoute',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_route' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'DispatchType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch' }),
	        resizable: true,
	        sortable: true,
	        width: 80
	      }, {
	        key: 'AvailableQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'available_box' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'FulfilledQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fulfilled_box' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        // key: 'Quantity',
	        key: 'InboundTotalQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_qty_box' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'InboundTotalPallets',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_qty_plt' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'PickupDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_date' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: DateFormatter2
	      }, {
	        key: 'DropoffDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_date' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: DateFormatter2
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: 'CostPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }] : []), [{
	        key: 'NetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_weight' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }]);
	
	      var dsqFreqColumns = [{
	        key: 'ContainerNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: 'Location',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'FBARoute',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_route' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'DispatchType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch' }),
	        resizable: true,
	        sortable: true,
	        width: 80
	      }, {
	        key: 'AvailableQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'available_box' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'FulfilledQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fulfilled_box' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        // key: 'Quantity',
	        key: 'InboundTotalQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_qty_box' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'InboundTotalPallets',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_qty_plt' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'PickupDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_date' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: DateFormatter2
	      }, {
	        key: 'DropoffDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_date' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: DateFormatter2
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: 'CostPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }] : []), [{
	        key: 'NetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_weight' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }]);
	
	      var jtbFreqColumns = [{
	        key: 'ContainerNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: 'AvailableQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'available' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'FulfilledQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fulfilled' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        // key: 'Quantity',
	        key: 'InboundTotalQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: 'CostPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }] : []), [{
	        key: 'NetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_weight' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }]);
	
	      var generateFreqColumns = function generateFreqColumns() {
	        if (isJTB) {
	          return jtbFreqColumns;
	        }
	        if (isDSQ || _root_url.isWUFS || isYI || isFBD) {
	          return dsqFreqColumns;
	        }
	        if (isKDW) {
	          return kdwFreqColumns;
	        }
	        if (isWIZ) {
	          return wizFreqColumns;
	        }
	        if (isABCFF) {
	          return abcffFreqColumns;
	        }
	        return columns;
	      };
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12, style: { marginTop: '-30px' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'react-table-customizer', id: 'SalesOrderForm-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'Product_id',
	              onGridSort: handleGridSort,
	              columns: generateFreqColumns(),
	              rowHeight: 25,
	              headerRowHeight: 45,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              enableRowSelect: 'multi',
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              onClearFilters: onClearFilters,
	              minHeight: 220,
	              onRowUpdated: this.handleRowUpdated,
	              onRowClick: onRowClick,
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              }
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderFrequent',
	    value: function renderFrequent() {
	      var _this18 = this;
	
	      if (this.props.customerFrequentIsLoading && !this.props.customerFrequentError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.customerFrequentError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.customerFrequentError)
	        )
	      );
	
	      // Parameters of the react-data-grid
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this18.state.frequentItems);
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var selectedIndexes = _this18.state.frequentItems.selectedIndexes.concat(rows.map(function (r) {
	          return r.rowIdx;
	        }));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        var frequentItems = _extends({}, _this18.state.frequentItems, { rows: newRows, selectedIndexes: selectedIndexes });
	        _this18.setState({ frequentItems: frequentItems });
	      };
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var rowIndexes = rows.map(function (r) {
	          return r.rowIdx;
	        });
	        var newRows = [].concat(_toConsumableArray(_this18.state.frequentItems.rows));
	        var selectedIndexes = _this18.state.frequentItems.selectedIndexes.filter(function (i) {
	          return rowIndexes.indexOf(i) === -1;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        var frequentItems = _extends({}, _this18.state.frequentItems, { rows: newRows, selectedIndexes: selectedIndexes });
	        _this18.setState({ frequentItems: frequentItems });
	      };
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var frequentItems = _extends({}, _this18.state.frequentItems, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this18.setState({ frequentItems: frequentItems });
	      };
	      // const onRowSelect = rows => {
	      //     var previousOrderes = {...this.state.frequentItems, selectedRows: rows};
	      //     this.setState({frequentItems});
	      // }
	      var onRowClick = function onRowClick(rowIdx, row) {
	        if (rowIdx > -1) {
	          if (_this18.context.router.routes[1].path !== 'outboundOrders/new' && _this18.context.router.routes[1].path !== 'outboundOrders/:id') {
	            _this18.props.fetchItemSalesHistory(_this18.state.currentCustomer, row.Product_id);
	          }
	          _this18.selectInventoryInfo(row);
	          // this.props.fetchProductInfo(row.Product_id);
	        }
	      };
	      // Custom Formatter component
	      var IsEnabledFormatter = _react2.default.createClass({
	        displayName: 'IsEnabledFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            { className: 'label label-success' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	          );
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disable' })
	          );
	        }
	      });
	
	      var showProductCost = function showProductCost() {
	        if ((isJML || isChinaTown || _root_url.isRivera) && (0, _permissions2.default)('no_show_product_cost')) {
	          return false;
	        }
	        return true;
	      };
	      // Column definition
	      var columns = [].concat(_toConsumableArray(!_root_url.isLO ? [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }] : []), [{
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: _root_url.isLO ? 160 : 70,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 250,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 200
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }], _toConsumableArray(showProductCost() ? [{
	        key: 'CostPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }] : []), [{
	        key: 'NetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_weight' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true
	      }], _toConsumableArray(_root_url.isLO ? [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }] : []));
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { className: 'react-table-customizer', id: 'SalesOrderForm-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'Product_id',
	              onGridSort: handleGridSort,
	              columns: columns,
	              rowHeight: 25,
	              headerRowHeight: 45,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              enableRowSelect: 'multi',
	              minHeight: 202,
	              onRowUpdated: this.handleRowUpdated,
	              onRowClick: onRowClick,
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              }
	            }),
	            !isChinaTown && _react2.default.createElement(
	              _reactBootstrap.Row,
	              { id: 'inventory-details' },
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 1 },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'inventory-label' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory' }),
	                  ':'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 5 },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 4 },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'col-xs-6 inlineLabel' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'in_stock' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'colon' },
	                        ':'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'col-xs-6 inventory-highlight' },
	                      ' ',
	                      this.state.inStock
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 4 },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'col-xs-7 inlineLabel' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchased' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'colon' },
	                        ':'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'col-xs-5 inventory-highlight' },
	                      ' ',
	                      this.state.purchased
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 4 },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'col-xs-6 inlineLabel' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'presale' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'colon' },
	                        ':'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'col-xs-6 inventory-highlight' },
	                      ' ',
	                      this.state.presale
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 6 },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-xs-5 inlineLabel' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'colon' },
	                      ':'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'col-xs-6 inventory-highlight' },
	                    ' ',
	                    this.state.net_weight
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-xs-5 inlineLabel' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_wt' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'colon' },
	                      ':'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'col-xs-6 inventory-highlight' },
	                    ' ',
	                    this.state.ship_weight
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-xs-5 inlineLabel' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'colon' },
	                      ':'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'col-xs-6 inventory-highlight' },
	                    ' ',
	                    this.state.total_weight
	                  )
	                )
	              )
	            ),
	            isChinaTown && _react2.default.createElement(
	              _reactBootstrap.Row,
	              { id: 'inventory-details', style: { fontSize: '15px' } },
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 1 },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'inventory-label-china' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory' }),
	                  ':'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 5 },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 4, className: 'pr1' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'col-xs-6 inlineLabel' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'in_stock' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'colon' },
	                        ':'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'col-xs-6 inventory-highlight-china' },
	                      ' ',
	                      this.state.inStock
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 4, className: 'pr1' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'col-xs-7 inlineLabel' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchased' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'colon' },
	                        ':'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'col-xs-5 inventory-highlight-china' },
	                      ' ',
	                      this.state.purchased
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 4, className: 'pr1' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'col-xs-6 inlineLabel' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'presale' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'colon' },
	                        ':'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'col-xs-6 inventory-highlight-china' },
	                      ' ',
	                      this.state.presale
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 6 },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4, className: 'pr1' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-xs-5 inlineLabel' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'colon' },
	                      ':'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'col-xs-6 inventory-highlight-china' },
	                    ' ',
	                    this.state.net_weight
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4, className: 'pr1' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-xs-5 inlineLabel' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_wt' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'colon' },
	                      ':'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'col-xs-6 inventory-highlight-china' },
	                    ' ',
	                    this.state.ship_weight
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4, className: 'pr1' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'col-xs-5 inlineLabel' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'colon' },
	                      ':'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'col-xs-6 inventory-highlight-china' },
	                    ' ',
	                    this.state.total_weight
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderOpenOrder',
	    value: function renderOpenOrder() {
	      var _this19 = this;
	
	      var _props2 = this.props,
	          salesCustomerDetails = _props2.salesCustomerDetails,
	          salesOrderCreated = _props2.salesOrderCreated,
	          currentSalesOrder = _props2.currentSalesOrder;
	
	      var salesOrder = salesOrderCreated || currentSalesOrder;
	      var orders = [];
	      var orderlist = '';
	      var route = '';
	      if (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
	        route = 'salesOrders';
	      } else if (this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id') {
	        route = 'mobileSalesOrders';
	      }
	      if (salesCustomerDetails && salesCustomerDetails.open_orders) {
	        orders = salesCustomerDetails.open_orders;
	        orderlist = salesCustomerDetails.open_orders.map(function (order) {
	          return _react2.default.createElement(
	            'li',
	            { style: { fontSize: '20px', listStyleType: 'none' } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_orders' }),
	            ' : ',
	            order.SONum,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                type: 'button',
	                onClick: function onClick() {
	                  _this19.props.fetchSalesOrderDetail(order.SalesOrder_id, route).then(function () {
	                    _this19.props.selectSalesOrder(_this19.props.currentSalesOrderDetail);
	                    _this19.context.router.push('/salesOrders/' + order.SalesOrder_id);
	                  });
	                }
	              },
	              _react2.default.createElement('em', { className: 'fa fa-edit' }),
	              ' ',
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	            )
	          );
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'ul',
	          null,
	          orderlist
	        )
	      );
	    }
	  }, {
	    key: 'renderHistory',
	    value: function renderHistory() {
	      var _this20 = this;
	
	      if (this.props.customerSalesHistoryIsLoading && !this.props.customerSalesHistoryError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.customerSalesHistoryError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.customerSalesHistoryError)
	        )
	      );
	
	      // Parameters of the react-data-grid
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this20.state.salesHistory);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this20.state.salesHistory.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var salesHistory = _extends({}, _this20.state.salesHistory, { filters: newFilters });
	        _this20.setState({ salesHistory: salesHistory });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        var salesHistory = _extends({}, _this20.state.salesHistory, { filters: {} });
	        _this20.setState({ salesHistory: salesHistory });
	      };
	
	      var HighlightFormatter = _react2.default.createClass({
	        displayName: 'HighlightFormatter',
	        render: function render() {
	          var _this21 = this;
	
	          var rows = this.props.state.rows;
	          if (rows.some(function (e) {
	            return e.ProductNum === _this21.props.value;
	          })) {
	            return _react2.default.createElement(
	              'div',
	              { style: { backgroundColor: '#5CB85C' } },
	              this.props.value
	            );
	          }
	          return _react2.default.createElement(
	            'div',
	            null,
	            this.props.value
	          );
	        }
	      });
	
	      var columns = [{
	        key: 'productNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 110,
	        formatter: _react2.default.createElement(HighlightFormatter, { state: this.state })
	      }, {
	        key: 'name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 110
	      }, {
	        key: 'description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 110
	      }, {
	        key: 'quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 110,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'totalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 110,
	        formatter: _boldCashFormatter2.default
	      }];
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { id: 'salesOrders-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'SalesOrder_id',
	                columns: columns,
	                rowHeight: 25,
	                headerRowHeight: 45,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                minHeight: 270,
	                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                onAddFilter: handleFilterChange,
	                onClearFilters: onClearFilters
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderPreviousSOs',
	    value: function renderPreviousSOs() {
	      var _this22 = this;
	
	      if (this.props.previousOrdersIsLoading && !this.props.previousOrdersError || this.props.detailByNumIsLoading && !this.props.detailByNumError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.previousOrdersError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.previousOrdersError)
	        )
	      );
	
	      // Parameters of the react-data-grid
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this22.state.previousSOs);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the row select function
	      var onRowClick = function onRowClick(rowIdx, row) {
	        if (rowIdx !== -1) {
	          var rows = getRows();
	
	          /* Single row select on row click */
	          rows.map(function (r) {
	            r.isSelected = false;
	          });
	          var selectedRows = [rows[rowIdx]];
	          rows[rowIdx].isSelected = true;
	
	          var previousSOs = _extends({}, _this22.state.previousSOs, { rows: rows, selectedRows: selectedRows });
	          _this22.setState({ previousSOs: previousSOs });
	          _this22.props.fetchPreviousOrderById(row.SalesOrder_id);
	        }
	      };
	
	      var onRowSelect = function onRowSelect(rows) {
	        var previousSOs = _extends({}, _this22.state.previousSOs, { selectedRows: rows });
	        _this22.setState({ previousSOs: previousSOs });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        var previousSOs = _extends({}, _this22.state.previousSOs, { rows: newRows, selectedRows: [rows[0].row] });
	        _this22.props.fetchPreviousOrderById(rows[0].row.SalesOrder_id);
	        _this22.setState({ previousSOs: previousSOs });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = getRows();
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        var previousSOs = _extends({}, _this22.state.previousSOs, { rows: newRows, selectedRows: [] });
	        _this22.setState({ previousSOs: previousSOs });
	      };
	
	      var columns = [{
	        key: 'SONum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: false,
	        width: 110
	      }];
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { id: 'salesOrders-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'SalesOrder_id',
	                columns: columns,
	                rowHeight: 25,
	                headerRowHeight: 45,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                minHeight: 221,
	                enableRowSelect: 'single',
	                onRowSelect: onRowSelect,
	                onRowClick: onRowClick,
	                rowSelection: {
	                  showCheckbox: true,
	                  onRowsSelected: onRowsSelected,
	                  onRowsDeselected: onRowsDeselected,
	                  selectBy: {
	                    isSelectedKey: 'isSelected'
	                  }
	                }
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderPreviousOrders',
	    value: function renderPreviousOrders() {
	      var _this23 = this;
	
	      if (this.props.previousOrdersIsLoading && !this.props.previousOrdersError || this.props.detailByNumIsLoading && !this.props.detailByNumError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.previousOrdersError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.previousOrdersError)
	        )
	      );
	      // Parameters of the react-data-grid
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this23.state.previousOrders);
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var ordersRows = [].concat(_toConsumableArray(_this23.state.previousOrders.rows));
	        var selectedRows = [].concat(_toConsumableArray(_this23.state.previousOrders.selectedRows));
	        var selectedIndexes = _this23.state.previousOrders.selectedIndexes.concat(rows.map(function (r) {
	          return r.rowIdx;
	        }));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	          selectedRows.push(r.row);
	        });
	        var previousOrders = _extends({}, _this23.state.previousOrders, { rows: ordersRows, selectedIndexes: selectedIndexes, selectedRows: selectedRows });
	        _this23.setState({ previousOrders: previousOrders });
	      };
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var rowIndexes = rows.map(function (r) {
	          return r.rowIdx;
	        });
	        var newRows = [].concat(_toConsumableArray(_this23.state.previousOrders.rows));
	        var selectedIndexes = _this23.state.previousOrders.selectedIndexes.filter(function (i) {
	          return rowIndexes.indexOf(i) === -1;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        var previousOrders = _extends({}, _this23.state.previousOrders, { rows: newRows, selectedIndexes: selectedIndexes });
	        _this23.setState({ previousOrders: previousOrders });
	      };
	      var onRowClick = function onRowClick(rowIdx, row) {
	        if (rowIdx > -1) {
	          if (_this23.context.router.routes[1].path !== 'outboundOrders/new' && _this23.context.router.routes[1].path !== 'outboundOrders/:id') {
	            _this23.props.fetchItemSalesHistory(_this23.state.currentCustomer, row.Product_id);
	          }
	          // this.props.fetchProductInfo(row.Product_id);
	        }
	      };
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var previousOrders = _extends({}, _this23.state.previousOrders, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this23.setState({ previousOrders: previousOrders });
	      };
	      var onRowSelect = function onRowSelect(rows) {
	        var previousOrderes = _extends({}, _this23.state.previousOrders, { selectedRows: rows });
	        _this23.setState({ previousOrders: previousOrders });
	      };
	      // Custom Formatter component
	      var IsEnabledFormatter = _react2.default.createClass({
	        displayName: 'IsEnabledFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            { className: 'label label-success' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	          );
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disable' })
	          );
	        }
	      });
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this23.state.previousOrders.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var previousOrders = _extends({}, _this23.state.previousOrders, { filters: newFilters });
	        _this23.setState({ previousOrders: previousOrders });
	      };
	
	      // all filters removed
	      var onClearFilters = function onClearFilters() {
	        var previousOrders = _extends({}, _this23.state.previousOrders, { filters: {} });
	        _this23.setState({ previousOrders: previousOrders });
	      };
	
	      var showProductCost = function showProductCost() {
	        if ((isJML || isChinaTown || _root_url.isRivera) && (0, _permissions2.default)('no_show_product_cost')) {
	          return false;
	        }
	        return true;
	      };
	
	      // Column difinition
	      var columns = [].concat(_toConsumableArray(!_root_url.isLO ? [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }] : []), [{
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: _root_url.isLO ? 160 : 80,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 170,
	        filterable: true,
	        filterRenderer: _filterMultiKeyword2.default
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        filterRenderer: _filterMultiKeyword2.default,
	        width: 100
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 65,
	        filterable: true,
	        formatter: _boldCashFormatter2.default
	      }], _toConsumableArray(showProductCost() ? [{
	        key: 'CostPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 75,
	        filterable: true
	      }] : []), [{
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 55,
	        filterable: true,
	        formatter: _boldCashFormatter2.default
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'TotalNetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true
	      }], _toConsumableArray(_root_url.isLO ? [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }] : []));
	      return (
	        // Previous Orders Table
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12, style: { marginTop: '-22px' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'PreviousOrders-dataGrid', style: { maxWidth: '99%' } },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'Product_id',
	                onGridSort: handleGridSort,
	                columns: columns,
	                rowHeight: 25,
	                headerRowHeight: 45,
	                minHeight: 221,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                enableRowSelect: 'single',
	                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                onAddFilter: handleFilterChange,
	                onClearFilters: onClearFilters,
	                onRowUpdated: this.handleRowUpdated,
	                onRowSelect: onRowSelect,
	                onRowClick: onRowClick,
	                rowSelection: {
	                  showCheckbox: true,
	                  onRowsSelected: onRowsSelected,
	                  onRowsDeselected: onRowsDeselected,
	                  selectBy: {
	                    isSelectedKey: 'isSelected'
	                  }
	                }
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderItemHistory',
	    value: function renderItemHistory() {
	      // Column difinition
	      var columns = [{
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: isChinaTown ? 45 : 40
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 50
	      }, {
	        key: 'SIUnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'si_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: isChinaTown ? 60 : 50
	      }, {
	        key: 'Date',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	        resizable: true,
	        sortable: true,
	        width: 85,
	        formatter: DateFormatterChina
	      }];
	
	      if (isChinaTown) {
	        var index1 = _lodash2.default.findIndex(columns, { key: "UnitPrice" });
	        columns.splice(index1, 1);
	      }
	
	      var minHeight = isChinaTown ? 385 : 70; //chinatest
	      return _react2.default.createElement(_itemHistoryGrid2.default, {
	        columns: columns,
	        rowHeight: 25,
	        minHeight: minHeight
	      });
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this24 = this;
	
	      var that = this;
	      // Parameters of the react-data-grid
	      var allRows = _reactDataGridAddons.Data.Selectors.getRows(this.state);
	      if (isHMM) {
	        allRows.sort(function (valueA, valueB) {
	          return parseFloat(valueA.Order) <= parseFloat(valueB.Order) ? -1 : 1;
	        });
	      }
	      var getRows = function getRows() {
	        return allRows;
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return Object.assign({ Idx: rowIdx + 1 }, rows[rowIdx]);
	      };
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = _this24.state.rows;
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        _this24.setState(_extends({}, _this24.state, { rows: newRows }));
	      };
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = _this24.state.rows;
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        _this24.setState(_extends({}, _this24.state, { rows: newRows }));
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this24.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this24.setState(state);
	      };
	      var handleFilterChange = function handleFilterChange(filter) {
	        var filteredRows = [].concat(_toConsumableArray(_this24.state.rows));
	        var newFilters = Object.assign({}, _this24.state.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        for (var property in newFilters) {
	          if (newFilters.hasOwnProperty(property)) {
	            filteredRows = filteredRows.filter(function (obj) {
	              if (obj[property]) {
	                return String(obj[property].toUpperCase()).includes(newFilters[property].filterTerm.toUpperCase());
	              }
	              return false;
	            });
	          }
	        }
	        _this24.setState({ filters: newFilters, filteredRows: filteredRows });
	      };
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        _this24.setState({ filters: {} });
	      };
	
	      var isNumeric = function isNumeric(str) {
	        if (typeof str !== "string") return false; // we only process strings!  
	        return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
	        !isNaN(parseFloat(str)); // ...and ensure strings of whitespace fail
	      };
	
	      // for ABCFF to set received case qty [ReceivedCaseQty] = case qty [Quantity]
	      var autoLoad = function autoLoad() {
	        var rows = getRows();
	        var newRows = [].concat(_toConsumableArray(_this24.state.rows));
	        newRows.map(function (row, rowIdx) {
	          row.ReceivedCaseQty = row.Quantity;
	          var e = {
	            cellKey: "autoLoad",
	            key: undefined,
	            rowIdx: rowIdx,
	            updated: { ReceivedCaseQty: String(row.Quantity) }
	          };
	          handleRowUpdated(e);
	        });
	        _this24.setState({ rows: newRows });
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        if (isHMM) {
	          if (e.cellKey === 'Order') {
	            if (!isNumeric(e.updated.Order)) {
	              return;
	            }
	            var _rows2 = _this24.state.rows;
	            var positionIndexExsited = false;
	            _rows2.forEach(function (row, idx) {
	              if (e.updated.Order === row.Order && e.rowIdx !== idx) {
	                positionIndexExsited = true;
	                alert('Position Index has been taken');
	                // return;
	              }
	            });
	            if (positionIndexExsited) {
	              return;
	            }
	          }
	        }
	
	        var rows = getRows();
	        var filteredRows = _this24.state.filteredRows;
	        var index = void 0;
	
	        if (e.cellKey === 'autoLoad') {
	          Object.assign(rows[e.rowIdx], { ReceivedCaseQty: e.updated.ReceivedCaseQty });
	        }
	
	        if (e.updated.PalletQuantity != null && (isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD)) {
	          // LALALA
	          if (isNaN(e.updated.PalletQuantity)) {
	            return;
	          }
	          // if ((this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && rows[e.rowIdx].AvailablePallets && (e.updated.PalletQuantity > rows[e.rowIdx].AvailablePallets)) {
	          //   alert("Cannot exceed available pallet quantity: " + rows[e.rowIdx].AvailablePallets);
	          //   return;
	          // }
	        }
	
	        if (e.updated.Quantity != null) {
	          if (isNaN(e.updated.Quantity)) {
	            return;
	          }
	          if ((_this24.context.router.routes[1].path === 'outboundOrders/new' || _this24.context.router.routes[1].path === 'outboundOrders/:id') && rows[e.rowIdx].AvailableQuantity && e.updated.Quantity > rows[e.rowIdx].AvailableQuantity) {
	            alert("Cannot exceed available quantity: " + rows[e.rowIdx].AvailableQuantity);
	            return;
	          }
	
	          // if ((this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && rows[e.rowIdx].AvailableQuantityPallet && (e.updated.PalletQuantity > rows[e.rowIdx].AvailableQuantityPallet)) {
	          //   alert("Cannot exceed available quantity: " + rows[e.rowIdx].AvailableQuantityPallet);
	          //   return;
	          // }
	          // if ((this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && rows[e.rowIdx].AvailableQuantityBox && (e.updated.BoxQuantity > rows[e.rowIdx].AvailableQuantityBox)) {
	          //   alert("Cannot exceed available quantity: " + rows[e.rowIdx].AvailableQuantityBox);
	          //   return;
	          // }
	          // if ((this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && rows[e.rowIdx].AvailableQuantityPiece && (e.updated.PieceQuantity > rows[e.rowIdx].AvailableQuantityPiece)) {
	          //   alert("Cannot exceed available quantity: " + rows[e.rowIdx].AvailableQuantityPiece);
	          //   return;
	          // }
	          if (!rows[e.rowIdx].IsOverSaleable && parseInt(e.updated.Quantity) > rows[e.rowIdx].InStock && !isAFG) {
	            return;
	          }
	          if (parseFloat(e.updated.Quantity) < 0) {
	            alert("Quantity is not allowed to be negative");
	            return;
	          }
	          if (rows[e.rowIdx].ProductType == 'Fixed') {
	            Object.assign(rows[e.rowIdx], { TotalPrice: +(0, _NumberUtil.roundToDecimals)(parseFloat(e.updated.Quantity * rows[e.rowIdx].UnitPrice), 4).toFixed(4) });
	          } else {
	            Object.assign(rows[e.rowIdx], { TotalPrice: +(0, _NumberUtil.roundToDecimals)(parseFloat(e.updated.Quantity * rows[e.rowIdx].UnitPrice * rows[e.rowIdx][!isJML ? 'NetWeight' : 'PackageSize_1']), 4).toFixed(4) });
	          }
	          Object.assign(rows[e.rowIdx], { TotalNetWeight: (0, _NumberUtil.roundTo)(e.updated.Quantity * rows[e.rowIdx].NetWeight, 2) });
	          if (rows[e.rowIdx].CRV) {
	            Object.assign(rows[e.rowIdx], { TotalCRV: +(0, _NumberUtil.roundTo)(parseFloat(e.updated.Quantity * rows[e.rowIdx].CRV), 2).toFixed(2) });
	          }
	        }
	
	        if (isABCFF && e.updated.ReceivedCaseQty != null) {
	          if (!isNumeric(e.updated.ReceivedCaseQty)) {
	            return;
	          }
	          Object.assign(rows[e.rowIdx], { ReceivedQuantity: e.updated.ReceivedCaseQty * rows[e.rowIdx].PerBoxQty });
	        }
	
	        if (isJML && e.updated.jmlPackageSize1 != null) {
	          if (isNaN(e.updated.jmlPackageSize1)) {
	            return;
	          }
	          if (parseFloat(e.updated.jmlPackageSize1) < 1) {
	            alert("Minimum amount allowed: 1");
	            return;
	          }
	          Object.assign(rows[e.rowIdx], { Quantity: e.updated.jmlPackageSize1 * rows[e.rowIdx].jmlBox });
	          Object.assign(rows[e.rowIdx], { TotalPrice: +(0, _NumberUtil.roundToDecimals)(parseFloat(rows[e.rowIdx].Quantity * rows[e.rowIdx].UnitPrice), 4).toFixed(4) });
	        }
	
	        if (isJML && e.updated.jmlBox != null) {
	          if (isNaN(e.updated.jmlBox)) {
	            return;
	          }
	          if (parseFloat(e.updated.jmlBox) < 1) {
	            alert("Minimum amount allowed: 1");
	            return;
	          }
	          _this24.setState({
	            lineBatchId: rows[e.rowIdx].Batch_id_id ? rows[e.rowIdx].Batch_id_id : rows[e.rowIdx].Batch_id,
	            lineBatchRows: _this24.state.rows,
	            lineBatchIdx: rows[e.rowIdx].Index,
	            lineQty: e.updated.jmlBox,
	            isBatchesModal2Visible: true
	          });
	
	          Object.assign(rows[e.rowIdx], { Quantity: e.updated.jmlBox * rows[e.rowIdx].jmlPackageSize1 });
	          Object.assign(rows[e.rowIdx], { TotalPrice: +(0, _NumberUtil.roundToDecimals)(parseFloat(rows[e.rowIdx].Quantity * rows[e.rowIdx].UnitPrice), 4).toFixed(4) });
	        }
	
	        if (e.updated.UnitPrice != null) {
	          if (isNaN(e.updated.UnitPrice)) {
	            return;
	          }
	          if (parseFloat(e.updated.UnitPrice) > 0 && e.updated.UnitPrice < rows[e.rowIdx].LowestSalePrice) {
	            _this24.setState({
	              case: 'belowRefPrice', confirmOpen: true, RowBeingEdited: _extends({}, rows[e.rowIdx]), newPrice: e.updated.UnitPrice
	            });
	            return;
	          }
	          if (parseFloat(e.updated.UnitPrice) < 0) {
	            alert("Unit Price is not allowed to be negative");
	            return;
	          }
	          if (rows[e.rowIdx].ProductType === 'Fixed') {
	            Object.assign(rows[e.rowIdx], { TotalPrice: +(0, _NumberUtil.roundToDecimals)(parseFloat(e.updated.UnitPrice * rows[e.rowIdx].Quantity), 4).toFixed(4) });
	          } else {
	            Object.assign(rows[e.rowIdx], { TotalPrice: +(0, _NumberUtil.roundToDecimals)(parseFloat(e.updated.UnitPrice * rows[e.rowIdx].NetWeight * rows[e.rowIdx].Quantity), 4).toFixed(4) });
	          }
	        }
	        if (e.updated.Remark != null) {
	          Object.assign(rows[e.rowIdx], { Remark: e.updated.Remark });
	        }
	        if (isHMM && e.cellKey === 'Order') {
	          Object.assign(rows[e.rowIdx], { Order: parseFloat(e.updated.Order) });
	        } else {
	          Object.assign(rows[e.rowIdx], e.updated);
	        }
	        // this.setState({ rows });
	        // }
	        // CODE FOR UPDATING TOTALS
	        var totalPrice = 0;
	        var finalWeight = 0;
	        var finalPrice = 0;
	        var totalTax = 0;
	        var totalTaxOriginal = 0;
	        var totalCRV = 0;
	        var discount = parseFloat(_this24.props.discount) || 0;
	        // if (totalPrice == null)
	        //   totalPrice = 0;
	        // if (finalWeight ==null)
	        //   finalWeight = 0;
	        rows.map(function (row) {
	          if (isHMM) {
	            totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
	          } else {
	            totalPrice += parseFloat(row.TotalPrice);
	          }
	          finalWeight += parseFloat(row.NetWeight * row.Quantity);
	          if (row.IsTaxable === true || row.IsTaxable === 'True') {
	            if (isHMM) {
	              totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(_this24.state.taxValue / 100);
	            } else {
	              if (isAN || _root_url.isElegant) {
	                var taxable = !_this24.props.salesCustomerDetails.Reseller;
	                if (isAN) {
	                  taxable = row.IsAllTaxable === true || !_this24.props.salesCustomerDetails.Reseller;
	                }
	                if (taxable) {
	                  totalTax += parseFloat(row.TotalPrice) * parseFloat(_this24.state.taxValue / 100);
	                }
	              } else {
	                totalTax += parseFloat(row.TotalPrice) * parseFloat(_this24.state.taxValue / 100);
	              }
	            }
	          }
	          if (row.CRV) {
	            row.TotalCRV = +(0, _NumberUtil.roundTo)(parseFloat(row.CRV * row.Quantity), 2).toFixed(2);
	          }
	          if (row.TotalCRV) {
	            totalCRV += row.TotalCRV;
	          }
	        });
	        totalTaxOriginal = totalTax = +(0, _NumberUtil.roundTo)(totalTax, 2).toFixed(2);
	        if (_root_url.isElegant) {
	          discount = parseFloat(_this24.state.SODiscount) || parseFloat(_this24.state.SOSavings) / totalPrice * 100 || 0;
	          totalTax = +(0, _NumberUtil.roundTo)((1 - discount / 100) * totalTax, 2).toFixed(2);
	        }
	        finalPrice = parseFloat(totalPrice) * (1 - discount / 100) + parseFloat(totalTax) + parseFloat(totalCRV);
	        finalWeight = +(0, _NumberUtil.roundTo)(finalWeight, 2).toFixed(2);
	        totalPrice = +(0, _NumberUtil.roundToDecimals)(totalPrice, 4).toFixed(4);
	        finalPrice = +(0, _NumberUtil.roundTo)(finalPrice, 2).toFixed(2);
	        var productNum = _this24.state.rows[e.rowIdx].ProductNum;
	        var productId = _this24.state.rows[e.rowIdx].Product_id;
	        _this24.setState({
	          rows: rows, totalPrice: totalPrice, finalWeight: finalWeight, finalPrice: finalPrice, totalTax: totalTax, totalCRV: totalCRV, totalTaxOriginal: totalTaxOriginal
	        }, function () {
	          if (_root_url.isEcity) {
	            if (rows[e.rowIdx].UnitPrice) {
	              _this24.props.fetchProductPromotion(productId, null, function () {
	                return _this24.checkForPromotions(productNum);
	              });
	            }
	          }
	        });
	      };
	      var onRowClick = function onRowClick(rowIdx, row) {
	        if (rowIdx > -1) {
	          if (_this24.context.router.routes[1].path !== 'outboundOrders/new' && _this24.context.router.routes[1].path !== 'outboundOrders/:id') {
	            _this24.props.fetchItemSalesHistory(_this24.state.currentCustomer, row.Product_id);
	          }
	          // if (this.state.yourOrderKey === 1) {
	          // here
	          if (isJML) {
	            _this24.props.fetchBatchesByID(row.Product_id, true);
	            _this24.selectInventoryInfo(row);
	          } else {
	            _this24.props.fetchProductInfo2(row.Product_id);
	          }
	          // }
	        }
	      };
	
	      var IsVariableFormatter = _react2.default.createClass({
	        displayName: 'IsVariableFormatter',
	        render: function render() {
	          var _this25 = this;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                className: 'textAlignStyle',
	                style: { height: '23px', width: '39px', padding: '0px' },
	                onClick: function onClick() {
	                  // const ProductNum = this.props.dependentValues.ProductNum;
	                  var Index = _this25.props.dependentValues.Index;
	                  that.removeRow(Index);
	                }
	              },
	              'X'
	            )
	          );
	        }
	      });
	
	      // Column difinition
	      var showProductCost = function showProductCost() {
	        if (isHMM || isJML) {
	          return false;
	        }
	        if ((isJML || isChinaTown || _root_url.isRivera) && (0, _permissions2.default)('no_show_product_cost')) {
	          return false;
	        }
	        return true;
	      };
	
	      var unitPriceEditable = function unitPriceEditable() {
	        if (isHMM && !(0, _permissions2.default)('hmm_so_change_unit_price')) {
	          false;
	        }
	        if (_root_url.isRivera && !(0, _permissions2.default)('edit_sales_order_price')) {
	          return false;
	        }
	        return true;
	      };
	
	      var columns = isChinaTown ? [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	        resizable: true,
	        sortable: true,
	        width: 200
	      }, {
	        key: 'Quantity',
	        name: !isJML ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true,
	        // editable: this.state.editSOPermission,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        // editable: this.state.editSOPermission,
	        editable: unitPriceEditable(),
	        formatter: _boldCashFormatter2.default
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: _boldCashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: 'cost',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: PriceFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice;
	        }
	      }] : []), [{
	        key: 'NetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true
	      }, {
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'TotalNetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'Remark',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }]) : [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }].concat(_toConsumableArray(isHMM ? [{
	        key: 'Order',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'positionIndex' }),
	        resizable: true,
	        sortable: true,
	        editable: true,
	        width: 70,
	        filterable: true
	      }] : [{
	        key: 'Index',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	        width: 35,
	        resizable: false,
	        sortable: true
	      }]), _toConsumableArray(!_root_url.isLO ? [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }] : []), _toConsumableArray(isABC ? [{
	        key: 'RefNo',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'FBA_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PoNo',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pro_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }] : []), _toConsumableArray(isTN ? [{
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        },
	        formatter: function formatter(_ref) {
	          var value = _ref.value,
	              dependentValues = _ref.dependentValues;
	
	          return _react2.default.createElement(
	            'div',
	            {
	              onDoubleClick: function onDoubleClick() {
	                _this24.props.fetchSalesOrderProductByID(dependentValues.Product_id, _this24.state.currentCustomer);
	                _this24.props.fetchBatchesByID(dependentValues.Product_id).then(function () {
	                  _this24.setBatchesModal2Visibility(true);
	                });
	                _this24.setState({
	                  lineBatchId: dependentValues.Batch_id_id ? dependentValues.Batch_id_id : dependentValues.Batch_id,
	                  lineBatchRows: _this24.state.rows,
	                  lineBatchIdx: dependentValues.Index,
	                  lineQty: dependentValues.Quantity
	                });
	                // this.setBatchesModal2Visibility(true);
	              }
	            },
	            value
	          );
	        }
	      }] : [{
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: isJML || _root_url.isLO ? 200 : 70,
	        filterable: true
	      }]), _toConsumableArray(isAFM ? [{
	        key: 'Brand',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'brand' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }] : []), [{
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	        resizable: true,
	        sortable: true,
	        width: isChinaTown ? 200 : 85
	      }], _toConsumableArray(isJML ? [{
	        key: 'jmlBox',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true, // this.state.editSOPermission
	        formatter: _boldTextFormatter2.default
	      }] : []), _toConsumableArray(isJML ? [{
	        key: 'jmlPackageSize1',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pcs/box' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: true, // this.state.editSOPermission
	        formatter: _boldTextFormatter2.default
	      }] : []), [{
	        key: 'Quantity',
	        name: !isJML ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_units' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: isJML ? false : true, // this.state.editSOPermission
	        formatter: _boldTextFormatter2.default
	      }], _toConsumableArray(isTN ? [{
	        key: 'pallet_barcode',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_barcode' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 150
	      }] : []), [{
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: unitPriceEditable(), // this.state.editSOPermission
	        formatter: _boldCashFormatter2.default
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true,
	        formatter: _boldCashFormatter2.default
	      }], _toConsumableArray(showProductCost() ? [{
	        key: 'cost',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }), //okc problem
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: PriceFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice;
	        }
	      }] : []), [{
	        key: 'NetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true
	      }, {
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'TotalNetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'Remark',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }]);
	
	      if (_root_url.isEcity || _root_url.isLucky88) {
	        var costIndex = _lodash2.default.findIndex(columns, { key: 'cost' });
	        var cost = {
	          key: 'cost',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }), //okc problem
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true,
	          formatter: PriceFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row.ArrivalPrice ? row.ArrivalPrice : row.UnitArrivalPrice;
	          }
	        };
	        var margin = {
	          key: 'SalesMargin',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_margin' }), //okc problem
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	          // formatter: PriceFormatter,
	          // getRowMetaData: row => row.ArrivalPrice ? row.ArrivalPrice : row.UnitArrivalPrice,
	        };
	        columns.splice(costIndex, 1, cost, margin);
	      }
	      if (isJML) {
	        var index1 = _lodash2.default.findIndex(columns, { key: "NetWeight" });
	        columns.splice(index1, 1);
	        var index2 = _lodash2.default.findIndex(columns, { key: "TotalNetWeight" });
	        columns.splice(index2, 1);
	      }
	
	      if (isHMM) {
	        var temp = {
	          key: 'TotalPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	          resizable: true,
	          sortable: true,
	          width: 70,
	          filterable: true,
	          formatter: HMMPriceFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        };
	        columns.splice(8, 1, temp);
	      }
	
	      if (_root_url.isLO) {
	        var refIndex = columns.findIndex(function (column) {
	          return column.key === 'RefNum';
	        });
	        if (refIndex !== -1) {
	          columns[refIndex].name = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'item_num' });
	        }
	        var nameIndex = columns.findIndex(function (column) {
	          return column.key === 'Name';
	        });
	        if (nameIndex !== -1) {
	          columns[nameIndex].name = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' });
	          columns[nameIndex].width = 426;
	        }
	        var descriptionIndex = columns.findIndex(function (column) {
	          return column.key === 'Description';
	        });
	        if (descriptionIndex !== -1) {
	          columns.splice(descriptionIndex, 1);
	        }
	      }
	
	      var boolOptions = ['true', 'false'];
	
	      var abcffColumn = this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id' ? [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'Index',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	        width: 35,
	        resizable: false,
	        sortable: true
	      }, {
	        key: "UnitQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'case_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true, // editSOPermission 
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: "PerBoxQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit/box' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: 'PalletQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true, // editSOPermission
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'RepackedPalletQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'repack_plt_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'AvailableQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'available_box' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'RefNum',
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	        resizable: true,
	        sortable: true,
	        width: 120
	      }, {
	        key: 'Remark',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }, {
	        key: 'InnerLabelQty',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inner_label' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true, // editSOPermission
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'OuterLabelQty',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'outer_label' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true, // editSOPermission
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: "FBACode",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'FBA-Code' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "FBARoute",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'FBA-Route' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "TrailerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trailer' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "POList",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_list' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "POD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pod' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editor: _react2.default.createElement(DropDownEditor, { options: boolOptions }),
	        formatter: function formatter(_ref2) {
	          var value = _ref2.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value === true || value === 'true' ? "true" : "false"
	          );
	        }
	      }, {
	        key: "DimUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dim_unit' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "WeightUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight_unit' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "BoxLength",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_L' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxWidth",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_W' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxHeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_H' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "BoxWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "PalletLength",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_L' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletWidth",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_W' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletHeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_H' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "PalletWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "UnitLength",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_L' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "UnitWidth",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_w' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "UnitHeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_h' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "UnitVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "Location",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        formatter: function formatter(_ref3) {
	          var value = _ref3.value,
	              dependentValues = _ref3.dependentValues;
	          return _react2.default.createElement(
	            'div',
	            {
	              style: { width: "100%", height: "100%", textAlign: "center" },
	              onDoubleClick: function onDoubleClick() {
	                _this24.openZBLModal(value, dependentValues);
	              }
	            },
	            value
	          );
	        },
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: "PalletStackable",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'stackable' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editor: _react2.default.createElement(DropDownEditor, { options: boolOptions }),
	        formatter: function formatter(_ref4) {
	          var value = _ref4.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value === true || value === 'true' ? "true" : "false"
	          );
	        }
	      }, {
	        key: "StoreReady",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'store_ready' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editor: _react2.default.createElement(DropDownEditor, { options: boolOptions }),
	        formatter: function formatter(_ref5) {
	          var value = _ref5.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value === true || value === 'true' ? "true" : "false"
	          );
	        }
	      }, {
	        key: "Preticketed",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'preticketed' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 120,
	        editor: _react2.default.createElement(DropDownEditor, { options: boolOptions }),
	        formatter: function formatter(_ref6) {
	          var value = _ref6.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value === true || value === 'true' ? "true" : "false"
	          );
	        }
	      }, {
	        key: "CantonNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'canton' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "OriginCountry",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'country' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "VendorStyleNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_style' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: "TJXStyleNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tjx_style' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: "UPC",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'upc' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: "Color",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'color' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: "Size",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'size_ratio' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: isHMM && !(0, _permissions2.default)('hmm_so_change_unit_price') ? false : true,
	        formatter: _boldCashFormatter2.default
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true,
	        formatter: _boldCashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: 'cost',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: PriceFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice;
	        }
	      }] : []), [{
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'Remark',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }]) : [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'Index',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	        width: 35,
	        resizable: false,
	        sortable: true
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'RefNum',
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	        resizable: true,
	        sortable: true,
	        width: 120
	      }, {
	        key: 'Remark',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }, {
	        key: 'UnitQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true, // editSOPermission
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'case_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true, // editSOPermission
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: "PerBoxQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_case' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        //
	        key: "ReceivedCaseQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'received_case_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        },
	        formatter: function formatter(_ref7) {
	          var value = _ref7.value,
	              dependentValues = _ref7.dependentValues;
	          return _react2.default.createElement(
	            'div',
	            null,
	            dependentValues.PerBoxQty ? dependentValues.ReceivedQuantity / dependentValues.PerBoxQty : ""
	          );
	        },
	        editable: true
	        // user use this to change ReceivedQuantity
	        // received_case_qty = received_unit_qty / PerBoxQty
	      }, {
	        key: "ReceivedQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'received_unit_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: 'PalletQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true, // editSOPermission
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: "Location",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        formatter: function formatter(_ref8) {
	          var value = _ref8.value,
	              dependentValues = _ref8.dependentValues;
	          return _react2.default.createElement(
	            'div',
	            {
	              style: { width: "100%", height: "100%", textAlign: "center" },
	              onDoubleClick: function onDoubleClick() {
	                _this24.openZBLModal(value, dependentValues);
	              }
	            },
	            value
	          );
	        },
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: "FBACode",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_code' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "FBARoute",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_route' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "TrailerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trailer' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "POList",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_list' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "POD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pod' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editor: _react2.default.createElement(DropDownEditor, { options: boolOptions }),
	        formatter: function formatter(_ref9) {
	          var value = _ref9.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value === true || value === 'true' ? "true" : "false"
	          );
	        }
	      }, {
	        key: "DimUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dim_unit' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "WeightUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight_unit' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "BoxLength",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_L' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxWidth",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_W' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxHeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_H' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "BoxWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "PalletLength",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_L' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletWidth",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_W' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletHeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_H' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "UnitLength",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_L' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "UnitWidth",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_w' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "UnitHeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_h' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "UnitVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "PalletStackable",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'stackable' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editor: _react2.default.createElement(DropDownEditor, { options: boolOptions }),
	        formatter: function formatter(_ref10) {
	          var value = _ref10.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value === true || value === 'true' ? "true" : "false"
	          );
	        }
	      }, {
	        key: "StoreReady",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'store_ready' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editor: _react2.default.createElement(DropDownEditor, { options: boolOptions }),
	        formatter: function formatter(_ref11) {
	          var value = _ref11.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value === true || value === 'true' ? "true" : "false"
	          );
	        }
	      }, {
	        key: "Preticketed",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'preticketed' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 120,
	        editor: _react2.default.createElement(DropDownEditor, { options: boolOptions }),
	        formatter: function formatter(_ref12) {
	          var value = _ref12.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value === true || value === 'true' ? "true" : "false"
	          );
	        }
	      }, {
	        key: "CantonNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'canton' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "OriginCountry",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'country' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "VendorStyleNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_style' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: "TJXStyleNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tjx_style' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: "UPC",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'upc' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: "Color",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'color' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: "Size",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'size_ratio' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: "PalletWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: isHMM && !(0, _permissions2.default)('hmm_so_change_unit_price') ? false : true,
	        formatter: _boldCashFormatter2.default
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true,
	        formatter: _boldCashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: 'cost',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: PriceFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice;
	        }
	      }] : []), [{
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }]);
	
	      var kdwColumn = this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id' ? [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'Index',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	        width: 35,
	        resizable: false,
	        sortable: true
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'PalletQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'AvailableQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'available_box' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'RefNum',
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	        resizable: true,
	        sortable: true,
	        width: 120
	      }, {
	        key: 'InnerLabelQty',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inner_label' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'OuterLabelQty',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'outer_label' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: "FBACode",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'FBA-Code' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "FBARoute",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'FBA-Route' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "ShipmentID",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipment_id' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "ServiceType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'service_type' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "ISANum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'isa_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "CustomerRef",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_ref#' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "Unloader",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unloader' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "TruckVendor",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'truck_vendor' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "TrailerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trailer' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "POList",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_list' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "POD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pod' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editor: _react2.default.createElement(DropDownEditor, { options: boolOptions }),
	        formatter: function formatter(_ref13) {
	          var value = _ref13.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value === true || value === 'true' ? "true" : "false"
	          );
	        }
	      }, {
	        key: "DimUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dim_unit' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "WeightUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight_unit' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "BoxLength",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_L' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxWidth",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_W' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxHeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_H' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "BoxWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "PalletLength",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_L' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletWidth",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_W' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletHeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_H' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "PalletWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: isHMM && !(0, _permissions2.default)('hmm_so_change_unit_price') ? false : true,
	        formatter: _boldCashFormatter2.default
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true,
	        formatter: _boldCashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: 'cost',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: PriceFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice;
	        }
	      }] : []), [{
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'Remark',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }]) : [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'Index',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	        width: 35,
	        resizable: false,
	        sortable: true
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'RefNum',
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	        resizable: true,
	        sortable: true,
	        width: 120
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'PalletQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: "ReceivedQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'received_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "Location",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        formatter: function formatter(_ref14) {
	          var value = _ref14.value,
	              dependentValues = _ref14.dependentValues;
	          return _react2.default.createElement(
	            'div',
	            {
	              style: { width: "100%", height: "100%", textAlign: "center" },
	              onDoubleClick: function onDoubleClick() {
	                _this24.openZBLModal(value, dependentValues);
	              }
	            },
	            value
	          );
	        },
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: "FBACode",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_code' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "FBARoute",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_route' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: 'ShipmentID',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipment_id' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: 'ServiceType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'service_type' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: 'ISANum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'isa_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "CustomerRef",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_ref#' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "Unloader",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unloader' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "TruckVendor",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'truck_vendor' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "TrailerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trailer' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "POList",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_list' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "POD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pod' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editor: _react2.default.createElement(DropDownEditor, { options: boolOptions }),
	        formatter: function formatter(_ref15) {
	          var value = _ref15.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value === true || value === 'true' ? "true" : "false"
	          );
	        }
	      }, {
	        key: "DimUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dim_unit' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "WeightUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight_unit' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "BoxLength",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_L' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxWidth",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_W' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxHeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_H' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "BoxWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "PalletLength",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_L' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletWidth",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_W' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletHeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_H' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "PalletWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: isHMM && !(0, _permissions2.default)('hmm_so_change_unit_price') ? false : true,
	        formatter: _boldCashFormatter2.default
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true,
	        formatter: _boldCashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: 'cost',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: PriceFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice;
	        }
	      }] : []), [{
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'Remark',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }]);
	
	      var yiColumn = this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id' ? [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'Index',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	        width: 35,
	        resizable: false,
	        sortable: true
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'PalletQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'AvailableQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'available_box' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'RefNum',
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	        resizable: true,
	        sortable: true,
	        width: 120
	      }, {
	        key: 'InnerLabelQty',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inner_label' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'OuterLabelQty',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'outer_label' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: "FBACode",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'FBA-Code' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "FBARoute",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'FBA-Route' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "TrailerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trailer' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "POList",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_list' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "POD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pod' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editor: _react2.default.createElement(DropDownEditor, { options: boolOptions }),
	        formatter: function formatter(_ref16) {
	          var value = _ref16.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value === true || value === 'true' ? "true" : "false"
	          );
	        }
	      }, {
	        key: "TotalShippingWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_ship_wt' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "NMFCClass",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'nmfc' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "BoxLength",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_L' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxWidth",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_W' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxHeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_H' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "BoxWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "PalletLength",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_L' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletWidth",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_W' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletHeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_H' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "PalletWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        // editable: this.state.editSOPermission,
	        editable: isHMM && !(0, _permissions2.default)('hmm_so_change_unit_price') ? false : true,
	        formatter: _boldCashFormatter2.default
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true,
	        formatter: _boldCashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: 'cost',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: PriceFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice;
	        }
	      }] : []), [{
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'Remark',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }]) : [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'Index',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	        width: 35,
	        resizable: false,
	        sortable: true
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'RefNum',
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	        resizable: true,
	        sortable: true,
	        width: 120
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'PalletQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: "ReceivedQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'received_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "FBACode",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_code' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "FBARoute",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_route' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "TrailerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trailer' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "POList",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_list' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "POD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pod' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editor: _react2.default.createElement(DropDownEditor, { options: boolOptions }),
	        formatter: function formatter(_ref17) {
	          var value = _ref17.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value === true || value === 'true' ? "true" : "false"
	          );
	        }
	      }, {
	        key: "TotalShippingWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_ship_wt' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "NMFCClass",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'nmfc' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "BoxLength",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_L' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxWidth",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_W' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxHeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_H' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "BoxWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "PalletLength",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_L' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletWidth",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_W' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletHeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_H' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "PalletWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: isHMM && !(0, _permissions2.default)('hmm_so_change_unit_price') ? false : true,
	        formatter: _boldCashFormatter2.default
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true,
	        formatter: _boldCashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: 'cost',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: PriceFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice;
	        }
	      }] : []), [{
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'Remark',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }]);
	
	      var dsqColumn = this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id' ? [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'Index',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	        width: 35,
	        resizable: false,
	        sortable: true
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'PalletQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'AvailableQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'available_box' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'RefNum',
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	        resizable: true,
	        sortable: true,
	        width: 120
	      }, {
	        key: 'InnerLabelQty',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inner_label' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'OuterLabelQty',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'outer_label' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: "FBACode",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'FBA-Code' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "FBARoute",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'FBA-Route' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "TrailerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trailer' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "POList",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_list' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "POD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pod' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editor: _react2.default.createElement(DropDownEditor, { options: boolOptions }),
	        formatter: function formatter(_ref18) {
	          var value = _ref18.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value === true || value === 'true' ? "true" : "false"
	          );
	        }
	      }, {
	        key: "DimUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dim_unit' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "WeightUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight_unit' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "BoxLength",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_L' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxWidth",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_W' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxHeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_H' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "BoxWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "PalletLength",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_L' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletWidth",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_W' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletHeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_H' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "PalletWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: isHMM && !(0, _permissions2.default)('hmm_so_change_unit_price') ? false : true,
	        formatter: _boldCashFormatter2.default
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true,
	        formatter: _boldCashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: 'cost',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: PriceFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice;
	        }
	      }] : []), [{
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'Remark',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }]) : [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'Index',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	        width: 35,
	        resizable: false,
	        sortable: true
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'RefNum',
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	        resizable: true,
	        sortable: true,
	        width: 120
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'PalletQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: "ReceivedQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'received_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "FBACode",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_code' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "FBARoute",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_route' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "TrailerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trailer' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "POList",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_list' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "POD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pod' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editor: _react2.default.createElement(DropDownEditor, { options: boolOptions }),
	        formatter: function formatter(_ref19) {
	          var value = _ref19.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value === true || value === 'true' ? "true" : "false"
	          );
	        }
	      }, {
	        key: "DimUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dim_unit' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "WeightUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight_unit' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "BoxLength",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_L' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxWidth",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_W' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxHeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_H' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "BoxWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "PalletLength",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_L' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletWidth",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_W' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletHeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_H' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "PalletVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "PalletWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: isHMM && !(0, _permissions2.default)('hmm_so_change_unit_price') ? false : true,
	        formatter: _boldCashFormatter2.default
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true,
	        formatter: _boldCashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: 'cost',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: PriceFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice;
	        }
	      }] : []), [{
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'Remark',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }]);
	
	      var wizColumn = this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id' ? [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'Index',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	        width: 35,
	        resizable: false,
	        sortable: true
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'AvailableQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'available' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	        resizable: true,
	        sortable: true,
	        width: 120
	      }, {
	        key: "FBACode",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'FBA' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        editable: true
	      }, {
	        key: "CustomerBoxQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_box' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "OutsideLabelQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'outside_label' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "InsideLabelQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inside_label' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "SpecialHandling",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'special_handling' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "CustomerNote",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_note' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 150,
	        editable: true
	      }, {
	        key: "ReceivedQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "ShipmentID",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipment_id' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "BillablePallets",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'billable_pallets' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'real_pallets' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "BoxPerPallet",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_per_plt' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "DispatchType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch_type' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "BoxLength",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_L' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxWidth",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_W' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxHeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_H' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_vol' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "BoxWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "PalletWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "PortDray",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port_dray' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "Location",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        // editable: true,
	        formatter: function formatter(_ref20) {
	          var value = _ref20.value,
	              dependentValues = _ref20.dependentValues;
	          return _react2.default.createElement(
	            'div',
	            {
	              style: { width: "100%", height: "100%", textAlign: "center" },
	              onDoubleClick: function onDoubleClick() {
	                _this24.openZBLModal(value, dependentValues);
	              }
	            },
	            value
	          );
	        },
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: isHMM && !(0, _permissions2.default)('hmm_so_change_unit_price') ? false : true,
	        formatter: _boldCashFormatter2.default
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true,
	        formatter: _boldCashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: 'cost',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: PriceFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice;
	        }
	      }] : []), [{
	        key: 'NetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true
	      }, {
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'TotalNetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'Remark',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }]) : [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'Index',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	        width: 35,
	        resizable: false,
	        sortable: true
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rcvd_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "Location",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	        resizable: true,
	        sortable: true,
	        width: 120
	      }, {
	        key: "ReceivedQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "ShipmentID",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_note' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "BillablePallets",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'billable_pallets' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'real_pallets' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "BoxPerPallet",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_per_plt' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "DispatchType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_note' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "BoxLength",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_L' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxWidth",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_W' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxHeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_H' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80,
	        editable: true
	      }, {
	        key: "BoxVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_vol' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "BoxWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "PalletWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "PortDray",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port_dray' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "DrayageTrucker",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'drayage_trucker' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: isHMM && !(0, _permissions2.default)('hmm_so_change_unit_price') ? false : true,
	        formatter: _boldCashFormatter2.default
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true,
	        formatter: _boldCashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: 'cost',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: PriceFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice;
	        }
	      }] : []), [{
	        key: 'NetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true
	      }, {
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'TotalNetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'Remark',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }]);
	
	      var jtbColumn = this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id' ? [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }].concat(_toConsumableArray(isHMM ? [{
	        key: 'Order',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'positionIndex' }),
	        resizable: true,
	        sortable: true,
	        editable: true,
	        width: 70,
	        filterable: true
	      }] : [{
	        key: 'Index',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	        width: 35,
	        resizable: false,
	        sortable: true
	      }]), [{
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'AvailableQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'available' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }], _toConsumableArray(isABC ? [{
	        key: 'RefNo',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'FBA_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PoNo',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pro_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }] : []), [{
	        key: 'RefNum',
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: isJML ? 200 : 70,
	        filterable: true
	      }], _toConsumableArray(isAFM ? [{
	        key: 'Brand',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'brand' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }] : []), [{
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	        resizable: true,
	        sortable: true,
	        width: isChinaTown ? 200 : 85
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: isHMM && !(0, _permissions2.default)('hmm_so_change_unit_price') ? false : true,
	        formatter: _boldCashFormatter2.default
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true,
	        formatter: _boldCashFormatter2.default
	      }], _toConsumableArray(showProductCost() ? [{
	        key: 'cost',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: PriceFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice;
	        }
	      }] : []), [{
	        key: 'TotalNetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'Remark',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }]) : [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }].concat(_toConsumableArray(isHMM ? [{
	        key: 'Order',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'positionIndex' }),
	        resizable: true,
	        sortable: true,
	        editable: true,
	        width: 70,
	        filterable: true
	      }] : [{
	        key: 'Index',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	        width: 35,
	        resizable: false,
	        sortable: true
	      }]), [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }], _toConsumableArray(isABC ? [{
	        key: 'RefNo',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'FBA_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PoNo',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pro_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }] : []), [{
	        key: 'RefNum',
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: isJML ? 200 : 70,
	        filterable: true
	      }], _toConsumableArray(isAFM ? [{
	        key: 'Brand',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'brand' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }] : []), [{
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	        resizable: true,
	        sortable: true,
	        width: isChinaTown ? 200 : 85
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: isHMM && !(0, _permissions2.default)('hmm_so_change_unit_price') ? false : true,
	        formatter: _boldCashFormatter2.default
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true,
	        formatter: _boldCashFormatter2.default
	      }], _toConsumableArray(showProductCost() ? [{
	        key: 'cost',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: PriceFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice;
	        }
	      }] : []), [{
	        key: 'NetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true
	      }, {
	        key: 'TotalNetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'Remark',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }]);
	
	      var fjColumn = this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id' ? [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: 'Index',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	        width: 35,
	        resizable: false,
	        sortable: true
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'AvailableQuantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'available' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }].concat(_toConsumableArray(isABC ? [{
	        key: 'RefNo',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'FBA_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PoNo',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pro_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }] : []), [{
	        key: 'RefNum',
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: isJML ? 200 : 70,
	        filterable: true
	      }], _toConsumableArray(isAFM ? [{
	        key: 'Brand',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'brand' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }] : []), [{
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	        resizable: true,
	        sortable: true,
	        width: isChinaTown ? 200 : 85
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: isHMM && !(0, _permissions2.default)('hmm_so_change_unit_price') ? false : true,
	        formatter: _boldCashFormatter2.default
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true,
	        formatter: _boldCashFormatter2.default
	      }], _toConsumableArray(showProductCost() ? [{
	        key: 'cost',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: PriceFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice;
	        }
	      }] : []), [{
	        key: 'NetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true
	      }, {
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'TotalNetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'Remark',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }]) : [{
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'del' }),
	        width: 50,
	        formatter: IsVariableFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }].concat(_toConsumableArray(isHMM ? [{
	        key: 'Order',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'positionIndex' }),
	        resizable: true,
	        sortable: true,
	        editable: true,
	        width: 70,
	        filterable: true
	      }] : [{
	        key: 'Index',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'idx' }),
	        width: 35,
	        resizable: false,
	        sortable: true
	      }]), [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }], _toConsumableArray(isABC ? [{
	        key: 'RefNo',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'FBA_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PoNo',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pro_num' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }] : []), [{
	        key: 'RefNum',
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: isJML ? 200 : 70,
	        filterable: true
	      }], _toConsumableArray(isAFM ? [{
	        key: 'Brand',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'brand' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }] : []), [{
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	        resizable: true,
	        sortable: true,
	        width: isChinaTown ? 200 : 85
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true,
	        editable: true,
	        formatter: _boldTextFormatter2.default
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        editable: isHMM && !(0, _permissions2.default)('hmm_so_change_unit_price') ? false : true,
	        formatter: _boldCashFormatter2.default
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true,
	        formatter: _boldCashFormatter2.default
	      }], _toConsumableArray(showProductCost() ? [{
	        key: 'cost',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: PriceFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice;
	        }
	      }] : []), [{
	        key: 'NetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true
	      }, {
	        key: 'PackageType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'TotalNetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'Remark',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        editable: true
	      }]);
	
	      var generateColumns = function generateColumns() {
	        if (isDSQ || _root_url.isWUFS || isFBD) {
	          return dsqColumn;
	        }
	        if (isYI) {
	          return yiColumn;
	        }
	        if (isKDW) {
	          return kdwColumn;
	        }
	        if (isABCFF) {
	          return abcffColumn;
	        }
	        if (isWIZ) {
	          return wizColumn;
	        }
	        if (isJTB) {
	          return jtbColumn;
	        }
	        if (isFJ) {
	          return fjColumn;
	        }
	        return columns;
	      };
	
	      // Your Sales Order Table
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _root_url.isEcity && _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { className: 'react-customizer', id: 'SalesOrderForm-dataGrid3' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'ProductNum',
	              enableCellSelect: true,
	              onGridSort: handleGridSort
	              // columns={columns}
	              , columns: generateColumns(),
	              rowHeight: isWIZ ? 40 : 25,
	              headerRowHeight: 45,
	              minHeight: this.state.yourOrderTableHeight,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              onRowClick: onRowClick,
	              onRowUpdated: handleRowUpdated,
	              enableRowSelect: 'single',
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              }
	            })
	          )
	        ),
	        !isChinaTown && !isFJ && !_root_url.isEcity && _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          isABCFF && this.context.router.routes[1].path === 'salesOrders/:id' && _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            { style: { float: 'right' } },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                onClick: autoLoad
	              },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'auto_load' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'react-customizer', id: 'SalesOrderForm-dataGrid3' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'ProductNum',
	              enableCellSelect: true,
	              onGridSort: handleGridSort
	              // columns={columns}
	              , columns: generateColumns(),
	              rowHeight: isWIZ || isABCFF ? 40 : 25,
	              headerRowHeight: 45,
	              minHeight: this.state.yourOrderTableHeight,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              onRowClick: onRowClick,
	              onRowUpdated: handleRowUpdated
	            })
	          )
	        ),
	        isChinaTown && _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { className: 'react-customizer', id: 'SalesOrderForm-dataGrid3China' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'ProductNum',
	              enableCellSelect: true,
	              onGridSort: handleGridSort,
	              columns: columns,
	              rowHeight: 40,
	              headerRowHeight: 45,
	              minHeight: this.state.yourOrderTableHeight,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              onRowClick: onRowClick,
	              onRowUpdated: handleRowUpdated
	            })
	          )
	        ),
	        isFJ && _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { className: 'react-customizer', id: 'SalesOrderForm-dataGrid3' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'ProductNum',
	              enableCellSelect: true,
	              onGridSort: handleGridSort
	              // columns={columns}
	              , columns: generateColumns(),
	              rowHeight: 25,
	              headerRowHeight: 45,
	              minHeight: 150,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              onRowClick: onRowClick,
	              onRowUpdated: handleRowUpdated
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'moveFavoritesToSO',
	    value: function moveFavoritesToSO() {
	      var _this26 = this;
	
	      var _props3 = this.props,
	          inventories = _props3.inventories,
	          inventoryIdValue = _props3.inventoryIdValue,
	          quantityValue = _props3.quantityValue,
	          favorites = _props3.favorites,
	          available = _props3.available,
	          inPurchase = _props3.inPurchase,
	          preSale = _props3.preSale,
	          salePrice = _props3.salePrice,
	          refPurchasePrice = _props3.refPurchasePrice,
	          unitPrice = _props3.unitPrice,
	          description = _props3.description;
	
	      var updatedInventories = [].concat(_toConsumableArray(this.state.inventories.allRows));
	      var updatedFavorites = JSON.parse(JSON.stringify(this.state.favorites.rows));
	      var rowsToAdd = JSON.parse(JSON.stringify(this.state.favorites.rows));
	      var newRows = JSON.parse(JSON.stringify(this.state.rows));
	      rowsToAdd.map(function (row) {
	        if (row.isSelected) {
	          var check = _lodash2.default.findIndex(_this26.state.rows, { ProductNum: row.ProductNum });
	          if (check == -1) {
	            var index = _lodash2.default.findIndex(updatedInventories, { ProductNum: row.ProductNum });
	            if (index > -1) {
	              if (updatedInventories[index].InStock > 0 || selectedInventory.IsOverSaleable == true) {
	                updatedInventories[index].inList = true;
	              }
	            }
	            index = _lodash2.default.findIndex(updatedFavorites, { ProductNum: row.ProductNum });
	            if (index > -1) {
	              if (updatedFavorites[index].InStock > 0 || updatedFavorites[index].IsOverSaleable == true) {
	                updatedFavorites[index].inList = true;
	              }
	            }
	            if (row.InStock > 0 || row.IsOverSaleable == true || isHMM) {
	              row.Quantity = 0;
	              row.UnitPrice = row.RefPurchasingPrice;
	              row.TotalPrice = 0;
	              row.isSelected = false;
	              row.TotalNetWeight = 0;
	              row.Name = row.ProductName;
	              var pos = _lodash2.default.findIndex(_this26.state.inventories.allRows, { Product_id: row.Product_id });
	              if (pos > -1) {
	                row.Weight = _this26.state.inventories.allRows[pos].Weight;
	              }
	              newRows.push(row);
	              var _favorites = _extends({}, _this26.state.favorites, { rows: updatedFavorites });
	              var _inventories3 = _extends({}, _this26.state.inventories, { allRows: updatedInventories });
	              _this26.setState({ inventories: _inventories3, favorites: _favorites, rows: newRows });
	            } else {
	              _this26.setState({ case: 'itemOutOfStock', confirmOpen: true });
	            }
	          } else {
	            _this26.setState({ case: 'addingDuplicate', confirmOpen: true });
	          }
	        }
	      });
	    }
	  }, {
	    key: 'barcodeScan',
	    value: function barcodeScan() {
	      var _this27 = this;
	
	      var selectedInventoryRow = _extends({}, this.state.selectedInventoryRow);
	      var check = _lodash2.default.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
	      if (check === -1) {
	        // add product by scaning barcode
	        this.moveToSO();
	      } else {
	        // update existing product
	        var rows = [].concat(_toConsumableArray(this.state.rows));
	        rows.map(function (row) {
	          if (row.ProductNum === selectedInventoryRow.ProductNum) {
	            var addQty = +row.Quantity + 1;
	            // more than product in stock
	            if (addQty <= row.InStock || row.IsOverSaleable === true || isHMM) {
	              row.Quantity = addQty;
	              row.TotalNetWeight = (0, _NumberUtil.roundTo)(row.NetWeight * row.Quantity, 2);
	              if (row.ProductType === 'Fixed') {
	                row.TotalPrice = +(0, _NumberUtil.roundToDecimals)(row.UnitPrice * row.Quantity, 4).toFixed(4);
	              } else {
	                // row.TotalPrice = +roundToDecimals(row.unitPrice * weight * row.Quantity, 4).toFixed(4);
	                row.TotalPrice = +(0, _NumberUtil.roundToDecimals)(row.UnitPrice * row.Quantity, 4).toFixed(4);
	              }
	              row.TotalCRV = +(0, _NumberUtil.roundTo)(parseFloat(row.Quantity) * parseFloat(row.CRV), 2).toFixed(2);
	              row.TotalNetWeight = (0, _NumberUtil.roundTo)(row.NetWeight * row.Quantity, 2);
	            } else {
	              _this27.setState({
	                case: 'itemOutOfStock',
	                confirmOpen: true,
	                selectedInventoryRow: {},
	                inStock: '',
	                purchased: '',
	                presale: '',
	                net_weight: '',
	                suggestValue: ''
	              });
	              _this27.props.resetFormInputs();
	              return;
	            }
	          }
	        });
	        this.setState({ rows: rows });
	
	        // update so detail
	        var totalPrice = 0;
	        var finalWeight = 0;
	        var totalTax = 0;
	        var totalTaxOriginal = 0;
	        var totalCRV = 0;
	        var index = 0;
	        var discount = parseFloat(this.props.discount) || 0;
	        rows = [].concat(_toConsumableArray(this.state.rows));
	        index = rows.length;
	        rows.map(function (row) {
	          row.Index = index;
	          index--;
	          totalCRV = (parseFloat(row.TotalCRV) || 0) + +(0, _NumberUtil.roundTo)(parseFloat(totalCRV), 2).toFixed(2);
	          if (row.IsTaxable === true) {
	            if (isHMM) {
	              totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(_this27.state.taxValue / 100);
	            } else {
	              if (isAN || _root_url.isElegant) {
	                var taxable = !_this27.props.salesCustomerDetails.Reseller;
	                if (taxable) {
	                  taxable = row.IsAllTaxable === true || !_this27.props.salesCustomerDetails.Reseller;
	                }
	                if (taxable) {
	                  totalTax += parseFloat(row.TotalPrice) * parseFloat(_this27.state.taxValue / 100);
	                }
	              } else {
	                totalTax += parseFloat(row.TotalPrice) * parseFloat(_this27.state.taxValue / 100);
	              }
	            }
	          }
	          if (isHMM) {
	            totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
	          } else {
	            totalPrice += parseFloat(row.TotalPrice);
	          }
	          if (row.TotalNetWeight != null) {
	            finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight);
	          }
	          finalWeight = Math.round(0.00001 + finalWeight * 100) / 100;
	        });
	        totalTaxOriginal = totalTax = +(0, _NumberUtil.roundTo)(totalTax, 2).toFixed(2);
	        if (_root_url.isElegant) {
	          discount = parseFloat(this.state.SODiscount) || parseFloat(this.state.SOSavings) / totalPrice * 100 || 0;
	          totalTax = +(0, _NumberUtil.roundTo)((1 - discount / 100) * totalTax, 2).toFixed(2);
	        }
	        finalWeight = Math.round(0.00001 + finalWeight * 100) / 100;
	        totalPrice = +(0, _NumberUtil.roundToDecimals)(totalPrice, 4).toFixed(4);
	        totalCRV = +(0, _NumberUtil.roundTo)(totalCRV, 2).toFixed(2);
	        var finalPrice = +(0, _NumberUtil.roundTo)(totalPrice * (1 - discount / 100) + totalTax + totalCRV, 2).toFixed(2);
	        // finalPrice = Math.round(0.00001 + finalPrice * 100) / 100;
	
	        this.setState({
	          rows: rows,
	          editing: true,
	          finalPrice: finalPrice,
	          totalPrice: totalPrice,
	          totalTax: totalTax,
	          totalTaxOriginal: totalTaxOriginal,
	          totalCRV: totalCRV,
	          finalWeight: finalWeight,
	          selectedInventoryRow: {},
	          inStock: '',
	          purchased: '',
	          presale: '',
	          net_weight: '',
	          ship_weight: '',
	          total_weight: '',
	          suggestValue: ''
	        });
	        this.props.resetFormInputs();
	        this.setAllProductQuantity(1);
	      }
	    }
	  }, {
	    key: 'checkMoveToSo',
	    value: function checkMoveToSo() {
	      var selectedInventoryRow = _extends({}, this.state.selectedInventoryRow);
	      var check = _lodash2.default.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
	      if (check === -1 || isTN) {
	        this.moveToSO();
	      } else {
	        var unitPrice = this.props.unitPrice;
	
	        var _selectedInventoryRow = _extends({}, this.state.selectedInventoryRow);
	        if (isOCM && unitPrice < _selectedInventoryRow.LowestSalePrice) {
	          this.setState({ case: 'belowLowestSalePriceAndDuplicate', confirmOpen: true });
	        } else {
	          this.setState({ case: 'addingDuplicate', confirmOpen: true });
	        }
	      }
	    }
	  }, {
	    key: 'moveToSO',
	    value: function moveToSO() {
	      var _this28 = this;
	
	      if (_root_url.isEcity && this.state.case === 'addingDuplicate') {
	        this.findDuplicate();
	      } else {
	        var eCityItemPriceTrick = function eCityItemPriceTrick(row) {
	          var priceDisplay = 0;
	          switch (_this28.state.customerPriceLevel) {
	            case 1:
	              priceDisplay = row.RefPrice;
	              break;
	            case 2:
	              priceDisplay = row.PriceLv1;
	              break;
	            case 3:
	              priceDisplay = row.PriceLv2;
	              break;
	            default:
	              priceDisplay = row.PriceLv1;
	              break;
	          }
	          return priceDisplay;
	        };
	        if (this.state.selectedInventoryRow.Product_id == null) {
	          this.setState({ case: 'chooseProduct', confirmOpen: true });
	          return;
	        }
	        var _props4 = this.props,
	            inventories = _props4.inventories,
	            inventoryIdValue = _props4.inventoryIdValue,
	            quantityValue = _props4.quantityValue,
	            favorites = _props4.favorites,
	            weight = _props4.weight,
	            available = _props4.available,
	            inPurchase = _props4.inPurchase,
	            preSale = _props4.preSale,
	            salePrice = _props4.salePrice,
	            refPurchasePrice = _props4.refPurchasePrice,
	            unitPrice = _props4.unitPrice,
	            description = _props4.description,
	            notation = _props4.notation,
	            itemNotation = _props4.itemNotation;
	
	        var selectedInventoryRow = _extends({}, this.state.selectedInventoryRow);
	
	        if (!isJTB && unitPrice < selectedInventoryRow.LowestSalePrice && arguments[0] !== 'move') {
	          this.setState({ case: 'belowLowestSalePrice', confirmOpen: true });
	          return;
	        }
	        if (isHMM && unitPrice < selectedInventoryRow.LowestSalePrice && arguments[0] === 'move' && !arguments[1]) {
	          this.openVerifyPasscode();
	          return;
	        }
	        // if(isEcity && !this.props.salesCustomerDetails.GoodCredit && !this.state.customerVerified) {
	        //   if(!arguments[2]) {
	        //     this.openVerifyPasscodeToCreaterSO();
	        //     return
	        //   }
	        // }
	        var totalPrice = 0;
	        var finalWeight = 0;
	        var totalTax = 0;
	        var totalTaxOriginal = 0;
	        var totalCRV = 0;
	        var index = 0;
	        var discount = parseFloat(this.props.discount) || 0;
	        // const check = _.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
	        if (quantityValue === undefined) {
	          quantityValue = 0;
	        }
	        // if (check == -1) {
	        if (selectedInventoryRow.InStock - (isHMM ? 0 : selectedInventoryRow.PreSale) > 0 && quantityValue <= selectedInventoryRow.InStock - (isHMM ? 0 : selectedInventoryRow.PreSale) || selectedInventoryRow.IsOverSaleable === true || isHMM || isAFG) {
	          selectedInventoryRow.Quantity = quantityValue;
	          selectedInventoryRow.UnitPrice = this.props.unitPrice;
	          selectedInventoryRow.TotalNetWeight = (0, _NumberUtil.roundTo)(selectedInventoryRow.NetWeight * selectedInventoryRow.Quantity, 2);
	          if (selectedInventoryRow.ProductType === 'Fixed') {
	            selectedInventoryRow.TotalPrice = +(0, _NumberUtil.roundToDecimals)(this.props.unitPrice * quantityValue, 4).toFixed(4);
	          } else {
	            selectedInventoryRow.TotalPrice = +(0, _NumberUtil.roundToDecimals)(this.props.unitPrice * weight * quantityValue, 4).toFixed(4);
	          }
	          // if (isJML && selectedInventoryRow.ProductType === 'Non-Fixed') {
	          //   selectedInventoryRow.TotalPrice = +roundToDecimals(this.props.unitPrice * this.props.PackageSize_1 * quantityValue, 4).toFixed(4);
	          // }
	          selectedInventoryRow.TotalCRV = +(0, _NumberUtil.roundTo)(parseFloat(selectedInventoryRow.Quantity) * parseFloat(selectedInventoryRow.CRV), 2).toFixed(2);
	          selectedInventoryRow.TotalNetWeight = (0, _NumberUtil.roundTo)(selectedInventoryRow.NetWeight * selectedInventoryRow.Quantity, 2);
	          selectedInventoryRow.Weight = this.props.weight;
	          selectedInventoryRow.Remark = itemNotation;
	          // if (isWIZ) {
	          if (this.props) {
	            selectedInventoryRow.ReceivedQuantity = this.props.ReceivedQuantity;
	            selectedInventoryRow.ShipmentID = this.props.ShipmentID;
	            selectedInventoryRow.BillablePallets = this.props.BillablePallets;
	            selectedInventoryRow.RealPallets = this.props.RealPallets;
	            selectedInventoryRow.BoxPerPallet = this.props.BoxPerPallet;
	            selectedInventoryRow.DispatchType = this.props.DispatchType;
	            selectedInventoryRow.BoxVol = this.props.BoxVol;
	            selectedInventoryRow.BoxHeight = this.props.BoxHeight;
	            selectedInventoryRow.BoxWidth = this.props.BoxWidth;
	            selectedInventoryRow.InnerLabelQty = this.props.InnerLabelQty;
	            selectedInventoryRow.OuterLabelQty = this.props.OuterLabelQty;
	            selectedInventoryRow.BoxLength = this.props.BoxLength;
	            selectedInventoryRow.BoxWeight = this.props.BoxWeight;
	            selectedInventoryRow.RepackedPalletQuantity = this.props.RepackedPalletQuantity;
	            selectedInventoryRow.PalletHeight = this.props.PalletHeight;
	            selectedInventoryRow.PalletWidth = this.props.PalletWidth;
	            selectedInventoryRow.PalletLength = this.props.PalletLength;
	            selectedInventoryRow.PalletVol = this.props.PalletVol;
	            selectedInventoryRow.PalletWeight = this.props.PalletWeight;
	
	            selectedInventoryRow.UnitQuantity = this.props.UnitQuantity;
	            selectedInventoryRow.PerBoxQty = this.props.PerBoxQty;
	            selectedInventoryRow.UnitLength = this.props.UnitLength;
	            selectedInventoryRow.UnitWidth = this.props.UnitWidth;
	            selectedInventoryRow.UnitHeight = this.props.UnitHeight;
	            selectedInventoryRow.UnitVol = this.props.UnitVol;
	
	            selectedInventoryRow.IsOversize = this.props.IsOversize;
	            selectedInventoryRow.IsOverweight = this.props.IsOverweight;
	            selectedInventoryRow.PortDray = this.props.PortDray;
	            selectedInventoryRow.DrayageTrucker = this.props.DrayageTrucker;
	            selectedInventoryRow.Location = this.props.Location;
	            selectedInventoryRow.WarehouseLocation = this.props.WarehouseLocation;
	            selectedInventoryRow.FBACode = this.props.FBACode;
	            selectedInventoryRow.PalletQuantity = this.props.PalletQuantity;
	            selectedInventoryRow.BoxQuantity = this.props.BoxQuantity;
	            selectedInventoryRow.PieceQuantity = this.props.PieceQuantity;
	            selectedInventoryRow.TotalShippingWeight = this.props.TotalShippingWeight;
	            selectedInventoryRow.NMFCClass = this.props.NMFCClass;
	            selectedInventoryRow.FBARoute = this.props.FBARoute;
	            selectedInventoryRow.DimUnit = this.props.DimUnit;
	            selectedInventoryRow.ServiceType = this.props.ServiceType;
	            selectedInventoryRow.ISANum = this.props.ISANum;
	            selectedInventoryRow.CustomerRef = this.props.CustomerRef;
	            selectedInventoryRow.Unloader = this.props.Unloader;
	            selectedInventoryRow.TruckVendor = this.props.TruckVendor;
	
	            // selectedInventoryRow.VendorStyleNum = this.props.VendorStyleNum;
	            // selectedInventoryRow.TJXStyleNum = this.props.TJXStyleNum;
	            // selectedInventoryRow.LineDescription = this.props.LineDescription;
	            // selectedInventoryRow.UPC = this.props.UPC;
	            // selectedInventoryRow.Color = this.props.Color;
	            // selectedInventoryRow.Size = this.props.Size;
	            // selectedInventoryRow.TotalUnits = this.props.TotalUnits;
	            selectedInventoryRow.StoreReady = this.props.StoreReady;
	            selectedInventoryRow.PalletStackable = this.props.PalletStackable;
	            selectedInventoryRow.Preticketed = this.props.Preticketed;
	            selectedInventoryRow.CantonNum = this.props.CantonNum;
	            selectedInventoryRow.OriginCountry = this.props.OriginCountry;
	
	            selectedInventoryRow.PackageSize_1 = this.props.PackageSize_1;
	            selectedInventoryRow.jmlBox = this.props.jmlBox;
	            selectedInventoryRow.jmlPackageSize1 = this.props.PackageSize_1;
	
	            selectedInventoryRow.CustomerBoxQty = this.props.CustomerBoxQty;
	            selectedInventoryRow.OutsideLabelQty = this.props.OutsideLabelQty;
	            selectedInventoryRow.InsideLabelQty = this.props.InsideLabelQty;
	            selectedInventoryRow.SpecialHandling = this.props.SpecialHandling;
	            selectedInventoryRow.CustomerNote = this.props.CustomerNote;
	
	            selectedInventoryRow.WeightUnit = this.props.WeightUnit;
	            selectedInventoryRow.TrailerNum = this.props.TrailerNum;
	            selectedInventoryRow.POList = this.props.POList;
	            selectedInventoryRow.POD = this.props.POD;
	            if (isOCM) {
	              selectedInventoryRow.Batch_id = this.state.Batch_id;
	              selectedInventoryRow.BatchExpiredDate = this.state.BatchExpiredDate;
	            }
	            if (isTN) {
	              selectedInventoryRow.Batch_id = this.state.Batch_id;
	              selectedInventoryRow.pallet_barcode = this.state.pallet_barcode;
	            }
	          }
	          // }
	          if (_root_url.isEcity) selectedInventoryRow.ProductCost = eCityItemPriceTrick(selectedInventoryRow);
	        } else {
	          this.setState({
	            case: 'itemOutOfStock',
	            confirmOpen: true,
	            selectedInventoryRow: {},
	            inStock: '',
	            purchased: '',
	            presale: '',
	            net_weight: '',
	            suggestValue: ''
	          });
	          this.props.resetFormInputs();
	          return;
	        }
	        var rows = [].concat(_toConsumableArray(this.state.rows));
	        if (isHMM) {
	          var maxPosition = 0;
	          rows.forEach(function (row) {
	            if (row.Order > maxPosition) {
	              maxPosition = row.Order;
	            }
	          });
	          rows.push(_extends({}, selectedInventoryRow, { Order: maxPosition + 1 }));
	        } else {
	          rows.unshift(selectedInventoryRow);
	        }
	        // rows.unshift(selectedInventoryRow);
	        index = rows.length;
	        rows.map(function (row) {
	          row.Index = index;
	          index--;
	          totalCRV = (parseFloat(row.TotalCRV) || 0) + +(0, _NumberUtil.roundTo)(parseFloat(totalCRV), 2).toFixed(2);
	          if (row.IsTaxable === true) {
	            if (isHMM) {
	              totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(_this28.state.taxValue / 100);
	            } else {
	              if (isAN || _root_url.isElegant) {
	                var taxable = !_this28.props.salesCustomerDetails.Reseller;
	                if (isAN) {
	                  taxable = row.IsAllTaxable === true || !_this28.props.salesCustomerDetails.Reseller;
	                }
	                if (taxable) {
	                  totalTax += parseFloat(row.TotalPrice) * parseFloat(_this28.state.taxValue / 100);
	                }
	              } else {
	                totalTax += parseFloat(row.TotalPrice) * parseFloat(_this28.state.taxValue / 100);
	              }
	            }
	          }
	          if (isHMM) {
	            totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
	          } else {
	            totalPrice += parseFloat(row.TotalPrice);
	          }
	          if (row.TotalNetWeight != null) {
	            finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight);
	          }
	          finalWeight = Math.round(0.00001 + finalWeight * 100) / 100;
	        });
	        totalTaxOriginal = totalTax = +(0, _NumberUtil.roundTo)(totalTax, 2).toFixed(2);
	        if (_root_url.isElegant) {
	          discount = parseFloat(this.state.SODiscount) || parseFloat(this.state.SOSavings) / totalPrice * 100 || 0;
	          totalTax = +(0, _NumberUtil.roundTo)((1 - discount / 100) * totalTax, 2).toFixed(2);
	        }
	        finalWeight = Math.round(0.00001 + finalWeight * 100) / 100;
	        totalPrice = +(0, _NumberUtil.roundToDecimals)(totalPrice, 4).toFixed(4);
	        totalCRV = +(0, _NumberUtil.roundTo)(totalCRV, 2).toFixed(2);
	        var finalPrice = +(0, _NumberUtil.roundTo)(totalPrice * (1 - discount / 100) + totalTax + totalCRV, 2).toFixed(2);
	        // finalPrice = Math.round(0.00001 + finalPrice * 100) / 100;
	        this.setState({
	          rows: rows,
	          editing: true,
	          finalPrice: finalPrice,
	          totalPrice: totalPrice,
	          totalTax: totalTax,
	          totalTaxOriginal: totalTaxOriginal,
	          totalCRV: totalCRV,
	          finalWeight: finalWeight,
	          selectedInventoryRow: {},
	          inStock: '',
	          purchased: '',
	          presale: '',
	          net_weight: '',
	          ship_weight: '',
	          total_weight: '',
	          suggestValue: ''
	        }, function () {
	          _this28.checkForPromotions(selectedInventoryRow.ProductNum);
	        });
	        // }
	        this.props.resetFormInputs();
	        this.setAllProductQuantity(1);
	      }
	    }
	  }, {
	    key: 'checkMoveToSo2',
	    value: function checkMoveToSo2() {
	      var selectedInventoryRow = _extends({}, this.state.selectedInventoryRow);
	
	      var check = _lodash2.default.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
	      if (check === -1 || isTN || isJML) {
	        this.moveToSO2();
	      } else {
	        var unitPrice = this.props.unitPrice;
	
	        var _selectedInventoryRow2 = _extends({}, this.state.selectedInventoryRow);
	        if (isOCM && unitPrice < _selectedInventoryRow2.LowestSalePrice) {
	          this.setState({ case: 'belowLowestSalePriceAndDuplicate', confirmOpen: true });
	        } else {
	          this.setState({ case: 'addingDuplicate', confirmOpen: true });
	        }
	      }
	    }
	  }, {
	    key: 'moveToSO2',
	    value: function moveToSO2() {
	      var _this29 = this;
	
	      if (_root_url.isEcity && this.state.case === 'addingDuplicate') {
	        this.findDuplicate();
	      } else {
	        var eCityItemPriceTrick = function eCityItemPriceTrick(row) {
	          var priceDisplay = 0;
	          switch (_this29.state.customerPriceLevel) {
	            case 1:
	              priceDisplay = row.RefPrice;
	              break;
	            case 2:
	              priceDisplay = row.PriceLv1;
	              break;
	            case 3:
	              priceDisplay = row.PriceLv2;
	              break;
	            default:
	              priceDisplay = row.PriceLv1;
	              break;
	          }
	          return priceDisplay;
	        };
	        if (this.state.selectedInventoryRow.Product_id == null) {
	          this.setState({ case: 'chooseProduct', confirmOpen: true });
	          return;
	        }
	        var _props5 = this.props,
	            inventories = _props5.inventories,
	            inventoryIdValue = _props5.inventoryIdValue,
	            quantityValue = _props5.quantityValue,
	            favorites = _props5.favorites,
	            weight = _props5.weight,
	            available = _props5.available,
	            inPurchase = _props5.inPurchase,
	            preSale = _props5.preSale,
	            salePrice = _props5.salePrice,
	            refPurchasePrice = _props5.refPurchasePrice,
	            unitPrice = _props5.unitPrice,
	            description = _props5.description,
	            notation = _props5.notation,
	            itemNotation = _props5.itemNotation;
	
	        var selectedInventoryRow = _extends({}, this.state.selectedInventoryRow);
	
	        if (!isJTB && unitPrice < selectedInventoryRow.LowestSalePrice && arguments[0] !== 'move') {
	          this.setState({ case: 'belowLowestSalePrice', confirmOpen: true });
	          return;
	        }
	        if (isHMM && unitPrice < selectedInventoryRow.LowestSalePrice && arguments[0] === 'move' && !arguments[1]) {
	          this.openVerifyPasscode();
	          return;
	        }
	
	        // if(isEcity && !this.props.salesCustomerDetails.GoodCredit && !this.state.customerVerified) {
	        //   if(!arguments[2]) {
	        //     this.openVerifyPasscodeToCreaterSO();
	        //     return
	        //   }
	        // }
	        var totalPrice = 0;
	        var finalWeight = 0;
	        var totalTax = 0;
	        var totalTaxOriginal = 0;
	        var totalCRV = 0;
	        var index = 0;
	        var discount = parseFloat(this.props.discount) || 0;
	        // const check = _.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
	        if (quantityValue === undefined) {
	          quantityValue = 0;
	        }
	        // if (check == -1) {
	        if (selectedInventoryRow.InStock - (isHMM ? 0 : selectedInventoryRow.PreSale) > 0 && (this.state.batchQty ? this.state.batchQty : quantityValue) <= selectedInventoryRow.InStock - (isHMM ? 0 : selectedInventoryRow.PreSale) || selectedInventoryRow.IsOverSaleable === true || isHMM || isAFG || isJML) {
	          selectedInventoryRow.Quantity = this.state.batchQty;
	          if (isJML) {
	            selectedInventoryRow.Quantity = this.state.batchQty * this.state.batchPcs;
	            selectedInventoryRow.jmlBox = this.state.batchQty;
	            selectedInventoryRow.jmlPackageSize1 = this.state.batchPcs;
	            selectedInventoryRow.SalesOrderLine_id = '';
	          }
	          // selectedInventoryRow.Quantity = quantityValue;
	          if (isJML && this.props.unitPrice || !isJML) {
	            selectedInventoryRow.UnitPrice = this.props.unitPrice;
	          }
	          if (isTN && this.state.lineQty) {
	            selectedInventoryRow.UnitPrice = this.state.lineQty;
	          }
	          selectedInventoryRow.TotalNetWeight = (0, _NumberUtil.roundTo)(selectedInventoryRow.NetWeight * selectedInventoryRow.Quantity, 2);
	          if (selectedInventoryRow.ProductType === 'Fixed') {
	            selectedInventoryRow.TotalPrice = +(0, _NumberUtil.roundToDecimals)(selectedInventoryRow.UnitPrice * selectedInventoryRow.Quantity, 4).toFixed(4);
	          } else {
	            selectedInventoryRow.TotalPrice = +(0, _NumberUtil.roundToDecimals)(selectedInventoryRow.UnitPrice * (!isJML ? weight : selectedInventoryRow.PackageSize_1) * quantityValue, 4).toFixed(4);
	          }
	          selectedInventoryRow.TotalCRV = +(0, _NumberUtil.roundTo)(parseFloat(selectedInventoryRow.Quantity) * parseFloat(selectedInventoryRow.CRV), 2).toFixed(2);
	          selectedInventoryRow.TotalNetWeight = (0, _NumberUtil.roundTo)(selectedInventoryRow.NetWeight * selectedInventoryRow.Quantity, 2);
	          selectedInventoryRow.Weight = this.props.weight;
	          selectedInventoryRow.Remark = itemNotation;
	          // if (isWIZ) {
	          if (this.props) {
	            selectedInventoryRow.ReceivedQuantity = this.props.ReceivedQuantity;
	            selectedInventoryRow.ShipmentID = this.props.ShipmentID;
	            selectedInventoryRow.ServiceType = this.props.ServiceType;
	            selectedInventoryRow.CustomerRef = this.props.CustomerRef;
	            selectedInventoryRow.Unloader = this.props.Unloader;
	            selectedInventoryRow.TruckVendor = this.props.TruckVendor;
	            selectedInventoryRow.ISANum = this.props.ISANum;
	            selectedInventoryRow.BillablePallets = this.props.BillablePallets;
	            selectedInventoryRow.RealPallets = this.props.RealPallets;
	            selectedInventoryRow.BoxPerPallet = this.props.BoxPerPallet;
	            selectedInventoryRow.DispatchType = this.props.DispatchType;
	            selectedInventoryRow.BoxVol = this.props.BoxVol;
	            selectedInventoryRow.BoxHeight = this.props.BoxHeight;
	            selectedInventoryRow.BoxWidth = this.props.BoxWidth;
	            selectedInventoryRow.InnerLabelQty = this.props.InnerLabelQty;
	            selectedInventoryRow.OuterLabelQty = this.props.OuterLabelQty;
	            selectedInventoryRow.BoxLength = this.props.BoxLength;
	            selectedInventoryRow.BoxWeight = this.props.BoxWeight;
	            selectedInventoryRow.RepackedPalletQuantity = this.props.RepackedPalletQuantity;
	            selectedInventoryRow.PalletHeight = this.props.PalletHeight;
	            selectedInventoryRow.PalletWidth = this.props.PalletWidth;
	            selectedInventoryRow.PalletLength = this.props.PalletLength;
	            selectedInventoryRow.PalletVol = this.props.PalletVol;
	            selectedInventoryRow.PalletWeight = this.props.PalletWeight;
	
	            selectedInventoryRow.UnitQuantity = this.props.UnitQuantity;
	            selectedInventoryRow.PerBoxQty = this.props.PerBoxQty;
	            selectedInventoryRow.UnitLength = this.props.UnitLength;
	            selectedInventoryRow.UnitWidth = this.props.UnitWidth;
	            selectedInventoryRow.UnitHeight = this.props.UnitHeight;
	            selectedInventoryRow.UnitVol = this.props.UnitVol;
	
	            selectedInventoryRow.IsOversize = this.props.IsOversize;
	            selectedInventoryRow.IsOverweight = this.props.IsOverweight;
	            selectedInventoryRow.PortDray = this.props.PortDray;
	            selectedInventoryRow.DrayageTrucker = this.props.DrayageTrucker;
	            selectedInventoryRow.Location = this.props.Location;
	            selectedInventoryRow.WarehouseLocation = this.props.WarehouseLocation;
	            selectedInventoryRow.FBACode = this.props.FBACode;
	            selectedInventoryRow.PalletQuantity = this.props.PalletQuantity;
	            selectedInventoryRow.BoxQuantity = this.props.BoxQuantity;
	            selectedInventoryRow.PieceQuantity = this.props.PieceQuantity;
	            selectedInventoryRow.TotalShippingWeight = this.props.TotalShippingWeight;
	            selectedInventoryRow.NMFCClass = this.props.NMFCClass;
	            selectedInventoryRow.FBARoute = this.props.FBARoute;
	            selectedInventoryRow.DimUnit = this.props.DimUnit;
	            selectedInventoryRow.IsNoReturn = this.props.IsNoReturn;
	            // selectedInventoryRow.VendorStyleNum = this.props.VendorStyleNum;
	            // selectedInventoryRow.TJXStyleNum = this.props.TJXStyleNum;
	            // selectedInventoryRow.LineDescription = this.props.LineDescription;
	            // selectedInventoryRow.UPC = this.props.UPC;
	            // selectedInventoryRow.Color = this.props.Color;
	            // selectedInventoryRow.Size = this.props.Size;
	            // selectedInventoryRow.TotalUnits = this.props.TotalUnits;
	            selectedInventoryRow.StoreReady = this.props.StoreReady;
	            selectedInventoryRow.PalletStackable = this.props.PalletStackable;
	            selectedInventoryRow.Preticketed = this.props.Preticketed;
	            selectedInventoryRow.CantonNum = this.props.CantonNum;
	            selectedInventoryRow.OriginCountry = this.props.OriginCountry;
	            selectedInventoryRow.CustomerBoxQty = this.props.CustomerBoxQty;
	            selectedInventoryRow.OutsideLabelQty = this.props.OutsideLabelQty;
	            selectedInventoryRow.InsideLabelQty = this.props.InsideLabelQty;
	            selectedInventoryRow.SpecialHandling = this.props.SpecialHandling;
	            selectedInventoryRow.CustomerNote = this.props.CustomerNote;
	            selectedInventoryRow.WeightUnit = this.props.WeightUnit;
	            selectedInventoryRow.TrailerNum = this.props.TrailerNum;
	            selectedInventoryRow.POList = this.props.POList;
	            selectedInventoryRow.POD = this.props.POD;
	            if (isOCM || isJML) {
	              selectedInventoryRow.Batch_id = this.state.Batch_id;
	              if (isJML) {
	                selectedInventoryRow.Batch_id_id = this.state.Batch_id;
	              }
	              selectedInventoryRow.BatchExpiredDate = this.state.BatchExpiredDate;
	            }
	            if (isTN) {
	              selectedInventoryRow.Batch_id = this.state.Batch_id;
	              selectedInventoryRow.pallet_barcode = this.state.pallet_barcode;
	            }
	          }
	          // }
	          if (_root_url.isEcity) selectedInventoryRow.ProductCost = eCityItemPriceTrick(selectedInventoryRow);
	        } else {
	          this.setState({
	            case: 'itemOutOfStock',
	            confirmOpen: true,
	            selectedInventoryRow: {},
	            inStock: '',
	            inStockWarehouse: '',
	            purchased: '',
	            presale: '',
	            net_weight: '',
	            suggestValue: '',
	            lineBatchId: '',
	            lineBatchIdx: '',
	            lineBatchRows: [],
	            lineQty: 0,
	            batchPcs: 0
	          });
	          this.props.resetFormInputs();
	          return;
	        }
	        var rows = [].concat(_toConsumableArray(this.state.rows));
	        if (isHMM) {
	          var maxPosition = 0;
	          rows.forEach(function (row) {
	            if (row.Order > maxPosition) {
	              maxPosition = row.Order;
	            }
	          });
	          rows.push(_extends({}, selectedInventoryRow, { Order: maxPosition + 1 }));
	        } else {
	          rows.unshift(selectedInventoryRow);
	        }
	        // rows.unshift(selectedInventoryRow);
	        index = rows.length;
	        rows.map(function (row) {
	          row.Index = index;
	          index--;
	          totalCRV = (parseFloat(row.TotalCRV) || 0) + +(0, _NumberUtil.roundTo)(parseFloat(totalCRV), 2).toFixed(2);
	          if (row.IsTaxable === true) {
	            if (isHMM) {
	              totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(_this29.state.taxValue / 100);
	            } else {
	              if (isAN || _root_url.isElegant) {
	                var taxable = !_this29.props.salesCustomerDetails.Reseller;
	                if (isAN) {
	                  taxable = row.IsAllTaxable === true || !_this29.props.salesCustomerDetails.Reseller;
	                }
	                if (taxable) {
	                  totalTax += parseFloat(row.TotalPrice) * parseFloat(_this29.state.taxValue / 100);
	                }
	              } else {
	                totalTax += parseFloat(row.TotalPrice) * parseFloat(_this29.state.taxValue / 100);
	              }
	            }
	          }
	          if (isHMM) {
	            totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
	          } else {
	            totalPrice += parseFloat(row.TotalPrice);
	          }
	          if (row.TotalNetWeight != null) {
	            finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight);
	          }
	          finalWeight = Math.round(0.00001 + finalWeight * 100) / 100;
	        });
	        totalTaxOriginal = totalTax = +(0, _NumberUtil.roundTo)(totalTax, 2).toFixed(2);
	        if (_root_url.isElegant) {
	          discount = parseFloat(this.state.SODiscount) || parseFloat(this.state.SOSavings) / totalPrice * 100 || 0;
	          totalTax = +(0, _NumberUtil.roundTo)((1 - discount / 100) * totalTax, 2).toFixed(2);
	        }
	        finalWeight = Math.round(0.00001 + finalWeight * 100) / 100;
	        totalPrice = +(0, _NumberUtil.roundToDecimals)(totalPrice, 4).toFixed(4);
	        totalCRV = +(0, _NumberUtil.roundTo)(totalCRV, 2).toFixed(2);
	        var finalPrice = +(0, _NumberUtil.roundTo)(totalPrice * (1 - discount / 100) + totalTax + totalCRV, 2).toFixed(2);
	        // finalPrice = Math.round(0.00001 + finalPrice * 100) / 100;
	        this.setState({
	          rows: rows,
	          editing: true,
	          finalPrice: finalPrice,
	          totalPrice: totalPrice,
	          totalTax: totalTax,
	          totalTaxOriginal: totalTaxOriginal,
	          totalCRV: totalCRV,
	          finalWeight: finalWeight
	          // selectedInventoryRow: {},
	          // inStock: '',
	          // purchased: '',
	          // presale: '',
	          // net_weight: '',
	          // ship_weight: '',
	          // total_weight: '',
	          // suggestValue: '',
	        });
	        // }
	        // this.props.resetFormInputs();
	        // this.setAllProductQuantity(1);
	      }
	    }
	  }, {
	    key: 'findDuplicate',
	    value: function findDuplicate() {
	      var selectedInventoryRow = _extends({}, this.state.selectedInventoryRow);
	      var check = _lodash2.default.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
	      var newRows = this.state.rows;
	      newRows.map(function (r) {
	        r.isSelected = false;
	      });
	      if (check > -1) {
	        newRows[check].isSelected = true;
	      }
	      this.setState(_extends({}, this.state, { rows: newRows }));
	    }
	  }, {
	    key: 'renderSelectedItem',
	    value: function renderSelectedItem() {
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 3 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'item_no' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 3 },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-5 centerStyle' },
	            this.state.selectedItemNumber
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 3 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'item_name' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 3 },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-5 centerStyle' },
	            this.state.selectedItemName
	          )
	        )
	      );
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      var formattedDate = date.getFullYear() + '-';
	      formattedDate += date.getMonth() + 1 + '-';
	      if (date.getDate() < 10) {
	        formattedDate += '0' + date.getDate() + 'T';
	      } else {
	        formattedDate += date.getDate() + 'T';
	      }
	      if (date.getHours() < 10) {
	        formattedDate += '0' + date.getHours() + ':';
	      } else {
	        formattedDate += date.getHours() + ':';
	      }
	      if (date.getMinutes() < 10) {
	        formattedDate += '0' + date.getMinutes() + ':';
	      } else {
	        formattedDate += date.getMinutes() + ':';
	      }
	      if (date.getSeconds < 10) {
	        formattedDate += '0' + date.getSeconds();
	      } else {
	        formattedDate += date.getSeconds();
	      }
	      return formattedDate;
	    }
	  }, {
	    key: 'handleKeyPressTargetInput',
	    value: function handleKeyPressTargetInput(value, event) {
	      if (event.keyCode === 13) {
	        _reactDom2.default.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
	      }
	    }
	  }, {
	    key: 'handleInventoryNumKeyPress',
	    value: function handleInventoryNumKeyPress(event) {
	      if (event.charCode === 13) {
	        if (this.state.inventories.rows.length > 0) {
	          //           lastChild
	          // :
	          // div.react-grid-Cell__value
	          // lastElementChild
	          // :
	          // div.react-grid-Cell__value
	          // ReactDOM.findDOMNode(this["myRowNameForTest"].refs[0].refs.cell.lastChild).focus();
	          var rows = this.state.inventories.rows;
	          rows.map(function (row) {
	            row.isSelected = false;
	          });
	          rows[0].isSelected = true;
	          var inventories = _extends({}, this.state.inventories, { rows: rows });
	          this.setState({ inventories: inventories, cellSelectEnabled: false });
	          _reactDom2.default.findDOMNode(this.refs.testingIfThisWorks.refs.base.refs.viewPortContainer).focus();
	        }
	      }
	    }
	  }, {
	    key: 'handleUPKeyPress',
	    value: function handleUPKeyPress(event) {
	      if (event.charCode === 13) {
	        event.preventDefault();
	        this.moveToSOButton.props.onClick();
	        _reactDom2.default.findDOMNode(this.refs.inventory.getRenderedComponent().myInput.refs.input).focus();
	      }
	    }
	  }, {
	    key: 'checkPermission',
	    value: function checkPermission(permission) {
	      return false;
	    }
	  }, {
	    key: 'customerHeader',
	    value: function customerHeader() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 'mt0' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_information' })
	        )
	      );
	    }
	  }, {
	    key: 'inboundInformationHeader',
	    value: function inboundInformationHeader() {
	      var type = "";
	      if (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id') {
	        type = "inbound";
	      }
	      if (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
	        type = "outbound";
	      }
	      return type === "inbound" ? _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inbound_information' })
	        )
	      ) : _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'outbound_information' })
	        )
	      );
	    }
	  }, {
	    key: 'generalInformationHeader',
	    value: function generalInformationHeader() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_info' })
	        )
	      );
	    }
	  }, {
	    key: 'containerInformationHeader',
	    value: function containerInformationHeader() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_info' })
	        )
	      );
	    }
	  }, {
	    key: 'pickdropInformationHeader',
	    value: function pickdropInformationHeader() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickdrop_info' })
	        )
	      );
	    }
	  }, {
	    key: 'renderSubtotal',
	    value: function renderSubtotal() {
	      var subtotal = 0;
	      if (this.state.selectedInventoryRow && this.state.selectedInventoryRow.ProductType === 'Fixed') {
	        if (this.props.quantityValue) {
	          subtotal = (this.props.quantityValue * this.props.unitPrice).toFixed(2);
	        }
	      } else if (this.props.weight) {
	        subtotal = (this.props.unitPrice * this.props.weight * this.props.quantityValue).toFixed(2);
	      }
	      // if (isJML && this.state.selectedInventoryRow && this.state.selectedInventoryRow.ProductType === 'Non-Fixed') { 
	      //   subtotal = (this.props.PackageSize_1 * this.props.unitPrice * this.props.quantityValue).toFixed(2);
	      // }
	      if (isNaN(subtotal)) {
	        subtotal = 0;
	      }
	      return _react2.default.createElement(_reduxForm.Field, { name: 'Subtotal', component: _inputField.DisabledInputField, placeholder: subtotal });
	    }
	  }, {
	    key: 'renderCustomerDetail',
	    value: function renderCustomerDetail() {
	      var _this30 = this;
	
	      var customerNameOptions = this.getCustomerNameOptions();
	      var customerNumOptions = this.getCustomerNumOptions();
	      var customerPhoneOptions = this.getCustomerPhoneOptions();
	      var SelectionForCustomer = this.props.currentSalesOrder ? _selection.DisabledSelection : _selection.SelectionWithProps;
	      // const fieldName = (this.context.router.routes[1].path === 'salesOrders/new') ? 'CustomerDetail_id' : 'Deliver_CustomerDetail_id';
	      var addressOptions = this.getAddressOptions();
	      var shippingPhoneOptions = this.getShippingPhoneOptions();
	      var isMobile = this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id';
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 7, id: 'customer-details' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'div',
	            { id: 'customer-name-dropdown', className: 'col-xs-11' },
	            isMobile ? _react2.default.createElement(_reduxForm.Field, {
	              name: 'Deliver_CustomerName',
	              withRef: true,
	              ref: 'customer_name',
	              matchPos: 'any',
	              component: _inputField.InputField,
	              onFocus: this.handleOnFocus,
	              disabled: true
	            }) : _react2.default.createElement(_reduxForm.Field, {
	              name: 'Deliver_Customer_id',
	              matchPos: 'any',
	              component: SelectionForCustomer,
	              ref: 'customer_name',
	              withRef: true,
	              options: customerNameOptions,
	              placeholder: _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'asteriksReq' },
	                  '*'
	                )
	              ),
	              onSelect: function onSelect(value) {
	                _this30.props.setValue('salesOrderForm', 'receivingCustomer', value.value);
	              },
	              onInputKeyDown: function onInputKeyDown(event) {
	                if (event.keyCode === 13) {
	                  var myField = document.getElementById('sales-auto-suggest');
	                  if (myField) {
	                    myField.select();
	                  }
	                }
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-3' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_id' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { id: 'customer-id-dropdown', className: 'col-xs-8' },
	            isMobile ? _react2.default.createElement(_reduxForm.Field, {
	              name: 'Deliver_Customer_num',
	              withRef: true
	              // ref="quantity"
	              , component: _inputField.InputField,
	              onFocus: this.handleOnFocus,
	              disabled: true
	            }) : _react2.default.createElement(_reduxForm.Field, {
	              name: 'Deliver_Customer_id',
	              component: SelectionForCustomer,
	              options: customerNumOptions,
	              onInputKeyDown: function onInputKeyDown(event) {
	                if (event.keyCode === 13) {
	                  var myField = document.getElementById('sales-auto-suggest');
	                  if (myField) {
	                    myField.select();
	                  }
	                }
	              },
	              matchPos: 'any',
	              onSelect: function onSelect(value) {
	                _this30.props.setValue('salesOrderForm', 'receivingCustomer', value.value);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-3' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' }),
	            ' #'
	          ),
	          _react2.default.createElement(
	            'div',
	            { id: 'customer-phone-dropdown', className: 'col-xs-8' },
	            isMobile ? _react2.default.createElement(_reduxForm.Field, {
	              name: 'Billing.Telephone',
	              withRef: true
	              // ref="quantity"
	              , component: _inputField.InputField,
	              onFocus: this.handleOnFocus,
	              disabled: true
	            }) : _react2.default.createElement(_reduxForm.Field, {
	              name: 'Deliver_Customer_id',
	              component: SelectionForCustomer,
	              options: customerPhoneOptions,
	              onInputKeyDown: function onInputKeyDown(event) {
	                if (event.keyCode === 13) {
	                  var myField = document.getElementById('sales-auto-suggest');
	                  if (myField) {
	                    myField.select();
	                  }
	                }
	              },
	              matchPos: 'any',
	              onSelect: function onSelect(value) {
	                _this30.props.setValue('salesOrderForm', 'receivingCustomer', value.value);
	              }
	            })
	          )
	        ),
	        isOCM && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'company' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'customer-company-dropdown', className: 'col-xs-8' },
	              _react2.default.createElement(_reduxForm.Field, {
	                name: 'Company_id',
	                matchPos: 'any',
	                component: SelectionForCustomer,
	                options: this.state.companyOptions,
	                onSelect: function onSelect(value) {
	                  _this30.props.setValue('salesOrderForm', 'Company_id', value.value);
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-8' },
	              _react2.default.createElement(_reduxForm.Field, {
	                name: 'Pickup_Warehouse_id',
	                matchPos: 'any',
	                component: SelectionForCustomer,
	                options: this.state.warehouseOptions,
	                onSelect: function onSelect(value) {
	                  _this30.props.setValue('salesOrderForm', 'Pickup_Warehouse_id', value.value);
	                }
	              })
	            )
	          )
	        ),
	        isFJ && _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-3' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'agent' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { id: 'customer-phone-dropdown', className: 'col-xs-8' },
	            _react2.default.createElement(_reduxForm.Field, { name: 'Agent_id', matchPos: 'any', component: _selection.Selection, options: this.state.FJAgentOptions })
	          )
	        )
	      );
	      // }
	    }
	  }, {
	    key: 'renderCustomerDetailABC',
	    value: function renderCustomerDetailABC() {
	      var CompanyName = this.state.CompanyName;
	
	      var customerNameOptions = this.getCustomerNameOptions();
	      var customerNumOptions = this.getCustomerNumOptions();
	      var customerPhoneOptions = this.getCustomerPhoneOptions();
	      var SelectionForCustomer = this.props.currentSalesOrder ? _selection.DisabledSelection : _selection.SelectionWithProps;
	      var addressOptions = this.getAddressOptions();
	      var shippingPhoneOptions = this.getShippingPhoneOptions();
	      var isMobile = this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id';
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 7, id: 'customer-details' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'company' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'div',
	            { id: 'customer-name-dropdown', className: 'col-xs-11' },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'CompanyName',
	              withRef: true,
	              ref: 'customer_name',
	              matchPos: 'any',
	              component: _inputField.InputField,
	              onFocus: this.handleOnFocus,
	              disabled: true
	            })
	          )
	        ),
	        _react2.default.createElement('div', { className: 'form-group' }),
	        _react2.default.createElement('div', { className: 'form-group' })
	      );
	    }
	  }, {
	    key: 'renderShippingAddressSelections',
	    value: function renderShippingAddressSelections() {
	      var _this31 = this;
	
	      var customerNameOptions = this.getCustomerNameOptions();
	      var shippingContactOptions = this.getShippingContactOptions();
	      var shippingPhoneOptions = this.getShippingPhoneOptions();
	      var shippingNameOptions = this.getShippingNameOptions();
	      var addressOptions = this.getAddressOptions();
	      var isMobile = this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id';
	      var fieldName = this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'outboundOrders/new' ? 'CustomerDetail_id' : 'Deliver_CustomerDetail_id';
	      var mobileSalesUserShippingAddress = this.props.initialValues ? this.props.initialValues.Shipping.Street + ' ' + this.props.initialValues.Shipping.City + ' ' + this.props.initialValues.Shipping.State + ' ' + this.props.initialValues.Shipping.Zip : null;
	      // if (this.props.receivingCustomer && !this.props.shipperChosen && shippingPhoneOptions.length) {
	      //   this.props.setValue('salesOrderForm', fieldName, shippingPhoneOptions[0].value);   
	      // }
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 6, id: 'customer-details' },
	        _react2.default.createElement(
	          'div',
	          { style: { width: '300px', display: 'flex' } },
	          isMobile ? _react2.default.createElement(
	            'h4',
	            { onDoubleClick: this.openShippingInfoFormModal, style: { textDecoration: 'underline' } },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_information' })
	          ) : _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_information' })
	          ),
	          (!isWIZ || !this.state.IsFBAAddress) && _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              id: 'shipping-info-add-button',
	              type: 'button',
	              onClick: function onClick() {
	                _this31.openShippingInfoEditModal();
	              },
	              disabled: !this.props.receivingCustomer
	            },
	            '+'
	          ),
	          isWIZ && this.state.IsFBAAddress && _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              id: 'shipping-info-add-button',
	              type: 'button',
	              onClick: function onClick() {
	                _this31.openFBAEditModal();
	              },
	              disabled: false
	            },
	            '+'
	          ),
	          this.state.showCarrierButton && _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              id: 'carrier-info-button',
	              type: 'button',
	              onClick: this.openCarrierInfoModal
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' })
	          )
	        ),
	        isWIZ && _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-5' },
	            'FBA Address'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-7' },
	            _react2.default.createElement(_reduxForm.Field, { name: 'IsFBAAddress', checked: this.state.IsFBAAddress, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                _this31.setState({ IsFBAAddress: !_this31.state.IsFBAAddress });
	              } })
	          )
	        ),
	        isWIZ && this.state.IsFBAAddress && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'div',
	              { id: 'fba-address-dropdown', className: 'col-xs-12' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'DestinationAddress', matchPos: 'any', component: _selection.Selection, options: this.state.FBAOptions })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'fba-address-dropdown', className: 'col-xs-9' },
	              _react2.default.createElement(_reduxForm.Field, { name: 'DestinationAddress', matchPos: 'any', component: _selection.Selection, options: this.state.FBAOptions2 })
	            )
	          )
	        ),
	        !isOCM && !isABCFF && (!isWIZ || !this.state.IsFBAAddress) && _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'div',
	            { id: 'customer-name-dropdown', className: 'col-xs-11' },
	            isMobile ? _react2.default.createElement(_reduxForm.Field, {
	              name: 'Shipping.FirstName',
	              withRef: true
	              // ref="quantity"
	              , component: _inputField.InputField,
	              onFocus: this.handleOnFocus,
	              disabled: true
	            }) : _react2.default.createElement(_reduxForm.Field, {
	              name: 'receivingCustomer',
	              matchPos: 'any',
	              placeholder: _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'asteriksReq' },
	                  '*'
	                )
	              ),
	              component: _selection.SelectionWithProps,
	              options: customerNameOptions
	            })
	          )
	        ),
	        (isHMM || isOCM || isABCFF) && _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-3' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receiver' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { id: 'customer-name-dropdown', className: 'col-xs-8' },
	            _react2.default.createElement(_reduxForm.Field, { name: fieldName, matchPos: 'any', component: _selection.Selection, options: shippingNameOptions })
	          )
	        ),
	        (!isWIZ || !this.state.IsFBAAddress) && _react2.default.createElement(
	          'div',
	          null,
	          isMobile ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-3' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { id: 'customer-id-dropdown', className: 'col-xs-8' },
	                _react2.default.createElement(_reduxForm.Field, {
	                  name: 'Shipping.Telephone',
	                  withRef: true
	                  // ref="quantity"
	                  , component: _inputField.InputField,
	                  onFocus: this.handleOnFocus,
	                  disabled: true
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-3' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-8' },
	                _react2.default.createElement('input', { style: { width: '100%', borderRadius: '5px', padding: '4px', border: '1px solid black', backgroundColor: '#CFD8DC' }, disabled: true, value: mobileSalesUserShippingAddress })
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-3' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { id: 'customer-id-dropdown', className: 'col-xs-8' },
	                _react2.default.createElement(_reduxForm.Field, { name: fieldName, matchPos: 'any', component: _selection.Selection, options: shippingPhoneOptions })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-3' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-8' },
	                _react2.default.createElement(_reduxForm.Field, { name: fieldName, matchPos: 'any', component: _selection.Selection, options: addressOptions })
	              )
	            )
	          ),
	          (isNBT || isKM) && _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-xs-3' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ssn' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-8' },
	              _react2.default.createElement(_reduxForm.Field, {
	                name: 'Shipping.SSN',
	                withRef: true,
	                component: _inputField.InputField,
	                onFocus: this.handleOnFocus,
	                disabled: true
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderShippingAddressSelectionsABC',
	    value: function renderShippingAddressSelectionsABC() {
	      var ShipTo = this.state.ShipTo;
	
	      var customerNameOptions = this.getCustomerNameOptions();
	      var shippingContactOptions = this.getShippingContactOptions();
	      var shippingPhoneOptions = this.getShippingPhoneOptions();
	      var shippingNameOptions = this.getShippingNameOptions();
	      var addressOptions = this.getAddressOptions();
	      var isMobile = this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id';
	      var fieldName = this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'outboundOrders/new' ? 'CustomerDetail_id' : 'Deliver_CustomerDetail_id';
	      var mobileSalesUserShippingAddress = this.props.initialValues ? this.props.initialValues.Shipping.Street + ' ' + this.props.initialValues.Shipping.City + ' ' + this.props.initialValues.Shipping.State + ' ' + this.props.initialValues.Shipping.Zip : null;
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 6, id: 'customer-details' },
	        _react2.default.createElement(
	          'div',
	          { style: { width: '300px', display: 'flex' } },
	          _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_to_address' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'div',
	            { id: 'customer-name-dropdown', className: 'col-xs-11' },
	            isMobile ? _react2.default.createElement(_reduxForm.Field, {
	              name: 'ShipTo.Name',
	              withRef: true
	              // ref="quantity"
	              , component: _inputField.InputField,
	              onFocus: this.handleOnFocus,
	              disabled: true
	            }) : _react2.default.createElement(_reduxForm.Field, {
	              name: 'receivingCustomer',
	              matchPos: 'any',
	              placeholder: _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'asteriksReq' },
	                  '*'
	                )
	              ),
	              component: _selection.SelectionWithProps,
	              options: customerNameOptions
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-3' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { id: 'customer-id-dropdown', className: 'col-xs-8' },
	            isMobile ? _react2.default.createElement(_reduxForm.Field, {
	              name: 'ShipTo.Telephone',
	              component: _inputField.InputField,
	              disabled: true
	            }) : _react2.default.createElement(_reduxForm.Field, { name: fieldName, matchPos: 'any', component: _selection.Selection, options: shippingPhoneOptions })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-3' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-8' },
	            isMobile ? _react2.default.createElement('input', { style: { width: '100%', borderRadius: '5px', padding: '4px', border: '1px solid black', backgroundColor: '#CFD8DC' }, disabled: true, value: ShipTo.Address }) : _react2.default.createElement(_reduxForm.Field, { name: fieldName, matchPos: 'any', component: _selection.Selection, options: addressOptions })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'productHeader',
	    value: function productHeader() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_information' })
	        )
	      );
	    }
	  }, {
	    key: 'renderCustomerCredit',
	    value: function renderCustomerCredit() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h4',
	          { style: { marginBottom: '5px' } },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_credit' })
	        )
	      );
	    }
	  }, {
	    key: 'orderHeader',
	    value: function orderHeader() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'your_order' })
	        )
	      );
	    }
	  }, {
	    key: 'moveFromPreviousOrderToSalesOrder',
	    value: function moveFromPreviousOrderToSalesOrder() {
	      var _this32 = this;
	
	      var selectPreviousOrderRows = [].concat(_toConsumableArray(this.state.previousOrders.selectedRows));
	      var newRows = [];
	      var totalPrice = 0;
	      var finalWeight = 0;
	      var totalTax = 0;
	      var totalTaxOriginal = 0;
	      var totalCRV = 0;
	      selectPreviousOrderRows.map(function (index) {
	        // check if the product already add in your order
	        var check = _lodash2.default.findIndex(_this32.state.rows, { ProductNum: index.ProductNum });
	        if (check === -1) {
	          newRows.push(index);
	        }
	      });
	      var rows = [].concat(_toConsumableArray(this.state.rows));
	      newRows.map(function (row) {
	        row.Quantity = 0;
	        row.TotalPrice = 0;
	        if (isJML) {
	          row.jmlBox = 0;
	          row.jmlPackageSize1 = 0;
	        }
	        rows.unshift(row);
	      });
	
	      var index = rows.length;
	      rows.map(function (row) {
	        row.Index = index;
	        index--;
	        // totalCRV = parseFloat(row.CRV) + totalCRV;
	        if (row.IsTaxable === true) {
	          if (isHMM) {
	            totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(_this32.state.taxValue / 100);
	          } else {
	            if (isAN || _root_url.isElegant) {
	              var taxable = !_this32.props.salesCustomerDetails.Reseller;
	              if (isAN) {
	                taxable = row.IsAllTaxable === true || !_this32.props.salesCustomerDetails.Reseller;
	              }
	              if (taxable) {
	                totalTax += parseFloat(row.TotalPrice) * parseFloat(_this32.state.taxValue / 100);
	              }
	            } else {
	              totalTax += parseFloat(row.TotalPrice) * parseFloat(_this32.state.taxValue / 100);
	            }
	          }
	        }
	        if (isHMM) {
	          totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
	        } else {
	          totalPrice += parseFloat(row.TotalPrice);
	        }
	        row.TotalCRV = +(0, _NumberUtil.roundTo)(row.Quantity * row.CRV, 2).toFixed(2);
	        if (row.Weight != null) {
	          finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight);
	        }
	        row.TotalNetWeight = row.TotalNetWeight;
	      });
	      totalTaxOriginal = totalTax = +(0, _NumberUtil.roundTo)(totalTax, 2).toFixed(2);
	      // reset selected after add
	      this.handleDeselectAll();
	      this.setState({
	        rows: rows,
	        totalPrice: totalPrice,
	        finalWeight: finalWeight,
	        totalTax: totalTax,
	        totalTaxOriginal: totalTaxOriginal,
	        totalCRV: totalCRV
	      });
	    }
	
	    // Quick Entry SO Number
	
	  }, {
	    key: 'onChangeQuickEntry',
	    value: function onChangeQuickEntry(e) {
	      this.setState({ quickEntrySONum: e.target.value });
	    }
	  }, {
	    key: 'onKeyPressQuickEntry',
	    value: function onKeyPressQuickEntry(e) {
	      var _this33 = this;
	
	      var handleSuccess = function handleSuccess(response) {};
	      var handleFailure = function handleFailure(error) {
	        _this33.setState({ quickEntryShowError: true });
	      };
	      if (e.charCode === 13) {
	        this.fetchPreviousOrderBySearch(this.state.quickEntrySONum);
	        // this.props.fetchQuickAccess(this.state.quickEntrySONum, handleSuccess, handleFailure);
	      }
	    }
	  }, {
	    key: 'checkblah',
	    value: function checkblah() {
	      if (isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
	        if (!this.state.frequentItems.selectedPK || this.state.frequentItems.selectedPK.length === 0) {
	          return true;
	        }
	      } else {
	        if (!this.state.frequentItems.selectedIndexes || this.state.frequentItems.selectedIndexes.length === 0) {
	          return true;
	        }
	      }
	    }
	  }, {
	    key: 'moveFromFrequentItemsToSalesOrder',
	    value: function moveFromFrequentItemsToSalesOrder() {
	      var _this34 = this;
	
	      var frequentRows = [].concat(_toConsumableArray(this.state.frequentItems.selectedIndexes));
	      if (isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
	        this.state.frequentItems.rows = this.props.customerFrequent.record;
	      }
	      var prevRows = [].concat(_toConsumableArray(this.state.frequentItems.rows));
	      var frequentPK = [];
	      if (isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
	        frequentPK = [].concat(_toConsumableArray(this.state.frequentItems.selectedPK));
	      }
	      var newRows = [];
	      var totalPrice = 0;
	      var finalWeight = 0;
	      var totalTax = 0;
	      var totalTaxOriginal = 0;
	      var totalCRV = 0;
	      var check = null;
	      if (isDSQ || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
	        frequentPK.map(function (r) {
	          prevRows.map(function (j, index) {
	            if (r === j.pk) {
	              newRows.push(prevRows[index]);
	            }
	          });
	        });
	      } else {
	        frequentRows.map(function (index) {
	          check = _lodash2.default.findIndex(_this34.state.rows, { ProductNum: prevRows[index].ProductNum });
	          if (check == -1) {
	            if (isJML) {
	              newRows.push(_extends({}, prevRows[index], { jmlBox: 0, jmlPackageSize1: 0 }));
	            } else {
	              newRows.push(prevRows[index]);
	            }
	          } else if (isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
	            newRows.push(prevRows[index]);
	          }
	        });
	      }
	      var rows = [].concat(_toConsumableArray(this.state.rows));
	      newRows.map(function (row) {
	        row.Quantity = 0;
	        row.TotalPrice = 0;
	        if (isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
	          rows.unshift(_extends({}, row));
	        } else {
	          rows.unshift(row);
	        }
	      });
	      var index = rows.length;
	      rows.map(function (row) {
	        row.Index = index;
	        index--;
	        // totalCRV = parseFloat(row.CRV) + totalCRV;
	        if (row.IsTaxable === true) {
	          if (isHMM) {
	            totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(_this34.state.taxValue / 100);
	          } else {
	            if (isAN || _root_url.isElegant) {
	              var taxable = !_this34.props.salesCustomerDetails.Reseller;
	              if (isAN) {
	                taxable = row.IsAllTaxable === true || !_this34.props.salesCustomerDetails.Reseller;
	              }
	              if (taxable) {
	                totalTax += parseFloat(row.TotalPrice) * parseFloat(_this34.state.taxValue / 100);
	              }
	            } else {
	              totalTax += parseFloat(row.TotalPrice) * parseFloat(_this34.state.taxValue / 100);
	            }
	          }
	        }
	        if (isHMM) {
	          totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
	        } else {
	          totalPrice += parseFloat(row.TotalPrice);
	        }
	        row.TotalCRV = +(0, _NumberUtil.roundTo)(row.Quantity * row.CRV, 2).toFixed(2);
	        if (row.Weight != null) {
	          finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight);
	        }
	        row.TotalNetWeight = row.TotalNetWeight;
	      });
	      totalTaxOriginal = totalTax = +(0, _NumberUtil.roundTo)(totalTax, 2).toFixed(2);
	      this.setState({
	        rows: rows, totalPrice: totalPrice, finalWeight: finalWeight, totalTax: totalTax, totalCRV: totalCRV, totalTaxOriginal: totalTaxOriginal
	      });
	    }
	  }, {
	    key: 'moveFromFavoriteItemsToSalesOrder',
	    value: function moveFromFavoriteItemsToSalesOrder() {
	      var _this35 = this;
	
	      var favoritesRows = [].concat(_toConsumableArray(this.state.favorites.selectedIndexes));
	      var prevRows = [].concat(_toConsumableArray(this.state.favorites.rows));
	      var newRows = [];
	      var totalPrice = 0;
	      var finalWeight = 0;
	      var totalTax = 0;
	      var totalTaxOriginal = 0;
	      var totalCRV = 0;
	      favoritesRows.map(function (index) {
	        var check = _lodash2.default.findIndex(_this35.state.rows, { ProductNum: prevRows[index].ProductNum });
	        if (check == -1) {
	          newRows.push(prevRows[index]);
	        }
	      });
	      var rows = [].concat(_toConsumableArray(this.state.rows));
	      newRows.map(function (row) {
	        row.Quantity = 0;
	        row.TotalPrice = 0;
	        rows.unshift(row);
	      });
	      var index = rows.length;
	      rows.map(function (row) {
	        row.Index = index;
	        index--;
	        // totalCRV = parseFloat(row.CRV) + totalCRV;
	        if (row.IsTaxable == true) {
	          if (isHMM) {
	            totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(_this35.state.taxValue / 100);
	          } else {
	            if (isAN || _root_url.isElegant) {
	              var taxable = !_this35.props.salesCustomerDetails.Reseller;
	              if (isAN) {
	                taxable = row.IsAllTaxable === true || !_this35.props.salesCustomerDetails.Reseller;
	              }
	              if (taxable) {
	                totalTax += parseFloat(row.TotalPrice) * parseFloat(_this35.state.taxValue / 100);
	              }
	            } else {
	              totalTax += parseFloat(row.TotalPrice) * parseFloat(_this35.state.taxValue / 100);
	            }
	          }
	        }
	        if (isHMM) {
	          totalPrice = parseFloat(totalPrice) + parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
	        } else {
	          totalPrice = parseFloat(totalPrice) + parseFloat(row.TotalPrice);
	        }
	        row.TotalCRV = +(0, _NumberUtil.roundTo)(row.Quantity * row.CRV, 2).toFixed(2);
	        if (row.Weight != null) {
	          finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight);
	        }
	        row.TotalNetWeight = row.TotalNetWeight;
	      });
	      totalTaxOriginal = totalTax = +(0, _NumberUtil.roundTo)(totalTax, 2).toFixed(2);
	      this.setState({
	        rows: rows, totalPrice: totalPrice, finalWeight: finalWeight, totalTax: totalTax, totalCRV: totalCRV, totalTaxOriginal: totalTaxOriginal
	      });
	    }
	
	    /* Handle Refund Confirm */
	
	  }, {
	    key: 'handleRefundConfirm',
	    value: function handleRefundConfirm() {
	      var id = this.props.params.id;
	      var _state2 = this.state,
	          refundAmount = _state2.refundAmount,
	          refundReason = _state2.refundReason;
	
	      if (id) {
	        this.props.requestSORefund(id, { refundAmount: refundAmount, refundReason: refundReason });
	      }
	    }
	  }, {
	    key: 'renderEditSOPermission',
	    value: function renderEditSOPermission() {
	      if (!this.props.currentSalesOrder) {
	        return;
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          onClick: this.openEditSOPermission
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'permission' })
	      );
	    }
	  }, {
	    key: 'renderExpressInvoice',
	    value: function renderExpressInvoice() {
	      var currentSalesOrderDetail = this.props.currentSalesOrderDetail;
	
	      if (!currentSalesOrderDetail || !currentSalesOrderDetail.SaleStatus) {
	        return;
	      }
	      var buttonShouldDisable = this.state.Released || currentSalesOrderDetail.SaleStatus === 'Finalized' || currentSalesOrderDetail.SaleStatus === 'Refunded' || currentSalesOrderDetail.SaleStatus === 'Partially Refunded' || currentSalesOrderDetail.SaleStatus === 'Canceled' || this.state.editing;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          onClick: this.openShipping,
	          disabled: buttonShouldDisable
	        },
	        _react2.default.createElement('em', { className: 'fa fa-edit' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'express_invoice' })
	      );
	    }
	  }, {
	    key: 'renderDropshipButton',
	    value: function renderDropshipButton() {
	      var currentSalesOrder = this.props.currentSalesOrder;
	
	      if (!currentSalesOrder) {
	        return null;
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          onClick: this.openDropship
	        },
	        _react2.default.createElement('em', { className: 'fa fa-plus' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropship' })
	      );
	    }
	  }, {
	    key: 'renderCreateBOLButton',
	    value: function renderCreateBOLButton() {
	      var currentSalesOrder = this.props.currentSalesOrder;
	
	      if (!currentSalesOrder) {
	        return null;
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          onClick: this.openCreateBOLModal
	        },
	        _react2.default.createElement('em', { className: 'fa fa-plus' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bol' })
	      );
	    }
	  }, {
	    key: 'renderShippingIFrame',
	    value: function renderShippingIFrame() {
	      if (this.props.shippingListPDF) {
	        var file = window.URL.createObjectURL(this.props.shippingListPDF);
	        return _react2.default.createElement('iframe', { style: { display: 'none' }, onLoad: this.shippingIFrameIsLoaded, id: 'shippingPdf', name: 'shippingPdf', src: file });
	      }
	    }
	  }, {
	    key: 'renderPackingIFrame',
	    value: function renderPackingIFrame() {
	      if (this.props.packingListPDF) {
	        var file = window.URL.createObjectURL(this.props.packingListPDF);
	        return _react2.default.createElement('iframe', { style: { display: 'none' }, onLoad: this.packingIFrameIsLoaded, id: 'packingPdf', name: 'packingPdf', src: file });
	      }
	    }
	  }, {
	    key: 'renderPickingIFrame',
	    value: function renderPickingIFrame() {
	      if (this.props.pickingListPDF) {
	        var file = window.URL.createObjectURL(this.props.pickingListPDF);
	        return _react2.default.createElement('iframe', { style: { display: 'none' }, onLoad: this.pickingIFrameIsLoaded, id: 'pickingPdf', name: 'pickingPdf', src: file });
	      }
	    }
	  }, {
	    key: 'renderSalesOrderIFrame',
	    value: function renderSalesOrderIFrame() {
	      if (this.props.salesOrderPDF) {
	        var file = window.URL.createObjectURL(this.props.salesOrderPDF);
	        return _react2.default.createElement('iframe', { style: { display: 'none' }, onLoad: this.salesOrderIFrameIsLoaded, id: 'salesOrderPdf', name: 'salesOrderPdf', src: file });
	      }
	    }
	  }, {
	    key: 'renderSalesOrderSIIFrame',
	    value: function renderSalesOrderSIIFrame() {
	      if (this.props.salesOrderSIPDF) {
	        var file = window.URL.createObjectURL(this.props.salesOrderSIPDF);
	        return _react2.default.createElement('iframe', { style: { display: 'none' }, onLoad: this.salesOrderSIIFrameIsLoaded, id: 'salesOrderSIPdf', name: 'salesOrderSIPdf', src: file });
	      }
	    }
	  }, {
	    key: 'renderRefundIframe',
	    value: function renderRefundIframe() {
	      var refundPDFFrameLoaded = this.state.refundPDFFrameLoaded;
	      var refundPDF = this.props.refundPDF;
	
	      return _react2.default.createElement(_PrintIframe2.default, {
	        id: 'refundPDF',
	        loaded: refundPDFFrameLoaded,
	        name: 'refundPDF',
	        onLoad: this.handlePrintFrameOnLoad,
	        pdf: refundPDF,
	        title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_refund_summary' })
	      });
	    }
	  }, {
	    key: 'renderPrint',
	    value: function renderPrint() {
	      var _this36 = this;
	
	      var currentSalesOrder = this.props.currentSalesOrder;
	      if (!currentSalesOrder) {
	        return;
	      }
	      var url = _root_url.ROOT_URL + 'v1/sale/printorder/' + currentSalesOrder.SalesOrder_id + '?Bearer=' + localStorage.getItem('token');
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          disabled: this.state.editing,
	          onClick: function onClick() {
	            _this36.props.printSalesOrder(currentSalesOrder.SalesOrder_id);
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_so' })
	      );
	    }
	  }, {
	    key: 'renderPrintPL',
	    value: function renderPrintPL() {
	      var _this37 = this;
	
	      var currentSalesOrder = this.props.currentSalesOrder;
	      if (!currentSalesOrder) {
	        return;
	      }
	      var picking_url = _root_url.ROOT_URL + 'v1/sale/printpickinglist/' + currentSalesOrder.SalesOrder_id + '?Bearer=' + localStorage.getItem('token');
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          disabled: this.state.editing,
	          onClick: function onClick() {
	            _this37.props.printPickingList(currentSalesOrder.SalesOrder_id);
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'picking_list' })
	      );
	    }
	  }, {
	    key: 'renderPrintSL',
	    value: function renderPrintSL() {
	      var _this38 = this;
	
	      var currentSalesOrder = this.props.currentSalesOrder;
	      if (!currentSalesOrder) {
	        return;
	      }
	      var shipping_url = _root_url.ROOT_URL + 'v1/sale/printshippinglist/' + currentSalesOrder.SalesOrder_id + '?Bearer=' + localStorage.getItem('token');
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          disabled: this.state.editing,
	          onClick: function onClick() {
	            _this38.props.printShippingList(currentSalesOrder.SalesOrder_id);
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_list' })
	      );
	    }
	  }, {
	    key: 'renderPrintPaL',
	    value: function renderPrintPaL() {
	      var _this39 = this;
	
	      var currentSalesOrder = this.props.currentSalesOrder;
	      if (!currentSalesOrder) {
	        return;
	      }
	      var packing_url = _root_url.ROOT_URL + 'v1/sale/printpackinglist/' + currentSalesOrder.SalesOrder_id + '?Bearer=' + localStorage.getItem('token');
	      var hasInvoice = false;
	      if (!isHMM || currentSalesOrder && currentSalesOrder.InvoiceNum) {
	        hasInvoice = true;
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          disabled: !hasInvoice,
	          onClick: function onClick() {
	            _this39.props.printPackingList(currentSalesOrder.SalesOrder_id);
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'packing_list' })
	      );
	    }
	  }, {
	    key: 'renderFavoritesList',
	    value: function renderFavoritesList() {
	      var _this40 = this;
	
	      if (this.props.favoriteListIsLoading && !this.props.favoriteListError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.favoriteListError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.favoriteListError)
	        )
	      );
	
	      // Parameters of the react-data-grid
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this40.state.favorites);
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        var selectedIndexes = _this40.state.favorites.selectedIndexes.concat(rows.map(function (r) {
	          return r.rowIdx;
	        }));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        var favorites = _extends({}, _this40.state.favorites, { rows: newRows, selectedIndexes: selectedIndexes });
	        _this40.setState({ favorites: favorites });
	      };
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var rowIndexes = rows.map(function (r) {
	          return r.rowIdx;
	        });
	        var newRows = [].concat(_toConsumableArray(_this40.state.favorites.rows));
	        var selectedIndexes = _this40.state.favorites.selectedIndexes.filter(function (i) {
	          return rowIndexes.indexOf(i) === -1;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        var favorites = _extends({}, _this40.state.favorites, { rows: newRows, selectedIndexes: selectedIndexes });
	        _this40.setState({ favorites: favorites });
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var favorites = _extends({}, _this40.state.favorites, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this40.setState({ favorites: favorites });
	      };
	      var onRowSelect = function onRowSelect(rows) {
	        var favorites = _extends({}, _this40.state.favorites, { selectedRows: rows });
	        _this40.setState({ favorites: favorites });
	      };
	      var onRowClick = function onRowClick(rowIdx, row) {
	        if (rowIdx > -1) {
	          if (_this40.context.router.routes[1].path !== 'outboundOrders/new' && _this40.context.router.routes[1].path !== 'outboundOrders/:id') {
	            _this40.props.fetchItemSalesHistory(_this40.state.currentCustomer, row.Product_id);
	          }
	          // this.props.fetchProductInfo(row.Product_id);
	        }
	      };
	      // Custom Formatter component
	      var IsEnabledFormatter = _react2.default.createClass({
	        displayName: 'IsEnabledFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            { className: 'label label-success' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	          );
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disable' })
	          );
	        }
	      });
	      // Inventory list pop up table columns
	
	      var showProductCost = function showProductCost() {
	        if ((isJML || isChinaTown || _root_url.isRivera) && (0, _permissions2.default)('no_show_product_cost')) {
	          return false;
	        }
	        return true;
	      };
	
	      var columns = [].concat(_toConsumableArray(!_root_url.isLO ? [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }] : []), [{
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: _root_url.isLO ? 160 : 70,
	        filterable: true
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 250,
	        filterable: true
	      }, {
	        key: 'Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 200
	      }, {
	        key: 'PackageSize',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 65,
	        filterable: true,
	        editable: true
	      }], _toConsumableArray(showProductCost() ? [{
	        key: 'CostPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_cost' }),
	        resizable: true,
	        sortable: true,
	        width: 65,
	        filterable: true,
	        editable: true
	      }] : []), [{
	        key: 'NetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_weight' }),
	        resizable: true,
	        sortable: true,
	        width: 65,
	        filterable: true,
	        editable: true
	      }], _toConsumableArray(_root_url.isLO ? [{
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }] : []));
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { className: 'react-table-customizer', id: 'SalesOrderForm-dataGrid4' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              columns: columns,
	              enableRowSelect: 'single',
	              minHeight: 202,
	              headerRowHeight: 45,
	              onGridSort: handleGridSort,
	              onRowClick: onRowClick,
	              onRowSelect: onRowSelect,
	              onRowUpdated: this.handleRowUpdated,
	              rowGetter: rowGetter,
	              rowHeight: 25,
	              rowKey: 'Product_id',
	              rowsCount: getSize(),
	              rowSelection: {
	                onRowsDeselected: onRowsDeselected,
	                onRowsSelected: onRowsSelected,
	                showCheckbox: true,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              }
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderPaymentInfo',
	    value: function renderPaymentInfo() {
	      var _this41 = this;
	
	      var _state3 = this.state,
	          paymentInfo = _state3.paymentInfo,
	          chargeID = _state3.chargeID,
	          paymentMethod = _state3.paymentMethod;
	
	      if (isAFG && paymentMethod === "ACH" && paymentInfo) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account_name' }),
	              ':'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'label',
	              null,
	              paymentInfo.NameOnAccount
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account_number' }),
	              ':'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'label',
	              null,
	              paymentInfo.AccountNum
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'routing_number' }),
	              ':'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'label',
	              null,
	              paymentInfo.Routing
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'success',
	                onClick: function onClick() {
	                  _this41.openAchEdit();
	                },
	                style: { marginTop: '10px' }
	              },
	              'Edit ACH Info'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            '\xA0'
	          )
	        );
	      }
	      if (!paymentInfo || !chargeID) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no_payment_record' })
	          )
	        );
	      }
	      return _react2.default.createElement(_MSOPaymentInfo2.default, {
	        info: paymentInfo,
	        totalPrice: this.state.totalPrice,
	        credit: this.state.creditAmount,
	        Billing: this.props.currentSalesOrderDetail.Billing,
	        orderID: this.props.params.id,
	        openConfirmRefund: this.openConfirmRefund.bind(this)
	      });
	    }
	  }, {
	    key: 'renderAutoSuggest',
	    value: function renderAutoSuggest() {
	      var _this42 = this;
	
	      return _react2.default.createElement(_SalesOrderAutoSuggest2.default, {
	        CustomerNumber: this.state.currentCustomer,
	        handleFocusQty: this.handleFocusQty,
	        handleKeyPress: this.handleKeyPress,
	        onChange: function onChange(e, _ref21) {
	          var newValue = _ref21.newValue;
	          _this42.clearInventoryInfo();_this42.props.resetFormInputs();_this42.setState({ suggestValue: newValue });
	        },
	        SearchType: this.props.searchType,
	        Group: this.props.group,
	        setAllProductQuantity: this.setAllProductQuantity,
	        value: this.state.suggestValue
	      });
	    }
	  }, {
	    key: 'getUsers',
	    value: function getUsers() {
	      var Users = [];
	      this.props.users.map(function (user) {
	        Users.push({ value: user.user_id, label: user.username });
	      });
	      return Users;
	    }
	  }, {
	    key: 'renderUsers',
	    value: function renderUsers() {
	      if (this.props.usersIsLoading) return _react2.default.createElement(_spinner2.default, null); // If group is loading, show a spinner.
	      var Users = this.getUsers();
	      return _react2.default.createElement(_reduxForm.Field, { name: 'Sales_User_id', component: _selection.Selection, options: Users });
	    }
	  }, {
	    key: 'renderDeliveryMethodInfo',
	    value: function renderDeliveryMethodInfo() {
	      if (this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id') {
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delivery_method' }),
	            ':'
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              id: 'delivery-method-button',
	              type: 'button',
	              onClick: this.openDeliveryMethodModal
	            },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'details' })
	          )
	        );
	      }
	      return _react2.default.createElement('div', { style: { margin: isChinaTown ? '0' : '105px' } });
	    }
	  }, {
	    key: 'renderDiscountAmount',
	    value: function renderDiscountAmount() {
	      var _this43 = this;
	
	      if (this.context.router.routes[1].path === 'mobileSalesOrders/:id') {
	        var _state4 = this.state,
	            discount = _state4.discount,
	            totalPrice = _state4.totalPrice;
	        var savings = this.props.savings;
	        /**
	         * @discount is greater than 0, if the promo is a 'percent off' type
	         * @discount is equal to 0, if the promo is a 'dollar off' type
	         */
	
	        var savingsValue = parseFloat(discount) === 0 ? (0, _NumberUtil.roundTo)(parseFloat(savings || 0), 2).toFixed(2) : (0, _NumberUtil.roundTo)(parseFloat(totalPrice || 0) * (parseFloat(discount || 0) / 100), 2).toFixed(2);
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disc' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'dollar-sign' },
	              '$'
	            )
	          ),
	          _react2.default.createElement(_reactBootstrap.Input, {
	            type: 'text',
	            value: savingsValue,
	            disabled: true
	          })
	        );
	      }
	      if (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
	        var _state5 = this.state,
	            SODiscount = _state5.SODiscount,
	            SOSavings = _state5.SOSavings;
	
	        var _savingsValue = parseFloat(SODiscount) + "%/" + (0, _NumberUtil.roundTo)(parseFloat(SOSavings || 0), 2).toFixed(2) + "$";
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disc' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'dollar-sign' },
	              '(%/$)'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { onDoubleClick: function onDoubleClick() {
	                _this43.openVerifyPasscodeDiscount();
	              }, style: { width: '65px', borderRadius: '3px', padding: '2px 5px', border: '1px solid black', backgroundColor: '#dddddd' } },
	            _savingsValue
	          )
	        );
	      }
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(yourOrderKey) {
	      this.clearInventoryInfo();
	      this.setState({
	        selectedInventoryRow: {},
	        inStock: '',
	        purchased: '',
	        presale: '',
	        net_weight: '',
	        suggestValue: ''
	      });
	      this.props.resetFormInputs();
	      switch (yourOrderKey) {
	        case 1:
	          this.setState({ yourOrderTableHeight: window.innerHeight < 930 ? 345 : 345, yourOrderKey: yourOrderKey });
	          break;
	        default:
	          this.setState({ yourOrderTableHeight: window.innerHeight < 930 ? 200 : 200, yourOrderKey: yourOrderKey });
	      }
	    }
	  }, {
	    key: 'handleSelect2',
	    value: function handleSelect2(inboundInfoKey) {
	      // this.clearInventoryInfo();
	      // this.setState({
	      //   selectedInventoryRow: {},
	      //   inStock: '',
	      //   purchased: '',
	      //   presale: '',
	      //   net_weight: '',
	      //   suggestValue: '',
	      // });
	      // this.props.resetFormInputs();
	      switch (inboundInfoKey) {
	        case 1:
	          this.setState({ inboundInfoKey: inboundInfoKey });
	          break;
	        default:
	          this.setState({ inboundInfoKey: inboundInfoKey });
	      }
	    }
	  }, {
	    key: 'handleSelect3',
	    value: function handleSelect3(fjInfoKey) {
	      // this.clearInventoryInfo();
	      // this.setState({
	      //   selectedInventoryRow: {},
	      //   inStock: '',
	      //   purchased: '',
	      //   presale: '',
	      //   net_weight: '',
	      //   suggestValue: '',
	      // });
	      // this.props.resetFormInputs();
	      switch (fjInfoKey) {
	        case 1:
	          this.setState({ fjInfoKey: fjInfoKey });
	          break;
	        default:
	          this.setState({ fjInfoKey: fjInfoKey });
	      }
	    }
	  }, {
	    key: 'fetchPreviousSalesOrderByIndexFromLast',
	    value: function fetchPreviousSalesOrderByIndexFromLast() {
	      this.props.fetchPreviousSalesOrderByIndexFromLast(this.state.currentCustomer, this.state.salesOrderIndexFromLast);
	    }
	  }, {
	    key: 'fetchPreviousSalesOrderByCustomer',
	    value: function fetchPreviousSalesOrderByCustomer() {
	      this.props.fetchPreviousSalesOrderByCustomer(this.state.currentCustomer, this.state.fromDate, this.state.toDate);
	    }
	  }, {
	    key: 'fetchPreviousOrdersFromALLSalesOrder',
	    value: function fetchPreviousOrdersFromALLSalesOrder() {
	      this.props.fetchPreviousOrdersFromALLSalesOrder(this.state.currentCustomer, this.state.fromDate, this.state.toDate);
	    }
	  }, {
	    key: 'fetchPreviousOrderBySearch',
	    value: function fetchPreviousOrderBySearch(SONum) {
	      this.props.fetchPreviousOrderBySearch(SONum);
	    }
	  }, {
	    key: 'getPreviousSalesOrder',
	    value: function getPreviousSalesOrder() {
	      var nextIndex = this.state.salesOrderIndexFromLast - 1;
	      if (nextIndex < 1) nextIndex = 1;
	      this.setState({
	        salesOrderIndexFromLast: nextIndex
	      }, this.fetchPreviousSalesOrderByIndexFromLast);
	    }
	  }, {
	    key: 'getNextSalesOrder',
	    value: function getNextSalesOrder() {
	      var nextIndex = this.state.salesOrderIndexFromLast + 1;
	      this.setState({
	        salesOrderIndexFromLast: nextIndex
	      }, this.fetchPreviousSalesOrderByIndexFromLast);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this44 = this;
	
	      var dispNetWeight = 0.00;
	      var dispShippingWeight = 0.00;
	      if (this.props.currentSalesOrder && this.props.currentSalesOrder.FinalNetWeight) {
	        dispNetWeight = Number(this.props.currentSalesOrder.FinalNetWeight).toFixed(2);
	      }
	      if (this.props.currentSalesOrder && this.props.currentSalesOrder.FinalShippingWeight) {
	        dispShippingWeight = Number(this.props.currentSalesOrder.FinalShippingWeight).toFixed(2);
	      }
	      var createDialogInventoryStyle = {
	        height: '700px',
	        width: '1000px',
	        marginLeft: '-28%',
	        marginTop: '-20%'
	      };
	      var createDialogShippingStyle = {
	        height: '780px',
	        width: window.innerWidth * 4 / 5,
	        marginLeft: '-35%',
	        marginTop: '-22%',
	        top: '60%'
	      };
	      var maxDate = new Date();
	      if (this.props.createTime) {
	        maxDate = new Date(this.props.createTime);
	      }
	      var minDate = new Date();
	      if (this.props.orderDate) {
	        minDate = new Date(this.props.orderDate);
	      }
	      var route = null;
	      var newRoute = null;
	      var breadcrumbTitle = null;
	      if (this.context.router.routes[1].path == 'salesOrders/new' || this.context.router.routes[1].path == 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
	        route = '/salesOrders';
	        newRoute = '/salesOrders/new';
	        breadcrumbTitle = 'sales_orders';
	      } else if (this.context.router.routes[1].path == 'mobileSalesOrders/new' || this.context.router.routes[1].path == 'mobileSalesOrders/:id') {
	        route = '/mobileSalesOrders';
	        newRoute = '/mobilSalesOrders/new';
	        breadcrumbTitle = 'mobile_sales_orders';
	      }
	      var selectInventoryInformation = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_inventory_information' });
	      var confirmAction = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm_action' });
	      var openSalesOrder = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'open_sales_order' });
	      var customerSalesHistory = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_sales_history' });
	      var _props6 = this.props,
	          handleSubmit = _props6.handleSubmit,
	          submitting = _props6.submitting,
	          pristine = _props6.pristine,
	          isEditing = _props6.isEditing,
	          isCreating = _props6.isCreating;
	
	      var allInventoryProducts = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all_products' });
	      var customerInformation = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_info' });
	      var orderInformation = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_info' });
	      var drayageInformation = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'drayage_info' });
	      var generalInformation = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general' });
	      var pickdropInformation = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickdrop' });
	      var frequentProducts = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'frequent_products' });
	      var inboundProducts = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inbound_products' });
	      var previousOrderList = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'previous_orders' });
	      var SODetails = _react2.default.createElement(_reactReduxI18n.Translate, { value: isWIZ || isJTB || isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isFJ ? "details" : "so_details" });
	      var CheckoutInfo = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_info' });
	      var changeTax = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'choose_tax_rate' });
	      var changeDiscountTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'change_discount_rates' });
	      var changeWeight = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'change_ship_weight' });
	      var changeEmployeeNoteTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'change_employee_note' });
	      var editAchTitle = "Edit ACH Info";
	      var changeCarrierInfo = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'change_carrier_info' });
	      var changeDeliveryFeeTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'change_delivery_fee' });
	      var editSOPermission = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'permission_for_editing_price_and_quantity' });
	      var confirmRefund = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_confirm_refund_order' });
	      var passcodeConfirm = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'passcode_confirm' });
	      var favoriteList = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'favorites_list' });
	      var ModalHeader = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'your_sales_order_has_been_saved' });
	      var expressInvoiceHeader = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_order_express_invoice' });
	      var customerNote = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust' });
	      var employeeNote = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'emp' });
	      var routeNote = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'route' });
	      var prefilledNote = this.props.salesCustomerDetails && this.props.salesCustomerDetails.Notation ? this.props.salesCustomerDetails.Notation : '';
	      var activeBreadcrumb = this.state.salesOrderNumber ? 'edit_sales_order' : 'create_sales_order';
	      if (isWIZ || isJTB || isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isFJ) {
	        if (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
	          activeBreadcrumb = this.state.salesOrderNumber ? 'edit_outbound_order' : 'create_outbound_order';
	        } else {
	          activeBreadcrumb = this.state.salesOrderNumber ? 'edit_inbound_order' : 'create_inbound_order';
	        }
	      }
	      var currentDate = new Date();
	      var tomorrow = currentDate;
	      var showProductCost = function showProductCost() {
	        if (isJML || (isChinaTown || _root_url.isRivera) && (0, _permissions2.default)('no_show_product_cost')) {
	          return false;
	        }
	        return true;
	      };
	
	      var jtbReceiveTypeOptions = [{ label: "Unit", value: "unit" }, { label: "Container", value: "container" }];
	
	      var jtbReceiveUnitOptions = [{ label: "pallet", value: "pallet" }, { label: "box", value: "box" }, { label: "piece", value: "piece" }];
	
	      var jtbDropshipTypeOptions = [{ label: "By Weight", value: "weight" }, { label: "By Piece", value: "piece" }];
	
	      var jtbContainerSizeOptions = [{ label: "20HQ", value: "20HQ" }, { label: "40HQ", value: "40HQ" }];
	
	      var kdwContainerSizeOptions = [{ label: "40", value: "40" }, { label: "45", value: "45" }];
	
	      var abcffContainerSizeOptions = [{ label: "20'", value: "20'" }, { label: "40'", value: "40'" }, { label: "40' HC", value: "40' HC" }, { label: "45'", value: "45'" }];
	
	      var jtbOrderTypeOptions = [{ label: "FBA", value: "FBA" }, { label: "Drop Shipping", value: "Drop Shipping" }];
	
	      var kdwOrderTypeOptions = [{ label: "Drayage Only", value: "DrayageOnly" }, { label: "Devanning Only", value: "DevanningOnly" }, { label: "Drayage & Devanning", value: "DrayageAndDevanning" }];
	
	      var timeOptions = [{ label: "00:00", value: "00:00" }, { label: "01:00", value: "01:00" }, { label: "02:00", value: "02:00" }, { label: "03:00", value: "03:00" }, { label: "04:00", value: "04:00" }, { label: "05:00", value: "05:00" }, { label: "06:00", value: "06:00" }, { label: "07:00", value: "07:00" }, { label: "08:00", value: "08:00" }, { label: "09:00", value: "09:00" }, { label: "10:00", value: "10:00" }, { label: "11:00", value: "11:00" }, { label: "12:00", value: "12:00" }, { label: "13:00", value: "13:00" }, { label: "14:00", value: "14:00" }, { label: "15:00", value: "15:00" }, { label: "16:00", value: "16:00" }, { label: "17:00", value: "17:00" }, { label: "18:00", value: "18:00" }, { label: "19:00", value: "19:00" }, { label: "20:00", value: "20:00" }, { label: "21:00", value: "21:00" }, { label: "22:00", value: "22:00" }, { label: "23:00", value: "23:00" }];
	
	      tomorrow.setDate(tomorrow.getDate() + 1);
	      var createDialogStyle = {
	        width: '600px',
	        marginLeft: '-15%'
	      };
	      var createDiscountDialogStyle = {
	        width: '450px',
	        height: '200px',
	        marginLeft: '-10%'
	      };
	      var createWeightDialogStyle = {
	        width: '500px',
	        height: '300px',
	        marginLeft: '-10%'
	      };
	      var createNoteDialogStyle = {
	        width: '500px',
	        height: '250px',
	        marginLeft: '-10%'
	      };
	      var editAchDialogStyle = {
	        width: '350px',
	        height: '320px',
	        marginLeft: '-10%'
	      };
	      var editLocationDialogStyle = {
	        width: '700px',
	        height: '250px',
	        marginLeft: '-10%'
	      };
	      var changeCarrierInfoStyle = {
	        width: '500px',
	        height: '400px',
	        marginLeft: '-10%'
	      };
	      var changeFBAStyle = {
	        width: '500px',
	        height: '350px',
	        marginLeft: '-10%'
	      };
	      var ShippingInfoConfirmModalStyle = {
	        width: '500px',
	        height: '200px',
	        marginLeft: '-10%'
	      };
	      var BatchesModal2Style = {
	        width: '600px',
	        height: '200px',
	        marginLeft: '-10%'
	      };
	      var MultiBatchModalStyle = {
	        width: '600px',
	        height: '500px',
	        marginLeft: '-10%'
	      };
	      var MultiBatchStyle = {
	        width: '690px',
	        height: '500px',
	        marginLeft: '-10%'
	      };
	      var changeDeliveryDialogStyle = {
	        width: '450px',
	        height: '230px',
	        marginLeft: '-10%'
	      };
	      var createDeliveryModalDialogStyle = {
	        width: '500px',
	        marginLeft: '-10%'
	        // currentSalesOrderDetail
	      };var _state6 = this.state,
	          Shipping = _state6.Shipping,
	          Billing = _state6.Billing,
	          ShipTo = _state6.ShipTo,
	          groupOptions = _state6.groupOptions;
	
	
	      var handleZoneChange = function handleZoneChange(el) {
	        var zoneSelected = el.value;
	        var zoneDisplay = el.label;
	
	        var binSelected = null;
	        var binDisplay = "";
	        var binOptions = [];
	        var levelSelected = null;
	        var levelDisplay = "";
	        var levelOptions = [];
	
	        _this44.setState({
	          zoneSelected: zoneSelected,
	          zoneDisplay: zoneDisplay,
	          binSelected: binSelected,
	          binDisplay: binDisplay,
	          binOptions: binOptions,
	          levelSelected: levelSelected,
	          levelDisplay: levelDisplay,
	          levelOptions: levelOptions
	        });
	
	        // let binOptions = [];
	        _axios2.default.get(_url.ZONES_URL + el.value + "/section/", {
	          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	          if (response && response.data) {
	            response.data.map(function (r) {
	              binOptions.push({ label: r.section_num, value: r.id });
	            });
	          }
	          _this44.setState({ binOptions: binOptions });
	        }, function (err) {
	          if (err.status === 500 || err.status === 404) {
	            err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	          }
	          alert(JSON.stringify(err.data));
	        });
	      };
	      var handleBinChange = function handleBinChange(el) {
	        var binSelected = el.value;
	        var binDisplay = el.label;
	        var levelSelected = null;
	        var levelDisplay = "";
	        var levelOptions = [];
	
	        _this44.setState({
	          binSelected: binSelected,
	          binDisplay: binDisplay,
	          levelSelected: levelSelected,
	          levelDisplay: levelDisplay,
	          levelOptions: levelOptions
	        });
	
	        // let levelOptions = [];
	        _axios2.default.get(_url.WAREHOUSES_URL + "/section/" + el.value + "/bin/", {
	          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	          if (response && response.data) {
	            response.data.map(function (r) {
	              levelOptions.push({ label: r.bin_num, value: r.id });
	            });
	          }
	          _this44.setState({ levelOptions: levelOptions });
	        }, function (err) {
	          if (err.status === 500 || err.status === 404) {
	            err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	          }
	          alert(JSON.stringify(err.data));
	        });
	      };
	      var handleLevelChange = function handleLevelChange(el) {
	        var levelSelected = el.value;
	        var levelDisplay = el.label;
	        _this44.setState({ levelSelected: levelSelected, levelDisplay: levelDisplay });
	      };
	
	      if (this.props.detailIsLoading && !this.props.detailError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement('br', null),
	        '...',
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reading_data' })
	      );else if (this.props.detailError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.error)
	        )
	      );
	      // const finalPrice = (this.state.finalPrice).toFixed(2);
	      var _state7 = this.state,
	          discount = _state7.discount,
	          finalPrice = _state7.finalPrice,
	          totalPrice = _state7.totalPrice,
	          totalCRV = _state7.totalCRV,
	          totalTax = _state7.totalTax,
	          taxValue = _state7.taxValue;
	      var savings = this.props.savings;
	
	      var totalTaxWithPromotion = (0, _NumberUtil.calculateTax)(this.state.rows, discount, parseFloat(taxValue) / 100);
	      // let finalPriceWithPromotion = 0;
	      if ((isMyumyu || isAFG || isWecom || isAFM || _root_url.isEcity || _root_url.isElegant) && this.props.currentSalesOrder && this.props.currentSalesOrder.SONum && this.props.currentSalesOrder.SONum.charAt(0) === 'M') {
	        if (this.props.currentSalesOrder && this.props.currentSalesOrder.GrandTotal) {
	          this.state.finalPriceWithPromotion = this.props.currentSalesOrder.FinalPrice;
	        }
	      } else {
	        // this.state.finalPriceWithPromotion = calculateSavings(discount, (savings || 0), totalPrice, totalCRV, totalTaxWithPromotion, this.state.delivery);
	        // this.state.finalPriceWithPromotion = calculateSavings(discount, (savings || 0), totalPrice, totalCRV, totalTax, this.state.delivery) - this.state.creditAmount;
	        if (this.props.currentSalesOrderDetail && this.props.currentSalesOrderDetail.Payment_Information) {
	          this.state.finalPriceWithPromotion = (0, _NumberUtil.calculateSavings)(discount, savings || 0, totalPrice, totalCRV, totalTax, this.state.delivery) - this.state.creditAmount - this.state.shareCreditAmount + this.state.fee;
	        } else if (this.props.currentSalesOrderDetail && !this.props.currentSalesOrderDetail.Payment_Information) {
	          // this.state.finalPriceWithPromotion = this.props.currentSalesOrder.GrandTotal - this.state.creditAmount;
	          this.state.finalPriceWithPromotion = (0, _NumberUtil.calculateSavings)(discount, savings || 0, totalPrice, totalCRV, totalTax, this.state.delivery) - this.state.creditAmount - this.state.shareCreditAmount + this.state.fee;
	        }
	      }
	      if (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
	        if (Number(this.state.SODiscount) > 0) {
	          if (_root_url.isElegant) {
	            totalTaxWithPromotion = totalTax;
	          } else {
	            totalTaxWithPromotion = totalTax - totalTax * (Number(this.state.SODiscount) / 100);
	          }
	          this.state.finalPriceWithPromotion = Number(totalPrice) - Number(totalPrice) * (Number(this.state.SODiscount) / 100) + totalTaxWithPromotion + this.state.delivery;
	        } else if (Number(this.state.SODiscount) === 0 && Number(this.state.SOSavings) > 0) {
	          totalTaxWithPromotion = totalTax;
	          this.state.finalPriceWithPromotion = Number(totalPrice) - Number(this.state.SOSavings) + totalTaxWithPromotion + this.state.delivery;
	        } else {
	          totalTaxWithPromotion = totalTax;
	          this.state.finalPriceWithPromotion = Number(totalPrice) + totalTaxWithPromotion + this.state.delivery;
	        }
	        this.state.finalPriceWithPromotion = this.state.finalPriceWithPromotion.toFixed(2);
	      }
	
	      if (this.state && this.state.finalPriceWithPromotion > 0) {
	        this.state.finalPriceWithPromotion = Number(this.state.finalPriceWithPromotion).toFixed(2);
	      }
	
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'form',
	            { autoComplete: 'off', method: 'get', action: '#', onSubmit: handleSubmit(isHMM ? this.handleHMMFormSubmit : this.handleFormSubmit) },
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb,
	              { style: this.state.crumbStyle },
	              _react2.default.createElement(
	                _reactBootstrap.Breadcrumb.Item,
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_management' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Breadcrumb.Item,
	                null,
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: route },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: isWIZ || isJTB || isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isFJ ? "orders" : "sales_orders" })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Breadcrumb.Item,
	                { active: 'true' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: activeBreadcrumb })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { id: 'breadcrumbButtonGroup' },
	              !isABCFF && _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  type: 'button',
	                  onClick: handleSubmit(function (data) {
	                    var quote = true;
	                    _this44.handleFormSubmit(data, quote);
	                  }),
	                  disabled: !(0, _permissions2.default)('add_sales_quote') || this.handleSaveDisable() //revert risk high
	                  // disabled={((this.state.rows.length === 0) || (this.state.Released) || (this.props.salesOrderIsCreating))}
	                },
	                _react2.default.createElement('em', { className: 'fa fa-save' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_sales_quote' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  type: 'button',
	                  onClick: handleSubmit(function (data) {
	                    if (isHMM) {
	                      _this44.handleHMMFormSubmit(data);
	                    } else {
	                      _this44.handleFormSubmit(data);
	                    }
	                  }),
	                  disabled: this.handleSaveDisable() //revert risk high
	                  // disabled={((this.state.rows.length === 0) || (this.state.Released) || (this.props.salesOrderIsCreating))}
	                },
	                _react2.default.createElement('em', { className: 'fa fa-save' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	              ),
	              !isABCFF && _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'primary',
	                  type: 'button',
	                  onClick: this.openHistory,
	                  disabled: this.state.currentCustomer === null
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_sales_history' })
	              ),
	              isABC && this.renderShippingStatsEdit(),
	              !isFJ && !isJTB && !isABCFF && this.renderExpressInvoice(),
	              isFJ && this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id' && this.renderExpressInvoice(),
	              !isWIZ && !isABCFF && this.renderDropshipButton(),
	              !isABCFF && this.renderPrint(),
	              !isABCFF && this.renderPrintPL(),
	              !isABCFF && this.renderPrintPaL(),
	              !isABCFF && this.renderPrintSL(),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  type: 'button',
	                  onClick: function onClick() {
	                    if (_this44.context.router.routes[1].path === 'outboundOrders/new' || _this44.context.router.routes[1].path === 'outboundOrders/:id') {
	                      _this44.context.router.push('/outboundOrders');
	                    } else {
	                      _this44.context.router.push(route);
	                    }
	                  }
	                },
	                _react2.default.createElement('em', { className: 'fa fa-close' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Grid,
	              { id: 'sales-order-form' },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 10 },
	                  !(isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB || isMAG) && _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    this.customerHeader(),
	                    _react2.default.createElement(
	                      'fieldset',
	                      { className: 'form-horizontal' },
	                      _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        {
	                          id: 'sales-order-customer-info',
	                          className: this.getPanelClassName()
	                        },
	                        _react2.default.createElement(
	                          _reactBootstrap.Row,
	                          null,
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            !isABC && this.renderCustomerDetail(),
	                            isABC && this.renderCustomerDetailABC(),
	                            !isTN && _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 5, id: 'billing-info' },
	                              _react2.default.createElement(
	                                'h4',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'billing_information' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-3' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'contact' })
	                                ),
	                                !Billing && _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-9' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_a_customer' }),
	                                  ' '
	                                ),
	                                Billing && _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-xs-9' },
	                                  Billing.FirstName,
	                                  Billing.LastName
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-3' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	                                ),
	                                Billing && _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-xs-9' },
	                                  Billing.Telephone
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group mb0' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-3' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' })
	                                ),
	                                Billing && _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-xs-9' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    Billing.Street
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    Billing.City,
	                                    ', ',
	                                    Billing.State,
	                                    ' ',
	                                    Billing.Zip
	                                  )
	                                )
	                              )
	                            ),
	                            isTN && _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 5, id: 'billing-info-tn' },
	                              _react2.default.createElement(
	                                'h4',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_information' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-4' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cpo_num' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-xs-8' },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'CPONum', component: _inputField.InputField })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-4' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-xs-8' },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'RefNum', component: _inputField.InputField })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-4' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_type' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-xs-8' },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'Type', component: _inputField.InputField })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-4' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'client' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-xs-8' },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'ClientCustName', component: _inputField.InputField })
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            !isABC && this.renderShippingAddressSelections(),
	                            isABC && this.renderShippingAddressSelectionsABC(),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6, id: 'so-dates' },
	                              _react2.default.createElement(
	                                'h4',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: isWIZ || isJTB || isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isFJ ? "order_dates" : "sales_order_dates" })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-4' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-xs-8' },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'OrderDate', selected: this.state.prevEstDate, component: _datePicker.DatePicker })
	                                )
	                              ),
	                              !isATL && !isRS && !_root_url.isUSPride && !isDSQ && !_root_url.isWUFS && !isABCFF && !isKDW && !isYI && !isFBD && !isWIZ && !isFJ && !isJTB && _react2.default.createElement(
	                                'div',
	                                { className: 'form-group', style: { backgroundColor: isChinaTown ? '#FFECB3' : 'inherit', display: 'flex', alignItems: 'center' } },
	                                !isTN && _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-4', style: { color: isChinaTown ? 'red' : 'black' } },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_delivery' })
	                                ),
	                                isTN && _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-4' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_date' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-xs-8' },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'DispatchDate', selected: this.state.prevEstDate, component: _datePicker.DatePicker })
	                                )
	                              ),
	                              _root_url.isSY && _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-4' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_type' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-xs-8' },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'SalesOrderTypeSy', matchPos: 'any', component: _selection.Selection, options: this.state.SalesOrderTypeSyOptions })
	                                )
	                              ),
	                              isOCM && _react2.default.createElement(
	                                'div',
	                                { className: 'form-group', style: { backgroundColor: 'inherit', display: 'flex', alignItems: 'center' } },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-4' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_start' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { id: 'customer-name-dropdown', className: 'col-xs-8' },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'DispatchStartTime', component: _selection.Selection, options: timeOptions })
	                                )
	                              ),
	                              isOCM && _react2.default.createElement(
	                                'div',
	                                { className: 'form-group', style: { backgroundColor: 'inherit', display: 'flex', alignItems: 'center' } },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-4' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_end' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { id: 'customer-name-dropdown', className: 'col-xs-8' },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'DispatchEndTime', component: _selection.Selection, options: timeOptions })
	                                )
	                              ),
	                              isFung && _react2.default.createElement(
	                                'div',
	                                { className: 'form-group', style: { backgroundColor: isChinaTown ? '#FFECB3' : 'inherit', display: 'flex', alignItems: 'center' } },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-4' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-xs-8' },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'PONum', className: 'PONum-no-highlight', component: _inputField.InputField })
	                                )
	                              ),
	                              (isTN || _root_url.isUSPride || isATL || isRS) && _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-4' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_by' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-xs-8' },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'ShipByDate', selected: this.state.prevEstDate, component: _datePicker.DatePicker })
	                                )
	                              ),
	                              isDHC && _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-4' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'seller' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'col-xs-8' },
	                                  this.renderUsers()
	                                )
	                              ),
	                              isBobaLife && _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-4' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'is_no_reduce' })
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'IsNoReduce', disabled: this.props.currentSalesOrder, checked: this.state.IsNoReduce, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                    _this44.setState({ IsNoReduce: !_this44.state.IsNoReduce });
	                                  } })
	                              ),
	                              isChinaTown && _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-4' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_method' })
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'ShippingMethod', component: pickShippingMethod })
	                              ),
	                              isTQ && _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'company' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'Company_id',
	                                      component: _selection.Selection,
	                                      options: this.state.companyOptions })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_po' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { className: 'PONum-no-highlight', name: 'PONum', component: _inputField.InputField })
	                                  )
	                                )
	                              ),
	                              isABC && this.renderNotesEditButton()
	                            ),
	                            ' '
	                          )
	                        ),
	                        ' '
	                      )
	                    )
	                  ),
	                  (isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB || isMAG) && _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    !isMAG && this.inboundInformationHeader(),
	                    isMAG && _react2.default.createElement(
	                      'h2',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_information' })
	                    ),
	                    _react2.default.createElement(
	                      'fieldset',
	                      { className: 'form-horizontal' },
	                      _react2.default.createElement(
	                        _reactBootstrap.Tabs,
	                        { activeKey: this.state.inboundInfoKey, justified: true, onSelect: this.handleSelect2 },
	                        _react2.default.createElement(
	                          _reactBootstrap.Tab,
	                          { eventKey: 1, title: customerInformation },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { style: { minHeight: '150px' } },
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6, style: { minHeight: '150px' } },
	                              !isABC && this.renderCustomerDetail(),
	                              isABC && this.renderCustomerDetailABC(),
	                              !isTN && _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5, id: 'billing-info' },
	                                _react2.default.createElement(
	                                  'h4',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'billing_information' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'contact' })
	                                  ),
	                                  !Billing && _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'please_select_a_customer' }),
	                                    ' '
	                                  ),
	                                  Billing && _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    Billing.FirstName,
	                                    Billing.LastName
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	                                  ),
	                                  Billing && _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    Billing.Telephone
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group mb0' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'address' })
	                                  ),
	                                  Billing && _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      null,
	                                      Billing.Street
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      null,
	                                      Billing.City,
	                                      ', ',
	                                      Billing.State,
	                                      ' ',
	                                      Billing.Zip
	                                    )
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              !isABC && this.renderShippingAddressSelections(),
	                              isABC && this.renderShippingAddressSelectionsABC(),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6, id: 'so-dates' },
	                                _react2.default.createElement(
	                                  'h4',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: isWIZ || isJTB || isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isFJ ? "order_dates" : "sales_order_dates" })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-4' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-8' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'OrderDate', selected: this.state.prevEstDate, component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                !isATL && !isRS && !_root_url.isUSPride && !isDSQ && !_root_url.isWUFS && !isABCFF && !isKDW && !isYI && !isFBD && !isWIZ && !isFJ && !isJTB && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  !isTN && _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-4' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_delivery' })
	                                  ),
	                                  isTN && _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-4' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_date' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-8' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DispatchDate', selected: this.state.prevEstDate, component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                isABC && this.renderNotesEditButton(),
	                                (isTN || _root_url.isUSPride || isATL || isRS) && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-4' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_by' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-8' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ShipByDate', selected: this.state.prevEstDate, component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                isDHC && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-4' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'seller' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-8' },
	                                    this.renderUsers()
	                                  )
	                                ),
	                                isBobaLife && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-4' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'is_no_reduce' })
	                                  ),
	                                  _react2.default.createElement(_reduxForm.Field, {
	                                    name: 'IsNoReduce',
	                                    disabled: this.props.currentSalesOrder,
	                                    checked: this.state.IsNoReduce,
	                                    component: _CheckboxFormatter2.default,
	                                    handleOnClick: function handleOnClick() {
	                                      _this44.setState({ IsNoReduce: !_this44.state.IsNoReduce });
	                                    }
	                                  })
	                                )
	                              ),
	                              ' '
	                            )
	                          ),
	                          ' '
	                        ),
	                        isMAG && false && _react2.default.createElement(
	                          _reactBootstrap.Tab,
	                          { eventKey: 2, title: "Container Info" },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_num' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ContainerNum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bol_num' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'bolNum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_line' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'shipping_line', component: _inputField.InputField })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6, style: { paddingLeft: '50px' } },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_size' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'size', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cargo_weight' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'cargo_weight', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'terminal' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'terminal', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'mag_note', component: _inputField.InputField })
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(_reactBootstrap.Col, { xs: 5 }),
	                              _react2.default.createElement(_reactBootstrap.Col, { xs: 6, style: { paddingLeft: '50px' } })
	                            )
	                          )
	                        ),
	                        isYI && _react2.default.createElement(
	                          _reactBootstrap.Tab,
	                          { eventKey: 2, title: orderInformation },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                isDSQ && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'DSQ_ID' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DSQID', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'appointment_time' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Appointment', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'appointment_date' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'AppointmentDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipment_date' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ShipmentDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'isa_num' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ISANum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Warehouse_id', matchPos: 'any', component: _selection.Selection, options: this.state.yiWarehouseOptions })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6, style: { paddingLeft: '50px' } },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ContainerNum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Carrier', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'destination' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DeliverTo', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Port', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'LF_Date' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'LFDate', component: _datePicker.DatePicker })
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_pallets' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'OrderPalletQty', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'loose_qty' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'LooseQty', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    'Direct Ship'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsDirectShip', component: Checkbox })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    'DO'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsDO', component: Checkbox })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    'BOL'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsBOL', component: Checkbox })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    'POD'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsPOD', component: Checkbox })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_empty' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsReturnEmpty', component: Checkbox })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6, style: { paddingLeft: '50px' } },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trucking_co' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'TruckingCo', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'arrival' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ArrivalDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ReturnDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                !(this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_in' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'StorageInDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_out' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'StorageOutDate', component: _datePicker.DatePicker })
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        (isDSQ || _root_url.isWUFS || isFBD) && _react2.default.createElement(
	                          _reactBootstrap.Tab,
	                          { eventKey: 2, title: orderInformation },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                isDSQ && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'DSQ_ID' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DSQID', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'appointment_time' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Appointment', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'appointment_date' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'AppointmentDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'isa_num' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ISANum', component: _inputField.InputField })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6, style: { paddingLeft: '50px' } },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ContainerNum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Carrier', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'destination' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DeliverTo', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Port', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'LF_Date' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'LFDate', component: _datePicker.DatePicker })
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_pallets' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'OrderPalletQty', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    'Direct Ship'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsDirectShip', component: Checkbox })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    'DO'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsDO', component: Checkbox })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    'BOL'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsBOL', component: Checkbox })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    'POD'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsPOD', component: Checkbox })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_empty' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsReturnEmpty', component: Checkbox })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6, style: { paddingLeft: '50px' } },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trucking_co' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'TruckingCo', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'arrival' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ArrivalDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ReturnDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                !(this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_in' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'StorageInDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_out' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'StorageOutDate', component: _datePicker.DatePicker })
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        isABCFF && _react2.default.createElement(
	                          _reactBootstrap.Tab,
	                          { eventKey: 2, title: orderInformation },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ContainerNum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_size' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ContainerSize', component: _selection.Selection, options: abcffContainerSizeOptions })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'isa_num' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ISANum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cpo_num' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'CPONum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'RefNum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tracking_num' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'TrackingNum', component: _inputField.InputField })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6, style: { paddingLeft: '50px' } },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'appointment_time' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Appointment', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'appointment_date' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'AppointmentDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Carrier', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'destination' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DeliverTo', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Port', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'LF_Date' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'LFDate', component: _datePicker.DatePicker })
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_pallets' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'OrderPalletQty', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    'Direct Ship'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsDirectShip', component: Checkbox })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    'DO'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsDO', component: Checkbox })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    'BOL'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsBOL', component: Checkbox })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    'POD'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsPOD', component: Checkbox })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_empty' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsReturnEmpty', component: Checkbox })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6, style: { paddingLeft: '50px' } },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trucking_co' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'TruckingCo', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'arrival' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ArrivalDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ReturnDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                !(this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_in' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'StorageInDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_out' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'StorageOutDate', component: _datePicker.DatePicker })
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        isKDW && _react2.default.createElement(
	                          _reactBootstrap.Tab,
	                          { eventKey: 2, title: orderInformation },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ContainerNum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'devanning' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsDevan', component: Checkbox })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'drayage' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsDrayage', component: Checkbox })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Port', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    'SSL'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'SSL', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'terminal' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'terminal', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    'MBL'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'MBL', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pin' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Pin', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'chassis' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ChassisType', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pierpass' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'PierPass', component: _inputField.InputField })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6, style: { paddingLeft: '50px' } },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_size' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ContainerSize', component: _selection.Selection, options: kdwContainerSizeOptions })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'appointment_time' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Appointment', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'appointment_date' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'AppointmentDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Carrier', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'destination' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DeliverTo', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Port', component: _inputField.InputField })
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_pallets' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'OrderPalletQty', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    'Direct Ship'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsDirectShip', component: Checkbox })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    'DO'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsDO', component: Checkbox })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    'BOL'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsBOL', component: Checkbox })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    'POD'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsPOD', component: Checkbox })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_empty' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsReturnEmpty', component: Checkbox })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6, style: { paddingLeft: '50px' } },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bol_num' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'bolNum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trucking_co' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'TruckingCo', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'arrival' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ArrivalDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ReturnDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                !(this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_in' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'StorageInDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_out' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'StorageOutDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    'ETA'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'delivery_eta', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_free_day' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'LFDate', component: _datePicker.DatePicker })
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        isKDW && _react2.default.createElement(
	                          _reactBootstrap.Tab,
	                          { eventKey: 3, title: drayageInformation },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trailer_num' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'TrailerNum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'drayage_city' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DrayageCity', component: _inputField.InputField })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6, style: { paddingLeft: '50px' } },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_appt' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'PickupApptDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_date' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'PickupDate', component: _datePicker.DatePicker })
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delivery_appt' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DeliveryApptDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delivery_date' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DeliveryDate', component: _datePicker.DatePicker })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6, style: { paddingLeft: '50px' } },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'perdiem_date' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'PerdiemDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yard' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Yard', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port_wait_time' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'PortWaitTime', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_to' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ReturnTo', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'empty_ready_date' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'EmptyReadyDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_date' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ReturnDate', component: _datePicker.DatePicker })
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        isJTB && _react2.default.createElement(
	                          _reactBootstrap.Tab,
	                          { eventKey: 2, title: orderInformation },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_type' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'OrderType', component: _selection.Selection, options: jtbOrderTypeOptions })
	                                  )
	                                ),
	                                this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id' && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_type' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ReceiveType', component: _selection.Selection, options: jtbReceiveTypeOptions })
	                                  )
	                                ),
	                                this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id' && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_unit' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ReceiveUnit', component: _selection.Selection, options: jtbReceiveUnitOptions })
	                                  )
	                                ),
	                                (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5', style: { color: this.state.dropShipWarning ? 'red' : 'black' } },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropship_type' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DropshipType', component: _selection.Selection, options: jtbDropshipTypeOptions })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ContainerNum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_size' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ContainerSize', component: _selection.Selection, options: jtbContainerSizeOptions })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6, style: { paddingLeft: '50px' } },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_route' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'FBARoute', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Carrier', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Port', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    'BOL'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'BOL', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    'POD'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'POD', component: _inputField.InputField })
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'appointment' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Appointment', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trucking_co' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'TruckingCo', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver_to' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DeliverTo', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_empty' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsReturnEmpty', component: Checkbox })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6, style: { paddingLeft: '50px' } },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'arrival' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ArrivalDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ReturnDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_in' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'StorageInDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_out' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'StorageOutDate', component: _datePicker.DatePicker })
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        isWIZ && !(this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && _react2.default.createElement(
	                          _reactBootstrap.Tab,
	                          { eventKey: 2, title: orderInformation },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_num' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ContainerNum', component: _inputField.InputField })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6, style: { paddingLeft: '50px' } },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trailer' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Trailer', component: _inputField.InputField })
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'isa_num' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ISANum', component: _inputField.InputField })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6, style: { paddingLeft: '50px' } },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dl_num' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DLNum', component: _inputField.InputField })
	                                  )
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_size' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ContainerSize', component: _selection.Selection, options: this.state.containerSizeOptions })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(_reactBootstrap.Col, { xs: 6, style: { paddingLeft: '50px' } })
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 10 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    'ISA Notation'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ISANote', component: 'Textarea', className: 'form-control' })
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        isWIZ && (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && _react2.default.createElement(
	                          _reactBootstrap.Tab,
	                          { eventKey: 2, title: orderInformation },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trucker' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Trucker', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'release_date' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ReleaseDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ready_date' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ReadyDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'outbound_date' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'OutboundDate', component: _datePicker.DatePicker })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 5 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'isa_num' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ISANum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipment_id' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ShipmentID', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'destination' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-7' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Destination', component: _inputField.InputField })
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(_reactBootstrap.Col, { xs: 5 }),
	                              _react2.default.createElement(_reactBootstrap.Col, { xs: 6, style: { paddingLeft: '50px' } })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(_reactBootstrap.Col, { xs: 6 }),
	                            _react2.default.createElement(_reactBootstrap.Col, { xs: 6 })
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  (isMAG || isKDW) && _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    this.containerInformationHeader(),
	                    _react2.default.createElement(
	                      'fieldset',
	                      { className: 'form-horizontal' },
	                      _react2.default.createElement(
	                        _reactBootstrap.Tabs,
	                        { activeKey: this.state.fjInfoKey, justified: true, onSelect: this.handleSelect3 },
	                        _react2.default.createElement(
	                          _reactBootstrap.Tab,
	                          { eventKey: 1, title: orderInformation },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6, style: { paddingRight: '25px' } },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'SaleStatus', matchPos: 'any', component: _selection.Selection, options: isKDW ? this.state.kdwStatusOptions : this.state.magStatusOptions })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    'ETA'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'delivery_eta', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_num' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ContainerNum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    'BOL Num'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'bolNum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'terminal' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'terminal', matchPos: 'any', component: _selection.Selection, options: this.state.magTerminalOptions })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    'LFD'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'delivery_lfd', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    'HOLD (Select)'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'mag2FREIGHT_HOLD', checked: this.state.mag2FREIGHT_HOLD, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ mag2FREIGHT_HOLD: !_this44.state.mag2FREIGHT_HOLD });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'Freight Hold'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'mag2CUSTOM_HOLD', checked: this.state.mag2CUSTOM_HOLD, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ mag2CUSTOM_HOLD: !_this44.state.mag2CUSTOM_HOLD });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'Custom Hold'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'mag2PIERPASS_HOLD', checked: this.state.mag2PIERPASS_HOLD, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ mag2PIERPASS_HOLD: !_this44.state.mag2PIERPASS_HOLD });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'Pierpass Hold'
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement('label', { className: 'col-xs-3' }),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'mag2EXAM', checked: this.state.mag2EXAM, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ mag2EXAM: !_this44.state.mag2EXAM });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'Exam'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'mag2CLOSED_AREA', checked: this.state.mag2CLOSED_AREA, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ mag2CLOSED_AREA: !_this44.state.mag2CLOSED_AREA });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'Closed Area'
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    'HOLD (Other)'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DeliveryStatusOther', component: _inputField.InputField })
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6, style: { paddingLeft: '25px' } },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cntr_location' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'cntrLocation', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    'Note (Select)'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'magDryrun', checked: this.state.magDryrun, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ magDryrun: !_this44.state.magDryrun });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'Dryrun'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'magOffhire', checked: this.state.magOffhire, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ magOffhire: !_this44.state.magOffhire });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'Offhire'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'magExtraStop', checked: this.state.magExtraStop, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ magExtraStop: !_this44.state.magExtraStop });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'Extra Stop'
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement('label', { className: 'col-xs-3' }),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'magExam', checked: this.state.magExam, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ magExam: !_this44.state.magExam });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'Exam'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'magExtraDelivery', checked: this.state.magExtraDelivery, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ magExtraDelivery: !_this44.state.magExtraDelivery });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'Extra Delivery'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'magStorage', checked: this.state.magStorage, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ magStorage: !_this44.state.magStorage });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'Storage'
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement('label', { className: 'col-xs-3' }),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'magOverweight', checked: this.state.magOverweight, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ magOverweight: !_this44.state.magOverweight });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'Overweight'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'magDropoff', checked: this.state.magDropoff, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ magDropoff: !_this44.state.magDropoff });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'Dropoff'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'magCongestion', checked: this.state.magCongestion, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ magCongestion: !_this44.state.magCongestion });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'Congestion'
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement('label', { className: 'col-xs-3' }),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'magBobtailFee', checked: this.state.magBobtailFee, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ magBobtailFee: !_this44.state.magBobtailFee });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'Bobtail Fee'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'magPrepull', checked: this.state.magPrepull, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ magPrepull: !_this44.state.magPrepull });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'Prepull'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'magChassisSplit', checked: this.state.magChassisSplit, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ magChassisSplit: !_this44.state.magChassisSplit });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'Chassis Split'
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement('label', { className: 'col-xs-3' }),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'magHandling', checked: this.state.magHandling, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ magHandling: !_this44.state.magHandling });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'Handling Fee'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'magPierpass', checked: this.state.magPierpass, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ magPierpass: !_this44.state.magPierpass });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'Pierpass'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'magAnFee', checked: this.state.magAnFee, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ magAnFee: !_this44.state.magAnFee });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'AN Fee'
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement('label', { className: 'col-xs-3' }),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'magCTF', checked: this.state.magCTF, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ magCTF: !_this44.state.magCTF });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'CTF'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'magFSC', checked: this.state.magFSC, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ magFSC: !_this44.state.magFSC });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'FSC'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'magOther', checked: this.state.magOther, component: _CheckboxFormatter2.default, handleOnClick: function handleOnClick() {
	                                        _this44.setState({ magOther: !_this44.state.magOther });
	                                      } }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      null,
	                                      'Other'
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    'Note (Other)'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'mag_note_other', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'size' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'size', matchPos: 'any', component: _selection.Selection, options: this.state.magSizeOptions })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_line' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'shipping_line', matchPos: 'any', component: _selection.Selection, options: this.state.magShippingLineOptions })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cargo_weight' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'cargo_weight', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'contact_person' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'contact_person', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'contact_email' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'contact_email', component: _inputField.InputField })
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  isFJ && _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    this.generalInformationHeader(),
	                    _react2.default.createElement(
	                      'fieldset',
	                      { className: 'form-horizontal' },
	                      _react2.default.createElement(
	                        _reactBootstrap.Tabs,
	                        { activeKey: this.state.fjInfoKey, justified: true, onSelect: this.handleSelect3 },
	                        _react2.default.createElement(
	                          _reactBootstrap.Tab,
	                          { eventKey: 1, title: orderInformation },
	                          this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id' && _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6, style: { paddingRight: '25px' } },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ContainerNum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Carrier', matchPos: 'any', component: _selection.Selection, options: this.state.fjCarrierOptions })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'broker' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Broker', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'truckload' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Truckload', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'truck_num' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'TruckNum', component: _inputField.InputField })
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6, style: { paddingLeft: '25px' } },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ext_invoice' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ExtInvoiceNum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Dispatch', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'detention_rate' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DetentionRate', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lumper_fee' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'LumperFee', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_space' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'PalletSpace', component: _inputField.InputField })
	                                  )
	                                )
	                              )
	                            )
	                          ),
	                          (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6, style: { paddingRight: '25px' } },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ContainerNum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ext_invoice' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'ExtInvoiceNum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'broker' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Broker', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'truckload' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Truckload', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'truck_num' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'TruckNum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Carrier', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trailer_num' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'TrailerNum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'orders' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'OrdersStuff', component: _inputField.InputField })
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6, style: { paddingLeft: '25px' } },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Dispatch', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'detention_rate' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DetentionRate', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lumper_fee' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'LumperFee', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_space' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'PalletSpace', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver_by_date' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DeliverByDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver_by_time' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DeliverByTime', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    'BOL'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsBOL', component: Checkbox })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    'Seal'
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'IsSeal', component: Checkbox })
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id' &&
	                        // true &&
	                        _react2.default.createElement(
	                          _reactBootstrap.Tab,
	                          { eventKey: 2, title: pickdropInformation },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6, style: { paddingRight: '25px' } },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_driver' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'PickupDriver', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_trailer' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'PickupTrailerNum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_date' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-4' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'PickupDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_time' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'PickupTime', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_street' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'PickupStreet', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_zip' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'PickupZip', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_city' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'PickupCity', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_state' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'PickupState', component: _selection.Selection, options: this.state.stateOptions })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_appt' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'PickupAppt', component: _inputField.InputField })
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6, style: { paddingLeft: '25px' } },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_driver' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DropoffDriver', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_trailer' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DropoffTrailerNum', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_date' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-4' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DropoffDate', component: _datePicker.DatePicker })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_time' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DropoffTime', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_street' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DropoffStreet', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_zip' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DropoffZip', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_city' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DropoffCity', component: _inputField.InputField })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_state' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-5' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DropoffState', component: _selection.Selection, options: this.state.stateOptions })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'form-group' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-3' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_appt' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-9' },
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'DropoffAppt', component: _inputField.InputField })
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  !isMAG && !isABCFF && !(this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    this.productHeader(),
	                    _react2.default.createElement(
	                      'fieldset',
	                      { className: 'form-horizontal' },
	                      _react2.default.createElement(
	                        _reactBootstrap.Tabs,
	                        { activeKey: this.state.yourOrderKey, justified: true, onSelect: this.handleSelect },
	                        _react2.default.createElement(
	                          _reactBootstrap.Tab,
	                          { eventKey: 1, title: allInventoryProducts },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _root_url.isSY && _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                { style: { marginLeft: '-8px' } },
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 2 },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'search-by-max-width' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_group' }),
	                                    ':'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 4 },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'group', component: _selection.Selection, options: groupOptions })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 12 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: isChinaTown ? 5 : 6 },
	                                  _react2.default.createElement(_reduxForm.Field, { name: 'searchType', component: renderTypeRadios }),
	                                  this.renderAutoSuggest()
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: isChinaTown ? 7 : 6, id: 'product-search-outputs' },
	                                  !isDSQ && !_root_url.isWUFS && !isABCFF && !isKDW && !isYI && !isFBD && _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: isChinaTown ? 1 : 2, className: 'pr0' },
	                                    !isWIZ ? _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: isJML ? 'box_qty' : "qty" })
	                                    ) : _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rcvd_qty' })
	                                    ),
	                                    !isJML ? _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'Quantity',
	                                      withRef: true,
	                                      ref: 'quantity',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (_root_url.isRivera && !(0, _permissions2.default)('edit_sales_order_price')) {
	                                          _this44.handleKeyPress('itemNotation', event);
	                                        }
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        if (isHMM && !(0, _permissions2.default)('hmm_so_change_unit_price')) {
	                                          _this44.handleKeyPress('itemNotation', event);
	                                        } else {
	                                          _this44.handleKeyPress('unitPrice', event);
	                                        }
	                                      },
	                                      placeholder: 'must be > 0'
	                                    }) : _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'jmlBox',
	                                      withRef: true,
	                                      ref: 'jmlBox',
	                                      component: _inputField.InputField
	                                      // disabled={this.state.selectedInventoryRow && this.state.selectedInventoryRow.ProductType !== 'Non-Fixed'}
	                                      // normalize={normalizeFourDecimals}
	                                      , onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        _this44.handleKeyPress('unitPrice', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: isAN || isCalco ? 2 : 1, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit' }),
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'dollar-sign' },
	                                        '$$'
	                                      )
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'UnitPrice',
	                                      withRef: true,
	                                      ref: 'unitPrice',
	                                      component: _inputField.InputField,
	                                      disabled: isHMM && !(0, _permissions2.default)('hmm_so_change_unit_price') || _root_url.isRivera && !(0, _permissions2.default)('edit_sales_order_price')
	                                      // normalize={normalizeFourDecimals}
	                                      , onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        // if (isJML && this.state.selectedInventoryRow && this.state.selectedInventoryRow.ProductType === 'Non-Fixed') {
	                                        //   this.handleKeyPress('PackageSize_1', event);
	                                        // } else {
	                                        _this44.handleKeyPress('itemNotation', event);
	                                        // }
	                                      }
	                                    })
	                                  ),
	                                  !isJML && _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'Weight',
	                                      withRef: true,
	                                      ref: 'weight',
	                                      component: _inputField.DisabledInputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (event.charCode === 13) {
	                                          if (!_this44.state.selectedInventoryRow) {
	                                            return;
	                                          }
	                                          _this44.handleFocusAutoSuggest();
	                                          _this44.checkMoveToSo();
	                                        }
	                                      }
	                                    })
	                                  ),
	
	                                  // break point
	                                  showProductCost() && _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2 },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cost' })
	                                    ),
	                                    _react2.default.createElement(
	                                      'span',
	                                      { className: 'dollar-sign' },
	                                      '$$'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: isHMM ? "" : "ProductCost",
	                                      withRef: true,
	                                      ref: 'ProductCost',
	                                      component: _inputField.DisabledInputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (event.charCode === 13) {
	                                          if (!_this44.state.selectedInventoryRow) {
	                                            return;
	                                          }
	                                          _this44.handleFocusAutoSuggest();
	                                          _this44.checkMoveToSo();
	                                        }
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2 },
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Row,
	                                      null,
	                                      _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { xs: 12 },
	                                        _react2.default.createElement(
	                                          'label',
	                                          null,
	                                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'subtotal' })
	                                        )
	                                      ),
	                                      this.renderSubtotal()
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2 },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'itemNotation',
	                                      withRef: true,
	                                      ref: 'itemNotation',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (event.charCode === 13) {
	                                          if (!_this44.state.selectedInventoryRow) {
	                                            return;
	                                          }
	                                          if (!isNumeric(_this44.props.quantityValue) || _this44.props.quantityValue < 0) {
	                                            return;
	                                          }
	
	                                          if (isWIZ) {
	                                            _this44.handleKeyPress('ReceivedQuantity', event);
	                                          } else if (isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD) {
	                                            _this44.handleKeyPress('FBACode', event);
	                                          } else if (isOCM || isTN) {
	                                            var suggestValue = _this44.state.suggestValue;
	
	                                            _this44.setBatchesModalVisibility(true);
	                                          } else if (isJML) {
	                                            _this44.setBatchesModal2Visibility(true);
	                                          } else {
	                                            _this44.handleFocusAutoSuggest();
	                                            _this44.checkMoveToSo();
	                                          }
	                                          // else if (isJTB) {
	                                          //   this.handleKeyPress('PalletQuantity', event);
	                                          // }
	                                        }
	                                      }
	                                    })
	                                  ),
	                                  isTN && _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr1' },
	                                    _react2.default.createElement('div', { style: { height: '23px' } }),
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Button,
	                                      {
	                                        id: 'product-add-button',
	                                        bsStyle: 'success',
	                                        disabled: this.state.selectedInventoryRow.Product_id == null,
	                                        onClick: function onClick() {
	                                          _this44.setMultiBatchModalVisibility(true);
	                                        }
	                                      },
	                                      '+'
	                                    )
	                                  ),
	                                  isChinaTown && _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr1' },
	                                    _react2.default.createElement('div', { style: { height: '23px' } }),
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Button,
	                                      {
	                                        id: 'product-add-button',
	                                        bsStyle: 'success',
	                                        onClick: function onClick() {
	                                          _this44.checkMoveToSo();
	                                        }
	                                      },
	                                      '+'
	                                    )
	                                  )
	                                )
	                              ),
	                              false && _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(_reactBootstrap.Col, { xs: 6 }),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 6 },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_qty' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PalletQuantity',
	                                      withRef: true,
	                                      ref: 'PalletQuantity',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('BoxQuantity', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_qty' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'BoxQuantity',
	                                      withRef: true,
	                                      ref: 'BoxQuantity',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('PieceQuantity', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'piece_qty' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PieceQuantity',
	                                      withRef: true,
	                                      ref: 'PieceQuantity',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (event.charCode === 13) {
	                                          if (!_this44.state.selectedInventoryRow) {
	                                            return;
	                                          }
	                                          _this44.handleFocusAutoSuggest();
	                                          _this44.checkMoveToSo();
	                                        }
	                                      }
	                                    })
	                                  )
	                                )
	                              ),
	                              isYI && _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 6 },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr1' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'FBA Code'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'FBACode',
	                                      withRef: true,
	                                      ref: 'FBACode',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('FBARoute', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'FBA Route'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'FBARoute',
	                                      withRef: true,
	                                      ref: 'FBARoute',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('TrailerNum', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Trailer'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'TrailerNum',
	                                      withRef: true,
	                                      ref: 'TrailerNum',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('POList', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'PO List'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'POList',
	                                      withRef: true,
	                                      ref: 'POList',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('POD', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0', style: { paddingLeft: '20px' } },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { style: { width: '100%' } },
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'POD' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'POD', component: Checkbox })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 6 },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_qty' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'Quantity',
	                                      withRef: true,
	                                      ref: 'quantity',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('BoxLength', event);
	                                      },
	                                      placeholder: 'must be > 0'
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Box L'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'BoxLength',
	                                      withRef: true,
	                                      ref: 'BoxLength',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('BoxWidth', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { style: { minWidth: '40px' } },
	                                      'Box W'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'BoxWidth',
	                                      withRef: true,
	                                      ref: 'BoxWidth',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('BoxHeight', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Box H'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'BoxHeight',
	                                      withRef: true,
	                                      ref: 'BoxHeight',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('BoxVol', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Box CBM'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'BoxVol',
	                                      withRef: true,
	                                      ref: 'BoxVol',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('BoxWeight', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'BoxWeight',
	                                      withRef: true,
	                                      ref: 'BoxWeight',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('WeightUnit', event);
	                                      }
	                                    })
	                                  )
	                                )
	                              ),
	                              (isDSQ || _root_url.isWUFS || isABCFF || isKDW || isFBD) && _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 6 },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr1' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'FBA Code'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'FBACode',
	                                      withRef: true,
	                                      ref: 'FBACode',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('FBARoute', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'FBA Route'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'FBARoute',
	                                      withRef: true,
	                                      ref: 'FBARoute',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('TrailerNum', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Trailer'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'TrailerNum',
	                                      withRef: true,
	                                      ref: 'TrailerNum',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('POList', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'PO List'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'POList',
	                                      withRef: true,
	                                      ref: 'POList',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('POD', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0', style: { paddingLeft: '20px' } },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { style: { width: '100%' } },
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'POD' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'POD', component: Checkbox })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Dim Unit'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'DimUnit',
	                                      withRef: true,
	                                      ref: 'DimUnit',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('quantity', event);
	                                      }
	                                    })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 6 },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_qty' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'Quantity',
	                                      withRef: true,
	                                      ref: 'quantity',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('BoxLength', event);
	                                      },
	                                      placeholder: 'must be > 0'
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Box L'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'BoxLength',
	                                      withRef: true,
	                                      ref: 'BoxLength',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('BoxWidth', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { style: { minWidth: '40px' } },
	                                      'Box W'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'BoxWidth',
	                                      withRef: true,
	                                      ref: 'BoxWidth',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('BoxHeight', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Box H'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'BoxHeight',
	                                      withRef: true,
	                                      ref: 'BoxHeight',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('BoxVol', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Box CBM'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'BoxVol',
	                                      withRef: true,
	                                      ref: 'BoxVol',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('BoxWeight', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'BoxWeight',
	                                      withRef: true,
	                                      ref: 'BoxWeight',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('WeightUnit', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight_unit' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'WeightUnit',
	                                      withRef: true,
	                                      ref: 'WeightUnit',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        if (isKDW) {
	                                          _this44.handleKeyPress('ShipmentID', event);
	                                        } else {
	                                          _this44.handleKeyPress('PalletQuantity', event);
	                                        }
	                                      }
	                                    })
	                                  )
	                                )
	                              ),
	                              isKDW && _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 6 },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr1' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Shipment ID'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'ShipmentID',
	                                      withRef: true,
	                                      ref: 'ShipmentID',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('ServiceType', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Service Type'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'ServiceType',
	                                      withRef: true,
	                                      ref: 'ServiceType',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('ISANum', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'ISA Num'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'ISANum',
	                                      withRef: true,
	                                      ref: 'ISANum',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('CustomerRef', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Cust Ref#'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'CustomerRef',
	                                      withRef: true,
	                                      ref: 'CustomerRef',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('Unloader', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Unloader'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'Unloader',
	                                      withRef: true,
	                                      ref: 'Unloader',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('TruckVendor', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Truck Vendor'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'TruckVendor',
	                                      withRef: true,
	                                      ref: 'TruckVendor',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('PalletQuantity', event);
	                                      }
	                                    })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 6 },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_qty' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PalletQuantity',
	                                      withRef: true,
	                                      ref: 'PalletQuantity',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('PalletLength', event);
	                                      }
	                                      // placeholder="must be > 0"
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Plt L'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PalletLength',
	                                      withRef: true,
	                                      ref: 'PalletLength',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('PalletWidth', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Plt W'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PalletWidth',
	                                      withRef: true,
	                                      ref: 'PalletWidth',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('PalletHeight', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Plt H'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PalletHeight',
	                                      withRef: true,
	                                      ref: 'PalletHeight',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('PalletVol', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Plt CBM'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PalletVol',
	                                      withRef: true,
	                                      ref: 'PalletVol',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('PalletWeight', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_weight' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PalletWeight',
	                                      withRef: true,
	                                      ref: 'PalletWeight',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (event.charCode === 13) {
	                                          if (!_this44.state.selectedInventoryRow) {
	                                            return;
	                                          }
	                                          if (isABCFF) {
	                                            _this44.handleKeyPress('CantonNum', event);
	                                          } else {
	                                            _this44.handleFocusAutoSuggest();
	                                            _this44.checkMoveToSo();
	                                          }
	                                        }
	                                      }
	                                    })
	                                  ),
	                                  !isABCFF && _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement('div', { style: { height: '12px' } }),
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Button,
	                                      {
	                                        id: 'product-add-button',
	                                        bsStyle: 'success',
	                                        onClick: function onClick() {
	                                          _this44.checkMoveToSo();
	                                        }
	                                      },
	                                      '+'
	                                    )
	                                  )
	                                )
	                              ),
	                              isYI && _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 6 },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr1' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Ttl Ship Wt'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'TotalShippingWeight',
	                                      withRef: true,
	                                      ref: 'TotalShippingWeight',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('NMFCClass', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'NMFC'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'NMFCClass',
	                                      withRef: true,
	                                      ref: 'NMFCClass',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('PalletQuantity', event);
	                                      }
	                                    })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 6 },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_qty' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PalletQuantity',
	                                      withRef: true,
	                                      ref: 'PalletQuantity',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('PalletLength', event);
	                                      }
	                                      // placeholder="must be > 0"
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Plt L'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PalletLength',
	                                      withRef: true,
	                                      ref: 'PalletLength',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('PalletWidth', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Plt W'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PalletWidth',
	                                      withRef: true,
	                                      ref: 'PalletWidth',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('PalletHeight', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Plt H'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PalletHeight',
	                                      withRef: true,
	                                      ref: 'PalletHeight',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('PalletVol', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Plt CBM'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PalletVol',
	                                      withRef: true,
	                                      ref: 'PalletVol',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('PalletWeight', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_weight' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PalletWeight',
	                                      withRef: true,
	                                      ref: 'PalletWeight',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (event.charCode === 13) {
	                                          if (!_this44.state.selectedInventoryRow) {
	                                            return;
	                                          }
	                                          if (isABCFF) {
	                                            _this44.handleKeyPress('UnitQuantity', event);
	                                          } else {
	                                            _this44.handleFocusAutoSuggest();
	                                            _this44.checkMoveToSo();
	                                          }
	                                        }
	                                      }
	                                    })
	                                  ),
	                                  !isABCFF && _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement('div', { style: { height: '12px' } }),
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Button,
	                                      {
	                                        id: 'product-add-button',
	                                        bsStyle: 'success',
	                                        onClick: function onClick() {
	                                          _this44.checkMoveToSo();
	                                        }
	                                      },
	                                      '+'
	                                    )
	                                  )
	                                )
	                              ),
	                              (isDSQ || _root_url.isWUFS || isABCFF || isFBD) && _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(_reactBootstrap.Col, { xs: 6 }),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 6 },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_qty' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PalletQuantity',
	                                      withRef: true,
	                                      ref: 'PalletQuantity',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('PalletLength', event);
	                                      }
	                                      // placeholder="must be > 0"
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Plt L'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PalletLength',
	                                      withRef: true,
	                                      ref: 'PalletLength',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('PalletWidth', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Plt W'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PalletWidth',
	                                      withRef: true,
	                                      ref: 'PalletWidth',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('PalletHeight', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Plt H'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PalletHeight',
	                                      withRef: true,
	                                      ref: 'PalletHeight',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('PalletVol', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Plt CBM'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PalletVol',
	                                      withRef: true,
	                                      ref: 'PalletVol',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('PalletWeight', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_weight' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PalletWeight',
	                                      withRef: true,
	                                      ref: 'PalletWeight',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (event.charCode === 13) {
	                                          if (!_this44.state.selectedInventoryRow) {
	                                            return;
	                                          }
	                                          if (isABCFF) {
	                                            _this44.handleKeyPress('UnitQuantity', event);
	                                          } else {
	                                            _this44.handleFocusAutoSuggest();
	                                            _this44.checkMoveToSo();
	                                          }
	                                        }
	                                      }
	                                    })
	                                  ),
	                                  !isABCFF && _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement('div', { style: { height: '12px' } }),
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Button,
	                                      {
	                                        id: 'product-add-button',
	                                        bsStyle: 'success',
	                                        onClick: function onClick() {
	                                          _this44.checkMoveToSo();
	                                        }
	                                      },
	                                      '+'
	                                    )
	                                  )
	                                )
	                              ),
	
	                              // (isABCFF) &&
	                              false && _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 12 },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pl0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_style' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'VendorStyleNum',
	                                      withRef: true,
	                                      ref: 'VendorStyleNum',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('TJXStyleNum', event);
	                                      }
	                                      // placeholder="must be > 0"
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pl0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'TJX Style'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'TJXStyleNum',
	                                      withRef: true,
	                                      ref: 'TJXStyleNum',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('LineDescription', event);
	                                      }
	                                      // placeholder="must be > 0"
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pl0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'LineDescription',
	                                      withRef: true,
	                                      ref: 'LineDescription',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('UPC', event);
	                                      }
	                                      // placeholder="must be > 0"
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pl0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'UPC'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'UPC',
	                                      withRef: true,
	                                      ref: 'UPC',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('Color', event);
	                                      }
	                                      // placeholder="must be > 0"
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pl0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'color' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'Color',
	                                      withRef: true,
	                                      ref: 'Color',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('Size', event);
	                                      }
	                                      // placeholder="must be > 0"
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr1' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Size/Ratios'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'Size',
	                                      withRef: true,
	                                      ref: 'Size',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('TotalUnits', event);
	                                      }
	                                      // placeholder="must be > 0"
	                                    })
	                                  )
	                                )
	                              ),
	                              isABCFF && _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(_reactBootstrap.Col, { xs: 6 }),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 6 },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_qty' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'UnitQuantity',
	                                      withRef: true,
	                                      ref: 'UnitQuantity',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('UnitLength', event);
	                                      }
	                                      // placeholder="must be > 0"
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Unt L'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'UnitLength',
	                                      withRef: true,
	                                      ref: 'UnitLength',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('UnitWidth', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Unt W'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'UnitWidth',
	                                      withRef: true,
	                                      ref: 'UnitWidth',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('UnitHeight', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Unt H'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'UnitHeight',
	                                      withRef: true,
	                                      ref: 'UnitHeight',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('UnitVol', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Unt CBM'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'UnitVol',
	                                      withRef: true,
	                                      ref: 'UnitVol',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('CantonNum', event);
	                                      }
	                                    })
	                                  )
	                                )
	                              ),
	                              isABCFF && _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(_reactBootstrap.Col, { xs: 4 }),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 8 },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { style: { width: '100%' } },
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'stackable' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'PalletStackable', component: Checkbox })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { style: { width: '100%' } },
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'store_ready' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'StoreReady', component: Checkbox })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pl0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { style: { width: '100%' } },
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'preticketed' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'Preticketed', component: Checkbox })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pl0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Canton #'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'CantonNum',
	                                      withRef: true,
	                                      ref: 'CantonNum',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('OriginCountry', event);
	                                      }
	                                      // placeholder="must be > 0"
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 3, className: 'pl0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'origin_country' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'OriginCountry',
	                                      withRef: true,
	                                      ref: 'OriginCountry',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (event.charCode === 13) {
	                                          if (!_this44.state.selectedInventoryRow) {
	                                            return;
	                                          }
	                                          _this44.handleFocusAutoSuggest();
	                                          _this44.checkMoveToSo();
	                                        }
	                                      }
	                                      // placeholder="must be > 0"
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement('div', { style: { height: '12px' } }),
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Button,
	                                      {
	                                        id: 'product-add-button',
	                                        bsStyle: 'success',
	                                        onClick: function onClick() {
	                                          _this44.checkMoveToSo();
	                                        }
	                                      },
	                                      '+'
	                                    )
	                                  )
	                                )
	                              ),
	                              isWIZ && _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 6 },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr1' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_qty' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'ReceivedQuantity',
	                                      withRef: true,
	                                      ref: 'ReceivedQuantity',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('ShipmentID', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_note' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'ShipmentID',
	                                      withRef: true,
	                                      ref: 'ShipmentID',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('DispatchType', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'WH Note'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'DispatchType',
	                                      withRef: true,
	                                      ref: 'DispatchType',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('PalletQuantity', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'billable_plts' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'BillablePallets',
	                                      withRef: true,
	                                      ref: 'BillablePallets',
	                                      component: _inputField.InputField,
	                                      disabled: true,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('PalletQuantity', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'real_plts' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PalletQuantity',
	                                      withRef: true,
	                                      ref: 'PalletQuantity',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('BoxPerPallet', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_per_plt' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'BoxPerPallet',
	                                      withRef: true,
	                                      ref: 'BoxPerPallet',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('BoxLength', event);
	                                      }
	                                    })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 6 },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Box L'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'BoxLength',
	                                      withRef: true,
	                                      ref: 'BoxLength',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('BoxWidth', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Box W'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'BoxWidth',
	                                      withRef: true,
	                                      ref: 'BoxWidth',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('BoxHeight', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      'Box H'
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'BoxHeight',
	                                      withRef: true,
	                                      ref: 'BoxHeight',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('BoxVol', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_vol' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'BoxVol',
	                                      withRef: true,
	                                      ref: 'BoxVol',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('BoxWeight', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'BoxWeight',
	                                      withRef: true,
	                                      ref: 'BoxWeight',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('PalletWeight', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr0' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_weight' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PalletWeight',
	                                      withRef: true,
	                                      ref: 'PalletWeight',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('PortDray', event);
	                                      }
	                                    })
	                                  )
	                                )
	                              ),
	                              isWIZ && _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 6 },
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2, className: 'pr1' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port_dray' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'PortDray',
	                                      withRef: true,
	                                      ref: 'PortDray',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('DrayageTrucker', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2 },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dray_trucker' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'DrayageTrucker',
	                                      withRef: true,
	                                      ref: 'DrayageTrucker',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (!_this44.state.selectedInventoryRow) {
	                                          return;
	                                        }
	                                        _this44.handleKeyPress('Location', event);
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 2 },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                      name: 'Location',
	                                      withRef: true,
	                                      ref: 'Location',
	                                      component: _inputField.InputField,
	                                      onFocus: this.handleOnFocus,
	                                      onKeyPress: function onKeyPress(event) {
	                                        if (event.charCode === 13) {
	                                          if (!_this44.state.selectedInventoryRow) {
	                                            return;
	                                          }
	                                          _this44.handleFocusAutoSuggest();
	                                          _this44.checkMoveToSo();
	                                        }
	                                      }
	                                    })
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { xs: 1, className: 'pr1' },
	                                    _react2.default.createElement('div', { style: { height: '12px' } }),
	                                    _react2.default.createElement(
	                                      _reactBootstrap.Button,
	                                      {
	                                        id: 'product-add-button',
	                                        bsStyle: 'success',
	                                        onClick: function onClick() {
	                                          _this44.checkMoveToSo();
	                                        }
	                                      },
	                                      '+'
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(_reactBootstrap.Col, { xs: 6 })
	                              )
	                            )
	                          ),
	                          !isChinaTown && !isFJ && _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { id: 'inventory-details' },
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 1 },
	                              _react2.default.createElement(
	                                'label',
	                                { className: 'inventory-label' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory' }),
	                                ':'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 5 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 4 },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-6 inlineLabel' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'in_stock' }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      { className: 'colon' },
	                                      ':'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'col-xs-6 inventory-highlight' },
	                                    ' ',
	                                    this.state.inStock
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 4 },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-7 inlineLabel' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchased' }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      { className: 'colon' },
	                                      ':'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'col-xs-5 inventory-highlight' },
	                                    ' ',
	                                    this.state.purchased
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 4 },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-6 inlineLabel' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'presale' }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      { className: 'colon' },
	                                      ':'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'col-xs-6 inventory-highlight' },
	                                    ' ',
	                                    this.state.presale
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-5 inlineLabel' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'colon' },
	                                    ':'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'col-xs-6 inventory-highlight' },
	                                  ' ',
	                                  this.state.net_weight
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-5 inlineLabel' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_wt' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'colon' },
	                                    ':'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'col-xs-6 inventory-highlight' },
	                                  ' ',
	                                  this.state.ship_weight
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-5 inlineLabel' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'colon' },
	                                    ':'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'col-xs-6 inventory-highlight' },
	                                  ' ',
	                                  this.state.total_weight
	                                )
	                              )
	                            )
	                          ),
	                          isChinaTown && _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { id: 'inventory-details', style: { fontSize: '15px' } },
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 1 },
	                              _react2.default.createElement(
	                                'label',
	                                { className: 'inventory-label-china' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory' }),
	                                ':'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 5 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 4, className: 'pr1' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-6 inlineLabel' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'in_stock' }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      { className: 'colon' },
	                                      ':'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'col-xs-6 inventory-highlight-china' },
	                                    ' ',
	                                    this.state.inStock
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 4, className: 'pr1' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-7 inlineLabel' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchased' }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      { className: 'colon' },
	                                      ':'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'col-xs-5 inventory-highlight-china' },
	                                    ' ',
	                                    this.state.purchased
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 4, className: 'pr1' },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-6 inlineLabel' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'presale' }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      { className: 'colon' },
	                                      ':'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'col-xs-6 inventory-highlight-china' },
	                                    ' ',
	                                    this.state.presale
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4, className: 'pr1' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-5 inlineLabel' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'colon' },
	                                    ':'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'col-xs-6 inventory-highlight-china' },
	                                  ' ',
	                                  this.state.net_weight
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4, className: 'pr1' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-5 inlineLabel' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_wt' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'colon' },
	                                    ':'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'col-xs-6 inventory-highlight-china' },
	                                  ' ',
	                                  this.state.ship_weight
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4, className: 'pr1' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { className: 'col-xs-5 inlineLabel' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'colon' },
	                                    ':'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'col-xs-6 inventory-highlight-china' },
	                                  ' ',
	                                  this.state.total_weight
	                                )
	                              )
	                            )
	                          ),
	                          _root_url.isEcity && _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { id: 'inventory-details' },
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 1 },
	                              _react2.default.createElement(
	                                'label',
	                                { className: 'inventory-label' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_sale' }),
	                                ':'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 5 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 4 },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-6 inlineLabel' },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price' }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      { className: 'colon' },
	                                      ':'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'col-xs-6 inventory-highlight' },
	                                    ' ',
	                                    this.state.salesItemHistory[0] && this.state.salesItemHistory[0].UnitPrice
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { xs: 5 },
	                                  _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-xs-7 inlineLabel', style: { width: '60px' } },
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	                                    _react2.default.createElement(
	                                      'span',
	                                      { className: 'colon' },
	                                      ':'
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'col-xs-5 inventory-highlight', style: { width: '80px' } },
	                                    ' ',
	                                    this.state.salesItemHistory[0] && this.state.salesItemHistory[0].Date
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        this.renderRollingGate(),
	                        !(isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) && _react2.default.createElement(
	                          _reactBootstrap.Tab,
	                          { eventKey: 2, title: frequentProducts },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'tab-products-table sales-order-freq-products' },
	                            _react2.default.createElement(
	                              _reactBootstrap.Button,
	                              { className: 'btn btn-primary position', disabled: !this.state.frequentItems.selectedIndexes || this.state.frequentItems.selectedIndexes.length === 0, onClick: function onClick() {
	                                  _this44.moveFromFrequentItemsToSalesOrder();
	                                } },
	                              _react2.default.createElement('em', { className: 'fa fa-plus' })
	                            ),
	                            this.renderFrequent()
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Tab,
	                          { eventKey: 3, title: previousOrderList },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'tab-products-table' },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 8, style: { marginTop: '-12px', paddingBottom: '13px', zIndex: '1' } },
	                                _react2.default.createElement(
	                                  _reactBootstrap.Button,
	                                  {
	                                    className: 'btn btn-primary',
	                                    onClick: this.handleShowAll
	                                  },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'show_from_all_orders' })
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Button,
	                                  {
	                                    className: 'btn btn-primary',
	                                    style: { marginLeft: '5px' },
	                                    onClick: this.handleSelectAll
	                                  },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_all' })
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Button,
	                                  {
	                                    className: 'btn btn-primary',
	                                    bsStyle: 'danger',
	                                    style: { marginLeft: '5px' },
	                                    onClick: this.handleDeselectAll
	                                  },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deselect_all' })
	                                ),
	                                _react2.default.createElement(
	                                  _reactBootstrap.Button,
	                                  {
	                                    className: 'btn btn-primary',
	                                    style: { marginLeft: '5px' },
	                                    disabled: !this.state.previousOrders.selectedIndexes || this.state.previousOrders.selectedIndexes.length === 0,
	                                    onClick: function onClick() {
	                                      _this44.moveFromPreviousOrderToSalesOrder();
	                                    }
	                                  },
	                                  _react2.default.createElement('em', { className: 'fa fa-plus' })
	                                ),
	                                _react2.default.createElement('input', {
	                                  style: { width: '150px', borderRadius: '5px', marginLeft: '5px', border: '1px solid black' },
	                                  type: 'text',
	                                  onChange: function onChange(e) {
	                                    _this44.onChangeQuickEntry(e);
	                                  },
	                                  onKeyPress: function onKeyPress(e) {
	                                    _this44.onKeyPressQuickEntry(e);
	                                  },
	                                  value: this.state.quickEntrySONum,
	                                  placeholder: _reactReduxI18n.I18n.t('order_num')
	                                }),
	                                this.state.quickEntryShowError && _react2.default.createElement(
	                                  'span',
	                                  { style: { marginLeft: '3px', color: 'red' } },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_not_found' })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 2 },
	                                this.renderPreviousSOs()
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 10, style: { marginTop: '-18px' } },
	                                this.renderPreviousOrders()
	                              )
	                            )
	                          )
	                        ),
	                        !(isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) && _react2.default.createElement(
	                          _reactBootstrap.Tab,
	                          { eventKey: 4, title: favoriteList },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'tab-products-table' },
	                            _react2.default.createElement(
	                              _reactBootstrap.Button,
	                              {
	                                bsStyle: 'primary',
	                                disabled: !this.state.favorites.selectedIndexes || this.state.favorites.selectedIndexes.length == 0,
	                                onClick: function onClick() {
	                                  _this44.moveFromFavoriteItemsToSalesOrder();
	                                }
	                              },
	                              _react2.default.createElement('em', { className: 'fa fa-plus' })
	                            ),
	                            this.renderFavoritesList()
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    this.productHeader(),
	                    _react2.default.createElement(
	                      'fieldset',
	                      { className: 'form-horizontal' },
	                      _react2.default.createElement(
	                        _reactBootstrap.Tabs,
	                        { activeKey: this.state.yourOrderKey, justified: true, onSelect: this.handleSelect },
	                        _react2.default.createElement(
	                          _reactBootstrap.Tab,
	                          { eventKey: 1, title: inboundProducts },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'tab-products-table sales-order-freq-products' },
	                            _react2.default.createElement(
	                              _reactBootstrap.Button,
	                              { className: 'btn btn-primary position', disabled: this.checkblah(), onClick: function onClick() {
	                                  _this44.moveFromFrequentItemsToSalesOrder();
	                                } },
	                              _react2.default.createElement('em', { className: 'fa fa-plus' })
	                            ),
	                            this.renderInboundProducts()
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  !isMAG && _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    !isFJ && this.orderHeader(),
	                    _react2.default.createElement(
	                      'fieldset',
	                      { className: 'form-horizontal' },
	                      _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        null,
	                        this.renderTable()
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 2, className: 'sales-order-details-panel', style: { marginTop: isFJ ? '11px' : '0px' } },
	                  _react2.default.createElement(
	                    _reactBootstrap.Tabs,
	                    { defaultActiveKey: 1, justified: true, className: 'tab-width-fix' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Tab,
	                      { eventKey: 1, title: SODetails, className: 'so-details-tab' },
	                      isChinaTown && //chinatest
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'customer-specific-price-details' },
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref' })
	                          ),
	                          ': ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            '$'
	                          ),
	                          this.state.RefPrice ? this.state.RefPrice.toFixed(2) : '--'
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lowest' })
	                          ),
	                          ': ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            '$'
	                          ),
	                          this.state.LowestSalePrice ? this.state.LowestSalePrice.toFixed(2) : '--'
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Lv1' })
	                          ),
	                          ': ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            '$'
	                          ),
	                          this.state.PriceLv1 ? this.state.PriceLv1.toFixed(2) : '--'
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Lv2' })
	                          ),
	                          ': ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            '$'
	                          ),
	                          this.state.PriceLv2 ? this.state.PriceLv2.toFixed(2) : '--'
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Lv3' })
	                          ),
	                          ': ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            '$'
	                          ),
	                          this.state.PriceLv3 ? this.state.PriceLv3.toFixed(2) : '--'
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Lv4' })
	                          ),
	                          ': ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            '$'
	                          ),
	                          this.state.PriceLv4 ? this.state.PriceLv4.toFixed(2) : '--'
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Lv5' })
	                          ),
	                          ': ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            '$'
	                          ),
	                          this.state.PriceLv5 ? this.state.PriceLv5.toFixed(2) : '--'
	                        ),
	                        isJML && _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4 },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term_short' }),
	                              ':'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 8 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'PaymentTerm_id', component: _selection.Selection, options: this.state.paymentTermOptions })
	                          )
	                        ),
	                        this.renderDeliveryMethodInfo()
	                      ),
	                      !isChinaTown && _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'sales-order-number' },
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 3 },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: isWIZ || isJTB || isDSQ || _root_url.isWUFS || isABCFF || isKDW || isYI || isFBD || isFJ ? "order_no" : "so_no" })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 9 },
	                          _react2.default.createElement(_reduxForm.Field, {
	                            name: 'SONum',
	                            component: this.props.currentSalesOrderDetail != null && (this.props.currentSalesOrderDetail.SaleStatus === 'Open' || this.props.currentSalesOrderDetail.SaleStatus === 'Packing') ? _inputField.InputField : _inputField.DisabledInputField,
	                            placeholder: this.state.salesOrderNumber
	                          })
	                        )
	                      ),
	                      !isChinaTown && _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'customer-specific-price-details' },
	                        this.renderSales(),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'created_by' })
	                          ),
	                          ': ',
	                          this.state.creator
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'modified_last_by' })
	                          ),
	                          ': ',
	                          this.state.modified_by
	                        ),
	                        !isHMM && _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_price_level' })
	                          ),
	                          ': ',
	                          this.state.customerPriceLevel
	                        ),
	                        !isJML && _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term' })
	                          ),
	                          ': ',
	                          this.state.customerPaymentTerm
	                        ),
	                        isJML && _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4 },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term_short' }),
	                              ':'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 8 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'PaymentTerm_id', component: _selection.Selection, options: this.state.paymentTermOptions })
	                          )
	                        ),
	                        this.renderDeliveryMethodInfo()
	                      ),
	                      !isChinaTown && !_root_url.isElegant && _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'sale-pricing-details' },
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 4, style: { padding: '0px' } },
	                          this.renderDiscountAmount()
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 4, style: { paddingRight: '0px' } },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'dollar-sign' },
	                              '$'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { onDoubleClick: function onDoubleClick() {
	                                _this44.openChangeTax();
	                              }, style: { width: '55px', borderRadius: '3px', padding: '2px 5px', border: '1px solid black', backgroundColor: '#dddddd' } },
	                            parseFloat(totalTaxWithPromotion).toFixed(2)
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 4, style: { paddingRight: '0px' } },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'CRV' }),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'dollar-sign' },
	                              '$'
	                            )
	                          ),
	                          _react2.default.createElement(_reduxForm.Field, { name: 'CRV', component: _inputField.DisabledInputField, placeholder: this.state.totalCRV.toFixed(2) })
	                        )
	                      ),
	                      _root_url.isElegant && _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'sale-pricing-details' },
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6, style: { padding: '0px' } },
	                          this.renderDiscountAmount()
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6, style: { paddingRight: '0px' } },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'dollar-sign' },
	                              '$'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'span',
	                            { onDoubleClick: function onDoubleClick() {
	                                _this44.openChangeTax();
	                              } },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'Tax', component: _inputField.DisabledInputField, placeholder: parseFloat(totalTaxWithPromotion).toFixed(2) })
	                          )
	                        )
	                      ),
	                      !isChinaTown && _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'sale-details-output' },
	                        (isMyumyu || isAFG || _root_url.isRivera || isWecom || isDHC || isAFM || _root_url.isEcity || _root_url.isElegant) && _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'pricing-highlight' },
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delivery' }),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'dollar-sign' },
	                                  '$$'
	                                ),
	                                ':'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                'div',
	                                { onDoubleClick: function onDoubleClick() {
	                                    _this44.openDeliveryFee();
	                                  } },
	                                _react2.default.createElement(
	                                  'label',
	                                  { style: { color: 'blue' } },
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'dollar-sign' },
	                                    '$'
	                                  ),
	                                  this.state.delivery.toFixed(2)
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'pricing-highlight' },
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order' }),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'dollar-sign' },
	                                  '$$'
	                                ),
	                                ':'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'dollar-sign' },
	                                  '$'
	                                ),
	                                this.state.totalPrice.toFixed(2)
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'pricing-highlight' },
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'transaction_fee' }),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'dollar-sign' },
	                                  '$$'
	                                ),
	                                ':'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'dollar-sign' },
	                                  '$'
	                                ),
	                                this.state.fee.toFixed(2)
	                              )
	                            )
	                          )
	                        ),
	                        this.state.creditAmount > 0 && _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'pricing-highlight' },
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit' }),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'dollar-sign' },
	                                  '$$'
	                                ),
	                                ':'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(
	                                  'span',
	                                  { style: { paddingLeft: '0px' }, className: 'dollar-sign' },
	                                  '-$'
	                                ),
	                                this.state.creditAmount
	                              )
	                            )
	                          )
	                        ),
	                        this.state.shareCreditAmount > 0 && _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'pricing-highlight' },
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'share' }),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'dollar-sign' },
	                                  '$$'
	                                ),
	                                ':'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(
	                                  'span',
	                                  { style: { paddingLeft: '0px' }, className: 'dollar-sign' },
	                                  '-$'
	                                ),
	                                this.state.shareCreditAmount
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'pricing-highlight' },
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final' }),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'dollar-sign' },
	                                  '$$'
	                                ),
	                                ':'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'dollar-sign' },
	                                  '$'
	                                ),
	                                parseFloat(this.state.finalPriceWithPromotion).toFixed(2)
	                              )
	                            )
	                          )
	                        ),
	                        !isHMM && _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_wt' }),
	                              ':'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              dispNetWeight,
	                              ' lb'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_wt' }),
	                              ':'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                              'div',
	                              { onDoubleClick: function onDoubleClick() {
	                                  _this44.openChangeWeight();
	                                } },
	                              _react2.default.createElement(
	                                'label',
	                                { style: { color: 'blue' } },
	                                dispShippingWeight
	                              ),
	                              _react2.default.createElement(
	                                'span',
	                                { style: { fontWeight: '550' } },
	                                ' lb'
	                              )
	                            )
	                          )
	                        ),
	                        this.renderSalesOrderMargin()
	                      ),
	                      !isWIZ && !isDSQ && !_root_url.isWUFS && !isABCFF && !isKDW && !isYI && !isFBD && !isFJ && !isJTB && _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'sale-history-details', style: { 'margin-top': '0' } },
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            'h4',
	                            { style: { marginBottom: '5px' } },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_history' })
	                          ),
	                          this.renderItemHistory()
	                        )
	                      ),
	                      isChinaTown && _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'sales-order-number' },
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 3 },
	                          _react2.default.createElement(
	                            'label',
	                            { style: { marginBottom: '0px' } },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_no' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 9 },
	                          _react2.default.createElement(_reduxForm.Field, {
	                            name: 'SONum',
	                            component: this.props.currentSalesOrderDetail != null && (this.props.currentSalesOrderDetail.SaleStatus === 'Open' || this.props.currentSalesOrderDetail.SaleStatus === 'Packing') ? _inputField.InputField : _inputField.DisabledInputField,
	                            placeholder: this.state.salesOrderNumber
	                          })
	                        )
	                      ),
	                      isChinaTown && _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'customer-specific-price-details' },
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'created_by' })
	                          ),
	                          ': ',
	                          this.state.created_by_name
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'modified_last_by' })
	                          ),
	                          ': ',
	                          this.state.modified_by
	                        ),
	                        !isHMM && _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_price_level' })
	                          ),
	                          ': ',
	                          this.state.customerPriceLevel
	                        ),
	                        !isJML && _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term' })
	                          ),
	                          ': ',
	                          this.state.customerPaymentTerm
	                        ),
	                        isJML && _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4 },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term_short' }),
	                              ':'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 8 },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'PaymentTerm_id', component: _selection.Selection, options: this.state.paymentTermOptions })
	                          )
	                        ),
	                        this.renderDeliveryMethodInfo()
	                      ),
	                      isChinaTown && _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'sale-details-output', style: { marginTop: isChinaTown ? '0px' : '5px' } },
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'pricing-highlight' },
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order' }),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'dollar-sign' },
	                                  '$$'
	                                ),
	                                ':'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'dollar-sign' },
	                                  '$'
	                                ),
	                                this.state.totalPrice.toFixed(2)
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'pricing-highlight' },
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final' }),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'dollar-sign' },
	                                  '$$'
	                                ),
	                                ':'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 6 },
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'dollar-sign' },
	                                  '$'
	                                ),
	                                parseFloat(this.state.finalPriceWithPromotion).toFixed(2)
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement('div', { style: { marginBottom: '10px' } })
	                        )
	                      ),
	                      !isChinaTown && _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'customer-credit-details', style: { 'margin-top': '0' } },
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          this.renderCustomerCredit()
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6, style: { color: 'red' } },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            '00-30 ',
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' }),
	                            ':'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6, style: { color: 'red' } },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            '$'
	                          ),
	                          this.state.Amount00_30.toFixed(2)
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6, style: { color: 'red' } },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            '30-60 ',
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' }),
	                            ':'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6, style: { color: 'red' } },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            '$'
	                          ),
	                          this.state.Amount31_60.toFixed(2)
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6, style: { color: 'red' } },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            '60-90 ',
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' }),
	                            ':'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6, style: { color: 'red' } },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            '$'
	                          ),
	                          this.state.Amount61_90.toFixed(2)
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6, style: { color: 'red' } },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            '90+ ',
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'days' }),
	                            ':'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6, style: { color: 'red' } },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            '$'
	                          ),
	                          this.state.Amount91.toFixed(2)
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_month' }),
	                            ':'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            '$'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unpaid' }),
	                            ':'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dollar-sign' },
	                            '$'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit_limit' }),
	                            ':'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement('span', { className: 'dollar-sign' }),
	                          this.state.CreditLimit
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                            ':'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement('span', { className: 'dollar-sign' }),
	                          this.state.PaymentTermDesc
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Credit' }),
	                            ': ',
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: this.props.salesCustomerDetails && this.props.salesCustomerDetails.CreditStatus ? this.props.salesCustomerDetails.CreditStatus : '' })
	                          )
	                        )
	                      ),
	                      !isChinaTown && _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'customer-note' },
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12, style: { 'padding-left': '0' } },
	                          _react2.default.createElement(
	                            _reactBootstrap.Tabs,
	                            { justified: true, className: 'notations' },
	                            _react2.default.createElement(
	                              _reactBootstrap.Tab,
	                              { eventKey: 1, title: customerNote },
	                              _react2.default.createElement(_reduxForm.Field, { id: 'cust-note', name: 'Notation', maxLength: 150, component: 'Textarea', className: 'form-control', style: { minHeight: '130px' } })
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Tab,
	                              { eventKey: 2, title: employeeNote },
	                              _react2.default.createElement(
	                                'span',
	                                { onDoubleClick: function onDoubleClick() {
	                                    _this44.openEmployeeNote();
	                                  } },
	                                _react2.default.createElement(_reactBootstrap.Input, {
	                                  type: 'text',
	                                  value: this.state.employeeNoteDisplay,
	                                  disabled: true
	                                })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Tab,
	                              { eventKey: 3, title: routeNote },
	                              _react2.default.createElement(_reduxForm.Field, { id: 'route-note', name: 'RouteNote', maxLength: 150, component: _inputField.InputField })
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Tab,
	                      { eventKey: 2, title: CheckoutInfo, className: 'check-out-info-tab' },
	                      this.renderPaymentInfo(),
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'note-input-field' },
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'h4',
	                              null,
	                              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 12 },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'Note', component: 'Textarea', className: 'form-control', style: { minHeight: '130px' } })
	                        )
	                      )
	                    )
	                  )
	                ),
	                ' '
	              ),
	              ' '
	            ),
	            _react2.default.createElement(Notes, { isVisible: this.state.isNotesModalVisibile, setModalVisibility: this.setNotesModalVisibility }),
	            _react2.default.createElement(PromotionAddingModal, {
	              isVisible: this.state.isPromotionAddingAlertModalVisible,
	              onClose: this.setPromotionAddingAlertModalVisibility,
	              onConfirm: this.handlePromotionAddConfirmClick,
	              productPromotions: this.props.productPromotions
	            }),
	            _react2.default.createElement(ShippingStatusEditModal, {
	              isVisible: this.state.shippingStatusEditModalVisible,
	              onClose: this.setShippingStatsEditModalVisibility,
	              currentSalesOrderDetail: this.props.currentSalesOrderDetail,
	              reloadThePage: this.reloadThePage
	            }),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: ShippingInfoConfirmModalStyle, isVisible: this.state.shippingInfoConfirmModalVisibility, onCloseClicked: function onCloseClicked() {
	                  _this44.closeShippinggInfoConfirmModal();
	                }, title: 'Shipping Info Confirmation' },
	              _react2.default.createElement(_ShippingInfoConfirmModal2.default, {
	                salesShippingCustomerDetails: this.props.salesShippingCustomerDetails || {},
	                CustomerDetail_id: this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'outboundOrders/new' ? this.props.shipperChosen : this.props.Deliver_CustomerDetail_id,
	                handleReturnClick: function handleReturnClick() {
	                  return _this44.closeShippinggInfoConfirmModal(false);
	                },
	                handleSaveClick: handleSubmit(function (form) {
	                  return _this44.handleFormSubmit(form);
	                })
	              })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: isJML ? MultiBatchStyle : MultiBatchModalStyle, isVisible: this.state.isBatchesModal2Visible, onCloseClicked: function onCloseClicked() {
	                  _this44.setBatchesModal2Visibility();
	                }, title: 'Edit Batch' },
	              _react2.default.createElement(_MultiBatchModal4.default, {
	                batchesInfo: this.props.batchesInfo,
	                onSelectedMultiBatch: this.onSelectedMultiBatch2,
	                selectedInventoryRow: this.state.selectedInventoryRow,
	                quantityValue: this.state.lineQty,
	                lineBatchId: this.state.lineBatchId,
	                lineBatchIdx: this.state.lineBatchIdx,
	                lineBatchRows: this.state.lineBatchRows
	              })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: MultiBatchModalStyle, isVisible: this.state.isMultiBatchVisible, onCloseClicked: function onCloseClicked() {
	                  _this44.setMultiBatchModalVisibility();
	                }, title: 'Assign Batch' },
	              _react2.default.createElement(_MultiBatchModal2.default, {
	                batchesInfo: this.props.batchesInfo,
	                onSelectedMultiBatch: this.onSelectedMultiBatch,
	                selectedInventoryRow: this.state.selectedInventoryRow,
	                quantityValue: this.props.quantityValue
	              })
	            ),
	            _react2.default.createElement(BatchesModal, {
	              setModalVisibility: this.setBatchesModalVisibility,
	              isVisible: this.state.isBatchesModalVisible,
	              batchesInfo: this.props.batchesInfo,
	              onSelectedBatch: this.onSelectedBatch,
	              salesOrderProduct: this.props.salesOrderProduct
	            })
	          ),
	          this.renderShippingIFrame(),
	          this.renderPackingIFrame(),
	          this.renderPickingIFrame(),
	          this.renderSalesOrderIFrame(),
	          this.renderSalesOrderSIIFrame(),
	          this.renderRefundIframe(),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            { dialogStyles: createDialogStyle, isVisible: this.state.historyOpen, onCloseClicked: function onCloseClicked() {
	                _this44.closeHistory();
	              }, title: customerSalesHistory },
	            this.renderHistory()
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            { dialogStyles: createDialogStyle, isVisible: this.state.openOrderOpen, onCloseClicked: function onCloseClicked() {
	                _this44.setState({ openOrderOpen: false });
	              }, title: openSalesOrder },
	            this.renderOpenOrder()
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogInventoryStyle,
	              isVisible: this.state.showInventoryOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this44.closeShowInventory('productSearch');
	              },
	              title: selectInventoryInformation
	            },
	            _react2.default.createElement(_salesInventoryInfo2.default, {
	              Customer_id: this.state.currentCustomer,
	              SearchType: this.props.searchType,
	              SearchValue: this.props.searchValue,
	              closeShowInventory: this.closeShowInventory,
	              selectInventoryInfo: this.selectInventoryInfo,
	              setSaleRowValue: this.props.setSaleRowValue,
	              setAllProductQuantity: this.setAllProductQuantity
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            { dialogStyles: createDialogStyle, isVisible: this.state.confirmOpen, onCloseClicked: function onCloseClicked() {
	                _this44.closeConfirm();
	              }, title: confirmAction },
	            _react2.default.createElement(_confirmActionModal2.default, {
	              'case': this.state.case,
	              closeC: this.closeConfirm,
	              caseAction: function caseAction() {
	                _this44.moveToSO('move');
	              },
	              zeroArray: this.state.quantityZero,
	              lowestSalePrice: this.state.selectedInventoryRow.LowestSalePrice,
	              currentPrice: this.props.unitPrice,
	              rowEdited: this.state.RowBeingEdited,
	              newPrice: this.state.newPrice,
	              updatePrice: this.handleUpdatePrice
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'remove-close-skylight' },
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: createDialogStyle, isVisible: this.state.showSOCreatedOpen, title: ModalHeader },
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'your_so_no_period_is' }),
	                  ' ',
	                  this.props.salesOrderCreated && this.props.salesOrderCreated.SONum || this.props.soNum
	                )
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_ask_if_stay_on_current_page' }),
	                  '?'
	                )
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle' },
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  { bsStyle: 'primary', className: 'mr', onClick: function onClick(event) {
	                      _this44.refreshPage(event);
	                    }, type: 'button' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	                ),
	                (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  { bsStyle: 'danger', className: 'mr', onClick: function onClick() {
	                      _this44.context.router.push("/outboundOrders");
	                    }, type: 'button' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	                ),
	                this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id' && _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  { bsStyle: 'danger', className: 'mr', onClick: function onClick() {
	                      _this44.context.router.push(route);
	                    }, type: 'button' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	                ),
	                this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id' && _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  { bsStyle: 'success', className: 'mr', onClick: function onClick() {
	                      _this44.goToNewSales(newRoute);
	                    }, type: 'button' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_so' })
	                ),
	                isFung && this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id' && _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  { bsStyle: 'success', onClick: function onClick() {
	                      _this44.printSI();
	                    }, type: 'button' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_si' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { id: 'sales-shipping-modal' },
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: createDialogShippingStyle, isVisible: this.state.showShippingOpen, onCloseClicked: this.closeShipping, title: expressInvoiceHeader },
	              _react2.default.createElement(_salesShippingModal2.default, {
	                rows: this.state.rows,
	                currentSalesOrder: this.props.currentSalesOrder,
	                InvoiceNum: this.props.currentSalesOrderDetail && this.props.currentSalesOrderDetail.InvoiceNum
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            { dialogStyles: createDialogStyle, isVisible: this.state.changeTaxOpen, onCloseClicked: function onCloseClicked() {
	                _this44.closeChangeTax();
	              }, title: changeTax },
	            _react2.default.createElement(_taxSelectionModal.TaxSelectionModal, { taxRateOptions: this.getTaxRateOptions(), taxValue: this.state.taxValue, onChange: this.handleTaxValueChange })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            { dialogStyles: createDiscountDialogStyle, isVisible: this.state.changeDiscountOpen, onCloseClicked: function onCloseClicked() {
	                _this44.closeDiscountModal();
	              }, title: changeDiscountTitle },
	            _react2.default.createElement(_discountChangeModal.DiscountChangeModal, { SODiscount: this.state.SODiscount, SOSavings: this.state.SOSavings, onDiscountSavingsConfirm: this.onDiscountSavingsConfirm })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            { dialogStyles: createWeightDialogStyle, isVisible: this.state.changeWeightOpen, onCloseClicked: function onCloseClicked() {
	                _this44.closeChangeWeight();
	              }, title: changeWeight },
	            _react2.default.createElement(_weightChangeModal.WeightChangeModal, { finalShippingWeight: this.state.finalShippingWeight, onClickButton: function onClickButton() {
	                _this44.onChangeWeightSubmit();
	              }, onChange: this.onShippingWeightChange })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            { dialogStyles: createNoteDialogStyle, isVisible: this.state.changeEmployeeNoteOpen, onCloseClicked: function onCloseClicked() {
	                _this44.closeEmployeeNote();
	              }, title: changeEmployeeNoteTitle },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle' },
	                _react2.default.createElement(
	                  'div',
	                  { style: { width: '80%' } },
	                  _react2.default.createElement(_reactBootstrap.Input, {
	                    type: 'textarea',
	                    rows: 5,
	                    onChange: this.onChangeEmployeeNote,
	                    value: this.state.employeeNoteText
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle' },
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'success',
	                    onClick: function onClick() {
	                      _this44.onSubmitEmployeeNote();
	                    }
	                  },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            { dialogStyles: editLocationDialogStyle, isVisible: this.state.ZBLModalOpen, onCloseClicked: function onCloseClicked() {
	                _this44.closeZBLModal();
	              }, title: "Change Location" },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle' },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 12 },
	                  _react2.default.createElement(
	                    'p',
	                    { style: { fontSize: '20px' } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'current_location' }),
	                    ': ',
	                    this.state.currentZBL
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle' },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zone' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bin' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'level' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle' },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Dropdown,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Dropdown.Toggle,
	                      { style: { height: '28px', width: '210px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' } },
	                      this.state.zoneDisplay
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Dropdown.Menu,
	                      { className: 'super-colors' },
	                      this.state.zoneOptions.map(function (el) {
	                        return _react2.default.createElement(
	                          _reactBootstrap.MenuItem,
	                          { onClick: function onClick() {
	                              return handleZoneChange(el);
	                            } },
	                          el.label
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Dropdown,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Dropdown.Toggle,
	                      { style: { height: '28px', width: '210px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' } },
	                      this.state.binDisplay
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Dropdown.Menu,
	                      { className: 'super-colors' },
	                      this.state.binOptions.map(function (el) {
	                        return _react2.default.createElement(
	                          _reactBootstrap.MenuItem,
	                          { onClick: function onClick() {
	                              return handleBinChange(el);
	                            } },
	                          el.label
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Dropdown,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Dropdown.Toggle,
	                      { style: { height: '28px', width: '210px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' } },
	                      this.state.levelDisplay
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Dropdown.Menu,
	                      { className: 'super-colors' },
	                      this.state.levelOptions.map(function (el) {
	                        return _react2.default.createElement(
	                          _reactBootstrap.MenuItem,
	                          { onClick: function onClick() {
	                              return handleLevelChange(el);
	                            } },
	                          el.label
	                        );
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle' },
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'success',
	                    style: { marginTop: '20px' },
	                    onClick: function onClick() {
	                      _this44.onSubmitZBLEdit();
	                    }
	                  },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'danger',
	                    style: { marginLeft: '10px', marginTop: '20px' },
	                    onClick: function onClick() {
	                      _this44.closeZBLModal();
	                    }
	                  },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            { dialogStyles: editAchDialogStyle, isVisible: this.state.achEditOpen, onCloseClicked: function onCloseClicked() {
	                _this44.closeAchEdit();
	              }, title: editAchTitle },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account_name' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { width: '80%' } },
	                  _react2.default.createElement(_reactBootstrap.Input, {
	                    type: 'text',
	                    onChange: this.onChangeNameOnAccount,
	                    value: this.state.NameOnAccount
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'account_number' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { width: '80%' } },
	                  _react2.default.createElement(_reactBootstrap.Input, {
	                    type: 'text',
	                    onChange: this.onChangeAccountNum,
	                    value: this.state.AccountNum
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'routing_number' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { width: '80%' } },
	                  _react2.default.createElement(_reactBootstrap.Input, {
	                    type: 'text',
	                    onChange: this.onChangeRouting,
	                    value: this.state.Routing
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle' },
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'success',
	                    onClick: function onClick() {
	                      _this44.onSubmitAchEdit();
	                    }
	                  },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'danger',
	                    style: { marginLeft: '10px' },
	                    onClick: function onClick() {
	                      _this44.closeAchEdit();
	                    }
	                  },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            { dialogStyles: changeDeliveryDialogStyle, isVisible: this.state.changeDeliveryFeeOpen, onCloseClicked: function onCloseClicked() {
	                _this44.closeDeliveryFee();
	              }, title: changeDeliveryFeeTitle },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle', style: { marginTop: '30px' } },
	                _react2.default.createElement(
	                  'div',
	                  { style: { width: '60%' } },
	                  _react2.default.createElement(_reactBootstrap.Input, {
	                    type: 'number',
	                    onChange: this.onChangeDeliveryFee,
	                    value: this.state.deliveryFeeEdit
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'centerStyle' },
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'success',
	                    onClick: function onClick() {
	                      _this44.onConfirmDeliveryFee();
	                    }
	                  },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            { dialogStyles: createDialogStyle, isVisible: this.state.editSOPermissionOpen, onCloseClicked: function onCloseClicked() {
	                _this44.closeEditSOPermission();
	              }, title: editSOPermission },
	            _react2.default.createElement(_confirmActionModal2.default, {
	              'case': this.state.case,
	              checkPermission: this.props.checkPermission,
	              checkPermissionSuccess: this.props.checkPermissionSuccess
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            { dialogStyles: createDialogStyle, isVisible: this.state.confirmRefundOpen, onCloseClicked: this.closeConfirmRefund.bind(this), title: confirmRefund },
	            _react2.default.createElement(_confirmActionModal2.default, {
	              'case': this.state.case,
	              closeConfirmRefund: this.closeConfirmRefund.bind(this),
	              handleRefundConfirm: this.handleRefundConfirm.bind(this),
	              checkPermission: this.props.checkPermission,
	              checkPermissionSuccess: this.props.checkPermissionSuccess
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogStyle,
	              isVisible: this.state.verifyPasscodeOpen,
	              onCloseClicked: this.closeVerifyPasscode, title: passcodeConfirm
	            },
	            _react2.default.createElement(_VerifyPasscodeModal2.default, {
	              text: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price_range_warning' }),
	              closeConfirm: this.handleVerifyPasscodeClose
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogStyle,
	              isVisible: this.state.verifyPasscodeToCreateSOModalOpen,
	              onCloseClicked: this.closeVerifyPasscodeToCreateSO,
	              title: passcodeConfirm
	            },
	            _react2.default.createElement(_VerifyPasscodeModal2.default, {
	              text: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit_limit_payment_term_warning' }),
	              closeConfirm: this.handleVerifypasscodeToCreateSOClose
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDeliveryModalDialogStyle,
	              isVisible: this.state.deliveryMethodModalOpen,
	              onCloseClicked: this.closeDeliveryMethodModal,
	              title: 'Delivery Method: ' + this.state.ShippingMethod
	            },
	            _react2.default.createElement(_DeliveryMethodModal2.default, {
	              info: this.state.shipping
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            { dialogStyles: changeCarrierInfoStyle, isVisible: this.state.carrierInfoModalOpen, onCloseClicked: function onCloseClicked() {
	                _this44.closeCarrierInfoModal();
	              }, title: changeCarrierInfo },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_carrierInfoModal.CarrierInfoModal, {
	                salesOrderId: this.props.params.id,
	                fetchCarrierInfo: this.props.fetchCarrierInfo,
	                postCarrierInfo: this.props.postCarrierInfo,
	                closeCarrierInfoModal: this.closeCarrierInfoModal
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            { dialogStyles: changeCarrierInfoStyle, isVisible: this.state.shippingInfoEditModalVisibility, onCloseClicked: function onCloseClicked() {
	                _this44.closeShippingInfoEditModal();
	              }, title: 'Add Shipping Address' },
	            _react2.default.createElement(_shippingInfoEditModal2.default, {
	              receivingCustomer: this.props.receivingCustomer,
	              salesCustomerDetails: this.props.salesCustomerDetails,
	              reFetchSalesCustomers: this.reFetchSalesCustomers
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            { dialogStyles: changeFBAStyle, isVisible: this.state.fbaEditModalVisibility, onCloseClicked: function onCloseClicked() {
	                _this44.closeFBAEditModal();
	              }, title: 'Add FBA Address' },
	            _react2.default.createElement(_fbaAddressEditModal2.default, {
	              closeFBAEditModal: this.closeFBAEditModal,
	              modalFetchFBA: this.modalFetchFBA
	              // receivingCustomer={this.props.receivingCustomer}
	              // salesCustomerDetails={this.props.salesCustomerDetails}
	              // reFetchSalesCustomers={this.reFetchSalesCustomers}
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogStyle,
	              isVisible: this.state.verifyPasscodeOpenDiscount,
	              onCloseClicked: this.closeVerifyPasscodeDiscount, title: passcodeConfirm
	            },
	            _react2.default.createElement(_VerifyPasscodeModal2.default, {
	              text: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price_range_warning' }),
	              closeConfirm: this.handleVerifyPasscodeCloseDiscount
	            })
	          ),
	          _react2.default.createElement(_DropshipModal2.default, {
	            visible: this.state.isDropshipOpen,
	            onClose: this.closeDropship,
	            salesOrderId: this.props.params.id
	          }),
	          _react2.default.createElement(_ShippingInfoFormModal2.default, {
	            isVisible: this.state.shippingInfoModalVisibility,
	            onClose: this.closeShippingInfoFormModal,
	            initialValues: this.props.initialValues
	          })
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return SalesOrderForm;
	}(_react.Component);
	
	SalesOrderForm.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var _default = (0, _reactRouter.withRouter)(SalesOrderForm);
	
	exports.default = _default;
	
	
	var pickShippingMethod = function pickShippingMethod(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-4 text-nowrap' },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'Delivery',
	        checked: props.input.value === "Delivery"
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delivery' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xs-3 text-nowrap' },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        type: 'radio',
	        value: 'Pickup',
	        checked: props.input.value === "Pickup"
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup' })
	    )
	  );
	};
	
	var renderTypeRadios = function renderTypeRadios(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group', id: 'search-product-by' },
	    !isChinaTown && _react2.default.createElement(
	      'label',
	      { className: 'col-xs-4 search-by-max-width' },
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'search_by' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col', style: { paddingRight: '5px' } },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        style: { marginRight: '3px' },
	        type: 'radio',
	        value: 'ProductNum',
	        checked: props.input.value === 'ProductNum'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col', style: { paddingRight: '5px' } },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        style: { marginRight: '3px' },
	        type: 'radio',
	        value: 'RefNum',
	        checked: props.input.value === 'RefNum'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col', style: { paddingRight: '5px' } },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        style: { marginRight: '3px' },
	        type: 'radio',
	        value: 'Name',
	        checked: props.input.value === 'Name'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col', style: { paddingRight: '5px' } },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        style: { marginRight: '3px' },
	        type: 'radio',
	        value: 'Description',
	        checked: props.input.value === 'Description'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col', style: { paddingRight: '5px' } },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        style: { marginRight: '3px' },
	        type: 'radio',
	        value: 'Barcode',
	        checked: props.input.value === 'Barcode'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Barcode' })
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'col', style: { paddingRight: '5px' } },
	      _react2.default.createElement('input', _extends({}, props.input, {
	        style: { marginRight: '3px' },
	        type: 'radio',
	        value: 'GeneralNum',
	        checked: props.input.value === 'GeneralNum'
	      })),
	      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_no' })
	    )
	  );
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(DropDownEditor, 'DropDownEditor', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(input, 'input', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(DriverListModal, 'DriverListModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(ISAEditModal, 'ISAEditModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(CTNEditModal, 'CTNEditModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(ShippingStatusEditModal, 'ShippingStatusEditModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(Notes, 'Notes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(BatchesModal, 'BatchesModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(PromotionAddingModal, 'PromotionAddingModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isBobaLife, 'isBobaLife', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isMyumyu, 'isMyumyu', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isHMM, 'isHMM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isDHC, 'isDHC', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isAFG, 'isAFG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isWecom, 'isWecom', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isCO, 'isCO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isAFM, 'isAFM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isTN, 'isTN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isABC, 'isABC', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isAN, 'isAN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isChinaTown, 'isChinaTown', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isJML, 'isJML', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isDSQ, 'isDSQ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isWIZ, 'isWIZ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isFJ, 'isFJ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isJTB, 'isJTB', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isFung, 'isFung', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isTQ, 'isTQ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isMAG, 'isMAG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isNBT, 'isNBT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isKM, 'isKM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isOCM, 'isOCM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isATL, 'isATL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isRS, 'isRS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isKDW, 'isKDW', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isABCFF, 'isABCFF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isYI, 'isYI', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isFBD, 'isFBD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isCalco, 'isCalco', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(DateFormatterChina, 'DateFormatterChina', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(DateFormatter2, 'DateFormatter2', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isNumeric, 'isNumeric', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(Checkbox, 'Checkbox', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(PriceFormatter, 'PriceFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(HMMPriceFormatter, 'HMMPriceFormatter', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(SalesOrderForm, 'SalesOrderForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(pickShippingMethod, 'pickShippingMethod', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(renderTypeRadios, 'renderTypeRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrderForm.jsx');
	}();

	;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _lodash = __webpack_require__(19);
	
	var _reactPaginate = __webpack_require__(104);
	
	var _reactPaginate2 = _interopRequireDefault(_reactPaginate);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _GenericDatePicker = __webpack_require__(48);
	
	var _GenericDatePicker2 = _interopRequireDefault(_GenericDatePicker);
	
	var _DateTimePicker = __webpack_require__(37);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _url = __webpack_require__(20);
	
	var _SpinnerButton = __webpack_require__(36);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _constants = __webpack_require__(11);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _datePicker = __webpack_require__(27);
	
	var _selection = __webpack_require__(21);
	
	var _TypeRadios = __webpack_require__(57);
	
	var _TypeRadios2 = _interopRequireDefault(_TypeRadios);
	
	var _GenericProductSuggest = __webpack_require__(51);
	
	var _GenericProductSuggest2 = _interopRequireDefault(_GenericProductSuggest);
	
	var _cleanDates = __webpack_require__(22);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _genericRadioFilter = __webpack_require__(50);
	
	var _genericRadioFilter2 = _interopRequireDefault(_genericRadioFilter);
	
	var _numberWithCommas = __webpack_require__(35);
	
	var _dateFilterRadios = __webpack_require__(49);
	
	var _dateFilterRadios2 = _interopRequireDefault(_dateFilterRadios);
	
	var _dispatchFilterRadios = __webpack_require__(270);
	
	var _dispatchFilterRadios2 = _interopRequireDefault(_dispatchFilterRadios);
	
	var _percentFormatter = __webpack_require__(97);
	
	var _percentFormatter2 = _interopRequireDefault(_percentFormatter);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _weightChangeModalMulti = __webpack_require__(321);
	
	var _bolListModal = __webpack_require__(264);
	
	var _dsqPrintModal = __webpack_require__(272);
	
	var _wizPODModal = __webpack_require__(322);
	
	var _generateBOLModal = __webpack_require__(275);
	
	var _SplitTrackingNumberModal = __webpack_require__(261);
	
	var _PaymentMethodModal = __webpack_require__(168);
	
	var _PaymentMethodModal2 = _interopRequireDefault(_PaymentMethodModal);
	
	var _AltonChildModal = __webpack_require__(249);
	
	var _AltonChildModal2 = _interopRequireDefault(_AltonChildModal);
	
	var _BolImagesTable = __webpack_require__(485);
	
	var _BolImagesTable2 = _interopRequireDefault(_BolImagesTable);
	
	var _salesOrder = __webpack_require__(158);
	
	var _salesOrder2 = _interopRequireDefault(_salesOrder);
	
	var _reactDropzone = __webpack_require__(45);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _EmailContentModal = __webpack_require__(486);
	
	var _EmailContentModal2 = _interopRequireDefault(_EmailContentModal);
	
	var _sales_actions = __webpack_require__(28);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DriverListModal = _salesOrder2.default.DriverListModal,
	    ISAEditModal = _salesOrder2.default.ISAEditModal,
	    CTNEditModal = _salesOrder2.default.CTNEditModal,
	    LocationChange = _salesOrder2.default.LocationChange,
	    InboundDateChange = _salesOrder2.default.InboundDateChange,
	    DeliveryTimeChange = _salesOrder2.default.DeliveryTimeChange,
	    PickupTimeChange = _salesOrder2.default.PickupTimeChange,
	    ExcelUploadOption = _salesOrder2.default.ExcelUploadOption,
	    LabelPrintModal = _salesOrder2.default.LabelPrintModal,
	    ShippingRateModal = _salesOrder2.default.ShippingRateModal;
	
	
	var isMyuMyu = _root_url.ROOT_API_URL === "https://mmstage-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === "https://myumyu-scm.truckxi.com/api/";
	var isCalco = _root_url.ROOT_API_URL === "https://calco-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === "https://calco-stage.truckxi.com/api/";
	var isEcity = _root_url.ROOT_API_URL === "https://ct-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/";
	var isHMM = _root_url.ROOT_API_URL === "https://hmm-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://hmm-scm.truckxi.com/api/";
	var isAFG = _root_url.ROOT_API_URL === "https://afg-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://afgstage-scm.truckxi.com/api/";
	var isMAG = _root_url.ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://magna-scm.truckxi.com/api/';
	var isWecom = _root_url.ROOT_API_URL === "https://wecom-scm.truckxi.com/api/";
	var isCO = _root_url.ROOT_API_URL === "https://co-scm.truckxi.com/api/";
	var isJML = _root_url.ROOT_API_URL === "https://jml-scm.truckxi.com/api/";
	var isSY = _root_url.ROOT_API_URL === "https://admin.apoodr.com/api/";
	var isAFM = _root_url.ROOT_API_URL === "https://afm-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://afm-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://afmstage-scm.truckxi.com/api/";
	var isTN = _root_url.ROOT_API_URL === "https://tn-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://tn-scm.truckxi.com/api/";
	var isABC = _root_url.ROOT_API_URL === "https://abc-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://abc-scm.truckxi.com/api/";
	var isUSPride = _root_url.ROOT_API_URL === "https://uspride-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://uspride-scm.truckxi.com/api/";
	var isChinaTown = _root_url.ROOT_API_URL === 'https://erp.chinatown-supermarket.com/api/' || _root_url.ROOT_URL === 'https://erp.chinatown-supermarket.com/api/';
	var isDSQ = _root_url.ROOT_API_URL === 'https://dsq-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://dsq-scm.truckxi.com/api/';
	var isWIZ = _root_url.ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
	var isGV = _root_url.ROOT_API_URL === 'https://scm.gvyummyus.com/api/' || _root_url.ROOT_URL === 'https://scm.gvyummyus.com/api/';
	var isFJ = _root_url.ROOT_API_URL === 'https://fj-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://fj-scm.truckxi.com/api/';
	var isJTB = _root_url.ROOT_API_URL === 'https://jtb-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://jtb-scm.truckxi.com/api/';
	var isFIT = _root_url.ROOT_API_URL === 'https://fit-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://fit-scm.truckxi.com/api/';
	var isNBT = _root_url.ROOT_API_URL === 'https://nbt-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://nbt-scm.truckxi.com/api/';
	var isKM = _root_url.ROOT_API_URL === 'https://kingmax-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://kingmax-scm.truckxi.com/api/';
	var isTQ = _root_url.ROOT_API_URL === 'https://topquality-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://topquality-scm.truckxi.com/api/';
	var isOCM = _root_url.ROOT_API_URL === 'https://ocm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ocm-scm.truckxi.com/api/';
	var isATL = _root_url.ROOT_API_URL === 'https://alton-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://alton-scm.truckxi.com/api/';
	var isRS = _root_url.ROOT_API_URL === 'https://redstone-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://redstone-scm.truckxi.com/api/';
	var isKDW = _root_url.ROOT_API_URL === 'https://kdw-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://kdw-scm.truckxi.com/api/';
	var isABCFF = _root_url.ROOT_API_URL === 'https://abcff-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://abcff-scm.truckxi.com/api/';
	var isYI = _root_url.ROOT_API_URL === 'https://ying-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ying-scm.truckxi.com/api/';
	var isFBD = _root_url.ROOT_API_URL === 'https://fbd-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://fbd-scm.truckxi.com/api/';
	var isEZone = _root_url.ROOT_API_URL === 'https://ezone-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ezone-scm.truckxi.com/api/';
	var isWUFS = _root_url.ROOT_API_URL === 'https://wufs-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://wufs-scm.truckxi.com/api/';
	var isSW = _root_url.ROOT_API_URL === 'https://snapwise-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://snapwise-scm.truckxi.com/api/';
	var isCS = _root_url.ROOT_API_URL === 'https://coastsequoia-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://coastsequoia-scm.truckxi.com/api/';
	var isLO = _root_url.ROOT_API_URL === 'https://lonni-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://lonni-scm.truckxi.com/api/';
	var isAmzey = _root_url.ROOT_API_URL === 'https://amzey-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://amzey-scm.truckxi.com/api/';
	var isAN = _root_url.ROOT_API_URL === 'https://asian-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://asian-scm.truckxi.com/api/';
	var isAPO = _root_url.ROOT_API_URL === 'https://admin.apoodr.com/api/' || _root_url.ROOT_URL === 'https://admin.apoodr.com/api/';
	
	var _require = __webpack_require__(5),
	    _require$Draggable = _require.Draggable,
	    DraggableContainer = _require$Draggable.Container,
	    RowActionsCell = _require$Draggable.RowActionsCell,
	    DropTargetRowContainer = _require$Draggable.DropTargetRowContainer,
	    Selectors = _require.Data.Selectors;
	
	var SalesOrder = function (_Component) {
	  _inherits(SalesOrder, _Component);
	
	  function SalesOrder() {
	    _classCallCheck(this, SalesOrder);
	
	    var _this = _possibleConstructorReturn(this, (SalesOrder.__proto__ || Object.getPrototypeOf(SalesOrder)).call(this));
	
	    _this.setDriverListModalVisibility = function () {
	      var driverListModalVisibility = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this.setState({ driverListModalVisibility: driverListModalVisibility });
	    };
	
	    _this.handleAssignSOToDriverSuccess = function () {
	      _this.setDriverListModalVisibility();
	      _this.fetchSalesOrdersByDetails(_this.state.days);
	    };
	
	    _this.setISAEditModalVisibility = function () {
	      var isaEditModalVisibility = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this.setState({ isaEditModalVisibility: isaEditModalVisibility });
	    };
	
	    _this.setCTNEditModalVisibility = function () {
	      var ctnEditModalVisibility = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this.setState({ ctnEditModalVisibility: ctnEditModalVisibility });
	    };
	
	    _this.handleISANoUpdateSuccess = function () {
	      _this.setISAEditModalVisibility();
	      _this.fetchSalesOrdersByDetails(_this.state.days);
	    };
	
	    _this.openPridePrint = function () {
	      _this.setState({ pridePrintVisibility: true });
	    };
	
	    _this.closePridePrint = function () {
	      _this.setState({ pridePrintVisibility: false });
	    };
	
	    _this.onConfirmPridePrint = function () {
	      var selectedRows = _this.state.salesOrders.selectedRows;
	
	
	      var salesOrder_id = [];
	      selectedRows.forEach(function (_ref) {
	        var SalesOrder_id = _ref.SalesOrder_id;
	
	        salesOrder_id.push(SalesOrder_id);
	      });
	      _this.props.printSalesOrderLabelUSPride({ salesOrder_id: salesOrder_id });
	      _this.closePridePrint();
	    };
	
	    _this.handleCTNNoUpdateSuccess = function () {
	      _this.setCTNEditModalVisibility();
	      _this.fetchSalesOrdersByDetails(_this.state.days);
	    };
	
	    _this.openDavisPO = function () {
	      _this.setState({ davisPOVisibility: true });
	    };
	
	    _this.closeDavisPO = function () {
	      _this.setState({ davisPOVisibility: false });
	    };
	
	    _this.setAltonChildVisibility = function () {
	      var isAltonChildVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this.setState({ isAltonChildVisible: isAltonChildVisible });
	    };
	
	    _this.openChowbusModal = function () {
	      _this.setState({ chowbusModalVisibility: true });
	    };
	
	    _this.closeChowbusModal = function () {
	      _this.setState({ chowbusModalVisibility: false, chowbusImportFile: null });
	    };
	
	    _this.onChangeChowbusImport = function (event) {
	      _this.setState({ chowbusImportFile: event.target.files[0] });
	    };
	
	    _this.openVoidNote = function () {
	      _this.setState({ voidNoteModalVisibility: true });
	    };
	
	    _this.closeVoidNote = function () {
	      _this.setState({
	        voidNoteModalVisibility: false,
	        voidReason: "",
	        voidNote: ""
	      });
	    };
	
	    _this.onVoidReasonChange = function (e) {
	      _this.setState({ voidReason: e.value });
	    };
	
	    _this.onVoidNoteChange = function (e) {
	      _this.state.voidNote = e.target.value;
	    };
	
	    _this.closePrintTrackingConfirm = function () {
	      _this.setState({ printTrackingConfirmOpen: false });
	    };
	
	    _this.openPrintTrackingConfirm = function () {
	      _this.setState({ printTrackingConfirmOpen: true });
	    };
	
	    _this.printTrackingConfirm = function () {
	      var trackingNumberSelected = _this.state.trackingNumberSelected;
	
	      _this.props.printSalesOrderLabelBatch(trackingNumberSelected);
	      _this.setState({ printTrackingConfirmOpen: false });
	    };
	
	    _this.onChangeFormNum = function (e) {
	      _this.setState({ trackingformNum: e.target.value });
	    };
	
	    _this.onChangeFormCarrier = function (e) {
	      _this.setState({ trackingformCarrier: e.target.value });
	    };
	
	    _this.onChangeFormMethod = function (e) {
	      _this.setState({ trackingformMethod: e.target.value });
	    };
	
	    _this.confirmTrackingForm = function () {
	      var singleSalesOrderId = _this.state.salesOrders.selectedRows.length === 1 && _this.state.salesOrders.selectedRows[0].SalesOrder_id;
	
	      var data = {
	        tracking: _this.state.trackingformNum,
	        carrier: _this.state.trackingformCarrier,
	        ship_method: _this.state.trackingformMethod
	      };
	
	      _axios2.default.post(_root_url.ROOT_URL + 'v2/shipping/add_tracking_num/' + singleSalesOrderId, data, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        alert("Tracking Info Added");
	        _this.fetchSalesOrdersByDetails(_this.state.days);
	        _this.closeTrackingForm();
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	      });
	    };
	
	    _this.onChangeTrackingNum = function (e) {
	      _this.setState({ newTrackingNum: e.target.value });
	    };
	
	    _this.changeTrackingConfirm = function () {
	      var salesOrders = _this.state.salesOrders;
	
	      var data = { delivery_tracking_num: _this.state.newTrackingNum };
	      if (isUSPride) {
	        data = { Tracking: _this.state.newTrackingNum };
	      }
	      // let data = null;
	      // if (salesOrders && salesOrders.selectedRows) {
	      //   salesOrders.selectedRows[0].delivery_tracking_num = this.state.newTrackingNum;
	      //   data = salesOrders.selectedRows[0];
	      // }
	
	      // axios here
	      _axios2.default.put(_url.CHANGE_TRACKING_URL + _this.state.newTrackingNumID,
	      // (SALES_ORDERS_URL + this.state.newTrackingNumID),
	      data, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        alert("Tracking Number Changed");
	        _this.fetchSalesOrdersByDetails(_this.state.days);
	        _this.setState({ changeTrackingOpen: false });
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	      });
	
	      // const route = this.context.router.routes[1].path;
	      // this.props.fetchSalesOrdersByFilter(
	      //   this.state.FromDate,
	      //   this.state.ToDate,
	      //   this.state.days,
	      //   this.state.Status,
	      //   null,
	      //   null,
	      //   route,
	      //   this.state.dispatchDateLT,
	      //   this.state.dispatchDateGT,
	      //   null,
	      //   this.state.limit,
	      //   this.state.currentPage,
	      //   this.state.searchFilter,
	      // );
	    };
	
	    _this.onChangeBolNumber = function (e) {
	      _this.setState({ BLNum: e.target.value });
	    };
	
	    _this.onChangeSealNumber = function (e) {
	      _this.setState({ SealNum: e.target.value });
	    };
	
	    _this.onChangeProNumber = function (e) {
	      _this.setState({ ProNum: e.target.value });
	    };
	
	    _this.onChangeCarrierNumber = function (e) {
	      _this.setState({ Carrier: e.target.value });
	    };
	
	    _this.confirmChangeBolNumber = function () {
	      var salesOrders = _this.state.salesOrders;
	
	      var data = { DestinationAddress_id: _this.state.drayageSelected, BLNum: _this.state.BLNum, SealNum: _this.state.SealNum, ProNum: _this.state.ProNum, Carrier: _this.state.Carrier };
	      var salesOrderIds = [];
	      if (salesOrders && salesOrders.selectedRows) {
	        salesOrders.selectedRows.forEach(function (salesOrder) {
	          salesOrderIds.push(salesOrder.SalesOrder_id);
	        });
	      }
	
	      var ids = salesOrderIds.join(",");
	
	      // axios here
	      _axios2.default.put(_url.ASSIGN_BOL_URL + ids, data, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        alert("BOL Number Assigned");
	        _this.fetchSalesOrdersByDetails(_this.state.days);
	        _this.setState({ openAssignBolVisibility: false });
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	      });
	    };
	
	    _this.confirmGetPickup = function () {
	      var salesOrders = _this.state.salesOrders;
	      // let data = {DestinationAddress_id: this.state.drayageSelected, BLNum: this.state.BLNum, SealNum: this.state.SealNum, ProNum: this.state.ProNum, Carrier: this.state.Carrier};
	
	      var salesOrderIds = [];
	      if (salesOrders && salesOrders.selectedRows) {
	        salesOrders.selectedRows.forEach(function (salesOrder) {
	          salesOrderIds.push(salesOrder.SalesOrder_id);
	        });
	      }
	
	      var ids = salesOrderIds.join(",");
	      var pickupString = "";
	      _this.setState({ xpoLoading: true });
	      // axios here
	      _axios2.default.get(_url.GET_PICKUP_URL + ids,
	      // (GET_QUOTE_URL + 6),
	      // data,
	      {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        pickupString = JSON.stringify(response.data.data.pickupRequestInfo, null, 2);
	        _this.setState({ pickupVisibility: true, pickupString: pickupString, xpoLoading: false });
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	        _this.setState({ xpoLoading: false });
	      });
	    };
	
	    _this.confirmGetQuote = function () {
	      var salesOrders = _this.state.salesOrders;
	      // let data = {DestinationAddress_id: this.state.drayageSelected, BLNum: this.state.BLNum, SealNum: this.state.SealNum, ProNum: this.state.ProNum, Carrier: this.state.Carrier};
	
	      var salesOrderIds = [];
	      if (salesOrders && salesOrders.selectedRows) {
	        salesOrders.selectedRows.forEach(function (salesOrder) {
	          salesOrderIds.push(salesOrder.SalesOrder_id);
	        });
	      }
	
	      var ids = salesOrderIds.join(",");
	      var xpoString = {};
	      _this.setState({ xpoLoading: true });
	      _axios2.default.get(_url.GET_QUOTE_URL + ids,
	      // (GET_QUOTE_URL + 6),
	      // data,
	      {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        // xpoString = JSON.stringify(response.data, null, 2);
	        xpoString = response.data;
	        _this.setState({ xpoQuoteVisibility: true, xpoString: xpoString, xpoLoading: false });
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	        _this.setState({ xpoLoading: false });
	      });
	    };
	
	    _this.confirmPostPickup = function () {
	      var _this$state = _this.state,
	          salesOrders = _this$state.salesOrders,
	          xpoPickupDate = _this$state.xpoPickupDate,
	          xpoReadyDate = _this$state.xpoReadyDate,
	          xpoCloseDate = _this$state.xpoCloseDate;
	      // let data = {DestinationAddress_id: this.state.drayageSelected, BLNum: this.state.BLNum, SealNum: this.state.SealNum, ProNum: this.state.ProNum, Carrier: this.state.Carrier};
	
	      var salesOrderIds = [];
	      if (salesOrders && salesOrders.selectedRows) {
	        salesOrders.selectedRows.forEach(function (salesOrder) {
	          salesOrderIds.push(salesOrder.SalesOrder_id);
	        });
	      }
	
	      var ids = salesOrderIds.join(",");
	      var pickupString = "";
	      var data = {
	        pickup: xpoPickupDate,
	        ready: xpoReadyDate,
	        close: xpoCloseDate
	      };
	      _this.setState({ xpoLoading: true, pickupLoading: true });
	      _axios2.default.post(_url.GET_PICKUP_URL + ids,
	      // (GET_QUOTE_URL + 6),
	      data, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        alert("Pickup Created: " + JSON.stringify(response.data, null, 2));
	        _this.setState({ pickupSelectionVisibility: false, xpoLoading: false, pickupLoading: false });
	        // pickupString = JSON.stringify(response.data, null, 2);
	        // this.setState({ pickupSelectionVisibility: false, pickupVisibility: true, pickupString, xpoLoading: false });
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data.message));
	        _this.setState({ xpoLoading: false, pickupLoading: false });
	      });
	    };
	
	    _this.confirmPostQuote = function () {
	      var salesOrders = _this.state.salesOrders;
	      // let data = {DestinationAddress_id: this.state.drayageSelected, BLNum: this.state.BLNum, SealNum: this.state.SealNum, ProNum: this.state.ProNum, Carrier: this.state.Carrier};
	
	      var salesOrderIds = [];
	      if (salesOrders && salesOrders.selectedRows) {
	        salesOrders.selectedRows.forEach(function (salesOrder) {
	          salesOrderIds.push(salesOrder.SalesOrder_id);
	        });
	      }
	
	      var ids = salesOrderIds.join(",");
	      var xpoString = "";
	      var data = null;
	      _this.setState({ xpoLoading: true });
	      _axios2.default.post(_url.GET_QUOTE_URL + ids,
	      // (GET_QUOTE_URL + 6),
	      data, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        alert("Quote Created. Quote ID: " + response.data);
	        _this.setState({ xpoLoading: false });
	        // xpoString = JSON.stringify(response.data, null, 2);
	        // this.setState({ xpoQuoteVisibility: true, xpoString, xpoLoading: false });
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	        _this.setState({ xpoLoading: false });
	      });
	    };
	
	    _this.confirmCreateBOL = function () {
	      var salesOrders = _this.state.salesOrders;
	      // let data = {DestinationAddress_id: this.state.drayageSelected, BLNum: this.state.BLNum, SealNum: this.state.SealNum, ProNum: this.state.ProNum, Carrier: this.state.Carrier};
	
	      var salesOrderIds = [];
	      if (salesOrders && salesOrders.selectedRows) {
	        salesOrders.selectedRows.forEach(function (salesOrder) {
	          salesOrderIds.push(salesOrder.SalesOrder_id);
	        });
	      }
	      var data = null;
	      var ids = salesOrderIds.join(",");
	      _axios2.default.post(_url.YING_BOL_URL + ids,
	      // (GET_QUOTE_URL + 6),
	      data, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        // alert("BOL Number Assigned");
	        // this.fetchSalesOrdersByDetails(
	        //   this.state.days
	        // );
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	      });
	    };
	
	    _this.confirmAddTracking = function () {
	      var salesOrders = _this.state.salesOrders;
	
	      var data = { addTrackingNumber: _this.state.addTrackingNumber };
	      var salesOrderIds = [];
	      if (salesOrders && salesOrders.selectedRows) {
	        salesOrders.selectedRows.forEach(function (salesOrder) {
	          salesOrderIds.push(salesOrder.SalesOrder_id);
	        });
	      }
	
	      var ids = salesOrderIds.join(",");
	      _axios2.default.put(_url.ADD_TRACKING_URL + ids, data, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        alert("Added Tracking Number");
	        _this.fetchSalesOrdersByDetails(_this.state.days);
	        _this.setState({ addTrackingOpen: false });
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	      });
	    };
	
	    _this.confirmExpressShip = function () {
	      var soPKs = _this.state.salesOrders.selectedRows.map(function (row) {
	        return row.SalesOrder_id;
	      });
	      var success = function success() {
	        if (isTN) {
	          _this.closeExpressShipVisibility();
	        }
	        _this.refreshSOList();
	      };
	      if (isTN && !_this.state.expressShipDate) {
	        alert("Please select a ship date");
	        return;
	      }
	      (0, _sales_actions.expressMultipleSOInvoices)(soPKs, success, _this.state.expressShipDate);
	    };
	
	    _this.handleSOPaymentMethodSaved = function (so_id, method) {
	      _this.closePaymentMethodModal();
	      var salesOrderRows = [].concat(_toConsumableArray(_this.state.salesOrders.rows));
	      var newRows = salesOrderRows.map(function (row) {
	        if (row.SalesOrder_id === so_id) {
	          return _extends({}, row, {
	            PaymentType: method
	          });
	        }
	        return row;
	      });
	      _this.setState({
	        salesOrders: _extends({}, _this.state.salesOrders, {
	          rows: newRows
	        })
	      });
	      // const route = this.context.router.routes[1].path;
	      // const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
	      // const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
	      // const days = this.state.days;
	      // const productNum = this.state.filterProductID;
	      // const seller = this.props.Seller;
	      // setTimeout(() => {
	      //   this.props.fetchSalesOrdersByFilter(fromDate, toDate, days, this.state.Status, seller, productNum, route);
	      // }, 1000);
	    };
	
	    _this.onChangeWeightSubmit = function (splitArray) {
	      var salesOrder_id = _this.state.salesOrders.selectedRows.length === 1 && _this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      _this.props.updateShippingWeightSplit(salesOrder_id, splitArray);
	      _this.setState({ changeWeightOpen: false });
	      var route = _this.context.router.routes[1].path;
	      var fromDate = _this.state.FromDate ? _this.formatDate(_this.state.FromDate) : "1900-01-01";
	      var toDate = _this.state.ToDate ? _this.formatDate(_this.state.ToDate) : "3000-01-01";
	      var days = _this.state.days;
	      var productNum = _this.state.filterProductID;
	      var seller = _this.props.Seller;
	      setTimeout(function () {
	        _this.props.fetchSalesOrdersByFilter(fromDate, toDate, days, _this.state.Status, seller, productNum, route, null, null, null, _this.state.limit, _this.state.currentPage, _this.state.searchFilter, _this.props.Warehouse_id);
	      }, 1000);
	    };
	
	    _this.onChangeWeightSubmitPrint = function (splitArray) {
	      var salesOrder_id = _this.state.salesOrders.selectedRows.length === 1 && _this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      if (_this.state.salesOrders.selectedRows[0].InvoiceNum === "" || !_this.state.salesOrders.selectedRows[0].InvoiceNum) {
	        alert("Cannot print without Invoice Number");
	        return;
	      }
	      _this.props.updateShippingWeightSplit(salesOrder_id, splitArray);
	      _this.setState({ changeWeightOpen: false });
	      var route = _this.context.router.routes[1].path;
	      var fromDate = _this.state.FromDate ? _this.formatDate(_this.state.FromDate) : "1900-01-01";
	      var toDate = _this.state.ToDate ? _this.formatDate(_this.state.ToDate) : "3000-01-01";
	      var days = _this.state.days;
	      var productNum = _this.state.filterProductID;
	      var seller = _this.props.Seller;
	      _this.props.fetchSalesOrdersByFilter(fromDate, toDate, days, _this.state.Status, seller, productNum, route, null, null, null, _this.state.limit, _this.state.currentPage, _this.state.searchFilter, _this.props.Warehouse_id);
	      var SalesOrder_id = [];
	      SalesOrder_id.push(salesOrder_id);
	      setTimeout(function () {
	        _this.props.printSalesOrderLabelBatch(SalesOrder_id);
	      }, 1000);
	    };
	
	    _this.onShippingWeightChange = function (e) {
	      _this.setState({
	        finalShippingWeight: e.target.value
	      });
	    };
	
	    _this.onUSPridePlatformChange = function (e) {
	      if (e && e.value) {
	        _this.setState({ USPridePlatform: e.value });
	      } else {
	        _this.setState({ USPridePlatform: "" });
	      }
	    };
	
	    _this.onUSPrideCustomerChange = function (e) {
	      if (e && e.value) {
	        _this.setState({ USPrideCustomer: e.value });
	      } else {
	        _this.setState({ USPrideCustomer: "" });
	      }
	    };
	
	    _this.sendEmailUpdate = function (val) {
	      var joinedString = val.join(',');
	      var data = null;
	      _axios2.default.post(_url.EMAIL_UPDATE + joinedString, data, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        alert("Email Update Sent!");
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	      });
	    };
	
	    _this.sendEmailPod = function (val) {
	      var joinedString = val.join(',');
	      var data = null;
	      _axios2.default.post(_url.EMAIL_POD + joinedString, data, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        alert("Email Update Sent!");
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	      });
	    };
	
	    _this.completeOB = function (val) {
	      var joinedString = val.join(',');
	      var data = null;
	      _axios2.default.post(_url.COMPLETE_OB + joinedString, data, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        alert("Outbound Order Completed!");
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	      });
	    };
	
	    _this.changeOutboundStatus = function (ids, val) {
	      var joinedString = ids.join(',');
	      var data = { OutboundStatus: val };
	      _axios2.default.put(
	      // (CHANGE_OB_STATUS_URL + joinedString),
	      _url.ASSIGN_BOL_URL + joinedString, data, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        alert("Outbound Status Changed!");
	        _this.fetchSalesOrdersByDetails(_this.state.days);
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	      });
	    };
	
	    _this.resyncOrder = function (ids) {
	      // let joinedString = ids.join(',');
	      // let data = {OutboundStatus: val};
	      var joinedString = ids;
	      var data = null;
	      _axios2.default.post(
	      // (CHANGE_OB_STATUS_URL + joinedString),
	      _url.RESYNC_URL + joinedString, data, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        alert("Order Resynced!");
	        _this.fetchSalesOrdersByDetails(_this.state.days);
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	      });
	    };
	
	    _this.onQuoteCustomerChange = function (e) {
	      if (e) {
	        _this.setState({
	          quoteSelectedCustomerId: e.value,
	          quoteSelectedCustomerName: e.label
	        });
	      } else {
	        _this.setState({
	          quoteSelectedCustomerId: null,
	          quoteSelectedCustomerName: ""
	        });
	      }
	    };
	
	    _this.setDeliveryTimeSelectModalVisibility = function () {
	      var deliveryTimeSelectVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this.setState({ deliveryTimeSelectVisible: deliveryTimeSelectVisible });
	    };
	
	    _this.setPickupTimeSelectModalVisibility = function () {
	      var pickupTimeSelectVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this.setState({ pickupTimeSelectVisible: pickupTimeSelectVisible });
	    };
	
	    _this.onChangeBolAddress = function (address) {
	      _this.setState({ bolAddressFBA: address.value });
	    };
	
	    _this.onPullSheetChange = function (e) {
	      _this.state.pullSheetAmount = e.target.value;
	    };
	
	    _this.handleOptionChange = function (changeEvent) {
	      _this.setState({ searchType: changeEvent.target.value });
	    };
	
	    _this.quoteConversion = function () {
	      var route = _this.context.router.routes[1].path;
	      var status = _this.state.salesOrders.selectedRows[0].SaleStatus;
	      var id = _this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      if (status === "Open") {
	        _this.props.orderToQuote(id).then(function () {
	          var seller = _this.props.Seller;
	          var fromDate = _this.state.FromDate ? _this.formatDate(_this.state.FromDate) : "1900-01-01";
	          var toDate = _this.state.ToDate ? _this.formatDate(_this.state.ToDate) : "3000-01-01";
	          var days = _this.state.days;
	          var productNum = _this.state.filterProductID;
	          _this.props.fetchSalesOrdersByFilter(fromDate, toDate, days, _this.state.Status, seller, productNum, route, null, null, null, _this.state.limit, _this.state.currentPage, _this.state.searchFilter, _this.props.Warehouse_id);
	        });
	      } else if (status === "Quote") {
	        _this.props.quoteToOrder(id).then(function () {
	          var seller = _this.props.Seller;
	          var fromDate = _this.state.FromDate ? _this.formatDate(_this.state.FromDate) : "1900-01-01";
	          var toDate = _this.state.ToDate ? _this.formatDate(_this.state.ToDate) : "3000-01-01";
	          var days = _this.state.days;
	          var productNum = _this.state.filterProductID;
	          _this.props.fetchSalesOrdersByFilter(fromDate, toDate, days, _this.state.Status, seller, productNum, route, null, null, null, _this.state.limit, _this.state.currentPage, _this.state.searchFilter, _this.props.Warehouse_id);
	        });
	      }
	    };
	
	    _this.quoteButton = function () {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'reset',
	          disabled: _this.shouldQuoteButtonDisable(),
	          onClick: function onClick() {
	            _this.quoteConversion();
	          }
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: _this.state.title })
	      );
	    };
	
	    _this.setToDate = function (e) {
	      if (e < _this.state.FromDate) {
	        return;
	      }
	      _this.setState({ ToDate: e });
	    };
	
	    _this.setFromDate = function (e) {
	      if ((_this.state.ToDate || !(isATL || isUSPride)) && e > _this.state.ToDate) {
	        return;
	      }
	      _this.setState({ FromDate: e });
	    };
	
	    _this.setFromDispatchDate = function (e) {
	      if ((_this.state.dispatchDateGT || !(isATL || isUSPride)) && e > _this.state.dispatchDateGT) {
	        return;
	      }
	      _this.setState({ dispatchDateLT: e });
	    };
	
	    _this.setToDispatchDate = function (e) {
	      if (e < _this.state.dispatchDateLT) {
	        return;
	      }
	      _this.setState({
	        dispatchDateGT: e
	      });
	    };
	
	    _this.setToRangeSearch = function () {
	      if (isATL || isUSPride) {
	        _this.setState({ dispatchDays: null, dispatchDateLT: null, dispatchDateGT: null });
	      }
	      _this.setState({ days: "-1" });
	    };
	
	    _this.setToDispatchRangeSearch = function () {
	      if (isATL || isUSPride) {
	        _this.setState({ days: null, FromDate: null, ToDate: null });
	      }
	      _this.setState({ dispatchDays: "-1" });
	    };
	
	    _this.fetchSalesOrdersByProduct = function (productID) {
	      var dateRange = -1;
	      var FromDate = "1900-01-01";
	      var ToDate = "3000-01-01";
	      var seller = _this.props.Seller;
	      var route = _this.context.router.routes[1].path;
	      var productNum = productID;
	      if (_this.state.FromDate != null) {
	        FromDate = _this.formatDate(_this.state.FromDate);
	      }
	
	      if (_this.state.ToDate != null) {
	        ToDate = _this.formatDate(_this.state.ToDate);
	      }
	
	      if (_this.state.days != null) {
	        dateRange = _this.state.days;
	      }
	      if (_this.props.Seller) {
	        seller = _this.props.Seller.value;
	      }
	      _this.setState({
	        filteredByItem: true,
	        selectedRows: [{}],
	        filterProductID: productID
	      });
	      _this.props.fetchSalesOrdersByFilter(FromDate, ToDate, dateRange, _this.state.Status, seller, productNum, route, null, null, null, _this.state.limit, _this.state.currentPage, _this.state.searchFilter, _this.props.Warehouse_id);
	    };
	
	    _this.shippingIFrameIsLoaded = function () {
	      if (!_this.state.shippingPdfFrameLoaded) {
	        var pdfFrame = window.frames.shippingPdf;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this.setState({ shippingPdfFrameLoaded: true });
	      }
	    };
	
	    _this.packingIFrameIsLoaded = function () {
	      if (!_this.state.packingListPdfFrameLoaded) {
	        var pdfFrame = window.frames.packingPdf;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this.setState({ packingListPdfFrameLoaded: true });
	      }
	    };
	
	    _this.pickingIFrameIsLoaded = function () {
	      if (!_this.state.pickingListPdfFrameLoaded) {
	        var pdfFrame = window.frames.pickingPdf;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this.setState({ pickingListPdfFrameLoaded: true });
	      }
	    };
	
	    _this.salesOrderIFrameIsLoaded = function () {
	      if (!_this.state.salesOrderPdfFrameLoaded) {
	        var pdfFrame = window.frames.salesOrderPdf;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this.setState({ salesOrderPdfFrameLoaded: true });
	      }
	    };
	
	    _this.bolByIdIFrameIsLoaded = function () {
	      if (!_this.state.bolIdPdfFrameLoaded) {
	        var pdfFrame = window.frames.bolIdPdf;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this.setState({ bolIdPdfFrameLoaded: true });
	      }
	    };
	
	    _this.bolWithoutLogIFrameIsLoaded = function () {
	      if (!_this.state.bolWithoutLogPdfFrameLoaded) {
	        var pdfFrame = window.frames.bolWithoutLogPdf;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this.setState({ bolWithoutLogPdfFrameLoaded: true });
	      }
	    };
	
	    _this.bolLabelIFrameIsLoaded = function () {
	      if (!_this.state.bolLabelFrameLoaded) {
	        var pdfFrame = window.frames.bolLabel;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this.setState({ bolLabelFrameLoaded: true });
	      }
	    };
	
	    _this.bolByFbaIFrameIsLoaded = function () {
	      if (!_this.state.bolFbaPdfFrameLoaded) {
	        var pdfFrame = window.frames.bolFbaPdf;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this.setState({ bolFbaPdfFrameLoaded: true });
	      }
	    };
	
	    _this.PODIframLoaded = function () {
	      if (!_this.state.PODIframeLoaded) {
	        var pdfFrame = window.frames.podPdf;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this.setState({ PODIframeLoaded: true });
	      }
	    };
	
	    _this.setLabelPrintModalVisibility = function () {
	      var isLabelPrintModalVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this.setState({ isLabelPrintModalVisible: isLabelPrintModalVisible });
	    };
	
	    _this.renderSetSOOpen = function () {
	      var salesOrderIds = [];
	      var selectedRows = _this.state.salesOrders.selectedRows;
	
	      var success = function success() {
	        alert('success');
	        _this.refreshSOList();
	      };
	      var failed = function failed() {
	        alert('failed');
	      };
	      var handleSetOpenClick = function handleSetOpenClick() {
	        var SalesOrderids = selectedRows.map(function (so) {
	          return so.SalesOrder_id;
	        });
	        _this.props.setOrdersToOpen(SalesOrderids.join(','), success, failed);
	      };
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          className: 'print-btn',
	          disabled: false,
	          type: 'button',
	          onClick: function onClick() {
	            handleSetOpenClick();
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'set_open' })
	      );
	    };
	
	    _this.renderUploadPODButton = function () {
	      var selectedRows = _this.state.salesOrders.selectedRows;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('input', {
	          type: 'file',
	          ref: 'uploadPODRef',
	          onChange: function onChange(e) {
	            var file = e.target.files[0];
	            var formData = new FormData();
	            formData.append('PODFile', file);
	            var succes = function succes() {
	              alert('success');
	              _this.fetchSalesOrdersByDetails(_this.state.days);
	            };
	            if (isTN) {
	              (0, _sales_actions.podUPloadSCM)(selectedRows[0].SalesOrder_id, formData, succes);
	            } else {
	              (0, _sales_actions.podUpload)(selectedRows[0].SalesOrder_id, formData, succes);
	            }
	          },
	          style: { display: 'none' }
	        }),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            className: 'print-btn',
	            type: 'button',
	            disabled: selectedRows.length !== 1,
	            onClick: function onClick() {
	              _this.refs.uploadPODRef.click();
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-upload' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'POD_upload' })
	        )
	      );
	    };
	
	    _this.renderUploadMSOButton = function () {
	      if (!isAmzey) return null;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'print-btn',
	          type: 'button'
	          // disabled={selectedRows.length !== 1}
	          , onClick: function onClick() {
	            _this.refs.uploadMSORef.click();
	          }
	        },
	        _react2.default.createElement('input', {
	          type: 'file',
	          ref: 'uploadMSORef',
	          onChange: function onChange(e) {
	            var file = e.target.files[0];
	            var formData = new FormData();
	            formData.append('FILE', file);
	            var succes = function succes() {
	              alert('success');
	              _this.refreshSOList();
	              // this.fetchSalesOrdersByDetails(this.state.days);
	            };
	            (0, _sales_actions.uploadMSO)(formData, succes);
	            _this.refs.uploadMSORef.value = "";
	          },
	          style: { display: 'none' }
	        }),
	        _react2.default.createElement('em', { className: 'fa fa-upload' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mso_upload' })
	      );
	    };
	
	    _this.renderSetOpen = function () {
	      var selectedRows = _this.state.salesOrders.selectedRows;
	
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'print-btn',
	          type: 'button',
	          disabled: selectedRows.length !== 1,
	          onClick: function onClick() {
	            var status = selectedRows[0].SaleStatus;
	            if (status !== 'Released') {
	              _this.props.setOrderToOpen(selectedRows[0].SalesOrder_id, _this.refreshSOList);
	            } else {
	              alert('can not set order to open after Released');
	            }
	          }
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'set_open' })
	      );
	    };
	
	    _this.setLocationChangeModalVisibility = function () {
	      var isLocationChangeModalVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this.setState({ isLocationChangeModalVisible: isLocationChangeModalVisible });
	    };
	
	    _this.setInboundDateChangeModalVisibility = function () {
	      var isInboundDateChangeModalVisibile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this.setState({ isInboundDateChangeModalVisibile: isInboundDateChangeModalVisibile });
	    };
	
	    _this.handleLocationChangeSuccess = function () {
	      _this.refreshSOList();
	      _this.setLocationChangeModalVisibility();
	      _this.setInboundDateChangeModalVisibility();
	    };
	
	    _this.renderLocatioinChangeButton = function () {
	      var selectedRows = _this.state.salesOrders.selectedRows;
	
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          className: 'print-btn',
	          type: 'button',
	          disabled: selectedRows.length !== 1,
	          onClick: function onClick() {
	            _this.setLocationChangeModalVisibility(true);
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location_edit' })
	      );
	    };
	
	    _this.renderInboundDateEditButton = function () {
	      var selectedRows = _this.state.salesOrders.selectedRows;
	
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          className: 'print-btn',
	          type: 'button',
	          disabled: selectedRows.length !== 1,
	          onClick: function onClick() {
	            _this.setInboundDateChangeModalVisibility(true);
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'other_info_edit' })
	      );
	    };
	
	    _this.estDeliveryTimeEditButton = function () {
	      var salesOrder_id = _this.state.salesOrders.selectedRows.length === 1 && _this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'print-btn',
	          type: 'button',
	          disabled: _this.state.salesOrders.selectedRows.length !== 1,
	          onClick: function onClick() {
	            var ShippingMethod = _this.state.salesOrders.selectedRows[0].ShippingMethod;
	            if (ShippingMethod === 'Delivery') {
	              _this.setDeliveryTimeSelectModalVisibility(true);
	            } else {
	              _this.setPickupTimeSelectModalVisibility(true);
	            }
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-pen' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delivery_date' })
	      );
	    };
	
	    _this.renderPrintBolKDW = function () {
	      var selectedRows = _this.state.salesOrders.selectedRows;
	
	
	      if (!_this.props.requestingSalesOrderPDF) {
	        return _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            className: 'print-btn',
	            disabled: selectedRows.length < 1,
	            onClick: function onClick() {
	              var salesOrder_id = [];
	              selectedRows.forEach(function (_ref2) {
	                var SalesOrder_id = _ref2.SalesOrder_id;
	
	                salesOrder_id.push(SalesOrder_id);
	              });
	              var ids = salesOrder_id.join(',');
	              _this.props.printSalesOrderLabelUSPride(ids);
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-print' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bol' })
	        );
	      } else {
	        return _react2.default.createElement(_SpinnerButton2.default, {
	          bsStyle: 'success',
	          disabled: true,
	          icon: 'fa-print',
	          translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bol' }),
	          loading: true,
	          onClick: function onClick() {
	            console.log('loading');
	          }
	        });
	      }
	    };
	
	    _this.renderPrintLabelUSPride = function () {
	      var selectedRows = _this.state.salesOrders.selectedRows;
	
	
	      var hasTracking = false;
	      selectedRows.map(function (r) {
	        if (r.TrackingNum) {
	          hasTracking = true;
	        }
	      });
	
	      if (!_this.props.requestingSalesOrderPDF) {
	        return _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            className: 'print-btn',
	            disabled: selectedRows.length < 1,
	            onClick: function onClick() {
	              var salesOrder_id = [];
	              selectedRows.forEach(function (_ref3) {
	                var SalesOrder_id = _ref3.SalesOrder_id;
	
	                salesOrder_id.push(SalesOrder_id);
	              });
	              if (hasTracking) {
	                _this.openPridePrint();
	              } else {
	                _this.props.printSalesOrderLabelUSPride({ salesOrder_id: salesOrder_id });
	              }
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-print' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_shipping' })
	        );
	      } else {
	        return _react2.default.createElement(_SpinnerButton2.default, {
	          bsStyle: 'success',
	          disabled: true,
	          icon: 'fa-print',
	          translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_shipping' }),
	          loading: true,
	          onClick: function onClick() {
	            console.log('loading');
	          }
	        });
	      }
	    };
	
	    _this.renderReprintLabelUSPride = function () {
	      var selectedRows = _this.state.salesOrders.selectedRows;
	
	      var missingTracking = false;
	      selectedRows.map(function (r) {
	        if (!r.TrackingNum) {
	          missingTracking = true;
	        }
	      });
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          className: 'print-btn',
	          disabled: selectedRows.length < 1 || missingTracking,
	          onClick: function onClick() {
	            var salesOrder_id = [];
	            selectedRows.forEach(function (_ref4) {
	              var SalesOrder_id = _ref4.SalesOrder_id;
	
	              salesOrder_id.push(SalesOrder_id);
	            });
	            _this.props.reprintSalesOrderLabelUSPride({ salesOrder_id: salesOrder_id });
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reprint_shipping' })
	      );
	    };
	
	    _this.renderSendEmailButton = function () {
	      var selectedRows = _this.state.salesOrders.selectedRows;
	
	      var salesOrder_id = _this.state.salesOrders.selectedRows.length === 1 && _this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'print-btn',
	          disabled: selectedRows.length !== 1,
	          type: 'button',
	          onClick: function onClick() {
	            _this.props.emailSO(salesOrder_id);
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-email' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email_so' })
	      );
	    };
	
	    _this.genSubjectTemplate = function () {
	      if (isCalco) {
	        var row = _this.state.salesOrders.selectedRows[0];
	        if (row) {
	          var soNum = row.SONum;
	          return 'Sales Order ' + soNum;
	        }
	      }
	      return '';
	    };
	
	    _this.genContentTemplate = function () {
	      return 'Dear Customer:\n\nYour sales order is attached. Please review the list of items on order.\nThank you for your business - we appreciate it very much\n\nSincerely.';
	    };
	
	    _this.handleEmailContentConfirm = function (subject, content, email, phone, sendEmail, source) {
	      var row = _this.state.salesOrders.selectedRows[0];
	      _this.props.emailSOCalco(row.SalesOrder_id);
	      // if(row) {
	      //   this.props.emailSOCalco(row.SalesOrder_id, subject, content, email, phone, sendEmail, source);
	      //   this.handleEmailContentClose();
	      // }
	    };
	
	    _this.handleEmailContentClose = function () {
	      _this.setState({
	        emailContentModalVisibility: false,
	        emailSubjectModalTemplate: '',
	        emailContentModalTemplate: ''
	      });
	    };
	
	    _this.renderSendSO = function () {
	      var selectedRows = _this.state.salesOrders.selectedRows;
	
	      var salesOrder_id = _this.state.salesOrders.selectedRows.length === 1 && _this.state.salesOrders.selectedRows[0].SalesOrder_id;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'print-btn',
	          disabled: selectedRows.length !== 1,
	          type: 'button',
	          onClick: function onClick() {
	            _this.handleEmailContentConfirm();
	            return;
	            _this.setState({
	              emailSubjectTemplate: _this.genSubjectTemplate(),
	              emailContentTemplate: _this.genContentTemplate(),
	              emailContentModalVisibility: true,
	              source: "SO"
	            });
	          }
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: "send_so" })
	      );
	    };
	
	    _this.renderAssignDriverButton = function () {
	      var selectedRows = _this.state.salesOrders.selectedRows;
	
	      return _react2.default.createElement(
	        _reactBootstrap.DropdownButton,
	        {
	          bsStyle: 'primary',
	          title: _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('i', { className: 'fa fa-print' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: ' Assign_to_driver' })
	          ),
	          className: 'assign_to_driver_dropdown'
	        },
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            className: 'print-btn',
	            disabled: selectedRows.length !== 1,
	            type: 'button',
	            onClick: function onClick() {
	              _this.setState({
	                assigningInboundDriver: true,
	                assigningOutboundDriver: false
	              }, function () {
	                return _this.setDriverListModalVisibility(true);
	              });
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-car' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Assign_inbound_driver' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            className: 'print-btn',
	            disabled: selectedRows.length !== 1,
	            type: 'button',
	            onClick: function onClick() {
	              _this.setState({
	                assigningInboundDriver: false,
	                assigningOutboundDriver: true
	              }, function () {
	                return _this.setDriverListModalVisibility(true);
	              });
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-car' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Assign_outbound_driver' })
	        )
	      );
	    };
	
	    _this.openDownloadModal = function (ids, url) {
	      var data = { pk: ids };
	      _this.setState({ openDownloadModalLoading: true });
	      _axios2.default.post(url, data, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        if (response.data) {
	          _this.setState({ openDownloadModalUrl: response.data.url, openDownloadModalVisibility: true, openDownloadModalLoading: false });
	        }
	      }, function (err) {
	        // this.setState({openDownloadModalUrl: 'https://www.google.com/search?q=google&oq=google&aqs=chrome..69i57j46i131i199i433i465i512j0i433i512l2j69i60l4.687j0j7&sourceid=chrome&ie=UTF-8', openDownloadModalVisibility: true});
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	        _this.setState({ openDownloadModalLoading: false });
	      });
	      // this.setState({openDownloadModalVisibility: true});
	    };
	
	    _this.openDownloadModal2 = function (ids, url) {
	      var _this$state2 = _this.state,
	          FromDate = _this$state2.FromDate,
	          ToDate = _this$state2.ToDate,
	          days = _this$state2.days;
	
	      var status = _this.state.Status === "all" ? "" : '&SaleStatus=' + _this.state.Status;
	      var dateRange = days || -1;
	
	      var _toFromDates = (0, _cleanDates.toFromDates)(dateRange, FromDate, ToDate),
	          fromDate = _toFromDates.fromDate,
	          toDate = _toFromDates.toDate;
	
	      var data = {
	        // pk: ids,
	        date_1: fromDate,
	        date_2: toDate
	      };
	
	      _this.setState({ openDownloadModalLoading: true });
	      _axios2.default.post(url, data, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        if (response.data) {
	          _this.setState({ openDownloadModalUrl: response.data.url, openDownloadModalVisibility: true, openDownloadModalLoading: false });
	        }
	      }, function (err) {
	        // this.setState({openDownloadModalUrl: 'https://www.google.com/search?q=google&oq=google&aqs=chrome..69i57j46i131i199i433i465i512j0i433i512l2j69i60l4.687j0j7&sourceid=chrome&ie=UTF-8', openDownloadModalVisibility: true});
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	        _this.setState({ openDownloadModalLoading: false });
	      });
	      // this.setState({openDownloadModalVisibility: true});
	    };
	
	    _this.closeDownloadModal = function () {
	      _this.setState({ openDownloadModalVisibility: false, openDownloadModalUrl: null });
	    };
	
	    _this.openXPOModal = function () {
	      _this.setState({ xpoQuoteVisibility: true });
	    };
	
	    _this.closeXPOModal = function () {
	      _this.setState({ xpoQuoteVisibility: false });
	    };
	
	    _this.openPickupModal = function () {
	      _this.setState({ pickupVisibility: true });
	    };
	
	    _this.closePickupModal = function () {
	      _this.setState({ pickupVisibility: false });
	    };
	
	    _this.openPickupSelectionModal = function () {
	      _this.setState({ pickupSelectionVisibility: true, xpoPickupDate: null, xpoReadyDate: null, xpoCloseDate: null });
	    };
	
	    _this.closePickupSelectionModal = function () {
	      _this.setState({ pickupSelectionVisibility: false });
	    };
	
	    _this.onRowValueChange = function (event, rowValues, type) {
	      // merge updated row with current row and rerender by setting state
	      _this.setState({ sortColumn: null, sortDirection: null });
	      var rows = JSON.parse(JSON.stringify(_this.state.rows));
	      var editedRows = _this.state.editedRows.slice(0);
	      rows[rowValues.Index][type] = event.target.value;
	      editedRows.forEach(function (element, idx) {
	        if (element.Index === rows[rowValues.Index].Index) {
	          editedRows.splice(idx, 1);
	        }
	      }, _this);
	      // push the row into the editedRows array
	      editedRows.push(rows[rowValues.Index]);
	      _this.setState({
	        rows: rows,
	        editedRows: editedRows
	      });
	    };
	
	    _this.renderInvoiceNoSearchInput = function () {
	      return _react2.default.createElement('input', {
	        value: _this.state.invoiceNoSearchTerm,
	        onChange: function onChange(e) {
	          return _this.setState({
	            invoiceNoSearchTerm: e.target.value
	          });
	        },
	        onKeyDown: function onKeyDown(e) {
	          if (e.key === "Enter") {
	            if (_this.state.invoiceNoSearchTerm) {
	              var pathname = _this.context.router.location.pathname;
	              _this.props.searchInvoicesByInvoiceNo(_this.state.searchType, _this.state.invoiceNoSearchTerm, pathname);
	            } else {
	              _this.fetchSalesOrdersByDetails(_this.state.days);
	            }
	          }
	        },
	        style: {
	          outline: "none",
	          width: "100%",
	          height: "24px",
	          padding: "10px 10px",
	          fontFamily: "Helvetica, sans-serif",
	          fontWeight: "300",
	          fontSize: "12px",
	          border: "1px solid #aaa",
	          borderRadius: "4px"
	        }
	      });
	    };
	
	    _this.renderTrackingNoSearchInput = function () {
	      return _react2.default.createElement('input', {
	        placeholder: 'Tracking No.',
	        value: _this.state.trackingNoSearchTerm,
	        onChange: function onChange(e) {
	          return _this.setState({
	            trackingNoSearchTerm: e.target.value
	          });
	        },
	        onKeyDown: function onKeyDown(e) {
	          if (e.key === "Enter") {
	            if (_this.state.trackingNoSearchTerm) {
	              var pathname = _this.context.router.location.pathname;
	              _this.props.searchInvoicesByTrackingNo(_this.state.trackingNoSearchTerm, pathname);
	            } else {
	              _this.fetchSalesOrdersByDetails(_this.state.days);
	            }
	          }
	        },
	        style: {
	          outline: "none",
	          width: "100%",
	          height: "24px",
	          padding: "10px 10px",
	          fontFamily: "Helvetica, sans-serif",
	          fontWeight: "300",
	          fontSize: "12px",
	          border: "1px solid #aaa",
	          borderRadius: "4px"
	        }
	      });
	    };
	
	    _this.handleStatusFilterChange = function (status) {
	      _this.setState({ currentPage: 0 });
	      var salesOrders = _extends({}, _this.state.salesOrders, {
	        selectedRows: []
	      });
	      if (isABC) {
	        _this.setState({ salesOrders: salesOrders });
	      }
	
	      var salesOrdersFilter = _this.props.salesOrdersFilter;
	      if (!salesOrdersFilter) {
	        var route = _this.context.router.routes[1].path;
	        var seller = _this.props.Seller;
	        if (_this.props.Seller) {
	          seller = _this.props.Seller.value;
	        }
	        var fromDate = _this.state.FromDate ? _this.formatDate(_this.state.FromDate) : "1900-01-01";
	        var toDate = _this.state.ToDate ? _this.formatDate(_this.state.ToDate) : "3000-01-01";
	        var days = _this.state.days;
	        if (days == null && !(isATL || isUSPride)) {
	          days = 7;
	        }
	        var productNum = _this.props.ProductNum;
	        _this.setState({ Status: status }, function () {
	          _this.props.fetchSalesOrdersByFilter(fromDate, toDate, days, _this.state.Status, seller, productNum, route, isATL || isUSPride ? _this.state.dispatchDateLT : null, isATL || isUSPride ? _this.state.dispatchDateGT : null, isATL || isUSPride ? _this.state.dispatchDays : null, _this.state.limit, _this.state.currentPage, _this.state.searchFilter, _this.props.Warehouse_id);
	        });
	      } else {
	        _this.setState({ Status: status });
	      }
	    };
	
	    _this.refreshSOList = function () {
	      var fromDate = _this.state.FromDate ? _this.formatDate(_this.state.FromDate) : "1900-01-01";
	      var toDate = _this.state.ToDate ? _this.formatDate(_this.state.ToDate) : "3000-01-01";
	      var days = _this.state.days;
	      var seller = _this.props.Seller;
	      var route = _this.context.router.routes[1].path;
	      var productNum = _this.props.ProductNum;
	      _this.props.fetchSalesOrdersByFilter(fromDate, toDate, days, _this.state.Status, seller, productNum, route, null, null, null, _this.state.limit, _this.state.currentPage, _this.state.searchFilter, _this.props.Warehouse_id);
	    };
	
	    _this.handleBreadCrumbTitle = function () {
	      if (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
	        if (_this.context.router.routes[1].path === "salesOrders") {
	          _this.setState(function () {
	            return { breadcrumbTitle: "inbound_order" };
	          });
	        } else if (_this.context.router.routes[1].path === "outboundOrders") {
	          _this.setState(function () {
	            return { breadcrumbTitle: "outbound_order" };
	          });
	        } else if (_this.context.router.routes[1].path === "mobileSalesOrders") {
	          _this.setState(function () {
	            return { breadcrumbTitle: "mobile_sales_order" };
	          });
	        }
	      } else {
	        if (_this.context.router.routes[1].path === "salesOrders") {
	          _this.setState(function () {
	            return { breadcrumbTitle: "sales_orders" };
	          });
	        } else if (_this.context.router.routes[1].path === "mobileSalesOrders") {
	          _this.setState(function () {
	            return { breadcrumbTitle: "mobile_sales_order" };
	          });
	        }
	      }
	    };
	
	    _this.onDropImage = function (files) {
	      var formData = new FormData();
	      formData.append('FILE', files[0]);
	      var success = function success() {
	        alert('success');
	        _this.refreshSOList();
	      };
	      var failed = function failed() {
	        alert('failed');
	      };
	      _this.props.uploadSOImage(formData, success, failed);
	    };
	
	    _this.onDropPOD = function (files) {
	      // const formData = new FormData();
	      // formData.append('FILE', files[0]);
	      // const success = () => {
	      //   alert('success');
	      //   this.refreshSOList();
	      // }
	      // const failed = () => {
	      //   alert('failed');
	      // }
	      // this.props.uploadSOPOD(formData, success, failed)
	    };
	
	    _this.setTNExcelOptionModalVisibility = function () {
	      var isExcelUploadOptionVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this.setState({ isExcelUploadOptionVisible: isExcelUploadOptionVisible });
	    };
	
	    _this.setShippingRateVisibility = function () {
	      var isShipingRateVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this.setState({ isShipingRateVisible: isShipingRateVisible });
	    };
	
	    _this.handleTeapplixPrintClick = function (row) {
	      var salesOrders = _this.state.salesOrders;
	
	      _this.props.selectTeapplixShipping(row.Code, salesOrders.selectedRows[0].SalesOrder_id);
	      _this.setShippingRateVisibility();
	    };
	
	    _this.renderTeapplixButton = function () {
	      var salesOrders = _this.state.salesOrders;
	
	      var salesOrderIds = [];
	      if (salesOrders && salesOrders.selectedRows.length > 0) {
	        salesOrders.selectedRows.map(function (row) {
	          salesOrderIds.push(row.SalesOrder_id);
	        });
	      }
	      var salesOrderIdsString = salesOrderIds.join(',');
	
	      var successDelete = function successDelete() {
	        alert('Success on delete teapplix label');
	        _this.refreshSOList();
	      };
	      var success = function success() {
	        // this.refreshSOList();
	      };
	
	      if (isABCFF) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.DropdownButton,
	            {
	              bsStyle: 'success',
	              disabled: !salesOrders.selectedRows.length,
	              title: _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'teapplix' })
	              ),
	              style: { marginLeft: '5px' }
	            },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                className: 'print-btn',
	                disabled: !salesOrders.selectedRows.length || _this.props.requestingSalesOrderPDF,
	                type: 'button',
	                onClick: function onClick() {
	                  if (salesOrders.selectedRows[0].Channel === "amazon-US" && salesOrders.selectedRows.length === 1) {
	                    _this.setShippingRateVisibility(true);
	                  } else {
	                    _this.props.selectTeapplixShipping('', salesOrderIdsString);
	                  }
	                }
	              },
	              _react2.default.createElement('i', { className: 'fa fa-print' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_label' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                className: 'print-btn',
	                disabled: !salesOrders.selectedRows.length || _this.props.requestingSalesOrderPDF,
	                type: 'button',
	                onClick: function onClick() {
	                  _this.props.printTeapplixLabel(salesOrderIdsString);
	                }
	              },
	              _react2.default.createElement('i', { className: 'fa fa-print' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reprint_label' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'danger',
	                className: 'print-btn',
	                disabled: !salesOrders.selectedRows.length,
	                type: 'button',
	                onClick: function onClick() {
	                  _this.props.deleteTeapplixShipping(salesOrderIdsString, successDelete);
	                }
	              },
	              _react2.default.createElement('em', { className: 'fa fa-trash' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel_label' })
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.DropdownButton,
	          {
	            bsStyle: 'success',
	            disabled: !salesOrders.selectedRows.length,
	            title: _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'teapplix' })
	            ),
	            style: { marginLeft: '5px' }
	          },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'primary',
	              className: 'print-btn',
	              disabled: !salesOrders.selectedRows.length || _this.props.requestingSalesOrderPDF,
	              type: 'button',
	              onClick: function onClick() {
	                _this.props.printTeapplixLabel(salesOrderIdsString);
	              }
	            },
	            _react2.default.createElement('i', { className: 'fa fa-print' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reprint_label' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'primary',
	              className: 'print-btn',
	              disabled: !salesOrders.selectedRows.length || _this.props.requestingSalesOrderPDF,
	              type: 'button',
	              onClick: function onClick() {
	                _this.props.selectTeapplixShipping(isATL ? "UPS_GROUND" : 'USPS_FIRST_PACKAGE', salesOrderIdsString, success);
	              }
	            },
	            _react2.default.createElement('i', { className: 'fa fa-print' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: isATL ? "ups_ground" : "USPS_first" })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'primary',
	              className: 'print-btn',
	              disabled: !salesOrders.selectedRows.length || _this.props.requestingSalesOrderPDF,
	              type: 'button',
	              onClick: function onClick() {
	                _this.props.selectTeapplixShipping(isATL ? "FEDEX_GROUND" : 'USPS_PRIORITY_PACKAGE', salesOrderIdsString, success);
	              }
	            },
	            _react2.default.createElement('i', { className: 'fa fa-print' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: isATL ? "fedex_ground" : "usps_priority" })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'danger',
	              className: 'print-btn',
	              disabled: !salesOrders.selectedRows.length,
	              type: 'button',
	              onClick: function onClick() {
	                _this.props.deleteTeapplixShipping(salesOrderIdsString, successDelete);
	              }
	            },
	            _react2.default.createElement('em', { className: 'fa fa-trash' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel_label' })
	          )
	        )
	      );
	      return _react2.default.createElement('span', null);
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.fiveLineButton,
	      clear: true,
	
	      salesOrders: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      salesOrderDetail: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      magSalesOrderDetail: {},
	
	      shippingPdfFrameLoaded: true,
	      pickingListPdfFrameLoaded: true,
	      packingListPdfFrameLoaded: true,
	      salesOrderPdfFrameLoaded: true,
	      bolIdPdfFrameLoaded: true,
	      bolWithoutLogPdfFrameLoaded: true,
	      bolFbaPdfFrameLoaded: true,
	      bolLabelFrameLoaded: true,
	
	      suggestValue: "",
	      searchType: "invoiceNo",
	      days: isABC ? "90" : isUSPride ? "2" : "7",
	      FromDate: undefined,
	      ToDate: undefined,
	      filteredByItem: false,
	      Status: "all",
	      rowsCount: 0,
	      total: 0,
	      canceledOrders: 0,
	      canceledTotal: 0,
	      dispatchDays: null,
	      dispatchDateGT: undefined,
	      dispatchDateLT: undefined,
	
	      checkAuthorizeOpen: false,
	      action: null,
	      title: "Quote",
	      breadcrumbTitle: "mobile_sales_order",
	      changeWeightOpen: false,
	      displayTrackingOpen: false,
	      changeTrackingOpen: false,
	
	      trackingFormOpen: false,
	      trackingformNum: null,
	      trackingformCarrier: null,
	      trackingformMethod: null,
	
	      newTrackingNum: null,
	      newTrackingNumID: null,
	      BLNum: null,
	      SealNum: null,
	      ProNum: null,
	      Carrier: null,
	      changePullSheetOpen: false,
	      confirmReshipOpen: false,
	      confirmQuoteOpen: false,
	      showDriverImageOpen: false,
	      submitImageOpen: false,
	      printBolOpen: false,
	      finalShippingWeight: 0,
	      pullSheetAmount: 0,
	      pullSheetSort: "",
	      scrollTopPositionIndex: null,
	      trackingNumberSelected: null,
	      invoiceNoSearchTerm: "",
	      trackingNoSearchTerm: "",
	
	      bolListModalVisibility: false,
	      generateBOLModalVisibility: false,
	      dsqPrintVisibility: false,
	      wizPODVisibility: false,
	      openAssignBolVisibility: false,
	      isAltonChildVisible: false,
	      altonSelectedProd: null,
	
	      paymentMethodModalVisibility: false,
	      voidNoteModalVisibility: false,
	      voidReason: "",
	      voidNote: "",
	
	      chowbusModalVisibility: false,
	      chowbusImportFile: null,
	
	      xpoString: {},
	      xpoQuoteVisibility: false,
	      pickupLoading: false,
	
	      pickupSelectionVisibility: false,
	      xpoPickupDate: null,
	      xpoReadyDate: null,
	      xpoCloseDate: null,
	
	      pickupString: "",
	      pickupVisibility: false,
	      xpoLoading: false,
	
	      openDownloadModalVisibility: false,
	      openDownloadModalUrl: null,
	      openDownloadModalLoading: false,
	
	      mag1: {
	        DRYRUN: false,
	        OFFHIRE: false,
	        PIERPASS: false,
	        AN_FEE: false,
	        OTHER: false,
	        HANDLING: false,
	        EXTRA_STOP: false,
	        EXAM: false,
	        EXTRA_DELIVERY: false,
	        STORAGE: false,
	        BOBTAIL_FEE: false,
	        CHASSIS_SPLIT: false,
	        CTF: false,
	        FSC: false,
	        PREPULL: false,
	        CONGESTION: false,
	        DROPOFF: false,
	        OVERWEIGHT: false
	      },
	
	      mag2: {
	        FREIGHT_HOLD: false,
	        CUSTOM_HOLD: false,
	        PIERPASS_HOLD: false,
	        EXAM: false,
	        CLOSED_AREA: false
	      },
	
	      rows: [],
	      file: [],
	      bolAddressFBA: "",
	
	      quoteSelectedCustomerId: null,
	      quoteSelectedCustomerName: "",
	      quoteSelectedCustomerPlaceholder: "",
	      quoteCustomerOptions: [],
	
	      excelCustomerOptions: [],
	
	      davisPOVisibility: false,
	      driverListModalVisibility: false,
	      isaEditModalVisibility: false,
	      ctnEditModalVisibility: false,
	
	      drayageListOptions: [],
	      warehouseOptions: [],
	
	      limit: isABC ? 25 : null,
	      limitDisplay: isABC ? '25' : 'all',
	      drayageSelected: null,
	      drayageListDisplay: "",
	      currentPage: 0,
	      searchFilter: {
	        SONum: '',
	        CompanyName: '',
	        FBACode: '',
	        CustomerBOLNo: '',
	        IsaNo: '',
	        ContainerNo: '',
	        ShippingStatus: ''
	      },
	
	      pridePrintVisibility: false,
	
	      assigningInboundDriver: false,
	      assigningOutboundDriver: false,
	      PODIframeLoaded: false,
	      selectedPODFile: '',
	      abcDatePickerShow: true,
	
	      isLocationChangeModalVisible: false,
	
	      addTrackingOpen: false,
	      addTrackingNumber: null,
	
	      isExpressShipVisibility: false,
	      expressShipDate: null,
	
	      USPrideCreateOpen: false,
	      USPridePlatform: "",
	      USPrideCustomer: "",
	      USPrideCreateLoading: false,
	
	      isInboundDateChangeModalVisibile: false,
	      deliveryTimeSelectVisible: false,
	      pickupTimeSelectVisible: false,
	      isExcelUploadOptionVisible: false,
	      isLabelPrintModalVisible: false,
	      emailContentModalVisibility: false,
	      isShipingRateVisible: false
	    };
	
	    _this.closeAssignBol = _this.closeAssignBol.bind(_this);
	    _this.openAssignBol = _this.openAssignBol.bind(_this);
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.openExpressShipVisibility = _this.openExpressShipVisibility.bind(_this);
	    _this.closeExpressShipVisibility = _this.closeExpressShipVisibility.bind(_this);
	
	    _this.closeChangeTracking = _this.closeChangeTracking.bind(_this);
	
	    _this.printForm = _this.printForm.bind(_this);
	    _this.loadsPost = _this.loadsPost.bind(_this);
	    _this.fetchSalesOrdersByDetails = _this.fetchSalesOrdersByDetails.bind(_this);
	    _this.fetchSalesOrdersByDispatch = _this.fetchSalesOrdersByDispatch.bind(_this);
	    _this.checkAuthorize = _this.checkAuthorize.bind(_this);
	    _this.openCheckAuthorize = _this.openCheckAuthorize.bind(_this);
	    _this.closeCheckAuthorize = _this.closeCheckAuthorize.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    // this.renderImage = this.renderImage.bind(this);
	    _this.renderDriverImage = _this.renderDriverImage.bind(_this);
	    _this.closeConfirmQuote = _this.closeConfirmQuote.bind(_this);
	
	    _this.openGenerateBOLModal = _this.openGenerateBOLModal.bind(_this);
	    _this.closeGenerateBOLModal = _this.closeGenerateBOLModal.bind(_this);
	
	    _this.openDSQPrint = _this.openDSQPrint.bind(_this);
	    _this.closeDSQPrint = _this.closeDSQPrint.bind(_this);
	
	    _this.openWIZPOD = _this.openWIZPOD.bind(_this);
	    _this.closeWIZPOD = _this.closeWIZPOD.bind(_this);
	    return _this;
	  }
	
	  _createClass(SalesOrder, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var warehouseOptions = this.state.warehouseOptions;
	
	      if (isUSPride) {
	        // warehouseOptions.push({label: "All", value: 999});
	        _axios2.default.get(_root_url.ROOT_URL + 'v1/warehouse/', { headers: { Authorization: 'Bearer ' + localStorage.getItem("token") } }).then(function (res) {
	          res.data.map(function (r) {
	            warehouseOptions.push({ label: r.Name, value: r.Warehouse_id });
	          });
	          _this2.setState({ warehouseOptions: warehouseOptions });
	        }, function (err) {
	          if (err.data) {
	            alert(err.data);
	          } else {
	            alert("Server issue detected, please contact admin.");
	          }
	        });
	        // this.props.setValue("salesOrders", "Warehouse_id", 999);
	      }
	
	      var drayageListOptions = [];
	      if (isKDW) {
	        _axios2.default.get(_url.MAG_DRAYAGE_LIST, {
	          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	          drayageListOptions = response.data;
	          if (response && response.data) {
	            response.data.map(function (r) {
	              drayageListOptions.push({ label: r.name + ": " + r.address, value: r.id });
	            });
	          }
	
	          // drayageListOptions.rows.map((r, index) => {
	          //   r.Idx = index++;
	          // })
	          _this2.setState({ drayageListOptions: drayageListOptions });
	        }, function (err) {
	          if (err.status === 500 || err.status === 404) {
	            err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	          }
	          alert(JSON.stringify(err.data));
	        });
	      }
	
	      window.addEventListener("resize", this.handleResize);
	      document.title = _root_url.companyCodeTitle;
	      if (isABC) {
	        // this.grid.onToggleFilter()
	      }
	      var salesOrdersFilter = this.props.salesOrdersFilter;
	      var route = this.context.router.routes[1].path;
	      if (salesOrdersFilter && route === salesOrdersFilter.currentPage) {
	        var selectedRows = salesOrdersFilter.currentRows.filter(function (r, idx) {
	          if (r.isSelected === true) {
	            _this2.setState({
	              scrollTopPositionIndex: idx
	            }, function () {
	              if (idx !== null) {
	                var top = 25 * _this2.state.scrollTopPositionIndex;
	                var gridCanvas = _this2.grid.getDataGridDOMNode().querySelector(".react-grid-Canvas");
	                gridCanvas.scrollTop = top;
	              }
	            });
	          }
	          return r.isSelected === true;
	        });
	        var salesOrders = _extends({}, this.state.salesOrders, {
	          rows: salesOrdersFilter.currentRows,
	          selectedRows: selectedRows,
	          filters: {}
	        });
	        this.setState({
	          salesOrders: salesOrders,
	          Status: salesOrdersFilter.Status,
	          FromDate: salesOrdersFilter.FromDate,
	          ToDate: salesOrdersFilter.ToDate,
	          days: salesOrdersFilter.Days
	        });
	        this.props.setValue("salesOrders", "Seller", salesOrdersFilter.Seller);
	        this.props.setValue("salesOrders", "ProductNum", salesOrdersFilter.ProductNum);
	
	        var fromDate = "1900-01-01";
	        if (salesOrdersFilter.FromDate) {
	          fromDate = this.formatDate(salesOrdersFilter.FromDate);
	        }
	        var toDate = "3000-01-01";
	        if (salesOrdersFilter.ToDate) {
	          toDate = this.formatDate(salesOrdersFilter.ToDate);
	        }
	        var seller = salesOrdersFilter.Seller;
	        if (salesOrdersFilter.Seller) {
	          seller = salesOrdersFilter.Seller.value;
	        }
	        // this.props.fetchSalesOrdersByFilter(
	        //   fromDate,
	        //   toDate,
	        //   salesOrdersFilter.Days,
	        //   salesOrdersFilter.Status,
	        //   seller,
	        //   salesOrdersFilter.ProductNum,
	        //   route,
	        //   null,
	        //   null,
	        //   null,
	        //   this.state.limit,
	        //   this.state.currentPage,
	        //   this.state.searchFilter,
	        //   this.props.Warehouse_id,
	        // );
	        this.props.fetchBaseUsers();
	        this.props.fetchBolAddress();
	      } else {
	        var _fromDate = "1900-01-01";
	        var _toDate = "3000-01-01";
	        var days = isABC ? "90" : isUSPride ? "2" : "7";
	        if (isMAG) {
	          days = "30";
	        }
	        if (isABCFF) {
	          days = "1";
	        }
	
	        var status = "all";
	        if (_root_url.isRivera) {
	          status = "open";
	        }
	
	        if (route === "mobileSalesOrders") {
	          if (isMyuMyu || isAFG || isWecom || isJML) {
	            days = "1";
	          } else if (isABC) {
	            status = 'all';
	          } else {
	            status = "open";
	          }
	        }
	        this.props.setDefaultDays("salesOrders");
	        this.setState({ Status: status, days: days }, function () {
	          return _this2.props.fetchSalesOrdersByFilter(_fromDate, _toDate, days, status, null, null, route, null, null, _this2.state.dispatchDays, _this2.state.limit, _this2.state.currentPage, _this2.state.searchFilter, _this2.props.Warehouse_id);
	        });
	        this.props.fetchBaseUsers();
	        this.props.fetchBolAddress();
	      }
	      if (salesOrdersFilter && route !== salesOrdersFilter.currentPage) {
	        this.props.setSalesOrdersFilter(null);
	      }
	      this.handleBreadCrumbTitle();
	      this.props.fetchCustomers();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.clear) {
	        this.props.setSalesOrdersFilter(null);
	      }
	      window.removeEventListener("resize", this.handleResize);
	    }
	
	    // Once products are ready, reset state.
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      var route = this.context.router.routes[1].path;
	      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
	        this.closeCheckAuthorize();
	        if (this.state.action === "void") {
	          if (isAFG) {
	            this.openVoidNote();
	          } else {
	            this.voidOrder();
	          }
	        }
	      }
	      if (nextProps.salesOrders && nextProps.salesOrders !== this.props.salesOrders) {
	        // Split Weight
	        if (this.state.salesOrders.selectedRows && this.state.salesOrders.selectedRows.length === 1) {
	          nextProps.salesOrders.Orders.map(function (orders) {
	            if (orders.SONum === _this3.state.salesOrders.selectedRows[0].SONum) {
	              _this3.state.salesOrders.selectedRows[0].FinalShippingWeight = orders.FinalShippingWeight;
	            }
	          });
	        }
	        this.setState({ total: nextProps.salesOrders.Total });
	        if (this.props.salesOrdersFilter && this.props.salesOrdersFilter.currentRows && this.context.router.routes[1].path === this.props.salesOrdersFilter.currentPage) {
	          this.setState({
	            salesOrders: _extends({}, this.state.salesOrders, {
	              rows: nextProps.salesOrders.Orders,
	              filters: {},
	              selectedRows: [] //whenever sales order list changed, set selected row empty
	            }),
	            salesOrderDetail: _extends({}, this.state.salesOrderDetail, {
	              rows: []
	            })
	          });
	          // this filter preserve logic is causing bugs
	
	          // const salesOrders = nextProps.salesOrders.Orders;
	          // let rows = salesOrders.map((order) => {
	          //   if (
	          //     order.InvoiceNum ===
	          //       this.state.salesOrders.selectedRows[0].InvoiceNum &&
	          //     order.SONum === this.state.salesOrders.selectedRows[0].SONum
	          //   ) {
	          //     return {
	          //       ...order,
	          //       isSelected: true,
	          //     };
	          //   } else {
	          //     return {
	          //       ...order,
	          //       isSelected: false,
	          //     };
	          //   }
	          // });
	          // const newSalesOrders = {
	          //   ...this.state.salesOrders,
	          //   rows,
	          //   selectedRows: this.state.salesOrders.selectedRows || [],
	          // };
	          // if (this.props.salesOrderDetail) {
	          //   var salesOrderDetail = {
	          //     ...this.state.salesOrderDetail,
	          //     rows: this.props.salesOrderDetail.Sales_Order_Lines,
	          //   };
	          //   this.setState({ salesOrderDetail });
	          // }
	          // this.setState({ salesOrders: newSalesOrders });
	          // this.props.setSalesOrdersFilter(null);
	        } else {
	          var salesOrders = _extends({}, this.state.salesOrders, {
	            rows: nextProps.salesOrders.Orders,
	            filters: {},
	            selectedRows: [] //whenever sales order list changed, set selected row empty
	          });
	          // for (var i = 0; i < salesOrders.rows.length; i++) {
	          //   if (
	          //     salesOrders.selectedRows[0] &&
	          //     salesOrders.rows[i].InvoiceNum ===
	          //       salesOrders.selectedRows[0].InvoiceNum &&
	          //     salesOrders.rows[i].SONum === salesOrders.selectedRows[0].SONum
	          //   ) {
	          //     salesOrders.rows[i].isSelected = true;
	          //   }
	          // }
	          var salesOrderDetail = _extends({}, this.state.salesOrderDetail, { rows: [] });
	          this.setState({ salesOrders: salesOrders, salesOrderDetail: salesOrderDetail });
	          this.props.setSalesOrdersFilter(null);
	        }
	
	        if (this.state.scrollTopPositionIndex !== null) {
	          var top = 25 * this.state.scrollTopPositionIndex;
	          if (this.grid) {
	            var gridCanvas = this.grid.getDataGridDOMNode().querySelector(".react-grid-Canvas");
	            gridCanvas.scrollTop = top;
	          }
	        }
	      }
	
	      if (nextProps.salesOrderDetail && nextProps.salesOrderDetail !== this.props.salesOrderDetail) {
	        var salesOrderDetail = _extends({}, this.state.salesOrderDetail, {
	          rows: nextProps.salesOrderDetail.Sales_Order_Lines
	        });
	
	        this.state.mag1 = {};
	        var mag1TempSplit = [];
	        if (isMAG && nextProps.salesOrderDetail.mag_note) {
	          mag1TempSplit = nextProps.salesOrderDetail.mag_note.split(',');
	          mag1TempSplit.map(function (r) {
	            if (r === 'DRYRUN') {
	              _this3.state.mag1.DRYRUN = true;
	            }
	            if (r === 'OFFHIRE') {
	              _this3.state.mag1.OFFHIRE = true;
	            }
	            if (r === 'PIERPASS') {
	              _this3.state.mag1.PIERPASS = true;
	            }
	            if (r === 'AN_FEE') {
	              _this3.state.mag1.AN_FEE = true;
	            }
	            if (r === 'OTHER') {
	              _this3.state.mag1.OTHER = true;
	            }
	            if (r === 'HANDLING') {
	              _this3.state.mag1.HANDLING = true;
	            }
	            if (r === 'EXTRA_STOP') {
	              _this3.state.mag1.EXTRA_STOP = true;
	            }
	            if (r === 'EXAM') {
	              _this3.state.mag1.EXAM = true;
	            }
	            if (r === 'EXTRA_DELIVERY') {
	              _this3.state.mag1.EXTRA_DELIVERY = true;
	            }
	            if (r === 'STORAGE') {
	              _this3.state.mag1.STORAGE = true;
	            }
	            if (r === 'BOBTAIL_FEE') {
	              _this3.state.mag1.BOBTAIL_FEE = true;
	            }
	            if (r === 'CHASSIS_SPLIT') {
	              _this3.state.mag1.CHASSIS_SPLIT = true;
	            }
	            if (r === 'CTF') {
	              _this3.state.mag1.CTF = true;
	            }
	            if (r === 'FSC') {
	              _this3.state.mag1.FSC = true;
	            }
	            if (r === 'PREPULL') {
	              _this3.state.mag1.PREPULL = true;
	            }
	            if (r === 'CONGESTION') {
	              _this3.state.mag1.CONGESTION = true;
	            }
	            if (r === 'DROPOFF') {
	              _this3.state.mag1.DROPOFF = true;
	            }
	            if (r === 'OVERWEIGHT') {
	              _this3.state.mag1.OVERWEIGHT = true;
	            }
	          });
	        }
	
	        this.state.mag2 = {};
	        var mag2TempSplit = [];
	        if (isMAG && nextProps.salesOrderDetail.DeliveryStatus) {
	          mag2TempSplit = nextProps.salesOrderDetail.DeliveryStatus.split(',');
	          mag2TempSplit.map(function (r) {
	            if (r === 'FREIGHT_HOLD') {
	              _this3.state.mag2.FREIGHT_HOLD = true;
	            }
	            if (r === 'CUSTOM_HOLD') {
	              _this3.state.mag2.CUSTOM_HOLD = true;
	            }
	            if (r === 'PIERPASS_HOLD') {
	              _this3.state.mag2.PIERPASS_HOLD = true;
	            }
	            if (r === 'EXAM') {
	              _this3.state.mag2.EXAM = true;
	            }
	            if (r === 'CLOSED_AREA') {
	              _this3.state.mag2.CLOSED_AREA = true;
	            }
	          });
	        }
	
	        this.setState({ magSalesOrderDetail: {} });
	        this.setState({ salesOrderDetail: salesOrderDetail, magSalesOrderDetail: nextProps.salesOrderDetail });
	      }
	
	      if (nextProps.Seller && nextProps.Seller !== this.props.Seller) {
	        var salesOrdersFilter = this.props.salesOrdersFilter;
	        if (!salesOrdersFilter) {
	          var seller = nextProps.Seller;
	          if (nextProps.Seller) {
	            seller = nextProps.Seller.value;
	          }
	          var fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : "1900-01-01";
	          var toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : "3000-01-01";
	          var days = this.state.days;
	
	          // if (fromDate == null) {
	          //   fromDate = '1900-01-01';
	          // }
	          // if (toDate == null) {
	          //   toDate = '3000-01-01';
	          // }
	          var productNum = this.state.filterProductID;
	          this.props.fetchSalesOrdersByFilter(fromDate, toDate, days, this.state.Status, seller, productNum, route, null, null, null, this.state.limit, this.state.currentPage, this.state.searchFilter, this.props.Warehouse_id);
	        }
	      }
	
	      if (this.props.Seller && nextProps.Seller == null) {
	        var _seller = nextProps.Seller;
	        var _fromDate2 = this.state.FromDate ? this.formatDate(this.state.FromDate) : "1900-01-01";
	        var _toDate2 = this.state.ToDate ? this.formatDate(this.state.ToDate) : "3000-01-01";
	        var _days = this.state.days;
	
	        // if (fromDate == null) {
	        //   fromDate = '1900-01-01';
	        // }
	        // if (toDate == null) {
	        //   toDate = '3000-01-01';
	        // }
	        var _productNum = this.state.filterProductID;
	        this.props.fetchSalesOrdersByFilter(_fromDate2, _toDate2, this.state.days, this.state.Status, _seller, _productNum, route, null, null, null, this.state.limit, this.state.currentPage, this.state.searchFilter, this.props.Warehouse_id);
	      }
	
	      if (nextProps.Warehouse_id && nextProps.Warehouse_id !== this.props.Warehouse_id) {
	        var _salesOrdersFilter = this.props.salesOrdersFilter;
	        if (!_salesOrdersFilter) {
	          var warehouse = nextProps.Warehouse_id;
	          if (nextProps.Warehouse_id) {
	            warehouse = nextProps.Warehouse_id.value;
	          }
	          var _fromDate3 = this.state.FromDate ? this.formatDate(this.state.FromDate) : "1900-01-01";
	          var _toDate3 = this.state.ToDate ? this.formatDate(this.state.ToDate) : "3000-01-01";
	          var _days2 = this.state.days;
	          var _seller2 = this.props.Seller;
	
	          // if (fromDate == null) {
	          //   fromDate = '1900-01-01';
	          // }
	          // if (toDate == null) {
	          //   toDate = '3000-01-01';
	          // }
	          var _productNum2 = this.state.filterProductID;
	          this.props.fetchSalesOrdersByFilter(_fromDate3, _toDate3, _days2, this.state.Status, _seller2, _productNum2, route, null, null, null, this.state.limit, this.state.currentPage, this.state.searchFilter, warehouse);
	        }
	      }
	
	      if (this.props.Warehouse_id && nextProps.Warehouse_id == null) {
	        var _warehouse = nextProps.Warehouse_id;
	        var _fromDate4 = this.state.FromDate ? this.formatDate(this.state.FromDate) : "1900-01-01";
	        var _toDate4 = this.state.ToDate ? this.formatDate(this.state.ToDate) : "3000-01-01";
	        var _days3 = this.state.days;
	
	        // if (fromDate == null) {
	        //   fromDate = '1900-01-01';
	        // }
	        // if (toDate == null) {
	        //   toDate = '3000-01-01';
	        // }
	        var _productNum3 = this.state.filterProductID;
	        this.props.fetchSalesOrdersByFilter(_fromDate4, _toDate4, this.state.days, this.state.Status, this.props.Seller, _productNum3, route, null, null, null, this.state.limit, this.state.currentPage, this.state.searchFilter, _warehouse);
	      }
	
	      if (nextProps.shippingListPDF && nextProps.shippingListPDF !== this.props.shippingListPDF) {
	        this.setState({ shippingPdfFrameLoaded: false });
	      }
	
	      if (nextProps.pickingListPDF && nextProps.pickingListPDF !== this.props.pickingListPDF) {
	        this.setState({ pickingListPdfFrameLoaded: false });
	      }
	
	      if (nextProps.packingListPDF && nextProps.packingListPDF !== this.props.packingListPDF) {
	        this.setState({ packingListPdfFrameLoaded: false });
	      }
	
	      if (nextProps.salesOrderPDF && nextProps.salesOrderPDF !== this.props.salesOrderPDF) {
	        this.setState({ salesOrderPdfFrameLoaded: false });
	      }
	      if (nextProps.bolIdPDF && nextProps.bolIdPDF !== this.props.bolIdPDF) {
	        this.setState({ bolIdPdfFrameLoaded: false });
	      }
	      if (nextProps.bolWithoutLogPDF && nextProps.bolWithoutLogPDF !== this.props.bolWithoutLogPDF) {
	        this.setState({ bolWithoutLogPdfFrameLoaded: false });
	      }
	      if (nextProps.bolLabel && nextProps.bolLabel !== this.props.bolLabel) {
	        this.setState({ bolLabelFrameLoaded: false });
	      }
	      if (nextProps.bolFbaPDF && nextProps.bolFbaPDF !== this.props.bolFbaPDF) {
	        this.setState({ bolFbaPdfFrameLoaded: false });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState.shippingPdfFrameLoaded !== this.state.shippingPdfFrameLoaded && this.state.shippingPdfFrameLoaded === false) {
	        return false;
	      }
	      if (nextState.pickingListPdfFrameLoaded !== this.state.pickingListPdfFrameLoaded && this.state.pickingListPdfFrameLoaded === false) {
	        return false;
	      }
	      if (nextState.packingListPdfFrameLoaded !== this.state.packingListPdfFrameLoaded && this.state.packingListPdfFrameLoaded === false) {
	        return false;
	      }
	      if (nextState.salesOrderPdfFrameLoaded !== this.state.salesOrderPdfFrameLoaded && this.state.salesOrderPdfFrameLoaded === false) {
	        return false;
	      }
	      if (nextState.bolIdPdfFrameLoaded !== this.state.bolIdPdfFrameLoaded && this.state.bolIdPdfFrameLoaded === false) {
	        return false;
	      }
	      if (nextState.bolWithoutLogPdfFrameLoaded !== this.state.bolWithoutLogPdfFrameLoaded && this.state.bolWithoutLogPdfFrameLoaded === false) {
	        return false;
	      }
	      if (nextState.bolLabelFrameLoaded !== this.state.bolLabelFrameLoaded && this.state.bolLabelFrameLoaded === false) {
	        return false;
	      }
	
	      if (nextState.bolFbaPdfFrameLoaded !== this.state.bolFbaPdfFrameLoaded && this.state.bolFbaPdfFrameLoaded === false) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.salesOrders !== this.state.salesOrders) {
	        var canceledTotal = 0;
	        var canceledOrders = this.state.salesOrders.rows.filter(function (row) {
	          var match = row.SaleStatus === "Canceled";
	          if (match) {
	            canceledTotal += row.FinalPrice;
	          }
	          return match;
	        });
	        this.setState({
	          rowsCount: _reactDataGridAddons.Data.Selectors.getRows(this.state.salesOrders).length,
	          canceledOrders: canceledOrders.length,
	          canceledTotal: canceledTotal
	        });
	      }
	    }
	  }, {
	    key: 'onConfirmDavisPO',
	    value: function onConfirmDavisPO() {
	      var salesOrders = this.state.salesOrders;
	
	      if (salesOrders && salesOrders.selectedRows && salesOrders.selectedRows[0]) {
	        this.props.setDavisPO(salesOrders.selectedRows[0].SalesOrder_id);
	      }
	      this.setState({ davisPOVisibility: false });
	
	      // const route = this.context.router.routes[1].path;
	      // const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
	      // const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
	      // const days = this.state.days;
	      // const productNum = this.state.filterProductID;
	      // const seller = this.props.Seller;
	      // setTimeout(() => {
	      //   this.props.fetchSalesOrdersByFilter(fromDate, toDate, days, this.state.Status, seller, productNum, route);
	      // }, 1000);
	    }
	  }, {
	    key: 'onConfirmChowbusImport',
	    value: function onConfirmChowbusImport() {
	      var _this4 = this;
	
	      if (!this.state.chowbusImportFile) {
	        alert("Please select a file to import");
	        return;
	      }
	      var data = new FormData();
	      data.append("file", this.state.chowbusImportFile);
	      this.props.chowbusImport(data).then(function (response) {
	        alert("Chowbus Orders Imported");
	        _this4.closeChowbusModal();
	      }, function (err) {
	        alert("Import Error:" + err.data);
	      });
	    }
	  }, {
	    key: 'onConfirmVoidNote',
	    value: function onConfirmVoidNote() {
	      var _this5 = this;
	
	      var salesOrder_id = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      var voidString = "";
	      if (this.state.voidReason) {
	        voidString = this.state.voidReason + ": ";
	      }
	      voidString += this.state.voidNote;
	      this.props.updateVoidNote(salesOrder_id, voidString);
	      setTimeout(function () {
	        _this5.voidOrder();
	      }, 1000);
	      this.closeVoidNote();
	    }
	  }, {
	    key: 'openTrackingForm',
	    value: function openTrackingForm() {
	      this.setState({
	        trackingFormOpen: true,
	        trackingformNum: null,
	        trackingformCarrier: null,
	        trackingformMethod: null
	      });
	    }
	  }, {
	    key: 'closeTrackingForm',
	    value: function closeTrackingForm() {
	      this.setState({ trackingFormOpen: false });
	    }
	  }, {
	    key: 'openDisplayTracking',
	    value: function openDisplayTracking() {
	      this.setState({ displayTrackingOpen: true });
	    }
	  }, {
	    key: 'closeDisplayTracking',
	    value: function closeDisplayTracking() {
	      this.setState({ displayTrackingOpen: false });
	    }
	  }, {
	    key: 'openChangeTracking',
	    value: function openChangeTracking(val, dep) {
	      this.setState({ changeTrackingOpen: true, newTrackingNum: val, newTrackingNumID: dep.SalesOrder_id });
	    }
	  }, {
	    key: 'closeChangeTracking',
	    value: function closeChangeTracking() {
	      this.setState({ changeTrackingOpen: false });
	    }
	  }, {
	    key: 'setPickupDate',
	    value: function setPickupDate(e) {
	      this.setState({ xpoPickupDate: e });
	    }
	  }, {
	    key: 'setReadyDate',
	    value: function setReadyDate(e) {
	      this.setState({ xpoReadyDate: e });
	    }
	  }, {
	    key: 'setCloseDate',
	    value: function setCloseDate(e) {
	      this.setState({ xpoCloseDate: e });
	    }
	  }, {
	    key: 'openAddTracking',
	    value: function openAddTracking() {
	      this.setState({
	        addTrackingOpen: true,
	        addTrackingNumber: null
	      });
	    }
	  }, {
	    key: 'closeAddTracking',
	    value: function closeAddTracking() {
	      this.setState({ addTrackingOpen: false });
	    }
	  }, {
	    key: 'openChangeWeight',
	    value: function openChangeWeight() {
	      this.setState({
	        changeWeightOpen: true,
	        finalShippingWeight: this.state.salesOrders.selectedRows[0].FinalShippingWeight
	      });
	    }
	  }, {
	    key: 'openbolListModal',
	    value: function openbolListModal() {
	      this.setState({ bolListModalVisibility: true });
	    }
	  }, {
	    key: 'closebolListModal',
	    value: function closebolListModal() {
	      this.setState({ bolListModalVisibility: false });
	    }
	  }, {
	    key: 'openDSQPrint',
	    value: function openDSQPrint() {
	      this.setState({ dsqPrintVisibility: true });
	    }
	  }, {
	    key: 'closeDSQPrint',
	    value: function closeDSQPrint() {
	      this.setState({ dsqPrintVisibility: false });
	    }
	  }, {
	    key: 'openWIZPOD',
	    value: function openWIZPOD() {
	      this.setState({ wizPODVisibility: true });
	    }
	  }, {
	    key: 'closeWIZPOD',
	    value: function closeWIZPOD() {
	      this.setState({ wizPODVisibility: false });
	    }
	  }, {
	    key: 'openAssignBol',
	    value: function openAssignBol() {
	      this.setState({ openAssignBolVisibility: true, BLNum: null, SealNum: null, ProNum: null, Carrier: null });
	    }
	  }, {
	    key: 'closeAssignBol',
	    value: function closeAssignBol() {
	      this.setState({ openAssignBolVisibility: false });
	    }
	  }, {
	    key: 'openExpressShipVisibility',
	    value: function openExpressShipVisibility() {
	      this.setState({ isExpressShipVisibility: true });
	    }
	  }, {
	    key: 'closeExpressShipVisibility',
	    value: function closeExpressShipVisibility() {
	      this.setState({ isExpressShipVisibility: false });
	    }
	  }, {
	    key: 'setExpressShipDate',
	    value: function setExpressShipDate(e) {
	      this.setState({ expressShipDate: e });
	    }
	  }, {
	    key: 'openGenerateBOLModal',
	    value: function openGenerateBOLModal() {
	      this.setState({ generateBOLModalVisibility: true });
	    }
	  }, {
	    key: 'closeGenerateBOLModal',
	    value: function closeGenerateBOLModal() {
	      this.setState({ generateBOLModalVisibility: false });
	    }
	  }, {
	    key: 'openChangePaymentMethodModal',
	    value: function openChangePaymentMethodModal() {
	      this.setState({
	        paymentMethodModalVisibility: true
	      });
	    }
	  }, {
	    key: 'closePaymentMethodModal',
	    value: function closePaymentMethodModal() {
	      this.setState({
	        paymentMethodModalVisibility: false
	      });
	    }
	  }, {
	    key: 'closeChangeWeight',
	    value: function closeChangeWeight() {
	      this.setState({ changeWeightOpen: false });
	    }
	  }, {
	    key: 'openConfirmReship',
	    value: function openConfirmReship() {
	      this.setState({ confirmReshipOpen: true });
	    }
	  }, {
	    key: 'closeConfirmReship',
	    value: function closeConfirmReship() {
	      this.setState({ confirmReshipOpen: false });
	    }
	  }, {
	    key: 'onConfirmReship',
	    value: function onConfirmReship() {
	      var salesOrder_id = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      this.props.reshipOrder(salesOrder_id);
	      this.setState({ confirmReshipOpen: false });
	    }
	
	    // USPride create with excel modal
	
	  }, {
	    key: 'openUSPrideCreate',
	    value: function openUSPrideCreate() {
	      var customers = this.props.customers;
	      var excelCustomerOptions = this.state.excelCustomerOptions;
	
	      if (isABCFF) {
	        if (customers) {
	          customers.map(function (r) {
	            excelCustomerOptions.push({ label: r.Name, value: r.Customer_id });
	          });
	        }
	        this.setState({ excelCustomerOptions: excelCustomerOptions });
	      }
	      this.setState({ USPrideCreateOpen: true });
	    }
	  }, {
	    key: 'closeUSPrideCreate',
	    value: function closeUSPrideCreate() {
	      this.setState({ USPrideCreateOpen: false });
	    }
	  }, {
	    key: 'openConfirmQuote',
	    value: function openConfirmQuote() {
	      var salesOrders = this.state.salesOrders;
	      var customers = this.props.customers;
	
	      var quoteSelectedCustomerId = null;
	      var quoteSelectedCustomerName = "";
	      var quoteSelectedCustomerPlaceholder = "";
	      if (salesOrders && salesOrders.selectedRows) {
	        salesOrders.selectedRows.forEach(function (salesOrder) {
	          quoteSelectedCustomerId = salesOrder.Deliver_Customer_id;
	          quoteSelectedCustomerName = salesOrder.Deliver_CustomerName;
	          quoteSelectedCustomerPlaceholder = salesOrder.Deliver_CustomerName;
	          // Deliver_CustomerDetail_id //Deliver_Customer_id //Deliver_CustomerName
	        });
	      }
	      var quoteCustomerOptions = [];
	      if (customers) {
	        customers.map(function (r) {
	          quoteCustomerOptions.push({ label: r.Name, value: r.Customer_id });
	        });
	      }
	      this.setState({
	        confirmQuoteOpen: true,
	        quoteSelectedCustomerId: quoteSelectedCustomerId,
	        quoteSelectedCustomerName: quoteSelectedCustomerName,
	        quoteCustomerOptions: quoteCustomerOptions,
	        quoteSelectedCustomerPlaceholder: quoteSelectedCustomerPlaceholder
	      });
	      this.props.setValue("salesOrders", "hmmCustomer", "");
	    }
	  }, {
	    key: 'closeConfirmQuote',
	    value: function closeConfirmQuote() {
	      this.setState({ confirmQuoteOpen: false });
	    }
	  }, {
	    key: 'onConfirmQuote',
	    value: function onConfirmQuote() {
	      var _this6 = this;
	
	      var _state = this.state,
	          salesOrders = _state.salesOrders,
	          quoteSelectedCustomerId = _state.quoteSelectedCustomerId;
	
	      var salesOrderIds = [];
	      if (salesOrders && salesOrders.selectedRows) {
	        salesOrders.selectedRows.forEach(function (salesOrder) {
	          salesOrderIds.push(salesOrder.SalesOrder_id);
	        });
	      }
	
	      this.props.setQuoteOrder(salesOrderIds.join(","), quoteSelectedCustomerId);
	      this.setState({ confirmQuoteOpen: false });
	      var route = this.context.router.routes[1].path;
	      var fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : "1900-01-01";
	      var toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : "3000-01-01";
	      var days = this.state.days;
	      var productNum = this.state.filterProductID;
	      var seller = this.props.Seller;
	      setTimeout(function () {
	        _this6.props.fetchSalesOrdersByFilter(fromDate, toDate, days, _this6.state.Status, seller, productNum, route, null, null, null, _this6.state.limit, _this6.state.currentPage, _this6.state.searchFilter, _this6.props.Warehouse_id);
	      }, 1000);
	    }
	  }, {
	    key: 'openShowDriverImage',
	    value: function openShowDriverImage() {
	      this.setState({ showDriverImageOpen: true });
	    }
	  }, {
	    key: 'closeShowDriverImage',
	    value: function closeShowDriverImage() {
	      this.setState({ showDriverImageOpen: false });
	    }
	  }, {
	    key: 'openSubmitImage',
	    value: function openSubmitImage() {
	      this.setState({ submitImageOpen: true });
	    }
	  }, {
	    key: 'closeSubmitImage',
	    value: function closeSubmitImage() {
	      this.setState({ submitImageOpen: false });
	    }
	  }, {
	    key: 'onSubmitImage',
	    value: function onSubmitImage(successCallback) {
	      var salesOrder_id = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      this.props.submitBolImage(salesOrder_id, this.state.file);
	      this.setState({ submitImageOpen: false });
	    }
	  }, {
	    key: 'openPrintBol',
	    value: function openPrintBol() {
	      this.setState({ printBolOpen: true });
	    }
	  }, {
	    key: 'closePrintBol',
	    value: function closePrintBol() {
	      this.setState({ printBolOpen: false });
	    }
	  }, {
	    key: 'openChangePullSheet',
	    value: function openChangePullSheet() {
	      this.setState({ changePullSheetOpen: true });
	    }
	  }, {
	    key: 'closeChangePullSheet',
	    value: function closeChangePullSheet() {
	      this.setState({ changePullSheetOpen: false });
	    }
	  }, {
	    key: 'onChangePullSheetSubmit',
	    value: function onChangePullSheetSubmit() {
	      var salesOrderIds = [];
	      var salesOrders = this.state.salesOrders;
	
	      if (salesOrders && salesOrders.selectedRows.length > 1) {
	        salesOrders.selectedRows.map(function (row) {
	          salesOrderIds.push(row.SalesOrder_id);
	        });
	      }
	      if (this.state.pullSheetAmount < 0 || this.state.pullSheetAmount > salesOrders.selectedRows.length) {
	        alert("Invalid Value!");
	        return;
	      }
	      this.props.printPickingListAFG(salesOrderIds.join(","), this.state.pullSheetAmount, this.state.pullSheetSort);
	      this.state.pullSheetAmount = null;
	      this.setState({ changePullSheetOpen: false });
	      // this.context.router.push(`/${this.context.router.routes[1].path}`);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      this.setState({
	        tableHeight: window.innerHeight - _constants.UI_HEIGHT.fiveLineButton
	      });
	    }
	  }, {
	    key: 'setCurrentSalesOrder',
	
	
	    // Set product being selected to be currentProduct and navigate user to the edit page
	    value: function setCurrentSalesOrder(e) {
	      e.preventDefault();
	      this.setState({ clear: false });
	      var currentSalesOrderId = this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      var salesOrders = this.state.salesOrders.rows.filter(function (row) {
	        var match = row.SalesOrder_id === currentSalesOrderId;
	        return match;
	      });
	
	      var FromDate = this.state.FromDate;
	      var ToDate = this.state.ToDate;
	      this.props.resetCurrentSalesOrder();
	
	      this.props.selectSalesOrder(salesOrders[0]);
	      var currentRows = _reactDataGridAddons.Data.Selectors.getRows(this.state.salesOrders);
	      var route = this.context.router.routes[1].path;
	      this.props.setSalesOrdersFilter({
	        Days: this.state.days,
	        FromDate: FromDate,
	        ToDate: ToDate,
	        Status: this.state.Status,
	        Seller: this.props.Seller,
	        ProductNum: this.props.ProductNum,
	        currentRows: currentRows,
	        currentPage: route
	      });
	      // this.context.router.push('/salesOrders/'+currentSalesOrder.SalesOrder_id);
	      this.context.router.push('/' + this.context.router.routes[1].path + '/' + currentSalesOrderId);
	    }
	  }, {
	    key: 'checkAuthorize',
	    value: function checkAuthorize(password) {
	      this.props.checkPassword(password);
	    }
	  }, {
	    key: 'openCheckAuthorize',
	    value: function openCheckAuthorize(action) {
	      this.props.clearCheckPassword();
	      this.setState({ checkAuthorizeOpen: true, action: action });
	    }
	  }, {
	    key: 'closeCheckAuthorize',
	    value: function closeCheckAuthorize() {
	      this.setState({ checkAuthorizeOpen: false });
	    }
	  }, {
	    key: 'clickNew',
	    value: function clickNew(e) {
	      e.preventDefault();
	      this.props.resetCurrentSalesOrder();
	      // this.context.router.push('/salesOrders/new')
	      this.context.router.push('/' + this.context.router.routes[1].path + '/new');
	    }
	  }, {
	    key: 'voidOrder',
	    value: function voidOrder() {
	      var _this7 = this;
	
	      var newRows = this.state.salesOrders.rows;
	      this.state.salesOrders.selectedRows.map(function (row) {
	        if (isUSPride) {
	          _this7.props.voidSalesOrder(row.SalesOrder_id);
	        } else {
	          _this7.props.voidSalesOrder(row.SalesOrder_id, _this7.context.router.routes[1].path);
	        }
	        newRows = newRows.filter(function (obj) {
	          return obj !== row;
	        });
	        var salesOrders = _extends({}, _this7.state.salesOrders, { rows: newRows, selectedRows: [] });
	        _this7.setState({ salesOrders: salesOrders });
	      });
	    }
	  }, {
	    key: 'shouldVoidButtonDisable',
	    value: function shouldVoidButtonDisable() {
	      var selectedRows = this.state.salesOrders.selectedRows;
	
	      // Always disable void if selected more than 1 row
	
	      if (selectedRows.length !== 1 && !isATL && !isRS && false) {
	        return true;
	      } else if (selectedRows.length < 1) {
	        return true;
	      }
	
	      var testing = false;
	      if (selectedRows && selectedRows.length > 1) {
	        selectedRows.map(function (r) {
	          if (r.SaleStatus === "Canceled" || r.SaleStatus === "Refunded" || r.SaleStatus === "Partially Refunded" || r.SaleStatus === "Finalized" || r.SaleStatus === "Released" || r.SaleStatus === "disable") {
	            testing = true;
	          }
	        });
	      }
	      if (testing === true) {
	        return true;
	      }
	
	      var status = selectedRows[0] ? selectedRows[0].SaleStatus : "disable";
	      var disabled = status === "Canceled" || status === "Refunded" || status === "Partially Refunded" || status === "Finalized" || status === "Released" || status === "disable";
	      return disabled;
	    }
	  }, {
	    key: 'shouldQuoteButtonDisable',
	    value: function shouldQuoteButtonDisable() {
	      var selectedRows = this.state.salesOrders.selectedRows;
	
	      if (selectedRows.length !== 1) {
	        return true;
	      }
	      var status = selectedRows[0] ? selectedRows[0].SaleStatus : "disable";
	      var disabled = status === "Canceled" || status === "Refunded" || status === "Partially Refunded" || status === "Finalized" || status === "Released" || status === "Packing" || status === "disable";
	      return disabled;
	    }
	  }, {
	    key: 'printForm',
	    value: function printForm(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: 'loadsPost',
	    value: function loadsPost() {
	      this.props.loadsPost(this.state.salesOrders.selectedRows[0].SalesOrder_id);
	    }
	  }, {
	    key: 'renderTable',
	
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	    value: function renderTable() {
	      var _this8 = this;
	
	      var route = this.context.router.routes[1].path;
	      if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.error)
	        )
	      );
	
	      // Parameters of the react-data-grid
	      var tableHeight = window.innerHeight < 930 ? 270 : 270;
	      if (isABC) {
	        tableHeight = window.innerHeight < 930 ? 800 : 800;
	      }
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this8.state.salesOrders);
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	
	        if (_root_url.isSnapwise) {
	          rows.map(function (r, i) {
	            if (!r.Tracking && r.TTracking) {
	              rows[i].Tracking = rows[i].TTracking;
	            } else if (!r.Tracking && !r.TTracking) {
	              rows[i].Tracking = "";
	            } else {}
	          });
	        }
	
	        if (isUSPride) {
	          rows.map(function (r, i) {
	            if (!r.carrierName) {
	              rows[i].carrierName = " ";
	            }
	          });
	        }
	
	        if (isAPO) {
	          rows.map(function (r, i) {
	            if (!r.TrackingNum && r.delivery_tracking_num) {
	              rows[i].TrackingNum = rows[i].delivery_tracking_num;
	            } else if (!r.TrackingNum && !r.delivery_tracking_num) {
	              rows[i].TrackingNum = "";
	            } else {}
	          });
	        }
	
	        // if (isAmzey) {
	        //   rows.map((r,i)=>{
	        //     if (!r.TrackingNum && r.delivery_tracking_num) {
	        //       rows[i].TrackingNum = rows[i].delivery_tracking_num;
	        //     } else if (!r.Tracking && !r.delivery_tracking_num) {
	        //       rows[i].TrackingNum = "";
	        //     } else {
	
	        //     }
	        //   })
	        // }
	
	        _this8.state.total = 0;
	        for (var i = 0; i < rows.length; i++) {
	          _this8.state.total += rows[i].FinalPrice;
	        }
	        return rows[rowIdx];
	      };
	
	      var onTrackingNumRouter = function onTrackingNumRouter(trackingNum) {
	        var url = "https://www.fedex.com/apps/fedextrack/?tracknumbers=" + trackingNum;
	        var win = window.open(url);
	        if (win != null) {
	          win.focus();
	        }
	      };
	
	      var onTrackingNumRouter2 = function onTrackingNumRouter2(trackingURL) {
	        var url = trackingURL;
	        var win = window.open(url);
	        if (win != null) {
	          win.focus();
	        }
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        var salesOrders = _extends({}, _this8.state.salesOrders, { filters: {} });
	        _this8.setState({ salesOrders: salesOrders });
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this8.state.salesOrders, {
	          sortColumn: sortColumn,
	          sortDirection: sortDirection
	        });
	        if (state.sortColumn === "OrderDateDisplay") {
	          state.sortColumn = "OrderDate";
	        }
	
	        if (state.sortDirection === "ASC") {
	          _this8.state.pullSheetSort = state.sortColumn;
	        } else if (state.sortDirection === "DESC") {
	          _this8.state.pullSheetSort = '-' + state.sortColumn;
	        } else {
	          _this8.state.pullSheetSort = "";
	        }
	        _this8.setState({ salesOrders: state });
	      };
	
	      var handleFilterChange = (0, _lodash.debounce)(function (filter) {
	        _this8.state.total = 0;
	        _this8.state.salesOrders.rows = _this8.props.salesOrders.Orders;
	        _this8.state.salesOrders.selectedRows = [];
	        var newFilters = Object.assign({}, _this8.state.salesOrders.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var salesOrders = _extends({}, _this8.state.salesOrders, { filters: newFilters });
	        _this8.setState({ salesOrders: salesOrders });
	      }, 500, { maxWait: 800 });
	
	      // Handle the row select function
	      var onRowClick = function onRowClick(rowIdx, row) {
	        if (rowIdx !== -1) {
	          var rows = getRows();
	          /* Multi row select on row click
	            let selectedRows = [...this.state.salesOrders.selectedRows];
	             let id = rows[rowIdx].SalesOrder_id;
	            let idx = selectedRows.indexOf(id);
	            if (idx == -1) {
	              rows[rowIdx].isSelected = true;
	              selectedRows.push(id);
	            } else {
	              rows[rowIdx].isSelected = false;
	              selectedRows.splice(idx, 1);
	            }
	          */
	
	          /* Single row select on row click */
	          rows.map(function (r) {
	            r.isSelected = false;
	          });
	          var selectedRows = [rows[rowIdx]];
	          rows[rowIdx].isSelected = true;
	
	          var salesOrders = _extends({}, _this8.state.salesOrders, { rows: rows, selectedRows: selectedRows });
	          _this8.setState({ salesOrders: salesOrders });
	          if (isKDW) {
	            _this8.props.fetchSalesOrderDetail(row.SalesOrder_id, "salesOrders");
	          } else {
	            _this8.props.fetchSalesOrderDetail(row.SalesOrder_id, route);
	          }
	        }
	      };
	
	      var handleLimitChange = function handleLimitChange(el) {
	        _this8.state.currentPage = 0;
	        _this8.state.limit = el.value;
	        _this8.state.limitDisplay = el.label;
	        var route = _this8.context.router.routes[1].path;
	
	        var salesOrders = _extends({}, _this8.state.salesOrders, {
	          selectedRows: []
	        });
	        _this8.setState({ salesOrders: salesOrders });
	
	        // salesOrders: {
	        //   rows: [],
	        //   selectedRows: [],
	        //   filters: {},
	        //   sortColumn: null,
	        //   sortDirection: null,
	        // },
	
	        _this8.props.fetchSalesOrdersByFilter(_this8.state.FromDate, _this8.state.ToDate, _this8.state.days, _this8.state.Status, null, null, route, _this8.state.dispatchDateLT, _this8.state.dispatchDateGT, null, _this8.state.limit, _this8.state.currentPage, _this8.state.searchFilter, _this8.props.Warehouse_id);
	        // this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
	      };
	
	      var handleOnPageChange = function handleOnPageChange(data) {
	        _this8.state.currentPage = data.selected;
	
	        var route = _this8.context.router.routes[1].path;
	
	        var salesOrders = _extends({}, _this8.state.salesOrders, {
	          selectedRows: []
	        });
	        _this8.setState({ salesOrders: salesOrders });
	
	        _this8.props.fetchSalesOrdersByFilter(_this8.state.FromDate, _this8.state.ToDate, _this8.state.days, _this8.state.Status, null, null, route, _this8.state.dispatchDateLT, _this8.state.dispatchDateGT, null, _this8.state.limit, _this8.state.currentPage, _this8.state.searchFilter, _this8.props.Warehouse_id);
	
	        // this.props.fetchSalesOrdersByFilter(
	        //   this.state.FromDate,
	        //   this.state.ToDate,
	        //   this.state.days,
	        //   this.state.Status,
	        //   seller,
	        //   productNum,
	        //   route,
	        //   this.state.dispatchDateLT,
	        //   this.state.dispatchDateGT,
	        //   dispatchDays,
	        // );
	
	        // this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
	      };
	
	      var onRowSelect = function onRowSelect(rows) {
	        var salesOrders = _extends({}, _this8.state.salesOrders, { selectedRows: rows });
	        _this8.setState({ salesOrders: salesOrders });
	      };
	
	      var onCellSelected = function onCellSelected(coordinates) {
	        var newRows = getRows();
	        /* Multi row select on cell selected
	                    let selectedRows = [...this.state.salesOrders.selectedRows];
	                    newRows[coordinates.rowIdx].isSelected = true;
	                    let id = newRows[coordinates.rowIdx].SalesOrder_id;
	                    if (selectedRows.indexOf(id) == -1) {
	                        selectedRows.push(id);
	                    }
	                  */
	        /* Single row select on cell selected */
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        var selectedRows = [newRows[coordinates.rowIdx]];
	        newRows[coordinates.rowIdx].isSelected = true;
	        var salesOrders = _extends({}, _this8.state.salesOrders, {
	          rows: newRows,
	          selectedRows: selectedRows
	        });
	        _this8.setState({ salesOrders: salesOrders });
	      };
	
	      var checkLabel = function checkLabel() {
	        var selectedRows = [].concat(_toConsumableArray(_this8.state.salesOrders.selectedRows));
	        if (selectedRows[0].SaleStatus === "Quote") {
	          _this8.setState({
	            title: "Open"
	          });
	        } else if (selectedRows[0].SaleStatus !== "Quote") {
	          _this8.setState({
	            title: "Quote"
	          });
	        }
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        _this8.setState({
	          scrollTopPositionIndex: rows[0].rowIdx
	        });
	        var newRows = getRows();
	        var selectedRows = [].concat(_toConsumableArray(_this8.state.salesOrders.selectedRows));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	          selectedRows.push(r.row);
	        });
	        var salesOrders = _extends({}, _this8.state.salesOrders, {
	          rows: newRows,
	          selectedRows: selectedRows
	        });
	        _this8.setState({ salesOrders: salesOrders }, function () {
	          checkLabel();
	        });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = [].concat(_toConsumableArray(_this8.state.salesOrders.rows));
	        var selectedRows = [].concat(_toConsumableArray(_this8.state.salesOrders.selectedRows));
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	          var rowIndex = selectedRows.indexOf(r.row);
	          selectedRows.splice(rowIndex, 1);
	        });
	        var salesOrders = _extends({}, _this8.state.salesOrders, {
	          rows: newRows,
	          selectedRows: selectedRows
	        });
	        _this8.setState({ salesOrders: salesOrders, title: "Quote" });
	      };
	
	      // Custom Formatter component
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	            var date = new Date(this.props.value);
	            var index = dateMap.indexOf(date.toString().slice(4, 3));
	            var localDate = index + date.toString().slice(8, 6);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var shippingAddressFormatter = _react2.default.createClass({
	        displayName: 'shippingAddressFormatter',
	        render: function render() {
	          if (this.props.dependentValues) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              this.props.dependentValues.Deliver_CustomerAddress + ' ' + this.props.dependentValues.City + ' ' + this.props.dependentValues.State
	            );
	          }
	          return _react2.default.createElement('span', null);
	        }
	      });
	
	      var SecondsDateFormatter = _react2.default.createClass({
	        displayName: 'SecondsDateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var date = (0, _moment2.default)(this.props.value).format("MM-DD-YY HH:mm");
	            return _react2.default.createElement(
	              'span',
	              null,
	              date
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var DateFormatter2 = _react2.default.createClass({
	        displayName: 'DateFormatter2',
	        render: function render() {
	          if (this.props.value) {
	            var date = (0, _moment2.default)(this.props.value).format("MM-DD-YY");
	            return _react2.default.createElement(
	              'span',
	              null,
	              date
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var YuansferFormatter = _react2.default.createClass({
	        displayName: 'YuansferFormatter',
	        render: function render() {
	          if (this.props.value === "alipay") {
	            return _react2.default.createElement(
	              'span',
	              null,
	              'Alipay'
	            );
	          }
	          if (this.props.value === "wechatpay") {
	            return _react2.default.createElement(
	              'span',
	              null,
	              'WeChatPay'
	            );
	          } else {
	            return _react2.default.createElement(
	              'span',
	              null,
	              this.props.value
	            );
	          }
	        }
	      });
	      // Custom Delivery Time component
	      var DeliveryTimeFormatter = _react2.default.createClass({
	        displayName: 'DeliveryTimeFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var d1 = _moment2.default.utc((0, _moment2.default)(this.props.value)).local().format("LT");
	            var d2 = _moment2.default.utc((0, _moment2.default)(this.props.value)).local().subtract(2, "hours").format("MM-DD-YY hh:mm A");
	            // This is the old way Julie designed it. Keeping it here in case a new bug is discovered with my alterations.
	            // d1 = moment(d1).format("h a");
	            // d2 = moment(d2).subtract(2, 'hours').format('MM-DD-YY hh:mm:ss a');
	            // d2 = moment(d2).format("h a");
	
	            return _react2.default.createElement(
	              'span',
	              null,
	              d2 + '-' + d1
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var VendorNameFormatter = _react2.default.createClass({
	        displayName: 'VendorNameFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            null,
	            this.props.value.Name
	          );
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var VendorNumFormatter = _react2.default.createClass({
	        displayName: 'VendorNumFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            null,
	            this.props.value.VendorNum
	          );
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var InvoiceNumFormatter = _react2.default.createClass({
	        displayName: 'InvoiceNumFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            null,
	            this.props.value
	          );
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var PromoCodeFormatter = _react2.default.createClass({
	        displayName: 'PromoCodeFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            null,
	            this.props.value
	          );
	          return _react2.default.createElement(
	            'span',
	            null,
	            '-'
	          );
	        }
	      });
	
	      var soNumWidth = this.context.router.routes[1].path === "mobileSalesOrders" ? 145 : 100;
	
	      // Column difinition
	      var columns = [{
	        key: "SONum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: soNumWidth
	      }].concat(_toConsumableArray(isEcity && this.context.router.routes[1].path === "mobileSalesOrders" ? [{
	        key: "ShippingMethod",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delivery' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }] : []), [{
	        key: "InvoiceNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 113,
	        formatter: InvoiceNumFormatter
	      }], _toConsumableArray(isTQ ? [{
	        key: "PONum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_po' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	
	      }] : []), _toConsumableArray(isFIT ? [{
	        key: "Quantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: "SKU",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }] : !isAN && [{
	        key: "Deliver_Customer_num",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }]), [{
	        key: "Deliver_CustomerName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 115
	      }], _toConsumableArray(!isCalco ? [] : [{
	        key: "OrderDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }]), _toConsumableArray(!isCalco ? [] : [{
	        key: "DispatchDate",
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_date' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_delivery' }),
	        resizable: true,
	        sortable: true,
	        width: 125,
	        filterable: true,
	        formatter: DateFormatter
	      }]), _toConsumableArray(isCalco ? [] : [{
	        key: isTN ? "ClientCustName" : isChinaTown ? "ShippingMethod" : "Description",
	        name: isTN ? "Client.Cust" : isChinaTown ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_method' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 124
	      }]), [{
	        key: "FinalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }], _toConsumableArray(isAN ? [] : [{
	        key: "Sales_User_Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }]), [{
	        key: "SaleStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }], _toConsumableArray(isEcity ? [{
	        key: "Sales_User_Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "Creater_Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'creator' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }] : []), _toConsumableArray(isAN ? [{
	        key: "Creater_Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'creator' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }] : [{
	        key: "PaymentType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true,
	        formatter: YuansferFormatter
	      }]), _toConsumableArray(isCalco ? [] : [{
	        key: "OrderDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }]), _toConsumableArray(isCalco ? [] : [{
	        key: "DispatchDate",
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_date' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_delivery' }),
	        resizable: true,
	        sortable: true,
	        width: 125,
	        filterable: true,
	        formatter: DateFormatter
	      }]), [{
	        key: "ShipmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: SecondsDateFormatter
	      }], _toConsumableArray(!isCalco ? [] : [{
	        key: isTN ? "ClientCustName" : isChinaTown ? "ShippingMethod" : "Description",
	        name: isTN ? "Client.Cust" : isChinaTown ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_method' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 124
	      }]), _toConsumableArray(!isCalco ? [] : [{
	        key: "PromoCode",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'promo_code' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }]), _toConsumableArray(!isCalco ? [] : [{
	        key: "discountDisplay",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }]));
	
	      if (isATL) {
	        columns = [{
	          key: "SONum",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_no' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: soNumWidth
	        }, {
	          key: "CPONum",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cpo_num' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 100
	        }, {
	          key: "InvoiceNum",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 113,
	          formatter: InvoiceNumFormatter
	        }].concat(_toConsumableArray(isTQ ? [{
	          key: "PONum",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_po' }),
	          resizable: true,
	          sortable: true,
	          width: 95,
	          filterable: true
	
	        }] : []), _toConsumableArray(isFIT ? [{
	          key: "Quantity",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_qty' }),
	          resizable: true,
	          sortable: true,
	          width: 95,
	          filterable: true
	        }, {
	          key: "SKU",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }),
	          resizable: true,
	          sortable: true,
	          width: 95,
	          filterable: true
	        }] : [{
	          key: "Deliver_Customer_num",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	          resizable: true,
	          sortable: true,
	          width: 95,
	          filterable: true
	        }]), [{
	          // key: "Deliver_CustomerName",
	          key: "shipToName",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_name' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 115
	        }, {
	          key: isTN ? "ClientCustName" : isChinaTown ? "ShippingMethod" : "Description",
	          name: isTN ? "Client.Cust" : isChinaTown ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_method' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 124
	        }, {
	          key: "TrackingNum",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tracking_num' }),
	          resizable: true,
	          sortable: true,
	          width: 120,
	          filterable: true
	        }, {
	          key: "FinalPrice",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true,
	          formatter: _cashFormatter2.default
	        }, {
	          key: "Sales_User_Name",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        }, {
	          key: "SaleStatus",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        }, {
	          key: "PaymentType",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	          resizable: true,
	          sortable: true,
	          width: 95,
	          filterable: true,
	          formatter: YuansferFormatter
	        }, {
	          key: "OrderDate",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	          resizable: true,
	          sortable: true,
	          width: 95,
	          filterable: true
	        }, {
	          key: "DispatchDate",
	          name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_date' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_delivery' }),
	          resizable: true,
	          sortable: true,
	          width: 125,
	          filterable: true,
	          formatter: DateFormatter
	        }, {
	          key: "ShipmentDate",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped' }),
	          resizable: true,
	          sortable: true,
	          width: 110,
	          filterable: true,
	          formatter: SecondsDateFormatter
	        }]);
	      }
	
	      var MAGColumn = [{
	        key: "InvoiceNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 113,
	        formatter: InvoiceNumFormatter
	      }, {
	        key: "SONum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: soNumWidth
	      }, {
	        key: "cntrStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 150,
	        filterable: true
	      }, {
	        key: "ContainerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 120
	      }, {
	        key: "cntrLocation",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cntr_location' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 150
	      }, {
	        key: "terminal",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'terminal' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 120
	      }, {
	        key: "delivery_lfd",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lfd' }),
	        resizable: true,
	        sortable: true,
	        width: 125,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: "size",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'size' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 120
	      }, {
	        key: "bolNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bol_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 120
	      }, {
	        key: "delivery_eta",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'eta' }),
	        resizable: true,
	        sortable: true,
	        width: 125,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: "delivery_address",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipment_address' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 200
	      }, {
	        key: "delivery_drayage",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipment_drayage' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "Deliver_CustomerName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 115
	      }, {
	        key: "DeliveryStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'hold_select' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 250
	      }, {
	        key: "DeliveryStatusOther",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'hold_other' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 200
	      }, {
	        key: "mag_note",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note_select' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 250
	      }, {
	        key: "mag_note_other",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'note_other' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 200
	      }, {
	        key: "shipping_line",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_line' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 120
	      }, {
	        key: "cargo_weight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cargo_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 120
	      }, {
	        key: "contact_person",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'contact_person' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 120
	      }, {
	        key: "contact_email",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'contact_email' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 120
	      }, {
	        key: "FinalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "Deliver_Customer_num",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }];
	
	      // For Ecity, add SalesMargin Column before SaleStatus
	      if (isEcity) {
	        var indexSalesStatus = _.findIndex(columns, { key: "SaleStatus" });
	        var salesMarginColumn = {
	          key: "SalesMargin",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_margin_percentsign' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true,
	          formatter: _percentFormatter2.default
	        };
	        columns.splice(indexSalesStatus, 0, salesMarginColumn);
	      }
	
	      if (isTN) {
	        var indexTN = _.findIndex(columns, { key: "InvoiceNum" });
	        var cpoCol = {
	          key: "CPONum",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cpo_num' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 90
	        };
	        var refCol = {
	          key: "RefNum",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 90
	        };
	        columns.splice(indexTN, 0, cpoCol, refCol);
	
	        var orderCol = _.findIndex(columns, { key: "OrderDate" });
	        var typeCol = {
	          key: "Type",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'type' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 90
	        };
	        columns.splice(orderCol, 0, typeCol);
	      }
	
	      // if (isAFG) {
	      if (true) {
	        var indexOrderDate = _.findIndex(columns, { key: "OrderDate" });
	        var orderColum = {
	          key: "OrderDateDisplay",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	          resizable: true,
	          sortable: true,
	          width: 95,
	          filterable: true
	        };
	        columns.splice(indexOrderDate, 1, orderColum);
	
	        if (this.state.salesOrders.rows.length > 0) {
	          this.state.salesOrders.rows.map(function (row) {
	            row.OrderDateDisplay = (0, _moment2.default)(row.OrderDate).format("MM-DD-YY HH:mm");
	          });
	        }
	
	        var jmlTrackingNumColumn = {
	          key: "TrackingNum",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tracking_num' }),
	          resizable: true,
	          sortable: true,
	          width: 110,
	          filterable: true,
	          formatter: function formatter(_ref5) {
	            var value = _ref5.value;
	            return _react2.default.createElement(
	              'div',
	              {
	                style: { width: "100%", height: "100%", textAlign: "center" },
	                onDoubleClick: function onDoubleClick() {
	                  _this8.openDisplayTracking();
	                }
	              },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'details' })
	            );
	          }
	        };
	
	        if (isAPO) {
	          jmlTrackingNumColumn = {
	            key: "TrackingNum",
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tracking_num' }),
	            resizable: true,
	            sortable: true,
	            width: 160,
	            filterable: true,
	            getRowMetaData: function getRowMetaData(row) {
	              return row;
	            },
	            formatter: function formatter(_ref6) {
	              var value = _ref6.value,
	                  dependentValues = _ref6.dependentValues;
	              return _react2.default.createElement(
	                'div',
	                {
	                  style: { width: "100%", height: "100%", textAlign: "center" },
	                  onDoubleClick: function onDoubleClick() {
	                    _this8.openChangeTracking(value, dependentValues);
	                  }
	                },
	                value ? value : "-"
	              );
	            }
	          };
	        }
	        if (isJML || isSY) {
	          columns.splice(indexOrderDate, 0, jmlTrackingNumColumn);
	        }
	
	        var indexSY = _.findIndex(columns, { key: "SaleStatus" });
	        var SalesOrderTypeSyColumn = {
	          key: "SalesOrderTypeSy",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_type' }),
	          resizable: true,
	          sortable: true,
	          width: 110,
	          filterable: true
	        };
	        if (isSY) {
	          columns.splice(indexSY, 0, SalesOrderTypeSyColumn);
	        }
	      }
	
	      if (isMyuMyu || isAFG || isWecom) {
	        var indexEstDelivery = _.findIndex(columns, { key: "DispatchDate" });
	        var estColum = {
	          key: "DispatchDateDisplay",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_delivery' }),
	          resizable: true,
	          sortable: true,
	          width: 160,
	          filterable: true
	        };
	        columns.splice(indexEstDelivery, 1, estColum);
	        if (this.state.salesOrders.rows.length > 0) {
	          this.state.salesOrders.rows.map(function (row) {
	            var date1 = _moment2.default.utc((0, _moment2.default)(row.DispatchDate)).local().format("HH:mm");
	            var date2 = _moment2.default.utc((0, _moment2.default)(row.DispatchDate)).local().subtract(2, "hours").format("MM-DD-YY HH:mm");
	            row.DispatchDateDisplay = date2 + '-' + date1;
	          });
	        }
	      } else if (isAFM) {
	        var _indexEstDelivery = _.findIndex(columns, { key: "DispatchDate" });
	        var _estColum = {
	          key: "TimeRange",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_delivery' }),
	          resizable: true,
	          sortable: true,
	          width: 160,
	          filterable: true,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          },
	          formatter: function formatter(props) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              props.value
	            );
	          }
	        };
	        var estColum1 = {
	          key: "ShippingMethod",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_method' }),
	          resizable: true,
	          sortable: true,
	          width: 160,
	          filterable: true
	        };
	        columns.splice(_indexEstDelivery, 1, _estColum, estColum1);
	
	        var indexFP = _.findIndex(columns, { key: "FinalPrice" });
	        if (this.state.salesOrders.rows.length > 0) {
	          this.state.salesOrders.rows.map(function (row) {
	            row.PaymentHoldDisplay = row.PaymentHold ? "true" : "false";
	          });
	        }
	        var paymentHoldCol = {
	          key: "PaymentHoldDisplay",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_hold' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	          // formatter: ({ value }) => (
	          //   <div>
	          //     { value ? "true" : "false" }
	          //   </div>
	          // ),
	        };
	        columns.splice(indexFP, 0, paymentHoldCol);
	      }
	
	      if (isGV) {
	        columns.splice(5, 0, {
	          key: "GvTicketQRCodeUrl",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qr_code' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 90,
	          formatter: function formatter(_ref7) {
	            var value = _ref7.value;
	
	            if (value) {
	              return _react2.default.createElement(
	                'a',
	                { href: value },
	                'download'
	              );
	            } else {
	              return null;
	            }
	          }
	        });
	      };
	
	      if (isAFM) {
	        columns.splice(8, 0, {
	          key: "ShippingStatus",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_status' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 90
	        });
	        columns.splice(9, 0, {
	          key: "OrderImage",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_image' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 90,
	          formatter: function formatter(_ref8) {
	            var value = _ref8.value;
	            return _react2.default.createElement(
	              'div',
	              {
	                style: { width: "100%", height: "100%", textAlign: "center" },
	                onDoubleClick: function onDoubleClick() {
	                  if (value !== '') {
	                    _this8.openShowDriverImage();
	                  }
	                }
	              },
	              value !== '' && _react2.default.createElement(_reactReduxI18n.Translate, { value: 'show' })
	            );
	          }
	        });
	        if (this.state.Status === 'Canceled') {
	          columns.splice(7, 0, {
	            key: "Settled",
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'settled' }),
	            resizable: true,
	            sortable: true,
	            filterable: true,
	            width: 90,
	            formatter: function formatter(_ref9) {
	              var value = _ref9.value;
	              return _react2.default.createElement(
	                'div',
	                {
	                  style: { width: "100%", height: "100%", textAlign: "center" }
	                },
	                value ? 'yes' : 'no'
	              );
	            }
	          });
	        }
	      }
	
	      if (isTN) {
	        var indexDispatchPrice = _.findIndex(columns, { key: "ShipmentDate" });
	        var shipByColumn = {
	          key: "ShipByDate",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_by' }),
	          resizable: true,
	          sortable: true,
	          width: 125,
	          filterable: true,
	          formatter: DateFormatter
	        };
	        var createTimeColumn = {
	          key: "CreateTime",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_time' }),
	          resizable: true,
	          sortable: true,
	          width: 125,
	          filterable: true,
	          formatter: DateFormatter
	        };
	        columns.splice(indexDispatchPrice, 0, shipByColumn, createTimeColumn);
	      }
	
	      if (!isTN && !isFIT && !isAN && !isCalco) {
	        var indexFinalPrice = _.findIndex(columns, { key: "FinalPrice" });
	        // this.context.router.routes[1].path !== "mobileSalesOrders"
	        if (isAFG && this.context.router.routes[1].path === "mobileSalesOrders") {} else {
	          var discountColumn = {
	            key: "discountDisplay",
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'discount' }),
	            resizable: true,
	            sortable: true,
	            width: 90,
	            filterable: true
	          };
	          var promoCodeColumn = {
	            key: "PromoCode",
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'promo_code' }),
	            resizable: true,
	            sortable: true,
	            filterable: true,
	            width: 100
	            // formatter: PromoCodeFormatter,
	          };
	          columns.splice(indexFinalPrice, 0, promoCodeColumn);
	          if (this.state.salesOrders.rows.length > 0) {
	            this.state.salesOrders.rows.map(function (row) {
	              if (!row.PromoCode) {
	                row.PromoCode = "-";
	              }
	            });
	          }
	          columns.splice(indexFinalPrice, 0, discountColumn);
	          if (this.state.salesOrders.rows.length > 0) {
	            this.state.salesOrders.rows.map(function (row) {
	              if (row.Discount !== 0 && row.Savings) {
	                row.discountDisplay = row.Discount + "% - $" + row.Savings.toFixed(2);
	              } else if (row.Discount === 0 && row.Savings !== 0) {
	                row.discountDisplay = "$" + row.Savings.toFixed(2);
	              } else {
	                row.discountDisplay = "-";
	              }
	            });
	          }
	        }
	
	        // For mobile sales order, replace Sales_User_Name with City
	        if (this.context.router.routes[1].path === "mobileSalesOrders") {
	          var _indexFinalPrice = _.findIndex(columns, { key: "FinalPrice" });
	          var groupBuyColumn = {
	            key: "IsGroupBuyDisplay",
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'group_buy' }),
	            resizable: true,
	            sortable: true,
	            width: 90,
	            filterable: true,
	            formatter: function formatter(_ref10) {
	              var value = _ref10.value;
	              return _react2.default.createElement(
	                'div',
	                { style: { width: "100%", height: "100%", textAlign: "center" } },
	                value
	              );
	            }
	          };
	          if (isWecom) {
	            columns.splice(_indexFinalPrice, 0, groupBuyColumn);
	            if (this.state.salesOrders.rows.length > 0) {
	              this.state.salesOrders.rows.map(function (row) {
	                if (row.IsGroupBuy === true) {
	                  row.IsGroupBuyDisplay = "yes";
	                } else {
	                  row.IsGroupBuyDisplay = "no";
	                }
	              });
	            }
	          }
	        }
	        if (isAFG && this.context.router.routes[1].path !== "mobileSalesOrders") {
	          var alcoholColumn = {
	            key: "Alcohol",
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'alcohol' }),
	            resizable: true,
	            sortable: true,
	            width: 90,
	            filterable: true
	          };
	          columns.splice(indexFinalPrice, 0, alcoholColumn);
	        }
	        if (isAFG) {
	          var platformColumn = {
	            key: "platform",
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'platform' }),
	            resizable: true,
	            sortable: true,
	            width: 90,
	            filterable: true
	          };
	          columns.splice(indexFinalPrice, 0, platformColumn);
	        }
	
	        // Find item index using _.findIndex
	        var indexEstDeliveryName = _.findIndex(columns, {
	          key: "DispatchDate"
	        });
	        var indexSalesUserName = _.findIndex(columns, {
	          key: "Sales_User_Name"
	        });
	        var indexCreateTime = _.findIndex(columns, { key: "CreateTime" });
	        var descriptionIndex = _.findIndex(columns, { key: "Description" });
	
	        var salesColumn = {
	          key: "Sales_User_Name",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true
	        };
	        var cityColumn = {
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city' }),
	          key: "City",
	          resizable: true,
	          sortable: true,
	          width: 90,
	          filterable: true
	        };
	        var stateColumn = {
	          key: "State",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'state' }),
	          resizable: true,
	          sortable: true,
	          width: 50,
	          filterable: true
	        };
	
	        var shippingWeight = {
	          key: "FinalShippingWeight",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_weight' }),
	          resizable: true,
	          sortable: true,
	          width: 90,
	          filterable: true,
	          formatter: function formatter(_ref11) {
	            var value = _ref11.value;
	            return _react2.default.createElement(
	              'div',
	              { style: { width: "100%", height: "100%" } },
	              value ? value.toFixed(2) : null
	            );
	          }
	        };
	
	        var shippingmethodColumn = {
	          key: "ShippingMethod",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shippingMethod' }),
	          resizable: true,
	          sortable: true,
	          width: 90,
	          filterable: true
	        };
	
	        var trackingNumColumn = {
	          key: "TrackingNum",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tracking_num' }),
	          resizable: true,
	          sortable: true,
	          width: 110,
	          filterable: true,
	          formatter: function formatter(_ref12) {
	            var value = _ref12.value;
	            return _react2.default.createElement(
	              'div',
	              {
	                style: { width: "100%", height: "100%", textAlign: "center" },
	                onDoubleClick: function onDoubleClick() {
	                  if (value === "split") {
	                    _this8.openDisplayTracking();
	                  } else {
	                    onTrackingNumRouter(value);
	                  }
	                }
	              },
	              value
	            );
	          }
	        };
	
	        var trackingNumColumnEZone = {
	          key: "TrackingNum",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tracking_num' }),
	          resizable: true,
	          sortable: true,
	          width: 160,
	          filterable: true,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          },
	          formatter: function formatter(_ref13) {
	            var value = _ref13.value,
	                dependentValues = _ref13.dependentValues;
	            return _react2.default.createElement(
	              'div',
	              {
	                style: { width: "100%", height: "100%", textAlign: "center" },
	                onDoubleClick: function onDoubleClick() {
	                  // if (value === "split") {
	                  //   this.openDisplayTracking();
	                  // } else {
	                  onTrackingNumRouter2(dependentValues.TrackingURL);
	                  // }
	                }
	              },
	              value
	            );
	          }
	        };
	
	        var isMobileEZ = this.context.router.routes[1].path === "mobileSalesOrders";
	        var indexEZ = _.findIndex(columns, { key: "Deliver_CustomerName" });
	        if (isEZone && isMobileEZ) {
	          columns.splice(indexEZ, 0, trackingNumColumnEZone);
	        }
	
	        if (isAFG) {
	          columns.splice(indexEstDeliveryName, 1);
	          columns.splice(indexEstDeliveryName, 0, trackingNumColumn);
	        }
	
	        /*if (!isRivera) {
	          columns.splice(indexSalesUserName, 1, shippingWeight, cityColumn, stateColumn,);
	        } else {
	          columns.splice(indexSalesUserName, 1, cityColumn, stateColumn);
	        }
	        columns.splice(indexCreateTime, 1, shippingmethodColumn);
	        columns.splice(descriptionIndex, 1); // hide desc on mobile order
	        } else {
	        const yuansferColName = _.findIndex(columns, { key: "PaymentType" });
	        columns.splice(yuansferColName, 1); // hide payment on sales order
	        }*/
	
	        if (_root_url.isRivera) {
	          columns.splice(indexSalesUserName, 1, salesColumn, cityColumn, stateColumn);
	          columns.splice(indexCreateTime, 1, shippingmethodColumn);
	          columns.splice(descriptionIndex, 1); // hide desc on mobile order
	          var yuansferColName = _.findIndex(columns, { key: "PaymentType" });
	          columns.splice(yuansferColName, 1); // hide payment on sales order
	        } else if (isHMM) {
	          columns.splice(indexSalesUserName, 1, shippingWeight, salesColumn, cityColumn, stateColumn);
	        } else {
	          columns.splice(indexSalesUserName, 1, shippingWeight, cityColumn, stateColumn);
	        }
	      }
	
	      if (isFIT) {
	        var _trackingNumColumn = {
	          key: "TrackingNum",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tracking_num' }),
	          resizable: true,
	          sortable: true,
	          width: 110,
	          filterable: true
	        };
	        var index = _.findIndex(columns, { key: "SaleStatus" });
	        columns.splice(index + 1, 0, _trackingNumColumn);
	      }
	
	      var ABCColumn = [{
	        key: "SONum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_num' }),
	        resizable: true,
	        width: 120,
	        filterable: true,
	        locked: true
	      }, {
	        key: "CompanyName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'company_name' }),
	        resizable: true,
	        width: 120,
	        filterable: true,
	        locked: true
	      }, {
	        key: "CreateTime",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	        resizable: true,
	        width: 120,
	        filterable: true,
	        locked: true,
	        formatter: SecondsDateFormatter
	      }, {
	        key: "FBACode",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'FBA' }),
	        resizable: true,
	        width: 120,
	        filterable: true,
	        locked: true
	      }, {
	        key: "CustomerBOLNo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'BOL' }),
	        resizable: true,
	        width: 120,
	        filterable: true,
	        locked: true
	      }, {
	        key: "TotalPalletQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt' }),
	        resizable: true,
	        width: 70,
	        filterable: true
	      }, {
	        key: "TotalInboundQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inbound_plt' }),
	        resizable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: "TotalOutboundQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'outbound_plt' }),
	        resizable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: "ESTInboundDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'EST_date' }),
	        resizable: true,
	        width: 150,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "IsaNo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ISA' }),
	        resizable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: "Reason",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reason' }),
	        resizable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref14) {
	          var value = _ref14.value;
	          return _react2.default.createElement(
	            'div',
	            {
	              style: { color: value ? 'red' : '' }
	            },
	            value
	          );
	        }
	      }, {
	        key: "TotalCartonQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ctn' }),
	        resizable: true,
	        width: 70,
	        filterable: true
	      }, {
	        key: "ShippingStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shpping_status' }),
	        resizable: true,
	        width: 70,
	        filterable: true
	      }, {
	        key: "Location",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' }),
	        resizable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "PodFileUrl",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pod' }),
	        resizable: true,
	        width: 90,
	        filterable: true,
	        formatter: function formatter(_ref15) {
	          var value = _ref15.value;
	          return _react2.default.createElement(
	            'a',
	            {
	              style: { color: value ? 'green' : '', cursor: 'pointer' },
	              href: value
	            },
	            value && 'uploaded'
	          );
	        }
	      }, {
	        key: "ContainerNo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container' }),
	        resizable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: "PickUpDriverName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inbound_driver' }),
	        resizable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: "OutboundDriverName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'outbound_driver' }),
	        resizable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: "ShipFrom",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_from' }),
	        resizable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: "ShipTo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_to' }),
	        resizable: true,
	        width: 200,
	        filterable: true
	      }];
	      var USPrideColumn = [{
	        key: "SONum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'SONum' }),
	        resizable: true,
	        sortable: true,
	        width: 125,
	        filterable: true
	      }, {
	        key: "InvoiceNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 113,
	        formatter: InvoiceNumFormatter
	      }, {
	        key: "Deliver_CustomerName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'store_name' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      },
	      // {
	      //   key: "SalesName",
	      //   name: <Translate value="sales" />,
	      //   resizable: true,
	      //   sortable: true,
	      //   width: 100,
	      //   filterable: true,
	      // },
	      {
	        key: "TrackingNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tracking_num' }),
	        resizable: true,
	        sortable: true,
	        width: 160,
	        filterable: true,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        },
	        formatter: function formatter(_ref16) {
	          var value = _ref16.value,
	              dependentValues = _ref16.dependentValues;
	          return _react2.default.createElement(
	            'div',
	            {
	              style: { width: "100%", height: "100%", textAlign: "center" },
	              onDoubleClick: function onDoubleClick() {
	                // uspride lala
	                // if (isUSPride) {
	                //   this.openChangeTracking(value, dependentValues);
	                // }
	              }
	            },
	            value
	          );
	        }
	      }, {
	        key: "WarehouseName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "poNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }].concat(_toConsumableArray(this.context.router.routes[1].path === "mobileSalesOrders" ? [{
	        key: "ProductRefNums",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'SKUs' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }] : []), [{
	        key: "OrderDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_date' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: "DispatchDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'must_ship_by' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true,
	        formatter: SecondsDateFormatter
	      }, {
	        key: "backorderDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'backorder_date' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true,
	        formatter: SecondsDateFormatter
	      }, {
	        key: "ExternalStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_status' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "SaleStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sale_status' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "ShippingStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_status' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "ShippingMethod",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_method' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "carrierName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier_name' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "shipToName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_to_name' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_to_address' }),
	        resizable: true,
	        sortable: true,
	        width: 250,
	        filterable: true,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        },
	        formatter: shippingAddressFormatter
	      }, {
	        key: "Deliver_CustomerPhone",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_to_phone' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "shipToSpeed",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_to_speed' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "SalesName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }]);
	
	      var ABCFFColumn = this.context.router.routes[1].path === 'outboundOrders' || this.context.router.routes[1].path === 'mobileSalesOrders' ? [{
	        key: "SONum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ob_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: soNumWidth
	      }, {
	        key: "CPONum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cpo' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "TrackingNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tracking_num' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true,
	        formatter: function formatter(_ref17) {
	          var value = _ref17.value;
	          return _react2.default.createElement(
	            'div',
	            {
	              style: { width: "100%", height: "100%", textAlign: "center" },
	              onDoubleClick: function onDoubleClick() {
	                if (!value) {
	                  _this8.openTrackingForm();
	                }
	              }
	            },
	            value ? value : "-"
	          );
	        }
	      }, {
	        key: "Channel",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'channel' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "LoadId",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'loadId' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true
	      }, {
	        key: "SaleStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "AddressName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Street",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'street' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "State",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'state' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true
	      }, {
	        key: "OrderDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: "DispatchDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_delivery' }),
	        resizable: true,
	        sortable: true,
	        width: 125,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: "Deliver_CustomerName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 130
	      }, {
	        key: "OrderPalletQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "InvoiceNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 113,
	        formatter: InvoiceNumFormatter
	      }, {
	        key: "RefNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: "IsDirectShip",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'direct_ship' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: function formatter(_ref18) {
	          var value = _ref18.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "Carrier",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Port",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "LFDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'LF_Date' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "IsDO",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsDO' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: function formatter(_ref19) {
	          var value = _ref19.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "IsBOL",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsBOL' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: function formatter(_ref20) {
	          var value = _ref20.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "IsPOD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsPOD' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: function formatter(_ref21) {
	          var value = _ref21.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "TruckingCo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trucking_co' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DeliverTo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver_to' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "IsReturnEmpty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_empty' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref22) {
	          var value = _ref22.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "ArrivalDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'arrival_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "ReturnDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "StorageOutDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_out' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "Deliver_Customer_num",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: "Description",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 124
	      }, {
	        key: "FinalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "Sales_User_Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "PaymentType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true,
	        formatter: YuansferFormatter
	      }, {
	        key: "ShipmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: SecondsDateFormatter
	      }] : [{
	        key: "SONum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ib_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: soNumWidth
	      }, {
	        key: "InvoiceNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 113,
	        formatter: InvoiceNumFormatter
	      }, {
	        key: "SaleStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "RefNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: "ContainerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_num' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        },
	        formatter: function formatter(_ref23) {
	          var value = _ref23.value,
	              dependentValues = _ref23.dependentValues;
	
	          return _react2.default.createElement(
	            'div',
	            null,
	            dependentValues.ContainerNum_lines ? dependentValues.ContainerNum_lines : value
	          );
	        }
	      }, {
	        key: "Appointment",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'apnt_time' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "AppointmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'apnt_date' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "ISANum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'isa' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Deliver_CustomerName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 130
	      }, {
	        key: "OrderPalletQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Carrier",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Port",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "LFDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'LF_Date' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "TrackingNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tracking_num' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "IsDO",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsDO' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref24) {
	          var value = _ref24.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "IsBOL",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsBOL' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref25) {
	          var value = _ref25.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "IsPOD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsPOD' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref26) {
	          var value = _ref26.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "TruckingCo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trucking_co' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DeliverTo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver_to' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "IsReturnEmpty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_empty' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref27) {
	          var value = _ref27.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "ArrivalDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'arrival_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "ReturnDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "StorageInDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_in' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "Deliver_Customer_num",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: "Description",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 124
	      }, {
	        key: "FinalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "Sales_User_Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "PaymentType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true,
	        formatter: YuansferFormatter
	      }, {
	        key: "OrderDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: "DispatchDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_delivery' }),
	        resizable: true,
	        sortable: true,
	        width: 125,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: "ShipmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: SecondsDateFormatter
	      }];
	
	      var YIColumn = this.context.router.routes[1].path === 'outboundOrders' ? [{
	        key: "SONum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ob_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: soNumWidth
	      }, {
	        key: "InvoiceNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 113,
	        formatter: InvoiceNumFormatter
	      }, {
	        key: "QuoteNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quote_num' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true
	      }, {
	        key: "TotalCost",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'xpo_price' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "PctMarkup",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'percent_markup (%)' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true
	      }, {
	        key: "PctMarkupCost",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'percent_markup ($)' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "FlatMarkup",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'flat_markup ($)' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "FinalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_price' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "PRONum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pro_num' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true
	      }, {
	        key: "PickupRef",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true
	      }, {
	        key: "OutboundStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ob_status' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true
	      }, {
	        key: "Warehouse_id",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "BLNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bol_num' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "SealNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'seal_num' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "ProNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pro_num' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "Carrier",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "SaleStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "ContainerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_num' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "OrderType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_type' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "SSL",
	        name: "SSL",
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "MBL",
	        name: "MBL",
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Pin",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pin' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "ChassisType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'chassis_type' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "PierPass",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pier_pass' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Appointment",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'apnt_time' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "AppointmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'apnt_date' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "ShipmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipment_date' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "ISANum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'isa' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Deliver_CustomerName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 130
	      }, {
	        key: "OrderPalletQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "LooseQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'loose_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "IsDirectShip",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'direct_ship' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        // filterable: true,
	        formatter: function formatter(_ref28) {
	          var value = _ref28.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "Port",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "LFDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_free_day' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "IsDO",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsDO' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: function formatter(_ref29) {
	          var value = _ref29.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "IsBOL",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsBOL' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: function formatter(_ref30) {
	          var value = _ref30.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "IsPOD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsPOD' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: function formatter(_ref31) {
	          var value = _ref31.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "TruckingCo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trucking_co' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DeliverTo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver_to' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "IsReturnEmpty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_empty' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref32) {
	          var value = _ref32.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "ArrivalDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'arrival_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "ReturnDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "StorageOutDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_out' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "Deliver_Customer_num",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: isTN ? "ClientCustName" : "Description",
	        name: isTN ? "Client.Cust" : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 124
	      }, {
	        key: "Sales_User_Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "PaymentType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true,
	        formatter: YuansferFormatter
	      }, {
	        key: "OrderDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: "DispatchDate",
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_date' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_delivery' }),
	        resizable: true,
	        sortable: true,
	        width: 125,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: "ShipmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: SecondsDateFormatter
	      }] : [{
	        key: "SONum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ib_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: soNumWidth
	      }, {
	        key: "InvoiceNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 113,
	        formatter: InvoiceNumFormatter
	      }, {
	        key: "SaleStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "ContainerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_num' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "Warehouse_id",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "BLNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bol_num' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "SealNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'seal_num' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "ProNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pro_num' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "Carrier",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "OrderType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_type' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "SSL",
	        name: "SSL",
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "MBL",
	        name: "MBL",
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Pin",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pin' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "ChassisType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'chassis_type' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "PierPass",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pier_pass' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Appointment",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'apnt_time' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "AppointmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'apnt_date' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "ShipmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipment_date' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "ISANum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'isa' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Deliver_CustomerName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 130
	      }, {
	        key: "OrderPalletQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Carrier",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Port",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "LFDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_free_day' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "IsDO",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsDO' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref33) {
	          var value = _ref33.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "IsBOL",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsBOL' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref34) {
	          var value = _ref34.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "IsPOD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsPOD' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref35) {
	          var value = _ref35.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "TruckingCo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trucking_co' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DeliverTo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver_to' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "IsReturnEmpty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_empty' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref36) {
	          var value = _ref36.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "ArrivalDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'arrival_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "ReturnDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "StorageInDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_in' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "Deliver_Customer_num",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: isTN ? "ClientCustName" : "Description",
	        name: isTN ? "Client.Cust" : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 124
	      }, {
	        key: "FinalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "Sales_User_Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "PaymentType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true,
	        formatter: YuansferFormatter
	      }, {
	        key: "OrderDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: "DispatchDate",
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_date' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_delivery' }),
	        resizable: true,
	        sortable: true,
	        width: 125,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: "ShipmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: SecondsDateFormatter
	      }];
	
	      var KDWColumn = this.context.router.routes[1].path === 'outboundOrders' ? [{
	        key: "SONum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ob_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: soNumWidth
	      }, {
	        key: "InvoiceNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 113,
	        formatter: InvoiceNumFormatter
	      }, {
	        key: "OutboundStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ob_status' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true
	      }, {
	        key: "BLNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bol_num' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "SealNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'seal_num' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "ProNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pro_num' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "Carrier",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "SaleStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "ContainerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_num' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "OrderType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_type' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "SSL",
	        name: "SSL",
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "MBL",
	        name: "MBL",
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Pin",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pin' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "ChassisType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'chassis_type' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "PierPass",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pier_pass' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Appointment",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'apnt_time' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "AppointmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'apnt_date' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "ISANum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'isa' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Deliver_CustomerName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 130
	      }, {
	        key: "OrderPalletQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "IsDirectShip",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'direct_ship' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: function formatter(_ref37) {
	          var value = _ref37.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "Carrier",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Port",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "LFDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_free_day' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "IsDO",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsDO' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: function formatter(_ref38) {
	          var value = _ref38.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "IsBOL",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsBOL' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: function formatter(_ref39) {
	          var value = _ref39.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "IsPOD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsPOD' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: function formatter(_ref40) {
	          var value = _ref40.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "TruckingCo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trucking_co' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DeliverTo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver_to' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "IsReturnEmpty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_empty' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref41) {
	          var value = _ref41.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "ArrivalDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'arrival_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "ReturnDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "StorageOutDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_out' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "Deliver_Customer_num",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: isTN ? "ClientCustName" : "Description",
	        name: isTN ? "Client.Cust" : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 124
	      }, {
	        key: "FinalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "Sales_User_Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "PaymentType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true,
	        formatter: YuansferFormatter
	      }, {
	        key: "OrderDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: "DispatchDate",
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_date' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_delivery' }),
	        resizable: true,
	        sortable: true,
	        width: 125,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: "ShipmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: SecondsDateFormatter
	      }] : [{
	        key: "SONum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ib_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: soNumWidth
	      }, {
	        key: "InvoiceNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 113,
	        formatter: InvoiceNumFormatter
	      }, {
	        key: "SaleStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "ContainerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_num' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "BLNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bol_num' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "SealNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'seal_num' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "ProNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pro_num' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "Carrier",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "OrderType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_type' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "SSL",
	        name: "SSL",
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "MBL",
	        name: "MBL",
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Pin",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pin' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "ChassisType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'chassis_type' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "PierPass",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pier_pass' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Appointment",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'apnt_time' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "AppointmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'apnt_date' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "ISANum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'isa' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Deliver_CustomerName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 130
	      }, {
	        key: "B2BName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_name2' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 130
	      }, {
	        key: "OrderPalletQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Port",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "LFDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_free_day' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "IsDO",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsDO' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref42) {
	          var value = _ref42.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "IsBOL",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsBOL' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref43) {
	          var value = _ref43.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "IsPOD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsPOD' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref44) {
	          var value = _ref44.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "TruckingCo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trucking_co' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DeliverTo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver_to' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "IsReturnEmpty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_empty' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref45) {
	          var value = _ref45.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "ArrivalDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'arrival_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "ReturnDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "StorageInDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_in' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "Deliver_Customer_num",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: isTN ? "ClientCustName" : "Description",
	        name: isTN ? "Client.Cust" : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 124
	      }, {
	        key: "FinalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "Sales_User_Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "PaymentType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true,
	        formatter: YuansferFormatter
	      }, {
	        key: "OrderDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: "DispatchDate",
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_date' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_delivery' }),
	        resizable: true,
	        sortable: true,
	        width: 125,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: "ShipmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: SecondsDateFormatter
	      }];
	
	      var DSQColumn = this.context.router.routes[1].path === 'outboundOrders' ? [{
	        key: "SONum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ob_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: soNumWidth
	      }, {
	        key: "InvoiceNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 113,
	        formatter: InvoiceNumFormatter
	      }, {
	        key: "DSQID",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dsq_id' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Appointment",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'apnt_time' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "AppointmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'apnt_date' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "ISANum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'isa' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Deliver_CustomerName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 130
	      }, {
	        key: "ContainerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "OrderPalletQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "IsDirectShip",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'direct_ship' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: function formatter(_ref46) {
	          var value = _ref46.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "Carrier",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Port",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "LFDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'LF_Date' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "IsDO",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsDO' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: function formatter(_ref47) {
	          var value = _ref47.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "IsBOL",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsBOL' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: function formatter(_ref48) {
	          var value = _ref48.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "IsPOD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsPOD' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        formatter: function formatter(_ref49) {
	          var value = _ref49.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "TruckingCo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trucking_co' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DeliverTo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver_to' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "IsReturnEmpty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_empty' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref50) {
	          var value = _ref50.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "ArrivalDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'arrival_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "ReturnDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "StorageOutDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_out' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "Deliver_Customer_num",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: isTN ? "ClientCustName" : "Description",
	        name: isTN ? "Client.Cust" : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 124
	      }, {
	        key: "FinalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "Sales_User_Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "SaleStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "PaymentType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true,
	        formatter: YuansferFormatter
	      }, {
	        key: "OrderDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: "DispatchDate",
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_date' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_delivery' }),
	        resizable: true,
	        sortable: true,
	        width: 125,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: "ShipmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: SecondsDateFormatter
	      }] : [{
	        key: "SONum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ib_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: soNumWidth
	      }, {
	        key: "InvoiceNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 113,
	        formatter: InvoiceNumFormatter
	      }, {
	        key: "DSQID",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dsq_id' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Appointment",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'apnt_time' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "AppointmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'apnt_date' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "ISANum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'isa' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Deliver_CustomerName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 130
	      }, {
	        key: "ContainerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "OrderPalletQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_qty' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Carrier",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Port",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "LFDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'LF_Date' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "IsDO",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsDO' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref51) {
	          var value = _ref51.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "IsBOL",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsBOL' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref52) {
	          var value = _ref52.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "IsPOD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsPOD' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref53) {
	          var value = _ref53.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "TruckingCo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trucking_co' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DeliverTo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver_to' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "IsReturnEmpty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_empty' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref54) {
	          var value = _ref54.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "ArrivalDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'arrival_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "ReturnDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "StorageInDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_in' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "Deliver_Customer_num",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: isTN ? "ClientCustName" : "Description",
	        name: isTN ? "Client.Cust" : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 124
	      }, {
	        key: "FinalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "Sales_User_Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "SaleStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "PaymentType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true,
	        formatter: YuansferFormatter
	      }, {
	        key: "OrderDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: "DispatchDate",
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_date' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_delivery' }),
	        resizable: true,
	        sortable: true,
	        width: 125,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: "ShipmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: SecondsDateFormatter
	      }];
	
	      var JTBColumn = this.context.router.routes[1].path === 'outboundOrders' ? [{
	        key: "SONum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ob_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: soNumWidth
	      }, {
	        key: "InvoiceNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 113,
	        formatter: InvoiceNumFormatter
	      }, {
	        key: "ContainerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "ContainerSize",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_size' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "OrderType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_type' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DropshipType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropship_type' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Carrier",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Port",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "BOL",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'BOL' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "POD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'POD' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "FBARoute",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_route' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Appointment",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'appointment' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "TruckingCo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trucking_co' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DeliverTo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver_to' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "IsReturnEmpty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_empty' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref55) {
	          var value = _ref55.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "ArrivalDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'arrival_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "ReturnDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "StorageInDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_in' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "StorageOutDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_out' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "Deliver_Customer_num",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: "Deliver_CustomerName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 115
	      }, {
	        key: isTN ? "ClientCustName" : "Description",
	        name: isTN ? "Client.Cust" : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 124
	      }, {
	        key: "FinalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "Sales_User_Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "SaleStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "PaymentType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true,
	        formatter: YuansferFormatter
	      }, {
	        key: "OrderDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: "DispatchDate",
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_date' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_delivery' }),
	        resizable: true,
	        sortable: true,
	        width: 125,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: "ShipmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: SecondsDateFormatter
	      }] : [{
	        key: "SONum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ib_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: soNumWidth
	      }, {
	        key: "InvoiceNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 113,
	        formatter: InvoiceNumFormatter
	      }, {
	        key: "ContainerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "ContainerSize",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_size' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "ReceiveType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_type' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "ReceiveUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'receive_unit' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Carrier",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Port",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "BOL",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'BOL' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "POD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'POD' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "FBARoute",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_route' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Appointment",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'appointment' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "TruckingCo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trucking_co' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DeliverTo",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver_to' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "IsReturnEmpty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_empty' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: function formatter(_ref56) {
	          var value = _ref56.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "ArrivalDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'arrival_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "ReturnDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "StorageInDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_in' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "StorageOutDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'storage_out' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "Deliver_Customer_num",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: "Deliver_CustomerName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 115
	      }, {
	        key: isTN ? "ClientCustName" : "Description",
	        name: isTN ? "Client.Cust" : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 124
	      }, {
	        key: "FinalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "Sales_User_Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "SaleStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "PaymentType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true,
	        formatter: YuansferFormatter
	      }, {
	        key: "OrderDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: "DispatchDate",
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_date' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_delivery' }),
	        resizable: true,
	        sortable: true,
	        width: 125,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: "ShipmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: SecondsDateFormatter
	      }];
	
	      var WIZColumn = this.context.router.routes[1].path === 'outboundOrders' ? [{
	        key: "SONum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ob_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: soNumWidth
	      }, {
	        key: "InvoiceNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 113,
	        formatter: InvoiceNumFormatter
	      }, {
	        key: "OutboundStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'outbound_status' }),
	        resizable: true,
	        sortable: true,
	        width: 130,
	        filterable: true
	      }, {
	        key: "Trucker",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trucker' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "ReleaseDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'release_date' }),
	        resizable: true,
	        sortable: true,
	        width: 125,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: "ReadyDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ready_date' }),
	        resizable: true,
	        sortable: true,
	        width: 125,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: "OutboundDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'outbound_date' }),
	        resizable: true,
	        sortable: true,
	        width: 125,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: "ShipmentID",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipment_id' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Destination",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'destination' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "ISANum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'isa' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "Deliver_Customer_num",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: "Deliver_CustomerName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 115
	      }, {
	        key: isTN ? "ClientCustName" : "Description",
	        name: isTN ? "Client.Cust" : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 124
	      }, {
	        key: "FinalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "Sales_User_Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "SaleStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "Notation",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_note' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: "EmployeeNote",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'employee_note' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: "PaymentType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true,
	        formatter: YuansferFormatter
	      }, {
	        key: "OrderDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: "DispatchDate",
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_date' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_delivery' }),
	        resizable: true,
	        sortable: true,
	        width: 125,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: "ShipmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: SecondsDateFormatter
	      }] : [{
	        key: "SONum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ib_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: soNumWidth
	      }, {
	        key: "InvoiceNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 113,
	        formatter: InvoiceNumFormatter
	      }, {
	        key: "ContainerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_num' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: "ContainerSize",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_size' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Deliver_Customer_num",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: "Deliver_CustomerName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 115
	      }, {
	        key: isTN ? "ClientCustName" : "Description",
	        name: isTN ? "Client.Cust" : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 124
	      }, {
	        key: "FinalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "Sales_User_Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "SaleStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "Notation",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_note' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: "EmployeeNote",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'employee_note' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: "PaymentType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true,
	        formatter: YuansferFormatter
	      }, {
	        key: "OrderDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: "DispatchDate",
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_date' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'est_delivery' }),
	        resizable: true,
	        sortable: true,
	        width: 125,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: "ShipmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'arrived' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: SecondsDateFormatter
	      }];
	
	      var FJCompleteBackground = function FJCompleteBackground(props) {
	        var rowBackground = props.dependentValues.IsComplete ? "#4caf50" : '';
	        return _react2.default.createElement(
	          'div',
	          { style: { backgroundColor: rowBackground } },
	          _react2.default.createElement(
	            'span',
	            null,
	            props.value
	          )
	        );
	      };
	
	      var FJColumn = this.context.router.routes[1].path === 'outboundOrders' ? [{
	        key: "SONum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ob_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: soNumWidth,
	        formatter: FJCompleteBackground,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: "InvoiceNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 113,
	        formatter: InvoiceNumFormatter
	      }, {
	        key: "Agent",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'agent' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "ContainerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Carrier",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DeliverByDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver_by_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DeliverByTime",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deliver_by_time' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "ExtInvoiceNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ext_invoice' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Broker",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'broker' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Truckload",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'truckload' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "TruckNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'truck_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "PickupDriver",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_driver' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DropoffDriver",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_driver' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "PickupTrailerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_trailer' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DropoffTrailerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_trailer' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "PickupDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "PickupTime",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_time' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DropoffDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "DropoffTime",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_time' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "PickupCity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_city' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DropoffCity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_city' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "PickupState",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_state' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DropoffState",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_state' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Dispatch",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DetentionRate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'detention_rate' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "LumperFee",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lumper_fee' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Deliver_Customer_num",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: "Deliver_CustomerName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 115
	      }, {
	        key: isTN ? "ClientCustName" : "Description",
	        name: isTN ? "Client.Cust" : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 124
	      }, {
	        key: "FinalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "SaleStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "PaymentType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true,
	        formatter: YuansferFormatter
	      }, {
	        key: "OrderDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: "ShipmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: SecondsDateFormatter
	      }] : [{
	        key: "SONum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ib_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: soNumWidth,
	        formatter: FJCompleteBackground,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        }
	      }, {
	        key: "InvoiceNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 113,
	        formatter: InvoiceNumFormatter
	      }, {
	        key: "Agent",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'agent' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "ContainerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "ExtInvoiceNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ext_invoice' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Broker",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'broker' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Truckload",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'truckload' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "TruckNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'truck_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "PickupDriver",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_driver' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DropoffDriver",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_driver' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "PickupTrailerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_trailer' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DropoffTrailerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_trailer' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "PickupDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "PickupTime",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_time' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DropoffDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_date' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true,
	        formatter: DateFormatter2
	      }, {
	        key: "DropoffTime",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_time' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "PickupCity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_city' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DropoffCity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_city' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "PickupState",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_state' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DropoffState",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dropoff_state' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Dispatch",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "DetentionRate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'detention_rate' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "LumperFee",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'lumper_fee' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: "Deliver_Customer_num",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: "Deliver_CustomerName",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_name' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 115
	      }, {
	        key: isTN ? "ClientCustName" : "Description",
	        name: isTN ? "Client.Cust" : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 124
	      }, {
	        key: "FinalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "SaleStatus",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: "PaymentType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true,
	        formatter: YuansferFormatter
	      }, {
	        key: "OrderDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: "ShipmentDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped' }),
	        resizable: true,
	        sortable: true,
	        width: 110,
	        filterable: true,
	        formatter: SecondsDateFormatter
	      }];
	
	      var limitSelection = [{
	        label: '25',
	        value: 25,
	        name: 'limit'
	      }, {
	        label: '50',
	        value: 50,
	        name: 'limit'
	      }, {
	        label: '100',
	        value: 100,
	        name: 'limit'
	      }, {
	        label: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' }),
	        value: 99999,
	        name: 'limit'
	      }];
	
	      if (isAmzey) {
	        // const trackingNum = {
	        //   key: "Tracking",
	        //   name: <Translate value="tracking_num" />,
	        //   resizable: true,
	        //   sortable: true,
	        //   width: 170,
	        //   filterable: true,
	        // };
	        var trackingNum = {
	          key: "TrackingNum",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tracking_num' }),
	          resizable: true,
	          sortable: true,
	          width: 160,
	          filterable: true,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          },
	          formatter: function formatter(_ref57) {
	            var value = _ref57.value,
	                dependentValues = _ref57.dependentValues;
	            return _react2.default.createElement(
	              'div',
	              {
	                style: { width: "100%", height: "100%", textAlign: "center" },
	                onDoubleClick: function onDoubleClick() {
	                  _this8.openChangeTracking(value, dependentValues);
	                }
	              },
	              value ? value : "-"
	            );
	          }
	        };
	        var DescriptionIndex = _.findIndex(columns, { key: 'Description' });
	        columns.splice(DescriptionIndex + 1, 0, trackingNum);
	      }
	
	      var generateColumns = function generateColumns() {
	        if (isABC) {
	          return ABCColumn;
	        }
	        if (isUSPride) {
	          return USPrideColumn;
	        }
	        if (isKDW || isFBD) {
	          return KDWColumn;
	        }
	        if (isYI) {
	          return YIColumn;
	        }
	        if (isABCFF) {
	          return ABCFFColumn;
	        }
	        if (isDSQ) {
	          return DSQColumn;
	        }
	        if (isJTB) {
	          return JTBColumn;
	        }
	        if (isWIZ) {
	          return WIZColumn;
	        }
	        if (isFJ) {
	          return FJColumn;
	        }
	        if (isMAG) {
	          return MAGColumn;
	        }
	        return columns;
	      };
	
	      var selectedOrderCount = 0;
	      if (this.state.salesOrders && this.state.salesOrders.selectedRows && this.state.salesOrders.selectedRows.length > 0) {
	        selectedOrderCount = this.state.salesOrders.selectedRows.length;
	      }
	
	      return (
	        // React Table Sales Order History Table
	        _react2.default.createElement(
	          'div',
	          { id: (isTN || isUSPride || isATL || isRS || isDSQ || isWUFS || isEZone || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB || isMAG) && "TNMSOTable" },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'div',
	                { id: 'salesOrders-dataGrid1', style: { marginTop: '26px' } },
	                _react2.default.createElement(_reactDataGrid2.default, {
	                  rowKey: 'SalesOrder_id',
	                  ref: function ref(g) {
	                    _this8.grid = g;
	                  },
	                  onGridSort: handleGridSort,
	                  toolbar: isABC ? null : _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                  onAddFilter: handleFilterChange,
	                  columns: generateColumns(),
	                  rowHeight: 25,
	                  headerRowHeight: 45,
	                  rowGetter: rowGetter,
	                  rowsCount: getSize(),
	                  onClearFilters: onClearFilters,
	                  minHeight: tableHeight - (isABC ? 100 : 0) //LALALA
	                  , enableRowSelect: 'multi',
	                  rowSelection: {
	                    showCheckbox: true,
	                    enableShiftSelect: true,
	                    onRowsSelected: onRowsSelected,
	                    onRowsDeselected: onRowsDeselected,
	                    selectBy: {
	                      isSelectedKey: "isSelected"
	                    }
	                  },
	                  onRowClick: onRowClick,
	                  onCellSelected: onCellSelected
	                })
	              )
	            )
	          ),
	          isABC && this.context.router.routes[1].path !== 'salesOrders' &&
	          // false &&
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 6, style: { display: 'flex' } },
	              _react2.default.createElement(
	                'div',
	                { style: { width: '600px' }, id: 'react-pagination' },
	                _react2.default.createElement(_reactPaginate2.default, {
	                  previousLabel: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prev_page' }),
	                  nextLabel: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'next_page' }),
	                  containerClassName: 'pagination',
	                  activeClassName: 'active',
	                  marginPagesDisplayed: 2,
	                  pageRangeDisplayed: 5,
	                  pageCount: this.props.msoTotalPages,
	                  onPageChange: handleOnPageChange,
	                  forcePage: this.state.currentPage
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { width: '100px', marginTop: '6px', marginLeft: '15px' } },
	                _react2.default.createElement(
	                  _reactBootstrap.Dropdown,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Dropdown.Toggle,
	                    { style: { height: '28px', width: '60px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' } },
	                    this.state.limitDisplay
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Dropdown.Menu,
	                    { className: 'super-colors' },
	                    limitSelection.map(function (el) {
	                      return _react2.default.createElement(
	                        _reactBootstrap.MenuItem,
	                        { onClick: function onClick() {
	                            return handleLimitChange(el);
	                          } },
	                        el.label
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          !isABC && _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 2 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'row-count' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_orders' }),
	                    ':\xA0',
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'font-color-orange', id: 'row-count-equation' },
	                      this.state.rowsCount + ' - ' + this.state.canceledOrders + ' = ' + (this.state.rowsCount - this.state.canceledOrders)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'row-count', style: { marginTop: '0px' } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'selected_orders' }),
	                    ':\xA0',
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'font-color-orange', id: 'row-count-equation' },
	                      selectedOrderCount
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 6 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'grand-total' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'grand-total-label' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'grand_total' }),
	                      ':\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'font-color-grey', id: 'total-equation' },
	                      '$' + (0, _numberWithCommas.numberWithCommas)((this.state.total || 0).toFixed(2)) + ' - $' + (0, _numberWithCommas.numberWithCommas)((this.state.canceledTotal || 0).toFixed(2)) + ' = $' + (0, _numberWithCommas.numberWithCommas)((this.state.total - this.state.canceledTotal).toFixed(2))
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mso-footnotes' },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_total_orders_equation' })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_grand_total_equation' })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDatePickers',
	    value: function renderDatePickers() {
	      if (this.state.days === -1) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'form-group date-picker-positioner' },
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-2 from-label col-xs-offset-5' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'from' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-2 control-date-picker' },
	            _react2.default.createElement(_reduxForm.Field, { name: 'FromDate', component: _datePicker.DatePicker })
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'col-xs-1 to-label' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'to' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-2 control-date-picker' },
	            _react2.default.createElement(_reduxForm.Field, { name: 'ToDate', component: _datePicker.DatePicker })
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderUsers',
	    value: function renderUsers() {
	      if (this.props.usersIsLoading) return _react2.default.createElement(_spinner2.default, null); // If group is loading, show a spinner.
	      var Users = this.getUsers();
	      return _react2.default.createElement(
	        'div',
	        { style: { marginRight: "10px" }, className: 'control-dropdown' },
	        _react2.default.createElement(_reduxForm.Field, { name: 'Seller', component: _selection.Selection, options: Users })
	      );
	    }
	  }, {
	    key: 'renderWarehouse',
	    value: function renderWarehouse() {
	      return _react2.default.createElement(
	        'div',
	        { style: { marginRight: "10px" }, className: 'control-dropdown2' },
	        _react2.default.createElement(_reduxForm.Field, { name: 'Warehouse_id', component: _selection.Selection, options: this.state.warehouseOptions })
	      );
	    }
	  }, {
	    key: 'getUsers',
	    value: function getUsers() {
	      var Users = [];
	      this.props.users.map(function (user) {
	        Users.push({ value: user.user_id, label: user.username });
	      });
	      return Users;
	    }
	  }, {
	    key: 'renderAddresses',
	    value: function renderAddresses() {
	      var Addresses = this.getAddress();
	      return _react2.default.createElement(
	        'div',
	        { style: { margin: "10px" }, className: 'control-dropdown' },
	        _react2.default.createElement(_reduxForm.Field, {
	          name: 'Warehouse',
	          component: _selection.SelectionWithProps,
	          options: Addresses,
	          onChange: this.onChangeBolAddress
	        })
	      );
	    }
	  }, {
	    key: 'getAddress',
	    value: function getAddress() {
	      var Addresses = [];
	      this.props.bolAddress.map(function (address) {
	        Addresses.push({
	          value: address.FBACode,
	          label: address.FBACode + " - " + address.Address
	        });
	      });
	      return Addresses;
	    }
	  }, {
	    key: 'fetchSalesOrdersByDispatch',
	    value: function fetchSalesOrdersByDispatch(dispatchDays) {
	      var _this9 = this;
	
	      if (isATL || isUSPride) {
	        // this.state.FromDate = "1900-01-01";
	        // this.state.ToDate = "3000-01-01";
	        this.state.FromDate = null;
	        this.state.ToDate = null;
	        this.state.days = null;
	      }
	      if (this.state.filteredByItem) {
	        this.setState({ dispatchDays: dispatchDays }, function () {
	          _this9.fetchSalesOrdersByProduct(_this9.state.filterProductID);
	        });
	        return;
	      }
	      var seller = this.props.Seller;
	      var productNum = this.props.ProductNum;
	      var route = this.context.router.routes[1].path;
	      if (this.props.Seller) {
	        seller = this.props.Seller.value;
	      }
	      if (dispatchDays === "-1" || dispatchDays === -1) {
	        this.setState({ dispatchDays: dispatchDays }, function () {
	          _this9.props.fetchSalesOrdersByFilter(_this9.state.FromDate, _this9.state.ToDate, _this9.state.days, _this9.state.Status, seller, productNum, route, _this9.state.dispatchDateLT, _this9.state.dispatchDateGT, dispatchDays, _this9.state.limit, _this9.state.currentPage, _this9.state.searchFilter, _this9.props.Warehouse_id);
	        });
	      } else {
	        this.setState({ dispatchDays: dispatchDays, dispatchDateLT: undefined, dispatchDateGT: undefined }, function () {
	          _this9.props.fetchSalesOrdersByFilter(_this9.state.FromDate, _this9.state.ToDate, _this9.state.days, _this9.state.Status, seller, productNum, route, _this9.state.dispatchDateLT, _this9.state.dispatchDateGT, dispatchDays, _this9.state.limit, _this9.state.currentPage, _this9.state.searchFilter, _this9.props.Warehouse_id);
	        });
	      }
	    }
	  }, {
	    key: 'fetchSalesOrdersByDetails',
	    value: function fetchSalesOrdersByDetails(days) {
	      var _this10 = this;
	
	      if (isATL || isUSPride) {
	        // this.state.dispatchDateLT = "1900-01-01";
	        // this.state.dispatchDateGT = "3000-01-01";
	        this.state.dispatchDateLT = null;
	        this.state.dispatchDateGT = null;
	        this.state.dispatchDays = null;
	      }
	      this.setState({ currentPage: 0 });
	      var salesOrders = _extends({}, this.state.salesOrders, {
	        selectedRows: []
	      });
	      if (isABC) {
	        this.setState({ salesOrders: salesOrders });
	      }
	
	      if (this.state.filteredByItem) {
	        this.setState({ days: days }, function () {
	          _this10.fetchSalesOrdersByProduct(_this10.state.filterProductID);
	        });
	        return;
	      }
	      var FromDate = "1900-01-01";
	      var ToDate = "3000-01-01";
	      var seller = this.props.Seller;
	      var productNum = this.props.ProductNum;
	      var route = this.context.router.routes[1].path;
	      if (this.state.FromDate != null) {
	        FromDate = this.state.FromDate;
	      }
	
	      if (this.state.ToDate != null) {
	        ToDate = this.state.ToDate;
	      }
	
	      if (this.props.Seller) {
	        seller = this.props.Seller.value;
	      }
	
	      if (days === "-1" || days === -1) {
	        this.setState({ days: days }, function () {
	          _this10.props.fetchSalesOrdersByFilter(FromDate, ToDate, days, _this10.state.Status, seller, productNum, route, _this10.state.dispatchDateLT, _this10.state.dispatchDateGT, _this10.state.dispatchDays, _this10.state.limit, _this10.state.currentPage, _this10.state.searchFilter, _this10.props.Warehouse_id);
	        });
	      } else {
	        this.setState({ days: days, FromDate: undefined, ToDate: undefined }, function () {
	          _this10.props.fetchSalesOrdersByFilter(FromDate, ToDate, days, _this10.state.Status, seller, productNum, route, _this10.state.dispatchDateLT, _this10.state.dispatchDateGT, _this10.state.dispatchDays, _this10.state.limit, _this10.state.currentPage, _this10.state.searchFilter, _this10.props.Warehouse_id);
	        });
	      }
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      if (isATL || isUSPride) {
	        if (date === "1900-01-01") {
	          return "1900-01-01";
	        }
	        if (date === "3000-01-01") {
	          return "3000-01-01";
	        }
	      }
	      var formattedDate = date.getFullYear() + '-';
	
	      formattedDate += date.getMonth() + 1 + '-';
	      if (date.getDate() < 10) {
	        formattedDate += '0' + date.getDate();
	      } else {
	        formattedDate += date.getDate();
	      }
	      return formattedDate;
	    }
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	  }, {
	    key: 'renderProductsTable',
	    value: function renderProductsTable() {
	      var _this11 = this;
	
	      var isMobile = this.context.router.routes[1].path === "mobileSalesOrders";
	
	      if (this.props.salesOrderIsLoading && !this.props.salesOrderError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.salesOrderError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert   alert-danger' },
	            JSON.stringify(this.props.salesOrderError)
	          )
	        );
	      }
	
	      // Parameters of the react-data-grid
	
	      var tableHeight = window.innerHeight < 930 ? 185 : 185;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this11.state.salesOrderDetail);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this11.state.salesOrderDetail, {
	          sortColumn: sortColumn,
	          sortDirection: sortDirection
	        });
	        _this11.setState({ salesOrderDetail: state });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        var salesOrderDetail = _extends({}, _this11.state.salesOrderDetail, { filters: {} });
	        _this11.setState({ salesOrderDetail: salesOrderDetail });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this11.state.salesOrderDetail.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var salesOrderDetail = _extends({}, _this11.state.salesOrderDetail, {
	          filters: newFilters
	        });
	        _this11.setState({ salesOrderDetail: salesOrderDetail });
	      };
	
	      // Handle the row select function
	      var onRowSelect = function onRowSelect(rows) {
	        var salesOrderDetail = _extends({}, _this11.state.salesOrderDetail, {
	          selectedRows: rows
	        });
	        _this11.setState({ salesOrderDetail: salesOrderDetail });
	      };
	
	      var VendorNameFormatter = _react2.default.createClass({
	        displayName: 'VendorNameFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            null,
	            this.props.value.Name
	          );
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var VendorNumFormatter = _react2.default.createClass({
	        displayName: 'VendorNumFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            null,
	            this.props.value.VendorNum
	          );
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var VitDateFormatter = _react2.default.createClass({
	        displayName: 'VitDateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var Vitdate = this.props.value.split("_")[0] + "  " + (this.props.value.split("_")[1] + ":00");
	            return _react2.default.createElement(
	              'span',
	              null,
	              Vitdate
	            );
	          }
	        }
	      });
	
	      // Column definition
	      var showProductCost = function showProductCost() {
	        if (isHMM || isJML) {
	          return false;
	        }
	        if ((isJML || isChinaTown || _root_url.isRivera) && (0, _permissions2.default)('no_show_product_cost')) {
	          return false;
	        }
	        if (isTN) {
	          return false;
	        }
	        return true;
	      };
	
	      var columns = [].concat(_toConsumableArray(!isAPO ? [{
	        key: "ProductNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }] : [{
	        key: "ProductNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        },
	        formatter: function formatter(_ref58) {
	          var value = _ref58.value,
	              dependentValues = _ref58.dependentValues;
	
	          return _react2.default.createElement(
	            'div',
	            {
	              onDoubleClick: function onDoubleClick() {
	                _this11.state.altonSelectedProd = dependentValues.Product_id;
	                _this11.setAltonChildVisibility(true);
	              }
	            },
	            value
	          );
	        } }]), _toConsumableArray(isATL || isRS || isCS || isAmzey ? [{
	        key: "RefNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        },
	        formatter: function formatter(_ref59) {
	          var value = _ref59.value,
	              dependentValues = _ref59.dependentValues;
	
	          return _react2.default.createElement(
	            'div',
	            {
	              onDoubleClick: function onDoubleClick() {
	                _this11.state.altonSelectedProd = dependentValues.Product_id;
	                _this11.setAltonChildVisibility(true);
	              }
	            },
	            value
	          );
	        }
	      }] : [{
	        key: "RefNum",
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: isJML || isLO ? 200 : 70
	      }]), _toConsumableArray(isAFM ? [{
	        key: 'Brand',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'brand' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }] : []), [{
	        key: "Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 350
	      }, {
	        key: "Description",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "jmlBox",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "jmlPackageSize1",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pcs/box' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "Quantity",
	        name: isABC ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inbound_qty' }) : isJML ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_units' }) : isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_qty' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	        resizable: true,
	        width: 100,
	        sortable: true
	      }], _toConsumableArray(isTN ? [{
	        key: "Pack_Quantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pack_quantity' }),
	        resizable: true,
	        width: 100,
	        sortable: true
	      }] : []), _toConsumableArray(!isTN ? [{
	        key: "PickupQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped_qty' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }] : []), [{
	        key: "PackageType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }], _toConsumableArray(!isTN ? [{
	        key: "UnitPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }] : []), _toConsumableArray(showProductCost() ? [{
	        key: "CostPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cost_price' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }] : []), _toConsumableArray(!isTN ? [{
	        key: "TotalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }] : []), _toConsumableArray(!isTN ? [{
	        key: "ProductTax",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }] : []), [{
	        key: "NetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: "TotalNetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }]);
	
	      if (isJML) {
	        var index1 = _.findIndex(columns, { key: "NetWeight" });
	        columns.splice(index1, 1);
	        var index2 = _.findIndex(columns, { key: "TotalNetWeight" });
	        columns.splice(index2, 1);
	      }
	
	      if (!isJML) {
	        var _index = _.findIndex(columns, { key: "jmlPackageSize1" });
	        columns.splice(_index, 1);
	        var _index2 = _.findIndex(columns, { key: "jmlBox" });
	        columns.splice(_index2, 1);
	      }
	
	      if (isABC) {
	        var indexABC = _.findIndex(columns, { key: "PickupQuantity" });
	        var temp = {
	          key: "OriginalQuantity",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'original_qty' }),
	          resizable: true,
	          width: 100,
	          sortable: true
	        };
	        columns.splice(indexABC, 0, temp);
	      }
	
	      if (isHMM) {
	        var _temp = {
	          key: "PackageSize",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	          resizable: true,
	          width: 100,
	          sortable: true
	        };
	        columns.splice(5, 0, _temp);
	      }
	
	      if (isTN) {
	        var invCol = {
	          key: "Inventory",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        };
	        var handCol = {
	          key: "OnHand",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'on_hand' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        };
	        var convertNumCol = {
	          key: "pc_box",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pack' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        };
	        var totalBoxNumCol = {
	          key: "total_box",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carton' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        };
	        var indexTN = _.findIndex(columns, { key: "Pack_Quantity" });
	        columns.splice(indexTN + 1, 0, invCol, handCol, convertNumCol, totalBoxNumCol);
	      }
	
	      if (isEcity || _root_url.isLucky88) {
	        var salesMarginColumn = {
	          key: "ProductMargin",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_margin_percentsign' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true,
	          formatter: function formatter(props) {
	            if (!props.value) return null;
	            if (props.value) {
	              return _react2.default.createElement(
	                'span',
	                null,
	                props.value,
	                '%'
	              );
	            }
	          }
	        };
	        var salesMarginColumn2 = {
	          key: "SalesMargin",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_margin_percentsign' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true,
	          formatter: function formatter(props) {
	            if (!props.value) return null;
	            if (props.value) {
	              return _react2.default.createElement(
	                'span',
	                null,
	                props.value,
	                '%'
	              );
	            }
	          }
	        };
	        var TotalPriceIndex = _.findIndex(columns, { key: "TotalPrice" });
	        isMobile && columns.splice(TotalPriceIndex, 0, salesMarginColumn);
	        !isMobile && columns.splice(TotalPriceIndex, 0, salesMarginColumn2);
	      }
	
	      if (isLO) {
	        var refIndex = columns.findIndex(function (column) {
	          return column.key === 'RefNum';
	        });
	        if (refIndex !== -1) {
	          columns[refIndex].name = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'item_num' });
	        }
	        var nameIndex = columns.findIndex(function (column) {
	          return column.key === 'Name';
	        });
	        if (nameIndex !== -1) {
	          columns[nameIndex].name = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' });
	          columns[nameIndex].width = 426;
	        }
	        var descriptionIndex = columns.findIndex(function (column) {
	          return column.key === 'Description';
	        });
	        if (descriptionIndex !== -1) {
	          columns.splice(descriptionIndex, 1);
	        }
	      }
	
	      var abcffColumnBottom = this.context.router.routes[1].path === 'outboundOrders' ? [{
	        key: "ProductNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: "RefNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70
	      }, {
	        key: "GTIN",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'gtin' }),
	        resizable: true,
	        sortable: true,
	        width: 70
	      }, {
	        key: "Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "Description",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      },
	      // {
	      //   key: "ReceivedCaseQty", // PerBoxQty * Quantity
	      //   name: <Translate value="unit_qty" />,
	      //   resizable: true,
	      //   width: 80,
	      //   sortable: true,
	      //   getRowMetaData: row => row,
	      //   formatter: ({ value, dependentValues }) => (
	      //     <div>
	      //       {value ? value*dependentValues.Quantity : ""}
	      //     </div>
	      //   ),
	      // },
	      {
	        key: "Quantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'case_qty' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "PerBoxQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_case' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "PickupQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped_case_qty' }),
	        resizable: true,
	        width: 100,
	        sortable: true
	      }, {
	        key: "PackageType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "UnitPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: "CostPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cost_price' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }] : []), [{
	        key: "TotalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "ProductTax",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "NetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: "TotalNetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: "POD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pod' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "InnerLabelQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inner_label' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "OuterLabelQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'outer_label' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "DimUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dim_unit' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "StoreReady",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'store_ready' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "Preticketed",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'preticketed' }),
	        resizable: true,
	        sortable: true,
	        width: 120
	      }, {
	        key: "CantonNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'canton' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "OriginCountry",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'country' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "VendorStyleNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_style' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "TJXStyleNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tjx_style' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "UPC",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'upc' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "Color",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'color' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "Size",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'size_ratio' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "WeightUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight_unit' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "BoxLength",
	        name: "Box L",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxWidth",
	        name: "Box W",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxHeight",
	        name: "Box H",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "BoxWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletLength",
	        name: "Plt L",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletWidth",
	        name: "Plt W",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletHeight",
	        name: "Plt H",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "UnitLength",
	        name: "Unit L",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "UnitWidth",
	        name: "Unit W",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "UnitHeight",
	        name: "Unit H",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "UnitVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "Location",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "FBACode",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_code' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "FBARoute",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_route' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "TrailerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trailer' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "POList",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_list' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }]) : [{
	        key: "ProductNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: "RefNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70
	      }, {
	        key: "Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "Description",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "Remark",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        sortable: true,
	        width: 160
	      }, {
	        key: "UnitQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "Quantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'case_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PerBoxQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_case' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "ReceivedCaseQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'received_case_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        },
	        formatter: function formatter(_ref60) {
	          var value = _ref60.value,
	              dependentValues = _ref60.dependentValues;
	          return _react2.default.createElement(
	            'div',
	            null,
	            dependentValues.PerBoxQty ? dependentValues.ReceivedQuantity / dependentValues.PerBoxQty : ""
	          );
	        }
	      }, {
	        key: "ReceivedQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'received_unit_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "Location",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "FBACode",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_code' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "FBARoute",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_route' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "TrailerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trailer' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "POList",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_list' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "POD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pod' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "DimUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dim_unit' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "PalletStackable",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'stackable' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "StoreReady",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'store_ready' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "Preticketed",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'preticketed' }),
	        resizable: true,
	        sortable: true,
	        width: 120
	      }, {
	        key: "CantonNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'canton' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "OriginCountry",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'country' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "VendorStyleNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_style' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "TJXStyleNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tjx_style' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "UPC",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'upc' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "Color",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'color' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "Size",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'size_ratio' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "WeightUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight_unit' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "BoxLength",
	        name: "Box L",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxWidth",
	        name: "Box W",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxHeight",
	        name: "Box H",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "BoxWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletLength",
	        name: "Plt L",
	        resizable: true,
	        sortable: true
	      }, {
	        key: "PalletVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "UnitLength",
	        name: "Unit L",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "UnitWidth",
	        name: "Unit W",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "UnitHeight",
	        name: "Unit H",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "UnitVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PickupQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped_case_qty' }),
	        resizable: true,
	        width: 100,
	        sortable: true
	      }, {
	        key: "PackageType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "UnitPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign22222' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: "CostPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cost_price' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }] : []), [{
	        key: "TotalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "ProductTax",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "NetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: "TotalNetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }]);
	
	      var kdwColumnBottom = this.context.router.routes[1].path === 'outboundOrders' ? [{
	        key: "ProductNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: "RefNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70
	      }, {
	        key: "Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "Description",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "Quantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_qty' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "PalletQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_qty' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "ReceivedQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'received_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "Location",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "FBACode",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_code' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "FBARoute",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_route' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'ShipmentID',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipment_id' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'ServiceType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'service_type' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'ISANum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'isa_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'CustomerRef',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_ref#' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'Unloader',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unloader' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'TruckVendor',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'truck_vendor' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: "TrailerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trailer' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "POList",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_list' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "POD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pod' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "InnerLabelQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inner_label' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "OuterLabelQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'outer_label' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "DimUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dim_unit' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "WeightUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight_unit' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "BoxLength",
	        name: "Box L",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxWidth",
	        name: "Box W",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxHeight",
	        name: "Box H",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "BoxWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletLength",
	        name: "Plt L",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletWidth",
	        name: "Plt W",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletHeight",
	        name: "Plt H",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PickupQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped_qty' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "PackageType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "UnitPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: "CostPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cost_price' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }] : []), [{
	        key: "TotalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "ProductTax",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "NetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: "TotalNetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }]) : [{
	        key: "ProductNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: "RefNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70
	      }, {
	        key: "Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "Description",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "Quantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "ReceivedQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'received_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "Location",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "FBACode",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_code' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "FBARoute",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_route' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: 'ShipmentID',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipment_id' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'ServiceType',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'service_type' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'ISANum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'isa_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'CustomerRef',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_ref#' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'Unloader',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unloader' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: 'TruckVendor',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'truck_vendor' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90
	      }, {
	        key: "TrailerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trailer' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "POList",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_list' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "POD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pod' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "DimUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dim_unit' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "WeightUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight_unit' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "BoxLength",
	        name: "Box L",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxWidth",
	        name: "Box W",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxHeight",
	        name: "Box H",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "BoxWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletLength",
	        name: "Plt L",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletWidth",
	        name: "Plt W",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletHeight",
	        name: "Plt H",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PickupQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped_qty' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "PackageType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "UnitPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: "CostPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cost_price' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }] : []), [{
	        key: "TotalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "ProductTax",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "NetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: "TotalNetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }]);
	
	      var yiColumnBottom = this.context.router.routes[1].path === 'outboundOrders' ? [{
	        key: "ProductNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: "RefNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70
	      }, {
	        key: "Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "Description",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "Quantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_qty' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "PalletQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_qty' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "ReceivedQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'received_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "FBACode",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_code' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "FBARoute",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_route' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "TrailerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trailer' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "POList",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_list' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "POD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pod' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "InnerLabelQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inner_label' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "OuterLabelQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'outer_label' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "TotalShippingWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_ship_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "NMFCClass",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'nmfc' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "BoxLength",
	        name: "Box L",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxWidth",
	        name: "Box W",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxHeight",
	        name: "Box H",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "BoxWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletLength",
	        name: "Plt L",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletWidth",
	        name: "Plt W",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletHeight",
	        name: "Plt H",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PickupQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped_qty' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "PackageType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "UnitPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: "CostPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cost_price' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }] : []), [{
	        key: "TotalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "ProductTax",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "NetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: "TotalNetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }]) : [{
	        key: "ProductNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: "RefNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70
	      }, {
	        key: "Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "Description",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "Quantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "ReceivedQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'received_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "FBACode",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_code' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "FBARoute",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_route' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "TrailerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trailer' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "POList",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_list' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "POD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pod' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "TotalShippingWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_ship_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "NMFCClass",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'nmfc' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "BoxLength",
	        name: "Box L",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxWidth",
	        name: "Box W",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxHeight",
	        name: "Box H",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "BoxWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletLength",
	        name: "Plt L",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletWidth",
	        name: "Plt W",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletHeight",
	        name: "Plt H",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PickupQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped_qty' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "PackageType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "UnitPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: "CostPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cost_price' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }] : []), [{
	        key: "TotalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "ProductTax",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "NetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: "TotalNetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }]);
	
	      var dsqColumnBottom = this.context.router.routes[1].path === 'outboundOrders' ? [{
	        key: "ProductNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: "RefNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70
	      }, {
	        key: "Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "Description",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "Quantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_qty' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "PalletQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_qty' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "ReceivedQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'received_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "FBACode",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_code' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "FBARoute",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_route' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "TrailerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trailer' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "POList",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_list' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "POD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pod' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "InnerLabelQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inner_label' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "OuterLabelQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'outer_label' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "DimUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dim_unit' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "WeightUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight_unit' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "BoxLength",
	        name: "Box L",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxWidth",
	        name: "Box W",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxHeight",
	        name: "Box H",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "BoxWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletLength",
	        name: "Plt L",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletWidth",
	        name: "Plt W",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletHeight",
	        name: "Plt H",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PickupQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped_qty' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "PackageType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "UnitPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: "CostPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cost_price' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }] : []), [{
	        key: "TotalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "ProductTax",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "NetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: "TotalNetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }]) : [{
	        key: "ProductNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: "RefNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70
	      }, {
	        key: "Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "Description",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "Quantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "ReceivedQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'received_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "FBACode",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_code' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "FBARoute",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba_route' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "TrailerNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trailer' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "POList",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'po_list' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "POD",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pod' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "DimUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dim_unit' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "WeightUnit",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight_unit' }),
	        resizable: true,
	        sortable: true,
	        width: 90
	      }, {
	        key: "BoxLength",
	        name: "Box L",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxWidth",
	        name: "Box W",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxHeight",
	        name: "Box H",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "BoxWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletLength",
	        name: "Plt L",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletWidth",
	        name: "Plt W",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletHeight",
	        name: "Plt H",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "PalletVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'plt_cbm' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PickupQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped_qty' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "PackageType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "UnitPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: "CostPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cost_price' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }] : []), [{
	        key: "TotalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "ProductTax",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "NetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: "TotalNetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }]);
	
	      var DateFormatter2 = _react2.default.createClass({
	        displayName: 'DateFormatter2',
	        render: function render() {
	          if (this.props.value) {
	            var date = (0, _moment2.default)(this.props.value).format("MM-DD-YY");
	            return _react2.default.createElement(
	              'span',
	              null,
	              date
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var wizColumnBottom = this.context.router.routes[1].path === 'outboundOrders' ? [{
	        key: "ProductNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: "RefNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }),
	        resizable: true,
	        sortable: true,
	        width: 70
	      }, {
	        key: "Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "Description",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "FBACode",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fba' }),
	        resizable: true,
	        sortable: true,
	        width: 80
	      }, {
	        key: "Quantity",
	        name: isABC ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inbound_qty' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped_qty' }),
	        resizable: true,
	        width: 100,
	        sortable: true
	      }, {
	        key: "CustomerBoxQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_box' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "OutsideLabelQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'outside_label' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "InsideLabelQty",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inside_label' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "SpecialHandling",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'special_handling' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 150
	      }, {
	        key: "CustomerNote",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_note' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 150
	      }, {
	        key: "InboundCustomer",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inbound_customer' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 110
	      }, {
	        key: "InboundContainer",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inbound_container' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 110
	      }, {
	        key: "InboundDate",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inbound_date' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 90,
	        formatter: DateFormatter2
	      }, {
	        key: "ReceivedQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "ShipmentID",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipment_id' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "BillablePallets",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'billable_pallets' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'real_pallets' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "BoxPerPallet",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_per_plt' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "DispatchType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch_type' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "BoxLength",
	        name: "Box L",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxWidth",
	        name: "Box W",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxHeight",
	        name: "Box H",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_vol' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "BoxWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "IsOversize",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsOversize' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        formatter: function formatter(_ref61) {
	          var value = _ref61.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "IsOverweight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsOverweight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        formatter: function formatter(_ref62) {
	          var value = _ref62.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "PortDray",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port_dray' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "Location",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PackageType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "UnitPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: "CostPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cost_price' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }] : []), [{
	        key: "TotalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "ProductTax",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "NetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: "TotalNetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }]) : [{
	        key: "ProductNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: "Location",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "RefNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }),
	        resizable: true,
	        sortable: true,
	        width: 70
	      }, {
	        key: "Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "Description",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "Quantity",
	        name: isABC ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inbound_qty' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rcvd_qty' }),
	        resizable: true,
	        width: 100,
	        sortable: true
	      }, {
	        key: "ReceivedQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "ShipmentID",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_note' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "BillablePallets",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'billable_pallets' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'real_pallets' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "BoxPerPallet",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_per_plt' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "IsOversize",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'oversize' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        formatter: function formatter(_ref63) {
	          var value = _ref63.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "IsOverweight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'overweight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        formatter: function formatter(_ref64) {
	          var value = _ref64.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "DispatchType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse_note' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "DrayageTrucker",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dray_trucker' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "BoxLength",
	        name: "Box L",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxWidth",
	        name: "Box W",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxHeight",
	        name: "Box H",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_vol' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "BoxWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PortDray",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port_dray' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PackageType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "UnitPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: "CostPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cost_price' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }] : []), [{
	        key: "TotalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "ProductTax",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "NetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: "TotalNetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }]);
	
	      var jtbColumnBottom = [{
	        key: "ProductNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: "RefNum",
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: isJML ? 200 : 70
	      }, {
	        key: "Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 350
	      }, {
	        key: "Description",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "Quantity",
	        name: isABC ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inbound_qty' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	        resizable: true,
	        width: 100,
	        sortable: true
	      }, {
	        key: "PickupQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped_qty' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "UnitPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: "CostPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cost_price' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }] : []), [{
	        key: "TotalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "ProductTax",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "TotalNetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }]);
	      var generateColumnsBottom = function generateColumnsBottom() {
	        if (isDSQ || isWUFS || isFBD) {
	          return dsqColumnBottom;
	        }
	        if (isYI) {
	          return yiColumnBottom;
	        }
	        if (isKDW) {
	          return kdwColumnBottom;
	        }
	        if (isABCFF) {
	          return abcffColumnBottom;
	        }
	        if (isWIZ) {
	          return wizColumnBottom;
	        }
	        if (isJTB) {
	          return jtbColumnBottom;
	        }
	        return columns;
	      };
	
	      return (
	        // Sales Invoice Details
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { id: 'salesOrders-dataGrid2' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'SalesOrder_id',
	                onGridSort: handleGridSort,
	                onAddFilter: handleFilterChange,
	                onClearFilters: onClearFilters
	                // columns={columns}
	                , columns: generateColumnsBottom(),
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                rowHeight: 25,
	                headerRowHeight: 45,
	                minHeight: tableHeight,
	                onRowUpdated: this.handleRowUpdated,
	                onRowSelect: onRowSelect
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'saveMagStuff',
	    value: function saveMagStuff() {
	      var _this12 = this;
	
	      if (!this.state.magSalesOrderDetail) {
	        return;
	      }
	
	      var _state2 = this.state,
	          mag1 = _state2.mag1,
	          mag2 = _state2.mag2;
	
	
	      var magNoteTemp = [];
	      if (mag1.DRYRUN) {
	        magNoteTemp.push('DRYRUN');
	      }
	      if (mag1.OFFHIRE) {
	        magNoteTemp.push('OFFHIRE');
	      }
	      if (mag1.PIERPASS) {
	        magNoteTemp.push('PIERPASS');
	      }
	      if (mag1.AN_FEE) {
	        magNoteTemp.push('AN_FEE');
	      }
	      if (mag1.OTHER) {
	        magNoteTemp.push('OTHER');
	      }
	      if (mag1.HANDLING) {
	        magNoteTemp.push('HANDLING');
	      }
	      if (mag1.EXTRA_STOP) {
	        magNoteTemp.push('EXTRA_STOP');
	      }
	      if (mag1.EXAM) {
	        magNoteTemp.push('EXAM');
	      }
	      if (mag1.EXTRA_DELIVERY) {
	        magNoteTemp.push('EXTRA_DELIVERY');
	      }
	      if (mag1.STORAGE) {
	        magNoteTemp.push('STORAGE');
	      }
	      if (mag1.BOBTAIL_FEE) {
	        magNoteTemp.push('BOBTAIL_FEE');
	      }
	      if (mag1.CHASSIS_SPLIT) {
	        magNoteTemp.push('CHASSIS_SPLIT');
	      }
	      if (mag1.CTF) {
	        magNoteTemp.push('CTF');
	      }
	      if (mag1.FSC) {
	        magNoteTemp.push('FSC');
	      }
	      if (mag1.PREPULL) {
	        magNoteTemp.push('PREPULL');
	      }
	      if (mag1.CONGESTION) {
	        magNoteTemp.push('CONGESTION');
	      }
	      if (mag1.DROPOFF) {
	        magNoteTemp.push('DROPOFF');
	      }
	      if (mag1.OVERWEIGHT) {
	        magNoteTemp.push('OVERWEIGHT');
	      }
	      this.state.magSalesOrderDetail.mag_note = magNoteTemp.join(',');
	
	      var magDeliveryStatusTemp = [];
	      if (mag2.FREIGHT_HOLD) {
	        magDeliveryStatusTemp.push('FREIGHT_HOLD');
	      }
	      if (mag2.CUSTOM_HOLD) {
	        magDeliveryStatusTemp.push('CUSTOM_HOLD');
	      }
	      if (mag2.PIERPASS_HOLD) {
	        magDeliveryStatusTemp.push('PIERPASS_HOLD');
	      }
	      if (mag2.EXAM) {
	        magDeliveryStatusTemp.push('EXAM');
	      }
	      if (mag2.CLOSED_AREA) {
	        magDeliveryStatusTemp.push('CLOSED_AREA');
	      }
	      this.state.magSalesOrderDetail.DeliveryStatus = magDeliveryStatusTemp.join(',');
	
	      _axios2.default.put(_url.SALES_ORDERS_URL + this.state.magSalesOrderDetail.SalesOrder_id, this.state.magSalesOrderDetail, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        alert("Order Saved");
	        _this12.fetchSalesOrdersByDetails(_this12.state.days);
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	      });
	    }
	  }, {
	    key: 'renderMagContainer',
	    value: function renderMagContainer() {
	      var _this13 = this;
	
	      var _state3 = this.state,
	          magSalesOrderDetail = _state3.magSalesOrderDetail,
	          mag1 = _state3.mag1,
	          mag2 = _state3.mag2;
	
	
	      magSalesOrderDetail.delivery_lfd = magSalesOrderDetail.delivery_lfd ? new Date(magSalesOrderDetail.delivery_lfd) : null;
	
	      var handleContainerChange = function handleContainerChange(e) {
	        magSalesOrderDetail[e.name] = e.value;
	        _this13.setState({ magSalesOrderDetail: magSalesOrderDetail });
	      };
	
	      var handleContainerDate = function handleContainerDate(e, keyname) {
	        magSalesOrderDetail[keyname] = e;
	        _this13.setState({ magSalesOrderDetail: magSalesOrderDetail });
	      };
	
	      var handleContainerDrop = function handleContainerDrop(e, keyname) {
	        magSalesOrderDetail[keyname] = e.value;
	        _this13.setState({ magSalesOrderDetail: magSalesOrderDetail });
	      };
	
	      var handleContainerCheck1 = function handleContainerCheck1(keyname) {
	        mag1[keyname] = !mag1[keyname];
	        _this13.setState({ mag1: mag1 });
	      };
	
	      var handleContainerCheck2 = function handleContainerCheck2(keyname) {
	        mag2[keyname] = !mag2[keyname];
	        _this13.setState({ mag2: mag2 });
	      };
	
	      var magTerminalOptions = [{ label: "EVERPORT", value: "EVERPORT" }, { label: "LBCT", value: "LBCT" }, { label: "SHIPPERS-CARSON", value: "SHIPPERS-CARSON" }, { label: "SHIPPERS-ALAMEDA", value: "SHIPPERS-ALAMEDA" }, { label: 'SHIPPERS-LONGBEACH', value: "SHIPPERS-LONGBEACH" }, { label: "TRAPAC", value: "TRAPAC" }, { label: "WBCT", value: "WBCT" }, { label: 'PCT', value: "PCT" }, { label: "ITS", value: "ITS" }, { label: "APM", value: "APM" }, { label: "C60-MATSON", value: "C60-MATSON" }, { label: "TTI", value: "TTI" }, { label: "YUSEN", value: "YUSEN" }, { label: "FMS", value: "FMS" }, { label: "PIER-A", value: "PIER-A" }, { label: "EXAM-SITE", value: "EXAM-SITE" }, { label: "OTHER", value: "OTHER" }];
	
	      return (
	        // Sales Invoice Details
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-4' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_num' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-8' },
	                _react2.default.createElement(_reactBootstrap.Input, { disabled: true, value: magSalesOrderDetail.ContainerNum ? magSalesOrderDetail.ContainerNum : "", name: 'ContainerNum', type: 'text', onChange: function onChange(e) {
	                    return handleContainerChange(e.target);
	                  } })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-4' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bol_num' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-8' },
	                _react2.default.createElement(_reactBootstrap.Input, { disabled: true, value: magSalesOrderDetail.bolNum ? magSalesOrderDetail.bolNum : "", name: 'bolNum', type: 'text', onChange: function onChange(e) {
	                    return handleContainerChange(e.target);
	                  } })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-4', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'terminal' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-8', style: { marginBottom: '15px' } },
	                _react2.default.createElement(
	                  _reactBootstrap.Dropdown,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Dropdown.Toggle,
	                    { style: { height: '25px', width: '200px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' } },
	                    magSalesOrderDetail.terminal ? magSalesOrderDetail.terminal : 'SELECT'
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Dropdown.Menu,
	                    { className: 'super-colors' },
	                    magTerminalOptions.map(function (el) {
	                      return _react2.default.createElement(
	                        _reactBootstrap.MenuItem,
	                        { onClick: function onClick() {
	                            return handleContainerDrop(el, 'terminal');
	                          } },
	                        el.label
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-4', style: { marginBottom: '15px' } },
	                'LFD'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-8', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_DateTimePicker2.default, {
	                  id: 'all-register-datepicker',
	                  format: 'MM-DD-YY'
	                  // max={Today}
	                  // step={10}
	                  , onChange: function onChange(e) {
	                    handleContainerDate(e, 'delivery_lfd');
	                  },
	                  time: false,
	                  value: magSalesOrderDetail.delivery_lfd
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 5 },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-3' },
	                'HOLD (Select)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'FREIGHT_HOLD',
	                  checked: mag2.FREIGHT_HOLD,
	                  onClick: function onClick() {
	                    handleContainerCheck2('FREIGHT_HOLD');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Freight Hold'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'CUSTOM_HOLD',
	                  checked: mag2.CUSTOM_HOLD,
	                  onClick: function onClick() {
	                    handleContainerCheck2('CUSTOM_HOLD');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Custom Hold'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'PIERPASS_HOLD',
	                  checked: mag2.PIERPASS_HOLD,
	                  onClick: function onClick() {
	                    handleContainerCheck2('PIERPASS_HOLD');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Pierpass Hold'
	                )
	              ),
	              _react2.default.createElement('label', { style: { marginBottom: '15px' }, className: 'col-xs-3' }),
	              _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '15px' }, className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'EXAM',
	                  checked: mag2.EXAM,
	                  onClick: function onClick() {
	                    handleContainerCheck2('EXAM');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Exam'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '15px' }, className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'CLOSED_AREA',
	                  checked: mag2.CLOSED_AREA,
	                  onClick: function onClick() {
	                    handleContainerCheck2('CLOSED_AREA');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Closed Area'
	                )
	              ),
	              _react2.default.createElement(
	                'label',
	                { style: { marginBottom: '15px' }, className: 'col-xs-3' },
	                '\xA0'
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-3' },
	                'HOLD (Other)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-9' },
	                _react2.default.createElement(_reactBootstrap.Input, { value: magSalesOrderDetail.DeliveryStatusOther ? magSalesOrderDetail.DeliveryStatusOther : "", name: 'DeliveryStatusOther', type: 'text', onChange: function onChange(e) {
	                    return handleContainerChange(e.target);
	                  } })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-3' },
	                'Note (Select)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'DRYRUN',
	                  checked: mag1.DRYRUN,
	                  onClick: function onClick() {
	                    handleContainerCheck1('DRYRUN');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Dryrun'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'OFFHIRE',
	                  checked: mag1.OFFHIRE,
	                  onClick: function onClick() {
	                    handleContainerCheck1('OFFHIRE');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Offhire'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'EXTRA_STOP',
	                  checked: mag1.EXTRA_STOP,
	                  onClick: function onClick() {
	                    handleContainerCheck1('EXTRA_STOP');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Extra Stop'
	                )
	              ),
	              _react2.default.createElement('label', { className: 'col-xs-3' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'EXAM',
	                  checked: mag1.EXAM,
	                  onClick: function onClick() {
	                    handleContainerCheck1('EXAM');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Exam'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'EXTRA_DELIVERY',
	                  checked: mag1.EXTRA_DELIVERY,
	                  onClick: function onClick() {
	                    handleContainerCheck1('EXTRA_DELIVERY');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Extra Delivery'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'STORAGE',
	                  checked: mag1.STORAGE,
	                  onClick: function onClick() {
	                    handleContainerCheck1('STORAGE');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Storage'
	                )
	              ),
	              _react2.default.createElement('label', { className: 'col-xs-3' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'OVERWEIGHT',
	                  checked: mag1.OVERWEIGHT,
	                  onClick: function onClick() {
	                    handleContainerCheck1('OVERWEIGHT');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Overweight'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'DROPOFF',
	                  checked: mag1.DROPOFF,
	                  onClick: function onClick() {
	                    handleContainerCheck1('DROPOFF');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Dropoff'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'CONGESTION',
	                  checked: mag1.CONGESTION,
	                  onClick: function onClick() {
	                    handleContainerCheck1('CONGESTION');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Congestion'
	                )
	              ),
	              _react2.default.createElement('label', { className: 'col-xs-3' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'BOBTAIL_FEE',
	                  checked: mag1.BOBTAIL_FEE,
	                  onClick: function onClick() {
	                    handleContainerCheck1('BOBTAIL_FEE');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Bobtail Fee'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'PREPULL',
	                  checked: mag1.PREPULL,
	                  onClick: function onClick() {
	                    handleContainerCheck1('PREPULL');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Prepull'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'CHASSIS_SPLIT',
	                  checked: mag1.CHASSIS_SPLIT,
	                  onClick: function onClick() {
	                    handleContainerCheck1('CHASSIS_SPLIT');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Chassis Split'
	                )
	              ),
	              _react2.default.createElement('label', { className: 'col-xs-3' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'HANDLING',
	                  checked: mag1.HANDLING,
	                  onClick: function onClick() {
	                    handleContainerCheck1('HANDLING');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Handling Fee'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'PIERPASS',
	                  checked: mag1.PIERPASS,
	                  onClick: function onClick() {
	                    handleContainerCheck1('PIERPASS');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Pierpass'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'AN_FEE',
	                  checked: mag1.AN_FEE,
	                  onClick: function onClick() {
	                    handleContainerCheck1('AN_FEE');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'AN Fee'
	                )
	              ),
	              _react2.default.createElement('label', { className: 'col-xs-3' }),
	              _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '15px' }, className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'CTF',
	                  checked: mag1.CTF,
	                  onClick: function onClick() {
	                    handleContainerCheck1('CTF');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'CTF'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '15px' }, className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'FSC',
	                  checked: mag1.FSC,
	                  onClick: function onClick() {
	                    handleContainerCheck1('FSC');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'FSC'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '15px' }, className: 'col-xs-3' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  name: 'OTHER',
	                  checked: mag1.OTHER,
	                  onClick: function onClick() {
	                    handleContainerCheck1('OTHER');
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Other'
	                )
	              ),
	              _react2.default.createElement(
	                'label',
	                { style: { marginBottom: '15px' }, className: 'col-xs-3' },
	                '\xA0'
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-3' },
	                'Note (Other)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-9' },
	                _react2.default.createElement(_reactBootstrap.Input, { value: magSalesOrderDetail.mag_note_other ? magSalesOrderDetail.mag_note_other : "", name: 'mag_note_other', type: 'text', onChange: function onChange(e) {
	                    return handleContainerChange(e.target);
	                  } })
	              )
	            ),
	            _react2.default.createElement(_reactBootstrap.Col, { xs: 3 })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderMagLoad',
	    value: function renderMagLoad() {
	      var _this14 = this;
	
	      var magSalesOrderDetail = this.state.magSalesOrderDetail;
	
	
	      magSalesOrderDetail.delivery_lfd = magSalesOrderDetail.delivery_lfd ? new Date(magSalesOrderDetail.delivery_lfd) : null;
	
	      magSalesOrderDetail.pick_appt_date = magSalesOrderDetail.pick_appt_date ? new Date(magSalesOrderDetail.pick_appt_date) : null;
	      magSalesOrderDetail.loadout_date = magSalesOrderDetail.loadout_date ? new Date(magSalesOrderDetail.loadout_date) : null;
	      magSalesOrderDetail.portwaiting_start_time = magSalesOrderDetail.portwaiting_start_time ? new Date(magSalesOrderDetail.portwaiting_start_time) : null;
	      magSalesOrderDetail.portwaiting_finish_time = magSalesOrderDetail.portwaiting_finish_time ? new Date(magSalesOrderDetail.portwaiting_finish_time) : null;
	
	      // if (this.props.salesOrderIsLoading && !this.props.salesOrderError)
	      //   return <Spinner />;
	      // else if (this.props.salesOrderError) {
	      //   return (
	      //     <ContentWrapper>
	      //       <div className="alert alert-danger">
	      //         {JSON.stringify(this.props.salesOrderError)}
	      //       </div>
	      //     </ContentWrapper>
	      //   );
	      // }
	
	      // const tableHeight = window.innerHeight < 930 ? 185 : 185;
	
	      // const getRows = () => Data.Selectors.getRows(this.state.salesOrderDetail);
	
	      // const getSize = () => getRows().length;
	
	      // const rowGetter = (rowIdx) => {
	      //   const rows = getRows();
	      //   return rows[rowIdx];
	      // };
	
	      // const generateColumnsBottom = () => {
	      //   if (isWIZ) {
	      //     return wizColumnBottom;
	      //   }
	      //   if (isJTB) {
	      //     return jtbColumnBottom;
	      //   }
	      //   return columns;
	      // };
	      var handleLoadChange = function handleLoadChange(e) {
	        magSalesOrderDetail[e.name] = e.value;
	        _this14.setState({ magSalesOrderDetail: magSalesOrderDetail });
	      };
	
	      var handleLoadDate = function handleLoadDate(e, keyname) {
	        magSalesOrderDetail[keyname] = e;
	        _this14.setState({ magSalesOrderDetail: magSalesOrderDetail });
	      };
	
	      return (
	        // Sales Invoice Details
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_appt_date' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-7', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_DateTimePicker2.default, {
	                  id: 'all-register-datepicker',
	                  format: 'MM-DD-YY HH:mm'
	                  // max={Today}
	                  , step: 10,
	                  onChange: function onChange(e) {
	                    handleLoadDate(e, 'pick_appt_date');
	                  },
	                  time: true,
	                  value: magSalesOrderDetail.pick_appt_date
	                })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-4' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_appt_#' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-8' },
	                _react2.default.createElement(_reactBootstrap.Input, { value: magSalesOrderDetail.pick_appt_num ? magSalesOrderDetail.pick_appt_num : "", name: 'pick_appt_num', type: 'text', onChange: function onChange(e) {
	                    return handleLoadChange(e.target);
	                  } })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'loadout_date' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-7', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_DateTimePicker2.default, {
	                  id: 'all-register-datepicker',
	                  format: 'MM-DD-YY'
	                  // max={Today}
	                  // step={10}
	                  , onChange: function onChange(e) {
	                    handleLoadDate(e, 'loadout_date');
	                  },
	                  time: false,
	                  value: magSalesOrderDetail.loadout_date
	                })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-4' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'chassis_num' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-8' },
	                _react2.default.createElement(_reactBootstrap.Input, { value: magSalesOrderDetail.chassis_num ? magSalesOrderDetail.chassis_num : "", name: 'chassis_num', type: 'text', onChange: function onChange(e) {
	                    return handleLoadChange(e.target);
	                  } })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-4' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'loadout_port_waiting' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-8' },
	                _react2.default.createElement(_reactBootstrap.Input, { value: magSalesOrderDetail.LOADOUT_PORT_WAITING ? magSalesOrderDetail.LOADOUT_PORT_WAITING : "", name: 'LOADOUT_PORT_WAITING', type: 'text', onChange: function onChange(e) {
	                    return handleLoadChange(e.target);
	                  } })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'portwaiting_start' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-7', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_DateTimePicker2.default, {
	                  id: 'all-register-datepicker',
	                  format: 'MM-DD-YY HH:mm'
	                  // max={Today}
	                  , step: 10,
	                  onChange: function onChange(e) {
	                    handleLoadDate(e, 'portwaiting_start_time');
	                  },
	                  time: true,
	                  value: magSalesOrderDetail.portwaiting_start_time
	                })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'portwaiting_finish' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-7', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_DateTimePicker2.default, {
	                  id: 'all-register-datepicker',
	                  format: 'MM-DD-YY HH:mm'
	                  // max={Today}
	                  , step: 10,
	                  onChange: function onChange(e) {
	                    handleLoadDate(e, 'portwaiting_finish_time');
	                  },
	                  time: true,
	                  value: magSalesOrderDetail.portwaiting_finish_time
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderMagDelivery',
	    value: function renderMagDelivery() {
	      var _this15 = this;
	
	      var magSalesOrderDetail = this.state.magSalesOrderDetail;
	
	
	      magSalesOrderDetail.SCHEDULED_DELIVERY_DATE = magSalesOrderDetail.SCHEDULED_DELIVERY_DATE ? new Date(magSalesOrderDetail.SCHEDULED_DELIVERY_DATE) : null;
	      magSalesOrderDetail.ACTUAL_DELIVERY_DATE = magSalesOrderDetail.ACTUAL_DELIVERY_DATE ? new Date(magSalesOrderDetail.ACTUAL_DELIVERY_DATE) : null;
	      magSalesOrderDetail.DETENTION_START_TIME = magSalesOrderDetail.DETENTION_START_TIME ? new Date(magSalesOrderDetail.DETENTION_START_TIME) : null;
	      magSalesOrderDetail.DETENTION_FINISH_TIME = magSalesOrderDetail.DETENTION_FINISH_TIME ? new Date(magSalesOrderDetail.DETENTION_FINISH_TIME) : null;
	
	      var handleDeliveryChange = function handleDeliveryChange(e) {
	        magSalesOrderDetail[e.name] = e.value;
	        _this15.setState({ magSalesOrderDetail: magSalesOrderDetail });
	      };
	
	      var handleDeliveryDrop = function handleDeliveryDrop(e, keyname) {
	        magSalesOrderDetail[keyname] = e.value;
	        _this15.setState({ magSalesOrderDetail: magSalesOrderDetail });
	      };
	
	      var handleDeliveryDate = function handleDeliveryDate(e, keyname) {
	        magSalesOrderDetail[keyname] = e;
	        _this15.setState({ magSalesOrderDetail: magSalesOrderDetail });
	      };
	
	      var magDeliveryTypeOptions = [{
	        label: 'DROP_HOOK',
	        value: 'DROP_HOOK'
	      }, {
	        label: 'LIVE_UNLOADING',
	        value: 'LIVE_UNLOADING'
	      }];
	
	      return (
	        // Sales Invoice Details
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-4', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delivery_type' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-8', style: { marginBottom: '15px' } },
	                _react2.default.createElement(
	                  _reactBootstrap.Dropdown,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Dropdown.Toggle,
	                    { style: { height: '25px', width: '150px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' } },
	                    magSalesOrderDetail.DELIVERY_TYPE ? magSalesOrderDetail.DELIVERY_TYPE : 'SELECT'
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Dropdown.Menu,
	                    { className: 'super-colors' },
	                    magDeliveryTypeOptions.map(function (el) {
	                      return _react2.default.createElement(
	                        _reactBootstrap.MenuItem,
	                        { onClick: function onClick() {
	                            return handleDeliveryDrop(el, 'DELIVERY_TYPE');
	                          } },
	                        el.label
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'scheduled_delivery' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-7', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_DateTimePicker2.default, {
	                  id: 'all-register-datepicker',
	                  format: 'MM-DD-YY HH:mm'
	                  // max={Today}
	                  , step: 10,
	                  onChange: function onChange(e) {
	                    handleDeliveryDate(e, 'SCHEDULED_DELIVERY_DATE');
	                  },
	                  time: true,
	                  value: magSalesOrderDetail.SCHEDULED_DELIVERY_DATE
	                })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-4' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'appointment_#' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-8' },
	                _react2.default.createElement(_reactBootstrap.Input, { value: magSalesOrderDetail.SCHEDULED_DELIVERY_APPT_NUM ? magSalesOrderDetail.SCHEDULED_DELIVERY_APPT_NUM : "", name: 'SCHEDULED_DELIVERY_APPT_NUM', type: 'text', onChange: function onChange(e) {
	                    return handleDeliveryChange(e.target);
	                  } })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'actual_delivery' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-7', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_DateTimePicker2.default, {
	                  id: 'all-register-datepicker',
	                  format: 'MM-DD-YY HH:mm'
	                  // max={Today}
	                  , step: 10,
	                  onChange: function onChange(e) {
	                    handleDeliveryDate(e, 'ACTUAL_DELIVERY_DATE');
	                  },
	                  time: true,
	                  value: magSalesOrderDetail.ACTUAL_DELIVERY_DATE
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-4' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'detention_waiting_time' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-8' },
	                _react2.default.createElement(_reactBootstrap.Input, { value: magSalesOrderDetail.DETENTION_WAITING_TIME ? magSalesOrderDetail.DETENTION_WAITING_TIME : "", name: 'DETENTION_WAITING_TIME', type: 'text', onChange: function onChange(e) {
	                    return handleDeliveryChange(e.target);
	                  } })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'detention_start_time' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-7', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_DateTimePicker2.default, {
	                  id: 'all-register-datepicker',
	                  format: 'MM-DD-YY HH:mm'
	                  // max={Today}
	                  , step: 10,
	                  onChange: function onChange(e) {
	                    handleDeliveryDate(e, 'DETENTION_START_TIME');
	                  },
	                  time: true,
	                  value: magSalesOrderDetail.DETENTION_START_TIME
	                })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'detention_finish_time' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-7', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_DateTimePicker2.default, {
	                  id: 'all-register-datepicker',
	                  format: 'MM-DD-YY HH:mm'
	                  // max={Today}
	                  , step: 10,
	                  onChange: function onChange(e) {
	                    handleDeliveryDate(e, 'DETENTION_FINISH_TIME');
	                  },
	                  time: true,
	                  value: magSalesOrderDetail.DETENTION_FINISH_TIME
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-4' },
	                'POD'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-8' },
	                _react2.default.createElement(_reactBootstrap.Input, { value: magSalesOrderDetail.POD ? magSalesOrderDetail.POD : "", name: 'POD', type: 'text', onChange: function onChange(e) {
	                    return handleDeliveryChange(e.target);
	                  } })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  type: 'submit',
	                  onClick: function onClick() {
	                    // this.refs.msoCreateInputRef4.click();
	                    _this15.openWIZPOD();
	                  },
	                  disabled: this.state.salesOrders.selectedRows.length !== 1
	                },
	                _react2.default.createElement('em', { className: 'fa fa-list' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pod' })
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderMagEmpty',
	    value: function renderMagEmpty() {
	      var _this16 = this;
	
	      var magSalesOrderDetail = this.state.magSalesOrderDetail;
	
	
	      magSalesOrderDetail.EMPTY_NOTIFICATION_DATE = magSalesOrderDetail.EMPTY_NOTIFICATION_DATE ? new Date(magSalesOrderDetail.EMPTY_NOTIFICATION_DATE) : null;
	      magSalesOrderDetail.EMPTY_PICKUP_DATE = magSalesOrderDetail.EMPTY_PICKUP_DATE ? new Date(magSalesOrderDetail.EMPTY_PICKUP_DATE) : null;
	      magSalesOrderDetail.EMPTYIN_APPT_DATETIME = magSalesOrderDetail.EMPTYIN_APPT_DATETIME ? new Date(magSalesOrderDetail.EMPTYIN_APPT_DATETIME) : null;
	      magSalesOrderDetail.Empty_Return_FINAL_Date = magSalesOrderDetail.Empty_Return_FINAL_Date ? new Date(magSalesOrderDetail.Empty_Return_FINAL_Date) : null;
	      magSalesOrderDetail.empty_back_to_yard_date = magSalesOrderDetail.empty_back_to_yard_date ? new Date(magSalesOrderDetail.empty_back_to_yard_date) : null;
	
	      var handleEmptyChange = function handleEmptyChange(e) {
	        magSalesOrderDetail[e.name] = e.value;
	        _this16.setState({ magSalesOrderDetail: magSalesOrderDetail });
	      };
	
	      var handleEmptyDate = function handleEmptyDate(e, keyname) {
	        magSalesOrderDetail[keyname] = e;
	        _this16.setState({ magSalesOrderDetail: magSalesOrderDetail });
	      };
	      return (
	        // Sales Invoice Details
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-4' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'empty_status' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-8' },
	                _react2.default.createElement(_reactBootstrap.Input, { value: magSalesOrderDetail.EMPTY_STATUS ? magSalesOrderDetail.EMPTY_STATUS : "", name: 'EMPTY_STATUS', type: 'text', onChange: function onChange(e) {
	                    return handleEmptyChange(e.target);
	                  } })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'empty_notification' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-7', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_DateTimePicker2.default, {
	                  id: 'all-register-datepicker',
	                  format: 'MM-DD-YY'
	                  // max={Today}
	                  // step={10}
	                  , onChange: function onChange(e) {
	                    handleEmptyDate(e, 'EMPTY_NOTIFICATION_DATE');
	                  },
	                  time: false,
	                  value: magSalesOrderDetail.EMPTY_NOTIFICATION_DATE
	                })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'empty_pickup_date' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-7', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_DateTimePicker2.default, {
	                  id: 'all-register-datepicker',
	                  format: 'MM-DD-YY'
	                  // max={Today}
	                  // step={10}
	                  , onChange: function onChange(e) {
	                    handleEmptyDate(e, 'EMPTY_PICKUP_DATE');
	                  },
	                  time: false,
	                  value: magSalesOrderDetail.EMPTY_PICKUP_DATE
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-4' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'empty_location' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-8' },
	                _react2.default.createElement(_reactBootstrap.Input, { value: magSalesOrderDetail.EMPTY_LOCATION ? magSalesOrderDetail.EMPTY_LOCATION : "", name: 'EMPTY_LOCATION', type: 'text', onChange: function onChange(e) {
	                    return handleEmptyChange(e.target);
	                  } })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-4' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'empty-in_terminal' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-8' },
	                _react2.default.createElement(_reactBootstrap.Input, { value: magSalesOrderDetail.EMPTY_IN_TERMINAL ? magSalesOrderDetail.EMPTY_IN_TERMINAL : "", name: 'EMPTY_IN_TERMINAL', type: 'text', onChange: function onChange(e) {
	                    return handleEmptyChange(e.target);
	                  } })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'empty_appt' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-7', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_DateTimePicker2.default, {
	                  id: 'all-register-datepicker',
	                  format: 'MM-DD-YY HH:mm'
	                  // max={Today}
	                  , step: 10,
	                  onChange: function onChange(e) {
	                    handleEmptyDate(e, 'EMPTYIN_APPT_DATETIME');
	                  },
	                  time: true,
	                  value: magSalesOrderDetail.EMPTYIN_APPT_DATETIME
	                })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-4' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'empty_appt#' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-8' },
	                _react2.default.createElement(_reactBootstrap.Input, { value: magSalesOrderDetail.EMPTY_APPT_NUM ? magSalesOrderDetail.EMPTY_APPT_NUM : "", name: 'EMPTY_APPT_NUM', type: 'text', onChange: function onChange(e) {
	                    return handleEmptyChange(e.target);
	                  } })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_final_date' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-7', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_DateTimePicker2.default, {
	                  id: 'all-register-datepicker',
	                  format: 'MM-DD-YY'
	                  // max={Today}
	                  // step={10}
	                  , onChange: function onChange(e) {
	                    handleEmptyDate(e, 'Empty_Return_FINAL_Date');
	                  },
	                  time: false,
	                  value: magSalesOrderDetail.Empty_Return_FINAL_Date
	                })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-4' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'return_final_terminal' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-8' },
	                _react2.default.createElement(_reactBootstrap.Input, { value: magSalesOrderDetail.Empty_Return_FINAL_TERMINAL ? magSalesOrderDetail.Empty_Return_FINAL_TERMINAL : "", name: 'Empty_Return_FINAL_TERMINAL', type: 'text', onChange: function onChange(e) {
	                    return handleEmptyChange(e.target);
	                  } })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-4' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'empty_portwaiting' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-8' },
	                _react2.default.createElement(_reactBootstrap.Input, { value: magSalesOrderDetail.EMPTYIN_PORTWAITING ? magSalesOrderDetail.EMPTYIN_PORTWAITING : "", name: 'EMPTYIN_PORTWAITING', type: 'text', onChange: function onChange(e) {
	                    return handleEmptyChange(e.target);
	                  } })
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'col-xs-5', style: { marginBottom: '15px' } },
	                'Empty Back to Yard'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-7', style: { marginBottom: '15px' } },
	                _react2.default.createElement(_DateTimePicker2.default, {
	                  id: 'all-register-datepicker',
	                  format: 'MM-DD-YY'
	                  // max={Today}
	                  // step={10}
	                  , onChange: function onChange(e) {
	                    handleEmptyDate(e, 'empty_back_to_yard_date');
	                  },
	                  time: false,
	                  value: magSalesOrderDetail.empty_back_to_yard_date
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderProductsTableFJ',
	    value: function renderProductsTableFJ() {
	      var _this17 = this;
	
	      if (this.props.salesOrderIsLoading && !this.props.salesOrderError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.salesOrderError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.salesOrderError)
	          )
	        );
	      }
	
	      // Parameters of the react-data-grid
	
	      var tableHeight = window.innerHeight < 930 ? 185 : 185;
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this17.state.salesOrderDetail);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this17.state.salesOrderDetail, {
	          sortColumn: sortColumn,
	          sortDirection: sortDirection
	        });
	        _this17.setState({ salesOrderDetail: state });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        // all filters removed
	        var salesOrderDetail = _extends({}, _this17.state.salesOrderDetail, { filters: {} });
	        _this17.setState({ salesOrderDetail: salesOrderDetail });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this17.state.salesOrderDetail.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var salesOrderDetail = _extends({}, _this17.state.salesOrderDetail, {
	          filters: newFilters
	        });
	        _this17.setState({ salesOrderDetail: salesOrderDetail });
	      };
	
	      // Handle the row select function
	      var onRowSelect = function onRowSelect(rows) {
	        var salesOrderDetail = _extends({}, _this17.state.salesOrderDetail, {
	          selectedRows: rows
	        });
	        _this17.setState({ salesOrderDetail: salesOrderDetail });
	      };
	
	      var VendorNameFormatter = _react2.default.createClass({
	        displayName: 'VendorNameFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            null,
	            this.props.value.Name
	          );
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var VendorNumFormatter = _react2.default.createClass({
	        displayName: 'VendorNumFormatter',
	        render: function render() {
	          if (this.props.value) return _react2.default.createElement(
	            'span',
	            null,
	            this.props.value.VendorNum
	          );
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      // Column definition
	      var showProductCost = function showProductCost() {
	        if (isHMM || isJML) {
	          return false;
	        }
	        if ((isJML || isChinaTown || _root_url.isRivera) && (0, _permissions2.default)('no_show_product_cost')) {
	          return false;
	        }
	        return true;
	      };
	
	      var columns = [{
	        key: "ProductNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: "RefNum",
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: isJML ? 200 : 70
	      }, {
	        key: "Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 350
	      }, {
	        key: "Description",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "Quantity",
	        name: isABC ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inbound_qty' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	        resizable: true,
	        width: 100,
	        sortable: true
	      }, {
	        key: "PickupQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped_qty' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "PackageType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "UnitPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: "CostPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cost_price' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }] : []), [{
	        key: "TotalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "ProductTax",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "NetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: "TotalNetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }]);
	
	      if (isJML) {
	        var index1 = _.findIndex(columns, { key: "NetWeight" });
	        columns.splice(index1, 1);
	        var index2 = _.findIndex(columns, { key: "TotalNetWeight" });
	        columns.splice(index2, 1);
	      }
	
	      if (isABC) {
	        var indexABC = _.findIndex(columns, { key: "PickupQuantity" });
	        var temp = {
	          key: "OriginalQuantity",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'original_qty' }),
	          resizable: true,
	          width: 100,
	          sortable: true
	        };
	        columns.splice(indexABC, 0, temp);
	      }
	
	      if (isHMM) {
	        var _temp2 = {
	          key: "PackageSize",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'package_size' }),
	          resizable: true,
	          width: 100,
	          sortable: true
	        };
	        columns.splice(5, 0, _temp2);
	      }
	
	      if (isTN) {
	        var invCol = {
	          key: "Inventory",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        };
	        var handCol = {
	          key: "OnHand",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'on_hand' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        };
	        var convertNumCol = {
	          key: "pc_box",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pack' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        };
	        var totalBoxNumCol = {
	          key: "total_box",
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carton' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        };
	        var indexTN = _.findIndex(columns, { key: "PickupQuantity" });
	        columns.splice(indexTN, 0, invCol, handCol, convertNumCol, totalBoxNumCol);
	      }
	      var isMobile = this.context.router.routes[1].path === "mobileSalesOrders";
	
	      var jtbColumnBottom = [{
	        key: "ProductNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: "RefNum",
	        name: isTN ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: isJML ? 200 : 70
	      }, {
	        key: "Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 350
	      }, {
	        key: "Description",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "Quantity",
	        name: isABC ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inbound_qty' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	        resizable: true,
	        width: 100,
	        sortable: true
	      }, {
	        key: "PalletQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_qty' }),
	        resizable: true,
	        width: 100,
	        sortable: true
	      }, {
	        key: "PickupQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped_qty' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "PackageType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "UnitPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: "CostPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cost_price' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }] : []), [{
	        key: "TotalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "ProductTax",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "NetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: "TotalNetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }]);
	
	      var wizColumnBottom = [{
	        key: "ProductNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }, {
	        key: "RefNum",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' }),
	        resizable: true,
	        sortable: true,
	        width: 70
	      }, {
	        key: "Name",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "Description",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 150
	      }, {
	        key: "ReceivedQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'received_qty' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "ShipmentID",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipment_id' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "BillablePallets",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'billable_pallets' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'real_pallets' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "BoxPerPallet",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_per_plt' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        editable: true
	      }, {
	        key: "DispatchType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch_type' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "BoxLength",
	        name: "Box L",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxWidth",
	        name: "Box W",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxHeight",
	        name: "Box H",
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 80
	      }, {
	        key: "BoxVol",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_vol' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "BoxWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "PalletWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pallet_weight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "IsOversize",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsOversize' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        formatter: function formatter(_ref65) {
	          var value = _ref65.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "IsOverweight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'IsOverweight' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100,
	        formatter: function formatter(_ref66) {
	          var value = _ref66.value;
	          return _react2.default.createElement(
	            'div',
	            null,
	            value ? "true" : "false"
	          );
	        }
	      }, {
	        key: "PortDray",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'port_dray' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "Location",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'location' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 100
	      }, {
	        key: "Quantity",
	        name: isABC ? _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inbound_qty' }) : _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	        resizable: true,
	        width: 100,
	        sortable: true
	      }, {
	        key: "PickupQuantity",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipped_qty' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "PackageType",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	        resizable: true,
	        width: 80,
	        sortable: true
	      }, {
	        key: "UnitPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }].concat(_toConsumableArray(showProductCost() ? [{
	        key: "CostPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cost_price' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }] : []), [{
	        key: "TotalPrice",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "ProductTax",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' }),
	        resizable: true,
	        width: 70,
	        sortable: true,
	        formatter: _cashFormatter2.default
	      }, {
	        key: "NetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'net_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }, {
	        key: "TotalNetWeight",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_weight' }),
	        resizable: true,
	        width: 70,
	        sortable: true
	      }]);
	
	      var generateColumnsBottom = function generateColumnsBottom() {
	        if (isWIZ) {
	          return wizColumnBottom;
	        }
	        if (isJTB) {
	          return jtbColumnBottom;
	        }
	        return columns;
	      };
	
	      return (
	        // Sales Invoice Details
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { id: 'salesOrders-dataGrid2' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'SalesOrder_id',
	                onGridSort: handleGridSort,
	                onAddFilter: handleFilterChange,
	                onClearFilters: onClearFilters
	                // columns={columns}
	                , columns: generateColumnsBottom(),
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                rowHeight: 25,
	                headerRowHeight: 45,
	                minHeight: tableHeight,
	                onRowUpdated: this.handleRowUpdated,
	                onRowSelect: onRowSelect
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderShippingIFrame',
	    value: function renderShippingIFrame() {
	      if (this.props.shippingListPDF) {
	        var file = window.URL.createObjectURL(this.props.shippingListPDF);
	        return _react2.default.createElement('iframe', {
	          style: { display: "none" },
	          onLoad: this.shippingIFrameIsLoaded,
	          id: 'shippingPdf',
	          name: 'shippingPdf',
	          src: file
	        });
	      }
	    }
	  }, {
	    key: 'renderPackingIFrame',
	    value: function renderPackingIFrame() {
	      if (this.props.packingListPDF) {
	        var file = window.URL.createObjectURL(this.props.packingListPDF);
	        return _react2.default.createElement('iframe', {
	          style: { display: "none" },
	          onLoad: this.packingIFrameIsLoaded,
	          id: 'packingPdf',
	          name: 'packingPdf',
	          src: file
	        });
	      }
	    }
	  }, {
	    key: 'renderPickingIFrame',
	    value: function renderPickingIFrame() {
	      if (this.props.pickingListPDF) {
	        var file = window.URL.createObjectURL(this.props.pickingListPDF);
	        return _react2.default.createElement('iframe', {
	          style: { display: "none" },
	          onLoad: this.pickingIFrameIsLoaded,
	          id: 'pickingPdf',
	          name: 'pickingPdf',
	          src: file
	        });
	      }
	    }
	  }, {
	    key: 'renderSalesOrderIFrame',
	    value: function renderSalesOrderIFrame() {
	      if (this.props.salesOrderPDF) {
	        var file = window.URL.createObjectURL(this.props.salesOrderPDF);
	        return _react2.default.createElement('iframe', {
	          style: { display: "none" },
	          onLoad: this.salesOrderIFrameIsLoaded,
	          id: 'salesOrderPdf',
	          name: 'salesOrderPdf',
	          src: file
	        });
	      }
	    }
	  }, {
	    key: 'renderBolByIdIFrame',
	    value: function renderBolByIdIFrame() {
	      if (this.props.bolIdPDF) {
	        var file = window.URL.createObjectURL(this.props.bolIdPDF);
	        return _react2.default.createElement('iframe', {
	          style: { display: "none" },
	          onLoad: this.bolByIdIFrameIsLoaded,
	          id: 'bolIdPdf',
	          name: 'bolIdPdf',
	          src: file
	        });
	      }
	    }
	  }, {
	    key: 'renderBolWithoutLogIFrame',
	    value: function renderBolWithoutLogIFrame() {
	      if (this.props.bolWithoutLogPDF) {
	        var file = window.URL.createObjectURL(this.props.bolWithoutLogPDF);
	        return _react2.default.createElement('iframe', {
	          style: { display: "none" },
	          onLoad: this.bolWithoutLogIFrameIsLoaded,
	          id: 'bolWithoutLogPdf',
	          name: 'bolWithoutLogPdf',
	          src: file
	        });
	      }
	    }
	  }, {
	    key: 'renderBolLabelIFrame',
	    value: function renderBolLabelIFrame() {
	      if (this.props.bolLabel) {
	        var file = window.URL.createObjectURL(this.props.bolLabel);
	        return _react2.default.createElement('iframe', {
	          style: { display: "none" },
	          onLoad: this.bolLabelIFrameIsLoaded,
	          id: 'bolLabel',
	          name: 'bolLabel',
	          src: file
	        });
	      }
	    }
	  }, {
	    key: 'renderBolByFbaIFrame',
	    value: function renderBolByFbaIFrame() {
	      if (this.props.bolFbaPDF) {
	        var file = window.URL.createObjectURL(this.props.bolFbaPDF);
	        return _react2.default.createElement('iframe', {
	          style: { display: "none" },
	          onLoad: this.bolByFbaIFrameIsLoaded,
	          id: 'bolFbaPdf',
	          name: 'bolFbaPdf',
	          src: file
	        });
	      }
	    }
	
	    // renderPODIFrame() {
	    //   if (this.state.selectedPODFile) {
	    //     const file = window.URL.createObjectURL(this.state.selectedPODFile);
	    //     return (
	    //       <iframe
	    //         style={{ display: "none" }}
	    //         onLoad={this.PODIframLoaded}
	    //         id="podPdf"
	    //         name="podPdf"
	    //         src={file}
	    //       />
	    //     );
	    //   }
	    // }
	
	  }, {
	    key: 'renderPrint',
	    value: function renderPrint() {
	      var _this18 = this;
	
	      var salesOrder_id = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      // if(!salesOrder_id)
	      //   return;
	      var url = _root_url.ROOT_URL + 'v1/sale/printorder/' + salesOrder_id + '?Bearer=' + localStorage.getItem("token");
	      var picking_url = _root_url.ROOT_URL + 'v1/sale/printpickinglist/' + salesOrder_id + '?Bearer=' + localStorage.getItem("token");
	      var shipping_url = _root_url.ROOT_URL + 'v1/sale/printshippinglist/' + salesOrder_id + '?Bearer=' + localStorage.getItem("token");
	      var packing_url = _root_url.ROOT_URL + 'v1/sale/printpackinglist/' + salesOrder_id + '?Bearer=' + localStorage.getItem("token");
	      return _react2.default.createElement(
	        'div',
	        { className: 'padLeft', id: isABC && "buttonsContainer-padLeft" },
	        !isABCFF && _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            className: 'print-btn',
	            disabled: !salesOrder_id || !(0, _permissions2.default)("print_sales_order"),
	            type: 'button',
	            onClick: function onClick() {
	              _this18.props.printSalesOrder(salesOrder_id);
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-print' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_so' })
	        ),
	        !isABC && !isSW && !isABCFF && this.renderPickingListPrint(),
	        !isABC && !isSW && !isABCFF && this.renderPackingListPrint(),
	        isABCFF && this.context.router.routes[1].path === 'outboundOrders' && this.renderPackingListPrint(),
	        !isABC && !isSW && !isABCFF && this.renderShippingListPrint(),
	        isUSPride && this.renderExportSelectedButton(),
	        isABCFF && this.context.router.routes[1].path === "outboundOrders" && this.renderPickingListPrint(),
	        isABCFF && this.context.router.routes[1].path !== "outboundOrders" && this.renderReceivingReportPrint(),
	        isABCFF && this.context.router.routes[1].path === "outboundOrders" && this.renderDscoShipmentButton(),
	        isABCFF && this.context.router.routes[1].path === "outboundOrders" && this.renderWalmartShipmentButton(),
	        isSW && this.renderPickingListPrintSW(),
	        isSW && this.renderPackingListPrintSW(),
	        isSW && this.renderShippingListPrintSW(),
	        isTN && this.renderSetSOOpen(),
	        isABC && this.renderInboundDateEditButton(),
	        isABC && _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            style: { float: 'right' },
	            bsStyle: 'primary',
	            className: 'print-btn',
	            type: 'button',
	            onClick: function onClick() {
	              _this18.setState({
	                abcDatePickerShow: !_this18.state.abcDatePickerShow
	              });
	            }
	          },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'advanced_search' })
	        )
	      );
	    }
	  }, {
	    key: 'renderPickingListPrint',
	    value: function renderPickingListPrint() {
	      var _this19 = this;
	
	      var salesOrderIds = [];
	      var salesOrders = this.state.salesOrders;
	
	      var salesOrder_id = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      if (salesOrders && salesOrders.selectedRows.length > 0) {
	        salesOrders.selectedRows.map(function (row) {
	          salesOrderIds.push(row.SalesOrder_id);
	        });
	      }
	      if (salesOrders.selectedRows.length <= 1 && !isATL) {
	        return _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            className: 'print-btn',
	            disabled: !salesOrder_id || !(0, _permissions2.default)("print_sales_order"),
	            type: 'button',
	            onClick: function onClick() {
	              if (isJML) {
	                _this19.setLabelPrintModalVisibility(true);
	                return;
	              }
	              _this19.props.printPickingList(salesOrder_id);
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-print' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, {
	            value: isMyuMyu || isAFG || isWecom ? "pull_sheet" : "picking_list"
	          })
	        );
	      } else if (isATL) {
	        return _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            className: 'print-btn',
	            disabled: salesOrderIds.length === 0,
	            type: 'button',
	            onClick: function onClick() {
	              _this19.props.printPickingListATL(salesOrderIds.join(','));
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-print' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, {
	            value: "driver_list"
	          })
	        );
	      }
	      if (isAFG || isMyuMyu || isWecom) {
	        return _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            className: 'print-btn',
	            type: 'button',
	            disabled: !(0, _permissions2.default)("print_sales_order"),
	            onClick: function onClick() {
	              // this.props.printPickingList(salesOrderIds.join(','));
	              _this19.openChangePullSheet();
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-print' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pull_sheet' })
	        );
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          className: 'print-btn',
	          type: 'button',
	          disabled: !(0, _permissions2.default)("print_sales_order"),
	          onClick: function onClick() {
	            _this19.props.printPickingList(salesOrderIds.join(","));
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'picking_list' })
	      );
	    }
	  }, {
	    key: 'renderPickingListPrintSW',
	    value: function renderPickingListPrintSW() {
	      var _this20 = this;
	
	      var salesOrderIds = [];
	      var salesOrders = this.state.salesOrders;
	
	      var salesOrder_id = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      if (salesOrders && salesOrders.selectedRows.length > 0) {
	        salesOrders.selectedRows.map(function (row) {
	          salesOrderIds.push(row.SalesOrder_id);
	        });
	      }
	      if (salesOrders.selectedRows.length <= 1) {
	        return _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            className: 'print-btn',
	            disabled: !salesOrder_id || !(0, _permissions2.default)("print_sales_order"),
	            type: 'button',
	            onClick: function onClick() {
	              _this20.props.printPickingList(salesOrder_id);
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-print' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, {
	            value: isMyuMyu || isAFG || isWecom ? "pull_sheet" : "picking_list"
	          })
	        );
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          className: 'print-btn',
	          type: 'button',
	          disabled: !(0, _permissions2.default)("print_sales_order"),
	          onClick: function onClick() {
	            _this20.props.printPickingList(salesOrderIds.join(","));
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'picking_list' })
	      );
	    }
	  }, {
	    key: 'renderPackingListPrint',
	    value: function renderPackingListPrint() {
	      var _this21 = this;
	
	      var salesOrderIds = [];
	      var salesOrders = this.state.salesOrders;
	
	
	      var allHaveInvoiceNum = true;
	      if (salesOrders && salesOrders.selectedRows) {
	        salesOrders.selectedRows.forEach(function (salesOrder) {
	          salesOrderIds.push(salesOrder.SalesOrder_id);
	          if (!salesOrder.InvoiceNum && isHMM) {
	            allHaveInvoiceNum = false;
	          }
	        });
	      }
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          className: 'print-btn',
	          disabled: salesOrderIds.length === 0 || !(0, _permissions2.default)("print_sales_order") || !allHaveInvoiceNum,
	          type: 'button',
	          onClick: function onClick() {
	            if (isATL) {
	              _this21.props.printPackingListATL(salesOrderIds.join(","));
	            } else {
	              _this21.props.printPackingList(salesOrderIds.join(","));
	            }
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        !isATL && _react2.default.createElement(_reactReduxI18n.Translate, {
	          value: isMyuMyu || isAFG || isWecom ? "picking_sheet" : "packing_list"
	        }),
	        isATL && _react2.default.createElement(_reactReduxI18n.Translate, { value: "order_details" })
	      );
	    }
	  }, {
	    key: 'renderPackingListPrintSW',
	    value: function renderPackingListPrintSW() {
	      var _this22 = this;
	
	      var salesOrderIds = [];
	      var salesOrders = this.state.salesOrders;
	
	
	      var allHaveInvoiceNum = true;
	      if (salesOrders && salesOrders.selectedRows) {
	        salesOrders.selectedRows.forEach(function (salesOrder) {
	          salesOrderIds.push(salesOrder.SalesOrder_id);
	          if (!salesOrder.InvoiceNum && isHMM) {
	            allHaveInvoiceNum = false;
	          }
	        });
	      }
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          className: 'print-btn',
	          disabled: salesOrderIds.length === 0 || !(0, _permissions2.default)("print_sales_order") || !allHaveInvoiceNum,
	          type: 'button',
	          onClick: function onClick() {
	            _this22.props.printPackingList(salesOrderIds.join(","));
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, {
	          value: isMyuMyu || isAFG || isWecom ? "picking_sheet" : "packing_list"
	        })
	      );
	    }
	  }, {
	    key: 'renderReceivingReportPrint',
	    value: function renderReceivingReportPrint() {
	      var _this23 = this;
	
	      var salesOrderIds = [];
	      var salesOrders = this.state.salesOrders;
	
	      if (salesOrders && salesOrders.selectedRows) {
	        salesOrders.selectedRows.forEach(function (salesOrder) {
	          salesOrderIds.push(salesOrder.SalesOrder_id);
	        });
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          className: 'print-btn',
	          disabled: salesOrderIds.length === 0 || !(0, _permissions2.default)("print_sales_order"),
	          type: 'button',
	          onClick: function onClick() {
	            _this23.props.printPackingList(salesOrderIds.join(","));
	            // this.props.printReceivingReport(salesOrderIds.join(","));
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: "receiving_report" })
	      );
	    }
	  }, {
	    key: 'renderShippingListPrint',
	    value: function renderShippingListPrint() {
	      var _this24 = this;
	
	      var salesOrderIds = [];
	      var salesOrders = this.state.salesOrders;
	
	      if (salesOrders && salesOrders.selectedRows) {
	        salesOrders.selectedRows.forEach(function (salesOrder) {
	          salesOrderIds.push(salesOrder.SalesOrder_id);
	        });
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          className: 'print-btn',
	          disabled: salesOrderIds.length === 0 || !(0, _permissions2.default)("print_sales_order"),
	          type: 'button',
	          onClick: function onClick() {
	            if (isATL) {
	              _this24.props.printShippingListATL(salesOrderIds.join(","));
	            } else {
	              _this24.props.printShippingList(salesOrderIds.join(","));
	            }
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: isATL ? "shipping_request" : "shipping_list" })
	      );
	    }
	  }, {
	    key: 'renderShippingListPrintSW',
	    value: function renderShippingListPrintSW() {
	      var _this25 = this;
	
	      var salesOrderIds = [];
	      var salesOrders = this.state.salesOrders;
	
	      if (salesOrders && salesOrders.selectedRows) {
	        salesOrders.selectedRows.forEach(function (salesOrder) {
	          salesOrderIds.push(salesOrder.SalesOrder_id);
	        });
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          className: 'print-btn',
	          disabled: salesOrderIds.length === 0 || !(0, _permissions2.default)("print_sales_order"),
	          type: 'button',
	          onClick: function onClick() {
	            _this25.props.printShippingList(salesOrderIds.join(","));
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: "shipping_list" })
	      );
	    }
	  }, {
	    key: 'renderDscoShipmentButton',
	    value: function renderDscoShipmentButton() {
	      var _this26 = this;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          style: { marginLeft: '5px' },
	          bsStyle: 'success',
	          type: 'button',
	          onClick: function onClick() {
	            _this26.refs.dsco_ref.click();
	          },
	          disabled: false
	        },
	        _react2.default.createElement('em', { className: 'fa fa-upload' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dsco_shipment' })
	      );
	    }
	  }, {
	    key: 'renderWalmartShipmentButton',
	    value: function renderWalmartShipmentButton() {
	      var _this27 = this;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          style: { marginLeft: '5px' },
	          bsStyle: 'success',
	          type: 'button',
	          onClick: function onClick() {
	            _this27.refs.walmartb2b_ref.click();
	          },
	          disabled: false
	        },
	        _react2.default.createElement('em', { className: 'fa fa-upload' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'walmart_shipment' })
	      );
	    }
	  }, {
	    key: 'renderYingBOLPrint',
	    value: function renderYingBOLPrint() {
	      var _this28 = this;
	
	      var salesOrderIds = [];
	      var salesOrders = this.state.salesOrders;
	
	      if (salesOrders && salesOrders.selectedRows) {
	        salesOrders.selectedRows.forEach(function (salesOrder) {
	          salesOrderIds.push(salesOrder.SalesOrder_id);
	        });
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          className: 'print-btn',
	          disabled: salesOrderIds.length === 0 || !(0, _permissions2.default)("print_sales_order"),
	          type: 'button',
	          onClick: function onClick() {
	            _this28.props.printYingBOL(salesOrderIds.join(","));
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        '\xA0BOL'
	      );
	    }
	
	    // renderYingPrintFile() {
	    //   const salesOrderIds = [];
	    //   const { salesOrders } = this.state;
	    //   if (salesOrders && salesOrders.selectedRows) {
	    //     salesOrders.selectedRows.forEach((salesOrder) => {
	    //       salesOrderIds.push(salesOrder.SalesOrder_id);
	    //     });
	    //   }
	    //   return (
	    //     <Button
	    //       bsStyle="primary"
	    //       className="print-btn"
	    //       disabled={
	    //         salesOrderIds.length === 0 || !checkPermission("print_sales_order")
	    //       }
	    //       type="button"
	    //       onClick={() => {
	    //         this.props.printYingCustomerFile(salesOrderIds.join(","));
	    //       }}
	    //     >
	    //       <em className="fa fa-print" />
	    //       <Translate value="customer_label" />
	    //     </Button>
	    //   );
	    // }
	
	  }, {
	    key: 'renderYingPrintFile',
	    value: function renderYingPrintFile() {
	      var _this29 = this;
	
	      var salesOrderIds = [];
	      var salesOrders = this.state.salesOrders;
	
	      if (salesOrders && salesOrders.selectedRows.length > 0) {
	        salesOrders.selectedRows.map(function (row) {
	          salesOrderIds.push(row.SalesOrder_id);
	        });
	      }
	
	      var exportUrl = _root_url.ROOT_URL + 'v2/sales/order-file-upload/' + salesOrderIds.join(",") + '?Bearer=' + localStorage.getItem("token");
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          className: 'print-btn'
	          // href={exportUrl}
	          , onClick: function onClick() {
	            _this29.yingPrintFile();
	          },
	          disabled: !salesOrderIds || salesOrderIds.length < 1
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_label' })
	      );
	    }
	  }, {
	    key: 'yingPrintFile',
	    value: function yingPrintFile() {
	      var salesOrderIds = [];
	      var salesOrders = this.state.salesOrders;
	
	      if (salesOrders && salesOrders.selectedRows.length > 0) {
	        salesOrders.selectedRows.map(function (row) {
	          salesOrderIds.push(row.SalesOrder_id);
	        });
	        salesOrderIds = salesOrderIds.join(",");
	      }
	
	      _axios2.default.get(_url.YING_CUSTOMER_FILE + salesOrderIds + '/', {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        if (response.data && response.data[0]) {
	          window.open(response.data[0].url, '_blank');
	        }
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	      });
	    }
	  }, {
	    key: 'renderSubmitBolImageButton',
	    value: function renderSubmitBolImageButton() {
	      var _this30 = this;
	
	      var selectedRows = this.state.salesOrders.selectedRows;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'print-btn',
	          disabled: selectedRows.length !== 1,
	          type: 'button',
	          onClick: function onClick() {
	            _this30.openSubmitImage();
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-upload' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'upload_image' })
	      );
	    }
	  }, {
	    key: 'swShippingLabel',
	    value: function swShippingLabel() {
	      var _this31 = this;
	
	      var selectedRows = this.state.salesOrders.selectedRows;
	
	      var salesOrder_id = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'print-btn',
	          type: 'button',
	          disabled: selectedRows.length !== 1,
	          onClick: function onClick() {
	            _this31.props.printShippigLabel(salesOrder_id);
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_label' })
	      );
	    }
	  }, {
	    key: 'swResync',
	    value: function swResync() {
	      var _this32 = this;
	
	      var selectedRows = this.state.salesOrders.selectedRows;
	
	      var salesOrder_id = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'print-btn',
	          type: 'button',
	          disabled: selectedRows.length !== 1,
	          onClick: function onClick() {
	            _this32.resyncOrder(salesOrder_id);
	          }
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'resync' })
	      );
	    }
	  }, {
	    key: 'renderPrintLabelButton',
	    value: function renderPrintLabelButton() {
	      var _this33 = this;
	
	      var salesOrder_id = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'print-btn',
	          type: 'button'
	          // href={exportUrl}
	          , disabled: !(0, _permissions2.default)("print_sales_order"),
	          onClick: function onClick() {
	            _this33.props.printSalesOrderLabel(salesOrder_id);
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_label' })
	      );
	    }
	  }, {
	    key: 'renderPrintLabelButtonDSQ',
	    value: function renderPrintLabelButtonDSQ() {
	      var _this34 = this;
	
	      var salesOrder_id = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'print-btn',
	          type: 'button',
	          disabled: !(0, _permissions2.default)("print_sales_order") || this.state.salesOrders.selectedRows.length !== 1,
	          onClick: function onClick() {
	            _this34.openDSQPrint();
	            // this.props.printSalesOrderLabel(salesOrder_id);
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: isABCFF ? "shipping_label" : "print_label" })
	      );
	    }
	  }, {
	    key: 'renderPrintLabelButtonAFG',
	    value: function renderPrintLabelButtonAFG() {
	      var _this35 = this;
	
	      var SalesOrder_id = [];
	      var SalesOrder_trackingNum = [];
	      var hasInvoice = true;
	      var salesOrders = this.state.salesOrders;
	
	      if (salesOrders && salesOrders.selectedRows) {
	        salesOrders.selectedRows.map(function (r) {
	          if ((r.InvoiceNum === "" || !r.InvoiceNum) && isAFG === true) {
	            hasInvoice = false;
	          }
	          SalesOrder_id.push(r.SalesOrder_id);
	          if (r.TrackingNum) {
	            SalesOrder_trackingNum.push(r.TrackingNum);
	          }
	        });
	      }
	      this.state.trackingNumberSelected = SalesOrder_id;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          className: 'print-btn'
	          // href={exportUrl}
	          , disabled: hasInvoice === false || SalesOrder_id.length === 0 || !(0, _permissions2.default)("print_sales_order"),
	          onClick: function onClick() {
	            if (SalesOrder_trackingNum[0] && SalesOrder_trackingNum[0].length > 0 && (isAFG || isNBT || isKM)) {
	              _this35.openPrintTrackingConfirm();
	            } else {
	              _this35.props.printSalesOrderLabelBatch(SalesOrder_id);
	            }
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: isAPO ? "shipstation" : "print_label" })
	      );
	    }
	  }, {
	    key: 'renderUpdateNumberButton',
	    value: function renderUpdateNumberButton() {
	      var _this36 = this;
	
	      var selectedRows = this.state.salesOrders.selectedRows;
	
	      return _react2.default.createElement(
	        _reactBootstrap.DropdownButton,
	        {
	          bsStyle: 'primary',
	          title: _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('i', { className: 'fa fa-print' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'update_no' })
	          )
	        },
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            className: 'print-btn',
	            disabled: selectedRows.length !== 1,
	            type: 'button',
	            onClick: function onClick() {
	              _this36.setISAEditModalVisibility(true);
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'update_customer_bol' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            className: 'print-btn',
	            disabled: selectedRows.length !== 1,
	            type: 'button',
	            onClick: function onClick() {
	              _this36.setCTNEditModalVisibility(true);
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'update_ctn_no' })
	        )
	      );
	    }
	  }, {
	    key: 'renderExportButton',
	    value: function renderExportButton() {
	      var _this37 = this;
	
	      var qb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
	      var _state4 = this.state,
	          FromDate = _state4.FromDate,
	          ToDate = _state4.ToDate,
	          days = _state4.days;
	
	      var status = this.state.Status === "all" ? "" : '&SaleStatus=' + this.state.Status;
	      var dateRange = days || -1;
	
	      var _toFromDates2 = (0, _cleanDates.toFromDates)(dateRange, FromDate, ToDate),
	          fromDate = _toFromDates2.fromDate,
	          toDate = _toFromDates2.toDate;
	
	      var route = this.props.route.path;
	      var orderType = route === "salesOrders" ? "sales_order" : "sales_mobile_order";
	
	      var salesOrderIds = "";
	      var salesOrders = this.state.salesOrders;
	
	      if (salesOrders && salesOrders.selectedRows.length >= 1) {
	        salesOrders.selectedRows.map(function (row) {
	          salesOrderIds += row.SalesOrder_id + ',';
	        });
	      }
	      salesOrderIds = salesOrderIds.substring(0, salesOrderIds.length - 1);
	
	      var lalaIDS = [];
	      if (salesOrders && salesOrders.selectedRows.length > 0) {
	        salesOrders.selectedRows.map(function (row) {
	          lalaIDS.push(row.SalesOrder_id);
	        });
	      }
	
	      var exportUrl = _root_url.ROOT_URL + 'v1/sale/' + orderType + '/search/' + (!qb ? "export" : "export_for_quick_books") + '/?OrderDate__gte=' + fromDate + '&OrderDate__lte=' + toDate + status + '&Bearer=' + localStorage.getItem("token");
	
	      var exportUrl1 = _root_url.ROOT_URL + 'v1/sale/' + orderType + '/search/' + (!qb ? "export" : "export_for_quick_books") + '/' + salesOrderIds + '?Bearer=' + localStorage.getItem("token");
	
	      var exportUrl2 = _root_url.ROOT_URL + 'v1/sale/' + orderType + '/search/' + (!qb ? "export" : "export_for_quick_books");
	      if (isAmzey) {
	        return _react2.default.createElement(
	          _reactBootstrap.DropdownButton,
	          {
	            bsStyle: 'success',
	            disabled: !(0, _permissions2.default)("print_sales_order"),
	            title: _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	            ),
	            style: { marginLeft: '5px' }
	          },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'success',
	              type: 'button',
	              href: salesOrderIds === "" ? exportUrl : exportUrl1
	            },
	            _react2.default.createElement('em', { className: 'fa fa-download' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: "excel" })
	          )
	        );
	      }
	      if (!isATL) {
	        return _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            href: salesOrderIds === "" ? exportUrl : exportUrl1,
	            disabled: !(0, _permissions2.default)("print_sales_order")
	          },
	          _react2.default.createElement('em', { className: 'fa fa-download' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: qb ? "excel_qb" : "excel" })
	        );
	      } else {
	        return _react2.default.createElement(_SpinnerButton2.default, {
	          bsStyle: 'success',
	          type: 'button',
	          onClick: function onClick() {
	            // this.props.printPickingList(salesOrderIds.join(','));
	            _this37.openDownloadModal(lalaIDS, exportUrl2);
	          },
	          loading: this.state.openDownloadModalLoading
	          // href={salesOrderIds === "" ? exportUrl : exportUrl1}
	          , disabled: salesOrders.selectedRows.length < 1 || this.state.openDownloadModalLoading,
	          icon: 'fa-download',
	          translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: qb ? "excel_qb" : "excel" })
	        });
	      }
	    }
	  }, {
	    key: 'renderExportDetailButton',
	    value: function renderExportDetailButton() {
	      var _this38 = this;
	
	      var qb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
	      var _state5 = this.state,
	          FromDate = _state5.FromDate,
	          ToDate = _state5.ToDate,
	          days = _state5.days;
	
	      var status = this.state.Status === "all" ? "" : '&SaleStatus=' + this.state.Status;
	      var dateRange = days || -1;
	
	      var _toFromDates3 = (0, _cleanDates.toFromDates)(dateRange, FromDate, ToDate),
	          fromDate = _toFromDates3.fromDate,
	          toDate = _toFromDates3.toDate;
	
	      var route = this.props.route.path;
	      var orderType = route === "salesOrders" ? "sales_order" : "sales_mobile_order";
	
	      var salesOrderIds = "";
	      var salesOrders = this.state.salesOrders;
	
	      if (salesOrders && salesOrders.selectedRows.length >= 1) {
	        salesOrders.selectedRows.map(function (row) {
	          salesOrderIds += row.SalesOrder_id + ',';
	        });
	      }
	      salesOrderIds = salesOrderIds.substring(0, salesOrderIds.length - 1);
	
	      var lalaIDS = [];
	      if (salesOrders && salesOrders.selectedRows.length > 0) {
	        salesOrders.selectedRows.map(function (row) {
	          lalaIDS.push(row.SalesOrder_id);
	        });
	      }
	
	      var exportUrl = _root_url.ROOT_URL + 'v1/sale/' + orderType + '/search/' + (!qb ? "export" : "export_for_quick_books") + '/?OrderDate__gte=' + fromDate + '&OrderDate__lte=' + toDate + status + '&Bearer=' + localStorage.getItem("token");
	
	      var exportUrl1 = _root_url.ROOT_URL + 'v1/sale/' + orderType + '/search/' + (!qb ? "export" : "export_for_quick_books") + '/' + salesOrderIds + '?Bearer=' + localStorage.getItem("token");
	
	      var exportUrl2 = _root_url.ROOT_URL + 'v1/sale/' + orderType + '/search/orderdetailexport_new';
	
	      if (!isATL) {
	        return _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            href: salesOrderIds === "" ? exportUrl : exportUrl1,
	            disabled: !(0, _permissions2.default)("print_sales_order")
	          },
	          _react2.default.createElement('em', { className: 'fa fa-download' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: qb ? "excel_qb" : "excel" })
	        );
	      } else {
	        return _react2.default.createElement(_SpinnerButton2.default, {
	          bsStyle: 'success',
	          type: 'button',
	          onClick: function onClick() {
	            // this.props.printPickingList(salesOrderIds.join(','));
	            _this38.openDownloadModal2(lalaIDS, exportUrl2);
	          },
	          loading: this.state.openDownloadModalLoading
	          // href={salesOrderIds === "" ? exportUrl : exportUrl1}
	          , disabled: this.state.openDownloadModalLoading,
	          icon: 'fa-download',
	          translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_detail' })
	        });
	      }
	    }
	  }, {
	    key: 'renderExportSelectedButton',
	    value: function renderExportSelectedButton() {
	      var salesOrderIds = [];
	      var salesOrders = this.state.salesOrders;
	
	      if (salesOrders && salesOrders.selectedRows.length > 0) {
	        salesOrders.selectedRows.map(function (row) {
	          salesOrderIds.push(row.SalesOrder_id);
	        });
	      }
	
	      var exportUrl = _root_url.ROOT_URL + 'v2/so-line-export/' + salesOrderIds.join(",") + '?Bearer=' + localStorage.getItem("token");
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          href: exportUrl,
	          disabled: !salesOrderIds || salesOrderIds.length < 1
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'export_line_details' })
	      );
	    }
	  }, {
	    key: 'renderExportButtonATL',
	    value: function renderExportButtonATL() {
	      var _this39 = this;
	
	      var salesOrderIds = [];
	      var salesOrders = this.state.salesOrders;
	
	      if (salesOrders && salesOrders.selectedRows.length > 0) {
	        salesOrders.selectedRows.map(function (row) {
	          salesOrderIds.push(row.SalesOrder_id);
	        });
	      }
	
	      var exportUrl = _root_url.ROOT_URL + 'v1/sale/sales_mobile_order/search/shipmentexport/' + salesOrderIds.join(",") + '?Bearer=' + localStorage.getItem("token");
	      var exportUrl2 = _root_url.ROOT_URL + 'v1/sale/sales_mobile_order/search/shipmentexport';
	
	      if (!isATL) {
	        return _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            style: { marginBottom: '5px' },
	            href: exportUrl,
	            disabled: !salesOrderIds || salesOrderIds.length < 1
	          },
	          _react2.default.createElement('em', { className: 'fa fa-download' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipment_export' })
	        );
	      } else {
	        return _react2.default.createElement(_SpinnerButton2.default, {
	          bsStyle: 'success',
	          type: 'button',
	          style: { marginBottom: '5px' },
	          loading: this.state.openDownloadModalLoading,
	          onClick: function onClick() {
	            // this.props.printPickingList(salesOrderIds.join(','));
	            _this39.openDownloadModal(salesOrderIds, exportUrl2);
	          }
	          // href={exportUrl}
	          , disabled: !salesOrderIds || salesOrderIds.length < 1 || this.state.openDownloadModalLoading,
	          icon: 'fa-download',
	          translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipment_export' })
	        });
	      }
	    }
	  }, {
	    key: 'renderOrderExportButtonATL',
	    value: function renderOrderExportButtonATL() {
	      var _this40 = this;
	
	      var salesOrderIds = [];
	      var salesOrders = this.state.salesOrders;
	
	      if (salesOrders && salesOrders.selectedRows.length > 0) {
	        salesOrders.selectedRows.map(function (row) {
	          salesOrderIds.push(row.SalesOrder_id);
	        });
	      }
	
	      var exportUrl = _root_url.ROOT_URL + 'v1/sale/sales_mobile_order/search/orderdetailexport/' + salesOrderIds.join(",") + '?Bearer=' + localStorage.getItem("token");
	      var exportUrl2 = _root_url.ROOT_URL + 'v1/sale/sales_mobile_order/search/orderdetailexport';
	
	      if (!isATL) {
	        return _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            style: { marginBottom: '5px' },
	            href: exportUrl,
	            disabled: !salesOrderIds || salesOrderIds.length < 1
	          },
	          _react2.default.createElement('em', { className: 'fa fa-download' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_export' })
	        );
	      } else {
	        return _react2.default.createElement(
	          _SpinnerButton2.default,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            style: { marginBottom: '5px' }
	            // href={exportUrl}
	            , onClick: function onClick() {
	              // this.props.printPickingList(salesOrderIds.join(','));
	              _this40.openDownloadModal(salesOrderIds, exportUrl2);
	            },
	            loading: this.state.openDownloadModalLoading,
	            disabled: !salesOrderIds || salesOrderIds.length < 1 || this.state.openDownloadModalLoading,
	            icon: 'fa-download',
	            translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_export' })
	          },
	          _react2.default.createElement('em', { className: 'fa fa-download' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_export' })
	        );
	      }
	    }
	  }, {
	    key: 'dsqExcelTemplate',
	    value: function dsqExcelTemplate() {
	      var exportUrl = _root_url.ROOT_URL + 'v2/so-template?Bearer=' + localStorage.getItem("token");
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          href: exportUrl,
	          disabled: false
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ib_excel_template' })
	      );
	    }
	  }, {
	    key: 'abcffMsoTemplate',
	    value: function abcffMsoTemplate() {
	      var exportUrl = _root_url.ROOT_URL + 'v2/customer-so-template?Bearer=' + localStorage.getItem("token");
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          href: exportUrl,
	          disabled: false
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        'MSO Template'
	      );
	    }
	  }, {
	    key: 'dsqExcelTemplateOb',
	    value: function dsqExcelTemplateOb() {
	      var selectedRows = this.state.salesOrders.selectedRows;
	
	      var salesOrder_id = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	
	      var exportUrl = _root_url.ROOT_URL + 'v2/rebuild/prefilled-ob-template/' + salesOrder_id + '?Bearer=' + localStorage.getItem("token");
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          href: exportUrl,
	          disabled: this.state.salesOrders.selectedRows.length !== 1
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prefilled_ob_template' })
	      );
	    }
	  }, {
	    key: 'renderCalculateFees',
	    value: function renderCalculateFees() {
	      var _this41 = this;
	
	      var selectedRows = this.state.salesOrders.selectedRows;
	
	      var salesOrder_id = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	
	      // const exportUrl = `${ROOT_URL}v2/rebuild/prefilled-ob-template/${salesOrder_id}?Bearer=${localStorage.getItem("token")}`;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          className: 'print-btn',
	          onClick: function onClick() {
	            return _this41.calculateFees();
	          },
	          disabled: this.state.salesOrders.selectedRows.length !== 1
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'calculate_fees' })
	      );
	    }
	  }, {
	    key: 'calculateFees',
	    value: function calculateFees() {
	      var _this42 = this;
	
	      var selectedRows = this.state.salesOrders.selectedRows;
	
	      var salesOrder_id = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	
	      var data = null;
	      _axios2.default.post(_root_url.ROOT_URL + 'v1/sale/calculate-order-fees/' + salesOrder_id, data, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        alert("Fees Calculated.");
	        _this42.fetchSalesOrdersByDetails(_this42.state.days);
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data.message));
	      });
	    }
	  }, {
	    key: 'dsqOutboundTemplate',
	    value: function dsqOutboundTemplate() {
	      var exportUrl = _root_url.ROOT_URL + 'v2/ob-template?Bearer=' + localStorage.getItem("token");
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          href: exportUrl,
	          disabled: false
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        'OB Template'
	      );
	    }
	  }, {
	    key: 'magExcelTemplate',
	    value: function magExcelTemplate() {
	      var exportUrl = _root_url.ROOT_URL + 'v2/so-template?Bearer=' + localStorage.getItem("token");
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          href: exportUrl,
	          disabled: false
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel_template' })
	      );
	    }
	  }, {
	    key: 'jtbExcelTemplate',
	    value: function jtbExcelTemplate() {
	      var exportUrl = _root_url.ROOT_URL + 'v2/so-template?Bearer=' + localStorage.getItem("token");
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          href: exportUrl,
	          disabled: false
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ib_excel_template' })
	      );
	    }
	  }, {
	    key: 'wizExcelTemplate',
	    value: function wizExcelTemplate() {
	      var exportUrl = _root_url.ROOT_URL + 'v2/so-template?Bearer=' + localStorage.getItem("token");
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          href: exportUrl,
	          disabled: false
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ib_excel_template' })
	      );
	    }
	  }, {
	    key: 'bolList',
	    value: function bolList() {
	      var _this43 = this;
	
	      var selectedRows = this.state.salesOrders.selectedRows;
	
	      var salesOrder_id = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          onClick: function onClick() {
	            _this43.openbolListModal();
	          },
	          disabled: false
	        },
	        _react2.default.createElement('em', { className: 'fa fa-list' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bol_list' })
	      );
	    }
	  }, {
	    key: 'generateBOL',
	    value: function generateBOL() {
	      var _this44 = this;
	
	      var selectedRows = this.state.salesOrders.selectedRows;
	
	      var salesOrder_id = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          onClick: function onClick() {
	            _this44.openGenerateBOLModal();
	          },
	          disabled: selectedRows.length < 1
	        },
	        _react2.default.createElement('em', { className: 'fa fa-plus' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bol' })
	      );
	    }
	  }, {
	    key: 'fjExcelTemplate',
	    value: function fjExcelTemplate() {
	      var exportUrl = _root_url.ROOT_URL + 'v2/so-template?Bearer=' + localStorage.getItem("token");
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          href: exportUrl,
	          disabled: false
	        },
	        _react2.default.createElement('em', { className: 'fa fa-download' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ib_excel_template' })
	      );
	    }
	  }, {
	    key: 'renderCreateTaskButton',
	    value: function renderCreateTaskButton() {
	      var _this45 = this;
	
	      var selectedRows = this.state.salesOrders.selectedRows;
	
	      var salesOrder_id = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          disabled: this.context.router.routes[1].path !== "mobileSalesOrders" || selectedRows.length !== 1,
	          onClick: function onClick() {
	            _this45.props.createMobileTask(salesOrder_id);
	          }
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'on_fleet' })
	      );
	    }
	  }, {
	    key: 'renderChangeWeightButton',
	    value: function renderChangeWeightButton() {
	      var _this46 = this;
	
	      var selectedRows = this.state.salesOrders.selectedRows;
	
	      var salesOrder_id = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          disabled: this.context.router.routes[1].path !== "mobileSalesOrders" || selectedRows.length !== 1,
	          onClick: function onClick() {
	            _this46.openChangeWeight();
	          }
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'change_weight_button' })
	      );
	    }
	  }, {
	    key: 'renderAddTracking',
	    value: function renderAddTracking() {
	      var _this47 = this;
	
	      var selectedRows = this.state.salesOrders.selectedRows;
	
	      var salesOrder_id = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      var val = null;
	      var dep = null;
	      if (selectedRows && selectedRows.length === 1) {
	        val = selectedRows[0].TrackingNum;
	        dep = selectedRows[0];
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          disabled:
	          // this.context.router.routes[1].path !== "mobileSalesOrders" ||
	          selectedRows && selectedRows.length !== 1,
	          onClick: function onClick() {
	            // this.openAddTracking();
	            _this47.openChangeTracking(val, dep);
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-plus' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tracking' })
	      );
	    }
	  }, {
	    key: 'renderChowbusImportButton',
	    value: function renderChowbusImportButton() {
	      var _this48 = this;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          onClick: function onClick() {
	            _this48.openChowbusModal();
	          }
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'chowbus' })
	      );
	    }
	  }, {
	    key: 'renderPaymentMethodChangeButton',
	    value: function renderPaymentMethodChangeButton() {
	      var _this49 = this;
	
	      var selectedRows = this.state.salesOrders.selectedRows;
	
	      var salesOrder_id = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          disabled: this.context.router.routes[1].path !== "mobileSalesOrders" || selectedRows.length !== 1,
	          onClick: function onClick() {
	            // this.openChangeWeight();
	            _this49.openChangePaymentMethodModal();
	          }
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'change_payment_method' })
	      );
	    }
	  }, {
	    key: 'renderEmailPackingButton',
	    value: function renderEmailPackingButton() {
	      var _this50 = this;
	
	      var selectedRows = this.state.salesOrders.selectedRows;
	
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          disabled: selectedRows.length < 1,
	          onClick: function onClick() {
	            var salesOrder_id = [];
	            selectedRows.forEach(function (_ref67) {
	              var SalesOrder_id = _ref67.SalesOrder_id;
	
	              salesOrder_id.push(SalesOrder_id);
	            });
	            var ids = salesOrder_id.join(',');
	            _this50.props.sendPacking(ids);
	          }
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email_packing' })
	      );
	    }
	  }, {
	    key: 'renderReshipButton',
	    value: function renderReshipButton() {
	      var _this51 = this;
	
	      var selectedRows = this.state.salesOrders.selectedRows;
	
	      var salesOrder_id = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      var hasInvoice = true;
	      if (selectedRows[0] && (!selectedRows[0].InvoiceNum || selectedRows[0].InvoiceNum === "")) {
	        hasInvoice = false;
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          disabled: hasInvoice === false || this.context.router.routes[1].path !== "mobileSalesOrders" || selectedRows.length !== 1,
	          onClick: function onClick() {
	            _this51.openConfirmReship();
	          }
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reship' })
	      );
	    }
	  }, {
	    key: 'renderQuoteButton',
	    value: function renderQuoteButton() {
	      var _this52 = this;
	
	      var selectedRows = this.state.salesOrders.selectedRows;
	
	      var onlyQuote = true;
	      selectedRows.map(function (r) {
	        if (r.SaleStatus !== "Quote") {
	          onlyQuote = false;
	        }
	      });
	
	      if (isABCFF) {
	        return _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success',
	            type: 'button',
	            disabled: !onlyQuote,
	            onClick: function onClick() {
	              _this52.quoteConversion();
	            }
	          },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'set_order' })
	        );
	      }
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          disabled: !onlyQuote || this.context.router.routes[1].path !== "salesOrders" || selectedRows.length !== 1,
	          onClick: function onClick() {
	            _this52.openConfirmQuote();
	          }
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'set_order' })
	      );
	    }
	  }, {
	    key: 'postPickupButton',
	    value: function postPickupButton() {
	      var _this53 = this;
	
	      var selectedRows = this.state.salesOrders.selectedRows;
	      // let onlyQuote = true;
	      // selectedRows.map((r) => {
	      //   if (r.SaleStatus !== "Quote") {
	      //     onlyQuote = false;
	      //   }
	      // });
	
	      return _react2.default.createElement(_SpinnerButton2.default, {
	        bsStyle: 'success',
	        type: 'button',
	        className: 'print-btn',
	        loading: this.state.xpoLoading,
	        disabled:
	        // this.context.router.routes[1].path !== "salesOrders" ||
	        selectedRows.length !== 1,
	        onClick: function onClick() {
	          // this.confirmPostPickup();
	          _this53.openPickupSelectionModal();
	        },
	        translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_pickup' })
	
	      });
	    }
	  }, {
	    key: 'postQuoteButton',
	    value: function postQuoteButton() {
	      var _this54 = this;
	
	      var selectedRows = this.state.salesOrders.selectedRows;
	      // let onlyQuote = true;
	      // selectedRows.map((r) => {
	      //   if (r.SaleStatus !== "Quote") {
	      //     onlyQuote = false;
	      //   }
	      // });
	
	      return _react2.default.createElement(_SpinnerButton2.default, {
	        bsStyle: 'success',
	        type: 'button',
	        className: 'print-btn',
	        loading: this.state.xpoLoading,
	        disabled:
	        // this.context.router.routes[1].path !== "salesOrders" ||
	        selectedRows.length !== 1,
	        onClick: function onClick() {
	          _this54.confirmPostQuote();
	        },
	        translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_quote' })
	      });
	    }
	  }, {
	    key: 'getQuoteButton',
	    value: function getQuoteButton() {
	      var _this55 = this;
	
	      var selectedRows = this.state.salesOrders.selectedRows;
	      // let onlyQuote = true;
	      // selectedRows.map((r) => {
	      //   if (r.SaleStatus !== "Quote") {
	      //     onlyQuote = false;
	      //   }
	      // });
	
	      return _react2.default.createElement(_SpinnerButton2.default, {
	        bsStyle: 'success',
	        type: 'button',
	        className: 'print-btn',
	        loading: this.state.xpoLoading,
	        disabled:
	        // this.context.router.routes[1].path !== "salesOrders" ||
	        selectedRows.length !== 1,
	        onClick: function onClick() {
	          _this55.confirmGetQuote();
	        },
	        translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'get_quote' })
	      });
	    }
	  }, {
	    key: 'getPickupButton',
	    value: function getPickupButton() {
	      var _this56 = this;
	
	      var selectedRows = this.state.salesOrders.selectedRows;
	      // let onlyQuote = true;
	      // selectedRows.map((r) => {
	      //   if (r.SaleStatus !== "Quote") {
	      //     onlyQuote = false;
	      //   }
	      // });
	
	      return _react2.default.createElement(_SpinnerButton2.default, {
	        bsStyle: 'success',
	        type: 'button',
	        className: 'print-btn',
	        loading: this.state.xpoLoading,
	        disabled:
	        // this.context.router.routes[1].path !== "salesOrders" ||
	        selectedRows.length !== 1,
	        onClick: function onClick() {
	          _this56.confirmGetPickup();
	        },
	        translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'get_pickup' })
	
	      });
	    }
	  }, {
	    key: 'createBOLButton',
	    value: function createBOLButton() {
	      var _this57 = this;
	
	      var selectedRows = this.state.salesOrders.selectedRows;
	      // let onlyQuote = true;
	      // selectedRows.map((r) => {
	      //   if (r.SaleStatus !== "Quote") {
	      //     onlyQuote = false;
	      //   }
	      // });
	
	      return _react2.default.createElement(_SpinnerButton2.default, {
	        bsStyle: 'success',
	        type: 'button',
	        className: 'print-btn',
	        loading: this.state.xpoLoading,
	        disabled:
	        // this.context.router.routes[1].path !== "salesOrders" ||
	        selectedRows.length !== 1,
	        onClick: function onClick() {
	          _this57.confirmCreateBOL();
	        },
	        translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_bol' })
	
	      });
	    }
	  }, {
	    key: 'renderEmailUpdateButton',
	    value: function renderEmailUpdateButton() {
	      var _this58 = this;
	
	      var salesOrders = this.state.salesOrders;
	
	      var salesOrderIds = [];
	
	      if (salesOrders && salesOrders.selectedRows.length > 0) {
	        salesOrders.selectedRows.map(function (row) {
	          salesOrderIds.push(row.SalesOrder_id);
	        });
	      }
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          disabled: salesOrderIds.length < 1,
	          onClick: function onClick() {
	            _this58.sendEmailUpdate(salesOrderIds);
	          }
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email_update' })
	      );
	    }
	  }, {
	    key: 'renderEmailPodButton',
	    value: function renderEmailPodButton() {
	      var _this59 = this;
	
	      var salesOrders = this.state.salesOrders;
	
	      var salesOrderIds = [];
	
	      if (salesOrders && salesOrders.selectedRows.length > 0) {
	        salesOrders.selectedRows.map(function (row) {
	          salesOrderIds.push(row.SalesOrder_id);
	        });
	      }
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          disabled: salesOrderIds.length < 1,
	          onClick: function onClick() {
	            _this59.sendEmailPod(salesOrderIds);
	          }
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email_pod' })
	      );
	    }
	  }, {
	    key: 'renderCompleteOutboundButton',
	    value: function renderCompleteOutboundButton() {
	      var _this60 = this;
	
	      var salesOrders = this.state.salesOrders;
	
	      var salesOrderIds = [];
	
	      if (salesOrders && salesOrders.selectedRows.length > 0) {
	        salesOrders.selectedRows.map(function (row) {
	          salesOrderIds.push(row.SalesOrder_id);
	        });
	      }
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          disabled: salesOrderIds.length < 1,
	          onClick: function onClick() {
	            _this60.completeOB(salesOrderIds);
	          }
	        },
	        'Complete OB'
	      );
	    }
	  }, {
	    key: 'renderDavisPO',
	    value: function renderDavisPO() {
	      var _this61 = this;
	
	      var selectedRows = this.state.salesOrders.selectedRows;
	
	      var onlyOpen = true;
	      // selectedRows.map(r=> {
	      //   if (r.SaleStatus !== 'Open') {
	      //     onlyOpen = false;
	      //   }
	      // });
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          type: 'button',
	          disabled: !onlyOpen || selectedRows.length !== 1,
	          onClick: function onClick() {
	            _this61.openDavisPO();
	          }
	        },
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'davis_po' })
	      );
	    }
	  }, {
	    key: 'renderDriverImageButton',
	    value: function renderDriverImageButton() {
	      var _this62 = this;
	
	      var selectedRows = this.state.salesOrders.selectedRows;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'success',
	          className: 'print-btn',
	          disabled: selectedRows.length !== 1,
	          type: 'button',
	          onClick: function onClick() {
	            _this62.openShowDriverImage();
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'show_image' })
	      );
	    }
	  }, {
	    key: 'outboundStatusButton',
	    value: function outboundStatusButton() {
	      var _this63 = this;
	
	      // const salesOrder_id =
	      //   this.state.salesOrders.selectedRows.length === 1 &&
	      //   this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      var salesOrders = this.state.salesOrders;
	
	      var salesOrderIds = [];
	
	      if (salesOrders && salesOrders.selectedRows.length > 0) {
	        salesOrders.selectedRows.map(function (row) {
	          salesOrderIds.push(row.SalesOrder_id);
	        });
	      }
	
	      return _react2.default.createElement(
	        _reactBootstrap.DropdownButton,
	        {
	          bsStyle: 'primary',
	          disabled: salesOrderIds.length < 1,
	          title: _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ob_status' })
	          )
	        },
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            className: 'print-btn',
	            disabled: salesOrderIds.length < 1,
	            type: 'button',
	            onClick: function onClick() {
	              _this63.changeOutboundStatus(salesOrderIds, 'preparing');
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-edit' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'preparing' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            className: 'print-btn',
	            disabled: salesOrderIds.length < 1,
	            type: 'button',
	            onClick: function onClick() {
	              _this63.changeOutboundStatus(salesOrderIds, 'ready_to_ship');
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-edit' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ready_to_ship' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            className: 'print-btn',
	            disabled: salesOrderIds.length < 1,
	            type: 'button',
	            onClick: function onClick() {
	              _this63.changeOutboundStatus(salesOrderIds, 'en_route');
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-edit' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'en_route' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            className: 'print-btn',
	            disabled: salesOrderIds.length < 1,
	            type: 'button',
	            onClick: function onClick() {
	              _this63.changeOutboundStatus(salesOrderIds, 'delivered');
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-edit' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delivered' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            className: 'print-btn',
	            disabled: salesOrderIds.length < 1,
	            type: 'button',
	            onClick: function onClick() {
	              _this63.changeOutboundStatus(salesOrderIds, 'trouble');
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-edit' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'trouble' })
	        )
	      );
	    }
	  }, {
	    key: 'renderTNOriginal',
	    value: function renderTNOriginal() {
	      var _this64 = this;
	
	      return _react2.default.createElement(
	        _reactBootstrap.DropdownButton,
	        {
	          bsStyle: 'success',
	          type: 'submit',
	          title: _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('em', { className: 'fa fa-plus' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel_create' })
	          )
	        },
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success'
	            // className="print-btn"
	            // type="button"
	            , onClick: function onClick() {
	              _this64.refs.msoCreateInputRef.click();
	            },
	            disabled: !(0, _permissions2.default)("add_sales_order")
	          },
	          'Excel (New)'
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'success'
	            // className="print-btn"
	            // type="button"
	            , onClick: function onClick() {
	              _this64.refs.msoCreateInputRefOriginal.click();
	            },
	            disabled: !(0, _permissions2.default)("add_sales_order")
	          },
	          'Excel (Original)'
	        )
	      );
	    }
	  }, {
	    key: 'renderPrintBolButton',
	    value: function renderPrintBolButton() {
	      var _this65 = this;
	
	      var salesOrder_id = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      return _react2.default.createElement(
	        _reactBootstrap.DropdownButton,
	        {
	          bsStyle: 'primary',
	          title: _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('i', { className: 'fa fa-print' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: ' print_bol' })
	          )
	        },
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            className: 'print-btn',
	            disabled: !salesOrder_id,
	            type: 'button',
	            onClick: function onClick() {
	              _this65.props.printBolById(salesOrder_id);
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-print' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_bol_by_id' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            className: 'print-btn',
	            disabled: !salesOrder_id,
	            type: 'button',
	            onClick: function onClick() {
	              _this65.openPrintBol();
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-print' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_bol_by_address' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            className: 'print-btn',
	            disabled: !salesOrder_id,
	            type: 'button',
	            onClick: function onClick() {
	              _this65.props.printBolWithoutLog(salesOrder_id);
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-print' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_bol_without_log' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            className: 'print-btn',
	            disabled: !salesOrder_id,
	            type: 'button',
	            onClick: function onClick() {
	              _this65.props.printBolLabel(salesOrder_id);
	            }
	          },
	          _react2.default.createElement('em', { className: 'fa fa-print' }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_bol_label' })
	        )
	      );
	    }
	  }, {
	    key: 'renderDriverImage',
	    value: function renderDriverImage() {
	      var imageFile = "/img/dummy.png";
	      if (this.state.salesOrders.selectedRows[0]) {
	        imageFile = this.state.salesOrders.selectedRows[0].OrderImage;
	      }
	      return _react2.default.createElement(
	        'div',
	        { style: { position: "relative" } },
	        _react2.default.createElement('img', {
	          style: { width: "200px", height: "200px" },
	          src: imageFile,
	          onClick: function onClick() {
	            return window.open(imageFile, "_blank");
	          }
	        })
	      );
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(row, files) {
	      var _this66 = this;
	
	      if (!files) {
	        return;
	      }
	      var reader = new FileReader();
	      reader.onload = function () {
	        var index = row.props.rowIdx;
	        var newRows = _this66.state.salesOrders.selectedRows;
	        newRows[index].BolImageUrl = reader.result;
	        _this66.setState({ rows: newRows, file: files[0] });
	      };
	      // get the first file and convert to blob object (Blob.slice([start [, end [, contentType]]))
	      var blob = files[0].slice(0, files[0].size, files[0].type);
	      reader.readAsDataURL(blob);
	    }
	  }, {
	    key: 'renderAutoSuggest',
	    value: function renderAutoSuggest() {
	      var _this67 = this;
	
	      if (!this.state.filteredByItem) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'control-dropdown' },
	          _react2.default.createElement(_GenericProductSuggest2.default, {
	            value: this.state.suggestValue,
	            onChange: function onChange(e, _ref68) {
	              var newValue = _ref68.newValue;
	
	              _this67.setState({ suggestValue: newValue });
	            },
	            SearchType: this.state.searchType,
	            fetchOrdersByProduct: this.fetchSalesOrdersByProduct
	          })
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { id: 'suggestion-box' },
	        this.state.suggestValue,
	        _react2.default.createElement('em', {
	          className: 'fa fa-times pull-right',
	          onClick: function onClick() {
	            _this67.setState({
	              filteredByItem: false,
	              suggestValue: "",
	              filterProductID: null
	            }, function () {
	              _this67.fetchSalesOrdersByDetails(_this67.state.days);
	            });
	          }
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this68 = this;
	
	      // const handleFilterChangePage = (event) => {
	      //   // this.setState({currentPage: 0});
	      //   this.state.currentPage = 0;
	      //   let salesOrders = {
	      //     ...this.state.salesOrders,
	      //     selectedRows: [],
	      //   };
	      //   this.setState({ salesOrders });
	      //   const route = this.context.router.routes[1].path;
	
	      //   let keys = Object.keys(this.state.searchFilter);
	      //   for (let i = 0; i < keys.length; i++) {
	      //     if (event.target.name === keys[i]) {
	      //       this.state.searchFilter[keys[i]] = event.target.value;
	      //     }
	      //   }
	
	      //   this.props.fetchSalesOrdersByFilter(
	      //     this.state.FromDate,
	      //     this.state.ToDate,
	      //     this.state.days,
	      //     this.state.Status,
	      //     null,
	      //     null,
	      //     route,
	      //     this.state.dispatchDateLT,
	      //     this.state.dispatchDateGT,
	      //     null,
	      //     this.state.limit,
	      //     this.state.currentPage,
	      //     this.state.searchFilter,
	      //   );
	      //   // this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
	      // }
	
	      var handleFilterChangePage = (0, _lodash.debounce)(function (event) {
	        // this.setState({currentPage: 0});
	        _this68.state.currentPage = 0;
	        var salesOrders = _extends({}, _this68.state.salesOrders, {
	          selectedRows: []
	        });
	        _this68.setState({ salesOrders: salesOrders });
	        var route = _this68.context.router.routes[1].path;
	
	        var keys = Object.keys(_this68.state.searchFilter);
	        for (var i = 0; i < keys.length; i++) {
	          if (event.name === keys[i]) {
	            _this68.state.searchFilter[keys[i]] = event.value;
	          }
	        }
	
	        _this68.props.fetchSalesOrdersByFilter(_this68.state.FromDate, _this68.state.ToDate, _this68.state.days, _this68.state.Status, null, null, route, _this68.state.dispatchDateLT, _this68.state.dispatchDateGT, null, _this68.state.limit, _this68.state.currentPage, _this68.state.searchFilter, _this68.props.Warehouse_id);
	        // this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
	      }, 200, { maxWait: 300 });
	
	      var singleSalesOrderId = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	
	      var singleSalesOrderNum = this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SONum;
	
	      var multiSalesOrderId = [];
	      var multiSalesOrderNum = [];
	      var salesOrderIdString = "";
	      var salesOrderNumString = "";
	      if (this.state.salesOrders && this.state.salesOrders.selectedRows.length >= 1) {
	        this.state.salesOrders.selectedRows.map(function (row) {
	          multiSalesOrderId.push(row.SalesOrder_id);
	          multiSalesOrderNum.push(row.SONum);
	        });
	        salesOrderIdString = multiSalesOrderId.join(",");
	        salesOrderNumString = multiSalesOrderNum.join(",");
	      }
	
	      // let dsqTempOrder = [];
	      // if (this.state.salesOrders && this.state.salesOrders.selectedRows) {
	      //   dsqTempOrder = this.state.salesOrders.selectedRows[0];
	      // }
	
	      var DriverListModalStyle = {
	        width: "550px",
	        height: "200px",
	        marginLeft: "-15%"
	      };
	      var createDialogStyle = {
	        width: "550px",
	        height: "300px",
	        marginLeft: "-15%"
	      };
	      var dlMODAL = {
	        width: "550px",
	        height: "300px",
	        marginLeft: "-15%"
	      };
	      var xpoMODAL = {
	        width: "1000px",
	        height: "500px",
	        marginLeft: "-25%",
	        marginTop: "-310px"
	      };
	      var pickupMODAL = {
	        width: "700px",
	        height: "620px",
	        marginLeft: "-15%",
	        marginTop: "-310px"
	      };
	      var pickupSelectionMODAL = {
	        width: "350px",
	        height: "320px",
	        marginLeft: "-5%",
	        marginTop: "-200px"
	      };
	      var bolImageDialogue = {
	        width: "700px",
	        height: "600px",
	        marginLeft: "-15%"
	      };
	      var createWeightDialogStyle = {
	        width: "600px",
	        height: "360px",
	        marginLeft: "-10%"
	      };
	      var altonChildDialogStyle = {
	        width: "600px",
	        height: "450px",
	        marginLeft: "-10%"
	      };
	      var bolListDialogStyle = {
	        width: "1050px",
	        height: "635px",
	        marginLeft: "-27%",
	        marginTop: "-310px"
	      };
	      var generateBOLStyle = {
	        width: '500px',
	        height: '515px',
	        marginLeft: '-10%'
	      };
	      var dsqPrintDialogStyle = {
	        width: "1050px",
	        height: "550px",
	        marginLeft: "-27%",
	        marginTop: "-310px"
	      };
	      var wizPODDialogStyle = {
	        width: "690px",
	        height: "550px",
	        marginLeft: "-10%",
	        marginTop: "-310px"
	      };
	      var createTrackingDialogStyle = {
	        width: "700px",
	        height: "290px",
	        marginLeft: "-10%"
	      };
	      var changeTrackingDialogStyle = {
	        width: "500px",
	        height: "200px",
	        marginLeft: "-10%"
	      };
	      var changeShipDateDialogue = {
	        width: "450px",
	        height: "200px",
	        marginLeft: "-10%"
	      };
	      var changeBOLDialogStyle = {
	        width: "500px",
	        height: "300px",
	        marginLeft: "-10%"
	      };
	      var createPullSheetDialogStyle = {
	        width: "500px",
	        height: "300px",
	        marginLeft: "-10%"
	      };
	      var voidNoteDialogStyle = {
	        width: "550px",
	        height: "330px",
	        marginLeft: "-10%"
	      };
	      var chowbusDialogStyle = {
	        width: "500px",
	        height: "300px",
	        marginLeft: "-10%"
	      };
	      var voidReasonSelection = [{
	        value: "Items Out of Stock",
	        label: "Items Out of Stock"
	      }, {
	        value: "Customer Request",
	        label: "Customer Request"
	      }, {
	        value: "Items Damaged",
	        label: "Items Damaged"
	      }, {
	        value: "Duplicated Order",
	        label: "Duplicated Order"
	      }, {
	        value: "Invalid Shipping Address",
	        label: "Invalid Shipping Address"
	      }, {
	        value: "Other",
	        label: "Other"
	      }];
	      var USPridePlatformOptions = [{ label: '123 Store', value: '123store' }, { label: 'Amazon', value: 'amazon' }, { label: 'TikTok', value: 'tiktok' }, { label: 'Gigacloud', value: 'gigacloud' }, { label: 'shein', value: 'shein' }, { label: 'Home Depot', value: 'homedepot' },
	      // {label: 'Houzz', value: 'houzz',},
	      { label: 'Overstock', value: 'overstock' }, { label: 'Walmart', value: 'walmart' }, { label: 'Wayfair', value: 'wayfair' }, { label: 'Cymax', value: 'cymax' }, { label: 'BBB', value: 'bbb' }];
	      if (isABCFF) {
	        USPridePlatformOptions = [
	        // {label: 'Other', value: 'other',},
	        { label: 'SILB2C', value: 'SILB2C' }, { label: 'Amazon', value: 'amazon' }, { label: 'Home Depot', value: 'homedepot' }, { label: 'Costco', value: 'costco' }, { label: 'Overstock', value: 'overstock' }, { label: 'Walmart', value: 'walmart' }, { label: 'Wayfair', value: 'wayfair' }, { label: 'Cymax', value: 'cymax' }, { label: 'BBB', value: 'bbb' }];
	      }
	      if (isATL) {
	        USPridePlatformOptions = [
	        // {label: 'Amazon Seller', value: 'amazon_seller',},
	        { label: 'Amazon Seller Mulhouse', value: 'amazon_seller_mulhouse' }, { label: 'Amazon Seller Rosevera', value: 'amazon_seller_rosevera' }, { label: 'Amazon Rosevera', value: 'amazon_rosevera' }, { label: 'Home Depot', value: 'homedepot' },
	        // {label: 'Houzz', value: 'houzz',},
	        { label: 'Houzz Mulhouse', value: 'houzz_mulhouse' }, { label: 'Houzz Rosevera', value: 'houzz_resevera' }, { label: 'Overstock', value: 'overstock' }, { label: 'Walmart', value: 'walmart' }, { label: 'Wayfair', value: 'wayfair' }, { label: 'Cymax', value: 'cymax' }, { label: 'Hayneedle', value: 'hayneedle' }];
	      }
	      var USPridePlatform = this.state.USPridePlatform;
	      var USPrideCustomer = this.state.USPrideCustomer;
	
	      var changeWeight = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'change_ship_weight' });
	      var changePaymentMethod = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_method_change' });
	      var altonChildTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'child_sku' });
	      var displayTrackingTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'split_tracking_numbers' });
	      var displayTrackingTitle2 = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tracking_nums' });
	      var changePullSheet = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pull_sheet_format' });
	      var reshipTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reship' });
	      var quoteTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'set_order' });
	      var davisPOTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_to_po' });
	      var pridePrintTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pride_print' });
	      var dlTITLE = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'file_ready' });
	      var showImageTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'show_image' });
	      var submitImageTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit_image' });
	      var printBolTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_bol' });
	      var voidNoteTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'void_note' });
	      var chowbusImportTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'chowbus_import' });
	      var salesOrder_id = this.state.salesOrders && this.state.salesOrders.selectedRows[0] && this.state.salesOrders.selectedRows[0].SalesOrder_id;
	      salesOrder_id = salesOrder_id || "";
	      var height = (this.state.tableHeight / 3 * 2 + 70).toString();
	      var tableCollapseFix = { height: height };
	      var detailsTableHeight = (this.state.tableHeight / 2.5 + 45).toString();
	      var detailsTableCollapseFix = { height: detailsTableHeight };
	      var listPurchasers = [{ value: "", label: "" }];
	      var inputFieldKey = Math.random();
	
	      var handleDrayageChange = function handleDrayageChange(el) {
	        var drayageSelected = el.value;
	        var drayageListDisplay = el.label;
	
	        _this68.setState({ drayageSelected: drayageSelected, drayageListDisplay: drayageListDisplay });
	      };
	
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: this.state.breadcrumbTitle })
	            )
	          ),
	          " ",
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'sales-orders-list', style: isABC ? { width: '100%' } : {} },
	            (!isABC || this.state.abcDatePickerShow === true) && _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { id: 'date-range-picker', className: 'form-horizontal' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'filter-title' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_status' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'colon' },
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 10 },
	                      _react2.default.createElement(
	                        'div',
	                        { id: 'statusFilterRadios', className: 'form-horizontal' },
	                        (0, _genericRadioFilter2.default)({
	                          content: [{
	                            option: "all",
	                            id: "all-radio-filter",
	                            name: "statusFilterRadios",
	                            labelName: "all"
	                          }, {
	                            option: "open",
	                            id: "open-radio-filter",
	                            name: "statusFilterRadios",
	                            labelName: "open"
	                          }, {
	                            option: "packing",
	                            id: "packing-radio-filter",
	                            name: "statusFilterRadios",
	                            labelName: "packing"
	                          }].concat(_toConsumableArray(isTN ? [{
	                            option: "ready",
	                            id: "ready-radio-filter",
	                            name: "statusFilterRadios",
	                            labelName: "ready"
	                          }] : []), [{
	                            option: "Released",
	                            id: "released-radio-filter",
	                            name: "statusFilterRadios",
	                            labelName: "released"
	                          }, {
	                            option: "Canceled",
	                            id: "canceled-radio-filter",
	                            name: "statusFilterRadios",
	                            labelName: "canceled"
	                          }], _toConsumableArray(!isTN ? [{
	                            option: "Quote",
	                            id: "quote-radio-filter",
	                            name: "statusFilterRadios",
	                            labelName: "quote"
	                          }] : [])),
	                          value: this.state.Status,
	                          handleOnClick: this.handleStatusFilterChange,
	                          type: "buttons"
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'filter-title' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_date' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'colon' },
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 10 },
	                      (0, _dateFilterRadios2.default)({
	                        handleOnClick: this.fetchSalesOrdersByDetails,
	                        setFromDate: this.setFromDate,
	                        setToDate: this.setToDate,
	                        setToRangeSearch: this.setToRangeSearch,
	                        FromDate: this.state.FromDate,
	                        ToDate: this.state.ToDate,
	                        Days: this.state.days
	                      })
	                    )
	                  ),
	                  (isCalco || isATL || isUSPride) && _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 2 },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'filter-title' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: isATL || isUSPride ? "import_date" : "order_delivered" }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'colon' },
	                          ':'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 10 },
	                      (0, _dispatchFilterRadios2.default)({
	                        handleOnClick: this.fetchSalesOrdersByDispatch,
	                        setFromDate: this.setFromDispatchDate,
	                        setToDate: this.setToDispatchDate,
	                        setToRangeSearch: this.setToDispatchRangeSearch,
	                        FromDate: this.state.dispatchDateLT,
	                        ToDate: this.state.dispatchDateGT,
	                        Days: this.state.dispatchDays
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            " ",
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  {
	                    className: 'position-relative table-collapse-fix',
	                    id: isTN || isUSPride || isATL || isRS || isDSQ || isWUFS || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB ? "table-collapse-fix-450" : isABC && "table-collapse-fix-940",
	                    style: { marginBottom: isABC ? '80px' : '0px' }
	                  },
	                  _react2.default.createElement(
	                    'div',
	                    { style: { position: "relative" } },
	                    _react2.default.createElement(
	                      _reactBootstrap.ButtonToolbar,
	                      { className: 'table-buttons' },
	                      !isABCFF && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: 'success',
	                          type: 'submit',
	                          onClick: function onClick(event) {
	                            _this68.clickNew(event);
	                          },
	                          disabled: this.context.router.routes[1].path === "mobileSalesOrders" || !(0, _permissions2.default)("add_sales_order")
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	                      ),
	                      (isUSPride || isATL || isRS || isABCFF && this.context.router.routes[1].path === "mobileSalesOrders") && !this.state.USPrideCreateLoading && _react2.default.createElement(
	                        'div',
	                        { style: { marginLeft: '89px' } },
	                        _react2.default.createElement(
	                          _reactBootstrap.Button,
	                          {
	                            bsStyle: 'success',
	                            type: 'submit',
	                            onClick: function onClick() {
	                              _this68.openUSPrideCreate();
	                            },
	                            disabled: !(0, _permissions2.default)("add_sales_order")
	                          },
	                          _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel_create' })
	                        )
	                      ),
	                      (isUSPride || isATL || isRS || isABCFF && this.context.router.routes[1].path === "mobileSalesOrders") && this.state.USPrideCreateLoading && _react2.default.createElement(
	                        'div',
	                        { style: { marginLeft: '89px' } },
	                        _react2.default.createElement(_SpinnerButton2.default, {
	                          bsStyle: 'success',
	                          disabled: true,
	                          icon: 'fa-plus',
	                          translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'creating_orders' }),
	                          loading: true,
	                          onClick: function onClick() {
	                            console.log('loading');
	                          }
	                        })
	                      ),
	                      (isDSQ || isWUFS || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB || isMAG) && this.context.router.routes[1].path === "salesOrders" && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: 'success',
	                          type: 'submit',
	                          onClick: function onClick() {
	                            _this68.refs.msoCreateInputRef2.click();
	                          }
	                          // disabled={!checkPermission("add_sales_order")}
	                          , disabled: false
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inbound_with_excel' })
	                      ),
	                      isEZone && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: 'success',
	                          type: 'submit',
	                          onClick: function onClick() {
	                            _this68.refs.msoCreateInputRef2.click();
	                          }
	                          // disabled={!checkPermission("add_sales_order")}
	                          , disabled: false
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel_creat' })
	                      ),
	                      (isDSQ || isWUFS || isKDW || isYI || isFBD) && this.context.router.routes[1].path === "outboundOrders" && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: 'success',
	                          type: 'submit',
	                          onClick: function onClick() {
	                            _this68.refs.msoCreateInputRef3.click();
	                          }
	                          // disabled={!checkPermission("add_sales_order")}
	                          , disabled: false
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'outbound_with_excel' })
	                      ),
	                      isABCFF && this.context.router.routes[1].path === "outboundOrders" && _react2.default.createElement('input', {
	                        type: 'file',
	                        style: { display: "none" },
	                        onClick: function onClick(e) {
	                          e.target.value = null;
	                        },
	                        onChange: function onChange(e) {
	                          var formData = new FormData();
	                          formData.append("File", e.target.files[0]);
	                          if (e.target.files[0]) {
	                            _axios2.default.post(_root_url.ROOT_URL + 'v2/sales/upload_dsco_shipment?platform=dsco', formData, {
	                              headers: {
	                                Authorization: 'Bearer ' + localStorage.getItem("token")
	                              }
	                            }).then(function (res) {
	                              alert('success');
	                            }, function (err) {
	                              alert(JSON.stringify(err.data));
	                            });
	                          }
	                        },
	                        ref: 'dsco_ref'
	                      }),
	                      isABCFF && this.context.router.routes[1].path === "outboundOrders" && _react2.default.createElement('input', {
	                        type: 'file',
	                        style: { display: "none" },
	                        onClick: function onClick(e) {
	                          e.target.value = null;
	                        },
	                        onChange: function onChange(e) {
	                          var formData = new FormData();
	                          formData.append("File", e.target.files[0]);
	                          if (e.target.files[0]) {
	                            _axios2.default.post(_root_url.ROOT_URL + 'v2/sales/upload_dsco_shipment?platform=walmartb2b', formData, {
	                              headers: {
	                                Authorization: 'Bearer ' + localStorage.getItem("token")
	                              }
	                            }).then(function (res) {
	                              alert('success');
	                            }, function (err) {
	                              alert(JSON.stringify(err.data));
	                            });
	                          }
	                        },
	                        ref: 'walmartb2b_ref'
	                      }),
	                      (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB || isMAG || isEZone) && this.context.router.routes[1].path === "salesOrders" && _react2.default.createElement('input', {
	                        type: 'file',
	                        style: { display: "none" },
	                        onClick: function onClick(e) {
	                          e.target.value = null;
	                        },
	                        onChange: function onChange(e) {
	                          var formData = new FormData();
	                          formData.append("FILE", e.target.files[0]);
	                          if (e.target.files[0]) {
	                            _axios2.default.post(_root_url.ROOT_URL + 'v2/import-so-xls', formData, {
	                              headers: {
	                                Authorization: 'Bearer ' + localStorage.getItem("token")
	                              }
	                            }).then(function (res) {
	                              alert("Inbound Orders imported successfully");
	                              _this68.fetchSalesOrdersByDetails(_this68.state.days);
	                            }, function (err) {
	                              if (err.data) {
	                                alert(err.data);
	                              } else {
	                                alert("Server issue detected, please contact admin.");
	                              }
	                            });
	                          }
	                        },
	                        ref: 'msoCreateInputRef2'
	                      }),
	                      (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB || isMAG) && this.context.router.routes[1].path === "outboundOrders" && _react2.default.createElement('input', {
	                        type: 'file',
	                        style: { display: "none" },
	                        onClick: function onClick(e) {
	                          e.target.value = null;
	                        },
	                        onChange: function onChange(e) {
	                          var formData = new FormData();
	                          formData.append("FILE", e.target.files[0]);
	                          if (e.target.files[0]) {
	                            _axios2.default.post(_root_url.ROOT_URL + 'v2/import-outbound-xls', formData, {
	                              headers: {
	                                Authorization: 'Bearer ' + localStorage.getItem("token")
	                              }
	                            }).then(function (res) {
	                              alert("Outbound Orders imported successfully");
	                              _this68.fetchSalesOrdersByDetails(_this68.state.days);
	                            }, function (err) {
	                              if (err.data) {
	                                alert(err.data);
	                              } else {
	                                alert("Server issue detected, please contact admin.");
	                              }
	                            });
	                          }
	                        },
	                        ref: 'msoCreateInputRef3'
	                      }),
	                      isWIZ && this.context.router.routes[1].path === "outboundOrders" && _react2.default.createElement('input', {
	                        type: 'file',
	                        style: { display: "none" },
	                        onClick: function onClick(e) {
	                          e.target.value = null;
	                        },
	                        onChange: function onChange(e) {
	                          var wURL = _root_url.ROOT_URL + 'v2/sales/pod/' + _this68.state.salesOrders.selectedRows[0].SalesOrder_id + '/';
	                          var formData = new FormData();
	                          formData.append("FILE", e.target.files[0]);
	                          if (e.target.files[0]) {
	                            _axios2.default.post(wURL, formData, {
	                              headers: {
	                                Authorization: 'Bearer ' + localStorage.getItem("token")
	                              }
	                            }).then(function (res) {
	                              alert("POD uploaded successfully");
	                              _this68.fetchSalesOrdersByDetails(_this68.state.days);
	                            }, function (err) {
	                              if (err.data) {
	                                alert(err.data);
	                              } else {
	                                alert("Server issue detected, please contact admin.");
	                              }
	                            });
	                          }
	                        },
	                        ref: 'msoCreateInputRef4'
	                      }),
	                      isTN && this.context.router.routes[1].path === "salesOrders" &&
	                      // this.renderTNOriginal()
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: 'success',
	                          type: 'submit',
	                          onClick: function onClick() {
	                            // this.refs.msoCreateInputRef.click();
	                            _this68.setTNExcelOptionModalVisibility(true);
	                          },
	                          disabled: !(0, _permissions2.default)("add_sales_order")
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel_create' })
	                      ),
	                      isYI && this.context.router.routes[1].path === "mobileSalesOrders" && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: 'success',
	                          type: 'submit',
	                          onClick: function onClick() {
	                            _this68.refs.msoCreateInputRefabcff.click();
	                          },
	                          disabled: !(0, _permissions2.default)("add_sales_order")
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel_create' })
	                      ),
	                      isYI && this.context.router.routes[1].path === "mobileSalesOrders" && _react2.default.createElement('input', {
	                        type: 'file',
	                        style: { display: "none" },
	                        onClick: function onClick(e) {
	                          e.target.value = null;
	                        },
	                        onChange: function onChange(e) {
	                          var formData = new FormData();
	                          formData.append("FILE", e.target.files[0]);
	                          if (e.target.files[0]) {
	                            _axios2.default.post(
	                            // `${ROOT_URL}v2/import_orders_xls`,
	                            _root_url.ROOT_URL + 'v2/import_orders_abcff', formData, {
	                              headers: {
	                                Authorization: 'Bearer ' + localStorage.getItem("token")
	                              }
	                            }).then(function (res) {
	                              alert("MSO Imported Successfully");
	                              _this68.fetchSalesOrdersByDetails(_this68.state.days);
	                            }, function (err) {
	                              if (err.data) {
	                                alert(err.data);
	                              } else {
	                                alert("Server issue detected, please contact admin.");
	                              }
	                            });
	                          }
	                        },
	                        ref: 'msoCreateInputRefabcff'
	                      }),
	                      isTN && this.context.router.routes[1].path === "salesOrders" && _react2.default.createElement('input', {
	                        type: 'file',
	                        style: { display: "none" },
	                        onClick: function onClick(e) {
	                          e.target.value = null;
	                        },
	                        onChange: function onChange(e) {
	                          var formData = new FormData();
	                          formData.append("FILE", e.target.files[0]);
	                          if (e.target.files[0]) {
	                            _axios2.default.post(
	                            // `${ROOT_URL}v2/import_orders_xls`,
	                            _root_url.ROOT_URL + 'v2/tn_order_import_original', formData, {
	                              headers: {
	                                Authorization: 'Bearer ' + localStorage.getItem("token")
	                              }
	                            }).then(function (res) {
	                              alert("SO Imported Successfully");
	                              _this68.fetchSalesOrdersByDetails(_this68.state.days);
	                            }, function (err) {
	                              if (err.data) {
	                                alert(err.data);
	                              } else {
	                                alert("Server issue detected, please contact admin.");
	                              }
	                            });
	                          }
	                        },
	                        ref: 'msoCreateInputRefOriginal'
	                      }),
	                      !(isABCFF && this.context.router.routes[1].path === 'outboundOrders') && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: 'warning',
	                          type: 'button',
	                          disabled: this.state.salesOrders.selectedRows.length !== 1 || !(0, _permissions2.default)("change_sales_order"),
	                          onClick: function onClick(event) {
	                            _this68.setCurrentSalesOrder(event);
	                          }
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	                      ),
	                      !isABCFF && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: 'danger',
	                          type: 'reset',
	                          disabled: this.shouldVoidButtonDisable() || !(0, _permissions2.default)("delete_sales_order"),
	                          onClick: function onClick() {
	                            _this68.openCheckAuthorize("void");
	                          }
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-trash' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'void' })
	                      ),
	                      (isDSQ || isWUFS || isATL || isUSPride || isKDW || isYI || isFBD || isWIZ || isABCFF && this.context.router.routes[1].path === 'outboundOrders' || isFJ && this.context.router.routes[1].path !== 'outboundOrders' || isJTB || isMAG) && !isSW && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: 'primary'
	                          // type="reset"
	                          , disabled: !this.state.salesOrders.selectedRows.length,
	                          onClick: function onClick() {
	                            var soPKs = _this68.state.salesOrders.selectedRows.map(function (row) {
	                              return row.SalesOrder_id;
	                            });
	                            var success = function success() {
	                              _this68.refreshSOList();
	                            };
	                            (0, _sales_actions.expressMultipleSOInvoices)(soPKs, success);
	                          }
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-file' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'express_invoice' })
	                      ),
	                      isTN && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: 'primary'
	                          // type="reset"
	                          , disabled: !this.state.salesOrders.selectedRows.length,
	                          onClick: function onClick() {
	                            _this68.openExpressShipVisibility();
	                            // this.confirmExpressShip();
	                          }
	                        },
	                        _react2.default.createElement('em', { className: 'fa fa-file' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'express_invoice' })
	                      ),
	                      this.renderPrint(),
	                      this.renderShippingIFrame(),
	                      this.renderPackingIFrame(),
	                      this.renderPickingIFrame(),
	                      this.renderSalesOrderIFrame(),
	                      this.renderBolByIdIFrame(),
	                      this.renderBolWithoutLogIFrame(),
	                      this.renderBolLabelIFrame(),
	                      this.renderBolByFbaIFrame()
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'table-filters', style: { zIndex: 1 } },
	                      !(isWIZ || isATL || isKDW || isABCFF) && _react2.default.createElement(
	                        'label',
	                        {
	                          style: { marginRight: "0px" },
	                          className: 'control-label'
	                        },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_seller' })
	                      ),
	                      !(isWIZ || isATL || isKDW) && this.renderUsers(),
	                      isUSPride && _react2.default.createElement(
	                        'label',
	                        {
	                          style: { marginRight: "3px" },
	                          className: 'control-label'
	                        },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'warehouse' })
	                      ),
	                      isUSPride && this.renderWarehouse(),
	                      _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        { className: 'table-buttons' },
	                        !(isABCFF && this.context.router.routes[1].path === 'salesOrders') && this.renderExportButton(),
	                        isATL && this.renderExportButtonATL(),
	                        isATL && this.renderExportDetailButton(),
	                        isATL && this.renderOrderExportButtonATL(),
	                        isTN && this.renderExportSelectedButton(),
	                        isCalco && this.renderExportButton("qb"),
	                        isCalco && this.renderEmailPackingButton(),
	                        isMyuMyu && this.renderCreateTaskButton(),
	                        isAFG && this.renderChangeWeightButton(),
	                        _root_url.isRivera && this.renderPaymentMethodChangeButton(),
	                        !(isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isATL) && this.renderReshipButton(),
	                        !(isDSQ || isWUFS || isKDW || isYI || isFBD || isMAG || isATL || isUSPride || isABCFF) && this.renderQuoteButton(),
	                        isABCFF && this.context.router.routes[1].path === 'outboundOrders' && this.renderQuoteButton(),
	                        isUSPride && this.renderAddTracking(),
	                        (isCO || isABC) && this.renderPrintBolButton(),
	                        (isCalco || isEcity) && this.renderDriverImageButton(),
	                        isMyuMyu && this.renderChowbusImportButton(),
	                        (isMyuMyu || isAFG) && this.renderDavisPO(),
	                        !(isCalco || isAFG || isABC || isFIT || isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isNBT || isKM || isATL || isSW) && this.renderPrintLabelButton(),
	                        isAPO && this.renderPrintLabelButtonAFG(),
	                        (isAmzey || isATL) && this.context.router.routes[1].path === 'mobileSalesOrders' && this.renderTeapplixButton(),
	                        isABCFF && this.context.router.routes[1].path === 'outboundOrders' && this.renderTeapplixButton(),
	                        this.renderUploadMSOButton(),
	                        isAFM && this.estDeliveryTimeEditButton(),
	                        (isAFG || isFIT || isNBT || isKM) && this.renderPrintLabelButtonAFG(),
	                        (isDSQ || isWUFS || isKDW || isYI || isFBD) && this.renderPrintLabelButtonDSQ(),
	                        (isUSPride || isRS) && this.renderPrintLabelUSPride(),
	                        (isUSPride || isRS) && this.renderReprintLabelUSPride(),
	                        (isDSQ || isWUFS || isKDW || isYI || isFBD) && this.context.router.routes[1].path === 'salesOrders' && this.dsqExcelTemplate(),
	                        (isDSQ || isWUFS || isKDW || isFBD) && this.context.router.routes[1].path === 'salesOrders' && this.dsqExcelTemplateOb(),
	                        (isDSQ || isWUFS || isKDW || isYI || isFBD) && this.context.router.routes[1].path === 'outboundOrders' && this.dsqOutboundTemplate(),
	                        (isABCFF || isYI) && this.context.router.routes[1].path === 'mobileSalesOrders' && this.abcffMsoTemplate(),
	                        isSW && this.context.router.routes[1].path === 'mobileSalesOrders' && this.swShippingLabel(),
	                        isSW && this.context.router.routes[1].path === 'mobileSalesOrders' && this.swResync(),
	                        isJTB && this.context.router.routes[1].path === 'salesOrders' && this.jtbExcelTemplate(),
	                        isWIZ && this.context.router.routes[1].path === 'salesOrders' && this.wizExcelTemplate(),
	                        isFJ && this.context.router.routes[1].path === 'salesOrders' && this.fjExcelTemplate(),
	                        isMAG && this.context.router.routes[1].path === 'salesOrders' && this.magExcelTemplate(),
	                        isEZone && this.magExcelTemplate(),
	                        isWIZ && this.bolList(),
	                        isWIZ && this.generateBOL(),
	                        isMAG && this.renderEmailUpdateButton(),
	                        isKDW && this.context.router.routes[1].path === 'outboundOrders' && this.outboundStatusButton(),
	                        (isWIZ || isKDW) && this.context.router.routes[1].path === "outboundOrders" && _react2.default.createElement(
	                          _reactBootstrap.Button,
	                          {
	                            bsStyle: 'success',
	                            type: 'submit',
	                            onClick: function onClick() {
	                              // this.refs.msoCreateInputRef4.click();
	                              _this68.openWIZPOD();
	                            },
	                            disabled: this.state.salesOrders.selectedRows.length !== 1
	                          },
	                          _react2.default.createElement('em', { className: 'fa fa-list' }),
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pod' })
	                        ),
	                        isKDW && this.context.router.routes[1].path === "outboundOrders" && this.renderEmailPodButton(),
	                        isKDW && this.context.router.routes[1].path === "outboundOrders" && _react2.default.createElement(
	                          _reactBootstrap.Button,
	                          {
	                            bsStyle: 'success',
	                            type: 'submit',
	                            onClick: function onClick() {
	                              // this.refs.msoCreateInputRef4.click();
	                              _this68.openAssignBol();
	                            },
	                            disabled: this.state.salesOrders.selectedRows.length < 1
	                          },
	                          'Assign BOL'
	                        ),
	                        isKDW && this.context.router.routes[1].path === "outboundOrders" && this.renderPrintBolKDW(),
	                        isOCM && this.renderSendEmailButton(),
	                        isYI && this.context.router.routes[1].path === "outboundOrders" && this.postQuoteButton(),
	                        isYI && this.context.router.routes[1].path === "outboundOrders" && this.getQuoteButton()
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'table-filters-thirdrow', style: { zIndex: 1, left: isYI ? "0px" : "177px" } },
	                      _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        { style: { position: 'relative', display: 'flex', flexDirection: 'row' } },
	                        isCalco && this.renderSendSO(),
	                        isYI && this.context.router.routes[1].path === "outboundOrders" && this.createBOLButton(),
	                        isYI && this.context.router.routes[1].path === "outboundOrders" && this.renderYingBOLPrint(),
	                        isYI && this.context.router.routes[1].path === "outboundOrders" && this.postPickupButton(),
	                        isYI && this.context.router.routes[1].path === "outboundOrders" && this.getPickupButton(),
	                        isYI && this.renderCalculateFees(),
	                        isYI && this.context.router.routes[1].path === "outboundOrders" && this.renderYingPrintFile(),
	                        (isCO || isABC || isTN) && this.renderSubmitBolImageButton(),
	                        (isABC || isTN) && this.renderUploadPODButton(),
	                        isTN && this.renderSetOpen()
	                      )
	                    ),
	                    isABC && this.context.router.routes[1].path !== 'salesOrders' && _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      { style: { marginTop: '40px' } },
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-sm-3', style: { width: '120px' } },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_num' })
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-sm-3', style: { width: '120px' } },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'company' })
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-sm-3', style: { width: '120px' } },
	                          'FBA'
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-sm-3', style: { width: '120px' } },
	                          'BOL'
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-sm-3', style: { width: '120px' } },
	                          'ISA'
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-sm-3', style: { width: '120px' } },
	                          'Ship Status'
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'col-sm-3', style: { width: '120px' } },
	                          'Container'
	                        )
	                      )
	                    ),
	                    isABC && this.context.router.routes[1].path !== 'salesOrders' && _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: 'col-sm-3', style: { width: '120px' } },
	                        _react2.default.createElement(_reactBootstrap.Input, { name: 'SONum', type: 'text', onChange: function onChange(e) {
	                            return handleFilterChangePage(e.target);
	                          } })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: 'col-sm-3', style: { width: '120px' } },
	                        _react2.default.createElement(_reactBootstrap.Input, { name: 'CompanyName', type: 'text', onChange: function onChange(e) {
	                            return handleFilterChangePage(e.target);
	                          } })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: 'col-sm-3', style: { width: '120px' } },
	                        _react2.default.createElement(_reactBootstrap.Input, { name: 'FBACode', type: 'text', onChange: function onChange(e) {
	                            return handleFilterChangePage(e.target);
	                          } })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: 'col-sm-3', style: { width: '120px' } },
	                        _react2.default.createElement(_reactBootstrap.Input, { name: 'CustomerBOLNo', type: 'text', onChange: function onChange(e) {
	                            return handleFilterChangePage(e.target);
	                          } })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: 'col-sm-3', style: { width: '120px' } },
	                        _react2.default.createElement(_reactBootstrap.Input, { name: 'IsaNo', type: 'text', onChange: function onChange(e) {
	                            return handleFilterChangePage(e.target);
	                          } })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: 'col-sm-3', style: { width: '120px' } },
	                        _react2.default.createElement(_reactBootstrap.Input, { name: 'ShippingStatus', type: 'text', onChange: function onChange(e) {
	                            return handleFilterChangePage(e.target);
	                          } })
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: 'col-sm-3', style: { width: '120px' } },
	                        _react2.default.createElement(_reactBootstrap.Input, { name: 'ContainerNo', type: 'text', onChange: function onChange(e) {
	                            return handleFilterChangePage(e.target);
	                          } })
	                      )
	                    ),
	                    isABC && this.context.router.routes[1].path === 'salesOrders' && _react2.default.createElement('div', { style: { height: "90px" } }),
	                    (!isABC || this.context.router.routes[1].path === 'salesOrders') && _react2.default.createElement(
	                      'div',
	                      {
	                        id: 'autosuggest-div',
	                        className: (isTN || isABC || isUSPride || isATL || isRS || isDSQ || isWUFS || isEZone || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB || isMAG) && "TNAutosuggest-div"
	                      },
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { style: { height: "30px" } },
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 7 },
	                          _react2.default.createElement(_TypeRadios2.default, {
	                            InvoiceNoSearch: true,
	                            TrackingNoSearch: isAFG ? true : null,
	                            CPONumSearch: isTN ? true : null,
	                            value: this.state.searchType,
	                            handleOptionChange: this.handleOptionChange
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 6 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { xs: 12 },
	                              (this.state.searchType === "invoiceNo" || this.state.searchType === "CPONum" || this.state.searchType === "Type") && this.renderInvoiceNoSearchInput(),
	                              isAFG && this.state.searchType === "trackingNo" && this.renderTrackingNoSearchInput(),
	                              this.state.searchType !== "invoiceNo" && this.state.searchType !== "trackingNo" && this.state.searchType !== "CPONum" && this.state.searchType !== "Type" && this.renderAutoSuggest()
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  this.renderTable()
	                )
	              )
	            ),
	            " ",
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                !isABC && !isFJ && !isDSQ && !isWUFS && !isABCFF && !isKDW && !isYI && !isFBD && !isWIZ && !isJTB && !isMAG && _react2.default.createElement(
	                  'h2',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sale_order_details' })
	                ),
	                (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isJTB || isFJ) && _react2.default.createElement(
	                  'h2',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_details' })
	                ),
	                !isABC && !isFJ && !isMAG && _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'details-table-collapse-fix' },
	                  this.renderProductsTable()
	                ),
	                isFJ && _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'details-table-collapse-fix' },
	                  this.renderProductsTable()
	                ),
	                (isMAG || isKDW) && _react2.default.createElement(
	                  'h2',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'container_info' }),
	                  ' (',
	                  this.state.magSalesOrderDetail.SalesOrder_id ? this.state.magSalesOrderDetail.SONum : "None",
	                  ')',
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                      bsStyle: 'success',
	                      type: 'button',
	                      style: { marginLeft: '50px' },
	                      disabled: !this.state.magSalesOrderDetail.SalesOrder_id,
	                      onClick: function onClick(event) {
	                        _this68.saveMagStuff(event);
	                      }
	                    },
	                    _react2.default.createElement('em', { className: 'fa fa-save' }),
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save_order_info' })
	                  )
	                ),
	                (isMAG || isKDW) && _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'details-table-collapse-fix' },
	                  this.renderMagContainer()
	                ),
	                (isMAG || isKDW) && _react2.default.createElement(
	                  'h2',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'load_pickup_info' }),
	                  ' (',
	                  this.state.magSalesOrderDetail.SalesOrder_id ? this.state.magSalesOrderDetail.SONum : "None",
	                  ')'
	                ),
	                (isMAG || isKDW) &&
	                // <Panel className="details-table-collapse-fix">
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  null,
	                  this.renderMagLoad()
	                ),
	                (isMAG || isKDW) && _react2.default.createElement(
	                  'h2',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delivery_info' }),
	                  ' (',
	                  this.state.magSalesOrderDetail.SalesOrder_id ? this.state.magSalesOrderDetail.SONum : "None",
	                  ')'
	                ),
	                (isMAG || isKDW) &&
	                // <Panel className="details-table-collapse-fix">
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  null,
	                  this.renderMagDelivery()
	                ),
	                (isMAG || isKDW) && _react2.default.createElement(
	                  'h2',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'empty_info' }),
	                  ' (',
	                  this.state.magSalesOrderDetail.SalesOrder_id ? this.state.magSalesOrderDetail.SONum : "None",
	                  ')'
	                ),
	                (isMAG || isKDW) &&
	                // <Panel style={{marginBottom: '200px'}} className="details-table-collapse-fix">
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { style: { marginBottom: '200px' } },
	                  this.renderMagEmpty()
	                )
	              )
	            ),
	            " "
	          ),
	          _react2.default.createElement(LocationChange, {
	            setModalVisibility: this.setLocationChangeModalVisibility,
	            isVisible: this.state.isLocationChangeModalVisible,
	            selectedRows: this.state.salesOrders.selectedRows,
	            onSuccess: this.handleLocationChangeSuccess
	          }),
	          _react2.default.createElement(InboundDateChange, {
	            setModalVisibility: this.setInboundDateChangeModalVisibility,
	            isVisible: this.state.isInboundDateChangeModalVisibile,
	            selectedRows: this.state.salesOrders.selectedRows,
	            onSuccess: this.handleLocationChangeSuccess
	          }),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createWeightDialogStyle,
	              isVisible: this.state.changeWeightOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closeChangeWeight();
	              },
	              title: changeWeight
	            },
	            _react2.default.createElement(_weightChangeModalMulti.WeightChangeModalMulti, {
	              salesOrderId: singleSalesOrderId,
	              fetchShippingWeightTracking: this.props.fetchShippingWeightTracking,
	              finalShippingWeight: this.state.finalShippingWeight,
	              onSave: this.onChangeWeightSubmit,
	              onSavePrint: this.onChangeWeightSubmitPrint,
	              onChange: this.onShippingWeightChange
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: bolListDialogStyle,
	              isVisible: this.state.bolListModalVisibility,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closebolListModal();
	              },
	              title: "BOL List"
	            },
	            _react2.default.createElement(_bolListModal.BOLListModal
	            // salesOrderId={singleSalesOrderId}
	            , { salesOrderNum: singleSalesOrderNum,
	              closebolListModal: this.closebolListModal,
	              printSalesOrderLabelBOL: this.props.printSalesOrderLabelBOL,
	              testHAHA: this.props.printSalesOrderLabel
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: generateBOLStyle,
	              isVisible: this.state.generateBOLModalVisibility,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closeGenerateBOLModal();
	              },
	              title: "Generate BOL"
	            },
	            _react2.default.createElement(_generateBOLModal.GenerateBOLModal, {
	              salesOrderIdString: salesOrderIdString,
	              salesOrderNumString: salesOrderNumString,
	              closeGenerateBOLModal: this.closeGenerateBOLModal
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: dsqPrintDialogStyle,
	              isVisible: this.state.dsqPrintVisibility,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closeDSQPrint();
	              },
	              title: "Select Products"
	            },
	            _react2.default.createElement(_dsqPrintModal.DSQPrintModal
	            // salesOrderId={singleSalesOrderId}
	            // salesOrderNum={singleSalesOrderNum}
	            , { printSalesOrderLabelDSQ: this.props.printSalesOrderLabelDSQ,
	              singleSalesOrderId: singleSalesOrderId,
	              closebolListModal: this.closeDSQPrint
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: wizPODDialogStyle,
	              isVisible: this.state.wizPODVisibility,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closeWIZPOD();
	              },
	              title: "POD (" + singleSalesOrderNum + ")"
	            },
	            _react2.default.createElement(_wizPODModal.WIZPODModal
	            // salesOrderId={singleSalesOrderId}
	            // salesOrderNum={singleSalesOrderNum}
	            // printSalesOrderLabelDSQ={this.props.printSalesOrderLabelDSQ}
	            , { singleSalesOrderId: singleSalesOrderId,
	              closeWIZPOD: this.closeWIZPOD
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createWeightDialogStyle,
	              isVisible: this.state.USPrideCreateOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closeUSPrideCreate();
	              },
	              title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_with_excel' })
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'centerStyle' },
	              isABCFF && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { className: 'centerStyle' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Select Customer:'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { className: 'centerStyle' },
	                  _react2.default.createElement(
	                    'div',
	                    { style: { width: "250px" } },
	                    _react2.default.createElement(_reduxForm.Field, {
	                      name: 'excelCustomer',
	                      placeholder: _react2.default.createElement(
	                        'span',
	                        { style: { fontStyle: "normal" } },
	                        'Select'
	                      ),
	                      component: _selection.SelectionWithProps,
	                      options: this.state.excelCustomerOptions,
	                      onSelect: function onSelect(value) {
	                        _this68.onUSPrideCustomerChange(value);
	                      }
	                    })
	                  )
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { className: 'centerStyle' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Select Market:'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { className: 'centerStyle' },
	                  _react2.default.createElement(
	                    'div',
	                    { style: { width: "250px" } },
	                    _react2.default.createElement(_reduxForm.Field, {
	                      name: 'excelPlatform',
	                      placeholder: _react2.default.createElement(
	                        'span',
	                        { style: { fontStyle: "normal" } },
	                        'Select'
	                      ),
	                      component: _selection.SelectionWithProps,
	                      options: USPridePlatformOptions,
	                      onSelect: function onSelect(value) {
	                        _this68.onUSPridePlatformChange(value);
	                      }
	                    })
	                  )
	                )
	              ),
	              !isABCFF && _react2.default.createElement(
	                _reactBootstrap.Dropdown,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Dropdown.Toggle,
	                  {
	                    style: {
	                      width: "154px",
	                      backgroundColor: "white",
	                      border: "1px solid #555555",
	                      color: "black",
	                      fontWeight: "400",
	                      marginTop: "10px"
	                    }
	                  },
	                  this.state.USPridePlatform && this.state.USPridePlatform,
	                  !this.state.USPridePlatform && "Select"
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Dropdown.Menu,
	                  { className: 'super-colors' },
	                  USPridePlatformOptions.map(function (el) {
	                    return _react2.default.createElement(
	                      _reactBootstrap.MenuItem,
	                      { onClick: function onClick() {
	                          return _this68.onUSPridePlatformChange(el);
	                        } },
	                      el.label
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { marginTop: "10px" } },
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'success',
	                    type: 'submit',
	                    onClick: function onClick(event) {
	                      _this68.refs.createSORef.click();
	                    },
	                    disabled: (!(0, _permissions2.default)("add_sales_order") || USPridePlatform === '') && !isABCFF
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'import_and_submit' })
	                ),
	                _react2.default.createElement('input', {
	                  type: 'file',
	                  ref: 'createSORef',
	                  key: inputFieldKey,
	                  onClick: function onClick(e) {
	                    e.target.value = null;
	                  },
	                  onChange: function onChange(e) {
	                    _this68.setState({ USPrideCreateOpen: false, USPrideCreateLoading: true });
	                    var formData = new FormData();
	                    var file = e.target.files[0];
	                    formData.append('FILE', file);
	                    (0, _sales_actions.generateSOWithExcelUSPride)(formData, USPridePlatform, USPrideCustomer, function () {
	                      alert('success, reloading the page');
	                      _this68.refreshSOList();
	                      _this68.onUSPridePlatformChange('');
	                      _this68.onUSPrideCustomerChange('');
	                      _this68.setState({ USPrideCreateLoading: false });
	                    }, function () {
	                      _this68.setState({ USPrideCreateLoading: false });
	                    });
	                  },
	                  style: { display: 'none' }
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createWeightDialogStyle,
	              isVisible: this.state.paymentMethodModalVisibility,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closePaymentMethodModal();
	              },
	              title: changePaymentMethod
	            },
	            _react2.default.createElement(_PaymentMethodModal2.default, {
	              salesOrder: this.state.salesOrders.selectedRows,
	              successSaved: this.handleSOPaymentMethodSaved
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: altonChildDialogStyle,
	              isVisible: this.state.isAltonChildVisible,
	              onCloseClicked: function onCloseClicked() {
	                _this68.setAltonChildVisibility(false);
	              },
	              title: altonChildTitle
	            },
	            _react2.default.createElement(_AltonChildModal2.default, {
	              altonSelectedProd: this.state.altonSelectedProd
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createTrackingDialogStyle,
	              isVisible: this.state.displayTrackingOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closeDisplayTracking();
	              },
	              title: isAFG ? displayTrackingTitle : displayTrackingTitle2
	            },
	            _react2.default.createElement(_SplitTrackingNumberModal.SplitTrackingNumberModal, {
	              salesOrderId: singleSalesOrderId,
	              jmlPrintLabel: this.props.printShippigLabel,
	              fetchJmlTracking: this.props.fetchJmlTracking,
	              fetchShippingWeightTracking: this.props.fetchShippingWeightTracking
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: changeTrackingDialogStyle,
	              isVisible: this.state.changeTrackingOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closeChangeTracking();
	              },
	              title: "Change Tracking Number"
	            },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'centerStyle' },
	              _react2.default.createElement(
	                'div',
	                { style: { width: '350px' } },
	                _react2.default.createElement(_reactBootstrap.Input, { type: 'text', value: this.state.newTrackingNum, onChange: this.onChangeTrackingNum })
	              )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { className: 'button-toolbar-center' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  onClick: this.changeTrackingConfirm,
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  onClick: this.closeChangeTracking,
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: changeBOLDialogStyle,
	              isVisible: this.state.trackingFormOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closeTrackingForm();
	              },
	              title: "Add Tracking Info"
	            },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 4 },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tracking_num' })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 4 },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 4 },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_method' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 4 },
	                _react2.default.createElement(_reactBootstrap.Input, { type: 'text', value: this.state.trackingformNum, onChange: this.onChangeFormNum })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 4 },
	                _react2.default.createElement(_reactBootstrap.Input, { type: 'text', value: this.state.trackingformCarrier, onChange: this.onChangeFormCarrier })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 4 },
	                _react2.default.createElement(_reactBootstrap.Input, { type: 'text', value: this.state.trackingformMethod, onChange: this.onChangeFormMethod })
	              )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { className: 'button-toolbar-center' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  onClick: this.confirmTrackingForm,
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: changeShipDateDialogue,
	              isVisible: this.state.isExpressShipVisibility,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closeExpressShipVisibility();
	              },
	              title: "Set Ship Date"
	            },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'centerStyle' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_date' }),
	                ':'
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { width: '350px' } },
	                (0, _GenericDatePicker2.default)({
	                  setDate: this.setExpressShipDate,
	                  selectedDate: this.state.expressShipDate,
	                  onChange: function onChange(e) {
	                    _this68.setExpressShipDate(e);
	                  }
	                })
	              )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { className: 'button-toolbar-center' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  onClick: this.confirmExpressShip,
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  onClick: this.closeExpressShipVisibility,
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: changeBOLDialogStyle,
	              isVisible: this.state.openAssignBolVisibility,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closeAssignBol();
	              },
	              title: "Assign BOL Number"
	            },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'bol_num' }),
	                  ':'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'seal_num' }),
	                  ':'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(_reactBootstrap.Input, { type: 'text', value: this.state.BLNum, onChange: this.onChangeBolNumber })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(_reactBootstrap.Input, { type: 'text', value: this.state.SealNum, onChange: this.onChangeSealNumber })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pro_num' }),
	                  ':'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' }),
	                  ':'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(_reactBootstrap.Input, { type: 'text', value: this.state.ProNum, onChange: this.onChangeProNumber })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(_reactBootstrap.Input, { type: 'text', value: this.state.Carrier, onChange: this.onChangeCarrierNumber })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 12 },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_to_address' }),
	                  ':'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 12 },
	                _react2.default.createElement(
	                  'div',
	                  { style: { width: '100px', marginTop: '6px' } },
	                  _react2.default.createElement(
	                    _reactBootstrap.Dropdown,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Dropdown.Toggle,
	                      { style: { height: '28px', width: '350px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' } },
	                      this.state.drayageListDisplay
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Dropdown.Menu,
	                      { className: 'super-colors' },
	                      this.state.drayageListOptions.map(function (el) {
	                        return _react2.default.createElement(
	                          _reactBootstrap.MenuItem,
	                          { onClick: function onClick() {
	                              return handleDrayageChange(el);
	                            } },
	                          el.label
	                        );
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { className: 'button-toolbar-center' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  onClick: this.confirmChangeBolNumber,
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  onClick: this.closeAssignBol,
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogStyle,
	              isVisible: this.state.printTrackingConfirmOpen,
	              onCloseClicked: this.closePrintTrackingConfirm,
	              title: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm_print_tracking' })
	            },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'centerStyle' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_confirm_print_tracking' })
	              )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { className: 'button-toolbar-center' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  onClick: this.closePrintTrackingConfirm,
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  onClick: this.printTrackingConfirm,
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createPullSheetDialogStyle,
	              isVisible: this.state.changePullSheetOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closeChangePullSheet();
	              },
	              title: changePullSheet
	            },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 4 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_amount' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 4 },
	                  _react2.default.createElement(_reactBootstrap.Input, { type: 'number', onChange: this.onPullSheetChange })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 3 },
	                  _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'primary',
	                        onClick: function onClick() {
	                          _this68.onChangePullSheetSubmit();
	                        }
	                      },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogStyle,
	              isVisible: this.state.checkAuthorizeOpen,
	              onCloseClicked: this.closeCheckAuthorize
	            },
	            _react2.default.createElement(_confirmActionModal2.default, {
	              'case': 'confirmPassword',
	              closeC: this.checkAuthorize,
	              checkPasswordFailure: this.props.checkPasswordFailure
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: voidNoteDialogStyle,
	              isVisible: this.state.voidNoteModalVisibility,
	              onCloseClicked: this.closeVoidNote,
	              title: voidNoteTitle
	            },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'centerStyle' },
	              _react2.default.createElement(
	                'div',
	                { style: { width: "250px", marginTop: "10px" } },
	                _react2.default.createElement(
	                  'p',
	                  { style: { marginBottom: "3px", fontWeight: "bold" } },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'void_reason' }),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Dropdown,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Dropdown.Toggle,
	                    {
	                      style: {
	                        width: "250px",
	                        backgroundColor: "white",
	                        border: "1px solid #555555",
	                        color: "black",
	                        fontWeight: "400"
	                      }
	                    },
	                    this.state.voidReason && this.state.voidReason,
	                    !this.state.voidReason && "Select"
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Dropdown.Menu,
	                    { className: 'super-colors' },
	                    voidReasonSelection.map(function (el) {
	                      return _react2.default.createElement(
	                        _reactBootstrap.MenuItem,
	                        { onClick: function onClick() {
	                            return _this68.onVoidReasonChange(el);
	                          } },
	                        el.label
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  style: {
	                    width: "350px",
	                    marginTop: "20px",
	                    marginBottom: "35px"
	                  }
	                },
	                _react2.default.createElement(
	                  'p',
	                  { style: { marginBottom: "3px", fontWeight: "bold" } },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'void_note' }),
	                  ':'
	                ),
	                _react2.default.createElement(_reactBootstrap.Input, {
	                  type: 'textarea',
	                  rows: 3,
	                  onChange: this.onVoidNoteChange
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { className: 'button-toolbar-center' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsStyle: 'danger', onClick: this.closeVoidNote, type: 'button' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  onClick: function onClick() {
	                    _this68.onConfirmVoidNote();
	                  },
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm_void' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: chowbusDialogStyle,
	              isVisible: this.state.chowbusModalVisibility,
	              onCloseClicked: this.closeChowbusModal,
	              title: chowbusImportTitle
	            },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'centerStyle', style: { marginBottom: "20px" } },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'spreadsheet' })
	              ),
	              _react2.default.createElement('input', {
	                style: { border: "1px solid #aaa" },
	                type: 'file',
	                name: 'file',
	                onChange: this.onChangeChowbusImport
	              })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { className: 'button-toolbar-center' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  onClick: this.closeChowbusModal,
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  onClick: function onClick() {
	                    _this68.onConfirmChowbusImport();
	                  },
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'import' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogStyle,
	              isVisible: this.state.confirmReshipOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closeConfirmReship();
	              },
	              title: reshipTitle
	            },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'centerStyle' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_confirm_reship' })
	              )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { className: 'button-toolbar-center' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  onClick: this.closeConfirmReship,
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  onClick: function onClick() {
	                    _this68.onConfirmReship();
	                  },
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogStyle,
	              isVisible: this.state.showDriverImageOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closeShowDriverImage();
	              },
	              title: showImageTitle
	            },
	            this.renderDriverImage()
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: bolImageDialogue,
	              isVisible: this.state.submitImageOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closeSubmitImage();
	              },
	              title: submitImageTitle
	            },
	            _react2.default.createElement(_BolImagesTable2.default, {
	              salesOrder_id: this.state.salesOrders.selectedRows.length === 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id,
	              handleImageClosed: function handleImageClosed() {
	                _this68.closeSubmitImage();
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogStyle,
	              isVisible: this.state.printBolOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closePrintBol();
	              },
	              title: printBolTitle
	            },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'centerStyle' },
	              this.renderAddresses()
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { className: 'button-toolbar-center' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  onClick: function onClick() {
	                    _this68.props.printBolByFba(_this68.state.bolAddressFBA);
	                  },
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Print' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogStyle,
	              isVisible: this.state.confirmQuoteOpen,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closeConfirmQuote();
	              },
	              title: quoteTitle
	            },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'centerStyle' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_assign_customer' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'centerStyle' },
	              _react2.default.createElement(
	                'div',
	                { style: { width: "350px" } },
	                _react2.default.createElement(_reduxForm.Field, {
	                  name: 'hmmCustomer',
	                  placeholder: _react2.default.createElement(
	                    'span',
	                    { style: { fontStyle: "normal" } },
	                    this.state.quoteSelectedCustomerPlaceholder
	                  ),
	                  component: _selection.SelectionWithProps,
	                  options: this.state.quoteCustomerOptions,
	                  onSelect: function onSelect(value) {
	                    _this68.onQuoteCustomerChange(value);
	                  }
	                })
	              )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'centerStyle' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_confirm_quote' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { className: 'button-toolbar-center' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  onClick: this.closeConfirmQuote,
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  onClick: function onClick() {
	                    _this68.onConfirmQuote();
	                  },
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogStyle,
	              isVisible: this.state.davisPOVisibility,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closeDavisPO();
	              },
	              title: davisPOTitle
	            },
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'centerStyle' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_po_to_so_dropship' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { className: 'button-toolbar-center' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  onClick: function onClick() {
	                    return _this68.closeDavisPO();
	                  },
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  onClick: function onClick() {
	                    return _this68.onConfirmDavisPO();
	                  },
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: createDialogStyle,
	              isVisible: this.state.pridePrintVisibility,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closePridePrint();
	              },
	              title: pridePrintTitle
	            },
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'centerStyle' },
	              _react2.default.createElement(
	                'h4',
	                { style: { paddingLeft: '15px', paddingRight: '15px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pride_msg_print_shipping' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { className: 'button-toolbar-center' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  onClick: function onClick() {
	                    return _this68.closePridePrint();
	                  },
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  onClick: function onClick() {
	                    return _this68.onConfirmPridePrint();
	                  },
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'continue' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: dlMODAL,
	              isVisible: this.state.openDownloadModalVisibility,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closeDownloadModal();
	              },
	              title: dlTITLE
	            },
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'centerStyle' },
	              _react2.default.createElement(
	                'h4',
	                { style: { paddingLeft: '15px', paddingRight: '15px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'file_is_ready_to_download' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { className: 'button-toolbar-center' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  href: this.state.openDownloadModalUrl,
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'download' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  onClick: function onClick() {
	                    return _this68.closeDownloadModal();
	                  },
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: xpoMODAL,
	              isVisible: this.state.xpoQuoteVisibility,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closeXPOModal();
	              },
	              title: "XPO Logistics Quote"
	            },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  'label',
	                  { style: { color: 'gray', fontSize: '14px' } },
	                  'Pricing Breakdown'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { fontSize: '14px', marginBottom: '15px' } },
	                  this.state.xpoString.rateQuote && 'Standard Quote for ' + this.state.xpoString.rateQuote.shipmentInfo.bill2Party.address.name
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(
	                  'label',
	                  { style: { color: 'gray', fontSize: '14px' } },
	                  'Quote Created'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { fontSize: '14px', marginBottom: '15px' } },
	                  this.state.xpoString.rateQuote && (0, _moment2.default)(this.state.xpoString.rateQuote.quoteCreateDate).format('MMM D, YYYY h:mm A') + ' PDT'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(
	                  'label',
	                  { style: { color: 'gray', fontSize: '14px' } },
	                  'Quote Confirmation #'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { fontSize: '14px', marginBottom: '15px' } },
	                  this.state.xpoString.rateQuote && this.state.xpoString.rateQuote.confirmationNbr
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(
	                  'label',
	                  { style: { color: 'gray', fontSize: '14px' } },
	                  'Payment Terms'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { fontSize: '14px', marginBottom: '15px' } },
	                  this.state.xpoString.rateQuote && this.state.xpoString.rateQuote.shipmentInfo.paymentTermCd
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(
	                  'label',
	                  { style: { color: 'gray', fontSize: '14px' } },
	                  'Transit Days'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { fontSize: '14px', marginBottom: '15px' } },
	                  this.state.xpoString.transitTime && this.state.xpoString.transitTime.transitDays
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(
	                  'label',
	                  { style: { color: 'gray', fontSize: '14px' } },
	                  'From'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { fontSize: '14px', marginBottom: '15px' } },
	                  this.state.xpoString.rateQuote && this.state.xpoString.rateQuote.shipmentInfo.shipper.address.postalCd + ' ' + this.state.xpoString.rateQuote.shipmentInfo.shipper.address.stateCd + ' (' + this.state.xpoString.rateQuote.shipmentInfo.shipper.address.countryCd + ')'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(
	                  'label',
	                  { style: { color: 'gray', fontSize: '14px' } },
	                  'To'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { fontSize: '14px', marginBottom: '15px' } },
	                  this.state.xpoString.rateQuote && this.state.xpoString.rateQuote.shipmentInfo.consignee.address.postalCd + ' ' + this.state.xpoString.rateQuote.shipmentInfo.consignee.address.stateCd + ' (' + this.state.xpoString.rateQuote.shipmentInfo.consignee.address.countryCd + ')'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(
	                  'label',
	                  { style: { color: 'gray', fontSize: '14px' } },
	                  'Shipping Date'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { fontSize: '14px', marginBottom: '15px' } },
	                  this.state.xpoString.rateQuote && (0, _moment2.default)(this.state.xpoString.rateQuote.shipmentInfo.shipmentDate).format('MMM Do, YYYY')
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(
	                  'label',
	                  { style: { color: 'gray', fontSize: '14px' } },
	                  'Estimated Delivery'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { fontSize: '14px', marginBottom: '15px' } },
	                  this.state.xpoString.transitTime && (0, _moment2.default)(this.state.xpoString.transitTime.estdDlvrDate).format('MMM Do, YYYY')
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 2 },
	                _react2.default.createElement(
	                  'label',
	                  { style: { color: 'gray', fontSize: '14px' } },
	                  'Class'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { fontSize: '14px', marginBottom: '15px' } },
	                  this.state.xpoString.rateQuote && this.state.xpoString.rateQuote.shipmentInfo.commodity[0].nmfcClass
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 1 },
	                _react2.default.createElement(
	                  'label',
	                  { style: { color: 'gray', fontSize: '14px' } },
	                  'Units'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { fontSize: '14px', marginBottom: '15px' } },
	                  this.state.xpoString.rateQuote && this.state.xpoString.rateQuote.shipmentInfo.commodity[0].pieceCnt
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 2 },
	                _react2.default.createElement(
	                  'label',
	                  { style: { color: 'gray', fontSize: '14px' } },
	                  'Length(in)'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { fontSize: '14px', marginBottom: '15px' } },
	                  this.state.xpoString.rateQuote && this.state.xpoString.rateQuote.shipmentInfo.commodity[0].dimensions.length
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 2 },
	                _react2.default.createElement(
	                  'label',
	                  { style: { color: 'gray', fontSize: '14px' } },
	                  'Width(in)'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { fontSize: '14px', marginBottom: '15px' } },
	                  this.state.xpoString.rateQuote && this.state.xpoString.rateQuote.shipmentInfo.commodity[0].dimensions.width
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 2 },
	                _react2.default.createElement(
	                  'label',
	                  { style: { color: 'gray', fontSize: '14px' } },
	                  'Height(in)'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { fontSize: '14px', marginBottom: '15px' } },
	                  this.state.xpoString.rateQuote && this.state.xpoString.rateQuote.shipmentInfo.commodity[0].dimensions.height
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 2 },
	                _react2.default.createElement(
	                  'label',
	                  { style: { color: 'gray', fontSize: '14px' } },
	                  'Weight(lbs)'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { fontSize: '14px', marginBottom: '15px' } },
	                  this.state.xpoString.rateQuote && this.state.xpoString.rateQuote.shipmentInfo.commodity[0].grossWeight.weight
	                )
	              ),
	              _react2.default.createElement(_reactBootstrap.Col, { xs: 1 })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  'div',
	                  { style: { fontSize: '18px', fontWeight: 'bold', marginBottom: '15px', marginTop: '10px' } },
	                  'Total Net Charge:  $',
	                  this.state.xpoString.rateQuote && this.state.xpoString.rateQuote.totCharge[0].amt
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  'div',
	                  { style: { fontSize: '12px', marginBottom: '15px', color: 'gray' } },
	                  this.state.xpoString.rateQuote && this.state.xpoString.rateQuote.shipmentInfo.comment
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { className: 'button-toolbar-center' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  onClick: function onClick() {
	                    return _this68.closeXPOModal();
	                  },
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'close' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: pickupMODAL,
	              isVisible: this.state.pickupVisibility,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closePickupModal();
	              },
	              title: "Pickup Info"
	            },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'pre',
	                { style: { width: "650px", overflowY: "scroll", height: "500px" } },
	                this.state.pickupString
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { className: 'button-toolbar-center' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  onClick: function onClick() {
	                    return _this68.closePickupModal();
	                  },
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'close' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: pickupSelectionMODAL,
	              isVisible: this.state.pickupSelectionVisibility,
	              onCloseClicked: function onCloseClicked() {
	                _this68.closePickupSelectionModal();
	              },
	              title: "Pickup Dates"
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'centerStyle' },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { style: { marginBottom: '10px' } },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 6 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pickup_date' })
	                  )
	                ),
	                (0, _GenericDatePicker2.default)({
	                  setDate: this.setPickupDate,
	                  selectedDate: this.state.xpoPickupDate,
	                  onChange: function onChange(e) {
	                    _this68.setPickupDate(e);
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { style: { marginBottom: '10px' } },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 6 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ready_date' })
	                  )
	                ),
	                (0, _GenericDatePicker2.default)({
	                  setDate: this.setReadyDate,
	                  selectedDate: this.state.xpoReadyDate,
	                  onChange: function onChange(e) {
	                    _this68.setReadyDate(e);
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { style: { marginBottom: '10px' } },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 6 },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'close_date' })
	                  )
	                ),
	                (0, _GenericDatePicker2.default)({
	                  setDate: this.setCloseDate,
	                  selectedDate: this.state.xpoCloseDate,
	                  onChange: function onChange(e) {
	                    _this68.setCloseDate(e);
	                  }
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              { className: 'button-toolbar-center', style: { marginTop: '20px' } },
	              _react2.default.createElement(_SpinnerButton2.default, {
	                bsStyle: 'success',
	                type: 'button',
	                className: 'print-btn',
	                loading: this.state.pickupLoading
	                // disabled={
	                //   selectedRows.length !== 1
	                // }
	                , onClick: function onClick() {
	                  _this68.confirmPostPickup();
	                },
	                translation: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	              }),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  onClick: function onClick() {
	                    return _this68.closePickupSelectionModal();
	                  },
	                  type: 'button'
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'close' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: DriverListModalStyle,
	              isVisible: this.state.driverListModalVisibility,
	              onCloseClicked: this.setDriverListModalVisibility,
	              title: "Assign MSOs to Driver"
	            },
	            _react2.default.createElement(DriverListModal, {
	              assigningInboundDriver: this.state.assigningInboundDriver,
	              assigningOutboundDriver: this.state.assigningOutboundDriver,
	              selectedOrders: this.state.salesOrders.selectedRows || [],
	              handleSuccess: this.handleAssignSOToDriverSuccess
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: DriverListModalStyle,
	              isVisible: this.state.isaEditModalVisibility,
	              onCloseClicked: this.setISAEditModalVisibility,
	              title: "isa number update"
	            },
	            _react2.default.createElement(ISAEditModal, {
	              selectedSalesOrder: this.state.salesOrders.selectedRows[0],
	              handleISANoUpdateSuccess: this.handleISANoUpdateSuccess
	            })
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: DriverListModalStyle,
	              isVisible: this.state.ctnEditModalVisibility,
	              onCloseClicked: this.setCTNEditModalVisibility,
	              title: "ctn number update"
	            },
	            _react2.default.createElement(CTNEditModal, {
	              selectedSalesOrder: this.state.salesOrders.selectedRows[0],
	              handleCTNNoUpdateSuccess: this.handleCTNNoUpdateSuccess
	            })
	          ),
	          _react2.default.createElement(DeliveryTimeChange, {
	            isVisible: this.state.deliveryTimeSelectVisible,
	            setModalVisibility: this.setDeliveryTimeSelectModalVisibility,
	            selectedRows: this.state.salesOrders.selectedRows,
	            onSuccess: function onSuccess() {
	              _this68.setDeliveryTimeSelectModalVisibility();
	              _this68.refreshSOList();
	            }
	          }),
	          _react2.default.createElement(PickupTimeChange, {
	            isVisible: this.state.pickupTimeSelectVisible,
	            setModalVisibility: this.setPickupTimeSelectModalVisibility,
	            selectedRows: this.state.salesOrders.selectedRows,
	            onSuccess: function onSuccess() {
	              _this68.setPickupTimeSelectModalVisibility();
	              _this68.refreshSOList();
	            }
	          }),
	          _react2.default.createElement(ExcelUploadOption, {
	            isVisible: this.state.isExcelUploadOptionVisible,
	            setModalVisibility: this.setTNExcelOptionModalVisibility,
	            onSuccess: function onSuccess() {
	              _this68.refreshSOList();
	              _this68.setTNExcelOptionModalVisibility();
	            }
	          }),
	          _react2.default.createElement(_EmailContentModal2.default, {
	            visible: this.state.emailContentModalVisibility,
	            subject: this.state.emailSubjectTemplate,
	            content: this.state.emailContentTemplate,
	            onConfirm: this.handleEmailContentConfirm,
	            onClose: this.handleEmailContentClose,
	            selectedRows: this.state.salesOrders ? this.state.salesOrders.selectedRows : [],
	            source: "SO"
	          }),
	          _react2.default.createElement(LabelPrintModal, {
	            isVisible: this.state.isLabelPrintModalVisible,
	            salesOrders: this.state.salesOrders,
	            setModalVisibility: this.setLabelPrintModalVisibility,
	            printPickingListPartial: this.props.printPickingListPartial
	          }),
	          _react2.default.createElement(ShippingRateModal, {
	            isVisible: this.state.isShipingRateVisible,
	            setModalVisibility: this.setShippingRateVisibility,
	            salesOrders: this.state.salesOrders,
	            handleTeapplixPrintClick: this.handleTeapplixPrintClick
	          })
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return SalesOrder;
	}(_react.Component);
	
	SalesOrder.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = SalesOrder;
	exports.default = _default;
	;
	
	var _temp3 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(DriverListModal, 'DriverListModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(ISAEditModal, 'ISAEditModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(CTNEditModal, 'CTNEditModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(LocationChange, 'LocationChange', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(InboundDateChange, 'InboundDateChange', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(DeliveryTimeChange, 'DeliveryTimeChange', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(PickupTimeChange, 'PickupTimeChange', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(ExcelUploadOption, 'ExcelUploadOption', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(LabelPrintModal, 'LabelPrintModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(ShippingRateModal, 'ShippingRateModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isMyuMyu, 'isMyuMyu', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isCalco, 'isCalco', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isHMM, 'isHMM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isAFG, 'isAFG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isMAG, 'isMAG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isWecom, 'isWecom', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isCO, 'isCO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isJML, 'isJML', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isSY, 'isSY', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isAFM, 'isAFM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isTN, 'isTN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isABC, 'isABC', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isUSPride, 'isUSPride', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isChinaTown, 'isChinaTown', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isDSQ, 'isDSQ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isWIZ, 'isWIZ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isGV, 'isGV', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isFJ, 'isFJ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isJTB, 'isJTB', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isFIT, 'isFIT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isNBT, 'isNBT', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isKM, 'isKM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isTQ, 'isTQ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isOCM, 'isOCM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isATL, 'isATL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isRS, 'isRS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isKDW, 'isKDW', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isABCFF, 'isABCFF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isYI, 'isYI', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isFBD, 'isFBD', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isEZone, 'isEZone', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isWUFS, 'isWUFS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isSW, 'isSW', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isCS, 'isCS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isLO, 'isLO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isAmzey, 'isAmzey', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isAN, 'isAN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isAPO, 'isAPO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(SalesOrder, 'SalesOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesOrders.jsx');
	}();

	;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _cashFormatter = __webpack_require__(31);
	
	var _cashFormatter2 = _interopRequireDefault(_cashFormatter);
	
	var _cleanDates = __webpack_require__(22);
	
	var _constants = __webpack_require__(11);
	
	var _customizableDateFilterRadios = __webpack_require__(268);
	
	var _customizableDateFilterRadios2 = _interopRequireDefault(_customizableDateFilterRadios);
	
	var _dateFilterRadios = __webpack_require__(49);
	
	var _dateFilterRadios2 = _interopRequireDefault(_dateFilterRadios);
	
	var _dateFormat = __webpack_require__(39);
	
	var _genericRadioFilter = __webpack_require__(50);
	
	var _genericRadioFilter2 = _interopRequireDefault(_genericRadioFilter);
	
	var _inputField = __webpack_require__(16);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _selection = __webpack_require__(21);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _GenericProductSuggest = __webpack_require__(51);
	
	var _GenericProductSuggest2 = _interopRequireDefault(_GenericProductSuggest);
	
	var _TypeRadios = __webpack_require__(57);
	
	var _TypeRadios2 = _interopRequireDefault(_TypeRadios);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  titleLabel: {
	    width: '50px',
	    paddingTop: '4px',
	    fontWeight: 'bold'
	  },
	  titleField: {
	    width: '100px',
	    marginRight: '10px'
	  },
	  titleLabel2: {
	    width: '70px',
	    paddingTop: '4px',
	    fontWeight: 'bold'
	  },
	  col: {
	    flexDirection: 'column'
	    // marginTop: 10,
	  },
	  box: {
	    height: 15,
	    width: 30,
	    marginRight: 5
	  }
	};
	var isDev = _root_url.ROOT_API_URL === 'https://dev-scm.truckxi.com/api/';
	var isAFM = _root_url.ROOT_API_URL === "https://afm-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://afm-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://afmstage-scm.truckxi.com/api/";
	var isFung = _root_url.ROOT_API_URL === 'https://fung-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://fung-scm.truckxi.com/api/';
	var isOCM = _root_url.ROOT_API_URL === 'https://ocm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ocm-scm.truckxi.com/api/';
	var isAN = _root_url.ROOT_API_URL === 'https://asian-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://asian-scm.truckxi.com/api/';
	var isATL = _root_url.ROOT_API_URL === 'https://alton-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://alton-scm.truckxi.com/api/';
	var isChinaTown = _root_url.ROOT_API_URL === 'https://erp.chinatown-supermarket.com/api/' || _root_url.ROOT_URL === 'https://erp.chinatown-supermarket.com/api/';
	
	var legendData = [{
	  key: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'legend_inventory_stop_sale' }),
	  value: 'rgb(255, 175, 175)',
	  width: 6
	}, {
	  key: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'legend_inventory_over_stock' }),
	  value: 'rgb(144, 202, 249)',
	  width: 12
	}, {
	  key: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'legend_inventory_warning_stock' }),
	  value: 'rgb(132, 238, 139)',
	  width: 12
	}, {
	  key: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'legend_inventory_danger_stock' }),
	  value: 'rgb(240, 240, 10)',
	  width: 12
	}, {
	  key: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'legend_inventory_half_stock' }),
	  value: 'rgb(244, 67, 54)',
	  width: 12
	}];
	
	var getBackgroundColor = function getBackgroundColor(stockLevel) {
	  var color = 'transparent';
	  if (stockLevel === 'over_stock') color = 'rgb(144, 202, 249)';else if (stockLevel === 'in_stock') color = 'rgb(132, 238, 139)';else if (stockLevel === 'low_stock') color = 'rgb(240, 240, 10)';else if (stockLevel === 'danger_stock') color = 'rgb(244, 67, 54)';else if (stockLevel === 'stopsale') color = 'rgb(255, 175, 175)';
	  return color;
	};
	
	var SalesPerformance = function (_Component) {
	  _inherits(SalesPerformance, _Component);
	
	  function SalesPerformance() {
	    _classCallCheck(this, SalesPerformance);
	
	    var _this = _possibleConstructorReturn(this, (SalesPerformance.__proto__ || Object.getPrototypeOf(SalesPerformance)).call(this));
	
	    _this.handleCustomerToDate = function (e) {
	      if (e < _this.state.users.FromDate) {
	        return;
	      }
	      _this.setState(function (prevState) {
	        return {
	          users: _extends({}, prevState.users, {
	            ToDate: e
	          })
	        };
	      });
	    };
	
	    _this.handleCustomerFromDate = function (e) {
	      if (e > _this.state.users.ToDate) {
	        return;
	      }
	      _this.setState(function (prevState) {
	        return {
	          users: _extends({}, prevState.users, {
	            FromDate: e
	          })
	        };
	      });
	    };
	
	    _this.setToDate = function (e) {
	      if (e < _this.state.FromDate) {
	        return;
	      }
	      _this.setState({ ToDate: e });
	    };
	
	    _this.setFromDate = function (e) {
	      if (e > _this.state.ToDate) {
	        return;
	      }
	      _this.setState({ FromDate: e });
	    };
	
	    _this.setToRangeSearch = function () {
	      _this.setState({ Days: -1 });
	    };
	
	    _this.mergeMonthAndSaleData = function () {
	      var months = _this.state.users.months;
	
	      var rowCopy = _this.state.users.rows.slice();
	      rowCopy.map(function (row) {
	        months.map(function (month) {
	          if (!row.hasOwnProperty(month)) {
	            row[month] = 0;
	          }
	        });
	      });
	      _this.setState(function (prevState) {
	        return {
	          users: _extends({}, prevState, {
	            rows: rowCopy
	          })
	        };
	      }, function () {
	        _this.handleUserPerformanceShape();
	      });
	    };
	
	    _this.handleSalesTypeFilterChange = function (SalesType) {
	      var productNum = _this.state.filterProductID;
	      var seller = _this.props.Seller;
	      if (_this.props.Seller) {
	        seller = _this.props.Seller.value;
	      }
	      var customer = _this.props.Customer;
	      if (_this.props.Customer) {
	        customer = _this.props.Customer.value;
	      }
	      var group = _this.state.currentGroup;
	      var category = _this.state.currentCategory;
	      if (group === -1 && category === -1) {
	        group = null;
	        category = null;
	      } else if (category === -1) {
	        category = null;
	      } else if (category) {
	        group = null;
	      }
	      _this.setState({ SalesType: SalesType }, function () {
	        _this.props.fetchSalesPerformanceByFilter(_this.state.limit, SalesType || 'posorder', _this.state.Days || 1, _this.state.FromDate, _this.state.ToDate, 'show', productNum, group, category, _this.state.hide, seller, customer);
	      });
	    };
	
	    _this.handleOptionChange = function (changeEvent) {
	      _this.setState({ productSearchType: changeEvent.target.value });
	    };
	
	    _this.renderShowDetails = function () {
	      return !_this.state.filteredByItem ? _react2.default.createElement(
	        'div',
	        { style: { marginTop: '3px' } },
	        _react2.default.createElement(
	          'label',
	          null,
	          _react2.default.createElement('input', {
	            style: { 'font-size': '50px', zoom: '2', marginRight: '2px' },
	            type: 'checkbox',
	            value: 'showdetails',
	            checked: _this.state.hide,
	            onClick: _this.handleShowDetailsChange
	          }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'hide_details' })
	        )
	      ) : _react2.default.createElement(
	        'div',
	        { style: { marginTop: '3px' } },
	        _react2.default.createElement(
	          'label',
	          null,
	          _react2.default.createElement('input', {
	            style: { 'font-size': '50px', zoom: '2', marginRight: '2px' },
	            type: 'checkbox',
	            value: 'showdetails',
	            disabled: true,
	            checked: _this.state.hide,
	            onClick: _this.handleShowDetailsChange
	          }),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'hide_details' })
	        )
	      );
	    };
	
	    _this.handleShowDetailsChange = function () {
	      _this.setState({ hide: !_this.state.hide }, function () {
	        _this.fetchSalesPerformance(_this.state.Days || 1);
	      });
	    };
	
	    _this.fetchUserPerformance = function (currentDays) {
	      var allDays = void 0;
	      _this.setState(function (prevState) {
	        return {
	          columns: [],
	          userTimeSelection: currentDays,
	          users: {
	            rows: [],
	            months: [],
	            list: []
	          }
	        };
	      }, function () {
	        var Days = void 0;
	        allDays = (0, _cleanDates.getDateRangeBetweenDates)(currentDays);
	        Days = allDays.days.toString();
	        var fromDate = '1900-01-01';
	        var toDate = '3000-01-01';
	        if (_this.state.userFromDate) {
	          fromDate = _this.formatDate(_this.state.userFromDate);
	        }
	        if (_this.state.userToDate) {
	          toDate = _this.formatDate(_this.state.userToDate);
	        }
	        var User = _this.props.User;
	
	        if (allDays.lastMonth === false) {
	          if (User) {
	            var id = User.value;
	            if (Days === '-1' || Days === -1) {
	              _this.setState(function (prevState) {
	                return _extends({}, prevState, {
	                  userDays: Days,
	                  userTimeSelection: currentDays
	                });
	              }, function () {
	                _this.props.fetchUserPerformanceByFilter(fromDate, toDate, id, false, Days, false);
	              });
	            } else {
	              _this.setState(function (prevState) {
	                return _extends({}, prevState, {
	                  userDays: Days,
	                  userFromDate: undefined,
	                  userToDate: undefined
	                });
	              }, function () {
	                _this.props.fetchUserPerformanceByFilter(fromDate, toDate, id, false, Days, false);
	              });
	            }
	          } else {
	            alert('Please select a user.');
	          }
	        } else {
	          var lastMonth = allDays.lastMonth;
	          if (User) {
	            var _id = User.value;
	            if (Days.days === '-1' || Days.days === -1) {
	              _this.setState(function (prevState) {
	                return _extends({}, prevState, {
	                  userDays: Days,
	                  userTimeSelection: currentDays
	                });
	              }, function () {
	                _this.props.fetchUserPerformanceByFilter(fromDate, toDate, _id, false, Days, lastMonth);
	              });
	            } else {
	              _this.setState(function (prevState) {
	                return _extends({}, prevState, {
	                  userDays: Days,
	                  userFromDate: undefined,
	                  userToDate: undefined
	                });
	              }, function () {
	                _this.props.fetchUserPerformanceByFilter(fromDate, toDate, _id, false, Days, lastMonth);
	              });
	            }
	          } else {
	            alert('Please select a user.');
	          }
	        }
	      });
	    };
	
	    _this.handleFetchSalesPerformanceByProduct = function (ProductNum) {
	      var fromDate = '1900-01-01';
	      var toDate = '3000-01-01';
	      if (_this.state.FromDate) {
	        fromDate = _this.formatDate(_this.state.FromDate);
	      }
	      if (_this.state.ToDate) {
	        toDate = _this.formatDate(_this.state.ToDate);
	      }
	      var SalesType = _this.state.SalesType;
	      var seller = _this.props.Seller;
	      if (_this.props.Seller) {
	        seller = _this.props.Seller.value;
	      }
	      var customer = _this.props.Customer;
	      if (_this.props.Customer) {
	        customer = _this.props.Customer.value;
	      }
	      var group = _this.state.currentGroup;
	      var category = _this.state.currentCategory;
	      if (group === -1 && category === -1) {
	        group = null;
	        category = null;
	      } else if (category === -1) {
	        category = null;
	      } else if (category) {
	        group = null;
	      }
	      _this.setState({ filteredByItem: true, filterProductID: ProductNum, currentGroup: -1 });
	      _this.props.fetchSalesPerformanceByFilter(_this.state.limit, SalesType || 'posorder', _this.state.Days, fromDate, toDate, 'show', ProductNum, group, category, _this.state.hide, seller, customer);
	    };
	
	    _this.handleUserPerformanceShape = function () {
	      var rows = _this.state.users.rows;
	
	      var copiedRow = rows.slice();
	      var dates = [];
	      var newObj = {};
	      Object.keys(copiedRow[0]).map(function (item) {
	        if (item.includes('-')) {
	          dates.push(item);
	        } else {
	          newObj[item] = undefined;
	        }
	      });
	      var sortedArray = _this.handleDateShape(dates);
	      sortedArray.map(function (year) {
	        if (!Object.keys(newObj).includes(year)) {
	          newObj[year] = 0;
	        }
	      });
	      _this.finishInjectingObjectKeys(newObj);
	    };
	
	    _this.handleDateShape = function (dates) {
	      var sorted = dates.sort(function (a, b) {
	        var dateA = a.split('-').join();
	        var dateB = b.split('-').join();
	        return dateA < dateB ? -1 : dateA > dateB ? 1 : 0;
	      });
	      return sorted;
	    };
	
	    _this.finishInjectingObjectKeys = function (obj) {
	      var newRows = [];
	      var copiedRows = _this.state.users.rows.slice();
	      copiedRows.map(function (row) {
	        var clonedObjectZero = _.cloneDeep(obj);
	        for (var key in row) {
	          clonedObjectZero[key] = row[key];
	        }
	        newRows.push(clonedObjectZero);
	      });
	      _this.setState(function (prevState) {
	        return {
	          users: _extends({}, prevState, {
	            rows: newRows
	          })
	        };
	      }, function () {
	        _this.generateColumns();
	      });
	    };
	
	    _this.generateColumns = function () {
	      var columns = _this.state.columns.slice();
	      var copiedRows = _this.state.users.rows.slice();
	      var storage = [];
	      copiedRows.map(function (row) {
	        for (var property in row) {
	          var columnObject = {
	            key: Math.random(),
	            name: undefined,
	            resizable: true,
	            width: 120,
	            sortable: true,
	            filterable: true
	          };
	          if (!columnObject.name) {
	            if (!storage.includes(property)) {
	              if (property === 'Customer Name') {
	                columnObject.width = 200;
	              }
	              if (property.slice(8, property.length) === 'Margin') {
	                columnObject.width = 135;
	              }
	              columnObject.key = property;
	              columnObject.name = property;
	              storage.push(property);
	            }
	            if (typeof columnObject.key !== 'number') {
	              columns.push(columnObject);
	            }
	          }
	        }
	      });
	      _this.setState({
	        columns: columns
	      });
	    };
	
	    _this.spIFrameIsLoaded = function () {
	      if (!_this.state.spPdfFrameLoaded) {
	        var pdfFrame = window.frames.spPDF;
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this.setState({ spPdfFrameLoaded: true });
	      }
	    };
	
	    _this.renderLegend = function () {
	      if (!(_root_url.isEcity || _root_url.isLucky88)) {
	        return;
	      }
	      var legendItem = function legendItem(elem) {
	        return _react2.default.createElement(
	          'div',
	          { style: { display: 'flex', flexDirection: 'row' } },
	          _react2.default.createElement('p', { style: _extends({ backgroundColor: elem.value }, styles.box) }),
	          _react2.default.createElement(
	            'p',
	            { style: { fontSize: 12 } },
	            elem.key
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        { style: { padding: '16px' } },
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { tyle: styles.col },
	          legendData.map(function (elem, i) {
	            return _react2.default.createElement(
	              _reactBootstrap.Row,
	              { marginBottom: 1, key: i },
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                null,
	                legendItem(elem)
	              )
	            );
	          })
	        )
	      );
	    };
	
	    _this.sortUsers = function (newUsers) {
	      if (newUsers.length) {
	        var users = newUsers.sort(function (a, b) {
	          if (a.username.toUpperCase() < b.username.toUpperCase()) {
	            return -1;
	          } else if (a.username.toUpperCase() > b.username.toUpperCase()) {
	            return 1;
	          }
	          return 0;
	        });
	        return users;
	      }
	    };
	
	    _this.handleUserSelection = function () {
	      var users = [];
	      _this.props.users.map(function (user) {
	        users.push({ value: user.BaseUser_id, label: user.username });
	      });
	      return users;
	    };
	
	    _this.userSetToDate = function (e) {
	      if (e < _this.state.userFromDate) {
	        return;
	      }
	      _this.setState({ userToDate: e });
	    };
	
	    _this.userSetFromDate = function (e) {
	      _this.setState({ userFromDate: e });
	    };
	
	    _this.userSetToRangeSearch = function () {
	      _this.setState({ userDays: -1, userTimeSelection: -1 });
	    };
	
	    _this.handleTabSelect = function (key) {
	      _this.setState({
	        tabsKey: key
	      });
	    };
	
	    _this.renderCustomersTable = function () {
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this.state.users);
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIndex) {
	        var rows = getRows();
	        return rows[rowIndex];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this.state.users, {
	          sortColumn: sortColumn,
	          sortDirection: sortDirection
	        });
	        _this.setState({ state: state });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this.state.byProduct.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        _this.setState({
	          users: {
	            filters: newFilters,
	            rows: _this.state.users.rows
	          }
	        });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        _this.setState({
	          users: {
	            filters: {},
	            rows: []
	          }
	        });
	      };
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        { style: { paddingTop: '20px' } },
	        _this.state.columns.length > 0 ? _react2.default.createElement(
	          _reactBootstrap.Col,
	          { md: 12 },
	          _react2.default.createElement(
	            'div',
	            { id: 'UserManagement-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'user_id',
	              enableCellSelect: true,
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              columns: _this.state.columns,
	              rowHeight: 25,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: _this.state.tableHeight,
	              onRowUpdated: _this.handleRowUpdated,
	              onAddFilter: handleFilterChange
	            })
	          )
	        ) : _react2.default.createElement('div', null)
	      );
	    };
	
	    _this.state = {
	
	      spPdfFrameLoaded: true,
	
	      limit: 'MSO',
	      limitDisplay: 'MSO',
	
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.customersPage,
	      byProduct: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      users: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null,
	        ToDate: null,
	        FromDate: null,
	        selectedRows: [],
	        id: null,
	        months: [],
	        list: []
	      },
	      saleQTY: 0,
	      avgSalePrice: 0,
	      avgMarkupPct: 0,
	      sum: 0,
	      currentGroup: null,
	      currentCategory: null,
	      groupExpanded: false,
	      hide: false,
	      suggestValue: '',
	      productSearchType: 'ProductNum',
	      tabsKey: 'ProductPerformance',
	
	      // used for genericRadioFilter and DatePicker
	      SalesType: 'all',
	      Days: '1',
	      FromDate: undefined,
	      ToDate: undefined,
	      userFromDate: null,
	      userToDate: null,
	      userDays: null,
	      userTimeSelection: null,
	      columns: [],
	      Seller: undefined,
	      Customer: undefined
	    };
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.fetchSalesPerformance = _this.fetchSalesPerformance.bind(_this);
	    return _this;
	  }
	
	  _createClass(SalesPerformance, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      document.title = _root_url.companyCodeTitle;
	      this.props.setDefaultOfForm('Days', '1', 'salesPerformance');
	      this.props.setDefaultOfForm('userDays', '30', 'salesPerformance');
	      this.props.setDefaultOfForm('SalesType', 'all', 'salesPerformance');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.handleResize);
	      this.props.fetchBaseUsers();
	      this.props.fetchGroups();
	      this.props.fetchActiveCustomers();
	      this.props.setDefaultOfForm('Days', '1', 'salesPerformance');
	      this.props.setDefaultOfForm('userDays', '30', 'salesPerformance');
	      this.props.setDefaultOfForm('SalesType', 'all', 'salesPerformance');
	      this.props.setDefaultOfForm('Seller', null, 'salesPerformance');
	      this.props.setDefaultOfForm('Customer', null, 'salesPerformance');
	      this.props.fetchMobileUsers(0, 200, '', '', '', '');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (!nextProps.SalesType) {
	        this.props.setDefaultOfForm('SalesType', 'all', 'salesPerformance');
	      }
	      if (!nextProps.Days) {
	        this.props.setDefaultOfForm('Days', '1', 'salesPerformance');
	      }
	      if (!nextProps.userDays) {
	        this.props.setDefaultOfForm('userDays', '30', 'salesPerformance');
	      }
	      if (nextProps.salesPerformance && nextProps.salesPerformance != this.props.salesPerformance) {
	        var byProduct = _extends({}, this.state.byProduct, { rows: nextProps.salesPerformance.performance_lines });
	        var saleQTY = nextProps.salesPerformance.SaleQTY;
	        var avgSalePrice = nextProps.salesPerformance.AVGSalePrice;
	        var avgMarkupPct = nextProps.salesPerformance.AvgMarkupPct;
	        var sum = nextProps.salesPerformance.sum;
	        this.setState({
	          byProduct: byProduct, saleQTY: saleQTY, avgSalePrice: avgSalePrice, avgMarkupPct: avgMarkupPct, sum: sum, pageCounts: nextProps.salesPerformance.pages
	        });
	      }
	      if (nextProps.SalesType && nextProps.SalesType !== this.props.SalesType) {
	        var fromDate = '1900-01-01';
	        var toDate = '3000-01-01';
	        if (this.state.FromDate) {
	          fromDate = this.formatDate(this.state.FromDate);
	        }
	        if (this.state.ToDate) {
	          toDate = this.formatDate(this.state.ToDate);
	        }
	        var productNum = this.state.filterProductID;
	        var group = this.state.currentGroup;
	        var category = this.state.currentCategory;
	        if (group === -1 && category === -1) {
	          group = null;
	          category = null;
	        } else if (category === -1) {
	          category = null;
	        } else if (category) {
	          group = null;
	        }
	        var seller = this.props.Seller;
	        if (this.props.Seller) {
	          seller = this.props.Seller.value;
	        }
	        var customer = this.props.Customer;
	        if (this.props.Customer) {
	          customer = this.props.Customer.value;
	        }
	        this.props.fetchSalesPerformanceByFilter(this.state.limit, nextProps.SalesType || 'posorder', this.state.Days || 1, fromDate, toDate, 'show', productNum, group, category, this.state.hide, seller, customer);
	      }
	      if (nextProps.groups && nextProps.groups !== this.props.groups) {
	        var productGroup_id = nextProps.groups[0].ProductGroup_id;
	        var _fromDate = '1900-01-01';
	        var _toDate = '3000-01-01';
	        if (this.state.FromDate) {
	          _fromDate = this.formatDate(this.state.FromDate);
	        }
	        if (this.state.ToDate) {
	          _toDate = this.formatDate(this.state.ToDate);
	        }
	        this.setState({ currentGroup: productGroup_id });
	        var _seller = this.props.Seller;
	        if (this.props.Seller) {
	          _seller = this.props.Seller.value;
	        }
	        var _customer = this.props.Customer;
	        if (this.props.Customer) {
	          _customer = this.props.Customer.value;
	        }
	        this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days || 1, _fromDate, _toDate, 'show', null, productGroup_id, null, this.state.hide, _seller, _customer);
	      }
	      if (nextProps.FromDate && nextProps.FromDate !== this.state.FromDate || nextProps.ToDate && nextProps.ToDate !== this.state.ToDate) {
	        var _fromDate2 = '1900-01-01';
	        var _toDate2 = '3000-01-01';
	        if (nextProps.FromDate) {
	          _fromDate2 = this.formatDate(nextProps.FromDate);
	        }
	        if (nextProps.ToDate) {
	          _toDate2 = this.formatDate(nextProps.ToDate);
	        }
	        var _productNum = this.state.filterProductID;
	        var _seller2 = this.props.Seller;
	        if (this.props.Seller) {
	          _seller2 = this.props.Seller.value;
	        }
	        var _customer2 = this.props.Customer;
	        if (this.props.Customer) {
	          _customer2 = this.props.Customer.value;
	        }
	        var _group = this.state.currentGroup;
	        var _category = this.state.currentCategory;
	        if (_group === -1 && _category === -1) {
	          _group = null;
	          _category = null;
	        } else if (_category === -1) {
	          _category = null;
	        } else if (_category) {
	          _group = null;
	        }
	        this.props.fetchSalesPerformanceByFilter(this.state.limit, nextProps.SalesType || 'posorder', this.state.Days || 1, _fromDate2, _toDate2, 'show', _productNum, _group, _category, this.state.hide, _seller2, _customer2);
	      }
	
	      // when select seller
	      if (nextProps.Seller && nextProps.Seller !== this.props.Seller) {
	        var _seller3 = nextProps.Seller;
	        if (nextProps.Seller) {
	          _seller3 = nextProps.Seller.value;
	        }
	        var _customer3 = nextProps.Customer;
	        if (nextProps.Customer) {
	          _customer3 = nextProps.Customer.value;
	        }
	        var _group2 = this.state.currentGroup;
	        var _category2 = this.state.currentCategory;
	        if (_group2 === -1 && _category2 === -1) {
	          _group2 = null;
	          _category2 = null;
	        } else if (_category2 === -1) {
	          _category2 = null;
	        } else if (_category2) {
	          _group2 = null;
	        }
	        var _fromDate3 = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
	        var _toDate3 = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
	
	        var _productNum2 = this.state.filterProductID;
	        this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days || 1, _fromDate3, _toDate3, 'show', _productNum2, _group2, _category2, this.state.hide, _seller3, _customer3);
	      }
	
	      // when delete seller
	      if (this.props.Seller && nextProps.Seller == null) {
	        var _seller4 = nextProps.Seller;
	        var _fromDate4 = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
	        var _toDate4 = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
	        var _productNum3 = this.state.filterProductID;
	        var _group3 = this.state.currentGroup;
	        var _category3 = this.state.currentCategory;
	        if (_group3 === -1 && _category3 === -1) {
	          _group3 = null;
	          _category3 = null;
	        } else if (_category3 === -1) {
	          _category3 = null;
	        } else if (_category3) {
	          _group3 = null;
	        }
	        var _customer4 = nextProps.Customer;
	        if (nextProps.Customer) {
	          _customer4 = nextProps.Customer.value;
	        }
	        this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days || 1, _fromDate4, _toDate4, 'show', _productNum3, _group3, _category3, this.state.hide, _seller4, _customer4);
	      }
	
	      // when select customer
	      if (nextProps.Customer && nextProps.Customer !== this.props.Customer) {
	        var _seller5 = nextProps.Seller;
	        if (nextProps.Seller) {
	          _seller5 = nextProps.Seller.value;
	        }
	        var _customer5 = nextProps.Customer;
	        if (nextProps.Customer) {
	          _customer5 = nextProps.Customer.value;
	        }
	        var _group4 = this.state.currentGroup;
	        var _category4 = this.state.currentCategory;
	        if (_group4 === -1 && _category4 === -1) {
	          _group4 = null;
	          _category4 = null;
	        } else if (_category4 === -1) {
	          _category4 = null;
	        } else if (_category4) {
	          _group4 = null;
	        }
	        var _fromDate5 = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
	        var _toDate5 = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
	
	        var _productNum4 = this.state.filterProductID;
	
	        this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days || 1, _fromDate5, _toDate5, 'show', _productNum4, _group4, _category4, this.state.hide, _seller5, _customer5);
	      }
	
	      // when delete customer
	      if (this.props.Customer && nextProps.Customer == null) {
	        var _seller6 = nextProps.Seller;
	        if (nextProps.Seller) {
	          _seller6 = nextProps.Seller.value;
	        }
	        var _customer6 = nextProps.Customer;
	        var _fromDate6 = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
	        var _toDate6 = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
	        var _productNum5 = this.state.filterProductID;
	        var _group5 = this.state.currentGroup;
	        var _category5 = this.state.currentCategory;
	        if (_group5 === -1 && _category5 === -1) {
	          _group5 = null;
	          _category5 = null;
	        } else if (_category5 === -1) {
	          _category5 = null;
	        } else if (_category5) {
	          _group5 = null;
	        }
	        this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days || 1, _fromDate6, _toDate6, 'show', _productNum5, _group5, _category5, this.state.hide, _seller6, _customer6);
	      }
	
	      if (nextProps.userFromDate && nextProps.userFromDate !== this.state.userFromDate || nextProps.userFromDate && nextProps.userFromDate !== this.state.userFromDate) {
	        var User = this.props.User;
	
	        var Days = this.state.userDays;
	        var _fromDate7 = '1900-01-01';
	        var _toDate7 = '3000-01-01';
	        if (nextProps.userFromDate) {
	          _fromDate7 = this.formatDate(nextProps.userFromDate);
	        }
	        if (nextProps.userToDate) {
	          _toDate7 = this.formatDate(nextProps.userToDate);
	        }
	        if (User) {
	          var id = User.value;
	          if (Days === '-1' || Days === -1) {
	            this.setState(function (prevState) {
	              return _extends({}, prevState, {
	                userDays: Days,
	                columns: []
	              });
	            }, function () {
	              _this2.props.fetchUserPerformanceByFilter(_fromDate7, _toDate7, id, false, Days);
	            });
	          } else {
	            this.setState(function (prevState) {
	              return {
	                userDays: Days,
	                userFromDate: undefined,
	                userToDate: undefined,
	                columns: []
	              };
	            }, function () {
	              _this2.props.fetchUserPerformanceByFilter(_fromDate7, _toDate7, id, false, Days);
	            });
	          }
	        }
	      }
	
	      if (nextProps.users && nextProps.users !== this.props.users) {
	        var sortedUsers = this.sortUsers(nextProps.users);
	        this.setState({ users: { rows: sortedUsers } });
	      }
	
	      if (nextProps.userPerformanceData && nextProps.userPerformanceData !== this.props.userPerformanceData) {
	        (function () {
	          var userTableData = [];
	          var monthData = [];
	          for (var key in nextProps.userPerformanceData) {
	            if (key === 'rows') {
	              nextProps.userPerformanceData[key].map(function (sale) {
	                userTableData.push(sale);
	              });
	            }
	            if (key === 'months') {
	              nextProps.userPerformanceData[key].map(function (month) {
	                var profitMonth = month + ' Profit';
	                var marginMonth = month + ' Margin';
	                if (!monthData.includes(month)) {
	                  monthData.push(month);
	                }
	                if (!monthData.includes(profitMonth)) {
	                  monthData.push(profitMonth);
	                  monthData.push(marginMonth);
	                }
	              });
	            }
	          }
	          _this2.setState(function (prevState) {
	            return {
	              users: _extends({}, prevState, {
	                rows: userTableData,
	                months: monthData
	              }),
	              columns: []
	            };
	          }, function () {
	            _this2.mergeMonthAndSaleData();
	          });
	        })();
	      }
	      if (this.props.User !== nextProps.User) {
	        this.setState(function (prevState) {
	          return {
	            columns: [],
	            users: _extends({}, prevState, {
	              rows: [],
	              months: []
	            })
	          };
	        });
	      }
	
	      if (nextProps.spPDF && nextProps.spPDF !== this.props.spPDF) {
	        this.setState({ spPdfFrameLoaded: false });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState.spPdfFrameLoaded !== this.state.spPdfFrameLoaded && this.state.spPdfFrameLoaded === false) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var productGroup_id = this.state.currentGroup;
	      var productCategory_id = this.state.currentCategory;
	      var groups = document.getElementsByName('group');
	      var i = 0;
	      for (; i < groups.length; i++) {
	        if (groups[i].id !== 'g' + productGroup_id) {
	          groups[i].style.backgroundColor = null;
	        } else {
	          groups[i].style.backgroundColor = _constants.APP_COLORS['active-category-background-nav'];
	        }
	      }
	      var categories = document.getElementsByName('category');
	      i = 0;
	      if (categories) {
	        for (; i < categories.length; i++) {
	          if (categories[i].id !== 'c' + productCategory_id) {
	            categories[i].style.backgroundColor = null;
	          } else {
	            categories[i].style.backgroundColor = _constants.APP_COLORS['active-category-background-nav'];
	          }
	        }
	      }
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      var formattedDate = date.getFullYear() + '-';
	      formattedDate += date.getMonth() + 1 + '-';
	      if (date.getDate() < 10) {
	        formattedDate += '0' + date.getDate();
	      } else {
	        formattedDate += date.getDate();
	      }
	      return formattedDate;
	    }
	
	    // Used for radiofilter and date picker
	
	  }, {
	    key: 'handleResize',
	
	
	    // End used for radiofilter and date picker
	
	    value: function handleResize() {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.customersPage });
	    }
	  }, {
	    key: 'fetchSalesPerformance',
	    value: function fetchSalesPerformance(curDays, productSearch) {
	      var _this3 = this;
	
	      var Days = curDays.toString();
	      if (this.state.filteredByItem) {
	        if (Days === '-1' || Days === -1) {
	          this.setState({ Days: Days }, function () {
	            _this3.handleFetchSalesPerformanceByProduct(_this3.state.filterProductID);
	          });
	        } else {
	          this.setState({ Days: Days, FromDate: undefined, ToDate: undefined }, function () {
	            _this3.handleFetchSalesPerformanceByProduct(_this3.state.filterProductID);
	          });
	        }
	        return;
	      }
	      var fromDate = '1900-01-01';
	      var toDate = '3000-01-01';
	      if (this.state.FromDate) {
	        fromDate = this.formatDate(this.state.FromDate);
	      }
	      if (this.state.ToDate) {
	        toDate = this.formatDate(this.state.ToDate);
	      }
	      var SalesType = this.state.SalesType ? this.state.SalesType : 'all';
	      var productNum = this.props.ProductNum;
	      var seller = this.props.Seller;
	      if (this.props.Seller) {
	        seller = this.props.Seller.value;
	      }
	      var customer = this.props.Customer;
	      if (this.props.Customer) {
	        customer = this.props.Customer.value;
	      }
	      var group = this.state.currentGroup;
	      var category = this.state.currentCategory;
	      if (group === -1 && category === -1) {
	        group = null;
	        category = null;
	      } else if (category === -1) {
	        category = null;
	      } else if (category) {
	        group = null;
	      }
	      if (Days === '-1' || Days === -1) {
	        this.setState({ Days: Days }, function () {
	          _this3.props.fetchSalesPerformanceByFilter(_this3.state.limit, SalesType || 'posorder', curDays || _this3.state.Days, fromDate, toDate, 'show', productNum, group, category, _this3.state.hide, seller, customer);
	        });
	      } else {
	        this.setState({ Days: Days, FromDate: undefined, ToDate: undefined }, function () {
	          _this3.props.fetchSalesPerformanceByFilter(_this3.state.limit, SalesType || 'posorder', curDays || _this3.state.Days, fromDate, toDate, 'show', productNum, group, category, _this3.state.hide, seller, customer);
	        });
	      }
	    }
	  }, {
	    key: 'handleLimitChange',
	    value: function handleLimitChange(el) {
	      this.setState({ limit: el.value, limitDisplay: el.label });
	      // el.preventDefault();
	      this.state.limit = el.value;
	      this.state.limitDisplay = el.label;
	
	      var fromDate = '1900-01-01';
	      var toDate = '3000-01-01';
	      if (this.state.FromDate) {
	        fromDate = this.formatDate(this.state.FromDate);
	      }
	      if (this.state.ToDate) {
	        toDate = this.formatDate(this.state.ToDate);
	      }
	      var SalesType = this.props.SalesType;
	
	      var productNum = this.props.ProductNum;
	      var seller = this.props.Seller;
	      if (this.props.Seller) {
	        seller = this.props.Seller.value;
	      }
	      var customer = this.props.Customer;
	      if (this.props.Customer) {
	        customer = this.props.Customer.value;
	      }
	      var group = this.state.currentGroup;
	      var category = this.state.currentCategory;
	      if (group === -1 && category === -1) {
	        group = null;
	        category = null;
	      } else if (category === -1) {
	        category = null;
	      } else if (category) {
	        group = null;
	      }
	      this.props.fetchSalesPerformanceByFilter(this.state.limit, SalesType || 'posorder', this.state.Days, fromDate, toDate, 'show', productNum, group, category, this.state.hide, seller, customer);
	    }
	  }, {
	    key: 'printLALASP',
	    value: function printLALASP(curDays) {
	      var _this4 = this;
	
	      var Days = curDays.toString();
	
	      var fromDate = '1900-01-01';
	      var toDate = '3000-01-01';
	      if (this.state.FromDate) {
	        fromDate = this.formatDate(this.state.FromDate);
	      }
	      if (this.state.ToDate) {
	        toDate = this.formatDate(this.state.ToDate);
	      }
	
	      if (Days === '-1' || Days === -1) {
	        this.setState({ Days: Days }, function () {
	          _this4.props.printSP(curDays || _this4.state.Days, fromDate, toDate);
	        });
	      } else {
	        this.setState({ Days: Days, FromDate: undefined, ToDate: undefined }, function () {
	          _this4.props.printSP(curDays || _this4.state.Days, fromDate, toDate);
	        });
	      }
	    }
	  }, {
	    key: 'handleClickCategory',
	    value: function handleClickCategory(id) {
	      this.props.setDefaultOfForm('ProductNum', null, 'salesPerformance');
	      var fromDate = '1900-01-01';
	      var toDate = '3000-01-01';
	      if (this.state.FromDate) {
	        fromDate = this.formatDate(this.state.FromDate);
	      }
	      if (this.state.ToDate) {
	        toDate = this.formatDate(this.state.ToDate);
	      }
	      var productNum = null;
	      var seller = this.props.Seller;
	      if (this.props.Seller) {
	        seller = this.props.Seller.value;
	      }
	      var customer = this.props.Customer;
	      if (this.props.Customer) {
	        customer = this.props.Customer.value;
	      }
	      this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days, fromDate, toDate, 'show', productNum, null, id, this.state.hide, seller, customer);
	      this.setState({ currentCategory: id });
	    }
	  }, {
	    key: 'renderCategories',
	    value: function renderCategories(group_id) {
	      var _this5 = this;
	
	      if (!this.props.groupCategories) return;
	      var groupCategories = this.props.groupCategories;
	      if (this.state.currentGroup === group_id && this.state.groupExpanded) {
	        return groupCategories.map(function (category) {
	          return _react2.default.createElement(
	            'li',
	            { className: 'clickListLi', style: { color: _constants.APP_COLORS['sub-category-nav'], fontFamily: 'Arial' }, name: 'category', id: 'c' + category.ProductCategory_id, onClick: _this5.handleClickCategory.bind(_this5, category.ProductCategory_id) },
	            _react2.default.createElement(
	              'label',
	              { style: { fontWeight: 'bold' } },
	              category.CategoryNum
	            ),
	            ' ' + category.Description
	          );
	        });
	      }
	    }
	  }, {
	    key: 'handleClickGroup',
	    value: function handleClickGroup(group, id) {
	      this.props.setDefaultOfForm('ProductNum', null, 'salesPerformance');
	      var groupExpanded = this.state.groupExpanded;
	      var fromDate = '1900-01-01';
	      var toDate = '3000-01-01';
	      if (this.state.FromDate) {
	        fromDate = this.formatDate(this.state.FromDate);
	      }
	      if (this.state.ToDate) {
	        toDate = this.formatDate(this.state.ToDate);
	      }
	      var productNum = null;
	      var seller = this.props.Seller;
	      if (this.props.Seller) {
	        seller = this.props.Seller.value;
	      }
	      var customer = this.props.Customer;
	      if (this.props.Customer) {
	        customer = this.props.Customer.value;
	      }
	      if (group && this.state.currentGroup === group.ProductGroup_id) {
	        this.setState({ groupExpanded: !groupExpanded });
	        if (!groupExpanded) {
	          this.setState({ currentCategory: -1, filteredByItem: false, filterProductID: null, suggestValue: '' });
	          this.props.fetchSalesPerformanceByFilter(this.state.limit, this.props.SalesType || 'posorder', this.state.Days, fromDate, toDate, 'show', productNum, this.state.currentGroup, null, this.state.hide, seller, customer);
	          this.props.fetchGroupCategories(group.ProductGroup_id);
	        }
	      } else if (group) {
	        this.setState({ currentGroup: group.ProductGroup_id, groupExpanded: true, currentCategory: -1, filteredByItem: false, filterProductID: null, suggestValue: '' });
	        this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days, fromDate, toDate, 'show', productNum, group.ProductGroup_id, null, this.state.hide, seller, customer);
	        this.props.fetchGroupCategories(group.ProductGroup_id);
	      } else {
	        this.setState({ currentGroup: -1, currentCategory: -1, filteredByItem: false, filterProductID: null, suggestValue: '' });
	        this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days, fromDate, toDate, 'show', productNum, null, null, this.state.hide, seller, customer);
	      }
	    }
	  }, {
	    key: 'getUsers',
	
	
	    // sellers, users
	    value: function getUsers() {
	      var Users = [];
	      this.props.users.map(function (user) {
	        Users.push({ value: user.user_id, label: user.username });
	      });
	      return Users;
	    }
	  }, {
	    key: 'renderUsers',
	    value: function renderUsers() {
	      if (this.props.usersIsLoading) return _react2.default.createElement(_spinner2.default, null); // If group is loading, show a spinner.
	
	      var Users = this.getUsers();
	      return _react2.default.createElement(_reduxForm.Field, { name: 'Seller', component: _selection.Selection, options: Users });
	    }
	  }, {
	    key: 'renderSPIFrame',
	    value: function renderSPIFrame() {
	      //renderBolByFbaIFrame
	      if (this.props.spPDF) {
	        var file = window.URL.createObjectURL(this.props.spPDF);
	        return _react2.default.createElement('iframe', {
	          style: { display: "none" },
	          onLoad: this.spIFrameIsLoaded,
	          id: 'spPDF',
	          name: 'spPDF',
	          src: file
	        });
	      }
	    }
	
	    // customers
	
	  }, {
	    key: 'getCustomers',
	    value: function getCustomers() {
	      var Customers = [];
	      this.props.customers.map(function (customer) {
	        Customers.push({ value: customer.Customer_id, label: customer.Name });
	      });
	      return Customers;
	    }
	  }, {
	    key: 'renderCustomers',
	    value: function renderCustomers() {
	      if (this.props.customersIsLoading) return _react2.default.createElement(_spinner2.default, null); // If group is loading, show a spinner.
	      var Customers = this.getCustomers();
	      return _react2.default.createElement(_reduxForm.Field, { name: 'Customer', component: _selection.Selection, options: Customers });
	    }
	  }, {
	    key: 'renderGroups',
	    value: function renderGroups() {
	      var _this6 = this;
	
	      if (!this.props.groups) return;
	      var groups = this.props.groups;
	      return groups.map(function (group) {
	        var GroupNum = parseInt(group.GroupNum);
	        if (GroupNum < 10) GroupNum = '0' + GroupNum;
	        var description = 'Misc';
	        if (localStorage.getItem('lang') === 'ch') {
	          description = 'Description';
	        } else if (localStorage.getItem('lang') === 'en') {
	          description = 'Name';
	        }
	        return _react2.default.createElement(
	          _reactBootstrap.Panel,
	          { className: 'panelStyle' },
	          _react2.default.createElement(
	            'div',
	            { style: { color: _constants.APP_COLORS['category-nav'], fontFamily: 'Arial Black', cursor: 'pointer' }, name: 'group', id: 'g' + group.ProductGroup_id, onClick: _this6.handleClickGroup.bind(_this6, group, 'g' + group.ProductGroup_id) },
	            _react2.default.createElement(
	              'label',
	              { style: { fontWeight: 'bold' } },
	              GroupNum
	            ),
	            ' ',
	            ' ',
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: group[description] })
	          ),
	          _this6.renderCategories(group.ProductGroup_id)
	        );
	      });
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this7 = this;
	
	      if (this.props.salesPerformanceIsLoading && !this.props.salesPerformanceError) {
	        return _react2.default.createElement(
	          'div',
	          { id: 'spinner' },
	          _react2.default.createElement(_spinner2.default, null)
	        );
	      } else if (this.props.salesPerformanceError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.salesPerformanceError)
	          )
	        );
	      }
	
	      // Parameters of the react-data-grid
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this7.state.byProduct);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var byProduct = Object.assign({}, _this7.state.byProduct, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this7.setState({ byProduct: byProduct });
	      };
	
	      var totalFormatter = _react2.default.createClass({
	        displayName: 'totalFormatter',
	        render: function render() {
	          return this.props.dependentValues.Product_id__ProductType === 'Non-Fixed' ? _react2.default.createElement(
	            'span',
	            null,
	            this.props.dependentValues.TotalNetWeight
	          ) : _react2.default.createElement('span', null);
	        }
	      });
	
	      // filter helper functions
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this7.state.byProduct.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        _this7.setState({
	          byProduct: {
	            filters: newFilters,
	            rows: _this7.state.byProduct.rows
	          }
	        });
	      };
	
	      var onClearFilters = function onClearFilters() {
	        _this7.setState({
	          byProduct: {
	            filters: {},
	            rows: _this7.state.byProduct.rows
	          }
	        });
	      };
	
	      // Column difinition
	
	      var columns = [{
	        key: 'Product_id__ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true
	      }, {
	        key: 'Product_id__RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        filterable: true
	      }].concat(_toConsumableArray(isAFM || isATL ? [{
	        key: 'Product_id__Brand',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'brand' }),
	        resizable: true,
	        sortable: true,
	        width: 100
	      }] : []), [{
	        key: 'Product_id__Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_name' }),
	        resizable: true,
	        sortable: true,
	        width: 200,
	        filterable: true
	      }, {
	        key: 'Product_id__Description',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        width: 120,
	        filterable: true
	      }, {
	        key: 'Quantity',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true
	      }, {
	        key: 'TotalNetWeight',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	        resizable: true,
	        sortable: true,
	        width: 70,
	        formatter: totalFormatter,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        },
	        filterable: true
	      }, {
	        key: 'UnitPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        formatter: _cashFormatter2.default,
	        filterable: true
	      }, {
	        key: 'TotalPrice',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        formatter: _cashFormatter2.default,
	        filterable: true
	      }, {
	        key: 'CustomerNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_no' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'CustomerName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_name' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }, {
	        key: 'DeliverDate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delivered' }),
	        resizable: true,
	        sortable: true,
	        width: 90,
	        formatter: _dateFormat.DateFormatter,
	        filterable: true
	      }, {
	        key: 'OrderNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'invoice_no' }),
	        resizable: true,
	        sortable: true,
	        width: 100,
	        filterable: true
	      }], _toConsumableArray(isChinaTown ? [{
	        key: 'Sales_User_Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_creator' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }] : []), _toConsumableArray(isChinaTown ? [{
	        key: 'Creater_Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'si_creator' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }] : [{
	        key: 'Sales',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	        resizable: true,
	        sortable: true,
	        width: 60,
	        filterable: true
	      }]), [{
	        key: 'SalesInvoice_id__Notation',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'notation' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }]);
	
	      if (this.state.SalesType && this.state.SalesType === 'presale') {
	        var indexSalesInvoice = _.findIndex(columns, { key: 'OrderNum' });
	        var salesOrderNumColumn = {
	          key: 'OrderNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_no' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          filterable: true
	        };
	        columns.splice(indexSalesInvoice, 1, salesOrderNumColumn);
	      }
	
	      if (_root_url.isLO) {
	        var prodNoIndex = columns.findIndex(function (column) {
	          return column.key === 'Product_id__ProductNum';
	        });
	        if (prodNoIndex !== -1) {
	          columns.splice(prodNoIndex, 1);
	        }
	        var refNoIndex = columns.findIndex(function (column) {
	          return column.key === 'Product_id__RefNum';
	        });
	        if (refNoIndex !== -1) {
	          columns[refNoIndex].name = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'item_no' });
	          columns[refNoIndex].width = 120;
	        }
	        var prodNameIndex = columns.findIndex(function (column) {
	          return column.key === 'Product_id__Name';
	        });
	        if (prodNameIndex !== -1) {
	          columns[prodNameIndex].name = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'item_description' });
	          columns[prodNameIndex].width = 240;
	        }
	        var descriptionIndex = columns.findIndex(function (column) {
	          return column.key === 'Product_id__Description';
	        });
	        if (descriptionIndex !== -1) {
	          columns.splice(descriptionIndex, 1);
	        }
	      }
	
	      if (_root_url.isEcity || _root_url.isLucky88) {
	        var CustomerNumIndex = _.findIndex(columns, { key: 'CustomerNum' });
	        var purchaser = {
	          key: 'Purchaser_User',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'purchaser' }),
	          resizable: true,
	          sortable: true,
	          width: 120,
	          filterable: true
	        };
	        var maxStock = {
	          key: 'Product_id__MaxStockRange',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'max_stock' }),
	          resizable: true,
	          sortable: true,
	          width: 120,
	          filterable: true
	        };
	        var quantity = {
	          key: 'product_quantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' }),
	          resizable: true,
	          sortable: true,
	          width: 120,
	          filterable: true,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          },
	          formatter: function formatter(row) {
	            var backgroundColor = 'transparent';
	            console.log(row);
	            var stockLevel = row.dependentValues ? row.dependentValues.StockLevel : "";
	            backgroundColor = getBackgroundColor(stockLevel);
	            return _react2.default.createElement(
	              'div',
	              {
	                style: {
	                  backgroundColor: backgroundColor,
	                  width: '100%',
	                  textAlign: 'left',
	                  paddingLeft: 5
	                }
	              },
	              row.value
	            );
	          }
	
	        };
	        var vendor = {
	          key: 'Vendor_name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor' }),
	          resizable: true,
	          sortable: true,
	          width: 120,
	          filterable: true
	        };
	        var promoStart = {
	          key: 'product_promo_start_date',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'promotion_start' }),
	          resizable: true,
	          sortable: true,
	          width: 120,
	          filterable: true,
	          formatter: _dateFormat.DateFormatter
	          // const purchaser = {
	          //   key: 'Purchaser_User',
	          //   name: <Translate value="purchaser" />,
	          //   resizable: true,
	          //   sortable: true,
	          //   width: 120,
	          //   filterable: true,
	          // }
	        };columns.splice(CustomerNumIndex, 0, maxStock, quantity, vendor, promoStart, purchaser);
	      }
	
	      // React Table Purchase Order Full Table
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          _react2.default.createElement(
	            'div',
	            { className: 'react-table-purchasing-performance', id: 'SalesPerformance-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              enableCellSelect: true,
	              onGridSort: handleGridSort,
	              columns: columns,
	              rowHeight: 25,
	              headerRowHeight: 45,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              minHeight: 390,
	              onAddFilter: handleFilterChange,
	              onClearFilters: onClearFilters
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 12 },
	          this.renderLegend()
	        )
	      );
	    }
	  }, {
	    key: 'renderAutoSuggest',
	    value: function renderAutoSuggest() {
	      var _this8 = this;
	
	      if (!this.state.filteredByItem) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'control-dropdown' },
	          _react2.default.createElement(_GenericProductSuggest2.default, {
	            value: this.state.suggestValue,
	            onChange: function onChange(e, _ref) {
	              var newValue = _ref.newValue;
	              _this8.setState({ suggestValue: newValue });
	            },
	            SearchType: this.state.productSearchType,
	            fetchOrdersByProduct: this.handleFetchSalesPerformanceByProduct
	          })
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { id: 'suggestion-box' },
	        this.state.suggestValue,
	        _react2.default.createElement('em', { className: 'fa fa-times pull-right', onClick: function onClick() {
	            _this8.setState({ filteredByItem: false, suggestValue: '', filterProductID: null }, function () {
	              _this8.fetchSalesPerformance(_this8.state.days);
	            });
	          } })
	      );
	    }
	  }, {
	    key: 'renderUserPerformanceTab',
	    value: function renderUserPerformanceTab() {
	      var User = this.props.User;
	      var _state = this.state,
	          userFromDate = _state.userFromDate,
	          userToDate = _state.userToDate,
	          userDays = _state.userDays;
	
	      var toDate = (0, _dateFormat.formatDate)(userToDate);
	      var fromDate = (0, _dateFormat.formatDate)(userFromDate);
	      var dates = (0, _cleanDates.toFromDates)(userDays, fromDate, toDate);
	      var users = this.handleUserSelection();
	      var id = void 0;
	      if (User) {
	        id = '&userId=' + User.value;
	      } else {
	        id = '';
	      }
	      var userPerformanceTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'user_performance' });
	      var excelUrl = _root_url.ROOT_URL + 'v1/sale/userperformance/?startDate=' + dates.fromDate + '&endDate=' + dates.toDate + id + '&mode=export&Bearer=' + localStorage.getItem('token');
	
	      if (_root_url.isEcity || isDev || isOCM) {
	        var Buttons = [{ days: '30', title: 'Last Month' }, { days: '60', title: '2 Months' }, { days: '90', title: '3 Months' }];
	        return _react2.default.createElement(
	          _reactBootstrap.Tab,
	          { eventKey: 'UserPerformance', title: userPerformanceTitle },
	          _react2.default.createElement(
	            'div',
	            { className: 'by-quantity-tab' },
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { id: 'date-range-picker', className: 'form-horizontal' },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 2 },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'filter-title' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Select a User' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'colon' },
	                      ':'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 8, style: { width: '150px', paddinBottom: '20px', zIndex: 1000000 } },
	                  _react2.default.createElement(_reduxForm.Field, { name: 'User', component: _selection.Selection, matchPos: 'any', options: users })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 2 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'user-performance-toolbar' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'success',
	                        href: excelUrl,
	                        disabled: !(0, _permissions2.default)('print_sales_performance')
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-download' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'export' })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 2 },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'filter-title' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date_range' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'colon' },
	                      ':'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 10 },
	                  (0, _customizableDateFilterRadios2.default)({
	                    handleOnClick: this.fetchUserPerformance,
	                    userSetFromDate: this.userSetFromDate,
	                    userSetToRangeSearch: this.userSetToRangeSearch,
	                    userSetToDate: this.userSetToDate,
	                    userFromDate: this.state.userFromDate,
	                    userToDate: this.state.userToDate,
	                    userDays: this.state.userDays,
	                    Mode: this.state.userMode,
	                    userTimeSelection: this.state.userTimeSelection
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                this.renderCustomersTable()
	              )
	            )
	          )
	        );
	      }
	      return _react2.default.createElement('div', null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      var salesType = this.state.SalesType;
	      var days = this.state.Days;
	      var fromDate = '1900-01-01';
	      var toDate = '3000-01-01';
	      if (this.state.FromDate) {
	        fromDate = this.formatDate(this.state.FromDate);
	      }
	      if (this.state.ToDate) {
	        toDate = this.formatDate(this.state.ToDate);
	      }
	      var dates = (0, _cleanDates.toFromDates)(days, fromDate, toDate);
	      if (salesType === 'salesorder') {
	        fromDate = 'SalesInvoice_id__DispatchDate__gte=' + dates.fromDate;
	        toDate = 'SalesInvoice_id__DispatchDate__lte=' + dates.toDate;
	      } else if (salesType === 'posorder') {
	        fromDate = 'Order_id__Date__gte=' + dates.fromDate;
	        toDate = 'Order_id__Date__lte=' + dates.toDate;
	      } else if (salesType === 'all') {
	        fromDate = 'date__gte=' + dates.fromDate;
	        toDate = 'date__lte=' + dates.toDate;
	      } else {
	        fromDate = 'date__gte=' + dates.fromDate;
	        toDate = 'date__lte=' + dates.toDate;
	      }
	      var productNum = this.state.filterProductID;
	      var group = this.state.currentGroup;
	      var category = this.state.currentCategory;
	      if (group === -1 && category === -1) {
	        group = null;
	        category = null;
	      } else if (category === -1) {
	        category = null;
	      } else if (category) {
	        group = null;
	      }
	      var aggregate = this.state.hide;
	      var seller = this.props.Seller;
	      if (this.props.Seller) {
	        seller = this.props.Seller.value;
	      }
	      var customer = this.props.Customer;
	      if (this.props.Customer) {
	        customer = this.props.Customer.value;
	      }
	
	      if (productNum) {
	        productNum = '&Product_id__ProductNum=' + productNum;
	        group = '';
	        category = '';
	        aggregate = '';
	        seller = '';
	        customer = '';
	      } else {
	        productNum = '';
	        if (group) {
	          group = '&Product_id__ProductGroup_id=' + group;
	        } else {
	          group = '';
	        }
	        if (category) {
	          category = '&Product_id__ProductCategory1_id=' + category;
	        } else {
	          category = '';
	        }
	        if (aggregate) {
	          aggregate = '&Aggregate=' + aggregate;
	        } else {
	          aggregate = '';
	        }
	        if (seller) {
	          seller = '&Sales_User_id=' + seller;
	        } else {
	          seller = '';
	        }
	        if (customer) {
	          customer = '&SalesInvoice_id__Deliver_Customer_id=' + customer;
	        } else {
	          customer = '';
	        }
	      }
	
	      var print_url = _root_url.ROOT_URL + 'v1/sale/performance/print/' + salesType + '/?' + fromDate + '&' + toDate + productNum + group + category + aggregate + seller + customer + '&Bearer=' + localStorage.getItem('token');
	
	      var excel_url = _root_url.ROOT_URL + 'v1/sale/performance/excel/' + salesType + '/?' + fromDate + '&' + toDate + productNum + group + category + aggregate + seller + customer + '&Bearer=' + localStorage.getItem('token');
	
	      // AFM report url BelongWarehouse
	      var warehouse = localStorage.getItem('warehouseLocation');
	      var report_url = '';
	      if (warehouse === 'All' || warehouse === null) {
	        report_url = _root_url.ROOT_URL + 'v1/sale/performance_categories?' + fromDate + '&' + toDate + '&Bearer=' + localStorage.getItem('token');
	      } else {
	        report_url = _root_url.ROOT_URL + 'v1/sale/performance_categories?' + fromDate + '&' + toDate + '&BelongWarehouse=' + warehouse + '&Bearer=' + localStorage.getItem('token');
	      }
	
	      var limitSelection = [{
	        label: 'ALL',
	        value: 'ALL'
	      }, {
	        label: 'MSO',
	        value: 'MSO'
	      }, {
	        label: 'SO',
	        value: 'SO'
	      }];
	
	      // const handleLimitChange = (el) => {
	      //   // this.setState({ limit: el.value, limitDisplay: el.label});
	      //   el.preventDefault();
	      //   this.state.limit = el.value;
	      //   this.state.limitDisplay = el.label;
	
	      //   this.props.setDefaultOfForm('ProductNum', null, 'salesPerformance');
	      // let fromDate = '1900-01-01';
	      // let toDate = '3000-01-01';
	      // if (this.state.FromDate) {
	      //   fromDate = this.formatDate(this.state.FromDate);
	      // }
	      // if (this.state.ToDate) {
	      //   toDate = this.formatDate(this.state.ToDate);
	      // }
	      // const productNum = null;
	      // this.props.fetchSalesPerformanceByFilter(this.state.SalesType || 'posorder', this.state.Days, fromDate, toDate, 'show', productNum, null, id, this.state.hide, null);
	      // }
	
	      var productPerformanceTitle = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_performance' });
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_performance' })
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'sales-performance' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Tabs,
	                { activeKey: this.state.tabsKey, justified: true, onSelect: this.handleTabSelect },
	                _react2.default.createElement(
	                  _reactBootstrap.Tab,
	                  { eventKey: 'ProductPerformance', title: productPerformanceTitle, style: { height: '750px' } },
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Panel,
	                      { id: 'category-nav', className: 'panelStyle' },
	                      _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        { className: 'panelStyle' },
	                        _react2.default.createElement(
	                          'div',
	                          { style: { color: _constants.APP_COLORS['category-nav'], fontWeight: 'bold', cursor: 'pointer' }, name: 'group', id: 'g-1', onClick: this.handleClickGroup.bind(this, null, '-1') },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' })
	                        )
	                      ),
	                      this.renderGroups()
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 10 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Panel,
	                      { id: 'date-range-picker', className: 'form-horizontal' },
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 1 },
	                          _react2.default.createElement(
	                            'h3',
	                            { className: 'filter-title' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'filter' }),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'colon' },
	                              ':'
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 11 },
	                          _react2.default.createElement(
	                            'div',
	                            { id: 'statusFilterRadios', className: 'form-horizontal' },
	                            (0, _genericRadioFilter2.default)({
	                              content: [{
	                                option: 'all',
	                                id: 'all-radio-filter',
	                                name: 'statusFilterRadios',
	                                labelName: 'all'
	                              }, {
	                                option: 'posorder',
	                                id: 'open-radio-filter',
	                                name: 'statusFilterRadios',
	                                labelName: 'pos'
	                              }, {
	                                option: 'salesorder',
	                                id: 'salesOrder-radio-filter',
	                                name: 'statusFilterRadios',
	                                labelName: isAFM || isATL ? 'invoiced' : 'sales_order'
	                              }, {
	                                option: 'presale',
	                                id: 'presale-radio-filter',
	                                name: 'statusFilterRadios',
	                                labelName: isAFM || isATL ? 'order' : 'presale'
	                              }],
	                              value: this.state.SalesType,
	                              handleOnClick: this.handleSalesTypeFilterChange,
	                              type: 'buttons'
	                            })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 11, xsOffset: 1 },
	                          (0, _dateFilterRadios2.default)({
	                            handleOnClick: this.fetchSalesPerformance,
	                            setFromDate: this.setFromDate,
	                            setToRangeSearch: this.setToRangeSearch,
	                            setToDate: this.setToDate,
	                            FromDate: this.state.FromDate,
	                            ToDate: this.state.ToDate,
	                            Days: this.state.Days
	                          })
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 10 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Panel,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: isAFM || isATL ? 4 : 2 },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { style: { marginLeft: '7px' } },
	                            _react2.default.createElement(
	                              _reactBootstrap.ButtonToolbar,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                  bsStyle: 'primary',
	                                  href: print_url,
	                                  disabled: !(0, _permissions2.default)('print_sales_performance')
	                                },
	                                _react2.default.createElement('em', { className: 'fa fa-print' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                  bsStyle: 'success',
	                                  href: excel_url,
	                                  disabled: !(0, _permissions2.default)('print_sales_performance')
	                                },
	                                _react2.default.createElement('em', { className: 'fa fa-download' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	                              )
	                            )
	                          ),
	                          (isAFM || isATL) && _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { style: { marginTop: "5px" } },
	                            _react2.default.createElement(
	                              _reactBootstrap.ButtonToolbar,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                  bsStyle: 'primary',
	                                  href: report_url,
	                                  disabled: !(0, _permissions2.default)('print_sales_performance')
	                                },
	                                _react2.default.createElement('em', { className: 'fa fa-download' }),
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'report' })
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                  bsStyle: 'primary',
	                                  onClick: function onClick() {
	                                    // this.props.printSP(1);
	                                    _this9.printLALASP(_this9.state.Days);
	                                  },
	                                  disabled: false
	                                },
	                                _react2.default.createElement('em', { className: 'fa fa-print' }),
	                                ' PDF Report'
	                              ),
	                              this.renderSPIFrame()
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: isAFM || isATL ? 10 : 8 },
	                          _react2.default.createElement(
	                            'div',
	                            { id: 'autosuggest-div' },
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              { style: { height: '30px' } },
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(_TypeRadios2.default, { value: this.state.productSearchType, handleOptionChange: this.handleOptionChange })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Row,
	                              null,
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                this.renderAutoSuggest()
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { style: { 'padding-bottom': '5px', display: 'flex', flexDirection: 'row', marginLeft: '7px' } },
	                        (!isAFM || true) && _react2.default.createElement(
	                          'div',
	                          { style: _extends({}, styles.titleLabel) },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'seller' })
	                        ),
	                        (!isAFM || true) && _react2.default.createElement(
	                          'div',
	                          { style: _extends({}, styles.titleField) },
	                          this.renderUsers()
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { style: _extends({}, styles.titleLabel) },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sale_qty' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { style: _extends({}, styles.titleField) },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'SaleQTY', component: _inputField.DisabledInputField, placeholder: this.state.saleQTY })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { style: _extends({}, styles.titleLabel, { width: '91px' }) },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_item_sale' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { style: _extends({}, styles.titleField) },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'sum', component: _inputField.DisabledInputField, placeholder: this.state.sum })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { style: _extends({}, styles.titleLabel, { width: '69px' }) },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'avg_sale_dollarsign' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { style: _extends({}, styles.titleField) },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'AVGSalePrice', component: _inputField.DisabledInputField, placeholder: this.state.avgSalePrice })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { style: _extends({}, styles.titleLabel, { width: '92px' }) },
	                          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'avg_markup_percentsign' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { style: _extends({}, styles.titleField) },
	                          _react2.default.createElement(_reduxForm.Field, { name: 'AvgMarkupPct', component: _inputField.DisabledInputField, placeholder: this.state.avgMarkupPct })
	                        ),
	                        this.renderShowDetails()
	                      ),
	                      (isFung || isOCM || isAN) && _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { xs: 3 },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'col-xs-6' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'select_customer' })
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            this.renderCustomers()
	                          )
	                        )
	                      ),
	                      this.renderTable()
	                    )
	                  )
	                ),
	                this.renderUserPerformanceTab()
	              )
	            )
	          )
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return SalesPerformance;
	}(_react.Component);
	
	var _default = SalesPerformance;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesPerformance.jsx');
	
	  __REACT_HOT_LOADER__.register(isDev, 'isDev', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesPerformance.jsx');
	
	  __REACT_HOT_LOADER__.register(isAFM, 'isAFM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesPerformance.jsx');
	
	  __REACT_HOT_LOADER__.register(isFung, 'isFung', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesPerformance.jsx');
	
	  __REACT_HOT_LOADER__.register(isOCM, 'isOCM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesPerformance.jsx');
	
	  __REACT_HOT_LOADER__.register(isAN, 'isAN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesPerformance.jsx');
	
	  __REACT_HOT_LOADER__.register(isATL, 'isATL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesPerformance.jsx');
	
	  __REACT_HOT_LOADER__.register(isChinaTown, 'isChinaTown', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesPerformance.jsx');
	
	  __REACT_HOT_LOADER__.register(legendData, 'legendData', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesPerformance.jsx');
	
	  __REACT_HOT_LOADER__.register(getBackgroundColor, 'getBackgroundColor', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesPerformance.jsx');
	
	  __REACT_HOT_LOADER__.register(SalesPerformance, 'SalesPerformance', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesPerformance.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesPerformance.jsx');
	}();

	;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _inputField = __webpack_require__(16);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _setWeightModal = __webpack_require__(74);
	
	var _setWeightModal2 = _interopRequireDefault(_setWeightModal);
	
	var _datePicker = __webpack_require__(27);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isMyumyu = _root_url.ROOT_API_URL === 'https://mmstage-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://myumyu-scm.truckxi.com/api/';
	var isAFG = _root_url.ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://afg-scm.truckxi.com/api/';
	var isWecom = _root_url.ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/';
	var isAFM = _root_url.ROOT_API_URL === "https://afm-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://afm-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://afmstage-scm.truckxi.com/api/";
	var isABC = _root_url.ROOT_API_URL === "https://abc-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://abc-scm.truckxi.com/api/";
	var isTN = _root_url.ROOT_API_URL === "https://tn-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://tn-scm.truckxi.com/api/";
	var isJML = _root_url.ROOT_API_URL === "https://jml-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://jml-scm.truckxi.com/api/";
	var isLO = _root_url.ROOT_API_URL === 'https://lonni-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://lonni-scm.truckxi.com/api/';
	var isABCFF = _root_url.ROOT_API_URL === "https://abcff-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://abcff-scm.truckxi.com/api/";
	
	var renderRadios = function renderRadios(props) {
	  var titleClass = (0, _classnames2.default)({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'marginRightLabel', 'marginH4Style');
	  return _react2.default.createElement(
	    _reactBootstrap.ButtonToolbar,
	    { className: 'payment-type-buttons' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: 'primary', type: 'button' },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'notPaid-payment-type' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'notPaid-payment-type', type: 'radio', value: 'Not Paid', name: 'paymentTypeRadios', checked: props.input.value === "Not Paid" || !props.input })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'not_paid' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: 'primary', type: 'button' },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'cash-payment-type' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'cash-payment-type', type: 'radio', value: 'cash',
	            name: 'paymentTypeRadios', checked: props.input.value === "cash" })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cash' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: 'primary', type: 'button' },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'credit-payment-type' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'credit-payment-type', type: 'radio', value: 'credit_card', name: 'paymentTypeRadios', checked: props.input.value === "credit_card" })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit_card' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { bsStyle: 'primary', type: 'button' },
	      _react2.default.createElement(
	        'div',
	        { className: 'radio' },
	        _react2.default.createElement(
	          'label',
	          { 'for': 'check-payment-type' },
	          _react2.default.createElement('input', _extends({}, props.input, { id: 'check-payment-type', type: 'radio', value: 'check',
	            name: 'paymentTypeRadios', checked: props.input.value === "check" })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check' })
	        )
	      )
	    )
	  );
	};
	
	var sortByLineID = function sortByLineID(a, b) {
	  return parseFloat(a.SalesOrderLine_id) - parseFloat(b.SalesOrderLine_id);
	};
	
	var RowRenderer = function (_Component) {
	  _inherits(RowRenderer, _Component);
	
	  function RowRenderer() {
	    _classCallCheck(this, RowRenderer);
	
	    return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(RowRenderer, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { onDoubleClick: function onDoubleClick() {
	            _this2.props.onDoubleClick(_this2.props.row);
	          } },
	        _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	      );
	    }
	  }]);
	
	  return RowRenderer;
	}(_react.Component);
	
	RowRenderer.PropTypes = {
	  onDoubleClick: _react2.default.PropTypes.func
	};
	
	var SalesShippingModal = function (_Component2) {
	  _inherits(SalesShippingModal, _Component2);
	
	  function SalesShippingModal() {
	    _classCallCheck(this, SalesShippingModal);
	
	    var _this3 = _possibleConstructorReturn(this, (SalesShippingModal.__proto__ || Object.getPrototypeOf(SalesShippingModal)).call(this));
	
	    _this3.IFrameIsLoaded = function () {
	      if (!_this3.state.PdfFrameLoaded) {
	        var pdfFrame = window.frames["Pdf"];
	        pdfFrame.focus();
	        pdfFrame.print();
	        _this3.setState({ PdfFrameLoaded: true });
	      }
	    };
	
	    _this3.keepLoaded = function (oldLoaded) {
	      var products = _extends({}, _this3.state.products);
	      if (oldLoaded) {
	        products.rows[_this3.state.currentRow].LoadedQuantity = oldLoaded;
	      }
	      _this3.setState({ products: products });
	    };
	
	    _this3.handleKeyPress = function (event) {
	      if (event.charCode == 13 && parseFloat(_this3.state.selectedQty) && _this3.state.selectedQty) {
	        event.preventDefault();
	        var rows = _reactDataGridAddons.Data.Selectors.getRows(_this3.state.salesOrders);
	        var selectedRowIdx = _this3.state.selectedRowIdx;
	
	        var _salesOrders = _extends({}, _this3.state.salesOrders, { rows: rows });
	        _this3.setState({
	          salesOrders: _salesOrders,
	          totalLoaded: _this3.state.selectedQty || 0,
	          rowChosen: rows[parseFloat(selectedRowIdx)].SalesOrderLine_id,
	          currentRow: parseFloat(selectedRowIdx),
	          currentTable: 'salesOrders'
	        }, function () {
	          _this3.load(rows[selectedRowIdx].Index);
	        });
	      } else if (event.charCode == 13) {
	        var _rows = _reactDataGridAddons.Data.Selectors.getRows(_this3.state.salesOrders);
	        var _selectedRowIdx = _this3.state.selectedRowIdx;
	
	        var newRowIdx = 0;
	        if (_rows.length && parseFloat(_selectedRowIdx) < _rows.length - 1) newRowIdx = parseFloat(_selectedRowIdx) + 1;
	        _this3.setState({
	          selectedRowIdx: newRowIdx,
	          selectedQty: '',
	          totalLoaded: _this3.state.selectedQty || 0,
	          rowChosen: _rows[parseFloat(_selectedRowIdx)].SalesOrderLine_id,
	          currentRow: parseFloat(_selectedRowIdx),
	          currentTable: 'salesOrders'
	        });
	      }
	    };
	
	    _this3.handleChange = function (event) {
	      _this3.setState({ selectedQty: event.target.value });
	    };
	
	    _this3.renderQuickLoader = function () {
	      var rowName = '';
	      var rows = _reactDataGridAddons.Data.Selectors.getRows(_this3.state.salesOrders);
	      var _this3$state = _this3.state,
	          selectedQty = _this3$state.selectedQty,
	          selectedRowIdx = _this3$state.selectedRowIdx;
	
	      if (rows.length && selectedRowIdx < rows.length && !isLO) {
	        rowName = (rows[parseFloat(selectedRowIdx)].ProductNum || "") + "  " + (rows[parseFloat(selectedRowIdx)].Name || "") + "  " + (rows[parseFloat(selectedRowIdx)].Description || "");
	      }
	      if (rows.length && selectedRowIdx < rows.length && isLO) {
	        rowName = (rows[parseFloat(selectedRowIdx)].RefNum || "") + "  " + (rows[parseFloat(selectedRowIdx)].Name || "") + "  " + (rows[parseFloat(selectedRowIdx)].Description || "");
	      }
	      if (rowName.length && rowName.length >= 54) {
	        rowName = rowName.substring(0, 53);
	        rowName += '...';
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Panel,
	        { className: 'quick-loader-panel' },
	        rows.length ? _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 9 },
	          _react2.default.createElement(
	            'label',
	            { className: 'quick-loader-label' },
	            _react2.default.createElement(
	              'span',
	              { className: 'quick-loader-text' },
	              rowName
	            )
	          )
	        ) : _react2.default.createElement(
	          _reactBootstrap.Col,
	          { style: { 'display': 'block', 'text-align': 'center' } },
	          _react2.default.createElement(
	            'label',
	            { className: 'quick-loader-label' },
	            _react2.default.createElement(
	              'span',
	              { className: 'quick-loader-text', style: { 'color': '#5cb85c' } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_products_loaded_click_save_to_complete' })
	            )
	          )
	        ),
	        rows.length ? _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 3, className: 'quick-loader-input' },
	          _react2.default.createElement(_reactBootstrap.Input, { type: 'number', autoFocus: true, placeholder: _reactReduxI18n.I18n.t('loaded_qty'), ref: 'quickLoader', withRef: true, value: _this3.state.selectedQty, onChange: _this3.handleChange, onKeyPress: function onKeyPress(event) {
	              _this3.handleKeyPress(event);
	            } })
	        ) : _react2.default.createElement('span', null)
	      );
	    };
	
	    _this3.state = {
	      // Control state of Modal
	      confirmActionOpen: false,
	      setWeightOpen: false,
	
	      orderNum: null,
	      numInputFields: 0,
	      totalLoaded: null,
	      rowChosen: null,
	      currentRow: null,
	      currentTable: null,
	
	      salesOrders: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      products: {
	        rows: [],
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      selectedRowIdx: 0,
	      selectedQty: ''
	    };
	
	    _this3.openSetWeight = _this3.openSetWeight.bind(_this3);
	    _this3.closeSetWeight = _this3.closeSetWeight.bind(_this3);
	    _this3.openAction = _this3.openAction.bind(_this3);
	    _this3.closeAction = _this3.closeAction.bind(_this3);
	    _this3.moveOff = _this3.moveOff.bind(_this3);
	    _this3.moveTo = _this3.moveTo.bind(_this3);
	    _this3.quickMove = _this3.quickMove.bind(_this3);
	    return _this3;
	  }
	
	  _createClass(SalesShippingModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.InvoiceNum) {
	        if (isABC) {
	          var _salesOrders2 = _extends({}, this.state.salesOrders, { rows: this.props.rows });
	          var products = _extends({}, this.state.products, { rows: this.props.salesOrderDetail.Sales_Invoice_Lines.map(function (line) {
	              return _extends({}, line, {
	                Quantity: line.Quantity + '/' + line.LoadedQuantity,
	                LoadedQuantity: 0
	              });
	            }) });
	          this.setState({ salesOrders: _salesOrders2, products: products });
	        } else {
	          this.props.fetchSalesInvoiceDetail(this.props.InvoiceNum, "InvoiceNum");
	        }
	      } else {
	        var _salesOrders3 = _extends({}, this.state.salesOrders, { rows: this.props.rows });
	        this.setState({ salesOrders: _salesOrders3 });
	        this.props.setValue('salesShippingModal', 'PaymentType', 'Not Paid');
	        this.props.setValue('salesShippingModal', 'InvoiceShipDate', null); //new Date()
	      }
	      // this.props.fetchSalesOrdersByDate(this.formatDate(new Date));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.PaymentType && nextProps.PaymentType != this.props.PaymentType) {
	        this.props.convertingToInvoiceReset();
	        this.props.updateSalesInvoiceReset();
	      }
	      if (nextProps.salesOrderDetail && nextProps.salesOrderDetail != this.props.salesOrderDetail) {
	        var sales_Invoice_Lines = nextProps.salesOrderDetail.Sales_Invoice_Lines;
	        var products = _extends({}, this.state.products, { rows: sales_Invoice_Lines });
	        var _salesOrders4 = _extends({}, this.state.salesOrders, { rows: this.props.rows });
	        var leftRows = [];
	        _salesOrders4.rows.map(function (r) {
	          var index = _.findIndex(sales_Invoice_Lines, { 'Index': r.Index });
	          if (index == -1) {
	            leftRows.push(r);
	          }
	        });
	        _salesOrders4.rows = leftRows;
	        _salesOrders4.rows.sort(sortByLineID);
	        this.setState({ products: products, salesOrders: _salesOrders4 });
	      }
	
	      if (nextProps.salesInvoicePdf && nextProps.salesInvoicePdf !== this.props.salesInvoicePdf) {
	        this.setState({ PdfFrameLoaded: false });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState.PdfFrameLoaded !== this.state.PdfFrameLoaded && this.state.PdfFrameLoaded == false) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'closeSetWeight',
	    value: function closeSetWeight() {
	      var _this4 = this;
	
	      this.setState({ setWeightOpen: false }, function () {
	        if (_this4.state.salesOrders.rows.length) _reactDom2.default.findDOMNode(_this4.refs['quickLoader'].refs.input).focus();
	      });
	    }
	  }, {
	    key: 'openSetWeight',
	    value: function openSetWeight() {
	      this.setState({ setWeightOpen: true });
	    }
	  }, {
	    key: 'openAction',
	    value: function openAction() {
	      this.setState({ confirmActionOpen: true });
	    }
	  }, {
	    key: 'closeAction',
	    value: function closeAction() {
	      this.setState({ confirmActionOpen: false });
	    }
	  }, {
	    key: 'moveOff',
	    value: function moveOff(row) {
	      var salesOrders = _extends({}, this.state.salesOrders);
	      salesOrders.rows.push(row);
	      salesOrders.rows.sort(sortByLineID);
	      var products = _extends({}, this.state.products);
	      var index = _.findIndex(products.rows, { 'Index': row.Index });
	      if (index > -1) products.rows.splice(index, 1);
	      this.setState({ products: products, salesOrders: salesOrders, selectedRowIdx: 0, selectedQty: '' });
	      this.props.convertingToInvoiceReset();
	      this.props.updateSalesInvoiceReset();
	    }
	  }, {
	    key: 'moveTo',
	    value: function moveTo(row) {
	      var products = _extends({}, this.state.products);
	      products.rows.push(row);
	      products.rows.sort(sortByLineID);
	      var rows = _reactDataGridAddons.Data.Selectors.getRows(this.state.salesOrders);
	      var salesOrders = _extends({}, this.state.salesOrders, { rows: rows });
	      var index = _.findIndex(salesOrders.rows, { 'Index': row.Index });
	      var newRowIdx = parseFloat(this.state.selectedRowIdx);
	      if (index > -1) salesOrders.rows.splice(index, 1);
	      if (newRowIdx >= salesOrders.rows.length - 1) {
	        newRowIdx = salesOrders.rows.length - 1;
	      }
	      this.setState({ products: products, salesOrders: salesOrders, selectedRowIdx: newRowIdx, selectedQty: '' });
	      this.props.convertingToInvoiceReset();
	      this.props.updateSalesInvoiceReset();
	    }
	  }, {
	    key: 'quickMove',
	    value: function quickMove(row) {
	      var products = _extends({}, this.state.products);
	      products.rows.sort(sortByLineID);
	      var index = _.findIndex(products.rows, { 'Index': row.Index });
	      products.rows[index].TotalNetWeight = row.TotalNetWeight;
	      products.rows[index].TotalPrice = row.TotalPrice;
	      this.setState({ products: products });
	      // this.props.convertingToInvoiceReset();
	      // this.props.updateSalesInvoiceReset();
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      var formattedDate;
	      if (date.getMonth() < 10) {
	        formattedDate = '0' + (parseInt(date.getMonth()) + 1);
	      } else {
	
	        // TURN THESE TO STRINGS
	        formattedDate = String(parseInt(date.getMonth() + 1));
	      }
	
	      if (date.getDate() < 10) {
	        formattedDate += '0' + date.getDate();
	      } else {
	        formattedDate += String(date.getDate());
	      }
	
	      formattedDate += String(date.getFullYear());
	      return formattedDate;
	    }
	  }, {
	    key: 'createInvoice',
	    value: function createInvoice(isPartial) {
	      var rows = this.state.products.rows;
	      if (isABC) {
	        rows = rows.filter(function (row) {
	          return row.LoadedQuantity;
	        });
	      }
	      var shipment_info = {};
	      if (isABCFF) {
	        shipment_info = {
	          trackingNumber: this.props.trackingNumber,
	          shipCarrier: this.props.shipCarrier,
	          shipMethod: this.props.shipMethod
	        };
	      }
	      this.props.convertToInvoice(this.props.currentSalesOrder.SalesOrder_id, rows, this.props.PaymentType, this.props.PaymentNum, isPartial, this.props.InvoiceShipDate, shipment_info);
	    }
	  }, {
	    key: 'autoLoad',
	    value: function autoLoad() {
	      // let productRows = [...this.state.products.rows];
	      var salesOrders = _extends({}, this.state.salesOrders);
	      var products = _extends({}, this.state.products);
	      salesOrders.rows = salesOrders.rows.map(function (r) {
	        if (r.ProductType != 'Non-Fixed') {
	          r.LoadedQuantity = r.Quantity;
	          r.TotalNetWeight = ((parseFloat(r.LoadedQuantity) || 0) * (parseFloat(r.NetWeight) || 0)).toFixed(2);
	          products.rows.push(r);
	          return null;
	        } else {
	          if (isJML) {
	            r.LoadedQuantity = r.Quantity;
	            r.TotalNetWeight = ((parseFloat(r.LoadedQuantity) || 0) * (parseFloat(r.PackageSize_1) || 0)).toFixed(2);
	            r.Weights = Array(r.Quantity).fill(parseFloat(r.PackageSize_1));
	            products.rows.push(r);
	            return null;
	          }
	          return r;
	        }
	      });
	      salesOrders.rows = salesOrders.rows.filter(function (obj) {
	        return obj !== null;
	      });
	      products.rows.sort(sortByLineID);
	      // productRows.map(row => {
	      //   if (row.ProductType == "Fixed") {
	      //     if (row.LoadedQuantity == 0) {
	      //       row.LoadedQuantity = row.Quantity;
	      //     }
	      //   }
	      // });
	      //
	      // let products = {...this.state.products, rows: productRows};
	      this.setState({ products: products, salesOrders: salesOrders });
	      this.props.convertingToInvoiceReset();
	      this.props.updateSalesInvoiceReset();
	    }
	  }, {
	    key: 'load',
	    value: function load(Index) {
	      var _this5 = this;
	
	      // let productRows = [...this.state.products.rows];
	      var salesOrders = _extends({}, this.state.salesOrders);
	      var products = _extends({}, this.state.products);
	      var isNonFixed = false;
	      salesOrders.rows = salesOrders.rows.map(function (r) {
	        if (r.Index == Index && (r.ProductType == 'Fixed' || r.ProductType == 'Per-Pound')) {
	          r.LoadedQuantity = parseFloat(roundTo(_this5.state.selectedQty, 2));
	          r.TotalNetWeight = parseFloat(((parseFloat(r.LoadedQuantity) || 0) * (parseFloat(r.NetWeight) || 0)).toFixed(2));
	          products.rows.push(r);
	          return null;
	        } else if (r.Index == Index && r.ProductType == 'Non-Fixed') {
	          r.LoadedQuantity = parseFloat(roundTo(_this5.state.selectedQty, 2));
	          isNonFixed = true;
	          return r;
	        } else {
	          return r;
	        }
	      });
	
	      var index = 0;
	      if (!isNonFixed) {
	        salesOrders.rows = salesOrders.rows.filter(function (obj) {
	          return obj !== null && obj !== undefined;
	        });
	      } else {
	        for (var i = 0; i < salesOrders.rows.length; i++) {
	          if (salesOrders.rows[i].Index == Index) index = i;
	        }
	        this.setState({ currentRow: index, currentTable: 'salesOrders', setWeightOpen: true });
	      }
	
	      // let products = {...this.state.products, rows: productRows};
	      var newRowIdx = parseFloat(this.state.selectedRowIdx);
	      if (newRowIdx >= salesOrders.rows.length - 1) {
	        newRowIdx = salesOrders.rows.length - 1;
	      }
	      //will need to put this somewhere else
	      this.setState({ products: products, salesOrders: salesOrders, selectedQty: '', selectedRowIdx: newRowIdx });
	      this.props.convertingToInvoiceReset();
	      this.props.updateSalesInvoiceReset();
	    }
	  }, {
	    key: 'checkRows',
	    value: function checkRows(isPartial) {
	      var _this6 = this;
	
	      if (isTN && !this.props.InvoiceShipDate) {
	        alert("Please select a Ship Date to save.");
	        return;
	      }
	      var valid = true;
	      var _props = this.props,
	          salesInvoiceDetail = _props.salesInvoiceDetail,
	          convertToInvoiceSuccess = _props.convertToInvoiceSuccess;
	
	      if (!isABC) {
	        this.state.products.rows.map(function (row) {
	          if (row.LoadedQuantity == 0) {
	            _this6.setState({ confirmActionOpen: true });
	            valid = false;
	          }
	        });
	      }
	      if (isABC && this.props.InvoiceNum && !convertToInvoiceSuccess) {
	        this.createInvoice(isPartial);
	        return;
	      }
	      if (valid && !this.props.InvoiceNum && !convertToInvoiceSuccess) {
	        this.createInvoice(isPartial);
	      } else if (valid) {
	        var update = {};
	        update.Sales_Invoice_Lines = this.state.products.rows;
	        update.DocumentDate = new Date();
	        if (salesInvoiceDetail && salesInvoiceDetail.OrderDate != null) {
	          update.OrderDate = salesInvoiceDetail.OrderDate;
	        }
	        var SalesInvoice_id = salesInvoiceDetail && salesInvoiceDetail.SalesInvoice_id || convertToInvoiceSuccess.SalesInvoice_id;
	        var SaleStatus = salesInvoiceDetail && salesInvoiceDetail.SaleStatus || convertToInvoiceSuccess.SaleStatus;
	        this.props.updateSalesInvoice(update, SaleStatus.toLowerCase(), SalesInvoice_id, this.props.PaymentType, this.props.PaymentNum);
	      }
	    }
	  }, {
	    key: 'returnTotalWeight',
	    value: function returnTotalWeight(totalWeight, weights) {
	      var currentRow = this.state[this.state.currentTable].rows[this.state.currentRow];
	      currentRow.TotalNetWeight = parseFloat(totalWeight);
	      currentRow.TotalPrice = parseFloat(roundTo((parseFloat(totalWeight) || 0) * (parseFloat(currentRow.UnitPrice) || 0), 2).toFixed(2));
	      currentRow.Weights = weights;
	      if (this.state.currentTable == "salesOrders") {
	        this.moveTo(currentRow);
	      } else {
	        this.quickMove(currentRow);
	      }
	    }
	  }, {
	    key: 'renderSalesOrderSelection',
	    value: function renderSalesOrderSelection() {
	      var _this7 = this;
	
	      var that = this;
	      if (this.props.salesOrdersIsLoading && !this.props.salesOrdersError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.salesOrdersError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.salesOrdersError)
	        )
	      );else {
	        var onDoubleClick = function onDoubleClick(e) {
	          this.setState({ totalLoaded: row.loaded_quantity, setWeightOpen: true, rowChosen: row.salesOrderLine_id });
	        };
	
	        // Parameters of the react-data-grid
	
	        var tableHeight = window.innerHeight < 900 ? 387 : 387;
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this7.state.salesOrders);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var salesOrders = _extends({}, _this7.state.salesOrders, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this7.setState({ salesOrders: salesOrders });
	        };
	
	        var onRowSelect = function onRowSelect(rows) {
	          var salesOrder = _extends({}, _this7.state.salesOrders, { selectedRows: rows });
	          _this7.setState({ salesOrders: salesOrders });
	        };
	
	        var onRowClick = function onRowClick(rowIdx, row) {
	          _this7.props.fetchSalesOrderDetail(row.SalesOrder_id);
	          _this7.setState({ orderNum: row.SONum });
	        };
	
	        var handleRowUpdated = function handleRowUpdated(e) {
	          var rows = getRows();
	          if (isJML && e.updated.jmlBox != null) {
	            Object.assign(rows[e.rowIdx], _extends({}, e.updated, { LoadedQuantity: Number(e.updated.jmlBox) * Number(rows[e.rowIdx].jmlPackageSize1) }));
	          } else {
	            Object.assign(rows[e.rowIdx], e.updated);
	          }
	          var loadedQuantity = parseFloat(rows[e.rowIdx].LoadedQuantity) || 0;
	          var unitPrice = parseFloat(rows[e.rowIdx].UnitPrice) || 0;
	          var netWeight = parseFloat(rows[e.rowIdx].NetWeight) || 0;
	          if (rows[e.rowIdx].ProductType == "Fixed") {
	            rows[e.rowIdx].TotalNetWeight = (loadedQuantity * netWeight).toFixed(2);
	            rows[e.rowIdx].TotalPrice = roundTo(loadedQuantity * unitPrice, 2).toFixed(2);
	          }
	          if (rows[e.rowIdx].ProductType == "Per-Pound") {
	            rows[e.rowIdx].TotalNetWeight = (loadedQuantity * netWeight).toFixed(2);
	            rows[e.rowIdx].TotalPrice = roundTo(loadedQuantity * netWeight * unitPrice, 2).toFixed(2);
	          }
	          var salesOrders = _extends({}, _this7.state.salesOrders, { rows: rows
	            // this.setState({ salesOrders });
	          });_this7.setState({
	            salesOrders: salesOrders,
	            totalLoaded: rows[e.rowIdx].LoadedQuantity,
	            rowChosen: rows[e.rowIdx].SalesOrderLine_id,
	            currentRow: e.rowIdx,
	            currentTable: "salesOrders"
	          }, function () {
	            if (rows[e.rowIdx].ProductType == "Non-Fixed") {
	              if (!isJML) {
	                _this7.setState({ setWeightOpen: true });
	              } else {
	                var totalWeight = rows[e.rowIdx].PackageSize_1 * loadedQuantity;
	                var Weights = [];
	                for (var i = 0; i < loadedQuantity; i++) {
	                  Weights.push(parseFloat(rows[e.rowIdx].PackageSize_1));
	                }
	                _this7.returnTotalWeight(totalWeight, Weights);
	              }
	            }
	          });
	        };
	
	        var IsVariableFormatter = _react2.default.createClass({
	          displayName: 'IsVariableFormatter',
	          render: function render() {
	            if (this.props.dependentValues && this.props.dependentValues.ProductType == "Non-Fixed") {
	              return _react2.default.createElement(
	                'span',
	                null,
	                this.props.value,
	                ' ',
	                _react2.default.createElement(
	                  'label',
	                  { className: 'label label-success' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'non_fixed' })
	                )
	              );
	            } else if (this.props.dependentValues && this.props.dependentValues.ProductType == 'Per-Pound') {
	              return _react2.default.createElement(
	                'span',
	                null,
	                this.props.value,
	                ' ',
	                _react2.default.createElement(
	                  'label',
	                  { className: 'label label-primary' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'per_pound' })
	                )
	              );
	            }
	            return _react2.default.createElement(
	              'span',
	              null,
	              this.props.value,
	              ' '
	            );
	          }
	        });
	
	        // Column difinition
	        var RowRenderer2 = _react2.default.createClass({
	          displayName: 'RowRenderer2',
	
	          render: function render() {
	            var _this8 = this;
	
	            if (that.state.salesOrders.rows.length && that.state.salesOrders.rows[parseFloat(that.state.selectedRowIdx)].Index === this.props.row.Index) return _react2.default.createElement(
	              'div',
	              { style: { color: 'blue' }, onDoubleClick: function onDoubleClick() {
	                  _this8.props.onDoubleClick(_this8.props.row);
	                } },
	              _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	            );
	            return _react2.default.createElement(
	              'div',
	              { onDoubleClick: function onDoubleClick() {
	                  _this8.props.onDoubleClick(_this8.props.row);
	                } },
	              _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	            );
	          }
	        });
	
	        var columns = [].concat(_toConsumableArray(!isLO ? [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          sortable: true,
	          width: 80
	        }] : []), _toConsumableArray(isAFM ? [{
	          key: 'Barcode',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'barcode' }),
	          resizable: true,
	          sortable: true,
	          width: 100
	        }] : [{
	          key: 'RefNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	          resizable: true,
	          sortable: true,
	          width: isLO ? 160 : 80
	        }]), _toConsumableArray(isAFM ? [{
	          key: 'Brand',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'brand' }),
	          resizable: true,
	          sortable: true,
	          width: 100
	        }] : []), [{
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	          resizable: true,
	          sortable: true,
	          width: 160
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	          resizable: true,
	          sortable: true,
	          width: 95
	        }, {
	          key: 'Quantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	          resizable: true,
	          sortable: true,
	          formatter: IsVariableFormatter,
	          width: 100,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'LoadedQuantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'loaded_qty' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          editable: !isJML
	        }], _toConsumableArray(isJML ? [{
	          key: 'jmlBox',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          editable: true
	        }, {
	          key: 'jmlPackageSize1',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pcs/box' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          editable: true
	        }] : []), _toConsumableArray(isLO ? [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          sortable: true,
	          width: 80
	        }] : []));
	
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { style: { maxWidth: '100%' }, id: 'SalesShippingModal-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowRenderer: _react2.default.createElement(RowRenderer2, { onDoubleClick: this.moveTo }),
	                onGridSort: handleGridSort,
	                columns: columns,
	                rowHeight: 35,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                enableCellSelect: true,
	                onRowUpdated: handleRowUpdated,
	                minHeight: tableHeight,
	                onRowSelect: onRowSelect
	              })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderSalesOrderDetail',
	    value: function renderSalesOrderDetail() {
	      var _this9 = this;
	
	      var that = this;
	      if (this.props.salesOrderIsLoading && !this.props.salesOrderError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.salesOrderError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.salesOrderError)
	        )
	      );else {
	        var onDoubleClick = function onDoubleClick(e) {
	          this.setState({ totalLoaded: row.loaded_quantity, setWeightOpen: true, rowChosen: row.salesOrderLine_id });
	        };
	
	        // Parameters of the react-data-grid
	
	        var tableHeight = window.innerHeight < 900 ? 430 : 430;
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this9.state.products);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var products = _extends({}, _this9.state.products, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this9.setState({ products: products });
	        };
	
	        var handleRowUpdated = function handleRowUpdated(e) {
	          var rows = getRows();
	          if (isJML && e.updated.jmlBox != null) {
	            Object.assign(rows[e.rowIdx], _extends({}, e.updated, { LoadedQuantity: Number(e.updated.jmlBox) * Number(rows[e.rowIdx].jmlPackageSize1) }));
	          } else {
	            Object.assign(rows[e.rowIdx], e.updated);
	          }
	          var loadedQuantity = parseFloat(rows[e.rowIdx].LoadedQuantity) || 0;
	          var unitPrice = parseFloat(rows[e.rowIdx].UnitPrice) || 0;
	          var netWeight = parseFloat(rows[e.rowIdx].NetWeight) || 0;
	          if (rows[e.rowIdx].ProductType == "Fixed") {
	            rows[e.rowIdx].TotalNetWeight = (loadedQuantity * netWeight).toFixed(2);
	            rows[e.rowIdx].TotalPrice = roundTo(loadedQuantity * unitPrice, 2).toFixed(2);
	          }
	          if (rows[e.rowIdx].ProductType == "Per-Pound") {
	            rows[e.rowIdx].TotalNetWeight = (loadedQuantity * netWeight).toFixed(2);
	            rows[e.rowIdx].TotalPrice = roundTo(loadedQuantity * netWeight * unitPrice, 2).toFixed(2);
	          }
	          var products = _extends({}, _this9.state.products, { rows: rows });
	          _this9.setState({
	            products: products,
	            totalLoaded: rows[e.rowIdx].LoadedQuantity,
	            rowChosen: rows[e.rowIdx].SalesOrderLine_id,
	            currentRow: e.rowIdx,
	            currentTable: "products"
	          }, function () {
	            if (rows[e.rowIdx].ProductType == "Non-Fixed") {
	              if (!isJML) {
	                _this9.setState({ setWeightOpen: true });
	              } else {
	                var totalWeight = rows[e.rowIdx].PackageSize_1 * loadedQuantity;
	                var Weights = [];
	                for (var i = 0; i < loadedQuantity; i++) {
	                  Weights.push(parseFloat(rows[e.rowIdx].PackageSize_1));
	                }
	                _this9.returnTotalWeight(totalWeight, Weights);
	              }
	            }
	          });
	          _this9.props.convertingToInvoiceReset();
	          _this9.props.updateSalesInvoiceReset();
	        };
	
	        // var RowRenderer = React.createClass({
	        //
	        //  render: function() {
	        //    return (<div onClick={()=>{console.log("on click, move")}}><ReactDataGrid.Row ref="row" {...this.props} onDoubleClick={this.props.onDoubleClick} /></div>)
	        //  }
	        // });
	        //
	        // RowRenderer.PropTypes: {
	        //   onDoubleClick: React.PropTypes.func
	        // }
	
	        // Custom Formatter component
	        var IsVariableFormatter = _react2.default.createClass({
	          displayName: 'IsVariableFormatter',
	          render: function render() {
	            if (this.props.dependentValues && this.props.dependentValues.ProductType == "Non-Fixed") {
	              return _react2.default.createElement(
	                'span',
	                null,
	                this.props.value,
	                ' ',
	                _react2.default.createElement(
	                  'label',
	                  { className: 'label label-success' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'non_fixed' })
	                )
	              );
	            } else if (this.props.dependentValues && this.props.dependentValues.ProductType == 'Per-Pound') {
	              return _react2.default.createElement(
	                'span',
	                null,
	                this.props.value,
	                ' ',
	                _react2.default.createElement(
	                  'label',
	                  { className: 'label label-primary' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'per_pound' })
	                )
	              );
	            }
	            return _react2.default.createElement(
	              'span',
	              null,
	              this.props.value,
	              ' '
	            );
	          }
	        });
	
	        // Column difinition
	
	        var columns = [].concat(_toConsumableArray(!isLO ? [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          sortable: true,
	          width: 80
	        }] : []), _toConsumableArray(isAFM ? [{
	          key: 'Barcode',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'barcode' }),
	          resizable: true,
	          sortable: true,
	          width: 100
	        }] : [{
	          key: 'RefNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	          resizable: true,
	          sortable: true,
	          width: isLO ? 160 : 80
	        }]), _toConsumableArray(isAFM ? [{
	          key: 'Brand',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'brand' }),
	          resizable: true,
	          sortable: true,
	          width: 100
	        }] : []), [{
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	          resizable: true,
	          sortable: true,
	          width: 100
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc' }),
	          resizable: true,
	          sortable: true,
	          width: 100
	        }, {
	          key: 'PackageSize',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	          resizable: true,
	          sortable: true,
	          width: 80
	        }, {
	          key: 'Quantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	          resizable: true,
	          sortable: true,
	          width: 110,
	          formatter: IsVariableFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'LoadedQuantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'loaded_qty' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          editable: !isJML
	        }], _toConsumableArray(isJML ? [{
	          key: 'jmlBox',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'box' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          editable: true
	        }, {
	          key: 'jmlPackageSize1',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pcs/box' }),
	          resizable: true,
	          sortable: true,
	          width: 100,
	          editable: true
	        }] : []), [{
	          key: 'TotalNetWeight',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	          resizable: true,
	          sortable: true,
	          width: 100
	        }, {
	          key: 'TotalPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	          resizable: true,
	          sortable: true,
	          width: 100
	        }], _toConsumableArray(isLO ? [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prod_num' }),
	          resizable: true,
	          sortable: true,
	          width: 80
	        }] : []));
	
	        if (isABC) {
	          var index1 = _.findIndex(columns, { key: "PackageSize" });
	          var index2 = _.findIndex(columns, { key: "LoadedQuantity" });
	          var index3 = _.findIndex(columns, { key: "Description" });
	
	          columns.splice(index1, 1);
	          columns.splice(index2, 1);
	          columns.splice(index3, 1, {
	            key: 'Description',
	            name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'desc_editable' }),
	            resizable: true,
	            sortable: true,
	            width: 95,
	            editable: true
	          });
	        }
	
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { style: { maxWidth: '100%' }, id: 'SalesShippingModal-dataGrid2' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'Product_id',
	                rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: this.moveOff }),
	                onGridSort: handleGridSort,
	                columns: columns,
	                rowHeight: 35,
	                enableCellSelect: true,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                minHeight: tableHeight,
	                onRowUpdated: handleRowUpdated
	              })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderIFrame',
	    value: function renderIFrame() {
	      if (this.props.salesInvoicePdf) {
	        var file = window.URL.createObjectURL(this.props.salesInvoicePdf);
	        return _react2.default.createElement('iframe', { style: { display: 'none' }, onLoad: this.IFrameIsLoaded, id: 'Pdf', name: 'Pdf', src: file });
	      }
	    }
	  }, {
	    key: 'renderPrint',
	    value: function renderPrint() {
	      var _this10 = this;
	
	      var pk = this.props.currentSalesOrder.SalesInvoice_id || this.props.salesInvoiceDetail && this.props.salesInvoiceDetail.SalesInvoice_id || this.props.convertToInvoiceSuccess && this.props.convertToInvoiceSuccess.SalesInvoice_id;
	      if (!pk) return;
	      var shipping_url = _root_url.ROOT_URL + 'v1/sale/printinvoice/' + pk + "?Bearer=" + localStorage.getItem('token');
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          className: 'position-print-invoice-btn-relative',
	          disabled: this.props.requestingSalesInvoicePdf,
	          type: 'button',
	          onClick: function onClick() {
	            _this10.props.printSalesInvoice(pk);
	          }
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_invoice' })
	      );
	    }
	  }, {
	    key: 'renderPaymentNum',
	    value: function renderPaymentNum() {
	      if (this.props.PaymentType && this.props.PaymentType == "Check") {
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'position-relative' },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'check_no' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'PaymentNum', component: _inputField.InputField, placeholder: 'Enter check no.' })
	          )
	        );
	      } else {
	        return;
	      }
	    }
	  }, {
	    key: 'renderShipmentInfo',
	    value: function renderShipmentInfo() {
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tracking_num' })
	          ),
	          _react2.default.createElement(_reduxForm.Field, { name: 'trackingNumber', component: _inputField.InputField, placeholder: 'Enter tracking no.' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'carrier' })
	          ),
	          _react2.default.createElement(_reduxForm.Field, { name: 'shipCarrier', component: _inputField.InputField, placeholder: 'Enter carrier.' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { xs: 2 },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_method' })
	          ),
	          _react2.default.createElement(_reduxForm.Field, { name: 'shipMethod', component: _inputField.InputField, placeholder: 'Enter ship method.' })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this11 = this;
	
	      var _props2 = this.props,
	          savings = _props2.savings,
	          discount = _props2.discount,
	          taxRate = _props2.taxRate;
	
	
	      var createDialogStyle = {
	        width: '500px',
	        height: '600px',
	        top: '45%',
	        marginLeft: '-10%'
	      };
	
	      var totalUnit = 0;
	      var totalUnitProducts = 0;
	      var totalNetWeight = 0;
	      var totalPrice = 0;
	      var finalPrice = 0;
	      var salesOrdersRows = this.state.salesOrders.rows || [];
	      var productsRows = this.state.products.rows || [];
	      var currentWeights = productsRows[this.state.currentRow] ? this.state.products.rows[this.state.currentRow].Weights : [];
	      var weightsTitle = 'Set Product Weights: ';
	      var totalTax = 0;
	      var _state = this.state,
	          currentTable = _state.currentTable,
	          currentRow = _state.currentRow;
	
	      if (currentTable && this.state[currentTable].rows.length && this.state[currentTable].rows[currentRow]) {
	        weightsTitle = this.state[currentTable].rows[currentRow].ProductNum + ' ' + this.state[currentTable].rows[currentRow].Name;
	      }
	      salesOrdersRows.map(function (r) {
	        totalUnit += parseFloat(r.Quantity) || 0;
	      });
	      productsRows.map(function (r) {
	        totalUnitProducts += parseFloat(r.LoadedQuantity) || 0;
	        totalNetWeight += parseFloat(r.TotalNetWeight) || 0;
	        totalPrice += parseFloat(r.TotalPrice) || 0;
	        if (r.IsTaxable === true) {
	          totalTax += r.TotalPrice * (taxRate / 100);
	        }
	      });
	
	      totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
	      if (isMyumyu || isAFG || isWecom || isAFM) {
	        if (discount === 0 && savings > 0) {
	          finalPrice = parseFloat(Math.round(totalPrice * 100) / 100 + roundTo(parseFloat(this.props.currentSalesOrder.Delivery) + totalTax - savings, 2)).toFixed(2);
	        } else if (discount > 0) {
	          finalPrice = parseFloat(Math.round(totalPrice * 100) / 100 + roundTo(parseFloat(this.props.currentSalesOrder.Delivery) + totalTax - totalPrice * (discount / 100), 2)).toFixed(2);
	        } else {
	          finalPrice = parseFloat(Math.round(totalPrice * 100) / 100 + roundTo(parseFloat(this.props.currentSalesOrder.Delivery) + totalTax, 2)).toFixed(2);
	        }
	        totalPrice = parseFloat(Math.round(totalPrice * 100) / 100 + roundTo(parseFloat(this.props.currentSalesOrder.Delivery), 2)).toFixed(2);
	      } else {
	        totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
	      }
	      // isMyumyu ? totalPrice = parseFloat((Math.round(totalPrice*100)/100) + roundTo(parseFloat(this.props.currentSalesOrder.Delivery), 2)).toFixed(2) : totalPrice = parseFloat((Math.round(totalPrice*100)/100)).toFixed(2)
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'success-message' },
	          (this.props.convertingToInvoice || this.props.salesInvoiceIsUpdating) && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_spinner2.default, null),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'uploading' })
	          ),
	          (this.props.convertToInvoiceSuccess && !this.props.refreshConvertingToInvoice || this.props.salesInvoiceUpdated) && !(this.props.convertingToInvoice || this.props.salesInvoiceIsUpdating) && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-success' },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saved' }),
	              ' '
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'your_sales_invoice_no_is' }),
	              ' '
	            ),
	            this.props.salesInvoiceUpdated && this.props.salesInvoiceUpdated.InvoiceNum || this.props.convertToInvoiceSuccess && this.props.convertToInvoiceSuccess.InvoiceNum
	          ),
	          this.props.convertToInvoiceFailure && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger marginTopStyle' },
	            this.props.convertToInvoiceError
	          ),
	          this.props.salesInvoiceUpdateError && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger marginTopStyle' },
	            this.props.salesInvoiceUpdateError.detail
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 5 },
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_order_no' }),
	              ': ',
	              this.props.currentSalesOrder.SONum
	            )
	          ),
	          isTN && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 2 },
	              _react2.default.createElement(
	                'h4',
	                { className: 'filter-title' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ship_date' }),
	                _react2.default.createElement(
	                  'span',
	                  { style: { color: 'red' } },
	                  '*'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'colon' },
	                  ':'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 2, style: { paddingTop: '10px' } },
	              _react2.default.createElement(_reduxForm.Field, { component: _datePicker.DatePicker, name: 'InvoiceShipDate' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'set-height' },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 5 },
	            !isTN && _react2.default.createElement(
	              'h4',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cust_name' }),
	              ': ',
	              this.props.currentSalesOrder.Deliver_CustomerName
	            ),
	            isTN && _react2.default.createElement(
	              'h4',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer' }),
	              ': ',
	              this.props.currentSalesOrder.Deliver_CustomerName,
	              ' (CPO: ',
	              this.props.currentSalesOrder.CPONum,
	              ')'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 1 },
	            _react2.default.createElement(
	              'h4',
	              { className: 'filter-title' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'colon' },
	                ':'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 4 },
	            _react2.default.createElement(_reduxForm.Field, { name: 'PaymentType', component: renderRadios })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 2 },
	            this.renderPaymentNum()
	          )
	        ),
	        isABCFF && this.renderShipmentInfo(),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 5 },
	            this.renderQuickLoader(),
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { className: 'table-collapse-fix-pre' },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'panel-toolbar' },
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  { bsStyle: 'primary', type: 'button', style: { marginLeft: '140px' }, onClick: function onClick() {
	                      return _this11.autoLoad();
	                    } },
	                  _react2.default.createElement('em', { className: 'fa fa-mail-forward' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'auto_load' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 3 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'marginRightLabel' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_prod' }),
	                    ':'
	                  ),
	                  this.state.salesOrders.rows.length
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 3 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'marginRightLabel' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_unit' }),
	                    ':'
	                  ),
	                  totalUnit
	                )
	              ),
	              this.renderSalesOrderSelection()
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 7 },
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { className: 'table-collapse-fix' },
	              _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                { className: 'pull-right' },
	                this.renderPrint(),
	                isABC && _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'success',
	                    type: 'button',
	                    disabled: this.props.salesOrderDetail == null || this.props.convertingToInvoice || this.props.convertToInvoiceSuccess,
	                    onClick: function onClick() {
	                      return _this11.checkRows(true);
	                    }
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-save' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'partial_save' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'success',
	                    type: 'button',
	                    disabled: this.props.salesOrderDetail == null || this.props.convertingToInvoice || this.props.convertToInvoiceSuccess,
	                    onClick: function onClick() {
	                      return _this11.checkRows();
	                    }
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-save' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 10 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'panel-toolbar' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 3 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'marginRightLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_prod' }),
	                        ':'
	                      ),
	                      this.state.products.rows.length
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 3 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'marginRightLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_unit' }),
	                        ':'
	                      ),
	                      totalUnitProducts
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 3 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'marginRightLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_weight' }),
	                        ':'
	                      ),
	                      totalNetWeight
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { xs: 3 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'marginRightLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_price' }),
	                        ':'
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'dollar-sign' },
	                        '$'
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        finalPrice
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 12 },
	                  this.renderSalesOrderDetail()
	                )
	              )
	            )
	          )
	        ),
	        this.renderIFrame(),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          { dialogStyles: createDialogStyle, isVisible: this.state.setWeightOpen, onCloseClicked: function onCloseClicked() {
	              _this11.closeSetWeight();
	            }, title: weightsTitle },
	          _react2.default.createElement(_setWeightModal2.default, {
	            closeC: this.closeSetWeight,
	            totalLoaded: this.state.totalLoaded,
	            rowChosen: this.state.rowChosen,
	            returnTotalWeight: this.returnTotalWeight.bind(this),
	            currentTable: this.state.currentTable,
	            keepLoaded: this.keepLoaded,
	            currentWeights: currentWeights,
	            setWeights: function setWeights() {}
	          })
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          { dialogStyles: createDialogStyle, isVisible: this.state.confirmActionOpen, onCloseClicked: function onCloseClicked() {
	              _this11.closeAction();
	            }, title: 'Confirm Action' },
	          _react2.default.createElement(_confirmActionModal2.default, { closeC: this.closeAction, 'case': "quantityZero", caseAction: this.createInvoice.bind(this) })
	        )
	      );
	    }
	  }]);
	
	  return SalesShippingModal;
	}(_react.Component);
	
	SalesShippingModal.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = SalesShippingModal;
	exports.default = _default;
	
	
	function roundTo(n, digits) {
	  if (digits === undefined) {
	    digits = 0;
	  }
	
	  var multiplicator = Math.pow(10, digits);
	  n = parseFloat((n * multiplicator).toFixed(11));
	  var test = Math.round(n) / multiplicator;
	  return +test.toFixed(2);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(roundTo, 'roundTo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesShippingModal.jsx');
	
	  __REACT_HOT_LOADER__.register(isMyumyu, 'isMyumyu', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesShippingModal.jsx');
	
	  __REACT_HOT_LOADER__.register(isAFG, 'isAFG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesShippingModal.jsx');
	
	  __REACT_HOT_LOADER__.register(isWecom, 'isWecom', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesShippingModal.jsx');
	
	  __REACT_HOT_LOADER__.register(isAFM, 'isAFM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesShippingModal.jsx');
	
	  __REACT_HOT_LOADER__.register(isABC, 'isABC', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesShippingModal.jsx');
	
	  __REACT_HOT_LOADER__.register(isTN, 'isTN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesShippingModal.jsx');
	
	  __REACT_HOT_LOADER__.register(isJML, 'isJML', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesShippingModal.jsx');
	
	  __REACT_HOT_LOADER__.register(isLO, 'isLO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesShippingModal.jsx');
	
	  __REACT_HOT_LOADER__.register(isABCFF, 'isABCFF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesShippingModal.jsx');
	
	  __REACT_HOT_LOADER__.register(renderRadios, 'renderRadios', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesShippingModal.jsx');
	
	  __REACT_HOT_LOADER__.register(sortByLineID, 'sortByLineID', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesShippingModal.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesShippingModal.jsx');
	
	  __REACT_HOT_LOADER__.register(SalesShippingModal, 'SalesShippingModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesShippingModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/salesShippingModal.jsx');
	}();

	;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _lodash = __webpack_require__(19);
	
	var _root_url = __webpack_require__(9);
	
	var _constants = __webpack_require__(11);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _numberWithCommas = __webpack_require__(35);
	
	var _shipToOrders_actions = __webpack_require__(91);
	
	var _shipFromOrders_actions = __webpack_require__(143);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(5),
	    _require$Draggable = _require.Draggable,
	    DraggableContainer = _require$Draggable.Container,
	    RowActionsCell = _require$Draggable.RowActionsCell,
	    DropTargetRowContainer = _require$Draggable.DropTargetRowContainer,
	    Selectors = _require.Data.Selectors;
	
	var PreOrder = function (_Component) {
	  _inherits(PreOrder, _Component);
	
	  function PreOrder() {
	    _classCallCheck(this, PreOrder);
	
	    var _this = _possibleConstructorReturn(this, (PreOrder.__proto__ || Object.getPrototypeOf(PreOrder)).call(this));
	
	    _this.state = {
	      breadcrumbTitle: 'ship_from_orders',
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.fiveLineButton,
	      shipFromOrders: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      salesOrderDetail: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      rowsCount: 0,
	      total: 0,
	      canceledOrders: 0,
	      canceledTotal: 0
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    return _this;
	  }
	
	  _createClass(PreOrder, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.console.log('componentDidMount');
	      window.addEventListener('resize', this.handleResize);
	      document.title = _root_url.companyCodeTitle;
	      this.props.fetchShipFromOrders();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.console.log('componentWillUnmount');
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      window.console.log('componentWillReceiveProps', nextProps);
	      if (nextProps.shipFromOrders && nextProps.shipFromOrders !== this.props.shipFromOrders) {
	        // Split Weight
	        if (this.state.shipFromOrders.selectedRows && this.state.shipFromOrders.selectedRows.length === 1) {
	          nextProps.shipFromOrders.Orders.map(function (orders) {
	            if (orders.Shiporder_id === _this2.state.shipFromOrders.selectedRows[0].Shiporder_id) {
	              _this2.state.shipFromOrders.selectedRows[0].FinalShippingWeight = orders.FinalShippingWeight;
	            }
	          });
	        }
	        this.setState({ total: nextProps.shipFromOrders.Rows });
	
	        var shipFromOrders = _extends({}, this.state.shipFromOrders, {
	          rows: nextProps.shipFromOrders.Orders,
	          filters: {}
	        });
	        var selectedRows0 = shipFromOrders.selectedRows[0];
	        if (selectedRows0) {
	          for (var i = 0; i < shipFromOrders.rows.length; i++) {
	            if (selectedRows0.Shiporder_id === shipFromOrders.rows[i].Shiporder_id) {
	              shipFromOrders.rows[i].isSelected = true;
	            }
	          }
	        }
	
	        var salesOrderDetail = _extends({}, this.state.salesOrderDetail, { rows: [] });
	        this.setState({ shipFromOrders: shipFromOrders, salesOrderDetail: salesOrderDetail });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      window.console.log('shouldComponentUpdate', nextProps, nextState);
	      return true;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      window.console.log('shouldComponentUpdate', prevProps, prevState);
	      if (prevState.shipFromOrders !== this.state.shipFromOrders) {
	        var canceledTotal = 0;
	        var canceledOrders = this.state.shipFromOrders.rows.filter(function (row) {
	          var match = row.SaleStatus === "Canceled";
	          if (match) {
	            canceledTotal += row.FinalPrice;
	          }
	          return match;
	        });
	        this.setState({
	          rowsCount: _reactDataGridAddons.Data.Selectors.getRows(this.state.shipFromOrders).length,
	          canceledOrders: canceledOrders.length,
	          canceledTotal: canceledTotal
	        });
	      }
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      this.setState({
	        tableHeight: window.innerHeight - _constants.UI_HEIGHT.fiveLineButton
	      });
	    }
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this3 = this;
	
	      var route = this.context.router.routes[1].path;
	      // Parameters of the react-data-grid
	      var tableHeight = window.innerHeight < 930 ? 270 : 270;
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.shipFromOrders);
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        _this3.state.total = 0;
	        for (var i = 0; i < rows.length; i++) {
	          _this3.state.total += rows[i].FinalPrice;
	        }
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this3.state.shipFromOrders, {
	          sortColumn: sortColumn,
	          sortDirection: sortDirection
	        });
	        if (state.sortColumn === 'OrderDateDisplay') {
	          state.sortColumn = 'OrderDate';
	        }
	
	        if (state.sortDirection === 'ASC') {
	          _this3.state.pullSheetSort = state.sortColumn;
	        } else if (state.sortDirection === 'DESC') {
	          _this3.state.pullSheetSort = '-' + state.sortColumn;
	        } else {
	          _this3.state.pullSheetSort = '';
	        }
	        _this3.setState({ shipFromOrders: state });
	      };
	
	      var handleFilterChange = (0, _lodash.debounce)(function (filter) {
	        _this3.state.total = 0;
	        _this3.state.shipFromOrders.rows = _this3.props.shipFromOrders.Orders;
	        _this3.state.shipFromOrders.selectedRows = [];
	        var newFilters = Object.assign({}, _this3.state.shipFromOrders.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var shipFromOrders = _extends({}, _this3.state.shipFromOrders, { filters: newFilters });
	        _this3.setState({ shipFromOrders: shipFromOrders });
	      }, 500, { maxWait: 800 });
	
	      // Handle the row select function
	      var onRowClick = function onRowClick(rowIdx, row) {
	        if (rowIdx !== -1) {
	          var rows = getRows();
	          /* Multi row select on row click
	            let selectedRows = [...this.state.shipFromOrders.selectedRows];
	             let id = rows[rowIdx].SalesOrder_id;
	            let idx = selectedRows.indexOf(id);
	            if (idx == -1) {
	              rows[rowIdx].isSelected = true;
	              selectedRows.push(id);
	            } else {
	              rows[rowIdx].isSelected = false;
	              selectedRows.splice(idx, 1);
	            }
	          */
	
	          /* Single row select on row click */
	          rows.map(function (r) {
	            r.isSelected = false;
	          });
	          var selectedRows = [rows[rowIdx]];
	          rows[rowIdx].isSelected = true;
	
	          var shipFromOrders = _extends({}, _this3.state.shipFromOrders, { rows: rows, selectedRows: selectedRows });
	          _this3.setState({ shipFromOrders: shipFromOrders });
	          // this.props.fetchSalesOrderDetail(row.SalesOrder_id, route);
	        }
	      };
	
	      // Custom Formatter component
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            // const dateMap = [
	            //   'Jan',
	            //   'Feb',
	            //   'Mar',
	            //   'Apr',
	            //   'May',
	            //   'Jun',
	            //   'Jul',
	            //   'Aug',
	            //   'Sep',
	            //   'Oct',
	            //   'Nov',
	            //   'Dec',
	            // ];
	            var date = new Date(this.props.value);
	            // const index = dateMap.indexOf(date.toString().slice(4, 3));
	            // const localDate = index + date.toString().slice(8, 6);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      // Column difinition
	      var columns = [{
	        key: 'Order_Num',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 113
	      }, {
	        key: 'Note',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 124
	      }, {
	        key: 'PaaymentAmount',
	        name: 'Payment Amount',
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'TotalPrice',
	        name: 'Total Price',
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'file_path',
	        name: 'File Path',
	        resizable: true,
	        sortable: true,
	        width: 160,
	        filterable: true
	      }, {
	        key: 'FBA_id',
	        name: 'FBA ID',
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'OrderStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'PaymentStatus',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_status' }),
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: 'invoice_path',
	        name: 'Invoice Path',
	        resizable: true,
	        sortable: true,
	        width: 130,
	        filterable: true
	      }, {
	        key: 'mailing_label',
	        name: 'Mailing Label',
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: 'nonfba_address',
	        name: 'Non FBA Address',
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: 'nonfba_recipientname',
	        name: 'Non FBA Recipient Name',
	        resizable: true,
	        sortable: true,
	        width: 150,
	        filterable: true
	      }, {
	        key: 'nonfba_shipspeed',
	        name: 'Non FBA Ship Speed',
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: 'nonfba_upload_additional_doc',
	        name: 'Non FBA Upload Additional Doc',
	        resizable: true,
	        sortable: true,
	        width: 160,
	        filterable: true
	      }, {
	        key: 'warehouse_destination',
	        name: 'Warehouse Destination',
	        resizable: true,
	        sortable: true,
	        width: 105,
	        filterable: true
	      }, {
	        key: 'request_time',
	        name: 'Request Time',
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true,
	        formatter: DateFormatter
	      }, {
	        key: 'create_time',
	        name: 'Create Time',
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true,
	        formatter: DateFormatter
	      }];
	
	      var generateColumns = function generateColumns() {
	        return columns;
	      };
	      return (
	        // React Table Sales Order History Table
	        _react2.default.createElement(
	          'div',
	          { id: 'TNMSOTable' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'div',
	                { id: 'shipFromOrders-dataGrid1' },
	                _react2.default.createElement(_reactDataGrid2.default, {
	                  rowKey: 'Shiporder_id',
	                  ref: function ref(g) {
	                    _this3.grid = g;
	                  },
	                  onGridSort: handleGridSort,
	                  toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                  onAddFilter: handleFilterChange,
	                  columns: generateColumns(),
	                  rowHeight: 25,
	                  headerRowHeight: 45,
	                  rowGetter: rowGetter,
	                  rowsCount: getSize(),
	                  minHeight: tableHeight,
	                  enableRowSelect: 'multi',
	                  rowSelection: {
	                    showCheckbox: true,
	                    enableShiftSelect: true,
	                    selectBy: {
	                      isSelectedKey: 'isSelected'
	                    }
	                  },
	                  onRowClick: onRowClick
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 2 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'row-count' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_orders' }),
	                    ':\xA0',
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'font-color-orange', id: 'row-count-equation' },
	                      this.state.rowsCount + ' - ' + this.state.canceledOrders + ' = ' + (this.state.rowsCount - this.state.canceledOrders)
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 6 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'grand-total' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'grand-total-label' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'grand_total' }),
	                      ':\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'font-color-grey', id: 'total-equation' },
	                      '$' + (0, _numberWithCommas.numberWithCommas)((this.state.total || 0).toFixed(2)) + ' - $' + (0, _numberWithCommas.numberWithCommas)((this.state.canceledTotal || 0).toFixed(2)) + ' = $' + (0, _numberWithCommas.numberWithCommas)((this.state.total - this.state.canceledTotal).toFixed(2))
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mso-footnotes' },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_total_orders_equation' })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_grand_total_equation' })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: this.state.breadcrumbTitle })
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'sales-orders-list' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  {
	                    className: 'position-relative table-collapse-fix',
	                    id: 'table-collapse-fix-450',
	                    style: { marginBottom: '0px' }
	                  },
	                  this.renderTable()
	                )
	              )
	            ),
	            ' ',
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_details' })
	                ),
	                _react2.default.createElement(_reactBootstrap.Panel, { className: 'details-table-collapse-fix' })
	              )
	            ),
	            ' '
	          )
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return PreOrder;
	}(_react.Component);
	
	PreOrder.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = PreOrder;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PreOrder, 'PreOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/shipFromOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/shipFromOrders.jsx');
	}();

	;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _lodash = __webpack_require__(19);
	
	var _root_url = __webpack_require__(9);
	
	var _constants = __webpack_require__(11);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _numberWithCommas = __webpack_require__(35);
	
	var _shipToOrders_actions = __webpack_require__(91);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(5),
	    _require$Draggable = _require.Draggable,
	    DraggableContainer = _require$Draggable.Container,
	    RowActionsCell = _require$Draggable.RowActionsCell,
	    DropTargetRowContainer = _require$Draggable.DropTargetRowContainer,
	    Selectors = _require.Data.Selectors;
	
	var PreOrder = function (_Component) {
	  _inherits(PreOrder, _Component);
	
	  function PreOrder() {
	    _classCallCheck(this, PreOrder);
	
	    var _this = _possibleConstructorReturn(this, (PreOrder.__proto__ || Object.getPrototypeOf(PreOrder)).call(this));
	
	    _this.state = {
	      breadcrumbTitle: 'ship_to_orders',
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.fiveLineButton,
	      shipToOrders: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      salesOrderDetail: {
	        rows: [],
	        selectedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      rowsCount: 0,
	      total: 0,
	      canceledOrders: 0,
	      canceledTotal: 0
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    return _this;
	  }
	
	  _createClass(PreOrder, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.console.log('componentDidMount');
	      window.addEventListener('resize', this.handleResize);
	      document.title = _root_url.companyCodeTitle;
	      this.props.fetchShipToOrders();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.console.log('componentWillUnmount');
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      window.console.log('componentWillReceiveProps', nextProps);
	      if (nextProps.shipToOrders && nextProps.shipToOrders !== this.props.shipToOrders) {
	        // Split Weight
	        if (this.state.shipToOrders.selectedRows && this.state.shipToOrders.selectedRows.length === 1) {
	          nextProps.shipToOrders.Orders.map(function (orders) {
	            if (orders.Shiporder_id === _this2.state.shipToOrders.selectedRows[0].Shiporder_id) {
	              _this2.state.shipToOrders.selectedRows[0].FinalShippingWeight = orders.FinalShippingWeight;
	            }
	          });
	        }
	        this.setState({ total: nextProps.shipToOrders.Rows });
	
	        var shipToOrders = _extends({}, this.state.shipToOrders, {
	          rows: nextProps.shipToOrders.Orders,
	          filters: {}
	        });
	        var selectedRows0 = shipToOrders.selectedRows[0];
	        if (selectedRows0) {
	          for (var i = 0; i < shipToOrders.rows.length; i++) {
	            if (selectedRows0.Shiporder_id === shipToOrders.rows[i].Shiporder_id) {
	              shipToOrders.rows[i].isSelected = true;
	            }
	          }
	        }
	
	        var salesOrderDetail = _extends({}, this.state.salesOrderDetail, { rows: [] });
	        this.setState({ shipToOrders: shipToOrders, salesOrderDetail: salesOrderDetail });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      window.console.log('shouldComponentUpdate', nextProps, nextState);
	      return true;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      window.console.log('shouldComponentUpdate', prevProps, prevState);
	      if (prevState.shipToOrders !== this.state.shipToOrders) {
	        var canceledTotal = 0;
	        var canceledOrders = this.state.shipToOrders.rows.filter(function (row) {
	          var match = row.SaleStatus === "Canceled";
	          if (match) {
	            canceledTotal += row.FinalPrice;
	          }
	          return match;
	        });
	        this.setState({
	          rowsCount: _reactDataGridAddons.Data.Selectors.getRows(this.state.shipToOrders).length,
	          canceledOrders: canceledOrders.length,
	          canceledTotal: canceledTotal
	        });
	      }
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      this.setState({
	        tableHeight: window.innerHeight - _constants.UI_HEIGHT.fiveLineButton
	      });
	    }
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this3 = this;
	
	      var route = this.context.router.routes[1].path;
	      // Parameters of the react-data-grid
	      var tableHeight = window.innerHeight < 930 ? 270 : 270;
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.shipToOrders);
	      };
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        _this3.state.total = 0;
	        for (var i = 0; i < rows.length; i++) {
	          _this3.state.total += rows[i].FinalPrice;
	        }
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var state = Object.assign({}, _this3.state.shipToOrders, {
	          sortColumn: sortColumn,
	          sortDirection: sortDirection
	        });
	        if (state.sortColumn === 'OrderDateDisplay') {
	          state.sortColumn = 'OrderDate';
	        }
	
	        if (state.sortDirection === 'ASC') {
	          _this3.state.pullSheetSort = state.sortColumn;
	        } else if (state.sortDirection === 'DESC') {
	          _this3.state.pullSheetSort = '-' + state.sortColumn;
	        } else {
	          _this3.state.pullSheetSort = '';
	        }
	        _this3.setState({ shipToOrders: state });
	      };
	
	      var handleFilterChange = (0, _lodash.debounce)(function (filter) {
	        _this3.state.total = 0;
	        _this3.state.shipToOrders.rows = _this3.props.shipToOrders.Orders;
	        _this3.state.shipToOrders.selectedRows = [];
	        var newFilters = Object.assign({}, _this3.state.shipToOrders.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var shipToOrders = _extends({}, _this3.state.shipToOrders, { filters: newFilters });
	        _this3.setState({ shipToOrders: shipToOrders });
	      }, 500, { maxWait: 800 });
	
	      // Handle the row select function
	      var onRowClick = function onRowClick(rowIdx, row) {
	        if (rowIdx !== -1) {
	          var rows = getRows();
	          /* Multi row select on row click
	            let selectedRows = [...this.state.shipToOrders.selectedRows];
	             let id = rows[rowIdx].SalesOrder_id;
	            let idx = selectedRows.indexOf(id);
	            if (idx == -1) {
	              rows[rowIdx].isSelected = true;
	              selectedRows.push(id);
	            } else {
	              rows[rowIdx].isSelected = false;
	              selectedRows.splice(idx, 1);
	            }
	          */
	
	          /* Single row select on row click */
	          rows.map(function (r) {
	            r.isSelected = false;
	          });
	          var selectedRows = [rows[rowIdx]];
	          rows[rowIdx].isSelected = true;
	
	          var shipToOrders = _extends({}, _this3.state.shipToOrders, { rows: rows, selectedRows: selectedRows });
	          _this3.setState({ shipToOrders: shipToOrders });
	          // this.props.fetchSalesOrderDetail(row.SalesOrder_id, route);
	        }
	      };
	
	      // Custom Formatter component
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            // const dateMap = [
	            //   'Jan',
	            //   'Feb',
	            //   'Mar',
	            //   'Apr',
	            //   'May',
	            //   'Jun',
	            //   'Jul',
	            //   'Aug',
	            //   'Sep',
	            //   'Oct',
	            //   'Nov',
	            //   'Dec',
	            // ];
	            var date = new Date(this.props.value);
	            // const index = dateMap.indexOf(date.toString().slice(4, 3));
	            // const localDate = index + date.toString().slice(8, 6);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      // Column difinition
	      var columns = [{
	        key: 'Order_Num',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_num' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 113
	      }, {
	        key: 'ETA',
	        name: 'ETA',
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 95,
	        formatter: DateFormatter
	      }, {
	        key: 'Note',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        width: 124
	      }, {
	        key: 'ShipmentType',
	        name: 'Shipment Type',
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'StandardPallet',
	        name: 'Standard Pallet',
	        resizable: true,
	        sortable: true,
	        width: 90,
	        filterable: true
	      }, {
	        key: 'container20',
	        name: '20\' container',
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: 'container40',
	        name: '40\' container',
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: 'containerhq40',
	        name: '40\' HQ Container',
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true
	      }, {
	        key: 'RefFilePath',
	        name: 'Ref File Path',
	        resizable: true,
	        sortable: true,
	        width: 160,
	        filterable: true
	      }, {
	        key: 'Status',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	        resizable: true,
	        sortable: true,
	        width: 80,
	        filterable: true
	      }, {
	        key: 'warehouse_destination',
	        name: 'Warehouse Destination',
	        resizable: true,
	        sortable: true,
	        width: 105,
	        filterable: true
	      }, {
	        key: 'create_time',
	        name: 'Create Time',
	        resizable: true,
	        sortable: true,
	        width: 95,
	        filterable: true,
	        formatter: DateFormatter
	      }];
	
	      var generateColumns = function generateColumns() {
	        return columns;
	      };
	      return (
	        // React Table Sales Order History Table
	        _react2.default.createElement(
	          'div',
	          { id: 'TNMSOTable' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'div',
	                { id: 'shipToOrders-dataGrid1' },
	                _react2.default.createElement(_reactDataGrid2.default, {
	                  rowKey: 'Shiporder_id',
	                  ref: function ref(g) {
	                    _this3.grid = g;
	                  },
	                  onGridSort: handleGridSort,
	                  toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                  onAddFilter: handleFilterChange,
	                  columns: generateColumns(),
	                  rowHeight: 25,
	                  headerRowHeight: 45,
	                  rowGetter: rowGetter,
	                  rowsCount: getSize(),
	                  minHeight: tableHeight,
	                  enableRowSelect: 'multi',
	                  rowSelection: {
	                    showCheckbox: true,
	                    enableShiftSelect: true,
	                    selectBy: {
	                      isSelectedKey: 'isSelected'
	                    }
	                  },
	                  onRowClick: onRowClick
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 2 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'row-count' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_orders' }),
	                    ':\xA0',
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'font-color-orange', id: 'row-count-equation' },
	                      this.state.rowsCount + ' - ' + this.state.canceledOrders + ' = ' + (this.state.rowsCount - this.state.canceledOrders)
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 6 },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'grand-total' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'grand-total-label' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'grand_total' }),
	                      ':\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'font-color-grey', id: 'total-equation' },
	                      '$' + (0, _numberWithCommas.numberWithCommas)((this.state.total || 0).toFixed(2)) + ' - $' + (0, _numberWithCommas.numberWithCommas)((this.state.canceledTotal || 0).toFixed(2)) + ' = $' + (0, _numberWithCommas.numberWithCommas)((this.state.total - this.state.canceledTotal).toFixed(2))
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 4 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mso-footnotes' },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_total_orders_equation' })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_grand_total_equation' })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: this.state.breadcrumbTitle })
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'sales-orders-list' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  {
	                    className: 'position-relative table-collapse-fix',
	                    id: 'table-collapse-fix-450',
	                    style: { marginBottom: '0px' }
	                  },
	                  this.renderTable()
	                )
	              )
	            ),
	            ' ',
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_details' })
	                ),
	                _react2.default.createElement(_reactBootstrap.Panel, { className: 'details-table-collapse-fix' })
	              )
	            ),
	            ' '
	          )
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return PreOrder;
	}(_react.Component);
	
	PreOrder.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = PreOrder;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PreOrder, 'PreOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/shipToOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/shipToOrders.jsx');
	}();

	;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _constants = __webpack_require__(11);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _root_url = __webpack_require__(9);
	
	var _EditPosPaymentModal = __webpack_require__(653);
	
	var _EditPosPaymentModal2 = _interopRequireDefault(_EditPosPaymentModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewPosOrder = function (_Component) {
	  _inherits(ViewPosOrder, _Component);
	
	  function ViewPosOrder() {
	    _classCallCheck(this, ViewPosOrder);
	
	    var _this = _possibleConstructorReturn(this, (ViewPosOrder.__proto__ || Object.getPrototypeOf(ViewPosOrder)).call(this));
	
	    _this.openShowEditPayment = function () {
	      _this.setState({ showEditPaymentOpen: true });
	    };
	
	    _this.closeShowEditPayment = function () {
	      _this.setState({ showEditPaymentOpen: false });
	    };
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.editSalesInvPage,
	      totalPrice: 0,
	      totalTax: 0,
	      finalPrice: 0,
	      totalCRV: 0,
	
	      paymentInfo: {
	        cardAmount: 0,
	        cardNum: '',
	        cashAmount: 0,
	        change: 0,
	        checkAmount: 0,
	        checkNum: '',
	        creditAmount: 0,
	        mobileAmount: 0
	      },
	
	      posOrder: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      currentOrder: null,
	      showEditPaymentOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(ViewPosOrder, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.handleResize);
	      if (this.props.params && this.props.params.id) {
	        this.props.fetchPosOrderDetail(this.props.params.id);
	        this.setState({ currentOrder: this.props.params.id });
	      } else {
	        this.context.router.push('/posOrders/');
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.posOrderDetail && nextProps.posOrderDetail != this.props.posOrderDetail) {
	        var posOrder = _extends({}, this.state.posOrder, { rows: nextProps.posOrderDetail.POS_Order_Lines });
	        var totalPrice = nextProps.posOrderDetail.Subtotal || 0;
	        var totalTax = nextProps.posOrderDetail.SalesTax || 0;
	        var finalPrice = nextProps.posOrderDetail.FinalPrice || 0;
	        var totalCRV = nextProps.posOrderDetail.CRV || 0;
	
	        totalPrice = roundTo(totalPrice, 2).toFixed(2);
	        finalPrice = roundTo(finalPrice, 2).toFixed(2);
	        totalCRV = roundTo(totalCRV, 2).toFixed(2);
	        totalTax = roundTo(totalTax, 2).toFixed(2);
	
	        var _nextProps$posOrderDe = nextProps.posOrderDetail,
	            cashAmount = _nextProps$posOrderDe.CashAmount,
	            change = _nextProps$posOrderDe.Change,
	            checkAmount = _nextProps$posOrderDe.CheckAmount,
	            cardAmount = _nextProps$posOrderDe.CreditCardAmount,
	            creditAmount = _nextProps$posOrderDe.StoreCreditAmount,
	            mobileAmount = _nextProps$posOrderDe.MobileAmount;
	        var _nextProps$posOrderDe2 = nextProps.posOrderDetail,
	            checkNum = _nextProps$posOrderDe2.CheckNum,
	            cardNum = _nextProps$posOrderDe2.CreditCardNumber;
	
	
	        cashAmount = +roundTo(cashAmount, 2).toFixed(2);
	        change = +roundTo(change, 2).toFixed(2);
	        checkAmount = +roundTo(checkAmount, 2).toFixed(2);
	        cardAmount = +roundTo(cardAmount, 2).toFixed(2);
	        creditAmount = +roundTo(creditAmount, 2).toFixed(2);
	        mobileAmount = +roundTo(mobileAmount, 2).toFixed(2);
	
	        var paymentInfo = {
	          cashAmount: cashAmount,
	          change: change,
	          checkAmount: checkAmount,
	          cardAmount: cardAmount,
	          checkNum: checkNum,
	          cardNum: cardNum,
	          creditAmount: creditAmount,
	          mobileAmount: mobileAmount
	        };
	        this.setState({
	          posOrder: posOrder,
	          totalPrice: totalPrice,
	          totalTax: totalTax,
	          finalPrice: finalPrice,
	          totalCRV: totalCRV,
	          paymentInfo: paymentInfo
	        });
	      }
	    }
	  }, {
	    key: 'breadcrumbs',
	    value: function breadcrumbs() {
	      return _react2.default.createElement(
	        _reactBootstrap.Breadcrumb,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb.Item,
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pos_management' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb.Item,
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pos_order' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb.Item,
	          { active: 'true' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'view_pos_order' })
	        )
	      );
	    }
	  }, {
	    key: 'renderPosOrder',
	    value: function renderPosOrder() {
	      var _this2 = this;
	
	      var that = this;
	      if (this.props.detailIsLoading && !this.props.detailError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.detailError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.detailError)
	        )
	      );else {
	        // Parameters of the react-data-grid
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.posOrder);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var posOrder = _extends({}, _this2.state.posOrder, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this2.setState({ posOrder: posOrder });
	        };
	
	        var IsVariableFormatter = _react2.default.createClass({
	          displayName: 'IsVariableFormatter',
	          render: function render() {
	            if (this.props.dependentValues.ProductType !== "Non-Fixed") {
	              return _react2.default.createElement(
	                'span',
	                null,
	                this.props.value,
	                ' '
	              );
	            } else {
	              return _react2.default.createElement(
	                'span',
	                null,
	                this.props.value,
	                ' ',
	                _react2.default.createElement(
	                  'label',
	                  { className: 'label label-success' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'non_fixed' })
	                )
	              );
	            }
	          }
	        });
	
	        // Column difinition
	
	        var columns = [{
	          key: 'ProductNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	          resizable: true,
	          sortable: true,
	          width: 100
	        }, {
	          key: 'RefNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	          resizable: true,
	          sortable: true,
	          width: 70
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	          resizable: true,
	          sortable: true
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          resizable: true,
	          sortable: true
	        }, {
	          key: 'Quantity',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'qty' }),
	          resizable: true,
	          width: 40,
	          sortable: true,
	          formatter: IsVariableFormatter,
	          getRowMetaData: function getRowMetaData(row) {
	            return row;
	          }
	        }, {
	          key: 'PackageType',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pkg_type' }),
	          resizable: true,
	          width: 80,
	          sortable: true
	        }, {
	          key: 'TotalNetWeight',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_wt' }),
	          resizable: true,
	          width: 100,
	          sortable: true
	        }, {
	          key: 'UnitPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_dollarsign' }),
	          resizable: true,
	          width: 70,
	          sortable: true
	        }, {
	          key: 'TotalPrice',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' }),
	          resizable: true,
	          width: 80,
	          sortable: true
	        }];
	
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'div',
	              { id: 'ViewPosOrder-dataGrid1' },
	              _react2.default.createElement(_reactDataGrid2.default, {
	                rowKey: 'Product_id',
	                onGridSort: handleGridSort,
	                columns: columns,
	                rowHeight: 25,
	                headerRowHeight: 45,
	                rowGetter: rowGetter,
	                rowsCount: getSize(),
	                minHeight: this.state.tableHeight
	              })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var totalPrice = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_dollarsign' })
	      );
	      var tax = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' })
	      );
	      var crv = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'crv' })
	      );
	      var finalPriceHeader = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' })
	      );
	
	      var createDialogEditPaymentStyle = {
	        width: '550px',
	        height: '550px',
	        marginLeft: '-15%'
	      };
	
	      var _state = this.state,
	          posOrderID = _state.currentOrder,
	          paymentInfo = _state.paymentInfo,
	          finalPrice = _state.finalPrice;
	
	      var printUrl = _root_url.ROOT_URL + 'v1/pos/orders/print/' + posOrderID + '?Bearer=' + localStorage.getItem('token');
	      var excelUrl = _root_url.ROOT_URL + 'v1/pos/orders/excel/' + posOrderID + '?Bearer=' + localStorage.getItem('token');
	      if (this.props.detailIsLoading && !this.props.detailError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement('br', null),
	        '...',
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reading_data' })
	      );else if (this.props.detailError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          this.props.error
	        )
	      );else {
	        var posOrderDetail = this.props.posOrderDetail;
	
	        var posNumTitle = posOrderDetail && posOrderDetail.Order_Num || '';
	        return (
	          //---------------
	          // Begin HTML
	          //---------------
	          _react2.default.createElement(
	            _ContentWrapper2.default,
	            null,
	            this.breadcrumbs(),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'warning',
	                  type: 'button',
	                  onClick: this.openShowEditPayment
	                },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_payment_method' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'primary',
	                  type: 'button',
	                  href: printUrl },
	                _react2.default.createElement('em', { className: 'fa fa-print' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  type: 'button',
	                  href: excelUrl },
	                _react2.default.createElement('em', { className: 'fa fa-download' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'danger',
	                  type: 'reset',
	                  onClick: function onClick() {
	                    _this3.context.router.push('/posOrders');
	                  } },
	                _react2.default.createElement('em', { className: 'fa fa-close' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Grid,
	              { fluid: 'true', id: 'edit-sales-invoice' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                posNumTitle
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'row-wrapper' },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 10, className: 'mb0' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    null,
	                    this.renderPosOrder()
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { xs: 2, className: 'position-absolute' },
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { header: totalPrice },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-control-static' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'dollar-sign' },
	                        '$'
	                      ),
	                      this.state.totalPrice
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { header: tax },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-control-static' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'dollar-sign' },
	                        '$'
	                      ),
	                      this.state.totalTax
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { header: crv },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-control-static' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'dollar-sign' },
	                        '$'
	                      ),
	                      this.state.totalCRV
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { header: finalPriceHeader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-control-static' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'dollar-sign' },
	                        '$'
	                      ),
	                      this.state.finalPrice
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              {
	                dialogStyles: createDialogEditPaymentStyle,
	                isVisible: this.state.showEditPaymentOpen,
	                onCloseClicked: this.closeShowEditPayment,
	                title: 'edit payment info'
	              },
	              _react2.default.createElement(_EditPosPaymentModal2.default, {
	                posID: posOrderID,
	                paymentInfo: _extends({}, paymentInfo, {
	                  finalPrice: finalPrice
	                }),
	                onCloseClicked: this.closeShowEditPayment
	              })
	            )
	          )
	          //---------------
	          // End HTML
	          //---------------
	
	        );
	      }
	    }
	  }]);
	
	  return ViewPosOrder;
	}(_react.Component);
	
	ViewPosOrder.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var _default = (0, _reactRouter.withRouter)(ViewPosOrder);
	
	exports.default = _default;
	
	
	function roundTo(n, digits) {
	  if (digits === undefined) {
	    digits = 0;
	  }
	
	  var multiplicator = Math.pow(10, digits);
	  n = parseFloat((n * multiplicator).toFixed(11));
	  var test = Math.round(n) / multiplicator;
	  return +test.toFixed(2);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(roundTo, 'roundTo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/viewPosOrder.jsx');
	
	  __REACT_HOT_LOADER__.register(ViewPosOrder, 'ViewPosOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/viewPosOrder.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/viewPosOrder.jsx');
	}();

	;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(13);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Wholesale = function (_Component) {
	    _inherits(Wholesale, _Component);
	
	    function Wholesale() {
	        _classCallCheck(this, Wholesale);
	
	        var _this = _possibleConstructorReturn(this, (Wholesale.__proto__ || Object.getPrototypeOf(Wholesale)).call(this));
	
	        _this.state = {
	            tableHeight: window.innerHeight - _constants.UI_HEIGHT.fourLineButton,
	
	            salesOrders: {
	                rows: [],
	                selectedRows: null,
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            salesOrderDetail: {
	                rows: [],
	                selectedRows: null,
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            }
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        return _this;
	    }
	
	    _createClass(Wholesale, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	            this.props.fetchWholesale();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        // Once products are ready, reset state.
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.wholesale && nextProps.wholesale != this.props.wholesale) {
	                var salesOrders = _extends({}, this.state.salesOrders, { rows: nextProps.wholesale });
	                this.setState({ salesOrders: salesOrders });
	            }
	
	            if (nextProps.salesOrderDetail && nextProps.salesOrderDetail != this.props.salesOrderDetail) {
	                var salesOrderDetail = _extends({}, this.state.salesOrderDetail, { rows: nextProps.salesOrderDetail.Batch_Order_Lines });
	                console.log(salesOrderDetail);
	                this.setState({ salesOrderDetail: salesOrderDetail });
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.fourLineButton });
	        }
	
	        // Set product being selected to be currentProduct and navigate user to the edit page
	
	    }, {
	        key: 'setCurrentWholesale',
	        value: function setCurrentWholesale(e) {
	            e.preventDefault();
	            var currentWholesale = this.state.selectedRows[0];
	            this.props.resetCurrentWholesale();
	            this.props.selectWholesale(currentWholesale);
	            this.context.router.push('/wholesale/' + currentWholesale.Wholesale_id);
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            this.props.resetCurrentWholesale();
	            this.context.router.push('/wholesale/new');
	        }
	    }, {
	        key: 'voidOrder',
	        value: function voidOrder() {
	            var _this2 = this;
	
	            var newRows = this.state.salesOrders.rows;
	            this.state.salesOrders.selectedRows.map(function (row) {
	                _this2.props.voidSalesOrder(row.SalesOrder_id, 'salesOrders');
	                newRows = newRows.filter(function (obj) {
	                    return obj.SalesOrder_id !== row.SalesOrder_id;
	                });
	                var salesOrders = _extends({}, _this2.state.salesOrders, { rows: newRows });
	                _this2.setState({ salesOrders: salesOrders });
	            });
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this3 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.salesOrders);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this3.state.salesOrders, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this3.setState({ salesOrders: state });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this3.state.salesOrders.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var salesOrders = _extends({}, _this3.state.salesOrders, { filters: newFilters });
	                    _this3.setState({ salesOrders: salesOrders });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var salesOrders = _extends({}, _this3.state.salesOrders, { selectedRows: rows });
	                    _this3.setState({ salesOrders: salesOrders });
	                };
	
	                var onRowClick = function onRowClick(rowIdx, row) {
	                    _this3.props.fetchWholesaleOrderDetail(row.SalesOrder_id);
	                };
	
	                //Custom Formatter component
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNameFormatter = _react2.default.createClass({
	                    displayName: 'VendorNameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNumFormatter = _react2.default.createClass({
	                    displayName: 'VendorNumFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.VendorNum
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'SONum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'so_no' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'Deliver_Customer_num',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_no' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'Deliver_CustomerName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 189,
	                    filterable: true
	                }, {
	                    key: 'Description',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 260,
	                    filterable: true
	                }, {
	                    key: 'TotalPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_price' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 125,
	                    filterable: true
	                }, {
	                    key: 'Sales_User_id',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 178,
	                    filterable: true
	                }, {
	                    key: 'SaleStatus',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'status' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120,
	                    filterable: true
	                }, {
	                    key: 'UpdateTime',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'document_date' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 170,
	                    filterable: true,
	                    formatter: DateFormatter
	                }, {
	                    key: 'DispatchDate',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'schedule_shipping_date' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200,
	                    filterable: true,
	                    formatter: DateFormatter
	                }, {
	                    key: 'ShipmentDate',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_date' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 115,
	                    filterable: true,
	                    formatter: DateFormatter
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'Wholesale-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'SalesOrder_id',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowHeight: 25,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: this.state.tableHeight / 3 * 2,
	                                enableRowSelect: 'multi',
	                                onRowSelect: onRowSelect,
	                                onRowClick: onRowClick
	                            })
	                        )
	                    )
	                );
	            }
	        }
	
	        // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	    }, {
	        key: 'renderProductsTable',
	        value: function renderProductsTable() {
	            var _this4 = this;
	
	            if (this.props.detailIsLoading && !this.props.detailError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.detailError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.detailError)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this4.state.salesOrderDetail);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this4.state.salesOrderDetail, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this4.setState({ salesOrderDetail: state });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this4.state.salesOrderDetail.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var salesOrderDetail = _extends({}, _this4.state.salesOrderDetail, { filters: newFilters });
	                    _this4.setState({ salesOrderDetail: salesOrderDetail });
	                };
	
	                //Custom Formatter component
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNameFormatter = _react2.default.createClass({
	                    displayName: 'VendorNameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNumFormatter = _react2.default.createClass({
	                    displayName: 'VendorNumFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.VendorNum
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductNum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200
	                }, {
	                    key: 'Name',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 200
	                }, {
	                    key: 'Description',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 800
	                }, {
	                    key: 'Quantity',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120
	                }, {
	                    key: 'MeasureUnit',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_of_measure' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 150
	                }, {
	                    key: 'UnitPrice',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 147
	                }, {
	                    key: 'Batch_PONum',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 150
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'Wholesale-dataGrid2' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'Wholesale_id',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                rowHeight: 25,
	                                minHeight: this.state.tableHeight / 3,
	                                onRowUpdated: this.handleRowUpdated })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'checkPermission',
	        value: function checkPermission(permission) {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            var fullList = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'full_list_table_sales_order' });
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content-heading' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'wholesale' })
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    _reactBootstrap.Panel,
	                    { header: fullList },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { className: 'btn btn-primary pull-right', type: 'submit', onClick: function onClick(event) {
	                                _this5.clickNew(event);
	                            }, disabled: this.checkPermission("add_sales_order") },
	                        _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_so' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { className: 'btn btn-primary pull-right' },
	                        _react2.default.createElement('em', { className: 'fa fa-print marginRightStyle' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { className: 'btn btn-danger pull-right', onClick: function onClick() {
	                                _this5.voidOrder();
	                            } },
	                        _react2.default.createElement('em', { className: 'fa fa-trash marginRightStyle' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'void' })
	                    ),
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sales_order_full_table' }),
	                        'S'
	                    ),
	                    _react2.default.createElement('hr', null),
	                    this.renderTable(),
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'detail_information' })
	                    ),
	                    _react2.default.createElement('hr', null),
	                    this.renderProductsTable()
	                )
	            );
	        }
	    }]);
	
	    return Wholesale;
	}(_react.Component);
	
	Wholesale.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = Wholesale;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(Wholesale, 'Wholesale', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/wholesale.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/wholesale.jsx');
	}();

	;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _inputField = __webpack_require__(16);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WholesaleModal = function (_Component) {
	    _inherits(WholesaleModal, _Component);
	
	    function WholesaleModal() {
	        _classCallCheck(this, WholesaleModal);
	
	        var _this = _possibleConstructorReturn(this, (WholesaleModal.__proto__ || Object.getPrototypeOf(WholesaleModal)).call(this));
	
	        _this.state = {
	            rows: [],
	            selectedRows: [],
	            editedRows: [],
	            filters: {},
	            sortColumn: null,
	            sortDirection: null
	        };
	        return _this;
	    }
	
	    _createClass(WholesaleModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.fetchInventoryBatches(this.props.ProductNum);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.inventoryBatches && nextProps.inventoryBatches != this.props.inventoryBatches) {
	                this.setState({ rows: nextProps.inventoryBatches });
	            }
	        }
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this2 = this;
	
	            if (this.props.isLoading) return _react2.default.createElement(_spinner2.default, null);else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this2.setState(state);
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this2.state.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    _this2.setState({ filters: newFilters });
	                };
	
	                // Handle the row select function
	
	                var onRowSelect = function onRowSelect(rows) {
	                    _this2.setState({ selectedRows: rows });
	                };
	
	                var handleRowUpdated = function handleRowUpdated(e) {
	                    // merge updated row with current row and rerender by setting state
	                    var rows = _this2.state.rows.slice(0);
	                    var editedRows = _this2.state.editedRows.slice(0);
	                    Object.assign(rows[e.rowIdx], e.updated);
	                    if (e.updated.Quantity != null) {
	                        Object.assign(rows[e.rowIdx], { Total: parseFloat(e.updated.Quantity * rows[e.rowIdx].UnitPrice).toFixed(2) });
	                    }
	                    if (e.updated.UnitPrice != null) {
	                        Object.assign(rows[e.rowIdx], { Total: parseFloat(e.updated.UnitPrice * rows[e.rowIdx].Quantity).toFixed(2) });
	                    }
	                    // if the element is already edited, remove the old one.
	                    editedRows.forEach(function (element, index) {
	                        console.log(element.id, rows[e.rowIdx].id);
	                        if (element.id === rows[e.rowIdx].id) editedRows.splice(index, 1);
	                    }, _this2);
	                    // push the row into the editedRows array
	                    editedRows.push(rows[e.rowIdx]);
	                    _this2.setState({
	                        rows: rows,
	                        editedRows: editedRows
	                    });
	                };
	
	                // const onRowClick = (rowIdx, row) => {
	                //     this.props.fetchSalesOrders();
	                // }
	
	                //Custom Formatter component
	
	                var DateFormatter = _react2.default.createClass({
	                    displayName: 'DateFormatter',
	                    render: function render() {
	                        if (this.props.value) {
	                            var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                            var date = new Date(this.props.value);
	                            var index = dateMap.indexOf(date.toString().slice(4, 3));
	                            var localDate = index + date.toString().slice(8, 6);
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                date.toString().slice(4, 15)
	                            );;
	                        } else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNameFormatter = _react2.default.createClass({
	                    displayName: 'VendorNameFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.Name
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                var VendorNumFormatter = _react2.default.createClass({
	                    displayName: 'VendorNumFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.value.VendorNum
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            '-'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'Batch_PONum',
	                    name: 'Batch No.',
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'BatchAmount',
	                    name: 'In Stock',
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'Quantity',
	                    name: 'Quantity',
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true,
	                    editable: true
	                }, {
	                    key: 'ProductUnitOfMeasure',
	                    name: 'Unit',
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }, {
	                    key: 'UnitPrice',
	                    name: 'Unit Price',
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true,
	                    editable: true
	                }, {
	                    key: 'Total',
	                    name: 'Total Price',
	                    resizable: true,
	                    sortable: true,
	                    width: 100,
	                    filterable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'WholesaleModal-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                style: { height: 250 },
	                                rowKey: 'id',
	                                enableCellSelect: true,
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                onRowUpdated: handleRowUpdated,
	                                onRowSelect: onRowSelect })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                closeC = _props.closeC,
	                moveToSO = _props.moveToSO;
	
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement('hr', null),
	                this.renderTable(),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { action: 'submit', onClick: function onClick(event) {
	                                moveToSO(_this3.state.rows);closeC();
	                            }, className: 'btn btn-primary col-sm-11 buttonStyle' },
	                        'Move to S.O.'
	                    )
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-danger col-sm-11 buttonStyle', onClick: function onClick(event) {
	                                event.preventDefault();closeC();
	                            } },
	                        'Cancel'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return WholesaleModal;
	}(_react.Component);
	
	var _default = WholesaleModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(WholesaleModal, 'WholesaleModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/wholesaleModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/wholesaleModal.jsx');
	}();

	;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _constants = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _inputField = __webpack_require__(16);
	
	var _isActive = __webpack_require__(96);
	
	var _isActive2 = _interopRequireDefault(_isActive);
	
	var _afterAddonField = __webpack_require__(93);
	
	var _afterAddonField2 = _interopRequireDefault(_afterAddonField);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _customerForm = __webpack_require__(171);
	
	var _customerForm2 = _interopRequireDefault(_customerForm);
	
	var _datePicker = __webpack_require__(27);
	
	var _wholesaleModal = __webpack_require__(677);
	
	var _wholesaleModal2 = _interopRequireDefault(_wholesaleModal);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WholesaleOrderForm = function (_Component) {
	    _inherits(WholesaleOrderForm, _Component);
	
	    function WholesaleOrderForm() {
	        _classCallCheck(this, WholesaleOrderForm);
	
	        var _this = _possibleConstructorReturn(this, (WholesaleOrderForm.__proto__ || Object.getPrototypeOf(WholesaleOrderForm)).call(this));
	
	        _this.state = {
	            cellSelectEnabled: true,
	
	            customerOpen: false,
	            batchOpen: false,
	            dirty: false,
	            favoriteItemsOpen: true,
	            previousOrdersOpen: false,
	            promotionsOpen: false,
	            currentCustomer: null,
	            currentCustomerName: null,
	            customersWithFavorites: [],
	            selectedItemName: '',
	            selectedItemNumber: '',
	            totalPrice: null,
	            finalWeight: null,
	
	            rows: [],
	            selectedRows: null,
	            filters: {},
	            sortColumn: null,
	            sortDirection: null,
	            inventoryInput: null,
	
	            inventories: {
	                rows: [],
	                allRows: [],
	                currString: null,
	                selectedRows: null,
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            favorites: {
	                rows: [],
	                selectedRows: null,
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            previousOrders: {
	                rows: [],
	                selectedRows: null,
	                sortColumn: null,
	                sortDirection: null
	            },
	
	            promotions: {
	                rows: [],
	                selectedRows: null,
	                sortColumn: null,
	                sortDirection: null
	            }
	        };
	        _this.openCustomer = _this.openCustomer.bind(_this);
	        _this.closeCustomer = _this.closeCustomer.bind(_this);
	        _this.moveToSO = _this.moveToSO.bind(_this);
	        _this.removeFromSO = _this.removeFromSO.bind(_this);
	        _this.openChooseFromBatch = _this.openChooseFromBatch.bind(_this);
	        _this.closeChooseFromBatch = _this.closeChooseFromBatch.bind(_this);
	        return _this;
	    }
	
	    _createClass(WholesaleOrderForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {}
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var currentSalesOrder = this.props.currentSalesOrder;
	
	            if (currentSalesOrder) this.props.fetchSalesOrderDetail(currentSalesOrder.SalesOrder_id).then(function () {
	                _this2.props.fetchInventories();
	                _this2.props.fetchCustomers();
	                _this2.props.fetchCustomersWithFavorites();
	                _this2.props.fetchPreviousOrders();
	                _this2.props.fetchPromotions();
	            });else {
	                this.props.fetchInventories();
	                this.props.fetchCustomers();
	                this.props.fetchCustomersWithFavorites();
	                this.props.fetchPreviousOrders();
	                this.props.fetchPromotions();
	            }
	            // making a leaving hook to confirm leaving
	            this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            (0, _reduxForm.reset)('productForm');
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.dirty != this.props.dirty) {
	                this.setState({
	                    dirty: nextProps.dirty
	                });
	            }
	
	            if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
	                var inventoryItems = [].concat(_toConsumableArray(nextProps.inventories));
	
	                // inventoryItems.map(item => {
	                //   item.Weight = item.ProductNum.NetWeight;
	                //   item.IsOverSaleable = item.ProductNum.IsOverSaleable;
	                //   item.Name = item.ProductNum.Name;
	                //   item.Ordered = item.Purchased;
	                //   item.Price = item.RefPurchasingPrice;
	                //   item.ItemNum = item.ProductNum.ProductNum;
	                // })
	                var inventories = _extends({}, this.state.inventories, { allRows: inventoryItems, rows: inventoryItems });
	                console.log("inventories", inventories);
	                this.setState({ inventories: inventories });
	            }
	
	            if (nextProps.inventoryIdValue && nextProps.inventoryIdValue != this.props.inventoryIdValue) {
	                var filteredRows = this.state.inventories.allRows.filter(function (obj) {
	                    return String(obj.ProductNum.ProductNum).includes(String(nextProps.inventoryIdValue));
	                });
	
	                var _inventories = _extends({}, this.state.inventories, { rows: filteredRows });
	                this.setState({ inventories: _inventories });
	
	                var index = _lodash2.default.findIndex(filteredRows, { 'ItemNum': nextProps.inventoryIdValue });
	                if (index > -1) {
	                    console.log(filteredRows[index].ProductNum.Name, nextProps.inventoryIdValue);
	                    this.setState({
	                        selectedItemName: filteredRows[index].ProductNum.Name,
	                        selectedItemNumber: nextProps.inventoryIdValue
	                    });
	                }
	            }
	
	            if (nextProps.customersWithFavorites && nextProps.customersWithFavorites != this.props.customersWithFavorites) {
	                var _index = _lodash2.default.findIndex(nextProps.customersWithFavorites, { 'Customer_id': this.state.currentCustomer });
	                if (_index != -1) {
	                    var newFavorites = [].concat(_toConsumableArray(nextProps.customersWithFavorites[_index].Sales_FavoriteList_Lines));
	
	                    this.state.rows.map(function (row) {
	                        var check = _lodash2.default.findIndex(newFavorites, { 'ProductNum': row.ProductNum });
	                        if (check != -1) {
	                            newFavorites[_index].inList = true;
	                        }
	                    });
	
	                    var _favorites = _extends({}, this.state.favorites, { rows: newFavorites });
	                    this.setState({ favorites: _favorites });
	                }
	            }
	
	            if (nextProps.previousOrders && nextProps.previousOrders != this.props.previousOrders) {
	                var previousOrders = _extends({}, this.state.previousOrders, { rows: nextProps.previousOrders });
	                this.setState({ previousOrders: previousOrders });
	            }
	
	            if (nextProps.promotions && nextProps.promotions != this.props.promotions) {
	                var promotions = _extends({}, this.state.promotions, { rows: nextProps.promotions });
	                this.setState({ promotions: promotions });
	            }
	
	            if (nextProps.customerChosen && nextProps.customerChosen != this.props.customerChosen) {
	                var _index2 = _lodash2.default.findIndex(this.props.customersWithFavorites, { 'Customer_id': nextProps.customerChosen.value });
	                if (_index2 != -1) {
	                    var newFavRows = this.props.customersWithFavorites[_index2].Sales_FavoriteList_Lines;
	                    this.state.rows.map(function (row) {
	                        var rowPos = _lodash2.default.findIndex(newFavRows, { 'ProductNum': row.ProductNum });
	                        if (rowPos != -1) {
	                            newFavRows[rowPos].inList = true;
	                        }
	                    });
	
	                    var favorites = _extends({}, this.state.favorites, { rows: newFavRows });
	                    this.setState({ favorites: favorites, currentCustomer: nextProps.customerChosen.value, currentCustomerName: nextProps.customerChosen.label });
	                }
	            }
	        }
	    }, {
	        key: 'routerWillLeave',
	        value: function routerWillLeave(nextLocation) {
	            if (this.state.dirty) return _react2.default.createElement(_reactReduxI18n.Translate, { value: 'work_not_saved_warning' });
	        }
	
	        // Helper function to pop up the add payment term function
	
	    }, {
	        key: 'openCustomer',
	        value: function openCustomer() {
	            this.setState({ customerOpen: true });
	        }
	    }, {
	        key: 'closeCustomer',
	        value: function closeCustomer() {
	            this.setState({ customerOpen: false });
	        }
	    }, {
	        key: 'openChooseFromBatch',
	        value: function openChooseFromBatch() {
	            var index = _lodash2.default.findIndex(this.state.inventories.allRows, { 'ProductNum': this.state.selectedItemNumber });
	            console.log("item to select", this.state.inventories.allRows[index]);
	            if (this.state.inventories.allRows[index].InStock > 0) {
	                this.setState({ batchOpen: true });
	            } else {
	                alert("Item has none in stock!");
	            }
	        }
	    }, {
	        key: 'closeChooseFromBatch',
	        value: function closeChooseFromBatch() {
	            this.setState({ batchOpen: false });
	        }
	    }, {
	        key: 'handleFormSubmit',
	        value: function handleFormSubmit(formProps) {
	            this.setState({ dirty: false });
	            if (!this.props.currentSalesOrder) this.props.createSalesOrder(formProps);else {
	                if (!this.checkPermission("change_sales_order")) this.props.editSalesOrder(formProps);else alert("You have no permission!");
	            }
	        }
	    }, {
	        key: 'title',
	        value: function title() {
	            if (!this.props.params.id) {
	                return _react2.default.createElement(
	                    'h3',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_a_new_sales_order' })
	                );
	            }
	            return _react2.default.createElement(
	                'h3',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_sales_order' }),
	                ' ',
	                this.props.params.id
	            );
	        }
	
	        // Render the customers selection, including name and number.
	
	    }, {
	        key: 'renderCustomers',
	        value: function renderCustomers() {
	            if (this.props.customersIsLoading) return _react2.default.createElement(_spinner2.default, null); // If payment term is loading, show a spinner.
	            else {
	                    var customerNameOptions = this.getCustomerNameOptions();
	                    var customerNumOptions = this.getCustomerNumOptions();
	                    return _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 12 },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_name' }),
	                                    ': '
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Customer_id', component: _selection2.default, options: customerNameOptions })
	                            )
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 12 },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_no' }),
	                                    ': '
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Customer_id', component: _selection2.default, options: customerNumOptions })
	                            )
	                        )
	                    );
	                }
	        }
	    }, {
	        key: 'getCustomerNameOptions',
	        value: function getCustomerNameOptions() {
	            var customerOptions = [];
	            this.props.customers.map(function (customer) {
	                customerOptions.push({ value: customer.Customer_id, label: customer.Name });
	            });
	            return customerOptions;
	        }
	    }, {
	        key: 'getCustomerNumOptions',
	        value: function getCustomerNumOptions() {
	            var customerOptions = [];
	            this.props.customers.map(function (customer) {
	                customerOptions.push({ value: customer.Customer_id, label: customer.CustomerNum });
	            });
	            return customerOptions;
	        }
	
	        // Render the product selection
	
	    }, {
	        key: 'renderInventories',
	        value: function renderInventories() {
	            var _this3 = this;
	
	            if (this.props.inventoriesIsLoading) return _react2.default.createElement(_spinner2.default, null); // If payment term is loading, show a spinner.
	            else {
	                    // Parameters of the react-data-grid
	
	                    var getRows = function getRows() {
	                        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.inventories);
	                    };
	
	                    var getSize = function getSize() {
	                        return getRows().length;
	                    };
	
	                    var rowGetter = function rowGetter(rowIdx) {
	                        var rows = getRows();
	                        return rows[rowIdx];
	                    };
	
	                    // Handle the sortable function
	
	                    var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                        var inventories = _extends({}, _this3.state.inventories, { sortColumn: sortColumn, sortDirection: sortDirection });
	                        _this3.setState({ inventories: inventories });
	                    };
	
	                    var handleFilterChange = function handleFilterChange(filter) {
	                        var newFilters = Object.assign({}, _this3.state.inventories.filters);
	                        if (filter.filterTerm) {
	                            newFilters[filter.column.key] = filter;
	                        } else {
	                            delete newFilters[filter.column.key];
	                        }
	                        var inventories = _extends({}, _this3.state.inventories, { filters: newFilters });
	                        _this3.setState({ inventories: inventories });
	                    };
	
	                    // Handle the row select function
	
	                    var onRowClick = function onRowClick(rowIdx, row) {
	                        var rows = _this3.state.inventories.rows;
	                        rows.map(function (row) {
	                            row.isSelected = false;
	                        });
	                        rows[rowIdx] = Object.assign({}, row, { isSelected: true });
	                        var inventories = _extends({}, _this3.state.inventories, { rows: rows });
	                        _this3.setState({ inventories: inventories, cellSelectEnabled: false, selectedItemName: row.Name, selectedItemNumber: row.ProductNum, refPrice: row.Price });
	                    };
	
	                    var onRowsSelected = function onRowsSelected(rows) {
	                        var newRows = _this3.state.inventories.rows;
	                        rows.map(function (r) {
	                            newRows[r.rowIdx].isSelected = true;
	                        });
	                        var inventories = _extends({}, _this3.state.inventories, { rows: newRows });
	                        _this3.setState({ inventories: inventories });
	                    };
	
	                    var onRowsDeselected = function onRowsDeselected(rows) {
	                        var newRows = _this3.state.inventories.rows;
	                        rows.map(function (r) {
	                            newRows[r.rowIdx].isSelected = false;
	                        });
	                        var inventories = _extends({}, _this3.state.inventories, { rows: newRows });
	                        _this3.setState({ inventories: inventories });
	                    };
	
	                    var onKeyDown = function onKeyDown(e) {
	                        console.log(_this3);
	                        console.log(e);
	                        var currentSelected = null;
	                        if (e.keyCode === 40 || e.keyCode === 38) {
	                            e.preventDefault();
	
	                            var rows = [];
	                            _this3.state.inventories.rows.forEach(function (r) {
	                                if (r.isSelected == true) {
	                                    currentSelected = r.id;
	                                }
	                                rows.push(Object.assign({}, r, { isSelected: false }));
	                            });
	
	                            var index = _lodash2.default.findIndex(rows, { 'id': currentSelected });
	                            if (e.keyCode === 40) {
	                                if (index == rows.length - 1) return;
	                                rows[index + 1].isSelected = true;
	                            } else {
	                                if (index == 0) return;
	                                rows[index - 1].isSelected = true;
	                            }
	                            var inventories = _extends({}, _this3.state.inventories, { rows: rows });
	                            _this3.setState({ inventories: inventories });
	                        } else if (e.keyCode === 13) {
	                            console.log("entered block for enter");
	                            e.preventDefault();
	
	                            _this3.state.inventories.rows.forEach(function (r) {
	                                if (r.isSelected == true) {
	                                    currentSelected = r;
	                                }
	                            });
	                            console.log(currentSelected);
	                            if (currentSelected != null) {
	                                _this3.setState({ selectedItemName: currentSelected.Name, selectedItemNumber: currentSelected.ItemNum, refPrice: currentSelected.Price }, _this3["chooseFromBatch"].props.onClick);
	                            }
	                        }
	                    };
	
	                    var RowRenderer = _react2.default.createClass({
	                        displayName: 'RowRenderer',
	
	                        getRowStyle: function getRowStyle() {
	                            return {
	                                color: this.getRowBackground()
	                            };
	                        },
	                        getRowBackground: function getRowBackground() {
	                            if (this.props.row.inList == true) {
	                                return 'blue';
	                            } else if (this.props.row.IsOverSaleable == false && this.props.row.InStock == 0) {
	                                return 'red';
	                            } else {
	                                return null;
	                            }
	                        },
	                        render: function render() {
	                            //here we are just changing the style
	                            //but we could replace this with anything we liked, cards, images, etc
	                            //usually though it will just be a matter of wrapping a div, and then calling back through to the grid
	                            return _react2.default.createElement(
	                                'div',
	                                { style: this.getRowStyle() },
	                                _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	                            );
	                        }
	                    });
	
	                    //Custom Formatter component
	
	                    var DateFormatter = _react2.default.createClass({
	                        displayName: 'DateFormatter',
	                        render: function render() {
	                            if (this.props.value) {
	                                var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                                var date = new Date(this.props.value);
	                                var index = dateMap.indexOf(date.toString().slice(4, 3));
	                                var localDate = index + date.toString().slice(8, 6);
	                                return _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    date.toString().slice(4, 15)
	                                );;
	                            } else return _react2.default.createElement(
	                                'span',
	                                { className: 'label label-danger' },
	                                '-'
	                            );
	                        }
	                    });
	
	                    var VendorNameFormatter = _react2.default.createClass({
	                        displayName: 'VendorNameFormatter',
	                        render: function render() {
	                            if (this.props.value) return _react2.default.createElement(
	                                'span',
	                                null,
	                                this.props.value.Name
	                            );else return _react2.default.createElement(
	                                'span',
	                                { className: 'label label-danger' },
	                                '-'
	                            );
	                        }
	                    });
	
	                    var VendorNumFormatter = _react2.default.createClass({
	                        displayName: 'VendorNumFormatter',
	                        render: function render() {
	                            if (this.props.value) return _react2.default.createElement(
	                                'span',
	                                null,
	                                this.props.value.VendorNum
	                            );else return _react2.default.createElement(
	                                'span',
	                                { className: 'label label-danger' },
	                                '-'
	                            );
	                        }
	                    });
	
	                    // Column difinition
	
	                    var columns = [{
	                        key: 'ProductNum',
	                        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'item_no' }),
	                        resizable: true,
	                        sortable: true,
	                        filterable: true
	                    }, {
	                        key: 'Name',
	                        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                        resizable: true,
	                        sortable: true,
	                        filterable: true
	                    }, {
	                        key: 'PreSale',
	                        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'presale' }),
	                        resizable: true,
	                        sortable: true,
	                        filterable: true
	                    }, {
	                        key: 'InStock',
	                        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'instock' }),
	                        resizable: true,
	                        sortable: true
	                    }, {
	                        key: 'Purchased',
	                        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	                        resizable: true,
	                        sortable: true
	                    }];
	
	                    return _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 12 },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inventory_number' }),
	                                    ': '
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Inventory_id', withRef: true, onKeyPress: function onKeyPress(event) {
	                                        return _this3.handleInventoryNumKeyPress(event);
	                                    }, ref: 'inventory', component: _inputField.InputField })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 12 },
	                                _react2.default.createElement(
	                                    'div',
	                                    { style: { maxWidth: '99%' }, id: 'WholesaleOrderForm-dataGrid1' },
	                                    _react2.default.createElement(_reactDataGrid2.default, {
	                                        ref: 'reactDataGrid',
	                                        style: { height: 250 },
	                                        rowKey: 'Product_id',
	                                        enableCellSelect: this.state.cellSelectEnabled,
	                                        onGridSort: handleGridSort,
	                                        toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                        onAddFilter: handleFilterChange,
	                                        columns: columns,
	                                        rowHeight: 25,
	                                        rowGetter: rowGetter,
	                                        rowsCount: getSize(),
	                                        onRowUpdated: this.handleRowUpdated,
	                                        onRowClick: onRowClick,
	                                        rowRenderer: RowRenderer,
	                                        enableRowSelect: 'single',
	                                        rowSelection: {
	                                            showCheckbox: false,
	                                            selectBy: {
	                                                isSelectedKey: 'isSelected'
	                                            }
	                                        },
	                                        onGridKeyDown: onKeyDown })
	                                )
	                            )
	                        )
	                    );
	                }
	        }
	    }, {
	        key: 'getInventoryNameOptions',
	        value: function getInventoryNameOptions() {
	            var inventoryOptions = [];
	            this.props.inventories.map(function (inventory) {
	                inventoryOptions.push({ value: inventory.id, label: inventory.id });
	            });
	            return inventoryOptions;
	        }
	    }, {
	        key: 'getInventoryNumOptions',
	        value: function getInventoryNumOptions() {
	            var inventoryOptions = [];
	            this.props.inventories.map(function (inventory) {
	                inventoryOptions.push({ value: inventory.id, label: inventory.ProductNum.ProductNum });
	            });
	            return inventoryOptions;
	        }
	    }, {
	        key: 'favoriteItemsHeader',
	        value: function favoriteItemsHeader() {
	            var _this4 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { onClick: function onClick() {
	                        return _this4.setState({ favoriteItemsOpen: !_this4.state.favoriteItemsOpen });
	                    } },
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'favorite_items' })
	                )
	            );
	        }
	    }, {
	        key: 'previousOrdersHeader',
	        value: function previousOrdersHeader() {
	            var _this5 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { onClick: function onClick() {
	                        return _this5.setState({ previousOrdersOpen: !_this5.state.previousOrdersOpen, promotionsOpen: false });
	                    } },
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'previous_orders' })
	                )
	            );
	        }
	    }, {
	        key: 'promotionsHeader',
	        value: function promotionsHeader() {
	            var _this6 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { onClick: function onClick() {
	                        return _this6.setState({ promotionsOpen: !_this6.state.promotionsOpen, previousOrdersOpen: false });
	                    } },
	                _react2.default.createElement(
	                    'label',
	                    { style: { cursor: "pointer" } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'promotions' })
	                )
	            );
	        }
	    }, {
	        key: 'renderPreviousOrders',
	        value: function renderPreviousOrders() {
	            var _this7 = this;
	
	            if (this.props.previousOrdersIsLoading && !this.props.previousOrdersError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.previousOrdersError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.previousOrdersError)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this7.state.previousOrders);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var previousOrders = _extends({}, _this7.state.previousOrders, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this7.setState({ previousOrders: previousOrders });
	                };
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var previousOrders = _extends({}, _this7.state.previousOrders, { selectedRows: rows });
	                    _this7.setState({ previousOrders: previousOrders });
	                };
	
	                //Custom Formatter component
	                var IsEnabledFormatter = _react2.default.createClass({
	                    displayName: 'IsEnabledFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-success' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'enabled' })
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'disable' })
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120,
	                    filterable: true
	                }, {
	                    key: 'PreSale',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'presale' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true
	                }, {
	                    key: 'InStock',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'instock' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80
	                }, {
	                    key: 'Ordered',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80
	                }, {
	                    key: 'Price',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'WholesaleOrderForm-dataGrid2' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'Product_id',
	                                onGridSort: handleGridSort,
	                                columns: columns,
	                                rowHeight: 25,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                enableRowSelect: 'multi',
	                                minHeight: this.state.tableHeight,
	                                onRowUpdated: this.handleRowUpdated,
	                                onRowSelect: onRowSelect
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderFavorites',
	        value: function renderFavorites() {
	            var _this8 = this;
	
	            if (this.props.favoritesIsLoading && !this.props.favoritesError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.favoritesError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.favoritesError)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this8.state.favorites);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var favorites = _extends({}, _this8.state.favorites, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this8.setState({ favorites: favorites });
	                };
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var POs = _extends({}, _this8.state.favorites, { selectedRows: rows });
	                    _this8.setState({ favorites: favorites });
	                };
	
	                var onRowClick = function onRowClick(rowIdx, row) {
	                    _this8.setState({ selectedItemName: row.ProductName, selectedItemNumber: row.ProductNum });
	                };
	
	                var RowRenderer = _react2.default.createClass({
	                    displayName: 'RowRenderer',
	
	                    getRowStyle: function getRowStyle() {
	                        return {
	                            color: this.getRowBackground()
	                        };
	                    },
	                    getRowBackground: function getRowBackground() {
	                        if (this.props.row.inList == true) {
	                            return 'blue';
	                        } else if (this.props.row.IsOverSaleable == false && this.props.row.InStock == 0) {
	                            return 'red';
	                        } else {
	                            return null;
	                        }
	                    },
	                    render: function render() {
	                        //here we are just changing the style
	                        //but we could replace this with anything we liked, cards, images, etc
	                        //usually though it will just be a matter of wrapping a div, and then calling back through to the grid
	                        return _react2.default.createElement(
	                            'div',
	                            { style: this.getRowStyle() },
	                            _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	                        );
	                    }
	                });
	
	                //Custom Formatter component
	                var IsEnabledFormatter = _react2.default.createClass({
	                    displayName: 'IsEnabledFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-success' },
	                            'Enabled'
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            'Disable'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120,
	                    filterable: true
	                }, {
	                    key: 'PreSale',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'presale' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true
	                }, {
	                    key: 'InStock',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'instock' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80
	                }, {
	                    key: 'Ordered',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80
	                }, {
	                    key: 'Price',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'WholesaleOrderForm-dataGrid3' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'Product_id',
	                                onGridSort: handleGridSort,
	                                columns: columns,
	                                rowHeight: 25,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                minHeight: this.state.tableHeight,
	                                onRowUpdated: this.handleRowUpdated,
	                                onRowSelect: onRowSelect,
	                                onRowClick: onRowClick,
	                                rowRenderer: RowRenderer
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderPromotions',
	        value: function renderPromotions() {
	            var _this9 = this;
	
	            if (this.props.promotionsAreLoading && !this.props.promotionsError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.promotionsError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.promotionsError)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this9.state.promotions);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var promotions = _extends({}, _this9.state.promotions, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this9.setState({ promotions: promotions });
	                };
	
	                var onRowSelect = function onRowSelect(rows) {
	                    var POs = _extends({}, _this9.state.promotions, { selectedRows: rows });
	                    _this9.setState({ promotions: promotions });
	                };
	
	                //Custom Formatter component
	                var IsEnabledFormatter = _react2.default.createClass({
	                    displayName: 'IsEnabledFormatter',
	                    render: function render() {
	                        if (this.props.value) return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-success' },
	                            'Enabled'
	                        );else return _react2.default.createElement(
	                            'span',
	                            { className: 'label label-danger' },
	                            'Disable'
	                        );
	                    }
	                });
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'ProductName',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 120,
	                    filterable: true
	                }, {
	                    key: 'PreSale',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'presale' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80,
	                    filterable: true
	                }, {
	                    key: 'InStock',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'instock' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80
	                }, {
	                    key: 'Ordered',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ordered' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 80
	                }, {
	                    key: 'Price',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price' }),
	                    resizable: true,
	                    sortable: true,
	                    width: 100
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'WholesaleOrderForm-dataGrid4' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'Product_id',
	                                onGridSort: handleGridSort,
	                                columns: columns,
	                                rowHeight: 25,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                enableRowSelect: 'multi',
	                                minHeight: this.state.tableHeight,
	                                onRowUpdated: this.handleRowUpdated,
	                                onRowSelect: onRowSelect
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this10 = this;
	
	            // Parameters of the react-data-grid
	
	            var getRows = function getRows() {
	                return _reactDataGridAddons.Data.Selectors.getRows(_this10.state);
	            };
	
	            var getSize = function getSize() {
	                return getRows().length;
	            };
	
	            var rowGetter = function rowGetter(rowIdx) {
	                var rows = getRows();
	                return rows[rowIdx];
	            };
	
	            var onRowsSelected = function onRowsSelected(rows) {
	                var newRows = _this10.state.rows;
	                rows.map(function (r) {
	                    newRows[r.rowIdx].isSelected = true;
	                });
	                _this10.setState(_extends({}, _this10.state, { rows: newRows }));
	            };
	
	            var onRowsDeselected = function onRowsDeselected(rows) {
	                var newRows = _this10.state.rows;
	                rows.map(function (r) {
	                    newRows[r.rowIdx].isSelected = false;
	                });
	                _this10.setState(_extends({}, _this10.state, { rows: newRows }));
	            };
	
	            // Handle the sortable function
	
	            var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                var state = Object.assign({}, _this10.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	                _this10.setState(state);
	            };
	
	            var handleFilterChange = function handleFilterChange(filter) {
	                var newFilters = Object.assign({}, _this10.state.filters);
	                if (filter.filterTerm) {
	                    newFilters[filter.column.key] = filter;
	                } else {
	                    delete newFilters[filter.column.key];
	                }
	                _this10.setState({ filters: newFilters });
	            };
	
	            //Custom Formatter component
	
	            var DateFormatter = _react2.default.createClass({
	                displayName: 'DateFormatter',
	                render: function render() {
	                    if (this.props.value) {
	                        var dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	                        var date = new Date(this.props.value);
	                        var index = dateMap.indexOf(date.toString().slice(4, 3));
	                        var localDate = index + date.toString().slice(8, 6);
	                        return _react2.default.createElement(
	                            'span',
	                            null,
	                            date.toString().slice(4, 15)
	                        );;
	                    } else return _react2.default.createElement(
	                        'span',
	                        { className: 'label label-danger' },
	                        '-'
	                    );
	                }
	            });
	
	            var VendorNameFormatter = _react2.default.createClass({
	                displayName: 'VendorNameFormatter',
	                render: function render() {
	                    if (this.props.value) return _react2.default.createElement(
	                        'span',
	                        null,
	                        this.props.value.Name
	                    );else return _react2.default.createElement(
	                        'span',
	                        { className: 'label label-danger' },
	                        '-'
	                    );
	                }
	            });
	
	            var VendorNumFormatter = _react2.default.createClass({
	                displayName: 'VendorNumFormatter',
	                render: function render() {
	                    if (this.props.value) return _react2.default.createElement(
	                        'span',
	                        null,
	                        this.props.value.VendorNum
	                    );else return _react2.default.createElement(
	                        'span',
	                        { className: 'label label-danger' },
	                        '-'
	                    );
	                }
	            });
	
	            // Column difinition
	
	            var columns = [{
	                key: 'ProductNum',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	                resizable: true,
	                sortable: true,
	                width: 100,
	                filterable: true
	            }, {
	                key: 'ProductName',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_name' }),
	                resizable: true,
	                sortable: true,
	                width: 100,
	                filterable: true
	            }, {
	                key: 'ProductDescription',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	                resizable: true,
	                sortable: true,
	                width: 100
	            }, {
	                key: 'Quantity',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' }),
	                resizable: true,
	                sortable: true,
	                width: 100,
	                filterable: true
	            }, {
	                key: 'ProductUnitOfMeasure',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_of_measure' }),
	                resizable: true,
	                sortable: true,
	                width: 100,
	                filterable: true
	            }, {
	                key: 'UnitPrice',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'unit_price' }),
	                resizable: true,
	                sortable: true,
	                width: 100,
	                filterable: true
	            }, {
	                key: 'Total',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_price' }),
	                resizable: true,
	                sortable: true,
	                width: 100,
	                filterable: true
	            }, {
	                key: 'Weight',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'weight' }),
	                resizable: true,
	                sortable: true,
	                width: 100,
	                filterable: true
	            }, {
	                key: 'Batch_PONum',
	                name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'batch_num' }),
	                resizable: true,
	                sortable: true,
	                width: 100,
	                filterable: true
	            }];
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 12 },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { maxWidth: '99%' }, id: 'WholesaleOrderForm-dataGrid5' },
	                        _react2.default.createElement(_reactDataGrid2.default, {
	                            style: { height: 250 },
	                            rowKey: 'Batch_PONum',
	                            onGridSort: handleGridSort,
	                            toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                            onAddFilter: handleFilterChange,
	                            columns: columns,
	                            rowHeight: 25,
	                            rowGetter: rowGetter,
	                            rowsCount: getSize(),
	                            enableRowSelect: 'multi',
	                            onRowUpdated: this.handleRowUpdated,
	                            rowSelection: {
	                                showCheckbox: true,
	                                enableShiftSelect: true,
	                                onRowsSelected: onRowsSelected,
	                                onRowsDeselected: onRowsDeselected,
	                                selectBy: {
	                                    isSelectedKey: 'isSelected'
	                                }
	                            } })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'moveToSO',
	        value: function moveToSO(Rows) {
	            var newRows = this.state.rows;
	            var updatedInventories = this.state.inventories.allRows;
	            var updatedFavorites = this.state.favorites.rows;
	            var ProductNum = void 0;
	            var validEntry = false;
	
	            Rows.map(function (row) {
	                ProductNum = row.ProductNum;
	                if (row.Total > 0) {
	                    row.isSelected = false;
	                    if (row.BatchAmount < row.Quantity) {
	                        alert("Not enough of " + row.ProductName + " of batch " + row.Batch_PONum + " in stock!");
	                    } else {
	                        validEntry = true;
	                        newRows.push(row);
	                    }
	                }
	            });
	
	            if (validEntry) {
	                var index = _lodash2.default.findIndex(updatedInventories, { 'ItemNum': ProductNum });
	                if (index != -1) {
	                    updatedInventories[index].inList = true;
	                }
	
	                index = _lodash2.default.findIndex(updatedFavorites, { 'ProductNum': ProductNum });
	                if (index != -1) {
	                    updatedFavorites[index].inList = true;
	                }
	
	                var totalPrice = 0;
	                var finalWeight = 0;
	                newRows.map(function (row) {
	                    totalPrice = totalPrice + parseInt(row.Total);
	                    finalWeight = finalWeight + parseInt(row.Weight);
	                });
	
	                var inventories = _extends({}, this.state.inventories, { allRows: updatedInventories });
	                this.setState({ inventories: inventories, rows: newRows, totalPrice: totalPrice, finalWeight: finalWeight });
	            }
	        }
	    }, {
	        key: 'renderSelectedItem',
	        value: function renderSelectedItem() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 3 },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'item_no' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 3 },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-5 centerStyle' },
	                                    this.state.selectedItemNumber
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 3 },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'item_name' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 3 },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col-sm-5 centerStyle' },
	                                    this.state.selectedItemName
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'removeFromSO',
	        value: function removeFromSO() {
	            var updatedRows = this.state.rows;
	            var updatedSelectedRows = this.state.selectedRows;
	            var updatedInventories = this.state.inventories.allRows;
	            var updatedFavorites = this.state.favorites.rows;
	            var totalPrice = 0;
	            var finalWeight = 0;
	
	            updatedRows.map(function (row) {
	                if (row.isSelected == true) {
	                    var index = _lodash2.default.findIndex(updatedInventories, { 'ItemNum': row.ProductNum });
	                    if (index != -1) {
	                        updatedInventories[index].inList = false;
	                    }
	
	                    index = _lodash2.default.findIndex(updatedFavorites, { 'ProductNum': row.ProductNum });
	                    if (index != -1) {
	                        updatedFavorites[index].inList = false;
	                    }
	                }
	            });
	
	            updatedRows.map(function (row) {
	                if (row.isSelected != true) {
	                    var index = _lodash2.default.findIndex(updatedInventories, { 'ItemNum': row.ProductNum });
	                    if (index != -1) {
	                        updatedInventories[index].inList = true;
	                    }
	
	                    index = _lodash2.default.findIndex(updatedFavorites, { 'ProductNum': row.ProductNum });
	                    if (index != -1) {
	                        updatedFavorites[index].inList = true;
	                    }
	                }
	            });
	
	            updatedRows = updatedRows.filter(function (obj) {
	                return obj.isSelected == false || obj.isSelected == null;
	            });
	
	            updatedRows.map(function (row) {
	                totalPrice += row.TotalPrice;
	                finalWeight += row.Weight;
	            });
	
	            var inventories = _extends({}, this.state.inventories, { allRows: updatedInventories });
	            var favorites = _extends({}, this.state.inventories, { rows: updatedFavorites });
	            this.setState({ inventories: inventories, favorites: favorites, rows: updatedRows, totalPrice: totalPrice, finalWeight: finalWeight });
	        }
	    }, {
	        key: 'formatDate',
	        value: function formatDate(date) {
	            var formattedDate = date.getFullYear() + '-';
	            if (date.getMonth() < 9) {
	                formattedDate += '0' + date.getMonth() + 1 + '-';
	            } else {
	                formattedDate += date.getMonth() + 1 + '-';
	            }
	
	            if (date.getDate() < 9) {
	                formattedDate += '0' + date.getDate() + 'T';
	            } else {
	                formattedDate += date.getDate() + 'T';
	            }
	
	            if (date.getHours() < 9) {
	                formattedDate += '0' + date.getHours() + ':';
	            } else {
	                formattedDate += date.getHours() + ':';
	            }
	
	            if (date.getMinutes() < 9) {
	                formattedDate += '0' + date.getMinutes() + ':';
	            } else {
	                formattedDate += date.getMinutes() + ':';
	            }
	
	            if (date.getSeconds < 9) {
	                formattedDate += '0' + date.getSeconds();
	            } else {
	                formattedDate += date.getSeconds();
	            }
	            return formattedDate;
	        }
	    }, {
	        key: 'addNewSalesOrder',
	        value: function addNewSalesOrder() {
	            var _props = this.props,
	                createSalesOrder = _props.createSalesOrder,
	                description = _props.description,
	                orderDate = _props.orderDate,
	                dispatchDate = _props.dispatchDate,
	                documentDate = _props.documentDate;
	
	            var newOrder = {};
	            var Batch_Order_Lines = [];
	            this.state.rows.map(function (row) {
	                Batch_Order_Lines.push(row);
	            });
	            var index = _lodash2.default.findIndex(this.props.customers, { 'Customer_id': this.state.currentCustomer });
	            newOrder.Batch_Order_Lines = Batch_Order_Lines;
	            newOrder.IsWholesale = true;
	            newOrder.Deliver_Customer_id = this.state.currentCustomer;
	            newOrder.Deliver_Customer_num = this.props.customers[index].CustomerNum;
	            newOrder.Deliver_CustomerName = this.state.currentCustomerName;
	            newOrder.Description = description;
	            newOrder.Deliver_CustomerAddress_id = 1;
	            newOrder.Deliver_CustomerContact_id = 1;
	            newOrder.Pickup_Warehouse_id = 1;
	            newOrder.DispatchMethod_id = 1;
	            newOrder.DispatchOutSourceContact_id = 1;
	            newOrder.PaymentTerm_id = 1;
	            newOrder.TotalPrice = this.state.totalPrice;
	            newOrder.FinalWeight = this.state.finalWeight;
	            if (!orderDate) {
	                newOrder.OrderDate = this.formatDate(new Date());
	            } else {
	                newOrder.OrderDate = this.formatDate(orderDate);
	            }
	            newOrder.UpdateTime = this.formatDate(new Date());
	            if (!dispatchDate) {
	                var currentDate = new Date();
	                var tomorrow = currentDate;
	                tomorrow.setDate(tomorrow.getDate() + 1);
	                newOrder.DispatchDate = this.formatDate(tomorrow);
	            } else {
	                newOrder.DispatchDate = this.formatDate(dispatchDate);
	            }
	            this.setState({ dirty: false });
	            createSalesOrder(newOrder);
	        }
	    }, {
	        key: 'handleInventoryNumKeyPress',
	        value: function handleInventoryNumKeyPress(event) {
	            if (event.charCode == 13) {
	                if (this.state.inventories.rows.length > 0) {
	                    var rows = this.state.inventories.rows;
	                    rows.map(function (row) {
	                        row.isSelected = false;
	                    });
	                    rows[0].isSelected = true;
	                    var inventories = _extends({}, this.state.inventories, { rows: rows });
	                    this.setState({ inventories: inventories, cellSelectEnabled: false });
	                    _reactDom2.default.findDOMNode(this.refs["reactDataGrid"].refs.base.refs.viewPortContainer).focus();
	                }
	            }
	        }
	    }, {
	        key: 'checkPermission',
	        value: function checkPermission(permission) {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this11 = this;
	
	            var createDialogStyle = {
	                width: "700px",
	                height: "650px",
	                marginTop: '-300px',
	                marginLeft: '-25%'
	            };
	
	            var _props2 = this.props,
	                handleSubmit = _props2.handleSubmit,
	                submitting = _props2.submitting,
	                pristine = _props2.pristine,
	                isEditing = _props2.isEditing,
	                isCreating = _props2.isCreating;
	
	            var currentDate = new Date();
	            var tomorrow = currentDate;
	            tomorrow.setDate(tomorrow.getDate() + 1);
	            if (this.props.detailIsLoading && !this.props.detailError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement('br', null),
	                '...reading data'
	            );else if (this.props.detailError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                return _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        this.props.name
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        null,
	                        this.title(),
	                        _react2.default.createElement(
	                            'form',
	                            { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	                            _react2.default.createElement('hr', null),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 4 },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Panel,
	                                        null,
	                                        _react2.default.createElement(
	                                            'h4',
	                                            null,
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_select_customer' })
	                                        ),
	                                        _react2.default.createElement('hr', null),
	                                        this.renderCustomers(),
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'col-sm-5 marginTopStyle' },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 7 },
	                                                _react2.default.createElement(_reduxForm.Field, { name: 'CustomerDescription', component: 'Textarea', className: 'form-control', style: { minHeight: '34px', marginBottom: 10 } })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Panel,
	                                            { className: 'panelStyle', header: this.favoriteItemsHeader(), collapsible: true, expanded: this.state.favoriteItemsOpen },
	                                            this.renderFavorites()
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Panel,
	                                            { className: 'panelStyle', header: this.previousOrdersHeader(), collapsible: true, expanded: this.state.previousOrdersOpen },
	                                            this.renderPreviousOrders()
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Panel,
	                                            { className: 'panelStyle', header: this.promotionsHeader(), collapsible: true, expanded: this.state.promotionsOpen },
	                                            this.renderPromotions()
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 8 },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 12 },
	                                            _react2.default.createElement(
	                                                _reactRouter.Link,
	                                                { to: '/wholesale', className: 'btn btn-default' },
	                                                _react2.default.createElement('em', { className: 'fa fa-close' })
	                                            ),
	                                            (isCreating || isEditing) && _react2.default.createElement(_spinner2.default, null),
	                                            this.props.createError && _react2.default.createElement(
	                                                'div',
	                                                { className: 'alert alert-danger marginTopStyle' },
	                                                JSON.stringify(this.props.createError)
	                                            ),
	                                            this.props.editError && _react2.default.createElement(
	                                                'div',
	                                                { className: 'alert alert-danger marginTopStyle' },
	                                                JSON.stringify(this.props.editError)
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Button,
	                                                { className: 'btn btn-primary pull-right', disabled: isCreating || isEditing || pristine || this.state.currentCustomer == null || this.state.rows == 0, onClick: function onClick() {
	                                                        _this11.addNewSalesOrder();
	                                                    } },
	                                                _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Button,
	                                                { className: 'btn btn-primary pull-right', disabled: isCreating || isEditing || pristine },
	                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print' })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement('hr', null),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Panel,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { sm: 12 },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'form-group' },
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Row,
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 3 },
	                                                            _react2.default.createElement(
	                                                                'h4',
	                                                                null,
	                                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_detail' })
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 3 },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'document_date' })
	                                                            ),
	                                                            _react2.default.createElement(_reduxForm.Field, { name: 'DocumentDate', selected: new Date(), component: _datePicker.DisabledDatePicker })
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 3 },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_date' })
	                                                            ),
	                                                            _react2.default.createElement(_reduxForm.Field, { name: 'WholesaleOrderDate', selected: new Date(), component: _datePicker.DatePicker })
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 3 },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch_date' })
	                                                            ),
	                                                            _react2.default.createElement(_reduxForm.Field, { name: 'DispatchDate', selected: tomorrow, component: _datePicker.DatePicker })
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement('hr', null),
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Row,
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 12 },
	                                                            this.renderInventories(),
	                                                            _react2.default.createElement('br', null),
	                                                            _react2.default.createElement('hr', null),
	                                                            this.renderSelectedItem(),
	                                                            _react2.default.createElement(
	                                                                _reactBootstrap.Row,
	                                                                null,
	                                                                _react2.default.createElement(_reactBootstrap.Col, { sm: 8 }),
	                                                                _react2.default.createElement(
	                                                                    _reactBootstrap.Col,
	                                                                    { sm: 2 },
	                                                                    _react2.default.createElement(
	                                                                        _reactBootstrap.Button,
	                                                                        { ref: function ref(button) {
	                                                                                _this11.chooseFromBatch = button;
	                                                                            }, className: 'btn btn-primary pull-right', disabled: !this.state.selectedItemNumber, onClick: function onClick() {
	                                                                                return _this11.openChooseFromBatch();
	                                                                            } },
	                                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_select_from_batch' })
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    _reactBootstrap.Col,
	                                                                    { sm: 2 },
	                                                                    _react2.default.createElement(
	                                                                        _reactBootstrap.Button,
	                                                                        { className: 'btn btn-danger pull-right', onClick: function onClick() {
	                                                                                return _this11.removeFromSO();
	                                                                            },
	                                                                            disabled: this.state.selectedRows > 0 },
	                                                                        _react2.default.createElement('em', null),
	                                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'remove_from_so_list' })
	                                                                    )
	                                                                )
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement('hr', null),
	                                                    this.renderTable(),
	                                                    _react2.default.createElement('hr', null),
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Row,
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 6 },
	                                                            _react2.default.createElement(
	                                                                _reactBootstrap.Row,
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    _reactBootstrap.Col,
	                                                                    { sm: 6 },
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_price' })
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    _reactBootstrap.Col,
	                                                                    { sm: 6 },
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        this.state.totalPrice
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                _reactBootstrap.Row,
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    _reactBootstrap.Col,
	                                                                    { sm: 6 },
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax' })
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                _reactBootstrap.Row,
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    _reactBootstrap.Col,
	                                                                    { sm: 6 },
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_dollarsign' })
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                _reactBootstrap.Row,
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    _reactBootstrap.Col,
	                                                                    { sm: 6 },
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'final_weight' })
	                                                                    )
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    _reactBootstrap.Col,
	                                                                    { sm: 6 },
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        this.state.finalWeight
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                _reactBootstrap.Row,
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    _reactBootstrap.Col,
	                                                                    { sm: 6 },
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'profit' })
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                _reactBootstrap.Row,
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    _reactBootstrap.Col,
	                                                                    { sm: 6 },
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'profit_percentage' })
	                                                                    )
	                                                                )
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                _reactBootstrap.Row,
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    _reactBootstrap.Col,
	                                                                    { sm: 6 },
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term' })
	                                                                    )
	                                                                )
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'h4',
	                                                        null,
	                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping' })
	                                                    ),
	                                                    _react2.default.createElement('hr', null),
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Row,
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 6 },
	                                                            _react2.default.createElement(
	                                                                _reactBootstrap.Row,
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    _reactBootstrap.Col,
	                                                                    { sm: 6 },
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_address' })
	                                                                    )
	                                                                )
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Row,
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 6 },
	                                                            _react2.default.createElement(
	                                                                _reactBootstrap.Row,
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    _reactBootstrap.Col,
	                                                                    { sm: 6 },
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'transit_method' })
	                                                                    )
	                                                                )
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Row,
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 6 },
	                                                            _react2.default.createElement(
	                                                                _reactBootstrap.Row,
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    _reactBootstrap.Col,
	                                                                    { sm: 6 },
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'scheduling_shipping_date' })
	                                                                    )
	                                                                )
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Row,
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactBootstrap.Col,
	                                                            { sm: 6 },
	                                                            _react2.default.createElement(
	                                                                _reactBootstrap.Row,
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    _reactBootstrap.Col,
	                                                                    { sm: 6 },
	                                                                    _react2.default.createElement(
	                                                                        'label',
	                                                                        null,
	                                                                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipment_date' })
	                                                                    )
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(_reactBootstrap.Row, null),
	                            this.props.isCreating || this.props.isEditing && _react2.default.createElement(_spinner2.default, null),
	                            this.props.createError && _react2.default.createElement(
	                                'div',
	                                { className: 'alert alert-danger marginTopStyle' },
	                                JSON.stringify(this.props.createError)
	                            ),
	                            this.props.editError && _react2.default.createElement(
	                                'div',
	                                { className: 'alert alert-danger marginTopStyle' },
	                                JSON.stringify(this.props.editError)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactSkylight.SkyLightStateless,
	                            { isVisible: this.state.customerOpen, onCloseClicked: function onCloseClicked() {
	                                    _this11.closeCustomer();
	                                }, title: 'Add A New Payment Term' },
	                            _react2.default.createElement(_customerForm2.default, { closePT: this.closeCustomer })
	                        ),
	                        _react2.default.createElement(
	                            _reactSkylight.SkyLightStateless,
	                            { dialogStyles: createDialogStyle, isVisible: this.state.batchOpen, onCloseClicked: function onCloseClicked() {
	                                    _this11.closeChooseFromBatch();
	                                }, title: 'Choose From Batch', className: 'wholesaleModal' },
	                            _react2.default.createElement(_wholesaleModal2.default, { ProductNum: this.state.selectedItemNumber, closeC: this.closeChooseFromBatch, moveToSO: this.moveToSO })
	                        )
	                    )
	                );
	            }
	        }
	    }]);
	
	    return WholesaleOrderForm;
	}(_react.Component);
	
	WholesaleOrderForm.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	
	var _default = (0, _reactRouter.withRouter)(WholesaleOrderForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(WholesaleOrderForm, 'WholesaleOrderForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/wholesaleOrderForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Sales/wholesaleOrderForm.jsx');
	}();

	;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _genericRadioFilter = __webpack_require__(50);
	
	var _genericRadioFilter2 = _interopRequireDefault(_genericRadioFilter);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _dateFormat = __webpack_require__(39);
	
	var _dateFilterRadios = __webpack_require__(49);
	
	var _dateFilterRadios2 = _interopRequireDefault(_dateFilterRadios);
	
	var _reduxForm = __webpack_require__(3);
	
	var _selection = __webpack_require__(21);
	
	var _root_url = __webpack_require__(9);
	
	var _cleanDates = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tableHeight = window.innerHeight < 930 ? 700 : 700;
	
	var ActionLog = function (_Component) {
	  _inherits(ActionLog, _Component);
	
	  function ActionLog(props) {
	    _classCallCheck(this, ActionLog);
	
	    var _this = _possibleConstructorReturn(this, (ActionLog.__proto__ || Object.getPrototypeOf(ActionLog)).call(this, props));
	
	    _this.handleFilterStatusChange = function (status) {
	      var fromDate = _this.state.fromDate ? (0, _dateFormat.formatDate)(_this.state.FromDate) : '1900-01-01';
	      var ToDate = _this.state.ToDate ? (0, _dateFormat.formatDate)(_this.state.ToDate) : '3000-01-01';
	      var days = _this.state.days;
	      var field = _this.state.field;
	      if (days == null) {
	        days = 90;
	      }
	      _this.setState({
	        action: status
	      }, function () {
	        _this.props.fetchActionLogByFilter(_this.state.action, field, days, fromDate, ToDate);
	      });
	    };
	
	    _this.handleDaysStatusChange = function (days) {
	      var dateRange = 90;
	      var FromDate = '1900-01-01';
	      var ToDate = '3000-01-01';
	      if (_this.state.FromDate != null) {
	        FromDate = _this.state.FromDate;
	      }
	      if (_this.state.ToDate != null) {
	        ToDate = _this.state.ToDate;
	      }
	      if (days !== null) {
	        dateRange = days;
	      }
	      if (days === -1 || days === '-1') {
	        _this.setState({
	          days: days
	        }, function () {
	          _this.props.fetchActionLogByFilter(_this.state.action, _this.state.field, days, FromDate, ToDate);
	        });
	      } else {
	        _this.setState({
	          days: days,
	          FromDate: null,
	          ToDate: null
	        }, function () {
	          _this.props.fetchActionLogByFilter(_this.state.action, _this.state.field, days, FromDate, ToDate);
	        });
	      }
	    };
	
	    _this.setToRangeSearch = function (e) {
	      _this.setState({ days: '-1' });
	    };
	
	    _this.setFromDate = function (e) {
	      if (e > _this.state.ToDate) {
	        return;
	      }
	      _this.setState({ FromDate: e });
	    };
	
	    _this.setToDate = function (e) {
	      if (e < _this.state.FromDate) {
	        return;
	      }
	      _this.setState({ ToDate: e });
	    };
	
	    _this.renderFields = function () {
	      var fields = _this.getFields();
	      return _react2.default.createElement(
	        'div',
	        { className: 'control-dropdown', style: { marginBottom: 5 } },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Search:'
	        ),
	        ' ',
	        _react2.default.createElement(_reduxForm.Field, { name: 'Field', component: _selection.Selection, options: fields })
	      );
	    };
	
	    _this.getFields = function () {
	      return [{ value: 'ProductCost', label: 'Product Cost' }, { value: 'P5Percentage', label: 'P5Percentage' }, { value: 'LowestSalePrice', label: 'Lowest Sales Price' }, { value: 'RefPrice', label: 'Ref Price' }, { value: 'SaleStatus', label: 'SaleStatus' }, { value: 'ArrivalStatus', label: 'Arrival Status' }, { value: 'P4Percentage', label: 'P4Percentage' }, { value: 'P1Percentage', label: 'P1Percentage' }, { value: 'ReturnStatus', label: 'Return Status' }, { value: 'P2Percentage', label: 'P2Percentage' }, { value: 'P3Percentage', label: 'P3Percentage' }, { value: 'IsDiscontinued', label: 'Is Discontinued' }, { value: 'Add Item', label: 'Add Item' }, { value: 'IsStopSale', label: 'IsStopSale' }, { value: 'RemoveItem', label: 'Remove Item' }, { value: 'Change Quantity', label: 'Change Quantity' }, { value: 'IsStopPurchase', label: 'IsStopPurchase' }, { value: 'PackageSize', label: 'Package Size' }, { value: 'invoice_status', label: 'Invoice Status' }, { value: 'InStockPrice', label: 'InStockPrice' }];
	    };
	
	    _this.state = {
	      logs: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      FromDate: undefined,
	      ToDate: undefined,
	      action: '',
	      field: '',
	      days: '7'
	    };
	    return _this;
	  }
	
	  _createClass(ActionLog, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      var FromDate = this.state.FromDate ? (0, _dateFormat.formatDate)(this.state.FromDate) : '1900-01-01';
	      var ToDate = this.state.ToDate ? (0, _dateFormat.formatDate)(this.state.ToDate) : '3000-01-01';
	      var days = this.state.days;
	      var field = this.state.field;
	      var action = this.state.action;
	      if (days == null) {
	        days = 90;
	      }
	      this.props.fetchActionLogByFilter(action, field, days, FromDate, ToDate);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.actionLog && this.props.actionLog !== nextProps.actionLog) {
	        var logs = this.state.logs;
	
	        this.setState({ logs: _extends({}, logs, { rows: nextProps.actionLog }) });
	      }
	      if (nextProps.field && this.props.field != nextProps.field) {
	        this.setState({
	          field: nextProps.field.value
	        }, function () {
	          var FromDate = _this2.state.FromDate ? (0, _dateFormat.formatDate)(_this2.state.FromDate) : '1900-01-01';
	          var ToDate = _this2.state.ToDate ? (0, _dateFormat.formatDate)(_this2.state.ToDate) : '3000-01-01';
	          var days = _this2.state.days;
	
	          var field = nextProps.field;
	          if (nextProps.field) {
	            field = nextProps.field.value;
	          }
	          var action = _this2.state.action;
	          if (days == null) {
	            days = 90;
	          }
	          _this2.props.fetchActionLogByFilter(action, field, days, FromDate, ToDate);
	        });
	      }
	
	      if (this.props.field && nextProps.field == null) {
	        this.setState({
	          field: nextProps.field
	        }, function () {
	          var FromDate = _this2.state.FromDate ? (0, _dateFormat.formatDate)(_this2.state.FromDate) : '1900-01-01';
	          var ToDate = _this2.state.ToDate ? (0, _dateFormat.formatDate)(_this2.state.ToDate) : '3000-01-01';
	          var days = _this2.state.days;
	          var field = nextProps.field;
	          var action = _this2.state.action;
	          if (days == null) {
	            days = 90;
	          }
	          _this2.props.fetchActionLogByFilter(action, field, days, FromDate, ToDate);
	        });
	      }
	    }
	  }, {
	    key: 'renderPrint',
	    value: function renderPrint() {
	      var fromDate = this.state.FromDate ? (0, _dateFormat.formatDate)(this.state.FromDate) : '1900-01-01';
	      var toDate = this.state.ToDate ? (0, _dateFormat.formatDate)(this.state.ToDate) : '3000-01-01';
	      var days = this.state.days;
	      var field = this.state.field;
	      var action = this.state.action;
	      var dates = (0, _cleanDates.toFromDates)(days, fromDate, toDate);
	      var url = _root_url.ROOT_URL + 'v1/dashboard/audit_trail_filter/export/?Action=' + action + '&Field=' + field + '&Date__gte=' + dates.fromDate + '&Date__lte=' + dates.toDate + '&Bearer=' + localStorage.getItem('token');
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          type: 'button',
	          href: url
	        },
	        _react2.default.createElement('em', { className: 'fa fa-print' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'print_log' })
	      );
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this3 = this;
	
	      if (this.props.actionLogIsLoading && !this.props.actionLogError) {
	        console.log("error?", this.props.actionLogIsLoading);
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.actionLogError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.actionLogError)
	          )
	        );
	      }
	      var columns = [{
	        key: 'Date',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'date' }),
	        sortable: true,
	        resizable: true,
	        width: 110,
	        formatter: _dateFormat.DateFormatter
	      }, {
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	        sortable: true,
	        filterable: true,
	        resizable: true,
	        width: 110
	      }, {
	        key: 'RefNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' }),
	        sortable: true,
	        filterable: true,
	        resizable: true,
	        width: 110
	      }, {
	        key: 'ProductNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_num' }),
	        sortable: true,
	        filterable: true,
	        resizable: true,
	        width: 110
	      }, {
	        key: 'Field',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'field' }),
	        sortable: true,
	        filterable: true,
	        resizable: true,
	        width: 110
	      }, {
	        key: 'From',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'old_value' }),
	        sortable: true,
	        filterable: true,
	        resizable: true,
	        width: 110
	      }, {
	        key: 'To',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_value' }),
	        sortable: true,
	        filterable: true,
	        resizable: true,
	        width: 110
	      }, {
	        key: 'Action',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'action' }),
	        sortable: true,
	        filterable: true,
	        resizable: true,
	        width: 150
	      }];
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.logs);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var logs = Object.assign({}, _this3.state.logs, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this3.setState({ logs: logs });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this3.state.logs.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var logs = _extends({}, _this3.state.logs, { filters: newFilters });
	        _this3.setState({ logs: logs });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'salesOrders-dataGrid1', style: { marginTop: -20 } },
	        _react2.default.createElement(_reactDataGrid2.default, {
	          rowKey: 'id',
	          onGridSort: handleGridSort,
	          toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	          onAddFilter: handleFilterChange,
	          columns: columns,
	          rowHeight: 25,
	          headerRowHeight: 45,
	          minHeight: 500,
	          rowGetter: rowGetter,
	          rowsCount: getSize()
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Admin' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'action_log' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'sales-orders-list' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { id: 'date-range-picker', className: 'form-horizontal' },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      'h3',
	                      { className: 'filter-title' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_status' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'colon' },
	                        ':'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 10 },
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'statusFilterRadios', className: 'form-horizontal' },
	                      (0, _genericRadioFilter2.default)({
	                        content: [{
	                          option: '',
	                          id: 'all-radio-filter',
	                          name: 'statusFilterRadios',
	                          labelName: 'all'
	                        }, {
	                          option: 'Create',
	                          id: 'Create-radio-filter',
	                          name: 'statusFilterRadios',
	                          labelName: 'Create'
	                        }, {
	                          option: 'Edit',
	                          id: 'Edit-radio-filter',
	                          name: 'statusFilterRadios',
	                          labelName: 'Edit'
	                        }, {
	                          option: 'Void',
	                          id: 'Void-radio-filter',
	                          name: 'statusFilterRadios',
	                          labelName: 'Void'
	                        }],
	                        value: this.state.action,
	                        handleOnClick: this.handleFilterStatusChange,
	                        type: 'buttons'
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 2 },
	                    _react2.default.createElement(
	                      'h3',
	                      { className: 'filter-title' },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_date' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'colon' },
	                        ':'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 10 },
	                    (0, _dateFilterRadios2.default)({
	                      handleOnClick: this.handleDaysStatusChange,
	                      setFromDate: this.setFromDate,
	                      setToDate: this.setToDate,
	                      setToRangeSearch: this.setToRangeSearch,
	                      FromDate: this.state.FromDate,
	                      ToDate: this.state.ToDate,
	                      Days: this.state.days
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            { id: 'breadcrumbButtonGroup' },
	            this.renderPrint()
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            { className: 'position-relative', style: { minHeight: 500 } },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { style: { maxWidth: '99%' } },
	              this.renderFields()
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 12 },
	                _react2.default.createElement(
	                  'div',
	                  { style: { maxWidth: '99%' } },
	                  this.renderTable()
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { style: { maxWidth: '99%' } },
	              _react2.default.createElement(
	                'span',
	                { className: 'pull-right' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_show_action_log_from_last_90_days' })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ActionLog;
	}(_react.Component);
	
	ActionLog.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = ActionLog;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(tableHeight, 'tableHeight', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/ActionLog.jsx');
	
	  __REACT_HOT_LOADER__.register(ActionLog, 'ActionLog', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/ActionLog.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/ActionLog.jsx');
	}();

	;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _selection = __webpack_require__(21);
	
	var _reduxForm = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  onCloseClicked: _propTypes2.default.func.isRequired,
	  selectedUserId: _propTypes2.default.string.isRequired
	};
	
	var ChoosePaymentMethodModal = function (_Component) {
	  _inherits(ChoosePaymentMethodModal, _Component);
	
	  function ChoosePaymentMethodModal() {
	    _classCallCheck(this, ChoosePaymentMethodModal);
	
	    var _this = _possibleConstructorReturn(this, (ChoosePaymentMethodModal.__proto__ || Object.getPrototypeOf(ChoosePaymentMethodModal)).call(this));
	
	    _this.state = {
	      inputText: '',
	      errors: ''
	    };
	    return _this;
	  }
	
	  _createClass(ChoosePaymentMethodModal, [{
	    key: 'renderOptions',
	    value: function renderOptions() {
	      if (this.props.usersIsLoading) return _react2.default.createElement(_spinner2.default, null); // If group is loading, show a spinner.
	      var options = [{ value: true, label: 'Stripe' }, { value: false, label: 'Anywhere' }];
	      return _react2.default.createElement(_reduxForm.Field, { name: 'IsStripe', component: _selection.Selection, options: options });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var errors = this.state.errors;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'text-center', style: { marginTop: '20px' } },
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Choose Payment Method' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          this.renderOptions(),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-1 col-xs-offset-5', style: { marginTop: '50px' } },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                onClick: function onClick() {
	                  _this2.props.changePaymentMethod(_this2.props.IsStripe.value);
	                }
	              },
	              _react2.default.createElement('em', { className: 'fa fa-check' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Confirm' })
	            )
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          errors !== '' && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: errors })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChoosePaymentMethodModal;
	}(_react.Component);
	
	ChoosePaymentMethodModal.propTypes = propTypes;
	var _default = ChoosePaymentMethodModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/ChoosePaymentMethodModal.jsx');
	
	  __REACT_HOT_LOADER__.register(ChoosePaymentMethodModal, 'ChoosePaymentMethodModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/ChoosePaymentMethodModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/ChoosePaymentMethodModal.jsx');
	}();

	;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _url = __webpack_require__(20);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  onCloseClicked: _propTypes2.default.func.isRequired,
	  selectedUserId: _propTypes2.default.string,
	  selectedMobileUserId: _propTypes2.default.string.isRequired
	};
	
	var CreditDetailModal = function (_Component) {
	  _inherits(CreditDetailModal, _Component);
	
	  function CreditDetailModal(props) {
	    _classCallCheck(this, CreditDetailModal);
	
	    var _this = _possibleConstructorReturn(this, (CreditDetailModal.__proto__ || Object.getPrototypeOf(CreditDetailModal)).call(this, props));
	
	    _this.getCreditList = function (id) {
	      var data = new FormData();
	      data.append('pk', id);
	      _axios2.default.post(_url.USER_QUERY_CREDIT_URL, data, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        if (response.status !== 200) {
	          return;
	        }
	        _this.setState({
	          rows: JSON.parse(response.data).map(function (item, index) {
	            return _extends({}, item, {
	              id: index
	            });
	          })
	        });
	      }).catch(function () {
	        alert('Could not edit credit, please try again!');
	      });
	    };
	
	    _this.handleGridSort = function (sortColumn, sortDirection) {
	      _this.setState({ sortColumn: sortColumn, sortDirection: sortDirection });
	    };
	
	    _this.handleFilterChange = function (filter) {
	      var newFilters = Object.assign({}, _this.state.filters);
	      if (filter.filterTerm) {
	        newFilters[filter.column.key] = filter;
	      } else {
	        delete newFilters[filter.column.key];
	      }
	      _this.setState({ filters: newFilters });
	    };
	
	    _this.rowGetter = function (rowIdx) {
	      var rows = _this.getRows();
	      return rows[rowIdx];
	    };
	
	    _this.getRows = function () {
	      return _reactDataGridAddons.Data.Selectors.getRows(_this.state);
	    };
	
	    _this.getSize = function () {
	      return _this.getRows().length;
	    };
	
	    _this.state = {
	      rows: []
	    };
	    _this.getCreditList(props.selectedMobileUserId);
	    return _this;
	  }
	
	  _createClass(CreditDetailModal, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedMobileUserId === this.props.selectedMobileUserId) {
	        return;
	      }
	      this.setState({ rows: [] });
	      this.getCreditList(nextProps.selectedMobileUserId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var columns = [{
	        key: 'creater',
	        name: 'Creater',
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'amount',
	        name: 'Amount',
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'reason',
	        name: 'Reason',
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'create_time',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_time' }),
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          {
	            id: 'MobileUserTable-dataGrid1',
	            style: { marginTop: "50px", zIndex: 0 }
	          },
	          _react2.default.createElement(_reactDataGrid2.default, {
	            rowKey: 'id',
	            onGridSort: this.handleGridSort,
	            headerRowHeight: 50,
	            rowHeight: 30,
	            onAddFilter: this.handleFilterChange,
	            columns: columns,
	            minHeight: 560,
	            rowGetter: this.rowGetter,
	            rowsCount: this.getSize()
	          })
	        )
	      );
	    }
	  }]);
	
	  return CreditDetailModal;
	}(_react.Component);
	
	CreditDetailModal.propTypes = propTypes;
	var _default = CreditDetailModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/CreditDetailModal.jsx');
	
	  __REACT_HOT_LOADER__.register(CreditDetailModal, 'CreditDetailModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/CreditDetailModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/CreditDetailModal.jsx');
	}();

	;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _url = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  onCloseClicked: _propTypes2.default.func.isRequired,
	  selectedUserId: _propTypes2.default.string,
	  selectedMobileUserId: _propTypes2.default.string.isRequired
	};
	
	var EditCreditModal = function (_Component) {
	  _inherits(EditCreditModal, _Component);
	
	  function EditCreditModal() {
	    _classCallCheck(this, EditCreditModal);
	
	    var _this = _possibleConstructorReturn(this, (EditCreditModal.__proto__ || Object.getPrototypeOf(EditCreditModal)).call(this));
	
	    _this.editCredit = function (credit) {
	      var errors = '';
	
	      // check validation
	      if (!credit) {
	        errors = 'Credit field cannot be empty';
	      } else if (!/[0-9]+/.test(credit)) {
	        errors = 'Credit is not valid';
	      }
	
	      var data = new FormData();
	      data.append('pk', _this.props.selectedMobileUserId);
	      data.append('credit', credit);
	      if (errors === '') {
	        _axios2.default.post(_url.USER_PUT_CREDIT_URL, data, {
	          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	          if (response.status === 200) {
	            alert('Edit credit to: ' + credit);
	          }
	          _this.props.onCloseClicked();
	          _this.setState({
	            errors: ''
	          });
	        }).catch(function (error) {
	          alert('Could not edit credit, please try again!');
	        });
	      } else {
	        _this.setState({ errors: errors });
	      }
	    };
	
	    _this.state = {
	      inputText: '',
	      errors: ''
	    };
	    return _this;
	  }
	
	  _createClass(EditCreditModal, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          inputText = _state.inputText,
	          errors = _state.errors;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'text-center', style: { marginTop: '20px' } },
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'type_in_credit' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-1 col-xs-offset-3', style: { textAlign: 'right', paddingRight: '0px' } },
	            '+'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-4' },
	            _react2.default.createElement(_reactBootstrap.Input, {
	              type: 'email',
	              onChange: function onChange(event) {
	                return _this2.setState({ inputText: event.target.value });
	              }
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-1 col-xs-offset-5', style: { marginTop: '50px' } },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                onClick: function onClick() {
	                  _this2.editCredit(inputText);
	                }
	              },
	              _react2.default.createElement('em', { className: 'fa fa-check' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Confirm' })
	            )
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          errors !== '' && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: errors })
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditCreditModal;
	}(_react.Component);
	
	EditCreditModal.propTypes = propTypes;
	var _default = EditCreditModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/EditCreditModal.jsx');
	
	  __REACT_HOT_LOADER__.register(EditCreditModal, 'EditCreditModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/EditCreditModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/EditCreditModal.jsx');
	}();

	;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _ResetEmailModal = __webpack_require__(517);
	
	var _ResetEmailModal2 = _interopRequireDefault(_ResetEmailModal);
	
	var _ChoosePaymentMethodModal = __webpack_require__(680);
	
	var _ChoosePaymentMethodModal2 = _interopRequireDefault(_ChoosePaymentMethodModal);
	
	var _EditCreditModal = __webpack_require__(515);
	
	var _EditCreditModal2 = _interopRequireDefault(_EditCreditModal);
	
	var _CreditDetailModal = __webpack_require__(514);
	
	var _CreditDetailModal2 = _interopRequireDefault(_CreditDetailModal);
	
	var _url = __webpack_require__(20);
	
	var _root_url = __webpack_require__(9);
	
	var _userManagement = __webpack_require__(309);
	
	var _userManagement2 = _interopRequireDefault(_userManagement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DispatcherBindModal = _userManagement2.default.DispatcherBindModal;
	
	var isHMM = _root_url.ROOT_API_URL === 'https://hmm-scm.truckxi.com/api/';
	var isEcity = _root_url.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://ctstage-scm.truckxi.com/api/';
	var isABC = _root_url.ROOT_API_URL === 'https://abc-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://abc-scm.truckxi.com/api/';
	
	var styles = {
	  buttonBar: {
	    // position: 'absolute',
	    marginLeft: '235px',
	    marginBottom: '5px',
	    zIndex: 2
	  },
	  buttonStyle: {
	    position: 'absolute'
	  },
	  createDialogStyle: {
	    width: '550px',
	    height: '300px',
	    marginLeft: '-15%'
	  },
	  DispatcherBindModalStyle: {
	    width: '550px',
	    height: '200px',
	    marginLeft: '-15%'
	  },
	  creditDetailDialogStyle: {
	    width: '900px',
	    height: '700px',
	    marginLeft: '-30%',
	    marginTop: '-350px',
	    zIndex: 101
	  },
	  creditDetailOverlayStyle: {
	    zIndex: 100
	  }
	};
	
	var MobileUserTable = function (_Component) {
	  _inherits(MobileUserTable, _Component);
	
	  function MobileUserTable(props) {
	    _classCallCheck(this, MobileUserTable);
	
	    var _this = _possibleConstructorReturn(this, (MobileUserTable.__proto__ || Object.getPrototypeOf(MobileUserTable)).call(this, props));
	
	    _this.setDispatcherBindModalVisibility = function () {
	      var dispatcherBindModalVisibility = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return _this.setState({ dispatcherBindModalVisibility: dispatcherBindModalVisibility });
	    };
	
	    _this.getRows = function () {
	      return _reactDataGridAddons.Data.Selectors.getRows(_this.state);
	    };
	
	    _this.getSize = function () {
	      return _this.getRows().length;
	    };
	
	    _this.onRowsSelected = function (rows) {
	      _this.props.clearUsernameData();
	      var newRows = _this.getRows();
	      newRows.map(function (r) {
	        r.isSelected = false;
	      });
	      rows.map(function (r) {
	        newRows[r.rowIdx].isSelected = true;
	      });
	      _this.setState({
	        selectedUserId: rows[0].row.User_id,
	        selectedMobileUserId: rows[0].row.MobileUser_id,
	        selectedCustomerId: rows[0].row.Customer_id_id,
	        isStripe: rows[0].row.IsStripe
	      }, function () {
	        _this.props.grabMobileUserID(_this.state.selectedMobileUserId);
	        _this.props.setDefaultOfForm("IsStripe", _this.state.isStripe, "choosePaymentMethod");
	      });
	    };
	
	    _this.onRowsDeselected = function (rows) {
	      var newRows = _this.getRows();
	      rows.map(function (r) {
	        newRows[r.rowIdx].isSelected = false;
	      });
	      _this.setState({
	        selectedUserId: '',
	        selectedMobileUserId: '',
	        selectedCustomerId: '',
	        isStripe: ''
	      }, function () {
	        _this.props.clearUsernameData();
	        _this.props.setDefaultOfForm("IsStripe", null, "choosePaymentMethod");
	      });
	    };
	
	    _this.resetPassword = function () {
	      var letter = Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 4);
	      var password = letter + '1234';
	      var url = _url.RESET_PASSWORD_URL + _this.state.selectedUserId;
	
	      _axios2.default.put(url, {
	        password: password
	      }, {
	        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
	      }).then(function (response) {
	        if (response.status === 200) {
	          alert('Reset password to: ' + password);
	        }
	      }).catch(function (error) {
	        alert("Could not reset password, please try again!");
	      });
	      _this.setState({
	        showPasswordPopup: false
	      });
	    };
	
	    _this.savePaymentMethod = function (IsStripe) {
	      var customer_id = _this.state.selectedCustomerId;
	      var url = _url.CHANGE_STRIPE_URL + customer_id;
	      _axios2.default.put(url, {
	        IsStripe: IsStripe
	      }, {
	        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
	      }).then(function (response) {
	        if (response.status === 200) {
	          alert('Payment Method Changed Successfully');
	        }
	      }).catch(function (err) {
	        alert("Payment Method Change Fail");
	      });
	      _this.setState({
	        showChoosePaymentMethod: false,
	        selectedUserId: '',
	        selectedMobileUserId: '',
	        selectedCustomerId: '',
	        isStripe: ''
	      }, function () {
	        _this.props.fetchMobileUsers(_this.props.currentPage, _this.props.limit, _this.props.searchCustomerNo, _this.props.searchFirstName, _this.props.searchLastName, _this.props.searchEmail);
	      });
	    };
	
	    _this.rowGetter = function (rowIdx) {
	      var rows = _this.getRows();
	      return rows[rowIdx];
	    };
	
	    _this.handleGridSort = function (sortColumn, sortDirection) {
	      _this.setState({ sortColumn: sortColumn, sortDirection: sortDirection });
	    };
	
	    _this.handleFilterChange = function (filter) {
	      var newFilters = Object.assign({}, _this.state.filters);
	      if (filter.filterTerm) {
	        newFilters[filter.column.key] = filter;
	      } else {
	        delete newFilters[filter.column.key];
	      }
	      _this.setState({ filters: newFilters });
	    };
	
	    _this.openChoosePaymentMethod = function () {
	      _this.setState({
	        showChoosePaymentMethod: true
	      });
	    };
	
	    _this.closeChoosePaymentMethod = function () {
	      _this.setState({
	        showChoosePaymentMethod: false
	      });
	    };
	
	    _this.onSelectShowPrice = function (show) {
	      var url = _url.USERNAME_URL + _this.state.selectedMobileUserId + "/";
	      _axios2.default.put(url, {
	        IsWebShowPrice: show
	      }, {
	        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
	      }).then(function (response) {
	        if (response.status === 200) {
	          _this.props.handleShowPriceChange();
	          // alert(`Changed Show Price to ${show}`);
	        }
	      }).catch(function (error) {
	        alert("Could not set Show Price, please try again!");
	      });
	    };
	
	    _this.onDeactivate = function (show) {
	      var url = _url.USERNAME_URL + _this.state.selectedMobileUserId + "/";
	      _axios2.default.put(url, {
	        IsActive: show
	      }, {
	        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
	      }).then(function (response) {
	        if (response.status === 200) {
	          _this.props.handleShowPriceChange();
	          // alert(`Changed Show Price to ${show}`);
	        }
	      }).catch(function (error) {
	        alert("Could not set Show Price, please try again!");
	      });
	    };
	
	    _this.handleDispatcherBindSuccess = function () {
	      _this.props.refetchMobileUsers();
	    };
	
	    _this.state = {
	      rows: props.rows,
	      filters: {},
	      showPasswordPopup: false,
	      showEmailPopup: false,
	      showEditCreditPopup: false,
	      showCreditDetailPopup: false,
	      showChoosePaymentMethod: false,
	      selectedUserId: '',
	      selectedMobileUserId: '',
	      selectedCustomerId: '',
	      isStripe: '',
	      dispatcherBindModalVisibility: false,
	      clickedUserId: '',
	      clickedMobileUserId: '',
	      actionBtnClicked: false
	    };
	    _this.checkAuthorize = _this.checkAuthorize.bind(_this);
	    _this.closeResetPasswordPopup = _this.closeResetPasswordPopup.bind(_this);
	    _this.openResetPasswordPopup = _this.openResetPasswordPopup.bind(_this);
	    _this.closeResetEmailPopup = _this.closeResetEmailPopup.bind(_this);
	    _this.openResetEmailPopup = _this.openResetEmailPopup.bind(_this);
	    _this.closeEditCreditPopup = _this.closeEditCreditPopup.bind(_this);
	    _this.openEditCreditPopup = _this.openEditCreditPopup.bind(_this);
	    _this.closeCreditDetailPopup = _this.closeCreditDetailPopup.bind(_this);
	    _this.openCreditDetailPopup = _this.openCreditDetailPopup.bind(_this);
	    return _this;
	  }
	
	  _createClass(MobileUserTable, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.rows !== this.props.rows) {
	        this.setState({ rows: nextProps.rows });
	      }
	      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
	        this.closeResetPasswordPopup();
	        this.resetPassword();
	      }
	    }
	
	    // MODAL ACTIONS
	
	
	    // Mobile user table
	
	
	    // Handle the row select function
	
	
	    // Handle the sortable function
	
	  }, {
	    key: 'checkAuthorize',
	    value: function checkAuthorize(password) {
	      this.props.checkPassword(password);
	    }
	  }, {
	    key: 'openResetPasswordPopup',
	    value: function openResetPasswordPopup() {
	      this.setState({
	        showPasswordPopup: true
	      });
	      this.props.clearCheckPassword();
	    }
	  }, {
	    key: 'closeResetPasswordPopup',
	    value: function closeResetPasswordPopup() {
	      this.setState({
	        showPasswordPopup: false
	      });
	    }
	  }, {
	    key: 'openResetEmailPopup',
	    value: function openResetEmailPopup() {
	      this.setState({
	        showEmailPopup: true
	      });
	    }
	  }, {
	    key: 'closeResetEmailPopup',
	    value: function closeResetEmailPopup() {
	      this.setState({
	        showEmailPopup: false
	      });
	    }
	  }, {
	    key: 'openEditCreditPopup',
	    value: function openEditCreditPopup() {
	      this.setState({
	        showEditCreditPopup: true
	      });
	    }
	  }, {
	    key: 'closeCreditDetailPopup',
	    value: function closeCreditDetailPopup() {
	      this.setState({
	        showCreditDetailPopup: false
	      });
	    }
	  }, {
	    key: 'openCreditDetailPopup',
	    value: function openCreditDetailPopup() {
	      this.setState({
	        showCreditDetailPopup: true
	      });
	    }
	  }, {
	    key: 'closeEditCreditPopup',
	    value: function closeEditCreditPopup() {
	      this.setState({
	        showEditCreditPopup: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var IsActiveFormatter = _react2.default.createClass({
	        displayName: 'IsActiveFormatter',
	        render: function render() {
	          if (this.props.value === true) {
	            return _react2.default.createElement(
	              'span',
	              { className: 'label label-success' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'active' })
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inactive' })
	          );
	        }
	      });
	      var CreditFormatter = _react2.default.createClass({
	        displayName: 'CreditFormatter',
	
	        onClick: function onClick(row) {
	          _this2.setState({
	            clickedUserId: '' + row.dependentValues.User_id,
	            clickedMobileUserId: '' + row.dependentValues.MobileUser_id
	          });
	          _this2.openCreditDetailPopup();
	        },
	        render: function render() {
	          var _this3 = this;
	
	          return _react2.default.createElement(
	            'div',
	            {
	              style: {
	                width: '100%',
	                color: '#0077c5',
	                fontWeight: 600,
	                cursor: 'pointer'
	              },
	              onClick: function onClick() {
	                _this3.onClick(_this3.props);
	              }
	            },
	            this.props.value
	          );
	        }
	      });
	      var ActionFormatterMessage = _react2.default.createClass({
	        displayName: 'ActionFormatterMessage',
	
	        onClick: function onClick(row) {
	          if (_this2.state.actionBtnClicked) {
	            return;
	          }
	          var mobileUserId = row.dependentValues.MobileUser_id;
	          _this2.setState({ actionBtnClicked: true }, function () {
	            _this2.context.router.push('/userManagement/mobileUserMessages/' + mobileUserId);
	          });
	        },
	        render: function render() {
	          var _this4 = this;
	
	          return _react2.default.createElement(
	            'div',
	            {
	              style: {
	                width: '100%',
	                color: '#0077c5',
	                fontWeight: 600,
	                cursor: 'pointer'
	              },
	              onClick: function onClick() {
	                _this4.onClick(_this4.props);
	              }
	            },
	            'Messages'
	          );
	        }
	      });
	
	      var ActionFormatterProduct = _react2.default.createClass({
	        displayName: 'ActionFormatterProduct',
	
	        onClick: function onClick(row) {
	          if (_this2.state.actionBtnClicked) {
	            return;
	          }
	          var mobileUserId = row.dependentValues.MobileUser_id;
	          _this2.setState({ actionBtnClicked: true }, function () {
	            _this2.context.router.push('/userManagement/mobileUserProducts/' + mobileUserId);
	          });
	        },
	        render: function render() {
	          var _this5 = this;
	
	          return _react2.default.createElement(
	            'div',
	            {
	              style: {
	                width: '100%',
	                color: '#0077c5',
	                fontWeight: 600,
	                cursor: 'pointer'
	              },
	              onClick: function onClick() {
	                _this5.onClick(_this5.props);
	              }
	            },
	            'Product'
	          );
	        }
	      });
	
	      var columns = [{
	        key: 'CustomerNum',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_no' }),
	        resizable: true,
	        width: 90,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'FirstName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'first_name' }),
	        resizable: true,
	        width: 90,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'LastName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_name' }),
	        resizable: true,
	        width: 90,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'email',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' }),
	        resizable: true,
	        width: 200,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'phone',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' }),
	        resizable: true,
	        width: 100,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'IsActive',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'active' }),
	        width: 65,
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: IsActiveFormatter
	        // getRowMetaData: (row) => row,
	      }].concat(_toConsumableArray(isABC ? [{
	        key: 'DispatcherName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatch_name' }),
	        resizable: true,
	        width: 150,
	        sortable: true,
	        filterable: true
	      }] : []), _toConsumableArray(_root_url.isWUFS ? [{
	        key: 'credit',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit' }),
	        resizable: true,
	        width: 65,
	        sortable: true,
	        filterable: true,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        },
	        formatter: CreditFormatter,
	        cellClass: this.state.showCreditDetailPopup ? 'z-index-100' : ''
	      }, {
	        key: 'action',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'action' }),
	        resizable: true,
	        width: 80,
	        sortable: true,
	        filterable: true,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        },
	        formatter: ActionFormatterMessage
	      }, {
	        key: 'action2',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'action' }),
	        resizable: true,
	        width: 80,
	        sortable: true,
	        filterable: true,
	        getRowMetaData: function getRowMetaData(row) {
	          return row;
	        },
	        formatter: ActionFormatterProduct
	      }] : []));
	
	      if (isHMM) {
	        var indexPhone = _.findIndex(columns, { key: "phone" });
	        var showPriceColumn = {
	          key: 'IsWebShowPriceDisplay',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'show_price' }),
	          resizable: true,
	          sortable: true,
	          width: 80,
	          filterable: true,
	          formatter: function formatter(_ref) {
	            var value = _ref.value;
	            return _react2.default.createElement(
	              'div',
	              { style: { width: "100%", height: "100%", textAlign: "center" } },
	              value
	            );
	          }
	        };
	        // const showType = {
	        //   key: "UserType",
	        //   name: <Translate value="type" />,
	        //   resizable: true,
	        //   sortable: true,
	        //   width: 80,
	        //   filterable: true,
	        // };
	        // columns.splice(indexPhone, 0, showType);
	        columns.splice(indexPhone, 0, showPriceColumn);
	        if (this.state.rows.length > 0) {
	          this.state.rows.map(function (row) {
	            if (row.IsWebShowPrice === true) {
	              row.IsWebShowPriceDisplay = "yes";
	            } else {
	              row.IsWebShowPriceDisplay = "no";
	            }
	          });
	        }
	      }
	      var resetEmail = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reset_email' });
	      var resetPassword = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reset_password' });
	      var changePaymentMethod = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'change_payment_method' });
	      var editCredit = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_credit' });
	      var creditDetail = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit_details' });
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          { style: styles.buttonBar },
	          _react2.default.createElement(
	            _reactBootstrap.DropdownButton,
	            {
	              bsStyle: 'warning',
	              disabled: this.state.selectedUserId === "",
	              title: _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement('i', { className: 'fa fa-pencil' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: ' edit' })
	              )
	            },
	            _react2.default.createElement(
	              _reactBootstrap.MenuItem,
	              { onClick: this.openResetPasswordPopup },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reset password' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.MenuItem,
	              { onClick: this.openResetEmailPopup },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reset email' })
	            ),
	            isEcity && _react2.default.createElement(
	              _reactBootstrap.MenuItem,
	              { onClick: this.openChoosePaymentMethod },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'change_payment_method' })
	            ),
	            _root_url.isWUFS && _react2.default.createElement(
	              _reactBootstrap.MenuItem,
	              { onClick: this.openEditCreditPopup },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_credit' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'success',
	              onClick: function onClick() {
	                return _this2.props.fetchUsername(_this2.props.mobileUserId);
	              }
	            },
	            _react2.default.createElement('em', { className: 'fa fa-download' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fetch_username' })
	          ),
	          isHMM && _react2.default.createElement(
	            _reactBootstrap.DropdownButton,
	            {
	              bsStyle: 'warning',
	              disabled: this.state.selectedUserId === "",
	              title: _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'show_price' })
	              )
	            },
	            _react2.default.createElement(
	              _reactBootstrap.MenuItem,
	              { onClick: function onClick() {
	                  return _this2.onSelectShowPrice(true);
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'show' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.MenuItem,
	              { onClick: function onClick() {
	                  return _this2.onSelectShowPrice(false);
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'hide' })
	            )
	          ),
	          true && _react2.default.createElement(
	            _reactBootstrap.DropdownButton,
	            {
	              bsStyle: 'danger',
	              disabled: this.state.selectedUserId === "",
	              title: _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'activate' })
	              )
	            },
	            _react2.default.createElement(
	              _reactBootstrap.MenuItem,
	              { onClick: function onClick() {
	                  return _this2.onDeactivate(true);
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'active' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.MenuItem,
	              { onClick: function onClick() {
	                  return _this2.onDeactivate(false);
	                } },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deactive' })
	            )
	          ),
	          isABC && _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'success',
	              onClick: function onClick() {
	                return _this2.setDispatcherBindModalVisibility(true);
	              },
	              disabled: this.state.selectedUserId === ""
	            },
	            _react2.default.createElement('em', { className: 'fa fa-link' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dispatcher_bind' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: styles.createDialogStyle,
	            isVisible: this.state.showPasswordPopup,
	            onCloseClicked: this.closeResetPasswordPopup,
	            title: resetPassword
	          },
	          _react2.default.createElement(_confirmActionModal2.default, {
	            'case': 'confirmPassword',
	            closeC: this.checkAuthorize,
	            checkPasswordFailure: this.props.checkPasswordFailure
	          })
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: styles.createDialogStyle,
	            isVisible: this.state.showEmailPopup,
	            onCloseClicked: this.closeResetEmailPopup.bind(this),
	            title: resetEmail
	          },
	          _react2.default.createElement(_ResetEmailModal2.default, {
	            isVisible: this.state.showEmailPopup,
	            onCloseClicked: this.closeResetEmailPopup,
	            selectedUserId: this.state.selectedUserId
	          })
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: styles.createDialogStyle,
	            isVisible: this.state.showEditCreditPopup,
	            onCloseClicked: this.closeEditCreditPopup.bind(this),
	            title: editCredit
	          },
	          _react2.default.createElement(_EditCreditModal2.default, {
	            isVisible: this.state.showEditCreditPopup,
	            onCloseClicked: this.closeEditCreditPopup,
	            selectedUserId: this.state.selectedUserId,
	            selectedMobileUserId: this.state.selectedMobileUserId
	          })
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: styles.creditDetailDialogStyle,
	            overlayStyles: styles.creditDetailOverlayStyle,
	            isVisible: this.state.showCreditDetailPopup,
	            onCloseClicked: this.closeCreditDetailPopup.bind(this),
	            title: creditDetail
	          },
	          _react2.default.createElement(_CreditDetailModal2.default, {
	            isVisible: this.state.showCreditDetailPopup,
	            onCloseClicked: this.closeCreditDetailPopup,
	            selectedUserId: this.state.clickedUserId,
	            selectedMobileUserId: this.state.clickedMobileUserId
	          })
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: styles.createDialogStyle,
	            isVisible: this.state.showChoosePaymentMethod,
	            onCloseClicked: this.closeChoosePaymentMethod,
	            title: changePaymentMethod
	          },
	          _react2.default.createElement(_ChoosePaymentMethodModal2.default, {
	            'case': 'confirmPaymentMethod',
	            isStripe: this.state.isStripe,
	            id: this.state.selectedCustomerId,
	            changePaymentMethod: this.savePaymentMethod
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            id: 'MobileUserTable-dataGrid1',
	            style: { marginTop: "55px", zIndex: 0 }
	          },
	          _react2.default.createElement(_reactDataGrid2.default, {
	            rowKey: 'MobileUser_id',
	            onGridSort: this.handleGridSort
	            // toolbar={<Toolbar enableFilter />}
	            , headerRowHeight: 50,
	            rowHeight: 25,
	            onAddFilter: this.handleFilterChange,
	            columns: columns,
	            minHeight: 580,
	            rowGetter: this.rowGetter,
	            rowsCount: this.getSize(),
	            enableRowSelect: 'single',
	            rowSelection: {
	              showCheckbox: true,
	              enableShiftSelect: true,
	              onRowsSelected: this.onRowsSelected,
	              onRowsDeselected: this.onRowsDeselected,
	              selectBy: {
	                isSelectedKey: "isSelected"
	              }
	            }
	          })
	        ),
	        _react2.default.createElement(
	          _reactSkylight.SkyLightStateless,
	          {
	            dialogStyles: styles.createDialogStyle,
	            isVisible: this.state.dispatcherBindModalVisibility,
	            onCloseClicked: this.setDispatcherBindModalVisibility,
	            title: 'Bind Mobile user with scm user'
	          },
	          _react2.default.createElement(DispatcherBindModal, {
	            scmUsers: this.props.scmUsers || [],
	            selectedMobileUserId: this.state.selectedMobileUserId,
	            handleDispatcherBindSuccess: this.handleDispatcherBindSuccess
	          })
	        )
	      );
	    }
	  }]);
	
	  return MobileUserTable;
	}(_react.Component);
	
	MobileUserTable.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	MobileUserTable.propTypes = {
	  clearCheckPassword: _propTypes2.default.func.isRequired,
	  checkPassword: _propTypes2.default.func.isRequired,
	  checkPasswordSuccess: _propTypes2.default.bool.isRequired,
	  checkPasswordFailure: _propTypes2.default.bool.isRequired
	};
	
	var _default = MobileUserTable;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(DispatcherBindModal, 'DispatcherBindModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/MobileUserTable.jsx');
	
	  __REACT_HOT_LOADER__.register(isHMM, 'isHMM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/MobileUserTable.jsx');
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/MobileUserTable.jsx');
	
	  __REACT_HOT_LOADER__.register(isABC, 'isABC', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/MobileUserTable.jsx');
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/MobileUserTable.jsx');
	
	  __REACT_HOT_LOADER__.register(MobileUserTable, 'MobileUserTable', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/MobileUserTable.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/MobileUserTable.jsx');
	}();

	;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _url = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  onCloseClicked: _propTypes2.default.func.isRequired,
	  selectedUserId: _propTypes2.default.string.isRequired
	};
	
	var ResetEmailModal = function (_Component) {
	  _inherits(ResetEmailModal, _Component);
	
	  function ResetEmailModal() {
	    _classCallCheck(this, ResetEmailModal);
	
	    var _this = _possibleConstructorReturn(this, (ResetEmailModal.__proto__ || Object.getPrototypeOf(ResetEmailModal)).call(this));
	
	    _this.resetEmail = function (email) {
	      var errors = '';
	
	      // check validation
	      if (!email) {
	        errors = 'Email field cannot be empty';
	      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
	        errors = 'Email is not valid';
	      }
	
	      var url = _url.RESET_EMAIL_URL + _this.props.selectedUserId;
	      if (errors === '') {
	        _axios2.default.put(url, {
	          email: email
	        }, {
	          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	        }).then(function (response) {
	          if (response.status === 200) {
	            alert('Reset email to: ' + email);
	          }
	          _this.props.onCloseClicked();
	          _this.setState({
	            errors: ''
	          });
	        }).catch(function (error) {
	          alert('Could not reset email, please try again!');
	        });
	      } else {
	        _this.setState({ errors: errors });
	      }
	    };
	
	    _this.state = {
	      inputText: '',
	      errors: ''
	    };
	    return _this;
	  }
	
	  _createClass(ResetEmailModal, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          inputText = _state.inputText,
	          errors = _state.errors;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'text-center', style: { marginTop: '20px' } },
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'type_in_your_email' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-4 col-xs-offset-4' },
	            _react2.default.createElement(_reactBootstrap.Input, {
	              type: 'email',
	              onChange: function onChange(event) {
	                return _this2.setState({ inputText: event.target.value });
	              }
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-1 col-xs-offset-5', style: { marginTop: '50px' } },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                onClick: function onClick() {
	                  _this2.resetEmail(inputText);
	                }
	              },
	              _react2.default.createElement('em', { className: 'fa fa-check' }),
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Confirm' })
	            )
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          errors !== '' && _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: errors })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ResetEmailModal;
	}(_react.Component);
	
	ResetEmailModal.propTypes = propTypes;
	var _default = ResetEmailModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/ResetEmailModal.jsx');
	
	  __REACT_HOT_LOADER__.register(ResetEmailModal, 'ResetEmailModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/ResetEmailModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/ResetEmailModal.jsx');
	}();

	;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserProductGroupsModal = function (_Component) {
	  _inherits(UserProductGroupsModal, _Component);
	
	  function UserProductGroupsModal() {
	    _classCallCheck(this, UserProductGroupsModal);
	
	    var _this = _possibleConstructorReturn(this, (UserProductGroupsModal.__proto__ || Object.getPrototypeOf(UserProductGroupsModal)).call(this));
	
	    _this.state = {
	      groups: []
	    };
	    return _this;
	  }
	
	  _createClass(UserProductGroupsModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      if (this.props.groups && this.props.groups.length > 0) {
	        this.setState({
	          groups: this.props.groups
	        });
	      }
	    }
	  }, {
	    key: 'handleChangeProductGroups',
	    value: function handleChangeProductGroups(id, checked) {
	      var cpGroups = [];
	      if (id == -2) {
	        cpGroups = this.state.groups.map(function (item) {
	          return _extends({}, item, { checked: checked });
	        });
	      } else {
	        cpGroups = this.state.groups.map(function (item) {
	          if (item.value == id) {
	            return _extends({}, item, { checked: checked });
	          } else {
	            return _extends({}, item);
	          }
	        });
	      }
	
	      this.setState({
	        groups: cpGroups
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          onChangeProductGroups = _props.onChangeProductGroups,
	          onClose = _props.onClose;
	
	      return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', flexDirection: 'column' } },
	        _react2.default.createElement(
	          'div',
	          { style: { overflowY: 'scroll', height: '200px' } },
	          this.state.groups.map(function (item) {
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('input', { type: 'checkbox', checked: item.checked, onChange: function onChange(event) {
	                  _this2.handleChangeProductGroups(item.value, event.target.checked);
	                } }),
	              _react2.default.createElement(
	                'span',
	                null,
	                item.label
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.ButtonToolbar,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { onClick: function onClick() {
	                onClose();
	              }, bsStyle: 'danger' },
	            ' ',
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { onClick: function onClick() {
	                onChangeProductGroups(_this2.state.groups);
	              }, bsStyle: 'success' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return UserProductGroupsModal;
	}(_react.Component);
	
	var _default = UserProductGroupsModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(UserProductGroupsModal, 'UserProductGroupsModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/UserProductGroupsModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/UserProductGroupsModal.jsx');
	}();

	;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _inputField = __webpack_require__(16);
	
	var _selection = __webpack_require__(21);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isHF = _root_url.ROOT_API_URL === 'https://hfstage-erp.truckxi.com/api/' || _root_url.ROOT_URL === 'https://hfstage-erp.truckxi.com/api/';
	
	var verifyStatus = [{
	  value: false,
	  label: 'In Progress'
	}, {
	  value: true,
	  label: 'Verified'
	}];
	
	var genderStatus = [{
	  value: 'male',
	  label: 'Male'
	}, {
	  value: 'female',
	  label: 'Female'
	}, {
	  value: 'other',
	  label: 'Other'
	}];
	
	var retailerStatus = [{
	  label: 'YES',
	  value: true
	}, {
	  label: 'NO',
	  value: false
	}];
	
	var businessTypes = [{
	  label: 'C-Corp',
	  value: 'C-Corp'
	}, {
	  label: 'S-Corp',
	  value: 'S-Corp'
	}, {
	  label: 'LLC',
	  value: 'LLC'
	}, {
	  label: 'Sole Proprietor',
	  value: 'Sole Proprietor'
	}];
	
	var propTypes = {
	  confirm: _propTypes2.default.func.isRequired,
	  cancel: _propTypes2.default.func.isRequired,
	  // eslint-disable-next-line react/require-default-props
	  user: _propTypes2.default.object,
	  customerOptions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.string,
	    label: _propTypes2.default.string
	  }))
	};
	var defaultProps = {
	  customerOptions: []
	};
	var BusinessUserEditModal = function BusinessUserEditModal(_ref) {
	  var handleSubmit = _ref.handleSubmit,
	      cancel = _ref.cancel,
	      confirm = _ref.confirm,
	      user = _ref.user,
	      customerOptions = _ref.customerOptions;
	  return _react2.default.createElement(
	    _reactBootstrap.Panel,
	    null,
	    _react2.default.createElement(
	      'form',
	      { className: 'form-horizontal', method: 'get', action: '#' },
	      _react2.default.createElement(
	        _reactBootstrap.Grid,
	        { style: { width: '100%' } },
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'business_name' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'full_name' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone_number' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'business_name', component: _inputField.InputField })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'full_name', component: _inputField.InputField })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'phone_number', component: _inputField.InputField })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'email', component: _inputField.InputField })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'street' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'suite' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'state' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'street', component: _inputField.InputField })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'suit_unit', component: _inputField.InputField })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'city', component: _inputField.InputField })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'state', component: _inputField.InputField })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zipcode' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'verified' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'business_name' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'zipcode', component: _inputField.InputField })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'is_process', component: _selection.Selection, options: verifyStatus, disabled: true })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'business_name', component: _inputField.InputField, disabled: true })
	              )
	            )
	          ),
	          _react2.default.createElement(_reactBootstrap.Col, { sm: 6 })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'business_type' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ein' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ssn' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'is_retailer' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'business_type', component: _selection.Selection, options: businessTypes })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'ein', component: _inputField.InputField })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'ssn', component: _inputField.InputField })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'is_retailer', component: _selection.Selection, options: retailerStatus })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'resale_no' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dun_brad_no' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'year_in_business' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _root_url.isElegant && _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customers' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'resale_no', component: _inputField.InputField })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'dun_brad_no', component: _inputField.InputField })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'business_year', component: _inputField.InputField })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            isHF && _react2.default.createElement(
	              'div',
	              null,
	              user.file1 !== null && user.file1 !== '' && _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  href: user.file1
	                },
	                _react2.default.createElement('em', { className: 'fa fa-download' }),
	                '  Document 1'
	              )
	            ),
	            isHF && _react2.default.createElement(
	              'div',
	              null,
	              user.file2 != null && user.file2 != "" && _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  href: user.file2
	                },
	                _react2.default.createElement('em', { className: 'fa fa-download' }),
	                '  Document 2'
	              )
	            ),
	            isHF && _react2.default.createElement(
	              'div',
	              null,
	              user.file3 != null && user.file3 != "" && _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  href: user.file3
	                },
	                _react2.default.createElement('em', { className: 'fa fa-download' }),
	                '  Document 3'
	              )
	            ),
	            isHF && _react2.default.createElement(
	              'div',
	              null,
	              user.file4 != null && user.file4 != "" && _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  href: user.file4
	                },
	                _react2.default.createElement('em', { className: 'fa fa-download' }),
	                '  Document 4'
	              )
	            ),
	            isHF && _react2.default.createElement(
	              'div',
	              null,
	              user.file5 != null && user.file5 != "" && _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  href: user.file5
	                },
	                _react2.default.createElement('em', { className: 'fa fa-download' }),
	                '  Document 5'
	              )
	            ),
	            _root_url.isElegant && _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'customer_group_id', component: _selection.Selection, options: customerOptions })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'centerStyle' },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsStyle: 'primary', style: { marginRight: '5px', width: '90px' }, onClick: cancel },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsStyle: 'success', style: { width: '90px' }, onClick: handleSubmit(confirm) },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	          )
	        )
	      )
	    )
	  );
	};
	
	function mapStateToProps(state) {
	  var initialValues = state.settings.selectedBusinessUser;
	  return {
	    initialValues: initialValues
	  };
	}
	
	var validate = function validate(values) {
	  var errors = {};
	  if (!values.email) {
	    errors.email = 'Email can not be empty';
	  }
	  if (!values.business_name) {
	    errors.business_name = 'Business name can not be empty';
	  }
	  if (!values.full_name) {
	    errors.full_name = 'Name can not be empty';
	  }
	  if (!values.phone_number) {
	    errors.phone_number = 'Phone number can not be empty';
	  }
	  if (!values.street) {
	    errors.street = 'Street can not be empty';
	  }
	  if (!values.city) {
	    errors.city = 'City can not be empty';
	  }
	  if (!values.state) {
	    errors.state = 'State can not be empty';
	  }
	  if (!values.zipcode) {
	    errors.zipcode = 'Zipcode can not be empty';
	  }
	  return errors;
	};
	
	BusinessUserEditModal.propTypes = propTypes;
	BusinessUserEditModal.defaultProps = defaultProps;
	
	var businessUserEditModal = (0, _reduxForm.reduxForm)({
	  form: 'userManagement/businessUserEdit',
	  destroyOnUnmount: true,
	  enableReinitialize: true,
	  touchOnChange: true,
	  touchOnBlur: false,
	  validate: validate
	})(BusinessUserEditModal);
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(businessUserEditModal);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/businessUserEditModal.jsx');
	
	  __REACT_HOT_LOADER__.register(isHF, 'isHF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/businessUserEditModal.jsx');
	
	  __REACT_HOT_LOADER__.register(verifyStatus, 'verifyStatus', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/businessUserEditModal.jsx');
	
	  __REACT_HOT_LOADER__.register(genderStatus, 'genderStatus', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/businessUserEditModal.jsx');
	
	  __REACT_HOT_LOADER__.register(retailerStatus, 'retailerStatus', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/businessUserEditModal.jsx');
	
	  __REACT_HOT_LOADER__.register(businessTypes, 'businessTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/businessUserEditModal.jsx');
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/businessUserEditModal.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/businessUserEditModal.jsx');
	
	  __REACT_HOT_LOADER__.register(BusinessUserEditModal, 'BusinessUserEditModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/businessUserEditModal.jsx');
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/businessUserEditModal.jsx');
	
	  __REACT_HOT_LOADER__.register(businessUserEditModal, 'businessUserEditModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/businessUserEditModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/businessUserEditModal.jsx');
	}();

	;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var contextTypes = {
	  router: _propTypes2.default.object
	};
	
	var propTypes = {
	  multiCurrenciesEdited: _propTypes2.default.bool,
	  multiCurrenciesIsEditing: _propTypes2.default.bool,
	  currencyRatesIsLoading: _propTypes2.default.bool,
	  currencyRatesError: _propTypes2.default.string,
	  currencyRates: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  fetchCurrencyRates: _propTypes2.default.func.isRequired,
	  editMultiCurrencies: _propTypes2.default.func.isRequired
	};
	
	var defaultProps = {
	  multiCurrenciesEdited: false,
	  multiCurrenciesIsEditing: false,
	  currencyRatesIsLoading: false,
	  currencyRatesError: '',
	  currencyRates: []
	};
	
	var CurrencyManagement = function (_Component) {
	  _inherits(CurrencyManagement, _Component);
	
	  function CurrencyManagement() {
	    _classCallCheck(this, CurrencyManagement);
	
	    var _this = _possibleConstructorReturn(this, (CurrencyManagement.__proto__ || Object.getPrototypeOf(CurrencyManagement)).call(this));
	
	    _this.getRows = function () {
	      return _reactDataGridAddons.Data.Selectors.getRows(_this.state.currencyValues);
	    };
	
	    _this.getSize = function () {
	      return _this.getRows().length;
	    };
	
	    _this.updateRows = function () {
	      _this.props.editMultiCurrencies(_this.state.currencyValues.editedRows);
	    };
	
	    _this.rowGetter = function (rowIdx) {
	      var rows = _this.getRows();
	      return rows[rowIdx];
	    };
	
	    _this.handleGridSort = function (sortColumn, sortDirection) {
	      var currencyValues = Object.assign({}, _this.state.currencyValues, { sortColumn: sortColumn, sortDirection: sortDirection });
	      _this.setState({ currencyValues: currencyValues });
	    };
	
	    _this.handleRowUpdated = function (e) {
	      _this.setState({ sortColumn: null, sortDirection: null });
	      var rows = _this.getRows();
	      var editedRows = _this.state.currencyValues.editedRows.slice(0);
	      Object.assign(rows[e.rowIdx], e.updated);
	      // if the element is already edited, remove the old one.
	      editedRows.forEach(function (element, index) {
	        console.log('element: ', element);
	        if (element.Idx === rows[e.rowIdx].Index) {
	          editedRows.splice(index, 1);
	        }
	      });
	      // push the row into the editedRows array
	      editedRows.push(rows[e.rowIdx]);
	      var currencyValues = _extends({}, _this.state.currencyValues, {
	        rows: rows,
	        editedRows: editedRows
	      });
	      _this.setState({ currencyValues: currencyValues });
	    };
	
	    _this.state = {
	      currencyValues: {
	        rows: [],
	        selectedRows: [],
	        editedRows: [],
	        sortColumn: null,
	        sortDirection: null
	      }
	    };
	    return _this;
	  }
	
	  _createClass(CurrencyManagement, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.currencyRates) {
	        var currencyRates = this.props.currencyRates;
	
	        currencyRates.map(function (currencyRate, index) {
	          currencyRate.Index = index;
	        });
	        var currencyValues = _extends({}, this.state.currencyValues, {
	          rows: currencyRates,
	          filters: {},
	          sortColumn: null,
	          sortDirection: null
	        });
	        this.setState({ currencyValues: currencyValues });
	      }
	      this.props.fetchCurrencyRates();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.currencyRates && nextProps.currencyRates !== this.props.currencyRates) {
	        var currencyRates = nextProps.currencyRates;
	
	        currencyRates.map(function (currencyRate, index) {
	          currencyRate.Idex = index;
	        });
	        var currencyValues = _extends({}, this.state.currencyValues, {
	          rows: currencyRates,
	          editedRows: [],
	          filters: {},
	          sortColumn: null,
	          sortDirection: null
	        });
	        this.setState({ currencyValues: currencyValues });
	      }
	      if (nextProps.multiCurrenciesEdited && nextProps.multiCurrenciesEdited !== this.props.multiCurrenciesEdited) {
	        this.props.fetchCurrencyRates();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var columns = [{
	        key: 'CountryFullName',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'country' }),
	        resizable: true,
	        editable: false,
	        width: 120,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'CurrencyCode',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'currency' }),
	        resizable: true,
	        editable: false,
	        width: 120,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'ExchangeRate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rate' }),
	        resizable: true,
	        editable: true,
	        width: 90,
	        sortable: true,
	        filterable: true
	      }];
	
	      if (this.props.currencyRatesIsLoading && !this.props.currencyRatesError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.currencyRatesError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.currencyRatesError)
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'admin_tools' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'currency_management' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'tax-management' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { id: 'tax-management-table' },
	              _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                { className: 'tax-management-table-buttons' },
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'success',
	                    className: 'buttonStyle',
	                    onClick: function onClick(event) {
	                      return _this2.updateRows(event);
	                    },
	                    disabled: this.state.currencyValues.editedRows.length === 0 || !(0, _permissions2.default)('change_currency')
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { id: 'edit-information' },
	                this.props.multiCurrenciesIsEditing && !this.props.multiCurrenciesEdited && _react2.default.createElement(
	                  'div',
	                  { className: 'alert alert-info groups-saving-info' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saving' })
	                ),
	                !this.props.multiCurrenciesIsEditing && this.props.multiCurrenciesEdited && _react2.default.createElement(
	                  'div',
	                  { className: 'alert alert-success groups-saving-info' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saved' })
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { sm: 12 },
	                  _react2.default.createElement(
	                    'div',
	                    { style: { maxWidth: '100%' }, id: 'TaxManagement-dataGrid1' },
	                    _react2.default.createElement(_reactDataGrid2.default, {
	                      rowKey: 'Currency_id',
	                      enableCellSelect: true,
	                      onGridSort: this.handleGridSort,
	                      toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, null),
	                      onRowUpdated: this.handleRowUpdated,
	                      rowHeight: 25,
	                      minHeight: 675,
	                      columns: columns,
	                      rowGetter: this.rowGetter,
	                      rowsCount: this.getSize()
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CurrencyManagement;
	}(_react.Component);
	
	CurrencyManagement.contextTypes = contextTypes;
	CurrencyManagement.propTypes = propTypes;
	CurrencyManagement.defaultProps = defaultProps;
	
	var _default = CurrencyManagement;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(contextTypes, 'contextTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/currencyManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/currencyManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/currencyManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(CurrencyManagement, 'CurrencyManagement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/currencyManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/currencyManagement.jsx');
	}();

	;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupManagement = function (_Component) {
	    _inherits(GroupManagement, _Component);
	
	    function GroupManagement() {
	        _classCallCheck(this, GroupManagement);
	
	        var _this = _possibleConstructorReturn(this, (GroupManagement.__proto__ || Object.getPrototypeOf(GroupManagement)).call(this));
	
	        _this.state = {
	            groups: {
	                rows: [],
	                selectedRows: null,
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            },
	            rowClicked: false
	        };
	        return _this;
	    }
	
	    _createClass(GroupManagement, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            document.title = _root_url.companyCodeTitle;
	            this.props.fetchGroups();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.groups && nextProps.groups != this.props.groups) {
	                var newRows = [].concat(_toConsumableArray(nextProps.groups));
	                var groups = _extends({}, this.state.groups, { rows: newRows });
	                this.setState({ groups: groups });
	            }
	        }
	    }, {
	        key: 'renderTable',
	        value: function renderTable() {
	            var _this2 = this;
	
	            if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.error)
	                )
	            );else {
	                // Parameters of the react-data-grid
	                var tableHeight = window.innerHeight < 930 ? 650 : 650;
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this2.state.groups);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var groups = Object.assign({}, _this2.state.groups, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this2.setState({ groups: groups });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this2.state.groups.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var groups = _extends({}, _this2.state.groups, { filters: newFilters });
	                    _this2.setState({ groups: groups });
	                };
	
	                // Handle the row select function
	
	                var onRowsSelected = function onRowsSelected(rows) {
	                    var newRows = _this2.state.groups.rows;
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = true;
	                    });
	                    var groups = _extends({}, _this2.state.groups, { rows: newRows });
	                    _this2.setState({ groups: groups });
	                };
	
	                var onRowsDeselected = function onRowsDeselected(rows) {
	                    var newRows = _this2.state.groups.rows;
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = false;
	                    });
	                    // var rowIndexes = rows.map(r => r.rowIdx);
	                    var groups = _extends({}, _this2.state.groups, { rows: newRows });
	                    _this2.setState({ groups: groups });
	                };
	
	                var onRowClick = function onRowClick(rowIdx, row) {
	                    if (!_this2.state.rowClicked && (0, _permissions2.default)("change_group")) {
	                        _this2.setState({ rowClicked: true }, function () {
	                            _this2.props.resetCurrentGroup();
	                            _this2.props.selectCurrentGroup(row.id);
	                            _this2.context.router.push('/groupManagement/' + row.id);
	                        });
	                    }
	                };
	
	                // Column difinition
	
	                var columns = [{
	                    key: 'name',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'role_name' }),
	                    resizable: true,
	                    width: 220,
	                    sortable: true,
	                    filterable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { maxWidth: '99%' }, id: 'GroupManagement-dataGrid1' },
	                            _react2.default.createElement(_reactDataGrid2.default, {
	                                rowKey: 'id',
	                                onGridSort: handleGridSort,
	                                toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                                onAddFilter: handleFilterChange,
	                                columns: columns,
	                                rowHeight: 25,
	                                minHeight: tableHeight,
	                                rowGetter: rowGetter,
	                                rowsCount: getSize(),
	                                onRowClick: onRowClick
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'clickNew',
	        value: function clickNew(e) {
	            e.preventDefault();
	            this.props.resetCurrentGroup();
	            this.context.router.push('/groupManagement/new');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return (
	                //---------------
	                // Begin HTML: Create New/Edit role_management
	                //---------------
	                _react2.default.createElement(
	                    _ContentWrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'admin' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            { active: 'true' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'role_management' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Grid,
	                        { id: 'settings-role-management' },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'manage_active_roles' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Panel,
	                            { className: 'position-relative table-collapse-fix' },
	                            _react2.default.createElement(
	                                _reactBootstrap.ButtonToolbar,
	                                { className: 'table-buttons' },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        bsStyle: 'success',
	                                        className: 'marginLeftStyle',
	                                        onClick: function onClick(event) {
	                                            _this3.clickNew(event);
	                                        }, disabled: !(0, _permissions2.default)("add_group") },
	                                    _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	                                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_role' })
	                                )
	                            ),
	                            this.renderTable()
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return GroupManagement;
	}(_react.Component);
	
	GroupManagement.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = GroupManagement;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(GroupManagement, 'GroupManagement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/groupManagement.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/groupManagement.jsx');
	}();

	;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _inputField = __webpack_require__(16);
	
	var _reduxForm = __webpack_require__(3);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _permissions2 = __webpack_require__(24);
	
	var _permissions3 = _interopRequireDefault(_permissions2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RowRenderer = function (_Component) {
	    _inherits(RowRenderer, _Component);
	
	    function RowRenderer() {
	        _classCallCheck(this, RowRenderer);
	
	        return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	    }
	
	    _createClass(RowRenderer, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { onDoubleClick: function onDoubleClick() {
	                        _this2.props.onDoubleClick(_this2.props.row);
	                    } },
	                _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	            );
	        }
	    }]);
	
	    return RowRenderer;
	}(_react.Component);
	
	var GroupManagementDetail = function (_Component2) {
	    _inherits(GroupManagementDetail, _Component2);
	
	    function GroupManagementDetail() {
	        _classCallCheck(this, GroupManagementDetail);
	
	        var _this3 = _possibleConstructorReturn(this, (GroupManagementDetail.__proto__ || Object.getPrototypeOf(GroupManagementDetail)).call(this));
	
	        _this3.state = {
	            dirty: false,
	
	            groups: {
	                rows: [],
	                selectedRows: null,
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            },
	            userGroups: {
	                rows: [],
	                selectedRows: null,
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            },
	            permissions: {
	                rows: [],
	                selectedRows: null,
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            },
	            userPermissions: {
	                rows: [],
	                selectedRows: null,
	                filters: {},
	                sortColumn: null,
	                sortDirection: null
	            }
	        };
	        _this3.moveToUserPermissions = _this3.moveToUserPermissions.bind(_this3);
	        _this3.moveOffUserPermissions = _this3.moveOffUserPermissions.bind(_this3);
	        return _this3;
	    }
	
	    _createClass(GroupManagementDetail, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this4 = this;
	
	            if (this.props.params.id) {
	                this.props.fetchGroupDetail(this.props.params.id).then(function () {
	                    _this4.props.fetchPermissions();
	                });
	            } else {
	                this.props.fetchPermissions();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.groupDetail && nextProps.groupDetail != this.props.groupDetail) {
	                var userPermissions = _extends({}, this.state.userPermissions, { rows: nextProps.groupDetail.permissions });
	                var permissions = _extends({}, this.state.permissions);
	                userPermissions.rows.map(function (row) {
	                    var index = _lodash2.default.findIndex(permissions.rows, { permission_ptr_id: row.permission_ptr_id });
	                    if (index > -1) permissions.rows.splice(index, 1);
	                });
	                this.setState({ userPermissions: userPermissions, permissions: permissions });
	            }
	            if (nextProps.permissions && nextProps.permissions != this.props.permissions) {
	                var newRows = [].concat(_toConsumableArray(nextProps.permissions));
	                var _permissions = _extends({}, this.state.permissions, { rows: newRows });
	                var _userPermissions = this.state.userPermissions;
	
	                _userPermissions.rows.map(function (row) {
	                    var index = _lodash2.default.findIndex(_permissions.rows, { permission_ptr_id: row.permission_ptr_id });
	                    if (index > -1) _permissions.rows.splice(index, 1);
	                });
	                this.setState({ permissions: _permissions });
	            }
	            if (nextProps.groups && nextProps.groups != this.props.groups) {
	                var _newRows = [].concat(_toConsumableArray(nextProps.groups));
	                var groups = _extends({}, this.state.groups, { rows: _newRows });
	                this.setState({ groups: groups });
	            }
	        }
	    }, {
	        key: 'renderGroups',
	        value: function renderGroups() {
	            var _this5 = this;
	
	            if (this.props.groupsIsLoading && !this.props.groupsError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.groupsError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.groupsError)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this5.state.groups);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var groups = Object.assign({}, _this5.state.groups, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this5.setState({ groups: groups });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this5.state.groups.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var groups = _extends({}, _this5.state.groups, { filters: newFilters });
	                    _this5.setState({ groups: groups });
	                };
	
	                // Handle the row select function
	
	                var onRowsSelected = function onRowsSelected(rows) {
	                    var newRows = [].concat(_toConsumableArray(_this5.state.groups.rows));
	                    var selectedRows = [];
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = true;
	                        selectedRows.push(r.row);
	                    });
	                    if (_this5.state.groups.selectedRows) selectedRows = selectedRows.concat(_this5.state.groups.selectedRows);
	                    var groups = _extends({}, _this5.state.groups, { rows: newRows, selectedRows: selectedRows });
	                    _this5.setState({ groups: groups });
	                };
	
	                var onRowsDeselected = function onRowsDeselected(rows) {
	                    var newRows = [].concat(_toConsumableArray(_this5.state.groups.rows));
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = false;
	                    });
	                    var selectedRows = [].concat(_toConsumableArray(_this5.state.groups.selectedRows));
	                    selectedRows = selectedRows.filter(function (obj) {
	                        return obj.isSelected == true;
	                    });
	                    var groups = _extends({}, _this5.state.groups, { rows: newRows, selectedRows: selectedRows });
	                    _this5.setState({ groups: groups });
	                };
	
	                var onRowClick = function onRowClick(rowIdx, row) {}
	                //  this.props.fetchUserDetail(row.user_id);
	
	
	                // Column difinition
	
	                ;var columns = [{
	                    key: 'name',
	                    name: 'group name',
	                    resizable: true,
	                    width: 220,
	                    sortable: true,
	                    filterable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 5 },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { maxWidth: '99%' }, id: 'GroupManagementDetail-dataGrid1' },
	                        _react2.default.createElement(_reactDataGrid2.default, {
	                            rowKey: 'id',
	                            onGridSort: handleGridSort,
	                            toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                            onAddFilter: handleFilterChange,
	                            columns: columns,
	                            rowGetter: rowGetter,
	                            rowsCount: getSize(),
	                            onRowClick: onRowClick,
	                            enableRowSelect: 'multi',
	                            rowSelection: {
	                                showCheckbox: true,
	                                enableShiftSelect: true,
	                                onRowsSelected: onRowsSelected,
	                                onRowsDeselected: onRowsDeselected,
	                                selectBy: {
	                                    isSelectedKey: 'isSelected'
	                                }
	                            }
	                        })
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderUserGroups',
	        value: function renderUserGroups() {
	            var _this6 = this;
	
	            if (this.props.groupsIsLoading && !this.props.groupsError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.groupsError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.groupsError)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this6.state.userGroups);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var userGroups = Object.assign({}, _this6.state.userGroups, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this6.setState({ userGroups: userGroups });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this6.state.userGroups.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var userGroups = _extends({}, _this6.state.userGroups, { filters: newFilters });
	                    _this6.setState({ userGroups: userGroups });
	                };
	
	                // Handle the row select function
	
	                var onRowsSelected = function onRowsSelected(rows) {
	                    var newRows = [].concat(_toConsumableArray(_this6.state.userGroups.rows));
	                    var selectedRows = [];
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = true;
	                        selectedRows.push(r.row);
	                    });
	                    if (_this6.state.userGroups.selectedRows) selectedRows = selectedRows.concat(_this6.state.userGroups.selectedRows);
	                    var userGroups = _extends({}, _this6.state.userGroups, { rows: newRows, selectedRows: selectedRows });
	                    _this6.setState({ userGroups: userGroups });
	                };
	
	                var onRowsDeselected = function onRowsDeselected(rows) {
	                    var newRows = [].concat(_toConsumableArray(_this6.state.userGroups.rows));
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = false;
	                    });
	                    var selectedRows = [].concat(_toConsumableArray(_this6.state.userGroups.selectedRows));
	                    selectedRows = selectedRows.filter(function (obj) {
	                        return obj.isSelected == true;
	                    });
	                    var userGroups = _extends({}, _this6.state.userGroups, { rows: newRows, selectedRows: selectedRows });
	                    _this6.setState({ userGroups: userGroups });
	                };
	
	                var onRowClick = function onRowClick(rowIdx, row) {}
	                //  this.props.fetchUserDetail(row.user_id);
	
	
	                // Column difinition
	
	                ;var columns = [{
	                    key: 'name',
	                    name: 'group name',
	                    resizable: true,
	                    width: 220,
	                    sortable: true,
	                    filterable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 5 },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { maxWidth: '99%' }, id: 'GroupManagementDetail-dataGrid2' },
	                        _react2.default.createElement(_reactDataGrid2.default, {
	                            rowKey: 'id',
	                            onGridSort: handleGridSort,
	                            toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                            onAddFilter: handleFilterChange,
	                            columns: columns,
	                            rowGetter: rowGetter,
	                            rowsCount: getSize(),
	                            onRowClick: onRowClick,
	                            enableRowSelect: 'multi',
	                            rowSelection: {
	                                showCheckbox: true,
	                                enableShiftSelect: true,
	                                onRowsSelected: onRowsSelected,
	                                onRowsDeselected: onRowsDeselected,
	                                selectBy: {
	                                    isSelectedKey: 'isSelected'
	                                }
	                            }
	                        })
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderPermissions',
	        value: function renderPermissions() {
	            var _this7 = this;
	
	            if (this.props.permissionsIsLoading && !this.props.permissionsError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.permissionsError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.permissionsError)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this7.state.permissions);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var permissions = Object.assign({}, _this7.state.permissions, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this7.setState({ permissions: permissions });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this7.state.permissions.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var permissions = _extends({}, _this7.state.permissions, { filters: newFilters });
	                    _this7.setState({ permissions: permissions });
	                };
	
	                // Handle the row select function
	
	                var onRowsSelected = function onRowsSelected(rows) {
	                    var newRows = [].concat(_toConsumableArray(_this7.state.permissions.rows));
	                    var selectedRows = [];
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = true;
	                        selectedRows.push(r.row);
	                    });
	                    if (_this7.state.permissions.selectedRows) selectedRows = selectedRows.concat(_this7.state.permissions.selectedRows);
	                    var permissions = _extends({}, _this7.state.permissions, { rows: newRows, selectedRows: selectedRows });
	                    _this7.setState({ permissions: permissions });
	                };
	
	                var onRowsDeselected = function onRowsDeselected(rows) {
	                    var newRows = [].concat(_toConsumableArray(_this7.state.permissions.rows));
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = false;
	                    });
	                    var selectedRows = [].concat(_toConsumableArray(_this7.state.permissions.selectedRows));
	                    selectedRows = selectedRows.filter(function (obj) {
	                        return obj.isSelected == true;
	                    });
	                    var permissions = _extends({}, _this7.state.permissions, { rows: newRows, selectedRows: selectedRows });
	                    _this7.setState({ permissions: permissions });
	                };
	
	                var onRowClick = function onRowClick(rowIdx, row) {}
	                //  this.props.fetchUserDetail(row.user_id);
	
	
	                // Column difinition
	
	                ;var columns = [{
	                    key: 'name',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'permission_name' }),
	                    width: 220,
	                    resizable: true,
	                    sortable: true,
	                    filterable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 6 },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { maxWidth: '100%' }, id: 'GroupManagementDetail-dataGrid3' },
	                        _react2.default.createElement(_reactDataGrid2.default, {
	                            rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: this.moveToUserPermissions }),
	                            rowKey: 'id',
	                            onGridSort: handleGridSort,
	                            toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                            onAddFilter: handleFilterChange,
	                            columns: columns,
	                            rowHeight: 25,
	                            minHeight: 605,
	                            rowGetter: rowGetter,
	                            rowsCount: getSize(),
	                            onRowClick: onRowClick
	                            //   enableRowSelect='multi'
	                            //   rowSelection={{
	                            //     showCheckbox: true,
	                            //     enableShiftSelect: true,
	                            //     onRowsSelected: onRowsSelected,
	                            //     onRowsDeselected: onRowsDeselected,
	                            //     selectBy: {
	                            //      isSelectedKey: 'isSelected'
	                            //     }
	                            //  }}
	                        })
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderUserPermissions',
	        value: function renderUserPermissions() {
	            var _this8 = this;
	
	            if (this.props.permissionsIsLoading && !this.props.permissionsError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.permissionsError) return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'alert alert-danger' },
	                    JSON.stringify(this.props.permissionsError)
	                )
	            );else {
	                // Parameters of the react-data-grid
	
	                var getRows = function getRows() {
	                    return _reactDataGridAddons.Data.Selectors.getRows(_this8.state.userPermissions);
	                };
	
	                var getSize = function getSize() {
	                    return getRows().length;
	                };
	
	                var rowGetter = function rowGetter(rowIdx) {
	                    var rows = getRows();
	                    return rows[rowIdx];
	                };
	
	                // Handle the sortable function
	
	                var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	                    var userPermissions = Object.assign({}, _this8.state.userPermissions, { sortColumn: sortColumn, sortDirection: sortDirection });
	                    _this8.setState({ userPermissions: userPermissions });
	                };
	
	                var handleFilterChange = function handleFilterChange(filter) {
	                    var newFilters = Object.assign({}, _this8.state.userPermissions.filters);
	                    if (filter.filterTerm) {
	                        newFilters[filter.column.key] = filter;
	                    } else {
	                        delete newFilters[filter.column.key];
	                    }
	                    var userPermissions = _extends({}, _this8.state.userPermissions, { filters: newFilters });
	                    _this8.setState({ userPermissions: userPermissions });
	                };
	
	                // Handle the row select function
	
	                var onRowsSelected = function onRowsSelected(rows) {
	                    var newRows = [].concat(_toConsumableArray(_this8.state.userPermissions.rows));
	                    var selectedRows = [];
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = true;
	                        selectedRows.push(r.row);
	                    });
	                    if (_this8.state.userPermissions.selectedRows) selectedRows = selectedRows.concat(_this8.state.userPermissions.selectedRows);
	                    var userPermissions = _extends({}, _this8.state.userPermissions, { rows: newRows, selectedRows: selectedRows });
	                    _this8.setState({ userPermissions: userPermissions });
	                };
	
	                var onRowsDeselected = function onRowsDeselected(rows) {
	                    var newRows = [].concat(_toConsumableArray(_this8.state.userPermissions.rows));
	                    rows.map(function (r) {
	                        newRows[r.rowIdx].isSelected = false;
	                    });
	                    var selectedRows = [].concat(_toConsumableArray(_this8.state.userPermissions.selectedRows));
	                    selectedRows = selectedRows.filter(function (obj) {
	                        return obj.isSelected == true;
	                    });
	                    var userPermissions = _extends({}, _this8.state.userPermissions, { rows: newRows, selectedRows: selectedRows });
	                    _this8.setState({ userPermissions: userPermissions });
	                };
	
	                var onRowClick = function onRowClick(rowIdx, row) {}
	                //  this.props.fetchUserDetail(row.user_id);
	
	
	                // Column difinition
	
	                ;var columns = [{
	                    key: 'name',
	                    name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'granted_permission_name' }),
	                    resizable: true,
	                    width: 220,
	                    sortable: true,
	                    filterable: true
	                }];
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 6 },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { maxWidth: '100%' }, id: 'GroupManagementDetail-dataGrid4' },
	                        _react2.default.createElement(_reactDataGrid2.default, {
	                            rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: this.moveOffUserPermissions }),
	                            rowKey: 'id',
	                            onGridSort: handleGridSort,
	                            toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	                            onAddFilter: handleFilterChange,
	                            columns: columns,
	                            rowHeight: 25,
	                            minHeight: 605,
	                            rowGetter: rowGetter,
	                            rowsCount: getSize(),
	                            onRowClick: onRowClick
	                            //   enableRowSelect='multi'
	                            //   rowSelection={{
	                            //     showCheckbox: true,
	                            //     enableShiftSelect: true,
	                            //     onRowsSelected: onRowsSelected,
	                            //     onRowsDeselected: onRowsDeselected,
	                            //     selectBy: {
	                            //      isSelectedKey: 'isSelected'
	                            //     }
	                            //  }}
	                        })
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'moveToUserPermissions',
	        value: function moveToUserPermissions(permission) {
	            var userPermissionsRows = [].concat(_toConsumableArray(this.state.userPermissions.rows));
	            var newRows = [].concat(_toConsumableArray(this.state.permissions.rows));
	            var index = _lodash2.default.findIndex(newRows, { id: permission.id });
	            if (index > -1) newRows.splice(index, 1);
	            userPermissionsRows.push(permission);
	            var userPermissions = _extends({}, this.state.userPermissions, { rows: userPermissionsRows });
	            var permissions = _extends({}, this.state.permissions, { rows: newRows.sort(function (a, b) {
	                    return a.name.localeCompare(b.name);
	                }) });
	            this.setState({ userPermissions: userPermissions, permissions: permissions });
	        }
	    }, {
	        key: 'moveOffUserPermissions',
	        value: function moveOffUserPermissions(permission) {
	            var userPermissionsRows = [].concat(_toConsumableArray(this.state.userPermissions.rows));
	            var newRows = [].concat(_toConsumableArray(this.state.permissions.rows));
	            var index = _lodash2.default.findIndex(userPermissionsRows, { id: permission.id });
	            if (index > -1) userPermissionsRows.splice(index, 1);
	            newRows.push(permission);
	            var userPermissions = _extends({}, this.state.userPermissions, { rows: userPermissionsRows });
	            var permissions = _extends({}, this.state.permissions, { rows: newRows.sort(function (a, b) {
	                    return a.name.localeCompare(b.name);
	                }) });
	            this.setState({ userPermissions: userPermissions, permissions: permissions });
	        }
	    }, {
	        key: 'moveToUserGroups',
	        value: function moveToUserGroups() {
	            var userGroupsRows = [].concat(_toConsumableArray(this.state.userGroups.rows));
	            var newRows = [].concat(_toConsumableArray(this.state.groups.selectedRows));
	            newRows.map(function (row) {
	                row.isSelected = false;
	            });
	            var newUserGroupsRows = [];
	            newRows.map(function (row) {
	                var obj = Object.assign({}, row);
	                newUserGroupsRows.push(obj);
	            });
	            userGroupsRows = userGroupsRows.concat(newUserGroupsRows);
	            var userGroupsRowsUnique = [];
	
	            userGroupsRows.map(function (row) {
	                var index = _lodash2.default.findIndex(userGroupsRowsUnique, { 'id': row.id });
	                if (index == -1) userGroupsRowsUnique.push(row);
	            });
	            var userGroups = _extends({}, this.state.userGroups, { rows: userGroupsRowsUnique });
	            var groups = _extends({}, this.state.groups, { selectedRows: [] });
	            this.setState.apply(this, _toConsumableArray(this.state).concat([{ userGroups: userGroups, groups: groups }]));
	        }
	    }, {
	        key: 'moveOffUserGroups',
	        value: function moveOffUserGroups() {
	            var userGroupsRows = [].concat(_toConsumableArray(this.state.userGroups.rows));
	            userGroupsRows = userGroupsRows.filter(function (obj) {
	                return obj.isSelected == false || obj.isSelected == null;
	            });
	            var userGroups = _extends({}, this.state.userGroups, { rows: userGroupsRows, isSelected: [] });
	            this.setState.apply(this, _toConsumableArray(this.state).concat([{ userGroups: userGroups }]));
	        }
	    }, {
	        key: 'handleFormSubmit',
	        value: function handleFormSubmit(formProps) {
	            this.setState({ dirty: false });
	            if (this.props.currentGroup) {
	                if ((0, _permissions3.default)("change_group")) {
	                    this.props.editGroupDetail(this.props.currentGroup, formProps, this.state.userPermissions.rows);
	                } else alert("You have no permission!");
	            } else {
	                this.props.createGroupDetail(formProps, this.state.userPermissions.rows);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this9 = this;
	
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                submitting = _props.submitting,
	                pristine = _props.pristine;
	
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'form',
	                    { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	                    _react2.default.createElement(
	                        _reactBootstrap.Breadcrumb,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'admin' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'role_management' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Breadcrumb.Item,
	                            { active: 'true' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'user_detail' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            { type: 'submit', bsStyle: 'success' },
	                            _react2.default.createElement('em', { className: 'fa fa-save' }),
	                            ' ',
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            { bsStyle: 'danger', onClick: function onClick() {
	                                    _this9.context.router.push('/groupManagement');
	                                } },
	                            _react2.default.createElement('em', { className: 'fa fa-close' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Grid,
	                        { id: 'group-management-detail' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'marginBottomStyle' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Panel,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 6 },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 3 },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'role_name' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6, style: { float: "left" } },
	                                        _react2.default.createElement(_reduxForm.Field, { name: 'name', component: _inputField.InputField })
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Panel,
	                                { id: 'group-management-detail-permissions' },
	                                this.renderPermissions(),
	                                this.renderUserPermissions()
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return GroupManagementDetail;
	}(_react.Component);
	
	GroupManagementDetail.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = GroupManagementDetail;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/groupManagementDetail.jsx');
	
	    __REACT_HOT_LOADER__.register(GroupManagementDetail, 'GroupManagementDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/groupManagementDetail.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/groupManagementDetail.jsx');
	}();

	;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _businessUsersModal = __webpack_require__(169);
	
	var _businessUsersModal2 = _interopRequireDefault(_businessUsersModal);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _root_url = __webpack_require__(9);
	
	var _url = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tableHeight = window.innerHeight < 930 ? 650 : 650;
	
	var UserManagement = function (_Component) {
	  _inherits(UserManagement, _Component);
	
	  function UserManagement() {
	    _classCallCheck(this, UserManagement);
	
	    var _this = _possibleConstructorReturn(this, (UserManagement.__proto__ || Object.getPrototypeOf(UserManagement)).call(this));
	
	    _this.state = {
	      messages: {
	        rows: [],
	        selectedRows: null,
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      businessUsersModalOpen: false,
	      messageModalOpen: false,
	      message: '',
	      userId: '',
	      replyMessage: '',
	      replyFile: null,
	      isLoading: false,
	      error: ''
	    };
	    _this.handleChangeMessage = _this.handleChangeMessage.bind(_this);
	    _this.handleChangeFile = _this.handleChangeFile.bind(_this);
	    _this.setReplyModalVisibility = _this.setReplyModalVisibility.bind(_this);
	    return _this;
	  }
	
	  _createClass(UserManagement, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      this.getMessageListById();
	    }
	  }, {
	    key: 'getMessageListById',
	    value: function getMessageListById() {
	      var _this2 = this;
	
	      var id = this.context.router.params.id;
	
	      if (!id) {
	        return;
	      }
	      var data = new FormData();
	      data.append('pk', id);
	      _axios2.default.post(_url.USER_QUERY_NOTE_URL, data, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        if (response.status !== 200) {
	          return;
	        }
	        var messages = _extends({}, _this2.state.messages, { rows: JSON.parse(response.data) });
	        _this2.setState({ messages: messages, error: '', isLoading: false });
	      }).catch(function (error) {
	        _this2.setState({ error: error, isLoading: false });
	      });
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this3 = this;
	
	      if (this.state.isLoading && !this.state.error) return _react2.default.createElement(_spinner2.default, null);else if (this.state.error) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.state.error)
	          )
	        );
	      }
	
	      // Parameters of the react-data-grid
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.messages);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var messages = Object.assign({}, _this3.state.messages, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this3.setState({ messages: messages });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this3.state.messages.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var messages = _extends({}, _this3.state.messages, { filters: newFilters });
	        _this3.setState({ messages: messages });
	      };
	
	      // Handle the row select function
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = _this3.state.messages.rows;
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        var messages = _extends({}, _this3.state.messages, { rows: newRows });
	        _this3.setState({ messages: messages });
	      };
	
	      var FilePathFormatter = _react2.default.createClass({
	        displayName: 'FilePathFormatter',
	        render: function render() {
	          return this.props.value ? _react2.default.createElement(
	            'a',
	            { href: this.props.value, target: '_blank', style: { cursor: 'pointer' } },
	            this.props.value
	          ) : _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      var FromAdminFormatter = _react2.default.createClass({
	        displayName: 'FromAdminFormatter',
	        render: function render() {
	          return (
	            // from_admin(0代表用户，1代表系统)
	            String(this.props.value) === '0' ? _react2.default.createElement(
	              'span',
	              null,
	              'User'
	            ) : _react2.default.createElement(
	              'span',
	              null,
	              'System'
	            )
	          );
	        }
	      });
	
	      var DateFormatter = _react2.default.createClass({
	        displayName: 'DateFormatter',
	        render: function render() {
	          if (this.props.value) {
	            var date = new Date(this.props.value);
	            return _react2.default.createElement(
	              'span',
	              null,
	              date.toString().slice(4, 15)
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            { className: 'label label-danger' },
	            '-'
	          );
	        }
	      });
	
	      // Column difinition
	      var columns = [{
	        key: 'communicate_num',
	        name: 'Communicate Num',
	        width: 130,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'FilePath',
	        name: 'File Path',
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: FilePathFormatter
	      }, {
	        key: 'note',
	        name: 'Note',
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'from_admin',
	        name: 'Type',
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: FromAdminFormatter
	      }, {
	        key: 'create_time',
	        name: 'Create Time',
	        width: 95,
	        resizable: true,
	        sortable: true,
	        filterable: true,
	        formatter: DateFormatter
	      }];
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            'div',
	            { id: 'mobileUserMessagesManagement-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'user_id',
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              headerRowHeight: 50,
	              rowHeight: 25,
	              onAddFilter: handleFilterChange,
	              columns: columns,
	              width: 200,
	              minHeight: tableHeight,
	              rowGetter: rowGetter,
	              rowsCount: getSize()
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'total-users' },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_users' }),
	            ':\xA0',
	            _react2.default.createElement(
	              'span',
	              { className: 'font-color-orange' },
	              this.state.messages.rows.length
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'setReplyModalVisibility',
	    value: function setReplyModalVisibility() {
	      var messageModalOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      this.setState({ messageModalOpen: messageModalOpen });
	    }
	  }, {
	    key: 'clickNew',
	    value: function clickNew(e) {
	      var id = this.context.router.params.id;
	
	      e.preventDefault();
	      this.setReplyModalVisibility(true);
	      this.setState({ userId: id, replyMessage: '', replyFile: null });
	    }
	  }, {
	    key: 'handleChangeMessage',
	    value: function handleChangeMessage(e) {
	      this.setState({ replyMessage: e.target.value });
	    }
	  }, {
	    key: 'handleChangeFile',
	    value: function handleChangeFile(event) {
	      this.setState({ replyFile: event.target.files[0] });
	    }
	  }, {
	    key: 'handleOnSubmit',
	    value: function handleOnSubmit() {
	      var _this4 = this;
	
	      var _state = this.state,
	          replyMessage = _state.replyMessage,
	          replyFile = _state.replyFile,
	          userId = _state.userId;
	
	      var data = new FormData();
	      data.append('pk', userId);
	      data.append('note', replyMessage);
	      data.append('FILE', replyFile);
	
	      _axios2.default.post(_url.USER_PUT_NOTE_URL, data, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function () {
	        window.location.reload();
	        alert('Reply success!');
	        _this4.setState({
	          messageModalOpen: false,
	          replyMessage: '',
	          replyFile: null,
	          userId: ''
	        });
	      }, function (err) {
	        if (err.status === 500 || err.status === 404) {
	          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
	        }
	        alert(JSON.stringify(err.data));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return (
	        //---------------
	        // Begin HTML: Create New/Edit user_management
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Admin' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mobile_user_messages_management' })
	            ),
	            _react2.default.createElement(_reactBootstrap.ButtonToolbar, {
	              style: {
	                zIndex: 1,
	                position: 'absolute',
	                top: '10px',
	                right: '10px'
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'settings-user-management' },
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { className: 'position-relative table-collapse-fix' },
	              !this.state.isLoading && !this.state.error && _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                { className: 'table-buttons' },
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'success',
	                    className: 'marginLeftStyle',
	                    onClick: function onClick(event) {
	                      _this5.clickNew(event);
	                    }
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_message' })
	                )
	              ),
	              this.renderTable()
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: { height: '800px', width: '75%', top: '29%', left: '38%' },
	              isVisible: this.state.businessUsersModalOpen,
	              onCloseClicked: this.closeMessageModal,
	              title: 'Business Users'
	            },
	            _react2.default.createElement(_businessUsersModal2.default, null)
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: { height: '400px', width: '500px' },
	              isVisible: this.state.messageModalOpen,
	              onCloseClicked: this.setReplyModalVisibility,
	              title: 'Reply Message'
	            },
	            _react2.default.createElement(
	              'span',
	              null,
	              this.state.message
	            ),
	            _react2.default.createElement('textarea', {
	              rows: 5,
	              style: { width: '100%', border: '1px solid #000000' },
	              value: this.state.replyMessage,
	              onChange: this.handleChangeMessage
	            }),
	            _react2.default.createElement('input', {
	              style: { border: '1px solid #aaa' },
	              type: 'file',
	              name: 'file',
	              onChange: this.handleChangeFile
	            }),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'success',
	                onClick: function onClick() {
	                  _this5.handleOnSubmit();
	                },
	                disabled: this.state.replyMessage === ''
	              },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return UserManagement;
	}(_react.Component);
	
	UserManagement.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = UserManagement;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(tableHeight, 'tableHeight', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/mobileUserMessagesManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(UserManagement, 'UserManagement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/mobileUserMessagesManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/mobileUserMessagesManagement.jsx');
	}();

	;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _root_url = __webpack_require__(9);
	
	var _url = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tableHeight = window.innerHeight < 930 ? 650 : 650;
	
	var MobileUserProducts = function (_Component) {
	  _inherits(MobileUserProducts, _Component);
	
	  function MobileUserProducts() {
	    _classCallCheck(this, MobileUserProducts);
	
	    var _this = _possibleConstructorReturn(this, (MobileUserProducts.__proto__ || Object.getPrototypeOf(MobileUserProducts)).call(this));
	
	    _this.state = {
	      products: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      isLoading: false,
	      error: '',
	      selectedProduct: {},
	      editModalOpen: false
	    };
	    _this.setEditModalVisibility = _this.setEditModalVisibility.bind(_this);
	    return _this;
	  }
	
	  _createClass(MobileUserProducts, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var currentProduct = this.props.currentProduct;
	      // this.props.setValue('productForm', 'PackageSize', '2');
	      // this.props.setDefaultOfForm("PriceType", "weight", "productForm")
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      this.getProductsById();
	    }
	  }, {
	    key: 'getProductsById',
	    value: function getProductsById() {
	      var _this2 = this;
	
	      var id = this.context.router.params.id;
	
	      if (!id) {
	        return;
	      }
	      var data = new FormData();
	      data.append('pk', id);
	      _axios2.default.post(_url.USER_PRODUCTS_URL, data, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        if (response.status !== 200) {
	          return;
	        }
	        var products = _extends({}, _this2.state.products, { rows: response.data });
	        _this2.setState({ products: products, error: '', isLoading: false });
	      }).catch(function (error) {
	        _this2.setState({ error: error, isLoading: false });
	      });
	    }
	  }, {
	    key: 'setEditModalVisibility',
	    value: function setEditModalVisibility() {
	      var editModalOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      this.setState({ editModalOpen: editModalOpen });
	    }
	  }, {
	    key: 'editProdcut',
	    value: function editProdcut(e) {
	      e.preventDefault();
	      var selectedProduct = this.state.selectedProduct;
	
	      console.log('selectedProduct:  ', selectedProduct);
	      this.setEditModalVisibility(true);
	    }
	  }, {
	    key: 'handleOnSubmit',
	    value: function handleOnSubmit() {
	      console.log('handleOnSubmit');
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      console.log('handleChange: ', event);
	      // this.setState({ value: event.target.value });
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this3 = this;
	
	      if (this.state.isLoading && !this.state.error) return _react2.default.createElement(_spinner2.default, null);else if (this.state.error) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.state.error)
	          )
	        );
	      }
	
	      // Parameters of the react-data-grid
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.products);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var products = Object.assign({}, _this3.state.products, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this3.setState({ products: products });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this3.state.products.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var products = _extends({}, _this3.state.products, { filters: newFilters });
	        _this3.setState({ products: products });
	      };
	
	      // Handle the row select function
	      var onRowsSelected = function onRowsSelected(rows) {
	        // const newRows = this.state.products.rows;
	        // rows.map((r) => {
	        //   newRows[r.rowIdx].isSelected = true;
	        // });
	
	        var newRows = getRows();
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        var products = _extends({}, _this3.state.products, { rows: newRows });
	        _this3.setState({ products: products, selectedProduct: rows[0].row });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = getRows();
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        _this3.setState({ selectedProduct: {} });
	      };
	
	      // Column difinition
	      var columns = [{
	        key: 'Product_sku',
	        name: 'SKU',
	        width: 100,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'Product_name',
	        name: 'Name',
	        width: 150,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'Product_quantity',
	        name: 'Qty',
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'Alert_quantity',
	        name: 'Alert Qty',
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'History_quantity',
	        name: 'History Qty',
	        width: 80,
	        resizable: true,
	        sortable: true,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            'div',
	            { id: 'mobileUserMessagesManagement-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'Product_id',
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              headerRowHeight: 50,
	              rowHeight: 25,
	              onAddFilter: handleFilterChange,
	              columns: columns,
	              width: 200,
	              minHeight: tableHeight,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              enableRowSelect: 'single',
	              rowSelection: {
	                showCheckbox: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: { isSelectedKey: 'isSelected' }
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'total-users' },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_users' }),
	            ':\xA0',
	            _react2.default.createElement(
	              'span',
	              { className: 'font-color-orange' },
	              this.state.products.rows.length
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var selectedProduct = this.state.selectedProduct;
	
	      return (
	        //---------------
	        // Begin HTML: Create New/Edit user_management
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Admin' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mobile_user_products' })
	            ),
	            _react2.default.createElement(_reactBootstrap.ButtonToolbar, {
	              style: {
	                zIndex: 1,
	                position: 'absolute',
	                top: '10px',
	                right: '10px'
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'settings-user-management' },
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { className: 'position-relative table-collapse-fix' },
	              !this.state.isLoading && !this.state.error && _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                { className: 'table-buttons' },
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'success',
	                    className: 'marginLeftStyle',
	                    onClick: function onClick(event) {
	                      _this4.editProdcut(event);
	                    },
	                    disabled: !this.state.selectedProduct.Product_id
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_product' })
	                )
	              ),
	              this.renderTable()
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: { height: '450px', width: '500px' },
	              isVisible: this.state.editModalOpen,
	              onCloseClicked: this.setEditModalVisibility,
	              title: 'Edit Product'
	            },
	            _react2.default.createElement(
	              'form',
	              { className: 'form-horizontal', onSubmit: this.handleSubmit },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'product-img-view' },
	                    _react2.default.createElement('img', { src: selectedProduct.Product_image, alt: 'Upload image', className: 'img-thumbnail', style: {
	                        height: '100px', width: '100px' }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-2' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'sku' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-8' },
	                        _react2.default.createElement('input', { type: 'text', value: selectedProduct.Product_sku, onChange: this.handleChange, className: 'form-control' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-2' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-8' },
	                        _react2.default.createElement('input', { type: 'text', value: selectedProduct.Product_name, onChange: this.handleChange, className: 'form-control' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-2' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'quantity' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-8' },
	                        _react2.default.createElement('input', { type: 'text', value: selectedProduct.Product_quantity, onChange: this.handleChange, className: 'form-control' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-2' },
	                        'Alert Qty'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-8' },
	                        _react2.default.createElement('input', { type: 'text', value: selectedProduct.Alert_quantity, onChange: this.handleChange, className: 'form-control' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-xs-2' },
	                        'History Qty'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-8' },
	                        _react2.default.createElement('input', { type: 'text', value: selectedProduct.History_quantity, onChange: this.handleChange, className: 'form-control' })
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'success',
	                onClick: function onClick() {
	                  _this4.handleOnSubmit();
	                }
	              },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MobileUserProducts;
	}(_react.Component);
	
	MobileUserProducts.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = MobileUserProducts;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(tableHeight, 'tableHeight', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/mobileUserProducts.jsx');
	
	  __REACT_HOT_LOADER__.register(MobileUserProducts, 'MobileUserProducts', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/mobileUserProducts.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/mobileUserProducts.jsx');
	}();

	;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cloneDeep = __webpack_require__(124);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _findIndex = __webpack_require__(125);
	
	var _findIndex2 = _interopRequireDefault(_findIndex);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  createDialogStyle: {
	    width: '500px',
	    height: '300px',
	    marginLeft: '-15%'
	  }
	};
	
	var contextTypes = {
	  router: _propTypes2.default.object
	};
	
	var propTypes = {
	  multiTaxesEdited: _propTypes2.default.bool,
	  multiTaxesIsEditing: _propTypes2.default.bool,
	  taxRatesIsLoading: _propTypes2.default.bool,
	  taxRatesError: _propTypes2.default.string,
	  taxIsDeleting: _propTypes2.default.bool,
	  taxDeleted: _propTypes2.default.bool,
	  taxDeleteError: _propTypes2.default.string,
	  taxRates: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  fetchTaxRates: _propTypes2.default.func.isRequired,
	  editMultiTaxes: _propTypes2.default.func.isRequired,
	  deleteTax: _propTypes2.default.func.isRequired
	};
	
	var defaultProps = {
	  multiTaxesEdited: false,
	  multiTaxesIsEditing: false,
	  taxRatesIsLoading: false,
	  taxIsDeleting: false,
	  taxDeleted: false,
	  taxDeleteError: '',
	  taxRatesError: '',
	  taxRates: []
	};
	
	var TaxManagement = function (_Component) {
	  _inherits(TaxManagement, _Component);
	
	  function TaxManagement() {
	    _classCallCheck(this, TaxManagement);
	
	    var _this = _possibleConstructorReturn(this, (TaxManagement.__proto__ || Object.getPrototypeOf(TaxManagement)).call(this));
	
	    _this.clickNew = function () {
	      _this.handleClearFilters();
	      var rows = (0, _cloneDeep2.default)(_this.state.taxValues.rows);
	      var index = rows.length;
	      var newRow = {
	        Name: null,
	        Rate: null,
	        State: null,
	        Zipcode: null,
	        City: null,
	        County: null,
	        Idx: index
	      };
	      rows.push(newRow);
	      var editedRows = (0, _cloneDeep2.default)(_this.state.taxValues.editedRows);
	      editedRows.push(newRow);
	      var taxValues = _extends({}, _this.state.taxValues, {
	        rows: rows,
	        editedRows: editedRows
	      });
	      _this.setState({ taxValues: taxValues });
	    };
	
	    _this.updateRows = function () {
	      _this.props.editMultiTaxes(_this.state.taxValues.editedRows);
	    };
	
	    _this.deleteTax = function () {
	      var taxAreaId = _this.state.taxValues.selectedRows[0].TaxArea_id;
	      if (taxAreaId) {
	        _this.props.deleteTax(taxAreaId).then(function () {
	          _this.props.fetchTaxRates();
	        });
	      } else {
	        var rows = (0, _cloneDeep2.default)(_this.state.taxValues.rows);
	        var editedRows = (0, _cloneDeep2.default)(_this.state.taxValues.editedRows);
	        var index = (0, _findIndex2.default)(rows, { Idx: _this.state.taxValues.selectedRows[0].Idx });
	        rows.splice(index, 1);
	        index = (0, _findIndex2.default)(editedRows, { Idx: _this.state.taxValues.selectedRows[0].Idx });
	        editedRows.splice(index, 1);
	        var taxValues = _extends({}, _this.state.taxValues, {
	          rows: rows,
	          editedRows: editedRows,
	          selectedRows: []
	        });
	        _this.setState({
	          taxValues: taxValues,
	          showConfirmationModal: false
	        });
	      }
	    };
	
	    _this.handleClearFilters = function () {
	      var taxValues = _extends({}, _this.state.taxValues, { filters: {} });
	      _this.setState({ taxValues: taxValues });
	    };
	
	    _this.renderTable = function () {
	      if (_this.props.taxRatesIsLoading && !_this.props.taxRatesError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (_this.props.taxRatesError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(_this.props.taxRatesError)
	          )
	        );
	      }
	
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this.state.taxValues);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var taxValues = Object.assign({}, _this.state.taxValues, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this.setState({ taxValues: taxValues });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this.state.taxValues.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var taxValues = _extends({}, _this.state.taxValues, { filters: newFilters });
	        _this.setState({ taxValues: taxValues });
	      };
	
	      var handleRowUpdated = function handleRowUpdated(e) {
	        // merge updated row with current row and rerender by setting state
	        _this.setState({ sortColumn: null, sortDirection: null });
	        var rows = getRows();
	        var editedRows = _this.state.taxValues.editedRows.slice(0);
	        Object.assign(rows[e.rowIdx], e.updated);
	        // if the element is already edited, remove the old one.
	        editedRows.forEach(function (element, index) {
	          if (element.Idx === rows[e.rowIdx].Idx) {
	            editedRows.splice(index, 1);
	          }
	        });
	        // push the row into the editedRows array
	        editedRows.push(rows[e.rowIdx]);
	        var taxValues = _extends({}, _this.state.taxValues, {
	          rows: rows,
	          editedRows: editedRows
	        });
	        _this.setState({ taxValues: taxValues });
	      };
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = getRows();
	        newRows.map(function (r) {
	          r.isSelected = false;
	        });
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        var taxValues = _extends({}, _this.state.taxValues, { rows: newRows, selectedRows: [rows[0].row] });
	        _this.setState({ taxValues: taxValues });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = getRows();
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        var taxValues = _extends({}, _this.state.taxValues, { rows: newRows, selectedRows: [] });
	        _this.setState({ taxValues: taxValues });
	      };
	
	      var columns = [{
	        key: 'Name',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	        resizable: true,
	        editable: true,
	        width: 90,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'Rate',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'rate' }),
	        resizable: true,
	        editable: true,
	        width: 90,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'State',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'state' }),
	        resizable: true,
	        editable: true,
	        width: 90,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'Zipcode',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zipcode' }),
	        resizable: true,
	        editable: true,
	        width: 110,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'City',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city' }),
	        resizable: true,
	        editable: true,
	        width: 110,
	        sortable: true,
	        filterable: true
	      }, {
	        key: 'County',
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'county' }),
	        resizable: true,
	        editable: true,
	        width: 110,
	        sortable: true,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '100%' }, id: 'TaxManagement-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'TaxArea_id',
	              enableCellSelect: true,
	              onGridSort: handleGridSort,
	              onClearFilters: _this.handleClearFilters,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              onRowUpdated: handleRowUpdated,
	              rowHeight: 25,
	              minHeight: 675,
	              columns: columns,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              enableRowSelect: 'single',
	              rowSelection: {
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                showCheckbox: true,
	                selectBy: {
	                  isSelectedKey: 'isSelected'
	                }
	              }
	            })
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      taxValues: {
	        rows: [],
	        selectedRows: [],
	        editedRows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null,
	        showConfirmationModal: false
	      }
	    };
	    _this.closeConfirmationModal = _this.closeConfirmationModal.bind(_this);
	    _this.openConfirmationModal = _this.openConfirmationModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(TaxManagement, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      if (this.props.taxRates) {
	        var taxRates = this.props.taxRates;
	
	        taxRates.map(function (taxRate, index) {
	          taxRate.Idx = index;
	        });
	        var taxValues = _extends({}, this.state.taxValues, {
	          rows: taxRates,
	          filters: {},
	          sortColumn: null,
	          sortDirection: null
	        });
	        this.setState({ taxValues: taxValues });
	      }
	      this.props.fetchTaxRates();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.taxRates && nextProps.taxRates !== this.props.taxRates) {
	        var taxRates = nextProps.taxRates;
	
	        taxRates.map(function (taxRate, index) {
	          taxRate.Idx = index;
	        });
	        var taxValues = _extends({}, this.state.taxValues, {
	          rows: taxRates,
	          editedRows: [],
	          filters: {},
	          sortColumn: null,
	          sortDirection: null
	        });
	        this.setState({ taxValues: taxValues });
	      }
	      if (nextProps.multiTaxesEdited && nextProps.multiTaxesEdited !== this.props.multiTaxesEdited) {
	        this.props.fetchTaxRates();
	      }
	    }
	  }, {
	    key: 'openConfirmationModal',
	    value: function openConfirmationModal() {
	      this.setState({
	        showConfirmationModal: true
	      });
	    }
	  }, {
	    key: 'closeConfirmationModal',
	    value: function closeConfirmationModal() {
	      this.setState({
	        showConfirmationModal: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'admin_tools' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tax_management' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Grid,
	          { id: 'tax-management' },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { id: 'tax-management-table' },
	              _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                { className: 'tax-management-table-buttons' },
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'primary',
	                    className: 'buttonStyle',
	                    onClick: function onClick(event) {
	                      return _this2.clickNew(event);
	                    },
	                    disabled: !(0, _permissions2.default)('add_tax_area')
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'success',
	                    className: 'buttonStyle',
	                    onClick: function onClick(event) {
	                      return _this2.updateRows(event);
	                    },
	                    disabled: this.state.taxValues.editedRows.length === 0 || !(0, _permissions2.default)('change_tax_area')
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-save marginRightStyle' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'danger',
	                    className: 'buttonStyle',
	                    onClick: this.openConfirmationModal,
	                    disabled: this.state.taxValues.selectedRows.length === 0 || !(0, _permissions2.default)('delete_tax_area')
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-trash marginRightStyle' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete' })
	                ),
	                _react2.default.createElement(
	                  _reactSkylight.SkyLightStateless,
	                  {
	                    dialogStyles: styles.createDialogStyle,
	                    isVisible: this.state.showConfirmationModal,
	                    onCloseClicked: this.closeConfirmationModal,
	                    title: 'Delete Tax'
	                  },
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'centerStyle', style: { marginTop: '20px' } },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'msg_confirm_delete' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'centerStyle', style: { marginTop: '80px' } },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'primary',
	                        onClick: function onClick(event) {
	                          return _this2.deleteTax(event);
	                        },
	                        style: { float: 'none' }
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-check' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Confirm' })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { id: 'edit-information' },
	                this.props.multiTaxesIsEditing && !this.props.multiTaxesEdited && _react2.default.createElement(
	                  'div',
	                  { className: 'alert alert-info groups-saving-info' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saving' })
	                ),
	                !this.props.multiTaxesIsEditing && this.props.multiTaxesEdited && _react2.default.createElement(
	                  'div',
	                  { className: 'alert alert-success groups-saving-info' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'saved' })
	                ),
	                this.props.taxIsDeleting && !this.props.taxDeleted && !this.props.taxDeleteError && _react2.default.createElement(
	                  'div',
	                  { className: 'alert alert-info groups-saving-info' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deleting' })
	                ),
	                !this.props.taxIsDeleting && this.props.taxDeleted && !this.props.taxDeleteError && _react2.default.createElement(
	                  'div',
	                  { className: 'alert alert-success groups-saving-info' },
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'deleted' })
	                ),
	                !this.props.taxIsDeleting && !this.props.taxDeleted && this.props.taxDeleteError && _react2.default.createElement(
	                  'div',
	                  { className: 'alert alert-danger groups-saving-info' },
	                  this.props.taxDeleteError
	                )
	              ),
	              this.renderTable()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TaxManagement;
	}(_react.Component);
	
	TaxManagement.contextTypes = contextTypes;
	TaxManagement.propTypes = propTypes;
	TaxManagement.defaultProps = defaultProps;
	
	var _default = TaxManagement;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/taxManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(contextTypes, 'contextTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/taxManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(propTypes, 'propTypes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/taxManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(defaultProps, 'defaultProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/taxManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(TaxManagement, 'TaxManagement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/taxManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/taxManagement.jsx');
	}();

	;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactCsv = __webpack_require__(200);
	
	var _moment = __webpack_require__(26);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _businessUsersModal = __webpack_require__(169);
	
	var _businessUsersModal2 = _interopRequireDefault(_businessUsersModal);
	
	var _reactPaginate = __webpack_require__(104);
	
	var _reactPaginate2 = _interopRequireDefault(_reactPaginate);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _mobileUserTable = __webpack_require__(686);
	
	var _mobileUserTable2 = _interopRequireDefault(_mobileUserTable);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import ProvidersModal from './providersModal';
	
	
	var isAFG = _root_url.ROOT_API_URL === 'https://afgstage-scm.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://afg-scm.truckxi.com/api/';
	var isHF = _root_url.ROOT_API_URL === 'https://hfstage-erp.truckxi.com/api/' || _root_url.ROOT_API_URL === 'https://hf-erp.truckxi.com/api/';
	var isAPO = _root_url.ROOT_API_URL === 'https://admin.apoodr.com/api/' || _root_url.ROOT_URL === 'https://admin.apoodr.com/api/';
	
	var tableHeight = window.innerHeight < 930 ? 650 : 650;
	
	var isHMM = _root_url.ROOT_API_URL === "https://hmm-scm.truckxi.com/api/" || _root_url.ROOT_URL === "https://hmm-scm.truckxi.com/api/";
	
	var UserManagement = function (_Component) {
	  _inherits(UserManagement, _Component);
	
	  function UserManagement() {
	    _classCallCheck(this, UserManagement);
	
	    var _this = _possibleConstructorReturn(this, (UserManagement.__proto__ || Object.getPrototypeOf(UserManagement)).call(this));
	
	    _this.refetchMobileUsers = function () {
	      return _this.props.fetchMobileUsers(_this.state.currentPage, _this.state.limit, _this.state.searchCustomerNo, _this.state.searchFirstName, _this.state.searchLastName, _this.state.searchEmail, _this.state.searchPhone, _this.state.active);
	    };
	
	    _this.closeBusinessUserModal = function () {
	      return _this.setState({ businessUsersModalOpen: false });
	    };
	
	    _this.openBusinessUserModal = function () {
	      return _this.setState({ businessUsersModalOpen: true });
	    };
	
	    _this.handleCustomerNoChange = function (event) {
	      _this.state.searchCustomerNo = event.target.value;
	      _this.handleTextChange();
	    };
	
	    _this.handleFirstNameChange = function (event) {
	      _this.state.searchFirstName = event.target.value;
	      _this.handleTextChange();
	    };
	
	    _this.handleLastNameChange = function (event) {
	      _this.state.searchLastName = event.target.value;
	      _this.handleTextChange();
	    };
	
	    _this.handleEmailChange = function (event) {
	      _this.state.searchEmail = event.target.value;
	      _this.handleTextChange();
	    };
	
	    _this.handlePhoneChange = function (event) {
	      _this.state.searchPhone = event.target.value;
	      _this.handleTextChange();
	    };
	
	    _this.handleOnSubmit = function (event) {
	      event.preventDefault();
	    };
	
	    _this.handleTextChange = function () {
	      _this.state.currentPage = 0;
	      _this.props.fetchMobileUsers(_this.state.currentPage, _this.state.limit, _this.state.searchCustomerNo, _this.state.searchFirstName, _this.state.searchLastName, _this.state.searchEmail, _this.state.searchPhone, _this.state.active);
	    };
	
	    _this.handleLimitChange = function (el) {
	      _this.state.currentPage = 0;
	      _this.state.limit = el.value;
	      _this.state.limitDisplay = el.label;
	      _this.props.fetchMobileUsers(_this.state.currentPage, _this.state.limit, _this.state.searchCustomerNo, _this.state.searchFirstName, _this.state.searchLastName, _this.state.searchEmail, _this.state.searchPhone, _this.state.active);
	      // this.props.fetchMobileUsers(this.state.currentPage, this.state.limit, this.state.searchFilter);
	    };
	
	    _this.handleActiveChange = function (el) {
	      _this.state.currentPage = 0;
	      _this.state.active = el.value;
	      _this.state.activeDisplay = el.label;
	      _this.props.fetchMobileUsers(_this.state.currentPage, _this.state.limit, _this.state.searchCustomerNo, _this.state.searchFirstName, _this.state.searchLastName, _this.state.searchEmail, _this.state.searchPhone, _this.state.active);
	    };
	
	    _this.handleShowPriceChange = function () {
	      _this.state.currentPage = 0;
	      _this.props.fetchMobileUsers(_this.state.currentPage, _this.state.limit, _this.state.searchCustomerNo, _this.state.searchFirstName, _this.state.searchLastName, _this.state.searchEmail, _this.state.searchPhone, _this.state.active);
	    };
	
	    _this.state = {
	      currentPage: 0,
	      limit: 25,
	      limitDisplay: '25',
	      active: '',
	      activeDisplay: 'All',
	      searchCustomerNo: '',
	      searchFirstName: '',
	      searchLastName: '',
	      searchEmail: '',
	      searchPhone: '',
	      users: {
	        rows: [],
	        selectedRows: null,
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      mobileUsers: [],
	      rowClicked: false,
	      username: {
	        rows: [],
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      businessUsersModalOpen: false,
	      providersModalopen: false
	    };
	    return _this;
	  }
	
	  _createClass(UserManagement, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      document.title = _root_url.companyCodeTitle;
	      setTimeout(function () {
	        _this2.props.fetchBaseUsers();
	      }, 1000);
	      // this.props.fetchBaseUsers();
	      this.props.fetchMobileUsers(this.state.currentPage, this.state.limit, this.state.searchCustomerNo, this.state.searchFirstName, this.state.searchLastName, this.state.searchEmail, this.state.searchPhone, this.state.active);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.users && nextProps.users != this.props.users) {
	        var newRows = [].concat(_toConsumableArray(nextProps.users));
	        var users = _extends({}, this.state.users, { rows: newRows });
	        this.setState({ users: users });
	      }
	      if (nextProps.mobileUsers !== this.props.mobileUsers) {
	        this.setState({ mobileUsers: nextProps.mobileUsers });
	      }
	      if (nextProps.username !== this.props.username) {
	        // As of now, there should only be one row, so no need to map/loop. 
	        var rows = [];
	        var row = {};
	        row.username = nextProps.username;
	        rows.push(row);
	        this.setState(function (prevState) {
	          return {
	            username: _extends({}, prevState, {
	              rows: rows
	            })
	          };
	        });
	      }
	    }
	  }, {
	    key: 'clickNew',
	    value: function clickNew(e) {
	      e.preventDefault();
	      this.props.resetCurrentUser();
	      this.context.router.push('/userManagement/new');
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this3 = this;
	
	      if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.error)
	        )
	      );
	
	      // Parameters of the react-data-grid
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this3.state.users);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      // Handle the sortable function
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var users = Object.assign({}, _this3.state.users, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this3.setState({ users: users });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this3.state.users.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var users = _extends({}, _this3.state.users, { filters: newFilters });
	        _this3.setState({ users: users });
	      };
	
	      // Handle the row select function
	
	      var onRowsSelected = function onRowsSelected(rows) {
	        var newRows = _this3.state.users.rows;
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = true;
	        });
	        var users = _extends({}, _this3.state.users, { rows: newRows });
	        _this3.setState({ users: users });
	      };
	
	      var onRowsDeselected = function onRowsDeselected(rows) {
	        var newRows = _this3.state.users.rows;
	        rows.map(function (r) {
	          newRows[r.rowIdx].isSelected = false;
	        });
	        // var rowIndexes = rows.map(r => r.rowIdx);
	        var users = _extends({}, _this3.state.users, { rows: newRows });
	        _this3.setState({ users: users });
	      };
	
	      var onRowClick = function onRowClick(rowIdx, row) {
	        if (rowIdx != -1 && !_this3.state.rowClicked && (0, _permissions2.default)('change_baseuser')) {
	          _this3.setState({ rowClicked: true }, function () {
	            _this3.props.resetCurrentUser();
	            _this3.props.selectCurrentUser(row.BaseUser_id);
	            _this3.context.router.push('/userManagement/' + row.BaseUser_id);
	          });
	        }
	      };
	
	      // Column difinition
	
	      var columns = [{
	        key: "username",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'user_name' }),
	        resizable: true,
	        width: 220,
	        sortable: true,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            'div',
	            { id: 'UserManagement-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'user_id',
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              rowHeight: 25,
	              onAddFilter: handleFilterChange,
	              columns: columns,
	              width: 200,
	              minHeight: tableHeight,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              onRowClick: onRowClick,
	              onRowSelect: onRowsSelected,
	              enableRowSelect: 'single'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'total-users' },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_users' }),
	            ':\xA0',
	            _react2.default.createElement(
	              'span',
	              { className: 'font-color-orange' },
	              this.state.users.rows.length
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderMobileTable',
	    value: function renderMobileTable() {
	      var _this4 = this;
	
	      if (this.props.mobileUsersIsLoading && !this.props.mobileUsersError) {
	        return _react2.default.createElement(_spinner2.default, null);
	      }
	      var mobileUsers = this.state.mobileUsers;
	
	
	      var handleOnPageChange = function handleOnPageChange(data) {
	        _this4.state.currentPage = data.selected;
	        _this4.props.fetchMobileUsers(_this4.state.currentPage, _this4.state.limit, _this4.state.searchCustomerNo, _this4.state.searchFirstName, _this4.state.searchLastName, _this4.state.searchEmail, _this4.state.searchPhone, _this4.state.active);
	      };
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12 },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_mobileUserTable2.default, {
	                checkPassword: this.props.checkPassword,
	                checkPasswordSuccess: this.props.checkPasswordSuccess,
	                checkPasswordFailure: this.props.checkPasswordFailure,
	                clearCheckPassword: this.props.clearCheckPassword,
	                rows: mobileUsers,
	                tableHeight: tableHeight,
	                mobileUserId: this.props.mobileUserId,
	                searchCustomerNo: this.state.searchCustomerNo,
	                searchFirstName: this.state.searchFirstName,
	                searchLastName: this.state.searchLastName,
	                searchEmail: this.state.searchEmail,
	                currentPage: this.state.currentPage,
	                limit: this.state.limit,
	                handleShowPriceChange: this.handleShowPriceChange,
	                scmUsers: this.state.users.rows || [],
	                refetchMobileUsers: this.refetchMobileUsers
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'react-pagination' },
	          _react2.default.createElement(_reactPaginate2.default, {
	            previousLabel: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'prev_page' }),
	            nextLabel: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'next_page' }),
	            containerClassName: 'pagination',
	            activeClassName: 'active',
	            marginPagesDisplayed: 2,
	            pageRangeDisplayed: 5,
	            pageCount: this.props.mobileUsersTotalPages,
	            onPageChange: handleOnPageChange,
	            forcePage: this.state.currentPage
	          })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'total-users', style: { paddingTop: '0px' } },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'total_users' }),
	            ':\xA0',
	            _react2.default.createElement(
	              'span',
	              { className: 'font-color-orange' },
	              this.props.mobileUsersTotalCount
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderUsernameTable',
	    value: function renderUsernameTable() {
	      var _this5 = this;
	
	      if (this.props.isLoading && !this.props.error) return _react2.default.createElement(_spinner2.default, null);else if (this.props.error) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.error)
	        )
	      );
	
	      // Parameters of the react-data-grid
	      var getRows = function getRows() {
	        return _reactDataGridAddons.Data.Selectors.getRows(_this5.state.username);
	      };
	
	      var getSize = function getSize() {
	        return getRows().length;
	      };
	
	      var rowGetter = function rowGetter(rowIdx) {
	        var rows = getRows();
	        return rows[rowIdx];
	      };
	
	      var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	        var username = Object.assign({}, _this5.state.username, { sortColumn: sortColumn, sortDirection: sortDirection });
	        _this5.setState({ username: username });
	      };
	
	      var handleFilterChange = function handleFilterChange(filter) {
	        var newFilters = Object.assign({}, _this5.state.username.filters);
	        if (filter.filterTerm) {
	          newFilters[filter.column.key] = filter;
	        } else {
	          delete newFilters[filter.column.key];
	        }
	        var username = _extends({}, _this5.state.username, { filters: newFilters });
	        _this5.setState({ username: username });
	      };
	
	      var columns = [{
	        key: "username",
	        name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mobile_username' }),
	        resizable: true,
	        width: 220,
	        sortable: true,
	        filterable: true
	      }];
	
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            'div',
	            { id: 'UserManagement-dataGrid2' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'username',
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              rowHeight: 25,
	              columns: columns,
	              onGridSort: handleGridSort,
	              onAddFilter: handleFilterChange,
	              width: 200,
	              minHeight: tableHeight,
	              rowGetter: rowGetter,
	              rowsCount: getSize()
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'formatMobileUserInfoForExport',
	    value: function formatMobileUserInfoForExport() {
	      var formattedInfo = [];
	      var headersRow = ['Customer Number', 'First Name', 'Last Name', 'Email', 'IsActive'];
	      formattedInfo.push(headersRow);
	
	      this.state.mobileUsers.forEach(function (row) {
	        formattedInfo.push([row.CustomerNum, row.FirstName, row.LastName, row.email, row.IsActive]);
	      });
	      return formattedInfo;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var limitSelection = [{
	        label: '25',
	        value: 25,
	        name: 'limit'
	      }, {
	        label: '50',
	        value: 50,
	        name: 'limit'
	      }, {
	        label: '100',
	        value: 100,
	        name: 'limit'
	      }, {
	        label: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'all' }),
	        value: null,
	        name: 'limit'
	      }];
	
	      var isActiveSelection = [{
	        label: 'All',
	        value: ''
	      }, {
	        label: 'Active',
	        value: '1'
	      }, {
	        label: 'Inactive',
	        value: '0'
	      }];
	
	      var mobileCustomerOrderExportUrl = _root_url.ROOT_URL + 'v1/customer/export/orders-per-customer?Bearer=' + localStorage.getItem('token');
	      return (
	        //---------------
	        // Begin HTML: Create New/Edit user_management
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Admin' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'user_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.ButtonToolbar,
	              {
	                style: {
	                  zIndex: 1,
	                  position: 'absolute',
	                  top: '10px',
	                  right: '10px'
	                }
	              },
	              (isAFG || isAPO || isHMM || isHF || _root_url.isElegant) && _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                  bsStyle: 'success',
	                  className: 'marginLeftStyle',
	                  onClick: function onClick() {
	                    _this6.openBusinessUserModal();
	                  }
	                },
	                _react2.default.createElement('em', { className: 'fa fa-user marginRightStyle' }),
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: "business_user" })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'settings-user-management' },
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    'h1',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'scm_user_info' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'position-relative table-collapse-fix' },
	                  _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    { className: 'table-buttons' },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'success',
	                        className: 'marginLeftStyle',
	                        onClick: function onClick(event) {
	                          _this6.clickNew(event);
	                        },
	                        disabled: !(0, _permissions2.default)('add_baseuser')
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-plus marginRightStyle' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_user' })
	                    )
	                  ),
	                  this.renderTable()
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 9 },
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mobile_user_info' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'position-relative table-collapse-fix panel-body-fix' },
	                  _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    { className: 'table-buttons' },
	                    _react2.default.createElement(
	                      _reactCsv.CSVLink,
	                      {
	                        data: this.formatMobileUserInfoForExport(),
	                        filename: 'mobile-user-' + (0, _moment2.default)().format('YYYYMMDD') + '.csv',
	                        className: 'btn btn-success export-to-excel',
	                        target: '_blank'
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-download' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: "mobile_users" })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'success',
	                        className: 'export-to-excel',
	                        href: mobileCustomerOrderExportUrl,
	                        onClick: function onClick() {
	                          return alert(_reactReduxI18n.I18n.t('msg_export_order_stats'));
	                        }
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-download' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'order_stats' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-group', style: { marginBottom: '0px', marginTop: '30px', position: 'absolute', zIndex: 2 }, id: 'search-product-by' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: this.handleOnSubmit },
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          null,
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'col-sm-2' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'customer_no' })
	                          ),
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'col-sm-2' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'first_name' })
	                          ),
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'col-sm-2' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_name' })
	                          ),
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'col-sm-2' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' })
	                          ),
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'col-sm-1' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	                          ),
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'col-sm-1', style: { paddingRight: '0px' } },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'active' })
	                          ),
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'col-sm-2' },
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'limit' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { className: 'col-sm-2' },
	                          _react2.default.createElement(_reactBootstrap.Input, { type: 'text', onChange: this.handleCustomerNoChange })
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { className: 'col-sm-2' },
	                          _react2.default.createElement(_reactBootstrap.Input, { type: 'text', onChange: this.handleFirstNameChange })
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { className: 'col-sm-2' },
	                          _react2.default.createElement(_reactBootstrap.Input, { type: 'text', onChange: this.handleLastNameChange })
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { className: 'col-sm-2' },
	                          _react2.default.createElement(_reactBootstrap.Input, { type: 'text', onChange: this.handleEmailChange })
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { className: 'col-sm-1' },
	                          _react2.default.createElement(_reactBootstrap.Input, { type: 'text', onChange: this.handlePhoneChange })
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { className: 'col-sm-1', style: { paddingRight: '0px' } },
	                          _react2.default.createElement(
	                            _reactBootstrap.Dropdown,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Dropdown.Toggle,
	                              { style: { width: '60px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' } },
	                              this.state.activeDisplay
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Dropdown.Menu,
	                              { className: 'super-colors' },
	                              isActiveSelection.map(function (el) {
	                                return _react2.default.createElement(
	                                  _reactBootstrap.MenuItem,
	                                  { onClick: function onClick() {
	                                      return _this6.handleActiveChange(el);
	                                    } },
	                                  el.label
	                                );
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Col,
	                          { className: 'col-sm-2' },
	                          _react2.default.createElement(
	                            _reactBootstrap.Dropdown,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Dropdown.Toggle,
	                              { style: { width: '60px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' } },
	                              this.state.limitDisplay
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Dropdown.Menu,
	                              { className: 'super-colors' },
	                              limitSelection.map(function (el) {
	                                return _react2.default.createElement(
	                                  _reactBootstrap.MenuItem,
	                                  { onClick: function onClick() {
	                                      return _this6.handleLimitChange(el);
	                                    } },
	                                  el.label
	                                );
	                              })
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  this.renderMobileTable()
	                )
	              ),
	              this.props.username && _react2.default.createElement(
	                _reactBootstrap.Col,
	                { xs: 3 },
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mobile_username' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'position-relative table-collapse-fix panel-body-fix' },
	                  this.renderUsernameTable()
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactSkylight.SkyLightStateless,
	            {
	              dialogStyles: { height: '800px', width: '75%', top: '29%', left: '38%' },
	              isVisible: this.state.businessUsersModalOpen,
	              onCloseClicked: this.closeBusinessUserModal,
	              title: "Business Users"
	            },
	            _react2.default.createElement(_businessUsersModal2.default, null)
	          )
	        )
	      );
	    }
	  }]);
	
	  return UserManagement;
	}(_react.Component);
	
	UserManagement.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = UserManagement;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isAFG, 'isAFG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/userManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(isHF, 'isHF', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/userManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(isAPO, 'isAPO', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/userManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(tableHeight, 'tableHeight', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/userManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(isHMM, 'isHMM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/userManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(UserManagement, 'UserManagement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/userManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/userManagement.jsx');
	}();

	;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _inputField = __webpack_require__(16);
	
	var _reduxForm = __webpack_require__(3);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(18);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _userName = __webpack_require__(528);
	
	var _userName2 = _interopRequireDefault(_userName);
	
	var _userPassword = __webpack_require__(690);
	
	var _userPassword2 = _interopRequireDefault(_userPassword);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _url = __webpack_require__(20);
	
	var _root_url = __webpack_require__(9);
	
	var _UserProductGroupsModal = __webpack_require__(518);
	
	var _UserProductGroupsModal2 = _interopRequireDefault(_UserProductGroupsModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEcity = _root_url.ROOT_API_URL === "https://dev-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === "https://ct-scm.truckxi.com/api/";
	var isHMM = _root_url.ROOT_API_URL === "https://hmm-scm.truckxi.com/api/";
	var isAN = _root_url.ROOT_API_URL === 'https://asian-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://asian-scm.truckxi.com/api/';
	var isFung = _root_url.ROOT_API_URL === 'https://fung-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://fung-scm.truckxi.com/api/';
	
	var RowRenderer = function (_Component) {
	  _inherits(RowRenderer, _Component);
	
	  function RowRenderer() {
	    _classCallCheck(this, RowRenderer);
	
	    return _possibleConstructorReturn(this, (RowRenderer.__proto__ || Object.getPrototypeOf(RowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(RowRenderer, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // here we are just changing the style
	      // but we could replace this with anything we liked, cards, images, etc
	      // usually though it will just be a matter of wrapping a div, and then calling back through to the grid
	      return _react2.default.createElement(
	        'div',
	        { onDoubleClick: function onDoubleClick() {
	            _this2.props.onDoubleClick(_this2.props.row);
	          } },
	        _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props))
	      );
	    }
	  }]);
	
	  return RowRenderer;
	}(_react.Component);
	
	var DisableRowRenderer = function (_Component2) {
	  _inherits(DisableRowRenderer, _Component2);
	
	  function DisableRowRenderer() {
	    _classCallCheck(this, DisableRowRenderer);
	
	    return _possibleConstructorReturn(this, (DisableRowRenderer.__proto__ || Object.getPrototypeOf(DisableRowRenderer)).apply(this, arguments));
	  }
	
	  _createClass(DisableRowRenderer, [{
	    key: 'render',
	    value: function render() {
	      //here we are just changing the style
	      //but we could replace this with anything we liked, cards, images, etc
	      //usually though it will just be a matter of wrapping a div, and then calling back through to the grid
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactDataGrid2.default.Row, _extends({ ref: 'row' }, this.props, { style: { 'background-color': 'gray' } }))
	      );
	    }
	  }]);
	
	  return DisableRowRenderer;
	}(_react.Component);
	
	var UserManagementDetail = function (_Component3) {
	  _inherits(UserManagementDetail, _Component3);
	
	  function UserManagementDetail() {
	    _classCallCheck(this, UserManagementDetail);
	
	    var _this4 = _possibleConstructorReturn(this, (UserManagementDetail.__proto__ || Object.getPrototypeOf(UserManagementDetail)).call(this));
	
	    _this4.resetPassword = function () {
	      var letter = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 4);
	      var password = letter + '1234';
	      var url = _url.RESET_PASSWORD_URL + _this4.props.userDetail.User_id;
	
	      _axios2.default.put(url, { password: password }, {
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        if (response.status === 200) {
	          alert('Reset password to: ' + password);
	        }
	      }).catch(function (error) {
	        alert("Could not reset password, please try again!");
	      });
	      _this4.setState({ showPasswordPopup: false });
	    };
	
	    _this4.deleteUser = function () {
	      var url = _url.DELETE_USER_URL + _this4.props.userDetail.BaseUser_id;
	
	      _axios2.default.delete(url, {
	        data: { id: "BaseUser_id" },
	        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
	      }).then(function (response) {
	        if (response.status === 200) {
	          alert("The user has been deleted!");
	        }
	      }).catch(function (error) {
	        alert("Could not delete user, please try again!");
	      });
	      _this4.setState({
	        deleteUserPopup: false
	      });
	    };
	
	    _this4.handleAdminChange = function (value) {
	      _this4.setState({ admin: value });
	    };
	
	    _this4.renderIsOfficeOnly = function () {
	      var IsOfficeOnly = _this4.state.IsOfficeOnly;
	
	
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 3 },
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-12 marginTopStyle inlineLabel' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'office_only' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6, style: { float: "left" } },
	            _react2.default.createElement('input', {
	              checked: IsOfficeOnly,
	              onChange: function onChange(e) {
	                return _this4.setState({
	                  IsOfficeOnly: e.target.checked
	                });
	              },
	              type: 'checkbox'
	            })
	          )
	        )
	      );
	    };
	
	    _this4.state = {
	      dirty: false,
	      groupName: '',
	      groups: {
	        rows: [],
	        selectedRows: null,
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      userGroups: {
	        rows: [],
	        selectedRows: null,
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      permissions: {
	        rows: [],
	        selectedRows: null,
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      userPermissions: {
	        rows: [],
	        selectedRows: null,
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	
	      groupPermissions: {
	        rows: [],
	        selectedRows: null,
	        filters: {},
	        sortColumn: null,
	        sortDirection: null
	      },
	      editUserNameOpen: false,
	      editPasswordOpen: false,
	      showPasswordPopup: false,
	      deleteUserPopup: false,
	
	      admin: 'no',
	      IsOfficeOnly: false,
	      productGroups: [{ label: 'All', value: -2, checked: false }],
	      productGroupVisible: false
	    };
	    _this4.moveToUserGroups = _this4.moveToUserGroups.bind(_this4);
	    _this4.moveOffUserGroups = _this4.moveOffUserGroups.bind(_this4);
	    _this4.moveToUserPermissions = _this4.moveToUserPermissions.bind(_this4);
	    _this4.moveOffUserPermissions = _this4.moveOffUserPermissions.bind(_this4);
	    _this4.moveAllPermissions = _this4.moveAllPermissions.bind(_this4);
	    _this4.moveSelectedPermissions = _this4.moveSelectedPermissions.bind(_this4);
	    _this4.openEditUserName = _this4.openEditUserName.bind(_this4);
	    _this4.closeEditUserName = _this4.closeEditUserName.bind(_this4);
	    _this4.openEditPassword = _this4.openEditPassword.bind(_this4);
	    _this4.closeEditPassword = _this4.closeEditPassword.bind(_this4);
	    _this4.checkAuthorize = _this4.checkAuthorize.bind(_this4);
	    _this4.openResetPasswordPopup = _this4.openResetPasswordPopup.bind(_this4);
	    _this4.closeResetPasswordPopup = _this4.closeResetPasswordPopup.bind(_this4);
	    _this4.openDeleteUserPopup = _this4.openDeleteUserPopup.bind(_this4);
	    _this4.closeDeleteUserPopup = _this4.closeDeleteUserPopup.bind(_this4);
	    _this4.closeUserProductGroupPopup = _this4.closeUserProductGroupPopup.bind(_this4);
	    _this4.openUserProductGroupsPopup = _this4.openUserProductGroupsPopup.bind(_this4);
	    _this4.handleChangeProductGroups = _this4.handleChangeProductGroups.bind(_this4);
	    return _this4;
	  }
	
	  _createClass(UserManagementDetail, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this5 = this;
	
	      if (_root_url.isJML) {
	        this.props.fetchProductAllGroups();
	      }
	      if (this.props.currentUser) {
	        this.props.fetchUserDetail(this.props.currentUser).then(function () {
	          _this5.props.resetUserDetail();
	          _this5.props.fetchGroups();
	          _this5.props.fetchPermissions();
	        });
	      } else {
	        this.props.resetUserDetail();
	        this.props.fetchGroups();
	        this.props.fetchPermissions();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.userDetail && nextProps.userDetail != this.props.userDetail) {
	        var userPermissions = _extends({}, this.state.userPermissions, { rows: nextProps.userDetail.permissions.sort(function (a, b) {
	            return a.name.localeCompare(b.name);
	          }) });
	        var userGroups = _extends({}, this.state.userGroups, { rows: nextProps.userDetail.groups.sort(function (a, b) {
	            return a.name.localeCompare(b.name);
	          }) });
	        var permissions = _extends({}, this.state.permissions);
	        var groups = _extends({}, this.state.groups);
	        userPermissions.rows.map(function (row) {
	          var index = _lodash2.default.findIndex(permissions.rows, { permission_ptr_id: row.permission_ptr_id });
	          if (index > -1) permissions.rows.splice(index, 1);
	        });
	        userGroups.rows.map(function (row) {
	          var index = _lodash2.default.findIndex(groups.rows, { group_ptr_id: row.group_ptr_id });
	          if (index > -1) groups.rows.splice(index, 1);
	        });
	        if (_root_url.isJML && nextProps.userDetail.product_group_list && (this.props.productGroups || []).length > 0) {
	          var groupList = nextProps.userDetail.product_group_list.split(',');
	          this.initProductGroups(this.props.productGroups, groupList);
	        }
	        this.setState({ userPermissions: userPermissions, userGroups: userGroups, permissions: permissions, groups: groups, IsOfficeOnly: nextProps.userDetail.IsOfficeOnly });
	      }
	      if (nextProps.groupDetail && nextProps.groupDetail != this.props.groupDetail) {
	        var groupPermissions = _extends({}, this.state.groupPermissions, { rows: nextProps.groupDetail.permissions.sort(function (a, b) {
	            return a.name.localeCompare(b.name);
	          }) });
	        this.setState({ groupPermissions: groupPermissions });
	      }
	      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
	        if (this.state.showPasswordPopup) {
	          this.closeResetPasswordPopup();
	          this.resetPassword();
	        }
	        if (this.state.deleteUserPopup) {
	          this.closeDeleteUserPopup();
	          this.deleteUser();
	          this.context.router.push('/userManagement');
	        }
	      }
	      if (nextProps.permissions && nextProps.permissions != this.props.permissions) {
	        var newRows = [].concat(_toConsumableArray(nextProps.permissions));
	        var _permissions = _extends({}, this.state.permissions, { rows: newRows.sort(function (a, b) {
	            return a.name.localeCompare(b.name);
	          }) });
	        var _userPermissions = this.state.userPermissions;
	
	        _userPermissions.rows.map(function (row) {
	          var index = _lodash2.default.findIndex(_permissions.rows, { permission_ptr_id: row.permission_ptr_id });
	          if (index > -1) _permissions.rows.splice(index, 1);
	        });
	        this.setState({ permissions: _permissions });
	      }
	      if (nextProps.groups && nextProps.groups != this.props.groups) {
	        var _newRows = [].concat(_toConsumableArray(nextProps.groups));
	        var _groups = _extends({}, this.state.groups, { rows: _newRows.sort(function (a, b) {
	            return a.name.localeCompare(b.name);
	          }) });
	        var _userGroups = this.state.userGroups;
	
	        _userGroups.rows.map(function (row) {
	          var index = _lodash2.default.findIndex(_groups.rows, { group_ptr_id: row.group_ptr_id });
	          if (index > -1) _groups.rows.splice(index, 1);
	        });
	        this.setState({ groups: _groups });
	      }
	      if (nextProps.productGroups && nextProps.productGroups != this.props.productGroups) {
	        var _groupList = [];
	        if ((this.props.userDetail || nextProps.userDetail || { product_group_list: '' }).product_group_list) {
	          _groupList = (this.props.userDetail || nextProps.userDetail).product_group_list.split(',');
	        }
	        this.initProductGroups(nextProps.productGroups, _groupList);
	      }
	    }
	  }, {
	    key: 'initProductGroups',
	    value: function initProductGroups(productGroups, userProductGroups) {
	      var isAllChecked = true;
	      var cpProductGroups = productGroups.map(function (item) {
	        if (userProductGroups.length == 0 || userProductGroups.filter(function (id) {
	          return item.ProductGroup_id == id;
	        }).length == 0) {
	          isAllChecked = false;
	          return { label: item.Name, value: item.ProductGroup_id, checked: false };
	        } else {
	          return { label: item.Name, value: item.ProductGroup_id, checked: true };
	        }
	      });
	      cpProductGroups.unshift({ label: 'All', value: -2, checked: isAllChecked });
	      this.setState({
	        productGroups: cpProductGroups
	      });
	    }
	  }, {
	    key: 'renderGroups',
	    value: function renderGroups() {
	      var _this6 = this;
	
	      if (this.props.groupsIsLoading && !this.props.groupsError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.groupsError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.groupsError)
	        )
	      );else {
	        // Parameters of the react-data-grid
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this6.state.groups);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var groups = Object.assign({}, _this6.state.groups, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this6.setState({ groups: groups });
	        };
	
	        var handleFilterChange = function handleFilterChange(filter) {
	          var newFilters = Object.assign({}, _this6.state.groups.filters);
	          if (filter.filterTerm) {
	            newFilters[filter.column.key] = filter;
	          } else {
	            delete newFilters[filter.column.key];
	          }
	          var groups = _extends({}, _this6.state.groups, { filters: newFilters });
	          _this6.setState({ groups: groups });
	        };
	
	        // Handle the row select function
	        var onRowsSelected = function onRowsSelected(rows) {
	          var newRows = [].concat(_toConsumableArray(_this6.state.groups.rows));
	          var selectedRows = [];
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = true;
	            selectedRows.push(r.row);
	          });
	          if (_this6.state.groups.selectedRows) selectedRows = selectedRows.concat(_this6.state.groups.selectedRows);
	          var groups = _extends({}, _this6.state.groups, { rows: newRows, selectedRows: selectedRows });
	          _this6.setState({ groups: groups });
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          var newRows = [].concat(_toConsumableArray(_this6.state.groups.rows));
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = false;
	          });
	          var selectedRows = [].concat(_toConsumableArray(_this6.state.groups.selectedRows));
	          selectedRows = selectedRows.filter(function (obj) {
	            return obj.isSelected == true;
	          });
	          var groups = _extends({}, _this6.state.groups, { rows: newRows, selectedRows: selectedRows });
	          _this6.setState({ groups: groups });
	        };
	
	        var onRowClick = function onRowClick(rowIdx, row) {
	          _this6.setState({ groupName: row.name }, function () {
	            _this6.props.fetchGroupDetail(row.id);
	          });
	        };
	
	        // Column difinition
	        var columns = [{
	          key: 'name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'group_name' }),
	          resizable: true,
	          width: 250,
	          sortable: true,
	          filterable: true
	        }];
	
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 4 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '100%' }, id: 'UserManagementDetail-dataGrid1' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: this.moveToUserGroups }),
	              rowKey: 'id',
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              columns: columns,
	              rowHeight: 25,
	              minHeight: 265,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              onRowClick: onRowClick
	              // enableRowSelect='multi'
	              //  rowSelection={{
	              //    showCheckbox: true,
	              //    enableShiftSelect: true,
	              //    onRowsSelected: onRowsSelected,
	              //    onRowsDeselected: onRowsDeselected,
	              //    selectBy: { isSelectedKey: 'isSelected' }
	              // }}
	            })
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderUserGroups',
	    value: function renderUserGroups() {
	      var _this7 = this;
	
	      if (this.props.groupsIsLoading && !this.props.groupsError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.groupsError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.groupsError)
	        )
	      );else {
	        // Parameters of the react-data-grid
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this7.state.userGroups);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var userGroups = Object.assign({}, _this7.state.userGroups, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this7.setState({ userGroups: userGroups });
	        };
	
	        var handleFilterChange = function handleFilterChange(filter) {
	          var newFilters = Object.assign({}, _this7.state.userGroups.filters);
	          if (filter.filterTerm) {
	            newFilters[filter.column.key] = filter;
	          } else {
	            delete newFilters[filter.column.key];
	          }
	          var userGroups = _extends({}, _this7.state.userGroups, { filters: newFilters });
	          _this7.setState({ userGroups: userGroups });
	        };
	
	        // Handle the row select function
	        var onRowsSelected = function onRowsSelected(rows) {
	          var newRows = [].concat(_toConsumableArray(_this7.state.userGroups.rows));
	          var selectedRows = [];
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = true;
	            selectedRows.push(r.row);
	          });
	          if (_this7.state.userGroups.selectedRows) selectedRows = selectedRows.concat(_this7.state.userGroups.selectedRows);
	          var userGroups = _extends({}, _this7.state.userGroups, { rows: newRows, selectedRows: selectedRows });
	          _this7.setState({ userGroups: userGroups });
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          var newRows = [].concat(_toConsumableArray(_this7.state.userGroups.rows));
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = false;
	          });
	          var selectedRows = [].concat(_toConsumableArray(_this7.state.userGroups.selectedRows));
	          selectedRows = selectedRows.filter(function (obj) {
	            return obj.isSelected == true;
	          });
	          var userGroups = _extends({}, _this7.state.userGroups, { rows: newRows, selectedRows: selectedRows });
	          _this7.setState({ userGroups: userGroups });
	        };
	
	        var onRowClick = function onRowClick(rowIdx, row) {
	          _this7.setState({ groupName: row.name }, function () {
	            _this7.props.fetchGroupDetail(row.id);
	          });
	        };
	
	        // Column difinition
	        var columns = [{
	          key: 'name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'group_name' }),
	          resizable: true,
	          width: 250,
	          sortable: true,
	          filterable: true
	        }];
	
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 4 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '100%' }, id: 'UserManagementDetail-dataGrid2' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: this.moveOffUserGroups }),
	              rowKey: 'id',
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              columns: columns,
	              rowHeight: 25,
	              minHeight: 265,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              onRowClick: onRowClick
	              // enableRowSelect='multi'
	              // rowSelection={{
	              //   showCheckbox: true,
	              //   enableShiftSelect: true,
	              //   onRowsSelected: onRowsSelected,
	              //   onRowsDeselected: onRowsDeselected,
	              //   selectBy: { isSelectedKey: 'isSelected' }
	              // }}
	            })
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderGroupsPermissions',
	    value: function renderGroupsPermissions() {
	      var _this8 = this;
	
	      if (this.props.groupDetailIsLoading && !this.props.groupDetailError) return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 4 },
	        _react2.default.createElement(_spinner2.default, null)
	      );else if (this.props.groupDetailError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.groupDetailError)
	        )
	      );else {
	        // Parameters of the react-data-grid
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this8.state.groupPermissions);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var groupPermissions = Object.assign({}, _this8.state.groupPermissions, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this8.setState({ groupPermissions: groupPermissions });
	        };
	
	        var handleFilterChange = function handleFilterChange(filter) {
	          var newFilters = Object.assign({}, _this8.state.groupPermissions.filters);
	          if (filter.filterTerm) {
	            newFilters[filter.column.key] = filter;
	          } else {
	            delete newFilters[filter.column.key];
	          }
	          var groupPermissions = _extends({}, _this8.state.groupPermissions, { filters: newFilters });
	          _this8.setState({ groupPermissions: groupPermissions });
	        };
	
	        // Handle the row select function
	        var onRowsSelected = function onRowsSelected(rows) {
	          var newRows = [].concat(_toConsumableArray(_this8.state.groupPermissions.rows));
	          var selectedRows = [];
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = true;
	            selectedRows.push(r.row);
	          });
	          if (_this8.state.groupPermissions.selectedRows) selectedRows = selectedRows.concat(_this8.state.groupPermissions.selectedRows);
	          var groupPermissions = _extends({}, _this8.state.groupPermissions, { rows: newRows, selectedRows: selectedRows });
	          _this8.setState({ groupPermissions: groupPermissions });
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          var newRows = [].concat(_toConsumableArray(_this8.state.groupPermissions.rows));
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = false;
	          });
	          var selectedRows = [].concat(_toConsumableArray(_this8.state.groupPermissions.selectedRows));
	          selectedRows = selectedRows.filter(function (obj) {
	            return obj.isSelected == true;
	          });
	          var groupPermissions = _extends({}, _this8.state.groupPermissions, { rows: newRows, selectedRows: selectedRows });
	          _this8.setState({ groupPermissions: groupPermissions });
	        };
	
	        var onRowClick = function onRowClick(rowIdx, row) {}
	        //  this.props.fetchUserDetail(row.user_id);
	
	
	        // Column difinition
	        ;var columns = [{
	          key: 'name',
	          name: this.state.groupName || _react2.default.createElement(_reactReduxI18n.Translate, { value: 'granted_permission_name' }),
	          resizable: true,
	          width: 250,
	          sortable: true,
	          filterable: true
	        }];
	
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 4 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '100%' }, className: 'group-permission-data-grid', id: 'UserManagementDetail-dataGrid3' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowKey: 'id',
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              columns: columns,
	              rowHeight: 25,
	              minHeight: 265,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              onRowClick: onRowClick
	            })
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderPermissions',
	    value: function renderPermissions() {
	      var _this9 = this;
	
	      if (this.props.permissionsIsLoading && !this.props.permissionsError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.permissionsError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.permissionsError)
	        )
	      );else {
	        // Parameters of the react-data-grid
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this9.state.permissions);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var permissions = Object.assign({}, _this9.state.permissions, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this9.setState({ permissions: permissions });
	        };
	
	        var handleFilterChange = function handleFilterChange(filter) {
	          var newFilters = Object.assign({}, _this9.state.permissions.filters);
	          if (filter.filterTerm) {
	            newFilters[filter.column.key] = filter;
	          } else {
	            delete newFilters[filter.column.key];
	          }
	          var permissions = _extends({}, _this9.state.permissions, { filters: newFilters });
	          _this9.setState({ permissions: permissions });
	        };
	
	        // Handle the row select function
	        var onRowsSelected = function onRowsSelected(rows) {
	          var newRows = [].concat(_toConsumableArray(_this9.state.permissions.rows));
	          var selectedRows = [];
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = true;
	            selectedRows.push(r.row);
	          });
	          if (_this9.state.permissions.selectedRows) selectedRows = selectedRows.concat(_this9.state.permissions.selectedRows);
	          var permissions = _extends({}, _this9.state.permissions, { rows: newRows, selectedRows: selectedRows });
	          _this9.setState({ permissions: permissions });
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          var newRows = [].concat(_toConsumableArray(_this9.state.permissions.rows));
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = false;
	          });
	          var selectedRows = [].concat(_toConsumableArray(_this9.state.permissions.selectedRows));
	          selectedRows = selectedRows.filter(function (obj) {
	            return obj.isSelected == true;
	          });
	          var permissions = _extends({}, _this9.state.permissions, { rows: newRows, selectedRows: selectedRows });
	          _this9.setState({ permissions: permissions });
	        };
	
	        var onRowClick = function onRowClick(rowIdx, row) {}
	        //  this.props.fetchUserDetail(row.user_id);
	
	
	        // Column difinition
	        ;var columns = [{
	          key: 'name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'permission_name' }),
	          resizable: true,
	          width: 250,
	          sortable: true,
	          filterable: true
	        }];
	
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 6 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '100%' }, id: 'UserManagementDetail-dataGrid4' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: this.moveToUserPermissions }),
	              rowKey: 'id',
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              columns: columns,
	              rowHeight: 25,
	              minHeight: 265,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              onRowClick: onRowClick,
	              rowSelection: {
	                showCheckbox: true,
	                enableShiftSelect: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: { isSelectedKey: 'isSelected' }
	              }
	            })
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderUserPermissions',
	    value: function renderUserPermissions() {
	      var _this10 = this;
	
	      if (this.props.permissionsIsLoading && !this.props.permissionsError) return _react2.default.createElement(_spinner2.default, null);else if (this.props.permissionsError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.permissionsError)
	        )
	      );else {
	        // Parameters of the react-data-grid
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this10.state.userPermissions);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var userPermissions = Object.assign({}, _this10.state.userPermissions, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this10.setState({ userPermissions: userPermissions });
	        };
	
	        var handleFilterChange = function handleFilterChange(filter) {
	          var newFilters = Object.assign({}, _this10.state.userPermissions.filters);
	          if (filter.filterTerm) {
	            newFilters[filter.column.key] = filter;
	          } else {
	            delete newFilters[filter.column.key];
	          }
	          var userPermissions = _extends({}, _this10.state.userPermissions, { filters: newFilters });
	          _this10.setState({ userPermissions: userPermissions });
	        };
	
	        // Handle the row select function
	        var onRowsSelected = function onRowsSelected(rows) {
	          var newRows = [].concat(_toConsumableArray(_this10.state.userPermissions.rows));
	          var selectedRows = [];
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = true;
	            selectedRows.push(r.row);
	          });
	          if (_this10.state.userPermissions.selectedRows) selectedRows = selectedRows.concat(_this10.state.userPermissions.selectedRows);
	          var userPermissions = _extends({}, _this10.state.userPermissions, { rows: newRows, selectedRows: selectedRows });
	          _this10.setState({ userPermissions: userPermissions });
	        };
	
	        var onRowsDeselected = function onRowsDeselected(rows) {
	          var newRows = [].concat(_toConsumableArray(_this10.state.userPermissions.rows));
	          rows.map(function (r) {
	            newRows[r.rowIdx].isSelected = false;
	          });
	          var selectedRows = [].concat(_toConsumableArray(_this10.state.userPermissions.selectedRows));
	          selectedRows = selectedRows.filter(function (obj) {
	            return obj.isSelected == true;
	          });
	          var userPermissions = _extends({}, _this10.state.userPermissions, { rows: newRows, selectedRows: selectedRows });
	          _this10.setState({ userPermissions: userPermissions });
	        };
	
	        var onRowClick = function onRowClick(rowIdx, row) {}
	        // this.props.fetchUserDetail(row.user_id);
	
	
	        // Column difinition
	        ;var columns = [{
	          key: 'name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'granted_permission_name' }),
	          resizable: true,
	          width: 250,
	          sortable: true,
	          filterable: true
	        }];
	
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 6 },
	          _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '100%' }, id: 'UserManagementDetail-dataGrid5' },
	            _react2.default.createElement(_reactDataGrid2.default, {
	              rowRenderer: _react2.default.createElement(RowRenderer, { onDoubleClick: this.moveOffUserPermissions }),
	              rowKey: 'id',
	              onGridSort: handleGridSort,
	              toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	              onAddFilter: handleFilterChange,
	              columns: columns,
	              rowHeight: 25,
	              minHeight: 265,
	              rowGetter: rowGetter,
	              rowsCount: getSize(),
	              onRowClick: onRowClick,
	              rowSelection: {
	                showCheckbox: true,
	                enableShiftSelect: true,
	                onRowsSelected: onRowsSelected,
	                onRowsDeselected: onRowsDeselected,
	                selectBy: { isSelectedKey: 'isSelected' }
	              }
	            })
	          )
	        );
	      }
	    }
	  }, {
	    key: 'moveToUserPermissions',
	    value: function moveToUserPermissions(permission) {
	      var userPermissionsRows = [].concat(_toConsumableArray(this.state.userPermissions.rows));
	      var newRows = [].concat(_toConsumableArray(this.state.permissions.rows));
	      var index = _lodash2.default.findIndex(newRows, { id: permission.id });
	      if (index > -1) newRows.splice(index, 1);
	      index = _lodash2.default.findIndex(userPermissionsRows, { id: permission.id });
	      if (index == -1) userPermissionsRows.push(_extends({}, permission, { isSelected: false }));
	      var userPermissions = _extends({}, this.state.userPermissions, { rows: userPermissionsRows });
	      var permissions = _extends({}, this.state.permissions, { rows: newRows.sort(function (a, b) {
	          return a.name.localeCompare(b.name);
	        }) });
	      this.setState({ userPermissions: userPermissions, permissions: permissions });
	    }
	  }, {
	    key: 'moveOffUserPermissions',
	    value: function moveOffUserPermissions(permission) {
	      var userPermissionsRows = [].concat(_toConsumableArray(this.state.userPermissions.rows));
	      var newRows = [].concat(_toConsumableArray(this.state.permissions.rows));
	      var index = _lodash2.default.findIndex(userPermissionsRows, { id: permission.id });
	      if (index > -1) userPermissionsRows.splice(index, 1);
	      index = _lodash2.default.findIndex(newRows, { id: permission.id });
	      if (index == -1) newRows.push(_extends({}, permission, { isSelected: false }));
	      var userPermissions = _extends({}, this.state.userPermissions, { rows: userPermissionsRows });
	      var permissions = _extends({}, this.state.permissions, { rows: newRows.sort(function (a, b) {
	          return a.name.localeCompare(b.name);
	        }) });
	      this.setState({ userPermissions: userPermissions, permissions: permissions });
	    }
	  }, {
	    key: 'moveAllPermissions',
	    value: function moveAllPermissions() {
	      var permissionsRows = [].concat(_toConsumableArray(this.state.permissions.rows));
	      var userPermissionsRows = [].concat(_toConsumableArray(this.state.userPermissions.rows));
	      var index = void 0;
	      permissionsRows.map(function (r) {
	        index = _lodash2.default.findIndex(userPermissionsRows, { id: r.id });
	        if (index == -1) userPermissionsRows.push(r);
	      });
	      var userPermissions = _extends({}, this.state.userPermissions, { rows: userPermissionsRows });
	      var permissions = _extends({}, this.state.permissions, { rows: [] });
	      this.setState({ userPermissions: userPermissions, permissions: permissions });
	    }
	  }, {
	    key: 'moveSelectedDisabled',
	    value: function moveSelectedDisabled() {
	      var permissions = this.state.permissions;
	
	      if (permissions.selectedRows && permissions.selectedRows.length > 0) {
	        return false;
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'moveSelectedPermissions',
	    value: function moveSelectedPermissions() {
	      var userPermissionsRows = [].concat(_toConsumableArray(this.state.userPermissions.rows));
	      var permissionsRows = [].concat(_toConsumableArray(this.state.permissions.rows));
	      var newRows = [].concat(_toConsumableArray(this.state.permissions.rows));
	      var selectedPermissionRows = [].concat(_toConsumableArray(this.state.permissions.selectedRows));
	      var index = void 0;
	      permissionsRows.map(function (r) {
	        selectedPermissionRows.map(function (s) {
	          if (r.id === s.id) {
	            index = _lodash2.default.findIndex(newRows, { id: r.id });
	            if (index > -1) {
	              newRows.splice(index, 1);
	            }
	            index = _lodash2.default.findIndex(userPermissionsRows, { id: r.id });
	            if (index == -1) {
	              userPermissionsRows.push(_extends({}, r, { isSelected: false }));
	            }
	          }
	        });
	      });
	      var userPermissions = _extends({}, this.state.userPermissions, { rows: userPermissionsRows });
	      var permissions = _extends({}, this.state.permissions, { selectedRows: [], rows: newRows.sort(function (a, b) {
	          return a.name.localeCompare(b.name);
	        }) });
	      this.setState({ userPermissions: userPermissions, permissions: permissions });
	    }
	  }, {
	    key: 'moveToUserGroups',
	    value: function moveToUserGroups(group) {
	      var userGroupsRows = [].concat(_toConsumableArray(this.state.userGroups.rows));
	      var newRows = [].concat(_toConsumableArray(this.state.groups.rows));
	      var index = _lodash2.default.findIndex(newRows, { id: group.id });
	      if (index > -1) newRows.splice(index, 1);
	      index = _lodash2.default.findIndex(userGroupsRows, { id: group.id });
	      if (index == -1) userGroupsRows.push(group);
	      var userGroups = _extends({}, this.state.userGroups, { rows: userGroupsRows });
	      var groups = _extends({}, this.state.groups, { rows: newRows.sort(function (a, b) {
	          return a.name.localeCompare(b.name);
	        }) });
	      this.setState({ userGroups: userGroups, groups: groups });
	    }
	  }, {
	    key: 'moveOffUserGroups',
	    value: function moveOffUserGroups(group) {
	      var userGroupsRows = [].concat(_toConsumableArray(this.state.userGroups.rows));
	      var newRows = [].concat(_toConsumableArray(this.state.groups.rows));
	      var index = _lodash2.default.findIndex(userGroupsRows, { id: group.id });
	      if (index > -1) userGroupsRows.splice(index, 1);
	      index = _lodash2.default.findIndex(newRows, { id: group.id });
	      if (index == -1) newRows.push(group);
	      var userGroups = _extends({}, this.state.userGroups, { rows: userGroupsRows });
	      var groups = _extends({}, this.state.groups, { rows: newRows.sort(function (a, b) {
	          return a.name.localeCompare(b.name);
	        }) });
	      this.setState({ userGroups: userGroups, groups: groups });
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(originalFormProp) {
	      var product_group_list = '';
	      if (_root_url.isJML) {
	        var productGroups = [];
	        this.state.productGroups.map(function (item) {
	          if (item.value != -2 && item.checked) {
	            productGroups.push(item.value);
	          }
	        });
	        product_group_list = productGroups.toString();
	      }
	      var formProps = _extends({}, originalFormProp, {
	        IsOfficeOnly: this.state.IsOfficeOnly
	      }, _root_url.isJML && { product_group_list: product_group_list });
	      this.setState({ dirty: false });
	      var props = _extends({}, formProps, {
	        id: formProps.BaseUser_id,
	        email: formProps.email ? formProps.email : '',
	        FirstName: formProps.FirstName,
	        LastName: formProps.LastName
	      });
	      if (_root_url.isJML) {
	        props.product_group_list = product_group_list;
	      }
	
	      if (this.props.currentUser) {
	        if (!this.checkPermission("change_baseuser")) this.props.editUserDetail(props, _reactDataGridAddons.Data.Selectors.getRows(this.state.userPermissions), _reactDataGridAddons.Data.Selectors.getRows(this.state.userGroups), 1);else alert("You have no permission!");
	      } else {
	        this.props.createUserDetail(formProps, _reactDataGridAddons.Data.Selectors.getRows(this.state.userPermissions), _reactDataGridAddons.Data.Selectors.getRows(this.state.userGroups));
	      }
	      if (formProps.username === localStorage.getItem('username')) alert('You changed your own permissions, please logout and log back in for the permissions to take affect.');
	    }
	  }, {
	    key: 'renderPassword',
	    value: function renderPassword() {
	      if (this.props.userDetail) {
	        return _react2.default.createElement(_reactBootstrap.Col, { sm: 6 });
	      } else {
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 6 },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'password' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6, style: { float: "left" } },
	              _react2.default.createElement(_reduxForm.Field, { className: 'largeInput', name: 'password', component: _inputField.PasswordInputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6 },
	              _react2.default.createElement(
	                'label',
	                { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm_password' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 6, style: { float: "left" } },
	              _react2.default.createElement(_reduxForm.Field, { className: 'largeInput', name: 'passwordConfirm', component: _inputField.PasswordInputField })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderAdmin',
	    value: function renderAdmin() {
	      return _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 3 },
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 12 },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-12 marginTopStyle inlineLabel' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'pass_code' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6, style: { float: "left" } },
	            _react2.default.createElement(_reduxForm.Field, { className: 'largeInput', name: 'passcode', component: _inputField.PasswordInputField })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderName',
	    value: function renderName() {
	      if (this.props.currentUser) {
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 3 },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-12 marginTopStyle inlineLabel' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'user_name' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6, style: { float: "left" } },
	            _react2.default.createElement(_reduxForm.Field, { className: 'largeInput', name: 'username', component: _inputField.DisabledInputField, placeholder: this.props.userDetail ? this.props.userDetail.username : null })
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          _reactBootstrap.Col,
	          { sm: 3 },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-12 marginTopStyle inlineLabel' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'user_name' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6, style: { float: "left" } },
	            _react2.default.createElement(_reduxForm.Field, { className: 'largeInput', name: 'username', component: _inputField.InputField })
	          )
	        );
	      }
	    }
	  }, {
	    key: 'openEditUserName',
	    value: function openEditUserName() {
	      this.setState({ editUserNameOpen: true });
	    }
	  }, {
	    key: 'closeEditUserName',
	    value: function closeEditUserName() {
	      this.setState({ editUserNameOpen: false });
	      this.props.fetchUserDetail(this.props.currentUser);
	    }
	  }, {
	    key: 'openEditPassword',
	    value: function openEditPassword() {
	      this.props.resetPassword();
	      this.setState({ editPasswordOpen: true });
	    }
	  }, {
	    key: 'closeEditPassword',
	    value: function closeEditPassword() {
	      this.setState({ editPasswordOpen: false });
	    }
	  }, {
	    key: 'closeResetPasswordPopup',
	    value: function closeResetPasswordPopup() {
	      this.setState({ showPasswordPopup: false });
	    }
	  }, {
	    key: 'closeDeleteUserPopup',
	    value: function closeDeleteUserPopup() {
	      this.setState({ deleteUserPopup: false });
	    }
	  }, {
	    key: 'closeUserProductGroupPopup',
	    value: function closeUserProductGroupPopup() {
	      this.setState({ productGroupVisible: false });
	    }
	  }, {
	    key: 'checkPermission',
	    value: function checkPermission(permission) {
	      return false;
	    }
	  }, {
	    key: 'checkAuthorize',
	    value: function checkAuthorize(password) {
	      this.props.checkPassword(password);
	    }
	  }, {
	    key: 'openResetPasswordPopup',
	    value: function openResetPasswordPopup() {
	      this.setState({ showPasswordPopup: true });
	      this.props.clearCheckPassword();
	    }
	  }, {
	    key: 'openDeleteUserPopup',
	    value: function openDeleteUserPopup() {
	      this.setState({ deleteUserPopup: true });
	      this.props.clearCheckPassword();
	    }
	  }, {
	    key: 'openUserProductGroupsPopup',
	    value: function openUserProductGroupsPopup() {
	      this.setState({ productGroupVisible: true });
	    }
	  }, {
	    key: 'handleChangeProductGroups',
	    value: function handleChangeProductGroups(productGroups) {
	      this.setState({
	        productGroups: productGroups
	      });
	      this.closeUserProductGroupPopup();
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      if (this.props.createUserDetailError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            this.props.createUserDetailError.data
	          )
	        );
	      }
	      return;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this11 = this;
	
	      var createDialogStyle = {
	        height: '300px',
	        width: '600px',
	        marginLeft: '-10%'
	      };
	      var _props = this.props,
	          _handleSubmit = _props.handleSubmit,
	          submitting = _props.submitting,
	          pristine = _props.pristine;
	
	      var editUsername = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_username' });
	      var changePassword = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'change_password' });
	      var resetPassword = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reset_password' });
	      var deleteUser = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete_user' });
	      var productGroups = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_groups' });
	      return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'form',
	          { method: 'get', action: '#', onSubmit: _handleSubmit(this.handleFormSubmit.bind(this)) },
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'Admin' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'user_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'user_detail' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { type: 'submit', bsStyle: 'success' },
	              _react2.default.createElement('em', { className: 'fa fa-save' }),
	              ' ',
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'primary', onClick: this.openEditUserName, disabled: this.checkPermission("change_baseuser") },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_username' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'primary', onClick: this.openEditPassword, disabled: this.checkPermission("change_baseuser") },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_password' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'primary', onClick: this.openResetPasswordPopup, disabled: this.checkPermission("change_baseuser") },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reset_password' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'danger', onClick: this.openDeleteUserPopup, disabled: this.checkPermission("change_baseuser") },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'delete_user' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsStyle: 'danger', onClick: function onClick() {
	                  _this11.context.router.push('/userManagement');
	                } },
	              _react2.default.createElement('em', { className: 'fa fa-close' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { id: 'user-management-detail' },
	            this.renderError(),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { className: 'marginBottomStyle' },
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  { style: { marginTop: 6 } },
	                  this.renderName(),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 3 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 6 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 6, style: { float: "left" } },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'email', component: _inputField.InputField })
	                    )
	                  ),
	                  this.renderPassword()
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 3 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 6 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'first_name' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 6, style: { float: "left" } },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'FirstName', component: _inputField.InputField })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 3 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 6 },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'col-sm-12 marginTopStyle inlineLabel' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_name' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Col,
	                      { sm: 6, style: { float: "left" } },
	                      _react2.default.createElement(_reduxForm.Field, { name: 'LastName', component: _inputField.InputField })
	                    )
	                  ),
	                  _root_url.isJML && _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 6 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      { style: { marginLeft: "15px" }, bsStyle: 'primary', onClick: function onClick() {
	                          _this11.openUserProductGroupsPopup();
	                        } },
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'product_groups' })
	                    )
	                  ),
	                  (isEcity || _root_url.isRivera || isHMM || isAN || isFung) && this.renderAdmin(),
	                  _root_url.isRivera && this.renderIsOfficeOnly()
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { id: 'user-management-detail-groups' },
	                this.renderGroups(),
	                this.renderUserGroups(),
	                this.renderGroupsPermissions()
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Panel,
	                { id: 'user-management-detail-permissions' },
	                _react2.default.createElement(
	                  _reactBootstrap.ButtonToolbar,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { style: { marginLeft: "15px" }, bsStyle: 'primary', onClick: function onClick() {
	                        _this11.moveAllPermissions();
	                      } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'move_all' })
	                  ),
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { bsStyle: 'primary', disabled: this.moveSelectedDisabled(), onClick: function onClick() {
	                        _this11.moveSelectedPermissions();
	                      } },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'move_selected' })
	                  )
	                ),
	                this.renderPermissions(),
	                this.renderUserPermissions()
	              )
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: createDialogStyle, isVisible: this.state.editUserNameOpen, onCloseClicked: this.closeEditUserName.bind(this), title: editUsername },
	              _react2.default.createElement(_userName2.default, { userDetail: this.props.userDetail, handleSubmit: function handleSubmit() {
	                  _handleSubmit(_this11.handleFormSubmit.bind(_this11));
	                } })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: createDialogStyle, isVisible: this.state.editPasswordOpen, onCloseClicked: this.closeEditPassword.bind(this), title: changePassword },
	              _react2.default.createElement(_userPassword2.default, { userDetail: this.props.userDetail })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: createDialogStyle, isVisible: this.state.showPasswordPopup, onCloseClicked: this.closeResetPasswordPopup.bind(this), title: resetPassword },
	              _react2.default.createElement(_confirmActionModal2.default, {
	                'case': 'confirmPassword', closeC: this.checkAuthorize,
	                checkPasswordFailure: this.props.checkPasswordFailure,
	                checkPasswordSuccess: this.props.checkPasswordSuccess,
	                clearCheckPassword: this.props.clearCheckPassword
	              })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: createDialogStyle, isVisible: this.state.deleteUserPopup, onCloseClicked: this.closeDeleteUserPopup.bind(this), title: deleteUser },
	              _react2.default.createElement(_confirmActionModal2.default, {
	                'case': 'confirmPassword', closeC: this.checkAuthorize,
	                checkPasswordFailure: this.props.checkPasswordFailure,
	                checkPasswordSuccess: this.props.checkPasswordSuccess,
	                clearCheckPassword: this.props.clearCheckPassword
	              })
	            ),
	            _react2.default.createElement(
	              _reactSkylight.SkyLightStateless,
	              { dialogStyles: createDialogStyle, isVisible: this.state.productGroupVisible, onCloseClicked: this.closeUserProductGroupPopup, title: productGroups },
	              _react2.default.createElement(_UserProductGroupsModal2.default, {
	                groups: this.state.productGroups,
	                onChangeProductGroups: this.handleChangeProductGroups,
	                onClose: this.closeUserProductGroupPopup
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return UserManagementDetail;
	}(_react.Component);
	
	UserManagementDetail.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	UserManagementDetail.propTypes = {
	  clearCheckPassword: _propTypes2.default.func.isRequired,
	  checkPassword: _propTypes2.default.func.isRequired,
	  checkPasswordSuccess: _propTypes2.default.bool.isRequired,
	  checkPasswordFailure: _propTypes2.default.bool.isRequired
	};
	
	var _default = UserManagementDetail;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/userManagementDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(isHMM, 'isHMM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/userManagementDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(isAN, 'isAN', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/userManagementDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(isFung, 'isFung', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/userManagementDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(RowRenderer, 'RowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/userManagementDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(DisableRowRenderer, 'DisableRowRenderer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/userManagementDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(UserManagementDetail, 'UserManagementDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/userManagementDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/userManagementDetail.jsx');
	}();

	;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _inputField = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserName = function (_Component) {
	  _inherits(UserName, _Component);
	
	  function UserName() {
	    _classCallCheck(this, UserName);
	
	    return _possibleConstructorReturn(this, (UserName.__proto__ || Object.getPrototypeOf(UserName)).apply(this, arguments));
	  }
	
	  _createClass(UserName, [{
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      this.props.editUserDetail(formProps, formProps.user_permissions, formProps.groups, 2);
	    }
	  }, {
	    key: 'renderResponse',
	    value: function renderResponse() {
	      var _props = this.props,
	          editUserDetailSuccess = _props.editUserDetailSuccess,
	          editUserDetailError = _props.editUserDetailError,
	          editUserDetailIsLoading = _props.editUserDetailIsLoading;
	
	      if (editUserDetailSuccess) {
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-success' },
	            'Success!'
	          )
	        );
	      } else if (editUserDetailIsLoading && !editUserDetailError) {
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-info' },
	            '...',
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reading_data' })
	          )
	        );
	      } else if (editUserDetailError) {
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            editUserDetailError
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          handleSubmit = _props2.handleSubmit,
	          editUserDetailSuccess = _props2.editUserDetailSuccess;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12, style: { marginTop: '20px' } },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 4 },
	              _react2.default.createElement(
	                'label',
	                { style: { float: 'right', paddingTop: '2px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'user_name' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 5, style: { float: 'left' } },
	              _react2.default.createElement(_reduxForm.Field, { name: 'username', component: _inputField.InputField })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { style: { marginTop: '80px', textAlign: 'center' } },
	          _react2.default.createElement(
	            'button',
	            { onClick: handleSubmit, className: 'btn btn-primary buttonStyle' },
	            _react2.default.createElement('em', { className: 'fa fa-check' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	          )
	        ),
	        _react2.default.createElement('br', null),
	        this.renderResponse()
	      );
	    }
	  }]);
	
	  return UserName;
	}(_react.Component);
	
	var _default = UserName;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(UserName, 'UserName', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/userName.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/userName.jsx');
	}();

	;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _inputField = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserPassword = function (_Component) {
	  _inherits(UserPassword, _Component);
	
	  function UserPassword() {
	    _classCallCheck(this, UserPassword);
	
	    return _possibleConstructorReturn(this, (UserPassword.__proto__ || Object.getPrototypeOf(UserPassword)).apply(this, arguments));
	  }
	
	  _createClass(UserPassword, [{
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      this.props.editPassword(formProps);
	    }
	  }, {
	    key: 'showErrorMessage',
	    value: function showErrorMessage() {
	      var editPasswordError = this.props.editPasswordError;
	      if (editPasswordError) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            editPasswordError
	          )
	        );
	      }
	      return;
	    }
	  }, {
	    key: 'renderResponse',
	    value: function renderResponse() {
	      var _props = this.props,
	          editUserDetailSuccess = _props.editUserDetailSuccess,
	          editPasswordError = _props.editPasswordError,
	          editPasswordIsLoading = _props.editPasswordIsLoading;
	
	      if (editUserDetailSuccess) {
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-success' },
	            'Success!'
	          )
	        );
	      } else if (editPasswordIsLoading && !editPasswordError) {
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-info' },
	            '...',
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'reading_data' })
	          )
	        );
	      } else if (editPasswordError) {
	        return _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            editPasswordError
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var handleSubmit = this.props.handleSubmit;
	
	      return _react2.default.createElement(
	        'form',
	        { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12, className: 'marginTopStyle' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 5 },
	              _react2.default.createElement(
	                'label',
	                { style: { float: 'right', paddingTop: '2px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'password' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 5, style: { float: 'left' } },
	              _react2.default.createElement(_reduxForm.Field, { name: 'password', component: _inputField.InputField })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12, className: 'marginTopStyle' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 5 },
	              _react2.default.createElement(
	                'label',
	                { style: { float: 'right', paddingTop: '2px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_password' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 5, style: { float: 'left' } },
	              _react2.default.createElement(_reduxForm.Field, { name: 'new_password', component: _inputField.InputField })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12, className: 'marginTopStyle' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 5 },
	              _react2.default.createElement(
	                'label',
	                { style: { float: 'right', paddingTop: '2px' } },
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'new_password_again' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { xs: 5, style: { float: 'left' } },
	              _react2.default.createElement(_reduxForm.Field, { name: 'renew_password', component: _inputField.InputField })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { style: { marginTop: '50px', textAlign: 'center' } },
	          _react2.default.createElement(
	            'button',
	            { action: 'submit', className: 'btn btn-primary buttonStyle' },
	            _react2.default.createElement('em', { className: 'fa fa-check' }),
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	          )
	        ),
	        _react2.default.createElement('br', null),
	        this.renderResponse()
	      );
	    }
	  }]);
	
	  return UserPassword;
	}(_react.Component);
	
	var _default = UserPassword;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(UserPassword, 'UserPassword', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/userPassword.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Settings/userPassword.jsx');
	}();

	;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(13);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helper function to check the fields are valid or not.
	
	function checkValid(elem) {
	    return elem.touched && elem.invalid ? 'has-danger' : '';
	}
	
	var UserForm = function (_Component) {
	    _inherits(UserForm, _Component);
	
	    function UserForm() {
	        _classCallCheck(this, UserForm);
	
	        return _possibleConstructorReturn(this, (UserForm.__proto__ || Object.getPrototypeOf(UserForm)).apply(this, arguments));
	    }
	
	    _createClass(UserForm, [{
	        key: 'onSubmit',
	        value: function onSubmit(props) {
	            var _this2 = this;
	
	            this.props.createUsers(props).then(function () {
	                _this2.context.router.push('/users');
	            });
	        }
	
	        // If the url is ".../users/new", return a blank form with title of new user.
	        // If the url comes with a userID, the form will be filled with title of edit
	        // user corresponding information.
	
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.params.id) {
	                var _props$user = this.props.user,
	                    name = _props$user.name,
	                    email = _props$user.email,
	                    phone = _props$user.phone,
	                    address = _props$user.address;
	
	                this.props.fields.name.onChange(name);
	                this.props.fields.email.onChange(email);
	                this.props.fields.phone.onChange(phone);
	                this.props.fields.address.city.onChange(address.city);
	                this.props.fields.address.street.onChange(address.street);
	            } else {
	                (0, _reduxForm.reset)('userForm');
	            }
	        }
	    }, {
	        key: 'title',
	        value: function title() {
	            if (!this.props.params.id) {
	                return _react2.default.createElement(
	                    'h3',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_a_new_user' })
	                );
	            }
	            return _react2.default.createElement(
	                'h3',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_user' })
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                _props$fields = _props.fields,
	                name = _props$fields.name,
	                email = _props$fields.email,
	                phone = _props$fields.phone,
	                address = _props$fields.address,
	                handleSubmit = _props.handleSubmit;
	
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'form',
	                    { onSubmit: handleSubmit(this.onSubmit.bind(this)) },
	                    this.title(),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'form-group ' + checkValid(name) },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	                        ),
	                        _react2.default.createElement('input', _extends({ type: 'text', className: 'form-control' }, name)),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'text-help' },
	                            name.touched ? name.error : ''
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'form-group ' + checkValid(email) },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' })
	                        ),
	                        _react2.default.createElement('input', _extends({ type: 'text', className: 'form-control' }, email)),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'text-help' },
	                            email.touched ? email.error : ''
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'form-group ' + checkValid(phone) },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'phone' })
	                        ),
	                        _react2.default.createElement('input', _extends({ type: 'text', className: 'form-control' }, phone)),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'text-help' },
	                            phone.touched ? phone.error : ''
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'form-group ' + checkValid(address.city) },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city' })
	                        ),
	                        _react2.default.createElement('input', _extends({ type: 'text', className: 'form-control' }, address.city))
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'form-group ' + checkValid(address.street) },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'street' })
	                        ),
	                        _react2.default.createElement('input', _extends({ type: 'text', className: 'form-control' }, address.street))
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { type: 'submit', className: 'btn btn-primary' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'submit' })
	                    ),
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/users', className: 'btn btn-danger buttonStyle' },
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UserForm;
	}(_react.Component);
	
	UserForm.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	var _default = UserForm;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(checkValid, 'checkValid', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Users/userForm.jsx');
	
	    __REACT_HOT_LOADER__.register(UserForm, 'UserForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Users/userForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Users/userForm.jsx');
	}();

	;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(13);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Users = function (_Component) {
	    _inherits(Users, _Component);
	
	    function Users() {
	        _classCallCheck(this, Users);
	
	        return _possibleConstructorReturn(this, (Users.__proto__ || Object.getPrototypeOf(Users)).apply(this, arguments));
	    }
	
	    _createClass(Users, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _ContentWrapper2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content-heading' },
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'dashboard' })
	                )
	            );
	        }
	    }]);
	
	    return Users;
	}(_react.Component);
	
	var _default = Users;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(Users, 'Users', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Users/users.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Users/users.jsx');
	}();

	;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	// Helping function to render a multi-fields form. Reference on redux-form array.
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cloneDeep = __webpack_require__(124);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _axios = __webpack_require__(12);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _selection = __webpack_require__(21);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _inputField = __webpack_require__(16);
	
	var _isActive = __webpack_require__(96);
	
	var _isActive2 = _interopRequireDefault(_isActive);
	
	var _confirmActionModal = __webpack_require__(32);
	
	var _confirmActionModal2 = _interopRequireDefault(_confirmActionModal);
	
	var _root_url = __webpack_require__(9);
	
	var _priceTableModal = __webpack_require__(159);
	
	var _map = __webpack_require__(55);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isTQ = _root_url.ROOT_API_URL === 'https://topquality-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://topquality-scm.truckxi.com/api/';
	var isOCM = _root_url.ROOT_API_URL === 'https://ocm-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://ocm-scm.truckxi.com/api/';
	var isMAG = _root_url.ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || _root_url.ROOT_URL === 'https://magna-scm.truckxi.com/api/';
	
	var renderIsDefault = function renderIsDefault(props) {
	  // Bad implementation, cannot set the value attribute of Input componnet to a boolean.
	
	  var titleClass = (0, _classnames2.default)({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'control-label', 'col-sm-4');
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactBootstrap.Row,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 12 },
	        props.meta.touched && props.meta.error && _react2.default.createElement(
	          'span',
	          { className: 'parsley-error-message' },
	          props.meta.error
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Row,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 5 },
	        _react2.default.createElement(
	          'label',
	          { className: 'default-address' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'default_address' })
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 2 },
	        _react2.default.createElement(
	          'label',
	          null,
	          _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { type: 'radio', value: true, checked: props.input.value == true || props.input.value == "true" })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'yes' })
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { sm: 2 },
	        _react2.default.createElement(
	          'label',
	          null,
	          _react2.default.createElement(_reactBootstrap.Input, _extends({}, props.input, { type: 'radio', value: false, checked: props.input.value == false || props.input.value == "false" })),
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no' })
	        )
	      )
	    )
	  );
	};
	
	var renderShipping = function (_Component) {
	  _inherits(renderShipping, _Component);
	
	  function renderShipping() {
	    _classCallCheck(this, renderShipping);
	
	    var _this = _possibleConstructorReturn(this, (renderShipping.__proto__ || Object.getPrototypeOf(renderShipping)).call(this));
	
	    _this.state = {
	      ptModalOpen: false,
	      fjCustomerId: ""
	    };
	    return _this;
	  }
	
	  _createClass(renderShipping, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {}
	  }, {
	    key: 'copyBillingToShipping',
	    value: function copyBillingToShipping(e) {
	      e.preventDefault();
	      var shipping = (0, _cloneDeep2.default)(this.props.billing);
	      shipping.VendorDetail_id = undefined;
	      this.props.changeFieldArrayOfForm('Shipping', 0, shipping, 'vendorDetailForm');
	    }
	  }, {
	    key: 'renderDeleteButton',
	    value: function renderDeleteButton(index, fields) {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'danger',
	          className: 'trash',
	          type: 'reset',
	          onClick: function onClick() {
	            fields.remove(index);
	          } },
	        _react2.default.createElement('em', { className: 'fa fa-trash-o' })
	      );
	    }
	  }, {
	    key: 'renderAutoFillButton',
	    value: function renderAutoFillButton() {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'default',
	          className: 'auto-fill',
	          type: 'button',
	          onClick: this.copyBillingToShipping.bind(this) },
	        _react2.default.createElement('em', { className: 'fa fa-edit' }),
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'auto_fill' })
	      );
	    }
	  }, {
	    key: 'renderAddress',
	    value: function renderAddress(Shipping, index) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'form-horizontal' },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-2' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 10 },
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.AddressName', component: _inputField.InputField })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'form-horizontal' },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { className: 'col-sm-2' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'street' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'asteriksReq' },
	                '*'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 10 },
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.Street', component: _inputField.InputField })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 6 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'asteriksReq' },
	                  '*'
	                )
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.City', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'state' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'asteriksReq' },
	                  '*'
	                )
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.State', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 3 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zip' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'asteriksReq' },
	                  '*'
	                )
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.Zip', component: _inputField.InputField })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'first_name' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.FirstName', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_name' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.LastName', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tel' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.Telephone', component: _inputField.InputField })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 8 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.Email', component: _inputField.InputField })
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 4 },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fax' })
	              ),
	              _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.Fax', component: _inputField.InputField })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var fields = this.props.fields;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'primary',
	            className: 'plus',
	            type: 'button',
	            onClick: function onClick() {
	              fields.push({}); // pushes empty child field onto the end of the array
	            } },
	          _react2.default.createElement('em', { className: 'fa fa-plus' })
	        ),
	        !fields.length && _react2.default.createElement(
	          'div',
	          { className: 'marginTopStyle' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'no_shipping_information' })
	        ),
	        fields.map(function (Shipping, index) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              { key: index },
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 12 },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'position-relative' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping' }),
	                    ' #',
	                    index + 1
	                  ),
	                  index === 0 && _this2.renderAutoFillButton(),
	                  _this2.renderDeleteButton(index, fields)
	                ),
	                _this2.renderAddress(Shipping, index),
	                _react2.default.createElement(_reduxForm.Field, { name: Shipping + '.IsDefault', component: renderIsDefault })
	              )
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return renderShipping;
	}(_react.Component);
	
	var VendorDetailForm = function (_Component2) {
	  _inherits(VendorDetailForm, _Component2);
	
	  function VendorDetailForm() {
	    _classCallCheck(this, VendorDetailForm);
	
	    var _this3 = _possibleConstructorReturn(this, (VendorDetailForm.__proto__ || Object.getPrototypeOf(VendorDetailForm)).call(this));
	
	    _this3.state = {
	      dirty: false,
	      case: "paymentTermMissing",
	      vendorImg: []
	    };
	    _this3.openConfirm = _this3.openConfirm.bind(_this3);
	    _this3.closeConfirm = _this3.closeConfirm.bind(_this3);
	    return _this3;
	  }
	
	  _createClass(VendorDetailForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // reset('productForm');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this4 = this;
	
	      var currentVendor = this.props.currentVendor;
	
	      if (currentVendor) {
	        this.setState({ fjCustomerId: currentVendor.Vendor_id });
	        this.props.fetchVendorDetail(currentVendor.Vendor_id).then(function () {
	          return _this4.props.fetchPaymentTerms();
	        });
	      } else {
	        this.props.fetchPaymentTerms();
	        this.props.setDefaultOfForm('IsActive', "false", 'vendorDetailForm');
	      }
	      // making a leaving hook to confirm leaving
	      this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
	
	      if (isMAG && currentVendor && currentVendor.Vendor_id) {
	        this.state.vendorImg = [];
	        _axios2.default.get(_root_url.ROOT_URL + 'v2/upload-vendor-img/' + currentVendor.Vendor_id, {
	          headers: {
	            Authorization: 'Bearer ' + localStorage.getItem("token")
	          }
	        }).then(function (res) {
	          res.data.map(function (r) {
	            _this4.state.vendorImg.push(r);
	          });
	        }, function (err) {
	          if (err.data) {
	            alert(err.data);
	          } else {
	            alert("Server issue detected, please contact admin.");
	          }
	        });
	      }
	      if (_root_url.isEcity) {
	        this.props.fetchDefaultBuyers();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      // reset('productForm');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.dirty != this.props.dirty) {
	        this.setState({
	          dirty: nextProps.dirty
	        });
	      }
	      if (nextProps.isActive && nextProps.isActive != this.props.isActive) {
	        console.log("is active", nextProps.isActive);
	      }
	      if ((nextProps.isActive === true || nextProps.isActive === "true") && nextProps.isActive != this.props.isActive) {
	        if (!this.props.paymentTerm_id && !nextProps.paymentTerm_id) {
	          this.props.setDefaultOfForm('IsActive', "false", 'vendorDetailForm');
	          this.openConfirm();
	        }
	      }
	      if (nextProps.paymentTerm_id != this.props.paymentTerm_id) {
	        if (!nextProps.paymentTerm_id || nextProps.paymentTerm_id.length === 0) {
	          this.props.setDefaultOfForm('IsActive', "false", 'vendorDetailForm');
	          this.props.setDefaultOfForm('PaymentTerm_id', null, 'vendorDetailForm');
	          this.openConfirm();
	        }
	      }
	      if (this.props.default_purchaser_user_id !== nextProps.default_purchaser_user_id) {
	        this.props.setDefaultOfForm('default_purchaser_user_id', nextProps.default_purchaser_user_id, 'vendorDetailForm');
	      }
	    }
	  }, {
	    key: 'routerWillLeave',
	    value: function routerWillLeave(nextLocation) {
	      if (this.state.dirty) return 'Your work is not saved! Are you sure you want to leave?';
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      this.setState({ dirty: false });
	      if (!this.props.currentVendor) this.props.createVendor(formProps);else {
	        if (!this.checkPermission("change_vendor")) this.props.editVendor(formProps);else alert("You have no permission!");
	      }
	    }
	  }, {
	    key: 'openConfirm',
	    value: function openConfirm() {
	      this.setState({ confirmOpen: true });
	    }
	  }, {
	    key: 'closeConfirm',
	    value: function closeConfirm() {
	      this.setState({ confirmOpen: false });
	    }
	  }, {
	    key: 'openPTModal',
	    value: function openPTModal() {
	      this.setState({ ptModalOpen: true });
	    }
	  }, {
	    key: 'closePTModal',
	    value: function closePTModal() {
	      this.setState({ ptModalOpen: false });
	    }
	  }, {
	    key: 'vendorImgDelete',
	    value: function vendorImgDelete(id) {
	      var _this5 = this;
	
	      var currentVendor = this.props.currentVendor;
	      var vendorImg = this.state.vendorImg;
	
	      _axios2.default.delete(_root_url.ROOT_URL + 'v2/upload-vendor-img/' + id, {
	        headers: {
	          Authorization: 'Bearer ' + localStorage.getItem("token")
	        }
	      }).then(function (res) {
	        alert("delete successful");
	
	        vendorImg = [];
	
	        _axios2.default.get(_root_url.ROOT_URL + 'v2/upload-vendor-img/' + currentVendor.Vendor_id, {
	          headers: {
	            Authorization: 'Bearer ' + localStorage.getItem("token")
	          }
	        }).then(function (res) {
	          res.data.map(function (r) {
	            vendorImg.push(r);
	          });
	          _this5.setState({ vendorImg: vendorImg });
	        }, function (err) {
	          if (err.data) {
	            alert(err.data);
	          } else {
	            alert("Server issue detected, please contact admin.");
	          }
	        });
	      }, function (err) {
	        if (err.data) {
	          alert(err.data);
	        } else {
	          alert("Server issue detected, please contact admin.");
	        }
	      });
	    }
	  }, {
	    key: 'breadcrumb',
	    value: function breadcrumb() {
	      if (!this.props.params.id) {
	        return _react2.default.createElement(
	          _reactBootstrap.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            null,
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_management' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb.Item,
	            { active: 'true' },
	            _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create_vendor' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Breadcrumb,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb.Item,
	          null,
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_management' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Breadcrumb.Item,
	          { active: 'true' },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit_vendor' })
	        )
	      );
	    }
	  }, {
	    key: 'renderPaymentTerms',
	    value: function renderPaymentTerms() {
	      if (this.props.paymentTermsIsLoading) return _react2.default.createElement(_spinner2.default, null); // If payment term is loading, show a spinner.
	      else {
	          var paymentTermOptions = this.getPaymentTermOptions();
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reduxForm.Field, { name: 'PaymentTerm_id', component: _selection2.default, options: paymentTermOptions })
	          );
	        }
	    }
	  }, {
	    key: 'renderVendorImg',
	    value: function renderVendorImg(info, type) {
	      var _this6 = this;
	
	      var vendorImg = this.state.vendorImg;
	
	
	      return true && _react2.default.createElement(
	        'div',
	        null,
	        (0, _map2.default)(vendorImg, function (r, index) {
	          return true ? _react2.default.createElement(
	            _reactBootstrap.Col,
	            { sm: 12, key: index, style: { marginBottom: '5px', fontSize: '15px', display: 'flex', justifyContent: 'space-between' } },
	            _react2.default.createElement(
	              'a',
	              { href: r.file_url },
	              r.filename
	            ),
	            _react2.default.createElement(
	              'span',
	              { style: { color: 'red', cursor: 'pointer' }, onClick: function onClick() {
	                  return _this6.vendorImgDelete(r.id);
	                } },
	              'Delete'
	            )
	          ) : _react2.default.createElement('div', { key: index });
	        })
	      );
	    }
	  }, {
	    key: 'getPaymentTermOptions',
	    value: function getPaymentTermOptions() {
	      var paymentTermOptions = [];
	      this.props.paymentTerms.map(function (paymentTerm) {
	        paymentTermOptions.push({ value: paymentTerm.PaymentTerm_id, label: paymentTerm.Name });
	      });
	      return paymentTermOptions;
	    }
	  }, {
	    key: 'copyBillingToMailing',
	    value: function copyBillingToMailing(e) {
	      e.preventDefault();
	      if (this.props.billing) {
	        this.props.setDefaultOfForm('Mailing', this.props.billing, 'vendorDetailForm');
	      }
	    }
	  }, {
	    key: 'checkPermission',
	    value: function checkPermission(permission) {
	      return false;
	    }
	  }, {
	    key: 'getDefaultPurchaserOptions',
	    value: function getDefaultPurchaserOptions() {
	      var purchaserUserOptions = [];
	      (this.props.defaultBuyers || []).forEach(function (defaultBuyer) {
	        purchaserUserOptions.push({
	          value: defaultBuyer.BaseUser_id,
	          label: defaultBuyer.username
	        });
	      });
	      return purchaserUserOptions;
	    }
	  }, {
	    key: 'renderDefaultPurchaser',
	    value: function renderDefaultPurchaser() {
	      var defaultPurchaserOptions = this.getDefaultPurchaserOptions();
	      return _react2.default.createElement(_reduxForm.Field, { name: 'default_purchaser_user_id', component: _selection2.default, options: defaultPurchaserOptions });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var vendorDetails = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_details' })
	      );
	      var billingDetails = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'billing_details' })
	      );
	      var mailingDetails = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'mailing_details' })
	      );
	      var shippingDetails = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_details' })
	      );
	      var vendorImages = _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_images' })
	      );
	      var activeVendor = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'active_vendor' });
	      var confirmAction = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm_action' });
	      var priceTable = _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_price_table' });
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          submitting = _props.submitting,
	          pristine = _props.pristine;
	
	      var createDialogStyle = {
	        height: '600px',
	        marginTop: '-20%',
	        width: '680px',
	        marginLeft: '-10%',
	        left: '45%'
	      };
	      var createDialogStylePT = {
	        height: '600px',
	        marginTop: '-20%',
	        width: '600px',
	        marginLeft: '-10%',
	        left: '45%'
	      };
	      if (this.props.detailIsLoading && !this.props.detailError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement('br', null),
	        '...reading data'
	      );else if (this.props.detailError) return _react2.default.createElement(
	        _ContentWrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert alert-danger' },
	          JSON.stringify(this.props.error)
	        )
	      );else {
	        return (
	          //---------------
	          // Begin HTML
	          //---------------
	          _react2.default.createElement(
	            _ContentWrapper2.default,
	            null,
	            _react2.default.createElement(
	              'form',
	              { method: 'get', action: '#', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	              this.breadcrumb(),
	              _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                null,
	                isMAG && true && _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'success',
	                    type: 'submit',
	                    onClick: function onClick(e) {
	                      e.preventDefault();
	                      _this7.refs.msoCreateInputRef2.click();
	                    },
	                    disabled: this.context.router.routes[1].path === 'vendors/new'
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'upload_id' })
	                ),
	                isMAG && true && _react2.default.createElement('input', {
	                  type: 'file',
	                  multiple: true,
	                  style: { display: "none" },
	                  onClick: function onClick(e) {
	                    e.target.value = null;
	                  },
	                  onChange: function onChange(e) {
	                    var currentVendor = _this7.props.currentVendor;
	
	                    var formData = new FormData();
	                    var vendorImg = _this7.state.vendorImg;
	
	                    formData.append("FILE", e.target.files[0]);
	                    if (e.target.files[0]) {
	                      _axios2.default.post(_root_url.ROOT_URL + 'v2/upload-vendor-img/' + currentVendor.Vendor_id, formData, {
	                        headers: {
	                          Authorization: 'Bearer ' + localStorage.getItem("token")
	                        }
	                      }).then(function (res) {
	                        alert("Upload successful");
	                        vendorImg = [];
	                        _axios2.default.get(_root_url.ROOT_URL + 'v2/upload-vendor-img/' + currentVendor.Vendor_id, {
	                          headers: {
	                            Authorization: 'Bearer ' + localStorage.getItem("token")
	                          }
	                        }).then(function (res) {
	                          res.data.map(function (r) {
	                            vendorImg.push(r);
	                          });
	                          _this7.setState({ vendorImg: vendorImg });
	                        }, function (err) {
	                          if (err.data) {
	                            alert(err.data);
	                          } else {
	                            alert("Server issue detected, please contact admin.");
	                          }
	                        });
	
	                        // refresh here
	                      }, function (err) {
	                        if (err.data) {
	                          alert(err.data);
	                        } else {
	                          alert("Server issue detected, please contact admin.");
	                        }
	                      });
	                    }
	                  },
	                  ref: 'msoCreateInputRef2'
	                }),
	                isMAG && _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'success',
	                    type: 'button',
	                    onClick: function onClick() {
	                      return _this7.openPTModal();
	                    },
	                    disabled: this.context.router.routes[1].path === 'vendors/new'
	                  },
	                  _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'price_table' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'success',
	                    type: 'submit',
	                    action: 'submit' },
	                  _react2.default.createElement('em', { className: 'fa fa-save' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'save' })
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'danger',
	                    type: 'reset',
	                    href: '/vendors' },
	                  _react2.default.createElement('em', { className: 'fa fa-close' }),
	                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'cancel' })
	                )
	              ),
	              ' ',
	              _react2.default.createElement(
	                _reactBootstrap.Grid,
	                { id: 'vendor-form' },
	                _react2.default.createElement(
	                  _reactBootstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 8 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                          _reactBootstrap.Panel,
	                          { id: 'vendor-details', style: { height: _root_url.isEcity ? '270px' : '220px' }, header: vendorDetails },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: 8 },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'asteriksReq' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Name', component: _inputField.InputField })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' })
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Description', component: _inputField.InputField })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: 4 },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term' })
	                                ),
	                                this.renderPaymentTerms()
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit_status' })
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'CreditStatus', component: _inputField.InputField })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: 8 },
	                              _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { sm: 6 },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_no' }),
	                                      _react2.default.createElement(
	                                        'span',
	                                        { className: 'asteriksReq' },
	                                        '*'
	                                      )
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'VendorNum', component: _inputField.InputField })
	                                  )
	                                ),
	
	                                // !isMAG &&
	                                true && _react2.default.createElement(
	                                  _reactBootstrap.Col,
	                                  { sm: 6 },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'ref_num' })
	                                    ),
	                                    _react2.default.createElement(_reduxForm.Field, { name: 'RefNum', component: _inputField.InputField })
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: 4 },
	                              _react2.default.createElement(_reduxForm.Field, { name: 'IsActive', labelName: activeVendor, component: _isActive2.default })
	                            ),
	                            _root_url.isEcity && _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: 6 },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'default_purchaser' })
	                                ),
	                                this.renderDefaultPurchaser()
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      ' ',
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(
	                          _reactBootstrap.Panel,
	                          { id: 'billing-details', header: billingDetails },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'form-horizontal' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-10' },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Billing.AddressName', component: _inputField.InputField })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'form-horizontal' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'street' }),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'asteriksReq' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-10' },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Billing.Street', component: _inputField.InputField })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: 6 },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'asteriksReq' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Billing.City', component: _inputField.InputField })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: 3 },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'state' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'asteriksReq' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Billing.State', component: _inputField.InputField })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: 3 },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zip' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'asteriksReq' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Billing.Zip', component: _inputField.InputField })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: isTQ || isOCM ? 6 : 4 },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'first_name' })
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Billing.FirstName', component: _inputField.InputField })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: isTQ || isOCM ? 6 : 4 },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_name' })
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Billing.LastName', component: _inputField.InputField })
	                              )
	                            ),
	                            !(isTQ || isOCM) && _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: 4 },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tel' })
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Billing.Telephone', component: _inputField.InputField })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            !(isTQ || isOCM) && _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: 8 },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' })
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Billing.Email', component: _inputField.InputField })
	                              )
	                            ),
	                            (isTQ || isOCM) && _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: 8 },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tel' })
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Billing.Telephone', component: _inputField.InputField })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: 4 },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fax' })
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Billing.Fax', component: _inputField.InputField })
	                              )
	                            )
	                          ),
	                          (isTQ || isOCM) && _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: 12 },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' })
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'asteriksReq' },
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'press_enter_for_emails' })
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, {
	                                  name: 'Billing.Email',
	                                  component: 'Textarea',
	                                  className: 'form-control resize-vertical',
	                                  style: { minHeight: '40px' },
	                                  resize: 'vertical'
	                                })
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      ' ',
	                      _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(
	                          _reactBootstrap.Panel,
	                          { id: 'mailing-details', header: mailingDetails },
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'form-horizontal' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' })
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Mailing.AddressName', component: _inputField.InputField })
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 4 },
	                                _react2.default.createElement(
	                                  _reactBootstrap.Button,
	                                  {
	                                    bsStyle: 'default',
	                                    className: 'auto-fill',
	                                    type: 'button',
	                                    onClick: this.copyBillingToMailing.bind(this) },
	                                  _react2.default.createElement('em', { className: 'fa fa-edit' }),
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'auto_fill' })
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'form-horizontal' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form-group' },
	                              _react2.default.createElement(
	                                'label',
	                                { className: 'col-sm-2' },
	                                _react2.default.createElement(_reactReduxI18n.Translate, { value: 'street' }),
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'asteriksReq' },
	                                  '*'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 10 },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Mailing.Street', component: _inputField.InputField })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: 6 },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'city' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'asteriksReq' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Mailing.City', component: _inputField.InputField })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: 3 },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'state' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'asteriksReq' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Mailing.State', component: _inputField.InputField })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: 3 },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'zip' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'asteriksReq' },
	                                    '*'
	                                  )
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Mailing.Zip', component: _inputField.InputField })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: 4 },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'first_name' })
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Mailing.FirstName', component: _inputField.InputField })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: 4 },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'last_name' })
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Mailing.LastName', component: _inputField.InputField })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: 4 },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'tel' })
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Mailing.Telephone', component: _inputField.InputField })
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: 8 },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'email' })
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Mailing.Email', component: _inputField.InputField })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactBootstrap.Col,
	                              { sm: 4 },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  _react2.default.createElement(_reactReduxI18n.Translate, { value: 'fax' })
	                                ),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'Mailing.Fax', component: _inputField.InputField })
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      ' '
	                    )
	                  ),
	                  ' ',
	                  _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 4 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Panel,
	                      { id: 'shipping-details', header: shippingDetails },
	                      _react2.default.createElement(
	                        'h3',
	                        null,
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'shipping_info' })
	                      ),
	                      _react2.default.createElement(_reduxForm.FieldArray, {
	                        name: 'Shipping',
	                        component: renderShipping,
	                        shipping: this.props.shipping,
	                        billing: this.props.billing
	                        // currentShipping={ this.props.currentVendorDetail ? this.props.currentVendorDetail.Shipping:[]}
	                        , changeFieldArrayOfForm: this.props.changeFieldArrayOfForm
	                      })
	                    )
	                  ),
	                  ' ',
	                  isMAG && _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 4 },
	                    _react2.default.createElement(
	                      _reactBootstrap.Panel,
	                      { id: 'vendor-img', header: vendorImages },
	                      _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        this.renderVendorImg()
	                      )
	                    )
	                  )
	                ),
	                ' ',
	                this.props.isCreating || this.props.isEditing && _react2.default.createElement(_spinner2.default, null)
	              ),
	              _react2.default.createElement(
	                _reactSkylight.SkyLightStateless,
	                { dialogStyles: createDialogStyle, isVisible: this.state.confirmOpen, onCloseClicked: function onCloseClicked() {
	                    _this7.closeConfirm();
	                  }, title: confirmAction },
	                _react2.default.createElement(_confirmActionModal2.default, { 'case': this.state.case, closeC: this.closeConfirm })
	              ),
	              _react2.default.createElement(
	                _reactSkylight.SkyLightStateless,
	                { dialogStyles: createDialogStylePT, isVisible: this.state.ptModalOpen, onCloseClicked: function onCloseClicked() {
	                    _this7.closePTModal();
	                  }, title: priceTable },
	                _react2.default.createElement(_priceTableModal.PriceTableModal, {
	                  fjCustomerId: this.state.fjCustomerId,
	                  fetchPT: this.props.fetchPT,
	                  updatePT: this.props.updatePT
	                  // deleteFJAgents = {this.props.deleteFJAgents}
	                  , closePTModal: this.closePTModal,
	                  type: 'Vendor'
	                })
	              )
	            )
	          )
	          //---------------
	          // End HTML
	          //---------------
	
	        );
	      }
	    }
	  }]);
	
	  return VendorDetailForm;
	}(_react.Component);
	
	VendorDetailForm.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var _default = (0, _reactRouter.withRouter)(VendorDetailForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(isTQ, 'isTQ', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Vendors/vendorDetailForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isOCM, 'isOCM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Vendors/vendorDetailForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isMAG, 'isMAG', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Vendors/vendorDetailForm.jsx');
	
	  __REACT_HOT_LOADER__.register(renderIsDefault, 'renderIsDefault', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Vendors/vendorDetailForm.jsx');
	
	  __REACT_HOT_LOADER__.register(renderShipping, 'renderShipping', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Vendors/vendorDetailForm.jsx');
	
	  __REACT_HOT_LOADER__.register(VendorDetailForm, 'VendorDetailForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Vendors/vendorDetailForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Vendors/vendorDetailForm.jsx');
	}();

	;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(7);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(5);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactDropzone = __webpack_require__(45);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _constants = __webpack_require__(11);
	
	var _permissions = __webpack_require__(24);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _FilterToolbar = __webpack_require__(149);
	
	var _FilterToolbar2 = _interopRequireDefault(_FilterToolbar);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _spinner = __webpack_require__(10);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Vendors = function (_Component) {
	  _inherits(Vendors, _Component);
	
	  function Vendors() {
	    _classCallCheck(this, Vendors);
	
	    var _this = _possibleConstructorReturn(this, (Vendors.__proto__ || Object.getPrototypeOf(Vendors)).call(this));
	
	    _this.state = {
	      tableHeight: window.innerHeight - _constants.UI_HEIGHT.customersPage,
	
	      rows: [],
	      selectedRows: null,
	      filters: {},
	      sortColumn: null,
	      sortDirection: null,
	      files: null
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    return _this;
	  }
	
	  _createClass(Vendors, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.title = _root_url.companyCodeTitle;
	      window.addEventListener('resize', this.handleResize);
	      this.props.fetchVendors();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	
	    // Once vendors ready, reset state.
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.vendors && nextProps.vendors != this.props.vendors) {
	        this.setState({ rows: nextProps.vendors });
	      }
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      this.setState({ tableHeight: window.innerHeight - _constants.UI_HEIGHT.customersPage });
	    }
	
	    // Set vendor being selected to be currentVendor and navigate user to the edit page
	
	  }, {
	    key: 'onDrop',
	    value: function onDrop(files) {
	      if (files) {
	        alert('Upload takes time, please stay on the current page');
	      }
	      this.props.attachDocument(files);
	      this.setState({ files: files });
	    }
	  }, {
	    key: 'setCurrentVendor',
	    value: function setCurrentVendor(e) {
	      e.preventDefault();
	      var currentVendor = this.state.selectedRows[0];
	      this.props.resetCurrentVendor();
	      this.props.selectVendor(currentVendor);
	      this.context.router.push('/vendors/' + currentVendor.Vendor_id);
	    }
	  }, {
	    key: 'clickNew',
	    value: function clickNew(e) {
	      e.preventDefault();
	      this.props.resetCurrentVendor();
	      this.context.router.push('/vendors/new');
	    }
	
	    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
	
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this2 = this;
	
	      if (this.props.isLoading && !this.props.error) {
	        return _react2.default.createElement(_spinner2.default, null);
	      } else if (this.props.error) {
	        return _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            JSON.stringify(this.props.error)
	          )
	        );
	      } else {
	        // Parameters of the react-data-grid
	
	        var getRows = function getRows() {
	          return _reactDataGridAddons.Data.Selectors.getRows(_this2.state);
	        };
	
	        var getSize = function getSize() {
	          return getRows().length;
	        };
	
	        var rowGetter = function rowGetter(rowIdx) {
	          var rows = getRows();
	          return rows[rowIdx];
	        };
	
	        // Handle the sortable function
	
	        var handleGridSort = function handleGridSort(sortColumn, sortDirection) {
	          var state = Object.assign({}, _this2.state, { sortColumn: sortColumn, sortDirection: sortDirection });
	          _this2.setState(state);
	        };
	
	        var handleFilterChange = function handleFilterChange(filter) {
	          var newFilters = Object.assign({}, _this2.state.filters);
	          if (filter.filterTerm) {
	            newFilters[filter.column.key] = filter;
	          } else {
	            delete newFilters[filter.column.key];
	          }
	          _this2.setState({ filters: newFilters });
	        };
	
	        //Custom Formatter component
	        var IsActiveFormatter = _react2.default.createClass({
	          displayName: 'IsActiveFormatter',
	          render: function render() {
	            if (this.props.value) return _react2.default.createElement(
	              'span',
	              { className: 'label label-success' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'active' })
	            );else return _react2.default.createElement(
	              'span',
	              { className: 'label label-danger' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'inactive' })
	            );
	          }
	        });
	
	        // Handle the row select function
	
	        var onRowSelect = function onRowSelect(rows) {
	          _this2.setState({ selectedRows: rows });
	        };
	
	        // Column difinition
	
	        var columns = [{
	          key: 'VendorNum',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor_no' }),
	          width: 125,
	          resizable: true,
	          sortable: true,
	          filterable: true
	        }, {
	          key: 'Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'name' }),
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          width: 250
	        }, {
	          key: 'Description',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'description' }),
	          width: 200,
	          resizable: true,
	          sortable: true,
	          filterable: true
	        }, {
	          key: 'PaymentTerm_id__Name',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'payment_term' }),
	          width: 120,
	          resizable: true,
	          sortable: true,
	          filterable: true
	        }, {
	          key: 'CreditStatus',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'credit_status' }),
	          width: 120,
	          resizable: true,
	          sortable: true,
	          filterable: true
	        }, {
	          key: 'IsActive',
	          name: _react2.default.createElement(_reactReduxI18n.Translate, { value: 'active' }),
	          width: 65,
	          resizable: true,
	          sortable: true,
	          filterable: true,
	          formatter: IsActiveFormatter
	        }];
	
	        return (
	          //React Table Vendors List
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 12 },
	              _react2.default.createElement(
	                'div',
	                { id: 'Vendors-dataGrid1' },
	                _react2.default.createElement(_reactDataGrid2.default, {
	                  rowKey: 'Vendor_id',
	                  enableCellSelect: true,
	                  onGridSort: handleGridSort,
	                  toolbar: _react2.default.createElement(_FilterToolbar2.default, { enableFilter: true }),
	                  onAddFilter: handleFilterChange,
	                  columns: columns,
	                  rowHeight: 25,
	                  headerRowHeight: 45,
	                  rowGetter: rowGetter,
	                  rowsCount: getSize(),
	                  minHeight: this.state.tableHeight,
	                  enableRowSelect: 'single',
	                  onRowUpdated: this.handleRowUpdated,
	                  onRowSelect: onRowSelect
	                })
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var height = (this.state.tableHeight + 70).toString();
	      var tableCollapseFix = { height: height };
	      var excelUrl = _root_url.ROOT_URL + 'v1/vendor/export/?Bearer=' + localStorage.getItem('token');
	      var excelUrlBarcode = _root_url.ROOT_URL + 'v1/vendor/export-product-barcode/' + (this.state.selectedRows && this.state.selectedRows[0].Vendor_id) + '/?Bearer=' + localStorage.getItem('token');
	      return (
	        //---------------
	        // Begin HTML
	        //---------------
	        _react2.default.createElement(
	          _ContentWrapper2.default,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'general_management' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: 'true' },
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'vendor' })
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            _reactBootstrap.Grid,
	            { fluid: 'true', id: 'vendors-page' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              _react2.default.createElement(_reactReduxI18n.Translate, { value: 'manage_vendors' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Col,
	                { md: 12 },
	                _react2.default.createElement(
	                  _reactBootstrap.Panel,
	                  { className: 'position-relative', style: tableCollapseFix },
	                  _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    { className: 'table-buttons', style: { display: 'flex' } },
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'success',
	                        type: 'submit',
	                        onClick: function onClick(event) {
	                          _this3.clickNew(event);
	                        },
	                        disabled: !(0, _permissions2.default)("add_vendor")
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-plus' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'create' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'warning',
	                        onClick: function onClick(event) {
	                          _this3.setCurrentVendor(event);
	                        },
	                        disabled: !this.state.selectedRows || this.state.selectedRows.length != 1 || !(0, _permissions2.default)("change_vendor")
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-pencil' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'edit' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'success',
	                        type: 'button',
	                        href: excelUrl
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-download' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'excel' })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: 'success',
	                        type: 'button'
	                        //   onClick={(event) => { console.log('this.state', this.state) } }
	                        , disabled: !this.state.selectedRows || this.state.selectedRows.length != 1,
	                        href: excelUrlBarcode
	                      },
	                      _react2.default.createElement('em', { className: 'fa fa-download' }),
	                      _react2.default.createElement(_reactReduxI18n.Translate, { value: 'barcode_export' })
	                    ),
	                    _react2.default.createElement(
	                      _reactDropzone2.default,
	                      { onDrop: this.onDrop.bind(this), style: { 'padding-left': '5px' }, className: 'upload-button' },
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { bsStyle: 'primary' },
	                        _react2.default.createElement('em', { className: 'fa fa-file-text' }),
	                        _react2.default.createElement(_reactReduxI18n.Translate, { value: 'upload_import' })
	                      )
	                    )
	                  ),
	                  this.renderTable()
	                )
	              )
	            )
	          )
	        )
	        //---------------
	        // End HTML
	        //---------------
	
	      );
	    }
	  }]);
	
	  return Vendors;
	}(_react.Component);
	
	Vendors.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var _default = Vendors;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Vendors, 'Vendors', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Vendors/vendors.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/Vendors/vendors.jsx');
	}();

	;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(4);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _reactSkylight = __webpack_require__(15);
	
	var _ContentWrapper = __webpack_require__(8);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  marginLeft: '10%',
	  marginRight: '10%',
	  textAlign: 'center',
	  fontSize: '25px'
	};
	
	var buttonWrapperStyle = {
	  display: 'flex',
	  textAlign: 'center',
	  alignItems: 'center',
	  justifyContent: 'center',
	  marginLeft: '0px'
	};
	
	var notifyModalStyle = {
	  width: '400px',
	  height: '250px',
	  marginLeft: '-15%'
	};
	
	var Modal = function Modal(_ref) {
	  var content = _ref.content,
	      onConfirm = _ref.onConfirm,
	      onCancel = _ref.onCancel;
	  return _react2.default.createElement(
	    _ContentWrapper2.default,
	    null,
	    _react2.default.createElement(
	      _reactBootstrap.Row,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 12, style: { padding: '20px' } },
	        _react2.default.createElement(
	          'div',
	          { style: styles },
	          content
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Row,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 12, style: buttonWrapperStyle },
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'btn btn-primary col-sm-6 buttonStyle',
	            onClick: onConfirm
	          },
	          _react2.default.createElement(_reactReduxI18n.Translate, { value: 'confirm' })
	        )
	      )
	    )
	  );
	};
	
	var NotifyModal = function NotifyModal(_ref2) {
	  var title = _ref2.title,
	      content = _ref2.content,
	      onConfirm = _ref2.onConfirm,
	      onCancel = _ref2.onCancel,
	      isVisible = _ref2.isVisible;
	  return _react2.default.createElement(
	    _reactSkylight.SkyLightStateless,
	    {
	      dialogStyles: notifyModalStyle,
	      isVisible: isVisible,
	      onCloseClicked: onCancel,
	      title: title
	    },
	    _react2.default.createElement(Modal, {
	      content: content,
	      onConfirm: onConfirm,
	      onCancel: onCancel
	    })
	  );
	};
	
	var _default = NotifyModal;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/common/notifyModal.jsx');
	
	  __REACT_HOT_LOADER__.register(buttonWrapperStyle, 'buttonWrapperStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/common/notifyModal.jsx');
	
	  __REACT_HOT_LOADER__.register(notifyModalStyle, 'notifyModalStyle', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/common/notifyModal.jsx');
	
	  __REACT_HOT_LOADER__.register(Modal, 'Modal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/common/notifyModal.jsx');
	
	  __REACT_HOT_LOADER__.register(NotifyModal, 'NotifyModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/common/notifyModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/components/common/notifyModal.jsx');
	}();

	;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _APDetail = __webpack_require__(214);
	
	var _APDetail2 = _interopRequireDefault(_APDetail);
	
	var _vendors_actions = __webpack_require__(46);
	
	var _arap_actions = __webpack_require__(43);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _settings_actions = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var isNumeric = function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	};
	
	var validate = function validate(values, props) {
	  var errors = {};
	
	  if (values.TotalPayment && !isNumeric(values.TotalPayment)) {
	    errors.TotalPayment = 'Accept number only!';
	  }
	
	  if (values.TotalPayment <= 0) {
	    errors.TotalPayment = 'Positive number only!';
	  }
	
	  if (values.Discount && !isNumeric(values.Discount)) {
	    errors.Discount = 'Accept number only!';
	  }
	
	  if (values.Discount && values.Discount < 0) {
	    errors.Discount = 'Positive number only!';
	  }
	
	  if (!values.Vendor) {
	    errors.Vendor = 'Required';
	  }
	
	  if (!values.Account) {
	    errors.Account = 'Required';
	  }
	
	  if (!values.TotalPayment) {
	    errors.TotalPayment = 'Required';
	  }
	
	  if (!values.Method) {
	    errors.Method = 'Required';
	  }
	
	  return errors;
	};
	
	var apDetail = (0, _reduxForm.reduxForm)({
	  form: 'apDetail',
	  enableReinitialize: true,
	  destroyOnUnmount: false,
	  touchOnChange: true,
	  touchOnBlur: false,
	  validate: validate
	})(_APDetail2.default);
	var selector = (0, _reduxForm.formValueSelector)('apDetail');
	
	function mapStateToProps(state) {
	  var _ref;
	
	  var vendor_id = selector(state, 'Vendor');
	  var credits = selector(state, 'Credits');
	
	  var invoiceDate = selector(state, 'InvoiceDate');
	  var fromDate = selector(state, 'FromDate');
	  var toDate = selector(state, 'ToDate');
	
	  var invoiceDateBySequence = selector(state, 'InvoiceDateBySequence');
	  var fromDateBySequence = selector(state, 'FromDateBySequence');
	  var toDateBySequence = selector(state, 'ToDateBySequence');
	
	  var method = selector(state, 'Method');
	  var checkNum = selector(state, 'CheckNum');
	  var account = selector(state, 'Account');
	  var discount = selector(state, 'Discount');
	  var totalPayment = selector(state, 'TotalPayment');
	  var waive = selector(state, 'Waive');
	  var note = selector(state, 'Note');
	  return _ref = {
	    vendor_id: vendor_id,
	    credits: credits,
	    invoiceDate: invoiceDate,
	    fromDate: fromDate,
	    toDate: toDate,
	    invoiceDateBySequence: invoiceDateBySequence,
	    fromDateBySequence: fromDateBySequence,
	    toDateBySequence: toDateBySequence,
	    method: method,
	    checkNum: checkNum,
	    account: account,
	    discount: discount,
	    totalPayment: totalPayment,
	    waive: waive,
	    note: note,
	    invoices: state.arap.invoices,
	    invoicesIsLoading: state.arap.invoicesIsLoading,
	    invoicesError: state.arap.invoicesError,
	    apCreated: state.arap.apCreated,
	    apEdited: state.arap.apEdited,
	    apCreateError: state.arap.apCreateError,
	    apEditError: state.arap.apEditError,
	    apIsCreating: state.arap.apIsCreating,
	    apIsEditing: state.arap.apIsEditing,
	    apDetail: state.arap.apDetail,
	    initialValues: state.arap.apDetail
	
	  }, _defineProperty(_ref, 'credits', state.arap.credits), _defineProperty(_ref, 'creditsIsLoading', state.arap.creditsIsLoading), _defineProperty(_ref, 'creditsError', state.arap.creditsError), _defineProperty(_ref, 'vendors', state.vendors.all), _defineProperty(_ref, 'vendorsIsLoading', state.vendors.isLoading), _defineProperty(_ref, 'vendorsError', state.vendors.error), _defineProperty(_ref, 'currentVendorDetail', state.vendors.currentVendorDetail), _defineProperty(_ref, 'userPermissions', state.auth.userPermissions), _defineProperty(_ref, 'checkPassword', state.settings.checkPassword), _defineProperty(_ref, 'checkPasswordSuccess', state.settings.checkPasswordSuccess), _defineProperty(_ref, 'checkPasswordFailure', state.settings.checkPasswordFailure), _ref;
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchAPInvoices: _arap_actions.fetchAPInvoices, createAP: _arap_actions.createAP, editAP: _arap_actions.editAP, deleteAP: _arap_actions.deleteAP, fetchVendors: _vendors_actions.fetchVendors, fetchVendorDetail: _vendors_actions.fetchVendorDetail,
	  fetchAPDetail: _arap_actions.fetchAPDetail, fetchAPCredits: _arap_actions.fetchAPCredits, clearCredits: _arap_actions.clearCredits, clearAPDetail: _arap_actions.clearAPDetail, checkPassword: _settings_actions.checkPassword, clearCheckPassword: _settings_actions.clearCheckPassword, setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm })(apDetail);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/APDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(isNumeric, 'isNumeric', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/APDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/APDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(apDetail, 'apDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/APDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/APDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/APDetail.jsx');
	}();

	;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _arap_actions = __webpack_require__(43);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _settings_actions = __webpack_require__(33);
	
	var _APList = __webpack_require__(215);
	
	var _APList2 = _interopRequireDefault(_APList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apList = (0, _reduxForm.reduxForm)({
	    form: 'apList',
	    destroyOnUnmount: false
	})(_APList2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('apList');
	
	function mapStateToProps(state) {
	    var fromDate = selector(state, 'FromDate');
	    var toDate = selector(state, 'ToDate');
	    var days = selector(state, 'Days');
	    return {
	        fromDate: fromDate,
	        toDate: toDate,
	        days: days,
	        ap: state.arap.ap,
	        isLoading: state.arap.apIsLoading,
	        error: state.arap.apError,
	        apDetail: state.arap.apDetail,
	        apDetailError: state.arap.apDetailError,
	        apDetailIsLoading: state.arap.apDetailIsLoading,
	        checkPassword: state.settings.checkPassword,
	        checkPasswordSuccess: state.settings.checkPasswordSuccess,
	        checkPasswordFailure: state.settings.checkPasswordFailure
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	    fetchAP: _arap_actions.fetchAP,
	    deleteAP: _arap_actions.deleteAP,
	    fetchAPDetail: _arap_actions.fetchAPDetail,
	    clearAPDetail: _arap_actions.clearAPDetail,
	    setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	    checkPassword: _settings_actions.checkPassword,
	    clearCheckPassword: _settings_actions.clearCheckPassword
	})(apList);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/APList.jsx');
	
	    __REACT_HOT_LOADER__.register(apList, 'apList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/APList.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/APList.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/APList.jsx');
	}();

	;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _createAP = __webpack_require__(218);
	
	var _createAP2 = _interopRequireDefault(_createAP);
	
	var _vendors_actions = __webpack_require__(46);
	
	var _arap_actions = __webpack_require__(43);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isNumeric = function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	};
	
	var validate = function validate(values) {
	  var errors = {};
	  if (values.TotalPayment && !isNumeric(values.TotalPayment)) {
	    errors.TotalPayment = 'Enter a number!';
	  }
	
	  if (values.TotalPayment < 0) {
	    errors.TotalPayment = 'Positive numbers only!';
	  }
	
	  if (values.Discount && !isNumeric(values.Discount)) {
	    errors.Discount = 'Enter a number!';
	  }
	
	  if (values.Discount && values.Discount < 0) {
	    errors.Discount = 'Positive numbers only!';
	  }
	
	  if (values.waiveAmount && !isNumeric(values.waiveAmount)) {
	    errors.waiveAmount = 'Enter a number!';
	  }
	
	  if (!values.Vendor) {
	    errors.Vendor = 'Required';
	  }
	
	  if (!values.Account) {
	    errors.Account = 'Required';
	  }
	
	  if (!values.TotalPayment) {
	    errors.TotalPayment = 'Required';
	  }
	
	  if (!values.Method) {
	    errors.Method = 'Required';
	  }
	
	  if (!values.PaymentDate) {
	    errors.PaymentDate = 'Required';
	  }
	
	  return errors;
	};
	
	var createAPForm = (0, _reduxForm.reduxForm)({
	  form: 'createAP',
	  destroyOnUnmount: false,
	  touchOnChange: true,
	  touchOnBlur: false,
	  validate: validate
	})(_createAP2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('createAP');
	
	function mapStateToProps(state) {
	  var vendorID = selector(state, 'Vendor');
	  var credits = selector(state, 'Credits');
	
	  var invoiceDate = selector(state, 'InvoiceDate');
	  var paymentDate = selector(state, 'PaymentDate');
	  var fromDate = selector(state, 'FromDate');
	  var toDate = selector(state, 'ToDate');
	
	  var method = selector(state, 'Method');
	  var checkNum = selector(state, 'CheckNum');
	  var account = selector(state, 'Account');
	  var discount = selector(state, 'Discount');
	  var totalPayment = selector(state, 'TotalPayment');
	  var waiveAmount = selector(state, 'WaiveAmount');
	  var note = selector(state, 'Note');
	
	  return {
	    vendorID: vendorID,
	    credits: credits,
	    invoiceDate: invoiceDate,
	    paymentDate: paymentDate,
	    fromDate: fromDate,
	    toDate: toDate,
	    method: method,
	    checkNum: checkNum,
	    account: account,
	    discount: discount,
	    totalPayment: totalPayment,
	    waiveAmount: waiveAmount,
	    note: note,
	    invoices: state.arap.invoices,
	    invoicesIsLoading: state.arap.invoicesIsLoading,
	    invoicesError: state.arap.invoicesError,
	    apCreated: state.arap.apCreated,
	    apCreateError: state.arap.apCreateError,
	    apIsCreating: state.arap.apIsCreating,
	
	    // credits: state.arap.credits,
	    creditsIsLoading: state.arap.creditsIsLoading,
	    creditsError: state.arap.creditsError,
	
	    vendors: state.vendors.all,
	    vendorsIsLoading: state.vendors.isLoading,
	    vendorsError: state.vendors.error,
	    currentVendorDetail: state.vendors.currentVendorDetail,
	    userPermissions: state.auth.userPermissions
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchAPInvoices: _arap_actions.fetchAPInvoices,
	  createAP: _arap_actions.createAP,
	  fetchVendors: _vendors_actions.fetchVendors,
	  fetchVendorDetail: _vendors_actions.fetchVendorDetail,
	  fetchAPCredits: _arap_actions.fetchAPCredits,
	  clearCredits: _arap_actions.clearCredits,
	  clearAPDetail: _arap_actions.clearAPDetail,
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	  changeField: _arap_actions.changeField
	})(createAPForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/createAP.jsx');
	
	  __REACT_HOT_LOADER__.register(isNumeric, 'isNumeric', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/createAP.jsx');
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/createAP.jsx');
	
	  __REACT_HOT_LOADER__.register(createAPForm, 'createAPForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/createAP.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/createAP.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/createAP.jsx');
	}();

	;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _editAP = __webpack_require__(220);
	
	var _editAP2 = _interopRequireDefault(_editAP);
	
	var _arap_actions = __webpack_require__(43);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _settings_actions = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var isNumeric = function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	};
	
	var validate = function validate(values) {
	  var errors = {};
	
	  if (values.TotalPayment && !isNumeric(values.TotalPayment)) {
	    errors.TotalPayment = 'Enter a number!';
	  }
	
	  if (values.TotalPayment < 0) {
	    errors.TotalPayment = 'Positive numbers only!';
	  }
	
	  if (values.Discount && !isNumeric(values.Discount)) {
	    errors.Discount = 'Enter a number!';
	  }
	
	  if (values.Discount && values.Discount < 0) {
	    errors.Discount = 'Positive numbers only!';
	  }
	
	  if (values.waiveAmount && !isNumeric(values.waiveAmount)) {
	    errors.waiveAmount = 'Enter a number!';
	  }
	
	  if (!values.Vendor) {
	    errors.Vendor = 'Required';
	  }
	
	  if (!values.Account) {
	    errors.Account = 'Required';
	  }
	
	  if (!values.TotalPayment) {
	    errors.TotalPayment = 'Required';
	  }
	
	  if (!values.Method) {
	    errors.Method = 'Required';
	  }
	
	  return errors;
	};
	
	var editAPForm = (0, _reduxForm.reduxForm)({
	  form: 'editAP',
	  destroyOnUnmount: true,
	  touchOnChange: true,
	  touchOnBlur: false,
	  validate: validate
	})(_editAP2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('editAP');
	
	function mapStateToProps(state) {
	  var _ref;
	
	  var vendorID = selector(state, 'Vendor');
	  var credits = selector(state, 'Credits');
	
	  var invoiceDate = selector(state, 'InvoiceDate');
	  var paymentDate = selector(state, 'PaymentDate');
	
	  var method = selector(state, 'Method');
	  var checkNum = selector(state, 'CheckNum');
	  var account = selector(state, 'Account');
	  var discount = selector(state, 'Discount');
	  var totalPayment = selector(state, 'TotalPayment');
	  var waiveAmount = selector(state, 'WaiveAmount');
	  var note = selector(state, 'Note');
	  return _ref = {
	    vendorID: vendorID,
	    credits: credits,
	    invoiceDate: invoiceDate,
	    paymentDate: paymentDate,
	    method: method,
	    checkNum: checkNum,
	    account: account,
	    discount: discount,
	    totalPayment: totalPayment,
	    waiveAmount: waiveAmount,
	    note: note,
	    invoices: state.arap.invoices,
	    invoicesIsLoading: state.arap.invoicesIsLoading,
	    invoicesError: state.arap.invoicesError,
	    apCreated: state.arap.apCreated,
	    apEdited: state.arap.apEdited,
	    apEditError: state.arap.apEditError,
	    apIsEditing: state.arap.apIsEditing,
	    apDetail: state.arap.apDetail,
	    apDetailError: state.arap.apDetailError,
	    apDetailIsLoading: state.arap.apDetailIsLoading,
	    originalCheckNumber: state.arap.originalCheckNumber
	
	  }, _defineProperty(_ref, 'credits', state.arap.credits), _defineProperty(_ref, 'creditsIsLoading', state.arap.creditsIsLoading), _defineProperty(_ref, 'creditsError', state.arap.creditsError), _defineProperty(_ref, 'userPermissions', state.auth.userPermissions), _defineProperty(_ref, 'checkPassword', state.settings.checkPassword), _defineProperty(_ref, 'checkPasswordSuccess', state.settings.checkPasswordSuccess), _defineProperty(_ref, 'checkPasswordFailure', state.settings.checkPasswordFailure), _defineProperty(_ref, 'initialValues', state.arap.apDetail), _ref;
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchAPInvoices: _arap_actions.fetchAPInvoices,
	  fetchAPDetail: _arap_actions.fetchAPDetail,
	  fetchAPCredits: _arap_actions.fetchAPCredits,
	  editAP: _arap_actions.editAP,
	  deleteAP: _arap_actions.deleteAP,
	  clearCredits: _arap_actions.clearCredits,
	  clearAPForm: _arap_actions.clearAPForm,
	  checkPassword: _settings_actions.checkPassword,
	  clearCheckPassword: _settings_actions.clearCheckPassword,
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm
	})(editAPForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/editAP.jsx');
	
	  __REACT_HOT_LOADER__.register(isNumeric, 'isNumeric', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/editAP.jsx');
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/editAP.jsx');
	
	  __REACT_HOT_LOADER__.register(editAPForm, 'editAPForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/editAP.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/editAP.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/editAP.jsx');
	}();

	;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _vendorStatement = __webpack_require__(223);
	
	var _vendorStatement2 = _interopRequireDefault(_vendorStatement);
	
	var _arap_actions = __webpack_require__(43);
	
	var _sales_actions = __webpack_require__(28);
	
	var _vendors_actions = __webpack_require__(46);
	
	var _print_actions = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vendorStatement = (0, _reduxForm.reduxForm)({
	    form: 'vendorStatement'
	})(_vendorStatement2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('vendorStatement');
	
	function mapStateToProps(state) {
	    var typeRadios = selector(state, 'typeRadios');
	    var Year = selector(state, 'Year');
	    var Month = selector(state, 'Month');
	    var StatementType = selector(state, 'StatementType');
	    var Quarter = selector(state, 'Quarter');
	    var FromDate = selector(state, 'FromDate');
	    var ToDate = selector(state, 'ToDate');
	    var Vendor = selector(state, 'Vendor');
	
	    return {
	        typeRadios: typeRadios,
	        Year: Year,
	        Month: Month,
	        StatementType: StatementType,
	        Quarter: Quarter,
	        FromDate: FromDate,
	        ToDate: ToDate,
	        Vendor: Vendor,
	        vendorStatementIsLoading: state.arap.vendorStatementIsLoading,
	        vendorStatement: state.arap.vendorStatement,
	        vendorStatementError: state.arap.vendorStatementError,
	        vendors: state.vendors.all,
	        vendorsIsLoading: state.vendors.isLoading,
	        vendorsError: state.vendors.error,
	        currentVendorDetail: state.vendors.currentVendorDetail,
	        vendorDetailIsLoading: state.vendors.detailIsLoading,
	        vendorDetailError: state.vendors.detailError,
	        purchasesVendorDetails: state.salesOrders.purchasesVendorDetails,
	        purchasesVendorDetailsIsLoading: state.salesOrders.purchasesVendorDetailsIsLoading,
	        purchasesVendorDetailsError: state.salesOrders.purchasesVendorDetailsError,
	        currentVendor: state.vendors.currentVendor,
	        requestingApReport: state.print.requestingApReport,
	        apReport: state.print.apReport,
	
	        requestingWarehouseReceivePdf: state.print.requestingWarehouseReceivePdf,
	        warehouseReceivePdf: state.print.warehouseReceivePdf
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	    setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	    fetchVendorStatement: _arap_actions.fetchVendorStatement,
	    setValue: _sales_actions.setValue,
	    fetchVendors: _vendors_actions.fetchVendors,
	    fetchVendorDetail: _vendors_actions.fetchVendorDetail,
	    fetchPurchasesVendorDetail: _sales_actions.fetchPurchasesVendorDetail,
	    resetCurrentVendor: _vendors_actions.resetCurrentVendor,
	    printAPReport: _print_actions.printAPReport,
	    printWarehouseReceive: _print_actions.printWarehouseReceive
	})(vendorStatement);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/vendorStatement.jsx');
	
	    __REACT_HOT_LOADER__.register(vendorStatement, 'vendorStatement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/vendorStatement.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/vendorStatement.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/vendorStatement.jsx');
	}();

	;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _vendorStatementMain = __webpack_require__(224);
	
	var _vendorStatementMain2 = _interopRequireDefault(_vendorStatementMain);
	
	var _arap_actions = __webpack_require__(43);
	
	var _sales_actions = __webpack_require__(28);
	
	var _vendors_actions = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vendorStatementMain = (0, _reduxForm.reduxForm)({
	    form: 'vendorStatementMain'
	})(_vendorStatementMain2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('vendorStatementMain');
	
	function mapStateToProps(state) {
	    var typeRadios = selector(state, 'typeRadios');
	    var Days = selector(state, 'Days');
	    return {
	        typeRadios: typeRadios,
	        Days: Days,
	        vendorStatementListIsLoading: state.arap.vendorStatementListIsLoading,
	        vendorStatementList: state.arap.vendorStatementList,
	        vendorStatementListError: state.arap.vendorStatementListError,
	        currentVendor: state.vendors.currentVendor
	
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm, fetchVendorStatementList: _arap_actions.fetchVendorStatementList, setValue: _sales_actions.setValue, selectVendor: _vendors_actions.selectVendor, resetCurrentVendor: _vendors_actions.resetCurrentVendor })(vendorStatementMain);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/vendorStatementMain.jsx');
	
	    __REACT_HOT_LOADER__.register(vendorStatementMain, 'vendorStatementMain', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/vendorStatementMain.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/vendorStatementMain.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AP/vendorStatementMain.jsx');
	}();

	;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _ARDetail = __webpack_require__(225);
	
	var _ARDetail2 = _interopRequireDefault(_ARDetail);
	
	var _customers_actions = __webpack_require__(42);
	
	var _arap_actions = __webpack_require__(43);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _settings_actions = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var isNumeric = function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	};
	
	var validate = function validate(values, props) {
	  var errors = {};
	
	  if (values.TotalPayment && !isNumeric(values.TotalPayment)) {
	    errors.TotalPayment = 'Accept number only!';
	  }
	
	  if (values.TotalPayment <= 0) {
	    errors.TotalPayment = 'Positive number only!';
	  }
	
	  if (values.Discount && !isNumeric(values.Discount)) {
	    errors.Discount = 'Accept number only!';
	  }
	
	  if (values.Discount && values.Discount < 0) {
	    errors.Discount = 'Positive number only!';
	  }
	
	  if (!values.Customer) {
	    errors.Customer = 'Required';
	  }
	
	  if (!values.Account) {
	    errors.Account = 'Required';
	  }
	
	  if (!values.TotalPayment) {
	    errors.TotalPayment = 'Required';
	  }
	
	  if (!values.Method) {
	    errors.Method = 'Required';
	  }
	
	  return errors;
	};
	
	var arDetail = (0, _reduxForm.reduxForm)({
	  form: 'arDetail',
	  enableReinitialize: true,
	  destroyOnUnmount: false,
	  touchOnChange: true,
	  touchOnBlur: false,
	  validate: validate
	})(_ARDetail2.default);
	var selector = (0, _reduxForm.formValueSelector)('arDetail');
	
	function mapStateToProps(state) {
	  var _ref;
	
	  var customer_id = selector(state, 'Customer');
	  var credits = selector(state, 'Credits');
	
	  var invoiceDate = selector(state, 'InvoiceDate');
	  var fromDate = selector(state, 'FromDate');
	  var toDate = selector(state, 'ToDate');
	
	  var invoiceDateBySequence = selector(state, 'InvoiceDateBySequence');
	  var fromDateBySequence = selector(state, 'FromDateBySequence');
	  var toDateBySequence = selector(state, 'ToDateBySequence');
	
	  var method = selector(state, 'Method');
	  var checkNum = selector(state, 'CheckNum');
	  var account = selector(state, 'Account');
	  var discount = selector(state, 'Discount');
	  var totalPayment = selector(state, 'TotalPayment');
	  var waive = selector(state, 'Waive');
	  var note = selector(state, 'Note');
	  return _ref = {
	    customer_id: customer_id,
	    credits: credits,
	    invoiceDate: invoiceDate,
	    fromDate: fromDate,
	    toDate: toDate,
	    invoiceDateBySequence: invoiceDateBySequence,
	    fromDateBySequence: fromDateBySequence,
	    toDateBySequence: toDateBySequence,
	    method: method,
	    checkNum: checkNum,
	    account: account,
	    discount: discount,
	    totalPayment: totalPayment,
	    waive: waive,
	    note: note,
	    invoices: state.arap.invoices,
	    invoicesIsLoading: state.arap.invoicesIsLoading,
	    invoicesError: state.arap.invoicesError,
	    arCreated: state.arap.arCreated,
	    arEdited: state.arap.arEdited,
	    arCreateError: state.arap.arCreateError,
	    arEditError: state.arap.arEditError,
	    arIsCreating: state.arap.arIsCreating,
	    arIsEditing: state.arap.arIsEditing,
	    arDetail: state.arap.arDetail,
	    initialValues: state.arap.arDetail
	
	  }, _defineProperty(_ref, 'credits', state.arap.credits), _defineProperty(_ref, 'creditsIsLoading', state.arap.creditsIsLoading), _defineProperty(_ref, 'creditsError', state.arap.creditsError), _defineProperty(_ref, 'customers', state.customers.all), _defineProperty(_ref, 'customersIsLoading', state.customers.isLoading), _defineProperty(_ref, 'customersError', state.customers.error), _defineProperty(_ref, 'currentCustomerDetail', state.customers.currentCustomerDetail), _defineProperty(_ref, 'userPermissions', state.auth.userPermissions), _defineProperty(_ref, 'checkPassword', state.settings.checkPassword), _defineProperty(_ref, 'checkPasswordSuccess', state.settings.checkPasswordSuccess), _defineProperty(_ref, 'checkPasswordFailure', state.settings.checkPasswordFailure), _ref;
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchARInvoices: _arap_actions.fetchARInvoices, createAR: _arap_actions.createAR, editAR: _arap_actions.editAR, deleteAR: _arap_actions.deleteAR, fetchCustomers: _customers_actions.fetchCustomers, fetchCustomerDetail: _customers_actions.fetchCustomerDetail,
	  fetchARDetail: _arap_actions.fetchARDetail, fetchARCredits: _arap_actions.fetchARCredits, clearCredits: _arap_actions.clearCredits, clearARDetail: _arap_actions.clearARDetail, checkPassword: _settings_actions.checkPassword, clearCheckPassword: _settings_actions.clearCheckPassword, setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm })(arDetail);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/ARDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(isNumeric, 'isNumeric', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/ARDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/ARDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(arDetail, 'arDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/ARDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/ARDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/ARDetail.jsx');
	}();

	;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _arap_actions = __webpack_require__(43);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _settings_actions = __webpack_require__(33);
	
	var _ARList = __webpack_require__(226);
	
	var _ARList2 = _interopRequireDefault(_ARList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arList = (0, _reduxForm.reduxForm)({
	    form: 'arList',
	    destroyOnUnmount: true
	})(_ARList2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('arList');
	
	function mapStateToProps(state) {
	    var fromDate = selector(state, 'FromDate');
	    var toDate = selector(state, 'ToDate');
	    var days = selector(state, 'Days');
	    return {
	        fromDate: fromDate,
	        toDate: toDate,
	        days: days,
	        ar: state.arap.ar,
	        isLoading: state.arap.arIsLoading,
	        error: state.arap.arError,
	        arDetail: state.arap.arDetail,
	        arDetailError: state.arap.arDetailError,
	        arDetailIsLoading: state.arap.arDetailIsLoading,
	        checkPassword: state.settings.checkPassword,
	        checkPasswordSuccess: state.settings.checkPasswordSuccess,
	        checkPasswordFailure: state.settings.checkPasswordFailure
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	    fetchAR: _arap_actions.fetchAR,
	    deleteAR: _arap_actions.deleteAR,
	    fetchARDetail: _arap_actions.fetchARDetail,
	    clearARDetail: _arap_actions.clearARDetail,
	    setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	    checkPassword: _settings_actions.checkPassword,
	    clearCheckPassword: _settings_actions.clearCheckPassword
	})(arList);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/ARList.jsx');
	
	    __REACT_HOT_LOADER__.register(arList, 'arList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/ARList.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/ARList.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/ARList.jsx');
	}();

	;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _salesInvoice_actions = __webpack_require__(52);
	
	var _salesInvoicePayment_actions = __webpack_require__(212);
	
	var _SIPaymentForm = __webpack_require__(234);
	
	var _SIPaymentForm2 = _interopRequireDefault(_SIPaymentForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	  var errors = {};
	  if (!values.PaymentStatus) {
	    errors.PaymentStatus = 'Required';
	  }
	  return errors;
	};
	
	var SIPayment = (0, _reduxForm.reduxForm)({
	  form: 'SIPaymentForm',
	  validate: validate
	})(_SIPaymentForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('SIPaymentForm');
	
	function mapStateToProps(state) {
	  var paymentStatusRecord = selector(state, 'PaymentStatusRecord');
	
	  return {
	    paymentStatusRecord: paymentStatusRecord,
	
	    salesInvoiceDetail: state.salesInvoice.currentSalesInvoiceDetail,
	    detailIsLoading: state.salesInvoice.detailIsLoading,
	    detailError: state.salesInvoice.detailError,
	
	    updatedSalesInvoicePayment: state.salesInvoicePayment.updatedSalesInvoicePayment,
	    updateSalesInvoicePaymentError: state.salesInvoicePayment.updateSalesInvoicePaymentError,
	    salesInvoicePaymentIsUpdating: state.salesInvoicePayment.salesInvoicePaymentIsUpdating,
	    salesInvoicePaymentUpdated: state.salesInvoicePayment.salesInvoicePaymentUpdated,
	
	    initialValues: state.salesInvoice.currentSalesInvoiceDetail
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  resetCurrentSalesInvoice: _salesInvoice_actions.resetCurrentSalesInvoice,
	  fetchSalesInvoiceDetail: _salesInvoice_actions.fetchSalesInvoiceDetail,
	  updateSalesInvoicePayment: _salesInvoicePayment_actions.updateSalesInvoicePayment,
	  resetSalesInvoicePayment: _salesInvoicePayment_actions.resetSalesInvoicePayment
	})(SIPayment);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/SIPaymentForm.jsx');
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/SIPaymentForm.jsx');
	
	  __REACT_HOT_LOADER__.register(SIPayment, 'SIPayment', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/SIPaymentForm.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/SIPaymentForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/SIPaymentForm.jsx');
	}();

	;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _salesInvoice_actions = __webpack_require__(52);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _SIPaymentList = __webpack_require__(237);
	
	var _SIPaymentList2 = _interopRequireDefault(_SIPaymentList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SIPaymentListContainer = (0, _reduxForm.reduxForm)({
	  form: 'SIPaymentList'
	})(_SIPaymentList2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('SIPaymentList');
	
	function mapStateToProps(state) {
	  var Days = selector(state, 'Days');
	  var FromDate = selector(state, 'FromDate');
	  var ToDate = selector(state, 'ToDate');
	  return {
	    Days: Days,
	    FromDate: FromDate,
	    ToDate: ToDate,
	    salesInvoice: state.salesInvoice.all,
	    isLoading: state.salesInvoice.isLoading,
	    error: state.salesInvoice.error
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchSalesInvoices: _salesInvoice_actions.fetchSalesInvoices,
	  setDefaultDays: _purchaseOrders_actions.setDefaultDays
	})(SIPaymentListContainer);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/SIPaymentList.jsx');
	
	  __REACT_HOT_LOADER__.register(SIPaymentListContainer, 'SIPaymentListContainer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/SIPaymentList.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/SIPaymentList.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/SIPaymentList.jsx');
	}();

	;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _cityReport = __webpack_require__(227);
	
	var _cityReport2 = _interopRequireDefault(_cityReport);
	
	var _arap_actions = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    cityReportLines: state.arap.cityReport.reportData,
	    cityReportIsLoading: state.arap.cityReport.cityReportIsLoading,
	    cityReportError: state.arap.cityReport.cityReportError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  resetCityReport: _arap_actions.resetCityReport
	})(_cityReport2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/cityReport.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/cityReport.jsx');
	}();

	;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _createAR = __webpack_require__(238);
	
	var _createAR2 = _interopRequireDefault(_createAR);
	
	var _customers_actions = __webpack_require__(42);
	
	var _arap_actions = __webpack_require__(43);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _settings_actions = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var isNumeric = function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	};
	
	var validate = function validate(values) {
	  var errors = {};
	  if (values.TotalPayment && !isNumeric(values.TotalPayment)) {
	    errors.TotalPayment = 'Accept number only!';
	  }
	
	  if (values.TotalPayment < 0) {
	    errors.TotalPayment = 'Positive number only!';
	  }
	
	  if (values.Discount && !isNumeric(values.Discount)) {
	    errors.Discount = 'Accept number only!';
	  }
	
	  if (values.Discount && values.Discount < 0) {
	    errors.Discount = 'Positive number only!';
	  }
	
	  if (values.PenaltyAmount && !isNumeric(values.PenaltyAmount)) {
	    errors.PenaltyAmount = 'Accept number only!';
	  }
	
	  if (values.PenaltyAmount && values.PenaltyAmount < 0) {
	    errors.PenaltyAmount = 'Positive number only!';
	  }
	
	  if (values.waiveAmount && !isNumeric(values.waiveAmount)) {
	    errors.waiveAmount = 'Accept number only!';
	  }
	
	  if (!values.Customer) {
	    errors.Customer = 'Required';
	  }
	
	  if (!values.Account) {
	    errors.Account = 'Required';
	  }
	
	  if (!values.TotalPayment) {
	    errors.TotalPayment = 'Required';
	  }
	
	  if (!values.Method) {
	    errors.Method = 'Required';
	  }
	
	  if (!values.PaymentDate) {
	    errors.PaymentDate = 'Required';
	  }
	
	  return errors;
	};
	
	var createARForm = (0, _reduxForm.reduxForm)({
	  form: 'createAR',
	  enableReinitialize: true,
	  destroyOnUnmount: false,
	  touchOnChange: true,
	  touchOnBlur: false,
	  validate: validate
	})(_createAR2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('createAR');
	
	function mapStateToProps(state) {
	  var _ref;
	
	  var customer_id = selector(state, 'Customer');
	  var credits = selector(state, 'Credits');
	
	  var invoiceDate = selector(state, 'InvoiceDate');
	  var paymentDate = selector(state, 'PaymentDate');
	  var fromDate = selector(state, 'FromDate');
	  var toDate = selector(state, 'ToDate');
	  var penaltyAmount = selector(state, 'PenaltyAmount');
	
	  var method = selector(state, 'Method');
	  var checkNum = selector(state, 'CheckNum');
	  var account = selector(state, 'Account');
	  var discount = selector(state, 'Discount');
	  var totalPayment = selector(state, 'TotalPayment');
	  var waive = selector(state, 'Waive');
	  var note = selector(state, 'Note');
	  return _ref = {
	    customer_id: customer_id,
	    credits: credits,
	    invoiceDate: invoiceDate,
	    paymentDate: paymentDate,
	    fromDate: fromDate,
	    toDate: toDate,
	    penaltyAmount: penaltyAmount,
	    method: method,
	    checkNum: checkNum,
	    account: account,
	    discount: discount,
	    totalPayment: totalPayment,
	    waive: waive,
	    note: note,
	    invoices: state.arap.invoices,
	    invoicesIsLoading: state.arap.invoicesIsLoading,
	    invoicesError: state.arap.invoicesError,
	    arCreated: state.arap.arCreated,
	    arCreateError: state.arap.arCreateError,
	    arIsCreating: state.arap.arIsCreating,
	
	    arIsRefunding: state.arap.arIsRefunding,
	    arRefunded: state.arap.arIsRefunded,
	    arRefundError: state.arap.arRefundError
	
	  }, _defineProperty(_ref, 'credits', state.arap.credits), _defineProperty(_ref, 'creditsIsLoading', state.arap.creditsIsLoading), _defineProperty(_ref, 'creditsError', state.arap.creditsError), _defineProperty(_ref, 'customers', state.customers.all), _defineProperty(_ref, 'customersIsLoading', state.customers.isLoading), _defineProperty(_ref, 'customersError', state.customers.error), _defineProperty(_ref, 'currentCustomerDetail', state.customers.currentCustomerDetail), _defineProperty(_ref, 'userPermissions', state.auth.userPermissions), _defineProperty(_ref, 'checkPassword', state.settings.checkPassword), _defineProperty(_ref, 'checkPasswordSuccess', state.settings.checkPasswordSuccess), _defineProperty(_ref, 'checkPasswordFailure', state.settings.checkPasswordFailure), _ref;
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchARInvoices: _arap_actions.fetchARInvoices,
	  createAR: _arap_actions.createAR,
	  refundAR: _arap_actions.refundAR,
	  fetchCustomers: _customers_actions.fetchCustomers,
	  fetchCustomerDetail: _customers_actions.fetchCustomerDetail,
	  fetchARCredits: _arap_actions.fetchARCredits,
	  clearCredits: _arap_actions.clearCredits,
	  clearARForm: _arap_actions.clearARForm,
	  checkPassword: _settings_actions.checkPassword,
	  clearCheckPassword: _settings_actions.clearCheckPassword,
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	  clearARDetail: _arap_actions.clearARDetail,
	  changeField: _arap_actions.changeField
	})(createARForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/createAR.jsx');
	
	  __REACT_HOT_LOADER__.register(isNumeric, 'isNumeric', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/createAR.jsx');
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/createAR.jsx');
	
	  __REACT_HOT_LOADER__.register(createARForm, 'createARForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/createAR.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/createAR.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/createAR.jsx');
	}();

	;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _customerStatement = __webpack_require__(239);
	
	var _customerStatement2 = _interopRequireDefault(_customerStatement);
	
	var _arap_actions = __webpack_require__(43);
	
	var _sales_actions = __webpack_require__(28);
	
	var _customers_actions = __webpack_require__(42);
	
	var _print_actions = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customerStatement = (0, _reduxForm.reduxForm)({
	    form: 'customerStatement'
	})(_customerStatement2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('customerStatement');
	
	function mapStateToProps(state) {
	    var typeRadios = selector(state, 'typeRadios');
	    var Year = selector(state, 'Year');
	    var Month = selector(state, 'Month');
	    var StatementType = selector(state, 'StatementType');
	    var Quarter = selector(state, 'Quarter');
	    var FromDate = selector(state, 'FromDate');
	    var ToDate = selector(state, 'ToDate');
	    var Customer = selector(state, 'Customer');
	
	    return {
	        typeRadios: typeRadios,
	        Year: Year,
	        Month: Month,
	        StatementType: StatementType,
	        Quarter: Quarter,
	        FromDate: FromDate,
	        ToDate: ToDate,
	        Customer: Customer,
	        customerStatementIsLoading: state.arap.customerStatementIsLoading,
	        customerStatement: state.arap.customerStatement,
	        customerStatementError: state.arap.customerStatementError,
	        customers: state.customers.all,
	        customersIsLoading: state.customers.isLoading,
	        customersError: state.customers.error,
	        salesCustomerDetails: state.salesOrders.salesCustomerDetails,
	        salesCustomerDetailsIsLoading: state.salesOrders.salesCustomerDetailsIsLoading,
	        salesCustomerDetailsError: state.salesOrders.salesCustomerDetailsError,
	        currentCustomer: state.customers.currentCustomer,
	
	        requestingArReport: state.print.requestingArReport,
	        arReport: state.print.arReport
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	    setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	    fetchCustomerStatement: _arap_actions.fetchCustomerStatement,
	    setValue: _sales_actions.setValue,
	    fetchCustomers: _customers_actions.fetchCustomers,
	    fetchSalesCustomerDetail: _sales_actions.fetchSalesCustomerDetail,
	    printARReport: _print_actions.printARReport,
	    printPlainARReport: _print_actions.printPlainARReport,
	    printSalesInvoiceForCustomerStatement: _print_actions.printSalesInvoiceForCustomerStatement,
	    printSalesInvoiceReturn: _print_actions.printSalesInvoiceReturn
	})(customerStatement);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/customerStatement.jsx');
	
	    __REACT_HOT_LOADER__.register(customerStatement, 'customerStatement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/customerStatement.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/customerStatement.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/customerStatement.jsx');
	}();

	;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _customerStatementMain = __webpack_require__(240);
	
	var _customerStatementMain2 = _interopRequireDefault(_customerStatementMain);
	
	var _arap_actions = __webpack_require__(43);
	
	var _sales_actions = __webpack_require__(28);
	
	var _customers_actions = __webpack_require__(42);
	
	var _paymentTerms_actions = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customerStatementMain = (0, _reduxForm.reduxForm)({
	  form: 'customerStatementMain'
	})(_customerStatementMain2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('customerStatementMain');
	
	function mapStateToProps(state) {
	  var typeRadios = selector(state, 'typeRadios');
	  var Days = selector(state, 'Days');
	  var PaymentTerm = selector(state, 'PaymentTerm');
	
	  return {
	    typeRadios: typeRadios,
	    Days: Days,
	    PaymentTerm: PaymentTerm,
	    paymentTerms: state.paymentTerms.all,
	    isLoading: state.paymentTerms.isLoading,
	    customerStatementListIsLoading: state.arap.customerStatementListIsLoading,
	    customerStatementList: state.arap.customerStatementList,
	    customerStatementListError: state.arap.customerStatementListError,
	    currentCustomer: state.customers.currentCustomer
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	  fetchCustomerStatementList: _arap_actions.fetchCustomerStatementList,
	  setValue: _sales_actions.setValue,
	  selectCustomer: _customers_actions.selectCustomer,
	  resetCurrentCustomer: _customers_actions.resetCurrentCustomer,
	  fetchPaymentTerms: _paymentTerms_actions.fetchPaymentTerms
	})(customerStatementMain);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/customerStatementMain.jsx');
	
	  __REACT_HOT_LOADER__.register(customerStatementMain, 'customerStatementMain', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/customerStatementMain.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/customerStatementMain.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/customerStatementMain.jsx');
	}();

	;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _editAR = __webpack_require__(241);
	
	var _editAR2 = _interopRequireDefault(_editAR);
	
	var _arap_actions = __webpack_require__(43);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _settings_actions = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var isNumeric = function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	};
	
	var validate = function validate(values) {
	  var errors = {};
	
	  if (values.TotalPayment && !isNumeric(values.TotalPayment)) {
	    errors.TotalPayment = 'Enter a number!';
	  }
	
	  if (values.TotalPayment < 0) {
	    errors.TotalPayment = 'Positive numbers only!';
	  }
	
	  if (values.Discount && !isNumeric(values.Discount)) {
	    errors.Discount = 'Enter a number!';
	  }
	
	  if (values.Discount && values.Discount < 0) {
	    errors.Discount = 'Positive numbers only!';
	  }
	
	  if (values.PenaltyAmount && !isNumeric(values.PenaltyAmount)) {
	    errors.PenaltyAmount = 'Enter a number!';
	  }
	
	  if (values.PenaltyAmount && values.PenaltyAmount < 0) {
	    errors.PenaltyAmount = 'Positive numbers only!';
	  }
	
	  if (values.WaiveAmount && !isNumeric(values.WaiveAmount)) {
	    errors.WaiveAmount = 'Enter a number!';
	  }
	
	  if (!values.Customer) {
	    errors.Customer = 'Required';
	  }
	
	  if (!values.Account) {
	    errors.Account = 'Required';
	  }
	
	  if (!values.TotalPayment) {
	    errors.TotalPayment = 'Required';
	  }
	
	  if (!values.Method) {
	    errors.Method = 'Required';
	  }
	
	  return errors;
	};
	
	var editARForm = (0, _reduxForm.reduxForm)({
	  form: 'editAR',
	  enableReinitialize: true,
	  destroyOnUnmount: true,
	  touchOnChange: true,
	  touchOnBlur: false,
	  validate: validate
	})(_editAR2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('editAR');
	
	function mapStateToProps(state) {
	  var _extends2;
	
	  var customer_id = selector(state, 'Customer');
	  var credits = selector(state, 'Credits');
	
	  var invoiceDate = selector(state, 'InvoiceDate');
	  var paymentDate = selector(state, 'PaymentDate');
	  var penaltyAmount = selector(state, 'PenaltyAmount');
	
	  var method = selector(state, 'Method');
	  var checkNum = selector(state, 'CheckNum');
	  var account = selector(state, 'Account');
	  var discount = selector(state, 'Discount');
	  var totalPayment = selector(state, 'TotalPayment');
	  var waive = selector(state, 'Waive');
	  var waiveAmount = selector(state, 'WaiveAmount');
	  var note = selector(state, 'Note');
	  return _extends({}, state.arap.bounceCheck, (_extends2 = {
	
	    customer_id: customer_id,
	    credits: credits,
	    invoiceDate: invoiceDate,
	    paymentDate: paymentDate,
	    penaltyAmount: penaltyAmount,
	    method: method,
	    checkNum: checkNum,
	    account: account,
	    discount: discount,
	    totalPayment: totalPayment,
	    waive: waive,
	    waiveAmount: waiveAmount,
	    note: note,
	
	    invoices: state.arap.invoices,
	    invoicesIsLoading: state.arap.invoicesIsLoading,
	    invoicesError: state.arap.invoicesError,
	    arEdited: state.arap.arEdited,
	    arEditError: state.arap.arEditError,
	    arIsEditing: state.arap.arIsEditing,
	    arDetail: state.arap.arDetail,
	    arDetailError: state.arap.arDetailError,
	    arDetailIsLoading: state.arap.arDetailIsLoading
	
	  }, _defineProperty(_extends2, 'credits', state.arap.credits), _defineProperty(_extends2, 'creditsIsLoading', state.arap.creditsIsLoading), _defineProperty(_extends2, 'creditsError', state.arap.creditsError), _defineProperty(_extends2, 'userPermissions', state.auth.userPermissions), _defineProperty(_extends2, 'checkPassword', state.settings.checkPassword), _defineProperty(_extends2, 'checkPasswordSuccess', state.settings.checkPasswordSuccess), _defineProperty(_extends2, 'checkPasswordFailure', state.settings.checkPasswordFailure), _defineProperty(_extends2, 'initialValues', state.arap.arDetail), _extends2));
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchARInvoices: _arap_actions.fetchARInvoices,
	  fetchARCredits: _arap_actions.fetchARCredits,
	  fetchARDetail: _arap_actions.fetchARDetail,
	  editAR: _arap_actions.editAR,
	  deleteAR: _arap_actions.deleteAR,
	  bounceCheck: _arap_actions.bounceCheck,
	  clearCredits: _arap_actions.clearCredits,
	  clearARForm: _arap_actions.clearARForm,
	  checkPassword: _settings_actions.checkPassword,
	  clearCheckPassword: _settings_actions.clearCheckPassword,
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm
	})(editARForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/editAR.jsx');
	
	  __REACT_HOT_LOADER__.register(isNumeric, 'isNumeric', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/editAR.jsx');
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/editAR.jsx');
	
	  __REACT_HOT_LOADER__.register(editARForm, 'editARForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/editAR.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/editAR.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/editAR.jsx');
	}();

	;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _generalReport = __webpack_require__(242);
	
	var _generalReport2 = _interopRequireDefault(_generalReport);
	
	var _arap_actions = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var generalReport = (0, _reduxForm.reduxForm)({
	    form: 'generalReport'
	})(_generalReport2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('generalReport');
	
	function mapStateToProps(state) {
	    var typeRadios = selector(state, 'typeRadios');
	    var Year = selector(state, 'Year');
	    var Month = selector(state, 'Month');
	    var SalesType = selector(state, 'SalesType');
	    var Quarter = selector(state, 'Quarter');
	    return {
	        typeRadios: typeRadios,
	        Year: Year,
	        Month: Month,
	        SalesType: SalesType,
	        Quarter: Quarter,
	        generalReportIsLoading: state.arap.generalReportIsLoading,
	        generalReport: state.arap.generalReport,
	        generalReportError: state.arap.generalReportError,
	        currentCustomer: state.customers.currentCustomer
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm, fetchGeneralReport: _arap_actions.fetchGeneralReport })(generalReport);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/generalReport.jsx');
	
	    __REACT_HOT_LOADER__.register(generalReport, 'generalReport', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/generalReport.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/generalReport.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/generalReport.jsx');
	}();

	;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _mobileCustomerStatement = __webpack_require__(243);
	
	var _mobileCustomerStatement2 = _interopRequireDefault(_mobileCustomerStatement);
	
	var _arap_actions = __webpack_require__(43);
	
	var _sales_actions = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mobileCustomerStatement = (0, _reduxForm.reduxForm)({
	  form: 'mobileCustomerStatement',
	  destroyOnUnmount: true
	})(_mobileCustomerStatement2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('mobileCustomerStatement');
	
	function mapStateToProps(state) {
	  var typeRadios = selector(state, 'typeRadios');
	  var Year = selector(state, 'Year');
	  var Month = selector(state, 'Month');
	  var Quarter = selector(state, 'Quarter');
	  var FromDate = selector(state, 'FromDate');
	  var ToDate = selector(state, 'ToDate');
	
	  var _state$arap$mobileCus = state.arap.mobileCustomerStatement,
	      _state$arap$mobileCus2 = _state$arap$mobileCus.mobileCustomerStatement,
	      months = _state$arap$mobileCus2.months,
	      days = _state$arap$mobileCus2.days,
	      invoice_amount = _state$arap$mobileCus2.invoice_amount,
	      receive_amount = _state$arap$mobileCus2.receive_amount,
	      order_amount = _state$arap$mobileCus2.order_amount,
	      total_order = _state$arap$mobileCus2.total_order,
	      total_capture = _state$arap$mobileCus2.total_capture,
	      total_invoice = _state$arap$mobileCus2.total_invoice,
	      mobileCustomerStatementError = _state$arap$mobileCus.mobileCustomerStatementError,
	      mobileCustomerStatementIsLoading = _state$arap$mobileCus.mobileCustomerStatementIsLoading;
	
	  var rows = months || days || [];
	  var twoDecimalZero = 0 .toFixed(2);
	  var invoiceAmount = invoice_amount ? parseFloat(invoice_amount).toFixed(2) : twoDecimalZero;
	  var receiveAmount = receive_amount ? parseFloat(receive_amount).toFixed(2) : twoDecimalZero;
	  var orderAmount = order_amount ? parseFloat(order_amount).toFixed(2) : twoDecimalZero;
	  var totalOrders = parseFloat(total_order) || 0;
	  var totalCaptured = parseFloat(total_capture) || 0;
	  var totalInvoices = parseFloat(total_invoice) || 0;
	
	  return {
	    typeRadios: typeRadios,
	    Year: Year,
	    Month: Month,
	    Quarter: Quarter,
	    FromDate: FromDate,
	    ToDate: ToDate,
	    mobileCustomerStatement: {
	      mobileCustomerStatementError: mobileCustomerStatementError,
	      mobileCustomerStatementIsLoading: mobileCustomerStatementIsLoading,
	      rows: rows,
	      invoiceAmount: invoiceAmount,
	      receiveAmount: receiveAmount,
	      orderAmount: orderAmount,
	      totalOrders: totalOrders,
	      totalCaptured: totalCaptured,
	      totalInvoices: totalInvoices
	    }
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	  fetchMobileCustomerStatement: _arap_actions.fetchMobileCustomerStatement,
	  resetMobileCustomerStatement: _arap_actions.resetMobileCustomerStatement,
	  setValue: _sales_actions.setValue
	})(mobileCustomerStatement);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/mobileCustomerStatement.jsx');
	
	  __REACT_HOT_LOADER__.register(mobileCustomerStatement, 'mobileCustomerStatement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/mobileCustomerStatement.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/mobileCustomerStatement.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/AR/mobileCustomerStatement.jsx');
	}();

	;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _paymentTerms_actions = __webpack_require__(54);
	
	var _agents_actions = __webpack_require__(108);
	
	var _agentForm = __webpack_require__(245);
	
	var _agentForm2 = _interopRequireDefault(_agentForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.Name) {
	        errors.Name = 'Required';
	    }
	    if (!values.AgentNum) {
	        errors.AgentNum = 'Required';
	    }
	    if (!values.Description) {
	        errors.Description = 'Required';
	    }
	    return errors;
	};
	
	var agentForm = (0, _reduxForm.reduxForm)({
	    form: 'agentForm',
	    validate: validate
	})(_agentForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('agentForm');
	
	function mapStateToProps(state) {
	    return {
	        currentAgent: state.agents.currentAgent,
	        currentAgentDetail: state.agents.currentAgentDetail,
	        detailIsLoading: state.agents.detailIsLoading,
	        detailError: state.agents.detailError,
	        initialValues: state.agents.currentAgentDetail,
	        paymentTerms: state.paymentTerms.all,
	        paymentTermsIsLoading: state.paymentTerms.isLoading,
	        paymentTermsError: state.paymentTerms.error,
	        isCreating: state.agents.isCreating,
	        createError: state.agents.createError,
	        created: state.agents.created,
	        isEditing: state.agents.isEditing,
	        editError: state.agents.editError,
	        edited: state.agents.edited,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchPaymentTerms: _paymentTerms_actions.fetchPaymentTerms, createAgent: _agents_actions.createAgent, editAgent: _agents_actions.editAgent, fetchAgentDetail: _agents_actions.fetchAgentDetail })(agentForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Agents/agentForm.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Agents/agentForm.jsx');
	
	    __REACT_HOT_LOADER__.register(agentForm, 'agentForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Agents/agentForm.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Agents/agentForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Agents/agentForm.jsx');
	}();

	;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _agents_actions = __webpack_require__(108);
	
	var _reactRedux = __webpack_require__(6);
	
	var _agents = __webpack_require__(246);
	
	var _agents2 = _interopRequireDefault(_agents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	    return {
	        agents: state.agents.all,
	        currentAgent: state.agents.currentAgent,
	        isLoading: state.agents.isLoading,
	        error: state.agents.error,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchAgents: _agents_actions.fetchAgents, selectAgent: _agents_actions.selectAgent, resetCurrentAgent: _agents_actions.resetCurrentAgent })(_agents2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Agents/agents.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Agents/agents.jsx');
	}();

	;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _auth_actions = __webpack_require__(79);
	
	var _login = __webpack_require__(247);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	    return { errorMessage: state.auth.error };
	}
	
	var LoginForm = (0, _reduxForm.reduxForm)({
	    form: 'signin'
	})(_login2.default);
	
	LoginForm = (0, _reactRedux.connect)(mapStateToProps, { signinUser: _auth_actions.signinUser })(LoginForm);
	
	var _default = LoginForm;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Auth/login.jsx');
	
	    __REACT_HOT_LOADER__.register(LoginForm, 'LoginForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Auth/login.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Auth/login.jsx');
	}();

	;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _auth_actions = __webpack_require__(79);
	
	var _language_actions = __webpack_require__(134);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// An HOC which will navigate user back to the login
	// page if the user try to reach some pages without
	// being authenticated.
	
	var _default = function _default(ComposedComponent, name) {
	  var Authentication = function (_Component) {
	    _inherits(Authentication, _Component);
	
	    function Authentication() {
	      _classCallCheck(this, Authentication);
	
	      return _possibleConstructorReturn(this, (Authentication.__proto__ || Object.getPrototypeOf(Authentication)).apply(this, arguments));
	    }
	
	    _createClass(Authentication, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        this.props.checkStatues();
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (localStorage.getItem('lang') === 'ch') {
	          this.props.changeToChinese();
	        } else {
	          this.props.changeToEnglish();
	        }
	      }
	    }, {
	      key: 'componentWillUpdate',
	      value: function componentWillUpdate(nextProps) {
	        if (!nextProps.authenticated) {
	          this.context.router.push('/login');
	        }
	        if (localStorage.getItem('lang') == 'ch') {
	          this.props.changeToChinese();
	        } else {
	          this.props.changeToEnglish();
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var userPermissions = this.props.userPermissions;
	        if (name && userPermissions.indexOf(name) == -1) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            'no permission'
	          );
	        }
	        return _react2.default.createElement(ComposedComponent, this.props);
	      }
	    }]);
	
	    return Authentication;
	  }(_react.Component);
	
	  Authentication.contextTypes = {
	    router: _react2.default.PropTypes.object
	  };
	
	
	  function mapStateToProps(state) {
	    return { authenticated: state.auth.authenticated,
	      userType: state.auth.userType,
	      userPermissions: state.auth.userPermissions };
	  }
	  return (0, _reactRedux.connect)(mapStateToProps, { changeToEnglish: _language_actions.changeToEnglish, changeToChinese: _language_actions.changeToChinese, checkStatues: _auth_actions.checkStatues })(Authentication);
	};
	
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Auth/require_auth.jsx');
	}();

	;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _auth_actions = __webpack_require__(79);
	
	var _signup = __webpack_require__(248);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Signup form validation. Very simple, password must be same with the passwordConfirm and each
	// field should be filled.
	
	function validate(formProps) {
	    var errors = {};
	
	    if (!formProps.email) {
	        errors.email = 'Please enter an email';
	    }
	
	    if (!formProps.password) {
	        errors.password = 'Please enter a password';
	    }
	
	    if (!formProps.passwordConfirm) {
	        errors.passwordConfirm = 'Please confirm password';
	    }
	
	    if (formProps.password != formProps.passwordConfirm) {
	        errors.password = 'Passwords must match';
	    }
	
	    return errors;
	}
	
	function mapStateToProps(state) {
	    return { errorMessage: state.auth.error };
	}
	
	var _default = (0, _reduxForm.reduxForm)({
	    form: 'signup',
	    fields: ['email', 'password', 'passwordConfirm'],
	    validate: validate
	}, mapStateToProps, { signupUser: _auth_actions.signupUser })(_signup2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Auth/signup.jsx');
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Auth/signup.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Auth/signup.jsx');
	}();

	;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// An HOC which will navigate user back to the login
	// page if the user try to reach some pages without
	// being authenticated.
	
	var _default = function _default(PurchaseDashboard, WarehouseDashboard, SalesDashboard) {
	    var UserBasedAuthentication = function (_Component) {
	        _inherits(UserBasedAuthentication, _Component);
	
	        function UserBasedAuthentication() {
	            _classCallCheck(this, UserBasedAuthentication);
	
	            return _possibleConstructorReturn(this, (UserBasedAuthentication.__proto__ || Object.getPrototypeOf(UserBasedAuthentication)).apply(this, arguments));
	        }
	
	        _createClass(UserBasedAuthentication, [{
	            key: 'componentDidMount',
	            value: function componentDidMount() {
	                if (!this.props.authenticated) {
	                    this.context.router.push('/login');
	                }
	            }
	        }, {
	            key: 'componentWillUpdate',
	            value: function componentWillUpdate(nextProps) {
	                if (!nextProps.authenticated) {
	                    this.context.router.push('/login');
	                }
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                if (this.props.userType == "w") {
	                    return _react2.default.createElement(WarehouseDashboard, this.props);
	                } else if (this.props.userType == "s") {
	                    return _react2.default.createElement(SalesDashboard, this.props);
	                } else {
	                    return _react2.default.createElement(PurchaseDashboard, this.props);
	                }
	            }
	        }]);
	
	        return UserBasedAuthentication;
	    }(_react.Component);
	
	    UserBasedAuthentication.contextTypes = {
	        router: _react2.default.PropTypes.object
	    };
	
	
	    function mapStateToProps(state) {
	        return { authenticated: state.auth.authenticated,
	            userType: state.auth.userType };
	    }
	    return (0, _reactRedux.connect)(mapStateToProps)(UserBasedAuthentication);
	};
	
	exports.default = _default;
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }

	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Auth/userBased_auth.jsx');
	}();

	;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _customers_actions = __webpack_require__(42);
	
	var _customers = __webpack_require__(324);
	
	var _customers2 = _interopRequireDefault(_customers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    customers: state.customers.all,
	    customerTotalPages: state.customers.customerTotalPages,
	    customerTotalCount: state.customers.customerTotalCount,
	    currentCustomer: state.customers.currentCustomer,
	    isLoading: state.customers.isLoading,
	    error: state.customers.error,
	    userPermissions: state.auth.userPermissions,
	    isAttachingDocument: state.customers.isAttachingDocument
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchCustomers: _customers_actions.fetchCustomers,
	  fetchCustomersPaginate: _customers_actions.fetchCustomersPaginate,
	  selectCustomer: _customers_actions.selectCustomer,
	  resetCurrentCustomer: _customers_actions.resetCurrentCustomer,
	  attachDocument: _customers_actions.attachDocument
	})(_customers2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Customers/customers.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Customers/customers.jsx');
	}();

	;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _dispatch_actions = __webpack_require__(53);
	
	var _print_actions = __webpack_require__(47);
	
	var _AutoRouting = __webpack_require__(326);
	
	var _AutoRouting2 = _interopRequireDefault(_AutoRouting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AutoRoutingContainer = (0, _reduxForm.reduxForm)({
	  form: 'AutoRouting'
	  // validate
	})(_AutoRouting2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('AutoRouting');
	
	function mapStateToProps(state) {
	  var dateChosen = selector(state, 'DeliverDate');
	  var OrderNo = selector(state, 'OrderNo');
	  var StopIndex = selector(state, 'StopIndex');
	  var deleteStopIndex = selector(state, 'deleteStopIndex');
	  return {
	    // dateChosen,
	    OrderNo: OrderNo,
	    StopIndex: StopIndex,
	    deleteStopIndex: deleteStopIndex,
	    routes: state.dispatch.autoRoutes,
	    routesIsLoading: state.dispatch.routesIsLoading,
	    routesError: state.dispatch.routesError,
	    buttonLoadingVisible: state.dispatch.buttonLoadingVisible,
	
	    stops: state.dispatch.stops,
	    stopsIsLoading: state.dispatch.stopsIsLoading,
	    stopsError: state.dispatch.stopsError,
	    savingEditedStops: state.dispatch.savingEditedStops,
	
	    pdfFile: state.dispatch.pdfFile
	    // unassignedOrders: state.dispatch.unassignedOrders,
	    // unassignedOrdersIsLoading: state.dispatch.unassignedOrdersIsLoading,
	    // unassignedOrdersError: state.dispatch.unassignedOrdersError,
	    // assigningOrderRoute: state.dispatch.assigningOrderRoute,
	    // userPermissions: state.auth.userPermissions,
	
	    // requestingRoutingPdf: state.print.requestingRoutingPdf,
	    // routingPdf: state.print.routingPdf,
	    // routingPdfFailure: state.print.routingPdfFailure,
	
	    // requestingPickingListPdf: state.print.requestingPickingListPdf,
	    // pickingListPdf: state.print.pickingListPdf,
	    // pickingListPdfFailure: state.print.pickingListPdfFailure,
	
	    // requestingPackingListPdf: state.print.requestingPackingListPdf,
	    // packingListPdf: state.print.packingListPdf,
	    // packingListPdfFailure: state.print.packingListPdfFailure,
	
	    // requestingDispatchSalesInvoicePdf: state.print.requestingDispatchSalesInvoicePdf,
	    // dispatchSalesInvoicePdf: state.print.dispatchSalesInvoicePdf,
	    // dispatchSalesInvoicePdfFailure: state.print.dispatchSalesInvoicePdfFailure,
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  // fetchRoutes,
	  // fetchStops,
	  fetchAutoRouteStops: _dispatch_actions.fetchAutoRouteStops,
	  changeFormValue: _dispatch_actions.changeFormValue,
	  updateStopsOfAutoRoutes: _dispatch_actions.updateStopsOfAutoRoutes,
	  changeStopIndex: _dispatch_actions.changeStopIndex,
	  // clearEditStatus,
	  // fetchUnassignedOrders,
	  // assignOrderRoute,
	  // saveEditedStops,
	  // printDispatchRoute,
	  // printDispatchPickingList,
	  // printDispatchPackingList,
	  // printDispatchSalesInvoice,
	  generateRoute: _dispatch_actions.generateRoute,
	  fetchAutoRoutes: _dispatch_actions.fetchAutoRoutes,
	  printPickinglist: _dispatch_actions.printPickinglist,
	  printPickinglistAll: _dispatch_actions.printPickinglistAll
	})(AutoRoutingContainer);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/AutoRouting.jsx');
	
	  __REACT_HOT_LOADER__.register(AutoRoutingContainer, 'AutoRoutingContainer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/AutoRouting.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/AutoRouting.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/AutoRouting.jsx');
	}();

	;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _Drivers = __webpack_require__(327);
	
	var _Drivers2 = _interopRequireDefault(_Drivers);
	
	var _settings_actions = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    checkingPermission: state.settings.checkingPermission,
	    checkPermissionSuccess: state.settings.checkPermissionSuccess,
	    checkPermissionFailure: state.settings.checkPermissionFailure
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { checkPermission: _settings_actions.checkPermission })(_Drivers2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/Drivers.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/Drivers.jsx');
	}();

	;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _EditRouteModal = __webpack_require__(328);
	
	var _EditRouteModal2 = _interopRequireDefault(_EditRouteModal);
	
	var _dispatch_actions = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    // savingNewRoute: state.dispatch.savingNewRoute,
	    // saveNewRouteSuccess: state.dispatch.saveNewRouteSuccess,
	    // saveNewRouteError: state.dispatch.saveNewRouteError,
	    savingRouteEdits: state.dispatch.savingRouteEdits,
	    saveRouteEditsSuccessful: state.dispatch.saveRouteEditedSuccessful
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { saveRouteEdits: _dispatch_actions.saveRouteEdits })(_EditRouteModal2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/EditRouteModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/EditRouteModal.jsx');
	}();

	;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _NewRouteModal = __webpack_require__(330);
	
	var _NewRouteModal2 = _interopRequireDefault(_NewRouteModal);
	
	var _dispatch_actions = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    savingNewRoute: state.dispatch.savingNewRoute,
	    saveNewRouteSuccess: state.dispatch.saveNewRouteSuccess,
	    saveNewRouteError: state.dispatch.saveNewRouteError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { saveNewRoute: _dispatch_actions.saveNewRoute })(_NewRouteModal2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/NewRouteModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/NewRouteModal.jsx');
	}();

	;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _editRoutes = __webpack_require__(331);
	
	var _editRoutes2 = _interopRequireDefault(_editRoutes);
	
	var _dispatch_actions = __webpack_require__(53);
	
	var _customers_actions = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var editRoutes = (0, _reduxForm.reduxForm)({
	  form: 'editRoutes'
	})(_editRoutes2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('editRoutes');
	
	function mapStateToProps(state) {
	  var days = selector(state, 'days');
	  return {
	    days: days,
	
	    routes: state.dispatch.routes,
	    routesIsLoading: state.dispatch.routesIsLoading,
	    routesError: state.dispatch.routesError,
	
	    customerRoutes: state.dispatch.customerRoutes,
	    customerRoutesIsLoading: state.dispatch.customerRoutesIsLoading,
	    customerRoutesError: state.dispatch.customerRoutesError,
	
	    savingRouteEdits: state.dispatch.savingRouteEdits,
	    saveRouteEditsSuccessful: state.dispatch.saveRouteEditsSuccessful,
	    saveRouteEditsFailure: state.dispatch.saveRouteEditsFailure,
	    saveRouteEditsError: state.dispatch.saveRouteEditsError,
	
	    allCustomers: state.customers.all,
	    customersIsLoading: state.customers.isLoading,
	    customersError: state.customers.error
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchCustomerRoutes: _dispatch_actions.fetchCustomerRoutes,
	  fetchRoutes: _dispatch_actions.fetchRoutes,
	  saveRouteEdits: _dispatch_actions.saveRouteEdits,
	  saveNewRoute: _dispatch_actions.saveNewRoute,
	  fetchActiveCustomers: _customers_actions.fetchActiveCustomers
	})(editRoutes);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/editRoutes.jsx');
	
	  __REACT_HOT_LOADER__.register(editRoutes, 'editRoutes', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/editRoutes.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/editRoutes.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/editRoutes.jsx');
	}();

	;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _dispatch_actions = __webpack_require__(53);
	
	var _print_actions = __webpack_require__(47);
	
	var _routing = __webpack_require__(332);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routing = (0, _reduxForm.reduxForm)({
	  form: 'routing'
	  // validate
	})(_routing2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('routing');
	
	function mapStateToProps(state) {
	  var dateChosen = selector(state, 'DeliverDate');
	
	  return {
	    dateChosen: dateChosen,
	
	    routes: state.dispatch.routes,
	    routesIsLoading: state.dispatch.routesIsLoading,
	    routesError: state.dispatch.routesError,
	
	    stops: state.dispatch.stops,
	    stopsIsLoading: state.dispatch.stopsIsLoading,
	    stopsError: state.dispatch.stopsError,
	    savingEditedStops: state.dispatch.savingEditedStops,
	
	    unassignedOrders: state.dispatch.unassignedOrders,
	    unassignedOrdersIsLoading: state.dispatch.unassignedOrdersIsLoading,
	    unassignedOrdersError: state.dispatch.unassignedOrdersError,
	    assigningOrderRoute: state.dispatch.assigningOrderRoute,
	    userPermissions: state.auth.userPermissions,
	
	    requestingRoutingPdf: state.print.requestingRoutingPdf,
	    routingPdf: state.print.routingPdf,
	    routingPdfFailure: state.print.routingPdfFailure,
	
	    requestingPickingListPdf: state.print.requestingPickingListPdf,
	    pickingListPdf: state.print.pickingListPdf,
	    pickingListPdfFailure: state.print.pickingListPdfFailure,
	
	    requestingPackingListPdf: state.print.requestingPackingListPdf,
	    packingListPdf: state.print.packingListPdf,
	    packingListPdfFailure: state.print.packingListPdfFailure,
	
	    requestingDispatchSalesInvoicePdf: state.print.requestingDispatchSalesInvoicePdf,
	    dispatchSalesInvoicePdf: state.print.dispatchSalesInvoicePdf,
	    dispatchSalesInvoicePdfFailure: state.print.dispatchSalesInvoicePdfFailure
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchRoutes: _dispatch_actions.fetchRoutes,
	  fetchStops: _dispatch_actions.fetchStops,
	  clearEditStatus: _dispatch_actions.clearEditStatus,
	  fetchUnassignedOrders: _dispatch_actions.fetchUnassignedOrders,
	  assignOrderRoute: _dispatch_actions.assignOrderRoute,
	  saveEditedStops: _dispatch_actions.saveEditedStops,
	  printDispatchRoute: _print_actions.printDispatchRoute,
	  printDispatchPickingList: _print_actions.printDispatchPickingList,
	  printDispatchPackingList: _print_actions.printDispatchPackingList,
	  printDispatchSalesInvoice: _print_actions.printDispatchSalesInvoice
	})(routing);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/routing.jsx');
	
	  __REACT_HOT_LOADER__.register(routing, 'routing', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/routing.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/routing.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/routing.jsx');
	}();

	;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _sales_actions = __webpack_require__(28);
	
	var _dispatch_actions = __webpack_require__(53);
	
	var _shipping = __webpack_require__(334);
	
	var _shipping2 = _interopRequireDefault(_shipping);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shipping = (0, _reduxForm.reduxForm)({
	  form: 'shipping'
	  // validate
	})(_shipping2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('shipping');
	
	function mapStateToProps(state) {
	  var chosenOrderNum = selector(state, 'Sales_Order_No');
	  var ShippingDate = selector(state, 'ShippingDate');
	
	  return {
	    chosenOrderNum: chosenOrderNum,
	    ShippingDate: ShippingDate,
	
	    salesOrders: state.dispatch.salesOrders,
	    salesOrdersIsLoading: state.dispatch.salesOrdersIsLoading,
	    salesOrdersError: state.dispatch.salesOrdersError,
	
	    salesOrderDetail: state.salesOrders.currentSalesOrderDetail,
	    salesOrderIsLoading: state.salesOrders.detailIsLoading,
	    salesOrderError: state.salesOrders.detailError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchSalesOrderDetail: _sales_actions.fetchSalesOrderDetail, fetchSalesOrdersByDate: _dispatch_actions.fetchSalesOrdersByDate, convertToInvoice: _dispatch_actions.convertToInvoice })(shipping);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/shipping.jsx');
	
	  __REACT_HOT_LOADER__.register(shipping, 'shipping', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/shipping.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/shipping.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Dispatch/shipping.jsx');
	}();

	;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _products_actions = __webpack_require__(30);
	
	var _CategoryAnalysis = __webpack_require__(339);
	
	var _CategoryAnalysis2 = _interopRequireDefault(_CategoryAnalysis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    category: state.categoryAnalysis.category,
	    categories: state.products.groups,
	    subCategories: state.products.groupCategories
	  };
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchGroups: _products_actions.fetchGroups,
	  fetchGroupCategories: _products_actions.fetchGroupCategories
	})(_CategoryAnalysis2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/General/CategoryAnalysis.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/General/CategoryAnalysis.jsx');
	}();

	;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _mobileManagement_actions = __webpack_require__(135);
	
	var _MobileManagement = __webpack_require__(341);
	
	var _MobileManagement2 = _interopRequireDefault(_MobileManagement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    productList: state.mobileManagement.productList,
	    productListIsLoading: state.mobileManagement.productListIsLoading,
	    productListError: state.mobileManagement.productListError,
	    isGreatDealsUpdating: state.mobileManagement.isGreatDealsUpdating,
	    isGreatDealsUpdated: state.mobileManagement.isGreatDealsUpdated,
	    updateGreatDealsError: state.mobileManagement.updateGreatDealsError,
	    isNewArrivalsUpdating: state.mobileManagement.isNewArrivalsUpdating,
	    isNewArrivalsUpdated: state.mobileManagement.isNewArrivalsUpdated,
	    updateNewArrivalsError: state.mobileManagement.updateNewArrivalsError,
	    isUpdating: state.mobileManagement.isGreatDealsUpdating || state.mobileManagement.isNewArrivalsUpdating,
	    isUpdated: state.mobileManagement.isGreatDealsUpdated && state.mobileManagement.isNewArrivalsUpdated,
	    billboardImagesList: state.mobileManagement.billboardImagesList,
	    billboardImagesIsLoading: state.mobileManagement.billboardImagesIsLoading,
	    billboardImagesError: state.mobileManagement.billboardImagesError,
	    savingBillboardImages: state.mobileManagement.savingBillboardImages,
	    saveBillboardImagesSuccess: state.mobileManagement.saveBillboardImagesSuccess,
	    deletingBillboardImage: state.mobileManagement.deletingBillboardImage
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchGreatDealsNewArrivals: _mobileManagement_actions.fetchGreatDealsNewArrivals,
	  fetchBillboardImages: _mobileManagement_actions.fetchBillboardImages,
	  updateGreatDeals: _mobileManagement_actions.updateGreatDeals,
	  updateNewArrivals: _mobileManagement_actions.updateNewArrivals,
	  saveBillboardImages: _mobileManagement_actions.saveBillboardImages,
	  deleteBillboardImage: _mobileManagement_actions.deleteBillboardImage
	})(_MobileManagement2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/General/MobileManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/General/MobileManagement.jsx');
	}();

	;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _sales_actions = __webpack_require__(28);
	
	var _dashboard_actions = __webpack_require__(132);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _generalDashboardRevision = __webpack_require__(343);
	
	var _generalDashboardRevision2 = _interopRequireDefault(_generalDashboardRevision);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var generalDashboard = (0, _reduxForm.reduxForm)({
	  form: 'generalDashboard'
	})(_generalDashboardRevision2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('generalDashboard');
	
	function mapStateToProps(state) {
	  var poDateChosen = selector(state, 'selectedPODate');
	  var soDateChosen = selector(state, 'selectedSODate');
	  var Message = selector(state, 'MessageField');
	
	  return {
	    poDateChosen: poDateChosen,
	    soDateChosen: soDateChosen,
	    Message: Message,
	
	    todaysIncomingOrders: state.purchaseOrders.todaysIncomingOrders,
	    todaysIncomingOrdersIsLoading: state.purchaseOrders.todaysIncomingOrdersIsLoading,
	    todaysIncomingOrdersError: state.purchaseOrders.todaysIncomingOrdersError,
	
	    todaysOutgoingOrders: state.salesOrders.todaysOutgoingOrders,
	    todaysOutgoingOrdersIsLoading: state.salesOrders.todaysOutgoingOrdersIsLoading,
	    todaysOutgoingOrdersError: state.salesOrders.todaysOutgoingOrdersError,
	
	    salesOrders: state.salesOrders.all,
	    SOIsLoading: state.salesOrders.isLoading,
	    SOError: state.salesOrders.error,
	
	    messages: state.dashboard.messages,
	    messagesIsLoading: state.dashboard.messagesIsLoading,
	    messagesError: state.dashboard.messagesError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchDashboardMessages: _dashboard_actions.fetchDashboardMessages,
	  fetchIncomingOrdersByDate: _purchaseOrders_actions.fetchIncomingOrdersByDate,
	  fetchOutgoingOrdersByDate: _sales_actions.fetchOutgoingOrdersByDate,
	  fetchPurchaseOrders: _purchaseOrders_actions.fetchPurchaseOrders,
	  fetchPurchaseOrdersNotReceived: _purchaseOrders_actions.fetchPurchaseOrdersNotReceived,
	  fetchSalesOrders: _sales_actions.fetchSalesOrders,
	  fetchTotalPurchases: _purchaseOrders_actions.fetchTotalPurchases,
	  postDashboardMessage: _dashboard_actions.postDashboardMessage,
	  resetCurrentPurchaseOrder: _purchaseOrders_actions.resetCurrentPurchaseOrder,
	  selectPurchaseOrder: _purchaseOrders_actions.selectPurchaseOrder,
	  setField: _dashboard_actions.setField
	})(generalDashboard);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/General/generalDashboardRevision.jsx');
	
	  __REACT_HOT_LOADER__.register(generalDashboard, 'generalDashboard', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/General/generalDashboardRevision.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/General/generalDashboardRevision.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/General/generalDashboardRevision.jsx');
	}();

	;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _adjustmentInventory_actions = __webpack_require__(107);
	
	var _adjustInventoryForm = __webpack_require__(348);
	
	var _adjustInventoryForm2 = _interopRequireDefault(_adjustInventoryForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.ReasonDesc) {
	        errors.ReasonDesc = 'Please Enter A Reason.';
	    }
	    return errors;
	};
	
	var adjustInventoryForm = (0, _reduxForm.reduxForm)({
	    form: 'adjustInventoryForm',
	    validate: validate
	})(_adjustInventoryForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('adjustInventoryForm');
	
	function mapStateToProps(state) {
	    return {
	        isEditing: state.adjustment.isEditing,
	        isLoading: state.adjustment.isLoading,
	        isDeleting: state.adjustment.isDeleting,
	        createError: state.adjustment.createError,
	        editingError: state.adjustment.editingError,
	        deletionError: state.adjustment.deletionError,
	        edited: state.adjustment.edited,
	        created: state.adjustment.created,
	        deleted: state.adjustment.deleted,
	        error: state.adjustment.error,
	        reason: state.adjustment.reason,
	        initialValues: state.adjustment.reason
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	    fetchReasons: _adjustmentInventory_actions.fetchReasons,
	    createReason: _adjustmentInventory_actions.createReason,
	    editReason: _adjustmentInventory_actions.editReason,
	    deleteReason: _adjustmentInventory_actions.deleteReason,
	    selectReason: _adjustmentInventory_actions.selectReason,
	    resetCurrentReason: _adjustmentInventory_actions.resetCurrentReason
	})(adjustInventoryForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/adjustInventoryForm.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/adjustInventoryForm.jsx');
	
	    __REACT_HOT_LOADER__.register(adjustInventoryForm, 'adjustInventoryForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/adjustInventoryForm.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/adjustInventoryForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/adjustInventoryForm.jsx');
	}();

	;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _adjustmentInventory_actions = __webpack_require__(107);
	
	var _reactRedux = __webpack_require__(6);
	
	var _adjustmentInventory = __webpack_require__(349);
	
	var _adjustmentInventory2 = _interopRequireDefault(_adjustmentInventory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adjustmentInventory = (0, _reduxForm.reduxForm)({
	    form: 'adjustmentInventory'
	})(_adjustmentInventory2.default);
	
	function mapStateToProps(state) {
	    return {
	        reasons: state.adjustment.reasons,
	        isEditing: state.adjustment.isEditing,
	        isLoading: state.adjustment.isLoading,
	        isDeleting: state.adjustment.isDeleting,
	        createError: state.adjustment.createError,
	        editingError: state.adjustment.editingError,
	        deletionError: state.adjustment.deletionError,
	        edited: state.adjustment.edited,
	        created: state.adjustment.created,
	        deleted: state.adjustment.deleted,
	        error: state.adjustment.error,
	        reason: state.adjustment.reason
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	    fetchReasons: _adjustmentInventory_actions.fetchReasons,
	    createReason: _adjustmentInventory_actions.createReason,
	    deleteReason: _adjustmentInventory_actions.deleteReason,
	    editReason: _adjustmentInventory_actions.editReason,
	    selectReason: _adjustmentInventory_actions.selectReason,
	    resetCurrentReason: _adjustmentInventory_actions.resetCurrentReason
	})(adjustmentInventory);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/adjustmentInventory.jsx");
	
	    __REACT_HOT_LOADER__.register(adjustmentInventory, "adjustmentInventory", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/adjustmentInventory.jsx");
	
	    __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/adjustmentInventory.jsx");
	}();

	;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _adjustmentInventory_actions = __webpack_require__(107);
	
	var _reactRedux = __webpack_require__(6);
	
	var _adjustmentLog = __webpack_require__(350);
	
	var _adjustmentLog2 = _interopRequireDefault(_adjustmentLog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adjustmentLog = (0, _reduxForm.reduxForm)({
	    form: 'adjustmentLog'
	})(_adjustmentLog2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('adjustmentLog');
	
	function mapStateToProps(state) {
	    var limit = selector(state, 'limit');
	    return {
	        limit: limit,
	        logs: state.adjustment.logs,
	        isLoading: state.adjustment.isLoading,
	        logError: state.adjustment.logError
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	    grabAdjustmentLogs: _adjustmentInventory_actions.grabAdjustmentLogs
	})(adjustmentLog);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/adjustmentLog.jsx");
	
	    __REACT_HOT_LOADER__.register(adjustmentLog, "adjustmentLog", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/adjustmentLog.jsx");
	
	    __REACT_HOT_LOADER__.register(selector, "selector", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/adjustmentLog.jsx");
	
	    __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/adjustmentLog.jsx");
	}();

	;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _zones_actions = __webpack_require__(60);
	
	var _binDetail = __webpack_require__(351);
	
	var _binDetail2 = _interopRequireDefault(_binDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var binDetail = (0, _reduxForm.reduxForm)({
	    form: 'binDetail'
	})(_binDetail2.default);
	
	function mapStateToProps(state) {
	    return {
	        currentBin: state.zones.currentBin,
	        currentBinDetail: state.zones.currentBinDetail,
	        detailIsLoading: state.zones.binDetailIsLoading,
	        detailError: state.zones.binDetailError
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchBinDetail: _zones_actions.fetchBinDetail })(binDetail);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/binDetail.jsx');
	
	    __REACT_HOT_LOADER__.register(binDetail, 'binDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/binDetail.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/binDetail.jsx');
	}();

	;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _putAway_actions = __webpack_require__(81);
	
	var _receive_actions = __webpack_require__(66);
	
	var _zones_actions = __webpack_require__(60);
	
	var _reactRedux = __webpack_require__(6);
	
	var _warehouses_actions = __webpack_require__(44);
	
	var _inboundForm = __webpack_require__(353);
	
	var _inboundForm2 = _interopRequireDefault(_inboundForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import { fetchScrapRecords, selectScrapRecord, resetCurrentScrapRecord } from '../../actions/scrapRecords_actions';
	var inboundForm = (0, _reduxForm.reduxForm)({
	    form: 'inboundForm'
	})(_inboundForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('inboundForm');
	
	function mapStateToProps(state) {
	    var zone_id = selector(state, 'Zone_id');
	    var Default_Warehouse_id = selector(state, 'Default_Warehouse_id');
	    var Default_WarehouseZone_id = selector(state, 'Default_WarehouseZone_id');
	    return {
	        Default_Warehouse_id: Default_Warehouse_id,
	        Default_WarehouseZone_id: Default_WarehouseZone_id,
	        zone_id: zone_id,
	        putAway: state.putAway.all,
	        isLoading: state.putAway.isLoading,
	        error: state.putAway.error,
	        receiveHistory: state.receives.fetchedReceiveHistory,
	        allReceiveHistoryDetail: state.receives.fetchedAllReceiveHistoryDetail,
	        receiveHistoryDetail: state.receives.fetchedReceiveHistoryDetail,
	        currentPutAway: state.putAway.currentPutAway,
	        currentPutAwayDetail: state.putAway.currentPutAwayDetail,
	        currentZoneDetail: state.zones.currentZoneDetail,
	        bins: state.zones.bins,
	        detailIsLoading: state.zones.detailIsLoading,
	        detailError: state.zones.detailError,
	        binList: state.putAway.fetchedBinList,
	        warehouses: state.warehouses.all,
	        currentWarehouseDetail: state.warehouses.currentWarehouseDetail
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchWarehouses: _warehouses_actions.fetchWarehouses, fetchWarehouseDetail: _warehouses_actions.fetchWarehouseDetail, resetCurrentWarehouseReceive: _putAway_actions.resetCurrentWarehouseReceive, selectWarehouseReceive: _putAway_actions.selectWarehouseReceive, createBins: _putAway_actions.createBins, fetchPutAwayDetail: _putAway_actions.fetchPutAwayDetail, createPutAway: _putAway_actions.createPutAway, editPutAway: _putAway_actions.editPutAway, fetchReceiveHistoryDetail: _receive_actions.fetchReceiveHistoryDetail, fetchAllReceiveHistoryDetail: _receive_actions.fetchAllReceiveHistoryDetail, fetchReceiveHistory: _receive_actions.fetchReceiveHistory, fetchPutAway: _putAway_actions.fetchPutAway, resetCurrentPutAway: _putAway_actions.resetCurrentPutAway, fetchZoneDetail: _zones_actions.fetchZoneDetail, fetchBinList: _putAway_actions.fetchBinList })(inboundForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inboundForm.jsx');
	
	    __REACT_HOT_LOADER__.register(inboundForm, 'inboundForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inboundForm.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inboundForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inboundForm.jsx');
	}();

	;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _sales_actions = __webpack_require__(28);
	
	var _inventories_actions = __webpack_require__(38);
	
	var _products_actions = __webpack_require__(30);
	
	var _warehouses_actions = __webpack_require__(44);
	
	var _inventories = __webpack_require__(354);
	
	var _inventories2 = _interopRequireDefault(_inventories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inventories = (0, _reduxForm.reduxForm)({
	    form: 'inventories',
	    destroyOnUnmount: false
	})(_inventories2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('inventories');
	
	function mapStateToProps(state) {
	    var typeRadios = selector(state, 'typeRadios');
	    var periodRadios = selector(state, 'periodRadios');
	    var fromDate = selector(state, 'FromDate');
	    var toDate = selector(state, 'ToDate');
	    var DateRange = selector(state, 'DateRange');
	    var warehouse = selector(state, 'Warehouse');
	
	    return {
	        typeRadios: typeRadios,
	        periodRadios: periodRadios,
	        fromDate: fromDate,
	        toDate: toDate,
	        DateRange: DateRange,
	        warehouse: warehouse,
	
	        groups: state.products.groups,
	        inventories: state.inventories.detailedInventories,
	        isLoading: state.inventories.detailedInventoriesIsLoading,
	        error: state.inventories.detailedInventoriesError,
	        currentInventory: state.inventories.currentInventory,
	        inventoriesByGroup: state.inventories.inventoriesByGroup,
	        inventoriesByGroupIsLoading: state.inventories.inventoriesByGroupIsLoading,
	        inventoriesByGroupError: state.inventories.inventoriesByGroupError,
	        inventoriesByCategory: state.inventories.inventoriesByCategory,
	        inventoriesByCategoryIsLoading: state.inventories.inventoriesByCategoryIsLoading,
	        inventoriesByCategoryError: state.inventories.inventoriesByCategoryError,
	        groupCategories: state.products.groupCategories,
	        currentCategoryGroup: state.products.currentCategoryGroup,
	
	        inventoriesByPeriod: state.inventories.inventoriesByPeriod,
	        inventoriesByPeriodIsLoading: state.inventories.inventoriesByPeriodIsLoading,
	        inventoriesByPeriodError: state.inventories.inventoriesByPeriodError,
	        product: state.products.product,
	
	        nonZeroInventories: state.inventories.nonZeroInventories,
	        nonZeroInventoriesIsLoading: state.inventories.nonZeroInventoriesIsLoading,
	        nonZeroInventoriesError: state.inventories.nonZeroInventoriesError,
	
	        warehouseList: state.warehouses.all,
	        warehouseListIsLoading: state.warehouses.isLoading,
	        fetchWarehousesError: state.warehouses.fetchWarehousesError
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	    fetchInventories: _inventories_actions.fetchInventories, fetchInventoriesByGroup: _inventories_actions.fetchInventoriesByGroup, fetchInventoriesByCategory: _inventories_actions.fetchInventoriesByCategory, setGroupCategory: _products_actions.setGroupCategory, setOriginPage: _inventories_actions.setOriginPage,
	    fetchDetailedInventories: _inventories_actions.fetchDetailedInventories, selectInventory: _inventories_actions.selectInventory, resetCurrentInventory: _inventories_actions.resetCurrentInventory, resetGroupAndCategory: _products_actions.resetGroupAndCategory, selectProduct: _products_actions.selectProduct,
	    fetchGroups: _products_actions.fetchGroups, fetchGroupCategories: _products_actions.fetchGroupCategories, setValue: _sales_actions.setValue, fetchInventoriesByPeriod: _inventories_actions.fetchInventoriesByPeriod, fetchAllInventories: _inventories_actions.fetchAllInventories, fetchNonZeroInventories: _inventories_actions.fetchNonZeroInventories,
	    fetchWarehouses: _warehouses_actions.fetchWarehouses,
	    resetWarehouses: _warehouses_actions.resetWarehouses
	})(inventories);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventories.jsx');
	
	    __REACT_HOT_LOADER__.register(inventories, 'inventories', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventories.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventories.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventories.jsx');
	}();

	;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _inventoryAdjustments_actions = __webpack_require__(109);
	
	var _inventoryConverts_actions = __webpack_require__(59);
	
	var _inventoryAdjustmentForm = __webpack_require__(355);
	
	var _inventoryAdjustmentForm2 = _interopRequireDefault(_inventoryAdjustmentForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.Name) {
	        errors.Name = 'Required';
	    }
	    return errors;
	};
	
	var inventoryAdjustmentForm = (0, _reduxForm.reduxForm)({
	    form: 'inventoryAdjustmentForm',
	    validate: validate
	})(_inventoryAdjustmentForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('inventoryAdjustmentForm');
	
	function mapStateToProps(state) {
	    var toZoneValue = selector(state, 'ToZone');
	    var toBinValue = selector(state, 'ToBin');
	    var quantityValue = selector(state, 'Quantity');
	    var postingDate = selector(state, 'PostingDate');
	    var note = selector(state, 'Note');
	    return {
	        quantityValue: quantityValue,
	        toZoneValue: toZoneValue,
	        toBinValue: toBinValue,
	        postingDate: postingDate,
	        note: note,
	
	        currentInventoryAdjustment: state.inventoryAdjustments.currentInventoryAdjustment,
	        currentInventoryAdjustmentDetail: state.inventoryAdjustments.currentInventoryAdjustmentDetail,
	        detailIsLoading: state.inventoryAdjustments.detailIsLoading,
	        detailError: state.inventoryAdjustments.detailError,
	        initialValues: state.inventoryAdjustments.currentInventoryAdjustmentDetail,
	        isCreating: state.inventoryAdjustments.isCreating,
	        createError: state.inventoryAdjustments.createError,
	        created: state.inventoryAdjustments.created,
	        isEditing: state.inventoryAdjustments.isEditing,
	        editError: state.inventoryAdjustments.editError,
	        edited: state.inventoryAdjustments.edited,
	
	        inventories: state.inventoryConverts.inventories,
	        vendorIsLoading: state.inventories.isLoading,
	        vendorError: state.inventories.error,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { createInventoryAdjustment: _inventoryAdjustments_actions.createInventoryAdjustment, editInventoryAdjustment: _inventoryAdjustments_actions.editInventoryAdjustment, fetchInventoryAdjustmentDetail: _inventoryAdjustments_actions.fetchInventoryAdjustmentDetail, fetchInventories: _inventoryConverts_actions.fetchInventories })(inventoryAdjustmentForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryAdjustmentForm.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryAdjustmentForm.jsx');
	
	    __REACT_HOT_LOADER__.register(inventoryAdjustmentForm, 'inventoryAdjustmentForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryAdjustmentForm.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryAdjustmentForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryAdjustmentForm.jsx');
	}();

	;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _inventoryAdjustments_actions = __webpack_require__(109);
	
	var _reactRedux = __webpack_require__(6);
	
	var _inventoryConverts_actions = __webpack_require__(59);
	
	var _inventoryAdjustments = __webpack_require__(356);
	
	var _inventoryAdjustments2 = _interopRequireDefault(_inventoryAdjustments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	    return {
	        inventoryAdjustments: state.inventoryAdjustments.all,
	        isLoading: state.inventoryAdjustments.isLoading,
	        error: state.inventoryAdjustments.error,
	        currentInventoryAdjustment: state.inventoryAdjustments.currentInventoryAdjustment,
	        userPermissions: state.auth.userPermissions,
	        adjustmentDetail: state.inventoryAdjustments.adjustmentDetail,
	        adjustmentDetailError: state.inventoryAdjustments.adjustmentDetailError,
	        adjustmentDetailIsLoading: state.inventoryAdjustments.adjustmentDetailIsLoading
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { resetCurrentInventoryConvert: _inventoryConverts_actions.resetCurrentInventoryConvert, fetchInventoryAdjustments: _inventoryAdjustments_actions.fetchInventoryAdjustments, selectInventoryAdjustment: _inventoryAdjustments_actions.selectInventoryAdjustment, resetCurrentInventoryAdjustment: _inventoryAdjustments_actions.resetCurrentInventoryAdjustment, fetchInventoryAdjustmentsDetail: _inventoryAdjustments_actions.fetchInventoryAdjustmentsDetail })(_inventoryAdjustments2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryAdjustments.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryAdjustments.jsx');
	}();

	;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _inventoryConverts_actions = __webpack_require__(59);
	
	var _inventoryConvertForm = __webpack_require__(357);
	
	var _inventoryConvertForm2 = _interopRequireDefault(_inventoryConvertForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.Quantity) {
	        errors.Quantity = 'Required';
	    }
	    if (!values.ConvertedQuantity) {
	        errors.ConvertedQuantity = 'Required';
	    }
	    if (!values.ToZone) {
	        errors.ToZone = 'Required';
	    }
	    if (!values.ToBin) {
	        errors.ToBin = 'Required';
	    }
	    return errors;
	};
	
	var inventoryConvertForm = (0, _reduxForm.reduxForm)({
	    form: 'inventoryConvertForm',
	    validate: validate
	})(_inventoryConvertForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('inventoryConvertForm');
	
	function mapStateToProps(state) {
	    var toZoneValue = selector(state, 'ToZone');
	    var toBinValue = selector(state, 'ToBin');
	    var quantityValue = selector(state, 'Quantity');
	    var convertedQuantityValue = selector(state, 'ConvertedQuantity');
	    var postingDate = selector(state, 'PostingDate');
	    var note = selector(state, 'Note');
	    var processingFee = selector(state, 'ProcessingFee');
	    return {
	        quantityValue: quantityValue,
	        convertedQuantityValue: convertedQuantityValue,
	        toZoneValue: toZoneValue,
	        toBinValue: toBinValue,
	        postingDate: postingDate,
	        note: note,
	        processingFee: processingFee,
	
	        currentInventoryConvert: state.inventoryConverts.currentInventoryConvert,
	        currentInventoryConvertDetail: state.inventoryConverts.currentInventoryConvertDetail,
	        detailIsLoading: state.inventoryConverts.detailIsLoading,
	        detailError: state.inventoryConverts.detailError,
	        initialValues: state.inventoryConverts.currentInventoryConvertDetail,
	        isCreating: state.inventoryConverts.isCreating,
	        createError: state.inventoryConverts.createError,
	        created: state.inventoryConverts.created,
	        isEditing: state.inventoryConverts.isEditing,
	        editError: state.inventoryConverts.editError,
	        edited: state.inventoryConverts.edited,
	        inventories: state.inventoryConverts.inventories,
	
	        vendorIsLoading: state.inventories.isLoading,
	        vendorError: state.inventories.error,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { createInventoryConvert: _inventoryConverts_actions.createInventoryConvert, editInventoryConvert: _inventoryConverts_actions.editInventoryConvert, fetchInventoryConvertDetail: _inventoryConverts_actions.fetchInventoryConvertDetail, fetchInventories: _inventoryConverts_actions.fetchInventories })(inventoryConvertForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryConvertForm.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryConvertForm.jsx');
	
	    __REACT_HOT_LOADER__.register(inventoryConvertForm, 'inventoryConvertForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryConvertForm.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryConvertForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryConvertForm.jsx');
	}();

	;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _inventoryConverts_actions = __webpack_require__(59);
	
	var _reactRedux = __webpack_require__(6);
	
	var _inventoryConverts = __webpack_require__(358);
	
	var _inventoryConverts2 = _interopRequireDefault(_inventoryConverts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	    return {
	        inventoryConverts: state.inventoryConverts.all,
	        isLoading: state.inventoryConverts.isLoading,
	        error: state.inventoryConverts.error,
	        currentInventoryConvert: state.inventoryConverts.currentInventoryConvert,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchInventoryConverts: _inventoryConverts_actions.fetchInventoryConverts, selectInventoryConvert: _inventoryConverts_actions.selectInventoryConvert, resetCurrentInventoryConvert: _inventoryConverts_actions.resetCurrentInventoryConvert })(_inventoryConverts2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryConverts.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryConverts.jsx');
	}();

	;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _inventories_actions = __webpack_require__(38);
	
	var _inventoryAdjustments_actions = __webpack_require__(109);
	
	var _products_actions = __webpack_require__(30);
	
	var _settings_actions = __webpack_require__(33);
	
	var _inventoryDetail = __webpack_require__(359);
	
	var _inventoryDetail2 = _interopRequireDefault(_inventoryDetail);
	
	var _zones_actions = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inventoryDetail = (0, _reduxForm.reduxForm)({
	    form: 'inventoryDetail',
	    enableReinitialize: true
	})(_inventoryDetail2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('inventoryDetail');
	
	function mapStateToProps(state) {
	    var RefPriceValue = selector(state, 'RefPrice');
	    var ConvertType = selector(state, 'ConvertType');
	    var zoneID = selector(state, 'Default_WarehouseZone_id');
	
	    return {
	        RefPriceValue: RefPriceValue,
	        ConvertType: ConvertType,
	        zoneID: zoneID,
	
	        currentInventoryDetail: state.inventories.currentInventoryDetail,
	        currentProduct: state.products.currentProduct,
	        currentProductDetail: state.products.currentProductDetail,
	        initialValues: state.products.currentProductDetail,
	        detailIsLoading: state.inventories.detailIsLoading,
	        error: state.inventories.detailError,
	        currentInventory: state.inventories.currentInventory,
	        quickInventoryAdjustmentIsEditing: state.inventoryAdjustments.quickInventoryAdjustmentIsEditing,
	        quickInventoryAdjustmentEdited: state.inventoryAdjustments.quickInventoryAdjustmentEdited,
	        quickInventoryAdjustmentEditError: state.inventoryAdjustments.quickInventoryAdjustmentEditError,
	        inventoryBatchLogDetail: state.inventoryAdjustments.inventoryBatchLogDetail,
	        productReceiveHistory: state.inventoryAdjustments.productReceiveHistory,
	        filterUpdated: state.inventoryAdjustments.filterUpdated,
	        receiveTableFilterUpdated: state.inventoryAdjustments.receiveTableFilterUpdated,
	
	        CRVs: state.products.CRVs,
	        CRVsIsLoading: state.products.CRVsIsLoading,
	        CRVsError: state.products.CRVsError,
	        checkPassword: state.settings.checkPassword,
	        checkPasswordSuccess: state.settings.checkPasswordSuccess,
	        checkPasswordFailure: state.settings.checkPasswordFailure,
	
	        inventoryHistory: state.inventories.inventoryHistory,
	        inventoryHistoryIsLoading: state.inventories.inventoryHistoryIsLoading,
	        inventoryHistoryError: state.inventories.inventoryHistoryError,
	
	        zones: state.zones.all,
	        zoneError: state.zones.error,
	        zoneIsLoading: state.zones.isLoading,
	        bins: state.zones.bins,
	        binError: state.zones.binError,
	        binIsLoading: state.zones.binIsLoading
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	    fetchZones: _zones_actions.fetchZones, fetchBins: _zones_actions.fetchBins, resetBins: _zones_actions.resetBins,
	    fetchInventoryDetail: _inventories_actions.fetchInventoryDetail, fetchInventoryHistory: _inventories_actions.fetchInventoryHistory, quickAdjustment: _inventoryAdjustments_actions.quickAdjustment, resetQuickInventoryAdjustments: _inventoryAdjustments_actions.resetQuickInventoryAdjustments, fetchProductDetail: _products_actions.fetchProductDetail,
	    fetchCRVValues: _products_actions.fetchCRVValues, editProduct: _products_actions.editProduct, checkPassword: _settings_actions.checkPassword, clearCheckPassword: _settings_actions.clearCheckPassword, setValue: _products_actions.setValue, fetchInventoriesDetails: _inventories_actions.fetchInventoriesDetails, updateFilter: _inventories_actions.updateFilter, handleInventoryClick: _inventories_actions.handleInventoryClick,
	    updateReceiveTableFilter: _inventories_actions.updateReceiveTableFilter, fetchReceiveHistory: _inventories_actions.fetchReceiveHistory, fetchReceiveHistoryFilterInitial: _inventories_actions.fetchReceiveHistoryFilterInitial
	})(inventoryDetail);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryDetail.jsx');
	
	    __REACT_HOT_LOADER__.register(inventoryDetail, 'inventoryDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryDetail.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryDetail.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryDetail.jsx');
	}();

	;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _inventories_actions = __webpack_require__(38);
	
	var _reactRedux = __webpack_require__(6);
	
	var _inventoryExpired = __webpack_require__(360);
	
	var _inventoryExpired2 = _interopRequireDefault(_inventoryExpired);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	    return {
	        inventories: state.inventories.expiredInventories,
	        isLoading: state.inventories.expiredIsLoading,
	        error: state.inventories.expiredError,
	        currentInventory: state.inventories.currentInventory
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchExpiredInventories: _inventories_actions.fetchExpiredInventories, selectInventory: _inventories_actions.selectInventory, resetCurrentInventory: _inventories_actions.resetCurrentInventory })(_inventoryExpired2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryExpired.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryExpired.jsx');
	}();

	;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _inventories_actions = __webpack_require__(38);
	
	var _reactRedux = __webpack_require__(6);
	
	var _inventoryLowStock = __webpack_require__(361);
	
	var _inventoryLowStock2 = _interopRequireDefault(_inventoryLowStock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	    return {
	        inventories: state.inventories.lowStockInventories,
	        isLoading: state.inventories.lowStockIsLoading,
	        error: state.inventories.lowStockError,
	        currentInventory: state.inventories.currentInventory
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchLowStockInventoryInventories: _inventories_actions.fetchLowStockInventoryInventories, selectInventory: _inventories_actions.selectInventory, resetCurrentInventory: _inventories_actions.resetCurrentInventory })(_inventoryLowStock2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryLowStock.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryLowStock.jsx');
	}();

	;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _inventoryRelocations_actions = __webpack_require__(110);
	
	var _inventoryConverts_actions = __webpack_require__(59);
	
	var _warehouses_actions = __webpack_require__(44);
	
	var _inventoryRelocationForm = __webpack_require__(362);
	
	var _inventoryRelocationForm2 = _interopRequireDefault(_inventoryRelocationForm);
	
	var _zones_actions = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.Quantity) {
	        errors.Quantity = 'Required';
	    }
	    return errors;
	};
	
	var inventoryRelocationForm = (0, _reduxForm.reduxForm)({
	    form: 'inventoryRelocationForm',
	    validate: validate
	})(_inventoryRelocationForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('inventoryRelocationForm');
	
	function mapStateToProps(state) {
	    var _ref;
	
	    var toZoneValue = selector(state, 'ToZone');
	    var toBinValue = selector(state, 'ToBin');
	    var quantityValue = selector(state, 'Quantity');
	    var postingDate = selector(state, 'PostingDate');
	    var note = selector(state, 'Note');
	    var Default_Warehouse_id = selector(state, 'Default_Warehouse_id');
	    var Default_WarehouseZone_id = selector(state, 'Default_WarehouseZone_id');
	    return _ref = {
	        Default_Warehouse_id: Default_Warehouse_id,
	        Default_WarehouseZone_id: Default_WarehouseZone_id,
	        quantityValue: quantityValue,
	        toZoneValue: toZoneValue,
	        toBinValue: toBinValue,
	        postingDate: postingDate,
	        note: note,
	
	        currentZoneDetail: state.zones.currentZoneDetail,
	        bins: state.zones.bins,
	        detailIsLoading: state.zones.detailIsLoading,
	        detailError: state.zones.detailError,
	
	        currentInventoryRelocation: state.inventoryRelocations.currentInventoryRelocation,
	        currentInventoryRelocationDetail: state.inventoryRelocations.currentInventoryRelocationDetail
	    }, _defineProperty(_ref, 'detailIsLoading', state.inventoryRelocations.detailIsLoading), _defineProperty(_ref, 'detailError', state.inventoryRelocations.detailError), _defineProperty(_ref, 'initialValues', state.inventoryRelocations.currentInventoryRelocationDetail), _defineProperty(_ref, 'isCreating', state.inventoryRelocations.isCreating), _defineProperty(_ref, 'createError', state.inventoryRelocations.createError), _defineProperty(_ref, 'created', state.inventoryRelocations.created), _defineProperty(_ref, 'isEditing', state.inventoryRelocations.isEditing), _defineProperty(_ref, 'editError', state.inventoryRelocations.editError), _defineProperty(_ref, 'edited', state.inventoryRelocations.edited), _defineProperty(_ref, 'inventories', state.inventoryConverts.inventories), _defineProperty(_ref, 'vendorIsLoading', state.inventories.isLoading), _defineProperty(_ref, 'vendorError', state.inventories.error), _defineProperty(_ref, 'warehouses', state.warehouses.all), _defineProperty(_ref, 'currentWarehouseDetail', state.warehouses.currentWarehouseDetail), _defineProperty(_ref, 'userPermissions', state.auth.userPermissions), _ref;
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchWarehouses: _warehouses_actions.fetchWarehouses, fetchWarehouseDetail: _warehouses_actions.fetchWarehouseDetail, createInventoryRelocation: _inventoryRelocations_actions.createInventoryRelocation, editInventoryRelocation: _inventoryRelocations_actions.editInventoryRelocation, fetchInventoryRelocationDetail: _inventoryRelocations_actions.fetchInventoryRelocationDetail, fetchInventories: _inventoryConverts_actions.fetchInventories, fetchZoneDetail: _zones_actions.fetchZoneDetail })(inventoryRelocationForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryRelocationForm.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryRelocationForm.jsx');
	
	    __REACT_HOT_LOADER__.register(inventoryRelocationForm, 'inventoryRelocationForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryRelocationForm.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryRelocationForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryRelocationForm.jsx');
	}();

	;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _inventoryRelocations_actions = __webpack_require__(110);
	
	var _inventoryConverts_actions = __webpack_require__(59);
	
	var _inventoryRelocationFromInbound = __webpack_require__(363);
	
	var _inventoryRelocationFromInbound2 = _interopRequireDefault(_inventoryRelocationFromInbound);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.Quantity) {
	        errors.Quantity = 'Required';
	    }
	    return errors;
	};
	
	var inventoryRelocationFromInbound = (0, _reduxForm.reduxForm)({
	    form: 'inventoryRelocationFromInbound',
	    validate: validate
	})(_inventoryRelocationFromInbound2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('inventoryRelocationFromInbound');
	
	function mapStateToProps(state) {
	    var postingDate = selector(state, 'PostingDate');
	    var note = selector(state, 'Note');
	    return {
	        postingDate: postingDate,
	        note: note,
	
	        currentInventoryRelocation: state.inventoryRelocations.currentInventoryRelocation,
	        currentInventoryRelocationDetail: state.inventoryRelocations.currentInventoryRelocationDetail,
	        detailIsLoading: state.inventoryRelocations.detailIsLoading,
	        detailError: state.inventoryRelocations.detailError,
	        initialValues: state.inventoryRelocations.currentInventoryRelocationDetail,
	        isCreating: state.inventoryRelocations.isCreating,
	        createError: state.inventoryRelocations.createError,
	        created: state.inventoryRelocations.created,
	        isEditing: state.inventoryRelocations.isEditing,
	        editError: state.inventoryRelocations.editError,
	        edited: state.inventoryRelocations.edited,
	
	        inventories: state.inventoryConverts.inventories,
	        vendorIsLoading: state.inventories.isLoading,
	        vendorError: state.inventories.error,
	        currentWarehouseReceive: state.putAway.currentWarehouseReceive
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { createInventoryRelocation: _inventoryRelocations_actions.createInventoryRelocation, editInventoryRelocation: _inventoryRelocations_actions.editInventoryRelocation, fetchInventoryRelocationDetail: _inventoryRelocations_actions.fetchInventoryRelocationDetail, fetchInventories: _inventoryConverts_actions.fetchInventories })(inventoryRelocationFromInbound);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryRelocationFromInbound.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryRelocationFromInbound.jsx');
	
	    __REACT_HOT_LOADER__.register(inventoryRelocationFromInbound, 'inventoryRelocationFromInbound', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryRelocationFromInbound.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryRelocationFromInbound.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryRelocationFromInbound.jsx');
	}();

	;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _inventoryRelocations_actions = __webpack_require__(110);
	
	var _inventoryConverts_actions = __webpack_require__(59);
	
	var _reactRedux = __webpack_require__(6);
	
	var _inventoryRelocations = __webpack_require__(364);
	
	var _inventoryRelocations2 = _interopRequireDefault(_inventoryRelocations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	    return {
	        inventoryRelocations: state.inventoryRelocations.all,
	        isLoading: state.inventoryRelocations.isLoading,
	        error: state.inventoryRelocations.error,
	        currentInventoryRelocation: state.inventoryRelocations.currentInventoryRelocation,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { resetCurrentInventoryConvert: _inventoryConverts_actions.resetCurrentInventoryConvert, fetchInventoryRelocations: _inventoryRelocations_actions.fetchInventoryRelocations, selectInventoryRelocation: _inventoryRelocations_actions.selectInventoryRelocation, resetCurrentInventoryRelocation: _inventoryRelocations_actions.resetCurrentInventoryRelocation })(_inventoryRelocations2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryRelocations.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryRelocations.jsx');
	}();

	;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _inventoryRepackages_actions = __webpack_require__(133);
	
	var _inventoryConverts_actions = __webpack_require__(59);
	
	var _inventoryRepackageForm = __webpack_require__(365);
	
	var _inventoryRepackageForm2 = _interopRequireDefault(_inventoryRepackageForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.Quantity) {
	        errors.Quantity = 'Required';
	    }
	    if (!values.RepackagedQuantity) {
	        errors.RepackagedQuantity = 'Required';
	    }
	    return errors;
	};
	
	var inventoryRepackageForm = (0, _reduxForm.reduxForm)({
	    form: 'inventoryRepackageForm',
	    validate: validate
	})(_inventoryRepackageForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('inventoryRepackageForm');
	
	function mapStateToProps(state) {
	    var quantityValue = selector(state, 'Quantity');
	    var repackagedQuantityValue = selector(state, 'RepackagedQuantity');
	    var postingDate = selector(state, 'PostingDate');
	    var note = selector(state, 'Note');
	    return {
	        quantityValue: quantityValue,
	        repackagedQuantityValue: repackagedQuantityValue,
	        postingDate: postingDate,
	        note: note,
	
	        currentInventoryRepackage: state.inventoryRepackages.currentInventoryRepackage,
	        currentInventoryRepackageDetail: state.inventoryRepackages.currentInventoryRepackageDetail,
	        detailIsLoading: state.inventoryRepackages.detailIsLoading,
	        detailError: state.inventoryRepackages.detailError,
	        initialValues: state.inventoryRepackages.currentInventoryRepackageDetail,
	        isCreating: state.inventoryRepackages.isCreating,
	        createError: state.inventoryRepackages.createError,
	        created: state.inventoryRepackages.created,
	        isEditing: state.inventoryRepackages.isEditing,
	        editError: state.inventoryRepackages.editError,
	        edited: state.inventoryRepackages.edited,
	
	        inventories: state.inventoryConverts.inventories,
	        vendorIsLoading: state.inventories.isLoading,
	        vendorError: state.inventories.error,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { createInventoryRepackage: _inventoryRepackages_actions.createInventoryRepackage, editInventoryRepackage: _inventoryRepackages_actions.editInventoryRepackage, fetchInventoryRepackageDetail: _inventoryRepackages_actions.fetchInventoryRepackageDetail, fetchInventories: _inventoryConverts_actions.fetchInventories })(inventoryRepackageForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryRepackageForm.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryRepackageForm.jsx');
	
	    __REACT_HOT_LOADER__.register(inventoryRepackageForm, 'inventoryRepackageForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryRepackageForm.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryRepackageForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryRepackageForm.jsx');
	}();

	;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _inventoryRepackages_actions = __webpack_require__(133);
	
	var _inventoryConverts_actions = __webpack_require__(59);
	
	var _reactRedux = __webpack_require__(6);
	
	var _inventoryRepackages = __webpack_require__(366);
	
	var _inventoryRepackages2 = _interopRequireDefault(_inventoryRepackages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	    return {
	        inventoryRepackages: state.inventoryRepackages.all,
	        isLoading: state.inventoryRepackages.isLoading,
	        error: state.inventoryRepackages.error,
	        currentInventoryRepackage: state.inventoryRepackages.currentInventoryRepackage,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { resetCurrentInventoryConvert: _inventoryConverts_actions.resetCurrentInventoryConvert, fetchInventoryRepackages: _inventoryRepackages_actions.fetchInventoryRepackages, selectInventoryRepackage: _inventoryRepackages_actions.selectInventoryRepackage, resetCurrentInventoryRepackage: _inventoryRepackages_actions.resetCurrentInventoryRepackage })(_inventoryRepackages2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryRepackages.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/inventoryRepackages.jsx');
	}();

	;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _inventories_actions = __webpack_require__(38);
	
	var _products_actions = __webpack_require__(30);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _productConvert = __webpack_require__(367);
	
	var _productConvert2 = _interopRequireDefault(_productConvert);
	
	var _settings_actions = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var productConvertReport = (0, _reduxForm.reduxForm)({
	  form: 'productConvertReport',
	  destroyOnUnmount: false
	})(_productConvert2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('productConvertReport');
	
	function mapStateToProps(state) {
	  var PackageSize = selector(state, 'PackageSize');
	  var Stock = selector(state, 'Stock');
	  var EffectDate = selector(state, 'EffectDate');
	  return {
	    PackageSize: PackageSize,
	    Stock: Stock,
	    EffectDate: EffectDate,
	    lowInventoriesIsLoading: state.inventories.lowInventoriesIsLoading,
	    lowInventories: state.inventories.lowInventories,
	    lowInventoriesError: state.inventories.lowInventoriesError,
	    workingOrdersIsLoading: state.inventories.workingOrdersIsLoading,
	    workingOrders: state.inventories.workingOrders,
	    workingOrdersError: state.inventories.workingOrdersError,
	    checkPassword: state.settings.checkPassword,
	    checkPasswordSuccess: state.settings.checkPasswordSuccess,
	    checkPasswordFailure: state.settings.checkPasswordFailure
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchLowInventories: _inventories_actions.fetchLowInventories,
	  fetchWorkingOrders: _inventories_actions.fetchWorkingOrders,
	  fetchRelatedProducts: _products_actions.fetchRelatedProducts,
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	  checkPassword: _settings_actions.checkPassword,
	  clearCheckPassword: _settings_actions.clearCheckPassword
	})(productConvertReport);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/productConvert.jsx');
	
	  __REACT_HOT_LOADER__.register(productConvertReport, 'productConvertReport', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/productConvert.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/productConvert.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/productConvert.jsx');
	}();

	;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _inventoryConverts_actions = __webpack_require__(59);
	
	var _productConvertDetail = __webpack_require__(368);
	
	var _productConvertDetail2 = _interopRequireDefault(_productConvertDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var productConvertDetail = (0, _reduxForm.reduxForm)({
	  form: 'productConvertDetail'
	})(_productConvertDetail2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('productConvertDetail');
	
	function mapStateToProps(state) {
	  var Convert = selector(state, 'Convert');
	  var Prod1Qty = selector(state, 'Prod1Qty');
	  var Prod2Qty = selector(state, 'Prod2Qty');
	  return {
	    Convert: Convert,
	    Prod1Qty: Prod1Qty,
	    Prod2Qty: Prod2Qty,
	    currentProductDetail: state.products.currentProductDetail,
	    detailIsLoading: state.products.detailIsLoading,
	    detailError: state.products.detailError,
	    fetchingRelatedProducts: state.products.fetchingRelatedProducts,
	    relatedProductsFetched: state.products.relatedProductsFetched,
	    relatedProductsFetchError: state.products.relatedProductsFetchError,
	    inventoryConvertIsCreating: state.inventoryConverts.inventoryConvertIsCreating,
	    inventoryConvertCreated: state.inventoryConverts.inventoryConvertCreated
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { setField: _inventoryConverts_actions.setField, createNewConvert: _inventoryConverts_actions.createNewConvert })(productConvertDetail);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/productConvertDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(productConvertDetail, 'productConvertDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/productConvertDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/productConvertDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/productConvertDetail.jsx');
	}();

	;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _putAway_actions = __webpack_require__(81);
	
	var _reactRedux = __webpack_require__(6);
	
	var _putAway = __webpack_require__(369);
	
	var _putAway2 = _interopRequireDefault(_putAway);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	    return {
	        putAway: state.putAway.all,
	        isLoading: state.putAway.isLoading,
	        error: state.putAway.error,
	        userPermissions: state.auth.userPermissions
	    };
	}
	// import { fetchScrapRecords, selectScrapRecord, resetCurrentScrapRecord } from '../../actions/scrapRecords_actions';
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { selectPutAway: _putAway_actions.selectPutAway, fetchPutAway: _putAway_actions.fetchPutAway, resetCurrentPutAway: _putAway_actions.resetCurrentPutAway })(_putAway2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/putAway.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/putAway.jsx');
	}();

	;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _putAway_actions = __webpack_require__(81);
	
	var _receive_actions = __webpack_require__(66);
	
	var _zones_actions = __webpack_require__(60);
	
	var _reactRedux = __webpack_require__(6);
	
	var _warehouses_actions = __webpack_require__(44);
	
	var _putAwayForm = __webpack_require__(370);
	
	var _putAwayForm2 = _interopRequireDefault(_putAwayForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import { fetchScrapRecords, selectScrapRecord, resetCurrentScrapRecord } from '../../actions/scrapRecords_actions';
	var putAwayForm = (0, _reduxForm.reduxForm)({
	    form: 'putAwayForm'
	})(_putAwayForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('putAwayForm');
	
	function mapStateToProps(state) {
	    var zone_id = selector(state, 'Zone_id');
	    var Default_Warehouse_id = selector(state, 'Default_Warehouse_id');
	    var Default_WarehouseZone_id = selector(state, 'Default_WarehouseZone_id');
	    return {
	        Default_Warehouse_id: Default_Warehouse_id,
	        Default_WarehouseZone_id: Default_WarehouseZone_id,
	        zone_id: zone_id,
	        putAway: state.putAway.all,
	        isLoading: state.putAway.isLoading,
	        error: state.putAway.error,
	        receiveHistory: state.receives.fetchedReceiveHistory,
	        allReceiveHistoryDetail: state.receives.fetchedAllReceiveHistoryDetail,
	        receiveHistoryDetail: state.receives.fetchedReceiveHistoryDetail,
	        currentPutAway: state.putAway.currentPutAway,
	        currentPutAwayDetail: state.putAway.currentPutAwayDetail,
	        currentZoneDetail: state.zones.currentZoneDetail,
	        bins: state.zones.bins,
	        detailIsLoading: state.zones.detailIsLoading,
	        detailError: state.zones.detailError,
	        binList: state.putAway.fetchedBinList,
	        binListError: state.putAway.fetchBinListError,
	        warehouses: state.warehouses.all,
	        currentWarehouseDetail: state.warehouses.currentWarehouseDetail,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchWarehouses: _warehouses_actions.fetchWarehouses, fetchWarehouseDetail: _warehouses_actions.fetchWarehouseDetail, resetCurrentWarehouseReceive: _putAway_actions.resetCurrentWarehouseReceive, selectWarehouseReceive: _putAway_actions.selectWarehouseReceive, fetchPutAwayDetail: _putAway_actions.fetchPutAwayDetail, createPutAway: _putAway_actions.createPutAway, editPutAway: _putAway_actions.editPutAway, fetchReceiveHistoryDetail: _receive_actions.fetchReceiveHistoryDetail, fetchAllReceiveHistoryDetail: _receive_actions.fetchAllReceiveHistoryDetail, fetchReceiveHistory: _receive_actions.fetchReceiveHistory, fetchPutAway: _putAway_actions.fetchPutAway, resetCurrentPutAway: _putAway_actions.resetCurrentPutAway, fetchZoneDetail: _zones_actions.fetchZoneDetail, createBins: _putAway_actions.createBins, fetchBinList: _putAway_actions.fetchBinList })(putAwayForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/putAwayForm.jsx');
	
	    __REACT_HOT_LOADER__.register(putAwayForm, 'putAwayForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/putAwayForm.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/putAwayForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/putAwayForm.jsx');
	}();

	;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _receive_actions = __webpack_require__(66);
	
	var _inventories_actions = __webpack_require__(38);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _print_actions = __webpack_require__(47);
	
	var _receiveForm = __webpack_require__(371);
	
	var _receiveForm2 = _interopRequireDefault(_receiveForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	  var errors = {};
	  if (!values.Name) {
	    errors.Name = 'Required';
	  }
	  return errors;
	};
	
	var receiveForm = (0, _reduxForm.reduxForm)({
	  form: 'receiveForm',
	  validate: validate
	})(_receiveForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('receiveForm');
	
	function mapStateToProps(state) {
	  var toZoneValue = selector(state, 'ToZone');
	  var toBinValue = selector(state, 'ToBin');
	  var rcvQuantityValue = selector(state, 'RcvQuantity');
	  var rcvUnitPriceValue = selector(state, 'RcvUnitPrice');
	  var rcvTotalPriceValue = selector(state, 'RcvTotalPrice');
	  var palletValue = selector(state, 'Pallet');
	  var storageRateValue = selector(state, 'StorageRate');
	  var rtnQuantityValue = selector(state, 'RtnQuantity');
	  var postingDate = selector(state, 'PostingDate');
	  var note = selector(state, 'Note');
	  var HandlingCost = selector(state, 'HandlingCost');
	  var MiscCost = selector(state, 'MiscCost');
	  var ShippingCost = selector(state, 'ShippingCost');
	  var priceAdjustment = selector(state, 'PriceAdjustment');
	  var ShareCost = selector(state, 'ShareCost');
	  var InvoiceFinalPrice = selector(state, 'InvoiceFinalPrice') || 0;
	  var TaxRate = selector(state, 'TaxRate') || 0;
	  var TotalCRV = selector(state, 'TotalCRV');
	  var InvoiceNum = selector(state, 'InvoiceNum');
	  var PackingNum = selector(state, 'PackingNum');
	  var PostingDate = selector(state, 'PostingDate');
	  var InvoiceDate = selector(state, 'InvoiceDate');
	  var ReceivingPrice = selector(state, 'ReceivingPrice');
	  var Warehouse = selector(state, 'Warehouse');
	  var container_num = selector(state, 'container_num');
	
	  return {
	    note: note,
	    rcvQuantityValue: rcvQuantityValue,
	    rcvUnitPriceValue: rcvUnitPriceValue,
	    rcvTotalPriceValue: rcvTotalPriceValue,
	    palletValue: palletValue,
	    storageRateValue: storageRateValue,
	    rtnQuantityValue: rtnQuantityValue,
	    toZoneValue: toZoneValue,
	    toBinValue: toBinValue,
	    postingDate: postingDate,
	    HandlingCost: HandlingCost,
	    MiscCost: MiscCost,
	    ShippingCost: ShippingCost,
	    priceAdjustment: priceAdjustment,
	    ShareCost: ShareCost,
	    InvoiceFinalPrice: InvoiceFinalPrice,
	    TaxRate: TaxRate,
	    TotalCRV: TotalCRV,
	    InvoiceNum: InvoiceNum,
	    PackingNum: PackingNum,
	    PostingDate: PostingDate,
	    InvoiceDate: InvoiceDate,
	    ReceivingPrice: ReceivingPrice,
	    Warehouse: Warehouse,
	    container_num: container_num,
	
	    currentReceive: state.receives.currentReceive,
	    currentReceiveDetail: state.receives.currentReceiveDetail,
	    detailIsLoading: state.receives.detailIsLoading,
	    detailError: state.receives.detailError,
	    isCreating: state.receives.isCreating,
	    createError: state.receives.createError,
	    created: state.receives.created,
	    createdReceive: state.receives.createdReceive,
	    isEditing: state.receives.isEditing,
	    editError: state.receives.editError,
	    edited: state.receives.edited,
	    isCompleting: state.receives.isCompleting,
	    completeError: state.receives.completeError,
	    completed: state.receives.completed,
	    initialValues: state.receives.currentReceiveDetail,
	    receiveLoading: state.receives.receiveLoading,
	
	    currentPurchaseOrder: state.purchaseOrders.currentPurchaseOrder,
	    currentPurchaseOrderDetail: state.purchaseOrders.currentPurchaseOrderDetail,
	
	    inventories: state.inventories.all,
	    inventoriesIsLoading: state.inventories.isLoading,
	    inventoriesError: state.inventories.error,
	
	    requestingWarehouseReceivePdf: state.print.requestingWarehouseReceivePdf,
	    warehouseReceivePdf: state.print.warehouseReceivePdf
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  completePurchaseOrder: _receive_actions.completePurchaseOrder,
	  createReceive: _receive_actions.createReceive,
	  resetCreateReceive: _receive_actions.resetCreateReceive,
	  editReceive: _receive_actions.editReceive,
	  fetchReceiveDetail: _receive_actions.fetchReceiveDetail,
	  fetchInventories: _inventories_actions.fetchInventories,
	  fetchPurchaseOrderDetail: _purchaseOrders_actions.fetchPurchaseOrderDetail,
	  convertPOToReceive: _receive_actions.convertPOToReceive,
	  setPostingDate: _receive_actions.setPostingDate,
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	  printWarehouseReceive: _print_actions.printWarehouseReceive
	})(receiveForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/receiveForm.jsx');
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/receiveForm.jsx');
	
	  __REACT_HOT_LOADER__.register(receiveForm, 'receiveForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/receiveForm.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/receiveForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/receiveForm.jsx');
	}();

	;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _receive_actions = __webpack_require__(66);
	
	var _sales_actions = __webpack_require__(28);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _print_actions = __webpack_require__(47);
	
	var _products_actions = __webpack_require__(30);
	
	var _receiveHistoryDetail = __webpack_require__(372);
	
	var _receiveHistoryDetail2 = _interopRequireDefault(_receiveHistoryDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var receiveHistoryDetail = (0, _reduxForm.reduxForm)({
	  form: 'receiveHistoryDetail'
	})(_receiveHistoryDetail2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('receiveHistoryDetail');
	
	function mapStateToProps(state) {
	  var HandlingCost = selector(state, 'HandlingCost');
	  var MiscCost = selector(state, 'MiscCost');
	  var ShippingCost = selector(state, 'ShippingCost');
	  var priceAdjustment = selector(state, 'PriceAdjustment');
	  var InvoiceFinalPrice = selector(state, 'InvoiceFinalPrice');
	  var TaxRate = selector(state, 'TaxRate');
	  var TotalCRV = selector(state, 'TotalCRV');
	  var quantityValue = selector(state, 'Quantity');
	  var searchType = selector(state, 'searchType');
	  var customerChosen = selector(state, 'customerChosen');
	  var unitPrice = selector(state, 'unitPrice');
	  var remark = selector(state, 'itemNotation');
	  var weight = selector(state, 'Weight');
	
	  return {
	    HandlingCost: HandlingCost,
	    MiscCost: MiscCost,
	    ShippingCost: ShippingCost,
	    priceAdjustment: priceAdjustment,
	    InvoiceFinalPrice: InvoiceFinalPrice,
	    TaxRate: TaxRate,
	    TotalCRV: TotalCRV,
	    quantityValue: quantityValue,
	    searchType: searchType,
	    customerChosen: customerChosen,
	    unitPrice: unitPrice,
	    remark: remark,
	    weight: weight,
	    currentReceiveHistory: state.receives.currentReceiveHistory,
	    currentReceiveHistoryDetail: state.receives.fetchedReceiveHistoryDetailRecord,
	    detailIsLoading: state.receives.isfetchingReceiveHistoryDetail,
	    error: state.receives.fetchReceiveHistoryDetailError,
	    initialValues: state.receives.fetchedReceiveHistoryDetailRecord,
	
	    isEditingReveiveHistory: state.receives.isEditingReveiveHistory,
	    editedReceiveHistory: state.receives.editedReceiveHistory,
	
	    simplifiedProducts: state.products.simplifiedProducts,
	    simplifiedProductsIsLoading: state.products.simplifiedProductsIsLoading,
	    simplifiedProductsError: state.products.simplifiedProductsError,
	
	    taxRates: state.salesOrders.taxRates,
	    taxRatesIsLoading: state.salesOrders.taxRatesIsLoading,
	    taxRatesError: state.salesOrders.taxRatesError,
	
	    purchaseOrderProduct: state.purchaseOrders.purchaseOrderProduct,
	    purchaseOrderProductIsLoading: state.purchaseOrders.purchaseOrderProductIsLoading,
	    purchaseOrderProductError: state.purchaseOrders.purchaseOrderProductError,
	    requestingWarehouseReceivePdf: state.print.requestingWarehouseReceivePdf,
	    warehouseReceivePdf: state.print.warehouseReceivePdf
	
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  editReceiveHistory: _receive_actions.editReceiveHistory,
	  fetchProductInfo: _products_actions.fetchProductInfo,
	  fetchProductsByVendor: _products_actions.fetchProductsByVendor,
	  fetchReceiveHistoryDetailRecord: _receive_actions.fetchReceiveHistoryDetailRecord,
	  fetchSimplifiedProducts: _products_actions.fetchSimplifiedProducts,
	  printWarehouseReceive: _print_actions.printWarehouseReceive,
	  resetAllProducts: _purchaseOrders_actions.resetAllProducts,
	  resetEditReceiveHistory: _receive_actions.resetEditReceiveHistory,
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	  setDefaultSearchType: _purchaseOrders_actions.setDefaultSearchType,
	  setValue: _sales_actions.setValue
	})(receiveHistoryDetail);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/receiveHistoryDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(receiveHistoryDetail, 'receiveHistoryDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/receiveHistoryDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/receiveHistoryDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/receiveHistoryDetail.jsx');
	}();

	;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _receive_actions = __webpack_require__(66);
	
	var _putAway_actions = __webpack_require__(81);
	
	var _settings_actions = __webpack_require__(33);
	
	var _print_actions = __webpack_require__(47);
	
	var _baseModal_actions = __webpack_require__(80);
	
	var _receiveHistoryList = __webpack_require__(373);
	
	var _receiveHistoryList2 = _interopRequireDefault(_receiveHistoryList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var receiveHistoryList = (0, _reduxForm.reduxForm)({
	    form: 'receiveHistoryList',
	    destroyOnUnmount: false
	})(_receiveHistoryList2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('receiveHistoryList');
	
	function mapStateToProps(state) {
	    var Days = selector(state, 'Days');
	    var FromDate = selector(state, 'FromDate');
	    var ToDate = selector(state, 'ToDate');
	    return {
	        Days: Days,
	        FromDate: FromDate,
	        ToDate: ToDate,
	        currentReceiveHistory: state.receives.fetchedReceiveHistory,
	        isfetchingReceiveHistory: state.receives.isfetchingReceiveHistory,
	        isLoading: state.receives.isfetchingReceiveHistory,
	        error: state.receives.fetchReceiveHistoryError,
	        currentReceiveHistoryDetail: state.receives.fetchedReceiveHistoryDetailRecord,
	
	        voidStatus: state.receives.voidStatus,
	        voidIsLoading: state.receives.voidIsLoading,
	        voidError: state.receives.voidError,
	
	        checkingPermission: state.settings.checkingPermission,
	        checkPermissionSuccess: state.settings.checkPermissionSuccess,
	        checkPermissionFailure: state.settings.checkPermissionFailure,
	
	        requestingWarehouseReceivePdf: state.print.requestingWarehouseReceivePdf,
	        warehouseReceivePdf: state.print.warehouseReceivePdf,
	        passcodeVerified: state.baseModals.confirmPasscodeModal.verified
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	    setDefaultDays: _purchaseOrders_actions.setDefaultDays,
	    setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	    fetchReceiveHistoryByDate: _receive_actions.fetchReceiveHistoryByDate,
	    selectReceiveHistory: _receive_actions.selectReceiveHistory,
	    resetCurrentReceiveHistory: _receive_actions.resetCurrentReceiveHistory,
	    fetchPurchaseOrders: _purchaseOrders_actions.fetchPurchaseOrders,
	    fetchReceiveHistory: _receive_actions.fetchReceiveHistory,
	    fetchReceiveHistoryDetailRecord: _receive_actions.fetchReceiveHistoryDetailRecord,
	    voidReceiving: _receive_actions.voidReceiving,
	    autoPutaway: _putAway_actions.autoPutaway,
	    checkPermission: _settings_actions.checkPermission,
	    resetDeleteStatus: _receive_actions.resetDeleteStatus,
	    printWarehouseReceive: _print_actions.printWarehouseReceive,
	    setConfirmPasscodeModalVisibility: _baseModal_actions.setConfirmPasscodeModalVisibility,
	    setPasscodeVerificationStatus: _baseModal_actions.setPasscodeVerificationStatus,
	    fetchLineLabel: _print_actions.fetchLineLabel
	})(receiveHistoryList);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/receiveHistoryList.jsx');
	
	    __REACT_HOT_LOADER__.register(receiveHistoryList, 'receiveHistoryList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/receiveHistoryList.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/receiveHistoryList.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/receiveHistoryList.jsx');
	}();

	;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _receive_actions = __webpack_require__(66);
	
	var _receiveList = __webpack_require__(374);
	
	var _receiveList2 = _interopRequireDefault(_receiveList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    currentReceive: state.receives.currentReceive,
	    receives: state.receives.all,
	    isLoading: state.receives.isLoading,
	    error: state.receives.errors,
	    userPermissions: state.auth.userPermissions
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  selectPurchaseOrder: _purchaseOrders_actions.selectPurchaseOrder,
	  resetCurrentPurchaseOrder: _purchaseOrders_actions.resetCurrentPurchaseOrder,
	  fetchPurchaseOrders: _purchaseOrders_actions.fetchPurchaseOrders,
	  selectReceive: _receive_actions.selectReceive,
	  resetCurrentReceive: _receive_actions.resetCurrentReceive,
	  fetchReceives: _receive_actions.fetchReceives
	})(_receiveList2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/receiveList.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/receiveList.jsx');
	}();

	;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _receiveModal = __webpack_require__(375);
	
	var _receiveModal2 = _interopRequireDefault(_receiveModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.Name) {
	        errors.Name = 'Required';
	    }
	    if (values.IsEnabled === null) {
	        errors.IsEnabled = 'Required';
	    }
	    return errors;
	};
	
	var receiveModal = (0, _reduxForm.reduxForm)({
	    form: 'receiveModal'
	})(_receiveModal2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('receiveModal');
	
	function mapStateToProps(state) {
	    var purchaseOrderValue = selector(state, 'PurchaseOrder_id');
	    return {
	        purchaseOrderValue: purchaseOrderValue,
	
	        currentPurchaseOrder: state.purchaseOrders.currentPurchaseOrder,
	        purchaseOrders: state.purchaseOrders.all,
	        isLoading: state.purchaseOrders.isLoading,
	        error: state.purchaseOrders.error
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchPurchaseOrders: _purchaseOrders_actions.fetchPurchaseOrders, selectPurchaseOrder: _purchaseOrders_actions.selectPurchaseOrder, resetCurrentPurchaseOrder: _purchaseOrders_actions.resetCurrentPurchaseOrder })(receiveModal);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/receiveModal.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/receiveModal.jsx');
	
	    __REACT_HOT_LOADER__.register(receiveModal, 'receiveModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/receiveModal.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/receiveModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/receiveModal.jsx');
	}();

	;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _scrapRecords_actions = __webpack_require__(142);
	
	var _inventories_actions = __webpack_require__(38);
	
	var _products_actions = __webpack_require__(30);
	
	var _scrapRecordForm = __webpack_require__(376);
	
	var _scrapRecordForm2 = _interopRequireDefault(_scrapRecordForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.Name) {
	        errors.Name = 'Required';
	    }
	    return errors;
	};
	
	var scrapRecordForm = (0, _reduxForm.reduxForm)({
	    form: 'scrapRecordForm',
	    validate: validate
	})(_scrapRecordForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('scrapRecordForm');
	
	function mapStateToProps(state) {
	    var quantityValue = selector(state, 'Quantity');
	    var productValue = selector(state, 'ProductNum');
	    return {
	        quantityValue: quantityValue,
	        productValue: productValue,
	
	        currentScrapRecord: state.scrapRecords.currentScrapRecord,
	        currentScrapRecordDetail: state.scrapRecords.currentScrapRecordDetail,
	        detailIsLoading: state.scrapRecords.detailIsLoading,
	        detailError: state.scrapRecords.detailError,
	        isCreating: state.scrapRecords.isCreating,
	        createError: state.scrapRecords.createError,
	        created: state.scrapRecords.created,
	        isEditing: state.scrapRecords.isEditing,
	        editError: state.scrapRecords.editError,
	        edited: state.scrapRecords.edited,
	
	        inventories: state.inventories.all,
	        vendorIsLoading: state.inventories.isLoading,
	        vendorError: state.inventories.error,
	
	        scrapRecordsInventories: state.scrapRecords.inventories,
	        inventoriesIsLoading: state.scrapRecords.inventoriesIsLoading,
	        inventoriesError: state.scrapRecords.inventoriesError,
	        products: state.products.all,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { editScrapRecord: _scrapRecords_actions.editScrapRecord, createScrapRecord: _scrapRecords_actions.createScrapRecord, fetchProducts: _products_actions.fetchProducts, fetchInventoryScrap: _scrapRecords_actions.fetchInventoryScrap, fetchScrapRecordDetail: _scrapRecords_actions.fetchScrapRecordDetail, fetchInventories: _inventories_actions.fetchInventories })(scrapRecordForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/scrapRecordForm.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/scrapRecordForm.jsx');
	
	    __REACT_HOT_LOADER__.register(scrapRecordForm, 'scrapRecordForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/scrapRecordForm.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/scrapRecordForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/scrapRecordForm.jsx');
	}();

	;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _scrapRecords_actions = __webpack_require__(142);
	
	var _reactRedux = __webpack_require__(6);
	
	var _scrapRecords = __webpack_require__(377);
	
	var _scrapRecords2 = _interopRequireDefault(_scrapRecords);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	    return {
	        scrapRecords: state.scrapRecords.all,
	        isLoading: state.scrapRecords.isLoading,
	        error: state.scrapRecords.error,
	        currentScrapRecord: state.scrapRecords.currentScrapRecord,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchScrapRecords: _scrapRecords_actions.fetchScrapRecords, selectScrapRecord: _scrapRecords_actions.selectScrapRecord, resetCurrentScrapRecord: _scrapRecords_actions.resetCurrentScrapRecord })(_scrapRecords2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/scrapRecords.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/scrapRecords.jsx');
	}();

	;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _products_actions = __webpack_require__(30);
	
	var _vendorBatches = __webpack_require__(379);
	
	var _vendorBatches2 = _interopRequireDefault(_vendorBatches);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    vendorBatchesIsLoading: state.vendors.vendorBatchesIsLoading,
	    vendorBatchesError: state.vendors.vendorBatchesError,
	    vendorBatches: state.vendors.vendorBatches
	  };
	}
	
	var vendorBatches = (0, _reduxForm.reduxForm)({
	  form: 'vendorBatches',
	  destroyOnUnmount: false
	})(_vendorBatches2.default);
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchSimplifiedProducts: _products_actions.fetchSimplifiedProducts })(vendorBatches);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/vendorBatches.jsx');
	
	  __REACT_HOT_LOADER__.register(vendorBatches, 'vendorBatches', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/vendorBatches.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/vendorBatches.jsx');
	}();

	;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _warehouses_actions = __webpack_require__(44);
	
	var _zones_actions = __webpack_require__(60);
	
	var _warehouseDetail = __webpack_require__(380);
	
	var _warehouseDetail2 = _interopRequireDefault(_warehouseDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warehouseDetail = (0, _reduxForm.reduxForm)({
	    form: 'warehouseDetail'
	})(_warehouseDetail2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('warehouseDetail');
	
	function mapStateToProps(state) {
	    var nameValue = selector(state, 'ZoneName');
	    return {
	        nameValue: nameValue,
	        zones: state.zones.all,
	        warehouseBinsDetail: state.warehouses.warehouseBinsDetail,
	        currentWarehouse: state.warehouses.currentWarehouse,
	        currentWarehouseDetail: state.warehouses.currentWarehouseDetail,
	        detailIsLoading: state.warehouses.detailIsLoading,
	        detailError: state.warehouses.detailError,
	        deleteZone: state.zones.deleteZone,
	        deleteZoneSuccess: state.zones.deleteZoneSuccess,
	        deleteZoneFailureError: state.zones.deleteZoneFailureError,
	        deleteBin: state.zones.deleteBin,
	        deleteBinSuccess: state.zones.deleteBinSuccess,
	        deleteBinFailureError: state.zones.deleteBinFailureError,
	        deleteLevel: state.zones.deleteLevel,
	        deleteLevelSuccess: state.zones.deleteLevelSuccess,
	        deleteLevelFailureError: state.zones.deleteLevelFailure,
	        createBinSuccess: state.zones.createBinSuccess,
	        createLevelSuccess: state.zones.createLevelSuccess,
	        levelCreateError: state.zones.levelCreateError,
	        binCreateError: state.zones.binCreateError,
	        createError: state.zones.createError,
	        bins: state.zones.bins,
	        levels: state.zones.levels,
	        attachDocumentSuccess: state.zones.attachDocumentSuccess,
	        updatedLevel: state.zones.updatedLevel,
	        updatedBin: state.zones.updatedBin
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	    generateBin: _zones_actions.generateBin,
	    deleteBinsBD: _zones_actions.deleteBinsBD,
	    editZone: _zones_actions.editZone,
	    createZone: _zones_actions.createZone,
	    generateZoneBarcode: _zones_actions.generateZoneBarcode,
	    getLevelsByBin: _zones_actions.getLevelsByBin,
	    getBinsByZone: _zones_actions.getBinsByZone,
	    fetchWarehouseBins: _warehouses_actions.fetchWarehouseBins,
	    fetchWarehouseDetail: _warehouses_actions.fetchWarehouseDetail,
	    searchZones: _zones_actions.searchZones,
	    selectZone: _zones_actions.selectZone,
	    resetCurrentZone: _zones_actions.resetCurrentZone,
	    deleteBin: _zones_actions.deleteBin,
	    deleteZone: _zones_actions.deleteZone,
	    selectBin: _zones_actions.selectBin,
	    selectLevel: _zones_actions.selectLevel,
	    editLevels: _zones_actions.editLevels,
	    editBins: _zones_actions.editBins,
	    attachZoneBinLevel: _zones_actions.attachZoneBinLevel,
	    importZoneBinLevel: _zones_actions.importZoneBinLevel,
	    createLevelFailure: _zones_actions.createLevelFailure,
	    createBinFailure: _zones_actions.createBinFailure,
	    createZoneFailure: _zones_actions.createZoneFailure })(warehouseDetail);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/warehouseDetail.jsx');
	
	    __REACT_HOT_LOADER__.register(warehouseDetail, 'warehouseDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/warehouseDetail.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/warehouseDetail.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/warehouseDetail.jsx');
	}();

	;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _warehouses_actions = __webpack_require__(44);
	
	var _reactRedux = __webpack_require__(6);
	
	var _warehouses = __webpack_require__(382);
	
	var _warehouses2 = _interopRequireDefault(_warehouses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warehouses = (0, _reduxForm.reduxForm)({
	    form: 'warehouses'
	})(_warehouses2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('warehouses');
	
	function mapStateToProps(state) {
	    var nameValue = selector(state, 'WarehouseName');
	    return {
	        nameValue: nameValue,
	
	        updated: state.warehouses.updated,
	        warehouses: state.warehouses.all,
	        currentWarehouses: state.warehouses.currentWarehouse,
	        initialValues: state.warehouses.currentWarehouse,
	        isLoading: state.warehouses.isLoading,
	        error: state.warehouses.error,
	        currentWarehouse: state.warehouses.currentWarehouse,
	        deleteWarehouse: state.warehouses.deleteWarehouse,
	        deleteWarehouseSuccess: state.warehouses.deleteWarehouseSuccess,
	        deleteWarehouseError: state.warehouses.deleteWarehouseError
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchWarehouses: _warehouses_actions.fetchWarehouses, selectWarehouse: _warehouses_actions.selectWarehouse, resetCurrentWarehouse: _warehouses_actions.resetCurrentWarehouse, searchWarehouses: _warehouses_actions.searchWarehouses, deleteWarehouse: _warehouses_actions.deleteWarehouse, editWarehouseDefault: _warehouses_actions.editWarehouseDefault })(warehouses);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/warehouses.jsx');
	
	    __REACT_HOT_LOADER__.register(warehouses, 'warehouses', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/warehouses.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/warehouses.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/warehouses.jsx');
	}();

	;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _zones_actions = __webpack_require__(60);
	
	var _zoneDetail = __webpack_require__(383);
	
	var _zoneDetail2 = _interopRequireDefault(_zoneDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var zoneDetail = (0, _reduxForm.reduxForm)({
	    form: 'zoneDetail'
	})(_zoneDetail2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('zoneDetail');
	
	function mapStateToProps(state) {
	    var nameValue = selector(state, 'BinName');
	    return {
	        nameValue: nameValue,
	
	        bins: state.zones.bins,
	
	        currentZone: state.zones.currentZone,
	        currentZoneDetail: state.zones.currentZoneDetail,
	        detailIsLoading: state.zones.detailIsLoading,
	        detailError: state.zones.detailError,
	        currentBin: state.zones.currentBin,
	        deleteBin: state.zones.deleteBin,
	        deleteBinSuccess: state.zones.deleteBinSuccess,
	        deleteBinFailureError: state.zones.deleteBinFailureError
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchZoneDetail: _zones_actions.fetchZoneDetail, searchBins: _zones_actions.searchBins, resetCurrentBin: _zones_actions.resetCurrentBin, selectBin: _zones_actions.selectBin, deleteBin: _zones_actions.deleteBin })(zoneDetail);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/zoneDetail.jsx');
	
	    __REACT_HOT_LOADER__.register(zoneDetail, 'zoneDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/zoneDetail.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/zoneDetail.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Inventories/zoneDetail.jsx');
	}();

	;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MMdriver = __webpack_require__(394);
	
	var _MMdriver2 = _interopRequireDefault(_MMdriver);
	
	var _mmdriverActions = __webpack_require__(210);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    drivers: state.MMDrivers.drivers
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchMMDriversByTime: _mmdriverActions.fetchMMDriversByTime, editDriverInfomation: _mmdriverActions.editDriverInfomation })(_MMdriver2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/MMdriver/index.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/MMdriver/index.jsx');
	}();

	;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _paymentTerms = __webpack_require__(395);
	
	var _paymentTerms2 = _interopRequireDefault(_paymentTerms);
	
	var _paymentTerms_actions = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    paymentTerms: state.paymentTerms.all,
	    currentPaymentTerm: state.paymentTerms.currentPaymentTerm,
	    isLoading: state.paymentTerms.isLoading,
	    error: state.paymentTerms.error,
	    userPermissions: state.auth.userPermissions
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchPaymentTerms: _paymentTerms_actions.fetchPaymentTerms,
	  selectPaymentTerm: _paymentTerms_actions.selectPaymentTerm,
	  resetCurrentPaymentTerm: _paymentTerms_actions.resetCurrentPaymentTerm
	})(_paymentTerms2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/PaymentTerms/paymentTerms.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/PaymentTerms/paymentTerms.jsx');
	}();

	;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _Category2B2BDetail = __webpack_require__(396);
	
	var _Category2B2BDetail2 = _interopRequireDefault(_Category2B2BDetail);
	
	var _settings_actions = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    category2Products: state.products.category2ProductsB2B,
	    category2ProductsIsLoading: state.products.category2ProductsIsLoadingB2B,
	    category2Id: state.products.category2IdB2B,
	
	    checkPassword: state.settings.checkPassword,
	    checkPasswordSuccess: state.settings.checkPasswordSuccess,
	    checkPasswordFailure: state.settings.checkPasswordFailure
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { checkPassword: _settings_actions.checkPassword, clearCheckPassword: _settings_actions.clearCheckPassword })(_Category2B2BDetail2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/Category2B2BDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/Category2B2BDetail.jsx');
	}();

	;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _Category2Detail = __webpack_require__(397);
	
	var _Category2Detail2 = _interopRequireDefault(_Category2Detail);
	
	var _settings_actions = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    category2Products: state.products.category2Products,
	    category2ProductsIsLoading: state.products.category2ProductsIsLoading,
	    category2Id: state.products.category2Id,
	
	    checkPassword: state.settings.checkPassword,
	    checkPasswordSuccess: state.settings.checkPasswordSuccess,
	    checkPasswordFailure: state.settings.checkPasswordFailure
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { checkPassword: _settings_actions.checkPassword, clearCheckPassword: _settings_actions.clearCheckPassword })(_Category2Detail2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/Category2Detail.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/Category2Detail.jsx');
	}();

	;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _products_actions = __webpack_require__(30);
	
	var _category_ = __webpack_require__(402);
	
	var _category_2 = _interopRequireDefault(_category_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    categories: state.products.categories2,
	    categoryIsLoading: state.products.category2IsLoading,
	    categoryError: state.products.category2Error,
	
	    currentCategory: state.products.currentCategory,
	    multiIsEditing: state.products.multiCategory2IsEditing,
	    multiError: state.products.multiCategory2EditError,
	    multiEdited: state.products.multiCategory2Edited,
	    userPermissions: state.auth.userPermissions,
	    deletingCategory: state.products.deletingCategory2,
	    deleteCategorySuccess: state.products.deleteCategory2Success,
	    deleteCategoryError: state.products.deleteCategory2Error
	    // currentGroup: state.products.currentGroup,
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchCategories2: _products_actions.fetchCategories2,
	  selectCategory: _products_actions.selectCategory,
	  resetCurrentCategory: _products_actions.resetCurrentCategory,
	  editMultiCategories2: _products_actions.editMultiCategories2,
	  deleteCategory2: _products_actions.deleteCategory2,
	  clearCategory2Status: _products_actions.clearCategory2Status,
	  fetchGroupCategories: _products_actions.fetchGroupCategories,
	  fetchCategory2Products: _products_actions.fetchCategory2Products
	})(_category_2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/category_2.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/category_2.jsx');
	}();

	;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _products_actions = __webpack_require__(30);
	
	var _category_2_b2b = __webpack_require__(403);
	
	var _category_2_b2b2 = _interopRequireDefault(_category_2_b2b);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    // categories: state.products.categories2,
	    // categoryIsLoading: state.products.category2IsLoading,
	    // categoryError: state.products.category2Error,
	
	    // currentCategory: state.products.currentCategory,
	    // multiIsEditing: state.products.multiCategory2IsEditing,
	    // multiError: state.products.multiCategory2EditError,
	    // multiEdited: state.products.multiCategory2Edited,
	    // userPermissions: state.auth.userPermissions,
	    // deletingCategory: state.products.deletingCategory2,
	    // deleteCategorySuccess: state.products.deleteCategory2Success,
	    // deleteCategoryError: state.products.deleteCategory2Error,
	    // currentGroup: state.products.currentGroup,
	
	
	    categories: state.products.categories2B2B,
	    categoryIsLoading: state.products.category2IsLoadingB2B,
	    categoryError: state.products.category2ErrorB2B,
	
	    currentCategory: state.products.currentCategoryB2B,
	    multiIsEditing: state.products.multiCategory2IsEditingB2B,
	    multiError: state.products.multiCategory2EditErrorB2B,
	    multiEdited: state.products.multiCategory2EditedB2B,
	    userPermissions: state.auth.userPermissions,
	    deletingCategory: state.products.deletingCategory2B2B,
	    deleteCategorySuccess: state.products.deleteCategory2SuccessB2B,
	    deleteCategoryError: state.products.deleteCategory2ErrorB2B
	    // currentGroup: state.products.currentGroup,
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  //   fetchCategories2,
	  //   selectCategory,
	  //   resetCurrentCategory,
	  //   editMultiCategories2,
	  //   deleteCategory2,
	  //   clearCategory2Status,
	  fetchGroupCategories: _products_actions.fetchGroupCategories,
	  //   fetchCategory2Products,
	
	  fetchCategories2B2B: _products_actions.fetchCategories2B2B,
	  selectCategoryB2B: _products_actions.selectCategoryB2B,
	  resetCurrentCategoryB2B: _products_actions.resetCurrentCategoryB2B,
	  editMultiCategories2B2B: _products_actions.editMultiCategories2B2B,
	  deleteCategory2B2B: _products_actions.deleteCategory2B2B,
	  clearCategory2StatusB2B: _products_actions.clearCategory2StatusB2B,
	  //
	  fetchCategory2ProductsB2B: _products_actions.fetchCategory2ProductsB2B
	})(_category_2_b2b2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/category_2_b2b.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/category_2_b2b.jsx');
	}();

	;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _drayageList = __webpack_require__(411);
	
	var drayageList = (0, _reduxForm.reduxForm)({
	  form: 'drayageList'
	})(_drayageList.DrayageList);
	// import { fetchMeasurementUnit, editMeasurementUnit, clearMeasurementUnitEdited, deleteMeasurementUnit } from '../../actions/products_actions';
	//containers
	
	
	function mapStateToProps(state) {
	  return {
	    // measurementUnitFetched: state.products.measurementUnitFetched,
	    // fetchingMeasurementUnit: state.products.fetchingMeasurementUnit,
	    // measurementUnitFetchError: state.products.measurementUnitFetchError,
	    // editingMeasurementUnit: state.products.editingMeasurementUnit,
	    // measurementUnitEdited: state.products.measurementUnitEdited,
	    // measurementUnitEditError: state.products.measurementUnitEditError,
	    // deletingMeasurementUnit: state.products.deletingMeasurementUnit,
	    // deleteMeasurementUnitSuccess: state.products.deleteMeasurementUnitSuccess,
	    // deleteMeasurementUnitError: state.products.deleteMeasurementUnitError,
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  //   fetchMeasurementUnit, editMeasurementUnit, clearMeasurementUnitEdited, deleteMeasurementUnit
	})(drayageList);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/drayageList.jsx');
	
	  __REACT_HOT_LOADER__.register(drayageList, 'drayageList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/drayageList.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/drayageList.jsx');
	}();

	;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _products_actions = __webpack_require__(30);
	
	var _editGroupForm = __webpack_require__(412);
	
	var editGroupForm = (0, _reduxForm.reduxForm)({
	  form: 'editGroupForm'
	})(_editGroupForm.EditGroupForm);
	
	var selector = (0, _reduxForm.formValueSelector)('editGroupForm');
	
	function mapStateToProps(state) {
	  var Category = selector(state, 'Category');
	  var Group = selector(state, 'Group');
	  var IsLarge = selector(state, 'IsLarge');
	  var LastDigit = selector(state, 'LastDigit');
	  var Name = selector(state, 'Name');
	  var Description = selector(state, 'Description');
	  var isMadePrev = selector(state, 'isMadePrev');
	  return {
	    Category: Category,
	    Group: Group,
	    IsLarge: IsLarge,
	    LastDigit: LastDigit,
	    Name: Name,
	    Description: Description,
	    isMadePrev: isMadePrev,
	    existingProd: state.products.all,
	    existingProdError: state.products.error,
	    existingProdIsLoading: state.products.isLoading,
	    fetchingSuggestedProdNum: state.products.fetchingSuggestedProdNum,
	    suggestedProdNumFetched: state.products.suggestedProdNumFetched,
	    suggestedProdNumFetchError: state.products.suggestedProdNumFetchError,
	    groupCategories: state.products.groupCategories,
	    groupCategoryError: state.products.groupCategoryError,
	    groupCategoryIsLoading: state.products.groupCategoryIsLoading,
	    fetchingSuggestDigit: state.products.fetchingSuggestDigit,
	    suggestDigitFetched: state.products.suggestDigitFetched,
	    suggestDigitFetchError: state.products.suggestDigitFetchError,
	    updateProduct: state.products.updateProduct,
	    updateProductIsLoading: state.products.updateProductIsLoading || state.products.isCreating,
	    updateProductError: state.products.error
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  setValue: _products_actions.setValue,
	  fetchGroupCategories: _products_actions.fetchGroupCategories,
	  fetchSuggestedProdNum: _products_actions.fetchSuggestedProdNum,
	  fetchProductsByCategory: _products_actions.fetchProductsByCategory,
	  fetchSuggestDigit: _products_actions.fetchSuggestDigit,
	  clearSuggestDigit: _products_actions.clearSuggestDigit,
	  updateProductGroup: _products_actions.updateProductGroup,
	  fetchProductDetail: _products_actions.fetchProductDetail
	})(editGroupForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/editGroupForm.jsx');
	
	  __REACT_HOT_LOADER__.register(editGroupForm, 'editGroupForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/editGroupForm.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/editGroupForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/editGroupForm.jsx');
	}();

	;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _products_actions = __webpack_require__(30);
	
	var _groups = __webpack_require__(414);
	
	var _groups2 = _interopRequireDefault(_groups);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var groups = (0, _reduxForm.reduxForm)({
	  form: 'groups'
	})(_groups2.default);
	
	function mapStateToProps(state) {
	  return {
	    groups: state.products.groups,
	    groupIsLoading: state.products.groupIsLoading,
	    groupError: state.products.groupError,
	    currentGroup: state.products.currentGroup,
	    multiIsEditing: state.products.multiGroupIsEditing,
	    multiError: state.products.multiGroupEditError,
	    multiEdited: state.products.multiGroupEdited,
	    userPermissions: state.auth.userPermissions,
	    deletingGroup: state.products.deletingGroup,
	    deleteGroupSuccess: state.products.deleteGroupSuccess,
	    deleteGroupError: state.products.deleteGroupError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchGroups: _products_actions.fetchGroups,
	  fetchGroupsElegant: _products_actions.fetchGroupsElegant,
	  fetchGroupCategories: _products_actions.fetchGroupCategories,
	  selectGroup: _products_actions.selectGroup,
	  resetCurrentGroup: _products_actions.resetCurrentGroup,
	  editMultiGroups: _products_actions.editMultiGroups,
	  editMultiGroupsElegant: _products_actions.editMultiGroupsElegant,
	  deleteGroup: _products_actions.deleteGroup,
	  clearDeleteGroupStatus: _products_actions.clearDeleteGroupStatus,
	  resetCategory2Id: _products_actions.resetCategory2Id
	})(groups);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/groups.jsx');
	
	  __REACT_HOT_LOADER__.register(groups, 'groups', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/groups.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/groups.jsx');
	}();

	;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _products_actions = __webpack_require__(30);
	
	var _measurementUnit = __webpack_require__(415);
	
	//containers
	var measurementUnit = (0, _reduxForm.reduxForm)({
	  form: 'measurementUnit'
	})(_measurementUnit.MeasurementUnit);
	
	function mapStateToProps(state) {
	  return {
	    measurementUnitFetched: state.products.measurementUnitFetched,
	    fetchingMeasurementUnit: state.products.fetchingMeasurementUnit,
	    measurementUnitFetchError: state.products.measurementUnitFetchError,
	    editingMeasurementUnit: state.products.editingMeasurementUnit,
	    measurementUnitEdited: state.products.measurementUnitEdited,
	    measurementUnitEditError: state.products.measurementUnitEditError,
	    deletingMeasurementUnit: state.products.deletingMeasurementUnit,
	    deleteMeasurementUnitSuccess: state.products.deleteMeasurementUnitSuccess,
	    deleteMeasurementUnitError: state.products.deleteMeasurementUnitError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchMeasurementUnit: _products_actions.fetchMeasurementUnit, editMeasurementUnit: _products_actions.editMeasurementUnit, clearMeasurementUnitEdited: _products_actions.clearMeasurementUnitEdited, deleteMeasurementUnit: _products_actions.deleteMeasurementUnit
	})(measurementUnit);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/measurementUnit.jsx');
	
	  __REACT_HOT_LOADER__.register(measurementUnit, 'measurementUnit', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/measurementUnit.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/measurementUnit.jsx');
	}();

	;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _products_actions = __webpack_require__(30);
	
	var _inventories_actions = __webpack_require__(38);
	
	var _priceLevel = __webpack_require__(417);
	
	var _priceLevel2 = _interopRequireDefault(_priceLevel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    groups: state.products.groups,
	    priceLevels: state.products.priceLevels,
	    isLoading: state.products.priceLevelIsLoading,
	    error: state.products.priceLevelError,
	    groupCategories: state.products.groupCategories,
	    groupCategoryError: state.products.groupCategoryError,
	    groupCategoryIsLoading: state.products.groupCategoryIsLoading,
	    multiIsEditing: state.products.multiPriceLevelIsEditing,
	    multiError: state.products.multiPriceLevelEditError,
	    multiEdited: state.products.multiPriceLevelEdited
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchGroups: _products_actions.fetchGroups,
	  fetchGroupCategories: _products_actions.fetchGroupCategories,
	  fetchProductsByGroup: _products_actions.fetchProductsByGroup,
	  fetchProductsByCategory: _products_actions.fetchProductsByCategory,
	  resetGroupAndCategory: _products_actions.resetGroupAndCategory,
	  fetchPriceLevels: _products_actions.fetchPriceLevels,
	  editMultiPriceLevels: _products_actions.editMultiPriceLevels,
	  selectProduct: _products_actions.selectProduct,
	  setOriginPage: _inventories_actions.setOriginPage
	})(_priceLevel2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/priceLevel.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/priceLevel.jsx');
	}();

	;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _products_actions = __webpack_require__(30);
	
	var _vendors_actions = __webpack_require__(46);
	
	var _warehouses_actions = __webpack_require__(44);
	
	var _zones_actions = __webpack_require__(60);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _inventories_actions = __webpack_require__(38);
	
	var _promotions_actions = __webpack_require__(71);
	
	var _wholesaleModal_actions = __webpack_require__(145);
	
	var _settings_actions = __webpack_require__(33);
	
	var _productForm = __webpack_require__(418);
	
	var _productForm2 = _interopRequireDefault(_productForm);
	
	var _baseModal_actions = __webpack_require__(80);
	
	var _RootUrl = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var isMyuMyu = _RootUrl.ROOT_API_URL === "https://mmstage-scm.truckxi.com/api/" || _RootUrl.ROOT_API_URL === "https://myumyu-scm.truckxi.com/api/";
	var isEcity = _RootUrl.ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/" || _RootUrl.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || _RootUrl.ROOT_API_URL === "https://dev-scm.truckxi.com/api/";
	var isJML = _RootUrl.ROOT_API_URL === "https://jml-scm.truckxi.com/api/" || _RootUrl.ROOT_API_URL === "https://dev-scm.truckxi.com/api/";
	var isHMM = _RootUrl.ROOT_API_URL === "https://hmm-scm.truckxi.com/api/";
	var isUSPride = _RootUrl.ROOT_API_URL === "https://uspride-scm.truckxi.com/api/" || _RootUrl.ROOT_API_URL === "https://uspride-scm.truckxi.com/api/";
	var isATL = _RootUrl.ROOT_API_URL === 'https://alton-scm.truckxi.com/api/' || _RootUrl.ROOT_URL === 'https://alton-scm.truckxi.com/api/';
	var isRS = _RootUrl.ROOT_API_URL === 'https://redstone-scm.truckxi.com/api/' || _RootUrl.ROOT_URL === 'https://redstone-scm.truckxi.com/api/';
	
	var isNumeric = function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	};
	
	var validate = function validate(values) {
	  var errors = {};
	
	  if (values.NetWeight && !isNumeric(values.NetWeight)) {
	    errors.NetWeight = 'Accept number only!';
	  }
	  if (values.ShippingWeight && !isNumeric(values.ShippingWeight)) {
	    errors.ShippingWeight = 'Accept number only!';
	  }
	  if (values.CRV && !isNumeric(values.CRV)) {
	    errors.CRV = 'Accept number only!';
	  }
	  if (!values.ProductType) {
	    errors.ProductType = 'Required';
	  }
	  if (values.RefPrice === '' || values.RefPrice === null || values.RefPrice === undefined) {
	    errors.RefPrice = 'Required';
	  }
	  if (values.RefPrice && !isNumeric(values.RefPrice)) {
	    errors.RefPrice = 'Accept number only!';
	  }
	  if (values.LowestSalePrice === '' || values.LowestSalePrice === null || values.LowestSalePrice === undefined) {
	    errors.LowestSalePrice = 'Required';
	  }
	  if (values.LowestSalePrice && !isNumeric(values.LowestSalePrice)) {
	    errors.LowestSalePrice = 'Accept number only!';
	  }
	
	  if (!values.ConvertType) {
	    errors.ConvertType = 'Required';
	  }
	
	  if (!values.Name) {
	    errors.Name = 'Required';
	  }
	
	  return errors;
	};
	
	var productForm = (0, _reduxForm.reduxForm)({
	  form: 'productForm',
	  destroyOnUnmount: true,
	  enableReinitialize: true,
	  touchOnChange: true,
	  touchOnBlur: false,
	  validate: validate
	})(_productForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('productForm');
	
	function mapStateToProps(state) {
	  var _ref;
	
	  // console.log('this is the state', state);
	  var DimensionUnit = selector(state, 'DimensionUnit');
	  var DimensionHeight = selector(state, 'DimensionHeight');
	  var DimensionLength = selector(state, 'DimensionLength');
	  var DimensionWidth = selector(state, 'DimensionWidth');
	  var Pricelv1Value = selector(state, 'PriceLv1');
	  var Pricelv2Value = selector(state, 'PriceLv2');
	  var Pricelv3Value = selector(state, 'PriceLv3');
	  var Pricelv4Value = selector(state, 'PriceLv4');
	  var Pricelv5Value = selector(state, 'PriceLv5');
	  var RefPriceValue = selector(state, 'RefPrice');
	  var Default_Warehouse_id = selector(state, 'Default_Warehouse_id');
	  var ProductGroup_id = selector(state, 'ProductGroup_id');
	  var ProductNumber = selector(state, 'ProductNumber');
	  var GeneralNumber = selector(state, 'GeneralNumber');
	  var ConvertProductNum = selector(state, 'ConvertProductNum');
	  var ConvertNum = selector(state, 'ConvertNum');
	  var Related_Product_id = selector(state, 'Related_Product_id');
	  // const ProductType = selector(state, 'ProductType');
	  var ProductNum = selector(state, 'ProductNum');
	  var PackageSize_1 = selector(state, 'PackageSize_1');
	  var PackageType_2 = selector(state, 'PackageType_2');
	  var PackageSize_2 = selector(state, 'PackageSize_2');
	  var MeasureUnit_2 = selector(state, 'MeasureUnit_2');
	  var ConvertType = selector(state, 'ConvertType');
	  var NetWeight = selector(state, 'NetWeight');
	  var zoneID = selector(state, 'Default_WarehouseZone_id');
	  var IsStopSale = selector(state, 'IsStopSale');
	  var IsAllTaxable = selector(state, 'IsAllTaxable');
	  var Zone = selector(state, 'Zone');
	  var Bin = selector(state, 'Bin');
	  var Level = selector(state, 'Level');
	  var Zone2 = selector(state, 'Zone2');
	  var Bin2 = selector(state, 'Bin2');
	  var Level2 = selector(state, 'Level2');
	  var Zone3 = selector(state, 'Zone3');
	  var Bin3 = selector(state, 'Bin3');
	  var Level3 = selector(state, 'Level3');
	  var ProductCost = selector(state, 'ProductCost');
	  var ShippingFeeUnitPrice = selector(state, 'ShippingFeeUnitPrice');
	  var TaxAmount = selector(state, 'TaxAmount');
	  var MiscUnitPrice = selector(state, 'MiscUnitPrice');
	  var English_Details_Brand = selector(state, 'English_Details_Brand');
	  var customerId = selector(state, 'customerId');
	  var Customer = selector(state, 'Customer');
	  var Chinese_Details_Brand = selector(state, 'Chinese_Details_Brand');
	  var English_Brand_Origin = selector(state, 'English_Brand_Origin');
	  var Chinese_Brand_Origin = selector(state, 'Chinese_Brand_Origin');
	  var English_Details_NetContent = selector(state, 'English_Details_NetContent');
	  var Chinese_Details_NetContent = selector(state, 'Chinese_Details_NetContent');
	  var English_Details_Made_In = selector(state, 'English_Details_Made_In');
	  var Chinese_Details_Made_In = selector(state, 'Chinese_Details_Made_In');
	  var English_Details_Organic = selector(state, 'English_Details_Organic');
	  var Chinese_Details_Organic = selector(state, 'Chinese_Details_Organic');
	  var English_Details_Contains_Sugar = selector(state, 'English_Details_Contains_Sugar');
	  var Chinese_Details_Contains_Sugar = selector(state, 'Chinese_Details_Contains_Sugar');
	  var English_Details_Flavor = selector(state, 'English_Details_Flavor');
	  var Chinese_Details_Flavor = selector(state, 'Chinese_Details_Flavor');
	  var English_Details_Ingredients = selector(state, 'English_Details_Ingredients');
	  var Chinese_Details_Ingredients = selector(state, 'Chinese_Details_Ingredients');
	  // Brands
	
	  var ArrivalPrice = void 0;
	  if (state.products.currentProductDetail && isEcity) {
	    ArrivalPrice = (Number(MiscUnitPrice) + Number(ShippingFeeUnitPrice) + Number(ProductCost)).toFixed(4);
	  }
	
	  if (state.products.currentProductDetail && (isHMM || isUSPride || isATL || isRS)) {
	    ArrivalPrice = (Number(ShippingFeeUnitPrice) + Number(TaxAmount) + Number(MiscUnitPrice) + Number(ProductCost)).toFixed(3);
	  }
	
	  var initialValues = state.products.currentProductDetail;
	  return _ref = {
	    customerOptions: state.products.customers.map(function (customer) {
	      return {
	        label: customer.Name,
	        value: customer.Customer_id
	      };
	    }),
	    ShippingFeeUnitPrice: ShippingFeeUnitPrice,
	    ArrivalPrice: ArrivalPrice,
	    ProductCost: ProductCost,
	    Default_Warehouse_id: Default_Warehouse_id,
	    DimensionUnit: DimensionUnit,
	    DimensionHeight: DimensionHeight,
	    DimensionLength: DimensionLength,
	    DimensionWidth: DimensionWidth,
	    Pricelv1Value: Pricelv1Value,
	    Pricelv2Value: Pricelv2Value,
	    Pricelv3Value: Pricelv3Value,
	    Pricelv4Value: Pricelv4Value,
	    Pricelv5Value: Pricelv5Value,
	    RefPriceValue: RefPriceValue,
	    ProductGroup_id: ProductGroup_id,
	    ProductNumber: ProductNumber,
	    GeneralNumber: GeneralNumber,
	    ConvertProductNum: ConvertProductNum,
	    ConvertNum: ConvertNum,
	    Related_Product_id: Related_Product_id,
	    // ProductType,
	    ProductNum: ProductNum,
	    PackageSize_1: PackageSize_1,
	    PackageType_2: PackageType_2,
	    PackageSize_2: PackageSize_2,
	    MeasureUnit_2: MeasureUnit_2,
	    ConvertType: ConvertType,
	    NetWeight: NetWeight,
	    zoneID: zoneID,
	    IsStopSale: IsStopSale,
	    IsAllTaxable: IsAllTaxable,
	    Zone: Zone,
	    Bin: Bin,
	    Level: Level,
	    Zone2: Zone2,
	    Bin2: Bin2,
	    Level2: Level2,
	    Zone3: Zone3,
	    Bin3: Bin3,
	    Level3: Level3,
	    customerId: customerId,
	    Customer: Customer,
	    English_Details_Brand: English_Details_Brand,
	    Chinese_Details_Brand: Chinese_Details_Brand,
	    English_Brand_Origin: English_Brand_Origin,
	    Chinese_Brand_Origin: Chinese_Brand_Origin,
	    English_Details_NetContent: English_Details_NetContent,
	    Chinese_Details_NetContent: Chinese_Details_NetContent,
	    English_Details_Made_In: English_Details_Made_In,
	    Chinese_Details_Made_In: Chinese_Details_Made_In,
	    English_Details_Organic: English_Details_Organic,
	    Chinese_Details_Organic: Chinese_Details_Organic,
	    English_Details_Contains_Sugar: English_Details_Contains_Sugar,
	    Chinese_Details_Contains_Sugar: Chinese_Details_Contains_Sugar,
	    English_Details_Flavor: English_Details_Flavor,
	    Chinese_Details_Flavor: Chinese_Details_Flavor,
	    English_Details_Ingredients: English_Details_Ingredients,
	    Chinese_Details_Ingredients: Chinese_Details_Ingredients,
	
	    zones: state.zones.zones,
	    bins: state.zones.bins,
	    levels: state.zones.levels,
	    zones2: state.zones.zones2,
	    bins2: state.zones.bins2,
	    levels2: state.zones.levels2,
	    zones3: state.zones.zones3,
	    bins3: state.zones.bins3,
	    levels3: state.zones.levels3,
	    currentProduct: state.products.currentProduct,
	    currentProductDetail: state.products.currentProductDetail,
	    detailIsLoading: state.products.detailIsLoading,
	    detailError: state.products.detailError,
	    initialValues: initialValues,
	    isCreating: state.products.isCreating,
	    createError: state.products.createError,
	    created: state.products.created,
	    isEditing: state.products.isEditing,
	    editError: state.products.editError,
	    edited: state.products.edited,
	    products: state.products.all,
	    productIsLoading: state.products.isLoading,
	    productError: state.products.error,
	    vendors: state.vendors.all,
	    vendorIsLoading: state.vendors.isLoading,
	    vendorError: state.vendors.error,
	    groups: state.products.groups,
	    groupIsLoading: state.products.groupIsLoading,
	    groupError: state.products.groupError,
	    categories: state.products.categories,
	    categoryIsLoading: state.products.categoryIsLoading,
	    categoryError: state.products.categoryError,
	    categories2: state.products.categories2,
	    category2IsLoading: state.products.category2IsLoading,
	    category2Error: state.products.category2Error,
	    display_categories: state.products.display_categories,
	    editCategoryLoading: state.products.editCategoryLoading,
	    groupCategories: state.products.groupCategories,
	    groupCategoryError: state.products.groupCategoryError,
	    groupCategoryIsLoading: state.products.groupCategoryIsLoading,
	    warehouses: state.warehouses.all,
	    warehouseIsLoading: state.warehouses.isLoading,
	    warehouseError: state.warehouses.error,
	    productInventory: state.wholesaleModal.productInventory
	  }, _defineProperty(_ref, 'zones', state.zones.all), _defineProperty(_ref, 'zoneError', state.zones.error), _defineProperty(_ref, 'zoneIsLoading', state.zones.isLoading), _defineProperty(_ref, 'bins', state.zones.bins), _defineProperty(_ref, 'binError', state.zones.binError), _defineProperty(_ref, 'binIsLoading', state.zones.binIsLoading), _defineProperty(_ref, 'VendorID', selector(state, 'Vendor_id2')), _defineProperty(_ref, 'currentWarehouseDetail', state.warehouses.currentWarehouseDetail), _defineProperty(_ref, 'userPermissions', state.auth.userPermissions), _defineProperty(_ref, 'smallProductDetail', state.products.smallProductDetail), _defineProperty(_ref, 'smallProductDetailIsLoading', state.products.smallProductDetailIsLoading), _defineProperty(_ref, 'smallProductDetailError', state.products.smallProductDetailError), _defineProperty(_ref, 'CRVs', state.products.CRVs), _defineProperty(_ref, 'CRVsIsLoading', state.products.CRVsIsLoading), _defineProperty(_ref, 'CRVsError', state.products.CRVsError), _defineProperty(_ref, 'productSaved', state.products.productSaved), _defineProperty(_ref, 'defaultBuyers', state.products.defaultBuyers), _defineProperty(_ref, 'defaultBuyersIsLoading', state.products.defaultBuyersIsLoading), _defineProperty(_ref, 'defaultBuyersError', state.products.defaultBuyersError), _defineProperty(_ref, 'originPage', state.inventories.originPage), _defineProperty(_ref, 'attachingProductImage', state.products.attachingProductImage), _defineProperty(_ref, 'productImageAttached', state.products.productImageAttached), _defineProperty(_ref, 'fetchingConvertableProducts', state.products.fetchingConvertableProducts), _defineProperty(_ref, 'convertableProductsFetched', state.products.convertableProductsFetched), _defineProperty(_ref, 'convertableProductsFetchError', state.products.convertableProductsFetchError), _defineProperty(_ref, 'packageTypesFetched', state.products.packageTypesFetched), _defineProperty(_ref, 'fetchingPackageTypes', state.products.fetchingPackageTypes), _defineProperty(_ref, 'packageTypeFetchError', state.products.packageTypeFetchError), _defineProperty(_ref, 'measurementUnitFetched', state.products.measurementUnitFetched), _defineProperty(_ref, 'fetchingMeasurementUnit', state.products.fetchingMeasurementUnit), _defineProperty(_ref, 'measurementUnitFetchError', state.products.measurementUnitFetchError), _defineProperty(_ref, 'promotionDetails', state.promotions.promotionDetails), _defineProperty(_ref, 'promotionDetailsIsLoading', state.promotions.promotionDetailsIsLoading), _defineProperty(_ref, 'promotionDetailsError', state.promotions.promotionDetailsError), _defineProperty(_ref, 'continueOrDiscontinueProductError', state.products.continueOrDiscontinueProductError), _defineProperty(_ref, 'continueOrDiscontinueProductSuccess', state.products.continueOrDiscontinueProductSuccess), _defineProperty(_ref, 'checkingPermission', state.settings.checkingPermission), _defineProperty(_ref, 'checkPermissionSuccess', state.settings.checkPermissionSuccess), _defineProperty(_ref, 'checkPermissionFailure', state.settings.checkPermissionFailure), _defineProperty(_ref, 'checkPassword', state.settings.checkPassword), _defineProperty(_ref, 'checkPasswordSuccess', state.settings.checkPasswordSuccess), _defineProperty(_ref, 'checkPasswordFailure', state.settings.checkPasswordFailure), _defineProperty(_ref, 'isLoadingDescriptionBoxSave', state.products.savingMobileDescriptionText), _defineProperty(_ref, 'saveMobileDescriptionTextSuccess', state.products.saveMobileDescriptionTextSuccess), _defineProperty(_ref, 'confirmPasscodeModal', state.baseModals.confirmPasscodeModal), _ref;
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchWarehouseDetail: _warehouses_actions.fetchWarehouseDetail,
	  fetchVendors: _vendors_actions.fetchVendors,
	  createProduct: _products_actions.createProduct,
	  clearAttachedProductImage: _products_actions.clearAttachedProductImage,
	  fetchPackageTypes: _products_actions.fetchPackageTypes,
	  fetchBins: _zones_actions.fetchBins,
	  resetBins: _zones_actions.resetBins,
	  editProduct: _products_actions.editProduct,
	  fetchProductDetail: _products_actions.fetchProductDetail,
	  fetchProductInventoryBatches: _wholesaleModal_actions.fetchProductInventoryBatches,
	  postProductInventoryBatches: _wholesaleModal_actions.postProductInventoryBatches,
	  setCurrentProduct: _products_actions.setCurrentProduct,
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	  fetchConvertableProducts: _products_actions.fetchConvertableProducts,
	  fetchGroups: _products_actions.fetchGroups,
	  changeVendorValue: _vendors_actions.changeVendorValue,
	  change: _reduxForm.change,
	  fetchProducts: _products_actions.fetchProducts,
	  fetchCategories: _products_actions.fetchCategories,
	  fetchCategories2: _products_actions.fetchCategories2,
	  fetchGroupCategories: _products_actions.fetchGroupCategories,
	  fetchZones: _zones_actions.fetchZones,
	  fetchWarehouses: _warehouses_actions.fetchWarehouses,
	  fetchProductByNum: _products_actions.fetchProductByNum,
	  fetchProductsByCategory: _products_actions.fetchProductsByCategory,
	  fetchNextProduct: _products_actions.fetchNextProduct,
	  fetchPreviousProduct: _products_actions.fetchPreviousProduct,
	  fetchPreviousProductWithGeno: _products_actions.fetchPreviousProductWithGeno,
	  fetchNextProductWithGeno: _products_actions.fetchNextProductWithGeno,
	  setValue: _products_actions.setValue,
	  fetchMeasurementUnit: _products_actions.fetchMeasurementUnit,
	  resetCurrentProduct: _products_actions.resetCurrentProduct,
	  clearCurrentProduct: _products_actions.clearCurrentProduct,
	  reinitialize: _products_actions.reinitialize,
	  fetchSmallProductInfo: _products_actions.fetchSmallProductInfo,
	  clearSmallProdStatus: _products_actions.clearSmallProdStatus,
	  fetchCRVValues: _products_actions.fetchCRVValues,
	  selectProduct: _products_actions.selectProduct,
	  attachProductImage: _products_actions.attachProductImage,
	  selectInventory: _inventories_actions.selectInventory,
	  fetchPromoDetails: _promotions_actions.fetchPromoDetails,
	  checkPermission: _settings_actions.checkPermission,
	  checkPassword: _settings_actions.checkPassword,
	  clearCheckPassword: _settings_actions.clearCheckPassword,
	  fetchDefaultBuyers: _products_actions.fetchDefaultBuyers,
	  continueProduct: _products_actions.continueProduct,
	  discontinueProduct: _products_actions.discontinueProduct,
	  saveMobileDescriptionBoxText: _products_actions.saveMobileDescriptionBoxText,
	  duplicateProduct: _products_actions.duplicateProduct,
	  updateProductGroup: _products_actions.updateProductGroup,
	  deleteProduct: _products_actions.deleteProduct,
	  getBinsByZone: _zones_actions.getBinsByZone,
	  getLevelsByBin: _zones_actions.getLevelsByBin,
	  handleInventoryClick: _inventories_actions.handleInventoryClick,
	  fetchDisplayCategories: _products_actions.fetchDisplayCategories,
	  editDisplayCategories: _products_actions.editDisplayCategories,
	  setConfirmPasscodeModalVisibility: _baseModal_actions.setConfirmPasscodeModalVisibility,
	  setPasscodeVerificationStatus: _baseModal_actions.setPasscodeVerificationStatus,
	  initializeESL: _products_actions.initializeESL,
	  deleteESL: _products_actions.deleteESL,
	  fetchESLTemplate: _products_actions.fetchESLTemplate,
	  saveESL: _products_actions.saveESL,
	  fetchESL: _products_actions.fetchESL,
	  fetchCustomers: _products_actions.fetchCustomers
	})(productForm);
	
	exports.default = _default;
	
	// fields!: ['Product_id', 'ProductNum', 'GeneralNum', 'RefNum', 'Name', 'Description', 'Relate_Product_id', 'ProductGroup_id',
	//     'ProductCategory1_id', 'ProductCategory2_id', 'Vendor_id', 'Default_Warehouse_id', 'Default_WarehouseLoaction_id',
	//     'Default_WarehouseZone_id', 'Default_WarehouseBin_id', 'PackageType_id', 'PackageSize', 'Width', 'Length', 'Height',
	//     'MeasureUnit', 'NetWeight', 'ShippingWeight', 'MaxWeightRange', 'MinWeightRange', 'MaxStockRange', 'MinStockRange',
	//     'ShiftLife', 'ProductType_id', 'Purchasor_User_id', 'ProductBarcode', 'RefBarcode', 'Discontinued', 'Taxable', 'OverSaleable',
	//     'Promotion', 'StopSale', 'NetCost', 'ItemCost', 'LowestSalePrice', 'RefPrice']
	
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isMyuMyu, 'isMyuMyu', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isJML, 'isJML', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isHMM, 'isHMM', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isUSPride, 'isUSPride', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isATL, 'isATL', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isRS, 'isRS', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isNumeric, 'isNumeric', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(productForm, 'productForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productForm.jsx');
	}();

	;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.productFormNavigation_3 = exports.productFormNavigation_2 = undefined;
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _products_actions = __webpack_require__(30);
	
	var _productFormNavigation = __webpack_require__(419);
	
	var productFormNavigation_1 = (0, _reduxForm.reduxForm)({
	  form: 'productFormNavigation_1'
	})(_productFormNavigation.ProductFormNavigation_1);
	
	var selector = (0, _reduxForm.formValueSelector)('productFormNavigation_1');
	
	function mapStateToProps(state) {
	  var Category = selector(state, 'Category');
	  var Group = selector(state, 'Group');
	  var IsLarge = selector(state, 'IsLarge');
	  var LastDigit = selector(state, 'LastDigit');
	  var Name = selector(state, 'Name');
	  var Description = selector(state, 'Description');
	  return {
	    Category: Category,
	    Group: Group,
	    IsLarge: IsLarge,
	    LastDigit: LastDigit,
	    Name: Name,
	    Description: Description,
	    existingProd: state.products.all,
	    existingProdError: state.products.error,
	    existingProdIsLoading: state.products.isLoading,
	    fetchingSuggestedProdNum: state.products.fetchingSuggestedProdNum,
	    suggestedProdNumFetched: state.products.suggestedProdNumFetched,
	    suggestedProdNumFetchError: state.products.suggestedProdNumFetchError,
	    groupCategories: state.products.groupCategories,
	    groupCategoryError: state.products.groupCategoryError,
	    groupCategoryIsLoading: state.products.groupCategoryIsLoading,
	    fetchingSuggestDigit: state.products.fetchingSuggestDigit,
	    suggestDigitFetched: state.products.suggestDigitFetched,
	    suggestDigitFetchError: state.products.suggestDigitFetchError,
	    fetchingConvertableProducts: state.products.fetchingConvertableProducts,
	    convertableProductsFetchError: state.products.convertableProductsFetchError
	  };
	}
	
	productFormNavigation_1 = (0, _reactRedux.connect)(mapStateToProps, {
	  setValue: _products_actions.setValue, fetchGroupCategories: _products_actions.fetchGroupCategories, fetchSuggestedProdNum: _products_actions.fetchSuggestedProdNum,
	  fetchProductsByCategory: _products_actions.fetchProductsByCategory, fetchSuggestDigit: _products_actions.fetchSuggestDigit, clearSuggestDigit: _products_actions.clearSuggestDigit
	})(productFormNavigation_1);
	var _default = productFormNavigation_1;
	exports.default = _default;
	
	
	var productFormNavigation_2 = (0, _reduxForm.reduxForm)({
	  form: 'productFormNavigation_2'
	})(_productFormNavigation.ProductFormNavigation_2);
	
	var selector_2 = (0, _reduxForm.formValueSelector)('productFormNavigation_2');
	
	function mapStateToProps_2(state) {
	  var ProdType = selector_2(state, 'ProdType');
	  var PackageType = selector_2(state, 'PackageType');
	  var PackageSize_1 = selector_2(state, 'PackageSize_1');
	  var PackageType_2 = selector_2(state, 'PackageType_2');
	  var PackageSize_2 = selector_2(state, 'PackageSize_2');
	  var MeasureUnit_2 = selector_2(state, 'MeasureUnit_2');
	  var NetWeight_1 = selector_2(state, 'NetWeight_1');
	  var NetWeight_2 = selector_2(state, 'NetWeight_2');
	  var RefPrice = selector_2(state, 'RefPrice');
	  var LowestSalePrice = selector_2(state, 'LowestSalePrice');
	  return {
	    ProdType: ProdType,
	    PackageType: PackageType,
	    PackageSize_1: PackageSize_1,
	    PackageType_2: PackageType_2,
	    PackageSize_2: PackageSize_2,
	    MeasureUnit_2: MeasureUnit_2,
	    NetWeight_1: NetWeight_1,
	    NetWeight_2: NetWeight_2,
	    RefPrice: RefPrice,
	    LowestSalePrice: LowestSalePrice,
	    packageTypesFetched: state.products.packageTypesFetched,
	    measurementUnitFetched: state.products.measurementUnitFetched
	  };
	}
	
	exports.productFormNavigation_2 = productFormNavigation_2 = (0, _reactRedux.connect)(mapStateToProps_2, { setValue: _products_actions.setValue, fetchPackageTypes: _products_actions.fetchPackageTypes, fetchMeasurementUnit: _products_actions.fetchMeasurementUnit })(productFormNavigation_2);
	exports.productFormNavigation_2 = productFormNavigation_2;
	
	
	var productFormNavigation_3 = (0, _reduxForm.reduxForm)({
	  form: 'productFormNavigation_3'
	})(_productFormNavigation.ProductFormNavigation_3);
	
	var selector_3 = (0, _reduxForm.formValueSelector)('productFormNavigation_3');
	
	function mapStateToProps_3(state) {
	  var ConvertNum = selector_3(state, 'ConvertNum');
	  var SmallProdType = selector_3(state, 'SmallProdType');
	  var SmallPackageType = selector_3(state, 'SmallPackageType');
	  var ConvertType = selector_3(state, 'ConvertType');
	  return {
	    ConvertNum: ConvertNum,
	    SmallProdType: SmallProdType,
	    SmallPackageType: SmallPackageType,
	    ConvertType: ConvertType,
	    packageTypesFetched: state.products.packageTypesFetched,
	    fetchingConvertableProducts: state.products.fetchingConvertableProducts,
	    convertableProductsFetched: state.products.convertableProductsFetched,
	    convertableProductsFetchError: state.products.convertableProductsFetchError
	  };
	}
	
	exports.productFormNavigation_3 = productFormNavigation_3 = (0, _reactRedux.connect)(mapStateToProps_3, { setValue: _products_actions.setValue, fetchPackageTypes: _products_actions.fetchPackageTypes, fetchConvertableProducts: _products_actions.fetchConvertableProducts })(productFormNavigation_3);
	
	exports.productFormNavigation_3 = productFormNavigation_3;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productFormNavigation.jsx');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps_2, 'mapStateToProps_2', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productFormNavigation.jsx');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps_3, 'mapStateToProps_3', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productFormNavigation.jsx');
	
	  __REACT_HOT_LOADER__.register(productFormNavigation_1, 'productFormNavigation_1', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productFormNavigation.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productFormNavigation.jsx');
	
	  __REACT_HOT_LOADER__.register(productFormNavigation_2, 'productFormNavigation_2', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productFormNavigation.jsx');
	
	  __REACT_HOT_LOADER__.register(selector_2, 'selector_2', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productFormNavigation.jsx');
	
	  __REACT_HOT_LOADER__.register(productFormNavigation_3, 'productFormNavigation_3', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productFormNavigation.jsx');
	
	  __REACT_HOT_LOADER__.register(selector_3, 'selector_3', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productFormNavigation.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/productFormNavigation.jsx');
	}();

	;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _products_actions = __webpack_require__(30);
	
	var _inventories_actions = __webpack_require__(38);
	
	var _products = __webpack_require__(420);
	
	var _products2 = _interopRequireDefault(_products);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    groups: state.products.groups,
	    products: state.products.all,
	    currentProduct: state.products.currentProduct,
	    isLoading: state.products.isLoading,
	    error: state.products.error,
	    groupCategories: state.products.groupCategories,
	    groupCategoryError: state.products.groupCategoryError,
	    groupCategoryIsLoading: state.products.groupCategoryIsLoading,
	    currentCategoryGroup: state.products.currentCategoryGroup,
	    userType: state.auth.userType,
	    userPermissions: state.auth.userPermissions,
	    product: state.products.product,
	    filters: state.products.filters
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { setOriginPage: _inventories_actions.setOriginPage, resetGroupAndCategory: _products_actions.resetGroupAndCategory, fetchGroups: _products_actions.fetchGroups, fetchGroupCategories: _products_actions.fetchGroupCategories, fetchProductsByGroup: _products_actions.fetchProductsByGroup, fetchProductsByCategory: _products_actions.fetchProductsByCategory, fetchProducts: _products_actions.fetchProducts, selectProduct: _products_actions.selectProduct, resetCurrentProduct: _products_actions.resetCurrentProduct, setGroupCategory: _products_actions.setGroupCategory, attachDocument: _products_actions.attachDocument, fetchQuickAccess: _products_actions.fetchQuickAccess, setRowsFilters: _products_actions.setRowsFilters })(_products2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/products.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Products/products.jsx');
	}();

	;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _chartModal = __webpack_require__(422);
	
	var _chartModal2 = _interopRequireDefault(_chartModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var chartModal = (0, _reduxForm.reduxForm)({
	  form: 'chartModal'
	})(_chartModal2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('chartModal');
	
	function mapStateToProps(state) {
	  return {
	    purchasePivotChartsIsLoading: state.purchaseOrders.purchasePivotChartsIsLoading,
	    purchasePivotCharts: state.purchaseOrders.purchasePivotCharts,
	    purchasePivotChartsError: state.purchaseOrders.purchasePivotChartsError,
	    isDuplicatingPurchasePivotChart: state.purchaseOrders.isDuplicatingPurchasePivotChart,
	    duplicatedPurchasePivotChart: state.purchaseOrders.duplicatedPurchasePivotChart
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { setPurchasePivotChart: _purchaseOrders_actions.setPurchasePivotChart, duplicatePivotChart: _purchaseOrders_actions.duplicatePivotChart })(chartModal);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/chartModal.jsx');
	
	  __REACT_HOT_LOADER__.register(chartModal, 'chartModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/chartModal.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/chartModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/chartModal.jsx');
	}();

	;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _customers_actions = __webpack_require__(42);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _customerInfo = __webpack_require__(424);
	
	var _customerInfo2 = _interopRequireDefault(_customerInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customerInfo = (0, _reduxForm.reduxForm)({
	    form: 'customerInfo',
	    validate: validate
	})(_customerInfo2.default);
	var selector = (0, _reduxForm.formValueSelector)('customerInfo');
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.Name) {
	        errors.Name = 'Required';
	    }
	    if (!values.TermDays) {
	        errors.TermDays = 'Required';
	    } else if (isNaN(Number(values.TermDays))) {
	        errors.TermDays = 'Term Days should be a number.';
	    }
	    if (!values.Termtype) {
	        errors.Termtype = 'Required';
	    }
	    return errors;
	};
	
	function mapStateToProps(state) {
	    var deliver_Customer_id = selector(state, 'Deliver_Customer_id');
	    return {
	        deliver_Customer_id: deliver_Customer_id,
	        currentPaymentTerm: state.paymentTerms.currentPaymentTerm,
	        initialValues: state.paymentTerms.currentPaymentTerm,
	        isCreating: state.paymentTerms.isCreating,
	        createError: state.paymentTerms.createError,
	        created: state.paymentTerms.created,
	        isEditing: state.paymentTerms.isEditing,
	        editError: state.paymentTerms.editError,
	        edited: state.paymentTerms.edited,
	
	        customers: state.customers.all,
	        customersIsLoading: state.customers.isLoading,
	        customersError: state.customers.error,
	        currentCustomerDetail: state.customers.currentCustomerDetail,
	        detailIsLoading: state.customers.detailIsLoading,
	        detailError: state.customers.detailError,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { createDropship: _purchaseOrders_actions.createDropship, fetchCustomers: _customers_actions.fetchCustomers, fetchCustomerDetail: _customers_actions.fetchCustomerDetail })(customerInfo);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/customerInfo.jsx');
	
	    __REACT_HOT_LOADER__.register(customerInfo, 'customerInfo', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/customerInfo.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/customerInfo.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/customerInfo.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/customerInfo.jsx');
	}();

	;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _customers_actions = __webpack_require__(42);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _sales_actions = __webpack_require__(28);
	
	var _dashboard_actions = __webpack_require__(132);
	
	var _arap_actions = __webpack_require__(43);
	
	var _presidentDashboard = __webpack_require__(426);
	
	var _presidentDashboard2 = _interopRequireDefault(_presidentDashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var presidentDashboard = (0, _reduxForm.reduxForm)({
	  form: 'presidentDashboard'
	})(_presidentDashboard2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('presidentDashboard');
	
	function mapStateToProps(state) {
	  var OverallPeriod = selector(state, 'OverallPeriod');
	  var SalesPeriod = selector(state, 'SalesPeriod');
	
	  return {
	    OverallPeriod: OverallPeriod,
	    SalesPeriod: SalesPeriod,
	
	    customers: state.customers.all,
	    customersIsLoading: state.customers.isLoading,
	    customersError: state.customers.error,
	
	    presidentInfo: state.purchaseOrders.presidentInfo,
	    presidentInfoIsLoading: state.purchaseOrders.presidentInfoIsLoading,
	    presidentInfoError: state.purchaseOrders.presidentInfoError,
	
	    overallSales: state.salesOrders.overallSales,
	    overallSalesIsLoading: state.salesOrders.overallSalesIsLoading,
	    overallSalesError: state.salesOrders.overallSalesError,
	
	    overallPurchases: state.purchaseOrders.overallPurchases,
	    overallPurchasesIsLoading: state.purchaseOrders.overallPurchasesIsLoading,
	    overallPurchasesError: state.purchaseOrders.overallPurchasesError,
	
	    customersStatuses: state.customers.customersStatuses,
	    customersStatusesIsLoading: state.customers.customersStatusesIsLoading,
	    customersStatusesError: state.customers.customersStatusesError,
	
	    consolodatedStatistics: state.dashboard.consolodatedStatistics,
	    consolodatedStatisticsIsLoading: state.dashboard.consolodatedStatisticsIsLoading,
	    consolodatedStatisticsError: state.dashboard.consolodatedStatisticsError,
	
	    customerStatementListIsLoading: state.arap.customerStatementListIsLoading,
	    customerStatementList: state.arap.customerStatementList,
	    customerStatementListError: state.arap.customerStatementListError,
	
	    salesTotals: state.salesOrders.salesTotals,
	    salesTotalsIsLoading: state.salesOrders.salesTotalsIsLoading,
	    salesTotalsError: state.salesOrders.salesTotalsError,
	
	    vendorStatementListIsLoading: state.arap.vendorStatementListIsLoading,
	    vendorStatementList: state.arap.vendorStatementList,
	    vendorStatementListError: state.arap.vendorStatementListError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchSalesTotals: _sales_actions.fetchSalesTotals,
	  fetchCustomers: _customers_actions.fetchCustomers,
	  fetchPresidentDashInfo: _purchaseOrders_actions.fetchPresidentDashInfo,
	  fetchOverallPurchasePerformance: _purchaseOrders_actions.fetchOverallPurchasePerformance,
	  fetchOverallSalesPerformance: _sales_actions.fetchOverallSalesPerformance,
	  fetchCustomersStatus: _customers_actions.fetchCustomersStatus,
	  fetchConsolidatedStatistics: _dashboard_actions.fetchConsolidatedStatistics,
	  fetchCustomerStatementList: _arap_actions.fetchCustomerStatementList,
	  fetchVendorStatementList: _arap_actions.fetchVendorStatementList
	})(presidentDashboard);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/presidentDashboard.jsx');
	
	  __REACT_HOT_LOADER__.register(presidentDashboard, 'presidentDashboard', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/presidentDashboard.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/presidentDashboard.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/presidentDashboard.jsx');
	}();

	;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _priceAdjustment = __webpack_require__(427);
	
	var _priceAdjustment2 = _interopRequireDefault(_priceAdjustment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var priceAdjustmentReport = (0, _reduxForm.reduxForm)({
	  form: 'priceAdjustmentReport'
	})(_priceAdjustment2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('priceAdjustmentReport');
	
	function mapStateToProps(state) {
	  return {
	    priceAdjustmentIsLoading: state.purchaseOrders.priceAdjustmentIsLoading,
	    priceAdjustment: state.purchaseOrders.priceAdjustment,
	    priceAdjustmentError: state.purchaseOrders.priceAdjustmentError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchPriceAdjustment: _purchaseOrders_actions.fetchPriceAdjustment })(priceAdjustmentReport);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/priceAdjustment.jsx');
	
	  __REACT_HOT_LOADER__.register(priceAdjustmentReport, 'priceAdjustmentReport', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/priceAdjustment.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/priceAdjustment.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/priceAdjustment.jsx');
	}();

	;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _priceAdjustmentDetail = __webpack_require__(428);
	
	var _priceAdjustmentDetail2 = _interopRequireDefault(_priceAdjustmentDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var priceAdjustmentDetail = (0, _reduxForm.reduxForm)({
	  form: 'priceAdjustmentDetail'
	})(_priceAdjustmentDetail2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('priceAdjustmentDetail');
	
	function mapStateToProps(state) {
	  return {
	    priceAdjustmentIsLoading: state.purchaseOrders.priceAdjustmentIsLoading,
	    priceAdjustment: state.purchaseOrders.priceAdjustment,
	    priceAdjustmentError: state.purchaseOrders.priceAdjustmentError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { createPriceAdjustment: _purchaseOrders_actions.createPriceAdjustment })(priceAdjustmentDetail);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/priceAdjustmentDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(priceAdjustmentDetail, 'priceAdjustmentDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/priceAdjustmentDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/priceAdjustmentDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/priceAdjustmentDetail.jsx');
	}();

	;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _inventories_actions = __webpack_require__(38);
	
	var _favorites_actions = __webpack_require__(58);
	
	var _purchaseQuotes_actions = __webpack_require__(62);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _purchaseReturns_actions = __webpack_require__(112);
	
	var _purchaseDashboard = __webpack_require__(431);
	
	var _purchaseDashboard2 = _interopRequireDefault(_purchaseDashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var purchaseDashboard = (0, _reduxForm.reduxForm)({
	    form: 'purchaseDashboard'
	})(_purchaseDashboard2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('purchaseDashboard');
	
	function mapStateToProps(state) {
	    var dateChosen = selector(state, 'SelectedDate');
	
	    return {
	        dateChosen: dateChosen,
	
	        todaysIncomingOrders: state.purchaseOrders.todaysIncomingOrders,
	        todaysIncomingOrdersIsLoading: state.purchaseOrders.todaysIncomingOrdersIsLoading,
	        todaysIncomingOrdersError: state.purchaseOrders.todaysIncomingOrdersError,
	
	        // To be removed
	        currentPurchaseOrder: state.purchaseOrders.currentPurchaseOrder,
	        purchaseOrders: state.purchaseOrders.all,
	        POIsLoading: state.purchaseOrders.isLoading,
	        POError: state.purchaseOrders.error,
	        // end here
	
	        inventories: state.inventories.all,
	        favorites: state.favorites.all,
	        inventoryIsLoading: state.inventories.isLoading,
	        favoritesAreLoading: state.favorites.isLoading,
	        inventoryError: state.inventories.error,
	        favoritesError: state.favorites.error,
	        currentInventory: state.inventories.currentInventory,
	        currentFavorites: state.favorites.currentFavorites,
	
	        numPurchaseQuotes: state.purchaseQuotes.numPurchaseQuotes,
	        numPurchaseQuotesLoading: state.purchaseQuotes.numPurchaseQuotesLoading,
	        numPurchaseQuotesError: state.purchaseQuotes.numPurchaseQuotesError,
	        numPurchaseOrdersNotReceived: state.purchaseOrders.numPurchaseOrdersNotReceived,
	        numPurchaseOrdersNotReceivedLoading: state.purchaseOrders.numPurchaseOrdersNotReceivedLoading,
	        numPurchaseOrdersNotReceivedError: state.purchaseOrders.numPurchaseOrdersNotReceivedError,
	        numTotalPurchases: state.purchaseOrders.numTotalPurchases,
	        numTotalPurchasesError: state.purchaseOrders.numTotalPurchasesError,
	        numTotalPurchasesLoading: state.purchaseOrders.numTotalPurchasesLoading,
	        numPurchaseOrdersNotPaid: state.purchaseOrders.numPurchaseOrdersNotPaid,
	        numPurchaseOrdersNotPaidLoading: state.purchaseOrders.numPurchaseOrdersNotPaidLoading,
	        numPurchaseOrdersNotPaidError: state.purchaseOrders.numPurchaseOrdersNotPaidError
	
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchPurchaseOrders: _purchaseOrders_actions.fetchPurchaseOrders, selectPurchaseOrder: _purchaseOrders_actions.selectPurchaseOrder, resetCurrentPurchaseOrder: _purchaseOrders_actions.resetCurrentPurchaseOrder,
	    fetchInventories: _inventories_actions.fetchInventories, fetchFavorites: _favorites_actions.fetchFavorites, selectInventory: _inventories_actions.selectInventory, selectFavorites: _favorites_actions.selectFavorites,
	    resetCurrentInventory: _inventories_actions.resetCurrentInventory, resetCurrentFavorites: _favorites_actions.resetCurrentFavorites, deleteFavorite: _favorites_actions.deleteFavorite,
	    fetchNumPurchaseQuotes: _purchaseQuotes_actions.fetchNumPurchaseQuotes, fetchPurchaseOrdersNotReceived: _purchaseOrders_actions.fetchPurchaseOrdersNotReceived, fetchTotalPurchases: _purchaseOrders_actions.fetchTotalPurchases,
	    fetchTodaysIncomingOrders: _purchaseOrders_actions.fetchTodaysIncomingOrders, fetchIncomingOrdersByDate: _purchaseOrders_actions.fetchIncomingOrdersByDate, resetCurrentPurchaseReturn: _purchaseReturns_actions.resetCurrentPurchaseReturn, fetchPurchasePaymentNotPaid: _purchaseOrders_actions.fetchPurchasePaymentNotPaid })(purchaseDashboard);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseDashboard.jsx');
	
	    __REACT_HOT_LOADER__.register(purchaseDashboard, 'purchaseDashboard', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseDashboard.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseDashboard.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseDashboard.jsx');
	}();

	;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _inventories_actions = __webpack_require__(38);
	
	var _favorites_actions = __webpack_require__(58);
	
	var _vendors_actions = __webpack_require__(46);
	
	var _purchaseQuotes_actions = __webpack_require__(62);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _purchaseManagerDashboard = __webpack_require__(432);
	
	var _purchaseManagerDashboard2 = _interopRequireDefault(_purchaseManagerDashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var purchaseManagerDashboard = (0, _reduxForm.reduxForm)({
	    form: 'purchaseManagerDashboard'
	})(_purchaseManagerDashboard2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('purchaseManagerDashboard');
	
	function mapStateToProps(state) {
	    var dateChosen = selector(state, 'SelectedDate');
	
	    return {
	        dateChosen: dateChosen,
	
	        vendorRecords: state.vendors.vendorRecords,
	        vendorRecordsIsLoading: state.vendors.vendorRecordsIsLoading,
	        vendorRecordsError: state.vendors.vendorRecordsError,
	
	        purchaseOrderPerformance: state.purchaseOrders.purchaseOrderPerformance,
	        purchaseOrderPerformanceIsLoading: state.purchaseOrders.purchaseOrderPerformanceIsLoading,
	        purchaseOrderPerformanceError: state.purchaseOrders.purchaseOrderPerformanceError,
	
	        purchaseManagerInfo: state.purchaseOrders.purchaseManagerInfo,
	        purchaseManagerInfoIsLoading: state.purchaseOrders.purchaseManagerInfoIsLoading,
	        purchaseManagerInfoError: state.purchaseOrders.purchaseManagerInfoError,
	
	        lastMonth: state.purchaseOrders.lastMonth,
	        lastMonthIsLoading: state.purchaseOrders.lastMonthIsLoading,
	        lastMonthError: state.purchaseOrders.lastMonthError,
	
	        purchasersPerformance: state.purchaseOrders.purchasersPerformance,
	        purchasersPerformanceIsLoading: state.purchaseOrders.purchasersPerformanceIsLoading,
	        purchasersPerformanceError: state.purchaseOrders.purchasersPerformanceError,
	
	        incidentReport: state.purchaseOrders.incidentReport,
	        incidentReportIsLoading: state.purchaseOrders.incidentReportIsLoading,
	        incidentReportError: state.purchaseOrders.incidentReportError
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	    fetchVendorRecords: _vendors_actions.fetchVendorRecords, fetchPurchaseOrderPerformance: _purchaseOrders_actions.fetchPurchaseOrderPerformance, fetchPurchaseManagerInfo: _purchaseOrders_actions.fetchPurchaseManagerInfo,
	    fetchMonthPerformance: _purchaseOrders_actions.fetchMonthPerformance, fetchPurchasersPerformance: _purchaseOrders_actions.fetchPurchasersPerformance, fetchIncidentReport: _purchaseOrders_actions.fetchIncidentReport })(purchaseManagerDashboard);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseManagerDashboard.jsx');
	
	    __REACT_HOT_LOADER__.register(purchaseManagerDashboard, 'purchaseManagerDashboard', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseManagerDashboard.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseManagerDashboard.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseManagerDashboard.jsx');
	}();

	;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _purchaseOrderForm = __webpack_require__(433);
	
	var _purchaseOrderForm2 = _interopRequireDefault(_purchaseOrderForm);
	
	var _vendors_actions = __webpack_require__(46);
	
	var _products_actions = __webpack_require__(30);
	
	var _paymentTerms_actions = __webpack_require__(54);
	
	var _warehouses_actions = __webpack_require__(44);
	
	var _sales_actions = __webpack_require__(28);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _purchaseQuotes_actions = __webpack_require__(62);
	
	var _purchaseTemplates_actions = __webpack_require__(65);
	
	var _print_actions = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isNumeric = function isNumeric(n) {
	    return !isNaN(parseFloat(n)) && isFinite(n);
	};
	
	var validate = function validate(values, props) {
	    var errors = {};
	
	    if (values.AllProd_Quantity && !isNumeric(values.AllProd_Quantity)) {
	        errors.AllProd_Quantity = 'Accept number only!';
	    }
	    if (values.AllProd_Quantity && values.AllProd_Quantity < 0) {
	        errors.AllProd_Quantity = 'Positive number only!';
	    }
	    if (values.AllProd_FOBUnitPrice && !isNumeric(values.AllProd_FOBUnitPrice)) {
	        errors.AllProd_FOBUnitPrice = 'Accept number only!';
	    }
	    if (values.AllProd_FOBUnitPrice && values.AllProd_FOBUnitPrice < 0) {
	        errors.AllProd_FOBUnitPrice = 'Positive number only!';
	    }
	    if (values.AllProd_EstSalePrice && !isNumeric(values.AllProd_EstSalePrice)) {
	        errors.AllProd_EstSalePrice = 'Accept number only!';
	    }
	    if (values.AllProd_EstSalePrice && values.AllProd_EstSalePrice < 0) {
	        errors.AllProd_EstSalePrice = 'Positive number only!';
	    }
	    if (values.Quantity && !isNumeric(values.Quantity)) {
	        errors.Quantity = 'Accept number only!';
	    }
	    if (values.FOBUnitPrice && !isNumeric(values.FOBUnitPrice)) {
	        errors.FOBUnitPrice = 'Accept number only!';
	    }
	    if (values.FOBUnitPrice && values.FOBUnitPrice < 0) {
	        errors.FOBUnitPrice = 'Positive number only!';
	    }
	    if (values.EstSalePrice && !isNumeric(values.EstSalePrice)) {
	        errors.EstSalePrice = 'Accept number only!';
	    }
	    if (values.ShippingCost && !isNumeric(values.ShippingCost)) {
	        errors.ShippingCost = 'Accept number only!';
	    }
	    if (values.ShippingCost && values.ShippingCost < 0) {
	        errors.ShippingCost = 'Positive number only!';
	    }
	    if (values.HandlingCost && !isNumeric(values.HandlingCost)) {
	        errors.HandlingCost = 'Accept number only!';
	    }
	    if (values.HandlingCost && values.HandlingCost < 0) {
	        errors.HandlingCost = 'Positive number only!';
	    }
	    if (values.MiscCost && !isNumeric(values.MiscCost)) {
	        errors.MiscCost = 'Accept number only!';
	    }
	    if (values.MiscCost && values.MiscCost < 0) {
	        errors.MiscCost = 'Positive number only!';
	    }
	    if (values.Adjustments && !isNumeric(values.Adjustments)) {
	        errors.Adjustments = 'Accept number only!';
	    }
	    if (values.Discount && !isNumeric(values.Discount)) {
	        errors.Discount = 'Accept number only!';
	    }
	    if (values.Discount && values.Discount < 0) {
	        errors.Discount = 'Positive number only!';
	    }
	
	    if (!values.ShippingMethod) {
	        errors.ShippingMethod = 'Required';
	    }
	
	    if (!values.Vendor_id) {
	        errors.Vendor_id = 'Required';
	    }
	
	    // if (values.TaxRate && !isNumeric(values.TaxRate)) {
	    //     errors.TaxRate = 'Accept number only!'
	    // }
	    // if (values.TaxRate && (values.TaxRate < 0)) {
	    //     errors.TaxRate = 'Positive number only!'
	    // }
	
	
	    return errors;
	};
	var purchaseOrderForm = (0, _reduxForm.reduxForm)({
	    form: 'purchaseOrderForm',
	    validate: validate,
	    enableReinitialize: true,
	    touchOnChange: true,
	    touchOnBlur: false
	})(_purchaseOrderForm2.default);
	
	// let today = new Date();
	// let initialValues = {
	//   OrderDate: today
	// }
	//
	// purchaseOrderForm = connect(
	//     state => ({
	//       initialValues: initialValues
	//     })
	// )(purchaseOrderForm)
	
	var selector = (0, _reduxForm.formValueSelector)('purchaseOrderForm');
	
	function mapStateToProps(state) {
	    var productInformation = selector(state, 'ProductInformation');
	
	    var productsValue = selector(state, 'Purchase_Order_Line');
	    var vendorsValue = selector(state, 'Vendor_id');
	    var vendorContactValue = selector(state, 'VendorContact');
	    var priceTypeValue = selector(state, 'ConvertItemPrice');
	    var miscCostValue = selector(state, 'MiscCost');
	    var handlingCostValue = selector(state, 'HandlingCost');
	    var shippingCostValue = selector(state, 'ShippingCost');
	    var adjustmentValue = selector(state, 'PriceAdjustment');
	    var allProducts = selector(state, 'AllProducts');
	    var allProdQuantity = selector(state, 'AllProd_Quantity');
	    var weight = selector(state, 'Weight');
	    var allProdFOBUnitPrice = selector(state, 'AllProd_FOBUnitPrice');
	    var allProdEstSalePrice = selector(state, 'AllProd_EstSalePrice');
	    var FOBUnitPrice = selector(state, 'FOBUnitPrice');
	    var remark = selector(state, 'Remark');
	    var allProdRemark = selector(state, 'AllProd_Remark');
	    var searchType = selector(state, 'searchType');
	    var isDropship = selector(state, 'IsDropship');
	    var shippingMethod = selector(state, 'ShippingMethod');
	    var orderDate = selector(state, 'OrderDate');
	
	    var taxRate = selector(state, 'TaxRate');
	
	    return {
	        productInformation: productInformation,
	
	        productsValue: productsValue,
	        vendorsValue: vendorsValue,
	        vendorContactValue: vendorContactValue,
	        priceTypeValue: priceTypeValue,
	        miscCostValue: miscCostValue,
	        shippingCostValue: shippingCostValue,
	        handlingCostValue: handlingCostValue,
	        adjustmentValue: adjustmentValue,
	        allProducts: allProducts,
	        allProdQuantity: allProdQuantity,
	        weight: weight,
	        allProdFOBUnitPrice: allProdFOBUnitPrice,
	        allProdEstSalePrice: allProdEstSalePrice,
	        FOBUnitPrice: FOBUnitPrice,
	        remark: remark,
	        allProdRemark: allProdRemark,
	        searchType: searchType,
	        isDropship: isDropship,
	        shippingMethod: shippingMethod,
	        orderDate: orderDate,
	        taxRate: taxRate,
	
	        currentPurchaseOrderDetail: state.purchaseOrders.currentPurchaseOrderDetail,
	        currentPurchaseOrder: state.purchaseOrders.currentPurchaseOrder,
	        currentPurchaseQuoteDetail: state.purchaseQuotes.currentPurchaseQuoteDetail,
	        currentPurchaseQuote: state.purchaseQuotes.currentPurchaseQuote,
	        currentPurchaseTemplate: state.purchaseTemplates.currentPurchaseTemplate,
	        currentPurchaseTemplateDetail: state.purchaseTemplates.currentPurchaseTemplateDetail,
	        detailIsLoading: state.purchaseOrders.detailIsLoading || state.purchaseQuotes.detailIsLoading || state.purchaseTemplates.detailIsLoading,
	        detailError: state.purchaseOrders.detailError || state.purchaseQuotes.detailError || state.purchaseTemplates.detailError,
	        initialValues: state.purchaseOrders.currentPurchaseOrderDetail || state.purchaseQuotes.currentPurchaseQuoteDetail || state.purchaseTemplates.currentPurchaseTemplateDetail,
	
	        isEditing: state.purchaseOrders.purchaseOrderIsEditing || state.purchaseQuotes.purchaseQuoteIsEditing || state.purchaseTemplates.purchaseTemplateIsEditing,
	        editError: state.purchaseOrders.purchaseOrderEditError || state.purchaseQuotes.purchaseQuoteEditError || state.purchaseTemplates.purchaseTemplateEditError,
	        isCreating: state.purchaseOrders.purchaseOrderIsCreating || state.purchaseQuotes.purchaseQuoteIsCreating || state.purchaseTemplates.purchaseTemplateIsCreating,
	        createError: state.purchaseOrders.purchaseOrderCreateError || state.purchaseQuotes.purchaseQuoteCreateError || state.purchaseTemplates.purchaseTemplateCreateError,
	
	        purchaseOrderCreated: state.purchaseOrders.purchaseOrderCreated,
	        purchaseOrderEdited: state.purchaseOrders.purchaseOrderEdited,
	
	        isPlacing: state.purchaseQuotes.purchaseQuoteIsPlacing,
	        placeError: state.purchaseQuotes.purchaseQuotePlaceError,
	        purchaseOrderPlaced: state.purchaseQuotes.purchaseQuotePlaced,
	
	        purchaseQuoteCreated: state.purchaseQuotes.purchaseQuoteCreated,
	        purchaseQuoteEdited: state.purchaseQuotes.purchaseQuoteEdited,
	
	        purchaseTemplateCreated: state.purchaseTemplates.purchaseTemplateCreated,
	        purchaseTemplateEdited: state.purchaseTemplates.purchaseTemplateEdited,
	
	        products: state.products.allByVendor,
	        productIsLoading: state.products.isLoading,
	        productError: state.products.error,
	        productInfo: state.products.productInfo,
	        productInfoIsLoading: state.products.productInfoIsLoading,
	        productInfoError: state.products.productInfoError,
	        vendors: state.vendors.all,
	        vendorIsLoading: state.vendors.isLoading,
	        vendorError: state.vendors.error,
	        currentVendorDetail: state.vendors.currentVendorDetail,
	        vendorDetailIsLoading: state.vendors.detailIsLoading,
	        vendorDetailError: state.vendors.detailError,
	        paymentTerms: state.paymentTerms.all,
	        paymentTermsIsLoading: state.paymentTerms.isLoading,
	        paymentTermsError: state.paymentTerms.error,
	        warehouses: state.warehouses.all,
	        warehouseIsLoading: state.warehouses.isLoading,
	        warehouseError: state.warehouses.error,
	        userPermissions: state.auth.userPermissions,
	
	        simplifiedProducts: state.products.simplifiedProducts,
	        simplifiedProductsIsLoading: state.products.simplifiedProductsIsLoading,
	        simplifiedProductsError: state.products.simplifiedProductsError,
	
	        taxRates: state.salesOrders.taxRates,
	        taxRatesIsLoading: state.salesOrders.taxRatesIsLoading,
	        taxRatesError: state.salesOrders.taxRatesError,
	
	        purchaseOrderProduct: state.purchaseOrders.purchaseOrderProduct,
	        purchaseOrderProductIsLoading: state.purchaseOrders.purchaseOrderProductIsLoading,
	        purchaseOrderProductError: state.purchaseOrders.purchaseOrderProductError,
	
	        requestingPurchaseOrderPdf: state.print.requestingPurchaseOrderPdf,
	        purchaseOrderPdf: state.print.purchaseOrderPdf
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	    convertTemplateToQuote: _purchaseTemplates_actions.convertTemplateToQuote,
	    createDropship: _purchaseOrders_actions.createDropship,
	    createPurchaseOrder: _purchaseOrders_actions.createPurchaseOrder,
	    createPurchaseQuote: _purchaseQuotes_actions.createPurchaseQuote,
	    createPurchaseTemplate: _purchaseTemplates_actions.createPurchaseTemplate,
	    editPurchaseOrder: _purchaseOrders_actions.editPurchaseOrder,
	    editPurchaseQuote: _purchaseQuotes_actions.editPurchaseQuote,
	    editPurchaseTemplate: _purchaseTemplates_actions.editPurchaseTemplate,
	    fetchActiveVendors: _vendors_actions.fetchActiveVendors,
	    fetchPaymentTerms: _paymentTerms_actions.fetchPaymentTerms,
	    fetchProductInfo: _products_actions.fetchProductInfo,
	    fetchProductsByVendor: _products_actions.fetchProductsByVendor,
	    fetchPurchaseOrderDetail: _purchaseOrders_actions.fetchPurchaseOrderDetail,
	    fetchPurchaseQuoteDetail: _purchaseQuotes_actions.fetchPurchaseQuoteDetail,
	    fetchPurchaseTemplateDetail: _purchaseTemplates_actions.fetchPurchaseTemplateDetail,
	    fetchSimplifiedProducts: _products_actions.fetchSimplifiedProducts,
	    fetchVendorDetail: _vendors_actions.fetchVendorDetail,
	    fetchVendors: _vendors_actions.fetchVendors,
	    fetchWarehouses: _warehouses_actions.fetchWarehouses, fetchTaxRates: _sales_actions.fetchTaxRates,
	    initializedPurchaseOrderForm: _purchaseOrders_actions.initializedPurchaseOrderForm,
	    initializeForm: _purchaseOrders_actions.initializeForm,
	    printPickup: _print_actions.printPickup,
	    printPurchaseOrder: _print_actions.printPurchaseOrder,
	    purchaseQuotePlace: _purchaseQuotes_actions.purchaseQuotePlace,
	    resetAllProducts: _purchaseOrders_actions.resetAllProducts,
	    resetCurrentPurchaseOrder: _purchaseOrders_actions.resetCurrentPurchaseOrder,
	    resetCurrentPurchaseQuote: _purchaseQuotes_actions.resetCurrentPurchaseQuote,
	    resetCurrentPurchaseTemplate: _purchaseTemplates_actions.resetCurrentPurchaseTemplate,
	    resetCurrentVendor: _vendors_actions.resetCurrentVendor,
	    selectPurchaseOrder: _purchaseOrders_actions.selectPurchaseOrder,
	    selectPurchaseQuote: _purchaseQuotes_actions.selectPurchaseQuote,
	    selectPurchaseTemplate: _purchaseTemplates_actions.selectPurchaseTemplate,
	    setAllProducts: _purchaseOrders_actions.setAllProducts,
	    setDefaultConvertItemPrice: _purchaseOrders_actions.setDefaultConvertItemPrice,
	    setDefaultIsDropship: _purchaseOrders_actions.setDefaultIsDropship,
	    setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	    setDefaults: _purchaseOrders_actions.setDefaults,
	    setDefaultSearchType: _purchaseOrders_actions.setDefaultSearchType,
	    setDefaultVendorAddress: _purchaseOrders_actions.setDefaultVendorAddress,
	    setInitialForm: _purchaseOrders_actions.setInitialForm,
	    setPriceValues: _purchaseOrders_actions.setPriceValues,
	    setValue: _purchaseOrders_actions.setValue, clearRemarks: _purchaseOrders_actions.clearRemarks
	})(purchaseOrderForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseOrderForm.jsx');
	
	    __REACT_HOT_LOADER__.register(isNumeric, 'isNumeric', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseOrderForm.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseOrderForm.jsx');
	
	    __REACT_HOT_LOADER__.register(purchaseOrderForm, 'purchaseOrderForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseOrderForm.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseOrderForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseOrderForm.jsx');
	}();

	;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _purchaseOrderList_actions = __webpack_require__(111);
	
	var _sales_actions = __webpack_require__(28);
	
	var _print_actions = __webpack_require__(47);
	
	var _settings_actions = __webpack_require__(33);
	
	var _purchaseOrderList = __webpack_require__(434);
	
	var _purchaseOrderList2 = _interopRequireDefault(_purchaseOrderList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var purchaseOrderList = (0, _reduxForm.reduxForm)({
	  form: 'purchaseOrderList',
	  destroyOnUnmount: false
	})(_purchaseOrderList2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('purchaseOrderList');
	
	function mapStateToProps(state) {
	  var Days = selector(state, 'Days');
	  var FromDate = selector(state, 'FromDate');
	  var ToDate = selector(state, 'ToDate');
	  var Status = selector(state, 'Status');
	  var Purchaser = selector(state, 'Purchaser');
	  var ProductNum = selector(state, 'ProductNum');
	  return {
	    Days: Days,
	    FromDate: FromDate,
	    ToDate: ToDate,
	    Status: Status,
	    Purchaser: Purchaser,
	    ProductNum: ProductNum,
	    currentPurchaseOrder: state.purchaseOrders.currentPurchaseOrder,
	    purchaseOrders: state.purchaseOrders.all,
	    isLoading: state.purchaseOrders.isLoading,
	    error: state.purchaseOrders.error,
	    userPermissions: state.auth.userPermissions,
	
	    purchaseOrderDetail: state.purchaseOrders.currentPurchaseOrderDetail,
	    purchaseOrderDetailIsLoading: state.purchaseOrders.detailIsLoading,
	    purchaseOrderDetailError: state.purchaseOrders.detailError,
	
	    purchaseOrderList: state.purchaseOrders.purchaseOrderList,
	    purchaseOrderListIsLoading: state.purchaseOrders.purchaseOrderListIsLoading,
	    purchaseOrderListError: state.purchaseOrders.purchaseOrderListError,
	
	    purchaseOrdersFilter: state.purchaseOrders.purchaseOrdersFilter,
	
	    users: state.settings.all,
	    usersIsLoading: state.settings.isLoading,
	    usersError: state.settings.error,
	
	    requestingPurchaseOrderPdf: state.print.requestingPurchaseOrderPdf,
	    purchaseOrderPdf: state.print.purchaseOrderPdf,
	
	    purchaseOrderPdfNs: state.print.purchaseOrderPdfNs,
	    requestingPurchaseOrderPdfNs: state.print.requestingPurchaseOrderPdfNs,
	
	    checkPassword: state.settings.checkPassword,
	    checkPasswordSuccess: state.settings.checkPasswordSuccess,
	    checkPasswordFailure: state.settings.checkPasswordFailure,
	
	    mergePurchaseOrderData: state.purchaseOrders.mergePurchaseOrderData,
	    mergePurchaseOrderError: state.purchaseOrders.mergePurchaseOrderError,
	    mergePurchaseOrderSuccess: state.purchaseOrders.mergePurchaseOrderSuccess,
	    mergePurchaseOrderLoading: state.purchaseOrders.mergePurchaseOrderLoading
	
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchPurchaseOrdersByDate: _purchaseOrders_actions.fetchPurchaseOrdersByDate,
	  fetchPurchaseOrderList: _purchaseOrders_actions.fetchPurchaseOrderList,
	  fetchPurchaseOrders: _purchaseOrders_actions.fetchPurchaseOrders,
	  selectPurchaseOrder: _purchaseOrders_actions.selectPurchaseOrder,
	  resetCurrentPurchaseOrder: _purchaseOrders_actions.resetCurrentPurchaseOrder,
	  setPurchaseOrdersFilter: _purchaseOrders_actions.setPurchaseOrdersFilter,
	  deletePurchaseOrder: _purchaseOrders_actions.deletePurchaseOrder,
	  setDefaultDays: _purchaseOrders_actions.setDefaultDays,
	  fetchPurchaseOrderDetail: _purchaseOrders_actions.fetchPurchaseOrderDetail,
	  setValue: _sales_actions.setValue,
	  fetchBaseUsers: _settings_actions.fetchBaseUsers,
	  fetchPurchaseOrdersByFilter: _purchaseOrderList_actions.fetchPurchaseOrdersByFilter,
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	  printPurchaseOrder: _print_actions.printPurchaseOrder,
	  checkPassword: _settings_actions.checkPassword,
	  clearCheckPassword: _settings_actions.clearCheckPassword,
	  printPurchaseOrderNoSubtotals: _print_actions.printPurchaseOrderNoSubtotals,
	  mergePurchaseOrders: _purchaseOrders_actions.mergePurchaseOrders,
	  approvePendingPO: _purchaseOrders_actions.approvePendingPO,
	  emailPO: _purchaseOrders_actions.emailPO,
	  uploadPOImage: _purchaseOrderList_actions.uploadPOImage,
	  uploadPOPOD: _purchaseOrderList_actions.uploadPOPOD
	})(purchaseOrderList);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseOrderList.jsx');
	
	  __REACT_HOT_LOADER__.register(purchaseOrderList, 'purchaseOrderList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseOrderList.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseOrderList.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseOrderList.jsx');
	}();

	;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _receive_actions = __webpack_require__(66);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _purchasePaymentDetail = __webpack_require__(435);
	
	var _purchasePaymentDetail2 = _interopRequireDefault(_purchasePaymentDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var purchasePaymentDetail = (0, _reduxForm.reduxForm)({
	    form: 'purchasePaymentDetail'
	})(_purchasePaymentDetail2.default);
	
	function mapStateToProps(state) {
	    return {
	        currentReceiveHistory: state.receives.currentReceiveHistory,
	        currentReceiveHistoryDetail: state.receives.fetchedReceiveHistoryDetailRecord,
	        detailIsLoading: state.receives.isfetchingReceiveHistoryDetail,
	        error: state.receives.fetchReceiveHistoryDetailError,
	        fetchedAttachedFiles: state.receives.fetchedAttachedFiles,
	        initialValues: state.receives.fetchedReceiveHistoryDetailRecord,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { resetAttachedFile: _receive_actions.resetAttachedFile, fetchAttachedFile: _receive_actions.fetchAttachedFile, attachFile: _receive_actions.attachFile, deleteAttachedFile: _receive_actions.deleteAttachedFile, fetchReceiveHistoryDetailRecord: _receive_actions.fetchReceiveHistoryDetailRecord, editReceiveHistory: _receive_actions.editReceiveHistory })(purchasePaymentDetail);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasePaymentDetail.jsx');
	
	    __REACT_HOT_LOADER__.register(purchasePaymentDetail, 'purchasePaymentDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasePaymentDetail.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasePaymentDetail.jsx');
	}();

	;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _receive_actions = __webpack_require__(66);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _purchasePaymentList = __webpack_require__(436);
	
	var _purchasePaymentList2 = _interopRequireDefault(_purchasePaymentList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var purchasePaymentList = (0, _reduxForm.reduxForm)({
	  form: 'purchasePaymentList'
	})(_purchasePaymentList2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('purchasePaymentList');
	
	function mapStateToProps(state) {
	  var Days = selector(state, 'Days');
	  var FromDate = selector(state, 'FromDate');
	  var ToDate = selector(state, 'ToDate');
	  return {
	    Days: Days,
	    FromDate: FromDate,
	    ToDate: ToDate,
	    currentReceiveHistory: state.receives.fetchedReceiveHistory,
	    isLoading: state.receives.isfetchingReceiveHistory,
	    error: state.receives.fetchReceiveHistoryError };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { selectReceiveHistory: _receive_actions.selectReceiveHistory, resetCurrentReceiveHistory: _receive_actions.resetCurrentReceiveHistory, fetchPurchaseOrders: _purchaseOrders_actions.fetchPurchaseOrders,
	  fetchReceiveHistory: _receive_actions.fetchReceiveHistory, fetchReceiveHistoryByDate: _receive_actions.fetchReceiveHistoryByDate, setDefaultDays: _purchaseOrders_actions.setDefaultDays })(purchasePaymentList);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasePaymentList.jsx');
	
	  __REACT_HOT_LOADER__.register(purchasePaymentList, 'purchasePaymentList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasePaymentList.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasePaymentList.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasePaymentList.jsx');
	}();

	;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _purchasePivotChart = __webpack_require__(437);
	
	var _purchasePivotChart2 = _interopRequireDefault(_purchasePivotChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var purchasePivotChart = (0, _reduxForm.reduxForm)({
	  form: 'purchasePivotChart'
	})(_purchasePivotChart2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('purchasePivotChart');
	
	function mapStateToProps(state) {
	  return {
	    purchasePivotChartOrdersIsLoading: state.purchaseOrders.purchasePivotChartOrdersIsLoading,
	    purchasePivotChartOrders: state.purchaseOrders.purchasePivotChartOrders,
	    purchasePivotChartOrdersError: state.purchaseOrders.purchasePivotChartOrdersError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchPurchasePivotChartOrders: _purchaseOrders_actions.fetchPurchasePivotChartOrders, fetchPurchasePivotCharts: _purchaseOrders_actions.fetchPurchasePivotCharts, clearDuplicatedPurchasePivotChart: _purchaseOrders_actions.clearDuplicatedPurchasePivotChart })(purchasePivotChart);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasePivotChart.jsx');
	
	  __REACT_HOT_LOADER__.register(purchasePivotChart, 'purchasePivotChart', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasePivotChart.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasePivotChart.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasePivotChart.jsx');
	}();

	;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _purchaseQuotes_actions = __webpack_require__(62);
	
	var _vendors_actions = __webpack_require__(46);
	
	var _purchasePivotChartDetail = __webpack_require__(438);
	
	var _purchasePivotChartDetail2 = _interopRequireDefault(_purchasePivotChartDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var purchasePivotChartDetail = (0, _reduxForm.reduxForm)({
	  form: 'purchasePivotChartDetail'
	})(_purchasePivotChartDetail2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('purchasePivotChartDetail');
	
	function mapStateToProps(state) {
	  vendor = selector(state, 'Vendor');
	  return {
	    vendor: vendor,
	    vendors: state.vendors.all,
	    vendorIsLoading: state.vendors.isLoading,
	    vendorError: state.vendors.error,
	    purchasePivot_id: state.purchaseOrders.purchasePivot_id,
	    purchasePivotChartsDetailIsLoading: state.purchaseOrders.purchasePivotChartsDetailIsLoading,
	    purchasePivotChartsDetail: state.purchaseOrders.purchasePivotChartsDetail,
	    purchasePivotChartsDetailError: state.purchaseOrders.purchasePivotChartsDetailError,
	    initialValues: state.purchaseOrders.purchasePivotChartsDetail,
	    purchaseQuoteIsCreating: state.purchaseQuotes.purchaseQuoteIsCreating,
	    purchaseQuoteCreateError: state.purchaseQuotes.purchaseQuoteCreateError,
	    purchaseQuoteCreated: state.purchaseQuotes.purchaseQuoteCreated
	
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchPurchasePivotChartsDetail: _purchaseOrders_actions.fetchPurchasePivotChartsDetail, fetchVendors: _vendors_actions.fetchVendors, resetPurchasePivotCharts: _purchaseOrders_actions.resetPurchasePivotCharts, createPurchasePivotChart: _purchaseOrders_actions.createPurchasePivotChart, createPurchaseQuote: _purchaseQuotes_actions.createPurchaseQuote, resetCurrentPurchaseQuote: _purchaseQuotes_actions.resetCurrentPurchaseQuote })(purchasePivotChartDetail);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasePivotChartDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(purchasePivotChartDetail, 'purchasePivotChartDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasePivotChartDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasePivotChartDetail.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasePivotChartDetail.jsx');
	}();

	;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _products_actions = __webpack_require__(30);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _purchasePivotChartSearchProd = __webpack_require__(439);
	
	var _purchasePivotChartSearchProd2 = _interopRequireDefault(_purchasePivotChartSearchProd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var purchasePivotChartSearchProd = (0, _reduxForm.reduxForm)({
	  form: 'purchasePivotChartSearchProd'
	})(_purchasePivotChartSearchProd2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('purchasePivotChartSearchProd');
	
	function mapStateToProps(state) {
	  var searchType = selector(state, 'SearchType');
	  var searchValue = selector(state, 'SearchValue');
	  return {
	    searchType: searchType,
	    searchValue: searchValue,
	    simplifiedProducts: state.products.simplifiedProducts,
	    simplifiedProductsIsLoading: state.products.simplifiedProductsIsLoading,
	    simplifiedProductsError: state.products.simplifiedProductsError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchSimplifiedProducts: _products_actions.fetchSimplifiedProducts, setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm })(purchasePivotChartSearchProd);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasePivotChartSearchProd.jsx');
	
	  __REACT_HOT_LOADER__.register(purchasePivotChartSearchProd, 'purchasePivotChartSearchProd', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasePivotChartSearchProd.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasePivotChartSearchProd.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasePivotChartSearchProd.jsx');
	}();

	;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _purchaseQuoteForm = __webpack_require__(440);
	
	var _purchaseQuoteForm2 = _interopRequireDefault(_purchaseQuoteForm);
	
	var _vendors_actions = __webpack_require__(46);
	
	var _products_actions = __webpack_require__(30);
	
	var _paymentTerms_actions = __webpack_require__(54);
	
	var _purchaseQuotes_actions = __webpack_require__(62);
	
	var _warehouses_actions = __webpack_require__(44);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _purchaseTemplates_actions = __webpack_require__(65);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var purchaseQuoteForm = (0, _reduxForm.reduxForm)({
	    form: 'purchaseQuoteForm'
	})(_purchaseQuoteForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('purchaseQuoteForm');
	
	function mapStateToProps(state) {
	    var productInformation = selector(state, 'ProductInformation');
	
	    var productsValue = selector(state, 'Purchase_Order_Line');
	    var vendorsValue = selector(state, 'Vendor_id');
	    var vendorContactValue = selector(state, 'VendorContact');
	    var priceTypeValue = selector(state, 'ConvertItemPrice');
	    var miscCostValue = selector(state, 'MiscCost');
	    var handlingCostValue = selector(state, 'HandlingCost');
	    var shippingCostValue = selector(state, 'ShippingCost');
	    var discountValue = selector(state, 'Discount');
	    var taxValue = selector(state, 'TaxRate');
	    var allProducts = selector(state, 'AllProducts');
	    var allProdQuantity = selector(state, 'AllProd_Quantity');
	    var allProdFOBUnitPrice = selector(state, 'AllProd_FOBUnitPrice');
	    var allProdEstSalePrice = selector(state, 'AllProd_EstSalePrice');
	    // Dumb way to get the formProps
	    var formProps = selector(state, 'OrderDate', 'ETADate', 'ReceivedDate', 'FinalNetWeight', 'FinalShippingWeight', 'TotalPrice', 'NoteToVendor', 'ReleaseInformation', 'CarryType', 'Discount', 'ShippingCost', 'HandlingCost', 'MiscCost', 'MiscNote', 'TaxRate', 'PaymentStatus', 'PurchaseStatus', 'FinalPrice', 'ConvertItemPrice', 'Vendor_id', 'Pickup_VendorAddress_id', 'Pickup_VendorContact_id', 'Deliver_Warehouse_id', 'DispatchMethod_id', 'DispatchOutSourceContact_id', 'Purchaser_User_id', 'Modifier_User_id', 'PaymentTerm_id');
	    return {
	        productInformation: productInformation,
	        productsValue: productsValue,
	        vendorsValue: vendorsValue,
	        vendorContactValue: vendorContactValue,
	        priceTypeValue: priceTypeValue,
	        miscCostValue: miscCostValue,
	        shippingCostValue: shippingCostValue,
	        handlingCostValue: handlingCostValue,
	        discountValue: discountValue,
	        taxValue: taxValue,
	        formProps: formProps,
	        allProducts: allProducts,
	        allProdQuantity: allProdQuantity,
	        allProdFOBUnitPrice: allProdFOBUnitPrice,
	        allProdEstSalePrice: allProdEstSalePrice,
	
	        currentPurchaseTemplateDetail: state.purchaseTemplates.currentPurchaseTemplateDetail,
	        currentPurchaseTemplate: state.purchaseTemplates.currentPurchaseTemplate,
	        currentPurchaseQuoteDetail: state.purchaseQuotes.currentPurchaseQuoteDetail,
	        currentPurchaseQuote: state.purchaseQuotes.currentPurchaseQuote,
	        detailIsLoading: state.purchaseQuotes.detailIsLoading || state.purchaseTemplates.detailIsLoading,
	        detailError: state.purchaseQuotes.detailError || state.purchaseTemplates.detailError,
	        initialValues: state.purchaseQuotes.currentPurchaseQuoteDetail || state.purchaseTemplates.currentPurchaseTemplateDetail,
	
	        isEditing: state.purchaseQuotes.purchaseQuoteIsEditing,
	        editError: state.purchaseQuotes.purchaseQuoteEditError,
	        isCreating: state.purchaseQuotes.purchaseQuoteIsCreating || state.purchaseOrders.purchaseOrderIsCreating,
	        createError: state.purchaseQuotes.purchaseQuoteCreateError || state.purchaseOrders.purchaseOrderCreateError,
	        isPlacing: state.purchaseQuotes.purchaseQuoteIsPlacing,
	        placeError: state.purchaseQuotes.purchaseQuotePlaceError,
	
	        products: state.products.allByVendor,
	        productIsLoading: state.products.isLoading,
	        productError: state.products.error,
	        productInfo: state.products.productInfo,
	        productInfoIsLoading: state.products.productInfoIsLoading,
	        productInfoError: state.products.productInfoError,
	        vendors: state.vendors.all,
	        vendorIsLoading: state.vendors.isLoading,
	        vendorError: state.vendors.error,
	        currentVendorDetail: state.vendors.currentVendorDetail,
	        vendorDetailIsLoading: state.vendors.detailIsLoading,
	        vendorDetailError: state.vendors.detailError,
	        paymentTerms: state.paymentTerms.all,
	        paymentTermsIsLoading: state.paymentTerms.isLoading,
	        paymentTermsError: state.paymentTerms.error,
	        warehouses: state.warehouses.all,
	        warehouseIsLoading: state.warehouses.isLoading,
	        warehouseError: state.warehouses.error,
	        userPermissions: state.auth.userPermissions,
	
	        simplifiedProducts: state.products.simplifiedProducts,
	        simplifiedProductsIsLoading: state.products.simplifiedProductsIsLoading,
	        simplifiedProductsError: state.products.simplifiedProductsError
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	    purchaseQuotePlace: _purchaseQuotes_actions.purchaseQuotePlace, fetchVendors: _vendors_actions.fetchVendors, fetchProductsByVendor: _products_actions.fetchProductsByVendor, fetchProductInfo: _products_actions.fetchProductInfo,
	    fetchPaymentTerms: _paymentTerms_actions.fetchPaymentTerms, fetchVendorDetail: _vendors_actions.fetchVendorDetail, resetCurrentVendor: _vendors_actions.resetCurrentVendor, fetchPurchaseQuoteDetail: _purchaseQuotes_actions.fetchPurchaseQuoteDetail,
	    convertTemplateToQuote: _purchaseTemplates_actions.convertTemplateToQuote, editPurchaseQuote: _purchaseQuotes_actions.editPurchaseQuote, createPurchaseQuote: _purchaseQuotes_actions.createPurchaseQuote, createPurchaseOrder: _purchaseOrders_actions.createPurchaseOrder,
	    fetchWarehouses: _warehouses_actions.fetchWarehouses, fetchSimplifiedProducts: _products_actions.fetchSimplifiedProducts, setPriceValues: _purchaseOrders_actions.setPriceValues })(purchaseQuoteForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseQuoteForm.jsx');
	
	    __REACT_HOT_LOADER__.register(purchaseQuoteForm, 'purchaseQuoteForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseQuoteForm.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseQuoteForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseQuoteForm.jsx');
	}();

	;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _purchaseQuotes_actions = __webpack_require__(62);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _reactRedux = __webpack_require__(6);
	
	var _purchaseQuoteList = __webpack_require__(441);
	
	var _purchaseQuoteList2 = _interopRequireDefault(_purchaseQuoteList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function mapStateToProps(state) {
	    var _ref;
	
	    return _ref = {
	        currentPurchaseQuote: state.purchaseQuotes.currentPurchaseQuote,
	        purchaseQuotes: state.purchaseQuotes.all,
	        isLoading: state.purchaseQuotes.isLoading,
	        error: state.purchaseQuotes.error,
	        userPermissions: state.auth.userPermissions
	    }, _defineProperty(_ref, 'currentPurchaseQuote', state.purchaseQuotes.currentPurchaseQuote), _defineProperty(_ref, 'purchaseOrderList', state.purchaseOrders.purchaseOrderList), _defineProperty(_ref, 'purchaseOrderListIsLoading', state.purchaseOrders.purchaseOrderListIsLoading), _defineProperty(_ref, 'purchaseOrderListError', state.purchaseOrders.purchaseOrderListError), _defineProperty(_ref, 'purchaseQuoteIsDeleting', state.purchaseQuotes.purchaseQuoteIsDeleting), _defineProperty(_ref, 'purchaseQuoteDeleteError', state.purchaseQuotes.purchaseQuoteDeleteError), _defineProperty(_ref, 'purchaseQuoteIsDeleted', state.purchaseQuotes.purchaseQuoteIsDeleted), _ref;
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchPurchaseQuotes: _purchaseQuotes_actions.fetchPurchaseQuotes, selectPurchaseQuote: _purchaseQuotes_actions.selectPurchaseQuote, resetCurrentPurchaseQuote: _purchaseQuotes_actions.resetCurrentPurchaseQuote, fetchPurchaseOrderList: _purchaseOrders_actions.fetchPurchaseOrderList, deletePurchaseQuote: _purchaseQuotes_actions.deletePurchaseQuote })(_purchaseQuoteList2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseQuoteList.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseQuoteList.jsx');
	}();

	;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _products_actions = __webpack_require__(30);
	
	var _print_actions = __webpack_require__(47);
	
	var _purchaseReference = __webpack_require__(443);
	
	var _purchaseReference2 = _interopRequireDefault(_purchaseReference);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var purchaseReferenceReport = (0, _reduxForm.reduxForm)({
	  form: 'purchaseReferenceReport',
	  destroyOnUnmount: false
	})(_purchaseReference2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('purchaseReferenceReport');
	
	function mapStateToProps(state) {
	  var typeRadios = selector(state, 'typeRadios');
	  return {
	    typeRadios: typeRadios,
	    groups: state.products.groups,
	    purchaseReferenceReportIsLoading: state.purchaseOrders.purchaseReferenceReportIsLoading,
	    purchaseReferenceReportError: state.purchaseOrders.purchaseReferenceReportError,
	    purchaseReferenceReport: state.purchaseOrders.purchaseReferenceReport,
	    groupCategories: state.products.groupCategories,
	
	    requestingPurchaseReferencePdf: state.print.requestingPurchaseReferencePdf,
	    purchaseReferencePdf: state.print.purchaseReferencePdf
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchGroupCategories: _products_actions.fetchGroupCategories,
	  fetchGroups: _products_actions.fetchGroups,
	  fetchPurchasingReference: _purchaseOrders_actions.fetchPurchasingReference,
	  printPurchaseReference: _print_actions.printPurchaseReference,
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm
	})(purchaseReferenceReport);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseReference.jsx');
	
	  __REACT_HOT_LOADER__.register(purchaseReferenceReport, 'purchaseReferenceReport', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseReference.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseReference.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseReference.jsx');
	}();

	;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _purchaseReturnForm = __webpack_require__(444);
	
	var _purchaseReturnForm2 = _interopRequireDefault(_purchaseReturnForm);
	
	var _vendors_actions = __webpack_require__(46);
	
	var _products_actions = __webpack_require__(30);
	
	var _paymentTerms_actions = __webpack_require__(54);
	
	var _warehouses_actions = __webpack_require__(44);
	
	var _sales_actions = __webpack_require__(28);
	
	var _purchaseReturns_actions = __webpack_require__(112);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _inventories_actions = __webpack_require__(38);
	
	var _print_actions = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isNumeric = function isNumeric(n) {
	    return !isNaN(parseFloat(n)) && isFinite(n);
	};
	
	var validate = function validate(values) {
	    var errors = {};
	
	    if (values.AllProd_Quantity && !isNumeric(values.AllProd_Quantity)) {
	        errors.AllProd_Quantity = 'Accept number only!';
	    }
	
	    if (values.AllProd_Quantity && values.AllProd_Quantity < 0) {
	        errors.AllProd_Quantity = 'Positive number only!';
	    }
	
	    if (values.AllProd_FOBUnitPrice && !isNumeric(values.AllProd_FOBUnitPrice)) {
	        errors.AllProd_FOBUnitPrice = 'Accept number only!';
	    }
	
	    if (values.AllProd_FOBUnitPrice && values.AllProd_FOBUnitPrice < 0) {
	        errors.AllProd_FOBUnitPrice = 'Positive number only!';
	    }
	
	    if (values.ShippingCost && !isNumeric(values.ShippingCost)) {
	        errors.ShippingCost = 'Accept number only!';
	    }
	
	    if (values.ShippingCost && values.ShippingCost < 0) {
	        errors.ShippingCost = 'Positive number only!';
	    }
	
	    if (values.HandlingCost && !isNumeric(values.HandlingCost)) {
	        errors.HandlingCost = 'Accept number only!';
	    }
	
	    if (values.HandlingCost && values.HandlingCost < 0) {
	        errors.HandlingCost = 'Positive number only!';
	    }
	
	    if (values.Adjustment && !isNumeric(values.Adjustment)) {
	        errors.Adjustment = 'Accept number only!';
	    }
	
	    if (values.MiscCost && !isNumeric(values.MiscCost)) {
	        errors.MiscCost = 'Accept number only!';
	    }
	
	    if (values.MiscCost && values.MiscCost < 0) {
	        errors.MiscCost = 'Positive number only!';
	    }
	
	    if (values.Discount && !isNumeric(values.Discount)) {
	        errors.Discount = 'Accept number only!';
	    }
	
	    if (values.Discount && values.Discount < 0) {
	        errors.Discount = 'Positive number only!';
	    }
	
	    if (!values.ShippingMethod) {
	        errors.ShippingMethod = 'Required';
	    }
	
	    if (!values.Vendor_id) {
	        errors.Vendor_id = 'Required';
	    }
	
	    if (!values.Pickup_Warehouse_id) {
	        errors.Pickup_Warehouse_id = 'Required';
	    }
	
	    if (!values.ReturnReason) {
	        errors.ReturnReason = 'Required';
	    }
	
	    return errors;
	};
	
	var purchaseReturnForm = (0, _reduxForm.reduxForm)({
	    form: 'purchaseReturnForm',
	    validate: validate
	})(_purchaseReturnForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('purchaseReturnForm');
	
	function mapStateToProps(state) {
	    // const productInformation = selector(state, 'ProductInformation');
	    var allProducts = selector(state, 'AllProducts');
	    var searchType = selector(state, 'SearchType');
	    var vendorsValue = selector(state, 'Vendor_id');
	    var vendorContactValue = selector(state, 'VendorContact');
	    var priceTypeValue = selector(state, 'ConvertItemPrice');
	    var miscCostValue = selector(state, 'MiscCost');
	    var handlingCostValue = selector(state, 'HandlingCost');
	    var adjustmentCostValue = selector(state, 'Adjustment');
	    var shippingCostValue = selector(state, 'ShippingCost');
	    var allProd_Quantity = selector(state, 'AllProd_Quantity');
	    var allProd_FOBUnitPrice = selector(state, 'AllProd_FOBUnitPrice');
	    var taxRate = selector(state, 'TaxRate');
	    var crv = selector(state, 'CRV');
	    var discount = selector(state, 'Discount');
	    return {
	        // productInformation,
	        allProducts: allProducts,
	        searchType: searchType,
	        vendorsValue: vendorsValue,
	        vendorContactValue: vendorContactValue,
	        priceTypeValue: priceTypeValue,
	        miscCostValue: miscCostValue,
	        shippingCostValue: shippingCostValue,
	        handlingCostValue: handlingCostValue,
	        adjustmentCostValue: adjustmentCostValue,
	        allProd_Quantity: allProd_Quantity,
	        allProd_FOBUnitPrice: allProd_FOBUnitPrice,
	        taxRate: taxRate,
	        crv: crv,
	        discount: discount,
	
	        currentPurchaseReturnDetail: state.purchaseReturns.currentPurchaseReturnDetail,
	        currentPurchaseReturn: state.purchaseReturns.currentPurchaseReturn,
	        detailIsLoading: state.purchaseReturns.detailIsLoading,
	        detailError: state.purchaseReturns.detailError,
	        initialValues: state.purchaseReturns.currentPurchaseReturnDetail,
	
	        isEditing: state.purchaseReturns.purchaseReturnIsEditing,
	        editError: state.purchaseReturns.purchaseReturnEditError,
	        isCreating: state.purchaseReturns.purchaseReturnIsCreating,
	        createError: state.purchaseReturns.purchaseReturnCreateError,
	
	        products: state.vendors.currentVendorInventoryDetail,
	        vendors: state.vendors.all,
	        vendorIsLoading: state.vendors.isLoading,
	        vendorError: state.vendors.error,
	        currentVendorDetail: state.vendors.currentVendorDetail,
	        vendorDetailIsLoading: state.vendors.detailIsLoading,
	        vendorDetailError: state.vendors.detailError,
	        paymentTerms: state.paymentTerms.all,
	        paymentTermsIsLoading: state.paymentTerms.isLoading,
	        paymentTermsError: state.paymentTerms.error,
	        warehouses: state.warehouses.all,
	        warehouseIsLoading: state.warehouses.isLoading,
	        warehouseError: state.warehouses.error,
	        userPermissions: state.auth.userPermissions,
	
	        simplifiedProducts: state.products.simplifiedProducts,
	        simplifiedProductsIsLoading: state.products.simplifiedProductsIsLoading,
	        simplifiedProductsError: state.products.simplifiedProductsError,
	
	        taxRates: state.salesOrders.taxRates,
	        taxRatesIsLoading: state.salesOrders.taxRatesIsLoading,
	        taxRatesError: state.salesOrders.taxRatesError,
	
	        requestingPurchaseReturnPdf: state.print.requestingPurchaseReturnPdf,
	        purchaseReturnPdf: state.print.purchaseReturnPdf
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	    editPurchaseReturn: _purchaseReturns_actions.editPurchaseReturn, createPurchaseReturn: _purchaseReturns_actions.createPurchaseReturn, completePurchaseReturn: _purchaseReturns_actions.completePurchaseReturn, setPriceValues: _purchaseOrders_actions.setPriceValues, setAllProducts: _purchaseOrders_actions.setAllProducts, fetchTaxRates: _sales_actions.fetchTaxRates,
	    fetchVendors: _vendors_actions.fetchVendors, fetchProductsByVendor: _products_actions.fetchProductsByVendor, fetchProductInfo: _products_actions.fetchProductInfo, fetchPaymentTerms: _paymentTerms_actions.fetchPaymentTerms, setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm, resetAllProducts: _purchaseOrders_actions.resetAllProducts,
	    fetchVendorDetail: _vendors_actions.fetchVendorDetail, resetCurrentVendor: _vendors_actions.resetCurrentVendor, fetchVendorInventoryDetail: _vendors_actions.fetchVendorInventoryDetail, fetchPurchaseReturnDetail: _purchaseReturns_actions.fetchPurchaseReturnDetail, getVendorBatches: _vendors_actions.getVendorBatches,
	    fetchWarehouses: _warehouses_actions.fetchWarehouses, fetchReturnBatch: _inventories_actions.fetchReturnBatch, printPurchaseReturn: _print_actions.printPurchaseReturn, fetchActiveVendors: _vendors_actions.fetchActiveVendors
	})(purchaseReturnForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseReturnForm.jsx');
	
	    __REACT_HOT_LOADER__.register(isNumeric, 'isNumeric', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseReturnForm.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseReturnForm.jsx');
	
	    __REACT_HOT_LOADER__.register(purchaseReturnForm, 'purchaseReturnForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseReturnForm.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseReturnForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseReturnForm.jsx');
	}();

	;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _purchaseReturns_actions = __webpack_require__(112);
	
	var _print_actions = __webpack_require__(47);
	
	var _purchaseReturnList = __webpack_require__(445);
	
	var _purchaseReturnList2 = _interopRequireDefault(_purchaseReturnList);
	
	var _settings_actions = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    currentPurchaseReturn: state.purchaseReturns.currentPurchaseReturn,
	    purchaseReturns: state.purchaseReturns.all,
	    isLoading: state.purchaseReturns.isLoading,
	    error: state.purchaseReturns.error,
	    userPermissions: state.auth.userPermissions,
	    requestingPurchaseReturnPdf: state.print.requestingPurchaseReturnPdf,
	    purchaseReturnPdf: state.print.purchaseReturnPdf,
	    purchaseReturnIsVoiding: state.purchaseReturns.purchaseReturnIsVoiding,
	    purchaseReturnVoidError: state.purchaseReturns.purchaseReturnVoidError,
	    purchaseReturnVoided: state.purchaseReturns.purchaseReturnVoided,
	
	    checkPassword: state.settings.checkPassword,
	    checkPasswordSuccess: state.settings.checkPasswordSuccess,
	    checkPasswordFailure: state.settings.checkPasswordFailure,
	    purchaseReturnPdfNs: state.print.purchaseReturnPdfNs
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchPurchaseReturns: _purchaseReturns_actions.fetchPurchaseReturns,
	  selectPurchaseReturn: _purchaseReturns_actions.selectPurchaseReturn,
	  resetCurrentPurchaseReturn: _purchaseReturns_actions.resetCurrentPurchaseReturn,
	  printPurchaseReturn: _print_actions.printPurchaseReturn,
	  voidPurchaseReturn: _purchaseReturns_actions.voidPurchaseReturn,
	  checkPassword: _settings_actions.checkPassword,
	  clearCheckPassword: _settings_actions.clearCheckPassword,
	  printPurchaseReturnNoSubtotals: _print_actions.printPurchaseReturnNoSubtotals
	})(_purchaseReturnList2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseReturnList.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseReturnList.jsx');
	}();

	;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _purchaseScheduleForm = __webpack_require__(446);
	
	var _purchaseScheduleForm2 = _interopRequireDefault(_purchaseScheduleForm);
	
	var _vendors_actions = __webpack_require__(46);
	
	var _products_actions = __webpack_require__(30);
	
	var _paymentTerms_actions = __webpack_require__(54);
	
	var _purchaseTemplates_actions = __webpack_require__(65);
	
	var _warehouses_actions = __webpack_require__(44);
	
	var _purchaseSchedules_actions = __webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var purchaseScheduleForm = (0, _reduxForm.reduxForm)({
	    form: 'purchaseScheduleForm'
	})(_purchaseScheduleForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('purchaseScheduleForm');
	
	function mapStateToProps(state) {
	    var productsValue = selector(state, 'PurchaseTemplate.Purchase_Template_Line');
	    var vendorsValue = selector(state, 'PurchaseTemplate.Vendor_id');
	    var vendorContactValue = selector(state, 'PurchaseTemplate.VendorContact');
	    var priceTypeValue = selector(state, 'PurchaseTemplate.ConvertItemPrice');
	    var miscCostValue = selector(state, 'PurchaseTemplate.MiscCost');
	    var repeatFreqValue = selector(state, 'RepeatFrequency');
	    return {
	        productsValue: productsValue,
	        vendorsValue: vendorsValue,
	        vendorContactValue: vendorContactValue,
	        priceTypeValue: priceTypeValue,
	        miscCostValue: miscCostValue,
	        repeatFreqValue: repeatFreqValue,
	
	        currentPurchaseTemplate: state.purchaseTemplates.currentPurchaseTemplate,
	
	        currentPurchaseScheduleDetail: state.purchaseSchedules.currentPurchaseScheduleDetail,
	        currentPurchaseSchedule: state.purchaseSchedules.currentPurchaseSchedule,
	        detailIsLoading: state.purchaseSchedules.detailIsLoading,
	        detailError: state.purchaseSchedules.detailError,
	        initialValues: state.purchaseSchedules.currentPurchaseScheduleDetail,
	
	        isEditing: state.purchaseSchedules.purchaseScheduleIsEditing,
	        editError: state.purchaseSchedules.purchaseScheduleEditError,
	        isCreating: state.purchaseSchedules.purchaseScheduleIsCreating,
	        createError: state.purchaseSchedules.purchaseScheduleCreateError,
	
	        products: state.products.all,
	        productIsLoading: state.products.isLoading,
	        productError: state.products.error,
	        vendors: state.vendors.all,
	        vendorIsLoading: state.vendors.isLoading,
	        vendorError: state.vendors.error,
	        currentVendorDetail: state.vendors.currentVendorDetail,
	        vendorDetailIsLoading: state.vendors.detailIsLoading,
	        vendorDetailError: state.vendors.detailError,
	        paymentTerms: state.paymentTerms.all,
	        paymentTermsIsLoading: state.paymentTerms.isLoading,
	        paymentTermsError: state.paymentTerms.error,
	        warehouses: state.warehouses.all,
	        warehouseIsLoading: state.warehouses.isLoading,
	        warehouseError: state.warehouses.error,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	    fetchVendors: _vendors_actions.fetchVendors, fetchProducts: _products_actions.fetchProducts, fetchPaymentTerms: _paymentTerms_actions.fetchPaymentTerms, fetchVendorDetail: _vendors_actions.fetchVendorDetail,
	    resetCurrentVendor: _vendors_actions.resetCurrentVendor, fetchPurchaseScheduleDetail: _purchaseSchedules_actions.fetchPurchaseScheduleDetail, createPurchaseSchedule: _purchaseSchedules_actions.createPurchaseSchedule, editPurchaseSchedule: _purchaseSchedules_actions.editPurchaseSchedule,
	    selectPurchaseTemplate: _purchaseTemplates_actions.selectPurchaseTemplate, resetCurrentPurchaseTemplate: _purchaseTemplates_actions.resetCurrentPurchaseTemplate, convertTemplateToSchedule: _purchaseTemplates_actions.convertTemplateToSchedule, fetchWarehouses: _warehouses_actions.fetchWarehouses
	})(purchaseScheduleForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseScheduleForm.jsx');
	
	    __REACT_HOT_LOADER__.register(purchaseScheduleForm, 'purchaseScheduleForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseScheduleForm.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseScheduleForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseScheduleForm.jsx');
	}();

	;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _purchaseSchedules_actions = __webpack_require__(113);
	
	var _reactRedux = __webpack_require__(6);
	
	var _purchaseScheduleList = __webpack_require__(447);
	
	var _purchaseScheduleList2 = _interopRequireDefault(_purchaseScheduleList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	    return {
	        currentPurchaseSchedule: state.purchaseSchedules.currentPurchaseSchedule,
	        purchaseSchedules: state.purchaseSchedules.all,
	        isLoading: state.purchaseSchedules.isLoading,
	        error: state.purchaseSchedules.error,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchPurchaseSchedules: _purchaseSchedules_actions.fetchPurchaseSchedules, selectPurchaseSchedule: _purchaseSchedules_actions.selectPurchaseSchedule, resetCurrentPurchaseSchedule: _purchaseSchedules_actions.resetCurrentPurchaseSchedule })(_purchaseScheduleList2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseScheduleList.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseScheduleList.jsx');
	}();

	;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _purchaseTemplates_actions = __webpack_require__(65);
	
	var _purchaseSchedules_actions = __webpack_require__(113);
	
	var _purchaseScheduleModal = __webpack_require__(448);
	
	var _purchaseScheduleModal2 = _interopRequireDefault(_purchaseScheduleModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.Name) {
	        errors.Name = 'Required';
	    }
	    if (values.IsEnabled === null) {
	        errors.IsEnabled = 'Required';
	    }
	    return errors;
	};
	
	var purchaseScheduleModal = (0, _reduxForm.reduxForm)({
	    form: 'purchaseScheduleModal'
	})(_purchaseScheduleModal2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('purchaseScheduleModal');
	
	function mapStateToProps(state) {
	    var purchaseTemplateValue = selector(state, 'PurchaseTemplate_id');
	    return {
	        purchaseTemplateValue: purchaseTemplateValue,
	
	        currentPurchaseTemplate: state.purchaseTemplates.currentPurchaseTemplate,
	        purchaseTemplates: state.purchaseTemplates.all,
	        isLoading: state.purchaseTemplates.isLoading,
	        error: state.purchaseTemplates.error
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchPurchaseTemplates: _purchaseTemplates_actions.fetchPurchaseTemplates, selectPurchaseTemplate: _purchaseTemplates_actions.selectPurchaseTemplate, resetCurrentPurchaseTemplate: _purchaseTemplates_actions.resetCurrentPurchaseTemplate, resetCurrentPurchaseSchedule: _purchaseSchedules_actions.resetCurrentPurchaseSchedule })(purchaseScheduleModal);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseScheduleModal.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseScheduleModal.jsx');
	
	    __REACT_HOT_LOADER__.register(purchaseScheduleModal, 'purchaseScheduleModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseScheduleModal.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseScheduleModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseScheduleModal.jsx');
	}();

	;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _purchaseTemplateForm = __webpack_require__(449);
	
	var _purchaseTemplateForm2 = _interopRequireDefault(_purchaseTemplateForm);
	
	var _vendors_actions = __webpack_require__(46);
	
	var _products_actions = __webpack_require__(30);
	
	var _paymentTerms_actions = __webpack_require__(54);
	
	var _warehouses_actions = __webpack_require__(44);
	
	var _purchaseTemplates_actions = __webpack_require__(65);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var purchaseTemplateForm = (0, _reduxForm.reduxForm)({
	    form: 'purchaseTemplateForm'
	})(_purchaseTemplateForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('purchaseTemplateForm');
	
	function mapStateToProps(state) {
	    var productInformation = selector(state, 'ProductInformation');
	
	    var templateNameValue = selector(state, 'Name');
	    var productsValue = selector(state, 'Purchase_Template_Line');
	    var vendorsValue = selector(state, 'Vendor_id');
	    var vendorContactValue = selector(state, 'VendorContact');
	    var priceTypeValue = selector(state, 'ConvertItemPrice');
	    var miscCostValue = selector(state, 'MiscCost');
	    var handlingCostValue = selector(state, 'HandlingCost');
	    var shippingCostValue = selector(state, 'ShippingCost');
	    var allProducts = selector(state, 'AllProducts');
	    var allProdQuantity = selector(state, 'AllProd_Quantity');
	    var allProdFOBUnitPrice = selector(state, 'AllProd_FOBUnitPrice');
	    var allProdEstSalePrice = selector(state, 'AllProd_EstSalePrice');
	    return {
	        productInformation: productInformation,
	        templateNameValue: templateNameValue,
	        productsValue: productsValue,
	        vendorsValue: vendorsValue,
	        vendorContactValue: vendorContactValue,
	        priceTypeValue: priceTypeValue,
	        miscCostValue: miscCostValue,
	        shippingCostValue: shippingCostValue,
	        handlingCostValue: handlingCostValue,
	        allProducts: allProducts,
	        allProdQuantity: allProdQuantity,
	        allProdFOBUnitPrice: allProdFOBUnitPrice,
	        allProdEstSalePrice: allProdEstSalePrice,
	
	        currentPurchaseTemplateDetail: state.purchaseTemplates.currentPurchaseTemplateDetail,
	        currentPurchaseTemplate: state.purchaseTemplates.currentPurchaseTemplate,
	        detailIsLoading: state.purchaseTemplates.detailIsLoading,
	        detailError: state.purchaseTemplates.detailError,
	        initialValues: state.purchaseTemplates.currentPurchaseTemplateDetail,
	
	        currentPurchaseProduct: state.purchaseTemplates.currentPurchaseProduct,
	
	        isEditing: state.purchaseTemplates.purchaseTemplateIsEditing,
	        editError: state.purchaseTemplates.purchaseTemplateEditError,
	        isCreating: state.purchaseTemplates.purchaseTemplateIsCreating,
	        createError: state.purchaseTemplates.purchaseTemplateCreateError,
	
	        products: state.products.allByVendor,
	        productIsLoading: state.products.isLoading,
	        productError: state.products.error,
	        productInfo: state.products.productInfo,
	        productInfoIsLoading: state.products.productInfoIsLoading,
	        productInfoError: state.products.productInfoError,
	        vendors: state.vendors.all,
	        vendorIsLoading: state.vendors.isLoading,
	        vendorError: state.vendors.error,
	        currentVendorDetail: state.vendors.currentVendorDetail,
	        vendorDetailIsLoading: state.vendors.detailIsLoading,
	        vendorDetailError: state.vendors.detailError,
	        paymentTerms: state.paymentTerms.all,
	        paymentTermsIsLoading: state.paymentTerms.isLoading,
	        paymentTermsError: state.paymentTerms.error,
	        warehouses: state.warehouses.all,
	        warehouseIsLoading: state.warehouses.isLoading,
	        warehouseError: state.warehouses.error,
	        userPermissions: state.auth.userPermissions,
	
	        simplifiedProducts: state.products.simplifiedProducts,
	        simplifiedProductsIsLoading: state.products.simplifiedProductsIsLoading,
	        simplifiedProductsError: state.products.simplifiedProductsError
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	    fetchVendors: _vendors_actions.fetchVendors, fetchProductsByVendor: _products_actions.fetchProductsByVendor, fetchProductInfo: _products_actions.fetchProductInfo, fetchPaymentTerms: _paymentTerms_actions.fetchPaymentTerms,
	    fetchVendorDetail: _vendors_actions.fetchVendorDetail, resetCurrentVendor: _vendors_actions.resetCurrentVendor, fetchPurchaseTemplateDetail: _purchaseTemplates_actions.fetchPurchaseTemplateDetail,
	    editPurchaseTemplate: _purchaseTemplates_actions.editPurchaseTemplate, createPurchaseTemplate: _purchaseTemplates_actions.createPurchaseTemplate, fetchWarehouses: _warehouses_actions.fetchWarehouses,
	    fetchSimplifiedProducts: _products_actions.fetchSimplifiedProducts, setPriceValues: _purchaseOrders_actions.setPriceValues
	})(purchaseTemplateForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseTemplateForm.jsx');
	
	    __REACT_HOT_LOADER__.register(purchaseTemplateForm, 'purchaseTemplateForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseTemplateForm.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseTemplateForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseTemplateForm.jsx');
	}();

	;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _purchaseTemplates_actions = __webpack_require__(65);
	
	var _reactRedux = __webpack_require__(6);
	
	var _purchaseTemplateList = __webpack_require__(450);
	
	var _purchaseTemplateList2 = _interopRequireDefault(_purchaseTemplateList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	    return {
	        currentPurchaseTemplate: state.purchaseTemplates.currentPurchaseTemplate,
	        purchaseTemplates: state.purchaseTemplates.all,
	        isLoading: state.purchaseTemplates.isLoading,
	        error: state.purchaseTemplates.error,
	        userPermissions: state.auth.userPermissions,
	        purchaseTemplateList: state.purchaseTemplates.purchaseTemplateList,
	        purchaseTemplateListIsLoading: state.purchaseTemplates.purchaseTemplateListIsLoading,
	        purchaseTemplateListError: state.purchaseTemplates.purchaseTemplateListError
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { deletePurchaseTemplate: _purchaseTemplates_actions.deletePurchaseTemplate, fetchPurchaseTemplates: _purchaseTemplates_actions.fetchPurchaseTemplates, selectPurchaseTemplate: _purchaseTemplates_actions.selectPurchaseTemplate, resetCurrentPurchaseTemplate: _purchaseTemplates_actions.resetCurrentPurchaseTemplate, fetchPurchaseTemplateList: _purchaseTemplates_actions.fetchPurchaseTemplateList })(_purchaseTemplateList2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseTemplateList.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchaseTemplateList.jsx');
	}();

	;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _vendors_actions = __webpack_require__(46);
	
	var _purchasingPerformance = __webpack_require__(451);
	
	var _purchasingPerformance2 = _interopRequireDefault(_purchasingPerformance);
	
	var _products_actions = __webpack_require__(30);
	
	var _purchasingPerformanceList_actions = __webpack_require__(138);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var purchasingPerformance = (0, _reduxForm.reduxForm)({
	    form: 'purchasingPerformance'
	})(_purchasingPerformance2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('purchasingPerformance');
	
	function mapStateToProps(state) {
	    var Days = selector(state, 'Days');
	    var FromDate = selector(state, 'FromDate');
	    var ToDate = selector(state, 'ToDate');
	    var POStatus = selector(state, 'POStatus');
	    var Vendor_id = selector(state, 'Vendor_id');
	    var searchType = selector(state, 'searchType');
	    var allProducts = selector(state, 'AllProducts');
	    var Product_id = selector(state, 'Product_id');
	
	    return {
	        Days: Days,
	        FromDate: FromDate,
	        ToDate: ToDate,
	        POStatus: POStatus,
	        Vendor_id: Vendor_id,
	        searchType: searchType,
	        allProducts: allProducts,
	        Product_id: Product_id,
	        vendors: state.vendors.all,
	        purchasingPerformanceIsLoading: state.purchaseOrders.purchasingPerformanceIsLoading,
	        purchasingPerformance: state.purchaseOrders.purchasingPerformance,
	        purchasingPerformanceError: state.purchaseOrders.purchasingPerformanceError,
	        purchaseOrderPerformanceByProductIsLoading: state.purchaseOrders.purchaseOrderPerformanceByProductIsLoading,
	        purchaseOrderPerformanceByProduct: state.purchaseOrders.purchaseOrderPerformanceByProduct,
	        purchaseOrderPerformanceByProductError: state.purchaseOrders.purchaseOrderPerformanceByProductError,
	
	        simplifiedProducts: state.products.simplifiedProducts,
	        simplifiedProductsIsLoading: state.products.simplifiedProductsIsLoading,
	        simplifiedProductsError: state.products.simplifiedProductsError,
	
	        productInfo: state.products.productInfo,
	        productInfoIsLoading: state.products.productInfoIsLoading,
	        productInfoError: state.products.productInfoError,
	
	        purchaseOrderDetail: state.purchaseOrders.currentPurchaseOrderDetail,
	        purchaseOrderDetailIsLoading: state.purchaseOrders.detailIsLoading,
	        purchaseOrderDetailError: state.purchaseOrders.detailError,
	
	        purchaseOrderList: state.purchaseOrders.purchaseOrderList,
	        purchaseOrderListIsLoading: state.purchaseOrders.purchaseOrderListIsLoading,
	        purchaseOrderListError: state.purchaseOrders.purchaseOrderListError
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchPurchasePerformanceByFilter: _purchasingPerformanceList_actions.fetchPurchasePerformanceByFilter, fetchPurchasingPerformance: _purchaseOrders_actions.fetchPurchasingPerformance, setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm, fetchVendors: _vendors_actions.fetchVendors, fetchPurchasingPerformanceByProduct: _purchaseOrders_actions.fetchPurchasingPerformanceByProduct, setDefaultSearchType: _purchaseOrders_actions.setDefaultSearchType, setAllProducts: _purchaseOrders_actions.setAllProducts, resetAllProducts: _purchaseOrders_actions.resetAllProducts, fetchPurchaseOrderList: _purchaseOrders_actions.fetchPurchaseOrderList, fetchProductInfo: _products_actions.fetchProductInfo, fetchSimplifiedProducts: _products_actions.fetchSimplifiedProducts })(purchasingPerformance);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasingPerformance.jsx');
	
	    __REACT_HOT_LOADER__.register(purchasingPerformance, 'purchasingPerformance', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasingPerformance.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasingPerformance.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/purchasingPerformance.jsx');
	}();

	;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _tracking_actions = __webpack_require__(213);
	
	var _trackingNoteModal = __webpack_require__(452);
	
	var _trackingNoteModal2 = _interopRequireDefault(_trackingNoteModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    notes: state.trackingNote.notes
	  };
	};
	
	var TrackingNoteModalContainer = (0, _reactRedux.connect)(mapStateToProps, { fetchTrackingNote: _tracking_actions.fetchTrackingNote, editTrackingNote: _tracking_actions.editTrackingNote })(_trackingNoteModal2.default);
	
	var _default = TrackingNoteModalContainer;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/trackingNoteModal.jsx');
	
	  __REACT_HOT_LOADER__.register(TrackingNoteModalContainer, 'TrackingNoteModalContainer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/trackingNoteModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/trackingNoteModal.jsx');
	}();

	;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _warehouses_actions = __webpack_require__(44);
	
	var _sales_actions = __webpack_require__(28);
	
	var _inventories_actions = __webpack_require__(38);
	
	var _favorites_actions = __webpack_require__(58);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _warehouseDashboard = __webpack_require__(453);
	
	var _warehouseDashboard2 = _interopRequireDefault(_warehouseDashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warehouseDashboard = (0, _reduxForm.reduxForm)({
	    form: 'warehouseDashboard'
	})(_warehouseDashboard2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('warehouseDashboard');
	
	function mapStateToProps(state) {
	    var salesDate = selector(state, 'SalesDate');
	    var purchaseDate = selector(state, 'PurchaseDate');
	    var warehouseChosen = selector(state, 'Warehouse');
	
	    return {
	        salesDate: salesDate,
	        purchaseDate: purchaseDate,
	        warehouseChosen: warehouseChosen,
	
	        todaysIncomingOrders: state.purchaseOrders.todaysIncomingOrders,
	        todaysIncomingOrdersIsLoading: state.purchaseOrders.todaysIncomingOrdersIsLoading,
	        todaysIncomingOrdersError: state.purchaseOrders.todaysIncomingOrdersError,
	
	        todaysOutgoingOrders: state.salesOrders.todaysOutgoingOrders,
	        todaysOutgoingOrdersIsLoading: state.salesOrders.todaysOutgoingOrdersIsLoading,
	        todaysOutgoingOrdersError: state.salesOrders.todaysOutgoingOrdersError,
	
	        salesOrders: state.warehouses.salesOrders,
	        SOIsLoading: state.warehouses.salesOrdersIsLoading,
	        SOError: state.warehouses.salesOrdersError,
	
	        currentPurchaseOrder: state.purchaseOrders.currentPurchaseOrder,
	
	        purchaseOrders: state.warehouses.purchaseOrders,
	        POIsLoading: state.warehouses.purchaseOrdersIsLoading,
	        POError: state.warehouses.purchaseOrdersError,
	
	        warehouses: state.warehouses.all,
	        warehousesIsLoading: state.warehouses.isLoading,
	        warehousesError: state.warehouses.error,
	
	        warehouseBinsDetail: state.warehouses.warehouseBinsDetail,
	        warehouseBinsDetailIsLoading: state.warehouses.warehouseBinsDetailIsLoading,
	        warehouseBinsDetailError: state.warehouses.warehouseBinsDetailError,
	
	        inventories: state.inventories.all,
	        favorites: state.favorites.all,
	        inventoryIsLoading: state.inventories.isLoading,
	        favoritesAreLoading: state.favorites.isLoading,
	        inventoryError: state.inventories.error,
	        favoritesError: state.favorites.error,
	        currentInventory: state.inventories.currentInventory,
	        currentFavorites: state.favorites.currentFavorites
	
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchPurchaseOrders: _purchaseOrders_actions.fetchPurchaseOrders, selectPurchaseOrder: _purchaseOrders_actions.selectPurchaseOrder, resetCurrentPurchaseOrder: _purchaseOrders_actions.resetCurrentPurchaseOrder,
	    fetchInventories: _inventories_actions.fetchInventories, fetchFavorites: _favorites_actions.fetchFavorites, selectInventory: _inventories_actions.selectInventory, selectFavorites: _favorites_actions.selectFavorites,
	    resetCurrentInventory: _inventories_actions.resetCurrentInventory, resetCurrentFavorites: _favorites_actions.resetCurrentFavorites, deleteFavorite: _favorites_actions.deleteFavorite,
	    fetchWarehouses: _warehouses_actions.fetchWarehouses, fetchWarehouseSalesOrders: _warehouses_actions.fetchWarehouseSalesOrders, fetchWarehousePurchaseOrders: _warehouses_actions.fetchWarehousePurchaseOrders,
	    fetchWarehouseBins: _warehouses_actions.fetchWarehouseBins, fetchTodaysIncomingOrders: _purchaseOrders_actions.fetchTodaysIncomingOrders, fetchIncomingOrdersByDate: _purchaseOrders_actions.fetchIncomingOrdersByDate,
	    fetchTodaysOutgoingOrders: _sales_actions.fetchTodaysOutgoingOrders, fetchOutgoingOrdersByDate: _sales_actions.fetchOutgoingOrdersByDate })(warehouseDashboard);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/warehouseDashboard.jsx');
	
	    __REACT_HOT_LOADER__.register(warehouseDashboard, 'warehouseDashboard', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/warehouseDashboard.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/warehouseDashboard.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Purchase/warehouseDashboard.jsx');
	}();

	;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _rma_actions = __webpack_require__(139);
	
	var _rma = __webpack_require__(456);
	
	var _rma2 = _interopRequireDefault(_rma);
	
	var _sales_actions = __webpack_require__(28);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rma = (0, _reduxForm.reduxForm)({
	    form: 'rma'
	})(_rma2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('rma');
	
	function mapStateToProps(state) {
	    return {
	        // customers: state.rma.customers,
	        customerOptions: state.rma.customers.map(function (customer) {
	            return {
	                label: customer.Name,
	                value: customer.Customer_id
	            };
	        }),
	        customerReturns: state.rma.customerReturns,
	        pages: state.rma.pages,
	        count: state.rma.count,
	        dispatchReturns: state.rma.dispatchReturns,
	        isLoading: state.rma.isLoading,
	        error: state.rma.error,
	        customerReturnError: state.rma.customerReturnError,
	        dispatchReturnError: state.rma.dispatchReturnError,
	        isCreating: state.rma.isCreating,
	        createCustomerReturnError: state.rma.createCustomerReturnError,
	        created: state.rma.created,
	        editCustomerReturnError: state.rma.editCustomerReturnError,
	        editDispatchReturnError: state.rma.editDispatchReturnError,
	        isEditing: state.rma.isEditing,
	        returnsFilter: state.rma.returnsFilter
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	    fetchCustomerReturnsByFilter: _rma_actions.fetchCustomerReturnsByFilter,
	    createCustomerReturn: _rma_actions.createCustomerReturn,
	    editCustomerReturn: _rma_actions.editCustomerReturn,
	    dispatchEditReturn: _rma_actions.dispatchEditReturn,
	    fetchDispatchReturns: _rma_actions.fetchDispatchReturns,
	    setReturnsFilter: _rma_actions.setReturnsFilter,
	    setValue: _sales_actions.setValue,
	    setDefaultDays: _purchaseOrders_actions.setDefaultDays,
	    setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	    resetCurrentForm: _rma_actions.resetCurrentForm,
	    clearCurrentReturn: _rma_actions.clearCurrentReturn,
	    fetchCustomers: _rma_actions.fetchCustomers,
	    changeRMAStatus: _rma_actions.changeRMAStatus,
	    uploadRMA: _rma_actions.uploadRMA
	})(_rma2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/RMA/rma.jsx");
	
	    __REACT_HOT_LOADER__.register(rma, "rma", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/RMA/rma.jsx");
	
	    __REACT_HOT_LOADER__.register(selector, "selector", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/RMA/rma.jsx");
	
	    __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/RMA/rma.jsx");
	}();

	;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _rma_actions = __webpack_require__(139);
	
	var _rmaForm = __webpack_require__(458);
	
	var _rmaForm2 = _interopRequireDefault(_rmaForm);
	
	var _sales_actions = __webpack_require__(28);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.Customer_Name) {
	        errors.Customer_Name = 'Required';
	    }
	    if (!values.RMA_Content) {
	        errors.RMA_Content = 'Required';
	    }
	    if (!values.RMA_Num) {
	        errors.RMA_Num = 'Required';
	    }
	    if (typeof values.Is_Warranty !== 'boolean' && _typeof(values.Is_Warranty) !== 'object') {
	        errors.Is_Warranty = 'Required';
	    }
	    if (!values.Product_SN) {
	        errors.Product_SN = 'Required';
	    }
	    if (!values.Product_Description) {
	        errors.Product_Description = 'Required';
	    }
	    if (!values.Product_Model) {
	        errors.Product_Model = 'Required';
	    }
	    return errors;
	};
	var rmaForm = (0, _reduxForm.reduxForm)({
	    form: 'rmaForm',
	    validate: validate,
	    enableReinitialize: true
	})(_rmaForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('rmaForm');
	
	function mapStateToProps(state) {
	    var RMA_Content = selector(state, 'RMA_Content');
	    var RMA_Service_Type = selector(state, 'RMA_Service_Type');
	    var RMA_Num = selector(state, 'RMA_Num');
	    var Product_SN = selector(state, 'Product_SN');
	    var Product_Description = selector(state, 'Product_Description');
	    var Return_Logitics_Company = selector(state, 'Return_Logitics_Company');
	    var Return_Tracking_Num = selector(state, 'Return_Tracking_Num');
	    var Is_Urgent = selector(state, 'Is_Urgent');
	    var Is_Warranty = selector(state, 'Is_Warranty');
	    var Customer_Name = selector(state, 'Customer_Name');
	    var Customer_Mobile = selector(state, 'Customer_Mobile');
	    var Customer_Address = selector(state, 'Customer_Address');
	    var Customer_Email = selector(state, 'Customer_Email');
	    var Submit_Description1 = selector(state, 'Submit_Description1');
	    var Submit_Description2 = selector(state, 'Submit_Description2');
	    var Openbox_Description = selector(state, 'Openbox_Description');
	    var Product_Detail_Info = selector(state, 'Product_Detail_Info');
	    var Warehouse_Check_Info = selector(state, 'Warehouse_Check_Info');
	    var Fix_Status = selector(state, 'Fix_Status');
	    var Fix_Description1 = selector(state, 'Fix_Description1');
	    var Fix_Description2 = selector(state, 'Fix_Description2');
	    var Dispatch_Logiticis_Company = selector(state, 'Dispatch_Logiticis_Company');
	    var Dispatch_Tracking_Num = selector(state, 'Dispatch_Tracking_Num');
	    var Dispatch_Fee = selector(state, 'Dispatch_Fee');
	    var Dispatch_Date = selector(state, 'Dispatch_Date');
	    var Person_Dispatch = selector(state, 'Person_Dispatch');
	    var Dispatch_Description1 = selector(state, 'Dispatch_Description1');
	    var Dispatch_Description2 = selector(state, 'Dispatch_Description2');
	    var Days = selector(state, 'Days');
	    var FromDate = selector(state, 'FromDate');
	    var ToDate = selector(state, 'ToDate');
	    var Status = selector(state, 'Status');
	    var Customer = selector(state, 'Customer');
	    var notesShortcut = selector(state, 'notesShortcut');
	
	    return {
	        notesShortcut: notesShortcut,
	        Days: Days,
	        FromDate: FromDate,
	        ToDate: ToDate,
	        Status: Status,
	        Dispatch_Logiticis_Company: Dispatch_Logiticis_Company,
	        Dispatch_Tracking_Num: Dispatch_Tracking_Num,
	        Dispatch_Fee: Dispatch_Fee,
	        Dispatch_Date: Dispatch_Date,
	        Person_Dispatch: Person_Dispatch,
	        Dispatch_Description1: Dispatch_Description1,
	        Dispatch_Description2: Dispatch_Description2,
	        RMA_Content: RMA_Content,
	        RMA_Service_Type: RMA_Service_Type,
	        RMA_Num: RMA_Num,
	        Product_SN: Product_SN,
	        Product_Description: Product_Description,
	        Return_Logitics_Company: Return_Logitics_Company,
	        Return_Tracking_Num: Return_Tracking_Num,
	        Is_Urgent: Is_Urgent,
	        Is_Warranty: Is_Warranty,
	        Customer_Name: Customer_Name,
	        Customer_Mobile: Customer_Mobile,
	        Customer_Address: Customer_Address,
	        Customer_Email: Customer_Email,
	        Submit_Description1: Submit_Description1,
	        Submit_Description2: Submit_Description2,
	        Openbox_Description: Openbox_Description,
	        Product_Detail_Info: Product_Detail_Info,
	        Warehouse_Check_Info: Warehouse_Check_Info,
	        Fix_Status: Fix_Status,
	        Fix_Description1: Fix_Description1,
	        Fix_Description2: Fix_Description2,
	        customerReturns: state.rma.customerReturns,
	        dispatchReturns: state.rma.dispatchReturns,
	        isLoading: state.rma.isLoading,
	        error: state.rma.error,
	        customerReturnError: state.rma.customerReturnError,
	        dispatchReturnError: state.rma.dispatchReturnError,
	        isCreating: state.rma.isCreating,
	        createCustomerReturnError: state.rma.createCustomerReturnError,
	        created: state.rma.created,
	        editCustomerReturnError: state.rma.editCustomerReturnError,
	        editDispatchReturnError: state.rma.editDispatchReturnError,
	        isEditing: state.rma.isEditing,
	        returnsFilter: state.rma.returnsFilter,
	        initialValues: state.rma.currentReturnDetail,
	        currentReturnDetail: state.rma.currentReturnDetail,
	        customerOptions: state.rma.customers.map(function (customer) {
	            return {
	                label: customer.Name,
	                value: customer.Customer_id
	            };
	        }),
	        Customer: Customer
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	    fetchCustomerReturnsByFilter: _rma_actions.fetchCustomerReturnsByFilter,
	    createCustomerReturn: _rma_actions.createCustomerReturn,
	    editCustomerReturn: _rma_actions.editCustomerReturn,
	    dispatchEditReturn: _rma_actions.dispatchEditReturn,
	    fetchDispatchReturns: _rma_actions.fetchDispatchReturns,
	    setReturnsFilter: _rma_actions.setReturnsFilter,
	    setValue: _sales_actions.setValue,
	    setDefaultDays: _purchaseOrders_actions.setDefaultDays,
	    setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	    resetCurrentForm: _rma_actions.resetCurrentForm,
	    fetchCustomerReturn: _rma_actions.fetchCustomerReturn,
	    fetchCustomers: _rma_actions.fetchCustomers,
	    createRMAOrder: _rma_actions.createRMAOrder,
	    editRMAOrder: _rma_actions.editRMAOrder
	})(rmaForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/RMA/rmaForm.jsx");
	
	    __REACT_HOT_LOADER__.register(validate, "validate", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/RMA/rmaForm.jsx");
	
	    __REACT_HOT_LOADER__.register(rmaForm, "rmaForm", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/RMA/rmaForm.jsx");
	
	    __REACT_HOT_LOADER__.register(selector, "selector", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/RMA/rmaForm.jsx");
	
	    __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/RMA/rmaForm.jsx");
	}();

	;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _salesInvoice_actions = __webpack_require__(52);
	
	var _sales_actions = __webpack_require__(28);
	
	var _creditForm = __webpack_require__(460);
	
	var _creditForm2 = _interopRequireDefault(_creditForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var creditForm = (0, _reduxForm.reduxForm)({
	  form: 'creditForm'
	})(_creditForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('creditForm');
	
	function mapStateToProps(state) {
	  var Days = selector(state, 'Days');
	  var FormTypes = selector(state, 'FormTypes');
	  var FromDate = selector(state, 'FromDate');
	  var ToDate = selector(state, 'ToDate');
	  var Customers = selector(state, 'Customers');
	  var Item = selector(state, 'Item');
	
	  return {
	    Days: Days,
	    FormTypes: FormTypes,
	    FromDate: FromDate,
	    ToDate: ToDate,
	    Customers: Customers,
	    Item: Item,
	
	    currentSalesInvoice: state.salesInvoice.currentSalesInvoice,
	    salesInvoiceDetail: state.salesInvoice.currentSalesInvoiceDetail,
	    salesReturnDetail: state.salesInvoice.salesReturnDetail,
	    initialValues: state.salesInvoice.salesReturnDetail,
	    currentCustomer: state.customers.currentCustomer,
	    customerItem: state.salesInvoice.customerItem
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchSalesInvoiceDetail: _salesInvoice_actions.fetchSalesInvoiceDetail, fetchSalesInvoiceCompletedDetail: _salesInvoice_actions.fetchSalesInvoiceCompletedDetail, createSalesReturn: _sales_actions.createSalesReturn, editSalesReturn: _sales_actions.editSalesReturn, fetchSalesReturnDetail: _sales_actions.fetchSalesReturnDetail, fetchCustomerItem: _salesInvoice_actions.fetchCustomerItem })(creditForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/creditForm.jsx');
	
	  __REACT_HOT_LOADER__.register(creditForm, 'creditForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/creditForm.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/creditForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/creditForm.jsx');
	}();

	;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _salesInvoice_actions = __webpack_require__(52);
	
	var _customers_actions = __webpack_require__(42);
	
	var _sales_actions = __webpack_require__(28);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _customerIssueCredit = __webpack_require__(461);
	
	var _customerIssueCredit2 = _interopRequireDefault(_customerIssueCredit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customerIssueCredit = (0, _reduxForm.reduxForm)({
	    form: 'customerIssueCredit',
	    validate: validate,
	    enableReinitialize: true,
	    touchOnChange: true,
	    touchOnBlur: false
	})(_customerIssueCredit2.default);
	
	customerIssueCredit = (0, _reactRedux.connect)(function (state) {
	    return {
	        initialValues: state.salesInvoice.salesReturnDetail
	
	    };
	})(customerIssueCredit);
	
	var isNumeric = function isNumeric(n) {
	    return !isNaN(parseFloat(n)) && isFinite(n);
	};
	
	var validate = function validate(values) {
	    var errors = {};
	    if (values.Quantity && !isNumeric(values.Quantity)) {
	        errors.Quantity = 'Accept number only!';
	    }
	    if (values.Quantity && values.Quantity < 0) {
	        errors.Quantity = 'Positive number only!';
	    }
	    if (values.UnitPrice && !isNumeric(values.UnitPrice)) {
	        errors.UnitPrice = 'Accept number only!';
	    }
	    if (values.UnitPrice && values.UnitPrice < 0) {
	        errors.UnitPrice = 'Positive number only!';
	    }
	    if (!values.Deliver_Customer_id) {
	        errors.Deliver_Customer_id = 'Required';
	    }
	    return errors;
	};
	
	var selector = (0, _reduxForm.formValueSelector)('customerIssueCredit');
	
	function mapStateToProps(state) {
	    var Promo = selector(state, 'Promo');
	    var Tax = selector(state, 'Tax');
	    var RestockingFee = selector(state, 'RestockingFee');
	    var Customers = selector(state, 'Customers');
	    var Item = selector(state, 'Item');
	    var searchValue = selector(state, 'ProductInformation');
	    var searchType = selector(state, 'searchType');
	    var Quantity = selector(state, 'Quantity');
	    var Weight = selector(state, 'Weight');
	    var UnitPrice = selector(state, 'UnitPrice');
	    var itemNotation = selector(state, 'itemNotation');
	    var PostingDate = selector(state, 'PostingDate');
	
	    return {
	        Promo: Promo,
	        Tax: Tax,
	        RestockingFee: RestockingFee,
	        Customers: Customers,
	        Item: Item,
	        searchValue: searchValue,
	        searchType: searchType,
	        Quantity: Quantity,
	        Weight: Weight,
	        UnitPrice: UnitPrice,
	        itemNotation: itemNotation,
	        PostingDate: PostingDate,
	
	        currentSalesInvoice: state.salesInvoice.currentSalesInvoice,
	        salesInvoiceDetail: state.customers.currentCustomerDetail,
	        salesReturnDetail: state.salesInvoice.salesReturnDetail,
	        //initialValues: state.salesInvoice.salesReturnDetail,
	        currentCustomer: state.customers.currentCustomer,
	        customerItem: state.salesInvoice.customerItem,
	        taxRates: state.salesOrders.taxRates,
	        taxRatesIsLoading: state.salesOrders.taxRatesIsLoading,
	        taxRatesError: state.salesOrders.taxRatesError
	
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchSalesInvoiceDetail: _salesInvoice_actions.fetchSalesInvoiceDetail, fetchCustomerItem: _salesInvoice_actions.fetchCustomerItem, createCreditIssue: _sales_actions.createCreditIssue, fetchSalesInvoiceCompletedDetail: _salesInvoice_actions.fetchSalesInvoiceCompletedDetail, fetchSalesReturnDetail: _sales_actions.fetchSalesReturnDetail, setValue: _sales_actions.setValue, setSaleRowValue: _sales_actions.setSaleRowValue, resetIssueInputs: _salesInvoice_actions.resetIssueInputs, setDefaultSearchType: _purchaseOrders_actions.setDefaultSearchType, fetchCustomerDetail: _customers_actions.fetchCustomerDetail, fetchTaxRates: _sales_actions.fetchTaxRates })(customerIssueCredit);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/customerIssueCredit.jsx');
	
	    __REACT_HOT_LOADER__.register(customerIssueCredit, 'customerIssueCredit', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/customerIssueCredit.jsx');
	
	    __REACT_HOT_LOADER__.register(isNumeric, 'isNumeric', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/customerIssueCredit.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/customerIssueCredit.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/customerIssueCredit.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/customerIssueCredit.jsx');
	}();

	;

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _purchaseTemplates_actions = __webpack_require__(65);
	
	var _reactRedux = __webpack_require__(6);
	
	var _customerItems = __webpack_require__(462);
	
	var _customerItems2 = _interopRequireDefault(_customerItems);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	    return {
	        currentPurchaseTemplate: state.purchaseTemplates.currentPurchaseTemplate,
	        purchaseTemplates: state.purchaseTemplates.all,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { deletePurchaseTemplate: _purchaseTemplates_actions.deletePurchaseTemplate, selectPurchaseTemplate: _purchaseTemplates_actions.selectPurchaseTemplate, resetCurrentPurchaseTemplate: _purchaseTemplates_actions.resetCurrentPurchaseTemplate })(_customerItems2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/customerItems.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/customerItems.jsx');
	}();

	;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _customers_actions = __webpack_require__(42);
	
	var _salesInvoice_actions = __webpack_require__(52);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _sales_actions = __webpack_require__(28);
	
	var _customerReturn = __webpack_require__(463);
	
	var _customerReturn2 = _interopRequireDefault(_customerReturn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customerReturn = (0, _reduxForm.reduxForm)({
	  form: 'customerReturn'
	})(_customerReturn2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('customerReturn');
	
	function mapStateToProps(state) {
	  var Days = selector(state, 'Days');
	  var FormTypes = selector(state, 'FormTypes');
	  var FromDate = selector(state, 'FromDate');
	  var ToDate = selector(state, 'ToDate');
	  var Customers = selector(state, 'Customers');
	  var Invoice_num = selector(state, 'Invoice_num');
	  var InvoiceNum = selector(state, 'InvoiceNum');
	
	  return {
	    Days: Days,
	    FormTypes: FormTypes,
	    FromDate: FromDate,
	    ToDate: ToDate,
	    Customers: Customers,
	    Invoice_num: Invoice_num,
	    InvoiceNum: InvoiceNum,
	
	    customers: state.customers.all,
	    customersIsLoading: state.customers.isLoading,
	    customersError: state.customers.error,
	
	    salesInvoice: state.salesInvoice.completed,
	    isLoading: state.salesInvoice.completedIsLoading,
	    error: state.salesInvoice.completedError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  setDefaultDays: _purchaseOrders_actions.setDefaultDays,
	  fetchSalesInvoices: _salesInvoice_actions.fetchSalesInvoices,
	  fetchSalesInvoicesByNum: _salesInvoice_actions.fetchSalesInvoicesByNum,
	  fetchCustomers: _customers_actions.fetchCustomers,
	  selectCustomer: _customers_actions.selectCustomer,
	  fetchSalesInvoicesCompleted: _salesInvoice_actions.fetchSalesInvoicesCompleted,
	  resetCurrentSalesInvoice: _salesInvoice_actions.resetCurrentSalesInvoice,
	  resetCurrentSalesInvoicePromise: _salesInvoice_actions.resetCurrentSalesInvoicePromise,
	  selectSalesInvoice: _salesInvoice_actions.selectSalesInvoice,
	  setValue: _sales_actions.setValue
	})(customerReturn);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/customerReturn.jsx');
	
	  __REACT_HOT_LOADER__.register(customerReturn, 'customerReturn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/customerReturn.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/customerReturn.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/customerReturn.jsx');
	}();

	;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _salesInvoice_actions = __webpack_require__(52);
	
	var _sales_actions = __webpack_require__(28);
	
	var _customerReturnForm = __webpack_require__(464);
	
	var _customerReturnForm2 = _interopRequireDefault(_customerReturnForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customerReturnForm = (0, _reduxForm.reduxForm)({
	  form: 'customerReturnForm'
	})(_customerReturnForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('customerReturnForm');
	
	function mapStateToProps(state) {
	  var Promo = selector(state, 'Promo');
	  var Tax = selector(state, 'Tax');
	  var RestockingFee = selector(state, 'RestockingFee');
	  var Note = selector(state, 'Note');
	  var Customers = selector(state, 'Customers');
	  var Item = selector(state, 'Item');
	  var searchValue = selector(state, 'ProductInformation');
	  var searchType = selector(state, 'searchType');
	  var Quantity = selector(state, 'Quantity');
	  var Weight = selector(state, 'Weight');
	  var UnitPrice = selector(state, 'UnitPrice');
	  var CreditInvoiceNum = selector(state, 'CreditInvoiceNum');
	  var PostingDate = selector(state, 'PostingDate');
	
	  return {
	    Promo: Promo,
	    Tax: Tax,
	    RestockingFee: RestockingFee,
	    Note: Note,
	    Customers: Customers,
	    Item: Item,
	    searchValue: searchValue,
	    searchType: searchType,
	    Quantity: Quantity,
	    Weight: Weight,
	    UnitPrice: UnitPrice,
	    CreditInvoiceNum: CreditInvoiceNum,
	    PostingDate: PostingDate,
	    currentSalesInvoice: state.salesInvoice.currentSalesInvoice,
	    salesInvoiceDetail: state.salesInvoice.currentSalesInvoiceDetail ? state.salesInvoice.currentSalesInvoiceDetail.data : state.salesInvoice.currentSalesInvoiceDetail,
	    salesReturnDetail: state.salesInvoice.salesReturnDetail,
	    initialValues: state.salesInvoice.salesReturnDetail,
	    currentCustomer: state.customers.currentCustomer,
	    customerItem: state.salesInvoice.customerItem,
	    unpaidInvoices: state.salesInvoice.unpaidInvoices,
	    salesReturnIsCreating: state.salesInvoice.salesReturnIsCreating
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchSalesInvoiceDetail: _salesInvoice_actions.fetchSalesInvoiceDetail,
	  fetchCustomerItem: _salesInvoice_actions.fetchCustomerItem,
	  fetchUnpaidInvoices: _salesInvoice_actions.fetchUnpaidInvoices,
	  editSalesReturn: _sales_actions.editSalesReturn,
	  fetchSalesInvoiceCompletedDetail: _salesInvoice_actions.fetchSalesInvoiceCompletedDetail,
	  createSalesReturn: _sales_actions.createSalesReturn,
	  fetchSalesReturnDetail: _sales_actions.fetchSalesReturnDetail,
	  setValue: _sales_actions.setValue,
	  setSaleRowValue: _sales_actions.setSaleRowValue,
	  resetCurrentSalesInvoice: _salesInvoice_actions.resetCurrentSalesInvoice
	})(customerReturnForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/customerReturnForm.jsx');
	
	  __REACT_HOT_LOADER__.register(customerReturnForm, 'customerReturnForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/customerReturnForm.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/customerReturnForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/customerReturnForm.jsx');
	}();

	;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _products_actions = __webpack_require__(30);
	
	var _sales_actions = __webpack_require__(28);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _settings_actions = __webpack_require__(33);
	
	var _inventoryReturn = __webpack_require__(465);
	
	var _inventoryReturn2 = _interopRequireDefault(_inventoryReturn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inventoryReturn = (0, _reduxForm.reduxForm)({
	  form: 'inventoryReturn'
	})(_inventoryReturn2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('inventoryReturn');
	
	function mapStateToProps(state) {
	  var Days = selector(state, 'Days');
	  var FromDate = selector(state, 'FromDate');
	  var ToDate = selector(state, 'ToDate');
	  return {
	    Days: Days,
	    FromDate: FromDate,
	    ToDate: ToDate,
	    updated: state.salesInvoice.updated,
	    inventoryReturn: state.salesInvoice.inventoryReturn,
	    inventoryReturnIsLoading: state.salesInvoice.inventoryReturnIsLoading,
	    inventoryReturnError: state.salesInvoice.inventoryReturnError,
	    inventoryReturnDetailsError: state.salesInvoice.inventoryReturnDetailsError,
	    inventoryReturnDetailsIsLoading: state.salesInvoice.inventoryReturnDetailsIsLoading,
	    inventoryReturnIsEditing: state.salesInvoice.inventoryReturnIsEditing,
	    editInventoryReturnError: state.salesInvoice.editInventoryReturnError,
	    inventoryReturnEdited: state.salesInvoice.inventoryReturnEdited,
	    inventoryReturnDetails: state.salesInvoice.inventoryReturnDetails,
	
	    checkPassword: state.settings.checkPassword,
	    checkPasswordSuccess: state.settings.checkPasswordSuccess,
	    checkPasswordFailure: state.settings.checkPasswordFailure
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  setDefaultDays: _purchaseOrders_actions.setDefaultDays,
	  fetchInventoryReturns: _sales_actions.fetchInventoryReturns,
	  editInventoryReturns: _sales_actions.editInventoryReturns,
	  fetchPriceLevels: _products_actions.fetchPriceLevels,
	  editMultiPriceLevels: _products_actions.editMultiPriceLevels,
	  fetchInventoryReturnsDetails: _sales_actions.fetchInventoryReturnsDetails,
	  voidReturn: _sales_actions.voidReturn,
	  completeReturn: _sales_actions.completeReturn,
	  checkPassword: _settings_actions.checkPassword,
	  clearCheckPassword: _settings_actions.clearCheckPassword
	})(inventoryReturn);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/inventoryReturn.jsx');
	
	  __REACT_HOT_LOADER__.register(inventoryReturn, 'inventoryReturn', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/inventoryReturn.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/inventoryReturn.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/inventoryReturn.jsx');
	}();

	;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _salesInvoice_actions = __webpack_require__(52);
	
	var _sales_actions = __webpack_require__(28);
	
	var _restockReturnForm = __webpack_require__(466);
	
	var _restockReturnForm2 = _interopRequireDefault(_restockReturnForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var restockReturnForm = (0, _reduxForm.reduxForm)({
	  form: 'restockReturnForm'
	})(_restockReturnForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('restockReturnForm');
	
	function mapStateToProps(state) {
	  var Promo = selector(state, 'Promo');
	  var Tax = selector(state, 'Tax');
	  var RestockingFee = selector(state, 'RestockingFee');
	  var Customers = selector(state, 'Customers');
	  var Item = selector(state, 'Item');
	  var searchValue = selector(state, 'ProductInformation');
	  var searchType = selector(state, 'searchType');
	  var Quantity = selector(state, 'Quantity');
	  var Weight = selector(state, 'Weight');
	  var UnitPrice = selector(state, 'UnitPrice');
	
	  return {
	    Promo: Promo,
	    Tax: Tax,
	    RestockingFee: RestockingFee,
	    Customers: Customers,
	    Item: Item,
	    searchValue: searchValue,
	    searchType: searchType,
	    Quantity: Quantity,
	    Weight: Weight,
	    UnitPrice: UnitPrice,
	
	    currentSalesInvoice: state.salesInvoice.currentSalesInvoice,
	    salesInvoiceDetail: state.salesInvoice.currentSalesInvoiceDetail ? state.salesInvoice.currentSalesInvoiceDetail.data : state.salesInvoice.currentSalesInvoiceDetail,
	    salesReturnDetail: state.salesInvoice.salesReturnDetail,
	    initialValues: state.salesInvoice.salesReturnDetail,
	    currentCustomer: state.customers.currentCustomer,
	    customerItem: state.salesInvoice.customerItem,
	    inventoryReturnIsLoading: state.salesInvoice.inventoryReturnIsLoading
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchSalesInvoiceDetail: _salesInvoice_actions.fetchSalesInvoiceDetail,
	  fetchCustomerItem: _salesInvoice_actions.fetchCustomerItem,
	  editSalesReturn: _sales_actions.editSalesReturn,
	  fetchSalesInvoiceCompletedDetail: _salesInvoice_actions.fetchSalesInvoiceCompletedDetail,
	  createSalesReturn: _sales_actions.createSalesReturn,
	  fetchSalesReturnDetail: _sales_actions.fetchSalesReturnDetail,
	  setValue: _sales_actions.setValue,
	  setSaleRowValue: _sales_actions.setSaleRowValue,
	  completeReturn: _sales_actions.completeReturn
	})(restockReturnForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/restockReturnForm.jsx');
	
	  __REACT_HOT_LOADER__.register(restockReturnForm, 'restockReturnForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/restockReturnForm.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/restockReturnForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Returns/restockReturnForm.jsx');
	}();

	;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _customers_actions = __webpack_require__(42);
	
	var _salesInvoice_actions = __webpack_require__(52);
	
	var _EditCustomerModal = __webpack_require__(470);
	
	var _EditCustomerModal2 = _interopRequireDefault(_EditCustomerModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	  var errors = {};
	  if (!values.Deliver_Customer_id) {
	    errors.Deliver_Customer_id = 'Required';
	  }
	  return errors;
	};
	
	var customerModal = (0, _reduxForm.reduxForm)({
	  form: 'editCustomerModal',
	  validate: validate
	})(_EditCustomerModal2.default);
	var selector = (0, _reduxForm.formValueSelector)('editCustomerModal');
	
	function mapStateToProps(state) {
	  var deliverCustomerId = selector(state, 'Deliver_Customer_id');
	  return {
	    deliverCustomerId: deliverCustomerId,
	
	    customers: state.customers.all,
	    customersIsLoading: state.customers.isLoading,
	    customersError: state.customers.error,
	    currentCustomerDetail: state.customers.currentCustomerDetail,
	    detailIsLoading: state.customers.detailIsLoading,
	    detailError: state.customers.detailError,
	    userPermissions: state.auth.userPermissions,
	    siCustomerIsEditing: state.salesInvoice.siCustomerIsEditing,
	    siCustomerEdited: state.salesInvoice.siCustomerEdited
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  editSICustomer: _salesInvoice_actions.editSICustomer,
	  fetchCustomerDetail: _customers_actions.fetchCustomerDetail,
	  fetchCustomers: _customers_actions.fetchCustomers,
	  resetEditSICustomer: _salesInvoice_actions.resetEditSICustomer
	})(customerModal);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/EditCustomerModal.jsx');
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/EditCustomerModal.jsx');
	
	  __REACT_HOT_LOADER__.register(customerModal, 'customerModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/EditCustomerModal.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/EditCustomerModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/EditCustomerModal.jsx');
	}();

	;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _pos_actions = __webpack_require__(70);
	
	var _EditPosPaymentModal = __webpack_require__(471);
	
	var _EditPosPaymentModal2 = _interopRequireDefault(_EditPosPaymentModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    editingPosPayment: state.pos.editingPosPayment,
	    editedPosPayment: state.pos.editedPosPayment,
	    editPosPaymentError: state.pos.editPosPaymentError
	  };
	};
	
	var EditPosPaymentModalContainer = (0, _reactRedux.connect)(mapStateToProps, { editPosPayment: _pos_actions.editPosPayment })(_EditPosPaymentModal2.default);
	
	var _default = EditPosPaymentModalContainer;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/EditPosPaymentModal.jsx');
	
	  __REACT_HOT_LOADER__.register(EditPosPaymentModalContainer, 'EditPosPaymentModalContainer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/EditPosPaymentModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/EditPosPaymentModal.jsx');
	}();

	;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _sales_actions = __webpack_require__(28);
	
	var _MSOPaymentInfo = __webpack_require__(472);
	
	var _MSOPaymentInfo2 = _interopRequireDefault(_MSOPaymentInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    refund: state.salesOrders.refund
	  };
	};
	
	var MSOPaymentInfoContainer = (0, _reactRedux.connect)(mapStateToProps, { requestSORefund: _sales_actions.requestSORefund, printMSORefundPDF: _sales_actions.printMSORefundPDF })(_MSOPaymentInfo2.default);
	
	var _default = MSOPaymentInfoContainer;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/MSOPaymentInfo.jsx');
	
	  __REACT_HOT_LOADER__.register(MSOPaymentInfoContainer, 'MSOPaymentInfoContainer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/MSOPaymentInfo.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/MSOPaymentInfo.jsx');
	}();

	;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PromotionsPage = __webpack_require__(473);
	
	var _PromotionsPage2 = _interopRequireDefault(_PromotionsPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PromotionsPageContainer = function PromotionsPageContainer() {
	  return _react2.default.createElement(_PromotionsPage2.default, null);
	};
	
	var _default = PromotionsPageContainer;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PromotionsPageContainer, 'PromotionsPageContainer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/PromotionsPage.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/PromotionsPage.jsx');
	}();

	;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _pos_actions = __webpack_require__(70);
	
	var _cashOutModal = __webpack_require__(484);
	
	var _cashOutModal2 = _interopRequireDefault(_cashOutModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cashOutModal = (0, _reduxForm.reduxForm)({
	  form: 'cashOutModal'
	})(_cashOutModal2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('cashOutModal');
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { verifyRegisters: _pos_actions.verifyRegisters })(cashOutModal);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/cashOutModal.jsx');
	
	  __REACT_HOT_LOADER__.register(cashOutModal, 'cashOutModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/cashOutModal.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/cashOutModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/cashOutModal.jsx');
	}();

	;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _editSalesInvoice = __webpack_require__(488);
	
	var _editSalesInvoice2 = _interopRequireDefault(_editSalesInvoice);
	
	var _print_actions = __webpack_require__(47);
	
	var _inventories_actions = __webpack_require__(38);
	
	var _salesInvoice_actions = __webpack_require__(52);
	
	var _sales_actions = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var editSalesInvoice = (0, _reduxForm.reduxForm)({
	  form: 'editSalesInvoice'
	})(_editSalesInvoice2.default);
	
	editSalesInvoice = (0, _reactRedux.connect)(function (state) {
	  return {
	    initialValues: state.salesInvoice.currentSalesInvoice
	  };
	})(editSalesInvoice);
	
	var selector = (0, _reduxForm.formValueSelector)('editSalesInvoice');
	
	function mapStateToProps(state) {
	  var DocumentDate = selector(state, 'DocDate');
	  var OrderDate = selector(state, 'OrderDate');
	  var NewItem = selector(state, 'NewItem');
	  var Quantity = selector(state, 'Quantity');
	  var UnitPrice = selector(state, 'UnitPrice');
	  var searchValue = selector(state, 'ProductInformation');
	  var searchType = selector(state, 'searchType');
	  var ItemNotation = selector(state, 'itemNotation');
	  var Notation = selector(state, 'Notation');
	  var postingDate = selector(state, 'PostingDate');
	  var invoiceNum = selector(state, 'InvoiceNum');
	  var CreateTime = selector(state, 'CreateTime');
	  var InvoiceShipDate = selector(state, 'InvoiceShipDate');
	
	  return {
	    DocumentDate: DocumentDate,
	    OrderDate: OrderDate,
	    NewItem: NewItem,
	    Quantity: Quantity,
	    UnitPrice: UnitPrice,
	    searchValue: searchValue,
	    searchType: searchType,
	    ItemNotation: ItemNotation,
	    Notation: Notation,
	    postingDate: postingDate,
	    invoiceNum: invoiceNum,
	    CreateTime: CreateTime,
	    InvoiceShipDate: InvoiceShipDate,
	
	    inventories: state.inventories.all,
	    inventoriesIsLoading: state.inventories.isLoading,
	    inventoriesError: state.inventories.error,
	    currentSalesInvoice: state.salesInvoice.currentSalesInvoice,
	    salesInvoiceDetail: state.salesInvoice.currentSalesInvoiceDetail,
	    detailIsLoading: state.salesInvoice.detailIsLoading,
	    detailError: state.salesInvoice.detailError,
	    userPermissions: state.auth.userPermissions,
	
	    customerPrices: state.salesOrders.customerPrices,
	    customerPricesIsLoading: state.salesOrders.customerPricesIsLoading,
	    customerPricesError: state.salesOrders.customerPricesError,
	
	    taxRates: state.salesOrders.taxRates,
	    taxRatesIsLoading: state.salesOrders.taxRatesIsLoading,
	    taxRatesError: state.salesOrders.taxRatesError,
	
	    salesInvoiceIsUpdating: state.salesInvoice.salesInvoiceIsUpdating,
	    salesInvoiceUpdateError: state.salesInvoice.salesInvoiceUpdateError,
	    salesInvoiceUpdated: state.salesInvoice.salesInvoiceUpdated,
	
	    siCustomerIsEditing: state.salesInvoice.siCustomerIsEditing,
	    siCustomerEdited: state.salesInvoice.siCustomerEdited,
	
	    salesOrderProduct: state.salesOrders.salesOrderProduct,
	    salesOrderProductIsLoading: state.salesOrders.salesOrderProductIsLoading,
	    salesOrderProductFailure: state.salesOrders.salesOrderProductFailure,
	
	    salesInvoicePdf: state.print.salesInvoicePdf,
	    salesInvoicePdfError: state.print.salesInvoicePdfError,
	    printSalesInvoiceIsLoading: state.print.printSalesInvoiceIsLoading
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  updateSalesInvoice: _salesInvoice_actions.updateSalesInvoice,
	  fetchInventories: _inventories_actions.fetchInventories,
	  fetchSalesInvoiceDetail: _salesInvoice_actions.fetchSalesInvoiceDetail,
	  fetchCustomerPrices: _sales_actions.fetchCustomerPrices,
	  fetchTaxRates: _sales_actions.fetchTaxRates,
	  setSaleRowValue: _sales_actions.setSaleRowValue,
	  setValue: _sales_actions.setValue,
	  resetFormInputs: _salesInvoice_actions.resetFormInputs,
	  fetchSalesOrderLineWeights: _sales_actions.fetchSalesOrderLineWeights,
	  setOrderLineWeights: _sales_actions.setOrderLineWeights,
	  printSalesInvoice: _print_actions.printSalesInvoice,
	  updateInvoiceEmployeeNote: _salesInvoice_actions.updateInvoiceEmployeeNote
	})(editSalesInvoice);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/editSalesInvoice.jsx');
	
	  __REACT_HOT_LOADER__.register(editSalesInvoice, 'editSalesInvoice', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/editSalesInvoice.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/editSalesInvoice.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/editSalesInvoice.jsx');
	}();

	;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _favoriteList = __webpack_require__(489);
	
	var _favoriteList2 = _interopRequireDefault(_favoriteList);
	
	var _favoriteList_actions = __webpack_require__(89);
	
	var _favorites_actions = __webpack_require__(58);
	
	var _sales_actions = __webpack_require__(28);
	
	var _inventories_actions = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var favoriteList = (0, _reduxForm.reduxForm)({
	  form: 'favoriteList',
	  destroyOnUnmount: false
	})(_favoriteList2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('favoriteList');
	
	function mapStateToProps(state) {
	  var SearchType = selector(state, 'SearchType');
	  var ProductInformation = selector(state, 'ProductInformation');
	
	  return {
	    SearchType: SearchType,
	    ProductInformation: ProductInformation,
	    initialValues: { SearchType: 'RefNum' },
	
	    customers: state.customerFavorites.customersWithFavorites,
	    customersIsLoading: state.customerFavorites.customersWithFavoritesIsLoading,
	    customersError: state.customerFavorites.customersWithFavoritesError,
	    isSaving: state.customerFavorites.isLoading,
	    saveError: state.customerFavorites.error,
	    userPermissions: state.auth.userPermissions,
	
	    favoriteList: state.favorites.favoriteList,
	    favoriteListIsLoading: state.favorites.favoriteListIsLoading,
	    favoriteListError: state.favorites.favoriteListError,
	
	    saveFavoriteListSuccess: state.favorites.saveFavoriteListSuccess,
	    saveFavoriteListError: state.favorites.saveFavoriteListError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  addNewCustomerFavorite: _favoriteList_actions.addNewCustomerFavorite,
	  fetchCustomerFavorites: _favoriteList_actions.fetchCustomerFavorites,
	  selectCustomerFavorites: _favoriteList_actions.selectCustomerFavorites,
	  resetCurrentCustomerFavorites: _favoriteList_actions.resetCurrentCustomerFavorites,
	  fetchCustomersWithFavorites: _favoriteList_actions.fetchCustomersWithFavorites,
	  deleteCustomerFavorite: _favoriteList_actions.deleteCustomerFavorite,
	  setSaleRowValue: _sales_actions.setSaleRowValue,
	  setValue: _sales_actions.setValue,
	  fetchInventories: _inventories_actions.fetchInventories,
	  saveFavoriteList: _favorites_actions.saveFavoriteList,
	  fetchFavoriteList: _favorites_actions.fetchFavoriteList })(favoriteList);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/favoriteList.jsx');
	
	  __REACT_HOT_LOADER__.register(favoriteList, 'favoriteList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/favoriteList.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/favoriteList.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/favoriteList.jsx');
	}();

	;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _groupList = __webpack_require__(490);
	
	var _groupList2 = _interopRequireDefault(_groupList);
	
	var _groupList_actions = __webpack_require__(90);
	
	var _customers_actions = __webpack_require__(42);
	
	var _sales_actions = __webpack_require__(28);
	
	var _inventories_actions = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var groupList = (0, _reduxForm.reduxForm)({
	  form: 'favoriteList',
	  destroyOnUnmount: false
	})(_groupList2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('favoriteList');
	
	function mapStateToProps(state) {
	  var SearchType = selector(state, 'SearchType');
	  var ProductInformation = selector(state, 'ProductInformation');
	  var SelectedCustomer = selector(state, 'SelectedCustomer');
	
	  return {
	    SearchType: SearchType,
	    ProductInformation: ProductInformation,
	    SelectedCustomer: SelectedCustomer,
	    initialValues: { SearchType: 'RefNum' },
	
	    groups: state.customerGroups.groups,
	    groupsIsLoading: state.customerGroups.groupsIsLoading,
	    groupsError: state.customerGroups.groupsError,
	    isSaving: state.customerGroups.isLoading,
	    saveError: state.customerGroups.error,
	    userPermissions: state.auth.userPermissions,
	
	    saveProductListSuccess: state.customerGroups.saveProductListSuccess,
	    saveProductListError: state.customerGroups.saveProductListFailure,
	
	    groupDetails: state.customerGroups.groupDetails,
	    groupDetailsIsLoading: state.customerGroups.groupDetailsIsLoading,
	    groupDetailsError: state.customerGroups.groupDetailsError,
	
	    allCustomers: state.customers.all,
	    allCustomersIsLoading: state.customers.isLoading,
	    allCustomersError: state.customers.error
	
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  setSaleRowValue: _sales_actions.setSaleRowValue,
	  setValue: _sales_actions.setValue,
	  fetchInventories: _inventories_actions.fetchInventories,
	
	  createGroup: _groupList_actions.createGroup,
	  deleteGroup: _groupList_actions.deleteGroup,
	  editCustomerGroup: _customers_actions.editCustomerGroup,
	  saveProductList: _groupList_actions.saveProductList,
	  fetchCustomerGroupsDetail: _groupList_actions.fetchCustomerGroupsDetail,
	  fetchCustomerGroups: _groupList_actions.fetchCustomerGroups,
	  fetchCustomers: _customers_actions.fetchCustomers })(groupList);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/groupList.jsx');
	
	  __REACT_HOT_LOADER__.register(groupList, 'groupList', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/groupList.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/groupList.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/groupList.jsx');
	}();

	;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _logModal = __webpack_require__(491);
	
	var _logModal2 = _interopRequireDefault(_logModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logModal = (0, _reduxForm.reduxForm)({
	  form: 'logModal'
	})(_logModal2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('logModal');
	
	function mapStateToProps(state) {
	  return {};
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {})(logModal);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/logModal.jsx');
	
	  __REACT_HOT_LOADER__.register(logModal, 'logModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/logModal.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/logModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/logModal.jsx');
	}();

	;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _otherService_actions = __webpack_require__(136);
	
	var _otherService = __webpack_require__(492);
	
	var _otherService2 = _interopRequireDefault(_otherService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var otherService = (0, _reduxForm.reduxForm)({
	  form: 'otherService',
	  destroyOnUnmount: false
	})(_otherService2.default);
	
	function mapStateToProps(state) {
	  return {
	    currentSalesOrder: state.otherService.currentSalesOrder,
	    otherService: state.otherService.all,
	    isLoading: state.otherService.isLoading,
	    error: state.otherService.error,
	    salesOrderDetail: state.otherService.currentSalesOrderDetail,
	    salesOrderIsLoading: state.otherService.detailIsLoading,
	    salesOrderError: state.otherService.detailError,
	    salesOrdersFilter: state.otherService.salesOrdersFilter,
	    userPermissions: state.auth.userPermissions,
	    users: state.settings.all,
	    usersIsLoading: state.settings.isLoading,
	    usersError: state.settings.error,
	    msoTotalPages: state.otherService.msoTotalPages,
	
	    requestingShippingList: state.otherService.requestingShippingList,
	    shippingListPDF: state.otherService.shippingListPDF,
	
	    requestingPickingList: state.otherService.requestingPickingList,
	    pickingListPDF: state.otherService.pickingListPDF,
	
	    requestingPackingList: state.otherService.requestingPackingList,
	    packingListPDF: state.otherService.packingListPDF,
	
	    requestingSalesOrderPDF: state.otherService.requestingSalesOrderPDF,
	    salesOrderPDF: state.otherService.salesOrderPDF,
	
	    requestingBolIdPDF: state.otherService.requestingBolIdPDF,
	    bolIdPDF: state.otherService.bolIdPDF,
	    requestingBolWithoutLogPDF: state.otherService.requestingBolWithoutLogPDF,
	    bolWithoutLogPDF: state.otherService.bolWithoutLogPDF,
	    requestingBolLabel: state.otherService.requestingBolLabel,
	    bolLabel: state.otherService.bolLabel,
	    requestingBolFbaPDF: state.otherService.requestingBolFbaPDF,
	    bolFbaPDF: state.otherService.bolFbaPDF,
	    bolAddress: state.otherService.bolAddress,
	    quoteLoading: state.otherService.quoteLoading
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchOtherService: _otherService_actions.fetchOtherService,
	  fetchSalesOrderDetail: _otherService_actions.fetchSalesOrderDetail
	})(otherService);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/otherService.jsx');
	
	  __REACT_HOT_LOADER__.register(otherService, 'otherService', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/otherService.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/otherService.jsx');
	}();

	;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _sales_actions = __webpack_require__(28);
	
	var _pos_actions = __webpack_require__(70);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _settings_actions = __webpack_require__(33);
	
	var _posCredits = __webpack_require__(493);
	
	var _posCredits2 = _interopRequireDefault(_posCredits);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var posCredits = (0, _reduxForm.reduxForm)({
	  form: 'posCredits',
	  destroyOnUnmount: false
	})(_posCredits2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('posCredits');
	
	function mapStateToProps(state) {
	  var Days = selector(state, 'Days');
	  var FromDate = selector(state, 'FromDate');
	  var ToDate = selector(state, 'ToDate');
	  var Status = selector(state, 'Status');
	  var Seller = selector(state, 'Seller');
	  var ProductNum = selector(state, 'ProductNum');
	  return {
	    Days: Days,
	    FromDate: FromDate,
	    ToDate: ToDate,
	    Status: Status,
	    Seller: Seller,
	    ProductNum: ProductNum,
	    currentPosCredit: state.salesOrders.currentPosCredit, // x thisis after view
	    posCredits: state.pos.all,
	    isLoading: state.pos.isLoading,
	    error: state.pos.error,
	
	    posCreditDetail: state.pos.currentPosCreditDetail, // this is the select detail
	    posCreditIsLoading: state.pos.creditDetailIsLoading,
	    posCreditError: state.pos.creditDetailError,
	    posCreditsFilter: state.salesOrders.salesOrdersFilter // x
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  setDefaultDays: _purchaseOrders_actions.setDefaultDays,
	  fetchSalesOdersByDate: _sales_actions.fetchSalesOdersByDate,
	  voidSalesOrder: _sales_actions.voidSalesOrder,
	  fetchSalesOrders: _sales_actions.fetchSalesOrders,
	  fetchSalesOrderDetail: _sales_actions.fetchSalesOrderDetail,
	  selectSalesOrder: _sales_actions.selectSalesOrder,
	  resetCurrentSalesOrder: _sales_actions.resetCurrentSalesOrder,
	  loadsPost: _sales_actions.loadsPost,
	  setSalesOrdersFilter: _sales_actions.setSalesOrdersFilter,
	  setValue: _sales_actions.setValue,
	  fetchBaseUsers: _settings_actions.fetchBaseUsers,
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	  fetchSalesOrdersByFilter: _sales_actions.fetchSalesOrdersByFilter,
	  fetchPosCreditsByDate: _pos_actions.fetchPosCreditsByDate,
	  fetchPosCredits: _pos_actions.fetchPosCredits,
	  fetchPosCreditDetail: _pos_actions.fetchPosCreditDetail,
	  fetchPosCreditsByFilter: _pos_actions.fetchPosCreditsByFilter,
	  voidPosOrder: _pos_actions.voidPosOrder,
	  checkPassword: _settings_actions.checkPassword,
	  clearCheckPassword: _settings_actions.clearCheckPassword
	})(posCredits);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/posCredits.jsx');
	
	  __REACT_HOT_LOADER__.register(posCredits, 'posCredits', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/posCredits.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/posCredits.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/posCredits.jsx');
	}();

	;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _pos_actions = __webpack_require__(70);
	
	var _baseModal_actions = __webpack_require__(80);
	
	var _posHolds = __webpack_require__(494);
	
	var _posHolds2 = _interopRequireDefault(_posHolds);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    posHolds: state.pos.posHolds,
	    posHoldsOderDetail: state.pos.posHoldsOderDetail,
	    confirmPasscodeVerified: state.baseModals.confirmPasscodeModal.verified,
	    requestingPosHoldsPDF: state.pos.requestingPosHoldsPDF,
	    posHoldsPDF: state.pos.posHoldsPDF
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchPosHoldsOrders: _pos_actions.fetchPosHoldsOrders,
	  fetchPosHoldsOrdersDetail: _pos_actions.fetchPosHoldsOrdersDetail,
	  voidSelectedPosHoldsOrder: _pos_actions.voidSelectedPosHoldsOrder,
	  printPosHolds: _pos_actions.printPosHolds,
	  setConfirmPasscodeModalVisibility: _baseModal_actions.setConfirmPasscodeModalVisibility,
	  setPasscodeVerificationStatus: _baseModal_actions.setPasscodeVerificationStatus
	})(_posHolds2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/posHolds.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/posHolds.jsx');
	}();

	;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _customers_actions = __webpack_require__(42);
	
	var _sales_actions = __webpack_require__(28);
	
	var _pos_actions = __webpack_require__(70);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _settings_actions = __webpack_require__(33);
	
	var _posOrders = __webpack_require__(495);
	
	var _posOrders2 = _interopRequireDefault(_posOrders);
	
	var _root_url = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isEcity = _root_url.ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/" || _root_url.ROOT_API_URL === 'https://ct-scm.truckxi.com/api/';
	
	var posOrders = (0, _reduxForm.reduxForm)({
	  form: 'posOrders',
	  destroyOnUnmount: false
	})(_posOrders2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('posOrders');
	
	function mapStateToProps(state) {
	  var Days = selector(state, 'Days');
	  var FromDate = selector(state, 'FromDate');
	  var ToDate = selector(state, 'ToDate');
	  var Status = selector(state, 'Status');
	  var Seller = selector(state, 'Seller');
	  var ProductNum = selector(state, 'ProductNum');
	  var Customer = selector(state, 'Customer');
	  var Type = selector(state, 'Type');
	
	  return {
	    Days: Days,
	    FromDate: FromDate,
	    ToDate: ToDate,
	    Status: Status,
	    Seller: Seller,
	    ProductNum: ProductNum,
	    Customer: Customer,
	    Type: Type,
	    currentPosOrder: state.salesOrders.currentSalesOrder,
	    posOrders: isEcity ? state.pos.all !== null ? state.pos.all.records : [] : state.pos.all,
	    posOrdersAll: state.pos.all,
	    isLoading: state.pos.isLoading,
	    error: state.pos.error,
	    posOrderDetail: state.pos.currentPosOrderDetail,
	    posOrderIsLoading: state.pos.detailIsLoading,
	    posOrderError: state.pos.detailError,
	    posOrdersFilter: state.salesOrders.salesOrdersFilter,
	    userPermissions: state.auth.userPermissions,
	
	    users: state.settings.all,
	    usersIsLoading: state.settings.isLoading,
	    usersError: state.settings.error,
	
	    checkPassword: state.settings.checkPassword,
	    checkPasswordSuccess: state.settings.checkPasswordSuccess,
	    checkPasswordFailure: state.settings.checkPasswordFailure,
	
	    customers: state.customers.all,
	    customersIsLoading: state.customers.isLoading,
	    customersError: state.customers.error
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  setDefaultDays: _purchaseOrders_actions.setDefaultDays,
	  fetchSalesOdersByDate: _sales_actions.fetchSalesOdersByDate,
	  voidSalesOrder: _sales_actions.voidSalesOrder,
	  fetchSalesOrders: _sales_actions.fetchSalesOrders,
	  fetchSalesOrderDetail: _sales_actions.fetchSalesOrderDetail,
	  selectSalesOrder: _sales_actions.selectSalesOrder,
	  fetchActiveCustomers: _customers_actions.fetchActiveCustomers,
	  resetCurrentSalesOrder: _sales_actions.resetCurrentSalesOrder,
	  loadsPost: _sales_actions.loadsPost,
	  setSalesOrdersFilter: _sales_actions.setSalesOrdersFilter,
	  setValue: _sales_actions.setValue,
	  fetchBaseUsers: _settings_actions.fetchBaseUsers,
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	  fetchSalesOrdersByFilter: _sales_actions.fetchSalesOrdersByFilter,
	  fetchPosOrdersByDate: _pos_actions.fetchPosOrdersByDate,
	  fetchPosOrders: _pos_actions.fetchPosOrders,
	  fetchPosOrderDetail: _pos_actions.fetchPosOrderDetail,
	  fetchPosOrdersByFilter: _pos_actions.fetchPosOrdersByFilter,
	  voidPosOrder: _pos_actions.voidPosOrder,
	  checkPassword: _settings_actions.checkPassword,
	  clearCheckPassword: _settings_actions.clearCheckPassword
	})(posOrders);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/posOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(isEcity, 'isEcity', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/posOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(posOrders, 'posOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/posOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/posOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/posOrders.jsx');
	}();

	;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _products_actions = __webpack_require__(30);
	
	var _sales_actions = __webpack_require__(28);
	
	var _pos_actions = __webpack_require__(70);
	
	var _posReport = __webpack_require__(496);
	
	var _posReport2 = _interopRequireDefault(_posReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var posReport = (0, _reduxForm.reduxForm)({
	  form: 'posReport'
	})(_posReport2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('posReport');
	
	function mapStateToProps(state) {
	  var Days = selector(state, 'Days');
	  var FromDate = selector(state, 'FromDate');
	  var ToDate = selector(state, 'ToDate');
	  var StartError = selector(state, 'StartError');
	  var EndError = selector(state, 'EndError');
	  var Types = selector(state, 'Types');
	
	  return {
	    Days: Days,
	    FromDate: FromDate,
	    ToDate: ToDate,
	    Types: Types,
	    StartError: StartError,
	    EndError: EndError,
	
	    groups: state.products.groups,
	    groupIsLoading: state.products.groupIsLoading,
	    groupError: state.products.groupError,
	
	    groupCategories: state.products.groupCategories,
	    groupCategoryError: state.products.groupCategoryError,
	    groupCategoryIsLoading: state.products.groupCategoryIsLoading,
	
	    posReport: state.salesOrders.posReport,
	    posReportIsLoading: state.salesOrders.posReportIsLoading,
	    posReportError: state.salesOrders.posReportError,
	
	    registers: state.pos.registers,
	    registersIsLoading: state.pos.registersIsLoading,
	    registersError: state.pos.registersError,
	
	    sessions: state.pos.sessions,
	    sessionsIsLoading: state.pos.sessionsIsLoading,
	    sessionsError: state.pos.sessionsError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchGroups: _products_actions.fetchGroups, fetchGroupCategories: _products_actions.fetchGroupCategories, fetchAllRegisterSessions: _pos_actions.fetchAllRegisterSessions, fetchPosReport: _sales_actions.fetchPosReport, setValue: _sales_actions.setValue, setField: _pos_actions.setField, fetchRegisters: _pos_actions.fetchRegisters, fetchRegisterSessions: _pos_actions.fetchRegisterSessions, fetchRegisterSessionsByDate: _pos_actions.fetchRegisterSessionsByDate
	})(posReport);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/posReport.jsx');
	
	  __REACT_HOT_LOADER__.register(posReport, 'posReport', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/posReport.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/posReport.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/posReport.jsx');
	}();

	;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _preOrders_actions = __webpack_require__(211);
	
	var _preOrders = __webpack_require__(497);
	
	var _preOrders2 = _interopRequireDefault(_preOrders);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var preOrders = (0, _reduxForm.reduxForm)({
	  form: 'preOrders',
	  destroyOnUnmount: false
	})(_preOrders2.default);
	
	function mapStateToProps(state) {
	  return {
	    currentSalesOrder: state.preOrders.currentSalesOrder,
	    preOrders: state.preOrders.all,
	    isLoading: state.preOrders.isLoading,
	    error: state.preOrders.error,
	    salesOrderDetail: state.preOrders.currentSalesOrderDetail,
	    salesOrderIsLoading: state.preOrders.detailIsLoading,
	    salesOrderError: state.preOrders.detailError,
	    salesOrdersFilter: state.preOrders.salesOrdersFilter,
	    userPermissions: state.auth.userPermissions,
	    users: state.settings.all,
	    usersIsLoading: state.settings.isLoading,
	    usersError: state.settings.error,
	    msoTotalPages: state.preOrders.msoTotalPages,
	
	    requestingShippingList: state.preOrders.requestingShippingList,
	    shippingListPDF: state.preOrders.shippingListPDF,
	
	    requestingPickingList: state.preOrders.requestingPickingList,
	    pickingListPDF: state.preOrders.pickingListPDF,
	
	    requestingPackingList: state.preOrders.requestingPackingList,
	    packingListPDF: state.preOrders.packingListPDF,
	
	    requestingSalesOrderPDF: state.preOrders.requestingSalesOrderPDF,
	    salesOrderPDF: state.preOrders.salesOrderPDF,
	
	    requestingBolIdPDF: state.preOrders.requestingBolIdPDF,
	    bolIdPDF: state.preOrders.bolIdPDF,
	    requestingBolWithoutLogPDF: state.preOrders.requestingBolWithoutLogPDF,
	    bolWithoutLogPDF: state.preOrders.bolWithoutLogPDF,
	    requestingBolLabel: state.preOrders.requestingBolLabel,
	    bolLabel: state.preOrders.bolLabel,
	    requestingBolFbaPDF: state.preOrders.requestingBolFbaPDF,
	    bolFbaPDF: state.preOrders.bolFbaPDF,
	    bolAddress: state.preOrders.bolAddress,
	    quoteLoading: state.preOrders.quoteLoading
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchPreOrders: _preOrders_actions.fetchPreOrders,
	  fetchSalesOrderDetail: _preOrders_actions.fetchSalesOrderDetail
	})(preOrders);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/preOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(preOrders, 'preOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/preOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/preOrders.jsx');
	}();

	;

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _warehouses_actions = __webpack_require__(44);
	
	var _inventories_actions = __webpack_require__(38);
	
	var _favorites_actions = __webpack_require__(58);
	
	var _sales_actions = __webpack_require__(28);
	
	var _salesInvoice_actions = __webpack_require__(52);
	
	var _customers_actions = __webpack_require__(42);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _salesDashboard = __webpack_require__(498);
	
	var _salesDashboard2 = _interopRequireDefault(_salesDashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var salesDashboard = (0, _reduxForm.reduxForm)({
	    form: 'salesDashboard'
	})(_salesDashboard2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('salesDashboard');
	
	function mapStateToProps(state) {
	    var orderScheduleDate = selector(state, 'OrderScheduleDate');
	    var warehouseChosen = selector(state, 'Warehouse');
	
	    return {
	        orderScheduleDate: orderScheduleDate,
	        warehouseChosen: warehouseChosen,
	
	        customerOrderSchedules: state.salesOrders.customerOrderSchedules,
	        customerOrderSchedulesIsLoading: state.salesOrders.customerOrderSchedulesIsLoading,
	        customerOrderSchedulesError: state.salesOrders.customerOrderSchedulesError,
	
	        customerCreditLines: state.customers.customerCreditLines,
	        customerCreditLinesIsLoading: state.customers.customerCreditLinesIsLoading,
	        customerCreditLinesError: state.customers.customerCreditLinesError,
	
	        salesOrders: state.salesOrders.all,
	        SOIsLoading: state.salesOrders.isLoading,
	        SOError: state.salesOrders.error,
	
	        salesInvoices: state.salesInvoice.all,
	        salesInvoicesIsLoading: state.salesInvoice.isLoading,
	        salesInvoicesError: state.salesInvoice.error,
	
	        currentPurchaseOrder: state.purchaseOrders.currentPurchaseOrder,
	
	        purchaseOrders: state.warehouses.purchaseOrders,
	        POIsLoading: state.warehouses.purchaseOrdersIsLoading,
	        POError: state.warehouses.purchaseOrdersError,
	
	        warehouses: state.warehouses.all,
	        warehousesIsLoading: state.warehouses.isLoading,
	        warehousesError: state.warehouses.error,
	
	        warehouseBinsDetail: state.warehouses.warehouseBinsDetail,
	        warehouseBinsDetailIsLoading: state.warehouses.warehouseBinsDetailIsLoading,
	        warehouseBinsDetailError: state.warehouses.warehouseBinsDetailError,
	
	        inventories: state.inventories.all,
	        favorites: state.favorites.all,
	        inventoryIsLoading: state.inventories.isLoading,
	        favoritesAreLoading: state.favorites.isLoading,
	        inventoryError: state.inventories.error,
	        favoritesError: state.favorites.error,
	        currentInventory: state.inventories.currentInventory,
	        currentFavorites: state.favorites.currentFavorites,
	
	        dashboardSalesDetail: state.salesOrders.dashboardSalesDetail,
	        dashboardSalesDetailIsLoading: state.salesOrders.dashboardSalesDetailIsLoading,
	        dashboardSalesDetailError: state.salesOrders.dashboardSalesDetailError
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchPurchaseOrders: _purchaseOrders_actions.fetchPurchaseOrders, selectPurchaseOrder: _purchaseOrders_actions.selectPurchaseOrder, resetCurrentPurchaseOrder: _purchaseOrders_actions.resetCurrentPurchaseOrder,
	    fetchInventories: _inventories_actions.fetchInventories, fetchFavorites: _favorites_actions.fetchFavorites, selectInventory: _inventories_actions.selectInventory, selectFavorites: _favorites_actions.selectFavorites,
	    resetCurrentInventory: _inventories_actions.resetCurrentInventory, resetCurrentFavorites: _favorites_actions.resetCurrentFavorites, deleteFavorite: _favorites_actions.deleteFavorite,
	    fetchWarehouses: _warehouses_actions.fetchWarehouses, fetchWarehouseSalesOrders: _warehouses_actions.fetchWarehouseSalesOrders, fetchWarehousePurchaseOrders: _warehouses_actions.fetchWarehousePurchaseOrders,
	    fetchWarehouseBins: _warehouses_actions.fetchWarehouseBins, fetchCustomerOrderSchedules: _sales_actions.fetchCustomerOrderSchedules, fetchSalesOrders: _sales_actions.fetchSalesOrders, fetchSalesCSV: _sales_actions.fetchSalesCSV,
	    fetchSalesInvoices: _salesInvoice_actions.fetchSalesInvoices, fetchCustomerOrderSchedulesByDate: _sales_actions.fetchCustomerOrderSchedulesByDate, fetchCustomerCreditByDate: _customers_actions.fetchCustomerCreditByDate, fetchSalesDashboardDetail: _sales_actions.fetchSalesDashboardDetail })(salesDashboard);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesDashboard.jsx');
	
	    __REACT_HOT_LOADER__.register(salesDashboard, 'salesDashboard', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesDashboard.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesDashboard.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesDashboard.jsx');
	}();

	;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _salesInvoice_actions = __webpack_require__(52);
	
	var _sales_actions = __webpack_require__(28);
	
	var _print_actions = __webpack_require__(47);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _settings_actions = __webpack_require__(33);
	
	var _baseModal_actions = __webpack_require__(80);
	
	var _salesInvoice = __webpack_require__(500);
	
	var _salesInvoice2 = _interopRequireDefault(_salesInvoice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var salesInvoice = (0, _reduxForm.reduxForm)({
	  form: 'salesInvoice',
	  destroyOnUnmount: false
	})(_salesInvoice2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('salesInvoice');
	
	function mapStateToProps(state) {
	  var Days = selector(state, 'Days');
	  var FromDate = selector(state, 'FromDate');
	  var ToDate = selector(state, 'ToDate');
	  var Seller = selector(state, 'Seller');
	  var StatusFilter = selector(state, 'StatusFilter');
	  var OrderFilter = selector(state, 'OrderFilter');
	
	  return {
	    Days: Days,
	    FromDate: FromDate,
	    ToDate: ToDate,
	    Seller: Seller,
	    StatusFilter: StatusFilter,
	    OrderFilter: OrderFilter,
	    salesInvoice: state.salesInvoice.all,
	    isLoading: state.salesInvoice.isLoading,
	    error: state.salesInvoice.error,
	    currentSalesInvoice: state.salesInvoice.currentSalesInvoice,
	    salesInvoiceDetail: state.salesInvoice.currentSalesInvoiceDetail,
	    detailIsLoading: state.salesInvoice.detailIsLoading,
	    detailError: state.salesInvoice.detailError,
	    salesReturnDetail: state.salesInvoice.salesReturnDetail,
	    users: state.settings.all,
	    usersIsLoading: state.settings.isLoading,
	    usersError: state.settings.error,
	    checkPassword: state.settings.checkPassword,
	    checkPasswordSuccess: state.settings.checkPasswordSuccess,
	    checkPasswordFailure: state.settings.checkPasswordFailure,
	    requestingSalesInvoicePdf: state.print.requestingSalesInvoicePdf,
	    salesInvoicePdf: state.print.salesInvoicePdf,
	    salesInvoicePdfError: state.print.salesInvoicePdfError,
	    requestingSalesInvoiceReturnPdf: state.print.requestingSalesInvoiceReturnPdf,
	    salesInvoiceReturnPdf: state.print.salesInvoiceReturnPdf,
	    salesInvoiceReturnPdfError: state.print.salesInvoiceReturnPdfError,
	    printSalesInvoiceIsLoading: state.print.printSalesInvoiceIsLoading,
	    finalizingSalesInvoice: state.salesInvoice.finalizingSalesInvoice,
	    deliveringSalesInvoice: state.salesInvoice.deliveringSalesInvoice,
	
	    salesorderPdfNs: state.print.salesorderPdfNs,
	    requestingSalesInvoicePdfsNs: state.print.requestingSalesInvoicePdfsNs,
	    salesInvoiceReturnPdfNs: state.print.salesInvoiceReturnPdfNs,
	
	    requestingContainerInvoicePDF: state.print.requestingContainerInvoicePDF,
	    containerInvoicePDF: state.print.containerInvoicePDF,
	
	    passcodeVerified: state.baseModals.confirmPasscodeModal.verified
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  setDefaultDays: _purchaseOrders_actions.setDefaultDays,
	  resetCurrentSalesInvoice: _salesInvoice_actions.resetCurrentSalesInvoice,
	  selectSalesInvoice: _salesInvoice_actions.selectSalesInvoice,
	  fetchFinalizedInvoices: _salesInvoice_actions.fetchFinalizedInvoices,
	  fetchSalesInvoices: _salesInvoice_actions.fetchSalesInvoices,
	  fetchSalesInvoiceDetail: _salesInvoice_actions.fetchSalesInvoiceDetail,
	  fetchSalesInvoicesByType: _salesInvoice_actions.fetchSalesInvoicesByType,
	  finalizeInvoice: _salesInvoice_actions.finalizeInvoice,
	  deliverInvoice: _salesInvoice_actions.deliverInvoice,
	  voidInvoice: _salesInvoice_actions.voidInvoice,
	  voidReturn: _salesInvoice_actions.voidReturn,
	  printInvoice: _salesInvoice_actions.printInvoice,
	  fetchSalesReturnDetail: _sales_actions.fetchSalesReturnDetail,
	  fetchBaseUsers: _settings_actions.fetchBaseUsers,
	  setField: _salesInvoice_actions.setField,
	  checkPassword: _settings_actions.checkPassword,
	  clearCheckPassword: _settings_actions.clearCheckPassword,
	  printSalesInvoice: _print_actions.printSalesInvoice,
	  printSalesInvoiceReturn: _print_actions.printSalesInvoiceReturn,
	  printSalesInvoiceNoSubtotals: _print_actions.printSalesInvoiceNoSubtotals,
	  printSalesInvoiceReturnsNoSubtotals: _print_actions.printSalesInvoiceReturnsNoSubtotals,
	  setConfirmPasscodeModalVisibility: _baseModal_actions.setConfirmPasscodeModalVisibility,
	  setPasscodeVerificationStatus: _baseModal_actions.setPasscodeVerificationStatus
	})(salesInvoice);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesInvoice.jsx');
	
	  __REACT_HOT_LOADER__.register(salesInvoice, 'salesInvoice', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesInvoice.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesInvoice.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesInvoice.jsx');
	}();

	;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _customers_actions = __webpack_require__(42);
	
	var _favoriteList_actions = __webpack_require__(89);
	
	var _inventories_actions = __webpack_require__(38);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _favorites_actions = __webpack_require__(58);
	
	var _previousOrders_actions = __webpack_require__(137);
	
	var _promotions_actions = __webpack_require__(71);
	
	var _settings_actions = __webpack_require__(33);
	
	var _paymentTerms_actions = __webpack_require__(54);
	
	var _products_actions = __webpack_require__(30);
	
	var _dispatch_actions = __webpack_require__(53);
	
	var _salesInvoice_actions = __webpack_require__(52);
	
	var _vendors_actions = __webpack_require__(46);
	
	var _salesOrderForm = __webpack_require__(502);
	
	var _salesOrderForm2 = _interopRequireDefault(_salesOrderForm);
	
	var _sales_actions = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isNumeric = function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	};
	
	var validate = function validate(values) {
	  var errors = {};
	  if (values.Quantity && !isNumeric(values.Quantity)) {
	    errors.Quantity = 'Accept number only!';
	  }
	  if (values.Quantity && values.Quantity < 0) {
	    errors.Quantity = 'Positive number only!';
	  }
	  if (values.UnitPrice && !isNumeric(values.UnitPrice) && values.UnitPrice !== '-') {
	    errors.UnitPrice = 'Accept number only!';
	  }
	  // if (values.UnitPrice && (values.UnitPrice < 0)) {
	  //   errors.UnitPrice = 'Positive number only!';
	  // }
	  if (!values.Deliver_Customer_id) {
	    errors.Deliver_Customer_id = 'Required';
	  }
	  return errors;
	};
	
	var salesOrderForm = (0, _reduxForm.reduxForm)({
	  form: 'salesOrderForm',
	  validate: validate,
	  enableReinitialize: true,
	  touchOnChange: true,
	  touchOnBlur: false
	})(_salesOrderForm2.default);
	
	salesOrderForm = (0, _reactRedux.connect)(function (state) {
	  return {
	    initialValues: state.salesOrders.currentSalesOrderDetail
	  };
	})(salesOrderForm);
	
	var selector = (0, _reduxForm.formValueSelector)('salesOrderForm');
	
	function mapStateToProps(state) {
	  var available = selector(state, 'Available');
	  var createTime = selector(state, 'CreateTime');
	  var creditRadios = selector(state, 'creditRadios');
	  var customerChosen = selector(state, 'Deliver_Customer_id');
	  var Deliver_CustomerDetail_id = selector(state, 'Deliver_CustomerDetail_id');
	  var description = selector(state, 'CustomerDescription');
	  var discount = selector(state, 'Discount');
	
	  var dispatchDate = selector(state, 'DispatchDate');
	  var dispatchStartTime = selector(state, 'DispatchStartTime');
	  var dispatchEndTime = selector(state, 'DispatchEndTime');
	
	  var shipByDate = selector(state, 'ShipByDate');
	  var employeeNote = selector(state, 'EmployeeNote');
	  var routeNote = selector(state, 'RouteNote');
	  var inPurchase = selector(state, 'InPurchase');
	  var inventoryIdValue = selector(state, 'Inventory_id');
	  var itemNotation = selector(state, 'itemNotation');
	
	  var ReceivedQuantity = selector(state, 'ReceivedQuantity');
	  var ShipmentID = selector(state, 'ShipmentID');
	  var ServiceType = selector(state, 'ServiceType');
	  var CustomerRef = selector(state, 'CustomerRef');
	  var Unloader = selector(state, 'Unloader');
	  var TruckVendor = selector(state, 'TruckVendor');
	
	  var ISANum = selector(state, 'ISANum');
	  var BillablePallets = selector(state, 'BillablePallets');
	  var RealPallets = selector(state, 'RealPallets');
	  var BoxPerPallet = selector(state, 'BoxPerPallet');
	  var PalletQuantity = selector(state, 'PalletQuantity');
	  var BoxQuantity = selector(state, 'BoxQuantity');
	  var PieceQuantity = selector(state, 'PieceQuantity');
	  var DispatchType = selector(state, 'DispatchType');
	  var BoxVol = selector(state, 'BoxVol');
	  var BoxLength = selector(state, 'BoxLength');
	  var BoxWidth = selector(state, 'BoxWidth');
	  var InnerLabelQty = selector(state, 'InnerLabelQty');
	  var OuterLabelQty = selector(state, 'OuterLabelQty');
	  var BoxHeight = selector(state, 'BoxHeight');
	  var BoxWeight = selector(state, 'BoxWeight');
	  var RepackedPalletQuantity = selector(state, 'RepackedPalletQuantity');
	  var PalletLength = selector(state, 'PalletLength');
	  var PalletWidth = selector(state, 'PalletWidth');
	  var PalletHeight = selector(state, 'PalletHeight');
	  var PalletVol = selector(state, 'PalletVol');
	  var PalletWeight = selector(state, 'PalletWeight');
	
	  var UnitQuantity = selector(state, 'UnitQuantity');
	  var UnitLength = selector(state, 'UnitLength');
	  var UnitWidth = selector(state, 'UnitWidth');
	  var UnitHeight = selector(state, 'UnitHeight');
	  var UnitVol = selector(state, 'UnitVol');
	
	  var IsOversize = selector(state, 'IsOversize');
	  var IsOverweight = selector(state, 'IsOverweight');
	  var PortDray = selector(state, 'PortDray');
	  var DrayageTrucker = selector(state, 'DrayageTrucker');
	  var Location = selector(state, 'Location');
	  var WarehouseLocation = selector(state, 'WarehouseLocation');
	  var Zone = selector(state, 'Zone');
	  var Section = selector(state, 'Section');
	  var Bin = selector(state, 'Bin');
	
	  var FBACode = selector(state, 'FBACode');
	  var TotalShippingWeight = selector(state, 'TotalShippingWeight');
	  var NMFCClass = selector(state, 'NMFCClass');
	
	  var FBARoute = selector(state, 'FBARoute');
	  var DimUnit = selector(state, 'DimUnit');
	
	  // const VendorStyleNum = selector(state, 'VendorStyleNum');
	  // const TJXStyleNum = selector(state, 'TJXStyleNum');
	  // const LineDescription = selector(state, 'LineDescription');
	  // const UPC = selector(state, 'UPC');
	  // const Color = selector(state, 'Color');
	  // const Size = selector(state, 'Size');
	  // const TotalUnits = selector(state, 'TotalUnits');
	  var StoreReady = selector(state, 'StoreReady');
	  var PalletStackable = selector(state, 'PalletStackable');
	  var Preticketed = selector(state, 'Preticketed');
	  var CantonNum = selector(state, 'CantonNum');
	  var OriginCountry = selector(state, 'OriginCountry');
	
	  var WeightUnit = selector(state, 'WeightUnit');
	  var TrailerNum = selector(state, 'TrailerNum');
	  var POList = selector(state, 'POList');
	  var POD = selector(state, 'POD');
	
	  // const ContainerNum = selector(state, 'ContainerNum');
	  var AvailableQuantity = selector(state, 'AvailableQuantity');
	  var AvailableQuantityPallet = selector(state, 'AvailableQuantityPallet');
	  var AvailableQuantityBox = selector(state, 'AvailableQuantityBox');
	  var AvailableQuantityPiece = selector(state, 'AvailableQuantityPiece');
	
	  var notation = selector(state, 'Notation');
	  var note = selector(state, 'Note');
	  var orderDate = selector(state, 'OrderDate');
	  var preSale = selector(state, 'PreSale');
	  var previousOrderFromDate = selector(state, 'PreviousOrderFromDate');
	  var previousOrderToDate = selector(state, 'PreviousOrderToDate');
	  var quantityValue = selector(state, 'Quantity');
	  var receivingCustomer = selector(state, 'receivingCustomer');
	  var refPurchasePrice = selector(state, 'RefPurchasePrice');
	  var salePrice = selector(state, 'SalePrice');
	  var sales = selector(state, 'Sales');
	  var soNum = selector(state, 'SONum');
	  var searchType = selector(state, 'searchType');
	  var group = selector(state, 'group');
	  var searchValue = selector(state, 'ProductInformation');
	  var shipperChosen = selector(state, 'CustomerDetail_id');
	  var subtotal = selector(state, 'Subtotal');
	  var taxRate = selector(state, 'TaxRate');
	  var unitPrice = selector(state, 'UnitPrice');
	  var weight = selector(state, 'Weight');
	  var savings = selector(state, 'Savings');
	  var productCost = selector(state, 'ProductCost');
	  var Sales_User_id = selector(state, 'Sales_User_id');
	  var PaymentTerm_id = selector(state, 'PaymentTerm_id');
	  var PackageSize_1 = selector(state, 'PackageSize_1');
	  var jmlBox = selector(state, 'jmlBox');
	
	  var Company_id = selector(state, 'Company_id');
	  var Pickup_Warehouse_id = selector(state, 'Pickup_Warehouse_id');
	  var gate_motor = selector(state, 'gate_motor');
	  var gate_lock = selector(state, 'gate_lock');
	  return {
	    PackageSize_1: PackageSize_1,
	    jmlBox: jmlBox,
	    PaymentTerm_id: PaymentTerm_id,
	    Sales_User_id: Sales_User_id,
	    available: available,
	    createTime: createTime,
	    creditRadios: creditRadios,
	    customerChosen: customerChosen,
	    Deliver_CustomerDetail_id: Deliver_CustomerDetail_id,
	    description: description,
	    discount: discount,
	    Company_id: Company_id,
	    Pickup_Warehouse_id: Pickup_Warehouse_id,
	
	    dispatchDate: dispatchDate,
	    dispatchStartTime: dispatchStartTime,
	    dispatchEndTime: dispatchEndTime,
	
	    shipByDate: shipByDate,
	    employeeNote: employeeNote,
	    routeNote: routeNote,
	    inPurchase: inPurchase,
	    inventoryIdValue: inventoryIdValue,
	    itemNotation: itemNotation,
	
	    ReceivedQuantity: ReceivedQuantity,
	    ShipmentID: ShipmentID,
	    ServiceType: ServiceType,
	    CustomerRef: CustomerRef,
	    Unloader: Unloader,
	    TruckVendor: TruckVendor,
	    ISANum: ISANum,
	    BillablePallets: BillablePallets,
	    RealPallets: RealPallets,
	    BoxPerPallet: BoxPerPallet,
	    PalletQuantity: PalletQuantity,
	    BoxQuantity: BoxQuantity,
	    PieceQuantity: PieceQuantity,
	    FBACode: FBACode,
	    DispatchType: DispatchType,
	    BoxVol: BoxVol,
	    BoxWidth: BoxWidth,
	    InnerLabelQty: InnerLabelQty,
	    OuterLabelQty: OuterLabelQty,
	    BoxHeight: BoxHeight,
	    BoxLength: BoxLength,
	    BoxWeight: BoxWeight,
	    RepackedPalletQuantity: RepackedPalletQuantity,
	    PalletLength: PalletLength,
	    PalletWidth: PalletWidth,
	    PalletHeight: PalletHeight,
	    PalletVol: PalletVol,
	
	    UnitQuantity: UnitQuantity,
	    UnitLength: UnitLength,
	    UnitWidth: UnitWidth,
	    UnitHeight: UnitHeight,
	    UnitVol: UnitVol,
	
	    PalletWeight: PalletWeight,
	    IsOversize: IsOversize,
	    IsOverweight: IsOverweight,
	    PortDray: PortDray,
	    DrayageTrucker: DrayageTrucker,
	    TotalShippingWeight: TotalShippingWeight,
	    NMFCClass: NMFCClass,
	    FBARoute: FBARoute,
	    DimUnit: DimUnit,
	
	    // VendorStyleNum,
	    // TJXStyleNum,
	    // LineDescription,
	    // UPC,
	    // Color,
	    // Size,
	    // TotalUnits,
	    StoreReady: StoreReady,
	    PalletStackable: PalletStackable,
	    Preticketed: Preticketed,
	    CantonNum: CantonNum,
	    OriginCountry: OriginCountry,
	
	    WeightUnit: WeightUnit,
	    TrailerNum: TrailerNum,
	    POList: POList,
	    POD: POD,
	    Location: Location,
	    WarehouseLocation: WarehouseLocation,
	    Zone: Zone,
	    Section: Section,
	    Bin: Bin,
	    // ContainerNum,
	    AvailableQuantity: AvailableQuantity,
	    AvailableQuantityPallet: AvailableQuantityPallet,
	    AvailableQuantityBox: AvailableQuantityBox,
	    AvailableQuantityPiece: AvailableQuantityPiece,
	
	    notation: notation,
	    note: note,
	    orderDate: orderDate,
	    preSale: preSale,
	    previousOrderFromDate: previousOrderFromDate,
	    previousOrderToDate: previousOrderToDate,
	    quantityValue: quantityValue,
	    receivingCustomer: receivingCustomer,
	    refPurchasePrice: refPurchasePrice,
	    salePrice: salePrice,
	    sales: sales,
	    soNum: soNum,
	    searchType: searchType,
	    group: group,
	    searchValue: searchValue,
	    shipperChosen: shipperChosen,
	    subtotal: subtotal,
	    taxRate: taxRate,
	    unitPrice: unitPrice,
	    weight: weight,
	    savings: savings,
	    productCost: productCost,
	
	    users: state.settings.all,
	
	    currentSalesOrder: state.salesOrders.currentSalesOrder,
	    currentSalesOrderDetail: state.salesOrders.currentSalesOrderDetail,
	    detailIsLoading: state.salesOrders.detailIsLoading,
	    detailError: state.salesOrders.detailError,
	    initialValues: state.salesOrders.currentSalesOrderDetail,
	
	    customers: state.customers.all,
	    customersIsLoading: state.customers.isLoading,
	    customersError: state.customers.error,
	
	    isCreating: state.salesOrders.isCreating,
	    createError: state.salesOrders.createError,
	    created: state.salesOrders.created,
	    isEditing: state.salesOrders.isEditing,
	    editError: state.salesOrders.editError,
	    edited: state.salesOrders.edited,
	
	    salesOrderEdited: state.salesOrders.salesOrderEdited,
	    salesOrderIsEditing: state.salesOrders.salesOrderIsEditing,
	    salesOrderEditError: state.salesOrders.salesOrderEditError,
	
	    salesOrderCreated: state.salesOrders.salesOrderCreated,
	    salesOrderIsCreating: state.salesOrders.salesOrderIsCreating,
	    salesOrderCreateError: state.salesOrders.salesOrderCreateError,
	
	    customerPrices: state.salesOrders.customerPrices,
	    customerPricesIsLoading: state.salesOrders.customerPricesIsLoading,
	    customerPricesError: state.salesOrders.customerPricesError,
	
	    inventories: state.inventories.salesOrderInventory,
	    inventoriesIsLoading: state.inventories.salesOrderInventoryIsLoading,
	    inventoriesError: state.inventories.salesOrderInventoryError,
	
	    // favorites: state.favorites.all,
	    // favoritesIsLoading: state.favorites.isLoading,
	    // favoritesError: state.favorites.error,
	    // currentFavorites: state.favorites.currentFavorites,
	
	    customersWithFavorites: state.customerFavorites.customersWithFavorites,
	
	    previousSOs: state.previousOrders.SOs,
	    previousOrders: state.previousOrders.all,
	    previousOrdersIsLoading: state.previousOrders.isLoading,
	    previousOrdersError: state.previousOrders.error,
	    currentPreviousOrders: state.previousOrders.currentPreviousOrders,
	
	    salesOrderDetailByNum: state.salesOrders.currentSalesOrderDetailByNum,
	    detailByNumIsLoading: state.salesOrders.detailByNumIsLoading,
	    detailByNumError: state.salesOrders.detailByNumError,
	
	    productPromotions: state.salesOrders.promotions,
	    promotions: state.promotions.all,
	    promotionsIsLoading: state.promotions.isLoading,
	    promotionsError: state.promotions.error,
	    currentPromotions: state.promotions.currentPromotions,
	    userPermissions: state.auth.userPermissions,
	
	    taxRates: state.salesOrders.taxRates,
	    taxRatesIsLoading: state.salesOrders.taxRatesIsLoading,
	    taxRatesError: state.salesOrders.taxRatesError,
	
	    paymentTerms: state.paymentTerms.all,
	    paymentTermsIsLoading: state.paymentTerms.isLoading,
	    paymentTermsError: state.paymentTerms.error,
	
	    salesCustomerDetails: state.salesOrders.salesCustomerDetails,
	    salesShippingCustomerDetails: state.salesOrders.salesShippingCustomerDetails,
	    salesCustomerDetailsIsLoading: state.salesOrders.salesCustomerDetailsIsLoading,
	    salesCustomerDetailsError: state.salesOrders.salesCustomerDetailsError,
	
	    allShipping: state.salesOrders.allShipping,
	    allShippingIsLoading: state.salesOrders.allShippingIsLoading,
	    allShippingError: state.salesOrders.allShippingError,
	
	    salesItemHistory: state.salesOrders.salesItemHistory,
	    // salesItemHistoryIsLoading: state.salesOrders.salesItemHistoryIsLoading,
	    // salesItemHistoryError: state.salesOrders.salesItemHistoryError,
	
	    customerSalesHistory: state.salesOrders.customerSalesHistory,
	    customerSalesHistoryIsLoading: state.salesOrders.customerSalesHistoryIsLoading,
	    customerSalesHistoryError: state.salesOrders.customerSalesHistoryError,
	
	    customerFrequent: state.salesOrders.customerFrequent,
	    customerFrequentIsLoading: state.salesOrders.customerFrequentIsLoading,
	    customerFrequentError: state.salesOrders.customerFrequentError,
	
	    productInfo: state.products.productInfo,
	    productInfoIsLoading: state.products.productInfoIsLoading,
	    productInfoError: state.products.productInfoError,
	
	    groups: state.products.groups,
	    groupIsLoading: state.products.groupIsLoading,
	    groupError: state.products.groupError,
	    currentGroup: state.products.currentGroup,
	
	    favoriteList: state.favorites.favoriteList,
	    favoriteListIsLoading: state.favorites.favoriteListIsLoading,
	    favoriteListError: state.favorites.favoriteListError,
	
	    checkingPermission: state.settings.checkingPermission,
	    checkPermissionSuccess: state.settings.checkPermissionSuccess,
	    checkPermissionFailure: state.settings.checkPermissionFailure,
	
	    salesOrderProduct: state.salesOrders.salesOrderProduct,
	    salesOrderProductIsLoading: state.salesOrders.salesOrderProductIsLoading,
	    salesOrderProductFailure: state.salesOrders.salesOrderProductFailure,
	
	    requestingShippingList: state.salesOrders.requestingShippingList,
	    shippingListPDF: state.salesOrders.shippingListPDF,
	
	    requestingPickingList: state.salesOrders.requestingPickingList,
	    pickingListPDF: state.salesOrders.pickingListPDF,
	
	    requestingPackingList: state.salesOrders.requestingPackingList,
	    packingListPDF: state.salesOrders.packingListPDF,
	
	    requestingSalesOrderPDF: state.salesOrders.requestingSalesOrderPDF,
	    salesOrderPDF: state.salesOrders.salesOrderPDF,
	
	    requestingSalesOrderSIPDF: state.salesOrders.requestingSalesOrderSIPDF,
	    salesOrderSIPDF: state.salesOrders.salesOrderSIPDF,
	
	    requestingRefundPDF: state.salesOrders.requestingRefundPDF,
	    refundPDF: state.salesOrders.refundPDF,
	
	    prevEstDate: state.salesOrders.prevEstDate,
	    prevEstDateIsNeeded: state.salesOrders.prevEstDate,
	
	    batchesInfo: state.salesOrders.batchesInfo,
	    gate_motor: gate_motor,
	    gate_lock: gate_lock
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  checkPermission: _settings_actions.checkPermission,
	  clearConvertingToInvoice: _dispatch_actions.clearConvertingToInvoice,
	  clearInventories: _sales_actions.clearInventories,
	  clearSalesCustomerDetails: _sales_actions.clearSalesCustomerDetails,
	  clearUpdateSalesInvoice: _salesInvoice_actions.clearUpdateSalesInvoice,
	  createSalesOrder: _sales_actions.createSalesOrder,
	  destroyEstDate: _sales_actions.destroyEstDate,
	  editSalesOrder: _sales_actions.editSalesOrder,
	  fetchActiveCustomers: _customers_actions.fetchActiveCustomers,
	  fetchAllShipping: _sales_actions.fetchAllShipping,
	  fetchBaseUsers: _settings_actions.fetchBaseUsers,
	  fetchCustomerSalesHistory: _sales_actions.fetchCustomerSalesHistory,
	  fetchCustomerFrequent: _sales_actions.fetchCustomerFrequent,
	  fetchInboundProducts: _sales_actions.fetchInboundProducts,
	  fetchCustomerPrices: _sales_actions.fetchCustomerPrices,
	  fetchCustomers: _customers_actions.fetchCustomers,
	  fetchCustomersWithFavorites: _favoriteList_actions.fetchCustomersWithFavorites,
	  fetchFavoriteList: _favorites_actions.fetchFavoriteList,
	  fetchFavorites: _favorites_actions.fetchFavorites,
	  fetchItemSalesHistory: _sales_actions.fetchItemSalesHistory,
	  fetchPaymentTerms: _paymentTerms_actions.fetchPaymentTerms,
	  fetchPreviousOrders: _previousOrders_actions.fetchPreviousOrders,
	  fetchPreviousOrderById: _previousOrders_actions.fetchPreviousOrderById,
	  fetchPreviousSalesOrderByIndexFromLast: _previousOrders_actions.fetchPreviousSalesOrderByIndexFromLast,
	  fetchPreviousSalesOrderByCustomer: _previousOrders_actions.fetchPreviousSalesOrderByCustomer,
	  fetchPreviousOrdersFromALLSalesOrder: _previousOrders_actions.fetchPreviousOrdersFromALLSalesOrder,
	  fetchPreviousOrderBySearch: _previousOrders_actions.fetchPreviousOrderBySearch,
	  fetchGroups: _products_actions.fetchGroups,
	  fetchProductInfo: _products_actions.fetchProductInfo,
	  fetchProductInfo2: _products_actions.fetchProductInfo2,
	  fetchPromotions: _promotions_actions.fetchPromotions,
	  fetchSalesCustomerDetail: _sales_actions.fetchSalesCustomerDetail,
	  fetchSalesOrderDetail: _sales_actions.fetchSalesOrderDetail,
	  fetchSalesOrderForm: _sales_actions.fetchSalesOrderForm,
	  fetchSalesOrderInventory: _inventories_actions.fetchSalesOrderInventory,
	  fetchTaxRates: _sales_actions.fetchTaxRates,
	  finishUnmount: _sales_actions.finishUnmount,
	  initializeForm: _sales_actions.initializeForm,
	  initializeSalesOrderForm: _sales_actions.initializeSalesOrderForm,
	  keepEstDate: _sales_actions.keepEstDate,
	  printPackingList: _sales_actions.printPackingList,
	  printPickingList: _sales_actions.printPickingList,
	  printSalesOrder: _sales_actions.printSalesOrder,
	  printShippingList: _sales_actions.printShippingList,
	  requestSORefund: _sales_actions.requestSORefund,
	  resetCurrentSalesOrder: _sales_actions.resetCurrentSalesOrder,
	  resetFormInputs: _sales_actions.resetFormInputs,
	  selectSalesOrder: _sales_actions.selectSalesOrder,
	  setCredit: _sales_actions.setCredit,
	  setDefaultSearchType: _purchaseOrders_actions.setDefaultSearchType,
	  setSaleOrderProductValues: _sales_actions.setSaleOrderProductValues,
	  setSaleRowValue: _sales_actions.setSaleRowValue,
	  setSubtotal: _sales_actions.setSubtotal,
	  setValue: _sales_actions.setValue,
	  fetchSalesOrderDetailByNum: _sales_actions.fetchSalesOrderDetailByNum,
	  fetchVendors: _vendors_actions.fetchVendors,
	  updateShippingWeight: _sales_actions.updateShippingWeight,
	  updateEmployeeNote: _sales_actions.updateEmployeeNote,
	  fetchCarrierInfo: _sales_actions.fetchCarrierInfo,
	  postCarrierInfo: _sales_actions.postCarrierInfo,
	  getPaymentTerms: _sales_actions.getPaymentTerms,
	  fetchFJAgents: _sales_actions.fetchFJAgents,
	  fetchFJCarriers: _sales_actions.fetchFJCarriers,
	  fetchFBAAddressOptions: _sales_actions.fetchFBAAddressOptions,
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	  printSalesOrderSI: _sales_actions.printSalesOrderSI,
	  fetchCompany: _sales_actions.fetchCompany,
	  fetchWarehousesByCompany: _sales_actions.fetchWarehousesByCompany,
	  createSalesQuote: _sales_actions.createSalesQuote,
	  fetchBatchesByID: _sales_actions.fetchBatchesByID,
	  fetchSalesOrderProductByID: _sales_actions.fetchSalesOrderProductByID,
	  QBAuthStatusCheck: _sales_actions.QBAuthStatusCheck,
	  getQBAuth: _sales_actions.getQBAuth,
	  fetchProductDetail: _sales_actions.fetchProductDetail,
	  fetchProductPromotion: _sales_actions.fetchProductPromotion
	})(salesOrderForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(isNumeric, 'isNumeric', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(salesOrderForm, 'salesOrderForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesOrderForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesOrderForm.jsx');
	}();

	;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _sales_actions = __webpack_require__(28);
	
	var _salesOrderList_actions = __webpack_require__(140);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _autoSuggest_actions = __webpack_require__(72);
	
	var _settings_actions = __webpack_require__(33);
	
	var _customers_actions = __webpack_require__(42);
	
	var _salesOrders = __webpack_require__(503);
	
	var _salesOrders2 = _interopRequireDefault(_salesOrders);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var salesOrders = (0, _reduxForm.reduxForm)({
	  form: 'salesOrders',
	  destroyOnUnmount: false
	})(_salesOrders2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('salesOrders');
	
	function mapStateToProps(state) {
	  var Days = selector(state, 'Days');
	  var FromDate = selector(state, 'FromDate');
	  var ToDate = selector(state, 'ToDate');
	  var Status = selector(state, 'Status');
	  var Seller = selector(state, 'Seller');
	  var Warehouse_id = selector(state, 'Warehouse_id');
	  var ProductNum = selector(state, 'ProductNum');
	  return {
	    Days: Days,
	    FromDate: FromDate,
	    ToDate: ToDate,
	    Status: Status,
	    Seller: Seller,
	    Warehouse_id: Warehouse_id,
	    ProductNum: ProductNum,
	    currentSalesOrder: state.salesOrders.currentSalesOrder,
	    salesOrders: state.salesOrders.all,
	    isLoading: state.salesOrders.isLoading,
	    error: state.salesOrders.error,
	    salesOrderDetail: state.salesOrders.currentSalesOrderDetail,
	    salesOrderIsLoading: state.salesOrders.detailIsLoading,
	    salesOrderError: state.salesOrders.detailError,
	    salesOrdersFilter: state.salesOrders.salesOrdersFilter,
	    userPermissions: state.auth.userPermissions,
	    users: state.settings.all,
	    usersIsLoading: state.settings.isLoading,
	    usersError: state.settings.error,
	    msoTotalPages: state.salesOrders.msoTotalPages,
	
	    requestingShippingList: state.salesOrders.requestingShippingList,
	    shippingListPDF: state.salesOrders.shippingListPDF,
	
	    requestingPickingList: state.salesOrders.requestingPickingList,
	    pickingListPDF: state.salesOrders.pickingListPDF,
	
	    requestingPackingList: state.salesOrders.requestingPackingList,
	    packingListPDF: state.salesOrders.packingListPDF,
	
	    requestingSalesOrderPDF: state.salesOrders.requestingSalesOrderPDF,
	    salesOrderPDF: state.salesOrders.salesOrderPDF,
	
	    requestingBolIdPDF: state.salesOrders.requestingBolIdPDF,
	    bolIdPDF: state.salesOrders.bolIdPDF,
	    requestingBolWithoutLogPDF: state.salesOrders.requestingBolWithoutLogPDF,
	    bolWithoutLogPDF: state.salesOrders.bolWithoutLogPDF,
	    requestingBolLabel: state.salesOrders.requestingBolLabel,
	    bolLabel: state.salesOrders.bolLabel,
	    requestingBolFbaPDF: state.salesOrders.requestingBolFbaPDF,
	    bolFbaPDF: state.salesOrders.bolFbaPDF,
	    bolAddress: state.salesOrders.bolAddress,
	
	    checkPassword: state.settings.checkPassword,
	    checkPasswordSuccess: state.settings.checkPasswordSuccess,
	    checkPasswordFailure: state.settings.checkPasswordFailure,
	
	    quoteLoading: state.salesOrders.quoteLoading,
	
	    customers: state.customers.all
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  setDefaultDays: _purchaseOrders_actions.setDefaultDays,
	  fetchSalesOdersByDate: _sales_actions.fetchSalesOdersByDate,
	  voidSalesOrder: _sales_actions.voidSalesOrder,
	  fetchSalesOrders: _sales_actions.fetchSalesOrders,
	  fetchSalesOrderDetail: _sales_actions.fetchSalesOrderDetail,
	  selectSalesOrder: _sales_actions.selectSalesOrder,
	  resetCurrentSalesOrder: _sales_actions.resetCurrentSalesOrder,
	  loadsPost: _sales_actions.loadsPost,
	  setSalesOrdersFilter: _sales_actions.setSalesOrdersFilter,
	  setValue: _sales_actions.setValue,
	  fetchBaseUsers: _settings_actions.fetchBaseUsers,
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	  fetchSalesOrdersByFilter: _salesOrderList_actions.fetchSalesOrdersByFilter,
	  printShippingList: _sales_actions.printShippingList,
	  printYingBOL: _sales_actions.printYingBOL,
	  printReceivingReport: _sales_actions.printReceivingReport,
	  printYingCustomerFile: _sales_actions.printYingCustomerFile,
	  removeSalesOrderPDF: _sales_actions.removeSalesOrderPDF,
	  printSalesOrder: _sales_actions.printSalesOrder,
	  printPickingList: _sales_actions.printPickingList,
	  printPickingListAFG: _sales_actions.printPickingListAFG,
	  printPickingListATL: _sales_actions.printPickingListATL,
	  printPackingList: _sales_actions.printPackingList,
	  printPackingListATL: _sales_actions.printPackingListATL,
	  printShippingListATL: _sales_actions.printShippingListATL,
	  fetchProductSuggestions: _autoSuggest_actions.fetchProductSuggestions,
	  checkPassword: _settings_actions.checkPassword,
	  clearCheckPassword: _settings_actions.clearCheckPassword,
	  orderToQuote: _sales_actions.orderToQuote,
	  quoteToOrder: _sales_actions.quoteToOrder,
	  printShippigLabel: _sales_actions.printShippigLabel,
	  printSalesOrderLabel: _sales_actions.printSalesOrderLabel,
	  printSalesOrderLabelBOL: _sales_actions.printSalesOrderLabelBOL,
	  printSalesOrderLabelDSQ: _sales_actions.printSalesOrderLabelDSQ,
	  printSalesOrderLabelBatch: _sales_actions.printSalesOrderLabelBatch,
	  createMobileTask: _sales_actions.createMobileTask,
	  emailSO: _sales_actions.emailSO,
	  updateShippingWeight: _sales_actions.updateShippingWeight,
	  updateShippingWeightSplit: _sales_actions.updateShippingWeightSplit,
	  fetchShippingWeightTracking: _sales_actions.fetchShippingWeightTracking,
	  fetchJmlTracking: _sales_actions.fetchJmlTracking,
	  searchInvoicesByInvoiceNo: _salesOrderList_actions.searchInvoicesByInvoiceNo,
	  searchInvoicesByTrackingNo: _salesOrderList_actions.searchInvoicesByTrackingNo,
	  reshipOrder: _sales_actions.reshipOrder,
	  setQuoteOrder: _sales_actions.setQuoteOrder,
	  updateVoidNote: _sales_actions.updateVoidNote,
	  chowbusImport: _sales_actions.chowbusImport,
	  submitBolImage: _sales_actions.submitBolImage,
	  printBolById: _sales_actions.printBolById,
	  printBolWithoutLog: _sales_actions.printBolWithoutLog,
	  printBolLabel: _sales_actions.printBolLabel,
	  printBolByFba: _sales_actions.printBolByFba,
	  fetchBolAddress: _sales_actions.fetchBolAddress,
	  fetchCustomers: _customers_actions.fetchCustomers,
	  setDavisPO: _sales_actions.setDavisPO,
	  sendPacking: _sales_actions.sendPacking,
	  printSalesOrderLabelUSPride: _sales_actions.printSalesOrderLabelUSPride,
	  reprintSalesOrderLabelUSPride: _sales_actions.reprintSalesOrderLabelUSPride,
	  setOrdersToOpen: _salesOrderList_actions.setOrdersToOpen,
	  uploadSOImage: _salesOrderList_actions.uploadSOImage,
	  uploadSOPOD: _salesOrderList_actions.uploadSOPOD,
	  setOrderToOpen: _sales_actions.setOrderToOpen,
	  selectTeapplixShipping: _sales_actions.selectTeapplixShipping,
	  printTeapplixLabel: _sales_actions.printTeapplixLabel,
	  deleteTeapplixShipping: _sales_actions.deleteTeapplixShipping,
	  printPickingListPartial: _sales_actions.printPickingListPartial,
	  emailSOCalco: _sales_actions.emailSOCalco
	})(salesOrders);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(salesOrders, 'salesOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesOrders.jsx');
	}();

	;

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _sales_actions = __webpack_require__(28);
	
	var _products_actions = __webpack_require__(30);
	
	var _salesPerformance = __webpack_require__(504);
	
	var _salesPerformance2 = _interopRequireDefault(_salesPerformance);
	
	var _salesPerformanceList_actions = __webpack_require__(141);
	
	var _settings_actions = __webpack_require__(33);
	
	var _customers_actions = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var salesPerformance = (0, _reduxForm.reduxForm)({
	  form: 'salesPerformance'
	})(_salesPerformance2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('salesPerformance');
	
	function mapStateToProps(state) {
	  var Days = selector(state, 'Days');
	  var FromDate = selector(state, 'FromDate');
	  var ToDate = selector(state, 'ToDate');
	  var userDays = selector(state, 'userDays');
	  var userTimeSelection = selector(state, 'userTimeSelection');
	  var userFromDate = selector(state, 'userFromDate');
	  var userToDate = selector(state, 'userToDate');
	  var Aggregate = selector(state, 'Aggregate');
	  var SalesType = selector(state, 'SalesType');
	  var ProductNum = selector(state, 'ProductNum');
	  var User = selector(state, 'User');
	  var Seller = selector(state, 'Seller');
	  var Customer = selector(state, 'Customer');
	  return {
	    Days: Days,
	    FromDate: FromDate,
	    ToDate: ToDate,
	    Aggregate: Aggregate,
	    SalesType: SalesType,
	    ProductNum: ProductNum,
	    User: User,
	    userDays: userDays,
	    userTimeSelection: userTimeSelection,
	    userFromDate: userFromDate,
	    userToDate: userToDate,
	    Seller: Seller,
	    Customer: Customer,
	    groups: state.products.groups,
	    groupCategories: state.products.groupCategories,
	    salesPerformanceIsLoading: state.salesOrders.salesPerformanceIsLoading,
	    salesPerformance: state.salesOrders.salesPerformance,
	    salesPerformanceError: state.salesOrders.salesPerformanceError,
	    users: state.settings.all,
	    customers: state.customers.all,
	    customersIsLoading: state.customers.isLoading,
	    mobileUsers: state.settings.all,
	    isLoading: state.settings.isLoading,
	    userPerformanceIsLoading: state.salesOrders.userPerformanceIsLoading,
	    userPerformanceData: state.salesOrders.userPerformanceData,
	    userPerformanceError: state.salesOrders.userPerformanceError,
	
	    spPDF: state.salesOrders.spPDF
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchSalesPerformanceByFilter: _salesPerformanceList_actions.fetchSalesPerformanceByFilter,
	  fetchSalesPerformance: _sales_actions.fetchSalesPerformance,
	  printSP: _sales_actions.printSP,
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	  fetchGroups: _products_actions.fetchGroups,
	  fetchGroupCategories: _products_actions.fetchGroupCategories,
	  fetchBaseUsers: _settings_actions.fetchBaseUsers,
	  fetchMobileUsers: _settings_actions.fetchMobileUsers,
	  resetCurrentUser: _settings_actions.resetCurrentUser,
	  fetchActiveCustomers: _customers_actions.fetchActiveCustomers,
	  fetchUserPerformanceByFilter: _salesPerformanceList_actions.fetchUserPerformanceByFilter
	})(salesPerformance);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesPerformance.jsx');
	
	  __REACT_HOT_LOADER__.register(salesPerformance, 'salesPerformance', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesPerformance.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesPerformance.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesPerformance.jsx');
	}();

	;

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _sales_actions = __webpack_require__(28);
	
	var _dispatch_actions = __webpack_require__(53);
	
	var _salesInvoice_actions = __webpack_require__(52);
	
	var _print_actions = __webpack_require__(47);
	
	var _salesShippingModal = __webpack_require__(505);
	
	var _salesShippingModal2 = _interopRequireDefault(_salesShippingModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var salesShippingModal = (0, _reduxForm.reduxForm)({
	  form: 'salesShippingModal'
	  // validate
	})(_salesShippingModal2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('salesShippingModal');
	var selector2 = (0, _reduxForm.formValueSelector)('salesOrderForm');
	
	function mapStateToProps(state) {
	  var chosenOrderNum = selector(state, 'Sales_Order_No');
	  var ShippingDate = selector(state, 'ShippingDate');
	
	  var PaymentType = selector(state, 'PaymentType');
	  var InvoiceShipDate = selector(state, 'InvoiceShipDate');
	  var PaymentNum = selector(state, 'PaymentNum');
	
	  var trackingNumber = selector(state, 'trackingNumber');
	  var shipCarrier = selector(state, 'shipCarrier');
	  var shipMethod = selector(state, 'shipMethod');
	
	  var discount = selector2(state, 'Discount');
	  var savings = selector2(state, 'Savings');
	  var taxRate = selector2(state, 'TaxRate');
	
	  return {
	    chosenOrderNum: chosenOrderNum,
	    ShippingDate: ShippingDate,
	    PaymentType: PaymentType,
	    InvoiceShipDate: InvoiceShipDate,
	    PaymentNum: PaymentNum,
	    discount: discount,
	    savings: savings,
	    taxRate: taxRate,
	
	    trackingNumber: trackingNumber,
	    shipCarrier: shipCarrier,
	    shipMethod: shipMethod,
	
	    salesOrders: state.dispatch.salesOrders,
	    salesOrdersIsLoading: state.dispatch.salesOrdersIsLoading,
	    salesOrdersError: state.dispatch.salesOrdersError,
	    salesInvoiceDetail: state.salesInvoice.currentSalesInvoiceDetail,
	    detailIsLoading: state.salesInvoice.detailIsLoading,
	    detailError: state.salesInvoice.detailError,
	
	    salesOrderDetail: state.salesOrders.currentSalesOrderDetail,
	    salesOrderIsLoading: state.salesOrders.detailIsLoading,
	    salesOrderError: state.salesOrders.detailError,
	
	    convertingToInvoice: state.dispatch.convertingToInvoice,
	    convertToInvoiceSuccess: state.dispatch.convertToInvoiceSuccess,
	    convertToInvoiceFailure: state.dispatch.convertToInvoiceFailure,
	    convertToInvoiceError: state.dispatch.convertToInvoiceError,
	    refreshConvertingToInvoice: state.dispatch.refreshConvertingToInvoice,
	
	    salesInvoiceIsUpdating: state.salesInvoice.salesInvoiceIsUpdating,
	    salesInvoiceUpdateError: state.salesInvoice.salesInvoiceUpdateError,
	    salesInvoiceUpdated: state.salesInvoice.salesInvoiceUpdated,
	    initialValues: state.salesInvoice.currentSalesInvoiceDetail,
	
	    requestingSalesInvoicePdf: state.print.requestingSalesInvoicePdf,
	    salesInvoicePdf: state.print.salesInvoicePdf
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchSalesOrderDetail: _sales_actions.fetchSalesOrderDetail,
	  fetchSalesOrdersByDate: _dispatch_actions.fetchSalesOrdersByDate,
	  updateSalesInvoiceReset: _salesInvoice_actions.updateSalesInvoiceReset,
	  convertingToInvoiceReset: _dispatch_actions.convertingToInvoiceReset,
	  convertToInvoice: _dispatch_actions.convertToInvoice,
	  updateSalesInvoice: _salesInvoice_actions.updateSalesInvoice,
	  fetchSalesInvoiceDetail: _salesInvoice_actions.fetchSalesInvoiceDetail,
	  setValue: _sales_actions.setValue,
	  printSalesInvoice: _print_actions.printSalesInvoice
	})(salesShippingModal);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesShippingModal.jsx');
	
	  __REACT_HOT_LOADER__.register(salesShippingModal, 'salesShippingModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesShippingModal.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesShippingModal.jsx');
	
	  __REACT_HOT_LOADER__.register(selector2, 'selector2', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesShippingModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/salesShippingModal.jsx');
	}();

	;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _shipFromOrders_actions = __webpack_require__(143);
	
	var _shipFromOrders = __webpack_require__(506);
	
	var _shipFromOrders2 = _interopRequireDefault(_shipFromOrders);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shipFromOrders = (0, _reduxForm.reduxForm)({
	  form: 'shipFromOrders',
	  destroyOnUnmount: false
	})(_shipFromOrders2.default);
	
	function mapStateToProps(state) {
	  return {
	    currentSalesOrder: state.shipFromOrders.currentSalesOrder,
	    shipFromOrders: state.shipFromOrders.all,
	    isLoading: state.shipFromOrders.isLoading,
	    error: state.shipFromOrders.error,
	    salesOrderDetail: state.shipFromOrders.currentSalesOrderDetail,
	    salesOrderIsLoading: state.shipFromOrders.detailIsLoading,
	    salesOrderError: state.shipFromOrders.detailError,
	    salesOrdersFilter: state.shipFromOrders.salesOrdersFilter,
	    userPermissions: state.auth.userPermissions,
	    users: state.settings.all,
	    usersIsLoading: state.settings.isLoading,
	    usersError: state.settings.error,
	    msoTotalPages: state.shipFromOrders.msoTotalPages,
	
	    requestingShippingList: state.shipFromOrders.requestingShippingList,
	    shippingListPDF: state.shipFromOrders.shippingListPDF,
	
	    requestingPickingList: state.shipFromOrders.requestingPickingList,
	    pickingListPDF: state.shipFromOrders.pickingListPDF,
	
	    requestingPackingList: state.shipFromOrders.requestingPackingList,
	    packingListPDF: state.shipFromOrders.packingListPDF,
	
	    requestingSalesOrderPDF: state.shipFromOrders.requestingSalesOrderPDF,
	    salesOrderPDF: state.shipFromOrders.salesOrderPDF,
	
	    requestingBolIdPDF: state.shipFromOrders.requestingBolIdPDF,
	    bolIdPDF: state.shipFromOrders.bolIdPDF,
	    requestingBolWithoutLogPDF: state.shipFromOrders.requestingBolWithoutLogPDF,
	    bolWithoutLogPDF: state.shipFromOrders.bolWithoutLogPDF,
	    requestingBolLabel: state.shipFromOrders.requestingBolLabel,
	    bolLabel: state.shipFromOrders.bolLabel,
	    requestingBolFbaPDF: state.shipFromOrders.requestingBolFbaPDF,
	    bolFbaPDF: state.shipFromOrders.bolFbaPDF,
	    bolAddress: state.shipFromOrders.bolAddress,
	    quoteLoading: state.shipFromOrders.quoteLoading
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchShipFromOrders: _shipFromOrders_actions.fetchShipFromOrders,
	  fetchSalesOrderDetail: _shipFromOrders_actions.fetchSalesOrderDetail
	})(shipFromOrders);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/shipFromOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(shipFromOrders, 'shipFromOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/shipFromOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/shipFromOrders.jsx');
	}();

	;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _shipToOrders_actions = __webpack_require__(91);
	
	var _shipToOrders = __webpack_require__(507);
	
	var _shipToOrders2 = _interopRequireDefault(_shipToOrders);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shipToOrders = (0, _reduxForm.reduxForm)({
	  form: 'shipToOrders',
	  destroyOnUnmount: false
	})(_shipToOrders2.default);
	
	function mapStateToProps(state) {
	  return {
	    currentSalesOrder: state.shipToOrders.currentSalesOrder,
	    shipToOrders: state.shipToOrders.all,
	    isLoading: state.shipToOrders.isLoading,
	    error: state.shipToOrders.error,
	    salesOrderDetail: state.shipToOrders.currentSalesOrderDetail,
	    salesOrderIsLoading: state.shipToOrders.detailIsLoading,
	    salesOrderError: state.shipToOrders.detailError,
	    salesOrdersFilter: state.shipToOrders.salesOrdersFilter,
	    userPermissions: state.auth.userPermissions,
	    users: state.settings.all,
	    usersIsLoading: state.settings.isLoading,
	    usersError: state.settings.error,
	    msoTotalPages: state.shipToOrders.msoTotalPages,
	
	    requestingShippingList: state.shipToOrders.requestingShippingList,
	    shippingListPDF: state.shipToOrders.shippingListPDF,
	
	    requestingPickingList: state.shipToOrders.requestingPickingList,
	    pickingListPDF: state.shipToOrders.pickingListPDF,
	
	    requestingPackingList: state.shipToOrders.requestingPackingList,
	    packingListPDF: state.shipToOrders.packingListPDF,
	
	    requestingSalesOrderPDF: state.shipToOrders.requestingSalesOrderPDF,
	    salesOrderPDF: state.shipToOrders.salesOrderPDF,
	
	    requestingBolIdPDF: state.shipToOrders.requestingBolIdPDF,
	    bolIdPDF: state.shipToOrders.bolIdPDF,
	    requestingBolWithoutLogPDF: state.shipToOrders.requestingBolWithoutLogPDF,
	    bolWithoutLogPDF: state.shipToOrders.bolWithoutLogPDF,
	    requestingBolLabel: state.shipToOrders.requestingBolLabel,
	    bolLabel: state.shipToOrders.bolLabel,
	    requestingBolFbaPDF: state.shipToOrders.requestingBolFbaPDF,
	    bolFbaPDF: state.shipToOrders.bolFbaPDF,
	    bolAddress: state.shipToOrders.bolAddress,
	    quoteLoading: state.shipToOrders.quoteLoading
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchShipToOrders: _shipToOrders_actions.fetchShipToOrders,
	  fetchSalesOrderDetail: _shipToOrders_actions.fetchSalesOrderDetail
	})(shipToOrders);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/shipToOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(shipToOrders, 'shipToOrders', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/shipToOrders.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/shipToOrders.jsx');
	}();

	;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _viewPosOrder = __webpack_require__(508);
	
	var _viewPosOrder2 = _interopRequireDefault(_viewPosOrder);
	
	var _pos_actions = __webpack_require__(70);
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var viewPosOrder = (0, _reduxForm.reduxForm)({
	    form: 'viewPosOrder'
	})(_viewPosOrder2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('viewPosOrder');
	
	function mapStateToProps(state) {
	    return {
	        posOrderDetail: state.pos.currentPosOrderDetail,
	        detailIsLoading: state.salesInvoice.detailIsLoading,
	        detailError: state.salesInvoice.detailError,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchPosOrderDetail: _pos_actions.fetchPosOrderDetail })(viewPosOrder);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/viewPosOrder.jsx');
	
	    __REACT_HOT_LOADER__.register(viewPosOrder, 'viewPosOrder', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/viewPosOrder.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/viewPosOrder.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/viewPosOrder.jsx');
	}();

	;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _wholesale_actions = __webpack_require__(146);
	
	var _sales_actions = __webpack_require__(28);
	
	var _reactRedux = __webpack_require__(6);
	
	var _wholesale = __webpack_require__(509);
	
	var _wholesale2 = _interopRequireDefault(_wholesale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	    return {
	        currentWholesale: state.wholesale.currentWholesale,
	        wholesale: state.wholesale.all,
	        detailIsLoading: state.wholesale.detailIsLoading,
	        detailError: state.wholesale.detailError,
	        salesOrderDetail: state.wholesale.currentWholesaleDetail,
	        salesOrderIsLoading: state.wholesale.detailIsLoading,
	        salesOrderError: state.wholesale.detailError,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { voidSalesOrder: _sales_actions.voidSalesOrder, fetchWholesaleOrderDetail: _wholesale_actions.fetchWholesaleOrderDetail, fetchWholesale: _wholesale_actions.fetchWholesale, selectWholesale: _wholesale_actions.selectWholesale, resetCurrentWholesale: _wholesale_actions.resetCurrentWholesale })(_wholesale2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/wholesale.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/wholesale.jsx');
	}();

	;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _favorites_actions = __webpack_require__(58);
	
	var _wholesaleModal_actions = __webpack_require__(145);
	
	var _wholesaleModal = __webpack_require__(510);
	
	var _wholesaleModal2 = _interopRequireDefault(_wholesaleModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wholesaleModal = (0, _reduxForm.reduxForm)({
	    form: 'wholesaleModal'
	})(_wholesaleModal2.default);
	
	function mapStateToProps(state) {
	    return {
	        inventoryBatches: state.wholesaleModal.all,
	        isLoading: state.wholesaleModal.isLoading,
	        error: state.wholesaleModal.error
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchInventoryBatches: _wholesaleModal_actions.fetchInventoryBatches })(wholesaleModal);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/wholesaleModal.jsx');
	
	    __REACT_HOT_LOADER__.register(wholesaleModal, 'wholesaleModal', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/wholesaleModal.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/wholesaleModal.jsx');
	}();

	;

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _customers_actions = __webpack_require__(42);
	
	var _favoriteList_actions = __webpack_require__(89);
	
	var _inventories_actions = __webpack_require__(38);
	
	var _favorites_actions = __webpack_require__(58);
	
	var _previousOrders_actions = __webpack_require__(137);
	
	var _promotions_actions = __webpack_require__(71);
	
	var _sales_actions = __webpack_require__(28);
	
	var _wholesale_actions = __webpack_require__(146);
	
	var _wholesaleOrderForm = __webpack_require__(511);
	
	var _wholesaleOrderForm2 = _interopRequireDefault(_wholesaleOrderForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.Name) {
	        errors.Name = 'Required';
	    }
	    if (!values.SalesOrderNum) {
	        errors.SalesOrderNum = 'Required';
	    }
	    if (!values.Description) {
	        errors.Description = 'Required';
	    }
	    return errors;
	};
	
	var wholesaleOrderForm = (0, _reduxForm.reduxForm)({
	    form: 'wholesaleOrderForm',
	    validate: validate
	})(_wholesaleOrderForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('wholesaleOrderForm');
	
	function mapStateToProps(state) {
	    var inventoryIdValue = selector(state, 'Inventory_id');
	    var quantityValue = selector(state, 'Quantity');
	    var description = selector(state, 'Description');
	    var available = selector(state, 'Available');
	    var inPurchase = selector(state, 'InPurchase');
	    var preSale = selector(state, 'PreSale');
	    var salePrice = selector(state, 'SalePrice');
	    var refPurchasePrice = selector(state, 'RefPurchasePrice');
	    var unitPrice = selector(state, 'UnitPrice');
	    var customerChosen = selector(state, 'Customer_id');
	    var salesNum = selector(state, 'SalesNum');
	    var documentDate = selector(state, 'DocumentDate');
	    var sales = selector(state, 'Sales');
	    var orderDate = selector(state, 'WholesaleOrderDate');
	    var dispatchDate = selector(state, 'DispatchDate');
	
	    return {
	        inventoryIdValue: inventoryIdValue,
	        quantityValue: quantityValue,
	        available: available,
	        inPurchase: inPurchase,
	        preSale: preSale,
	        salePrice: salePrice,
	        refPurchasePrice: refPurchasePrice,
	        unitPrice: unitPrice,
	        customerChosen: customerChosen,
	        description: description,
	        salesNum: salesNum,
	        documentDate: documentDate,
	        sales: sales,
	        orderDate: orderDate,
	        dispatchDate: dispatchDate,
	
	        currentSalesOrder: state.salesOrders.currentSalesOrder,
	        currentSalesOrderDetail: state.salesOrders.currentSalesOrderDetail,
	        detailIsLoading: state.salesOrders.detailIsLoading,
	        detailError: state.salesOrders.detailError,
	        initialValues: state.salesOrders.currentSalesOrderDetail,
	
	        customers: state.customers.all,
	        customersIsLoading: state.customers.isLoading,
	        customersError: state.customers.error,
	
	        isCreating: state.salesOrders.isCreating,
	        createError: state.salesOrders.createError,
	        created: state.salesOrders.created,
	        isEditing: state.salesOrders.isEditing,
	        editError: state.salesOrders.editError,
	        edited: state.salesOrders.edited,
	
	        inventories: state.inventories.all,
	        inventoriesIsLoading: state.inventories.isLoading,
	        inventoriesError: state.inventories.error,
	
	        favorites: state.favorites.all,
	        favoritesIsLoading: state.favorites.isLoading,
	        favoritesError: state.favorites.error,
	        currentFavorites: state.favorites.currentFavorites,
	
	        customersWithFavorites: state.customerFavorites.customersWithFavorites,
	
	        previousOrders: state.previousOrders.all,
	        previousOrdersIsLoading: state.previousOrders.isLoading,
	        previousOrdersError: state.previousOrders.error,
	        currentPreviousOrders: state.previousOrders.currentPreviousOrders,
	
	        promotions: state.promotions.all,
	        promotionsIsLoading: state.promotions.isLoading,
	        promotionsError: state.promotions.error,
	        currentPromotions: state.promotions.currentPromotions,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchCustomersWithFavorites: _favoriteList_actions.fetchCustomersWithFavorites, fetchPromotions: _promotions_actions.fetchPromotions, fetchPreviousOrders: _previousOrders_actions.fetchPreviousOrders, fetchFavorites: _favorites_actions.fetchFavorites, fetchInventories: _inventories_actions.fetchInventories, fetchCustomers: _customers_actions.fetchCustomers, createSalesOrder: _sales_actions.createSalesOrder, editSalesOrder: _sales_actions.editSalesOrder, fetchSalesOrderDetail: _sales_actions.fetchSalesOrderDetail, createWholesale: _wholesale_actions.createWholesale })(wholesaleOrderForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/wholesaleOrderForm.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/wholesaleOrderForm.jsx');
	
	    __REACT_HOT_LOADER__.register(wholesaleOrderForm, 'wholesaleOrderForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/wholesaleOrderForm.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/wholesaleOrderForm.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Sales/wholesaleOrderForm.jsx');
	}();

	;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _settings_actions = __webpack_require__(33);
	
	var _ActionLog = __webpack_require__(512);
	
	var _ActionLog2 = _interopRequireDefault(_ActionLog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionLog = (0, _reduxForm.reduxForm)({
	  form: 'actionLog',
	  destroyOnUnmount: false
	})(_ActionLog2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('actionLog');
	
	function mapStateToProps(state) {
	  var field = selector(state, 'Field');
	  return {
	    field: field,
	    actionLog: state.settings.actionLog,
	    actionLogIsLoading: state.settings.actionLogIsLoading,
	    actionLogError: state.settings.actionLogError,
	    userPermissions: state.auth.userPermissions
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchActionLog: _settings_actions.fetchActionLog, fetchActionLogByFilter: _settings_actions.fetchActionLogByFilter })(actionLog);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/ActionLog.jsx');
	
	  __REACT_HOT_LOADER__.register(actionLog, 'actionLog', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/ActionLog.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/ActionLog.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/ActionLog.jsx');
	}();

	;

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ChoosePaymentMethodModal = __webpack_require__(513);
	
	var _ChoosePaymentMethodModal2 = _interopRequireDefault(_ChoosePaymentMethodModal);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var choosePaymentMethod = (0, _reduxForm.reduxForm)({
	  form: 'choosePaymentMethod'
	})(_ChoosePaymentMethodModal2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('choosePaymentMethod');
	
	function mapStateToProps(state) {
	  var IsStripe = selector(state, 'IsStripe');
	  return {
	    IsStripe: IsStripe
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm
	})(choosePaymentMethod);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/ChoosePaymentMethodModal.jsx');
	
	  __REACT_HOT_LOADER__.register(choosePaymentMethod, 'choosePaymentMethod', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/ChoosePaymentMethodModal.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/ChoosePaymentMethodModal.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/ChoosePaymentMethodModal.jsx');
	}();

	;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _sales_actions = __webpack_require__(28);
	
	var _currencyManagement = __webpack_require__(520);
	
	var _currencyManagement2 = _interopRequireDefault(_currencyManagement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	  var errors = {};
	  if (!values.CountryFullName) {
	    errors.CountryFullName = 'Required';
	  }
	  if (!values.CurrencyCode) {
	    errors.CurrencyCode = 'Required';
	  }
	  if (!values.ExchangeRate) {
	    errors.Rate = 'Required';
	  }
	  return errors;
	};
	
	var currencyManagement = (0, _reduxForm.reduxForm)({
	  form: 'currencyManagement',
	  validate: validate
	})(_currencyManagement2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('currencyManagement');
	
	function mapStateToProps(state) {
	  var CountryFullName = selector(state, 'CountryFullName');
	  var CurrencyCode = selector(state, 'CurrencyCode');
	  var ExchangeRate = selector(state, 'ExchangeRate');
	
	  return {
	    CountryFullName: CountryFullName,
	    CurrencyCode: CurrencyCode,
	    ExchangeRate: ExchangeRate,
	    currencyRates: state.salesOrders.currencyRates,
	    currencyRatesIsLoading: state.salesOrders.currencyRatesIsLoading,
	    currencyRatesError: state.salesOrders.currencyRatesError,
	    multiCurrenciesIsEditing: state.salesOrders.multiCurrenciesIsEditing,
	    multiCurrenciesEdited: state.salesOrders.multiCurrenciesEdited,
	    multiCurrenciesEditError: state.salesOrders.multiCurrenciesEditError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchCurrencyRates: _sales_actions.fetchCurrencyRates, editMultiCurrencies: _sales_actions.editMultiCurrencies })(currencyManagement);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/currencyManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/currencyManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(currencyManagement, 'currencyManagement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/currencyManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/currencyManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/currencyManagement.jsx');
	}();

	;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _settings_actions = __webpack_require__(33);
	
	var _reactRedux = __webpack_require__(6);
	
	var _groupManagement = __webpack_require__(521);
	
	var _groupManagement2 = _interopRequireDefault(_groupManagement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	    return {
	        groups: state.settings.groups,
	        groupsError: state.settings.groupsError,
	        groupsIsLoading: state.settings.groupsIsLoading,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchGroups: _settings_actions.fetchGroups, selectCurrentGroup: _settings_actions.selectCurrentGroup, resetCurrentGroup: _settings_actions.resetCurrentGroup })(_groupManagement2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/groupManagement.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/groupManagement.jsx');
	}();

	;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _settings_actions = __webpack_require__(33);
	
	var _reactRedux = __webpack_require__(6);
	
	var _groupManagementDetail = __webpack_require__(522);
	
	var _groupManagementDetail2 = _interopRequireDefault(_groupManagementDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var groupManagementDetail = (0, _reduxForm.reduxForm)({
	    form: 'groupManagementDetail'
	})(_groupManagementDetail2.default);
	
	function mapStateToProps(state) {
	    return {
	        currentGroup: state.settings.currentGroup,
	        groupDetail: state.settings.groupDetail,
	        isLoading: state.settings.groupDetailIsLoading,
	        error: state.settings.groupDetailError,
	        initialValues: state.settings.groupDetail,
	        groups: state.settings.groups,
	        groupsError: state.settings.groupsError,
	        groupsIsLoading: state.settings.groupsIsLoading,
	        permissions: state.settings.permissions,
	        permissionsIsLoading: state.settings.permissionsIsLoading,
	        permissionsError: state.settings.permissionsError,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchGroupDetail: _settings_actions.fetchGroupDetail, fetchGroups: _settings_actions.fetchGroups, fetchPermissions: _settings_actions.fetchPermissions, editGroupDetail: _settings_actions.editGroupDetail, createGroupDetail: _settings_actions.createGroupDetail })(groupManagementDetail);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/groupManagementDetail.jsx');
	
	    __REACT_HOT_LOADER__.register(groupManagementDetail, 'groupManagementDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/groupManagementDetail.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/groupManagementDetail.jsx');
	}();

	;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _mobileUserMessagesManagement = __webpack_require__(523);
	
	var _mobileUserMessagesManagement2 = _interopRequireDefault(_mobileUserMessagesManagement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    currentUser: state.settings.currentUser,
	    isLoading: state.settings.userDetailIsLoading,
	    error: state.settings.userDetailError,
	    userPermissions: state.auth.userPermissions
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {})(_mobileUserMessagesManagement2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/mobileUserMessagesManagement.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/mobileUserMessagesManagement.jsx');
	}();

	;

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _mobileUserProducts = __webpack_require__(524);
	
	var _mobileUserProducts2 = _interopRequireDefault(_mobileUserProducts);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    currentUser: state.settings.currentUser,
	    isLoading: state.settings.userDetailIsLoading,
	    error: state.settings.userDetailError,
	    userPermissions: state.auth.userPermissions
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm
	})(_mobileUserProducts2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/mobileUserProducts.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/mobileUserProducts.jsx');
	}();

	;

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _settings_actions = __webpack_require__(33);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _MobileUserTable = __webpack_require__(516);
	
	var _MobileUserTable2 = _interopRequireDefault(_MobileUserTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    mobileUserId: state.settings.mobileUserId,
	    username: state.settings.username,
	    usernameIsLoading: state.settings.usernameIsLoading,
	    userNameError: state.settings.userNameError
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  grabMobileUserID: _settings_actions.grabMobileUserID,
	  fetchUsername: _settings_actions.fetchUsername,
	  clearUsernameData: _settings_actions.clearUsernameData,
	  setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm,
	  fetchMobileUsers: _settings_actions.fetchMobileUsers
	})(_MobileUserTable2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/mobileUserTable.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/mobileUserTable.jsx');
	}();

	;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _reduxForm = __webpack_require__(3);
	
	var _sales_actions = __webpack_require__(28);
	
	var _taxManagement = __webpack_require__(525);
	
	var _taxManagement2 = _interopRequireDefault(_taxManagement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.Name) {
	        errors.Name = 'Require';
	    }
	    if (!values.Rate) {
	        errors.Rate = 'Require';
	    }
	    return errors;
	};
	
	var taxManagement = (0, _reduxForm.reduxForm)({
	    form: 'taxManagement',
	    validate: validate
	})(_taxManagement2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('taxManagement');
	
	function mapStateToProps(state) {
	    var Name = selector(state, 'Name');
	    var Rate = selector(state, 'Rate');
	    var State = selector(state, 'State');
	
	    return {
	        Name: Name,
	        Rate: Rate,
	        State: State,
	
	        taxRates: state.salesOrders.taxRates,
	        taxRatesIsLoading: state.salesOrders.taxRatesIsLoading,
	        taxRatesError: state.salesOrders.taxRatesError,
	
	        creatingTaxRate: state.salesOrders.creatingTaxRate,
	        createTaxRateSuccess: state.salesOrders.createTaxRateSuccess,
	        createTaxRateFailure: state.salesOrders.createTaxRateFailure,
	
	        multiTaxesIsEditing: state.salesOrders.multiTaxesIsEditing,
	        multiTaxesEdited: state.salesOrders.multiTaxesEdited,
	        multiTaxesEditError: state.salesOrders.multiTaxesEditError,
	
	        taxIsDeleting: state.salesOrders.taxIsDeleting,
	        taxDeleted: state.salesOrders.taxDeleted,
	        taxDeleteError: state.salesOrders.taxDeleteError
	
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	    createTaxRate: _sales_actions.createTaxRate, fetchTaxRates: _sales_actions.fetchTaxRates, editMultiTaxes: _sales_actions.editMultiTaxes, deleteTax: _sales_actions.deleteTax })(taxManagement);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/taxManagement.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/taxManagement.jsx');
	
	    __REACT_HOT_LOADER__.register(taxManagement, 'taxManagement', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/taxManagement.jsx');
	
	    __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/taxManagement.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/taxManagement.jsx');
	}();

	;

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _settings_actions = __webpack_require__(33);
	
	var _userManagement = __webpack_require__(526);
	
	var _userManagement2 = _interopRequireDefault(_userManagement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	    return {
	        users: state.settings.all,
	        isLoading: state.settings.isLoading,
	        error: state.settings.error,
	        userType: state.auth.userType,
	        userPermissions: state.auth.userPermissions,
	        mobileUsers: state.settings.mobileUsers,
	        mobileUsersTotalPages: state.settings.mobileUsersTotalPages,
	        mobileUsersTotalCount: state.settings.mobileUsersTotalCount,
	        mobileUsersIsLoading: state.settings.mobileUsersIsLoading,
	        checkPasswordSuccess: state.settings.checkPasswordSuccess,
	        checkPasswordFailure: state.settings.checkPasswordFailure,
	        mobileUserId: state.settings.mobileUserId,
	        usernameIsLoading: state.settings.usernameIsLoading,
	        username: state.settings.username,
	        usernameError: state.settings.usernameError
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	    checkPassword: _settings_actions.checkPassword,
	    clearCheckPassword: _settings_actions.clearCheckPassword,
	    fetchBaseUsers: _settings_actions.fetchBaseUsers,
	    selectCurrentUser: _settings_actions.selectCurrentUser,
	    resetCurrentUser: _settings_actions.resetCurrentUser,
	    fetchMobileUsers: _settings_actions.fetchMobileUsers,
	    grabMobileUserID: _settings_actions.grabMobileUserID,
	    fetchUsername: _settings_actions.fetchUsername,
	    clearUsernameData: _settings_actions.clearUsernameData
	})(_userManagement2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/userManagement.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/userManagement.jsx');
	}();

	;

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _settings_actions = __webpack_require__(33);
	
	var _reactRedux = __webpack_require__(6);
	
	var _userManagementDetail = __webpack_require__(527);
	
	var _userManagementDetail2 = _interopRequireDefault(_userManagementDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (values.password && values.passwordConfirm && values.password != values.passwordConfirm) {
	        errors.password = 'password does not match!';
	    }
	    return errors;
	};
	
	var userManagementDetail = (0, _reduxForm.reduxForm)({
	    form: 'userManagementDetail',
	    validate: validate
	})(_userManagementDetail2.default);
	
	function mapStateToProps(state) {
	    return {
	        currentUser: state.settings.currentUser,
	        userDetail: state.settings.userDetail,
	        isLoading: state.settings.userDetailIsLoading,
	        error: state.settings.userDetailError,
	        initialValues: state.settings.userDetail,
	        groups: state.settings.groups,
	        groupsError: state.settings.groupsError,
	        groupsIsLoading: state.settings.groupsIsLoading,
	        groupDetail: state.settings.groupDetail,
	        groupDetailIsLoading: state.settings.groupDetailIsLoading,
	        groupDetailError: state.settings.groupDetailError,
	        permissions: state.settings.permissions,
	        permissionsIsLoading: state.settings.permissionsIsLoading,
	        permissionsError: state.settings.permissionsError,
	        createUserDetailError: state.settings.createUserDetailError,
	        userPermissions: state.auth.userPermissions,
	        checkPasswordSuccess: state.settings.checkPasswordSuccess,
	        checkPasswordFailure: state.settings.checkPasswordFailure,
	        productGroups: state.settings.productGroups
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { checkPassword: _settings_actions.checkPassword, clearCheckPassword: _settings_actions.clearCheckPassword, fetchBaseUsers: _settings_actions.fetchBaseUsers, fetchUserDetail: _settings_actions.fetchUserDetail, fetchGroups: _settings_actions.fetchGroups, fetchGroupDetail: _settings_actions.fetchGroupDetail, fetchPermissions: _settings_actions.fetchPermissions, fetchProductAllGroups: _settings_actions.fetchProductAllGroups, editUserDetail: _settings_actions.editUserDetail, createUserDetail: _settings_actions.createUserDetail, resetPassword: _settings_actions.resetPassword, resetUserDetail: _settings_actions.resetUserDetail })(userManagementDetail);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/userManagementDetail.jsx');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/userManagementDetail.jsx');
	
	    __REACT_HOT_LOADER__.register(userManagementDetail, 'userManagementDetail', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/userManagementDetail.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/userManagementDetail.jsx');
	}();

	;

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _settings_actions = __webpack_require__(33);
	
	var _userPassword = __webpack_require__(529);
	
	var _userPassword2 = _interopRequireDefault(_userPassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	    return {
	        editUserDetailSuccess: state.settings.editUserDetailSuccess,
	        editPasswordIsLoading: state.settings.editPasswordIsLoading,
	        initialValues: state.settings.userDetail,
	        editPasswordError: state.settings.editPasswordError
	    };
	}
	
	var userPassword = (0, _reduxForm.reduxForm)({
	    form: 'userPassword'
	})(_userPassword2.default);
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { editPassword: _settings_actions.editPassword })(userPassword);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/userPassword.jsx');
	
	    __REACT_HOT_LOADER__.register(userPassword, 'userPassword', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/userPassword.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Settings/userPassword.jsx');
	}();

	;

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _users_actions = __webpack_require__(144);
	
	var _userForm = __webpack_require__(530);
	
	var _userForm2 = _interopRequireDefault(_userForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(values) {
	    var errors = {};
	    if (!values.name) {
	        errors.name = 'Enter a username';
	    }
	    if (!values.email) {
	        errors.email = 'Enter a category';
	    }
	
	    if (!values.phone) {
	        errors.phone = 'Enter some phone';
	    }
	    return errors;
	}
	
	function mapStateToProps(state) {
	    return {
	        user: state.users.currentUser
	    };
	}
	
	var _default = (0, _reduxForm.reduxForm)({
	    form: 'userForm',
	    fields: ['name', 'email', 'phone', 'address.city', 'address.street'],
	    validate: validate
	}, mapStateToProps, { createUsers: _users_actions.createUsers })(_userForm2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Users/userForm.js');
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Users/userForm.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Users/userForm.js');
	}();

	;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _users_actions = __webpack_require__(144);
	
	var _users = __webpack_require__(531);
	
	var _users2 = _interopRequireDefault(_users);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	    return {
	        users: state.users.all,
	        currentUser: state.users.currentUser,
	        isLoading: state.users.isLoading,
	        error: state.users.error
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchUsers: _users_actions.fetchUsers, selectUser: _users_actions.selectUser })(_users2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Users/users.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Users/users.jsx');
	}();

	;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(6);
	
	var _paymentTerms_actions = __webpack_require__(54);
	
	var _vendors_actions = __webpack_require__(46);
	
	var _purchaseOrders_actions = __webpack_require__(23);
	
	var _customers_actions = __webpack_require__(42);
	
	var _products_actions = __webpack_require__(30);
	
	var _vendorDetailForm = __webpack_require__(532);
	
	var _vendorDetailForm2 = _interopRequireDefault(_vendorDetailForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	  var errors = {};
	  if (!values.Name) {
	    errors.Name = 'Required';
	  }
	  if (!values.VendorNum) {
	    errors.VendorNum = 'Required';
	  }
	  if (!values.Description) {
	    errors.Description = 'Required';
	  }
	  return errors;
	};
	
	var vendorDetailForm = (0, _reduxForm.reduxForm)({
	  form: 'vendorDetailForm'
	})(_vendorDetailForm2.default);
	
	var selector = (0, _reduxForm.formValueSelector)('vendorDetailForm');
	
	function mapStateToProps(state) {
	  var paymentTerm_id = selector(state, 'PaymentTerm_id');
	  var isActive = selector(state, 'IsActive');
	  var billing = selector(state, 'Billing');
	  var mailing = selector(state, 'Mailing');
	  var shipping = selector(state, 'Shipping');
	  var default_purchaser_user_id = selector(state, 'DefaultPurchaserID');
	  return {
	    paymentTerm_id: paymentTerm_id,
	    isActive: isActive,
	    billing: billing,
	    mailing: mailing,
	    shipping: shipping,
	    currentVendor: state.vendors.currentVendor,
	    currentVendorDetail: state.vendors.currentVendorDetail,
	    detailIsLoading: state.vendors.detailIsLoading,
	    detailError: state.vendors.detailError,
	    initialValues: state.vendors.currentVendorDetail,
	    paymentTerms: state.paymentTerms.all,
	    paymentTermsIsLoading: state.paymentTerms.isLoading,
	    paymentTermsError: state.paymentTerms.error,
	    isCreating: state.vendors.isCreating,
	    createError: state.vendors.createError,
	    created: state.vendors.created,
	    isEditing: state.vendors.isEditing,
	    editError: state.vendors.editError,
	    edited: state.vendors.edited,
	    userPermissions: state.auth.userPermissions,
	    defaultBuyers: state.products.defaultBuyers,
	    default_purchaser_user_id: default_purchaser_user_id
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchPaymentTerms: _paymentTerms_actions.fetchPaymentTerms, createVendor: _vendors_actions.createVendor, editVendor: _vendors_actions.editVendor, fetchVendorDetail: _vendors_actions.fetchVendorDetail, setDefaultOfForm: _purchaseOrders_actions.setDefaultOfForm, changeFieldArrayOfForm: _purchaseOrders_actions.changeFieldArrayOfForm, fetchPT: _customers_actions.fetchPT, updatePT: _customers_actions.updatePT, fetchDefaultBuyers: _products_actions.fetchDefaultBuyers
	})(vendorDetailForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Vendors/vendorDetailForm.jsx');
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Vendors/vendorDetailForm.jsx');
	
	  __REACT_HOT_LOADER__.register(vendorDetailForm, 'vendorDetailForm', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Vendors/vendorDetailForm.jsx');
	
	  __REACT_HOT_LOADER__.register(selector, 'selector', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Vendors/vendorDetailForm.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Vendors/vendorDetailForm.jsx');
	}();

	;

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vendors_actions = __webpack_require__(46);
	
	var _reactRedux = __webpack_require__(6);
	
	var _vendors = __webpack_require__(533);
	
	var _vendors2 = _interopRequireDefault(_vendors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	    return {
	        vendors: state.vendors.all,
	        currentVendor: state.vendors.currentVendor,
	        isLoading: state.vendors.isLoading,
	        error: state.vendors.error,
	        userPermissions: state.auth.userPermissions
	    };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, { fetchVendors: _vendors_actions.fetchVendors, selectVendor: _vendors_actions.selectVendor, resetCurrentVendor: _vendors_actions.resetCurrentVendor, attachDocument: _vendors_actions.attachDocument })(_vendors2.default);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Vendors/vendors.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/containers/Vendors/vendors.jsx');
	}();

	;

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    reasons: [],
	    isEditing: false,
	    isLoading: false,
	    isDeleting: false,
	    createError: null,
	    editingError: null,
	    deletionError: null,
	    logError: null,
	    edited: false,
	    created: false,
	    deleted: false,
	    error: null,
	    reason: null,
	    logs: []
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _type.REQUEST_REASONS:
	            return _extends({}, state, { isLoading: true, error: null });
	        case _type.REQUEST_REASONS_SUCCESS:
	            return _extends({}, state, { reasons: action.payload.data, isLoading: false, error: null });
	        case _type.REQUEST_REASONS_FAILURE:
	            var requestError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { error: requestError, reasons: [], isLoading: false });
	        case _type.START_REASON_CREATION:
	            return _extends({}, state, { isLoading: true, error: null, createError: null, created: false });
	        case _type.REASON_CREATION_SUCCESS:
	            return _extends({}, state, { isLoading: false, createError: null, error: null, created: true });
	        case _type.REASON_CREATION_FAILURE:
	            var creationError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { isLoading: false, createError: creationError, created: false });
	        case _type.START_REASON_EDITING:
	            return _extends({}, state, { isEditing: true, editingError: null, edited: false });
	        case _type.REASON_EDITING_SUCCESS:
	            return _extends({}, state, { isEditing: false, editingError: null, edited: true });
	        case _type.REASON_EDITING_FAILURE:
	            var editingError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { isEditing: false, editingError: editingError, edited: false });
	        case _type.REQUEST_DELETE_REASON:
	            return _extends({}, state, { isDeleting: true, deleted: false, deletionError: null });
	        case _type.REASON_DELETE_SUCCESS:
	            return _extends({}, state, { isDeleting: false, deleted: true, deletionError: null });
	        case _type.REASON_DELETE_FAILURE:
	            var deletionError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { isDeleting: false, deleted: false, deletionError: deletionError });
	        case _type.SELECT_REASON:
	            return _extends({}, state, { reason: action.payload });
	        case _type.RESET_CURRENT_REASON:
	            return _extends({}, state, { reason: null });
	        case _type.REQUEST_ADJUSTMENT_LOGS:
	            return _extends({}, state, { logs: null, logError: null, isLoading: true });
	        case _type.ADJUSTMENT_LOG_SUCCESS:
	            return _extends({}, state, { logs: action.payload.data, logError: null, isLoading: false });
	        case _type.ADJUSTMENT_LOG_FAILURE:
	            var logError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { logs: [], logError: logError, isLoading: false });
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, "INITIAL_STATE", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/adjustmentInventory_reducer.js");
	
	    __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/adjustmentInventory_reducer.js");
	}();

	;

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    all: [],
	    currentAgent: null,
	    currentAgentDetail: null,
	    isLoading: false,
	    error: null,
	    detailIsLoading: false,
	    detailError: null,
	    isCreating: false,
	    createError: null,
	    created: false
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _type.REQUEST_AGENTS:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.FETCH_AGENTS_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	        case _type.FETCH_AGENTS_FAILURE:
	            var error = action.payload || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { all: [], error: error, isLoading: false });
	        case _type.SELECT_AGENT:
	            return _extends({}, state, { currentAgent: action.payload });
	        case _type.RESET_CURRENT_AGENT:
	            return _extends({}, state, { currentAgent: null, currentAgentDetail: null });
	        case _type.REQUEST_CREATING_AGENT:
	            return _extends({}, state, { isCreating: true, createError: null, created: false });
	        case _type.CREATE_AGENT_SUCCESS:
	            return _extends({}, state, { isCreating: false, createError: null, created: true });
	        case _type.CREATE_AGENT_FAILURE:
	            var createError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { isCreating: false, createError: createError, created: false });
	        case _type.REQUEST_EDITING_AGENT:
	            return _extends({}, state, { isEditing: true, editError: null, edited: false });
	        case _type.EDIT_AGENT_SUCCESS:
	            return _extends({}, state, { isEditing: false, editError: null, edited: true });
	        case _type.EDIT_AGENT_FAILURE:
	            var editError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { isEditing: false, editError: editError, edited: false });
	        case _type.REQUEST_AGENT_DETAIL:
	            return _extends({}, state, { detailError: null, detailIsLoading: true });
	        case _type.FETCH_AGENT_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { currentAgentDetail: action.payload.data, detailError: null, detailIsLoading: false });
	        case _type.FETCH_AGENT_DETAIL_FAILURE:
	            // return error and make loading = false
	            var detailError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { all: [], detailError: detailError, detailIsLoading: false });
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/agents_reducer.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/agents_reducer.js');
	}();

	;

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    ar: null,
	    arIsLoading: false,
	    arError: null,
	    arIsCreating: false,
	    arCreateError: null,
	    arCreated: false,
	    arIsRefunding: false,
	    arRefundError: null,
	    arRefunded: false,
	    arIsEditing: false,
	    arEditError: null,
	    arEdited: false,
	    arIsDeleting: false,
	    arDeleteError: null,
	    arDeleted: false,
	    arDetail: null,
	    arDetailError: null,
	    arDetailIsLoading: false,
	    invoices: null,
	    invoicesError: null,
	    invoicesIsLoading: false,
	    credits: null,
	    creditsError: null,
	    creditsIsLoading: false,
	    bounceCheck: {
	        bounceCheck: {},
	        bounceCheckError: null,
	        bounceCheckIsRequesting: false
	    },
	    arAccounts: {
	        accountList: [],
	        accountsIsLoading: false,
	        accountsError: null
	    },
	
	    ap: null,
	    apIsLoading: false,
	    apError: null,
	    apIsCreating: false,
	    apCreateError: null,
	    apCreated: false,
	    apIsEditing: false,
	    apEditError: null,
	    apEdited: false,
	    apIsDeleting: false,
	    apDeleteError: null,
	    apDeleted: false,
	    apDetail: null,
	    apDetailError: null,
	    apDetailIsLoading: false,
	    originalCheckNumber: null,
	
	    statements: null,
	    statementsError: null,
	    statementsIsLoading: false,
	    statementsAP: null,
	    statementsAPError: null,
	    statementsAPIsLoading: false,
	    generalReport: [],
	    generalReportIsLoading: false,
	    generalReportError: null,
	    cityReport: {
	        reportData: [],
	        cityReportIsLoading: false,
	        cityReportError: null
	    },
	    customerStatement: [],
	    customerStatementIsLoading: false,
	    customerStatementError: null,
	    customerStatementList: [],
	    customerStatementListIsLoading: false,
	    customerStatementListError: null,
	    vendorStatement: [],
	    vendorStatementIsLoading: false,
	    vendorStatementError: null,
	    vendorStatementList: [],
	    vendorStatementListIsLoading: false,
	    vendorStatementListError: null,
	    mobileCustomerStatement: {
	        mobileCustomerStatement: {},
	        mobileCustomerStatementIsLoading: false,
	        mobileCustomerStatementError: null
	    }
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _type.REQUEST_AR:
	            return _extends({}, state, { ar: null, arError: null, arIsLoading: true, arCreated: false, arEdited: false, arDetail: null });
	        case _type.FETCH_AR_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { ar: action.payload.data, arError: null, arIsLoading: false });
	        case _type.FETCH_AR_FAILURE:
	            // return error and make loading = false
	            var arError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { ar: null, arError: arError, arIsLoading: false });
	        case _type.REQUEST_AR_DETAIL:
	            return _extends({}, state, { arDetail: null, arDetailError: null, arDetailIsLoading: true });
	        case _type.FETCH_AR_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { arDetail: action.payload.data, arDetailError: null, arDetailIsLoading: false });
	        case _type.FETCH_AR_DETAIL_FAILURE:
	            // return error and make loading = false
	            var arDetailError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { arDetail: null, arDetailError: arDetailError, arDetailIsLoading: false });
	        case _type.CLEAR_AR_DETAIL:
	        case _type.CLEAR_AR_FORM:
	            return _extends({}, state, { arDetail: null, arDetailError: null, arDetailIsLoading: false });
	        case _type.CREATE_AR:
	            return _extends({}, state, { arIsCreating: true, arCreateError: null, arCreated: false });
	        case _type.CREATE_AR_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { arIsCreating: false, arCreateError: null, arCreated: true });
	        case _type.CREATE_AR_FAILURE:
	            // return error and make loading = false
	            var arCreateError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            alert(JSON.stringify(arCreateError));
	            return _extends({}, state, { arIsCreating: false, arCreateError: arCreateError, arCreated: false });
	        case _type.REFUND_AR:
	            return _extends({}, state, {
	                arIsRefunding: true,
	                arRefundError: null,
	                arRefunded: false
	            });
	        case _type.REFUND_AR_SUCCESS:
	            return _extends({}, state, {
	                arIsRefunding: false,
	                arRefundError: null,
	                arRefunded: true
	            });
	        case _type.REFUND_AR_FAILURE:
	            {
	                var arRefundError = action.payload.data || { message: action.payload.message };
	                alert(JSON.stringify(arRefundError));
	                return _extends({}, state, {
	                    arIsRefunding: false,
	                    arRefundError: arRefundError,
	                    arRefunded: false
	                });
	            }
	        case _type.DELETE_AR:
	            return _extends({}, state, { arIsDeleting: true, arDeleteError: null, arDeleted: false });
	        case _type.DELETE_AR_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { arIsDeleting: false, arDeleteError: null, arDeleted: true });
	        case _type.DELETE_AR_FAILURE:
	            // return error and make loading = false
	            var arDeleteError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { arIsDeleting: false, arDeleteError: arDeleteError, arDeleted: false });
	        case _type.EDIT_AR:
	            return _extends({}, state, { arIsEditing: true, arEditError: null, arEdited: false });
	        case _type.EDIT_AR_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { arIsEditing: false, arEditError: null, arEdited: true });
	        case _type.EDIT_AR_FAILURE:
	            // return error and make loading = false
	            var arEditError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            alert(JSON.stringify(arEditError));
	            return _extends({}, state, { arIsEditing: false, arEditError: arEditError, arEdited: false });
	        case _type.BOUNCE_CHECK:
	            return _extends({}, state, {
	                bounceCheck: {
	                    bounceCheck: {},
	                    bounceCheckError: null,
	                    bounceCheckIsRequesting: true
	                }
	            });
	        case _type.BOUNCE_CHECK_SUCCESS:
	            // return list of posts and make loading = false
	            alert('Bounced Check Successful');
	            return _extends({}, state, {
	                bounceCheck: {
	                    bounceCheck: action.payload.data,
	                    bounceCheckError: null,
	                    bounceCheckIsRequesting: false
	                }
	            });
	        case _type.BOUNCE_CHECK_FAILURE:
	            // return error and make loading = false
	            var bounceCheckError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            alert(JSON.stringify(bounceCheckError));
	            return _extends({}, state, {
	                bounceCheck: {
	                    bounceCheck: {},
	                    bounceCheckError: bounceCheckError,
	                    bounceCheckIsRequesting: true
	                }
	            });
	        case _type.REQUEST_AR_ACCOUNTS:
	            return _extends({}, state, {
	                arAccounts: {
	                    accountList: [],
	                    accountListIsLoading: true,
	                    accountListError: null
	                }
	            });
	        case _type.FETCH_AR_ACCOUNTS_SUCCESS:
	            return _extends({}, state, {
	                arAccounts: {
	                    accountList: action.payload.data,
	                    accountListIsLoading: false,
	                    accountListError: null
	                }
	            });
	        case _type.FETCH_AR_ACCOUNTS_FAILURE:
	            var accountListError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, {
	                arAccounts: {
	                    accountList: [],
	                    accountListIsLoading: false,
	                    accountListError: accountListError
	                }
	            });
	        case _type.CLEAR_AR_ACCOUNTS:
	            return _extends({}, state, {
	                arAccounts: {
	                    accountList: [],
	                    accountListIsLoading: false,
	                    accountListError: null
	                }
	            });
	        case _type.REQUEST_AP:
	            return _extends({}, state, { ap: null, apError: null, apIsLoading: true, apCreated: false, apEdited: false, apDetail: null });
	        case _type.FETCH_AP_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { ap: action.payload.data, apError: null, apIsLoading: false });
	        case _type.FETCH_AP_FAILURE:
	            // return error and make loading = false
	            var apError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { ap: null, apError: apError, apIsLoading: false });
	        case _type.REQUEST_AP_DETAIL:
	            return _extends({}, state, { apDetail: null, apDetailError: null, apDetailIsLoading: true });
	        case _type.FETCH_AP_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { apDetail: action.payload.data, apDetailError: null, apDetailIsLoading: false, originalCheckNumber: action.payload.data.CheckNum });
	        case _type.FETCH_AP_DETAIL_FAILURE:
	            // return error and make loading = false
	            var apDetailError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { apDetail: null, apDetailError: apDetailError, apDetailIsLoading: false });
	        case _type.CLEAR_AP_DETAIL:
	        case _type.CLEAR_AP_FORM:
	            return _extends({}, state, { apDetail: null, apDetailError: null, apDetailIsLoading: false });
	        case _type.CREATE_AP:
	            return _extends({}, state, { apIsCreating: true, apCreateError: null, apCreated: false });
	        case _type.CREATE_AP_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { apIsCreating: false, apCreateError: null, apCreated: true });
	        case _type.CREATE_AP_FAILURE:
	            // return error and make loading = false
	            var apCreateError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            alert(JSON.stringify(apCreateError));
	            return _extends({}, state, { apIsCreating: false, apCreateError: apCreateError, apCreated: false });
	        case _type.DELETE_AP:
	            return _extends({}, state, { apIsDeleting: true, apDeleteError: null, apDeleted: false });
	        case _type.DELETE_AP_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { apIsDeleting: false, apDeleteError: null, apDeleted: true });
	        case _type.DELETE_AP_FAILURE:
	            // return error and make loading = false
	            var apDeleteError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { apIsDeleting: false, apDeleteError: apDeleteError, apDeleted: false });
	        case _type.EDIT_AP:
	            return _extends({}, state, { apIsEditing: true, apEditError: null, apEdited: false });
	        case _type.EDIT_AP_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { apIsEditing: false, apEditError: null, apEdited: true });
	        case _type.EDIT_AP_FAILURE:
	            // return error and make loading = false
	            var apEditError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            alert(JSON.stringify(apEditError));
	            return _extends({}, state, { apIsEditing: false, apEditError: apEditError, apEdited: false });
	
	        case _type.REQUEST_INVOICES:
	            return _extends({}, state, { invoices: null, invoicesError: null, invoicesIsLoading: true });
	        case _type.FETCH_INVOICES_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { invoices: action.payload.data, invoicesError: null, invoicesIsLoading: false });
	        case _type.FETCH_INVOICES_FAILURE:
	            // return error and make loading = false
	            var invoicesError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { invoices: null, invoicesError: invoicesError, invoicesIsLoading: false });
	        case _type.REQUEST_CREDITS:
	            return _extends({}, state, { credits: null, creditsError: null, creditsIsLoading: true });
	        case _type.FETCH_CREDITS_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { credits: action.payload.data, creditsError: null, creditsIsLoading: false });
	        case _type.FETCH_CREDITS_FAILURE:
	            // return error and make loading = false
	            var creditsError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { credits: null, creditsError: creditsError, creditsIsLoading: false });
	        case _type.CLEAR_CREDITS:
	            return _extends({}, state, { credits: null, creditsError: null, creditsIsLoading: false });
	        case _type.REQUEST_STATEMENT:
	            return _extends({}, state, { statements: [], statementsError: null, statementsIsLoading: true });
	        case _type.FETCH_STATEMENT_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { statements: action.payload.data, statementsError: null, statementsIsLoading: false });
	        case _type.FETCH_STATEMENT_FAILURE:
	            // return error and make loading = false
	            var statementsError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { statements: [], statementsError: statementsError, statementsIsLoading: false });
	
	        case _type.REQUEST_STATEMENT_AP:
	            return _extends({}, state, { statementsAP: [], statementsAPError: null, statementsAPIsLoading: true });
	        case _type.FETCH_STATEMENT_AP_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { statementsAP: action.payload.data, statementsAPError: null, statementsAPIsLoading: false });
	        case _type.FETCH_STATEMENT_AP_FAILURE:
	            // return error and make loading = false
	            var statementsAPError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { statementsAP: [], statementsAPError: statementsAPError, statementsAPIsLoading: false });
	
	        case _type.REQUEST_GENERAL_REPORT:
	            return _extends({}, state, { generalReport: [], generalReportError: null, generalReportIsLoading: true });
	        case _type.FETCH_GENERAL_REPORT_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { generalReport: action.payload.data, generalReportError: null, generalReportIsLoading: false });
	        case _type.FETCH_GENERAL_REPORT_FAILURE:
	            // return error and make loading = false
	            var generalReportError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { generalReport: [], generalReportError: generalReportError, generalReportIsLoading: false });
	
	        case _type.REQUEST_CITY_REPORT:
	            return _extends({}, state, {
	                cityReport: {
	                    reportData: [],
	                    cityReportIsLoading: true,
	                    cityReportError: null
	                }
	            });
	        case _type.FETCH_CITY_REPORT_SUCCESS:
	            return _extends({}, state, {
	                cityReport: {
	                    reportData: action.payload.data,
	                    cityReportIsLoading: false,
	                    cityReportError: null
	                }
	            });
	        case _type.FETCH_CITY_REPORT_FAILURE:
	            var cityReportError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, {
	                cityReport: {
	                    reportData: [],
	                    cityReportIsLoading: false,
	                    cityReportError: cityReportError
	                }
	            });
	        case _type.RESET_CITY_REPORT:
	            return _extends({}, state, {
	                cityReport: {
	                    reportData: [],
	                    cityReportIsLoading: false,
	                    cityReportError: null
	                }
	            });
	
	        case _type.REQUEST_CUSTOMER_STATEMENT:
	            return _extends({}, state, { customerStatement: [], customerStatementError: null, customerStatementIsLoading: true });
	        case _type.FETCH_CUSTOMER_STATEMENT_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { customerStatement: action.payload.data, customerStatementError: null, customerStatementIsLoading: false });
	        case _type.FETCH_CUSTOMER_STATEMENT_FAILURE:
	            // return error and make loading = false
	            var customerStatementError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { customerStatement: [], customerStatementError: customerStatementError, customerStatementIsLoading: false });
	        case _type.REQUEST_VENDOR_STATEMENT:
	            return _extends({}, state, { vendorStatement: [], vendorStatementError: null, vendorStatementIsLoading: true });
	        case _type.FETCH_VENDOR_STATEMENT_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { vendorStatement: action.payload.data, vendorStatementError: null, vendorStatementIsLoading: false });
	        case _type.FETCH_VENDOR_STATEMENT_FAILURE:
	            // return error and make loading = false
	            var vendorStatementError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { vendorStatement: [], vendorStatementError: vendorStatementError, vendorStatementIsLoading: false });
	        case _type.REQUEST_CUSTOMER_STATEMENT_LIST:
	            return _extends({}, state, { customerStatementList: [], customerStatementListError: null, customerStatementListIsLoading: true });
	        case _type.FETCH_CUSTOMER_STATEMENT_LIST_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { customerStatementList: action.payload.data, customerStatementListError: null, customerStatementListIsLoading: false });
	        case _type.FETCH_CUSTOMER_STATEMENT_LIST_FAILURE:
	            // return error and make loading = false
	            var customerStatementListError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { customerStatementList: [], customerStatementListError: customerStatementListError, customerStatementListIsLoading: false });
	        case _type.REQUEST_VENDOR_STATEMENT_LIST:
	            return _extends({}, state, { vendorStatementList: [], vendorStatementListError: null, vendorStatementListIsLoading: true });
	        case _type.FETCH_VENDOR_STATEMENT_LIST_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { vendorStatementList: action.payload.data, vendorStatementListError: null, vendorStatementListIsLoading: false });
	        case _type.FETCH_VENDOR_STATEMENT_LIST_FAILURE:
	            // return error and make loading = false
	            var vendorStatementListError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { vendorStatementList: [], vendorStatementListError: vendorStatementListError, vendorStatementListIsLoading: false });
	        case _type.REQUEST_MOBILE_CUSTOMER_STATEMENT:
	            return _extends({}, state, {
	                mobileCustomerStatement: {
	                    mobileCustomerStatement: {},
	                    mobileCustomerStatementError: null,
	                    mobileCustomerStatementIsLoading: true
	                }
	            });
	        case _type.FETCH_MOBILE_CUSTOMER_STATEMENT_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, {
	                mobileCustomerStatement: {
	                    mobileCustomerStatement: action.payload.data,
	                    mobileCustomerStatementError: null,
	                    mobileCustomerStatementIsLoading: false
	                }
	            });
	        case _type.FETCH_MOBILE_CUSTOMER_STATEMENT_FAILURE:
	            // return error and make loading = false
	            return _extends({}, state, {
	                mobileCustomerStatement: {
	                    mobileCustomerStatement: {},
	                    mobileCustomerStatementError: action.payload.data || { message: action.payload.message },
	                    mobileCustomerStatementIsLoading: false
	                }
	            });
	        case _type.RESET_MOBILE_CUSTOMER_STATEMENT:
	            return _extends({}, state, {
	                mobileCustomerStatement: {
	                    mobileCustomerStatement: {},
	                    mobileCustomerStatementError: null,
	                    mobileCustomerStatementIsLoading: false
	                }
	            });
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/arap_reducer.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/arap_reducer.jsx');
	}();

	;

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    authenticated: false,
	    isLoading: false,
	    error: null,
	    userType: null,
	    userPermissions: null
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _type.REQUEST_AUTH:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.AUTH_USER:
	            return _extends({}, state, { error: null, isLoading: false, authenticated: true, userType: action.payload });
	        case _type.AUTH_USER_PERMISSIONS:
	            return _extends({}, state, { authenticated: true, userPermissions: action.payload });
	        case _type.UNAUTH_USER:
	            return _extends({}, state, { error: null, isLoading: false, authenticated: false });
	
	        case _type.AUTH_ERROR:
	            return _extends({}, state, { error: action.payload, isLoading: false });
	
	        case _type.FETCH_MESSAGE:
	            return _extends({}, state, { message: action.payload.data.message });
	
	    }
	    return state;
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/auth_reducer.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/auth_reducer.js');
	}();

	;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	  salesOrderSuggestions: [],
	  salesOrderSuggestionsIsLoading: false,
	  salesOrderSuggestionsError: null,
	
	  purchaseOrderSuggestions: [],
	  purchaseOrderSuggestionsIsLoading: false,
	  purchaseOrderSuggestionsError: null,
	
	  productSuggestions: [],
	  productSuggestionsIsLoading: false,
	  productSuggestionsError: null
	};
	
	var _default = function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _type.FETCH_SALES_ORDER_SUGGESTIONS:
	      return _extends({}, state, { salesOrderSuggestionsIsLoading: true, salesOrderSuggestions: [], salesOrderSuggestionsError: null
	      });
	    case _type.FETCH_SALES_ORDER_SUGGESTIONS_SUCCESS:
	      console.log('payload: ', action.payload.data);
	      return _extends({}, state, { salesOrderSuggestionsIsLoading: false, salesOrderSuggestions: action.payload.data });
	    case _type.FETCH_SALES_ORDER_SUGGESTIONS_FAILURE:
	      return _extends({}, state, { salesOrderSuggestionsIsLoading: false, salesOrderSuggestionsError: action.payload.data });
	
	    case _type.FETCH_PURCHASE_ORDER_SUGGESTIONS:
	      return _extends({}, state, { purchaseOrderSuggestionsIsLoading: true, purchaseOrderSuggestions: [], purchaseOrderSuggestionsError: null
	      });
	    case _type.FETCH_PURCHASE_ORDER_SUGGESTIONS_SUCCESS:
	      return _extends({}, state, { purchaseOrderSuggestionsIsLoading: false, purchaseOrderSuggestions: action.payload.data });
	    case _type.FETCH_PURCHASE_ORDER_SUGGESTIONS_FAILURE:
	      return _extends({}, state, { purchaseOrderSuggestionsIsLoading: false, purchaseOrderSuggestions: action.payload.data });
	
	    case _type.FETCH_PRODUCT_SUGGESTIONS:
	      return _extends({}, state, { productSuggestionsIsLoading: true, productSuggestions: [], productSuggestionsError: null
	      });
	    case _type.FETCH_PRODUCT_SUGGESTIONS_SUCCESS:
	      return _extends({}, state, { productSuggestionsIsLoading: false, productSuggestions: action.payload.data });
	    case _type.FETCH_PRODUCT_SUGGESTIONS_FAILURE:
	      return _extends({}, state, { productSuggestionsIsLoading: false, productSuggestionsError: action.payload.data });
	
	    default:
	      return state;
	  }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/autoSuggest_reducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/autoSuggest_reducer.js');
	}();

	;

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	  confirmPasscodeModal: {
	    visibility: false,
	    verified: false
	  }
	};
	
	var _default = function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _type.SET_CONFIRM_PASSCODE_MODAL_VISIBILITY:
	      return _extends({}, state, {
	        confirmPasscodeModal: _extends({}, state.confirmPasscodeModal, {
	          visibility: action.payload
	        })
	      });
	    case _type.SET_PASSCODE_VERFICATION:
	      return _extends({}, state, {
	        confirmPasscodeModal: _extends({}, state.confirmPasscodeModal, {
	          verified: action.payload
	        })
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/baseModals_reducers.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/baseModals_reducers.js');
	}();

	;

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var initialState = {
	  category: 'all'
	};
	
	var _default = function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _type.CHOOSE_CATEGORY:
	      return _extends({}, state, {
	        category: action.payload
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/categoryAnalysis_reducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/categoryAnalysis_reducer.js');
	}();

	;

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	  all: [],
	  customerTotalPages: null,
	  customerTotalCount: null,
	  currentCustomer: null,
	  currentCustomerDetail: null,
	  isLoading: false,
	  error: null,
	  detailIsLoading: false,
	  detailError: null,
	  isCreating: false,
	  createError: null,
	  created: false,
	  isEditing: false,
	  editError: null,
	  edited: false,
	  customerCreditLines: [],
	  customerCreditLinesIsLoading: false,
	  customerCreditLinesError: null,
	  customersStatuses: [],
	  customersStatusesIsLoading: false,
	  customersStatusesError: null,
	  isAttachingDocument: false
	};
	
	var _default = function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _type.REQUEST_CUSTOMERS:
	      return _extends({}, state, { error: null, isLoading: true });
	    case _type.FETCH_CUSTOMERS_SUCCESS:
	      // return list of posts and make loading = false
	      return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	    // return error and make loading = false
	    case _type.FETCH_CUSTOMERS_FAILURE:
	      {
	        var error = action.payload || { message: action.payload.message }; // 2nd one is network or server down errors
	        alert(JSON.stringify(error));
	        return _extends({}, state, { all: [], error: error, isLoading: false });
	      }
	
	    case _type.REQUEST_CUSTOMERS_PAGINATE:
	      return _extends({}, state, { error: null, isLoading: true });
	    case _type.FETCH_CUSTOMERS_PAGINATE_SUCCESS:
	      return _extends({}, state, {
	        all: action.payload.data.record,
	        customerTotalPages: action.payload.data.pages,
	        customerTotalCount: action.payload.data.count,
	        error: null,
	        isLoading: false });
	    case _type.FETCH_CUSTOMERS_PAGINATE_FAILURE:
	      {
	        var _error = action.payload || { message: action.payload.message };
	        alert(JSON.stringify(_error));
	        return _extends({}, state, { all: [], error: _error, isLoading: false });
	      }
	
	    case _type.SELECT_CUSTOMER:
	      return _extends({}, state, { currentCustomer: action.payload });
	    case _type.RESET_CURRENT_CUSTOMER:
	      return _extends({}, state, { currentCustomer: null, currentCustomerDetail: null });
	    case _type.REQUEST_CREATING_CUSTOMER:
	      return _extends({}, state, { isCreating: true, createError: null, created: false });
	    case _type.CREATE_CUSTOMER_SUCCESS:
	      return _extends({}, state, { isCreating: false, createError: null, created: true });
	    case _type.CREATE_CUSTOMER_FAILURE:
	      {
	        var createError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	        alert(JSON.stringify(createError));
	        return _extends({}, state, { isCreating: false, createError: createError, created: false });
	      }
	    case _type.REQUEST_EDITING_CUSTOMER:
	      return _extends({}, state, { isEditing: true, editError: null, edited: false });
	    case _type.EDIT_CUSTOMER_SUCCESS:
	      return _extends({}, state, { isEditing: false, editError: null, edited: true });
	    // 2nd term stands for network or server down errors
	    case _type.EDIT_CUSTOMER_FAILURE:
	      {
	        var editError = action.payload.data || { message: action.payload.message };
	        alert(JSON.stringify(editError));
	        return _extends({}, state, { isEditing: false, editError: editError, edited: false });
	      }
	    case _type.REQUEST_CUSTOMER_DETAIL:
	      return _extends({}, state, { detailError: null, detailIsLoading: true });
	    // return list of posts and make loading = false
	    case _type.FETCH_CUSTOMER_DETAIL_SUCCESS:
	      return _extends({}, state, { currentCustomerDetail: action.payload.data, detailError: null, detailIsLoading: false });
	    // return error and make loading = false
	    case _type.FETCH_CUSTOMER_DETAIL_FAILURE:
	      {
	        var detailError = action.payload || { message: action.payload.message }; // 2nd one is network or server down errors
	        return _extends({}, state, { all: [], detailError: detailError, detailIsLoading: false });
	      }
	    case _type.REQUEST_CUSTOMER_CREDIT_BY_DATE:
	      return _extends({}, state, { customerCreditLinesIsLoading: true, customerCreditLinesError: null });
	    case _type.FETCH_CUSTOMER_CREDIT_BY_DATE_SUCCESS:
	      return _extends({}, state, { customerCreditLines: action.payload.data, customerCreditLinesIsLoading: false });
	    case _type.FETCH_CUSTOMER_CREDIT_BY_DATE_FAILURE:
	      {
	        var customerCreditLinesError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { customerCreditLinesError: customerCreditLinesError, customerCreditLinesIsLoading: false });
	      }
	    case _type.REQUEST_CUSTOMERS_STATUS:
	      return _extends({}, state, { customersStatuses: [], customersStatusesIsLoading: true, customersStatusesError: null });
	    case _type.FETCH_CUSTOMERS_STATUS_SUCCESS:
	      return _extends({}, state, { customersStatuses: action.payload.data, customersStatusesIsLoading: false });
	    case _type.FETCH_CUSTOMERS_STATUS_FAILURE:
	      {
	        var customersStatusesError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { customersStatusesError: customersStatusesError, customersStatusesIsLoading: false });
	      }
	    case _type.ATTACH_DOCUMENT:
	      return _extends({}, state, { isAttachingDocument: true, attachDocumentError: null, attachDocumentSuccess: false });
	    case _type.ATTACH_DOCUMENT_SUCCESS:
	      return _extends({}, state, { isAttachingDocument: false, attachDocumentError: null, attachDocumentSuccess: true });
	    case _type.ATTACH_DOCUMENT_FAILURE:
	      {
	        var attachDocumentError = action.payload.data || { message: action.payload.message };
	        alert(JSON.stringify(attachDocumentError));
	        return _extends({}, state, { isAttachingDocument: false, attachDocumentError: attachDocumentError, attachDocumentSuccess: false });
	      }
	    case _type.FETCH_SALES_INVOICE_DETAIL_SUCCESS:
	      return _extends({}, state, { currentSalesInvoice: action.payload.data, customersStatusesIsLoading: false });
	    default:
	      return state;
	  }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/customers_reducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/customers_reducer.js');
	}();

	;

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	  messages: [],
	  messagesIsLoading: false,
	  messagesError: null,
	
	  postingMessage: false,
	  postMessagesSuccess: null,
	  postMessageError: null,
	
	  consolodatedStatistics: null,
	  consolodatedStatisticsIsLoading: false,
	  consolodatedStatisticsError: null
	};
	
	var _default = function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    // Request for messages on General Dashboard
	    case _type.REQUEST_DASHBOARD_MESSAGES:
	      return _extends({}, state, { messages: [], messagesIsLoading: true, messagesError: null });
	    case _type.FETCH_DASHBOARD_MESSAGES_SUCCESS:
	      return _extends({}, state, { messagesIsLoading: false, messages: action.payload.data });
	    case _type.FETCH_DASHBOARD_MESSAGES_FAILURE:
	      return _extends({}, state, { messagesIsLoading: false, messagesError: action.payload.data });
	
	    // Request to post message
	    case _type.POST_DASHBOARD_MESSAGE:
	      return _extends({}, state, { postingMessage: true, postMessageError: null, postMessagesSuccess: null });
	    case _type.POST_MESSAGE_SUCCESS:
	      return _extends({}, state, { postingMessage: false, postMessagesSuccess: true, messages: action.payload.data });
	    case _type.POST_MESSAGE_FAILURE:
	      return _extends({}, state, { postingMessage: false, postMessageError: action.payload.data });
	
	    // Request for consolodated statistics
	    case _type.REQUEST_CONSOLIDATED_STATISTICS:
	      return _extends({}, state, { consolodatedStatisticsIsLoading: true, consolodatedStatistics: null, consolodatedStatisticsError: null });
	    case _type.FETCH_CONSOLODATED_STATISTICS_SUCCESS:
	      return _extends({}, state, { consolodatedStatisticsIsLoading: false, consolodatedStatistics: action.payload.data });
	    case _type.FETCH_CONSOLODATED_STATISTICS_FAILURE:
	      return _extends({}, state, { consolodatedStatisticsIsLoading: false, consolodatedStatisticsError: action.payload.data });
	
	    default:
	      return state;
	  }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/dashboard_reducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/dashboard_reducer.js');
	}();

	;

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    routes: [],
	    autoRoutes: [],
	    routesIsLoading: false,
	    routesError: null,
	    stops: [],
	    stopsIsLoading: false,
	    stopsError: null,
	    editStops: [],
	    editStopsIsLoading: false,
	    editStopsError: null,
	    savingStopEdits: false,
	    saveStopEditsSuccessful: null,
	    saveStopEditsFailure: null,
	    savingRouteEdits: false,
	    saveRouteEditsSuccessful: null,
	    saveRouteEditsFailure: null,
	    saveRouteEditsError: null,
	    salesOrders: [],
	    salesOrdersIsLoading: false,
	    salesOrdersError: null,
	    customerRoutes: [],
	    customerRoutesIsLoading: false,
	    customerRoutesError: null,
	    unassignedOrders: [],
	    unassignedOrdersIsLoading: false,
	    unassignedOrdersError: null,
	    assigningOrderRoute: false,
	    assignOrderRouteSuccess: null,
	    assignOrderRouteFailure: null,
	    convertingToInvoice: false,
	    convertToInvoiceSuccess: null,
	    convertToInvoiceFailure: null,
	    convertToInvoiceError: null,
	    refreshConvertingToInvoice: false,
	    savingEditedStops: false,
	    saveEditedStopsSuccess: null,
	    saveEditedStopsFailure: null,
	    savingNewRoute: false,
	    saveNewRouteSuccess: null,
	    saveNewRouteError: null,
	    routesPrinters: [],
	    savePrinterSuccess: false,
	    buttonLoadingVisible: false,
	    pdfFile: null
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _type.START_FETCHING_AUTO_ROUTES:
	            return _extends({}, state, { autoRoutes: [], stops: [] });
	        case _type.SAVE_ROUTES_PRINTER_SUCESS:
	            return _extends({}, state, { savePrinterSuccess: action.payload });
	        case _type.SET_AUTO_ROUTING_BUTTONS_LOADING:
	            return _extends({}, state, { buttonLoadingVisible: action.payload });
	        case _type.FETCH_ROUTES_PRINTER_SUCESS:
	            return _extends({}, state, { routesPrinters: action.payload });
	        case _type.REQUEST_ROUTES:
	            return _extends({}, state, { routesError: null, routesIsLoading: true });
	        case _type.FETCH_ROUTES_SUCCESS:
	            return _extends({}, state, { routes: action.payload.data, routesIsLoading: false });
	        case _type.FETCH_AUTO_ROUTES_SUCCESS:
	            return _extends({}, state, { autoRoutes: action.payload.data, routesIsLoading: false });
	        case _type.FETCH_ROUTES_FAILURE:
	            var routesError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { routesError: routesError, routesIsLoading: false });
	        case _type.REQUEST_STOPS:
	            return _extends({}, state, { stopsIsLoading: true, stopsError: false });
	        case _type.FETCH_STOPS_SUCCESS:
	            return _extends({}, state, { stops: action.payload.data, stopsIsLoading: false });
	        case _type.FETCH_STOPS_FAILURE:
	            var stopsError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { stopsError: stopsError, stopsIsLoading: false });
	        case _type.REQUEST_EDIT_STOPS:
	            return _extends({}, state, { editStopsIsLoading: true, editStopsError: null });
	        case _type.FETCH_EDIT_STOPS_SUCCESS:
	            return _extends({}, state, { editStops: action.payload.data, editStopsIsLoading: false });
	        case _type.FETCH_EDIT_STOPS_FAILURE:
	            var editStopsError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { editStopsError: editStopsError, editStopsIsLoading: false });
	        case _type.REQUEST_SAVE_EDITS:
	            return _extends({}, state, { savingStopEdits: true, saveStopEditsFailure: null, saveStopEditsSuccessful: null });
	        case _type.SAVE_EDITS_SUCCESS:
	            return _extends({}, state, { savingStopEdits: false, saveStopEditsSuccessful: true });
	        case _type.SAVE_EDITS_FAILURE:
	            var saveStopEditsFailure = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { savingStopEdits: false, saveStopEditsFailure: saveStopEditsFailure });
	        case _type.CLEAR_EDIT_STATUS:
	            return _extends({}, state, { saveStopEditsFailure: null, saveStopEditsSuccessful: null });
	        case _type.REQUEST_SALES_ORDERS_BY_DATE:
	            return _extends({}, state, { salesOrdersIsLoading: true, salesOrdersError: null });
	        case _type.FETCH_SALES_ORDERS_BY_DATE_SUCCESS:
	            return _extends({}, state, { salesOrders: action.payload.data, salesOrdersIsLoading: false });
	        case _type.FETCH_SALES_ORDERS_BY_DATE_FAILURE:
	            var salesOrdersError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { salesOrdersError: salesOrdersError, salesOrdersIsLoading: false });
	        case _type.REQUEST_CUSTOMER_ROUTES:
	            return _extends({}, state, { customerRoutesIsLoading: true, customerRoutesError: null });
	        case _type.FETCH_CUSTOMER_ROUTES_SUCCESS:
	            return _extends({}, state, { customerRoutes: action.payload.data, customerRoutesIsLoading: false });
	        case _type.FETCH_CUSTOMER_ROUTES_FAILURE:
	            var customerRoutesError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { customerRoutesError: customerRoutesError, customerRoutesIsLoading: false });
	        case _type.REQUEST_UNASSIGNED_ORDERS:
	            return _extends({}, state, { unassignedOrdersIsLoading: true, unassignedOrdersError: null });
	        case _type.FETCH_UNASSIGNED_ORDERS_SUCCESS:
	            return _extends({}, state, { unassignedOrders: action.payload.data, unassignedOrdersIsLoading: false });
	        case _type.FETCH_UNASSIGNED_ORDERS_FAILURE:
	            var unassignedOrdersError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { unassignedOrdersError: unassignedOrdersError, unassignedOrdersIsLoading: false });
	        case _type.REQUEST_ASSIGN_ORDER_ROUTE:
	            return _extends({}, state, { assigningOrderRoute: true, assignOrderRouteSuccess: null, assignOrderRouteFailure: null });
	        case _type.ASSIGN_ORDER_ROUTE_SUCCESS:
	            return _extends({}, state, { assigningOrderRoute: false, assignOrderRouteSuccess: true });
	        case _type.ASSIGN_ORDER_ROUTE_FAILURE:
	            return _extends({}, state, { assigningOrderRoute: false, assignOrderRouteFailure: true });
	        case _type.REQUEST_SAVE_ROUTE_EDITS:
	            return _extends({}, state, { savingRouteEdits: true, saveRouteEditsFailure: null, saveRouteEditsSuccessful: null });
	        case _type.SAVE_ROUTE_EDIT_SUCCESS:
	            return _extends({}, state, { savingRouteEdits: false, saveRouteEditsSuccessful: true });
	        case _type.SAVE_ROUTE_EDIT_FAILURE:
	            var saveRouteEditsError = action.payload.data || { message: action.payload.message };
	            alert(JSON.stringify(saveRouteEditsError));
	            return _extends({}, state, { savingRouteEdits: false, saveRouteEditsFailure: true, saveRouteEditsError: saveRouteEditsError });
	        case _type.REQUEST_CONVERT_TO_INVOICE:
	            return _extends({}, state, { convertingToInvoice: true, convertToInvoiceSuccess: null, convertToInvoiceFailure: null, refreshConvertingToInvoice: false, convertToInvoiceError: null });
	        case _type.CONVERT_TO_INVOICE_SUCCESS:
	            return _extends({}, state, { convertingToInvoice: false, convertToInvoiceSuccess: action.payload.data, refreshConvertingToInvoice: false, convertToInvoiceError: null });
	        case _type.CONVERT_TO_INVOICE_FAILURE:
	            var convertToInvoiceError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { convertingToInvoice: false, convertToInvoiceFailure: true, refreshConvertingToInvoice: false, convertToInvoiceError: convertToInvoiceError });
	        case _type.CLEAR_CONVERT_TO_INVOICE:
	            return _extends({}, state, { convertingToInvoice: false, convertToInvoiceFailure: null, convertToInvoiceSuccess: null, refreshConvertingToInvoice: true });
	        case _type.CONVERT_TO_INVOICE_RESET:
	            return _extends({}, state, { refreshConvertingToInvoice: true });
	        case _type.SAVE_EDITED_STOPS:
	            return _extends({}, state, { savingEditedStops: true, saveEditedStopsSuccess: false, saveEditedStopsFailure: false });
	        case _type.SAVE_EDITED_STOPS_SUCCESS:
	            return _extends({}, state, { savingEditedStops: false, saveEditedStopsSuccess: true, saveEditedStopsFailure: false });
	        case _type.SAVE_EDITED_STOPS_FAILURE:
	            var saveEditedStopsError = action.payload.data || { message: action.payload.message };
	            alert(JSON.stringify(saveEditedStopsError));
	            return _extends({}, state, { savingEditedStops: false, saveEditedStopsSuccess: true, saveEditedStopsFailure: true });
	        case _type.REQUEST_SAVE_NEW_ROUTES:
	            return _extends({}, state, {
	                savingNewRoute: true,
	                saveNewRouteSuccess: false,
	                saveNewRouteError: null
	            });
	        case _type.SAVE_NEW_ROUTES_SUCCESS:
	            return _extends({}, state, {
	                savingNewRoute: false,
	                saveNewRouteSuccess: true,
	                saveNewRouteError: null
	            });
	        case _type.SAVE_NEW_ROUTES_FAILURE:
	            {
	                var saveNewRouteError = action.payload.data || { message: action.payload.message };
	                alert(JSON.stringify(saveNewRouteError));
	                return _extends({}, state, {
	                    savingNewRoute: false,
	                    saveNewRouteSuccess: false,
	                    saveNewRouteError: saveNewRouteError
	                });
	            }
	        case 'AUTO_ROUTING/routePickingList':
	            return _extends({}, state, {
	                pdfFile: action.payload
	            });
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/dispatch_reducer.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/dispatch_reducer.jsx');
	}();

	;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    all: [],
	    currentFavorites: null,
	    currentFavoritesDetail: null,
	    isLoading: false,
	    error: null,
	    favoritesAreLoading: false,
	    favoritesError: null,
	    isCreating: false,
	    createError: null,
	    created: false,
	    isEditing: false,
	    editError: null,
	    edited: false,
	    customersWithFavorites: [],
	    customersWithFavoritesIsLoading: null,
	    customersWithFavoritesError: null,
	    inList: false
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	
	        // Favorites action handlers
	        case _type.REQUEST_CUSTOMER_FAVORITES:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.FETCH_CUSTOMER_FAVORITES_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	        case _type.FETCH_CUSTOMER_FAVORITES_FAILURE:
	            var error = action.payload || { message: action.payload.message };
	            return _extends({}, state, { all: [], error: error, isLoading: false });
	        case _type.SELECT_CUSTOMER_FAVORITES:
	            return _extends({}, state, { currentFavorites: action.payload });
	        case _type.RESET_CURRENT_CUSTOMER_FAVORITES:
	            return _extends({}, state, { currentFavorites: null });
	        case _type.REQUEST_CUSTOMER_FAVORITES_DETAIL:
	            return _extends({}, state, { favoritesError: null, favoritesAreLoading: true });
	        case _type.FETCH_CUSTOMER_FAVORITES_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { currentFavoritesDetail: action.payload.data, favoritesError: null, favoritesAreLoading: false });
	        case _type.FETCH_CUSTOMER_FAVORITES_DETAIL_FAILURE:
	            // return error and make loading = false
	            var favoritesError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { all: [], favoritesError: favoritesError, favoritesAreLoading: false });
	        case _type.REQUEST_ADDING_CUSTOMER_FAVORITE:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.ADD_CUSTOMER_FAVORITE_SUCCESS:
	            return _extends({}, state, { isLoading: false });
	        case _type.ADD_CUSTOMER_FAVORITE_FAILURE:
	            var favAddError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { error: favAddError, isLoading: false });
	        case _type.REQUEST_DELETE_CUSTOMER_FAVORITE:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.DELETE_CUSTOMER_FAVORITE_SUCCESS:
	            return _extends({}, state, { isLoading: false });
	        case _type.DELETE_CUSTOMER_FAVORITE_FAILURE:
	            return _extends({}, state, { error: error, isLoading: false });
	        case _type.REQUEST_CUSTOMERS_WITH_FAVORITES:
	            return _extends({}, state, { customersWithFavoritesError: null, customersWithFavoritesIsLoading: true });
	        case _type.FETCH_CUSTOMERS_WITH_FAVORITES_SUCCESS:
	            return _extends({}, state, { customersWithFavorites: action.payload.data, customersWithFavoritesError: null, customersWithFavoritesIsLoading: false });
	        case _type.FETCH_CUSTOMERS_WITH_FAVORITES_FAILURE:
	            var customersWithFavoritesError = action.payload;
	            return _extends({}, state, { all: [], customersWithFavoritesError: customersWithFavoritesError, customersWithFavoritesIsLoading: false });
	        case _type.ITEM_IN_LIST:
	            return _extends({}, state, { inList: true });
	        case _type.CLEAR_IN_LIST_ERROR:
	            return _extends({}, state, { inList: false });
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/favoriteList_reducer.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/favoriteList_reducer.jsx');
	}();

	;

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    all: [],
	    currentFavorites: null,
	    currentFavoritesDetail: null,
	    isLoading: false,
	    error: null,
	    favoritesAreLoading: false,
	    favoritesError: null,
	    isCreating: false,
	    createError: null,
	    created: false,
	    isEditing: false,
	    editError: null,
	    edited: false,
	    favoriteList: [],
	    favoriteListIsLoading: false,
	    favoriteListError: null,
	    saveFavoriteListSuccess: null,
	    saveFavoriteListError: null
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	
	        // Favorites action handlers
	        case _type.REQUEST_FAVORITES:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.FETCH_FAVORITES_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	        case _type.FETCH_FAVORITES_FAILURE:
	            var error = action.payload || { message: action.payload.message };
	            return _extends({}, state, { all: [], error: error, isLoading: false });
	        case _type.SELECT_FAVORITES:
	            return _extends({}, state, { currentFavorites: action.payload });
	        case _type.RESET_CURRENT_FAVORITES:
	            return _extends({}, state, { currentFavorites: null });
	        case _type.REQUEST_FAVORITES_DETAIL:
	            return _extends({}, state, { favoritesError: null, favoritesAreLoading: true });
	        case _type.FETCH_FAVORITES_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { currentFavoritesDetail: action.payload.data, favoritesError: null, favoritesAreLoading: false });
	        case _type.FETCH_FAVORITES_DETAIL_FAILURE:
	            // return error and make loading = false
	            var favoritesError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { all: [], favoritesError: favoritesError, favoritesAreLoading: false });
	        case _type.REQUEST_ADDING_FAVORITE:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.ADD_FAVORITE_SUCCESS:
	            return _extends({}, state, { isLoading: false });
	        case _type.ADD_FAVORITE_FAILURE:
	            return _extends({}, state, { error: error, isLoading: false });
	        case _type.REQUEST_DELETE_FAVORITE:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.DELETE_FAVORITE_SUCCESS:
	            return _extends({}, state, { isLoading: false });
	        case _type.DELETE_FAVORITE_FAILURE:
	            return _extends({}, state, { error: error, isLoading: false });
	        case _type.REQUEST_FAVORITE_LIST:
	            return _extends({}, state, { favoriteListIsLoading: true, favoriteList: [], favoriteListError: null });
	        case _type.FETCH_FAVORITE_LIST_SUCCESS:
	            return _extends({}, state, { favoriteListIsLoading: false, favoriteList: action.payload.data });
	        case _type.FETCH_FAVORITE_LIST_FAILURE:
	            var favoriteListError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { favoriteListIsLoading: false, favoriteListError: favoriteListError });
	        case _type.REQUEST_SAVE_FAVORITE_LIST:
	            return _extends({}, state, { saveFavoriteListSuccess: null, saveFavoriteListError: null });
	        case _type.SAVE_FAVORITE_LIST_SUCCESS:
	            return _extends({}, state, { saveFavoriteListSuccess: true });
	        case _type.SAVE_FAVORITE_LIST_FAILURE:
	            return _extends({}, state, { saveFavoriteListError: true });
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/favorites_reducer.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/favorites_reducer.js');
	}();

	;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    all: [],
	    isLoading: false,
	    error: null,
	    groups: [],
	    groupsIsLoading: null,
	    groupsError: null,
	    groupDetails: null,
	    groupDetailsIsLoading: false,
	    groupDetailsError: false,
	    saveProductListSuccess: false,
	    saveProductListFailure: false
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	
	        // Group action handlers
	        case _type.CREATE_GROUP_FAILURE:
	            var addGroupError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { error: addGroupError, isLoading: false, saveProductListSuccess: false, saveProductListFailure: false });
	        case _type.REQUEST_DELETE_GROUP:
	            return _extends({}, state, { error: null, isLoading: true, saveProductListSuccess: false, saveProductListFailure: false });
	        case _type.DELETE_GROUP_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false, saveProductListSuccess: false, saveProductListFailure: false });
	        case _type.DELETE_GROUP_FAILURE:
	            var deleteError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { all: [], error: deleteError, isLoading: false, saveProductListSuccess: false, saveProductListFailure: false });
	        case _type.REQUEST_CUSTOMER_GROUPS_DETAIL:
	            return _extends({}, state, { groupDetailsError: null, groupDetailsIsLoading: true, saveProductListSuccess: false, saveProductListFailure: false });
	        case _type.FETCH_CUSTOMER_GROUPS_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { groupDetails: action.payload.data, groupDetailsError: null, groupDetailsIsLoading: false, saveProductListSuccess: false, saveProductListFailure: false });
	        case _type.FETCH_CUSTOMER_GROUPS_DETAIL_FAILURE:
	            // return error and make loading = false
	            var groupDetailsError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { all: [], groupDetailsError: groupDetailsError, groupDetailsIsLoading: false, saveProductListSuccess: false, saveProductListFailure: false });
	        case _type.REQUEST_CUSTOMER_GROUPS:
	            return _extends({}, state, { groupsError: null, groupsIsLoading: true, saveProductListSuccess: false, saveProductListFailure: false });
	        case _type.FETCH_CUSTOMER_GROUPS_SUCCESS:
	            return _extends({}, state, { groups: action.payload.data, groupsError: null, groupsIsLoading: false, saveProductListSuccess: false, saveProductListFailure: false });
	        case _type.FETCH_CUSTOMER_GROUPS_FAILURE:
	            var groupsError = action.payload;
	            return _extends({}, state, { all: [], groupsError: groupsError, groupsIsLoading: false, saveProductListSuccess: false, saveProductListFailure: false });
	        case _type.SAVE_PRODUCT_LIST_SUCCESS:
	            return _extends({}, state, { saveProductListSuccess: true });
	        case _type.SAVE_PRODUCT_LIST_FAILURE:
	            return _extends({}, state, { saveProductListError: true });
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/groupList_reducer.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/groupList_reducer.jsx');
	}();

	;

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.rootEpic = undefined;
	
	var _reduxForm = __webpack_require__(3);
	
	var _reactReduxI18n = __webpack_require__(2);
	
	var _redux = __webpack_require__(206);
	
	var _reduxObservable = __webpack_require__(204);
	
	var _users_reducer = __webpack_require__(740);
	
	var _users_reducer2 = _interopRequireDefault(_users_reducer);
	
	var _products_reducer = __webpack_require__(722);
	
	var _products_reducer2 = _interopRequireDefault(_products_reducer);
	
	var _customers_reducer = __webpack_require__(702);
	
	var _customers_reducer2 = _interopRequireDefault(_customers_reducer);
	
	var _paymentTerms_reducer = __webpack_require__(717);
	
	var _paymentTerms_reducer2 = _interopRequireDefault(_paymentTerms_reducer);
	
	var _vendors_reducer = __webpack_require__(741);
	
	var _vendors_reducer2 = _interopRequireDefault(_vendors_reducer);
	
	var _agents_reducer = __webpack_require__(696);
	
	var _agents_reducer2 = _interopRequireDefault(_agents_reducer);
	
	var _purchaseQuotes_reducer = __webpack_require__(725);
	
	var _purchaseQuotes_reducer2 = _interopRequireDefault(_purchaseQuotes_reducer);
	
	var _purchaseSchedules_reducer = __webpack_require__(727);
	
	var _purchaseSchedules_reducer2 = _interopRequireDefault(_purchaseSchedules_reducer);
	
	var _purchaseTemplates_reducer = __webpack_require__(728);
	
	var _purchaseTemplates_reducer2 = _interopRequireDefault(_purchaseTemplates_reducer);
	
	var _purchaseReturns_reducer = __webpack_require__(726);
	
	var _purchaseReturns_reducer2 = _interopRequireDefault(_purchaseReturns_reducer);
	
	var _purchaseOrders_reducer = __webpack_require__(724);
	
	var _purchaseOrders_reducer2 = _interopRequireDefault(_purchaseOrders_reducer);
	
	var _inventories_reducer = __webpack_require__(709);
	
	var _inventories_reducer2 = _interopRequireDefault(_inventories_reducer);
	
	var _inventoryRelocations_reducer = __webpack_require__(712);
	
	var _inventoryRelocations_reducer2 = _interopRequireDefault(_inventoryRelocations_reducer);
	
	var _inventoryAdjustments_reducer = __webpack_require__(710);
	
	var _inventoryAdjustments_reducer2 = _interopRequireDefault(_inventoryAdjustments_reducer);
	
	var _inventoryRepackages_reducer = __webpack_require__(713);
	
	var _inventoryRepackages_reducer2 = _interopRequireDefault(_inventoryRepackages_reducer);
	
	var _inventoryConverts_reducer = __webpack_require__(711);
	
	var _inventoryConverts_reducer2 = _interopRequireDefault(_inventoryConverts_reducer);
	
	var _scrapRecords_reducer = __webpack_require__(735);
	
	var _scrapRecords_reducer2 = _interopRequireDefault(_scrapRecords_reducer);
	
	var _putAway_reducer = __webpack_require__(729);
	
	var _putAway_reducer2 = _interopRequireDefault(_putAway_reducer);
	
	var _receive_reducer = __webpack_require__(730);
	
	var _receive_reducer2 = _interopRequireDefault(_receive_reducer);
	
	var _warehouses_reducer = __webpack_require__(742);
	
	var _warehouses_reducer2 = _interopRequireDefault(_warehouses_reducer);
	
	var _zones_reducer = __webpack_require__(745);
	
	var _zones_reducer2 = _interopRequireDefault(_zones_reducer);
	
	var _salesOrders_reducer = __webpack_require__(734);
	
	var _salesOrders_reducer2 = _interopRequireDefault(_salesOrders_reducer);
	
	var _wholesale_reducer = __webpack_require__(744);
	
	var _wholesale_reducer2 = _interopRequireDefault(_wholesale_reducer);
	
	var _favoriteList_reducer = __webpack_require__(705);
	
	var _favoriteList_reducer2 = _interopRequireDefault(_favoriteList_reducer);
	
	var _groupList_reducer = __webpack_require__(707);
	
	var _groupList_reducer2 = _interopRequireDefault(_groupList_reducer);
	
	var _salesInvoice_reducer = __webpack_require__(733);
	
	var _salesInvoice_reducer2 = _interopRequireDefault(_salesInvoice_reducer);
	
	var _salesInvoicePayment_reducer = __webpack_require__(732);
	
	var _salesInvoicePayment_reducer2 = _interopRequireDefault(_salesInvoicePayment_reducer);
	
	var _wholesaleModal_reducer = __webpack_require__(743);
	
	var _wholesaleModal_reducer2 = _interopRequireDefault(_wholesaleModal_reducer);
	
	var _dispatch_reducer = __webpack_require__(704);
	
	var _dispatch_reducer2 = _interopRequireDefault(_dispatch_reducer);
	
	var _favorites_reducer = __webpack_require__(706);
	
	var _favorites_reducer2 = _interopRequireDefault(_favorites_reducer);
	
	var _previousOrders_reducer = __webpack_require__(720);
	
	var _previousOrders_reducer2 = _interopRequireDefault(_previousOrders_reducer);
	
	var _promotions_reducer = __webpack_require__(723);
	
	var _promotions_reducer2 = _interopRequireDefault(_promotions_reducer);
	
	var _arap_reducer = __webpack_require__(697);
	
	var _arap_reducer2 = _interopRequireDefault(_arap_reducer);
	
	var _settings_reducer = __webpack_require__(736);
	
	var _settings_reducer2 = _interopRequireDefault(_settings_reducer);
	
	var _dashboard_reducer = __webpack_require__(703);
	
	var _dashboard_reducer2 = _interopRequireDefault(_dashboard_reducer);
	
	var _auth_reducer = __webpack_require__(698);
	
	var _auth_reducer2 = _interopRequireDefault(_auth_reducer);
	
	var _pos_reducer = __webpack_require__(718);
	
	var _pos_reducer2 = _interopRequireDefault(_pos_reducer);
	
	var _print_reducer = __webpack_require__(721);
	
	var _print_reducer2 = _interopRequireDefault(_print_reducer);
	
	var _autoSuggest_reducer = __webpack_require__(699);
	
	var _autoSuggest_reducer2 = _interopRequireDefault(_autoSuggest_reducer);
	
	var _mobileManagement_reducer = __webpack_require__(715);
	
	var _mobileManagement_reducer2 = _interopRequireDefault(_mobileManagement_reducer);
	
	var _adjustmentInventory_reducer = __webpack_require__(695);
	
	var _adjustmentInventory_reducer2 = _interopRequireDefault(_adjustmentInventory_reducer);
	
	var _rma_reducers = __webpack_require__(731);
	
	var _rma_reducers2 = _interopRequireDefault(_rma_reducers);
	
	var _mmdriverReducer = __webpack_require__(714);
	
	var _mmdriverReducer2 = _interopRequireDefault(_mmdriverReducer);
	
	var _tracking_reducer = __webpack_require__(739);
	
	var _tracking_reducer2 = _interopRequireDefault(_tracking_reducer);
	
	var _categoryAnalysis_reducer = __webpack_require__(701);
	
	var _categoryAnalysis_reducer2 = _interopRequireDefault(_categoryAnalysis_reducer);
	
	var _baseModals_reducers = __webpack_require__(700);
	
	var _baseModals_reducers2 = _interopRequireDefault(_baseModals_reducers);
	
	var _preOrders_reducer = __webpack_require__(719);
	
	var _preOrders_reducer2 = _interopRequireDefault(_preOrders_reducer);
	
	var _shipToOrders_reducer = __webpack_require__(738);
	
	var _shipToOrders_reducer2 = _interopRequireDefault(_shipToOrders_reducer);
	
	var _shipFromOrders_reducer = __webpack_require__(737);
	
	var _shipFromOrders_reducer2 = _interopRequireDefault(_shipFromOrders_reducer);
	
	var _otherService_reducer = __webpack_require__(716);
	
	var _otherService_reducer2 = _interopRequireDefault(_otherService_reducer);
	
	var _autoSuggest_actions = __webpack_require__(72);
	
	var _purchaseOrderList_actions = __webpack_require__(111);
	
	var _salesOrderList_actions = __webpack_require__(140);
	
	var _salesPerformanceList_actions = __webpack_require__(141);
	
	var _purchasingPerformanceList_actions = __webpack_require__(138);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootEpic = exports.rootEpic = (0, _reduxObservable.combineEpics)(_autoSuggest_actions.SalesAutoSuggestEpic, _salesOrderList_actions.SalesOrderListEpic, _autoSuggest_actions.PurchaseAutoSuggestEpic, _autoSuggest_actions.ProductAutoSuggestEpic, _purchaseOrderList_actions.PurchaseOrderListEpic, _purchasingPerformanceList_actions.PurchasingPerformanceListEpic, _salesPerformanceList_actions.SalesPerformanceListEpic);
	
	var rootReducer = (0, _redux.combineReducers)({
	  // Dashboard
	  favorites: _favorites_reducer2.default,
	
	  // Ch 2
	  users: _users_reducer2.default,
	  products: _products_reducer2.default,
	  customers: _customers_reducer2.default,
	  paymentTerms: _paymentTerms_reducer2.default,
	  form: _reduxForm.reducer,
	  vendors: _vendors_reducer2.default,
	  agents: _agents_reducer2.default,
	  auth: _auth_reducer2.default,
	
	  // Ch 3
	  purchaseQuotes: _purchaseQuotes_reducer2.default,
	  purchaseTemplates: _purchaseTemplates_reducer2.default,
	  purchaseSchedules: _purchaseSchedules_reducer2.default,
	  purchaseReturns: _purchaseReturns_reducer2.default,
	  purchaseOrders: _purchaseOrders_reducer2.default,
	  trackingNote: _tracking_reducer2.default,
	
	  // Ch 4
	  salesOrders: _salesOrders_reducer2.default,
	  previousOrders: _previousOrders_reducer2.default,
	  promotions: _promotions_reducer2.default,
	  wholesale: _wholesale_reducer2.default,
	  customerFavorites: _favoriteList_reducer2.default,
	  customerGroups: _groupList_reducer2.default,
	  salesInvoice: _salesInvoice_reducer2.default,
	  salesInvoicePayment: _salesInvoicePayment_reducer2.default,
	  wholesaleModal: _wholesaleModal_reducer2.default,
	  pos: _pos_reducer2.default,
	  preOrders: _preOrders_reducer2.default,
	  shipToOrders: _shipToOrders_reducer2.default,
	  shipFromOrders: _shipFromOrders_reducer2.default,
	  otherService: _otherService_reducer2.default,
	
	  // Ch 5
	  inventories: _inventories_reducer2.default,
	  inventoryRelocations: _inventoryRelocations_reducer2.default,
	  inventoryAdjustments: _inventoryAdjustments_reducer2.default,
	  inventoryRepackages: _inventoryRepackages_reducer2.default,
	  inventoryConverts: _inventoryConverts_reducer2.default,
	  scrapRecords: _scrapRecords_reducer2.default,
	  putAway: _putAway_reducer2.default,
	  receives: _receive_reducer2.default,
	  warehouses: _warehouses_reducer2.default,
	  zones: _zones_reducer2.default,
	
	  categoryAnalysis: _categoryAnalysis_reducer2.default,
	
	  // Ch 6
	  dispatch: _dispatch_reducer2.default,
	
	  arap: _arap_reducer2.default,
	  settings: _settings_reducer2.default,
	  dashboard: _dashboard_reducer2.default,
	  print: _print_reducer2.default,
	  autoSuggest: _autoSuggest_reducer2.default,
	  mobileManagement: _mobileManagement_reducer2.default,
	  adjustment: _adjustmentInventory_reducer2.default,
	
	  rma: _rma_reducers2.default,
	  i18n: _reactReduxI18n.i18nReducer,
	
	  MMDrivers: _mmdriverReducer2.default,
	  baseModals: _baseModals_reducers2.default
	});
	
	var _default = rootReducer;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(rootEpic, 'rootEpic', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/index.js');
	
	  __REACT_HOT_LOADER__.register(rootReducer, 'rootReducer', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/index.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/index.js');
	}();

	;

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	  all: [],
	  currentInventory: null,
	  currentInventoryDetail: null,
	  isLoading: false,
	  error: null,
	  detailIsLoading: false,
	  detailError: null,
	  isCreating: false,
	  createError: null,
	  created: false,
	  isEditing: false,
	  editError: null,
	  edited: false,
	  lowStockInventories: null,
	  lowStockError: null,
	  lowStockIsLoading: false,
	  expiredInventories: null,
	  expiredError: null,
	  expiredIsLoading: false,
	  detailedInventories: [],
	  detailedInventoriesIsLoading: false,
	  detailedInventoriesError: null,
	  salesOrderInventory: [],
	  salesOrderInventoryIsLoading: false,
	  salesOrderInventoryError: null,
	  inventoriesByGroupIsLoading: false,
	  inventoriesByGroup: [],
	  inventoriesByGroupError: null,
	  inventoriesByCategoryIsLoading: false,
	  inventoriesByCategory: [],
	  inventoriesByCategoryError: null,
	  inventoriesByPeriod: null,
	  inventoriesByPeriodIsLoading: false,
	  inventoriesByPeriodError: null,
	  originPage: null,
	  nonZeroInventories: [],
	  nonZeroInventoriesIsLoading: false,
	  nonZeroInventoriesError: null,
	  lowInventoriesIsLoading: false,
	  lowInventories: null,
	  lowInventoriesError: null,
	  workingOrdersIsLoading: false,
	  workingOrders: null,
	  workingOrdersError: null,
	  inventoryHistory: [],
	  inventoryHistoryIsLoading: false,
	  inventoryHistoryError: null
	};
	
	var _default = function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    // Inventory action handlers
	    case _type.REQUEST_INVENTORIES:
	      return _extends({}, state, { all: null, error: null, isLoading: true
	      });
	    case _type.FETCH_INVENTORIES_SUCCESS:
	      return _extends({}, state, { all: action.payload.data, error: null, isLoading: false
	      });
	    case _type.FETCH_INVENTORIES_FAILURE:
	      var error = action.payload || { message: action.payload.message };
	      return _extends({}, state, { all: null, error: error, isLoading: false
	      });
	    case _type.CLEAR_INVENTORIES:
	      return _extends({}, state, { all: null, error: null, isLoading: false
	      });
	    case _type.REQUEST_LOW_STOCK_INVENTORIES:
	      return _extends({}, state, { all: null, lowStockError: null, lowStockIsLoading: true
	      });
	    case _type.FETCH_LOW_STOCK_INVENTORIES_SUCCESS:
	      return _extends({}, state, { lowStockInventories: action.payload.data, lowStockError: null, lowStockIsLoading: false
	      });
	    case _type.FETCH_LOW_STOCK_INVENTORIES_FAILURE:
	      var lowStockError = action.payload || { message: action.payload.message };
	      return _extends({}, state, { lowStockInventories: [], lowStockError: lowStockError, lowStockIsLoading: false
	      });
	    case _type.REQUEST_EXPIRED_INVENTORIES:
	      return _extends({}, state, { all: null, expiredError: null, expiredIsLoading: true
	      });
	    case _type.FETCH_EXPIRED_INVENTORIES_SUCCESS:
	      return _extends({}, state, { expiredInventories: action.payload.data, expiredError: null, expiredIsLoading: false
	      });
	    case _type.FETCH_EXPIRED_INVENTORIES_FAILURE:
	      var expiredError = action.payload || { message: action.payload.message };
	      return _extends({}, state, { expiredInventories: [], expiredError: expiredError, expiredIsLoading: false
	      });
	    case _type.SELECT_INVENTORY:
	      return _extends({}, state, { currentInventory: action.payload });
	    case _type.RESET_CURRENT_INVENTORY:
	      return _extends({}, state, { currentInventory: null });
	    case _type.REQUEST_INVENTORY_DETAIL:
	      return _extends({}, state, { detailError: null, detailIsLoading: true });
	    case _type.FETCH_INVENTORY_DETAIL_SUCCESS:
	      // return list of posts and make loading = false
	      return _extends({}, state, { currentInventoryDetail: action.payload.data, detailError: null, detailIsLoading: false
	      });
	    case _type.FETCH_INVENTORY_DETAIL_FAILURE:
	      // return error and make loading = false
	      var detailError = action.payload || { message: action.payload.message }; // 2nd one is network or server down errors
	      return _extends({}, state, { all: [], detailError: detailError, detailIsLoading: false
	      });
	    case _type.REQUEST_DETAILED_INVENTORIES:
	      return _extends({}, state, { detailedInventoriesIsLoading: true, detailedInventories: [], detailedInventoriesError: null
	      });
	    case _type.FETCH_DETAILED_INVENTORIES_SUCCESS:
	      return _extends({}, state, { detailedInventoriesIsLoading: false, detailedInventories: action.payload.data });
	    case _type.FETCH_DETAILED_INVENTORIES_FAILURE:
	      var detailedInventoriesError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { detailedInventoriesIsLoading: false, detailedInventoriesError: detailedInventoriesError });
	    case _type.REQUEST_SALES_ORDER_INVENTORY:
	      return _extends({}, state, { salesOrderInventoryIsLoading: true, salesOrderInventoryError: null, salesOrderInventory: []
	      });
	    case _type.FETCH_SALES_ORDER_INVENTORY_SUCCESS:
	      return _extends({}, state, { salesOrderInventoryIsLoading: false, salesOrderInventory: action.payload.data });
	    case _type.FETCH_SALES_ORDER_INVENTORY_FAILURE:
	      var salesOrderInventoryError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { salesOrderInventoryIsLoading: false, salesOrderInventoryError: salesOrderInventoryError });
	
	    case _type.REQUEST_INVENTORIES_BY_GROUP:
	      return _extends({}, state, { inventoriesByGroupIsLoading: true, inventoriesByGroup: [], inventoriesByGroupError: null
	      });
	    case _type.REQUEST_INVENTORIES_BY_GROUP_SUCCESS:
	      return _extends({}, state, { inventoriesByGroupIsLoading: false, inventoriesByGroup: action.payload.data });
	    case _type.REQUEST_INVENTORIES_BY_GROUP_FAILURE:
	      var inventoriesByGroupError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { inventoriesByGroupIsLoading: false, inventoriesByGroupError: inventoriesByGroupError });
	    case _type.REQUEST_INVENTORIES_BY_CATEGORY:
	      return _extends({}, state, { inventoriesByCategoryIsLoading: true, inventoriesByCategory: [], inventoriesByCategoryError: null
	      });
	    case _type.REQUEST_INVENTORIES_BY_CATEGORY_SUCCESS:
	      return _extends({}, state, { inventoriesByCategoryIsLoading: false, inventoriesByCategory: action.payload.data });
	    case _type.REQUEST_INVENTORIES_BY_CATEGORY_FAILURE:
	      var inventoriesByCategoryError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { inventoriesByCategoryIsLoading: false, inventoriesByCategoryError: inventoriesByCategoryError });
	    case _type.REQUEST_INVENTORIES_BY_PERIOD:
	      return _extends({}, state, { inventoriesByPeriodIsLoading: true, inventoriesByPeriod: null, inventoriesByPeriodError: null
	      });
	    case _type.FETCH_INVENTORIES_BY_PERIOD_SUCCESS:
	      return _extends({}, state, { inventoriesByPeriodIsLoading: false, inventoriesByPeriod: action.payload.data });
	    case _type.FETCH_INVENTORIES_BY_PERIOD_FAILURE:
	      var inventoriesByPeriodError = action.payload.data || { message: action.payload.message };
	      alert(JSON.stringify(inventoriesByPeriodError));
	      return _extends({}, state, { inventoriesByPeriodIsLoading: false, inventoriesByPeriodError: inventoriesByPeriodError });
	    case _type.REQUEST_NONZERO_INVENTORIES:
	      return _extends({}, state, { nonZeroInventoriesIsLoading: true, nonZeroInventories: [], nonZeroInventoriesError: null
	      });
	    case _type.FETCH_NONZERO_INVENTORIES_SUCCESS:
	      return _extends({}, state, { nonZeroInventoriesIsLoading: false, nonZeroInventories: action.payload.data });
	    case _type.FETCH_NONZERO_INVENTORIES_FAILURE:
	      var nonZeroInventoriesError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { nonZeroInventoriesIsLoading: false, nonZeroInventoriesError: nonZeroInventoriesError });
	
	    case _type.SET_ORIGIN_PAGE:
	      return _extends({}, state, { originPage: action.payload });
	    case _type.REQUEST_LOW_INVENTORIES:
	      return _extends({}, state, { lowInventoriesIsLoading: true, lowInventories: null, lowInventoriesError: null
	      });
	    case _type.FETCH_LOW_INVENTORIES_SUCCESS:
	      return _extends({}, state, { lowInventoriesIsLoading: false, lowInventories: action.payload.data, lowInventoriesError: null
	      });
	    case _type.FETCH_LOW_INVENTORIES_FAILURE:
	      var lowInventoriesError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { lowInventoriesIsLoading: false, lowInventories: null, lowInventoriesError: lowInventoriesError
	      });
	
	    case _type.REQUEST_WORKING_ORDERS:
	      return _extends({}, state, { workingOrdersIsLoading: true, workingOrders: null, workingOrdersError: null
	      });
	    case _type.FETCH_WORKING_ORDERS_SUCCESS:
	      return _extends({}, state, { workingOrdersIsLoading: false, workingOrders: action.payload.data, workingOrdersError: null
	      });
	    case _type.FETCH_WORKING_ORDERS_FAILURE:
	      var workingOrdersError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { workingOrdersIsLoading: false, workingOrders: null, workingOrdersError: workingOrdersError
	      });
	
	    case _type.FETCH_INVENTORY_HISTORY:
	      return _extends({}, state, { inventoryHistoryIsLoading: true, inventoryHistory: null, inventoryHistoryError: null
	      });
	    case _type.FETCH_INVENTORY_HISTORY_SUCCESS:
	      return _extends({}, state, { inventoryHistoryIsLoading: false, inventoryHistory: action.payload.data, inventoryHistoryError: null
	      });
	    case _type.FETCH_INVENTORY_HISTORY_FAILURE:
	      var inventoryHistoryError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { inventoryHistoryIsLoading: false, inventoryHistory: null, inventoryHistoryError: inventoryHistoryError
	      });
	
	    default:
	      return state;
	  }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/inventories_reducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/inventories_reducer.js');
	}();

	;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    all: [],
	    currentInventoryAdjustment: null,
	    currentInventoryAdjustmentDetail: null,
	    isLoading: false,
	    error: null,
	    detailIsLoading: false,
	    detailError: null,
	    isCreating: false,
	    createError: null,
	    created: false,
	    isEditing: false,
	    editError: null,
	    edited: false,
	    inventoryAdjustmentIsCreating: false,
	    inventoryAdjustmentCreateError: null,
	    inventoryAdjustmentCreated: false,
	    inventoryAdjustmentIsEditing: false,
	    inventoryAdjustmentEditError: null,
	    inventoryAdjustmentEdited: false,
	    quickInventoryAdjustmentIsEditing: false,
	    quickInventoryAdjustmentEditError: null,
	    quickInventoryAdjustmentEdited: false,
	    adjustmentDetail: null,
	    adjustmentDetailError: null,
	    adjustmentDetailIsLoading: false,
	    filters: {
	        start_date: '2000-12-07T08:00:00.000Z',
	        end_date: '2090-12-14T07:59:59.999Z'
	    },
	    filterUpdated: false,
	    inventoryBatchLogDetail: null,
	    receiveTableFilter: {
	        start_date: '2000-12-07T08:00:00.000Z',
	        end_date: '2090-12-14T07:59:59.999Z'
	    },
	    receiveTableFilterUpdated: false,
	    productReceiveHistory: null
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	
	        // Inventory Adjustment action handlers
	        case _type.RESET_RECEIVE_FILTER_WITH_NEW_ID:
	            return _extends({}, state, { receiveTableFilter: _extends({}, action.payload), receiveTableFilterUpdated: true });
	        case _type.FETCH_INVENTORIES_PRODUCT_RECEIVE_SUCCESS:
	            return _extends({}, state, { productReceiveHistory: action.payload, receiveTableFilterUpdated: false });
	        case _type.UPDATE_RECEIVE_TABLE_FILTER:
	            return _extends({}, state, { receiveTableFilter: _extends({}, state.receiveTableFilter, action.payload), receiveTableFilterUpdated: true });
	        case _type.RESET_FILTER_WITH_NEW_ID:
	            return _extends({}, state, { filters: action.payload, filterUpdated: true });
	        case _type.FETCH_INVENTORY_ADJUSTMENT_BATCH_LOG:
	            return _extends({}, state, { inventoryBatchLogDetail: action.payload });
	        case _type.UPDATE_INVENTORY_FILTER:
	            return _extends({}, state, { filters: _extends({}, state.filters, action.payload), filterUpdated: true });
	        case _type.FETCH_INVENTORIES_DETAILS_SUCCESS:
	            return _extends({}, state, { filterUpdated: false });
	        case _type.REQUEST_INVENTORY_ADJUSTMENTS:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.FETCH_INVENTORY_ADJUSTMENTS_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	        case _type.FETCH_INVENTORY_ADJUSTMENTS_FAILURE:
	            var error = action.payload || { message: action.payload.message };
	            return _extends({}, state, { all: [], error: error, isLoading: false });
	        case _type.REQUEST_INVENTORY_ADJUSTMENTS_DETAIL:
	            return _extends({}, state, { adjustmentDetail: null, adjustmentDetailError: null, adjustmentDetailIsLoading: true });
	        case _type.FETCH_INVENTORY_ADJUSTMENTS_DETAIL_SUCCESS:
	            return _extends({}, state, { adjustmentDetail: action.payload.data, adjustmentDetailError: null, adjustmentDetailIsLoading: false });
	        case _type.FETCH_INVENTORY_ADJUSTMENTS_DETAIL_FAILURE:
	            var adjustmentDetailError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { adjustmentDetail: null, adjustmentDetailError: adjustmentDetailError, adjustmentDetailIsLoading: false });
	        case _type.SELECT_INVENTORY_ADJUSTMENT:
	            return _extends({}, state, { currentInventoryAdjustment: action.payload });
	        case _type.RESET_CURRENT_INVENTORY_ADJUSTMENT:
	            return _extends({}, state, { currentInventoryAdjustment: null, currentInventoryAdjustmentDetail: null });
	        case _type.REQUEST_INVENTORY_ADJUSTMENT_DETAIL:
	            return _extends({}, state, { detailError: null, detailIsLoading: true });
	        case _type.FETCH_INVENTORY_ADJUSTMENT_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { currentInventoryAdjustmentDetail: action.payload, detailError: null, detailIsLoading: false });
	        case _type.FETCH_INVENTORY_ADJUSTMENT_DETAIL_FAILURE:
	            // return error and make loading = false
	            var detailError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { all: [], detailError: detailError, detailIsLoading: false });
	        case _type.REQUEST_CREATING_INVENTORY_ADJUSTMENTS:
	            return _extends({}, state, { inventoryAdjustmentIsCreating: true, inventoryAdjustmentCreateError: null, inventoryAdjustmentCreated: false });
	        case _type.CREATE_INVENTORY_ADJUSTMENTS_SUCCESS:
	            return _extends({}, state, { inventoryAdjustmentIsCreating: false, inventoryAdjustmentCreateError: null, inventoryAdjustmentCreated: true });
	        case _type.CREATE_INVENTORY_ADJUSTMENTS_FAILURE:
	            var inventoryAdjustmentCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { inventoryAdjustmentIsCreating: false, inventoryAdjustmentCreateError: inventoryAdjustmentCreateError, inventoryAdjustmentCreated: false });
	        case _type.REQUEST_EDITING_INVENTORY_ADJUSTMENTS:
	            return _extends({}, state, { inventoryAdjustmentIsEditing: true, inventoryAdjustmentEditError: null, inventoryAdjustmentEdited: false });
	        case _type.EDIT_INVENTORY_ADJUSTMENTS_SUCCESS:
	            return _extends({}, state, { inventoryAdjustmentIsEditing: false, inventoryAdjustmentEditError: null, inventoryAdjustmentEdited: true });
	        case _type.EDIT_INVENTORY_ADJUSTMENTS_FAILURE:
	            var inventoryAdjustmentEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { inventoryAdjustmentIsEditing: false, inventoryAdjustmentEditError: inventoryAdjustmentEditError, inventoryAdjustmentEdited: false });
	        case _type.REQUEST_QUICK_INVENTORY_ADJUSTMENTS:
	            return _extends({}, state, { quickInventoryAdjustmentIsEditing: true, quickInventoryAdjustmentEditError: null, quickInventoryAdjustmentEdited: false });
	        case _type.QUICK_INVENTORY_ADJUSTMENTS_SUCCESS:
	            return _extends({}, state, { quickInventoryAdjustmentIsEditing: false, quickInventoryAdjustmentEditError: null, quickInventoryAdjustmentEdited: true });
	        case _type.QUICK_INVENTORY_ADJUSTMENTS_FAILURE:
	            var quickInventoryAdjustmentEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { quickInventoryAdjustmentIsEditing: false, quickInventoryAdjustmentEditError: quickInventoryAdjustmentEditError, quickInventoryAdjustmentEdited: false });
	        case _type.RESET_QUICK_INVENTORY_ADJUSTMENTS:
	            return _extends({}, state, { quickInventoryAdjustmentIsEditing: false, quickInventoryAdjustmentEditError: null, quickInventoryAdjustmentEdited: false });
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/inventoryAdjustments_reducer.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/inventoryAdjustments_reducer.js');
	}();

	;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    all: [],
	    currentInventoryConvert: null,
	    currentInventoryConvertDetail: null,
	    isLoading: false,
	    error: null,
	    detailIsLoading: false,
	    detailError: null,
	    isCreating: false,
	    createError: null,
	    created: false,
	    isEditing: false,
	    editError: null,
	    edited: false,
	
	    inventories: null,
	    inventoriesIsLoading: false,
	    inventoriesError: null,
	    inventoryConvertIsCreating: false,
	    inventoryConvertCreateError: null,
	    inventoryConvertCreated: false,
	    inventoryConvertIsEditing: false,
	    inventoryConvertEditError: null,
	    inventoryConvertEdited: false
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	
	        // Inventory Relocation action handlers
	        case _type.REQUEST_INVENTORY_CONVERTS:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.FETCH_INVENTORY_CONVERTS_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	        case _type.FETCH_INVENTORY_CONVERTS_FAILURE:
	            var error = action.payload || { message: action.payload.message };
	            return _extends({}, state, { all: [], error: error, isLoading: false });
	        case _type.SELECT_INVENTORY_CONVERT:
	            return _extends({}, state, { currentInventoryConvert: action.payload });
	        case _type.RESET_CURRENT_INVENTORY_CONVERT:
	            return _extends({}, state, { currentInventoryConvert: null, currentInventoryConvertDetail: null, inventories: null });
	        case _type.REQUEST_INVENTORY_CONVERT_DETAIL:
	            return _extends({}, state, { detailError: null, detailIsLoading: true });
	        case _type.FETCH_INVENTORY_CONVERT_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { currentInventoryConvertDetail: action.payload, currentInventoryConvert: null, detailError: null, detailIsLoading: false });
	        case _type.FETCH_INVENTORY_CONVERT_DETAIL_FAILURE:
	            // return error and make loading = false
	            var detailError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { all: [], detailError: detailError, detailIsLoading: false });
	        case _type.REQUEST_INVENTORIES_BIN:
	            return _extends({}, state, { inventoriesError: null, inventoriesIsLoading: true });
	        case _type.FETCH_INVENTORIES_BIN_SUCCESS:
	            return _extends({}, state, { inventories: action.payload.data, inventoriesError: null, inventoriesIsLoading: false });
	        case _type.FETCH_INVENTORIES_BIN_FAILURE:
	            var inventoriesError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { inventories: [], inventoriesError: inventoriesError, inventoriesIsLoading: false });
	        // case REQUEST_CREATING_INVENTORY_CONVERT:
	        //     return { ...state, inventoryConvertIsCreating: true, inventoryConvertCreateError: null, inventoryConvertCreated: false };
	        // case CREATE_INVENTORY_CONVERT_SUCCESS:
	        //     return { ...state, inventoryConvertIsCreating: false, inventoryConvertCreateError: null, inventoryConvertCreated: true };
	        // case CREATE_INVENTORY_CONVERT_FAILURE:
	        //     const inventoryConvertCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	        //     return { ...state, inventoryConvertIsCreating: false, inventoryConvertCreateError: inventoryConvertCreateError, inventoryConvertCreated: false };
	        case _type.REQUEST_EDITING_INVENTORY_CONVERT:
	            return _extends({}, state, { inventoryConvertIsEditing: true, inventoryConvertEditError: null, inventoryConvertEdited: false });
	        case _type.EDIT_INVENTORY_CONVERT_SUCCESS:
	            return _extends({}, state, { inventoryConvertIsEditing: false, inventoryConvertEditError: null, inventoryConvertEdited: true });
	        case _type.EDIT_INVENTORY_CONVERT_FAILURE:
	            var inventoryConvertEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { inventoryConvertIsEditing: false, inventoryConvertEditError: inventoryConvertEditError, inventoryConvertEdited: false });
	        case _type.REQUEST_NEW_CONVERT:
	            return _extends({}, state, { inventoryConvertIsCreating: true, inventoryConvertCreated: false });
	        case _type.NEW_CONVERT_SUCCESS:
	            return _extends({}, state, { inventoryConvertIsCreating: false, inventoryConvertCreated: true });
	        case _type.NEW_CONVERT_FAILURE:
	            var inventoryConvertCreateError = action.payload.data || { message: action.payload.message };
	            alert(JSON.stringify(inventoryConvertCreateError));
	            return _extends({}, state, { inventoryConvertIsCreating: false, inventoryConvertCreated: false });
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/inventoryConverts_reducer.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/inventoryConverts_reducer.js');
	}();

	;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    all: [],
	    currentInventoryRelocation: null,
	    currentInventoryRelocationDetail: null,
	    isLoading: false,
	    error: null,
	    detailIsLoading: false,
	    detailError: null,
	    isCreating: false,
	    createError: null,
	    created: false,
	    isEditing: false,
	    editError: null,
	    edited: false,
	    inventoryRelocationIsCreating: false,
	    inventoryRelocationCreateError: null,
	    inventoryRelocationCreated: false,
	    inventoryRelocationIsEditing: false,
	    inventoryRelocationEditError: null,
	    inventoryRelocationEdited: false
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	
	        // Inventory Relocation action handlers
	        case _type.REQUEST_INVENTORY_RELOCATIONS:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.FETCH_INVENTORY_RELOCATIONS_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	        case _type.FETCH_INVENTORY_RELOCATIONS_FAILURE:
	            var error = action.payload || { message: action.payload.message };
	            return _extends({}, state, { all: [], error: error, isLoading: false });
	        case _type.SELECT_INVENTORY_RELOCATION:
	            return _extends({}, state, { currentInventoryRelocation: action.payload });
	        case _type.RESET_CURRENT_INVENTORY_RELOCATION:
	            return _extends({}, state, { currentInventoryRelocation: null, currentInventoryRelocationDetail: null });
	        case _type.REQUEST_INVENTORY_RELOCATION_DETAIL:
	            return _extends({}, state, { detailError: null, detailIsLoading: true });
	        case _type.FETCH_INVENTORY_RELOCATION_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { currentInventoryRelocationDetail: action.payload, detailError: null, detailIsLoading: false });
	        case _type.FETCH_INVENTORY_RELOCATION_DETAIL_FAILURE:
	            // return error and make loading = false
	            var detailError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { all: [], detailError: detailError, detailIsLoading: false });
	        case _type.REQUEST_CREATING_INVENTORY_RELOCATION:
	            return _extends({}, state, { inventoryRelocationIsCreating: true, inventoryRelocationCreateError: null, inventoryRelocationCreated: false });
	        case _type.CREATE_INVENTORY_RELOCATION_SUCCESS:
	            return _extends({}, state, { inventoryRelocationIsCreating: false, inventoryRelocationCreateError: null, inventoryRelocationCreated: true });
	        case _type.CREATE_INVENTORY_RELOCATION_FAILURE:
	            var inventoryRelocationCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { inventoryRelocationIsCreating: false, inventoryRelocationCreateError: inventoryRelocationCreateError, inventoryRelocationCreated: false });
	        case _type.REQUEST_EDITING_INVENTORY_RELOCATION:
	            return _extends({}, state, { inventoryRelocationIsEditing: true, inventoryRelocationEditError: null, inventoryRelocationEdited: false });
	        case _type.EDIT_INVENTORY_RELOCATION_SUCCESS:
	            return _extends({}, state, { inventoryRelocationIsEditing: false, inventoryRelocationEditError: null, inventoryRelocationEdited: true });
	        case _type.EDIT_INVENTORY_RELOCATION_FAILURE:
	            var inventoryRelocationEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { inventoryRelocationIsEditing: false, inventoryRelocationEditError: inventoryRelocationEditError, inventoryRelocationEdited: false });
	
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/inventoryRelocations_reducer.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/inventoryRelocations_reducer.js');
	}();

	;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    all: [],
	    currentInventoryRepackage: null,
	    currentInventoryRepackageDetail: null,
	    isLoading: false,
	    error: null,
	    detailIsLoading: false,
	    detailError: null,
	    isCreating: false,
	    createError: null,
	    created: false,
	    isEditing: false,
	    editError: null,
	    edited: false,
	    inventoryRepackageIsCreating: false,
	    inventoryRepackageCreateError: null,
	    inventoryRepackageCreated: false,
	    inventoryRepackageIsEditing: false,
	    inventoryRepackageEditError: null,
	    inventoryRepackageEdited: false
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	
	        // Inventory Relocation action handlers
	        case _type.REQUEST_INVENTORY_REPACKAGES:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.FETCH_INVENTORY_REPACKAGES_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	        case _type.FETCH_INVENTORY_REPACKAGES_FAILURE:
	            var error = action.payload || { message: action.payload.message };
	            return _extends({}, state, { all: [], error: error, isLoading: false });
	        case _type.SELECT_INVENTORY_REPACKAGE:
	            return _extends({}, state, { currentInventoryRepackage: action.payload });
	        case _type.RESET_CURRENT_INVENTORY_REPACKAGE:
	            return _extends({}, state, { currentInventoryRepackage: null, currentInventoryRepackageDetail: null });
	        case _type.REQUEST_INVENTORY_REPACKAGE_DETAIL:
	            return _extends({}, state, { detailError: null, detailIsLoading: true });
	        case _type.FETCH_INVENTORY_REPACKAGE_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { currentInventoryRepackageDetail: action.payload, detailError: null, detailIsLoading: false });
	        case _type.FETCH_INVENTORY_REPACKAGE_DETAIL_FAILURE:
	            // return error and make loading = false
	            var detailError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { all: [], detailError: detailError, detailIsLoading: false });
	        case _type.REQUEST_CREATING_INVENTORY_REPACKAGE:
	            return _extends({}, state, { inventoryRepackageIsCreating: true, inventoryRepackageCreateError: null, inventoryRepackageCreated: false });
	        case _type.CREATE_INVENTORY_REPACKAGE_SUCCESS:
	            return _extends({}, state, { inventoryRepackageIsCreating: false, inventoryRepackageCreateError: null, inventoryRepackageCreated: true });
	        case _type.CREATE_INVENTORY_REPACKAGE_FAILURE:
	            var inventoryRepackageCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { inventoryRepackageIsCreating: false, inventoryRepackageCreateError: inventoryRepackageCreateError, inventoryRepackageCreated: false });
	        case _type.REQUEST_EDITING_INVENTORY_REPACKAGE:
	            return _extends({}, state, { inventoryRepackageIsEditing: true, inventoryRepackageEditError: null, inventoryRepackageEdited: false });
	        case _type.EDIT_INVENTORY_REPACKAGE_SUCCESS:
	            return _extends({}, state, { inventoryRepackageIsEditing: false, inventoryRepackageEditError: null, inventoryRepackageEdited: true });
	        case _type.EDIT_INVENTORY_REPACKAGE_FAILURE:
	            var inventoryRepackageEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { inventoryRepackageIsEditing: false, inventoryRepackageEditError: inventoryRepackageEditError, inventoryRepackageEdited: false });
	
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/inventoryRepackages_reducer.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/inventoryRepackages_reducer.js');
	}();

	;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //import type
	
	
	var _type = __webpack_require__(14);
	
	//initial state
	var initialState = {
	  drivers: [],
	  driver: {}
	  //  driverUpdated: false
	
	
	  //export reducer
	};
	var _default = function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _type.FETCH_MMDRIVERS:
	      return _extends({}, state, {
	        drivers: action.payload
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/mmdriver-reducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/mmdriver-reducer.js');
	}();

	;

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	  productList: [],
	  productListIsLoading: false,
	  productListError: null,
	  isGreatDealsUpdating: false,
	  isGreatDealsUpdated: false,
	  updateGreatDealsError: null,
	  isNewArrivalsUpdating: false,
	  isNewArrivalsUpdated: false,
	  updateNewArrivalsError: null,
	  billboardImagesList: [],
	  billboardImagesIsLoading: false,
	  billboardImagesError: null,
	  savingBillboardImages: false,
	  saveBillboardImagesSuccess: false,
	  saveBillboardImagesError: null,
	  deletingBillboardImage: false,
	  deleteBillboardImageSuccess: false,
	  deleteBillboardImageError: null
	};
	
	var _default = function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _type.FETCH_GREAT_DEALS_NEW_ARRIVALS:
	      return _extends({}, state, {
	        productList: [],
	        productListIsLoading: true,
	        productListError: null
	      });
	    case _type.FETCH_GREAT_DEALS_NEW_ARRIVALS_SUCCESS:
	      return _extends({}, state, {
	        productList: action.payload.data,
	        productListIsLoading: false,
	        productListError: null
	      });
	    case _type.FETCH_GREAT_DEALS_NEW_ARRIVALS_FAILURE:
	      {
	        var productListError = action.payload.data || { message: action.payload.message };
	        alert(JSON.stringify(productListError));
	        return _extends({}, state, {
	          productList: [],
	          productListIsLoading: false,
	          productListError: productListError
	        });
	      }
	    case _type.UPDATE_GREAT_DEALS:
	      return _extends({}, state, {
	        isGreatDealsUpdating: true,
	        isGreatDealsUpdated: false,
	        updateGreatDealsError: null
	      });
	    case _type.UPDATE_GREAT_DEALS_SUCCESS:
	      return _extends({}, state, {
	        isGreatDealsUpdating: false,
	        isGreatDealsUpdated: true,
	        updateGreatDealsError: null
	      });
	    case _type.UPDATE_GREAT_DEALS_FAILURE:
	      {
	        var updateGreatDealsError = action.payload.data || { message: action.payload.message };
	        alert(JSON.stringify(updateGreatDealsError));
	        return _extends({}, state, {
	          isGreatDealsUpdating: false,
	          isGreatDealsUpdated: false,
	          updateGreatDealsError: updateGreatDealsError
	        });
	      }
	    case _type.UPDATE_NEW_ARRIVALS:
	      return _extends({}, state, {
	        isNewArrivalsUpdating: true,
	        isNewArrivalsUpdated: false,
	        updateNewArrivalsError: null
	      });
	    case _type.UPDATE_NEW_ARRIVALS_SUCCESS:
	      return _extends({}, state, {
	        isNewArrivalsUpdating: false,
	        isNewArrivalsUpdated: true,
	        updateNewArrivalsError: null
	      });
	    case _type.UPDATE_NEW_ARRIVALS_FAILURE:
	      {
	        var updateNewArrivalsError = action.payload.data || { message: action.payload.message };
	        alert(JSON.stringify(updateNewArrivalsError));
	        return _extends({}, state, {
	          isNewArrivalsUpdating: false,
	          isNewArrivalsUpdated: false,
	          updateNewArrivalsError: updateNewArrivalsError
	        });
	      }
	    case _type.FETCH_BILLBOARD_IMAGES:
	      return _extends({}, state, {
	        billboardImagesList: [],
	        billboardImagesIsLoading: true,
	        billboardImagesError: null
	      });
	    case _type.FETCH_BILLBOARD_IMAGES_SUCCESS:
	      return _extends({}, state, {
	        billboardImagesList: action.payload.data,
	        billboardImagesIsLoading: false,
	        billboardImagesError: null
	      });
	    case _type.FETCH_BILLBOARD_IMAGES_FAILURE:
	      {
	        var billboardImagesError = action.payload.data || { message: action.payload.message };
	        alert(JSON.stringify(billboardImagesError));
	        return _extends({}, state, {
	          billboardImagesList: [],
	          billboardImagesIsLoading: false,
	          billboardImagesError: null
	        });
	      }
	    case _type.SAVE_BILLBOARD_IMAGES:
	      return {
	        savingBillboardImages: true,
	        saveBillboardImagesSuccess: false,
	        saveBillboardImagesError: null
	      };
	    case _type.SAVE_BILLBOARD_IMAGES_SUCCESS:
	      return {
	        savingBillboardImages: false,
	        saveBillboardImagesSuccess: true,
	        saveBillboardImagesError: null
	      };
	    case _type.SAVE_BILLBOARD_IMAGES_FAILURE:
	      {
	        var saveBillboardImagesError = action.payload.data || { message: action.payload.message };
	        alert(JSON.stringify(saveBillboardImagesError));
	        return {
	          savingBillboardImages: false,
	          saveBillboardImagesSuccess: false,
	          saveBillboardImagesError: saveBillboardImagesError
	        };
	      }
	    case _type.DELETE_BILLBOARD_IMAGE:
	      return {
	        deletingBillboardImage: true,
	        deleteBillboardImageSuccess: false,
	        deleteBillboardImageError: null
	      };
	    case _type.DELETE_BILLBOARD_IMAGE_SUCCESS:
	      return {
	        deletingBillboardImage: false,
	        deleteBillboardImageSuccess: true,
	        deleteBillboardImageError: null
	      };
	    case _type.DELETE_BILLBOARD_IMAGE_FAILURE:
	      {
	        var deleteBillboardImageError = action.payload.data || { message: action.payload.message };
	        alert(JSON.stringify(deleteBillboardImageError));
	        return {
	          deletingBillboardImage: false,
	          deleteBillboardImageSuccess: false,
	          deleteBillboardImageError: deleteBillboardImageError
	        };
	      }
	    default:
	      return state;
	  }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/mobileManagement_reducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/mobileManagement_reducer.js');
	}();

	;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	  msoTotalPages: null,
	  all: null,
	  currentSalesOrder: null,
	  currentSalesOrderDetail: null,
	  currentSalesOrderDetailByNum: null,
	  isLoading: true,
	  error: null,
	  detailIsLoading: false,
	  detailByNumIsLoading: false,
	  detailError: null,
	  detailByNumError: null,
	  salesOrderIsCreating: false,
	  salesOrderCreateError: null,
	  salesOrderCreated: false,
	  salesOrderIsEditing: false,
	  salesOrderEditError: null,
	  salesOrderEdited: false,
	  customerOrderSchedules: [],
	  customerOrderSchedulesIsLoading: false,
	  customerOrderSchedulesError: null,
	  todaysOutgoingOrders: [],
	  todaysOutgoingOrdersIsLoading: null,
	  todaysOutgoingOrdersError: null,
	  salesOrderLineWeights: [],
	  salesOrderLineWeightsIsLoading: false,
	  salesOrderLineWeightsError: null,
	  salesOrderLineWeightsIsEditing: false,
	  editSalesOrderLineWeightsError: null,
	  editSalesOrderLineWeightsSuccess: false,
	  printForm: null,
	  printFormIsLoading: false,
	  printFormError: null,
	  csv: null,
	  csvIsLoading: false,
	  csvError: null,
	  SavingPosSale: false,
	  SavePosSaleSuccessful: null,
	  SavePosSaleFailure: null,
	  SavePosError: null,
	  InvalidCharacterEntered: false,
	  ChargeNotMet: false,
	  RequestingDraft: null,
	  DraftDetails: null,
	  DraftError: null,
	  drafts: null,
	  draftsIsLoading: null,
	  draftsError: null,
	  customerPricesIsLoading: false,
	  customerPricesError: null,
	  customerPrices: [],
	  currencyRates: null,
	  currencyRatesIsLoading: false,
	  currencyRatesError: null,
	  multiCurrenciesIsEditing: false,
	  multiCurrenciesEdited: false,
	  multiCurrenciesEditError: null,
	  taxRates: null,
	  taxRatesIsLoading: false,
	  taxRatesError: null,
	  creatingTaxRate: false,
	  createTaxRateError: null,
	  createTaxRateSuccess: null,
	  multiTaxesIsEditing: false,
	  multiTaxesEdited: false,
	  multiTaxesEditError: null,
	  taxIsDeleting: false,
	  taxDeleted: false,
	  taxDeleteError: null,
	  overallSales: [],
	  overallSalesIsLoading: false,
	  overallSalesError: null,
	  posReport: [],
	  posReportIsLoading: false,
	  posReportError: null,
	  salesInventoryInfo: [],
	  salesInventoryInfoIsLoading: false,
	  salesInventoryInfoError: null,
	  salesCustomerDetails: null,
	  salesShippingCustomerDetails: null,
	  salesCustomerDetailsIsLoading: false,
	  allShipping: null,
	  allShippingIsLoading: false,
	  allShippingError: null,
	  purchasesVendorDetailsError: null,
	  purchasesVendorDetails: null,
	  purchasesVendorDetailsIsLoading: false,
	  salesCustomerDetailsError: null,
	  salesItemHistory: [],
	  salesItemHistoryIsLoading: false,
	  salesItemHistoryError: null,
	  customerSalesHistory: [],
	  customerSalesHistoryIsLoading: false,
	  customerSalesHistoryError: null,
	  customerFrequent: [],
	  customerFrequentIsLoading: false,
	  customerFrequentError: null,
	  salesOrdersFilter: null,
	  salesPerformanceIsLoading: false,
	  salesPerformance: null,
	  salesPerformanceError: null,
	  dashboardSalesDetail: null,
	  dashboardSalesDetailIsLoading: false,
	  dashboardSalesDetailError: null,
	  salesLevels: {},
	  salesLevelsIsLoading: false,
	  salesLevelsError: null,
	  salesOrderProduct: null,
	  salesOrderProductIsLoading: false,
	  salesOrderProductFailure: null,
	
	  requestingShippingList: false,
	  shippingListPDF: null,
	  requestingPackingList: false,
	  packingListPDF: null,
	  requestingPickingList: false,
	  pickingListPDF: null,
	  requestingSalesOrderPDF: false,
	  salesOrderPDF: null,
	  requestingBolIdPDF: false,
	  bolIdPDF: null,
	  requestingBolWithoutLogPDF: false,
	  bolWithoutLogPDF: null,
	  requestingBolLabel: false,
	  bolLabel: null,
	  requestingBolFbaPDF: false,
	  bolFbaPDF: null,
	  spPDF: null,
	  bolAddress: [],
	  requestingRefundPDF: false,
	  refundPDF: null,
	  prevEstDate: null,
	  prevEstDateIsNeeded: false,
	  // Refund related reducer
	  refund: { error: null, loading: false, status: 0 },
	  quoteLoading: false,
	  salesTotals: null,
	  salesTotalsIsLoading: false,
	  salesTotalsError: null,
	  userPerformanceIsLoading: false,
	  userPerformanceError: null,
	  userPerformanceData: {},
	  batchesInfo: {}
	};
	
	var _default = function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  // console.log("action.payload:", action);
	  switch (action.type) {
	    case _type.REQUEST_OTHER_SERVICE:
	      return _extends({}, state, { error: null, isLoading: true });
	    case _type.FETCH_OTHER_SERVICE_SUCCESS:
	      return _extends({}, state, { all: action.payload.data, error: null, isLoading: false, msoTotalPages: action.payload.data ? action.payload.data.pages : 1
	      });
	    case _type.FETCH_OTHER_SERVICE_FAILURE:
	      {
	        var error = action.payload || { message: action.payload.message };
	        return _extends({}, state, { all: [], error: error, isLoading: false
	        });
	      }
	    default:
	      return state;
	  }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/otherService_reducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/otherService_reducer.js');
	}();

	;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    all: [],
	    currentPaymentTerm: null,
	    isLoading: false,
	    error: null,
	    isCreating: false,
	    createError: null,
	    created: false,
	    isEditing: false,
	    editError: null,
	    edited: false
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _type.REQUEST_PAYMENTTERMS:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.FETCH_PAYMENTTERMS_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	        case _type.FETCH_PAYMENTTERMS_FAILURE:
	            var error = action.payload || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { all: [], error: error, isLoading: false });
	        case _type.SELECT_PAYMENTTERM:
	            return _extends({}, state, { currentPaymentTerm: action.payload });
	        case _type.RESET_CURRENT_PAYMENTTERM:
	            return _extends({}, state, { currentPaymentTerm: null });
	        case _type.REQUEST_CREATING_PAYMENT_TERM:
	            return _extends({}, state, { isCreating: true, createError: null, created: false });
	        case _type.CREATE_PAYMENT_TERM_SUCCESS:
	            return _extends({}, state, { isCreating: false, createError: null, created: true });
	        case _type.CREATE_PAYMENT_TERM_FAILURE:
	            var createError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { isCreating: false, createError: createError, created: false });
	        case _type.RESET_CREATE_PAYMENT_TERM:
	            return _extends({}, state, { isCreating: false, createError: null, created: false });
	        case _type.REQUEST_EDITING_PAYMENT_TERM:
	            return _extends({}, state, { isEditing: true, editError: null, edited: false });
	        case _type.EDIT_PAYMENT_TERM_SUCCESS:
	            return _extends({}, state, { isEditing: false, editError: null, edited: true });
	        case _type.EDIT_PAYMENT_TERM_FAILURE:
	            var editError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { isEditing: false, editError: editError, edited: false });
	        case _type.RESET_EDIT_PAYMENT_TERM:
	            return _extends({}, state, { isEditing: false, editError: null, edited: false });
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/paymentTerms_reducer.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/paymentTerms_reducer.js');
	}();

	;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	  all: null,
	  isLoading: true,
	  error: null,
	  registers: [],
	  registersIsLoading: false,
	  registersError: null,
	
	  sessions: [],
	  sessionsIsLoading: false,
	  sessionsError: null,
	
	  currentSalesOrder: null,
	  currentPosOrderDetail: null,
	  detailIsLoading: false,
	  detailError: null,
	
	  currentPosCreditDetail: null,
	  creditDetailIsLoading: false,
	  creditDetailError: null,
	
	  editingPosPayment: false,
	  editedPosPayment: false,
	  editPosPaymentError: null,
	
	  posHolds: [],
	  posHoldsOderDetail: null,
	
	  requestingPosHoldsPDF: false,
	  posHoldsPDF: null
	};
	
	var _default = function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    // Fetch registers
	    case _type.FETCH_POS_HOLDS_DETAILS_SUCCESS:
	      return _extends({}, state, { posHoldsOderDetail: action.payload });
	    case _type.FETCH_POS_HOLDS_SUCCESS:
	      return _extends({}, state, { posHolds: action.payload });
	    case _type.REQUEST_REGISTERS:
	      return _extends({}, state, { registersIsLoading: true, registers: [], registersError: null });
	    case _type.FETCH_REGISTERS_SUCCESS:
	      return _extends({}, state, { registersIsLoading: false, registers: action.payload.data });
	    case _type.FETCH_REGISTERS_FAILRE:
	      return _extends({}, state, { registersIsLoading: false, registersError: action.payload.data });
	
	    // Fetch sessions
	    case _type.REQUEST_REGISTER_SESSIONS:
	      return _extends({}, state, { sessionsIsLoading: true, sessions: [], sessionsError: null });
	    case _type.REQUEST_REGISTER_SESSIONS_DATE:
	      return _extends({}, state, { sessionsIsLoading: true, sessions: [], sessionsError: null });
	    case _type.FETCH_REGISTER_SESSIONS_SUCCESS:
	      return _extends({}, state, { sessionsIsLoading: false, sessions: action.payload.data });
	    case _type.FETCH_REGISTER_SESSIONS_FAILURE:
	      return _extends({}, state, { sessionsIsLoading: false, sessionsError: action.payload.data });
	    case _type.VERIFY_REGISTER:
	      return _extends({}, state, { sessionsIsLoading: true, sessions: [], sessionsError: null });
	
	    // Fetch POS orders
	    case _type.REQUEST_POS_ORDERS:
	      return _extends({}, state, { error: null, isLoading: true });
	    case _type.FETCH_POS_ORDERS_SUCCESS:
	      return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	    case _type.FETCH_POS_ORDERS_FAILURE:
	      var error = action.payload || { message: action.payload.message };
	      return _extends({}, state, { all: [], error: error, isLoading: false });
	    case _type.REQUEST_POS_ORDER_DETAIL:
	      return _extends({}, state, { detailError: null, detailIsLoading: true, currentPosOrderDetail: null });
	    case _type.FETCH_POS_ORDER_DETAIL_SUCCESS:
	      // return list of posts and make loading = false
	      return _extends({}, state, { currentPosOrderDetail: action.payload, detailError: null, detailIsLoading: false });
	    case _type.FETCH_POS_ORDER_DETAIL_FAILURE:
	      // return error and make loading = false
	      var detailError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	      return _extends({}, state, { all: [], detailError: detailError, detailIsLoading: false });
	    case _type.REQUEST_VOID_POS_ORDER:
	      return _extends({}, state, { error: null, isLoading: true });
	    case _type.VOID_POS_ORDER_SUCCESS:
	      return _extends({}, state, { isLoading: false });
	    case _type.VOID_POS_ORDER_FAILURE:
	      var voidError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	      alert(JSON.stringify(voidError));
	      return _extends({}, state, { error: voidError, isLoading: false });
	
	    // Fetch POS credit
	    case _type.REQUEST_POS_CREDITS:
	      return _extends({}, state, { error: null, isLoading: true });
	    case _type.FETCH_POS_CREDITS_SUCCESS:
	      return _extends({}, state, { all: action.payload.data, error: null, isLoading: false
	      });
	    case _type.FETCH_POS_CREDITS_FAILURE:
	      {
	        var creditError = action.payload || { message: action.payload.message };
	        return _extends({}, state, { all: [], error: creditError, isLoading: false
	        });
	      }
	    case _type.REQUEST_POS_CREDIT_DETAIL:
	      return _extends({}, state, { detailError: null, creditDetailIsLoading: true, currentPosOrderDetail: null
	      });
	    case _type.FETCH_POS_CREDIT_DETAIL_SUCCESS:
	      return _extends({}, state, { currentPosCreditDetail: action.payload, creditDetailError: null, creditDetailIsLoading: false
	      });
	    case _type.FETCH_POS_CREDIT_DETAIL_FAILURE:
	      {
	        var creditDetailError = action.payload || { message: action.payload.message };
	        return _extends({}, state, { all: [], creditDetailError: creditDetailError, creditDetailIsLoading: false
	        });
	      }
	
	    // edit POS payment
	    case _type.REQUEST_EDIT_POS_PAYMENT:
	      return _extends({}, state, {
	        editingPosPayment: true,
	        editedPosPayment: false,
	        editPosPaymentError: null
	      });
	    case _type.EDIT_POS_PAYMENT_SUCCESS:
	      return _extends({}, state, {
	        editingPosPayment: false,
	        editedPosPayment: true,
	        editPosPaymentError: null
	      });
	    case _type.EDIT_POS_PAYMENT_FAILURE:
	      var editPosPaymentError = action.payload || { message: action.payload.message };
	      alert(JSON.stringify(editPosPaymentError));
	      return _extends({}, state, {
	        editingPosPayment: false,
	        editedPosPayment: false,
	        editPosPaymentError: editPosPaymentError
	      });
	    // print
	    case _type.REQUEST_POS_HOLDS_PDF:
	      return _extends({}, state, { requestingPosHoldsPDF: true, posHoldsPDF: null });
	    case _type.FETCH_POS_HOLDS_PDF_SUCCESS:
	      return _extends({}, state, { requestingPosHoldsPDF: false, posHoldsPDF: action.payload.data });
	
	    default:
	      return state;
	  }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/pos_reducer.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/pos_reducer.jsx');
	}();

	;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	  msoTotalPages: null,
	  all: null,
	  currentSalesOrder: null,
	  currentSalesOrderDetail: null,
	  currentSalesOrderDetailByNum: null,
	  isLoading: true,
	  error: null,
	  detailIsLoading: false,
	  detailByNumIsLoading: false,
	  detailError: null,
	  detailByNumError: null,
	  salesOrderIsCreating: false,
	  salesOrderCreateError: null,
	  salesOrderCreated: false,
	  salesOrderIsEditing: false,
	  salesOrderEditError: null,
	  salesOrderEdited: false,
	  customerOrderSchedules: [],
	  customerOrderSchedulesIsLoading: false,
	  customerOrderSchedulesError: null,
	  todaysOutgoingOrders: [],
	  todaysOutgoingOrdersIsLoading: null,
	  todaysOutgoingOrdersError: null,
	  salesOrderLineWeights: [],
	  salesOrderLineWeightsIsLoading: false,
	  salesOrderLineWeightsError: null,
	  salesOrderLineWeightsIsEditing: false,
	  editSalesOrderLineWeightsError: null,
	  editSalesOrderLineWeightsSuccess: false,
	  printForm: null,
	  printFormIsLoading: false,
	  printFormError: null,
	  csv: null,
	  csvIsLoading: false,
	  csvError: null,
	  SavingPosSale: false,
	  SavePosSaleSuccessful: null,
	  SavePosSaleFailure: null,
	  SavePosError: null,
	  InvalidCharacterEntered: false,
	  ChargeNotMet: false,
	  RequestingDraft: null,
	  DraftDetails: null,
	  DraftError: null,
	  drafts: null,
	  draftsIsLoading: null,
	  draftsError: null,
	  customerPricesIsLoading: false,
	  customerPricesError: null,
	  customerPrices: [],
	  currencyRates: null,
	  currencyRatesIsLoading: false,
	  currencyRatesError: null,
	  multiCurrenciesIsEditing: false,
	  multiCurrenciesEdited: false,
	  multiCurrenciesEditError: null,
	  taxRates: null,
	  taxRatesIsLoading: false,
	  taxRatesError: null,
	  creatingTaxRate: false,
	  createTaxRateError: null,
	  createTaxRateSuccess: null,
	  multiTaxesIsEditing: false,
	  multiTaxesEdited: false,
	  multiTaxesEditError: null,
	  taxIsDeleting: false,
	  taxDeleted: false,
	  taxDeleteError: null,
	  overallSales: [],
	  overallSalesIsLoading: false,
	  overallSalesError: null,
	  posReport: [],
	  posReportIsLoading: false,
	  posReportError: null,
	  salesInventoryInfo: [],
	  salesInventoryInfoIsLoading: false,
	  salesInventoryInfoError: null,
	  salesCustomerDetails: null,
	  salesShippingCustomerDetails: null,
	  salesCustomerDetailsIsLoading: false,
	  allShipping: null,
	  allShippingIsLoading: false,
	  allShippingError: null,
	  purchasesVendorDetailsError: null,
	  purchasesVendorDetails: null,
	  purchasesVendorDetailsIsLoading: false,
	  salesCustomerDetailsError: null,
	  salesItemHistory: [],
	  salesItemHistoryIsLoading: false,
	  salesItemHistoryError: null,
	  customerSalesHistory: [],
	  customerSalesHistoryIsLoading: false,
	  customerSalesHistoryError: null,
	  customerFrequent: [],
	  customerFrequentIsLoading: false,
	  customerFrequentError: null,
	  salesOrdersFilter: null,
	  salesPerformanceIsLoading: false,
	  salesPerformance: null,
	  salesPerformanceError: null,
	  dashboardSalesDetail: null,
	  dashboardSalesDetailIsLoading: false,
	  dashboardSalesDetailError: null,
	  salesLevels: {},
	  salesLevelsIsLoading: false,
	  salesLevelsError: null,
	  salesOrderProduct: null,
	  salesOrderProductIsLoading: false,
	  salesOrderProductFailure: null,
	
	  requestingShippingList: false,
	  shippingListPDF: null,
	  requestingPackingList: false,
	  packingListPDF: null,
	  requestingPickingList: false,
	  pickingListPDF: null,
	  requestingSalesOrderPDF: false,
	  salesOrderPDF: null,
	  requestingBolIdPDF: false,
	  bolIdPDF: null,
	  requestingBolWithoutLogPDF: false,
	  bolWithoutLogPDF: null,
	  requestingBolLabel: false,
	  bolLabel: null,
	  requestingBolFbaPDF: false,
	  bolFbaPDF: null,
	  spPDF: null,
	  bolAddress: [],
	  requestingRefundPDF: false,
	  refundPDF: null,
	  prevEstDate: null,
	  prevEstDateIsNeeded: false,
	  // Refund related reducer
	  refund: { error: null, loading: false, status: 0 },
	  quoteLoading: false,
	  salesTotals: null,
	  salesTotalsIsLoading: false,
	  salesTotalsError: null,
	  userPerformanceIsLoading: false,
	  userPerformanceError: null,
	  userPerformanceData: {},
	  batchesInfo: {}
	};
	
	var _default = function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  // console.log("action.payload:", action);
	  switch (action.type) {
	    case _type.REQUEST_PRE_ORDERS:
	      return _extends({}, state, { error: null, isLoading: true });
	    case _type.FETCH_PRE_ORDERS_SUCCESS:
	      return _extends({}, state, { all: action.payload.data, error: null, isLoading: false, msoTotalPages: action.payload.data ? action.payload.data.pages : 1
	      });
	    case _type.FETCH_PRE_ORDERS_FAILURE:
	      {
	        var error = action.payload || { message: action.payload.message };
	        return _extends({}, state, { all: [], error: error, isLoading: false
	        });
	      }
	    default:
	      return state;
	  }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/preOrders_reducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/preOrders_reducer.js');
	}();

	;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	  all: [],
	  currentPreviousOrders: null,
	  currentPreviousOrdersDetail: null,
	  isLoading: false,
	  error: null,
	  previousOrdersAreLoading: false,
	  previousOrdersError: null,
	  isCreating: false,
	  createError: null,
	  created: false,
	  isEditing: false,
	  editError: null,
	  edited: false
	};
	
	var _default = function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    // PreviousSOs action handlers
	    case _type.REQUEST_PREVIOUSSOS:
	      return _extends({}, state, { error: null, isLoading: true });
	    case _type.FETCH_PREVIOUSSOS_SUCCESS:
	      return _extends({}, state, { SOs: action.payload.data, error: null, isLoading: false });
	    case _type.FETCH_PREVIOUSSOS_FAILURE:
	      {
	        var _error = action.payload || { message: action.payload.message };
	        return _extends({}, state, { SOs: [], error: _error, isLoading: false });
	      }
	    case _type.REQUEST_PREVIOUSSO_DETAIL:
	      return _extends({}, state, { error: null, isLoading: true });
	    case _type.FETCH_PREVIOUSSO_DETAIL_SUCCESS:
	      return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	    case _type.FETCH_PREVIOUSSO_DETAIL_FAILURE:
	      var er = action.payload || { message: action.payload.message };
	      return _extends({}, state, { all: [], previousOrdersError: er, isLoading: false });
	
	    // PreviousOrders action handlers
	    case _type.REQUEST_PREVIOUSORDERS:
	      return _extends({}, state, { error: null, isLoading: true });
	    case _type.FETCH_PREVIOUSORDERS_SUCCESS:
	      return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	    case _type.FETCH_PREVIOUSORDERS_FAILURE:
	      var err = action.payload || { message: action.payload.message };
	      return _extends({}, state, { all: [], error: err, isLoading: false });
	    case _type.SELECT_PREVIOUSORDERS:
	      return _extends({}, state, { currentPreviousOrders: action.payload });
	    case _type.RESET_CURRENT_PREVIOUSORDERS:
	      return _extends({}, state, { currentPreviousOrders: null });
	    case _type.REQUEST_PREVIOUSORDERS_DETAIL:
	      return _extends({}, state, { previousOrdersError: null, previousOrdersAreLoading: true });
	    case _type.FETCH_PREVIOUSORDERS_DETAIL_SUCCESS:
	      // return list of posts and make loading = false
	      return _extends({}, state, { currentPreviousOrdersDetail: action.payload.data, previousOrdersError: null, previousOrdersAreLoading: false });
	    case _type.FETCH_PREVIOUSORDERS_DETAIL_FAILURE:
	      // return error and make loading = false
	      var previousOrdersError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	      return _extends({}, state, { all: [], previousOrdersError: previousOrdersError, previousOrdersAreLoading: false });
	    case _type.REQUEST_ADDING_PREVIOUSORDER:
	      return _extends({}, state, { error: null, isLoading: true });
	    case _type.ADD_PREVIOUSORDER_SUCCESS:
	      return _extends({}, state, { isLoading: false });
	    case _type.ADD_PREVIOUSORDER_FAILURE:
	      return _extends({}, state, { error: error, isLoading: false });
	    case _type.REQUEST_DELETE_PREVIOUSORDER:
	      return _extends({}, state, { error: null, isLoading: true });
	    case _type.DELETE_PREVIOUSORDER_SUCCESS:
	      return _extends({}, state, { isLoading: false });
	    case _type.DELETE_PREVIOUSORDER_FAILURE:
	      return _extends({}, state, { error: error, isLoading: false });
	    default:
	      return state;
	  }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/previousOrders_reducer.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/previousOrders_reducer.jsx');
	}();

	;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _PrintError = __webpack_require__(258);
	
	var _PrintError2 = _interopRequireDefault(_PrintError);
	
	var _type = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INITIAL_STATE = {
	  requestingPurchaseOrderPdf: false,
	  purchaseOrderPdf: null,
	  requestingSalesInvoicePdf: false,
	  requestingSalesInvoiceReturnPdf: false,
	  salesInvoicePdf: null,
	  salesInvoiceReturnPdf: null,
	  requestingWarehouseReceivePdf: false,
	  warehouseReceivePdf: null,
	  requestingArReport: false,
	  arReport: null,
	  requestingApReport: false,
	  apReport: null,
	  printSalesInvoiceIsLoading: false,
	  requestingPurchaseReturnPdf: false,
	  purchaseReturnPdf: null,
	  requestingPurchaseReferencePdf: false,
	  purchaseReferencePdf: null,
	  requestingRoutingPdf: false,
	  routingPdf: null,
	  routingPdfFailure: false,
	  requestingPickingListPdf: false,
	  pickingListPdf: null,
	  pickingListPdfFailure: false,
	  requestingPackingListPdf: false,
	  packingListPdf: null,
	  packingListPdfFailure: false,
	  requestingDispatchSalesInvoicePdf: false,
	  dispatchSalesInvoicePdf: null,
	  dispatchSalesInvoicePdfFailure: false,
	  requestingPurchaseOrderPdfNs: false,
	  purchaseOrderPdfNs: null,
	  salesorderPdfNs: null,
	  requestingSalesInvoicePdfsNs: false,
	  salesInvoiceReturnPdfNs: null,
	  purchaseReturnPdfNs: null
	};
	
	var _default = function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _type.REQUEST_PO_PDF:
	      return _extends({}, state, { requestingPurchaseOrderPdf: true, purchaseOrderPdf: null });
	    case _type.FETCH_PO_PDF_SUCCESS:
	      return _extends({}, state, { requestingPurchaseOrderPdf: false, purchaseOrderPdf: action.payload.data });
	    case _type.REQUEST_PO_NOSUBTOTAL_PDF:
	      return _extends({}, state, { requestingPurchaseOrderPdfNs: true, purchaseOrderPdfNs: null });
	    case _type.REQUEST_PO_NOSUBTOTAL_PDF_SUCCESS:
	      return _extends({}, state, { requestingPurchaseOrderPdfNs: false, purchaseOrderPdfNs: action.payload.data });
	    case _type.REQUEST_SI_PDF:
	      return _extends({}, state, { requestingSalesInvoicePdf: true, salesInvoicePdf: null, printSalesInvoiceIsLoading: true
	      });
	    case _type.FETCH_SI_PDF_SUCCESS:
	      return _extends({}, state, { requestingSalesInvoicePdf: false, salesInvoicePdf: action.payload.data, printSalesInvoiceIsLoading: false
	      });
	    case _type.FETCH_SI_PDF_FAILURE:
	      var salesInvoicePdfError = action.payload || { message: action.payload.message };
	      alert(JSON.stringify(salesInvoicePdfError));
	      return _extends({}, state, { requestingSalesInvoicePdf: false, salesInvoiceReturnPdfError: salesInvoiceReturnPdfError, printSalesInvoiceIsLoading: false
	      });
	    case _type.REQUEST_SI_NOSUBTOTAL_PDF:
	      return _extends({}, state, { salesorderPdfNs: null, requestingSalesInvoicePdf: true
	      });
	    case _type.REQUEST_SI_NOSUBTOTAL_PDF_SUCCESS:
	      return _extends({}, state, { salesorderPdfNs: action.payload.data, requestingSalesInvoicePdf: false
	      });
	    case _type.REQUEST_SI_RETURN_PDF:
	      return _extends({}, state, { requestingSalesInvoiceReturnPdf: true, salesInvoiceReturnPdf: null, printSalesInvoiceIsLoading: true
	      });
	    case _type.FETCH_SI_RETURN_PDF_SUCCESS:
	      return _extends({}, state, { requestingSalesInvoiceReturnPdf: false, salesInvoiceReturnPdf: action.payload.data, arReport: action.payload.data, printSalesInvoiceIsLoading: false
	      });
	    case _type.FETCH_SI_RETURN_PDF_FAILURE:
	      var salesInvoiceReturnPdfError = action.payload || { message: action.payload.message };
	      alert(JSON.stringify(salesInvoiceReturnPdfError));
	      return _extends({}, state, { requestingSalesInvoiceReturnPdf: false, salesInvoiceReturnPdfError: salesInvoiceReturnPdfError, printSalesInvoiceIsLoading: false
	      });
	    case _type.REQUEST_WR_PDF:
	      return _extends({}, state, { requestingWarehouseReceivePdf: true, warehouseReceivePdf: null });
	    case _type.FETCH_WR_PDF_SUCCESS:
	      return _extends({}, state, { requestingWarehouseReceivePdf: false, warehouseReceivePdf: action.payload.data });
	    case _type.REQUEST_AR_PDF:
	      return _extends({}, state, { requestingArReport: true, arReport: null });
	    case _type.FETCH_AR_PDF_SUCCESS:
	      return _extends({}, state, { requestingArReport: false, arReport: action.payload.data });
	    case _type.REQUEST_PURCHASE_RETURN_PDF:
	      return _extends({}, state, {
	        requestingPurchaseReturnPdf: true,
	        purchaseReturnPdf: null
	      });
	    case _type.FETCH_PURCHASE_RETURN_PDF_SUCCESS:
	      return _extends({}, state, {
	        requestingPurchaseReturnPdf: false,
	        purchaseReturnPdf: action.payload.data
	      });
	
	    case _type.REQUEST_PURCHASE_REFERENCE_PDF:
	      return _extends({}, state, {
	        requestingPurchaseReferencePdf: true,
	        purchaseReferencePdf: null
	      });
	    case _type.FETCH_PURCHASE_REFERENCE_PDF_SUCCESS:
	      return _extends({}, state, {
	        requestingPurchaseReferencePdf: false,
	        purchaseReferencePdf: action.payload.data
	      });
	
	    case _type.REQUEST_AP_PDF:
	      return _extends({}, state, {
	        requestingApReport: true,
	        apReport: null
	      });
	    case _type.FETCH_AP_PDF_SUCCESS:
	      return _extends({}, state, {
	        requestingApReport: false,
	        apReport: action.payload.data
	      });
	
	    case _type.REQUEST_ROUTING_PDF:
	      return _extends({}, state, { requestingRoutingPdf: true, routingPdf: null });
	    case _type.REQUEST_ROUTING_PDF_SUCCESS:
	      return _extends({}, state, { requestingRoutingPdf: false, routingPdf: action.payload.data });
	    case _type.REQUEST_ROUTING_PDF_FAILURE:
	      (0, _PrintError2.default)(action.payload);
	      return _extends({}, state, { requestingRoutingPdf: false, routingPdfFailure: true });
	    case _type.REQUEST_DISPATCH_PICKING_LIST_PDF:
	      return _extends({}, state, { requestingPickingListPdf: true, pickingListPdf: null });
	    case _type.REQUEST_DISPATCH_PICKING_LIST_PDF_SUCCESS:
	      return _extends({}, state, { requestingPickingListPdf: false, pickingListPdf: action.payload.data });
	    case _type.REQUEST_DISPATCH_PICKING_LIST_PDF_FAILURE:
	      (0, _PrintError2.default)(action.payload);
	      return _extends({}, state, { requestingPickingListPdf: false, pickingListPdfFailure: true });
	    case _type.REQUEST_DISPATCH_PACKING_LIST_PDF:
	      return _extends({}, state, { requestingPackingListPdf: true, packingListPdf: null });
	    case _type.REQUEST_DISPATCH_PACKING_LIST_PDF_SUCCESS:
	      return _extends({}, state, { requestingPackingListPdf: false, packingListPdf: action.payload.data });
	    case _type.REQUEST_DISPATCH_PACKING_LIST_PDF_FAILURE:
	      (0, _PrintError2.default)(action.payload);
	      return _extends({}, state, { requestingPackingListPdf: false, packingListPdfFailure: true });
	    case _type.REQUEST_DISPATCH_SALES_INVOICE_PDF:
	      return _extends({}, state, { requestingDispatchSalesInvoicePdf: true, dispatchSalesInvoicePdf: null });
	    case _type.REQUEST_DISPATCH_SALES_INVOICE_PDF_SUCCESS:
	      return _extends({}, state, { requestingDispatchSalesInvoicePdf: false, dispatchSalesInvoicePdf: action.payload.data });
	    case _type.REQUEST_DISPATCH_SALES_INVOICE_PDF_FAILURE:
	      (0, _PrintError2.default)(action.payload);
	      return _extends({}, state, { requestingDispatchSalesInvoicePdf: false, dispatchSalesInvoicePdfFailure: true });
	    case _type.REQUEST_SI_RETURN_NOSUBTOTAL_PDF:
	      return _extends({}, state, { requestingSalesInvoiceReturnPdf: true, salesInvoiceReturnPdfNs: null, printSalesInvoiceIsLoading: true
	      });
	    case _type.REQUEST_SI_RETURN_NOSUBTOTAL_PDF_SUCCESS:
	      return _extends({}, state, { requestingSalesInvoiceReturnPdf: false, salesInvoiceReturnPdfNs: action.payload.data, printSalesInvoiceIsLoading: false
	      });
	    case _type.REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL:
	      return _extends({}, state, { requestingPurchaseReturnPdf: true, purchaseReturnPdfNs: null
	      });
	    case _type.REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL_SUCCESS:
	      return _extends({}, state, { requestingPurchaseReturnPdf: false, purchaseReturnPdfNs: action.payload.data
	      });
	    default:
	      return _extends({}, state);
	  }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/print_reducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/print_reducer.js');
	}();

	;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    all: [],
	    allByVendor: [],
	    currentProduct: null,
	    currentProductDetail: null,
	    isLoading: false,
	    error: null,
	    detailIsLoading: false,
	    detailError: null,
	    isCreating: false,
	    createError: null,
	    created: false,
	    isEditing: false,
	    editError: null,
	    edited: false,
	    multiIsEditing: false,
	    multiEditError: null,
	    multiEdited: false,
	    groups: null,
	    groupIsLoading: false,
	    groupError: null,
	    currentGroup: null,
	    groupIsCreating: false,
	    groupCreateError: null,
	    groupCreated: false,
	    groupIsEditing: false,
	    groupEditError: null,
	    groupEdited: false,
	    multiGroupIsEditing: false,
	    multiGroupEditError: null,
	    multiGroupEdited: false,
	    categories: [],
	    categoryIsLoading: false,
	    categoryError: null,
	    currentCategory: null,
	    currentCategoryB2B: null,
	    categoryIsCreating: false,
	    categoryCreateError: null,
	    categoryCreated: false,
	    categoryIsEditing: false,
	    categoryEditError: null,
	    categoryEdited: false,
	
	    categories_2: [],
	    category_2Error: null,
	    category_2IsLoading: false,
	    multiCategory_2IsEditing: false,
	    multiCategory_2EditError: null,
	    multiCategory_2Edited: false,
	
	    categories2B2B: [],
	    category2ErrorB2B: null,
	    category2IsLoadingB2B: false,
	    multiCategory2IsEditingB2B: false,
	    multiCategory2EditErrorB2B: null,
	    multiCategory2EditedB2B: false,
	
	    display_categories: null,
	    display_categories_error: null,
	    displayCategoriesIsLoading: false,
	    editCategoryLoading: false,
	
	    priceLevels: [],
	    priceLevelIsLoading: false,
	    priceLevelError: null,
	    multiPriceLevelIsEditing: false,
	    multiPriceLevelEditError: null,
	    multiPriceLevelEdited: false,
	    types: [],
	    typeIsLoading: false,
	    typeError: null,
	    multiCategoryIsEditing: false,
	    multiCategoryEditError: null,
	    multiCategoryEdited: false,
	    productInfo: null,
	    productInfoError: null,
	    productInfoIsLoading: false,
	    simplifiedProducts: [],
	    simplifiedProductsIsLoading: false,
	    simplifiedProductsError: null,
	    groupCategories: [],
	    groupCategoryError: null,
	    groupCategoryIsLoading: false,
	    deletingCategory: false,
	    deleteCategorySuccess: null,
	    deleteCategoryError: null,
	    deletingGroup: false,
	    deleteGroupSuccess: null,
	    deleteGroupError: null,
	    smallProductDetail: null,
	    smallProductDetailIsLoading: false,
	    smallProductDetailError: null,
	    CRVs: [],
	    CRVsIsLoading: false,
	    CRVsError: null,
	    currentCategoryGroup: null,
	    productSaved: null,
	    product: null,
	    fetchingRelatedProducts: false,
	    relatedProductsFetched: false,
	    relatedProductsFetchError: null,
	    fetchingSuggestDigit: false,
	    suggestDigitFetched: null,
	    suggestDigitFetchError: null,
	
	    // Buyer Details
	    defaultBuyers: [],
	    defaultBuyersIsLoading: false,
	    defaultBuyersError: null,
	
	    fetchingPackageTypes: false,
	    packageTypesFetched: false,
	    packageTypeFetchError: null,
	    editingPackageTypes: false,
	    packageTypesEdited: false,
	    packageTypeEditError: null,
	    deletingPackageTypes: false,
	    deletePackageTypesSuccess: null,
	    deletePackageTypesError: null,
	    fetchingMeasurementUnit: false,
	    measurementUnitFetched: false,
	    measurementUnitFetchError: null,
	    editingMeasurementUnit: false,
	    measurementUnitEdited: false,
	    measurementUnitEditError: null,
	    deletingMeasurementUnit: false,
	    deleteMeasurementUnitSuccess: null,
	    deleteMeasurementUnitError: null,
	    fetchingConvertableProducts: false,
	    convertableProductsFetched: null,
	    convertableProductsFetchError: null,
	
	    isAttachingDocument: false,
	    attachDocumentError: null,
	    attachDocumentSuccess: false,
	    category2ProductsIsLoading: false,
	    category2ProductsIsLoadingB2B: false,
	    requestCategory2ProductsSuccess: false,
	    requestCategory2ProductsSuccessB2B: false,
	    requestCategory2ProductsError: null,
	    requestCategory2ProductsErrorB2B: null,
	    category2Id: null,
	    category2IdB2B: null,
	    category2Products: null,
	    category2ProductsB2B: null,
	    deletingCategory2Product: false,
	    deleteCategory2ProductSuccess: false,
	    deleteCategory2ProductError: null,
	
	    continuingOrDiscontinuingProduct: false,
	    continueOrDiscontinueProductError: false,
	    continueOrDiscontinueProductSuccess: false,
	
	    updateProduct: null,
	    updateProductIsLoading: false,
	    updateProductError: null,
	
	    savingMobileDescriptionText: false,
	    saveMobileDescriptionTextSuccess: false,
	    saveMobileDescriptionTextError: null,
	    deleteProduct: false,
	    deleteProductSuccess: false,
	    deleteProductError: null,
	    customers: [],
	    filters: {}
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        // Product action handlers
	        case _type.PRODUCTFORM_ACTIVE_CUSTOMER:
	            return _extends({}, state, {
	                customers: action.payload
	            });
	        case _type.REQUEST_INITIALIZE_ESL:
	            return _extends({}, state);
	        case _type.REQUEST_DELETE_ESL:
	            return _extends({}, state);
	        case _type.REQUEST_FETCH_ESL_TEMPLATE:
	            return _extends({}, state);
	        case _type.REQUEST_SAVE_ESL:
	            return _extends({}, state);
	        case _type.REQUEST_FETCH_ESL:
	            return _extends({}, state);
	        case _type.REQUEST_PRODUCTS:
	            return _extends({}, state, { error: null, isLoading: true, multiPriceLevelIsEditing: false, multiPriceLevelEditError: null, multiPriceLevelEdited: false });
	        case _type.FETCH_PRODUCTS_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	        case _type.FETCH_PRODUCTS_FAILURE:
	            var error = action.payload || { message: action.payload.message };
	            return _extends({}, state, { all: [], error: error, isLoading: false });
	        case _type.REQUEST_PRODUCTS_BY_VENDOR:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.FETCH_PRODUCTS_BY_VENDOR_SUCCESS:
	            return _extends({}, state, { allByVendor: action.payload.data, error: null, isLoading: false });
	        case _type.FETCH_PRODUCTS_BY_VENDOR_FAILURE:
	            var byVendorError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { all: [], error: byVendorError, isLoading: false });
	        case _type.SELECT_PRODUCT:
	            return _extends({}, state, { currentProduct: action.payload });
	        case _type.RESET_CURRENT_PRODUCT:
	            return _extends({}, state, { currentProduct: null, currentProductDetail: null });
	        case _type.CLEAR_CURRENT_PRODUCT:
	            return _extends({}, state, { currentProduct: null });
	        case _type.SET_GROUP_CATEGORY:
	            return _extends({}, state, { currentCategoryGroup: action.payload });
	        case _type.REQUEST_CREATING_PRODUCT:
	            return _extends({}, state, { isCreating: true, createError: null, created: false });
	        case _type.CREATE_PRODUCT_SUCCESS:
	            return _extends({}, state, { isCreating: false, createError: null, created: true, productSaved: action.payload.data });
	        case _type.CREATE_PRODUCT_FAILURE:
	            var createError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { isCreating: false, createError: createError, created: false });
	        case _type.REQUEST_EDITING_PRODUCT:
	            return _extends({}, state, { isEditing: true, editError: null, edited: false });
	        case _type.EDIT_PRODUCT_SUCCESS:
	            return _extends({}, state, { isEditing: false, editError: null, edited: true, productSaved: action.payload.data });
	        case _type.EDIT_PRODUCT_FAILURE:
	            var editError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { isEditing: false, editError: editError, edited: false });
	        case _type.REQUEST_EDITING_MULTI_PRODUCT:
	            return _extends({}, state, { multiIsEditing: true, multiEditError: null, multiEdited: false });
	        case _type.EDIT_MULTI_PRODUCT_SUCCESS:
	            return _extends({}, state, { multiIsEditing: false, multiEditError: null, multiEdited: true });
	        case _type.EDIT_MULTI_PRODUCT_FAILURE:
	            var multiEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { multiIsEditing: false, multiEditError: multiEditError, multiEdited: false });
	        case _type.REQUEST_PRODUCT_DETAIL:
	            return _extends({}, state, { detailError: null, detailIsLoading: true });
	        case _type.FETCH_PRODUCT_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { currentProductDetail: action.payload, detailError: null, detailIsLoading: false });
	        case _type.FETCH_PRODUCT_DETAIL_FAILURE:
	            // return error and make loading = false
	            var detailError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { all: [], detailError: detailError, detailIsLoading: false });
	        case _type.REQUEST_DISPLAY_CATEGORIES:
	            return _extends({}, state, { display_categories_error: null, displayCategoriesIsLoading: true });
	        case _type.FETCH_DISPLAY_CATEGORIES_SUCCESS:
	            return _extends({}, state, { display_categories: action.payload, display_categories_error: null, displayCategoriesIsLoading: false });
	        case _type.FETCH_DISPLAY_CATEGORIES_FAILURE:
	            var display_categories_error = action.payload || { message: action.payload.message };
	            return _extends({}, state, { display_categories_error: display_categories_error, displayCategoriesIsLoading: false });
	        case _type.REQUEST_EDIT_DISPLAY_CATEGORIES:
	            return _extends({}, state, { editCategoryLoading: true });
	        case _type.EDIT_DISPLAY_CATEGORIES_SUCCESS:
	            // console.log('success', action.payload.data)
	            alert('Display Categories Saved Successfully');
	            return _extends({}, state, { editCategoryLoading: false });
	        case _type.EDIT_DISPLAY_CATEGORIES_FAILURE:
	            // console.log('error', action.payload.data)
	            alert(action.payload.data.detail);
	            return _extends({}, state, { editCategoryLoading: false });
	        case _type.REQUEST_PRODUCT_BY_NUM:
	            return _extends({}, state, { detailError: null, detailIsLoading: true });
	        case _type.FETCH_PRODUCT_BY_NUM_SUCCESS:
	            console.log("payload 2", action.payload.data[0]);
	            return _extends({}, state, { currentProduct: action.payload.data[0], detailIsLoading: false });
	        case _type.FETCH_PRODUCT_BY_NUM_FAILURE:
	            var detailsError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { detailError: detailsError, detailIsLoading: false });
	        case _type.REQUEST_NEXT_PRODUCT:
	            return _extends({}, state, { detailIsLoading: true, detailError: null });
	        case _type.FETCH_NEXT_PRODUCT_SUCCESS:
	            return _extends({}, state, { currentProduct: action.payload.data, detailIsLoading: false });
	        case _type.FETCH_NEXT_PRODUCT_FAILURE:
	            var nextDetailError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { detailError: nextDetailError, detailIsLoading: false });
	        case _type.REQUEST_PREVIOUS_PRODUCT:
	            return _extends({}, state, { detailIsLoading: true, detailError: null });
	        case _type.FETCH_PREVIOUS_PRODUCT_SUCCESS:
	            return _extends({}, state, { currentProduct: action.payload.data, detailIsLoading: false });
	        case _type.FETCH_PREVIOUS_PRODUCT_FAILURE:
	            var prevDetailError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { detailError: prevDetailError, detailIsLoading: false });
	
	        // Group action handlers
	        case _type.REQUEST_GROUPS:
	            return _extends({}, state, { groupError: null, groupIsLoading: true, groups: null, categories: [] });
	        case _type.FETCH_GROUPS_SUCCESS:
	            return _extends({}, state, { groups: action.payload.data, groupError: null, groupIsLoading: false });
	        case _type.FETCH_GROUPS_FAILURE:
	            var groupError = action.payload || { message: action.payload.message };
	            alert(JSON.stringify(groupError));
	            return _extends({}, state, { groups: null, groupError: groupError, groupIsLoading: false });
	        case _type.SELECT_GROUP:
	            return _extends({}, state, { currentGroup: action.payload });
	        case _type.RESET_CURRENT_GROUP:
	            return _extends({}, state, { currentGroup: null });
	        case _type.RESET_GROUP_AND_CATEGORY:
	            return _extends({}, state, { groups: null, groupCategories: [] });
	        case _type.REQUEST_CREATING_GROUP:
	            return _extends({}, state, { groupIsCreating: true, groupCreateError: null, groupCreated: false });
	        case _type.CREATE_GROUP_SUCCESS:
	            return _extends({}, state, { groupIsCreating: false, groupCreateError: null, groupCreated: true });
	        case _type.CREATE_GROUP_FAILURE:
	            var groupCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { groupIsCreating: false, groupCreateError: groupCreateError, groupCreated: false });
	        case _type.REQUEST_EDITING_GROUP:
	            return _extends({}, state, { groupIsEditing: true, groupEditError: null, groupEdited: false });
	        case _type.EDIT_GROUP_SUCCESS:
	            return _extends({}, state, { groupIsEditing: false, groupEditError: null, groupEdited: true });
	        case _type.EDIT_GROUP_FAILURE:
	            var groupEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { groupIsEditing: false, groupEditError: groupEditError, groupEdited: false });
	        case _type.REQUEST_EDITING_MULTI_GROUPS:
	            return _extends({}, state, { multiGroupIsEditing: true, multiGroupEditError: null, multiGroupEdited: false });
	        case _type.EDIT_MULTI_GROUPS_SUCCESS:
	            return _extends({}, state, { multiGroupIsEditing: false, multiGroupEditError: null, multiGroupEdited: true });
	        case _type.EDIT_MULTI_GROUPS_FAILURE:
	            var multiGroupEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { multiGroupIsEditing: false, multiGroupEditError: multiGroupEditError, multiGroupEdited: false });
	
	        // Category action handlers
	        case _type.REQUEST_CATEGORIES:
	            return _extends({}, state, { groups: null, categories: [], categoryError: null, categoryIsLoading: true });
	        case _type.FETCH_CATEGORIES_SUCCESS:
	            return _extends({}, state, { categories: action.payload.data, categoryError: null, categoryIsLoading: false });
	        case _type.FETCH_CATEGORIES_FAILURE:
	            var categoryError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { categories: [], categoryError: categoryError, categoryIsLoading: false });
	        case _type.REQUEST_GROUP_CATEGORIES:
	            return _extends({}, state, { groupCategories: [], groupCategoryError: null, groupCategoryIsLoading: true });
	        case _type.FETCH_GROUP_CATEGORIES_SUCCESS:
	            return _extends({}, state, { groupCategories: action.payload.data, groupCategoryError: null, groupCategoryIsLoading: false });
	        case _type.FETCH_GROUP_CATEGORIES_FAILURE:
	            var groupCategoryError = action.payload || { message: action.payload.message };
	            alert(JSON.stringify(groupCategoryError));
	            return _extends({}, state, { groupCategories: [], groupCategoryError: groupCategoryError, groupCategoryIsLoading: false });
	
	        case _type.SELECT_CATEGORY:
	            return _extends({}, state, { currentCategory: action.payload });
	        case _type.SELECT_CATEGORY_B2B:
	            return _extends({}, state, { currentCategoryB2B: action.payload });
	        case _type.RESET_CURRENT_CATEGORY:
	            return _extends({}, state, { currentCategory: null });
	        case _type.RESET_CURRENT_CATEGORY_B2B:
	            return _extends({}, state, { currentCategoryB2B: null });
	        case _type.REQUEST_CREATING_CATEGORY:
	            return _extends({}, state, { categoryIsCreating: true, categoryCreateError: null, categoryCreated: false });
	        case _type.CREATE_CATEGORY_SUCCESS:
	            return _extends({}, state, { categoryIsCreating: false, categoryCreateError: null, categoryCreated: true });
	        case _type.CREATE_CATEGORY_FAILURE:
	            var categoryCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { categoryIsCreating: false, categoryCreateError: categoryCreateError, categoryCreated: false });
	        case _type.REQUEST_EDITING_CATEGORY:
	            return _extends({}, state, { categoryIsEditing: true, categoryEditError: null, categoryEdited: false });
	        case _type.EDIT_CATEGORY_SUCCESS:
	            return _extends({}, state, { categoryIsEditing: false, categoryEditError: null, categoryEdited: true });
	        case _type.EDIT_CATEGORY_FAILURE:
	            var categoryEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { categoryIsEditing: false, categoryEditError: categoryEditError, categoryEdited: false });
	        case _type.REQUEST_EDITING_MULTI_CATEGORIES:
	            return _extends({}, state, { multiCategoryIsEditing: true, multiCategoryEditError: null, multiCategoryEdited: false });
	        case _type.EDIT_MULTI_CATEGORIES_SUCCESS:
	            return _extends({}, state, { multiCategoryIsEditing: false, multiCategoryEditError: null, multiCategoryEdited: true });
	        case _type.EDIT_MULTI_CATEGORIES_FAILURE:
	            var multiCategoryEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { multiCategoryIsEditing: false, multiCategoryEditError: multiCategoryEditError, multiCategoryEdited: false });
	        case _type.RESET_CATEGORY:
	            return _extends({}, state, { categoryIsEditing: false, categoryEditError: null, categoryEdited: false, categoryIsCreating: false, categoryCreateError: null, categoryCreated: false });
	
	        case _type.REQUEST_CATEGORIES_2:
	            return _extends({}, state, { categories2: [], category2Error: null, category2IsLoading: true });
	        case _type.FETCH_CATEGORIES_2_SUCCESS:
	            return _extends({}, state, { categories2: action.payload.data, category2Error: null, category2IsLoading: false });
	        case _type.FETCH_CATEGORIES_2_FAILURE:
	            var category2Error = action.payload || { message: action.payload.message };
	            return _extends({}, state, { categories2: [], category2Error: category2Error, category2IsLoading: false });
	        case _type.REQUEST_EDITING_MULTI_CATEGORIES_2:
	            return _extends({}, state, { multiCategory2IsEditing: true, multiCategory2EditError: null, multiCategory2Edited: false, category2ImageAttached: false });
	        case _type.EDIT_MULTI_CATEGORIES_2_SUCCESS:
	            return _extends({}, state, { multiCategory2IsEditing: false, multiCategory2EditError: null, multiCategory2Edited: true });
	        case _type.EDIT_MULTI_CATEGORIES_2_FAILURE:
	            var multiCategory2EditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            alert(JSON.stringify(multiCategory2EditError));
	            return _extends({}, state, { multiCategory2IsEditing: false, multiCategory2EditError: multiCategory2EditError, multiCategory2Edited: false });
	
	        case _type.REQUEST_DELETE_CATEGORY_2:
	            return _extends({}, state, { deletingCategory2: true, deleteCategory2Success: null, deleteCategory2Error: null });
	        case _type.DELETE_CATEGORY_2_SUCCESS:
	            return _extends({}, state, { deletingCategory2: false, deleteCategory2Success: true });
	        case _type.DELETE_CATEGORY_2_FAILURE:
	            var deleteCategory2Error = action.payload.data || { message: action.payload.message };
	            alert(JSON.stringify(deleteCategory2Error));
	            return _extends({}, state, { deletingCategory2: false, deleteCategory2Error: deleteCategory2Error });
	        case _type.CLEAR_CATEGORY_2_STATUS:
	            return _extends({}, state, {
	                deletingCategory2: false,
	                deleteCategory2Success: null,
	                deleteCategory2Error: null,
	                multiCategory2IsEditing: false,
	                multiCategory2EditError: null,
	                multiCategory2Edited: false,
	                savingCategory2Image: false,
	                category2ImageAttached: false,
	                category2ImageAttachError: null
	            });
	
	        // Category B2B action handlers
	        case _type.REQUEST_CATEGORIES_2_B2B:
	            return _extends({}, state, { categories2B2B: [], category2ErrorB2B: null, category2IsLoadingB2B: true });
	        case _type.FETCH_CATEGORIES_2_SUCCESS_B2B:
	            return _extends({}, state, { categories2B2B: action.payload.data, category2ErrorB2B: null, category2IsLoadingB2B: false });
	        case _type.FETCH_CATEGORIES_2_FAILURE_B2B:
	            var category2ErrorB2B = action.payload || { message: action.payload.message };
	            return _extends({}, state, { categories2B2B: [], category2ErrorB2B: category2ErrorB2B, category2IsLoadingB2B: false });
	        case _type.REQUEST_EDITING_MULTI_CATEGORIES_2_B2B:
	            return _extends({}, state, { multiCategory2IsEditingB2B: true, multiCategory2EditErrorB2B: null, multiCategory2EditedB2B: false, category2ImageAttachedB2B: false });
	        case _type.EDIT_MULTI_CATEGORIES_2_SUCCESS_B2B:
	            return _extends({}, state, { multiCategory2IsEditingB2B: false, multiCategory2EditErrorB2B: null, multiCategory2EditedB2B: true });
	        case _type.EDIT_MULTI_CATEGORIES_2_FAILURE_B2B:
	            var multiCategory2EditErrorB2B = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            alert(JSON.stringify(multiCategory2EditErrorB2B));
	            return _extends({}, state, { multiCategory2IsEditingB2B: false, multiCategory2EditErrorB2B: multiCategory2EditErrorB2B, multiCategory2EditedB2B: false });
	
	        case _type.REQUEST_DELETE_CATEGORY_2_B2B:
	            return _extends({}, state, { deletingCategory2B2B: true, deleteCategory2SuccessB2B: null, deleteCategory2ErrorB2B: null });
	        case _type.DELETE_CATEGORY_2_SUCCESS_B2B:
	            return _extends({}, state, { deletingCategory2B2B: false, deleteCategory2SuccessB2B: true });
	        case _type.DELETE_CATEGORY_2_FAILURE_B2B:
	            var deleteCategory2ErrorB2B = action.payload.data || { message: action.payload.message };
	            alert(JSON.stringify(deleteCategory2ErrorB2B));
	            return _extends({}, state, { deletingCategory2B2B: false, deleteCategory2ErrorB2B: deleteCategory2ErrorB2B });
	        case _type.CLEAR_CATEGORY_2_STATUS_B2B:
	            return _extends({}, state, {
	                deletingCategory2B2B: false,
	                deleteCategory2SuccessB2B: null,
	                deleteCategory2ErrorB2B: null,
	                multiCategory2IsEditingB2B: false,
	                multiCategory2EditErrorB2B: null,
	                multiCategory2EditedB2B: false,
	                savingCategory2ImageB2B: false,
	                category2ImageAttachedB2B: false,
	                category2ImageAttachErrorB2B: null
	            });
	
	        // PriceLevel action handlers
	        case _type.REQUEST_PRICELEVELS:
	            return _extends({}, state, { priceLevelError: null, priceLevelIsLoading: true, multiPriceLevelIsEditing: false, multiPriceLevelEditError: null, multiPriceLevelEdited: false });
	        case _type.FETCH_PRICELEVELS_SUCCESS:
	            return _extends({}, state, { priceLevels: action.payload.data, priceLevelError: null, priceLevelIsLoading: false });
	        case _type.FETCH_PRICELEVELS_FAILURE:
	            var priceLevelError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { priceLevels: [], priceLevelError: priceLevelError, priceLevelIsLoading: false });
	        case _type.REQUEST_EDITING_MULTI_PRICELEVELS:
	            return _extends({}, state, { multiPriceLevelIsEditing: true, multiPriceLevelEditError: null, multiPriceLevelEdited: false });
	        case _type.EDIT_MULTI_PRICELEVELS_SUCCESS:
	            return _extends({}, state, { multiPriceLevelIsEditing: false, multiPriceLevelEditError: null, multiPriceLevelEdited: true });
	        case _type.EDIT_MULTI_PRICELEVELS_FAILURE:
	            var multiPriceLevelEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { multiPriceLevelIsEditing: false, multiPriceLevelEditError: multiPriceLevelEditError, multiPriceLevelEdited: false });
	
	        // Type action handlers
	        case _type.REQUEST_TYPES:
	            return _extends({}, state, { typeError: null, typeIsLoading: true });
	        case _type.FETCH_TYPES_SUCCESS:
	            return _extends({}, state, { types: action.payload.data, typeError: null, typeIsLoading: false });
	        case _type.FETCH_TYPES_FAILURE:
	            var typeError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { types: [], typeError: typeError, typeIsLoading: false });
	
	        case _type.REQUEST_PRODUCT_INFO:
	            return _extends({}, state, { productInfoError: null, productInfoIsLoading: true });
	        case _type.FETCH_PRODUCT_INFO_SUCCESS:
	            return _extends({}, state, { productInfo: action.payload.data, productInfoError: null, productInfoIsLoading: false });
	        case _type.FETCH_PRODUCT_INFO_FAILURE:
	            var productInfoError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { productInfo: null, productInfoError: productInfoError, productInfoIsLoading: false });
	
	        case _type.DELETE_PRODUCT:
	            return _extends({}, state, { deleteProduct: true, deleteProductSuccess: true, deleteProductError: false });
	        case _type.DELETE_PRODUCT_SUCCESS:
	            return _extends({}, state, { deleteProduct: true, deleteProductSuccess: true, deleteProductError: false });
	        case _type.DELETE_PRODUCT_FAILURE:
	            var deleteProductInfoError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { deleteProduct: false, deleteProductSuccess: false, deleteProductError: deleteProductInfoError });
	
	        case _type.REQUEST_SIMPLIFIED_PRODUCTS:
	            return _extends({}, state, { simplifiedProductsIsLoading: true, simplifiedProductsError: null, simplifiedProducts: [] });
	        case _type.FETCH_SIMPLIFIED_PRODUCTS_SUCCESS:
	            return _extends({}, state, { simplifiedProductsIsLoading: false, simplifiedProducts: action.payload.data });
	        case _type.FETCH_SIMPLIFIED_PRODUCTS_FAILURE:
	            var simplifiedProductsError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { simplifiedProductsIsLoading: false, simplifiedProductsError: simplifiedProductsError });
	
	        case _type.REQUEST_DELETE_CATEGORY:
	            return _extends({}, state, { deletingCategory: true, deleteCategorySuccess: null, deleteCategoryError: null });
	        case _type.DELETE_CATEGORY_SUCCESS:
	            return _extends({}, state, { deletingCategory: false, deleteCategorySuccess: true });
	        case _type.DELETE_CATEGORY_FAILURE:
	            var deleteCategoryError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { deletingCategory: false, deleteCategoryError: deleteCategoryError });
	        case _type.CLEAR_GROUP_STATUS:
	            return _extends({}, state, { deleteCategoryError: null, deleteCategorySuccess: null });
	
	        case _type.REQUEST_DELETE_GROUP:
	            return _extends({}, state, { deletingGroup: true, deleteGroupSuccess: null, deleteGroupError: null });
	        case _type.DELETE_PRODUCT_GROUP_SUCCESS:
	            return _extends({}, state, { deletingGroup: false, deleteGroupSuccess: true });
	        case _type.DELETE_GROUP_FAILURE:
	            var deleteGroupError = action.payload.data || { message: action.payload.messge };
	            return _extends({}, state, { deletingGroup: false, deleteGroupError: deleteGroupError });
	        case _type.CLEAR_GROUP_STATUS:
	            return _extends({}, state, { deleteGroupError: null, deleteGroupSuccess: null });
	
	        case _type.REINITIALZIE_PRODUCT_FORM:
	            return _extends({}, state, { currentProduct: action.payload });
	
	        case _type.REQUEST_SMALL_PRODUCT_INFO:
	            return _extends({}, state, { smallProductDetailIsLoading: true, smallProductDetail: null, smallProductDetailError: null });
	        case _type.FETCH_SMALL_PRODUCT_INFO_SUCCESS:
	            return _extends({}, state, { smallProductDetailIsLoading: false, smallProductDetail: action.payload.data });
	        case _type.FETCH_SMALL_PRODUCT_INFO_FAILURE:
	            var smallProductDetailError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { smallProductDetailIsLoading: false, smallProductDetailError: smallProductDetailError });
	        case _type.CLEAR_SMALL_PRODUCT:
	            return _extends({}, state, { smallProductDetail: null, smallProductDetailError: null });
	
	        case _type.REQUEST_CRV_VALUES:
	            return _extends({}, state, { CRVsIsLoading: true, CRVs: [], CRVsError: null });
	        case _type.FETCH_CRV_VALUES_SUCCESS:
	            return _extends({}, state, { CRVsIsLoading: false, CRVs: action.payload.data });
	        case _type.FETCH_CRV_VALUES_FAILURE:
	            var CRVsError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { CRVsIsLoading: false, CRVsError: CRVsError });
	
	        case _type.REQUEST_DEFAULT_BUYERS:
	            return _extends({}, state, { defaultBuyersIsLoading: true, defaultBuyers: [], defaultBuyersError: null });
	        case _type.REQUEST_DEFAULT_BUYERS_SUCCESS:
	            return _extends({}, state, { defaultBuyersIsLoading: false, defaultBuyers: action.payload.data });
	        case _type.REQUEST_DEFAULT_BUYERS_FAILURE:
	            var defaultBuyersError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { defaultBuyersIsLoading: false, defaultBuyersError: defaultBuyersError });
	
	        case _type.ATTACH_PRODUCT_IMAGE:
	            return _extends({}, state, { attachingProductImage: true, productImageAttached: false, productImageAttachError: null });
	        case _type.ATTACH_PRODUCT_IMAGE_SUCCESS:
	            return _extends({}, state, { attachingProductImage: false, productImageAttached: true, productImageAttachError: null });
	        case _type.ATTACH_PRODUCT_IMAGE_FAILURE:
	            var productImageAttachError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { attachingProductImage: false, productImageAttached: false, productImageAttachError: productImageAttachError });
	        case _type.CLEAR_ATTACHED_PRODUCT_IMAGE:
	            return _extends({}, state, { attachingProductImage: false, productImageAttached: false, productImageAttachError: null });
	        case _type.SET_CURRENT_PRODUCT:
	            return _extends({}, state, { product: action.payload });
	        case _type.FETCH_RELATED_PRODUCTS:
	            return _extends({}, state, { fetchingRelatedProducts: true, relatedProductsFetched: false, relatedProductsFetchError: null });
	        case _type.FETCH_RELATED_PRODUCTS_SUCCESS:
	            return _extends({}, state, { fetchingRelatedProducts: false, relatedProductsFetched: action.payload.data, relatedProductsFetchError: null });
	        case _type.FETCH_RELATED_PRODUCTS_FAILURE:
	            var relatedProductsFetchError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { fetchingRelatedProducts: false, relatedProductsFetched: false, relatedProductsFetchError: relatedProductsFetchError });
	        case _type.FETCH_SUGGESTED_PROD_NUM:
	            return _extends({}, state, { fetchingSuggestedProdNum: true, suggestedProdNumFetched: null, suggestedProdNumFetchError: null });
	        case _type.FETCH_SUGGESTED_PROD_NUM_SUCCESS:
	            return _extends({}, state, { fetchingSuggestedProdNum: false, suggestedProdNumFetched: action.payload.data, suggestedProdNumFetchError: null });
	        case _type.FETCH_SUGGESTED_PROD_NUM_FAILURE:
	            var suggestedProdNumFetchError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { fetchingSuggestedProdNum: false, suggestedProdNumFetchError: suggestedProdNumFetchError });
	
	        case _type.FETCH_SUGGEST_DIGIT:
	            return _extends({}, state, { fetchingSuggestDigit: true, suggestDigitFetched: false, suggestDigitFetchError: null });
	        case _type.FETCH_SUGGEST_DIGIT_SUCCESS:
	            return _extends({}, state, { fetchingSuggestDigit: false, suggestDigitFetched: action.payload.data, suggestDigitFetchError: null });
	        case _type.FETCH_SUGGEST_DIGIT_FAILURE:
	            var suggestDigitFetchError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { fetchingSuggestDigit: false, suggestDigitFetched: false, suggestDigitFetchError: suggestDigitFetchError });
	        case _type.CLEAR_SUGGEST_DIGIT:
	            return _extends({}, state, { fetchingSuggestDigit: false, suggestDigitFetched: null, suggestDigitFetchError: null });
	
	        case _type.FETCH_PACKAGE_TYPES:
	            return _extends({}, state, { fetchingPackageTypes: true, packageTypesFetched: false, packageTypeFetchError: null });
	        case _type.FETCH_PACKAGE_TYPES_SUCCESS:
	            return _extends({}, state, { fetchingPackageTypes: false, packageTypesFetched: action.payload.data, packageTypeFetchError: null });
	        case _type.FETCH_PACKAGE_TYPES_FAILURE:
	            var packageTypeFetchError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { fetchingPackageTypes: false, packageTypesFetched: false, packageTypeFetchError: packageTypeFetchError });
	        case _type.EDIT_PACKAGE_TYPE:
	            return _extends({}, state, { editingPackageTypes: true, packageTypesEdited: false, packageTypeEditError: null });
	        case _type.EDIT_PACKAGE_TYPE_SUCCESS:
	            return _extends({}, state, { editingPackageTypes: false, packageTypesEdited: true, packageTypeEditError: null });
	        case _type.EDIT_PACKAGE_TYPE_FAILURE:
	            var packageTypeEditError = action.payload.data || { message: action.data.message };
	            return _extends({}, state, { editingPackageTypes: false, packageTypesEdited: false, packageTypeEditError: packageTypeEditError });
	        case _type.REQUEST_DELETE_PACKAGE_TYPE:
	            return _extends({}, state, { deletingPackageTypes: true, deletePackageTypesSuccess: null, deletePackageTypesError: null });
	        case _type.DELETE_PACKAGE_TYPE_SUCCESS:
	            return _extends({}, state, { deletingPackageTypes: false, deletePackageTypesSuccess: true, deletePackageTypesError: null });
	        case _type.DELETE_PACKAGE_TYPE_FAILURE:
	            var deletePackageTypesError = action.payload.data || { message: action.payload.messge };
	            return _extends({}, state, { deletingPackageTypes: false, deletePackageTypesSuccess: null, deletePackageTypesError: deletePackageTypesError });
	        case _type.CLEAR_PACKAGE_TYPE_EDITED:
	            return _extends({}, state, { editingPackageTypes: false, packageTypesEdited: false, packageTypeEditError: null });
	        case _type.FETCH_MEASUREMENT_UNIT:
	            return _extends({}, state, { fetchingMeasurementUnit: true, measurementUnitFetched: false, measurementUnitFetchError: null });
	        case _type.FETCH_MEASUREMENT_UNIT_SUCCESS:
	            return _extends({}, state, { fetchingMeasurementUnit: false, measurementUnitFetched: action.payload.data, measurementUnitFetchError: null });
	        case _type.FETCH_MEASUREMENT_UNIT_FAILURE:
	            var measurementUnitFetchError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { fetchingMeasurementUnit: false, measurementUnitFetched: false, measurementUnitFetchError: measurementUnitFetchError });
	        case _type.EDIT_MEASUREMENT_UNIT:
	            return _extends({}, state, { editingMeasurementUnit: true, measurementUnitEdited: false, measurementUnitEditError: null });
	        case _type.EDIT_MEASUREMENT_UNIT_SUCCESS:
	            return _extends({}, state, { editingMeasurementUnit: false, measurementUnitEdited: true, measurementUnitEditError: null });
	        case _type.EDIT_MEASUREMENT_UNIT_FAILURE:
	            var measurementUnitEditError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { editingMeasurementUnit: false, measurementUnitEdited: false, measurementUnitEditError: measurementUnitEditError });
	        case _type.CLEAR_MEASUREMENT_UNIT_EDITED:
	            return _extends({}, state, { editingMeasurementUnit: false, measurementUnitEdited: false, measurementUnitEditError: null });
	        case _type.REQUEST_DELETE_MEASUREMENT_UNIT:
	            return _extends({}, state, { deletingMeasurementUnit: true, deleteMeasurementUnitSuccess: null, deleteMeasurementUnitError: null });
	        case _type.DELETE_MEASUREMENT_UNIT_SUCCESS:
	            return _extends({}, state, { deletingMeasurementUnit: false, deleteMeasurementUnitSuccess: true, deleteMeasurementUnitError: null });
	        case _type.DELETE_MEASUREMENT_UNIT_FAILURE:
	            var deleteMeasurementUnitError = action.payload.data || { message: action.payload.messge };
	            return _extends({}, state, { deletingMeasurementUnit: false, deleteMeasurementUnitSuccess: null, deleteMeasurementUnitError: deleteMeasurementUnitError });
	        case _type.FETCH_CONVERTABLE_PRODUCTS:
	            return _extends({}, state, { fetchingConvertableProducts: true, convertableProductsFetched: null, convertableProductsFetchError: null });
	        case _type.FETCH_CONVERTABLE_PRODUCTS_SUCCESS:
	            return _extends({}, state, { fetchingConvertableProducts: false, convertableProductsFetched: action.payload.data, convertableProductsFetchError: null });
	        case _type.FETCH_CONVERTABLE_PRODUCTS_FAILURE:
	            var convertableProductsFetchError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { fetchingConvertableProducts: false, convertableProductsFetched: null, convertableProductsFetchError: convertableProductsFetchError });
	        case _type.ATTACH_DOCUMENT:
	            return _extends({}, state, { isAttachingDocument: true, attachDocumentError: null, attachDocumentSuccess: false });
	        case _type.ATTACH_DOCUMENT_SUCCESS:
	            return _extends({}, state, { isAttachingDocument: false, attachDocumentError: null, attachDocumentSuccess: true });
	        case _type.ATTACH_DOCUMENT_FAILURE:
	            var attachDocumentError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { isAttachingDocument: false, attachDocumentError: attachDocumentError, attachDocumentSuccess: false });
	        case _type.REQUEST_CATEGORY2_PRODUCTS:
	            return _extends({}, state, { category2Id: action.payload, category2ProductsIsLoading: true, requestCategory2ProductsSuccess: null, requestCategory2ProductsError: null });
	        case _type.FETCH_CATEGORY2_PRODUCTS_SUCCESS:
	            return _extends({}, state, { category2Products: action.payload.data, category2ProductsIsLoading: false, requestCategory2ProductsSuccess: true, requestCategory2ProductsError: null });
	        case _type.FETCH_CATEGORY2_PRODUCTS_FAILURE:
	            var requestCategory2Error = action.payload.data || { message: action.payload.message };
	            alert(JSON.stringify(requestCategory2Error));
	            return _extends({}, state, { category2ProductsIsLoading: false, requestCategory2ProductsSuccess: false, requestCategory2ProductsError: null });
	
	        case _type.REQUEST_CATEGORY2_PRODUCTS_B2B:
	            return _extends({}, state, { category2IdB2B: action.payload, category2ProductsIsLoadingB2B: true, requestCategory2ProductsSuccessB2B: null, requestCategory2ProductsErrorB2B: null });
	        case _type.FETCH_CATEGORY2_PRODUCTS_SUCCESS_B2B:
	            return _extends({}, state, { category2ProductsB2B: action.payload.data, category2ProductsIsLoadingB2B: false, requestCategory2ProductsSuccessB2B: true, requestCategory2ProductsErrorB2B: null });
	        case _type.FETCH_CATEGORY2_PRODUCTS_FAILURE_B2B:
	            var requestCategory2ErrorB2B = action.payload.data || { message: action.payload.message };
	            alert(JSON.stringify(requestCategory2ErrorB2B));
	            return _extends({}, state, { category2ProductsIsLoadingB2B: false, requestCategory2ProductsSuccessB2B: false, requestCategory2ProductsErrorB2B: null });
	
	        case _type.RESET_CATEGORY2_ID:
	            return _extends({}, state, { category2Id: null, category2IdB2B: null });
	
	        case _type.DELETE_CATEGORY2_PRODUCT:
	            return _extends({}, state, { deletingCategory2Product: true, deleteCategory2ProductSuccess: false, deleteCategory2ProductError: null });
	        case _type.DELETE_CATEGORY2_PRODUCT_SUCCESS:
	            return _extends({}, state, { deletingCategory2Product: false, deleteCategory2ProductSuccess: true, deleteCategory2ProductError: null });
	        case _type.DELETE_CATEGORY2_PRODUCT_FAILURE:
	            var deleteCategory2ProductError = action.payload.data || { message: action.payload.message };
	            alert(JSON.stringify(deleteCategory2ProductError));
	            return _extends({}, state, { deletingCategory2Product: false, deleteCategory2ProductSuccess: false, deleteCategory2ProductError: null });
	
	        // discontinuing product
	        case _type.REQUEST_CONTINUE_OR_DISCONTINUE_PRODUCT:
	            return _extends({}, state, { continuingOrDiscontinuingProduct: true, continueOrDiscontinueProductSuccess: false, continueOrDiscontinueProductError: null });
	        case _type.CONTINUE_OR_DISCONTINUE_PRODUCT_SUCCESS:
	            return _extends({}, state, { continuingOrDiscontinuingProduct: false, continueOrDiscontinueProductSuccess: true, continueOrDiscontinueProductError: null });
	        case _type.CONTINUE_OR_DISCONTINUE_PRODUCT_FAILURE:
	            return _extends({}, state, { continuingOrDiscontinuingProduct: false, continueOrDiscontinueProductSuccess: false, continueOrDiscontinueProductError: action.payload.message });
	
	        case _type.REQUEST_UPDATE_PRODUCT:
	            return _extends({}, state, { updateProductError: null, updateProductIsLoading: true, updateProduct: null });
	        case _type.UPDATE_PRODUCT_SUCCEESS:
	            return _extends({}, state, { updateProductError: null, updateProductIsLoading: false, updateProduct: action.payload });
	        case _type.UPDATE_PRODUCT_FAILURE:
	            var requestUpdateProductError = action.payload.data || { message: action.payload.message };
	            alert(JSON.stringify(requestUpdateProductError));
	            return _extends({}, state, { updateProductError: requestUpdateProductError, updateProductIsLoading: false, updateProduct: null });
	        case _type.REQUEST_SAVE_MOBILE_DESCRIPTION_BOX_TEXT:
	            return _extends({}, state, {
	                savingMobileDescriptionText: true,
	                saveMobileDescriptionTextSuccess: false,
	                saveMobileDescriptionTextError: null
	            });
	        case _type.SAVE_MOBILE_DESCRIPTION_BOX_TEXT_SUCCESS:
	            return _extends({}, state, {
	                savingMobileDescriptionText: false,
	                saveMobileDescriptionTextSuccess: true,
	                saveMobileDescriptionTextError: null
	            });
	        case _type.SAVE_MOBILE_DESCRIPTION_BOX_TEXT_FAILURE:
	            {
	                var saveMobileDescriptionTextError = action.payload.data || { message: action.payload.message };
	                alert(JSON.stringify(saveMobileDescriptionTextError));
	                return _extends({}, state, {
	                    savingMobileDescriptionText: false,
	                    saveMobileDescriptionTextSuccess: false,
	                    saveMobileDescriptionTextError: saveMobileDescriptionTextError
	                });
	            }
	        case _type.SET_ROWS_FILTERS:
	            {
	                return _extends({}, state, {
	                    filters: action.payload
	                });
	            };
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/products_reducer.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/products_reducer.js');
	}();

	;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _INITIAL_STATE;
	
	var _type = __webpack_require__(14);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var INITIAL_STATE = (_INITIAL_STATE = {
	    all: [],
	    currentPromotions: null,
	    currentPromotionsDetail: null,
	    isLoading: false,
	    error: null,
	    promotionsAreLoading: false,
	    promotionsError: null,
	    isCreating: false,
	    createError: null,
	    created: false,
	    isEditing: false,
	    editError: null,
	    edited: false,
	    addError: null,
	    addPromotionSuccess: false,
	    editIsLoading: false,
	    editPromotionSuccess: false
	}, _defineProperty(_INITIAL_STATE, 'editError', null), _defineProperty(_INITIAL_STATE, 'promoNotes', null), _defineProperty(_INITIAL_STATE, 'promoNotesIsLoading', false), _defineProperty(_INITIAL_STATE, 'promoNotesError', null), _defineProperty(_INITIAL_STATE, 'savePromoNotesSuccess', null), _defineProperty(_INITIAL_STATE, 'currentPromo', null), _defineProperty(_INITIAL_STATE, 'savingPromotion', false), _defineProperty(_INITIAL_STATE, 'promotionDetails', null), _defineProperty(_INITIAL_STATE, 'promotionDetailsIsLoading', false), _defineProperty(_INITIAL_STATE, 'promotionDetailsError', null), _INITIAL_STATE);
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        // Promotions action handlers
	        case _type.REQUEST_PROMOTIONS:
	            return _extends({}, state, { error: null, all: [], isLoading: true });
	        case _type.FETCH_PROMOTIONS_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false, addPromotionSuccess: false, editPromotionSuccess: false });
	        case _type.FETCH_PROMOTIONS_FAILURE:
	            var error = action.payload || { message: action.payload.message };
	            return _extends({}, state, { all: [], error: error, isLoading: false });
	        case _type.SELECT_PROMOTIONS:
	            return _extends({}, state, { currentPromotions: action.payload });
	        case _type.RESET_CURRENT_PROMOTIONS:
	            return _extends({}, state, { currentPromotions: null, currentPromotionsDetail: null, addPromotionSuccess: false, editPromotionSuccess: false });
	        case _type.REQUEST_PROMOTIONS_DETAIL:
	            return _extends({}, state, { promotionsError: null, promotionsAreLoading: true });
	        case _type.FETCH_PROMOTIONS_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { currentPromotionsDetail: action.payload, promotionsError: null, promotionsAreLoading: false });
	        case _type.FETCH_PROMOTIONS_DETAIL_FAILURE:
	            // return error and make loading = false
	            var promotionsError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { all: [], promotionsError: promotionsError, promotionsAreLoading: false });
	        case _type.REQUEST_ADDING_PROMOTION:
	            return _extends({}, state, { addError: null, isLoading: true });
	        case _type.ADD_PROMOTION_SUCCESS:
	            return _extends({}, state, { isLoading: false, addPromotionSuccess: true });
	        case _type.ADD_PROMOTION_FAILURE:
	            var addError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { addError: addError, isLoading: false });
	        case _type.REQUEST_EDITING_PROMOTION:
	            return _extends({}, state, { editError: null, editIsLoading: true });
	        case _type.EDIT_PROMOTION_SUCCESS:
	            return _extends({}, state, { editIsLoading: false, editPromotionSuccess: true });
	        case _type.EDIT_PROMOTION_FAILURE:
	            var editError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { editError: editError, editIsLoading: false });
	        case _type.REQUEST_DELETE_PROMOTION:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.DELETE_PROMOTION_SUCCESS:
	            return _extends({}, state, { isLoading: false });
	        case _type.DELETE_PROMOTION_FAILURE:
	            return _extends({}, state, { error: error, isLoading: false });
	        case _type.REQUEST_PROMO_NOTES:
	            return _extends({}, state, { promoNotesIsLoading: true, promoNotesError: null });
	        case _type.FETCH_PROMO_NOTES_SUCCESS:
	            return _extends({}, state, { promoNotesIsLoading: false, promoNotes: action.payload.data });
	        case _type.FETCH_PROMO_NOTES_FAILURE:
	            var promoNotesError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { promoNotesIsLoading: false, promoNotesError: promoNotesError });
	        case _type.SAVE_PROMO_NOTES_SUCCESS:
	            return _extends({}, state, { savePromoNotesSuccess: true });
	        case _type.SAVE_PROMO_NOTES_FAILURE:
	            var savePromoNotesError = action.payload.data || { message: action.payload.message };
	            alert(JSON.stringify(savePromoNotesError));
	            return _extends({}, state, { savePromoNotesSuccess: false });
	        case _type.CLEAR_PROMO_NOTES_STATUS:
	            return _extends({}, state, { savePromoNotesSuccess: null });
	        case _type.SET_CURRENT_PROMO:
	            return _extends({}, state, { currentPromo: action.payload.data });
	        case _type.RESET_CURRENT_PROMO:
	            return _extends({}, state, { currentPromo: null });
	        case _type.REQUEST_PROMO_DETAILS:
	            return _extends({}, state, { promotionDetailsIsLoading: true, promotionDetails: null, promotionDetailsError: null });
	        case _type.FETCH_PROMO_DETAILS_SUCCESS:
	            return _extends({}, state, { promotionDetailsIsLoading: false, promotionDetails: action.payload.data });
	        case _type.FETCH_PROMO_DETAILS_FAILURE:
	            var promotionDetailsError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { promotionDetailsIsLoading: false, promotionDetails: null, promotionDetailsError: promotionDetailsError });
	        case _type.SAVE_PROMOTION_SUCCESS:
	            return _extends({}, state, { promotionDetailsError: null, savingPromotion: false });
	        case _type.REQUEST_SAVE_PROMOTION:
	            return _extends({}, state, { promotionDetailsError: null, savingPromotion: true });
	        case _type.CLEAR_PROMO_DETAIL_STATUS:
	            return _extends({}, state, { promotionDetailsError: null });
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/promotions_reducer.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/promotions_reducer.jsx');
	}();

	;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _INITIAL_STATE;
	
	var _type = __webpack_require__(14);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var INITIAL_STATE = (_INITIAL_STATE = {
	  all: null,
	  currentPurchaseOrder: null,
	  currentPurchaseOrderDetail: null,
	  isLoading: true,
	  error: null,
	  detailIsLoading: false,
	  detailError: null,
	  purchaseOrderIsCreating: false,
	  purchaseOrderCreateError: null,
	  purchaseOrderCreated: null,
	  purchaseOrderIsCopying: false,
	  purchaseOrderCopyError: null,
	  purchaseOrderCopied: false,
	  purchaseOrderIsEditing: false,
	  purchaseOrderEditError: null,
	  purchaseOrderEdited: false,
	  numPurchaseOrdersNotReceived: null,
	  numPurchaseOrdersNotReceivedLoading: null,
	  numPurchaseOrdersNotReceivedError: null,
	  numTotalPurchases: null,
	  numTotalPurchasesLoading: null,
	  numTotalPurchasesError: null,
	  todaysIncomingOrders: [],
	  todaysIncomingOrdersIsLoading: null,
	  todaysIncomingOrdersError: null,
	  purchaseOrderIsDeleting: false,
	  purchaseOrderDeleteError: null,
	  purchaseOrderIsDeleted: false,
	  purchaseOrderPerformance: [],
	  purchaseOrderPerformanceIsLoading: false,
	  purchaseOrderPerformanceError: null,
	  purchaseManagerInfo: {},
	  purchaseManagerInfoIsLoading: false,
	  purchaseManagerInfoError: null,
	  lastMonth: [],
	  lastMonthIsLoading: false,
	  lastMonthError: null,
	  purchasersPerformance: [],
	  purchasersPerformanceIsLoading: false,
	  purchasersPerformanceError: null,
	  presidentInfo: {},
	  presidentInfoIsLoading: false,
	  presidentInfoError: null,
	  overallPurchases: [],
	  overallPurchasesIsLoading: false,
	  overallPurchasesError: null,
	  incidentReport: [],
	  incidentReportIsLoading: false,
	  incidentReportError: null,
	  purchaseOrderList: [],
	  purchaseOrderListIsLoading: false,
	  purchaseOrderListError: null,
	  purchaseOrdersFilter: null,
	  purchasingPerformanceIsLoading: false,
	  purchasingPerformance: null,
	  purchasingPerformanceError: null,
	  priceAdjustmentIsLoading: false,
	  priceAdjustment: null,
	  priceAdjustmentError: null,
	  purchasePivotChartOrdersIsLoading: false,
	  purchasePivotChartOrders: null,
	  purchasePivotChartOrdersError: null,
	  purchasePivotChartsIsLoading: false,
	  purchasePivotCharts: null,
	  purchasePivotChartsError: null,
	  purchasePivotChartsDetailIsLoading: false,
	  purchasePivotChartsDetail: null,
	  purchasePivotChartsDetailError: null,
	  purchasePivot_id: null,
	  isDuplicatingPurchasePivotChart: false,
	  duplicatedPurchasePivotChart: false,
	  duplicatePurchasePivotChartError: null
	}, _defineProperty(_INITIAL_STATE, 'duplicatedPurchasePivotChart', null), _defineProperty(_INITIAL_STATE, 'duplicatePurchasePivotChartError', null), _defineProperty(_INITIAL_STATE, 'purchaseReferenceReportIsLoading', false), _defineProperty(_INITIAL_STATE, 'purchaseReferenceReport', null), _defineProperty(_INITIAL_STATE, 'purchaseReferenceReportError', null), _defineProperty(_INITIAL_STATE, 'numPurchaseOrdersNotPaid', null), _defineProperty(_INITIAL_STATE, 'numPurchaseOrdersNotPaidLoading', null), _defineProperty(_INITIAL_STATE, 'numPurchaseOrdersNotPaidError', null), _defineProperty(_INITIAL_STATE, 'purchaseOrderPerformanceByProduct', []), _defineProperty(_INITIAL_STATE, 'purchaseOrderPerformanceByProductIsLoading', false), _defineProperty(_INITIAL_STATE, 'purchaseOrderPerformanceByProductError', null), _defineProperty(_INITIAL_STATE, 'purchaseOrderProduct', null), _defineProperty(_INITIAL_STATE, 'purchaseOrderProductIsLoading', false), _defineProperty(_INITIAL_STATE, 'purchaseOrderProductError', null), _defineProperty(_INITIAL_STATE, 'mergePurchaseOrderLoading', false), _defineProperty(_INITIAL_STATE, 'mergePurchaseOrderSuccess', false), _defineProperty(_INITIAL_STATE, 'mergePurchaseOrderError', ''), _defineProperty(_INITIAL_STATE, 'mergePurchaseOrderData', []), _INITIAL_STATE);
	
	var _default = function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    // Product action handlers
	    case _type.REQUEST_PURCHASE_ORDERS_BY_FILTER:
	    case _type.REQUEST_PURCHASE_ORDERS:
	      return _extends({}, state, { all: null, error: null, isLoading: true
	      });
	    case _type.FETCH_PURCHASE_ORDERS_SUCCESS:
	      return _extends({}, state, { all: action.payload.data, error: null, isLoading: false
	      });
	    case _type.FETCH_PURCHASE_ORDERS_FAILURE:
	      var error = action.payload || { message: action.payload.message };
	      return _extends({}, state, { all: null, error: error, isLoading: false
	      });
	    case _type.SELECT_PURCHASE_ORDER:
	      return _extends({}, state, { currentPurchaseOrder: action.payload, currentPurchaseOrderDetail: null, purchaseOrderEditError: null, purchaseOrderCreateError: null
	      });
	    case _type.RESET_CURRENT_PURCHASE_ORDER:
	      return _extends({}, state, { currentPurchaseOrder: null, currentPurchaseOrderDetail: null, purchaseOrderEditError: null, purchaseOrderCreateError: null, purchaseOrderCreated: null, purchaseOrderEdited: null
	      });
	    case _type.REQUEST_PURCHASE_ORDER_DETAIL:
	      return _extends({}, state, { detailError: null, detailIsLoading: true });
	    case _type.FETCH_PURCHASE_ORDER_DETAIL_SUCCESS:
	      // return list of posts and make loading = false
	      return _extends({}, state, { currentPurchaseOrderDetail: action.payload, detailError: null, detailIsLoading: false
	      });
	    case _type.FETCH_PURCHASE_ORDER_DETAIL_FAILURE:
	      // return error and make loading = false
	      var detailError = action.payload || { message: action.payload.message }; // 2nd one is network or server down errors
	      return _extends({}, state, { all: [], detailError: detailError, detailIsLoading: false
	      });
	    case _type.REQUEST_CREATING_PURCHASE_ORDER:
	      return _extends({}, state, { purchaseOrderIsCreating: true, purchaseOrderCreateError: null, purchaseOrderCreated: null, purchaseOrderEdited: null
	      });
	    case _type.CREATE_PURCHASE_ORDER_SUCCESS:
	      return _extends({}, state, { purchaseOrderIsCreating: false, purchaseOrderCreateError: null, purchaseOrderCreated: action.payload.data
	      });
	    case _type.CREATE_PURCHASE_ORDER_FAILURE:
	      var purchaseOrderCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	      return _extends({}, state, { purchaseOrderIsCreating: false, purchaseOrderCreateError: purchaseOrderCreateError, purchaseOrderCreated: null
	      });
	    case _type.COPY_PURCHASE_ORDER:
	      return _extends({}, state, { purchaseOrderIsCopying: true, purchaseOrderCopyError: null, purchaseOrderCopied: false
	      });
	    case _type.COPY_PURCHASE_ORDER_SUCCESS:
	      return _extends({}, state, { purchaseOrderIsCopying: false, purchaseOrderCopyError: null, purchaseOrderCopied: true
	      });
	    case _type.COPY_PURCHASE_ORDER_FAILURE:
	      var purchaseOrderCopyError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	      return _extends({}, state, { purchaseOrderIsCopying: false, purchaseOrderCopyError: purchaseOrderCopyError, purchaseOrderCopied: false
	      });
	    case _type.REQUEST_EDITING_PURCHASE_ORDER:
	      return _extends({}, state, { purchaseOrderIsEditing: true, purchaseOrderEditError: null, purchaseOrderEdited: false, purchaseOrderCreated: null
	      });
	    case _type.EDIT_PURCHASE_ORDER_SUCCESS:
	      return _extends({}, state, { purchaseOrderIsEditing: false, purchaseOrderEditError: null, purchaseOrderEdited: true
	      });
	    case _type.EDIT_PURCHASE_ORDER_FAILURE:
	      var purchaseOrderEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	      return _extends({}, state, { purchaseOrderIsEditing: false, purchaseOrderEditError: purchaseOrderEditError, purchaseOrderEdited: false
	      });
	    case _type.REQUEST_PURCHASE_ORDERS_NOT_RECEIVED:
	      return _extends({}, state, { numPurchaseOrdersNotReceivedError: null, numPurchaseOrdersNotReceivedLoading: true });
	    case _type.FETCH_PURCHASE_ORDERS_NOT_RECEIVED_SUCCESS:
	      return _extends({}, state, { numPurchaseOrdersNotReceived: action.payload.data.number, numPurchaseOrdersNotReceivedLoading: false });
	    case _type.FETCH_PURCHASE_ORDERS_NOT_RECEIVED_FAILURE:
	      return _extends({}, state, { numPurchaseOrdersNotReceivedError: action.payload.data, numPurchaseOrdersNotReceivedLoading: false });
	    case _type.REQUEST_TOTAL_PURCHASES:
	      return _extends({}, state, { numTotalPurchasesError: null, numTotalPurchasesLoading: true });
	    case _type.FETCH_TOTAL_PURCHASES_SUCCESS:
	      return _extends({}, state, { numTotalPurchases: action.payload.data.number, numTotalPurchasesLoading: false });
	    case _type.FETCH_TOTAL_PURCHASES_FAILURE:
	      return _extends({}, state, { numTotalPurchasesError: action.payload.data, numTotalPurchasesLoading: false });
	    case _type.REQUEST_TODAYS_INCOMING_ORDERS:
	      return _extends({}, state, { todaysIncomingOrdersIsLoading: true, todaysIncomingOrdersError: null });
	    case _type.FETCH_TODAYS_INCOMING_ORDERS_SUCCESS:
	      return _extends({}, state, { todaysIncomingOrders: action.payload.data, todaysIncomingOrdersIsLoading: false });
	    case _type.FETCH_TODAYS_INCOMING_ORDERS_FAILURE:
	      var todaysIncomingOrdersError = action.payload.data || { messate: action.payload.message };
	      return _extends({}, state, { todaysIncomingOrdersError: todaysIncomingOrdersError, todaysIncomingOrdersIsLoading: false });
	    case _type.REQUEST_PRINT_PURCHASE_ORDER:
	      return _extends({}, state, { purchaseOrderIsPrinting: true, purchaseOrderPrintError: null, purchaseOrderIsPrinted: null
	      });
	    case _type.PRINT_PURCHASE_ORDER_SUCCESS:
	      return _extends({}, state, { purchaseOrderIsPrinting: false, purchaseOrderPrintError: null, purchaseOrderIsPrinted: action.payload.data
	      });
	    case _type.PRINT_PURCHASE_ORDER_FAILURE:
	      var purchaseOrderPrintError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { purchaseOrderIsPrinting: false, purchaseOrderPrintError: purchaseOrderPrintError, purchaseOrderIsPrinted: null
	      });
	    case _type.REQUEST_DELETE_PURCHASE_ORDER:
	      return _extends({}, state, { purchaseOrderIsDeleting: true, purchaseOrderDeleteError: null, purchaseOrderIsDeleted: false
	      });
	    case _type.DELETE_PURCHASE_ORDER_SUCCESS:
	      return _extends({}, state, { purchaseOrderIsDeleting: false, purchaseOrderDeleteError: null, purchaseOrderIsDeleted: true
	      });
	    case _type.DELETE_PURCHASE_ORDER_FAILURE:
	      var purchaseOrderDeleteError = action.payload.data || { messate: action.payload.message };
	      return _extends({}, state, { purchaseOrderIsDeleting: false, purchaseOrderDeleteError: purchaseOrderDeleteError, purchaseOrderIsDeleted: false
	      });
	    case _type.REQUEST_PURCHASE_ORDER_PERFORMANCE:
	      return _extends({}, state, { purchaseOrderPerformanceIsLoading: true, purchaseOrderPerformanceError: null });
	    case _type.FETCH_PURCHASE_ORDER_PERFORMANCE_SUCCESS:
	      return _extends({}, state, { purchaseOrderPerformanceIsLoading: false, purchaseOrderPerformance: action.payload.data });
	    case _type.FETCH_PURCHASE_ORDER_PERFORMANCE_FAILURE:
	      var purchaseOrderPerformanceError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { purchaseOrderPerformanceIsLoading: false, purchaseOrderPerformanceError: purchaseOrderPerformanceError });
	    case _type.REQUEST_PURCHASE_MANAGER_INFO:
	      return _extends({}, state, { purchaseManagerInfoIsLoading: true, purchaseManagerInfo: null, purchaseManagerInfoError: null
	      });
	    case _type.FETCH_PURCHASE_MANAGER_INFO_SUCCESS:
	      return _extends({}, state, { purchaseManagerInfoIsLoading: false, purchaseManagerInfo: action.payload.data });
	    case _type.FETCH_PURCHASE_MANAGER_INFO_FAILURE:
	      var purchaseManagerInfoError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { purchaseManagerInfoIsLoading: false, purchaseManagerInfoError: purchaseManagerInfoError });
	    case _type.REQUEST_LAST_MONTH_PERFORMANCE:
	      return _extends({}, state, { lastMonthIsLoading: true, lastMonth: [], lastMonthError: null
	      });
	    case _type.FETCH_LAST_MONTH_PERFORMANCE_SUCCESS:
	      return _extends({}, state, { lastMonthIsLoading: false, lastMonth: action.payload.data });
	    case _type.FETCH_LAST_MONTH_PERFORMANCE_FAILURE:
	      var lastMonthError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { lastMonthIsLoading: false, lastMonthError: lastMonthError });
	    case _type.REQUEST_PURCHASERS_PERFORMANCE:
	      return _extends({}, state, { purchasersPerformanceIsLoading: true, purchasersPerformance: [], purchasersPerformanceError: null
	      });
	    case _type.FETCH_PURCHASERS_PERFORMANCE_SUCCESS:
	      return _extends({}, state, { purchasersPerformanceIsLoading: false, purchasersPerformance: action.payload.data });
	    case _type.FETCH_PURCHASERS_PERFORMANCE_FAILURE:
	      var purchasersPerformanceError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { purchasersPerformanceIsLoading: false, purchasersPerformanceError: purchasersPerformanceError });
	    case _type.REQUEST_PRESIDENT_DASH_INFO:
	      return _extends({}, state, { presidentInfoIsLoading: true, presidentInfo: {}, presidentInfoError: null
	      });
	    case _type.FETCH_PRESIDENT_DASH_INFO_SUCCESS:
	      return _extends({}, state, { presidentInfoIsLoading: false, presidentInfo: action.payload.data });
	    case _type.FETCH_PRESIDENT_DASH_INFO_FAILURE:
	      var presidentInfoError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { presidentInfoIsLoading: false, presidentInfoError: presidentInfoError });
	    case _type.REQUEST_OVERALL_PURCHASE_PERFORMANCE:
	      return _extends({}, state, { overallPurchasesIsLoading: true, overallPurchasesError: null, overallPurchases: []
	      });
	    case _type.FETCH_OVERALL_PURCHASE_PERFORMANCE_SUCCESS:
	      return _extends({}, state, { overallPurchasesIsLoading: false, overallPurchases: action.payload.data });
	    case _type.FETCH_OVERALL_PURCHASE_PERFORMANCE_FAILURE:
	      var overallPurchasesError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { overallPurchasesIsLoading: false, overallPurchasesError: overallPurchasesError });
	    case _type.REQUEST_INCIDENT_REPORT:
	      return _extends({}, state, { incidentReportIsLoading: true, incidentReport: [], incidentReportError: null
	      });
	    case _type.FETCH_INCIDENT_REPORT_SUCCESS:
	      return _extends({}, state, { incidentReportIsLoading: false, incidentReport: action.payload.data });
	    case _type.FETCH_INCIDENT_REPORT_FAILURE:
	      var incidentReportError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { incidentReportIsLoading: false, incidentReportError: incidentReportError });
	    case _type.REQUEST_PURCHASE_ORDER_LIST:
	      return _extends({}, state, { purchaseOrderListIsLoading: true, purchaseOrderList: [], purchaseOrderListError: null
	      });
	    case _type.FETCH_PURCHASE_ORDER_LIST_SUCCESS:
	      return _extends({}, state, { purchaseOrderListIsLoading: false, purchaseOrderList: action.payload.data });
	    case _type.FETCH_PURCHASE_ORDER_LIST_FAILURE:
	      var purchaseOrderListError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { purchaseOrderListIsLoading: false, purchaseOrderListError: purchaseOrderListError });
	    case _type.SET_PURCHASE_ORDERS_FILTER:
	      return _extends({}, state, { purchaseOrdersFilter: action.payload });
	    case _type.REQUEST_PURCHASING_PERFORMANCE:
	    case _type.REQUEST_PURCHASING_PERFORMANCE_BY_FILTER:
	      return _extends({}, state, { purchasingPerformanceIsLoading: true, purchasingPerformance: null, purchasingPerformanceError: null
	      });
	    case _type.FETCH_PURCHASING_PERFORMANCE_SUCCESS:
	      return _extends({}, state, { purchasingPerformanceIsLoading: false, purchasingPerformance: action.payload.data, purchasingPerformanceError: null
	      });
	    case _type.FETCH_PURCHASING_PERFORMANCE_FAILURE:
	      var purchasingPerformanceError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { purchasingPerformanceIsLoading: false, purchasingPerformance: null, purchasingPerformanceError: purchasingPerformanceError
	      });
	    case _type.REQUEST_PRICE_ADJUSTMENT:
	      return _extends({}, state, { priceAdjustmentIsLoading: true, priceAdjustment: null, priceAdjustmentError: null
	      });
	    case _type.FETCH_PRICE_ADJUSTMENT_SUCCESS:
	      return _extends({}, state, { priceAdjustmentIsLoading: false, priceAdjustment: action.payload.data, priceAdjustmentError: null
	      });
	    case _type.FETCH_PRICE_ADJUSTMENT_FAILURE:
	      var priceAdjustmentError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { priceAdjustmentIsLoading: false, priceAdjustment: null, priceAdjustmentError: priceAdjustmentError
	      });
	    case _type.REQUEST_PURCHASE_PIVOT_CHART_ORDERS:
	      return _extends({}, state, { purchasePivotChartOrdersIsLoading: true, purchasePivotChartOrders: null, purchasePivotChartOrdersError: null
	      });
	    case _type.FETCH_PURCHASE_PIVOT_CHART_ORDERS_SUCCESS:
	      return _extends({}, state, { purchasePivotChartOrdersIsLoading: false, purchasePivotChartOrders: action.payload.data, purchasePivotChartOrdersError: null
	      });
	    case _type.FETCH_PURCHASE_PIVOT_CHART_ORDERS_FAILURE:
	      var purchasePivotChartOrdersError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { purchasePivotChartOrdersIsLoading: false, purchasePivotChartOrders: null, purchasePivotChartOrdersError: purchasePivotChartOrdersError
	      });
	    case _type.REQUEST_PURCHASE_PIVOT_CHARTS:
	      return _extends({}, state, { purchasePivotChartsIsLoading: true, purchasePivotCharts: null, purchasePivotChartsError: null
	      });
	    case _type.FETCH_PURCHASE_PIVOT_CHARTS_SUCCESS:
	      return _extends({}, state, { purchasePivotChartsIsLoading: false, purchasePivotCharts: action.payload.data, purchasePivotChartsError: null
	      });
	    case _type.FETCH_PURCHASE_PIVOT_CHARTS_FAILURE:
	      var purchasePivotChartsError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { purchasePivotChartsIsLoading: false, purchasePivotCharts: null, purchasePivotChartsError: purchasePivotChartsError
	      });
	    case _type.REQUEST_PURCHASE_PIVOT_CHARTS_DETAIL:
	      return _extends({}, state, { purchasePivotChartsDetailIsLoading: true, purchasePivotChartsDetail: null, purchasePivotChartsDetailError: null
	      });
	    case _type.FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_SUCCESS:
	      return _extends({}, state, { purchasePivotChartsDetailIsLoading: false, purchasePivotChartsDetail: action.payload.data, purchasePivotChartsDetailError: null
	      });
	    case _type.FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_FAILURE:
	      var purchasePivotChartsDetailError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { purchasePivotChartsDetailIsLoading: false, purchasePivotChartsDetail: null, purchasePivotChartsDetailError: purchasePivotChartsDetailError
	      });
	    case _type.RESET_PURCHASE_PIVOT_CHARTS:
	      return _extends({}, state, { purchasePivotChartsDetail: null });
	    case _type.SET_PURCHASE_PIVOT_ID:
	      return _extends({}, state, { purchasePivot_id: action.payload });
	    case _type.DUPLICATE_PURCHASE_PIVOT_CHART:
	      return _extends({}, state, { isDuplicatingPurchasePivotChart: true, duplicatedPurchasePivotChart: false, duplicatePurchasePivotChartError: null
	      });
	    case _type.DUPLICATE_PURCHASE_PIVOT_CHART_SUCCESS:
	      return _extends({}, state, { isDuplicatingPurchasePivotChart: false, duplicatedPurchasePivotChart: true, duplicatePurchasePivotChartError: null
	      });
	    case _type.DUPLICATE_PURCHASE_PIVOT_CHART_FAILURE:
	      var duplicatePurchasePivotChartError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { isDuplicatingPurchasePivotChart: false, duplicatedPurchasePivotChart: false, duplicatePurchasePivotChartError: duplicatePurchasePivotChartError
	      });
	    case _type.CLEAR_DUPLICATED_PURCHASE_PIVOT_CHART:
	      console.log('here...clear');
	      return _extends({}, state, { isDuplicatingPurchasePivotChart: false, duplicatedPurchasePivotChart: false, duplicatePurchasePivotChartError: null
	      });
	    case _type.REQUEST_PURCHASING_REFERENCE:
	      return _extends({}, state, { purchaseReferenceReportIsLoading: true, purchaseReferenceReport: null, purchaseReferenceReportError: null
	      });
	    case _type.FETCH_PURCHASING_REFERENCE_SUCCESS:
	      return _extends({}, state, { purchaseReferenceReportIsLoading: false, purchaseReferenceReport: action.payload.data, purchaseReferenceReportError: null
	      });
	    case _type.FETCH_PURCHASING_REFERENCE_FAILURE:
	      var purchaseReferenceReportError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { purchaseReferenceReportIsLoading: false, purchaseReferenceReport: null, purchaseReferenceReportError: purchaseReferenceReportError
	      });
	    case _type.REQUEST_PURCHASE_PAYMENT_NOT_PAID:
	      return _extends({}, state, { numPurchaseOrdersNotPaidError: null, numPurchaseOrdersNotPaidLoading: true });
	    case _type.FETCH_PURCHASE_PAYMENT_NOT_PAID_SUCCESS:
	      return _extends({}, state, { numPurchaseOrdersNotPaid: action.payload.data.payment, numPurchaseOrdersNotPaidLoading: false });
	    case _type.FETCH_PURCHASE_PAYMENT_NOT_PAID_FAILURE:
	      return _extends({}, state, { numPurchaseOrdersNotPaidError: action.payload.data, numPurchaseOrdersNotPaidLoading: false });
	    case _type.REQUEST_PURCHASING_PERFORMANCE_BY_PRODUCT:
	      return _extends({}, state, { purchaseOrderPerformanceByProductIsLoading: true, purchaseOrderPerformanceByProductError: null });
	    case _type.FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_SUCCESS:
	      console.log(action.payload.data);
	      return _extends({}, state, { purchaseOrderPerformanceByProductIsLoading: false, purchaseOrderPerformanceByProduct: action.payload.data });
	    case _type.FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_FAILURE:
	      var purchaseOrderPerformanceByProductError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { purchaseOrderPerformanceByProductIsLoading: false, purchaseOrderPerformanceByProductError: purchaseOrderPerformanceByProductError });
	    case _type.REQUEST_PURCHASE_PRODUCT_BY_ID:
	      return _extends({}, state, { purchaseOrderProductIsLoading: true, purchaseOrderProduct: null, purchaseOrderProductError: null
	      });
	    case _type.FETCH_PURCHASE_PRODUCT_BY_ID_SUCCESS:
	      return _extends({}, state, { purchaseOrderProductIsLoading: false, purchaseOrderProduct: action.payload.data });
	    case _type.FETCH_PURCHASE_PRODUCT_BY_ID_FAILURE:
	      return _extends({}, state, { purchaseOrderProductIsLoading: false, purchaseOrderProductError: action.payload.data });
	    case _type.MERGE_PURCHASE_ORDERS_LOADING:
	      return _extends({}, state, { mergePurchaseOrderLoading: true, mergePurchaseOrderSuccess: false, mergePurchaseOrderError: ''
	      });
	    case _type.MERGE_PURCHASE_ORDERS_SUCCESS:
	      return _extends({}, state, { mergePurchaseOrderLoading: false, mergePurchaseOrderSuccess: true, mergePurchaseOrderError: ''
	      });
	    case _type.MERGE_PURCHASE_ORDERS_ERROR:
	      return _extends({}, state, { mergePurchaseOrderLoading: false, mergePurchaseOrderSuccess: false, mergePurchaseOrderError: action.payload
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/purchaseOrders_reducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/purchaseOrders_reducer.js');
	}();

	;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    all: [],
	    numPurchaseQuotes: null,
	    currentPurchaseQuote: null,
	    currentPurchaseQuoteDetail: null,
	    isLoading: true,
	    error: null,
	    detailIsLoading: false,
	    numPurchaseQuotesLoading: false,
	    numPurchaseQuotesError: null,
	    detailError: null,
	    purchaseQuoteIsCreating: false,
	    purchaseQuoteCreateError: null,
	    purchaseQuoteCreated: null,
	    purchaseQuoteIsPlacing: false,
	    purchaseQuotePlaceError: null,
	    purchaseQuotePlaced: false,
	    purchaseQuoteIsEditing: false,
	    purchaseQuoteEditError: null,
	    purchaseQuoteEdited: false,
	    purchaseQuoteIsDeleting: false,
	    purchaseQuoteDeleteError: null,
	    purchaseQuoteIsDeleted: false
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        // Product action handlers
	        case _type.REQUEST_PURCHASE_QUOTES:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.FETCH_PURCHASE_QUOTES_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	        case _type.FETCH_PURCHASE_QUOTES_FAILURE:
	            var error = action.payload || { message: action.payload.message };
	            return _extends({}, state, { all: [], error: error, isLoading: false });
	        case _type.SELECT_PURCHASE_QUOTE:
	            return _extends({}, state, { currentPurchaseQuote: action.payload });
	        case _type.RESET_CURRENT_PURCHASE_QUOTE:
	            return _extends({}, state, { currentPurchaseQuote: null, currentPurchaseQuoteDetail: null, purchaseQuoteCreateError: null, purchaseQuoteEditError: null, purchaseQuoteCreated: null, purchaseQuotePlaced: false });
	        case _type.REQUEST_PURCHASE_QUOTE_DETAIL:
	            return _extends({}, state, { detailError: null, detailIsLoading: true });
	        case _type.FETCH_PURCHASE_QUOTE_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { currentPurchaseQuoteDetail: action.payload, detailError: null, detailIsLoading: false });
	        case _type.FETCH_PURCHASE_QUOTE_DETAIL_FAILURE:
	            // return error and make loading = false
	            var detailError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { all: [], detailError: detailError, detailIsLoading: false });
	        case _type.REQUEST_CREATING_PURCHASE_QUOTE:
	            return _extends({}, state, { purchaseQuoteIsCreating: true, purchaseQuoteCreateError: null, purchaseQuoteCreated: null });
	        case _type.CREATE_PURCHASE_QUOTE_SUCCESS:
	            return _extends({}, state, { purchaseQuoteIsCreating: false, purchaseQuoteCreateError: null, purchaseQuoteCreated: action.payload.data });
	        case _type.CREATE_PURCHASE_QUOTE_FAILURE:
	            var purchaseQuoteCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { purchaseQuoteIsCreating: false, purchaseQuoteCreateError: purchaseQuoteCreateError, purchaseQuoteCreated: null });
	
	        case _type.REQUEST_PURCHASE_QUOTE_PLACE:
	            return _extends({}, state, { purchaseQuoteIsPlacing: true, purchaseQuotePlaceError: null, purchaseQuotePlaced: false });
	        case _type.PURCHASE_QUOTE_PLACE_SUCCESS:
	            return _extends({}, state, { purchaseQuoteIsPlacing: false, purchaseQuotePlaceError: null, purchaseQuotePlaced: true });
	        case _type.PURCHASE_QUOTE_PLACE_FAILURE:
	            var purchaseQuotePlaceError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { purchaseQuoteIsPlacing: false, purchaseQuotePlaceError: purchaseQuotePlaceError, purchaseQuotePlaced: false });
	
	        case _type.REQUEST_EDITING_PURCHASE_QUOTE:
	            return _extends({}, state, { purchaseQuoteIsEditing: true, purchaseQuoteEditError: null, purchaseQuoteEdited: false, purchaseQuoteCreated: null });
	        case _type.EDIT_PURCHASE_QUOTE_SUCCESS:
	            return _extends({}, state, { purchaseQuoteIsEditing: false, purchaseQuoteEditError: null, purchaseQuoteEdited: true });
	        case _type.EDIT_PURCHASE_QUOTE_FAILURE:
	            var purchaseQuoteEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { purchaseQuoteIsEditing: false, purchaseQuoteEditError: purchaseQuoteEditError, purchaseQuoteEdited: false });
	        case _type.REQUEST_NUM_PURCHASE_QUOTES:
	            return _extends({}, state, { numPurchaseQuotesError: null, numPurchaseQuotesLoading: true });
	        case _type.FETCH_NUM_PURCHASE_QUOTES_SUCCESS:
	            return _extends({}, state, { numPurchaseQuotes: action.payload.data.number, numPurchaseQuotesLoading: false });
	        case _type.FETCH_NUM_PURCHASE_QUOTES_FAILURE:
	            return _extends({}, state, { numPurchaseQuotesError: action.payload.data, numPurchaseQuotesLoading: false });
	        case _type.REQUEST_DELETE_PURCHASE_QUOTE:
	            return _extends({}, state, { purchaseQuoteIsDeleting: true, purchaseQuoteDeleteError: null, purchaseQuoteIsDeleted: false });
	        case _type.DELETE_PURCHASE_QUOTE_SUCCESS:
	            return _extends({}, state, { purchaseQuoteIsDeleting: false, purchaseQuoteDeleteError: null, purchaseQuoteIsDeleted: true });
	        case _type.DELETE_PURCHASE_QUOTE_FAILURE:
	            var purchaseQuoteDeleteError = action.payload.data || { messate: action.payload.message };
	            return _extends({}, state, { purchaseQuoteIsDeleting: false, purchaseQuoteDeleteError: purchaseQuoteDeleteError, purchaseQuoteIsDeleted: false });
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/purchaseQuotes_reducer.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/purchaseQuotes_reducer.js');
	}();

	;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    all: [],
	    currentPurchaseReturn: null,
	    currentPurchaseReturnDetail: null,
	    currentVendor: null,
	    isLoading: true,
	    error: null,
	    detailIsLoading: false,
	    detailError: null,
	    purchaseReturnIsCreating: false,
	    purchaseReturnCreateError: null,
	    purchaseReturnCreated: false,
	    purchaseReturnIsEditing: false,
	    purchaseReturnEditError: null,
	    purchaseReturnEdited: false,
	    purchaseReturnIsCompleting: false,
	    purchaseReturnCompleteError: null,
	    purchaseReturnCompleted: false,
	    purchaseReturnIsVoiding: false,
	    purchaseReturnVoidError: null,
	    purchaseReturnVoided: false
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        // Product action handlers
	        case _type.REQUEST_PURCHASE_RETURNS:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.FETCH_PURCHASE_RETURNS_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	        case _type.FETCH_PURCHASE_RETURNS_FAILURE:
	            var error = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { all: [], error: error, isLoading: false });
	        case _type.SELECT_PURCHASE_RETURN:
	            return _extends({}, state, { currentPurchaseReturn: action.payload });
	        // case SELECT_VENDOR:
	        //     return {...state, currentVendor: action.payload };
	        case _type.RESET_CURRENT_PURCHASE_RETURN:
	            return _extends({}, state, { currentPurchaseReturn: null, currentPurchaseReturnDetail: null });
	        case _type.REQUEST_PURCHASE_RETURN_DETAIL:
	            return _extends({}, state, { detailError: null, detailIsLoading: true });
	        case _type.FETCH_PURCHASE_RETURN_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { currentPurchaseReturnDetail: action.payload, detailError: null, detailIsLoading: false });
	        case _type.FETCH_PURCHASE_RETURN_DETAIL_FAILURE:
	            // return error and make loading = false
	            var detailError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { all: [], detailError: detailError, detailIsLoading: false });
	        case _type.REQUEST_CREATING_PURCHASE_RETURN:
	            return _extends({}, state, { purchaseReturnIsCreating: true, purchaseReturnCreateError: null, purchaseReturnCreated: false });
	        case _type.CREATE_PURCHASE_RETURN_SUCCESS:
	            return _extends({}, state, { purchaseReturnIsCreating: false, purchaseReturnCreateError: null, purchaseReturnCreated: true });
	        case _type.CREATE_PURCHASE_RETURN_FAILURE:
	            var purchaseReturnCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { purchaseReturnIsCreating: false, purchaseReturnCreateError: purchaseReturnCreateError, purchaseReturnCreated: false });
	        case _type.REQUEST_EDITING_PURCHASE_RETURN:
	            return _extends({}, state, { purchaseReturnIsEditing: true, purchaseReturnEditError: null, purchaseReturnEdited: false });
	        case _type.EDIT_PURCHASE_RETURN_SUCCESS:
	            return _extends({}, state, { purchaseReturnIsEditing: false, purchaseReturnEditError: null, purchaseReturnEdited: true });
	        case _type.EDIT_PURCHASE_RETURN_FAILURE:
	            var purchaseReturnEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { purchaseReturnIsEditing: false, purchaseReturnEditError: purchaseReturnEditError, purchaseReturnEdited: false });
	        case _type.COMPLETE_PURCHASE_RETURN:
	            return _extends({}, state, { purchaseReturnIsCompleting: true, purchaseReturnCompleteError: null, purchaseReturnCompleted: false });
	        case _type.COMPLETE_PURCHASE_RETURN_SUCCESS:
	            return _extends({}, state, { purchaseReturnIsCompleting: false, purchaseReturnCompleteError: null, purchaseReturnCompleted: true });
	        case _type.COMPLETE_PURCHASE_RETURN_FAILURE:
	            var purchaseReturnCompleteError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { purchaseReturnIsCompleting: false, purchaseReturnCompleteError: purchaseReturnCompleteError, purchaseReturnCompleted: false });
	        case _type.REQUEST_VOID_PURCHASE_RETURN:
	            return _extends({}, state, {
	                purchaseReturnIsVoiding: true,
	                purchaseReturnVoidError: null,
	                purchaseReturnVoided: false
	            });
	        case _type.VOID_PURCHASE_RETURN_SUCCESS:
	            return _extends({}, state, {
	                purchaseReturnIsVoiding: false,
	                purchaseReturnVoidError: null,
	                purchaseReturnVoided: true
	            });
	        case _type.VOID_PURCHASE_RETURN_FAILURE:
	            var purchaseReturnVoidError = action.payload.data || { message: action.payload.message };
	            alert(JSON.stringify(purchaseReturnVoidError));
	            return _extends({}, state, {
	                purchaseReturnIsVoiding: false,
	                purchaseReturnVoidError: purchaseReturnVoidError,
	                purchaseReturnVoided: false
	            });
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/purchaseReturns_reducer.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/purchaseReturns_reducer.js');
	}();

	;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    all: [],
	    currentPurchaseSchedule: null,
	    currentPurchaseScheduleDetail: null,
	    isLoading: true,
	    error: null,
	    detailIsLoading: false,
	    detailError: null,
	    purchaseScheduleIsCreating: false,
	    purchaseScheduleCreateError: null,
	    purchaseScheduleCreated: false,
	    purchaseScheduleIsEditing: false,
	    purchaseScheduleEditError: null,
	    purchaseScheduleEdited: false
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        // Product action handlers
	        case _type.REQUEST_PURCHASE_SCHEDULES:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.FETCH_PURCHASE_SCHEDULES_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	        case _type.FETCH_PURCHASE_SCHEDULES_FAILURE:
	            var error = action.payload || { message: action.payload.message };
	            return _extends({}, state, { all: [], error: error, isLoading: false });
	        case _type.SELECT_PURCHASE_SCHEDULE:
	            return _extends({}, state, { currentPurchaseSchedule: action.payload });
	        case _type.RESET_CURRENT_PURCHASE_SCHEDULE:
	            return _extends({}, state, { currentPurchaseSchedule: null, currentPurchaseScheduleDetail: null,
	                purchaseScheduleEditError: null, purchaseScheduleCreateError: null,
	                purchaseScheduleIsEditing: false, purchaseScheduleIsCreating: false });
	        case _type.REQUEST_PURCHASE_SCHEDULE_DETAIL:
	            return _extends({}, state, { detailError: null, detailIsLoading: true });
	        case _type.FETCH_PURCHASE_SCHEDULE_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { currentPurchaseScheduleDetail: action.payload, detailError: null, detailIsLoading: false });
	        case _type.FETCH_PURCHASE_SCHEDULE_DETAIL_FAILURE:
	            // return error and make loading = false
	            var detailError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { all: [], detailError: detailError, detailIsLoading: false });
	        case _type.REQUEST_CREATING_PURCHASE_SCHEDULE:
	            return _extends({}, state, { purchaseScheduleIsCreating: true, purchaseScheduleCreateError: null, purchaseScheduleCreated: false });
	        case _type.CREATE_PURCHASE_SCHEDULE_SUCCESS:
	            return _extends({}, state, { purchaseScheduleIsCreating: false, purchaseScheduleCreateError: null, purchaseScheduleCreated: true });
	        case _type.CREATE_PURCHASE_SCHEDULE_FAILURE:
	            var purchaseScheduleCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { purchaseScheduleIsCreating: false, purchaseScheduleCreateError: purchaseScheduleCreateError, purchaseScheduleCreated: false });
	        case _type.REQUEST_EDITING_PURCHASE_SCHEDULE:
	            return _extends({}, state, { purchaseScheduleIsEditing: true, purchaseScheduleEditError: null, purchaseScheduleEdited: false });
	        case _type.EDIT_PURCHASE_SCHEDULE_SUCCESS:
	            return _extends({}, state, { purchaseScheduleIsEditing: false, purchaseScheduleEditError: null, purchaseScheduleEdited: true });
	        case _type.EDIT_PURCHASE_SCHEDULE_FAILURE:
	            var purchaseScheduleEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { purchaseScheduleIsEditing: false, purchaseScheduleEditError: purchaseScheduleEditError, purchaseScheduleEdited: false });
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/purchaseSchedules_reducer.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/purchaseSchedules_reducer.js');
	}();

	;

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    all: [],
	    currentPurchaseTemplate: null,
	    currentPurchaseTemplateDetail: null,
	    isLoading: true,
	    error: null,
	    detailIsLoading: false,
	    detailError: null,
	    purchaseTemplateIsCreating: false,
	    purchaseTemplateCreateError: null,
	    purchaseTemplateCreated: null,
	    purchaseTemplateIsEditing: false,
	    purchaseTemplateEditError: null,
	    purchaseTemplateEdited: false,
	    currentPurchaseProduct: null,
	    purchaseTemplateIsDeleting: true,
	    purchaseTemplateDeleteError: null,
	    purchaseTemplateDeleted: false,
	    purchaseTemplateList: [],
	    purchaseTemplateListIsLoading: false,
	    purchaseTemplateListError: null
	
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        // Product action handlers
	        case _type.REQUEST_PURCHASE_TEMPLATES:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.FETCH_PURCHASE_TEMPLATES_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	        case _type.FETCH_PURCHASE_TEMPLATES_FAILURE:
	            var error = action.payload || { message: action.payload.message };
	            return _extends({}, state, { all: [], error: error, isLoading: false });
	        case _type.SELECT_PURCHASE_TEMPLATE:
	            return _extends({}, state, { currentPurchaseTemplate: action.payload });
	        case _type.RESET_CURRENT_PURCHASE_TEMPLATE:
	            return _extends({}, state, { currentPurchaseTemplate: null, currentPurchaseTemplateDetail: null, purchaseTemplateEditError: null, purchaseTemplateCreateError: null, purchaseTemplateCreated: null });
	        case _type.REQUEST_PURCHASE_TEMPLATE_DETAIL:
	            return _extends({}, state, { detailError: null, detailIsLoading: true });
	        case _type.FETCH_PURCHASE_TEMPLATE_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { currentPurchaseTemplateDetail: action.payload, detailError: null, detailIsLoading: false });
	        case _type.FETCH_PURCHASE_TEMPLATE_DETAIL_FAILURE:
	            // return error and make loading = false
	            var detailError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { all: [], detailError: detailError, detailIsLoading: false });
	        case _type.REQUEST_CREATING_PURCHASE_TEMPLATE:
	            return _extends({}, state, { purchaseTemplateIsCreating: true, purchaseTemplateCreateError: null, purchaseTemplateCreated: null });
	        case _type.CREATE_PURCHASE_TEMPLATE_SUCCESS:
	            return _extends({}, state, { purchaseTemplateIsCreating: false, purchaseTemplateCreateError: null, purchaseTemplateCreated: action.payload.data });
	        case _type.CREATE_PURCHASE_TEMPLATE_FAILURE:
	            var purchaseTemplateCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { purchaseTemplateIsCreating: false, purchaseTemplateCreateError: purchaseTemplateCreateError, purchaseTemplateCreated: null });
	        case _type.REQUEST_EDITING_PURCHASE_TEMPLATE:
	            return _extends({}, state, { purchaseTemplateIsEditing: true, purchaseTemplateEditError: null, purchaseTemplateEdited: false, purchaseTemplateCreated: null });
	        case _type.EDIT_PURCHASE_TEMPLATE_SUCCESS:
	            return _extends({}, state, { purchaseTemplateIsEditing: false, purchaseTemplateEditError: null, purchaseTemplateEdited: true });
	        case _type.EDIT_PURCHASE_TEMPLATE_FAILURE:
	            var purchaseTemplateEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { purchaseTemplateIsEditing: false, purchaseTemplateEditError: purchaseTemplateEditError, purchaseTemplateEdited: false });
	        case _type.DELETE_PURCHASE_TEMPLATE:
	            return _extends({}, state, { purchaseTemplateIsDeleting: true, purchaseTemplateDeleteError: null, purchaseTemplateDeleted: false });
	        case _type.DELETE_PURCHASE_TEMPLATE_SUCCESS:
	            return _extends({}, state, { purchaseTemplateIsDeleting: false, purchaseTemplateDeleteError: null, purchaseTemplateDeleted: true });
	        case _type.DELETE_PURCHASE_TEMPLATE_FAILURE:
	            var purchaseTemplateDeleteError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { purchaseTemplateIsDeleting: false, purchaseTemplateDeleteError: purchaseTemplateDeleteError, purchaseTemplateDeleted: false });
	        case _type.REQUEST_PURCHASE_TEMPLATE_LIST:
	            return _extends({}, state, { purchaseTemplateListIsLoading: true, purchaseTemplateList: [], purchaseTemplateListError: null });
	        case _type.FETCH_PURCHASE_TEMPLATE_LIST_SUCCESS:
	            return _extends({}, state, { purchaseTemplateListIsLoading: false, purchaseTemplateList: action.payload.data });
	        case _type.FETCH_PURCHASE_TEMPLATE_LIST_FAILURE:
	            var purchaseTemplateListError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { purchaseTemplateListIsLoading: false, purchaseTemplateListError: purchaseTemplateListError });
	
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/purchaseTemplates_reducer.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/purchaseTemplates_reducer.js');
	}();

	;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _INITIAL_STATE;
	
	var _type = __webpack_require__(14);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var INITIAL_STATE = (_INITIAL_STATE = {
	    all: [],
	    error: null,
	    isLoading: false,
	    currentPutAway: null,
	    putAwayIsCreating: false,
	    putAwayCreateError: null,
	    putAwayCreated: false
	}, _defineProperty(_INITIAL_STATE, 'currentPutAway', null), _defineProperty(_INITIAL_STATE, 'detailError', null), _defineProperty(_INITIAL_STATE, 'detailIsLoading', false), _defineProperty(_INITIAL_STATE, 'currentPutAwayDetail', null), _defineProperty(_INITIAL_STATE, 'putAwayIsEditing', false), _defineProperty(_INITIAL_STATE, 'putAwayEditError', null), _defineProperty(_INITIAL_STATE, 'putAwayEdited', false), _defineProperty(_INITIAL_STATE, 'isfetchingBinList', false), _defineProperty(_INITIAL_STATE, 'fetchBinListError', null), _defineProperty(_INITIAL_STATE, 'fetchedBinList', null), _defineProperty(_INITIAL_STATE, 'currentWarehouseReceive', null), _defineProperty(_INITIAL_STATE, 'isAutoPutaway', false), _defineProperty(_INITIAL_STATE, 'autoPutawayError', null), _defineProperty(_INITIAL_STATE, 'autoPutawaySuccess', false), _INITIAL_STATE);
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	
	        // Inventory Adjustment action handlers
	        case _type.REQUEST_PUT_AWAY:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.FETCH_PUT_AWAY_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	        case _type.FETCH_PUT_AWAY_FAILURE:
	            var error = action.payload || { message: action.payload.message };
	            return _extends({}, state, { all: [], error: error, isLoading: false });
	        case _type.RESET_CURRENT_PUT_AWAY:
	            return _extends({}, state, { currentPutAway: null, currentPutAwayDetail: null });
	        case _type.REQUEST_CREATING_PUT_AWAY:
	            return _extends({}, state, { putAwayIsCreating: true, putAwayCreateError: null, putAwayCreated: false });
	        case _type.CREATE_PUT_AWAY_SUCCESS:
	            return _extends({}, state, { putAwayIsCreating: false, putAwayCreateError: null, putAwayCreated: true });
	        case _type.CREATE_PUT_AWAY_FAILURE:
	            var putAwayCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { putAwayIsCreating: false, putAwayCreateError: putAwayCreateError, putAwayCreated: false });
	        case _type.SELECT_PUT_AWAY:
	            return _extends({}, state, { currentPutAway: action.payload });
	        case _type.REQUEST_PUT_AWAY_DETAIL:
	            return _extends({}, state, { detailError: null, detailIsLoading: true });
	        case _type.FETCH_PUT_AWAY_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { currentPutAwayDetail: action.payload.data, detailError: null, detailIsLoading: false });
	        case _type.FETCH_PUT_AWAY_DETAIL_FAILURE:
	            // return error and make loading = false
	            var detailError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { all: [], detailError: detailError, detailIsLoading: false });
	        case _type.REQUEST_EDITING_PUT_AWAY:
	            return _extends({}, state, { putAwayIsEditing: true, putAwayEditError: null, putAwayEdited: false });
	        case _type.EDIT_PUT_AWAY_SUCCESS:
	            return _extends({}, state, { putAwayIsEditing: false, putAwayEditError: null, putAwayEdited: true });
	        case _type.EDIT_PUT_AWAY_FAILURE:
	            var putAwayEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { putAwayIsEditing: false, putAwayEditError: putAwayEditError, putAwayEdited: false });
	        case _type.REQUEST_BIN_LIST_DETAIL:
	            return _extends({}, state, { isfetchingBinList: true, fetchBinListError: null, fetchedBinList: null });
	        case _type.FETCH_BIN_LIST_DETAIL_SUCCESS:
	            return _extends({}, state, { isfetchingBinList: false, fetchBinListError: null, fetchedBinList: action.payload.data });
	        case _type.FETCH_BIN_LIST_DETAIL_FAILURE:
	            var fetchBinListError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { isfetchingBinList: false, fetchBinListError: fetchBinListError, fetchedBinList: null });
	        case _type.REQUEST_CREATING_BINS:
	            return _extends({}, state, { isfetchingBinList: true, fetchBinListError: null, fetchedBinList: null });
	        case _type.CREATE_BINS_SUCCESS:
	            return _extends({}, state, { isfetchingBinList: false, fetchBinListError: null, fetchedBinList: action.payload.data });
	        case _type.CREATE_BINS_FAILURE:
	            var createBinsError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { isfetchingBinList: false, fetchBinListError: createBinsError, fetchedBinList: null });
	        case _type.SELECT_WAREHOUSE_RECEIVE:
	            return _extends({}, state, { currentWarehouseReceive: action.payload });
	        case _type.RESET_CURRENT_WAREHOUSE_RECEIVE:
	            return _extends({}, state, { currentWarehouseReceive: null });
	        case _type.AUTO_PUTAWAY:
	            return _extends({}, state, { isAutoPutaway: true, autoPutawayError: null, autoPutawaySuccess: false });
	        case _type.AUTO_PUTAWAY_SUCCESS:
	            return _extends({}, state, { isAutoPutaway: false, autoPutawayError: null, autoPutawaySuccess: true });
	        case _type.AUTO_PUTAWAY_FAILURE:
	            var autoPutawayError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { isAutoPutaway: false, autoPutawayError: autoPutawayError, autoPutawaySuccess: false });
	
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/putAway_reducer.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/putAway_reducer.jsx');
	}();

	;

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    all: null,
	    currentReceive: null,
	    currentReceiveDetail: null,
	    isLoading: false,
	    error: null,
	    detailIsLoading: false,
	    detailError: null,
	    isCreating: false,
	    createError: null,
	    created: false,
	    createdReceive: null,
	    isEditing: false,
	    editError: null,
	    edited: false,
	    isCompleting: false,
	    completeError: null,
	    completed: false,
	    isfetchingReceiveHistory: false,
	    fetchedReceiveHistory: null,
	    fetchReceiveHistoryError: null,
	    currentReceiveHistory: null,
	    isfetchingAllReceiveHistoryDetail: true,
	    fetchAllReceiveHistoryDetailError: null,
	    fetchedAllReceiveHistoryDetail: null,
	    isfetchingReceiveHistoryDetailRecord: false,
	    fetchReceiveHistoryDetailRecordError: null,
	    fetchedReceiveHistoryDetailRecord: null,
	    isEditingReveiveHistory: false,
	    editReceiveHistoryError: null,
	    editedReceiveHistory: null,
	    isAttachingFiles: false,
	    attachFilesError: null,
	    attachFilesSuccess: false,
	    isfetchingAttachedFiles: false,
	    fetchAttachedFilesError: null,
	    fetchedAttachedFiles: null,
	    isDeletingFiles: false,
	    deleteFilesError: null,
	    deleteFilesSuccess: false,
	    voidStatus: null,
	    voidIsLoading: false,
	    voidError: null,
	    receiveLoading: false
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _type.REQUEST_RECEIVES:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.FETCH_RECEIVES_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	        case _type.FETCH_RECEIVES_FAILURE:
	            var error = action.payload || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            console.log("fetch receives fail", action.payload);
	            return _extends({}, state, { all: [], error: error, isLoading: false });
	        case _type.SELECT_RECEIVE:
	            return _extends({}, state, { currentReceive: action.payload, fetchedAttachedFiles: null });
	        case _type.RESET_CURRENT_RECEIVE:
	            return _extends({}, state, { currentReceive: null, currentReceiveDetail: null, editError: null, createError: null });
	        case _type.REQUEST_CREATING_RECEIVE:
	            return _extends({}, state, { isCreating: true, createError: null, created: false, createdReceive: null, receiveLoading: true });
	        case _type.CREATE_RECEIVE_SUCCESS:
	            return _extends({}, state, { isCreating: false, createError: null, created: true, createdReceive: action.payload.data, receiveLoading: false });
	        case _type.CREATE_RECEIVE_FAILURE:
	            var createError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { isCreating: false, createError: createError, created: false, createdReceive: null, receiveLoading: false });
	        case _type.RESET_CREATE_RECEIVE:
	            return _extends({}, state, { isCreating: false, createError: null, created: false, createdReceive: null });
	        case _type.REQUEST_EDITING_RECEIVE:
	            return _extends({}, state, { isEditing: true, editError: null, edited: false });
	        case _type.EDIT_RECEIVE_SUCCESS:
	            return _extends({}, state, { isEditing: false, editError: null, edited: true });
	        case _type.EDIT_RECEIVE_FAILURE:
	            var editError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { isEditing: false, editError: editError, edited: false });
	        case _type.REQUEST_RECEIVE_DETAIL:
	            return _extends({}, state, { detailError: null, detailIsLoading: true });
	        case _type.FETCH_RECEIVE_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { currentReceiveDetail: action.payload.data, detailError: null, detailIsLoading: false });
	        case _type.FETCH_RECEIVE_DETAIL_FAILURE:
	            // return error and make loading = false
	            var detailError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            console.log("fetch receive detail fail", action.payload);
	            alert(JSON.stringify(detailError));
	            return _extends({}, state, { all: null, detailError: detailError, detailIsLoading: false });
	        case _type.COMPLETE_PURCHASE_ORDER:
	            return _extends({}, state, { isCompleting: true, completeError: null, completed: false });
	        case _type.COMPLETE_PURCHASE_ORDER_SUCCESS:
	            return _extends({}, state, { isCompleting: false, completeError: null, completed: true });
	        case _type.COMPLETE_PURCHASE_ORDER_FAILURE:
	            var completeError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { isCompleting: false, completeError: completeError, completed: false });
	
	        case _type.FETCH_RECEIVE_HISTORY:
	            return _extends({}, state, { isfetchingReceiveHistory: true, fetchReceiveHistoryError: null, fetchedReceiveHistory: null });
	        case _type.FETCH_RECEIVE_HISTORY_SUCCESS:
	            return _extends({}, state, { isfetchingReceiveHistory: false, fetchReceiveHistoryError: null, fetchedReceiveHistory: action.payload.data });
	        case _type.FETCH_RECEIVE_HISTORY_FAILURE:
	            var fetchReceiveHistoryError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { isfetchingReceiveHistory: false, fetchReceiveHistoryError: fetchReceiveHistoryError, fetchedReceiveHistory: null });
	        case _type.SELECT_RECEIVE_HISTORY:
	            return _extends({}, state, { currentReceiveHistory: action.payload });
	        case _type.RESET_CURRENT_RECEIVE_HISTORY:
	            return _extends({}, state, { currentReceiveHistory: null, fetchedReceiveHistoryDetailRecord: null });
	        case _type.FETCH_RECEIVE_HISTORY_DETAIL:
	            return _extends({}, state, { isfetchingReceiveHistoryDetail: true, fetchReceiveHistoryDetailError: null, fetchedReceiveHistoryDetail: null });
	        case _type.FETCH_RECEIVE_HISTORY_DETAIL_SUCCESS:
	            return _extends({}, state, { isfetchingReceiveHistoryDetail: false, fetchReceiveHistoryDetailError: null, fetchedReceiveHistoryDetail: action.payload.data });
	        case _type.FETCH_RECEIVE_HISTORY_DETAIL_FAILURE:
	            var fetchReceiveHistoryDetailError = action.payload.data || { message: action.payload.message };
	            alert(JSON.stringify(fetchReceiveHistoryDetailError));
	            return _extends({}, state, { isfetchingReceiveHistoryDetail: false, fetchReceiveHistoryDetailError: fetchReceiveHistoryDetailError, fetchedReceiveHistoryDetail: null });
	
	        case _type.FETCH_ALL_RECEIVE_HISTORY_DETAIL:
	            return _extends({}, state, { isfetchingAllReceiveHistoryDetail: true, fetchAllReceiveHistoryDetailError: null, fetchedAllReceiveHistoryDetail: null });
	        case _type.FETCH_ALL_RECEIVE_HISTORY_DETAIL_SUCCESS:
	            return _extends({}, state, { isfetchingAllReceiveHistoryDetail: false, fetchAllReceiveHistoryDetailError: null, fetchedAllReceiveHistoryDetail: action.payload.data });
	        case _type.FETCH_ALL_RECEIVE_HISTORY_DETAIL_FAILURE:
	            var fetchAllReceiveHistoryDetailError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { isfetchingAllReceiveHistoryDetail: false, fetchAllReceiveHistoryDetailError: fetchAllReceiveHistoryDetailError, fetchedAllReceiveHistoryDetail: null });
	        case _type.FETCH_RECEIVE_HISTORY_DETAIL_RECORD:
	            return _extends({}, state, { isfetchingReceiveHistoryDetailRecord: true, fetchReceiveHistoryDetailRecordError: null, fetchedReceiveHistoryDetailRecord: null });
	        case _type.FETCH_RECEIVE_HISTORY_DETAIL_RECORD_SUCCESS:
	            return _extends({}, state, { isfetchingReceiveHistoryDetailRecord: false, fetchReceiveHistoryDetailRecordError: null, fetchedReceiveHistoryDetailRecord: action.payload.data });
	        case _type.FETCH_RECEIVE_HISTORY_DETAIL_RECORD_FAILURE:
	            var fetchReceiveHistoryDetailRecordError = action.payload.data || { message: action.payload.message };
	            alert(JSON.stringify(fetchReceiveHistoryDetailRecordError));
	            return _extends({}, state, { isfetchingReceiveHistoryDetailRecord: false, fetchReceiveHistoryDetailRecordError: fetchReceiveHistoryDetailRecordError, fetchedReceiveHistoryDetailRecord: null });
	
	        case _type.REQUEST_EDITING_RECEIVE_HISTORY:
	            return _extends({}, state, { isEditingReveiveHistory: true, editReceiveHistoryError: null, editedReceiveHistory: null });
	        case _type.EDIT_RECEIVE_HISTORY_SUCCESS:
	            return _extends({}, state, { isEditingReveiveHistory: false, editReceiveHistoryError: null, editedReceiveHistory: action.payload.data });
	        case _type.EDIT_RECEIVE_HISTORY_FAILURE:
	            var editReceiveHistoryError = action.payload.data || { message: action.payload.message };
	            alert(JSON.stringify(editReceiveHistoryError));
	            return _extends({}, state, { isEditingReveiveHistory: false, editReceiveHistoryError: editReceiveHistoryError, editedReceiveHistory: null });
	        case _type.RESET_EDIT_RECEIVE_HISTORY:
	            return _extends({}, state, { isEditingReveiveHistory: false, editReceiveHistoryError: null, editedReceiveHistory: null });
	
	        case _type.DELETE_RECEIVE:
	            return _extends({}, state, { voidStatus: '', voidIsLoading: true, voidError: null });
	        case _type.DELETE_RECEIVE_FINISHED:
	            return _extends({}, state, { voidStatus: action.payload.data, voidIsLoading: false });
	        case _type.RESET_DELETE_STATUS:
	            return _extends({}, state, { voidStatus: '', voidIsLoading: false, voidError: null });
	
	        case _type.ATTACH_FILES:
	            return _extends({}, state, { isAttachingFiles: true, attachFilesError: null, attachFilesSuccess: false });
	        case _type.ATTACH_FILES_SUCCESS:
	            return _extends({}, state, { isAttachingFiles: false, attachFilesError: null, attachFilesSuccess: true });
	        case _type.ATTACH_FILES_FAILURE:
	            var attachFilesError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { isAttachingFiles: false, attachFilesError: attachFilesError, attachFilesSuccess: false });
	        case _type.FETCH_ATTACHED_FILES:
	            return _extends({}, state, { isfetchingAttachedFiles: true, fetchAttachedFilesError: null, fetchedAttachedFiles: null });
	        case _type.FETCH_ATTACHED_FILES_SUCCESS:
	            return _extends({}, state, { isfetchingAttachedFiles: false, fetchAttachedFilesError: null, fetchedAttachedFiles: action.payload.data });
	        case _type.FETCH_ATTACHED_FILES_FAILURE:
	            var fetchAttachedFilesError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { isfetchingAttachedFiles: false, fetchAttachedFilesError: fetchAttachedFilesError, fetchedAttachedFiles: null });
	        case _type.DELETE_ATTACHED_FILES:
	            return _extends({}, state, { isDeletingFiles: true, deleteFilesError: null, deleteFilesSuccess: false });
	        case _type.DELETE_ATTACHED_FILES_SUCCESS:
	            return _extends({}, state, { isDeletingFiles: false, deleteFilesError: null, deleteFilesSuccess: true, fetchedAttachedFiles: null });
	        case _type.DELETE_ATTACHED_FILES_FAILURE:
	            var deleteFilesError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { isDeletingFiles: false, deleteFilesError: deleteFilesError, deleteFilesSuccess: false });
	        case _type.RESET_ATTACHED_FILES:
	            return _extends({}, state, { fetchedAttachedFiles: null });
	
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, "INITIAL_STATE", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/receive_reducer.js");
	
	    __REACT_HOT_LOADER__.register(_default, "default", "/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/receive_reducer.js");
	}();

	;

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    dispatchReturns: [],
	    isLoading: false,
	    error: null,
	    customerReturnError: null,
	    dispatchReturnError: null,
	    isCreating: false,
	    createCustomerReturnError: null,
	    created: false,
	    editCustomerReturnError: null,
	    editDispatchReturnError: null,
	    isEditing: false,
	    returnsFilter: null,
	    initialValue: {},
	    currentReturnDetail: undefined,
	    customers: [],
	
	    pages: 0,
	    count: 0,
	    customerReturns: []
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _type.FETCH_CUSTOMERS:
	            return _extends({}, state, {
	                customers: action.payload
	            });
	        case _type.REQUEST_CUSTOMER_SEARCH:
	            return _extends({}, state, { customerReturnError: null, isLoading: true });
	        case _type.CUSTOMER_SEARCH_SUCCESS:
	            return _extends({}, state, {
	                customerReturns: action.payload.data.record,
	                customerReturnError: null,
	                isLoading: false,
	                pages: action.payload.data.pages,
	                count: action.payload.data.count
	            });
	        case _type.CUSTOMER_SEARCH_FAILURE:
	            var customerReturnError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { customerReturns: [], customerReturnError: customerReturnError, isLoading: false });
	        case _type.REQUEST_CUSTOMER_CREATE_RETURN:
	            return _extends({}, state, { isCreating: true, createCustomerReturnError: null, created: false });
	        case _type.CUSTOMER_CREATE_RETURN_SUCCESS:
	            return _extends({}, state, { isCreating: false, createCustomerReturnError: null, created: true });
	        case _type.CUSTOMER_CREATE_RETURN_FAILURE:
	            var createCustomerReturnError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { isCreating: false, createCustomerReturnError: createCustomerReturnError, created: false });
	        case _type.REQUEST_CUSTOMER_EDIT_RETURN:
	            return _extends({}, state, { isEditing: true, editCustomerReturnError: null, edited: false });
	        case _type.CUSTOMER_EDIT_RETURN_SUCCESS:
	            return _extends({}, state, { isEditing: false, editCustomerReturnError: null, edited: true });
	        case _type.CUSTOMER_EDIT_RETURN_FAILURE:
	            var editCustomerReturnError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { isEditing: false, editCustomerReturnError: editCustomerReturnError, edited: false });
	        case _type.REQUEST_DISPATCH_EDIT_RETURN:
	            return _extends({}, state, { isEditing: true, editDispatchReturnError: null, edited: false });
	        case _type.DISPATCH_EDIT_RETURN_SUCCESS:
	            return _extends({}, state, { isEditing: false, editDispatchReturnError: null, edited: true });
	        case _type.DISPATCH_EDIT_RETURN_FAILURE:
	            var editDispatchReturnError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { isEditing: false, editDispatchReturnError: editDispatchReturnError, edited: false });
	        case _type.REQUEST_DISPATCH_SEARCH:
	            return _extends({}, state, { dispatchReturnError: null, isLoading: true });
	        case _type.DISPATCH_SEARCH_SUCCESS:
	            return _extends({}, state, { dispatchReturns: action.payload.data, dispatchReturnError: null, isLoading: false });
	        case _type.DISPATCH_SEARCH_FAILURE:
	            var dispatchReturnError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { dispatchReturns: [], dispatchReturnError: dispatchReturnError, isLoading: false });
	        case _type.SET_RETURNS_FILTER:
	            return _extends({}, state, { returnsFilter: action.payload });
	        case _type.RESET_CURRENT_FORM:
	            return _extends({}, state, { currentReturn: null, currentReturnDetail: null, editCustomerReturnError: null, createCustomerReturnError: null, created: null, edited: null
	            });
	        case _type.RETURN_SEARCH_SUCCESS:
	            return _extends({}, state, { currentReturnDetail: action.payload, initialValues: action.payload });
	        case _type.RESET_CURRENT_RETURN:
	            return _extends({}, state, { currentReturnDetail: null });
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/rma_reducers.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/rma_reducers.js');
	}();

	;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	  updatedSalesInvoicePayment: null,
	  updateSalesInvoicePaymentError: null,
	  salesInvoicePaymentIsUpdating: false,
	  salesInvoicePaymentUpdated: false
	};
	
	var _default = function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _type.UPDATE_SALES_INVOICE_PAYMENT:
	      return _extends({}, state, {
	        updatedSalesInvoicePayment: null,
	        updateSalesInvoicePaymentError: null,
	        salesInvoicePaymentIsUpdating: true,
	        salesInvoicePaymentUpdated: false
	      });
	    case _type.UPDATE_SALES_INVOICE_PAYMENT_SUCCESS:
	      return _extends({}, state, {
	        updatedSalesInvoicePayment: action.payload.data,
	        updateSalesInvoicePaymentError: null,
	        salesInvoicePaymentIsUpdating: false,
	        salesInvoicePaymentUpdated: true
	      });
	    case _type.UPDATE_SALES_INVOICE_PAYMENT_FAILURE:
	      var updateSalesInvoicePaymentError = action.payload || { message: action.payload.message };
	      return _extends({}, state, {
	        updatedSalesInvoicePayment: null,
	        updateSalesInvoicePaymentError: updateSalesInvoicePaymentError,
	        salesInvoicePaymentIsUpdating: false,
	        salesInvoicePaymentUpdated: false
	      });
	    case _type.RESET_SALES_INVOICE_PAYMENT:
	      return _extends({}, state, {
	        updatedSalesInvoicePayment: null,
	        updateSalesInvoicePaymentError: null,
	        salesInvoicePaymentIsUpdating: false,
	        salesInvoicePaymentUpdated: false
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/salesInvoicePayment_reducer.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/salesInvoicePayment_reducer.jsx');
	}();

	;

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	  all: [],
	  currentSalesInvoice: null,
	  currentSalesInvoiceDetail: null,
	  isLoading: true,
	  error: null,
	  completed: [],
	  completedError: null,
	  completedIsLoading: false,
	  detailIsLoading: false,
	  detailError: null,
	  salesInvoiceIsCreating: false,
	  salesInvoiceCreateError: null,
	  salesInvoiceCreated: false,
	  salesInvoiceIsEditing: false,
	  salesInvoiceEditError: null,
	  salesInvoiceEdited: false,
	  salesInvoiceIsUpdating: false,
	  salesInvoiceUpdated: null,
	  salesInvoiceUpdateError: null,
	  salesInvoiceIsVoiding: false,
	  salesInvoiceVoidError: null,
	  salesInvoiceVoided: false,
	  finalizingSalesInvoice: false,
	  finalizeSalesInvoiceSuccess: null,
	  finalizeSalesInvoiceFailure: null,
	  finalizeSalesInvoiceError: null,
	  deliveringSalesInvoice: false,
	  deliverSalesInvoiceSuccess: null,
	  deliverSalesInvoiceFailure: null,
	  deliverSalesInvoiceError: null,
	  salesReturnIsCreating: false,
	  salesReturnCreateError: null,
	  salesReturnCreated: false,
	  salesReturnDetail: null,
	  salesReturnDetailError: null,
	  salesReturnDetailIsLoading: false,
	  customerItem: null,
	  customerItemError: null,
	  customerItemIsLoading: false,
	  inventoryReturn: null,
	  inventoryReturnError: null,
	  inventoryReturnDetailsError: null,
	  inventoryReturnDetailsIsLoading: null,
	  inventoryReturnIsLoading: false,
	  editInventoryReturnError: null,
	  inventoryReturnIsEditing: false,
	  inventoryReturnEdited: false,
	  inventoryReturnDetails: null,
	  printInvoice: null,
	  updated: false,
	  editSICustomerError: null,
	  siCustomerIsEditing: false,
	  siCustomerEdited: false,
	  unpaidInvoices: null,
	  unpaidInvoicesIsLoading: false,
	  unpaidInvoicesError: null
	};
	
	var _default = function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    // Product action handlers
	    case _type.REQUEST_SALES_INVOICES:
	      return _extends({}, state, { error: null, isLoading: true });
	    case _type.REQUEST_SALES_INVOICES_BY_NUM:
	      return _extends({}, state, { error: null, isLoading: true });
	    case _type.FETCH_SALES_INVOICES_BY_NUM_SUCCESS:
	      // console.log('MAde it here');
	      console.log(action.payload.data);
	      return _extends({}, state, { completed: action.payload.data, completedError: null, completedIsLoading: false
	      });
	    case _type.FETCH_SALES_INVOICES_BY_NUM_FAILURE:
	      var numError = action.payload || { message: action.payload.message };
	      alert(JSON.stringify(numError));
	      return _extends({}, state, { completed: [], completedError: numError, completedIsLoading: false
	      });
	    case _type.FETCH_SALES_INVOICES_SUCCESS:
	      return _extends({}, state, { all: action.payload.data, error: null, isLoading: false
	      });
	    case _type.FETCH_SALES_INVOICES_FAILURE:
	      var error = action.payload || { message: action.payload.message };
	      return _extends({}, state, { all: [], error: error, isLoading: false
	      });
	    case _type.REQUEST_SALES_INVOICES_COMPLETED:
	      return _extends({}, state, { completed: [], completedError: null, completedIsLoading: true
	      });
	    case _type.FETCH_SALES_INVOICES_COMPLETED_SUCCESS:
	      return _extends({}, state, { completed: action.payload.data, completedError: null, completedIsLoading: false
	      });
	    case _type.FETCH_SALES_INVOICES_COMPLETED_FAILURE:
	      var completedError = action.payload || { message: action.payload.message };
	      alert(JSON.stringify(completedError));
	      return _extends({}, state, { completed: [], completedError: completedError, completedIsLoading: false
	      });
	    case _type.SELECT_SALES_INVOICE:
	      return _extends({}, state, { currentSalesInvoice: action.payload });
	    case _type.RESET_CURRENT_SALES_INVOICE:
	      return _extends({}, state, { completed: [], currentSalesInvoiceDetail: null, salesReturnDetail: null
	      });
	    case _type.REQUEST_SALES_INVOICE_DETAIL:
	      return _extends({}, state, { detailError: null, detailIsLoading: true });
	    case _type.FETCH_SALES_INVOICE_DETAIL_SUCCESS:
	      // return list of posts and make loading = false
	      return _extends({}, state, { currentSalesInvoiceDetail: action.payload, detailError: null, detailIsLoading: false
	      });
	    case _type.FETCH_SALES_INVOICE_DETAIL_FAILURE:
	      // return error and make loading = false
	      console.log('detail error', action.payload);
	      var detailError = action.payload || { message: action.payload.message }; // 2nd one is network or server down errors
	      return _extends({}, state, { all: [], detailError: detailError, detailIsLoading: false
	      });
	    case _type.REQUEST_CREATING_SALES_INVOICE:
	      return _extends({}, state, { salesInvoiceIsCreating: true, salesInvoiceCreateError: null, salesInvoiceCreated: false
	      });
	    case _type.CREATE_SALES_INVOICE_SUCCESS:
	      return _extends({}, state, { salesInvoiceIsCreating: false, salesInvoiceCreateError: null, salesInvoiceCreated: true
	      });
	    case _type.CREATE_SALES_INVOICE_FAILURE:
	      var salesInvoiceCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	      return _extends({}, state, { salesInvoiceIsCreating: false, salesInvoiceCreateError: salesInvoiceCreateError, salesInvoiceCreated: false
	      });
	    case _type.REQUEST_EDITING_SALES_INVOICE:
	      return _extends({}, state, { salesInvoiceIsEditing: true, salesInvoiceEditError: null, salesInvoiceEdited: false
	      });
	    case _type.EDIT_SALES_INVOICE_SUCCESS:
	      return _extends({}, state, { salesInvoiceIsEditing: false, salesInvoiceEditError: null, salesInvoiceEdited: true
	      });
	    case _type.EDIT_SALES_INVOICE_FAILURE:
	      var salesInvoiceEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	      return _extends({}, state, { salesInvoiceIsEditing: false, salesInvoiceEditError: salesInvoiceEditError, salesInvoiceEdited: false
	      });
	    case _type.REQUEST_FINALIZED_INVOICES:
	      return _extends({}, state, { error: null, isLoading: true });
	    case _type.FETCH_FINALIZED_INVOICES_SUCCESS:
	      return _extends({}, state, { all: action.payload.data, error: null, isLoading: false
	      });
	    case _type.FETCH_FINALIZED_INVOICES_FAILURE:
	      var finalizedError = action.payload || { message: action.payload.message };
	      return _extends({}, state, { all: [], error: finalizedError, isLoading: false
	      });
	    case _type.UPDATE_SALES_INVOICE:
	      return _extends({}, state, { salesInvoiceIsUpdating: true, salesInvoiceUpdateError: null, salesInvoiceUpdated: null
	      });
	    case _type.UPDATE_SALES_INVOICE_SUCCESS:
	      return _extends({}, state, { salesInvoiceIsUpdating: false, salesInvoiceUpdateError: null, salesInvoiceUpdated: action.payload.data
	      });
	    case _type.UPDATE_SALES_INVOICE_FAILURE:
	      var salesInvoiceUpdateError = action.payload.data || { message: action.payload.message };
	      alert(JSON.stringify(salesInvoiceUpdateError));
	      return _extends({}, state, { salesInvoiceIsUpdating: false, salesInvoiceUpdateError: salesInvoiceUpdateError, salesInvoiceUpdated: null
	      });
	    case _type.CLEAR_UPDATE_SALES_INVOICE:
	      return _extends({}, state, { salesInvoiceIsUpdating: false, salesInvoiceUpdateError: null, salesInvoiceUpdated: null, currentSalesInvoiceDetail: null
	      });
	    case _type.UPDATE_SALES_INVOICE_RESET:
	      return _extends({}, state, { salesInvoiceIsUpdating: false, salesInvoiceUpdateError: null, salesInvoiceUpdated: null
	      });
	    case _type.REQUEST_FINALIZE_INVOICE:
	      return _extends({}, state, { finalizingSalesInvoice: true, finalizeSalesInvoiceSuccess: null, finalizeSalesInvoiceFailure: null, finalizeSalesInvoiceError: null
	      });
	    case _type.FINALIZE_INVOICE_SUCCESS:
	      return _extends({}, state, { finalizingSalesInvoice: false, finalizeSalesInvoiceSuccess: true });
	    case _type.FINALIZE_INVOICE_FAILURE:
	      var finalizeSalesInvoiceError = action.payload.data || { message: action.payload.message };
	      alert(JSON.stringify(finalizeSalesInvoiceError));
	      return _extends({}, state, { finalizingSalesInvoice: false, finalizeSalesInvoiceFailure: true, finalizeSalesInvoiceError: finalizeSalesInvoiceError
	      });
	    case _type.REQUEST_DELIVER_INVOICE:
	      return _extends({}, state, { deliveringSalesInvoice: true, deliverSalesInvoiceSuccess: false, deliverSalesInvoiceError: null
	      });
	    case _type.DELIVER_INVOICE_SUCCESS:
	      return _extends({}, state, { deliveringSalesInvoice: false, deliverSalesInvoiceSuccess: true, deliverSalesInvoiceError: null
	      });
	    case _type.DELIVER_INVOICE_FAILURE:
	      var deliverSalesInvoiceError = action.payload.data || { message: action.payload.message };
	      alert(JSON.stringify(deliverSalesInvoiceError));
	      return _extends({}, state, { deliveringSalesInvoice: false, deliverSalesInvoiceSuccess: false, deliverSalesInvoiceError: deliverSalesInvoiceError
	      });
	    case _type.REQUEST_VOID_INVOICE:
	      return _extends({}, state, { salesInvoiceIsVoiding: true, salesInvoiceVoidError: null, salesInvoiceVoided: false
	      });
	    case _type.VOID_INVOICE_SUCCESS:
	      return _extends({}, state, { salesInvoiceIsVoiding: false, salesInvoiceVoidError: null, salesInvoiceVoided: true
	      });
	    case _type.VOID_INVOICE_FAILURE:
	      var salesInvoiceVoidError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { salesInvoiceIsVoiding: false, salesInvoiceVoidError: salesInvoiceVoidError, salesInvoiceVoided: false
	      });
	    case _type.REQUEST_VOID_RETURN:
	      return _extends({}, state, { salesInvoiceIsVoiding: true, salesInvoiceVoidError: null, salesInvoiceVoided: false
	      });
	    case _type.VOID_RETURN_SUCCESS:
	      return _extends({}, state, { salesInvoiceIsVoiding: false, salesInvoiceVoidError: null, salesInvoiceVoided: true
	      });
	    case _type.VOID_RETURN_FAILURE:
	      var salesReturnVoidError = action.payload.data || { message: action.payload.message };
	      return _extends({}, state, { salesInvoiceIsVoiding: false, salesReturnVoidError: salesReturnVoidError, salesInvoiceVoided: false
	      });
	    case _type.REQUEST_CREATING_SALES_RETURN:
	      return _extends({}, state, { salesReturnIsCreating: true, salesReturnCreateError: null, salesReturnCreated: false
	      });
	    case _type.CREATE_SALES_RETURN_SUCCESS:
	      return _extends({}, state, { salesReturnIsCreating: false, salesReturnCreateError: null, salesReturnCreated: true
	      });
	    case _type.CREATE_SALES_RETURN_FAILURE:
	      var salesReturnCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	      alert(JSON.stringify(salesReturnCreateError));
	      return _extends({}, state, { salesReturnIsCreating: false, salesReturnCreateError: salesReturnCreateError, salesReturnCreated: false
	      });
	
	    case _type.REQUEST_SALES_RETURN_DETAIL:
	      return _extends({}, state, { salesReturnDetail: null, salesReturnDetailError: null, salesReturnDetailIsLoading: true
	      });
	    case _type.FETCH_SALES_RETURN_DETAIL_SUCCESS:
	      return _extends({}, state, { salesReturnDetail: action.payload.data, salesReturnDetailError: null, salesReturnDetailIsLoading: false
	      });
	    case _type.FETCH_SALES_RETURN_DETAIL_FAILURE:
	      var salesReturnDetailError = action.payload || { message: action.payload.message };
	      return _extends({}, state, { salesReturnDetail: [], salesReturnDetailError: salesReturnDetailError, salesReturnDetailIsLoading: false
	      });
	    case _type.REQUEST_CUSTOMER_ITEM:
	      return _extends({}, state, { customerItem: null, customerItemError: null, customerItemIsLoading: true
	      });
	    case _type.FETCH_CUSTOMER_ITEM_SUCCESS:
	      return _extends({}, state, { customerItem: action.payload.data, customerItemError: null, customerItemIsLoading: false
	      });
	    case _type.FETCH_CUSTOMER_ITEM_FAILURE:
	      var customerItemError = action.payload || { message: action.payload.message };
	      return _extends({}, state, { customerItem: [], customerItemError: customerItemError, customerItemIsLoading: false
	      });
	    case _type.REQUEST_INVENTORY_RETURN:
	      return _extends({}, state, { inventoryReturn: null, inventoryReturnError: null, inventoryReturnIsLoading: true, inventoryReturnEdited: false
	      });
	    case _type.FETCH_INVENTORY_RETURN_SUCCESS:
	      return _extends({}, state, { inventoryReturn: action.payload.data, inventoryReturnError: null, inventoryReturnIsLoading: false, updated: false
	      });
	    case _type.FETCH_INVENTORY_RETURN_FAILURE:
	      var inventoryReturnError = action.payload || { message: action.payload.message };
	      alert(JSON.stringify(inventoryReturnError));
	      return _extends({}, state, { inventoryReturn: [], inventoryReturnError: inventoryReturnError, inventoryReturnIsLoading: false
	      });
	    case _type.REQUEST_INVENTORY_RETURN_DETAILS:
	      return _extends({}, state, { inventoryReturnDetails: null, inventoryReturnDetailsError: null, inventoryReturnDetailsIsLoading: true, inventoryReturnEdited: false, updated: false
	      });
	    case _type.FETCH_INVENTORY_RETURN_DETAILS_SUCCESS:
	      return _extends({}, state, { inventoryReturnDetails: action.payload.data, inventoryReturnDetailsError: null, inventoryReturnDetailsIsLoading: false
	      });
	    case _type.FETCH_INVENTORY_RETURN_DETAILS_FAILURE:
	      var inventoryReturnDetailsError = action.payload || { message: action.payload.message };
	      alert(JSON.stringify(inventoryReturnDetailsError));
	      return _extends({}, state, { inventoryReturnDetails: [], inventoryReturnDetailsError: inventoryReturnDetailsError, inventoryReturnDetailsIsLoading: false
	      });
	    case _type.EDIT_INVENTORY_RETURN:
	      return _extends({}, state, { editInventoryReturnError: null, inventoryReturnIsEditing: true, inventoryReturnEdited: false
	      });
	    case _type.EDIT_INVENTORY_RETURN_SUCCESS:
	      return _extends({}, state, { editInventoryReturnError: null, inventoryReturnIsEditing: false, inventoryReturnEdited: true
	      });
	    case _type.EDIT_INVENTORY_RETURN_FAILURE:
	      var editInventoryReturnError = action.payload || { message: action.payload.message };
	      return _extends({}, state, { editInventoryReturnError: editInventoryReturnError, inventoryReturnIsEditing: false, inventoryReturnEdited: false
	      });
	    case _type.REQUEST_RETURN_VOID:
	      return _extends({}, state, { inventoryReturn: null, inventoryReturnError: null, inventoryReturnIsLoading: true, inventoryReturnEdited: false
	      });
	    case _type.REQUEST_RETURN_COMPLETE:
	      return _extends({}, state, { inventoryReturn: null, inventoryReturnError: null, inventoryReturnIsLoading: true, inventoryReturnEdited: false
	      });
	    case _type.FETCH_RETURN_SUCCESS:
	      return _extends({}, state, { inventoryReturn: action.payload.data, inventoryReturnError: null, inventoryReturnIsLoading: false, updated: true
	      });
	    case _type.FETCH_RETURN_FAILURE:
	      var inventoryReturnStatusError = action.payload || { message: action.payload.message };
	      alert(JSON.stringify(inventoryReturnStatusError));
	      return _extends({}, state, { inventoryReturn: [], inventoryReturnError: inventoryReturnStatusError, inventoryReturnIsLoading: false
	      });
	
	    case _type.REQUEST_UNPAID_INVOICE:
	      return _extends({}, state, { unpaidInvoices: null, unpaidInvoicesError: null, unpaidInvoicesIsLoading: true
	      });
	    case _type.FETCH_UNPAID_INVOICE_SUCCESS:
	      return _extends({}, state, { unpaidInvoices: action.payload.data, unpaidInvoicesError: null, unpaidInvoicesIsLoading: false
	      });
	    case _type.FETCH_UNPAID_INVOICE_FAILURE:
	      var unpaidInvoicesError = action.payload || { message: action.payload.message };
	      return _extends({}, state, { unpaidInvoices: [], unpaidInvoicesError: unpaidInvoicesError, unpaidInvoicesIsLoading: false
	      });
	
	    case _type.EDIT_SI_CUSTOMER:
	      return _extends({}, state, {
	        editSICustomerError: null,
	        siCustomerIsEditing: true,
	        siCustomerEdited: false
	      });
	    case _type.EDIT_SI_CUSTOMER_SUCCESS:
	      return _extends({}, state, {
	        editSICustomerError: null,
	        siCustomerIsEditing: false,
	        siCustomerEdited: true
	      });
	    case _type.EDIT_SI_CUSTOMER_FAILURE:
	      var editSICustomerError = action.payload.data || { message: action.payload.message };
	      alert(JSON.stringify(editSICustomerError));
	      return _extends({}, state, {
	        editSICustomerError: editSICustomerError,
	        siCustomerIsEditing: false,
	        siCustomerEdited: false
	      });
	    case _type.RESET_EDIT_SI_CUSTOMER:
	      return _extends({}, state, {
	        editSICustomerError: null,
	        siCustomerIsEditing: false,
	        siCustomerEdited: false
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/salesInvoice_reducer.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/salesInvoice_reducer.jsx');
	}();

	;

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	  msoTotalPages: null,
	  all: null,
	  currentSalesOrder: null,
	  currentSalesOrderDetail: null,
	  currentSalesOrderDetailByNum: null,
	  isLoading: true,
	  error: null,
	  detailIsLoading: false,
	  detailByNumIsLoading: false,
	  detailError: null,
	  detailByNumError: null,
	  salesOrderIsCreating: false,
	  salesOrderCreateError: null,
	  salesOrderCreated: false,
	  salesOrderIsEditing: false,
	  salesOrderEditError: null,
	  salesOrderEdited: false,
	  customerOrderSchedules: [],
	  customerOrderSchedulesIsLoading: false,
	  customerOrderSchedulesError: null,
	  todaysOutgoingOrders: [],
	  todaysOutgoingOrdersIsLoading: null,
	  todaysOutgoingOrdersError: null,
	  salesOrderLineWeights: [],
	  salesOrderLineWeightsIsLoading: false,
	  salesOrderLineWeightsError: null,
	  salesOrderLineWeightsIsEditing: false,
	  editSalesOrderLineWeightsError: null,
	  editSalesOrderLineWeightsSuccess: false,
	  printForm: null,
	  printFormIsLoading: false,
	  printFormError: null,
	  csv: null,
	  csvIsLoading: false,
	  csvError: null,
	  SavingPosSale: false,
	  SavePosSaleSuccessful: null,
	  SavePosSaleFailure: null,
	  SavePosError: null,
	  InvalidCharacterEntered: false,
	  ChargeNotMet: false,
	  RequestingDraft: null,
	  DraftDetails: null,
	  DraftError: null,
	  drafts: null,
	  draftsIsLoading: null,
	  draftsError: null,
	  customerPricesIsLoading: false,
	  customerPricesError: null,
	  customerPrices: [],
	  currencyRates: null,
	  currencyRatesIsLoading: false,
	  currencyRatesError: null,
	  multiCurrenciesIsEditing: false,
	  multiCurrenciesEdited: false,
	  multiCurrenciesEditError: null,
	  taxRates: null,
	  taxRatesIsLoading: false,
	  taxRatesError: null,
	  creatingTaxRate: false,
	  createTaxRateError: null,
	  createTaxRateSuccess: null,
	  multiTaxesIsEditing: false,
	  multiTaxesEdited: false,
	  multiTaxesEditError: null,
	  taxIsDeleting: false,
	  taxDeleted: false,
	  taxDeleteError: null,
	  overallSales: [],
	  overallSalesIsLoading: false,
	  overallSalesError: null,
	  posReport: [],
	  posReportIsLoading: false,
	  posReportError: null,
	  salesInventoryInfo: [],
	  salesInventoryInfoIsLoading: false,
	  salesInventoryInfoError: null,
	  salesCustomerDetails: null,
	  salesShippingCustomerDetails: null,
	  salesCustomerDetailsIsLoading: false,
	  allShipping: null,
	  allShippingIsLoading: false,
	  allShippingError: null,
	  purchasesVendorDetailsError: null,
	  purchasesVendorDetails: null,
	  purchasesVendorDetailsIsLoading: false,
	  salesCustomerDetailsError: null,
	  salesItemHistory: [],
	  salesItemHistoryIsLoading: false,
	  salesItemHistoryError: null,
	  customerSalesHistory: [],
	  customerSalesHistoryIsLoading: false,
	  customerSalesHistoryError: null,
	  customerFrequent: [],
	  customerFrequentIsLoading: false,
	  customerFrequentError: null,
	  salesOrdersFilter: null,
	  salesPerformanceIsLoading: false,
	  salesPerformance: null,
	  salesPerformanceError: null,
	  dashboardSalesDetail: null,
	  dashboardSalesDetailIsLoading: false,
	  dashboardSalesDetailError: null,
	  salesLevels: {},
	  salesLevelsIsLoading: false,
	  salesLevelsError: null,
	  salesOrderProduct: null,
	  salesOrderProductIsLoading: false,
	  salesOrderProductFailure: null,
	
	  requestingShippingList: false,
	  shippingListPDF: null,
	  requestingPackingList: false,
	  packingListPDF: null,
	  requestingPickingList: false,
	  pickingListPDF: null,
	  requestingSalesOrderPDF: false,
	  salesOrderPDF: null,
	  requestingBolIdPDF: false,
	  bolIdPDF: null,
	  requestingBolWithoutLogPDF: false,
	  bolWithoutLogPDF: null,
	  requestingBolLabel: false,
	  bolLabel: null,
	  requestingBolFbaPDF: false,
	  bolFbaPDF: null,
	  spPDF: null,
	  bolAddress: [],
	  requestingRefundPDF: false,
	  refundPDF: null,
	  prevEstDate: null,
	  prevEstDateIsNeeded: false,
	  // Refund related reducer
	  refund: { error: null, loading: false, status: 0 },
	  quoteLoading: false,
	  salesTotals: null,
	  salesTotalsIsLoading: false,
	  salesTotalsError: null,
	  userPerformanceIsLoading: false,
	  userPerformanceError: null,
	  userPerformanceData: {},
	  batchesInfo: {},
	  promotions: []
	};
	
	var _default = function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  // console.log("action.payload:", action);
	  switch (action.type) {
	    case 'salesOrderForm/productpromotionfetching':
	      return _extends({}, state, {
	        promotions: []
	      });
	    case 'salesOrderForm/productpromotion':
	      return _extends({}, state, {
	        promotions: action.payload
	      });
	    case _type.REQUEST_SET_SHIPPING_WEIGHT:
	    case _type.UPDATE_SHIPPING_WEIGHT_SUCCESS:
	    case _type.UPDATE_SHIPPING_WEIGHT_FAILURE:
	    case _type.REQUEST_SET_SHIPPING_WEIGHT_SPLIT:
	    // Product action handlers
	    case _type.REQUEST_SALES_ORDERS_BY_FILTER:
	    case _type.REQUEST_SALES_ORDERS:
	      return _extends({}, state, { error: null, isLoading: true });
	    case _type.FETCH_SALES_ORDERS_SUCCESS:
	      return _extends({}, state, { all: action.payload.data, error: null, isLoading: false, msoTotalPages: action.payload.data ? action.payload.data.pages : 1
	      });
	    case _type.FETCH_SALES_ORDERS_FAILURE:
	      {
	        var error = action.payload || { message: action.payload.message };
	        return _extends({}, state, { all: null, error: error, isLoading: false
	        });
	      }
	    case _type.SELECT_SALES_ORDER:
	      return _extends({}, state, { currentSalesOrder: action.payload });
	    case _type.RESET_CURRENT_SALES_ORDER:
	      return _extends({}, state, { currentSalesOrder: null, currentSalesOrderDetail: null, salesCustomerDetails: null, refund: { error: null, loading: false, status: 0 }
	      });
	    case _type.REQUEST_SALES_ORDER_DETAIL:
	      return _extends({}, state, { detailError: null, detailIsLoading: true, currentSalesOrderDetail: null
	      });
	    case _type.FETCH_SALES_ORDER_DETAIL_SUCCESS:
	      // return list of posts and make loading = false
	      return _extends({}, state, { currentSalesOrderDetail: action.payload, detailError: null, detailIsLoading: false
	      });
	    case _type.FETCH_SALES_ORDER_DETAIL_FAILURE:
	      {
	        // return error and make loading = false
	        var detailError = action.payload || { message: action.payload.message }; // 2nd one is network or server down errors
	        return _extends({}, state, { all: [], detailError: detailError, detailIsLoading: false
	        });
	      }
	    case _type.REQUEST_SALES_ORDER_DETAIL_BY_NUM:
	      return _extends({}, state, { detailByNumError: null, detailByNumIsLoading: true, currentSalesOrderDetailByNum: null
	      });
	    case _type.FETCH_SALES_ORDER_DETAIL_BY_NUM_SUCCESS:
	      // return list of posts and make loading = false
	      return _extends({}, state, { currentSalesOrderDetailByNum: action.payload, detailByNumError: null, detailByNumIsLoading: false
	      });
	    case _type.FETCH_SALES_ORDER_DETAIL_BY_NUM_FAILURE:
	      {
	        // return error and make loading = false
	        var detailByNumError = action.payload || { message: action.payload.message }; // 2nd one is network or server down errors
	        alert('Sales Order Number does not exist');
	        return _extends({}, state, { currentSalesOrderDetailByNum: null, detailByNumError: detailByNumError, detailByNumIsLoading: false
	        });
	      }
	    case _type.REQUEST_CREATING_SALES_ORDER:
	      return _extends({}, state, { salesOrderIsCreating: true, salesOrderCreateError: null, salesOrderCreated: false
	      });
	    case _type.CREATE_SALES_ORDER_SUCCESS:
	      return _extends({}, state, { salesOrderIsCreating: false, salesOrderCreateError: null, salesOrderCreated: action.payload.data
	      });
	    case _type.CREATE_SALES_ORDER_FAILURE:
	      {
	        var salesOrderCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	        alert(JSON.stringify(salesOrderCreateError));
	        // alert('Please fill out all the fields');
	        return _extends({}, state, { salesOrderIsCreating: false, salesOrderCreateError: salesOrderCreateError, salesOrderCreated: false
	        });
	      }
	    case _type.REQUEST_EDITING_SALES_ORDER:
	      return _extends({}, state, { salesOrderIsEditing: true, salesOrderEditError: null, salesOrderEdited: false, salesOrderCreated: false
	      });
	    case _type.EDIT_SALES_ORDER_SUCCESS:
	      return _extends({}, state, { salesOrderIsEditing: false, salesOrderEditError: null, salesOrderEdited: action.payload.data, salesOrderCreated: action.payload.data
	      });
	    case _type.EDIT_SALES_ORDER_FAILURE:
	      {
	        var salesOrderEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	        alert(JSON.stringify(salesOrderEditError));
	        return _extends({}, state, { salesOrderIsEditing: false, salesOrderEditError: salesOrderEditError, salesOrderEdited: false, salesOrderCreated: false
	        });
	      }
	    case _type.REQUEST_VOID_SALES_ORDER:
	      return _extends({}, state, { error: null, isLoading: true });
	    case _type.VOID_SALES_ORDER_SUCCESS:
	      return _extends({}, state, { isLoading: false });
	    case _type.VOID_SALES_ORDER_FAILURE:
	      {
	        var voidSalesOrderError = action.payload.data || { message: action.payload.message };
	        alert(JSON.stringify(voidSalesOrderError));
	        return _extends({}, state, { voidSalesOrderError: voidSalesOrderError, isLoading: false });
	      }
	    case _type.REQUEST_CUSTOMER_SALES_HISTORY:
	      return _extends({}, state, { customerSalesHistoryIsLoading: true, customerSalesHistoryError: null });
	    case _type.FETCH_CUSTOMER_SALES_HISTORY_SUCCESS:
	      return _extends({}, state, { customerSalesHistory: action.payload.data, customerSalesHistoryIsLoading: false });
	    case _type.FETCH_CUSTOMER_SALES_HISTORY_FAILURE:
	      {
	        var customerSalesHistoryError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { customerSalesHistoryError: customerSalesHistoryError, customerSalesHistoryIsLoading: false });
	      }
	    case _type.REQUEST_CUSTOMER_ORDER_SCHEDULES:
	      return _extends({}, state, { customerOrderSchedulesIsLoading: true, customerOrderSchedulesError: null });
	    case _type.FETCH_CUSTOMER_ORDER_SCHEDULES_SUCCESS:
	      return _extends({}, state, { customerOrderSchedulesIsLoading: false, customerOrderSchedules: action.payload.data });
	    case _type.FETCH_CUSTOMER_ORDER_SCHEDULES_FAILURE:
	      {
	        var customerOrderSchedulesError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { customerOrderSchedulesError: customerOrderSchedulesError, customerOrderSchedulesIsLoading: false });
	      }
	    case _type.REQUEST_TODAYS_OUTGOING_ORDERS:
	      return _extends({}, state, { todaysOutgoingOrdersIsLoading: true, todaysOutgoingOrdersError: null });
	    case _type.FETCH_TODAYS_OUTGOING_ORDERS_SUCCESS:
	      return _extends({}, state, { todaysOutgoingOrders: action.payload.data, todaysOutgoingOrdersIsLoading: false });
	    case _type.FETCH_TODAYS_OUTGOING_ORDERS_FAILURE:
	      {
	        var todaysOutgoingOrdersError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { todaysOutgoingOrdersError: todaysOutgoingOrdersError, todaysOutgoingOrdersIsLoading: false });
	      }
	    case _type.REQUEST_SALES_ORDER_LINE_WEIGHTS:
	      return _extends({}, state, { salesOrderLineWeightsIsLoading: true, salesOrderLineWeightsError: null });
	    case _type.FETCH_SALES_ORDER_LINE_WEIGHTS_SUCCESS:
	      return _extends({}, state, { salesOrderLineWeights: action.payload.data, salesOrderLineWeightsIsLoading: false });
	    case _type.FETCH_SALES_ORDER_LINE_WEIGHTS_FAILURE:
	      {
	        var salesOrderLineWeightsError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { salesOrderLineWeightsError: salesOrderLineWeightsError, salesOrderLineWeightsIsLoading: false });
	      }
	    case _type.REQUEST_SET_ORDER_LINE_WEIGHTS:
	      return _extends({}, state, { salesOrderLineWeightsIsEditing: true, editSalesOrderLineWeightsError: null });
	    case _type.EDIT_SALES_ORDER_LINE_WEIGHTS_SUCCESS:
	      return _extends({}, state, { salesOrderLineWeightsIsEditing: false, editSalesOrderLineWeightsSuccess: true, editSalesOrderLineWeightsError: null
	      });
	    case _type.EDIT_SALES_ORDER_LINE_WEIGHTS_FAILURE:
	      {
	        var editSalesOrderLineWeightsError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { editSalesOrderLineWeightsError: editSalesOrderLineWeightsError.errors[0], salesOrderLineWeightsIsEditing: false });
	      }
	    case _type.CLEAR_SALES_ORDER_LINE_WEIGHTS:
	      return _extends({}, state, { salesOrderLineWeightsIsEditing: false, editSalesOrderLineWeightsSuccess: false, editSalesOrderLineWeightsError: null
	      });
	    case _type.REQUEST_SALES_ORDER_FORM:
	      return _extends({}, state, { printFormIsLoading: true, printFormError: null });
	    case _type.FETCH_SALES_ORDER_FORM_SUCCESS:
	      window.open('data:application/pdf,' + escape(action.payload.data));
	      return _extends({}, state, { printForm: action.payload.data, printFormIsLoading: false });
	    case _type.FETCH_SALES_ORDER_FORM_FAILURE:
	      {
	        var printFormError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { printFormIsLoading: false, printFormError: printFormError });
	      }
	    case _type.REQUEST_SALES_CSV:
	      return _extends({}, state, { csvIsLoading: true, csvError: null });
	    case _type.FETCH_SALES_CSV_SUCCESS:
	      window.open('data:application/pdf,' + escape(action.payload.data));
	      return _extends({}, state, { csv: action.payload.data, csvIsLoading: false });
	    case _type.FETCH_SALES_CSV_FAILURE:
	      {
	        var csvError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { csvIsLoading: false, csvError: csvError });
	      }
	    case _type.REQUEST_SAVE_POS_SALE:
	      return _extends({}, state, { SavingPosSale: true, SavePosSaleSuccessful: null, SavePosSaleFailure: null, SavePosError: SavePosError
	      });
	    case _type.SAVE_POS_SALE_SUCCESS:
	      return _extends({}, state, { SavingPosSale: false, SavePosSaleSuccessful: true });
	    case _type.SAVE_POS_SALE_FAILURE:
	      {
	        var _SavePosError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { SavingPosSale: false, SavePosSaleFailure: true, SavePosError: _SavePosError
	        });
	      }
	    case _type.INVALID_CHARACTER_ENTERED:
	      return _extends({}, state, { InvalidCharacterEntered: true });
	    case _type.CLEAR_ERROR_MESSAGE_IN_POS:
	      return _extends({}, state, { InvalidCharacterEntered: false, ChargeNotMet: false });
	    case _type.CHARGE_NOT_MET:
	      return _extends({}, state, { ChargeNotMet: true });
	    case _type.START_NEW_ORDER:
	      return _extends({}, state, { SavePosSaleSuccessful: null, SavePosSaleFailure: null });
	    case _type.REQUEST_DRAFT_DETAILS:
	      return _extends({}, state, { RequestingDraft: true, LoadDraftSuccessful: null, LoadDraftFailure: null
	      });
	    case _type.LOAD_DRAFT_SUCCESS:
	      return _extends({}, state, { RequestingDraft: false, DraftDetails: action.payload.data });
	    case _type.LOAD_DRAFT_FAILURE:
	      {
	        var DraftError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { RequestingDraft: false, DraftError: DraftError });
	      }
	    case _type.REQUEST_DRAFTS:
	      return _extends({}, state, { draftsIsLoading: true, drafts: null, draftsError: null
	      });
	    case _type.FETCH_DRAFTS_SUCCESSFUL:
	      return _extends({}, state, { draftsIsLoading: false, drafts: action.payload.data });
	    case _type.FETCH_DRAFTS_FAILURE:
	      {
	        var draftsError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { draftsIsLoading: false, draftsError: draftsError });
	      }
	    case _type.REQUEST_CUSTOMER_PRICES:
	      return _extends({}, state, { customerPricesIsLoading: true, customerPricesError: null });
	    case _type.FETCH_CUSTOMER_PRICES_SUCCESS:
	      return _extends({}, state, { customerPricesIsLoading: false, customerPrices: action.payload.data });
	    case _type.FETCH_CUSTOMER_PRICES_FAILURE:
	      {
	        var customerPricesError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { customerPricesIsLoading: false, customerPricesError: customerPricesError });
	      }
	    case _type.REQUEST_CURRENCY_RATES:
	      return _extends({}, state, { currencyRatesIsLoading: true, currencyRates: null, currencyRatesError: null
	      });
	    case _type.FETCH_CURRENCY_RATES_SUCCESS:
	      return _extends({}, state, { currencyRatesIsLoading: false, currencyRates: action.payload.data, currencyRatesError: null
	      });
	    case _type.FETCH_CURRENCY_RATES_FAILURE:
	      {
	        var currencyRatesError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { currencyRatesIsLoading: false, currencyRates: null, currencyRatesError: currencyRatesError
	        });
	      }
	    case _type.EDIT_MULTI_CURRENCIES:
	      return _extends({}, state, { multiCurrenciesIsEditing: true, multiCurrenciesEdited: false, multiCurrenciesEditError: null
	      });
	    case _type.EDIT_MULTI_CURRENCIES_SUCCESS:
	      return _extends({}, state, { multiCurrenciesIsEditing: false, multiCurrenciesEdited: true });
	    case _type.EDIT_MULTI_CURRENCIES_FAILURE:
	      {
	        var multiCurrenciesEditError = action.payload.data || { message: action.payload.message };
	        alert(JSON.stringify(multiCurrenciesEditError));
	        return _extends({}, state, { multiCurrenciesIsEditing: false, multiCurrenciesEditError: multiCurrenciesEditError });
	      }
	    case _type.REQUEST_TAX_RATES:
	      return _extends({}, state, { taxRatesIsLoading: true, taxRates: null, taxRatesError: null
	      });
	    case _type.FETCH_TAX_RATES_SUCCESS:
	      return _extends({}, state, { taxRatesIsLoading: false, taxRates: action.payload.data, taxRatesError: null
	      });
	    case _type.FETCH_TAX_RATES_FAILURE:
	      {
	        var taxRatesError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { taxRatesIsLoading: false, taxRates: null, taxRatesError: taxRatesError
	        });
	      }
	    case _type.EDIT_MULTI_TAXES:
	      return _extends({}, state, { multiTaxesIsEditing: true, multiTaxesEdited: false, multiTaxesEditError: null
	      });
	    case _type.EDIT_MULTI_TAXES_SUCCESS:
	      return _extends({}, state, { multiTaxesIsEditing: false, multiTaxesEdited: true });
	    case _type.EDIT_MULTI_TAXES_FAILURE:
	      {
	        var multiTaxesEditError = action.payload.data || { message: action.payload.message };
	        alert(JSON.stringify(multiTaxesEditError));
	        return _extends({}, state, { multiTaxesIsEditing: false, multiTaxesEditError: multiTaxesEditError });
	      }
	    case _type.DELETE_TAX:
	      return _extends({}, state, { taxIsDeleting: true, taxDeleted: false, taxDeleteError: null
	      });
	    case _type.DELETE_TAX_SUCCESS:
	      return _extends({}, state, { taxIsDeleting: false, taxDeleted: true });
	    case _type.DELETE_TAX_FAILURE:
	      {
	        var taxDeleteError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { taxIsDeleting: false, taxDeleteError: taxDeleteError });
	      }
	    case _type.REQUEST_CREATE_TAX_RATE:
	      return _extends({}, state, { creatingTaxRate: true, createTaxRateError: null, createTaxRateSuccess: null
	      });
	    case _type.CREATE_TAX_RATE_SUCCESS:
	      return _extends({}, state, { creatingTaxRate: false, createTaxRateSuccess: true });
	    case _type.CREATE_TAX_RATE_FAILURE:
	      {
	        var createTaxRateError = action.payload.data || { message: action.payload.data };
	        return _extends({}, state, { creatingTaxRate: false, createTaxRateError: createTaxRateError });
	      }
	    case _type.REQUEST_OVERALL_SALES_PERFORMANCE:
	      return _extends({}, state, { overallSalesIsLoading: true, overallSalesError: null, overallSales: []
	      });
	    case _type.FETCH_OVERALL_SALES_PERFORMANCE_SUCCESS:
	      return _extends({}, state, { overallSalesIsLoading: false, overallSales: action.payload.data });
	    case _type.FETCH_OVERALL_SALES_PERFORMANCE_FAILURE:
	      {
	        var overallSalesError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { overallSalesIsLoading: false, overallSalesError: overallSalesError });
	      }
	    case _type.REQUEST_POS_REPORT:
	      return _extends({}, state, { posReportIsLoading: true, posReport: [], posReportError: null
	      });
	    case _type.FETCH_POS_REPORT_SUCCESS:
	      return _extends({}, state, { posReportIsLoading: false, posReport: action.payload.data });
	    case _type.FETCH_POS_REPORT_FAILURE:
	      {
	        var posReportError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { posReportIsLoading: false, posReportError: posReportError });
	      }
	    case _type.REQUEST_SALES_INVENTORY_INFO:
	      return _extends({}, state, { salesInventoryInfoIsLoading: true, salesInventoryInfo: [], salesInventoryInfoError: null
	      });
	    case _type.FETCH_SALES_INVENTORY_INFO_SUCCESS:
	      return _extends({}, state, { salesInventoryInfoIsLoading: false, salesInventoryInfo: action.payload.data });
	    case _type.FETCH_SALES_INVENTORY_INFO_FAILURE:
	      {
	        var salesInventoryInfoError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { salesInventoryInfoIsLoading: false, salesInventoryInfoError: salesInventoryInfoError });
	      }
	    case _type.REQUEST_SALES_CUSTOMER_DETAIL:
	      return _extends({}, state, { salesCustomerDetailsIsLoading: true, salesCustomerDetails: {}, salesCustomerDetailsError: null
	      });
	    case _type.REQUEST_SALES_SHIPPING_CUSTOMER_DETAIL:
	      return _extends({}, state, { salesCustomerDetailsIsLoading: true, salesShippingCustomerDetails: {}, salesCustomerDetailsError: null
	      });
	    case _type.FETCH_SALES_SHIPPING_CUSTOMER_DETAIL_SUCCESS:
	      return _extends({}, state, { salesCustomerDetailsIsLoading: false, salesShippingCustomerDetails: action.payload.data });
	    case _type.FETCH_SALES_CUSTOMER_DETAIL_SUCCESS:
	      return _extends({}, state, { salesCustomerDetailsIsLoading: false, salesCustomerDetails: action.payload.data });
	    case _type.FETCH_SALES_CUSTOMER_DETAIL_FAILURE:
	      {
	        var salesCustomerDetailsError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { salesCustomerDetailsIsLoading: false, salesCustomerDetailsError: salesCustomerDetailsError });
	      }
	    case _type.REQUEST_SHIPPING_DETAIL:
	      return _extends({}, state, { allShippingIsLoading: true, allShipping: {}, allShippingError: null
	      });
	    case _type.FETCH_SHIPPING_DETAIL_SUCCESS:
	      return _extends({}, state, { allShippingIsLoading: false, allShipping: action.payload.data });
	    case _type.FETCH_SHIPPING_DETAIL_FAILURE:
	      {
	        var allShippingError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { allShippingIsLoading: false, allShippingError: allShippingError });
	      }
	    case _type.REQUEST_PURCHASES_VENDOR_DETAIL:
	      return _extends({}, state, { salesVendorDetailsIsLoading: true, purchasesDetails: {}, purchasesVendorDetailsError: null
	      });
	    case _type.FETCH_PURCHASES_VENDOR_DETAIL_SUCCESS:
	      return _extends({}, state, { purchasesVendorDetailsIsLoading: false, purchasesVendorDetails: action.payload.data });
	    case _type.FETCH_PURCHASES_VENDOR_DETAIL_FAILURE:
	      {
	        var purchasesVendorDetailsError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { purchasesVendorDetailsIsLoading: false, purchasesVendorDetailsError: purchasesVendorDetailsError });
	      }
	    case _type.CLEAR_SALES_CUSTOMER_DETAILS:
	      return _extends({}, state, { salesCustomerDetails: null });
	    case _type.REQUEST_ITEM_SALES_HISTORY:
	      return _extends({}, state, { salesItemHistoryIsLoading: true, salesItemHistory: [], salesItemHistoryError: null
	      });
	    case _type.FETCH_ITEM_SALES_HISTORY_SUCCESS:
	      return _extends({}, state, { salesItemHistoryIsLoading: false, salesItemHistory: action.payload.data });
	    case _type.FETCH_ITEM_SALES_HISTORY_FAILURE:
	      {
	        var salesItemHistoryError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { salesItemHistoryIsLoading: false, salesItemHistoryError: salesItemHistoryError });
	      }
	    case _type.REQUEST_CUSTOMER_FREQUENT:
	      return _extends({}, state, { customerFrequentIsLoading: true, customerFrequent: [], customerFrequentError: null
	      });
	    case _type.FETCH_CUSTOMER_FREQUENT_SUCCESS:
	      return _extends({}, state, { customerFrequentIsLoading: false, customerFrequent: action.payload.data });
	    case _type.FETCH_CUSTOMER_FREQUENT_FAILURE:
	      {
	        var customerFrequentError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { customerFrequentIsLoading: false, customerFrequentError: customerFrequentError });
	      }
	    case _type.SET_SALES_ORDERS_FILTER:
	      return _extends({}, state, { salesOrdersFilter: action.payload });
	    case _type.REQUEST_SALES_PERFORMANCE_BY_FILTER:
	    case _type.REQUEST_SALES_PERFORMANCE:
	      return _extends({}, state, { salesPerformanceIsLoading: true, salesPerformance: null, salesPerformanceError: null
	      });
	    case _type.REQUEST_SALES_PERFORMANCE_SUCCESS:
	      return _extends({}, state, { salesPerformanceIsLoading: false, salesPerformance: action.payload.data, salesPerformanceError: null
	      });
	    case _type.REQUEST_SALES_PERFORMANCE_FAILURE:
	      {
	        var salesPerformanceError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { salesPerformanceIsLoading: false, salesPerformance: null, salesPerformanceError: salesPerformanceError
	        });
	      }
	    case _type.REQUEST_USER_PERFORMANCE_BY_FILTER:
	      return _extends({}, state, { userPerformanceIsLoading: true, userPerformanceData: {}, userPerformanceError: null
	      });
	    case _type.REQUEST_USER_PERFORMANCE_SUCCESS:
	      return _extends({}, state, { userPerformanceIsLoading: false, userPerformanceData: action.payload, userPerformanceError: null
	      });
	    case _type.REQUEST_USER_PERFORMANCE_FAILURE:
	      return _extends({}, state, { userPerformanceIsLoading: false, userPerformanceData: {}, userPerformanceError: action.payload
	      });
	    case _type.REQUEST_SALES_DASHBOARD_DETAIL:
	      return _extends({}, state, { dashboardSalesDetailError: null, dashboardSalesDetailIsLoading: true, dashboardSalesDetail: null
	      });
	    case _type.FETCH_SALES_DASHBOARD_DETAIL_SUCCESS:
	      return _extends({}, state, { dashboardSalesDetail: action.payload.data, dashboardSalesDetailError: null, dashboardSalesDetailIsLoading: false
	      });
	    case _type.FETCH_SALES_DASHBOARD_DETAIL_FAILURE:
	      {
	        var dashboardSalesDetailError = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { dashboardSalesDetail: null, dashboardSalesDetailError: dashboardSalesDetailError, dashboardSalesDetailIsLoading: false
	        });
	      }
	    case _type.REQUEST_SALES_LEVELS:
	      return _extends({}, state, { salesLevelsIsLoading: true, salesLevels: {}, salesLevelsError: null
	      });
	    case _type.FETCH_SALES_LEVELS_SUCCESS:
	      return _extends({}, state, { salesLevelsIsLoading: false, salesLevels: action.payload.data });
	    case _type.FETCH_SALES_LEVELS_FAILURE:
	      return _extends({}, state, { salesLevelsIsLoading: false, salesLevelsError: action.payload.data });
	    case _type.REQUEST_REFUND:
	      return _extends({}, state, { refund: { error: null, loading: true, status: 0 } });
	    case _type.REQUEST_REFUND_SUCCESS:
	      return _extends({}, state, { refund: { error: null, loading: false, status: 200 } });
	    case _type.REQUEST_REFUND_FAILURE:
	      {
	        var refundError = action.payload.data || { message: action.payload.message }; // 2nd one is network or server down errors
	        return _extends({}, state, { refund: { error: refundError, loading: false, status: 400 } });
	      }
	    case _type.REQUEST_PRODUCT_BY_ID:
	      return _extends({}, state, { salesOrderProductIsLoading: true, salesOrderProduct: null, salesOrderProductFailure: null
	      });
	    case _type.FETCH_PRODUCT_BY_ID_SUCCESS:
	      return _extends({}, state, { salesOrderProductIsLoading: false, salesOrderProduct: action.payload.data });
	    case _type.FETCH_PRODUCT_BY_ID_FAILURE:
	      return _extends({}, state, { salesOrderProductIsLoading: false, salesOrderProductFailure: action.payload.data });
	
	    case _type.REQUEST_SHIPPING_LIST_PDF:
	      return _extends({}, state, { requestingShippingList: true, shippingListPDF: null });
	    case _type.FETCH_SHIPPING_LIST_SUCCESS:
	      return _extends({}, state, { requestingShippingList: false, shippingListPDF: action.payload.data });
	    case _type.REMOVE_SHIPPING_PDF:
	      return _extends({}, state, { shippingListPDF: null });
	
	    case _type.REQUEST_PACKING_LIST_PDF:
	      return _extends({}, state, { requestingPackingList: true, packingListPDF: null });
	    case _type.FETCH_PACKING_LIST_SUCCESS:
	      return _extends({}, state, { requestingPackingList: false, packingListPDF: action.payload.data });
	
	    case _type.REQUEST_PICKING_LIST_PDF:
	      return _extends({}, state, { requestingPickingList: true, pickingListPDF: null });
	    case _type.FETCH_PICKING_LIST_SUCCESS:
	      return _extends({}, state, { requestingPickingList: false, pickingListPDF: action.payload.data });
	
	    case _type.REQUEST_SO_PDF:
	      return _extends({}, state, { requestingSalesOrderPDF: true, salesOrderPDF: null });
	    case _type.FETCH_SO_PDF_SUCCESS:
	      return _extends({}, state, { requestingSalesOrderPDF: false, salesOrderPDF: action.payload.data });
	
	    case _type.REQUEST_SO_SI_PDF:
	      return _extends({}, state, { requestingSalesOrderSIPDF: true, salesOrderSIPDF: null });
	    case _type.FETCH_SO_SI_PDF_SUCCESS:
	      return _extends({}, state, { requestingSalesOrderSIPDF: false, salesOrderSIPDF: action.payload.data });
	
	    case _type.REQUEST_BOL_ID_PDF:
	      return _extends({}, state, { requestingBolIdPDF: true, bolIdPDF: null });
	    case _type.FETCH_BOL_ID_PDF_SUCCESS:
	      return _extends({}, state, { requestingBolIdPDF: false, bolIdPDF: action.payload.data });
	
	    case _type.REQUEST_BOL_WITHOUT_LOG:
	      return _extends({}, state, { requestingBolWithoutLogPDF: true, bolWithoutLogPDF: null });
	    case _type.FETCH_BOL_WITHOUT_LOG_SUCCESS:
	      return _extends({}, state, { requestingBolWithoutLogPDF: false, bolWithoutLogPDF: action.payload.data });
	
	    case _type.REQUEST_BOL_LABEL:
	      return _extends({}, state, { requestingBolLabel: true, bolLabel: null });
	    case _type.FETCH_BOL_LABEL_SUCCESS:
	      return _extends({}, state, { requestingBolLabel: false, bolLabel: action.payload.data });
	
	    case _type.REQUEST_BOL_FBA_PDF:
	      return _extends({}, state, { requestingBolFbaPDF: true, bolFbaPDF: null });
	    case _type.FETCH_BOL_FBA_PDF_SUCCESS:
	      return _extends({}, state, { requestingBolFbaPDF: false, bolFbaPDF: action.payload.data });
	
	    case _type.REQUEST_SP_PDF:
	      return _extends({}, state, { spPDF: null });
	    case _type.FETCH_SP_SUCCESS:
	      return _extends({}, state, { spPDF: action.payload.data });
	
	    case _type.FETCH_BOL_ADDRESS_SUCCESS:
	      return _extends({}, state, { bolAddress: action.payload.data });
	
	    case _type.REQUEST_REFUND_PDF:
	      return _extends({}, state, { requestingRefundPDF: true, refundPDF: null });
	    case _type.REQUEST_REFUND_PDF_SUCCESS:
	      return _extends({}, state, { requestingRefundPDF: false, refundPDF: action.payload.data });
	
	    case _type.KEEP_EST_DATE:
	      return _extends({}, state, { prevEstDate: action.payload.date, salesOrderEdited: false, salesOrderCreated: false, detailIsLoading: true, prevEstDateIsNeeded: true
	      });
	    case _type.FINISHED_UNMOUNT:
	      return _extends({}, state, { detailIsLoading: false });
	    case _type.DESTROY_EST_DATE:
	      return _extends({}, state, { prevEstDate: null, salesOrderEdited: false, salesOrderCreated: false, prevEstDateIsNeeded: false
	      });
	
	    case _type.REQUEST_SALES_TOTALS:
	      return _extends({}, state, { salesTotalsIsLoading: true, salesTotals: null, salesTotalsError: null
	      });
	    case _type.FETCH_SALES_TOTALS_SUCCESS:
	      return _extends({}, state, { salesTotalsIsLoading: false, salesTotals: action.payload.data
	      });
	    case _type.FETCH_SALES_TOTALS_FAILURE:
	      return _extends({}, state, { salesTotalsIsLoading: false, salesTotalsError: action.payload.data
	      });
	    case _type.REQUEST_SALES_ORDER_TO_QUOTE:
	      return _extends({}, state, { error: null, quoteLoading: true
	      });
	    case _type.SALES_ORDER_TO_QUOTE_SUCCESS:
	      return _extends({}, state, { quoteLoading: false
	      });
	    case _type.SALES_ORDER_TO_QUOTE_FAILURE:
	      {
	        var sToOerror = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { error: sToOerror, quoteLoading: false
	        });
	      }
	    case _type.REQUEST_SALES_QUOTE_TO_OPEN:
	      return _extends({}, state, { error: null, quoteLoading: true
	      });
	    case _type.REQUEST_SALES_QUOTE_TO_ORDER_SUCCESS:
	      return _extends({}, state, { quoteLoading: false
	      });
	    case _type.REQUEST_SALES_QUOTE_TO_ORDER_FAILURE:
	      {
	        var qToSerror = action.payload.data || { message: action.payload.message };
	        return _extends({}, state, { quoteLoading: false, error: qToSerror
	        });
	      }
	    case _type.UPDATE_CURRENT_SALES_ORDER_DETAIL_SHIPPINGINFO:
	      return _extends({}, state, { currentSalesOrderDetail: _extends({}, state.currentSalesOrderDetail, { Shipping: action.payload }) });
	    case _type.SALES_ORDER_FORM_BATCHES:
	      return _extends({}, state, {
	        batchesInfo: action.payload
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/salesOrders_reducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/salesOrders_reducer.js');
	}();

	;

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    all: [],
	    currentScrapRecord: null,
	    currentScrapRecordDetail: null,
	    isLoading: false,
	    error: null,
	    detailIsLoading: false,
	    detailError: null,
	    isCreating: false,
	    createError: null,
	    created: false,
	    isEditing: false,
	    editError: null,
	    edited: false,
	    inventories: null,
	    inventoriesIsLoading: false,
	    inventoriesError: null,
	    scrapRecordIsCreating: false,
	    scrapRecordCreateError: null,
	    scrapRecordCreated: false,
	    scrapRecordIsEditing: false,
	    scrapRecordEditError: null,
	    scrapRecordEdited: false
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	
	        // Inventory Adjustment action handlers
	        case _type.REQUEST_SCRAP_RECORDS:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.FETCH_SCRAP_RECORDS_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	        case _type.FETCH_SCRAP_RECORDS_FAILURE:
	            var error = action.payload || { message: action.payload.message };
	            return _extends({}, state, { all: [], error: error, isLoading: false });
	        case _type.SELECT_SCRAP_RECORD:
	            return _extends({}, state, { currentScrapRecord: action.payload });
	        case _type.RESET_CURRENT_SCRAP_RECORD:
	            return _extends({}, state, { currentScrapRecord: null, currentScrapRecordDetail: null });
	        case _type.REQUEST_SCRAP_RECORD_DETAIL:
	            return _extends({}, state, { detailError: null, detailIsLoading: true });
	        case _type.FETCH_SCRAP_RECORD_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { currentScrapRecordDetail: action.payload.data, detailError: null, detailIsLoading: false });
	        case _type.FETCH_SCRAP_RECORD_DETAIL_FAILURE:
	            // return error and make loading = false
	            var detailError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { all: [], detailError: detailError, detailIsLoading: false });
	        case _type.FETCH_INVENTORY_SCRAP:
	            return _extends({}, state, { inventories: null, inventoriesIsLoading: true, inventoriesError: null });
	        case _type.FETCH_INVENTORY_SCRAP_SUCCESS:
	            return _extends({}, state, { inventories: action.payload.data, inventoriesIsLoading: false, inventoriesError: null });
	        case _type.FETCH_INVENTORY_SCRAP_FAILURE:
	            var inventoriesError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { inventories: null, inventoriesIsLoading: false, inventoriesError: inventoriesError });
	        case _type.REQUEST_CREATING_SCRAP_RECORD:
	            return _extends({}, state, { scrapRecordIsCreating: true, scrapRecordCreateError: null, scrapRecordCreated: false });
	        case _type.CREATE_SCRAP_RECORD_SUCCESS:
	            return _extends({}, state, { scrapRecordIsCreating: false, scrapRecordCreateError: null, scrapRecordCreated: true });
	        case _type.CREATE_SCRAP_RECORD_FAILURE:
	            var scrapRecordCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { scrapRecordIsCreating: false, scrapRecordCreateError: scrapRecordCreateError, scrapRecordCreated: false });
	        case _type.REQUEST_EDITING_SCRAP_RECORD:
	            return _extends({}, state, { scrapRecordIsEditing: true, scrapRecordEditError: null, scrapRecordEdited: false });
	        case _type.EDIT_SCRAP_RECORD_SUCCESS:
	            return _extends({}, state, { scrapRecordIsEditing: false, scrapRecordEditError: null, scrapRecordEdited: true });
	        case _type.EDIT_SCRAP_RECORD_FAILURE:
	            var scrapRecordEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { scrapRecordIsEditing: false, scrapRecordEditError: scrapRecordEditError, scrapRecordEdited: false });
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/scrapRecords_reducer.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/scrapRecords_reducer.js');
	}();

	;

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    all: [],
	    error: null,
	    isLoading: false,
	    userDetail: null,
	    userDetailError: null,
	    userDetailIsLoading: false,
	    mobileUsers: [],
	    mobileUsersTotalPages: null,
	    mobileUsersTotalCount: null,
	    mobileUsersIsLoading: false,
	    mobileUsersError: null,
	    currentUser: null,
	    groups: [],
	    groupsError: null,
	    groupsIsLoading: false,
	    groupDetail: null,
	    groupDetailError: null,
	    groupDetailIsLoading: false,
	    currentGroup: null,
	    permissions: null,
	    permissionsIsLoading: false,
	    permissionsError: null,
	    editUserDetail: null,
	    editUserDetailError: null,
	    editUserDetailIsLoading: false,
	    editGroupDetail: null,
	    editGroupDetailError: null,
	    editGroupDetailIsLoading: false,
	    editUserDetailSuccess: false,
	    editPassword: false,
	    editPasswordError: null,
	    editPasswordIsLoading: false,
	    createUserDetailError: null,
	    createGroupDetailError: null,
	    checkPassword: false,
	    checkPasswordSuccess: false,
	    checkPasswordFailure: false,
	    checkingPermission: false,
	    checkPermissionSuccess: null,
	    checkPermissionFailure: false,
	    actionLog: [],
	    actionLogIsLoading: false,
	    actionLogError: null,
	    mobileUserId: null,
	    username: null,
	    usernameIsLoading: false,
	    userNameError: null,
	    selectedBusinessUser: {}
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _type.SET_SELECTED_BUSINESSUSER:
	            return _extends({}, state, { selectedBusinessUser: action.payload });
	        case _type.REQUEST_BASE_USER:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.FETCH_BASE_USER_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	        case _type.FETCH_BASE_USER_FAILURE:
	            var error = action.payload || { message: action.payload.message };
	            alert(JSON.stringify(error));
	            return _extends({}, state, { all: [], error: error, isLoading: false });
	        case _type.REQUEST_BASE_USER_DETAIL:
	            return _extends({}, state, { userDetailError: null, userDetailIsLoading: true, editUserDetailSuccess: false });
	        case _type.FETCH_BASE_USER_DETAIL_SUCCESS:
	            return _extends({}, state, { userDetail: action.payload.data, userDetailError: null, userDetailIsLoading: false });
	        case _type.FETCH_BASE_USER_DETAIL_FAILURE:
	            var userDetailError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { userDetail: [], userDetailError: userDetailError, userDetailIsLoading: false });
	        case _type.REQUEST_MOBILE_USERS:
	            return _extends({}, state, {
	                mobileUsers: [],
	                mobileUsersIsLoading: true,
	                mobileUsersError: null
	            });
	        case _type.FETCH_MOBILE_USERS_SUCCESS:
	            return _extends({}, state, {
	                mobileUsers: action.payload.data.record,
	                mobileUsersTotalPages: action.payload.data.pages,
	                mobileUsersTotalCount: action.payload.data.count,
	                mobileUsersIsLoading: false,
	                mobileUsersError: null
	            });
	        case _type.FETCH_MOBILE_USERS_FAILURE:
	            var mobileUsersError = action.payload || { message: action.payload.message };
	            alert(JSON.stringify(error));
	            return _extends({}, state, {
	                mobileUsers: [],
	                mobileUsersIsLoading: false,
	                mobileUsersError: mobileUsersError
	            });
	        case _type.SELECT_CURRENT_USER:
	            return _extends({}, state, { currentUser: action.payload });
	        case _type.RESET_CURRENT_USER:
	            return _extends({}, state, { currentUser: null, userDetail: null, editUserDetailSuccess: false });
	        case _type.REQUEST_USER_GROUPS:
	            return _extends({}, state, { groupsError: null, groupsIsLoading: true });
	        case _type.FETCH_USER_GROUPS_SUCCESS:
	            return _extends({}, state, { groups: action.payload.data, groupsError: null, groupsIsLoading: false });
	        case _type.FETCH_USER_PRODUCT_ALL_GROUPS_SUCCESS:
	            return _extends({}, state, { productGroups: action.payload.data });
	        case _type.FETCH_USER_GROUPS_FAILURE:
	            var groupsError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { groups: [], groupsError: groupsError, groupsIsLoading: false });
	        case _type.REQUEST_GROUP_DETAIL:
	            return _extends({}, state, { groupDetailError: null, groupDetailIsLoading: true });
	        case _type.FETCH_GROUP_DETAIL_SUCCESS:
	            return _extends({}, state, { groupDetail: action.payload.data, groupDetailError: null, groupDetailIsLoading: false });
	        case _type.FETCH_GROUP_DETAIL_FAILURE:
	            var groupDetailError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { groupDetail: [], groupDetailError: groupDetailError, groupDetailIsLoading: false });
	        case _type.SELECT_CURRENT_GROUP:
	            return _extends({}, state, { currentGroup: action.payload });
	        case _type.RESET_CURRENT_USER_GROUP:
	            return _extends({}, state, { currentGroup: null, groupDetail: null });
	        case _type.REQUEST_PERMISSIONS:
	            return _extends({}, state, { permissions: null, permissionsIsLoading: true });
	        case _type.FETCH_PERMISSIONS_SUCCESS:
	            return _extends({}, state, { permissions: action.payload.data, permissionsError: null, permissionsIsLoading: false });
	        case _type.FETCH_PERMISSIONS_FAILURE:
	            var permissionsError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { permissions: [], permissionsError: permissionsError, permissionsIsLoading: false });
	        case _type.EDIT_USER_DETAIL:
	            return _extends({}, state, { editUserDetail: null, editUserDetailIsLoading: true });
	        case _type.EDIT_USER_DETAIL_SUCCESS:
	            return _extends({}, state, { editUserDetail: action.payload.data, editUserDetailError: null, editUserDetailIsLoading: false, editUserDetailSuccess: true });
	        case _type.EDIT_USER_DETAIL_FAILURE:
	            var editUserDetailError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { editUserDetail: [], editUserDetailError: editUserDetailError, editUserDetailIsLoading: false });
	        case _type.EDIT_PASSWORD:
	            return _extends({}, state, { editPassword: null, editPasswordError: null, editPasswordIsLoading: true, editUserDetailSuccess: false });
	        case _type.EDIT_PASSWORD_SUCCESS:
	            return _extends({}, state, { editPassword: action.payload.data, editPasswordError: null, editPasswordIsLoading: false, editUserDetailSuccess: true });
	        case _type.EDIT_PASSWORD_FAILURE:
	            var editPasswordError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { editPassword: [], editPasswordError: editPasswordError, editPasswordIsLoading: false });
	        case _type.RESET_PASSWORD:
	            return _extends({}, state, { editPasswordError: null, editUserDetailSuccess: false });
	        case _type.EDIT_GROUP_DETAIL:
	            return _extends({}, state, { editGroupDetail: null, editGroupDetailIsLoading: true });
	        case _type.EDIT_GROUP_DETAIL_SUCCESS:
	            return _extends({}, state, { editGroupDetail: action.payload.data, editGroupDetailError: null, editGroupDetailIsLoading: false });
	        case _type.EDIT_GROUP_DETAIL_FAILURE:
	            var editGroupDetailError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { editGroupDetail: [], editGroupDetailError: editGroupDetailError, editGroupDetailIsLoading: false });
	        case _type.CREATE_GROUP_DETAIL_FAILURE:
	            var createGroupDetailError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { createGroupDetailError: createGroupDetailError });
	        case _type.RESET_USER_DETAIL:
	            return _extends({}, state, { createUserDetailError: null });
	        case _type.CREATE_USER_DETAIL:
	            return _extends({}, state, { createUserDetailError: null });
	        case _type.CREATE_USER_DETAIL_SUCCESS:
	            return _extends({}, state, { createUserDetailError: null });
	        case _type.CREATE_USER_DETAIL_FAILURE:
	            var createUserDetailError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { createUserDetailError: createUserDetailError });
	        case _type.CHECK_PASSWORD:
	            return _extends({}, state, { checkPassword: true, checkPasswordSuccess: false, checkPasswordFailure: false });
	        case _type.CHECK_PASSWORD_SUCCESS:
	            return _extends({}, state, { checkPassword: false, checkPasswordSuccess: true, checkPasswordFailure: false });
	        case _type.CHECK_PASSWORD_FAILURE:
	            return _extends({}, state, { checkPassword: false, checkPasswordSuccess: false, checkPasswordFailure: true });
	        case _type.CLEAR_CHECK_PASSWORD:
	            return _extends({}, state, { checkPassword: false, checkPasswordSuccess: false, checkPasswordFailure: false });
	        case _type.CHECK_PERMISSIOIN:
	            return _extends({}, state, { checkingPermission: true, checkPermissionSuccess: null, checkPermissionFailure: false });
	        case _type.CHECK_PERMISSIOIN_SUCCESS:
	            return _extends({}, state, { checkingPermission: false, checkPermissionSuccess: action.payload.data, checkPermissionFailure: false });
	        case _type.CHECK_PERMISSIOIN_FAILURE:
	            return _extends({}, state, { checkingPermission: false, checkPermissionSuccess: null, checkPermissionFailure: true });
	        case _type.REQUEST_ACTION_LOG:
	            return _extends({}, state, {
	                actionLog: [],
	                actionLogIsLoading: true,
	                actionLogError: null
	            });
	        case _type.FETCH_ACTION_LOG_SUCCESS:
	            return _extends({}, state, {
	                actionLog: action.payload.data,
	                actionLogIsLoading: false,
	                actionLogError: null
	            });
	        case _type.FETCH_ACTION_LOG_FAILURE:
	            var actionLogError = action.payload || { message: action.payload.message };
	            alert(JSON.stringify(actionLogError));
	            return _extends({}, state, {
	                actionLog: [],
	                actionLogIsLoading: false,
	                actionLogError: actionLogError
	            });
	        case _type.REQUEST_ACTION_LOG_BY_FILTER:
	            return _extends({}, state, { actionLog: [], actionLogIsLoading: true, actionLogError: null
	            });
	        case _type.ACTION_LOG_FILTER_SUCCESS:
	            return _extends({}, state, { actionLog: action.payload.data, actionLogIsLoading: false, actionLogError: null
	            });
	        case _type.ACTION_LOG_FILTER_FAILURE:
	            var actionLogFilterError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { actionLog: [], actionLogIsLoading: false, actionLogError: actionLogFilterError
	            });
	        case _type.GRAB_MOBILE_USER_ID:
	            return _extends({}, state, { mobileUserId: action.payload
	            });
	        case _type.REQUEST_USERNAME:
	            return _extends({}, state, { usernameIsLoading: true
	            });
	        case _type.REQUEST_USERNAME_SUCCESS:
	            return _extends({}, state, { usernameIsLoading: false, userNameError: null, username: action.payload
	            });
	        case _type.REQUEST_USERNAME_FAILURE:
	            return _extends({}, state, { usernameIsLoading: false, userNameError: action.payload
	            });
	        case _type.CLEAR_USERNAME_DATA:
	            return _extends({}, state, { username: null, usernameIsLoading: false, userNameError: null, mobileUserId: null
	            });
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/settings_reducer.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/settings_reducer.jsx');
	}();

	;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	  msoTotalPages: null,
	  all: null,
	  currentSalesOrder: null,
	  currentSalesOrderDetail: null,
	  currentSalesOrderDetailByNum: null,
	  isLoading: true,
	  error: null,
	  detailIsLoading: false,
	  detailByNumIsLoading: false,
	  detailError: null,
	  detailByNumError: null,
	  salesOrderIsCreating: false,
	  salesOrderCreateError: null,
	  salesOrderCreated: false,
	  salesOrderIsEditing: false,
	  salesOrderEditError: null,
	  salesOrderEdited: false,
	  customerOrderSchedules: [],
	  customerOrderSchedulesIsLoading: false,
	  customerOrderSchedulesError: null,
	  todaysOutgoingOrders: [],
	  todaysOutgoingOrdersIsLoading: null,
	  todaysOutgoingOrdersError: null,
	  salesOrderLineWeights: [],
	  salesOrderLineWeightsIsLoading: false,
	  salesOrderLineWeightsError: null,
	  salesOrderLineWeightsIsEditing: false,
	  editSalesOrderLineWeightsError: null,
	  editSalesOrderLineWeightsSuccess: false,
	  printForm: null,
	  printFormIsLoading: false,
	  printFormError: null,
	  csv: null,
	  csvIsLoading: false,
	  csvError: null,
	  SavingPosSale: false,
	  SavePosSaleSuccessful: null,
	  SavePosSaleFailure: null,
	  SavePosError: null,
	  InvalidCharacterEntered: false,
	  ChargeNotMet: false,
	  RequestingDraft: null,
	  DraftDetails: null,
	  DraftError: null,
	  drafts: null,
	  draftsIsLoading: null,
	  draftsError: null,
	  customerPricesIsLoading: false,
	  customerPricesError: null,
	  customerPrices: [],
	  currencyRates: null,
	  currencyRatesIsLoading: false,
	  currencyRatesError: null,
	  multiCurrenciesIsEditing: false,
	  multiCurrenciesEdited: false,
	  multiCurrenciesEditError: null,
	  taxRates: null,
	  taxRatesIsLoading: false,
	  taxRatesError: null,
	  creatingTaxRate: false,
	  createTaxRateError: null,
	  createTaxRateSuccess: null,
	  multiTaxesIsEditing: false,
	  multiTaxesEdited: false,
	  multiTaxesEditError: null,
	  taxIsDeleting: false,
	  taxDeleted: false,
	  taxDeleteError: null,
	  overallSales: [],
	  overallSalesIsLoading: false,
	  overallSalesError: null,
	  posReport: [],
	  posReportIsLoading: false,
	  posReportError: null,
	  salesInventoryInfo: [],
	  salesInventoryInfoIsLoading: false,
	  salesInventoryInfoError: null,
	  salesCustomerDetails: null,
	  salesShippingCustomerDetails: null,
	  salesCustomerDetailsIsLoading: false,
	  allShipping: null,
	  allShippingIsLoading: false,
	  allShippingError: null,
	  purchasesVendorDetailsError: null,
	  purchasesVendorDetails: null,
	  purchasesVendorDetailsIsLoading: false,
	  salesCustomerDetailsError: null,
	  salesItemHistory: [],
	  salesItemHistoryIsLoading: false,
	  salesItemHistoryError: null,
	  customerSalesHistory: [],
	  customerSalesHistoryIsLoading: false,
	  customerSalesHistoryError: null,
	  customerFrequent: [],
	  customerFrequentIsLoading: false,
	  customerFrequentError: null,
	  salesOrdersFilter: null,
	  salesPerformanceIsLoading: false,
	  salesPerformance: null,
	  salesPerformanceError: null,
	  dashboardSalesDetail: null,
	  dashboardSalesDetailIsLoading: false,
	  dashboardSalesDetailError: null,
	  salesLevels: {},
	  salesLevelsIsLoading: false,
	  salesLevelsError: null,
	  salesOrderProduct: null,
	  salesOrderProductIsLoading: false,
	  salesOrderProductFailure: null,
	
	  requestingShippingList: false,
	  shippingListPDF: null,
	  requestingPackingList: false,
	  packingListPDF: null,
	  requestingPickingList: false,
	  pickingListPDF: null,
	  requestingSalesOrderPDF: false,
	  salesOrderPDF: null,
	  requestingBolIdPDF: false,
	  bolIdPDF: null,
	  requestingBolWithoutLogPDF: false,
	  bolWithoutLogPDF: null,
	  requestingBolLabel: false,
	  bolLabel: null,
	  requestingBolFbaPDF: false,
	  bolFbaPDF: null,
	  spPDF: null,
	  bolAddress: [],
	  requestingRefundPDF: false,
	  refundPDF: null,
	  prevEstDate: null,
	  prevEstDateIsNeeded: false,
	  // Refund related reducer
	  refund: { error: null, loading: false, status: 0 },
	  quoteLoading: false,
	  salesTotals: null,
	  salesTotalsIsLoading: false,
	  salesTotalsError: null,
	  userPerformanceIsLoading: false,
	  userPerformanceError: null,
	  userPerformanceData: {},
	  batchesInfo: {}
	};
	
	var _default = function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  // console.log("action.payload:", action);
	  switch (action.type) {
	    case _type.REQUEST_SHIP_FROM_ORDERS:
	      return _extends({}, state, { error: null, isLoading: true });
	    case _type.FETCH_SHIP_FROM_ORDERS_SUCCESS:
	      return _extends({}, state, { all: action.payload.data, error: null, isLoading: false, msoTotalPages: action.payload.data ? action.payload.data.pages : 1
	      });
	    case _type.FETCH_SHIP_FROM_ORDERS_FAILURE:
	      {
	        var error = action.payload || { message: action.payload.message };
	        return _extends({}, state, { all: [], error: error, isLoading: false
	        });
	      }
	    default:
	      return state;
	  }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/shipFromOrders_reducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/shipFromOrders_reducer.js');
	}();

	;

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	  msoTotalPages: null,
	  all: null,
	  currentSalesOrder: null,
	  currentSalesOrderDetail: null,
	  currentSalesOrderDetailByNum: null,
	  isLoading: true,
	  error: null,
	  detailIsLoading: false,
	  detailByNumIsLoading: false,
	  detailError: null,
	  detailByNumError: null,
	  salesOrderIsCreating: false,
	  salesOrderCreateError: null,
	  salesOrderCreated: false,
	  salesOrderIsEditing: false,
	  salesOrderEditError: null,
	  salesOrderEdited: false,
	  customerOrderSchedules: [],
	  customerOrderSchedulesIsLoading: false,
	  customerOrderSchedulesError: null,
	  todaysOutgoingOrders: [],
	  todaysOutgoingOrdersIsLoading: null,
	  todaysOutgoingOrdersError: null,
	  salesOrderLineWeights: [],
	  salesOrderLineWeightsIsLoading: false,
	  salesOrderLineWeightsError: null,
	  salesOrderLineWeightsIsEditing: false,
	  editSalesOrderLineWeightsError: null,
	  editSalesOrderLineWeightsSuccess: false,
	  printForm: null,
	  printFormIsLoading: false,
	  printFormError: null,
	  csv: null,
	  csvIsLoading: false,
	  csvError: null,
	  SavingPosSale: false,
	  SavePosSaleSuccessful: null,
	  SavePosSaleFailure: null,
	  SavePosError: null,
	  InvalidCharacterEntered: false,
	  ChargeNotMet: false,
	  RequestingDraft: null,
	  DraftDetails: null,
	  DraftError: null,
	  drafts: null,
	  draftsIsLoading: null,
	  draftsError: null,
	  customerPricesIsLoading: false,
	  customerPricesError: null,
	  customerPrices: [],
	  currencyRates: null,
	  currencyRatesIsLoading: false,
	  currencyRatesError: null,
	  multiCurrenciesIsEditing: false,
	  multiCurrenciesEdited: false,
	  multiCurrenciesEditError: null,
	  taxRates: null,
	  taxRatesIsLoading: false,
	  taxRatesError: null,
	  creatingTaxRate: false,
	  createTaxRateError: null,
	  createTaxRateSuccess: null,
	  multiTaxesIsEditing: false,
	  multiTaxesEdited: false,
	  multiTaxesEditError: null,
	  taxIsDeleting: false,
	  taxDeleted: false,
	  taxDeleteError: null,
	  overallSales: [],
	  overallSalesIsLoading: false,
	  overallSalesError: null,
	  posReport: [],
	  posReportIsLoading: false,
	  posReportError: null,
	  salesInventoryInfo: [],
	  salesInventoryInfoIsLoading: false,
	  salesInventoryInfoError: null,
	  salesCustomerDetails: null,
	  salesShippingCustomerDetails: null,
	  salesCustomerDetailsIsLoading: false,
	  allShipping: null,
	  allShippingIsLoading: false,
	  allShippingError: null,
	  purchasesVendorDetailsError: null,
	  purchasesVendorDetails: null,
	  purchasesVendorDetailsIsLoading: false,
	  salesCustomerDetailsError: null,
	  salesItemHistory: [],
	  salesItemHistoryIsLoading: false,
	  salesItemHistoryError: null,
	  customerSalesHistory: [],
	  customerSalesHistoryIsLoading: false,
	  customerSalesHistoryError: null,
	  customerFrequent: [],
	  customerFrequentIsLoading: false,
	  customerFrequentError: null,
	  salesOrdersFilter: null,
	  salesPerformanceIsLoading: false,
	  salesPerformance: null,
	  salesPerformanceError: null,
	  dashboardSalesDetail: null,
	  dashboardSalesDetailIsLoading: false,
	  dashboardSalesDetailError: null,
	  salesLevels: {},
	  salesLevelsIsLoading: false,
	  salesLevelsError: null,
	  salesOrderProduct: null,
	  salesOrderProductIsLoading: false,
	  salesOrderProductFailure: null,
	
	  requestingShippingList: false,
	  shippingListPDF: null,
	  requestingPackingList: false,
	  packingListPDF: null,
	  requestingPickingList: false,
	  pickingListPDF: null,
	  requestingSalesOrderPDF: false,
	  salesOrderPDF: null,
	  requestingBolIdPDF: false,
	  bolIdPDF: null,
	  requestingBolWithoutLogPDF: false,
	  bolWithoutLogPDF: null,
	  requestingBolLabel: false,
	  bolLabel: null,
	  requestingBolFbaPDF: false,
	  bolFbaPDF: null,
	  spPDF: null,
	  bolAddress: [],
	  requestingRefundPDF: false,
	  refundPDF: null,
	  prevEstDate: null,
	  prevEstDateIsNeeded: false,
	  // Refund related reducer
	  refund: { error: null, loading: false, status: 0 },
	  quoteLoading: false,
	  salesTotals: null,
	  salesTotalsIsLoading: false,
	  salesTotalsError: null,
	  userPerformanceIsLoading: false,
	  userPerformanceError: null,
	  userPerformanceData: {},
	  batchesInfo: {}
	};
	
	var _default = function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  // console.log("action.payload:", action);
	  switch (action.type) {
	    case _type.REQUEST_SHIP_TO_ORDERS:
	      return _extends({}, state, { error: null, isLoading: true });
	    case _type.FETCH_SHIP_TO_ORDERS_SUCCESS:
	      return _extends({}, state, { all: action.payload.data, error: null, isLoading: false, msoTotalPages: action.payload.data ? action.payload.data.pages : 1
	      });
	    case _type.FETCH_SHIP_TO_ORDERS_FAILURE:
	      {
	        var error = action.payload || { message: action.payload.message };
	        return _extends({}, state, { all: [], error: error, isLoading: false
	        });
	      }
	    default:
	      return state;
	  }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/shipToOrders_reducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/shipToOrders_reducer.js');
	}();

	;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    notes: []
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _type.FETCH_TRACKING_SUCCESS:
	            return _extends({}, state, {
	                notes: action.payload
	            });
	        case _type.EDIT_TRACKING_SUCCESS:
	            return _extends({}, state);
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/tracking_reducer.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/tracking_reducer.js');
	}();

	;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = { all: [], currentUser: null, isLoading: true, error: null };
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _type.REQUEST_USERS:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.FETCH_USERS_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	        case _type.FETCH_USERS_FAILURE:
	            // return error and make loading = false
	            var error = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { all: [], error: error, isLoading: false });
	        case _type.CREATE_USER:
	            return state;
	        case _type.SELECT_USER:
	            return Object.assign({}, state, {
	                currentUser: action.payload
	            });
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/users_reducer.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/users_reducer.js');
	}();

	;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    all: [],
	    currentVendor: null,
	    currentVendorDetail: null,
	    isLoading: false,
	    error: null,
	    detailIsLoading: false,
	    detailError: null,
	    isCreating: false,
	    createError: null,
	    created: false,
	    isEditing: false,
	    editError: null,
	    edited: false,
	    currentVendorInventoryDetail: null,
	    vendorInventoryDetailError: null,
	    vendorInventoryDetailIsLoading: false,
	    vendorRecords: [],
	    vendorRecordsIsLoading: null,
	    vendorRecordsError: null,
	    vendorBatchesIsLoading: false,
	    vendorBatchesError: null,
	    vendorBatches: null,
	    isAttachingDocument: false
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _type.REQUEST_VENDORS:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.FETCH_VENDORS_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	        case _type.FETCH_VENDORS_FAILURE:
	            var error = action.payload || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { all: [], error: error, isLoading: false });
	        case _type.SELECT_VENDOR:
	            return _extends({}, state, { currentVendor: action.payload });
	        case _type.RESET_CURRENT_VENDOR:
	            return _extends({}, state, { currentVendor: null, currentVendorDetail: null, editError: null, createError: null });
	        case _type.REQUEST_CREATING_VENDOR:
	            return _extends({}, state, { isCreating: true, createError: null, created: false });
	        case _type.CREATE_VENDOR_SUCCESS:
	            return _extends({}, state, { isCreating: false, createError: null, created: true });
	        case _type.CREATE_VENDOR_FAILURE:
	            var createError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            alert(JSON.stringify(createError));
	            return _extends({}, state, { isCreating: false, createError: createError, created: false });
	        case _type.REQUEST_EDITING_VENDOR:
	            return _extends({}, state, { isEditing: true, editError: null, edited: false });
	        case _type.EDIT_VENDOR_SUCCESS:
	            return _extends({}, state, { isEditing: false, editError: null, edited: true });
	        case _type.EDIT_VENDOR_FAILURE:
	            var editError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            alert(JSON.stringify(editError));
	            return _extends({}, state, { isEditing: false, editError: editError, edited: false });
	        case _type.REQUEST_VENDOR_DETAIL:
	            return _extends({}, state, { detailError: null, detailIsLoading: true });
	        case _type.FETCH_VENDOR_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { currentVendorDetail: action.payload.data, detailError: null, detailIsLoading: false });
	        case _type.FETCH_VENDOR_DETAIL_FAILURE:
	            // return error and make loading = false
	            var detailError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { all: [], detailError: detailError, detailIsLoading: false });
	        case _type.REQUEST_VENDOR_INVENTORY_DETAIL:
	            return _extends({}, state, { currentVendorInventoryDetail: null, vendorInventoryDetailError: null, vendorInventoryDetailIsLoading: true });
	        case _type.FETCH_VENDOR_INVENTORY_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { currentVendorInventoryDetail: action.payload.data, vendorInventoryDetailError: null, vendorInventoryDetailIsLoading: false });
	        case _type.FETCH_VENDOR_INVENTORY_DETAIL_FAILURE:
	            // return error and make loading = false
	            var vendorInventoryDetailError = action.payload.data || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { vendorInventoryDetailError: vendorInventoryDetailError, vendorInventoryDetailIsLoading: false });
	        case _type.REQUEST_VENDOR_RECORDS:
	            return _extends({}, state, { vendorRecordsIsLoading: true, vendorRecordsError: null, vendorRecords: [] });
	        case _type.FETCH_VENDOR_RECORDS_SUCCESS:
	            return _extends({}, state, { vendorRecordsIsLoading: false, vendorRecords: action.payload.data });
	        case _type.FETCH_VENDOR_RECORDS_FAILURE:
	            var vendorRecordsError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { vendorRecordsIsLoading: false, vendorRecordsError: vendorRecordsError });
	        case _type.FETCH_VENDOR_BATCHES:
	            return _extends({}, state, { vendorBatchesIsLoading: true, vendorBatchesError: null, vendorBatches: [] });
	        case _type.FETCH_VENDOR_BATCHES_SUCCESS:
	            return _extends({}, state, { vendorBatchesIsLoading: false, vendorBatches: action.payload.data });
	        case _type.FETCH_VENDOR_BATCHES_FAILURE:
	            var vendorBatchesError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { vendorBatchesIsLoading: false, vendorBatchesError: vendorBatchesError });
	        case _type.ATTACH_DOCUMENT:
	            return _extends({}, state, { isAttachingDocument: true, attachDocumentError: null, attachDocumentSuccess: false });
	        case _type.ATTACH_DOCUMENT_SUCCESS:
	            return _extends({}, state, { isAttachingDocument: false, attachDocumentError: null, attachDocumentSuccess: true });
	        case _type.ATTACH_DOCUMENT_FAILURE:
	            var attachDocumentError = action.payload.data || { message: action.payload.message };
	            // alert(JSON.stringify(attachDocumentError));
	            return _extends({}, state, { isAttachingDocument: false, attachDocumentError: attachDocumentError, attachDocumentSuccess: false });
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/vendors_reducer.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/vendors_reducer.js');
	}();

	;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    all: [],
	    fetchWarehousesError: null,
	    currentWarehouse: null,
	    currentWarehouseDetail: null,
	    isLoading: false,
	    error: null,
	    detailIsLoading: false,
	    detailError: null,
	    isCreating: false,
	    createError: null,
	    created: false,
	    isEditing: false,
	    editError: null,
	    edited: false,
	    salesOrders: [],
	    salesOrdersIsLoading: false,
	    salesOrdersError: null,
	    purchaseOrders: [],
	    purchaseOrdersIsLoading: false,
	    purchaseOrdersError: null,
	    warehouseBinsDetail: null,
	    warehouseBinsDetailIsLoading: false,
	    warehouseBinsDetailError: null,
	    deleteWarehouse: false,
	    deleteWarehouseSuccess: null,
	    deleteWarehouseError: null
	
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	
	        // Warehouse action handlers
	        case _type.REQUEST_WAREHOUSES:
	            return _extends({}, state, { fetchWarehousesError: null, isLoading: true });
	        case _type.FETCH_WAREHOUSES_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, updated: false, fetchWarehousesError: null, isLoading: false });
	        case _type.FETCH_WAREHOUSES_FAILURE:
	            var fetchWarehousesError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { all: [], fetchWarehousesError: fetchWarehousesError, isLoading: false });
	        case _type.RESET_WAREHOUSES:
	            return _extends({}, state, { all: [], updated: false, fetchWarehousesError: null, isLoading: false });
	        case _type.SELECT_WAREHOUSE:
	            return _extends({}, state, { currentWarehouse: action.payload });
	        case _type.RESET_CURRENT_WAREHOUSE:
	            return _extends({}, state, { currentWarehouse: null, currentWarehouseDetail: null });
	        case _type.REQUEST_WAREHOUSE_DETAIL:
	            return _extends({}, state, { detailError: null, detailIsLoading: true });
	        case _type.FETCH_WAREHOUSE_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { currentWarehouseDetail: action.payload.data, detailError: null, detailIsLoading: false });
	        case _type.FETCH_WAREHOUSE_DETAIL_FAILURE:
	            // return error and make loading = false
	            var detailError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { all: [], detailError: detailError, detailIsLoading: false });
	        case _type.REQUEST_CREATING_WAREHOUSE:
	            return _extends({}, state, { isCreating: true, createError: null, created: false });
	        case _type.CREATE_WAREHOUSE_SUCCESS:
	            return _extends({}, state, { isCreating: false, createError: null, created: true });
	        case _type.CREATE_WAREHOUSE_FAILURE:
	            var createError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { isCreating: false, createError: createError, created: false });
	        case _type.REQUEST_EDITING_WAREHOUSE:
	            return _extends({}, state, { isEditing: true, editError: null, edited: false });
	        case _type.EDIT_WAREHOUSE_SUCCESS:
	            return _extends({}, state, { updated: true, isEditing: false, editError: null, edited: true });
	        case _type.EDIT_WAREHOUSE_FAILURE:
	            var editError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { isEditing: false, editError: editError, edited: false });
	        case _type.REQUEST_WAREHOUSE_SALES_ORDERS:
	            return _extends({}, state, { salesOrdersIsLoading: true, salesOrdersError: null });
	        case _type.FETCH_WAREHOUSE_SALES_ORDERS_SUCCESS:
	            return _extends({}, state, { salesOrders: action.payload.data, salesOrdersIsLoading: false });
	        case _type.FETCH_WAREHOUSE_SALES_ORDERS_FAILURE:
	            var salesOrdersError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { salesOrdersError: salesOrdersError, salesOrdersIsLoading: false });
	        case _type.REQUEST_WAREHOUSE_PURCHASE_ORDERS:
	            return _extends({}, state, { purchaseOrdersIsLoading: true, purchaseOrdersError: null });
	        case _type.FETCH_WAREHOUSE_PURCHASE_ORDERS_SUCCESS:
	            return _extends({}, state, { purchaseOrders: action.payload.data, purchaseOrdersIsLoading: false });
	        case _type.FETCH_WAREHOUSE_PURCHASE_ORDERS_FAILURE:
	            var purchaseOrdersError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { purchaseOrdersError: purchaseOrdersError, purchaseOrdersIsLoading: null });
	        case _type.REQUEST_WAREHOUSE_BINS:
	            return _extends({}, state, { warehouseBinsDetailIsLoading: true, warehouseBinsDetailError: null });
	        case _type.FETCH_WAREHOUSE_BINS_SUCCESS:
	            return _extends({}, state, { warehouseBinsDetail: action.payload.data, warehouseBinsDetailIsLoading: false });
	        case _type.FETCH_WAREHOUSE_BINS_FAILURE:
	            var warehouseBinsDetailError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { warehouseBinsDetailError: warehouseBinsDetailError, warehouseBinsDetailIsLoading: false });
	        case _type.REQUEST_DELETE_WAREHOUSE:
	            return _extends({}, state, { deleteWarehouse: true, deleteWarehouseSuccess: null, deleteWarehouseError: null });
	        case _type.DELETE_WAREHOUSE_SUCCESS:
	            return _extends({}, state, { deleteWarehouse: false, deleteWarehouseSuccess: true });
	        case _type.DELETE_WAREHOUSE_FAILURE:
	            var deleteWarehouseError = action.payload.data || { message: action.payload.messge };
	            return _extends({}, state, { deleteWarehouse: false, deleteWarehouseError: deleteWarehouseError });
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/warehouses_reducer.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/warehouses_reducer.js');
	}();

	;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	  all: [],
	  isLoading: false,
	  error: null,
	  productInventory: [],
	  productIsLoading: false,
	  productError: null
	};
	
	var _default = function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    // Favorites action handlers
	    case _type.REQUEST_INVENTORY_BATCHES:
	      return _extends({}, state, { error: null, isLoading: true });
	    case _type.FETCH_INVENTORY_BATCHES_SUCCESS:
	      return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	    case _type.FETCH_INVENTORY_BATCHES_FAILURE:
	      var error = action.payload || { message: action.payload.message };
	      return _extends({}, state, { all: [], error: error, isLoading: false });
	    case _type.REQUEST_PRODUCT_INVENTORY_BATCHES:
	      return _extends({}, state, { productError: null, productIsLoading: true });
	    case _type.FETCH_PRODUCT_INVENTORY_BATCHES_SUCCESS:
	      return _extends({}, state, { productInventory: action.payload.data, productError: null, productIsLoading: false });
	    case _type.FETCH_PRODUCT_INVENTORY_BATCHES_FAILURE:
	      var productError = action.payload || { message: action.payload.message };
	      return _extends({}, state, { productInventory: [], productError: productError, productIsLoading: false });
	    default:
	      return state;
	  }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/wholesaleModal_reducer.jsx');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/wholesaleModal_reducer.jsx');
	}();

	;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    all: [],
	    currentWholesale: null,
	    currentWholesaleDetail: null,
	    isLoading: true,
	    error: null,
	    detailIsLoading: false,
	    detailError: null,
	    wholesaleIsCreating: false,
	    wholesaleCreateError: null,
	    wholesaleCreated: false,
	    wholesaleIsEditing: false,
	    wholesaleEditError: null,
	    wholesaleEdited: false
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        // Product action handlers
	        case _type.REQUEST_WHOLESALE:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.FETCH_WHOLESALE_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	        case _type.FETCH_WHOLESALE_FAILURE:
	            var error = action.payload || { message: action.payload.message };
	            return _extends({}, state, { all: [], error: error, isLoading: false });
	        case _type.SELECT_WHOLESALE:
	            return _extends({}, state, { currentWholesale: action.payload });
	        case _type.RESET_CURRENT_WHOLESALE:
	            return _extends({}, state, { currentWholesale: null, currentWholesaleDetail: null });
	        case _type.REQUEST_WHOLESALE_DETAIL:
	            return _extends({}, state, { detailError: null, detailIsLoading: true });
	        case _type.FETCH_WHOLESALE_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { currentWholesaleDetail: action.payload, detailError: null, detailIsLoading: false });
	        case _type.FETCH_WHOLESALE_DETAIL_FAILURE:
	            // return error and make loading = false
	            var detailError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { all: [], detailError: detailError, detailIsLoading: false });
	        case _type.REQUEST_CREATING_WHOLESALE:
	            return _extends({}, state, { wholesaleIsCreating: true, wholesaleCreateError: null, wholesaleCreated: false });
	        case _type.CREATE_WHOLESALE_SUCCESS:
	            return _extends({}, state, { wholesaleIsCreating: false, wholesaleCreateError: null, wholesaleCreated: true });
	        case _type.CREATE_WHOLESALE_FAILURE:
	            var wholesaleCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { wholesaleIsCreating: false, wholesaleCreateError: wholesaleCreateError, wholesaleCreated: false });
	        case _type.REQUEST_EDITING_WHOLESALE:
	            return _extends({}, state, { wholesaleIsEditing: true, wholesaleEditError: null, wholesaleEdited: false });
	        case _type.EDIT_WHOLESALE_SUCCESS:
	            return _extends({}, state, { wholesaleIsEditing: false, wholesaleEditError: null, wholesaleEdited: true });
	        case _type.EDIT_WHOLESALE_FAILURE:
	            var wholesaleEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { wholesaleIsEditing: false, wholesaleEditError: wholesaleEditError, wholesaleEdited: false });
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/wholesale_reducer.jsx');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/wholesale_reducer.jsx');
	}();

	;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _type = __webpack_require__(14);
	
	var INITIAL_STATE = {
	    all: [],
	    currentZone: null,
	    currentZoneDetail: null,
	    isLoading: false,
	    error: null,
	    detailIsLoading: false,
	    detailError: null,
	    isCreating: false,
	    createError: null,
	    created: false,
	    isEditing: false,
	    editError: null,
	    edited: false,
	    bins: [],
	    bins2: [],
	    bins3: [],
	    bin: null,
	    level: null,
	    currentBin: null,
	    currentBinDetail: null,
	    binDetailIsLoading: false,
	    binDetailError: null,
	    binIsCreating: false,
	    binCreateError: null,
	    createBinSuccess: false,
	    binIsEditing: false,
	    binEditError: null,
	    binEdited: false,
	    deleteZone: false,
	    deleteZoneSuccess: null,
	    deleteZoneFailureError: null,
	    deleteBin: false,
	    deleteBinSuccess: null,
	    deleteBinFailureError: null,
	    levels: [],
	    levels2: [],
	    levels3: [],
	    createBarcodeSuccess: null,
	    createBarcodeFailureError: null,
	    barcode: null,
	    zone: null,
	    updatedZone: null,
	    updatedBin: null,
	    updatedLevel: null,
	    currentLevel: null,
	    levelEditError: null,
	    levelEditied: null,
	    levelCreateError: null,
	    createLevelSuccess: false,
	    isAttaching: false,
	    attachDocumentError: null,
	    attachDocumentSuccess: null,
	    deleteLevel: null,
	    deleteLevelSuccess: null,
	    deleteLevelFailureError: null
	};
	
	var _default = function _default() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	
	        case _type.FETCH_WAREHOUSE_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { all: action.payload.data.Warehouse_Zone });
	
	        // Zone action handlers
	        case _type.REQUEST_ZONES:
	            return _extends({}, state, { error: null, isLoading: true });
	        case _type.FETCH_ZONES_SUCCESS:
	            return _extends({}, state, { all: action.payload.data, error: null, isLoading: false });
	        case _type.FETCH_ZONES_FAILURE:
	            var error = action.payload || { message: action.payload.message };
	            return _extends({}, state, { all: [], error: error, isLoading: false });
	        case _type.SELECT_ZONE:
	            return _extends({}, state, { currentZone: action.payload });
	        case _type.RESET_CURRENT_ZONE:
	            return _extends({}, state, { currentZone: null, currentZoneDetail: null });
	        case _type.REQUEST_ZONE_DETAIL:
	            return _extends({}, state, { detailError: null, detailIsLoading: true });
	        case _type.FETCH_ZONE_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { currentZoneDetail: action.payload.data, detailError: null, detailIsLoading: false, bins: action.payload.data.Warehouse_Bin });
	        case _type.FETCH_ZONE_DETAIL_FAILURE:
	            // return error and make loading = false
	            var detailError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { all: [], detailError: detailError, detailIsLoading: false });
	        case _type.REQUEST_CREATING_ZONE:
	            return _extends({}, state, { isCreating: true, createError: null, created: false });
	        case _type.CREATE_ZONE_SUCCESS:
	            return _extends({}, state, { zone: action.payload.data, isCreating: false, createError: null, created: true });
	        case _type.CREATE_ZONE_FAILURE:
	            var createError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { isCreating: false, createError: createError, created: false });
	        case _type.REQUEST_EDITING_ZONE:
	            return _extends({}, state, { isEditing: true, editError: null, edited: false });
	        case _type.EDIT_ZONE_SUCCESS:
	            return _extends({}, state, { updatedZone: action.payload.data, isEditing: false, editError: null, edited: true });
	        case _type.EDIT_ZONE_FAILURE:
	            var editError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { isEditing: false, editError: editError, edited: false });
	
	        // Bin action handlers
	        case _type.REQUEST_BINS:
	            return _extends({}, state, { binError: null, binIsLoading: true });
	        case _type.FETCH_BINS_SUCCESS:
	            return _extends({}, state, { bins: action.payload.data, binError: null, binIsLoading: false });
	        case _type.FETCH_BINS2_SUCCESS:
	            return _extends({}, state, { bins2: action.payload.data, binError: null, binIsLoading: false });
	        case _type.FETCH_BINS3_SUCCESS:
	            return _extends({}, state, { bins3: action.payload.data, binError: null, binIsLoading: false });
	        case _type.FETCH_BINS_FAILURE:
	            var binError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { bins: [], bins2: [], bins3: [], binError: binError, binIsLoading: false });
	        case _type.FETCH_LEVELS:
	            return _extends({}, state, { levelsError: null, fetchLevelsIsLoading: true });
	        case _type.FETCH_LEVELS_SUCCESS:
	            return _extends({}, state, { levels: action.payload.data, levelsError: false, fetchLevelsIsLoading: false });
	        case _type.FETCH_LEVELS2_SUCCESS:
	            return _extends({}, state, { levels2: action.payload.data, levelsError: false, fetchLevelsIsLoading: false });
	        case _type.FETCH_LEVELS3_SUCCESS:
	            return _extends({}, state, { levels3: action.payload.data, levelsError: false, fetchLevelsIsLoading: false });
	        case _type.FETCH_LEVELS_ERROR:
	            var levelsError = action.payload || { message: action.payload.message };
	            return _extends({}, state, { levels: [], levelsError: levelsError, fetchLevelsIsLoading: false });
	        case _type.RESET_BINS:
	            return _extends({}, state, { bins: [], bins2: [], bins3: [], binError: null, binIsLoading: false });
	        case _type.SELECT_BIN:
	            return _extends({}, state, { currentBin: action.payload });
	        case _type.RESET_CURRENT_BIN:
	            return _extends({}, state, { currentBin: null, currentBinDetail: null });
	        case _type.REQUEST_BIN_DETAIL:
	            return _extends({}, state, { binDetailError: null, binDetailIsLoading: true });
	        case _type.FETCH_BIN_DETAIL_SUCCESS:
	            // return list of posts and make loading = false
	            return _extends({}, state, { currentBinDetail: action.payload.data, binDetailError: null, binDetailIsLoading: false });
	        case _type.FETCH_BIN_DETAIL_FAILURE:
	            // return error and make loading = false
	            var binDetailError = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return _extends({}, state, { all: [], binDetailError: binDetailError, binDetailIsLoading: false });
	        case _type.REQUEST_CREATING_BIN:
	            return _extends({}, state, { isCreating: true, binCreateError: null, createBinSuccess: false });
	        case _type.CREATE_BIN_SUCCESS:
	            return _extends({}, state, { bin: action.payload.data, isCreating: false, binCreateError: null, createBinSuccess: true });
	        case _type.CREATE_BIN_FAILURE:
	            var binCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { isCreating: false, binCreateError: binCreateError, createBinSuccess: false });
	        case _type.REQUEST_EDITING_BIN:
	            return _extends({}, state, { isEditing: true, binEditError: null, binEdited: false });
	        case _type.EDIT_BIN_SUCCESS:
	            return _extends({}, state, { updatedBin: action.payload.data, isEditing: false, binEditError: null, binEdited: true });
	        case _type.EDIT_BIN_FAILURE:
	            var binEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { isEditing: false, binEditError: binEditError, binEdited: false });
	        case _type.REQUEST_DELETE_ZONE:
	            return _extends({}, state, { deleteZone: true, deleteZoneSuccess: null, deleteZoneFailureError: null });
	        case _type.DELETE_ZONE_SUCCESS:
	            return _extends({}, state, { deleteZone: false, deleteZoneSuccess: true });
	        case _type.DELETE_ZONE_FAILURE:
	            var deleteZoneFailureError = action.payload.data || { message: action.payload.messge };
	            return _extends({}, state, { deleteZone: false, deleteZoneFailureError: deleteZoneFailureError });
	        case _type.REQUEST_DELETE_BIN:
	            return _extends({}, state, { deleteBin: true, deleteBinSuccess: null, deleteBinFailureError: null });
	        case _type.DELETE_BIN_SUCCESS:
	            return _extends({}, state, { deleteBin: false, deleteBinSuccess: true });
	        case _type.DELETE_BIN_FAILURE:
	            var deleteBinFailureError = action.payload.data || { message: action.payload.messge };
	            return _extends({}, state, { deleteBin: false, deleteBinFailureError: deleteBinFailureError });
	        case _type.CREATE_BARCODE:
	            return _extends({}, state, { isCreating: true, createError: null, created: false });
	        case _type.CREATE_BARCODE_SUCCESS:
	            return _extends({}, state, { isCreating: false, createError: null, created: true });
	        case _type.CREATE_BARCODE_FAILURE:
	            var createBarcodeFailure = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { isCreating: false, createError: createBarcodeFailure, created: false });
	        case _type.SELECT_LEVEL:
	            return _extends({}, state, { currentLevel: action.payload });
	        case _type.REQUEST_EDITING_LEVEL:
	            return _extends({}, state, { isEditing: true, levelEditError: null, levelEditied: false });
	        case _type.EDITING_LEVEL_SUCCESS:
	            return _extends({}, state, { updatedLevel: action.payload.data, isEditing: false, levelEditError: null, levelEditied: true });
	        case _type.EDITING_LEVEL_FAILURE:
	            var levelEditError = action.payload.data || { message: action.payload.message };
	            return _extends({}, state, { isEditing: false, levelEditError: levelEditError, levelEditied: false });
	        case _type.CREATE_LEVEL_REQUEST:
	            return _extends({}, state, { isCreating: true, levelCreateError: null, createLevelSuccess: false });
	        case _type.CREATE_LEVEL_SUCCESS:
	            return _extends({}, state, { level: action.payload.data, isCreating: false, levelCreateError: null, createLevelSuccess: true });
	        case _type.CREATE_LEVEL_FAILURE:
	            var levelCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
	            return _extends({}, state, { isCreating: false, levelCreateError: levelCreateError, createLevelSuccess: false });
	        case _type.ATTACH_ZONE_BIN_LEVEL:
	            return _extends({}, state, { isAttaching: null, attachDocumentError: null, attachDocumentSuccess: null });
	        case _type.ATTACH_ZONE_BIN_LEVEL_SUCCESS:
	            return _extends({}, state, { isAttaching: true, attachDocumentError: null, attachDocumentSuccess: true });
	        case _type.ATTACH_ZONE_BIN_LEVEL_FAILURE:
	            var attachDocumentError = action.payload.data || { message: action.payload.data };
	            return _extends({}, state, { isAttaching: false, attachDocumentError: attachDocumentError, attachDocumentSuccess: false });
	        case _type.REQUEST_DELETE_LEVEL:
	            return _extends({}, state, { deleteLevel: true, deleteLevelSuccess: null, deleteLevelFailureError: null });
	        case _type.DELETE_LEVEL_SUCCESS:
	            return _extends({}, state, { deleteLevel: false, deleteLevelSuccess: true });
	        case _type.DELETE_LEVEL_FAILURE:
	            var deleteLevelFailureError = action.payload.data || { message: action.payload.data };
	            return _extends({}, state, { deleteLevel: false, deleteLevelSuccess: false, deleteLevelFailureError: deleteLevelFailureError });
	        default:
	            return state;
	    }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(INITIAL_STATE, 'INITIAL_STATE', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/zones_reducer.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', '/Users/yuanshuo/FrontEnd/front-web/Client/master/jsx/reducers/zones_reducer.js');
	}();

	;

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(100)();
	// imports
	
	
	// module
	exports.push([module.id, ".rw-btn,.rw-input{color:inherit;font:inherit;margin:0}button.rw-input{overflow:visible}button.rw-input,select.rw-input{text-transform:none}button.rw-input,html input[type=button].rw-input,input[type=reset].rw-input,input[type=submit].rw-input{-webkit-appearance:button;cursor:pointer}button[disabled].rw-input,html input[disabled].rw-input{cursor:not-allowed}button.rw-input::-moz-focus-inner,input.rw-input::-moz-focus-inner{border:0;padding:0}@font-face{font-family:RwWidgets;src:url(" + __webpack_require__(751) + ");src:url(" + __webpack_require__(750) + "?#iefix&v=4.1.0) format(\"embedded-opentype\"),url(" + __webpack_require__(804) + ") format(\"woff\"),url(" + __webpack_require__(753) + ") format(\"truetype\"),url(" + __webpack_require__(752) + "#fontawesomeregular) format(\"svg\");font-weight:400;font-style:normal}.rw-i{display:inline-block;font-family:RwWidgets;font-style:normal;font-weight:400;line-height:1em;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.rw-i-caret-down:before{content:\"\\E803\"}.rw-i-caret-up:before{content:\"\\E800\"}.rw-i-caret-left:before{content:\"\\E801\"}.rw-i-caret-right:before{content:\"\\E802\"}.rw-i-clock-o:before{content:\"\\E805\"}.rw-i-calendar:before{content:\"\\E804\"}.rw-i-search:before{content:\"\\E806\"}.rw-sr{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0}.rw-widget,.rw-widget *,.rw-widget:after,.rw-widget :after,.rw-widget:before,.rw-widget :before{box-sizing:border-box}.rw-widget{outline:0;background-clip:border-box}.rw-btn{color:#333;line-height:2.286em;display:inline-block;margin:0;text-align:center;vertical-align:middle;background:none;background-image:none;border:1px solid transparent;padding:0;white-space:nowrap}.rw-rtl{direction:rtl}.rw-input{color:#555;height:2.286em;padding:.429em .857em;background-color:#fff}.rw-input[disabled]{box-shadow:none;cursor:not-allowed;opacity:1;background-color:#eee;border-color:#ccc}.rw-input[readonly]{cursor:not-allowed}.rw-filter-input{position:relative;width:100%;padding-right:1.9em;border:1px solid #ccc;border-radius:4px;margin-bottom:2px}.rw-rtl .rw-filter-input{padding-left:1.9em;padding-right:0}.rw-filter-input>.rw-input{width:100%;border:none;outline:none}.rw-filter-input>span{margin-top:-2px}.rw-i.rw-loading{background:url(" + __webpack_require__(806) + ") no-repeat 50%;width:16px;height:100%}.rw-i.rw-loading:before{content:\"\"}.rw-loading-mask{border-radius:4px;position:relative}.rw-loading-mask:after{content:\"\";background:url(" + __webpack_require__(805) + ") no-repeat 50%;position:absolute;background-color:#fff;opacity:.7;top:0;left:0;height:100%;width:100%}.rw-now{font-weight:600}.rw-state-focus{background-color:#fff;border:1px solid #66afe9;color:#333}.rw-state-selected{background-color:#adadad;border:1px solid #adadad;color:#333}.rw-state-disabled{box-shadow:none;cursor:not-allowed;opacity:1}.rw-btn,.rw-dropdownlist{cursor:pointer}.rw-btn[disabled],.rw-state-disabled .rw-btn,.rw-state-readonly .rw-btn{box-shadow:none;pointer-events:none;cursor:not-allowed;filter:alpha(opacity=65);opacity:.65}.rw-selectlist,ul.rw-list{margin:0;padding-left:0;list-style:none;padding:5px 0;overflow:auto;outline:0;height:100%}.rw-selectlist>li,ul.rw-list>li{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.rw-selectlist>li.rw-list-optgroup,ul.rw-list>li.rw-list-optgroup{font-weight:700}.rw-selectlist>li.rw-list-empty,.rw-selectlist>li.rw-list-option,ul.rw-list>li.rw-list-empty,ul.rw-list>li.rw-list-option{padding-left:10px;padding-right:10px}.rw-selectlist>li.rw-list-option,ul.rw-list>li.rw-list-option{cursor:pointer;border:1px solid transparent;border-radius:3px}.rw-selectlist>li.rw-list-option:hover,ul.rw-list>li.rw-list-option:hover{background-color:#e6e6e6;border-color:#adadad}.rw-selectlist>li.rw-list-option.rw-state-focus,ul.rw-list>li.rw-list-option.rw-state-focus{background-color:#fff;border:1px solid #66afe9;color:#333}.rw-selectlist>li.rw-list-option.rw-state-selected,ul.rw-list>li.rw-list-option.rw-state-selected{background-color:#adadad;border:1px solid #adadad;color:#333}.rw-selectlist>li.rw-list-option.rw-state-disabled,.rw-selectlist>li.rw-list-option.rw-state-readonly,ul.rw-list>li.rw-list-option.rw-state-disabled,ul.rw-list>li.rw-list-option.rw-state-readonly{color:#777;cursor:not-allowed}.rw-selectlist>li.rw-list-option.rw-state-disabled:hover,.rw-selectlist>li.rw-list-option.rw-state-readonly:hover,ul.rw-list>li.rw-list-option.rw-state-disabled:hover,ul.rw-list>li.rw-list-option.rw-state-readonly:hover{background:none;border-color:transparent}.rw-selectlist.rw-list-grouped>li.rw-list-optgroup,ul.rw-list.rw-list-grouped>li.rw-list-optgroup{padding-left:10px}.rw-selectlist.rw-list-grouped>li.rw-list-option,ul.rw-list.rw-list-grouped>li.rw-list-option{padding-left:20px}.rw-widget{position:relative}.rw-open.rw-widget,.rw-open>.rw-multiselect-wrapper{border-bottom-right-radius:0;border-bottom-left-radius:0}.rw-open-up.rw-widget,.rw-open-up>.rw-multiselect-wrapper{border-top-right-radius:0;border-top-left-radius:0}.rw-combobox .rw-list,.rw-datetimepicker .rw-list,.rw-dropdownlist .rw-list,.rw-multiselect .rw-list,.rw-numberpicker .rw-list{max-height:200px;height:auto}.rw-widget{background-color:#fff;border:1px solid #ccc;border-radius:4px}.rw-widget .rw-input{border-bottom-left-radius:4px;border-top-left-radius:4px}.rw-rtl .rw-widget .rw-input{border-bottom-left-radius:0;border-top-left-radius:0;border-bottom-right-radius:4px;border-top-right-radius:4px}.rw-widget>.rw-select{border-left:1px solid #ccc}.rw-widget.rw-rtl>.rw-select{border-right:1px solid #ccc;border-left:none}.rw-widget.rw-state-focus,.rw-widget.rw-state-focus:hover{box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);border-color:#66afe9;outline:0}.rw-widget.rw-state-readonly,.rw-widget.rw-state-readonly>.rw-multiselect-wrapper{cursor:not-allowed}.rw-widget.rw-state-disabled,.rw-widget.rw-state-disabled:active,.rw-widget.rw-state-disabled:hover{box-shadow:none;background-color:#eee;border-color:#ccc}.rw-combobox,.rw-datetimepicker,.rw-dropdownlist,.rw-numberpicker{padding-right:1.9em}.rw-combobox.rw-rtl,.rw-datetimepicker.rw-rtl,.rw-dropdownlist.rw-rtl,.rw-numberpicker.rw-rtl{padding-right:0;padding-left:1.9em}.rw-combobox>.rw-input,.rw-datetimepicker>.rw-input,.rw-dropdownlist>.rw-input,.rw-numberpicker>.rw-input{width:100%;border:none;outline:0}.rw-combobox>.rw-input::-moz-placeholder,.rw-datetimepicker>.rw-input::-moz-placeholder,.rw-dropdownlist>.rw-input::-moz-placeholder,.rw-numberpicker>.rw-input::-moz-placeholder{color:#999;opacity:1}.rw-combobox>.rw-input:-ms-input-placeholder,.rw-datetimepicker>.rw-input:-ms-input-placeholder,.rw-dropdownlist>.rw-input:-ms-input-placeholder,.rw-numberpicker>.rw-input:-ms-input-placeholder{color:#999}.rw-combobox>.rw-input::-webkit-input-placeholder,.rw-datetimepicker>.rw-input::-webkit-input-placeholder,.rw-dropdownlist>.rw-input::-webkit-input-placeholder,.rw-numberpicker>.rw-input::-webkit-input-placeholder{color:#999}.rw-placeholder{color:#999}.rw-select{position:absolute;width:1.9em;height:100%;right:0;top:0}.rw-select.rw-btn,.rw-select>.rw-btn{height:100%;vertical-align:middle;outline:0}.rw-rtl .rw-select{left:0;right:auto}.rw-combobox input.rw-input,.rw-datetimepicker input.rw-input,.rw-multiselect,.rw-numberpicker input.rw-input{box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.rw-combobox:active,.rw-combobox:active.rw-state-focus,.rw-datetimepicker:active,.rw-datetimepicker:active.rw-state-focus,.rw-dropdownlist:active,.rw-dropdownlist:active.rw-state-focus,.rw-header>.rw-btn:active,.rw-header>.rw-btn:active.rw-state-focus,.rw-numberpicker .rw-btn.rw-state-active,.rw-numberpicker .rw-btn.rw-state-active.rw-state-focus{background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.rw-combobox:hover,.rw-datetimepicker:hover,.rw-dropdownlist:hover,.rw-numberpicker:hover{background-color:#e6e6e6;border-color:#adadad}.rw-dropdownlist.rw-state-disabled,.rw-dropdownlist.rw-state-readonly{cursor:not-allowed}.rw-dropdownlist>.rw-input{line-height:2.286em;background-color:transparent;padding-top:0;padding-bottom:0;padding-right:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.rw-dropdownlist.rw-rtl>.rw-input{padding:.429em .857em;padding-top:0;padding-bottom:0;padding-left:0}.rw-dropdownlist.rw-rtl>.rw-select,.rw-dropdownlist>.rw-select{border-width:0}.rw-numberpicker .rw-btn{display:block;height:1.143em;line-height:1.143em;width:100%;border-width:0}.rw-popup{position:absolute;box-shadow:0 5px 6px rgba(0,0,0,.2);border-top-right-radius:0;border-top-left-radius:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px;border:1px solid #ccc;background:#fff;padding:2px;overflow:auto;margin-bottom:10px;left:10px;right:10px}.rw-dropup>.rw-popup{margin-bottom:0;margin-top:10px;border-top-right-radius:3px;border-top-left-radius:3px;border-bottom-right-radius:0;border-bottom-left-radius:0;box-shadow:0 0 6px rgba(0,0,0,.2)}.rw-popup-container{position:absolute;top:100%;margin-top:1px;z-index:1005;left:-11px;right:-11px}.rw-widget.rw-state-focus .rw-popup-container{z-index:1015}.rw-popup-container.rw-dropup{top:auto;bottom:100%}.rw-popup-container.rw-calendar-popup{right:auto;width:18em}.rw-datetimepicker .rw-btn{width:1.8em}.rw-datetimepicker.rw-has-neither{padding-left:0;padding-right:0}.rw-datetimepicker.rw-has-neither .rw-input{border-radius:4px}.rw-datetimepicker.rw-has-both{padding-right:3.8em}.rw-datetimepicker.rw-has-both.rw-rtl{padding-right:0;padding-left:3.8em}.rw-datetimepicker.rw-has-both>.rw-select{width:3.8em;height:100%}.rw-calendar{background-color:#fff}.rw-calendar thead>tr{border-bottom:2px solid #ccc}.rw-calendar .rw-header{padding-bottom:5px}.rw-calendar .rw-header .rw-btn-left,.rw-calendar .rw-header .rw-btn-right{width:12.5%}.rw-calendar .rw-header .rw-btn-view{width:75%;background-color:#eee;border-radius:4px}.rw-calendar .rw-header .rw-btn-view[disabled]{box-shadow:none;cursor:not-allowed}.rw-calendar .rw-footer{border-top:1px solid #ccc}.rw-calendar .rw-footer .rw-btn{width:100%;white-space:normal}.rw-calendar .rw-footer .rw-btn:hover{background-color:#e6e6e6}.rw-calendar .rw-footer .rw-btn[disabled]{box-shadow:none;cursor:not-allowed}.rw-calendar-grid{outline:none;height:14.28571429em;table-layout:fixed;width:100%}.rw-calendar-grid th{text-align:right;padding:0 .4em 0 .1em}.rw-calendar-grid .rw-btn{width:100%;text-align:right}.rw-calendar-grid td .rw-btn{border-radius:4px;padding:0 .4em 0 .1em;outline:0}.rw-calendar-grid td .rw-btn:hover{background-color:#e6e6e6}.rw-calendar-grid td .rw-btn.rw-off-range{color:#b3b3b3}.rw-calendar-grid.rw-nav-view .rw-btn{padding:.25em 0 .3em;display:block;overflow:hidden;text-align:center;white-space:normal}.rw-selectlist{padding:2px}.rw-selectlist>ul{height:100%;overflow:auto}.rw-selectlist>ul>li.rw-list-option{position:relative;min-height:27px;cursor:auto;outline:none;padding-left:5px}.rw-selectlist>ul>li.rw-list-option>label>input{position:absolute;margin:4px 0 0 -20px}.rw-selectlist>ul>li.rw-list-option>label{padding-left:20px;line-height:1.423em;display:inline-block}.rw-selectlist.rw-rtl>ul>li.rw-list-option{padding-left:0;padding-right:5px}.rw-selectlist.rw-rtl>ul>li.rw-list-option>label>input{margin:4px -20px 0 0}.rw-selectlist.rw-rtl>ul>li.rw-list-option>label{padding-left:0;padding-right:20px}.rw-selectlist.rw-state-disabled>ul>li:hover,.rw-selectlist.rw-state-readonly>ul>li:hover{background:none;border-color:transparent}.rw-multiselect{background-color:#fff}.rw-multiselect:hover{border-color:#adadad}.rw-multiselect-wrapper{border-radius:4px;position:relative;cursor:text}.rw-multiselect-wrapper:after,.rw-multiselect-wrapper:before{content:\" \";display:table}.rw-multiselect-wrapper:after{clear:both}.rw-multiselect-wrapper i.rw-loading{position:absolute;right:3px}.rw-multiselect-wrapper>.rw-input{outline:0;border-width:0;line-height:normal;width:auto;max-width:100%}.rw-multiselect-wrapper>.rw-input::-moz-placeholder{color:#999;opacity:1}.rw-multiselect-wrapper>.rw-input:-ms-input-placeholder{color:#999}.rw-multiselect-wrapper>.rw-input::-webkit-input-placeholder{color:#999}.rw-state-disabled>.rw-multiselect-wrapper,.rw-state-readonly>.rw-multiselect-wrapper{cursor:not-allowed}.rw-rtl .rw-multiselect-wrapper>.rw-input{float:right}.rw-multiselect-create-tag{border-top:1px solid #ccc;padding-top:5px;margin-top:5px}.rw-multiselect-taglist{margin:0;padding-left:0;list-style:none;display:inline;padding-right:0}.rw-multiselect-taglist>li{padding-left:5px;padding-right:5px;display:inline-block;margin:1px;padding:.214em .15em .214em .4em;line-height:1.4em;text-align:center;white-space:nowrap;border-radius:3px;border:1px solid #ccc;background-color:#ccc;cursor:pointer}.rw-multiselect-taglist>li.rw-state-focus{background-color:#fff;border:1px solid #66afe9;color:#333}.rw-multiselect-taglist>li.rw-state-disabled,.rw-multiselect-taglist>li.rw-state-readonly,.rw-multiselect.rw-state-disabled .rw-multiselect-taglist>li,.rw-multiselect.rw-state-readonly .rw-multiselect-taglist>li{cursor:not-allowed;filter:alpha(opacity=65);opacity:.65}.rw-multiselect-taglist>li .rw-btn{outline:0;font-size:115%;line-height:normal}.rw-rtl .rw-multiselect-taglist>li{float:right}", ""]);
	
	// exports


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(100)();
	// imports
	
	
	// module
	exports.push([module.id, ".DayPicker{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:relative;padding:1rem 0;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.DayPicker,.DayPicker-Month{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.DayPicker-Month{display:table;border-collapse:collapse;border-spacing:0;margin:0 1rem}.DayPicker-NavBar{position:absolute;left:0;right:0;padding:0 .5rem;top:1rem}.DayPicker-NavButton{position:absolute;width:1.5rem;height:1.5rem;background-repeat:no-repeat;background-position:50%;background-size:contain;cursor:pointer}.DayPicker-NavButton--prev{left:1rem;background-image:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjI2cHgiIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDI2IDUwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy4zLjIgKDEyMDQzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5wcmV2PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc2tldGNoOnR5cGU9Ik1TUGFnZSI+CiAgICAgICAgPGcgaWQ9InByZXYiIHNrZXRjaDp0eXBlPSJNU0xheWVyR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzLjM5MzE5MywgMjUuMDAwMDAwKSBzY2FsZSgtMSwgMSkgdHJhbnNsYXRlKC0xMy4zOTMxOTMsIC0yNS4wMDAwMDApIHRyYW5zbGF0ZSgwLjg5MzE5MywgMC4wMDAwMDApIiBmaWxsPSIjNTY1QTVDIj4KICAgICAgICAgICAgPHBhdGggZD0iTTAsNDkuMTIzNzMzMSBMMCw0NS4zNjc0MzQ1IEwyMC4xMzE4NDU5LDI0LjcyMzA2MTIgTDAsNC4yMzEzODMxNCBMMCwwLjQ3NTA4NDQ1OSBMMjUsMjQuNzIzMDYxMiBMMCw0OS4xMjM3MzMxIEwwLDQ5LjEyMzczMzEgWiIgaWQ9InJpZ2h0IiBza2V0Y2g6dHlwZT0iTVNTaGFwZUdyb3VwIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K\")}.DayPicker-NavButton--next{right:1rem;background-image:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjI2cHgiIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDI2IDUwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy4zLjIgKDEyMDQzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5uZXh0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc2tldGNoOnR5cGU9Ik1TUGFnZSI+CiAgICAgICAgPGcgaWQ9Im5leHQiIHNrZXRjaDp0eXBlPSJNU0xheWVyR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuOTUxNDUxLCAwLjAwMDAwMCkiIGZpbGw9IiM1NjVBNUMiPgogICAgICAgICAgICA8cGF0aCBkPSJNMCw0OS4xMjM3MzMxIEwwLDQ1LjM2NzQzNDUgTDIwLjEzMTg0NTksMjQuNzIzMDYxMiBMMCw0LjIzMTM4MzE0IEwwLDAuNDc1MDg0NDU5IEwyNSwyNC43MjMwNjEyIEwwLDQ5LjEyMzczMzEgTDAsNDkuMTIzNzMzMSBaIiBpZD0icmlnaHQiIHNrZXRjaDp0eXBlPSJNU1NoYXBlR3JvdXAiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=\")}.DayPicker-Caption{display:table-caption;height:1.5rem;text-align:center}.DayPicker-Weekdays{display:table-header-group}.DayPicker-WeekdaysRow{display:table-row}.DayPicker-Weekday{display:table-cell;padding:.5rem;font-size:.875em;text-align:center;color:#8b9898}.DayPicker-Body{display:table-row-group}.DayPicker-Week{display:table-row}.DayPicker-Day{border:1px solid #eaecec;text-align:center}.DayPicker-Day,.DayPicker-WeekNumber{display:table-cell;padding:.5rem;cursor:pointer;vertical-align:middle}.DayPicker-WeekNumber{text-align:right;min-width:1rem;font-size:.75em;color:#8b9898}.DayPicker--interactionDisabled .DayPicker-Day{cursor:default}.DayPicker-Footer{display:table-caption;caption-side:bottom;padding-top:.5rem}.DayPicker-TodayButton{border:none;background-image:none;background-color:transparent;box-shadow:none;cursor:pointer;color:#4a90e2;font-size:.875em}.DayPicker-Day--today{color:#d0021b;font-weight:500}.DayPicker-Day--disabled{background-color:#eff1f1}.DayPicker-Day--disabled,.DayPicker-Day--outside{color:#dce0e0;cursor:default}.DayPicker-Day--sunday{background-color:#f7f8f8}.DayPicker-Day--sunday:not(.DayPicker-Day--today){color:#dce0e0}.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside){color:#fff;background-color:#4a90e2}.DayPickerInput{display:inline-block}.DayPickerInput-OverlayWrapper{position:relative}.DayPickerInput-Overlay{left:0;position:absolute;background:#fff;box-shadow:0 2px 5px rgba(0,0,0,.15)}", ""]);
	
	// exports


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(100)();
	// imports
	
	
	// module
	exports.push([module.id, ".rangeslider{margin:20px 0;position:relative;background:#e6e6e6;-ms-touch-action:none;touch-action:none}.rangeslider,.rangeslider .rangeslider__fill{display:block;box-shadow:inset 0 1px 3px rgba(0,0,0,.4)}.rangeslider .rangeslider__handle{background:#fff;border:1px solid #ccc;cursor:pointer;display:inline-block;position:absolute;box-shadow:0 1px 3px rgba(0,0,0,.4),0 -1px 3px rgba(0,0,0,.4)}.rangeslider .rangeslider__handle .rangeslider__active{opacity:1}.rangeslider .rangeslider__handle-tooltip{width:40px;height:40px;text-align:center;position:absolute;background-color:rgba(0,0,0,.8);font-weight:400;font-size:14px;transition:all .1s ease-in;border-radius:4px;display:inline-block;color:#fff;left:50%;transform:translate3d(-50%,0,0)}.rangeslider .rangeslider__handle-tooltip span{margin-top:12px;display:inline-block;line-height:100%}.rangeslider .rangeslider__handle-tooltip:after{content:\" \";position:absolute;width:0;height:0}.rangeslider-horizontal{height:12px;border-radius:10px}.rangeslider-horizontal .rangeslider__fill{height:100%;background-color:#7cb342;border-radius:10px;top:0}.rangeslider-horizontal .rangeslider__handle{width:30px;height:30px;border-radius:30px;top:50%;transform:translate3d(-50%,-50%,0)}.rangeslider-horizontal .rangeslider__handle:after{content:\" \";position:absolute;width:16px;height:16px;top:6px;left:6px;border-radius:50%;background-color:#dadada;box-shadow:inset 0 1px 3px rgba(0,0,0,.4),inset 0 -1px 3px rgba(0,0,0,.4)}.rangeslider-horizontal .rangeslider__handle-tooltip{top:-55px}.rangeslider-horizontal .rangeslider__handle-tooltip:after{border-left:8px solid transparent;border-right:8px solid transparent;border-top:8px solid rgba(0,0,0,.8);left:50%;bottom:-8px;transform:translate3d(-50%,0,0)}.rangeslider-vertical{margin:20px auto;height:150px;max-width:10px;background-color:transparent}.rangeslider-vertical .rangeslider__fill,.rangeslider-vertical .rangeslider__handle{position:absolute}.rangeslider-vertical .rangeslider__fill{width:100%;background-color:#7cb342;box-shadow:none;bottom:0}.rangeslider-vertical .rangeslider__handle{width:30px;height:10px;left:-10px;box-shadow:none}.rangeslider-vertical .rangeslider__handle-tooltip{left:-100%;top:50%;transform:translate3d(-50%,-50%,0)}.rangeslider-vertical .rangeslider__handle-tooltip:after{border-top:8px solid transparent;border-bottom:8px solid transparent;border-left:8px solid rgba(0,0,0,.8);left:100%;top:12px}.rangeslider-reverse.rangeslider-horizontal .rangeslider__fill{right:0}.rangeslider-reverse.rangeslider-vertical .rangeslider__fill{top:0;bottom:inherit}.rangeslider__labels{position:relative}.rangeslider-vertical .rangeslider__labels{position:relative;list-style-type:none;margin:0 0 0 24px;padding:0;text-align:left;width:250px;height:100%;left:10px}.rangeslider-vertical .rangeslider__labels .rangeslider__label-item{position:absolute;transform:translate3d(0,-50%,0)}.rangeslider-vertical .rangeslider__labels .rangeslider__label-item:before{content:\"\";width:10px;height:2px;background:#000;position:absolute;left:-14px;top:50%;transform:translateY(-50%);z-index:-1}.rangeslider__labels .rangeslider__label-item{position:absolute;font-size:14px;cursor:pointer;display:inline-block;top:10px;transform:translate3d(-50%,0,0)}", ""]);
	
	// exports


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(100)();
	// imports
	
	
	// module
	exports.push([module.id, ".Select{position:relative}.Select,.Select div,.Select input,.Select span{box-sizing:border-box}.Select.is-disabled>.Select-control{background-color:#f9f9f9}.Select.is-disabled>.Select-control:hover{box-shadow:none}.Select.is-disabled .Select-arrow-zone{cursor:default;pointer-events:none;opacity:.35}.Select-control{background-color:#fff;border-color:#d9d9d9 #ccc #b3b3b3;border-radius:4px;border:1px solid #ccc;color:#333;cursor:default;display:table;border-spacing:0;border-collapse:separate;height:36px;outline:none;overflow:hidden;position:relative;width:100%}.Select-control:hover{box-shadow:0 1px 0 rgba(0,0,0,.06)}.Select-control .Select-input:focus{outline:none}.is-searchable.is-open>.Select-control{cursor:text}.is-open>.Select-control{border-bottom-right-radius:0;border-bottom-left-radius:0;background:#fff;border-color:#b3b3b3 #ccc #d9d9d9}.is-open>.Select-control>.Select-arrow{border-color:transparent transparent #999;border-width:0 5px 5px}.is-searchable.is-focused:not(.is-open)>.Select-control{cursor:text}.is-focused:not(.is-open)>.Select-control{border-color:#007eff;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 0 3px rgba(0,126,255,.1)}.Select--single>.Select-control .Select-value,.Select-placeholder{bottom:0;color:#aaa;left:0;line-height:34px;padding-left:10px;padding-right:10px;position:absolute;right:0;top:0;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value .Select-value-label,.has-value.Select--single>.Select-control .Select-value .Select-value-label{color:#333}.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label,.has-value.Select--single>.Select-control .Select-value a.Select-value-label{cursor:pointer;text-decoration:none}.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:hover,.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,.has-value.Select--single>.Select-control .Select-value a.Select-value-label:hover{color:#007eff;outline:none;text-decoration:underline}.Select-input{height:34px;padding-left:10px;padding-right:10px;vertical-align:middle}.Select-input>input{width:100%;background:none transparent;border:0 none;box-shadow:none;cursor:default;display:inline-block;font-family:inherit;font-size:inherit;margin:0;outline:none;line-height:14px;padding:8px 0 12px;-webkit-appearance:none}.is-focused .Select-input>input{cursor:text}.has-value.is-pseudo-focused .Select-input{opacity:0}.Select-control:not(.is-searchable)>.Select-input{outline:none}.Select-loading-zone{cursor:pointer;display:table-cell;text-align:center}.Select-loading,.Select-loading-zone{position:relative;vertical-align:middle;width:16px}.Select-loading{-webkit-animation:Select-animation-spin .4s infinite linear;animation:Select-animation-spin .4s infinite linear;height:16px;box-sizing:border-box;border-radius:50%;border:2px solid #ccc;border-right-color:#333;display:inline-block}.Select-clear-zone{-webkit-animation:Select-animation-fadeIn .2s;animation:Select-animation-fadeIn .2s;color:#999;cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:17px}.Select-clear-zone:hover{color:#d0021b}.Select-clear{display:inline-block;font-size:18px;line-height:1}.Select--multi .Select-clear-zone{width:17px}.Select-arrow-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:25px;padding-right:5px}.Select-arrow{border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 2.5px;display:inline-block;height:0;width:0}.is-open .Select-arrow,.Select-arrow-zone:hover>.Select-arrow{border-top-color:#666}.Select--multi .Select-multi-value-wrapper{display:inline-block}.Select .Select-aria-only{display:inline-block;height:1px;width:1px;margin:-1px;clip:rect(0,0,0,0);overflow:hidden}@-webkit-keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}@keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}.Select-menu-outer{border-bottom-right-radius:4px;border-bottom-left-radius:4px;background-color:#fff;border:1px solid #ccc;border-top-color:#e6e6e6;box-shadow:0 1px 0 rgba(0,0,0,.06);box-sizing:border-box;margin-top:-1px;max-height:200px;position:absolute;top:100%;width:100%;z-index:1;-webkit-overflow-scrolling:touch}.Select-menu{max-height:198px;overflow-y:auto}.Select-option{box-sizing:border-box;background-color:#fff;color:#666;cursor:pointer;display:block;padding:8px 10px}.Select-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.Select-option.is-selected{background-color:#f5faff;background-color:rgba(0,126,255,.04);color:#333}.Select-option.is-focused{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);color:#333}.Select-option.is-disabled{color:#ccc;cursor:default}.Select-noresults{box-sizing:border-box;color:#999;cursor:default;display:block;padding:8px 10px}.Select--multi .Select-input{vertical-align:middle;margin-left:10px;padding:0}.Select--multi.has-value .Select-input{margin-left:5px}.Select--multi .Select-value{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);border-radius:2px;border:1px solid #c2e0ff;border:1px solid rgba(0,126,255,.24);color:#007eff;display:inline-block;font-size:.9em;line-height:1.4;margin-left:5px;margin-top:5px;vertical-align:top}.Select--multi .Select-value-icon,.Select--multi .Select-value-label{display:inline-block;vertical-align:middle}.Select--multi .Select-value-label{border-bottom-right-radius:2px;border-top-right-radius:2px;cursor:default;padding:2px 5px}.Select--multi a.Select-value-label{color:#007eff;cursor:pointer;text-decoration:none}.Select--multi a.Select-value-label:hover{text-decoration:underline}.Select--multi .Select-value-icon{cursor:pointer;border-bottom-left-radius:2px;border-top-left-radius:2px;border-right:1px solid #c2e0ff;border-right:1px solid rgba(0,126,255,.24);padding:1px 5px 3px}.Select--multi .Select-value-icon:focus,.Select--multi .Select-value-icon:hover{background-color:#d8eafd;background-color:rgba(0,113,230,.08);color:#0071e6}.Select--multi .Select-value-icon:active{background-color:#c2e0ff;background-color:rgba(0,126,255,.24)}.Select--multi.is-disabled .Select-value{background-color:#fcfcfc;border:1px solid #e3e3e3;color:#333}.Select--multi.is-disabled .Select-value-icon{cursor:not-allowed;border-right:1px solid #e3e3e3}.Select--multi.is-disabled .Select-value-icon:active,.Select--multi.is-disabled .Select-value-icon:focus,.Select--multi.is-disabled .Select-value-icon:hover{background-color:#fcfcfc}@keyframes Select-animation-spin{to{transform:rotate(1turn)}}@-webkit-keyframes Select-animation-spin{to{-webkit-transform:rotate(1turn)}}", ""]);
	
	// exports


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "rw-widgets.eot";

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "rw-widgets.eot";

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "rw-widgets.svg";

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "rw-widgets.ttf";

/***/ }),
/* 754 */
/***/ (function(module, exports) {

	module.exports = {
		"(all_markup_percentsign_will_base_on_this_price)": "（所有加成 % 将会基于此价格）",
		"(mm_unit)": "(规格单位)",
		"(inches)": "(英寸)",
		"(no_sale_will_be_allowed_lower_than_this_price)": "（销售不得低于此价格）",
		"(num)": "(数量)",
		"(pkg_type)": "(包装类型)",
		"(pkg_size)": "(包装尺寸)",
		"(pkg_size_1)": "(包装尺寸 1)",
		"(pkg_size_2)": "(包装尺寸 2)",
		"(ref_no)": "(参考编号)",
		")__action_denied_": "）。动作已取消。",
		"00_dashsign_07_days": "00 - 07 天",
		"08_dashsign_30_days": "08 - 30 天",
		"00_dashsign_30_days": "00 - 30 天",
		"31_dashsign_60_days": "31 - 60 天",
		"4_wks_sale": "4周销售",
		"61_dashsign_90_days": "61 - 90 天",
		"91_plussign_days": "91+ 天",
		"account": "账号",
		"account_payable": "应付帐款",
		"account_payable_payment_report": "应付帐款（付款报表）",
		"account_payment_term": "帐户付款方式",
		"account_receivable": "应收帐款",
		"account_receivable_receive_report": "应收帐款（收款报表）",
		"action": "行动",
		"action_log": "修改记录",
		"active": "启用",
		"active_customer": "启用客户",
		"active_schedule": "",
		"active_vendor": "可用供货商",
		"add": "新增",
		"add_a_new_category": "新增类别",
		"add_a_new_group": "新增组别",
		"add_a_new_payment_term": "新增付款条款",
		"add_agent": "新增代理",
		"add_another_product": "新增商品",
		"add_customer": "新增客户",
		"add_invoice": "新增发票",
		"add_new_bin": "新增储位",
		"add_new_favorite": "新增收藏",
		"add_new_route": "新增线路",
		"add_new_zone": "新增区域",
		"add_non_product": "新增非商品",
		"add_payment_term": "新增付款条款",
		"add_pickup": "",
		"add_purchase_order": "新增采购单",
		"add_shipping_address": "",
		"add_vendor": "新增供货商",
		"address": "地址",
		"adjust": "调整",
		"adjust_some_or_all_of_the_selected_inventory": "调整部分或全部选定库存",
		"adjustment": "调整",
		"adjustment_date": "调整日期",
		"adjustment_quantity": "调整量",
		"admin_tools": "管理工具",
		"advanced_search": "进阶搜索",
		"afg_choice": "AFG Choice",
		"agent_information": "代理信息",
		"agent_name": "代理名称",
		"agent_num": "代理商编号",
		"agents": "代理商",
		"all": "所有",
		"all_bins": "所有储位",
		"all_products": "所有商品",
		"alt_phone": "替代号码",
		"amount": "量",
		"approve": "批准",
		"ap_aged_report": "应付帐龄分析表",
		"ap_aged_report_detail": "应付帐龄分析表细节",
		"ap_num": "AP 编号",
		"ap_records_existed_for_this_warehouse_receive_(apnum:_": "此收货单已有应付纪录（AP 编号：",
		"ap_statistics": "应付帐款数据",
		"ar_aged_report": "应收帐龄分析表",
		"ar_aged_report_detail": "应收帐龄分析表细节",
		"ar_customer_payment": "应收客户款项",
		"ar_date": "AR 日期",
		"ar_num": "AR 编号",
		"ar_slashsign_ap": "帐款管理",
		"ar_statistics": "应收帐款数据",
		"arrival": "到达",
		"arrival_status": "到达状态",
		"attachment_upload": "上传附件",
		"auto_apply": "Auto Apply",
		"auto_fill": "自动填入",
		"auto_load": "自动加载",
		"auto_putaway": "自动入库",
		"available": "可用",
		"available_bins": "可用储位",
		"avg_cost": "平均库存价",
		"avg_in_stock_dollarsign": "平均库存价",
		"avg_markup_percentsign": "平均加成 %",
		"avg_sale_dollarsign": "平均销售价",
		"b2b_b2c": "B2B/B2C",
		"back": "返回",
		"balance": "馀额",
		"barcode": "条形码",
		"barcode_poundsign": "条形码 #",
		"basic_info": "基本信息",
		"batch_no": "批次号",
		"batch_no_po_no": "批次编号 (采购单编号)",
		"batch_num": "批次编号",
		"bill_date": "付款日期",
		"billing_address": "付款地址",
		"billing_contact": "付款联系人",
		"billing_details": "付款明细",
		"billing_information": "付款信息",
		"bin": "储位",
		"bin_amount": "储位数量",
		"bin_detail_view": "检视储位细节",
		"bin_name": "储位名称",
		"bin_range": "储位范围",
		"bins_available": "可用储位",
		"button": "Button",
		"buy": "Buy",
		"buy_a_get_b": "Buy A Get B",
		"by_3_days": "3 天",
		"by_po": "按采购单",
		"by_product": "按商品",
		"by_quantity": "By Quantity",
		"by_quantity_discount": "按数量 (折扣)",
		"by_quantity_product": "按数量 (商品)",
		"by_total_price": "按总价 ",
		"by_unit": "按单位",
		"by_week": "按周",
		"by_weight": "按重量",
		"cancel": "取消",
		"cancel_return": "取消退还",
		"cancelled": "取消",
		"carry_type": "运输规格",
		"carrier": "承运人",
		"carrier_code": "承运人号码",
		"change_carrier_info": "承运人讯息",
		"bol_num": "BOL 号码",
		"pro_num": "PRO 号码",
		"ltl_carrier": "零擔貨運运营商",
		"please_clarify_other": "请输入其他方式",
		"carry_type_shipping_method": "运输规格和方式",
		"case (large prod)": "大货",
		"case": "箱",
		"cash_dollarsign": "现金$",
		"category": "类别",
		"category_1": "商品类别1",
		"category_2": "商品类别2",
		"category_2_product_list": "商品类别2 商品列表",
		"category_2_B2B_product_list": "商品类别2 B2B 商品列表",
		"category_2_b2c": "商品类别2 B2C",
		"category_2_b2b": "商品类别2 B2B",
		"category_analysis": "类编分析",
		"category_detail": "类别细节",
		"category_name": "类别名称",
		"category_hidden": "隐藏类别",
		"category_visible": "显示类别",
		"cc_hold_until": "卡片预扣费用至",
		"change_delivery_fee": "改变送货费用",
		"change_employee_note": "改变员工备注",
		"change_payment_method": "改变付款方式",
		"change_pull_sheet": "Pull Sheet Assign Amount",
		"change_ship_weight": "改变运输重量",
		"change_weight_button": "改变重量",
		"change_discount_rates": "改变打折量",
		"charged": "已扣款",
		"check": "支票",
		"check_dollarsign": "支票$",
		"check_num": "支票号码",
		"chinese": "中文",
		"chowbus": "Chowbus",
		"chowbus_import": "Chowbus 导入",
		"cif": "到库价",
		"city": "城市",
		"city_report": "城市报表",
		"clear": "清除",
		"clear_all_values": "清空数据",
		"close": "关闭",
		"COD": "COD",
		"code": "Code",
		"company": "公司",
		"complete": "完成",
		"complete_return": "完成退货",
		"complete_this_sheet": "完成此表",
		"completed": "完成",
		"confirm": "确认",
		"confirm_action": "确认操作",
		"confirm_add": "确认新增",
		"confirm_create": "确认新增",
		"confirm_delete": "确认删除",
		"confirm_group_change": "确认组别修改",
		"confirm_new_password": "确认新密码",
		"confirm_password": "确认密码",
		"confirm_print_tracking": "确认打印标签",
		"confirm_void": "确定作废",
		"confirmation": "确认",
		"contact": "联系人",
		"contact_information": "联系信息",
		"contact_person": "联系人",
		"content_management": "内容管理",
		"continue_product": "解锁商品",
		"convert": "转换",
		"convert_date": "转换日期",
		"convert_item_price": "转换商品价格",
		"convert_prod_qty": "转换数量",
		"convert_product_qty": "转换商品数量",
		"convert_quantity": "转换数量",
		"convert_target_quantity": "转换的目标数量",
		"convert_type": "转换类型",
		"convert_user": "转换用户",
		"convertable_product": "可转换商品",
		"cost": "成本",
		"costs_details": "成本细节",
		"county": "县",
		"create": "创建",
		"create_a_new_agent": "创建新代理",
		"create_a_new_category": "创建类别",
		"create_a_new_customer": "创建客户",
		"create_a_new_favorite": "创建收藏",
		"create_a_new_product": "创建商品",
		"create_a_new_purchase": "创建采购单",
		"create_a_new_purchase_order": "创建一个新的采购订单",
		"create_a_new_purchase_quote": "创建采购报价单",
		"create_a_new_purchase_return": "创建供货商",
		"create_a_new_purchase_schedule": "创建采购时间表",
		"create_a_new_purchase_template": "创建采购模板",
		"create_a_new_sales_order": "创建销售订单",
		"create_a_new_user": "新建用户",
		"create_a_new_vendor": "创建供货商",
		"create_a_purchase_quote": "创建采购报价",
		"create_a_purchase_schedule": "创建采购计划",
		"create_account": "",
		"create_and_duplicate": "创建和复制",
		"create_bin": "创建储位",
		"create_customer_return": "创建客户退货",
		"create_date": "创建日期",
		"create_inventory_adjustment_sheet": "创建库存调整列表",
		"create_inventory_convert_sheet": "创建库存转换列表",
		"create_inventory_relocation_sheet": "创建搬迁记录表",
		"create_inventory_repackage_sheet": "创建库存重新包装表",
		"create_new_po": "创建新的采购单",
		"create_new_purchase_order": "创建采购单",
		"create_new_sales_order": "创建新销售单",
		"create_payment": "创建付款",
		"create_product": "创建商品",
		"create_promotion": "创建促销",
		"create_purchase_order": "",
		"create_purchase_quote": "创建采购报价",
		"create_put_away": "",
		"create_receiving": "创建收货",
		"create_role": "创建角色",
		"create_sales_order": "创建一个新的销售单",
		"create_sales_return": "创建销售退货",
		"create_so": "新建销售单",
		"create_task": "创建任务",
		"create_time": "创建时间",
		"create_user": "创建用户",
		"create_warehouse": "创建仓库",
		"create_zone": "",
		"created": "创建",
		"created_by": "创建",
		"created_time": "创建时间",
		"credit": "积分",
		"credit_card": "信用卡",
		"Credit_card": "信用卡：",
		"credit_card_dollarsign": "信用卡$",
		"credit_limit": "信用额度",
		"credit_limit_payment_term_warning": "用户已超过信用或者结账周期限制， 请输入PASSCODE确认身份再继续",
		"credit_line": "信用额度",
		"credit_note": "客户信用记录",
		"credit_reason": "信用理由",
		"credit_status": "信用",
		"CRV": "CRV",
		"crv": "CRV",
		"currency_management": "货币管理",
		"current_bin": "当前储位",
		"current_inventory": "当前库存",
		"current_order_amount": "当前订单数量",
		"current_order_total": "目前的订单总额",
		"current_quantity": "当前数量",
		"current_target_inventory": "当前的目标库存",
		"current_zone": "当前区域",
		"cust_id": "客户ID",
		"cust_name": "客户名称",
		"cust_no": "客户No",
		"cust_po": "客户PO.",
		"customer": "顾客",
		"customer_group": "Customer Group",
		"customer_credit": "客户信用",
		"customer_credit_report": "客户信用报告",
		"customer_description": "客户详细",
		"customer_details": "顾客信息",
		"customer_id": "客户编号",
		"customer_information": "客户信息",
		"customer_management": "客户管理",
		"customer_name": "客户名称",
		"customer_name_colonsign": "客户名称",
		"customer_no": "客户编号",
		"customer_note": "客户备注",
		"customer_num": "客户编号",
		"customer_num_colonsign": "客户#：",
		"customer_order_schedule": "客户订货日程表",
		"customer_price_level": "客户价等级",
		"customer_return": "客户退货",
		"customer_rma": "客户 RMA",
		"customer_sales_history": "客户销售历史",
		"customer_statement": "客户报表",
		"customers": "客户",
		"customers2": "客户列表",
		"dashboard": "主页",
		"dashboard_v1": "主页 V1",
		"dashboard_v2": "主页 V2",
		"dashboard_v3": "主页 V3",
		"date": "日期",
		"date_filter": "过滤日期",
		"date_range": "日期范围",
		"dates": "日期",
		"days": "天数",
		"dead": "死货",
		"davis_po": "Davis PO",
		"decimal": "十进制",
		"default_address": "默认地址",
		"default_bin": "默认储位",
		"default_location": "默认位置",
		"default_location_colonsign": "默认位置:",
		"default_purchaser": "默认采购员",
		"default_sales": "默认销售员",
		"default_warehouse": "默认仓库",
		"default_warehouse_bin": "默认仓库储位",
		"default_warehouse_zone": "默认仓库区域",
		"default_zone": "默认区域",
		"default": "默认",
		"del": "删除",
		"delayed": "延误",
		"delete": "删除",
		"delete_file": "删除文件",
		"delete_product": "删除商品",
		"delete_purchase_order": "删除采购订单",
		"delete_purchase_template": "删除采购模板",
		"delete_successful": "删除成功",
		"delete_user": "删除用户",
		"deleted": "已删除",
		"deliver_date": "送货日期",
		"deliver_warehouse": "目的地仓库",
		"delivered": "交付",
		"delivery_warehouse": "送货仓库",
		"desc": "描述",
		"description": "描述",
		"detail": "详情",
		"detailed_excel": "详细导出",
		"detailed_information": "详细信息",
		"detailed_statement": "详细报表",
		"details": "细节",
		"details_&_convert": "",
		"details_&_repackage": "",
		"details_and_convert": "详细信息和转换",
		"details_and_repackage": "详细信息和重新包装",
		"dimension": "尺寸",
		"difference": "差异值",
		"disable": "停用",
		"disabled": "停用",
		"disc": "折扣",
		"discard_changes": "放弃更改",
		"discontinue": "停产",
		"discount": "折扣",
		"discount_description": "折扣描述",
		"dispatch": "调度计划",
		"dispatch_date": "发货日期",
		"dispatch_rma": "发送 RMA",
		"display": "显示类别",
		"distance": "距离",
		"document_date": "修改日期",
		"documented": "记录",
		"done": "完成",
		"draft": "草稿",
		"driver": "司机",
		"driver_license": "驾照号码",
		"dropship": "代购",
		"ds": "代购",
		"duplicate": "重复",
		"duplicate_product": "重复商品",
		"duplicate_product_promotion": "此商品已经被另一个促销使用。 是否继续添加？",
		"e_fax": "E传真",
		"edit": "编辑",
		"edit_agent": "编辑代理",
		"edit_bin": "编辑储位",
		"edit_category": "编辑类别",
		"edit_customer": "编辑客户",
		"edit_customer_confirm": "",
		"edit_customers": "编辑客户",
		"edit_display_category": "编辑显示类别",
		"edit_display_category_warning": "编辑前需要先创建产品",
		"edit_esl": "编辑电子标签",
		"edit_group": "编辑组别",
		"edit_groups": "编辑组别",
		"edit_invoice": "编辑发票",
		"edit_password": "编辑密码",
		"edit_payment": "编辑付款",
		"edit_payment_term": "编辑付款条款",
		"edit_product": "编辑商品",
		"edit_product_meta": "编辑商品元数据",
		"edit_purchase": "编辑采购单",
		"edit_purchase_order": "编辑采购订单",
		"edit_purchase_quote": "编辑采购报价单",
		"edit_purchase_return": "编辑采购退货",
		"edit_purchase_schedule": "编辑采购时间表",
		"edit_purchase_template": "编辑采购模板",
		"edit_put_away": "编辑放弃",
		"edit_released_si": "编辑销售发票",
		"edit_route": "编辑路线",
		"edit_routes": "编辑路线",
		"edit_sales_invoice": "编辑销售发票",
		"Edit_sales_order": "编辑销售订单",
		"edit_sales_order": "编辑销售订单",
		"edit_so": "编辑销售单",
		"edit_user": "编辑用户",
		"edit_username": "编辑用户名",
		"edit_vendor": "",
		"edit_warehouse": "编辑仓库",
		"edit_zone": "",
		"effect": "生效",
		"effect_date": "生效日期",
		"ein": "EIN",
		"email": "电子邮件",
		"email_address": "",
		"email_colonsign": "电子邮件：",
		"email_po": "电邮采购单",
		"email_so": "电邮订单",
		"employee_note": "员工备注",
		"enabled": "启用",
		"end": "结束",
		"end_date": "结束日期",
		"english": "英语",
		"eng_name": "英文名称",
		"chi_name": "中文名称",
		"enter_email_of_driver": "Enter the email of your driver",
		"error": "错误",
		"ESL": "电子标签",
		"esl_code": "电子标签号码",
		"esl_template": "电子标签模版",
		"est_date": "估计日期",
		"est_delivery": "预计送货",
		"is_no_reduce": "不扣库存",
		"est_receive_date": "预计接收日期",
		"est_sale_price": "预计销售价格",
		"et_sale_total": "预计总销售",
		"eta_date": "预计到货日期",
		"excel": "导出",
		"bank_account": "银行账户",
		"exit": "退出",
		"expire_date": "过期日期",
		"expired_date": "到期日",
		"expire_datetime": "过期日 (MM-DD-YYYY)",
		"expired_inventories": "过期库存",
		"expired_warning": "过期警告",
		"expiring": "即将到期",
		"export": "导出",
		"export_date": "到期日期",
		"export_inventories": "导出库存",
		"export_to_excel": "导出",
		"faq": "常见问题",
		"favorite_items": "建议商品",
		"favorite_list": "建议销售清单",
		"favorite_product_list": "收藏列表",
		"favorites_list": "收藏表",
		"fax": "传真",
		"fax_colonsign": "传真：",
		"field": "栏位",
		"file": "文件",
		"fill_with_latest_value": "最新的数据",
		"filter": "过滤",
		"final": "最终",
		"final_dollarsign": "最终价",
		"final_weight": "最终重量",
		"final_wt": "最终重量.",
		"finalize": "定案",
		"finalize_invoice": "定案发票",
		"finalize_si": "完成销售发票",
		"finalized": "敲定",
		"finish": "完成",
		"Finish_Shipping": "完成装运",
		"first_name": "名",
		"fob": "FOB",
		"fob_unit_price": "离岸价格",
		"free": "Free",
		"frequent_products": "常用货品",
		"Fri": "周五",
		"fri_route": "周五路线",
		"fri_stop": "周五停靠点",
		"from": "从",
		"from_bin": "",
		"full_list_table_sales_invoice": "销售发票列表",
		"full_list_table_sales_order": "完整列表 | 销售订单",
		"gv_rewards": "GV 奖励",
		"margin$": "余量 %",
		"nbt_rewards": "NBT 奖励",
		"general": "一般",
		"general_dashboard": "通用主页",
		"general_information": "基础信息",
		"general_management": "基础管理",
		"general_management2": "客户管理",
		"general_no": "通用编号",
		"generate_barcode": "生成条形码",
		"generate_all_barcode": "生成全部条形码",
		"generate_all_zone_barcode": "生成全部区域条形码",
		"index_no": "索引编号",
		"general_product_convert": "一般 | 商品转换",
		"general_product_repackage": "一般 | 商品重新包装",
		"general_report": "通用报表",
		"get": "Get",
		"gift_quantity": "商品赠送数量",
		"gift_quantity_column": "赠送数量",
		"good": "良好",
		"Good_Credit": "好信用",
		"grand_total": "累计",
		"group": "组别",
		"group_wholesale": "批发",
		"group_buy": "团购",
		"group_list": "类别列表",
		"group_name": "组别名",
		"groups": "组别",
		"groups_management": "组别管理",
		"handling": "手续费",
		"handling_cost": "手续费",
		"hmart_barcode": "HMart条形码",
		"hold": "保留",
		"id": "ID",
		"idx": "IDX",
		"image": "图片",
		"image_2": "图片 #2",
		"image_size_limit": "每个上传图片不能超过 7mb.",
		"import": "导入",
		"in_stock": "有现货",
		"in_stock_colonsign": "库存:",
		"in_stock_inactive": "有货/死货",
		"inactive": "非活动",
		"inbound": "入站",
		"inbound_area": "入库区",
		"inbound_plt": "入库板数",
		"insert_new_product_in_favorite_list": "输入建议销售清单",
		"instock": "现货",
		"internal_barcode": "内部条形码",
		"inv_cost": "库存成本",
		"inventories": "存货",
		"inventory": "库存",
		"inv": "库存",
		"inventory_adjust_sheet_warehouse_loc": "库存调整表 | 仓库位置",
		"inventory_adjust_warehouse_loc": "库存调整 | 仓库位置",
		"inventory_adjustment": "库存调整",
		"inventory_adjustment_sheet": "库存调整表",
		"inventory_adjustments": "库存调整",
		"inventory_convert": "库存转换",
		"inventory_convert_sheet": "库存转换表",
		"inventory_convert_sheet_warehouse_location": "库存转换工作表 | 仓库位置",
		"inventory_convert_warehouse_location": "库存转换 | 仓库位置",
		"inventory_converts": "转换库存",
		"inventory_detail": "库存明细",
		"inventory_details": "库存详细",
		"inventory_expired_passed_due": "存货过期 / 库存到期",
		"inventory_information": "库存信息",
		"inventory_number": "库存号码",
		"inventory_price": "库存总价",
		"inventory_receive": "库存接收",
		"inventory_receive_details": "库存接收详情",
		"inventory_receive_information": "库存接收信息",
		"inventory_receive_sheet": "库存接收表",
		"inventory_relocation": "库存搬迁",
		"inventory_relocation_sheet": "库存搬迁工作表",
		"inventory_relocation_sheet_warehouse_location": "库位迁移表 | 仓库位置",
		"inventory_relocation_warehouse_location": "库存迁移 | 仓库位置",
		"inventory_relocations": "库存搬迁",
		"inventory_repackage": "库存重新包装",
		"inventory_repackage_sheet": "库存重新包装表",
		"inventory_repackage_warehouse_loc": "库存重新包装 | 仓库位置",
		"inventory_scrap": "库存报废",
		"inventory_scrap_sheet": "库存报废表",
		"inventory_scrap_sheet_warehouse_location": "库存报废单 | 仓库位置",
		"inventory_scrap_warehouse_location": "库存报废 | 仓库位置",
		"inventory_transfer": "转移库存",
		"invoice": "发票",
		"invoice_amount": "发票金额",
		"invoice_date": "发票日期",
		"invoice_date_colonsign": "发票日期：",
		"invoice_final_dollarsign": "发票最终 $",
		"invoice_no": "发票编号",
		"invoice_no_colonsign": "发票编号：",
		"invoice_not_received": "未收货发票",
		"invoice_total": "发票总额",
		"invoice_type": "发票类型",
		"invoices_not_finalized": "未结算发票",
		"invoice_vendor": "供货商发票号码",
		"invoiced": "已发票",
		"invoiced_cost": "已发票 / 成本",
		"is_at_inbound_area": "在收货区",
		"is_at_outbound_area": "在出货区",
		"is_dropship": "Dropship",
		"is_enabled": "启用*",
		"is_public": "公开",
		"issue_credit": "问题信用",
		"issue_return": "",
		"item_count": "物品数量",
		"Item_is_out_of_stock": "缺货",
		"item_name": "项目名",
		"item_no": "编号",
		"lang": "语言",
		"large_label_mac": "大标签MAC",
		"large_label_win": "大标签WIN",
		"last_dollarsign": "最后价格",
		"last_modified_by": "最后修改",
		"last_month": "上个月",
		"last_name": "姓",
		"lb": "磅",
		"level": "层",
		"levels": "层",
		"level_1": "1级",
		"level_2": "2级",
		"level_3": "3级",
		"level_4": "4级",
		"level_5": "5级",
		"lg": "大",
		"limit": "显示数量",
		"limit_qty_order": "限制数量/订单",
		"limit_qty_order_desc": "(零代表无限制)",
		"link_existing_prod": "关联现有商品",
		"linked_so_no": "关联订单",
		"list_of_adjustment_lines": "库存调整行列",
		"list_of_inventory_convert_lines": "库存转换的列表",
		"list_of_inventory_relocation_lines": "库存搬迁行列表",
		"list_of_inventory_repackage_lines": "",
		"list_of_inventory_scrap_lines": "库存报废列表",
		"list_of_repackage_lines": "库存重新包装列表",
		"loaded_qty": "加载数量",
		"loaded_quantity": "",
		"location": "位置",
		"location_bin": "区域",
		"login": "登录",
		"login_in": "",
		"logo": "Logo",
		"logout": "登出",
		"low_stock": "低库存",
		"low_stock_inventories": "低库存",
		"low_stock_inventory": "低库存",
		"lowest_amount": "最低价格",
		"lowest_amt": "最低数量",
		"lowest_sale_dollarsign": "最低售价",
		"lv1": "一等价格",
		"lv2": "二等价格",
		"lv3": "三等价格",
		"lv4": "四等价格",
		"lv5": "五等价格",
		"mailing": "",
		"mailing_address": "",
		"mailing_contact": "",
		"mailing_contact_information": "邮寄联系",
		"mailing_details": "邮寄明细",
		"mailing_information": "邮件信息",
		"manage_active_users": "管理用户",
		"manage_customers": "管理客户",
		"manage_promotions": "管理促销",
		"march": "",
		"margin": "余量",
		"match": "相符",
		"max": "最大",
		"max_limit": "最大",
		"max_limit_colonsign": "最大值:",
		"max_stock_range": "最大库存范围",
		"measure": "规格单位",
		"measure_unit": "规格",
		"memo_no": "Memo 号码",
		"memo_poundsign": "备注 #",
		"merchant_report": "销售商报告",
		"merchant_summary": "销售商汇总",
		"meta_info": "元数据",
		"method": "方法",
		"middle_name": "中间名字",
		"min": "最小",
		"min_purchase_amount": "最低购买价值",
		"min_limit": "最小",
		"min_limit_colonsign": "最小值:",
		"min_stock_range": "最小库存范围",
		"misc": "杂项",
		"misc_cost": "杂费",
		"misc_cost_detail": "杂费内容",
		"misc_cost_details": "杂项明细",
		"misc_detail": "其他明细",
		"misc_dollarsign": "杂费",
		"misc_fee": "杂项费用",
		"mix_product": "混合产品",
		"mix_setting": "混合配置",
		"mm": "规格",
		"mm_type": "规格类型",
		"mm_unit": "规格单位",
		"mobile": "移动电话",
		"mobile_customer_statement": "手机客户报表",
		"mobile_dollarsign": "手机$",
		"mobile_description_box": "产品描述修改",
		"mobile_management": "手机管理",
		"mobile_sale": "手机销售",
		"mobile_sales_order": "手机销售订单",
		"mobile_username": "手机客户用户名",
		"mobile_users": "手机用户",
		"modified": "修改",
		"modified_by": "修改者",
		"modified_on": "修改日期",
		"modified_time": "修改时间",
		"modifier": "修改人员",
		"modify": "修改",
		"modify_inventory": "修改库存",
		"modify_username": "修改用户名",
		"Mon": "周一",
		"mon_route": "周一路线",
		"member_card": "会员卡",
		"mon_stop": "周一停靠点",
		"month": "月",
		"Monthly": "月",
		"more_info": "更多",
		"multilevel_marketing": "多层销售",
		"move_all": "移动全部",
		"move_selected": "移动选择",
		"move_off": "",
		"move_off_from_list": "从列表中移出",
		"move_off_from_products_list": "从商品列表移除",
		"move_off_products_list": "从商品列表移除",
		"move_to": "",
		"move_to_list": "移动到列表",
		"move_to_po": "移至采购单",
		"move_to_product_list": "移动到商品列表",
		"move_to_products_list": "移动到商品列表",
		"move_to_so": "移动到销售单",
		"move_to_so_list": "移动到销售订单列表",
		"msg_po_to_so_dropship": "确定 SO 到 PO (Davis)?",
		"msg_add_duplicate_item": "您加入了重复的物品",
		"msg_assign_customer": "分配此单给客户:",
		"msg_agree_terms": "我同意上述条款",
		"msg_ask_for_manager_login": "输入经理的用户名与密码",
		"msg_ask_if_stay_on_current_page": "是否要留在当前页面？",
		"msg_confirm_add_customer_to_group": "此动作将从旧群组移除此客户，确定继续？",
		"msg_confirm_change_group_without_save_products": "尚未储存商品信息，确定继续？",
		"msg_confirm_delete": "确定要删除？",
		"msg_confirm_print_tracking": "订单已有追踪号码. 是否继续打印标签?",
		"msg_confirm_refund_order": "你确定要退款吗？",
		"msg_confirm_reship": "确定补发此订单?",
		"msg_confirm_quote": "确定把报价单别为购买单?",
		"passcode_confirm": "密码确认",
		"your_passcode_is_not_correct": "密码不正确",
		"msg_convert_qty_cannot_exceed_current_qty": "转换数量不能大于当前数量",
		"msg_drag_drop_attachment": "尝试在此处删除一些文件，或单击以选择要上传的文件。",
		"msg_drop_upload_files": "拖放上传文件或点击选择文件",
		"msg_enter_scrap_amount_and_inventory_will_be_updated": "输入下方的报废数量，并更新库存",
		"msg_export_order_stats": "导出用户统计信息会需要1分钟，请不要离开页面",
		"msg_grand_total_equation": "＊ 累计 ＝ 总计 － 已取消",
		"msg_inventory_price_equation": "* 库存总价 = 平均库存价 × 库存",
		"msg_item_already_in_sales_order": "此项目已在销售订单",
		"msg_large_prod": "箱 (大货)",
		"msg_no_permission": "您没有当前操作的权限。",
		"msg_operation_saved": "您的操作已储存",
		"msg_please_select_a_vendor": "请选择一个供货商",
		"msg_product_image_modal_desc": "* 请在关闭弹窗前保存图片",
		"msg_products_loaded_click_save_to_complete": "所有商品已载入，点击储存已完成订单",
		"msg_purchase_order_num_is": "采购单编号为",
		"msg_purchase_order_saved": "您的采购单已储存",
		"msg_purchase_quote_generated": "您的采购报价单已生成",
		"msg_purchase_quote_saved": "您的采购报价单已储存",
		"msg_purchase_template_saved": "您的采购模板已储存",
		"msg_relocation_qty_cannot_exceed_current_qty": "搬迁数量不能大于当前数量",
		"msg_repackage_qty_cannot_exceed_current_qty": "重新包装数量不能大于当前数量",
		"msg_scrap_qty_cannot_exceed_current_qty": "报废数量不能大于当前数量",
		"msg_select_a_group": "选择一个组别",
		"msg_select_a_purchase_template": "选择采购模板",
		"msg_select_an_inventory_as_target": "选择一个目标库存",
		"msg_select_an_inventory_to_adjust": "选择一个库存来调整",
		"msg_select_an_inventory_to_convert": "选择一个库存来转换",
		"msg_select_an_inventory_to_relocate": "选择一个库存来搬迁",
		"msg_select_an_inventory_to_repackage": "选择一个库存来重新包装",
		"msg_select_an_item": "选择一个商品",
		"msg_select_customer": "选择客户",
		"msg_select_from_batch": "从批次选择",
		"msg_select_warehouse": "选择仓库",
		"msg_select_warehouse_bin": "选择仓库储位",
		"msg_select_warehouse_zone": "选择仓库区域",
		"msg_show_action_log_from_last_90_days": "显示过去 90 天的修改记录",
		"msg_small_prod": "个 (小货)",
		"msg_total_orders_equation": "＊ 总订单数 ＝ 订单数 － 已取消订单",
		"MSO": "MSO",
		"n1_prod_qty": "N1 商品数量",
		"n2_prod_qty": "N2 商品数量",
		"name": "名称",
		"nationwide": "全国销售",
		"need_to_signup": "",
		"negative": "负",
		"net": "实收金额",
		"net_cost": "库存成本",
		"net_receiving": "应收金额",
		"net_weight": "净重",
		"net_wt": "商品重量",
		"new_password": "新密码",
		"new_purchase_order": "新采购单",
		"new_purchase_quote": "新采购报价",
		"new_purchase_template": "新采购模板",
		"new_quantity": "新的数量",
		"new_receiving": "新收货",
		"new_sales_order": "新销售单",
		"new_sales_return": "新的销售退货",
		"new_scrap_record": "新纪录",
		"new_series_no": "新系列号",
		"new_so": "新销售订单",
		"new_username": "新用户名",
		"new_value": "新数值",
		"next_execute_date": "下个执行时间",
		"prev_page": "上一页",
		"next_page": "下一页",
		"No": "否",
		"no": "否",
		"no_bin_range": "无储位范围",
		"no_invoice": "",
		"no_pickup": "",
		"no_mix_product": "没有混合物品",
		"no_shipping_address": "",
		"no_shipping_information": "没有运输信息",
		"no_vendor": "没有供货商",
		"non_fixed": "不固定重量",
		"non_food": "非食物",
		"non_zero": "非零",
		"none": "没有",
		"not_shipped_quantity": "未发送数量",
		"not_yet_received": "未收货",
		"notation": "备注",
		"note": "备注",
		"notes_for_pos": "POS的注意事项",
		"notes_for_sales": "销售记录",
		"num": "编号",
		"number": "编号",
		"number_of_card_transactions": "卡片交易数量",
		"number_of_checks": "支票数量",
		"off_stock": "关闭现货",
		"offrate": "Offrate",
		"old_value": "旧数值",
		"on_hold": "搁置",
		"on_fleet": "Onfleet",
		"on_sale": "可售",
		"on_stock": "打开现货",
		"one_time": "单次",
		"one_time_schedule": "上次时间",
		"one_time_use": "单次使用",
		"oops": "",
		"open": "未发货",
		"open_draft": "",
		"open_sales_orders": "打开销售单",
		"optional": "Optional",
		"order": "订单",
		"order_amount": "订单数量",
		"order_count_overview": "下单数总览",
		"order_date": "订购日期",
		"order_history": "历史订单",
		"order_num": "订单编号",
		"order_qty": "订单数量",
		"order_stats": "订单统计",
		"order_status": "订单状态",
		"order_total": "订单总价",
		"order_total_dollarsign": "订单总价 $",
		"order_type": "订单类型",
		"order_unit": "订单单价",
		"order_unit_dollarsign": "订单单价 $",
		"ordered": "下单",
		"orders": "订单",
		"out_of_stock": "缺货",
		"out_of_stock_active": "无货/缺货",
		"outbound": "出库区",
		"outbound_area": "出库区",
		"outbound_plt": "出库板数",
		"outstanding": "未付金额",
		"outstanding_invoice": "未付发票",
		"outstanding_order": "未到订单",
		"over_stock": "高库存",
		"oversaleable": "可超卖",
		"owner": "所有者",
		"package": "包",
		"package_details": "包装详细",
		"package_dimension_shipping": "包装尺寸运输",
		"package_size": "包装尺寸",
		"packageSize": "包装尺寸",
		"package_slashsign_weight": "包装 / 重量",
		"package_type": "包装类型",
		"package_weight_shipping": "包装重量运输",
		"packaging": "包装",
		"packing": "包装中",
		"packing_num": "包装号码",
		"paid_dollarsign": "已付金额",
		"pallet": "栈板",
		"partial": "部分接收",
		"pass": "忽略",
		"passed_due": "过期",
		"password": "密码",
		"payment": "付款",
		"payment_amount": "支付金额",
		"payment_date": "付款日期",
		"payment_detail": "付款细节",
		"payment_details": "付款细节",
		"payment_info": "",
		"payment_method": "付款方法",
		"payment_status": "支付状态",
		"payment_summary": "支付统计",
		"payment_term": "付款条款",
		"payment_term_short": "付款条款",
		"payment_term_name": "付款条款名称",
		"payment_terms_management": "付款条款管理",
		"payment_type": "付款方式",
		"per_pallet": "栈板",
		"per_pound": "每磅",
		"percentsign_off": "％ 折扣",
		"permission_name": "权限名称",
		"phone": "电话",
		"pickup": "提货",
		"pickup_contact": "供货商联系人",
		"pickup_poundsign": "提货 #",
		"pickup_vendor_address": "供货商提货地址",
		"pickup_warehouse": "提货仓库",
		"pickup_warehouse_name": "供货商提货地址",
		"piece (small prod)": "小货",
		"piece": "个",
		"pkg_type": "包装类型",
		"place_new_order": "产生采购订单",
		"new_outbound_order": "创建出库单",
		"new_inbound_order": "创建入库单",
		"percentage_fee": "百分比费用",
		"flat_fee": "固定费用",
		"credit_amount": "钱包额度",
		"placed": "下单",
		"plain_statement": "简单声明",
		"please_enter_a_valid_email": "Please enter a valid email!",
		"please_select_an_end_date_that_is_after_the_start_date": "Please select an end date that is after the start date.",
		"please_select_a_start_date_that_is_before_the_end_date": "Please select a start date that is before the end date.",
		"please_select_a_contact": "请选择一个联系人",
		"please_select_a_customer": "请选择客户",
		"please_select_a_product": "请选择一个商品",
		"please_select_an_inventory": "请选择一个库存",
		"please_select_category": "请选择类别",
		"please_select_group": "请选择组别",
		"please_select_inventory": "请选择库存",
		"pmt_date": "支付日期",
		"pmt_status": "付款状态",
		"po_date": "采购单日期",
		"po_details": "采购单明细",
		"po_final_dollarsign": "采购单最终 $",
		"po_num": "采购单编号",
		"po_purchase_status": "采购单状态",
		"po_scheduled_arrival": "采购单预计到达",
		"po_scheduled_to_arrive": "采购单预计到达",
		"po_status": "采购单状态",
		"poor": "差",
		"pos": "收银机",
		"pos_management": "POS管理",
		"pos_credit": "POS 信用",
		"pos_order": "POS 单",
		"pos_order_credits": "POS 信用列表",
		"pos_order_full_table": "POS 全单列表",
		"pos_report": "收银机报告",
		"posting_date": "发布日期",
		"pr_no": "采购退货单编号",
		"presale": "预售",
		"presale_colonsign": "预售:",
		"president_dashboard": "总数据主页",
		"press_enter_for_emails": "按回车输入电子邮件",
		"press_enter_to_confirm_weights": "",
		"preview": "预览",
		"previous": "之前",
		"previous_orders": "以前的订单",
		"price": "价钱",
		"price_1": "价格1",
		"price_2": "价格2",
		"price_3": "价格3",
		"price_4": "价格4",
		"price_adjustment": "价格调整表",
		"price_adjustment_chart": "价格调整表",
		"price_level": "价格水平",
		"price_level_percent": "价格百分比",
		"sales_price_levels": "价格水平设置",
		"sales_type": "销售类型",
		"price_lvl": "价格等级",
		"price_range_warning": "输入PASSCODE确认身份再继续之前动作",
		"price_reference": "价格调整表",
		"price_reference_chart": "价格调整表",
		"print": "打印",
		"print_new_label": "打印新标签",
		"print_no": "打印编号",
		"print_barcode": "打印条形码",
		"print_general_information": "打印基本信息",
		"print_invoice": "打印发票",
		"print_label": "打印标签",
		"print_picking_list": "打印拣货单清单",
		"print_po": "打印采购单",
		"print_purchase_order": "打印采购订单",
		"print_purchase_payment": "打印购买付款",
		"print_reminder": "打印提示",
		"print_shipping": "打印运送",
		"print_shipping_sheet": "打印运输单",
		"print_si": "打印发票",
		"print_so": "打印销售单",
		"print_specifications": "打印规格",
		"print_statements": "打印报表",
		"printing_information": "打印信息",
		"process_purchase_return": "执行采购退货",
		"process_sales_return": "执行销售退货",
		"processing_fee": "手续费",
		"prod2_desc": "商品 2 描述",
		"prod2_name": "商品 2 名称",
		"prod2_num": "商品 2 编号",
		"prod2_qty": "商品 2 数量",
		"prod2_ref_num": "商品 2 参考编号",
		"prod_barcode": "商品条形码",
		"prod_cost": "商品成本",
		"prod_group": "商品组别",
		"prod_name": "商品",
		"prod_num": "商品编号",
		"prod_type": "商品类型",
		"product": "商品",
		"product_barcode": "商品条形码",
		"product_categories": "商品类别",
		"product_category_1": "商品类别 1",
		"product_category_2": "商品类别 2",
		"product_convert": "大小货调整表",
		"product_convert_page": "商品转换",
		"product_cost": "商品成本",
		"product_cost_and_price": "商品成本和价格",
		"product_description": "",
		"product_detail": "商品细节",
		"product_details": "商品详细",
		"product_does_not_exist": "商品不存在",
		"product_filter": "商品",
		"product_group": "商品组别",
		"product_group_and_category": "商品组别和类别",
		"product_groups": "商品组别",
		"product_information": "商品信息",
		"product_list": "商品列表",
		"product_location_detail": "商品详情储位",
		"product_management": "商品管理",
		"product_name": "商品名称",
		"product_not_found": "商品号不存在",
		"product_num": "商品编号",
		"product_num_ref_num": "商品编号/参考编号",
		"product_price": "商品价格",
		"product_purchased": "商品采购",
		"product_repackage_sheet_product_repackage": "商品名称",
		"product_sku": "产品 SKU",
		"product_to_return": "商品退还",
		"product_type": "商品类别",
		"product_unit_of_measure": "",
		"product_unit_weight_price": "商品单位重量价格",
		"products": "商品",
		"products_list": "",
		"profile": "详细",
		"profit": "利润",
		"profit_percentage": "利润百分比",
		"profit_pl": "实际利润比",
		"promo": "促销",
		"promo_code": "Promo Code",
		"promotion": "促销",
		"promotion_management": "商品名称",
		"promotion_name": "商品名称",
		"promotions": "促销",
		"Proposition65": "Proposition 65",
		"puchase_payment_detail": "购买付款明细",
		"pull_sheet_format": "Pull Sheet 格式化",
		"purchase": "采购",
		"purchase_dashboard": "采购主页",
		"purchase_date": "采购日期",
		"purchase_date_colonsign": "采购日期名称",
		"purchase_information": "采购信息",
		"purchase_management": "采购管理",
		"purchase_no": "采购号码",
		"purchase_order": "采购订单",
		"purchase_order_date": "采购单日期",
		"purchase_order_dates": "采购单日期",
		"purchase_order_detail": "采购单明细",
		"purchase_order_details": "采购单明细",
		"purchase_order_expect_coming_today": "采购订单预计今日到达",
		"purchase_order_full_list": "采购单完整列表",
		"purchase_order_full_table": "采购单表",
		"purchase_order_no": "采购订单编号",
		"purchase_order_not_received": "采购订单未收货",
		"purchase_order_number": "采购单编号: ",
		"purchase_order_receive_rate": "采购单收货率",
		"purchase_order_requires_products": "采购订单需要商品”",
		"purchase_orders_arrive_today": "预计当天到货采购订单",
		"purchase_payment": "采购单付款",
		"purchase_payment_details": "采购付款明细",
		"purchase_payments": "采购付款",
		"purchase_performance": "采购状况表",
		"purchase_pivot": "采购模板对比表",
		"purchase_pivot_chart": "采购视图",
		"purchase_quote": "采购报价",
		"purchase_quote_details": "采购报价明细",
		"purchase_quote_full_table": "采购报价表",
		"purchase_reference": "采购参考表",
		"purchase_reference_report": "采购参考表",
		"purchase_report": "采购报告",
		"purchase_return": "采购退货",
		"purchase_return_details": "采购退货细节",
		"purchase_return_list": "采购退货表",
		"purchase_return_num": "商品名称",
		"purchase_sales": "已收货 / 已发票",
		"purchase_schedule": "采购时间表",
		"purchase_statistics": "采购统计",
		"purchase_status": "采购状态",
		"purchase_template": "采购模板",
		"purchase_template_details": "采购模板明细",
		"purchase_template_full_table": "采购模板表",
		"purchase_template_must_have_products": "“采购模板必须有商品”",
		"purchase_template_no": "采购模板编号",
		"purchase_template_unavailable": "采购模板不可用",
		"purchase_user": "采购用户",
		"purchased": "购买",
		"purchased_by": "采购人员",
		"purchased_colonsign": "采购:",
		"purchaser": "采购人员",
		"purchaser_name": "",
		"purchasing": "采购",
		"purchasing_performance": "采购业绩",
		"put_away": "放置",
		"put_away_form": "",
		"put_away_list": "放弃列表",
		"put_away_num": "放弃数量",
		"putaway_quantity": "",
		"qty": "数量",
		"box": "数量",
		"qty_from": "原数量",
		"qty_to": "新数量",
		"quantity": "数量",
		"quantity_cannot_have_a_zero_value": "不能为 0",
		"quantity_colonsign": "数量：",
		"quantity_weight": "数量/ 重量",
		"quarter": "季",
		"quick_actions": "快速操作",
		"quote_reference": "采购报价单",
		"quote_reference_chart": "采购视图",
		"quote_reference_chart_detail": "采购视图明细",
		"range": "范围",
		"rate": "商品名称",
		"rcv_qty": "接收数量",
		"rcv_box": "接收数量",
		"rcv_quantity": "收货数量",
		"rcv_total_price": "收货总价格",
		"reading_data": "读取数据",
		"reason_for_return": "退货原因",
		"receipt": "收据",
		"receipt_no": "收据编号",
		"receive": "收货",
		"receive_all": "全部接收",
		"receive_date": "收货日期",
		"receive_detail": "",
		"receive_dollarsign": "收货价",
		"receive_final_dollarsign": "收货单最终 $",
		"receive_history": "收货历史",
		"receive_history_detail": "收货历史详细",
		"receive_list": "接收列表",
		"receive_num": "收货编号",
		"receive_qty": "收货数量",
		"receive_total_dollarsign": "收货总价",
		"receive_total_price": "",
		"receive_total_wt": "收货总重",
		"receive_unit_dollarsign": "收货单价",
		"receive_unit_price": "",
		"received": "已收货",
		"receiver": "收货人员",
		"receiving": "收货",
		"receiving_date": "接收日期",
		"receiving_details": "接收详细信息",
		"receiving_history": "接收历史",
		"receiving_information": "接收信息",
		"receiving_list": "收货单",
		"record_adjustment_no": "记录（调整）编号",
		"record_convert_no": "记录(转换)号",
		"record_relocation_no": "",
		"record_repackage_no": "记录（重新包装）编号",
		"record_scrap_no": "记录报废NO",
		"recreate": "重建",
		"refresh_system": "刷新系统",
		"confirm_refresh": "确认加载和刷新系统?",
		"ref_barcode": "参考条形码",
		"ref_cost": "参考成本",
		"ref_price": "参考价格",
		"ref_cost_price": "参考价格",
		"ref_dollarsign": "参考价格",
		"ref_num": "参考号",
		"item_num": "参考号",
		"ref_purchasing_price": "参考采购价",
		"refer_purchasing_price": "参考采购价",
		"refund": "退款",
		"refund_amount": "退款金额",
		"refund_successful": "退款成功",
		"related": "有关",
		"related_no": "关联号码",
		"related_product": "关联商品",
		"release": "发货",
		"released": "已发货",
		"relocate": "搬迁",
		"relocate_quantity": "搬迁数量",
		"relocate_some_or_all_of_the_selected_inventory": "部分或全部库存搬迁",
		"relocate_user": "搬迁执行者",
		"relocation": "搬迁",
		"relocation_date": "",
		"relocation_destination": "搬迁目的地",
		"relocation_quantity": "搬迁数量",
		"remark": "备注",
		"remember_me": "记住我",
		"remove": "移除",
		"remove_from_so_list": "从销售列表中删除",
		"repackage": "重新包装",
		"repackage_date": "重新包装日期",
		"repackage_destination": "重新打包目的地",
		"repackage_quantity": "重新包装数量",
		"repackage_target_quantity": "重新包装目标数量",
		"repackage_user": "重新包装用户",
		"repeat_frequency": "重复频率",
		"repeat_interval": "重复间隔",
		"repeat_on": "重复",
		"report": "报表",
		"resale_no": "Resale号",
		"reseller": "Reseller",
		"reset_all": "重置全部",
		"reset_email": "重置电子邮件",
		"reset_password": "重置密码",
		"reship": "补发",
		"restocking_fee": "退货费用",
		"return": "返回",
		"rtned_qty": "已退货数量",
		"return_date": "退货日期",
		"return_details": "退货明细",
		"return_no": "退货号",
		"return_order_info": "采购退货单信息",
		"return_qty": "退货数量",
		"return_quantity": "退还数量",
		"return_reason": "退货原因",
		"return_status": "退货状态",
		"return_this_product": "退还商品",
		"return_unit_price": "回单位价格",
		"returns": "退货",
		"retype_password": "",
		"rewards": "奖励",
		"role_management": "角色管理",
		"role_name": "角色名称",
		"route": "路线",
		"route_details": "路线详情",
		"route_num": "路线编号",
		"route_number": "路线编号",
		"routing": "排线",
		"rtn_quantity": "退货数量",
		"sale": "销售",
		"sale_details": "销售细节",
		"sale_dollarsign": "售价",
		"sale_invoice_details": "销售发票明细",
		"sale_order_details": "销售单明细",
		"sale_price": "售价",
		"sale_qty": "销售数量",
		"saleable": "可售",
		"sales": "销售",
		"sales_colonsign": "销售：",
		"sales_cost": "销售额 / 成本",
		"sales_dashboard": "销售主页",
		"sales_history": "销售历史",
		"sales_inventory_value": "销售价值/库存价值",
		"sales_invoice": "销售发票",
		"sales_invoice_detail": "销售发票的明细",
		"sales_invoice_details": "发票明细",
		"sales_invoice_full_table": "销售发票全表",
		"sales_invoices_today": "今日销售发票",
		"sales_management": "销售管理",
		"sales_management2": "订单管理",
		"sales_margin_percentsign": "销售利润 %",
		"sales_margin_master_percentsign": "销售利润(M) %",
		"sales_order": "销售订单",
		"sales_order_dates": "销售订单日期",
		"sales_order_details": "销售订单明细",
		"sales_order_full_table": "销售订单全表",
		"sales_order_list": "销售订单列表",
		"sales_order_no": "销售订单编号",
		"sales_order_rate": "销售订单比例",
		"sales_orders": "销售订单",
		"sales_orders_open": "未出货销售订单",
		"sales_orders_ship_today": "预计当天出货销售订单",
		"sales_performance": "销售绩效表",
		"sales_performance_list": "销售业绩表",
		"sales_report": "销售报告",
		"sales_return": "销售退货",
		"sales_returned": "销售退货",
		"same_as_billing_address": "与付款地址相同",
		"same_as_billing_contact": "与付款联系人相同",
		"same_as_billing_information": "与付款信息相同",
		"Sat": "周六",
		"sat_route": "周六路线",
		"sat_stop": "周六停靠点",
		"saturday": "周六",
		"save": "保存",
		"save_and_print": "保存打印",
		"save_changes": "",
		"save_draft": "保存草稿",
		"save_successful": "保存成功",
		"save_weights": "保存重量",
		"saved": "保存完成",
		"saved_tracking_note": "此采购单追踪笔记已保存",
		"schedule_shipping_date": "预计发货日期",
		"scheduled": "规划",
		"scheduled_to_ship": "规划发货",
		"scheduled_shipping_date": "预计发货日期",
		"scrap": "报废",
		"scrap_amount": "报废数量",
		"scrap_date": "报废日期",
		"scrap_product_details": "报废商品明细",
		"scrap_qty": "报废数量",
		"scrap_quantity": "报废数量",
		"scrap_record": "报废记录",
		"scrap_records": "报废记录",
		"scrap_some_or_all_of_the_selected_inventory": "报废部分或全部选定的库存",
		"scrapping": "报废",
		"service_code": "Service Code",
		"search": "搜索",
		"search_by": "搜索类别",
		"search_prod": "搜索商品:",
		"search_prod_by": "搜索商品",
		"search_type": "搜索类别:",
		"sectioned_list": "Sectioned List",
		"select": "选择",
		"select_a_product_to_scrap": "选择商品进行报废",
		"select_a_purchase_order": "选择采购订单",
		"select_an_inventory_item": "选择库存商品",
		"select_customer_information": "选择客户信息",
		"select_group": "选择组别",
		"select_inventory_to_scrap": "选择库存报废",
		"select_purchase_template": "选择购买模板",
		"select_purchaser": "选择采购员",
		"select_receive_history": "",
		"select_seller": "选择卖家",
		"select_vendor": "选择供货商",
		"selected_bins": "选择储位",
		"seller": "销售员",
		"set_order": "定位订单",
		"set_schedule": "设定的时间表",
		"set_various_weight": "设置不固定重量",
		"set_weights": "",
		"setting": "设置",
		"share": "分享",
		"share_cost": "攤入成本",
		"sheet_not_completed_warning": "",
		"shelf_life": "保质期",
		"shift_life_day": "保质期(日)",
		"shelf_life_statistics": "保质期统计",
		"ship_dollarsign": "运费",
		"ship_to": "运送到",
		"ship_weight": "运输重量",
		"ship_wt": "运输重量",
		"shipment_date": "发货日期",
		"shipped": "发货",
		"shipped_qty": "发货数量",
		"shipping": "运输",
		"shipping_address": "送货地址",
		"shipping_address_poundsign": "送货地址 #",
		"shipping_cost": "运费",
		"shipping_cost_details": "运费成本细节",
		"shipping_cost_information": "运输成本",
		"shipping_date": "发货日期",
		"shipping_details": "送货明细",
		"shipping_dollarsign": "运费",
		"shipping_fee": "运输费用",
		"shipping_information": "运输信息",
		"shipping_method": "运输方式",
		"shipping_poundsign": "运输 #",
		"shipping_weight": "运输重量",
		"shipto": "运送到",
		"show_as": "Show As",
		"show": "显示",
		"hide": "隐藏",
		"show_price": "显示价格",
		"show_finalized_si": "显示完成销售发票",
		"show_released_si": "显示销售发票",
		"si_dollarsign": "发票$",
		"si_no": "发票号码",
		"si_payment": "",
		"si_status": "发票状态",
		"sign_in_to_continue": "",
		"simplified_excel": "简化导出",
		"simplified_statement": "简化报表",
		"size": "尺寸",
		"sm": "小",
		"small_catch_weight": "小货不固定重量",
		"small_label": "小标签",
		"small_net_weight": "小货重量",
		"small_product_no": "小货编号",
		"so_dollarsign": "销售$",
		"so_no": "销售单编号",
		"so_scheduled_shipping": "SO预计发货",
		"so_to_po": "SO 到 PO",
		"sold": "出售",
		"space_not_enough_create_bins": "",
		"space_not_enough_relocate": "",
		"specify": "指定",
		"split_tracking_numbers": "分包追踪号码",
		"spreadsheet": "导入表格",
		"start": "开始",
		"start_date": "开始日期",
		"state": "州",
		"statement_range": "报表范围",
		"status": "状态",
		"stock": "库存",
		"stock_left_after_1_week": "一周后剩馀库存",
		"stock_range": "库存范围",
		"stop": "停靠",
		"stop_purchase": "停卖",
		"stop_route": "停止路线",
		"stop_sale": "停售",
		"stopsale": "停售",
		"storage_rate": "仓储费用",
		"store_credit_dollarsign": "低佣金$",
		"street": "街",
		"sub_menu": "",
		"submit": "提交",
		"subtitle": "",
		"subtotal": "小计",
		"suite": "单元号",
		"success": "成功",
		"Sun": "周日",
		"sun_route": "周日路线",
		"sun_stop": "周日停靠点",
		"sync_scale": "同步电子秤",
		"sync_esl": "同步电子标签",
		"target_weight": "目标重量",
		"Tax": "TAX:",
		"tax": "税",
		"tax_code": "税号",
		"tax_management": "税率管理",
		"taxable": "交税",
		"tel": "联系电话",
		"tel_colonsign": "电话：",
		"telephone": "电话",
		"temperature": "存放温度",
		"template_name": "模板名称",
		"term_days": "",
		"term_type": "",
		"term_types": "类型",
		"test": "测试",
		"this_group": "此组别",
		"this_customer_is_already_in_the_group": "This customer is already in the group.",
		"thu_route": "周四路线",
		"thu_stop": "周四停靠点",
		"Thur": "周四",
		"thurs_route": "周四路线",
		"thurs_stop": "周四停靠点",
		"to": "到",
		"to_bin": "到储位",
		"to_zone": "到区域",
		"tooltip_customer_bypass_payment": "Bypassing payments will let mobile users skip mobile payment, and pay with AR.",
		"tooltip_customer_manager": "Manager users can see all past orders for this business customer.",
		"today": "今天",
		"total": "总计",
		"total_amount": "总金额",
		"total_ap": "总应付",
		"total_ar": "总应收",
		"total_bin": "",
		"total_bins": "总储位",
		"total_credit": "总额度",
		"total_customers": "总客户",
		"total_dollarsign": "总价",
		"total_inventory_price": "库存总价总计",
		"total_inventory_worth": "库存总价值",
		"total_invoice": "总发票",
		"total_net_weight": "总净重",
		"total_net_wt": "总净重",
		"total_orders_today": "订单总数",
		"total_price": "总价格",
		"total_price_colonsign": "总价：",
		"total_prod": "总数量",
		"total_purchases": "商品采购总额",
		"total_receive_price": "总收货金额",
		"total_return": "总退货",
		"total_sale": "总销售额",
		"total_sales_price": "总销售金额",
		"total_sales_worth": "总销售价值",
		"total_ship_wt": "总毛重",
		"total_shipping_weight": "总运输重量",
		"total_shipping_weight_lbs": "总运输重量 (磅)",
		"total_size": "尺寸总和",
		"total_storage_day": "总存储日",
		"total_unit": "总数量",
		"total_users": "总用户",
		"total_weight": "总重量",
		"total_wt": "总重量",
		"track_all": "追踪全部",
		"track_no": "追踪号码",
		"tracking_note": "追踪笔记",
		"tracking_num": "追踪号码",
		"tracking_nums": "追踪号码",
		"transaction_fee": "手续费",
		"transit_method": "运输方式",
		"translation": "翻译",
		"try_dropping_some_files_here,_or_click_to_select_files_to_upload": "尝试在此处放入文件，或单击以选择要上传的文件",
		"tue_route": "周二路线",
		"tue_stop": "周二停靠点",
		"Tues": "周二",
		"tues_stop": "周二停靠点",
		"type": "类型",
		"Typo": "id",
		"type_in_your_email": "輸入您的电子邮件",
		"type_in_your_password": "輸入您的密碼",
		"unassigned_orders": "未分配订单",
		"undo": "不做",
		"undone": "未完成",
		"unit": "单元",
		"unit_dollarsign": "单价",
		"unit_of_measure": "测量单位",
		"unit_per_pallet": "栈板规格",
		"unit_price": "单价",
		"unit_type": "Unit Type",
		"unit_price_colonsign": "单价:",
		"unload_all": "全部卸载",
		"unload_selected": "重置已选",
		"unpaid": "未付",
		"unpaid_amount": "未付金额",
		"update": "更新",
		"update_date": "",
		"update_dollarsign": "更新价格",
		"update_inventory": "更新库存",
		"update_no": "更新编号",
		"update_time": "更新时间",
		"upload": "上传文件",
		"upload_file": "上传文件",
		"upload_files": "上传文件",
		"upload_images": "上传图片",
		"uploading": "上传",
		"usable": "可用",
		"used_bin": "",
		"user": "用户",
		"user_amount": "用户数量",
		"use_product_a": "Use Product A",
		"user_detail": "用户信息",
		"user_management": "用户管理",
		"user_performance": "销售员业绩",
		"user_name": "用户名",
		"user_role": "用户角色",
		"username": "用户名",
		"variable_weight": "不固定重量",
		"vehicle": "车量",
		"vendor": "供货商",
		"vendor_add": "增加供货商",
		"vendor_description": "供货商说明",
		"vendor_details": "供货商信息",
		"vendor_id": "供货商号",
		"vendor_information": "供货商信息",
		"vendor_invoice_no": "供货商发票号码",
		"vendor_inv": "供货商发票号",
		"vendor_inv_date": "供货商发票日期",
		"vendor_name": "供货商名称",
		"vendor_no": "供货商编号",
		"mfr_no": "制造商编号",
		"vendor_num": "供货商编号",
		"vendor_number": "供货商编号",
		"vendor_products": "供货商商品",
		"vendor_product_number": "供货商商品编号",
		"vendor_statement": "供货商报表",
		"vendors": "供货商",
		"vendors_management": "供货商管理",
		"view_pos_order": "",
		"void": "作废",
		"void_note": "作废备注",
		"void_reason": "作废原因",
		"warehouse": "仓库",
		"warehouse_bin_id": "仓库储位 ID",
		"warehouse_bins": "仓库储位",
		"warehouse_dashboard": "仓库主页",
		"warehouse_detail_view": "仓库详细查看",
		"warehouse_id": "仓库 ID",
		"warehouse_management": "仓库管理",
		"warehouse_map_view": "仓库视图",
		"warehouse_name": "仓库名称",
		"warehouse_receive_deleted__purchase_orders_purchasestatus_rolled_back_to_partially_received_": "收货单已删除。采购订单状态返回至 Partially Received。",
		"Warehouse_receive_deleted__purchase_orders_purchasestatus_rolled_back_to_placed_": "收货单已删除。采购订单状态返回至 Placed。",
		"warehouse_receive_num": "",
		"warehouse_zone_id": "",
		"warehousebin_id": "",
		"warning": "警告",
		"wechat": "微信",
		"Wed": "周三",
		"wed_route": "周三路线",
		"wed_stop": "周三停靠点",
		"Weekly": "周",
		"weeks_left_after_1_week": "一周后剩馀周数",
		"weight": "重量",
		"weight_lbs": "重量 (磅)",
		"service": "服务",
		"tracking_link": "追踪链接",
		"weight(s)_cannot_have_a_zero_value": "",
		"weight_range": "重量范围",
		"weight_return": "退货重量",
		"wh": "WH",
		"wholesale": "批发",
		"wholesale_only": "仅限批发",
		"wk_sale": "周销售",
		"work_not_saved_warning": "您的工作还未保存！您确定你要退出？",
		"working_order": "工作顺序",
		"working_orders": "转换库存",
		"year": "年",
		"yes": "是",
		"yesterday": "昨天",
		"your_order": "您的订单",
		"your_purchase_order": "采购订单",
		"your_purchase_quote": "采购报价",
		"your_purchase_template": "采购模板",
		"your_return_order": "您的采购退货单",
		"your_sales_order": "您的销售订单",
		"your_so_no_period_is": "销售单号是",
		"zip": "邮编",
		"zipcode": "邮政编码",
		"zone": "区域",
		"zone_description": "",
		"zone_detail": "",
		"zone_detail_view": "",
		"zone_id": "区域 ID",
		"zone_level": "区域等级",
		"zone_name": "区域名称",
		"zone_no": "区域编号",
		"create_ap": "Create AP",
		"create_ar": "Create AR",
		"new_working_orders": "新转换库存",
		"ref_sales": "销售参考价",
		"price_style_1": "原价",
		"price_style_2": "价格尾数0,5,9",
		"color": "颜色",
		"brand": "品牌",
		"style": "款式",
		"us_size": "美国尺寸",
		"eu_size": "欧洲尺寸",
		"repair_detail": "维修明细",
		"shipping_detail": "邮寄信息",
		"Customer_Name": "客户姓名",
		"Customer_Mobile": "客户电话",
		"Customer_Address": "客户地址",
		"Customer_Email": "电子邮箱地址",
		"customer_link": "绑定客户",
		"rma": "退货授权",
		"RMA_Content": "提单内容简介",
		"RMA_Service_Type": "服务类型",
		"RMA_Number": "RMA号码",
		"Product_Serial_Number": "产品序列号",
		"Product_Description": "产品描述",
		"Is_Urgent": "加急?",
		"Is_Warranty": "保修?",
		"Return_Logistics_Company": "物流公司",
		"Return_Tracking_Number": "物流跟踪号吗",
		"Openbox_Description": "开箱检查",
		"Product_Detail_Info": "产品详细信息",
		"Warehouse_Check_Info": "仓库检查信息",
		"Status": "状态",
		"Repair_Note": "维修注释",
		"Dispatch_Logistics_Company": "物流公司",
		"Dispatch_Tracking_Number": "物流公司跟踪号码",
		"Shipping_Cost": "物流费用",
		"Dispatch_Description": "物流描述",
		"Product_Model": "产品型号",
		"unreceived": "未收到",
		"repairing": "维修中",
		"repaired": "已维修",
		"dispatched": "已派送",
		"excel_qb": "Quick Book导出",
		"delivery_tracking_num": "跟踪号码",
		"total_delivery_fee": "邮寄费用",
		"shippingMethod": "送货方式",
		"quality": "质量描述",
		"pos_holds": "保留单",
		"pos_holds_full_table": "POS 保留列表",
		"Shipping_fee": "运费",
		"Misc_fee": "杂费",
		"arrival_price": "到货价",
		"main_sku": "主要的SKU",
		"admin_password": "管理员密码",
		"admin": "管理员",
		"sales_popularity": "产品活跃",
		"confirmNcontinue": "确定并继续",
		"weight_not_in_range": "其中一个或者多个产品的重量不在定义的产品重量范围内",
		"add_credit_amount": "添加/减去积分",
		"edit_credit": "编辑积分",
		"business_user": "商业用户",
		"Business_already_verified": "已验证",
		"business_name": "商业名称",
		"full_name": "代表人全名",
		"phone_number": "电话号码",
		"confirm_verification": "验证此用户",
		"verified": "验证状态",
		"Name_and_Description_fields_are_required": "名称和产品描述为必填项",
		"passcode_confirm_text": "输入passcode确认身份",
		"category_description": "类别描述",
		"meta_description": "元描述",
		"meta_title": "元题目",
		"meta_keywords": "元关键字",
		"key": "关键字",
		"category_info_edit": "编辑类别信息",
		"category_display_info": "类别显示讯息",
		"category_meta_info": "类别元数据",
		"VPN": "VPN",
		"business_type": "商业类型",
		"ssn": "社会安全号",
		"is_retailer": "零售商",
		"year_in_business": "创立年份",
		"all_locations": "全部地点",
		"alcohol": "酒精",
		"platform": "平台",
		"customer_discount": "折扣(%OFF)",
		"discount_$": "折扣 $",
		"discount_rate_%": "折扣率 %",
		"generating": "生成中...",
		"outbound_order": "出口单",
		"outbound_order2": "XPO订单列表",
		"inbound_order": "入库单",
		"storage_orders": "仓库单",
		"inventory_history": "仓库历史",
		"checking": "检测中",
		"rma_num": "RMA号码",
		"return_tracking": "退货跟踪号码",
		"proccess_status": "维修状态",
		"request_type": "请求类型",
		"sn_num": "SN号码",
		"notes_shortcut": "快捷附注",
		"products_repaired": "需要维修的产品",
		"products_cost": "维修消耗的产品",
		"notes": "附注",
		"request_details": "客户备注",
		"sku_num": "SKU号码",
		"appointment": "預約",
		"lowest_sale": "最低售价",
		"dollarsign": "",
		"pre_order": "Pre Orders",
		"ship_to_orders": "Ship To Orders",
		"ship_from_orders": "Ship From Orders",
		"other_service": "Other Service",
		"type_in_credit": "Type In Credit",
		"credit_details": "Credit Details",
		"mobile_user_messages_management": "Mobile User Messages management",
		"mobile_user_products": "Mobile User Products",
		"lot_number": "仓位",
		"legend_inventory_stop_sale": "停售",
		"legend_inventory_danger_stock": "库存 < 最低范围",
		"legend_inventory_warning_stock": "最低范围 ≤ 库存 ≤ 最大范围",
		"legend_inventory_over_stock": "库存 > 最大范围",
		"legend_inventory_po_stock": "库存 + 购买单数量 > 最小范围",
		"legend_inventory_half_stock": "库存 < 最低范围 ÷ 2",
		"picking_list": "拣货单",
		"packing_list": "装箱单",
		"shipping_list": "运输单",
		"creator": "创建者",
		"show_image": "图片展示",
		"invoice_creator": "发票创建者",
		"no_payment_record": "没有支付记录",
		"box_qty": "数量",
		"upload_product": "上传产品",
		"product_template": "产品模板"
	};

/***/ }),
/* 755 */
/***/ (function(module, exports) {

	module.exports = {
		"(all_markup_percentsign_will_base_on_this_price)": "(All markup % will base on this price.)",
		"(mm_unit)": "(MM Unit)",
		"(inches)": "(In.)",
		"(no_sale_will_be_allowed_lower_than_this_price)": "(No sale will be allowed lower than this price.)",
		"(num)": "(Num)",
		"(pkg_type)": "(Pkg Type)",
		"(pkg_size)": "(Pkg Size)",
		"(pkg_size_1)": "(Pkg Size 1)",
		"(pkg_size_2)": "(Pkg Size 2)",
		"(ref_no)": "(Ref No.)",
		")__action_denied_": "). Action denied.",
		"00_dashsign_07_days": "00 - 07 Days",
		"08_dashsign_30_days": "08 - 30 Days",
		"00_dashsign_30_days": "00 - 30 Days",
		"31_dashsign_60_days": "31 - 60 Days",
		"4_wks_sale": "4 WKS Sale",
		"61_dashsign_90_days": "61 - 90 Days",
		"91_plussign_days": "91+ Days",
		"customers2": "Customers",
		"general_management2": "General Management",
		"outbound_order2": "Outbound Order",
		"sales_management2": "Sales Management",
		"account": "Account",
		"account_payable": "Accounts Payable",
		"account_payable_payment_report": "Accounts Payable (Payment Report)",
		"account_payment_term": "Account Payment Term",
		"account_receivable": "Accounts Receivable",
		"account_receivable_receive_report": "Accounts Receivable (Receive Report)",
		"action": "Action",
		"action_log": "Action Log",
		"payment_term_short": "Pay Term",
		"unit_cost": "Unit Cost $",
		"volume_cft": "Volume (CFT)",
		"top_deal": "Top Deal",
		"new_arrival": "New Arrival",
		"active": "Active",
		"active_customer": "Active Customer",
		"active_schedule": "Active Schedule",
		"active_vendor": "Active Vendor",
		"add": "Add",
		"all_taxable": "All Taxable",
		"add_a_new_category": "Add a New Category",
		"add_a_new_group": "Add a New Group",
		"add_a_new_payment_term": "Add A New Payment Term",
		"add_agent": "Add Agent",
		"add_another_product": "Add Another Product",
		"add_customer": "Add Customers",
		"add_invoice": "Add Invoice",
		"add_new_bin": "Add New Bin",
		"add_new_favorite": "Add New Favorite",
		"add_new_route": "Add New Route",
		"add_new_zone": "Add New Zone",
		"add_non_product": "Add Non Product",
		"add_payment_term": "Add Payment Term",
		"add_pickup": "Add Pickup",
		"add_purchase_order": "Add Purchase Order",
		"add_shipping_address": "Add Shipping Address",
		"add_vendor": "Add Vendor",
		"address": "Address",
		"adjust": "Adjust",
		"adjust_some_or_all_of_the_selected_inventory": "Adjust some or all of the selected inventory",
		"adjustment": "Adjustment",
		"adjustment_date": "Adjustment Date",
		"adjustment_quantity": "Adjustment Quantity",
		"admin_tools": "Admin Tools",
		"advanced_search": "Advanced Search",
		"afg_choice": "AFG Choice",
		"agent_information": "Agent Information",
		"agent_name": "Agent Name",
		"agent_num": "Agent No.",
		"agents": "Agents",
		"all": "All",
		"all_bins": "All Bins",
		"all_products": "All Products",
		"alt_phone": "Alt. Phone",
		"amount": "Amount",
		"ap_aged_report": "AP Aged Report",
		"ap_aged_report_detail": "AP Aged Report Detail",
		"ap_num": "AP No.",
		"ap_records_existed_for_this_warehouse_receive_(apnum:_": "AP records existed for this warehouse receive (APNum: ",
		"ap_statistics": "AP Statistics",
		"app_email": "App Email",
		"approve": "Approve",
		"ar_aged_report": "AR Aged Report",
		"ar_aged_report_detail": "AR Aged Report Detail",
		"ar_customer_payment": "AR Customer Payment",
		"ar_date": "AR Date",
		"ar_num": "AR No.",
		"ar_slashsign_ap": "AR / AP",
		"ar_statistics": "AR Statistics",
		"arrival": "Arrival",
		"arrival_status": "Arrival Status",
		"attachment_upload": "Attachment Upload",
		"auto_apply": "Auto Apply",
		"auto_fill": "Auto Fill",
		"auto_load": "Auto Load",
		"auto_putaway": "Auto Putaway",
		"available": "Available",
		"available_bins": "Available Bins",
		"avg_cost": "Avg. Cost",
		"avg_in_stock_dollarsign": " Avg. In Stock $",
		"avg_markup_percentsign": "Avg. Markup %",
		"avg_sale_dollarsign": "Avg. Sale $",
		"b2b_b2c": "B2B/B2C",
		"back": "Back",
		"balance": "Balance",
		"barcode": "Barcode",
		"barcode_poundsign": "Barcode #",
		"basic_info": "Basic Info",
		"batch_no": "Batch No.",
		"batch_no_po_no": "Batch No. (PO No.)",
		"batch_num": "Batch No.",
		"bill_date": "Bill Date",
		"billing_address": "Billing Address",
		"billing_contact": "Billing Contact",
		"billing_details": "Billing Details",
		"billing_information": "Billing Information",
		"bin": "Bin",
		"bin_amount": "Bin Amount",
		"bin_detail_view": "Bin Detail View",
		"bin_name": "Bin Name",
		"bin_range": "Bin Range",
		"bins_available": "Bins Available",
		"button": "Button",
		"buy": "Buy",
		"buy_a_get_b": "Buy A Get B",
		"by_3_days": "By 3 Days",
		"by_po": "By PO",
		"by_product": "By Product",
		"by_quantity": "By Quantity",
		"by_quantity_discount": "By Quantity (Discount)",
		"by_quantity_product": "By Quantity (Product)",
		"by_total_price": "By Total Price",
		"by_unit": "By Unit",
		"by_week": "By Week",
		"by_weight": "By Weight",
		"cancel": "Cancel",
		"cancel_return": "Cancel Return",
		"cancelled": "Cancelled",
		"carry_type": "Carry Type",
		"carrier": "Carrier",
		"carrier_code": "Carrier Code",
		"change_carrier_info": "Carrier Info",
		"please_clarify_other": "Please Clarify Other",
		"bol_num": "BOL Num",
		"pro_num": "PRO Num",
		"ltl_carrier": "LTL Carrier",
		"carry_type_shipping_method": "Carry Type Shipping Method",
		"case (large prod)": "Case (Large Prod)",
		"case": "Case",
		"case_qty": "Case QTY",
		"cash_dollarsign": "Cash $",
		"category": "Category",
		"category_1": "Category 1",
		"category_2": "Category 2",
		"category_2_product_list": "CATEGORY 2 PRODUCT LIST",
		"category_2_B2B_product_list": "CATEGORY 2 B2B PRODUCT LIST",
		"category_2_b2c": "Category 2 B2C",
		"category_2_b2b": "Category 2 B2B",
		"category_analysis": "Category Analysis",
		"category_detail": "Category Detail",
		"category_name": "Category Name",
		"category_hidden": "Hidden Categories",
		"category_visible": "Visible Categories",
		"cc_hold_until": "CC Hold Until",
		"change_delivery_fee": "Change Delivery Fee",
		"change_employee_note": "Change Employee Note",
		"change_payment_method": "Payment Method",
		"change_pull_sheet": "Pull Sheet Assign Amount",
		"change_ship_weight": "Change Shipping Weight",
		"change_weight_button": "Change Weight",
		"change_discount_rates": "Change Discount Rates",
		"charged": "Charged",
		"check": "Check",
		"check_dollarsign": "Check $",
		"check_num": "Check No.",
		"chinese": "Chinese",
		"chowbus": "Chowbus",
		"chowbus_import": "Chowbus Import",
		"cif": "CIF",
		"city": "City",
		"city_report": "City Report",
		"clear": "Clear",
		"clear_all_values": "Clear All Values",
		"close": "Close",
		"COD": "COD",
		"code": "Code",
		"company": "Company",
		"complete": "Complete",
		"complete_return": "Complete Return",
		"complete_this_sheet": "Complete This Sheet",
		"completed": "Completed",
		"confirm": "Confirm",
		"confirm_action": "Confirm Action",
		"confirm_add": "Confirm Add",
		"confirm_create": "Confirm Create",
		"confirm_delete": "Confirm Delete",
		"confirm_group_change": "Confirm Group Change",
		"confirm_new_password": "Confirm New Password",
		"confirm_password": "Confirm Password",
		"confirm_print_tracking": "Confirm Print Label",
		"confirm_void": "Confirm Void",
		"confirmation": "Confirmation",
		"contact": "Contact",
		"contact_information": "Contact Information",
		"contact_person": "Contact Person",
		"content_management": "Content Management",
		"continue_product": "Continue",
		"convert": "Convert",
		"convert_date": "Convert Date",
		"convert_item_price": "Convert Item Price",
		"convert_prod_qty": "Convert Prod Qty",
		"convert_product_qty": "Convert Product Qty",
		"convert_quantity": "Convert Quantity",
		"convert_target_quantity": "Convert target Quantity",
		"convert_type": "Convert Type",
		"convert_user": "Convert User",
		"convertable_product": "Convertable Product",
		"cost": "Cost",
		"costs_details": "Costs Details",
		"county": "County",
		"create": "Create",
		"create_a_new_agent": "Create a New Agent",
		"create_a_new_category": "",
		"create_a_new_customer": "Create A New Customer",
		"create_a_new_favorite": "Create A New Favorite",
		"create_a_new_product": "Create A New Product",
		"create_a_new_purchase": "Create a New Purchase",
		"create_a_new_purchase_order": "Create a New Purchase Order",
		"create_a_new_purchase_quote": "Create a New Purchase Quote",
		"create_a_new_purchase_return": "Create a New Purchase Return",
		"create_a_new_purchase_schedule": "Create a New Purchase Schedule",
		"create_a_new_purchase_template": "Create a New Purchase Template",
		"create_a_new_sales_order": "",
		"create_a_new_user": "",
		"create_a_new_vendor": "Create a New Vendor",
		"create_a_purchase_quote": "Create a Purchase Quote",
		"create_a_purchase_schedule": "Create a Purchase Schedule",
		"create_account": "Create Account",
		"create_and_duplicate": "Create and Duplicate",
		"create_ap": "Create AP",
		"create_ar": "Create AR",
		"create_bin": "",
		"create_customer_return": "Create Customer Return",
		"create_date": "Create Date",
		"create_inventory_adjustment_sheet": "Create Inventory Adjustment Sheet",
		"create_inventory_convert_sheet": "Create Inventory Convert Sheet",
		"create_inventory_relocation_sheet": "Create Inventory Relocation Sheet",
		"create_inventory_repackage_sheet": "Create Inventory Repackage Sheet",
		"create_new_po": "Create New Purchase Order",
		"create_new_purchase_order": "Create New Purchase Order",
		"create_new_sales_order": "Create New Sales Order",
		"create_payment": "Create Payment",
		"create_product": "Create Product",
		"create_promotion": "Create Promotion",
		"create_purchase_order": "Create Purchase Order",
		"create_purchase_quote": "Create Purchase Quote",
		"create_put_away": "",
		"create_receiving": "Create Receiving",
		"create_role": "Create Role",
		"create_sales_order": "Create Sales Order",
		"create_sales_return": "Create Sales Return",
		"create_so": "Create SO",
		"create_time": "Create Time",
		"create_user": "Create User",
		"purchase_convert_unit": "Purchase Convert Unit",
		"create_warehouse": "Create Warehouse",
		"create_zone": "",
		"created": "Created",
		"created_by": "Created By",
		"create_task": "Create Task",
		"created_time": "Created Time",
		"credit": "Credit",
		"credit_card": "Credit Card",
		"Credit_card": "Credit Card:",
		"credit_card_dollarsign": "Credit Card $",
		"credit_limit": "Credit Limit",
		"credit_limit_payment_term_warning": "Customer has exceed his Credit Limit and/or Payment Term Limit. In order to create SO, please verify your identity with passcode",
		"credit_line": "Credit Line",
		"credit_note": "Customer Credit Notes",
		"credit_reason": "Credit Reason",
		"credit_status": "Credit Status",
		"CRV": "CRV",
		"crv": "CRV",
		"ctn_plt": "CTN/PLT",
		"currency_management": "Currency Management",
		"current_bin": "Current Bin",
		"current_inventory": "Current Inventory",
		"current_order_amount": "Current Order Amount",
		"current_order_total": "Current Order Total",
		"current_quantity": "Current Quantity",
		"current_target_inventory": "Current Target Inventory",
		"current_zone": "Current Zone",
		"cust_id": "Cust ID",
		"cust_name": "Cust. Name",
		"cust_no": "Cust No.",
		"cust_po": "Cust PO.",
		"customer": "Customer",
		"customer_group": "Customer Group",
		"customer_credit": "Customer Credit",
		"customer_credit_report": "Customer Credit Report",
		"customer_description": "",
		"customer_details": "Customer Details",
		"customer_id": "",
		"customer_information": "Customer Information",
		"customer_management": "",
		"customer_name": "Customer Name",
		"customer_name_colonsign": "Customer Name:",
		"customer_no": "Customer No.",
		"customer_note": "Customer Note",
		"customer_num": "Customer Num",
		"customer_num_colonsign": "Customer No.:",
		"customer_order_schedule": "Customer Order Schedule",
		"customer_price_level": "Customer Price Level",
		"customer_rma": "Customer RMA",
		"customer_return": "Customer Return",
		"customer_sales_history": "Customer Sales History",
		"customer_statement": "Customer Statement",
		"customers": "",
		"dashboard": "",
		"dashboard_v1": "",
		"dashboard_v2": "",
		"dashboard_v3": "",
		"date": "Date",
		"date_filter": "Date filter",
		"date_range": "Date Range",
		"dates": "Dates",
		"days": "Days",
		"dead": "Dead",
		"davis_po": "Davis PO",
		"decimal": "Decimal",
		"default_address": "Default Address",
		"default_bin": "Default Bin",
		"default_location": "Default Location",
		"default_location_colonsign": "Default Location:",
		"default_purchaser": "Default Purchaser",
		"default_sales": "Default Sales",
		"default_warehouse": "Default Warehouse",
		"default_warehouse_bin": "Default Warehouse Bin",
		"default_warehouse_zone": "Default Warehouse Zone",
		"default_zone": "",
		"default": "Default",
		"del": "DEL",
		"delayed": "Delayed",
		"delete": "Delete",
		"delete_file": "Delete File",
		"delete_product": "Delete Product",
		"delete_purchase_order": "Delete Purchase Order",
		"delete_purchase_template": "Delete Purchase Template",
		"delete_successful": "Delete Successful",
		"delete_user": "Delete User",
		"deleted": "Deleted",
		"deliver_date": "Deliver Date",
		"deliver_warehouse": "Deliver Warehouse",
		"delivered": "Delivered",
		"delivery_warehouse": "Delivery Warehouse",
		"desc": "Desc",
		"description": "Description",
		"mobile_description_box": "Mobile Description Box",
		"mobile_management": "Mobile Management",
		"multilevel_marketing": "Multilevel Sales",
		"detail": "Detail",
		"detailed_excel": "Detailed Excel",
		"detailed_information": "Detailed Information",
		"details": "Details",
		"details_&_convert": "",
		"details_&_repackage": "",
		"details_and_convert": "Details&Convert",
		"details_and_repackage": "Details & Repackage",
		"difference": "Diff",
		"dimension": "Dimension",
		"disable": "Disable",
		"disabled": "",
		"disc": "Disc",
		"discard_changes": "Discard Changes",
		"discontinue": "Discontinued",
		"discount": "Discount",
		"discount_description": "Discount Description",
		"dispatch": "Dispatch",
		"dispatch_date": "Dispatch Date",
		"dispatch_rma": "Dispatch RMA",
		"display": "Display",
		"distance": "Distance",
		"document_date": "Documented",
		"documented": "Documented",
		"done": "Done",
		"draft": "Draft",
		"driver": "Driver",
		"driver_license": "Driver License Number",
		"dropship": "Dropship",
		"ds": "DS",
		"dsco_shipment": "Dsco Shipment",
		"duplicate": "Duplicate",
		"duplicate_product": "Duplicate Product Found",
		"duplicate_product_promotion": "This product is being used in another promotion. Do you wish to add anyway?",
		"e_fax": "E Fax",
		"edit": "Edit",
		"edit_agent": "",
		"edit_bin": "",
		"edit_category": "Edit Category",
		"edit_customer": "Edit Customer",
		"edit_customer_confirm": "This action will void the current invoice and copy current invoice information to a new invoice. Continue?",
		"edit_customers": "Edit Customers",
		"edit_display_category": "Edit Display Categories",
		"edit_display_category_warning": "Must Create Product Before Editing",
		"edit_esl": "Edit ESL",
		"edit_group": "",
		"edit_groups": "",
		"edit_invoice": "Edit Invoice",
		"edit_password": "Edit Password",
		"edit_payment": "Edit Payment",
		"edit_payment_term": "Edit Payment Term",
		"edit_product": "Edit Product",
		"edit_product_meta": "Edit Product Meta Info",
		"edit_purchase": "Edit Purchase",
		"edit_purchase_order": "Edit Purchase Order",
		"edit_purchase_quote": "Edit Purchase Quote",
		"edit_purchase_return": "Edit Purchase Return",
		"edit_purchase_schedule": "Edit Purchase Schedule",
		"edit_purchase_template": "Edit Purchase Template",
		"edit_put_away": "Edit Put Away",
		"bol_list": "BOL List",
		"bol": "BOL",
		"edit_released_si": "",
		"edit_route": "",
		"edit_routes": "Edit Routes",
		"edit_sales_invoice": "",
		"Edit_sales_order": "",
		"edit_sales_order": "",
		"edit_so": "Edit SO",
		"edit_user": "",
		"edit_username": "Edit Username",
		"edit_vendor": "Edit Vendor",
		"edit_warehouse": "Edit Warehouse",
		"edit_zone": "",
		"effect": "Effect",
		"effect_date": "Effect Date",
		"ein": "EIN",
		"email": "Email",
		"email_address": "Email Address",
		"email_colonsign": "Email:",
		"email_po": "Email PO",
		"email_so": "Email SO",
		"employee_note": "Employee Note",
		"enabled": "Enabled",
		"end": "End",
		"end_date": "End Date",
		"english": "",
		"eng_name": "ENG Name",
		"chi_name": "CHI Name",
		"enter_email_of_driver": "Enter the email of your driver",
		"error": "Error",
		"ESL": "ESL",
		"esl_code": "ESL Code",
		"esl_template": "ESL Template",
		"est_date": "Est Date",
		"est_delivery": "Est Delivery",
		"is_no_reduce": "No Stock Deduction",
		"est_receive_date": "Est Receive Date",
		"est_sale_price": "Est Sale Price",
		"et_sale_total": "Est Sale Total",
		"eta_date": "ETA Date",
		"excel": "Excel",
		"exit": "Exit",
		"expire_date": "Expire Date",
		"expired_date": "Expired Date",
		"expire_datetime": "Expire Date (MM-DD-YYYY)",
		"expired_inventories": "Expired Inventories",
		"expired_warning": "Expired Warning",
		"expiring": "Expiring",
		"export": "Export",
		"export_date": "Expired Date",
		"export_inventories": "Export Inventories",
		"export_to_excel": "Export to Excel",
		"export_line": "Export Line",
		"faq": "FAQ",
		"favorite_items": "",
		"favorite_list": "",
		"favorite_product_list": "Favorite Product List",
		"favorites_list": "Favorites List",
		"fax": "Fax",
		"fax_colonsign": "Fax:",
		"field": "Field",
		"file": "File",
		"fill_with_latest_value": "Fill With Last Values",
		"filter": "Filter",
		"final": "Final",
		"final_dollarsign": "Final $",
		"final_weight": "",
		"final_wt": "Final Wt.",
		"finalize": "Finalize",
		"finalize_invoice": "Finalize Invoice",
		"finalize_si": "",
		"finalized": "Finalized",
		"finish": "Finish",
		"Finish_Shipping": "Finish Shipping ",
		"first_name": "First Name",
		"fob": "FOB",
		"fob_unit_price": "Fob Unit Price",
		"free": "Free",
		"frequent_products": "Frequent Products",
		"Fri": "Fri",
		"fri_route": "Fri Route",
		"fri_stop": "Fri Stop",
		"from": "From",
		"from_bin": "",
		"full_list_table_sales_invoice": "",
		"full_list_table_sales_order": "Full List Table | Sales Order",
		"gv_rewards": "GV Rewards",
		"general": "General",
		"general_dashboard": "General Dashboard",
		"general_information": "General Information",
		"general_management": "General Management",
		"general_no": "General No.",
		"generate_barcode": "Generate Barcode",
		"generate_all_barcode": "Generate All Barcode",
		"generate_all_zone_barcode": "All Zone Barcode",
		"index_no": "Index No.",
		"general_product_convert": "General | Product Convert",
		"general_product_repackage": "General|Product Repackage",
		"general_report": "General Report",
		"get": "Get",
		"gift_quantity": "Product Gift Quantity",
		"gift_quantity_column": "Gift Quantity",
		"good": "Good",
		"Good_Credit": "Good Credit",
		"grand_total": "Grand Total",
		"group": "Group",
		"group_wholesale": "Wholesale",
		"group_buy": "Group Buy",
		"group_list": "Group List",
		"group_name": "Group Name",
		"groups": "Groups",
		"groups_management": "Groups Management",
		"gtin": "GTIN",
		"handling": "Handling",
		"handling_cost": "Handling Cost",
		"hmart_barcode": "HMart Code",
		"hold": "Hold",
		"id": "ID",
		"idx": "IDX",
		"Image": "Image",
		"image_2": "Image #2",
		"image_size_limit": "Each file size cannot exceed 7mb.",
		"import": "Import",
		"in_stock": "In Stock",
		"in_stock_colonsign": "In Stock:",
		"in_stock_inactive": "In Stock / Inactive",
		"inactive": "Inactive",
		"inbound": "Inbound",
		"inbound_area": "",
		"inbound_plt": "Inbound PLT",
		"insert_new_product_in_favorite_list": "",
		"instock": "In Stock",
		"inbound_products": "Inbound Products",
		"nbt_rewards": "NBT Rewards",
		"isa_num": "ISA Num",
		"dl_num": "DL Num",
		"internal_barcode": "Internal Barcode",
		"inv_cost": "Inv. Cost",
		"inventories": "Inventories",
		"inventory": "Inventory",
		"inv": "Inv.",
		"inventory_adjust_sheet_warehouse_loc": "Inventory Adjustment Sheet | Warehouse Location",
		"inventory_adjust_warehouse_loc": "Inventory Adjustment | Warehouse Location",
		"inventory_adjustment": "Inventory Adjustment",
		"inventory_adjustment_sheet": "Inventory Adjustment Sheet",
		"inventory_adjustments": "Inventory Adjustments",
		"inventory_convert": "Inventory Convert",
		"inventory_convert_sheet": "Inventory Convert Sheet",
		"inventory_convert_sheet_warehouse_location": "Inventory Convert Sheet | Warehouse Location",
		"inventory_convert_warehouse_location": "Inventory Convert | Warehouse Location",
		"inventory_converts": "Inventory Converts",
		"inventory_detail": "Inventory Detail",
		"inventory_details": "Inventory Details",
		"inventory_expired_passed_due": "INVENTORY EXPIRED/PASSED DUE",
		"inventory_information": "Inventory Information",
		"inventory_number": "",
		"inventory_price": "Inventory Price",
		"inventory_receive": "Inventory Receive",
		"inventory_receive_details": "Inventory Receive Details",
		"inventory_receive_information": "Inventory Receive Information",
		"inventory_receive_sheet": "Inventory Receive Sheet",
		"inventory_relocation": "Inventory Relocation",
		"inventory_relocation_sheet": "Inventory Relocation Sheet",
		"inventory_relocation_sheet_warehouse_location": "Inventory Relocation Sheet|Warehouse Location",
		"inventory_relocation_warehouse_location": "Inventory Relocation | Warehouse Location",
		"inventory_relocations": "Inventory Relocations",
		"inventory_repackage": "Inventory Repackage",
		"inventory_repackage_sheet": "Inventory Repackage Sheet",
		"inventory_repackage_warehouse_loc": "Inventory Repackage|Warehouse Location",
		"inventory_scrap": "Inventory Scrap",
		"inventory_scrap_sheet": "Inventory Scrap Sheet",
		"inventory_scrap_sheet_warehouse_location": "Inventory Scrap Sheet|Warehouse Location",
		"inventory_scrap_warehouse_location": "Inventory Scrap|Warehouse Location",
		"inventory_transfer": "Inventory Transfer",
		"invoice": "",
		"invoice_amount": "Invoice Amount",
		"invoice_date": "",
		"invoice_date_colonsign": "Invoice Date:",
		"invoice_final_dollarsign": "Invoice Final $",
		"invoice_no": "Invoice No.",
		"invoice_no_colonsign": "Invoice No.:",
		"invoice_not_received": "INVOICE NOT RECEIVED",
		"invoice_total": "",
		"invoice_type": "Invoice Type",
		"invoice_vendor": "Vendor Invoice",
		"invoiced": "Invoiced",
		"invoiced_cost": "INVOICED / COST",
		"invoices_not_finalized": "Invoices Not Finalized",
		"is_at_inbound_area": "",
		"is_at_outbound_area": "",
		"is_dropship": "Is Dropship",
		"is_enabled": "Enabled*",
		"is_public": "Is Public",
		"issue_credit": "Issue Credit",
		"issue_return": "Issue Return",
		"item_count": "Item Count",
		"Item_is_out_of_stock": "Item is out of Stock",
		"item_name": "",
		"item_no": "Item No.",
		"lang": "Lang",
		"large_label_mac": "L-MAC",
		"large_label_win": "L-WIN",
		"last_dollarsign": "Last $",
		"last_modified_by": "Last Modified By",
		"last_month": "Last Month",
		"last_name": "Last Name",
		"lb": "lb",
		"level": "Level",
		"levels": "Levels",
		"level_1": "Level 1",
		"level_2": "Level 2",
		"level_3": "Level 3",
		"level_4": "Level 4",
		"level_5": "Level 5",
		"lg": "Lg",
		"limit": "Display Limit",
		"limit_qty_order": "Limited Qty/Order",
		"limit_qty_order_desc": "(Zero means no restrictions)",
		"link_existing_prod": "Link Existing Prod",
		"linked_so_no": "",
		"list_of_adjustment_lines": "List of Inventory Adjustment Lines",
		"list_of_inventory_convert_lines": "List of Inventory Convert Lines",
		"list_of_inventory_relocation_lines": "List of Inventory Relocation Lines",
		"list_of_inventory_repackage_lines": "",
		"list_of_inventory_scrap_lines": "List of Inventory Scrap Lines",
		"list_of_repackage_lines": "List of Inventory Repackage Lines",
		"loaded_qty": "Loaded Qty",
		"loaded_quantity": "Loaded Quantity",
		"location": "Location",
		"location_bin": "Bin",
		"login": "",
		"login_in": "Login",
		"logo": "Logo",
		"logout": "",
		"low_stock": "Low Stock",
		"low_stock_inventories": "Low Stock Inventories",
		"low_stock_inventory": "Low Stock Inventory",
		"lowest_amount": "Lowest Amount",
		"lowest_amt": "",
		"lowest_sale_dollarsign": "Lowest Sale $",
		"lv1": "Lv1",
		"lv2": "Lv2",
		"lv3": "Lv3",
		"lv4": "Lv4",
		"lv5": "Lv5",
		"mailing": "Mailing",
		"mailing_address": "Mailing Address",
		"mailing_contact": "Mailing Contact",
		"mailing_contact_information": "Mailing Contact Information",
		"mailing_details": "Mailing Details",
		"mailing_information": "Mailing Information",
		"manage_active_users": "Manage Active Users",
		"manage_customers": "Manage Customers",
		"manage_promotions": "Manage Promotions",
		"march": "March",
		"margin": "Margin",
		"match": "Match",
		"max": "",
		"max_limit": "Max Limit",
		"max_limit_colonsign": "Max Limit:",
		"max_stock_range": "Max Stock Range",
		"measure": "Measure",
		"measure_unit": "",
		"memo_no": "Memo No.",
		"memo_poundsign": "Memo #",
		"merchant_report": "Merchant Report",
		"merchant_summary": "Merchant Summary",
		"meta_info": "Meta Info",
		"method": "Method",
		"middle_name": "Middle Name",
		"min": "",
		"min_purchase_amount": "Min Purchase Amount",
		"min_limit": "Min Limit",
		"min_limit_colonsign": "Min Limit:",
		"min_stock_range": "Min Stock range",
		"misc": "Misc",
		"misc_cost": "",
		"misc_cost_detail": "",
		"misc_cost_details": "Misc Cost Details",
		"misc_detail": "Misc Detail",
		"misc_dollarsign": "Misc $",
		"misc_fee": "Misc Fee",
		"mix_product": "Mix Product",
		"mix_setting": "Mix Setting",
		"mm": "MM",
		"mm_type": "MM Type",
		"mm_unit": "MM Unit",
		"mobile": "Mobile",
		"mobile_customer_statement": "Mobile Customer Statement",
		"mobile_dollarsign": "Mobile $",
		"mobile_sale": "Mobile Sale",
		"mobile_sales_order": "Mobile Sales Order",
		"mobile_username": "Mobile Username",
		"mobile_users": "Mobile Users",
		"modified": "Modified",
		"modified_by": "Modified By",
		"modified_on": "Modified On",
		"modified_time": "Modified Time",
		"modifier": "Modifier",
		"modify": "Modify",
		"modify_inventory": "Modify Inventory",
		"modify_username": "Modify Username",
		"Mon": "Mon",
		"mon_route": "Mon Route",
		"mon_stop": "Mon Stop",
		"month": "Month",
		"Monthly": "Monthly",
		"more_info": "More Info",
		"move_off": "Move Off",
		"move_off_from_list": "Move off from list",
		"move_off_from_products_list": "Move off From Products List",
		"move_off_products_list": "Move Off Products List",
		"move_to": "Move To",
		"move_to_list": "move to list",
		"move_to_po": "Move To PO",
		"move_to_product_list": "",
		"move_to_products_list": "",
		"move_to_so": "Move to SO",
		"move_to_so_list": "",
		"move_all": "Move All",
		"general_info": "General Information",
		"pickdrop_info": "Pickup/Dropoff Information",
		"pickdrop": "Pickup/Dropoff",
		"move_selected": "Move Selected",
		"msg_po_to_so_dropship": "Confirm SO to PO (Davis)?",
		"pride_msg_print_shipping": "Warning: There are existing tracking numbers in selections. Continuing will overwrite them with new tracking numbers.",
		"msg_add_duplicate_item": "You are adding a duplicate item",
		"msg_assign_customer": "Assign current order to customer:",
		"msg_agree_terms": "I agree with terms.",
		"msg_ask_for_manager_login": "Type in manager's username and password",
		"msg_ask_if_stay_on_current_page": "Do you want to stay on the current page?",
		"msg_confirm_add_customer_to_group": "Adding this customer to this group will remove them from their previous group. Are you sure?",
		"msg_confirm_change_group_without_save_products": "Are you sure you want to change groups without saving your products?",
		"msg_confirm_delete": "Are you sure you want to delete?",
		"msg_confirm_merge_pos": "Are you sure you want to merge these purchase orders?",
		"msg_confirm_print_tracking": "Order has existing Tracking Number. Continue to print label?",
		"msg_confirm_refund_order": "Are you sure you want to refund order?",
		"msg_confirm_reship": "Are you sure you want to reship order?",
		"msg_confirm_quote": "Confirm set Quotes to Sales Orders?",
		"passcode_confirm": "Please confirm your passcode",
		"your_passcode_is_not_correct": "Passcode is not correct",
		"msg_convert_qty_cannot_exceed_current_qty": "Conversion quantity cannot be higher than current quantity",
		"msg_drag_drop_attachment": "Drop some files here, or click to select files to upload.",
		"msg_drop_upload_files": "Try dropping some files here, or click to select files to upload.",
		"msg_enter_scrap_amount_and_inventory_will_be_updated": "Enter the scrap amount below and the inventory will be updated accordingly",
		"msg_export_order_stats": "Exporting user stats could take up to 1 minute, please stay on the page",
		"msg_grand_total_equation": "* Grand Total = Total - Canceled",
		"msg_inventory_price_equation": "* Inventory Price = Avg Cost × Stock",
		"msg_item_already_in_sales_order": "This item is already in the sales order",
		"msg_large_prod": "Case (Large Prod)",
		"msg_no_permission": "You don't have permission for this operation.",
		"msg_operation_saved": "Your operation has been saved",
		"msg_please_select_a_vendor": "Please Select a Vendor",
		"msg_product_image_modal_desc": "* Please save your work before closing the window",
		"msg_products_loaded_click_save_to_complete": "All products are loaded. Press save to complete the order.",
		"msg_purchase_order_num_is": "The purchase order No. is",
		"msg_purchase_order_saved": "Your purchase order has been saved",
		"msg_purchase_quote_generated": "Your purchase quote is generated",
		"msg_purchase_quote_saved": "Your purchase quote has been saved",
		"msg_purchase_template_saved": "Your purchase template has been saved",
		"msg_relocation_qty_cannot_exceed_current_qty": "Relocation quantity cannot be higher than current quantity",
		"msg_repackage_qty_cannot_exceed_current_qty": "Repackage Quantity cannot be Higher than current Quantity",
		"msg_scrap_qty_cannot_exceed_current_qty": "Scrap Quantity cannot be Higher than current Quantity",
		"msg_select_a_group": "Select a Group",
		"msg_select_a_purchase_template": "Select a purchase template",
		"msg_select_an_inventory_as_target": "Select an inventory as target",
		"msg_select_an_inventory_to_adjust": "Select an inventory to adjust",
		"msg_select_an_inventory_to_convert": "Select an inventory to convert",
		"msg_select_an_inventory_to_relocate": "Select an inventory to relocate",
		"msg_select_an_inventory_to_repackage": "Select an inventory to repackage",
		"msg_select_an_item": "Select an item",
		"msg_select_customer": "Select customer",
		"msg_select_from_batch": "Select from batch",
		"msg_select_warehouse": "Select warehouse",
		"msg_select_warehouse_bin": "Select warehouse bin",
		"msg_select_warehouse_zone": "Select warehouse zone",
		"msg_show_action_log_from_last_90_days": "* Showing action logs from last 90 days",
		"msg_small_prod": "Piece (Small Prod)",
		"msg_total_orders_equation": "* Total Orders = Number of Orders - Canceled Orders",
		"MSO": "MSO",
		"n1_prod_qty": "N1 Prod Qty",
		"n2_prod_qty": "N2 Prod Qty",
		"name": "Name",
		"nationwide": "Nationwide",
		"need_to_signup": "Need To Sign Up?",
		"negative": "Negative",
		"net": "Net",
		"net_cost": "Net Cost",
		"net_receiving": "Net Receiving",
		"net_weight": "Net Weight",
		"net_wt": "Net Wt",
		"new_password": "New Password",
		"new_purchase_order": "New Purchase Order",
		"new_purchase_quote": "New Purchase Quote",
		"new_purchase_template": "New Purchase Template",
		"new_quantity": "New Quantity",
		"new_receiving": "New Receiving",
		"new_sales_order": "New Sales Order",
		"new_sales_return": "New Sales Return",
		"new_scrap_record": "New Scrap Record",
		"new_series_no": "New Series No.",
		"new_so": "New SO",
		"new_username": "New Username",
		"new_value": "New Value",
		"new_working_orders": "New Working Order",
		"next_execute_date": "Next Execute Date",
		"prev_page": "< Prev",
		"next_page": "Next >",
		"No": "No",
		"no": "No",
		"no_bin_range": "No Bin Range",
		"no_invoice": "",
		"no_pickup": "",
		"no_mix_product": "No Mixed Products",
		"no_shipping_address": "No Shipping Address",
		"no_shipping_information": "No Shipping Information",
		"no_vendor": "",
		"non_fixed": "Non-Fixed",
		"non_food": "Non Food",
		"non_zero": "Non-Zero",
		"none": "None",
		"not_shipped_quantity": "Unshipped",
		"not_yet_received": "Not Yet Received",
		"notation": "Notation",
		"note": "Note",
		"notes_for_pos": "Notes For POS",
		"notes_for_sales": "Notes For Sales",
		"num": "Num",
		"number": "Number",
		"number_of_card_transactions": "Number of Card Transactions",
		"number_of_checks": "Number of Checks",
		"off_stock": "Out of Stock",
		"offrate": "Offrate",
		"old_value": "Old Value",
		"on_hold": "On Hold",
		"on_fleet": "Onfleet",
		"on_sale": "On Sale",
		"on_stock": "On Stock",
		"one_time": "One Time",
		"one_time_schedule": "One Time Schedule",
		"one_time_use": "One Time Use",
		"oops": "Oops",
		"open": "Open",
		"open_draft": "Open Draft",
		"open_sales_orders": "Open Sales Orders",
		"optional": "Optional",
		"order": "Order",
		"order_amount": "Order Amount",
		"order_count_overview": "Orders Count Overview",
		"order_date": "Order Date",
		"order_history": "",
		"order_num": "Order No.",
		"order_qty": "Order Qty",
		"order_stats": "Order Stats",
		"order_status": "",
		"order_total": "Order Total",
		"order_total_dollarsign": "Order Total (USD)",
		"order_type": "Order Type",
		"order_unit": "Order Unit",
		"order_unit_dollarsign": "Order Unit (USD)",
		"ordered": "Ordered",
		"orders": "Orders",
		"out_of_stock": "Out of Stock",
		"out_of_stock_active": "Out of Stock / Active",
		"outbound": "",
		"outbound_area": "",
		"outbound_plt": "Outbound PLT",
		"outstanding": "Outstanding",
		"outstanding_invoice": "",
		"outstanding_order": "",
		"over_stock": "Over Stock",
		"oversaleable": "Oversaleable",
		"owner": "Owner",
		"package": "Package",
		"package_details": "Package Details",
		"package_dimension_shipping": "Pkg Dim Shipping",
		"package_size": "Pkg Size",
		"packageSize": "Package Size",
		"package_slashsign_weight": "Package / Weight",
		"package_type": "Pkg Type",
		"package_weight_shipping": "Pkg Wt Shipping",
		"packaging_details": "Packaging",
		"packing": "Packing",
		"packing_num": "Packing No.",
		"paid_dollarsign": "Paid $",
		"pallet": "Pallet",
		"partial": "Partial",
		"pass": "Pass",
		"passed_due": "Passed Due",
		"password": "Password",
		"payment": "Payment",
		"payment_amount": "payment amount",
		"payment_date": "Payment Date",
		"payment_detail": "Payment Detail",
		"payment_details": "Payment Details",
		"payment_info": "Payment Info",
		"payment_method": "Payment Method",
		"payment_status": "",
		"payment_summary": "Payment Summary",
		"payment_term": "Payment Term",
		"payment_term_name": "",
		"payment_terms_management": "Payment Terms Management",
		"payment_type": "Payment Type",
		"pc_box": "PC/Box",
		"pcs_ctn": "PCS/CTN",
		"per_pallet": "Per Pallet",
		"per_pound": "Per-Pound",
		"percentsign_off": "% Off",
		"permission_name": "Permission Name",
		"phone": "Phone",
		"pickup": "",
		"pickup_contact": "Pickup Contact",
		"pickup_poundsign": "Pickup #",
		"pickup_vendor_address": "Pickup Vendor Address",
		"pickup_warehouse": "Pickup Warehouse",
		"pickup_warehouse_name": "Pickup Warehouse Name",
		"piece (small prod)": "Piece (Small Prod)",
		"piece": "Piece",
		"pkg_type": "Pkg Type",
		"pkg_size_1": "Pkg Size 1",
		"pkg_size_2": "Pkg Size 2",
		"place_new_order": "Place New Order",
		"placed": "Placed",
		"plain_statement": "Plain Statement",
		"please_enter_a_valid_email": "Please enter a valid email!",
		"please_select_an_end_date_that_is_after_the_start_date": "Please select an end date that is after the start date.",
		"please_select_a_start_date_that_is_before_the_end_date": "Please select a start date that is before the end date.",
		"please_select_a_contact": "",
		"please_select_a_customer": "Please Select A Customer",
		"please_select_a_product": "Please Select a Product",
		"please_select_an_inventory": "Please select an inventory",
		"please_select_category": "Please Select Category",
		"please_select_group": "Please Select a Group",
		"please_select_inventory": "Please Select an Inventory",
		"plt_barcode": "PLT Barcode",
		"plt_qty": "PLT Qty",
		"pmt_date": "PMT Date",
		"pmt_status": "Payment Status",
		"po_date": "PO Date",
		"po_details": "PO Details",
		"po_final": "PO Final",
		"po_final_dollarsign": "PO Final $",
		"po_info": "PO Info",
		"po_num": "PO No.",
		"po_purchase_status": "PO Purchase Status",
		"po_scheduled_arrival": "PO Scheduled Arrival",
		"po_scheduled_to_arrive": "PO Scheduled to Arrive",
		"po_status": "PO Status",
		"po_total": "PO Total",
		"poor": "Poor",
		"pos": "POS",
		"pos_management": "POS Management",
		"pos_credit": "POS Credit",
		"pos_order": "POS Order",
		"pos_order_credits": "POS Credit Full Table",
		"pos_order_full_table": "POS Order Full Table",
		"pos_report": "POS Report",
		"posting_date": "Posting",
		"pr_no": "PR NO",
		"presale": "Presale",
		"presale_colonsign": "Presale:",
		"president_dashboard": "President Dashboard",
		"press_enter_for_emails": "Press Enter for more emails",
		"press_enter_for_phones": "Press Enter for more phones",
		"press_enter_to_confirm_weights": "Press Enter to Confirm Weights",
		"preview": "",
		"previous": "Previous",
		"previous_orders": "",
		"price": "",
		"price_1": "Price 1",
		"price_2": "Price 2",
		"price_3": "Price 3",
		"price_4": "Price 4",
		"price_adjustment": "Price Adjustment",
		"price_adjustment_chart": "Price Adjustment Chart",
		"price_level": "",
		"price_level_percent": "Price Level Percent",
		"sales_price_levels": "Sales Price Levels",
		"sales_type": "Sales Type",
		"price_lvl": "Price LvL",
		"price_range_warning": "Input passcode to confirm your identity to process the previous action",
		"price_reference": "Price Reference",
		"price_reference_chart": "Price Reference Chart",
		"print": "Print",
		"print_barcode": "Print Barcode",
		"print_bol": "Print BOL",
		"print_general_information": "Print General Information",
		"print_invoice": "Print Invoice",
		"print_label": "Print Label",
		"print_new_label": "Print New Label",
		"print_no": "Print No",
		"print_ns": "Print No $",
		"print_picking_list": "Print Picking List",
		"print_po": "Print PO",
		"print_purchase_order": "Print Purchase Order",
		"print_purchase_payment": "Print Purchase Payment",
		"print_reminder": "Print Reminder",
		"print_shipping": "Print Shipping",
		"print_shipping_sheet": "Print Shipping Sheet",
		"print_si": "Print SI",
		"print_so": "Print SO",
		"print_specifications": "Print Specifications",
		"print_statements": "Print Statements",
		"printing_information": "Printing Information",
		"process_purchase_return": "Process Purchase Return",
		"process_sales_return": "Process Sales Return",
		"processing_fee": "Processing Fee",
		"prod2_desc": "Prod 2 Desc",
		"prod2_name": "Prod 2 Name",
		"prod2_num": "Prod 2 No.",
		"prod2_qty": "Prod 2 Qty",
		"prod2_ref_num": "Prod 2 Ref No.",
		"prod_barcode": "Prod Barcode",
		"prod_cost": "Prod Cost",
		"prod_group": "Prod Group",
		"prod_name": "Prod Name",
		"prod_num": "Prod No.",
		"prod_type": "Prod Type",
		"product": "Product",
		"product_a": "Purchase Product (A)",
		"product_b": "Gift Product (B)",
		"product_barcode": "Product Barcode",
		"product_categories": "",
		"product_category_1": "",
		"product_category_2": "",
		"product_convert": "Product Convert",
		"product_convert_page": "Product Convert Page",
		"product_cost": "Product Cost",
		"product_cost_and_price": "Product Cost and Price",
		"product_description": "",
		"product_detail": "",
		"product_details": "Product Details",
		"product_does_not_exist": "Product Does Not Exist",
		"product_filter": "Product",
		"product_group": "",
		"product_group_and_category": "Product Group and Category",
		"product_groups": "Product Groups",
		"product_information": "Product Information",
		"product_list": "Product List",
		"product_location_detail": "Product Location Detail",
		"product_management": "",
		"product_name": "Product Name",
		"product_not_found": "Product not found.",
		"product_num": "Product No.",
		"product_num_ref_num": "Prod No./Ref No.",
		"product_price": "Product Price",
		"product_purchased": "Product Purchased",
		"product_repackage_sheet_product_repackage": "Product Repackage Sheet|Product Repackage",
		"product_sku": "Product SKU",
		"sku": "SKU",
		"product_to_return": "Product to Return",
		"product_type": "",
		"product_unit_of_measure": "",
		"product_unit_weight_price": "Product Unit Weight Price",
		"products": "",
		"products_list": "Products List",
		"profile": "",
		"profit": "",
		"profit_percentage": "",
		"profit_pl": "Profit",
		"promo": "Promo",
		"promo_code": "Promo Code",
		"promotion": "",
		"promotion_management": "Promotion Management",
		"promotion_name": "Promotion Name",
		"promotions": "",
		"Proposition65": "Proposition 65",
		"puchase_payment_detail": "Purchase Payment Detail",
		"pull_sheet_format": "Pull Sheet Format",
		"purchase": "Purchase",
		"purchase_dashboard": "",
		"purchase_date": "",
		"purchase_date_colonsign": "Purchase Date:",
		"purchase_information": "",
		"purchase_management": "Purchase Management",
		"purchase_no": "Purchase No.",
		"purchase_order": "Purchase Order",
		"purchase_order_date": "Purchase Order Date",
		"purchase_order_dates": "Purchase Order Dates",
		"purchase_order_detail": "Purchase Order Detail",
		"purchase_order_details": "Purchase Order Details",
		"purchase_order_expect_coming_today": "Purchase Order Expect Coming Today",
		"purchase_order_full_list": "Purchase Order Full List",
		"purchase_order_full_table": "Purchase Order Full Table",
		"purchase_order_no": "Purchase Order No.",
		"purchase_order_not_received": "Purchase Order Not Received",
		"purchase_order_number": "Purchase Order Number: ",
		"purchase_order_receive_rate": "Purchase Order Receive Rate",
		"purchase_order_requires_products": "purchase order requires products",
		"purchase_orders_arrive_today": "Purchase Orders Scheduled To Arrive",
		"purchase_payment": "Purchase Payment",
		"purchase_payment_details": "Purchase Payment Details",
		"purchase_payments": "Purchase Payments",
		"purchase_performance": "Purchase Performance",
		"purchase_pivot": "Purchase Pivot",
		"purchase_pivot_chart": "Purchase Pivot Chart",
		"purchase_quote": "Purchase Quote",
		"purchase_quote_details": "Purchase Quote Details",
		"purchase_quote_full_table": "Purchase Quote Full Table",
		"purchase_reference": "Purchase Reference",
		"purchase_reference_report": "Purchase Reference Report",
		"purchase_report": "Purchase Report",
		"purchase_return": "Purchase Return",
		"purchase_return_details": "Purchase Return Details",
		"purchase_return_list": "Purchase Return List",
		"purchase_return_num": "Purchase Return Num",
		"purchase_sales": "RECEIVED / INVOICED",
		"purchase_schedule": "Purchase Schedule",
		"purchase_statistics": "Purchase Statistics",
		"purchase_status": "",
		"purchase_template": "Purchase Template",
		"purchase_template_details": "Purchase Template Details",
		"purchase_template_full_table": "Purchase Template Full Table",
		"purchase_template_must_have_products": "purchase template must have products",
		"purchase_template_no": "Purchase Template No.",
		"purchase_template_unavailable": "Purchase Template Unavailable",
		"purchase_user": "Purchase User",
		"purchased": "Purchased",
		"purchased_by": "",
		"purchased_colonsign": "Purchased:",
		"purchaser": "Purchaser",
		"purchaser_name": "",
		"purchasing": "",
		"purchasing_performance": "Purchasing Performance",
		"put_away": "",
		"put_away_form": "",
		"put_away_list": "Put Away List",
		"put_away_num": "Put Away Num",
		"putaway_quantity": "",
		"qty": "Qty",
		"qty_from": "Qty From",
		"pod": "POD",
		"upload_pod": "Upload POD",
		"delete_double": "Delete (double-click)",
		"qty_to": "Qty To",
		"delivery_pickup": "Delivery/Pickup",
		"margin$": "Margin %",
		"discount_$": "Discount $",
		"discount_rate_%": "Discount Rate %",
		"quantity": "Quantity",
		"quantity_cannot_have_a_zero_value": "Quantity cannot have a zero value.",
		"quantity_colonsign": "Quantity:",
		"quantity_weight": "Qty / Wt",
		"quarter": "Quarter",
		"quick_actions": "Quick Actions",
		"quote_reference": "Quote Reference",
		"quote_reference_chart": "Quote Reference Chart",
		"quote_reference_chart_detail": "Quote Reference Chart Detail",
		"range": "Range",
		"rate": "Rate",
		"rcv_qty": "Rcv Qty",
		"rcv_box": "Rcv Box",
		"rcv_quantity": "Rcv Quantity",
		"rcv_total_price": "Rcv Total Price",
		"reading_data": "Reading Data",
		"reason_for_return": "Reason for Return",
		"receipt": "Receipt",
		"receipt_no": "Receipt No.",
		"receive": "",
		"receive_all": "Receive All",
		"receive_date": "Receive Date",
		"receive_detail": "",
		"receive_dollarsign": "Receive $",
		"receive_final_dollarsign": "Receive Final $",
		"receive_history": "Receive History",
		"receive_history_detail": "",
		"receive_list": "Receive List",
		"receive_num": "Receive No.",
		"receive_qty": "Receive Qty",
		"receive_total_dollarsign": "Receive Total $",
		"receive_total_price": "",
		"receive_total_wt": "Receive Total Wt",
		"receive_unit_dollarsign": "Receive Unit $",
		"receive_unit_price": "",
		"received": "Received",
		"received_qty": "Received QTY",
		"received_box_qty": "Received Box QTY",
		"received_case_qty": "Received Case QTY",
		"received_unit_qty": "Received Unit QTY",
		"receiver": "Receiver",
		"receiving": "Receiving",
		"receiving_date": "Receiving Date",
		"receiving_details": "Receiving Details",
		"receiving_history": "Receiving History",
		"receiving_information": "Receiving Information",
		"receiving_list": "Receiving List",
		"record_adjustment_no": "Record (Adjustment) No.",
		"record_convert_no": "Record (Convert) No.",
		"record_relocation_no": "",
		"record_repackage_no": "Record (Repackage) No.",
		"record_scrap_no": "Record Scrap NO",
		"recreate": "Recreate",
		"refresh_system": "Refresh System",
		"confirm_refresh": "Confirm reload and refresh system?",
		"ref_barcode": "Ref Barcode",
		"ref_cost": "Ref Cost",
		"ref_price": "Ref Price",
		"ref_cost_price": "Ref Cost Price",
		"ref_dollarsign": "Ref $",
		"ref_num": "Ref No.",
		"item_num": "Item No.",
		"ref_purchasing_price": "",
		"refer_purchasing_price": "Ref Price",
		"refund": "Refund",
		"refund_amount": "refund amount",
		"refund_successful": "Refund Successful",
		"related": "Related",
		"related_no": "Related No.",
		"related_product": "Related Product",
		"release": "Release",
		"released": "Released",
		"relocate": "Relocate",
		"relocate_quantity": "Relocate Quantity",
		"relocate_some_or_all_of_the_selected_inventory": "Relocate some or all of the selected inventory",
		"relocate_user": "",
		"relocation": "Relocation",
		"relocation_date": "",
		"relocation_destination": "Relocation Destination",
		"relocation_quantity": "Relocation Quantity",
		"remark": "Remark",
		"remember_me": "Remember Me",
		"remove": "Remove",
		"remove_from_so_list": "",
		"repackage": "Repackage",
		"repackage_date": "Repackage Date",
		"repackage_destination": "Repackage Destination",
		"repackage_quantity": "Repackage Quantity",
		"repackage_target_quantity": "Repackage Target Quantity",
		"repackage_user": "Repackage User",
		"repeat_frequency": "Repeat Frequency",
		"repeat_interval": "Repeat Interval",
		"repeat_on": "Repeat On",
		"report": "Report",
		"resale_no": "Resale No",
		"reseller": "Reseller",
		"reset_all": "Reset All",
		"reset_email": "Reset Email",
		"reset_password": "Reset Password",
		"reship": "Reship",
		"restocking_fee": "Restocking Fee",
		"return": "",
		"rtned_qty": "Returned QTY",
		"return_date": "Return Date",
		"return_details": "Return Details",
		"return_no": "Return No.",
		"return_order_info": "Return Order Info",
		"return_qty": "Return Qty",
		"return_quantity": "",
		"return_reason": "Return Reason",
		"return_status": "Return Status",
		"return_this_product": "",
		"return_unit_price": "",
		"returns": "Returns",
		"retype_password": "Retype Password",
		"rewards": "Rewards",
		"rma": "RMA",
		"rma_form": "RMA Form",
		"rma_id": "RMA ID",
		"rma_num": "RMA No.",
		"role_management": "Role Management",
		"role_name": "Role Name",
		"route": "Route",
		"ob_status": "OB Status",
		"npi": "NPI #",
		"route_details": "Route Details",
		"route_num": "Route Num",
		"route_number": "Route Number",
		"routing": "",
		"rtn_quantity": "Rtn Quantity",
		"sale": "Sale",
		"sale_details": "Sale Details",
		"sale_dollarsign": "Sale $",
		"sale_invoice_details": "Sale Invoice Details",
		"sale_order_details": "Sale Order Details",
		"sale_price": "Sale Price",
		"sale_qty": "Sale Qty",
		"order_details": "Order Details",
		"CBM": "CBM",
		"saleable": "",
		"sales": "Sales",
		"sales_colonsign": "Sales:",
		"sales_cost": "Sales / Cost",
		"sales_dashboard": "Sales Dashboard",
		"sales_history": "Sales History",
		"sales_inventory_value": "Sales Value/Inventory Value",
		"sales_invoice": "",
		"sales_invoice_detail": "",
		"sales_invoice_details": "Sales Invoice Details",
		"sales_invoice_full_table": "",
		"sales_invoices_today": "Sales Invoices Today",
		"sales_management": "Sales Management",
		"sales_margin_percentsign": "Sales Margin %",
		"sales_margin_master_percentsign": "Sales Margin %",
		"sales_order": "Sales Order",
		"sales_order_dates": "Sales Order Dates",
		"sales_order_details": "Sales Order Details",
		"sales_order_full_table": "",
		"sales_order_list": "Sales Order List",
		"sales_order_no": "",
		"sales_order_rate": "Sales Order Rate",
		"sales_orders": "Sales Orders",
		"sales_orders_open": "Sales Orders Open",
		"sales_orders_ship_today": "Sales Orders Scheduled To Ship Today",
		"sales_performance": "Sales Performance",
		"sales_performance_list": "Sales Performance List",
		"sales_report": "Sales Report",
		"sales_return": "Sales Return",
		"sales_returned": "Sales Returned",
		"same_as_billing_address": "Same as Billing Address",
		"same_as_billing_contact": "Same as Billing Contact",
		"same_as_billing_information": "Same as Billing Information",
		"Sat": "Sat",
		"sat_route": "Sat Route",
		"sat_stop": "Sat Stop",
		"saturday": "Saturday",
		"save": "Save",
		"save_and_print": "Save and Print",
		"save_changes": "Save Changes",
		"save_draft": "Save Draft",
		"save_successful": "Save Successful",
		"save_weights": "Save Weights",
		"saved": "Saved",
		"saved_tracking_note": "Tracking Notation saved for this Purchase Order",
		"schedule_shipping_date": "",
		"scheduled": "Scheduled",
		"scheduled_to_ship": "Scheduled to Ship",
		"scheduled_shipping_date": "Scheduled Shipping Date",
		"scrap": "Scrap",
		"scrap_amount": "Scrap Amount",
		"scrap_date": "Scrap Date",
		"scrap_product_details": "Scrap Product Details",
		"scrap_qty": "Scrap Qty",
		"scrap_quantity": "Scrap Quantity",
		"scrap_record": "Scrap Record",
		"scrap_records": "Scrap Records",
		"scrap_some_or_all_of_the_selected_inventory": "Scrap Some or all of the Selected Inventory",
		"scrapping": "Scrapping",
		"service_code": "Service Code",
		"search": "Search",
		"new_inbound_order": "New Inbound Order",
		"pride_print": "Print Shipping Label",
		"inbound_order": "Inbound Order",
		"new_outbound_order": "New Outbound Order",
		"Outbound Order": "Outbound Order",
		"ib_excel_template": "IB Template",
		"LF_Date": "LF Date",
		"fba_route": "FBA Route",
		"search_by": "Search Product by:",
		"search_prod": "Search Product:",
		"search_prod_by": "Search Prod by:",
		"search_type": "Search Type:",
		"sectioned_list": "Sectioned List",
		"select": "Select",
		"select_a_product_to_scrap": "Select A Product To Scrap",
		"select_a_purchase_order": "Select a Purchase Order",
		"select_an_inventory_item": "",
		"select_customer_information": "Select Customer Information",
		"select_group": "Select Group",
		"select_inventory_to_scrap": "Select Inventory To Scrap",
		"select_purchase_template": "Select Purchase Template",
		"select_purchaser": "Select Purchaser",
		"select_receive_history": "",
		"select_seller": "Select Seller",
		"select_vendor": "Select Vendor",
		"selected_bins": "",
		"seller": "Seller",
		"set_order": "Set Order",
		"set_schedule": "Set Schedule",
		"set_various_weight": "",
		"set_weights": "Set Weights",
		"setting": "Setting",
		"share": "Share",
		"share_cost": "Share Cost",
		"sheet_not_completed_warning": "",
		"shelf_life": "Shelf Life",
		"shift_life_day": "Shift Life (Day)",
		"shelf_life_statistics": "Shelf Life Statistics",
		"ship_dollarsign": "Ship $",
		"ship_to": "Ship-To",
		"ship_to_address": "Ship To Address",
		"ship_date": "Ship Date",
		"ship_by": "Ship By",
		"ship_method": "Ship Method",
		"ship_weight": "Ship Wt",
		"ship_wt": "Ship Wt",
		"shipment_date": "",
		"shipped": "Shipped",
		"shipped_qty": "Shipped Qty",
		"shipped_case_qty": "Shipped Case Qty",
		"shipping": "",
		"shipping_address": "",
		"shipping_address_poundsign": "Shipping Address #",
		"shipping_cost": "",
		"shipping_cost_details": "Shipping Cost Details",
		"shipping_cost_information": "Shipping Cost Information",
		"shipping_date": "",
		"shipping_details": "Shipping Details",
		"shipping_dollarsign": "Shipping $",
		"shipping_fee": "Shipping Fee",
		"shipping_information": "Shipping Information",
		"shipping_method": "",
		"shipping_poundsign": "Shipping #",
		"shipping_weight": "Shipping Weight",
		"shipto": "Ship To",
		"show_as": "Show As",
		"show": "Show",
		"hide": "Hide",
		"show_finalized_si": "",
		"show_released_si": "",
		"show_price": "Show Price",
		"si_no": "SI No.",
		"si_dollarsign": "SI$",
		"si_payment": "SI Payment",
		"si_status": "SI Status",
		"sign_in_to_continue": "Sign In to Continue",
		"simplified_excel": "Simplified Excel",
		"simplified_statement": "Simplified Statement",
		"size": "Size",
		"sm": "Sm",
		"small_catch_weight": "Sm Catch Wt",
		"small_label_mac": "S-MAC",
		"small_label_win": "S-WIN",
		"small_net_weight": "Sm Net Wt",
		"small_product_no": "Sm Prod No.",
		"so_dollarsign": "SO$",
		"so_no": "SO No.",
		"so_scheduled_shipping": "SO Scheduled Shipping",
		"sold": "Sold",
		"so_to_po": "SO to PO",
		"space_not_enough_create_bins": "\"The space is not enough. Do you want to create new bins?\"",
		"space_not_enough_relocate": "\"The space is not enough. Do you want to relocate?\"",
		"specify": "Specify",
		"split_tracking_numbers": "Split Tracking Numbers",
		"spreadsheet": "Import Spreadsheet",
		"start": "Start",
		"start_date": "Start Date",
		"state": "State",
		"statement_range": "Statement Range",
		"status": "Status",
		"stock": "Stock",
		"stock_left_after_1_week": "Stock Left After 1 Week",
		"stock_range": "Stock Range",
		"stop": "Stop",
		"stop_purchase": "Stop Purchase",
		"stop_route": "Stop Route",
		"stop_sale": "Stop Sale",
		"stopsale": "",
		"storage_rate": "Storage Rate",
		"store_credit_dollarsign": "Store Credit $",
		"street": "",
		"sub_menu": "",
		"submit": "Submit",
		"subtitle": "",
		"subtotal": "Subtotal",
		"suite": "Suite",
		"success": "Success",
		"Sun": "Sun",
		"sun_route": "Sun Route",
		"sun_stop": "Sun Stop",
		"sync_scale": "Sync Scales",
		"sync_esl": "Sync ESL",
		"target_weight": "Target Weight",
		"tax": "",
		"Tax": "Tax:",
		"tax_code": "Tax Code",
		"tax_management": "Tax Management",
		"taxable": "",
		"tel": "Tel",
		"tel_colonsign": "Tel:",
		"telephone": "Telephone",
		"temperature": "Temperature",
		"template_name": "Template Name",
		"term_days": "Term Days",
		"term_type": "Term Type",
		"term_types": "",
		"test": "test",
		"this_group": "this group",
		"this_customer_is_already_in_the_group": "This customer is already in the group.",
		"thu_route": "Thu Route",
		"thu_stop": "Thu Stop",
		"Thur": "Thur",
		"thurs_route": "Thurs Route",
		"thurs_stop": "Thurs Stop",
		"to": "To",
		"to_bin": "To Bin",
		"to_zone": "To Zone",
		"tooltip_customer_bypass_payment": "Bypassing payments will let mobile users skip mobile payment, and pay with AR.",
		"tooltip_customer_manager": "Manager users can see all past orders for this business customer.",
		"today": "Today",
		"total": "Total",
		"total_amount": "Total Amount",
		"total_bin": "",
		"total_bins": "Total Bins",
		"total_credit": "Total Credit",
		"total_customers": "Total Customers",
		"total_dollarsign": "Total $",
		"total_inventory_price": "Total Inventory Price",
		"total_inventory_worth": "Total Inventory Worth",
		"total_invoice": "Total Invoice",
		"total_net_weight": "Total Net Weight",
		"total_net_wt": "Total Net Wt",
		"total_orders_today": "Total Orders Today",
		"total_pcs": "Total Pcs",
		"total_price": "Total Price",
		"total_price_colonsign": "Total Price:",
		"total_prod": "Total Prod",
		"total_purchases": "Total Purchases",
		"total_receive_price": "Total Receive Price",
		"total_return": "Total Return",
		"total_sale": "Total Sale",
		"total_sales_price": "Total Sales Price",
		"total_sales_worth": "Total Sales Worth",
		"total_ship_wt": "Total Ship Wt",
		"total_shipping_weight": "Total Shipping Weight",
		"total_shipping_weight_lbs": "Total Shipping Weight (lbs)",
		"total_size": "",
		"total_storage_day": "Total Storage Day",
		"total_unit": "Total Unit",
		"total_users": "Total Users",
		"total_weight": "Total Wt",
		"total_wt": "Total Wt",
		"track_all": "Track All",
		"track_no": "Track No.",
		"tracking_note": "Tracking Note",
		"tracking_num": "Tracking Num",
		"tracking_nums": "Tracking Nums",
		"transaction_fee": "Trans. Fee",
		"transit_method": "",
		"translation": "Translation",
		"try_dropping_some_files_here,_or_click_to_select_files_to_upload": "Try Dropping some files here, or click to select files to upload",
		"tue_route": "Tue Route",
		"tue_stop": "Tue Stop",
		"Tues": "Tues",
		"tues_stop": "Tues Stop",
		"type": "Type",
		"type_in_your_email": "Type In Your Email",
		"type_in_your_password": "Type In Your Password",
		"Typo": "Correction",
		"unassigned_orders": "Unassigned Orders",
		"undo": "Undo",
		"undone": "Undone",
		"unit_case": "Unit/Case",
		"unit_type": "Unit Type",
		"unit_dollarsign": "Unit Price",
		"unit_of_measure": "Unit Of Measure",
		"unit_per_pallet": "Unit Per Pallet",
		"unit_price": "Unit Price",
		"unit_price_colonsign": "Unit Price:",
		"unload_all": "Unload All",
		"unload_selected": "Unload Selected",
		"unpaid": "Unpaid",
		"unpaid_amount": "Unpaid Amount",
		"update": "Update",
		"update_ctn_no": "Update CTN No.",
		"update_date": "",
		"update_dollarsign": "Update $",
		"update_inventory": "Update Inventory",
		"update_isa_no": "Update ISA No.",
		"update_no": "Update No.",
		"update_time": "",
		"upload": "Upload",
		"upload_file": "Upload File",
		"upload_files": "Upload Files",
		"upload_images": "Upload Images",
		"upload_id": "Upload IDs",
		"prefilled_ob_template": "Prefilled OB",
		"creating_orders": "Creating Orders..",
		"uploading": "",
		"usable": "Usable",
		"used_bin": "",
		"use_product_a": "Use Product A",
		"user": "User",
		"user_amount": "User Amount",
		"user_detail": "User Detail",
		"user_management": "User Management",
		"user_name": "User Name",
		"user_performance": "User Performance",
		"user_role": "",
		"username": "Username",
		"variable_weight": "",
		"vehicle": "Vehicle",
		"vendor": "Vendor",
		"vendor_add": "Vendor Add",
		"vendor_description": "Vendor Description",
		"vendor_details": "Vendor Details",
		"vendor_id": "Vendor ID",
		"vendor_information": "Vendor Information",
		"vendor_invoice_no": "Vendor Invoice No.",
		"vendor_inv": "Vendor Inv. No.",
		"vendor_inv_date": "Vendor Inv. Date",
		"vendor_name": "Vendor Name",
		"vendor_no": "Vendor No",
		"mfr_no": "MFR No",
		"vendor_num": "Vendor Num",
		"vendor_number": "Vendor Number",
		"vendor_products": "Vendor Products",
		"vendor_product_number": "Vendor Product Number",
		"vendor_statement": "Vendor Statement",
		"vendors": "Vendors",
		"vendors_management": "Vendors Management",
		"view_pos_order": "View Pos Order",
		"void": "Void",
		"void_note": "Void Note",
		"void_reason": "Void Reason",
		"warehouse": "Warehouse",
		"warehouse_bin_id": "Warehouse Bin ID",
		"warehouse_bins": "Warehouse Bins",
		"warehouse_dashboard": "Warehouse Dashboard",
		"warehouse_detail_view": "Warehouse Detail View",
		"warehouse_id": "Warehouse ID",
		"warehouse_management": "Warehouse Management",
		"warehouse_map_view": "Warehouse Map View",
		"warehouse_name": "Warehouse Name",
		"warehouse_receive_deleted__purchase_orders_purchasestatus_rolled_back_to_partially_received_": "Warehouse receive deleted. Purchase order's PurchaseStatus rolled back to Partially Received.",
		"Warehouse_receive_deleted__purchase_orders_purchasestatus_rolled_back_to_placed_": "Warehouse receive deleted. Purchase order’s PurchaseStatus rolled back to Placed.",
		"warehouse_receive_num": "",
		"warehouse_zone_id": "",
		"warehousebin_id": "",
		"warning": "Warning",
		"wechat": "WeChat",
		"Wed": "Wed",
		"wed_route": "Wed Route",
		"wed_stop": "Wed Stop",
		"Weekly": "Weekly",
		"weeks_left_after_1_week": "Weeks Left After 1 Week",
		"weight": "Weight",
		"weight_lbs": "Weight (lbs)",
		"service": "Service",
		"tracking_link": "Tracking Link",
		"weight(s)_cannot_have_a_zero_value": "Weight(s) cannot have a zero value.",
		"weight_range": "Weight Range",
		"weight_return": "Weight Return",
		"wh": "WH",
		"wholesale": "Wholesale",
		"wholesale_only": "Wholesale Only",
		"wk_sale": "WK Sale",
		"work_not_saved_warning": "Your work is not saved! Are you sure you want to leave?",
		"working_order": "Working Order",
		"working_orders": "Working Orders",
		"year": "Year",
		"yes": "Yes",
		"yesterday": "Yesterday",
		"your_order": "Your Order",
		"your_purchase_order": "Your Purchase Order",
		"your_purchase_quote": "Your Purchase Quote",
		"your_purchase_template": "Your Purchase Template",
		"your_return_order": "Your Return Order",
		"your_sales_order": "Your Sales Order",
		"your_so_no_period_is": "Your Sales Order No. is:",
		"zip": "Zip",
		"no_price": "No Price",
		"excel_lines": "Excel Lines",
		"sales_convert_unit": "Sales Convert Unit",
		"zipcode": "Zipcode",
		"zone": "Zone",
		"zone_description": "",
		"zone_detail": "",
		"zone_detail_view": "",
		"zone_id": "Zone ID",
		"zone_level": "",
		"zone_name": "Zone Name",
		"zone_no": "Zone No.",
		"ref_sales": "Ref Sales",
		"price_style_1": "Price as is",
		"price_style_2": "Round to 0,5,9",
		"color": "Color",
		"brand": "Brand",
		"style": "Style",
		"us_size": "US Size",
		"eu_size": "EU Size",
		"repair_detail": "Repair Detail",
		"shipping_detail": "Shipping Detail",
		"Customer_Name": "Customer Name",
		"Customer_Mobile": "Customer Mobile",
		"Customer_Address": "Customer Address",
		"Customer_Email": "Customer Email Address",
		"customer_link": "Link Customers",
		"RMA_Content": "RMA Content",
		"RMA_Service_Type": "RMA Service Type",
		"RMA_Number": "RMA Number",
		"Product_Serial_Number": "Product Serial Number",
		"Product_Description": "Product Description",
		"Is_Urgent": "Is Urgent?",
		"Is_Warranty": "Has Warranty?",
		"Return_Logistics_Company": "Return Logistics Company",
		"Return_Tracking_Number": "Return Tracking Number",
		"Openbox_Description": "Openbox Description",
		"Product_Detail_Info": "Product Detail Infomation",
		"Warehouse_Check_Info": "Warehouse Checking Infomation",
		"Status": "Status",
		"Repair_Note": "Repair Note",
		"Dispatch_Logistics_Company": "Shipping Company",
		"Dispatch_Tracking_Number": "Tracking Number",
		"Shipping_Cost": "Shipping Fee",
		"Dispatch_Description": "Shipping Description",
		"Product_Model": "Product Model",
		"show_image": "Show Img",
		"excel_qb": "Excel QB",
		"delivery_tracking_num": "Delivery Tracking Number",
		"total_delivery_fee": "Delivery Fee",
		"email_packing": "Email Packing",
		"cpo_num": "CPO Num",
		"client": "Client/Cust",
		"order_information": "Order Information",
		"pos_holds": "Pos Holds",
		"pos_holds_full_table": "POS Holds Full Table",
		"Shipping_fee": "Shipping$",
		"main_sku": "Main SKU",
		"admin_password": "Admin Password",
		"admin": "Admin",
		"sales_popularity": "Sales Popularity",
		"confirmNcontinue": "Confirm & Continue",
		"weight_not_in_range": "One or more of items weight are not in the weight range of this product",
		"Name_and_Description_fields_are_required": "Name and Description fields are required",
		"passcode_confirm_text": "Please confirm passcode to proceed the previous action",
		"category_description": "Category Description",
		"meta_description": "Description",
		"meta_title": "Title",
		"meta_keywords": "Keywords",
		"member_card": "Member Card",
		"key": "Key",
		"category_info_edit": "Edit Category Info",
		"category_display_info": "Category Display Info",
		"category_meta_info": "Category Meta Info",
		"VPN": "VPN",
		"business_type": "Business Type",
		"ssn": "SSN",
		"is_retailer": "Is Retailer",
		"year_in_business": "Year in business",
		"barcode_export": "Barcode Export",
		"bank_account": "Bank Account",
		"all_locations": "All Locations",
		"alcohol": "Alcohol",
		"platform": "Platform",
		"customer_discount": "Discount(%OFF)",
		"bol_inventory": "BOL Inventory",
		"generating": "Generating....",
		"total_sales_invoices": "Total Sales Invoices",
		"inventory_history": "Inventory History",
		"checking": "check",
		"appointment": "Appointment",
		"dollarsign": "$",
		"lowest_sale": "Lowest Sale",
		"pre_order": "Pre Orders",
		"ship_to_orders": "Ship To Orders",
		"ship_from_orders": "Ship From Orders",
		"other_service": "Other Service",
		"edit_credit": "Edit Credit",
		"type_in_credit": "Type In Credit",
		"credit_details": "Credit Details",
		"mobile_user_messages_management": "Mobile User Messages management",
		"mobile_user_products": "Mobile User Products",
		"lot_number": "Lot No.",
		"legend_inventory_stop_sale": "Stop Sale",
		"legend_inventory_danger_stock": "In Stock < Min Stock",
		"legend_inventory_warning_stock": "Min Stock ≤ In Stock ≤ Max Stock",
		"legend_inventory_over_stock": "In Stock > Max Stock",
		"legend_inventory_po_stock": "In Stock + PO Amount > Min Stock",
		"legend_inventory_half_stock": "In Stock < Min Stock ÷ 2",
		"box_qty": "Box Quantity",
		"box": "Box",
		"upload_product": "Upload Product",
		"product_template": "Product Template"
	};

/***/ }),
/* 756 */
/***/ (function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ }),
/* 757 */
/***/ (function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ }),
/* 758 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 759 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 760 */
/***/ (function(module, exports) {

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	module.exports = asciiToArray;


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(186),
	    keys = __webpack_require__(106);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(839),
	    arrayEach = __webpack_require__(182),
	    assignValue = __webpack_require__(184),
	    baseAssign = __webpack_require__(761),
	    cloneBuffer = __webpack_require__(771),
	    copyArray = __webpack_require__(811),
	    copySymbols = __webpack_require__(778),
	    getAllKeys = __webpack_require__(781),
	    getTag = __webpack_require__(196),
	    initCloneArray = __webpack_require__(782),
	    initCloneByTag = __webpack_require__(783),
	    initCloneObject = __webpack_require__(784),
	    isArray = __webpack_require__(78),
	    isBuffer = __webpack_require__(190),
	    isObject = __webpack_require__(208),
	    keys = __webpack_require__(106);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (!isArr) {
	    var props = isFull ? getAllKeys(value) : keys(value);
	  }
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(208);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	module.exports = baseCreate;


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(128);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ }),
/* 765 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(759),
	    isArray = __webpack_require__(78);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(841);
	
	/**
	 * The base implementation of `_.invert` and `_.invertBy` which inverts
	 * `object` with values transformed by `iteratee` and set by `setter`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform values.
	 * @param {Object} accumulator The initial inverted object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseInverter(object, setter, iteratee, accumulator) {
	  baseForOwn(object, function(value, key, object) {
	    setter(accumulator, iteratee(value), key, object);
	  });
	  return accumulator;
	}
	
	module.exports = baseInverter;


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(128),
	    isArrayLike = __webpack_require__(131);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),
/* 769 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(769);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ }),
/* 771 */
/***/ (function(module, exports) {

	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var result = new buffer.constructor(buffer.length);
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(123);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(756),
	    arrayReduce = __webpack_require__(183),
	    mapToArray = __webpack_require__(813);
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ }),
/* 774 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(757),
	    arrayReduce = __webpack_require__(183),
	    setToArray = __webpack_require__(815);
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(840);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(123);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(186),
	    getSymbols = __webpack_require__(188);
	
	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(88),
	    isArrayLike = __webpack_require__(131),
	    keys = __webpack_require__(106);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	var baseInverter = __webpack_require__(767);
	
	/**
	 * Creates a function like `_.invertBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} toIteratee The function to resolve iteratees.
	 * @returns {Function} Returns the new inverter function.
	 */
	function createInverter(setter, toIteratee) {
	  return function(object, iteratee) {
	    return baseInverter(object, setter, toIteratee(iteratee), {});
	  };
	}
	
	module.exports = createInverter;


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(766),
	    getSymbols = __webpack_require__(188),
	    keys = __webpack_require__(106);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 782 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(123),
	    cloneDataView = __webpack_require__(772),
	    cloneMap = __webpack_require__(773),
	    cloneRegExp = __webpack_require__(774),
	    cloneSet = __webpack_require__(775),
	    cloneSymbol = __webpack_require__(776),
	    cloneTypedArray = __webpack_require__(777);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(763),
	    getPrototype = __webpack_require__(812),
	    isPrototype = __webpack_require__(197);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	var asciiToArray = __webpack_require__(760),
	    hasUnicode = __webpack_require__(189),
	    unicodeToArray = __webpack_require__(786);
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	module.exports = stringToArray;


/***/ }),
/* 786 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	module.exports = unicodeToArray;


/***/ }),
/* 787 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(185),
	    baseToString = __webpack_require__(195),
	    toInteger = __webpack_require__(127),
	    toString = __webpack_require__(129);
	
	/**
	 * Checks if `string` ends with the given target string.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {string} [target] The string to search for.
	 * @param {number} [position=string.length] The position to search up to.
	 * @returns {boolean} Returns `true` if `string` ends with `target`,
	 *  else `false`.
	 * @example
	 *
	 * _.endsWith('abc', 'c');
	 * // => true
	 *
	 * _.endsWith('abc', 'b');
	 * // => false
	 *
	 * _.endsWith('abc', 'b', 2);
	 * // => true
	 */
	function endsWith(string, target, position) {
	  string = toString(string);
	  target = baseToString(target);
	
	  var length = string.length;
	  position = position === undefined
	    ? length
	    : baseClamp(toInteger(position), 0, length);
	
	  var end = position;
	  position -= target.length;
	  return position >= 0 && string.slice(position, end) == target;
	}
	
	module.exports = endsWith;


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(779),
	    findIndex = __webpack_require__(125);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity]
	 *  The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(787),
	    createInverter = __webpack_require__(780),
	    identity = __webpack_require__(816);
	
	/**
	 * Creates an object composed of the inverted keys and values of `object`.
	 * If `object` contains duplicate values, subsequent values overwrite
	 * property assignments of previous values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.7.0
	 * @category Object
	 * @param {Object} object The object to invert.
	 * @returns {Object} Returns the new inverted object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2, 'c': 1 };
	 *
	 * _.invert(object);
	 * // => { '1': 'c', '2': 'b' }
	 */
	var invert = createInverter(function(result, value, key) {
	  result[value] = key;
	}, constant(identity));
	
	module.exports = invert;


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(207);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsFinite = root.isFinite;
	
	/**
	 * Checks if `value` is a finite primitive number.
	 *
	 * **Note:** This method is based on
	 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	 * @example
	 *
	 * _.isFinite(3);
	 * // => true
	 *
	 * _.isFinite(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isFinite(Infinity);
	 * // => false
	 *
	 * _.isFinite('3');
	 * // => false
	 */
	function isFinite(value) {
	  return typeof value == 'number' && nativeIsFinite(value);
	}
	
	module.exports = isFinite;


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	var createCaseFirst = __webpack_require__(187);
	
	/**
	 * Converts the first character of `string` to lower case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.lowerFirst('Fred');
	 * // => 'fred'
	 *
	 * _.lowerFirst('FRED');
	 * // => 'fRED'
	 */
	var lowerFirst = createCaseFirst('toLowerCase');
	
	module.exports = lowerFirst;


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(185),
	    baseToString = __webpack_require__(195),
	    toInteger = __webpack_require__(127),
	    toString = __webpack_require__(129);
	
	/**
	 * Checks if `string` starts with the given target string.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {string} [target] The string to search for.
	 * @param {number} [position=0] The position to search from.
	 * @returns {boolean} Returns `true` if `string` starts with `target`,
	 *  else `false`.
	 * @example
	 *
	 * _.startsWith('abc', 'a');
	 * // => true
	 *
	 * _.startsWith('abc', 'b');
	 * // => false
	 *
	 * _.startsWith('abc', 'b', 1);
	 * // => true
	 */
	function startsWith(string, target, position) {
	  string = toString(string);
	  position = baseClamp(toInteger(position), 0, string.length);
	  target = baseToString(target);
	  return string.slice(position, position + target.length) == target;
	}
	
	module.exports = startsWith;


/***/ }),
/* 794 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 795 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(817);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	var createCaseFirst = __webpack_require__(187);
	
	/**
	 * Converts the first character of `string` to upper case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.upperFirst('fred');
	 * // => 'Fred'
	 *
	 * _.upperFirst('FRED');
	 * // => 'FRED'
	 */
	var upperFirst = createCaseFirst('toUpperCase');
	
	module.exports = upperFirst;


/***/ }),
/* 798 */
/***/ (function(module, exports) {

	/**
	 * @name MarkerWithLabel for V3
	 * @version 1.1.9 [June 30, 2013]
	 * @author Gary Little (inspired by code from Marc Ridey of Google).
	 * @copyright Copyright 2012 Gary Little [gary at luxcentral.com]
	 * @fileoverview MarkerWithLabel extends the Google Maps JavaScript API V3
	 *  <code>google.maps.Marker</code> class.
	 *  <p>
	 *  MarkerWithLabel allows you to define markers with associated labels. As you would expect,
	 *  if the marker is draggable, so too will be the label. In addition, a marker with a label
	 *  responds to all mouse events in the same manner as a regular marker. It also fires mouse
	 *  events and "property changed" events just as a regular marker would. Version 1.1 adds
	 *  support for the raiseOnDrag feature introduced in API V3.3.
	 *  <p>
	 *  If you drag a marker by its label, you can cancel the drag and return the marker to its
	 *  original position by pressing the <code>Esc</code> key. This doesn't work if you drag the marker
	 *  itself because this feature is not (yet) supported in the <code>google.maps.Marker</code> class.
	 */
	
	/*!
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *       http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/*jslint browser:true */
	/*global document,google */
	
	/**
	 * @param {Function} childCtor Child class.
	 * @param {Function} parentCtor Parent class.
	 */
	function inherits(childCtor, parentCtor) {
	  /** @constructor */
	  function tempCtor() {};
	  tempCtor.prototype = parentCtor.prototype;
	  childCtor.superClass_ = parentCtor.prototype;
	  childCtor.prototype = new tempCtor();
	  /** @override */
	  childCtor.prototype.constructor = childCtor;
	}
	
	/**
	 * @param {Object} gMapsApi The Google Maps API instance (usually `google.maps`)
	 * @return {Function} The instantiable MarkerWithLabel class
	 */
	module.exports = function(gMapsApi) {
	
	  /**
	   * This constructor creates a label and associates it with a marker.
	   * It is for the private use of the MarkerWithLabel class.
	   * @constructor
	   * @param {Marker} marker The marker with which the label is to be associated.
	   * @param {string} crossURL The URL of the cross image =.
	   * @param {string} handCursor The URL of the hand cursor.
	   * @private
	   */
	  function MarkerLabel_(marker, crossURL, handCursorURL) {
	    this.marker_ = marker;
	    this.handCursorURL_ = marker.handCursorURL;
	
	    this.labelDiv_ = document.createElement("div");
	    this.labelDiv_.style.cssText = "position: absolute; overflow: hidden;";
	
	    // Set up the DIV for handling mouse events in the label. This DIV forms a transparent veil
	    // in the "overlayMouseTarget" pane, a veil that covers just the label. This is done so that
	    // events can be captured even if the label is in the shadow of a google.maps.InfoWindow.
	    // Code is included here to ensure the veil is always exactly the same size as the label.
	    this.eventDiv_ = document.createElement("div");
	    this.eventDiv_.style.cssText = this.labelDiv_.style.cssText;
	
	    // This is needed for proper behavior on MSIE:
	    this.eventDiv_.addEventListener('selectstart', function() { return false; });
	    this.eventDiv_.addEventListener('dragstart', function() { return false; });
	
	    // Get the DIV for the "X" to be displayed when the marker is raised.
	    this.crossDiv_ = MarkerLabel_.getSharedCross(crossURL);
	  }
	  inherits(MarkerLabel_, gMapsApi.OverlayView);
	
	  /**
	   * Returns the DIV for the cross used when dragging a marker when the
	   * raiseOnDrag parameter set to true. One cross is shared with all markers.
	   * @param {string} crossURL The URL of the cross image =.
	   * @private
	   */
	  MarkerLabel_.getSharedCross = function (crossURL) {
	    var div;
	    if (typeof MarkerLabel_.getSharedCross.crossDiv === "undefined") {
	      div = document.createElement("img");
	      div.style.cssText = "position: absolute; z-index: 1000002; display: none;";
	      // Hopefully Google never changes the standard "X" attributes:
	      div.style.marginLeft = "-8px";
	      div.style.marginTop = "-9px";
	      div.src = crossURL;
	      MarkerLabel_.getSharedCross.crossDiv = div;
	    }
	    return MarkerLabel_.getSharedCross.crossDiv;
	  };
	
	  /**
	   * Adds the DIV representing the label to the DOM. This method is called
	   * automatically when the marker's <code>setMap</code> method is called.
	   * @private
	   */
	  MarkerLabel_.prototype.onAdd = function () {
	    var me = this;
	    var cMouseIsDown = false;
	    var cDraggingLabel = false;
	    var cSavedZIndex;
	    var cLatOffset, cLngOffset;
	    var cIgnoreClick;
	    var cRaiseEnabled;
	    var cStartPosition;
	    var cStartCenter;
	    // Constants:
	    var cRaiseOffset = 20;
	    var cDraggingCursor = "url(" + this.handCursorURL_ + ")";
	
	    // Stops all processing of an event.
	    //
	    var cAbortEvent = function (e) {
	      if (e.preventDefault) {
	        e.preventDefault();
	      }
	      e.cancelBubble = true;
	      if (e.stopPropagation) {
	        e.stopPropagation();
	      }
	    };
	
	    var cStopBounce = function () {
	      me.marker_.setAnimation(null);
	    };
	
	    this.getPanes().markerLayer.appendChild(this.labelDiv_);
	    this.getPanes().overlayMouseTarget.appendChild(this.eventDiv_);
	    // One cross is shared with all markers, so only add it once:
	    if (typeof MarkerLabel_.getSharedCross.processed === "undefined") {
	      this.getPanes().markerLayer.appendChild(this.crossDiv_);
	      MarkerLabel_.getSharedCross.processed = true;
	    }
	
	    this.listeners_ = [
	      gMapsApi.event.addDomListener(this.eventDiv_, "mouseover", function (e) {
	        if (me.marker_.getDraggable() || me.marker_.getClickable()) {
	          this.style.cursor = "pointer";
	          gMapsApi.event.trigger(me.marker_, "mouseover", e);
	        }
	      }),
	      gMapsApi.event.addDomListener(this.eventDiv_, "mouseout", function (e) {
	        if ((me.marker_.getDraggable() || me.marker_.getClickable()) && !cDraggingLabel) {
	          this.style.cursor = me.marker_.getCursor();
	          gMapsApi.event.trigger(me.marker_, "mouseout", e);
	        }
	      }),
	      gMapsApi.event.addDomListener(this.eventDiv_, "mousedown", function (e) {
	        cDraggingLabel = false;
	        if (me.marker_.getDraggable()) {
	          cMouseIsDown = true;
	          this.style.cursor = cDraggingCursor;
	        }
	        if (me.marker_.getDraggable() || me.marker_.getClickable()) {
	          gMapsApi.event.trigger(me.marker_, "mousedown", e);
	          cAbortEvent(e); // Prevent map pan when starting a drag on a label
	        }
	      }),
	      gMapsApi.event.addDomListener(document, "mouseup", function (mEvent) {
	        var position;
	        if (cMouseIsDown) {
	          cMouseIsDown = false;
	          me.eventDiv_.style.cursor = "pointer";
	          gMapsApi.event.trigger(me.marker_, "mouseup", mEvent);
	        }
	        if (cDraggingLabel) {
	          if (cRaiseEnabled) { // Lower the marker & label
	            position = me.getProjection().fromLatLngToDivPixel(me.marker_.getPosition());
	            position.y += cRaiseOffset;
	            me.marker_.setPosition(me.getProjection().fromDivPixelToLatLng(position));
	            // This is not the same bouncing style as when the marker portion is dragged,
	            // but it will have to do:
	            try { // Will fail if running Google Maps API earlier than V3.3
	              me.marker_.setAnimation(gMapsApi.Animation.BOUNCE);
	              setTimeout(cStopBounce, 1406);
	            } catch (e) {}
	          }
	          me.crossDiv_.style.display = "none";
	          me.marker_.setZIndex(cSavedZIndex);
	          cIgnoreClick = true; // Set flag to ignore the click event reported after a label drag
	          cDraggingLabel = false;
	          mEvent.latLng = me.marker_.getPosition();
	          gMapsApi.event.trigger(me.marker_, "dragend", mEvent);
	        }
	      }),
	      gMapsApi.event.addListener(me.marker_.getMap(), "mousemove", function (mEvent) {
	        var position;
	        if (cMouseIsDown) {
	          if (cDraggingLabel) {
	            // Change the reported location from the mouse position to the marker position:
	            mEvent.latLng = new gMapsApi.LatLng(mEvent.latLng.lat() - cLatOffset, mEvent.latLng.lng() - cLngOffset);
	            position = me.getProjection().fromLatLngToDivPixel(mEvent.latLng);
	            if (cRaiseEnabled) {
	              me.crossDiv_.style.left = position.x + "px";
	              me.crossDiv_.style.top = position.y + "px";
	              me.crossDiv_.style.display = "";
	              position.y -= cRaiseOffset;
	            }
	            me.marker_.setPosition(me.getProjection().fromDivPixelToLatLng(position));
	            if (cRaiseEnabled) { // Don't raise the veil; this hack needed to make MSIE act properly
	              me.eventDiv_.style.top = (position.y + cRaiseOffset) + "px";
	            }
	            gMapsApi.event.trigger(me.marker_, "drag", mEvent);
	          } else {
	            // Calculate offsets from the click point to the marker position:
	            cLatOffset = mEvent.latLng.lat() - me.marker_.getPosition().lat();
	            cLngOffset = mEvent.latLng.lng() - me.marker_.getPosition().lng();
	            cSavedZIndex = me.marker_.getZIndex();
	            cStartPosition = me.marker_.getPosition();
	            cStartCenter = me.marker_.getMap().getCenter();
	            cRaiseEnabled = me.marker_.get("raiseOnDrag");
	            cDraggingLabel = true;
	            me.marker_.setZIndex(1000000); // Moves the marker & label to the foreground during a drag
	            mEvent.latLng = me.marker_.getPosition();
	            gMapsApi.event.trigger(me.marker_, "dragstart", mEvent);
	          }
	        }
	      }),
	      gMapsApi.event.addDomListener(document, "keydown", function (e) {
	        if (cDraggingLabel) {
	          if (e.keyCode === 27) { // Esc key
	            cRaiseEnabled = false;
	            me.marker_.setPosition(cStartPosition);
	            me.marker_.getMap().setCenter(cStartCenter);
	            gMapsApi.event.trigger(document, "mouseup", e);
	          }
	        }
	      }),
	      gMapsApi.event.addDomListener(this.eventDiv_, "click", function (e) {
	        if (me.marker_.getDraggable() || me.marker_.getClickable()) {
	          if (cIgnoreClick) { // Ignore the click reported when a label drag ends
	            cIgnoreClick = false;
	          } else {
	            gMapsApi.event.trigger(me.marker_, "click", e);
	            cAbortEvent(e); // Prevent click from being passed on to map
	          }
	        }
	      }),
	      gMapsApi.event.addDomListener(this.eventDiv_, "dblclick", function (e) {
	        if (me.marker_.getDraggable() || me.marker_.getClickable()) {
	          gMapsApi.event.trigger(me.marker_, "dblclick", e);
	          cAbortEvent(e); // Prevent map zoom when double-clicking on a label
	        }
	      }),
	      gMapsApi.event.addListener(this.marker_, "dragstart", function (mEvent) {
	        if (!cDraggingLabel) {
	          cRaiseEnabled = this.get("raiseOnDrag");
	        }
	      }),
	      gMapsApi.event.addListener(this.marker_, "drag", function (mEvent) {
	        if (!cDraggingLabel) {
	          if (cRaiseEnabled) {
	            me.setPosition(cRaiseOffset);
	            // During a drag, the marker's z-index is temporarily set to 1000000 to
	            // ensure it appears above all other markers. Also set the label's z-index
	            // to 1000000 (plus or minus 1 depending on whether the label is supposed
	            // to be above or below the marker).
	            me.labelDiv_.style.zIndex = 1000000 + (this.get("labelInBackground") ? -1 : +1);
	          }
	        }
	      }),
	      gMapsApi.event.addListener(this.marker_, "dragend", function (mEvent) {
	        if (!cDraggingLabel) {
	          if (cRaiseEnabled) {
	            me.setPosition(0); // Also restores z-index of label
	          }
	        }
	      }),
	      gMapsApi.event.addListener(this.marker_, "position_changed", function () {
	        me.setPosition();
	      }),
	      gMapsApi.event.addListener(this.marker_, "zindex_changed", function () {
	        me.setZIndex();
	      }),
	      gMapsApi.event.addListener(this.marker_, "visible_changed", function () {
	        me.setVisible();
	      }),
	      gMapsApi.event.addListener(this.marker_, "labelvisible_changed", function () {
	        me.setVisible();
	      }),
	      gMapsApi.event.addListener(this.marker_, "title_changed", function () {
	        me.setTitle();
	      }),
	      gMapsApi.event.addListener(this.marker_, "labelcontent_changed", function () {
	        me.setContent();
	      }),
	      gMapsApi.event.addListener(this.marker_, "labelanchor_changed", function () {
	        me.setAnchor();
	      }),
	      gMapsApi.event.addListener(this.marker_, "labelclass_changed", function () {
	        me.setStyles();
	      }),
	      gMapsApi.event.addListener(this.marker_, "labelstyle_changed", function () {
	        me.setStyles();
	      })
	    ];
	  };
	
	  /**
	   * Removes the DIV for the label from the DOM. It also removes all event handlers.
	   * This method is called automatically when the marker's <code>setMap(null)</code>
	   * method is called.
	   * @private
	   */
	  MarkerLabel_.prototype.onRemove = function () {
	    var i;
	    this.labelDiv_.parentNode.removeChild(this.labelDiv_);
	    this.eventDiv_.parentNode.removeChild(this.eventDiv_);
	
	    // Remove event listeners:
	    for (i = 0; i < this.listeners_.length; i++) {
	      gMapsApi.event.removeListener(this.listeners_[i]);
	    }
	  };
	
	  /**
	   * Draws the label on the map.
	   * @private
	   */
	  MarkerLabel_.prototype.draw = function () {
	    this.setContent();
	    this.setTitle();
	    this.setStyles();
	  };
	
	  /**
	   * Sets the content of the label.
	   * The content can be plain text or an HTML DOM node.
	   * @private
	   */
	  MarkerLabel_.prototype.setContent = function () {
	    var content = this.marker_.get("labelContent");
	    if (typeof content.nodeType === "undefined") {
	      this.labelDiv_.innerHTML = content;
	      this.eventDiv_.innerHTML = this.labelDiv_.innerHTML;
	    } else {
	      // Remove current content
	      while (this.labelDiv_.lastChild) {
	        this.labelDiv_.removeChild(this.labelDiv_.lastChild);
	      }
	
	      while (this.eventDiv_.lastChild) {
	        this.eventDiv_.removeChild(this.eventDiv_.lastChild);
	      }
	
	      this.labelDiv_.appendChild(content);
	      content = content.cloneNode(true);
	      this.eventDiv_.appendChild(content);
	    }
	  };
	
	  /**
	   * Sets the content of the tool tip for the label. It is
	   * always set to be the same as for the marker itself.
	   * @private
	   */
	  MarkerLabel_.prototype.setTitle = function () {
	    this.eventDiv_.title = this.marker_.getTitle() || "";
	  };
	
	  /**
	   * Sets the style of the label by setting the style sheet and applying
	   * other specific styles requested.
	   * @private
	   */
	  MarkerLabel_.prototype.setStyles = function () {
	    var i, labelStyle;
	
	    // Apply style values from the style sheet defined in the labelClass parameter:
	    this.labelDiv_.className = this.marker_.get("labelClass");
	    this.eventDiv_.className = this.labelDiv_.className;
	
	    // Clear existing inline style values:
	    this.labelDiv_.style.cssText = "";
	    this.eventDiv_.style.cssText = "";
	    // Apply style values defined in the labelStyle parameter:
	    labelStyle = this.marker_.get("labelStyle");
	    for (i in labelStyle) {
	      if (labelStyle.hasOwnProperty(i)) {
	        this.labelDiv_.style[i] = labelStyle[i];
	        this.eventDiv_.style[i] = labelStyle[i];
	      }
	    }
	    this.setMandatoryStyles();
	  };
	
	  /**
	   * Sets the mandatory styles to the DIV representing the label as well as to the
	   * associated event DIV. This includes setting the DIV position, z-index, and visibility.
	   * @private
	   */
	  MarkerLabel_.prototype.setMandatoryStyles = function () {
	    this.labelDiv_.style.position = "absolute";
	    this.labelDiv_.style.overflow = "hidden";
	    // Make sure the opacity setting causes the desired effect on MSIE:
	    if (typeof this.labelDiv_.style.opacity !== "undefined" && this.labelDiv_.style.opacity !== "") {
	      this.labelDiv_.style.MsFilter = "\"progid:DXImageTransform.Microsoft.Alpha(opacity=" + (this.labelDiv_.style.opacity * 100) + ")\"";
	      this.labelDiv_.style.filter = "alpha(opacity=" + (this.labelDiv_.style.opacity * 100) + ")";
	    }
	
	    this.eventDiv_.style.position = this.labelDiv_.style.position;
	    this.eventDiv_.style.overflow = this.labelDiv_.style.overflow;
	    this.eventDiv_.style.opacity = 0.01; // Don't use 0; DIV won't be clickable on MSIE
	    this.eventDiv_.style.MsFilter = "\"progid:DXImageTransform.Microsoft.Alpha(opacity=1)\"";
	    this.eventDiv_.style.filter = "alpha(opacity=1)"; // For MSIE
	
	    this.setAnchor();
	    this.setPosition(); // This also updates z-index, if necessary.
	    this.setVisible();
	  };
	
	  /**
	   * Sets the anchor point of the label.
	   * @private
	   */
	  MarkerLabel_.prototype.setAnchor = function () {
	    var anchor = this.marker_.get("labelAnchor");
	    this.labelDiv_.style.marginLeft = -anchor.x + "px";
	    this.labelDiv_.style.marginTop = -anchor.y + "px";
	    this.eventDiv_.style.marginLeft = -anchor.x + "px";
	    this.eventDiv_.style.marginTop = -anchor.y + "px";
	  };
	
	  /**
	   * Sets the position of the label. The z-index is also updated, if necessary.
	   * @private
	   */
	  MarkerLabel_.prototype.setPosition = function (yOffset) {
	    var position = this.getProjection().fromLatLngToDivPixel(this.marker_.getPosition());
	    if (typeof yOffset === "undefined") {
	      yOffset = 0;
	    }
	    this.labelDiv_.style.left = Math.round(position.x) + "px";
	    this.labelDiv_.style.top = Math.round(position.y - yOffset) + "px";
	    this.eventDiv_.style.left = this.labelDiv_.style.left;
	    this.eventDiv_.style.top = this.labelDiv_.style.top;
	
	    this.setZIndex();
	  };
	
	  /**
	   * Sets the z-index of the label. If the marker's z-index property has not been defined, the z-index
	   * of the label is set to the vertical coordinate of the label. This is in keeping with the default
	   * stacking order for Google Maps: markers to the south are in front of markers to the north.
	   * @private
	   */
	  MarkerLabel_.prototype.setZIndex = function () {
	    var zAdjust = (this.marker_.get("labelInBackground") ? -1 : +1);
	    if (typeof this.marker_.getZIndex() === "undefined") {
	      this.labelDiv_.style.zIndex = parseInt(this.labelDiv_.style.top, 10) + zAdjust;
	      this.eventDiv_.style.zIndex = this.labelDiv_.style.zIndex;
	    } else {
	      this.labelDiv_.style.zIndex = this.marker_.getZIndex() + zAdjust;
	      this.eventDiv_.style.zIndex = this.labelDiv_.style.zIndex;
	    }
	  };
	
	  /**
	   * Sets the visibility of the label. The label is visible only if the marker itself is
	   * visible (i.e., its visible property is true) and the labelVisible property is true.
	   * @private
	   */
	  MarkerLabel_.prototype.setVisible = function () {
	    if (this.marker_.get("labelVisible")) {
	      this.labelDiv_.style.display = this.marker_.getVisible() ? "block" : "none";
	    } else {
	      this.labelDiv_.style.display = "none";
	    }
	    this.eventDiv_.style.display = this.labelDiv_.style.display;
	  };
	
	  /**
	   * @name MarkerWithLabelOptions
	   * @class This class represents the optional parameter passed to the {@link MarkerWithLabel} constructor.
	   *  The properties available are the same as for <code>google.maps.Marker</code> with the addition
	   *  of the properties listed below. To change any of these additional properties after the labeled
	   *  marker has been created, call <code>google.maps.Marker.set(propertyName, propertyValue)</code>.
	   *  <p>
	   *  When any of these properties changes, a property changed event is fired. The names of these
	   *  events are derived from the name of the property and are of the form <code>propertyname_changed</code>.
	   *  For example, if the content of the label changes, a <code>labelcontent_changed</code> event
	   *  is fired.
	   *  <p>
	   * @property {string|Node} [labelContent] The content of the label (plain text or an HTML DOM node).
	   * @property {Point} [labelAnchor] By default, a label is drawn with its anchor point at (0,0) so
	   *  that its top left corner is positioned at the anchor point of the associated marker. Use this
	   *  property to change the anchor point of the label. For example, to center a 50px-wide label
	   *  beneath a marker, specify a <code>labelAnchor</code> of <code>google.maps.Point(25, 0)</code>.
	   *  (Note: x-values increase to the right and y-values increase to the top.)
	   * @property {string} [labelClass] The name of the CSS class defining the styles for the label.
	   *  Note that style values for <code>position</code>, <code>overflow</code>, <code>top</code>,
	   *  <code>left</code>, <code>zIndex</code>, <code>display</code>, <code>marginLeft</code>, and
	   *  <code>marginTop</code> are ignored; these styles are for internal use only.
	   * @property {Object} [labelStyle] An object literal whose properties define specific CSS
	   *  style values to be applied to the label. Style values defined here override those that may
	   *  be defined in the <code>labelClass</code> style sheet. If this property is changed after the
	   *  label has been created, all previously set styles (except those defined in the style sheet)
	   *  are removed from the label before the new style values are applied.
	   *  Note that style values for <code>position</code>, <code>overflow</code>, <code>top</code>,
	   *  <code>left</code>, <code>zIndex</code>, <code>display</code>, <code>marginLeft</code>, and
	   *  <code>marginTop</code> are ignored; these styles are for internal use only.
	   * @property {boolean} [labelInBackground] A flag indicating whether a label that overlaps its
	   *  associated marker should appear in the background (i.e., in a plane below the marker).
	   *  The default is <code>false</code>, which causes the label to appear in the foreground.
	   * @property {boolean} [labelVisible] A flag indicating whether the label is to be visible.
	   *  The default is <code>true</code>. Note that even if <code>labelVisible</code> is
	   *  <code>true</code>, the label will <i>not</i> be visible unless the associated marker is also
	   *  visible (i.e., unless the marker's <code>visible</code> property is <code>true</code>).
	   * @property {boolean} [raiseOnDrag] A flag indicating whether the label and marker are to be
	   *  raised when the marker is dragged. The default is <code>true</code>. If a draggable marker is
	   *  being created and a version of Google Maps API earlier than V3.3 is being used, this property
	   *  must be set to <code>false</code>.
	   * @property {boolean} [optimized] A flag indicating whether rendering is to be optimized for the
	   *  marker. <b>Important: The optimized rendering technique is not supported by MarkerWithLabel,
	   *  so the value of this parameter is always forced to <code>false</code>.
	   * @property {string} [crossImage="http://maps.gstatic.com/intl/en_us/mapfiles/drag_cross_67_16.png"]
	   *  The URL of the cross image to be displayed while dragging a marker.
	   * @property {string} [handCursor="http://maps.gstatic.com/intl/en_us/mapfiles/closedhand_8_8.cur"]
	   *  The URL of the cursor to be displayed while dragging a marker.
	   */
	  /**
	   * Creates a MarkerWithLabel with the options specified in {@link MarkerWithLabelOptions}.
	   * @constructor
	   * @param {MarkerWithLabelOptions} [opt_options] The optional parameters.
	   */
	  function MarkerWithLabel(opt_options) {
	    opt_options = opt_options || {};
	    opt_options.labelContent = opt_options.labelContent || "";
	    opt_options.labelAnchor = opt_options.labelAnchor || new gMapsApi.Point(0, 0);
	    opt_options.labelClass = opt_options.labelClass || "markerLabels";
	    opt_options.labelStyle = opt_options.labelStyle || {};
	    opt_options.labelInBackground = opt_options.labelInBackground || false;
	    if (typeof opt_options.labelVisible === "undefined") {
	      opt_options.labelVisible = true;
	    }
	    if (typeof opt_options.raiseOnDrag === "undefined") {
	      opt_options.raiseOnDrag = true;
	    }
	    if (typeof opt_options.clickable === "undefined") {
	      opt_options.clickable = true;
	    }
	    if (typeof opt_options.draggable === "undefined") {
	      opt_options.draggable = false;
	    }
	    if (typeof opt_options.optimized === "undefined") {
	      opt_options.optimized = false;
	    }
	    opt_options.crossImage = opt_options.crossImage || "http" + (document.location.protocol === "https:" ? "s" : "") + "://maps.gstatic.com/intl/en_us/mapfiles/drag_cross_67_16.png";
	    opt_options.handCursor = opt_options.handCursor || "http" + (document.location.protocol === "https:" ? "s" : "") + "://maps.gstatic.com/intl/en_us/mapfiles/closedhand_8_8.cur";
	    opt_options.optimized = false; // Optimized rendering is not supported
	
	    this.label = new MarkerLabel_(this, opt_options.crossImage, opt_options.handCursor); // Bind the label to the marker
	
	    // Call the parent constructor. It calls Marker.setValues to initialize, so all
	    // the new parameters are conveniently saved and can be accessed with get/set.
	    // Marker.set triggers a property changed event (called "propertyname_changed")
	    // that the marker label listens for in order to react to state changes.
	    gMapsApi.Marker.apply(this, arguments);
	  }
	  inherits(MarkerWithLabel, gMapsApi.Marker);
	
	  /**
	   * Overrides the standard Marker setMap function.
	   * @param {Map} theMap The map to which the marker is to be added.
	   * @private
	   */
	  MarkerWithLabel.prototype.setMap = function (theMap) {
	
	    // Call the inherited function...
	    gMapsApi.Marker.prototype.setMap.apply(this, arguments);
	
	    // ... then deal with the label:
	    this.label.setMap(theMap);
	  };
	
	  return MarkerWithLabel;
	}


/***/ }),
/* 799 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ }),
/* 800 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(799);
	exports.encode = exports.stringify = __webpack_require__(800);


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.MarkerWithLabel = undefined
	
	var _defineProperty2 = __webpack_require__(835)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(829)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(830)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(832)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(834)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(833)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _MarkerWithLabel$cont /*
	                            * -----------------------------------------------------------------------------
	                            * This file is auto-generated from the corresponding file at `src/macros/`.
	                            * Please **DO NOT** edit this file directly when creating PRs.
	                            * -----------------------------------------------------------------------------
	                            */
	/* global google */
	
	var _react = __webpack_require__(1)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(18)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _markerwithlabel = __webpack_require__(798)
	
	var _markerwithlabel2 = _interopRequireDefault(_markerwithlabel)
	
	var _reactDom = __webpack_require__(34)
	
	var _reactDom2 = _interopRequireDefault(_reactDom)
	
	var _MapChildHelper = __webpack_require__(837)
	
	var _constants = __webpack_require__(836)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `MarkerWithLabel`
	 *
	 * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
	 */
	var MarkerWithLabel = (exports.MarkerWithLabel = (function(
	  _React$PureComponent
	) {
	  ;(0, _inherits3.default)(MarkerWithLabel, _React$PureComponent)
	
	  /*
	   * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
	   */
	  function MarkerWithLabel(props, context) {
	    ;(0, _classCallCheck3.default)(this, MarkerWithLabel)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (
	        MarkerWithLabel.__proto__ ||
	        (0, _getPrototypeOf2.default)(MarkerWithLabel)
	      ).call(this, props, context)
	    )
	
	    var NativeMarkerWithLabel = (0, _markerwithlabel2.default)(google.maps)
	    var markerWithLabel = new NativeMarkerWithLabel()
	    ;(0, _MapChildHelper.construct)(
	      MarkerWithLabel.propTypes,
	      updaterMap,
	      _this.props,
	      markerWithLabel
	    )
	    var markerClusterer = _this.context[_constants.MARKER_CLUSTERER]
	    if (markerClusterer) {
	      markerClusterer.addMarker(markerWithLabel, !!_this.props.noRedraw)
	    } else {
	      markerWithLabel.setMap(_this.context[_constants.MAP])
	    }
	    _this.state = (0, _defineProperty3.default)(
	      {},
	      _constants.MARKER_WITH_LABEL,
	      markerWithLabel
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(MarkerWithLabel, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.MARKER_WITH_LABEL],
	          eventMap
	        )
	        var container = document.createElement("div")
	        _reactDom2.default.unstable_renderSubtreeIntoContainer(
	          this,
	          _react2.default.Children.only(this.props.children),
	          container
	        )
	        this.state[_constants.MARKER_WITH_LABEL].set("labelContent", container)
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.MARKER_WITH_LABEL],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	        if (this.props.children !== prevProps.children) {
	          _reactDom2.default.unstable_renderSubtreeIntoContainer(
	            this,
	            _react2.default.Children.only(this.props.children),
	            this.state[_constants.MARKER_WITH_LABEL].get("labelContent")
	          )
	        }
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var markerWithLabel = this.state[_constants.MARKER_WITH_LABEL]
	        if (markerWithLabel) {
	          var markerClusterer = this.context[_constants.MARKER_CLUSTERER]
	          if (markerClusterer) {
	            markerClusterer.removeMarker(markerWithLabel, !!this.props.noRedraw)
	          }
	          if (markerWithLabel.get("labelContent")) {
	            _reactDom2.default.unmountComponentAtNode(
	              markerWithLabel.get("labelContent")
	            )
	          }
	          markerWithLabel.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	
	      /**
	       *
	       * @type Animation
	       * @public
	       */
	    },
	    {
	      key: "getAnimation",
	      value: function getAnimation() {
	        return this.state[_constants.MARKER_WITH_LABEL].getAnimation()
	      },
	
	      /**
	       *
	       * @type boolean
	       * @public
	       */
	    },
	    {
	      key: "getClickable",
	      value: function getClickable() {
	        return this.state[_constants.MARKER_WITH_LABEL].getClickable()
	      },
	
	      /**
	       *
	       * @type string
	       * @public
	       */
	    },
	    {
	      key: "getCursor",
	      value: function getCursor() {
	        return this.state[_constants.MARKER_WITH_LABEL].getCursor()
	      },
	
	      /**
	       *
	       * @type boolean
	       * @public
	       */
	    },
	    {
	      key: "getDraggable",
	      value: function getDraggable() {
	        return this.state[_constants.MARKER_WITH_LABEL].getDraggable()
	      },
	
	      /**
	       *
	       * @type string|Icon|Symbol
	       * @public
	       */
	    },
	    {
	      key: "getIcon",
	      value: function getIcon() {
	        return this.state[_constants.MARKER_WITH_LABEL].getIcon()
	      },
	
	      /**
	       *
	       * @type MarkerLabel
	       * @public
	       */
	    },
	    {
	      key: "getLabel",
	      value: function getLabel() {
	        return this.state[_constants.MARKER_WITH_LABEL].getLabel()
	      },
	
	      /**
	       *
	       * @type number
	       * @public
	       */
	    },
	    {
	      key: "getOpacity",
	      value: function getOpacity() {
	        return this.state[_constants.MARKER_WITH_LABEL].getOpacity()
	      },
	
	      /**
	       *
	       * @type MarkerPlace
	       * @public
	       */
	    },
	    {
	      key: "getPlace",
	      value: function getPlace() {
	        return this.state[_constants.MARKER_WITH_LABEL].getPlace()
	      },
	
	      /**
	       *
	       * @type LatLng
	       * @public
	       */
	    },
	    {
	      key: "getPosition",
	      value: function getPosition() {
	        return this.state[_constants.MARKER_WITH_LABEL].getPosition()
	      },
	
	      /**
	       *
	       * @type MarkerShape
	       * @public
	       */
	    },
	    {
	      key: "getShape",
	      value: function getShape() {
	        return this.state[_constants.MARKER_WITH_LABEL].getShape()
	      },
	
	      /**
	       *
	       * @type string
	       * @public
	       */
	    },
	    {
	      key: "getTitle",
	      value: function getTitle() {
	        return this.state[_constants.MARKER_WITH_LABEL].getTitle()
	      },
	
	      /**
	       *
	       * @type boolean
	       * @public
	       */
	    },
	    {
	      key: "getVisible",
	      value: function getVisible() {
	        return this.state[_constants.MARKER_WITH_LABEL].getVisible()
	      },
	
	      /**
	       *
	       * @type number
	       * @public
	       */
	    },
	    {
	      key: "getZIndex",
	      value: function getZIndex() {
	        return this.state[_constants.MARKER_WITH_LABEL].getZIndex()
	      },
	    },
	  ])
	  return MarkerWithLabel
	})(_react2.default.PureComponent))
	
	MarkerWithLabel.propTypes = {
	  /**
	   * It will be `MarkerWithLabel#labelContent`.
	   * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * For `MarkerWithLabel`
	   * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
	   */
	  labelAnchor: _propTypes2.default.object,
	
	  /**
	   * For `MarkerWithLabel`
	   * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
	   */
	  labelClass: _propTypes2.default.string,
	
	  /**
	   * For `MarkerWithLabel`. This is for native JS style object, so you may
	   * expect some React shorthands for inline styles not working here.
	   * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
	   */
	  labelStyle: _propTypes2.default.object,
	
	  /**
	   * For `MarkerWithLabel`
	   * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
	   */
	  labelVisible: _propTypes2.default.bool,
	
	  /**
	   * For the 2nd argument of `MarkerCluster#addMarker`
	   * @see https://github.com/mikesaidani/marker-clusterer-plus
	   */
	  noRedraw: _propTypes2.default.bool,
	
	  /**
	   * @type Animation
	   */
	  defaultAnimation: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  defaultClickable: _propTypes2.default.bool,
	
	  /**
	   * @type string
	   */
	  defaultCursor: _propTypes2.default.string,
	
	  /**
	   * @type boolean
	   */
	  defaultDraggable: _propTypes2.default.bool,
	
	  /**
	   * @type string|Icon|Symbol
	   */
	  defaultIcon: _propTypes2.default.any,
	
	  /**
	   * @type string|MarkerLabel
	   */
	  defaultLabel: _propTypes2.default.any,
	
	  /**
	   * @type number
	   */
	  defaultOpacity: _propTypes2.default.number,
	
	  /**
	   * @type MarkerOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type MarkerPlace
	   */
	  defaultPlace: _propTypes2.default.any,
	
	  /**
	   * @type LatLng|LatLngLiteral
	   */
	  defaultPosition: _propTypes2.default.any,
	
	  /**
	   * @type MarkerShape
	   */
	  defaultShape: _propTypes2.default.any,
	
	  /**
	   * @type string
	   */
	  defaultTitle: _propTypes2.default.string,
	
	  /**
	   * @type boolean
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * @type number
	   */
	  defaultZIndex: _propTypes2.default.number,
	
	  /**
	   * @type Animation
	   */
	  animation: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  clickable: _propTypes2.default.bool,
	
	  /**
	   * @type string
	   */
	  cursor: _propTypes2.default.string,
	
	  /**
	   * @type boolean
	   */
	  draggable: _propTypes2.default.bool,
	
	  /**
	   * @type string|Icon|Symbol
	   */
	  icon: _propTypes2.default.any,
	
	  /**
	   * @type string|MarkerLabel
	   */
	  label: _propTypes2.default.any,
	
	  /**
	   * @type number
	   */
	  opacity: _propTypes2.default.number,
	
	  /**
	   * @type MarkerOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * @type MarkerPlace
	   */
	  place: _propTypes2.default.any,
	
	  /**
	   * @type LatLng|LatLngLiteral
	   */
	  position: _propTypes2.default.any,
	
	  /**
	   * @type MarkerShape
	   */
	  shape: _propTypes2.default.any,
	
	  /**
	   * @type string
	   */
	  title: _propTypes2.default.string,
	
	  /**
	   * @type boolean
	   */
	  visible: _propTypes2.default.bool,
	
	  /**
	   * @type number
	   */
	  zIndex: _propTypes2.default.number,
	
	  /**
	   * function
	   */
	  onDblClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragEnd: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragStart: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOut: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onRightClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onAnimationChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onClickableChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onCursorChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDrag: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDraggableChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onFlatChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onIconChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onPositionChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onShapeChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onTitleChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onVisibleChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onZindexChanged: _propTypes2.default.func,
	}
	MarkerWithLabel.defaultProps = {
	  labelVisible: true,
	}
	MarkerWithLabel.contextTypes = ((_MarkerWithLabel$cont = {}),
	(0, _defineProperty3.default)(
	  _MarkerWithLabel$cont,
	  _constants.MAP,
	  _propTypes2.default.object
	),
	(0, _defineProperty3.default)(
	  _MarkerWithLabel$cont,
	  _constants.MARKER_CLUSTERER,
	  _propTypes2.default.object
	),
	_MarkerWithLabel$cont)
	exports.default = MarkerWithLabel
	
	var eventMap = {
	  onDblClick: "dblclick",
	  onDragEnd: "dragend",
	  onDragStart: "dragstart",
	  onMouseDown: "mousedown",
	  onMouseOut: "mouseout",
	  onMouseOver: "mouseover",
	  onMouseUp: "mouseup",
	  onRightClick: "rightclick",
	  onAnimationChanged: "animation_changed",
	  onClick: "click",
	  onClickableChanged: "clickable_changed",
	  onCursorChanged: "cursor_changed",
	  onDrag: "drag",
	  onDraggableChanged: "draggable_changed",
	  onFlatChanged: "flat_changed",
	  onIconChanged: "icon_changed",
	  onPositionChanged: "position_changed",
	  onShapeChanged: "shape_changed",
	  onTitleChanged: "title_changed",
	  onVisibleChanged: "visible_changed",
	  onZindexChanged: "zindex_changed",
	}
	
	var updaterMap = {
	  /**
	   * For `MarkerWithLabel`
	   * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
	   */
	  labelAnchor: function labelAnchor(instance, _labelAnchor) {
	    instance.set("labelAnchor", _labelAnchor)
	  },
	
	  /**
	   * For `MarkerWithLabel`
	   * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
	   */
	  labelClass: function labelClass(instance, _labelClass) {
	    instance.set("labelClass", _labelClass)
	  },
	
	  /**
	   * For `MarkerWithLabel`
	   * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
	   */
	  labelStyle: function labelStyle(instance, _labelStyle) {
	    instance.set("labelStyle", _labelStyle)
	  },
	
	  /**
	   * For `MarkerWithLabel`
	   * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
	   */
	  labelVisible: function labelVisible(instance, _labelVisible) {
	    instance.set("labelVisible", _labelVisible)
	  },
	  animation: function animation(instance, _animation) {
	    instance.setAnimation(_animation)
	  },
	  clickable: function clickable(instance, _clickable) {
	    instance.setClickable(_clickable)
	  },
	  cursor: function cursor(instance, _cursor) {
	    instance.setCursor(_cursor)
	  },
	  draggable: function draggable(instance, _draggable) {
	    instance.setDraggable(_draggable)
	  },
	  icon: function icon(instance, _icon) {
	    instance.setIcon(_icon)
	  },
	  label: function label(instance, _label) {
	    instance.setLabel(_label)
	  },
	  opacity: function opacity(instance, _opacity) {
	    instance.setOpacity(_opacity)
	  },
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	  place: function place(instance, _place) {
	    instance.setPlace(_place)
	  },
	  position: function position(instance, _position) {
	    instance.setPosition(_position)
	  },
	  shape: function shape(instance, _shape) {
	    instance.setShape(_shape)
	  },
	  title: function title(instance, _title) {
	    instance.setTitle(_title)
	  },
	  visible: function visible(instance, _visible) {
	    instance.setVisible(_visible)
	  },
	  zIndex: function zIndex(instance, _zIndex) {
	    instance.setZIndex(_zIndex)
	  },
	}


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(748);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(101)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./index.css", function() {
				var newContent = require("!!../../css-loader/index.js!./index.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 804 */
/***/ (function(module, exports) {

	module.exports = "data:application/font-woff;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTphcHBsaWNhdGlvbi9mb250LXdvZmY7YmFzZTY0LGQwOUdSZ0FCQUFBQUFBMEVBQTRBQUFBQUZnZ0FBUUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFCUFV5OHlBQUFCUkFBQUFFUUFBQUJXUGloSVRtTnRZWEFBQUFHSUFBQUFPZ0FBQVVyUUZ4bTNZM1owSUFBQUFjUUFBQUFLQUFBQUNnQUFBQUJtY0dkdEFBQUIwQUFBQlpRQUFBdHdpSkNRV1dkaGMzQUFBQWRrQUFBQUNBQUFBQWdBQUFBUVoyeDVaZ0FBQjJ3QUFBS3JBQUFEY0lOTUFSTm9aV0ZrQUFBS0dBQUFBRFlBQUFBMkJYTk1sR2hvWldFQUFBcFFBQUFBSUFBQUFDUUhVUU5TYUcxMGVBQUFDbkFBQUFBYkFBQUFJQlhCQUFCc2IyTmhBQUFLakFBQUFCSUFBQUFTQTJnQ09HMWhlSEFBQUFxZ0FBQUFJQUFBQUNBQXZ3djJibUZ0WlFBQUNzQUFBQUdNQUFBQzViMk9LRTV3YjNOMEFBQU1UQUFBQUU4QUFBQnQ2TWUrNG5CeVpYQUFBQXljQUFBQVpRQUFBSHZkYXdPRmVKeGpZR1Rhd1RpQmdaV0JnNm1LYVE4REEwTVBoR1o4d0dESXlNVEF3TVRBeXN5QUZRU2t1YVl3T0x4Z2VNSEdIUFEvaXlHS09aaGhHbENZRVNRSEFQMWZDL040bkdOZ1lHQm1nR0FaQmtZR0VIQUI4aGpCZkJZR0RTRE5CcVFaR1pnWUdGNncvZjhQVXZDQ0FVUkxNRUxWQXdFakc4T0lCd0JxZFFhMEFBQUFBQUFBQUFBQUFBQUFBQUI0bksxV2FYTVRSeENkMVdITE5qNkNEeEkyZ1ZuR2NveDJWcGpMQ0JERzdFb1c0Qnp5bGV4Q2psMUxkdTZMVC93Ry9acGVrVlNSYi95MHZCNGQyR0FuVlZRb1N2Mm05KzFNOSt1ZVhwUFFrc1JlV0krazNId3BwclkyYVdUblNVZzNiRnFPNGtQWjJRc3BVMHorTG9pQ2FMWFV2dTA0SkNJU2dhcDFoU1dDMlBmSTBpVGpRNDh5V3JZbHZXcFNidWxKZDlrYUQrcXQrdmJUMEZHTzNRa2xOWnVoUSt1UkxhbkNxQkpGTXUyUmtqWXR3OVZmU1ZyaDV5dk1mTlVNSllMb0pKTEdtMkVNaitSbjQ0eFdHYTNHZGh4RmtVMldHMFdLUkRNOGlDS1BzbHBpbjF3eFFVRDVvQmxTWHZrMG9ueUVINUVWZTVUVENuSEpkcHJmOXlVLzZSM092eVRpZW91eUpRZitRSFprQjN1bksva2kwdG9LNDZhZGJFZWhpdkIwZlNmRUk1dVQ2cC9zVVY3VGFPQjJSYVluelFpV3lsZVFXUGtKWmZZUHlXcmhmTXFYUEJyVmtvT2NDRm92YzJKZjhnNjBIa2RNaVdzbXlJTHVqazZJb082WG5LSFlZL3E0K09POVhTd1hJUVRJT0piMWprcTRFRVlwWWJPYUpHMEVPWWlTc2tXVjFIcEhUSnp5T2kzaUxXRy9UdTNvUzJlMFNhZzdNWjZ0aDQ2dG5LamtlRFNwMDB5bVR1Mms1dEdVQmxGS09oTTg1dGNCbEIvUkpLKzJzWnJFeXFOcGJETmpKSkZRb0lWemFTcUlaU2VXTkFYUlBKclJtN3RobW12WG9rV2FQRkRQUFhwUGIyNkZtenM5cCszQVAydjhaM1VxcG9POU1KMmVEc2hLZkpwMnVVblJ1bjU2aG44bThVUFdBaXFSTFRiRGxNVkR0bjRINWVWalM0N0Nhd05zOTU3eksraDk5a1RJcElINEcvQWVMOVVwQlV5Rm1GVlFDOTIwMXJVc3k5UnFWb3RVWk9xN0lVMHJYOVpwQWswNURuMWpYOFk0L3ErWkdVdE1DZC92eE9uWkVaZWV1ZllseURTSDNHWmRqK1oxYXJGZGdNNXN6K2sweS9aOW5lYllmcURUUE52ek9oMWhhK3QwbE8ySE9pMncvVWluWTJ3dmFFR1Q3anNFY2hHQlhNQUdFb0d3ZFJBSTIwc0loSzFDSUd3WEVRamJJZ0podTRSQTJINk1RTmd1SXhDMmw3V3NtbjRxYVJ3N0U4c0FSWWdEb3pudXlHVnVLbGRUeWFVU3JvdEdwemJrS1hLcnBLSjRWdjByQS8zaWtUZXNnYlZBdWtUVy9JcEpybnhVbGVPUHJtaDUwOFM1QW81VmYzdHpYSjhURDJXL1dQaFQ4TC9hbXFxa1Y2eDVaSElWZVNQUWsrTkUxeVlWajY3cDhybXFSOWYvaTRvT2E0RitBNlVRQzBWWmxnMittWkR3VWFmVFVBMWM1UkF6R3pNUDEvVzZaYzNQNGZ5YkdDRUw2SDc4TnhRYUM5eURUbGxKV2UxZ3I5WFhqMlc1dHdmbHNDZFlrbUsrek90YjRZdU16RXI3UldZcGV6N3llY0FWTUNxVllhc05YSzNnelhzUzg1RHBUZkpNRUxjVlpZT2tqY2VaSUxHQll4NHdiNzZUSUNSTVhiV0IyaW1jc0lHOFlNd3AyTytFUTFSdmxPVndlNkY5SG8yVWYydFg3TWdaRlUwUStHMzJSdGpyczFEeVc2eUJoQ2UvMU5kQVZTRk54YmlwZ0VzajVZWnE4R0ZjcmR0R01rNmdyNmpZRGN1eWlnOGZSOXgzU281bElQbElFYXRIUnordHZVS2QxTG45eWlodTN6djlDSUpCYVdMKzlyNlo0cUNVZDdXU1pWWnRBMU8zR3BWVDE1ckR4YXNPM2MyajdudkgyU2R5MWpUZGRFL2M5TDZtVmJlRGc3bFpFTzNiSEpTbFRDNm82OE1PRzZqTHphWFE2bVZja3Q1MkR6QXNNS0Rmb1JVYi8xZjNjZmc4VjZvS28rTkl2WjJvSDZQUFlnenlEemgvUi9VRjZPY3hUTG1HbE9kN2x4T2ZidHpEMlRKZHhWMnNuK0xmd0t5MTVtYnBHbkJEMHcyWWg2eGFIYnJLRFh5bkJqbzkwdHlPOUJEd3NlNEs4UUJnRThCaThJbnVXc2J6S1lEeGZNWWNIK0J6NWpCb01vZkJGbk1ZYkRObkRXQ0hPUXgybWNOZ2p6a012bURPT3NDWHpHRVFNb2RCeEJ3R1Q1Z1RBRHhsRG9Pdm1NUGdhK1l3K0lZNTl3RytaUTZEbURrTUV1WXcyTmQwYXloeml4ZDBGNmh0VUJYb3dQUVRGdmV3T05SVUdiSy80NFZoZjI4UXMzOHdpS2svYXJvOXBQN0VDMFA5MlNDbS9tSVFVMy9WZEdkSS9ZMFhodnE3UVV6OXd5Q21QdE12eG5LWndWOUd2a3VGQThvdU5wL3o5OFQ3QjhJYVFMWUFBUUFCLy84QUQzaWNYVkpCYXhOQkZINXZObXppYkxwcDYyWlR0VW1iM1NTVnBFMGwyV3hLVTlNcWxnb2lMYWFJSi9WUXJWUXBvdlZpclFjRmtSS0NGQ2xpVDFQRWczcHhnd2dpOUpLSzFSNGwvb1VpNkttbllCTm5OeEdMQy9QZTIzbnZlOTgzYndhdzBRQWdPZHdDR2NReUpUaVFpQ3BpWDFoTDRpaWFxUjVVU1U3eDFiMCtoWGhyTkVScjlMV3NvaEtTYXBUV0pBQUUvdUVzdVFkdEhDOEpISThkaXFnTllzeXdHNmg0UmVrOTRCUjNkNUVMZGErc1NqemtTMjFoVDVBbGgxdHkyVmpGaDZJV3kzUVllZVRjZU1MR3FTcXZwM2hSdGxFeTdqYTF0TGpKQ1A1c2F2K0h0OG5OZERqRnRkTVdHWWR4M1Z0MkM4bHB5YUUrZ01hY3dJUUNDT0FHaWY4ZmhBQWNnUjdRSVExWnlNRW9UTUp0ME1kNkx4Zk9uTXFQREErWnh1QlJyVGZVZmJoTFZUcmJaUy8xaUM0Q3ZvRkVJSjNSN2RXM3orTi9Yc2dZc1Q1ZEU5MStSYzJtVXlidXE4KzJja0ZzNXJKOGlIclltWVNadzR4aEJ0SXBOY2dSelNqZzUyYUNzVTNMMnZ4cmNhMWNybG9Xdm1Hc1dpNVh2R0xFVGJGcDE1eXRLbU9kMUtON3FHTys5M2YvL2hXTXg0T25qV2drYWxUTmlCNDFjQ0lZbjJTTVJTekxpckM5Q3F2WkptTGhNZVkwWTI0djBucU01eGk3dm0rcmZ5OWp0eUpmZzNFellxSVJOVnN1enVjc05QWWFiNFZMZ2dRS2hDRUo5SDBpMnRQVkxnajh2dnlLbUVBdGRoeGJ4OHdoUDV5UlJGa0lrVHhtRlJtMUpBOVNJY1JkNnJGczdVdlVIZkhRblhQTEw0dFRaUHJ4cTBmbkYyOTkydms4TDk3OXVQdmhQdEZxYnVwVVZIanhkbUY1bWt5VjFrdThjcmx3cDdLd1VQbGhHeUNOaG5QM2JlRGhtanp2RGttaVFMZ2VUaTJHTUkvb3ZHRlJ0OWxkSVJKUTNBR1ZQSHk2dmVvcWZTdWkxaitzYk13c1RxMWNHeU1qTjBvdmlqZUhoUEVOUHo2WVhTR3JYNTZKeGZyellOeS9NWjZmZTdKZW1oOTJuYnk2ZW5aeFpzTVBmd0FScGN4R0FBQUJBQUFBQVFBQWVzYXhVMThQUFBVQUN3UG9BQUFBQU5GYkdaRUFBQUFBMFZydllmLzkvMm9Eb1FOVEFBQUFDQUFDQUFBQUFBQUFlSnhqWUdSZ1lBNzZuOFVReGZ5Q2dlSC9kK1pGREVBUkZNQUJBSXQxQmFsNG5HTit3Y0RBWk0zQXdKZ0t3U0EyOHdJZ2pvVFFBRUxUQTlRQUFBQUFBQUFnQUQ0QVhnQitBVElCZkFHNEFBQUFBUUFBQUFnQWRBQVBBQUFBQUFBQ0FBQUFFQUJ6QUFBQU5BdHdBQUFBQUhpY2RaTE5Uc0pBRklYUElHS0V4SVVhM2Q2VndSakxUK0pDTnBLUTRNckV1R0RocnNEUWxwUU9tUTRRbnNFMzhCMThKUlBmeEVPWmlDYllabnEvZStiMHpwMXBBWnppRXdyYjY0NWp5d3BWWmxzdTRRZ1BuZytvOXoyWHljK2VEMUhEcStjS2RlMjVpaHNZenpXYzRaMFZWUG1ZMlJRZm5oWE8xYVhuRWs3VWplY0Q2dmVleStRbno0ZTRVS0huQ3ZXVjV5b0c2czF6RFZmcXEyZm1hNXRFc1pONjcxcmF6ZGFkRE5kaUtDVlptRXE0Y0xHeHVYUmxZaktuMDlRRUl6T3pxOXRWTW82MHkxOTB0RWhEdXhOMk5OQTJUMHdtcmFDNUV4OTFwbTNvOUhpelNyNk0yczVOWkdMTlRQcSt2c3l0bWVxUkMyTG41cDFHNC9lNjZQR2c1bGpESWtHRUdBNkNPdFZyeGphYWFQR0RDSVowQ0oxYlY0SU1JVklxSVJaOEl5NW1jdVpkamdtempLcW1JeVVIR1BFNW8yT0ZXNDRFWTliUWRPUjRZWXhZSTJVbHU5ZXhUeHN3YnRaTGlwV0VQUWJzZEovemtURXIzR0hSMGZobkx6bVdkTFdwT25hODZkb1dYUXAvdEwvOUM4OW5NemVsTXFJZUZLZmtxSGJRNFAzUGZyOEJmdUtLYVhpY2JjYkJEWUFnREFEQUZnV3J1emhVVTFDSUJFelZ1TDRSdjk3cndNQm5nbjhFZ0FZNzdOR2l3d0hKWGZ2c2sxSU95L2xtMUxUR052TDFMaTNDT1JUUGFpVlgyZHdSV0NVQ1BIR3VGRU1BZUp4ajhON0JjQ0lvWWlNalkxL2tCc2FkSEF3Y0RNa0ZHeGxZblRZeU1HaEJhQTRVZWljREF3TW5Nb3Vad1dXakNtTkhZTVFHaDQ2SWpjd3BMaHZWUUx4ZEhBME1qQ3dPSGNraEVTQWxrVUN3a1lGSGF3ZmovOVlOTEwwYm1SaGNBQWZUSXJnQUFBQT0i"

/***/ }),
/* 805 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 806 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,R0lGODlhEAAQAPIAAP///zMzM87OzmdnZzMzM4GBgZqamqenpyH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1237);

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1245);

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1320);

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1323);

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1343);

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1350);

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1373);

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1375);

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1379);

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1388);

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1399);

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1420);

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(146);

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1532);

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1549);

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1744);

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1752);

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1835);

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(1953);

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(2258);

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(2261);

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(3);

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(32);

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(33);

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(335);

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(34);

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(35);

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(36);

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(40);

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(42);

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(48);

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(52);

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(553);

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(554);

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(556);

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(564);

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(567);

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(568);

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(17))(977);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/app.bundle-0baf60.js